/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				var _m = moreModules[moduleId];
/******/
/******/ 				// Check if module is deduplicated
/******/ 				switch(typeof _m) {
/******/ 				case "object":
/******/ 					// Module can be created from a template
/******/ 					modules[moduleId] = (function(_m) {
/******/ 						var args = _m.slice(1), templateId = _m[0];
/******/ 						return function (a,b,c) {
/******/ 							modules[templateId].apply(this, [a,b,c].concat(args));
/******/ 						};
/******/ 					}(_m));
/******/ 					break;
/******/ 				case "function":
/******/ 					// Normal module
/******/ 					modules[moduleId] = _m;
/******/ 					break;
/******/ 				default:
/******/ 					// Module is a copy of another module
/******/ 					modules[moduleId] = modules[_m];
/******/ 					break;
/******/ 				}
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + "32f7c46dc19de595abe9" + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(814);
	__webpack_require__(1052);
	__webpack_require__(458);
	module.exports = __webpack_require__(961);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1721);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1639)();
	}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return (Object.getOwnPropertyNames(obj).length === 0);
	        } else {
	            var k;
	            for (k in obj) {
	                if (obj.hasOwnProperty(k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null,
	            rfc2822         : false,
	            weekdayMismatch : false
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.weekdayMismatch &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid (flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i = 0; i < momentProperties.length; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        ss : '%d seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function set$1 (mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
	            }
	            else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return isArray(this._months) ? this._months :
	                this._months['standalone'];
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return isArray(this._monthsShort) ? this._monthsShort :
	                this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            var args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays (ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        var weekdays = isArray(this._weekdays) ? this._weekdays :
	            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
	        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
	            : (m) ? weekdays[m.day()] : weekdays;
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('k',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour they want. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var localeFamilies = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                var aliasedRequire = require;
	                __webpack_require__(1633)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {}
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	            else {
	                if ((typeof console !==  'undefined') && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var locale, parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, tmpLocale, parentConfig = baseConfig;
	            // MERGE
	            tmpLocale = loadLocale(name);
	            if (tmpLocale != null) {
	                parentConfig = tmpLocale._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            var curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;
	
	    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10)
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    var obsOffsets = {
	        UT: 0,
	        GMT: 0,
	        EDT: -4 * 60,
	        EST: -5 * 60,
	        CDT: -5 * 60,
	        CST: -6 * 60,
	        MDT: -6 * 60,
	        MST: -7 * 60,
	        PDT: -7 * 60,
	        PST: -8 * 60
	    };
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10);
	            var m = hm % 100, h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i));
	        if (match) {
	            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        // Final attempt, use Input Fallback
	        hooks.createFromInputFallback(config);
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
	
	    function isDurationValid(m) {
	        for (var key in m) {
	            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
	                return false;
	            }
	        }
	
	        var unitHasDecimal = false;
	        for (var i = 0; i < ordering.length; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher);
	
	        if (matches === null) {
	            return null;
	        }
	
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ?
	          0 :
	          parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            }
	            else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (isNumber(input)) {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add      = createAdder(1, 'add');
	    var subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function calendar$1 (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year': output = monthDiff(this, that) / 12; break;
	            case 'month': output = monthDiff(this, that); break;
	            case 'quarter': output = monthDiff(this, that) / 3; break;
	            case 'second': output = (this - that) / 1e3; break; // 1000
	            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
	            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
	            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default: output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true;
	        var m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect () {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment';
	        var zone = '';
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        var prefix = '[' + func + '("]';
	        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        var suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 createLocal(time).isValid())) {
	            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000;
	    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
	    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
	    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return (dividend % divisor + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf (units) {
	        var time;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
	                break;
	            case 'isoWeek':
	                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2 () {
	        return isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict ?
	          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
	          locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add               = add;
	    proto.calendar          = calendar$1;
	    proto.clone             = clone;
	    proto.diff              = diff;
	    proto.endOf             = endOf;
	    proto.format            = format;
	    proto.from              = from;
	    proto.fromNow           = fromNow;
	    proto.to                = to;
	    proto.toNow             = toNow;
	    proto.get               = stringGet;
	    proto.invalidAt         = invalidAt;
	    proto.isAfter           = isAfter;
	    proto.isBefore          = isBefore;
	    proto.isBetween         = isBetween;
	    proto.isSame            = isSame;
	    proto.isSameOrAfter     = isSameOrAfter;
	    proto.isSameOrBefore    = isSameOrBefore;
	    proto.isValid           = isValid$2;
	    proto.lang              = lang;
	    proto.locale            = locale;
	    proto.localeData        = localeData;
	    proto.max               = prototypeMax;
	    proto.min               = prototypeMin;
	    proto.parsingFlags      = parsingFlags;
	    proto.set               = stringSet;
	    proto.startOf           = startOf;
	    proto.subtract          = subtract;
	    proto.toArray           = toArray;
	    proto.toObject          = toObject;
	    proto.toDate            = toDate;
	    proto.toISOString       = toISOString;
	    proto.inspect           = inspect;
	    proto.toJSON            = toJSON;
	    proto.toString          = toString;
	    proto.unix              = unix;
	    proto.valueOf           = valueOf;
	    proto.creationData      = creationData;
	    proto.year       = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear    = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month       = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week           = proto.weeks        = getSetWeek;
	    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	    proto.weeksInYear    = getWeeksInYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.date       = getSetDayOfMonth;
	    proto.day        = proto.days             = getSetDayOfWeek;
	    proto.weekday    = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear  = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset            = getSetOffset;
	    proto.utc                  = setOffsetToUTC;
	    proto.local                = setOffsetToLocal;
	    proto.parseZone            = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST                = isDaylightSavingTime;
	    proto.isLocal              = isLocal;
	    proto.isUtcOffset          = isUtcOffset;
	    proto.isUtc                = isUtc;
	    proto.isUTC                = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    function createUnix (input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone () {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar        = calendar;
	    proto$1.longDateFormat  = longDateFormat;
	    proto$1.invalidDate     = invalidDate;
	    proto$1.ordinal         = ordinal;
	    proto$1.preparse        = preParsePostFormat;
	    proto$1.postformat      = preParsePostFormat;
	    proto$1.relativeTime    = relativeTime;
	    proto$1.pastFuture      = pastFuture;
	    proto$1.set             = set;
	
	    proto$1.months            =        localeMonths;
	    proto$1.monthsShort       =        localeMonthsShort;
	    proto$1.monthsParse       =        localeMonthsParse;
	    proto$1.monthsRegex       = monthsRegex;
	    proto$1.monthsShortRegex  = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays       =        localeWeekdays;
	    proto$1.weekdaysMin    =        localeWeekdaysMin;
	    proto$1.weekdaysShort  =        localeWeekdaysShort;
	    proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	    proto$1.weekdaysRegex       =        weekdaysRegex;
	    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1 (format, index, field, setter) {
	        var locale = getLocale();
	        var utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	    var mathAbs = Math.abs;
	
	    function abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1 (duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1 (input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1 (input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':   return months;
	                case 'quarter': return months / 3;
	                case 'year':    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1 () {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asQuarters     = makeAs('Q');
	    var asYears        = makeAs('y');
	
	    function clone$1 () {
	        return createDuration(this);
	    }
	
	    function get$2 (units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        ss: 44,         // a few seconds to seconds
	        s : 45,         // seconds to minute
	        m : 45,         // minutes to hour
	        h : 22,         // hours to day
	        d : 26,         // days to month
	        M : 11          // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	        var duration = createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds <= thresholds.ss && ['s', seconds]  ||
	                seconds < thresholds.s   && ['ss', seconds] ||
	                minutes <= 1             && ['m']           ||
	                minutes < thresholds.m   && ['mm', minutes] ||
	                hours   <= 1             && ['h']           ||
	                hours   < thresholds.h   && ['hh', hours]   ||
	                days    <= 1             && ['d']           ||
	                days    < thresholds.d   && ['dd', days]    ||
	                months  <= 1             && ['M']           ||
	                months  < thresholds.M   && ['MM', months]  ||
	                years   <= 1             && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var locale = this.localeData();
	        var output = relativeTime$1(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return ((x > 0) - (x < 0)) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000;
	        var days         = abs$1(this._days);
	        var months       = abs$1(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        var totalSign = total < 0 ? '-' : '';
	        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return totalSign + 'P' +
	            (Y ? ymSign + Y + 'Y' : '') +
	            (M ? ymSign + M + 'M' : '') +
	            (D ? daysSign + D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? hmsSign + h + 'H' : '') +
	            (m ? hmsSign + m + 'M' : '') +
	            (s ? hmsSign + s + 'S' : '');
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid        = isValid$1;
	    proto$2.abs            = abs;
	    proto$2.add            = add$1;
	    proto$2.subtract       = subtract$1;
	    proto$2.as             = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds      = asSeconds;
	    proto$2.asMinutes      = asMinutes;
	    proto$2.asHours        = asHours;
	    proto$2.asDays         = asDays;
	    proto$2.asWeeks        = asWeeks;
	    proto$2.asMonths       = asMonths;
	    proto$2.asQuarters     = asQuarters;
	    proto$2.asYears        = asYears;
	    proto$2.valueOf        = valueOf$1;
	    proto$2._bubble        = bubble;
	    proto$2.clone          = clone$1;
	    proto$2.get            = get$2;
	    proto$2.milliseconds   = milliseconds;
	    proto$2.seconds        = seconds;
	    proto$2.minutes        = minutes;
	    proto$2.hours          = hours;
	    proto$2.days           = days;
	    proto$2.weeks          = weeks;
	    proto$2.months         = months;
	    proto$2.years          = years;
	    proto$2.humanize       = humanize;
	    proto$2.toISOString    = toISOString$1;
	    proto$2.toString       = toISOString$1;
	    proto$2.toJSON         = toISOString$1;
	    proto$2.locale         = locale;
	    proto$2.localeData     = localeData;
	
	    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	    proto$2.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    hooks.version = '2.24.0';
	
	    setHookCallback(createLocal);
	
	    hooks.fn                    = proto;
	    hooks.min                   = min;
	    hooks.max                   = max;
	    hooks.now                   = now;
	    hooks.utc                   = createUTC;
	    hooks.unix                  = createUnix;
	    hooks.months                = listMonths;
	    hooks.isDate                = isDate;
	    hooks.locale                = getSetGlobalLocale;
	    hooks.invalid               = createInvalid;
	    hooks.duration              = createDuration;
	    hooks.isMoment              = isMoment;
	    hooks.weekdays              = listWeekdays;
	    hooks.parseZone             = createInZone;
	    hooks.localeData            = getLocale;
	    hooks.isDuration            = isDuration;
	    hooks.monthsShort           = listMonthsShort;
	    hooks.weekdaysMin           = listWeekdaysMin;
	    hooks.defineLocale          = defineLocale;
	    hooks.updateLocale          = updateLocale;
	    hooks.locales               = listLocales;
	    hooks.weekdaysShort         = listWeekdaysShort;
	    hooks.normalizeUnits        = normalizeUnits;
	    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat        = getCalendarFormat;
	    hooks.prototype             = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD',                             // <input type="date" />
	        TIME: 'HH:mm',                                  // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
	        MONTH: 'YYYY-MM'                                // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25);
	var core = __webpack_require__(68);
	var hide = __webpack_require__(60);
	var redefine = __webpack_require__(61);
	var ctx = __webpack_require__(77);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {/*
	 * Copyright 2019, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var allLocaleData = _interopDefault(__webpack_require__(1852));
	var IntlMessageFormat = _interopDefault(__webpack_require__(523));
	var IntlRelativeFormat = _interopDefault(__webpack_require__(1361));
	var PropTypes = _interopDefault(__webpack_require__(2));
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var hoistNonReactStatics = _interopDefault(__webpack_require__(1664));
	var invariant = _interopDefault(__webpack_require__(32));
	var memoizeIntlConstructor = _interopDefault(__webpack_require__(1353));
	
	// GENERATED FILE
	var defaultLocaleData = { "locale": "en", "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	    var s = String(n).split("."),
	        v0 = !s[1],
	        t0 = Number(s[0]) == n,
	        n10 = t0 && s[0].slice(-1),
	        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
	  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function addLocaleData() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  var locales = Array.isArray(data) ? data : [data];
	
	  locales.forEach(function (localeData) {
	    if (localeData && localeData.locale) {
	      IntlMessageFormat.__addLocaleData(localeData);
	      IntlRelativeFormat.__addLocaleData(localeData);
	    }
	  });
	}
	
	function hasLocaleData(locale) {
	  var localeParts = (locale || '').split('-');
	
	  while (localeParts.length > 0) {
	    if (hasIMFAndIRFLocaleData(localeParts.join('-'))) {
	      return true;
	    }
	
	    localeParts.pop();
	  }
	
	  return false;
	}
	
	function hasIMFAndIRFLocaleData(locale) {
	  var normalizedLocale = locale && locale.toLowerCase();
	
	  return !!(IntlMessageFormat.__localeData__[normalizedLocale] && IntlRelativeFormat.__localeData__[normalizedLocale]);
	}
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var asyncGenerator = function () {
	  function AwaitValue(value) {
	    this.value = value;
	  }
	
	  function AsyncGenerator(gen) {
	    var front, back;
	
	    function send(key, arg) {
	      return new Promise(function (resolve, reject) {
	        var request = {
	          key: key,
	          arg: arg,
	          resolve: resolve,
	          reject: reject,
	          next: null
	        };
	
	        if (back) {
	          back = back.next = request;
	        } else {
	          front = back = request;
	          resume(key, arg);
	        }
	      });
	    }
	
	    function resume(key, arg) {
	      try {
	        var result = gen[key](arg);
	        var value = result.value;
	
	        if (value instanceof AwaitValue) {
	          Promise.resolve(value.value).then(function (arg) {
	            resume("next", arg);
	          }, function (arg) {
	            resume("throw", arg);
	          });
	        } else {
	          settle(result.done ? "return" : "normal", result.value);
	        }
	      } catch (err) {
	        settle("throw", err);
	      }
	    }
	
	    function settle(type, value) {
	      switch (type) {
	        case "return":
	          front.resolve({
	            value: value,
	            done: true
	          });
	          break;
	
	        case "throw":
	          front.reject(value);
	          break;
	
	        default:
	          front.resolve({
	            value: value,
	            done: false
	          });
	          break;
	      }
	
	      front = front.next;
	
	      if (front) {
	        resume(front.key, front.arg);
	      } else {
	        back = null;
	      }
	    }
	
	    this._invoke = send;
	
	    if (typeof gen.return !== "function") {
	      this.return = undefined;
	    }
	  }
	
	  if (typeof Symbol === "function" && Symbol.asyncIterator) {
	    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	      return this;
	    };
	  }
	
	  AsyncGenerator.prototype.next = function (arg) {
	    return this._invoke("next", arg);
	  };
	
	  AsyncGenerator.prototype.throw = function (arg) {
	    return this._invoke("throw", arg);
	  };
	
	  AsyncGenerator.prototype.return = function (arg) {
	    return this._invoke("return", arg);
	  };
	
	  return {
	    wrap: function (fn) {
	      return function () {
	        return new AsyncGenerator(fn.apply(this, arguments));
	      };
	    },
	    await: function (value) {
	      return new AwaitValue(value);
	    }
	  };
	}();
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var bool = PropTypes.bool;
	var number = PropTypes.number;
	var string = PropTypes.string;
	var func = PropTypes.func;
	var object = PropTypes.object;
	var oneOf = PropTypes.oneOf;
	var shape = PropTypes.shape;
	var any = PropTypes.any;
	var oneOfType = PropTypes.oneOfType;
	
	var localeMatcher = oneOf(['best fit', 'lookup']);
	var narrowShortLong = oneOf(['narrow', 'short', 'long']);
	var numeric2digit = oneOf(['numeric', '2-digit']);
	var funcReq = func.isRequired;
	
	var intlConfigPropTypes = {
	  locale: string,
	  timeZone: string,
	  formats: object,
	  messages: object,
	  textComponent: any,
	
	  defaultLocale: string,
	  defaultFormats: object,
	
	  onError: func
	};
	
	var intlFormatPropTypes = {
	  formatDate: funcReq,
	  formatTime: funcReq,
	  formatRelative: funcReq,
	  formatNumber: funcReq,
	  formatPlural: funcReq,
	  formatMessage: funcReq,
	  formatHTMLMessage: funcReq
	};
	
	var intlShape = shape(_extends({}, intlConfigPropTypes, intlFormatPropTypes, {
	  formatters: object,
	  now: funcReq
	}));
	
	var messageDescriptorPropTypes = {
	  id: string.isRequired,
	  description: oneOfType([string, object]),
	  defaultMessage: string
	};
	
	var dateTimeFormatPropTypes = {
	  localeMatcher: localeMatcher,
	  formatMatcher: oneOf(['basic', 'best fit']),
	
	  timeZone: string,
	  hour12: bool,
	
	  weekday: narrowShortLong,
	  era: narrowShortLong,
	  year: numeric2digit,
	  month: oneOf(['numeric', '2-digit', 'narrow', 'short', 'long']),
	  day: numeric2digit,
	  hour: numeric2digit,
	  minute: numeric2digit,
	  second: numeric2digit,
	  timeZoneName: oneOf(['short', 'long'])
	};
	
	var numberFormatPropTypes = {
	  localeMatcher: localeMatcher,
	
	  style: oneOf(['decimal', 'currency', 'percent']),
	  currency: string,
	  currencyDisplay: oneOf(['symbol', 'code', 'name']),
	  useGrouping: bool,
	
	  minimumIntegerDigits: number,
	  minimumFractionDigits: number,
	  maximumFractionDigits: number,
	  minimumSignificantDigits: number,
	  maximumSignificantDigits: number
	};
	
	var relativeFormatPropTypes = {
	  style: oneOf(['best fit', 'numeric']),
	  units: oneOf(['second', 'minute', 'hour', 'day', 'month', 'year', 'second-short', 'minute-short', 'hour-short', 'day-short', 'month-short', 'year-short'])
	};
	
	var pluralFormatPropTypes = {
	  style: oneOf(['cardinal', 'ordinal'])
	};
	
	/*
	HTML escaping and shallow-equals implementations are the same as React's
	(on purpose.) Therefore, it has the following Copyright and Licensing:
	
	Copyright 2013-2014, Facebook, Inc.
	All rights reserved.
	
	This source code is licensed under the BSD-style license found in the LICENSE
	file in the root directory of React's source tree.
	*/
	
	var intlConfigPropNames = Object.keys(intlConfigPropTypes);
	
	var ESCAPED_CHARS = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  "'": '&#x27;'
	};
	
	var UNSAFE_CHARS_REGEX = /[&><"']/g;
	
	function escape(str) {
	  return ('' + str).replace(UNSAFE_CHARS_REGEX, function (match) {
	    return ESCAPED_CHARS[match];
	  });
	}
	
	function filterProps(props, whitelist) {
	  var defaults$$1 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  return whitelist.reduce(function (filtered, name) {
	    if (props.hasOwnProperty(name)) {
	      filtered[name] = props[name];
	    } else if (defaults$$1.hasOwnProperty(name)) {
	      filtered[name] = defaults$$1[name];
	    }
	
	    return filtered;
	  }, {});
	}
	
	function invariantIntlContext() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      intl = _ref.intl;
	
	  invariant(intl, '[React Intl] Could not find required `intl` object. ' + '<IntlProvider> needs to exist in the component ancestry.');
	}
	
	function shallowEquals(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function shouldIntlComponentUpdate(_ref2, nextProps, nextState) {
	  var props = _ref2.props,
	      state = _ref2.state,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === undefined ? {} : _ref2$context;
	  var nextContext = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var _context$intl = context.intl,
	      intl = _context$intl === undefined ? {} : _context$intl;
	  var _nextContext$intl = nextContext.intl,
	      nextIntl = _nextContext$intl === undefined ? {} : _nextContext$intl;
	
	
	  return !shallowEquals(nextProps, props) || !shallowEquals(nextState, state) || !(nextIntl === intl || shallowEquals(filterProps(nextIntl, intlConfigPropNames), filterProps(intl, intlConfigPropNames)));
	}
	
	function createError(message, exception) {
	  var eMsg = exception ? '\n' + exception : '';
	  return '[React Intl] ' + message + eMsg;
	}
	
	function defaultErrorHandler(error) {
	  if (false) {
	    console.error(error);
	  }
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// Inspired by react-redux's `connect()` HOC factory function implementation:
	// https://github.com/rackt/react-redux
	
	function getDisplayName(Component$$1) {
	  return Component$$1.displayName || Component$$1.name || 'Component';
	}
	
	function injectIntl(WrappedComponent) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$intlPropName = options.intlPropName,
	      intlPropName = _options$intlPropName === undefined ? 'intl' : _options$intlPropName,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var InjectIntl = function (_Component) {
	    inherits(InjectIntl, _Component);
	
	    function InjectIntl(props, context) {
	      classCallCheck(this, InjectIntl);
	
	      var _this = possibleConstructorReturn(this, (InjectIntl.__proto__ || Object.getPrototypeOf(InjectIntl)).call(this, props, context));
	
	      invariantIntlContext(context);
	      return _this;
	    }
	
	    createClass(InjectIntl, [{
	      key: 'getWrappedInstance',
	      value: function getWrappedInstance() {
	        invariant(withRef, '[React Intl] To access the wrapped instance, ' + 'the `{withRef: true}` option must be set when calling: ' + '`injectIntl()`');
	
	        return this._wrappedInstance;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        return React__default.createElement(WrappedComponent, _extends({}, this.props, defineProperty({}, intlPropName, this.context.intl), {
	          ref: withRef ? /* istanbul ignore next */function (ref) {
	            return _this2._wrappedInstance = ref;
	          } : null
	        }));
	      }
	    }]);
	    return InjectIntl;
	  }(React.Component);
	
	  InjectIntl.displayName = 'InjectIntl(' + getDisplayName(WrappedComponent) + ')';
	  InjectIntl.contextTypes = {
	    intl: intlShape
	  };
	  InjectIntl.WrappedComponent = WrappedComponent;
	
	
	  return hoistNonReactStatics(InjectIntl, WrappedComponent);
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	function defineMessages(messageDescriptors) {
	  // This simply returns what's passed-in because it's meant to be a hook for
	  // babel-plugin-react-intl.
	  return messageDescriptors;
	}
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	// This is a "hack" until a proper `intl-pluralformat` package is created.
	
	function resolveLocale(locales) {
	  // IntlMessageFormat#_resolveLocale() does not depend on `this`.
	  return IntlMessageFormat.prototype._resolveLocale(locales);
	}
	
	function findPluralFunction(locale) {
	  // IntlMessageFormat#_findPluralFunction() does not depend on `this`.
	  return IntlMessageFormat.prototype._findPluralRuleFunction(locale);
	}
	
	var IntlPluralFormat = function IntlPluralFormat(locales) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  classCallCheck(this, IntlPluralFormat);
	
	  var useOrdinal = options.style === 'ordinal';
	  var pluralFn = findPluralFunction(resolveLocale(locales));
	
	  this.format = function (value) {
	    return pluralFn(value, useOrdinal);
	  };
	};
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var DATE_TIME_FORMAT_OPTIONS = Object.keys(dateTimeFormatPropTypes);
	var NUMBER_FORMAT_OPTIONS = Object.keys(numberFormatPropTypes);
	var RELATIVE_FORMAT_OPTIONS = Object.keys(relativeFormatPropTypes);
	var PLURAL_FORMAT_OPTIONS = Object.keys(pluralFormatPropTypes);
	
	var RELATIVE_FORMAT_THRESHOLDS = {
	  second: 60, // seconds to minute
	  minute: 60, // minutes to hour
	  hour: 24, // hours to day
	  day: 30, // days to month
	  month: 12 };
	
	function updateRelativeFormatThresholds(newThresholds) {
	  var thresholds = IntlRelativeFormat.thresholds;
	  thresholds.second = newThresholds.second;
	  thresholds.minute = newThresholds.minute;
	  thresholds.hour = newThresholds.hour;
	  thresholds.day = newThresholds.day;
	  thresholds.month = newThresholds.month;
	  thresholds['second-short'] = newThresholds['second-short'];
	  thresholds['minute-short'] = newThresholds['minute-short'];
	  thresholds['hour-short'] = newThresholds['hour-short'];
	  thresholds['day-short'] = newThresholds['day-short'];
	  thresholds['month-short'] = newThresholds['month-short'];
	}
	
	function getNamedFormat(formats, type, name, onError) {
	  var format = formats && formats[type] && formats[type][name];
	  if (format) {
	    return format;
	  }
	
	  onError(createError('No ' + type + ' format named: ' + name));
	}
	
	function formatDate(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      timeZone = config.timeZone;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var date = new Date(value);
	  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'date', format, onError));
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    onError(createError('Error formatting date.', e));
	  }
	
	  return String(date);
	}
	
	function formatTime(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      timeZone = config.timeZone;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var date = new Date(value);
	  var defaults$$1 = _extends({}, timeZone && { timeZone: timeZone }, format && getNamedFormat(formats, 'time', format, onError));
	  var filteredOptions = filterProps(options, DATE_TIME_FORMAT_OPTIONS, defaults$$1);
	
	  if (!filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second) {
	    // Add default formatting options if hour, minute, or second isn't defined.
	    filteredOptions = _extends({}, filteredOptions, { hour: 'numeric', minute: 'numeric' });
	  }
	
	  try {
	    return state.getDateTimeFormat(locale, filteredOptions).format(date);
	  } catch (e) {
	    onError(createError('Error formatting time.', e));
	  }
	
	  return String(date);
	}
	
	function formatRelative(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var date = new Date(value);
	  var now = new Date(options.now);
	  var defaults$$1 = format && getNamedFormat(formats, 'relative', format, onError);
	  var filteredOptions = filterProps(options, RELATIVE_FORMAT_OPTIONS, defaults$$1);
	
	  // Capture the current threshold values, then temporarily override them with
	  // specific values just for this render.
	  var oldThresholds = _extends({}, IntlRelativeFormat.thresholds);
	  updateRelativeFormatThresholds(RELATIVE_FORMAT_THRESHOLDS);
	
	  try {
	    return state.getRelativeFormat(locale, filteredOptions).format(date, {
	      now: isFinite(now) ? now : state.now()
	    });
	  } catch (e) {
	    onError(createError('Error formatting relative time.', e));
	  } finally {
	    updateRelativeFormatThresholds(oldThresholds);
	  }
	
	  return String(date);
	}
	
	function formatNumber(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats;
	  var format = options.format;
	
	
	  var onError = config.onError || defaultErrorHandler;
	  var defaults$$1 = format && getNamedFormat(formats, 'number', format, onError);
	  var filteredOptions = filterProps(options, NUMBER_FORMAT_OPTIONS, defaults$$1);
	
	  try {
	    return state.getNumberFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    onError(createError('Error formatting number.', e));
	  }
	
	  return String(value);
	}
	
	function formatPlural(config, state, value) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale;
	
	
	  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);
	  var onError = config.onError || defaultErrorHandler;
	
	  try {
	    return state.getPluralFormat(locale, filteredOptions).format(value);
	  } catch (e) {
	    onError(createError('Error formatting plural.', e));
	  }
	
	  return 'other';
	}
	
	function formatMessage(config, state) {
	  var messageDescriptor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var values = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var locale = config.locale,
	      formats = config.formats,
	      messages = config.messages,
	      defaultLocale = config.defaultLocale,
	      defaultFormats = config.defaultFormats;
	  var id = messageDescriptor.id,
	      defaultMessage = messageDescriptor.defaultMessage;
	
	  // Produce a better error if the user calls `intl.formatMessage(element)`
	
	  if (false) {
	    invariant(!React.isValidElement(config), '[React Intl] Don\'t pass React elements to ' + 'formatMessage(), pass `.props`.');
	  }
	
	  // `id` is a required field of a Message Descriptor.
	  invariant(id, '[React Intl] An `id` must be provided to format a message.');
	
	  var message = messages && messages[id];
	  var hasValues = Object.keys(values).length > 0;
	
	  // Avoid expensive message formatting for simple messages without values. In
	  // development messages will always be formatted in case of missing values.
	  if (!hasValues && ("production") === 'production') {
	    return message || defaultMessage || id;
	  }
	
	  var formattedMessage = void 0;
	  var onError = config.onError || defaultErrorHandler;
	
	  if (message) {
	    try {
	      var formatter = state.getMessageFormat(message, locale, formats);
	
	      formattedMessage = formatter.format(values);
	    } catch (e) {
	      onError(createError('Error formatting message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : ''), e));
	    }
	  } else {
	    // This prevents warnings from littering the console in development
	    // when no `messages` are passed into the <IntlProvider> for the
	    // default locale, and a default message is in the source.
	    if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) {
	      onError(createError('Missing message: "' + id + '" for locale: "' + locale + '"' + (defaultMessage ? ', using default message as fallback.' : '')));
	    }
	  }
	
	  if (!formattedMessage && defaultMessage) {
	    try {
	      var _formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats);
	
	      formattedMessage = _formatter.format(values);
	    } catch (e) {
	      onError(createError('Error formatting the default message for: "' + id + '"', e));
	    }
	  }
	
	  if (!formattedMessage) {
	    onError(createError('Cannot format message: "' + id + '", ' + ('using message ' + (message || defaultMessage ? 'source' : 'id') + ' as fallback.')));
	  }
	
	  return formattedMessage || message || defaultMessage || id;
	}
	
	function formatHTMLMessage(config, state, messageDescriptor) {
	  var rawValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  // Process all the values before they are used when formatting the ICU
	  // Message string. Since the formatted message might be injected via
	  // `innerHTML`, all String-based values need to be HTML-escaped.
	  var escapedValues = Object.keys(rawValues).reduce(function (escaped, name) {
	    var value = rawValues[name];
	    escaped[name] = typeof value === 'string' ? escape(value) : value;
	    return escaped;
	  }, {});
	
	  return formatMessage(config, state, messageDescriptor, escapedValues);
	}
	
	
	
	var format = Object.freeze({
		formatDate: formatDate,
		formatTime: formatTime,
		formatRelative: formatRelative,
		formatNumber: formatNumber,
		formatPlural: formatPlural,
		formatMessage: formatMessage,
		formatHTMLMessage: formatHTMLMessage
	});
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var intlConfigPropNames$1 = Object.keys(intlConfigPropTypes);
	var intlFormatPropNames = Object.keys(intlFormatPropTypes);
	
	// These are not a static property on the `IntlProvider` class so the intl
	// config values can be inherited from an <IntlProvider> ancestor.
	var defaultProps = {
	  formats: {},
	  messages: {},
	  timeZone: null,
	  textComponent: 'span',
	
	  defaultLocale: 'en',
	  defaultFormats: {},
	
	  onError: defaultErrorHandler
	};
	
	var IntlProvider = function (_Component) {
	  inherits(IntlProvider, _Component);
	
	  function IntlProvider(props) {
	    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    classCallCheck(this, IntlProvider);
	
	    var _this = possibleConstructorReturn(this, (IntlProvider.__proto__ || Object.getPrototypeOf(IntlProvider)).call(this, props, context));
	
	    invariant(typeof Intl !== 'undefined', '[React Intl] The `Intl` APIs must be available in the runtime, ' + 'and do not appear to be built-in. An `Intl` polyfill should be loaded.\n' + 'See: http://formatjs.io/guides/runtime-environments/');
	
	    var intlContext = context.intl;
	
	    // Used to stabilize time when performing an initial rendering so that
	    // all relative times use the same reference "now" time.
	
	    var initialNow = void 0;
	    if (isFinite(props.initialNow)) {
	      initialNow = Number(props.initialNow);
	    } else {
	      // When an `initialNow` isn't provided via `props`, look to see an
	      // <IntlProvider> exists in the ancestry and call its `now()`
	      // function to propagate its value for "now".
	      initialNow = intlContext ? intlContext.now() : Date.now();
	    }
	
	    // Creating `Intl*` formatters is expensive. If there's a parent
	    // `<IntlProvider>`, then its formatters will be used. Otherwise, this
	    // memoize the `Intl*` constructors and cache them for the lifecycle of
	    // this IntlProvider instance.
	
	    var _ref = intlContext || {},
	        _ref$formatters = _ref.formatters,
	        formatters = _ref$formatters === undefined ? {
	      getDateTimeFormat: memoizeIntlConstructor(Intl.DateTimeFormat),
	      getNumberFormat: memoizeIntlConstructor(Intl.NumberFormat),
	      getMessageFormat: memoizeIntlConstructor(IntlMessageFormat),
	      getRelativeFormat: memoizeIntlConstructor(IntlRelativeFormat),
	      getPluralFormat: memoizeIntlConstructor(IntlPluralFormat)
	    } : _ref$formatters;
	
	    _this.state = _extends({}, formatters, {
	
	      // Wrapper to provide stable "now" time for initial render.
	      now: function now() {
	        return _this._didDisplay ? Date.now() : initialNow;
	      }
	    });
	    return _this;
	  }
	
	  createClass(IntlProvider, [{
	    key: 'getConfig',
	    value: function getConfig() {
	      var intlContext = this.context.intl;
	
	      // Build a whitelisted config object from `props`, defaults, and
	      // `context.intl`, if an <IntlProvider> exists in the ancestry.
	
	      var config = filterProps(this.props, intlConfigPropNames$1, intlContext);
	
	      // Apply default props. This must be applied last after the props have
	      // been resolved and inherited from any <IntlProvider> in the ancestry.
	      // This matches how React resolves `defaultProps`.
	      for (var propName in defaultProps) {
	        if (config[propName] === undefined) {
	          config[propName] = defaultProps[propName];
	        }
	      }
	
	      if (!hasLocaleData(config.locale)) {
	        var _config = config,
	            locale = _config.locale,
	            defaultLocale = _config.defaultLocale,
	            defaultFormats = _config.defaultFormats,
	            onError = _config.onError;
	
	
	        onError(createError('Missing locale data for locale: "' + locale + '". ' + ('Using default locale: "' + defaultLocale + '" as fallback.')));
	
	        // Since there's no registered locale data for `locale`, this will
	        // fallback to the `defaultLocale` to make sure things can render.
	        // The `messages` are overridden to the `defaultProps` empty object
	        // to maintain referential equality across re-renders. It's assumed
	        // each <FormattedMessage> contains a `defaultMessage` prop.
	        config = _extends({}, config, {
	          locale: defaultLocale,
	          formats: defaultFormats,
	          messages: defaultProps.messages
	        });
	      }
	
	      return config;
	    }
	  }, {
	    key: 'getBoundFormatFns',
	    value: function getBoundFormatFns(config, state) {
	      return intlFormatPropNames.reduce(function (boundFormatFns, name) {
	        boundFormatFns[name] = format[name].bind(null, config, state);
	        return boundFormatFns;
	      }, {});
	    }
	  }, {
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var config = this.getConfig();
	
	      // Bind intl factories and current config to the format functions.
	      var boundFormatFns = this.getBoundFormatFns(config, this.state);
	
	      var _state = this.state,
	          now = _state.now,
	          formatters = objectWithoutProperties(_state, ['now']);
	
	
	      return {
	        intl: _extends({}, config, boundFormatFns, {
	          formatters: formatters,
	          now: now
	        })
	      };
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._didDisplay = true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return React.Children.only(this.props.children);
	    }
	  }]);
	  return IntlProvider;
	}(React.Component);
	
	IntlProvider.displayName = 'IntlProvider';
	IntlProvider.contextTypes = {
	  intl: intlShape
	};
	IntlProvider.childContextTypes = {
	  intl: intlShape.isRequired
	};
	 false ? IntlProvider.propTypes = _extends({}, intlConfigPropTypes, {
	  children: PropTypes.element.isRequired,
	  initialNow: PropTypes.any
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedDate = function (_Component) {
	  inherits(FormattedDate, _Component);
	
	  function FormattedDate(props, context) {
	    classCallCheck(this, FormattedDate);
	
	    var _this = possibleConstructorReturn(this, (FormattedDate.__proto__ || Object.getPrototypeOf(FormattedDate)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedDate, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatDate = _context$intl.formatDate,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedDate = formatDate(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedDate);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedDate
	      );
	    }
	  }]);
	  return FormattedDate;
	}(React.Component);
	
	FormattedDate.displayName = 'FormattedDate';
	FormattedDate.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedDate.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedTime = function (_Component) {
	  inherits(FormattedTime, _Component);
	
	  function FormattedTime(props, context) {
	    classCallCheck(this, FormattedTime);
	
	    var _this = possibleConstructorReturn(this, (FormattedTime.__proto__ || Object.getPrototypeOf(FormattedTime)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedTime, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatTime = _context$intl.formatTime,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedTime = formatTime(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedTime);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedTime
	      );
	    }
	  }]);
	  return FormattedTime;
	}(React.Component);
	
	FormattedTime.displayName = 'FormattedTime';
	FormattedTime.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedTime.propTypes = _extends({}, dateTimeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var SECOND = 1000;
	var MINUTE = 1000 * 60;
	var HOUR = 1000 * 60 * 60;
	var DAY = 1000 * 60 * 60 * 24;
	
	// The maximum timer delay value is a 32-bit signed integer.
	// See: https://mdn.io/setTimeout
	var MAX_TIMER_DELAY = 2147483647;
	
	function selectUnits(delta) {
	  var absDelta = Math.abs(delta);
	
	  if (absDelta < MINUTE) {
	    return 'second';
	  }
	
	  if (absDelta < HOUR) {
	    return 'minute';
	  }
	
	  if (absDelta < DAY) {
	    return 'hour';
	  }
	
	  // The maximum scheduled delay will be measured in days since the maximum
	  // timer delay is less than the number of milliseconds in 25 days.
	  return 'day';
	}
	
	function getUnitDelay(units) {
	  switch (units) {
	    case 'second':
	      return SECOND;
	    case 'minute':
	      return MINUTE;
	    case 'hour':
	      return HOUR;
	    case 'day':
	      return DAY;
	    default:
	      return MAX_TIMER_DELAY;
	  }
	}
	
	function isSameDate(a, b) {
	  if (a === b) {
	    return true;
	  }
	
	  var aTime = new Date(a).getTime();
	  var bTime = new Date(b).getTime();
	
	  return isFinite(aTime) && isFinite(bTime) && aTime === bTime;
	}
	
	var FormattedRelative = function (_Component) {
	  inherits(FormattedRelative, _Component);
	
	  function FormattedRelative(props, context) {
	    classCallCheck(this, FormattedRelative);
	
	    var _this = possibleConstructorReturn(this, (FormattedRelative.__proto__ || Object.getPrototypeOf(FormattedRelative)).call(this, props, context));
	
	    invariantIntlContext(context);
	
	    var now = isFinite(props.initialNow) ? Number(props.initialNow) : context.intl.now();
	
	    // `now` is stored as state so that `render()` remains a function of
	    // props + state, instead of accessing `Date.now()` inside `render()`.
	    _this.state = { now: now };
	    return _this;
	  }
	
	  createClass(FormattedRelative, [{
	    key: 'scheduleNextUpdate',
	    value: function scheduleNextUpdate(props, state) {
	      var _this2 = this;
	
	      // Cancel and pending update because we're scheduling a new update.
	      clearTimeout(this._timer);
	
	      var value = props.value,
	          units = props.units,
	          updateInterval = props.updateInterval;
	
	      var time = new Date(value).getTime();
	
	      // If the `updateInterval` is falsy, including `0` or we don't have a
	      // valid date, then auto updates have been turned off, so we bail and
	      // skip scheduling an update.
	      if (!updateInterval || !isFinite(time)) {
	        return;
	      }
	
	      var delta = time - state.now;
	      var unitDelay = getUnitDelay(units || selectUnits(delta));
	      var unitRemainder = Math.abs(delta % unitDelay);
	
	      // We want the largest possible timer delay which will still display
	      // accurate information while reducing unnecessary re-renders. The delay
	      // should be until the next "interesting" moment, like a tick from
	      // "1 minute ago" to "2 minutes ago" when the delta is 120,000ms.
	      var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);
	
	      this._timer = setTimeout(function () {
	        _this2.setState({ now: _this2.context.intl.now() });
	      }, delay);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scheduleNextUpdate(this.props, this.state);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var nextValue = _ref.value;
	
	      // When the `props.value` date changes, `state.now` needs to be updated,
	      // and the next update can be rescheduled.
	      if (!isSameDate(nextValue, this.props.value)) {
	        this.setState({ now: this.context.intl.now() });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate(nextProps, nextState) {
	      this.scheduleNextUpdate(nextProps, nextState);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this._timer);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatRelative = _context$intl.formatRelative,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedRelative = formatRelative(value, _extends({}, this.props, this.state));
	
	      if (typeof children === 'function') {
	        return children(formattedRelative);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedRelative
	      );
	    }
	  }]);
	  return FormattedRelative;
	}(React.Component);
	
	FormattedRelative.displayName = 'FormattedRelative';
	FormattedRelative.contextTypes = {
	  intl: intlShape
	};
	FormattedRelative.defaultProps = {
	  updateInterval: 1000 * 10
	};
	 false ? FormattedRelative.propTypes = _extends({}, relativeFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  updateInterval: PropTypes.number,
	  initialNow: PropTypes.any,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedNumber = function (_Component) {
	  inherits(FormattedNumber, _Component);
	
	  function FormattedNumber(props, context) {
	    classCallCheck(this, FormattedNumber);
	
	    var _this = possibleConstructorReturn(this, (FormattedNumber.__proto__ || Object.getPrototypeOf(FormattedNumber)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedNumber, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatNumber = _context$intl.formatNumber,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          children = _props.children;
	
	
	      var formattedNumber = formatNumber(value, this.props);
	
	      if (typeof children === 'function') {
	        return children(formattedNumber);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedNumber
	      );
	    }
	  }]);
	  return FormattedNumber;
	}(React.Component);
	
	FormattedNumber.displayName = 'FormattedNumber';
	FormattedNumber.contextTypes = {
	  intl: intlShape
	};
	 false ? FormattedNumber.propTypes = _extends({}, numberFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	  format: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedPlural = function (_Component) {
	  inherits(FormattedPlural, _Component);
	
	  function FormattedPlural(props, context) {
	    classCallCheck(this, FormattedPlural);
	
	    var _this = possibleConstructorReturn(this, (FormattedPlural.__proto__ || Object.getPrototypeOf(FormattedPlural)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedPlural, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, next = Array(_len), _key = 0; _key < _len; _key++) {
	        next[_key] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatPlural = _context$intl.formatPlural,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          value = _props.value,
	          other = _props.other,
	          children = _props.children;
	
	
	      var pluralCategory = formatPlural(value, this.props);
	      var formattedPlural = this.props[pluralCategory] || other;
	
	      if (typeof children === 'function') {
	        return children(formattedPlural);
	      }
	
	      return React__default.createElement(
	        Text,
	        null,
	        formattedPlural
	      );
	    }
	  }]);
	  return FormattedPlural;
	}(React.Component);
	
	FormattedPlural.displayName = 'FormattedPlural';
	FormattedPlural.contextTypes = {
	  intl: intlShape
	};
	FormattedPlural.defaultProps = {
	  style: 'cardinal'
	};
	 false ? FormattedPlural.propTypes = _extends({}, pluralFormatPropTypes, {
	  value: PropTypes.any.isRequired,
	
	  other: PropTypes.node.isRequired,
	  zero: PropTypes.node,
	  one: PropTypes.node,
	  two: PropTypes.node,
	  few: PropTypes.node,
	  many: PropTypes.node,
	
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var defaultFormatMessage = function defaultFormatMessage(descriptor, values) {
	  if (false) {
	    console.error('[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry. Using default message as fallback.');
	  }
	  return formatMessage({}, { getMessageFormat: memoizeIntlConstructor(IntlMessageFormat) }, descriptor, values);
	};
	
	var FormattedMessage = function (_Component) {
	  inherits(FormattedMessage, _Component);
	
	  function FormattedMessage(props, context) {
	    classCallCheck(this, FormattedMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedMessage.__proto__ || Object.getPrototypeOf(FormattedMessage)).call(this, props, context));
	
	    if (!props.defaultMessage) {
	      invariantIntlContext(context);
	    }
	    return _this;
	  }
	
	  createClass(FormattedMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ref = this.context.intl || {},
	          _ref$formatMessage = _ref.formatMessage,
	          formatMessage$$1 = _ref$formatMessage === undefined ? defaultFormatMessage : _ref$formatMessage,
	          _ref$textComponent = _ref.textComponent,
	          Text = _ref$textComponent === undefined ? 'span' : _ref$textComponent;
	
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          values = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	
	      var tokenDelimiter = void 0;
	      var tokenizedValues = void 0;
	      var elements = void 0;
	
	      var hasValues = values && Object.keys(values).length > 0;
	      if (hasValues) {
	        // Creates a token with a random UID that should not be guessable or
	        // conflict with other parts of the `message` string.
	        var uid = Math.floor(Math.random() * 0x10000000000).toString(16);
	
	        var generateToken = function () {
	          var counter = 0;
	          return function () {
	            return 'ELEMENT-' + uid + '-' + (counter += 1);
	          };
	        }();
	
	        // Splitting with a delimiter to support IE8. When using a regex
	        // with a capture group IE8 does not include the capture group in
	        // the resulting array.
	        tokenDelimiter = '@__' + uid + '__@';
	        tokenizedValues = {};
	        elements = {};
	
	        // Iterates over the `props` to keep track of any React Element
	        // values so they can be represented by the `token` as a placeholder
	        // when the `message` is formatted. This allows the formatted
	        // message to then be broken-up into parts with references to the
	        // React Elements inserted back in.
	        Object.keys(values).forEach(function (name) {
	          var value = values[name];
	
	          if (React.isValidElement(value)) {
	            var token = generateToken();
	            tokenizedValues[name] = tokenDelimiter + token + tokenDelimiter;
	            elements[token] = value;
	          } else {
	            tokenizedValues[name] = value;
	          }
	        });
	      }
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedMessage = formatMessage$$1(descriptor, tokenizedValues || values);
	
	      var nodes = void 0;
	
	      var hasElements = elements && Object.keys(elements).length > 0;
	      if (hasElements) {
	        // Split the message into parts so the React Element values captured
	        // above can be inserted back into the rendered message. This
	        // approach allows messages to render with React Elements while
	        // keeping React's virtual diffing working properly.
	        nodes = formattedMessage.split(tokenDelimiter).filter(function (part) {
	          return !!part;
	        }).map(function (part) {
	          return elements[part] || part;
	        });
	      } else {
	        nodes = [formattedMessage];
	      }
	
	      if (typeof children === 'function') {
	        return children.apply(undefined, toConsumableArray(nodes));
	      }
	
	      // Needs to use `createElement()` instead of JSX, otherwise React will
	      // warn about a missing `key` prop with rich-text message formatting.
	      return React.createElement.apply(undefined, [Component$$1, null].concat(toConsumableArray(nodes)));
	    }
	  }]);
	  return FormattedMessage;
	}(React.Component);
	
	FormattedMessage.displayName = 'FormattedMessage';
	FormattedMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: PropTypes.object,
	  tagName: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	var FormattedHTMLMessage = function (_Component) {
	  inherits(FormattedHTMLMessage, _Component);
	
	  function FormattedHTMLMessage(props, context) {
	    classCallCheck(this, FormattedHTMLMessage);
	
	    var _this = possibleConstructorReturn(this, (FormattedHTMLMessage.__proto__ || Object.getPrototypeOf(FormattedHTMLMessage)).call(this, props, context));
	
	    invariantIntlContext(context);
	    return _this;
	  }
	
	  createClass(FormattedHTMLMessage, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      var values = this.props.values;
	      var nextValues = nextProps.values;
	
	
	      if (!shallowEquals(nextValues, values)) {
	        return true;
	      }
	
	      // Since `values` has already been checked, we know they're not
	      // different, so the current `values` are carried over so the shallow
	      // equals comparison on the other props isn't affected by the `values`.
	      var nextPropsToCheck = _extends({}, nextProps, {
	        values: values
	      });
	
	      for (var _len = arguments.length, next = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        next[_key - 1] = arguments[_key];
	      }
	
	      return shouldIntlComponentUpdate.apply(undefined, [this, nextPropsToCheck].concat(next));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$intl = this.context.intl,
	          formatHTMLMessage = _context$intl.formatHTMLMessage,
	          Text = _context$intl.textComponent;
	      var _props = this.props,
	          id = _props.id,
	          description = _props.description,
	          defaultMessage = _props.defaultMessage,
	          rawValues = _props.values,
	          _props$tagName = _props.tagName,
	          Component$$1 = _props$tagName === undefined ? Text : _props$tagName,
	          children = _props.children;
	
	
	      var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
	      var formattedHTMLMessage = formatHTMLMessage(descriptor, rawValues);
	
	      if (typeof children === 'function') {
	        return children(formattedHTMLMessage);
	      }
	
	      // Since the message presumably has HTML in it, we need to set
	      // `innerHTML` in order for it to be rendered and not escaped by React.
	      // To be safe, all string prop values were escaped when formatting the
	      // message. It is assumed that the message is not UGC, and came from the
	      // developer making it more like a template.
	      //
	      // Note: There's a perf impact of using this component since there's no
	      // way for React to do its virtual DOM diffing.
	      var html = { __html: formattedHTMLMessage };
	      return React__default.createElement(Component$$1, { dangerouslySetInnerHTML: html });
	    }
	  }]);
	  return FormattedHTMLMessage;
	}(React.Component);
	
	FormattedHTMLMessage.displayName = 'FormattedHTMLMessage';
	FormattedHTMLMessage.contextTypes = {
	  intl: intlShape
	};
	FormattedHTMLMessage.defaultProps = {
	  values: {}
	};
	 false ? FormattedHTMLMessage.propTypes = _extends({}, messageDescriptorPropTypes, {
	  values: PropTypes.object,
	  tagName: PropTypes.string,
	  children: PropTypes.func
	}) : void 0;
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(defaultLocaleData);
	
	/*
	 * Copyright 2015, Yahoo Inc.
	 * Copyrights licensed under the New BSD License.
	 * See the accompanying LICENSE file for terms.
	 */
	
	addLocaleData(allLocaleData);
	
	exports.addLocaleData = addLocaleData;
	exports.intlShape = intlShape;
	exports.injectIntl = injectIntl;
	exports.defineMessages = defineMessages;
	exports.IntlProvider = IntlProvider;
	exports.FormattedDate = FormattedDate;
	exports.FormattedTime = FormattedTime;
	exports.FormattedRelative = FormattedRelative;
	exports.FormattedNumber = FormattedNumber;
	exports.FormattedPlural = FormattedPlural;
	exports.FormattedMessage = FormattedMessage;
	exports.FormattedHTMLMessage = FormattedHTMLMessage;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(460);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.21';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function',
	      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading whitespace. */
	  var reTrimStart = /^\s+/;
	
	  /** Used to match a single whitespace character. */
	  var reWhitespace = /\s/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /**
	   * Used to validate the `validate` option in `_.template` variable.
	   *
	   * Forbids characters which could potentially change the meaning of the function argument definition:
	   * - "()," (modification of function parameters)
	   * - "=" (default value)
	   * - "[]{}" (destructuring of function parameters)
	   * - "/" (beginning of a comment)
	   * - whitespace
	   */
	  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
	      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	      if (types) {
	        return types;
	      }
	
	      // Legacy `process.binding('util')` for Node.js < 10.
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.trim`.
	   *
	   * @private
	   * @param {string} string The string to trim.
	   * @returns {string} Returns the trimmed string.
	   */
	  function baseTrim(string) {
	    return string
	      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	      : string;
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedEndIndex(string) {
	    var index = string.length;
	
	    while (index-- && reWhitespace.test(string.charAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      if (isSet(value)) {
	        value.forEach(function(subValue) {
	          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	        });
	      } else if (isMap(value)) {
	        value.forEach(function(subValue, key) {
	          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	        });
	      }
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        stack || (stack = new Stack);
	        if (isObject(srcValue)) {
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = safeGet(object, key),
	          srcValue = safeGet(source, key),
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || isFunction(objValue)) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      if (iteratees.length) {
	        iteratees = arrayMap(iteratees, function(iteratee) {
	          if (isArray(iteratee)) {
	            return function(value) {
	              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	            }
	          }
	          return iteratee;
	        });
	      } else {
	        iteratees = [identity];
	      }
	
	      var index = -1;
	      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	          return object;
	        }
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      var low = 0,
	          high = array == null ? 0 : array.length;
	      if (high === 0) {
	        return 0;
	      }
	
	      value = iteratee(value);
	      var valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision && nativeIsFinite(number)) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Check that cyclic values are equal.
	      var arrStacked = stack.get(array);
	      var othStacked = stack.get(other);
	      if (arrStacked && othStacked) {
	        return arrStacked == other && othStacked == array;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Check that cyclic values are equal.
	      var objStacked = stack.get(object);
	      var othStacked = stack.get(other);
	      if (objStacked && othStacked) {
	        return objStacked == other && othStacked == object;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return new Ctor;
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return new Ctor;
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      var type = typeof value;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	
	      return !!length &&
	        (type == 'number' ||
	          (type != 'symbol' && reIsUint.test(value))) &&
	            (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the property to get.
	     * @returns {*} Returns the property value.
	     */
	    function safeGet(object, key) {
	      if (key === 'constructor' && typeof object[key] === 'function') {
	        return;
	      }
	
	      if (key == '__proto__') {
	        return;
	      }
	
	      return object[key];
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (string.charCodeAt(0) === 46 /* . */) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, subString) {
	        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     *
	     * // Combining several predicates using `_.overEvery` or `_.overSome`.
	     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	     * // => objects for ['fred', 'barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 30 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            timeWaiting = wait - timeSinceLastCall;
	
	        return maxing
	          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	          : timeWaiting;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            clearTimeout(timerId);
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = baseTrim(value);
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(object, sources) {
	      object = Object(object);
	
	      var index = -1;
	      var length = sources.length;
	      var guard = length > 2 ? sources[2] : undefined;
	
	      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	        length = 1;
	      }
	
	      while (++index < length) {
	        var source = sources[index];
	        var props = keysIn(source);
	        var propsIndex = -1;
	        var propsLength = props.length;
	
	        while (++propsIndex < propsLength) {
	          var key = props[propsIndex];
	          var value = object[key];
	
	          if (value === undefined ||
	              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	            object[key] = source[key];
	          }
	        }
	      }
	
	      return object;
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (value != null &&
	          typeof value.toString != 'function') {
	        value = nativeObjectToString.call(value);
	      }
	
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      // The sourceURL gets injected into the source that's eval-ed, so be careful
	      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
	      // and escape the comment, thus injecting code that gets evaled.
	      var sourceURL = '//# sourceURL=' +
	        (hasOwnProperty.call(options, 'sourceURL')
	          ? (options.sourceURL + '').replace(/\s/g, ' ')
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Throw an error if a forbidden character was found in `variable`, to prevent
	      // potential command injection attacks.
	      else if (reForbiddenIdentifierChars.test(variable)) {
	        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
	      }
	
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return baseTrim(string);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.slice(0, trimmedEndIndex(string) + 1);
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * **Note:** Multiple values can be checked by combining several matchers
	     * using `_.overSome`
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     *
	     * // Checking for several possible values
	     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
	     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * Following shorthands are possible for providing predicates.
	     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
	     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     *
	     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
	     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name + '';
	        if (!hasOwnProperty.call(realNames, key)) {
	          realNames[key] = [];
	        }
	        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(102)(module)))

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1060), __esModule: true };

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1044);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1043);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(190);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(190);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireDefault(__webpack_require__(1686));
	
	exports.Provider = _Provider["default"];
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(761));
	
	exports.connectAdvanced = _connectAdvanced["default"];
	
	var _Context = __webpack_require__(139);
	
	exports.ReactReduxContext = _Context.ReactReduxContext;
	
	var _connect = _interopRequireDefault(__webpack_require__(1687));
	
	exports.connect = _connect["default"];
	
	var _useDispatch = __webpack_require__(1693);
	
	exports.useDispatch = _useDispatch.useDispatch;
	exports.createDispatchHook = _useDispatch.createDispatchHook;
	
	var _useSelector = __webpack_require__(1694);
	
	exports.useSelector = _useSelector.useSelector;
	exports.createSelectorHook = _useSelector.createSelectorHook;
	
	var _useStore = __webpack_require__(764);
	
	exports.useStore = _useStore.useStore;
	exports.createStoreHook = _useStore.createStoreHook;
	
	var _batch = __webpack_require__(765);
	
	var _reactBatchedUpdates = __webpack_require__(1696);
	
	exports.batch = _reactBatchedUpdates.unstable_batchedUpdates;
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(766));
	
	exports.shallowEqual = _shallowEqual["default"];
	(0, _batch.setBatch)(_reactBatchedUpdates.unstable_batchedUpdates);

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(1042);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 16 */
/***/ (function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = exports.Toggle = exports.TimePicker = exports.TextField = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = exports.Tab = exports.Tabs = exports.Snackbar = exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = exports.SvgIcon = exports.Subheader = exports.Slider = exports.SelectField = exports.RefreshIndicator = exports.RaisedButton = exports.RadioButtonGroup = exports.RadioButton = exports.Popover = exports.Paper = exports.MuiThemeProvider = exports.MenuItem = exports.Menu = exports.makeSelectable = exports.ListItem = exports.List = exports.LinearProgress = exports.IconMenu = exports.IconButton = exports.GridTile = exports.GridList = exports.FontIcon = exports.FloatingActionButton = exports.FlatButton = exports.DropDownMenu = exports.Drawer = exports.Divider = exports.Dialog = exports.DatePicker = exports.CircularProgress = exports.Chip = exports.Checkbox = exports.CardText = exports.CardTitle = exports.CardMedia = exports.CardHeader = exports.CardActions = exports.Card = exports.BottomNavigationItem = exports.BottomNavigation = exports.Badge = exports.Avatar = exports.AutoComplete = exports.AppBar = undefined;
	
	var _AppBar2 = __webpack_require__(584);
	
	var _AppBar3 = _interopRequireDefault(_AppBar2);
	
	var _AutoComplete2 = __webpack_require__(1521);
	
	var _AutoComplete3 = _interopRequireDefault(_AutoComplete2);
	
	var _Avatar2 = __webpack_require__(585);
	
	var _Avatar3 = _interopRequireDefault(_Avatar2);
	
	var _Badge2 = __webpack_require__(1524);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _BottomNavigation2 = __webpack_require__(1526);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(586);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	var _Card2 = __webpack_require__(1528);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardActions2 = __webpack_require__(587);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardHeader2 = __webpack_require__(589);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardMedia2 = __webpack_require__(590);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardTitle2 = __webpack_require__(592);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardText2 = __webpack_require__(591);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _Checkbox2 = __webpack_require__(269);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Chip2 = __webpack_require__(1531);
	
	var _Chip3 = _interopRequireDefault(_Chip2);
	
	var _CircularProgress2 = __webpack_require__(170);
	
	var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);
	
	var _DatePicker2 = __webpack_require__(1543);
	
	var _DatePicker3 = _interopRequireDefault(_DatePicker2);
	
	var _Dialog2 = __webpack_require__(171);
	
	var _Dialog3 = _interopRequireDefault(_Dialog2);
	
	var _Divider2 = __webpack_require__(172);
	
	var _Divider3 = _interopRequireDefault(_Divider2);
	
	var _Drawer2 = __webpack_require__(594);
	
	var _Drawer3 = _interopRequireDefault(_Drawer2);
	
	var _DropDownMenu2 = __webpack_require__(373);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _FlatButton2 = __webpack_require__(82);
	
	var _FlatButton3 = _interopRequireDefault(_FlatButton2);
	
	var _FloatingActionButton2 = __webpack_require__(1550);
	
	var _FloatingActionButton3 = _interopRequireDefault(_FloatingActionButton2);
	
	var _FontIcon2 = __webpack_require__(83);
	
	var _FontIcon3 = _interopRequireDefault(_FontIcon2);
	
	var _GridList2 = __webpack_require__(1553);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(595);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	var _IconButton2 = __webpack_require__(64);
	
	var _IconButton3 = _interopRequireDefault(_IconButton2);
	
	var _IconMenu2 = __webpack_require__(596);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _LinearProgress2 = __webpack_require__(374);
	
	var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);
	
	var _List2 = __webpack_require__(173);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(376);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(597);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	var _Menu2 = __webpack_require__(598);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(113);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _MuiThemeProvider2 = __webpack_require__(619);
	
	var _MuiThemeProvider3 = _interopRequireDefault(_MuiThemeProvider2);
	
	var _Paper2 = __webpack_require__(37);
	
	var _Paper3 = _interopRequireDefault(_Paper2);
	
	var _Popover2 = __webpack_require__(1561);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _RadioButton2 = __webpack_require__(601);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(600);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	var _RaisedButton2 = __webpack_require__(114);
	
	var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);
	
	var _RefreshIndicator2 = __webpack_require__(1564);
	
	var _RefreshIndicator3 = _interopRequireDefault(_RefreshIndicator2);
	
	var _SelectField2 = __webpack_require__(271);
	
	var _SelectField3 = _interopRequireDefault(_SelectField2);
	
	var _Slider2 = __webpack_require__(1567);
	
	var _Slider3 = _interopRequireDefault(_Slider2);
	
	var _Subheader2 = __webpack_require__(115);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	var _SvgIcon2 = __webpack_require__(45);
	
	var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);
	
	var _Step2 = __webpack_require__(1571);
	
	var _Step3 = _interopRequireDefault(_Step2);
	
	var _StepButton2 = __webpack_require__(1572);
	
	var _StepButton3 = _interopRequireDefault(_StepButton2);
	
	var _StepContent2 = __webpack_require__(1574);
	
	var _StepContent3 = _interopRequireDefault(_StepContent2);
	
	var _StepLabel2 = __webpack_require__(602);
	
	var _StepLabel3 = _interopRequireDefault(_StepLabel2);
	
	var _Stepper2 = __webpack_require__(1575);
	
	var _Stepper3 = _interopRequireDefault(_Stepper2);
	
	var _Snackbar2 = __webpack_require__(1570);
	
	var _Snackbar3 = _interopRequireDefault(_Snackbar2);
	
	var _Tabs2 = __webpack_require__(1582);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Tab2 = __webpack_require__(607);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Table2 = __webpack_require__(273);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(603);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(604);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(605);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(379);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(606);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(272);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	var _TextField2 = __webpack_require__(58);
	
	var _TextField3 = _interopRequireDefault(_TextField2);
	
	var _TimePicker2 = __webpack_require__(1594);
	
	var _TimePicker3 = _interopRequireDefault(_TimePicker2);
	
	var _Toggle2 = __webpack_require__(610);
	
	var _Toggle3 = _interopRequireDefault(_Toggle2);
	
	var _Toolbar2 = __webpack_require__(614);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(611);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(612);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(613);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AppBar = _AppBar3.default;
	exports.AutoComplete = _AutoComplete3.default;
	exports.Avatar = _Avatar3.default;
	exports.Badge = _Badge3.default;
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.Card = _Card3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardText = _CardText3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Chip = _Chip3.default;
	exports.CircularProgress = _CircularProgress3.default;
	exports.DatePicker = _DatePicker3.default;
	exports.Dialog = _Dialog3.default;
	exports.Divider = _Divider3.default;
	exports.Drawer = _Drawer3.default;
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.FlatButton = _FlatButton3.default;
	exports.FloatingActionButton = _FloatingActionButton3.default;
	exports.FontIcon = _FontIcon3.default;
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.IconButton = _IconButton3.default;
	exports.IconMenu = _IconMenu3.default;
	exports.LinearProgress = _LinearProgress3.default;
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.MuiThemeProvider = _MuiThemeProvider3.default;
	exports.Paper = _Paper3.default;
	exports.Popover = _Popover3.default;
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.RaisedButton = _RaisedButton3.default;
	exports.RefreshIndicator = _RefreshIndicator3.default;
	exports.SelectField = _SelectField3.default;
	exports.Slider = _Slider3.default;
	exports.Subheader = _Subheader3.default;
	exports.SvgIcon = _SvgIcon3.default;
	exports.Step = _Step3.default;
	exports.StepButton = _StepButton3.default;
	exports.StepContent = _StepContent3.default;
	exports.StepLabel = _StepLabel3.default;
	exports.Stepper = _Stepper3.default;
	exports.Snackbar = _Snackbar3.default;
	exports.Tabs = _Tabs3.default;
	exports.Tab = _Tab3.default;
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.TextField = _TextField3.default;
	exports.TimePicker = _TimePicker3.default;
	exports.Toggle = _Toggle3.default;
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// Notification
	var SHOW_ALERT = exports.SHOW_ALERT = 'SHOW_ALERT';
	var HIDE_ALERT = exports.HIDE_ALERT = 'HIDE_ALERT';
	
	// Career
	var REQUEST_CAREER = exports.REQUEST_CAREER = 'REQUEST_CAREER';
	var REQUEST_CAREER_FAILURE = exports.REQUEST_CAREER_FAILURE = 'REQUEST_CAREER_FAILURE';
	var REQUEST_CAREER_SUCCESS = exports.REQUEST_CAREER_SUCCESS = 'REQUEST_CAREER_SUCCESS';
	
	// Certificate
	var REQUEST_CERTIFICATE = exports.REQUEST_CERTIFICATE = 'REQUEST_CERTIFICATE';
	var REQUEST_CERTIFICATE_FAILURE = exports.REQUEST_CERTIFICATE_FAILURE = 'REQUEST_CERTIFICATE_FAILURE';
	var REQUEST_CERTIFICATE_SUCCESS = exports.REQUEST_CERTIFICATE_SUCCESS = 'REQUEST_CERTIFICATE_SUCCESS';
	
	// Dialog Box
	var HIDE_DIALOG_BOX = exports.HIDE_DIALOG_BOX = 'HIDE_DIALOG_BOX';
	var SHOW_DIALOG_BOX = exports.SHOW_DIALOG_BOX = 'SHOW_DIALOG_BOX';
	
	// Education
	var REQUEST_EDUCATION = exports.REQUEST_EDUCATION = 'REQUEST_EDUCATION';
	var REQUEST_EDUCATION_FAILURE = exports.REQUEST_EDUCATION_FAILURE = 'REQUEST_EDUCATION_FAILURE';
	var REQUEST_EDUCATION_SUCCESS = exports.REQUEST_EDUCATION_SUCCESS = 'REQUEST_EDUCATION_SUCCESS';
	
	// Login
	var INITIALIZE_LOGIN = exports.INITIALIZE_LOGIN = 'INITIALIZE_LOGIN';
	var LOGIN = exports.LOGIN = 'LOGIN';
	var LOGIN_FAILURE = exports.LOGIN_FAILURE = 'LOGIN_FAILURE';
	var LOGIN_REQUEST = exports.LOGIN_REQUEST = 'LOGIN_REQUEST';
	var LOGIN_STEP = exports.LOGIN_STEP = 'LOGIN_STEP';
	var LOGIN_SUCCESS = exports.LOGIN_SUCCESS = 'LOGIN_SUCCESS';
	var LOGIN_VALIDATION_ERRORS = exports.LOGIN_VALIDATION_ERRORS = 'LOGIN_VALIDATION_ERRORS';
	var LOGOUT_FAILURE = exports.LOGOUT_FAILURE = 'LOGOUT_FAILURE';
	var LOGOUT_REQUEST = exports.LOGOUT_REQUEST = 'LOGOUT_REQUEST';
	var LOGOUT_SUCCESS = exports.LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
	var NOT_AUTHENTICATED = exports.NOT_AUTHENTICATED = 'NOT_AUTHENTICATED';
	var AUTHENTICATED = exports.AUTHENTICATED = 'AUTHENTICATED';
	var SSO_CHECK_START = exports.SSO_CHECK_START = 'SSO_CHECK_START';
	var SSO_CHECK_END = exports.SSO_CHECK_END = 'SSO_CHECK_END';
	var SET_SECURITY_CODE = exports.SET_SECURITY_CODE = 'SET_SECURITY_CODE';
	
	var SET_DETAIL_IDS = exports.SET_DETAIL_IDS = 'SET_DETAIL_IDS';
	
	// Appraisal
	var REQUEST_APPRAISAL = exports.REQUEST_APPRAISAL = 'REQUEST_APPRAISAL';
	var REQUEST_APPRAISAL_SUCCESS = exports.REQUEST_APPRAISAL_SUCCESS = 'REQUEST_APPRAISAL_SUCCESS';
	var REQUEST_APPRAISAL_FAILURE = exports.REQUEST_APPRAISAL_FAILURE = 'REQUEST_APPRAISAL_FAILURE';
	var REQUEST_APPRAISAL_BY_ID = exports.REQUEST_APPRAISAL_BY_ID = 'REQUEST_APPRAISAL_BY_ID';
	var REQUEST_APPRAISAL_BY_ID_SUCCESS = exports.REQUEST_APPRAISAL_BY_ID_SUCCESS = 'REQUEST_APPRAISAL_BY_ID_SUCCESS';
	var REQUEST_APPRAISAL_BY_ID_FAILURE = exports.REQUEST_APPRAISAL_BY_ID_FAILURE = 'REQUEST_APPRAISAL_BY_ID_FAILURE';
	var RESET_APPRAISAL_LOADING = exports.RESET_APPRAISAL_LOADING = 'RESET_APPRAISAL_LOADING';
	var SAVING_APPRAISAL = exports.SAVING_APPRAISAL = 'SAVING_APPRAISAL';
	var SAVING_APPRAISAL_SUCCESS = exports.SAVING_APPRAISAL_SUCCESS = 'SAVING_APPRAISAL_SUCCESS';
	var SAVING_APPRAISAL_FAILURE = exports.SAVING_APPRAISAL_FAILURE = 'SAVING_APPRAISAL_FAILURE';
	var SUBMIT_APPRAISAL = exports.SUBMIT_APPRAISAL = 'SUBMIT_APPRAISAL';
	var SUBMIT_APPRAISAL_SUCCESS = exports.SUBMIT_APPRAISAL_SUCCESS = 'SUBMIT_APPRAISAL_SUCCESS';
	var SUBMIT_APPRAISAL_FAILURE = exports.SUBMIT_APPRAISAL_FAILURE = 'SUBMIT_APPRAISAL_FAILURE';
	var SET_FINAL_ANSWERS = exports.SET_FINAL_ANSWERS = 'SET_FINAL_ANSWER';
	var SET_MANAGER_ANSWERS = exports.SET_MANAGER_ANSWERS = 'SET_MANAGER_ANSWER';
	var SET_EMPLOYEE_ANSWERS = exports.SET_EMPLOYEE_ANSWERS = 'SET_EMPLOYEE_ANSWER';
	var SET_MANAGER_YEAR = exports.SET_MANAGER_YEAR = 'SET_MANAGER_YEAR';
	var SET_EMPLOYEE_YEAR = exports.SET_EMPLOYEE_YEAR = 'SET_EMPLOYEE_YEAR';
	var SET_APPRAISAL_TAB = exports.SET_APPRAISAL_TAB = 'SET_APPRAISAL_TAB';
	
	// Manager Appraisal
	var REQUEST_MANAGER_APPRAISAL = exports.REQUEST_MANAGER_APPRAISAL = 'REQUEST_MANAGER_APPRAISAL';
	var REQUEST_MANAGER_APPRAISAL_SUCCESS = exports.REQUEST_MANAGER_APPRAISAL_SUCCESS = 'REQUEST_MANAGER_APPRAISAL_SUCCESS';
	var REQUEST_MANAGER_APPRAISAL_FAILURE = exports.REQUEST_MANAGER_APPRAISAL_FAILURE = 'REQUEST_MANAGER_APPRAISAL_FAILURE';
	var SET_EMPLOYEE = exports.SET_EMPLOYEE = 'SET_EMPLOYEE';
	
	//  Emoployee Holiday
	var REQUEST_HOLIDAY = exports.REQUEST_HOLIDAY = 'REQUEST_HOLIDAY';
	var REQUEST_HOLIDAY_SUCCESS = exports.REQUEST_HOLIDAY_SUCCESS = 'REQUEST_HOLIDAY_SUCCESS';
	var REQUEST_HOLIDAY_FAILURE = exports.REQUEST_HOLIDAY_FAILURE = 'REQUEST_HOLIDAY_FAILURE';
	var REQUEST_HOLIDAY_OVERVIEW = exports.REQUEST_HOLIDAY_OVERVIEW = 'REQUEST_HOLIDAY_OVERVIEW';
	var REQUEST_HOLIDAY_OVERVIEW_SUCCESS = exports.REQUEST_HOLIDAY_OVERVIEW_SUCCESS = 'REQUEST_HOLIDAY_OVERVIEW_SUCCESS';
	var REQUEST_HOLIDAY_OVERVIEW_FAILURE = exports.REQUEST_HOLIDAY_OVERVIEW_FAILURE = 'REQUEST_HOLIDAY_OVERVIEW_FAILURE';
	var SET_HOLIDAY_INFO = exports.SET_HOLIDAY_INFO = 'SET_HOLIDAY_INFO';
	var FETCH_HOLIDAY_BY_YEAR = exports.FETCH_HOLIDAY_BY_YEAR = 'FETCH_HOLIDAY_BY_YEAR';
	var FETCH_HOLIDAY_BY_YEAR_SUCCESS = exports.FETCH_HOLIDAY_BY_YEAR_SUCCESS = 'FETCH_HOLIDAY_BY_YEAR_SUCCESS';
	var FETCH_HOLIDAY_BY_YEAR_FAILURE = exports.FETCH_HOLIDAY_BY_YEAR_FAILURE = 'FETCH_HOLIDAY_BY_YEAR_FAILURE';
	
	//  Emoployee Bank
	var REQUEST_BANK = exports.REQUEST_BANK = 'REQUEST_BANK';
	var REQUEST_BANK_SUCCESS = exports.REQUEST_BANK_SUCCESS = 'REQUEST_BANK_SUCCESS';
	var REQUEST_BANK_FAILURE = exports.REQUEST_BANK_FAILURE = 'REQUEST_BANK_FAILURE';
	var SET_BANK_BRANCHES = exports.SET_BANK_BRANCHES = 'SET_BANK_BRANCHES';
	var REQUEST_BANK_BRANCHES = exports.REQUEST_BANK_BRANCHES = 'REQUEST_BANK_BRANCHES';
	
	var SET_ACCOUNT_STATUS = exports.SET_ACCOUNT_STATUS = 'SET_ACCOUNT_STATUS';
	var CREATE_NEW_ACCOUNT = exports.CREATE_NEW_ACCOUNT = 'CREATE_NEW_ACCOUNT';
	var CLEAR_NEW_ACCOUNT = exports.CLEAR_NEW_ACCOUNT = 'CLEAR_NEW_ACCOUNT';
	
	var REQUEST_BANK_UPDATE = exports.REQUEST_BANK_UPDATE = 'REQUEST_BANK_UPDATE';
	var REQUEST_BANK_UPDATE_SUCCESS = exports.REQUEST_BANK_UPDATE_SUCCESS = 'REQUEST_BANK_UPDATE_SUCCESS';
	var REQUEST_BANK_UPDATE_FAILURE = exports.REQUEST_BANK_UPDATE_FAILURE = 'REQUEST_BANK_UPDATE_FAILURE';
	
	// Profile
	var REQUEST_EMPLOYEE_MASTER = exports.REQUEST_EMPLOYEE_MASTER = 'REQUEST_EMPLOYEE_MASTER';
	var REQUEST_EMPLOYEE_MASTER_FAILURE = exports.REQUEST_EMPLOYEE_MASTER_FAILURE = 'REQUEST_EMPLOYEE_MASTER_FAILURE';
	var REQUEST_EMPLOYEE_MASTER_SUCCESS = exports.REQUEST_EMPLOYEE_MASTER_SUCCESS = 'REQUEST_EMPLOYEE_MASTER_SUCCESS';
	var REQUEST_EMPLOYEE_DETAIL_ORG = exports.REQUEST_EMPLOYEE_DETAIL_ORG = 'REQUEST_EMPLOYEE_DETAIL_ORG';
	var REQUEST_EMPLOYEE_DETAIL_ORG_FAILURE = exports.REQUEST_EMPLOYEE_DETAIL_ORG_FAILURE = 'REQUEST_EMPLOYEE_DETAIL_ORG_FAILURE';
	var REQUEST_EMPLOYEE_DETAIL_ORG_SUCCESS = exports.REQUEST_EMPLOYEE_DETAIL_ORG_SUCCESS = 'REQUEST_EMPLOYEE_DETAIL_ORG_SUCCESS';
	var PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_REQUEST = exports.PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_REQUEST = 'PATCH_IDENTIFICATIONCARD_REQUEST';
	var PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_SUCCESS = exports.PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_SUCCESS = 'PATCH_IDENTIFICATIONCARD_SUCCESS';
	var PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_FAILURE = exports.PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_FAILURE = 'PATCH_IDENTIFICATIONCARD_FAILURE';
	
	// Qualification
	var REQUEST_QUALIFICATION = exports.REQUEST_QUALIFICATION = 'REQUEST_QUALIFICATION';
	var REQUEST_QUALIFICATION_FAILURE = exports.REQUEST_QUALIFICATION_FAILURE = 'REQUEST_QUALIFICATION_FAILURE';
	var REQUEST_QUALIFICATION_SUCCESS = exports.REQUEST_QUALIFICATION_SUCCESS = 'REQUEST_QUALIFICATION_SUCCESS';
	
	// Courses
	var REQUEST_EMPLOYEE_MASTER_COURSES = exports.REQUEST_EMPLOYEE_MASTER_COURSES = 'REQUEST_EMPLOYEE_MASTER_COURSES';
	var REQUEST_EMPLOYEE_MASTER_COURSES_FAILURE = exports.REQUEST_EMPLOYEE_MASTER_COURSES_FAILURE = 'REQUEST_EMPLOYEE_MASTER_COURSES_FAILURE';
	var REQUEST_EMPLOYEE_MASTER_COURSES_SUCCESS = exports.REQUEST_EMPLOYEE_MASTER_COURSES_SUCCESS = 'REQUEST_EMPLOYEE_MASTER_COURSES_SUCCESS';
	var REQUEST_COURSES = exports.REQUEST_COURSES = 'REQUEST_COURSES';
	var REQUEST_COURSES_FAILURE = exports.REQUEST_COURSES_FAILURE = 'REQUEST_COURSES_FAILURE';
	var REQUEST_COURSES_SUCCESS = exports.REQUEST_COURSES_SUCCESS = 'REQUEST_COURSES_SUCCESS';
	var REQUEST_COURSE_ATTENDANCE = exports.REQUEST_COURSE_ATTENDANCE = 'REQUEST_COURSE_ATTENDANCE';
	var REQUEST_COURSE_ATTENDANCE_SUCCESS = exports.REQUEST_COURSE_ATTENDANCE_SUCCESS = 'REQUEST_COURSE_ATTENDANCE_SUCCESS';
	var REQUEST_COURSE_ATTENDANCE_FAILURE = exports.REQUEST_COURSE_ATTENDANCE_FAILURE = 'REQUEST_COURSE_ATTENDANCE_FAILURE';
	var REQUEST_COURSE_LEAVE = exports.REQUEST_COURSE_LEAVE = 'REQUEST_COURSE_LEAVE';
	var REQUEST_COURSE_LEAVE_SUCCESS = exports.REQUEST_COURSE_LEAVE_SUCCESS = 'REQUEST_COURSE_LEAVE_SUCCESS';
	var REQUEST_COURSE_LEAVE_FAILURE = exports.REQUEST_COURSE_LEAVE_FAILURE = 'REQUEST_COURSE_LEAVE_FAILURE';
	
	var COURSE_EVAL_LIST_REQUEST = exports.COURSE_EVAL_LIST_REQUEST = 'COURSE_EVAL_LIST_REQUEST';
	var COURSE_EVAL_LIST_SUCCESS = exports.COURSE_EVAL_LIST_SUCCESS = 'COURSE_EVAL_LIST_SUCCESS';
	var COURSE_EVAL_LIST_FAILURE = exports.COURSE_EVAL_LIST_FAILURE = 'COURSE_EVAL_LIST_FAILURE';
	
	var COURSE_EVAL_REQUEST = exports.COURSE_EVAL_REQUEST = 'COURSE_EVAL_REQUEST';
	var COURSE_EVAL_SUCCESS = exports.COURSE_EVAL_SUCCESS = 'COURSE_EVAL_SUCCESS';
	var COURSE_EVAL_FAILURE = exports.COURSE_EVAL_FAILURE = 'COURSE_EVAL_FAILURE';
	
	var COURSE_EVAL_SAVE_REQUEST = exports.COURSE_EVAL_SAVE_REQUEST = 'COURSE_EVAL_SAVE_REQUEST';
	var COURSE_EVAL_SAVE_SUCCESS = exports.COURSE_EVAL_SAVE_SUCCESS = 'COURSE_EVAL_SAVE_SUCCESS';
	var COURSE_EVAL_SAVE_FAILURE = exports.COURSE_EVAL_SAVE_FAILURE = 'COURSE_EVAL_SAVE_FAILURE';
	
	var COURSE_EVAL_SUBMIT_REQUEST = exports.COURSE_EVAL_SUBMIT_REQUEST = 'COURSE_EVAL_SUBMIT_REQUEST';
	var COURSE_EVAL_SUBMIT_SUCCESS = exports.COURSE_EVAL_SUBMIT_SUCCESS = 'COURSE_EVAL_SUBMIT_SUCCESS';
	var COURSE_EVAL_SUBMIT_FAILURE = exports.COURSE_EVAL_SUBMIT_FAILURE = 'COURSE_EVAL_SUBMIT_FAILURE';
	
	// Course Questionnaire
	var COURSE_QUEST_REQUEST = exports.COURSE_QUEST_REQUEST = 'COURSE_QUEST_REQUEST';
	var COURSE_QUEST_SUCCESS = exports.COURSE_QUEST_SUCCESS = 'COURSE_QUEST_SUCCESS';
	var COURSE_QUEST_FAILURE = exports.COURSE_QUEST_FAILURE = 'COURSE_QUEST_FAILURE';
	
	var COURSE_QUEST_SUBMIT_REQUEST = exports.COURSE_QUEST_SUBMIT_REQUEST = 'COURSE_QUEST_SUBMIT_REQUEST';
	var COURSE_QUEST_SUBMIT_SUCCESS = exports.COURSE_QUEST_SUBMIT_SUCCESS = 'COURSE_QUEST_SUBMIT_SUCCESS';
	var COURSE_QUEST_SUBMIT_FAILURE = exports.COURSE_QUEST_SUBMIT_FAILURE = 'COURSE_QUEST_SUBMIT_FAILURE';
	
	// EmployeeSearch
	var SEARCH_REQUEST = exports.SEARCH_REQUEST = 'SEARCH_REQUEST';
	var SEARCH_REQUEST_CLEAR = exports.SEARCH_REQUEST_CLEAR = 'SEARCH_REQUEST_CLEAR';
	var SEARCH_REQUEST_SUCCESS = exports.SEARCH_REQUEST_SUCCESS = 'SEARCH_REQUEST_SUCCESS';
	var SEARCH_REQUEST_FAILURE = exports.SEARCH_REQUEST_FAILURE = 'SEARCH_REQUEST_FAILURE';
	var SEARCH_REQUEST_SUCCESS_ALL = exports.SEARCH_REQUEST_SUCCESS_ALL = 'SEARCH_REQUEST_SUCCESS_ALL';
	
	// Create new entitys in QData
	var CREATE_ENTITY_REQUEST = exports.CREATE_ENTITY_REQUEST = 'CREATE_ENTITY_REQUEST';
	var CREATE_ENTITY_REQUEST_SUCCESS = exports.CREATE_ENTITY_REQUEST_SUCCESS = 'CREATE_ENTITY_REQUEST_SUCCESS';
	var CREATE_ENTITY_REQUEST_FAILURE = exports.CREATE_ENTITY_REQUEST_FAILURE = 'CREATE_ENTITY_REQUEST_FAILURE';
	
	// Save entitys in QData
	var SAVE_ENTITY_REQUEST = exports.SAVE_ENTITY_REQUEST = 'SAVE_ENTITY_REQUEST';
	var SAVE_ENTITY_REQUEST_SUCCESS = exports.SAVE_ENTITY_REQUEST_SUCCESS = 'SAVE_ENTITY_REQUEST_SUCCESS';
	var SAVE_ENTITY_REQUEST_FAILURE = exports.SAVE_ENTITY_REQUEST_FAILURE = 'SAVE_ENTITY_REQUEST_FAILURE';
	
	// Delete entitys in QData
	var DELETE_ENTITY_REQUEST = exports.DELETE_ENTITY_REQUEST = 'DELETE_ENTITY_REQUEST';
	var DELETE_ENTITY_REQUEST_SUCCESS = exports.DELETE_ENTITY_REQUEST_SUCCESS = 'DELETE_ENTITY_REQUEST_SUCCESS';
	var DELETE_ENTITY_REQUEST_FAILURE = exports.DELETE_ENTITY_REQUEST_FAILURE = 'DELETE_ENTITY_REQUEST_FAILURE';
	
	// Settings
	var NEW_PASSWORD_REQUEST = exports.NEW_PASSWORD_REQUEST = 'NEW_PASSWORD_REQUEST';
	var NEW_PASSWORD_SUCCESS = exports.NEW_PASSWORD_SUCCESS = 'NEW_PASSWORD_SUCCESS';
	var NEW_PASSWORD_FAILURE = exports.NEW_PASSWORD_FAILURE = 'NEW_PASSWORD_FAILURE';
	
	// FILES
	
	var REQUEST_FILES = exports.REQUEST_FILES = 'REQUEST_FILES';
	var REQUEST_FILES_SUCCESS = exports.REQUEST_FILES_SUCCESS = 'REQUEST_FILES_SUCCESS';
	var REQUEST_FILES_FAILURE = exports.REQUEST_FILES_FAILURE = 'REQUEST_FILES_FAILURE';
	
	var REQUEST_PAYSLIPS = exports.REQUEST_PAYSLIPS = 'REQUEST_PAYSLIPS';
	var REQUEST_PAYSLIPS_SUCCESS = exports.REQUEST_PAYSLIPS_SUCCESS = 'REQUEST_PAYSLIPS_SUCCESS';
	var REQUEST_PAYSLIPS_FAILURE = exports.REQUEST_PAYSLIPS_FAILURE = 'REQUEST_PAYSLIPS_FAILURE';
	
	var REQUEST_FILE_DOWNLOAD = exports.REQUEST_FILE_DOWNLOAD = 'REQUEST_FILE_DOWNLOAD';
	var REQUEST_FILE_DOWNLOAD_SUCCESS = exports.REQUEST_FILE_DOWNLOAD_SUCCESS = 'REQUEST_FILE_DOWNLOAD_SUCCESS';
	var REQUEST_FILE_DOWNLOAD_FAILURE = exports.REQUEST_FILE_DOWNLOAD_FAILURE = 'REQUEST_FILE_DOWNLOAD_FAILURE';
	
	var REQUEST_FILE_DELETE = exports.REQUEST_FILE_DELETE = 'REQUEST_FILE_DELETE';
	var REQUEST_FILE_DELETE_SUCCESS = exports.REQUEST_FILE_DELETE_SUCCESS = 'REQUEST_FILE_DELETE_SUCCESS';
	var REQUEST_FILE_DELETE_FAILURE = exports.REQUEST_FILE_DELETE_FAILURE = 'REQUEST_FILE_DELETE_FAILURE';
	
	var REQUEST_FILE_UPLOAD = exports.REQUEST_FILE_UPLOAD = 'REQUEST_FILE_UPLOAD';
	var REQUEST_FILE_UPLOAD_SUCCESS = exports.REQUEST_FILE_UPLOAD_SUCCESS = 'REQUEST_FILE_UPLOAD_SUCCESS';
	var REQUEST_FILE_UPLOAD_FAILURE = exports.REQUEST_FILE_UPLOAD_FAILURE = 'REQUEST_FILE_UPLOAD_FAILURE';
	
	var INIT_FILE_UPLOAD = exports.INIT_FILE_UPLOAD = 'INIT_FILE_UPLOAD';
	var INIT_FILE_UPLOAD_SUCCESS = exports.INIT_FILE_UPLOAD_SUCCESS = 'INIT_FILE_UPLOAD_SUCCESS';
	var INIT_FILE_UPLOAD_FAILURE = exports.INIT_FILE_UPLOAD_FAILURE = 'INIT_FILE_UPLOAD_FAILURE';
	
	var REQUEST_FILE_BY_ID = exports.REQUEST_FILE_BY_ID = 'REQUEST_FILE_BY_ID';
	var REQUEST_FILE_BY_ID_SUCCESS = exports.REQUEST_FILE_BY_ID_SUCCESS = 'REQUEST_FILE_BY_ID_SUCCESS';
	var REQUEST_FILE_BY_ID_FAILURE = exports.REQUEST_FILE_BY_ID_FAILURE = 'REQUEST_FILE_BY_ID_FAILURE';
	
	// OrgChart
	var ORGCHART_REQUEST_DATA = exports.ORGCHART_REQUEST_DATA = 'ORGCHART_REQUEST_DATA';
	var ORGCHART_REQUEST_DATA_SUCCESS = exports.ORGCHART_REQUEST_DATA_SUCCESS = 'ORGCHART_REQUEST_DATA_SUCCESS';
	var ORGCHART_REQUEST_DATA_FAILURE = exports.ORGCHART_REQUEST_DATA_FAILURE = 'ORGCHART_REQUEST_DATA_FAILURE';
	var ORGCHART_SET_ACTIVE_NODE = exports.ORGCHART_SET_ACTIVE_NODE = 'ORGCHART_SET_ACTIVE_NODE';
	
	// WebValues
	
	var REQUEST_WEB_VALUES = exports.REQUEST_WEB_VALUES = 'REQUEST_WEB_VALUES';
	var REQUEST_WEB_VALUES_SUCCESS = exports.REQUEST_WEB_VALUES_SUCCESS = 'REQUEST_WEB_VALUES_SUCCESS';
	var REQUEST_WEB_VALUES_FAILURE = exports.REQUEST_WEB_VALUES_FAILURE = 'REQUEST_WEB_VALUES_FAILURE';
	
	var SET_LANGUAGE = exports.SET_LANGUAGE = 'SET_LANGUAGE';
	var SET_PAY_YEAR = exports.SET_PAY_YEAR = 'SET_PAY_YEAR';
	var SET_GROUP_FILTER = exports.SET_GROUP_FILTER = 'SET_GROUP_FILTER';
	
	var REQUEST_TAX_CARDS = exports.REQUEST_TAX_CARDS = 'REQUEST_TAX_CARDS';
	var REQUEST_TAX_CARDS_SUCCESS = exports.REQUEST_TAX_CARDS_SUCCESS = 'REQUEST_TAX_CARDS_SUCCESS';
	var REQUEST_TAX_CARDS_FAILURE = exports.REQUEST_TAX_CARDS_FAILURE = 'REQUEST_TAX_CARDS_FAILURE';
	
	var REQUEST_CREATE_TAX_CARDS = exports.REQUEST_CREATE_TAX_CARDS = 'REQUEST_CREATE_TAX_CARDS';
	var REQUEST_CREATE_TAX_CARDS_SUCCESS = exports.REQUEST_CREATE_TAX_CARDS_SUCCESS = 'REQUEST_CREATE_TAX_CARDS_SUCCESS';
	var REQUEST_CREATE_TAX_CARDS_FAILURE = exports.REQUEST_CREATE_TAX_CARDS_FAILURE = 'REQUEST_CREATE_TAX_CARDS_FAILURE';
	var REQUEST_UPDATE_TAX_CARD = exports.REQUEST_UPDATE_TAX_CARD = 'REQUEST_UPDATE_TAX_CARD';
	var REQUEST_UPDATE_TAX_CARD_SUCCESS = exports.REQUEST_UPDATE_TAX_CARD_SUCCESS = 'REQUEST_UPDATE_TAX_CARD_SUCCESS';
	var REQUEST_UPDATE_TAX_CARD_FAILURE = exports.REQUEST_UPDATE_TAX_CARD_FAILURE = 'REQUEST_UPDATE_TAX_CARD_FAILURE';
	var SET_TAX_CARD_INFO = exports.SET_TAX_CARD_INFO = 'SET_TAX_CARD_INFO';
	var SET_TAX_CARD_STATUS = exports.SET_TAX_CARD_STATUS = 'SET_TAX_CARD_STATUS';
	var SET_TAX_DISCOUNT = exports.SET_TAX_DISCOUNT = 'SET_TAX_DISCOUNT';
	
	var REQUEST_AGREEMENTS = exports.REQUEST_AGREEMENTS = 'REQUEST_AGREEMENTS';
	var REQUEST_AGREEMENTS_SUCCESS = exports.REQUEST_AGREEMENTS_SUCCESS = 'REQUEST_AGREEMENTS_SUCCESS';
	var REQUEST_AGREEMENTS_FAILURE = exports.REQUEST_AGREEMENTS_FAILURE = 'REQUEST_AGREEMENTS_FAILURE';
	
	var REQUEST_AGREEMENT_YES = exports.REQUEST_AGREEMENT_YES = 'REQUEST_AGREEMENT_YES';
	var REQUEST_AGREEMENT_NO = exports.REQUEST_AGREEMENT_NO = 'REQUEST_AGREEMENT_NO';
	
	var UPDATE_AGREEMENT_ANSWERS = exports.UPDATE_AGREEMENT_ANSWERS = 'UPDATE_AGREEMENT_ANSWERS';
	
	// Birthdays
	var REQUEST_BIRTHDAYS = exports.REQUEST_BIRTHDAYS = 'REQUEST_BIRTHDAYS';
	var REQUEST_BIRTHDAYS_SUCCESS = exports.REQUEST_BIRTHDAYS_SUCCESS = 'REQUEST_BIRTHDAYS_SUCCESS';
	var REQUEST_BIRTHDAYS_FAILURE = exports.REQUEST_BIRTHDAYS_FAILURE = 'REQUEST_BIRTHDAYS_FAILURE';
	
	// Benefits
	var REQUEST_BENEFITS = exports.REQUEST_BENEFITS = 'REQUEST_BENEFITS';
	var REQUEST_BENEFITS_SUCCESS = exports.REQUEST_BENEFITS_SUCCESS = 'REQUEST_BENEFITS_SUCCESS';
	var REQUEST_BENEFITS_FAILURE = exports.REQUEST_BENEFITS_FAILURE = 'REQUEST_BENEFITS_FAILURE';
	
	var FITNESS_GRANT_REGISTER_REQUEST = exports.FITNESS_GRANT_REGISTER_REQUEST = 'FITNESS_GRANT_REGISTER_REQUEST';
	var FITNESS_GRANT_REGISTER_SUCCESS = exports.FITNESS_GRANT_REGISTER_SUCCESS = 'FITNESS_GRANT_REGISTER_SUCCESS';
	var FITNESS_GRANT_REGISTER_FAILURE = exports.FITNESS_GRANT_REGISTER_FAILURE = 'FITNESS_GRANT_REGISTER_FAILURE';
	
	var GRANT_REGISTER_REQUEST = exports.GRANT_REGISTER_REQUEST = 'GRANT_REGISTER_REQUEST';
	var GRANT_REGISTER_SUCCESS = exports.GRANT_REGISTER_SUCCESS = 'GRANT_REGISTER_SUCCESS';
	var GRANT_REGISTER_FAILURE = exports.GRANT_REGISTER_FAILURE = 'GRANT_REGISTER_FAILURE';
	
	// Email
	var SEND_EMAIL = exports.SEND_EMAIL = 'SEND_EMAIL';
	var SEND_EMAIL_SUCCESS = exports.SEND_EMAIL_SUCCESS = 'SEND_EMAIL_SUCCESS';
	var SEND_EMAIL_FAILURE = exports.SEND_EMAIL_FAILURE = 'SEND_EMAIL_FAILURE';
	
	// Loans
	var REQUEST_LOANS = exports.REQUEST_LOANS = 'REQUEST_LOANS';
	var REQUEST_LOANS_FAILURE = exports.REQUEST_LOANS_FAILURE = 'REQUEST_LOANS_FAILURE';
	var REQUEST_LOANS_SUCCESS = exports.REQUEST_LOANS_SUCCESS = 'REQUEST_LOANS_SUCCESS';
	
	// Union
	var REQUEST_UNION = exports.REQUEST_UNION = 'REQUEST_UNION';
	var REQUEST_UNION_FAILURE = exports.REQUEST_UNION_FAILURE = 'REQUEST_UNION_FAILURE';
	var REQUEST_UNION_SUCCESS = exports.REQUEST_UNION_SUCCESS = 'REQUEST_UNION_SUCCESS';
	
	// Union
	var REQUEST_EMPLOYEE_UNION = exports.REQUEST_EMPLOYEE_UNION = 'REQUEST_EMPLOYEE_UNION';
	var REQUEST_EMPLOYEE_UNION_FAILURE = exports.REQUEST_EMPLOYEE_UNION_FAILURE = 'REQUEST_EMPLOYEE_UNION_FAILURE';
	var REQUEST_EMPLOYEE_UNION_SUCCESS = exports.REQUEST_EMPLOYEE_UNION_SUCCESS = 'REQUEST_EMPLOYEE_UNION_SUCCESS';
	
	// Pension
	var REQUEST_PENSION = exports.REQUEST_PENSION = 'REQUEST_PENSION';
	var REQUEST_PENSION_FAILURE = exports.REQUEST_PENSION_FAILURE = 'REQUEST_PENSION_FAILURE';
	var REQUEST_PENSION_SUCCESS = exports.REQUEST_PENSION_SUCCESS = 'REQUEST_PENSION_SUCCESS';
	
	// ApprovalRequests
	var APPROVAL_REQUEST_CREATE = exports.APPROVAL_REQUEST_CREATE = 'APPROVAL_REQUEST_CREATE';
	var APPROVAL_REQUEST_SUCCESS = exports.APPROVAL_REQUEST_SUCCESS = 'APPROVAL_REQUEST_SUCCESS';
	var APPROVAL_REQUEST_FAILURE = exports.APPROVAL_REQUEST_FAILURE = 'APPROVAL_REQUEST_FAILURE';
	
	// Bonuses
	var REQUEST_BONUSES = exports.REQUEST_BONUSES = 'REQUEST_BONUSES';
	var REQUEST_BONUSES_SUCCESS = exports.REQUEST_BONUSES_SUCCESS = 'REQUEST_BONUSES_SUCCESS';
	var REQUEST_BONUSES_FAILURE = exports.REQUEST_BONUSES_FAILURE = 'REQUEST_BONUSES_FAILURE';
	
	// PerDiem
	var PerDiemAmountTypeEnum = exports.PerDiemAmountTypeEnum = ['Accommodation', // Gisting 1
	'Other', // Annað 2
	'Total'];
	
	var PERDIEM_INIT_APPROVAL_REQUEST = exports.PERDIEM_INIT_APPROVAL_REQUEST = 'PERDIEM_INIT_APPROVAL_REQUEST';
	var PERDIEM_INIT_APPROVAL_SUCCESS = exports.PERDIEM_INIT_APPROVAL_SUCCESS = 'PERDIEM_INIT_APPROVAL_SUCCESS';
	var PERDIEM_INIT_APPROVAL_FAILURE = exports.PERDIEM_INIT_APPROVAL_FAILURE = 'PERDIEM_INIT_APPROVAL_FAILURE';
	
	var PERDIEM_CALCULATE_REQUEST = exports.PERDIEM_CALCULATE_REQUEST = 'PERDIEM_CALCULATE_REQUEST';
	var PERDIEM_CALCULATE_SUCCESS = exports.PERDIEM_CALCULATE_SUCCESS = 'PERDIEM_CALCULATE_SUCCESS';
	var PERDIEM_CALCULATE_FAILURE = exports.PERDIEM_CALCULATE_FAILURE = 'PERDIEM_CALCULATE_FAILURE';
	var PERDIEM_CALCULATE_RESET = exports.PERDIEM_CALCULATE_RESET = 'PERDIEM_CALCULATE_RESET';
	
	var PERDIEM_APPROVAL_REQUEST = exports.PERDIEM_APPROVAL_REQUEST = 'PERDIEM_APPROVAL_REQUEST';
	var PERDIEM_APPROVAL_SUCCESS = exports.PERDIEM_APPROVAL_SUCCESS = 'PERDIEM_APPROVAL_SUCCESS';
	var PERDIEM_APPROVAL_FAILURE = exports.PERDIEM_APPROVAL_FAILURE = 'PERDIEM_APPROVAL_FAILURE';
	
	var PERDIEM_RECORDS_APPEND = exports.PERDIEM_RECORDS_APPEND = 'PERDIEM_RECORDS_APPEND';
	
	var CALCULATE_REQUEST = exports.CALCULATE_REQUEST = 'PERDIEM_CALCULATE_REQUEST';
	var CALCULATE_SUCCESS = exports.CALCULATE_SUCCESS = 'PERDIEM_CALCULATE_SUCCESS';
	var CALCULATE_FAILURE = exports.CALCULATE_FAILURE = 'PERDIEM_CALCULATE_FAILURE';
	var CALCULATE_RESET = exports.CALCULATE_RESET = 'PERDIEM_CALCULATE_RESET';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SHOW_ALERT, 'SHOW_ALERT', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(HIDE_ALERT, 'HIDE_ALERT', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CAREER, 'REQUEST_CAREER', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CAREER_FAILURE, 'REQUEST_CAREER_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CAREER_SUCCESS, 'REQUEST_CAREER_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CERTIFICATE, 'REQUEST_CERTIFICATE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CERTIFICATE_FAILURE, 'REQUEST_CERTIFICATE_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CERTIFICATE_SUCCESS, 'REQUEST_CERTIFICATE_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(HIDE_DIALOG_BOX, 'HIDE_DIALOG_BOX', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SHOW_DIALOG_BOX, 'SHOW_DIALOG_BOX', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDUCATION, 'REQUEST_EDUCATION', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDUCATION_FAILURE, 'REQUEST_EDUCATION_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EDUCATION_SUCCESS, 'REQUEST_EDUCATION_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_LOGIN, 'INITIALIZE_LOGIN', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(LOGIN, 'LOGIN', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(LOGIN_FAILURE, 'LOGIN_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(LOGIN_REQUEST, 'LOGIN_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(LOGIN_STEP, 'LOGIN_STEP', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(LOGIN_SUCCESS, 'LOGIN_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(LOGIN_VALIDATION_ERRORS, 'LOGIN_VALIDATION_ERRORS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(LOGOUT_FAILURE, 'LOGOUT_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(LOGOUT_REQUEST, 'LOGOUT_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(LOGOUT_SUCCESS, 'LOGOUT_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(NOT_AUTHENTICATED, 'NOT_AUTHENTICATED', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(AUTHENTICATED, 'AUTHENTICATED', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SSO_CHECK_START, 'SSO_CHECK_START', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SSO_CHECK_END, 'SSO_CHECK_END', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_SECURITY_CODE, 'SET_SECURITY_CODE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_DETAIL_IDS, 'SET_DETAIL_IDS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_APPRAISAL, 'REQUEST_APPRAISAL', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_APPRAISAL_SUCCESS, 'REQUEST_APPRAISAL_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_APPRAISAL_FAILURE, 'REQUEST_APPRAISAL_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_APPRAISAL_BY_ID, 'REQUEST_APPRAISAL_BY_ID', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_APPRAISAL_BY_ID_SUCCESS, 'REQUEST_APPRAISAL_BY_ID_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_APPRAISAL_BY_ID_FAILURE, 'REQUEST_APPRAISAL_BY_ID_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(RESET_APPRAISAL_LOADING, 'RESET_APPRAISAL_LOADING', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SAVING_APPRAISAL, 'SAVING_APPRAISAL', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SAVING_APPRAISAL_SUCCESS, 'SAVING_APPRAISAL_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SAVING_APPRAISAL_FAILURE, 'SAVING_APPRAISAL_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SUBMIT_APPRAISAL, 'SUBMIT_APPRAISAL', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SUBMIT_APPRAISAL_SUCCESS, 'SUBMIT_APPRAISAL_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SUBMIT_APPRAISAL_FAILURE, 'SUBMIT_APPRAISAL_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_FINAL_ANSWERS, 'SET_FINAL_ANSWERS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_MANAGER_ANSWERS, 'SET_MANAGER_ANSWERS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_EMPLOYEE_ANSWERS, 'SET_EMPLOYEE_ANSWERS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_MANAGER_YEAR, 'SET_MANAGER_YEAR', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_EMPLOYEE_YEAR, 'SET_EMPLOYEE_YEAR', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_APPRAISAL_TAB, 'SET_APPRAISAL_TAB', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_MANAGER_APPRAISAL, 'REQUEST_MANAGER_APPRAISAL', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_MANAGER_APPRAISAL_SUCCESS, 'REQUEST_MANAGER_APPRAISAL_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_MANAGER_APPRAISAL_FAILURE, 'REQUEST_MANAGER_APPRAISAL_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_EMPLOYEE, 'SET_EMPLOYEE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_HOLIDAY, 'REQUEST_HOLIDAY', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_HOLIDAY_SUCCESS, 'REQUEST_HOLIDAY_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_HOLIDAY_FAILURE, 'REQUEST_HOLIDAY_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_HOLIDAY_OVERVIEW, 'REQUEST_HOLIDAY_OVERVIEW', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_HOLIDAY_OVERVIEW_SUCCESS, 'REQUEST_HOLIDAY_OVERVIEW_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_HOLIDAY_OVERVIEW_FAILURE, 'REQUEST_HOLIDAY_OVERVIEW_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_HOLIDAY_INFO, 'SET_HOLIDAY_INFO', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_HOLIDAY_BY_YEAR, 'FETCH_HOLIDAY_BY_YEAR', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_HOLIDAY_BY_YEAR_SUCCESS, 'FETCH_HOLIDAY_BY_YEAR_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_HOLIDAY_BY_YEAR_FAILURE, 'FETCH_HOLIDAY_BY_YEAR_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BANK, 'REQUEST_BANK', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BANK_SUCCESS, 'REQUEST_BANK_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BANK_FAILURE, 'REQUEST_BANK_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_BANK_BRANCHES, 'SET_BANK_BRANCHES', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BANK_BRANCHES, 'REQUEST_BANK_BRANCHES', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_ACCOUNT_STATUS, 'SET_ACCOUNT_STATUS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_NEW_ACCOUNT, 'CREATE_NEW_ACCOUNT', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(CLEAR_NEW_ACCOUNT, 'CLEAR_NEW_ACCOUNT', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BANK_UPDATE, 'REQUEST_BANK_UPDATE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BANK_UPDATE_SUCCESS, 'REQUEST_BANK_UPDATE_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BANK_UPDATE_FAILURE, 'REQUEST_BANK_UPDATE_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EMPLOYEE_MASTER, 'REQUEST_EMPLOYEE_MASTER', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EMPLOYEE_MASTER_FAILURE, 'REQUEST_EMPLOYEE_MASTER_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EMPLOYEE_MASTER_SUCCESS, 'REQUEST_EMPLOYEE_MASTER_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EMPLOYEE_DETAIL_ORG, 'REQUEST_EMPLOYEE_DETAIL_ORG', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EMPLOYEE_DETAIL_ORG_FAILURE, 'REQUEST_EMPLOYEE_DETAIL_ORG_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EMPLOYEE_DETAIL_ORG_SUCCESS, 'REQUEST_EMPLOYEE_DETAIL_ORG_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_REQUEST, 'PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_SUCCESS, 'PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_FAILURE, 'PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_QUALIFICATION, 'REQUEST_QUALIFICATION', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_QUALIFICATION_FAILURE, 'REQUEST_QUALIFICATION_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_QUALIFICATION_SUCCESS, 'REQUEST_QUALIFICATION_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EMPLOYEE_MASTER_COURSES, 'REQUEST_EMPLOYEE_MASTER_COURSES', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EMPLOYEE_MASTER_COURSES_FAILURE, 'REQUEST_EMPLOYEE_MASTER_COURSES_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EMPLOYEE_MASTER_COURSES_SUCCESS, 'REQUEST_EMPLOYEE_MASTER_COURSES_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_COURSES, 'REQUEST_COURSES', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_COURSES_FAILURE, 'REQUEST_COURSES_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_COURSES_SUCCESS, 'REQUEST_COURSES_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_COURSE_ATTENDANCE, 'REQUEST_COURSE_ATTENDANCE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_COURSE_ATTENDANCE_SUCCESS, 'REQUEST_COURSE_ATTENDANCE_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_COURSE_ATTENDANCE_FAILURE, 'REQUEST_COURSE_ATTENDANCE_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_COURSE_LEAVE, 'REQUEST_COURSE_LEAVE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_COURSE_LEAVE_SUCCESS, 'REQUEST_COURSE_LEAVE_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_COURSE_LEAVE_FAILURE, 'REQUEST_COURSE_LEAVE_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_EVAL_LIST_REQUEST, 'COURSE_EVAL_LIST_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_EVAL_LIST_SUCCESS, 'COURSE_EVAL_LIST_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_EVAL_LIST_FAILURE, 'COURSE_EVAL_LIST_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_EVAL_REQUEST, 'COURSE_EVAL_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_EVAL_SUCCESS, 'COURSE_EVAL_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_EVAL_FAILURE, 'COURSE_EVAL_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_EVAL_SAVE_REQUEST, 'COURSE_EVAL_SAVE_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_EVAL_SAVE_SUCCESS, 'COURSE_EVAL_SAVE_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_EVAL_SAVE_FAILURE, 'COURSE_EVAL_SAVE_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_EVAL_SUBMIT_REQUEST, 'COURSE_EVAL_SUBMIT_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_EVAL_SUBMIT_SUCCESS, 'COURSE_EVAL_SUBMIT_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_EVAL_SUBMIT_FAILURE, 'COURSE_EVAL_SUBMIT_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_QUEST_REQUEST, 'COURSE_QUEST_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_QUEST_SUCCESS, 'COURSE_QUEST_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_QUEST_FAILURE, 'COURSE_QUEST_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_QUEST_SUBMIT_REQUEST, 'COURSE_QUEST_SUBMIT_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_QUEST_SUBMIT_SUCCESS, 'COURSE_QUEST_SUBMIT_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(COURSE_QUEST_SUBMIT_FAILURE, 'COURSE_QUEST_SUBMIT_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SEARCH_REQUEST, 'SEARCH_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SEARCH_REQUEST_CLEAR, 'SEARCH_REQUEST_CLEAR', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SEARCH_REQUEST_SUCCESS, 'SEARCH_REQUEST_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SEARCH_REQUEST_FAILURE, 'SEARCH_REQUEST_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SEARCH_REQUEST_SUCCESS_ALL, 'SEARCH_REQUEST_SUCCESS_ALL', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_ENTITY_REQUEST, 'CREATE_ENTITY_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_ENTITY_REQUEST_SUCCESS, 'CREATE_ENTITY_REQUEST_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(CREATE_ENTITY_REQUEST_FAILURE, 'CREATE_ENTITY_REQUEST_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_ENTITY_REQUEST, 'SAVE_ENTITY_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_ENTITY_REQUEST_SUCCESS, 'SAVE_ENTITY_REQUEST_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SAVE_ENTITY_REQUEST_FAILURE, 'SAVE_ENTITY_REQUEST_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_ENTITY_REQUEST, 'DELETE_ENTITY_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_ENTITY_REQUEST_SUCCESS, 'DELETE_ENTITY_REQUEST_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_ENTITY_REQUEST_FAILURE, 'DELETE_ENTITY_REQUEST_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(NEW_PASSWORD_REQUEST, 'NEW_PASSWORD_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(NEW_PASSWORD_SUCCESS, 'NEW_PASSWORD_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(NEW_PASSWORD_FAILURE, 'NEW_PASSWORD_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILES, 'REQUEST_FILES', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILES_SUCCESS, 'REQUEST_FILES_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILES_FAILURE, 'REQUEST_FILES_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PAYSLIPS, 'REQUEST_PAYSLIPS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PAYSLIPS_SUCCESS, 'REQUEST_PAYSLIPS_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PAYSLIPS_FAILURE, 'REQUEST_PAYSLIPS_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILE_DOWNLOAD, 'REQUEST_FILE_DOWNLOAD', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILE_DOWNLOAD_SUCCESS, 'REQUEST_FILE_DOWNLOAD_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILE_DOWNLOAD_FAILURE, 'REQUEST_FILE_DOWNLOAD_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILE_DELETE, 'REQUEST_FILE_DELETE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILE_DELETE_SUCCESS, 'REQUEST_FILE_DELETE_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILE_DELETE_FAILURE, 'REQUEST_FILE_DELETE_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILE_UPLOAD, 'REQUEST_FILE_UPLOAD', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILE_UPLOAD_SUCCESS, 'REQUEST_FILE_UPLOAD_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILE_UPLOAD_FAILURE, 'REQUEST_FILE_UPLOAD_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(INIT_FILE_UPLOAD, 'INIT_FILE_UPLOAD', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(INIT_FILE_UPLOAD_SUCCESS, 'INIT_FILE_UPLOAD_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(INIT_FILE_UPLOAD_FAILURE, 'INIT_FILE_UPLOAD_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILE_BY_ID, 'REQUEST_FILE_BY_ID', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILE_BY_ID_SUCCESS, 'REQUEST_FILE_BY_ID_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_FILE_BY_ID_FAILURE, 'REQUEST_FILE_BY_ID_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(ORGCHART_REQUEST_DATA, 'ORGCHART_REQUEST_DATA', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(ORGCHART_REQUEST_DATA_SUCCESS, 'ORGCHART_REQUEST_DATA_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(ORGCHART_REQUEST_DATA_FAILURE, 'ORGCHART_REQUEST_DATA_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(ORGCHART_SET_ACTIVE_NODE, 'ORGCHART_SET_ACTIVE_NODE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_WEB_VALUES, 'REQUEST_WEB_VALUES', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_WEB_VALUES_SUCCESS, 'REQUEST_WEB_VALUES_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_WEB_VALUES_FAILURE, 'REQUEST_WEB_VALUES_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_LANGUAGE, 'SET_LANGUAGE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_PAY_YEAR, 'SET_PAY_YEAR', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_GROUP_FILTER, 'SET_GROUP_FILTER', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_TAX_CARDS, 'REQUEST_TAX_CARDS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_TAX_CARDS_SUCCESS, 'REQUEST_TAX_CARDS_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_TAX_CARDS_FAILURE, 'REQUEST_TAX_CARDS_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATE_TAX_CARDS, 'REQUEST_CREATE_TAX_CARDS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATE_TAX_CARDS_SUCCESS, 'REQUEST_CREATE_TAX_CARDS_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_CREATE_TAX_CARDS_FAILURE, 'REQUEST_CREATE_TAX_CARDS_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_UPDATE_TAX_CARD, 'REQUEST_UPDATE_TAX_CARD', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_UPDATE_TAX_CARD_SUCCESS, 'REQUEST_UPDATE_TAX_CARD_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_UPDATE_TAX_CARD_FAILURE, 'REQUEST_UPDATE_TAX_CARD_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_TAX_CARD_INFO, 'SET_TAX_CARD_INFO', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_TAX_CARD_STATUS, 'SET_TAX_CARD_STATUS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SET_TAX_DISCOUNT, 'SET_TAX_DISCOUNT', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AGREEMENTS, 'REQUEST_AGREEMENTS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AGREEMENTS_SUCCESS, 'REQUEST_AGREEMENTS_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AGREEMENTS_FAILURE, 'REQUEST_AGREEMENTS_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AGREEMENT_YES, 'REQUEST_AGREEMENT_YES', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_AGREEMENT_NO, 'REQUEST_AGREEMENT_NO', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(UPDATE_AGREEMENT_ANSWERS, 'UPDATE_AGREEMENT_ANSWERS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BIRTHDAYS, 'REQUEST_BIRTHDAYS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BIRTHDAYS_SUCCESS, 'REQUEST_BIRTHDAYS_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BIRTHDAYS_FAILURE, 'REQUEST_BIRTHDAYS_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BENEFITS, 'REQUEST_BENEFITS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BENEFITS_SUCCESS, 'REQUEST_BENEFITS_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BENEFITS_FAILURE, 'REQUEST_BENEFITS_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FITNESS_GRANT_REGISTER_REQUEST, 'FITNESS_GRANT_REGISTER_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FITNESS_GRANT_REGISTER_SUCCESS, 'FITNESS_GRANT_REGISTER_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(FITNESS_GRANT_REGISTER_FAILURE, 'FITNESS_GRANT_REGISTER_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(GRANT_REGISTER_REQUEST, 'GRANT_REGISTER_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(GRANT_REGISTER_SUCCESS, 'GRANT_REGISTER_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(GRANT_REGISTER_FAILURE, 'GRANT_REGISTER_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SEND_EMAIL, 'SEND_EMAIL', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SEND_EMAIL_SUCCESS, 'SEND_EMAIL_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(SEND_EMAIL_FAILURE, 'SEND_EMAIL_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_LOANS, 'REQUEST_LOANS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_LOANS_FAILURE, 'REQUEST_LOANS_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_LOANS_SUCCESS, 'REQUEST_LOANS_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_UNION, 'REQUEST_UNION', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_UNION_FAILURE, 'REQUEST_UNION_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_UNION_SUCCESS, 'REQUEST_UNION_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EMPLOYEE_UNION, 'REQUEST_EMPLOYEE_UNION', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EMPLOYEE_UNION_FAILURE, 'REQUEST_EMPLOYEE_UNION_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_EMPLOYEE_UNION_SUCCESS, 'REQUEST_EMPLOYEE_UNION_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PENSION, 'REQUEST_PENSION', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PENSION_FAILURE, 'REQUEST_PENSION_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_PENSION_SUCCESS, 'REQUEST_PENSION_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(APPROVAL_REQUEST_CREATE, 'APPROVAL_REQUEST_CREATE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(APPROVAL_REQUEST_SUCCESS, 'APPROVAL_REQUEST_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(APPROVAL_REQUEST_FAILURE, 'APPROVAL_REQUEST_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BONUSES, 'REQUEST_BONUSES', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BONUSES_SUCCESS, 'REQUEST_BONUSES_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_BONUSES_FAILURE, 'REQUEST_BONUSES_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PerDiemAmountTypeEnum, 'PerDiemAmountTypeEnum', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PERDIEM_INIT_APPROVAL_REQUEST, 'PERDIEM_INIT_APPROVAL_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PERDIEM_INIT_APPROVAL_SUCCESS, 'PERDIEM_INIT_APPROVAL_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PERDIEM_INIT_APPROVAL_FAILURE, 'PERDIEM_INIT_APPROVAL_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PERDIEM_CALCULATE_REQUEST, 'PERDIEM_CALCULATE_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PERDIEM_CALCULATE_SUCCESS, 'PERDIEM_CALCULATE_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PERDIEM_CALCULATE_FAILURE, 'PERDIEM_CALCULATE_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PERDIEM_CALCULATE_RESET, 'PERDIEM_CALCULATE_RESET', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PERDIEM_APPROVAL_REQUEST, 'PERDIEM_APPROVAL_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PERDIEM_APPROVAL_SUCCESS, 'PERDIEM_APPROVAL_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PERDIEM_APPROVAL_FAILURE, 'PERDIEM_APPROVAL_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(PERDIEM_RECORDS_APPEND, 'PERDIEM_RECORDS_APPEND', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(CALCULATE_REQUEST, 'CALCULATE_REQUEST', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(CALCULATE_SUCCESS, 'CALCULATE_SUCCESS', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(CALCULATE_FAILURE, 'CALCULATE_FAILURE', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	
	  __REACT_HOT_LOADER__.register(CALCULATE_RESET, 'CALCULATE_RESET', 'D:/a/1/s/src/web/employee/src/constants/ActionTypes.js');
	}();

	;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global) {/*!
	 * @overview es6-promise - a tiny implementation of Promises/A+.
	 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
	 * @license   Licensed under MIT license
	 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
	 * @version   v4.2.8+1e68dce6
	 */
	
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.ES6Promise = factory());
	}(this, (function () { 'use strict';
	
	function objectOrFunction(x) {
	  var type = typeof x;
	  return x !== null && (type === 'object' || type === 'function');
	}
	
	function isFunction(x) {
	  return typeof x === 'function';
	}
	
	
	
	var _isArray = void 0;
	if (Array.isArray) {
	  _isArray = Array.isArray;
	} else {
	  _isArray = function (x) {
	    return Object.prototype.toString.call(x) === '[object Array]';
	  };
	}
	
	var isArray = _isArray;
	
	var len = 0;
	var vertxNext = void 0;
	var customSchedulerFn = void 0;
	
	var asap = function asap(callback, arg) {
	  queue[len] = callback;
	  queue[len + 1] = arg;
	  len += 2;
	  if (len === 2) {
	    // If len is 2, that means that we need to schedule an async flush.
	    // If additional callbacks are queued before the queue is flushed, they
	    // will be processed by this flush that we are scheduling.
	    if (customSchedulerFn) {
	      customSchedulerFn(flush);
	    } else {
	      scheduleFlush();
	    }
	  }
	};
	
	function setScheduler(scheduleFn) {
	  customSchedulerFn = scheduleFn;
	}
	
	function setAsap(asapFn) {
	  asap = asapFn;
	}
	
	var browserWindow = typeof window !== 'undefined' ? window : undefined;
	var browserGlobal = browserWindow || {};
	var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
	var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';
	
	// test for web worker but not in IE10
	var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
	
	// node
	function useNextTick() {
	  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
	  // see https://github.com/cujojs/when/issues/410 for details
	  return function () {
	    return process.nextTick(flush);
	  };
	}
	
	// vertx
	function useVertxTimer() {
	  if (typeof vertxNext !== 'undefined') {
	    return function () {
	      vertxNext(flush);
	    };
	  }
	
	  return useSetTimeout();
	}
	
	function useMutationObserver() {
	  var iterations = 0;
	  var observer = new BrowserMutationObserver(flush);
	  var node = document.createTextNode('');
	  observer.observe(node, { characterData: true });
	
	  return function () {
	    node.data = iterations = ++iterations % 2;
	  };
	}
	
	// web worker
	function useMessageChannel() {
	  var channel = new MessageChannel();
	  channel.port1.onmessage = flush;
	  return function () {
	    return channel.port2.postMessage(0);
	  };
	}
	
	function useSetTimeout() {
	  // Store setTimeout reference so es6-promise will be unaffected by
	  // other code modifying setTimeout (like sinon.useFakeTimers())
	  var globalSetTimeout = setTimeout;
	  return function () {
	    return globalSetTimeout(flush, 1);
	  };
	}
	
	var queue = new Array(1000);
	function flush() {
	  for (var i = 0; i < len; i += 2) {
	    var callback = queue[i];
	    var arg = queue[i + 1];
	
	    callback(arg);
	
	    queue[i] = undefined;
	    queue[i + 1] = undefined;
	  }
	
	  len = 0;
	}
	
	function attemptVertx() {
	  try {
	    var vertx = Function('return this')().require('vertx');
	    vertxNext = vertx.runOnLoop || vertx.runOnContext;
	    return useVertxTimer();
	  } catch (e) {
	    return useSetTimeout();
	  }
	}
	
	var scheduleFlush = void 0;
	// Decide what async method to use to triggering processing of queued callbacks:
	if (isNode) {
	  scheduleFlush = useNextTick();
	} else if (BrowserMutationObserver) {
	  scheduleFlush = useMutationObserver();
	} else if (isWorker) {
	  scheduleFlush = useMessageChannel();
	} else if (browserWindow === undefined && "function" === 'function') {
	  scheduleFlush = attemptVertx();
	} else {
	  scheduleFlush = useSetTimeout();
	}
	
	function then(onFulfillment, onRejection) {
	  var parent = this;
	
	  var child = new this.constructor(noop);
	
	  if (child[PROMISE_ID] === undefined) {
	    makePromise(child);
	  }
	
	  var _state = parent._state;
	
	
	  if (_state) {
	    var callback = arguments[_state - 1];
	    asap(function () {
	      return invokeCallback(_state, child, callback, parent._result);
	    });
	  } else {
	    subscribe(parent, child, onFulfillment, onRejection);
	  }
	
	  return child;
	}
	
	/**
	  `Promise.resolve` returns a promise that will become resolved with the
	  passed `value`. It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    resolve(1);
	  });
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.resolve(1);
	
	  promise.then(function(value){
	    // value === 1
	  });
	  ```
	
	  @method resolve
	  @static
	  @param {Any} value value that the returned promise will be resolved with
	  Useful for tooling.
	  @return {Promise} a promise that will become fulfilled with the given
	  `value`
	*/
	function resolve$1(object) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (object && typeof object === 'object' && object.constructor === Constructor) {
	    return object;
	  }
	
	  var promise = new Constructor(noop);
	  resolve(promise, object);
	  return promise;
	}
	
	var PROMISE_ID = Math.random().toString(36).substring(2);
	
	function noop() {}
	
	var PENDING = void 0;
	var FULFILLED = 1;
	var REJECTED = 2;
	
	function selfFulfillment() {
	  return new TypeError("You cannot resolve a promise with itself");
	}
	
	function cannotReturnOwn() {
	  return new TypeError('A promises callback cannot return that same promise.');
	}
	
	function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
	  try {
	    then$$1.call(value, fulfillmentHandler, rejectionHandler);
	  } catch (e) {
	    return e;
	  }
	}
	
	function handleForeignThenable(promise, thenable, then$$1) {
	  asap(function (promise) {
	    var sealed = false;
	    var error = tryThen(then$$1, thenable, function (value) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	      if (thenable !== value) {
	        resolve(promise, value);
	      } else {
	        fulfill(promise, value);
	      }
	    }, function (reason) {
	      if (sealed) {
	        return;
	      }
	      sealed = true;
	
	      reject(promise, reason);
	    }, 'Settle: ' + (promise._label || ' unknown promise'));
	
	    if (!sealed && error) {
	      sealed = true;
	      reject(promise, error);
	    }
	  }, promise);
	}
	
	function handleOwnThenable(promise, thenable) {
	  if (thenable._state === FULFILLED) {
	    fulfill(promise, thenable._result);
	  } else if (thenable._state === REJECTED) {
	    reject(promise, thenable._result);
	  } else {
	    subscribe(thenable, undefined, function (value) {
	      return resolve(promise, value);
	    }, function (reason) {
	      return reject(promise, reason);
	    });
	  }
	}
	
	function handleMaybeThenable(promise, maybeThenable, then$$1) {
	  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
	    handleOwnThenable(promise, maybeThenable);
	  } else {
	    if (then$$1 === undefined) {
	      fulfill(promise, maybeThenable);
	    } else if (isFunction(then$$1)) {
	      handleForeignThenable(promise, maybeThenable, then$$1);
	    } else {
	      fulfill(promise, maybeThenable);
	    }
	  }
	}
	
	function resolve(promise, value) {
	  if (promise === value) {
	    reject(promise, selfFulfillment());
	  } else if (objectOrFunction(value)) {
	    var then$$1 = void 0;
	    try {
	      then$$1 = value.then;
	    } catch (error) {
	      reject(promise, error);
	      return;
	    }
	    handleMaybeThenable(promise, value, then$$1);
	  } else {
	    fulfill(promise, value);
	  }
	}
	
	function publishRejection(promise) {
	  if (promise._onerror) {
	    promise._onerror(promise._result);
	  }
	
	  publish(promise);
	}
	
	function fulfill(promise, value) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	
	  promise._result = value;
	  promise._state = FULFILLED;
	
	  if (promise._subscribers.length !== 0) {
	    asap(publish, promise);
	  }
	}
	
	function reject(promise, reason) {
	  if (promise._state !== PENDING) {
	    return;
	  }
	  promise._state = REJECTED;
	  promise._result = reason;
	
	  asap(publishRejection, promise);
	}
	
	function subscribe(parent, child, onFulfillment, onRejection) {
	  var _subscribers = parent._subscribers;
	  var length = _subscribers.length;
	
	
	  parent._onerror = null;
	
	  _subscribers[length] = child;
	  _subscribers[length + FULFILLED] = onFulfillment;
	  _subscribers[length + REJECTED] = onRejection;
	
	  if (length === 0 && parent._state) {
	    asap(publish, parent);
	  }
	}
	
	function publish(promise) {
	  var subscribers = promise._subscribers;
	  var settled = promise._state;
	
	  if (subscribers.length === 0) {
	    return;
	  }
	
	  var child = void 0,
	      callback = void 0,
	      detail = promise._result;
	
	  for (var i = 0; i < subscribers.length; i += 3) {
	    child = subscribers[i];
	    callback = subscribers[i + settled];
	
	    if (child) {
	      invokeCallback(settled, child, callback, detail);
	    } else {
	      callback(detail);
	    }
	  }
	
	  promise._subscribers.length = 0;
	}
	
	function invokeCallback(settled, promise, callback, detail) {
	  var hasCallback = isFunction(callback),
	      value = void 0,
	      error = void 0,
	      succeeded = true;
	
	  if (hasCallback) {
	    try {
	      value = callback(detail);
	    } catch (e) {
	      succeeded = false;
	      error = e;
	    }
	
	    if (promise === value) {
	      reject(promise, cannotReturnOwn());
	      return;
	    }
	  } else {
	    value = detail;
	  }
	
	  if (promise._state !== PENDING) {
	    // noop
	  } else if (hasCallback && succeeded) {
	    resolve(promise, value);
	  } else if (succeeded === false) {
	    reject(promise, error);
	  } else if (settled === FULFILLED) {
	    fulfill(promise, value);
	  } else if (settled === REJECTED) {
	    reject(promise, value);
	  }
	}
	
	function initializePromise(promise, resolver) {
	  try {
	    resolver(function resolvePromise(value) {
	      resolve(promise, value);
	    }, function rejectPromise(reason) {
	      reject(promise, reason);
	    });
	  } catch (e) {
	    reject(promise, e);
	  }
	}
	
	var id = 0;
	function nextId() {
	  return id++;
	}
	
	function makePromise(promise) {
	  promise[PROMISE_ID] = id++;
	  promise._state = undefined;
	  promise._result = undefined;
	  promise._subscribers = [];
	}
	
	function validationError() {
	  return new Error('Array Methods must be provided an Array');
	}
	
	var Enumerator = function () {
	  function Enumerator(Constructor, input) {
	    this._instanceConstructor = Constructor;
	    this.promise = new Constructor(noop);
	
	    if (!this.promise[PROMISE_ID]) {
	      makePromise(this.promise);
	    }
	
	    if (isArray(input)) {
	      this.length = input.length;
	      this._remaining = input.length;
	
	      this._result = new Array(this.length);
	
	      if (this.length === 0) {
	        fulfill(this.promise, this._result);
	      } else {
	        this.length = this.length || 0;
	        this._enumerate(input);
	        if (this._remaining === 0) {
	          fulfill(this.promise, this._result);
	        }
	      }
	    } else {
	      reject(this.promise, validationError());
	    }
	  }
	
	  Enumerator.prototype._enumerate = function _enumerate(input) {
	    for (var i = 0; this._state === PENDING && i < input.length; i++) {
	      this._eachEntry(input[i], i);
	    }
	  };
	
	  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
	    var c = this._instanceConstructor;
	    var resolve$$1 = c.resolve;
	
	
	    if (resolve$$1 === resolve$1) {
	      var _then = void 0;
	      var error = void 0;
	      var didError = false;
	      try {
	        _then = entry.then;
	      } catch (e) {
	        didError = true;
	        error = e;
	      }
	
	      if (_then === then && entry._state !== PENDING) {
	        this._settledAt(entry._state, i, entry._result);
	      } else if (typeof _then !== 'function') {
	        this._remaining--;
	        this._result[i] = entry;
	      } else if (c === Promise$1) {
	        var promise = new c(noop);
	        if (didError) {
	          reject(promise, error);
	        } else {
	          handleMaybeThenable(promise, entry, _then);
	        }
	        this._willSettleAt(promise, i);
	      } else {
	        this._willSettleAt(new c(function (resolve$$1) {
	          return resolve$$1(entry);
	        }), i);
	      }
	    } else {
	      this._willSettleAt(resolve$$1(entry), i);
	    }
	  };
	
	  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
	    var promise = this.promise;
	
	
	    if (promise._state === PENDING) {
	      this._remaining--;
	
	      if (state === REJECTED) {
	        reject(promise, value);
	      } else {
	        this._result[i] = value;
	      }
	    }
	
	    if (this._remaining === 0) {
	      fulfill(promise, this._result);
	    }
	  };
	
	  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
	    var enumerator = this;
	
	    subscribe(promise, undefined, function (value) {
	      return enumerator._settledAt(FULFILLED, i, value);
	    }, function (reason) {
	      return enumerator._settledAt(REJECTED, i, reason);
	    });
	  };
	
	  return Enumerator;
	}();
	
	/**
	  `Promise.all` accepts an array of promises, and returns a new promise which
	  is fulfilled with an array of fulfillment values for the passed promises, or
	  rejected with the reason of the first passed promise to be rejected. It casts all
	  elements of the passed iterable to promises as it runs this algorithm.
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = resolve(2);
	  let promise3 = resolve(3);
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // The array here would be [ 1, 2, 3 ];
	  });
	  ```
	
	  If any of the `promises` given to `all` are rejected, the first promise
	  that is rejected will be given as an argument to the returned promises's
	  rejection handler. For example:
	
	  Example:
	
	  ```javascript
	  let promise1 = resolve(1);
	  let promise2 = reject(new Error("2"));
	  let promise3 = reject(new Error("3"));
	  let promises = [ promise1, promise2, promise3 ];
	
	  Promise.all(promises).then(function(array){
	    // Code here never runs because there are rejected promises!
	  }, function(error) {
	    // error.message === "2"
	  });
	  ```
	
	  @method all
	  @static
	  @param {Array} entries array of promises
	  @param {String} label optional string for labeling the promise.
	  Useful for tooling.
	  @return {Promise} promise that is fulfilled when all `promises` have been
	  fulfilled, or rejected if any of them become rejected.
	  @static
	*/
	function all(entries) {
	  return new Enumerator(this, entries).promise;
	}
	
	/**
	  `Promise.race` returns a new promise which is settled in the same way as the
	  first passed promise to settle.
	
	  Example:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 2');
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // result === 'promise 2' because it was resolved before promise1
	    // was resolved.
	  });
	  ```
	
	  `Promise.race` is deterministic in that only the state of the first
	  settled promise matters. For example, even if other promises given to the
	  `promises` array argument are resolved, but the first settled promise has
	  become rejected before the other promises became fulfilled, the returned
	  promise will become rejected:
	
	  ```javascript
	  let promise1 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      resolve('promise 1');
	    }, 200);
	  });
	
	  let promise2 = new Promise(function(resolve, reject){
	    setTimeout(function(){
	      reject(new Error('promise 2'));
	    }, 100);
	  });
	
	  Promise.race([promise1, promise2]).then(function(result){
	    // Code here never runs
	  }, function(reason){
	    // reason.message === 'promise 2' because promise 2 became rejected before
	    // promise 1 became fulfilled
	  });
	  ```
	
	  An example real-world use case is implementing timeouts:
	
	  ```javascript
	  Promise.race([ajax('foo.json'), timeout(5000)])
	  ```
	
	  @method race
	  @static
	  @param {Array} promises array of promises to observe
	  Useful for tooling.
	  @return {Promise} a promise which settles in the same way as the first passed
	  promise to settle.
	*/
	function race(entries) {
	  /*jshint validthis:true */
	  var Constructor = this;
	
	  if (!isArray(entries)) {
	    return new Constructor(function (_, reject) {
	      return reject(new TypeError('You must pass an array to race.'));
	    });
	  } else {
	    return new Constructor(function (resolve, reject) {
	      var length = entries.length;
	      for (var i = 0; i < length; i++) {
	        Constructor.resolve(entries[i]).then(resolve, reject);
	      }
	    });
	  }
	}
	
	/**
	  `Promise.reject` returns a promise rejected with the passed `reason`.
	  It is shorthand for the following:
	
	  ```javascript
	  let promise = new Promise(function(resolve, reject){
	    reject(new Error('WHOOPS'));
	  });
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  Instead of writing the above, your code now simply becomes the following:
	
	  ```javascript
	  let promise = Promise.reject(new Error('WHOOPS'));
	
	  promise.then(function(value){
	    // Code here doesn't run because the promise is rejected!
	  }, function(reason){
	    // reason.message === 'WHOOPS'
	  });
	  ```
	
	  @method reject
	  @static
	  @param {Any} reason value that the returned promise will be rejected with.
	  Useful for tooling.
	  @return {Promise} a promise rejected with the given `reason`.
	*/
	function reject$1(reason) {
	  /*jshint validthis:true */
	  var Constructor = this;
	  var promise = new Constructor(noop);
	  reject(promise, reason);
	  return promise;
	}
	
	function needsResolver() {
	  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
	}
	
	function needsNew() {
	  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
	}
	
	/**
	  Promise objects represent the eventual result of an asynchronous operation. The
	  primary way of interacting with a promise is through its `then` method, which
	  registers callbacks to receive either a promise's eventual value or the reason
	  why the promise cannot be fulfilled.
	
	  Terminology
	  -----------
	
	  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
	  - `thenable` is an object or function that defines a `then` method.
	  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
	  - `exception` is a value that is thrown using the throw statement.
	  - `reason` is a value that indicates why a promise was rejected.
	  - `settled` the final resting state of a promise, fulfilled or rejected.
	
	  A promise can be in one of three states: pending, fulfilled, or rejected.
	
	  Promises that are fulfilled have a fulfillment value and are in the fulfilled
	  state.  Promises that are rejected have a rejection reason and are in the
	  rejected state.  A fulfillment value is never a thenable.
	
	  Promises can also be said to *resolve* a value.  If this value is also a
	  promise, then the original promise's settled state will match the value's
	  settled state.  So a promise that *resolves* a promise that rejects will
	  itself reject, and a promise that *resolves* a promise that fulfills will
	  itself fulfill.
	
	
	  Basic Usage:
	  ------------
	
	  ```js
	  let promise = new Promise(function(resolve, reject) {
	    // on success
	    resolve(value);
	
	    // on failure
	    reject(reason);
	  });
	
	  promise.then(function(value) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Advanced Usage:
	  ---------------
	
	  Promises shine when abstracting away asynchronous interactions such as
	  `XMLHttpRequest`s.
	
	  ```js
	  function getJSON(url) {
	    return new Promise(function(resolve, reject){
	      let xhr = new XMLHttpRequest();
	
	      xhr.open('GET', url);
	      xhr.onreadystatechange = handler;
	      xhr.responseType = 'json';
	      xhr.setRequestHeader('Accept', 'application/json');
	      xhr.send();
	
	      function handler() {
	        if (this.readyState === this.DONE) {
	          if (this.status === 200) {
	            resolve(this.response);
	          } else {
	            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
	          }
	        }
	      };
	    });
	  }
	
	  getJSON('/posts.json').then(function(json) {
	    // on fulfillment
	  }, function(reason) {
	    // on rejection
	  });
	  ```
	
	  Unlike callbacks, promises are great composable primitives.
	
	  ```js
	  Promise.all([
	    getJSON('/posts'),
	    getJSON('/comments')
	  ]).then(function(values){
	    values[0] // => postsJSON
	    values[1] // => commentsJSON
	
	    return values;
	  });
	  ```
	
	  @class Promise
	  @param {Function} resolver
	  Useful for tooling.
	  @constructor
	*/
	
	var Promise$1 = function () {
	  function Promise(resolver) {
	    this[PROMISE_ID] = nextId();
	    this._result = this._state = undefined;
	    this._subscribers = [];
	
	    if (noop !== resolver) {
	      typeof resolver !== 'function' && needsResolver();
	      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
	    }
	  }
	
	  /**
	  The primary way of interacting with a promise is through its `then` method,
	  which registers callbacks to receive either a promise's eventual value or the
	  reason why the promise cannot be fulfilled.
	   ```js
	  findUser().then(function(user){
	    // user is available
	  }, function(reason){
	    // user is unavailable, and you are given the reason why
	  });
	  ```
	   Chaining
	  --------
	   The return value of `then` is itself a promise.  This second, 'downstream'
	  promise is resolved with the return value of the first promise's fulfillment
	  or rejection handler, or rejected if the handler throws an exception.
	   ```js
	  findUser().then(function (user) {
	    return user.name;
	  }, function (reason) {
	    return 'default name';
	  }).then(function (userName) {
	    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
	    // will be `'default name'`
	  });
	   findUser().then(function (user) {
	    throw new Error('Found user, but still unhappy');
	  }, function (reason) {
	    throw new Error('`findUser` rejected and we're unhappy');
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
	    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
	  });
	  ```
	  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
	   ```js
	  findUser().then(function (user) {
	    throw new PedagogicalException('Upstream error');
	  }).then(function (value) {
	    // never reached
	  }).then(function (value) {
	    // never reached
	  }, function (reason) {
	    // The `PedgagocialException` is propagated all the way down to here
	  });
	  ```
	   Assimilation
	  ------------
	   Sometimes the value you want to propagate to a downstream promise can only be
	  retrieved asynchronously. This can be achieved by returning a promise in the
	  fulfillment or rejection handler. The downstream promise will then be pending
	  until the returned promise is settled. This is called *assimilation*.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // The user's comments are now available
	  });
	  ```
	   If the assimliated promise rejects, then the downstream promise will also reject.
	   ```js
	  findUser().then(function (user) {
	    return findCommentsByAuthor(user);
	  }).then(function (comments) {
	    // If `findCommentsByAuthor` fulfills, we'll have the value here
	  }, function (reason) {
	    // If `findCommentsByAuthor` rejects, we'll have the reason here
	  });
	  ```
	   Simple Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let result;
	   try {
	    result = findResult();
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	  findResult(function(result, err){
	    if (err) {
	      // failure
	    } else {
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findResult().then(function(result){
	    // success
	  }, function(reason){
	    // failure
	  });
	  ```
	   Advanced Example
	  --------------
	   Synchronous Example
	   ```javascript
	  let author, books;
	   try {
	    author = findAuthor();
	    books  = findBooksByAuthor(author);
	    // success
	  } catch(reason) {
	    // failure
	  }
	  ```
	   Errback Example
	   ```js
	   function foundBooks(books) {
	   }
	   function failure(reason) {
	   }
	   findAuthor(function(author, err){
	    if (err) {
	      failure(err);
	      // failure
	    } else {
	      try {
	        findBoooksByAuthor(author, function(books, err) {
	          if (err) {
	            failure(err);
	          } else {
	            try {
	              foundBooks(books);
	            } catch(reason) {
	              failure(reason);
	            }
	          }
	        });
	      } catch(error) {
	        failure(err);
	      }
	      // success
	    }
	  });
	  ```
	   Promise Example;
	   ```javascript
	  findAuthor().
	    then(findBooksByAuthor).
	    then(function(books){
	      // found books
	  }).catch(function(reason){
	    // something went wrong
	  });
	  ```
	   @method then
	  @param {Function} onFulfilled
	  @param {Function} onRejected
	  Useful for tooling.
	  @return {Promise}
	  */
	
	  /**
	  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
	  as the catch block of a try/catch statement.
	  ```js
	  function findAuthor(){
	  throw new Error('couldn't find that author');
	  }
	  // synchronous
	  try {
	  findAuthor();
	  } catch(reason) {
	  // something went wrong
	  }
	  // async with promises
	  findAuthor().catch(function(reason){
	  // something went wrong
	  });
	  ```
	  @method catch
	  @param {Function} onRejection
	  Useful for tooling.
	  @return {Promise}
	  */
	
	
	  Promise.prototype.catch = function _catch(onRejection) {
	    return this.then(null, onRejection);
	  };
	
	  /**
	    `finally` will be invoked regardless of the promise's fate just as native
	    try/catch/finally behaves
	  
	    Synchronous example:
	  
	    ```js
	    findAuthor() {
	      if (Math.random() > 0.5) {
	        throw new Error();
	      }
	      return new Author();
	    }
	  
	    try {
	      return findAuthor(); // succeed or fail
	    } catch(error) {
	      return findOtherAuther();
	    } finally {
	      // always runs
	      // doesn't affect the return value
	    }
	    ```
	  
	    Asynchronous example:
	  
	    ```js
	    findAuthor().catch(function(reason){
	      return findOtherAuther();
	    }).finally(function(){
	      // author was either found, or not
	    });
	    ```
	  
	    @method finally
	    @param {Function} callback
	    @return {Promise}
	  */
	
	
	  Promise.prototype.finally = function _finally(callback) {
	    var promise = this;
	    var constructor = promise.constructor;
	
	    if (isFunction(callback)) {
	      return promise.then(function (value) {
	        return constructor.resolve(callback()).then(function () {
	          return value;
	        });
	      }, function (reason) {
	        return constructor.resolve(callback()).then(function () {
	          throw reason;
	        });
	      });
	    }
	
	    return promise.then(callback, callback);
	  };
	
	  return Promise;
	}();
	
	Promise$1.prototype.then = then;
	Promise$1.all = all;
	Promise$1.race = race;
	Promise$1.resolve = resolve$1;
	Promise$1.reject = reject$1;
	Promise$1._setScheduler = setScheduler;
	Promise$1._setAsap = setAsap;
	Promise$1._asap = asap;
	
	/*global self*/
	function polyfill() {
	  var local = void 0;
	
	  if (typeof global !== 'undefined') {
	    local = global;
	  } else if (typeof self !== 'undefined') {
	    local = self;
	  } else {
	    try {
	      local = Function('return this')();
	    } catch (e) {
	      throw new Error('polyfill failed because global object is unavailable in this environment');
	    }
	  }
	
	  var P = local.Promise;
	
	  if (P) {
	    var promiseToString = null;
	    try {
	      promiseToString = Object.prototype.toString.call(P.resolve());
	    } catch (e) {
	      // silently ignored
	    }
	
	    if (promiseToString === '[object Promise]' && !P.cast) {
	      return;
	    }
	  }
	
	  local.Promise = Promise$1;
	}
	
	// Strange compat..
	Promise$1.polyfill = polyfill;
	Promise$1.Promise = Promise$1;
	
	return Promise$1;
	
	})));
	
	
	
	//# sourceMappingURL=es6-promise.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138), (function() { return this; }())))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _config = __webpack_require__(54);
	
	var pallet = _extends({
	  mainButton: '#3B53A7',
	  primary1Color: '#3B53A7',
	  titleColor: '#1D1C1E',
	  subtitleColor: '#A39FA8',
	  dividerColor: '#F6F6F6',
	  loginColor: '#3B53A7',
	  appBarColor: 'white',
	  appBarTextColor: '#1D1C1E',
	  appBarTextColorHint: '#A39FA8',
	  errorColor: '#E06255',
	  warningColor: '#ECC651',
	  infoColor: '#859DEE',
	  successColor: '#4D8F5F',
	  grey: '#A39FA8'
	}, _config.theme);
	
	var _default = pallet;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(pallet, 'pallet', 'D:/a/1/s/src/web/employee/src/constants/colors.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/constants/colors.js');
	}();

	;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.listWM = exports.readWM = exports.remove = exports.save = exports.create = exports.list = exports.read = exports.base = exports.refresh = exports.injectQDataInterceptor = exports.core = exports.custom = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint global-require: 0 */
	
	
	var _axios = __webpack_require__(179);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(54);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var TOKEN_EXPIRES_PATH_LOCAL_STORAGE = 'expires';
	var TOKEN_PATH_LOCAL_STORAGE = 'token';
	var REFRESH_TOKEN_PATH_LOCAL_STORAGE = 'refreshToken';
	
	var expandWM = function expandWM(data) {
	  if (!data) {
	    return data;
	  } else if (data.Message) {
	    return { Message: data.Message };
	  } else if (data) {
	    return _extends({}, data.Entity, data);
	  }
	  return data;
	};
	var expandWMList = function expandWMList(list) {
	  if (!list) {
	    return [];
	  } else if (list.Message) {
	    return { Message: list.Message };
	  } else if (list) {
	    return list.map(expandWM);
	  }
	  return list;
	};
	var customTransformResponse = function customTransformResponse(func) {
	  return [].concat(_axios2.default.defaults.transformResponse, func);
	};
	
	/* Create custom instance of axios with baseURL from config */
	var custom = exports.custom = _axios2.default.create({
	  baseURL: _config.apiUrl
	});
	
	var core = exports.core = _axios2.default.create({
	  baseURL: _config.apiUrl
	});
	
	var injectQDataInterceptor = exports.injectQDataInterceptor = function injectQDataInterceptor(interceptor) {
	  if (interceptor) {
	    custom.interceptors.request.use(interceptor);
	  }
	};
	
	var refresh = exports.refresh = function refresh(refreshToken) {
	  return core({
	    url: '/Token',
	    method: 'POST',
	    headers: {
	      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
	    },
	    data: 'grant_type=refresh_token&refresh_token=' + refreshToken
	  });
	};
	
	if (!_config.useSSO) {
	  custom.interceptors.request.use(function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
	      var accessTokenExpires, accessToken, refreshToken, refreshResponse, newAccessToken, newAccessTokenExpires, newRefreshToken, authorization, _authorization;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              (0, _lodash.set)(config, 'headers.Content-Type', 'application/json');
	              (0, _lodash.set)(config, 'headers.Accept', 'application/json');
	              accessTokenExpires = parseInt(localStorage.getItem(TOKEN_EXPIRES_PATH_LOCAL_STORAGE), 10);
	              accessToken = localStorage.getItem(TOKEN_PATH_LOCAL_STORAGE);
	              refreshToken = localStorage.getItem(REFRESH_TOKEN_PATH_LOCAL_STORAGE);
	              _context.prev = 5;
	
	              if (!(!accessTokenExpires || !(0, _moment2.default)(accessTokenExpires).isValid() || (0, _moment2.default)(accessTokenExpires).isBefore((0, _moment2.default)().add(5, 'm')))) {
	                _context.next = 20;
	                break;
	              }
	
	              _context.next = 9;
	              return refresh(refreshToken);
	
	            case 9:
	              refreshResponse = _context.sent;
	              newAccessToken = (0, _lodash.get)(refreshResponse, ['data', 'access_token'], '');
	              newAccessTokenExpires = Date.now() + (0, _lodash.get)(refreshResponse, ['data', 'expires_in'], 0);
	              newRefreshToken = (0, _lodash.get)(refreshResponse, ['data', 'refresh_token'], '');
	
	              localStorage.setItem(TOKEN_EXPIRES_PATH_LOCAL_STORAGE, newAccessTokenExpires);
	              localStorage.setItem(TOKEN_PATH_LOCAL_STORAGE, newAccessToken);
	              localStorage.setItem(REFRESH_TOKEN_PATH_LOCAL_STORAGE, newRefreshToken);
	
	              authorization = newAccessToken ? 'Bearer ' + newAccessToken : undefined;
	
	              (0, _lodash.set)(config, 'headers.Authorization', authorization);
	              _context.next = 22;
	              break;
	
	            case 20:
	              _authorization = accessToken ? 'Bearer ' + accessToken : undefined;
	
	              (0, _lodash.set)(config, 'headers.Authorization', _authorization);
	
	            case 22:
	              _context.next = 27;
	              break;
	
	            case 24:
	              _context.prev = 24;
	              _context.t0 = _context['catch'](5);
	
	              window.location.replace('/account?logout=true');
	
	            case 27:
	              return _context.abrupt('return', config);
	
	            case 28:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[5, 24]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }());
	}
	
	var base = function base(_ref2) {
	  var entity = _ref2.entity,
	      action = _ref2.action,
	      args = _objectWithoutProperties(_ref2, ['entity', 'action']);
	
	  return custom(_extends({
	    url: '/api/QDataEntity/' + action + '/' + entity,
	    method: 'POST'
	  }, args));
	};
	
	exports.base = base;
	var read = function read(_ref3) {
	  var entityID = _ref3.entityID,
	      args = _objectWithoutProperties(_ref3, ['entityID']);
	
	  return base(_extends({
	    action: 'Read',
	    data: JSON.stringify(entityID)
	  }, args));
	};
	
	exports.read = read;
	var list = function list(_ref4) {
	  var args = _objectWithoutProperties(_ref4, []);
	
	  return base(_extends({
	    action: 'List'
	  }, args));
	};
	
	exports.list = list;
	var create = function create(_ref5) {
	  var args = _objectWithoutProperties(_ref5, []);
	
	  return base(_extends({
	    action: 'Create'
	  }, args));
	};
	
	exports.create = create;
	var save = function save(_ref6) {
	  var args = _objectWithoutProperties(_ref6, []);
	
	  return base(_extends({
	    action: 'Save'
	  }, args));
	};
	
	exports.save = save;
	var remove = function remove(_ref7) {
	  var args = _objectWithoutProperties(_ref7, []);
	
	  return base(_extends({
	    action: 'Delete'
	  }, args));
	};
	
	exports.remove = remove;
	var readWM = function readWM(_ref8) {
	  var entity = _ref8.entity,
	      entityID = _ref8.entityID,
	      args = _objectWithoutProperties(_ref8, ['entity', 'entityID']);
	
	  return custom(_extends({
	    url: '/api/QDataWebModel/' + entity + '/' + entityID,
	    transformResponse: customTransformResponse(expandWM)
	  }, args));
	};
	
	exports.readWM = readWM;
	var listWM = function listWM(_ref9) {
	  var entity = _ref9.entity,
	      args = _objectWithoutProperties(_ref9, ['entity']);
	
	  return custom(_extends({
	    url: '/api/QDataWebModel/' + entity,
	    transformResponse: customTransformResponse(expandWMList)
	  }, args));
	};
	exports.listWM = listWM;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TOKEN_EXPIRES_PATH_LOCAL_STORAGE, 'TOKEN_EXPIRES_PATH_LOCAL_STORAGE', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(TOKEN_PATH_LOCAL_STORAGE, 'TOKEN_PATH_LOCAL_STORAGE', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(REFRESH_TOKEN_PATH_LOCAL_STORAGE, 'REFRESH_TOKEN_PATH_LOCAL_STORAGE', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(expandWM, 'expandWM', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(expandWMList, 'expandWMList', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(customTransformResponse, 'customTransformResponse', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(custom, 'custom', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(core, 'core', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(injectQDataInterceptor, 'injectQDataInterceptor', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(refresh, 'refresh', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(base, 'base', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(read, 'read', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(list, 'list', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(create, 'create', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(save, 'save', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(remove, 'remove', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(readWM, 'readWM', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	
	  __REACT_HOT_LOADER__.register(listWM, 'listWM', 'D:/a/1/s/src/web/employee/src/utils/Api.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 22 */
[1855, 28],
/* 23 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _FontIcon = __webpack_require__(83);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _RaisedButton = __webpack_require__(114);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    marginTop: 16,
	    marginBottom: 16
	  },
	  icon: {
	    marginRight: 8
	  },
	  panel: {
	    padding: 16,
	    display: 'flex',
	    flexDirection: 'row',
	    justifyContent: 'space-between'
	  },
	  panelText: {
	    display: 'flex',
	    flex: 1,
	    alignItems: 'center'
	  },
	  message: {
	    whiteSpace: 'normal',
	    wordBreak: 'break-word'
	  },
	  info: {
	    borderLeft: 'solid 4px ' + _colors2.default.infoColor
	  },
	  success: {
	    borderLeft: 'solid 4px ' + _colors2.default.successColor
	  },
	  warning: {
	    borderLeft: 'solid 4px ' + _colors2.default.warningColor
	  },
	  error: {
	    borderLeft: 'solid 4px ' + _colors2.default.errorColor
	  },
	  actionStyle: {
	    alignSelf: 'flex-end'
	  }
	};
	
	var color = {
	  info: _colors2.default.infoColor,
	  success: _colors2.default.successColor,
	  warning: _colors2.default.warningColor,
	  error: _colors2.default.errorColor,
	  default: '#555'
	};
	
	var PanelMessage = function PanelMessage(_ref) {
	  var message = _ref.message,
	      iconName = _ref.iconName,
	      iconClassName = _ref.iconClassName,
	      type = _ref.type,
	      action = _ref.action,
	      actionLabel = _ref.actionLabel,
	      zDepth = _ref.zDepth;
	  return _react2.default.createElement(
	    _reactFlexboxGrid.Col,
	    { xs: true, style: styles.root },
	    _react2.default.createElement(
	      _Paper2.default,
	      { zDepth: zDepth, style: _extends({}, styles.panel, styles[type]) },
	      _react2.default.createElement(
	        'div',
	        { style: styles.panelText },
	        _react2.default.createElement(
	          _FontIcon2.default,
	          { style: styles.icon, color: color[type], className: iconClassName },
	          iconName
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: styles.message },
	          message
	        )
	      ),
	      action && actionLabel && _react2.default.createElement(_RaisedButton2.default, {
	        style: styles.actionStyle,
	        backgroundColor: color[type],
	        labelColor: '#fff',
	        onClick: action,
	        label: actionLabel
	      })
	    )
	  );
	};
	
	PanelMessage.propTypes = {
	  /*
	    The message to be displayed inside the component
	  */
	  message: _propTypes2.default.node,
	
	  /*
	    Then name of the icon placed inside the icon component
	  */
	  iconName: _propTypes2.default.string,
	
	  /*
	    The class name of the icon component
	  */
	  iconClassName: _propTypes2.default.string,
	
	  /*
	    The style type of the component
	  */
	  type: _propTypes2.default.oneOf(['success', 'warning', 'error', 'info', 'default']),
	  /*
	    The function to trigger on the action click
	  */
	  action: _propTypes2.default.func,
	  /*
	    The label for the action button
	  */
	  actionLabel: _propTypes2.default.node,
	  /*
	    The shadow depth of the paper component
	  */
	  zDepth: _propTypes2.default.number
	};
	
	PanelMessage.defaultProps = {
	  type: 'default',
	  iconClassName: 'material-icons',
	  zDepth: 0
	};
	
	var _default = PanelMessage;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/panels/PanelMessage.js');
	
	  __REACT_HOT_LOADER__.register(color, 'color', 'D:/a/1/s/src/web/employee/src/components/panels/PanelMessage.js');
	
	  __REACT_HOT_LOADER__.register(PanelMessage, 'PanelMessage', 'D:/a/1/s/src/web/employee/src/components/panels/PanelMessage.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/panels/PanelMessage.js');
	}();

	;

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _splice = _interopRequireDefault(__webpack_require__(1816));
	
	var _getIn = _interopRequireDefault(__webpack_require__(1813));
	
	var _setIn = _interopRequireDefault(__webpack_require__(1815));
	
	var _deepEqual = _interopRequireDefault(__webpack_require__(1811));
	
	var _deleteIn = _interopRequireDefault(__webpack_require__(1812));
	
	var _keys = _interopRequireDefault(__webpack_require__(1814));
	
	var structure = {
	  allowsArrayErrors: true,
	  empty: {},
	  emptyList: [],
	  getIn: _getIn["default"],
	  setIn: _setIn["default"],
	  deepEqual: _deepEqual["default"],
	  deleteIn: _deleteIn["default"],
	  forEach: function forEach(items, callback) {
	    return items.forEach(callback);
	  },
	  fromJS: function fromJS(value) {
	    return value;
	  },
	  keys: _keys["default"],
	  size: function size(array) {
	    return array ? array.length : 0;
	  },
	  some: function some(items, callback) {
	    return items.some(callback);
	  },
	  splice: _splice["default"],
	  equals: function equals(a, b) {
	    return b.every(function (val) {
	      return ~a.indexOf(val);
	    });
	  },
	  orderChanged: function orderChanged(a, b) {
	    return b.some(function (val, index) {
	      return val !== a[index];
	    });
	  },
	  toJS: function toJS(value) {
	    return value;
	  }
	};
	var _default = structure;
	exports["default"] = _default;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  container: {},
	  subtitle: {
	    marginLeft: 12,
	    lineHeight: 2
	  }
	};
	
	var KTitle = function KTitle(_ref) {
	  var title = _ref.title,
	      style = _ref.style,
	      containerStyle = _ref.containerStyle,
	      subtitle = _ref.subtitle,
	      subtitleStyle = _ref.subtitleStyle,
	      dataCy = _ref.dataCy;
	  return _react2.default.createElement(
	    'div',
	    { style: _extends({}, styles.container, containerStyle), 'data-cy': dataCy },
	    _react2.default.createElement(
	      'h2',
	      { style: _extends({ color: _colors2.default.titleColor }, style) },
	      title
	    ),
	    subtitle && _react2.default.createElement(
	      'span',
	      { style: _extends({}, styles.subtitle, subtitleStyle) },
	      subtitle
	    )
	  );
	};
	
	KTitle.propTypes = {
	  title: _propTypes2.default.node.isRequired,
	  subtitle: _propTypes2.default.node,
	  style: _propTypes2.default.object,
	  containerStyle: _propTypes2.default.object,
	  subtitleStyle: _propTypes2.default.object,
	  dataCy: _propTypes2.default.string
	};
	
	var _default = KTitle;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/KJRN/KTitle.js');
	
	  __REACT_HOT_LOADER__.register(KTitle, 'KTitle', 'D:/a/1/s/src/web/employee/src/components/KJRN/KTitle.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KTitle.js');
	}();

	;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(1646);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ }),
/* 31 */
[1897, 196, 131, 25],
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CircularProgress = __webpack_require__(170);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _reactIntl = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  container: {
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  text: {
	    padding: 24,
	    fontSize: 24,
	    fontWeight: 300
	  }
	};
	
	// eslint-disable-next-line react/prop-types
	var Loading = function Loading(_ref) {
	  var _ref$height = _ref.height,
	      height = _ref$height === undefined ? '100vh' : _ref$height;
	  return _react2.default.createElement(
	    'div',
	    { style: _extends({}, styles.container, { height: height }) },
	    _react2.default.createElement(_CircularProgress2.default, {
	      size: 120,
	      style: { lineHeight: '90px' },
	      mode: 'indeterminate',
	      thickness: 4
	    }),
	    _react2.default.createElement(
	      'span',
	      { style: styles.text },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loading.message' })
	    )
	  );
	};
	
	var _default = Loading;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/Loading.js');
	
	  __REACT_HOT_LOADER__.register(Loading, 'Loading', 'D:/a/1/s/src/web/employee/src/components/Loading.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/Loading.js');
	}();

	;

/***/ }),
/* 34 */
[1892, 79],
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fromNowLocale = exports.compare = exports.isPassed = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.default = convert;
	exports.dateTime = dateTime;
	exports.convertToDate = convertToDate;
	exports.convertTime = convertTime;
	exports.duration = duration;
	exports.fromNow = fromNow;
	exports.fromNowExact = fromNowExact;
	exports.now = now;
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function convert(dateString) {
	  _moment2.default.locale('is');
	  return dateString ? (0, _moment2.default)(dateString).format('DD. MM. YYYY') : '';
	}
	
	function dateTime(dateString) {
	  _moment2.default.locale('is');
	  return dateString ? (0, _moment2.default)(dateString).format('D.M.YYYY HH:mm') : '';
	}
	
	function convertToDate(dateString) {
	  _moment2.default.locale('en');
	  return dateString ? (0, _moment2.default)(dateString).toDate() : '';
	}
	
	function convertTime(dateString) {
	  _moment2.default.locale('is');
	  return dateString ? (0, _moment2.default)(dateString).format('HH:mm') : '';
	}
	
	function duration(hours) {
	  var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : localStorage.language || 'is';
	
	  if (lang === 'en') {
	    _moment2.default.updateLocale('en', { relativeTime: { h: '1 hour', hh: '%d hours' } });
	    _moment2.default.locale('en');
	  } else {
	    _moment2.default.updateLocale('is', { relativeTime: { h: '1 klukkustund' } });
	    _moment2.default.locale('is');
	  }
	  _moment2.default.relativeTimeThreshold('h', 2000);
	  return hours > 0 ? _moment2.default.duration(hours, 'hours').humanize() : '';
	}
	
	function fromNow(date) {
	  _moment2.default.locale('is');
	  return (0, _moment2.default)(date).fromNow(true);
	}
	
	function fromNowExact(date) {
	  _moment2.default.locale('is');
	  var n = (0, _moment2.default)();
	  var t = (0, _moment2.default)(date);
	  var exact = '';
	  var years = n.diff(t, 'years');
	  if (years) {
	    exact = years + ' \xE1r ';
	  }
	  var months = n.subtract(years, 'years').diff(t, 'months');
	  if (months) {
	    exact += months + ' m\xE1nu\xF0' + (months === 1 ? 'ur' : 'ir') + ' ';
	  }
	  var days = n.subtract(months, 'months').diff(t, 'days');
	  if (days) {
	    exact += days + ' dag' + (days === 1 || days === 21 || days === 31 ? 'ur' : 'ar') + ' ';
	  }
	  return exact;
	}
	
	function now(f) {
	  return (0, _moment2.default)().format(f);
	}
	
	var isPassed = exports.isPassed = function isPassed(a) {
	  return new Date(a).getTime() < Date.now();
	};
	var compare = exports.compare = function compare(a, b) {
	  return new Date(a).getTime() > new Date(b).getTime();
	};
	
	var fromNowLocale = exports.fromNowLocale = function fromNowLocale(lang, yearMonthDays) {
	  var _yearMonthDays$split = yearMonthDays.split(' - '),
	      _yearMonthDays$split2 = _slicedToArray(_yearMonthDays$split, 2),
	      years = _yearMonthDays$split2[0],
	      months = _yearMonthDays$split2[1];
	  // translations
	
	
	  var tYear = lang === 'is' ? 'ár' : 'year';
	  var tYears = lang === 'is' ? 'ár' : 'years';
	  var tMonth = lang === 'is' ? 'mánuður' : 'month';
	  var tMonths = lang === 'is' ? 'mánuðir' : 'months';
	  var tAnd = lang === 'is' ? ' og ' : ' and ';
	  // string logic
	  var yearsText = years ? years + ' ' + (years > 1 ? tYears : tYear) : '';
	  var and = years && months ? tAnd : '';
	  var monthsText = months ? months + ' ' + (months > 1 ? tMonths : tMonth) : '';
	  return '' + yearsText + and + monthsText;
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(convert, 'convert', 'D:/a/1/s/src/web/employee/src/utils/dateTools.js');
	
	  __REACT_HOT_LOADER__.register(dateTime, 'dateTime', 'D:/a/1/s/src/web/employee/src/utils/dateTools.js');
	
	  __REACT_HOT_LOADER__.register(convertToDate, 'convertToDate', 'D:/a/1/s/src/web/employee/src/utils/dateTools.js');
	
	  __REACT_HOT_LOADER__.register(convertTime, 'convertTime', 'D:/a/1/s/src/web/employee/src/utils/dateTools.js');
	
	  __REACT_HOT_LOADER__.register(duration, 'duration', 'D:/a/1/s/src/web/employee/src/utils/dateTools.js');
	
	  __REACT_HOT_LOADER__.register(fromNow, 'fromNow', 'D:/a/1/s/src/web/employee/src/utils/dateTools.js');
	
	  __REACT_HOT_LOADER__.register(fromNowExact, 'fromNowExact', 'D:/a/1/s/src/web/employee/src/utils/dateTools.js');
	
	  __REACT_HOT_LOADER__.register(now, 'now', 'D:/a/1/s/src/web/employee/src/utils/dateTools.js');
	
	  __REACT_HOT_LOADER__.register(isPassed, 'isPassed', 'D:/a/1/s/src/web/employee/src/utils/dateTools.js');
	
	  __REACT_HOT_LOADER__.register(compare, 'compare', 'D:/a/1/s/src/web/employee/src/utils/dateTools.js');
	
	  __REACT_HOT_LOADER__.register(fromNowLocale, 'fromNowLocale', 'D:/a/1/s/src/web/employee/src/utils/dateTools.js');
	}();

	;

/***/ }),
/* 36 */
[1860, 27],
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Paper = __webpack_require__(1559);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper2.default;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getColumnProps = exports.Col = exports.getRowProps = exports.Row = exports.Grid = undefined;
	
	var _Row2 = __webpack_require__(1651);
	
	Object.defineProperty(exports, 'getRowProps', {
	  enumerable: true,
	  get: function get() {
	    return _Row2.getRowProps;
	  }
	});
	
	var _Col2 = __webpack_require__(1649);
	
	Object.defineProperty(exports, 'getColumnProps', {
	  enumerable: true,
	  get: function get() {
	    return _Col2.getColumnProps;
	  }
	});
	
	var _Grid2 = __webpack_require__(1650);
	
	var _Grid3 = _interopRequireDefault(_Grid2);
	
	var _Row3 = _interopRequireDefault(_Row2);
	
	var _Col3 = _interopRequireDefault(_Col2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Grid = _Grid3.default;
	exports.Row = _Row3.default;
	exports.Col = _Col3.default;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 42 */
[1876, 22, 486, 89, 36],
/* 43 */
[1893, 87],
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.removeNotifications = exports.removeNotification = exports.updateNotification = exports.notify = exports.addNotification = exports.reducer = exports.types = exports.actions = exports.POSITIONS = exports.STATUS = exports.DEFAULT_NOTIFICATION = undefined;
	
	var _NotificationsSystem = __webpack_require__(1724);
	
	var _NotificationsSystem2 = _interopRequireDefault(_NotificationsSystem);
	
	var _constants = __webpack_require__(215);
	
	var _notifications = __webpack_require__(781);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DEFAULT_NOTIFICATION = _constants.DEFAULT_NOTIFICATION;
	exports.STATUS = _constants.STATUS;
	exports.POSITIONS = _constants.POSITIONS;
	exports.actions = _notifications.actions;
	exports.types = _notifications.types;
	exports.reducer = _notifications2.default;
	exports.addNotification = _notifications.addNotification;
	exports.notify = _notifications.notify;
	exports.updateNotification = _notifications.updateNotification;
	exports.removeNotification = _notifications.removeNotification;
	exports.removeNotifications = _notifications.removeNotifications;
	// NotificationsSystem React component
	
	exports.default = _NotificationsSystem2.default;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SvgIcon = __webpack_require__(1577);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SvgIcon2.default;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(163),
	    baseIteratee = __webpack_require__(112),
	    baseMap = __webpack_require__(541),
	    isArray = __webpack_require__(41);
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	module.exports = map;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(1732);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(140);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _setDisplayName = __webpack_require__(783);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(784);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = function pure(BaseComponent) {
	  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return !(0, _shallowEqual2.default)(props, nextProps);
	  });
	
	  if (false) {
	    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	exports.default = pure;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(279)["default"];
	
	function _getRequireWildcardCache(nodeInterop) {
	  if (typeof WeakMap !== "function") return null;
	  var cacheBabelInterop = new WeakMap();
	  var cacheNodeInterop = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
	    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	  })(nodeInterop);
	}
	
	function _interopRequireWildcard(obj, nodeInterop) {
	  if (!nodeInterop && obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache(nodeInterop);
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  loadingContainer: {
	    padding: 12,
	    width: 'calc(100% - 24px)',
	    height: 'calc(100% - 24px)',
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  progress: {
	    width: '70%'
	  },
	  text: {
	    fontSize: 24,
	    marginBottom: 12
	  }
	};
	
	var TLoading = function TLoading() {
	  return _react2.default.createElement(
	    'div',
	    { style: styles.loadingContainer },
	    _react2.default.createElement(
	      'span',
	      { style: styles.text },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.loading' })
	    ),
	    _react2.default.createElement(_materialUi.LinearProgress, { style: styles.progress, mode: 'indeterminate' })
	  );
	};
	
	var _default = TLoading;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/tiles/TLoading.js');
	
	  __REACT_HOT_LOADER__.register(TLoading, 'TLoading', 'D:/a/1/s/src/web/employee/src/containers/tiles/TLoading.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TLoading.js');
	}();

	;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _reactIntl = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  loadingContainer: {
	    padding: '24px 18px',
	    width: 'calc(100% - 36px)',
	    height: 'calc(100% - 48px)',
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    justifyContent: 'center',
	    textAlign: 'center'
	  },
	  textError: {
	    borderBottom: '4px solid ' + _colors2.default.errorColor,
	    padding: 8,
	    fontSize: 20,
	    marginBottom: 12
	  },
	  text: {
	    borderBottom: '4px solid ' + _colors2.default.primary1Color,
	    padding: 8,
	    fontSize: 20,
	    marginBottom: 12
	  },
	  textWarning: {
	    borderBottom: '4px solid ' + _colors2.default.warningColor,
	    padding: 8,
	    fontSize: 20,
	    marginBottom: 12
	  },
	  textSuccess: {
	    borderBottom: '4px solid ' + _colors2.default.successColor,
	    padding: 8,
	    fontSize: 20,
	    marginBottom: 12
	  }
	};
	
	var TMessage = function TMessage(_ref) {
	  var type = _ref.type,
	      message = _ref.message,
	      children = _ref.children,
	      style = _ref.style,
	      values = _ref.values;
	
	  var content = _react2.default.createElement(
	    'span',
	    { style: styles.text },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: message, values: values })
	  );
	
	  if (type === 'error') {
	    content = _react2.default.createElement(
	      'span',
	      { style: styles.textError },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: message, values: values })
	    );
	  }
	
	  if (type === 'warning') {
	    content = _react2.default.createElement(
	      'span',
	      { style: styles.textWarning },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: message, values: values })
	    );
	  }
	
	  if (type === 'success') {
	    content = _react2.default.createElement(
	      'span',
	      { style: styles.textSuccess },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: message, values: values })
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: _extends({}, styles.loadingContainer, style) },
	    content,
	    children
	  );
	};
	
	TMessage.propTypes = {
	  message: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.node,
	  style: _propTypes2.default.object,
	  type: _propTypes2.default.oneOf(['error', 'warning', 'success']),
	  values: _propTypes2.default.object
	};
	
	TMessage.defaultProps = {
	  style: {},
	  values: {}
	};
	
	var _default = TMessage;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/tiles/TMessage.js');
	
	  __REACT_HOT_LOADER__.register(TMessage, 'TMessage', 'D:/a/1/s/src/web/employee/src/containers/tiles/TMessage.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TMessage.js');
	}();

	;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(410);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _KButton = __webpack_require__(146);
	
	var _KButton2 = _interopRequireDefault(_KButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  button: {
	    textDecoration: 'none',
	    fontWeight: 600,
	    color: _colors2.default.primary1Color,
	    maxWidth: 150,
	    textTransform: 'uppercase',
	    backgroundColor: 'transparent'
	  }
	};
	
	var KFlatButton = function KFlatButton(props) {
	  return _react2.default.createElement(_KButton2.default, _extends({ flat: true }, props, { buttonStyle: _extends({}, styles.button, props.style) }));
	};
	
	KFlatButton.propTypes = { style: _propTypes2.default.object };
	
	var _default = KFlatButton;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/KJRN/KFlatButton.js');
	
	  __REACT_HOT_LOADER__.register(KFlatButton, 'KFlatButton', 'D:/a/1/s/src/web/employee/src/components/KJRN/KFlatButton.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KFlatButton.js');
	}();

	;

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useMobileLogin = exports.recaptchaKey = exports.siteName = exports.applicationInsightsInstrumentationKey = exports.msalScope = exports.msalApplicationID = exports.msalTenantID = exports.reverseListItemLabels = exports.hiddenFeatures = exports.destination = exports.server = exports.tags = exports.hideXapLogin = exports.useSSO = exports.theme = exports.logoWidth = exports.logo = exports.customer = exports.supportEmail = exports.apiUrl = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _customerConfig = __webpack_require__(897);
	
	var config = _interopRequireWildcard(_customerConfig);
	
	var _colorManipulator = __webpack_require__(90);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var getTheme = function getTheme() {
	  var customerTheme = {};
	  try {
	    customerTheme = JSON.parse(config.theme);
	  } catch (ex) {
	    console.log('error parsing theme: ' + ex);
	  }
	  var primaryColor = '#3B53A7';
	  return _extends({}, customerTheme, {
	    mainButton: customerTheme.mainButton || primaryColor,
	    primary1Color: customerTheme.primary1Color || primaryColor,
	    primary2Color: (0, _colorManipulator.lighten)(customerTheme.primary2Color || primaryColor, 0.15),
	    primary3Color: (0, _colorManipulator.lighten)(customerTheme.primary3Color || primaryColor, 0.6),
	    loginColor: customerTheme.loginColor || primaryColor
	  });
	};
	
	var getHiddenFeatures = function getHiddenFeatures() {
	  var customerFeatures = {};
	  try {
	    customerFeatures = JSON.parse(config.hiddenFeatures);
	  } catch (ex) {
	    console.log('error parsing hidden features: ' + ex);
	  }
	
	  return {
	    appraisals: customerFeatures.appraisals === 'true'
	  };
	};
	
	/* eslint import/prefer-default-export: 0 */
	var settings = {
	  apiUrl: config.apiUrl,
	  supportEmail: config.supportEmail || 'applicon@applicon.is',
	  customer: config.customer,
	  /* eslint global-require: 0 */
	  logo: __webpack_require__(1844), // eslint-disable-line import/no-dynamic-require
	  logoWidth: config.logoWidth || 193,
	  theme: getTheme(),
	  useSSO: config.useSSO === 'true',
	  useMobileLogin: config.useMobileLogin === 'true',
	  hideXapLogin: config.hideXapLogin === 'true',
	  tags: config.tags || [config.customer],
	  server: config.server,
	  destination: config.destination,
	  hiddenFeatures: getHiddenFeatures(),
	  reverseListItemLabels: config.reverseListItemLabels === 'true',
	  msalTenantID: config.msalTenantID,
	  msalApplicationID: config.msalApplicationID,
	  msalScope: config.msalScope,
	  applicationInsightsInstrumentationKey: config.applicationInsightsInstrumentationKey,
	  siteName: config.siteName,
	  recaptchaKey: config.recaptchaKey
	};
	
	var apiUrl = exports.apiUrl = settings.apiUrl;
	var supportEmail = exports.supportEmail = settings.supportEmail;
	var customer = exports.customer = settings.customer;
	var logo = exports.logo = settings.logo;
	var logoWidth = exports.logoWidth = settings.logoWidth;
	var theme = exports.theme = settings.theme;
	var useSSO = exports.useSSO = settings.useSSO;
	var hideXapLogin = exports.hideXapLogin = settings.hideXapLogin;
	var tags = exports.tags = settings.tags;
	var server = exports.server = settings.server;
	var destination = exports.destination = settings.destination;
	var hiddenFeatures = exports.hiddenFeatures = settings.hiddenFeatures;
	var reverseListItemLabels = exports.reverseListItemLabels = settings.reverseListItemLabels;
	var msalTenantID = exports.msalTenantID = settings.msalTenantID;
	var msalApplicationID = exports.msalApplicationID = settings.msalApplicationID;
	var msalScope = exports.msalScope = settings.msalScope;
	var applicationInsightsInstrumentationKey = exports.applicationInsightsInstrumentationKey = settings.applicationInsightsInstrumentationKey;
	var siteName = exports.siteName = settings.siteName;
	var recaptchaKey = exports.recaptchaKey = settings.recaptchaKey;
	var useMobileLogin = exports.useMobileLogin = settings.useMobileLogin;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getTheme, 'getTheme', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(getHiddenFeatures, 'getHiddenFeatures', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(settings, 'settings', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(apiUrl, 'apiUrl', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(supportEmail, 'supportEmail', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(customer, 'customer', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(logo, 'logo', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(logoWidth, 'logoWidth', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(theme, 'theme', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(useSSO, 'useSSO', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(hideXapLogin, 'hideXapLogin', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(tags, 'tags', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(server, 'server', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(destination, 'destination', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(hiddenFeatures, 'hiddenFeatures', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(reverseListItemLabels, 'reverseListItemLabels', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(msalTenantID, 'msalTenantID', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(msalApplicationID, 'msalApplicationID', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(msalScope, 'msalScope', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(applicationInsightsInstrumentationKey, 'applicationInsightsInstrumentationKey', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(siteName, 'siteName', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(recaptchaKey, 'recaptchaKey', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	
	  __REACT_HOT_LOADER__.register(useMobileLogin, 'useMobileLogin', 'D:/a/1/s/src/web/employee/src/utils/settings.js');
	}();

	;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.11' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 56 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(772);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(771);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(1700);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(1699);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextField = __webpack_require__(1584);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(417);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is a Buffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Buffer, otherwise false
	 */
	function isBuffer(val) {
	  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
	    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a plain Object
	 *
	 * @param {Object} val The value to test
	 * @return {boolean} True if value is a plain Object, otherwise false
	 */
	function isPlainObject(val) {
	  if (toString.call(val) !== '[object Object]') {
	    return false;
	  }
	
	  var prototype = Object.getPrototypeOf(val);
	  return prototype === null || prototype === Object.prototype;
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 * nativescript
	 *  navigator.product -> 'NativeScript' or 'NS'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
	                                           navigator.product === 'NativeScript' ||
	                                           navigator.product === 'NS')) {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (isPlainObject(result[key]) && isPlainObject(val)) {
	      result[key] = merge(result[key], val);
	    } else if (isPlainObject(val)) {
	      result[key] = merge({}, val);
	    } else if (isArray(val)) {
	      result[key] = val.slice();
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	/**
	 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
	 *
	 * @param {string} content with BOM
	 * @return {string} content value without BOM
	 */
	function stripBOM(content) {
	  if (content.charCodeAt(0) === 0xFEFF) {
	    content = content.slice(1);
	  }
	  return content;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isPlainObject: isPlainObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim,
	  stripBOM: stripBOM
	};


/***/ }),
/* 60 */
[1863, 42, 127, 36],
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25);
	var hide = __webpack_require__(60);
	var has = __webpack_require__(69);
	var SRC = __webpack_require__(131)('src');
	var $toString = __webpack_require__(1102);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(68).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var fails = __webpack_require__(27);
	var defined = __webpack_require__(87);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _IconButton = __webpack_require__(1554);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _IconButton2.default;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var horizontal = _propTypes2.default.oneOf(['left', 'middle', 'right']);
	var vertical = _propTypes2.default.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _propTypes2.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _propTypes2.default.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _propTypes2.default.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _combineActions = _interopRequireDefault(__webpack_require__(1734));
	
	exports.combineActions = _combineActions.default;
	
	var _createAction = _interopRequireDefault(__webpack_require__(403));
	
	exports.createAction = _createAction.default;
	
	var _createActions = _interopRequireDefault(__webpack_require__(1735));
	
	exports.createActions = _createActions.default;
	
	var _createCurriedAction = _interopRequireDefault(__webpack_require__(1736));
	
	exports.createCurriedAction = _createCurriedAction.default;
	
	var _handleAction = _interopRequireDefault(__webpack_require__(785));
	
	exports.handleAction = _handleAction.default;
	
	var _handleActions = _interopRequireDefault(__webpack_require__(1737));
	
	exports.handleActions = _handleActions.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.updateSyncErrors = exports.updateSyncWarnings = exports.untouch = exports.unregisterField = exports.touch = exports.submit = exports.stopSubmit = exports.stopAsyncValidation = exports.startSubmit = exports.startAsyncValidation = exports.setSubmitSucceeded = exports.setSubmitFailed = exports.resetSection = exports.reset = exports.registerField = exports.initialize = exports.focus = exports.destroy = exports.clearSubmitErrors = exports.clearSubmit = exports.clearFields = exports.clearAsyncError = exports.change = exports.blur = exports.autofill = exports.arrayUnshift = exports.arraySwap = exports.arraySplice = exports.arrayShift = exports.arrayRemoveAll = exports.arrayRemove = exports.arrayPush = exports.arrayPop = exports.arrayMove = exports.arrayInsert = exports.formPropTypes = exports.fieldArrayPropTypes = exports.fieldArrayMetaPropTypes = exports.fieldArrayFieldsPropTypes = exports.fieldPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.SubmissionError = exports.ReduxFormContext = exports.values = exports.reducer = exports.reduxForm = exports.hasSubmitFailed = exports.hasSubmitSucceeded = exports.isSubmitting = exports.isValid = exports.isPristine = exports.isInvalid = exports.isDirty = exports.isAsyncValidating = exports.getFormSubmitErrors = exports.getFormSyncWarnings = exports.getFormAsyncErrors = exports.getFormMeta = exports.getFormSyncErrors = exports.getFormInitialValues = exports.getFormValues = exports.getFormNames = exports.getFormError = exports.formValues = exports.formValueSelector = exports.FieldArray = exports.Fields = exports.Field = exports.propTypes = exports.FormSection = exports.FormName = exports.Form = exports.defaultShouldWarn = exports.defaultShouldError = exports.defaultShouldValidate = exports.defaultShouldAsyncValidate = exports.actionTypes = void 0;
	
	var _actions = _interopRequireDefault(__webpack_require__(794));
	
	var _actionTypes = _interopRequireDefault(__webpack_require__(406));
	
	exports.actionTypes = _actionTypes["default"];
	
	var _ReduxFormContext = __webpack_require__(101);
	
	exports.ReduxFormContext = _ReduxFormContext.ReduxFormContext;
	
	var _defaultShouldAsyncValidate = _interopRequireDefault(__webpack_require__(796));
	
	exports.defaultShouldAsyncValidate = _defaultShouldAsyncValidate["default"];
	
	var _defaultShouldValidate = _interopRequireDefault(__webpack_require__(798));
	
	exports.defaultShouldValidate = _defaultShouldValidate["default"];
	
	var _defaultShouldError = _interopRequireDefault(__webpack_require__(797));
	
	exports.defaultShouldError = _defaultShouldError["default"];
	
	var _defaultShouldWarn = _interopRequireDefault(__webpack_require__(799));
	
	exports.defaultShouldWarn = _defaultShouldWarn["default"];
	
	var _Form = _interopRequireDefault(__webpack_require__(1755));
	
	exports.Form = _Form["default"];
	
	var _FormName = _interopRequireDefault(__webpack_require__(1756));
	
	exports.FormName = _FormName["default"];
	
	var _FormSection = _interopRequireDefault(__webpack_require__(1757));
	
	exports.FormSection = _FormSection["default"];
	
	var _SubmissionError = __webpack_require__(793);
	
	exports.SubmissionError = _SubmissionError.SubmissionError;
	
	var _propTypes = _interopRequireWildcard(__webpack_require__(1793));
	
	exports.propTypes = _propTypes["default"];
	exports.fieldInputPropTypes = _propTypes.fieldInputPropTypes;
	exports.fieldMetaPropTypes = _propTypes.fieldMetaPropTypes;
	exports.fieldPropTypes = _propTypes.fieldPropTypes;
	exports.fieldArrayFieldsPropTypes = _propTypes.fieldArrayFieldsPropTypes;
	exports.fieldArrayMetaPropTypes = _propTypes.fieldArrayMetaPropTypes;
	exports.fieldArrayPropTypes = _propTypes.fieldArrayPropTypes;
	exports.formPropTypes = _propTypes.formPropTypes;
	
	var _Field = _interopRequireDefault(__webpack_require__(1752));
	
	exports.Field = _Field["default"];
	
	var _Fields = _interopRequireDefault(__webpack_require__(1754));
	
	exports.Fields = _Fields["default"];
	
	var _FieldArray = _interopRequireDefault(__webpack_require__(1753));
	
	exports.FieldArray = _FieldArray["default"];
	
	var _formValueSelector = _interopRequireDefault(__webpack_require__(1771));
	
	exports.formValueSelector = _formValueSelector["default"];
	
	var _formValues = _interopRequireDefault(__webpack_require__(1772));
	
	exports.formValues = _formValues["default"];
	
	var _getFormError = _interopRequireDefault(__webpack_require__(1775));
	
	exports.getFormError = _getFormError["default"];
	
	var _getFormNames = _interopRequireDefault(__webpack_require__(1778));
	
	exports.getFormNames = _getFormNames["default"];
	
	var _getFormValues = _interopRequireDefault(__webpack_require__(1782));
	
	exports.getFormValues = _getFormValues["default"];
	
	var _getFormInitialValues = _interopRequireDefault(__webpack_require__(1776));
	
	exports.getFormInitialValues = _getFormInitialValues["default"];
	
	var _getFormSyncErrors = _interopRequireDefault(__webpack_require__(1780));
	
	exports.getFormSyncErrors = _getFormSyncErrors["default"];
	
	var _getFormMeta = _interopRequireDefault(__webpack_require__(1777));
	
	exports.getFormMeta = _getFormMeta["default"];
	
	var _getFormAsyncErrors = _interopRequireDefault(__webpack_require__(1774));
	
	exports.getFormAsyncErrors = _getFormAsyncErrors["default"];
	
	var _getFormSyncWarnings = _interopRequireDefault(__webpack_require__(1781));
	
	exports.getFormSyncWarnings = _getFormSyncWarnings["default"];
	
	var _getFormSubmitErrors = _interopRequireDefault(__webpack_require__(1779));
	
	exports.getFormSubmitErrors = _getFormSubmitErrors["default"];
	
	var _isAsyncValidating = _interopRequireDefault(__webpack_require__(1787));
	
	exports.isAsyncValidating = _isAsyncValidating["default"];
	
	var _isDirty = _interopRequireDefault(__webpack_require__(1788));
	
	exports.isDirty = _isDirty["default"];
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(1789));
	
	exports.isInvalid = _isInvalid["default"];
	
	var _isPristine = _interopRequireDefault(__webpack_require__(1790));
	
	exports.isPristine = _isPristine["default"];
	
	var _isValid = _interopRequireDefault(__webpack_require__(1792));
	
	exports.isValid = _isValid["default"];
	
	var _isSubmitting = _interopRequireDefault(__webpack_require__(1791));
	
	exports.isSubmitting = _isSubmitting["default"];
	
	var _hasSubmitSucceeded = _interopRequireDefault(__webpack_require__(1786));
	
	exports.hasSubmitSucceeded = _hasSubmitSucceeded["default"];
	
	var _hasSubmitFailed = _interopRequireDefault(__webpack_require__(1785));
	
	exports.hasSubmitFailed = _hasSubmitFailed["default"];
	
	var _reduxForm = _interopRequireDefault(__webpack_require__(1795));
	
	exports.reduxForm = _reduxForm["default"];
	
	var _reducer = _interopRequireDefault(__webpack_require__(1794));
	
	exports.reducer = _reducer["default"];
	
	var _values = _interopRequireDefault(__webpack_require__(1820));
	
	exports.values = _values["default"];
	// alias for propTypes
	var arrayInsert = _actions["default"].arrayInsert;
	exports.arrayInsert = arrayInsert;
	var arrayMove = _actions["default"].arrayMove;
	exports.arrayMove = arrayMove;
	var arrayPop = _actions["default"].arrayPop;
	exports.arrayPop = arrayPop;
	var arrayPush = _actions["default"].arrayPush;
	exports.arrayPush = arrayPush;
	var arrayRemove = _actions["default"].arrayRemove;
	exports.arrayRemove = arrayRemove;
	var arrayRemoveAll = _actions["default"].arrayRemoveAll;
	exports.arrayRemoveAll = arrayRemoveAll;
	var arrayShift = _actions["default"].arrayShift;
	exports.arrayShift = arrayShift;
	var arraySplice = _actions["default"].arraySplice;
	exports.arraySplice = arraySplice;
	var arraySwap = _actions["default"].arraySwap;
	exports.arraySwap = arraySwap;
	var arrayUnshift = _actions["default"].arrayUnshift;
	exports.arrayUnshift = arrayUnshift;
	var autofill = _actions["default"].autofill;
	exports.autofill = autofill;
	var blur = _actions["default"].blur;
	exports.blur = blur;
	var change = _actions["default"].change;
	exports.change = change;
	var clearAsyncError = _actions["default"].clearAsyncError;
	exports.clearAsyncError = clearAsyncError;
	var clearFields = _actions["default"].clearFields;
	exports.clearFields = clearFields;
	var clearSubmit = _actions["default"].clearSubmit;
	exports.clearSubmit = clearSubmit;
	var clearSubmitErrors = _actions["default"].clearSubmitErrors;
	exports.clearSubmitErrors = clearSubmitErrors;
	var destroy = _actions["default"].destroy;
	exports.destroy = destroy;
	var focus = _actions["default"].focus;
	exports.focus = focus;
	var initialize = _actions["default"].initialize;
	exports.initialize = initialize;
	var registerField = _actions["default"].registerField;
	exports.registerField = registerField;
	var reset = _actions["default"].reset;
	exports.reset = reset;
	var resetSection = _actions["default"].resetSection;
	exports.resetSection = resetSection;
	var setSubmitFailed = _actions["default"].setSubmitFailed;
	exports.setSubmitFailed = setSubmitFailed;
	var setSubmitSucceeded = _actions["default"].setSubmitSucceeded;
	exports.setSubmitSucceeded = setSubmitSucceeded;
	var startAsyncValidation = _actions["default"].startAsyncValidation;
	exports.startAsyncValidation = startAsyncValidation;
	var startSubmit = _actions["default"].startSubmit;
	exports.startSubmit = startSubmit;
	var stopAsyncValidation = _actions["default"].stopAsyncValidation;
	exports.stopAsyncValidation = stopAsyncValidation;
	var stopSubmit = _actions["default"].stopSubmit;
	exports.stopSubmit = stopSubmit;
	var submit = _actions["default"].submit;
	exports.submit = submit;
	var touch = _actions["default"].touch;
	exports.touch = touch;
	var unregisterField = _actions["default"].unregisterField;
	exports.unregisterField = unregisterField;
	var untouch = _actions["default"].untouch;
	exports.untouch = untouch;
	var updateSyncWarnings = _actions["default"].updateSyncWarnings;
	exports.updateSyncWarnings = updateSyncWarnings;
	var updateSyncErrors = _actions["default"].updateSyncErrors;
	exports.updateSyncErrors = updateSyncErrors;

/***/ }),
/* 68 */
55,
/* 69 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 70 */
[1878, 195, 127, 72, 89, 69, 486, 36],
/* 71 */
[1881, 69, 43, 330],
/* 72 */
[1891, 194, 87],
/* 73 */
/***/ (function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	function keyCode(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Compares a keyboard event with a given keyCode or keyName.
	 *
	 * @param {Event} event Keyboard event that should be tested
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Boolean}
	 * @api public
	 */
	keyCode.isEventKey = function isEventKey(event, nameOrCode) {
	  if (event && 'object' === typeof event) {
	    var keyCode = event.which || event.keyCode || event.charCode
	    if (keyCode === null || keyCode === undefined) { return false; }
	    if (typeof nameOrCode === 'string') {
	      // check codes
	      var foundNamedKey = codes[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    
	      // check aliases
	      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
	      if (foundNamedKey) { return foundNamedKey === keyCode; }
	    } else if (typeof nameOrCode === 'number') {
	      return nameOrCode === keyCode;
	    }
	    return false;
	  }
	}
	
	exports = module.exports = keyCode;
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'spacebar': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _default = {
	  container: {
	    width: 'calc(100% - 72px)',
	    height: 'calc(100% - 20px)',
	    paddingLeft: 36,
	    paddingRight: 36,
	    paddingTop: 10,
	    paddingBottom: 10
	  },
	  link: {
	    marginTop: 10,
	    marginBottom: 10,
	    paddingLeft: 0
	  },
	  tag: {
	    marginTop: 12,
	    borderRadius: 4,
	    padding: 6,
	    color: 'white',
	    display: 'table'
	  },
	  spacer: {
	    marginTop: 30
	  },
	  actionButton: {
	    maxWidth: 'none',
	    fontSize: 14
	  },
	  action: {
	    flex: '1 1 0',
	    justifyContent: 'center',
	    minHeight: 40,
	    maxHeight: 40
	  }
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/styles/TBenefits.js');
	}();

	;

/***/ }),
/* 75 */
[1897, 306, 230, 106],
/* 76 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 77 */
[1859, 56],
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(27);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(552);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 81 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FlatButton = __webpack_require__(1547);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatButton2.default;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FontIcon = __webpack_require__(1551);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon2.default;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _events = __webpack_require__(274);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keycode = __webpack_require__(73);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _FocusRipple = __webpack_require__(382);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(618);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (event) {
	      tabPressed = (0, _keycode2.default)(event) === 'tab';
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = function (_Component) {
	  (0, _inherits3.default)(EnhancedButton, _Component);
	
	  function EnhancedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleKeyDown = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
	          _this.removeKeyboardFocus(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleKeyUp = function (event) {
	      _this.props.onKeyUp(event);
	    }, _this.handleBlur = function (event) {
	      _this.cancelFocusTimeout();
	      _this.removeKeyboardFocus(event);
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (event) event.persist();
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        // setTimeout is needed because the focus event fires first
	        // Wait so that we can capture if this was a keyboard focus
	        // or touch focus
	        _this.focusTimeout = setTimeout(function () {
	          if (tabPressed) {
	            _this.setKeyboardFocus(event);
	            tabPressed = false;
	          }
	        }, 150);
	
	        _this.props.onFocus(event);
	      }
	    }, _this.handleClick = function (event) {
	      _this.cancelFocusTimeout();
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.removeKeyboardFocus(event);
	        _this.props.onClick(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          disableKeyboardFocus = _props.disableKeyboardFocus,
	          keyboardFocused = _props.keyboardFocused;
	
	      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
	        this.setState({ isKeyboardFocused: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      injectStyle();
	      listenForTabPresses();
	      if (this.state.isKeyboardFocused) {
	        this.button.focus();
	        this.props.onKeyboardFocus(null, true);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        if (nextProps.onKeyboardFocus) {
	          nextProps.onKeyboardFocus(null, false);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	      }
	    }
	  }, {
	    key: 'isKeyboardFocused',
	    value: function isKeyboardFocused() {
	      return this.state.isKeyboardFocused;
	    }
	  }, {
	    key: 'removeKeyboardFocus',
	    value: function removeKeyboardFocus(event) {
	      if (this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        this.props.onKeyboardFocus(event, false);
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus(event) {
	      if (!this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: true });
	        this.props.onKeyboardFocus(event, true);
	      }
	    }
	  }, {
	    key: 'cancelFocusTimeout',
	    value: function cancelFocusTimeout() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	        this.focusTimeout = null;
	      }
	    }
	  }, {
	    key: 'createButtonChildren',
	    value: function createButtonChildren() {
	      var _props2 = this.props,
	          centerRipple = _props2.centerRipple,
	          children = _props2.children,
	          disabled = _props2.disabled,
	          disableFocusRipple = _props2.disableFocusRipple,
	          disableKeyboardFocus = _props2.disableKeyboardFocus,
	          disableTouchRipple = _props2.disableTouchRipple,
	          focusRippleColor = _props2.focusRippleColor,
	          focusRippleOpacity = _props2.focusRippleOpacity,
	          touchRippleColor = _props2.touchRippleColor,
	          touchRippleOpacity = _props2.touchRippleOpacity;
	      var isKeyboardFocused = this.state.isKeyboardFocused;
	
	      // Focus Ripple
	
	      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
	        color: focusRippleColor,
	        opacity: focusRippleOpacity,
	        show: isKeyboardFocused,
	        style: {
	          overflow: 'hidden'
	        },
	        key: 'focusRipple'
	      }) : undefined;
	
	      // Touch Ripple
	      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	        _TouchRipple2.default,
	        {
	          centerRipple: centerRipple,
	          color: touchRippleColor,
	          opacity: touchRippleOpacity,
	          key: 'touchRipple'
	        },
	        children
	      ) : undefined;
	
	      return [focusRipple, touchRipple, touchRipple ? undefined : children];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          centerRipple = _props3.centerRipple,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          disableTouchRipple = _props3.disableTouchRipple,
	          focusRippleColor = _props3.focusRippleColor,
	          focusRippleOpacity = _props3.focusRippleOpacity,
	          href = _props3.href,
	          keyboardFocused = _props3.keyboardFocused,
	          touchRippleColor = _props3.touchRippleColor,
	          touchRippleOpacity = _props3.touchRippleOpacity,
	          onBlur = _props3.onBlur,
	          onClick = _props3.onClick,
	          onFocus = _props3.onFocus,
	          onKeyUp = _props3.onKeyUp,
	          onKeyDown = _props3.onKeyDown,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          style = _props3.style,
	          tabIndex = _props3.tabIndex,
	          type = _props3.type,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'style', 'tabIndex', 'type']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          enhancedButton = _context$muiTheme.enhancedButton;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        border: 10,
	        boxSizing: 'border-box',
	        display: 'inline-block',
	        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
	        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
	        cursor: disabled ? 'default' : 'pointer',
	        textDecoration: 'none',
	        margin: 0,
	        padding: 0,
	        outline: 'none',
	        fontSize: 'inherit',
	        fontWeight: 'inherit',
	        position: 'relative', // This is needed so that ripples do not bleed past border radius.
	        verticalAlign: href ? 'middle' : null
	      }, style);
	
	      // Passing both background:none & backgroundColor can break due to object iteration order
	      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
	        mergedStyles.background = 'none';
	      }
	
	      if (disabled && href) {
	        return _react2.default.createElement(
	          'span',
	          (0, _extends3.default)({}, other, {
	            style: mergedStyles
	          }),
	          children
	        );
	      }
	
	      var buttonProps = (0, _extends3.default)({}, other, {
	        style: prepareStyles(mergedStyles),
	        ref: function ref(node) {
	          return _this2.button = node;
	        },
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyUp: this.handleKeyUp,
	        onKeyDown: this.handleKeyDown,
	        onClick: this.handleClick,
	        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
	      });
	
	      if (href) buttonProps.href = href;
	
	      var buttonChildren = this.createButtonChildren();
	
	      if (_react2.default.isValidElement(containerElement)) {
	        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
	      }
	
	      if (!href && containerElement === 'button') {
	        buttonProps.type = type;
	      }
	
	      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
	    }
	  }]);
	  return EnhancedButton;
	}(_react.Component);
	
	EnhancedButton.defaultProps = {
	  containerElement: 'button',
	  onBlur: function onBlur() {},
	  onClick: function onClick() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyUp: function onKeyUp() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  tabIndex: 0,
	  type: 'button'
	};
	EnhancedButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	EnhancedButton.propTypes =  false ? {
	  centerRipple: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  disableFocusRipple: _propTypes2.default.bool,
	  disableKeyboardFocus: _propTypes2.default.bool,
	  disableTouchRipple: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  focusRippleColor: _propTypes2.default.string,
	  focusRippleOpacity: _propTypes2.default.number,
	  href: _propTypes2.default.string,
	  keyboardFocused: _propTypes2.default.bool,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onKeyUp: _propTypes2.default.func,
	  onKeyboardFocus: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  tabIndex: _propTypes2.default.number,
	  touchRippleColor: _propTypes2.default.string,
	  touchRippleOpacity: _propTypes2.default.number,
	  type: _propTypes2.default.string
	} : {};
	exports.default = EnhancedButton;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STRING = exports.STRING = 'DT_STRING';
	var NUMBER = exports.NUMBER = 'DT_NUMBER';
	var DATE = exports.DATE = 'DT_DATE';
	var TIME = exports.TIME = 'DT_TIME';
	var BOOL = exports.BOOL = 'DT_BOOL';
	var TABLE = exports.TABLE = 'DT_TABLE';
	var HTML = exports.HTML = 'DT_HTML';
	
	var MANAGER_TAB = exports.MANAGER_TAB = 'MANAGER_TAB';
	var EMPLOYEE_TAB = exports.EMPLOYEE_TAB = 'EMPLOYEE_TAB';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(STRING, 'STRING', 'D:/a/1/s/src/web/employee/src/constants/DataTypes.js');
	
	  __REACT_HOT_LOADER__.register(NUMBER, 'NUMBER', 'D:/a/1/s/src/web/employee/src/constants/DataTypes.js');
	
	  __REACT_HOT_LOADER__.register(DATE, 'DATE', 'D:/a/1/s/src/web/employee/src/constants/DataTypes.js');
	
	  __REACT_HOT_LOADER__.register(TIME, 'TIME', 'D:/a/1/s/src/web/employee/src/constants/DataTypes.js');
	
	  __REACT_HOT_LOADER__.register(BOOL, 'BOOL', 'D:/a/1/s/src/web/employee/src/constants/DataTypes.js');
	
	  __REACT_HOT_LOADER__.register(TABLE, 'TABLE', 'D:/a/1/s/src/web/employee/src/constants/DataTypes.js');
	
	  __REACT_HOT_LOADER__.register(HTML, 'HTML', 'D:/a/1/s/src/web/employee/src/constants/DataTypes.js');
	
	  __REACT_HOT_LOADER__.register(MANAGER_TAB, 'MANAGER_TAB', 'D:/a/1/s/src/web/employee/src/constants/DataTypes.js');
	
	  __REACT_HOT_LOADER__.register(EMPLOYEE_TAB, 'EMPLOYEE_TAB', 'D:/a/1/s/src/web/employee/src/constants/DataTypes.js');
	}();

	;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(77);
	var IObject = __webpack_require__(194);
	var toObject = __webpack_require__(43);
	var toLength = __webpack_require__(34);
	var asc = __webpack_require__(314);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 87 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 88 */
[1884, 4, 68, 27],
/* 89 */
[1894, 28],
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertColorToString = convertColorToString;
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function convertColorToString(color) {
	  var type = color.type,
	      values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    for (var i = 0; i < 3; i++) {
	      values[i] = parseInt(values[i]);
	    }
	  }
	
	  var colorString = void 0;
	
	  if (type.indexOf('hsl') > -1) {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
	  } else {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
	  }
	
	  if (values.length === 4) {
	    colorString += ', ' + color.values[3] + ')';
	  } else {
	    colorString += ')';
	  }
	
	  return colorString;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	function convertHexToRGB(color) {
	  if (color.length === 4) {
	    var extendedColor = '#';
	    for (var i = 1; i < color.length; i++) {
	      extendedColor += color.charAt(i) + color.charAt(i);
	    }
	    color = extendedColor;
	  }
	
	  var values = {
	    r: parseInt(color.substr(1, 2), 16),
	    g: parseInt(color.substr(3, 2), 16),
	    b: parseInt(color.substr(5, 2), 16)
	  };
	
	  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values and color names.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {{type: string, values: number[]}} A MUI color object
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	
	   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;
	
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	
	  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  color = decomposeColor(color);
	
	  if (color.type.indexOf('rgb') > -1) {
	    var rgb = color.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
	  } else if (color.type.indexOf('hsl') > -1) {
	    return color.values[2] / 100;
	  }
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value, 0, 1);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return convertColorToString(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return convertColorToString(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return convertColorToString(color);
	}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var CHECKBOX = exports.CHECKBOX = 'CHECKBOX';
	var DATE = exports.DATE = 'DATE';
	var SCALE = exports.SCALE = 'SCALE';
	var RADIO = exports.RADIO = 'RADIO';
	var ATTACHMENT = exports.ATTACHMENT = 'ATTACHMENT';
	var NUMBER_FIELD = exports.NUMBER_FIELD = 'NUMBER_FIELD';
	var TEXT_FIELD = exports.TEXT_FIELD = 'TEXT_FIELD';
	var PASSWORD_FIELD = exports.PASSWORD_FIELD = 'PASSWORD_FIELD';
	var SELECT_LOOKUP = exports.SELECT_LOOKUP = 'SELECT_LOOKUP';
	var SELECT_ENUM = exports.SELECT_ENUM = 'SELECT_ENUM';
	var AUTOCOMPLETE = exports.AUTOCOMPLETE = 'AUTOCOMPLETE';
	var HIDDEN = exports.HIDDEN = 'HIDDEN';
	var LINK = exports.LINK = 'LINK';
	var EMAIL = exports.EMAIL = 'EMAIL';
	var PHONE = exports.PHONE = 'PHONE';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CHECKBOX, 'CHECKBOX', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(DATE, 'DATE', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(SCALE, 'SCALE', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(RADIO, 'RADIO', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(ATTACHMENT, 'ATTACHMENT', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(NUMBER_FIELD, 'NUMBER_FIELD', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(TEXT_FIELD, 'TEXT_FIELD', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(PASSWORD_FIELD, 'PASSWORD_FIELD', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_LOOKUP, 'SELECT_LOOKUP', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(SELECT_ENUM, 'SELECT_ENUM', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(AUTOCOMPLETE, 'AUTOCOMPLETE', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(HIDDEN, 'HIDDEN', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(LINK, 'LINK', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(EMAIL, 'EMAIL', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	
	  __REACT_HOT_LOADER__.register(PHONE, 'PHONE', 'D:/a/1/s/src/web/employee/src/constants/InputTypes.js');
	}();

	;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.shouldUse = exports.shouldCreate = exports.shouldShow = exports.shouldNotHide = exports.shouldEdit = undefined;
	
	var _lodash = __webpack_require__(8);
	
	var shouldEdit = exports.shouldEdit = function shouldEdit(valuesByKey, key) {
	  return (0, _lodash.get)(valuesByKey, ['Edit.' + key, 'Value']) !== 'false';
	};
	
	var shouldNotHide = exports.shouldNotHide = function shouldNotHide(valuesByKey, key) {
	  return (0, _lodash.get)(valuesByKey, ['Hide.' + key, 'Value']) !== 'true';
	};
	
	var shouldShow = exports.shouldShow = function shouldShow(valuesByKey, key) {
	  return (0, _lodash.get)(valuesByKey, ['Show.' + key, 'Value']) === 'true';
	};
	
	var shouldCreate = exports.shouldCreate = function shouldCreate(valuesByKey, key) {
	  return (0, _lodash.get)(valuesByKey, ['Create.' + key, 'Value']) === 'true';
	};
	
	var shouldUse = exports.shouldUse = function shouldUse(valuesByKey, key) {
	  return (0, _lodash.get)(valuesByKey, ['Use.' + key, 'Value']) === 'true';
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(shouldEdit, 'shouldEdit', 'D:/a/1/s/src/web/employee/src/utils/valuesByKey.js');
	
	  __REACT_HOT_LOADER__.register(shouldNotHide, 'shouldNotHide', 'D:/a/1/s/src/web/employee/src/utils/valuesByKey.js');
	
	  __REACT_HOT_LOADER__.register(shouldShow, 'shouldShow', 'D:/a/1/s/src/web/employee/src/utils/valuesByKey.js');
	
	  __REACT_HOT_LOADER__.register(shouldCreate, 'shouldCreate', 'D:/a/1/s/src/web/employee/src/utils/valuesByKey.js');
	
	  __REACT_HOT_LOADER__.register(shouldUse, 'shouldUse', 'D:/a/1/s/src/web/employee/src/utils/valuesByKey.js');
	}();

	;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(508);
	var $export = __webpack_require__(4);
	var shared = __webpack_require__(196)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(514))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(36)) {
	  var LIBRARY = __webpack_require__(109);
	  var global = __webpack_require__(25);
	  var fails = __webpack_require__(27);
	  var $export = __webpack_require__(4);
	  var $typed = __webpack_require__(244);
	  var $buffer = __webpack_require__(335);
	  var ctx = __webpack_require__(77);
	  var anInstance = __webpack_require__(122);
	  var propertyDesc = __webpack_require__(127);
	  var hide = __webpack_require__(60);
	  var redefineAll = __webpack_require__(128);
	  var toInteger = __webpack_require__(79);
	  var toLength = __webpack_require__(34);
	  var toIndex = __webpack_require__(506);
	  var toAbsoluteIndex = __webpack_require__(130);
	  var toPrimitive = __webpack_require__(89);
	  var has = __webpack_require__(69);
	  var classof = __webpack_require__(156);
	  var isObject = __webpack_require__(28);
	  var toObject = __webpack_require__(43);
	  var isArrayIter = __webpack_require__(321);
	  var create = __webpack_require__(124);
	  var getPrototypeOf = __webpack_require__(71);
	  var gOPN = __webpack_require__(125).f;
	  var getIterFn = __webpack_require__(337);
	  var uid = __webpack_require__(131);
	  var wks = __webpack_require__(31);
	  var createArrayMethod = __webpack_require__(86);
	  var createArrayIncludes = __webpack_require__(232);
	  var speciesConstructor = __webpack_require__(197);
	  var ArrayIterators = __webpack_require__(338);
	  var Iterators = __webpack_require__(157);
	  var $iterDetect = __webpack_require__(237);
	  var setSpecies = __webpack_require__(129);
	  var arrayFill = __webpack_require__(313);
	  var arrayCopyWithin = __webpack_require__(478);
	  var $DP = __webpack_require__(42);
	  var $GOPD = __webpack_require__(70);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(1295);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(199);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(264),
	    isLength = __webpack_require__(369);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var baseKeys = __webpack_require__(540),
	    getTag = __webpack_require__(200),
	    isArguments = __webpack_require__(205),
	    isArray = __webpack_require__(41),
	    isArrayLike = __webpack_require__(97),
	    isBuffer = __webpack_require__(206),
	    isPrototype = __webpack_require__(260),
	    isTypedArray = __webpack_require__(266);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) &&
	      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	    return !value.length;
	  }
	  var tag = getTag(value);
	  if (tag == mapTag || tag == setTag) {
	    return !value.size;
	  }
	  if (isPrototype(value)) {
	    return !baseKeys(value).length;
	  }
	  for (var key in value) {
	    if (hasOwnProperty.call(value, key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(535),
	    baseKeys = __webpack_require__(540),
	    isArrayLike = __webpack_require__(97);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _classCallCheck = _interopDefault(__webpack_require__(817));
	var _createClass = _interopDefault(__webpack_require__(143));
	var _possibleConstructorReturn = _interopDefault(__webpack_require__(821));
	var _getPrototypeOf = _interopDefault(__webpack_require__(818));
	var _inherits = _interopDefault(__webpack_require__(819));
	var _typeof = _interopDefault(__webpack_require__(279));
	var _objectWithoutProperties = _interopDefault(__webpack_require__(820));
	var _extends = _interopDefault(__webpack_require__(40));
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(2));
	var warning = _interopDefault(__webpack_require__(1647));
	
	function defineProperty(object, property, attr) {
	  return Object.defineProperty(object, property, attr);
	} // Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	
	
	var passiveOption = function () {
	  var cache = null;
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, defineProperty({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (err) {//
	    }
	
	    cache = supportsPassiveOption;
	    return supportsPassiveOption;
	  }();
	}();
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	
	function mergeDefaultEventOptions(options) {
	  return _extends({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function off(target, eventName, callback, options) {
	  // eslint-disable-next-line prefer-spread
	  target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = _objectWithoutProperties(props, ["children", "target"]);
	
	  Object.keys(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	
	    var type = _typeof(prop);
	
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({
	        capture: capture
	      }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? warning(options, 'react-event-listener: should be specified options in withOptions.') : void 0;
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(EventListener, _React$PureComponent);
	
	  function EventListener() {
	    _classCallCheck(this, EventListener);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(EventListener).apply(this, arguments));
	  }
	
	  _createClass(EventListener, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      this.applyListeners(off, prevProps);
	      this.applyListeners(on);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: "applyListeners",
	    value: function applyListeners(onOrOff) {
	      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props;
	      var target = props.target;
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	
	  return EventListener;
	}(React.PureComponent);
	
	EventListener.propTypes =  false ? {
	  /**
	   * You can provide a single child too.
	   */
	  children: PropTypes.node,
	
	  /**
	   * The DOM target to listen to.
	   */
	  target: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired
	} : {};
	
	exports.withOptions = withOptions;
	exports.default = EventListener;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.withReduxForm = exports.renderChildren = exports.ReduxFormContext = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReduxFormContext = React.createContext(null);
	exports.ReduxFormContext = ReduxFormContext;
	
	var renderChildren = function renderChildren(Component, _ref) {
	  var forwardedRef = _ref.forwardedRef,
	      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["forwardedRef"]);
	  return function (_reduxForm) {
	    return React.createElement(Component, (0, _extends2["default"])({}, rest, {
	      _reduxForm: _reduxForm,
	      ref: forwardedRef
	    }));
	  };
	};
	
	exports.renderChildren = renderChildren;
	
	var withReduxForm = function withReduxForm(Component) {
	  var Hoc = /*#__PURE__*/function (_React$Component) {
	    (0, _inheritsLoose2["default"])(Hoc, _React$Component);
	
	    function Hoc() {
	      return _React$Component.apply(this, arguments) || this;
	    }
	
	    var _proto = Hoc.prototype;
	
	    _proto.render = function render() {
	      return React.createElement(ReduxFormContext.Consumer, {
	        children: renderChildren(Component, this.props)
	      });
	    };
	
	    return Hoc;
	  }(React.Component);
	
	  var ref = React.forwardRef(function (props, ref) {
	    return React.createElement(Hoc, (0, _extends2["default"])({}, props, {
	      forwardedRef: ref
	    }));
	  });
	  ref.displayName = Component.displayName || Component.name || 'Component';
	  return ref;
	};
	
	exports.withReduxForm = withReduxForm;

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.unitRender = exports.normalizeNumberRange0to100 = exports.normalizeNumber = undefined;
	
	var _lodash = __webpack_require__(8);
	
	var normalizeNumber = exports.normalizeNumber = function normalizeNumber(value) {
	  if (!value) {
	    return value;
	  }
	  var numbers = (0, _lodash.toString)(value).replace(/[^\d]/g, '');
	  return numbers;
	};
	
	var normalizeNumberRange0to100 = exports.normalizeNumberRange0to100 = function normalizeNumberRange0to100(value) {
	  var number = parseInt(normalizeNumber(value), 10);
	  if (number >= 100) {
	    number = 100;
	  }
	  if (number <= 0 || (0, _lodash.isNaN)(number)) {
	    number = 0;
	  }
	  return (0, _lodash.toString)(number);
	};
	
	var unitRender = exports.unitRender = function unitRender(n) {
	  var digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	  return n ? n.toLocaleString(
	  // Need to use German because Icelandic is not working
	  'de-DE', { maximumFractionDigits: digits, minimumFractionDigits: digits }) : n;
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(normalizeNumber, 'normalizeNumber', 'D:/a/1/s/src/web/employee/src/utils/normalize.js');
	
	  __REACT_HOT_LOADER__.register(normalizeNumberRange0to100, 'normalizeNumberRange0to100', 'D:/a/1/s/src/web/employee/src/utils/normalize.js');
	
	  __REACT_HOT_LOADER__.register(unitRender, 'unitRender', 'D:/a/1/s/src/web/employee/src/utils/normalize.js');
	}();

	;

/***/ }),
/* 104 */
[1860, 150],
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(106);
	var core = __webpack_require__(55);
	var ctx = __webpack_require__(299);
	var hide = __webpack_require__(151);
	var has = __webpack_require__(121);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 106 */
25,
/* 107 */
[1876, 120, 466, 308, 104],
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(31)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(60)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 110 */
[1873, 131, 28, 69, 42, 27],
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(1409),
	    baseMatchesProperty = __webpack_require__(1410),
	    identity = __webpack_require__(203),
	    isArray = __webpack_require__(41),
	    property = __webpack_require__(1507);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MenuItem = __webpack_require__(377);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MenuItem2.default;

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RaisedButton = __webpack_require__(1562);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RaisedButton2.default;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Subheader = __webpack_require__(1576);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader2.default;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFileById = exports.requestFileByIdFailure = exports.requestFileByIdSuccess = exports.requestFileById = exports.initUpload = exports.initFileUploadFailure = exports.initFileUploadSuccess = exports.initFileUpload = exports.uploadFiles = exports.uploadFile = exports.requestFileUploadFailure = exports.requestFileUploadSuccess = exports.requestFileUpload = exports.deleteFile = exports.requestFileDeleteFailure = exports.requestFileDeleteSuccess = exports.requestFileDelete = exports.downloadFile = exports.download = exports.requestFileDownloadFailure = exports.requestFileDownloadSuccess = exports.requestFileDownload = exports.initPayYear = exports.fetchUserPayslips = exports.requestPayslipsFailure = exports.requestPayslipsSuccess = exports.requestPayslips = exports.setPayYear = exports.setGroupFilter = exports.fetchUserFiles = exports.requestFilesFailure = exports.requestFilesSuccess = exports.requestFiles = undefined;
	
	var _ActionTypes = __webpack_require__(18);
	
	var TYPES = _interopRequireWildcard(_ActionTypes);
	
	var _mimeTypes = __webpack_require__(1632);
	
	var _mimeTypes2 = _interopRequireDefault(_mimeTypes);
	
	var _fileSaver = __webpack_require__(516);
	
	var _fileSaver2 = _interopRequireDefault(_fileSaver);
	
	var _lodash = __webpack_require__(8);
	
	var _reduxForm = __webpack_require__(67);
	
	var _Api = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var requestFiles = exports.requestFiles = function requestFiles() {
	  return {
	    type: TYPES.REQUEST_FILES
	  };
	};
	
	var requestFilesSuccess = exports.requestFilesSuccess = function requestFilesSuccess(files, groupedFiles) {
	  return {
	    type: TYPES.REQUEST_FILES_SUCCESS,
	    groupedFiles: groupedFiles,
	    files: files
	  };
	};
	
	var requestFilesFailure = exports.requestFilesFailure = function requestFilesFailure(error) {
	  return {
	    type: TYPES.REQUEST_FILES_FAILURE,
	    error: error
	  };
	};
	
	var fetchUserFiles = exports.fetchUserFiles = function fetchUserFiles() {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, EmployeeMasterID, getFiles, files, groupedFiles;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              dispatch(requestFiles());
	              _getState = getState(), EmployeeMasterID = _getState.loginReducer.user.EmployeeMasterID;
	              _context.prev = 2;
	              getFiles = {
	                url: '/kjarni/api/v2/EmployeeMasters/EmployeeDocuments(employeeMasterId=' + EmployeeMasterID + ')',
	                method: 'GET'
	              };
	              _context.t0 = _lodash.orderBy;
	              _context.t1 = _lodash.get;
	              _context.next = 8;
	              return (0, _Api.custom)(getFiles);
	
	            case 8:
	              _context.t2 = _context.sent;
	              _context.t3 = [];
	              _context.t4 = (0, _context.t1)(_context.t2, 'data.value', _context.t3);
	              _context.t5 = ['AddDate'];
	              _context.t6 = ['desc'];
	              files = (0, _context.t0)(_context.t4, _context.t5, _context.t6);
	              groupedFiles = (0, _lodash.groupBy)(files, 'ObjectDocumentType');
	
	              dispatch(requestFilesSuccess(files, groupedFiles));
	              _context.next = 21;
	              break;
	
	            case 18:
	              _context.prev = 18;
	              _context.t7 = _context['catch'](2);
	
	              dispatch(requestFilesFailure(_context.t7));
	
	            case 21:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 18]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var setGroupFilter = exports.setGroupFilter = function setGroupFilter(groupFilter) {
	  return {
	    type: TYPES.SET_GROUP_FILTER,
	    groupFilter: groupFilter
	  };
	};
	
	var setPayYear = exports.setPayYear = function setPayYear(payYear, payYearOptions) {
	  return {
	    type: TYPES.SET_PAY_YEAR,
	    payYear: payYear || new Date().getFullYear(),
	    payYearOptions: payYearOptions
	  };
	};
	
	var requestPayslips = exports.requestPayslips = function requestPayslips() {
	  return {
	    type: TYPES.REQUEST_PAYSLIPS
	  };
	};
	
	var requestPayslipsSuccess = exports.requestPayslipsSuccess = function requestPayslipsSuccess(payslips) {
	  return {
	    type: TYPES.REQUEST_PAYSLIPS_SUCCESS,
	    payslips: payslips
	  };
	};
	
	var requestPayslipsFailure = exports.requestPayslipsFailure = function requestPayslipsFailure(error) {
	  return {
	    type: TYPES.REQUEST_PAYSLIPS_FAILURE,
	    error: error
	  };
	};
	
	var fetchUserPayslips = exports.fetchUserPayslips = function fetchUserPayslips() {
	  return function (dispatch, getState) {
	    dispatch(requestPayslips());
	
	    var _getState2 = getState(),
	        _getState2$loginReduc = _getState2.loginReducer.user,
	        token = _getState2$loginReduc.token,
	        EmployeeMasterID = _getState2$loginReduc.EmployeeMasterID,
	        payYear = _getState2.FileReducer.payYear;
	
	    var config = {
	      entity: 'PaySlip',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: 'Entity/EmployeeMasterID eq ' + EmployeeMasterID + ' and (Entity/PayPeriodBegda ge datetime\'' + payYear + '-01-01T00:00\') and (Entity/PayPeriodBegda le datetime\'' + payYear + '-12-31T00:00\')'
	      }
	    };
	
	    (0, _Api.listWM)(config).then(function (_ref2) {
	      var data = _ref2.data;
	      return dispatch(requestPayslipsSuccess(data));
	    }).catch(function (error) {
	      return dispatch(requestPayslipsFailure(error));
	    });
	  };
	};
	
	var initPayYear = exports.initPayYear = function initPayYear() {
	  return function (dispatch, getState) {
	    var _getState3 = getState(),
	        _getState3$loginReduc = _getState3.loginReducer.user,
	        token = _getState3$loginReduc.token,
	        EmployeeMasterID = _getState3$loginReduc.EmployeeMasterID;
	
	    var config = {
	      entity: 'PaySlip',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: 'Entity/EmployeeMasterID eq ' + EmployeeMasterID,
	        $expand: 'Entity',
	        $select: 'Entity/PayPeriodBegda'
	      }
	    };
	
	    (0, _Api.listWM)(config).then(function (payslips) {
	      var options = (0, _lodash.map)(payslips.data, function (_ref3) {
	        var PayPeriodBegda = _ref3.PayPeriodBegda;
	        return new Date(PayPeriodBegda).getFullYear();
	      });
	      var payYear = (0, _lodash.max)(options);
	      var payYearOptions = (0, _lodash.sortedUniq)(options);
	      dispatch(setPayYear(payYear, (0, _lodash.uniq)(payYearOptions)));
	      dispatch(fetchUserPayslips());
	    }).catch(function (error) {
	      return dispatch(requestPayslipsFailure(error));
	    });
	  };
	};
	
	var requestFileDownload = exports.requestFileDownload = function requestFileDownload() {
	  return {
	    type: TYPES.REQUEST_FILE_DOWNLOAD
	  };
	};
	
	var requestFileDownloadSuccess = exports.requestFileDownloadSuccess = function requestFileDownloadSuccess() {
	  return {
	    type: TYPES.REQUEST_FILE_DOWNLOAD_SUCCESS
	  };
	};
	
	var requestFileDownloadFailure = exports.requestFileDownloadFailure = function requestFileDownloadFailure(error) {
	  return {
	    type: TYPES.REQUEST_FILE_DOWNLOAD_FAILURE,
	    error: error
	  };
	};
	
	var dataURItoBlob = function dataURItoBlob(byteString, type) {
	  // write the bytes of the string to a typed array
	  var ia = new Uint8Array(byteString.length);
	  for (var i = 0; i < byteString.length; i += 1) {
	    ia[i] = byteString.charCodeAt(i);
	  }
	
	  return new Blob([ia], { type: type });
	};
	
	var download = exports.download = function download(fileObject) {
	  var docName = '' + fileObject.Name + fileObject.Extension;
	  var type = _mimeTypes2.default.lookup(docName);
	  _fileSaver2.default.saveAs(dataURItoBlob(atob(fileObject.FileSource), type), docName);
	};
	
	var downloadFile = exports.downloadFile = function downloadFile(documentId) {
	  return function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	      var getFile, data;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	
	              dispatch(requestFileDownload());
	              getFile = {
	                url: '/kjarni/api/v2/FileRepositories/' + documentId + '/GetDocument',
	                method: 'GET'
	              };
	              _context2.t0 = _lodash.get;
	              _context2.next = 6;
	              return (0, _Api.custom)(getFile);
	
	            case 6:
	              _context2.t1 = _context2.sent;
	              data = (0, _context2.t0)(_context2.t1, 'data');
	
	
	              download(data);
	
	              dispatch(requestFileDownloadSuccess());
	              _context2.next = 15;
	              break;
	
	            case 12:
	              _context2.prev = 12;
	              _context2.t2 = _context2['catch'](0);
	
	              dispatch(requestFileDownloadFailure(_context2.t2));
	
	            case 15:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 12]]);
	    }));
	
	    return function (_x3) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	};
	
	var requestFileDelete = exports.requestFileDelete = function requestFileDelete() {
	  return {
	    type: TYPES.REQUEST_FILE_DELETE
	  };
	};
	
	var requestFileDeleteSuccess = exports.requestFileDeleteSuccess = function requestFileDeleteSuccess() {
	  return {
	    type: TYPES.REQUEST_FILE_DELETE_SUCCESS
	  };
	};
	
	var requestFileDeleteFailure = exports.requestFileDeleteFailure = function requestFileDeleteFailure(error) {
	  return {
	    type: TYPES.REQUEST_FILE_DELETE_FAILURE,
	    error: error
	  };
	};
	
	var deleteFile = exports.deleteFile = function deleteFile(removeDoc) {
	  return function (dispatch, getState) {
	    dispatch(requestFileDelete());
	
	    var _getState4 = getState(),
	        token = _getState4.loginReducer.user.token;
	
	    var config = {
	      entity: 'FileRepository',
	      headers: { Authorization: 'Bearer ' + token },
	      data: removeDoc
	    };
	
	    (0, _Api.remove)(config).then(function () {
	      dispatch(requestFileDeleteSuccess());
	      dispatch(fetchUserFiles());
	    }).catch(function (error) {
	      return dispatch(requestFileDeleteFailure(error));
	    });
	  };
	};
	
	var requestFileUpload = exports.requestFileUpload = function requestFileUpload() {
	  return {
	    type: TYPES.REQUEST_FILE_UPLOAD
	  };
	};
	
	var requestFileUploadSuccess = exports.requestFileUploadSuccess = function requestFileUploadSuccess() {
	  return {
	    type: TYPES.REQUEST_FILE_UPLOAD_SUCCESS
	  };
	};
	
	var requestFileUploadFailure = exports.requestFileUploadFailure = function requestFileUploadFailure(error) {
	  return {
	    type: TYPES.REQUEST_FILE_UPLOAD_FAILURE,
	    error: error
	  };
	};
	
	var uploadFile = exports.uploadFile = function uploadFile(_ref5, idCallBack) {
	  var file = _ref5.file,
	      fileType = _ref5.fileType;
	  return function (dispatch, getState) {
	    dispatch(requestFileUpload());
	
	    var _getState5 = getState(),
	        ownerTypes = _getState5.FileReducer.ownerTypes,
	        _getState5$loginReduc = _getState5.loginReducer.user,
	        token = _getState5$loginReduc.token,
	        EmployeeMasterID = _getState5$loginReduc.EmployeeMasterID,
	        EmployeeName = _getState5.profileReducer.employeeMaster.EmployeeName;
	
	    // Encode file data
	
	
	    var ownerType = (0, _lodash.find)(ownerTypes, ['Value', 'EmployeeMaster']);
	    // If we cannot find the correct entity owner type we throw an error
	    if (ownerType === undefined || !ownerType.FileRepositoryEntityOwnerTypeID) {
	      dispatch(requestFileUploadFailure(new Error('Ekki er hægt að vista skjal á EmployeeMaster')));
	    } else if (file === undefined || !file.name) {
	      dispatch(requestFileUploadFailure(new Error('Ekki neitt skjal var valið')));
	    } else {
	      var reader = new FileReader();
	      var AddDate = new Date().toISOString();
	      reader.onload = function () {
	        var FileSource = reader.result.substring(reader.result.indexOf(',') + 1);
	        var Name = file.name.substring(0, file.name.indexOf('.'));
	        var Extension = file.name.substring(file.name.indexOf('.'));
	        var config = {
	          entity: 'FileRepository',
	          headers: { Authorization: 'Bearer ' + token },
	          data: {
	            ObjectOwner: EmployeeName,
	            EntityType: ownerType.FileRepositoryEntityOwnerTypeID,
	            Entity_ID: EmployeeMasterID,
	            FileSource: FileSource,
	            ObjectDocumentType: fileType,
	            Name: Name,
	            Extension: Extension,
	            AddDate: AddDate
	          }
	        };
	
	        return (0, _Api.create)(config).then(function (createResult) {
	          dispatch(requestFileUploadSuccess());
	          if (idCallBack) {
	            idCallBack(createResult.data);
	          } else {
	            dispatch((0, _reduxForm.reset)('fileUpload'));
	            dispatch(fetchUserFiles());
	          }
	        }).catch(function (error) {
	          return dispatch(requestFileUploadFailure(error));
	        });
	      };
	      reader.onerror = function (e) {
	        return dispatch(requestFileUploadFailure(e));
	      };
	      reader.readAsDataURL(file);
	    }
	  };
	};
	
	var uploadFiles = exports.uploadFiles = function uploadFiles(_ref6, idCallBack) {
	  var files = _ref6.files,
	      fileType = _ref6.fileType;
	  return function (dispatch) {
	    Array.from(files).forEach(function (file) {
	      dispatch(uploadFile({ file: file, fileType: fileType }, function () {
	        idCallBack();
	      }));
	    });
	  };
	};
	
	var initFileUpload = exports.initFileUpload = function initFileUpload() {
	  return {
	    type: TYPES.INIT_FILE_UPLOAD
	  };
	};
	
	var initFileUploadSuccess = exports.initFileUploadSuccess = function initFileUploadSuccess(_ref7) {
	  var ownerTypes = _ref7.ownerTypes,
	      documentTypes = _ref7.documentTypes;
	  return {
	    type: TYPES.INIT_FILE_UPLOAD_SUCCESS,
	    ownerTypes: ownerTypes,
	    documentTypes: documentTypes
	  };
	};
	
	var initFileUploadFailure = exports.initFileUploadFailure = function initFileUploadFailure(error) {
	  return {
	    type: TYPES.INIT_FILE_UPLOAD_FAILURE,
	    error: error
	  };
	};
	
	var initUpload = exports.initUpload = function initUpload() {
	  return function (dispatch, getState) {
	    dispatch(initFileUpload());
	
	    var _getState6 = getState(),
	        token = _getState6.loginReducer.user.token;
	
	    var ownerTypeConfig = {
	      entity: 'FileRepositoryEntityOwnerType',
	      headers: { Authorization: 'Bearer ' + token }
	    };
	    var documentTypeConfig = {
	      entity: 'FileRepositoryObjectDocumentType',
	      headers: { Authorization: 'Bearer ' + token }
	    };
	
	    (0, _Api.list)(ownerTypeConfig).then(function (oT) {
	      return (0, _Api.list)(documentTypeConfig).then(function (dT) {
	        dispatch(initFileUploadSuccess({
	          ownerTypes: oT.data, documentTypes: (0, _lodash.orderBy)(dT.data, 'Name')
	        }));
	        dispatch(fetchUserFiles());
	      }).catch(function (error) {
	        return dispatch(initFileUploadFailure(error));
	      });
	    }).catch(function (error) {
	      return dispatch(initFileUploadFailure(error));
	    });
	  };
	};
	
	var requestFileById = exports.requestFileById = function requestFileById() {
	  return {
	    type: TYPES.REQUEST_FILE_BY_ID,
	    fileById: {},
	    fileLoaded: false,
	    sentAt: Date.now(),
	    error: null
	  };
	};
	
	var requestFileByIdSuccess = exports.requestFileByIdSuccess = function requestFileByIdSuccess(fileById) {
	  return {
	    type: TYPES.REQUEST_FILE_BY_ID_SUCCESS,
	    fileById: fileById,
	    loaded: true,
	    receivedAt: Date.now(),
	    error: null
	  };
	};
	
	var requestFileByIdFailure = exports.requestFileByIdFailure = function requestFileByIdFailure(error) {
	  return {
	    type: TYPES.REQUEST_FILE_BY_ID_FAILURE,
	    fileById: {},
	    loaded: true,
	    receivedAt: Date.now(),
	    error: error
	  };
	};
	
	var getFileById = exports.getFileById = function getFileById(documentId) {
	  return function () {
	    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	      var getFile, data;
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	
	              dispatch(requestFileById());
	              getFile = {
	                url: '/kjarni/api/v2/FileRepositories/' + documentId + '/GetDocument',
	                method: 'GET'
	              };
	              _context3.t0 = _lodash.get;
	              _context3.next = 6;
	              return (0, _Api.custom)(getFile);
	
	            case 6:
	              _context3.t1 = _context3.sent;
	              data = (0, _context3.t0)(_context3.t1, 'data');
	
	
	              dispatch(requestFileByIdSuccess(data));
	              _context3.next = 14;
	              break;
	
	            case 11:
	              _context3.prev = 11;
	              _context3.t2 = _context3['catch'](0);
	
	              dispatch(requestFileByIdFailure(_context3.t2));
	
	            case 14:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[0, 11]]);
	    }));
	
	    return function (_x4) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestFiles, 'requestFiles', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFilesSuccess, 'requestFilesSuccess', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFilesFailure, 'requestFilesFailure', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(fetchUserFiles, 'fetchUserFiles', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(setGroupFilter, 'setGroupFilter', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(setPayYear, 'setPayYear', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestPayslips, 'requestPayslips', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestPayslipsSuccess, 'requestPayslipsSuccess', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestPayslipsFailure, 'requestPayslipsFailure', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(fetchUserPayslips, 'fetchUserPayslips', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(initPayYear, 'initPayYear', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFileDownload, 'requestFileDownload', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFileDownloadSuccess, 'requestFileDownloadSuccess', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFileDownloadFailure, 'requestFileDownloadFailure', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(dataURItoBlob, 'dataURItoBlob', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(download, 'download', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(downloadFile, 'downloadFile', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFileDelete, 'requestFileDelete', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFileDeleteSuccess, 'requestFileDeleteSuccess', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFileDeleteFailure, 'requestFileDeleteFailure', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(deleteFile, 'deleteFile', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFileUpload, 'requestFileUpload', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFileUploadSuccess, 'requestFileUploadSuccess', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFileUploadFailure, 'requestFileUploadFailure', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(uploadFile, 'uploadFile', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(uploadFiles, 'uploadFiles', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(initFileUpload, 'initFileUpload', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(initFileUploadSuccess, 'initFileUploadSuccess', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(initFileUploadFailure, 'initFileUploadFailure', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(initUpload, 'initUpload', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFileById, 'requestFileById', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFileByIdSuccess, 'requestFileByIdSuccess', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(requestFileByIdFailure, 'requestFileByIdFailure', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	
	  __REACT_HOT_LOADER__.register(getFileById, 'getFileById', 'D:/a/1/s/src/web/employee/src/actions/Files.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchEmployeeDetailOrg = exports.fetchEmployeeMaster = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchProfileIfNeeded = fetchProfileIfNeeded;
	exports.fetchOrgsIfNeeded = fetchOrgsIfNeeded;
	exports.patchIdentificationCard = patchIdentificationCard;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(8);
	
	var _Api = __webpack_require__(21);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _reapop = __webpack_require__(44);
	
	var _reactIntl = __webpack_require__(5);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/* EMPLOYEE MASTER */
	
	function requestEmployeeMaster() {
	  return {
	    type: types.REQUEST_EMPLOYEE_MASTER,
	    employeeMaster: {},
	    employeeMasterLoaded: false,
	    sentAt: Date.now(),
	    masterError: null
	  };
	}
	
	function requestEmployeeMasterFailure(error) {
	  return {
	    type: types.REQUEST_EMPLOYEE_MASTER_FAILURE,
	    employeeMaster: {},
	    employeeMasterLoaded: true,
	    receivedAt: Date.now(),
	    masterError: error
	  };
	}
	
	function requestEmployeeMasterSuccess(employeeMaster) {
	  return {
	    type: types.REQUEST_EMPLOYEE_MASTER_SUCCESS,
	    employeeMasterLoaded: true,
	    receivedAt: Date.now(),
	    employeeMaster: employeeMaster,
	    masterError: null
	  };
	}
	
	var fetchEmployeeMaster = exports.fetchEmployeeMaster = function fetchEmployeeMaster() {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, _getState$loginReduce, EmployeeMasterID, DefaultEmployeeDetailID, token, config, configApi2, _ref2, data, _ref3, _ref3$data, IdentificationCard, EmployeeDetailID;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              dispatch(requestEmployeeMaster());
	              _getState = getState(), _getState$loginReduce = _getState.loginReducer.user, EmployeeMasterID = _getState$loginReduce.EmployeeMasterID, DefaultEmployeeDetailID = _getState$loginReduce.DefaultEmployeeDetailID, token = _getState$loginReduce.token;
	              config = {
	                entity: 'EmployeeMaster',
	                entityID: EmployeeMasterID,
	                headers: { Authorization: 'Bearer ' + token }
	              };
	              configApi2 = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: '/kjarni/api/v2/EmployeeDetails/' + DefaultEmployeeDetailID
	              };
	              _context.next = 7;
	              return (0, _Api.readWM)(config);
	
	            case 7:
	              _ref2 = _context.sent;
	              data = _ref2.data;
	              _context.next = 11;
	              return (0, _Api.custom)(configApi2);
	
	            case 11:
	              _ref3 = _context.sent;
	              _ref3$data = _ref3.data;
	              IdentificationCard = _ref3$data.IdentificationCard;
	              EmployeeDetailID = _ref3$data.EmployeeDetailID;
	
	              dispatch(requestEmployeeMasterSuccess(_extends({}, data, { IdentificationCard: IdentificationCard, EmployeeDetailID: EmployeeDetailID })));
	              _context.next = 21;
	              break;
	
	            case 18:
	              _context.prev = 18;
	              _context.t0 = _context['catch'](0);
	
	              dispatch(requestEmployeeMasterFailure(_context.t0));
	
	            case 21:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 18]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	/* EMPLOYEE DETAIL ORG */
	
	function requestEmployeeDetailOrg() {
	  return {
	    type: types.REQUEST_EMPLOYEE_DETAIL_ORG,
	    employeeDetailOrgList: [],
	    employeeDetailOrgListLoaded: false,
	    sentAt: Date.now(),
	    detailError: null
	  };
	}
	
	function requestEmployeeDetailOrgFailure(error) {
	  return {
	    type: types.REQUEST_EMPLOYEE_DETAIL_ORG_FAILURE,
	    employeeDetailOrgList: [],
	    employeeDetailOrgListLoaded: true,
	    receivedAt: Date.now(),
	    detailError: error
	  };
	}
	
	function requestEmployeeDetailOrgSuccess(employeeDetailOrgList) {
	  return {
	    type: types.REQUEST_EMPLOYEE_DETAIL_ORG_SUCCESS,
	    employeeDetailOrgListLoaded: true,
	    receivedAt: Date.now(),
	    employeeDetailOrgList: employeeDetailOrgList,
	    detailError: null
	  };
	}
	
	var fetchEmployeeDetailOrg = exports.fetchEmployeeDetailOrg = function fetchEmployeeDetailOrg() {
	  return function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	      var _getState2, _getState2$loginReduc, EmployeeMasterID, token, now, fetchConfig;
	
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              // return (dispatch, getState) => {
	              dispatch(requestEmployeeDetailOrg());
	              _getState2 = getState(), _getState2$loginReduc = _getState2.loginReducer.user, EmployeeMasterID = _getState2$loginReduc.EmployeeMasterID, token = _getState2$loginReduc.token;
	              now = new Date().toISOString();
	              fetchConfig = {
	                entity: 'EmployeeDetailOrg',
	                headers: { Authorization: 'Bearer ' + token },
	                params: {
	                  $filter: 'Entity/EmployeeDetailID ge ' + EmployeeMasterID + '1 and Entity/EmployeeDetailID le ' + EmployeeMasterID + '9 and (Entity/EmployeeStatus eq \'0\' or (Entity/EmployeeStatus ge \'4\'  and Entity/EmployeeStatus le \'7\')) and Entity/Begda le datetime\'' + now + '\' and Entity/Endda ge datetime\'' + now + '\''
	                }
	              };
	
	
	              (0, _Api.listWM)(fetchConfig).then(function (_ref5) {
	                var data = _ref5.data;
	                return dispatch(requestEmployeeDetailOrgSuccess(data));
	              }).catch(function (error) {
	                return dispatch(requestEmployeeDetailOrgFailure(error));
	              });
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x3, _x4) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	};
	// }
	
	function fetchProfileIfNeeded() {
	  return function (dispatch, getState) {
	    if ((0, _lodash.isEmpty)(getState().profileReducer.employeeMaster)) {
	      dispatch(fetchEmployeeMaster());
	    }
	    var orgs = getState().profileReducer.employeeDetailOrgList;
	    if (!orgs || !orgs.length) {
	      dispatch(fetchEmployeeDetailOrg());
	    }
	  };
	}
	
	function fetchOrgsIfNeeded() {
	  return function (dispatch, getState) {
	    var orgs = getState().profileReducer.employeeDetailOrgList;
	    if (!orgs || !orgs.length) {
	      dispatch(fetchEmployeeDetailOrg());
	    }
	  };
	}
	
	/* EMPLOYEE DETAILS */
	
	function patchRequest() {
	  return {
	    type: types.PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_REQUEST,
	    sentAt: Date.now()
	  };
	}
	
	function patchSuccess(entry, entryId) {
	  return {
	    type: types.PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_SUCCESS,
	    receivedAt: Date.now(),
	    entry: entry,
	    entryId: entryId
	  };
	}
	
	function patchFailure(error) {
	  return {
	    type: types.PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_FAILURE,
	    receivedAt: Date.now(),
	    error: error
	  };
	}
	
	function patchIdentificationCard(entry, entryId) {
	  var _this = this;
	
	  return function () {
	    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	      var res, data;
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	
	              dispatch(patchRequest());
	              _context3.next = 4;
	              return (0, _Api.custom)({
	                url: '/kjarni/api/v2/EmployeeDetails(' + entryId + ')',
	                method: 'PATCH',
	                data: entry
	              });
	
	            case 4:
	              res = _context3.sent;
	              data = (0, _lodash.get)(res, 'data', {});
	
	              dispatch(patchSuccess(data, entryId));
	
	              _context3.next = 13;
	              break;
	
	            case 9:
	              _context3.prev = 9;
	              _context3.t0 = _context3['catch'](0);
	
	              dispatch(patchFailure(_context3.t0));
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.error.title' }),
	                message: (0, _lodash.get)(_context3.t0, 'message'),
	                status: 'error',
	                dismissible: true,
	                dismissAfter: 3000
	              }));
	
	            case 13:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, _this, [[0, 9]]);
	    }));
	
	    return function (_x5) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestEmployeeMaster, 'requestEmployeeMaster', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeMasterFailure, 'requestEmployeeMasterFailure', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeMasterSuccess, 'requestEmployeeMasterSuccess', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(fetchEmployeeMaster, 'fetchEmployeeMaster', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeDetailOrg, 'requestEmployeeDetailOrg', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeDetailOrgFailure, 'requestEmployeeDetailOrgFailure', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeDetailOrgSuccess, 'requestEmployeeDetailOrgSuccess', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(fetchEmployeeDetailOrg, 'fetchEmployeeDetailOrg', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(fetchProfileIfNeeded, 'fetchProfileIfNeeded', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(fetchOrgsIfNeeded, 'fetchOrgsIfNeeded', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(patchRequest, 'patchRequest', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(patchSuccess, 'patchSuccess', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(patchFailure, 'patchFailure', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	
	  __REACT_HOT_LOADER__.register(patchIdentificationCard, 'patchIdentificationCard', 'D:/a/1/s/src/web/employee/src/actions/profile.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 119 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _default = {
	  subheader: {
	    fontSize: 20,
	    fontWeight: 300,
	    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	    paddingLeft: 8,
	    paddingRight: 8,
	    marginTop: 8
	  },
	  content: {
	    maxWidth: 600,
	    marginLeft: 'auto',
	    marginRight: 'auto'
	  },
	  loading: {
	    padding: 16,
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    marginBottom: 16
	  },
	  label: {
	    color: 'rgba(0, 0, 0, 0.3)',
	    fontSize: '12px'
	  },
	  buttonStyle: {
	    background: 'transparent',
	    border: 'none',
	    padding: '8px',
	    marginLeft: '16px',
	    cursor: 'pointer'
	  },
	  row: {
	    alignItems: 'flex-start',
	    display: 'flex',
	    flexWrap: 'wrap',
	    justifyContent: 'flex-start',
	    padding: '16px 24px'
	  },
	  alignRight: {
	    textAlign: 'right'
	  },
	  col1: {
	    width: '15%'
	  },
	  col2: {
	    width: '40%'
	  },
	  col3: {
	    width: '20%'
	  },
	  col4: {
	    width: '15%'
	  }
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pay/styles/Cards.js');
	}();

	;

/***/ }),
/* 120 */
[1855, 152],
/* 121 */
69,
/* 122 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(77);
	var call = __webpack_require__(489);
	var isArrayIter = __webpack_require__(321);
	var anObject = __webpack_require__(22);
	var toLength = __webpack_require__(34);
	var getIterFn = __webpack_require__(337);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 124 */
[1875, 22, 495, 317, 330, 316, 319],
/* 125 */
[1880, 497, 317],
/* 126 */
[1883, 497, 317],
/* 127 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(61);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(25);
	var dP = __webpack_require__(42);
	var DESCRIPTORS = __webpack_require__(36);
	var SPECIES = __webpack_require__(31)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 130 */
[1890, 79],
/* 131 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(28);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function(useSourceMap) {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			return this.map(function (item) {
				var content = cssWithMappingToString(item, useSourceMap);
				if(item[2]) {
					return "@media " + item[2] + "{" + content + "}";
				} else {
					return content;
				}
			}).join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};
	
	function cssWithMappingToString(item, useSourceMap) {
		var content = item[1] || '';
		var cssMapping = item[3];
		if (!cssMapping) {
			return content;
		}
	
		if (useSourceMap) {
			var sourceMapping = toComment(cssMapping);
			var sourceURLs = cssMapping.sources.map(function (source) {
				return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
			});
	
			return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
		}
	
		return [content].join('\n');
	}
	
	// Adapted from convert-source-map (MIT)
	function toComment(sourceMap) {
	  var base64 = new Buffer(JSON.stringify(sourceMap)).toString('base64');
	  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;
	
	  return '/*# ' + data + ' */';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(297).Buffer))

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(162),
	    getRawTag = __webpack_require__(1447),
	    objectToString = __webpack_require__(1477);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(1405),
	    getValue = __webpack_require__(1448);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(167);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  set: function set(style, key, value) {
	    style[key] = value;
	  }
	};

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = exports.ReactReduxContext = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var ReactReduxContext = /*#__PURE__*/_react["default"].createContext(null);
	
	exports.ReactReduxContext = ReactReduxContext;
	
	if (false) {
	  ReactReduxContext.displayName = 'ReactRedux';
	}
	
	var _default = ReactReduxContext;
	exports["default"] = _default;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(1317);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _reactIs = __webpack_require__(212);
	
	var validateComponentProp = function validateComponentProp(props, propName, componentName) {
	  if (!(0, _reactIs.isValidElementType)(props[propName])) {
	    return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`.');
	  }
	
	  return null;
	};
	
	var _default = validateComponentProp;
	exports["default"] = _default;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	
	var stylesInDom = {};
	
	var	memoize = function (fn) {
		var memo;
	
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	};
	
	var isOldIE = memoize(function () {
		// Test for IE <= 9 as proposed by Browserhacks
		// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
		// Tests for existence of standard globals is to allow style-loader
		// to operate correctly into non-standard environments
		// @see https://github.com/webpack-contrib/style-loader/issues/177
		return window && document && document.all && !window.atob;
	});
	
	var getElement = (function (fn) {
		var memo = {};
	
		return function(selector) {
			if (typeof memo[selector] === "undefined") {
				var styleTarget = fn.call(this, selector);
				// Special case to return head of iframe instead of iframe itself
				if (styleTarget instanceof window.HTMLIFrameElement) {
					try {
						// This will throw an exception if access to iframe is blocked
						// due to cross-origin restrictions
						styleTarget = styleTarget.contentDocument.head;
					} catch(e) {
						styleTarget = null;
					}
				}
				memo[selector] = styleTarget;
			}
			return memo[selector]
		};
	})(function (target) {
		return document.querySelector(target)
	});
	
	var singleton = null;
	var	singletonCounter = 0;
	var	stylesInsertedAtTop = [];
	
	var	fixUrls = __webpack_require__(1838);
	
	module.exports = function(list, options) {
		if (true) {
			if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
	
		options.attrs = typeof options.attrs === "object" ? options.attrs : {};
	
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();
	
		// By default, add <style> tags to the <head> element
		if (!options.insertInto) options.insertInto = "head";
	
		// By default, add <style> tags to the bottom of the target
		if (!options.insertAt) options.insertAt = "bottom";
	
		var styles = listToStyles(list, options);
	
		addStylesToDom(styles, options);
	
		return function update (newList) {
			var mayRemove = [];
	
			for (var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
	
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
	
			if(newList) {
				var newStyles = listToStyles(newList, options);
				addStylesToDom(newStyles, options);
			}
	
			for (var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
	
				if(domStyle.refs === 0) {
					for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
	
					delete stylesInDom[domStyle.id];
				}
			}
		};
	};
	
	function addStylesToDom (styles, options) {
		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
	
			if(domStyle) {
				domStyle.refs++;
	
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
	
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
	
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
	
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles (list, options) {
		var styles = [];
		var newStyles = {};
	
		for (var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = options.base ? item[0] + options.base : item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
	
			if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
			else newStyles[id].parts.push(part);
		}
	
		return styles;
	}
	
	function insertStyleElement (options, style) {
		var target = getElement(options.insertInto)
	
		if (!target) {
			throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
		}
	
		var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];
	
		if (options.insertAt === "top") {
			if (!lastStyleElementInsertedAtTop) {
				target.insertBefore(style, target.firstChild);
			} else if (lastStyleElementInsertedAtTop.nextSibling) {
				target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				target.appendChild(style);
			}
			stylesInsertedAtTop.push(style);
		} else if (options.insertAt === "bottom") {
			target.appendChild(style);
		} else if (typeof options.insertAt === "object" && options.insertAt.before) {
			var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
			target.insertBefore(style, nextSibling);
		} else {
			throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
		}
	}
	
	function removeStyleElement (style) {
		if (style.parentNode === null) return false;
		style.parentNode.removeChild(style);
	
		var idx = stylesInsertedAtTop.indexOf(style);
		if(idx >= 0) {
			stylesInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement (options) {
		var style = document.createElement("style");
	
		options.attrs.type = "text/css";
	
		addAttrs(style, options.attrs);
		insertStyleElement(options, style);
	
		return style;
	}
	
	function createLinkElement (options) {
		var link = document.createElement("link");
	
		options.attrs.type = "text/css";
		options.attrs.rel = "stylesheet";
	
		addAttrs(link, options.attrs);
		insertStyleElement(options, link);
	
		return link;
	}
	
	function addAttrs (el, attrs) {
		Object.keys(attrs).forEach(function (key) {
			el.setAttribute(key, attrs[key]);
		});
	}
	
	function addStyle (obj, options) {
		var style, update, remove, result;
	
		// If a transform function was defined, run it on the css
		if (options.transform && obj.css) {
		    result = options.transform(obj.css);
	
		    if (result) {
		    	// If transform returns a value, use that instead of the original css.
		    	// This allows running runtime transformations on the css.
		    	obj.css = result;
		    } else {
		    	// If the transform function returns a falsy value, don't add this css.
		    	// This allows conditional loading of css
		    	return function() {
		    		// noop
		    	};
		    }
		}
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
	
			style = singleton || (singleton = createStyleElement(options));
	
			update = applyToSingletonTag.bind(null, style, styleIndex, false);
			remove = applyToSingletonTag.bind(null, style, styleIndex, true);
	
		} else if (
			obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function"
		) {
			style = createLinkElement(options);
			update = updateLink.bind(null, style, options);
			remove = function () {
				removeStyleElement(style);
	
				if(style.href) URL.revokeObjectURL(style.href);
			};
		} else {
			style = createStyleElement(options);
			update = applyToTag.bind(null, style);
			remove = function () {
				removeStyleElement(style);
			};
		}
	
		update(obj);
	
		return function updateStyle (newObj) {
			if (newObj) {
				if (
					newObj.css === obj.css &&
					newObj.media === obj.media &&
					newObj.sourceMap === obj.sourceMap
				) {
					return;
				}
	
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
	
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag (style, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (style.styleSheet) {
			style.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = style.childNodes;
	
			if (childNodes[index]) style.removeChild(childNodes[index]);
	
			if (childNodes.length) {
				style.insertBefore(cssNode, childNodes[index]);
			} else {
				style.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag (style, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			style.setAttribute("media", media)
		}
	
		if(style.styleSheet) {
			style.styleSheet.cssText = css;
		} else {
			while(style.firstChild) {
				style.removeChild(style.firstChild);
			}
	
			style.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink (link, options, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		/*
			If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
			and there is no publicPath defined then lets turn convertToAbsoluteUrls
			on by default.  Otherwise default to the convertToAbsoluteUrls option
			directly
		*/
		var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;
	
		if (options.convertToAbsoluteUrls || autoFixUrls) {
			css = fixUrls(css);
		}
	
		if (sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = link.href;
	
		link.href = URL.createObjectURL(blob);
	
		if(oldSrc) URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 143 */
/***/ (function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  Object.defineProperty(Constructor, "prototype", {
	    writable: false
	  });
	  return Constructor;
	}
	
	module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint global-require: 0 */
	
	
	exports.loginStep = loginStep;
	exports.loginValidationErrors = loginValidationErrors;
	exports.ssoCheckStart = ssoCheckStart;
	exports.ssoCheckEnd = ssoCheckEnd;
	exports.loginUser = loginUser;
	exports.twoFactorLogin = twoFactorLogin;
	exports.sso = sso;
	exports.notAuthenticated = notAuthenticated;
	exports.authenticated = authenticated;
	
	var _reactRouter = __webpack_require__(401);
	
	var _config = __webpack_require__(54);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _axios = __webpack_require__(179);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(8);
	
	var _Api = __webpack_require__(21);
	
	var _profile = __webpack_require__(118);
	
	var _Api2 = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function loginRequest(credentials) {
	  return {
	    type: types.LOGIN_REQUEST,
	    credentials: credentials
	  };
	}
	
	function loginFailure(error) {
	  return {
	    type: types.LOGIN_FAILURE,
	    error: error
	  };
	}
	
	function loginSuccess(user) {
	
	  return {
	    type: types.LOGIN_SUCCESS,
	    user: user
	  };
	}
	function setSecurityCode(securityCode) {
	  return {
	    type: types.SET_SECURITY_CODE,
	    securityCode: securityCode
	  };
	}
	
	function loginStep(step) {
	  return {
	    type: types.LOGIN_STEP,
	    step: step
	  };
	}
	
	function loginValidationErrors(validationError) {
	  return {
	    type: types.LOGIN_VALIDATION_ERRORS,
	    validationError: validationError
	  };
	}
	
	function ssoCheckStart() {
	  return {
	    type: types.SSO_CHECK_START
	  };
	}
	
	function ssoCheckEnd(_ref) {
	  var error = _ref.error,
	      data = _ref.data;
	
	  return {
	    type: types.SSO_CHECK_END,
	    error: error,
	    data: data
	  };
	}
	
	function fetchEmployeeMasterID(user, ssoCheck) {
	  return function (dispatch, getState) {
	    var fetchConfig = {
	      url: '/kjarni/api/v2/EmployeeXapUsers/MyUserInfo'
	    };
	
	    (0, _Api2.custom)(fetchConfig).then(function (data) {
	      var e = (0, _lodash.get)(data, 'data');
	      if (!e || !e.EmployeeMasterID) {
	        dispatch(loginFailure({ Message: 'Kjarna notandi ekki rétt tengdur' }));
	      } else {
	        (0, _Api.read)({
	          entity: 'EmployeeMaster',
	          entityID: e.EmployeeMasterID,
	          headers: { Authorization: 'Bearer ' + user.token }
	        }).then(function (empMaster) {
	          var Gender = '' + empMaster.data.GenderType;
	          localStorage.EmployeeMasterID = e.EmployeeMasterID;
	          localStorage.DefaultEmployeeDetailID = empMaster.data.DefaultEmployeeDetailID;
	          localStorage.EmployeeName = e.EmployeeName;
	          localStorage.Email = e.EmailWork || e.Email;
	          localStorage.Gender = Gender;
	          dispatch(loginSuccess(_extends({}, user, e, {
	            UserName: e.XapUserName,
	            EmployeeMasterID: e.EmployeeMasterID,
	            Gender: Gender,
	            DefaultEmployeeDetailID: empMaster.data.DefaultEmployeeDetailID
	          })));
	          dispatch((0, _profile.fetchOrgsIfNeeded)());
	          ssoCheck && dispatch(ssoCheckEnd({ data: user }));
	          /* Route the user to the page he tried to access before logging in */
	          if (!_config.useSSO) {
	            var _getState = getState(),
	                state = _getState.routing.locationBeforeTransitions.state;
	
	            var loginRoute = state && state.nextPathname ? state.nextPathname : '/';
	            _reactRouter.browserHistory.replace(loginRoute);
	          }
	        }).catch(function (error) {
	          return dispatch(loginFailure(_extends({}, error, { Message: error.message })));
	        });
	      }
	    }).catch(function (error) {
	      return dispatch(loginFailure(_extends({}, error, { Message: error.message, myUserInfo: true })));
	    });
	  };
	}
	
	function loginUser(username, password) {
	  if (!username) {
	    var error = { Message: 'Vinsamlegast skráið notandanafn' };
	    return function (dispatch) {
	      return dispatch(loginValidationErrors(error));
	    };
	  }
	  if (!password) {
	    var _error = { Message: 'Vinsamlegast skráið lykilorð' };
	    return function (dispatch) {
	      return dispatch(loginValidationErrors(_error));
	    };
	  }
	
	  var config = {
	    method: 'POST',
	    url: _config.apiUrl + '/Token',
	    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	    data: 'grant_type=password&username=' + username + '&password=' + password
	  };
	
	  return function (dispatch) {
	
	    dispatch(loginRequest({ username: username, password: password }));
	    return (0, _axios2.default)(config).then(function (_ref2) {
	      var data = _ref2.data;
	
	      localStorage.token = data.access_token;
	      localStorage.refreshToken = data.refresh_token;
	      localStorage.userName = data.userName;
	      localStorage.sso = false;
	      localStorage.expires = Date.now() + 1000 * data.expires_in;
	
	      var user = {
	        userName: data.userName,
	        token: data.access_token
	      };
	
	      dispatch(fetchEmployeeMasterID(user));
	    }).catch(function (error) {
	      if (error.response) {
	        dispatch(loginFailure({ Message: error.response.data.error_description || error.response.data.error_description }));
	      } else {
	        dispatch(loginFailure({ Message: 'Failed to connect to server.' }));
	      }
	    });
	  };
	}
	
	function twoFactorLogin(value) {
	  var _this = this;
	
	  var app = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  if (app && value.length !== 10) {
	    var error = { Message: 'auth.error.ssn.length' };
	    return function (dispatch) {
	      return dispatch(loginValidationErrors(error));
	    };
	  } else if (!app && value.length !== 7) {
	    var _error2 = { Message: 'auth.error.mobile.length' };
	    return function (dispatch) {
	      return dispatch(loginValidationErrors(_error2));
	    };
	  }
	  var url = app ? _config.apiUrl + '/api/Account/SsnLogin?provider=inngangur&identifier=' + value : _config.apiUrl + '/api/Account/MobileLogin?provider=inngangur&identifier=' + value;
	  var twoFactorAuthConfig = {
	    method: 'GET',
	    url: url,
	    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
	  };
	  return function (dispatch) {
	    dispatch(loginRequest({ value: value }));
	    (0, _axios2.default)(twoFactorAuthConfig).then(function () {
	      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(result) {
	        var _get, verificationCode, authId, twoFactorTokenConfig, _ref4, data, user;
	
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _get = (0, _lodash.get)(result, 'data'), verificationCode = _get.verificationCode, authId = _get.authId;
	
	                dispatch(setSecurityCode(verificationCode));
	                twoFactorTokenConfig = {
	                  method: 'POST',
	                  url: _config.apiUrl + '/Token',
	                  headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	                  data: 'auth_id=' + authId + '&grant_type=inngangur'
	                };
	                _context.prev = 3;
	                _context.next = 6;
	                return (0, _axios2.default)(twoFactorTokenConfig);
	
	              case 6:
	                _ref4 = _context.sent;
	                data = _ref4.data;
	
	                localStorage.token = data.access_token;
	                localStorage.refreshToken = data.refresh_token;
	                localStorage.userName = data.userName;
	                localStorage.sso = false;
	                localStorage.expires = Date.now() + 1000 * data.expires_in;
	
	                user = {
	                  userName: data.userName,
	                  token: data.access_token
	                };
	
	
	                dispatch(fetchEmployeeMasterID(user));
	                _context.next = 20;
	                break;
	
	              case 17:
	                _context.prev = 17;
	                _context.t0 = _context['catch'](3);
	
	                if (_context.t0.response) {
	                  dispatch(loginFailure({ Message: _context.t0.response.data.error_description || _context.t0.response.data.error_description }));
	                } else {
	                  dispatch(loginFailure({ Message: 'Failed to connect to server.' }));
	                }
	
	              case 20:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[3, 17]]);
	      }));
	
	      return function (_x2) {
	        return _ref3.apply(this, arguments);
	      };
	    }()).catch(function (error) {
	      if (error.response) {
	        dispatch(loginFailure({ Message: error.response.data.error_description || error.response.data.error_description }));
	      } else {
	        dispatch(loginFailure({ Message: 'Failed to connect to server.' }));
	      }
	    });
	  };
	}
	
	function sso() {
	  return function (dispatch) {
	    dispatch(ssoCheckStart());
	    var config = {
	      url: _config.apiUrl + '/api/qdata/PrincipalUser'
	    };
	    (0, _Api2.custom)(config).then(function (res) {
	      var userName = res.data;
	      localStorage.userName = userName;
	      localStorage.sso = true;
	      dispatch(fetchEmployeeMasterID({ userName: userName, sso: true }, true));
	    }).catch(function (error) {
	      dispatch(ssoCheckEnd({ error: error }));
	      dispatch(loginStep('sso'));
	    });
	  };
	}
	
	function notAuthenticated() {
	  return {
	    type: types.NOT_AUTHENTICATED
	  };
	}
	
	function authenticated(user) {
	  return {
	    type: types.AUTHENTICATED,
	    user: user
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(loginRequest, 'loginRequest', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(loginFailure, 'loginFailure', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(loginSuccess, 'loginSuccess', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(setSecurityCode, 'setSecurityCode', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(loginStep, 'loginStep', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(loginValidationErrors, 'loginValidationErrors', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(ssoCheckStart, 'ssoCheckStart', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(ssoCheckEnd, 'ssoCheckEnd', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(fetchEmployeeMasterID, 'fetchEmployeeMasterID', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(loginUser, 'loginUser', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(twoFactorLogin, 'twoFactorLogin', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(sso, 'sso', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(notAuthenticated, 'notAuthenticated', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	
	  __REACT_HOT_LOADER__.register(authenticated, 'authenticated', 'D:/a/1/s/src/web/employee/src/actions/account/login.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Dialog = __webpack_require__(171);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(82);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _reactIntl = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Alert = function Alert(_ref) {
	  var text = _ref.text,
	      open = _ref.open,
	      onOk = _ref.onOk,
	      okText = _ref.okText,
	      onCancel = _ref.onCancel,
	      cancelText = _ref.cancelText;
	  return _react2.default.createElement(
	    _Dialog2.default,
	    {
	      open: open,
	      actions: [_react2.default.createElement(_FlatButton2.default, {
	        label: cancelText,
	        secondary: true,
	        onClick: onCancel
	      }), _react2.default.createElement(_FlatButton2.default, {
	        'data-cy': 'button-ok',
	        label: okText,
	        primary: true,
	        onClick: onOk
	      })]
	    },
	    text
	  );
	};
	
	Alert.propTypes = {
	  text: _propTypes2.default.node,
	  open: _propTypes2.default.bool,
	  onOk: _propTypes2.default.func,
	  okText: _propTypes2.default.node,
	  onCancel: _propTypes2.default.func,
	  cancelText: _propTypes2.default.node
	};
	
	Alert.defaultProps = {
	  okText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'alert.ok' }),
	  cancelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'alert.cancel' })
	};
	
	var _default = Alert;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Alert, 'Alert', 'D:/a/1/s/src/web/employee/src/components/Alert.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/Alert.js');
	}();

	;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _materialUi = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = {
	  container: {
	    margin: '6px 12px',
	    height: 48,
	    flex: '1 0 auto',
	    display: 'flex'
	  },
	  button: {
	    outline: 'none',
	    border: 'none',
	    fontWeight: 500,
	    height: '100%',
	    width: '100%',
	    paddingLeft: 24,
	    paddingRight: 24,
	    fontSize: 16,
	    cursor: 'pointer',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  icon: {
	    marginRight: 4,
	    color: 'inherit'
	  },
	  default: {
	    textDecoration: 'none',
	    borderRadius: 4,
	    backgroundColor: _colors2.default.mainButton,
	    color: 'white'
	  },
	  flat: {
	    backgroundColor: 'transparent',
	    textDecoration: 'underline',
	    color: _colors2.default.titleColor
	  },
	  disabled: {
	    cursor: 'auto',
	    opacity: 0.2
	  }
	};
	
	var KButton = function KButton(_ref) {
	  var onClick = _ref.onClick,
	      label = _ref.label,
	      flat = _ref.flat,
	      containerStyle = _ref.containerStyle,
	      buttonStyle = _ref.buttonStyle,
	      iconName = _ref.iconName,
	      disabled = _ref.disabled,
	      rest = _objectWithoutProperties(_ref, ['onClick', 'label', 'flat', 'containerStyle', 'buttonStyle', 'iconName', 'disabled']);
	
	  var icon = _react2.default.createElement(
	    _materialUi.FontIcon,
	    { style: styles.icon, className: 'material-icons' },
	    iconName
	  );
	
	  var button = _react2.default.createElement(
	    'button',
	    _extends({}, rest, { disabled: disabled, style: _extends({}, styles.button, styles.default, buttonStyle), onClick: onClick }),
	    iconName && icon,
	    label
	  );
	  if (disabled) {
	    button = _react2.default.createElement(
	      'button',
	      _extends({}, rest, { disabled: disabled, style: _extends({}, styles.button, styles.disabled, buttonStyle), onClick: onClick }),
	      iconName && icon,
	      label
	    );
	  } else if (flat) {
	    button = _react2.default.createElement(
	      'button',
	      _extends({}, rest, { disabled: disabled, style: _extends({}, styles.button, styles.flat, buttonStyle), onClick: onClick }),
	      iconName && icon,
	      label
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: _extends({}, styles.container, containerStyle) },
	    button
	  );
	};
	
	KButton.propTypes = {
	  onClick: _propTypes2.default.func.isRequired,
	  label: _propTypes2.default.node.isRequired,
	  iconName: _propTypes2.default.string,
	  flat: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  buttonStyle: _propTypes2.default.object,
	  containerStyle: _propTypes2.default.object
	};
	
	var _default = KButton;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/KJRN/KButton.js');
	
	  __REACT_HOT_LOADER__.register(KButton, 'KButton', 'D:/a/1/s/src/web/employee/src/components/KJRN/KButton.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KButton.js');
	}();

	;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _FlatButton = __webpack_require__(82);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _RaisedButton = __webpack_require__(114);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _FontIcon = __webpack_require__(83);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _IconButton = __webpack_require__(64);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactModal = __webpack_require__(391);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _valuesByKey = __webpack_require__(92);
	
	var _PanelTable = __webpack_require__(431);
	
	var _PanelTable2 = _interopRequireDefault(_PanelTable);
	
	var _DetailList = __webpack_require__(221);
	
	var _DetailList2 = _interopRequireDefault(_DetailList);
	
	var _RootForm = __webpack_require__(429);
	
	var _RootForm2 = _interopRequireDefault(_RootForm);
	
	var _Alert = __webpack_require__(145);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _EntityCRUD = __webpack_require__(220);
	
	var CRUDActions = _interopRequireWildcard(_EntityCRUD);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_reactModal2.default.setAppElement('#app');
	
	var EditPanel = function (_Component) {
	  _inherits(EditPanel, _Component);
	
	  function EditPanel(props) {
	    _classCallCheck(this, EditPanel);
	
	    /* Initialize the container dialogs as closed and empty */
	    var _this = _possibleConstructorReturn(this, (EditPanel.__proto__ || Object.getPrototypeOf(EditPanel)).call(this, props));
	
	    _this.onKeyPress = function () {
	      return _this.__onKeyPress__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.closeAlert = function () {
	      return _this.__closeAlert__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.closeDialog = function () {
	      return _this.__closeDialog__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.openDialog = function () {
	      return _this.__openDialog__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.mapActions = function () {
	      return _this.__mapActions__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.editMode = function () {
	      return _this.__editMode__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.save = function () {
	      return _this.__save__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.delete = function () {
	      return _this.__delete__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.validate = function () {
	      return _this.__validate__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = {
	      open: false, dialogContent: [], editMode: false, alertOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(EditPanel, [{
	    key: '__validate__REACT_HOT_LOADER__',
	    value: function __validate__REACT_HOT_LOADER__() {
	      return this.__validate__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__delete__REACT_HOT_LOADER__',
	    value: function __delete__REACT_HOT_LOADER__() {
	      return this.__delete__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__save__REACT_HOT_LOADER__',
	    value: function __save__REACT_HOT_LOADER__() {
	      return this.__save__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__editMode__REACT_HOT_LOADER__',
	    value: function __editMode__REACT_HOT_LOADER__() {
	      return this.__editMode__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__mapActions__REACT_HOT_LOADER__',
	    value: function __mapActions__REACT_HOT_LOADER__() {
	      return this.__mapActions__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__openDialog__REACT_HOT_LOADER__',
	    value: function __openDialog__REACT_HOT_LOADER__() {
	      return this.__openDialog__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__closeDialog__REACT_HOT_LOADER__',
	    value: function __closeDialog__REACT_HOT_LOADER__() {
	      return this.__closeDialog__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__closeAlert__REACT_HOT_LOADER__',
	    value: function __closeAlert__REACT_HOT_LOADER__() {
	      return this.__closeAlert__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__onKeyPress__REACT_HOT_LOADER__',
	    value: function __onKeyPress__REACT_HOT_LOADER__() {
	      return this.__onKeyPress__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('keydown', this.onKeyPress);
	      this.props.onOpen && this.props.onOpen();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this.onKeyPress);
	    }
	  }, {
	    key: '__onKeyPress__REACT_HOT_LOADER__',
	    value: function __onKeyPress__REACT_HOT_LOADER__(event) {
	      if (event.keyCode === 27 && this.state.open) {
	        this.closeDialog();
	      }
	    }
	  }, {
	    key: '__closeAlert__REACT_HOT_LOADER__',
	    value: function __closeAlert__REACT_HOT_LOADER__() {
	      return this.setState({ alertOpen: false });
	    }
	  }, {
	    key: '__closeDialog__REACT_HOT_LOADER__',
	    value: function __closeDialog__REACT_HOT_LOADER__() {
	      this.setState({
	        open: false, editMode: false, dialogContent: [], dialogModel: null
	      });
	    }
	  }, {
	    key: '__openDialog__REACT_HOT_LOADER__',
	
	
	    /* Add actions to the model being displayed in the table */
	    value: function __openDialog__REACT_HOT_LOADER__() {
	      return this.setState({ open: true });
	    }
	  }, {
	    key: '__mapActions__REACT_HOT_LOADER__',
	
	
	    /* Open edit modal for the model, empty if newEntity param is set to true */
	    value: function __mapActions__REACT_HOT_LOADER__(model) {
	      var _this2 = this;
	
	      var dialogContent = model.detailFields.filter(function (f) {
	        return model[f];
	      }).map(function (f) {
	        return model[f];
	      });
	      return _extends({}, model, {
	        actions: [{
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.detail' }),
	          action: function action() {
	            return _this2.setState({ dialogContent: dialogContent, open: true, dialogModel: model });
	          }
	        }]
	      });
	    }
	  }, {
	    key: '__editMode__REACT_HOT_LOADER__',
	    value: function __editMode__REACT_HOT_LOADER__(newEntity) {
	      var _state = this.state,
	          dialogContent = _state.dialogContent,
	          dialogModel = _state.dialogModel;
	
	      var fields = void 0;
	      if (newEntity) {
	        var _props = this.props,
	            EmployeeMasterID = _props.EmployeeMasterID,
	            mapModel = _props.mapModel;
	        /* Create a new entity with the EmployeeMasterID of the user */
	
	        var newEd = mapModel({ Entity: { EmployeeMasterID: EmployeeMasterID } });
	        fields = newEd.detailFields.map(function (f) {
	          return newEd[f];
	        }).filter(function (f) {
	          return f.entity;
	        }).map(function (c) {
	          return _extends({
	            label: c.label,
	            name: c.entity,
	            value: newEd.Entity[c.entity]
	          }, newEd.entityMap[c.entity]);
	        });
	        /* Open the dialog */
	        this.setState({
	          save: false, editMode: true, fields: fields, dialogModel: newEd
	        }, this.setState({ open: true }));
	      } else {
	        fields = dialogContent.filter(function (f) {
	          return f.entity;
	        }).map(function (c) {
	          return _extends({
	            label: c.label,
	            name: c.entity,
	            value: dialogModel.Entity[c.entity]
	          }, dialogModel.entityMap[c.entity]);
	        });
	        /* Open the dialog */
	        this.setState({ save: true, editMode: true, fields: fields });
	      }
	    }
	  }, {
	    key: '__save__REACT_HOT_LOADER__',
	    value: function __save__REACT_HOT_LOADER__() {
	      if (this.ctl.isInvalid()) {
	        return;
	      }
	      // If entity is new we need to use `create`
	      this.state.save ? this.ctl.save() : this.ctl.create();
	      this.closeDialog();
	    }
	  }, {
	    key: '__delete__REACT_HOT_LOADER__',
	    value: function __delete__REACT_HOT_LOADER__() {
	      var _props2 = this.props,
	          dispatch = _props2.dispatch,
	          fetchData = _props2.fetchData,
	          modelName = _props2.modelName,
	          Entity = this.state.dialogModel.Entity;
	
	      dispatch(CRUDActions.remove(modelName, Entity, fetchData));
	      this.closeAlert();
	      this.closeDialog();
	    }
	  }, {
	    key: '__validate__REACT_HOT_LOADER__',
	    value: function __validate__REACT_HOT_LOADER__(values) {
	      var _props3 = this.props,
	          valuesByKey = _props3.valuesByKey,
	          modelName = _props3.modelName;
	
	      var requiredFields = valuesByKey['Required.' + modelName] ? valuesByKey['Required.' + modelName].Value.split(',') : [];
	      var error = {};
	      requiredFields.forEach(function (r) {
	        var value = values[r];
	        if (!value && value !== 0 && value !== false) {
	          error[r] = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' });
	        }
	      });
	      return error;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          modelName = _props4.modelName,
	          dataSource = _props4.dataSource,
	          fetchData = _props4.fetchData,
	          initSort = _props4.initSort,
	          dispatch = _props4.dispatch,
	          valuesByKey = _props4.valuesByKey,
	          loaded = _props4.loaded,
	          emptyText = _props4.emptyText;
	      var _state2 = this.state,
	          dialogContent = _state2.dialogContent,
	          dialogModel = _state2.dialogModel,
	          editMode = _state2.editMode,
	          alertOpen = _state2.alertOpen,
	          fields = _state2.fields;
	
	      var dataWithActions = dataSource && dataSource.map(this.mapActions);
	
	      var actions = (0, _valuesByKey.shouldEdit)(valuesByKey, modelName) ? [editMode ? undefined : _react2.default.createElement(_RaisedButton2.default, {
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.edit' }),
	        style: { marginRight: 8 },
	        primary: true,
	        key: 'edit',
	        onClick: function onClick() {
	          return _this3.editMode(false);
	        }
	      }), editMode ? undefined : _react2.default.createElement(_RaisedButton2.default, {
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.delete' }),
	        secondary: true,
	        key: 'delete',
	        onClick: function onClick() {
	          return _this3.setState({ alertOpen: true });
	        }
	      })] : [];
	
	      var saveActions = (0, _valuesByKey.shouldEdit)(valuesByKey, modelName) ? [!editMode ? undefined : _react2.default.createElement(_RaisedButton2.default, {
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.save' }),
	        primary: true,
	        key: 'save',
	        onClick: this.ctl && this.ctl.handleSubmit(this.save)
	      }), _react2.default.createElement(_RaisedButton2.default, {
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'alert.cancel' }),
	        onClick: this.closeDialog,
	        style: { marginLeft: 8 }
	      })] : [];
	
	      var panelActions = _react2.default.createElement(
	        'div',
	        { key: 'actions', style: { display: 'flex', justifyContent: 'space-between' } },
	        (0, _valuesByKey.shouldEdit)(valuesByKey, modelName) && _react2.default.createElement(_RaisedButton2.default, {
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.add' }),
	          primary: true,
	          onClick: function onClick() {
	            return _this3.editMode(true);
	          }
	        }),
	        _react2.default.createElement(_FlatButton2.default, {
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.refresh' }),
	          icon: _react2.default.createElement(
	            _FontIcon2.default,
	            { className: 'material-icons' },
	            'refresh'
	          ),
	          primary: true,
	          onClick: function onClick() {
	            return dispatch(fetchData());
	          }
	        })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        loaded && _react2.default.createElement(_PanelTable2.default, { emptyText: emptyText, dataSource: dataWithActions, actions: true, initSort: initSort }),
	        !loaded && _react2.default.createElement(
	          'div',
	          {
	            style: {
	              height: 80,
	              width: '100%',
	              display: 'flex',
	              alignItems: 'center',
	              justifyContent: 'center'
	            }
	          },
	          _react2.default.createElement(_materialUi.CircularProgress, { mode: 'indeterminate', thickness: 4 })
	        ),
	        _react2.default.createElement(
	          _reactModal2.default,
	          {
	            isOpen: this.state.open,
	            style: {
	              content: {
	                top: '50%',
	                left: '50%',
	                right: 'auto',
	                bottom: 'auto',
	                marginRight: '-50%',
	                transform: 'translate(-50%, -50%)'
	              }
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { style: { height: '64vh' } },
	            _react2.default.createElement(
	              _IconButton2.default,
	              {
	                style: { margin: -12, float: 'right' },
	                iconClassName: 'material-icons',
	                onClick: this.closeDialog
	              },
	              'close'
	            ),
	            editMode ? _react2.default.createElement(
	              'div',
	              { style: { minWidth: '50vw' } },
	              _react2.default.createElement(_RootForm2.default, {
	                formName: modelName
	                // ref={(rf) => { this.rootForm = rf; }}
	                , fields: fields,
	                initialValues: dialogModel.Entity,
	                provideController: function provideController(ctl) {
	                  _this3.ctl = ctl;
	                }
	                // function to be dispatched once request completes
	                , dataFetch: fetchData,
	                validate: this.validate
	              }),
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: 16 } },
	                saveActions
	              )
	            ) : _react2.default.createElement(
	              _react2.default.Fragment,
	              null,
	              _react2.default.createElement(_DetailList2.default, { dataSource: dialogContent }),
	              _react2.default.createElement(
	                'div',
	                { style: { marginTop: 16 } },
	                actions
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { padding: 12 } },
	          panelActions
	        ),
	        _react2.default.createElement(_Alert2.default, {
	          open: alertOpen,
	          onOk: this.delete,
	          onCancel: this.closeAlert,
	          text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.alert' })
	        })
	      );
	    }
	  }]);
	
	  return EditPanel;
	}(_react.Component);
	
	EditPanel.propTypes = {
	  modelName: _propTypes2.default.string.isRequired,
	  emptyText: _propTypes2.default.string,
	  mapModel: _propTypes2.default.func.isRequired,
	  EmployeeMasterID: _propTypes2.default.number.isRequired,
	  fetchData: _propTypes2.default.func.isRequired,
	  onOpen: _propTypes2.default.func,
	  dispatch: _propTypes2.default.func.isRequired,
	  dataSource: _propTypes2.default.array,
	  initSort: _propTypes2.default.string,
	  valuesByKey: _propTypes2.default.object,
	  loaded: _propTypes2.default.bool
	};
	
	EditPanel.defaultProps = {
	  dataSource: [],
	  initSort: ''
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref) {
	  var WebValuesReducer = _ref.WebValuesReducer;
	  return { valuesByKey: WebValuesReducer.valuesByKey };
	})(EditPanel);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EditPanel, 'EditPanel', 'D:/a/1/s/src/web/employee/src/components/profile/EditPanel.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/profile/EditPanel.js');
	}();

	;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _default = function _default(valuesByKey) {
	  var title = (0, _lodash.get)(valuesByKey, ['Appraisal.Title', 'Value']);
	  switch (title) {
	    case 'Discussion':
	      return 'appraisal.discussion';
	    case 'Development':
	      return 'appraisal.development';
	    case 'Conversation':
	      return 'appraisal.conversation';
	    default:
	      return 'appraisal.title';
	  }
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/utils/getAppraisalTitle.js');
	}();

	;

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchOpenEntry = exports.openEntryFailure = exports.openEntrySuccess = exports.openEntryRequest = exports.punchInOut = exports.punchInOutFailure = exports.punchInOutSuccess = exports.punchInOutRequest = exports.deleteEntry = exports.deleteFailure = exports.deleteSuccess = exports.deleteRequest = exports.sendNotifyEmail = exports.postFailure = exports.postOutOfRangeSuccess = exports.postSuccess = exports.postRequest = exports.patchEntry = exports.patchFailure = exports.patchSuccess = exports.patchRequest = exports.useTimeState = exports.initialize = exports.initializeFailure = exports.initializeSuccess = exports.initializeRequest = exports.changePeriod = exports.requestEntries = exports.fetchEntriesFailure = exports.fetchEntriesSuccess = exports.fetchEntries = exports.setPeriod = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(12);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Api = __webpack_require__(21);
	
	var _reapop = __webpack_require__(44);
	
	var _reactIntl = __webpack_require__(5);
	
	var _constants = __webpack_require__(291);
	
	var _holidays = __webpack_require__(227);
	
	var _api = __webpack_require__(185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getDates = function getDates(startDate, endDate) {
	  var dateArray = [];
	  var currentDate = new Date(startDate);
	  while (currentDate <= endDate) {
	    dateArray.push({
	      dateString: (0, _moment2.default)(currentDate).format('DD/MM/YY'),
	      date: (0, _moment2.default)(currentDate),
	      isWeekend: currentDate.getDay() === 6 || currentDate.getDay() === 0,
	      dayOfWeek: (0, _moment2.default)(currentDate).format('ddd'),
	      isRedDay: (0, _holidays.isRedDay)(currentDate)
	    });
	    currentDate.setDate(currentDate.getDate() + 1);
	  }
	  return dateArray;
	};
	var setPeriod = exports.setPeriod = function setPeriod(start, end) {
	  return {
	    type: _constants.SET_PERIOD,
	    start: start,
	    end: end,
	    datesBetween: getDates(start, end),
	    workingDays: (0, _holidays.numberOfWorkingDays)(start, end)
	  };
	};
	var fetchEntries = exports.fetchEntries = function fetchEntries() {
	  return {
	    type: _constants.FETCH_ENTRIES_REQUEST
	  };
	};
	
	var fetchEntriesSuccess = exports.fetchEntriesSuccess = function fetchEntriesSuccess(entries) {
	  return {
	    type: _constants.FETCH_ENTRIES_SUCCESS,
	    entries: entries
	  };
	};
	
	var fetchEntriesFailure = exports.fetchEntriesFailure = function fetchEntriesFailure(error) {
	  return {
	    type: _constants.FETCH_ENTRIES_FAILURE,
	    error: error
	  };
	};
	
	var requestEntries = exports.requestEntries = function requestEntries(start, end) {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, DefaultEmployeeDetailID, entriesRes, _getState2, entryTypes, vacationTypeId, filteredEntries, entries;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              dispatch(fetchEntries());
	              _getState = getState(), DefaultEmployeeDetailID = _getState.loginReducer.user.DefaultEmployeeDetailID;
	              _context.t0 = _lodash.get;
	              _context.next = 6;
	              return (0, _Api.custom)((0, _api.getEntries)(start, end, DefaultEmployeeDetailID));
	
	            case 6:
	              _context.t1 = _context.sent;
	              _context.t2 = [];
	              entriesRes = (0, _context.t0)(_context.t1, 'data.value', _context.t2);
	              _getState2 = getState(), entryTypes = _getState2.timeReducer.entryTypes;
	              vacationTypeId = (0, _lodash.get)((0, _lodash.find)((0, _lodash.map)(entryTypes), function (type) {
	                return type.ClockCardEntryTypeRule === 'VacationTrandsfer';
	              }), 'ClockCardEntryTypeID', null);
	              filteredEntries = vacationTypeId ? (0, _lodash.filter)(entriesRes, function (entry) {
	                return entry.ClockCardEntryTypeID !== vacationTypeId;
	              }) : entriesRes;
	              entries = (0, _lodash.keyBy)(filteredEntries, 'ClockCardEntryID');
	
	              dispatch(fetchEntriesSuccess(entries));
	              _context.next = 19;
	              break;
	
	            case 16:
	              _context.prev = 16;
	              _context.t3 = _context['catch'](0);
	
	              dispatch((0, _constants.FETCH_ENTRIES_FAILURE)(_context.t3));
	
	            case 19:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 16]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	var changePeriod = exports.changePeriod = function changePeriod(start, end) {
	  return function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              dispatch(setPeriod(start.startOf('day'), end.endOf('day')));
	              dispatch(requestEntries(start.startOf('day'), end.endOf('day')));
	
	            case 2:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x3) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	var initializeRequest = exports.initializeRequest = function initializeRequest() {
	  return {
	    type: _constants.INITIALIZE_REQUEST
	  };
	};
	
	var initializeSuccess = exports.initializeSuccess = function initializeSuccess(entryTypes, periodFrom, workingHours, hideActions, timeEmailTypes) {
	  return {
	    type: _constants.INITIALIZE_SUCCESS,
	    entryTypes: entryTypes,
	    periodFrom: periodFrom,
	    workingHours: workingHours,
	    hideActions: hideActions,
	    timeEmailTypes: timeEmailTypes
	  };
	};
	
	var initializeFailure = exports.initializeFailure = function initializeFailure(error) {
	  return {
	    type: _constants.INITIALIZE_FAILURE,
	    error: error
	  };
	};
	var initialize = exports.initialize = function initialize() {
	  return function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	      var _getState3, DefaultEmployeeDetailID, valuesByKey, requests, hideActions, _ref4, _ref5, xapRes, typesRes, hoursRes, xapTimeEmailRes, periodFrom, startDate, endDate, entryTypes, workingHours, timeEmailTypes;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	
	              dispatch(initializeRequest());
	              _getState3 = getState(), DefaultEmployeeDetailID = _getState3.loginReducer.user.DefaultEmployeeDetailID, valuesByKey = _getState3.WebValuesReducer.valuesByKey;
	              requests = [(0, _Api.custom)((0, _api.getXapValue)('Pay.PeriodFrom')), (0, _Api.custom)(_api.getClockCardEntryTypes), (0, _Api.custom)((0, _api.getWorkingHours)(DefaultEmployeeDetailID)), (0, _Api.custom)((0, _api.getXapValue)('Email.TimeRegistration'))];
	              hideActions = (0, _lodash.get)(valuesByKey, ['Hide.TimeActions', 'Value']) === 'true';
	              _context3.next = 7;
	              return Promise.all(requests);
	
	            case 7:
	              _ref4 = _context3.sent;
	              _ref5 = _slicedToArray(_ref4, 4);
	              xapRes = _ref5[0];
	              typesRes = _ref5[1];
	              hoursRes = _ref5[2];
	              xapTimeEmailRes = _ref5[3];
	              periodFrom = (0, _lodash.get)(xapRes, 'data.value[0].Value') || 1;
	              startDate = (0, _moment2.default)().date(periodFrom).add(-1, 'months').startOf('day');
	              endDate = (0, _moment2.default)().date(periodFrom - 1).endOf('day');
	
	              if (endDate.isSameOrBefore((0, _moment2.default)())) {
	                startDate = startDate.add(1, 'months');
	                endDate = startDate.clone().add(1, 'months').add(-1, 'days').endOf('day');
	              }
	              entryTypes = (0, _lodash.keyBy)((0, _lodash.get)(typesRes, 'data.value', []), 'ClockCardEntryTypeID');
	              workingHours = (0, _lodash.get)(hoursRes, 'data.value');
	              timeEmailTypes = (0, _lodash.split)((0, _lodash.get)(xapTimeEmailRes, 'data.value[0].Value', null), ',') || [];
	
	              dispatch(initializeSuccess(entryTypes, periodFrom, workingHours, hideActions, timeEmailTypes));
	              dispatch(changePeriod(startDate, endDate));
	              _context3.next = 27;
	              break;
	
	            case 24:
	              _context3.prev = 24;
	              _context3.t0 = _context3['catch'](0);
	
	              dispatch(initializeFailure((0, _lodash.get)(_context3.t0, 'message')));
	
	            case 27:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[0, 24]]);
	    }));
	
	    return function (_x4, _x5) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	};
	var useTimeState = exports.useTimeState = function useTimeState() {
	  return (0, _reactRedux.useSelector)(function (state) {
	    return state.timeReducer;
	  });
	};
	var patchRequest = exports.patchRequest = function patchRequest() {
	  return {
	    type: _constants.PATCH_REQUEST
	  };
	};
	
	var patchSuccess = exports.patchSuccess = function patchSuccess(entry, entryId) {
	  return {
	    type: _constants.PATCH_SUCCESS,
	    entry: entry,
	    entryId: entryId
	  };
	};
	
	var patchFailure = exports.patchFailure = function patchFailure(error) {
	  return {
	    type: _constants.PATCH_FAILURE,
	    error: error
	  };
	};
	
	var patchEntry = exports.patchEntry = function patchEntry(entry, entryId, cb) {
	  return function () {
	    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
	      var res, data, msg, errorData;
	      return regeneratorRuntime.wrap(function _callee4$(_context4) {
	        while (1) {
	          switch (_context4.prev = _context4.next) {
	            case 0:
	              _context4.prev = 0;
	
	              dispatch(patchRequest());
	              _context4.next = 4;
	              return (0, _Api.custom)((0, _api.patch)(entry, entryId));
	
	            case 4:
	              res = _context4.sent;
	              data = (0, _lodash.get)(res, 'data', {});
	
	              dispatch(patchSuccess(data, entryId));
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.notification.patch.title' }),
	                status: 'success',
	                dismissible: true,
	                dismissAfter: 3000
	              }));
	              cb();
	              _context4.next = 16;
	              break;
	
	            case 11:
	              _context4.prev = 11;
	              _context4.t0 = _context4['catch'](0);
	
	              dispatch(patchFailure(_context4.t0));
	              msg = (0, _lodash.get)(_context4.t0, 'response.data.error.message');
	
	              if (msg) {
	                errorData = JSON.parse(msg);
	
	                dispatch((0, _reapop.addNotification)({
	                  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error' }),
	                  message: (0, _lodash.get)(errorData, 'Errors[0].UserMessage'),
	                  status: 'error',
	                  dismissible: true,
	                  dismissAfter: 5000
	                }));
	              } else {
	                dispatch((0, _reapop.addNotification)({
	                  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error' }),
	                  message: (0, _lodash.get)(_context4.t0, 'message'),
	                  status: 'error',
	                  dismissible: true,
	                  dismissAfter: 3000
	                }));
	              }
	
	            case 16:
	            case 'end':
	              return _context4.stop();
	          }
	        }
	      }, _callee4, undefined, [[0, 11]]);
	    }));
	
	    return function (_x6) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	};
	var postRequest = exports.postRequest = function postRequest() {
	  return {
	    type: _constants.POST_REQUEST
	  };
	};
	
	var postSuccess = exports.postSuccess = function postSuccess(entries) {
	  return {
	    type: _constants.POST_SUCCESS,
	    entries: entries
	  };
	};
	var postOutOfRangeSuccess = exports.postOutOfRangeSuccess = function postOutOfRangeSuccess() {
	  return {
	    type: _constants.POST_OUT_OF_RANGE_SUCCESS
	  };
	};
	var postFailure = exports.postFailure = function postFailure(error) {
	  return {
	    type: _constants.POST_FAILURE,
	    error: error
	  };
	};
	var sendNotifyEmail = exports.sendNotifyEmail = function () {
	  var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(detailId, from, to, entryTypes, timeEmailTypes, entry) {
	    var entryTypeId, entryTypeRule;
	    return regeneratorRuntime.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            _context5.prev = 0;
	            entryTypeId = (0, _lodash.get)(entry, 'ClockCardEntryTypeID');
	            entryTypeRule = (0, _lodash.get)(entryTypes, [entryTypeId, 'ClockCardEntryTypeRule'], null);
	
	            if (!(entryTypeRule && (0, _lodash.includes)(timeEmailTypes, entryTypeRule))) {
	              _context5.next = 6;
	              break;
	            }
	
	            _context5.next = 6;
	            return (0, _Api.custom)((0, _api.notifyEntryTypeRule)(detailId, entryTypeRule, from, to));
	
	          case 6:
	            _context5.next = 10;
	            break;
	
	          case 8:
	            _context5.prev = 8;
	            _context5.t0 = _context5['catch'](0);
	
	          case 10:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, undefined, [[0, 8]]);
	  }));
	
	  return function sendNotifyEmail(_x7, _x8, _x9, _x10, _x11, _x12) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	// export const postEntry = (entry, cb) => async (dispatch, getState) => {
	//   try {
	//     dispatch(postRequest());
	//     const {
	//       timeReducer: {
	//         start, end, timeEmailTypes, entryTypes,
	//       },
	//       loginReducer: {
	//         user: { DefaultEmployeeDetailID },
	//       },
	//     } = getState();
	//     const data = get(await custom(post({ ...entry, EmployeeDetailID: DefaultEmployeeDetailID })), 'data');
	//     const ClockIn = get(entry, 'ClockIn');
	//     const ClockOut = get(entry, 'ClockOut', null);
	//     if (end.isBefore(ClockIn) || start.isAfter(ClockIn)) {
	//       dispatch(postOutOfRangeSuccess());
	//     } else {
	//       dispatch(postSuccess(keyBy([data], 'ClockCardEntryID')));
	//     }
	//     dispatch(addNotification({
	//       title: <FormattedMessage id="time.notification.post.title" />,
	//       status: 'success',
	//       dismissible: true,
	//       dismissAfter: 3000,
	//     }));
	//     cb();
	//     if (ClockOut && size(timeEmailTypes) > 0) {
	//       await sendNotifyEmail(DefaultEmployeeDetailID, ClockIn, ClockOut, entryTypes, timeEmailTypes, entry);
	//     }
	//   } catch (error) {
	//     dispatch(postFailure(error));
	//     const msg = get(error, 'response.data.error.message');
	//     if (get(error, 'response.status') === 403) {
	//       dispatch(addNotification({
	//         title: <FormattedMessage id="time.error" />,
	//         message: <FormattedMessage id="Error.AccessDenied" />,
	//         status: 'error',
	//         dismissible: true,
	//         dismissAfter: 3000,
	//       }));
	//     } else if (msg) {
	//       const errorData = JSON.parse(msg);
	//       const code = get(errorData, 'Errors[0].Code');
	//       if (code === 1) {
	//         dispatch(addNotification({
	//           title: <FormattedMessage id="time.error" />,
	//           message: <FormattedMessage id="time.error.NotEnoughSickHours.Many" />,
	//           status: 'error',
	//           dismissible: true,
	//           dismissAfter: 5000,
	//         }));
	//       } else {
	//         dispatch(addNotification({
	//           title: <FormattedMessage id="time.error" />,
	//           message: get(errorData, 'Errors[0].UserMessage'),
	//           status: 'error',
	//           dismissible: true,
	//           dismissAfter: 5000,
	//         }));
	//       }
	//     } else {
	//       dispatch(addNotification({
	//         title: <FormattedMessage id="time.error" />,
	//         message: get(error, 'message'),
	//         status: 'error',
	//         dismissible: true,
	//         dismissAfter: 3000,
	//       }));
	//     }
	//   }
	// };
	
	// export const postSpan = (entry, baseIn, baseOut, endDate, cb, registerWeekend, registerRedDays) => async (dispatch, getState) => {
	//   const {
	//     timeReducer: {
	//       start, end, timeEmailTypes, entryTypes,
	//     },
	//     loginReducer: {
	//       user: { DefaultEmployeeDetailID },
	//     },
	//   } = getState();
	//   const successResponses = [];
	//   const getSuccessEntries = data => keyBy(filter(data, e => start.isSameOrBefore(get(e, 'ClockIn')) && end.isSameOrAfter(get(e, 'ClockIn'))), 'ClockCardEntryID');
	//   try {
	//     dispatch(postRequest());
	//     const currentDateIn = new Date(baseIn);
	//     const currentDateOut = new Date(baseOut);
	
	//     const addEntry = async () => successResponses.push(await custom(post({
	//       ...entry,
	//       EmployeeDetailID: DefaultEmployeeDetailID,
	//       ClockIn: moment(currentDateIn),
	//       ClockOut: moment(currentDateOut),
	//     })));
	
	//     while (currentDateIn <= new Date(endDate)) {
	//       const isWeekday = !isRedDay(currentDateIn) && currentDateIn.getDay() % 6 !== 0;
	//       if (isWeekday) {
	//         // eslint-disable-next-line no-await-in-loop
	//         await addEntry();
	//       } else if (isRedDay(currentDateIn) && registerRedDays) {
	//         // eslint-disable-next-line no-await-in-loop
	//         await addEntry();
	//       } else if ((currentDateIn.getDay() % 6 === 0) && registerWeekend) {
	//         // eslint-disable-next-line no-await-in-loop
	//         await addEntry();
	//       }
	//       currentDateIn.setDate(currentDateIn.getDate() + 1);
	//       currentDateOut.setDate(currentDateOut.getDate() + 1);
	//     }
	
	//     const entries = getSuccessEntries(map(successResponses, 'data'));
	//     dispatch(postSuccess(entries));
	//     dispatch(addNotification({
	//       title: <FormattedMessage id="time.notification.batch.created" values={{ count: size(successResponses) }} />,
	//       status: 'success',
	//       dismissible: true,
	//       dismissAfter: 3000,
	//     }));
	//     cb();
	//     if (size(timeEmailTypes) > 0) {
	//       await sendNotifyEmail(DefaultEmployeeDetailID, new Date(baseIn).toISOString(), new Date(endDate).toISOString(), entryTypes, timeEmailTypes, entry);
	//     }
	//   } catch (error) {
	//     const msg = get(error, 'response.data.error.message');
	//     if (msg) {
	//       const errorData = JSON.parse(msg);
	//       const code = get(errorData, 'Errors[0].Code');
	//       if (code === 1) {
	//         const entries = getSuccessEntries(map(successResponses, 'data'));
	//         if (size(successResponses) === 0) {
	//           dispatch(postFailure(error));
	//           dispatch(addNotification({
	//             title: <FormattedMessage id="time.error" />,
	//             message: <FormattedMessage id="time.error.NotEnoughSickHours" />,
	//             status: 'error',
	//             dismissible: true,
	//             dismissAfter: 5000,
	//           }));
	//         } else {
	//           dispatch(postSuccess(entries));
	//           dispatch(addNotification({
	//             title: <FormattedMessage id="time.notification.batch.created" values={{ count: size(successResponses) }} />,
	//             status: 'success',
	//             dismissible: true,
	//             dismissAfter: 3000,
	//           }));
	//           dispatch(addNotification({
	//             title: <FormattedMessage id="time.error" />,
	//             message: <FormattedMessage id="time.error.NotEnoughSickHours.Many" />,
	//             status: 'error',
	//             dismissible: true,
	//             dismissAfter: 5000,
	//           }));
	//         }
	//       } else {
	//         dispatch(addNotification({
	//           title: <FormattedMessage id="time.error" />,
	//           message: get(errorData, 'Errors[0].UserMessage'),
	//           status: 'error',
	//           dismissible: true,
	//           dismissAfter: 5000,
	//         }));
	//       }
	//       cb();
	//     } else {
	//       dispatch(postFailure(error));
	//       dispatch(addNotification({
	//         title: <FormattedMessage id="time.error" />,
	//         message: get(error, 'message'),
	//         status: 'error',
	//         dismissible: true,
	//         dismissAfter: 3000,
	//       }));
	//     }
	//   }
	// };
	
	var deleteRequest = exports.deleteRequest = function deleteRequest() {
	  return {
	    type: _constants.DELETE_REQUEST
	  };
	};
	
	var deleteSuccess = exports.deleteSuccess = function deleteSuccess(entries) {
	  return {
	    type: _constants.DELETE_SUCCESS,
	    entries: entries
	  };
	};
	
	var deleteFailure = exports.deleteFailure = function deleteFailure(error) {
	  return {
	    type: _constants.DELETE_FAILURE,
	    error: error
	  };
	};
	
	var deleteEntry = exports.deleteEntry = function deleteEntry(entryId) {
	  return function () {
	    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(dispatch, getState) {
	      var _getState4, entries, msg, errorData;
	
	      return regeneratorRuntime.wrap(function _callee6$(_context6) {
	        while (1) {
	          switch (_context6.prev = _context6.next) {
	            case 0:
	              _context6.prev = 0;
	
	              dispatch(deleteRequest());
	              _context6.next = 4;
	              return (0, _Api.custom)((0, _api.deleteClockCardEntry)(entryId));
	
	            case 4:
	              _getState4 = getState(), entries = _getState4.timeReducer.entries;
	
	              delete entries[entryId];
	              dispatch(deleteSuccess(entries));
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.notification.delete.title' }),
	                status: 'success',
	                dismissible: true,
	                dismissAfter: 3000
	              }));
	              _context6.next = 15;
	              break;
	
	            case 10:
	              _context6.prev = 10;
	              _context6.t0 = _context6['catch'](0);
	
	              dispatch(deleteFailure(_context6.t0));
	              msg = (0, _lodash.get)(_context6.t0, 'response.data.error.message');
	
	              if (msg) {
	                errorData = JSON.parse(msg);
	
	                dispatch((0, _reapop.addNotification)({
	                  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error' }),
	                  message: (0, _lodash.get)(errorData, 'Errors[0].UserMessage'),
	                  status: 'error',
	                  dismissible: true,
	                  dismissAfter: 5000
	                }));
	              } else {
	                dispatch((0, _reapop.addNotification)({
	                  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error' }),
	                  message: (0, _lodash.get)(_context6.t0, 'message'),
	                  status: 'error',
	                  dismissible: true,
	                  dismissAfter: 3000
	                }));
	              }
	
	            case 15:
	            case 'end':
	              return _context6.stop();
	          }
	        }
	      }, _callee6, undefined, [[0, 10]]);
	    }));
	
	    return function (_x13, _x14) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	};
	
	var punchInOutRequest = exports.punchInOutRequest = function punchInOutRequest() {
	  return {
	    type: _constants.PUNCH_REQUEST
	  };
	};
	
	var punchInOutSuccess = exports.punchInOutSuccess = function punchInOutSuccess(openEntry, isPunchedIn) {
	  return {
	    type: _constants.PUNCH_SUCCESS,
	    openEntry: openEntry,
	    isPunchedIn: isPunchedIn
	  };
	};
	
	var punchInOutFailure = exports.punchInOutFailure = function punchInOutFailure(error) {
	  return {
	    type: _constants.PUNCH_FAILURE,
	    error: error
	  };
	};
	var punchInOut = exports.punchInOut = function punchInOut() {
	  return function () {
	    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(dispatch, getState) {
	      var _getState5, DefaultEmployeeDetailID, valuesByKey, kioskId, entryRes, entry, isPunchedIn, message;
	
	      return regeneratorRuntime.wrap(function _callee7$(_context7) {
	        while (1) {
	          switch (_context7.prev = _context7.next) {
	            case 0:
	              _context7.prev = 0;
	
	              dispatch(punchInOutRequest());
	              _getState5 = getState(), DefaultEmployeeDetailID = _getState5.loginReducer.user.DefaultEmployeeDetailID, valuesByKey = _getState5.WebValuesReducer.valuesByKey;
	              kioskId = (0, _lodash.get)(valuesByKey, ['PunchClock.KioskID', 'Value'], null);
	
	              if (kioskId) {
	                _context7.next = 6;
	                break;
	              }
	
	              throw Error('KioskID missing');
	
	            case 6:
	              _context7.next = 8;
	              return (0, _Api.custom)((0, _api.punch)(DefaultEmployeeDetailID, kioskId));
	
	            case 8:
	              entryRes = _context7.sent;
	              entry = (0, _lodash.get)(entryRes, 'data');
	              isPunchedIn = !(0, _lodash.get)(entry, 'ClockOut');
	
	              dispatch(punchInOutSuccess(entry, isPunchedIn));
	              if (!isPunchedIn) dispatch(patchSuccess(entry, (0, _lodash.get)(entry, 'ClockCardEntryID')));
	              _context7.next = 21;
	              break;
	
	            case 15:
	              _context7.prev = 15;
	              _context7.t0 = _context7['catch'](0);
	              message = (0, _lodash.get)(_context7.t0, 'error.message');
	
	              if (message) (0, _lodash.set)(_context7.t0, 'message', message);
	              dispatch(punchInOutFailure((0, _lodash.get)(_context7.t0, 'message')));
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error' }),
	                message: (0, _lodash.get)(_context7.t0, 'message'),
	                status: 'error',
	                dismissible: true,
	                dismissAfter: 3000
	              }));
	
	            case 21:
	            case 'end':
	              return _context7.stop();
	          }
	        }
	      }, _callee7, undefined, [[0, 15]]);
	    }));
	
	    return function (_x15, _x16) {
	      return _ref9.apply(this, arguments);
	    };
	  }();
	};
	
	var openEntryRequest = exports.openEntryRequest = function openEntryRequest() {
	  return {
	    type: _constants.OPEN_ENTRY_REQUEST
	  };
	};
	
	var openEntrySuccess = exports.openEntrySuccess = function openEntrySuccess(openEntry, isPunchedIn) {
	  return {
	    type: _constants.OPEN_ENTRY_SUCCESS,
	    openEntry: openEntry,
	    isPunchedIn: isPunchedIn
	  };
	};
	
	var openEntryFailure = exports.openEntryFailure = function openEntryFailure(error) {
	  return {
	    type: _constants.OPEN_ENTRY_FAILURE,
	    error: error
	  };
	};
	
	var fetchOpenEntry = exports.fetchOpenEntry = function fetchOpenEntry() {
	  return function () {
	    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(dispatch, getState) {
	      var _getState6, DefaultEmployeeDetailID, entryRes, entry, isPunchedIn;
	
	      return regeneratorRuntime.wrap(function _callee8$(_context8) {
	        while (1) {
	          switch (_context8.prev = _context8.next) {
	            case 0:
	              _context8.prev = 0;
	
	              dispatch(openEntryRequest());
	              _getState6 = getState(), DefaultEmployeeDetailID = _getState6.loginReducer.user.DefaultEmployeeDetailID;
	              _context8.next = 5;
	              return (0, _Api.custom)((0, _api.getOpenEntry)(DefaultEmployeeDetailID));
	
	            case 5:
	              entryRes = _context8.sent;
	              entry = (0, _lodash.get)(entryRes, 'data.value[0]', {});
	              isPunchedIn = !(0, _lodash.isEmpty)(entry) && !(0, _lodash.get)(entry, 'ClockOut');
	
	              dispatch(openEntrySuccess(entry, isPunchedIn));
	              _context8.next = 14;
	              break;
	
	            case 11:
	              _context8.prev = 11;
	              _context8.t0 = _context8['catch'](0);
	
	              dispatch(openEntryFailure());
	
	            case 14:
	            case 'end':
	              return _context8.stop();
	          }
	        }
	      }, _callee8, undefined, [[0, 11]]);
	    }));
	
	    return function (_x17, _x18) {
	      return _ref10.apply(this, arguments);
	    };
	  }();
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getDates, 'getDates', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(setPeriod, 'setPeriod', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchEntries, 'fetchEntries', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchEntriesSuccess, 'fetchEntriesSuccess', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchEntriesFailure, 'fetchEntriesFailure', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestEntries, 'requestEntries', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(changePeriod, 'changePeriod', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeRequest, 'initializeRequest', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeSuccess, 'initializeSuccess', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeFailure, 'initializeFailure', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(initialize, 'initialize', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(useTimeState, 'useTimeState', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(patchRequest, 'patchRequest', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(patchSuccess, 'patchSuccess', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(patchFailure, 'patchFailure', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(patchEntry, 'patchEntry', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(postRequest, 'postRequest', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(postSuccess, 'postSuccess', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(postOutOfRangeSuccess, 'postOutOfRangeSuccess', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(postFailure, 'postFailure', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(sendNotifyEmail, 'sendNotifyEmail', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteRequest, 'deleteRequest', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteSuccess, 'deleteSuccess', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteFailure, 'deleteFailure', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(deleteEntry, 'deleteEntry', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(punchInOutRequest, 'punchInOutRequest', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(punchInOutSuccess, 'punchInOutSuccess', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(punchInOutFailure, 'punchInOutFailure', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(punchInOut, 'punchInOut', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(openEntryRequest, 'openEntryRequest', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(openEntrySuccess, 'openEntrySuccess', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(openEntryFailure, 'openEntryFailure', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchOpenEntry, 'fetchOpenEntry', 'D:/a/1/s/src/web/employee/src/sites/time/actions.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 150 */
27,
/* 151 */
[1863, 107, 192, 104],
/* 152 */
28,
/* 153 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 154 */
[1891, 467, 300],
/* 155 */
[1893, 300],
/* 156 */
[1857, 76, 31],
/* 157 */
153,
/* 158 */
[1886, 42, 69, 31],
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var defined = __webpack_require__(87);
	var fails = __webpack_require__(27);
	var spaces = __webpack_require__(333);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(111);
	
	var _Actions = __webpack_require__(246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedValue;
	function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
	  if (keepUnprefixed) {
	    return [prefixedValue, value];
	  }
	  return prefixedValue;
	}
	module.exports = exports["default"];

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(80);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 163 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(550);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(41),
	    isKey = __webpack_require__(365),
	    stringToPath = __webpack_require__(565),
	    toString = __webpack_require__(169);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(353),
	    baseAssignValue = __webpack_require__(164);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(535),
	    baseKeysIn = __webpack_require__(1408),
	    isArrayLike = __webpack_require__(97);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(359);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CircularProgress = __webpack_require__(1532);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CircularProgress2.default;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dialog = __webpack_require__(1544);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dialog2.default;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Divider = __webpack_require__(593);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeSelectable = exports.ListItem = exports.List = undefined;
	
	var _List2 = __webpack_require__(375);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(376);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(597);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.default = _List3.default;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(100);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _RenderToLayer = __webpack_require__(616);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _lodash = __webpack_require__(1383);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PopoverAnimationDefault = __webpack_require__(1560);
	
	var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'none'
	  }
	};
	
	var Popover = function (_Component) {
	  (0, _inherits3.default)(Popover, _Component);
	
	  function Popover(props, context) {
	    (0, _classCallCheck3.default)(this, Popover);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));
	
	    _this.timeout = null;
	
	    _this.renderLayer = function () {
	      var _this$props = _this.props,
	          animated = _this$props.animated,
	          animation = _this$props.animation,
	          anchorEl = _this$props.anchorEl,
	          anchorOrigin = _this$props.anchorOrigin,
	          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
	          canAutoPosition = _this$props.canAutoPosition,
	          children = _this$props.children,
	          onRequestClose = _this$props.onRequestClose,
	          style = _this$props.style,
	          targetOrigin = _this$props.targetOrigin,
	          useLayerForClickAway = _this$props.useLayerForClickAway,
	          scrollableContainer = _this$props.scrollableContainer,
	          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway', 'scrollableContainer']);
	
	
	      var styleRoot = style;
	
	      if (!animated) {
	        styleRoot = {
	          position: 'fixed',
	          zIndex: _this.context.muiTheme.zIndex.popover
	        };
	
	        if (!_this.state.open) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
	          children
	        );
	      }
	
	      var Animation = animation || _PopoverAnimationDefault2.default;
	
	      return _react2.default.createElement(
	        Animation,
	        (0, _extends3.default)({
	          targetOrigin: targetOrigin,
	          style: styleRoot
	        }, other, {
	          open: _this.state.open && !_this.state.closing
	        }),
	        children
	      );
	    };
	
	    _this.componentClickAway = function () {
	      _this.requestClose('clickAway');
	    };
	
	    _this.setPlacement = function (scrolling) {
	      if (!_this.state.open) {
	        return;
	      }
	
	      if (!_this.popoverRefs.layer.getLayer()) {
	        return;
	      }
	
	      var targetEl = _this.popoverRefs.layer.getLayer().children[0];
	      if (!targetEl) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          targetOrigin = _this$props2.targetOrigin,
	          anchorOrigin = _this$props2.anchorOrigin;
	
	      var anchorEl = _this.props.anchorEl || _this.anchorEl;
	
	      var anchor = _this.getAnchorPosition(anchorEl);
	      var target = _this.getTargetPosition(targetEl);
	
	      var targetPosition = {
	        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
	        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
	      };
	
	      if (scrolling && _this.props.autoCloseWhenOffScreen) {
	        _this.autoCloseWhenOffScreen(anchor);
	      }
	
	      if (_this.props.canAutoPosition) {
	        target = _this.getTargetPosition(targetEl); // update as height may have changed
	        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
	      }
	
	      targetEl.style.top = targetPosition.top + 'px';
	      targetEl.style.left = targetPosition.left + 'px';
	      targetEl.style.maxHeight = window.innerHeight + 'px';
	    };
	
	    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
	    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);
	
	    _this.popoverRefs = {};
	
	    _this.state = {
	      open: props.open,
	      closing: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.placementTimeout = setTimeout(this.setPlacement);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.open === this.props.open) {
	        return;
	      }
	
	      if (nextProps.open) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	        this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
	        this.setState({
	          open: true,
	          closing: false
	        });
	      } else {
	        if (nextProps.animated) {
	          if (this.timeout !== null) return;
	          this.setState({ closing: true });
	          this.timeout = setTimeout(function () {
	            _this2.setState({
	              open: false
	            }, function () {
	              _this2.timeout = null;
	            });
	          }, 500);
	        } else {
	          this.setState({
	            open: false
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearTimeout(this.placementTimeout);
	      this.placementTimeout = setTimeout(this.setPlacement);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	      this.handleScroll.cancel();
	
	      if (this.placementTimeout) {
	        clearTimeout(this.placementTimeout);
	        this.placementTimeout = null;
	      }
	
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(reason) {
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(reason);
	      }
	    }
	  }, {
	    key: 'getAnchorPosition',
	    value: function getAnchorPosition(el) {
	      if (!el) {
	        el = _reactDom2.default.findDOMNode(this);
	      }
	
	      var rect = el.getBoundingClientRect();
	      var a = {
	        top: rect.top,
	        left: rect.left,
	        width: el.offsetWidth,
	        height: el.offsetHeight
	      };
	
	      a.right = rect.right || a.left + a.width;
	      a.bottom = rect.bottom || a.top + a.height;
	      a.middle = a.left + (a.right - a.left) / 2;
	      a.center = a.top + (a.bottom - a.top) / 2;
	
	      return a;
	    }
	  }, {
	    key: 'getTargetPosition',
	    value: function getTargetPosition(targetEl) {
	      return {
	        top: 0,
	        center: targetEl.offsetHeight / 2,
	        bottom: targetEl.offsetHeight,
	        left: 0,
	        middle: targetEl.offsetWidth / 2,
	        right: targetEl.offsetWidth
	      };
	    }
	  }, {
	    key: 'autoCloseWhenOffScreen',
	    value: function autoCloseWhenOffScreen(anchorPosition) {
	      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
	        this.requestClose('offScreen');
	      }
	    }
	  }, {
	    key: 'getOverlapMode',
	    value: function getOverlapMode(anchor, target, median) {
	      if ([anchor, target].indexOf(median) >= 0) return 'auto';
	      if (anchor === target) return 'inclusive';
	      return 'exclusive';
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions(anchor, target) {
	      var a = (0, _extends3.default)({}, anchor);
	      var t = (0, _extends3.default)({}, target);
	
	      var positions = {
	        x: ['left', 'right'].filter(function (p) {
	          return p !== t.horizontal;
	        }),
	        y: ['top', 'bottom'].filter(function (p) {
	          return p !== t.vertical;
	        })
	      };
	
	      var overlap = {
	        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
	        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
	      };
	
	      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
	      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');
	
	      if (overlap.y !== 'auto') {
	        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
	        if (overlap.y === 'inclusive') {
	          t.vertical = t.vertical;
	        }
	      }
	
	      if (overlap.x !== 'auto') {
	        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
	        if (overlap.y === 'inclusive') {
	          t.horizontal = t.horizontal;
	        }
	      }
	
	      return {
	        positions: positions,
	        anchorPos: a
	      };
	    }
	  }, {
	    key: 'applyAutoPositionIfNeeded',
	    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
	      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
	          positions = _getPositions.positions,
	          anchorPos = _getPositions.anchorPos;
	
	      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
	        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
	        if (newTop + target.bottom <= window.innerHeight) {
	          targetPosition.top = Math.max(0, newTop);
	        } else {
	          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
	          if (newTop + target.bottom <= window.innerHeight) {
	            targetPosition.top = Math.max(0, newTop);
	          }
	        }
	      }
	
	      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
	        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
	        if (newLeft + target.right <= window.innerWidth) {
	          targetPosition.left = Math.max(0, newLeft);
	        } else {
	          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
	          if (newLeft + target.right <= window.innerWidth) {
	            targetPosition.left = Math.max(0, newLeft);
	          }
	        }
	      }
	
	      return targetPosition;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var eventListener = this.state.open ? _react2.default.createElement(_reactEventListener2.default, {
	        target: this.props.scrollableContainer,
	        onScroll: this.handleScroll,
	        onResize: this.handleResize
	      }) : null;
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        eventListener,
	        _react2.default.createElement(_RenderToLayer2.default, {
	          ref: function ref(_ref) {
	            return _this3.popoverRefs.layer = _ref;
	          },
	          open: this.state.open,
	          componentClickAway: this.componentClickAway,
	          useLayerForClickAway: this.props.useLayerForClickAway,
	          render: this.renderLayer
	        })
	      );
	    }
	  }]);
	  return Popover;
	}(_react.Component);
	
	Popover.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  autoCloseWhenOffScreen: true,
	  canAutoPosition: true,
	  onRequestClose: function onRequestClose() {},
	  open: false,
	  scrollableContainer: 'window',
	  style: {
	    overflowY: 'auto'
	  },
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  useLayerForClickAway: true,
	  zDepth: 1
	};
	Popover.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Popover.propTypes =  false ? {
	  /**
	   * This is the DOM element that will be used to set the position of the
	   * popover.
	   */
	  anchorEl: _propTypes2.default.object,
	  /**
	   * This is the point on the anchor where the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it is added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * If true, the popover will hide when the anchor is scrolled off the screen.
	   */
	  autoCloseWhenOffScreen: _propTypes2.default.bool,
	  /**
	   * If true, the popover (potentially) ignores `targetOrigin`
	   * and `anchorOrigin` to make itself fit on screen,
	   * which is useful for mobile devices.
	   */
	  canAutoPosition: _propTypes2.default.bool,
	  /**
	   * The content of the popover.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Callback function fired when the popover is requested to be closed.
	   *
	   * @param {string} reason The reason for the close request. Possibles values
	   * are 'clickAway' and 'offScreen'.
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * If true, the popover is visible.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Represents the parent scrollable container.
	   * It can be an element or a string like `window`.
	   */
	  scrollableContainer: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying
	   * elements, and trigger an `onRequestClose('clickAway')` call.
	   */
	  useLayerForClickAway: _propTypes2.default.bool,
	  /**
	   * The zDepth of the popover.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = Popover;

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red50 = exports.red50 = '#ffebee';
	var red100 = exports.red100 = '#ffcdd2';
	var red200 = exports.red200 = '#ef9a9a';
	var red300 = exports.red300 = '#e57373';
	var red400 = exports.red400 = '#ef5350';
	var red500 = exports.red500 = '#f44336';
	var red600 = exports.red600 = '#e53935';
	var red700 = exports.red700 = '#d32f2f';
	var red800 = exports.red800 = '#c62828';
	var red900 = exports.red900 = '#b71c1c';
	var redA100 = exports.redA100 = '#ff8a80';
	var redA200 = exports.redA200 = '#ff5252';
	var redA400 = exports.redA400 = '#ff1744';
	var redA700 = exports.redA700 = '#d50000';
	
	var pink50 = exports.pink50 = '#fce4ec';
	var pink100 = exports.pink100 = '#f8bbd0';
	var pink200 = exports.pink200 = '#f48fb1';
	var pink300 = exports.pink300 = '#f06292';
	var pink400 = exports.pink400 = '#ec407a';
	var pink500 = exports.pink500 = '#e91e63';
	var pink600 = exports.pink600 = '#d81b60';
	var pink700 = exports.pink700 = '#c2185b';
	var pink800 = exports.pink800 = '#ad1457';
	var pink900 = exports.pink900 = '#880e4f';
	var pinkA100 = exports.pinkA100 = '#ff80ab';
	var pinkA200 = exports.pinkA200 = '#ff4081';
	var pinkA400 = exports.pinkA400 = '#f50057';
	var pinkA700 = exports.pinkA700 = '#c51162';
	
	var purple50 = exports.purple50 = '#f3e5f5';
	var purple100 = exports.purple100 = '#e1bee7';
	var purple200 = exports.purple200 = '#ce93d8';
	var purple300 = exports.purple300 = '#ba68c8';
	var purple400 = exports.purple400 = '#ab47bc';
	var purple500 = exports.purple500 = '#9c27b0';
	var purple600 = exports.purple600 = '#8e24aa';
	var purple700 = exports.purple700 = '#7b1fa2';
	var purple800 = exports.purple800 = '#6a1b9a';
	var purple900 = exports.purple900 = '#4a148c';
	var purpleA100 = exports.purpleA100 = '#ea80fc';
	var purpleA200 = exports.purpleA200 = '#e040fb';
	var purpleA400 = exports.purpleA400 = '#d500f9';
	var purpleA700 = exports.purpleA700 = '#aa00ff';
	
	var deepPurple50 = exports.deepPurple50 = '#ede7f6';
	var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
	var deepPurple200 = exports.deepPurple200 = '#b39ddb';
	var deepPurple300 = exports.deepPurple300 = '#9575cd';
	var deepPurple400 = exports.deepPurple400 = '#7e57c2';
	var deepPurple500 = exports.deepPurple500 = '#673ab7';
	var deepPurple600 = exports.deepPurple600 = '#5e35b1';
	var deepPurple700 = exports.deepPurple700 = '#512da8';
	var deepPurple800 = exports.deepPurple800 = '#4527a0';
	var deepPurple900 = exports.deepPurple900 = '#311b92';
	var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
	var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
	var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
	var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';
	
	var indigo50 = exports.indigo50 = '#e8eaf6';
	var indigo100 = exports.indigo100 = '#c5cae9';
	var indigo200 = exports.indigo200 = '#9fa8da';
	var indigo300 = exports.indigo300 = '#7986cb';
	var indigo400 = exports.indigo400 = '#5c6bc0';
	var indigo500 = exports.indigo500 = '#3f51b5';
	var indigo600 = exports.indigo600 = '#3949ab';
	var indigo700 = exports.indigo700 = '#303f9f';
	var indigo800 = exports.indigo800 = '#283593';
	var indigo900 = exports.indigo900 = '#1a237e';
	var indigoA100 = exports.indigoA100 = '#8c9eff';
	var indigoA200 = exports.indigoA200 = '#536dfe';
	var indigoA400 = exports.indigoA400 = '#3d5afe';
	var indigoA700 = exports.indigoA700 = '#304ffe';
	
	var blue50 = exports.blue50 = '#e3f2fd';
	var blue100 = exports.blue100 = '#bbdefb';
	var blue200 = exports.blue200 = '#90caf9';
	var blue300 = exports.blue300 = '#64b5f6';
	var blue400 = exports.blue400 = '#42a5f5';
	var blue500 = exports.blue500 = '#2196f3';
	var blue600 = exports.blue600 = '#1e88e5';
	var blue700 = exports.blue700 = '#1976d2';
	var blue800 = exports.blue800 = '#1565c0';
	var blue900 = exports.blue900 = '#0d47a1';
	var blueA100 = exports.blueA100 = '#82b1ff';
	var blueA200 = exports.blueA200 = '#448aff';
	var blueA400 = exports.blueA400 = '#2979ff';
	var blueA700 = exports.blueA700 = '#2962ff';
	
	var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
	var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
	var lightBlue200 = exports.lightBlue200 = '#81d4fa';
	var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
	var lightBlue400 = exports.lightBlue400 = '#29b6f6';
	var lightBlue500 = exports.lightBlue500 = '#03a9f4';
	var lightBlue600 = exports.lightBlue600 = '#039be5';
	var lightBlue700 = exports.lightBlue700 = '#0288d1';
	var lightBlue800 = exports.lightBlue800 = '#0277bd';
	var lightBlue900 = exports.lightBlue900 = '#01579b';
	var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
	var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
	var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
	var lightBlueA700 = exports.lightBlueA700 = '#0091ea';
	
	var cyan50 = exports.cyan50 = '#e0f7fa';
	var cyan100 = exports.cyan100 = '#b2ebf2';
	var cyan200 = exports.cyan200 = '#80deea';
	var cyan300 = exports.cyan300 = '#4dd0e1';
	var cyan400 = exports.cyan400 = '#26c6da';
	var cyan500 = exports.cyan500 = '#00bcd4';
	var cyan600 = exports.cyan600 = '#00acc1';
	var cyan700 = exports.cyan700 = '#0097a7';
	var cyan800 = exports.cyan800 = '#00838f';
	var cyan900 = exports.cyan900 = '#006064';
	var cyanA100 = exports.cyanA100 = '#84ffff';
	var cyanA200 = exports.cyanA200 = '#18ffff';
	var cyanA400 = exports.cyanA400 = '#00e5ff';
	var cyanA700 = exports.cyanA700 = '#00b8d4';
	
	var teal50 = exports.teal50 = '#e0f2f1';
	var teal100 = exports.teal100 = '#b2dfdb';
	var teal200 = exports.teal200 = '#80cbc4';
	var teal300 = exports.teal300 = '#4db6ac';
	var teal400 = exports.teal400 = '#26a69a';
	var teal500 = exports.teal500 = '#009688';
	var teal600 = exports.teal600 = '#00897b';
	var teal700 = exports.teal700 = '#00796b';
	var teal800 = exports.teal800 = '#00695c';
	var teal900 = exports.teal900 = '#004d40';
	var tealA100 = exports.tealA100 = '#a7ffeb';
	var tealA200 = exports.tealA200 = '#64ffda';
	var tealA400 = exports.tealA400 = '#1de9b6';
	var tealA700 = exports.tealA700 = '#00bfa5';
	
	var green50 = exports.green50 = '#e8f5e9';
	var green100 = exports.green100 = '#c8e6c9';
	var green200 = exports.green200 = '#a5d6a7';
	var green300 = exports.green300 = '#81c784';
	var green400 = exports.green400 = '#66bb6a';
	var green500 = exports.green500 = '#4caf50';
	var green600 = exports.green600 = '#43a047';
	var green700 = exports.green700 = '#388e3c';
	var green800 = exports.green800 = '#2e7d32';
	var green900 = exports.green900 = '#1b5e20';
	var greenA100 = exports.greenA100 = '#b9f6ca';
	var greenA200 = exports.greenA200 = '#69f0ae';
	var greenA400 = exports.greenA400 = '#00e676';
	var greenA700 = exports.greenA700 = '#00c853';
	
	var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
	var lightGreen100 = exports.lightGreen100 = '#dcedc8';
	var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
	var lightGreen300 = exports.lightGreen300 = '#aed581';
	var lightGreen400 = exports.lightGreen400 = '#9ccc65';
	var lightGreen500 = exports.lightGreen500 = '#8bc34a';
	var lightGreen600 = exports.lightGreen600 = '#7cb342';
	var lightGreen700 = exports.lightGreen700 = '#689f38';
	var lightGreen800 = exports.lightGreen800 = '#558b2f';
	var lightGreen900 = exports.lightGreen900 = '#33691e';
	var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
	var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
	var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
	var lightGreenA700 = exports.lightGreenA700 = '#64dd17';
	
	var lime50 = exports.lime50 = '#f9fbe7';
	var lime100 = exports.lime100 = '#f0f4c3';
	var lime200 = exports.lime200 = '#e6ee9c';
	var lime300 = exports.lime300 = '#dce775';
	var lime400 = exports.lime400 = '#d4e157';
	var lime500 = exports.lime500 = '#cddc39';
	var lime600 = exports.lime600 = '#c0ca33';
	var lime700 = exports.lime700 = '#afb42b';
	var lime800 = exports.lime800 = '#9e9d24';
	var lime900 = exports.lime900 = '#827717';
	var limeA100 = exports.limeA100 = '#f4ff81';
	var limeA200 = exports.limeA200 = '#eeff41';
	var limeA400 = exports.limeA400 = '#c6ff00';
	var limeA700 = exports.limeA700 = '#aeea00';
	
	var yellow50 = exports.yellow50 = '#fffde7';
	var yellow100 = exports.yellow100 = '#fff9c4';
	var yellow200 = exports.yellow200 = '#fff59d';
	var yellow300 = exports.yellow300 = '#fff176';
	var yellow400 = exports.yellow400 = '#ffee58';
	var yellow500 = exports.yellow500 = '#ffeb3b';
	var yellow600 = exports.yellow600 = '#fdd835';
	var yellow700 = exports.yellow700 = '#fbc02d';
	var yellow800 = exports.yellow800 = '#f9a825';
	var yellow900 = exports.yellow900 = '#f57f17';
	var yellowA100 = exports.yellowA100 = '#ffff8d';
	var yellowA200 = exports.yellowA200 = '#ffff00';
	var yellowA400 = exports.yellowA400 = '#ffea00';
	var yellowA700 = exports.yellowA700 = '#ffd600';
	
	var amber50 = exports.amber50 = '#fff8e1';
	var amber100 = exports.amber100 = '#ffecb3';
	var amber200 = exports.amber200 = '#ffe082';
	var amber300 = exports.amber300 = '#ffd54f';
	var amber400 = exports.amber400 = '#ffca28';
	var amber500 = exports.amber500 = '#ffc107';
	var amber600 = exports.amber600 = '#ffb300';
	var amber700 = exports.amber700 = '#ffa000';
	var amber800 = exports.amber800 = '#ff8f00';
	var amber900 = exports.amber900 = '#ff6f00';
	var amberA100 = exports.amberA100 = '#ffe57f';
	var amberA200 = exports.amberA200 = '#ffd740';
	var amberA400 = exports.amberA400 = '#ffc400';
	var amberA700 = exports.amberA700 = '#ffab00';
	
	var orange50 = exports.orange50 = '#fff3e0';
	var orange100 = exports.orange100 = '#ffe0b2';
	var orange200 = exports.orange200 = '#ffcc80';
	var orange300 = exports.orange300 = '#ffb74d';
	var orange400 = exports.orange400 = '#ffa726';
	var orange500 = exports.orange500 = '#ff9800';
	var orange600 = exports.orange600 = '#fb8c00';
	var orange700 = exports.orange700 = '#f57c00';
	var orange800 = exports.orange800 = '#ef6c00';
	var orange900 = exports.orange900 = '#e65100';
	var orangeA100 = exports.orangeA100 = '#ffd180';
	var orangeA200 = exports.orangeA200 = '#ffab40';
	var orangeA400 = exports.orangeA400 = '#ff9100';
	var orangeA700 = exports.orangeA700 = '#ff6d00';
	
	var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
	var deepOrange100 = exports.deepOrange100 = '#ffccbc';
	var deepOrange200 = exports.deepOrange200 = '#ffab91';
	var deepOrange300 = exports.deepOrange300 = '#ff8a65';
	var deepOrange400 = exports.deepOrange400 = '#ff7043';
	var deepOrange500 = exports.deepOrange500 = '#ff5722';
	var deepOrange600 = exports.deepOrange600 = '#f4511e';
	var deepOrange700 = exports.deepOrange700 = '#e64a19';
	var deepOrange800 = exports.deepOrange800 = '#d84315';
	var deepOrange900 = exports.deepOrange900 = '#bf360c';
	var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
	var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
	var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
	var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';
	
	var brown50 = exports.brown50 = '#efebe9';
	var brown100 = exports.brown100 = '#d7ccc8';
	var brown200 = exports.brown200 = '#bcaaa4';
	var brown300 = exports.brown300 = '#a1887f';
	var brown400 = exports.brown400 = '#8d6e63';
	var brown500 = exports.brown500 = '#795548';
	var brown600 = exports.brown600 = '#6d4c41';
	var brown700 = exports.brown700 = '#5d4037';
	var brown800 = exports.brown800 = '#4e342e';
	var brown900 = exports.brown900 = '#3e2723';
	
	var blueGrey50 = exports.blueGrey50 = '#eceff1';
	var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
	var blueGrey200 = exports.blueGrey200 = '#b0bec5';
	var blueGrey300 = exports.blueGrey300 = '#90a4ae';
	var blueGrey400 = exports.blueGrey400 = '#78909c';
	var blueGrey500 = exports.blueGrey500 = '#607d8b';
	var blueGrey600 = exports.blueGrey600 = '#546e7a';
	var blueGrey700 = exports.blueGrey700 = '#455a64';
	var blueGrey800 = exports.blueGrey800 = '#37474f';
	var blueGrey900 = exports.blueGrey900 = '#263238';
	
	var grey50 = exports.grey50 = '#fafafa';
	var grey100 = exports.grey100 = '#f5f5f5';
	var grey200 = exports.grey200 = '#eeeeee';
	var grey300 = exports.grey300 = '#e0e0e0';
	var grey400 = exports.grey400 = '#bdbdbd';
	var grey500 = exports.grey500 = '#9e9e9e';
	var grey600 = exports.grey600 = '#757575';
	var grey700 = exports.grey700 = '#616161';
	var grey800 = exports.grey800 = '#424242';
	var grey900 = exports.grey900 = '#212121';
	
	var black = exports.black = '#000000';
	var white = exports.white = '#ffffff';
	
	var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
	var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
	var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
	var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
	var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
	var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
	var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
	var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
	var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(806);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1826);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1825);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1824);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(805);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(807);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(824);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var patch = function () {
	  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, entityName, data) {
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.next = 2;
	            return (0, _Api.custom)({
	              url: '/kjarni/api/v2/' + entityName + '(' + id + ')',
	              method: 'PATCH',
	              data: data
	            });
	
	          case 2:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function patch(_x, _x2, _x3) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var _templateObject = _taggedTemplateLiteral([' or '], [' or ']);
	
	exports.setTab = setTab;
	exports.setManagerYear = setManagerYear;
	exports.setEmployee = setEmployee;
	exports.fetchManagerAppraisal = fetchManagerAppraisal;
	exports.requestAppraisalById = requestAppraisalById;
	exports.requestAppraisalByIdSuccess = requestAppraisalByIdSuccess;
	exports.requestAppraisalByIdFailure = requestAppraisalByIdFailure;
	exports.setDetailIDs = setDetailIDs;
	exports.sortChildren = sortChildren;
	exports.setFinalAnswers = setFinalAnswers;
	exports.setManagerAnswers = setManagerAnswers;
	exports.setEmployeeAnswers = setEmployeeAnswers;
	exports.initAnswers = initAnswers;
	exports.fetchOptions = fetchOptions;
	exports.fetchAppraisalById = fetchAppraisalById;
	exports.fetchAppraisalByIdIfNeeded = fetchAppraisalByIdIfNeeded;
	exports.requestAppraisal = requestAppraisal;
	exports.requestAppraisalSuccess = requestAppraisalSuccess;
	exports.requestAppraisalFailure = requestAppraisalFailure;
	exports.fetchAppraisal = fetchAppraisal;
	exports.resetAppraisalLoading = resetAppraisalLoading;
	exports.fetchAppraisalIfNeeded = fetchAppraisalIfNeeded;
	exports.setEmployeeYear = setEmployeeYear;
	exports.savingAppraisal = savingAppraisal;
	exports.savingAppraisalSuccess = savingAppraisalSuccess;
	exports.savingAppraisalFailure = savingAppraisalFailure;
	exports.saveAppraisal = saveAppraisal;
	exports.submittingAppraisal = submittingAppraisal;
	exports.submittingAppraisalSuccess = submittingAppraisalSuccess;
	exports.submittingAppraisalFailure = submittingAppraisalFailure;
	exports.submitAppraisal = submitAppraisal;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reapop = __webpack_require__(44);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _xSelect = __webpack_require__(188);
	
	var _Api = __webpack_require__(21);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _isEmpty = __webpack_require__(98);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _orderBy = __webpack_require__(372);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _includes = __webpack_require__(204);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _flattenDeep = __webpack_require__(569);
	
	var _flattenDeep2 = _interopRequireDefault(_flattenDeep);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function setTab(tab) {
	  return {
	    type: types.SET_APPRAISAL_TAB,
	    tab: tab
	  };
	}
	
	function setManagerYear(year) {
	  return {
	    type: types.SET_MANAGER_YEAR,
	    year: year
	  };
	}
	
	function setEmployee(employee) {
	  return {
	    type: types.SET_EMPLOYEE,
	    employee: employee
	  };
	}
	
	function requestManagerAppraisal() {
	  return {
	    type: types.REQUEST_MANAGER_APPRAISAL
	  };
	}
	
	function requestManagerAppraisalSuccess(appraisals) {
	  return {
	    type: types.REQUEST_MANAGER_APPRAISAL_SUCCESS,
	    appraisals: appraisals
	  };
	}
	
	function requestManagerAppraisalFailure(error) {
	  return {
	    type: types.REQUEST_MANAGER_APPRAISAL_FAILURE,
	    error: error
	  };
	}
	
	function fetchManagerAppraisal() {
	  return function (dispatch, getState) {
	    dispatch(requestManagerAppraisal());
	
	    var _getState = getState(),
	        _getState$loginReduce = _getState.loginReducer.user,
	        EmployeeMasterID = _getState$loginReduce.EmployeeMasterID,
	        token = _getState$loginReduce.token;
	
	    var config = {
	      entity: 'PMAppraisal',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: 'Entity/ManagerEmployeeMasterID eq ' + EmployeeMasterID,
	        $orderby: 'Entity/ManagerDueDate asc'
	      }
	    };
	    return (0, _Api.listWM)(config).then(function (_ref) {
	      var data = _ref.data;
	      return dispatch(requestManagerAppraisalSuccess(data));
	    }).catch(function (error) {
	      return dispatch(requestManagerAppraisalFailure(error));
	    });
	  };
	}
	
	function requestAppraisalById(appraisalId) {
	  return {
	    type: types.REQUEST_APPRAISAL_BY_ID,
	    appraisalId: appraisalId
	  };
	}
	
	function requestAppraisalByIdSuccess(appraisal, answers) {
	  return {
	    type: types.REQUEST_APPRAISAL_BY_ID_SUCCESS,
	    appraisal: appraisal,
	    answers: answers
	  };
	}
	
	function requestAppraisalByIdFailure(error, appraisalId) {
	  return {
	    type: types.REQUEST_APPRAISAL_BY_ID_FAILURE,
	    error: error,
	    appraisalId: appraisalId
	  };
	}
	
	function setDetailIDs(detailIDs) {
	  return {
	    type: types.SET_DETAIL_IDS,
	    detailIDs: detailIDs
	  };
	}
	
	/* Helper function to sort the QAElement Children */
	function sortChildren(obj) {
	  if (obj.Children) {
	    return _extends({}, obj.Entity, obj, { Children: (0, _orderBy2.default)(obj.Children.map(sortChildren), ['Order'], ['asc']) });
	  }
	  return _extends({}, obj.Entity, obj);
	}
	
	function setFinalAnswers(appraisalId, answers) {
	  return {
	    type: types.SET_FINAL_ANSWERS,
	    appraisalId: appraisalId,
	    answers: answers
	  };
	}
	
	function setManagerAnswers(appraisalId, answers) {
	  return {
	    type: types.SET_MANAGER_ANSWERS,
	    appraisalId: appraisalId,
	    answers: answers
	  };
	}
	
	function setEmployeeAnswers(appraisalId, answers) {
	  return {
	    type: types.SET_EMPLOYEE_ANSWERS,
	    appraisalId: appraisalId,
	    answers: answers
	  };
	}
	
	/*
	  When fetching an appraisal we need to check if it has answers and if not we need to initalize
	  root QAAnswer entities for the Appraisal
	*/
	function initAnswers(appraisal) {
	  return function (dispatch, getState) {
	    var EmployeeDetailID = appraisal.EmployeeDetailID,
	        EmployeeDueDate = appraisal.EmployeeDueDate,
	        EmployeeQAAnswerID = appraisal.EmployeeQAAnswerID,
	        FinalQAAnswerID = appraisal.FinalQAAnswerID,
	        ManagerDueDate = appraisal.ManagerDueDate,
	        ManagerQAAnswerID = appraisal.ManagerQAAnswerID,
	        ManagerStatus = appraisal.ManagerStatus,
	        PMAppraisalID = appraisal.PMAppraisalID,
	        PMForm = appraisal.PMForm;
	
	    var _getState2 = getState(),
	        _getState2$loginReduc = _getState2.loginReducer.user,
	        detailIDs = _getState2$loginReduc.detailIDs,
	        token = _getState2$loginReduc.token;
	
	    var isEmployee = (0, _includes2.default)(detailIDs, EmployeeDetailID);
	
	    var answerConfig = {
	      entity: 'QAAnswer',
	      headers: { Authorization: 'Bearer ' + token },
	      data: {
	        QAElementID: PMForm.QAElement.QAElementID
	      }
	    };
	    if (isEmployee && !EmployeeQAAnswerID) {
	      (0, _Api.create)(answerConfig).then(function (rootAnswer) {
	        var rootAnswerID = rootAnswer.data.QAAnswerID;
	
	        /* Check if we should update the AnswerID for the Employee or the Manager */
	        /* const conf = {
	          entity: 'PMAppraisal',
	          headers: { Authorization: `Bearer ${token}` },
	          data: {
	            ...appraisal.Entity,
	            EmployeeQAAnswerID: rootAnswerID,
	          },
	        }; */
	
	        /* Save the Appraisal with updated AnswerIDs */
	        var data = {
	          PMAppraisalID: PMAppraisalID,
	          EmployeeQAAnswerID: rootAnswerID
	        };
	        patch(PMAppraisalID, 'PMAppraisals', data).then(function () {
	          var groups = PMForm.QAElements.filter(function (e) {
	            return e.QAElementType === 2;
	          });
	
	          /* To initialize the answers correctly we need to create QAAnswers for
	          all the groups in the QAElement tree. This is done here so that it is
	          not required on submit or save of the form */
	          var createGroups = groups.map(function (_ref3) {
	            var QAElementID = _ref3.QAElementID,
	                Label = _ref3.Label,
	                Order = _ref3.Order;
	            return (0, _Api.create)({
	              entity: 'QAAnswer',
	              headers: { Authorization: 'Bearer ' + token },
	              data: {
	                QAAnswerParentID: rootAnswerID,
	                RootAnswerID: rootAnswerID,
	                QAElementID: QAElementID,
	                QAAnswerValue: Label,
	                QAAnswerText: Label,
	                QAAnswerOrder: Order
	              }
	            });
	          });
	          Promise.all(createGroups).then(function (QAA) {
	            dispatch(setEmployeeAnswers(PMAppraisalID, { RootAnswerID: rootAnswer.data.QAAnswerID, QAAnswers: QAA.map(function (x) {
	                return _extends({}, x.data);
	              }) }));
	            dispatch(requestAppraisalByIdSuccess(_extends({}, appraisal, { EmployeeQAAnswerID: rootAnswerID, Entity: _extends({}, (0, _lodash.get)(appraisal, 'Entity'), { EmployeeQAAnswerID: rootAnswerID }) })));
	          }).catch(function (error) {
	            return dispatch(requestAppraisalByIdFailure(error, PMAppraisalID));
	          });
	        }).catch(function (error) {
	          return dispatch(requestAppraisalByIdFailure(error, PMAppraisalID));
	        });
	      }).catch(function (error) {
	        return dispatch(requestAppraisalByIdFailure(error, PMAppraisalID));
	      });
	    } else if (isEmployee) {
	      var RootAnswerID = EmployeeQAAnswerID;
	      var allRoots = ManagerQAAnswerID + ', ' + EmployeeQAAnswerID + ', ' + FinalQAAnswerID;
	      var isFinal = ManagerStatus === 2 || new Date(ManagerDueDate).getTime() < Date.now() && new Date(EmployeeDueDate).getTime() < Date.now();
	      var conf = {
	        entity: 'QAAnswer',
	        headers: { Authorization: 'Bearer ' + token },
	        data: (0, _xSelect.xSelectSingle)([{ field: 'RootAnswerID', value: '' + (isFinal ? allRoots : RootAnswerID), relation: 'eq' }])
	      };
	      (0, _Api.list)(conf).then(function (QAA) {
	        var QAAnswers = QAA.data;
	        if (isFinal) {
	          dispatch(setFinalAnswers(PMAppraisalID, { RootAnswerID: FinalQAAnswerID, QAAnswers: QAAnswers.filter(function (x) {
	              return x.RootAnswerID === FinalQAAnswerID;
	            }) }));
	          dispatch(setManagerAnswers(PMAppraisalID, { RootAnswerID: ManagerQAAnswerID, QAAnswers: QAAnswers.filter(function (x) {
	              return x.RootAnswerID === ManagerQAAnswerID;
	            }) }));
	          dispatch(setEmployeeAnswers(PMAppraisalID, { RootAnswerID: EmployeeQAAnswerID, QAAnswers: QAAnswers.filter(function (x) {
	              return x.RootAnswerID === EmployeeQAAnswerID;
	            }) }));
	        } else if (isEmployee) {
	          dispatch(setEmployeeAnswers(PMAppraisalID, { RootAnswerID: RootAnswerID, QAAnswers: QAAnswers }));
	        }
	        dispatch(requestAppraisalByIdSuccess(appraisal));
	      }).catch(function (error) {
	        return dispatch(requestAppraisalByIdFailure(error, PMAppraisalID));
	      });
	    } else {
	      /* Should never happen, only when trying to access appraisal tha is not owned
	      This prevents any user that is not registered to an Appraisal from fetching
	      it either unknowingly or on purpose. IDEA: Might still be good idea to add GUID */
	      dispatch(requestAppraisalByIdSuccess(appraisal));
	    }
	  };
	}
	
	/*
	  Fetches the QAInput model for each QAElement adding it to the
	  QAElement passed and returning the updated element.
	  TODO: Do not perform this request for elements that have
	  no InputOptions or ScaleEntries
	*/
	function fetchOptions(qae, token) {
	  var QAInputID = qae.QAInputID;
	
	  var config = {
	    entity: 'QAInput',
	    entityID: QAInputID,
	    headers: { Authorization: 'Bearer ' + token }
	  };
	
	  return (0, _Api.read)(config).then(function (QAInput) {
	    return _extends({}, qae, { QAInput: QAInput.data });
	  });
	}
	
	/* Helper function that goes through all the QAElement childrent present and
	moves them to a single array. */
	var flattenChildren = function flattenChildren(obj) {
	  if (obj.Children) {
	    return [obj].concat(_toConsumableArray((0, _flattenDeep2.default)(obj.Children.map(flattenChildren))));
	  }
	  return obj;
	};
	
	function fetchAppraisalById(entityID) {
	  return function (dispatch, getState) {
	    dispatch(requestAppraisalById(entityID));
	
	    var _getState3 = getState(),
	        _getState3$loginReduc = _getState3.loginReducer.user,
	        token = _getState3$loginReduc.token,
	        EmployeeMasterID = _getState3$loginReduc.EmployeeMasterID;
	
	    var detailConfig = {
	      entity: 'EmployeeDetail',
	      headers: { Authorization: 'Bearer ' + token },
	      data: (0, _xSelect.xSelectSingle)([{ field: 'EmployeeMasterID', value: EmployeeMasterID, relation: 'eq' }])
	    };
	
	    (0, _Api.list)(detailConfig).then(function (detailIDs) {
	      dispatch(setDetailIDs(detailIDs.data));
	      var config = {
	        entity: 'PMAppraisal',
	        entityID: entityID,
	        headers: { Authorization: 'Bearer ' + token }
	      };
	      (0, _Api.readWM)(config).then(function (_ref4) {
	        var data = _ref4.data;
	
	        var appraisal = data;
	        if (appraisal.ManagerEmployeeMasterID !== EmployeeMasterID && !(0, _includes2.default)((0, _map2.default)(detailIDs.data, function (x) {
	          return x.EmployeeDetailID;
	        }), appraisal.EmployeeDetailID)) {
	          return dispatch(requestAppraisalByIdFailure(_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.error.mine' }), entityID));
	        } else if (!appraisal.PMFormID) {
	          return dispatch(requestAppraisalByIdFailure(_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.error.form' }), entityID));
	        }
	        var configForm = {
	          entity: 'PMForm',
	          entityID: appraisal.PMFormID,
	          headers: { Authorization: 'Bearer ' + token }
	        };
	        return (0, _Api.read)(configForm).then(function (PMF) {
	          var PMForm = PMF.data;
	          var configElement = {
	            entity: 'QAElement',
	            entityID: PMForm.QAElementID,
	            headers: { Authorization: 'Bearer ' + token }
	          };
	          (0, _Api.readWM)(configElement).then(function (QAElement) {
	            var initQAElements = flattenChildren(sortChildren(QAElement.data));
	            var QAElements = initQAElements.map(function (e) {
	              if (e.QAInput) {
	                return _extends({}, e, e.Entity, { QAInput: _extends({}, e.QAInput.Entity, e.QAInput) });
	              }
	              return _extends({}, e, e.Entity);
	            });
	            dispatch(initAnswers(_extends({}, appraisal, {
	              PMForm: _extends({}, PMForm, {
	                QAElement: sortChildren(QAElement.data),
	                QAElements: QAElements
	              })
	            })));
	          }).catch(function (error) {
	            return dispatch(requestAppraisalByIdFailure(error, entityID));
	          });
	        }).catch(function (error) {
	          return dispatch(requestAppraisalByIdFailure(error, entityID));
	        });
	      }).catch(function (error) {
	        return dispatch(requestAppraisalByIdFailure(error, entityID));
	      });
	    }).catch(function (error) {
	      return dispatch(requestAppraisalByIdFailure(error, entityID));
	    });
	  };
	}
	
	function fetchAppraisalByIdIfNeeded(id) {
	  return function (dispatch, getState) {
	    return ((0, _isEmpty2.default)(getState().Appraisal.appraisalsById[id]) || getState().Appraisal.expiredById[id]) && dispatch(fetchAppraisalById(id));
	  };
	}
	
	function requestAppraisal() {
	  return {
	    type: types.REQUEST_APPRAISAL
	  };
	}
	
	function requestAppraisalSuccess(appraisals, openAppraisals) {
	  return {
	    type: types.REQUEST_APPRAISAL_SUCCESS,
	    appraisals: appraisals,
	    openAppraisals: openAppraisals
	  };
	}
	
	function requestAppraisalFailure(error) {
	  return {
	    type: types.REQUEST_APPRAISAL_FAILURE,
	    error: error
	  };
	}
	
	function fetchAppraisal() {
	  return function (dispatch, getState) {
	    dispatch(requestAppraisal());
	
	    var _getState4 = getState(),
	        _getState4$loginReduc = _getState4.loginReducer.user,
	        EmployeeMasterID = _getState4$loginReduc.EmployeeMasterID,
	        token = _getState4$loginReduc.token;
	
	    var detailConfig = {
	      entity: 'EmployeeDetail',
	      headers: { Authorization: 'Bearer ' + token },
	      data: (0, _xSelect.xSelectSingle)([{ field: 'EmployeeMasterID', value: EmployeeMasterID, relation: 'eq' }])
	    };
	
	    return (0, _Api.list)(detailConfig).then(function (ids) {
	      var config = {
	        entity: 'PMAppraisal',
	        headers: { Authorization: 'Bearer ' + token },
	        params: {
	          $filter: '' + ids.data.map(function (_ref5) {
	            var EmployeeDetailID = _ref5.EmployeeDetailID;
	            return 'Entity/EmployeeDetailID eq ' + EmployeeDetailID;
	          }).join(_templateObject),
	          $orderby: 'Entity/EmployeeDueDate asc'
	        }
	      };
	      (0, _Api.listWM)(config).then(function (_ref6) {
	        var appraisals = _ref6.data;
	
	        var today = new Date();
	        today.setHours(0, 0, 0, 0);
	        var openAppraisals = (0, _lodash.filter)(appraisals, function (a) {
	          return new Date(a.EmployeeDueDate).getTime() >= today.getTime() && a.EmployeeStatus < 2;
	        });
	        dispatch(requestAppraisalSuccess(appraisals, openAppraisals));
	      }).catch(function (error) {
	        return dispatch(requestAppraisalFailure(error));
	      });
	    }).catch(function (error) {
	      return dispatch(requestAppraisalFailure(error));
	    });
	  };
	}
	
	function resetAppraisalLoading() {
	  return {
	    type: types.RESET_APPRAISAL_LOADING
	  };
	}
	
	function fetchAppraisalIfNeeded() {
	  return function (dispatch, getState) {
	    return (0, _isEmpty2.default)(getState().Appraisal.appraisals) && dispatch(fetchAppraisal());
	  };
	}
	
	function setEmployeeYear(year) {
	  return {
	    type: types.SET_EMPLOYEE_YEAR,
	    year: year
	  };
	}
	
	function savingAppraisal() {
	  return {
	    type: types.SAVING_APPRAISAL
	  };
	}
	
	function savingAppraisalSuccess(id) {
	  return {
	    type: types.SAVING_APPRAISAL_SUCCESS,
	    id: id
	  };
	}
	
	function savingAppraisalFailure(error) {
	  return {
	    type: types.SAVING_APPRAISAL_FAILURE,
	    error: error
	  };
	}
	
	function saveAppraisal(answers, answersToDelete, id, cb) {
	  return function (dispatch, getState) {
	    dispatch(savingAppraisal());
	
	    var _getState5 = getState(),
	        appraisalsById = _getState5.Appraisal.appraisalsById,
	        token = _getState5.loginReducer.user.token;
	
	    var appraisal = appraisalsById[id];
	
	    /* Delete unchecked checkbox answers first */
	    var deletePromises = (answersToDelete || []).map(function (answerId) {
	      return (0, _Api.remove)({ entity: 'QAAnswer', data: { QAAnswerID: answerId }, headers: { Authorization: 'Bearer ' + token } });
	    });
	
	    /* Then save/create the remaining answers */
	    var savePromises = answers.map(function (data) {
	      if (data.QAAnswerID) {
	        return (0, _Api.save)({ entity: 'QAAnswer', data: data, headers: { Authorization: 'Bearer ' + token } });
	      }
	      return (0, _Api.create)({ entity: 'QAAnswer', data: data, headers: { Authorization: 'Bearer ' + token } });
	    });
	
	    Promise.all([].concat(_toConsumableArray(deletePromises), _toConsumableArray(savePromises))).then(function () {
	      if (cb) {
	        dispatch(savingAppraisalSuccess(id));
	        dispatch(initAnswers(appraisal));
	        cb();
	      } else {
	        var data = {
	          PMAppraisalID: (0, _lodash.toNumber)(id),
	          EmployeeStatus: 'Started'
	        };
	        patch(id, 'PMAppraisals', data).then(function () {
	          dispatch(fetchAppraisal());
	          dispatch(savingAppraisalSuccess(id));
	          dispatch(initAnswers(appraisal));
	          dispatch((0, _reapop.addNotification)({
	            title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.notification.saved' }),
	            message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.notification.saved.message' }),
	            status: 'success',
	            dismissible: true,
	            dismissAfter: 4000
	          }));
	        }).catch(function (error) {
	          return dispatch(savingAppraisalFailure(error));
	        });
	      }
	    }).catch(function (error) {
	      return dispatch(savingAppraisalFailure(error));
	    });
	  };
	}
	
	function submittingAppraisal() {
	  return {
	    type: types.SUBMIT_APPRAISAL
	  };
	}
	
	function submittingAppraisalSuccess(id) {
	  return {
	    type: types.SUBMIT_APPRAISAL_SUCCESS,
	    id: id
	  };
	}
	
	function submittingAppraisalFailure(error) {
	  return {
	    type: types.SUBMIT_APPRAISAL_FAILURE,
	    error: error
	  };
	}
	
	function submitAppraisal(answers, answersToDelete, appraisalId) {
	  return function (dispatch) {
	    dispatch(submittingAppraisal());
	    dispatch(saveAppraisal(answers, answersToDelete, appraisalId, function () {
	      /* should never happen on emp web */
	      // const isManager = ManagerEmployeeMasterID === EmployeeMasterID;
	      // const isFinal = (ManagerStatus === 2 && EmployeeStatus === 2) || (ManagerStatus === 2 && (new Date(EmployeeDueDate).getTime() < Date.now()));
	      var data = {
	        PMAppraisalID: (0, _lodash.toNumber)(appraisalId),
	        EmployeeStatus: 'Finished'
	      };
	      patch(appraisalId, 'PMAppraisals', data).then(function () {
	        dispatch((0, _reapop.addNotification)({
	          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.notification.submitted' }),
	          message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.notification.submitted.message' }),
	          status: 'success',
	          dismissible: true,
	          dismissAfter: 4000
	        }));
	        dispatch(fetchAppraisal());
	        dispatch(submittingAppraisalSuccess(appraisalId));
	        dispatch((0, _reactRouterRedux.replace)('/appraisals'));
	      }).catch(function (error) {
	        return dispatch(savingAppraisalFailure(error));
	      });
	    }));
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(setTab, 'setTab', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(setManagerYear, 'setManagerYear', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(setEmployee, 'setEmployee', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(requestManagerAppraisal, 'requestManagerAppraisal', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(requestManagerAppraisalSuccess, 'requestManagerAppraisalSuccess', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(requestManagerAppraisalFailure, 'requestManagerAppraisalFailure', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(fetchManagerAppraisal, 'fetchManagerAppraisal', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(patch, 'patch', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(requestAppraisalById, 'requestAppraisalById', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(requestAppraisalByIdSuccess, 'requestAppraisalByIdSuccess', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(requestAppraisalByIdFailure, 'requestAppraisalByIdFailure', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(setDetailIDs, 'setDetailIDs', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(sortChildren, 'sortChildren', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(setFinalAnswers, 'setFinalAnswers', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(setManagerAnswers, 'setManagerAnswers', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(setEmployeeAnswers, 'setEmployeeAnswers', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(initAnswers, 'initAnswers', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(fetchOptions, 'fetchOptions', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(flattenChildren, 'flattenChildren', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(fetchAppraisalById, 'fetchAppraisalById', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(fetchAppraisalByIdIfNeeded, 'fetchAppraisalByIdIfNeeded', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(requestAppraisal, 'requestAppraisal', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(requestAppraisalSuccess, 'requestAppraisalSuccess', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(requestAppraisalFailure, 'requestAppraisalFailure', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(fetchAppraisal, 'fetchAppraisal', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(resetAppraisalLoading, 'resetAppraisalLoading', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(fetchAppraisalIfNeeded, 'fetchAppraisalIfNeeded', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(setEmployeeYear, 'setEmployeeYear', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(savingAppraisal, 'savingAppraisal', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(savingAppraisalSuccess, 'savingAppraisalSuccess', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(savingAppraisalFailure, 'savingAppraisalFailure', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(saveAppraisal, 'saveAppraisal', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(submittingAppraisal, 'submittingAppraisal', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(submittingAppraisalSuccess, 'submittingAppraisalSuccess', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(submittingAppraisalFailure, 'submittingAppraisalFailure', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(submitAppraisal, 'submitAppraisal', 'D:/a/1/s/src/web/employee/src/actions/Appraisal.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fitnessGrantRegisterAndUpload = exports.benefitUpload = exports.fitnessGrantRegister = exports.grantRegisterFailure = exports.grantRegisterSuccess = exports.grantRegisterRequest = exports.fitnessGrantRegisterFailure = exports.fitnessGrantRegisterSuccess = exports.fitnessGrantRegisterRequest = exports.fetchBenefits = exports.requestBenefitsFailure = exports.requestBenefitsSuccess = exports.requestBenefits = undefined;
	
	var _reapop = __webpack_require__(44);
	
	var _get = __webpack_require__(96);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _ActionTypes = __webpack_require__(18);
	
	var _Api = __webpack_require__(21);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var requestBenefits = exports.requestBenefits = function requestBenefits() {
	  return {
	    type: _ActionTypes.REQUEST_BENEFITS
	  };
	};
	
	var requestBenefitsSuccess = exports.requestBenefitsSuccess = function requestBenefitsSuccess(benefits) {
	  return {
	    type: _ActionTypes.REQUEST_BENEFITS_SUCCESS,
	    benefits: benefits
	  };
	};
	
	var requestBenefitsFailure = exports.requestBenefitsFailure = function requestBenefitsFailure(error) {
	  return {
	    type: _ActionTypes.REQUEST_BENEFITS_FAILURE,
	    error: error
	  };
	};
	
	var fetchBenefits = exports.fetchBenefits = function fetchBenefits() {
	  return function (dispatch, getState) {
	    dispatch(requestBenefits());
	
	    var _getState = getState(),
	        _getState$loginReduce = _getState.loginReducer.user,
	        EmployeeMasterID = _getState$loginReduce.EmployeeMasterID,
	        token = _getState$loginReduce.token;
	
	    var config = {
	      headers: { Authorization: 'Bearer ' + token },
	      method: 'GET',
	      url: '/api/HrData/HrBenefitPayWage?masterID=' + EmployeeMasterID
	    };
	    (0, _Api.custom)(config).then(function (res) {
	      return dispatch(requestBenefitsSuccess(res.data));
	    }).catch(function (err) {
	      return dispatch(requestBenefitsFailure(err));
	    });
	  };
	};
	
	var fitnessGrantRegisterRequest = exports.fitnessGrantRegisterRequest = function fitnessGrantRegisterRequest(benefitId) {
	  return {
	    type: _ActionTypes.FITNESS_GRANT_REGISTER_REQUEST,
	    benefitId: benefitId
	  };
	};
	
	var fitnessGrantRegisterSuccess = exports.fitnessGrantRegisterSuccess = function fitnessGrantRegisterSuccess(benefitId) {
	  return {
	    type: _ActionTypes.FITNESS_GRANT_REGISTER_SUCCESS,
	    benefitId: benefitId
	  };
	};
	
	var fitnessGrantRegisterFailure = exports.fitnessGrantRegisterFailure = function fitnessGrantRegisterFailure(error, benefitId) {
	  return {
	    type: _ActionTypes.FITNESS_GRANT_REGISTER_FAILURE,
	    benefitId: benefitId,
	    error: error
	  };
	};
	
	var grantRegisterRequest = exports.grantRegisterRequest = function grantRegisterRequest() {
	  return {
	    type: _ActionTypes.GRANT_REGISTER_REQUEST
	  };
	};
	
	var grantRegisterSuccess = exports.grantRegisterSuccess = function grantRegisterSuccess() {
	  return {
	    type: _ActionTypes.GRANT_REGISTER_SUCCESS
	  };
	};
	
	var grantRegisterFailure = exports.grantRegisterFailure = function grantRegisterFailure(error) {
	  return {
	    type: _ActionTypes.GRANT_REGISTER_FAILURE,
	    error: error
	  };
	};
	
	var fitnessGrantRegister = exports.fitnessGrantRegister = function fitnessGrantRegister(HrBenefitID, Amount, cb) {
	  return function (dispatch, getState) {
	    dispatch(fitnessGrantRegisterRequest(HrBenefitID));
	
	    var _getState2 = getState(),
	        token = _getState2.loginReducer.user.token;
	
	    var config = {
	      headers: { Authorization: 'Bearer ' + token },
	      method: 'POST',
	      url: '/api/EmployeeFitnessGrant/Register',
	      data: {
	        HrBenefitID: HrBenefitID,
	        Amount: Amount
	      }
	    };
	    (0, _Api.custom)(config).then(function () {
	      if (cb) cb();
	      dispatch((0, _reapop.addNotification)({
	        title: 'Móttekið!',
	        message: 'Umsókn um styrk var send og mun staða uppfærast næstu mánaðarmót.',
	        status: 'success',
	        dismissible: true,
	        dismissAfter: 16000
	      }));
	      dispatch(fitnessGrantRegisterSuccess(HrBenefitID));
	      dispatch(fetchBenefits());
	    }).catch(function (err) {
	      dispatch((0, _reapop.addNotification)({
	        title: 'Villa',
	        message: 'Ekki t\xF3kst a\xF0 s\xE6kja um styrk. ' + (0, _get2.default)(err, 'Message', ''),
	        status: 'error',
	        dismissible: true,
	        dismissAfter: 16000
	      }));
	      dispatch(fitnessGrantRegisterFailure(err, HrBenefitID));
	    });
	  };
	};
	
	var uploadFile = function () {
	  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref2, idCallBack, ownerType, token, EmployeeMasterID) {
	    var file = _ref2.file,
	        fileType = _ref2.fileType;
	    var reader, AddDate, fileResult, FileSource, Name, Extension, config, createResult;
	    return regeneratorRuntime.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            _context.prev = 0;
	            reader = new FileReader();
	            AddDate = new Date().toISOString();
	            _context.next = 5;
	            return new Promise(function (resolve, reject) {
	              reader.onload = function () {
	                return resolve(reader.result);
	              };
	              reader.onerror = reject;
	              reader.readAsDataURL(file);
	            });
	
	          case 5:
	            fileResult = _context.sent;
	            FileSource = fileResult.substring(fileResult.indexOf(',') + 1);
	            Name = file.name.substring(0, file.name.indexOf('.'));
	            Extension = file.name.substring(file.name.indexOf('.'));
	            config = {
	              entity: 'FileRepository',
	              headers: { Authorization: 'Bearer ' + token },
	              data: {
	                EntityType: ownerType.FileRepositoryEntityOwnerTypeID,
	                Entity_ID: EmployeeMasterID,
	                FileSource: FileSource,
	                ObjectDocumentType: fileType,
	                Name: Name,
	                Extension: Extension,
	                AddDate: AddDate
	              }
	            };
	            _context.next = 12;
	            return (0, _Api.create)(config);
	
	          case 12:
	            createResult = _context.sent;
	
	            if (idCallBack) {
	              idCallBack(createResult.data);
	            }
	            _context.next = 19;
	            break;
	
	          case 16:
	            _context.prev = 16;
	            _context.t0 = _context['catch'](0);
	            throw _context.t0;
	
	          case 19:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, undefined, [[0, 16]]);
	  }));
	
	  return function uploadFile(_x, _x2, _x3, _x4, _x5) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var benefitUpload = exports.benefitUpload = function benefitUpload(_ref3, cb, Email, EmailCallBack) {
	  var files = _ref3.files,
	      fileType = _ref3.fileType;
	  return function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	      var _getState3, ownerTypes, _getState3$loginReduc, token, EmployeeMasterID, uploadPromises;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              dispatch(grantRegisterRequest());
	              _context3.prev = 1;
	              _getState3 = getState(), ownerTypes = _getState3.FileReducer.ownerTypes, _getState3$loginReduc = _getState3.loginReducer.user, token = _getState3$loginReduc.token, EmployeeMasterID = _getState3$loginReduc.EmployeeMasterID;
	              uploadPromises = Array.from(files).map(function () {
	                var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(file) {
	                  var ownerType;
	                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
	                    while (1) {
	                      switch (_context2.prev = _context2.next) {
	                        case 0:
	                          ownerType = (0, _lodash.find)(ownerTypes, ['Value', 'EmployeeMaster']);
	
	                          if (!(ownerType === undefined || !ownerType.FileRepositoryEntityOwnerTypeID)) {
	                            _context2.next = 6;
	                            break;
	                          }
	
	                          dispatch((0, _reapop.addNotification)({
	                            title: 'Villa',
	                            message: 'Ekki er hægt að vista skjal á EmployeeMaster',
	                            status: 'error',
	                            dismissible: true,
	                            dismissAfter: 16000
	                          }));
	                          return _context2.abrupt('return');
	
	                        case 6:
	                          if (!(file === undefined || !file.name)) {
	                            _context2.next = 9;
	                            break;
	                          }
	
	                          dispatch((0, _reapop.addNotification)({
	                            title: 'Villa',
	                            message: 'Ekki neitt skjal var valið',
	                            status: 'error',
	                            dismissible: true,
	                            dismissAfter: 16000
	                          }));
	                          return _context2.abrupt('return');
	
	                        case 9:
	                          _context2.next = 11;
	                          return uploadFile({ file: file, fileType: fileType }, cb, ownerType, token, EmployeeMasterID);
	
	                        case 11:
	                        case 'end':
	                          return _context2.stop();
	                      }
	                    }
	                  }, _callee2, undefined);
	                }));
	
	                return function (_x8) {
	                  return _ref5.apply(this, arguments);
	                };
	              }());
	              _context3.next = 6;
	              return Promise.all(uploadPromises);
	
	            case 6:
	              dispatch((0, _reapop.addNotification)({
	                title: 'Vistað',
	                message: 'Viðhengi hefur verið vistað í skjalaskáp',
	                status: 'success',
	                dismissible: true,
	                dismissAfter: 4000
	              }));
	              if (Email) {
	                EmailCallBack();
	              }
	
	              dispatch(grantRegisterSuccess());
	
	              _context3.next = 15;
	              break;
	
	            case 11:
	              _context3.prev = 11;
	              _context3.t0 = _context3['catch'](1);
	
	              dispatch((0, _reapop.addNotification)({
	                title: 'Villa',
	                message: 'Ekki t\xF3kst a\xF0 s\xE6kja um styrk. ' + (0, _get2.default)(_context3.t0, 'Message', ''),
	                status: 'error',
	                dismissible: true,
	                dismissAfter: 16000
	              }));
	              dispatch(grantRegisterFailure(_context3.t0));
	
	            case 15:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[1, 11]]);
	    }));
	
	    return function (_x6, _x7) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	};
	
	var fitnessGrantRegisterAndUpload = exports.fitnessGrantRegisterAndUpload = function fitnessGrantRegisterAndUpload(HrBenefitID, Amount, files, fileType, cb, Email, EmailCallBack) {
	  return function () {
	    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
	      var _getState4, ownerTypes, _getState4$loginReduc, token, EmployeeMasterID, uploadPromises, config;
	
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              dispatch(fitnessGrantRegisterRequest(HrBenefitID));
	              _context5.prev = 1;
	              _getState4 = getState(), ownerTypes = _getState4.FileReducer.ownerTypes, _getState4$loginReduc = _getState4.loginReducer.user, token = _getState4$loginReduc.token, EmployeeMasterID = _getState4$loginReduc.EmployeeMasterID;
	              uploadPromises = Array.from(files).map(function () {
	                var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(file) {
	                  var ownerType;
	                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          ownerType = (0, _lodash.find)(ownerTypes, ['Value', 'EmployeeMaster']);
	
	                          if (!(ownerType === undefined || !ownerType.FileRepositoryEntityOwnerTypeID)) {
	                            _context4.next = 6;
	                            break;
	                          }
	
	                          dispatch((0, _reapop.addNotification)({
	                            title: 'Villa',
	                            message: 'Ekki er hægt að vista skjal á EmployeeMaster',
	                            status: 'error',
	                            dismissible: true,
	                            dismissAfter: 16000
	                          }));
	                          return _context4.abrupt('return');
	
	                        case 6:
	                          if (!(file === undefined || !file.name)) {
	                            _context4.next = 9;
	                            break;
	                          }
	
	                          dispatch((0, _reapop.addNotification)({
	                            title: 'Villa',
	                            message: 'Ekki neitt skjal var valið',
	                            status: 'error',
	                            dismissible: true,
	                            dismissAfter: 16000
	                          }));
	                          return _context4.abrupt('return');
	
	                        case 9:
	                          _context4.next = 11;
	                          return uploadFile({ file: file, fileType: fileType }, cb, ownerType, token, EmployeeMasterID);
	
	                        case 11:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, undefined);
	                }));
	
	                return function (_x11) {
	                  return _ref7.apply(this, arguments);
	                };
	              }());
	              _context5.next = 6;
	              return Promise.all(uploadPromises);
	
	            case 6:
	              dispatch((0, _reapop.addNotification)({
	                title: 'Vistað',
	                message: 'Viðhengi hefur verið vistað í skjalaskáp',
	                status: 'success',
	                dismissible: true,
	                dismissAfter: 4000
	              }));
	              config = {
	                headers: { Authorization: 'Bearer ' + token },
	                method: 'POST',
	                url: '/api/EmployeeFitnessGrant/Register',
	                data: {
	                  HrBenefitID: HrBenefitID,
	                  Amount: Amount
	                }
	              };
	              _context5.next = 10;
	              return (0, _Api.custom)(config);
	
	            case 10:
	
	              dispatch((0, _reapop.addNotification)({
	                title: 'Móttekið!',
	                message: 'Umsókn um styrk var send og mun staða uppfærast næstu mánaðarmót.',
	                status: 'success',
	                dismissible: true,
	                dismissAfter: 4000
	              }));
	              if (Email) {
	                EmailCallBack();
	              }
	
	              dispatch(fitnessGrantRegisterSuccess(HrBenefitID));
	              dispatch(fetchBenefits());
	
	              _context5.next = 20;
	              break;
	
	            case 16:
	              _context5.prev = 16;
	              _context5.t0 = _context5['catch'](1);
	
	              dispatch((0, _reapop.addNotification)({
	                title: 'Villa',
	                message: 'Ekki t\xF3kst a\xF0 s\xE6kja um styrk. ' + (0, _get2.default)(_context5.t0, 'Message', ''),
	                status: 'error',
	                dismissible: true,
	                dismissAfter: 16000
	              }));
	              dispatch(fitnessGrantRegisterFailure(_context5.t0, HrBenefitID));
	
	            case 20:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined, [[1, 16]]);
	    }));
	
	    return function (_x9, _x10) {
	      return _ref6.apply(this, arguments);
	    };
	  }();
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestBenefits, 'requestBenefits', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(requestBenefitsSuccess, 'requestBenefitsSuccess', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(requestBenefitsFailure, 'requestBenefitsFailure', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(fetchBenefits, 'fetchBenefits', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(fitnessGrantRegisterRequest, 'fitnessGrantRegisterRequest', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(fitnessGrantRegisterSuccess, 'fitnessGrantRegisterSuccess', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(fitnessGrantRegisterFailure, 'fitnessGrantRegisterFailure', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(grantRegisterRequest, 'grantRegisterRequest', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(grantRegisterSuccess, 'grantRegisterSuccess', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(grantRegisterFailure, 'grantRegisterFailure', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(fitnessGrantRegister, 'fitnessGrantRegister', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(uploadFile, 'uploadFile', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(benefitUpload, 'benefitUpload', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(fitnessGrantRegisterAndUpload, 'fitnessGrantRegisterAndUpload', 'D:/a/1/s/src/web/employee/src/actions/Benefits.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestHolidayInfo = exports.fetchHolidayByYear = exports.fetchHolidayOverview = exports.requestHolidayOverviewFailure = exports.requestHolidayOverviewSuccess = exports.requestHolidayOverview = exports.fetch = exports.requestHolidayFailure = exports.requestHolidaySuccess = exports.requestHoliday = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Api = __webpack_require__(21);
	
	var _lodash = __webpack_require__(8);
	
	var _api = __webpack_require__(185);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getYear = function getYear(year) {
	  var yearNow = new Date().getFullYear();
	  var holidayPayYearCheck = new Date(yearNow, 4, 1).getTime() < Date.now() ? yearNow : yearNow - 1;
	  var yearFixed = year || null;
	  var holidayPayYear = void 0;
	  if (yearFixed) {
	    holidayPayYear = (0, _lodash.toNumber)(yearFixed);
	  } else {
	    holidayPayYear = holidayPayYearCheck;
	  }
	  return holidayPayYear;
	};
	
	var requestHoliday = exports.requestHoliday = function requestHoliday() {
	  return {
	    type: types.REQUEST_HOLIDAY
	  };
	};
	
	var requestHolidaySuccess = exports.requestHolidaySuccess = function requestHolidaySuccess(holidays, holidayPayYear, earnedHolidayInfo) {
	  return {
	    type: types.REQUEST_HOLIDAY_SUCCESS,
	    holidays: holidays,
	    holidayPayYear: holidayPayYear,
	    earnedHolidayInfo: earnedHolidayInfo
	  };
	};
	
	var requestHolidayFailure = exports.requestHolidayFailure = function requestHolidayFailure(error) {
	  return {
	    type: types.REQUEST_HOLIDAY_FAILURE,
	    error: error
	  };
	};
	
	var fetch = exports.fetch = function fetch() {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	      var fixedYear, holidayPayYear, _getState, _getState$loginReduce, EmployeeMasterID, token, valuesByKey, useVacationOld, controller, config, modelConfig, data, earnedHolidayInfo, holidayStatus;
	
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              dispatch(requestHoliday());
	              _context2.t0 = _lodash.get;
	              _context2.next = 4;
	              return (0, _Api.custom)((0, _api.getXapValue)('EmployeeMasterHoliday.PayYear'));
	
	            case 4:
	              _context2.t1 = _context2.sent;
	              fixedYear = (0, _context2.t0)(_context2.t1, 'data.value[0].Value', null);
	              holidayPayYear = getYear(fixedYear);
	              _getState = getState(), _getState$loginReduce = _getState.loginReducer.user, EmployeeMasterID = _getState$loginReduce.EmployeeMasterID, token = _getState$loginReduce.token, valuesByKey = _getState.WebValuesReducer.valuesByKey;
	              useVacationOld = (0, _lodash.get)(valuesByKey, ['Use.VacationOld', 'Value']) === 'true';
	              controller = useVacationOld ? 'PayHolidays' : 'ClockCardEntries';
	              config = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: '/kjarni/api/v2/' + controller + '/Status(paywagecollectyear=' + holidayPayYear + ',employeemasterid=' + EmployeeMasterID + ')'
	              };
	              modelConfig = {
	                entity: 'EmployeeDetailHoliday',
	                headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }
	              };
	              _context2.prev = 12;
	              _context2.t2 = _lodash.get;
	              _context2.next = 16;
	              return (0, _Api.custom)(config);
	
	            case 16:
	              _context2.t3 = _context2.sent;
	              _context2.t4 = [];
	              data = (0, _context2.t2)(_context2.t3, 'data.value', _context2.t4);
	              earnedHolidayInfo = void 0;
	              _context2.next = 22;
	              return Promise.all((0, _lodash.map)(data, function () {
	                var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(obj) {
	                  var holidayModel, HrsPrMonth, PayHolidayDaysPerYear, WorkTimePerDay, Earned, allowance;
	                  return regeneratorRuntime.wrap(function _callee$(_context) {
	                    while (1) {
	                      switch (_context.prev = _context.next) {
	                        case 0:
	                          _context.t0 = _lodash.get;
	                          _context.next = 3;
	                          return (0, _Api.readWM)(_extends({}, modelConfig, { entityID: obj.EmployeeDetailID }));
	
	                        case 3:
	                          _context.t1 = _context.sent;
	                          holidayModel = (0, _context.t0)(_context.t1, 'data');
	                          HrsPrMonth = holidayModel.HrsPrMonth, PayHolidayDaysPerYear = holidayModel.PayHolidayDaysPerYear;
	                          WorkTimePerDay = obj.WorkTimePerDay, Earned = obj.Earned;
	                          allowance = HrsPrMonth ? HrsPrMonth * 12 * WorkTimePerDay : PayHolidayDaysPerYear * WorkTimePerDay;
	
	                          earnedHolidayInfo = _extends({}, obj, {
	                            HrsPrMonth: HrsPrMonth,
	                            PayHolidayDaysPerYear: PayHolidayDaysPerYear,
	                            allowance: allowance
	                          });
	                          return _context.abrupt('return', _extends({}, obj, {
	                            HrsPrMonth: HrsPrMonth,
	                            PayHolidayDaysPerYear: PayHolidayDaysPerYear
	                          }));
	
	                        case 10:
	                        case 'end':
	                          return _context.stop();
	                      }
	                    }
	                  }, _callee, undefined);
	                }));
	
	                return function (_x3) {
	                  return _ref2.apply(this, arguments);
	                };
	              }()));
	
	            case 22:
	              holidayStatus = _context2.sent;
	
	
	              dispatch(requestHolidaySuccess(holidayStatus, holidayPayYear, earnedHolidayInfo));
	              _context2.next = 29;
	              break;
	
	            case 26:
	              _context2.prev = 26;
	              _context2.t5 = _context2['catch'](12);
	
	              dispatch(requestHolidayFailure(_context2.t5));
	
	            case 29:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[12, 26]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	var requestHolidayOverview = exports.requestHolidayOverview = function requestHolidayOverview() {
	  return {
	    type: types.REQUEST_HOLIDAY_OVERVIEW
	  };
	};
	
	var requestHolidayOverviewSuccess = exports.requestHolidayOverviewSuccess = function requestHolidayOverviewSuccess(holidayOverview) {
	  return {
	    type: types.REQUEST_HOLIDAY_OVERVIEW_SUCCESS,
	    holidayOverview: holidayOverview
	  };
	};
	
	var requestHolidayOverviewFailure = exports.requestHolidayOverviewFailure = function requestHolidayOverviewFailure(error) {
	  return {
	    type: types.REQUEST_HOLIDAY_OVERVIEW_FAILURE,
	    error: error
	  };
	};
	
	var fetchHolidayOverview = exports.fetchHolidayOverview = function fetchHolidayOverview() {
	  return function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	      var fixedYear, payYear, _getState2, _getState2$loginReduc, EmployeeMasterID, token, valuesByKey, useVacationOld, controller, config, overview;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	              _context3.t0 = _lodash.get;
	              _context3.next = 4;
	              return (0, _Api.custom)((0, _api.getXapValue)('EmployeeMasterHoliday.PayYear'));
	
	            case 4:
	              _context3.t1 = _context3.sent;
	              fixedYear = (0, _context3.t0)(_context3.t1, 'data.value[0].Value', null);
	
	              dispatch(requestHolidayOverview());
	              payYear = getYear(fixedYear);
	              _getState2 = getState(), _getState2$loginReduc = _getState2.loginReducer.user, EmployeeMasterID = _getState2$loginReduc.EmployeeMasterID, token = _getState2$loginReduc.token, valuesByKey = _getState2.WebValuesReducer.valuesByKey;
	              useVacationOld = (0, _lodash.get)(valuesByKey, ['Use.VacationOld', 'Value']) === 'true';
	              controller = useVacationOld ? 'PayHolidays' : 'ClockCardEntries';
	              config = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: '/kjarni/api/v2/' + controller + '/OverviewCollect(paywagecollectyear=' + payYear + ',employeemasterid=' + EmployeeMasterID + ')'
	              };
	              _context3.t2 = _lodash.get;
	              _context3.next = 15;
	              return (0, _Api.custom)(config);
	
	            case 15:
	              _context3.t3 = _context3.sent;
	              overview = (0, _context3.t2)(_context3.t3, 'data.value[0]');
	
	              dispatch(requestHolidayOverviewSuccess(overview));
	              _context3.next = 23;
	              break;
	
	            case 20:
	              _context3.prev = 20;
	              _context3.t4 = _context3['catch'](0);
	
	              dispatch(requestHolidayOverviewFailure(_context3.t4));
	
	            case 23:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[0, 20]]);
	    }));
	
	    return function (_x4, _x5) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	};
	
	var setHolidayInfo = function setHolidayInfo(holidayInfo) {
	  return {
	    type: types.SET_HOLIDAY_INFO,
	    holidayInfo: holidayInfo
	  };
	};
	
	var fetchHolidayByYearRequest = function fetchHolidayByYearRequest(year) {
	  return {
	    type: types.FETCH_HOLIDAY_BY_YEAR,
	    year: year
	  };
	};
	var fetchHolidayByYearSuccess = function fetchHolidayByYearSuccess(holidays, holidaysOverview) {
	  return {
	    type: types.FETCH_HOLIDAY_BY_YEAR_SUCCESS,
	    holidays: holidays,
	    holidaysOverview: holidaysOverview
	  };
	};
	var fetchHolidayByYearFailure = function fetchHolidayByYearFailure(error) {
	  return {
	    type: types.FETCH_HOLIDAY_BY_YEAR_FAILURE,
	    error: error
	  };
	};
	
	var fetchHolidayByYear = exports.fetchHolidayByYear = function fetchHolidayByYear(year) {
	  return function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(dispatch, getState) {
	      var _getState3, _getState3$loginReduc, EmployeeMasterID, token, valuesByKey, useVacationOld, controller, config, overviewConfig, modelConfig, data, overview, holidays;
	
	      return regeneratorRuntime.wrap(function _callee5$(_context5) {
	        while (1) {
	          switch (_context5.prev = _context5.next) {
	            case 0:
	              dispatch(fetchHolidayByYearRequest(year));
	              _getState3 = getState(), _getState3$loginReduc = _getState3.loginReducer.user, EmployeeMasterID = _getState3$loginReduc.EmployeeMasterID, token = _getState3$loginReduc.token, valuesByKey = _getState3.WebValuesReducer.valuesByKey;
	              useVacationOld = (0, _lodash.get)(valuesByKey, ['Use.VacationOld', 'Value']) === 'true';
	              controller = useVacationOld ? 'PayHolidays' : 'ClockCardEntries';
	              config = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: '/kjarni/api/v2/' + controller + '/Status(paywagecollectyear=' + year + ',employeemasterid=' + EmployeeMasterID + ')'
	              };
	              overviewConfig = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: '/kjarni/api/v2/' + controller + '/OverviewCollect(paywagecollectyear=' + year + ',employeemasterid=' + EmployeeMasterID + ')'
	              };
	              modelConfig = {
	                entity: 'EmployeeDetailHoliday',
	                headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token }
	              };
	              _context5.prev = 7;
	              _context5.t0 = _lodash.get;
	              _context5.next = 11;
	              return (0, _Api.custom)(config);
	
	            case 11:
	              _context5.t1 = _context5.sent;
	              _context5.t2 = [];
	              data = (0, _context5.t0)(_context5.t1, 'data.value', _context5.t2);
	              _context5.t3 = _lodash.get;
	              _context5.next = 17;
	              return (0, _Api.custom)(overviewConfig);
	
	            case 17:
	              _context5.t4 = _context5.sent;
	              overview = (0, _context5.t3)(_context5.t4, 'data.value[0]');
	              _context5.next = 21;
	              return Promise.all((0, _lodash.map)(data, function () {
	                var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(obj) {
	                  var holidayModel;
	                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
	                    while (1) {
	                      switch (_context4.prev = _context4.next) {
	                        case 0:
	                          _context4.t0 = _lodash.get;
	                          _context4.next = 3;
	                          return (0, _Api.readWM)(_extends({}, modelConfig, { entityID: obj.EmployeeDetailID }));
	
	                        case 3:
	                          _context4.t1 = _context4.sent;
	                          holidayModel = (0, _context4.t0)(_context4.t1, 'data');
	                          return _context4.abrupt('return', _extends({}, obj, {
	                            PayHolidayDaysPerYear: (0, _lodash.get)(holidayModel, 'PayHolidayDaysPerYear'),
	                            HrsPrMonth: (0, _lodash.get)(holidayModel, 'HrsPrMonth')
	                          }));
	
	                        case 6:
	                        case 'end':
	                          return _context4.stop();
	                      }
	                    }
	                  }, _callee4, undefined);
	                }));
	
	                return function (_x8) {
	                  return _ref5.apply(this, arguments);
	                };
	              }()));
	
	            case 21:
	              holidays = _context5.sent;
	
	              dispatch(fetchHolidayByYearSuccess(holidays, overview));
	              _context5.next = 28;
	              break;
	
	            case 25:
	              _context5.prev = 25;
	              _context5.t5 = _context5['catch'](7);
	
	              dispatch(fetchHolidayByYearFailure(_context5.t5));
	
	            case 28:
	            case 'end':
	              return _context5.stop();
	          }
	        }
	      }, _callee5, undefined, [[7, 25]]);
	    }));
	
	    return function (_x6, _x7) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	};
	
	var requestHolidayInfo = exports.requestHolidayInfo = function requestHolidayInfo() {
	  return function (dispatch, getState) {
	    var _getState4 = getState(),
	        token = _getState4.loginReducer.user.token,
	        holidayInfo = _getState4.EmployeeHolidayReducer.holidayInfo,
	        valuesByKey = _getState4.WebValuesReducer.valuesByKey;
	
	    var templateConfig = valuesByKey['Info.EmployeeMasterHoliday.XapEmailTemplateID'];
	    if (!holidayInfo && templateConfig && templateConfig.Value) {
	      var config = {
	        entity: 'XapEmailTemplate',
	        entityID: Number(templateConfig.Value),
	        headers: { Authorization: 'Bearer ' + token }
	      };
	      return (0, _Api.read)(config).then(function (_ref6) {
	        var data = _ref6.data;
	
	        dispatch(setHolidayInfo(data));
	      });
	    }
	    return null;
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getYear, 'getYear', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(requestHoliday, 'requestHoliday', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(requestHolidaySuccess, 'requestHolidaySuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(requestHolidayFailure, 'requestHolidayFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(fetch, 'fetch', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(requestHolidayOverview, 'requestHolidayOverview', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(requestHolidayOverviewSuccess, 'requestHolidayOverviewSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(requestHolidayOverviewFailure, 'requestHolidayOverviewFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(fetchHolidayOverview, 'fetchHolidayOverview', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(setHolidayInfo, 'setHolidayInfo', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(fetchHolidayByYearRequest, 'fetchHolidayByYearRequest', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(fetchHolidayByYearSuccess, 'fetchHolidayByYearSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(fetchHolidayByYearFailure, 'fetchHolidayByYearFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(fetchHolidayByYear, 'fetchHolidayByYear', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(requestHolidayInfo, 'requestHolidayInfo', 'D:/a/1/s/src/web/employee/src/actions/EmployeeHoliday.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _Api = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var KAvatar = function KAvatar(_ref) {
	  var imgSrc = _ref.imgSrc,
	      iconName = _ref.iconName,
	      style = _ref.style,
	      size = _ref.size,
	      dataCy = _ref.dataCy,
	      masterId = _ref.masterId;
	
	  var _useState = (0, _react.useState)(undefined),
	      _useState2 = _slicedToArray(_useState, 2),
	      imageSrc = _useState2[0],
	      setImageSrc = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      hasTried = _useState4[0],
	      setHasTried = _useState4[1];
	
	  var setImage = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var imageObj, extension;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              // set to undefined while fetching to prevent broken image icon
	              setImageSrc(undefined);
	              imageObj = void 0;
	
	              if (!masterId) {
	                _context.next = 8;
	                break;
	              }
	
	              _context.t0 = _lodash.get;
	              _context.next = 6;
	              return (0, _Api.custom)({
	                url: '/kjarni/api/v2/EmployeeMasters(' + masterId + ')/Picture',
	                method: 'GET'
	              });
	
	            case 6:
	              _context.t1 = _context.sent;
	              imageObj = (0, _context.t0)(_context.t1, 'data');
	
	            case 8:
	              if (imageObj) {
	                setHasTried(true);
	                extension = imageObj.Extension.substring(1, imageObj.Extension.length);
	
	                setImageSrc('data:image/' + extension + ';base64, ' + imageObj.FileSource);
	              }
	
	            case 9:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function setImage() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    if (imgSrc) {
	      setImageSrc(imgSrc);
	    } else {
	      setImage();
	    }
	    return function () {
	      return null;
	    };
	  }, [imgSrc]);
	
	  return _react2.default.createElement(_materialUi.Avatar, {
	    size: size,
	    src: imageSrc,
	    onError: function onError() {
	      return !hasTried && setImage();
	    },
	    style: _extends({ objectFit: 'cover' }, style),
	    icon: _react2.default.createElement(
	      _materialUi.FontIcon,
	      { className: 'material-icons' },
	      iconName
	    ),
	    'data-cy': dataCy
	  });
	};
	
	KAvatar.propTypes = {
	  iconName: _propTypes2.default.string,
	  imgSrc: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  size: _propTypes2.default.number,
	  dataCy: _propTypes2.default.string,
	  masterId: _propTypes2.default.number
	};
	
	KAvatar.defaultProps = {
	  iconName: 'person',
	  size: 70
	};
	
	var _default = KAvatar;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(KAvatar, 'KAvatar', 'D:/a/1/s/src/web/employee/src/components/KJRN/KAvatar.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KAvatar.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(17);
	
	var _config = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var styles = {
	  defaultInnerDivStyle: {
	    display: 'flex',
	    flexDirection: _config.reverseListItemLabels ? 'column-reverse' : 'column'
	  },
	  primaryTextStyle: {
	    marginTop: _config.reverseListItemLabels ? 6 : 0
	  }
	};
	
	var KListItem = function KListItem(_ref) {
	  var innerDivStyle = _ref.innerDivStyle,
	      primaryText = _ref.primaryText,
	      props = _objectWithoutProperties(_ref, ['innerDivStyle', 'primaryText']);
	
	  return _react2.default.createElement(_materialUi.ListItem, _extends({
	    innerDivStyle: _extends({}, innerDivStyle, styles.defaultInnerDivStyle),
	    primaryText: _react2.default.createElement(
	      'div',
	      { style: styles.primaryTextStyle },
	      primaryText
	    )
	  }, props));
	};
	
	KListItem.propTypes = {
	  innerDivStyle: _propTypes2.default.object,
	  primaryText: _propTypes2.default.node
	};
	
	var _default = KListItem;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/KJRN/KListItem.js');
	
	  __REACT_HOT_LOADER__.register(KListItem, 'KListItem', 'D:/a/1/s/src/web/employee/src/components/KJRN/KListItem.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KListItem.js');
	}();

	;

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getClockCardEntryTypes = exports.getClockCardEntryTypes = {
	  url: '/kjarni/api/v2/ClockCardEntryTypes',
	  method: 'GET'
	};
	var getXapValue = exports.getXapValue = function getXapValue(val) {
	  return {
	    url: '/kjarni/api/v2/XapValues',
	    method: 'GET',
	    params: {
	      $filter: 'XapValueName eq \'' + val + '\''
	    }
	  };
	};
	var getWorkingHours = exports.getWorkingHours = function getWorkingHours(detailId) {
	  return {
	    url: '/kjarni/api/v2/EmployeeDetailWorkingHours',
	    method: 'GET',
	    params: {
	      $filter: 'EmployeeDetailID eq ' + detailId
	    }
	  };
	};
	var getWorkingHoursToday = exports.getWorkingHoursToday = function getWorkingHoursToday(detailId) {
	  return {
	    url: '/kjarni/api/v2/EmployeeDetailWorkingHours',
	    method: 'GET',
	    params: {
	      $filter: 'EmployeeDetailID eq ' + detailId + ' and Begda le ' + new Date().toISOString() + ' and ' + new Date().toISOString() + ' le Endda'
	    }
	  };
	};
	var getEntries = exports.getEntries = function getEntries(start, end, empId) {
	  return {
	    url: '/kjarni/api/v2/ClockCardEntries',
	    method: 'GET',
	    params: {
	      $filter: '(ClockIn ge ' + start.toISOString() + ' and ClockIn le ' + end.toISOString() + ') and EmployeeDetailID eq ' + empId
	    }
	  };
	};
	
	var patch = exports.patch = function patch(entry, entryId) {
	  return {
	    url: '/kjarni/api/v2/ClockCardEntries(' + entryId + ')',
	    method: 'PATCH',
	    data: entry
	  };
	};
	
	var post = exports.post = function post(entry) {
	  return {
	    url: '/kjarni/api/v2/ClockCardEntries',
	    method: 'POST',
	    data: entry
	  };
	};
	
	var deleteClockCardEntry = exports.deleteClockCardEntry = function deleteClockCardEntry(entryId) {
	  return {
	    url: '/kjarni/api/v2/ClockCardEntries(' + entryId + ')',
	    method: 'DELETE'
	  };
	};
	
	var getOpenEntry = exports.getOpenEntry = function getOpenEntry(detailId) {
	  return {
	    url: '/kjarni/api/v2/ClockCardEntries',
	    method: 'GET',
	    params: {
	      $filter: 'EmployeeDetailID eq ' + detailId + ' and ClockOut eq null and ClockTimeHasError eq false'
	    }
	  };
	};
	
	var punch = exports.punch = function punch(detailId, kioskId) {
	  return {
	    url: '/kjarni/api/v2/ClockCardEntries/ClockInOutDetailID(detailId=' + detailId + ',kioskId=' + kioskId + ')',
	    method: 'GET'
	  };
	};
	
	var notifyEntryTypeRule = exports.notifyEntryTypeRule = function notifyEntryTypeRule(detailId, rule, from, to) {
	  return {
	    url: '/kjarni/api/v2/ClockCardEntries/NotifyFromClockCardEntryTypeRule(detailId=' + detailId + ',rule=\'' + rule + '\',dateFrom=' + from + ',dateTo=' + to + ')',
	    method: 'GET'
	  };
	};
	
	var getHolidayStatus = exports.getHolidayStatus = function getHolidayStatus(payYear, masterId) {
	  return {
	    url: '/kjarni/api/v2/ClockCardEntries/Status(paywagecollectyear=' + payYear + ',employeemasterid=' + masterId + ')',
	    method: 'GET'
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getClockCardEntryTypes, 'getClockCardEntryTypes', 'D:/a/1/s/src/web/employee/src/sites/time/api.js');
	
	  __REACT_HOT_LOADER__.register(getXapValue, 'getXapValue', 'D:/a/1/s/src/web/employee/src/sites/time/api.js');
	
	  __REACT_HOT_LOADER__.register(getWorkingHours, 'getWorkingHours', 'D:/a/1/s/src/web/employee/src/sites/time/api.js');
	
	  __REACT_HOT_LOADER__.register(getWorkingHoursToday, 'getWorkingHoursToday', 'D:/a/1/s/src/web/employee/src/sites/time/api.js');
	
	  __REACT_HOT_LOADER__.register(getEntries, 'getEntries', 'D:/a/1/s/src/web/employee/src/sites/time/api.js');
	
	  __REACT_HOT_LOADER__.register(patch, 'patch', 'D:/a/1/s/src/web/employee/src/sites/time/api.js');
	
	  __REACT_HOT_LOADER__.register(post, 'post', 'D:/a/1/s/src/web/employee/src/sites/time/api.js');
	
	  __REACT_HOT_LOADER__.register(deleteClockCardEntry, 'deleteClockCardEntry', 'D:/a/1/s/src/web/employee/src/sites/time/api.js');
	
	  __REACT_HOT_LOADER__.register(getOpenEntry, 'getOpenEntry', 'D:/a/1/s/src/web/employee/src/sites/time/api.js');
	
	  __REACT_HOT_LOADER__.register(punch, 'punch', 'D:/a/1/s/src/web/employee/src/sites/time/api.js');
	
	  __REACT_HOT_LOADER__.register(notifyEntryTypeRule, 'notifyEntryTypeRule', 'D:/a/1/s/src/web/employee/src/sites/time/api.js');
	
	  __REACT_HOT_LOADER__.register(getHolidayStatus, 'getHolidayStatus', 'D:/a/1/s/src/web/employee/src/sites/time/api.js');
	}();

	;

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ICONS;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var NAME = exports.NAME = 'TransportGrants';
	
	var REQUEST_TRANSPORT_GRANTS = exports.REQUEST_TRANSPORT_GRANTS = NAME + '/REQUEST_TRANSPORT_GRANTS';
	var REQUEST_TRANSPORT_GRANTS_SUCCESS = exports.REQUEST_TRANSPORT_GRANTS_SUCCESS = NAME + '/REQUEST_TRANSPORT_GRANTS_SUCCESS';
	var REQUEST_TRANSPORT_GRANTS_FAILURE = exports.REQUEST_TRANSPORT_GRANTS_FAILURE = NAME + '/REQUEST_TRANSPORT_GRANTS_FAILURE';
	
	var EMPLOYEE_TRANSPORT_GRANT_REGISTER = exports.EMPLOYEE_TRANSPORT_GRANT_REGISTER = NAME + '/EMPLOYEE_TRANSPORT_GRANT_REGISTER';
	var EMPLOYEE_TRANSPORT_GRANT_REGISTER_SUCCESS = exports.EMPLOYEE_TRANSPORT_GRANT_REGISTER_SUCCESS = NAME + '/EMPLOYEE_TRANSPORT_GRANT_REGISTER_SUCCESS';
	var EMPLOYEE_TRANSPORT_GRANT_REGISTER_FAILURE = exports.EMPLOYEE_TRANSPORT_GRANT_REGISTER_FAILURE = NAME + '/EMPLOYEE_TRANSPORT_GRANT_REGISTER_FAILURE';
	
	var STATE_PROPS = exports.STATE_PROPS = {
	  PublicTransportation: 'PublicTransportation',
	  Cycling: 'Cycling',
	  Walking: 'Walking',
	  TransportationCard: 'TransportationCard'
	};
	
	var ICONS = exports.ICONS = (_ICONS = {}, _defineProperty(_ICONS, STATE_PROPS.PublicTransportation, 'directions_transit'), _defineProperty(_ICONS, STATE_PROPS.Cycling, 'directions_bike'), _defineProperty(_ICONS, STATE_PROPS.Walking, 'directions_walk'), _defineProperty(_ICONS, STATE_PROPS.TransportationCard, 'directions_bus'), _ICONS);
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(NAME, 'NAME', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/constants.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_TRANSPORT_GRANTS, 'REQUEST_TRANSPORT_GRANTS', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/constants.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_TRANSPORT_GRANTS_SUCCESS, 'REQUEST_TRANSPORT_GRANTS_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/constants.js');
	
	  __REACT_HOT_LOADER__.register(REQUEST_TRANSPORT_GRANTS_FAILURE, 'REQUEST_TRANSPORT_GRANTS_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/constants.js');
	
	  __REACT_HOT_LOADER__.register(EMPLOYEE_TRANSPORT_GRANT_REGISTER, 'EMPLOYEE_TRANSPORT_GRANT_REGISTER', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/constants.js');
	
	  __REACT_HOT_LOADER__.register(EMPLOYEE_TRANSPORT_GRANT_REGISTER_SUCCESS, 'EMPLOYEE_TRANSPORT_GRANT_REGISTER_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/constants.js');
	
	  __REACT_HOT_LOADER__.register(EMPLOYEE_TRANSPORT_GRANT_REGISTER_FAILURE, 'EMPLOYEE_TRANSPORT_GRANT_REGISTER_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/constants.js');
	
	  __REACT_HOT_LOADER__.register(STATE_PROPS, 'STATE_PROPS', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/constants.js');
	
	  __REACT_HOT_LOADER__.register(ICONS, 'ICONS', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/constants.js');
	}();

	;

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var setSettings = exports.setSettings = function setSettings(settings) {
	  if (settings && settings instanceof Object) {
	    localStorage.localSettings = JSON.stringify(settings);
	  }
	};
	
	var getSettings = exports.getSettings = function getSettings() {
	  var settings = {};
	  try {
	    var localSettings = localStorage.localSettings;
	    settings = JSON.parse(localSettings);
	  } catch (e) {
	    settings = {};
	  }
	
	  return settings;
	};
	
	var setSettingByKey = exports.setSettingByKey = function setSettingByKey(key, value) {
	  if (key) {
	    var settings = getSettings();
	    setSettings(_extends({}, settings, _defineProperty({}, key, value)));
	  }
	};
	
	var getSettingByKey = exports.getSettingByKey = function getSettingByKey(key) {
	  var settings = getSettings();
	  return settings[key];
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(setSettings, "setSettings", "D:/a/1/s/src/web/employee/src/utils/localSettings.js");
	
	  __REACT_HOT_LOADER__.register(getSettings, "getSettings", "D:/a/1/s/src/web/employee/src/utils/localSettings.js");
	
	  __REACT_HOT_LOADER__.register(setSettingByKey, "setSettingByKey", "D:/a/1/s/src/web/employee/src/utils/localSettings.js");
	
	  __REACT_HOT_LOADER__.register(getSettingByKey, "getSettingByKey", "D:/a/1/s/src/web/employee/src/utils/localSettings.js");
	}();

	;

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral([', '], [', ']);
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var xQuote = exports.xQuote = function xQuote(val) {
	  return '"' + val + '"';
	};
	
	var xRelation = {
	  none: 0,
	  eq: 1,
	  ge: 2,
	  le: 3,
	  gt: 4,
	  lt: 5,
	  ne: 6
	};
	var mapSelect = function mapSelect(_ref) {
	  var field = _ref.field,
	      value = _ref.value,
	      relation = _ref.relation,
	      _ref$isParameter = _ref.isParameter,
	      isParameter = _ref$isParameter === undefined ? true : _ref$isParameter;
	  return '\n{\n    "StringChar": "\'",\n    "SelectSingles": [{\n        "Operation": ' + xRelation[relation] + ',\n        "Value": ' + xQuote(value) + ',\n        "DefaultValue": null,\n        "SendProperty": true,\n        "choose": false,\n        "recordAction": 0,\n        "UniqueID": null,\n        "KeyID": 0,\n        "MasterID": 0,\n        "CreateDate": "0001-01-01T00:00:00"\n    }],\n    "SelectRanges": [],\n    "NotSelectSingles": [],\n    "NotSelectRanges": [],\n    "SelectActive": null,\n    "_ParameterPrefix": "@p",\n    "_ParameterCounter": 0,\n    "_ParametersGiven": false,\n    "CodeType": 1,\n    "FieldName": ' + xQuote(field) + ',\n    "EntityName": ' + xQuote(field) + ',\n    "IsParameter": ' + (isParameter ? 'true' : 'false') + ',\n    "Label": ' + xQuote(field) + ',\n    "IsHide": false,\n    "IsNoSave": false,\n    "IsRequired": false,\n    "IsSkipSQL": false,\n    "PadLeftChar": "\0",\n    "PadLeftLen": 0,\n    "Mask": null,\n    "Domain": null,\n    "Command": null,\n    "SearchFields": null,\n    "RecordName": null,\n    "UseLinq": true,\n    "FieldType": 0,\n    "SkipInVariant": false,\n    "Required": false,\n    "SqlGroup": 1\n}';
	};
	
	var xSelectSingle = exports.xSelectSingle = function xSelectSingle(selects) {
	  return '[\n  ' + selects.map(mapSelect).join(_templateObject) + '\n]';
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(xQuote, 'xQuote', 'D:/a/1/s/src/web/employee/src/utils/xSelect.js');
	
	  __REACT_HOT_LOADER__.register(xRelation, 'xRelation', 'D:/a/1/s/src/web/employee/src/utils/xSelect.js');
	
	  __REACT_HOT_LOADER__.register(mapSelect, 'mapSelect', 'D:/a/1/s/src/web/employee/src/utils/xSelect.js');
	
	  __REACT_HOT_LOADER__.register(xSelectSingle, 'xSelectSingle', 'D:/a/1/s/src/web/employee/src/utils/xSelect.js');
	}();

	;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(459);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(1046);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1045);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 191 */
[1883, 472, 301],
/* 192 */
127,
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(22);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 194 */
[1866, 76],
/* 195 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 196 */
[1888, 68, 25, 109],
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(22);
	var aFunction = __webpack_require__(56);
	var SPECIES = __webpack_require__(31)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.5.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2020-05-04T22:49Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var flat = arr.flat ? function( array ) {
		return arr.flat.call( array );
	} : function( array ) {
		return arr.concat.apply( [], array );
	};
	
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	var isFunction = function isFunction( obj ) {
	
	      // Support: Chrome <=57, Firefox <=52
	      // In some browsers, typeof returns "function" for HTML <object> elements
	      // (i.e., `typeof document.createElement( "object" ) === "function"`).
	      // We don't want to classify *any* DOM node as a function.
	      return typeof obj === "function" && typeof obj.nodeType !== "number";
	  };
	
	
	var isWindow = function isWindow( obj ) {
			return obj != null && obj === obj.window;
		};
	
	
	var document = window.document;
	
	
	
		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};
	
		function DOMEval( code, node, doc ) {
			doc = doc || document;
	
			var i, val,
				script = doc.createElement( "script" );
	
			script.text = code;
			if ( node ) {
				for ( i in preservedScriptAttributes ) {
	
					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[ i ] || node.getAttribute && node.getAttribute( i );
					if ( val ) {
						script.setAttribute( i, val );
					}
				}
			}
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	
	
	function toType( obj ) {
		if ( obj == null ) {
			return obj + "";
		}
	
		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.5.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		even: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return ( i + 1 ) % 2;
			} ) );
		},
	
		odd: function() {
			return this.pushStack( jQuery.grep( this, function( _elem, i ) {
				return i % 2;
			} ) );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					copy = options[ name ];
	
					// Prevent Object.prototype pollution
					// Prevent never-ending loop
					if ( name === "__proto__" || target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = Array.isArray( copy ) ) ) ) {
						src = target[ name ];
	
						// Ensure proper type for the source value
						if ( copyIsArray && !Array.isArray( src ) ) {
							clone = [];
						} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
							clone = {};
						} else {
							clone = src;
						}
						copyIsArray = false;
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		// Evaluates a script in a provided context; falls back to the global one
		// if not specified.
		globalEval: function( code, options, doc ) {
			DOMEval( code, { nonce: options && options.nonce }, doc );
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return flat( ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = toType( obj );
	
		if ( isFunction( obj ) || isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.5
	 * https://sizzlejs.com/
	 *
	 * Copyright JS Foundation and other contributors
	 * Released under the MIT license
	 * https://js.foundation/
	 *
	 * Date: 2020-03-14
	 */
	( function( window ) {
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		nonnativeSelectorCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ( {} ).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		pushNative = arr.push,
		push = arr.push,
		slice = arr.slice,
	
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[ i ] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
			"ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
		identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
			"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
	
			// "Attribute values must be CSS identifiers [capture 5]
			// or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
			whitespace + "*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
	
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
			whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
			"*" ),
		rdescend = new RegExp( whitespace + "|>" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
	
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace +
				"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
				"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rhtml = /HTML$/i,
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
		funescape = function( escape, nonHex ) {
			var high = "0x" + escape.slice( 1 ) - 0x10000;
	
			return nonHex ?
	
				// Strip the backslash prefix from a non-hex escape sequence
				nonHex :
	
				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				high < 0 ?
					String.fromCharCode( high + 0x10000 ) :
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" +
					ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		inDisabledFieldset = addCombinator(
			function( elem ) {
				return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			( arr = slice.call( preferredDoc.childNodes ) ),
			preferredDoc.childNodes
		);
	
		// Support: Android<4.0
		// Detect silently failing push.apply
		// eslint-disable-next-line no-unused-expressions
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				pushNative.apply( target, slice.call( els ) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
	
				// Can't trust NodeList.length
				while ( ( target[ j++ ] = els[ i++ ] ) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
			setDocument( context );
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {
	
					// ID selector
					if ( ( m = match[ 1 ] ) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( ( elem = context.getElementById( m ) ) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && ( elem = newContext.getElementById( m ) ) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[ 2 ] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!nonnativeSelectorCache[ selector + " " ] &&
					( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&
	
					// Support: IE 8 only
					// Exclude object elements
					( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {
	
					newSelector = selector;
					newContext = context;
	
					// qSA considers elements outside a scoping root when evaluating child or
					// descendant combinators, which is not what we want.
					// In such cases, we work around the behavior by prefixing every selector in the
					// list with an ID selector referencing the scope context.
					// The technique has to be used as well when a leading combinator is used
					// as such selectors are not recognized by querySelectorAll.
					// Thanks to Andrew Dupont for this technique.
					if ( nodeType === 1 &&
						( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
	
						// We can use :scope instead of the ID hack if the browser
						// supports it & if we're not changing the context.
						if ( newContext !== context || !support.scope ) {
	
							// Capture the context ID, setting it first if necessary
							if ( ( nid = context.getAttribute( "id" ) ) ) {
								nid = nid.replace( rcssescape, fcssescape );
							} else {
								context.setAttribute( "id", ( nid = expando ) );
							}
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
								toSelector( groups[ i ] );
						}
						newSelector = groups.join( "," );
					}
	
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
						nonnativeSelectorCache( selector, true );
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
	
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
	
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return ( cache[ key + " " ] = value );
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement( "fieldset" );
	
		try {
			return !!fn( el );
		} catch ( e ) {
			return false;
		} finally {
	
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
	
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split( "|" ),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[ i ] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( ( cur = cur.nextSibling ) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return ( name === "input" || name === "button" ) && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction( function( argument ) {
			argument = +argument;
			return markFunction( function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
						seed[ j ] = !( matches[ j ] = seed[ j ] );
					}
				}
			} );
		} );
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		var namespace = elem.namespaceURI,
			docElem = ( elem.ownerDocument || elem ).documentElement;
	
		// Support: IE <=8
		// Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
		// https://bugs.jquery.com/ticket/4833
		return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9 - 11+, Edge 12 - 18+
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( preferredDoc != document &&
			( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		// Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
		// Safari 4 - 5 only, Opera <=11.6 - 12.x only
		// IE/Edge & older browsers don't support the :scope pseudo-class.
		// Support: Safari 6.0 only
		// Safari 6.0 supports :scope but it's an alias of :root there.
		support.scope = assert( function( el ) {
			docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
			return typeof el.querySelectorAll !== "undefined" &&
				!el.querySelectorAll( ":scope fieldset div" ).length;
		} );
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert( function( el ) {
			el.className = "i";
			return !el.getAttribute( "className" );
		} );
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert( function( el ) {
			el.appendChild( document.createComment( "" ) );
			return !el.getElementsByTagName( "*" ).length;
		} );
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert( function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		} );
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter[ "ID" ] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute( "id" ) === attrId;
				};
			};
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter[ "ID" ] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode( "id" );
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find[ "ID" ] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( ( elem = elems[ i++ ] ) ) {
							node = elem.getAttributeNode( "id" );
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find[ "TAG" ] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
	
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( ( elem = results[ i++ ] ) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {
	
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert( function( el ) {
	
				var input;
	
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll( "[selected]" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push( "~=" );
				}
	
				// Support: IE 11+, Edge 15 - 18+
				// IE 11/Edge don't find elements on a `[name='']` query in some cases.
				// Adding a temporary attribute to the document before the selection works
				// around the issue.
				// Interestingly, IE 10 & older don't seem to have the issue.
				input = document.createElement( "input" );
				input.setAttribute( "name", "" );
				el.appendChild( input );
				if ( !el.querySelectorAll( "[name='']" ).length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
						whitespace + "*(?:''|\"\")" );
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll( ":checked" ).length ) {
					rbuggyQSA.push( ":checked" );
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push( ".#.+[+~]" );
				}
	
				// Support: Firefox <=3.6 - 5 only
				// Old Firefox doesn't throw on a badly-escaped identifier.
				el.querySelectorAll( "\\\f" );
				rbuggyQSA.push( "[\\r\\n\\f]" );
			} );
	
			assert( function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement( "input" );
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll( "[name=d]" ).length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: Opera 10 - 11 only
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll( "*,:x" );
				rbuggyQSA.push( ",.*:" );
			} );
		}
	
		if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector ) ) ) ) {
	
			assert( function( el ) {
	
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			} );
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				) );
			} :
			function( a, b ) {
				if ( b ) {
					while ( ( b = b.parentNode ) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {
	
				// Choose the first element that is related to our preferred document
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( a == document || a.ownerDocument == preferredDoc &&
					contains( preferredDoc, a ) ) {
					return -1;
				}
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ( b == document || b.ownerDocument == preferredDoc &&
					contains( preferredDoc, b ) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
	
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
	
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				return a == document ? -1 :
					b == document ? 1 :
					/* eslint-enable eqeqeq */
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( ( cur = cur.parentNode ) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( ( cur = cur.parentNode ) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[ i ] === bp[ i ] ) {
				i++;
			}
	
			return i ?
	
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[ i ], bp[ i ] ) :
	
				// Otherwise nodes in our document sort first
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				/* eslint-disable eqeqeq */
				ap[ i ] == preferredDoc ? -1 :
				bp[ i ] == preferredDoc ? 1 :
				/* eslint-enable eqeqeq */
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		setDocument( elem );
	
		if ( support.matchesSelector && documentIsHTML &&
			!nonnativeSelectorCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
	
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch ( e ) {
				nonnativeSelectorCache( expr, true );
			}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( context.ownerDocument || context ) != document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
	
		// Set document vars if needed
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		if ( ( elem.ownerDocument || elem ) != document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
	
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				( val = elem.getAttributeNode( name ) ) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return ( sel + "" ).replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( ( elem = results[ i++ ] ) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
	
			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {
	
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
	
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
	
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
	
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[ 1 ] = match[ 1 ].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
					match[ 5 ] || "" ).replace( runescape, funescape );
	
				if ( match[ 2 ] === "~=" ) {
					match[ 3 ] = " " + match[ 3 ] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
	
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[ 1 ] = match[ 1 ].toLowerCase();
	
				if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {
	
					// nth-* requires argument
					if ( !match[ 3 ] ) {
						Sizzle.error( match[ 0 ] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[ 4 ] = +( match[ 4 ] ?
						match[ 5 ] + ( match[ 6 ] || 1 ) :
						2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
					match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );
	
					// other types prohibit arguments
				} else if ( match[ 3 ] ) {
					Sizzle.error( match[ 0 ] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[ 6 ] && match[ 2 ];
	
				if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[ 3 ] ) {
					match[ 2 ] = match[ 4 ] || match[ 5 ] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
	
					// Get excess from tokenize (recursively)
					( excess = tokenize( unquoted, true ) ) &&
	
					// advance to the next closing parenthesis
					( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {
	
					// excess is a negative index
					match[ 0 ] = match[ 0 ].slice( 0, excess );
					match[ 2 ] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() {
						return true;
					} :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					( pattern = new RegExp( "(^|" + whitespace +
						")" + className + "(" + whitespace + "|$)" ) ) && classCache(
							className, function( elem ) {
								return pattern.test(
									typeof elem.className === "string" && elem.className ||
									typeof elem.getAttribute !== "undefined" &&
										elem.getAttribute( "class" ) ||
									""
								);
					} );
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					/* eslint-disable max-len */
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
					/* eslint-enable max-len */
	
				};
			},
	
			"CHILD": function( type, what, _argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, _context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( ( node = node[ dir ] ) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
	
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || ( node[ expando ] = {} );
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									( outerCache[ node.uniqueID ] = {} );
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
	
								// Use previously-cached element index if available
								if ( useCache ) {
	
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || ( node[ expando ] = {} );
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										( outerCache[ node.uniqueID ] = {} );
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
	
									// Use the same loop as above to seek `elem` from the start
									while ( ( node = ++nodeIndex && node && node[ dir ] ||
										( diff = nodeIndex = 0 ) || start.pop() ) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] ||
													( node[ expando ] = {} );
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													( outerCache[ node.uniqueID ] = {} );
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
	
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction( function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[ i ] );
								seed[ idx ] = !( matches[ idx ] = matched[ i ] );
							}
						} ) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
	
			// Potentially complex pseudos
			"not": markFunction( function( selector ) {
	
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction( function( seed, matches, _context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( ( elem = unmatched[ i ] ) ) {
								seed[ i ] = !( matches[ i ] = elem );
							}
						}
					} ) :
					function( elem, _context, xml ) {
						input[ 0 ] = elem;
						matcher( input, null, xml, results );
	
						// Don't keep the element (issue #299)
						input[ 0 ] = null;
						return !results.pop();
					};
			} ),
	
			"has": markFunction( function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			} ),
	
			"contains": markFunction( function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
				};
			} ),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
	
				// lang value must be a valid identifier
				if ( !ridentifier.test( lang || "" ) ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( ( elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
					return false;
				};
			} ),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement &&
					( !document.hasFocus || document.hasFocus() ) &&
					!!( elem.type || elem.href || ~elem.tabIndex );
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
	
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return ( nodeName === "input" && !!elem.checked ) ||
					( nodeName === "option" && !!elem.selected );
			},
	
			"selected": function( elem ) {
	
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					// eslint-disable-next-line no-unused-expressions
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
	
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos[ "empty" ]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( ( attr = elem.getAttribute( "type" ) ) == null ||
						attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo( function() {
				return [ 0 ];
			} ),
	
			"last": createPositionalPseudo( function( _matchIndexes, length ) {
				return [ length - 1 ];
			} ),
	
			"eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			} ),
	
			"even": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"odd": createPositionalPseudo( function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ?
					argument + length :
					argument > length ?
						length :
						argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} ),
	
			"gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			} )
		}
	};
	
	Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
				if ( match ) {
	
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[ 0 ].length ) || soFar;
				}
				groups.push( ( tokens = [] ) );
			}
	
			matched = false;
	
			// Combinators
			if ( ( match = rcombinators.exec( soFar ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
	
					// Cast descendant combinators to space
					type: match[ 0 ].replace( rtrim, " " )
				} );
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
					( match = preFilters[ type ]( match ) ) ) ) {
					matched = match.shift();
					tokens.push( {
						value: matched,
						type: type,
						matches: match
					} );
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
	
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[ i ].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
	
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( ( elem = elem[ dir ] ) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || ( elem[ expando ] = {} );
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] ||
								( outerCache[ elem.uniqueID ] = {} );
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( ( oldCache = uniqueCache[ key ] ) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return ( newCache[ 2 ] = oldCache[ 2 ] );
							} else {
	
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[ i ]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[ 0 ];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[ i ], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( ( elem = unmatched[ i ] ) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction( function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts(
					selector || "*",
					context.nodeType ? [ context ] : context,
					[]
				),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
	
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( ( elem = temp[ i ] ) ) {
						matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
	
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( ( elem = matcherOut[ i ] ) ) {
	
								// Restore matcherIn since elem is not yet a final match
								temp.push( ( matcherIn[ i ] = elem ) );
							}
						}
						postFinder( null, ( matcherOut = [] ), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) &&
							( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {
	
							seed[ temp ] = !( results[ temp ] = elem );
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		} );
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[ 0 ].type ],
			implicitRelative = leadingRelative || Expr.relative[ " " ],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					( checkContext = context ).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
	
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
				matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
			} else {
				matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
	
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[ j ].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
	
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens
							.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
	
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),
	
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
					len = elems.length;
	
				if ( outermost ) {
	
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					outermostContext = context == document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
	
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if ( !context && elem.ownerDocument != document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( ( matcher = elementMatchers[ j++ ] ) ) {
							if ( matcher( elem, context || document, xml ) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
	
						// They will have gone through all possible matchers
						if ( ( elem = !matcher && elem ) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( ( matcher = setMatchers[ j++ ] ) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
	
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
									setMatched[ i ] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
	
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[ i ] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache(
				selector,
				matcherFromGroupMatchers( elementMatchers, setMatchers )
			);
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( ( selector = compiled.selector || selector ) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[ 0 ] = match[ 0 ].slice( 0 );
			if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {
	
				context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
					.replace( runescape, funescape ), context ) || [] )[ 0 ];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[ i ];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ ( type = token.type ) ] ) {
					break;
				}
				if ( ( find = Expr.find[ type ] ) ) {
	
					// Search, expanding context for leading sibling combinators
					if ( ( seed = find(
						token.matches[ 0 ].replace( runescape, funescape ),
						rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
							context
					) ) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert( function( el ) {
	
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
	} );
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert( function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute( "href" ) === "#";
	} ) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		} );
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert( function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	} ) ) {
		addHandle( "value", function( elem, _name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		} );
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert( function( el ) {
		return el.getAttribute( "disabled" ) == null;
	} ) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
					( val = elem.getAttributeNode( name ) ) && val.specified ?
						val.value :
						null;
			}
		} );
	}
	
	return Sizzle;
	
	} )( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	
	
	function nodeName( elem, name ) {
	
	  return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	
	};
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Filtered directly for both simple and complex selectors
		return jQuery.filter( qualifier, elements, not );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, _i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, _i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, _i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			if ( elem.contentDocument != null &&
	
				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto( elem.contentDocument ) ) {
	
				return elem.contentDocument;
			}
	
			// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
			// Treat the template element as a regular one in browsers that
			// don't support it.
			if ( nodeName( elem, "template" ) ) {
				elem = elem.content || elem;
			}
	
			return jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = locked || options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && toType( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject, noValue ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
				// * false: [ value ].slice( 0 ) => resolve( value )
				// * true: [ value ].slice( 1 ) => resolve()
				resolve.apply( undefined, [ value ].slice( noValue ) );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.apply( undefined, [ value ] );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( _i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[ 3 - i ][ 3 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock,
	
						// progress_handlers.lock
						tuples[ 0 ][ 3 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject,
					!remaining );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( toType( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, _key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	
	
	// Matches dashed string for camelizing
	var rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g;
	
	// Used by camelCase as callback to replace()
	function fcamelCase( _all, letter ) {
		return letter.toUpperCase();
	}
	
	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 15
	// Microsoft forgot to hump their vendor prefix (#9572)
	function camelCase( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	}
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( Array.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( camelCase );
				} else {
					key = camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || Array.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var documentElement = document.documentElement;
	
	
	
		var isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem );
			},
			composed = { composed: true };
	
		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if ( documentElement.getRootNode ) {
			isAttached = function( elem ) {
				return jQuery.contains( elem.ownerDocument, elem ) ||
					elem.getRootNode( composed ) === elem.ownerDocument;
			};
		}
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				isAttached( elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted, scale,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType &&
				( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Support: Firefox <=54
			// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
			initial = initial / 2;
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			while ( maxIterations-- ) {
	
				// Evaluate and update our best guess (doubling guesses that zero out).
				// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
				jQuery.style( elem, prop, initialInUnit + unit );
				if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
					maxIterations = 0;
				}
				initialInUnit = initialInUnit / scale;
	
			}
	
			initialInUnit = initialInUnit * 2;
			jQuery.style( elem, prop, initialInUnit + unit );
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );
	
	var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );
	
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	
		// Support: IE <=9 only
		// IE <=9 replaces <option> tags with their contents when inserted outside of
		// the select element.
		div.innerHTML = "<option></option>";
		support.option = !!div.lastChild;
	} )();
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	// Support: IE <=9 only
	if ( !support.option ) {
		wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
	}
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, attached, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( toType( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			attached = isAttached( elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( attached ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 - 11+
	// focus() and blur() are asynchronous, except when they are no-op.
	// So expect focus to be synchronous when the element is already active,
	// and blur to be synchronous when the element is not already active.
	// (focus and blur are always synchronous in other supported browsers,
	// this just defines when we can count on it).
	function expectSync( elem, type ) {
		return ( elem === safeActiveElement() ) === ( type === "focus" );
	}
	
	// Support: IE <=9 only
	// Accessing document.activeElement can throw unexpectedly
	// https://bugs.jquery.com/ticket/13393
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Only attach events to objects that accept data
			if ( !acceptData( elem ) ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = Object.create( null );
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
	
				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix( nativeEvent ),
	
				handlers = (
						dataPriv.get( this, "events" ) || Object.create( null )
					)[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// If the event is namespaced, then each handler is only invoked if it is
					// specially universal or its namespaces are a superset of the event's.
					if ( !event.rnamespace || handleObj.namespace === false ||
						event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			click: {
	
				// Utilize native event to ensure correct state for checkable inputs
				setup: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Claim the first handler
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						// dataPriv.set( el, "click", ... )
						leverageNative( el, "click", returnTrue );
					}
	
					// Return false to allow normal processing in the caller
					return false;
				},
				trigger: function( data ) {
	
					// For mutual compressibility with _default, replace `this` access with a local var.
					// `|| data` is dead code meant only to preserve the variable through minification.
					var el = this || data;
	
					// Force setup before triggering a click
					if ( rcheckableType.test( el.type ) &&
						el.click && nodeName( el, "input" ) ) {
	
						leverageNative( el, "click" );
					}
	
					// Return non-false to allow normal event-path propagation
					return true;
				},
	
				// For cross-browser consistency, suppress native .click() on links
				// Also prevent it if we're currently inside a leveraged native-event stack
				_default: function( event ) {
					var target = event.target;
					return rcheckableType.test( target.type ) &&
						target.click && nodeName( target, "input" ) &&
						dataPriv.get( target, "click" ) ||
						nodeName( target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	// Ensure the presence of an event listener that handles manually-triggered
	// synthetic events by interrupting progress until reinvoked in response to
	// *native* events that it fires directly, ensuring that state changes have
	// already occurred before other listeners are invoked.
	function leverageNative( el, type, expectSync ) {
	
		// Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
		if ( !expectSync ) {
			if ( dataPriv.get( el, type ) === undefined ) {
				jQuery.event.add( el, type, returnTrue );
			}
			return;
		}
	
		// Register the controller as a special universal handler for all event namespaces
		dataPriv.set( el, type, false );
		jQuery.event.add( el, type, {
			namespace: false,
			handler: function( event ) {
				var notAsync, result,
					saved = dataPriv.get( this, type );
	
				if ( ( event.isTrigger & 1 ) && this[ type ] ) {
	
					// Interrupt processing of the outer synthetic .trigger()ed event
					// Saved data should be false in such cases, but might be a leftover capture object
					// from an async native handler (gh-4350)
					if ( !saved.length ) {
	
						// Store arguments for use when handling the inner native event
						// There will always be at least one argument (an event object), so this array
						// will not be confused with a leftover capture object.
						saved = slice.call( arguments );
						dataPriv.set( this, type, saved );
	
						// Trigger the native event and capture its result
						// Support: IE <=9 - 11+
						// focus() and blur() are asynchronous
						notAsync = expectSync( this, type );
						this[ type ]();
						result = dataPriv.get( this, type );
						if ( saved !== result || notAsync ) {
							dataPriv.set( this, type, false );
						} else {
							result = {};
						}
						if ( saved !== result ) {
	
							// Cancel the outer synthetic event
							event.stopImmediatePropagation();
							event.preventDefault();
							return result.value;
						}
	
					// If this is an inner synthetic event for an event with a bubbling surrogate
					// (focus or blur), assume that the surrogate already propagated from triggering the
					// native event and prevent that from happening again here.
					// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
					// bubbling surrogate propagates *after* the non-bubbling base), but that seems
					// less bad than duplication.
					} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
						event.stopPropagation();
					}
	
				// If this is a native event triggered above, everything is now in order
				// Fire an inner synthetic event with the original arguments
				} else if ( saved.length ) {
	
					// ...and capture the result
					dataPriv.set( this, type, {
						value: jQuery.event.trigger(
	
							// Support: IE <=9 - 11+
							// Extend with the prototype to reset the above stopImmediatePropagation()
							jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
							saved.slice( 1 ),
							this
						)
					} );
	
					// Abort handling of the native event
					event.stopImmediatePropagation();
				}
			}
		} );
	}
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || Date.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		code: true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
		jQuery.event.special[ type ] = {
	
			// Utilize native event if possible so blur/focus sequence is correct
			setup: function() {
	
				// Claim the first handler
				// dataPriv.set( this, "focus", ... )
				// dataPriv.set( this, "blur", ... )
				leverageNative( this, type, expectSync );
	
				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function() {
	
				// Force setup before trigger
				leverageNative( this, type );
	
				// Return non-false to allow normal event-path propagation
				return true;
			},
	
			delegateType: delegateType
		};
	} );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	// Prefer a tbody over its parent table for containing new rows
	function manipulationTarget( elem, content ) {
		if ( nodeName( elem, "table" ) &&
			nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
			elem.type = elem.type.slice( 5 );
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.get( src );
			events = pdataOld.events;
	
			if ( events ) {
				dataPriv.remove( dest, "handle events" );
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = flat( args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			valueIsFunction = isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( valueIsFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( valueIsFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl && !node.noModule ) {
									jQuery._evalUrl( node.src, {
										nonce: node.nonce || node.getAttribute( "nonce" )
									}, doc );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && isAttached( node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html;
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = isAttached( elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	var swap = function( elem, options, callback ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.call( elem );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
				"margin-top:1px;padding:0;border:0";
			div.style.cssText =
				"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
				"margin:auto;border:1px;padding:1px;" +
				"width:60%;top:1%";
			documentElement.appendChild( container ).appendChild( div );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;
	
			// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
			// Some styles come back with percentage values, even though they shouldn't
			div.style.right = "60%";
			pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;
	
			// Support: IE 9 - 11 only
			// Detect misreporting of content dimensions for box-sizing:border-box elements
			boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;
	
			// Support: IE 9 only
			// Detect overflow:scroll screwiness (gh-3699)
			// Support: Chrome <=64
			// Don't get tricked when zoom affects offsetWidth (gh-4029)
			div.style.position = "absolute";
			scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		function roundPixelMeasures( measure ) {
			return Math.round( parseFloat( measure ) );
		}
	
		var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
			reliableTrDimensionsVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		jQuery.extend( support, {
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelBoxStyles: function() {
				computeStyleTests();
				return pixelBoxStylesVal;
			},
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			},
			scrollboxSize: function() {
				computeStyleTests();
				return scrollboxSizeVal;
			},
	
			// Support: IE 9 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Behavior in IE 9 is more subtle than in newer versions & it passes
			// some versions of this test; make sure not to make it pass there!
			reliableTrDimensions: function() {
				var table, tr, trChild, trStyle;
				if ( reliableTrDimensionsVal == null ) {
					table = document.createElement( "table" );
					tr = document.createElement( "tr" );
					trChild = document.createElement( "div" );
	
					table.style.cssText = "position:absolute;left:-11111px";
					tr.style.height = "1px";
					trChild.style.height = "9px";
	
					documentElement
						.appendChild( table )
						.appendChild( tr )
						.appendChild( trChild );
	
					trStyle = window.getComputedStyle( tr );
					reliableTrDimensionsVal = parseInt( trStyle.height ) > 3;
	
					documentElement.removeChild( table );
				}
				return reliableTrDimensionsVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
	
			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// getPropertyValue is needed for:
		//   .css('filter') (IE 9 only, #12537)
		//   .css('--customProperty) (#3144)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !isAttached( elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style,
		vendorProps = {};
	
	// Return a vendor-prefixed property or undefined
	function vendorPropName( name ) {
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
	function finalPropName( name ) {
		var final = jQuery.cssProps[ name ] || vendorProps[ name ];
	
		if ( final ) {
			return final;
		}
		if ( name in emptyStyle ) {
			return name;
		}
		return vendorProps[ name ] = vendorPropName( name ) || name;
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		rcustomProp = /^--/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};
	
	function setPositiveNumber( _elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
		var i = dimension === "width" ? 1 : 0,
			extra = 0,
			delta = 0;
	
		// Adjustment may not be necessary
		if ( box === ( isBorderBox ? "border" : "content" ) ) {
			return 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin
			if ( box === "margin" ) {
				delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
			}
	
			// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
			if ( !isBorderBox ) {
	
				// Add padding
				delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// For "border" or "margin", add border
				if ( box !== "padding" ) {
					delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
	
				// But still keep track of it otherwise
				} else {
					extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
	
			// If we get here with a border-box (content + padding + border), we're seeking "content" or
			// "padding" or "margin"
			} else {
	
				// For "content", subtract padding
				if ( box === "content" ) {
					delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// For "content" or "padding", subtract border
				if ( box !== "margin" ) {
					delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		// Account for positive content-box scroll gutter when requested by providing computedVal
		if ( !isBorderBox && computedVal >= 0 ) {
	
			// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
			// Assuming integer scroll gutter, subtract the rest and round down
			delta += Math.max( 0, Math.ceil(
				elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
				computedVal -
				delta -
				extra -
				0.5
	
			// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
			// Use an explicit zero to avoid NaN (gh-3964)
			) ) || 0;
		}
	
		return delta;
	}
	
	function getWidthOrHeight( elem, dimension, extra ) {
	
		// Start with computed style
		var styles = getStyles( elem ),
	
			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			isBorderBox = boxSizingNeeded &&
				jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
			valueIsBorderBox = isBorderBox,
	
			val = curCSS( elem, dimension, styles ),
			offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );
	
		// Support: Firefox <=54
		// Return a confounding non-pixel value or feign ignorance, as appropriate.
		if ( rnumnonpx.test( val ) ) {
			if ( !extra ) {
				return val;
			}
			val = "auto";
		}
	
	
		// Support: IE 9 - 11 only
		// Use offsetWidth/offsetHeight for when box sizing is unreliable.
		// In those cases, the computed value can be trusted to be border-box.
		if ( ( !support.boxSizingReliable() && isBorderBox ||
	
			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||
	
			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||
	
			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&
	
			// Make sure the element is visible & connected
			elem.getClientRects().length ) {
	
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
			// Where available, offsetWidth/offsetHeight approximate border box dimensions.
			// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
			// retrieved value as a content box dimension.
			valueIsBorderBox = offsetProp in elem;
			if ( valueIsBorderBox ) {
				val = elem[ offsetProp ];
			}
		}
	
		// Normalize "" and auto
		val = parseFloat( val ) || 0;
	
		// Adjust for the element's box model
		return ( val +
			boxModelAdjustment(
				elem,
				dimension,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles,
	
				// Provide the current computed size to request scroll gutter calculation (gh-3589)
				val
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"gridArea": true,
			"gridColumn": true,
			"gridColumnEnd": true,
			"gridColumnStart": true,
			"gridRow": true,
			"gridRowEnd": true,
			"gridRowStart": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name ),
				style = elem.style;
	
			// Make sure that we're working with the right name. We don't
			// want to query the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
				// "px" to a few hardcoded values.
				if ( type === "number" && !isCustomProp ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					if ( isCustomProp ) {
						style.setProperty( name, value );
					} else {
						style[ name ] = value;
					}
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = camelCase( name ),
				isCustomProp = rcustomProp.test( name );
	
			// Make sure that we're working with the right name. We don't
			// want to modify the value if it is a CSS custom property
			// since they are user-defined.
			if ( !isCustomProp ) {
				name = finalPropName( origName );
			}
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
	
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( _i, dimension ) {
		jQuery.cssHooks[ dimension ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, dimension, extra );
							} ) :
							getWidthOrHeight( elem, dimension, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = getStyles( elem ),
	
					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() &&
						styles.position === "absolute",
	
					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					isBorderBox = boxSizingNeeded &&
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					subtract = extra ?
						boxModelAdjustment(
							elem,
							dimension,
							extra,
							isBorderBox,
							styles
						) :
						0;
	
				// Account for unreliable border-box dimensions by comparing offset* to computed and
				// faking a content-box to get border and padding (gh-3699)
				if ( isBorderBox && scrollboxSizeBuggy ) {
					subtract -= Math.ceil(
						elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
						parseFloat( styles[ dimension ] ) -
						boxModelAdjustment( elem, dimension, "border", false, styles ) -
						0.5
					);
				}
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ dimension ] = value;
					value = jQuery.css( elem, dimension );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( prefix !== "margin" ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( Array.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 && (
						jQuery.cssHooks[ tween.prop ] ||
						tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, inProgress,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function schedule() {
		if ( inProgress ) {
			if ( document.hidden === false && window.requestAnimationFrame ) {
				window.requestAnimationFrame( schedule );
			} else {
				window.setTimeout( schedule, jQuery.fx.interval );
			}
	
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = Date.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 15
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY and Edge just mirrors
			// the overflowX value there.
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( Array.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				// If there's more to do, yield
				if ( percent < 1 && length ) {
					return remaining;
				}
	
				// If this was an empty animation, synthesize a final progress notification
				if ( !length ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
				}
	
				// Resolve the animation and report its conclusion
				deferred.resolveWith( elem, [ animation ] );
				return false;
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						result.stop.bind( result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		// Attach callbacks from options
		animation
			.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		return animation;
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off
		if ( jQuery.fx.off ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = Date.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Run the timer and safely remove it when done (allowing for external removal)
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		jQuery.fx.start();
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( inProgress ) {
			return;
		}
	
		inProgress = true;
		schedule();
	};
	
	jQuery.fx.stop = function() {
		inProgress = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	function classesToArray( value ) {
		if ( Array.isArray( value ) ) {
			return value;
		}
		if ( typeof value === "string" ) {
			return value.match( rnothtmlwhite ) || [];
		}
		return [];
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			classes = classesToArray( value );
	
			if ( classes.length ) {
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value,
				isValidValue = type === "string" || Array.isArray( value );
	
			if ( typeof stateVal === "boolean" && isValidValue ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( isValidValue ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = classesToArray( value );
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, valueIsFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			valueIsFunction = isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( valueIsFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( Array.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( Array.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	support.focusin = "onfocusin" in window;
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		stopPropagationCallback = function( e ) {
			e.stopPropagation();
		};
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = lastElement = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
				lastElement = cur;
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = (
						dataPriv.get( cur, "events" ) || Object.create( null )
					)[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
	
						if ( event.isPropagationStopped() ) {
							lastElement.addEventListener( type, stopPropagationCallback );
						}
	
						elem[ type ]();
	
						if ( event.isPropagationStopped() ) {
							lastElement.removeEventListener( type, stopPropagationCallback );
						}
	
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
	
					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this.document || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = { guid: Date.now() };
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( Array.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && toType( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		if ( a == null ) {
			return "";
		}
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( _i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( Array.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
										( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
											.concat( match[ 2 ] );
								}
							}
							match = responseHeaders[ key.toLowerCase() + " " ];
						}
						return match == null ? null : match.join( ", " );
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 15
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available and should be processed, append data to url
				if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
						uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Use a noop converter for missing script
				if ( !isSuccess && jQuery.inArray( "script", s.dataTypes ) > -1 ) {
					s.converters[ "text script" ] = function() {};
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( _i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	jQuery.ajaxPrefilter( function( s ) {
		var i;
		for ( i in s.headers ) {
			if ( i.toLowerCase() === "content-type" ) {
				s.contentType = s.headers[ i ] || "";
			}
		}
	} );
	
	
	jQuery._evalUrl = function( url, options, doc ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
	
			// Only evaluate the response if it is successful (gh-4126)
			// dataFilter is not invoked for failure responses, so using it instead
			// of the default converter is kludgy but it works.
			converters: {
				"text script": function() {}
			},
			dataFilter: function( response ) {
				jQuery.globalEval( response, options, doc );
			}
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var htmlIsFunction = isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.ontimeout =
										xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain or forced-by-attrs requests
		if ( s.crossDomain || s.scriptAttrs ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" )
						.attr( s.scriptAttrs || {} )
						.prop( { charset: s.scriptCharset, src: s.url } )
						.on( "load error", callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						} );
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				if ( typeof props.top === "number" ) {
					props.top += "px";
				}
				if ( typeof props.left === "number" ) {
					props.left += "px";
				}
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
	
		// offset() relates an element's border box to the document origin
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var rect, win,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			// Get document-relative position by adding viewport scroll to viewport-relative gBCR
			rect = elem.getBoundingClientRect();
			win = elem.ownerDocument.defaultView;
			return {
				top: rect.top + win.pageYOffset,
				left: rect.left + win.pageXOffset
			};
		},
	
		// position() relates an element's margin box to its offset parent's padding box
		// This corresponds to the behavior of CSS absolute positioning
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset, doc,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// position:fixed elements are offset from the viewport, which itself always has zero offset
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume position:fixed implies availability of getBoundingClientRect
				offset = elem.getBoundingClientRect();
	
			} else {
				offset = this.offset();
	
				// Account for the *real* offset parent, which can be the document or its root element
				// when a statically positioned element is identified
				doc = elem.ownerDocument;
				offsetParent = elem.offsetParent || doc.documentElement;
				while ( offsetParent &&
					( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
					jQuery.css( offsetParent, "position" ) === "static" ) {
	
					offsetParent = offsetParent.parentNode;
				}
				if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {
	
					// Incorporate borders into its offset, since they are outside its content origin
					parentOffset = jQuery( offsetParent ).offset();
					parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
					parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
				}
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
	
				// Coalesce documents and windows
				var win;
				if ( isWindow( elem ) ) {
					win = elem;
				} else if ( elem.nodeType === 9 ) {
					win = elem.defaultView;
				}
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( _i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( _i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		},
	
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( _i, name ) {
	
			// Handle event binding
			jQuery.fn[ name ] = function( data, fn ) {
				return arguments.length > 0 ?
					this.on( name, null, data, fn ) :
					this.trigger( name );
			};
		} );
	
	
	
	
	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
	
	// Bind a function to a context, optionally partially applying any
	// arguments.
	// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
	// However, it is not slated for removal any time soon
	jQuery.proxy = function( fn, context ) {
		var tmp, args, proxy;
	
		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}
	
		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !isFunction( fn ) ) {
			return undefined;
		}
	
		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};
	
		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
		return proxy;
	};
	
	jQuery.holdReady = function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	};
	jQuery.isArray = Array.isArray;
	jQuery.parseJSON = JSON.parse;
	jQuery.nodeName = nodeName;
	jQuery.isFunction = isFunction;
	jQuery.isWindow = isWindow;
	jQuery.camelCase = camelCase;
	jQuery.type = toType;
	
	jQuery.now = Date.now;
	
	jQuery.isNumeric = function( obj ) {
	
		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&
	
			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	};
	
	jQuery.trim = function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	};
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( typeof noGlobal === "undefined" ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	return jQuery;
	} );


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(165),
	    toKey = __webpack_require__(136);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(1384),
	    Map = __webpack_require__(350),
	    Promise = __webpack_require__(1386),
	    Set = __webpack_require__(529),
	    WeakMap = __webpack_require__(532),
	    baseGetTag = __webpack_require__(134),
	    toSource = __webpack_require__(566);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var createFlow = __webpack_require__(1439);
	
	/**
	 * This method is like `_.flow` except that it creates a function that
	 * invokes the given functions from right to left.
	 *
	 * @static
	 * @since 3.0.0
	 * @memberOf _
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flow
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flowRight([square, _.add]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flowRight = createFlow(true);
	
	module.exports = flowRight;


/***/ }),
/* 203 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(253),
	    isArrayLike = __webpack_require__(97),
	    isString = __webpack_require__(1502),
	    toInteger = __webpack_require__(267),
	    values = __webpack_require__(583);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */
	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike(collection) ? collection : values(collection);
	  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	  var length = collection.length;
	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }
	  return isString(collection)
	    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	}
	
	module.exports = includes;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(1400),
	    isObjectLike = __webpack_require__(81);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(80),
	    stubFalse = __webpack_require__(1511);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	var createRange = __webpack_require__(1440);
	
	/**
	 * Creates an array of numbers (positive and/or negative) progressing from
	 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	 * `start` is specified without an `end` or `step`. If `end` is not specified,
	 * it's set to `start` with `start` then set to `0`.
	 *
	 * **Note:** JavaScript follows the IEEE-754 standard for resolving
	 * floating-point values which can produce unexpected results.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {number} [start=0] The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} [step=1] The value to increment or decrement by.
	 * @returns {Array} Returns the range of numbers.
	 * @see _.inRange, _.rangeRight
	 * @example
	 *
	 * _.range(4);
	 * // => [0, 1, 2, 3]
	 *
	 * _.range(-4);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 5);
	 * // => [1, 2, 3, 4]
	 *
	 * _.range(0, 20, 5);
	 * // => [0, 5, 10, 15]
	 *
	 * _.range(0, -4, -1);
	 * // => [0, -1, -2, -3]
	 *
	 * _.range(1, 4, 0);
	 * // => [1, 1, 1]
	 *
	 * _.range(0);
	 * // => []
	 */
	var range = createRange();
	
	module.exports = range;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultUtils = undefined;
	exports.dateTimeFormat = dateTimeFormat;
	exports.getYear = getYear;
	exports.setYear = setYear;
	exports.addDays = addDays;
	exports.addMonths = addMonths;
	exports.addYears = addYears;
	exports.cloneDate = cloneDate;
	exports.cloneAsDate = cloneAsDate;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getFirstDayOfMonth = getFirstDayOfMonth;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getWeekArray = getWeekArray;
	exports.localizedWeekday = localizedWeekday;
	exports.formatIso = formatIso;
	exports.isEqualDate = isEqualDate;
	exports.isBeforeDate = isBeforeDate;
	exports.isAfterDate = isAfterDate;
	exports.isBetweenDates = isBetweenDates;
	exports.monthDiff = monthDiff;
	exports.yearDiff = yearDiff;
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
	var dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var monthLongList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function dateTimeFormat(locale, options) {
	   false ? (0, _warning2.default)(locale === 'en-US', 'Material-UI: The ' + locale + ' locale is not supported by the built-in DateTimeFormat.\n  Use the `DateTimeFormat` prop to supply an alternative implementation.') : void 0;
	
	  this.format = function (date) {
	    if (options.month === 'short' && options.weekday === 'short' && options.day === '2-digit') {
	      return dayList[date.getDay()] + ', ' + monthList[date.getMonth()] + ' ' + date.getDate();
	    } else if (options.year === 'numeric' && options.month === 'numeric' && options.day === 'numeric') {
	      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
	    } else if (options.year === 'numeric' && options.month === 'long') {
	      return monthLongList[date.getMonth()] + ' ' + date.getFullYear();
	    } else if (options.weekday === 'narrow') {
	      return dayAbbreviation[date.getDay()];
	    } else if (options.year === 'numeric') {
	      return date.getFullYear().toString();
	    } else if (options.day === 'numeric') {
	      return date.getDate();
	    } else {
	       false ? (0, _warning2.default)(false, 'Material-UI: Wrong usage of DateTimeFormat') : void 0;
	    }
	  };
	}
	
	function getYear(d) {
	  return d.getFullYear();
	}
	
	function setYear(d, year) {
	  var newDate = cloneDate(d);
	  newDate.setFullYear(year);
	  return newDate;
	}
	
	function addDays(d, days) {
	  var newDate = cloneDate(d);
	  newDate.setDate(d.getDate() + days);
	  return newDate;
	}
	
	function addMonths(d, months) {
	  var newDate = cloneDate(d);
	  newDate.setMonth(d.getMonth() + months);
	  return newDate;
	}
	
	function addYears(d, years) {
	  var newDate = cloneDate(d);
	  newDate.setFullYear(d.getFullYear() + years);
	  return newDate;
	}
	
	function cloneDate(d) {
	  return new Date(d.getTime());
	}
	
	function cloneAsDate(d) {
	  var clonedDate = cloneDate(d);
	  clonedDate.setHours(0, 0, 0, 0);
	  return clonedDate;
	}
	
	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	
	  return resultDate.getDate();
	}
	
	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1);
	}
	
	function getFirstDayOfWeek() {
	  var now = new Date();
	  return new Date(now.setDate(now.getDate() - now.getDay()));
	}
	
	function getWeekArray(d, firstDayOfWeek) {
	  var dayArray = [];
	  var daysInMonth = getDaysInMonth(d);
	  var weekArray = [];
	  var week = [];
	
	  for (var i = 1; i <= daysInMonth; i++) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
	  }
	
	  var addWeek = function addWeek(week) {
	    var emptyDays = 7 - week.length;
	    for (var _i = 0; _i < emptyDays; ++_i) {
	      week[weekArray.length ? 'push' : 'unshift'](null);
	    }
	    weekArray.push(week);
	  };
	
	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      addWeek(week);
	      week = [];
	    }
	    week.push(day);
	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      addWeek(week);
	    }
	  });
	
	  return weekArray;
	}
	
	function localizedWeekday(DateTimeFormat, locale, day, firstDayOfWeek) {
	  var weekdayFormatter = new DateTimeFormat(locale, { weekday: 'narrow' });
	  var firstDayDate = getFirstDayOfWeek();
	
	  return weekdayFormatter.format(addDays(firstDayDate, day + firstDayOfWeek));
	}
	
	// Convert date to ISO 8601 (YYYY-MM-DD) date string, accounting for current timezone
	function formatIso(date) {
	  return new Date(date.toDateString() + ' 12:00:00 +0000').toISOString().substring(0, 10);
	}
	
	function isEqualDate(d1, d2) {
	  return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
	}
	
	function isBeforeDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() < date2.getTime();
	}
	
	function isAfterDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() > date2.getTime();
	}
	
	function isBetweenDates(dateToCheck, startDate, endDate) {
	  return !isBeforeDate(dateToCheck, startDate) && !isAfterDate(dateToCheck, endDate);
	}
	
	function monthDiff(d1, d2) {
	  var m = void 0;
	  m = (d1.getFullYear() - d2.getFullYear()) * 12;
	  m += d1.getMonth();
	  m -= d2.getMonth();
	  return m;
	}
	
	function yearDiff(d1, d2) {
	  return ~~(monthDiff(d1, d2) / 12);
	}
	
	var defaultUtils = exports.defaultUtils = {
	  getYear: getYear,
	  setYear: setYear,
	  addDays: addDays,
	  addMonths: addMonths,
	  addYears: addYears,
	  getFirstDayOfMonth: getFirstDayOfMonth,
	  getWeekArray: getWeekArray,
	  monthDiff: monthDiff
	};

/***/ }),
/* 209 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addHours = addHours;
	exports.addMinutes = addMinutes;
	exports.addSeconds = addSeconds;
	exports.formatTime = formatTime;
	exports.rad2deg = rad2deg;
	exports.getTouchEventOffsetValues = getTouchEventOffsetValues;
	exports.isInner = isInner;
	function addHours(d, hours) {
	  var newDate = clone(d);
	  newDate.setHours(d.getHours() + hours);
	  return newDate;
	}
	
	function addMinutes(d, minutes) {
	  var newDate = clone(d);
	  newDate.setMinutes(d.getMinutes() + minutes);
	  return newDate;
	}
	
	function addSeconds(d, seconds) {
	  var newDate = clone(d);
	  newDate.setSeconds(d.getMinutes() + seconds);
	  return newDate;
	}
	
	function clone(d) {
	  return new Date(d.getTime());
	}
	
	/**
	 * @param date [Date] A Date object.
	 * @param format [String] One of 'ampm', '24hr', defaults to 'ampm'.
	 * @param pedantic [Boolean] Check time-picker/time-picker.jsx file.
	 *
	 * @return String A string representing the formatted time.
	 */
	function formatTime(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ampm';
	  var pedantic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!date) return '';
	  var hours = date.getHours();
	  var mins = date.getMinutes().toString();
	
	  if (format === 'ampm') {
	    var isAM = hours < 12;
	    hours = hours % 12;
	    var additional = isAM ? ' am' : ' pm';
	    hours = (hours || 12).toString();
	
	    if (mins.length < 2) mins = '0' + mins;
	
	    if (pedantic) {
	      // Treat midday/midnight specially http://www.nist.gov/pml/div688/times.cfm
	      if (hours === '12' && mins === '00') {
	        return additional === ' pm' ? '12 noon' : '12 midnight';
	      }
	    }
	
	    return hours + (mins === '00' ? '' : ':' + mins) + additional;
	  }
	
	  hours = hours.toString();
	
	  if (hours.length < 2) hours = '0' + hours;
	  if (mins.length < 2) mins = '0' + mins;
	
	  return hours + ':' + mins;
	}
	
	function rad2deg(rad) {
	  return rad * 57.29577951308232;
	}
	
	function getTouchEventOffsetValues(event) {
	  var el = event.target;
	  var boundingRect = el.getBoundingClientRect();
	
	  return {
	    offsetX: event.clientX - boundingRect.left,
	    offsetY: event.clientY - boundingRect.top
	  };
	}
	
	function isInner(props) {
	  if (props.type !== 'hour') {
	    return false;
	  }
	  return props.value < 1 || props.value > 12;
	}

/***/ }),
/* 210 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = _interopDefault(__webpack_require__(1));
	var PropTypes = _interopDefault(__webpack_require__(2));
	var classnames = _interopDefault(__webpack_require__(1051));
	var onClickOutside = _interopDefault(__webpack_require__(1681));
	var moment = _interopDefault(__webpack_require__(3));
	var reactPopper = __webpack_require__(1684);
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	
	
	
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	
	
	
	
	
	
	
	
	
	
	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};
	
	function generateYears(year, noOfYear, minDate, maxDate) {
	  var list = [];
	  for (var i = 0; i < 2 * noOfYear + 1; i++) {
	    var newYear = year + noOfYear - i;
	    var isInRange = true;
	
	    if (minDate) {
	      isInRange = minDate.year() <= newYear;
	    }
	
	    if (maxDate && isInRange) {
	      isInRange = maxDate.year() >= newYear;
	    }
	
	    if (isInRange) {
	      list.push(newYear);
	    }
	  }
	
	  return list;
	}
	
	var YearDropdownOptions = function (_React$Component) {
	  inherits(YearDropdownOptions, _React$Component);
	
	  function YearDropdownOptions(props) {
	    classCallCheck(this, YearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      var selectedYear = _this.props.year;
	      var options = _this.state.yearsList.map(function (year) {
	        return React.createElement(
	          "div",
	          {
	            className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
	            key: year,
	            ref: year,
	            onClick: _this.onChange.bind(_this, year)
	          },
	          selectedYear === year ? React.createElement(
	            "span",
	            { className: "react-datepicker__year-option--selected" },
	            "\u2713"
	          ) : "",
	          year
	        );
	      });
	
	      var minYear = _this.props.minDate ? _this.props.minDate.year() : null;
	      var maxYear = _this.props.maxDate ? _this.props.maxDate.year() : null;
	
	      if (!maxYear || !_this.state.yearsList.find(function (year) {
	        return year === maxYear;
	      })) {
	        options.unshift(React.createElement(
	          "div",
	          {
	            className: "react-datepicker__year-option",
	            ref: "upcoming",
	            key: "upcoming",
	            onClick: _this.incrementYears
	          },
	          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
	        ));
	      }
	
	      if (!minYear || !_this.state.yearsList.find(function (year) {
	        return year === minYear;
	      })) {
	        options.push(React.createElement(
	          "div",
	          {
	            className: "react-datepicker__year-option",
	            ref: "previous",
	            key: "previous",
	            onClick: _this.decrementYears
	          },
	          React.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
	        ));
	      }
	
	      return options;
	    };
	
	    _this.onChange = function (year) {
	      _this.props.onChange(year);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.shiftYears = function (amount) {
	      var years = _this.state.yearsList.map(function (year) {
	        return year + amount;
	      });
	
	      _this.setState({
	        yearsList: years
	      });
	    };
	
	    _this.incrementYears = function () {
	      return _this.shiftYears(1);
	    };
	
	    _this.decrementYears = function () {
	      return _this.shiftYears(-1);
	    };
	
	    var yearDropdownItemNumber = props.yearDropdownItemNumber,
	        scrollableYearDropdown = props.scrollableYearDropdown;
	
	    var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
	
	    _this.state = {
	      yearsList: generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  YearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      "react-datepicker__year-dropdown": true,
	      "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
	    });
	
	    return React.createElement(
	      "div",
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return YearDropdownOptions;
	}(React.Component);
	
	YearDropdownOptions.propTypes = {
	  minDate: PropTypes.object,
	  maxDate: PropTypes.object,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number
	};
	
	var dayOfWeekCodes = {
	  1: "mon",
	  2: "tue",
	  3: "wed",
	  4: "thu",
	  5: "fri",
	  6: "sat",
	  7: "sun"
	};
	
	// These functions are not exported so
	// that we avoid magic strings like 'days'
	function set$1(date, unit, to) {
	  return date.set(unit, to);
	}
	
	function add(date, amount, unit) {
	  return date.add(amount, unit);
	}
	
	function subtract(date, amount, unit) {
	  return date.subtract(amount, unit);
	}
	
	function get$1(date, unit) {
	  return date.get(unit);
	}
	
	function getStartOf(date, unit) {
	  return date.startOf(unit);
	}
	
	// ** Date Constructors **
	
	function newDate(point) {
	  return moment(point);
	}
	
	function newDateWithOffset(utcOffset) {
	  return moment().utc().utcOffset(utcOffset);
	}
	
	function now(maybeFixedUtcOffset) {
	  if (maybeFixedUtcOffset == null) {
	    return newDate();
	  }
	  return newDateWithOffset(maybeFixedUtcOffset);
	}
	
	function cloneDate(date) {
	  return date.clone();
	}
	
	function parseDate(value, _ref) {
	  var dateFormat = _ref.dateFormat,
	      locale = _ref.locale;
	
	  var m = moment(value, dateFormat, locale || moment.locale(), true);
	  return m.isValid() ? m : null;
	}
	
	// ** Date "Reflection" **
	
	function isMoment(date) {
	  return moment.isMoment(date);
	}
	
	function isDate(date) {
	  return moment.isDate(date);
	}
	
	// ** Date Formatting **
	
	function formatDate(date, format) {
	  return date.format(format);
	}
	
	function safeDateFormat(date, _ref2) {
	  var dateFormat = _ref2.dateFormat,
	      locale = _ref2.locale;
	
	  return date && date.clone().locale(locale || moment.locale()).format(Array.isArray(dateFormat) ? dateFormat[0] : dateFormat) || "";
	}
	
	// ** Date Setters **
	
	function setTime(date, _ref3) {
	  var hour = _ref3.hour,
	      minute = _ref3.minute,
	      second = _ref3.second;
	
	  date.set({ hour: hour, minute: minute, second: second });
	  return date;
	}
	
	function setMonth(date, month) {
	  return set$1(date, "month", month);
	}
	
	function setYear(date, year) {
	  return set$1(date, "year", year);
	}
	
	
	
	// ** Date Getters **
	
	function getSecond(date) {
	  return get$1(date, "second");
	}
	
	function getMinute(date) {
	  return get$1(date, "minute");
	}
	
	function getHour(date) {
	  return get$1(date, "hour");
	}
	
	// Returns day of week
	function getDay(date) {
	  return get$1(date, "day");
	}
	
	function getWeek(date) {
	  return get$1(date, "week");
	}
	
	function getMonth(date) {
	  return get$1(date, "month");
	}
	
	function getYear(date) {
	  return get$1(date, "year");
	}
	
	// Returns day of month
	function getDate(date) {
	  return get$1(date, "date");
	}
	
	
	
	function getDayOfWeekCode(day) {
	  return dayOfWeekCodes[day.isoWeekday()];
	}
	
	// *** Start of ***
	
	function getStartOfDay(date) {
	  return getStartOf(date, "day");
	}
	
	function getStartOfWeek(date) {
	  return getStartOf(date, "week");
	}
	function getStartOfMonth(date) {
	  return getStartOf(date, "month");
	}
	
	function getStartOfDate(date) {
	  return getStartOf(date, "date");
	}
	
	// *** End of ***
	
	
	
	
	
	// ** Date Math **
	
	// *** Addition ***
	
	function addMinutes(date, amount) {
	  return add(date, amount, "minutes");
	}
	
	function addHours(date, amount) {
	  return add(date, amount, "hours");
	}
	
	function addDays(date, amount) {
	  return add(date, amount, "days");
	}
	
	function addWeeks(date, amount) {
	  return add(date, amount, "weeks");
	}
	
	function addMonths(date, amount) {
	  return add(date, amount, "months");
	}
	
	function addYears(date, amount) {
	  return add(date, amount, "years");
	}
	
	// *** Subtraction ***
	function subtractDays(date, amount) {
	  return subtract(date, amount, "days");
	}
	
	function subtractWeeks(date, amount) {
	  return subtract(date, amount, "weeks");
	}
	
	function subtractMonths(date, amount) {
	  return subtract(date, amount, "months");
	}
	
	function subtractYears(date, amount) {
	  return subtract(date, amount, "years");
	}
	
	// ** Date Comparison **
	
	function isBefore(date1, date2) {
	  return date1.isBefore(date2);
	}
	
	function isAfter(date1, date2) {
	  return date1.isAfter(date2);
	}
	
	function equals(date1, date2) {
	  return date1.isSame(date2);
	}
	
	function isSameYear(date1, date2) {
	  if (date1 && date2) {
	    return date1.isSame(date2, "year");
	  } else {
	    return !date1 && !date2;
	  }
	}
	
	function isSameMonth(date1, date2) {
	  if (date1 && date2) {
	    return date1.isSame(date2, "month");
	  } else {
	    return !date1 && !date2;
	  }
	}
	
	function isSameDay(moment1, moment2) {
	  if (moment1 && moment2) {
	    return moment1.isSame(moment2, "day");
	  } else {
	    return !moment1 && !moment2;
	  }
	}
	
	
	
	function isDayInRange(day, startDate, endDate) {
	  var before = startDate.clone().startOf("day").subtract(1, "seconds");
	  var after = endDate.clone().startOf("day").add(1, "seconds");
	  return day.clone().startOf("day").isBetween(before, after);
	}
	
	// *** Diffing ***
	
	
	
	// ** Date Localization **
	
	function localizeDate(date, locale) {
	  return date.clone().locale(locale || moment.locale());
	}
	
	
	
	
	
	
	
	function getLocaleData(date) {
	  return date.localeData();
	}
	
	function getLocaleDataForLocale(locale) {
	  return moment.localeData(locale);
	}
	
	function getFormattedWeekdayInLocale(locale, date, formatFunc) {
	  return formatFunc(locale.weekdays(date));
	}
	
	function getWeekdayMinInLocale(locale, date) {
	  return locale.weekdaysMin(date);
	}
	
	function getWeekdayShortInLocale(locale, date) {
	  return locale.weekdaysShort(date);
	}
	
	// TODO what is this format exactly?
	function getMonthInLocale(locale, date, format) {
	  return locale.months(date, format);
	}
	
	function getMonthShortInLocale(locale, date) {
	  return locale.monthsShort(date);
	}
	
	// ** Utils for some components **
	
	function isDayDisabled(day) {
	  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      minDate = _ref4.minDate,
	      maxDate = _ref4.maxDate,
	      excludeDates = _ref4.excludeDates,
	      includeDates = _ref4.includeDates,
	      filterDate = _ref4.filterDate;
	
	  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day") || excludeDates && excludeDates.some(function (excludeDate) {
	    return isSameDay(day, excludeDate);
	  }) || includeDates && !includeDates.some(function (includeDate) {
	    return isSameDay(day, includeDate);
	  }) || filterDate && !filterDate(day.clone()) || false;
	}
	
	function isOutOfBounds(day) {
	  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      minDate = _ref5.minDate,
	      maxDate = _ref5.maxDate;
	
	  return minDate && day.isBefore(minDate, "day") || maxDate && day.isAfter(maxDate, "day");
	}
	
	function isTimeDisabled(time, disabledTimes) {
	  var l = disabledTimes.length;
	  for (var i = 0; i < l; i++) {
	    if (disabledTimes[i].get("hours") === time.get("hours") && disabledTimes[i].get("minutes") === time.get("minutes")) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function isTimeInDisabledRange(time, _ref6) {
	  var minTime = _ref6.minTime,
	      maxTime = _ref6.maxTime;
	
	  if (!minTime || !maxTime) {
	    throw new Error("Both minTime and maxTime props required");
	  }
	
	  var base = moment().hours(0).minutes(0).seconds(0);
	  var baseTime = base.clone().hours(time.get("hours")).minutes(time.get("minutes"));
	  var min = base.clone().hours(minTime.get("hours")).minutes(minTime.get("minutes"));
	  var max = base.clone().hours(maxTime.get("hours")).minutes(maxTime.get("minutes"));
	
	  return !(baseTime.isSameOrAfter(min) && baseTime.isSameOrBefore(max));
	}
	
	function allDaysDisabledBefore(day, unit) {
	  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      minDate = _ref7.minDate,
	      includeDates = _ref7.includeDates;
	
	  var dateBefore = day.clone().subtract(1, unit);
	  return minDate && dateBefore.isBefore(minDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateBefore.isBefore(includeDate, unit);
	  }) || false;
	}
	
	function allDaysDisabledAfter(day, unit) {
	  var _ref8 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      maxDate = _ref8.maxDate,
	      includeDates = _ref8.includeDates;
	
	  var dateAfter = day.clone().add(1, unit);
	  return maxDate && dateAfter.isAfter(maxDate, unit) || includeDates && includeDates.every(function (includeDate) {
	    return dateAfter.isAfter(includeDate, unit);
	  }) || false;
	}
	
	function getEffectiveMinDate(_ref9) {
	  var minDate = _ref9.minDate,
	      includeDates = _ref9.includeDates;
	
	  if (includeDates && minDate) {
	    return moment.min(includeDates.filter(function (includeDate) {
	      return minDate.isSameOrBefore(includeDate, "day");
	    }));
	  } else if (includeDates) {
	    return moment.min(includeDates);
	  } else {
	    return minDate;
	  }
	}
	
	function getEffectiveMaxDate(_ref10) {
	  var maxDate = _ref10.maxDate,
	      includeDates = _ref10.includeDates;
	
	  if (includeDates && maxDate) {
	    return moment.max(includeDates.filter(function (includeDate) {
	      return maxDate.isSameOrAfter(includeDate, "day");
	    }));
	  } else if (includeDates) {
	    return moment.max(includeDates);
	  } else {
	    return maxDate;
	  }
	}
	
	function getHightLightDaysMap() {
	  var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";
	
	  var dateClasses = new Map();
	  for (var i = 0, len = highlightDates.length; i < len; i++) {
	    var obj = highlightDates[i];
	    if (isMoment(obj)) {
	      var key = obj.format("MM.DD.YYYY");
	      var classNamesArr = dateClasses.get(key) || [];
	      if (!classNamesArr.includes(defaultClassName)) {
	        classNamesArr.push(defaultClassName);
	        dateClasses.set(key, classNamesArr);
	      }
	    } else if ((typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object") {
	      var keys = Object.keys(obj);
	      var className = keys[0];
	      var arrOfMoments = obj[keys[0]];
	      if (typeof className === "string" && arrOfMoments.constructor === Array) {
	        for (var k = 0, _len = arrOfMoments.length; k < _len; k++) {
	          var _key = arrOfMoments[k].format("MM.DD.YYYY");
	          var _classNamesArr = dateClasses.get(_key) || [];
	          if (!_classNamesArr.includes(className)) {
	            _classNamesArr.push(className);
	            dateClasses.set(_key, _classNamesArr);
	          }
	        }
	      }
	    }
	  }
	
	  return dateClasses;
	}
	
	function timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
	  var l = injectedTimes.length;
	  var times = [];
	  for (var i = 0; i < l; i++) {
	    var injectedTime = addMinutes(addHours(cloneDate(startOfDay), getHour(injectedTimes[i])), getMinute(injectedTimes[i]));
	    var nextTime = addMinutes(cloneDate(startOfDay), (currentMultiplier + 1) * intervals);
	
	    if (injectedTime.isBetween(currentTime, nextTime)) {
	      times.push(injectedTimes[i]);
	    }
	  }
	
	  return times;
	}
	
	var WrappedYearDropdownOptions = onClickOutside(YearDropdownOptions);
	
	var YearDropdown = function (_React$Component) {
	  inherits(YearDropdown, _React$Component);
	
	  function YearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, YearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var minYear = _this.props.minDate ? getYear(_this.props.minDate) : 1900;
	      var maxYear = _this.props.maxDate ? getYear(_this.props.maxDate) : 2100;
	
	      var options = [];
	      for (var i = minYear; i <= maxYear; i++) {
	        options.push(React.createElement(
	          "option",
	          { key: i, value: i },
	          i
	        ));
	      }
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        "select",
	        {
	          value: _this.props.year,
	          className: "react-datepicker__year-select",
	          onChange: _this.onSelectChange
	        },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__year-read-view",
	          onClick: function onClick(event) {
	            return _this.toggleDropdown(event);
	          }
	        },
	        React.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__year-read-view--selected-year" },
	          _this.props.year
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedYearDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        year: _this.props.year,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	      });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (year) {
	      _this.toggleDropdown();
	      if (year === _this.props.year) return;
	      _this.props.onChange(year);
	    }, _this.toggleDropdown = function (event) {
	      _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      }, function () {
	        if (_this.props.adjustDateOnChange) {
	          _this.handleYearChange(_this.props.date, event);
	        }
	      });
	    }, _this.handleYearChange = function (date, event) {
	      _this.onSelect(date, event);
	      _this.setOpen();
	    }, _this.onSelect = function (date, event) {
	      if (_this.props.onSelect) {
	        _this.props.onSelect(date, event);
	      }
	    }, _this.setOpen = function () {
	      if (_this.props.setOpen) {
	        _this.props.setOpen(true);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  YearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return YearDropdown;
	}(React.Component);
	
	YearDropdown.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onChange: PropTypes.func.isRequired,
	  scrollableYearDropdown: PropTypes.bool,
	  year: PropTypes.number.isRequired,
	  yearDropdownItemNumber: PropTypes.number,
	  date: PropTypes.object,
	  onSelect: PropTypes.func,
	  setOpen: PropTypes.func
	};
	
	var MonthDropdownOptions = function (_React$Component) {
	  inherits(MonthDropdownOptions, _React$Component);
	
	  function MonthDropdownOptions() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdownOptions);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderOptions = function () {
	      return _this.props.monthNames.map(function (month, i) {
	        return React.createElement(
	          "div",
	          {
	            className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
	            key: month,
	            ref: month,
	            onClick: _this.onChange.bind(_this, i)
	          },
	          _this.props.month === i ? React.createElement(
	            "span",
	            { className: "react-datepicker__month-option--selected" },
	            "\u2713"
	          ) : "",
	          month
	        );
	      });
	    }, _this.onChange = function (month) {
	      return _this.props.onChange(month);
	    }, _this.handleClickOutside = function () {
	      return _this.props.onCancel();
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdownOptions.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "react-datepicker__month-dropdown" },
	      this.renderOptions()
	    );
	  };
	
	  return MonthDropdownOptions;
	}(React.Component);
	
	MonthDropdownOptions.propTypes = {
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  month: PropTypes.number.isRequired,
	  monthNames: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
	};
	
	var WrappedMonthDropdownOptions = onClickOutside(MonthDropdownOptions);
	
	var MonthDropdown = function (_React$Component) {
	  inherits(MonthDropdown, _React$Component);
	
	  function MonthDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function (monthNames) {
	      return monthNames.map(function (M, i) {
	        return React.createElement(
	          "option",
	          { key: i, value: i },
	          M
	        );
	      });
	    }, _this.renderSelectMode = function (monthNames) {
	      return React.createElement(
	        "select",
	        {
	          value: _this.props.month,
	          className: "react-datepicker__month-select",
	          onChange: function onChange(e) {
	            return _this.onChange(e.target.value);
	          }
	        },
	        _this.renderSelectOptions(monthNames)
	      );
	    }, _this.renderReadView = function (visible, monthNames) {
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__month-read-view",
	          onClick: _this.toggleDropdown
	        },
	        React.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__month-read-view--selected-month" },
	          monthNames[_this.props.month]
	        )
	      );
	    }, _this.renderDropdown = function (monthNames) {
	      return React.createElement(WrappedMonthDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        month: _this.props.month,
	        monthNames: monthNames,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown
	      });
	    }, _this.renderScrollMode = function (monthNames) {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible, monthNames)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown(monthNames));
	      }
	      return result;
	    }, _this.onChange = function (month) {
	      _this.toggleDropdown();
	      if (month !== _this.props.month) {
	        _this.props.onChange(month);
	      }
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthDropdown.prototype.render = function render() {
	    var _this2 = this;
	
	    var localeData = getLocaleDataForLocale(this.props.locale);
	    var monthNames = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function (M) {
	      return getMonthShortInLocale(localeData, newDate({ M: M }));
	    } : function (M) {
	      return getMonthInLocale(localeData, newDate({ M: M }), _this2.props.dateFormat);
	    });
	
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode(monthNames);
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode(monthNames);
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return MonthDropdown;
	}(React.Component);
	
	MonthDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  locale: PropTypes.string,
	  dateFormat: PropTypes.string.isRequired,
	  month: PropTypes.number.isRequired,
	  onChange: PropTypes.func.isRequired,
	  useShortMonthInDropdown: PropTypes.bool
	};
	
	function generateMonthYears(minDate, maxDate) {
	  var list = [];
	
	  var currDate = getStartOfMonth(cloneDate(minDate));
	  var lastDate = getStartOfMonth(cloneDate(maxDate));
	
	  while (!isAfter(currDate, lastDate)) {
	    list.push(cloneDate(currDate));
	
	    addMonths(currDate, 1);
	  }
	
	  return list;
	}
	
	var MonthYearDropdownOptions = function (_React$Component) {
	  inherits(MonthYearDropdownOptions, _React$Component);
	
	  function MonthYearDropdownOptions(props) {
	    classCallCheck(this, MonthYearDropdownOptions);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.renderOptions = function () {
	      return _this.state.monthYearsList.map(function (monthYear) {
	        var monthYearPoint = monthYear.valueOf();
	
	        var isSameMonthYear = isSameYear(_this.props.date, monthYear) && isSameMonth(_this.props.date, monthYear);
	
	        return React.createElement(
	          "div",
	          {
	            className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
	            key: monthYearPoint,
	            ref: monthYearPoint,
	            onClick: _this.onChange.bind(_this, monthYearPoint)
	          },
	          isSameMonthYear ? React.createElement(
	            "span",
	            { className: "react-datepicker__month-year-option--selected" },
	            "\u2713"
	          ) : "",
	          formatDate(monthYear, _this.props.dateFormat)
	        );
	      });
	    };
	
	    _this.onChange = function (monthYear) {
	      return _this.props.onChange(monthYear);
	    };
	
	    _this.handleClickOutside = function () {
	      _this.props.onCancel();
	    };
	
	    _this.state = {
	      monthYearsList: generateMonthYears(_this.props.minDate, _this.props.maxDate)
	    };
	    return _this;
	  }
	
	  MonthYearDropdownOptions.prototype.render = function render() {
	    var dropdownClass = classnames({
	      "react-datepicker__month-year-dropdown": true,
	      "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
	    });
	
	    return React.createElement(
	      "div",
	      { className: dropdownClass },
	      this.renderOptions()
	    );
	  };
	
	  return MonthYearDropdownOptions;
	}(React.Component);
	
	MonthYearDropdownOptions.propTypes = {
	  minDate: PropTypes.object.isRequired,
	  maxDate: PropTypes.object.isRequired,
	  onCancel: PropTypes.func.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  date: PropTypes.object.isRequired,
	  dateFormat: PropTypes.string.isRequired
	};
	
	var WrappedMonthYearDropdownOptions = onClickOutside(MonthYearDropdownOptions);
	
	var MonthYearDropdown = function (_React$Component) {
	  inherits(MonthYearDropdown, _React$Component);
	
	  function MonthYearDropdown() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, MonthYearDropdown);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      dropdownVisible: false
	    }, _this.renderSelectOptions = function () {
	      var currDate = getStartOfMonth(localizeDate(_this.props.minDate, _this.props.locale));
	      var lastDate = getStartOfMonth(localizeDate(_this.props.maxDate, _this.props.locale));
	
	      var options = [];
	
	      while (!isAfter(currDate, lastDate)) {
	        var timepoint = currDate.valueOf();
	        options.push(React.createElement(
	          "option",
	          { key: timepoint, value: timepoint },
	          formatDate(currDate, _this.props.dateFormat)
	        ));
	
	        addMonths(currDate, 1);
	      }
	
	      return options;
	    }, _this.onSelectChange = function (e) {
	      _this.onChange(e.target.value);
	    }, _this.renderSelectMode = function () {
	      return React.createElement(
	        "select",
	        {
	          value: getStartOfMonth(_this.props.date).valueOf(),
	          className: "react-datepicker__month-year-select",
	          onChange: _this.onSelectChange
	        },
	        _this.renderSelectOptions()
	      );
	    }, _this.renderReadView = function (visible) {
	      var yearMonth = formatDate(localizeDate(newDate(_this.props.date), _this.props.locale), _this.props.dateFormat);
	
	      return React.createElement(
	        "div",
	        {
	          key: "read",
	          style: { visibility: visible ? "visible" : "hidden" },
	          className: "react-datepicker__month-year-read-view",
	          onClick: function onClick(event) {
	            return _this.toggleDropdown(event);
	          }
	        },
	        React.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
	        React.createElement(
	          "span",
	          { className: "react-datepicker__month-year-read-view--selected-month-year" },
	          yearMonth
	        )
	      );
	    }, _this.renderDropdown = function () {
	      return React.createElement(WrappedMonthYearDropdownOptions, {
	        key: "dropdown",
	        ref: "options",
	        date: _this.props.date,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.onChange,
	        onCancel: _this.toggleDropdown,
	        minDate: localizeDate(_this.props.minDate, _this.props.locale),
	        maxDate: localizeDate(_this.props.maxDate, _this.props.locale),
	        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
	      });
	    }, _this.renderScrollMode = function () {
	      var dropdownVisible = _this.state.dropdownVisible;
	
	      var result = [_this.renderReadView(!dropdownVisible)];
	      if (dropdownVisible) {
	        result.unshift(_this.renderDropdown());
	      }
	      return result;
	    }, _this.onChange = function (monthYearPoint) {
	      _this.toggleDropdown();
	
	      var changedDate = newDate(parseInt(monthYearPoint));
	
	      if (isSameYear(_this.props.date, changedDate) && isSameMonth(_this.props.date, changedDate)) {
	        return;
	      }
	
	      _this.props.onChange(changedDate);
	    }, _this.toggleDropdown = function () {
	      return _this.setState({
	        dropdownVisible: !_this.state.dropdownVisible
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  MonthYearDropdown.prototype.render = function render() {
	    var renderedDropdown = void 0;
	    switch (this.props.dropdownMode) {
	      case "scroll":
	        renderedDropdown = this.renderScrollMode();
	        break;
	      case "select":
	        renderedDropdown = this.renderSelectMode();
	        break;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
	      },
	      renderedDropdown
	    );
	  };
	
	  return MonthYearDropdown;
	}(React.Component);
	
	MonthYearDropdown.propTypes = {
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  dateFormat: PropTypes.string.isRequired,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object.isRequired,
	  minDate: PropTypes.object.isRequired,
	  date: PropTypes.object.isRequired,
	  onChange: PropTypes.func.isRequired,
	  scrollableMonthYearDropdown: PropTypes.bool
	};
	
	var Day = function (_React$Component) {
	  inherits(Day, _React$Component);
	
	  function Day() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Day);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (!_this.isDisabled() && _this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.isDisabled() && _this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.isSameDay = function (other) {
	      return isSameDay(_this.props.day, other);
	    }, _this.isKeyboardSelected = function () {
	      return !_this.props.disabledKeyboardNavigation && !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
	    }, _this.isDisabled = function () {
	      return isDayDisabled(_this.props.day, _this.props);
	    }, _this.getHighLightedClass = function (defaultClassName) {
	      var _this$props = _this.props,
	          day = _this$props.day,
	          highlightDates = _this$props.highlightDates;
	
	
	      if (!highlightDates) {
	        return false;
	      }
	
	      // Looking for className in the Map of {'day string, 'className'}
	      var dayStr = day.format("MM.DD.YYYY");
	      return highlightDates.get(dayStr);
	    }, _this.isInRange = function () {
	      var _this$props2 = _this.props,
	          day = _this$props2.day,
	          startDate = _this$props2.startDate,
	          endDate = _this$props2.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isDayInRange(day, startDate, endDate);
	    }, _this.isInSelectingRange = function () {
	      var _this$props3 = _this.props,
	          day = _this$props3.day,
	          selectsStart = _this$props3.selectsStart,
	          selectsEnd = _this$props3.selectsEnd,
	          selectingDate = _this$props3.selectingDate,
	          startDate = _this$props3.startDate,
	          endDate = _this$props3.endDate;
	
	
	      if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) {
	        return false;
	      }
	
	      if (selectsStart && endDate && selectingDate.isSameOrBefore(endDate)) {
	        return isDayInRange(day, selectingDate, endDate);
	      }
	
	      if (selectsEnd && startDate && selectingDate.isSameOrAfter(startDate)) {
	        return isDayInRange(day, startDate, selectingDate);
	      }
	
	      return false;
	    }, _this.isSelectingRangeStart = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props4 = _this.props,
	          day = _this$props4.day,
	          selectingDate = _this$props4.selectingDate,
	          startDate = _this$props4.startDate,
	          selectsStart = _this$props4.selectsStart;
	
	
	      if (selectsStart) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, startDate);
	      }
	    }, _this.isSelectingRangeEnd = function () {
	      if (!_this.isInSelectingRange()) {
	        return false;
	      }
	
	      var _this$props5 = _this.props,
	          day = _this$props5.day,
	          selectingDate = _this$props5.selectingDate,
	          endDate = _this$props5.endDate,
	          selectsEnd = _this$props5.selectsEnd;
	
	
	      if (selectsEnd) {
	        return isSameDay(day, selectingDate);
	      } else {
	        return isSameDay(day, endDate);
	      }
	    }, _this.isRangeStart = function () {
	      var _this$props6 = _this.props,
	          day = _this$props6.day,
	          startDate = _this$props6.startDate,
	          endDate = _this$props6.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(startDate, day);
	    }, _this.isRangeEnd = function () {
	      var _this$props7 = _this.props,
	          day = _this$props7.day,
	          startDate = _this$props7.startDate,
	          endDate = _this$props7.endDate;
	
	      if (!startDate || !endDate) {
	        return false;
	      }
	      return isSameDay(endDate, day);
	    }, _this.isWeekend = function () {
	      var weekday = getDay(_this.props.day);
	      return weekday === 0 || weekday === 6;
	    }, _this.isOutsideMonth = function () {
	      return _this.props.month !== undefined && _this.props.month !== getMonth(_this.props.day);
	    }, _this.getClassNames = function (date) {
	      var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
	      return classnames("react-datepicker__day", dayClassName, "react-datepicker__day--" + getDayOfWeekCode(_this.props.day), {
	        "react-datepicker__day--disabled": _this.isDisabled(),
	        "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
	        "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
	        "react-datepicker__day--range-start": _this.isRangeStart(),
	        "react-datepicker__day--range-end": _this.isRangeEnd(),
	        "react-datepicker__day--in-range": _this.isInRange(),
	        "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
	        "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
	        "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
	        "react-datepicker__day--today": _this.isSameDay(now(_this.props.utcOffset)),
	        "react-datepicker__day--weekend": _this.isWeekend(),
	        "react-datepicker__day--outside-month": _this.isOutsideMonth()
	      }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Day.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: this.getClassNames(this.props.day),
	        onClick: this.handleClick,
	        onMouseEnter: this.handleMouseEnter,
	        "aria-label": "day-" + getDate(this.props.day),
	        role: "option"
	      },
	      this.props.renderDayContents ? this.props.renderDayContents(getDate(this.props.day)) : getDate(this.props.day)
	    );
	  };
	
	  return Day;
	}(React.Component);
	
	Day.propTypes = {
	  disabledKeyboardNavigation: PropTypes.bool,
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  highlightDates: PropTypes.instanceOf(Map),
	  inline: PropTypes.bool,
	  month: PropTypes.number,
	  onClick: PropTypes.func,
	  onMouseEnter: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  renderDayContents: PropTypes.func
	};
	
	var WeekNumber = function (_React$Component) {
	  inherits(WeekNumber, _React$Component);
	
	  function WeekNumber() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, WeekNumber);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  WeekNumber.prototype.render = function render() {
	    var weekNumberClasses = {
	      "react-datepicker__week-number": true,
	      "react-datepicker__week-number--clickable": !!this.props.onClick
	    };
	    return React.createElement(
	      "div",
	      {
	        className: classnames(weekNumberClasses),
	        "aria-label": "week-" + this.props.weekNumber,
	        onClick: this.handleClick
	      },
	      this.props.weekNumber
	    );
	  };
	
	  return WeekNumber;
	}(React.Component);
	
	WeekNumber.propTypes = {
	  weekNumber: PropTypes.number.isRequired,
	  onClick: PropTypes.func
	};
	
	var Week = function (_React$Component) {
	  inherits(Week, _React$Component);
	
	  function Week() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Week);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleWeekClick = function (day, weekNumber, event) {
	      if (typeof _this.props.onWeekSelect === "function") {
	        _this.props.onWeekSelect(day, weekNumber, event);
	      }
	    }, _this.formatWeekNumber = function (startOfWeek) {
	      if (_this.props.formatWeekNumber) {
	        return _this.props.formatWeekNumber(startOfWeek);
	      }
	      return getWeek(startOfWeek);
	    }, _this.renderDays = function () {
	      var startOfWeek = getStartOfWeek(cloneDate(_this.props.day));
	      var days = [];
	      var weekNumber = _this.formatWeekNumber(startOfWeek);
	      if (_this.props.showWeekNumber) {
	        var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
	        days.push(React.createElement(WeekNumber, { key: "W", weekNumber: weekNumber, onClick: onClickAction }));
	      }
	      return days.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        return React.createElement(Day, {
	          key: offset,
	          day: day,
	          month: _this.props.month,
	          onClick: _this.handleDayClick.bind(_this, day),
	          onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset,
	          renderDayContents: _this.props.renderDayContents,
	          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
	        });
	      }));
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Week.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      { className: "react-datepicker__week" },
	      this.renderDays()
	    );
	  };
	
	  return Week;
	}(React.Component);
	
	Week.propTypes = {
	  disabledKeyboardNavigation: PropTypes.bool,
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  month: PropTypes.number,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumber: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  renderDayContents: PropTypes.func
	};
	
	var FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
	
	var Month = function (_React$Component) {
	  inherits(Month, _React$Component);
	
	  function Month() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Month);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleDayClick = function (day, event) {
	      if (_this.props.onDayClick) {
	        _this.props.onDayClick(day, event);
	      }
	    }, _this.handleDayMouseEnter = function (day) {
	      if (_this.props.onDayMouseEnter) {
	        _this.props.onDayMouseEnter(day);
	      }
	    }, _this.handleMouseLeave = function () {
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave();
	      }
	    }, _this.isWeekInMonth = function (startOfWeek) {
	      var day = _this.props.day;
	      var endOfWeek = addDays(cloneDate(startOfWeek), 6);
	      return isSameMonth(startOfWeek, day) || isSameMonth(endOfWeek, day);
	    }, _this.renderWeeks = function () {
	      var weeks = [];
	      var isFixedHeight = _this.props.fixedHeight;
	      var currentWeekStart = getStartOfWeek(getStartOfMonth(cloneDate(_this.props.day)));
	      var i = 0;
	      var breakAfterNextPush = false;
	
	      while (true) {
	        weeks.push(React.createElement(Week, {
	          key: i,
	          day: currentWeekStart,
	          month: getMonth(_this.props.day),
	          onDayClick: _this.handleDayClick,
	          onDayMouseEnter: _this.handleDayMouseEnter,
	          onWeekSelect: _this.props.onWeekSelect,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          excludeDates: _this.props.excludeDates,
	          includeDates: _this.props.includeDates,
	          inline: _this.props.inline,
	          highlightDates: _this.props.highlightDates,
	          selectingDate: _this.props.selectingDate,
	          filterDate: _this.props.filterDate,
	          preSelection: _this.props.preSelection,
	          selected: _this.props.selected,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          showWeekNumber: _this.props.showWeekNumbers,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          dayClassName: _this.props.dayClassName,
	          utcOffset: _this.props.utcOffset,
	          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
	          renderDayContents: _this.props.renderDayContents
	        }));
	
	        if (breakAfterNextPush) break;
	
	        i++;
	        currentWeekStart = addWeeks(cloneDate(currentWeekStart), 1);
	
	        // If one of these conditions is true, we will either break on this week
	        // or break on the next week
	        var isFixedAndFinalWeek = isFixedHeight && i >= FIXED_HEIGHT_STANDARD_WEEK_COUNT;
	        var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
	
	        if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
	          if (_this.props.peekNextMonth) {
	            breakAfterNextPush = true;
	          } else {
	            break;
	          }
	        }
	      }
	
	      return weeks;
	    }, _this.getClassNames = function () {
	      var _this$props = _this.props,
	          selectingDate = _this$props.selectingDate,
	          selectsStart = _this$props.selectsStart,
	          selectsEnd = _this$props.selectsEnd;
	
	      return classnames("react-datepicker__month", {
	        "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Month.prototype.render = function render() {
	    return React.createElement(
	      "div",
	      {
	        className: this.getClassNames(),
	        onMouseLeave: this.handleMouseLeave,
	        role: "listbox",
	        "aria-label": "month-" + this.props.day.format("YYYY-MM")
	      },
	      this.renderWeeks()
	    );
	  };
	
	  return Month;
	}(React.Component);
	
	Month.propTypes = {
	  disabledKeyboardNavigation: PropTypes.bool,
	  day: PropTypes.object.isRequired,
	  dayClassName: PropTypes.func,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  inline: PropTypes.bool,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  onDayClick: PropTypes.func,
	  onDayMouseEnter: PropTypes.func,
	  onMouseLeave: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  peekNextMonth: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectingDate: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  startDate: PropTypes.object,
	  utcOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  renderDayContents: PropTypes.func
	};
	
	var Time = function (_React$Component) {
	  inherits(Time, _React$Component);
	
	  function Time() {
	    var _temp, _this, _ret;
	
	    classCallCheck(this, Time);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (time) {
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
	        return;
	      }
	
	      _this.props.onChange(time);
	    }, _this.liClasses = function (time, currH, currM) {
	      var classes = ["react-datepicker__time-list-item"];
	
	      if (currH === getHour(time) && currM === getMinute(time)) {
	        classes.push("react-datepicker__time-list-item--selected");
	      }
	      if ((_this.props.minTime || _this.props.maxTime) && isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !isTimeDisabled(time, _this.props.includeTimes)) {
	        classes.push("react-datepicker__time-list-item--disabled");
	      }
	      if (_this.props.injectTimes && (getHour(time) * 60 + getMinute(time)) % _this.props.intervals !== 0) {
	        classes.push("react-datepicker__time-list-item--injected");
	      }
	
	      return classes.join(" ");
	    }, _this.renderTimes = function () {
	      var times = [];
	      var format = _this.props.format ? _this.props.format : "hh:mm A";
	      var intervals = _this.props.intervals;
	      var activeTime = _this.props.selected ? _this.props.selected : newDate();
	      var currH = getHour(activeTime);
	      var currM = getMinute(activeTime);
	      var base = getStartOfDay(newDate());
	      var multiplier = 1440 / intervals;
	      var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function (a, b) {
	        return a - b;
	      });
	      for (var i = 0; i < multiplier; i++) {
	        var currentTime = addMinutes(cloneDate(base), i * intervals);
	        times.push(currentTime);
	
	        if (sortedInjectTimes) {
	          var timesToInject = timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
	          times = times.concat(timesToInject);
	        }
	      }
	
	      return times.map(function (time, i) {
	        return React.createElement(
	          "li",
	          {
	            key: i,
	            onClick: _this.handleClick.bind(_this, time),
	            className: _this.liClasses(time, currH, currM),
	            ref: function ref(li) {
	              if (currH === getHour(time) && currM === getMinute(time) || currH === getHour(time) && !_this.centerLi) {
	                _this.centerLi = li;
	              }
	            }
	          },
	          formatDate(time, format)
	        );
	      });
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }
	
	  Time.prototype.componentDidMount = function componentDidMount() {
	    // code to ensure selected time will always be in focus within time window when it first appears
	    this.list.scrollTop = Time.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi);
	  };
	
	  Time.prototype.render = function render() {
	    var _this2 = this;
	
	    var height = null;
	    if (this.props.monthRef && this.header) {
	      height = this.props.monthRef.clientHeight - this.header.clientHeight;
	    }
	
	    return React.createElement(
	      "div",
	      {
	        className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
	      },
	      React.createElement(
	        "div",
	        {
	          className: "react-datepicker__header react-datepicker__header--time",
	          ref: function ref(header) {
	            _this2.header = header;
	          }
	        },
	        React.createElement(
	          "div",
	          { className: "react-datepicker-time__header" },
	          this.props.timeCaption
	        )
	      ),
	      React.createElement(
	        "div",
	        { className: "react-datepicker__time" },
	        React.createElement(
	          "div",
	          { className: "react-datepicker__time-box" },
	          React.createElement(
	            "ul",
	            {
	              className: "react-datepicker__time-list",
	              ref: function ref(list) {
	                _this2.list = list;
	              },
	              style: height ? { height: height } : {}
	            },
	            this.renderTimes.bind(this)()
	          )
	        )
	      )
	    );
	  };
	
	  createClass(Time, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        intervals: 30,
	        onTimeChange: function onTimeChange() {},
	        todayButton: null,
	        timeCaption: "Time"
	      };
	    }
	  }]);
	  return Time;
	}(React.Component);
	
	Time.propTypes = {
	  format: PropTypes.string,
	  includeTimes: PropTypes.array,
	  intervals: PropTypes.number,
	  selected: PropTypes.object,
	  onChange: PropTypes.func,
	  todayButton: PropTypes.node,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  monthRef: PropTypes.object,
	  timeCaption: PropTypes.string,
	  injectTimes: PropTypes.array
	};
	
	Time.calcCenterPosition = function (listHeight, centerLiRef) {
	  return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
	};
	
	function CalendarContainer(_ref) {
	  var className = _ref.className,
	      children = _ref.children,
	      _ref$arrowProps = _ref.arrowProps,
	      arrowProps = _ref$arrowProps === undefined ? {} : _ref$arrowProps;
	
	  return React.createElement(
	    "div",
	    { className: className },
	    React.createElement("div", _extends({ className: "react-datepicker__triangle" }, arrowProps)),
	    children
	  );
	}
	
	CalendarContainer.propTypes = {
	  className: PropTypes.string,
	  children: PropTypes.node,
	  arrowProps: PropTypes.object // react-popper arrow props
	};
	
	var DROPDOWN_FOCUS_CLASSNAMES = ["react-datepicker__year-select", "react-datepicker__month-select", "react-datepicker__month-year-select"];
	
	var isDropdownSelect = function isDropdownSelect() {
	  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var classNames = (element.className || "").split(/\s+/);
	  return DROPDOWN_FOCUS_CLASSNAMES.some(function (testClassname) {
	    return classNames.indexOf(testClassname) >= 0;
	  });
	};
	
	var Calendar = function (_React$Component) {
	  inherits(Calendar, _React$Component);
	  createClass(Calendar, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        onDropdownFocus: function onDropdownFocus() {},
	        monthsShown: 1,
	        forceShowMonthNavigation: false,
	        timeCaption: "Time",
	        previousMonthButtonLabel: "Previous Month",
	        nextMonthButtonLabel: "Next Month"
	      };
	    }
	  }]);
	
	  function Calendar(props) {
	    classCallCheck(this, Calendar);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleClickOutside = function (event) {
	      _this.props.onClickOutside(event);
	    };
	
	    _this.handleDropdownFocus = function (event) {
	      if (isDropdownSelect(event.target)) {
	        _this.props.onDropdownFocus();
	      }
	    };
	
	    _this.getDateInView = function () {
	      var _this$props = _this.props,
	          preSelection = _this$props.preSelection,
	          selected = _this$props.selected,
	          openToDate = _this$props.openToDate,
	          utcOffset = _this$props.utcOffset;
	
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var current = now(utcOffset);
	      var initialDate = openToDate || selected || preSelection;
	      if (initialDate) {
	        return initialDate;
	      } else {
	        if (minDate && isBefore(current, minDate)) {
	          return minDate;
	        } else if (maxDate && isAfter(current, maxDate)) {
	          return maxDate;
	        }
	      }
	      return current;
	    };
	
	    _this.localizeDate = function (date) {
	      return localizeDate(date, _this.props.locale);
	    };
	
	    _this.increaseMonth = function () {
	      _this.setState({
	        date: addMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.decreaseMonth = function () {
	      _this.setState({
	        date: subtractMonths(cloneDate(_this.state.date), 1)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.handleDayClick = function (day, event) {
	      return _this.props.onSelect(day, event);
	    };
	
	    _this.handleDayMouseEnter = function (day) {
	      return _this.setState({ selectingDate: day });
	    };
	
	    _this.handleMonthMouseLeave = function () {
	      return _this.setState({ selectingDate: null });
	    };
	
	    _this.handleYearChange = function (date) {
	      if (_this.props.onYearChange) {
	        _this.props.onYearChange(date);
	      }
	    };
	
	    _this.handleMonthChange = function (date) {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(date);
	      }
	      if (_this.props.adjustDateOnChange) {
	        if (_this.props.onSelect) {
	          _this.props.onSelect(date);
	        }
	        if (_this.props.setOpen) {
	          _this.props.setOpen(true);
	        }
	      }
	    };
	
	    _this.handleMonthYearChange = function (date) {
	      _this.handleYearChange(date);
	      _this.handleMonthChange(date);
	    };
	
	    _this.changeYear = function (year) {
	      _this.setState({
	        date: setYear(cloneDate(_this.state.date), year)
	      }, function () {
	        return _this.handleYearChange(_this.state.date);
	      });
	    };
	
	    _this.changeMonth = function (month) {
	      _this.setState({
	        date: setMonth(cloneDate(_this.state.date), month)
	      }, function () {
	        return _this.handleMonthChange(_this.state.date);
	      });
	    };
	
	    _this.changeMonthYear = function (monthYear) {
	      _this.setState({
	        date: setYear(setMonth(cloneDate(_this.state.date), getMonth(monthYear)), getYear(monthYear))
	      }, function () {
	        return _this.handleMonthYearChange(_this.state.date);
	      });
	    };
	
	    _this.header = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var startOfWeek = getStartOfWeek(cloneDate(date));
	      var dayNames = [];
	      if (_this.props.showWeekNumbers) {
	        dayNames.push(React.createElement(
	          "div",
	          { key: "W", className: "react-datepicker__day-name" },
	          _this.props.weekLabel || "#"
	        ));
	      }
	      return dayNames.concat([0, 1, 2, 3, 4, 5, 6].map(function (offset) {
	        var day = addDays(cloneDate(startOfWeek), offset);
	        var localeData = getLocaleData(day);
	        var weekDayName = _this.formatWeekday(localeData, day);
	
	        return React.createElement(
	          "div",
	          { key: offset, className: "react-datepicker__day-name" },
	          weekDayName
	        );
	      }));
	    };
	
	    _this.formatWeekday = function (localeData, day) {
	      if (_this.props.formatWeekDay) {
	        return getFormattedWeekdayInLocale(localeData, day, _this.props.formatWeekDay);
	      }
	      return _this.props.useWeekdaysShort ? getWeekdayShortInLocale(localeData, day) : getWeekdayMinInLocale(localeData, day);
	    };
	
	    _this.renderPreviousMonthButton = function () {
	      if (_this.props.renderCustomHeader) {
	        return;
	      }
	
	      var allPrevDaysDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);
	
	      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--previous"];
	
	      var clickHandler = _this.decreaseMonth;
	
	      if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
	        classes.push("react-datepicker__navigation--previous--disabled");
	        clickHandler = null;
	      }
	
	      return React.createElement(
	        "button",
	        {
	          type: "button",
	          className: classes.join(" "),
	          onClick: clickHandler
	        },
	        _this.props.previousMonthButtonLabel
	      );
	    };
	
	    _this.renderNextMonthButton = function () {
	      if (_this.props.renderCustomHeader) {
	        return;
	      }
	
	      var allNextDaysDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);
	
	      if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var classes = ["react-datepicker__navigation", "react-datepicker__navigation--next"];
	      if (_this.props.showTimeSelect) {
	        classes.push("react-datepicker__navigation--next--with-time");
	      }
	      if (_this.props.todayButton) {
	        classes.push("react-datepicker__navigation--next--with-today-button");
	      }
	
	      var clickHandler = _this.increaseMonth;
	
	      if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
	        classes.push("react-datepicker__navigation--next--disabled");
	        clickHandler = null;
	      }
	
	      return React.createElement(
	        "button",
	        {
	          type: "button",
	          className: classes.join(" "),
	          onClick: clickHandler
	        },
	        _this.props.nextMonthButtonLabel
	      );
	    };
	
	    _this.renderCurrentMonth = function () {
	      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
	
	      var classes = ["react-datepicker__current-month"];
	
	      if (_this.props.showYearDropdown) {
	        classes.push("react-datepicker__current-month--hasYearDropdown");
	      }
	      if (_this.props.showMonthDropdown) {
	        classes.push("react-datepicker__current-month--hasMonthDropdown");
	      }
	      if (_this.props.showMonthYearDropdown) {
	        classes.push("react-datepicker__current-month--hasMonthYearDropdown");
	      }
	      return React.createElement(
	        "div",
	        { className: classes.join(" ") },
	        formatDate(date, _this.props.dateFormat)
	      );
	    };
	
	    _this.renderYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(YearDropdown, {
	        adjustDateOnChange: _this.props.adjustDateOnChange,
	        date: _this.state.date,
	        onSelect: _this.props.onSelect,
	        setOpen: _this.props.setOpen,
	        dropdownMode: _this.props.dropdownMode,
	        onChange: _this.changeYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        year: getYear(_this.state.date),
	        scrollableYearDropdown: _this.props.scrollableYearDropdown,
	        yearDropdownItemNumber: _this.props.yearDropdownItemNumber
	      });
	    };
	
	    _this.renderMonthDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showMonthDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(MonthDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonth,
	        month: getMonth(_this.state.date),
	        useShortMonthInDropdown: _this.props.useShortMonthInDropdown
	      });
	    };
	
	    _this.renderMonthYearDropdown = function () {
	      var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      if (!_this.props.showMonthYearDropdown || overrideHide) {
	        return;
	      }
	      return React.createElement(MonthYearDropdown, {
	        dropdownMode: _this.props.dropdownMode,
	        locale: _this.props.locale,
	        dateFormat: _this.props.dateFormat,
	        onChange: _this.changeMonthYear,
	        minDate: _this.props.minDate,
	        maxDate: _this.props.maxDate,
	        date: _this.state.date,
	        scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
	      });
	    };
	
	    _this.renderTodayButton = function () {
	      if (!_this.props.todayButton || _this.props.showTimeSelectOnly) {
	        return;
	      }
	      return React.createElement(
	        "div",
	        {
	          className: "react-datepicker__today-button",
	          onClick: function onClick(e) {
	            return _this.props.onSelect(getStartOfDate(now(_this.props.utcOffset)), e);
	          }
	        },
	        _this.props.todayButton
	      );
	    };
	
	    _this.renderDefaultHeader = function (_ref) {
	      var monthDate = _ref.monthDate,
	          i = _ref.i;
	      return React.createElement(
	        "div",
	        { className: "react-datepicker__header" },
	        _this.renderCurrentMonth(monthDate),
	        React.createElement(
	          "div",
	          {
	            className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
	            onFocus: _this.handleDropdownFocus
	          },
	          _this.renderMonthDropdown(i !== 0),
	          _this.renderMonthYearDropdown(i !== 0),
	          _this.renderYearDropdown(i !== 0)
	        ),
	        React.createElement(
	          "div",
	          { className: "react-datepicker__day-names" },
	          _this.header(monthDate)
	        )
	      );
	    };
	
	    _this.renderCustomHeader = function (_ref2) {
	      var monthDate = _ref2.monthDate,
	          i = _ref2.i;
	
	      if (i !== 0) {
	        return null;
	      }
	
	      var prevMonthButtonDisabled = allDaysDisabledBefore(_this.state.date, "month", _this.props);
	
	      var nextMonthButtonDisabled = allDaysDisabledAfter(_this.state.date, "month", _this.props);
	
	      return React.createElement(
	        "div",
	        {
	          className: "react-datepicker__header react-datepicker__header--custom",
	          onFocus: _this.props.onDropdownFocus
	        },
	        _this.props.renderCustomHeader(_extends({}, _this.state, {
	          changeMonth: _this.changeMonth,
	          changeYear: _this.changeYear,
	          decreaseMonth: _this.decreaseMonth,
	          increaseMonth: _this.increaseMonth,
	          prevMonthButtonDisabled: prevMonthButtonDisabled,
	          nextMonthButtonDisabled: nextMonthButtonDisabled
	        })),
	        React.createElement(
	          "div",
	          { className: "react-datepicker__day-names" },
	          _this.header(monthDate)
	        )
	      );
	    };
	
	    _this.renderMonths = function () {
	      if (_this.props.showTimeSelectOnly) {
	        return;
	      }
	
	      var monthList = [];
	      for (var i = 0; i < _this.props.monthsShown; ++i) {
	        var monthDate = addMonths(cloneDate(_this.state.date), i);
	        var monthKey = "month-" + i;
	        monthList.push(React.createElement(
	          "div",
	          {
	            key: monthKey,
	            ref: function ref(div) {
	              _this.monthContainer = div;
	            },
	            className: "react-datepicker__month-container"
	          },
	          _this.props.renderCustomHeader ? _this.renderCustomHeader({ monthDate: monthDate, i: i }) : _this.renderDefaultHeader({ monthDate: monthDate, i: i }),
	          React.createElement(Month, {
	            day: monthDate,
	            dayClassName: _this.props.dayClassName,
	            onDayClick: _this.handleDayClick,
	            onDayMouseEnter: _this.handleDayMouseEnter,
	            onMouseLeave: _this.handleMonthMouseLeave,
	            onWeekSelect: _this.props.onWeekSelect,
	            formatWeekNumber: _this.props.formatWeekNumber,
	            minDate: _this.props.minDate,
	            maxDate: _this.props.maxDate,
	            excludeDates: _this.props.excludeDates,
	            highlightDates: _this.props.highlightDates,
	            selectingDate: _this.state.selectingDate,
	            includeDates: _this.props.includeDates,
	            inline: _this.props.inline,
	            fixedHeight: _this.props.fixedHeight,
	            filterDate: _this.props.filterDate,
	            preSelection: _this.props.preSelection,
	            selected: _this.props.selected,
	            selectsStart: _this.props.selectsStart,
	            selectsEnd: _this.props.selectsEnd,
	            showWeekNumbers: _this.props.showWeekNumbers,
	            startDate: _this.props.startDate,
	            endDate: _this.props.endDate,
	            peekNextMonth: _this.props.peekNextMonth,
	            utcOffset: _this.props.utcOffset,
	            renderDayContents: _this.props.renderDayContents,
	            disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
	          })
	        ));
	      }
	      return monthList;
	    };
	
	    _this.renderTimeSection = function () {
	      if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) {
	        return React.createElement(Time, {
	          selected: _this.props.selected,
	          onChange: _this.props.onTimeChange,
	          format: _this.props.timeFormat,
	          includeTimes: _this.props.includeTimes,
	          intervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          timeCaption: _this.props.timeCaption,
	          todayButton: _this.props.todayButton,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          showMonthYearDropdown: _this.props.showMonthYearDropdown,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          monthRef: _this.state.monthContainer,
	          injectTimes: _this.props.injectTimes
	        });
	      }
	    };
	
	    _this.state = {
	      date: _this.localizeDate(_this.getDateInView()),
	      selectingDate: null,
	      monthContainer: null
	    };
	    return _this;
	  }
	
	  Calendar.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    // monthContainer height is needed in time component
	    // to determine the height for the ul in the time component
	    // setState here so height is given after final component
	    // layout is rendered
	    if (this.props.showTimeSelect) {
	      this.assignMonthContainer = function () {
	        _this2.setState({ monthContainer: _this2.monthContainer });
	      }();
	    }
	  };
	
	  Calendar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.preSelection && !isSameDay(this.props.preSelection, prevProps.preSelection)) {
	      this.setState({
	        date: this.localizeDate(this.props.preSelection)
	      });
	    } else if (this.props.openToDate && !isSameDay(this.props.openToDate, prevProps.openToDate)) {
	      this.setState({
	        date: this.localizeDate(this.props.openToDate)
	      });
	    }
	  };
	
	  Calendar.prototype.render = function render() {
	    var Container = this.props.container || CalendarContainer;
	
	    return React.createElement(
	      Container,
	      {
	        className: classnames("react-datepicker", this.props.className, {
	          "react-datepicker--time-only": this.props.showTimeSelectOnly
	        })
	      },
	      this.renderPreviousMonthButton(),
	      this.renderNextMonthButton(),
	      this.renderMonths(),
	      this.renderTodayButton(),
	      this.renderTimeSection(),
	      this.props.children
	    );
	  };
	
	  return Calendar;
	}(React.Component);
	
	Calendar.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  className: PropTypes.string,
	  children: PropTypes.node,
	  container: PropTypes.func,
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
	  dayClassName: PropTypes.func,
	  disabledKeyboardNavigation: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]),
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.instanceOf(Map),
	  includeDates: PropTypes.array,
	  includeTimes: PropTypes.array,
	  injectTimes: PropTypes.array,
	  inline: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  onClickOutside: PropTypes.func.isRequired,
	  onMonthChange: PropTypes.func,
	  onYearChange: PropTypes.func,
	  forceShowMonthNavigation: PropTypes.bool,
	  onDropdownFocus: PropTypes.func,
	  onSelect: PropTypes.func.isRequired,
	  onWeekSelect: PropTypes.func,
	  showTimeSelect: PropTypes.bool,
	  showTimeSelectOnly: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  onTimeChange: PropTypes.func,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  timeCaption: PropTypes.string,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  preSelection: PropTypes.object,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showMonthYearDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  startDate: PropTypes.object,
	  todayButton: PropTypes.node,
	  useWeekdaysShort: PropTypes.bool,
	  formatWeekDay: PropTypes.func,
	  withPortal: PropTypes.bool,
	  utcOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  weekLabel: PropTypes.string,
	  yearDropdownItemNumber: PropTypes.number,
	  setOpen: PropTypes.func,
	  useShortMonthInDropdown: PropTypes.bool,
	  showDisabledMonthNavigation: PropTypes.bool,
	  previousMonthButtonLabel: PropTypes.string,
	  nextMonthButtonLabel: PropTypes.string,
	  renderCustomHeader: PropTypes.func,
	  renderDayContents: PropTypes.func
	};
	
	var popperPlacementPositions = ["bottom", "bottom-end", "bottom-start", "left", "left-end", "left-start", "right", "right-end", "right-start", "top", "top-end", "top-start"];
	
	var PopperComponent = function (_React$Component) {
	  inherits(PopperComponent, _React$Component);
	
	  function PopperComponent() {
	    classCallCheck(this, PopperComponent);
	    return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  PopperComponent.prototype.render = function render() {
	    var _props = this.props,
	        className = _props.className,
	        hidePopper = _props.hidePopper,
	        popperComponent = _props.popperComponent,
	        popperModifiers = _props.popperModifiers,
	        popperPlacement = _props.popperPlacement,
	        popperProps = _props.popperProps,
	        targetComponent = _props.targetComponent;
	
	
	    var popper = void 0;
	
	    if (!hidePopper) {
	      var classes = classnames("react-datepicker-popper", className);
	      popper = React.createElement(
	        reactPopper.Popper,
	        _extends({
	          modifiers: popperModifiers,
	          placement: popperPlacement
	        }, popperProps),
	        function (_ref) {
	          var ref = _ref.ref,
	              style = _ref.style,
	              placement = _ref.placement,
	              arrowProps = _ref.arrowProps;
	          return React.createElement(
	            "div",
	            _extends({ ref: ref, style: style }, {
	              className: classes,
	              "data-placement": placement
	            }),
	            React.cloneElement(popperComponent, { arrowProps: arrowProps })
	          );
	        }
	      );
	    }
	
	    if (this.props.popperContainer) {
	      popper = React.createElement(this.props.popperContainer, {}, popper);
	    }
	
	    return React.createElement(
	      reactPopper.Manager,
	      null,
	      React.createElement(
	        reactPopper.Reference,
	        null,
	        function (_ref2) {
	          var ref = _ref2.ref;
	          return React.createElement(
	            "div",
	            { ref: ref, className: "react-datepicker-wrapper" },
	            targetComponent
	          );
	        }
	      ),
	      popper
	    );
	  };
	
	  createClass(PopperComponent, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        hidePopper: true,
	        popperModifiers: {
	          preventOverflow: {
	            enabled: true,
	            escapeWithReference: true,
	            boundariesElement: "viewport"
	          }
	        },
	        popperProps: {},
	        popperPlacement: "bottom-start"
	      };
	    }
	  }]);
	  return PopperComponent;
	}(React.Component);
	
	PopperComponent.propTypes = {
	  className: PropTypes.string,
	  hidePopper: PropTypes.bool,
	  popperComponent: PropTypes.element,
	  popperModifiers: PropTypes.object, // <datepicker/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <datepicker/> props
	  popperContainer: PropTypes.func,
	  popperProps: PropTypes.object,
	  targetComponent: PropTypes.element
	};
	
	var outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
	var WrappedCalendar = onClickOutside(Calendar);
	
	// Compares dates year+month combinations
	function hasPreSelectionChanged(date1, date2) {
	  if (date1 && date2) {
	    return getMonth(date1) !== getMonth(date2) || getYear(date1) !== getYear(date2);
	  }
	
	  return date1 !== date2;
	}
	
	function hasSelectionChanged(date1, date2) {
	  if (date1 && date2) {
	    return !equals(date1, date2);
	  }
	
	  return false;
	}
	
	/**
	 * General datepicker component.
	 */
	var INPUT_ERR_1 = "Date input not valid.";
	
	var DatePicker = function (_React$Component) {
	  inherits(DatePicker, _React$Component);
	  createClass(DatePicker, null, [{
	    key: "defaultProps",
	    get: function get$$1() {
	      return {
	        allowSameDay: false,
	        dateFormat: "L",
	        dateFormatCalendar: "MMMM YYYY",
	        onChange: function onChange() {},
	
	        disabled: false,
	        disabledKeyboardNavigation: false,
	        dropdownMode: "scroll",
	        onFocus: function onFocus() {},
	        onBlur: function onBlur() {},
	        onKeyDown: function onKeyDown() {},
	        onInputClick: function onInputClick() {},
	        onSelect: function onSelect() {},
	        onClickOutside: function onClickOutside$$1() {},
	        onMonthChange: function onMonthChange() {},
	
	        preventOpenOnFocus: false,
	        onYearChange: function onYearChange() {},
	        onInputError: function onInputError() {},
	
	        monthsShown: 1,
	        readOnly: false,
	        withPortal: false,
	        shouldCloseOnSelect: true,
	        showTimeSelect: false,
	        timeIntervals: 30,
	        timeCaption: "Time",
	        previousMonthButtonLabel: "Previous Month",
	        nextMonthButtonLabel: "Next month",
	        renderDayContents: function renderDayContents(date) {
	          return date;
	        }
	      };
	    }
	  }]);
	
	  function DatePicker(props) {
	    classCallCheck(this, DatePicker);
	
	    var _this = possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.getPreSelection = function () {
	      return _this.props.openToDate ? newDate(_this.props.openToDate) : _this.props.selectsEnd && _this.props.startDate ? newDate(_this.props.startDate) : _this.props.selectsStart && _this.props.endDate ? newDate(_this.props.endDate) : now(_this.props.utcOffset);
	    };
	
	    _this.calcInitialState = function () {
	      var defaultPreSelection = _this.getPreSelection();
	      var minDate = getEffectiveMinDate(_this.props);
	      var maxDate = getEffectiveMaxDate(_this.props);
	      var boundedPreSelection = minDate && isBefore(defaultPreSelection, minDate) ? minDate : maxDate && isAfter(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
	      return {
	        open: _this.props.startOpen || false,
	        preventFocus: false,
	        preSelection: _this.props.selected ? newDate(_this.props.selected) : boundedPreSelection,
	        // transforming highlighted days (perhaps nested array)
	        // to flat Map for faster access in day.jsx
	        highlightDates: getHightLightDaysMap(_this.props.highlightDates),
	        focused: false
	      };
	    };
	
	    _this.clearPreventFocusTimeout = function () {
	      if (_this.preventFocusTimeout) {
	        clearTimeout(_this.preventFocusTimeout);
	      }
	    };
	
	    _this.setFocus = function () {
	      if (_this.input && _this.input.focus) {
	        _this.input.focus();
	      }
	    };
	
	    _this.setBlur = function () {
	      if (_this.input && _this.input.blur) {
	        _this.input.blur();
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur();
	      }
	
	      _this.cancelFocusInput();
	    };
	
	    _this.setOpen = function (open) {
	      var skipSetBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      _this.setState({
	        open: open,
	        preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
	        lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE
	      }, function () {
	        if (!open) {
	          _this.setState(function (prev) {
	            return {
	              focused: skipSetBlur ? prev.focused : false
	            };
	          }, function () {
	            !skipSetBlur && _this.setBlur();
	
	            _this.setState({ inputValue: null });
	          });
	        }
	      });
	    };
	
	    _this.inputOk = function () {
	      return isMoment(_this.state.preSelection) || isDate(_this.state.preSelection);
	    };
	
	    _this.isCalendarOpen = function () {
	      return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
	    };
	
	    _this.handleFocus = function (event) {
	      if (!_this.state.preventFocus) {
	        _this.props.onFocus(event);
	        if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) {
	          _this.setOpen(true);
	        }
	      }
	      _this.setState({ focused: true });
	    };
	
	    _this.cancelFocusInput = function () {
	      clearTimeout(_this.inputFocusTimeout);
	      _this.inputFocusTimeout = null;
	    };
	
	    _this.deferFocusInput = function () {
	      _this.cancelFocusInput();
	      _this.inputFocusTimeout = setTimeout(function () {
	        return _this.setFocus();
	      }, 1);
	    };
	
	    _this.handleDropdownFocus = function () {
	      _this.cancelFocusInput();
	    };
	
	    _this.handleBlur = function (event) {
	      if (_this.state.open && !_this.props.withPortal) {
	        _this.deferFocusInput();
	      } else {
	        _this.props.onBlur(event);
	      }
	      _this.setState({ focused: false });
	    };
	
	    _this.handleCalendarClickOutside = function (event) {
	      if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	      _this.props.onClickOutside(event);
	      if (_this.props.withPortal) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleChange = function () {
	      for (var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++) {
	        allArgs[_key] = arguments[_key];
	      }
	
	      var event = allArgs[0];
	      if (_this.props.onChangeRaw) {
	        _this.props.onChangeRaw.apply(_this, allArgs);
	        if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) {
	          return;
	        }
	      }
	      _this.setState({
	        inputValue: event.target.value,
	        lastPreSelectChange: PRESELECT_CHANGE_VIA_INPUT
	      });
	      var date = parseDate(event.target.value, _this.props);
	      if (date || !event.target.value) {
	        _this.setSelected(date, event, true);
	      }
	    };
	
	    _this.handleSelect = function (date, event) {
	      // Preventing onFocus event to fix issue
	      // https://github.com/Hacker0x01/react-datepicker/issues/628
	      _this.setState({ preventFocus: true }, function () {
	        _this.preventFocusTimeout = setTimeout(function () {
	          return _this.setState({ preventFocus: false });
	        }, 50);
	        return _this.preventFocusTimeout;
	      });
	      _this.setSelected(date, event);
	      if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) {
	        _this.setPreSelection(date);
	      } else if (!_this.props.inline) {
	        _this.setOpen(false);
	      }
	    };
	
	    _this.setSelected = function (date, event, keepInput) {
	      var changedDate = date;
	
	      if (changedDate !== null && isDayDisabled(changedDate, _this.props)) {
	        if (isOutOfBounds(changedDate, _this.props)) {
	          _this.props.onChange(date, event);
	          _this.props.onSelect(changedDate, event);
	        }
	
	        return;
	      }
	
	      if (!isSameDay(_this.props.selected, changedDate) || _this.props.allowSameDay) {
	        if (changedDate !== null) {
	          if (_this.props.selected) {
	            var selected = _this.props.selected;
	            if (keepInput) selected = newDate(changedDate);
	            changedDate = setTime(newDate(changedDate), {
	              hour: getHour(selected),
	              minute: getMinute(selected),
	              second: getSecond(selected)
	            });
	          }
	          if (!_this.props.inline) {
	            _this.setState({
	              preSelection: changedDate
	            });
	          }
	        }
	        _this.props.onChange(changedDate, event);
	      }
	
	      _this.props.onSelect(changedDate, event);
	
	      if (!keepInput) {
	        _this.setState({ inputValue: null });
	      }
	    };
	
	    _this.setPreSelection = function (date) {
	      var isDateRangePresent = typeof _this.props.minDate !== "undefined" && typeof _this.props.maxDate !== "undefined";
	      var isValidDateSelection = isDateRangePresent && date ? isDayInRange(date, _this.props.minDate, _this.props.maxDate) : true;
	      if (isValidDateSelection) {
	        _this.setState({
	          preSelection: date
	        });
	      }
	    };
	
	    _this.handleTimeChange = function (time) {
	      var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
	      var changedDate = setTime(cloneDate(selected), {
	        hour: getHour(time),
	        minute: getMinute(time)
	      });
	
	      _this.setState({
	        preSelection: changedDate
	      });
	
	      _this.props.onChange(changedDate);
	      if (_this.props.shouldCloseOnSelect) {
	        _this.setOpen(false);
	      }
	      _this.setState({ inputValue: null });
	    };
	
	    _this.onInputClick = function () {
	      if (!_this.props.disabled && !_this.props.readOnly) {
	        _this.setOpen(true);
	      }
	
	      _this.props.onInputClick();
	    };
	
	    _this.onInputKeyDown = function (event) {
	      _this.props.onKeyDown(event);
	      var eventKey = event.key;
	      if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
	        if (eventKey === "ArrowDown" || eventKey === "ArrowUp") {
	          _this.onInputClick();
	        }
	        return;
	      }
	      var copy = newDate(_this.state.preSelection);
	      if (eventKey === "Enter") {
	        event.preventDefault();
	        if (_this.inputOk() && _this.state.lastPreSelectChange === PRESELECT_CHANGE_VIA_NAVIGATE) {
	          _this.handleSelect(copy, event);
	          !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
	        } else {
	          _this.setOpen(false);
	        }
	      } else if (eventKey === "Escape") {
	        event.preventDefault();
	
	        _this.setOpen(false);
	        if (!_this.inputOk()) {
	          _this.props.onInputError({ code: 1, msg: INPUT_ERR_1 });
	        }
	      } else if (eventKey === "Tab") {
	        _this.setOpen(false, true);
	      } else if (!_this.props.disabledKeyboardNavigation) {
	        var newSelection = void 0;
	        switch (eventKey) {
	          case "ArrowLeft":
	            newSelection = subtractDays(copy, 1);
	            break;
	          case "ArrowRight":
	            newSelection = addDays(copy, 1);
	            break;
	          case "ArrowUp":
	            newSelection = subtractWeeks(copy, 1);
	            break;
	          case "ArrowDown":
	            newSelection = addWeeks(copy, 1);
	            break;
	          case "PageUp":
	            newSelection = subtractMonths(copy, 1);
	            break;
	          case "PageDown":
	            newSelection = addMonths(copy, 1);
	            break;
	          case "Home":
	            newSelection = subtractYears(copy, 1);
	            break;
	          case "End":
	            newSelection = addYears(copy, 1);
	            break;
	        }
	        if (!newSelection) {
	          if (_this.props.onInputError) {
	            _this.props.onInputError({ code: 1, msg: INPUT_ERR_1 });
	          }
	          return; // Let the input component handle this keydown
	        }
	        event.preventDefault();
	        _this.setState({ lastPreSelectChange: PRESELECT_CHANGE_VIA_NAVIGATE });
	        if (_this.props.adjustDateOnChange) {
	          _this.setSelected(newSelection);
	        }
	        _this.setPreSelection(newSelection);
	      }
	    };
	
	    _this.onClearClick = function (event) {
	      if (event) {
	        if (event.preventDefault) {
	          event.preventDefault();
	        }
	      }
	      _this.props.onChange(null, event);
	      _this.setState({ inputValue: null });
	    };
	
	    _this.clear = function () {
	      _this.onClearClick();
	    };
	
	    _this.renderCalendar = function () {
	      if (!_this.props.inline && !_this.isCalendarOpen()) {
	        return null;
	      }
	      return React.createElement(
	        WrappedCalendar,
	        {
	          ref: function ref(elem) {
	            _this.calendar = elem;
	          },
	          locale: _this.props.locale,
	          adjustDateOnChange: _this.props.adjustDateOnChange,
	          setOpen: _this.setOpen,
	          dateFormat: _this.props.dateFormatCalendar,
	          useWeekdaysShort: _this.props.useWeekdaysShort,
	          formatWeekDay: _this.props.formatWeekDay,
	          dropdownMode: _this.props.dropdownMode,
	          selected: _this.props.selected,
	          preSelection: _this.state.preSelection,
	          onSelect: _this.handleSelect,
	          onWeekSelect: _this.props.onWeekSelect,
	          openToDate: _this.props.openToDate,
	          minDate: _this.props.minDate,
	          maxDate: _this.props.maxDate,
	          selectsStart: _this.props.selectsStart,
	          selectsEnd: _this.props.selectsEnd,
	          startDate: _this.props.startDate,
	          endDate: _this.props.endDate,
	          excludeDates: _this.props.excludeDates,
	          filterDate: _this.props.filterDate,
	          onClickOutside: _this.handleCalendarClickOutside,
	          formatWeekNumber: _this.props.formatWeekNumber,
	          highlightDates: _this.state.highlightDates,
	          includeDates: _this.props.includeDates,
	          includeTimes: _this.props.includeTimes,
	          injectTimes: _this.props.injectTimes,
	          inline: _this.props.inline,
	          peekNextMonth: _this.props.peekNextMonth,
	          showMonthDropdown: _this.props.showMonthDropdown,
	          useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
	          showMonthYearDropdown: _this.props.showMonthYearDropdown,
	          showWeekNumbers: _this.props.showWeekNumbers,
	          showYearDropdown: _this.props.showYearDropdown,
	          withPortal: _this.props.withPortal,
	          forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
	          showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
	          scrollableYearDropdown: _this.props.scrollableYearDropdown,
	          scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
	          todayButton: _this.props.todayButton,
	          weekLabel: _this.props.weekLabel,
	          utcOffset: _this.props.utcOffset,
	          outsideClickIgnoreClass: outsideClickIgnoreClass,
	          fixedHeight: _this.props.fixedHeight,
	          monthsShown: _this.props.monthsShown,
	          onDropdownFocus: _this.handleDropdownFocus,
	          onMonthChange: _this.props.onMonthChange,
	          onYearChange: _this.props.onYearChange,
	          dayClassName: _this.props.dayClassName,
	          showTimeSelect: _this.props.showTimeSelect,
	          showTimeSelectOnly: _this.props.showTimeSelectOnly,
	          onTimeChange: _this.handleTimeChange,
	          timeFormat: _this.props.timeFormat,
	          timeIntervals: _this.props.timeIntervals,
	          minTime: _this.props.minTime,
	          maxTime: _this.props.maxTime,
	          excludeTimes: _this.props.excludeTimes,
	          timeCaption: _this.props.timeCaption,
	          className: _this.props.calendarClassName,
	          container: _this.props.calendarContainer,
	          yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
	          previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
	          nextMonthButtonLabel: _this.props.nextMonthButtonLabel,
	          disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
	          renderCustomHeader: _this.props.renderCustomHeader,
	          popperProps: _this.props.popperProps,
	          renderDayContents: _this.props.renderDayContents
	        },
	        _this.props.children
	      );
	    };
	
	    _this.renderDateInput = function () {
	      var _classnames, _React$cloneElement;
	
	      var className = classnames(_this.props.className, (_classnames = {}, _classnames[outsideClickIgnoreClass] = _this.state.open, _classnames));
	
	      var customInput = _this.props.customInput || React.createElement("input", { type: "text" });
	      var customInputRef = _this.props.customInputRef || "ref";
	      var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : safeDateFormat(_this.props.selected, _this.props);
	
	      return React.cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function (input) {
	        _this.input = input;
	      }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
	    };
	
	    _this.renderClearButton = function () {
	      if (_this.props.isClearable && _this.props.selected != null) {
	        return React.createElement("button", {
	          type: "button",
	          className: "react-datepicker__close-icon",
	          onClick: _this.onClearClick,
	          title: _this.props.clearButtonTitle,
	          tabIndex: -1
	        });
	      } else {
	        return null;
	      }
	    };
	
	    _this.state = _this.calcInitialState();
	    return _this;
	  }
	
	  DatePicker.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (prevProps.inline && hasPreSelectionChanged(prevProps.selected, this.props.selected)) {
	      this.setPreSelection(this.props.selected);
	    }
	    if (prevProps.highlightDates !== this.props.highlightDates) {
	      this.setState({
	        highlightDates: getHightLightDaysMap(this.props.highlightDates)
	      });
	    }
	    if (!prevState.focused && hasSelectionChanged(prevProps.selected, this.props.selected)) {
	      this.setState({ inputValue: null });
	    }
	  };
	
	  DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearPreventFocusTimeout();
	  };
	
	  DatePicker.prototype.render = function render() {
	    var calendar = this.renderCalendar();
	
	    if (this.props.inline && !this.props.withPortal) {
	      return calendar;
	    }
	
	    if (this.props.withPortal) {
	      return React.createElement(
	        "div",
	        null,
	        !this.props.inline ? React.createElement(
	          "div",
	          { className: "react-datepicker__input-container" },
	          this.renderDateInput(),
	          this.renderClearButton()
	        ) : null,
	        this.state.open || this.props.inline ? React.createElement(
	          "div",
	          { className: "react-datepicker__portal" },
	          calendar
	        ) : null
	      );
	    }
	
	    return React.createElement(PopperComponent, {
	      className: this.props.popperClassName,
	      hidePopper: !this.isCalendarOpen(),
	      popperModifiers: this.props.popperModifiers,
	      targetComponent: React.createElement(
	        "div",
	        { className: "react-datepicker__input-container" },
	        this.renderDateInput(),
	        this.renderClearButton()
	      ),
	      popperContainer: this.props.popperContainer,
	      popperComponent: calendar,
	      popperPlacement: this.props.popperPlacement,
	      popperProps: this.props.popperProps
	    });
	  };
	
	  return DatePicker;
	}(React.Component);
	
	DatePicker.propTypes = {
	  adjustDateOnChange: PropTypes.bool,
	  allowSameDay: PropTypes.bool,
	  autoComplete: PropTypes.string,
	  autoFocus: PropTypes.bool,
	  calendarClassName: PropTypes.string,
	  calendarContainer: PropTypes.func,
	  children: PropTypes.node,
	  className: PropTypes.string,
	  customInput: PropTypes.element,
	  customInputRef: PropTypes.string,
	  // eslint-disable-next-line react/no-unused-prop-types
	  dateFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
	  dateFormatCalendar: PropTypes.string,
	  dayClassName: PropTypes.func,
	  disabled: PropTypes.bool,
	  disabledKeyboardNavigation: PropTypes.bool,
	  dropdownMode: PropTypes.oneOf(["scroll", "select"]).isRequired,
	  endDate: PropTypes.object,
	  excludeDates: PropTypes.array,
	  filterDate: PropTypes.func,
	  fixedHeight: PropTypes.bool,
	  formatWeekNumber: PropTypes.func,
	  highlightDates: PropTypes.array,
	  id: PropTypes.string,
	  includeDates: PropTypes.array,
	  includeTimes: PropTypes.array,
	  injectTimes: PropTypes.array,
	  inline: PropTypes.bool,
	  isClearable: PropTypes.bool,
	  locale: PropTypes.string,
	  maxDate: PropTypes.object,
	  minDate: PropTypes.object,
	  monthsShown: PropTypes.number,
	  name: PropTypes.string,
	  onBlur: PropTypes.func,
	  onChange: PropTypes.func.isRequired,
	  onSelect: PropTypes.func,
	  onWeekSelect: PropTypes.func,
	  onClickOutside: PropTypes.func,
	  onChangeRaw: PropTypes.func,
	  onFocus: PropTypes.func,
	  onInputClick: PropTypes.func,
	  onKeyDown: PropTypes.func,
	  onMonthChange: PropTypes.func,
	  onYearChange: PropTypes.func,
	  onInputError: PropTypes.func,
	  open: PropTypes.bool,
	  openToDate: PropTypes.object,
	  peekNextMonth: PropTypes.bool,
	  placeholderText: PropTypes.string,
	  popperContainer: PropTypes.func,
	  popperClassName: PropTypes.string, // <PopperComponent/> props
	  popperModifiers: PropTypes.object, // <PopperComponent/> props
	  popperPlacement: PropTypes.oneOf(popperPlacementPositions), // <PopperComponent/> props
	  popperProps: PropTypes.object,
	  preventOpenOnFocus: PropTypes.bool,
	  readOnly: PropTypes.bool,
	  required: PropTypes.bool,
	  scrollableYearDropdown: PropTypes.bool,
	  scrollableMonthYearDropdown: PropTypes.bool,
	  selected: PropTypes.object,
	  selectsEnd: PropTypes.bool,
	  selectsStart: PropTypes.bool,
	  showMonthDropdown: PropTypes.bool,
	  showMonthYearDropdown: PropTypes.bool,
	  showWeekNumbers: PropTypes.bool,
	  showYearDropdown: PropTypes.bool,
	  forceShowMonthNavigation: PropTypes.bool,
	  showDisabledMonthNavigation: PropTypes.bool,
	  startDate: PropTypes.object,
	  startOpen: PropTypes.bool,
	  tabIndex: PropTypes.number,
	  timeCaption: PropTypes.string,
	  title: PropTypes.string,
	  todayButton: PropTypes.node,
	  useWeekdaysShort: PropTypes.bool,
	  formatWeekDay: PropTypes.func,
	  utcOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  value: PropTypes.string,
	  weekLabel: PropTypes.string,
	  withPortal: PropTypes.bool,
	  yearDropdownItemNumber: PropTypes.number,
	  shouldCloseOnSelect: PropTypes.bool,
	  showTimeSelect: PropTypes.bool,
	  showTimeSelectOnly: PropTypes.bool,
	  timeFormat: PropTypes.string,
	  timeIntervals: PropTypes.number,
	  minTime: PropTypes.object,
	  maxTime: PropTypes.object,
	  excludeTimes: PropTypes.array,
	  useShortMonthInDropdown: PropTypes.bool,
	  clearButtonTitle: PropTypes.string,
	  previousMonthButtonLabel: PropTypes.string,
	  nextMonthButtonLabel: PropTypes.string,
	  renderCustomHeader: PropTypes.func,
	  renderDayContents: PropTypes.func
	};
	var PRESELECT_CHANGE_VIA_INPUT = "input";
	var PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";
	
	exports['default'] = DatePicker;
	exports.CalendarContainer = CalendarContainer;


/***/ }),
/* 212 */
[1912, 1665],
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(2);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(1049);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(1720);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var DEFAULT_STATUS = exports.DEFAULT_STATUS = 'default';
	var INFO_STATUS = exports.INFO_STATUS = 'info';
	var SUCCESS_STATUS = exports.SUCCESS_STATUS = 'success';
	var WARNING_STATUS = exports.WARNING_STATUS = 'warning';
	var ERROR_STATUS = exports.ERROR_STATUS = 'error';
	
	var STATUS = exports.STATUS = {
	  default: DEFAULT_STATUS,
	  info: INFO_STATUS,
	  success: SUCCESS_STATUS,
	  warning: WARNING_STATUS,
	  error: ERROR_STATUS
	};
	
	var TOP = exports.TOP = 't';
	var TOP_CENTER = exports.TOP_CENTER = 'tc';
	var TOP_LEFT_POSITION = exports.TOP_LEFT_POSITION = 'tl';
	var TOP_RIGHT_POSITION = exports.TOP_RIGHT_POSITION = 'tr';
	var BOTTOM = exports.BOTTOM = 'b';
	var BOTTOM_CENTER = exports.BOTTOM_CENTER = 'bc';
	var BOTTOM_LEFT_POSITION = exports.BOTTOM_LEFT_POSITION = 'bl';
	var BOTTOM_RIGHT_POSITION = exports.BOTTOM_RIGHT_POSITION = 'br';
	
	var POSITIONS = exports.POSITIONS = {
	  top: TOP,
	  topCenter: TOP_CENTER,
	  topLeft: TOP_LEFT_POSITION,
	  topRight: TOP_RIGHT_POSITION,
	  bottom: BOTTOM,
	  bottomCenter: BOTTOM_CENTER,
	  bottomLeft: BOTTOM_LEFT_POSITION,
	  bottomRight: BOTTOM_RIGHT_POSITION
	};
	
	// default value for notifications
	var DEFAULT_NOTIFICATION = exports.DEFAULT_NOTIFICATION = {
	  status: DEFAULT_STATUS,
	  position: TOP_RIGHT_POSITION,
	  dismissible: true,
	  dismissAfter: 5000,
	  allowHTML: false,
	  closeButton: false
	};

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.ACTION_TYPE_DELIMITER = exports.DEFAULT_NAMESPACE = void 0;
	var DEFAULT_NAMESPACE = '/';
	exports.DEFAULT_NAMESPACE = DEFAULT_NAMESPACE;
	var ACTION_TYPE_DELIMITER = '||';
	exports.ACTION_TYPE_DELIMITER = ACTION_TYPE_DELIMITER;

/***/ }),
/* 217 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  if (typeof value !== 'object' || value === null) return false;
	  var proto = value;
	
	  while (Object.getPrototypeOf(proto) !== null) {
	    proto = Object.getPrototypeOf(proto);
	  }
	
	  return Object.getPrototypeOf(value) === proto;
	};
	
	exports.default = _default;

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var formatName = function formatName(_ref, name) {
	  var sectionPrefix = _ref._reduxForm.sectionPrefix;
	  return sectionPrefix ? sectionPrefix + "." + name : name;
	};
	
	var _default = formatName;
	exports["default"] = _default;

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = create;
	exports.save = save;
	exports.remove = remove;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reapop = __webpack_require__(44);
	
	var _reactIntl = __webpack_require__(5);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Api = __webpack_require__(21);
	
	var Api = _interopRequireWildcard(_Api);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestCreate() {
	  return {
	    type: types.CREATE_ENTITY_REQUEST
	  };
	}
	
	function requestCreateSuccess(res) {
	  return {
	    type: types.CREATE_ENTITY_REQUEST_SUCCESS,
	    res: res
	  };
	}
	
	function requestCreateFailure(err) {
	  return {
	    type: types.CREATE_ENTITY_REQUEST_FAILURE,
	    err: err
	  };
	}
	
	function create(entity, data, action) {
	  return function (dispatch, getState) {
	    dispatch(requestCreate());
	
	    var _getState = getState(),
	        token = _getState.loginReducer.user.token,
	        valuesByKey = _getState.WebValuesReducer.valuesByKey;
	
	    var config = { entity: entity, data: data, headers: { Authorization: 'Bearer ' + token } };
	
	    Api.create(config).then(function (res) {
	      dispatch(requestCreateSuccess(res.data));
	      if (valuesByKey !== undefined && valuesByKey['Message.EmployeeMasterCourse'] !== undefined && valuesByKey['Message.EmployeeMasterCourse'].Value === 'true' && entity === 'EmployeeMasterCourse') {
	        var mailConfig = {
	          url: '/api/employeeMasterCourse/SendEmail',
	          headers: { Authorization: 'Bearer ' + token },
	          method: 'POST',
	          data: res.data.EmployeeMasterCourseID
	        };
	        Api.custom(mailConfig);
	        dispatch((0, _reapop.addNotification)({
	          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.create.title' }),
	          message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.create.contact.hr' }),
	          status: 'success',
	          dismissible: true,
	          dismissAfter: 6000
	        }));
	      } else {
	        dispatch((0, _reapop.addNotification)({
	          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.create.title' }),
	          message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.create.message' }),
	          status: 'success',
	          dismissible: true,
	          dismissAfter: 4000
	        }));
	      }
	      action && dispatch(action(res.data));
	    }).catch(function (err) {
	      var message = err.message && err.message.startsWith('Aðgangur leyfir ekki') ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.error.auth' }) : err.message;
	      dispatch((0, _reapop.addNotification)({
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.error.title' }),
	        // message: err.message || 'Villa kom upp við að stofna færslu í kjarna',
	        message: message,
	        status: 'error',
	        dismissible: true,
	        dismissAfter: 0
	      }));
	      dispatch(requestCreateFailure(err));
	    });
	  };
	}
	
	function requestSave() {
	  return {
	    type: types.SAVE_ENTITY_REQUEST
	  };
	}
	
	function requestSaveSuccess(res) {
	  return {
	    type: types.SAVE_ENTITY_REQUEST_SUCCESS,
	    res: res
	  };
	}
	
	function requestSaveFailure(err) {
	  return {
	    type: types.SAVE_ENTITY_REQUEST_FAILURE,
	    err: err
	  };
	}
	
	function save(entity, data, action) {
	  return function (dispatch, getState) {
	    dispatch(requestSave());
	
	    var _getState2 = getState(),
	        token = _getState2.loginReducer.user.token;
	
	    var config = { entity: entity, data: data, headers: { Authorization: 'Bearer ' + token } };
	
	    Api.save(config).then(function (res) {
	      dispatch(requestSaveSuccess(res.data));
	      dispatch((0, _reapop.addNotification)({
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.save.title' }),
	        message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.save.message' }),
	        status: 'success',
	        dismissible: true,
	        dismissAfter: 4000
	      }));
	      action && dispatch(action());
	    }).catch(function (err) {
	      var message = err.message && err.message.startsWith('Aðgangur leyfir ekki') ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.error.auth' }) : err.message;
	      dispatch((0, _reapop.addNotification)({
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.error.title' }),
	        // message: err.message || 'Villa kom upp við að vist færslu í kjarna',
	        message: message,
	        status: 'error',
	        dismissible: true,
	        dismissAfter: 0
	      }));
	      dispatch(requestSaveFailure(err));
	    });
	  };
	}
	
	function requestDelete() {
	  return {
	    type: types.DELETE_ENTITY_REQUEST
	  };
	}
	
	function requestDeleteSuccess(res) {
	  return {
	    type: types.DELETE_ENTITY_REQUEST_SUCCESS,
	    res: res
	  };
	}
	
	function requestDeleteFailure(err) {
	  return {
	    type: types.DELETE_ENTITY_REQUEST_FAILURE,
	    err: err
	  };
	}
	
	function remove(entity, data, action) {
	  return function (dispatch, getState) {
	    dispatch(requestDelete());
	
	    var _getState3 = getState(),
	        token = _getState3.loginReducer.user.token;
	
	    var config = { entity: entity, data: data, headers: { Authorization: 'Bearer ' + token } };
	
	    Api.remove(config).then(function (res) {
	      dispatch(requestDeleteSuccess(res.data));
	      dispatch((0, _reapop.addNotification)({
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.delete.title' }),
	        message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.delete.message' }),
	        status: 'success',
	        dismissible: true,
	        dismissAfter: 4000
	      }));
	      action && dispatch(action());
	    }).catch(function (err) {
	      var message = err.message && err.message.startsWith('Aðgangur leyfir ekki') ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.error.auth' }) : err.message;
	      dispatch((0, _reapop.addNotification)({
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.error.title' }),
	        // message: err.message || 'Villa kom upp við að vist færslu í kjarna',
	        message: message,
	        status: 'error',
	        dismissible: true,
	        dismissAfter: 0
	      }));
	      dispatch(requestDeleteFailure(err));
	    });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestCreate, 'requestCreate', 'D:/a/1/s/src/web/employee/src/actions/EntityCRUD.js');
	
	  __REACT_HOT_LOADER__.register(requestCreateSuccess, 'requestCreateSuccess', 'D:/a/1/s/src/web/employee/src/actions/EntityCRUD.js');
	
	  __REACT_HOT_LOADER__.register(requestCreateFailure, 'requestCreateFailure', 'D:/a/1/s/src/web/employee/src/actions/EntityCRUD.js');
	
	  __REACT_HOT_LOADER__.register(create, 'create', 'D:/a/1/s/src/web/employee/src/actions/EntityCRUD.js');
	
	  __REACT_HOT_LOADER__.register(requestSave, 'requestSave', 'D:/a/1/s/src/web/employee/src/actions/EntityCRUD.js');
	
	  __REACT_HOT_LOADER__.register(requestSaveSuccess, 'requestSaveSuccess', 'D:/a/1/s/src/web/employee/src/actions/EntityCRUD.js');
	
	  __REACT_HOT_LOADER__.register(requestSaveFailure, 'requestSaveFailure', 'D:/a/1/s/src/web/employee/src/actions/EntityCRUD.js');
	
	  __REACT_HOT_LOADER__.register(save, 'save', 'D:/a/1/s/src/web/employee/src/actions/EntityCRUD.js');
	
	  __REACT_HOT_LOADER__.register(requestDelete, 'requestDelete', 'D:/a/1/s/src/web/employee/src/actions/EntityCRUD.js');
	
	  __REACT_HOT_LOADER__.register(requestDeleteSuccess, 'requestDeleteSuccess', 'D:/a/1/s/src/web/employee/src/actions/EntityCRUD.js');
	
	  __REACT_HOT_LOADER__.register(requestDeleteFailure, 'requestDeleteFailure', 'D:/a/1/s/src/web/employee/src/actions/EntityCRUD.js');
	
	  __REACT_HOT_LOADER__.register(remove, 'remove', 'D:/a/1/s/src/web/employee/src/actions/EntityCRUD.js');
	}();

	;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _List = __webpack_require__(173);
	
	var _DataTypes = __webpack_require__(85);
	
	var _DetailListItem = __webpack_require__(861);
	
	var _DetailListItem2 = _interopRequireDefault(_DetailListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailList = function DetailList(_ref) {
	  var dataSource = _ref.dataSource,
	      containerStyle = _ref.containerStyle,
	      itemMaxWidth = _ref.itemMaxWidth;
	
	  var filtered = (0, _lodash.filter)(dataSource, function (f) {
	    return f.value > Number.MIN_VALUE || !(0, _lodash.isEmpty)(f.value);
	  });
	  return _react2.default.createElement(
	    _List.List,
	    {
	      style: _extends({
	        paddingTop: 0,
	        paddingBottom: 0,
	        display: 'flex',
	        flexWrap: 'wrap'
	      }, containerStyle)
	    },
	    (0, _lodash.map)(filtered, function (l, i) {
	      return _react2.default.createElement(
	        'div',
	        { key: i, style: { width: '100%', maxWidth: l.type === _DataTypes.TABLE || l.type === _DataTypes.HTML ? 'none' : itemMaxWidth } },
	        _react2.default.createElement(_DetailListItem2.default, l)
	      );
	    })
	  );
	};
	
	DetailList.propTypes = {
	  dataSource: _propTypes2.default.array,
	  containerStyle: _propTypes2.default.object,
	  itemMaxWidth: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	DetailList.defaultProps = {
	  itemMaxWidth: 250
	};
	
	var _default = DetailList;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DetailList, 'DetailList', 'D:/a/1/s/src/web/employee/src/components/DetailList.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/DetailList.js');
	}();

	;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var KTab = function KTab(_ref) {
	  var children = _ref.children,
	      style = _ref.style,
	      className = _ref.className;
	  return _react2.default.createElement(
	    'div',
	    { style: style, className: className },
	    children
	  );
	};
	
	KTab.propTypes = {
	  children: _propTypes2.default.node,
	  style: _propTypes2.default.object,
	  className: _propTypes2.default.string
	};
	
	var _default = KTab;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(KTab, 'KTab', 'D:/a/1/s/src/web/employee/src/components/KJRN/KTab.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KTab.js');
	}();

	;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _materialUi = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  tabs: {
	    width: '100%'
	  },
	  container: {
	    width: '100%',
	    marginBottom: 24
	  },
	  tabButtons: {
	    display: 'flex',
	    flexDirection: 'row',
	    borderBottom: '1px solid ' + _colors2.default.dividerColor,
	    flexWrap: 'wrap'
	  },
	  tabButton: {
	    outline: 'none',
	    border: 'none',
	    backgroundColor: 'transparent',
	    height: 60,
	    fontSize: 15,
	    paddingLeft: 18,
	    paddingRight: 18,
	    fontWeight: 600,
	    color: _colors2.default.titleColor,
	    cursor: 'pointer',
	    position: 'relative',
	    alignItems: 'center'
	  },
	  active: {
	    height: 2,
	    width: 'calc(100% - 36px)',
	    backgroundColor: _colors2.default.primary1Color,
	    position: 'absolute',
	    bottom: 0
	  }
	};
	
	var KTabs = function (_React$Component) {
	  _inherits(KTabs, _React$Component);
	
	  function KTabs(props) {
	    _classCallCheck(this, KTabs);
	
	    var _this = _possibleConstructorReturn(this, (KTabs.__proto__ || Object.getPrototypeOf(KTabs)).call(this, props));
	
	    _this.setIndex = function () {
	      return _this.__setIndex__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = {
	      index: 0,
	      tabs: _react2.default.Children.map(props.children, function (arg) {
	        return arg;
	      })
	    };
	    return _this;
	  }
	
	  _createClass(KTabs, [{
	    key: '__setIndex__REACT_HOT_LOADER__',
	    value: function __setIndex__REACT_HOT_LOADER__() {
	      return this.__setIndex__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__setIndex__REACT_HOT_LOADER__',
	    value: function __setIndex__REACT_HOT_LOADER__(index) {
	      return this.setState({ index: index });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          index = _state.index,
	          tabs = _state.tabs;
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.container },
	        _react2.default.createElement(
	          _materialUi.Paper,
	          { zDepth: 0, style: styles.tabs },
	          _react2.default.createElement(
	            'div',
	            { style: styles.tabButtons },
	            tabs.map(function (t, i) {
	              return _react2.default.createElement(
	                'button',
	                {
	                  style: styles.tabButton,
	                  key: 'tab' + i,
	                  onClick: function onClick() {
	                    return _this2.setIndex(i);
	                  },
	                  className: i !== index ? 'no-print' : ''
	                },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  t.props.name
	                ),
	                i === index && _react2.default.createElement('div', { style: styles.active })
	              );
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.tabContainer },
	            tabs[index]
	          )
	        )
	      );
	    }
	  }]);
	
	  return KTabs;
	}(_react2.default.Component);
	
	KTabs.propTypes = {
	  children: _propTypes2.default.node
	};
	
	var _default = KTabs;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/KJRN/KTabs.js');
	
	  __REACT_HOT_LOADER__.register(KTabs, 'KTabs', 'D:/a/1/s/src/web/employee/src/components/KJRN/KTabs.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KTabs.js');
	}();

	;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.renderList = exports.renderUnionRow = exports.validateTaxCard = exports.validateBankAccount = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _materialUi = __webpack_require__(17);
	
	var _icons = __webpack_require__(956);
	
	var _Cards = __webpack_require__(119);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var validateBankAccount = exports.validateBankAccount = function validateBankAccount(values, all) {
	  var errors = {};
	
	  if (values.BankAccountLedger) {
	    if (!all.bankLedgers[values.BankAccountLedger]) {
	      errors.BankAccountLedger = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'bank.errorLedger' });
	    }
	  } else {
	    errors.BankAccountLedger = ' ';
	  }
	
	  if (values.BankAccountNR) {
	    if ((0, _lodash.isNaN)(values.BankAccountNR)) {
	      errors.BankAccountNR = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'bank.errorAccount' });
	    }
	  } else {
	    errors.BankAccountNR = ' ';
	  }
	
	  if (values.BankID) {
	    if (!all.bankBranches[values.BankID]) {
	      errors.BankID = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'bank.errorBranch' });
	    }
	  } else {
	    errors.BankID = ' ';
	  }
	
	  return errors;
	};
	
	var validateTaxCard = exports.validateTaxCard = function validateTaxCard(values, taxDiscount) {
	  var errors = {};
	
	  var unused = parseInt(values.Unused, 10);
	
	  if (unused < 0) {
	    errors.Unused = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'taxCard.errorUnused.invalid' });
	  }
	
	  var currentMonth = new Date().getMonth();
	  var yearStart = new Date(new Date().getFullYear(), 0, 1);
	  var lastUsed = new Date(values.DateLastUsed);
	  var lastUsedMonth = lastUsed.getMonth();
	
	  var multiplier = yearStart.getTime() > lastUsed.getTime() ? currentMonth : lastUsedMonth + 1;
	
	  var maxDiscount = multiplier * taxDiscount;
	
	  if (values.DateLastUsed === null) {
	    errors.Unused = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'taxCard.errorUnused.noLast' });
	  } else if (unused > maxDiscount || unused < 0) {
	    errors.Unused = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'taxCard.errorUnused.max' });
	  }
	
	  return errors;
	};
	
	var renderUnionRow = exports.renderUnionRow = function renderUnionRow(obj) {
	  return _react2.default.createElement(
	    'div',
	    { style: _Cards2.default.row, key: obj.PayUnionID },
	    _react2.default.createElement(
	      'div',
	      { style: _Cards2.default.col1 },
	      _react2.default.createElement(
	        'span',
	        { style: _Cards2.default.label },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Union.number' })
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        obj.PayUnionID
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        { style: _Cards2.default.label },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Union' })
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        obj.PayUnionName
	      )
	    )
	  );
	};
	
	var renderList = exports.renderList = function renderList(obj, history, showHistory, setShowHistory) {
	  var renderRow = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : renderUnionRow;
	  return _react2.default.createElement(
	    _materialUi.Paper,
	    null,
	    renderRow(obj),
	    !(0, _lodash.isEmpty)(history) && _react2.default.createElement(
	      'button',
	      { style: _Cards2.default.buttonStyle, onClick: function onClick() {
	          return setShowHistory(!showHistory);
	        } },
	      showHistory ? _icons.closeIcon : _icons.openIcon
	    ),
	    showHistory && (0, _lodash.map)(history, function (u) {
	      return renderRow(u);
	    })
	  );
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(validateBankAccount, 'validateBankAccount', 'D:/a/1/s/src/web/employee/src/containers/pay/helpers.js');
	
	  __REACT_HOT_LOADER__.register(validateTaxCard, 'validateTaxCard', 'D:/a/1/s/src/web/employee/src/containers/pay/helpers.js');
	
	  __REACT_HOT_LOADER__.register(renderUnionRow, 'renderUnionRow', 'D:/a/1/s/src/web/employee/src/containers/pay/helpers.js');
	
	  __REACT_HOT_LOADER__.register(renderList, 'renderList', 'D:/a/1/s/src/web/employee/src/containers/pay/helpers.js');
	}();

	;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getPMEmployeeAppraisals = exports.updatePMEmployeeAppraisal = exports.getPMEmployeeAppraisal = undefined;
	
	var _Api = __webpack_require__(21);
	
	var APIH = '/api';
	
	var getPMEmployeeAppraisal = exports.getPMEmployeeAppraisal = function getPMEmployeeAppraisal(id) {
	  return _Api.custom.get(APIH + '/PMEmployeeAppraisalDto/' + id);
	};
	
	var updatePMEmployeeAppraisal = exports.updatePMEmployeeAppraisal = function updatePMEmployeeAppraisal(data, id) {
	  return _Api.custom.post(APIH + '/PMEmployeeAppraisalDto/UpdateAppraisalAnswersAndStatus?key=' + id, data);
	};
	
	var getPMEmployeeAppraisals = exports.getPMEmployeeAppraisals = function getPMEmployeeAppraisals() {
	  return _Api.custom.get(APIH + '/PMEmployeeAppraisalDto');
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(APIH, 'APIH', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/api.js');
	
	  __REACT_HOT_LOADER__.register(getPMEmployeeAppraisal, 'getPMEmployeeAppraisal', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/api.js');
	
	  __REACT_HOT_LOADER__.register(updatePMEmployeeAppraisal, 'updatePMEmployeeAppraisal', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/api.js');
	
	  __REACT_HOT_LOADER__.register(getPMEmployeeAppraisals, 'getPMEmployeeAppraisals', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/api.js');
	}();

	;

/***/ }),
/* 226 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var name = 'inOut';
	
	var INITIALIZE_REQUEST = exports.INITIALIZE_REQUEST = name + '/INITIALIZE_REQUEST';
	var INITIALIZE_SUCCESS = exports.INITIALIZE_SUCCESS = name + '/INITIALIZE_SUCCESS';
	var INITIALIZE_FAILURE = exports.INITIALIZE_FAILURE = name + '/INITIALIZE_FAILURE';
	
	var FETCH_RECORDS_REQUEST = exports.FETCH_RECORDS_REQUEST = name + '/FETCH_RECORDS_REQUEST';
	var FETCH_RECORDS_SUCCESS = exports.FETCH_RECORDS_SUCCESS = name + '/FETCH_RECORDS_SUCCESS';
	var FETCH_RECORDS_FAILURE = exports.FETCH_RECORDS_FAILURE = name + '/FETCH_RECORDS_FAILURE';
	
	var SET_PERIOD = exports.SET_PERIOD = name + '/SET_PERIOD';
	var SET_CANCEL_TOKEN = exports.SET_CANCEL_TOKEN = name + '/SET_CANCEL_TOKEN';
	
	var IN_OUT_FILTERS = exports.IN_OUT_FILTERS = 'inOutFilters';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(name, 'name', 'D:/a/1/s/src/web/employee/src/sites/inOut/constants.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_REQUEST, 'INITIALIZE_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/inOut/constants.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_SUCCESS, 'INITIALIZE_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/inOut/constants.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_FAILURE, 'INITIALIZE_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/inOut/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECORDS_REQUEST, 'FETCH_RECORDS_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/inOut/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECORDS_SUCCESS, 'FETCH_RECORDS_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/inOut/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECORDS_FAILURE, 'FETCH_RECORDS_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/inOut/constants.js');
	
	  __REACT_HOT_LOADER__.register(SET_PERIOD, 'SET_PERIOD', 'D:/a/1/s/src/web/employee/src/sites/inOut/constants.js');
	
	  __REACT_HOT_LOADER__.register(SET_CANCEL_TOKEN, 'SET_CANCEL_TOKEN', 'D:/a/1/s/src/web/employee/src/sites/inOut/constants.js');
	
	  __REACT_HOT_LOADER__.register(IN_OUT_FILTERS, 'IN_OUT_FILTERS', 'D:/a/1/s/src/web/employee/src/sites/inOut/constants.js');
	}();

	;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getNumberOfDays = exports.numberOfWorkingDays = exports.isHalfDay = exports.isRedDay = exports.holidays = exports.solstice = exports.fridagurVerslunarmanna = exports.sumardagurinnFyrsti = exports.bondadagur = exports.findNextWeekDay = exports.easter = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable no-mixed-operators */
	
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var easter = exports.easter = function easter(year) {
	  var a = year % 19;
	  var b = Math.floor(year / 100);
	  var c = year % 100;
	  var d = Math.floor(b / 4);
	  var e = b % 4;
	  var f = Math.floor((b + 8) / 25);
	  var g = Math.floor((b - f + 1) / 3);
	  var h = (19 * a + b - d - g + 15) % 30;
	  var i = Math.floor(c / 4);
	  var k = c % 4;
	  var l = (32 + 2 * e + 2 * i - h - k) % 7;
	  var m = Math.floor((a + 11 * h + 22 * l) / 451);
	  var easterMonth = Math.floor((h + l - 7 * m + 114) / 31);
	  var easterDay = (h + l - 7 * m + 114) % 31 + 1;
	
	  return new Date(year, easterMonth - 1, easterDay);
	};
	
	var findNextWeekDay = exports.findNextWeekDay = function findNextWeekDay(year, month, day, targetWDay) {
	  var date = new Date(year, month, day);
	  date.setDate(date.getDate() + (targetWDay - date.getDay() + 7) % 7);
	  return date;
	};
	
	var bondadagur = exports.bondadagur = function bondadagur(year) {
	  return findNextWeekDay(year, 0, 19, 5);
	};
	
	var sumardagurinnFyrsti = exports.sumardagurinnFyrsti = function sumardagurinnFyrsti(year) {
	  return findNextWeekDay(year, 3, 19, 4);
	};
	
	var fridagurVerslunarmanna = exports.fridagurVerslunarmanna = function fridagurVerslunarmanna(year) {
	  return findNextWeekDay(year, 7, 1, 1);
	};
	
	var solstice = exports.solstice = function solstice(year, season) {
	  var interval = 1000 * (56.5 + 47 * 60 + 5 * 3600 + 365 * 86400);
	
	  var date = season === 'winter' ? new Date(2016, 11, 21, 10, 44) : new Date(2016, 5, 20, 22, 34); // Default to 'summer'
	
	  while (date.getFullYear() < year) {
	    date.setTime(date.getTime() + interval);
	  }
	
	  while (date.getFullYear() > year) {
	    date.setTime(date.getTime() - interval);
	  }
	
	  return date;
	};
	
	var holidays = exports.holidays = function holidays(year) {
	  var easterSunday = easter(year);
	  var day = 86400000;
	
	  var holidayArr = [{
	    date: new Date(year, 0, 1),
	    description: 'Nýársdagur',
	    holiday: true
	  }, {
	    date: bondadagur(year),
	    description: 'Bóndadagur',
	    holiday: false
	  }, {
	    date: new Date(easterSunday.getTime() - 48 * day),
	    description: 'Bolludagur',
	    holiday: false
	  }, {
	    date: new Date(easterSunday.getTime() - 47 * day),
	    description: 'Sprengidagur',
	    holiday: false
	  }, {
	    date: new Date(easterSunday.getTime() - 46 * day),
	    description: 'Öskudagur',
	    holiday: false
	  }, {
	    date: new Date(year, 1, 14),
	    description: 'Valentínusardagur',
	    holiday: false
	  }, {
	    date: new Date(bondadagur(year).getTime() + 30 * day),
	    description: 'Konudagur',
	    holiday: false
	  }, {
	    date: new Date(easterSunday.getTime() - 3 * day),
	    description: 'Skírdagur',
	    holiday: true
	  }, {
	    date: new Date(easterSunday.getTime() - 2 * day),
	    description: 'Föstudagurinn langi',
	    holiday: true
	  }, {
	    date: easterSunday,
	    description: 'Páskadagur',
	    holiday: true
	  }, {
	    date: new Date(easterSunday.getTime() + day),
	    description: 'Annar í páskum',
	    holiday: true
	  }, {
	    date: sumardagurinnFyrsti(year),
	    description: 'Sumardagurinn fyrsti',
	    holiday: true
	  }, {
	    date: new Date(easterSunday.getTime() + 39 * day),
	    description: 'Uppstigningardagur',
	    holiday: true
	  }, {
	    date: new Date(easterSunday.getTime() + 49 * day),
	    description: 'Hvítasunnudagur',
	    holiday: true
	  }, {
	    date: new Date(easterSunday.getTime() + 50 * day),
	    description: 'Annar í Hvítasunnu',
	    holiday: true
	  }, {
	    date: new Date(year, 4, 1),
	    description: 'Verkalýðsdagurinn',
	    holiday: true
	  }, {
	    date: new Date(year, 5, 17),
	    description: 'Þjóðhátíðardagur Íslendinga',
	    holiday: true
	  }, {
	    date: solstice(year, 'summer'),
	    description: 'Sumarsólstöður',
	    holiday: false
	  }, {
	    date: new Date(year, 5, 24),
	    description: 'Jónsmessa',
	    holiday: false
	  }, {
	    date: fridagurVerslunarmanna(year),
	    description: 'Frídagur verslunarmanna',
	    holiday: true
	  }, {
	    date: new Date(year, 9, 31),
	    description: 'Hrekkjavaka',
	    holiday: false
	  }, {
	    date: new Date(year, 11, 1),
	    description: 'Fullveldisdagurinn',
	    holiday: false
	  }, {
	    date: solstice(year, 'winter'),
	    description: 'Vetrarsólstöður',
	    holiday: false
	  }, {
	    date: new Date(year, 11, 23),
	    description: 'Þorláksmessa',
	    holiday: false
	  }, {
	    date: new Date(year, 11, 24),
	    description: 'Aðfangadagur',
	    holiday: true,
	    halfDay: true
	  }, {
	    date: new Date(year, 11, 25),
	    description: 'Jóladagur',
	    holiday: true
	  }, {
	    date: new Date(year, 11, 26),
	    description: 'Annar í Jólum',
	    holiday: true
	  }, {
	    date: new Date(year, 11, 31),
	    description: 'Gamlársdagur',
	    holiday: true,
	    halfDay: true
	  }];
	
	  return (0, _lodash.reduce)(holidayArr, function (res, val) {
	    var d = (0, _moment2.default)((0, _lodash.get)(val, 'date')).format('DD-MM-YYYY').toString();
	    return _extends({}, res, _defineProperty({}, d, _extends({}, val)));
	  }, {});
	};
	
	var isRedDay = exports.isRedDay = function isRedDay(day) {
	  var h = holidays(day.getFullYear());
	  var ds = (0, _moment2.default)(day).format('DD-MM-YYYY').toString();
	  return Boolean((0, _lodash.get)(h, '[' + ds + '].holiday'));
	};
	
	var isHalfDay = exports.isHalfDay = function isHalfDay(day) {
	  var h = holidays(day.getFullYear());
	  var ds = (0, _moment2.default)(day).format('DD-MM-YYYY');
	  return Boolean((0, _lodash.get)(h, '[' + ds + '].halfDay'));
	};
	var numberOfWorkingDays = exports.numberOfWorkingDays = function numberOfWorkingDays(startDate, endDate) {
	  var currentDate = new Date(startDate);
	  var dayCount = 0;
	  while (currentDate <= endDate) {
	    if (!isRedDay(currentDate) && currentDate.getDay() !== 6 && currentDate.getDay() !== 0) {
	      dayCount += 1;
	    } else if (isHalfDay(currentDate) && currentDate.getDay() !== 6 && currentDate.getDay() !== 0) {
	      dayCount += 0.5;
	    }
	    currentDate.setDate(currentDate.getDate() + 1);
	  }
	  return dayCount;
	};
	
	var getNumberOfDays = exports.getNumberOfDays = function getNumberOfDays(startDate, endDate, registerRedDays, registerWeekend) {
	  var currentDateIn = new Date(startDate);
	  var currentDateOut = new Date(endDate);
	  var numberOfDays = 0;
	  while (currentDateIn <= new Date(endDate)) {
	    var isWeekday = !isRedDay(currentDateIn) && currentDateIn.getDay() % 6 !== 0;
	    if (isWeekday) {
	      numberOfDays += 1;
	    } else if (isHalfDay(currentDateIn)) {
	      // do nothing for half days ?
	    } else if (isRedDay(currentDateIn) && registerRedDays) {
	      numberOfDays += 1;
	    } else if (currentDateIn.getDay() % 6 === 0 && registerWeekend) {
	      numberOfDays += 1;
	    }
	    currentDateIn.setDate(currentDateIn.getDate() + 1);
	    currentDateOut.setDate(currentDateOut.getDate() + 1);
	  }
	  return numberOfDays;
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(easter, 'easter', 'D:/a/1/s/src/web/employee/src/sites/time/components/holidays.js');
	
	  __REACT_HOT_LOADER__.register(findNextWeekDay, 'findNextWeekDay', 'D:/a/1/s/src/web/employee/src/sites/time/components/holidays.js');
	
	  __REACT_HOT_LOADER__.register(bondadagur, 'bondadagur', 'D:/a/1/s/src/web/employee/src/sites/time/components/holidays.js');
	
	  __REACT_HOT_LOADER__.register(sumardagurinnFyrsti, 'sumardagurinnFyrsti', 'D:/a/1/s/src/web/employee/src/sites/time/components/holidays.js');
	
	  __REACT_HOT_LOADER__.register(fridagurVerslunarmanna, 'fridagurVerslunarmanna', 'D:/a/1/s/src/web/employee/src/sites/time/components/holidays.js');
	
	  __REACT_HOT_LOADER__.register(solstice, 'solstice', 'D:/a/1/s/src/web/employee/src/sites/time/components/holidays.js');
	
	  __REACT_HOT_LOADER__.register(holidays, 'holidays', 'D:/a/1/s/src/web/employee/src/sites/time/components/holidays.js');
	
	  __REACT_HOT_LOADER__.register(isRedDay, 'isRedDay', 'D:/a/1/s/src/web/employee/src/sites/time/components/holidays.js');
	
	  __REACT_HOT_LOADER__.register(isHalfDay, 'isHalfDay', 'D:/a/1/s/src/web/employee/src/sites/time/components/holidays.js');
	
	  __REACT_HOT_LOADER__.register(numberOfWorkingDays, 'numberOfWorkingDays', 'D:/a/1/s/src/web/employee/src/sites/time/components/holidays.js');
	
	  __REACT_HOT_LOADER__.register(getNumberOfDays, 'getNumberOfDays', 'D:/a/1/s/src/web/employee/src/sites/time/components/holidays.js');
	}();

	;

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 229 */
195,
/* 230 */
131,
/* 231 */
[1907, 1082, 468],
/* 232 */
[1856, 72, 34, 130],
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(25);
	var $export = __webpack_require__(4);
	var redefine = __webpack_require__(61);
	var redefineAll = __webpack_require__(128);
	var meta = __webpack_require__(110);
	var forOf = __webpack_require__(123);
	var anInstance = __webpack_require__(122);
	var isObject = __webpack_require__(28);
	var fails = __webpack_require__(27);
	var $iterDetect = __webpack_require__(237);
	var setToStringTag = __webpack_require__(158);
	var inheritIfRequired = __webpack_require__(320);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(510);
	var redefine = __webpack_require__(61);
	var hide = __webpack_require__(60);
	var fails = __webpack_require__(27);
	var defined = __webpack_require__(87);
	var wks = __webpack_require__(31);
	var regexpExec = __webpack_require__(328);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 235 */
[1868, 76],
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(28);
	var cof = __webpack_require__(76);
	var MATCH = __webpack_require__(31)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 237 */
[1872, 31],
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(109) || !__webpack_require__(27)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(25)[K];
	});


/***/ }),
/* 239 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(156);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(56);
	var ctx = __webpack_require__(77);
	var forOf = __webpack_require__(123);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(4);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 243 */
[1889, 79, 87],
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25);
	var hide = __webpack_require__(60);
	var uid = __webpack_require__(131);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 246 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(1462),
	    listCacheDelete = __webpack_require__(1463),
	    listCacheGet = __webpack_require__(1464),
	    listCacheHas = __webpack_require__(1465),
	    listCacheSet = __webpack_require__(1466);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(248),
	    stackClear = __webpack_require__(1483),
	    stackDelete = __webpack_require__(1484),
	    stackGet = __webpack_require__(1485),
	    stackHas = __webpack_require__(1486),
	    stackSet = __webpack_require__(1487);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(201);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(538),
	    createBaseEach = __webpack_require__(1436);
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	module.exports = baseEach;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(352),
	    isFlattenable = __webpack_require__(1458);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(537),
	    baseIsNaN = __webpack_require__(1404),
	    strictIndexOf = __webpack_require__(1488);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(1401),
	    isObjectLike = __webpack_require__(81);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(1459);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 258 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(201),
	    isArrayLike = __webpack_require__(97),
	    isIndex = __webpack_require__(258),
	    isObject = __webpack_require__(63);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(135);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(534),
	    baseFilter = __webpack_require__(1398),
	    baseIteratee = __webpack_require__(112),
	    isArray = __webpack_require__(41);
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 *
	 * // Combining several predicates using `_.overEvery` or `_.overSome`.
	 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
	 * // => objects for ['fred', 'barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	module.exports = filter;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var createFind = __webpack_require__(1438),
	    findIndex = __webpack_require__(368);
	
	/**
	 * Iterates over elements of `collection`, returning the first element
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {*} Returns the matched element, else `undefined`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'age': 36, 'active': true },
	 *   { 'user': 'fred',    'age': 40, 'active': false },
	 *   { 'user': 'pebbles', 'age': 1,  'active': true }
	 * ];
	 *
	 * _.find(users, function(o) { return o.age < 40; });
	 * // => object for 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.find(users, { 'age': 1, 'active': true });
	 * // => object for 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.find(users, ['active', false]);
	 * // => object for 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.find(users, 'active');
	 * // => object for 'barney'
	 */
	var find = createFind(findIndex);
	
	module.exports = find;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isObject = __webpack_require__(63);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    getPrototype = __webpack_require__(363),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(1407),
	    baseUnary = __webpack_require__(255),
	    nodeUtil = __webpack_require__(366);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(580);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(163),
	    copyArray = __webpack_require__(256),
	    isArray = __webpack_require__(41),
	    isSymbol = __webpack_require__(167),
	    stringToPath = __webpack_require__(565),
	    toKey = __webpack_require__(136),
	    toString = __webpack_require__(169);
	
	/**
	 * Converts `value` to a property path array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Util
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the new property path array.
	 * @example
	 *
	 * _.toPath('a.b.c');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toPath('a[0].b.c');
	 * // => ['a', '0', 'b', 'c']
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return arrayMap(value, toKey);
	  }
	  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	}
	
	module.exports = toPath;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(1529);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toArray2 = __webpack_require__(463);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(140);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _ClickAwayListener = __webpack_require__(380);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _keycode = __webpack_require__(73);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _List = __webpack_require__(375);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _menuUtils = __webpack_require__(1558);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var desktop = props.desktop,
	      maxHeight = props.maxHeight,
	      width = props.width;
	  var muiTheme = context.muiTheme;
	
	
	  var styles = {
	    root: {
	      // Nested div because the List scales x faster than it scales y
	      zIndex: muiTheme.zIndex.menu,
	      maxHeight: maxHeight,
	      overflowY: maxHeight ? 'auto' : null
	    },
	    divider: {
	      marginTop: 7,
	      marginBottom: 8
	    },
	    list: {
	      display: 'table-cell',
	      paddingBottom: desktop ? 16 : 8,
	      paddingTop: desktop ? 16 : 8,
	      userSelect: 'none',
	      width: width
	    },
	    selectedMenuItem: {
	      color: muiTheme.menuItem.selectedTextColor
	    }
	  };
	
	  return styles;
	}
	
	var Menu = function (_Component) {
	  (0, _inherits3.default)(Menu, _Component);
	
	  function Menu(props, context) {
	    (0, _classCallCheck3.default)(this, Menu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var filteredChildren = _this.getFilteredChildren(props.children);
	    var selectedIndex = _this.getLastSelectedIndex(props, filteredChildren);
	
	    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
	      props.onMenuItemFocusChange(null, newFocusIndex);
	    }
	    _this.state = {
	      focusIndex: newFocusIndex,
	      isKeyboardFocused: props.initiallyKeyboardFocused,
	      keyWidth: props.desktop ? 64 : 56
	    };
	
	    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      this.setScollPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var selectedIndex = void 0;
	      var filteredChildren = this.getFilteredChildren(nextProps.children);
	
	      if (this.props.multiple !== true) {
	        selectedIndex = this.getLastSelectedIndex(nextProps, filteredChildren);
	      } else {
	        selectedIndex = this.state.focusIndex;
	      }
	
	      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
	        this.props.onMenuItemFocusChange(null, newFocusIndex);
	      }
	      this.setState({
	        focusIndex: newFocusIndex,
	        keyWidth: nextProps.desktop ? 64 : 56
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoWidth) this.setWidth();
	    }
	  }, {
	    key: 'getValueLink',
	
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'setKeyboardFocused',
	    value: function setKeyboardFocused(keyboardFocused) {
	      this.setState({
	        isKeyboardFocused: keyboardFocused
	      });
	    }
	  }, {
	    key: 'getFilteredChildren',
	    value: function getFilteredChildren(children) {
	      var filteredChildren = [];
	      _react2.default.Children.forEach(children, function (child) {
	        if (child) {
	          filteredChildren.push(child);
	        }
	      });
	      return filteredChildren;
	    }
	  }, {
	    key: 'cloneMenuItem',
	    value: function cloneMenuItem(child, childIndex, styles, index) {
	      var _this2 = this;
	
	      var childIsDisabled = child.props.disabled;
	
	      var selectedChildStyles = {};
	      if (!childIsDisabled) {
	        var selected = this.isChildSelected(child, this.props);
	
	        if (selected) {
	          (0, _simpleAssign2.default)(selectedChildStyles, styles.selectedMenuItem, this.props.selectedMenuItemStyle);
	        }
	      }
	      var mergedChildStyles = (0, _simpleAssign2.default)({}, child.props.style, this.props.menuItemStyle, selectedChildStyles);
	
	      var extraProps = {
	        desktop: this.props.desktop,
	        style: mergedChildStyles
	      };
	      if (!childIsDisabled) {
	        var isFocused = childIndex === this.state.focusIndex;
	        var focusState = 'none';
	        if (isFocused) {
	          focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	        }
	
	        (0, _simpleAssign2.default)(extraProps, {
	          focusState: focusState,
	          onClick: function onClick(event) {
	            _this2.handleMenuItemClick(event, child, index);
	            if (child.props.onClick) child.props.onClick(event);
	          },
	          ref: isFocused ? 'focusedMenuItem' : null
	        });
	      }
	      return _react2.default.cloneElement(child, extraProps);
	    }
	  }, {
	    key: 'decrementKeyboardFocusIndex',
	    value: function decrementKeyboardFocusIndex(event) {
	      var index = this.state.focusIndex;
	
	      index--;
	      if (index < 0) index = 0;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'getMenuItemCount',
	    value: function getMenuItemCount(filteredChildren) {
	      var menuItemCount = 0;
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        if (!childIsADivider && !childIsDisabled) menuItemCount++;
	      });
	      return menuItemCount;
	    }
	  }, {
	    key: 'getLastSelectedIndex',
	    value: function getLastSelectedIndex(props, filteredChildren) {
	      var _this3 = this;
	
	      var selectedIndex = -1;
	      var menuItemIndex = 0;
	
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
	        if (!childIsADivider) menuItemIndex++;
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'setFocusIndexStartsWith',
	    value: function setFocusIndexStartsWith(event, keys, filteredChildren) {
	      var foundIndex = -1;
	      _react2.default.Children.forEach(filteredChildren, function (child, index) {
	        if (foundIndex >= 0) {
	          return;
	        }
	        var primaryText = child.props.primaryText;
	
	        if (typeof primaryText === 'string' && primaryText.substr(0, keys.length).toLowerCase() === keys.toLowerCase()) {
	          foundIndex = index;
	        }
	      });
	      if (foundIndex >= 0) {
	        this.setFocusIndex(event, foundIndex, true);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleMenuItemClick',
	    value: function handleMenuItemClick(event, item, index) {
	      var children = this.props.children;
	      var multiple = this.props.multiple;
	      var valueLink = this.getValueLink(this.props);
	      var menuValue = valueLink.value;
	      var itemValue = item.props.value;
	      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);
	
	      this.setFocusIndex(event, focusIndex, false);
	
	      if (multiple) {
	        menuValue = menuValue || [];
	
	        var itemIndex = menuValue.indexOf(itemValue);
	
	        var _menuValue = menuValue,
	            _menuValue2 = (0, _toArray3.default)(_menuValue),
	            newMenuValue = _menuValue2.slice(0);
	
	        if (itemIndex === -1) {
	          newMenuValue.push(itemValue);
	        } else {
	          newMenuValue.splice(itemIndex, 1);
	        }
	
	        valueLink.requestChange(event, newMenuValue);
	      } else if (!multiple && itemValue !== menuValue) {
	        valueLink.requestChange(event, itemValue);
	      }
	
	      this.props.onItemClick(event, item, index);
	    }
	  }, {
	    key: 'incrementKeyboardFocusIndex',
	    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
	      var index = this.state.focusIndex;
	      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
	
	      index++;
	      if (index > maxIndex) index = maxIndex;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'isChildSelected',
	    value: function isChildSelected(child, props) {
	      var menuValue = this.getValueLink(props).value;
	      var childValue = child.props.value;
	
	      if (props.multiple) {
	        return menuValue && menuValue.length && menuValue.indexOf(childValue) !== -1;
	      } else {
	        return child.props.hasOwnProperty('value') && menuValue === childValue;
	      }
	    }
	  }, {
	    key: 'setFocusIndex',
	    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
	      if (this.props.onMenuItemFocusChange) {
	        // Do this even if `newIndex === this.state.focusIndex` to allow users
	        // to detect up-arrow on the first MenuItem or down-arrow on the last.
	        this.props.onMenuItemFocusChange(event, newIndex);
	      }
	      this.setState({
	        focusIndex: newIndex,
	        isKeyboardFocused: isKeyboardFocused
	      });
	    }
	  }, {
	    key: 'setScollPosition',
	    value: function setScollPosition() {
	      var desktop = this.props.desktop;
	      var focusedMenuItem = this.refs.focusedMenuItem;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      if (focusedMenuItem) {
	        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;
	
	        // Make the focused item be the 2nd item in the list the user sees
	        var scrollTop = selectedOffSet - menuItemHeight;
	        if (scrollTop < menuItemHeight) scrollTop = 0;
	
	        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'cancelScrollEvent',
	    value: function cancelScrollEvent(event) {
	      event.stopPropagation();
	      event.preventDefault();
	      return false;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = _reactDom2.default.findDOMNode(this);
	      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
	      var elWidth = el.offsetWidth;
	      var keyWidth = this.state.keyWidth;
	      var minWidth = keyWidth * 1.5;
	      var keyIncrements = elWidth / keyWidth;
	      var newWidth = void 0;
	
	      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	      newWidth = keyIncrements * keyWidth;
	
	      if (newWidth < minWidth) newWidth = minWidth;
	
	      el.style.width = newWidth + 'px';
	      listEl.style.width = newWidth + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          desktop = _props.desktop,
	          disableAutoFocus = _props.disableAutoFocus,
	          initiallyKeyboardFocused = _props.initiallyKeyboardFocused,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          multiple = _props.multiple,
	          onItemClick = _props.onItemClick,
	          onEscKeyDown = _props.onEscKeyDown,
	          onMenuItemFocusChange = _props.onMenuItemFocusChange,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          menuItemStyle = _props.menuItemStyle,
	          style = _props.style,
	          value = _props.value,
	          valueLink = _props.valueLink,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemClick', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);
	
	      var filteredChildren = this.getFilteredChildren(children);
	
	      var menuItemIndex = 0;
	      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
	        var childIsDisabled = child.props.disabled;
	        var childName = child.type ? child.type.muiName : '';
	        var newChild = child;
	
	        switch (childName) {
	          case 'MenuItem':
	            newChild = _this4.cloneMenuItem(child, menuItemIndex, styles, index);
	            break;
	
	          case 'Divider':
	            newChild = _react2.default.cloneElement(child, {
	              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
	            });
	            break;
	        }
	
	        if (childName === 'MenuItem' && !childIsDisabled) {
	          menuItemIndex++;
	        }
	
	        return newChild;
	      });
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'div',
	          {
	            onKeyDown: this.handleKeyDown,
	            onWheel: this.handleOnWheel,
	            style: prepareStyles(mergedRootStyles),
	            ref: 'scrollContainer',
	            role: 'presentation'
	          },
	          _react2.default.createElement(
	            _List2.default,
	            (0, _extends3.default)({}, other, {
	              ref: 'list',
	              style: mergedListStyles,
	              role: 'menu'
	            }),
	            newChildren
	          )
	        )
	      );
	    }
	  }]);
	  return Menu;
	}(_react.Component);
	
	Menu.defaultProps = {
	  autoWidth: true,
	  desktop: false,
	  disableAutoFocus: false,
	  initiallyKeyboardFocused: false,
	  maxHeight: null,
	  multiple: false,
	  onChange: function onChange() {},
	  onEscKeyDown: function onEscKeyDown() {},
	  onItemClick: function onItemClick() {},
	  onKeyDown: function onKeyDown() {}
	};
	Menu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.handleClickAway = function (event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    var focusIndex = _this5.state.focusIndex;
	
	    if (focusIndex < 0) {
	      return;
	    }
	
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var focusedItem = filteredChildren[focusIndex];
	    if (!!focusedItem && focusedItem.props.menuItems && focusedItem.props.menuItems.length > 0) {
	      return;
	    }
	
	    _this5.setFocusIndex(event, -1, false);
	  };
	
	  this.handleKeyDown = function (event) {
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var key = (0, _keycode2.default)(event);
	    switch (key) {
	      case 'down':
	        event.preventDefault();
	        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        break;
	      case 'esc':
	        _this5.props.onEscKeyDown(event);
	        break;
	      case 'tab':
	        event.preventDefault();
	        if (event.shiftKey) {
	          _this5.decrementKeyboardFocusIndex(event);
	        } else {
	          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        }
	        break;
	      case 'up':
	        event.preventDefault();
	        _this5.decrementKeyboardFocusIndex(event);
	        break;
	      default:
	        if (key && key.length === 1) {
	          var hotKeys = _this5.hotKeyHolder.append(key);
	          if (_this5.setFocusIndexStartsWith(event, hotKeys, filteredChildren)) {
	            event.preventDefault();
	          }
	        }
	    }
	    _this5.props.onKeyDown(event);
	  };
	
	  this.handleOnWheel = function (event) {
	    var scrollContainer = _this5.refs.scrollContainer;
	    // Only scroll lock if the the Menu is scrollable.
	    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;
	
	    var scrollTop = scrollContainer.scrollTop,
	        scrollHeight = scrollContainer.scrollHeight,
	        clientHeight = scrollContainer.clientHeight;
	
	    var wheelDelta = event.deltaY;
	    var isDeltaPositive = wheelDelta > 0;
	
	    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
	      scrollContainer.scrollTop = scrollHeight;
	      return _this5.cancelScrollEvent(event);
	    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
	      scrollContainer.scrollTop = 0;
	      return _this5.cancelScrollEvent(event);
	    }
	  };
	};
	
	Menu.propTypes =  false ? {
	  /**
	   * If true, the width of the menu will be set automatically
	   * according to the widths of its children,
	   * using proper keyline increments (64px for desktop,
	   * 56px otherwise).
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The content of the menu. This is usually used to pass `MenuItem`
	   * elements.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the menu item will render with compact desktop styles.
	   */
	  desktop: _propTypes2.default.bool,
	  /**
	   * If true, the menu will not be auto-focused.
	   */
	  disableAutoFocus: _propTypes2.default.bool,
	  /**
	   * If true, the menu will be keyboard-focused initially.
	   */
	  initiallyKeyboardFocused: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The maximum height of the menu in pixels. If specified,
	   * the menu will be scrollable if it is taller than the provided
	   * height.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when a menu item with `value` not
	   * equal to the current `value` of the menu is clicked.
	   *
	   * @param {object} event Click event targeting the menu item.
	   * @param {any}  value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is focused and the *Esc* key
	   * is pressed.
	   *
	   * @param {object} event `keydown` event targeting the menu.
	   */
	  onEscKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is clicked.
	   *
	   * @param {object} event Click event targeting the menu item.
	   * @param {object} menuItem The menu item.
	   * @param {number} index The index of the menu item.
	   */
	  onItemClick: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function fired when the focus on a `MenuItem` is changed.
	   * There will be some "duplicate" changes reported if two different
	   * focusing event happen, for example if a `MenuItem` is focused via
	   * the keyboard and then it is clicked on.
	   *
	   * @param {object} event The event that triggered the focus change.
	   * The event can be null since the focus can be changed for non-event
	   * reasons such as prop changes.
	   * @param {number} newFocusIndex The index of the newly focused
	   * `MenuItem` or `-1` if focus was lost.
	   */
	  onMenuItemFocusChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   * This component also supports valueLink.
	   */
	  value: _propTypes2.default.any,
	  /**
	   * ValueLink for the menu's `value`.
	   */
	  valueLink: _propTypes2.default.object,
	  /**
	   * The width of the menu. If not specified, the menu's width
	   * will be set according to the widths of its children, using
	   * proper keyline increments (64px for desktop, 56px otherwise).
	   */
	  width: _propTypes4.default.stringOrNumber
	} : {};
	exports.default = Menu;

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SelectField = __webpack_require__(1565);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField2.default;

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableRowColumn = context.muiTheme.tableRowColumn;
	
	
	  var styles = {
	    root: {
	      paddingLeft: tableRowColumn.spacing,
	      paddingRight: tableRowColumn.spacing,
	      height: tableRowColumn.height,
	      textAlign: 'left',
	      fontSize: 13,
	      overflow: 'hidden',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis'
	    }
	  };
	
	  if (_react2.default.Children.count(props.children) === 1 && !isNaN(props.children)) {
	    styles.textAlign = 'right';
	  }
	
	  return styles;
	}
	
	var TableRowColumn = function (_Component) {
	  (0, _inherits3.default)(TableRowColumn, _Component);
	
	  function TableRowColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRowColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRowColumn.__proto__ || (0, _getPrototypeOf2.default)(TableRowColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _this.onMouseEnter = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onHover) {
	          _this.props.onHover(event, _this.props.columnNumber);
	        }
	      }
	    }, _this.onMouseLeave = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onHoverExit) {
	          _this.props.onHoverExit(event, _this.props.columnNumber);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRowColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onClick: this.onClick,
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave
	      };
	
	      return _react2.default.createElement(
	        'td',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        children
	      );
	    }
	  }]);
	  return TableRowColumn;
	}(_react.Component);
	
	TableRowColumn.defaultProps = {
	  hoverable: false
	};
	TableRowColumn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableRowColumn.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _propTypes2.default.number,
	  /**
	   * @ignore
	   * If true, this column responds to hover events.
	   */
	  hoverable: _propTypes2.default.bool,
	  /** @ignore */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Callback function for hover exit event.
	   */
	  onHoverExit: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableRowColumn;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = undefined;
	
	var _Table2 = __webpack_require__(1578);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(603);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(604);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(605);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(379);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(606);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(272);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.default = _Table3.default;

/***/ }),
/* 274 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(event) {
	      event.target.removeEventListener(event.type, recursiveFunction);
	      return callback(event);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(event) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
	  }
	};

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	
	// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
	// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
	
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = stripStyle;
	
	function stripStyle(style) {
	  var ret = {};
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 276 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return typeof value === 'function';
	};
	
	exports.default = _default;

/***/ }),
/* 277 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return typeof Map !== 'undefined' && value instanceof Map;
	};
	
	exports.default = _default;

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 279 */
/***/ (function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
	}
	
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchPensionData = exports.fetchEmployeeUnionData = exports.fetchUnionData = undefined;
	
	var _Api = __webpack_require__(21);
	
	var _lodash = __webpack_require__(8);
	
	var _ActionTypes = __webpack_require__(18);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var requestUnion = function requestUnion() {
	  return {
	    type: _ActionTypes.REQUEST_UNION
	  };
	};
	
	var requestUnionSuccess = function requestUnionSuccess(unions) {
	  return {
	    type: _ActionTypes.REQUEST_UNION_SUCCESS,
	    unions: unions
	  };
	};
	
	var requestUnionFailure = function requestUnionFailure(error) {
	  return {
	    type: _ActionTypes.REQUEST_UNION_FAILURE,
	    error: error
	  };
	};
	
	var fetchUnionData = exports.fetchUnionData = function fetchUnionData(employeeDetailId) {
	  return function (dispatch, getState) {
	    dispatch(requestUnion());
	
	    var _getState = getState(),
	        token = _getState.loginReducer.user.token;
	
	    var config = {
	      headers: { Authorization: 'Bearer ' + token },
	      method: 'GET',
	      url: '/kjarni/api/v2/EmployeeDetailUnions(' + employeeDetailId + ')/PayUnionDetail'
	    };
	
	    return (0, _Api.custom)(config).then(function (_ref) {
	      var data = _ref.data;
	
	      dispatch(requestUnionSuccess(data.value));
	    }).catch(function (err) {
	      return dispatch(requestUnionFailure(err));
	    });
	  };
	};
	
	var requestEmployeeUnion = function requestEmployeeUnion() {
	  return {
	    type: _ActionTypes.REQUEST_EMPLOYEE_UNION
	  };
	};
	
	var requestEmployeeUnionSuccess = function requestEmployeeUnionSuccess(employeeUnions) {
	  return {
	    type: _ActionTypes.REQUEST_EMPLOYEE_UNION_SUCCESS,
	    employeeUnions: employeeUnions
	  };
	};
	
	var requestEmployeeUnionFailure = function requestEmployeeUnionFailure(error) {
	  return {
	    type: _ActionTypes.REQUEST_EMPLOYEE_UNION_FAILURE,
	    error: error
	  };
	};
	
	var fetchEmployeeUnionData = exports.fetchEmployeeUnionData = function fetchEmployeeUnionData(employeeDetailId) {
	  return function (dispatch, getState) {
	    dispatch(requestEmployeeUnion());
	
	    var _getState2 = getState(),
	        token = _getState2.loginReducer.user.token;
	
	    var config = {
	      headers: { Authorization: 'Bearer ' + token },
	      method: 'GET',
	      url: '/kjarni/api/v2/EmployeeDetailUnions(' + employeeDetailId + ')/EmployeeUnionDetail'
	    };
	
	    return (0, _Api.custom)(config).then(function (_ref2) {
	      var data = _ref2.data;
	
	      dispatch(requestEmployeeUnionSuccess(data.value));
	    }).catch(function (err) {
	      return dispatch(requestEmployeeUnionFailure(err));
	    });
	  };
	};
	
	var requestPension = function requestPension() {
	  return {
	    type: _ActionTypes.REQUEST_PENSION
	  };
	};
	
	var requestPensionSuccess = function requestPensionSuccess(data) {
	  return {
	    type: _ActionTypes.REQUEST_PENSION_SUCCESS,
	    data: data
	  };
	};
	
	var requestPensionFailure = function requestPensionFailure(error) {
	  return {
	    type: _ActionTypes.REQUEST_PENSION_FAILURE,
	    error: error
	  };
	};
	
	var fetchPensionData = exports.fetchPensionData = function fetchPensionData(employeeDetailId) {
	  return function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState3, token, pensionConfig, getEmployeeMasterPensionsByMasterID, getXapValue, pension, useMasterPension, privateMasterPensions, General, Private;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              dispatch(requestPension());
	
	              _getState3 = getState(), token = _getState3.loginReducer.user.token;
	              pensionConfig = {
	                headers: { Authorization: 'Bearer ' + token },
	                method: 'GET',
	                url: '/kjarni/api/v2/EmployeeDetailPensions(' + employeeDetailId + ')/PensionDetail'
	              };
	              getEmployeeMasterPensionsByMasterID = {
	                headers: { Authorization: 'Bearer ' + token },
	                method: 'GET',
	                url: '/kjarni/api/v2/EmployeeMasterPensions(' + (0, _lodash.floor)(employeeDetailId / 10, 0) + ')/PensionDetail'
	              };
	              getXapValue = {
	                url: '/kjarni/api/v2/XapValues',
	                method: 'GET',
	                params: {
	                  $filter: 'XapValueName eq \'Pay.Use.EmployeePension.Private\''
	                }
	              };
	              _context.prev = 5;
	              _context.t0 = _lodash.get;
	              _context.next = 9;
	              return (0, _Api.custom)(pensionConfig);
	
	            case 9:
	              _context.t1 = _context.sent;
	              pension = (0, _context.t0)(_context.t1, 'data');
	              _context.t2 = _lodash.get;
	              _context.next = 14;
	              return (0, _Api.custom)(getXapValue);
	
	            case 14:
	              _context.t3 = _context.sent;
	              _context.t4 = (0, _context.t2)(_context.t3, 'data.value[0].Value', null);
	              useMasterPension = _context.t4 === 'true';
	              _context.t5 = useMasterPension;
	
	              if (!_context.t5) {
	                _context.next = 25;
	                break;
	              }
	
	              _context.t6 = _lodash.get;
	              _context.next = 22;
	              return (0, _Api.custom)(getEmployeeMasterPensionsByMasterID);
	
	            case 22:
	              _context.t7 = _context.sent;
	              _context.t8 = [];
	              _context.t5 = (0, _context.t6)(_context.t7, 'data.value', _context.t8);
	
	            case 25:
	              privateMasterPensions = _context.t5;
	              General = (0, _lodash.filter)((0, _lodash.get)(pension, 'General'), function (p) {
	                return (0, _moment2.default)().isBetween((0, _moment2.default)(p.Begda), (0, _moment2.default)(p.Endda));
	              });
	              Private = (0, _lodash.filter)(useMasterPension ? privateMasterPensions : (0, _lodash.get)(pension, 'Private', []), function (p) {
	                return (0, _moment2.default)().isBetween((0, _moment2.default)(p.Begda), (0, _moment2.default)(p.Endda));
	              });
	
	
	              dispatch(requestPensionSuccess({ General: General, Private: Private }));
	
	              _context.next = 34;
	              break;
	
	            case 31:
	              _context.prev = 31;
	              _context.t9 = _context['catch'](5);
	
	              dispatch(requestPensionFailure(_context.t9));
	
	            case 34:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[5, 31]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestUnion, 'requestUnion', 'D:/a/1/s/src/web/employee/src/actions/EmployeePensionAndUnion.js');
	
	  __REACT_HOT_LOADER__.register(requestUnionSuccess, 'requestUnionSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeePensionAndUnion.js');
	
	  __REACT_HOT_LOADER__.register(requestUnionFailure, 'requestUnionFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeePensionAndUnion.js');
	
	  __REACT_HOT_LOADER__.register(fetchUnionData, 'fetchUnionData', 'D:/a/1/s/src/web/employee/src/actions/EmployeePensionAndUnion.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeUnion, 'requestEmployeeUnion', 'D:/a/1/s/src/web/employee/src/actions/EmployeePensionAndUnion.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeUnionSuccess, 'requestEmployeeUnionSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeePensionAndUnion.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeUnionFailure, 'requestEmployeeUnionFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeePensionAndUnion.js');
	
	  __REACT_HOT_LOADER__.register(fetchEmployeeUnionData, 'fetchEmployeeUnionData', 'D:/a/1/s/src/web/employee/src/actions/EmployeePensionAndUnion.js');
	
	  __REACT_HOT_LOADER__.register(requestPension, 'requestPension', 'D:/a/1/s/src/web/employee/src/actions/EmployeePensionAndUnion.js');
	
	  __REACT_HOT_LOADER__.register(requestPensionSuccess, 'requestPensionSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeePensionAndUnion.js');
	
	  __REACT_HOT_LOADER__.register(requestPensionFailure, 'requestPensionFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeePensionAndUnion.js');
	
	  __REACT_HOT_LOADER__.register(fetchPensionData, 'fetchPensionData', 'D:/a/1/s/src/web/employee/src/actions/EmployeePensionAndUnion.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.leaveCourse = exports.attendCourse = exports.requestCoursesSuccess = exports.requestCoursesFailure = exports.requestCourses = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral([' or '], [' or ']);
	
	exports.fetchCourses = fetchCourses;
	exports.fetchCoursesIfNeeded = fetchCoursesIfNeeded;
	exports.requestCourseAttendance = requestCourseAttendance;
	exports.requestCourseAttendanceSuccess = requestCourseAttendanceSuccess;
	exports.requestCourseAttendanceFailure = requestCourseAttendanceFailure;
	exports.requestCourseLeave = requestCourseLeave;
	exports.requestCourseLeaveSuccess = requestCourseLeaveSuccess;
	exports.requestCourseLeaveFailure = requestCourseLeaveFailure;
	exports.requestEmployeeMasterCourses = requestEmployeeMasterCourses;
	exports.requestEmployeeMasterCoursesFailure = requestEmployeeMasterCoursesFailure;
	exports.requestEmployeeMasterCoursesSuccess = requestEmployeeMasterCoursesSuccess;
	exports.fetchEmployeeMasterCourses = fetchEmployeeMasterCourses;
	exports.fetchEmployeeMasterCoursesIfNeeded = fetchEmployeeMasterCoursesIfNeeded;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _flatten = __webpack_require__(568);
	
	var _flatten2 = _interopRequireDefault(_flatten);
	
	var _uniqBy = __webpack_require__(582);
	
	var _uniqBy2 = _interopRequireDefault(_uniqBy);
	
	var _uniq = __webpack_require__(1517);
	
	var _uniq2 = _interopRequireDefault(_uniq);
	
	var _find = __webpack_require__(263);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _isEmpty = __webpack_require__(98);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _orderBy = __webpack_require__(372);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _Api = __webpack_require__(21);
	
	var _reapop = __webpack_require__(44);
	
	var _reactIntl = __webpack_require__(5);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } /* eslint-disable consistent-return */
	
	
	var requestCourses = exports.requestCourses = function requestCourses() {
	  return {
	    type: types.REQUEST_COURSES
	  };
	};
	
	var requestCoursesFailure = exports.requestCoursesFailure = function requestCoursesFailure(coursesError) {
	  return {
	    type: types.REQUEST_COURSES_FAILURE,
	    coursesError: coursesError
	  };
	};
	
	var requestCoursesSuccess = exports.requestCoursesSuccess = function requestCoursesSuccess(attendingCourses, openCourses, allCourses) {
	  return {
	    type: types.REQUEST_COURSES_SUCCESS,
	    attendingCourses: attendingCourses,
	    openCourses: openCourses,
	    allCourses: allCourses
	  };
	};
	
	function fetchCourses() {
	  return function (dispatch, getState) {
	    dispatch(requestCourses());
	
	    var _getState = getState(),
	        _getState$loginReduce = _getState.loginReducer.user,
	        token = _getState$loginReduce.token,
	        EmployeeMasterID = _getState$loginReduce.EmployeeMasterID;
	
	    var n = new Date().toISOString();
	    var fetchOpen = {
	      entity: 'Course',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: 'Entity/CourseStatus eq \'0\' and CourseBegda gt datetime\'' + n + '\' and not Entity/CourseAttendees/any(a: a/EmployeeMasterID eq ' + EmployeeMasterID + ')',
	        $orderby: 'CourseBegda asc'
	      }
	    };
	    var fetchAttending = {
	      entity: 'Course',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: 'Entity/CourseStatus eq \'0\' and Entity/CourseAttendees/any(a: a/EmployeeMasterID eq ' + EmployeeMasterID + ') and CourseEndda gt datetime\'' + n + '\'',
	        $orderby: 'CourseBegda asc'
	      }
	    };
	
	    var fetchDetailOrg = {
	      entity: 'EmployeeDetailOrg',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $expand: 'Entity',
	        $select: 'Entity/EmployeeDetailOrgID, Entity/OrgCompanyID, Entity/OrgCompanyUnitID, Entity/OrgCompanyUnitPositionID',
	        $filter: 'Entity/EmployeeDetailID ge ' + EmployeeMasterID + '1 and Entity/EmployeeDetailID le ' + EmployeeMasterID + '9 and (Entity/EmployeeStatus eq \'0\' or (Entity/EmployeeStatus ge \'4\'  and Entity/EmployeeStatus le \'7\')) and Entity/Begda le datetime\'' + n + '\' and Entity/Endda ge datetime\'' + n + '\''
	      }
	    };
	
	    // TODO
	    // 1. Befor fetching the courses that are open we need to fetch the users EmployeeDetailOrg
	    // 2. From the EmployeeDetailOrg retrieve the users OrgCompanyID, OrgCompanyUnitID, OrgCompanyUnitPositionID
	    // 3. Fetch all CourseTargetsObjects that have the users info to get the CourseTargetId
	    // 4. Then we can ensure that we only fetch courses that have no CourseTargetCourses or CourseTargetCourses with specific IDs
	
	    (0, _Api.listWM)(fetchDetailOrg).then(function (employeeDetailOrgs) {
	      // go though the detail orgs and pick out the objectIDs for the request
	      var objectMapping = (0, _uniqBy2.default)((0, _flatten2.default)((0, _map2.default)(employeeDetailOrgs.data, function (dOrg) {
	        return [{ ObjectType: 'OrgCompany', ObjectID: dOrg.OrgCompanyID }, { ObjectType: 'OrgCompanyUnit', ObjectID: dOrg.OrgCompanyUnitID }, { ObjectType: 'OrgCompanyUnitPosition', ObjectID: dOrg.OrgCompanyUnitPositionID }];
	      })), function (x) {
	        return x.ObjectType + '-' + x.ObjectID;
	      });
	      // User only ever have one EmployeeMasterID
	      objectMapping.push({ ObjectType: 'EmployeeMaster', ObjectID: EmployeeMasterID });
	      var fetchTargetIDs = {
	        url: '/kjarni/api/v2/CourseTargetObjects?$filter=' + (0, _map2.default)(objectMapping, function (o) {
	          return '(ObjectType eq \'' + o.ObjectType + '\' and ObjectID eq ' + o.ObjectID + ')';
	        }).join(_templateObject),
	        method: 'Get'
	      };
	      (0, _Api.custom)(fetchTargetIDs).then(function (courseTargetObjects) {
	        var courseTargetIDs = (0, _uniq2.default)((0, _map2.default)(courseTargetObjects.data.value, function (cto) {
	          return cto.CourseTargetID;
	        }));
	        if (courseTargetIDs.length) {
	          fetchOpen.params.$filter += ' and ((not Entity/CourseTargetCourses/any()) or (Entity/CourseTargetCourses/any(a: ' + (0, _map2.default)(courseTargetIDs, function (ctID) {
	            return 'a/CourseTargetID eq ' + ctID;
	          }).join(_templateObject) + ')))';
	        } else {
	          fetchOpen.params.$filter += ' and (not Entity/CourseTargetCourses/any())';
	        }
	        (0, _Api.listWM)(fetchOpen).then(function (openCourses) {
	          (0, _Api.listWM)(fetchAttending).then(function (attendingCourses) {
	            dispatch(requestCoursesSuccess(attendingCourses.data.map(function (c) {
	              return _extends({}, c, {
	                MainCourseAttendeeID: c.CourseAttendees.find(function (a) {
	                  return a.EmployeeMasterID === EmployeeMasterID;
	                }).CourseAttendeeID,
	                CourseTimes: c.CourseTimes.map(function (t) {
	                  return _extends({}, t, t.Entity);
	                })
	              });
	            }), openCourses.data.map(function (c) {
	              return _extends({}, c, {
	                CourseTimes: c.CourseTimes.map(function (t) {
	                  return _extends({}, t, t.Entity);
	                })
	              });
	            }), (0, _orderBy2.default)([].concat(_toConsumableArray(attendingCourses.data.map(function (c) {
	              return _extends({}, c, { Attending: true });
	            })), _toConsumableArray(openCourses.data)), [function (c) {
	              return new Date(c.CourseBegda).getTime();
	            }], ['asc'])));
	          }, function (error) {
	            return dispatch(requestCoursesFailure(error));
	          });
	        }, function (error) {
	          return dispatch(requestCoursesFailure(error));
	        });
	      }, function (error) {
	        return dispatch(requestCoursesFailure(error));
	      });
	    }, function (error) {
	      return dispatch(requestCoursesFailure(error));
	    });
	  };
	}
	
	function fetchCoursesIfNeeded() {
	  return function (dispatch, getState) {
	    if ((0, _isEmpty2.default)(getState().coursesReducer.openCourses)) {
	      dispatch(fetchCourses());
	    }
	  };
	}
	
	/* ------------ COURSE ATTENDANCE ------------ */
	
	function requestCourseAttendance() {
	  return {
	    type: types.REQUEST_COURSE_ATTENDANCE
	  };
	}
	
	function requestCourseAttendanceSuccess() {
	  return {
	    type: types.REQUEST_COURSE_ATTENDANCE_SUCCESS
	  };
	}
	
	function requestCourseAttendanceFailure(error) {
	  return {
	    type: types.REQUEST_COURSE_ATTENDANCE_FAILURE,
	    error: error
	  };
	}
	
	var attendCourse = exports.attendCourse = function attendCourse(CourseID, QuestionnaireRootAnswerID) {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState2, EmployeeMasterID, allCourses, data, Course, registerRequest;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _getState2 = getState(), EmployeeMasterID = _getState2.loginReducer.user.EmployeeMasterID, allCourses = _getState2.coursesReducer.allCourses;
	              data = {
	                CourseID: CourseID,
	                EmployeeMasterID: EmployeeMasterID,
	                QuestionnaireRootAnswerID: QuestionnaireRootAnswerID
	              };
	              Course = (0, _find2.default)(allCourses, ['CourseID', CourseID]);
	
	              if (!(Course.CourseAttendeeRegistered >= Course.CourseMaxAttendance)) {
	                _context.next = 6;
	                break;
	              }
	
	              return _context.abrupt('return', dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.register.title' }),
	                message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.register.full' }),
	                status: 'error',
	                dismissible: true,
	                dismissibleAfter: 0
	              })));
	
	            case 6:
	              registerRequest = {
	                url: '/kjarni/api/v2/CourseAttendees/Register',
	                method: 'Post',
	                data: data
	              };
	
	              dispatch(requestCourseAttendance());
	              _context.next = 10;
	              return (0, _Api.custom)(registerRequest);
	
	            case 10:
	              dispatch(requestCourseAttendanceSuccess());
	              dispatch(fetchCourses());
	              _context.next = 17;
	              break;
	
	            case 14:
	              _context.prev = 14;
	              _context.t0 = _context['catch'](0);
	
	              dispatch(requestCourseAttendanceFailure((0, _lodash.get)(_context.t0, 'message')));
	
	            case 17:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 14]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	/* ------------ COURSE LEAVE ------------ */
	
	function requestCourseLeave() {
	  return {
	    type: types.REQUEST_COURSE_LEAVE
	  };
	}
	
	function requestCourseLeaveSuccess() {
	  return {
	    type: types.REQUEST_COURSE_LEAVE_SUCCESS
	  };
	}
	
	function requestCourseLeaveFailure(error) {
	  return {
	    type: types.REQUEST_COURSE_LEAVE_FAILURE,
	    error: error
	  };
	}
	
	var leaveCourse = exports.leaveCourse = function leaveCourse(CourseAttendeeID) {
	  return function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	      var unregisterRequest, msg;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	
	              dispatch(requestCourseLeave());
	              unregisterRequest = {
	                url: '/kjarni/api/v2/CourseAttendees/UnRegister',
	                method: 'Post',
	                data: { CourseAttendeeID: CourseAttendeeID }
	              };
	              _context2.next = 5;
	              return (0, _Api.custom)(unregisterRequest);
	
	            case 5:
	              dispatch(requestCourseLeaveSuccess());
	              dispatch(fetchCourses());
	              _context2.next = 13;
	              break;
	
	            case 9:
	              _context2.prev = 9;
	              _context2.t0 = _context2['catch'](0);
	              msg = (0, _lodash.get)(_context2.t0, 'error.message', 'Villa');
	
	              dispatch((0, _reapop.addNotification)({
	                title: 'Villa við afskráningu',
	                message: msg,
	                status: 'error',
	                dismissible: true,
	                dismissAfter: 12000
	              }));
	              // dispatch(requestCourseLeaveFailure({ Message: msg }));
	
	            case 13:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 9]]);
	    }));
	
	    return function (_x3) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	
	/* --------------------- EMPLOYEE MASTER COURSE ---------------------- */
	
	function requestEmployeeMasterCourses() {
	  return {
	    type: types.REQUEST_EMPLOYEE_MASTER_COURSES,
	    employeeMasterCourses: [],
	    employeeMasterCoursesLoaded: false,
	    sentAt: Date.now(),
	    error: null
	  };
	}
	
	function requestEmployeeMasterCoursesFailure(error) {
	  return {
	    type: types.REQUEST_EMPLOYEE_MASTER_COURSES_FAILURE,
	    employeeMasterCourses: [],
	    employeeMasterCoursesLoaded: true,
	    receivedAt: Date.now(),
	    error: error
	  };
	}
	
	function requestEmployeeMasterCoursesSuccess(employeeMasterCourses) {
	  return {
	    type: types.REQUEST_EMPLOYEE_MASTER_COURSES_SUCCESS,
	    employeeMasterCoursesLoaded: true,
	    receivedAt: Date.now(),
	    employeeMasterCourses: employeeMasterCourses,
	    error: null
	  };
	}
	
	function fetchEmployeeMasterCourses() {
	  return function (dispatch, getState) {
	    dispatch(requestEmployeeMasterCourses());
	
	    var _getState3 = getState(),
	        _getState3$loginReduc = _getState3.loginReducer.user,
	        EmployeeMasterID = _getState3$loginReduc.EmployeeMasterID,
	        token = _getState3$loginReduc.token;
	
	    var fetchConfig = {
	      entity: 'EmployeeMasterCourse',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: 'Entity/EmployeeMasterID eq ' + EmployeeMasterID
	      }
	    };
	
	    (0, _Api.listWM)(fetchConfig).then(function (_ref3) {
	      var data = _ref3.data;
	      return dispatch(requestEmployeeMasterCoursesSuccess(data));
	    }).catch(function (error) {
	      return dispatch(requestEmployeeMasterCoursesFailure(error));
	    });
	  };
	}
	
	function fetchEmployeeMasterCoursesIfNeeded() {
	  return function (dispatch, getState) {
	    return (0, _isEmpty2.default)(getState().coursesReducer.employeeMasterCourses) && dispatch(fetchEmployeeMasterCourses());
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestCourses, 'requestCourses', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(requestCoursesFailure, 'requestCoursesFailure', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(requestCoursesSuccess, 'requestCoursesSuccess', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(fetchCourses, 'fetchCourses', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(fetchCoursesIfNeeded, 'fetchCoursesIfNeeded', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(requestCourseAttendance, 'requestCourseAttendance', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(requestCourseAttendanceSuccess, 'requestCourseAttendanceSuccess', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(requestCourseAttendanceFailure, 'requestCourseAttendanceFailure', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(attendCourse, 'attendCourse', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(requestCourseLeave, 'requestCourseLeave', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(requestCourseLeaveSuccess, 'requestCourseLeaveSuccess', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(requestCourseLeaveFailure, 'requestCourseLeaveFailure', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(leaveCourse, 'leaveCourse', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeMasterCourses, 'requestEmployeeMasterCourses', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeMasterCoursesFailure, 'requestEmployeeMasterCoursesFailure', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeMasterCoursesSuccess, 'requestEmployeeMasterCoursesSuccess', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(fetchEmployeeMasterCourses, 'fetchEmployeeMasterCourses', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	
	  __REACT_HOT_LOADER__.register(fetchEmployeeMasterCoursesIfNeeded, 'fetchEmployeeMasterCoursesIfNeeded', 'D:/a/1/s/src/web/employee/src/actions/courses.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestLanguage = exports.setLanguage = exports.defaultLanguage = undefined;
	
	var _ActionTypes = __webpack_require__(18);
	
	var _Api = __webpack_require__(21);
	
	var defaultLanguage = exports.defaultLanguage = 'is';
	
	var setLanguage = exports.setLanguage = function setLanguage() {
	  var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultLanguage;
	
	  localStorage.language = language;
	  return {
	    type: _ActionTypes.SET_LANGUAGE,
	    language: language
	  };
	};
	
	var requestLanguage = exports.requestLanguage = function requestLanguage(language) {
	  return function (dispatch, getState) {
	    var token = getState().loginReducer.user.token;
	
	
	    var config = {
	      url: 'api/language/change',
	      method: 'POST',
	      headers: { Authorization: 'Bearer ' + token },
	      data: JSON.stringify(language === 'en' ? 'en-US' : 'is-IS')
	    };
	    (0, _Api.custom)(config).then(function () {
	      dispatch(setLanguage(language));
	      window.location.reload();
	    }).catch(function () {
	      dispatch(setLanguage());
	      window.location.reload();
	    });
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(defaultLanguage, 'defaultLanguage', 'D:/a/1/s/src/web/employee/src/actions/language.js');
	
	  __REACT_HOT_LOADER__.register(setLanguage, 'setLanguage', 'D:/a/1/s/src/web/employee/src/actions/language.js');
	
	  __REACT_HOT_LOADER__.register(requestLanguage, 'requestLanguage', 'D:/a/1/s/src/web/employee/src/actions/language.js');
	}();

	;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  container: {
	    flex: 1,
	    justifyContent: 'center',
	    alignItems: 'center',
	    display: 'flex',
	    flexDirection: 'column'
	  },
	  value: {
	    color: _colors2.default.titleColor,
	    fontWeight: 500,
	    fontSize: 18
	  },
	  label: {
	    color: _colors2.default.subtitleColor
	  },
	  hover: {}
	};
	
	var KValue = function KValue(_ref) {
	  var value = _ref.value,
	      label = _ref.label,
	      containerStyle = _ref.containerStyle,
	      valueStyle = _ref.valueStyle,
	      labelStyle = _ref.labelStyle;
	  return _react2.default.createElement(
	    'div',
	    { style: _extends({}, styles.container, containerStyle) },
	    _react2.default.createElement(
	      'div',
	      { style: _extends({}, styles.value, valueStyle) },
	      value
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: _extends({}, styles.label, labelStyle) },
	      label
	    )
	  );
	};
	
	KValue.propTypes = {
	  value: _propTypes2.default.node.isRequired,
	  label: _propTypes2.default.node.isRequired,
	  valueStyle: _propTypes2.default.object,
	  labelStyle: _propTypes2.default.object,
	  containerStyle: _propTypes2.default.object
	};
	
	var _default = KValue;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/KJRN/KValue.js');
	
	  __REACT_HOT_LOADER__.register(KValue, 'KValue', 'D:/a/1/s/src/web/employee/src/components/KJRN/KValue.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KValue.js');
	}();

	;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keyBy = __webpack_require__(370);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _filter = __webpack_require__(262);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	var _reactIntl = __webpack_require__(5);
	
	var _RootField = __webpack_require__(428);
	
	var _RootField2 = _interopRequireDefault(_RootField);
	
	var _Subheader = __webpack_require__(115);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _Truncate = __webpack_require__(872);
	
	var _Truncate2 = _interopRequireDefault(_Truncate);
	
	var _InputTypes = __webpack_require__(91);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  subheader: {
	    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	    fontSize: 18,
	    fontWeight: 500
	  },
	  input: {
	    marginBottom: 16,
	    marginTop: 8,
	    padding: 8
	  },
	  questionRoot: {
	    padding: 16
	  },
	  question: {
	    display: 'flex',
	    flexDirection: 'column',
	    paddingBottom: 16,
	    fontWeight: 500
	  },
	  label: {
	    color: 'rgb(176, 176, 176)'
	  },
	  description: {
	    color: 'rgb(95, 95, 95)',
	    fontSize: 14,
	    fontWeight: 'normal'
	  },
	  comment: {
	    color: 'rgb(95, 95, 95)',
	    marginTop: 16
	  },
	  checkboxGroup: {
	    display: 'flex',
	    flexDirection: 'row',
	    flexWrap: 'wrap',
	    marginTop: 32
	  },
	  answer: {
	    display: 'flex',
	    flexDirection: 'column',
	    marginBottom: 16
	  },
	  errorText: {
	    color: _colors2.default.errorColor
	  },
	  ansText: {
	    display: 'flex',
	    flexDirection: 'column'
	  }
	};
	
	var Answer = function Answer(_ref) {
	  var text = _ref.text,
	      showComment = _ref.showComment,
	      comment = _ref.comment,
	      title = _ref.title;
	  return _react2.default.createElement(
	    _reactFlexboxGrid.Col,
	    { xs: 12, style: styles.answer },
	    _react2.default.createElement(
	      'span',
	      { style: styles.label },
	      title
	    ),
	    _react2.default.createElement(
	      'span',
	      { style: styles.ansText },
	      text.length ? (0, _map2.default)(text, function (t, i) {
	        return _react2.default.createElement(_Truncate2.default, { key: i, message: t });
	      }) : _react2.default.createElement(
	        'span',
	        { style: styles.errorText },
	        'Ekkert svar.'
	      )
	    ),
	    showComment && _react2.default.createElement(
	      'span',
	      { style: styles.comment },
	      comment ? _react2.default.createElement(_Truncate2.default, { length: 300, message: comment }) : _react2.default.createElement(
	        'span',
	        { style: styles.errorText },
	        'Engin athugasemd.'
	      )
	    )
	  );
	};
	
	Answer.defaultProps = {
	  text: [],
	  showComment: false,
	  comment: '',
	  title: ''
	};
	
	Answer.propTypes = {
	  text: _propTypes2.default.array,
	  showComment: _propTypes2.default.bool,
	  comment: _propTypes2.default.string,
	  title: _propTypes2.default.node
	};
	
	var QAElement = function (_React$Component) {
	  _inherits(QAElement, _React$Component);
	
	  function QAElement(props) {
	    _classCallCheck(this, QAElement);
	
	    var _this = _possibleConstructorReturn(this, (QAElement.__proto__ || Object.getPrototypeOf(QAElement)).call(this, props));
	
	    _this.renderComment = function () {
	      return _this.__renderComment__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.renderInput = function () {
	      return _this.__renderInput__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.renderFinalAnswer = function () {
	      return _this.__renderFinalAnswer__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.renderAnswers = function () {
	      return _this.__renderAnswers__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(QAElement, [{
	    key: '__renderAnswers__REACT_HOT_LOADER__',
	    value: function __renderAnswers__REACT_HOT_LOADER__() {
	      return this.__renderAnswers__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__renderFinalAnswer__REACT_HOT_LOADER__',
	    value: function __renderFinalAnswer__REACT_HOT_LOADER__() {
	      return this.__renderFinalAnswer__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__renderInput__REACT_HOT_LOADER__',
	    value: function __renderInput__REACT_HOT_LOADER__() {
	      return this.__renderInput__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__renderComment__REACT_HOT_LOADER__',
	    value: function __renderComment__REACT_HOT_LOADER__() {
	      return this.__renderComment__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__renderComment__REACT_HOT_LOADER__',
	    value: function __renderComment__REACT_HOT_LOADER__() {
	      var _props = this.props,
	          QAElementID = _props.QAElementID,
	          AllowComment = _props.AllowComment,
	          QAInput = _props.QAInput;
	      var QAInputAnswerType = QAInput.QAInputAnswerType;
	
	      if (!AllowComment) {
	        return _react2.default.createElement('div', null);
	      }
	      return _react2.default.createElement(_RootField2.default, {
	        multiLine: true,
	        type: _InputTypes.TEXT_FIELD,
	        hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.answer.comment' }),
	        name: 'COMMENT-' + QAInputAnswerType + '-' + QAElementID
	      });
	    }
	  }, {
	    key: '__renderInput__REACT_HOT_LOADER__',
	    value: function __renderInput__REACT_HOT_LOADER__() {
	      var _props$QAInput = this.props.QAInput,
	          QAInputOptions = _props$QAInput.QAInputOptions,
	          HrQualificationScaleEntries = _props$QAInput.HrQualificationScaleEntries,
	          MaxAnswers = _props$QAInput.MaxAnswers,
	          QAInputAnswerType = _props$QAInput.QAInputAnswerType;
	
	      var options = QAInputOptions && QAInputOptions.map(function (e) {
	        return _extends({}, e, { label: e.QAInputOptionLabel, value: e.QAInputOptionID });
	      });
	      var scaleOptions = HrQualificationScaleEntries && HrQualificationScaleEntries.map(function (e) {
	        return _extends({}, e, { label: e.HrQualificationScaleEntryName, value: e.HrQualificationScaleEntryID });
	      });
	      var _props2 = this.props,
	          QAElementID = _props2.QAElementID,
	          disabled = _props2.disabled;
	
	      var isMultiple = MaxAnswers > 1;
	
	      switch (QAInputAnswerType) {
	        case 0:
	          return _react2.default.createElement(_RootField2.default, {
	            multiLine: true,
	            disabled: disabled,
	            rowsMax: 6,
	            type: _InputTypes.TEXT_FIELD,
	            hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.input.text' }),
	            name: QAInputAnswerType + '-' + QAElementID
	          });
	        case 1:
	          return _react2.default.createElement(
	            'span',
	            null,
	            'At this moment ATTACHMENT questions are not supported'
	          )
	          /*
	          <RootField
	            type={ATTACHMENT}
	            name={`${QAInputAnswerType}-${QAElementID}-${ATTACHMENT}`}
	          />
	          */
	          ;
	        case 2:
	          return _react2.default.createElement(_RootField2.default, {
	            type: _InputTypes.RADIO,
	            options: options,
	            disabled: disabled,
	            hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.input.select' }),
	            name: QAInputAnswerType + '-' + QAElementID
	          });
	        case 3:
	          return _react2.default.createElement(
	            'div',
	            { style: styles.checkboxGroup },
	            options && options.map(function (_ref2) {
	              var QAInputOptionLabel = _ref2.QAInputOptionLabel,
	                  QAInputOptionID = _ref2.QAInputOptionID;
	              return _react2.default.createElement(_RootField2.default, {
	                key: QAInputOptionID,
	                type: _InputTypes.CHECKBOX,
	                disabled: disabled,
	                label: QAInputOptionLabel,
	                name: QAInputAnswerType + '-' + QAElementID + '-' + btoa(QAInputOptionLabel)
	              });
	            })
	          );
	        case 4:
	          return _react2.default.createElement(_RootField2.default, {
	            type: _InputTypes.TEXT_FIELD,
	            multiLine: true,
	            disabled: disabled,
	            rows: 2,
	            rowsMax: 6,
	            hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.input.text' }),
	            name: QAInputAnswerType + '-' + QAElementID
	          });
	        case 5:
	          return _react2.default.createElement(_RootField2.default, {
	            type: _InputTypes.DATE,
	            multiple: isMultiple,
	            disabled: disabled,
	            name: QAInputAnswerType + '-' + QAElementID
	          });
	        case 6:
	          return _react2.default.createElement(_RootField2.default, {
	            type: _InputTypes.SCALE,
	            options: scaleOptions,
	            disabled: disabled,
	            hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.input.select' }),
	            name: QAInputAnswerType + '-' + QAElementID
	          });
	        default:
	          return _react2.default.createElement(
	            'span',
	            null,
	            'UNEXPECTED_ANSWER_TYPE'
	          );
	      }
	    }
	  }, {
	    key: '__renderFinalAnswer__REACT_HOT_LOADER__',
	    value: function __renderFinalAnswer__REACT_HOT_LOADER__() {
	      var _props3 = this.props,
	          QAInput = _props3.QAInput,
	          finalAnswers = _props3.finalAnswers,
	          QAElementID = _props3.QAElementID,
	          AllowComment = _props3.AllowComment;
	      var QAInputAnswerType = QAInput.QAInputAnswerType;
	
	      var finAns = (0, _keyBy2.default)(finalAnswers, 'QAElementID')[QAElementID];
	      var finalAnswerTexts = (0, _map2.default)((0, _filter2.default)(finalAnswers, ['QAElementID', QAElementID]), function (e) {
	        return e.QAAnswerText;
	      });
	      if (QAInputAnswerType === 5) {
	        finalAnswerTexts = (0, _map2.default)(finalAnswerTexts, _dateTools2.default);
	      }
	      return _react2.default.createElement(
	        _reactFlexboxGrid.Row,
	        { style: styles.answers },
	        _react2.default.createElement(Answer, {
	          title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.answer.final' }),
	          text: finalAnswerTexts,
	          showComment: AllowComment,
	          comment: finAns ? finAns.QAAnswerComment : ''
	        })
	      );
	    }
	  }, {
	    key: '__renderAnswers__REACT_HOT_LOADER__',
	    value: function __renderAnswers__REACT_HOT_LOADER__() {
	      var _props4 = this.props,
	          QAInput = _props4.QAInput,
	          employeeAnswers = _props4.employeeAnswers,
	          managerAnswers = _props4.managerAnswers,
	          QAElementID = _props4.QAElementID,
	          AllowComment = _props4.AllowComment,
	          showOnlyEmployeeAnswers = _props4.showOnlyEmployeeAnswers;
	      var QAInputAnswerType = QAInput.QAInputAnswerType;
	
	      var empAns = (0, _keyBy2.default)(employeeAnswers, 'QAElementID')[QAElementID];
	      var manAns = (0, _keyBy2.default)(managerAnswers, 'QAElementID')[QAElementID];
	      var employeeAnswerTexts = (0, _map2.default)((0, _filter2.default)(employeeAnswers, ['QAElementID', QAElementID]), function (e) {
	        return e.QAAnswerText;
	      });
	      var managerAnswerTexts = (0, _map2.default)((0, _filter2.default)(managerAnswers, ['QAElementID', QAElementID]), function (e) {
	        return e.QAAnswerText;
	      });
	      if (QAInputAnswerType === 5) {
	        employeeAnswerTexts = (0, _map2.default)(employeeAnswerTexts, _dateTools2.default);
	        managerAnswerTexts = (0, _map2.default)(managerAnswerTexts, _dateTools2.default);
	      }
	
	      return _react2.default.createElement(
	        _reactFlexboxGrid.Row,
	        { style: styles.answers },
	        _react2.default.createElement(
	          _reactFlexboxGrid.Col,
	          { style: { padding: 0 }, xs: 12, md: 6 },
	          _react2.default.createElement(Answer, {
	            title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.answer.employee' }),
	            text: employeeAnswerTexts,
	            showComment: AllowComment,
	            comment: empAns ? empAns.QAAnswerComment : ''
	          })
	        ),
	        _react2.default.createElement(
	          _reactFlexboxGrid.Col,
	          { style: { padding: 0 }, xs: 12, md: 6 },
	          !showOnlyEmployeeAnswers && _react2.default.createElement(Answer, {
	            title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.answer.manager' }),
	            text: managerAnswerTexts,
	            showComment: AllowComment,
	            comment: manAns ? manAns.QAAnswerComment : ''
	          })
	        )
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props,
	          QAElementType = _props5.QAElementType,
	          Label = _props5.Label,
	          Description = _props5.Description,
	          showAnswers = _props5.showAnswers,
	          showOnlyEmployeeAnswers = _props5.showOnlyEmployeeAnswers,
	          noInput = _props5.noInput;
	
	      switch (QAElementType) {
	        case 1:
	          return _react2.default.createElement('div', null);
	        case 2:
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _Subheader2.default,
	              { style: styles.subheader },
	              Label
	            ),
	            Description && _react2.default.createElement(_Subheader2.default, {
	              style: _extends({}, styles.subheader, {
	                fontSize: 14,
	                lineHeight: '14px',
	                marginBottom: 32
	              }),
	              dangerouslySetInnerHTML: { __html: Description }
	            })
	          );
	        case 3:
	          return _react2.default.createElement(
	            _Paper2.default,
	            { style: styles.input },
	            _react2.default.createElement(
	              'div',
	              { style: styles.questionRoot },
	              _react2.default.createElement(
	                'div',
	                { style: styles.question },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  Label
	                ),
	                _react2.default.createElement('span', { style: styles.description, dangerouslySetInnerHTML: { __html: Description } })
	              ),
	              (showAnswers || showOnlyEmployeeAnswers) && this.renderAnswers(),
	              noInput && !showOnlyEmployeeAnswers && this.renderFinalAnswer(),
	              !noInput && this.renderInput(),
	              !noInput && this.renderComment()
	            )
	          );
	        default:
	          return _react2.default.createElement('div', null);
	      }
	    }
	  }]);
	
	  return QAElement;
	}(_react2.default.Component);
	
	QAElement.defaultProps = {
	  AllowComment: false,
	  Description: '',
	  employeeAnswers: [],
	  finalAnswers: [],
	  Label: '',
	  managerAnswers: [],
	  noInput: false,
	  showAnswers: false,
	  showOnlyEmployeeAnswers: false
	};
	
	QAElement.propTypes = {
	  AllowComment: _propTypes2.default.bool,
	  Description: _propTypes2.default.string,
	  employeeAnswers: _propTypes2.default.array,
	  finalAnswers: _propTypes2.default.array,
	  Label: _propTypes2.default.string,
	  managerAnswers: _propTypes2.default.array,
	  noInput: _propTypes2.default.bool,
	  QAElementID: _propTypes2.default.number.isRequired,
	  QAElementType: _propTypes2.default.number.isRequired,
	  QAInput: _propTypes2.default.object,
	  showAnswers: _propTypes2.default.bool,
	  showOnlyEmployeeAnswers: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool
	};
	
	var _default = QAElement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/QAElement.js');
	
	  __REACT_HOT_LOADER__.register(Answer, 'Answer', 'D:/a/1/s/src/web/employee/src/components/QAElement.js');
	
	  __REACT_HOT_LOADER__.register(QAElement, 'QAElement', 'D:/a/1/s/src/web/employee/src/components/QAElement.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/QAElement.js');
	}();

	;

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var holidayResponseStatuses = {
	  OK: 'OK',
	  WARNING: 'WARNING',
	  ERROR: 'ERROR'
	};
	
	var _default = holidayResponseStatuses;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(holidayResponseStatuses, 'holidayResponseStatuses', 'D:/a/1/s/src/web/employee/src/constants/holidayResponseStatuses.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/constants/holidayResponseStatuses.js');
	}();

	;

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var STATUS = {
	  NONE: 0,
	  STARTED: 1,
	  FINISHED: 2
	};
	
	var ANSWER_TYPES = {
	  EMPLOYEE: 0,
	  MANAGER: 1,
	  FINAL: 2
	};
	
	exports.STATUS = STATUS;
	exports.ANSWER_TYPES = ANSWER_TYPES;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(STATUS, "STATUS", "D:/a/1/s/src/web/employee/src/containers/pmappraisals/appraisalEnums.js");
	
	  __REACT_HOT_LOADER__.register(ANSWER_TYPES, "ANSWER_TYPES", "D:/a/1/s/src/web/employee/src/containers/pmappraisals/appraisalEnums.js");
	}();

	;

/***/ }),
/* 287 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var name = exports.name = 'ApprovalRequests';
	
	var FETCH_DETAIL_APPROVAL_REQUESTS = exports.FETCH_DETAIL_APPROVAL_REQUESTS = name + '/FETCH_DETAIL_APPROVAL_REQUESTS';
	var FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS = exports.FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS = name + '/FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS';
	var FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE = exports.FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE = name + '/FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(name, 'name', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_DETAIL_APPROVAL_REQUESTS, 'FETCH_DETAIL_APPROVAL_REQUESTS', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS, 'FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE, 'FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/constants.js');
	}();

	;

/***/ }),
/* 288 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var name = 'Paytickets';
	
	var FETCH_TICKETS_REQUEST = exports.FETCH_TICKETS_REQUEST = name + '/FETCH_TICKETS_REQUEST';
	var FETCH_TICKETS_SUCCESS = exports.FETCH_TICKETS_SUCCESS = name + '/FETCH_TICKETS_SUCCESS';
	var FETCH_TICKETS_FAILURE = exports.FETCH_TICKETS_FAILURE = name + '/FETCH_TICKETS_FAILURE';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(name, 'name', 'D:/a/1/s/src/web/employee/src/sites/payTickets/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TICKETS_REQUEST, 'FETCH_TICKETS_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/payTickets/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TICKETS_SUCCESS, 'FETCH_TICKETS_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/payTickets/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_TICKETS_FAILURE, 'FETCH_TICKETS_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/payTickets/constants.js');
	}();

	;

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var name = 'teria';
	var INITIALIZE_REQUEST = exports.INITIALIZE_REQUEST = name + '/INITIALIZE_REQUEST';
	var INITIALIZE_SUCCESS = exports.INITIALIZE_SUCCESS = name + '/INITIALIZE_SUCCESS';
	var INITIALIZE_FAILURE = exports.INITIALIZE_FAILURE = name + '/INITIALIZE_FAILURE';
	
	var FETCH_PURCHASES_REQUEST = exports.FETCH_PURCHASES_REQUEST = name + '/FETCH_PURCHASES_REQUEST';
	var FETCH_PURCHASES_SUCCESS = exports.FETCH_PURCHASES_SUCCESS = name + '/FETCH_PURCHASES_SUCCESS';
	var FETCH_PURCHASES_FAILURE = exports.FETCH_PURCHASES_FAILURE = name + '/FETCH_PURCHASES_FAILURE';
	
	var SET_PERIOD = exports.SET_PERIOD = name + '/SET_PERIOD';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(name, 'name', 'D:/a/1/s/src/web/employee/src/sites/teria/constants.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_REQUEST, 'INITIALIZE_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/teria/constants.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_SUCCESS, 'INITIALIZE_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/teria/constants.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_FAILURE, 'INITIALIZE_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/teria/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASES_REQUEST, 'FETCH_PURCHASES_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/teria/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASES_SUCCESS, 'FETCH_PURCHASES_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/teria/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_PURCHASES_FAILURE, 'FETCH_PURCHASES_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/teria/constants.js');
	
	  __REACT_HOT_LOADER__.register(SET_PERIOD, 'SET_PERIOD', 'D:/a/1/s/src/web/employee/src/sites/teria/constants.js');
	}();

	;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(8);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _normalize = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var itemStyle = {
	  display: 'flex', alignItems: 'center', margin: 3
	};
	var iconStyle = { marginRight: 5 };
	var textStyle = { width: '75px' };
	var color = 'rgb(117, 117, 117)';
	
	var ExpectedHours = function ExpectedHours(_ref) {
	  var entries = _ref.entries,
	      workingHours = _ref.workingHours,
	      start = _ref.start,
	      workingDays = _ref.workingDays;
	
	  var _useState = (0, _react.useState)(0),
	      _useState2 = _slicedToArray(_useState, 2),
	      expectedHours = _useState2[0],
	      setExpectedHours = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      workedHours = _useState4[0],
	      setWorkedHours = _useState4[1];
	
	  (0, _react.useEffect)(function () {
	    setWorkedHours((0, _lodash.sumBy)((0, _lodash.toArray)(entries), 'ActualClockTime'));
	  }, [entries]);
	
	  (0, _react.useEffect)(function () {
	    var workingHour = (0, _lodash.find)(workingHours, function (h) {
	      return (0, _moment2.default)(start).isSameOrAfter((0, _lodash.get)(h, 'Begda')) && (0, _moment2.default)(start).isSameOrBefore((0, _lodash.get)(h, 'Endda'));
	    });
	    var hrsPerDay = (0, _lodash.get)(workingHour, 'HrsPrDay', 0);
	
	    setExpectedHours(hrsPerDay * workingDays);
	  }, [start, workingHours]);
	
	  return _react2.default.createElement(
	    'div',
	    { style: { display: 'flex' } },
	    _react2.default.createElement(
	      'div',
	      { style: itemStyle },
	      _react2.default.createElement(
	        _materialUi.FontIcon,
	        { color: color, style: iconStyle, className: 'material-icons' },
	        'schedule'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: textStyle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.hours', values: { hours: (0, _normalize.unitRender)(expectedHours - workedHours) }, tagName: 'div' }),
	        _react2.default.createElement(
	          'span',
	          { style: { color: color } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.TimeBehind' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: itemStyle },
	      _react2.default.createElement(
	        _materialUi.FontIcon,
	        { color: color, style: iconStyle, className: 'material-icons' },
	        ' done '
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: textStyle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.hours', values: { hours: (0, _normalize.unitRender)(workedHours) }, tagName: 'div' }),
	        _react2.default.createElement(
	          'span',
	          { style: { color: color } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.workedHours' })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: itemStyle },
	      _react2.default.createElement(
	        _materialUi.FontIcon,
	        { color: color, style: iconStyle, className: 'material-icons' },
	        'event_note'
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: textStyle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.hours', values: { hours: (0, _normalize.unitRender)(expectedHours) }, tagName: 'div' }),
	        _react2.default.createElement(
	          'span',
	          { style: { color: color } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.expectedHours' })
	        )
	      )
	    )
	  );
	};
	ExpectedHours.propTypes = {
	  entries: _propTypes2.default.shape({}).isRequired,
	  workingHours: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
	  workingDays: _propTypes2.default.number.isRequired,
	  start: _propTypes2.default.shape({}).isRequired
	};
	ExpectedHours.defaultProps = {};
	
	var _default = (0, _reactRedux.connect)(function (_ref2) {
	  var timeReducer = _ref2.timeReducer;
	  return _extends({}, timeReducer);
	})(ExpectedHours);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(itemStyle, 'itemStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/ExpectedHours.js');
	
	  __REACT_HOT_LOADER__.register(iconStyle, 'iconStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/ExpectedHours.js');
	
	  __REACT_HOT_LOADER__.register(textStyle, 'textStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/ExpectedHours.js');
	
	  __REACT_HOT_LOADER__.register(color, 'color', 'D:/a/1/s/src/web/employee/src/sites/time/components/ExpectedHours.js');
	
	  __REACT_HOT_LOADER__.register(ExpectedHours, 'ExpectedHours', 'D:/a/1/s/src/web/employee/src/sites/time/components/ExpectedHours.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/time/components/ExpectedHours.js');
	}();

	;

/***/ }),
/* 291 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var name = 'time';
	var INITIALIZE_REQUEST = exports.INITIALIZE_REQUEST = name + '/INITIALIZE_REQUEST';
	var INITIALIZE_SUCCESS = exports.INITIALIZE_SUCCESS = name + '/INITIALIZE_SUCCESS';
	var INITIALIZE_FAILURE = exports.INITIALIZE_FAILURE = name + '/INITIALIZE_FAILURE';
	
	var FETCH_ENTRIES_REQUEST = exports.FETCH_ENTRIES_REQUEST = name + '/FETCH_ENTRIES_REQUEST';
	var FETCH_ENTRIES_SUCCESS = exports.FETCH_ENTRIES_SUCCESS = name + '/FETCH_ENTRIES_SUCCESS';
	var FETCH_ENTRIES_FAILURE = exports.FETCH_ENTRIES_FAILURE = name + '/FETCH_ENTRIES_FAILURE';
	
	var PATCH_REQUEST = exports.PATCH_REQUEST = name + '/PATCH_REQUEST';
	var PATCH_SUCCESS = exports.PATCH_SUCCESS = name + '/PATCH_SUCCESS';
	var PATCH_FAILURE = exports.PATCH_FAILURE = name + '/PATCH_FAILURE';
	
	var DELETE_REQUEST = exports.DELETE_REQUEST = name + '/DELETE_REQUEST';
	var DELETE_SUCCESS = exports.DELETE_SUCCESS = name + '/DELETE_SUCCESS';
	var DELETE_FAILURE = exports.DELETE_FAILURE = name + '/DELETE_FAILURE';
	
	var POST_REQUEST = exports.POST_REQUEST = name + '/POST_REQUEST';
	var POST_SUCCESS = exports.POST_SUCCESS = name + '/POST_SUCCESS';
	var POST_OUT_OF_RANGE_SUCCESS = exports.POST_OUT_OF_RANGE_SUCCESS = name + '/POST_OUT_OF_RANGE_SUCCESS';
	var POST_FAILURE = exports.POST_FAILURE = name + '/POST_FAILURE';
	
	var SET_PERIOD = exports.SET_PERIOD = name + '/SET_PERIOD';
	
	var TABLE_VIEW = exports.TABLE_VIEW = 'TABLE_VIEW';
	var LIST_VIEW = exports.LIST_VIEW = 'LIST_VIEW';
	var VIEW_CONFIG_KEY = exports.VIEW_CONFIG_KEY = 'time.overview.viewStyle';
	var ORDERED_KEY = exports.ORDERED_KEY = 'clockCard.entries.orderedColumns';
	
	var PUNCH_REQUEST = exports.PUNCH_REQUEST = name + '/PUNCH_REQUEST';
	var PUNCH_SUCCESS = exports.PUNCH_SUCCESS = name + '/PUNCH_SUCCESS';
	var PUNCH_FAILURE = exports.PUNCH_FAILURE = name + '/PUNCH_FAILURE';
	
	var OPEN_ENTRY_REQUEST = exports.OPEN_ENTRY_REQUEST = name + '/OPEN_ENTRY_REQUEST';
	var OPEN_ENTRY_SUCCESS = exports.OPEN_ENTRY_SUCCESS = name + '/OPEN_ENTRY_SUCCESS';
	var OPEN_ENTRY_FAILURE = exports.OPEN_ENTRY_FAILURE = name + '/OPEN_ENTRY_FAILURE';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(name, 'name', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_REQUEST, 'INITIALIZE_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_SUCCESS, 'INITIALIZE_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_FAILURE, 'INITIALIZE_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ENTRIES_REQUEST, 'FETCH_ENTRIES_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ENTRIES_SUCCESS, 'FETCH_ENTRIES_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_ENTRIES_FAILURE, 'FETCH_ENTRIES_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(PATCH_REQUEST, 'PATCH_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(PATCH_SUCCESS, 'PATCH_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(PATCH_FAILURE, 'PATCH_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_REQUEST, 'DELETE_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_SUCCESS, 'DELETE_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(DELETE_FAILURE, 'DELETE_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(POST_REQUEST, 'POST_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(POST_SUCCESS, 'POST_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(POST_OUT_OF_RANGE_SUCCESS, 'POST_OUT_OF_RANGE_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(POST_FAILURE, 'POST_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(SET_PERIOD, 'SET_PERIOD', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(TABLE_VIEW, 'TABLE_VIEW', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(LIST_VIEW, 'LIST_VIEW', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(VIEW_CONFIG_KEY, 'VIEW_CONFIG_KEY', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(ORDERED_KEY, 'ORDERED_KEY', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(PUNCH_REQUEST, 'PUNCH_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(PUNCH_SUCCESS, 'PUNCH_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(PUNCH_FAILURE, 'PUNCH_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(OPEN_ENTRY_REQUEST, 'OPEN_ENTRY_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(OPEN_ENTRY_SUCCESS, 'OPEN_ENTRY_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	
	  __REACT_HOT_LOADER__.register(OPEN_ENTRY_FAILURE, 'OPEN_ENTRY_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/time/constants.js');
	}();

	;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(186);
	
	var _TransportationGrants = __webpack_require__(1015);
	
	var _TransportationGrants2 = _interopRequireDefault(_TransportationGrants);
	
	var _TransportationGrant = __webpack_require__(451);
	
	var _TransportationGrant2 = _interopRequireDefault(_TransportationGrant);
	
	var _reducer = __webpack_require__(1016);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  NAME: _constants.NAME,
	  TransportationGrants: _TransportationGrants2.default,
	  TransportationGrant: _TransportationGrant2.default,
	  reducer: _reducer2.default
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/index.js');
	}();

	;

/***/ }),
/* 293 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var name = 'vacations';
	
	var INITIALIZE_REQUEST = exports.INITIALIZE_REQUEST = name + '/INITIALIZE_REQUEST';
	var INITIALIZE_SUCCESS = exports.INITIALIZE_SUCCESS = name + '/INITIALIZE_SUCCESS';
	var INITIALIZE_FAILURE = exports.INITIALIZE_FAILURE = name + '/INITIALIZE_FAILURE';
	
	var FETCH_RECORDS_REQUEST = exports.FETCH_RECORDS_REQUEST = name + '/FETCH_RECORDS_REQUEST';
	var FETCH_RECORDS_SUCCESS = exports.FETCH_RECORDS_SUCCESS = name + '/FETCH_RECORDS_SUCCESS';
	var FETCH_RECORDS_FAILURE = exports.FETCH_RECORDS_FAILURE = name + '/FETCH_RECORDS_FAILURE';
	
	var SET_PERIOD = exports.SET_PERIOD = name + '/SET_PERIOD';
	var SET_CANCEL_TOKEN = exports.SET_CANCEL_TOKEN = name + '/SET_CANCEL_TOKEN';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(name, 'name', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/constants.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_REQUEST, 'INITIALIZE_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/constants.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_SUCCESS, 'INITIALIZE_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/constants.js');
	
	  __REACT_HOT_LOADER__.register(INITIALIZE_FAILURE, 'INITIALIZE_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECORDS_REQUEST, 'FETCH_RECORDS_REQUEST', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECORDS_SUCCESS, 'FETCH_RECORDS_SUCCESS', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/constants.js');
	
	  __REACT_HOT_LOADER__.register(FETCH_RECORDS_FAILURE, 'FETCH_RECORDS_FAILURE', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/constants.js');
	
	  __REACT_HOT_LOADER__.register(SET_PERIOD, 'SET_PERIOD', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/constants.js');
	
	  __REACT_HOT_LOADER__.register(SET_CANCEL_TOKEN, 'SET_CANCEL_TOKEN', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/constants.js');
	}();

	;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  icon: {
	    marginRight: 8,
	    color: _colors2.default.appBarTextColor
	  },
	  iconActivity: {
	    marginLeft: 8,
	    color: _colors2.default.appBarTextColor
	  },
	  checkboxRow: {
	    display: 'flex',
	    flexDirection: 'row',
	    padding: 8
	  },
	  container: {
	    margin: 16
	  },
	
	  embedContainer: {
	    padding: 24,
	    width: '100%'
	  },
	  card: {
	    maxWidth: 380,
	    minWidth: 300,
	    borderRadius: 8,
	    height: 460,
	    display: 'flex',
	    flexDirection: 'column',
	    flex: 1,
	    padding: 24,
	    paddingBottom: 24,
	    backgroundColor: 'white'
	
	  },
	  embedCard: {
	    display: 'flex',
	    flexDirection: 'column',
	    overflow: 'hidden',
	    minHeight: 400,
	    backgroundColor: 'white'
	  },
	  htmlContainer: {
	    overflowX: 'hidden',
	    overflowY: 'auto',
	    paddingBottom: 8
	  },
	  button: {
	    marginTop: 'auto',
	    alignSelf: 'flex-end'
	  },
	  dateRange: {
	    display: 'flex',
	    flexDirection: 'row',
	    alignItems: 'center',
	    marginBottom: 4
	  },
	  divider: {
	    marginTop: 16,
	    marginBottom: 16
	  },
	  details: {
	    marginTop: 12
	  },
	  detailItem: {
	    color: _colors2.default.appBarTextColor
	  },
	  detailItemValue: {
	    color: _colors2.default.titleColor,
	    marginLeft: 8
	  },
	  message: {
	    height: 'auto',
	    marginTop: 'auto'
	  }
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/styles/TransportationGrant.js');
	}();

	;

/***/ }),
/* 295 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var icon = exports.icon = '';
	
	var iconSelect = exports.iconSelect = function iconSelect(ext) {
	  if (ext.match(/\.(aif|cda|mid|mp3|mpa|ogg|wav|wma|wpl)/i)) {
	    return 'music_note';
	  } else if (ext.match(/\.(7z|arj|deb|pkg|rar|rpm|tar\.gz|z|zip)/i)) {
	    return 'layers';
	  } else if (ext.match(/\.(dmg|iso|toast|vcd)/i)) {
	    return 'album';
	  } else if (ext.match(/\.(csv|dat|dbf?|log|mdb|sav|sql|tar|xml)/i)) {
	    return 'dns';
	  } else if (ext.match(/\.(apk|bin|bat|cgi|pl|com|exe|gadget|jar|wsf)/i)) {
	    return 'build';
	  } else if (ext.match(/\.(fnt|fon|otf|ttf)/i)) {
	    return 'text_fields';
	  } else if (ext.match(/\.(ai|bmp|gif|ico|jpe?g|png|ps|psd|svg|tiff?)/i)) {
	    return 'photo';
	  } else if (ext.match(/\.(asp|cer|cfm|cgi|css|html?|jsp|part|rss|xhtml)/i)) {
	    return 'language';
	  } else if (ext.match(/\.(key|odp|pps|pptx?)/i)) {
	    return 'slideshow';
	  } else if (ext.match(/\.(c|class|cpp|cs|h|java|sh|jsx?|py|swift|vb|php)/i)) {
	    return 'code';
	  } else if (ext.match(/\.(ads|xlr|xlsx?)/i)) {
	    return 'poll';
	  } else if (ext.match(/\.(bak|cab|cfg|cpl|cur|dll|dmp|drv|icns|ico|ini|lnk|msi|sys|tmp)/i)) {
	    return 'settings';
	  } else if (ext.match(/\.(3g2|3gp|avi|flv|h264|m4v|mkv|mov|mp4|mpe?g|rm|swf|vob|wmv)/i)) {
	    return 'movie_creation';
	  } else if (ext.match(/\.(docx?|odt|pdf|rtf|tex|txt|wks|wdp)/i)) {
	    return 'description';
	  }
	  return 'insert_drive_file';
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(icon, 'icon', 'D:/a/1/s/src/web/employee/src/utils/iconSelect.js');
	
	  __REACT_HOT_LOADER__.register(iconSelect, 'iconSelect', 'D:/a/1/s/src/web/employee/src/utils/iconSelect.js');
	}();

	;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(1041);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(1040);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(1047)
	var ieee754 = __webpack_require__(1332)
	var isArray = __webpack_require__(1371)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 298 */
76,
/* 299 */
[1859, 1065],
/* 300 */
87,
/* 301 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 302 */
[1875, 120, 1079, 301, 305, 465, 1070],
/* 303 */
239,
/* 304 */
[1886, 107, 121, 75],
/* 305 */
[1887, 306, 230],
/* 306 */
[1888, 55, 106, 228],
/* 307 */
79,
/* 308 */
[1894, 152],
/* 309 */
[1895, 106, 55, 228, 310, 107],
/* 310 */
[1896, 75],
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1087);
	var global = __webpack_require__(106);
	var hide = __webpack_require__(151);
	var Iterators = __webpack_require__(153);
	var TO_STRING_TAG = __webpack_require__(75)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(243)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(43);
	var toAbsoluteIndex = __webpack_require__(130);
	var toLength = __webpack_require__(34);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1098);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 315 */
[1858, 42, 127],
/* 316 */
[1861, 28, 25],
/* 317 */
301,
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(31)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 319 */
[1864, 25],
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(28);
	var setPrototypeOf = __webpack_require__(329).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 321 */
[1867, 157, 31],
/* 322 */
[1870, 124, 127, 158, 60, 31],
/* 323 */
[1871, 109, 4, 61, 60, 157, 322, 158, 71, 31],
/* 324 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25);
	var macrotask = __webpack_require__(334).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(76)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(56);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(193);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 329 */
[1885, 28, 22, 77, 70],
/* 330 */
[1887, 196, 131],
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(236);
	var defined = __webpack_require__(87);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(79);
	var defined = __webpack_require__(87);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 333 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(77);
	var invoke = __webpack_require__(487);
	var html = __webpack_require__(319);
	var cel = __webpack_require__(316);
	var global = __webpack_require__(25);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(76)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(25);
	var DESCRIPTORS = __webpack_require__(36);
	var LIBRARY = __webpack_require__(109);
	var $typed = __webpack_require__(244);
	var hide = __webpack_require__(60);
	var redefineAll = __webpack_require__(128);
	var fails = __webpack_require__(27);
	var anInstance = __webpack_require__(122);
	var toInteger = __webpack_require__(79);
	var toLength = __webpack_require__(34);
	var toIndex = __webpack_require__(506);
	var gOPN = __webpack_require__(125).f;
	var dP = __webpack_require__(42).f;
	var arrayFill = __webpack_require__(313);
	var setToStringTag = __webpack_require__(158);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 336 */
[1895, 25, 68, 109, 507, 42],
/* 337 */
[1898, 156, 31, 157, 68],
/* 338 */
[1900, 108, 490, 157, 72, 323],
/* 339 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(751);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(1318);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(160);
	
	var _DOMUtils = __webpack_require__(247);
	
	var _DOMStateStorage = __webpack_require__(517);
	
	var _PathUtils = __webpack_require__(111);
	
	var _ExecutionEnvironment = __webpack_require__(343);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(1324);
	
	var _PathUtils = __webpack_require__(111);
	
	var _runTransitionHook = __webpack_require__(345);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(246);
	
	var _LocationUtils = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(354),
	    baseLodash = __webpack_require__(356);
	
	/** Used as references for the maximum length and index of an array. */
	var MAX_ARRAY_LENGTH = 4294967295;
	
	/**
	 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	 *
	 * @private
	 * @constructor
	 * @param {*} value The value to wrap.
	 */
	function LazyWrapper(value) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__dir__ = 1;
	  this.__filtered__ = false;
	  this.__iteratees__ = [];
	  this.__takeCount__ = MAX_ARRAY_LENGTH;
	  this.__views__ = [];
	}
	
	// Ensure `LazyWrapper` is an instance of `baseLodash`.
	LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	LazyWrapper.prototype.constructor = LazyWrapper;
	
	module.exports = LazyWrapper;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(354),
	    baseLodash = __webpack_require__(356);
	
	/**
	 * The base constructor for creating `lodash` wrapper objects.
	 *
	 * @private
	 * @param {*} value The value to wrap.
	 * @param {boolean} [chainAll] Enable explicit method chain sequences.
	 */
	function LodashWrapper(value, chainAll) {
	  this.__wrapped__ = value;
	  this.__actions__ = [];
	  this.__chain__ = !!chainAll;
	  this.__index__ = 0;
	  this.__values__ = undefined;
	}
	
	LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	LodashWrapper.prototype.constructor = LodashWrapper;
	
	module.exports = LodashWrapper;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(135),
	    root = __webpack_require__(80);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(1467),
	    mapCacheDelete = __webpack_require__(1468),
	    mapCacheGet = __webpack_require__(1469),
	    mapCacheHas = __webpack_require__(1470),
	    mapCacheSet = __webpack_require__(1471);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 352 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(164),
	    eq = __webpack_require__(201);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(63);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(1437);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 356 */
/***/ (function(module, exports) {

	/**
	 * The function whose prototype chain sequence wrappers inherit from.
	 *
	 * @private
	 */
	function baseLodash() {
	  // No operation performed.
	}
	
	module.exports = baseLodash;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(203),
	    overRest = __webpack_require__(562),
	    setToString = __webpack_require__(564);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(162),
	    arrayMap = __webpack_require__(163),
	    isArray = __webpack_require__(41),
	    isSymbol = __webpack_require__(167);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(530),
	    arrayIncludes = __webpack_require__(1389),
	    arrayIncludesWith = __webpack_require__(1390),
	    cacheHas = __webpack_require__(545),
	    createSet = __webpack_require__(1441),
	    setToArray = __webpack_require__(367);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(531);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(568),
	    overRest = __webpack_require__(562),
	    setToString = __webpack_require__(564);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(561);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(534),
	    stubArray = __webpack_require__(579);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(41),
	    isSymbol = __webpack_require__(167);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(552);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(537),
	    baseIteratee = __webpack_require__(112),
	    toInteger = __webpack_require__(267);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(164),
	    createAggregator = __webpack_require__(549);
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The corresponding value of
	 * each key is the last element responsible for generating the key. The
	 * iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * var array = [
	 *   { 'dir': 'left', 'code': 97 },
	 *   { 'dir': 'right', 'code': 100 }
	 * ];
	 *
	 * _.keyBy(array, function(o) {
	 *   return String.fromCharCode(o.code);
	 * });
	 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	 *
	 * _.keyBy(array, 'dir');
	 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	 */
	var keyBy = createAggregator(function(result, value, key) {
	  baseAssignValue(result, key, value);
	});
	
	module.exports = keyBy;


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(164),
	    baseForOwn = __webpack_require__(538),
	    baseIteratee = __webpack_require__(112);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var baseOrderBy = __webpack_require__(542),
	    isArray = __webpack_require__(41);
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	module.exports = orderBy;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.DropDownMenu = undefined;
	
	var _DropDownMenu2 = __webpack_require__(1546);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _MenuItem2 = __webpack_require__(377);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _DropDownMenu3.default;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _LinearProgress = __webpack_require__(1556);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LinearProgress2.default;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Subheader = __webpack_require__(115);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function (_Component) {
	  (0, _inherits3.default)(List, _Component);
	
	  function List() {
	    (0, _classCallCheck3.default)(this, List);
	    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var hasSubheader = false;
	
	      var firstChild = _react.Children.toArray(children)[0];
	      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
	        hasSubheader = true;
	      }
	
	      var styles = {
	        root: {
	          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return List;
	}(_react.Component);
	
	List.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	List.propTypes =  false ? {
	  /**
	   * These are usually `ListItem`s that are passed to
	   * be part of the list.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = List;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(140);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(90);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(84);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _IconButton = __webpack_require__(64);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _expandLess = __webpack_require__(1618);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(1619);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _NestedList = __webpack_require__(1557);
	
	var _NestedList2 = _interopRequireDefault(_NestedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var autoGenerateNestedIndicator = props.autoGenerateNestedIndicator,
	      insetChildren = props.insetChildren,
	      leftAvatar = props.leftAvatar,
	      leftCheckbox = props.leftCheckbox,
	      leftIcon = props.leftIcon,
	      nestedItems = props.nestedItems,
	      nestedLevel = props.nestedLevel,
	      rightAvatar = props.rightAvatar,
	      rightIcon = props.rightIcon,
	      rightIconButton = props.rightIconButton,
	      rightToggle = props.rightToggle,
	      secondaryText = props.secondaryText,
	      secondaryTextLines = props.secondaryTextLines;
	  var muiTheme = context.muiTheme;
	  var listItem = muiTheme.listItem;
	
	
	  var textColor = muiTheme.baseTheme.palette.textColor;
	  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
	  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	  var twoLine = secondaryText && secondaryTextLines === 1;
	  var threeLine = secondaryText && secondaryTextLines > 1;
	
	  var isKeyboardFocused = (props.isKeyboardFocused !== undefined ? props : state).isKeyboardFocused;
	
	  var styles = {
	    root: {
	      backgroundColor: (isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
	      color: textColor,
	      display: 'block',
	      fontSize: 16,
	      lineHeight: '16px',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	
	    // This inner div is needed so that ripples will span the entire container
	    innerDiv: {
	      marginLeft: nestedLevel * listItem.nestedLevelDepth,
	      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	      paddingRight: rightIcon || rightAvatar || rightIconButton || nestedItems.length && autoGenerateNestedIndicator ? 56 : rightToggle ? 72 : 16,
	      paddingBottom: singleAvatar ? 20 : 16,
	      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	      position: 'relative'
	    },
	
	    icons: {
	      height: 24,
	      width: 24,
	      display: 'block',
	      position: 'absolute',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      margin: 12
	    },
	
	    leftIcon: {
	      left: 4
	    },
	
	    rightIcon: {
	      right: 4
	    },
	
	    avatars: {
	      position: 'absolute',
	      top: singleAvatar ? 8 : 16
	    },
	
	    label: {
	      cursor: 'pointer'
	    },
	
	    leftAvatar: {
	      left: 16
	    },
	
	    rightAvatar: {
	      right: 16
	    },
	
	    leftCheckbox: {
	      position: 'absolute',
	      display: 'block',
	      width: 24,
	      top: twoLine ? 24 : singleAvatar ? 16 : 12,
	      left: 16
	    },
	
	    primaryText: {},
	
	    rightIconButton: {
	      position: 'absolute',
	      display: 'block',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      right: 4
	    },
	
	    rightToggle: {
	      position: 'absolute',
	      display: 'block',
	      width: 54,
	      top: twoLine ? 25 : singleAvatar ? 17 : 13,
	      right: 8
	    },
	
	    secondaryText: {
	      fontSize: 14,
	      lineHeight: threeLine ? '18px' : '16px',
	      height: threeLine ? 36 : 16,
	      margin: 0,
	      marginTop: 4,
	      color: listItem.secondaryTextColor,
	
	      // needed for 2 and 3 line ellipsis
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: threeLine ? null : 'nowrap',
	      display: threeLine ? '-webkit-box' : null,
	      WebkitLineClamp: threeLine ? 2 : null,
	      WebkitBoxOrient: threeLine ? 'vertical' : null
	    }
	  };
	
	  return styles;
	}
	
	var ListItem = function (_Component) {
	  (0, _inherits3.default)(ListItem, _Component);
	
	  function ListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: false,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	
	      if (_this.props.primaryTogglesNestedList) {
	        _this.handleNestedListToggle(event);
	      }
	    }, _this.handleNestedListToggle = function (event) {
	      if (_this.props.leftCheckbox) {
	        event.preventDefault();
	      }
	      event.stopPropagation();
	
	      if (_this.props.open === null) {
	        _this.setState({ open: !_this.state.open }, function () {
	          _this.props.onNestedListToggle(_this);
	        });
	      } else {
	        // Exposing `this` in the callback is quite a bad API.
	        // I'm doing a one level deep clone to expose a fake state.open.
	        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
	          state: {
	            open: !_this.state.open
	          }
	        }));
	      }
	    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
	      if (isKeyboardFocused) {
	        _this.setState({
	          isKeyboardFocused: false,
	          rightIconButtonKeyboardFocused: isKeyboardFocused
	        });
	      }
	
	      var iconButton = _this.props.rightIconButton;
	
	      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleRightIconButtonMouseLeave = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: false });
	      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
	    }, _this.handleRightIconButtonMouseEnter = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: true });
	      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
	    }, _this.handleRightIconButtonMouseUp = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
	    }, _this.handleRightIconButtonClick = function (event) {
	      var iconButton = _this.props.rightIconButton;
	
	      // Stop the event from bubbling up to the list-item
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onClick) iconButton.props.onClick(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchEnd(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.open !== null) this.setState({ open: nextProps.open });
	      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	
	    // This method is needed by the `MenuItem` component.
	
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState(focusState) {
	      if (this.button) {
	        var buttonEl = _reactDom2.default.findDOMNode(this.button);
	
	        switch (focusState) {
	          case 'none':
	            buttonEl.blur();
	            break;
	          case 'focused':
	            buttonEl.focus();
	            break;
	          case 'keyboard-focused':
	            this.button.setKeyboardFocus();
	            buttonEl.focus();
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'createDisabledElement',
	    value: function createDisabledElement(styles, contentChildren, additionalProps) {
	      var _props = this.props,
	          innerDivStyle = _props.innerDivStyle,
	          style = _props.style;
	
	
	      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createLabelElement',
	    value: function createLabelElement(styles, contentChildren, additionalProps) {
	      var _props2 = this.props,
	          innerDivStyle = _props2.innerDivStyle,
	          style = _props2.style;
	
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	      return _react2.default.createElement(
	        'label',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createTextElement',
	    value: function createTextElement(styles, data, key) {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      if (_react2.default.isValidElement(data)) {
	        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
	        if (typeof data.type === 'string') {
	          // if element is a native dom node
	          style = prepareStyles(style);
	        }
	        return _react2.default.cloneElement(data, {
	          key: key,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: prepareStyles(styles) },
	        data
	      );
	    }
	  }, {
	    key: 'pushElement',
	    value: function pushElement(children, element, baseStyles, additionalProps) {
	      if (element) {
	        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
	        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
	          key: children.length,
	          style: styles
	        }, additionalProps)));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          hoverColor = _props3.hoverColor,
	          initiallyOpen = _props3.initiallyOpen,
	          innerDivStyle = _props3.innerDivStyle,
	          insetChildren = _props3.insetChildren,
	          leftAvatar = _props3.leftAvatar,
	          leftCheckbox = _props3.leftCheckbox,
	          leftIcon = _props3.leftIcon,
	          nestedItems = _props3.nestedItems,
	          nestedLevel = _props3.nestedLevel,
	          nestedListStyle = _props3.nestedListStyle,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          isKeyboardFocused = _props3.isKeyboardFocused,
	          onMouseEnter = _props3.onMouseEnter,
	          onMouseLeave = _props3.onMouseLeave,
	          onNestedListToggle = _props3.onNestedListToggle,
	          onTouchStart = _props3.onTouchStart,
	          onClick = _props3.onClick,
	          rightAvatar = _props3.rightAvatar,
	          rightIcon = _props3.rightIcon,
	          rightIconButton = _props3.rightIconButton,
	          rightToggle = _props3.rightToggle,
	          primaryText = _props3.primaryText,
	          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
	          secondaryText = _props3.secondaryText,
	          secondaryTextLines = _props3.secondaryTextLines,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'containerElement', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'isKeyboardFocused', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onClick', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var contentChildren = [children];
	
	      if (leftIcon) {
	        var additionalProps = {
	          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
	        };
	        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
	      }
	
	      if (rightIcon) {
	        var _additionalProps = {
	          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
	        };
	        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
	      }
	
	      if (leftAvatar) {
	        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
	      }
	
	      if (rightAvatar) {
	        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
	      }
	
	      if (leftCheckbox) {
	        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
	      }
	
	      // RightIconButtonElement
	      var hasNestListItems = nestedItems.length;
	      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	      if (rightIconButton || needsNestedIndicator) {
	        var rightIconButtonElement = rightIconButton;
	        var rightIconButtonHandlers = {
	          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
	          onMouseEnter: this.handleRightIconButtonMouseEnter,
	          onMouseLeave: this.handleRightIconButtonMouseLeave,
	          onClick: this.handleRightIconButtonClick,
	          onMouseDown: this.handleRightIconButtonMouseUp,
	          onMouseUp: this.handleRightIconButtonMouseUp
	        };
	
	        // Create a nested list indicator icon if we don't have an icon on the right
	        if (needsNestedIndicator) {
	          rightIconButtonElement = this.state.open ? _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandLess2.default, null)
	          ) : _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandMore2.default, null)
	          );
	          rightIconButtonHandlers.onClick = this.handleNestedListToggle;
	        }
	
	        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
	      }
	
	      if (rightToggle) {
	        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
	      }
	
	      if (primaryText) {
	        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
	        contentChildren.push(primaryTextElement);
	      }
	
	      if (secondaryText) {
	        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	        contentChildren.push(secondaryTextElement);
	      }
	
	      var nestedList = nestedItems.length ? _react2.default.createElement(
	        _NestedList2.default,
	        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
	        nestedItems
	      ) : undefined;
	
	      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({
	            containerElement: containerElement
	          }, other, {
	            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	            onKeyboardFocus: this.handleKeyboardFocus,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseEnter: this.handleMouseEnter,
	            onTouchStart: this.handleTouchStart,
	            onTouchEnd: this.handleTouchEnd,
	            onClick: this.handleClick,
	            disabled: disabled,
	            ref: function ref(node) {
	              return _this2.button = node;
	            },
	            style: (0, _simpleAssign2.default)({}, styles.root, style)
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
	            contentChildren
	          )
	        ),
	        nestedList
	      );
	    }
	  }]);
	  return ListItem;
	}(_react.Component);
	
	ListItem.muiName = 'ListItem';
	ListItem.defaultProps = {
	  autoGenerateNestedIndicator: true,
	  containerElement: 'span',
	  disableKeyboardFocus: false,
	  disabled: false,
	  initiallyOpen: false,
	  insetChildren: false,
	  nestedItems: [],
	  nestedLevel: 0,
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onNestedListToggle: function onNestedListToggle() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {},
	  open: null,
	  primaryTogglesNestedList: false,
	  secondaryTextLines: 1
	};
	ListItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ListItem.propTypes =  false ? {
	  /**
	   * If true, generate a nested-list-indicator icon when nested list
	   * items are detected. Note that an indicator will not be created
	   * if a `rightIcon` or `rightIconButton` has been provided to
	   * the element.
	   */
	  autoGenerateNestedIndicator: _propTypes2.default.bool,
	  /**
	   * Children passed into the `ListItem`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The element to use as the container for the ListItem. Either a string to
	   * use a DOM element or a ReactElement. This is useful for wrapping the
	   * ListItem in a custom Link component. If a ReactElement is given, ensure
	   * that it passes all of its given props through to the underlying DOM
	   * element and renders its children prop for proper integration.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element will not be able to be focused by the keyboard.
	   */
	  disableKeyboardFocus: _propTypes2.default.bool,
	  /**
	   * If true, the element will not be clickable
	   * and will not display hover effects.
	   * This is automatically disabled if either `leftCheckbox`
	   * or `rightToggle` is set.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	  * Override the hover background color.
	  */
	  hoverColor: _propTypes2.default.string,
	  /**
	   * If true, the nested `ListItem`s are initially displayed.
	   */
	  initiallyOpen: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the inner div element.
	   */
	  innerDivStyle: _propTypes2.default.object,
	  /**
	   * If true, the children will be indented by 72px.
	   * This is useful if there is no left avatar or left icon.
	   */
	  insetChildren: _propTypes2.default.bool,
	  /**
	   * Use to control if the list item should render as keyboard focused.  If
	   * undefined (default), this will be automatically managed.  If provided,
	   * it will change the components style.  Note that this will not change the
	   * actual focus - and should only be used when you want to simulate
	   * keyboard focus (eg. in a rich text input autocomplete).
	   */
	  isKeyboardFocused: _propTypes2.default.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the left side.
	   */
	  leftAvatar: _propTypes2.default.element,
	  /**
	   * This is the `Checkbox` element to be displayed on the left side.
	   */
	  leftCheckbox: _propTypes2.default.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _propTypes2.default.element,
	  /**
	   * An array of `ListItem`s to nest underneath the current `ListItem`.
	   */
	  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.element),
	  /**
	   * Controls how deep a `ListItem` appears.
	   * This property is automatically managed, so modify at your own risk.
	   */
	  nestedLevel: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the nested items' `NestedList`.
	   */
	  nestedListStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the list item is clicked.
	   *
	   * @param {object} event Click event targeting the list item.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
	   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `ListItem` toggles its nested list.
	   *
	   * @param {object} listItem The `ListItem`.
	   */
	  onNestedListToggle: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Control toggle state of nested list.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * This is the block element that contains the primary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  primaryText: _propTypes2.default.node,
	  /**
	   * If true, clicking or tapping the primary text of the `ListItem`
	   * toggles the nested list.
	   */
	  primaryTogglesNestedList: _propTypes2.default.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the right side.
	   */
	  rightAvatar: _propTypes2.default.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _propTypes2.default.element,
	  /**
	   * This is the `IconButton` to be displayed on the right side.
	   * Hovering over this button will remove the `ListItem` hover.
	   * Also, clicking on this button will not trigger a
	   * ripple on the `ListItem`; the event will be stopped and prevented
	   * from bubbling up to cause a `ListItem` click.
	   */
	  rightIconButton: _propTypes2.default.element,
	  /**
	   * This is the `Toggle` element to display on the right side.
	   */
	  rightToggle: _propTypes2.default.element,
	  /**
	   * This is the block element that contains the secondary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  secondaryText: _propTypes2.default.node,
	  /**
	   * Can be 1 or 2. This is the number of secondary
	   * text lines before ellipsis will show.
	   */
	  secondaryTextLines: _propTypes2.default.oneOf([1, 2]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ListItem;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(140);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Popover = __webpack_require__(174);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _check = __webpack_require__(1615);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ListItem = __webpack_require__(376);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(270);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	function getStyles(props, context) {
	  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
	  var textColor = context.muiTheme.baseTheme.palette.textColor;
	  var indent = props.desktop ? 64 : 72;
	  var sidePadding = props.desktop ? 24 : 16;
	
	  var styles = {
	    root: {
	      color: props.disabled ? disabledColor : textColor,
	      cursor: props.disabled ? 'default' : 'pointer',
	      minHeight: props.desktop ? '32px' : '48px',
	      lineHeight: props.desktop ? '32px' : '48px',
	      fontSize: props.desktop ? 15 : 16,
	      whiteSpace: 'nowrap'
	    },
	
	    innerDivStyle: {
	      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
	      paddingRight: props.rightIcon ? indent : sidePadding,
	      paddingBottom: 0,
	      paddingTop: 0
	    },
	
	    secondaryText: {
	      float: 'right'
	    },
	
	    leftIconDesktop: {
	      margin: 0,
	      left: 24,
	      top: 4
	    },
	
	    rightIconDesktop: {
	      margin: 0,
	      right: 24,
	      top: 4,
	      fill: context.muiTheme.menuItem.rightIconDesktopFill
	    }
	  };
	
	  return styles;
	}
	
	var MenuItem = function (_Component) {
	  (0, _inherits3.default)(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.cloneMenuItem = function (item) {
	      return _react2.default.cloneElement(item, {
	        onClick: function onClick(event) {
	          if (!item.props.menuItems) {
	            _this.handleRequestClose();
	          }
	
	          if (item.props.onClick) {
	            item.props.onClick(event);
	          }
	        }
	      });
	    }, _this.handleClick = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this)
	      });
	
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _this.handleRequestClose = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.focusState === 'none') {
	        this.handleRequestClose();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState() {
	      this.refs.listItem.applyFocusState(this.props.focusState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          children = _props.children,
	          desktop = _props.desktop,
	          disabled = _props.disabled,
	          focusState = _props.focusState,
	          innerDivStyle = _props.innerDivStyle,
	          insetChildren = _props.insetChildren,
	          leftIcon = _props.leftIcon,
	          menuItems = _props.menuItems,
	          rightIcon = _props.rightIcon,
	          secondaryText = _props.secondaryText,
	          style = _props.style,
	          animation = _props.animation,
	          anchorOrigin = _props.anchorOrigin,
	          targetOrigin = _props.targetOrigin,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'anchorOrigin', 'targetOrigin', 'value']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);
	
	      // Left Icon
	      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
	      if (leftIconElement) {
	        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
	        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	      }
	
	      // Right Icon
	      var rightIconElement = void 0;
	      if (rightIcon) {
	        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	      }
	
	      // Secondary Text
	      var secondaryTextElement = void 0;
	      if (secondaryText) {
	        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;
	
	        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.secondaryText) },
	          secondaryText
	        );
	      }
	      var childMenuPopover = void 0;
	      if (menuItems) {
	        childMenuPopover = _react2.default.createElement(
	          _Popover2.default,
	          {
	            animation: animation,
	            anchorOrigin: anchorOrigin,
	            anchorEl: this.state.anchorEl,
	            open: this.state.open,
	            targetOrigin: targetOrigin,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	            _react2.default.Children.map(menuItems, this.cloneMenuItem)
	          )
	        );
	        other.onClick = this.handleClick;
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          hoverColor: this.context.muiTheme.menuItem.hoverColor,
	          innerDivStyle: mergedInnerDivStyles,
	          insetChildren: insetChildren,
	          leftIcon: leftIconElement,
	          ref: 'listItem',
	          rightIcon: rightIconElement,
	          role: 'menuitem',
	          style: mergedRootStyles
	        }),
	        children,
	        secondaryTextElement,
	        childMenuPopover
	      );
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	MenuItem.muiName = 'MenuItem';
	MenuItem.defaultProps = {
	  anchorOrigin: { horizontal: 'right', vertical: 'top' },
	  checked: false,
	  desktop: false,
	  disabled: false,
	  focusState: 'none',
	  insetChildren: false,
	  targetOrigin: { horizontal: 'left', vertical: 'top' }
	};
	MenuItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	MenuItem.propTypes =  false ? {
	  /**
	   * Location of the anchor for the popover of nested `MenuItem`
	   * elements.
	   * Options:
	   * horizontal: [left, middle, right]
	   * vertical: [top, center, bottom].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * If true, a left check mark will be rendered.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * Elements passed as children to the underlying `ListItem`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   * If true, the menu item will render with compact desktop
	   * styles.
	   */
	  desktop: _propTypes2.default.bool,
	  /**
	   * If true, the menu item will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The focus state of the menu item. This prop is used to set the focus
	   * state of the underlying `ListItem`.
	   */
	  focusState: _propTypes2.default.oneOf(['none', 'focused', 'keyboard-focused']),
	  /**
	   * Override the inline-styles of the inner div.
	   */
	  innerDivStyle: _propTypes2.default.object,
	  /**
	   * If true, the children will be indented.
	   * This is only needed when there is no `leftIcon`.
	   */
	  insetChildren: _propTypes2.default.bool,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _propTypes2.default.element,
	  /**
	   * `MenuItem` elements to nest within the menu item.
	   */
	  menuItems: _propTypes2.default.node,
	  /**
	   * Callback function fired when the menu item is clicked.
	   *
	   * @param {object} event Click event targeting the menu item.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Can be used to render primary text within the menu item.
	   */
	  primaryText: _propTypes2.default.node,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _propTypes2.default.element,
	  /**
	   * Can be used to render secondary text within the menu item.
	   */
	  secondaryText: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Location on the popover of nested `MenuItem` elements that will attach
	   * to the anchor's origin.
	   * Options:
	   * horizontal: [left, middle, right]
	   * vertical: [top, center, bottom].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * The value of the menu item.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = MenuItem;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'center');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    }
	  };
	}
	
	var PopoverAnimationVertical = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationVertical, _Component);
	
	  function PopoverAnimationVertical() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationVertical, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        this.props.children
	      );
	    }
	  }]);
	  return PopoverAnimationVertical;
	}(_react.Component);
	
	PopoverAnimationVertical.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationVertical.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	PopoverAnimationVertical.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  targetOrigin: _propTypes4.default.origin.isRequired,
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = PopoverAnimationVertical;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Tooltip = __webpack_require__(617);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeaderColumn = context.muiTheme.tableHeaderColumn;
	
	
	  return {
	    root: {
	      fontWeight: 'normal',
	      fontSize: 12,
	      paddingLeft: tableHeaderColumn.spacing,
	      paddingRight: tableHeaderColumn.spacing,
	      height: tableHeaderColumn.height,
	      textAlign: 'left',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis',
	      color: tableHeaderColumn.textColor,
	      position: 'relative'
	    },
	    tooltip: {
	      boxSizing: 'border-box',
	      marginTop: tableHeaderColumn.height / 2
	    }
	  };
	}
	
	var TableHeaderColumn = function (_Component) {
	  (0, _inherits3.default)(TableHeaderColumn, _Component);
	
	  function TableHeaderColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeaderColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeaderColumn.__proto__ || (0, _getPrototypeOf2.default)(TableHeaderColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onMouseEnter = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: true });
	      }
	    }, _this.onMouseLeave = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: false });
	      }
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeaderColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipStyle = _props.tooltipStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style', 'tooltip', 'tooltipStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave,
	        onClick: this.onClick
	      };
	
	      var tooltipNode = void 0;
	
	      if (tooltip !== undefined) {
	        tooltipNode = _react2.default.createElement(_Tooltip2.default, {
	          label: tooltip,
	          show: this.state.hovered,
	          style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyle)
	        });
	      }
	
	      return _react2.default.createElement(
	        'th',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        tooltipNode,
	        children
	      );
	    }
	  }]);
	  return TableHeaderColumn;
	}(_react.Component);
	
	TableHeaderColumn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableHeaderColumn.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _propTypes2.default.number,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  hoverable: _propTypes2.default.bool,
	  /** @ignore */
	  onClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHoverExit: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The string to supply to the tooltip. If not
	   * string is supplied no tooltip will be shown.
	   */
	  tooltip: _propTypes2.default.string,
	  /**
	   * Additional styling that can be applied to the tooltip.
	   */
	  tooltipStyle: _propTypes2.default.object
	} : {};
	exports.default = TableHeaderColumn;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(274);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	  return false;
	};
	
	var clickAwayEvents = ['mouseup', 'touchend'];
	var bind = function bind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.on(document, event, callback);
	  });
	};
	var unbind = function unbind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.off(document, event, callback);
	  });
	};
	
	var ClickAwayListener = function (_Component) {
	  (0, _inherits3.default)(ClickAwayListener, _Component);
	
	  function ClickAwayListener() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      // IE11 support, which trigger the handleClickAway even after the unbind
	      if (_this.isCurrentlyMounted) {
	        var el = _reactDom2.default.findDOMNode(_this);
	
	        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClickAwayListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isCurrentlyMounted = true;
	      if (this.props.onClickAway) {
	        bind(this.handleClickAway);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.onClickAway !== this.props.onClickAway) {
	        unbind(this.handleClickAway);
	        if (this.props.onClickAway) {
	          bind(this.handleClickAway);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isCurrentlyMounted = false;
	      unbind(this.handleClickAway);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.Component);
	
	ClickAwayListener.propTypes =  false ? {
	  children: _propTypes2.default.element,
	  onClickAway: _propTypes2.default.func
	} : {};
	exports.default = ClickAwayListener;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(100);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(73);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(382);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(618);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      position: 'relative',
	      overflow: 'visible',
	      display: 'table',
	      height: 'auto',
	      width: '100%'
	    },
	    input: {
	      position: 'absolute',
	      cursor: 'inherit',
	      pointerEvents: 'all',
	      opacity: 0,
	      width: '100%',
	      height: '100%',
	      zIndex: 2,
	      left: 0,
	      boxSizing: 'border-box',
	      padding: 0,
	      margin: 0
	    },
	    controls: {
	      display: 'flex',
	      width: '100%',
	      height: '100%'
	    },
	    label: {
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      width: 'calc(100% - 60px)',
	      lineHeight: '24px',
	      color: baseTheme.palette.textColor,
	      fontFamily: baseTheme.fontFamily
	    },
	    wrap: {
	      transition: _transitions2.default.easeOut(),
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      flexShrink: 0,
	      width: 60 - baseTheme.spacing.desktopGutterLess,
	      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
	    },
	    ripple: {
	      color: props.rippleColor || baseTheme.palette.primary1Color,
	      height: '200%',
	      width: '200%',
	      top: -12,
	      left: -12
	    }
	  };
	}
	
	var EnhancedSwitch = function (_Component) {
	  (0, _inherits3.default)(EnhancedSwitch, _Component);
	
	  function EnhancedSwitch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedSwitch.__proto__ || (0, _getPrototypeOf2.default)(EnhancedSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleChange = function (event) {
	      _this.tabPressed = false;
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      var isInputChecked = _this.refs.checkbox.checked;
	
	      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
	        _this.props.onParentShouldUpdate(isInputChecked);
	      }
	
	      if (_this.props.onSwitch) {
	        _this.props.onSwitch(event, isInputChecked);
	      }
	    }, _this.handleKeyDown = function (event) {
	      var code = (0, _keycode2.default)(event);
	
	      if (code === 'tab') {
	        _this.tabPressed = true;
	      }
	      if (_this.state.isKeyboardFocused && code === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.refs.touchRipple.start(event);
	      }
	    }, _this.handleMouseUp = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleMouseLeave = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleTouchStart = function (event) {
	      _this.refs.touchRipple.start(event);
	    }, _this.handleTouchEnd = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      // setTimeout is needed becuase the focus event fires first
	      // Wait so that we can capture if this was a keyboard focus
	      // or touch focus
	      setTimeout(function () {
	        if (_this.tabPressed) {
	          _this.setState({
	            isKeyboardFocused: true
	          });
	        }
	      }, 150);
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedSwitch, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.componentWillReceiveProps(this.props);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var inputNode = this.refs.checkbox;
	      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
	        this.props.onParentShouldUpdate(inputNode.checked);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hasCheckedProp = nextProps.hasOwnProperty('checked');
	      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;
	
	      if (hasCheckedProp || hasNewDefaultProp) {
	        var switched = nextProps.checked || nextProps.defaultChecked || false;
	
	        this.setState({
	          switched: switched
	        });
	
	        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
	          this.props.onParentShouldUpdate(switched);
	        }
	      }
	    }
	  }, {
	    key: 'isSwitched',
	    value: function isSwitched() {
	      return this.refs.checkbox.checked;
	    }
	
	    // no callback here because there is no event
	
	  }, {
	    key: 'setSwitched',
	    value: function setSwitched(newSwitchedValue) {
	      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
	        if (this.props.onParentShouldUpdate) {
	          this.props.onParentShouldUpdate(newSwitchedValue);
	        }
	        this.refs.checkbox.checked = newSwitchedValue;
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot call set method while checked is defined as a property.') : void 0;
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.checkbox.value;
	    }
	
	    // Checkbox inputs only use SPACE to change their state. Using ENTER will
	    // update the ui but not the input.
	
	
	    /**
	     * Because both the ripples and the checkbox input cannot share pointer
	     * events, the checkbox input takes control of pointer events and calls
	     * ripple animations manually.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          value = _props.value,
	          checked = _props.checked,
	          iconStyle = _props.iconStyle,
	          inputStyle = _props.inputStyle,
	          inputType = _props.inputType,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onSwitch = _props.onSwitch,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onParentShouldUpdate = _props.onParentShouldUpdate,
	          disabled = _props.disabled,
	          disableTouchRipple = _props.disableTouchRipple,
	          disableFocusRipple = _props.disableFocusRipple,
	          className = _props.className,
	          rippleColor = _props.rippleColor,
	          rippleStyle = _props.rippleStyle,
	          style = _props.style,
	          switched = _props.switched,
	          switchElement = _props.switchElement,
	          thumbStyle = _props.thumbStyle,
	          trackStyle = _props.trackStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'checked', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
	      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	      if (thumbStyle) {
	        wrapStyles.marginLeft /= 2;
	        wrapStyles.marginRight /= 2;
	      }
	
	      var labelElement = label && _react2.default.createElement(
	        'label',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var showTouchRipple = !disabled && !disableTouchRipple;
	      var showFocusRipple = !disabled && !disableFocusRipple;
	
	      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
	        ref: 'touchRipple',
	        key: 'touchRipple',
	        style: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        centerRipple: true
	      });
	
	      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
	        key: 'focusRipple',
	        innerStyle: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        show: this.state.isKeyboardFocused
	      });
	
	      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];
	
	      var touchHandlers = showTouchRipple ? {
	        onMouseUp: this.handleMouseUp,
	        onMouseDown: this.handleMouseDown,
	        onMouseLeave: this.handleMouseLeave,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd
	      } : {};
	
	      var inputElement = _react2.default.createElement('input', (0, _extends3.default)({}, other, {
	        ref: 'checkbox',
	        type: inputType,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
	        name: name,
	        value: value,
	        checked: this.state.switched,
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onChange: this.handleChange
	      }, touchHandlers));
	
	      // If toggle component (indicated by whether the style includes thumb) manually lay out
	      // elements in order to nest ripple elements
	      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        switchElement,
	        ripples
	      ) : _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: thumbStyle, zDepth: 1, circle: true },
	          ' ',
	          ripples,
	          ' '
	        )
	      );
	
	      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        switchOrThumbElement,
	        labelElement
	      ) : _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        labelElement,
	        switchOrThumbElement
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp
	        }),
	        inputElement,
	        elementsInOrder
	      );
	    }
	  }]);
	  return EnhancedSwitch;
	}(_react.Component);
	
	EnhancedSwitch.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	EnhancedSwitch.propTypes =  false ? {
	  checked: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  defaultChecked: _propTypes2.default.bool,
	  disableFocusRipple: _propTypes2.default.bool,
	  disableTouchRipple: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  iconStyle: _propTypes2.default.object,
	  inputStyle: _propTypes2.default.object,
	  inputType: _propTypes2.default.string.isRequired,
	  label: _propTypes2.default.node,
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  labelStyle: _propTypes2.default.object,
	  name: _propTypes2.default.string,
	  onBlur: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onParentShouldUpdate: _propTypes2.default.func,
	  onSwitch: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onTouchStart: _propTypes2.default.func,
	  rippleColor: _propTypes2.default.string,
	  rippleStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  switchElement: _propTypes2.default.element.isRequired,
	  switched: _propTypes2.default.bool.isRequired,
	  thumbStyle: _propTypes2.default.object,
	  trackStyle: _propTypes2.default.object,
	  value: _propTypes2.default.any
	} : {};
	exports.default = EnhancedSwitch;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(140);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(137);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ScaleIn = __webpack_require__(1603);
	
	var _ScaleIn2 = _interopRequireDefault(_ScaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = function (_Component) {
	  (0, _inherits3.default)(FocusRipple, _Component);
	
	  function FocusRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FocusRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
	      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
	      if (!innerCircle) return;
	
	      var startScale = 'scale(1)';
	      var endScale = 'scale(0.85)';
	      var currentScale = innerCircle.style.transform || startScale;
	      var nextScale = currentScale === startScale ? endScale : startScale;
	
	      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
	      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FocusRipple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      } else {
	        if (this.timeout) clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'getRippleElement',
	    value: function getRippleElement(props) {
	      var color = props.color,
	          innerStyle = props.innerStyle,
	          opacity = props.opacity;
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          ripple = _context$muiTheme.ripple;
	
	
	      var innerStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        opacity: opacity ? opacity : 0.16,
	        backgroundColor: color || ripple.color,
	        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	      }, innerStyle);
	
	      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	      var height = el.offsetHeight;
	      var width = el.offsetWidth;
	      var size = Math.max(height, width);
	
	      var oldTop = 0;
	      // For browsers that don't support endsWith()
	      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	        oldTop = parseInt(el.style.top);
	      }
	      el.style.height = size + 'px';
	      el.style.top = height / 2 - size / 2 + oldTop + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          style = _props.style;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0
	      }, style);
	
	      var ripple = show ? this.getRippleElement(this.props) : null;
	
	      return _react2.default.createElement(
	        _ScaleIn2.default,
	        {
	          maxScale: 0.85,
	          style: mergedRootStyles
	        },
	        ripple
	      );
	    }
	  }]);
	  return FocusRipple;
	}(_react.Component);
	
	FocusRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FocusRipple.propTypes =  false ? {
	  color: _propTypes2.default.string,
	  innerStyle: _propTypes2.default.object,
	  opacity: _propTypes2.default.number,
	  show: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	} : {};
	exports.default = FocusRipple;

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(214);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _SlideInChild = __webpack_require__(1605);
	
	var _SlideInChild2 = _interopRequireDefault(_SlideInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideIn = function (_Component) {
	  (0, _inherits3.default)(SlideIn, _Component);
	
	  function SlideIn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SlideIn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlideIn.__proto__ || (0, _getPrototypeOf2.default)(SlideIn)).call.apply(_ref, [this].concat(args))), _this), _this.getLeaveDirection = function () {
	      return _this.props.direction;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SlideIn, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          direction = _props.direction,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _SlideInChild2.default,
	          {
	            key: child.key,
	            direction: direction,
	            enterDelay: enterDelay,
	            getLeaveDirection: _this2.getLeaveDirection,
	            style: childStyle
	          },
	          child
	        );
	      }, this);
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return SlideIn;
	}(_react.Component);
	
	SlideIn.defaultProps = {
	  enterDelay: 0,
	  direction: 'left'
	};
	SlideIn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SlideIn.propTypes =  false ? {
	  childStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  direction: _propTypes2.default.oneOf(['left', 'right', 'up', 'down']),
	  enterDelay: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : {};
	exports.default = SlideIn;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
	(function() {
	  var getNanoSeconds, hrtime, loadTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - loadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    loadTime = getNanoSeconds();
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)))

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(1642)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getClass;
	
	var _flexboxgrid = __webpack_require__(1837);
	
	var _flexboxgrid2 = _interopRequireDefault(_flexboxgrid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getClass(className) {
	  return _flexboxgrid2.default && _flexboxgrid2.default[className] ? _flexboxgrid2.default[className] : className;
	}

/***/ }),
/* 387 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createProps;
	function createProps(propTypes, props, classNames) {
	  var newProps = {};
	
	  Object.keys(props).filter(function (key) {
	    return key === 'children' || !propTypes[key];
	  }).forEach(function (key) {
	    return newProps[key] = props[key];
	  });
	
	  var className = classNames.filter(function (cn) {
	    return cn;
	  }).join(' ');
	  return Object.assign({}, newProps, { className: className });
	}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	
	'use strict'
	
	if (true) {
	  module.exports = __webpack_require__(1656)
	} else {
	  module.exports = require('./index.ie11.development.js')
	}


/***/ }),
/* 389 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = undefined;
	
	var _exenv = __webpack_require__(1316);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EE = _exenv2.default;
	
	var SafeHTMLElement = EE.canUseDOM ? window.HTMLElement : {};
	
	var canUseDOM = exports.canUseDOM = EE.canUseDOM;
	
	exports.default = SafeHTMLElement;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Modal = __webpack_require__(1667);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Modal2.default;
	module.exports = exports["default"];

/***/ }),
/* 392 */
/***/ (function(module, exports) {

	
	
	// currently used to initiate the velocity style object to 0
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mapToZero;
	
	function mapToZero(obj) {
	  var ret = {};
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      ret[key] = 0;
	    }
	  }
	  return ret;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 393 */
/***/ (function(module, exports) {

	
	
	// usage assumption: currentStyle values have already been rendered but it says
	// nothing of whether currentStyle is stale (see unreadPropStyle)
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldStopAnimation;
	
	function shouldStopAnimation(currentStyle, style, currentVelocity) {
	  for (var key in style) {
	    if (!Object.prototype.hasOwnProperty.call(style, key)) {
	      continue;
	    }
	
	    if (currentVelocity[key] !== 0) {
	      return false;
	    }
	
	    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
	    // stepper will have already taken care of rounding precision errors, so
	    // won't have such thing as 0.9999 !=== 1
	    if (currentStyle[key] !== styleValue) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ }),
/* 394 */
/***/ (function(module, exports) {

	
	
	// stepper is used a lot. Saves allocation to return the same array wrapper.
	// This is fine and danger-free against mutations because the callsite
	// immediately destructures it and gets the numbers inside without passing the
	"use strict";
	
	exports.__esModule = true;
	exports["default"] = stepper;
	
	var reusedTuple = [0, 0];
	
	function stepper(secondPerFrame, x, v, destX, k, b, precision) {
	  // Spring stiffness, in kg / s^2
	
	  // for animations, destX is really spring length (spring at rest). initial
	  // position is considered as the stretched/compressed position of a spring
	  var Fspring = -k * (x - destX);
	
	  // Damping, in kg / s
	  var Fdamper = -b * v;
	
	  // usually we put mass here, but for animation purposes, specifying mass is a
	  // bit redundant. you could simply adjust k and b accordingly
	  // let a = (Fspring + Fdamper) / mass;
	  var a = Fspring + Fdamper;
	
	  var newV = v + a * secondPerFrame;
	  var newX = x + newV * secondPerFrame;
	
	  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
	    reusedTuple[0] = destX;
	    reusedTuple[1] = 0;
	    return reusedTuple;
	  }
	
	  reusedTuple[0] = newX;
	  reusedTuple[1] = newV;
	  return reusedTuple;
	}
	
	module.exports = exports["default"];
	// array reference around.

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ManagerReferenceNodeSetterContext = exports.ManagerReferenceNodeContext = void 0;
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(219));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(278));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(1297));
	
	var ManagerReferenceNodeContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeContext = ManagerReferenceNodeContext;
	var ManagerReferenceNodeSetterContext = (0, _createReactContext.default)();
	exports.ManagerReferenceNodeSetterContext = ManagerReferenceNodeSetterContext;
	
	var Manager =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(Manager, _React$Component);
	
	  function Manager() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "referenceNode", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setReferenceNode", function (newReferenceNode) {
	      if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
	        _this.referenceNode = newReferenceNode;
	
	        _this.forceUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = Manager.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.referenceNode = null;
	  };
	
	  _proto.render = function render() {
	    return React.createElement(ManagerReferenceNodeContext.Provider, {
	      value: this.referenceNode
	    }, React.createElement(ManagerReferenceNodeSetterContext.Provider, {
	      value: this.setReferenceNode
	    }, this.props.children));
	  };
	
	  return Manager;
	}(React.Component);
	
	exports.default = Manager;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _batch = __webpack_require__(765);
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  var batch = (0, _batch.getBatch)();
	  var first = null;
	  var last = null;
	  return {
	    clear: function clear() {
	      first = null;
	      last = null;
	    },
	    notify: function notify() {
	      batch(function () {
	        var listener = first;
	
	        while (listener) {
	          listener.callback();
	          listener = listener.next;
	        }
	      });
	    },
	    get: function get() {
	      var listeners = [];
	      var listener = first;
	
	      while (listener) {
	        listeners.push(listener);
	        listener = listener.next;
	      }
	
	      return listeners;
	    },
	    subscribe: function subscribe(callback) {
	      var isSubscribed = true;
	      var listener = last = {
	        callback: callback,
	        next: null,
	        prev: last
	      };
	
	      if (listener.prev) {
	        listener.prev.next = listener;
	      } else {
	        first = listener;
	      }
	
	      return function unsubscribe() {
	        if (!isSubscribed || first === null) return;
	        isSubscribed = false;
	
	        if (listener.next) {
	          listener.next.prev = listener.prev;
	        } else {
	          last = listener.prev;
	        }
	
	        if (listener.prev) {
	          listener.prev.next = listener.next;
	        } else {
	          first = listener.next;
	        }
	      };
	    }
	  };
	}
	
	var Subscription = /*#__PURE__*/function () {
	  function Subscription(store, parentSub) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.handleChangeWrapper = function handleChangeWrapper() {
	    if (this.onStateChange) {
	      this.onStateChange();
	    }
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports["default"] = Subscription;

/***/ }),
/* 397 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(212);
	
	var _createReactClass = __webpack_require__(95);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _getRouteParams = __webpack_require__(1711);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(398);
	
	var _RouteUtils = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(116);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(399);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(176);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(1705);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(773);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(1701);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(1716);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(1702);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(1703);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(775);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(1704);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(400);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(1714);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(780);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(1707);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(1708);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(1712);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(777);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertStatus = convertStatus;
	exports.Timer = Timer;
	exports.treatNotification = treatNotification;
	exports.preloadImage = preloadImage;
	exports.mapObjectValues = mapObjectValues;
	
	var _constants = __webpack_require__(215);
	
	/**
	 * Convert status in a understandable status for the Notification component
	 * @param {String|Number} status
	 * @returns {String} status an understandable status
	 */
	function convertStatus(status) {
	  var reHttpStatusCode = /^\d{3}$/;
	  // convert HTTP status code
	  if (reHttpStatusCode.test(status)) {
	    switch (true) {
	      case /^1/.test(status):
	        return _constants.STATUS.info;
	      case /^2/.test(status):
	        return _constants.STATUS.success;
	      case /^(4|5)/.test(status):
	        return _constants.STATUS.error;
	    }
	  }
	  return status;
	}
	
	/**
	 * Create a Timer
	 * @param {Number} delay
	 * @param {Function} callback
	 * @constructor
	 */
	function Timer(delay, callback) {
	  var timerId = void 0;
	  var start = void 0;
	  var remaining = delay;
	
	  this.pause = function () {
	    clearTimeout(timerId);
	    remaining -= new Date() - start;
	  };
	  this.resume = function () {
	    start = new Date();
	    clearTimeout(timerId);
	    timerId = setTimeout(callback, remaining);
	  };
	
	  this.getTimeRemaining = function () {
	    return remaining;
	  };
	}
	
	/**
	 * Treat data of a notification
	 * @param {Object} notification
	 * @returns {Object} a notification
	 */
	function treatNotification(notification) {
	  if (notification.dismissAfter) {
	    notification.dismissAfter = parseInt(notification.dismissAfter);
	  }
	  if (notification.image) {
	    notification.status = _constants.STATUS.default;
	  } else {
	    notification.status = convertStatus(notification.status);
	  }
	  if (!notification.buttons) {
	    notification.buttons = [];
	  }
	  return notification;
	}
	
	/**
	 * Preload an image
	 * @param {String} url url of image to load
	 * @param {Function} cb Function called when image is loaded or not
	 * @returns {void}
	 */
	function preloadImage(url, cb) {
	  var image = new Image();
	  image.src = url;
	  image.onload = cb;
	  image.onerror = cb;
	  return image;
	}
	
	/**
	 * Return values of an Object in an Array
	 * @param {Object} obj
	 * @returns {Array}
	 */
	function mapObjectValues(obj) {
	  var array = [];
	
	  for (var key in obj) {
	    if (obj.hasOwnProperty(key)) {
	      array.push(obj[key]);
	    }
	  }
	  return array;
	}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = createAction;
	
	var _invariant = _interopRequireDefault(__webpack_require__(32));
	
	var _isFunction = _interopRequireDefault(__webpack_require__(276));
	
	var _identity = _interopRequireDefault(__webpack_require__(404));
	
	var _isNull = _interopRequireDefault(__webpack_require__(1744));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createAction(type, payloadCreator, metaCreator) {
	  if (payloadCreator === void 0) {
	    payloadCreator = _identity.default;
	  }
	
	  (0, _invariant.default)((0, _isFunction.default)(payloadCreator) || (0, _isNull.default)(payloadCreator), 'Expected payloadCreator to be a function, undefined or null');
	  var finalPayloadCreator = (0, _isNull.default)(payloadCreator) || payloadCreator === _identity.default ? _identity.default : function (head) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return head instanceof Error ? head : payloadCreator.apply(void 0, [head].concat(args));
	  };
	  var hasMeta = (0, _isFunction.default)(metaCreator);
	  var typeString = type.toString();
	
	  var actionCreator = function actionCreator() {
	    var payload = finalPayloadCreator.apply(void 0, arguments);
	    var action = {
	      type: type
	    };
	
	    if (payload instanceof Error) {
	      action.error = true;
	    }
	
	    if (payload !== undefined) {
	      action.payload = payload;
	    }
	
	    if (hasMeta) {
	      action.meta = metaCreator.apply(void 0, arguments);
	    }
	
	    return action;
	  };
	
	  actionCreator.toString = function () {
	    return typeString;
	  };
	
	  return actionCreator;
	}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return value;
	};
	
	exports.default = _default;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = ownKeys;
	
	var _isMap = _interopRequireDefault(__webpack_require__(277));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object) {
	  if ((0, _isMap.default)(object)) {
	    // We are using loose transforms in babel. Here we are trying to convert an
	    // interable to an array. Loose mode expects everything to already be an
	    // array. The problem is that our eslint rules encourage us to prefer
	    // spread over Array.from.
	    //
	    // Instead of disabling loose mode we simply disable the warning.
	    // eslint-disable-next-line unicorn/prefer-spread
	    return Array.from(object.keys());
	  }
	
	  if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
	    return Reflect.ownKeys(object);
	  }
	
	  var keys = Object.getOwnPropertyNames(object);
	
	  if (typeof Object.getOwnPropertySymbols === 'function') {
	    keys = keys.concat(Object.getOwnPropertySymbols(object));
	  }
	
	  return keys;
	}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = exports.UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_ERRORS = exports.UNTOUCH = exports.UNREGISTER_FIELD = exports.TOUCH = exports.SUBMIT = exports.STOP_SUBMIT = exports.STOP_ASYNC_VALIDATION = exports.START_SUBMIT = exports.START_ASYNC_VALIDATION = exports.SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_FAILED = exports.RESET_SECTION = exports.RESET = exports.REGISTER_FIELD = exports.INITIALIZE = exports.FOCUS = exports.DESTROY = exports.CLEAR_ASYNC_ERROR = exports.CLEAR_SUBMIT_ERRORS = exports.CLEAR_SUBMIT = exports.CLEAR_FIELDS = exports.CHANGE = exports.BLUR = exports.AUTOFILL = exports.ARRAY_SWAP = exports.ARRAY_UNSHIFT = exports.ARRAY_SPLICE = exports.ARRAY_SHIFT = exports.ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE = exports.ARRAY_PUSH = exports.ARRAY_POP = exports.ARRAY_MOVE = exports.ARRAY_INSERT = exports.prefix = void 0;
	var prefix = '@@redux-form/';
	exports.prefix = prefix;
	var ARRAY_INSERT = prefix + "ARRAY_INSERT";
	exports.ARRAY_INSERT = ARRAY_INSERT;
	var ARRAY_MOVE = prefix + "ARRAY_MOVE";
	exports.ARRAY_MOVE = ARRAY_MOVE;
	var ARRAY_POP = prefix + "ARRAY_POP";
	exports.ARRAY_POP = ARRAY_POP;
	var ARRAY_PUSH = prefix + "ARRAY_PUSH";
	exports.ARRAY_PUSH = ARRAY_PUSH;
	var ARRAY_REMOVE = prefix + "ARRAY_REMOVE";
	exports.ARRAY_REMOVE = ARRAY_REMOVE;
	var ARRAY_REMOVE_ALL = prefix + "ARRAY_REMOVE_ALL";
	exports.ARRAY_REMOVE_ALL = ARRAY_REMOVE_ALL;
	var ARRAY_SHIFT = prefix + "ARRAY_SHIFT";
	exports.ARRAY_SHIFT = ARRAY_SHIFT;
	var ARRAY_SPLICE = prefix + "ARRAY_SPLICE";
	exports.ARRAY_SPLICE = ARRAY_SPLICE;
	var ARRAY_UNSHIFT = prefix + "ARRAY_UNSHIFT";
	exports.ARRAY_UNSHIFT = ARRAY_UNSHIFT;
	var ARRAY_SWAP = prefix + "ARRAY_SWAP";
	exports.ARRAY_SWAP = ARRAY_SWAP;
	var AUTOFILL = prefix + "AUTOFILL";
	exports.AUTOFILL = AUTOFILL;
	var BLUR = prefix + "BLUR";
	exports.BLUR = BLUR;
	var CHANGE = prefix + "CHANGE";
	exports.CHANGE = CHANGE;
	var CLEAR_FIELDS = prefix + "CLEAR_FIELDS";
	exports.CLEAR_FIELDS = CLEAR_FIELDS;
	var CLEAR_SUBMIT = prefix + "CLEAR_SUBMIT";
	exports.CLEAR_SUBMIT = CLEAR_SUBMIT;
	var CLEAR_SUBMIT_ERRORS = prefix + "CLEAR_SUBMIT_ERRORS";
	exports.CLEAR_SUBMIT_ERRORS = CLEAR_SUBMIT_ERRORS;
	var CLEAR_ASYNC_ERROR = prefix + "CLEAR_ASYNC_ERROR";
	exports.CLEAR_ASYNC_ERROR = CLEAR_ASYNC_ERROR;
	var DESTROY = prefix + "DESTROY";
	exports.DESTROY = DESTROY;
	var FOCUS = prefix + "FOCUS";
	exports.FOCUS = FOCUS;
	var INITIALIZE = prefix + "INITIALIZE";
	exports.INITIALIZE = INITIALIZE;
	var REGISTER_FIELD = prefix + "REGISTER_FIELD";
	exports.REGISTER_FIELD = REGISTER_FIELD;
	var RESET = prefix + "RESET";
	exports.RESET = RESET;
	var RESET_SECTION = prefix + "RESET_SECTION";
	exports.RESET_SECTION = RESET_SECTION;
	var SET_SUBMIT_FAILED = prefix + "SET_SUBMIT_FAILED";
	exports.SET_SUBMIT_FAILED = SET_SUBMIT_FAILED;
	var SET_SUBMIT_SUCCEEDED = prefix + "SET_SUBMIT_SUCCEEDED";
	exports.SET_SUBMIT_SUCCEEDED = SET_SUBMIT_SUCCEEDED;
	var START_ASYNC_VALIDATION = prefix + "START_ASYNC_VALIDATION";
	exports.START_ASYNC_VALIDATION = START_ASYNC_VALIDATION;
	var START_SUBMIT = prefix + "START_SUBMIT";
	exports.START_SUBMIT = START_SUBMIT;
	var STOP_ASYNC_VALIDATION = prefix + "STOP_ASYNC_VALIDATION";
	exports.STOP_ASYNC_VALIDATION = STOP_ASYNC_VALIDATION;
	var STOP_SUBMIT = prefix + "STOP_SUBMIT";
	exports.STOP_SUBMIT = STOP_SUBMIT;
	var SUBMIT = prefix + "SUBMIT";
	exports.SUBMIT = SUBMIT;
	var TOUCH = prefix + "TOUCH";
	exports.TOUCH = TOUCH;
	var UNREGISTER_FIELD = prefix + "UNREGISTER_FIELD";
	exports.UNREGISTER_FIELD = UNREGISTER_FIELD;
	var UNTOUCH = prefix + "UNTOUCH";
	exports.UNTOUCH = UNTOUCH;
	var UPDATE_SYNC_ERRORS = prefix + "UPDATE_SYNC_ERRORS";
	exports.UPDATE_SYNC_ERRORS = UPDATE_SYNC_ERRORS;
	var UPDATE_SYNC_WARNINGS = prefix + "UPDATE_SYNC_WARNINGS";
	exports.UPDATE_SYNC_WARNINGS = UPDATE_SYNC_WARNINGS;
	var _default = {
	  ARRAY_INSERT: ARRAY_INSERT,
	  ARRAY_MOVE: ARRAY_MOVE,
	  ARRAY_POP: ARRAY_POP,
	  ARRAY_PUSH: ARRAY_PUSH,
	  ARRAY_REMOVE: ARRAY_REMOVE,
	  ARRAY_REMOVE_ALL: ARRAY_REMOVE_ALL,
	  ARRAY_SHIFT: ARRAY_SHIFT,
	  ARRAY_SPLICE: ARRAY_SPLICE,
	  ARRAY_UNSHIFT: ARRAY_UNSHIFT,
	  ARRAY_SWAP: ARRAY_SWAP,
	  AUTOFILL: AUTOFILL,
	  BLUR: BLUR,
	  CHANGE: CHANGE,
	  CLEAR_FIELDS: CLEAR_FIELDS,
	  CLEAR_SUBMIT: CLEAR_SUBMIT,
	  CLEAR_SUBMIT_ERRORS: CLEAR_SUBMIT_ERRORS,
	  CLEAR_ASYNC_ERROR: CLEAR_ASYNC_ERROR,
	  DESTROY: DESTROY,
	  FOCUS: FOCUS,
	  INITIALIZE: INITIALIZE,
	  REGISTER_FIELD: REGISTER_FIELD,
	  RESET: RESET,
	  RESET_SECTION: RESET_SECTION,
	  SET_SUBMIT_FAILED: SET_SUBMIT_FAILED,
	  SET_SUBMIT_SUCCEEDED: SET_SUBMIT_SUCCEEDED,
	  START_ASYNC_VALIDATION: START_ASYNC_VALIDATION,
	  START_SUBMIT: START_SUBMIT,
	  STOP_ASYNC_VALIDATION: STOP_ASYNC_VALIDATION,
	  STOP_SUBMIT: STOP_SUBMIT,
	  SUBMIT: SUBMIT,
	  TOUCH: TOUCH,
	  UNREGISTER_FIELD: UNREGISTER_FIELD,
	  UNTOUCH: UNTOUCH,
	  UPDATE_SYNC_ERRORS: UPDATE_SYNC_ERRORS,
	  UPDATE_SYNC_WARNINGS: UPDATE_SYNC_WARNINGS
	};
	exports["default"] = _default;

/***/ }),
/* 407 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var isEvent = function isEvent(candidate) {
	  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
	};
	
	var _default = isEvent;
	exports["default"] = _default;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createIsValid;
	
	var _hasError = _interopRequireDefault(__webpack_require__(1784));
	
	function createIsValid(structure) {
	  var getIn = structure.getIn,
	      keys = structure.keys;
	  var hasError = (0, _hasError["default"])(structure);
	  return function (form, getFormState, ignoreSubmitErrors) {
	    if (ignoreSubmitErrors === void 0) {
	      ignoreSubmitErrors = false;
	    }
	
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      var formState = nonNullGetFormState(state);
	      var syncError = getIn(formState, form + ".syncError");
	
	      if (syncError) {
	        return false;
	      }
	
	      if (!ignoreSubmitErrors) {
	        var error = getIn(formState, form + ".error");
	
	        if (error) {
	          return false;
	        }
	      }
	
	      var syncErrors = getIn(formState, form + ".syncErrors");
	      var asyncErrors = getIn(formState, form + ".asyncErrors");
	      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + ".submitErrors");
	
	      if (!syncErrors && !asyncErrors && !submitErrors) {
	        return true;
	      }
	
	      var registeredFields = getIn(formState, form + ".registeredFields");
	
	      if (!registeredFields) {
	        return true;
	      }
	
	      return !keys(registeredFields).filter(function (name) {
	        return getIn(registeredFields, "['" + name + "'].count") > 0;
	      }).some(function (name) {
	        return hasError(getIn(registeredFields, "['" + name + "']"), syncErrors, asyncErrors, submitErrors);
	      });
	    };
	  };
	}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {/*! @azure/msal-browser v2.12.1 2021-03-15 */
	'use strict';
	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics = function(d, b) {
	    extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	    return extendStatics(d, b);
	};
	
	function __extends(d, b) {
	    extendStatics(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign = function() {
	    __assign = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	
	function __awaiter(thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	}
	
	function __generator(thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	}
	
	function __read(o, n) {
	    var m = typeof Symbol === "function" && o[Symbol.iterator];
	    if (!m) return o;
	    var i = m.call(o), r, ar = [], e;
	    try {
	        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	    }
	    catch (error) { e = { error: error }; }
	    finally {
	        try {
	            if (r && !r.done && (m = i["return"])) m.call(i);
	        }
	        finally { if (e) throw e.error; }
	    }
	    return ar;
	}
	
	function __spread() {
	    for (var ar = [], i = 0; i < arguments.length; i++)
	        ar = ar.concat(__read(arguments[i]));
	    return ar;
	}
	
	/*! @azure/msal-common v4.0.3 2021-03-15 */
	/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.
	
	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.
	
	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global Reflect, Promise */
	
	var extendStatics$1 = function(d, b) {
	    extendStatics$1 = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
	    return extendStatics$1(d, b);
	};
	
	function __extends$1(d, b) {
	    extendStatics$1(d, b);
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	}
	
	var __assign$1 = function() {
	    __assign$1 = Object.assign || function __assign(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign$1.apply(this, arguments);
	};
	
	function __awaiter$1(thisArg, _arguments, P, generator) {
	    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	    return new (P || (P = Promise))(function (resolve, reject) {
	        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	        step((generator = generator.apply(thisArg, _arguments || [])).next());
	    });
	}
	
	function __generator$1(thisArg, body) {
	    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	    function verb(n) { return function (v) { return step([n, v]); }; }
	    function step(op) {
	        if (f) throw new TypeError("Generator is already executing.");
	        while (_) try {
	            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	            if (y = 0, t) op = [op[0] & 2, t.value];
	            switch (op[0]) {
	                case 0: case 1: t = op; break;
	                case 4: _.label++; return { value: op[1], done: false };
	                case 5: _.label++; y = op[1]; op = [0]; continue;
	                case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                default:
	                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                    if (t[2]) _.ops.pop();
	                    _.trys.pop(); continue;
	            }
	            op = body.call(thisArg, _);
	        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	    }
	}
	
	function __spreadArrays() {
	    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	    for (var r = Array(s), k = 0, i = 0; i < il; i++)
	        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	            r[k] = a[j];
	    return r;
	}
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var Constants = {
	    LIBRARY_NAME: "MSAL.JS",
	    SKU: "msal.js.common",
	    // Prefix for all library cache entries
	    CACHE_PREFIX: "msal",
	    // default authority
	    DEFAULT_AUTHORITY: "https://login.microsoftonline.com/common/",
	    DEFAULT_AUTHORITY_HOST: "login.microsoftonline.com",
	    // ADFS String
	    ADFS: "adfs",
	    // Default AAD Instance Discovery Endpoint
	    AAD_INSTANCE_DISCOVERY_ENDPT: "https://login.microsoftonline.com/common/discovery/instance?api-version=1.1&authorization_endpoint=",
	    // Resource delimiter - used for certain cache entries
	    RESOURCE_DELIM: "|",
	    // Placeholder for non-existent account ids/objects
	    NO_ACCOUNT: "NO_ACCOUNT",
	    // Claims
	    CLAIMS: "claims",
	    // Consumer UTID
	    CONSUMER_UTID: "9188040d-6c67-4c5b-b112-36a304b66dad",
	    // Default scopes
	    OPENID_SCOPE: "openid",
	    PROFILE_SCOPE: "profile",
	    OFFLINE_ACCESS_SCOPE: "offline_access",
	    EMAIL_SCOPE: "email",
	    // Default response type for authorization code flow
	    CODE_RESPONSE_TYPE: "code",
	    CODE_GRANT_TYPE: "authorization_code",
	    RT_GRANT_TYPE: "refresh_token",
	    FRAGMENT_RESPONSE_MODE: "fragment",
	    S256_CODE_CHALLENGE_METHOD: "S256",
	    URL_FORM_CONTENT_TYPE: "application/x-www-form-urlencoded;charset=utf-8",
	    AUTHORIZATION_PENDING: "authorization_pending",
	    NOT_DEFINED: "not_defined",
	    EMPTY_STRING: "",
	    FORWARD_SLASH: "/"
	};
	var OIDC_DEFAULT_SCOPES = [
	    Constants.OPENID_SCOPE,
	    Constants.PROFILE_SCOPE,
	    Constants.OFFLINE_ACCESS_SCOPE
	];
	var OIDC_SCOPES = __spreadArrays(OIDC_DEFAULT_SCOPES, [
	    Constants.EMAIL_SCOPE
	]);
	/**
	 * Request header names
	 */
	var HeaderNames;
	(function (HeaderNames) {
	    HeaderNames["CONTENT_TYPE"] = "Content-Type";
	    HeaderNames["X_CLIENT_CURR_TELEM"] = "x-client-current-telemetry";
	    HeaderNames["X_CLIENT_LAST_TELEM"] = "x-client-last-telemetry";
	    HeaderNames["RETRY_AFTER"] = "Retry-After";
	    HeaderNames["X_MS_LIB_CAPABILITY"] = "x-ms-lib-capability";
	    HeaderNames["X_MS_LIB_CAPABILITY_VALUE"] = "retry-after, h429";
	})(HeaderNames || (HeaderNames = {}));
	/**
	 * Persistent cache keys MSAL which stay while user is logged in.
	 */
	var PersistentCacheKeys;
	(function (PersistentCacheKeys) {
	    PersistentCacheKeys["ID_TOKEN"] = "idtoken";
	    PersistentCacheKeys["CLIENT_INFO"] = "client.info";
	    PersistentCacheKeys["ADAL_ID_TOKEN"] = "adal.idtoken";
	    PersistentCacheKeys["ERROR"] = "error";
	    PersistentCacheKeys["ERROR_DESC"] = "error.description";
	})(PersistentCacheKeys || (PersistentCacheKeys = {}));
	/**
	 * String constants related to AAD Authority
	 */
	var AADAuthorityConstants;
	(function (AADAuthorityConstants) {
	    AADAuthorityConstants["COMMON"] = "common";
	    AADAuthorityConstants["ORGANIZATIONS"] = "organizations";
	    AADAuthorityConstants["CONSUMERS"] = "consumers";
	})(AADAuthorityConstants || (AADAuthorityConstants = {}));
	/**
	 * Keys in the hashParams sent by AAD Server
	 */
	var AADServerParamKeys;
	(function (AADServerParamKeys) {
	    AADServerParamKeys["CLIENT_ID"] = "client_id";
	    AADServerParamKeys["REDIRECT_URI"] = "redirect_uri";
	    AADServerParamKeys["RESPONSE_TYPE"] = "response_type";
	    AADServerParamKeys["RESPONSE_MODE"] = "response_mode";
	    AADServerParamKeys["GRANT_TYPE"] = "grant_type";
	    AADServerParamKeys["CLAIMS"] = "claims";
	    AADServerParamKeys["SCOPE"] = "scope";
	    AADServerParamKeys["ERROR"] = "error";
	    AADServerParamKeys["ERROR_DESCRIPTION"] = "error_description";
	    AADServerParamKeys["ACCESS_TOKEN"] = "access_token";
	    AADServerParamKeys["ID_TOKEN"] = "id_token";
	    AADServerParamKeys["REFRESH_TOKEN"] = "refresh_token";
	    AADServerParamKeys["EXPIRES_IN"] = "expires_in";
	    AADServerParamKeys["STATE"] = "state";
	    AADServerParamKeys["NONCE"] = "nonce";
	    AADServerParamKeys["PROMPT"] = "prompt";
	    AADServerParamKeys["SESSION_STATE"] = "session_state";
	    AADServerParamKeys["CLIENT_INFO"] = "client_info";
	    AADServerParamKeys["CODE"] = "code";
	    AADServerParamKeys["CODE_CHALLENGE"] = "code_challenge";
	    AADServerParamKeys["CODE_CHALLENGE_METHOD"] = "code_challenge_method";
	    AADServerParamKeys["CODE_VERIFIER"] = "code_verifier";
	    AADServerParamKeys["CLIENT_REQUEST_ID"] = "client-request-id";
	    AADServerParamKeys["X_CLIENT_SKU"] = "x-client-SKU";
	    AADServerParamKeys["X_CLIENT_VER"] = "x-client-VER";
	    AADServerParamKeys["X_CLIENT_OS"] = "x-client-OS";
	    AADServerParamKeys["X_CLIENT_CPU"] = "x-client-CPU";
	    AADServerParamKeys["POST_LOGOUT_URI"] = "post_logout_redirect_uri";
	    AADServerParamKeys["ID_TOKEN_HINT"] = "id_token_hint";
	    AADServerParamKeys["DEVICE_CODE"] = "device_code";
	    AADServerParamKeys["CLIENT_SECRET"] = "client_secret";
	    AADServerParamKeys["CLIENT_ASSERTION"] = "client_assertion";
	    AADServerParamKeys["CLIENT_ASSERTION_TYPE"] = "client_assertion_type";
	    AADServerParamKeys["TOKEN_TYPE"] = "token_type";
	    AADServerParamKeys["REQ_CNF"] = "req_cnf";
	    AADServerParamKeys["OBO_ASSERTION"] = "assertion";
	    AADServerParamKeys["REQUESTED_TOKEN_USE"] = "requested_token_use";
	    AADServerParamKeys["ON_BEHALF_OF"] = "on_behalf_of";
	    AADServerParamKeys["FOCI"] = "foci";
	})(AADServerParamKeys || (AADServerParamKeys = {}));
	/**
	 * Claims request keys
	 */
	var ClaimsRequestKeys;
	(function (ClaimsRequestKeys) {
	    ClaimsRequestKeys["ACCESS_TOKEN"] = "access_token";
	    ClaimsRequestKeys["XMS_CC"] = "xms_cc";
	})(ClaimsRequestKeys || (ClaimsRequestKeys = {}));
	/**
	 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
	 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
	 * internal partners too, hence the choice of generic "string" type instead of the "enum"
	 */
	var PromptValue = {
	    LOGIN: "login",
	    SELECT_ACCOUNT: "select_account",
	    CONSENT: "consent",
	    NONE: "none",
	};
	/**
	 * SSO Types - generated to populate hints
	 */
	var SSOTypes;
	(function (SSOTypes) {
	    SSOTypes["ACCOUNT"] = "account";
	    SSOTypes["SID"] = "sid";
	    SSOTypes["LOGIN_HINT"] = "login_hint";
	    SSOTypes["ID_TOKEN"] = "id_token";
	    SSOTypes["DOMAIN_HINT"] = "domain_hint";
	    SSOTypes["ORGANIZATIONS"] = "organizations";
	    SSOTypes["CONSUMERS"] = "consumers";
	    SSOTypes["ACCOUNT_ID"] = "accountIdentifier";
	    SSOTypes["HOMEACCOUNT_ID"] = "homeAccountIdentifier";
	})(SSOTypes || (SSOTypes = {}));
	/**
	 * Disallowed extra query parameters.
	 */
	var BlacklistedEQParams = [
	    SSOTypes.SID,
	    SSOTypes.LOGIN_HINT
	];
	/**
	 * allowed values for codeVerifier
	 */
	var CodeChallengeMethodValues = {
	    PLAIN: "plain",
	    S256: "S256"
	};
	/**
	 * allowed values for response_mode
	 */
	var ResponseMode;
	(function (ResponseMode) {
	    ResponseMode["QUERY"] = "query";
	    ResponseMode["FRAGMENT"] = "fragment";
	    ResponseMode["FORM_POST"] = "form_post";
	})(ResponseMode || (ResponseMode = {}));
	/**
	 * allowed grant_type
	 */
	var GrantType;
	(function (GrantType) {
	    GrantType["IMPLICIT_GRANT"] = "implicit";
	    GrantType["AUTHORIZATION_CODE_GRANT"] = "authorization_code";
	    GrantType["CLIENT_CREDENTIALS_GRANT"] = "client_credentials";
	    GrantType["RESOURCE_OWNER_PASSWORD_GRANT"] = "password";
	    GrantType["REFRESH_TOKEN_GRANT"] = "refresh_token";
	    GrantType["DEVICE_CODE_GRANT"] = "device_code";
	    GrantType["JWT_BEARER"] = "urn:ietf:params:oauth:grant-type:jwt-bearer";
	})(GrantType || (GrantType = {}));
	/**
	 * Account types in Cache
	 */
	var CacheAccountType;
	(function (CacheAccountType) {
	    CacheAccountType["MSSTS_ACCOUNT_TYPE"] = "MSSTS";
	    CacheAccountType["ADFS_ACCOUNT_TYPE"] = "ADFS";
	    CacheAccountType["MSAV1_ACCOUNT_TYPE"] = "MSA";
	    CacheAccountType["GENERIC_ACCOUNT_TYPE"] = "Generic"; // NTLM, Kerberos, FBA, Basic etc
	})(CacheAccountType || (CacheAccountType = {}));
	/**
	 * Separators used in cache
	 */
	var Separators;
	(function (Separators) {
	    Separators["CACHE_KEY_SEPARATOR"] = "-";
	    Separators["CLIENT_INFO_SEPARATOR"] = ".";
	})(Separators || (Separators = {}));
	/**
	 * Credential Type stored in the cache
	 */
	var CredentialType;
	(function (CredentialType) {
	    CredentialType["ID_TOKEN"] = "IdToken";
	    CredentialType["ACCESS_TOKEN"] = "AccessToken";
	    CredentialType["REFRESH_TOKEN"] = "RefreshToken";
	})(CredentialType || (CredentialType = {}));
	/**
	 * Credential Type stored in the cache
	 */
	var CacheSchemaType;
	(function (CacheSchemaType) {
	    CacheSchemaType["ACCOUNT"] = "Account";
	    CacheSchemaType["CREDENTIAL"] = "Credential";
	    CacheSchemaType["ID_TOKEN"] = "IdToken";
	    CacheSchemaType["ACCESS_TOKEN"] = "AccessToken";
	    CacheSchemaType["REFRESH_TOKEN"] = "RefreshToken";
	    CacheSchemaType["APP_METADATA"] = "AppMetadata";
	    CacheSchemaType["TEMPORARY"] = "TempCache";
	    CacheSchemaType["TELEMETRY"] = "Telemetry";
	    CacheSchemaType["UNDEFINED"] = "Undefined";
	    CacheSchemaType["THROTTLING"] = "Throttling";
	})(CacheSchemaType || (CacheSchemaType = {}));
	/**
	 * Combine all cache types
	 */
	var CacheType;
	(function (CacheType) {
	    CacheType[CacheType["ADFS"] = 1001] = "ADFS";
	    CacheType[CacheType["MSA"] = 1002] = "MSA";
	    CacheType[CacheType["MSSTS"] = 1003] = "MSSTS";
	    CacheType[CacheType["GENERIC"] = 1004] = "GENERIC";
	    CacheType[CacheType["ACCESS_TOKEN"] = 2001] = "ACCESS_TOKEN";
	    CacheType[CacheType["REFRESH_TOKEN"] = 2002] = "REFRESH_TOKEN";
	    CacheType[CacheType["ID_TOKEN"] = 2003] = "ID_TOKEN";
	    CacheType[CacheType["APP_METADATA"] = 3001] = "APP_METADATA";
	    CacheType[CacheType["UNDEFINED"] = 9999] = "UNDEFINED";
	})(CacheType || (CacheType = {}));
	/**
	 * More Cache related constants
	 */
	var APP_METADATA = "appmetadata";
	var ClientInfo = "client_info";
	var THE_FAMILY_ID = "1";
	var AUTHORITY_METADATA_CONSTANTS = {
	    CACHE_KEY: "authority-metadata",
	    REFRESH_TIME_SECONDS: 3600 * 24 // 24 Hours
	};
	var AuthorityMetadataSource;
	(function (AuthorityMetadataSource) {
	    AuthorityMetadataSource["CONFIG"] = "config";
	    AuthorityMetadataSource["CACHE"] = "cache";
	    AuthorityMetadataSource["NETWORK"] = "network";
	})(AuthorityMetadataSource || (AuthorityMetadataSource = {}));
	var SERVER_TELEM_CONSTANTS = {
	    SCHEMA_VERSION: 2,
	    MAX_HEADER_BYTES: 4000,
	    CACHE_KEY: "server-telemetry",
	    CATEGORY_SEPARATOR: "|",
	    VALUE_SEPARATOR: ",",
	    OVERFLOW_TRUE: "1",
	    OVERFLOW_FALSE: "0",
	    UNKNOWN_ERROR: "unknown_error"
	};
	/**
	 * Type of the authentication request
	 */
	
	(function (AuthenticationScheme) {
	    AuthenticationScheme["POP"] = "pop";
	    AuthenticationScheme["BEARER"] = "Bearer";
	})(exports.AuthenticationScheme || (exports.AuthenticationScheme = {}));
	/**
	 * Constants related to throttling
	 */
	var ThrottlingConstants = {
	    // Default time to throttle RequestThumbprint in seconds
	    DEFAULT_THROTTLE_TIME_SECONDS: 60,
	    // Default maximum time to throttle in seconds, overrides what the server sends back
	    DEFAULT_MAX_THROTTLE_TIME_SECONDS: 3600,
	    // Prefix for storing throttling entries
	    THROTTLING_PREFIX: "throttling"
	};
	var Errors = {
	    INVALID_GRANT_ERROR: "invalid_grant",
	    CLIENT_MISMATCH_ERROR: "client_mismatch",
	};
	/**
	 * Password grant parameters
	 */
	var PasswordGrantConstants;
	(function (PasswordGrantConstants) {
	    PasswordGrantConstants["username"] = "username";
	    PasswordGrantConstants["password"] = "password";
	})(PasswordGrantConstants || (PasswordGrantConstants = {}));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * AuthErrorMessage class containing string constants used by error codes and messages.
	 */
	var AuthErrorMessage = {
	    unexpectedError: {
	        code: "unexpected_error",
	        desc: "Unexpected error in authentication."
	    }
	};
	/**
	 * General error class thrown by the MSAL.js library.
	 */
	var AuthError = /** @class */ (function (_super) {
	    __extends$1(AuthError, _super);
	    function AuthError(errorCode, errorMessage, suberror) {
	        var _this = this;
	        var errorString = errorMessage ? errorCode + ": " + errorMessage : errorCode;
	        _this = _super.call(this, errorString) || this;
	        Object.setPrototypeOf(_this, AuthError.prototype);
	        _this.errorCode = errorCode || Constants.EMPTY_STRING;
	        _this.errorMessage = errorMessage || "";
	        _this.subError = suberror || "";
	        _this.name = "AuthError";
	        return _this;
	    }
	    /**
	     * Creates an error that is thrown when something unexpected happens in the library.
	     * @param errDesc
	     */
	    AuthError.createUnexpectedError = function (errDesc) {
	        return new AuthError(AuthErrorMessage.unexpectedError.code, AuthErrorMessage.unexpectedError.desc + ": " + errDesc);
	    };
	    return AuthError;
	}(Error));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var DEFAULT_CRYPTO_IMPLEMENTATION = {
	    createNewGuid: function () {
	        var notImplErr = "Crypto interface - createNewGuid() has not been implemented";
	        throw AuthError.createUnexpectedError(notImplErr);
	    },
	    base64Decode: function () {
	        var notImplErr = "Crypto interface - base64Decode() has not been implemented";
	        throw AuthError.createUnexpectedError(notImplErr);
	    },
	    base64Encode: function () {
	        var notImplErr = "Crypto interface - base64Encode() has not been implemented";
	        throw AuthError.createUnexpectedError(notImplErr);
	    },
	    generatePkceCodes: function () {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var notImplErr;
	            return __generator$1(this, function (_a) {
	                notImplErr = "Crypto interface - generatePkceCodes() has not been implemented";
	                throw AuthError.createUnexpectedError(notImplErr);
	            });
	        });
	    },
	    getPublicKeyThumbprint: function () {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var notImplErr;
	            return __generator$1(this, function (_a) {
	                notImplErr = "Crypto interface - getPublicKeyThumbprint() has not been implemented";
	                throw AuthError.createUnexpectedError(notImplErr);
	            });
	        });
	    },
	    signJwt: function () {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var notImplErr;
	            return __generator$1(this, function (_a) {
	                notImplErr = "Crypto interface - signJwt() has not been implemented";
	                throw AuthError.createUnexpectedError(notImplErr);
	            });
	        });
	    }
	};
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
	 */
	var ClientAuthErrorMessage = {
	    clientInfoDecodingError: {
	        code: "client_info_decoding_error",
	        desc: "The client info could not be parsed/decoded correctly. Please review the trace to determine the root cause."
	    },
	    clientInfoEmptyError: {
	        code: "client_info_empty_error",
	        desc: "The client info was empty. Please review the trace to determine the root cause."
	    },
	    tokenParsingError: {
	        code: "token_parsing_error",
	        desc: "Token cannot be parsed. Please review stack trace to determine root cause."
	    },
	    nullOrEmptyToken: {
	        code: "null_or_empty_token",
	        desc: "The token is null or empty. Please review the trace to determine the root cause."
	    },
	    endpointResolutionError: {
	        code: "endpoints_resolution_error",
	        desc: "Error: could not resolve endpoints. Please check network and try again."
	    },
	    networkError: {
	        code: "network_error",
	        desc: "Network request failed. Please check network trace to determine root cause."
	    },
	    unableToGetOpenidConfigError: {
	        code: "openid_config_error",
	        desc: "Could not retrieve endpoints. Check your authority and verify the .well-known/openid-configuration endpoint returns the required endpoints."
	    },
	    hashNotDeserialized: {
	        code: "hash_not_deserialized",
	        desc: "The hash parameters could not be deserialized. Please review the trace to determine the root cause."
	    },
	    blankGuidGenerated: {
	        code: "blank_guid_generated",
	        desc: "The guid generated was blank. Please review the trace to determine the root cause."
	    },
	    invalidStateError: {
	        code: "invalid_state",
	        desc: "State was not the expected format. Please check the logs to determine whether the request was sent using ProtocolUtils.setRequestState()."
	    },
	    stateMismatchError: {
	        code: "state_mismatch",
	        desc: "State mismatch error. Please check your network. Continued requests may cause cache overflow."
	    },
	    stateNotFoundError: {
	        code: "state_not_found",
	        desc: "State not found"
	    },
	    nonceMismatchError: {
	        code: "nonce_mismatch",
	        desc: "Nonce mismatch error. This may be caused by a race condition in concurrent requests."
	    },
	    nonceNotFoundError: {
	        code: "nonce_not_found",
	        desc: "nonce not found"
	    },
	    noTokensFoundError: {
	        code: "no_tokens_found",
	        desc: "No tokens were found for the given scopes, and no authorization code was passed to acquireToken. You must retrieve an authorization code before making a call to acquireToken()."
	    },
	    multipleMatchingTokens: {
	        code: "multiple_matching_tokens",
	        desc: "The cache contains multiple tokens satisfying the requirements. " +
	            "Call AcquireToken again providing more requirements such as authority or account."
	    },
	    multipleMatchingAccounts: {
	        code: "multiple_matching_accounts",
	        desc: "The cache contains multiple accounts satisfying the given parameters. Please pass more info to obtain the correct account"
	    },
	    multipleMatchingAppMetadata: {
	        code: "multiple_matching_appMetadata",
	        desc: "The cache contains multiple appMetadata satisfying the given parameters. Please pass more info to obtain the correct appMetadata"
	    },
	    tokenRequestCannotBeMade: {
	        code: "request_cannot_be_made",
	        desc: "Token request cannot be made without authorization code or refresh token."
	    },
	    appendEmptyScopeError: {
	        code: "cannot_append_empty_scope",
	        desc: "Cannot append null or empty scope to ScopeSet. Please check the stack trace for more info."
	    },
	    removeEmptyScopeError: {
	        code: "cannot_remove_empty_scope",
	        desc: "Cannot remove null or empty scope from ScopeSet. Please check the stack trace for more info."
	    },
	    appendScopeSetError: {
	        code: "cannot_append_scopeset",
	        desc: "Cannot append ScopeSet due to error."
	    },
	    emptyInputScopeSetError: {
	        code: "empty_input_scopeset",
	        desc: "Empty input ScopeSet cannot be processed."
	    },
	    DeviceCodePollingCancelled: {
	        code: "device_code_polling_cancelled",
	        desc: "Caller has cancelled token endpoint polling during device code flow by setting DeviceCodeRequest.cancel = true."
	    },
	    DeviceCodeExpired: {
	        code: "device_code_expired",
	        desc: "Device code is expired."
	    },
	    NoAccountInSilentRequest: {
	        code: "no_account_in_silent_request",
	        desc: "Please pass an account object, silent flow is not supported without account information"
	    },
	    invalidCacheRecord: {
	        code: "invalid_cache_record",
	        desc: "Cache record object was null or undefined."
	    },
	    invalidCacheEnvironment: {
	        code: "invalid_cache_environment",
	        desc: "Invalid environment when attempting to create cache entry"
	    },
	    noAccountFound: {
	        code: "no_account_found",
	        desc: "No account found in cache for given key."
	    },
	    CachePluginError: {
	        code: "no cache plugin set on CacheManager",
	        desc: "ICachePlugin needs to be set before using readFromStorage or writeFromStorage"
	    },
	    noCryptoObj: {
	        code: "no_crypto_object",
	        desc: "No crypto object detected. This is required for the following operation: "
	    },
	    invalidCacheType: {
	        code: "invalid_cache_type",
	        desc: "Invalid cache type"
	    },
	    unexpectedAccountType: {
	        code: "unexpected_account_type",
	        desc: "Unexpected account type."
	    },
	    unexpectedCredentialType: {
	        code: "unexpected_credential_type",
	        desc: "Unexpected credential type."
	    },
	    invalidAssertion: {
	        code: "invalid_assertion",
	        desc: "Client assertion must meet requirements described in https://tools.ietf.org/html/rfc7515"
	    },
	    invalidClientCredential: {
	        code: "invalid_client_credential",
	        desc: "Client credential (secret, certificate, or assertion) must not be empty when creating a confidential client. An application should at most have one credential"
	    },
	    tokenRefreshRequired: {
	        code: "token_refresh_required",
	        desc: "Cannot return token from cache because it must be refreshed. This may be due to one of the following reasons: forceRefresh parameter is set to true, claims have been requested, there is no cached access token or it is expired."
	    },
	    userTimeoutReached: {
	        code: "user_timeout_reached",
	        desc: "User defined timeout for device code polling reached",
	    },
	    tokenClaimsRequired: {
	        code: "token_claims_cnf_required_for_signedjwt",
	        desc: "Cannot generate a POP jwt if the token_claims are not populated"
	    },
	    noAuthorizationCodeFromServer: {
	        code: "authorization_code_missing_from_server_response",
	        desc: "Srver response does not contain an authorization code to proceed"
	    }
	};
	/**
	 * Error thrown when there is an error in the client code running on the browser.
	 */
	var ClientAuthError = /** @class */ (function (_super) {
	    __extends$1(ClientAuthError, _super);
	    function ClientAuthError(errorCode, errorMessage) {
	        var _this = _super.call(this, errorCode, errorMessage) || this;
	        _this.name = "ClientAuthError";
	        Object.setPrototypeOf(_this, ClientAuthError.prototype);
	        return _this;
	    }
	    /**
	     * Creates an error thrown when client info object doesn't decode correctly.
	     * @param caughtError
	     */
	    ClientAuthError.createClientInfoDecodingError = function (caughtError) {
	        return new ClientAuthError(ClientAuthErrorMessage.clientInfoDecodingError.code, ClientAuthErrorMessage.clientInfoDecodingError.desc + " Failed with error: " + caughtError);
	    };
	    /**
	     * Creates an error thrown if the client info is empty.
	     * @param rawClientInfo
	     */
	    ClientAuthError.createClientInfoEmptyError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.clientInfoEmptyError.code, "" + ClientAuthErrorMessage.clientInfoEmptyError.desc);
	    };
	    /**
	     * Creates an error thrown when the id token extraction errors out.
	     * @param err
	     */
	    ClientAuthError.createTokenParsingError = function (caughtExtractionError) {
	        return new ClientAuthError(ClientAuthErrorMessage.tokenParsingError.code, ClientAuthErrorMessage.tokenParsingError.desc + " Failed with error: " + caughtExtractionError);
	    };
	    /**
	     * Creates an error thrown when the id token string is null or empty.
	     * @param invalidRawTokenString
	     */
	    ClientAuthError.createTokenNullOrEmptyError = function (invalidRawTokenString) {
	        return new ClientAuthError(ClientAuthErrorMessage.nullOrEmptyToken.code, ClientAuthErrorMessage.nullOrEmptyToken.desc + " Raw Token Value: " + invalidRawTokenString);
	    };
	    /**
	     * Creates an error thrown when the endpoint discovery doesn't complete correctly.
	     */
	    ClientAuthError.createEndpointDiscoveryIncompleteError = function (errDetail) {
	        return new ClientAuthError(ClientAuthErrorMessage.endpointResolutionError.code, ClientAuthErrorMessage.endpointResolutionError.desc + " Detail: " + errDetail);
	    };
	    /**
	     * Creates an error thrown when the fetch client throws
	     */
	    ClientAuthError.createNetworkError = function (endpoint, errDetail) {
	        return new ClientAuthError(ClientAuthErrorMessage.networkError.code, ClientAuthErrorMessage.networkError.desc + " | Fetch client threw: " + errDetail + " | Attempted to reach: " + endpoint.split("?")[0]);
	    };
	    /**
	     * Creates an error thrown when the openid-configuration endpoint cannot be reached or does not contain the required data
	     */
	    ClientAuthError.createUnableToGetOpenidConfigError = function (errDetail) {
	        return new ClientAuthError(ClientAuthErrorMessage.unableToGetOpenidConfigError.code, ClientAuthErrorMessage.unableToGetOpenidConfigError.desc + " Attempted to retrieve endpoints from: " + errDetail);
	    };
	    /**
	     * Creates an error thrown when the hash cannot be deserialized.
	     * @param hashParamObj
	     */
	    ClientAuthError.createHashNotDeserializedError = function (hashParamObj) {
	        return new ClientAuthError(ClientAuthErrorMessage.hashNotDeserialized.code, ClientAuthErrorMessage.hashNotDeserialized.desc + " Given Object: " + hashParamObj);
	    };
	    /**
	     * Creates an error thrown when the state cannot be parsed.
	     * @param invalidState
	     */
	    ClientAuthError.createInvalidStateError = function (invalidState, errorString) {
	        return new ClientAuthError(ClientAuthErrorMessage.invalidStateError.code, ClientAuthErrorMessage.invalidStateError.desc + " Invalid State: " + invalidState + ", Root Err: " + errorString);
	    };
	    /**
	     * Creates an error thrown when two states do not match.
	     */
	    ClientAuthError.createStateMismatchError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.stateMismatchError.code, ClientAuthErrorMessage.stateMismatchError.desc);
	    };
	    /**
	     * Creates an error thrown when the state is not present
	     * @param missingState
	     */
	    ClientAuthError.createStateNotFoundError = function (missingState) {
	        return new ClientAuthError(ClientAuthErrorMessage.stateNotFoundError.code, ClientAuthErrorMessage.stateNotFoundError.desc + ":  " + missingState);
	    };
	    /**
	     * Creates an error thrown when the nonce does not match.
	     */
	    ClientAuthError.createNonceMismatchError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.nonceMismatchError.code, ClientAuthErrorMessage.nonceMismatchError.desc);
	    };
	    /**
	     * Creates an error thrown when the mnonce is not present
	     * @param missingNonce
	     */
	    ClientAuthError.createNonceNotFoundError = function (missingNonce) {
	        return new ClientAuthError(ClientAuthErrorMessage.nonceNotFoundError.code, ClientAuthErrorMessage.nonceNotFoundError.desc + ":  " + missingNonce);
	    };
	    /**
	     * Creates an error thrown when the authorization code required for a token request is null or empty.
	     */
	    ClientAuthError.createNoTokensFoundError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.noTokensFoundError.code, ClientAuthErrorMessage.noTokensFoundError.desc);
	    };
	    /**
	     * Throws error when multiple tokens are in cache.
	     */
	    ClientAuthError.createMultipleMatchingTokensInCacheError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.multipleMatchingTokens.code, ClientAuthErrorMessage.multipleMatchingTokens.desc + ".");
	    };
	    /**
	     * Throws error when multiple accounts are in cache for the given params
	     */
	    ClientAuthError.createMultipleMatchingAccountsInCacheError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.multipleMatchingAccounts.code, ClientAuthErrorMessage.multipleMatchingAccounts.desc);
	    };
	    /**
	     * Throws error when multiple appMetada are in cache for the given clientId.
	     */
	    ClientAuthError.createMultipleMatchingAppMetadataInCacheError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.multipleMatchingAppMetadata.code, ClientAuthErrorMessage.multipleMatchingAppMetadata.desc);
	    };
	    /**
	     * Throws error when no auth code or refresh token is given to ServerTokenRequestParameters.
	     */
	    ClientAuthError.createTokenRequestCannotBeMadeError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.tokenRequestCannotBeMade.code, ClientAuthErrorMessage.tokenRequestCannotBeMade.desc);
	    };
	    /**
	     * Throws error when attempting to append a null, undefined or empty scope to a set
	     * @param givenScope
	     */
	    ClientAuthError.createAppendEmptyScopeToSetError = function (givenScope) {
	        return new ClientAuthError(ClientAuthErrorMessage.appendEmptyScopeError.code, ClientAuthErrorMessage.appendEmptyScopeError.desc + " Given Scope: " + givenScope);
	    };
	    /**
	     * Throws error when attempting to append a null, undefined or empty scope to a set
	     * @param givenScope
	     */
	    ClientAuthError.createRemoveEmptyScopeFromSetError = function (givenScope) {
	        return new ClientAuthError(ClientAuthErrorMessage.removeEmptyScopeError.code, ClientAuthErrorMessage.removeEmptyScopeError.desc + " Given Scope: " + givenScope);
	    };
	    /**
	     * Throws error when attempting to append null or empty ScopeSet.
	     * @param appendError
	     */
	    ClientAuthError.createAppendScopeSetError = function (appendError) {
	        return new ClientAuthError(ClientAuthErrorMessage.appendScopeSetError.code, ClientAuthErrorMessage.appendScopeSetError.desc + " Detail Error: " + appendError);
	    };
	    /**
	     * Throws error if ScopeSet is null or undefined.
	     * @param givenScopeSet
	     */
	    ClientAuthError.createEmptyInputScopeSetError = function (givenScopeSet) {
	        return new ClientAuthError(ClientAuthErrorMessage.emptyInputScopeSetError.code, ClientAuthErrorMessage.emptyInputScopeSetError.desc + " Given ScopeSet: " + givenScopeSet);
	    };
	    /**
	     * Throws error if user sets CancellationToken.cancel = true during polling of token endpoint during device code flow
	     */
	    ClientAuthError.createDeviceCodeCancelledError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.DeviceCodePollingCancelled.code, "" + ClientAuthErrorMessage.DeviceCodePollingCancelled.desc);
	    };
	    /**
	     * Throws error if device code is expired
	     */
	    ClientAuthError.createDeviceCodeExpiredError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.DeviceCodeExpired.code, "" + ClientAuthErrorMessage.DeviceCodeExpired.desc);
	    };
	    /**
	     * Throws error when silent requests are made without an account object
	     */
	    ClientAuthError.createNoAccountInSilentRequestError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.NoAccountInSilentRequest.code, "" + ClientAuthErrorMessage.NoAccountInSilentRequest.desc);
	    };
	    /**
	     * Throws error when cache record is null or undefined.
	     */
	    ClientAuthError.createNullOrUndefinedCacheRecord = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.invalidCacheRecord.code, ClientAuthErrorMessage.invalidCacheRecord.desc);
	    };
	    /**
	     * Throws error when provided environment is not part of the CloudDiscoveryMetadata object
	     */
	    ClientAuthError.createInvalidCacheEnvironmentError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.invalidCacheEnvironment.code, ClientAuthErrorMessage.invalidCacheEnvironment.desc);
	    };
	    /**
	     * Throws error when account is not found in cache.
	     */
	    ClientAuthError.createNoAccountFoundError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.noAccountFound.code, ClientAuthErrorMessage.noAccountFound.desc);
	    };
	    /**
	     * Throws error if ICachePlugin not set on CacheManager.
	     */
	    ClientAuthError.createCachePluginError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.CachePluginError.code, "" + ClientAuthErrorMessage.CachePluginError.desc);
	    };
	    /**
	     * Throws error if crypto object not found.
	     * @param operationName
	     */
	    ClientAuthError.createNoCryptoObjectError = function (operationName) {
	        return new ClientAuthError(ClientAuthErrorMessage.noCryptoObj.code, "" + ClientAuthErrorMessage.noCryptoObj.desc + operationName);
	    };
	    /**
	     * Throws error if cache type is invalid.
	     */
	    ClientAuthError.createInvalidCacheTypeError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.invalidCacheType.code, "" + ClientAuthErrorMessage.invalidCacheType.desc);
	    };
	    /**
	     * Throws error if unexpected account type.
	     */
	    ClientAuthError.createUnexpectedAccountTypeError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.unexpectedAccountType.code, "" + ClientAuthErrorMessage.unexpectedAccountType.desc);
	    };
	    /**
	     * Throws error if unexpected credential type.
	     */
	    ClientAuthError.createUnexpectedCredentialTypeError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.unexpectedCredentialType.code, "" + ClientAuthErrorMessage.unexpectedCredentialType.desc);
	    };
	    /**
	     * Throws error if client assertion is not valid.
	     */
	    ClientAuthError.createInvalidAssertionError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.invalidAssertion.code, "" + ClientAuthErrorMessage.invalidAssertion.desc);
	    };
	    /**
	     * Throws error if client assertion is not valid.
	     */
	    ClientAuthError.createInvalidCredentialError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.invalidClientCredential.code, "" + ClientAuthErrorMessage.invalidClientCredential.desc);
	    };
	    /**
	     * Throws error if token cannot be retrieved from cache due to refresh being required.
	     */
	    ClientAuthError.createRefreshRequiredError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.tokenRefreshRequired.code, ClientAuthErrorMessage.tokenRefreshRequired.desc);
	    };
	    /**
	     * Throws error if the user defined timeout is reached.
	     */
	    ClientAuthError.createUserTimeoutReachedError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.userTimeoutReached.code, ClientAuthErrorMessage.userTimeoutReached.desc);
	    };
	    /*
	     * Throws error if token claims are not populated for a signed jwt generation
	     */
	    ClientAuthError.createTokenClaimsRequiredError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.tokenClaimsRequired.code, ClientAuthErrorMessage.tokenClaimsRequired.desc);
	    };
	    /**
	     * Throws error when the authorization code is missing from the server response
	     */
	    ClientAuthError.createNoAuthCodeInServerResponseError = function () {
	        return new ClientAuthError(ClientAuthErrorMessage.noAuthorizationCodeFromServer.code, ClientAuthErrorMessage.noAuthorizationCodeFromServer.desc);
	    };
	    return ClientAuthError;
	}(AuthError));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * @hidden
	 */
	var StringUtils = /** @class */ (function () {
	    function StringUtils() {
	    }
	    /**
	     * decode a JWT
	     *
	     * @param authToken
	     */
	    StringUtils.decodeAuthToken = function (authToken) {
	        if (StringUtils.isEmpty(authToken)) {
	            throw ClientAuthError.createTokenNullOrEmptyError(authToken);
	        }
	        var tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
	        var matches = tokenPartsRegex.exec(authToken);
	        if (!matches || matches.length < 4) {
	            throw ClientAuthError.createTokenParsingError("Given token is malformed: " + JSON.stringify(authToken));
	        }
	        var crackedToken = {
	            header: matches[1],
	            JWSPayload: matches[2],
	            JWSSig: matches[3]
	        };
	        return crackedToken;
	    };
	    /**
	     * Check if a string is empty.
	     *
	     * @param str
	     */
	    StringUtils.isEmpty = function (str) {
	        return (typeof str === "undefined" || !str || 0 === str.length);
	    };
	    StringUtils.startsWith = function (str, search) {
	        return str.indexOf(search) === 0;
	    };
	    StringUtils.endsWith = function (str, search) {
	        return (str.length >= search.length) && (str.lastIndexOf(search) === (str.length - search.length));
	    };
	    /**
	     * Parses string into an object.
	     *
	     * @param query
	     */
	    StringUtils.queryStringToObject = function (query) {
	        var match; // Regex for replacing addition symbol with a space
	        var pl = /\+/g;
	        var search = /([^&=]+)=([^&]*)/g;
	        var decode = function (s) { return decodeURIComponent(decodeURIComponent(s.replace(pl, " "))); };
	        var obj = {};
	        match = search.exec(query);
	        while (match) {
	            obj[decode(match[1])] = decode(match[2]);
	            match = search.exec(query);
	        }
	        return obj;
	    };
	    /**
	     * Trims entries in an array.
	     *
	     * @param arr
	     */
	    StringUtils.trimArrayEntries = function (arr) {
	        return arr.map(function (entry) { return entry.trim(); });
	    };
	    /**
	     * Removes empty strings from array
	     * @param arr
	     */
	    StringUtils.removeEmptyStringsFromArray = function (arr) {
	        return arr.filter(function (entry) {
	            return !StringUtils.isEmpty(entry);
	        });
	    };
	    /**
	     * Attempts to parse a string into JSON
	     * @param str
	     */
	    StringUtils.jsonParseHelper = function (str) {
	        try {
	            return JSON.parse(str);
	        }
	        catch (e) {
	            return null;
	        }
	    };
	    /**
	     * Tests if a given string matches a given pattern, with support for wildcards.
	     * @param pattern Wildcard pattern to string match. Supports "*" for wildcards
	     * @param input String to match against
	     */
	    StringUtils.matchPattern = function (pattern, input) {
	        // https://stackoverflow.com/a/3117248/4888559
	        var regex = new RegExp(pattern.replace(/\*/g, "[^ ]*"));
	        return regex.test(input);
	    };
	    return StringUtils;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Log message level.
	 */
	
	(function (LogLevel) {
	    LogLevel[LogLevel["Error"] = 0] = "Error";
	    LogLevel[LogLevel["Warning"] = 1] = "Warning";
	    LogLevel[LogLevel["Info"] = 2] = "Info";
	    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
	})(exports.LogLevel || (exports.LogLevel = {}));
	/**
	 * Class which facilitates logging of messages to a specific place.
	 */
	var Logger = /** @class */ (function () {
	    function Logger(loggerOptions, packageName, packageVersion) {
	        // Current log level, defaults to info.
	        this.level = exports.LogLevel.Info;
	        var defaultLoggerCallback = function () { };
	        this.localCallback = loggerOptions.loggerCallback || defaultLoggerCallback;
	        this.piiLoggingEnabled = loggerOptions.piiLoggingEnabled || false;
	        this.level = loggerOptions.logLevel || exports.LogLevel.Info;
	        this.packageName = packageName || Constants.EMPTY_STRING;
	        this.packageVersion = packageVersion || Constants.EMPTY_STRING;
	    }
	    /**
	     * Create new Logger with existing configurations.
	     */
	    Logger.prototype.clone = function (packageName, packageVersion) {
	        return new Logger({ loggerCallback: this.localCallback, piiLoggingEnabled: this.piiLoggingEnabled, logLevel: this.level }, packageName, packageVersion);
	    };
	    /**
	     * Log message with required options.
	     */
	    Logger.prototype.logMessage = function (logMessage, options) {
	        if ((options.logLevel > this.level) || (!this.piiLoggingEnabled && options.containsPii)) {
	            return;
	        }
	        var timestamp = new Date().toUTCString();
	        var logHeader = StringUtils.isEmpty(this.correlationId) ? "[" + timestamp + "] : " : "[" + timestamp + "] : [" + this.correlationId + "]";
	        var log = logHeader + " : " + this.packageName + "@" + this.packageVersion + " : " + exports.LogLevel[options.logLevel] + " - " + logMessage;
	        // debug(`msal:${LogLevel[options.logLevel]}${options.containsPii ? "-Pii": ""}${options.context ? `:${options.context}` : ""}`)(logMessage);
	        this.executeCallback(options.logLevel, log, options.containsPii || false);
	    };
	    /**
	     * Execute callback with message.
	     */
	    Logger.prototype.executeCallback = function (level, message, containsPii) {
	        if (this.localCallback) {
	            this.localCallback(level, message, containsPii);
	        }
	    };
	    /**
	     * Logs error messages.
	     */
	    Logger.prototype.error = function (message, correlationId) {
	        this.logMessage(message, {
	            logLevel: exports.LogLevel.Error,
	            containsPii: false,
	            correlationId: correlationId || ""
	        });
	    };
	    /**
	     * Logs error messages with PII.
	     */
	    Logger.prototype.errorPii = function (message, correlationId) {
	        this.logMessage(message, {
	            logLevel: exports.LogLevel.Error,
	            containsPii: true,
	            correlationId: correlationId || ""
	        });
	    };
	    /**
	     * Logs warning messages.
	     */
	    Logger.prototype.warning = function (message, correlationId) {
	        this.logMessage(message, {
	            logLevel: exports.LogLevel.Warning,
	            containsPii: false,
	            correlationId: correlationId || ""
	        });
	    };
	    /**
	     * Logs warning messages with PII.
	     */
	    Logger.prototype.warningPii = function (message, correlationId) {
	        this.logMessage(message, {
	            logLevel: exports.LogLevel.Warning,
	            containsPii: true,
	            correlationId: correlationId || ""
	        });
	    };
	    /**
	     * Logs info messages.
	     */
	    Logger.prototype.info = function (message, correlationId) {
	        this.logMessage(message, {
	            logLevel: exports.LogLevel.Info,
	            containsPii: false,
	            correlationId: correlationId || ""
	        });
	    };
	    /**
	     * Logs info messages with PII.
	     */
	    Logger.prototype.infoPii = function (message, correlationId) {
	        this.logMessage(message, {
	            logLevel: exports.LogLevel.Info,
	            containsPii: true,
	            correlationId: correlationId || ""
	        });
	    };
	    /**
	     * Logs verbose messages.
	     */
	    Logger.prototype.verbose = function (message, correlationId) {
	        this.logMessage(message, {
	            logLevel: exports.LogLevel.Verbose,
	            containsPii: false,
	            correlationId: correlationId || ""
	        });
	    };
	    /**
	     * Logs verbose messages with PII.
	     */
	    Logger.prototype.verbosePii = function (message, correlationId) {
	        this.logMessage(message, {
	            logLevel: exports.LogLevel.Verbose,
	            containsPii: true,
	            correlationId: correlationId || ""
	        });
	    };
	    /**
	     * Returns whether PII Logging is enabled or not.
	     */
	    Logger.prototype.isPiiLoggingEnabled = function () {
	        return this.piiLoggingEnabled || false;
	    };
	    return Logger;
	}());
	
	/* eslint-disable header/header */
	var name = "@azure/msal-common";
	var version = "4.0.3";
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Base type for credentials to be stored in the cache: eg: ACCESS_TOKEN, ID_TOKEN etc
	 *
	 * Key:Value Schema:
	 *
	 * Key: <home_account_id*>-<environment>-<credential_type>-<client_id>-<realm*>-<target*>
	 *
	 * Value Schema:
	 * {
	 *      homeAccountId: home account identifier for the auth scheme,
	 *      environment: entity that issued the token, represented as a full host
	 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
	 *      clientId: client ID of the application
	 *      secret: Actual credential as a string
	 *      familyId: Family ID identifier, usually only used for refresh tokens
	 *      realm: Full tenant or organizational identifier that the account belongs to
	 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
	 *      oboAssertion: access token passed in as part of OBO request
	 * }
	 */
	var CredentialEntity = /** @class */ (function () {
	    function CredentialEntity() {
	    }
	    /**
	     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
	     */
	    CredentialEntity.prototype.generateAccountId = function () {
	        return CredentialEntity.generateAccountIdForCacheKey(this.homeAccountId, this.environment);
	    };
	    /**
	     * Generate Credential Id key component as per the schema: <credential_type>-<client_id>-<realm>
	     */
	    CredentialEntity.prototype.generateCredentialId = function () {
	        return CredentialEntity.generateCredentialIdForCacheKey(this.credentialType, this.clientId, this.realm, this.familyId);
	    };
	    /**
	     * Generate target key component as per schema: <target>
	     */
	    CredentialEntity.prototype.generateTarget = function () {
	        return CredentialEntity.generateTargetForCacheKey(this.target);
	    };
	    /**
	     * generates credential key
	     */
	    CredentialEntity.prototype.generateCredentialKey = function () {
	        return CredentialEntity.generateCredentialCacheKey(this.homeAccountId, this.environment, this.credentialType, this.clientId, this.realm, this.target, this.familyId);
	    };
	    /**
	     * returns the type of the cache (in this case credential)
	     */
	    CredentialEntity.prototype.generateType = function () {
	        switch (this.credentialType) {
	            case CredentialType.ID_TOKEN:
	                return CacheType.ID_TOKEN;
	            case CredentialType.ACCESS_TOKEN:
	                return CacheType.ACCESS_TOKEN;
	            case CredentialType.REFRESH_TOKEN:
	                return CacheType.REFRESH_TOKEN;
	            default: {
	                throw ClientAuthError.createUnexpectedCredentialTypeError();
	            }
	        }
	    };
	    /**
	     * helper function to return `CredentialType`
	     * @param key
	     */
	    CredentialEntity.getCredentialType = function (key) {
	        if (key.indexOf(CredentialType.ACCESS_TOKEN.toLowerCase()) !== -1) {
	            return CredentialType.ACCESS_TOKEN;
	        }
	        else if (key.indexOf(CredentialType.ID_TOKEN.toLowerCase()) !== -1) {
	            return CredentialType.ID_TOKEN;
	        }
	        else if (key.indexOf(CredentialType.REFRESH_TOKEN.toLowerCase()) !== -1) {
	            return CredentialType.REFRESH_TOKEN;
	        }
	        return Constants.NOT_DEFINED;
	    };
	    /**
	     * generates credential key
	     */
	    CredentialEntity.generateCredentialCacheKey = function (homeAccountId, environment, credentialType, clientId, realm, target, familyId) {
	        var credentialKey = [
	            this.generateAccountIdForCacheKey(homeAccountId, environment),
	            this.generateCredentialIdForCacheKey(credentialType, clientId, realm, familyId),
	            this.generateTargetForCacheKey(target),
	        ];
	        return credentialKey.join(Separators.CACHE_KEY_SEPARATOR).toLowerCase();
	    };
	    /**
	     * generates Account Id for keys
	     * @param homeAccountId
	     * @param environment
	     */
	    CredentialEntity.generateAccountIdForCacheKey = function (homeAccountId, environment) {
	        var accountId = [homeAccountId, environment];
	        return accountId.join(Separators.CACHE_KEY_SEPARATOR).toLowerCase();
	    };
	    /**
	     * Generates Credential Id for keys
	     * @param credentialType
	     * @param realm
	     * @param clientId
	     * @param familyId
	     */
	    CredentialEntity.generateCredentialIdForCacheKey = function (credentialType, clientId, realm, familyId) {
	        var clientOrFamilyId = credentialType === CredentialType.REFRESH_TOKEN
	            ? familyId || clientId
	            : clientId;
	        var credentialId = [
	            credentialType,
	            clientOrFamilyId,
	            realm || "",
	        ];
	        return credentialId.join(Separators.CACHE_KEY_SEPARATOR).toLowerCase();
	    };
	    /**
	     * Generate target key component as per schema: <target>
	     */
	    CredentialEntity.generateTargetForCacheKey = function (scopes) {
	        return (scopes || "").toLowerCase();
	    };
	    return CredentialEntity;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * ClientConfigurationErrorMessage class containing string constants used by error codes and messages.
	 */
	var ClientConfigurationErrorMessage = {
	    redirectUriNotSet: {
	        code: "redirect_uri_empty",
	        desc: "A redirect URI is required for all calls, and none has been set."
	    },
	    postLogoutUriNotSet: {
	        code: "post_logout_uri_empty",
	        desc: "A post logout redirect has not been set."
	    },
	    claimsRequestParsingError: {
	        code: "claims_request_parsing_error",
	        desc: "Could not parse the given claims request object."
	    },
	    authorityUriInsecure: {
	        code: "authority_uri_insecure",
	        desc: "Authority URIs must use https.  Please see here for valid authority configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options"
	    },
	    urlParseError: {
	        code: "url_parse_error",
	        desc: "URL could not be parsed into appropriate segments."
	    },
	    urlEmptyError: {
	        code: "empty_url_error",
	        desc: "URL was empty or null."
	    },
	    emptyScopesError: {
	        code: "empty_input_scopes_error",
	        desc: "Scopes cannot be passed as null, undefined or empty array because they are required to obtain an access token."
	    },
	    nonArrayScopesError: {
	        code: "nonarray_input_scopes_error",
	        desc: "Scopes cannot be passed as non-array."
	    },
	    clientIdSingleScopeError: {
	        code: "clientid_input_scopes_error",
	        desc: "Client ID can only be provided as a single scope."
	    },
	    invalidPrompt: {
	        code: "invalid_prompt_value",
	        desc: "Supported prompt values are 'login', 'select_account', 'consent' and 'none'.  Please see here for valid configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options",
	    },
	    invalidClaimsRequest: {
	        code: "invalid_claims",
	        desc: "Given claims parameter must be a stringified JSON object."
	    },
	    tokenRequestEmptyError: {
	        code: "token_request_empty",
	        desc: "Token request was empty and not found in cache."
	    },
	    logoutRequestEmptyError: {
	        code: "logout_request_empty",
	        desc: "The logout request was null or undefined."
	    },
	    invalidCodeChallengeMethod: {
	        code: "invalid_code_challenge_method",
	        desc: "code_challenge_method passed is invalid. Valid values are \"plain\" and \"S256\"."
	    },
	    invalidCodeChallengeParams: {
	        code: "pkce_params_missing",
	        desc: "Both params: code_challenge and code_challenge_method are to be passed if to be sent in the request"
	    },
	    invalidCloudDiscoveryMetadata: {
	        code: "invalid_cloud_discovery_metadata",
	        desc: "Invalid cloudDiscoveryMetadata provided. Must be a JSON object containing tenant_discovery_endpoint and metadata fields"
	    },
	    invalidAuthorityMetadata: {
	        code: "invalid_authority_metadata",
	        desc: "Invalid authorityMetadata provided. Must by a JSON object containing authorization_endpoint, token_endpoint, end_session_endpoint, issuer fields."
	    },
	    untrustedAuthority: {
	        code: "untrusted_authority",
	        desc: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter."
	    },
	    resourceRequestParametersRequired: {
	        code: "resourceRequest_parameters_required",
	        desc: "resourceRequestMethod and resourceRequestUri are required"
	    }
	};
	/**
	 * Error thrown when there is an error in configuration of the MSAL.js library.
	 */
	var ClientConfigurationError = /** @class */ (function (_super) {
	    __extends$1(ClientConfigurationError, _super);
	    function ClientConfigurationError(errorCode, errorMessage) {
	        var _this = _super.call(this, errorCode, errorMessage) || this;
	        _this.name = "ClientConfigurationError";
	        Object.setPrototypeOf(_this, ClientConfigurationError.prototype);
	        return _this;
	    }
	    /**
	     * Creates an error thrown when the redirect uri is empty (not set by caller)
	     */
	    ClientConfigurationError.createRedirectUriEmptyError = function () {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.redirectUriNotSet.code, ClientConfigurationErrorMessage.redirectUriNotSet.desc);
	    };
	    /**
	     * Creates an error thrown when the post-logout redirect uri is empty (not set by caller)
	     */
	    ClientConfigurationError.createPostLogoutRedirectUriEmptyError = function () {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.postLogoutUriNotSet.code, ClientConfigurationErrorMessage.postLogoutUriNotSet.desc);
	    };
	    /**
	     * Creates an error thrown when the claims request could not be successfully parsed
	     */
	    ClientConfigurationError.createClaimsRequestParsingError = function (claimsRequestParseError) {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.claimsRequestParsingError.code, ClientConfigurationErrorMessage.claimsRequestParsingError.desc + " Given value: " + claimsRequestParseError);
	    };
	    /**
	     * Creates an error thrown if authority uri is given an insecure protocol.
	     * @param urlString
	     */
	    ClientConfigurationError.createInsecureAuthorityUriError = function (urlString) {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.authorityUriInsecure.code, ClientConfigurationErrorMessage.authorityUriInsecure.desc + " Given URI: " + urlString);
	    };
	    /**
	     * Creates an error thrown if URL string does not parse into separate segments.
	     * @param urlString
	     */
	    ClientConfigurationError.createUrlParseError = function (urlParseError) {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.urlParseError.code, ClientConfigurationErrorMessage.urlParseError.desc + " Given Error: " + urlParseError);
	    };
	    /**
	     * Creates an error thrown if URL string is empty or null.
	     * @param urlString
	     */
	    ClientConfigurationError.createUrlEmptyError = function () {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.urlEmptyError.code, ClientConfigurationErrorMessage.urlEmptyError.desc);
	    };
	    /**
	     * Error thrown when scopes are not an array
	     * @param inputScopes
	     */
	    ClientConfigurationError.createScopesNonArrayError = function (inputScopes) {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.nonArrayScopesError.code, ClientConfigurationErrorMessage.nonArrayScopesError.desc + " Given Scopes: " + inputScopes);
	    };
	    /**
	     * Error thrown when scopes are empty.
	     * @param scopesValue
	     */
	    ClientConfigurationError.createEmptyScopesArrayError = function (inputScopes) {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.emptyScopesError.code, ClientConfigurationErrorMessage.emptyScopesError.desc + " Given Scopes: " + inputScopes);
	    };
	    /**
	     * Error thrown when client id scope is not provided as single scope.
	     * @param inputScopes
	     */
	    ClientConfigurationError.createClientIdSingleScopeError = function (inputScopes) {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.clientIdSingleScopeError.code, ClientConfigurationErrorMessage.clientIdSingleScopeError.desc + " Given Scopes: " + inputScopes);
	    };
	    /**
	     * Error thrown when prompt is not an allowed type.
	     * @param promptValue
	     */
	    ClientConfigurationError.createInvalidPromptError = function (promptValue) {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidPrompt.code, ClientConfigurationErrorMessage.invalidPrompt.desc + " Given value: " + promptValue);
	    };
	    /**
	     * Creates error thrown when claims parameter is not a stringified JSON object
	     */
	    ClientConfigurationError.createInvalidClaimsRequestError = function () {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidClaimsRequest.code, ClientConfigurationErrorMessage.invalidClaimsRequest.desc);
	    };
	    /**
	     * Throws error when token request is empty and nothing cached in storage.
	     */
	    ClientConfigurationError.createEmptyLogoutRequestError = function () {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.logoutRequestEmptyError.code, ClientConfigurationErrorMessage.logoutRequestEmptyError.desc);
	    };
	    /**
	     * Throws error when token request is empty and nothing cached in storage.
	     */
	    ClientConfigurationError.createEmptyTokenRequestError = function () {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.tokenRequestEmptyError.code, ClientConfigurationErrorMessage.tokenRequestEmptyError.desc);
	    };
	    /**
	     * Throws error when an invalid code_challenge_method is passed by the user
	     */
	    ClientConfigurationError.createInvalidCodeChallengeMethodError = function () {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidCodeChallengeMethod.code, ClientConfigurationErrorMessage.invalidCodeChallengeMethod.desc);
	    };
	    /**
	     * Throws error when both params: code_challenge and code_challenge_method are not passed together
	     */
	    ClientConfigurationError.createInvalidCodeChallengeParamsError = function () {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidCodeChallengeParams.code, ClientConfigurationErrorMessage.invalidCodeChallengeParams.desc);
	    };
	    /**
	     * Throws an error when the user passes invalid cloudDiscoveryMetadata
	     */
	    ClientConfigurationError.createInvalidCloudDiscoveryMetadataError = function () {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidCloudDiscoveryMetadata.code, ClientConfigurationErrorMessage.invalidCloudDiscoveryMetadata.desc);
	    };
	    /**
	     * Throws an error when the user passes invalid cloudDiscoveryMetadata
	     */
	    ClientConfigurationError.createInvalidAuthorityMetadataError = function () {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.invalidAuthorityMetadata.code, ClientConfigurationErrorMessage.invalidAuthorityMetadata.desc);
	    };
	    /**
	     * Throws error when provided authority is not a member of the trusted host list
	     */
	    ClientConfigurationError.createUntrustedAuthorityError = function () {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.untrustedAuthority.code, ClientConfigurationErrorMessage.untrustedAuthority.desc);
	    };
	    /**
	     * Throws error when resourceRequestMethod or resourceRequestUri is missing
	     */
	    ClientConfigurationError.createResourceRequestParametersRequiredError = function () {
	        return new ClientConfigurationError(ClientConfigurationErrorMessage.resourceRequestParametersRequired.code, ClientConfigurationErrorMessage.resourceRequestParametersRequired.desc);
	    };
	    return ClientConfigurationError;
	}(ClientAuthError));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
	 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
	 * to ensure uniqueness of strings.
	 */
	var ScopeSet = /** @class */ (function () {
	    function ScopeSet(inputScopes) {
	        var _this = this;
	        // Filter empty string and null/undefined array items
	        var scopeArr = inputScopes ? StringUtils.trimArrayEntries(__spreadArrays(inputScopes)) : [];
	        var filteredInput = scopeArr ? StringUtils.removeEmptyStringsFromArray(scopeArr) : [];
	        // Validate and filter scopes (validate function throws if validation fails)
	        this.validateInputScopes(filteredInput);
	        this.scopes = new Set(); // Iterator in constructor not supported by IE11
	        filteredInput.forEach(function (scope) { return _this.scopes.add(scope); });
	    }
	    /**
	     * Factory method to create ScopeSet from space-delimited string
	     * @param inputScopeString
	     * @param appClientId
	     * @param scopesRequired
	     */
	    ScopeSet.fromString = function (inputScopeString) {
	        inputScopeString = inputScopeString || "";
	        var inputScopes = inputScopeString.split(" ");
	        return new ScopeSet(inputScopes);
	    };
	    /**
	     * Used to validate the scopes input parameter requested  by the developer.
	     * @param {Array<string>} inputScopes - Developer requested permissions. Not all scopes are guaranteed to be included in the access token returned.
	     * @param {boolean} scopesRequired - Boolean indicating whether the scopes array is required or not
	     */
	    ScopeSet.prototype.validateInputScopes = function (inputScopes) {
	        // Check if scopes are required but not given or is an empty array
	        if (!inputScopes || inputScopes.length < 1) {
	            throw ClientConfigurationError.createEmptyScopesArrayError(inputScopes);
	        }
	    };
	    /**
	     * Check if a given scope is present in this set of scopes.
	     * @param scope
	     */
	    ScopeSet.prototype.containsScope = function (scope) {
	        var lowerCaseScopes = this.printScopesLowerCase().split(" ");
	        var lowerCaseScopesSet = new ScopeSet(lowerCaseScopes);
	        // compare lowercase scopes
	        return !StringUtils.isEmpty(scope) ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
	    };
	    /**
	     * Check if a set of scopes is present in this set of scopes.
	     * @param scopeSet
	     */
	    ScopeSet.prototype.containsScopeSet = function (scopeSet) {
	        var _this = this;
	        if (!scopeSet || scopeSet.scopes.size <= 0) {
	            return false;
	        }
	        return (this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every(function (scope) { return _this.containsScope(scope); }));
	    };
	    /**
	     * Check if set of scopes contains only the defaults
	     */
	    ScopeSet.prototype.containsOnlyOIDCScopes = function () {
	        var _this = this;
	        var defaultScopeCount = 0;
	        OIDC_SCOPES.forEach(function (defaultScope) {
	            if (_this.containsScope(defaultScope)) {
	                defaultScopeCount += 1;
	            }
	        });
	        return this.scopes.size === defaultScopeCount;
	    };
	    /**
	     * Appends single scope if passed
	     * @param newScope
	     */
	    ScopeSet.prototype.appendScope = function (newScope) {
	        if (!StringUtils.isEmpty(newScope)) {
	            this.scopes.add(newScope.trim());
	        }
	    };
	    /**
	     * Appends multiple scopes if passed
	     * @param newScopes
	     */
	    ScopeSet.prototype.appendScopes = function (newScopes) {
	        var _this = this;
	        try {
	            newScopes.forEach(function (newScope) { return _this.appendScope(newScope); });
	        }
	        catch (e) {
	            throw ClientAuthError.createAppendScopeSetError(e);
	        }
	    };
	    /**
	     * Removes element from set of scopes.
	     * @param scope
	     */
	    ScopeSet.prototype.removeScope = function (scope) {
	        if (StringUtils.isEmpty(scope)) {
	            throw ClientAuthError.createRemoveEmptyScopeFromSetError(scope);
	        }
	        this.scopes.delete(scope.trim());
	    };
	    /**
	     * Removes default scopes from set of scopes
	     * Primarily used to prevent cache misses if the default scopes are not returned from the server
	     */
	    ScopeSet.prototype.removeOIDCScopes = function () {
	        var _this = this;
	        OIDC_SCOPES.forEach(function (defaultScope) {
	            _this.scopes.delete(defaultScope);
	        });
	    };
	    /**
	     * Combines an array of scopes with the current set of scopes.
	     * @param otherScopes
	     */
	    ScopeSet.prototype.unionScopeSets = function (otherScopes) {
	        if (!otherScopes) {
	            throw ClientAuthError.createEmptyInputScopeSetError(otherScopes);
	        }
	        var unionScopes = new Set(); // Iterator in constructor not supported in IE11
	        otherScopes.scopes.forEach(function (scope) { return unionScopes.add(scope.toLowerCase()); });
	        this.scopes.forEach(function (scope) { return unionScopes.add(scope.toLowerCase()); });
	        return unionScopes;
	    };
	    /**
	     * Check if scopes intersect between this set and another.
	     * @param otherScopes
	     */
	    ScopeSet.prototype.intersectingScopeSets = function (otherScopes) {
	        if (!otherScopes) {
	            throw ClientAuthError.createEmptyInputScopeSetError(otherScopes);
	        }
	        // Do not allow OIDC scopes to be the only intersecting scopes
	        if (!otherScopes.containsOnlyOIDCScopes()) {
	            otherScopes.removeOIDCScopes();
	        }
	        var unionScopes = this.unionScopeSets(otherScopes);
	        var sizeOtherScopes = otherScopes.getScopeCount();
	        var sizeThisScopes = this.getScopeCount();
	        var sizeUnionScopes = unionScopes.size;
	        return sizeUnionScopes < (sizeThisScopes + sizeOtherScopes);
	    };
	    /**
	     * Returns size of set of scopes.
	     */
	    ScopeSet.prototype.getScopeCount = function () {
	        return this.scopes.size;
	    };
	    /**
	     * Returns the scopes as an array of string values
	     */
	    ScopeSet.prototype.asArray = function () {
	        var array = [];
	        this.scopes.forEach(function (val) { return array.push(val); });
	        return array;
	    };
	    /**
	     * Prints scopes into a space-delimited string
	     */
	    ScopeSet.prototype.printScopes = function () {
	        if (this.scopes) {
	            var scopeArr = this.asArray();
	            return scopeArr.join(" ");
	        }
	        return "";
	    };
	    /**
	     * Prints scopes into a space-delimited lower-case string (used for caching)
	     */
	    ScopeSet.prototype.printScopesLowerCase = function () {
	        return this.printScopes().toLowerCase();
	    };
	    return ScopeSet;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Function to build a client info object
	 * @param rawClientInfo
	 * @param crypto
	 */
	function buildClientInfo(rawClientInfo, crypto) {
	    if (StringUtils.isEmpty(rawClientInfo)) {
	        throw ClientAuthError.createClientInfoEmptyError();
	    }
	    try {
	        var decodedClientInfo = crypto.base64Decode(rawClientInfo);
	        return JSON.parse(decodedClientInfo);
	    }
	    catch (e) {
	        throw ClientAuthError.createClientInfoDecodingError(e);
	    }
	}
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Authority types supported by MSAL.
	 */
	var AuthorityType;
	(function (AuthorityType) {
	    AuthorityType[AuthorityType["Default"] = 0] = "Default";
	    AuthorityType[AuthorityType["Adfs"] = 1] = "Adfs";
	})(AuthorityType || (AuthorityType = {}));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Type that defines required and optional parameters for an Account field (based on universal cache schema implemented by all MSALs).
	 *
	 * Key : Value Schema
	 *
	 * Key: <home_account_id>-<environment>-<realm*>
	 *
	 * Value Schema:
	 * {
	 *      homeAccountId: home account identifier for the auth scheme,
	 *      environment: entity that issued the token, represented as a full host
	 *      realm: Full tenant or organizational identifier that the account belongs to
	 *      localAccountId: Original tenant-specific accountID, usually used for legacy cases
	 *      username: primary username that represents the user, usually corresponds to preferred_username in the v2 endpt
	 *      authorityType: Accounts authority type as a string
	 *      name: Full name for the account, including given name and family name,
	 *      clientInfo: Full base64 encoded client info received from ESTS
	 *      lastModificationTime: last time this entity was modified in the cache
	 *      lastModificationApp:
	 *      oboAssertion: access token passed in as part of OBO request
	 *      idTokenClaims: Object containing claims parsed from ID token
	 * }
	 */
	var AccountEntity = /** @class */ (function () {
	    function AccountEntity() {
	    }
	    /**
	     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
	     */
	    AccountEntity.prototype.generateAccountId = function () {
	        var accountId = [this.homeAccountId, this.environment];
	        return accountId.join(Separators.CACHE_KEY_SEPARATOR).toLowerCase();
	    };
	    /**
	     * Generate Account Cache Key as per the schema: <home_account_id>-<environment>-<realm*>
	     */
	    AccountEntity.prototype.generateAccountKey = function () {
	        return AccountEntity.generateAccountCacheKey({
	            homeAccountId: this.homeAccountId,
	            environment: this.environment,
	            tenantId: this.realm,
	            username: this.username,
	            localAccountId: this.localAccountId
	        });
	    };
	    /**
	     * returns the type of the cache (in this case account)
	     */
	    AccountEntity.prototype.generateType = function () {
	        switch (this.authorityType) {
	            case CacheAccountType.ADFS_ACCOUNT_TYPE:
	                return CacheType.ADFS;
	            case CacheAccountType.MSAV1_ACCOUNT_TYPE:
	                return CacheType.MSA;
	            case CacheAccountType.MSSTS_ACCOUNT_TYPE:
	                return CacheType.MSSTS;
	            case CacheAccountType.GENERIC_ACCOUNT_TYPE:
	                return CacheType.GENERIC;
	            default: {
	                throw ClientAuthError.createUnexpectedAccountTypeError();
	            }
	        }
	    };
	    /**
	     * Returns the AccountInfo interface for this account.
	     */
	    AccountEntity.prototype.getAccountInfo = function () {
	        return {
	            homeAccountId: this.homeAccountId,
	            environment: this.environment,
	            tenantId: this.realm,
	            username: this.username,
	            localAccountId: this.localAccountId,
	            name: this.name,
	            idTokenClaims: this.idTokenClaims
	        };
	    };
	    /**
	     * Generates account key from interface
	     * @param accountInterface
	     */
	    AccountEntity.generateAccountCacheKey = function (accountInterface) {
	        var accountKey = [
	            accountInterface.homeAccountId,
	            accountInterface.environment || "",
	            accountInterface.tenantId || "",
	        ];
	        return accountKey.join(Separators.CACHE_KEY_SEPARATOR).toLowerCase();
	    };
	    /**
	     * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
	     * @param clientInfo
	     * @param authority
	     * @param idToken
	     * @param policy
	     */
	    AccountEntity.createAccount = function (clientInfo, homeAccountId, authority, idToken, oboAssertion, cloudGraphHostName, msGraphHost) {
	        var _a, _b, _c, _d, _e, _f;
	        var account = new AccountEntity();
	        account.authorityType = CacheAccountType.MSSTS_ACCOUNT_TYPE;
	        account.clientInfo = clientInfo;
	        account.homeAccountId = homeAccountId;
	        var env = authority.getPreferredCache();
	        if (StringUtils.isEmpty(env)) {
	            throw ClientAuthError.createInvalidCacheEnvironmentError();
	        }
	        account.environment = env;
	        // non AAD scenarios can have empty realm
	        account.realm = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.tid) || "";
	        account.oboAssertion = oboAssertion;
	        if (idToken) {
	            account.idTokenClaims = idToken.claims;
	            // How do you account for MSA CID here?
	            account.localAccountId = ((_b = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _b === void 0 ? void 0 : _b.oid) || ((_c = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _c === void 0 ? void 0 : _c.sub) || "";
	            /*
	             * In B2C scenarios the emails claim is used instead of preferred_username and it is an array. In most cases it will contain a single email.
	             * This field should not be relied upon if a custom policy is configured to return more than 1 email.
	             */
	            account.username = ((_d = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _d === void 0 ? void 0 : _d.preferred_username) || (((_e = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _e === void 0 ? void 0 : _e.emails) ? idToken.claims.emails[0] : "");
	            account.name = (_f = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _f === void 0 ? void 0 : _f.name;
	        }
	        account.cloudGraphHostName = cloudGraphHostName;
	        account.msGraphHost = msGraphHost;
	        return account;
	    };
	    /**
	     * Builds non-AAD/ADFS account.
	     * @param authority
	     * @param idToken
	     */
	    AccountEntity.createGenericAccount = function (authority, homeAccountId, idToken, oboAssertion, cloudGraphHostName, msGraphHost) {
	        var _a, _b, _c, _d;
	        var account = new AccountEntity();
	        account.authorityType = (authority.authorityType === AuthorityType.Adfs) ? CacheAccountType.ADFS_ACCOUNT_TYPE : CacheAccountType.GENERIC_ACCOUNT_TYPE;
	        account.homeAccountId = homeAccountId;
	        // non AAD scenarios can have empty realm
	        account.realm = "";
	        account.oboAssertion = oboAssertion;
	        var env = authority.getPreferredCache();
	        if (StringUtils.isEmpty(env)) {
	            throw ClientAuthError.createInvalidCacheEnvironmentError();
	        }
	        if (idToken) {
	            // How do you account for MSA CID here?
	            account.localAccountId = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.oid) || ((_b = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _b === void 0 ? void 0 : _b.sub) || "";
	            // upn claim for most ADFS scenarios
	            account.username = ((_c = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _c === void 0 ? void 0 : _c.upn) || "";
	            account.name = ((_d = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _d === void 0 ? void 0 : _d.name) || "";
	            account.idTokenClaims = idToken === null || idToken === void 0 ? void 0 : idToken.claims;
	        }
	        account.environment = env;
	        account.cloudGraphHostName = cloudGraphHostName;
	        account.msGraphHost = msGraphHost;
	        /*
	         * add uniqueName to claims
	         * account.name = idToken.claims.uniqueName;
	         */
	        return account;
	    };
	    /**
	     * Generate HomeAccountId from server response
	     * @param serverClientInfo
	     * @param authType
	     */
	    AccountEntity.generateHomeAccountId = function (serverClientInfo, authType, logger, cryptoObj, idToken) {
	        var _a;
	        var accountId = ((_a = idToken === null || idToken === void 0 ? void 0 : idToken.claims) === null || _a === void 0 ? void 0 : _a.sub) ? idToken.claims.sub : Constants.EMPTY_STRING;
	        // since ADFS does not have tid and does not set client_info
	        if (authType === AuthorityType.Adfs) {
	            return accountId;
	        }
	        // for cases where there is clientInfo
	        if (serverClientInfo) {
	            var clientInfo = buildClientInfo(serverClientInfo, cryptoObj);
	            if (!StringUtils.isEmpty(clientInfo.uid) && !StringUtils.isEmpty(clientInfo.utid)) {
	                return "" + clientInfo.uid + Separators.CLIENT_INFO_SEPARATOR + clientInfo.utid;
	            }
	        }
	        // default to "sub" claim
	        logger.verbose("No client info in response");
	        return accountId;
	    };
	    /**
	     * Validates an entity: checks for all expected params
	     * @param entity
	     */
	    AccountEntity.isAccountEntity = function (entity) {
	        if (!entity) {
	            return false;
	        }
	        return (entity.hasOwnProperty("homeAccountId") &&
	            entity.hasOwnProperty("environment") &&
	            entity.hasOwnProperty("realm") &&
	            entity.hasOwnProperty("localAccountId") &&
	            entity.hasOwnProperty("username") &&
	            entity.hasOwnProperty("authorityType"));
	    };
	    /**
	     * Helper function to determine whether 2 accounts are equal
	     * Used to avoid unnecessary state updates
	     * @param arrayA
	     * @param arrayB
	     */
	    AccountEntity.accountInfoIsEqual = function (accountA, accountB) {
	        if (!accountA || !accountB) {
	            return false;
	        }
	        return (accountA.homeAccountId === accountB.homeAccountId) &&
	            (accountA.localAccountId === accountB.localAccountId) &&
	            (accountA.username === accountB.username) &&
	            (accountA.tenantId === accountB.tenantId) &&
	            (accountA.environment === accountB.environment);
	    };
	    return AccountEntity;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * JWT Token representation class. Parses token string and generates claims object.
	 */
	var AuthToken = /** @class */ (function () {
	    function AuthToken(rawToken, crypto) {
	        if (StringUtils.isEmpty(rawToken)) {
	            throw ClientAuthError.createTokenNullOrEmptyError(rawToken);
	        }
	        this.rawToken = rawToken;
	        this.claims = AuthToken.extractTokenClaims(rawToken, crypto);
	    }
	    /**
	     * Extract token by decoding the rawToken
	     *
	     * @param encodedToken
	     */
	    AuthToken.extractTokenClaims = function (encodedToken, crypto) {
	        var decodedToken = StringUtils.decodeAuthToken(encodedToken);
	        // token will be decoded to get the username
	        try {
	            var base64TokenPayload = decodedToken.JWSPayload;
	            // base64Decode() should throw an error if there is an issue
	            var base64Decoded = crypto.base64Decode(base64TokenPayload);
	            return JSON.parse(base64Decoded);
	        }
	        catch (err) {
	            throw ClientAuthError.createTokenParsingError(err);
	        }
	    };
	    return AuthToken;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
	 */
	var CacheManager = /** @class */ (function () {
	    function CacheManager(clientId, cryptoImpl) {
	        this.clientId = clientId;
	        this.cryptoImpl = cryptoImpl;
	    }
	    /**
	     * Returns all accounts in cache
	     */
	    CacheManager.prototype.getAllAccounts = function () {
	        var _this = this;
	        var currentAccounts = this.getAccountsFilteredBy();
	        var accountValues = Object.keys(currentAccounts).map(function (accountKey) { return currentAccounts[accountKey]; });
	        var numAccounts = accountValues.length;
	        if (numAccounts < 1) {
	            return [];
	        }
	        else {
	            var allAccounts = accountValues.map(function (value) {
	                var accountEntity = CacheManager.toObject(new AccountEntity(), value);
	                var accountInfo = accountEntity.getAccountInfo();
	                var idToken = _this.readIdTokenFromCache(_this.clientId, accountInfo);
	                if (idToken && !accountInfo.idTokenClaims) {
	                    accountInfo.idTokenClaims = new AuthToken(idToken.secret, _this.cryptoImpl).claims;
	                }
	                return accountInfo;
	            });
	            return allAccounts;
	        }
	    };
	    /**
	     * saves a cache record
	     * @param cacheRecord
	     */
	    CacheManager.prototype.saveCacheRecord = function (cacheRecord) {
	        if (!cacheRecord) {
	            throw ClientAuthError.createNullOrUndefinedCacheRecord();
	        }
	        if (!!cacheRecord.account) {
	            this.setAccount(cacheRecord.account);
	        }
	        if (!!cacheRecord.idToken) {
	            this.setIdTokenCredential(cacheRecord.idToken);
	        }
	        if (!!cacheRecord.accessToken) {
	            this.saveAccessToken(cacheRecord.accessToken);
	        }
	        if (!!cacheRecord.refreshToken) {
	            this.setRefreshTokenCredential(cacheRecord.refreshToken);
	        }
	        if (!!cacheRecord.appMetadata) {
	            this.setAppMetadata(cacheRecord.appMetadata);
	        }
	    };
	    /**
	     * saves access token credential
	     * @param credential
	     */
	    CacheManager.prototype.saveAccessToken = function (credential) {
	        var _this = this;
	        var currentTokenCache = this.getCredentialsFilteredBy({
	            clientId: credential.clientId,
	            credentialType: CredentialType.ACCESS_TOKEN,
	            environment: credential.environment,
	            homeAccountId: credential.homeAccountId,
	            realm: credential.realm,
	        });
	        var currentScopes = ScopeSet.fromString(credential.target);
	        var currentAccessTokens = Object.keys(currentTokenCache.accessTokens).map(function (key) { return currentTokenCache.accessTokens[key]; });
	        if (currentAccessTokens) {
	            currentAccessTokens.forEach(function (tokenEntity) {
	                var tokenScopeSet = ScopeSet.fromString(tokenEntity.target);
	                if (tokenScopeSet.intersectingScopeSets(currentScopes)) {
	                    _this.removeCredential(tokenEntity);
	                }
	            });
	        }
	        this.setAccessTokenCredential(credential);
	    };
	    /**
	     * retrieve accounts matching all provided filters; if no filter is set, get all accounts
	     * not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
	     * @param homeAccountId
	     * @param environment
	     * @param realm
	     */
	    CacheManager.prototype.getAccountsFilteredBy = function (accountFilter) {
	        return this.getAccountsFilteredByInternal(accountFilter ? accountFilter.homeAccountId : "", accountFilter ? accountFilter.environment : "", accountFilter ? accountFilter.realm : "");
	    };
	    /**
	     * retrieve accounts matching all provided filters; if no filter is set, get all accounts
	     * not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
	     * @param homeAccountId
	     * @param environment
	     * @param realm
	     */
	    CacheManager.prototype.getAccountsFilteredByInternal = function (homeAccountId, environment, realm) {
	        var _this = this;
	        var allCacheKeys = this.getKeys();
	        var matchingAccounts = {};
	        allCacheKeys.forEach(function (cacheKey) {
	            var entity = _this.getAccount(cacheKey);
	            if (!entity) {
	                return;
	            }
	            if (!!homeAccountId && !_this.matchHomeAccountId(entity, homeAccountId)) {
	                return;
	            }
	            if (!!environment && !_this.matchEnvironment(entity, environment)) {
	                return;
	            }
	            if (!!realm && !_this.matchRealm(entity, realm)) {
	                return;
	            }
	            matchingAccounts[cacheKey] = entity;
	        });
	        return matchingAccounts;
	    };
	    /**
	     * retrieve credentails matching all provided filters; if no filter is set, get all credentials
	     * @param homeAccountId
	     * @param environment
	     * @param credentialType
	     * @param clientId
	     * @param realm
	     * @param target
	     */
	    CacheManager.prototype.getCredentialsFilteredBy = function (filter) {
	        return this.getCredentialsFilteredByInternal(filter.homeAccountId, filter.environment, filter.credentialType, filter.clientId, filter.familyId, filter.realm, filter.target, filter.oboAssertion);
	    };
	    /**
	     * Support function to help match credentials
	     * @param homeAccountId
	     * @param environment
	     * @param credentialType
	     * @param clientId
	     * @param realm
	     * @param target
	     */
	    CacheManager.prototype.getCredentialsFilteredByInternal = function (homeAccountId, environment, credentialType, clientId, familyId, realm, target, oboAssertion) {
	        var _this = this;
	        var allCacheKeys = this.getKeys();
	        var matchingCredentials = {
	            idTokens: {},
	            accessTokens: {},
	            refreshTokens: {},
	        };
	        allCacheKeys.forEach(function (cacheKey) {
	            // don't parse any non-credential type cache entities
	            var credType = CredentialEntity.getCredentialType(cacheKey);
	            if (credType === Constants.NOT_DEFINED) {
	                return;
	            }
	            // Attempt retrieval
	            var entity = _this.getSpecificCredential(cacheKey, credType);
	            if (!entity) {
	                return;
	            }
	            if (!!oboAssertion && !_this.matchOboAssertion(entity, oboAssertion)) {
	                return;
	            }
	            if (!!homeAccountId && !_this.matchHomeAccountId(entity, homeAccountId)) {
	                return;
	            }
	            if (!!environment && !_this.matchEnvironment(entity, environment)) {
	                return;
	            }
	            if (!!realm && !_this.matchRealm(entity, realm)) {
	                return;
	            }
	            if (!!credentialType && !_this.matchCredentialType(entity, credentialType)) {
	                return;
	            }
	            if (!!clientId && !_this.matchClientId(entity, clientId)) {
	                return;
	            }
	            if (!!familyId && !_this.matchFamilyId(entity, familyId)) {
	                return;
	            }
	            /*
	             * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
	             * Resource specific refresh tokens case will be added when the support is deemed necessary
	             */
	            if (!!target && !_this.matchTarget(entity, target)) {
	                return;
	            }
	            switch (credType) {
	                case CredentialType.ID_TOKEN:
	                    matchingCredentials.idTokens[cacheKey] = entity;
	                    break;
	                case CredentialType.ACCESS_TOKEN:
	                    matchingCredentials.accessTokens[cacheKey] = entity;
	                    break;
	                case CredentialType.REFRESH_TOKEN:
	                    matchingCredentials.refreshTokens[cacheKey] = entity;
	                    break;
	            }
	        });
	        return matchingCredentials;
	    };
	    /**
	     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
	     * @param filter
	     */
	    CacheManager.prototype.getAppMetadataFilteredBy = function (filter) {
	        return this.getAppMetadataFilteredByInternal(filter.environment, filter.clientId);
	    };
	    /**
	     * Support function to help match appMetadata
	     * @param environment
	     * @param clientId
	     */
	    CacheManager.prototype.getAppMetadataFilteredByInternal = function (environment, clientId) {
	        var _this = this;
	        var allCacheKeys = this.getKeys();
	        var matchingAppMetadata = {};
	        allCacheKeys.forEach(function (cacheKey) {
	            // don't parse any non-appMetadata type cache entities
	            if (!_this.isAppMetadata(cacheKey)) {
	                return;
	            }
	            // Attempt retrieval
	            var entity = _this.getAppMetadata(cacheKey);
	            if (!entity) {
	                return;
	            }
	            if (!!environment && !_this.matchEnvironment(entity, environment)) {
	                return;
	            }
	            if (!!clientId && !_this.matchClientId(entity, clientId)) {
	                return;
	            }
	            matchingAppMetadata[cacheKey] = entity;
	        });
	        return matchingAppMetadata;
	    };
	    /**
	     * retrieve authorityMetadata that contains a matching alias
	     * @param filter
	     */
	    CacheManager.prototype.getAuthorityMetadataByAlias = function (host) {
	        var _this = this;
	        var allCacheKeys = this.getAuthorityMetadataKeys();
	        var matchedEntity = null;
	        allCacheKeys.forEach(function (cacheKey) {
	            // don't parse any non-authorityMetadata type cache entities
	            if (!_this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(_this.clientId) === -1) {
	                return;
	            }
	            // Attempt retrieval
	            var entity = _this.getAuthorityMetadata(cacheKey);
	            if (!entity) {
	                return;
	            }
	            if (entity.aliases.indexOf(host) === -1) {
	                return;
	            }
	            matchedEntity = entity;
	        });
	        return matchedEntity;
	    };
	    /**
	     * Removes all accounts and related tokens from cache.
	     */
	    CacheManager.prototype.removeAllAccounts = function () {
	        var _this = this;
	        var allCacheKeys = this.getKeys();
	        allCacheKeys.forEach(function (cacheKey) {
	            var entity = _this.getAccount(cacheKey);
	            if (!entity) {
	                return;
	            }
	            _this.removeAccount(cacheKey);
	        });
	        return true;
	    };
	    /**
	     * returns a boolean if the given account is removed
	     * @param account
	     */
	    CacheManager.prototype.removeAccount = function (accountKey) {
	        var account = this.getAccount(accountKey);
	        if (!account) {
	            throw ClientAuthError.createNoAccountFoundError();
	        }
	        return (this.removeAccountContext(account) && this.removeItem(accountKey, CacheSchemaType.ACCOUNT));
	    };
	    /**
	     * returns a boolean if the given account is removed
	     * @param account
	     */
	    CacheManager.prototype.removeAccountContext = function (account) {
	        var _this = this;
	        var allCacheKeys = this.getKeys();
	        var accountId = account.generateAccountId();
	        allCacheKeys.forEach(function (cacheKey) {
	            // don't parse any non-credential type cache entities
	            var credType = CredentialEntity.getCredentialType(cacheKey);
	            if (credType === Constants.NOT_DEFINED) {
	                return;
	            }
	            var cacheEntity = _this.getSpecificCredential(cacheKey, credType);
	            if (!!cacheEntity && accountId === cacheEntity.generateAccountId()) {
	                _this.removeCredential(cacheEntity);
	            }
	        });
	        return true;
	    };
	    /**
	     * returns a boolean if the given credential is removed
	     * @param credential
	     */
	    CacheManager.prototype.removeCredential = function (credential) {
	        var key = credential.generateCredentialKey();
	        return this.removeItem(key, CacheSchemaType.CREDENTIAL);
	    };
	    /**
	     * Removes all app metadata objects from cache.
	     */
	    CacheManager.prototype.removeAppMetadata = function () {
	        var _this = this;
	        var allCacheKeys = this.getKeys();
	        allCacheKeys.forEach(function (cacheKey) {
	            if (_this.isAppMetadata(cacheKey)) {
	                _this.removeItem(cacheKey, CacheSchemaType.APP_METADATA);
	            }
	        });
	        return true;
	    };
	    /**
	     * Retrieve the cached credentials into a cacherecord
	     * @param account
	     * @param clientId
	     * @param scopes
	     * @param environment
	     */
	    CacheManager.prototype.readCacheRecord = function (account, clientId, scopes, environment) {
	        var cachedAccount = this.readAccountFromCache(account);
	        var cachedIdToken = this.readIdTokenFromCache(clientId, account);
	        var cachedAccessToken = this.readAccessTokenFromCache(clientId, account, scopes);
	        var cachedRefreshToken = this.readRefreshTokenFromCache(clientId, account, false);
	        var cachedAppMetadata = this.readAppMetadataFromCache(environment, clientId);
	        if (cachedAccount && cachedIdToken) {
	            cachedAccount.idTokenClaims = new AuthToken(cachedIdToken.secret, this.cryptoImpl).claims;
	        }
	        return {
	            account: cachedAccount,
	            idToken: cachedIdToken,
	            accessToken: cachedAccessToken,
	            refreshToken: cachedRefreshToken,
	            appMetadata: cachedAppMetadata,
	        };
	    };
	    /**
	     * Retrieve AccountEntity from cache
	     * @param account
	     */
	    CacheManager.prototype.readAccountFromCache = function (account) {
	        var accountKey = AccountEntity.generateAccountCacheKey(account);
	        return this.getAccount(accountKey);
	    };
	    /**
	     * Retrieve IdTokenEntity from cache
	     * @param clientId
	     * @param account
	     * @param inputRealm
	     */
	    CacheManager.prototype.readIdTokenFromCache = function (clientId, account) {
	        var idTokenFilter = {
	            homeAccountId: account.homeAccountId,
	            environment: account.environment,
	            credentialType: CredentialType.ID_TOKEN,
	            clientId: clientId,
	            realm: account.tenantId,
	        };
	        var credentialCache = this.getCredentialsFilteredBy(idTokenFilter);
	        var idTokens = Object.keys(credentialCache.idTokens).map(function (key) { return credentialCache.idTokens[key]; });
	        var numIdTokens = idTokens.length;
	        if (numIdTokens < 1) {
	            return null;
	        }
	        else if (numIdTokens > 1) {
	            throw ClientAuthError.createMultipleMatchingTokensInCacheError();
	        }
	        return idTokens[0];
	    };
	    /**
	     * Retrieve AccessTokenEntity from cache
	     * @param clientId
	     * @param account
	     * @param scopes
	     * @param inputRealm
	     */
	    CacheManager.prototype.readAccessTokenFromCache = function (clientId, account, scopes) {
	        var accessTokenFilter = {
	            homeAccountId: account.homeAccountId,
	            environment: account.environment,
	            credentialType: CredentialType.ACCESS_TOKEN,
	            clientId: clientId,
	            realm: account.tenantId,
	            target: scopes.printScopesLowerCase(),
	        };
	        var credentialCache = this.getCredentialsFilteredBy(accessTokenFilter);
	        var accessTokens = Object.keys(credentialCache.accessTokens).map(function (key) { return credentialCache.accessTokens[key]; });
	        var numAccessTokens = accessTokens.length;
	        if (numAccessTokens < 1) {
	            return null;
	        }
	        else if (numAccessTokens > 1) {
	            throw ClientAuthError.createMultipleMatchingTokensInCacheError();
	        }
	        return accessTokens[0];
	    };
	    /**
	     * Helper to retrieve the appropriate refresh token from cache
	     * @param clientId
	     * @param account
	     * @param familyRT
	     */
	    CacheManager.prototype.readRefreshTokenFromCache = function (clientId, account, familyRT) {
	        var id = familyRT ? THE_FAMILY_ID : undefined;
	        var refreshTokenFilter = {
	            homeAccountId: account.homeAccountId,
	            environment: account.environment,
	            credentialType: CredentialType.REFRESH_TOKEN,
	            clientId: clientId,
	            familyId: id
	        };
	        var credentialCache = this.getCredentialsFilteredBy(refreshTokenFilter);
	        var refreshTokens = Object.keys(credentialCache.refreshTokens).map(function (key) { return credentialCache.refreshTokens[key]; });
	        var numRefreshTokens = refreshTokens.length;
	        if (numRefreshTokens < 1) {
	            return null;
	        }
	        // address the else case after remove functions address environment aliases
	        return refreshTokens[0];
	    };
	    /**
	     * Retrieve AppMetadataEntity from cache
	     */
	    CacheManager.prototype.readAppMetadataFromCache = function (environment, clientId) {
	        var appMetadataFilter = {
	            environment: environment,
	            clientId: clientId,
	        };
	        var appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter);
	        var appMetadataEntries = Object.keys(appMetadata).map(function (key) { return appMetadata[key]; });
	        var numAppMetadata = appMetadataEntries.length;
	        if (numAppMetadata < 1) {
	            return null;
	        }
	        else if (numAppMetadata > 1) {
	            throw ClientAuthError.createMultipleMatchingAppMetadataInCacheError();
	        }
	        return appMetadataEntries[0];
	    };
	    /**
	     * Return the family_id value associated  with FOCI
	     * @param environment
	     * @param clientId
	     */
	    CacheManager.prototype.isAppMetadataFOCI = function (environment, clientId) {
	        var appMetadata = this.readAppMetadataFromCache(environment, clientId);
	        return !!(appMetadata && appMetadata.familyId === THE_FAMILY_ID);
	    };
	    /**
	     * helper to match account ids
	     * @param value
	     * @param homeAccountId
	     */
	    CacheManager.prototype.matchHomeAccountId = function (entity, homeAccountId) {
	        return !!(entity.homeAccountId && homeAccountId === entity.homeAccountId);
	    };
	    /**
	     * helper to match assertion
	     * @param value
	     * @param oboAssertion
	     */
	    CacheManager.prototype.matchOboAssertion = function (entity, oboAssertion) {
	        return !!(entity.oboAssertion && oboAssertion === entity.oboAssertion);
	    };
	    /**
	     * helper to match environment
	     * @param value
	     * @param environment
	     */
	    CacheManager.prototype.matchEnvironment = function (entity, environment) {
	        var cloudMetadata = this.getAuthorityMetadataByAlias(environment);
	        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) {
	            return true;
	        }
	        return false;
	    };
	    /**
	     * helper to match credential type
	     * @param entity
	     * @param credentialType
	     */
	    CacheManager.prototype.matchCredentialType = function (entity, credentialType) {
	        return (entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase());
	    };
	    /**
	     * helper to match client ids
	     * @param entity
	     * @param clientId
	     */
	    CacheManager.prototype.matchClientId = function (entity, clientId) {
	        return !!(entity.clientId && clientId === entity.clientId);
	    };
	    /**
	     * helper to match family ids
	     * @param entity
	     * @param familyId
	     */
	    CacheManager.prototype.matchFamilyId = function (entity, familyId) {
	        return !!(entity.familyId && familyId === entity.familyId);
	    };
	    /**
	     * helper to match realm
	     * @param entity
	     * @param realm
	     */
	    CacheManager.prototype.matchRealm = function (entity, realm) {
	        return !!(entity.realm && realm === entity.realm);
	    };
	    /**
	     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
	     * @param entity
	     * @param target
	     */
	    CacheManager.prototype.matchTarget = function (entity, target) {
	        if (entity.credentialType !== CredentialType.ACCESS_TOKEN || !entity.target) {
	            return false;
	        }
	        var entityScopeSet = ScopeSet.fromString(entity.target);
	        var requestTargetScopeSet = ScopeSet.fromString(target);
	        if (!requestTargetScopeSet.containsOnlyOIDCScopes()) {
	            requestTargetScopeSet.removeOIDCScopes(); // ignore OIDC scopes
	        }
	        else {
	            requestTargetScopeSet.removeScope(Constants.OFFLINE_ACCESS_SCOPE);
	        }
	        return entityScopeSet.containsScopeSet(requestTargetScopeSet);
	    };
	    /**
	     * returns if a given cache entity is of the type appmetadata
	     * @param key
	     */
	    CacheManager.prototype.isAppMetadata = function (key) {
	        return key.indexOf(APP_METADATA) !== -1;
	    };
	    /**
	     * returns if a given cache entity is of the type authoritymetadata
	     * @param key
	     */
	    CacheManager.prototype.isAuthorityMetadata = function (key) {
	        return key.indexOf(AUTHORITY_METADATA_CONSTANTS.CACHE_KEY) !== -1;
	    };
	    /**
	     * returns cache key used for cloud instance metadata
	     */
	    CacheManager.prototype.generateAuthorityMetadataCacheKey = function (authority) {
	        return AUTHORITY_METADATA_CONSTANTS.CACHE_KEY + "-" + this.clientId + "-" + authority;
	    };
	    /**
	     * Returns the specific credential (IdToken/AccessToken/RefreshToken) from the cache
	     * @param key
	     * @param credType
	     */
	    CacheManager.prototype.getSpecificCredential = function (key, credType) {
	        switch (credType) {
	            case CredentialType.ID_TOKEN: {
	                return this.getIdTokenCredential(key);
	            }
	            case CredentialType.ACCESS_TOKEN: {
	                return this.getAccessTokenCredential(key);
	            }
	            case CredentialType.REFRESH_TOKEN: {
	                return this.getRefreshTokenCredential(key);
	            }
	            default:
	                return null;
	        }
	    };
	    /**
	     * Helper to convert serialized data to object
	     * @param obj
	     * @param json
	     */
	    CacheManager.toObject = function (obj, json) {
	        for (var propertyName in json) {
	            obj[propertyName] = json[propertyName];
	        }
	        return obj;
	    };
	    return CacheManager;
	}());
	var DefaultStorageClass = /** @class */ (function (_super) {
	    __extends$1(DefaultStorageClass, _super);
	    function DefaultStorageClass() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    DefaultStorageClass.prototype.setAccount = function () {
	        var notImplErr = "Storage interface - setAccount() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.getAccount = function () {
	        var notImplErr = "Storage interface - getAccount() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.setIdTokenCredential = function () {
	        var notImplErr = "Storage interface - setIdTokenCredential() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.getIdTokenCredential = function () {
	        var notImplErr = "Storage interface - getIdTokenCredential() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.setAccessTokenCredential = function () {
	        var notImplErr = "Storage interface - setAccessTokenCredential() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.getAccessTokenCredential = function () {
	        var notImplErr = "Storage interface - getAccessTokenCredential() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.setRefreshTokenCredential = function () {
	        var notImplErr = "Storage interface - setRefreshTokenCredential() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.getRefreshTokenCredential = function () {
	        var notImplErr = "Storage interface - getRefreshTokenCredential() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.setAppMetadata = function () {
	        var notImplErr = "Storage interface - setAppMetadata() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.getAppMetadata = function () {
	        var notImplErr = "Storage interface - getAppMetadata() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.setServerTelemetry = function () {
	        var notImplErr = "Storage interface - setServerTelemetry() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.getServerTelemetry = function () {
	        var notImplErr = "Storage interface - getServerTelemetry() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.setAuthorityMetadata = function () {
	        var notImplErr = "Storage interface - setAuthorityMetadata() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.getAuthorityMetadata = function () {
	        var notImplErr = "Storage interface - getAuthorityMetadata() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.getAuthorityMetadataKeys = function () {
	        var notImplErr = "Storage interface - getAuthorityMetadataKeys() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.setThrottlingCache = function () {
	        var notImplErr = "Storage interface - setThrottlingCache() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.getThrottlingCache = function () {
	        var notImplErr = "Storage interface - getThrottlingCache() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.removeItem = function () {
	        var notImplErr = "Storage interface - removeItem() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.containsKey = function () {
	        var notImplErr = "Storage interface - containsKey() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.getKeys = function () {
	        var notImplErr = "Storage interface - getKeys() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    DefaultStorageClass.prototype.clear = function () {
	        var notImplErr = "Storage interface - clear() has not been implemented for the cacheStorage interface.";
	        throw AuthError.createUnexpectedError(notImplErr);
	    };
	    return DefaultStorageClass;
	}(CacheManager));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	// Token renewal offset default in seconds
	var DEFAULT_TOKEN_RENEWAL_OFFSET_SEC = 300;
	var DEFAULT_SYSTEM_OPTIONS = {
	    tokenRenewalOffsetSeconds: DEFAULT_TOKEN_RENEWAL_OFFSET_SEC
	};
	var DEFAULT_LOGGER_IMPLEMENTATION = {
	    loggerCallback: function () {
	        // allow users to not set loggerCallback
	    },
	    piiLoggingEnabled: false,
	    logLevel: exports.LogLevel.Info
	};
	var DEFAULT_NETWORK_IMPLEMENTATION = {
	    sendGetRequestAsync: function () {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var notImplErr;
	            return __generator$1(this, function (_a) {
	                notImplErr = "Network interface - sendGetRequestAsync() has not been implemented";
	                throw AuthError.createUnexpectedError(notImplErr);
	            });
	        });
	    },
	    sendPostRequestAsync: function () {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var notImplErr;
	            return __generator$1(this, function (_a) {
	                notImplErr = "Network interface - sendPostRequestAsync() has not been implemented";
	                throw AuthError.createUnexpectedError(notImplErr);
	            });
	        });
	    }
	};
	var DEFAULT_LIBRARY_INFO = {
	    sku: Constants.SKU,
	    version: version,
	    cpu: "",
	    os: ""
	};
	var DEFAULT_CLIENT_CREDENTIALS = {
	    clientSecret: "",
	    clientAssertion: undefined
	};
	/**
	 * Function that sets the default options when not explicitly configured from app developer
	 *
	 * @param Configuration
	 *
	 * @returns Configuration
	 */
	function buildClientConfiguration(_a) {
	    var userAuthOptions = _a.authOptions, userSystemOptions = _a.systemOptions, userLoggerOption = _a.loggerOptions, storageImplementation = _a.storageInterface, networkImplementation = _a.networkInterface, cryptoImplementation = _a.cryptoInterface, clientCredentials = _a.clientCredentials, libraryInfo = _a.libraryInfo, serverTelemetryManager = _a.serverTelemetryManager, persistencePlugin = _a.persistencePlugin, serializableCache = _a.serializableCache;
	    return {
	        authOptions: buildAuthOptions(userAuthOptions),
	        systemOptions: __assign$1(__assign$1({}, DEFAULT_SYSTEM_OPTIONS), userSystemOptions),
	        loggerOptions: __assign$1(__assign$1({}, DEFAULT_LOGGER_IMPLEMENTATION), userLoggerOption),
	        storageInterface: storageImplementation || new DefaultStorageClass(userAuthOptions.clientId, DEFAULT_CRYPTO_IMPLEMENTATION),
	        networkInterface: networkImplementation || DEFAULT_NETWORK_IMPLEMENTATION,
	        cryptoInterface: cryptoImplementation || DEFAULT_CRYPTO_IMPLEMENTATION,
	        clientCredentials: clientCredentials || DEFAULT_CLIENT_CREDENTIALS,
	        libraryInfo: __assign$1(__assign$1({}, DEFAULT_LIBRARY_INFO), libraryInfo),
	        serverTelemetryManager: serverTelemetryManager || null,
	        persistencePlugin: persistencePlugin || null,
	        serializableCache: serializableCache || null
	    };
	}
	/**
	 * Construct authoptions from the client and platform passed values
	 * @param authOptions
	 */
	function buildAuthOptions(authOptions) {
	    return __assign$1({ clientCapabilities: [] }, authOptions);
	}
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Error thrown when there is an error with the server code, for example, unavailability.
	 */
	var ServerError = /** @class */ (function (_super) {
	    __extends$1(ServerError, _super);
	    function ServerError(errorCode, errorMessage, subError) {
	        var _this = _super.call(this, errorCode, errorMessage, subError) || this;
	        _this.name = "ServerError";
	        Object.setPrototypeOf(_this, ServerError.prototype);
	        return _this;
	    }
	    return ServerError;
	}(AuthError));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var ThrottlingUtils = /** @class */ (function () {
	    function ThrottlingUtils() {
	    }
	    /**
	     * Prepares a RequestThumbprint to be stored as a key.
	     * @param thumbprint
	     */
	    ThrottlingUtils.generateThrottlingStorageKey = function (thumbprint) {
	        return ThrottlingConstants.THROTTLING_PREFIX + "." + JSON.stringify(thumbprint);
	    };
	    /**
	     * Performs necessary throttling checks before a network request.
	     * @param cacheManager
	     * @param thumbprint
	     */
	    ThrottlingUtils.preProcess = function (cacheManager, thumbprint) {
	        var _a;
	        var key = ThrottlingUtils.generateThrottlingStorageKey(thumbprint);
	        var value = cacheManager.getThrottlingCache(key);
	        if (value) {
	            if (value.throttleTime < Date.now()) {
	                cacheManager.removeItem(key, CacheSchemaType.THROTTLING);
	                return;
	            }
	            throw new ServerError(((_a = value.errorCodes) === null || _a === void 0 ? void 0 : _a.join(" ")) || Constants.EMPTY_STRING, value.errorMessage, value.subError);
	        }
	    };
	    /**
	     * Performs necessary throttling checks after a network request.
	     * @param cacheManager
	     * @param thumbprint
	     * @param response
	     */
	    ThrottlingUtils.postProcess = function (cacheManager, thumbprint, response) {
	        if (ThrottlingUtils.checkResponseStatus(response) || ThrottlingUtils.checkResponseForRetryAfter(response)) {
	            var thumbprintValue = {
	                throttleTime: ThrottlingUtils.calculateThrottleTime(parseInt(response.headers[HeaderNames.RETRY_AFTER])),
	                error: response.body.error,
	                errorCodes: response.body.error_codes,
	                errorMessage: response.body.error_description,
	                subError: response.body.suberror
	            };
	            cacheManager.setThrottlingCache(ThrottlingUtils.generateThrottlingStorageKey(thumbprint), thumbprintValue);
	        }
	    };
	    /**
	     * Checks a NetworkResponse object's status codes against 429 or 5xx
	     * @param response
	     */
	    ThrottlingUtils.checkResponseStatus = function (response) {
	        return response.status === 429 || response.status >= 500 && response.status < 600;
	    };
	    /**
	     * Checks a NetworkResponse object's RetryAfter header
	     * @param response
	     */
	    ThrottlingUtils.checkResponseForRetryAfter = function (response) {
	        if (response.headers) {
	            return response.headers.hasOwnProperty(HeaderNames.RETRY_AFTER) && (response.status < 200 || response.status >= 300);
	        }
	        return false;
	    };
	    /**
	     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
	     * @param throttleTime
	     */
	    ThrottlingUtils.calculateThrottleTime = function (throttleTime) {
	        if (throttleTime <= 0) {
	            throttleTime = 0;
	        }
	        var currentSeconds = Date.now() / 1000;
	        return Math.floor(Math.min(currentSeconds + (throttleTime || ThrottlingConstants.DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + ThrottlingConstants.DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
	    };
	    ThrottlingUtils.removeThrottle = function (cacheManager, clientId, authority, scopes, homeAccountIdentifier) {
	        var thumbprint = {
	            clientId: clientId,
	            authority: authority,
	            scopes: scopes,
	            homeAccountIdentifier: homeAccountIdentifier
	        };
	        var key = this.generateThrottlingStorageKey(thumbprint);
	        return cacheManager.removeItem(key, CacheSchemaType.THROTTLING);
	    };
	    return ThrottlingUtils;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var NetworkManager = /** @class */ (function () {
	    function NetworkManager(networkClient, cacheManager) {
	        this.networkClient = networkClient;
	        this.cacheManager = cacheManager;
	    }
	    /**
	     * Wraps sendPostRequestAsync with necessary preflight and postflight logic
	     * @param thumbprint
	     * @param tokenEndpoint
	     * @param options
	     */
	    NetworkManager.prototype.sendPostRequest = function (thumbprint, tokenEndpoint, options) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var response, e_1;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        ThrottlingUtils.preProcess(this.cacheManager, thumbprint);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, this.networkClient.sendPostRequestAsync(tokenEndpoint, options)];
	                    case 2:
	                        response = _a.sent();
	                        return [3 /*break*/, 4];
	                    case 3:
	                        e_1 = _a.sent();
	                        if (e_1 instanceof AuthError) {
	                            throw e_1;
	                        }
	                        else {
	                            throw ClientAuthError.createNetworkError(tokenEndpoint, e_1);
	                        }
	                    case 4:
	                        ThrottlingUtils.postProcess(this.cacheManager, thumbprint, response);
	                        return [2 /*return*/, response];
	                }
	            });
	        });
	    };
	    return NetworkManager;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Base application class which will construct requests to send to and handle responses from the Microsoft STS using the authorization code flow.
	 */
	var BaseClient = /** @class */ (function () {
	    function BaseClient(configuration) {
	        // Set the configuration
	        this.config = buildClientConfiguration(configuration);
	        // Initialize the logger
	        this.logger = new Logger(this.config.loggerOptions, name, version);
	        // Initialize crypto
	        this.cryptoUtils = this.config.cryptoInterface;
	        // Initialize storage interface
	        this.cacheManager = this.config.storageInterface;
	        // Set the network interface
	        this.networkClient = this.config.networkInterface;
	        // Set the NetworkManager
	        this.networkManager = new NetworkManager(this.networkClient, this.cacheManager);
	        // Set TelemetryManager
	        this.serverTelemetryManager = this.config.serverTelemetryManager;
	        // set Authority
	        this.authority = this.config.authOptions.authority;
	    }
	    /**
	     * Creates default headers for requests to token endpoint
	     */
	    BaseClient.prototype.createDefaultTokenRequestHeaders = function () {
	        var headers = this.createDefaultLibraryHeaders();
	        headers[HeaderNames.CONTENT_TYPE] = Constants.URL_FORM_CONTENT_TYPE;
	        headers[HeaderNames.X_MS_LIB_CAPABILITY] = HeaderNames.X_MS_LIB_CAPABILITY_VALUE;
	        if (this.serverTelemetryManager) {
	            headers[HeaderNames.X_CLIENT_CURR_TELEM] = this.serverTelemetryManager.generateCurrentRequestHeaderValue();
	            headers[HeaderNames.X_CLIENT_LAST_TELEM] = this.serverTelemetryManager.generateLastRequestHeaderValue();
	        }
	        return headers;
	    };
	    /**
	     * addLibraryData
	     */
	    BaseClient.prototype.createDefaultLibraryHeaders = function () {
	        var headers = {};
	        // client info headers
	        headers[AADServerParamKeys.X_CLIENT_SKU] = this.config.libraryInfo.sku;
	        headers[AADServerParamKeys.X_CLIENT_VER] = this.config.libraryInfo.version;
	        headers[AADServerParamKeys.X_CLIENT_OS] = this.config.libraryInfo.os;
	        headers[AADServerParamKeys.X_CLIENT_CPU] = this.config.libraryInfo.cpu;
	        return headers;
	    };
	    /**
	     * Http post to token endpoint
	     * @param tokenEndpoint
	     * @param queryString
	     * @param headers
	     * @param thumbprint
	     */
	    BaseClient.prototype.executePostToTokenEndpoint = function (tokenEndpoint, queryString, headers, thumbprint) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var response;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.networkManager.sendPostRequest(thumbprint, tokenEndpoint, { body: queryString, headers: headers })];
	                    case 1:
	                        response = _a.sent();
	                        if (this.config.serverTelemetryManager && response.status < 500 && response.status !== 429) {
	                            // Telemetry data successfully logged by server, clear Telemetry cache
	                            this.config.serverTelemetryManager.clearTelemetryCache();
	                        }
	                        return [2 /*return*/, response];
	                }
	            });
	        });
	    };
	    /**
	     * Updates the authority object of the client. Endpoint discovery must be completed.
	     * @param updatedAuthority
	     */
	    BaseClient.prototype.updateAuthority = function (updatedAuthority) {
	        if (!updatedAuthority.discoveryComplete()) {
	            throw ClientAuthError.createEndpointDiscoveryIncompleteError("Updated authority has not completed endpoint discovery.");
	        }
	        this.authority = updatedAuthority;
	    };
	    return BaseClient;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Validates server consumable params from the "request" objects
	 */
	var RequestValidator = /** @class */ (function () {
	    function RequestValidator() {
	    }
	    /**
	     * Utility to check if the `redirectUri` in the request is a non-null value
	     * @param redirectUri
	     */
	    RequestValidator.validateRedirectUri = function (redirectUri) {
	        if (StringUtils.isEmpty(redirectUri)) {
	            throw ClientConfigurationError.createRedirectUriEmptyError();
	        }
	    };
	    /**
	     * Utility to validate prompt sent by the user in the request
	     * @param prompt
	     */
	    RequestValidator.validatePrompt = function (prompt) {
	        if ([
	            PromptValue.LOGIN,
	            PromptValue.SELECT_ACCOUNT,
	            PromptValue.CONSENT,
	            PromptValue.NONE
	        ].indexOf(prompt) < 0) {
	            throw ClientConfigurationError.createInvalidPromptError(prompt);
	        }
	    };
	    RequestValidator.validateClaims = function (claims) {
	        try {
	            JSON.parse(claims);
	        }
	        catch (e) {
	            throw ClientConfigurationError.createInvalidClaimsRequestError();
	        }
	    };
	    /**
	     * Utility to validate code_challenge and code_challenge_method
	     * @param codeChallenge
	     * @param codeChallengeMethod
	     */
	    RequestValidator.validateCodeChallengeParams = function (codeChallenge, codeChallengeMethod) {
	        if (StringUtils.isEmpty(codeChallenge) || StringUtils.isEmpty(codeChallengeMethod)) {
	            throw ClientConfigurationError.createInvalidCodeChallengeParamsError();
	        }
	        else {
	            this.validateCodeChallengeMethod(codeChallengeMethod);
	        }
	    };
	    /**
	     * Utility to validate code_challenge_method
	     * @param codeChallengeMethod
	     */
	    RequestValidator.validateCodeChallengeMethod = function (codeChallengeMethod) {
	        if ([
	            CodeChallengeMethodValues.PLAIN,
	            CodeChallengeMethodValues.S256
	        ].indexOf(codeChallengeMethod) < 0) {
	            throw ClientConfigurationError.createInvalidCodeChallengeMethodError();
	        }
	    };
	    /**
	     * Removes unnecessary or duplicate query parameters from extraQueryParameters
	     * @param request
	     */
	    RequestValidator.sanitizeEQParams = function (eQParams, queryParams) {
	        if (!eQParams) {
	            return {};
	        }
	        // Remove any query parameters already included in SSO params
	        queryParams.forEach(function (value, key) {
	            if (eQParams[key]) {
	                delete eQParams[key];
	            }
	        });
	        return eQParams;
	    };
	    return RequestValidator;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var RequestParameterBuilder = /** @class */ (function () {
	    function RequestParameterBuilder() {
	        this.parameters = new Map();
	    }
	    /**
	     * add response_type = code
	     */
	    RequestParameterBuilder.prototype.addResponseTypeCode = function () {
	        this.parameters.set(AADServerParamKeys.RESPONSE_TYPE, encodeURIComponent(Constants.CODE_RESPONSE_TYPE));
	    };
	    /**
	     * add response_mode. defaults to query.
	     * @param responseMode
	     */
	    RequestParameterBuilder.prototype.addResponseMode = function (responseMode) {
	        this.parameters.set(AADServerParamKeys.RESPONSE_MODE, encodeURIComponent((responseMode) ? responseMode : ResponseMode.QUERY));
	    };
	    /**
	     * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
	     * @param scopeSet
	     * @param addOidcScopes
	     */
	    RequestParameterBuilder.prototype.addScopes = function (scopes, addOidcScopes) {
	        if (addOidcScopes === void 0) { addOidcScopes = true; }
	        var requestScopes = addOidcScopes ? __spreadArrays(scopes || [], OIDC_DEFAULT_SCOPES) : scopes || [];
	        var scopeSet = new ScopeSet(requestScopes);
	        this.parameters.set(AADServerParamKeys.SCOPE, encodeURIComponent(scopeSet.printScopes()));
	    };
	    /**
	     * add clientId
	     * @param clientId
	     */
	    RequestParameterBuilder.prototype.addClientId = function (clientId) {
	        this.parameters.set(AADServerParamKeys.CLIENT_ID, encodeURIComponent(clientId));
	    };
	    /**
	     * add redirect_uri
	     * @param redirectUri
	     */
	    RequestParameterBuilder.prototype.addRedirectUri = function (redirectUri) {
	        RequestValidator.validateRedirectUri(redirectUri);
	        this.parameters.set(AADServerParamKeys.REDIRECT_URI, encodeURIComponent(redirectUri));
	    };
	    /**
	     * add post logout redirectUri
	     * @param redirectUri
	     */
	    RequestParameterBuilder.prototype.addPostLogoutRedirectUri = function (redirectUri) {
	        RequestValidator.validateRedirectUri(redirectUri);
	        this.parameters.set(AADServerParamKeys.POST_LOGOUT_URI, encodeURIComponent(redirectUri));
	    };
	    /**
	     * add id_token_hint to logout request
	     * @param idTokenHint
	     */
	    RequestParameterBuilder.prototype.addIdTokenHint = function (idTokenHint) {
	        this.parameters.set(AADServerParamKeys.ID_TOKEN_HINT, encodeURIComponent(idTokenHint));
	    };
	    /**
	     * add domain_hint
	     * @param domainHint
	     */
	    RequestParameterBuilder.prototype.addDomainHint = function (domainHint) {
	        this.parameters.set(SSOTypes.DOMAIN_HINT, encodeURIComponent(domainHint));
	    };
	    /**
	     * add login_hint
	     * @param loginHint
	     */
	    RequestParameterBuilder.prototype.addLoginHint = function (loginHint) {
	        this.parameters.set(SSOTypes.LOGIN_HINT, encodeURIComponent(loginHint));
	    };
	    /**
	     * add sid
	     * @param sid
	     */
	    RequestParameterBuilder.prototype.addSid = function (sid) {
	        this.parameters.set(SSOTypes.SID, encodeURIComponent(sid));
	    };
	    /**
	     * add claims
	     * @param claims
	     */
	    RequestParameterBuilder.prototype.addClaims = function (claims, clientCapabilities) {
	        var mergedClaims = this.addClientCapabilitiesToClaims(claims, clientCapabilities);
	        RequestValidator.validateClaims(mergedClaims);
	        this.parameters.set(AADServerParamKeys.CLAIMS, encodeURIComponent(mergedClaims));
	    };
	    /**
	     * add correlationId
	     * @param correlationId
	     */
	    RequestParameterBuilder.prototype.addCorrelationId = function (correlationId) {
	        this.parameters.set(AADServerParamKeys.CLIENT_REQUEST_ID, encodeURIComponent(correlationId));
	    };
	    /**
	     * add library info query params
	     * @param libraryInfo
	     */
	    RequestParameterBuilder.prototype.addLibraryInfo = function (libraryInfo) {
	        // Telemetry Info
	        this.parameters.set(AADServerParamKeys.X_CLIENT_SKU, libraryInfo.sku);
	        this.parameters.set(AADServerParamKeys.X_CLIENT_VER, libraryInfo.version);
	        this.parameters.set(AADServerParamKeys.X_CLIENT_OS, libraryInfo.os);
	        this.parameters.set(AADServerParamKeys.X_CLIENT_CPU, libraryInfo.cpu);
	    };
	    /**
	     * add prompt
	     * @param prompt
	     */
	    RequestParameterBuilder.prototype.addPrompt = function (prompt) {
	        RequestValidator.validatePrompt(prompt);
	        this.parameters.set("" + AADServerParamKeys.PROMPT, encodeURIComponent(prompt));
	    };
	    /**
	     * add state
	     * @param state
	     */
	    RequestParameterBuilder.prototype.addState = function (state) {
	        if (!StringUtils.isEmpty(state)) {
	            this.parameters.set(AADServerParamKeys.STATE, encodeURIComponent(state));
	        }
	    };
	    /**
	     * add nonce
	     * @param nonce
	     */
	    RequestParameterBuilder.prototype.addNonce = function (nonce) {
	        this.parameters.set(AADServerParamKeys.NONCE, encodeURIComponent(nonce));
	    };
	    /**
	     * add code_challenge and code_challenge_method
	     * - throw if either of them are not passed
	     * @param codeChallenge
	     * @param codeChallengeMethod
	     */
	    RequestParameterBuilder.prototype.addCodeChallengeParams = function (codeChallenge, codeChallengeMethod) {
	        RequestValidator.validateCodeChallengeParams(codeChallenge, codeChallengeMethod);
	        if (codeChallenge && codeChallengeMethod) {
	            this.parameters.set(AADServerParamKeys.CODE_CHALLENGE, encodeURIComponent(codeChallenge));
	            this.parameters.set(AADServerParamKeys.CODE_CHALLENGE_METHOD, encodeURIComponent(codeChallengeMethod));
	        }
	        else {
	            throw ClientConfigurationError.createInvalidCodeChallengeParamsError();
	        }
	    };
	    /**
	     * add the `authorization_code` passed by the user to exchange for a token
	     * @param code
	     */
	    RequestParameterBuilder.prototype.addAuthorizationCode = function (code) {
	        this.parameters.set(AADServerParamKeys.CODE, encodeURIComponent(code));
	    };
	    /**
	     * add the `authorization_code` passed by the user to exchange for a token
	     * @param code
	     */
	    RequestParameterBuilder.prototype.addDeviceCode = function (code) {
	        this.parameters.set(AADServerParamKeys.DEVICE_CODE, encodeURIComponent(code));
	    };
	    /**
	     * add the `refreshToken` passed by the user
	     * @param refreshToken
	     */
	    RequestParameterBuilder.prototype.addRefreshToken = function (refreshToken) {
	        this.parameters.set(AADServerParamKeys.REFRESH_TOKEN, encodeURIComponent(refreshToken));
	    };
	    /**
	     * add the `code_verifier` passed by the user to exchange for a token
	     * @param codeVerifier
	     */
	    RequestParameterBuilder.prototype.addCodeVerifier = function (codeVerifier) {
	        this.parameters.set(AADServerParamKeys.CODE_VERIFIER, encodeURIComponent(codeVerifier));
	    };
	    /**
	     * add client_secret
	     * @param clientSecret
	     */
	    RequestParameterBuilder.prototype.addClientSecret = function (clientSecret) {
	        this.parameters.set(AADServerParamKeys.CLIENT_SECRET, encodeURIComponent(clientSecret));
	    };
	    /**
	     * add clientAssertion for confidential client flows
	     * @param clientAssertion
	     */
	    RequestParameterBuilder.prototype.addClientAssertion = function (clientAssertion) {
	        this.parameters.set(AADServerParamKeys.CLIENT_ASSERTION, encodeURIComponent(clientAssertion));
	    };
	    /**
	     * add clientAssertionType for confidential client flows
	     * @param clientAssertionType
	     */
	    RequestParameterBuilder.prototype.addClientAssertionType = function (clientAssertionType) {
	        this.parameters.set(AADServerParamKeys.CLIENT_ASSERTION_TYPE, encodeURIComponent(clientAssertionType));
	    };
	    /**
	     * add OBO assertion for confidential client flows
	     * @param clientAssertion
	     */
	    RequestParameterBuilder.prototype.addOboAssertion = function (oboAssertion) {
	        this.parameters.set(AADServerParamKeys.OBO_ASSERTION, encodeURIComponent(oboAssertion));
	    };
	    /**
	     * add grant type
	     * @param grantType
	     */
	    RequestParameterBuilder.prototype.addRequestTokenUse = function (tokenUse) {
	        this.parameters.set(AADServerParamKeys.REQUESTED_TOKEN_USE, encodeURIComponent(tokenUse));
	    };
	    /**
	     * add grant type
	     * @param grantType
	     */
	    RequestParameterBuilder.prototype.addGrantType = function (grantType) {
	        this.parameters.set(AADServerParamKeys.GRANT_TYPE, encodeURIComponent(grantType));
	    };
	    /**
	     * add client info
	     *
	     */
	    RequestParameterBuilder.prototype.addClientInfo = function () {
	        this.parameters.set(ClientInfo, "1");
	    };
	    /**
	     * add extraQueryParams
	     * @param eQparams
	     */
	    RequestParameterBuilder.prototype.addExtraQueryParameters = function (eQparams) {
	        var _this = this;
	        RequestValidator.sanitizeEQParams(eQparams, this.parameters);
	        Object.keys(eQparams).forEach(function (key) {
	            _this.parameters.set(key, eQparams[key]);
	        });
	    };
	    RequestParameterBuilder.prototype.addClientCapabilitiesToClaims = function (claims, clientCapabilities) {
	        var mergedClaims;
	        // Parse provided claims into JSON object or initialize empty object
	        if (!claims) {
	            mergedClaims = {};
	        }
	        else {
	            try {
	                mergedClaims = JSON.parse(claims);
	            }
	            catch (e) {
	                throw ClientConfigurationError.createInvalidClaimsRequestError();
	            }
	        }
	        if (clientCapabilities && clientCapabilities.length > 0) {
	            if (!mergedClaims.hasOwnProperty(ClaimsRequestKeys.ACCESS_TOKEN)) {
	                // Add access_token key to claims object
	                mergedClaims[ClaimsRequestKeys.ACCESS_TOKEN] = {};
	            }
	            // Add xms_cc claim with provided clientCapabilities to access_token key
	            mergedClaims[ClaimsRequestKeys.ACCESS_TOKEN][ClaimsRequestKeys.XMS_CC] = {
	                values: clientCapabilities
	            };
	        }
	        return JSON.stringify(mergedClaims);
	    };
	    /**
	     * adds `username` for Password Grant flow
	     * @param username
	     */
	    RequestParameterBuilder.prototype.addUsername = function (username) {
	        this.parameters.set(PasswordGrantConstants.username, username);
	    };
	    /**
	     * adds `password` for Password Grant flow
	     * @param password
	     */
	    RequestParameterBuilder.prototype.addPassword = function (password) {
	        this.parameters.set(PasswordGrantConstants.password, password);
	    };
	    /**
	     * add pop_jwk to query params
	     * @param cnfString
	     */
	    RequestParameterBuilder.prototype.addPopToken = function (cnfString) {
	        if (!StringUtils.isEmpty(cnfString)) {
	            this.parameters.set(AADServerParamKeys.TOKEN_TYPE, exports.AuthenticationScheme.POP);
	            this.parameters.set(AADServerParamKeys.REQ_CNF, encodeURIComponent(cnfString));
	        }
	    };
	    /**
	     * Utility to create a URL from the params map
	     */
	    RequestParameterBuilder.prototype.createQueryString = function () {
	        var queryParameterArray = new Array();
	        this.parameters.forEach(function (value, key) {
	            queryParameterArray.push(key + "=" + value);
	        });
	        return queryParameterArray.join("&");
	    };
	    return RequestParameterBuilder;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * ID_TOKEN Cache
	 *
	 * Key:Value Schema:
	 *
	 * Key Example: uid.utid-login.microsoftonline.com-idtoken-clientId-contoso.com-
	 *
	 * Value Schema:
	 * {
	 *      homeAccountId: home account identifier for the auth scheme,
	 *      environment: entity that issued the token, represented as a full host
	 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
	 *      clientId: client ID of the application
	 *      secret: Actual credential as a string
	 *      realm: Full tenant or organizational identifier that the account belongs to
	 * }
	 */
	var IdTokenEntity = /** @class */ (function (_super) {
	    __extends$1(IdTokenEntity, _super);
	    function IdTokenEntity() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Create IdTokenEntity
	     * @param homeAccountId
	     * @param authenticationResult
	     * @param clientId
	     * @param authority
	     */
	    IdTokenEntity.createIdTokenEntity = function (homeAccountId, environment, idToken, clientId, tenantId, oboAssertion) {
	        var idTokenEntity = new IdTokenEntity();
	        idTokenEntity.credentialType = CredentialType.ID_TOKEN;
	        idTokenEntity.homeAccountId = homeAccountId;
	        idTokenEntity.environment = environment;
	        idTokenEntity.clientId = clientId;
	        idTokenEntity.secret = idToken;
	        idTokenEntity.realm = tenantId;
	        idTokenEntity.oboAssertion = oboAssertion;
	        return idTokenEntity;
	    };
	    /**
	     * Validates an entity: checks for all expected params
	     * @param entity
	     */
	    IdTokenEntity.isIdTokenEntity = function (entity) {
	        if (!entity) {
	            return false;
	        }
	        return (entity.hasOwnProperty("homeAccountId") &&
	            entity.hasOwnProperty("environment") &&
	            entity.hasOwnProperty("credentialType") &&
	            entity.hasOwnProperty("realm") &&
	            entity.hasOwnProperty("clientId") &&
	            entity.hasOwnProperty("secret") &&
	            entity["credentialType"] === CredentialType.ID_TOKEN);
	    };
	    return IdTokenEntity;
	}(CredentialEntity));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Utility class which exposes functions for managing date and time operations.
	 */
	var TimeUtils = /** @class */ (function () {
	    function TimeUtils() {
	    }
	    /**
	     * return the current time in Unix time (seconds).
	     */
	    TimeUtils.nowSeconds = function () {
	        // Date.getTime() returns in milliseconds.
	        return Math.round(new Date().getTime() / 1000.0);
	    };
	    /**
	     * check if a token is expired based on given UTC time in seconds.
	     * @param expiresOn
	     */
	    TimeUtils.isTokenExpired = function (expiresOn, offset) {
	        // check for access token expiry
	        var expirationSec = Number(expiresOn) || 0;
	        var offsetCurrentTimeSec = TimeUtils.nowSeconds() + offset;
	        // If current time + offset is greater than token expiration time, then token is expired.
	        return (offsetCurrentTimeSec > expirationSec);
	    };
	    return TimeUtils;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * ACCESS_TOKEN Credential Type
	 *
	 * Key:Value Schema:
	 *
	 * Key Example: uid.utid-login.microsoftonline.com-accesstoken-clientId-contoso.com-user.read
	 *
	 * Value Schema:
	 * {
	 *      homeAccountId: home account identifier for the auth scheme,
	 *      environment: entity that issued the token, represented as a full host
	 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
	 *      clientId: client ID of the application
	 *      secret: Actual credential as a string
	 *      familyId: Family ID identifier, usually only used for refresh tokens
	 *      realm: Full tenant or organizational identifier that the account belongs to
	 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
	 *      cachedAt: Absolute device time when entry was created in the cache.
	 *      expiresOn: Token expiry time, calculated based on current UTC time in seconds. Represented as a string.
	 *      extendedExpiresOn: Additional extended expiry time until when token is valid in case of server-side outage. Represented as string in UTC seconds.
	 *      keyId: used for POP and SSH tokenTypes
	 *      tokenType: Type of the token issued. Usually "Bearer"
	 * }
	 */
	var AccessTokenEntity = /** @class */ (function (_super) {
	    __extends$1(AccessTokenEntity, _super);
	    function AccessTokenEntity() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Create AccessTokenEntity
	     * @param homeAccountId
	     * @param environment
	     * @param accessToken
	     * @param clientId
	     * @param tenantId
	     * @param scopes
	     * @param expiresOn
	     * @param extExpiresOn
	     */
	    AccessTokenEntity.createAccessTokenEntity = function (homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, tokenType, oboAssertion) {
	        var atEntity = new AccessTokenEntity();
	        atEntity.homeAccountId = homeAccountId;
	        atEntity.credentialType = CredentialType.ACCESS_TOKEN;
	        atEntity.secret = accessToken;
	        var currentTime = TimeUtils.nowSeconds();
	        atEntity.cachedAt = currentTime.toString();
	        /*
	         * Token expiry time.
	         * This value should be  calculated based on the current UTC time measured locally and the value  expires_in Represented as a string in JSON.
	         */
	        atEntity.expiresOn = expiresOn.toString();
	        atEntity.extendedExpiresOn = extExpiresOn.toString();
	        atEntity.environment = environment;
	        atEntity.clientId = clientId;
	        atEntity.realm = tenantId;
	        atEntity.target = scopes;
	        atEntity.oboAssertion = oboAssertion;
	        atEntity.tokenType = StringUtils.isEmpty(tokenType) ? exports.AuthenticationScheme.BEARER : tokenType;
	        return atEntity;
	    };
	    /**
	     * Validates an entity: checks for all expected params
	     * @param entity
	     */
	    AccessTokenEntity.isAccessTokenEntity = function (entity) {
	        if (!entity) {
	            return false;
	        }
	        return (entity.hasOwnProperty("homeAccountId") &&
	            entity.hasOwnProperty("environment") &&
	            entity.hasOwnProperty("credentialType") &&
	            entity.hasOwnProperty("realm") &&
	            entity.hasOwnProperty("clientId") &&
	            entity.hasOwnProperty("secret") &&
	            entity.hasOwnProperty("target") &&
	            entity["credentialType"] === CredentialType.ACCESS_TOKEN);
	    };
	    return AccessTokenEntity;
	}(CredentialEntity));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * REFRESH_TOKEN Cache
	 *
	 * Key:Value Schema:
	 *
	 * Key Example: uid.utid-login.microsoftonline.com-refreshtoken-clientId--
	 *
	 * Value:
	 * {
	 *      homeAccountId: home account identifier for the auth scheme,
	 *      environment: entity that issued the token, represented as a full host
	 *      credentialType: Type of credential as a string, can be one of the following: RefreshToken, AccessToken, IdToken, Password, Cookie, Certificate, Other
	 *      clientId: client ID of the application
	 *      secret: Actual credential as a string
	 *      familyId: Family ID identifier, '1' represents Microsoft Family
	 *      realm: Full tenant or organizational identifier that the account belongs to
	 *      target: Permissions that are included in the token, or for refresh tokens, the resource identifier.
	 * }
	 */
	var RefreshTokenEntity = /** @class */ (function (_super) {
	    __extends$1(RefreshTokenEntity, _super);
	    function RefreshTokenEntity() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * Create RefreshTokenEntity
	     * @param homeAccountId
	     * @param authenticationResult
	     * @param clientId
	     * @param authority
	     */
	    RefreshTokenEntity.createRefreshTokenEntity = function (homeAccountId, environment, refreshToken, clientId, familyId, oboAssertion) {
	        var rtEntity = new RefreshTokenEntity();
	        rtEntity.clientId = clientId;
	        rtEntity.credentialType = CredentialType.REFRESH_TOKEN;
	        rtEntity.environment = environment;
	        rtEntity.homeAccountId = homeAccountId;
	        rtEntity.secret = refreshToken;
	        rtEntity.oboAssertion = oboAssertion;
	        if (familyId)
	            rtEntity.familyId = familyId;
	        return rtEntity;
	    };
	    /**
	     * Validates an entity: checks for all expected params
	     * @param entity
	     */
	    RefreshTokenEntity.isRefreshTokenEntity = function (entity) {
	        if (!entity) {
	            return false;
	        }
	        return (entity.hasOwnProperty("homeAccountId") &&
	            entity.hasOwnProperty("environment") &&
	            entity.hasOwnProperty("credentialType") &&
	            entity.hasOwnProperty("clientId") &&
	            entity.hasOwnProperty("secret") &&
	            entity["credentialType"] === CredentialType.REFRESH_TOKEN);
	    };
	    return RefreshTokenEntity;
	}(CredentialEntity));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * InteractionRequiredAuthErrorMessage class containing string constants used by error codes and messages.
	 */
	var InteractionRequiredAuthErrorMessage = [
	    "interaction_required",
	    "consent_required",
	    "login_required"
	];
	var InteractionRequiredAuthSubErrorMessage = [
	    "message_only",
	    "additional_action",
	    "basic_action",
	    "user_password_expired",
	    "consent_required"
	];
	/**
	 * Error thrown when user interaction is required at the auth server.
	 */
	var InteractionRequiredAuthError = /** @class */ (function (_super) {
	    __extends$1(InteractionRequiredAuthError, _super);
	    function InteractionRequiredAuthError(errorCode, errorMessage, subError) {
	        var _this = _super.call(this, errorCode, errorMessage, subError) || this;
	        _this.name = "InteractionRequiredAuthError";
	        Object.setPrototypeOf(_this, InteractionRequiredAuthError.prototype);
	        return _this;
	    }
	    InteractionRequiredAuthError.isInteractionRequiredError = function (errorCode, errorString, subError) {
	        var isInteractionRequiredErrorCode = !!errorCode && InteractionRequiredAuthErrorMessage.indexOf(errorCode) > -1;
	        var isInteractionRequiredSubError = !!subError && InteractionRequiredAuthSubErrorMessage.indexOf(subError) > -1;
	        var isInteractionRequiredErrorDesc = !!errorString && InteractionRequiredAuthErrorMessage.some(function (irErrorCode) {
	            return errorString.indexOf(irErrorCode) > -1;
	        });
	        return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
	    };
	    return InteractionRequiredAuthError;
	}(ServerError));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var CacheRecord = /** @class */ (function () {
	    function CacheRecord(accountEntity, idTokenEntity, accessTokenEntity, refreshTokenEntity, appMetadataEntity) {
	        this.account = accountEntity || null;
	        this.idToken = idTokenEntity || null;
	        this.accessToken = accessTokenEntity || null;
	        this.refreshToken = refreshTokenEntity || null;
	        this.appMetadata = appMetadataEntity || null;
	    }
	    return CacheRecord;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Class which provides helpers for OAuth 2.0 protocol specific values
	 */
	var ProtocolUtils = /** @class */ (function () {
	    function ProtocolUtils() {
	    }
	    /**
	     * Appends user state with random guid, or returns random guid.
	     * @param userState
	     * @param randomGuid
	     */
	    ProtocolUtils.setRequestState = function (cryptoObj, userState, meta) {
	        var libraryState = ProtocolUtils.generateLibraryState(cryptoObj, meta);
	        return !StringUtils.isEmpty(userState) ? "" + libraryState + Constants.RESOURCE_DELIM + userState : libraryState;
	    };
	    /**
	     * Generates the state value used by the common library.
	     * @param randomGuid
	     * @param cryptoObj
	     */
	    ProtocolUtils.generateLibraryState = function (cryptoObj, meta) {
	        if (!cryptoObj) {
	            throw ClientAuthError.createNoCryptoObjectError("generateLibraryState");
	        }
	        // Create a state object containing a unique id and the timestamp of the request creation
	        var stateObj = {
	            id: cryptoObj.createNewGuid()
	        };
	        if (meta) {
	            stateObj.meta = meta;
	        }
	        var stateString = JSON.stringify(stateObj);
	        return cryptoObj.base64Encode(stateString);
	    };
	    /**
	     * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
	     * @param state
	     * @param cryptoObj
	     */
	    ProtocolUtils.parseRequestState = function (cryptoObj, state) {
	        if (!cryptoObj) {
	            throw ClientAuthError.createNoCryptoObjectError("parseRequestState");
	        }
	        if (StringUtils.isEmpty(state)) {
	            throw ClientAuthError.createInvalidStateError(state, "Null, undefined or empty state");
	        }
	        try {
	            // Split the state between library state and user passed state and decode them separately
	            var splitState = decodeURIComponent(state).split(Constants.RESOURCE_DELIM);
	            var libraryState = splitState[0];
	            var userState = splitState.length > 1 ? splitState.slice(1).join(Constants.RESOURCE_DELIM) : "";
	            var libraryStateString = cryptoObj.base64Decode(libraryState);
	            var libraryStateObj = JSON.parse(libraryStateString);
	            return {
	                userRequestState: !StringUtils.isEmpty(userState) ? userState : "",
	                libraryState: libraryStateObj
	            };
	        }
	        catch (e) {
	            throw ClientAuthError.createInvalidStateError(state, e);
	        }
	    };
	    return ProtocolUtils;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Url object class which can perform various transformations on url strings.
	 */
	var UrlString = /** @class */ (function () {
	    function UrlString(url) {
	        this._urlString = url;
	        if (StringUtils.isEmpty(this._urlString)) {
	            // Throws error if url is empty
	            throw ClientConfigurationError.createUrlEmptyError();
	        }
	        if (StringUtils.isEmpty(this.getHash())) {
	            this._urlString = UrlString.canonicalizeUri(url);
	        }
	    }
	    Object.defineProperty(UrlString.prototype, "urlString", {
	        get: function () {
	            return this._urlString;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Ensure urls are lower case and end with a / character.
	     * @param url
	     */
	    UrlString.canonicalizeUri = function (url) {
	        if (url) {
	            url = url.toLowerCase();
	            if (StringUtils.endsWith(url, "?")) {
	                url = url.slice(0, -1);
	            }
	            else if (StringUtils.endsWith(url, "?/")) {
	                url = url.slice(0, -2);
	            }
	            if (!StringUtils.endsWith(url, "/")) {
	                url += "/";
	            }
	        }
	        return url;
	    };
	    /**
	     * Throws if urlString passed is not a valid authority URI string.
	     */
	    UrlString.prototype.validateAsUri = function () {
	        // Attempts to parse url for uri components
	        var components;
	        try {
	            components = this.getUrlComponents();
	        }
	        catch (e) {
	            throw ClientConfigurationError.createUrlParseError(e);
	        }
	        // Throw error if URI or path segments are not parseable.
	        if (!components.HostNameAndPort || !components.PathSegments) {
	            throw ClientConfigurationError.createUrlParseError("Given url string: " + this.urlString);
	        }
	        // Throw error if uri is insecure.
	        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") {
	            throw ClientConfigurationError.createInsecureAuthorityUriError(this.urlString);
	        }
	    };
	    /**
	     * Function to remove query string params from url. Returns the new url.
	     * @param url
	     * @param name
	     */
	    UrlString.prototype.urlRemoveQueryStringParameter = function (name) {
	        var regex = new RegExp("(\\&" + name + "=)[^\&]+");
	        this._urlString = this.urlString.replace(regex, "");
	        // name=value&
	        regex = new RegExp("(" + name + "=)[^\&]+&");
	        this._urlString = this.urlString.replace(regex, "");
	        // name=value
	        regex = new RegExp("(" + name + "=)[^\&]+");
	        this._urlString = this.urlString.replace(regex, "");
	        return this.urlString;
	    };
	    UrlString.removeHashFromUrl = function (url) {
	        return UrlString.canonicalizeUri(url.split("#")[0]);
	    };
	    /**
	     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
	     * @param href The url
	     * @param tenantId The tenant id to replace
	     */
	    UrlString.prototype.replaceTenantPath = function (tenantId) {
	        var urlObject = this.getUrlComponents();
	        var pathArray = urlObject.PathSegments;
	        if (tenantId && (pathArray.length !== 0 && (pathArray[0] === AADAuthorityConstants.COMMON || pathArray[0] === AADAuthorityConstants.ORGANIZATIONS))) {
	            pathArray[0] = tenantId;
	        }
	        return UrlString.constructAuthorityUriFromObject(urlObject);
	    };
	    /**
	     * Returns the anchor part(#) of the URL
	     */
	    UrlString.prototype.getHash = function () {
	        return UrlString.parseHash(this.urlString);
	    };
	    /**
	     * Parses out the components from a url string.
	     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
	     */
	    UrlString.prototype.getUrlComponents = function () {
	        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
	        var regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
	        // If url string does not match regEx, we throw an error
	        var match = this.urlString.match(regEx);
	        if (!match) {
	            throw ClientConfigurationError.createUrlParseError("Given url string: " + this.urlString);
	        }
	        // Url component object
	        var urlComponents = {
	            Protocol: match[1],
	            HostNameAndPort: match[4],
	            AbsolutePath: match[5],
	            QueryString: match[7]
	        };
	        var pathSegments = urlComponents.AbsolutePath.split("/");
	        pathSegments = pathSegments.filter(function (val) { return val && val.length > 0; }); // remove empty elements
	        urlComponents.PathSegments = pathSegments;
	        if (!StringUtils.isEmpty(urlComponents.QueryString) && urlComponents.QueryString.endsWith("/")) {
	            urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
	        }
	        return urlComponents;
	    };
	    UrlString.getDomainFromUrl = function (url) {
	        var regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
	        var match = url.match(regEx);
	        if (!match) {
	            throw ClientConfigurationError.createUrlParseError("Given url string: " + url);
	        }
	        return match[2];
	    };
	    UrlString.getAbsoluteUrl = function (relativeUrl, baseUrl) {
	        if (relativeUrl[0] === Constants.FORWARD_SLASH) {
	            var url = new UrlString(baseUrl);
	            var baseComponents = url.getUrlComponents();
	            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
	        }
	        return relativeUrl;
	    };
	    /**
	     * Parses hash string from given string. Returns empty string if no hash symbol is found.
	     * @param hashString
	     */
	    UrlString.parseHash = function (hashString) {
	        var hashIndex1 = hashString.indexOf("#");
	        var hashIndex2 = hashString.indexOf("#/");
	        if (hashIndex2 > -1) {
	            return hashString.substring(hashIndex2 + 2);
	        }
	        else if (hashIndex1 > -1) {
	            return hashString.substring(hashIndex1 + 1);
	        }
	        return "";
	    };
	    UrlString.constructAuthorityUriFromObject = function (urlObject) {
	        return new UrlString(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"));
	    };
	    /**
	     * Returns URL hash as server auth code response object.
	     */
	    UrlString.getDeserializedHash = function (hash) {
	        // Check if given hash is empty
	        if (StringUtils.isEmpty(hash)) {
	            return {};
	        }
	        // Strip the # symbol if present
	        var parsedHash = UrlString.parseHash(hash);
	        // If # symbol was not present, above will return empty string, so give original hash value
	        var deserializedHash = StringUtils.queryStringToObject(StringUtils.isEmpty(parsedHash) ? hash : parsedHash);
	        // Check if deserialization didn't work
	        if (!deserializedHash) {
	            throw ClientAuthError.createHashNotDeserializedError(JSON.stringify(deserializedHash));
	        }
	        return deserializedHash;
	    };
	    /**
	     * Check if the hash of the URL string contains known properties
	     */
	    UrlString.hashContainsKnownProperties = function (hash) {
	        if (StringUtils.isEmpty(hash)) {
	            return false;
	        }
	        var parameters = UrlString.getDeserializedHash(hash);
	        return !!(parameters.code ||
	            parameters.error_description ||
	            parameters.error ||
	            parameters.state);
	    };
	    return UrlString;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var KeyLocation;
	(function (KeyLocation) {
	    KeyLocation["SW"] = "sw";
	    KeyLocation["UHW"] = "uhw";
	})(KeyLocation || (KeyLocation = {}));
	var PopTokenGenerator = /** @class */ (function () {
	    function PopTokenGenerator(cryptoUtils) {
	        this.cryptoUtils = cryptoUtils;
	    }
	    PopTokenGenerator.prototype.generateCnf = function (resourceRequestMethod, resourceRequestUri) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var kidThumbprint, reqCnf;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.cryptoUtils.getPublicKeyThumbprint(resourceRequestMethod, resourceRequestUri)];
	                    case 1:
	                        kidThumbprint = _a.sent();
	                        reqCnf = {
	                            kid: kidThumbprint,
	                            xms_ksl: KeyLocation.SW
	                        };
	                        return [2 /*return*/, this.cryptoUtils.base64Encode(JSON.stringify(reqCnf))];
	                }
	            });
	        });
	    };
	    PopTokenGenerator.prototype.signPopToken = function (accessToken, resourceRequestMethod, resourceRequestUri) {
	        var _a;
	        return __awaiter$1(this, void 0, void 0, function () {
	            var tokenClaims, resourceUrlString, resourceUrlComponents;
	            return __generator$1(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        tokenClaims = AuthToken.extractTokenClaims(accessToken, this.cryptoUtils);
	                        resourceUrlString = new UrlString(resourceRequestUri);
	                        resourceUrlComponents = resourceUrlString.getUrlComponents();
	                        if (!((_a = tokenClaims === null || tokenClaims === void 0 ? void 0 : tokenClaims.cnf) === null || _a === void 0 ? void 0 : _a.kid)) {
	                            throw ClientAuthError.createTokenClaimsRequiredError();
	                        }
	                        return [4 /*yield*/, this.cryptoUtils.signJwt({
	                                at: accessToken,
	                                ts: "" + TimeUtils.nowSeconds(),
	                                m: resourceRequestMethod.toUpperCase(),
	                                u: resourceUrlComponents.HostNameAndPort || "",
	                                nonce: this.cryptoUtils.createNewGuid(),
	                                p: resourceUrlComponents.AbsolutePath,
	                                q: [[], resourceUrlComponents.QueryString],
	                            }, tokenClaims.cnf.kid)];
	                    case 1: return [2 /*return*/, _b.sent()];
	                }
	            });
	        });
	    };
	    return PopTokenGenerator;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * APP_METADATA Cache
	 *
	 * Key:Value Schema:
	 *
	 * Key: appmetadata-<environment>-<client_id>
	 *
	 * Value:
	 * {
	 *      clientId: client ID of the application
	 *      environment: entity that issued the token, represented as a full host
	 *      familyId: Family ID identifier, '1' represents Microsoft Family
	 * }
	 */
	var AppMetadataEntity = /** @class */ (function () {
	    function AppMetadataEntity() {
	    }
	    /**
	     * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
	     */
	    AppMetadataEntity.prototype.generateAppMetadataKey = function () {
	        return AppMetadataEntity.generateAppMetadataCacheKey(this.environment, this.clientId);
	    };
	    /**
	     * Generate AppMetadata Cache Key
	     */
	    AppMetadataEntity.generateAppMetadataCacheKey = function (environment, clientId) {
	        var appMetaDataKeyArray = [
	            APP_METADATA,
	            environment,
	            clientId,
	        ];
	        return appMetaDataKeyArray.join(Separators.CACHE_KEY_SEPARATOR).toLowerCase();
	    };
	    /**
	     * Creates AppMetadataEntity
	     * @param clientId
	     * @param environment
	     * @param familyId
	     */
	    AppMetadataEntity.createAppMetadataEntity = function (clientId, environment, familyId) {
	        var appMetadata = new AppMetadataEntity();
	        appMetadata.clientId = clientId;
	        appMetadata.environment = environment;
	        if (familyId) {
	            appMetadata.familyId = familyId;
	        }
	        return appMetadata;
	    };
	    /**
	     * Validates an entity: checks for all expected params
	     * @param entity
	     */
	    AppMetadataEntity.isAppMetadataEntity = function (key, entity) {
	        if (!entity) {
	            return false;
	        }
	        return (key.indexOf(APP_METADATA) === 0 &&
	            entity.hasOwnProperty("clientId") &&
	            entity.hasOwnProperty("environment"));
	    };
	    return AppMetadataEntity;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * This class instance helps track the memory changes facilitating
	 * decisions to read from and write to the persistent cache
	 */ var TokenCacheContext = /** @class */ (function () {
	    function TokenCacheContext(tokenCache, hasChanged) {
	        this.cache = tokenCache;
	        this.hasChanged = hasChanged;
	    }
	    Object.defineProperty(TokenCacheContext.prototype, "cacheHasChanged", {
	        /**
	         * boolean which indicates the changes in cache
	         */
	        get: function () {
	            return this.hasChanged;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TokenCacheContext.prototype, "tokenCache", {
	        /**
	         * function to retrieve the token cache
	         */
	        get: function () {
	            return this.cache;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return TokenCacheContext;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Class that handles response parsing.
	 */
	var ResponseHandler = /** @class */ (function () {
	    function ResponseHandler(clientId, cacheStorage, cryptoObj, logger, serializableCache, persistencePlugin) {
	        this.clientId = clientId;
	        this.cacheStorage = cacheStorage;
	        this.cryptoObj = cryptoObj;
	        this.logger = logger;
	        this.serializableCache = serializableCache;
	        this.persistencePlugin = persistencePlugin;
	    }
	    /**
	     * Function which validates server authorization code response.
	     * @param serverResponseHash
	     * @param cachedState
	     * @param cryptoObj
	     */
	    ResponseHandler.prototype.validateServerAuthorizationCodeResponse = function (serverResponseHash, cachedState, cryptoObj) {
	        if (!serverResponseHash.state || !cachedState) {
	            throw !serverResponseHash.state ? ClientAuthError.createStateNotFoundError("Server State") : ClientAuthError.createStateNotFoundError("Cached State");
	        }
	        if (decodeURIComponent(serverResponseHash.state) !== decodeURIComponent(cachedState)) {
	            throw ClientAuthError.createStateMismatchError();
	        }
	        // Check for error
	        if (serverResponseHash.error || serverResponseHash.error_description || serverResponseHash.suberror) {
	            if (InteractionRequiredAuthError.isInteractionRequiredError(serverResponseHash.error, serverResponseHash.error_description, serverResponseHash.suberror)) {
	                throw new InteractionRequiredAuthError(serverResponseHash.error || Constants.EMPTY_STRING, serverResponseHash.error_description, serverResponseHash.suberror);
	            }
	            throw new ServerError(serverResponseHash.error || Constants.EMPTY_STRING, serverResponseHash.error_description, serverResponseHash.suberror);
	        }
	        if (serverResponseHash.client_info) {
	            buildClientInfo(serverResponseHash.client_info, cryptoObj);
	        }
	    };
	    /**
	     * Function which validates server authorization token response.
	     * @param serverResponse
	     */
	    ResponseHandler.prototype.validateTokenResponse = function (serverResponse) {
	        // Check for error
	        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
	            if (InteractionRequiredAuthError.isInteractionRequiredError(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) {
	                throw new InteractionRequiredAuthError(serverResponse.error, serverResponse.error_description, serverResponse.suberror);
	            }
	            var errString = serverResponse.error_codes + " - [" + serverResponse.timestamp + "]: " + serverResponse.error_description + " - Correlation ID: " + serverResponse.correlation_id + " - Trace ID: " + serverResponse.trace_id;
	            throw new ServerError(serverResponse.error, errString);
	        }
	    };
	    /**
	     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
	     * @param serverTokenResponse
	     * @param authority
	     */
	    ResponseHandler.prototype.handleServerTokenResponse = function (serverTokenResponse, authority, reqTimestamp, resourceRequestMethod, resourceRequestUri, authCodePayload, requestScopes, oboAssertion, handlingRefreshTokenResponse) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var idTokenObj, requestStateObj, cacheRecord, cacheContext, key, account;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (serverTokenResponse.id_token) {
	                            idTokenObj = new AuthToken(serverTokenResponse.id_token || Constants.EMPTY_STRING, this.cryptoObj);
	                            // token nonce check (TODO: Add a warning if no nonce is given?)
	                            if (authCodePayload && !StringUtils.isEmpty(authCodePayload.nonce)) {
	                                if (idTokenObj.claims.nonce !== authCodePayload.nonce) {
	                                    throw ClientAuthError.createNonceMismatchError();
	                                }
	                            }
	                        }
	                        // generate homeAccountId
	                        this.homeAccountIdentifier = AccountEntity.generateHomeAccountId(serverTokenResponse.client_info || Constants.EMPTY_STRING, authority.authorityType, this.logger, this.cryptoObj, idTokenObj);
	                        if (!!authCodePayload && !!authCodePayload.state) {
	                            requestStateObj = ProtocolUtils.parseRequestState(this.cryptoObj, authCodePayload.state);
	                        }
	                        cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, idTokenObj, requestScopes, oboAssertion, authCodePayload);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, , 4, 7]);
	                        if (!(this.persistencePlugin && this.serializableCache)) return [3 /*break*/, 3];
	                        this.logger.verbose("Persistence enabled, calling beforeCacheAccess");
	                        cacheContext = new TokenCacheContext(this.serializableCache, true);
	                        return [4 /*yield*/, this.persistencePlugin.beforeCacheAccess(cacheContext)];
	                    case 2:
	                        _a.sent();
	                        _a.label = 3;
	                    case 3:
	                        /*
	                         * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
	                         * If not present, we should return null, as it's the case that another application called removeAccount in between
	                         * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal.
	                         */
	                        if (handlingRefreshTokenResponse && cacheRecord.account) {
	                            key = cacheRecord.account.generateAccountKey();
	                            account = this.cacheStorage.getAccount(key);
	                            if (!account) {
	                                this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache");
	                                return [2 /*return*/, ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, idTokenObj, requestStateObj, resourceRequestMethod, resourceRequestUri)];
	                            }
	                        }
	                        this.cacheStorage.saveCacheRecord(cacheRecord);
	                        return [3 /*break*/, 7];
	                    case 4:
	                        if (!(this.persistencePlugin && this.serializableCache && cacheContext)) return [3 /*break*/, 6];
	                        this.logger.verbose("Persistence enabled, calling afterCacheAccess");
	                        return [4 /*yield*/, this.persistencePlugin.afterCacheAccess(cacheContext)];
	                    case 5:
	                        _a.sent();
	                        _a.label = 6;
	                    case 6: return [7 /*endfinally*/];
	                    case 7: return [2 /*return*/, ResponseHandler.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, idTokenObj, requestStateObj, resourceRequestMethod, resourceRequestUri)];
	                }
	            });
	        });
	    };
	    /**
	     * Generates CacheRecord
	     * @param serverTokenResponse
	     * @param idTokenObj
	     * @param authority
	     */
	    ResponseHandler.prototype.generateCacheRecord = function (serverTokenResponse, authority, reqTimestamp, idTokenObj, requestScopes, oboAssertion, authCodePayload) {
	        var env = authority.getPreferredCache();
	        if (StringUtils.isEmpty(env)) {
	            throw ClientAuthError.createInvalidCacheEnvironmentError();
	        }
	        // IdToken: non AAD scenarios can have empty realm
	        var cachedIdToken;
	        var cachedAccount;
	        if (!StringUtils.isEmpty(serverTokenResponse.id_token) && !!idTokenObj) {
	            cachedIdToken = IdTokenEntity.createIdTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.id_token || Constants.EMPTY_STRING, this.clientId, idTokenObj.claims.tid || Constants.EMPTY_STRING, oboAssertion);
	            cachedAccount = this.generateAccountEntity(serverTokenResponse, idTokenObj, authority, oboAssertion, authCodePayload);
	        }
	        // AccessToken
	        var cachedAccessToken = null;
	        if (!StringUtils.isEmpty(serverTokenResponse.access_token)) {
	            // If scopes not returned in server response, use request scopes
	            var responseScopes = serverTokenResponse.scope ? ScopeSet.fromString(serverTokenResponse.scope) : new ScopeSet(requestScopes || []);
	            // Use timestamp calculated before request
	            var tokenExpirationSeconds = reqTimestamp + (serverTokenResponse.expires_in || 0);
	            var extendedTokenExpirationSeconds = tokenExpirationSeconds + (serverTokenResponse.ext_expires_in || 0);
	            // non AAD scenarios can have empty realm
	            cachedAccessToken = AccessTokenEntity.createAccessTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.access_token || Constants.EMPTY_STRING, this.clientId, idTokenObj ? idTokenObj.claims.tid || Constants.EMPTY_STRING : authority.tenant, responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, serverTokenResponse.token_type, oboAssertion);
	        }
	        // refreshToken
	        var cachedRefreshToken = null;
	        if (!StringUtils.isEmpty(serverTokenResponse.refresh_token)) {
	            cachedRefreshToken = RefreshTokenEntity.createRefreshTokenEntity(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token || Constants.EMPTY_STRING, this.clientId, serverTokenResponse.foci, oboAssertion);
	        }
	        // appMetadata
	        var cachedAppMetadata = null;
	        if (!StringUtils.isEmpty(serverTokenResponse.foci)) {
	            cachedAppMetadata = AppMetadataEntity.createAppMetadataEntity(this.clientId, env, serverTokenResponse.foci);
	        }
	        return new CacheRecord(cachedAccount, cachedIdToken, cachedAccessToken, cachedRefreshToken, cachedAppMetadata);
	    };
	    /**
	     * Generate Account
	     * @param serverTokenResponse
	     * @param idToken
	     * @param authority
	     */
	    ResponseHandler.prototype.generateAccountEntity = function (serverTokenResponse, idToken, authority, oboAssertion, authCodePayload) {
	        var authorityType = authority.authorityType;
	        var cloudGraphHostName = authCodePayload ? authCodePayload.cloud_graph_host_name : "";
	        var msGraphhost = authCodePayload ? authCodePayload.msgraph_host : "";
	        // ADFS does not require client_info in the response
	        if (authorityType === AuthorityType.Adfs) {
	            this.logger.verbose("Authority type is ADFS, creating ADFS account");
	            return AccountEntity.createGenericAccount(authority, this.homeAccountIdentifier, idToken, oboAssertion, cloudGraphHostName, msGraphhost);
	        }
	        // This fallback applies to B2C as well as they fall under an AAD account type.
	        if (StringUtils.isEmpty(serverTokenResponse.client_info) && authority.protocolMode === "AAD") {
	            throw ClientAuthError.createClientInfoEmptyError();
	        }
	        return serverTokenResponse.client_info ?
	            AccountEntity.createAccount(serverTokenResponse.client_info, this.homeAccountIdentifier, authority, idToken, oboAssertion, cloudGraphHostName, msGraphhost) :
	            AccountEntity.createGenericAccount(authority, this.homeAccountIdentifier, idToken, oboAssertion, cloudGraphHostName, msGraphhost);
	    };
	    /**
	     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
	     *
	     * Optionally takes a state string that is set as-is in the response.
	     *
	     * @param cacheRecord
	     * @param idTokenObj
	     * @param fromTokenCache
	     * @param stateString
	     */
	    ResponseHandler.generateAuthenticationResult = function (cryptoObj, authority, cacheRecord, fromTokenCache, idTokenObj, requestState, resourceRequestMethod, resourceRequestUri) {
	        var _a, _b, _c;
	        return __awaiter$1(this, void 0, void 0, function () {
	            var accessToken, responseScopes, expiresOn, extExpiresOn, familyId, popTokenGenerator, uid, tid;
	            return __generator$1(this, function (_d) {
	                switch (_d.label) {
	                    case 0:
	                        accessToken = "";
	                        responseScopes = [];
	                        expiresOn = null;
	                        familyId = Constants.EMPTY_STRING;
	                        if (!cacheRecord.accessToken) return [3 /*break*/, 4];
	                        if (!(cacheRecord.accessToken.tokenType === exports.AuthenticationScheme.POP)) return [3 /*break*/, 2];
	                        popTokenGenerator = new PopTokenGenerator(cryptoObj);
	                        if (!resourceRequestMethod || !resourceRequestUri) {
	                            throw ClientConfigurationError.createResourceRequestParametersRequiredError();
	                        }
	                        return [4 /*yield*/, popTokenGenerator.signPopToken(cacheRecord.accessToken.secret, resourceRequestMethod, resourceRequestUri)];
	                    case 1:
	                        accessToken = _d.sent();
	                        return [3 /*break*/, 3];
	                    case 2:
	                        accessToken = cacheRecord.accessToken.secret;
	                        _d.label = 3;
	                    case 3:
	                        responseScopes = ScopeSet.fromString(cacheRecord.accessToken.target).asArray();
	                        expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
	                        extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
	                        _d.label = 4;
	                    case 4:
	                        if (cacheRecord.appMetadata) {
	                            familyId = cacheRecord.appMetadata.familyId === THE_FAMILY_ID ? THE_FAMILY_ID : Constants.EMPTY_STRING;
	                        }
	                        uid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.oid) || (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.sub) || Constants.EMPTY_STRING;
	                        tid = (idTokenObj === null || idTokenObj === void 0 ? void 0 : idTokenObj.claims.tid) || Constants.EMPTY_STRING;
	                        return [2 /*return*/, {
	                                authority: authority.canonicalAuthority,
	                                uniqueId: uid,
	                                tenantId: tid,
	                                scopes: responseScopes,
	                                account: cacheRecord.account ? cacheRecord.account.getAccountInfo() : null,
	                                idToken: idTokenObj ? idTokenObj.rawToken : Constants.EMPTY_STRING,
	                                idTokenClaims: idTokenObj ? idTokenObj.claims : {},
	                                accessToken: accessToken,
	                                fromCache: fromTokenCache,
	                                expiresOn: expiresOn,
	                                extExpiresOn: extExpiresOn,
	                                familyId: familyId,
	                                tokenType: ((_a = cacheRecord.accessToken) === null || _a === void 0 ? void 0 : _a.tokenType) || Constants.EMPTY_STRING,
	                                state: requestState ? requestState.userRequestState : Constants.EMPTY_STRING,
	                                cloudGraphHostName: ((_b = cacheRecord.account) === null || _b === void 0 ? void 0 : _b.cloudGraphHostName) || Constants.EMPTY_STRING,
	                                msGraphHost: ((_c = cacheRecord.account) === null || _c === void 0 ? void 0 : _c.msGraphHost) || Constants.EMPTY_STRING
	                            }];
	                }
	            });
	        });
	    };
	    return ResponseHandler;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Oauth2.0 Authorization Code client
	 */
	var AuthorizationCodeClient = /** @class */ (function (_super) {
	    __extends$1(AuthorizationCodeClient, _super);
	    function AuthorizationCodeClient(configuration) {
	        return _super.call(this, configuration) || this;
	    }
	    /**
	     * Creates the URL of the authorization request letting the user input credentials and consent to the
	     * application. The URL target the /authorize endpoint of the authority configured in the
	     * application object.
	     *
	     * Once the user inputs their credentials and consents, the authority will send a response to the redirect URI
	     * sent in the request and should contain an authorization code, which can then be used to acquire tokens via
	     * acquireToken(AuthorizationCodeRequest)
	     * @param request
	     */
	    AuthorizationCodeClient.prototype.getAuthCodeUrl = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var queryString;
	            return __generator$1(this, function (_a) {
	                queryString = this.createAuthCodeUrlQueryString(request);
	                return [2 /*return*/, this.authority.authorizationEndpoint + "?" + queryString];
	            });
	        });
	    };
	    /**
	     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
	     * authorization_code_grant
	     * @param request
	     */
	    AuthorizationCodeClient.prototype.acquireToken = function (request, authCodePayload) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var reqTimestamp, response, responseHandler;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.logger.info("in acquireToken call");
	                        if (!request || StringUtils.isEmpty(request.code)) {
	                            throw ClientAuthError.createTokenRequestCannotBeMadeError();
	                        }
	                        reqTimestamp = TimeUtils.nowSeconds();
	                        return [4 /*yield*/, this.executeTokenRequest(this.authority, request)];
	                    case 1:
	                        response = _a.sent();
	                        responseHandler = new ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
	                        // Validate response. This function throws a server error if an error is returned by the server.
	                        responseHandler.validateTokenResponse(response.body);
	                        return [4 /*yield*/, responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request.resourceRequestMethod, request.resourceRequestUri, authCodePayload)];
	                    case 2: return [2 /*return*/, _a.sent()];
	                }
	            });
	        });
	    };
	    /**
	     * Handles the hash fragment response from public client code request. Returns a code response used by
	     * the client to exchange for a token in acquireToken.
	     * @param hashFragment
	     */
	    AuthorizationCodeClient.prototype.handleFragmentResponse = function (hashFragment, cachedState) {
	        // Handle responses.
	        var responseHandler = new ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, null, null);
	        // Deserialize hash fragment response parameters.
	        var hashUrlString = new UrlString(hashFragment);
	        // Deserialize hash fragment response parameters.
	        var serverParams = UrlString.getDeserializedHash(hashUrlString.getHash());
	        // Get code response
	        responseHandler.validateServerAuthorizationCodeResponse(serverParams, cachedState, this.cryptoUtils);
	        // throw when there is no auth code in the response
	        if (!serverParams.code) {
	            throw ClientAuthError.createNoAuthCodeInServerResponseError();
	        }
	        return __assign$1(__assign$1({}, serverParams), { 
	            // Code param is optional in ServerAuthorizationCodeResponse but required in AuthorizationCodePaylod
	            code: serverParams.code });
	    };
	    /**
	     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
	     * Default behaviour is to redirect the user to `window.location.href`.
	     * @param authorityUri
	     */
	    AuthorizationCodeClient.prototype.getLogoutUri = function (logoutRequest) {
	        // Throw error if logoutRequest is null/undefined
	        if (!logoutRequest) {
	            throw ClientConfigurationError.createEmptyLogoutRequestError();
	        }
	        if (logoutRequest.account) {
	            // Clear given account.
	            this.cacheManager.removeAccount(AccountEntity.generateAccountCacheKey(logoutRequest.account));
	        }
	        else {
	            // Clear all accounts and tokens
	            this.cacheManager.clear();
	        }
	        var queryString = this.createLogoutUrlQueryString(logoutRequest);
	        // Construct logout URI.
	        return StringUtils.isEmpty(queryString) ? this.authority.endSessionEndpoint : this.authority.endSessionEndpoint + "?" + queryString;
	    };
	    /**
	     * Executes POST request to token endpoint
	     * @param authority
	     * @param request
	     */
	    AuthorizationCodeClient.prototype.executeTokenRequest = function (authority, request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var thumbprint, requestBody, headers;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        thumbprint = {
	                            clientId: this.config.authOptions.clientId,
	                            authority: authority.canonicalAuthority,
	                            scopes: request.scopes
	                        };
	                        return [4 /*yield*/, this.createTokenRequestBody(request)];
	                    case 1:
	                        requestBody = _a.sent();
	                        headers = this.createDefaultTokenRequestHeaders();
	                        return [2 /*return*/, this.executePostToTokenEndpoint(authority.tokenEndpoint, requestBody, headers, thumbprint)];
	                }
	            });
	        });
	    };
	    /**
	     * Generates a map for all the params to be sent to the service
	     * @param request
	     */
	    AuthorizationCodeClient.prototype.createTokenRequestBody = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var parameterBuilder, clientAssertion, popTokenGenerator, cnfString, correlationId;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        parameterBuilder = new RequestParameterBuilder();
	                        parameterBuilder.addClientId(this.config.authOptions.clientId);
	                        // validate the redirectUri (to be a non null value)
	                        parameterBuilder.addRedirectUri(request.redirectUri);
	                        // Add scope array, parameter builder will add default scopes and dedupe
	                        parameterBuilder.addScopes(request.scopes);
	                        // add code: user set, not validated
	                        parameterBuilder.addAuthorizationCode(request.code);
	                        // add code_verifier if passed
	                        if (request.codeVerifier) {
	                            parameterBuilder.addCodeVerifier(request.codeVerifier);
	                        }
	                        if (this.config.clientCredentials.clientSecret) {
	                            parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
	                        }
	                        if (this.config.clientCredentials.clientAssertion) {
	                            clientAssertion = this.config.clientCredentials.clientAssertion;
	                            parameterBuilder.addClientAssertion(clientAssertion.assertion);
	                            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
	                        }
	                        parameterBuilder.addGrantType(GrantType.AUTHORIZATION_CODE_GRANT);
	                        parameterBuilder.addClientInfo();
	                        if (!(request.authenticationScheme === exports.AuthenticationScheme.POP && !!request.resourceRequestMethod && !!request.resourceRequestUri)) return [3 /*break*/, 2];
	                        popTokenGenerator = new PopTokenGenerator(this.cryptoUtils);
	                        return [4 /*yield*/, popTokenGenerator.generateCnf(request.resourceRequestMethod, request.resourceRequestUri)];
	                    case 1:
	                        cnfString = _a.sent();
	                        parameterBuilder.addPopToken(cnfString);
	                        _a.label = 2;
	                    case 2:
	                        correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
	                        parameterBuilder.addCorrelationId(correlationId);
	                        if (!StringUtils.isEmpty(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
	                            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
	                        }
	                        return [2 /*return*/, parameterBuilder.createQueryString()];
	                }
	            });
	        });
	    };
	    /**
	     * This API validates the `AuthorizationCodeUrlRequest` and creates a URL
	     * @param request
	     */
	    AuthorizationCodeClient.prototype.createAuthCodeUrlQueryString = function (request) {
	        var parameterBuilder = new RequestParameterBuilder();
	        parameterBuilder.addClientId(this.config.authOptions.clientId);
	        var requestScopes = __spreadArrays(request.scopes || [], request.extraScopesToConsent || []);
	        parameterBuilder.addScopes(requestScopes);
	        // validate the redirectUri (to be a non null value)
	        parameterBuilder.addRedirectUri(request.redirectUri);
	        // generate the correlationId if not set by the user and add
	        var correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
	        parameterBuilder.addCorrelationId(correlationId);
	        // add response_mode. If not passed in it defaults to query.
	        parameterBuilder.addResponseMode(request.responseMode);
	        // add response_type = code
	        parameterBuilder.addResponseTypeCode();
	        // add library info parameters
	        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
	        // add client_info=1
	        parameterBuilder.addClientInfo();
	        if (request.codeChallenge && request.codeChallengeMethod) {
	            parameterBuilder.addCodeChallengeParams(request.codeChallenge, request.codeChallengeMethod);
	        }
	        if (request.prompt) {
	            parameterBuilder.addPrompt(request.prompt);
	        }
	        if (request.domainHint) {
	            parameterBuilder.addDomainHint(request.domainHint);
	        }
	        // Add sid or loginHint with preference for sid -> loginHint -> username of AccountInfo object
	        if (request.sid) {
	            parameterBuilder.addSid(request.sid);
	        }
	        else if (request.account) {
	            var accountSid = this.extractAccountSid(request.account);
	            // If account and loginHint are provided, we will check account first for sid before adding loginHint
	            if (accountSid) {
	                parameterBuilder.addSid(accountSid);
	            }
	            else if (request.loginHint) {
	                parameterBuilder.addLoginHint(request.loginHint);
	            }
	            else if (request.account.username) {
	                // Fallback to account username if provided
	                parameterBuilder.addLoginHint(request.account.username);
	            }
	        }
	        else if (request.loginHint) {
	            parameterBuilder.addLoginHint(request.loginHint);
	        }
	        if (request.nonce) {
	            parameterBuilder.addNonce(request.nonce);
	        }
	        if (request.state) {
	            parameterBuilder.addState(request.state);
	        }
	        if (!StringUtils.isEmpty(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
	            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
	        }
	        if (request.extraQueryParameters) {
	            parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
	        }
	        return parameterBuilder.createQueryString();
	    };
	    /**
	     * This API validates the `EndSessionRequest` and creates a URL
	     * @param request
	     */
	    AuthorizationCodeClient.prototype.createLogoutUrlQueryString = function (request) {
	        var parameterBuilder = new RequestParameterBuilder();
	        if (request.postLogoutRedirectUri) {
	            parameterBuilder.addPostLogoutRedirectUri(request.postLogoutRedirectUri);
	        }
	        if (request.correlationId) {
	            parameterBuilder.addCorrelationId(request.correlationId);
	        }
	        if (request.idTokenHint) {
	            parameterBuilder.addIdTokenHint(request.idTokenHint);
	        }
	        return parameterBuilder.createQueryString();
	    };
	    /**
	     * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
	     * @param account
	     */
	    AuthorizationCodeClient.prototype.extractAccountSid = function (account) {
	        if (account.idTokenClaims) {
	            var tokenClaims = account.idTokenClaims;
	            return tokenClaims.sid || null;
	        }
	        return null;
	    };
	    return AuthorizationCodeClient;
	}(BaseClient));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * OAuth2.0 Device code client
	 */
	var DeviceCodeClient = /** @class */ (function (_super) {
	    __extends$1(DeviceCodeClient, _super);
	    function DeviceCodeClient(configuration) {
	        return _super.call(this, configuration) || this;
	    }
	    /**
	     * Gets device code from device code endpoint, calls back to with device code response, and
	     * polls token endpoint to exchange device code for tokens
	     * @param request
	     */
	    DeviceCodeClient.prototype.acquireToken = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var deviceCodeResponse, reqTimestamp, response, responseHandler;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.getDeviceCode(request)];
	                    case 1:
	                        deviceCodeResponse = _a.sent();
	                        request.deviceCodeCallback(deviceCodeResponse);
	                        reqTimestamp = TimeUtils.nowSeconds();
	                        return [4 /*yield*/, this.acquireTokenWithDeviceCode(request, deviceCodeResponse)];
	                    case 2:
	                        response = _a.sent();
	                        responseHandler = new ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
	                        // Validate response. This function throws a server error if an error is returned by the server.
	                        responseHandler.validateTokenResponse(response);
	                        return [4 /*yield*/, responseHandler.handleServerTokenResponse(response, this.authority, reqTimestamp, request.resourceRequestMethod, request.resourceRequestUri)];
	                    case 3: return [2 /*return*/, _a.sent()];
	                }
	            });
	        });
	    };
	    /**
	     * Creates device code request and executes http GET
	     * @param request
	     */
	    DeviceCodeClient.prototype.getDeviceCode = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var queryString, headers, thumbprint;
	            return __generator$1(this, function (_a) {
	                queryString = this.createQueryString(request);
	                headers = this.createDefaultTokenRequestHeaders();
	                thumbprint = {
	                    clientId: this.config.authOptions.clientId,
	                    authority: request.authority,
	                    scopes: request.scopes
	                };
	                return [2 /*return*/, this.executePostRequestToDeviceCodeEndpoint(this.authority.deviceCodeEndpoint, queryString, headers, thumbprint)];
	            });
	        });
	    };
	    /**
	     * Executes POST request to device code endpoint
	     * @param deviceCodeEndpoint
	     * @param queryString
	     * @param headers
	     */
	    DeviceCodeClient.prototype.executePostRequestToDeviceCodeEndpoint = function (deviceCodeEndpoint, queryString, headers, thumbprint) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var _a, userCode, deviceCode, verificationUri, expiresIn, interval, message;
	            return __generator$1(this, function (_b) {
	                switch (_b.label) {
	                    case 0: return [4 /*yield*/, this.networkManager.sendPostRequest(thumbprint, deviceCodeEndpoint, {
	                            body: queryString,
	                            headers: headers
	                        })];
	                    case 1:
	                        _a = (_b.sent()).body, userCode = _a.user_code, deviceCode = _a.device_code, verificationUri = _a.verification_uri, expiresIn = _a.expires_in, interval = _a.interval, message = _a.message;
	                        return [2 /*return*/, {
	                                userCode: userCode,
	                                deviceCode: deviceCode,
	                                verificationUri: verificationUri,
	                                expiresIn: expiresIn,
	                                interval: interval,
	                                message: message
	                            }];
	                }
	            });
	        });
	    };
	    /**
	     * Create device code endpoint query parameters and returns string
	     */
	    DeviceCodeClient.prototype.createQueryString = function (request) {
	        var parameterBuilder = new RequestParameterBuilder();
	        parameterBuilder.addScopes(request.scopes);
	        parameterBuilder.addClientId(this.config.authOptions.clientId);
	        if (!StringUtils.isEmpty(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
	            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
	        }
	        return parameterBuilder.createQueryString();
	    };
	    /**
	     * Creates token request with device code response and polls token endpoint at interval set by the device code
	     * response
	     * @param request
	     * @param deviceCodeResponse
	     */
	    DeviceCodeClient.prototype.acquireTokenWithDeviceCode = function (request, deviceCodeResponse) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var requestBody, headers, userSpecifiedTimeout, deviceCodeExpirationTime, pollingIntervalMilli;
	            var _this = this;
	            return __generator$1(this, function (_a) {
	                requestBody = this.createTokenRequestBody(request, deviceCodeResponse);
	                headers = this.createDefaultTokenRequestHeaders();
	                userSpecifiedTimeout = request.timeout ? TimeUtils.nowSeconds() + request.timeout : undefined;
	                deviceCodeExpirationTime = TimeUtils.nowSeconds() + deviceCodeResponse.expiresIn;
	                pollingIntervalMilli = deviceCodeResponse.interval * 1000;
	                /*
	                 * Poll token endpoint while (device code is not expired AND operation has not been cancelled by
	                 * setting CancellationToken.cancel = true). POST request is sent at interval set by pollingIntervalMilli
	                 */
	                return [2 /*return*/, new Promise(function (resolve, reject) {
	                        var intervalId = setInterval(function () { return __awaiter$1(_this, void 0, void 0, function () {
	                            var thumbprint, response, error_1;
	                            return __generator$1(this, function (_a) {
	                                switch (_a.label) {
	                                    case 0:
	                                        _a.trys.push([0, 6, , 7]);
	                                        if (!request.cancel) return [3 /*break*/, 1];
	                                        this.logger.error("Token request cancelled by setting DeviceCodeRequest.cancel = true");
	                                        clearInterval(intervalId);
	                                        reject(ClientAuthError.createDeviceCodeCancelledError());
	                                        return [3 /*break*/, 5];
	                                    case 1:
	                                        if (!(userSpecifiedTimeout && userSpecifiedTimeout < deviceCodeExpirationTime && TimeUtils.nowSeconds() > userSpecifiedTimeout)) return [3 /*break*/, 2];
	                                        this.logger.error("User defined timeout for device code polling reached. The timeout was set for " + userSpecifiedTimeout);
	                                        clearInterval(intervalId);
	                                        reject(ClientAuthError.createUserTimeoutReachedError());
	                                        return [3 /*break*/, 5];
	                                    case 2:
	                                        if (!(TimeUtils.nowSeconds() > deviceCodeExpirationTime)) return [3 /*break*/, 3];
	                                        if (userSpecifiedTimeout) {
	                                            this.logger.verbose("User specified timeout ignored as the device code has expired before the timeout elapsed. The user specified timeout was set for " + userSpecifiedTimeout);
	                                        }
	                                        this.logger.error("Device code expired. Expiration time of device code was " + deviceCodeExpirationTime);
	                                        clearInterval(intervalId);
	                                        reject(ClientAuthError.createDeviceCodeExpiredError());
	                                        return [3 /*break*/, 5];
	                                    case 3:
	                                        thumbprint = {
	                                            clientId: this.config.authOptions.clientId,
	                                            authority: request.authority,
	                                            scopes: request.scopes
	                                        };
	                                        return [4 /*yield*/, this.executePostToTokenEndpoint(this.authority.tokenEndpoint, requestBody, headers, thumbprint)];
	                                    case 4:
	                                        response = _a.sent();
	                                        if (response.body && response.body.error === Constants.AUTHORIZATION_PENDING) {
	                                            // user authorization is pending. Sleep for polling interval and try again
	                                            this.logger.info(response.body.error_description || "no_error_description");
	                                        }
	                                        else {
	                                            clearInterval(intervalId);
	                                            resolve(response.body);
	                                        }
	                                        _a.label = 5;
	                                    case 5: return [3 /*break*/, 7];
	                                    case 6:
	                                        error_1 = _a.sent();
	                                        clearInterval(intervalId);
	                                        reject(error_1);
	                                        return [3 /*break*/, 7];
	                                    case 7: return [2 /*return*/];
	                                }
	                            });
	                        }); }, pollingIntervalMilli);
	                    })];
	            });
	        });
	    };
	    /**
	     * Creates query parameters and converts to string.
	     * @param request
	     * @param deviceCodeResponse
	     */
	    DeviceCodeClient.prototype.createTokenRequestBody = function (request, deviceCodeResponse) {
	        var requestParameters = new RequestParameterBuilder();
	        requestParameters.addScopes(request.scopes);
	        requestParameters.addClientId(this.config.authOptions.clientId);
	        requestParameters.addGrantType(GrantType.DEVICE_CODE_GRANT);
	        requestParameters.addDeviceCode(deviceCodeResponse.deviceCode);
	        var correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
	        requestParameters.addCorrelationId(correlationId);
	        requestParameters.addClientInfo();
	        if (!StringUtils.isEmpty(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
	            requestParameters.addClaims(request.claims, this.config.authOptions.clientCapabilities);
	        }
	        return requestParameters.createQueryString();
	    };
	    return DeviceCodeClient;
	}(BaseClient));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * OAuth2.0 refresh token client
	 */
	var RefreshTokenClient = /** @class */ (function (_super) {
	    __extends$1(RefreshTokenClient, _super);
	    function RefreshTokenClient(configuration) {
	        return _super.call(this, configuration) || this;
	    }
	    RefreshTokenClient.prototype.acquireToken = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var reqTimestamp, response, responseHandler;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        reqTimestamp = TimeUtils.nowSeconds();
	                        return [4 /*yield*/, this.executeTokenRequest(request, this.authority)];
	                    case 1:
	                        response = _a.sent();
	                        responseHandler = new ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
	                        responseHandler.validateTokenResponse(response.body);
	                        return [2 /*return*/, responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request.resourceRequestMethod, request.resourceRequestUri, undefined, [], undefined, true)];
	                }
	            });
	        });
	    };
	    /**
	     * Gets cached refresh token and attaches to request, then calls acquireToken API
	     * @param request
	     */
	    RefreshTokenClient.prototype.acquireTokenByRefreshToken = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var isFOCI, noFamilyRTInCache, clientMismatchErrorWithFamilyRT;
	            return __generator$1(this, function (_a) {
	                // Cannot renew token if no request object is given.
	                if (!request) {
	                    throw ClientConfigurationError.createEmptyTokenRequestError();
	                }
	                // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
	                if (!request.account) {
	                    throw ClientAuthError.createNoAccountInSilentRequestError();
	                }
	                isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment, this.config.authOptions.clientId);
	                // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
	                if (isFOCI) {
	                    try {
	                        return [2 /*return*/, this.acquireTokenWithCachedRefreshToken(request, true)];
	                    }
	                    catch (e) {
	                        noFamilyRTInCache = e instanceof ClientAuthError && e.errorCode === ClientAuthErrorMessage.noTokensFoundError.code;
	                        clientMismatchErrorWithFamilyRT = e instanceof ServerError && e.errorCode === Errors.INVALID_GRANT_ERROR && e.subError === Errors.CLIENT_MISMATCH_ERROR;
	                        // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
	                        if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) {
	                            return [2 /*return*/, this.acquireTokenWithCachedRefreshToken(request, false)];
	                            // throw in all other cases
	                        }
	                        else {
	                            throw e;
	                        }
	                    }
	                }
	                // fall back to application refresh token acquisition
	                return [2 /*return*/, this.acquireTokenWithCachedRefreshToken(request, false)];
	            });
	        });
	    };
	    /**
	     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
	     * @param request
	     */
	    RefreshTokenClient.prototype.acquireTokenWithCachedRefreshToken = function (request, foci) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var refreshToken, refreshTokenRequest;
	            return __generator$1(this, function (_a) {
	                refreshToken = this.cacheManager.readRefreshTokenFromCache(this.config.authOptions.clientId, request.account, foci);
	                // no refresh Token
	                if (!refreshToken) {
	                    throw ClientAuthError.createNoTokensFoundError();
	                }
	                refreshTokenRequest = __assign$1(__assign$1({}, request), { refreshToken: refreshToken.secret, authenticationScheme: exports.AuthenticationScheme.BEARER });
	                return [2 /*return*/, this.acquireToken(refreshTokenRequest)];
	            });
	        });
	    };
	    /**
	     * Constructs the network message and makes a NW call to the underlying secure token service
	     * @param request
	     * @param authority
	     */
	    RefreshTokenClient.prototype.executeTokenRequest = function (request, authority) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var requestBody, headers, thumbprint;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.createTokenRequestBody(request)];
	                    case 1:
	                        requestBody = _a.sent();
	                        headers = this.createDefaultTokenRequestHeaders();
	                        thumbprint = {
	                            clientId: this.config.authOptions.clientId,
	                            authority: authority.canonicalAuthority,
	                            scopes: request.scopes
	                        };
	                        return [2 /*return*/, this.executePostToTokenEndpoint(authority.tokenEndpoint, requestBody, headers, thumbprint)];
	                }
	            });
	        });
	    };
	    /**
	     * Helper function to create the token request body
	     * @param request
	     */
	    RefreshTokenClient.prototype.createTokenRequestBody = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var parameterBuilder, correlationId, clientAssertion, popTokenGenerator, _a, _b;
	            return __generator$1(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        parameterBuilder = new RequestParameterBuilder();
	                        parameterBuilder.addClientId(this.config.authOptions.clientId);
	                        parameterBuilder.addScopes(request.scopes);
	                        parameterBuilder.addGrantType(GrantType.REFRESH_TOKEN_GRANT);
	                        parameterBuilder.addClientInfo();
	                        correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
	                        parameterBuilder.addCorrelationId(correlationId);
	                        parameterBuilder.addRefreshToken(request.refreshToken);
	                        if (this.config.clientCredentials.clientSecret) {
	                            parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
	                        }
	                        if (this.config.clientCredentials.clientAssertion) {
	                            clientAssertion = this.config.clientCredentials.clientAssertion;
	                            parameterBuilder.addClientAssertion(clientAssertion.assertion);
	                            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
	                        }
	                        if (!(request.authenticationScheme === exports.AuthenticationScheme.POP)) return [3 /*break*/, 2];
	                        popTokenGenerator = new PopTokenGenerator(this.cryptoUtils);
	                        if (!request.resourceRequestMethod || !request.resourceRequestUri) {
	                            throw ClientConfigurationError.createResourceRequestParametersRequiredError();
	                        }
	                        _b = (_a = parameterBuilder).addPopToken;
	                        return [4 /*yield*/, popTokenGenerator.generateCnf(request.resourceRequestMethod, request.resourceRequestUri)];
	                    case 1:
	                        _b.apply(_a, [_c.sent()]);
	                        _c.label = 2;
	                    case 2:
	                        if (!StringUtils.isEmpty(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
	                            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
	                        }
	                        return [2 /*return*/, parameterBuilder.createQueryString()];
	                }
	            });
	        });
	    };
	    return RefreshTokenClient;
	}(BaseClient));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * OAuth2.0 client credential grant
	 */
	var ClientCredentialClient = /** @class */ (function (_super) {
	    __extends$1(ClientCredentialClient, _super);
	    function ClientCredentialClient(configuration) {
	        return _super.call(this, configuration) || this;
	    }
	    /**
	     * Public API to acquire a token with ClientCredential Flow for Confidential clients
	     * @param request
	     */
	    ClientCredentialClient.prototype.acquireToken = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var cachedAuthenticationResult;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.scopeSet = new ScopeSet(request.scopes || []);
	                        if (!request.skipCache) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.executeTokenRequest(request, this.authority)];
	                    case 1: return [2 /*return*/, _a.sent()];
	                    case 2: return [4 /*yield*/, this.getCachedAuthenticationResult()];
	                    case 3:
	                        cachedAuthenticationResult = _a.sent();
	                        if (!cachedAuthenticationResult) return [3 /*break*/, 4];
	                        return [2 /*return*/, cachedAuthenticationResult];
	                    case 4: return [4 /*yield*/, this.executeTokenRequest(request, this.authority)];
	                    case 5: return [2 /*return*/, _a.sent()];
	                }
	            });
	        });
	    };
	    /**
	     * looks up cache if the tokens are cached already
	     */
	    ClientCredentialClient.prototype.getCachedAuthenticationResult = function () {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var cachedAccessToken;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        cachedAccessToken = this.readAccessTokenFromCache();
	                        if (!cachedAccessToken ||
	                            TimeUtils.isTokenExpired(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
	                            return [2 /*return*/, null];
	                        }
	                        return [4 /*yield*/, ResponseHandler.generateAuthenticationResult(this.cryptoUtils, this.authority, {
	                                account: null,
	                                idToken: null,
	                                accessToken: cachedAccessToken,
	                                refreshToken: null,
	                                appMetadata: null
	                            }, true)];
	                    case 1: return [2 /*return*/, _a.sent()];
	                }
	            });
	        });
	    };
	    /**
	     * Reads access token from the cache
	     * TODO: Move this call to cacheManager instead
	     */
	    ClientCredentialClient.prototype.readAccessTokenFromCache = function () {
	        var accessTokenFilter = {
	            homeAccountId: "",
	            environment: this.authority.canonicalAuthorityUrlComponents.HostNameAndPort,
	            credentialType: CredentialType.ACCESS_TOKEN,
	            clientId: this.config.authOptions.clientId,
	            realm: this.authority.tenant,
	            target: this.scopeSet.printScopesLowerCase()
	        };
	        var credentialCache = this.cacheManager.getCredentialsFilteredBy(accessTokenFilter);
	        var accessTokens = Object.keys(credentialCache.accessTokens).map(function (key) { return credentialCache.accessTokens[key]; });
	        if (accessTokens.length < 1) {
	            return null;
	        }
	        else if (accessTokens.length > 1) {
	            throw ClientAuthError.createMultipleMatchingTokensInCacheError();
	        }
	        return accessTokens[0];
	    };
	    /**
	     * Makes a network call to request the token from the service
	     * @param request
	     * @param authority
	     */
	    ClientCredentialClient.prototype.executeTokenRequest = function (request, authority) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var requestBody, headers, thumbprint, reqTimestamp, response, responseHandler, tokenResponse;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        requestBody = this.createTokenRequestBody(request);
	                        headers = this.createDefaultTokenRequestHeaders();
	                        thumbprint = {
	                            clientId: this.config.authOptions.clientId,
	                            authority: request.authority,
	                            scopes: request.scopes
	                        };
	                        reqTimestamp = TimeUtils.nowSeconds();
	                        return [4 /*yield*/, this.executePostToTokenEndpoint(authority.tokenEndpoint, requestBody, headers, thumbprint)];
	                    case 1:
	                        response = _a.sent();
	                        responseHandler = new ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
	                        responseHandler.validateTokenResponse(response.body);
	                        return [4 /*yield*/, responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request.resourceRequestMethod, request.resourceRequestUri, undefined, request.scopes)];
	                    case 2:
	                        tokenResponse = _a.sent();
	                        return [2 /*return*/, tokenResponse];
	                }
	            });
	        });
	    };
	    /**
	     * generate the request to the server in the acceptable format
	     * @param request
	     */
	    ClientCredentialClient.prototype.createTokenRequestBody = function (request) {
	        var parameterBuilder = new RequestParameterBuilder();
	        parameterBuilder.addClientId(this.config.authOptions.clientId);
	        parameterBuilder.addScopes(request.scopes, false);
	        parameterBuilder.addGrantType(GrantType.CLIENT_CREDENTIALS_GRANT);
	        var correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
	        parameterBuilder.addCorrelationId(correlationId);
	        if (this.config.clientCredentials.clientSecret) {
	            parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
	        }
	        if (this.config.clientCredentials.clientAssertion) {
	            var clientAssertion = this.config.clientCredentials.clientAssertion;
	            parameterBuilder.addClientAssertion(clientAssertion.assertion);
	            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
	        }
	        if (!StringUtils.isEmpty(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
	            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
	        }
	        return parameterBuilder.createQueryString();
	    };
	    return ClientCredentialClient;
	}(BaseClient));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * On-Behalf-Of client
	 */
	var OnBehalfOfClient = /** @class */ (function (_super) {
	    __extends$1(OnBehalfOfClient, _super);
	    function OnBehalfOfClient(configuration) {
	        return _super.call(this, configuration) || this;
	    }
	    /**
	     * Public API to acquire tokens with on behalf of flow
	     * @param request
	     */
	    OnBehalfOfClient.prototype.acquireToken = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var cachedAuthenticationResult;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.scopeSet = new ScopeSet(request.scopes || []);
	                        if (!request.skipCache) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.executeTokenRequest(request, this.authority)];
	                    case 1: return [2 /*return*/, _a.sent()];
	                    case 2: return [4 /*yield*/, this.getCachedAuthenticationResult(request)];
	                    case 3:
	                        cachedAuthenticationResult = _a.sent();
	                        if (!cachedAuthenticationResult) return [3 /*break*/, 4];
	                        return [2 /*return*/, cachedAuthenticationResult];
	                    case 4: return [4 /*yield*/, this.executeTokenRequest(request, this.authority)];
	                    case 5: return [2 /*return*/, _a.sent()];
	                }
	            });
	        });
	    };
	    /**
	     * look up cache for tokens
	     * @param request
	     */
	    OnBehalfOfClient.prototype.getCachedAuthenticationResult = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var cachedAccessToken, cachedIdToken, idTokenObject, cachedAccount, localAccountId, accountInfo;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        cachedAccessToken = this.readAccessTokenFromCache(request);
	                        if (!cachedAccessToken ||
	                            TimeUtils.isTokenExpired(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
	                            return [2 /*return*/, null];
	                        }
	                        cachedIdToken = this.readIdTokenFromCache(request);
	                        cachedAccount = null;
	                        if (cachedIdToken) {
	                            idTokenObject = new AuthToken(cachedIdToken.secret, this.config.cryptoInterface);
	                            localAccountId = idTokenObject.claims.oid ? idTokenObject.claims.oid : idTokenObject.claims.sub;
	                            accountInfo = {
	                                homeAccountId: cachedIdToken.homeAccountId,
	                                environment: cachedIdToken.environment,
	                                tenantId: cachedIdToken.realm,
	                                username: Constants.EMPTY_STRING,
	                                localAccountId: localAccountId || ""
	                            };
	                            cachedAccount = this.readAccountFromCache(accountInfo);
	                        }
	                        return [4 /*yield*/, ResponseHandler.generateAuthenticationResult(this.cryptoUtils, this.authority, {
	                                account: cachedAccount,
	                                accessToken: cachedAccessToken,
	                                idToken: cachedIdToken,
	                                refreshToken: null,
	                                appMetadata: null
	                            }, true, idTokenObject)];
	                    case 1: return [2 /*return*/, _a.sent()];
	                }
	            });
	        });
	    };
	    /**
	     * read access token from cache TODO: CacheManager API should be used here
	     * @param request
	     */
	    OnBehalfOfClient.prototype.readAccessTokenFromCache = function (request) {
	        var accessTokenFilter = {
	            environment: this.authority.canonicalAuthorityUrlComponents.HostNameAndPort,
	            credentialType: CredentialType.ACCESS_TOKEN,
	            clientId: this.config.authOptions.clientId,
	            realm: this.authority.tenant,
	            target: this.scopeSet.printScopesLowerCase(),
	            oboAssertion: request.oboAssertion
	        };
	        var credentialCache = this.cacheManager.getCredentialsFilteredBy(accessTokenFilter);
	        var accessTokens = Object.keys(credentialCache.accessTokens).map(function (key) { return credentialCache.accessTokens[key]; });
	        var numAccessTokens = accessTokens.length;
	        if (numAccessTokens < 1) {
	            return null;
	        }
	        else if (numAccessTokens > 1) {
	            throw ClientAuthError.createMultipleMatchingTokensInCacheError();
	        }
	        return accessTokens[0];
	    };
	    /**
	     * read idtoken from cache TODO: CacheManager API should be used here instead
	     * @param request
	     */
	    OnBehalfOfClient.prototype.readIdTokenFromCache = function (request) {
	        var idTokenFilter = {
	            environment: this.authority.canonicalAuthorityUrlComponents.HostNameAndPort,
	            credentialType: CredentialType.ID_TOKEN,
	            clientId: this.config.authOptions.clientId,
	            realm: this.authority.tenant,
	            oboAssertion: request.oboAssertion
	        };
	        var credentialCache = this.cacheManager.getCredentialsFilteredBy(idTokenFilter);
	        var idTokens = Object.keys(credentialCache.idTokens).map(function (key) { return credentialCache.idTokens[key]; });
	        // When acquiring a token on behalf of an application, there might not be an id token in the cache
	        if (idTokens.length < 1) {
	            return null;
	        }
	        return idTokens[0];
	    };
	    /**
	     * read account from cache, TODO: CacheManager API should be used here instead
	     * @param account
	     */
	    OnBehalfOfClient.prototype.readAccountFromCache = function (account) {
	        return this.cacheManager.readAccountFromCache(account);
	    };
	    /**
	     * Make a network call to the server requesting credentials
	     * @param request
	     * @param authority
	     */
	    OnBehalfOfClient.prototype.executeTokenRequest = function (request, authority) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var requestBody, headers, thumbprint, reqTimestamp, response, responseHandler, tokenResponse;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        requestBody = this.createTokenRequestBody(request);
	                        headers = this.createDefaultTokenRequestHeaders();
	                        thumbprint = {
	                            clientId: this.config.authOptions.clientId,
	                            authority: request.authority,
	                            scopes: request.scopes
	                        };
	                        reqTimestamp = TimeUtils.nowSeconds();
	                        return [4 /*yield*/, this.executePostToTokenEndpoint(authority.tokenEndpoint, requestBody, headers, thumbprint)];
	                    case 1:
	                        response = _a.sent();
	                        responseHandler = new ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
	                        responseHandler.validateTokenResponse(response.body);
	                        return [4 /*yield*/, responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp, request.resourceRequestMethod, request.resourceRequestUri, undefined, request.scopes, request.oboAssertion)];
	                    case 2:
	                        tokenResponse = _a.sent();
	                        return [2 /*return*/, tokenResponse];
	                }
	            });
	        });
	    };
	    /**
	     * generate a server request in accepable format
	     * @param request
	     */
	    OnBehalfOfClient.prototype.createTokenRequestBody = function (request) {
	        var parameterBuilder = new RequestParameterBuilder();
	        parameterBuilder.addClientId(this.config.authOptions.clientId);
	        parameterBuilder.addScopes(request.scopes);
	        parameterBuilder.addGrantType(GrantType.JWT_BEARER);
	        parameterBuilder.addClientInfo();
	        var correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
	        parameterBuilder.addCorrelationId(correlationId);
	        parameterBuilder.addRequestTokenUse(AADServerParamKeys.ON_BEHALF_OF);
	        parameterBuilder.addOboAssertion(request.oboAssertion);
	        if (this.config.clientCredentials.clientSecret) {
	            parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
	        }
	        if (this.config.clientCredentials.clientAssertion) {
	            var clientAssertion = this.config.clientCredentials.clientAssertion;
	            parameterBuilder.addClientAssertion(clientAssertion.assertion);
	            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
	        }
	        return parameterBuilder.createQueryString();
	    };
	    return OnBehalfOfClient;
	}(BaseClient));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var SilentFlowClient = /** @class */ (function (_super) {
	    __extends$1(SilentFlowClient, _super);
	    function SilentFlowClient(configuration) {
	        return _super.call(this, configuration) || this;
	    }
	    /**
	     * Retrieves a token from cache if it is still valid, or uses the cached refresh token to renew
	     * the given token and returns the renewed token
	     * @param request
	     */
	    SilentFlowClient.prototype.acquireToken = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var e_1, refreshTokenClient;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        _a.trys.push([0, 2, , 3]);
	                        return [4 /*yield*/, this.acquireCachedToken(request)];
	                    case 1: return [2 /*return*/, _a.sent()];
	                    case 2:
	                        e_1 = _a.sent();
	                        if (e_1 instanceof ClientAuthError && e_1.errorCode === ClientAuthErrorMessage.tokenRefreshRequired.code) {
	                            refreshTokenClient = new RefreshTokenClient(this.config);
	                            return [2 /*return*/, refreshTokenClient.acquireTokenByRefreshToken(request)];
	                        }
	                        else {
	                            throw e_1;
	                        }
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Retrieves token from cache or throws an error if it must be refreshed.
	     * @param request
	     */
	    SilentFlowClient.prototype.acquireCachedToken = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var requestScopes, environment, cacheRecord;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        // Cannot renew token if no request object is given.
	                        if (!request) {
	                            throw ClientConfigurationError.createEmptyTokenRequestError();
	                        }
	                        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
	                        if (!request.account) {
	                            throw ClientAuthError.createNoAccountInSilentRequestError();
	                        }
	                        requestScopes = new ScopeSet(request.scopes || []);
	                        environment = request.authority || this.authority.getPreferredCache();
	                        cacheRecord = this.cacheManager.readCacheRecord(request.account, this.config.authOptions.clientId, requestScopes, environment);
	                        if (!this.isRefreshRequired(request, cacheRecord.accessToken)) return [3 /*break*/, 1];
	                        throw ClientAuthError.createRefreshRequiredError();
	                    case 1:
	                        if (this.config.serverTelemetryManager) {
	                            this.config.serverTelemetryManager.incrementCacheHits();
	                        }
	                        return [4 /*yield*/, this.generateResultFromCacheRecord(cacheRecord, request.resourceRequestMethod, request.resourceRequestUri)];
	                    case 2: return [2 /*return*/, _a.sent()];
	                }
	            });
	        });
	    };
	    /**
	     * Helper function to build response object from the CacheRecord
	     * @param cacheRecord
	     */
	    SilentFlowClient.prototype.generateResultFromCacheRecord = function (cacheRecord, resourceRequestMethod, resourceRequestUri) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var idTokenObj;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (cacheRecord.idToken) {
	                            idTokenObj = new AuthToken(cacheRecord.idToken.secret, this.config.cryptoInterface);
	                        }
	                        return [4 /*yield*/, ResponseHandler.generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, idTokenObj, undefined, resourceRequestMethod, resourceRequestUri)];
	                    case 1: return [2 /*return*/, _a.sent()];
	                }
	            });
	        });
	    };
	    /**
	     * Given a request object and an accessTokenEntity determine if the accessToken needs to be refreshed
	     * @param request
	     * @param cachedAccessToken
	     */
	    SilentFlowClient.prototype.isRefreshRequired = function (request, cachedAccessToken) {
	        if (request.forceRefresh || request.claims) {
	            // Must refresh due to request parameters
	            return true;
	        }
	        else if (!cachedAccessToken || TimeUtils.isTokenExpired(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
	            // Must refresh due to expired or non-existent access_token
	            return true;
	        }
	        return false;
	    };
	    return SilentFlowClient;
	}(BaseClient));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Oauth2.0 Password grant client
	 * Note: We are only supporting public clients for password grant and for purely testing purposes
	 */
	var UsernamePasswordClient = /** @class */ (function (_super) {
	    __extends$1(UsernamePasswordClient, _super);
	    function UsernamePasswordClient(configuration) {
	        return _super.call(this, configuration) || this;
	    }
	    /**
	     * API to acquire a token by passing the username and password to the service in exchage of credentials
	     * password_grant
	     * @param request
	     */
	    UsernamePasswordClient.prototype.acquireToken = function (request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var reqTimestamp, response, responseHandler, tokenResponse;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.logger.info("in acquireToken call");
	                        reqTimestamp = TimeUtils.nowSeconds();
	                        return [4 /*yield*/, this.executeTokenRequest(this.authority, request)];
	                    case 1:
	                        response = _a.sent();
	                        responseHandler = new ResponseHandler(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
	                        // Validate response. This function throws a server error if an error is returned by the server.
	                        responseHandler.validateTokenResponse(response.body);
	                        tokenResponse = responseHandler.handleServerTokenResponse(response.body, this.authority, reqTimestamp);
	                        return [2 /*return*/, tokenResponse];
	                }
	            });
	        });
	    };
	    /**
	     * Executes POST request to token endpoint
	     * @param authority
	     * @param request
	     */
	    UsernamePasswordClient.prototype.executeTokenRequest = function (authority, request) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var thumbprint, requestBody, headers;
	            return __generator$1(this, function (_a) {
	                thumbprint = {
	                    clientId: this.config.authOptions.clientId,
	                    authority: authority.canonicalAuthority,
	                    scopes: request.scopes
	                };
	                requestBody = this.createTokenRequestBody(request);
	                headers = this.createDefaultTokenRequestHeaders();
	                return [2 /*return*/, this.executePostToTokenEndpoint(authority.tokenEndpoint, requestBody, headers, thumbprint)];
	            });
	        });
	    };
	    /**
	     * Generates a map for all the params to be sent to the service
	     * @param request
	     */
	    UsernamePasswordClient.prototype.createTokenRequestBody = function (request) {
	        var parameterBuilder = new RequestParameterBuilder();
	        parameterBuilder.addClientId(this.config.authOptions.clientId);
	        parameterBuilder.addUsername(request.username);
	        parameterBuilder.addPassword(request.password);
	        parameterBuilder.addScopes(request.scopes);
	        parameterBuilder.addGrantType(GrantType.RESOURCE_OWNER_PASSWORD_GRANT);
	        parameterBuilder.addClientInfo();
	        var correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
	        parameterBuilder.addCorrelationId(correlationId);
	        if (!StringUtils.isEmpty(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) {
	            parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
	        }
	        return parameterBuilder.createQueryString();
	    };
	    return UsernamePasswordClient;
	}(BaseClient));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	function isOpenIdConfigResponse(response) {
	    return (response.hasOwnProperty("authorization_endpoint") &&
	        response.hasOwnProperty("token_endpoint") &&
	        response.hasOwnProperty("end_session_endpoint") &&
	        response.hasOwnProperty("issuer"));
	}
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Protocol modes supported by MSAL.
	 */
	
	(function (ProtocolMode) {
	    ProtocolMode["AAD"] = "AAD";
	    ProtocolMode["OIDC"] = "OIDC";
	})(exports.ProtocolMode || (exports.ProtocolMode = {}));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var AuthorityMetadataEntity = /** @class */ (function () {
	    function AuthorityMetadataEntity() {
	        this.expiresAt = TimeUtils.nowSeconds() + AUTHORITY_METADATA_CONSTANTS.REFRESH_TIME_SECONDS;
	    }
	    /**
	     * Update the entity with new aliases, preferred_cache and preferred_network values
	     * @param metadata
	     * @param fromNetwork
	     */
	    AuthorityMetadataEntity.prototype.updateCloudDiscoveryMetadata = function (metadata, fromNetwork) {
	        this.aliases = metadata.aliases;
	        this.preferred_cache = metadata.preferred_cache;
	        this.preferred_network = metadata.preferred_network;
	        this.aliasesFromNetwork = fromNetwork;
	    };
	    /**
	     * Update the entity with new endpoints
	     * @param metadata
	     * @param fromNetwork
	     */
	    AuthorityMetadataEntity.prototype.updateEndpointMetadata = function (metadata, fromNetwork) {
	        this.authorization_endpoint = metadata.authorization_endpoint;
	        this.token_endpoint = metadata.token_endpoint;
	        this.end_session_endpoint = metadata.end_session_endpoint;
	        this.issuer = metadata.issuer;
	        this.endpointsFromNetwork = fromNetwork;
	    };
	    /**
	     * Save the authority that was used to create this cache entry
	     * @param authority
	     */
	    AuthorityMetadataEntity.prototype.updateCanonicalAuthority = function (authority) {
	        this.canonical_authority = authority;
	    };
	    /**
	     * Reset the exiresAt value
	     */
	    AuthorityMetadataEntity.prototype.resetExpiresAt = function () {
	        this.expiresAt = TimeUtils.nowSeconds() + AUTHORITY_METADATA_CONSTANTS.REFRESH_TIME_SECONDS;
	    };
	    /**
	     * Returns whether or not the data needs to be refreshed
	     */
	    AuthorityMetadataEntity.prototype.isExpired = function () {
	        return this.expiresAt <= TimeUtils.nowSeconds();
	    };
	    /**
	     * Validates an entity: checks for all expected params
	     * @param entity
	     */
	    AuthorityMetadataEntity.isAuthorityMetadataEntity = function (key, entity) {
	        if (!entity) {
	            return false;
	        }
	        return (key.indexOf(AUTHORITY_METADATA_CONSTANTS.CACHE_KEY) === 0 &&
	            entity.hasOwnProperty("aliases") &&
	            entity.hasOwnProperty("preferred_cache") &&
	            entity.hasOwnProperty("preferred_network") &&
	            entity.hasOwnProperty("canonical_authority") &&
	            entity.hasOwnProperty("authorization_endpoint") &&
	            entity.hasOwnProperty("token_endpoint") &&
	            entity.hasOwnProperty("end_session_endpoint") &&
	            entity.hasOwnProperty("issuer") &&
	            entity.hasOwnProperty("aliasesFromNetwork") &&
	            entity.hasOwnProperty("endpointsFromNetwork") &&
	            entity.hasOwnProperty("expiresAt"));
	    };
	    return AuthorityMetadataEntity;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	function isCloudInstanceDiscoveryResponse(response) {
	    return (response.hasOwnProperty("tenant_discovery_endpoint") &&
	        response.hasOwnProperty("metadata"));
	}
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
	 * endpoint. It will store the pertinent config data in this object for use during token calls.
	 */
	var Authority = /** @class */ (function () {
	    function Authority(authority, networkInterface, cacheManager, authorityOptions) {
	        this.canonicalAuthority = authority;
	        this._canonicalAuthority.validateAsUri();
	        this.networkInterface = networkInterface;
	        this.cacheManager = cacheManager;
	        this.authorityOptions = authorityOptions;
	    }
	    Object.defineProperty(Authority.prototype, "authorityType", {
	        // See above for AuthorityType
	        get: function () {
	            var pathSegments = this.canonicalAuthorityUrlComponents.PathSegments;
	            if (pathSegments.length && pathSegments[0].toLowerCase() === Constants.ADFS) {
	                return AuthorityType.Adfs;
	            }
	            return AuthorityType.Default;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Authority.prototype, "protocolMode", {
	        /**
	         * ProtocolMode enum representing the way endpoints are constructed.
	         */
	        get: function () {
	            return this.authorityOptions.protocolMode;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Authority.prototype, "options", {
	        /**
	         * Returns authorityOptions which can be used to reinstantiate a new authority instance
	         */
	        get: function () {
	            return this.authorityOptions;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Authority.prototype, "canonicalAuthority", {
	        /**
	         * A URL that is the authority set by the developer
	         */
	        get: function () {
	            return this._canonicalAuthority.urlString;
	        },
	        /**
	         * Sets canonical authority.
	         */
	        set: function (url) {
	            this._canonicalAuthority = new UrlString(url);
	            this._canonicalAuthority.validateAsUri();
	            this._canonicalAuthorityUrlComponents = null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Authority.prototype, "canonicalAuthorityUrlComponents", {
	        /**
	         * Get authority components.
	         */
	        get: function () {
	            if (!this._canonicalAuthorityUrlComponents) {
	                this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
	            }
	            return this._canonicalAuthorityUrlComponents;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Authority.prototype, "hostnameAndPort", {
	        /**
	         * Get hostname and port i.e. login.microsoftonline.com
	         */
	        get: function () {
	            return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Authority.prototype, "tenant", {
	        /**
	         * Get tenant for authority.
	         */
	        get: function () {
	            return this.canonicalAuthorityUrlComponents.PathSegments[0];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Authority.prototype, "authorizationEndpoint", {
	        /**
	         * OAuth /authorize endpoint for requests
	         */
	        get: function () {
	            if (this.discoveryComplete()) {
	                var endpoint = this.replacePath(this.metadata.authorization_endpoint);
	                return this.replaceTenant(endpoint);
	            }
	            else {
	                throw ClientAuthError.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Authority.prototype, "tokenEndpoint", {
	        /**
	         * OAuth /token endpoint for requests
	         */
	        get: function () {
	            if (this.discoveryComplete()) {
	                var endpoint = this.replacePath(this.metadata.token_endpoint);
	                return this.replaceTenant(endpoint);
	            }
	            else {
	                throw ClientAuthError.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Authority.prototype, "deviceCodeEndpoint", {
	        get: function () {
	            if (this.discoveryComplete()) {
	                var endpoint = this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
	                return this.replaceTenant(endpoint);
	            }
	            else {
	                throw ClientAuthError.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Authority.prototype, "endSessionEndpoint", {
	        /**
	         * OAuth logout endpoint for requests
	         */
	        get: function () {
	            if (this.discoveryComplete()) {
	                var endpoint = this.replacePath(this.metadata.end_session_endpoint);
	                return this.replaceTenant(endpoint);
	            }
	            else {
	                throw ClientAuthError.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(Authority.prototype, "selfSignedJwtAudience", {
	        /**
	         * OAuth issuer for requests
	         */
	        get: function () {
	            if (this.discoveryComplete()) {
	                var endpoint = this.replacePath(this.metadata.issuer);
	                return this.replaceTenant(endpoint);
	            }
	            else {
	                throw ClientAuthError.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Replaces tenant in url path with current tenant. Defaults to common.
	     * @param urlString
	     */
	    Authority.prototype.replaceTenant = function (urlString) {
	        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
	    };
	    /**
	     * Replaces path such as tenant or policy with the current tenant or policy.
	     * @param urlString
	     */
	    Authority.prototype.replacePath = function (urlString) {
	        var endpoint = urlString;
	        var cachedAuthorityUrl = new UrlString(this.metadata.canonical_authority);
	        var cachedAuthorityParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
	        var currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
	        currentAuthorityParts.forEach(function (currentPart, index) {
	            var cachedPart = cachedAuthorityParts[index];
	            if (currentPart !== cachedPart) {
	                endpoint = endpoint.replace("/" + cachedPart + "/", "/" + currentPart + "/");
	            }
	        });
	        return endpoint;
	    };
	    Object.defineProperty(Authority.prototype, "defaultOpenIdConfigurationEndpoint", {
	        /**
	         * The default open id configuration endpoint for any canonical authority.
	         */
	        get: function () {
	            if (this.authorityType === AuthorityType.Adfs || this.protocolMode === exports.ProtocolMode.OIDC) {
	                return this.canonicalAuthority + ".well-known/openid-configuration";
	            }
	            return this.canonicalAuthority + "v2.0/.well-known/openid-configuration";
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /**
	     * Boolean that returns whethr or not tenant discovery has been completed.
	     */
	    Authority.prototype.discoveryComplete = function () {
	        return !!this.metadata;
	    };
	    /**
	     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
	     * and the /authorize, /token and logout endpoints.
	     */
	    Authority.prototype.resolveEndpointsAsync = function () {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var metadataEntity, cloudDiscoverySource, endpointSource, cacheKey;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort);
	                        if (!metadataEntity) {
	                            metadataEntity = new AuthorityMetadataEntity();
	                            metadataEntity.updateCanonicalAuthority(this.canonicalAuthority);
	                        }
	                        return [4 /*yield*/, this.updateCloudDiscoveryMetadata(metadataEntity)];
	                    case 1:
	                        cloudDiscoverySource = _a.sent();
	                        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
	                        return [4 /*yield*/, this.updateEndpointMetadata(metadataEntity)];
	                    case 2:
	                        endpointSource = _a.sent();
	                        if (cloudDiscoverySource !== AuthorityMetadataSource.CACHE && endpointSource !== AuthorityMetadataSource.CACHE) {
	                            // Reset the expiration time unless both values came from a successful cache lookup
	                            metadataEntity.resetExpiresAt();
	                            metadataEntity.updateCanonicalAuthority(this.canonicalAuthority);
	                        }
	                        cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache);
	                        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity);
	                        this.metadata = metadataEntity;
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
	     * @param metadataEntity
	     */
	    Authority.prototype.updateEndpointMetadata = function (metadataEntity) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var metadata;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        metadata = this.getEndpointMetadataFromConfig();
	                        if (metadata) {
	                            metadataEntity.updateEndpointMetadata(metadata, false);
	                            return [2 /*return*/, AuthorityMetadataSource.CONFIG];
	                        }
	                        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntity.isExpired()) {
	                            // No need to update
	                            return [2 /*return*/, AuthorityMetadataSource.CACHE];
	                        }
	                        return [4 /*yield*/, this.getEndpointMetadataFromNetwork()];
	                    case 1:
	                        metadata = _a.sent();
	                        if (metadata) {
	                            metadataEntity.updateEndpointMetadata(metadata, true);
	                            return [2 /*return*/, AuthorityMetadataSource.NETWORK];
	                        }
	                        else {
	                            throw ClientAuthError.createUnableToGetOpenidConfigError(this.defaultOpenIdConfigurationEndpoint);
	                        }
	                }
	            });
	        });
	    };
	    /**
	     * Compares the number of url components after the domain to determine if the cached authority metadata can be used for the requested authority
	     * Protects against same domain different authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
	     * @param metadataEntity
	     */
	    Authority.prototype.isAuthoritySameType = function (metadataEntity) {
	        var cachedAuthorityUrl = new UrlString(metadataEntity.canonical_authority);
	        var cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
	        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
	    };
	    /**
	     * Parse authorityMetadata config option
	     */
	    Authority.prototype.getEndpointMetadataFromConfig = function () {
	        if (this.authorityOptions.authorityMetadata) {
	            try {
	                return JSON.parse(this.authorityOptions.authorityMetadata);
	            }
	            catch (e) {
	                throw ClientConfigurationError.createInvalidAuthorityMetadataError();
	            }
	        }
	        return null;
	    };
	    /**
	     * Gets OAuth endpoints from the given OpenID configuration endpoint.
	     */
	    Authority.prototype.getEndpointMetadataFromNetwork = function () {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var response, e_1;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        _a.trys.push([0, 2, , 3]);
	                        return [4 /*yield*/, this.networkInterface.sendGetRequestAsync(this.defaultOpenIdConfigurationEndpoint)];
	                    case 1:
	                        response = _a.sent();
	                        return [2 /*return*/, isOpenIdConfigResponse(response.body) ? response.body : null];
	                    case 2:
	                        e_1 = _a.sent();
	                        return [2 /*return*/, null];
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache and returns where the information was retrived from
	     * @param cachedMetadata
	     * @param newMetadata
	     */
	    Authority.prototype.updateCloudDiscoveryMetadata = function (metadataEntity) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var metadata;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        metadata = this.getCloudDiscoveryMetadataFromConfig();
	                        if (metadata) {
	                            metadataEntity.updateCloudDiscoveryMetadata(metadata, false);
	                            return [2 /*return*/, AuthorityMetadataSource.CONFIG];
	                        }
	                        // If The cached metadata came from config but that config was not passed to this instance, we must go to the network
	                        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntity.isExpired()) {
	                            // No need to update
	                            return [2 /*return*/, AuthorityMetadataSource.CACHE];
	                        }
	                        return [4 /*yield*/, this.getCloudDiscoveryMetadataFromNetwork()];
	                    case 1:
	                        metadata = _a.sent();
	                        if (metadata) {
	                            metadataEntity.updateCloudDiscoveryMetadata(metadata, true);
	                            return [2 /*return*/, AuthorityMetadataSource.NETWORK];
	                        }
	                        else {
	                            // Metadata could not be obtained from config, cache or network
	                            throw ClientConfigurationError.createUntrustedAuthorityError();
	                        }
	                }
	            });
	        });
	    };
	    /**
	     * Parse cloudDiscoveryMetadata config or check knownAuthorities
	     */
	    Authority.prototype.getCloudDiscoveryMetadataFromConfig = function () {
	        // Check if network response was provided in config
	        if (this.authorityOptions.cloudDiscoveryMetadata) {
	            try {
	                var parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
	                var metadata = Authority.getCloudDiscoveryMetadataFromNetworkResponse(parsedResponse.metadata, this.hostnameAndPort);
	                if (metadata) {
	                    return metadata;
	                }
	            }
	            catch (e) {
	                throw ClientConfigurationError.createInvalidCloudDiscoveryMetadataError();
	            }
	        }
	        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
	        if (this.isInKnownAuthorities()) {
	            return Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
	        }
	        return null;
	    };
	    /**
	     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
	     * @param networkInterface
	     */
	    Authority.prototype.getCloudDiscoveryMetadataFromNetwork = function () {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var instanceDiscoveryEndpoint, match, response, metadata, e_2;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        instanceDiscoveryEndpoint = "" + Constants.AAD_INSTANCE_DISCOVERY_ENDPT + this.canonicalAuthority + "oauth2/v2.0/authorize";
	                        match = null;
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint)];
	                    case 2:
	                        response = _a.sent();
	                        metadata = isCloudInstanceDiscoveryResponse(response.body) ? response.body.metadata : [];
	                        match = Authority.getCloudDiscoveryMetadataFromNetworkResponse(metadata, this.hostnameAndPort);
	                        return [3 /*break*/, 4];
	                    case 3:
	                        e_2 = _a.sent();
	                        return [2 /*return*/, null];
	                    case 4:
	                        if (!match) {
	                            // Custom Domain scenario, host is trusted because Instance Discovery call succeeded 
	                            match = Authority.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
	                        }
	                        return [2 /*return*/, match];
	                }
	            });
	        });
	    };
	    /**
	     * Helper function to determine if this host is included in the knownAuthorities config option
	     */
	    Authority.prototype.isInKnownAuthorities = function () {
	        var _this = this;
	        var matches = this.authorityOptions.knownAuthorities.filter(function (authority) {
	            return UrlString.getDomainFromUrl(authority).toLowerCase() === _this.hostnameAndPort;
	        });
	        return matches.length > 0;
	    };
	    /**
	     * Creates cloud discovery metadata object from a given host
	     * @param host
	     */
	    Authority.createCloudDiscoveryMetadataFromHost = function (host) {
	        return {
	            preferred_network: host,
	            preferred_cache: host,
	            aliases: [host]
	        };
	    };
	    /**
	     * Searches instance discovery network response for the entry that contains the host in the aliases list
	     * @param response
	     * @param authority
	     */
	    Authority.getCloudDiscoveryMetadataFromNetworkResponse = function (response, authority) {
	        for (var i = 0; i < response.length; i++) {
	            var metadata = response[i];
	            if (metadata.aliases.indexOf(authority) > -1) {
	                return metadata;
	            }
	        }
	        return null;
	    };
	    /**
	     * helper function to generate environment from authority object
	     */
	    Authority.prototype.getPreferredCache = function () {
	        if (this.discoveryComplete()) {
	            return this.metadata.preferred_cache;
	        }
	        else {
	            throw ClientAuthError.createEndpointDiscoveryIncompleteError("Discovery incomplete.");
	        }
	    };
	    /**
	     * Returns whether or not the provided host is an alias of this authority instance
	     * @param host
	     */
	    Authority.prototype.isAlias = function (host) {
	        return this.metadata.aliases.indexOf(host) > -1;
	    };
	    return Authority;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var AuthorityFactory = /** @class */ (function () {
	    function AuthorityFactory() {
	    }
	    /**
	     * Create an authority object of the correct type based on the url
	     * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
	     *
	     * Also performs endpoint discovery.
	     *
	     * @param authorityUri
	     * @param networkClient
	     * @param protocolMode
	     */
	    AuthorityFactory.createDiscoveredInstance = function (authorityUri, networkClient, cacheManager, authorityOptions) {
	        return __awaiter$1(this, void 0, void 0, function () {
	            var acquireTokenAuthority, e_1;
	            return __generator$1(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        acquireTokenAuthority = AuthorityFactory.createInstance(authorityUri, networkClient, cacheManager, authorityOptions);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, acquireTokenAuthority.resolveEndpointsAsync()];
	                    case 2:
	                        _a.sent();
	                        return [2 /*return*/, acquireTokenAuthority];
	                    case 3:
	                        e_1 = _a.sent();
	                        throw ClientAuthError.createEndpointDiscoveryIncompleteError(e_1);
	                    case 4: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Create an authority object of the correct type based on the url
	     * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
	     *
	     * Does not perform endpoint discovery.
	     *
	     * @param authorityUrl
	     * @param networkInterface
	     * @param protocolMode
	     */
	    AuthorityFactory.createInstance = function (authorityUrl, networkInterface, cacheManager, authorityOptions) {
	        // Throw error if authority url is empty
	        if (StringUtils.isEmpty(authorityUrl)) {
	            throw ClientConfigurationError.createUrlEmptyError();
	        }
	        return new Authority(authorityUrl, networkInterface, cacheManager, authorityOptions);
	    };
	    return AuthorityFactory;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var ServerTelemetryEntity = /** @class */ (function () {
	    function ServerTelemetryEntity() {
	        this.failedRequests = [];
	        this.errors = [];
	        this.cacheHits = 0;
	    }
	    /**
	     * validates if a given cache entry is "Telemetry", parses <key,value>
	     * @param key
	     * @param entity
	     */
	    ServerTelemetryEntity.isServerTelemetryEntity = function (key, entity) {
	        var validateKey = key.indexOf(SERVER_TELEM_CONSTANTS.CACHE_KEY) === 0;
	        var validateEntity = true;
	        if (entity) {
	            validateEntity =
	                entity.hasOwnProperty("failedRequests") &&
	                    entity.hasOwnProperty("errors") &&
	                    entity.hasOwnProperty("cacheHits");
	        }
	        return validateKey && validateEntity;
	    };
	    return ServerTelemetryEntity;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var ThrottlingEntity = /** @class */ (function () {
	    function ThrottlingEntity() {
	    }
	    /**
	     * validates if a given cache entry is "Throttling", parses <key,value>
	     * @param key
	     * @param entity
	     */
	    ThrottlingEntity.isThrottlingEntity = function (key, entity) {
	        var validateKey = false;
	        if (key) {
	            validateKey = key.indexOf(ThrottlingConstants.THROTTLING_PREFIX) === 0;
	        }
	        var validateEntity = true;
	        if (entity) {
	            validateEntity = entity.hasOwnProperty("throttleTime");
	        }
	        return validateKey && validateEntity;
	    };
	    return ThrottlingEntity;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var StubbedNetworkModule = {
	    sendGetRequestAsync: function () {
	        var notImplErr = "Network interface - sendGetRequestAsync() has not been implemented for the Network interface.";
	        return Promise.reject(AuthError.createUnexpectedError(notImplErr));
	    },
	    sendPostRequestAsync: function () {
	        var notImplErr = "Network interface - sendPostRequestAsync() has not been implemented for the Network interface.";
	        return Promise.reject(AuthError.createUnexpectedError(notImplErr));
	    }
	};
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var ServerTelemetryManager = /** @class */ (function () {
	    function ServerTelemetryManager(telemetryRequest, cacheManager) {
	        this.cacheManager = cacheManager;
	        this.apiId = telemetryRequest.apiId;
	        this.correlationId = telemetryRequest.correlationId;
	        this.forceRefresh = telemetryRequest.forceRefresh || false;
	        this.wrapperSKU = telemetryRequest.wrapperSKU || Constants.EMPTY_STRING;
	        this.wrapperVer = telemetryRequest.wrapperVer || Constants.EMPTY_STRING;
	        this.telemetryCacheKey = SERVER_TELEM_CONSTANTS.CACHE_KEY + Separators.CACHE_KEY_SEPARATOR + telemetryRequest.clientId;
	    }
	    /**
	     * API to add MSER Telemetry to request
	     */
	    ServerTelemetryManager.prototype.generateCurrentRequestHeaderValue = function () {
	        var forceRefreshInt = this.forceRefresh ? 1 : 0;
	        var request = "" + this.apiId + SERVER_TELEM_CONSTANTS.VALUE_SEPARATOR + forceRefreshInt;
	        var platformFields = [this.wrapperSKU, this.wrapperVer].join(SERVER_TELEM_CONSTANTS.VALUE_SEPARATOR);
	        return [SERVER_TELEM_CONSTANTS.SCHEMA_VERSION, request, platformFields].join(SERVER_TELEM_CONSTANTS.CATEGORY_SEPARATOR);
	    };
	    /**
	     * API to add MSER Telemetry for the last failed request
	     */
	    ServerTelemetryManager.prototype.generateLastRequestHeaderValue = function () {
	        var lastRequests = this.getLastRequests();
	        var maxErrors = ServerTelemetryManager.maxErrorsToSend(lastRequests);
	        var failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join(SERVER_TELEM_CONSTANTS.VALUE_SEPARATOR);
	        var errors = lastRequests.errors.slice(0, maxErrors).join(SERVER_TELEM_CONSTANTS.VALUE_SEPARATOR);
	        var errorCount = lastRequests.errors.length;
	        // Indicate whether this header contains all data or partial data
	        var overflow = maxErrors < errorCount ? SERVER_TELEM_CONSTANTS.OVERFLOW_TRUE : SERVER_TELEM_CONSTANTS.OVERFLOW_FALSE;
	        var platformFields = [errorCount, overflow].join(SERVER_TELEM_CONSTANTS.VALUE_SEPARATOR);
	        return [SERVER_TELEM_CONSTANTS.SCHEMA_VERSION, lastRequests.cacheHits, failedRequests, errors, platformFields].join(SERVER_TELEM_CONSTANTS.CATEGORY_SEPARATOR);
	    };
	    /**
	     * API to cache token failures for MSER data capture
	     * @param error
	     */
	    ServerTelemetryManager.prototype.cacheFailedRequest = function (error) {
	        var lastRequests = this.getLastRequests();
	        lastRequests.failedRequests.push(this.apiId, this.correlationId);
	        if (!StringUtils.isEmpty(error.subError)) {
	            lastRequests.errors.push(error.subError);
	        }
	        else if (!StringUtils.isEmpty(error.errorCode)) {
	            lastRequests.errors.push(error.errorCode);
	        }
	        else if (!!error && error.toString()) {
	            lastRequests.errors.push(error.toString());
	        }
	        else {
	            lastRequests.errors.push(SERVER_TELEM_CONSTANTS.UNKNOWN_ERROR);
	        }
	        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
	        return;
	    };
	    /**
	     * Update server telemetry cache entry by incrementing cache hit counter
	     */
	    ServerTelemetryManager.prototype.incrementCacheHits = function () {
	        var lastRequests = this.getLastRequests();
	        lastRequests.cacheHits += 1;
	        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests);
	        return lastRequests.cacheHits;
	    };
	    /**
	     * Get the server telemetry entity from cache or initialize a new one
	     */
	    ServerTelemetryManager.prototype.getLastRequests = function () {
	        var initialValue = new ServerTelemetryEntity();
	        var lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey);
	        return lastRequests || initialValue;
	    };
	    /**
	     * Remove server telemetry cache entry
	     */
	    ServerTelemetryManager.prototype.clearTelemetryCache = function () {
	        var lastRequests = this.getLastRequests();
	        var numErrorsFlushed = ServerTelemetryManager.maxErrorsToSend(lastRequests);
	        var errorCount = lastRequests.errors.length;
	        if (numErrorsFlushed === errorCount) {
	            // All errors were sent on last request, clear Telemetry cache
	            this.cacheManager.removeItem(this.telemetryCacheKey);
	        }
	        else {
	            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
	            var serverTelemEntity = new ServerTelemetryEntity();
	            serverTelemEntity.failedRequests = lastRequests.failedRequests.slice(numErrorsFlushed * 2); // failedRequests contains 2 items for each error
	            serverTelemEntity.errors = lastRequests.errors.slice(numErrorsFlushed);
	            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity);
	        }
	    };
	    /**
	     * Returns the maximum number of errors that can be flushed to the server in the next network request
	     * @param serverTelemetryEntity
	     */
	    ServerTelemetryManager.maxErrorsToSend = function (serverTelemetryEntity) {
	        var i;
	        var maxErrors = 0;
	        var dataSize = 0;
	        var errorCount = serverTelemetryEntity.errors.length;
	        for (i = 0; i < errorCount; i++) {
	            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
	            var apiId = serverTelemetryEntity.failedRequests[2 * i] || Constants.EMPTY_STRING;
	            var correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || Constants.EMPTY_STRING;
	            var errorCode = serverTelemetryEntity.errors[i] || Constants.EMPTY_STRING;
	            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
	            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
	            if (dataSize < SERVER_TELEM_CONSTANTS.MAX_HEADER_BYTES) {
	                // Adding this entry to the header would still keep header size below the limit
	                maxErrors += 1;
	            }
	            else {
	                break;
	            }
	        }
	        return maxErrors;
	    };
	    return ServerTelemetryManager;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Constants
	 */
	var BrowserConstants = {
	    /**
	     * Interaction in progress cache value
	     */
	    INTERACTION_IN_PROGRESS_VALUE: "interaction_in_progress",
	    /**
	     * Invalid grant error code
	     */
	    INVALID_GRANT_ERROR: "invalid_grant",
	    /**
	     * Default popup window width
	     */
	    POPUP_WIDTH: 483,
	    /**
	     * Default popup window height
	     */
	    POPUP_HEIGHT: 600,
	    /**
	     * Default popup monitor poll interval in milliseconds
	     */
	    POLL_INTERVAL_MS: 50,
	    /**
	     * Msal-browser SKU
	     */
	    MSAL_SKU: "msal.js.browser",
	};
	(function (BrowserCacheLocation) {
	    BrowserCacheLocation["LocalStorage"] = "localStorage";
	    BrowserCacheLocation["SessionStorage"] = "sessionStorage";
	    BrowserCacheLocation["MemoryStorage"] = "memoryStorage";
	})(exports.BrowserCacheLocation || (exports.BrowserCacheLocation = {}));
	/**
	 * HTTP Request types supported by MSAL.
	 */
	var HTTP_REQUEST_TYPE;
	(function (HTTP_REQUEST_TYPE) {
	    HTTP_REQUEST_TYPE["GET"] = "GET";
	    HTTP_REQUEST_TYPE["POST"] = "POST";
	})(HTTP_REQUEST_TYPE || (HTTP_REQUEST_TYPE = {}));
	/**
	 * Temporary cache keys for MSAL, deleted after any request.
	 */
	var TemporaryCacheKeys;
	(function (TemporaryCacheKeys) {
	    TemporaryCacheKeys["AUTHORITY"] = "authority";
	    TemporaryCacheKeys["ACQUIRE_TOKEN_ACCOUNT"] = "acquireToken.account";
	    TemporaryCacheKeys["SESSION_STATE"] = "session.state";
	    TemporaryCacheKeys["REQUEST_STATE"] = "request.state";
	    TemporaryCacheKeys["NONCE_IDTOKEN"] = "nonce.id_token";
	    TemporaryCacheKeys["ORIGIN_URI"] = "request.origin";
	    TemporaryCacheKeys["RENEW_STATUS"] = "token.renew.status";
	    TemporaryCacheKeys["URL_HASH"] = "urlHash";
	    TemporaryCacheKeys["REQUEST_PARAMS"] = "request.params";
	    TemporaryCacheKeys["SCOPES"] = "scopes";
	    TemporaryCacheKeys["INTERACTION_STATUS_KEY"] = "interaction.status";
	})(TemporaryCacheKeys || (TemporaryCacheKeys = {}));
	(function (ApiId) {
	    ApiId[ApiId["acquireTokenRedirect"] = 861] = "acquireTokenRedirect";
	    ApiId[ApiId["acquireTokenPopup"] = 862] = "acquireTokenPopup";
	    ApiId[ApiId["ssoSilent"] = 863] = "ssoSilent";
	    ApiId[ApiId["acquireTokenSilent_authCode"] = 864] = "acquireTokenSilent_authCode";
	    ApiId[ApiId["handleRedirectPromise"] = 865] = "handleRedirectPromise";
	    ApiId[ApiId["acquireTokenSilent_silentFlow"] = 61] = "acquireTokenSilent_silentFlow";
	    ApiId[ApiId["logout"] = 961] = "logout";
	})(exports.ApiId || (exports.ApiId = {}));
	(function (InteractionType) {
	    InteractionType["Redirect"] = "redirect";
	    InteractionType["Popup"] = "popup";
	    InteractionType["Silent"] = "silent";
	})(exports.InteractionType || (exports.InteractionType = {}));
	(function (InteractionStatus) {
	    /**
	     * Initial status before interaction occurs
	     */
	    InteractionStatus["Startup"] = "startup";
	    /**
	     * Status set when all login calls occuring
	     */
	    InteractionStatus["Login"] = "login";
	    /**
	     * Status set when logout call occuring
	     */
	    InteractionStatus["Logout"] = "logout";
	    /**
	     * Status set for acquireToken calls
	     */
	    InteractionStatus["AcquireToken"] = "acquireToken";
	    /**
	     * Status set for ssoSilent calls
	     */
	    InteractionStatus["SsoSilent"] = "ssoSilent";
	    /**
	     * Status set when handleRedirect in progress
	     */
	    InteractionStatus["HandleRedirect"] = "handleRedirect";
	    /**
	     * Status set when interaction is complete
	     */
	    InteractionStatus["None"] = "none";
	})(exports.InteractionStatus || (exports.InteractionStatus = {}));
	var DEFAULT_REQUEST = {
	    scopes: OIDC_DEFAULT_SCOPES
	};
	/**
	 * JWK Key Format string (Type MUST be defined for window crypto APIs)
	 */
	var KEY_FORMAT_JWK = "jwk";
	(function (WrapperSKU) {
	    WrapperSKU["React"] = "@azure/msal-react";
	    WrapperSKU["Angular"] = "@azure/msal-angular";
	})(exports.WrapperSKU || (exports.WrapperSKU = {}));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Utility class for math specific functions in browser.
	 */
	var MathUtils = /** @class */ (function () {
	    function MathUtils() {
	    }
	    /**
	     * Decimal to Hex
	     *
	     * @param num
	     */
	    MathUtils.decimalToHex = function (num) {
	        var hex = num.toString(16);
	        while (hex.length < 2) {
	            hex = "0" + hex;
	        }
	        return hex;
	    };
	    return MathUtils;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var GuidGenerator = /** @class */ (function () {
	    function GuidGenerator(cryptoObj) {
	        this.cryptoObj = cryptoObj;
	    }
	    /*
	     * RFC4122: The version 4 UUID is meant for generating UUIDs from truly-random or
	     * pseudo-random numbers.
	     * The algorithm is as follows:
	     *     Set the two most significant bits (bits 6 and 7) of the
	     *        clock_seq_hi_and_reserved to zero and one, respectively.
	     *     Set the four most significant bits (bits 12 through 15) of the
	     *        time_hi_and_version field to the 4-bit version number from
	     *        Section 4.1.3. Version4
	     *     Set all the other bits to randomly (or pseudo-randomly) chosen
	     *     values.
	     * UUID                   = time-low "-" time-mid "-"time-high-and-version "-"clock-seq-reserved and low(2hexOctet)"-" node
	     * time-low               = 4hexOctet
	     * time-mid               = 2hexOctet
	     * time-high-and-version  = 2hexOctet
	     * clock-seq-and-reserved = hexOctet:
	     * clock-seq-low          = hexOctet
	     * node                   = 6hexOctet
	     * Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
	     * y could be 1000, 1001, 1010, 1011 since most significant two bits needs to be 10
	     * y values are 8, 9, A, B
	     */
	    GuidGenerator.prototype.generateGuid = function () {
	        try {
	            var buffer = new Uint8Array(16);
	            this.cryptoObj.getRandomValues(buffer);
	            // buffer[6] and buffer[7] represents the time_hi_and_version field. We will set the four most significant bits (4 through 7) of buffer[6] to represent decimal number 4 (UUID version number).
	            buffer[6] |= 0x40; // buffer[6] | 01000000 will set the 6 bit to 1.
	            buffer[6] &= 0x4f; // buffer[6] & 01001111 will set the 4, 5, and 7 bit to 0 such that bits 4-7 == 0100 = "4".
	            // buffer[8] represents the clock_seq_hi_and_reserved field. We will set the two most significant bits (6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively.
	            buffer[8] |= 0x80; // buffer[8] | 10000000 will set the 7 bit to 1.
	            buffer[8] &= 0xbf; // buffer[8] & 10111111 will set the 6 bit to 0.
	            return MathUtils.decimalToHex(buffer[0]) + MathUtils.decimalToHex(buffer[1])
	                + MathUtils.decimalToHex(buffer[2]) + MathUtils.decimalToHex(buffer[3])
	                + "-" + MathUtils.decimalToHex(buffer[4]) + MathUtils.decimalToHex(buffer[5])
	                + "-" + MathUtils.decimalToHex(buffer[6]) + MathUtils.decimalToHex(buffer[7])
	                + "-" + MathUtils.decimalToHex(buffer[8]) + MathUtils.decimalToHex(buffer[9])
	                + "-" + MathUtils.decimalToHex(buffer[10]) + MathUtils.decimalToHex(buffer[11])
	                + MathUtils.decimalToHex(buffer[12]) + MathUtils.decimalToHex(buffer[13])
	                + MathUtils.decimalToHex(buffer[14]) + MathUtils.decimalToHex(buffer[15]);
	        }
	        catch (err) {
	            var guidHolder = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx";
	            var hex = "0123456789abcdef";
	            var r = 0;
	            var guidResponse = "";
	            for (var i = 0; i < 36; i++) {
	                if (guidHolder[i] !== "-" && guidHolder[i] !== "4") {
	                    // each x and y needs to be random
	                    r = Math.random() * 16 | 0;
	                }
	                if (guidHolder[i] === "x") {
	                    guidResponse += hex[r];
	                }
	                else if (guidHolder[i] === "y") {
	                    // clock-seq-and-reserved first hex is filtered and remaining hex values are random
	                    r &= 0x3; // bit and with 0011 to set pos 2 to zero ?0??
	                    r |= 0x8; // set pos 3 to 1 as 1???
	                    guidResponse += hex[r];
	                }
	                else {
	                    guidResponse += guidHolder[i];
	                }
	            }
	            return guidResponse;
	        }
	    };
	    /**
	     * verifies if a string is  GUID
	     * @param guid
	     */
	    GuidGenerator.isGuid = function (guid) {
	        var regexGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
	        return regexGuid.test(guid);
	    };
	    return GuidGenerator;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Utility functions for strings in a browser. See here for implementation details:
	 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
	 */
	var BrowserStringUtils = /** @class */ (function () {
	    function BrowserStringUtils() {
	    }
	    /**
	     * Converts string to Uint8Array
	     * @param sDOMStr
	     */
	    BrowserStringUtils.stringToUtf8Arr = function (sDOMStr) {
	        var nChr;
	        var nArrLen = 0;
	        var nStrLen = sDOMStr.length;
	        /* mapping... */
	        for (var nMapIdx = 0; nMapIdx < nStrLen; nMapIdx++) {
	            nChr = sDOMStr.charCodeAt(nMapIdx);
	            nArrLen += nChr < 0x80 ? 1 : nChr < 0x800 ? 2 : nChr < 0x10000 ? 3 : nChr < 0x200000 ? 4 : nChr < 0x4000000 ? 5 : 6;
	        }
	        var aBytes = new Uint8Array(nArrLen);
	        /* transcription... */
	        for (var nIdx = 0, nChrIdx = 0; nIdx < nArrLen; nChrIdx++) {
	            nChr = sDOMStr.charCodeAt(nChrIdx);
	            if (nChr < 128) {
	                /* one byte */
	                aBytes[nIdx++] = nChr;
	            }
	            else if (nChr < 0x800) {
	                /* two bytes */
	                aBytes[nIdx++] = 192 + (nChr >>> 6);
	                aBytes[nIdx++] = 128 + (nChr & 63);
	            }
	            else if (nChr < 0x10000) {
	                /* three bytes */
	                aBytes[nIdx++] = 224 + (nChr >>> 12);
	                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
	                aBytes[nIdx++] = 128 + (nChr & 63);
	            }
	            else if (nChr < 0x200000) {
	                /* four bytes */
	                aBytes[nIdx++] = 240 + (nChr >>> 18);
	                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
	                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
	                aBytes[nIdx++] = 128 + (nChr & 63);
	            }
	            else if (nChr < 0x4000000) {
	                /* five bytes */
	                aBytes[nIdx++] = 248 + (nChr >>> 24);
	                aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
	                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
	                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
	                aBytes[nIdx++] = 128 + (nChr & 63);
	            }
	            else /* if (nChr <= 0x7fffffff) */ {
	                /* six bytes */
	                aBytes[nIdx++] = 252 + (nChr >>> 30);
	                aBytes[nIdx++] = 128 + (nChr >>> 24 & 63);
	                aBytes[nIdx++] = 128 + (nChr >>> 18 & 63);
	                aBytes[nIdx++] = 128 + (nChr >>> 12 & 63);
	                aBytes[nIdx++] = 128 + (nChr >>> 6 & 63);
	                aBytes[nIdx++] = 128 + (nChr & 63);
	            }
	        }
	        return aBytes;
	    };
	    /**
	     * Converst string to ArrayBuffer
	     * @param dataString
	     */
	    BrowserStringUtils.stringToArrayBuffer = function (dataString) {
	        var data = new ArrayBuffer(dataString.length);
	        var dataView = new Uint8Array(data);
	        for (var i = 0; i < dataString.length; i++) {
	            dataView[i] = dataString.charCodeAt(i);
	        }
	        return data;
	    };
	    /**
	     * Converts Uint8Array to a string
	     * @param aBytes
	     */
	    BrowserStringUtils.utf8ArrToString = function (aBytes) {
	        var sView = "";
	        for (var nPart = void 0, nLen = aBytes.length, nIdx = 0; nIdx < nLen; nIdx++) {
	            nPart = aBytes[nIdx];
	            sView += String.fromCharCode(nPart > 251 && nPart < 254 && nIdx + 5 < nLen ? /* six bytes */
	                /* (nPart - 252 << 30) may be not so safe in ECMAScript! So...: */
	                (nPart - 252) * 1073741824 + (aBytes[++nIdx] - 128 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
	                : nPart > 247 && nPart < 252 && nIdx + 4 < nLen ? /* five bytes */
	                    (nPart - 248 << 24) + (aBytes[++nIdx] - 128 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
	                    : nPart > 239 && nPart < 248 && nIdx + 3 < nLen ? /* four bytes */
	                        (nPart - 240 << 18) + (aBytes[++nIdx] - 128 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
	                        : nPart > 223 && nPart < 240 && nIdx + 2 < nLen ? /* three bytes */
	                            (nPart - 224 << 12) + (aBytes[++nIdx] - 128 << 6) + aBytes[++nIdx] - 128
	                            : nPart > 191 && nPart < 224 && nIdx + 1 < nLen ? /* two bytes */
	                                (nPart - 192 << 6) + aBytes[++nIdx] - 128
	                                : /* nPart < 127 ? */ /* one byte */
	                                    nPart);
	        }
	        return sView;
	    };
	    return BrowserStringUtils;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
	 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
	 */
	var Base64Encode = /** @class */ (function () {
	    function Base64Encode() {
	    }
	    /**
	     * Returns URL Safe b64 encoded string from a plaintext string.
	     * @param input
	     */
	    Base64Encode.prototype.urlEncode = function (input) {
	        return encodeURIComponent(this.encode(input)
	            .replace(/=/g, "")
	            .replace(/\+/g, "-")
	            .replace(/\//g, "_"));
	    };
	    /**
	     * Returns URL Safe b64 encoded string from an int8Array.
	     * @param inputArr
	     */
	    Base64Encode.prototype.urlEncodeArr = function (inputArr) {
	        return this.base64EncArr(inputArr)
	            .replace(/=/g, "")
	            .replace(/\+/g, "-")
	            .replace(/\//g, "_");
	    };
	    /**
	     * Returns b64 encoded string from plaintext string.
	     * @param input
	     */
	    Base64Encode.prototype.encode = function (input) {
	        var inputUtf8Arr = BrowserStringUtils.stringToUtf8Arr(input);
	        return this.base64EncArr(inputUtf8Arr);
	    };
	    /**
	     * Base64 encode byte array
	     * @param aBytes
	     */
	    Base64Encode.prototype.base64EncArr = function (aBytes) {
	        var eqLen = (3 - (aBytes.length % 3)) % 3;
	        var sB64Enc = "";
	        for (var nMod3 = void 0, nLen = aBytes.length, nUint24 = 0, nIdx = 0; nIdx < nLen; nIdx++) {
	            nMod3 = nIdx % 3;
	            /* Uncomment the following line in order to split the output in lines 76-character long: */
	            /*
	             *if (nIdx > 0 && (nIdx * 4 / 3) % 76 === 0) { sB64Enc += "\r\n"; }
	             */
	            nUint24 |= aBytes[nIdx] << (16 >>> nMod3 & 24);
	            if (nMod3 === 2 || aBytes.length - nIdx === 1) {
	                sB64Enc += String.fromCharCode(this.uint6ToB64(nUint24 >>> 18 & 63), this.uint6ToB64(nUint24 >>> 12 & 63), this.uint6ToB64(nUint24 >>> 6 & 63), this.uint6ToB64(nUint24 & 63));
	                nUint24 = 0;
	            }
	        }
	        return eqLen === 0 ? sB64Enc : sB64Enc.substring(0, sB64Enc.length - eqLen) + (eqLen === 1 ? "=" : "==");
	    };
	    /**
	     * Base64 string to array encoding helper
	     * @param nUint6
	     */
	    Base64Encode.prototype.uint6ToB64 = function (nUint6) {
	        return nUint6 < 26 ?
	            nUint6 + 65
	            : nUint6 < 52 ?
	                nUint6 + 71
	                : nUint6 < 62 ?
	                    nUint6 - 4
	                    : nUint6 === 62 ?
	                        43
	                        : nUint6 === 63 ?
	                            47
	                            :
	                                65;
	    };
	    return Base64Encode;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
	 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
	 */
	var Base64Decode = /** @class */ (function () {
	    function Base64Decode() {
	    }
	    /**
	     * Returns a URL-safe plaintext decoded string from b64 encoded input.
	     * @param input
	     */
	    Base64Decode.prototype.decode = function (input) {
	        var encodedString = input.replace(/-/g, "+").replace(/_/g, "/");
	        switch (encodedString.length % 4) {
	            case 0:
	                break;
	            case 2:
	                encodedString += "==";
	                break;
	            case 3:
	                encodedString += "=";
	                break;
	            default:
	                throw new Error("Invalid base64 string");
	        }
	        var inputUtf8Arr = this.base64DecToArr(encodedString);
	        return BrowserStringUtils.utf8ArrToString(inputUtf8Arr);
	    };
	    /**
	     * Decodes base64 into Uint8Array
	     * @param base64String
	     * @param nBlockSize
	     */
	    Base64Decode.prototype.base64DecToArr = function (base64String, nBlockSize) {
	        var sB64Enc = base64String.replace(/[^A-Za-z0-9\+\/]/g, "");
	        var nInLen = sB64Enc.length;
	        var nOutLen = nBlockSize ? Math.ceil((nInLen * 3 + 1 >>> 2) / nBlockSize) * nBlockSize : nInLen * 3 + 1 >>> 2;
	        var aBytes = new Uint8Array(nOutLen);
	        for (var nMod3 = void 0, nMod4 = void 0, nUint24 = 0, nOutIdx = 0, nInIdx = 0; nInIdx < nInLen; nInIdx++) {
	            nMod4 = nInIdx & 3;
	            nUint24 |= this.b64ToUint6(sB64Enc.charCodeAt(nInIdx)) << 18 - 6 * nMod4;
	            if (nMod4 === 3 || nInLen - nInIdx === 1) {
	                for (nMod3 = 0; nMod3 < 3 && nOutIdx < nOutLen; nMod3++, nOutIdx++) {
	                    aBytes[nOutIdx] = nUint24 >>> (16 >>> nMod3 & 24) & 255;
	                }
	                nUint24 = 0;
	            }
	        }
	        return aBytes;
	    };
	    /**
	     * Base64 string to array decoding helper
	     * @param charNum
	     */
	    Base64Decode.prototype.b64ToUint6 = function (charNum) {
	        return charNum > 64 && charNum < 91 ?
	            charNum - 65
	            : charNum > 96 && charNum < 123 ?
	                charNum - 71
	                : charNum > 47 && charNum < 58 ?
	                    charNum + 4
	                    : charNum === 43 ?
	                        62
	                        : charNum === 47 ?
	                            63
	                            :
	                                0;
	    };
	    return Base64Decode;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
	 */
	var BrowserAuthErrorMessage = {
	    pkceNotGenerated: {
	        code: "pkce_not_created",
	        desc: "The PKCE code challenge and verifier could not be generated."
	    },
	    cryptoDoesNotExist: {
	        code: "crypto_nonexistent",
	        desc: "The crypto object or function is not available."
	    },
	    httpMethodNotImplementedError: {
	        code: "http_method_not_implemented",
	        desc: "The HTTP method given has not been implemented in this library."
	    },
	    emptyNavigateUriError: {
	        code: "empty_navigate_uri",
	        desc: "Navigation URI is empty. Please check stack trace for more info."
	    },
	    hashEmptyError: {
	        code: "hash_empty_error",
	        desc: "Hash value cannot be processed because it is empty."
	    },
	    hashDoesNotContainStateError: {
	        code: "no_state_in_hash",
	        desc: "Hash does not contain state. Please verify that the request originated from msal."
	    },
	    unableToParseStateError: {
	        code: "unable_to_parse_state",
	        desc: "Unable to parse state. Please verify that the request originated from msal."
	    },
	    stateInteractionTypeMismatchError: {
	        code: "state_interaction_type_mismatch",
	        desc: "Hash contains state but the interaction type does not match the caller."
	    },
	    interactionInProgress: {
	        code: "interaction_in_progress",
	        desc: "Interaction is currently in progress. Please ensure that this interaction has been completed before calling an interactive API.  For more visit: aka.ms/msaljs/browser-errors."
	    },
	    popUpWindowError: {
	        code: "popup_window_error",
	        desc: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser."
	    },
	    emptyWindowError: {
	        code: "empty_window_error",
	        desc: "window.open returned null or undefined window object."
	    },
	    userCancelledError: {
	        code: "user_cancelled",
	        desc: "User cancelled the flow."
	    },
	    monitorPopupTimeoutError: {
	        code: "monitor_window_timeout",
	        desc: "Token acquisition in popup failed due to timeout."
	    },
	    monitorIframeTimeoutError: {
	        code: "monitor_window_timeout",
	        desc: "Token acquisition in iframe failed due to timeout."
	    },
	    redirectInIframeError: {
	        code: "redirect_in_iframe",
	        desc: "Code flow is not supported inside an iframe. Please ensure you are using MSAL.js in a top frame of the window if using the redirect APIs, or use the popup APIs."
	    },
	    blockTokenRequestsInHiddenIframeError: {
	        code: "block_iframe_reload",
	        desc: "Request was blocked inside an iframe because MSAL detected an authentication response. Please ensure monitorWindowForHash was called."
	    },
	    iframeClosedPrematurelyError: {
	        code: "iframe_closed_prematurely",
	        desc: "The iframe being monitored was closed prematurely."
	    },
	    silentSSOInsufficientInfoError: {
	        code: "silent_sso_error",
	        desc: "Silent SSO could not be completed - insufficient information was provided. Please provide either a loginHint or sid."
	    },
	    noAccountError: {
	        code: "no_account_error",
	        desc: "No account object provided to acquireTokenSilent and no active account has been set. Please call setActiveAccount or provide an account on the request."
	    },
	    silentPromptValueError: {
	        code: "silent_prompt_value_error",
	        desc: "The value given for the prompt value is not valid for silent requests - must be set to 'none'."
	    },
	    noTokenRequestCacheError: {
	        code: "no_token_request_cache_error",
	        desc: "No token request in found in cache."
	    },
	    unableToParseTokenRequestCacheError: {
	        code: "unable_to_parse_token_request_cache_error",
	        desc: "The cached token request could not be parsed."
	    },
	    noCachedAuthorityError: {
	        code: "no_cached_authority_error",
	        desc: "No cached authority found."
	    },
	    authRequestNotSet: {
	        code: "auth_request_not_set_error",
	        desc: "Auth Request not set. Please ensure initiateAuthRequest was called from the InteractionHandler"
	    },
	    invalidCacheType: {
	        code: "invalid_cache_type",
	        desc: "Invalid cache type"
	    },
	    notInBrowserEnvironment: {
	        code: "non_browser_environment",
	        desc: "Login and token requests are not supported in non-browser environments."
	    },
	    databaseNotOpen: {
	        code: "database_not_open",
	        desc: "Database is not open!"
	    },
	    noNetworkConnectivity: {
	        code: "no_network_connectivity",
	        desc: "No network connectivity. Check your internet connection."
	    },
	    postRequestFailed: {
	        code: "post_request_failed",
	        desc: "Network request failed: If the browser threw a CORS error, check that the redirectUri is registered in the Azure App Portal as type 'SPA'"
	    },
	    getRequestFailed: {
	        code: "get_request_failed",
	        desc: "Network request failed. Please check the network trace to determine root cause."
	    },
	    failedToParseNetworkResponse: {
	        code: "failed_to_parse_response",
	        desc: "Failed to parse network response. Check network trace."
	    }
	};
	/**
	 * Browser library error class thrown by the MSAL.js library for SPAs
	 */
	var BrowserAuthError = /** @class */ (function (_super) {
	    __extends(BrowserAuthError, _super);
	    function BrowserAuthError(errorCode, errorMessage) {
	        var _this = _super.call(this, errorCode, errorMessage) || this;
	        Object.setPrototypeOf(_this, BrowserAuthError.prototype);
	        _this.name = "BrowserAuthError";
	        return _this;
	    }
	    /**
	     * Creates an error thrown when PKCE is not implemented.
	     * @param errDetail
	     */
	    BrowserAuthError.createPkceNotGeneratedError = function (errDetail) {
	        return new BrowserAuthError(BrowserAuthErrorMessage.pkceNotGenerated.code, BrowserAuthErrorMessage.pkceNotGenerated.desc + " Detail:" + errDetail);
	    };
	    /**
	     * Creates an error thrown when the crypto object is unavailable.
	     * @param errDetail
	     */
	    BrowserAuthError.createCryptoNotAvailableError = function (errDetail) {
	        return new BrowserAuthError(BrowserAuthErrorMessage.cryptoDoesNotExist.code, BrowserAuthErrorMessage.cryptoDoesNotExist.desc + " Detail:" + errDetail);
	    };
	    /**
	     * Creates an error thrown when an HTTP method hasn't been implemented by the browser class.
	     * @param method
	     */
	    BrowserAuthError.createHttpMethodNotImplementedError = function (method) {
	        return new BrowserAuthError(BrowserAuthErrorMessage.httpMethodNotImplementedError.code, BrowserAuthErrorMessage.httpMethodNotImplementedError.desc + " Given Method: " + method);
	    };
	    /**
	     * Creates an error thrown when the navigation URI is empty.
	     */
	    BrowserAuthError.createEmptyNavigationUriError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.emptyNavigateUriError.code, BrowserAuthErrorMessage.emptyNavigateUriError.desc);
	    };
	    /**
	     * Creates an error thrown when the hash string value is unexpectedly empty.
	     * @param hashValue
	     */
	    BrowserAuthError.createEmptyHashError = function (hashValue) {
	        return new BrowserAuthError(BrowserAuthErrorMessage.hashEmptyError.code, BrowserAuthErrorMessage.hashEmptyError.desc + " Given Url: " + hashValue);
	    };
	    /**
	     * Creates an error thrown when the hash string value is unexpectedly empty.
	     */
	    BrowserAuthError.createHashDoesNotContainStateError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.hashDoesNotContainStateError.code, BrowserAuthErrorMessage.hashDoesNotContainStateError.desc);
	    };
	    /**
	     * Creates an error thrown when the hash string value is unexpectedly empty.
	     */
	    BrowserAuthError.createUnableToParseStateError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.unableToParseStateError.code, BrowserAuthErrorMessage.unableToParseStateError.desc);
	    };
	    /**
	     * Creates an error thrown when the state value in the hash does not match the interaction type of the API attempting to consume it.
	     */
	    BrowserAuthError.createStateInteractionTypeMismatchError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.stateInteractionTypeMismatchError.code, BrowserAuthErrorMessage.stateInteractionTypeMismatchError.desc);
	    };
	    /**
	     * Creates an error thrown when a browser interaction (redirect or popup) is in progress.
	     */
	    BrowserAuthError.createInteractionInProgressError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.interactionInProgress.code, BrowserAuthErrorMessage.interactionInProgress.desc);
	    };
	    /**
	     * Creates an error thrown when the popup window could not be opened.
	     * @param errDetail
	     */
	    BrowserAuthError.createPopupWindowError = function (errDetail) {
	        var errorMessage = BrowserAuthErrorMessage.popUpWindowError.desc;
	        errorMessage = !StringUtils.isEmpty(errDetail) ? errorMessage + " Details: " + errDetail : errorMessage;
	        return new BrowserAuthError(BrowserAuthErrorMessage.popUpWindowError.code, errorMessage);
	    };
	    /**
	     * Creates an error thrown when window.open returns an empty window object.
	     * @param errDetail
	     */
	    BrowserAuthError.createEmptyWindowCreatedError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.emptyWindowError.code, BrowserAuthErrorMessage.emptyWindowError.desc);
	    };
	    /**
	     * Creates an error thrown when the user closes a popup.
	     */
	    BrowserAuthError.createUserCancelledError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.userCancelledError.code, BrowserAuthErrorMessage.userCancelledError.desc);
	    };
	    /**
	     * Creates an error thrown when monitorPopupFromHash times out for a given popup.
	     */
	    BrowserAuthError.createMonitorPopupTimeoutError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.monitorPopupTimeoutError.code, BrowserAuthErrorMessage.monitorPopupTimeoutError.desc);
	    };
	    /**
	     * Creates an error thrown when monitorIframeFromHash times out for a given iframe.
	     */
	    BrowserAuthError.createMonitorIframeTimeoutError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.monitorIframeTimeoutError.code, BrowserAuthErrorMessage.monitorIframeTimeoutError.desc);
	    };
	    /**
	     * Creates an error thrown when navigateWindow is called inside an iframe.
	     * @param windowParentCheck
	     */
	    BrowserAuthError.createRedirectInIframeError = function (windowParentCheck) {
	        return new BrowserAuthError(BrowserAuthErrorMessage.redirectInIframeError.code, BrowserAuthErrorMessage.redirectInIframeError.desc + " (window.parent !== window) => " + windowParentCheck);
	    };
	    /**
	     * Creates an error thrown when an auth reload is done inside an iframe.
	     */
	    BrowserAuthError.createBlockReloadInHiddenIframeError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.blockTokenRequestsInHiddenIframeError.code, BrowserAuthErrorMessage.blockTokenRequestsInHiddenIframeError.desc);
	    };
	    /**
	     * Creates an error thrown when an iframe is found to be closed before the timeout is reached.
	     */
	    BrowserAuthError.createIframeClosedPrematurelyError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.iframeClosedPrematurelyError.code, BrowserAuthErrorMessage.iframeClosedPrematurelyError.desc);
	    };
	    /**
	     * Creates an error thrown when the login_hint, sid or account object is not provided in the ssoSilent API.
	     */
	    BrowserAuthError.createSilentSSOInsufficientInfoError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.silentSSOInsufficientInfoError.code, BrowserAuthErrorMessage.silentSSOInsufficientInfoError.desc);
	    };
	    /**
	     * Creates an error thrown when the account object is not provided in the acquireTokenSilent API.
	     */
	    BrowserAuthError.createNoAccountError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.noAccountError.code, BrowserAuthErrorMessage.noAccountError.desc);
	    };
	    /**
	     * Creates an error thrown when a given prompt value is invalid for silent requests.
	     */
	    BrowserAuthError.createSilentPromptValueError = function (givenPrompt) {
	        return new BrowserAuthError(BrowserAuthErrorMessage.silentPromptValueError.code, BrowserAuthErrorMessage.silentPromptValueError.desc + " Given value: " + givenPrompt);
	    };
	    /**
	     * Creates an error thrown when the cached token request could not be retrieved from the cache
	     */
	    BrowserAuthError.createUnableToParseTokenRequestCacheError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.unableToParseTokenRequestCacheError.code, BrowserAuthErrorMessage.unableToParseTokenRequestCacheError.desc);
	    };
	    /**
	     * Creates an error thrown when the token request could not be retrieved from the cache
	     */
	    BrowserAuthError.createNoTokenRequestCacheError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.noTokenRequestCacheError.code, BrowserAuthErrorMessage.noTokenRequestCacheError.desc);
	    };
	    /**
	     * Creates an error thrown when handleCodeResponse is called before initiateAuthRequest (InteractionHandler)
	     */
	    BrowserAuthError.createAuthRequestNotSetError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.authRequestNotSet.code, BrowserAuthErrorMessage.authRequestNotSet.desc);
	    };
	    /**
	     * Creates an error thrown when the authority could not be retrieved from the cache
	     */
	    BrowserAuthError.createNoCachedAuthorityError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.noCachedAuthorityError.code, BrowserAuthErrorMessage.noCachedAuthorityError.desc);
	    };
	    /**
	     * Creates an error thrown if cache type is invalid.
	     */
	    BrowserAuthError.createInvalidCacheTypeError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.invalidCacheType.code, "" + BrowserAuthErrorMessage.invalidCacheType.desc);
	    };
	    /**
	     * Create an error thrown when login and token requests are made from a non-browser environment
	     */
	    BrowserAuthError.createNonBrowserEnvironmentError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.notInBrowserEnvironment.code, BrowserAuthErrorMessage.notInBrowserEnvironment.desc);
	    };
	    /**
	     * Create an error thrown when indexDB database is not open
	     */
	    BrowserAuthError.createDatabaseNotOpenError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.databaseNotOpen.code, BrowserAuthErrorMessage.databaseNotOpen.desc);
	    };
	    /**
	     * Create an error thrown when token fetch fails due to no internet
	     */
	    BrowserAuthError.createNoNetworkConnectivityError = function () {
	        return new BrowserAuthError(BrowserAuthErrorMessage.noNetworkConnectivity.code, BrowserAuthErrorMessage.noNetworkConnectivity.desc);
	    };
	    /**
	     * Create an error thrown when token fetch fails due to reasons other than internet connectivity
	     */
	    BrowserAuthError.createPostRequestFailedError = function (errorDesc, endpoint) {
	        return new BrowserAuthError(BrowserAuthErrorMessage.postRequestFailed.code, BrowserAuthErrorMessage.postRequestFailed.desc + " | Network client threw: " + errorDesc + " | Attempted to reach: " + endpoint.split("?")[0]);
	    };
	    /**
	     * Create an error thrown when get request fails due to reasons other than internet connectivity
	     */
	    BrowserAuthError.createGetRequestFailedError = function (errorDesc, endpoint) {
	        return new BrowserAuthError(BrowserAuthErrorMessage.getRequestFailed.code, BrowserAuthErrorMessage.getRequestFailed.desc + " | Network client threw: " + errorDesc + " | Attempted to reach: " + endpoint.split("?")[0]);
	    };
	    /**
	     * Create an error thrown when network client fails to parse network response
	     */
	    BrowserAuthError.createFailedToParseNetworkResponseError = function (endpoint) {
	        return new BrowserAuthError(BrowserAuthErrorMessage.failedToParseNetworkResponse.code, BrowserAuthErrorMessage.failedToParseNetworkResponse.desc + " | Attempted to reach: " + endpoint.split("?")[0]);
	    };
	    return BrowserAuthError;
	}(AuthError));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	// Constant byte array length
	var RANDOM_BYTE_ARR_LENGTH = 32;
	/**
	 * Class which exposes APIs to generate PKCE codes and code verifiers.
	 */
	var PkceGenerator = /** @class */ (function () {
	    function PkceGenerator(cryptoObj) {
	        this.base64Encode = new Base64Encode();
	        this.cryptoObj = cryptoObj;
	    }
	    /**
	     * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
	     */
	    PkceGenerator.prototype.generateCodes = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var codeVerifier, codeChallenge;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        codeVerifier = this.generateCodeVerifier();
	                        return [4 /*yield*/, this.generateCodeChallengeFromVerifier(codeVerifier)];
	                    case 1:
	                        codeChallenge = _a.sent();
	                        return [2 /*return*/, {
	                                verifier: codeVerifier,
	                                challenge: codeChallenge
	                            }];
	                }
	            });
	        });
	    };
	    /**
	     * Generates a random 32 byte buffer and returns the base64
	     * encoded string to be used as a PKCE Code Verifier
	     */
	    PkceGenerator.prototype.generateCodeVerifier = function () {
	        try {
	            // Generate random values as utf-8
	            var buffer = new Uint8Array(RANDOM_BYTE_ARR_LENGTH);
	            this.cryptoObj.getRandomValues(buffer);
	            // encode verifier as base64
	            var pkceCodeVerifierB64 = this.base64Encode.urlEncodeArr(buffer);
	            return pkceCodeVerifierB64;
	        }
	        catch (e) {
	            throw BrowserAuthError.createPkceNotGeneratedError(e);
	        }
	    };
	    /**
	     * Creates a base64 encoded PKCE Code Challenge string from the
	     * hash created from the PKCE Code Verifier supplied
	     */
	    PkceGenerator.prototype.generateCodeChallengeFromVerifier = function (pkceCodeVerifier) {
	        return __awaiter(this, void 0, void 0, function () {
	            var pkceHashedCodeVerifier, e_1;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        _a.trys.push([0, 2, , 3]);
	                        return [4 /*yield*/, this.cryptoObj.sha256Digest(pkceCodeVerifier)];
	                    case 1:
	                        pkceHashedCodeVerifier = _a.sent();
	                        // encode hash as base64
	                        return [2 /*return*/, this.base64Encode.urlEncodeArr(new Uint8Array(pkceHashedCodeVerifier))];
	                    case 2:
	                        e_1 = _a.sent();
	                        throw BrowserAuthError.createPkceNotGeneratedError(e_1);
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    return PkceGenerator;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
	 */
	// RSA KeyGen Algorithm
	var PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
	// SHA-256 hashing algorithm
	var S256_HASH_ALG = "SHA-256";
	// MOD length for PoP tokens
	var MODULUS_LENGTH = 2048;
	// Public Exponent
	var PUBLIC_EXPONENT = new Uint8Array([0x01, 0x00, 0x01]);
	/**
	 * This class implements functions used by the browser library to perform cryptography operations such as
	 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
	 */
	var BrowserCrypto = /** @class */ (function () {
	    function BrowserCrypto() {
	        if (!(this.hasCryptoAPI())) {
	            throw BrowserAuthError.createCryptoNotAvailableError("Browser crypto or msCrypto object not available.");
	        }
	        this._keygenAlgorithmOptions = {
	            name: PKCS1_V15_KEYGEN_ALG,
	            hash: S256_HASH_ALG,
	            modulusLength: MODULUS_LENGTH,
	            publicExponent: PUBLIC_EXPONENT
	        };
	    }
	    /**
	     * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
	     * @param dataString
	     */
	    BrowserCrypto.prototype.sha256Digest = function (dataString) {
	        return __awaiter(this, void 0, void 0, function () {
	            var data;
	            return __generator(this, function (_a) {
	                data = BrowserStringUtils.stringToUtf8Arr(dataString);
	                return [2 /*return*/, this.hasIECrypto() ? this.getMSCryptoDigest(S256_HASH_ALG, data) : this.getSubtleCryptoDigest(S256_HASH_ALG, data)];
	            });
	        });
	    };
	    /**
	     * Populates buffer with cryptographically random values.
	     * @param dataBuffer
	     */
	    BrowserCrypto.prototype.getRandomValues = function (dataBuffer) {
	        var cryptoObj = window["msCrypto"] || window.crypto;
	        if (!cryptoObj.getRandomValues) {
	            throw BrowserAuthError.createCryptoNotAvailableError("getRandomValues does not exist.");
	        }
	        cryptoObj.getRandomValues(dataBuffer);
	    };
	    /**
	     * Generates a keypair based on current keygen algorithm config.
	     * @param extractable
	     * @param usages
	     */
	    BrowserCrypto.prototype.generateKeyPair = function (extractable, usages) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, (this.hasIECrypto() ?
	                        this.msCryptoGenerateKey(extractable, usages)
	                        : window.crypto.subtle.generateKey(this._keygenAlgorithmOptions, extractable, usages))];
	            });
	        });
	    };
	    /**
	     * Export key as Json Web Key (JWK)
	     * @param key
	     * @param format
	     */
	    BrowserCrypto.prototype.exportJwk = function (key) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, this.hasIECrypto() ? this.msCryptoExportJwk(key) : window.crypto.subtle.exportKey(KEY_FORMAT_JWK, key)];
	            });
	        });
	    };
	    /**
	     * Imports key as Json Web Key (JWK), can set extractable and usages.
	     * @param key
	     * @param format
	     * @param extractable
	     * @param usages
	     */
	    BrowserCrypto.prototype.importJwk = function (key, extractable, usages) {
	        return __awaiter(this, void 0, void 0, function () {
	            var keyString, keyBuffer;
	            return __generator(this, function (_a) {
	                keyString = BrowserCrypto.getJwkString(key);
	                keyBuffer = BrowserStringUtils.stringToArrayBuffer(keyString);
	                return [2 /*return*/, this.hasIECrypto() ?
	                        this.msCryptoImportKey(keyBuffer, extractable, usages)
	                        : window.crypto.subtle.importKey(KEY_FORMAT_JWK, key, this._keygenAlgorithmOptions, extractable, usages)];
	            });
	        });
	    };
	    /**
	     * Signs given data with given key
	     * @param key
	     * @param data
	     */
	    BrowserCrypto.prototype.sign = function (key, data) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, this.hasIECrypto() ?
	                        this.msCryptoSign(key, data)
	                        : window.crypto.subtle.sign(this._keygenAlgorithmOptions, key, data)];
	            });
	        });
	    };
	    /**
	     * Check whether IE crypto or other browser cryptography is available.
	     */
	    BrowserCrypto.prototype.hasCryptoAPI = function () {
	        return this.hasIECrypto() || this.hasBrowserCrypto();
	    };
	    /**
	     * Checks whether IE crypto (AKA msCrypto) is available.
	     */
	    BrowserCrypto.prototype.hasIECrypto = function () {
	        return "msCrypto" in window;
	    };
	    /**
	     * Check whether browser crypto is available.
	     */
	    BrowserCrypto.prototype.hasBrowserCrypto = function () {
	        return "crypto" in window;
	    };
	    /**
	     * Helper function for SHA digest.
	     * @param algorithm
	     * @param data
	     */
	    BrowserCrypto.prototype.getSubtleCryptoDigest = function (algorithm, data) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, window.crypto.subtle.digest(algorithm, data)];
	            });
	        });
	    };
	    /**
	     * IE Helper function for SHA digest.
	     * @param algorithm
	     * @param data
	     */
	    BrowserCrypto.prototype.getMSCryptoDigest = function (algorithm, data) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, new Promise(function (resolve, reject) {
	                        var digestOperation = window["msCrypto"].subtle.digest(algorithm, data.buffer);
	                        digestOperation.addEventListener("complete", function (e) {
	                            resolve(e.target.result);
	                        });
	                        digestOperation.addEventListener("error", function (error) {
	                            reject(error);
	                        });
	                    })];
	            });
	        });
	    };
	    /**
	     * IE Helper function for generating a keypair
	     * @param extractable
	     * @param usages
	     */
	    BrowserCrypto.prototype.msCryptoGenerateKey = function (extractable, usages) {
	        return __awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator(this, function (_a) {
	                return [2 /*return*/, new Promise(function (resolve, reject) {
	                        var msGenerateKey = window["msCrypto"].subtle.generateKey(_this._keygenAlgorithmOptions, extractable, usages);
	                        msGenerateKey.addEventListener("complete", function (e) {
	                            resolve(e.target.result);
	                        });
	                        msGenerateKey.addEventListener("error", function (error) {
	                            reject(error);
	                        });
	                    })];
	            });
	        });
	    };
	    /**
	     * IE Helper function for exportKey
	     * @param key
	     * @param format
	     */
	    BrowserCrypto.prototype.msCryptoExportJwk = function (key) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, new Promise(function (resolve, reject) {
	                        var msExportKey = window["msCrypto"].subtle.exportKey(KEY_FORMAT_JWK, key);
	                        msExportKey.addEventListener("complete", function (e) {
	                            var resultBuffer = e.target.result;
	                            var resultString = BrowserStringUtils.utf8ArrToString(new Uint8Array(resultBuffer))
	                                .replace(/\r/g, "")
	                                .replace(/\n/g, "")
	                                .replace(/\t/g, "")
	                                .split(" ").join("")
	                                .replace("\u0000", "");
	                            try {
	                                resolve(JSON.parse(resultString));
	                            }
	                            catch (e) {
	                                reject(e);
	                            }
	                        });
	                        msExportKey.addEventListener("error", function (error) {
	                            reject(error);
	                        });
	                    })];
	            });
	        });
	    };
	    /**
	     * IE Helper function for importKey
	     * @param key
	     * @param format
	     * @param extractable
	     * @param usages
	     */
	    BrowserCrypto.prototype.msCryptoImportKey = function (keyBuffer, extractable, usages) {
	        return __awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator(this, function (_a) {
	                return [2 /*return*/, new Promise(function (resolve, reject) {
	                        var msImportKey = window["msCrypto"].subtle.importKey(KEY_FORMAT_JWK, keyBuffer, _this._keygenAlgorithmOptions, extractable, usages);
	                        msImportKey.addEventListener("complete", function (e) {
	                            resolve(e.target.result);
	                        });
	                        msImportKey.addEventListener("error", function (error) {
	                            reject(error);
	                        });
	                    })];
	            });
	        });
	    };
	    /**
	     * IE Helper function for sign JWT
	     * @param key
	     * @param data
	     */
	    BrowserCrypto.prototype.msCryptoSign = function (key, data) {
	        return __awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator(this, function (_a) {
	                return [2 /*return*/, new Promise(function (resolve, reject) {
	                        var msSign = window["msCrypto"].subtle.sign(_this._keygenAlgorithmOptions, key, data);
	                        msSign.addEventListener("complete", function (e) {
	                            resolve(e.target.result);
	                        });
	                        msSign.addEventListener("error", function (error) {
	                            reject(error);
	                        });
	                    })];
	            });
	        });
	    };
	    /**
	     * Returns stringified jwk.
	     * @param jwk
	     */
	    BrowserCrypto.getJwkString = function (jwk) {
	        return JSON.stringify(jwk, Object.keys(jwk).sort());
	    };
	    return BrowserCrypto;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
	 */
	var DatabaseStorage = /** @class */ (function () {
	    function DatabaseStorage(dbName, tableName, version) {
	        this.dbName = dbName;
	        this.tableName = tableName;
	        this.version = version;
	        this.dbOpen = false;
	    }
	    /**
	     * Opens IndexedDB instance.
	     */
	    DatabaseStorage.prototype.open = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator(this, function (_a) {
	                return [2 /*return*/, new Promise(function (resolve, reject) {
	                        // TODO: Add timeouts?
	                        var openDB = window.indexedDB.open(_this.dbName, _this.version);
	                        openDB.addEventListener("upgradeneeded", function (e) {
	                            var event = e;
	                            event.target.result.createObjectStore(_this.tableName);
	                        });
	                        openDB.addEventListener("success", function (e) {
	                            var event = e;
	                            _this.db = event.target.result;
	                            _this.dbOpen = true;
	                            resolve();
	                        });
	                        openDB.addEventListener("error", function (error) { return reject(error); });
	                    })];
	            });
	        });
	    };
	    /**
	     * Retrieves item from IndexedDB instance.
	     * @param key
	     */
	    DatabaseStorage.prototype.get = function (key) {
	        return __awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!!this.dbOpen) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.open()];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
	                            // TODO: Add timeouts?
	                            if (!_this.db) {
	                                return reject(BrowserAuthError.createDatabaseNotOpenError());
	                            }
	                            var transaction = _this.db.transaction([_this.tableName], "readonly");
	                            var objectStore = transaction.objectStore(_this.tableName);
	                            var dbGet = objectStore.get(key);
	                            dbGet.addEventListener("success", function (e) {
	                                var event = e;
	                                resolve(event.target.result);
	                            });
	                            dbGet.addEventListener("error", function (e) { return reject(e); });
	                        })];
	                }
	            });
	        });
	    };
	    /**
	     * Adds item to IndexedDB under given key
	     * @param key
	     * @param payload
	     */
	    DatabaseStorage.prototype.put = function (key, payload) {
	        return __awaiter(this, void 0, void 0, function () {
	            var _this = this;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!!this.dbOpen) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.open()];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
	                            // TODO: Add timeouts?
	                            if (!_this.db) {
	                                return reject(BrowserAuthError.createDatabaseNotOpenError());
	                            }
	                            var transaction = _this.db.transaction([_this.tableName], "readwrite");
	                            var objectStore = transaction.objectStore(_this.tableName);
	                            var dbPut = objectStore.put(payload, key);
	                            dbPut.addEventListener("success", function (e) {
	                                var event = e;
	                                resolve(event.target.result);
	                            });
	                            dbPut.addEventListener("error", function (e) { return reject(e); });
	                        })];
	                }
	            });
	        });
	    };
	    return DatabaseStorage;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
	 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
	 */
	var CryptoOps = /** @class */ (function () {
	    function CryptoOps() {
	        // Browser crypto needs to be validated first before any other classes can be set.
	        this.browserCrypto = new BrowserCrypto();
	        this.b64Encode = new Base64Encode();
	        this.b64Decode = new Base64Decode();
	        this.guidGenerator = new GuidGenerator(this.browserCrypto);
	        this.pkceGenerator = new PkceGenerator(this.browserCrypto);
	        this.cache = new DatabaseStorage(CryptoOps.DB_NAME, CryptoOps.TABLE_NAME, CryptoOps.DB_VERSION);
	    }
	    /**
	     * Creates a new random GUID - used to populate state and nonce.
	     * @returns string (GUID)
	     */
	    CryptoOps.prototype.createNewGuid = function () {
	        return this.guidGenerator.generateGuid();
	    };
	    /**
	     * Encodes input string to base64.
	     * @param input
	     */
	    CryptoOps.prototype.base64Encode = function (input) {
	        return this.b64Encode.encode(input);
	    };
	    /**
	     * Decodes input string from base64.
	     * @param input
	     */
	    CryptoOps.prototype.base64Decode = function (input) {
	        return this.b64Decode.decode(input);
	    };
	    /**
	     * Generates PKCE codes used in Authorization Code Flow.
	     */
	    CryptoOps.prototype.generatePkceCodes = function () {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, this.pkceGenerator.generateCodes()];
	            });
	        });
	    };
	    /**
	     * Generates a keypair, stores it and returns a thumbprint
	     * @param resourceRequestMethod
	     * @param resourceRequestUri
	     */
	    CryptoOps.prototype.getPublicKeyThumbprint = function (resourceRequestMethod, resourceRequestUri) {
	        return __awaiter(this, void 0, void 0, function () {
	            var keyPair, publicKeyJwk, pubKeyThumprintObj, publicJwkString, publicJwkBuffer, publicJwkHash, privateKeyJwk, unextractablePrivateKey;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.browserCrypto.generateKeyPair(CryptoOps.EXTRACTABLE, CryptoOps.POP_KEY_USAGES)];
	                    case 1:
	                        keyPair = _a.sent();
	                        return [4 /*yield*/, this.browserCrypto.exportJwk(keyPair.publicKey)];
	                    case 2:
	                        publicKeyJwk = _a.sent();
	                        pubKeyThumprintObj = {
	                            e: publicKeyJwk.e,
	                            kty: publicKeyJwk.kty,
	                            n: publicKeyJwk.n
	                        };
	                        publicJwkString = BrowserCrypto.getJwkString(pubKeyThumprintObj);
	                        return [4 /*yield*/, this.browserCrypto.sha256Digest(publicJwkString)];
	                    case 3:
	                        publicJwkBuffer = _a.sent();
	                        publicJwkHash = this.b64Encode.urlEncodeArr(new Uint8Array(publicJwkBuffer));
	                        return [4 /*yield*/, this.browserCrypto.exportJwk(keyPair.privateKey)];
	                    case 4:
	                        privateKeyJwk = _a.sent();
	                        return [4 /*yield*/, this.browserCrypto.importJwk(privateKeyJwk, false, ["sign"])];
	                    case 5:
	                        unextractablePrivateKey = _a.sent();
	                        // Store Keypair data in keystore
	                        this.cache.put(publicJwkHash, {
	                            privateKey: unextractablePrivateKey,
	                            publicKey: keyPair.publicKey,
	                            requestMethod: resourceRequestMethod,
	                            requestUri: resourceRequestUri
	                        });
	                        return [2 /*return*/, publicJwkHash];
	                }
	            });
	        });
	    };
	    /**
	     * Signs the given object as a jwt payload with private key retrieved by given kid.
	     * @param payload
	     * @param kid
	     */
	    CryptoOps.prototype.signJwt = function (payload, kid) {
	        return __awaiter(this, void 0, void 0, function () {
	            var cachedKeyPair, publicKeyJwk, publicKeyJwkString, header, encodedHeader, encodedPayload, tokenString, tokenBuffer, signatureBuffer, encodedSignature;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.cache.get(kid)];
	                    case 1:
	                        cachedKeyPair = _a.sent();
	                        return [4 /*yield*/, this.browserCrypto.exportJwk(cachedKeyPair.publicKey)];
	                    case 2:
	                        publicKeyJwk = _a.sent();
	                        publicKeyJwkString = BrowserCrypto.getJwkString(publicKeyJwk);
	                        header = {
	                            alg: publicKeyJwk.alg,
	                            type: KEY_FORMAT_JWK
	                        };
	                        encodedHeader = this.b64Encode.urlEncode(JSON.stringify(header));
	                        // Generate payload
	                        payload.cnf = {
	                            jwk: JSON.parse(publicKeyJwkString)
	                        };
	                        encodedPayload = this.b64Encode.urlEncode(JSON.stringify(payload));
	                        tokenString = encodedHeader + "." + encodedPayload;
	                        tokenBuffer = BrowserStringUtils.stringToArrayBuffer(tokenString);
	                        return [4 /*yield*/, this.browserCrypto.sign(cachedKeyPair.privateKey, tokenBuffer)];
	                    case 3:
	                        signatureBuffer = _a.sent();
	                        encodedSignature = this.b64Encode.urlEncodeArr(new Uint8Array(signatureBuffer));
	                        return [2 /*return*/, tokenString + "." + encodedSignature];
	                }
	            });
	        });
	    };
	    CryptoOps.POP_KEY_USAGES = ["sign", "verify"];
	    CryptoOps.EXTRACTABLE = true;
	    CryptoOps.DB_VERSION = 1;
	    CryptoOps.DB_NAME = "msal.db";
	    CryptoOps.TABLE_NAME = CryptoOps.DB_NAME + ".keys";
	    return CryptoOps;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
	 */
	var BrowserConfigurationAuthErrorMessage = {
	    redirectUriNotSet: {
	        code: "redirect_uri_empty",
	        desc: "A redirect URI is required for all calls, and none has been set."
	    },
	    postLogoutUriNotSet: {
	        code: "post_logout_uri_empty",
	        desc: "A post logout redirect has not been set."
	    },
	    storageNotSupportedError: {
	        code: "storage_not_supported",
	        desc: "Given storage configuration option was not supported."
	    },
	    noRedirectCallbacksSet: {
	        code: "no_redirect_callbacks",
	        desc: "No redirect callbacks have been set. Please call setRedirectCallbacks() with the appropriate function arguments before continuing. " +
	            "More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
	    },
	    invalidCallbackObject: {
	        code: "invalid_callback_object",
	        desc: "The object passed for the callback was invalid. " +
	            "More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
	    },
	    stubPcaInstanceCalled: {
	        code: "stubbed_public_client_application_called",
	        desc: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors"
	    },
	    inMemRedirectUnavailable: {
	        code: "in_mem_redirect_unavailable",
	        desc: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
	    }
	};
	/**
	 * Browser library error class thrown by the MSAL.js library for SPAs
	 */
	var BrowserConfigurationAuthError = /** @class */ (function (_super) {
	    __extends(BrowserConfigurationAuthError, _super);
	    function BrowserConfigurationAuthError(errorCode, errorMessage) {
	        var _this = _super.call(this, errorCode, errorMessage) || this;
	        _this.name = "BrowserConfigurationAuthError";
	        Object.setPrototypeOf(_this, BrowserConfigurationAuthError.prototype);
	        return _this;
	    }
	    /**
	     * Creates an error thrown when the redirect uri is empty (not set by caller)
	     */
	    BrowserConfigurationAuthError.createRedirectUriEmptyError = function () {
	        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.redirectUriNotSet.code, BrowserConfigurationAuthErrorMessage.redirectUriNotSet.desc);
	    };
	    /**
	     * Creates an error thrown when the post-logout redirect uri is empty (not set by caller)
	     */
	    BrowserConfigurationAuthError.createPostLogoutRedirectUriEmptyError = function () {
	        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.postLogoutUriNotSet.code, BrowserConfigurationAuthErrorMessage.postLogoutUriNotSet.desc);
	    };
	    /**
	     * Creates error thrown when given storage location is not supported.
	     * @param givenStorageLocation
	     */
	    BrowserConfigurationAuthError.createStorageNotSupportedError = function (givenStorageLocation) {
	        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.storageNotSupportedError.code, BrowserConfigurationAuthErrorMessage.storageNotSupportedError.desc + " Given Location: " + givenStorageLocation);
	    };
	    /**
	     * Creates error thrown when callback object is invalid.
	     * @param callbackObject
	     */
	    BrowserConfigurationAuthError.createInvalidCallbackObjectError = function (callbackObject) {
	        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.invalidCallbackObject.code, BrowserConfigurationAuthErrorMessage.invalidCallbackObject.desc + " Given value for callback function: " + callbackObject);
	    };
	    /**
	     * Creates error thrown when redirect callbacks are not set before calling loginRedirect() or acquireTokenRedirect().
	     */
	    BrowserConfigurationAuthError.createRedirectCallbacksNotSetError = function () {
	        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.noRedirectCallbacksSet.code, BrowserConfigurationAuthErrorMessage.noRedirectCallbacksSet.desc);
	    };
	    /**
	     * Creates error thrown when the stub instance of PublicClientApplication is called.
	     */
	    BrowserConfigurationAuthError.createStubPcaInstanceCalledError = function () {
	        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.stubPcaInstanceCalled.code, BrowserConfigurationAuthErrorMessage.stubPcaInstanceCalled.desc);
	    };
	    /*
	     * Create an error thrown when in-memory storage is used and storeAuthStateInCookie=false.
	     */
	    BrowserConfigurationAuthError.createInMemoryRedirectUnavailableError = function () {
	        return new BrowserConfigurationAuthError(BrowserConfigurationAuthErrorMessage.inMemRedirectUnavailable.code, BrowserConfigurationAuthErrorMessage.inMemRedirectUnavailable.desc);
	    };
	    return BrowserConfigurationAuthError;
	}(AuthError));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var BrowserStorage = /** @class */ (function () {
	    function BrowserStorage(cacheLocation) {
	        this.validateWindowStorage(cacheLocation);
	        this.windowStorage = window[cacheLocation];
	    }
	    BrowserStorage.prototype.validateWindowStorage = function (cacheLocation) {
	        if (cacheLocation !== exports.BrowserCacheLocation.LocalStorage && cacheLocation !== exports.BrowserCacheLocation.SessionStorage) {
	            throw BrowserConfigurationAuthError.createStorageNotSupportedError(cacheLocation);
	        }
	        var storageSupported = !!window[cacheLocation];
	        if (!storageSupported) {
	            throw BrowserConfigurationAuthError.createStorageNotSupportedError(cacheLocation);
	        }
	    };
	    BrowserStorage.prototype.getItem = function (key) {
	        return this.windowStorage.getItem(key);
	    };
	    BrowserStorage.prototype.setItem = function (key, value) {
	        this.windowStorage.setItem(key, value);
	    };
	    BrowserStorage.prototype.removeItem = function (key) {
	        this.windowStorage.removeItem(key);
	    };
	    BrowserStorage.prototype.getKeys = function () {
	        return Object.keys(this.windowStorage);
	    };
	    BrowserStorage.prototype.containsKey = function (key) {
	        return this.windowStorage.hasOwnProperty(key);
	    };
	    return BrowserStorage;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var MemoryStorage = /** @class */ (function () {
	    function MemoryStorage() {
	        this.cache = new Map();
	    }
	    MemoryStorage.prototype.getItem = function (key) {
	        return this.cache.get(key) || null;
	    };
	    MemoryStorage.prototype.setItem = function (key, value) {
	        this.cache.set(key, value);
	    };
	    MemoryStorage.prototype.removeItem = function (key) {
	        this.cache.delete(key);
	    };
	    MemoryStorage.prototype.getKeys = function () {
	        var cacheKeys = [];
	        this.cache.forEach(function (value, key) {
	            cacheKeys.push(key);
	        });
	        return cacheKeys;
	    };
	    MemoryStorage.prototype.containsKey = function (key) {
	        return this.cache.has(key);
	    };
	    MemoryStorage.prototype.clear = function () {
	        this.cache.clear();
	    };
	    return MemoryStorage;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var BrowserProtocolUtils = /** @class */ (function () {
	    function BrowserProtocolUtils() {
	    }
	    /**
	     * Extracts the BrowserStateObject from the state string.
	     * @param browserCrypto
	     * @param state
	     */
	    BrowserProtocolUtils.extractBrowserRequestState = function (browserCrypto, state) {
	        if (StringUtils.isEmpty(state)) {
	            return null;
	        }
	        try {
	            var requestStateObj = ProtocolUtils.parseRequestState(browserCrypto, state);
	            return requestStateObj.libraryState.meta;
	        }
	        catch (e) {
	            throw ClientAuthError.createInvalidStateError(state, e);
	        }
	    };
	    /**
	     * Parses properties of server response from url hash
	     * @param locationHash Hash from url
	     */
	    BrowserProtocolUtils.parseServerResponseFromHash = function (locationHash) {
	        if (!locationHash) {
	            return {};
	        }
	        var hashUrlString = new UrlString(locationHash);
	        return UrlString.getDeserializedHash(hashUrlString.getHash());
	    };
	    return BrowserProtocolUtils;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * This class implements the cache storage interface for MSAL through browser local or session storage.
	 * Cookies are only used if storeAuthStateInCookie is true, and are only used for
	 * parameters such as state and nonce, generally.
	 */
	var BrowserCacheManager = /** @class */ (function (_super) {
	    __extends(BrowserCacheManager, _super);
	    function BrowserCacheManager(clientId, cacheConfig, cryptoImpl, logger) {
	        var _this = _super.call(this, clientId, cryptoImpl) || this;
	        // Cookie life calculation (hours * minutes * seconds * ms)
	        _this.COOKIE_LIFE_MULTIPLIER = 24 * 60 * 60 * 1000;
	        _this.cacheConfig = cacheConfig;
	        _this.logger = logger;
	        _this.internalStorage = new MemoryStorage();
	        _this.browserStorage = _this.setupBrowserStorage(_this.cacheConfig.cacheLocation);
	        _this.temporaryCacheStorage = _this.setupTemporaryCacheStorage(_this.cacheConfig.cacheLocation);
	        // Migrate any cache entries from older versions of MSAL.
	        _this.migrateCacheEntries();
	        return _this;
	    }
	    /**
	     * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
	     * @param cacheLocation
	     */
	    BrowserCacheManager.prototype.setupBrowserStorage = function (cacheLocation) {
	        switch (cacheLocation) {
	            case exports.BrowserCacheLocation.LocalStorage:
	            case exports.BrowserCacheLocation.SessionStorage:
	                try {
	                    // Temporary cache items will always be stored in session storage to mitigate problems caused by multiple tabs
	                    return new BrowserStorage(cacheLocation);
	                }
	                catch (e) {
	                    this.logger.verbose(e);
	                    break;
	                }
	            case exports.BrowserCacheLocation.MemoryStorage:
	        }
	        this.cacheConfig.cacheLocation = exports.BrowserCacheLocation.MemoryStorage;
	        return new MemoryStorage();
	    };
	    /**
	     *
	     * @param cacheLocation
	     */
	    BrowserCacheManager.prototype.setupTemporaryCacheStorage = function (cacheLocation) {
	        switch (cacheLocation) {
	            case exports.BrowserCacheLocation.LocalStorage:
	            case exports.BrowserCacheLocation.SessionStorage:
	                try {
	                    // Temporary cache items will always be stored in session storage to mitigate problems caused by multiple tabs
	                    return new BrowserStorage(exports.BrowserCacheLocation.SessionStorage);
	                }
	                catch (e) {
	                    this.logger.verbose(e);
	                    return this.internalStorage;
	                }
	            case exports.BrowserCacheLocation.MemoryStorage:
	            default:
	                return this.internalStorage;
	        }
	    };
	    /**
	     * Migrate all old cache entries to new schema. No rollback supported.
	     * @param storeAuthStateInCookie
	     */
	    BrowserCacheManager.prototype.migrateCacheEntries = function () {
	        var _this = this;
	        var idTokenKey = Constants.CACHE_PREFIX + "." + PersistentCacheKeys.ID_TOKEN;
	        var clientInfoKey = Constants.CACHE_PREFIX + "." + PersistentCacheKeys.CLIENT_INFO;
	        var errorKey = Constants.CACHE_PREFIX + "." + PersistentCacheKeys.ERROR;
	        var errorDescKey = Constants.CACHE_PREFIX + "." + PersistentCacheKeys.ERROR_DESC;
	        var idTokenValue = this.browserStorage.getItem(idTokenKey);
	        var clientInfoValue = this.browserStorage.getItem(clientInfoKey);
	        var errorValue = this.browserStorage.getItem(errorKey);
	        var errorDescValue = this.browserStorage.getItem(errorDescKey);
	        var values = [idTokenValue, clientInfoValue, errorValue, errorDescValue];
	        var keysToMigrate = [PersistentCacheKeys.ID_TOKEN, PersistentCacheKeys.CLIENT_INFO, PersistentCacheKeys.ERROR, PersistentCacheKeys.ERROR_DESC];
	        keysToMigrate.forEach(function (cacheKey, index) { return _this.migrateCacheEntry(cacheKey, values[index]); });
	    };
	    /**
	     * Utility function to help with migration.
	     * @param newKey
	     * @param value
	     * @param storeAuthStateInCookie
	     */
	    BrowserCacheManager.prototype.migrateCacheEntry = function (newKey, value) {
	        if (value) {
	            this.setTemporaryCache(newKey, value, true);
	        }
	    };
	    /**
	     * Parses passed value as JSON object, JSON.parse() will throw an error.
	     * @param input
	     */
	    BrowserCacheManager.prototype.validateAndParseJson = function (jsonValue) {
	        try {
	            var parsedJson = JSON.parse(jsonValue);
	            /**
	             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
	             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
	             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
	             *
	             */
	            return (parsedJson && typeof parsedJson === "object") ? parsedJson : null;
	        }
	        catch (error) {
	            return null;
	        }
	    };
	    /**
	     * fetches the entry from the browser storage based off the key
	     * @param key
	     */
	    BrowserCacheManager.prototype.getItem = function (key) {
	        return this.browserStorage.getItem(key);
	    };
	    /**
	     * sets the entry in the browser storage
	     * @param key
	     * @param value
	     */
	    BrowserCacheManager.prototype.setItem = function (key, value) {
	        this.browserStorage.setItem(key, value);
	    };
	    /**
	     * fetch the account entity from the platform cache
	     * @param accountKey
	     */
	    BrowserCacheManager.prototype.getAccount = function (accountKey) {
	        var account = this.getItem(accountKey);
	        if (!account) {
	            return null;
	        }
	        var parsedAccount = this.validateAndParseJson(account);
	        if (!parsedAccount) {
	            return null;
	        }
	        var accountEntity = CacheManager.toObject(new AccountEntity(), parsedAccount);
	        if (AccountEntity.isAccountEntity(accountEntity)) {
	            return accountEntity;
	        }
	        return null;
	    };
	    /**
	     * set account entity in the platform cache
	     * @param key
	     * @param value
	     */
	    BrowserCacheManager.prototype.setAccount = function (account) {
	        this.logger.verbose("BrowserCacheManager.setAccount called");
	        var key = account.generateAccountKey();
	        this.setItem(key, JSON.stringify(account));
	    };
	    /**
	     * generates idToken entity from a string
	     * @param idTokenKey
	     */
	    BrowserCacheManager.prototype.getIdTokenCredential = function (idTokenKey) {
	        this.logger.verbose("BrowserCacheManager.getIdTokenCredential called");
	        var value = this.getItem(idTokenKey);
	        if (!value) {
	            return null;
	        }
	        var parsedIdToken = this.validateAndParseJson(value);
	        if (!parsedIdToken) {
	            return null;
	        }
	        var idToken = CacheManager.toObject(new IdTokenEntity(), parsedIdToken);
	        if (IdTokenEntity.isIdTokenEntity(idToken)) {
	            this.logger.verbose("BrowserCacheManager.getIdTokenCredential: cache hit");
	            return idToken;
	        }
	        return null;
	    };
	    /**
	     * set IdToken credential to the platform cache
	     * @param idToken
	     */
	    BrowserCacheManager.prototype.setIdTokenCredential = function (idToken) {
	        this.logger.verbose("BrowserCacheManager.setIdTokenCredential called");
	        var idTokenKey = idToken.generateCredentialKey();
	        this.setItem(idTokenKey, JSON.stringify(idToken));
	    };
	    /**
	     * generates accessToken entity from a string
	     * @param key
	     */
	    BrowserCacheManager.prototype.getAccessTokenCredential = function (accessTokenKey) {
	        this.logger.verbose("BrowserCacheManager.getAccessTokenCredential called");
	        var value = this.getItem(accessTokenKey);
	        if (!value) {
	            return null;
	        }
	        var parsedAccessToken = this.validateAndParseJson(value);
	        if (!parsedAccessToken) {
	            return null;
	        }
	        var accessToken = CacheManager.toObject(new AccessTokenEntity(), parsedAccessToken);
	        if (AccessTokenEntity.isAccessTokenEntity(accessToken)) {
	            this.logger.verbose("BrowserCacheManager.getAccessTokenCredential: cache hit");
	            return accessToken;
	        }
	        return null;
	    };
	    /**
	     * set accessToken credential to the platform cache
	     * @param accessToken
	     */
	    BrowserCacheManager.prototype.setAccessTokenCredential = function (accessToken) {
	        this.logger.verbose("BrowserCacheManager.setAccessTokenCredential called");
	        var accessTokenKey = accessToken.generateCredentialKey();
	        this.setItem(accessTokenKey, JSON.stringify(accessToken));
	    };
	    /**
	     * generates refreshToken entity from a string
	     * @param refreshTokenKey
	     */
	    BrowserCacheManager.prototype.getRefreshTokenCredential = function (refreshTokenKey) {
	        this.logger.verbose("BrowserCacheManager.getRefreshTokenCredential called");
	        var value = this.getItem(refreshTokenKey);
	        if (!value) {
	            return null;
	        }
	        var parsedRefreshToken = this.validateAndParseJson(value);
	        if (!parsedRefreshToken) {
	            return null;
	        }
	        var refreshToken = CacheManager.toObject(new RefreshTokenEntity(), parsedRefreshToken);
	        if (RefreshTokenEntity.isRefreshTokenEntity(refreshToken)) {
	            this.logger.verbose("BrowserCacheManager.getRefreshTokenCredential: cache hit");
	            return refreshToken;
	        }
	        return null;
	    };
	    /**
	     * set refreshToken credential to the platform cache
	     * @param refreshToken
	     */
	    BrowserCacheManager.prototype.setRefreshTokenCredential = function (refreshToken) {
	        this.logger.verbose("BrowserCacheManager.setRefreshTokenCredential called");
	        var refreshTokenKey = refreshToken.generateCredentialKey();
	        this.setItem(refreshTokenKey, JSON.stringify(refreshToken));
	    };
	    /**
	     * fetch appMetadata entity from the platform cache
	     * @param appMetadataKey
	     */
	    BrowserCacheManager.prototype.getAppMetadata = function (appMetadataKey) {
	        this.logger.verbose("BrowserCacheManager.getAppMetadata called");
	        var value = this.getItem(appMetadataKey);
	        if (!value) {
	            return null;
	        }
	        var parsedMetadata = this.validateAndParseJson(value);
	        if (!parsedMetadata) {
	            return null;
	        }
	        var appMetadata = CacheManager.toObject(new AppMetadataEntity(), parsedMetadata);
	        if (AppMetadataEntity.isAppMetadataEntity(appMetadataKey, appMetadata)) {
	            this.logger.verbose("BrowserCacheManager.getAppMetadata: cache hit");
	            return appMetadata;
	        }
	        return null;
	    };
	    /**
	     * set appMetadata entity to the platform cache
	     * @param appMetadata
	     */
	    BrowserCacheManager.prototype.setAppMetadata = function (appMetadata) {
	        this.logger.verbose("BrowserCacheManager.setAppMetadata called");
	        var appMetadataKey = appMetadata.generateAppMetadataKey();
	        this.setItem(appMetadataKey, JSON.stringify(appMetadata));
	    };
	    /**
	     * fetch server telemetry entity from the platform cache
	     * @param serverTelemetryKey
	     */
	    BrowserCacheManager.prototype.getServerTelemetry = function (serverTelemetryKey) {
	        this.logger.verbose("BrowserCacheManager.getServerTelemetry called");
	        var value = this.getItem(serverTelemetryKey);
	        if (!value) {
	            return null;
	        }
	        var parsedMetadata = this.validateAndParseJson(value);
	        if (!parsedMetadata) {
	            return null;
	        }
	        var serverTelemetryEntity = CacheManager.toObject(new ServerTelemetryEntity(), parsedMetadata);
	        if (ServerTelemetryEntity.isServerTelemetryEntity(serverTelemetryKey, serverTelemetryEntity)) {
	            this.logger.verbose("BrowserCacheManager.getServerTelemetry: cache hit");
	            return serverTelemetryEntity;
	        }
	        return null;
	    };
	    /**
	     * set server telemetry entity to the platform cache
	     * @param serverTelemetryKey
	     * @param serverTelemetry
	     */
	    BrowserCacheManager.prototype.setServerTelemetry = function (serverTelemetryKey, serverTelemetry) {
	        this.logger.verbose("BrowserCacheManager.setServerTelemetry called");
	        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry));
	    };
	    /**
	     *
	     */
	    BrowserCacheManager.prototype.getAuthorityMetadata = function (key) {
	        this.logger.verbose("BrowserCacheManager.getAuthorityMetadata called");
	        var value = this.internalStorage.getItem(key);
	        if (!value) {
	            return null;
	        }
	        var parsedMetadata = this.validateAndParseJson(value);
	        if (parsedMetadata && AuthorityMetadataEntity.isAuthorityMetadataEntity(key, parsedMetadata)) {
	            this.logger.verbose("BrowserCacheManager.getAuthorityMetadata: cache hit");
	            return CacheManager.toObject(new AuthorityMetadataEntity(), parsedMetadata);
	        }
	        return null;
	    };
	    /**
	     *
	     */
	    BrowserCacheManager.prototype.getAuthorityMetadataKeys = function () {
	        var _this = this;
	        var allKeys = this.internalStorage.getKeys();
	        return allKeys.filter(function (key) {
	            return _this.isAuthorityMetadata(key);
	        });
	    };
	    /**
	     *
	     * @param entity
	     */
	    BrowserCacheManager.prototype.setAuthorityMetadata = function (key, entity) {
	        this.logger.verbose("BrowserCacheManager.setAuthorityMetadata called");
	        this.internalStorage.setItem(key, JSON.stringify(entity));
	    };
	    /**
	     * fetch throttling entity from the platform cache
	     * @param throttlingCacheKey
	     */
	    BrowserCacheManager.prototype.getThrottlingCache = function (throttlingCacheKey) {
	        this.logger.verbose("BrowserCacheManager.getThrottlingCache called");
	        var value = this.getItem(throttlingCacheKey);
	        if (!value) {
	            return null;
	        }
	        var parsedThrottlingCache = this.validateAndParseJson(value);
	        if (!parsedThrottlingCache) {
	            return null;
	        }
	        var throttlingCache = CacheManager.toObject(new ThrottlingEntity(), parsedThrottlingCache);
	        if (ThrottlingEntity.isThrottlingEntity(throttlingCacheKey, throttlingCache)) {
	            this.logger.verbose("BrowserCacheManager.getThrottlingCache: cache hit");
	            return throttlingCache;
	        }
	        return null;
	    };
	    /**
	     * set throttling entity to the platform cache
	     * @param throttlingCacheKey
	     * @param throttlingCache
	     */
	    BrowserCacheManager.prototype.setThrottlingCache = function (throttlingCacheKey, throttlingCache) {
	        this.logger.verbose("BrowserCacheManager.setThrottlingCache called");
	        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache));
	    };
	    /**
	     * Gets cache item with given key.
	     * Will retrieve frm cookies if storeAuthStateInCookie is set to true.
	     * @param key
	     */
	    BrowserCacheManager.prototype.getTemporaryCache = function (cacheKey, generateKey) {
	        this.logger.verbose("BrowserCacheManager.getTemporaryCache called");
	        var key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
	        if (this.cacheConfig.storeAuthStateInCookie) {
	            this.logger.verbose("BrowserCacheManager.getTemporaryCache: storeAuthStateInCookies set to true, retrieving from cookies");
	            var itemCookie = this.getItemCookie(key);
	            if (itemCookie) {
	                return itemCookie;
	            }
	        }
	        var value = this.temporaryCacheStorage.getItem(key);
	        if (!value) {
	            return null;
	        }
	        return value;
	    };
	    /**
	     * Sets the cache item with the key and value given.
	     * Stores in cookie if storeAuthStateInCookie is set to true.
	     * This can cause cookie overflow if used incorrectly.
	     * @param key
	     * @param value
	     */
	    BrowserCacheManager.prototype.setTemporaryCache = function (cacheKey, value, generateKey) {
	        var key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
	        this.temporaryCacheStorage.setItem(key, value);
	        if (this.cacheConfig.storeAuthStateInCookie) {
	            this.logger.verbose("BrowserCacheManager.setTemporaryCache: storeAuthStateInCookie set to true, setting item cookie");
	            this.setItemCookie(key, value);
	        }
	    };
	    /**
	     * Removes the cache item with the given key.
	     * Will also clear the cookie item if storeAuthStateInCookie is set to true.
	     * @param key
	     */
	    BrowserCacheManager.prototype.removeItem = function (key) {
	        this.browserStorage.removeItem(key);
	        this.temporaryCacheStorage.removeItem(key);
	        if (this.cacheConfig.storeAuthStateInCookie) {
	            this.logger.verbose("BrowserCacheManager.removeItem: storeAuthStateInCookie is true, clearing item cookie");
	            this.clearItemCookie(key);
	        }
	        return true;
	    };
	    /**
	     * Checks whether key is in cache.
	     * @param key
	     */
	    BrowserCacheManager.prototype.containsKey = function (key) {
	        return this.browserStorage.containsKey(key) || this.temporaryCacheStorage.containsKey(key);
	    };
	    /**
	     * Gets all keys in window.
	     */
	    BrowserCacheManager.prototype.getKeys = function () {
	        return __spread(this.browserStorage.getKeys(), this.temporaryCacheStorage.getKeys());
	    };
	    /**
	     * Clears all cache entries created by MSAL (except tokens).
	     */
	    BrowserCacheManager.prototype.clear = function () {
	        var _this = this;
	        this.removeAllAccounts();
	        this.removeAppMetadata();
	        this.getKeys().forEach(function (cacheKey) {
	            // Check if key contains msal prefix; For now, we are clearing all the cache items created by MSAL.js
	            if ((_this.browserStorage.containsKey(cacheKey) || _this.temporaryCacheStorage.containsKey(cacheKey)) && ((cacheKey.indexOf(Constants.CACHE_PREFIX) !== -1) || (cacheKey.indexOf(_this.clientId) !== -1))) {
	                _this.removeItem(cacheKey);
	            }
	        });
	        this.internalStorage.clear();
	    };
	    /**
	     * Add value to cookies
	     * @param cookieName
	     * @param cookieValue
	     * @param expires
	     */
	    BrowserCacheManager.prototype.setItemCookie = function (cookieName, cookieValue, expires) {
	        var cookieStr = encodeURIComponent(cookieName) + "=" + encodeURIComponent(cookieValue) + ";path=/;";
	        if (expires) {
	            var expireTime = this.getCookieExpirationTime(expires);
	            cookieStr += "expires=" + expireTime + ";";
	        }
	        if (this.cacheConfig.secureCookies) {
	            cookieStr += "Secure;";
	        }
	        document.cookie = cookieStr;
	    };
	    /**
	     * Get one item by key from cookies
	     * @param cookieName
	     */
	    BrowserCacheManager.prototype.getItemCookie = function (cookieName) {
	        var name = encodeURIComponent(cookieName) + "=";
	        var cookieList = document.cookie.split(";");
	        for (var i = 0; i < cookieList.length; i++) {
	            var cookie = cookieList[i];
	            while (cookie.charAt(0) === " ") {
	                cookie = cookie.substring(1);
	            }
	            if (cookie.indexOf(name) === 0) {
	                return decodeURIComponent(cookie.substring(name.length, cookie.length));
	            }
	        }
	        return "";
	    };
	    /**
	     * Clear all msal-related cookies currently set in the browser. Should only be used to clear temporary cache items.
	     */
	    BrowserCacheManager.prototype.clearMsalCookies = function () {
	        var _this = this;
	        var cookiePrefix = Constants.CACHE_PREFIX + "." + this.clientId;
	        var cookieList = document.cookie.split(";");
	        cookieList.forEach(function (cookie) {
	            while (cookie.charAt(0) === " ") {
	                cookie = cookie.substring(1);
	            }
	            if (cookie.indexOf(cookiePrefix) === 0) {
	                var cookieKey = cookie.split("=")[0];
	                _this.clearItemCookie(cookieKey);
	            }
	        });
	    };
	    /**
	     * Clear an item in the cookies by key
	     * @param cookieName
	     */
	    BrowserCacheManager.prototype.clearItemCookie = function (cookieName) {
	        this.setItemCookie(cookieName, "", -1);
	    };
	    /**
	     * Get cookie expiration time
	     * @param cookieLifeDays
	     */
	    BrowserCacheManager.prototype.getCookieExpirationTime = function (cookieLifeDays) {
	        var today = new Date();
	        var expr = new Date(today.getTime() + cookieLifeDays * this.COOKIE_LIFE_MULTIPLIER);
	        return expr.toUTCString();
	    };
	    /**
	     * Gets the cache object referenced by the browser
	     */
	    BrowserCacheManager.prototype.getCache = function () {
	        return this.browserStorage;
	    };
	    /**
	     * interface compat, we cannot overwrite browser cache; Functionality is supported by individual entities in browser
	     */
	    BrowserCacheManager.prototype.setCache = function () {
	        // sets nothing
	    };
	    /**
	     * Prepend msal.<client-id> to each key; Skip for any JSON object as Key (defined schemas do not need the key appended: AccessToken Keys or the upcoming schema)
	     * @param key
	     * @param addInstanceId
	     */
	    BrowserCacheManager.prototype.generateCacheKey = function (key) {
	        var generatedKey = this.validateAndParseJson(key);
	        if (!generatedKey) {
	            if (StringUtils.startsWith(key, Constants.CACHE_PREFIX) || StringUtils.startsWith(key, PersistentCacheKeys.ADAL_ID_TOKEN)) {
	                return key;
	            }
	            return Constants.CACHE_PREFIX + "." + this.clientId + "." + key;
	        }
	        return JSON.stringify(key);
	    };
	    /**
	     * Create authorityKey to cache authority
	     * @param state
	     */
	    BrowserCacheManager.prototype.generateAuthorityKey = function (stateString) {
	        var stateId = ProtocolUtils.parseRequestState(this.cryptoImpl, stateString).libraryState.id;
	        return this.generateCacheKey(TemporaryCacheKeys.AUTHORITY + "." + stateId);
	    };
	    /**
	     * Create Nonce key to cache nonce
	     * @param state
	     */
	    BrowserCacheManager.prototype.generateNonceKey = function (stateString) {
	        var stateId = ProtocolUtils.parseRequestState(this.cryptoImpl, stateString).libraryState.id;
	        return this.generateCacheKey(TemporaryCacheKeys.NONCE_IDTOKEN + "." + stateId);
	    };
	    /**
	     * Creates full cache key for the request state
	     * @param stateString State string for the request
	     */
	    BrowserCacheManager.prototype.generateStateKey = function (stateString) {
	        // Use the library state id to key temp storage for uniqueness for multiple concurrent requests
	        var stateId = ProtocolUtils.parseRequestState(this.cryptoImpl, stateString).libraryState.id;
	        return this.generateCacheKey(TemporaryCacheKeys.REQUEST_STATE + "." + stateId);
	    };
	    /**
	     * Gets the cached authority based on the cached state. Returns empty if no cached state found.
	     */
	    BrowserCacheManager.prototype.getCachedAuthority = function (cachedState) {
	        var stateCacheKey = this.generateStateKey(cachedState);
	        var state = this.getTemporaryCache(stateCacheKey);
	        if (!state) {
	            return null;
	        }
	        var authorityCacheKey = this.generateAuthorityKey(state);
	        return this.getTemporaryCache(authorityCacheKey);
	    };
	    /**
	     * Updates account, authority, and state in cache
	     * @param serverAuthenticationRequest
	     * @param account
	     */
	    BrowserCacheManager.prototype.updateCacheEntries = function (state, nonce, authorityInstance) {
	        this.logger.verbose("BrowserCacheManager.updateCacheEntries called");
	        // Cache the request state
	        var stateCacheKey = this.generateStateKey(state);
	        this.setTemporaryCache(stateCacheKey, state, false);
	        // Cache the nonce
	        var nonceCacheKey = this.generateNonceKey(state);
	        this.setTemporaryCache(nonceCacheKey, nonce, false);
	        // Cache authorityKey
	        var authorityCacheKey = this.generateAuthorityKey(state);
	        this.setTemporaryCache(authorityCacheKey, authorityInstance, false);
	    };
	    /**
	     * Reset all temporary cache items
	     * @param state
	     */
	    BrowserCacheManager.prototype.resetRequestCache = function (state) {
	        var _this = this;
	        this.logger.verbose("BrowserCacheManager.resetRequestCache called");
	        // check state and remove associated cache items
	        if (!StringUtils.isEmpty(state)) {
	            this.getKeys().forEach(function (key) {
	                if (key.indexOf(state) !== -1) {
	                    _this.removeItem(key);
	                }
	            });
	        }
	        // delete generic interactive request parameters
	        if (state) {
	            this.removeItem(this.generateStateKey(state));
	            this.removeItem(this.generateNonceKey(state));
	            this.removeItem(this.generateAuthorityKey(state));
	        }
	        this.removeItem(this.generateCacheKey(TemporaryCacheKeys.REQUEST_PARAMS));
	        this.removeItem(this.generateCacheKey(TemporaryCacheKeys.ORIGIN_URI));
	        this.removeItem(this.generateCacheKey(TemporaryCacheKeys.URL_HASH));
	        this.removeItem(this.generateCacheKey(TemporaryCacheKeys.INTERACTION_STATUS_KEY));
	    };
	    /**
	     * Removes temporary cache for the provided state
	     * @param stateString
	     */
	    BrowserCacheManager.prototype.cleanRequestByState = function (stateString) {
	        this.logger.verbose("BrowserCacheManager.cleanRequestByState called");
	        // Interaction is completed - remove interaction status.
	        if (stateString) {
	            var stateKey = this.generateStateKey(stateString);
	            var cachedState = this.temporaryCacheStorage.getItem(stateKey);
	            this.logger.info("BrowserCacheManager.cleanRequestByState: Removing temporary cache items for state: " + cachedState);
	            this.resetRequestCache(cachedState || "");
	        }
	        this.clearMsalCookies();
	    };
	    /**
	     * Looks in temporary cache for any state values with the provided interactionType and removes all temporary cache items for that state
	     * Used in scenarios where temp cache needs to be cleaned but state is not known, such as clicking browser back button.
	     * @param interactionType
	     */
	    BrowserCacheManager.prototype.cleanRequestByInteractionType = function (interactionType) {
	        var _this = this;
	        this.logger.verbose("BrowserCacheManager.cleanRequestByInteractionType called");
	        // Loop through all keys to find state key
	        this.getKeys().forEach(function (key) {
	            // If this key is not the state key, move on
	            if (key.indexOf(TemporaryCacheKeys.REQUEST_STATE) === -1) {
	                return;
	            }
	            // Retrieve state value, return if not a valid value
	            var stateValue = _this.temporaryCacheStorage.getItem(key);
	            if (!stateValue) {
	                return;
	            }
	            // Extract state and ensure it matches given InteractionType, then clean request cache
	            var parsedState = BrowserProtocolUtils.extractBrowserRequestState(_this.cryptoImpl, stateValue);
	            if (parsedState && parsedState.interactionType === interactionType) {
	                _this.logger.info("BrowserCacheManager.cleanRequestByInteractionType: Removing temporary cache items for state: " + stateValue);
	                _this.resetRequestCache(stateValue);
	            }
	        });
	        this.clearMsalCookies();
	    };
	    BrowserCacheManager.prototype.cacheCodeRequest = function (authCodeRequest, browserCrypto) {
	        this.logger.verbose("BrowserCacheManager.cacheCodeRequest called");
	        var encodedValue = browserCrypto.base64Encode(JSON.stringify(authCodeRequest));
	        this.setTemporaryCache(TemporaryCacheKeys.REQUEST_PARAMS, encodedValue, true);
	    };
	    /**
	     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
	     */
	    BrowserCacheManager.prototype.getCachedRequest = function (state, browserCrypto) {
	        this.logger.verbose("BrowserCacheManager.getCachedRequest called");
	        // Get token request from cache and parse as TokenExchangeParameters.
	        var encodedTokenRequest = this.getTemporaryCache(TemporaryCacheKeys.REQUEST_PARAMS, true);
	        if (!encodedTokenRequest) {
	            throw BrowserAuthError.createNoTokenRequestCacheError();
	        }
	        var parsedRequest = this.validateAndParseJson(browserCrypto.base64Decode(encodedTokenRequest));
	        if (!parsedRequest) {
	            throw BrowserAuthError.createUnableToParseTokenRequestCacheError();
	        }
	        this.removeItem(this.generateCacheKey(TemporaryCacheKeys.REQUEST_PARAMS));
	        // Get cached authority and use if no authority is cached with request.
	        if (StringUtils.isEmpty(parsedRequest.authority)) {
	            var authorityCacheKey = this.generateAuthorityKey(state);
	            var cachedAuthority = this.getTemporaryCache(authorityCacheKey);
	            if (!cachedAuthority) {
	                throw BrowserAuthError.createNoCachedAuthorityError();
	            }
	            parsedRequest.authority = cachedAuthority;
	        }
	        return parsedRequest;
	    };
	    return BrowserCacheManager;
	}(CacheManager));
	var DEFAULT_BROWSER_CACHE_MANAGER = function (clientId, logger) {
	    var cacheOptions = {
	        cacheLocation: exports.BrowserCacheLocation.MemoryStorage,
	        storeAuthStateInCookie: false,
	        secureCookies: false
	    };
	    return new BrowserCacheManager(clientId, cacheOptions, DEFAULT_CRYPTO_IMPLEMENTATION, logger);
	};
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
	 */
	var FetchClient = /** @class */ (function () {
	    function FetchClient() {
	    }
	    /**
	     * Fetch Client for REST endpoints - Get request
	     * @param url
	     * @param headers
	     * @param body
	     */
	    FetchClient.prototype.sendGetRequestAsync = function (url, options) {
	        return __awaiter(this, void 0, void 0, function () {
	            var response, e_1, _a, e_2;
	            return __generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        _b.trys.push([0, 2, , 3]);
	                        return [4 /*yield*/, fetch(url, {
	                                method: HTTP_REQUEST_TYPE.GET,
	                                headers: this.getFetchHeaders(options)
	                            })];
	                    case 1:
	                        response = _b.sent();
	                        return [3 /*break*/, 3];
	                    case 2:
	                        e_1 = _b.sent();
	                        if (window.navigator.onLine) {
	                            throw BrowserAuthError.createGetRequestFailedError(e_1, url);
	                        }
	                        else {
	                            throw BrowserAuthError.createNoNetworkConnectivityError();
	                        }
	                    case 3:
	                        _b.trys.push([3, 5, , 6]);
	                        _a = {
	                            headers: this.getHeaderDict(response.headers)
	                        };
	                        return [4 /*yield*/, response.json()];
	                    case 4: return [2 /*return*/, (_a.body = (_b.sent()),
	                            _a.status = response.status,
	                            _a)];
	                    case 5:
	                        e_2 = _b.sent();
	                        throw BrowserAuthError.createFailedToParseNetworkResponseError(url);
	                    case 6: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Fetch Client for REST endpoints - Post request
	     * @param url
	     * @param headers
	     * @param body
	     */
	    FetchClient.prototype.sendPostRequestAsync = function (url, options) {
	        return __awaiter(this, void 0, void 0, function () {
	            var reqBody, response, e_3, _a, e_4;
	            return __generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        reqBody = (options && options.body) || "";
	                        _b.label = 1;
	                    case 1:
	                        _b.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, fetch(url, {
	                                method: HTTP_REQUEST_TYPE.POST,
	                                headers: this.getFetchHeaders(options),
	                                body: reqBody
	                            })];
	                    case 2:
	                        response = _b.sent();
	                        return [3 /*break*/, 4];
	                    case 3:
	                        e_3 = _b.sent();
	                        if (window.navigator.onLine) {
	                            throw BrowserAuthError.createPostRequestFailedError(e_3, url);
	                        }
	                        else {
	                            throw BrowserAuthError.createNoNetworkConnectivityError();
	                        }
	                    case 4:
	                        _b.trys.push([4, 6, , 7]);
	                        _a = {
	                            headers: this.getHeaderDict(response.headers)
	                        };
	                        return [4 /*yield*/, response.json()];
	                    case 5: return [2 /*return*/, (_a.body = (_b.sent()),
	                            _a.status = response.status,
	                            _a)];
	                    case 6:
	                        e_4 = _b.sent();
	                        throw BrowserAuthError.createFailedToParseNetworkResponseError(url);
	                    case 7: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Get Fetch API Headers object from string map
	     * @param inputHeaders
	     */
	    FetchClient.prototype.getFetchHeaders = function (options) {
	        var headers = new Headers();
	        if (!(options && options.headers)) {
	            return headers;
	        }
	        var optionsHeaders = options.headers;
	        Object.keys(optionsHeaders).forEach(function (key) {
	            headers.append(key, optionsHeaders[key]);
	        });
	        return headers;
	    };
	    FetchClient.prototype.getHeaderDict = function (headers) {
	        var headerDict = {};
	        headers.forEach(function (value, key) {
	            headerDict[key] = value;
	        });
	        return headerDict;
	    };
	    return FetchClient;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * This client implements the XMLHttpRequest class to send GET and POST requests.
	 */
	var XhrClient = /** @class */ (function () {
	    function XhrClient() {
	    }
	    /**
	     * XhrClient for REST endpoints - Get request
	     * @param url
	     * @param headers
	     * @param body
	     */
	    XhrClient.prototype.sendGetRequestAsync = function (url, options) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, this.sendRequestAsync(url, HTTP_REQUEST_TYPE.GET, options)];
	            });
	        });
	    };
	    /**
	     * XhrClient for REST endpoints - Post request
	     * @param url
	     * @param headers
	     * @param body
	     */
	    XhrClient.prototype.sendPostRequestAsync = function (url, options) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                return [2 /*return*/, this.sendRequestAsync(url, HTTP_REQUEST_TYPE.POST, options)];
	            });
	        });
	    };
	    /**
	     * Helper for XhrClient requests.
	     * @param url
	     * @param method
	     * @param options
	     */
	    XhrClient.prototype.sendRequestAsync = function (url, method, options) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            var xhr = new XMLHttpRequest();
	            xhr.open(method, url, /* async: */ true);
	            _this.setXhrHeaders(xhr, options);
	            xhr.onload = function () {
	                if (xhr.status < 200 || xhr.status >= 300) {
	                    if (method === HTTP_REQUEST_TYPE.POST) {
	                        reject(BrowserAuthError.createPostRequestFailedError("Failed with status " + xhr.status, url));
	                    }
	                    else {
	                        reject(BrowserAuthError.createGetRequestFailedError("Failed with status " + xhr.status, url));
	                    }
	                }
	                try {
	                    var jsonResponse = JSON.parse(xhr.responseText);
	                    var networkResponse = {
	                        headers: _this.getHeaderDict(xhr),
	                        body: jsonResponse,
	                        status: xhr.status
	                    };
	                    resolve(networkResponse);
	                }
	                catch (e) {
	                    reject(BrowserAuthError.createFailedToParseNetworkResponseError(url));
	                }
	            };
	            xhr.onerror = function () {
	                if (window.navigator.onLine) {
	                    if (method === HTTP_REQUEST_TYPE.POST) {
	                        reject(BrowserAuthError.createPostRequestFailedError("Failed with status " + xhr.status, url));
	                    }
	                    else {
	                        reject(BrowserAuthError.createGetRequestFailedError("Failed with status " + xhr.status, url));
	                    }
	                }
	                else {
	                    reject(BrowserAuthError.createNoNetworkConnectivityError());
	                }
	            };
	            if (method === HTTP_REQUEST_TYPE.POST && options && options.body) {
	                xhr.send(options.body);
	            }
	            else if (method === HTTP_REQUEST_TYPE.GET) {
	                xhr.send();
	            }
	            else {
	                throw BrowserAuthError.createHttpMethodNotImplementedError(method);
	            }
	        });
	    };
	    /**
	     * Helper to set XHR headers for request.
	     * @param xhr
	     * @param options
	     */
	    XhrClient.prototype.setXhrHeaders = function (xhr, options) {
	        if (options && options.headers) {
	            var headers_1 = options.headers;
	            Object.keys(headers_1).forEach(function (key) {
	                xhr.setRequestHeader(key, headers_1[key]);
	            });
	        }
	    };
	    /**
	     * Gets a string map of the headers received in the response.
	     *
	     * Algorithm comes from https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/getAllResponseHeaders
	     * @param xhr
	     */
	    XhrClient.prototype.getHeaderDict = function (xhr) {
	        var headerString = xhr.getAllResponseHeaders();
	        var headerArr = headerString.trim().split(/[\r\n]+/);
	        var headerDict = {};
	        headerArr.forEach(function (value) {
	            var parts = value.split(": ");
	            var headerName = parts.shift();
	            var headerVal = parts.join(": ");
	            if (headerName && headerVal) {
	                headerDict[headerName] = headerVal;
	            }
	        });
	        return headerDict;
	    };
	    return XhrClient;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Utility class for browser specific functions
	 */
	var BrowserUtils = /** @class */ (function () {
	    function BrowserUtils() {
	    }
	    // #region Window Navigation and URL management
	    /**
	     * Clears hash from window url.
	     */
	    BrowserUtils.clearHash = function () {
	        // Office.js sets history.replaceState to null
	        if (typeof history.replaceState === "function") {
	            // Full removes "#" from url
	            history.replaceState(null, Constants.EMPTY_STRING, "" + window.location.pathname + window.location.search);
	        }
	        else {
	            window.location.hash = "";
	        }
	    };
	    /**
	     * Replaces current hash with hash from provided url
	     */
	    BrowserUtils.replaceHash = function (url) {
	        var urlParts = url.split("#");
	        urlParts.shift(); // Remove part before the hash
	        window.location.hash = urlParts.length > 0 ? urlParts.join("#") : "";
	    };
	    /**
	     * Returns boolean of whether the current window is in an iframe or not.
	     */
	    BrowserUtils.isInIframe = function () {
	        return window.parent !== window;
	    };
	    // #endregion
	    /**
	     * Returns current window URL as redirect uri
	     */
	    BrowserUtils.getCurrentUri = function () {
	        return window.location.href.split("?")[0].split("#")[0];
	    };
	    /**
	     * Gets the homepage url for the current window location.
	     */
	    BrowserUtils.getHomepage = function () {
	        var currentUrl = new UrlString(window.location.href);
	        var urlComponents = currentUrl.getUrlComponents();
	        return urlComponents.Protocol + "//" + urlComponents.HostNameAndPort + "/";
	    };
	    /**
	     * Returns best compatible network client object.
	     */
	    BrowserUtils.getBrowserNetworkClient = function () {
	        if (window.fetch && window.Headers) {
	            return new FetchClient();
	        }
	        else {
	            return new XhrClient();
	        }
	    };
	    /**
	     * Throws error if we have completed an auth and are
	     * attempting another auth request inside an iframe.
	     */
	    BrowserUtils.blockReloadInHiddenIframes = function () {
	        var isResponseHash = UrlString.hashContainsKnownProperties(window.location.hash);
	        // return an error if called from the hidden iframe created by the msal js silent calls
	        if (isResponseHash && BrowserUtils.isInIframe()) {
	            throw BrowserAuthError.createBlockReloadInHiddenIframeError();
	        }
	    };
	    /**
	     * Block redirect operations in iframes unless explicitly allowed
	     * @param interactionType Interaction type for the request
	     * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
	     */
	    BrowserUtils.blockRedirectInIframe = function (interactionType, allowRedirectInIframe) {
	        var isIframedApp = BrowserUtils.isInIframe();
	        if (interactionType === exports.InteractionType.Redirect && isIframedApp && !allowRedirectInIframe) {
	            // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
	            throw BrowserAuthError.createRedirectInIframeError(isIframedApp);
	        }
	    };
	    /**
	     * Throws error if token requests are made in non-browser environment
	     * @param isBrowserEnvironment Flag indicating if environment is a browser.
	     */
	    BrowserUtils.blockNonBrowserEnvironment = function (isBrowserEnvironment) {
	        if (!isBrowserEnvironment) {
	            throw BrowserAuthError.createNonBrowserEnvironmentError();
	        }
	    };
	    /**
	     * Returns boolean of whether current browser is an Internet Explorer or Edge browser.
	     */
	    BrowserUtils.detectIEOrEdge = function () {
	        var ua = window.navigator.userAgent;
	        var msie = ua.indexOf("MSIE ");
	        var msie11 = ua.indexOf("Trident/");
	        var msedge = ua.indexOf("Edge/");
	        var isIE = msie > 0 || msie11 > 0;
	        var isEdge = msedge > 0;
	        return isIE || isEdge;
	    };
	    return BrowserUtils;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var NavigationClient = /** @class */ (function () {
	    function NavigationClient() {
	    }
	    /**
	     * Navigates to other pages within the same web application
	     * @param url
	     * @param options
	     */
	    NavigationClient.prototype.navigateInternal = function (url, options) {
	        return NavigationClient.defaultNavigateWindow(url, options);
	    };
	    /**
	     * Navigates to other pages outside the web application i.e. the Identity Provider
	     * @param url
	     * @param options
	     */
	    NavigationClient.prototype.navigateExternal = function (url, options) {
	        return NavigationClient.defaultNavigateWindow(url, options);
	    };
	    /**
	     * Default navigation implementation invoked by the internal and external functions
	     * @param url
	     * @param options
	     */
	    NavigationClient.defaultNavigateWindow = function (url, options) {
	        if (options.noHistory) {
	            window.location.replace(url);
	        }
	        else {
	            window.location.assign(url);
	        }
	        return new Promise(function (resolve) {
	            setTimeout(function () {
	                resolve(true);
	            }, options.timeout);
	        });
	    };
	    return NavigationClient;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	// Default timeout for popup windows and iframes in milliseconds
	var DEFAULT_POPUP_TIMEOUT_MS = 60000;
	var DEFAULT_IFRAME_TIMEOUT_MS = 6000;
	var DEFAULT_REDIRECT_TIMEOUT_MS = 30000;
	/**
	 * MSAL function that sets the default options when not explicitly configured from app developer
	 *
	 * @param auth
	 * @param cache
	 * @param system
	 *
	 * @returns Configuration object
	 */
	function buildConfiguration(_a, isBrowserEnvironment) {
	    var userInputAuth = _a.auth, userInputCache = _a.cache, userInputSystem = _a.system;
	    // Default auth options for browser
	    var DEFAULT_AUTH_OPTIONS = {
	        clientId: "",
	        authority: "" + Constants.DEFAULT_AUTHORITY,
	        knownAuthorities: [],
	        cloudDiscoveryMetadata: "",
	        authorityMetadata: "",
	        redirectUri: "",
	        postLogoutRedirectUri: "",
	        navigateToLoginRequestUrl: true,
	        clientCapabilities: [],
	        protocolMode: exports.ProtocolMode.AAD
	    };
	    // Default cache options for browser
	    var DEFAULT_CACHE_OPTIONS = {
	        cacheLocation: exports.BrowserCacheLocation.SessionStorage,
	        storeAuthStateInCookie: false,
	        secureCookies: false
	    };
	    // Default logger options for browser
	    var DEFAULT_LOGGER_OPTIONS = {
	        loggerCallback: function () { },
	        logLevel: exports.LogLevel.Info,
	        piiLoggingEnabled: false
	    };
	    // Default system options for browser
	    var DEFAULT_BROWSER_SYSTEM_OPTIONS = __assign(__assign({}, DEFAULT_SYSTEM_OPTIONS), { loggerOptions: DEFAULT_LOGGER_OPTIONS, networkClient: isBrowserEnvironment ? BrowserUtils.getBrowserNetworkClient() : StubbedNetworkModule, navigationClient: new NavigationClient(), loadFrameTimeout: 0, 
	        // If loadFrameTimeout is provided, use that as default.
	        windowHashTimeout: (userInputSystem && userInputSystem.loadFrameTimeout) || DEFAULT_POPUP_TIMEOUT_MS, iframeHashTimeout: (userInputSystem && userInputSystem.loadFrameTimeout) || DEFAULT_IFRAME_TIMEOUT_MS, navigateFrameWait: isBrowserEnvironment && BrowserUtils.detectIEOrEdge() ? 500 : 0, redirectNavigationTimeout: DEFAULT_REDIRECT_TIMEOUT_MS, asyncPopups: false, allowRedirectInIframe: false });
	    var overlayedConfig = {
	        auth: __assign(__assign({}, DEFAULT_AUTH_OPTIONS), userInputAuth),
	        cache: __assign(__assign({}, DEFAULT_CACHE_OPTIONS), userInputCache),
	        system: __assign(__assign({}, DEFAULT_BROWSER_SYSTEM_OPTIONS), userInputSystem)
	    };
	    return overlayedConfig;
	}
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * Abstract class which defines operations for a browser interaction handling class.
	 */
	var InteractionHandler = /** @class */ (function () {
	    function InteractionHandler(authCodeModule, storageImpl, authCodeRequest) {
	        this.authModule = authCodeModule;
	        this.browserStorage = storageImpl;
	        this.authCodeRequest = authCodeRequest;
	    }
	    /**
	     * Function to handle response parameters from hash.
	     * @param locationHash
	     */
	    InteractionHandler.prototype.handleCodeResponse = function (locationHash, state, authority, networkModule) {
	        return __awaiter(this, void 0, void 0, function () {
	            var stateKey, requestState, authCodeResponse, nonceKey, cachedNonce, tokenResponse;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        // Check that location hash isn't empty.
	                        if (StringUtils.isEmpty(locationHash)) {
	                            throw BrowserAuthError.createEmptyHashError(locationHash);
	                        }
	                        stateKey = this.browserStorage.generateStateKey(state);
	                        requestState = this.browserStorage.getTemporaryCache(stateKey);
	                        if (!requestState) {
	                            throw ClientAuthError.createStateNotFoundError("Cached State");
	                        }
	                        authCodeResponse = this.authModule.handleFragmentResponse(locationHash, requestState);
	                        nonceKey = this.browserStorage.generateNonceKey(requestState);
	                        cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
	                        // Assign code to request
	                        this.authCodeRequest.code = authCodeResponse.code;
	                        if (!authCodeResponse.cloud_instance_host_name) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.updateTokenEndpointAuthority(authCodeResponse.cloud_instance_host_name, authority, networkModule)];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2:
	                        authCodeResponse.nonce = cachedNonce || undefined;
	                        authCodeResponse.state = requestState;
	                        return [4 /*yield*/, this.authModule.acquireToken(this.authCodeRequest, authCodeResponse)];
	                    case 3:
	                        tokenResponse = _a.sent();
	                        this.browserStorage.cleanRequestByState(state);
	                        return [2 /*return*/, tokenResponse];
	                }
	            });
	        });
	    };
	    InteractionHandler.prototype.updateTokenEndpointAuthority = function (cloudInstanceHostname, authority, networkModule) {
	        return __awaiter(this, void 0, void 0, function () {
	            var cloudInstanceAuthorityUri, cloudInstanceAuthority;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        cloudInstanceAuthorityUri = "https://" + cloudInstanceHostname + "/" + authority.tenant + "/";
	                        return [4 /*yield*/, AuthorityFactory.createDiscoveredInstance(cloudInstanceAuthorityUri, networkModule, this.browserStorage, authority.options)];
	                    case 1:
	                        cloudInstanceAuthority = _a.sent();
	                        this.authModule.updateAuthority(cloudInstanceAuthority);
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    return InteractionHandler;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var RedirectHandler = /** @class */ (function (_super) {
	    __extends(RedirectHandler, _super);
	    function RedirectHandler(authCodeModule, storageImpl, authCodeRequest, browserCrypto) {
	        var _this = _super.call(this, authCodeModule, storageImpl, authCodeRequest) || this;
	        _this.browserCrypto = browserCrypto;
	        return _this;
	    }
	    /**
	     * Redirects window to given URL.
	     * @param urlNavigate
	     */
	    RedirectHandler.prototype.initiateAuthRequest = function (requestUrl, params) {
	        return __awaiter(this, void 0, void 0, function () {
	            var navigationOptions, navigate;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.authModule.logger.verbose("RedirectHandler.initiateAuthRequest called");
	                        if (!!StringUtils.isEmpty(requestUrl)) return [3 /*break*/, 7];
	                        // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
	                        if (params.redirectStartPage) {
	                            this.authModule.logger.verbose("RedirectHandler.initiateAuthRequest: redirectStartPage set to true, caching start page");
	                            this.browserStorage.setTemporaryCache(TemporaryCacheKeys.ORIGIN_URI, params.redirectStartPage, true);
	                        }
	                        // Set interaction status in the library.
	                        this.browserStorage.setTemporaryCache(TemporaryCacheKeys.INTERACTION_STATUS_KEY, BrowserConstants.INTERACTION_IN_PROGRESS_VALUE, true);
	                        this.browserStorage.cacheCodeRequest(this.authCodeRequest, this.browserCrypto);
	                        this.authModule.logger.infoPii("RedirectHandler.initiateAuthRequest: Navigate to:" + requestUrl);
	                        navigationOptions = {
	                            apiId: exports.ApiId.acquireTokenRedirect,
	                            timeout: params.redirectTimeout,
	                            noHistory: false
	                        };
	                        if (!(typeof params.onRedirectNavigate === "function")) return [3 /*break*/, 4];
	                        this.authModule.logger.verbose("RedirectHandler.initiateAuthRequest: Invoking onRedirectNavigate callback");
	                        navigate = params.onRedirectNavigate(requestUrl);
	                        if (!(navigate !== false)) return [3 /*break*/, 2];
	                        this.authModule.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate did not return false, navigating");
	                        return [4 /*yield*/, params.navigationClient.navigateExternal(requestUrl, navigationOptions)];
	                    case 1:
	                        _a.sent();
	                        return [2 /*return*/];
	                    case 2:
	                        this.authModule.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate returned false, stopping navigation");
	                        return [2 /*return*/];
	                    case 3: return [3 /*break*/, 6];
	                    case 4:
	                        // Navigate window to request URL
	                        this.authModule.logger.verbose("RedirectHandler.initiateAuthRequest: Navigating window to navigate url");
	                        return [4 /*yield*/, params.navigationClient.navigateExternal(requestUrl, navigationOptions)];
	                    case 5:
	                        _a.sent();
	                        return [2 /*return*/];
	                    case 6: return [3 /*break*/, 8];
	                    case 7:
	                        // Throw error if request URL is empty.
	                        this.authModule.logger.info("RedirectHandler.initiateAuthRequest: Navigate url is empty");
	                        throw BrowserAuthError.createEmptyNavigationUriError();
	                    case 8: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Handle authorization code response in the window.
	     * @param hash
	     */
	    RedirectHandler.prototype.handleCodeResponse = function (locationHash, state, authority, networkModule, clientId) {
	        return __awaiter(this, void 0, void 0, function () {
	            var stateKey, requestState, authCodeResponse, nonceKey, cachedNonce, tokenResponse;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.authModule.logger.verbose("RedirectHandler.handleCodeResponse called");
	                        // Check that location hash isn't empty.
	                        if (StringUtils.isEmpty(locationHash)) {
	                            throw BrowserAuthError.createEmptyHashError(locationHash);
	                        }
	                        // Interaction is completed - remove interaction status.
	                        this.browserStorage.removeItem(this.browserStorage.generateCacheKey(TemporaryCacheKeys.INTERACTION_STATUS_KEY));
	                        stateKey = this.browserStorage.generateStateKey(state);
	                        requestState = this.browserStorage.getTemporaryCache(stateKey);
	                        if (!requestState) {
	                            throw ClientAuthError.createStateNotFoundError("Cached State");
	                        }
	                        authCodeResponse = this.authModule.handleFragmentResponse(locationHash, requestState);
	                        nonceKey = this.browserStorage.generateNonceKey(requestState);
	                        cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
	                        // Assign code to request
	                        this.authCodeRequest.code = authCodeResponse.code;
	                        if (!authCodeResponse.cloud_instance_host_name) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.updateTokenEndpointAuthority(authCodeResponse.cloud_instance_host_name, authority, networkModule)];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2:
	                        authCodeResponse.nonce = cachedNonce || undefined;
	                        authCodeResponse.state = requestState;
	                        // Remove throttle if it exists
	                        if (clientId) {
	                            ThrottlingUtils.removeThrottle(this.browserStorage, clientId, this.authCodeRequest.authority, this.authCodeRequest.scopes);
	                        }
	                        return [4 /*yield*/, this.authModule.acquireToken(this.authCodeRequest, authCodeResponse)];
	                    case 3:
	                        tokenResponse = _a.sent();
	                        this.browserStorage.cleanRequestByState(state);
	                        return [2 /*return*/, tokenResponse];
	                }
	            });
	        });
	    };
	    return RedirectHandler;
	}(InteractionHandler));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * This class implements the interaction handler base class for browsers. It is written specifically for handling
	 * popup window scenarios. It includes functions for monitoring the popup window for a hash.
	 */
	var PopupHandler = /** @class */ (function (_super) {
	    __extends(PopupHandler, _super);
	    function PopupHandler(authCodeModule, storageImpl, authCodeRequest) {
	        var _this = _super.call(this, authCodeModule, storageImpl, authCodeRequest) || this;
	        // Properly sets this reference for the unload event.
	        _this.unloadWindow = _this.unloadWindow.bind(_this);
	        return _this;
	    }
	    /**
	     * Opens a popup window with given request Url.
	     * @param requestUrl
	     */
	    PopupHandler.prototype.initiateAuthRequest = function (requestUrl, params) {
	        // Check that request url is not empty.
	        if (!StringUtils.isEmpty(requestUrl)) {
	            // Set interaction status in the library.
	            this.browserStorage.setTemporaryCache(TemporaryCacheKeys.INTERACTION_STATUS_KEY, BrowserConstants.INTERACTION_IN_PROGRESS_VALUE, true);
	            this.authModule.logger.infoPii("Navigate to:" + requestUrl);
	            // Open the popup window to requestUrl.
	            return this.openPopup(requestUrl, params.popupName, params.popup);
	        }
	        else {
	            // Throw error if request URL is empty.
	            this.authModule.logger.error("Navigate url is empty");
	            throw BrowserAuthError.createEmptyNavigationUriError();
	        }
	    };
	    /**
	     * Monitors a window until it loads a url with a known hash, or hits a specified timeout.
	     * @param popupWindow - window that is being monitored
	     * @param timeout - milliseconds until timeout
	     * @param urlNavigate - url that was navigated to
	     */
	    PopupHandler.prototype.monitorPopupForHash = function (popupWindow, timeout) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (timeout < DEFAULT_POPUP_TIMEOUT_MS) {
	                _this.authModule.logger.warning("system.loadFrameTimeout or system.windowHashTimeout set to lower (" + timeout + "ms) than the default (" + DEFAULT_POPUP_TIMEOUT_MS + "ms). This may result in timeouts.");
	            }
	            var maxTicks = timeout / BrowserConstants.POLL_INTERVAL_MS;
	            var ticks = 0;
	            var intervalId = setInterval(function () {
	                if (popupWindow.closed) {
	                    // Window is closed
	                    _this.cleanPopup();
	                    clearInterval(intervalId);
	                    reject(BrowserAuthError.createUserCancelledError());
	                    return;
	                }
	                var href = Constants.EMPTY_STRING;
	                try {
	                    /*
	                     * Will throw if cross origin,
	                     * which should be caught and ignored
	                     * since we need the interval to keep running while on STS UI.
	                     */
	                    href = popupWindow.location.href;
	                }
	                catch (e) { }
	                // Don't process blank pages or cross domain
	                if (StringUtils.isEmpty(href) || href === "about:blank") {
	                    return;
	                }
	                // Only run clock when we are on same domain
	                ticks++;
	                var contentHash = popupWindow.location.hash;
	                if (UrlString.hashContainsKnownProperties(contentHash)) {
	                    // Success case
	                    _this.cleanPopup(popupWindow);
	                    clearInterval(intervalId);
	                    resolve(contentHash);
	                    return;
	                }
	                else if (ticks > maxTicks) {
	                    // Timeout error
	                    _this.cleanPopup(popupWindow);
	                    clearInterval(intervalId);
	                    reject(BrowserAuthError.createMonitorPopupTimeoutError());
	                    return;
	                }
	            }, BrowserConstants.POLL_INTERVAL_MS);
	        });
	    };
	    /**
	     * @hidden
	     *
	     * Configures popup window for login.
	     *
	     * @param urlNavigate
	     * @param title
	     * @param popUpWidth
	     * @param popUpHeight
	     * @ignore
	     * @hidden
	     */
	    PopupHandler.prototype.openPopup = function (urlNavigate, popupName, popup) {
	        try {
	            var popupWindow = void 0;
	            // Popup window passed in, setting url to navigate to
	            if (popup) {
	                popupWindow = popup;
	                popupWindow.location.assign(urlNavigate);
	            }
	            else if (typeof popup === "undefined") {
	                // Popup will be undefined if it was not passed in
	                popupWindow = PopupHandler.openSizedPopup(urlNavigate, popupName);
	            }
	            // Popup will be null if popups are blocked
	            if (!popupWindow) {
	                throw BrowserAuthError.createEmptyWindowCreatedError();
	            }
	            if (popupWindow.focus) {
	                popupWindow.focus();
	            }
	            this.currentWindow = popupWindow;
	            window.addEventListener("beforeunload", this.unloadWindow);
	            return popupWindow;
	        }
	        catch (e) {
	            this.authModule.logger.error("error opening popup " + e.message);
	            this.browserStorage.removeItem(this.browserStorage.generateCacheKey(TemporaryCacheKeys.INTERACTION_STATUS_KEY));
	            throw BrowserAuthError.createPopupWindowError(e.toString());
	        }
	    };
	    PopupHandler.openSizedPopup = function (urlNavigate, popupName) {
	        /**
	         * adding winLeft and winTop to account for dual monitor
	         * using screenLeft and screenTop for IE8 and earlier
	         */
	        var winLeft = window.screenLeft ? window.screenLeft : window.screenX;
	        var winTop = window.screenTop ? window.screenTop : window.screenY;
	        /**
	         * window.innerWidth displays browser window"s height and width excluding toolbars
	         * using document.documentElement.clientWidth for IE8 and earlier
	         */
	        var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	        var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	        var left = Math.max(0, ((width / 2) - (BrowserConstants.POPUP_WIDTH / 2)) + winLeft);
	        var top = Math.max(0, ((height / 2) - (BrowserConstants.POPUP_HEIGHT / 2)) + winTop);
	        return window.open(urlNavigate, popupName, "width=" + BrowserConstants.POPUP_WIDTH + ", height=" + BrowserConstants.POPUP_HEIGHT + ", top=" + top + ", left=" + left + ", scrollbars=yes");
	    };
	    /**
	     * Event callback to unload main window.
	     */
	    PopupHandler.prototype.unloadWindow = function (e) {
	        this.browserStorage.cleanRequestByInteractionType(exports.InteractionType.Popup);
	        if (this.currentWindow) {
	            this.currentWindow.close();
	        }
	        // Guarantees browser unload will happen, so no other errors will be thrown.
	        e.preventDefault();
	    };
	    /**
	     * Closes popup, removes any state vars created during popup calls.
	     * @param popupWindow
	     */
	    PopupHandler.prototype.cleanPopup = function (popupWindow) {
	        if (popupWindow) {
	            // Close window.
	            popupWindow.close();
	        }
	        // Remove window unload function
	        window.removeEventListener("beforeunload", this.unloadWindow);
	        // Interaction is completed - remove interaction status.
	        this.browserStorage.removeItem(this.browserStorage.generateCacheKey(TemporaryCacheKeys.INTERACTION_STATUS_KEY));
	    };
	    /**
	     * Generates the name for the popup based on the client id and request
	     * @param clientId
	     * @param request
	     */
	    PopupHandler.generatePopupName = function (clientId, request) {
	        return "msal." + clientId + "." + request.scopes.join("-") + "." + request.authority + "." + request.correlationId;
	    };
	    return PopupHandler;
	}(InteractionHandler));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var SilentHandler = /** @class */ (function (_super) {
	    __extends(SilentHandler, _super);
	    function SilentHandler(authCodeModule, storageImpl, authCodeRequest, navigateFrameWait) {
	        var _this = _super.call(this, authCodeModule, storageImpl, authCodeRequest) || this;
	        _this.navigateFrameWait = navigateFrameWait;
	        return _this;
	    }
	    /**
	     * Creates a hidden iframe to given URL using user-requested scopes as an id.
	     * @param urlNavigate
	     * @param userRequestScopes
	     */
	    SilentHandler.prototype.initiateAuthRequest = function (requestUrl) {
	        return __awaiter(this, void 0, void 0, function () {
	            var _a;
	            return __generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        if (StringUtils.isEmpty(requestUrl)) {
	                            // Throw error if request URL is empty.
	                            this.authModule.logger.info("Navigate url is empty");
	                            throw BrowserAuthError.createEmptyNavigationUriError();
	                        }
	                        if (!this.navigateFrameWait) return [3 /*break*/, 2];
	                        return [4 /*yield*/, this.loadFrame(requestUrl)];
	                    case 1:
	                        _a = _b.sent();
	                        return [3 /*break*/, 3];
	                    case 2:
	                        _a = this.loadFrameSync(requestUrl);
	                        _b.label = 3;
	                    case 3: return [2 /*return*/, _a];
	                }
	            });
	        });
	    };
	    /**
	     * Monitors an iframe content window until it loads a url with a known hash, or hits a specified timeout.
	     * @param iframe
	     * @param timeout
	     */
	    SilentHandler.prototype.monitorIframeForHash = function (iframe, timeout) {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            if (timeout < DEFAULT_IFRAME_TIMEOUT_MS) {
	                _this.authModule.logger.warning("system.loadFrameTimeout or system.iframeHashTimeout set to lower (" + timeout + "ms) than the default (" + DEFAULT_IFRAME_TIMEOUT_MS + "ms). This may result in timeouts.");
	            }
	            /*
	             * Polling for iframes can be purely timing based,
	             * since we don't need to account for interaction.
	             */
	            var nowMark = window.performance.now();
	            var timeoutMark = nowMark + timeout;
	            var intervalId = setInterval(function () {
	                if (window.performance.now() > timeoutMark) {
	                    _this.removeHiddenIframe(iframe);
	                    clearInterval(intervalId);
	                    reject(BrowserAuthError.createMonitorIframeTimeoutError());
	                    return;
	                }
	                var href = Constants.EMPTY_STRING;
	                var contentWindow = iframe.contentWindow;
	                try {
	                    /*
	                     * Will throw if cross origin,
	                     * which should be caught and ignored
	                     * since we need the interval to keep running while on STS UI.
	                     */
	                    href = contentWindow ? contentWindow.location.href : Constants.EMPTY_STRING;
	                }
	                catch (e) { }
	                if (StringUtils.isEmpty(href)) {
	                    return;
	                }
	                var contentHash = contentWindow ? contentWindow.location.hash : Constants.EMPTY_STRING;
	                if (UrlString.hashContainsKnownProperties(contentHash)) {
	                    // Success case
	                    _this.removeHiddenIframe(iframe);
	                    clearInterval(intervalId);
	                    resolve(contentHash);
	                    return;
	                }
	            }, BrowserConstants.POLL_INTERVAL_MS);
	        });
	    };
	    /**
	     * @hidden
	     * Loads iframe with authorization endpoint URL
	     * @ignore
	     */
	    SilentHandler.prototype.loadFrame = function (urlNavigate) {
	        /*
	         * This trick overcomes iframe navigation in IE
	         * IE does not load the page consistently in iframe
	         */
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            var frameHandle = _this.createHiddenIframe();
	            setTimeout(function () {
	                if (!frameHandle) {
	                    reject("Unable to load iframe");
	                    return;
	                }
	                frameHandle.src = urlNavigate;
	                resolve(frameHandle);
	            }, _this.navigateFrameWait);
	        });
	    };
	    /**
	     * @hidden
	     * Loads the iframe synchronously when the navigateTimeFrame is set to `0`
	     * @param urlNavigate
	     * @param frameName
	     * @param logger
	     */
	    SilentHandler.prototype.loadFrameSync = function (urlNavigate) {
	        var frameHandle = this.createHiddenIframe();
	        frameHandle.src = urlNavigate;
	        return frameHandle;
	    };
	    /**
	     * @hidden
	     * Creates a new hidden iframe or gets an existing one for silent token renewal.
	     * @ignore
	     */
	    SilentHandler.prototype.createHiddenIframe = function () {
	        var authFrame = document.createElement("iframe");
	        authFrame.style.visibility = "hidden";
	        authFrame.style.position = "absolute";
	        authFrame.style.width = authFrame.style.height = "0";
	        authFrame.style.border = "0";
	        authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
	        document.getElementsByTagName("body")[0].appendChild(authFrame);
	        return authFrame;
	    };
	    /**
	     * @hidden
	     * Removes a hidden iframe from the page.
	     * @ignore
	     */
	    SilentHandler.prototype.removeHiddenIframe = function (iframe) {
	        if (document.body === iframe.parentNode) {
	            document.body.removeChild(iframe);
	        }
	    };
	    return SilentHandler;
	}(InteractionHandler));
	
	/* eslint-disable header/header */
	var name$1 = "@azure/msal-browser";
	var version$1 = "2.12.1";
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	(function (EventType) {
	    EventType["LOGIN_START"] = "msal:loginStart";
	    EventType["LOGIN_SUCCESS"] = "msal:loginSuccess";
	    EventType["LOGIN_FAILURE"] = "msal:loginFailure";
	    EventType["ACQUIRE_TOKEN_START"] = "msal:acquireTokenStart";
	    EventType["ACQUIRE_TOKEN_SUCCESS"] = "msal:acquireTokenSuccess";
	    EventType["ACQUIRE_TOKEN_FAILURE"] = "msal:acquireTokenFailure";
	    EventType["ACQUIRE_TOKEN_NETWORK_START"] = "msal:acquireTokenFromNetworkStart";
	    EventType["SSO_SILENT_START"] = "msal:ssoSilentStart";
	    EventType["SSO_SILENT_SUCCESS"] = "msal:ssoSilentSuccess";
	    EventType["SSO_SILENT_FAILURE"] = "msal:ssoSilentFailure";
	    EventType["HANDLE_REDIRECT_START"] = "msal:handleRedirectStart";
	    EventType["HANDLE_REDIRECT_END"] = "msal:handleRedirectEnd";
	    EventType["LOGOUT_START"] = "msal:logoutStart";
	    EventType["LOGOUT_SUCCESS"] = "msal:logoutSuccess";
	    EventType["LOGOUT_FAILURE"] = "msal:logoutFailure";
	})(exports.EventType || (exports.EventType = {}));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var ClientApplication = /** @class */ (function () {
	    /**
	     * @constructor
	     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
	     *
	     * Important attributes in the Configuration object for auth are:
	     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
	     * - authority: the authority URL for your application.
	     * - redirect_uri: the uri of your application registered in the portal.
	     *
	     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
	     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
	     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
	     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
	     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
	     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
	     *
	     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
	     * Full B2C functionality will be available in this library in future versions.
	     *
	     * @param configuration Object for the MSAL PublicClientApplication instance
	     */
	    function ClientApplication(configuration) {
	        /*
	         * If loaded in an environment where window is not available,
	         * set internal flag to false so that further requests fail.
	         * This is to support server-side rendering environments.
	         */
	        this.isBrowserEnvironment = typeof window !== "undefined";
	        // Set the configuration.
	        this.config = buildConfiguration(configuration, this.isBrowserEnvironment);
	        this.activeLocalAccountId = null;
	        // Array of events
	        this.eventCallbacks = new Map();
	        // Initialize logger
	        this.logger = new Logger(this.config.system.loggerOptions, name$1, version$1);
	        // Initialize the network module class.
	        this.networkClient = this.config.system.networkClient;
	        // Initialize the navigation client class.
	        this.navigationClient = this.config.system.navigationClient;
	        // Initialize redirectResponse Map
	        this.redirectResponse = new Map();
	        if (!this.isBrowserEnvironment) {
	            this.browserStorage = DEFAULT_BROWSER_CACHE_MANAGER(this.config.auth.clientId, this.logger);
	            this.browserCrypto = DEFAULT_CRYPTO_IMPLEMENTATION;
	            return;
	        }
	        // Initialize the crypto class.
	        this.browserCrypto = new CryptoOps();
	        // Initialize the browser storage class.
	        this.browserStorage = new BrowserCacheManager(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger);
	    }
	    // #region Redirect Flow
	    /**
	     * Event handler function which allows users to fire events after the PublicClientApplication object
	     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
	     * auth flows.
	     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
	     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
	     */
	    ClientApplication.prototype.handleRedirectPromise = function (hash) {
	        return __awaiter(this, void 0, void 0, function () {
	            var loggedInAccounts, redirectResponseKey, response;
	            var _this = this;
	            return __generator(this, function (_a) {
	                this.emitEvent(exports.EventType.HANDLE_REDIRECT_START, exports.InteractionType.Redirect);
	                this.logger.verbose("handleRedirectPromise called");
	                loggedInAccounts = this.getAllAccounts();
	                if (this.isBrowserEnvironment) {
	                    redirectResponseKey = hash || Constants.EMPTY_STRING;
	                    response = this.redirectResponse.get(redirectResponseKey);
	                    if (typeof response === "undefined") {
	                        this.logger.verbose("handleRedirectPromise has been called for the first time, storing the promise");
	                        response = this.handleRedirectResponse(hash)
	                            .then(function (result) {
	                            if (result) {
	                                // Emit login event if number of accounts change
	                                var isLoggingIn = loggedInAccounts.length < _this.getAllAccounts().length;
	                                if (isLoggingIn) {
	                                    _this.emitEvent(exports.EventType.LOGIN_SUCCESS, exports.InteractionType.Redirect, result);
	                                    _this.logger.verbose("handleRedirectResponse returned result, login success");
	                                }
	                                else {
	                                    _this.emitEvent(exports.EventType.ACQUIRE_TOKEN_SUCCESS, exports.InteractionType.Redirect, result);
	                                    _this.logger.verbose("handleRedirectResponse returned result, acquire token success");
	                                }
	                            }
	                            _this.emitEvent(exports.EventType.HANDLE_REDIRECT_END, exports.InteractionType.Redirect);
	                            return result;
	                        })
	                            .catch(function (e) {
	                            // Emit login event if there is an account
	                            if (loggedInAccounts.length > 0) {
	                                _this.emitEvent(exports.EventType.ACQUIRE_TOKEN_FAILURE, exports.InteractionType.Redirect, null, e);
	                            }
	                            else {
	                                _this.emitEvent(exports.EventType.LOGIN_FAILURE, exports.InteractionType.Redirect, null, e);
	                            }
	                            _this.emitEvent(exports.EventType.HANDLE_REDIRECT_END, exports.InteractionType.Redirect);
	                            throw e;
	                        });
	                        this.redirectResponse.set(redirectResponseKey, response);
	                    }
	                    else {
	                        this.logger.verbose("handleRedirectPromise has been called previously, returning the result from the first call");
	                    }
	                    return [2 /*return*/, response];
	                }
	                this.logger.verbose("handleRedirectPromise returns null, not browser environment");
	                return [2 /*return*/, null];
	            });
	        });
	    };
	    /**
	     * Checks if navigateToLoginRequestUrl is set, and:
	     * - if true, performs logic to cache and navigate
	     * - if false, handles hash string and parses response
	     * @param hash
	     */
	    ClientApplication.prototype.handleRedirectResponse = function (hash) {
	        return __awaiter(this, void 0, void 0, function () {
	            var responseHash, state, loginRequestUrl, loginRequestUrlNormalized, currentUrlNormalized, handleHashResult, navigationOptions, processHashOnRedirect, homepage;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!this.interactionInProgress()) {
	                            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
	                            return [2 /*return*/, null];
	                        }
	                        responseHash = this.getRedirectResponseHash(hash || window.location.hash);
	                        if (!responseHash) {
	                            // Not a recognized server response hash or hash not associated with a redirect request
	                            this.logger.info("handleRedirectPromise did not detect a response hash as a result of a redirect. Cleaning temporary cache.");
	                            this.browserStorage.cleanRequestByInteractionType(exports.InteractionType.Redirect);
	                            return [2 /*return*/, null];
	                        }
	                        try {
	                            state = this.validateAndExtractStateFromHash(responseHash, exports.InteractionType.Redirect);
	                            BrowserUtils.clearHash();
	                            this.logger.verbose("State extracted from hash");
	                        }
	                        catch (e) {
	                            this.logger.info("handleRedirectPromise was unable to extract state due to: " + e);
	                            this.browserStorage.cleanRequestByInteractionType(exports.InteractionType.Redirect);
	                            return [2 /*return*/, null];
	                        }
	                        loginRequestUrl = this.browserStorage.getTemporaryCache(TemporaryCacheKeys.ORIGIN_URI, true) || "";
	                        loginRequestUrlNormalized = UrlString.removeHashFromUrl(loginRequestUrl);
	                        currentUrlNormalized = UrlString.removeHashFromUrl(window.location.href);
	                        if (!(loginRequestUrlNormalized === currentUrlNormalized && this.config.auth.navigateToLoginRequestUrl)) return [3 /*break*/, 2];
	                        // We are on the page we need to navigate to - handle hash
	                        this.logger.verbose("Current page is loginRequestUrl, handling hash");
	                        return [4 /*yield*/, this.handleHash(responseHash, state)];
	                    case 1:
	                        handleHashResult = _a.sent();
	                        if (loginRequestUrl.indexOf("#") > -1) {
	                            // Replace current hash with non-msal hash, if present
	                            BrowserUtils.replaceHash(loginRequestUrl);
	                        }
	                        return [2 /*return*/, handleHashResult];
	                    case 2:
	                        if (!!this.config.auth.navigateToLoginRequestUrl) return [3 /*break*/, 3];
	                        this.logger.verbose("NavigateToLoginRequestUrl set to false, handling hash");
	                        return [2 /*return*/, this.handleHash(responseHash, state)];
	                    case 3:
	                        if (!!BrowserUtils.isInIframe()) return [3 /*break*/, 8];
	                        /*
	                         * Returned from authority using redirect - need to perform navigation before processing response
	                         * Cache the hash to be retrieved after the next redirect
	                         */
	                        this.browserStorage.setTemporaryCache(TemporaryCacheKeys.URL_HASH, responseHash, true);
	                        navigationOptions = {
	                            apiId: exports.ApiId.handleRedirectPromise,
	                            timeout: this.config.system.redirectNavigationTimeout,
	                            noHistory: true
	                        };
	                        processHashOnRedirect = true;
	                        if (!(!loginRequestUrl || loginRequestUrl === "null")) return [3 /*break*/, 5];
	                        homepage = BrowserUtils.getHomepage();
	                        // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
	                        this.browserStorage.setTemporaryCache(TemporaryCacheKeys.ORIGIN_URI, homepage, true);
	                        this.logger.warning("Unable to get valid login request url from cache, redirecting to home page");
	                        return [4 /*yield*/, this.navigationClient.navigateInternal(homepage, navigationOptions)];
	                    case 4:
	                        processHashOnRedirect = _a.sent();
	                        return [3 /*break*/, 7];
	                    case 5:
	                        // Navigate to page that initiated the redirect request
	                        this.logger.verbose("Navigating to loginRequestUrl: " + loginRequestUrl);
	                        return [4 /*yield*/, this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions)];
	                    case 6:
	                        processHashOnRedirect = _a.sent();
	                        _a.label = 7;
	                    case 7:
	                        // If navigateInternal implementation returns false, handle the hash now
	                        if (!processHashOnRedirect) {
	                            return [2 /*return*/, this.handleHash(responseHash, state)];
	                        }
	                        _a.label = 8;
	                    case 8: return [2 /*return*/, null];
	                }
	            });
	        });
	    };
	    /**
	     * Gets the response hash for a redirect request
	     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
	     * @param hash
	     */
	    ClientApplication.prototype.getRedirectResponseHash = function (hash) {
	        this.logger.verbose("getRedirectResponseHash called");
	        // Get current location hash from window or cache.
	        var isResponseHash = UrlString.hashContainsKnownProperties(hash);
	        var cachedHash = this.browserStorage.getTemporaryCache(TemporaryCacheKeys.URL_HASH, true);
	        this.browserStorage.removeItem(this.browserStorage.generateCacheKey(TemporaryCacheKeys.URL_HASH));
	        if (isResponseHash) {
	            this.logger.verbose("Hash contains known properties, returning response hash");
	            return hash;
	        }
	        this.logger.verbose("Hash does not contain known properties, returning cached hash");
	        return cachedHash;
	    };
	    /**
	     * @param hash
	     * @param interactionType
	     */
	    ClientApplication.prototype.validateAndExtractStateFromHash = function (hash, interactionType) {
	        this.logger.verbose("validateAndExtractStateFromHash called");
	        // Deserialize hash fragment response parameters.
	        var serverParams = UrlString.getDeserializedHash(hash);
	        if (!serverParams.state) {
	            throw BrowserAuthError.createHashDoesNotContainStateError();
	        }
	        var platformStateObj = BrowserProtocolUtils.extractBrowserRequestState(this.browserCrypto, serverParams.state);
	        if (!platformStateObj) {
	            throw BrowserAuthError.createUnableToParseStateError();
	        }
	        if (platformStateObj.interactionType !== interactionType) {
	            throw BrowserAuthError.createStateInteractionTypeMismatchError();
	        }
	        this.logger.verbose("Returning state from hash");
	        return serverParams.state;
	    };
	    /**
	     * Checks if hash exists and handles in window.
	     * @param hash
	     * @param state
	     */
	    ClientApplication.prototype.handleHash = function (hash, state) {
	        return __awaiter(this, void 0, void 0, function () {
	            var cachedRequest, serverTelemetryManager, currentAuthority, authClient, interactionHandler, e_1;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.logger.verbose("handleHash called");
	                        cachedRequest = this.browserStorage.getCachedRequest(state, this.browserCrypto);
	                        serverTelemetryManager = this.initializeServerTelemetryManager(exports.ApiId.handleRedirectPromise, cachedRequest.correlationId);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 4, , 5]);
	                        currentAuthority = this.browserStorage.getCachedAuthority(state);
	                        if (!currentAuthority) {
	                            throw BrowserAuthError.createNoCachedAuthorityError();
	                        }
	                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, currentAuthority)];
	                    case 2:
	                        authClient = _a.sent();
	                        interactionHandler = new RedirectHandler(authClient, this.browserStorage, cachedRequest, this.browserCrypto);
	                        return [4 /*yield*/, interactionHandler.handleCodeResponse(hash, state, authClient.authority, this.networkClient, this.config.auth.clientId)];
	                    case 3: return [2 /*return*/, _a.sent()];
	                    case 4:
	                        e_1 = _a.sent();
	                        serverTelemetryManager.cacheFailedRequest(e_1);
	                        this.browserStorage.cleanRequestByInteractionType(exports.InteractionType.Redirect);
	                        throw e_1;
	                    case 5: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
	     * the page, so any code that follows this function will not execute.
	     *
	     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
	     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
	     *
	     * @param request
	     */
	    ClientApplication.prototype.acquireTokenRedirect = function (request) {
	        return __awaiter(this, void 0, void 0, function () {
	            var isLoggedIn, validRequest, serverTelemetryManager, authCodeRequest, authClient, interactionHandler, navigateUrl, redirectStartPage, e_2;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        // Preflight request
	                        this.preflightBrowserEnvironmentCheck(exports.InteractionType.Redirect);
	                        this.logger.verbose("acquireTokenRedirect called");
	                        isLoggedIn = this.getAllAccounts().length > 0;
	                        if (isLoggedIn) {
	                            this.emitEvent(exports.EventType.ACQUIRE_TOKEN_START, exports.InteractionType.Redirect, request);
	                        }
	                        else {
	                            this.emitEvent(exports.EventType.LOGIN_START, exports.InteractionType.Redirect, request);
	                        }
	                        validRequest = this.preflightInteractiveRequest(request, exports.InteractionType.Redirect);
	                        serverTelemetryManager = this.initializeServerTelemetryManager(exports.ApiId.acquireTokenRedirect, validRequest.correlationId);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 5, , 6]);
	                        return [4 /*yield*/, this.initializeAuthorizationCodeRequest(validRequest)];
	                    case 2:
	                        authCodeRequest = _a.sent();
	                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, validRequest.authority)];
	                    case 3:
	                        authClient = _a.sent();
	                        interactionHandler = new RedirectHandler(authClient, this.browserStorage, authCodeRequest, this.browserCrypto);
	                        return [4 /*yield*/, authClient.getAuthCodeUrl(validRequest)];
	                    case 4:
	                        navigateUrl = _a.sent();
	                        redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
	                        // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
	                        return [2 /*return*/, interactionHandler.initiateAuthRequest(navigateUrl, {
	                                navigationClient: this.navigationClient,
	                                redirectTimeout: this.config.system.redirectNavigationTimeout,
	                                redirectStartPage: redirectStartPage,
	                                onRedirectNavigate: request.onRedirectNavigate
	                            })];
	                    case 5:
	                        e_2 = _a.sent();
	                        // If logged in, emit acquire token events
	                        if (isLoggedIn) {
	                            this.emitEvent(exports.EventType.ACQUIRE_TOKEN_FAILURE, exports.InteractionType.Redirect, null, e_2);
	                        }
	                        else {
	                            this.emitEvent(exports.EventType.LOGIN_FAILURE, exports.InteractionType.Redirect, null, e_2);
	                        }
	                        serverTelemetryManager.cacheFailedRequest(e_2);
	                        this.browserStorage.cleanRequestByState(validRequest.state);
	                        throw e_2;
	                    case 6: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    // #endregion
	    // #region Popup Flow
	    /**
	     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
	     *
	     * @param request
	     *
	     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
	     */
	    ClientApplication.prototype.acquireTokenPopup = function (request) {
	        var validRequest;
	        try {
	            this.preflightBrowserEnvironmentCheck(exports.InteractionType.Popup);
	            this.logger.verbose("acquireTokenPopup called");
	            validRequest = this.preflightInteractiveRequest(request, exports.InteractionType.Popup);
	        }
	        catch (e) {
	            // Since this function is syncronous we need to reject
	            return Promise.reject(e);
	        }
	        var popupName = PopupHandler.generatePopupName(this.config.auth.clientId, validRequest);
	        // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
	        if (this.config.system.asyncPopups) {
	            this.logger.verbose("asyncPopups set to true, acquiring token");
	            return this.acquireTokenPopupAsync(validRequest, popupName);
	        }
	        else {
	            // asyncPopups flag is set to false. Opens popup before acquiring token.
	            this.logger.verbose("asyncPopup set to false, opening popup before acquiring token");
	            var popup = PopupHandler.openSizedPopup("about:blank", popupName);
	            return this.acquireTokenPopupAsync(validRequest, popupName, popup);
	        }
	    };
	    /**
	     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
	     * @param validRequest
	     * @param popupName
	     * @param popup
	     *
	     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
	     */
	    ClientApplication.prototype.acquireTokenPopupAsync = function (validRequest, popupName, popup) {
	        return __awaiter(this, void 0, void 0, function () {
	            var loggedInAccounts, serverTelemetryManager, authCodeRequest, authClient, navigateUrl, interactionHandler, popupParameters, popupWindow, hash, state, result, isLoggingIn, e_3;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.logger.verbose("acquireTokenPopupAsync called");
	                        loggedInAccounts = this.getAllAccounts();
	                        if (loggedInAccounts.length > 0) {
	                            this.emitEvent(exports.EventType.ACQUIRE_TOKEN_START, exports.InteractionType.Popup, validRequest);
	                        }
	                        else {
	                            this.emitEvent(exports.EventType.LOGIN_START, exports.InteractionType.Popup, validRequest);
	                        }
	                        serverTelemetryManager = this.initializeServerTelemetryManager(exports.ApiId.acquireTokenPopup, validRequest.correlationId);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 7, , 8]);
	                        return [4 /*yield*/, this.initializeAuthorizationCodeRequest(validRequest)];
	                    case 2:
	                        authCodeRequest = _a.sent();
	                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, validRequest.authority)];
	                    case 3:
	                        authClient = _a.sent();
	                        return [4 /*yield*/, authClient.getAuthCodeUrl(validRequest)];
	                    case 4:
	                        navigateUrl = _a.sent();
	                        interactionHandler = new PopupHandler(authClient, this.browserStorage, authCodeRequest);
	                        popupParameters = {
	                            popup: popup,
	                            popupName: popupName
	                        };
	                        popupWindow = interactionHandler.initiateAuthRequest(navigateUrl, popupParameters);
	                        return [4 /*yield*/, interactionHandler.monitorPopupForHash(popupWindow, this.config.system.windowHashTimeout)];
	                    case 5:
	                        hash = _a.sent();
	                        state = this.validateAndExtractStateFromHash(hash, exports.InteractionType.Popup);
	                        // Remove throttle if it exists
	                        ThrottlingUtils.removeThrottle(this.browserStorage, this.config.auth.clientId, authCodeRequest.authority, authCodeRequest.scopes);
	                        return [4 /*yield*/, interactionHandler.handleCodeResponse(hash, state, authClient.authority, this.networkClient)];
	                    case 6:
	                        result = _a.sent();
	                        isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
	                        if (isLoggingIn) {
	                            this.emitEvent(exports.EventType.LOGIN_SUCCESS, exports.InteractionType.Popup, result);
	                        }
	                        else {
	                            this.emitEvent(exports.EventType.ACQUIRE_TOKEN_SUCCESS, exports.InteractionType.Popup, result);
	                        }
	                        return [2 /*return*/, result];
	                    case 7:
	                        e_3 = _a.sent();
	                        if (loggedInAccounts.length > 0) {
	                            this.emitEvent(exports.EventType.ACQUIRE_TOKEN_FAILURE, exports.InteractionType.Popup, null, e_3);
	                        }
	                        else {
	                            this.emitEvent(exports.EventType.LOGIN_FAILURE, exports.InteractionType.Popup, null, e_3);
	                        }
	                        serverTelemetryManager.cacheFailedRequest(e_3);
	                        this.browserStorage.cleanRequestByState(validRequest.state);
	                        throw e_3;
	                    case 8: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    // #endregion
	    // #region Silent Flow
	    /**
	     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
	     * - Any browser using a form of Intelligent Tracking Prevention
	     * - If there is not an established session with the service
	     *
	     * In these cases, the request must be done inside a popup or full frame redirect.
	     *
	     * For the cases where interaction is required, you cannot send a request with prompt=none.
	     *
	     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
	     * you session on the server still exists.
	     * @param request {@link SsoSilentRequest}
	     *
	     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
	     */
	    ClientApplication.prototype.ssoSilent = function (request) {
	        return __awaiter(this, void 0, void 0, function () {
	            var silentTokenResult, e_4;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.preflightBrowserEnvironmentCheck(exports.InteractionType.Silent);
	                        this.logger.verbose("ssoSilent called");
	                        this.emitEvent(exports.EventType.SSO_SILENT_START, exports.InteractionType.Silent, request);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 3, , 4]);
	                        return [4 /*yield*/, this.acquireTokenByIframe(request, exports.ApiId.ssoSilent)];
	                    case 2:
	                        silentTokenResult = _a.sent();
	                        this.emitEvent(exports.EventType.SSO_SILENT_SUCCESS, exports.InteractionType.Silent, silentTokenResult);
	                        return [2 /*return*/, silentTokenResult];
	                    case 3:
	                        e_4 = _a.sent();
	                        this.emitEvent(exports.EventType.SSO_SILENT_FAILURE, exports.InteractionType.Silent, null, e_4);
	                        throw e_4;
	                    case 4: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * This function uses a hidden iframe to fetch an authorization code from the eSTS. To be used for silent refresh token acquisition and renewal.
	     * @param request
	     * @param apiId - ApiId of the calling function. Used for telemetry.
	     */
	    ClientApplication.prototype.acquireTokenByIframe = function (request, apiId) {
	        return __awaiter(this, void 0, void 0, function () {
	            var silentRequest, serverTelemetryManager, authCodeRequest, authClient, navigateUrl, e_5;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.logger.verbose("acquireTokenByIframe called");
	                        // Check that we have some SSO data
	                        if (StringUtils.isEmpty(request.loginHint) && StringUtils.isEmpty(request.sid) && (!request.account || StringUtils.isEmpty(request.account.username))) {
	                            throw BrowserAuthError.createSilentSSOInsufficientInfoError();
	                        }
	                        // Check that prompt is set to none, throw error if it is set to anything else.
	                        if (request.prompt && request.prompt !== PromptValue.NONE) {
	                            throw BrowserAuthError.createSilentPromptValueError(request.prompt);
	                        }
	                        silentRequest = this.initializeAuthorizationRequest(__assign(__assign({}, request), { prompt: PromptValue.NONE }), exports.InteractionType.Silent);
	                        serverTelemetryManager = this.initializeServerTelemetryManager(apiId, silentRequest.correlationId);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 6, , 7]);
	                        return [4 /*yield*/, this.initializeAuthorizationCodeRequest(silentRequest)];
	                    case 2:
	                        authCodeRequest = _a.sent();
	                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, silentRequest.authority)];
	                    case 3:
	                        authClient = _a.sent();
	                        return [4 /*yield*/, authClient.getAuthCodeUrl(silentRequest)];
	                    case 4:
	                        navigateUrl = _a.sent();
	                        return [4 /*yield*/, this.silentTokenHelper(navigateUrl, authCodeRequest, authClient)];
	                    case 5: return [2 /*return*/, _a.sent()];
	                    case 6:
	                        e_5 = _a.sent();
	                        serverTelemetryManager.cacheFailedRequest(e_5);
	                        this.browserStorage.cleanRequestByState(silentRequest.state);
	                        throw e_5;
	                    case 7: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Use this function to obtain a token before every call to the API / resource provider
	     *
	     * MSAL return's a cached token when available
	     * Or it send's a request to the STS to obtain a new token using a refresh token.
	     *
	     * @param {@link SilentRequest}
	     *
	     * To renew idToken, please pass clientId as the only scope in the Authentication Parameters
	     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
	     */
	    ClientApplication.prototype.acquireTokenByRefreshToken = function (request) {
	        return __awaiter(this, void 0, void 0, function () {
	            var silentRequest, serverTelemetryManager, refreshTokenClient, e_6, isServerError, isInteractionRequiredError, isInvalidGrantError;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.emitEvent(exports.EventType.ACQUIRE_TOKEN_NETWORK_START, exports.InteractionType.Silent, request);
	                        // block the reload if it occurred inside a hidden iframe
	                        BrowserUtils.blockReloadInHiddenIframes();
	                        silentRequest = __assign(__assign({}, request), this.initializeBaseRequest(request));
	                        serverTelemetryManager = this.initializeServerTelemetryManager(exports.ApiId.acquireTokenSilent_silentFlow, silentRequest.correlationId);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 4, , 7]);
	                        return [4 /*yield*/, this.createRefreshTokenClient(serverTelemetryManager, silentRequest.authority)];
	                    case 2:
	                        refreshTokenClient = _a.sent();
	                        return [4 /*yield*/, refreshTokenClient.acquireTokenByRefreshToken(silentRequest)];
	                    case 3: 
	                    // Send request to renew token. Auth module will throw errors if token cannot be renewed.
	                    return [2 /*return*/, _a.sent()];
	                    case 4:
	                        e_6 = _a.sent();
	                        serverTelemetryManager.cacheFailedRequest(e_6);
	                        isServerError = e_6 instanceof ServerError;
	                        isInteractionRequiredError = e_6 instanceof InteractionRequiredAuthError;
	                        isInvalidGrantError = (e_6.errorCode === BrowserConstants.INVALID_GRANT_ERROR);
	                        if (!(isServerError && isInvalidGrantError && !isInteractionRequiredError)) return [3 /*break*/, 6];
	                        this.logger.verbose("Refresh token expired or invalid, attempting acquire token by iframe");
	                        return [4 /*yield*/, this.acquireTokenByIframe(request, exports.ApiId.acquireTokenSilent_authCode)];
	                    case 5: return [2 /*return*/, _a.sent()];
	                    case 6: throw e_6;
	                    case 7: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    /**
	     * Helper which acquires an authorization code silently using a hidden iframe from given url
	     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
	     * @param navigateUrl
	     * @param userRequestScopes
	     */
	    ClientApplication.prototype.silentTokenHelper = function (navigateUrl, authCodeRequest, authClient) {
	        return __awaiter(this, void 0, void 0, function () {
	            var silentHandler, msalFrame, hash, state;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        silentHandler = new SilentHandler(authClient, this.browserStorage, authCodeRequest, this.config.system.navigateFrameWait);
	                        return [4 /*yield*/, silentHandler.initiateAuthRequest(navigateUrl)];
	                    case 1:
	                        msalFrame = _a.sent();
	                        return [4 /*yield*/, silentHandler.monitorIframeForHash(msalFrame, this.config.system.iframeHashTimeout)];
	                    case 2:
	                        hash = _a.sent();
	                        state = this.validateAndExtractStateFromHash(hash, exports.InteractionType.Silent);
	                        // Handle response from hash string
	                        return [2 /*return*/, silentHandler.handleCodeResponse(hash, state, authClient.authority, this.networkClient)];
	                }
	            });
	        });
	    };
	    // #endregion
	    // #region Logout
	    /**
	     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
	     * Default behaviour is to redirect the user to `window.location.href`.
	     * @param logoutRequest
	     */
	    ClientApplication.prototype.logout = function (logoutRequest) {
	        return __awaiter(this, void 0, void 0, function () {
	            var validLogoutRequest, serverTelemetryManager, authClient, logoutUri, navigationOptions, navigate, e_7;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.preflightBrowserEnvironmentCheck(exports.InteractionType.Redirect);
	                        this.logger.verbose("logout called");
	                        validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
	                        serverTelemetryManager = this.initializeServerTelemetryManager(exports.ApiId.logout, validLogoutRequest.correlationId);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 9, , 10]);
	                        this.emitEvent(exports.EventType.LOGOUT_START, exports.InteractionType.Redirect, logoutRequest);
	                        return [4 /*yield*/, this.createAuthCodeClient(serverTelemetryManager, logoutRequest && logoutRequest.authority)];
	                    case 2:
	                        authClient = _a.sent();
	                        logoutUri = authClient.getLogoutUri(validLogoutRequest);
	                        this.emitEvent(exports.EventType.LOGOUT_SUCCESS, exports.InteractionType.Redirect, validLogoutRequest);
	                        if (!validLogoutRequest.account || AccountEntity.accountInfoIsEqual(validLogoutRequest.account, this.getActiveAccount())) {
	                            this.logger.verbose("Account not valid on validLogoutRequest, setting active account to null");
	                            this.setActiveAccount(null);
	                        }
	                        navigationOptions = {
	                            apiId: exports.ApiId.logout,
	                            timeout: this.config.system.redirectNavigationTimeout,
	                            noHistory: false
	                        };
	                        if (!(logoutRequest && typeof logoutRequest.onRedirectNavigate === "function")) return [3 /*break*/, 6];
	                        navigate = logoutRequest.onRedirectNavigate(logoutUri);
	                        if (!(navigate !== false)) return [3 /*break*/, 4];
	                        this.logger.verbose("Logout onRedirectNavigate did not return false, navigating");
	                        return [4 /*yield*/, this.navigationClient.navigateExternal(logoutUri, navigationOptions)];
	                    case 3:
	                        _a.sent();
	                        return [2 /*return*/];
	                    case 4:
	                        this.logger.verbose("Logout onRedirectNavigate returned false, stopping navigation");
	                        _a.label = 5;
	                    case 5: return [3 /*break*/, 8];
	                    case 6: return [4 /*yield*/, this.navigationClient.navigateExternal(logoutUri, navigationOptions)];
	                    case 7:
	                        _a.sent();
	                        return [2 /*return*/];
	                    case 8: return [3 /*break*/, 10];
	                    case 9:
	                        e_7 = _a.sent();
	                        serverTelemetryManager.cacheFailedRequest(e_7);
	                        this.emitEvent(exports.EventType.LOGOUT_FAILURE, exports.InteractionType.Redirect, null, e_7);
	                        throw e_7;
	                    case 10: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    // #endregion
	    // #region Account APIs
	    /**
	     * Returns all accounts that MSAL currently has data for.
	     * (the account object is created at the time of successful login)
	     * or empty array when no accounts are found
	     * @returns Array of account objects in cache
	     */
	    ClientApplication.prototype.getAllAccounts = function () {
	        this.logger.verbose("getAllAccounts called");
	        return this.isBrowserEnvironment ? this.browserStorage.getAllAccounts() : [];
	    };
	    /**
	     * Returns the signed in account matching username.
	     * (the account object is created at the time of successful login)
	     * or null when no matching account is found.
	     * This API is provided for convenience but getAccountById should be used for best reliability
	     * @param userName
	     * @returns The account object stored in MSAL
	     */
	    ClientApplication.prototype.getAccountByUsername = function (userName) {
	        var allAccounts = this.getAllAccounts();
	        if (!StringUtils.isEmpty(userName) && allAccounts && allAccounts.length) {
	            this.logger.verbose("Account matching username found, returning");
	            this.logger.verbosePii("Returning signed-in accounts matching username: " + userName);
	            return allAccounts.filter(function (accountObj) { return accountObj.username.toLowerCase() === userName.toLowerCase(); })[0] || null;
	        }
	        else {
	            this.logger.verbose("getAccountByUsername: No matching account found, returning null");
	            return null;
	        }
	    };
	    /**
	     * Returns the signed in account matching homeAccountId.
	     * (the account object is created at the time of successful login)
	     * or null when no matching account is found
	     * @param homeAccountId
	     * @returns The account object stored in MSAL
	     */
	    ClientApplication.prototype.getAccountByHomeId = function (homeAccountId) {
	        var allAccounts = this.getAllAccounts();
	        if (!StringUtils.isEmpty(homeAccountId) && allAccounts && allAccounts.length) {
	            this.logger.verbose("Account matching homeAccountId found, returning");
	            this.logger.verbosePii("Returning signed-in accounts matching homeAccountId: " + homeAccountId);
	            return allAccounts.filter(function (accountObj) { return accountObj.homeAccountId === homeAccountId; })[0] || null;
	        }
	        else {
	            this.logger.verbose("getAccountByHomeId: No matching account found, returning null");
	            return null;
	        }
	    };
	    /**
	     * Returns the signed in account matching localAccountId.
	     * (the account object is created at the time of successful login)
	     * or null when no matching account is found
	     * @param localAccountId
	     * @returns The account object stored in MSAL
	     */
	    ClientApplication.prototype.getAccountByLocalId = function (localAccountId) {
	        var allAccounts = this.getAllAccounts();
	        if (!StringUtils.isEmpty(localAccountId) && allAccounts && allAccounts.length) {
	            this.logger.verbose("Account matching localAccountId found, returning");
	            this.logger.verbosePii("Returning signed-in accounts matching localAccountId: " + localAccountId);
	            return allAccounts.filter(function (accountObj) { return accountObj.localAccountId === localAccountId; })[0] || null;
	        }
	        else {
	            this.logger.verbose("getAccountByLocalId: No matching account found, returning null");
	            return null;
	        }
	    };
	    /**
	     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
	     * @param account
	     */
	    ClientApplication.prototype.setActiveAccount = function (account) {
	        if (account) {
	            this.logger.verbose("setActiveAccount: Active account set");
	            this.activeLocalAccountId = account.localAccountId;
	        }
	        else {
	            this.logger.verbose("setActiveAccount: No account passed, active account not set");
	            this.activeLocalAccountId = null;
	        }
	    };
	    /**
	     * Gets the currently active account
	     */
	    ClientApplication.prototype.getActiveAccount = function () {
	        if (!this.activeLocalAccountId) {
	            this.logger.verbose("getActiveAccount: No active account");
	            return null;
	        }
	        return this.getAccountByLocalId(this.activeLocalAccountId);
	    };
	    // #endregion
	    // #region Helpers
	    /**
	     *
	     * Use to get the redirect uri configured in MSAL or null.
	     * @param requestRedirectUri
	     * @returns Redirect URL
	     *
	     */
	    ClientApplication.prototype.getRedirectUri = function (requestRedirectUri) {
	        this.logger.verbose("getRedirectUri called");
	        var redirectUri = requestRedirectUri || this.config.auth.redirectUri || BrowserUtils.getCurrentUri();
	        return UrlString.getAbsoluteUrl(redirectUri, BrowserUtils.getCurrentUri());
	    };
	    /**
	     * Use to get the redirectStartPage either from request or use current window
	     * @param requestStartPage
	     */
	    ClientApplication.prototype.getRedirectStartPage = function (requestStartPage) {
	        this.logger.verbose("getRedirectStartPage called");
	        var redirectStartPage = requestStartPage || window.location.href;
	        return UrlString.getAbsoluteUrl(redirectStartPage, BrowserUtils.getCurrentUri());
	    };
	    /**
	     * Used to get a discovered version of the default authority.
	     * @param requestAuthority
	     */
	    ClientApplication.prototype.getDiscoveredAuthority = function (requestAuthority) {
	        return __awaiter(this, void 0, void 0, function () {
	            var authorityOptions;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.logger.verbose("getDiscoveredAuthority called");
	                        authorityOptions = {
	                            protocolMode: this.config.auth.protocolMode,
	                            knownAuthorities: this.config.auth.knownAuthorities,
	                            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
	                            authorityMetadata: this.config.auth.authorityMetadata
	                        };
	                        if (!requestAuthority) return [3 /*break*/, 2];
	                        this.logger.verbose("Creating discovered authority with request authority");
	                        return [4 /*yield*/, AuthorityFactory.createDiscoveredInstance(requestAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions)];
	                    case 1: return [2 /*return*/, _a.sent()];
	                    case 2:
	                        this.logger.verbose("Creating discovered authority with configured authority");
	                        return [4 /*yield*/, AuthorityFactory.createDiscoveredInstance(this.config.auth.authority, this.config.system.networkClient, this.browserStorage, authorityOptions)];
	                    case 3: return [2 /*return*/, _a.sent()];
	                }
	            });
	        });
	    };
	    /**
	     * Helper to check whether interaction is in progress.
	     */
	    ClientApplication.prototype.interactionInProgress = function () {
	        // Check whether value in cache is present and equal to expected value
	        return (this.browserStorage.getTemporaryCache(TemporaryCacheKeys.INTERACTION_STATUS_KEY, true)) === BrowserConstants.INTERACTION_IN_PROGRESS_VALUE;
	    };
	    /**
	     * Creates an Authorization Code Client with the given authority, or the default authority.
	     * @param serverTelemetryManager
	     * @param authorityUrl
	     */
	    ClientApplication.prototype.createAuthCodeClient = function (serverTelemetryManager, authorityUrl) {
	        return __awaiter(this, void 0, void 0, function () {
	            var clientConfig;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.logger.verbose("createAuthCodeClient called");
	                        return [4 /*yield*/, this.getClientConfiguration(serverTelemetryManager, authorityUrl)];
	                    case 1:
	                        clientConfig = _a.sent();
	                        return [2 /*return*/, new AuthorizationCodeClient(clientConfig)];
	                }
	            });
	        });
	    };
	    /**
	     * Creates an Silent Flow Client with the given authority, or the default authority.
	     * @param serverTelemetryManager
	     * @param authorityUrl
	     */
	    ClientApplication.prototype.createSilentFlowClient = function (serverTelemetryManager, authorityUrl) {
	        return __awaiter(this, void 0, void 0, function () {
	            var clientConfig;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.logger.verbose("createSilentFlowClient called");
	                        return [4 /*yield*/, this.getClientConfiguration(serverTelemetryManager, authorityUrl)];
	                    case 1:
	                        clientConfig = _a.sent();
	                        return [2 /*return*/, new SilentFlowClient(clientConfig)];
	                }
	            });
	        });
	    };
	    /**
	     * Creates a Refresh Client with the given authority, or the default authority.
	     * @param serverTelemetryManager
	     * @param authorityUrl
	     */
	    ClientApplication.prototype.createRefreshTokenClient = function (serverTelemetryManager, authorityUrl) {
	        return __awaiter(this, void 0, void 0, function () {
	            var clientConfig;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.logger.verbose("createRefreshTokenClient called");
	                        return [4 /*yield*/, this.getClientConfiguration(serverTelemetryManager, authorityUrl)];
	                    case 1:
	                        clientConfig = _a.sent();
	                        return [2 /*return*/, new RefreshTokenClient(clientConfig)];
	                }
	            });
	        });
	    };
	    /**
	     * Creates a Client Configuration object with the given request authority, or the default authority.
	     * @param serverTelemetryManager
	     * @param requestAuthority
	     */
	    ClientApplication.prototype.getClientConfiguration = function (serverTelemetryManager, requestAuthority) {
	        return __awaiter(this, void 0, void 0, function () {
	            var discoveredAuthority;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.logger.verbose("getClientConfiguration called");
	                        return [4 /*yield*/, this.getDiscoveredAuthority(requestAuthority)];
	                    case 1:
	                        discoveredAuthority = _a.sent();
	                        return [2 /*return*/, {
	                                authOptions: {
	                                    clientId: this.config.auth.clientId,
	                                    authority: discoveredAuthority,
	                                    clientCapabilities: this.config.auth.clientCapabilities
	                                },
	                                systemOptions: {
	                                    tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds
	                                },
	                                loggerOptions: {
	                                    loggerCallback: this.config.system.loggerOptions.loggerCallback,
	                                    piiLoggingEnabled: this.config.system.loggerOptions.piiLoggingEnabled
	                                },
	                                cryptoInterface: this.browserCrypto,
	                                networkInterface: this.networkClient,
	                                storageInterface: this.browserStorage,
	                                serverTelemetryManager: serverTelemetryManager,
	                                libraryInfo: {
	                                    sku: BrowserConstants.MSAL_SKU,
	                                    version: version$1,
	                                    cpu: "",
	                                    os: ""
	                                }
	                            }];
	                }
	            });
	        });
	    };
	    /**
	     * Helper to validate app environment before making a request.
	     * @param request
	     * @param interactionType
	     */
	    ClientApplication.prototype.preflightInteractiveRequest = function (request, interactionType) {
	        this.logger.verbose("preflightInteractiveRequest called, validating app environment");
	        // block the reload if it occurred inside a hidden iframe
	        BrowserUtils.blockReloadInHiddenIframes();
	        // Check if interaction is in progress. Throw error if true.
	        if (this.interactionInProgress()) {
	            throw BrowserAuthError.createInteractionInProgressError();
	        }
	        return this.initializeAuthorizationRequest(request, interactionType);
	    };
	    /**
	     * Helper to validate app environment before making an auth request
	     * * @param interactionType
	     */
	    ClientApplication.prototype.preflightBrowserEnvironmentCheck = function (interactionType) {
	        this.logger.verbose("preflightBrowserEnvironmentCheck started");
	        // Block request if not in browser environment
	        BrowserUtils.blockNonBrowserEnvironment(this.isBrowserEnvironment);
	        // Block redirects if in an iframe
	        BrowserUtils.blockRedirectInIframe(interactionType, this.config.system.allowRedirectInIframe);
	        // Block auth requests inside a hidden iframe
	        BrowserUtils.blockReloadInHiddenIframes();
	        // Block redirects if memory storage is enabled but storeAuthStateInCookie is not
	        if (interactionType === exports.InteractionType.Redirect &&
	            this.config.cache.cacheLocation === exports.BrowserCacheLocation.MemoryStorage &&
	            !this.config.cache.storeAuthStateInCookie) {
	            throw BrowserConfigurationAuthError.createInMemoryRedirectUnavailableError();
	        }
	    };
	    /**
	     * Initializer function for all request APIs
	     * @param request
	     */
	    ClientApplication.prototype.initializeBaseRequest = function (request) {
	        this.logger.verbose("Initializing BaseAuthRequest");
	        var authority = request.authority || this.config.auth.authority;
	        var scopes = __spread(((request && request.scopes) || []));
	        var correlationId = (request && request.correlationId) || this.browserCrypto.createNewGuid();
	        var validatedRequest = __assign(__assign({}, request), { correlationId: correlationId,
	            authority: authority,
	            scopes: scopes });
	        return validatedRequest;
	    };
	    /**
	     *
	     * @param apiId
	     * @param correlationId
	     * @param forceRefresh
	     */
	    ClientApplication.prototype.initializeServerTelemetryManager = function (apiId, correlationId, forceRefresh) {
	        this.logger.verbose("initializeServerTelemetryManager called");
	        var telemetryPayload = {
	            clientId: this.config.auth.clientId,
	            correlationId: correlationId,
	            apiId: apiId,
	            forceRefresh: forceRefresh || false,
	            wrapperSKU: this.wrapperSKU,
	            wrapperVer: this.wrapperVer
	        };
	        return new ServerTelemetryManager(telemetryPayload, this.browserStorage);
	    };
	    /**
	     * Helper to initialize required request parameters for interactive APIs and ssoSilent()
	     * @param request
	     * @param interactionType
	     */
	    ClientApplication.prototype.initializeAuthorizationRequest = function (request, interactionType) {
	        this.logger.verbose("initializeAuthorizationRequest called");
	        var redirectUri = this.getRedirectUri(request.redirectUri);
	        var browserState = {
	            interactionType: interactionType
	        };
	        var state = ProtocolUtils.setRequestState(this.browserCrypto, (request && request.state) || "", browserState);
	        var authenticationScheme = request.authenticationScheme || exports.AuthenticationScheme.BEARER;
	        var validatedRequest = __assign(__assign({}, this.initializeBaseRequest(request)), { redirectUri: redirectUri, state: state, nonce: request.nonce || this.browserCrypto.createNewGuid(), responseMode: ResponseMode.FRAGMENT, authenticationScheme: authenticationScheme });
	        var account = request.account || this.getActiveAccount();
	        if (account) {
	            this.logger.verbose("Setting validated request account");
	            this.logger.verbosePii("Setting validated request account: " + account);
	            validatedRequest.account = account;
	        }
	        // Check for ADAL SSO
	        if (StringUtils.isEmpty(validatedRequest.loginHint)) {
	            // Only check for adal token if no SSO params are being used
	            var adalIdTokenString = this.browserStorage.getTemporaryCache(PersistentCacheKeys.ADAL_ID_TOKEN);
	            if (adalIdTokenString) {
	                var adalIdToken = new AuthToken(adalIdTokenString, this.browserCrypto);
	                this.browserStorage.removeItem(PersistentCacheKeys.ADAL_ID_TOKEN);
	                if (adalIdToken.claims && adalIdToken.claims.upn) {
	                    this.logger.verbose("No SSO params used and ADAL token retrieved, setting ADAL upn as loginHint");
	                    validatedRequest.loginHint = adalIdToken.claims.upn;
	                }
	            }
	        }
	        this.browserStorage.updateCacheEntries(validatedRequest.state, validatedRequest.nonce, validatedRequest.authority);
	        return validatedRequest;
	    };
	    /**
	     * Generates an auth code request tied to the url request.
	     * @param request
	     */
	    ClientApplication.prototype.initializeAuthorizationCodeRequest = function (request) {
	        return __awaiter(this, void 0, void 0, function () {
	            var generatedPkceParams, authCodeRequest;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.browserCrypto.generatePkceCodes()];
	                    case 1:
	                        generatedPkceParams = _a.sent();
	                        authCodeRequest = __assign(__assign({}, request), { redirectUri: request.redirectUri, code: "", codeVerifier: generatedPkceParams.verifier });
	                        request.codeChallenge = generatedPkceParams.challenge;
	                        request.codeChallengeMethod = Constants.S256_CODE_CHALLENGE_METHOD;
	                        return [2 /*return*/, authCodeRequest];
	                }
	            });
	        });
	    };
	    /**
	     * Initializer for the logout request.
	     * @param logoutRequest
	     */
	    ClientApplication.prototype.initializeLogoutRequest = function (logoutRequest) {
	        this.logger.verbose("initializeLogoutRequest called");
	        var validLogoutRequest = __assign({ correlationId: this.browserCrypto.createNewGuid() }, logoutRequest);
	        /*
	         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
	         * Otherwise, use passed uri, config, or current page.
	         */
	        if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
	            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
	                this.logger.verbose("Setting postLogoutRedirectUri to uri set on logout request");
	                validLogoutRequest.postLogoutRedirectUri = UrlString.getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, BrowserUtils.getCurrentUri());
	            }
	            else if (this.config.auth.postLogoutRedirectUri === null) {
	                this.logger.verbose("postLogoutRedirectUri configured as null and no uri set on request, not passing post logout redirect");
	            }
	            else if (this.config.auth.postLogoutRedirectUri) {
	                this.logger.verbose("Setting postLogoutRedirectUri to configured uri");
	                validLogoutRequest.postLogoutRedirectUri = UrlString.getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, BrowserUtils.getCurrentUri());
	            }
	            else {
	                this.logger.verbose("Setting postLogoutRedirectUri to current page");
	                validLogoutRequest.postLogoutRedirectUri = UrlString.getAbsoluteUrl(BrowserUtils.getCurrentUri(), BrowserUtils.getCurrentUri());
	            }
	        }
	        else {
	            this.logger.verbose("postLogoutRedirectUri passed as null, not settibng post logout redirect uri");
	        }
	        return validLogoutRequest;
	    };
	    /**
	     * Emits events by calling callback with event message
	     * @param eventType
	     * @param interactionType
	     * @param payload
	     * @param error
	     */
	    ClientApplication.prototype.emitEvent = function (eventType, interactionType, payload, error) {
	        var _this = this;
	        if (this.isBrowserEnvironment) {
	            var message_1 = {
	                eventType: eventType,
	                interactionType: interactionType || null,
	                payload: payload || null,
	                error: error || null,
	                timestamp: Date.now()
	            };
	            this.logger.info("Emitting event: " + eventType);
	            this.eventCallbacks.forEach(function (callback, callbackId) {
	                _this.logger.verbose("Emitting event to callback " + callbackId + ": " + eventType);
	                callback.apply(null, [message_1]);
	            });
	        }
	    };
	    /**
	     * Adds event callbacks to array
	     * @param callback
	     */
	    ClientApplication.prototype.addEventCallback = function (callback) {
	        if (this.isBrowserEnvironment) {
	            var callbackId = this.browserCrypto.createNewGuid();
	            this.eventCallbacks.set(callbackId, callback);
	            this.logger.verbose("Event callback registered with id: " + callbackId);
	            return callbackId;
	        }
	        return null;
	    };
	    /**
	     * Removes callback with provided id from callback array
	     * @param callbackId
	     */
	    ClientApplication.prototype.removeEventCallback = function (callbackId) {
	        this.eventCallbacks.delete(callbackId);
	        this.logger.verbose("Event callback " + callbackId + " removed.");
	    };
	    /**
	     * Returns the logger instance
	     */
	    ClientApplication.prototype.getLogger = function () {
	        return this.logger;
	    };
	    /**
	     * Replaces the default logger set in configurations with new Logger with new configurations
	     * @param logger Logger instance
	     */
	    ClientApplication.prototype.setLogger = function (logger) {
	        this.logger = logger;
	    };
	    /**
	     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
	     * @param sku
	     * @param version
	     */
	    ClientApplication.prototype.initializeWrapperLibrary = function (sku, version) {
	        // Validate the SKU passed in is one we expect
	        this.wrapperSKU = sku;
	        this.wrapperVer = version;
	    };
	    /**
	     * Sets navigation client
	     * @param navigationClient
	     */
	    ClientApplication.prototype.setNavigationClient = function (navigationClient) {
	        this.navigationClient = navigationClient;
	    };
	    return ClientApplication;
	}());
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	/**
	 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
	 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
	 */
	var PublicClientApplication = /** @class */ (function (_super) {
	    __extends(PublicClientApplication, _super);
	    /**
	     * @constructor
	     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
	     *
	     * Important attributes in the Configuration object for auth are:
	     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
	     * - authority: the authority URL for your application.
	     * - redirect_uri: the uri of your application registered in the portal.
	     *
	     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
	     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
	     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
	     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
	     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
	     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
	     *
	     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
	     * Full B2C functionality will be available in this library in future versions.
	     *
	     * @param configuration object for the MSAL PublicClientApplication instance
	     */
	    function PublicClientApplication(configuration) {
	        return _super.call(this, configuration) || this;
	    }
	    /**
	     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
	     * any code that follows this function will not execute.
	     *
	     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
	     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
	     *
	     * @param request
	     */
	    PublicClientApplication.prototype.loginRedirect = function (request) {
	        return __awaiter(this, void 0, void 0, function () {
	            return __generator(this, function (_a) {
	                this.logger.verbose("loginRedirect called");
	                return [2 /*return*/, this.acquireTokenRedirect(request || DEFAULT_REQUEST)];
	            });
	        });
	    };
	    /**
	     * Use when initiating the login process via opening a popup window in the user's browser
	     *
	     * @param request
	     *
	     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
	     */
	    PublicClientApplication.prototype.loginPopup = function (request) {
	        this.logger.verbose("loginPopup called");
	        return this.acquireTokenPopup(request || DEFAULT_REQUEST);
	    };
	    /**
	     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
	     *
	     * @param {@link (SilentRequest:type)}
	     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
	     */
	    PublicClientApplication.prototype.acquireTokenSilent = function (request) {
	        return __awaiter(this, void 0, void 0, function () {
	            var account, silentRequest, serverTelemetryManager, silentAuthClient, cachedToken, e_1, tokenRenewalResult, tokenRenewalError_1;
	            return __generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        this.preflightBrowserEnvironmentCheck(exports.InteractionType.Silent);
	                        this.logger.verbose("acquireTokenSilent called");
	                        account = request.account || this.getActiveAccount();
	                        if (!account) {
	                            throw BrowserAuthError.createNoAccountError();
	                        }
	                        silentRequest = __assign(__assign(__assign({}, request), this.initializeBaseRequest(request)), { account: account, forceRefresh: request.forceRefresh || false });
	                        this.emitEvent(exports.EventType.ACQUIRE_TOKEN_START, exports.InteractionType.Silent, request);
	                        _a.label = 1;
	                    case 1:
	                        _a.trys.push([1, 4, , 9]);
	                        serverTelemetryManager = this.initializeServerTelemetryManager(exports.ApiId.acquireTokenSilent_silentFlow, silentRequest.correlationId);
	                        return [4 /*yield*/, this.createSilentFlowClient(serverTelemetryManager, silentRequest.authority)];
	                    case 2:
	                        silentAuthClient = _a.sent();
	                        return [4 /*yield*/, silentAuthClient.acquireCachedToken(silentRequest)];
	                    case 3:
	                        cachedToken = _a.sent();
	                        this.emitEvent(exports.EventType.ACQUIRE_TOKEN_SUCCESS, exports.InteractionType.Silent, cachedToken);
	                        return [2 /*return*/, cachedToken];
	                    case 4:
	                        e_1 = _a.sent();
	                        _a.label = 5;
	                    case 5:
	                        _a.trys.push([5, 7, , 8]);
	                        return [4 /*yield*/, this.acquireTokenByRefreshToken(silentRequest)];
	                    case 6:
	                        tokenRenewalResult = _a.sent();
	                        this.emitEvent(exports.EventType.ACQUIRE_TOKEN_SUCCESS, exports.InteractionType.Silent, tokenRenewalResult);
	                        return [2 /*return*/, tokenRenewalResult];
	                    case 7:
	                        tokenRenewalError_1 = _a.sent();
	                        this.emitEvent(exports.EventType.ACQUIRE_TOKEN_FAILURE, exports.InteractionType.Silent, null, tokenRenewalError_1);
	                        throw tokenRenewalError_1;
	                    case 8: return [3 /*break*/, 9];
	                    case 9: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    return PublicClientApplication;
	}(ClientApplication));
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var stubbedPublicClientApplication = {
	    acquireTokenPopup: function () {
	        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
	    },
	    acquireTokenRedirect: function () {
	        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
	    },
	    acquireTokenSilent: function () {
	        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
	    },
	    getAllAccounts: function () {
	        return [];
	    },
	    getAccountByHomeId: function () {
	        return null;
	    },
	    getAccountByUsername: function () {
	        return null;
	    },
	    getAccountByLocalId: function () {
	        return null;
	    },
	    handleRedirectPromise: function () {
	        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
	    },
	    loginPopup: function () {
	        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
	    },
	    loginRedirect: function () {
	        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
	    },
	    logout: function () {
	        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
	    },
	    ssoSilent: function () {
	        return Promise.reject(BrowserConfigurationAuthError.createStubPcaInstanceCalledError());
	    },
	    addEventCallback: function () {
	        return null;
	    },
	    removeEventCallback: function () {
	        return;
	    },
	    getLogger: function () {
	        throw BrowserConfigurationAuthError.createStubPcaInstanceCalledError();
	    },
	    setLogger: function () {
	        return;
	    },
	    setActiveAccount: function () {
	        return;
	    },
	    getActiveAccount: function () {
	        return null;
	    },
	    initializeWrapperLibrary: function () {
	        return;
	    },
	    setNavigationClient: function () {
	        return;
	    }
	};
	
	/*
	 * Copyright (c) Microsoft Corporation. All rights reserved.
	 * Licensed under the MIT License.
	 */
	var EventMessageUtils = /** @class */ (function () {
	    function EventMessageUtils() {
	    }
	    /**
	     * Gets interaction status from event message
	     * @param message
	     */
	    EventMessageUtils.getInteractionStatusFromEvent = function (message) {
	        switch (message.eventType) {
	            case exports.EventType.LOGIN_START:
	                return exports.InteractionStatus.Login;
	            case exports.EventType.SSO_SILENT_START:
	                return exports.InteractionStatus.SsoSilent;
	            case exports.EventType.ACQUIRE_TOKEN_START:
	                if (message.interactionType === exports.InteractionType.Redirect || message.interactionType === exports.InteractionType.Popup) {
	                    return exports.InteractionStatus.AcquireToken;
	                }
	                break;
	            case exports.EventType.HANDLE_REDIRECT_START:
	                return exports.InteractionStatus.HandleRedirect;
	            case exports.EventType.LOGOUT_START:
	                return exports.InteractionStatus.Logout;
	            case exports.EventType.LOGIN_SUCCESS:
	            case exports.EventType.SSO_SILENT_SUCCESS:
	            case exports.EventType.HANDLE_REDIRECT_END:
	            case exports.EventType.LOGIN_FAILURE:
	            case exports.EventType.SSO_SILENT_FAILURE:
	            case exports.EventType.LOGOUT_FAILURE:
	                return exports.InteractionStatus.None;
	            case exports.EventType.ACQUIRE_TOKEN_SUCCESS:
	            case exports.EventType.ACQUIRE_TOKEN_FAILURE:
	                if (message.interactionType === exports.InteractionType.Redirect || message.interactionType === exports.InteractionType.Popup) {
	                    return exports.InteractionStatus.None;
	                }
	                break;
	        }
	        return null;
	    };
	    return EventMessageUtils;
	}());
	
	exports.AccountEntity = AccountEntity;
	exports.AuthError = AuthError;
	exports.AuthErrorMessage = AuthErrorMessage;
	exports.BrowserAuthError = BrowserAuthError;
	exports.BrowserAuthErrorMessage = BrowserAuthErrorMessage;
	exports.BrowserConfigurationAuthError = BrowserConfigurationAuthError;
	exports.BrowserConfigurationAuthErrorMessage = BrowserConfigurationAuthErrorMessage;
	exports.BrowserUtils = BrowserUtils;
	exports.EventMessageUtils = EventMessageUtils;
	exports.InteractionRequiredAuthError = InteractionRequiredAuthError;
	exports.Logger = Logger;
	exports.NavigationClient = NavigationClient;
	exports.PublicClientApplication = PublicClientApplication;
	exports.StringUtils = StringUtils;
	exports.UrlString = UrlString;
	exports.stubbedPublicClientApplication = stubbedPublicClientApplication;
	//# sourceMappingURL=index.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	var utils = __webpack_require__(59);
	var settle = __webpack_require__(831);
	var cookies = __webpack_require__(834);
	var buildURL = __webpack_require__(418);
	var buildFullPath = __webpack_require__(828);
	var parseHeaders = __webpack_require__(839);
	var isURLSameOrigin = __webpack_require__(837);
	var createError = __webpack_require__(414);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    var fullPath = buildFullPath(config.baseURL, config.url);
	    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request.onreadystatechange = function handleLoad() {
	      if (!request || request.readyState !== 4) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        status: request.status,
	        statusText: request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle browser request cancellation (as opposed to a manual cancellation)
	    request.onabort = function handleAbort() {
	      if (!request) {
	        return;
	      }
	
	      reject(createError('Request aborted', config, 'ECONNABORTED', request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
	      if (config.timeoutErrorMessage) {
	        timeoutErrorMessage = config.timeoutErrorMessage;
	      }
	      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
	        cookies.read(config.xsrfCookieName) :
	        undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (!utils.isUndefined(config.withCredentials)) {
	      request.withCredentials = !!config.withCredentials;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (!requestData) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 412 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 413 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(830);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(59);
	
	/**
	 * Config-specific merge-function which creates a new config-object
	 * by merging two configuration objects together.
	 *
	 * @param {Object} config1
	 * @param {Object} config2
	 * @returns {Object} New object resulting from merging config2 to config1
	 */
	module.exports = function mergeConfig(config1, config2) {
	  // eslint-disable-next-line no-param-reassign
	  config2 = config2 || {};
	  var config = {};
	
	  var valueFromConfig2Keys = ['url', 'method', 'data'];
	  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
	  var defaultToConfig2Keys = [
	    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
	    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
	    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
	    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
	    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
	  ];
	  var directMergeKeys = ['validateStatus'];
	
	  function getMergedValue(target, source) {
	    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
	      return utils.merge(target, source);
	    } else if (utils.isPlainObject(source)) {
	      return utils.merge({}, source);
	    } else if (utils.isArray(source)) {
	      return source.slice();
	    }
	    return source;
	  }
	
	  function mergeDeepProperties(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  }
	
	  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    }
	  });
	
	  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
	
	  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
	    if (!utils.isUndefined(config2[prop])) {
	      config[prop] = getMergedValue(undefined, config2[prop]);
	    } else if (!utils.isUndefined(config1[prop])) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  utils.forEach(directMergeKeys, function merge(prop) {
	    if (prop in config2) {
	      config[prop] = getMergedValue(config1[prop], config2[prop]);
	    } else if (prop in config1) {
	      config[prop] = getMergedValue(undefined, config1[prop]);
	    }
	  });
	
	  var axiosKeys = valueFromConfig2Keys
	    .concat(mergeDeepPropertiesKeys)
	    .concat(defaultToConfig2Keys)
	    .concat(directMergeKeys);
	
	  var otherKeys = Object
	    .keys(config1)
	    .concat(Object.keys(config2))
	    .filter(function filterAxiosKeys(key) {
	      return axiosKeys.indexOf(key) === -1;
	    });
	
	  utils.forEach(otherKeys, mergeDeepProperties);
	
	  return config;
	};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(59);
	var normalizeHeaderName = __webpack_require__(838);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(411);
	  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(411);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Accept');
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  /**
	   * A timeout in milliseconds to abort a request. If set to 0 (default) a
	   * timeout is not created.
	   */
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	  maxBodyLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)))

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(59);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      } else {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    var hashmarkIndex = url.indexOf('#');
	    if (hashmarkIndex !== -1) {
	      url = url.slice(0, hashmarkIndex);
	    }
	
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	
	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(841);
	} else {
	  module.exports = require('./msal-react.cjs.development.js');
	}
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleAgreement = exports.updateAnswers = exports.requestAgreementNo = exports.requestAgreementYes = exports.fetchAgreements = exports.requestAgreementsSuccess = exports.requestAgreementsFailure = exports.requestAgreements = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral([' or '], [' or ']),
	    _templateObject2 = _taggedTemplateLiteral([' and '], [' and ']),
	    _templateObject3 = _taggedTemplateLiteral([','], [',']),
	    _templateObject4 = _taggedTemplateLiteral([':'], [':']);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Api = __webpack_require__(21);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint no-confusing-arrow: 0 */
	
	
	var requestAgreements = exports.requestAgreements = function requestAgreements() {
	  return {
	    type: types.REQUEST_AGREEMENTS
	  };
	};
	
	var requestAgreementsFailure = exports.requestAgreementsFailure = function requestAgreementsFailure(error) {
	  return {
	    type: types.REQUEST_AGREEMENTS_FAILURE,
	    error: error
	  };
	};
	
	var requestAgreementsSuccess = exports.requestAgreementsSuccess = function requestAgreementsSuccess(_ref) {
	  var agreements = _ref.agreements,
	      edID = _ref.edID,
	      label = _ref.label,
	      answers = _ref.answers;
	  return {
	    type: types.REQUEST_AGREEMENTS_SUCCESS,
	    newAgreements: _defineProperty({}, edID, {
	      label: label,
	      agreements: agreements,
	      answers: (0, _lodash.keyBy)(answers, 'AgreementID')
	    })
	  };
	};
	
	var fetchAgreements = exports.fetchAgreements = function fetchAgreements() {
	  return function (dispatch, getState) {
	    dispatch(requestAgreements());
	    var now = new Date().toISOString();
	
	    var _getState = getState(),
	        _getState$loginReduce = _getState.loginReducer.user,
	        EmployeeMasterID = _getState$loginReduce.EmployeeMasterID,
	        token = _getState$loginReduce.token;
	
	    var detailConfig = {
	      entity: 'EmployeeDetailOrg',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: 'Entity/EmployeeDetailID ge ' + EmployeeMasterID + '1 and Entity/EmployeeDetailID le ' + EmployeeMasterID + '9 and (Entity/EmployeeStatus eq \'0\' or (Entity/EmployeeStatus ge \'4\'  and Entity/EmployeeStatus le \'7\')) and Entity/Begda le datetime\'' + now + '\' and Entity/Endda ge datetime\'' + now + '\'',
	        $expand: 'Entity',
	        $select: 'OrgCompanyPositionName,Entity/EmployeeDetailID,Entity/EmployeeGroup,Entity/EmployeeStatus'
	      }
	    };
	    var agreementConfig = {
	      entity: 'HrAgreement',
	      headers: { Authorization: 'Bearer ' + token }
	    };
	
	    var answerConfig = {
	      entity: 'EmployeeDetailAgreement',
	      headers: { Authorization: 'Bearer ' + token }
	    };
	
	    (0, _Api.listWM)(detailConfig).then(function (details) {
	      var pos = (0, _lodash.map)(details.data, function (x) {
	        return _extends({ label: x.OrgCompanyPositionName }, x.Entity);
	      });
	      if ((0, _lodash.isEmpty)(pos)) throw new Error('Missing EmployeeDetailOrg');
	      (0, _lodash.forEach)(pos, function (p) {
	        (0, _Api.list)(_extends({}, agreementConfig, {
	          params: {
	            $filter: 'Active eq true and (EmployeeStatus eq \'' + p.EmployeeStatus + '\' or EmployeeStatus eq \'0\') and (EmployeeGroup eq \'' + p.EmployeeGroup + '\' or EmployeeGroup eq \'0\')'
	          }
	        })).then(function (agreements) {
	          var agreementIDs = (0, _lodash.map)(agreements.data, function (x) {
	            return x.HrAgreementID;
	          });
	
	          if (!agreementIDs.length) {
	            return dispatch(requestAgreementsSuccess({
	              edID: p.EmployeeDetailID,
	              agreements: agreements.data,
	              answers: [],
	              label: p.label
	            }));
	          }
	
	          return (0, _Api.list)(_extends({}, answerConfig, {
	            params: {
	              $filter: '(' + (0, _lodash.map)(agreementIDs, function (id) {
	                return 'AgreementID eq ' + id;
	              }).join(_templateObject) + ') and Endda eq DateTime\'9999-12-31T00:00:00\' and EmployeeDetailID eq ' + p.EmployeeDetailID
	            }
	          })).then(function (answers) {
	            return dispatch(requestAgreementsSuccess({
	              edID: p.EmployeeDetailID,
	              agreements: agreements.data,
	              answers: answers.data,
	              label: p.label
	            }));
	          }).catch(function (err) {
	            return dispatch(requestAgreementsFailure(err));
	          });
	        }).catch(function (err) {
	          return dispatch(requestAgreementsFailure(err));
	        });
	      });
	    }).catch(function (err) {
	      return dispatch(requestAgreementsFailure(err));
	    });
	  };
	};
	
	var requestAgreementYes = exports.requestAgreementYes = function requestAgreementYes() {
	  return {
	    type: types.REQUEST_AGREEMENT_YES
	  };
	};
	
	var requestAgreementNo = exports.requestAgreementNo = function requestAgreementNo() {
	  return {
	    type: types.REQUEST_AGREEMENT_NO
	  };
	};
	
	var updateAnswers = exports.updateAnswers = function updateAnswers(newAnswer) {
	  return {
	    type: types.UPDATE_AGREEMENT_ANSWERS,
	    newAnswer: newAnswer
	  };
	};
	
	var cleanEntity = function cleanEntity(e) {
	  return (0, _lodash.omit)(e, ['CreateDate', 'CreateUserID', 'ModifyDate', 'ModifyUserID', 'RowVersion', 'KeyID', 'UniqueID', 'EntityID']);
	};
	
	var checkAndUpload = function checkAndUpload(_ref2, cb) {
	  var file = _ref2.file,
	      fileType = _ref2.fileType;
	  return function (dispatch, getState) {
	    /** If there is a file we need to start by uploading
	     * it so we can connect it with the answer.
	     */
	    var _getState2 = getState(),
	        _getState2$loginReduc = _getState2.loginReducer.user,
	        token = _getState2$loginReduc.token,
	        EmployeeMasterID = _getState2$loginReduc.EmployeeMasterID;
	
	    if (file && fileType) {
	      var reader = new FileReader();
	      reader.onload = function () {
	        var FileSource = reader.result.substring(reader.result.indexOf(',') + 1);
	        var Name = file.name.substring(0, file.name.indexOf('.'));
	        var Extension = file.name.substring(file.name.indexOf('.'));
	        var AddDate = new Date().toISOString();
	        var config = {
	          entity: 'FileRepository',
	          headers: { Authorization: 'Bearer ' + token },
	          data: {
	            AddDate: AddDate,
	            EntityType: 2,
	            Entity_ID: EmployeeMasterID,
	            FileSource: FileSource,
	            ObjectDocumentType: fileType,
	            Name: Name,
	            Extension: Extension
	          }
	        };
	
	        return (0, _Api.create)(config).then(function (createResult) {
	          cb(createResult.data);
	        }).catch(function (error) {
	          return dispatch(requestAgreementsFailure(error));
	        });
	      };
	      reader.onerror = function (e) {
	        return dispatch(requestAgreementsFailure(e));
	      };
	      reader.readAsDataURL(file);
	    } else {
	      cb(0);
	    }
	  };
	};
	
	var updateSpecialEntity = function updateSpecialEntity(entityInfo, fields, EmployeeDetailID, cb) {
	  return function (dispatch, getState) {
	    /** Will not allow changing of entities outside of Employee NS */
	    if (entityInfo.entity.indexOf('Employee') !== 0) {
	      return cb();
	    }
	
	    var _getState3 = getState(),
	        _getState3$loginReduc = _getState3.loginReducer.user,
	        token = _getState3$loginReduc.token,
	        EmployeeMasterID = _getState3$loginReduc.EmployeeMasterID;
	
	    var now = new Date().toISOString();
	
	    /** Fetch and check if there is a special entity for the user */
	    /** Check if the entity is employee master or detail based */
	    var existingConfig = {
	      headers: { Authorization: 'Bearer ' + token },
	      entity: entityInfo.entity
	    };
	    if ((0, _lodash.startsWith)(entityInfo.entity, 'EmployeeMaster')) {
	      existingConfig.params = {
	        $filter: entityInfo.fields.length ?
	        // `${map(entityInfo.fields, f => `${f[0]} eq ${f[1]}`).join` and `} and EmployeeMasterID eq ${EmployeeMasterID} and Endda ge DateTime'${now}' and Begda le DateTime'${now}'` :
	        (0, _lodash.map)(entityInfo.fields, function (f) {
	          return (0, _lodash.endsWith)(f[0], 'ID') ? f[0] + ' eq ' + f[1] : f[0] + ' eq ' + f[1];
	        }).join(_templateObject2) + ' and EmployeeMasterID eq ' + EmployeeMasterID + ' and Endda ge DateTime\'' + now + '\' and Begda le DateTime\'' + now + '\'' :
	        // `${map(entityInfo.fields, f => (endsWith(f[0], 'ID') || endsWith(f[0], 'Type')) ? `${f[0]} eq '${f[1]}'` : `${f[0]} eq ${f[1]}`).join` and `} and EmployeeDetailID eq ${EmployeeDetailID} and Endda ge DateTime'${now}' and Begda le DateTime'${now}'` :
	        'EmployeeDetailID eq ' + EmployeeDetailID + ' and Endda ge DateTime\'' + now + '\' and Begda le DateTime\'' + now + '\''
	      };
	    } else {
	      existingConfig.params = {
	        $filter: entityInfo.fields.length ?
	        // `${map(entityInfo.fields, f => `${f[0]} eq ${f[1]}`).join` and `} and EmployeeDetailID eq ${EmployeeDetailID} and Endda ge DateTime'${now}' and Begda le DateTime'${now}'` :
	        (0, _lodash.map)(entityInfo.fields, function (f) {
	          return (0, _lodash.endsWith)(f[0], 'ID') ? f[0] + ' eq \'' + f[1] + '\'' : f[0] + ' eq ' + f[1];
	        }).join(_templateObject2) + ' and EmployeeDetailID eq ' + EmployeeDetailID + ' and Endda ge DateTime\'' + now + '\' and Begda le DateTime\'' + now + '\'' :
	        // `${map(entityInfo.fields, f => (endsWith(f[0], 'ID') || endsWith(f[0], 'Type')) ? `${f[0]} eq '${f[1]}'` : `${f[0]} eq ${f[1]}`).join` and `} and EmployeeDetailID eq ${EmployeeDetailID} and Endda ge DateTime'${now}' and Begda le DateTime'${now}'` :
	        'EmployeeDetailID eq ' + EmployeeDetailID + ' and Endda ge DateTime\'' + now + '\' and Begda le DateTime\'' + now + '\''
	      };
	    }
	
	    return (0, _Api.list)(existingConfig).then(function (existing) {
	      if (existing.data.length) {
	        var oldEntity = cleanEntity(existing.data[0]);
	        var configUpdate = {
	          headers: { Authorization: 'Bearer ' + token },
	          entity: entityInfo.entity,
	          data: _extends({}, oldEntity, fields)
	        };
	
	        return (0, _Api.save)(configUpdate).then(cb);
	      }
	      /** Return here if there were no entries to update. */
	      return cb();
	    });
	  };
	};
	
	var handleAgreement = exports.handleAgreement = function handleAgreement(AgreementID, EmployeeDetailID, file, UploadType) {
	  return function (dispatch, getState) {
	    var _getState4 = getState(),
	        _getState4$loginReduc = _getState4.loginReducer.user,
	        token = _getState4$loginReduc.token,
	        EmployeeMasterID = _getState4$loginReduc.EmployeeMasterID,
	        agreementsByID = _getState4.AgreementsReducer.agreementsByID;
	
	    var headers = { Authorization: 'Bearer ' + token };
	    var agreementInfo = agreementsByID[EmployeeDetailID];
	    var agreement = agreementInfo && (0, _lodash.find)(agreementInfo.agreements, ['HrAgreementID', AgreementID]);
	    if (!agreementInfo || !agreement) {
	      return dispatch(requestAgreementsFailure({ Message: 'Error in agreements, no info' }));
	    }
	
	    return dispatch(checkAndUpload({ file: file, fileType: UploadType }, function (Document) {
	      /** Check if there is already an answer to the agreement that is YES */
	      var now = new Date().toISOString();
	
	      var newAnswer = agreementInfo.answers && agreementInfo.answers[AgreementID] && agreementInfo.answers[AgreementID].EmployeeDetailAgreementAnswer === 1 ? 0 : 1;
	
	      if (agreementInfo.answers && agreementInfo.answers[AgreementID]) {
	        var existingAnswer = agreementInfo.answers[AgreementID];
	
	        var configUpdateOld = {
	          headers: headers,
	          entity: 'EmployeeDetailAgreement',
	          data: _extends({}, cleanEntity(existingAnswer), {
	            EmployeeDetailEndda: now,
	            Endda: now
	          })
	        };
	        /** First we need to outdate the old answer */
	        (0, _Api.save)(configUpdateOld).catch(function (err) {
	          return requestAgreementsFailure(err);
	        });
	      }
	      /** Check if there is a special entity we need to update */
	      if (agreement.HrAgreementEntity && agreement.HrAgreementValue && ((0, _lodash.includes)(agreement.HrAgreementValue, 'ID') || (0, _lodash.includes)(agreement.HrAgreementValue, 'Type'))) {
	        /** We check for older entities and outdate them */
	        var entity = agreement.HrAgreementEntity;
	        var fields = (0, _lodash.map)((0, _lodash.replace)(agreement.HrAgreementValue, ' ', '').split(_templateObject3), function (x) {
	          return x.split(_templateObject4);
	        });
	        var newFields = { Endda: now };
	        dispatch(updateSpecialEntity({ entity: entity, fields: fields }, newFields, EmployeeDetailID, function () {
	          /** Done updating the entity */
	          /** Create a new special entity if we are agreeing */
	          if (newAnswer === 1) {
	            var specialFields = {};
	            fields.forEach(function (x) {
	              specialFields[x[0]] = x[1];
	            });
	            var configEntity = {
	              headers: headers,
	              entity: entity,
	              data: _extends({
	                Begda: agreement.HrAgreementBegda || now,
	                Endda: agreement.HrAgreementEndda || '9999-12-31T00:00:00'
	              }, specialFields)
	            };
	            if ((0, _lodash.startsWith)(entity, 'EmployeeMaster')) {
	              configEntity.data.EmployeeMasterID = EmployeeMasterID;
	            } else {
	              configEntity.data.EmployeeDetailID = EmployeeDetailID;
	            }
	            (0, _Api.create)(configEntity).catch(function (err) {
	              return requestAgreementsFailure(err);
	            });
	          }
	        }));
	      }
	
	      var configNewAnswer = {
	        headers: headers,
	        entity: 'EmployeeDetailAgreement',
	        data: {
	          EmployeeDetailID: EmployeeDetailID,
	          EmployeeMasterID: EmployeeMasterID,
	          EmployeeDetailAgreementAnswer: newAnswer,
	          AgreementID: AgreementID,
	          DocumentID: Document.DocumentId,
	          Begda: now,
	          Endda: '9999-12-31T00:00:00'
	        }
	      };
	
	      /** Add the new answer */
	      (0, _Api.create)(configNewAnswer).then(function (res) {
	        dispatch(fetchAgreements());
	        var configMail = {
	          headers: headers,
	          method: 'POST',
	          url: '/api/EmployeeDetailAgreementEmail/SendEmailNotification',
	          data: _extends({}, cleanEntity(res.data))
	        };
	        (0, _Api.custom)(configMail);
	      });
	
	      return newAnswer === 1 ? dispatch(requestAgreementYes()) : dispatch(requestAgreementNo());
	    }));
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestAgreements, 'requestAgreements', 'D:/a/1/s/src/web/employee/src/actions/Agreements.js');
	
	  __REACT_HOT_LOADER__.register(requestAgreementsFailure, 'requestAgreementsFailure', 'D:/a/1/s/src/web/employee/src/actions/Agreements.js');
	
	  __REACT_HOT_LOADER__.register(requestAgreementsSuccess, 'requestAgreementsSuccess', 'D:/a/1/s/src/web/employee/src/actions/Agreements.js');
	
	  __REACT_HOT_LOADER__.register(fetchAgreements, 'fetchAgreements', 'D:/a/1/s/src/web/employee/src/actions/Agreements.js');
	
	  __REACT_HOT_LOADER__.register(requestAgreementYes, 'requestAgreementYes', 'D:/a/1/s/src/web/employee/src/actions/Agreements.js');
	
	  __REACT_HOT_LOADER__.register(requestAgreementNo, 'requestAgreementNo', 'D:/a/1/s/src/web/employee/src/actions/Agreements.js');
	
	  __REACT_HOT_LOADER__.register(updateAnswers, 'updateAnswers', 'D:/a/1/s/src/web/employee/src/actions/Agreements.js');
	
	  __REACT_HOT_LOADER__.register(cleanEntity, 'cleanEntity', 'D:/a/1/s/src/web/employee/src/actions/Agreements.js');
	
	  __REACT_HOT_LOADER__.register(checkAndUpload, 'checkAndUpload', 'D:/a/1/s/src/web/employee/src/actions/Agreements.js');
	
	  __REACT_HOT_LOADER__.register(updateSpecialEntity, 'updateSpecialEntity', 'D:/a/1/s/src/web/employee/src/actions/Agreements.js');
	
	  __REACT_HOT_LOADER__.register(handleAgreement, 'handleAgreement', 'D:/a/1/s/src/web/employee/src/actions/Agreements.js');
	}();

	;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submitEvaluation = exports.requestSubmitEvaluationFailure = exports.requestSubmitEvaluationSuccess = exports.requestSubmitEvaluation = exports.saveEvaluation = exports.requestSaveEvaluationFailure = exports.requestSaveEvaluationSuccess = exports.requestSaveEvaluation = exports.fetchEvaluation = exports.initAnswers = exports.requestEvaluationFailure = exports.requestEvaluationSuccess = exports.requestEvaluation = exports.fetchEvaluations = exports.requestEvaluationsFailure = exports.requestEvaluationsSuccess = exports.requestEvaluations = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['-'], ['-']);
	
	exports.sortChildren = sortChildren;
	exports.fetchOptions = fetchOptions;
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _lodash = __webpack_require__(8);
	
	var _Api = __webpack_require__(21);
	
	var _reapop = __webpack_require__(44);
	
	var _xSelect = __webpack_require__(188);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var requestEvaluations = exports.requestEvaluations = function requestEvaluations() {
	  return {
	    type: types.COURSE_EVAL_LIST_REQUEST
	  };
	};
	
	var requestEvaluationsSuccess = exports.requestEvaluationsSuccess = function requestEvaluationsSuccess(evaluations) {
	  return {
	    type: types.COURSE_EVAL_LIST_SUCCESS,
	    evaluations: evaluations
	  };
	};
	
	var requestEvaluationsFailure = exports.requestEvaluationsFailure = function requestEvaluationsFailure(error) {
	  return {
	    type: types.COURSE_EVAL_LIST_FAILURE,
	    evaluationsError: error
	  };
	};
	
	var fetchEvaluations = exports.fetchEvaluations = function fetchEvaluations() {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, _getState$loginReduce, EmployeeMasterID, token, config, evaluations;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              dispatch(requestEvaluations());
	
	              _getState = getState(), _getState$loginReduce = _getState.loginReducer.user, EmployeeMasterID = _getState$loginReduce.EmployeeMasterID, token = _getState$loginReduce.token;
	              config = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: '/kjarni/api/v2/CourseEvaluations/GetEmployeeEvaluations(employeeMasterId=' + EmployeeMasterID + ')'
	              };
	              _context.t0 = _lodash.get;
	              _context.next = 7;
	              return (0, _Api.custom)(config);
	
	            case 7:
	              _context.t1 = _context.sent;
	              _context.t2 = [];
	              evaluations = (0, _context.t0)(_context.t1, 'data.value', _context.t2);
	
	              dispatch(requestEvaluationsSuccess(evaluations));
	
	              _context.next = 16;
	              break;
	
	            case 13:
	              _context.prev = 13;
	              _context.t3 = _context['catch'](0);
	
	              dispatch(requestEvaluationsFailure(_context.t3));
	
	            case 16:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 13]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var requestEvaluation = exports.requestEvaluation = function requestEvaluation(CourseAttendeeID) {
	  return {
	    type: types.COURSE_EVAL_REQUEST,
	    CourseAttendeeID: CourseAttendeeID
	  };
	};
	
	var requestEvaluationSuccess = exports.requestEvaluationSuccess = function requestEvaluationSuccess(_ref2) {
	  var CourseAttendee = _ref2.CourseAttendee,
	      CourseEvaluation = _ref2.CourseEvaluation,
	      CourseEvaluationAnswers = _ref2.CourseEvaluationAnswers;
	  return {
	    type: types.COURSE_EVAL_SUCCESS,
	    CourseAttendee: CourseAttendee,
	    CourseEvaluation: CourseEvaluation,
	    CourseEvaluationAnswers: CourseEvaluationAnswers
	  };
	};
	
	var requestEvaluationFailure = exports.requestEvaluationFailure = function requestEvaluationFailure(evaluationError) {
	  return {
	    type: types.COURSE_EVAL_FAILURE,
	    evaluationError: evaluationError
	  };
	};
	
	function sortChildren(obj) {
	  if (obj.Children) {
	    return _extends({}, obj.Entity, obj, { Children: (0, _lodash.orderBy)(obj.Children.map(sortChildren), ['Order'], ['asc']) });
	  }
	  return _extends({}, obj.Entity, obj);
	}
	
	var flattenChildren = function flattenChildren(obj) {
	  if (obj.Children) {
	    return [obj].concat(_toConsumableArray((0, _lodash.flattenDeep)(obj.Children.map(flattenChildren))));
	  }
	  return obj;
	};
	
	function fetchOptions(qae, token) {
	  var QAInputID = qae.QAInputID;
	
	  var config = {
	    entity: 'QAInput',
	    entityID: QAInputID,
	    headers: { Authorization: 'Bearer ' + token }
	  };
	
	  return (0, _Api.read)(config).then(function (_ref3) {
	    var data = _ref3.data;
	    return _extends({}, qae, { QAInput: data });
	  });
	}
	
	var initAnswers = exports.initAnswers = function initAnswers(_ref4) {
	  var CourseAttendee = _ref4.CourseAttendee,
	      CourseEvaluation = _ref4.CourseEvaluation;
	  return function (dispatch, getState) {
	    var _getState2 = getState(),
	        token = _getState2.loginReducer.user.token;
	
	    if (CourseAttendee.EvaluationRootAnswerID) {
	      // The CourseAttendee has a root answer ID
	      var answerConf = {
	        entity: 'QAAnswer',
	        headers: { Authorization: 'Bearer ' + token },
	        data: (0, _xSelect.xSelectSingle)([{
	          field: 'RootAnswerID',
	          value: CourseAttendee.EvaluationRootAnswerID,
	          relation: 'eq'
	        }])
	      };
	      (0, _Api.list)(answerConf).then(function (_ref5) {
	        var data = _ref5.data;
	        return dispatch(requestEvaluationSuccess({
	          CourseAttendee: CourseAttendee,
	          CourseEvaluation: CourseEvaluation,
	          CourseEvaluationAnswers: data
	        }));
	      }).catch(function (error) {
	        return dispatch(requestEvaluationFailure(error, CourseAttendee.CourseAttendeeID));
	      });
	    } else {
	      // The CourseAttendee does not ahve a root answer ID
	      var createRoot = {
	        entity: 'QAAnswer',
	        headers: { Authorization: 'Bearer ' + token },
	        data: { QAElementID: CourseEvaluation.QAElementID }
	      };
	      (0, _Api.create)(createRoot).then(function (_ref6) {
	        var data = _ref6.data;
	
	        var saveAttendee = {
	          entity: 'CourseAttendee',
	          headers: { Authorization: 'Bearer ' + token },
	          data: _extends({}, CourseAttendee.Entity, {
	            EvaluationRootAnswerID: data.QAAnswerID
	          })
	        };
	        (0, _Api.save)(saveAttendee).then(function (NewCourseAttendee) {
	          var groups = CourseEvaluation.QAElements.filter(function (e) {
	            return e.QAElementType === 2;
	          });
	
	          /* To initialize the answers correctly we need to create QAAnswers for
	          all the groups in the QAElement tree. This is done here so that it is
	          not required on submit or save of the form */
	          var answerGroups = groups.map(function (_ref7) {
	            var QAElementID = _ref7.QAElementID,
	                Label = _ref7.Label,
	                Order = _ref7.Order;
	            return (0, _Api.create)({
	              entity: 'QAAnswer',
	              headers: { Authorization: 'Bearer ' + token },
	              data: {
	                QAAnswerParentID: data.QAAnswerID,
	                RootAnswerID: data.QAAnswerID,
	                QAElementID: QAElementID,
	                QAAnswerValue: Label,
	                QAAnswerText: Label,
	                QAAnswerOrder: Order
	              }
	            });
	          });
	          Promise.all(answerGroups).then(function (CEAnswers) {
	            return (
	              // dispatch(setManagerAnswers(PMAppraisalID, { RootAnswerID: managerRootAnswerID, QAAnswers: ans.filter(x => x.RootAnswerID === managerRootAnswerID) }));
	              // dispatch(requestAppraisalByIdSuccess({ ...appraisal, ...newAppraisal, Entity: newAppraisal }));
	              dispatch(requestEvaluationSuccess({
	                CourseAttendee: _extends({}, CourseAttendee, NewCourseAttendee.data, {
	                  Entity: NewCourseAttendee.data
	                }),
	                CourseEvaluation: CourseEvaluation,
	                CourseEvaluationAnswers: CEAnswers.map(function (x) {
	                  return _extends({}, x.data);
	                })
	              }))
	            );
	          }).catch(function (error) {
	            return dispatch(requestEvaluationFailure(error, CourseAttendee.CourseAttendeeID));
	          });
	        })
	        /*
	        dispatch(requestEvaluationSuccess({
	        CourseAttendee: {
	          ...CourseAttendee,
	          ...NewCourseAttendee,
	          Entity: NewCourseAttendee,
	        },
	        CourseEvaluation,
	        CourseEvaluationAnswers: [],
	        })),
	        */
	        .catch(function (error) {
	          return dispatch(requestEvaluationFailure(error, CourseAttendee.CourseAttendeeID));
	        });
	      }).catch(function (error) {
	        return dispatch(requestEvaluationFailure(error, CourseAttendee.CourseAttendeeID));
	      });
	    }
	  };
	};
	
	var fetchEvaluation = exports.fetchEvaluation = function fetchEvaluation(CourseAttendeeID) {
	  return function () {
	    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	      var _getState3, _getState3$loginReduc, EmployeeMasterID, token, configAttendee, _ref9, CourseAttendee, CourseID, config, _ref10, Course, evalConfig, _ref11, CourseEvaluation, configElement, _ref12, QAElement, initQAElements, QAElements;
	
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	
	              dispatch(requestEvaluation(CourseAttendeeID));
	              _getState3 = getState(), _getState3$loginReduc = _getState3.loginReducer.user, EmployeeMasterID = _getState3$loginReduc.EmployeeMasterID, token = _getState3$loginReduc.token;
	              configAttendee = {
	                entity: 'CourseAttendee',
	                entityID: CourseAttendeeID,
	                headers: { Authorization: 'Bearer ' + token }
	              };
	              _context2.next = 6;
	              return (0, _Api.read)(configAttendee);
	
	            case 6:
	              _ref9 = _context2.sent;
	              CourseAttendee = _ref9.data;
	              CourseID = (0, _lodash.get)(CourseAttendee, 'CourseID');
	
	              if (!(!CourseAttendee || !CourseID)) {
	                _context2.next = 11;
	                break;
	              }
	
	              return _context2.abrupt('return', dispatch(requestEvaluationFailure(new Error('Þessi námskeiðsskráning er ekki til.'), CourseAttendeeID)));
	
	            case 11:
	              config = {
	                entity: 'Course',
	                entityID: CourseID,
	                headers: { Authorization: 'Bearer ' + token }
	              };
	              _context2.next = 14;
	              return (0, _Api.read)(config);
	
	            case 14:
	              _ref10 = _context2.sent;
	              Course = _ref10.data;
	
	              if (Course.CourseEvaluationID) {
	                _context2.next = 18;
	                break;
	              }
	
	              return _context2.abrupt('return', dispatch(requestEvaluationFailure(new Error('Ekkert námskeiðsmat er skráð á þetta námskeið.'), CourseAttendeeID)));
	
	            case 18:
	              if (!(CourseAttendee.EmployeeMasterID !== EmployeeMasterID)) {
	                _context2.next = 20;
	                break;
	              }
	
	              return _context2.abrupt('return', dispatch(requestEvaluationFailure(new Error('Þetta er ekki þín námskeiðsskráning.'), CourseAttendeeID)));
	
	            case 20:
	              evalConfig = {
	                entity: 'CourseEvaluation',
	                entityID: Course.CourseEvaluationID,
	                headers: { Authorization: 'Bearer ' + token }
	              };
	              _context2.next = 23;
	              return (0, _Api.read)(evalConfig);
	
	            case 23:
	              _ref11 = _context2.sent;
	              CourseEvaluation = _ref11.data;
	
	              if (CourseEvaluation.CourseEvaluationID) {
	                _context2.next = 27;
	                break;
	              }
	
	              return _context2.abrupt('return', dispatch(requestEvaluationFailure(new Error('Námskeiðsmatið á þessari námskeiðsskráning er ekki til.'), CourseAttendeeID)));
	
	            case 27:
	              if (CourseEvaluation.QAElementID) {
	                _context2.next = 29;
	                break;
	              }
	
	              return _context2.abrupt('return', dispatch(requestEvaluationFailure(new Error('Námskeiðsmatið er ekki með neinar spurningar.'), CourseAttendeeID)));
	
	            case 29:
	              configElement = {
	                entity: 'QAElement',
	                entityID: CourseEvaluation.QAElementID,
	                headers: { Authorization: 'Bearer ' + token }
	              };
	              _context2.next = 32;
	              return (0, _Api.readWM)(configElement);
	
	            case 32:
	              _ref12 = _context2.sent;
	              QAElement = _ref12.data;
	
	              if (QAElement) {
	                _context2.next = 36;
	                break;
	              }
	
	              return _context2.abrupt('return', dispatch(requestEvaluationFailure(new Error('Námskeiðsmatið er ekki með neinar spurningar.'), CourseAttendeeID)));
	
	            case 36:
	              initQAElements = flattenChildren(sortChildren(QAElement));
	              QAElements = initQAElements.map(function (e) {
	                if (e.QAInput) {
	                  return _extends({}, e, e.Entity, { QAInput: _extends({}, e.QAInput.Entity, e.QAInput) });
	                }
	                return _extends({}, e, e.Entity);
	              });
	              return _context2.abrupt('return', dispatch(initAnswers({
	                CourseAttendee: _extends({}, CourseAttendee, {
	                  CourseName: Course.CourseName,
	                  Entity: CourseAttendee
	                }),
	                CourseEvaluation: _extends({}, CourseEvaluation, {
	                  QAElement: sortChildren(QAElement),
	                  QAElements: QAElements
	                })
	              })));
	
	            case 41:
	              _context2.prev = 41;
	              _context2.t0 = _context2['catch'](0);
	              return _context2.abrupt('return', dispatch(requestEvaluationFailure(_context2.t0, CourseAttendeeID)));
	
	            case 44:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 41]]);
	    }));
	
	    return function (_x3, _x4) {
	      return _ref8.apply(this, arguments);
	    };
	  }();
	};
	
	var requestSaveEvaluation = exports.requestSaveEvaluation = function requestSaveEvaluation() {
	  return {
	    type: types.COURSE_EVAL_SAVE_REQUEST
	  };
	};
	var requestSaveEvaluationSuccess = exports.requestSaveEvaluationSuccess = function requestSaveEvaluationSuccess() {
	  return {
	    type: types.COURSE_EVAL_SAVE_SUCCESS
	  };
	};
	var requestSaveEvaluationFailure = exports.requestSaveEvaluationFailure = function requestSaveEvaluationFailure(error) {
	  return {
	    type: types.COURSE_EVAL_SAVE_FAILURE,
	    evaluationError: error
	  };
	};
	
	var convertFormData = function convertFormData(formData, CourseAttendee, CourseEvaluation, CourseEvaluationAnswers) {
	  /* NOTE:
	      CHECKBOX
	        * get QAAnswerValue from redux form value
	        * get QAAnswerText from redux form name last group
	      NOTE: ATTACHMENT questions put on hold!
	      ATTACHMENT
	        * on load of file send to repo
	        * QAAnswerText is the file name
	        * QAAnswerValue is the GUID of the file returned from repo
	      TEXT_FIELDS
	        * QAAnswerValue and QAAnswerText are set to the rf value
	      DATE
	        * set QAAnswerText to human version
	        * set QAAnswerValue to datetime stamp
	      RADIO AND SCALE
	        * set QAAnswerText to the option label
	        * set QAAnswerValue to QAInputOptionID or HrQualificationScaleEntryID
	  */
	
	  var QAElements = CourseEvaluation.QAElements;
	
	  var RootAnswerID = CourseAttendee.EvaluationRootAnswerID;
	
	  /* Map through all the fields submited through the Redux form */
	  var ansrs = (0, _lodash.map)((0, _lodash.keys)(formData), function (key) {
	    if ((0, _lodash.startsWith)(key, 'COMMENT')) {
	      return null;
	    }
	    var QAAnswerValue = formData[key];
	    /* Split the key into its components
	    example: '345-34045'
	    becomes ['345', '34045'] */
	    var qaKeys = key.split(_templateObject);
	
	    /* We use the Redux field names to identify information about the elements */
	    var QAInputAnswerType = Number(qaKeys[0]);
	    var QAElementID = Number(qaKeys[1]);
	    var QAInputOptionLabel = qaKeys[2];
	
	    /* QAElement information */
	
	    var _find = (0, _lodash.find)(QAElements, ['QAElementID', QAElementID]),
	        QAInput = _find.QAInput,
	        Order = _find.Order,
	        Level = _find.Level,
	        QAElementParentID = _find.QAElementParentID,
	        AllowComment = _find.AllowComment;
	
	    var option = QAInputAnswerType === 6 ? (0, _lodash.find)(QAInput.HrQualificationScaleEntries, ['HrQualificationScaleEntryID', QAAnswerValue]) : (0, _lodash.find)(QAInput.QAInputOptions, ['QAInputOptionID', QAAnswerValue]);
	
	    var checkBoxText = atob(QAInputOptionLabel || '');
	    var optionText = option ? option.HrQualificationScaleEntryName || option.QAInputOptionLabel : '';
	    var QAAnswerText = checkBoxText || optionText || QAAnswerValue;
	    var QAAnswerComment = null;
	
	    if (AllowComment) {
	      QAAnswerComment = formData['COMMENT-' + QAInputAnswerType + '-' + QAElementID];
	    }
	
	    /* If the Element is higher than 2 the Element is inside a group, then
	    we have to set the correct QAAnswerParentID. */
	    var QAAnswerParent = Level <= 2 ? RootAnswerID : (0, _lodash.find)(CourseEvaluationAnswers, ['QAElementID', QAElementParentID]);
	    var QAAnswerParentID = QAAnswerParent.QAAnswerID;
	
	    var existing = void 0;
	    var existingValue = void 0;
	    var existingComment = void 0;
	    var existingID = void 0;
	    var existingAnswers = CourseEvaluationAnswers.filter(function (ans) {
	      return ans.QAElementID === QAElementID;
	    });
	    // Check existingAnswers to see if we are adding a new answer or updating one.
	    if (existingAnswers.length) {
	      /* If we have a checkbox question we have to see if
	        this option alread has an answer */
	      if (QAInputAnswerType === 3) {
	        existing = (0, _lodash.find)(existingAnswers, ['QAAnswerText', atob(QAInputOptionLabel)]);
	      } else {
	        existing = existingAnswers[0];
	      }
	      existingValue = existing && existing.QAAnswerValue;
	      existingID = existing && existing.QAAnswerID;
	      existingComment = existing && existing.QAAnswerComment;
	    }
	
	    if ((0, _lodash.isEqual)(existingValue, QAAnswerValue) && (0, _lodash.isEqual)(existingComment, QAAnswerComment)) {
	      return undefined;
	    }
	
	    var def = {
	      QAAnswerParentID: QAAnswerParentID,
	      QAElementID: QAElementID,
	      QAAnswerValue: QAAnswerValue,
	      QAAnswerText: QAAnswerText,
	      QAAnswerComment: QAAnswerComment,
	      QAAnswerOrder: Order,
	      RootAnswerID: RootAnswerID
	    };
	
	    if (existingID) {
	      return _extends({ QAAnswerID: existingID }, def);
	    }
	
	    return def;
	  });
	
	  return (0, _lodash.compact)(ansrs);
	};
	
	var saveEvaluation = exports.saveEvaluation = function saveEvaluation(formData, CourseAttendeeID) {
	  var isSubmit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	  return function (dispatch, getState) {
	    var _getState4 = getState(),
	        token = _getState4.loginReducer.user.token,
	        _getState4$CourseEval = _getState4.CourseEvaluationReducer.evaluationById[CourseAttendeeID],
	        CourseAttendee = _getState4$CourseEval.CourseAttendee,
	        CourseEvaluation = _getState4$CourseEval.CourseEvaluation,
	        CourseEvaluationAnswers = _getState4$CourseEval.CourseEvaluationAnswers;
	
	    dispatch(requestSaveEvaluation(CourseAttendee.CourseAttendeeID));
	    var QAAnswers = convertFormData(formData, CourseAttendee, CourseEvaluation, CourseEvaluationAnswers);
	    return Promise.all(QAAnswers.map(function (data) {
	      if (data.QAAnswerID) {
	        return (0, _Api.save)({ entity: 'QAAnswer', data: data, headers: { Authorization: 'Bearer ' + token } });
	      }
	      return (0, _Api.create)({ entity: 'QAAnswer', data: data, headers: { Authorization: 'Bearer ' + token } });
	    })).then(function () {
	      // TODO: Save CourseAttendee
	      var status = {
	        entity: 'CourseAttendee',
	        headers: { Authorization: 'Bearer ' + token },
	        data: _extends({}, (0, _lodash.omit)(CourseAttendee, ['CreateDate', 'CreateUserID', 'ModifyDate', 'ModifyUserID', 'RowVersion', 'KeyID', 'UniqueID', 'EntityID']), {
	          EvaluationStatus: isSubmit ? 2 : 1
	        })
	      };
	      (0, _Api.save)(status).then(function () {
	        dispatch(requestSaveEvaluationSuccess());
	        dispatch((0, _reapop.addNotification)({
	          title: 'Vistað',
	          message: 'Námskeiðsmat hefur verið vistað',
	          status: 'success',
	          dismissible: true,
	          dismissAfter: 4000
	        }));
	        if (isSubmit) {
	          dispatch((0, _reactRouterRedux.replace)('/'));
	        } else {
	          dispatch(fetchEvaluation(CourseAttendeeID));
	        }
	      }).catch(function (error) {
	        return dispatch(requestSaveEvaluationFailure(error));
	      });
	    }).catch(function (error) {
	      return dispatch(requestSaveEvaluationFailure(error));
	    });
	  };
	};
	
	var requestSubmitEvaluation = exports.requestSubmitEvaluation = function requestSubmitEvaluation() {
	  return {
	    type: types.COURSE_EVAL_SUBMIT_REQUEST
	  };
	};
	var requestSubmitEvaluationSuccess = exports.requestSubmitEvaluationSuccess = function requestSubmitEvaluationSuccess() {
	  return {
	    type: types.COURSE_EVAL_SUBMIT_SUCCESS
	  };
	};
	var requestSubmitEvaluationFailure = exports.requestSubmitEvaluationFailure = function requestSubmitEvaluationFailure(error) {
	  return {
	    type: types.COURSE_EVAL_SUBMIT_FAILURE,
	    evaluationError: error
	  };
	};
	
	var submitEvaluation = exports.submitEvaluation = function submitEvaluation(formData, CourseAttendeeID) {
	  return function (dispatch) {
	    dispatch(saveEvaluation(formData, CourseAttendeeID, true));
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestEvaluations, 'requestEvaluations', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(requestEvaluationsSuccess, 'requestEvaluationsSuccess', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(requestEvaluationsFailure, 'requestEvaluationsFailure', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(fetchEvaluations, 'fetchEvaluations', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(requestEvaluation, 'requestEvaluation', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(requestEvaluationSuccess, 'requestEvaluationSuccess', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(requestEvaluationFailure, 'requestEvaluationFailure', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(sortChildren, 'sortChildren', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(flattenChildren, 'flattenChildren', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(fetchOptions, 'fetchOptions', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(initAnswers, 'initAnswers', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(fetchEvaluation, 'fetchEvaluation', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(requestSaveEvaluation, 'requestSaveEvaluation', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(requestSaveEvaluationSuccess, 'requestSaveEvaluationSuccess', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(requestSaveEvaluationFailure, 'requestSaveEvaluationFailure', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(convertFormData, 'convertFormData', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(saveEvaluation, 'saveEvaluation', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(requestSubmitEvaluation, 'requestSubmitEvaluation', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(requestSubmitEvaluationSuccess, 'requestSubmitEvaluationSuccess', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(requestSubmitEvaluationFailure, 'requestSubmitEvaluationFailure', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(submitEvaluation, 'submitEvaluation', 'D:/a/1/s/src/web/employee/src/actions/CourseEvaluation.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.requestSendEmail = exports.sendEmailFailure = exports.sendEmailSuccess = exports.sendEmail = undefined;
	
	var _ActionTypes = __webpack_require__(18);
	
	var _Api = __webpack_require__(21);
	
	var sendEmail = exports.sendEmail = function sendEmail() {
	  return {
	    type: _ActionTypes.SEND_EMAIL
	  };
	};
	
	var sendEmailSuccess = exports.sendEmailSuccess = function sendEmailSuccess(email) {
	  return {
	    type: _ActionTypes.SEND_EMAIL_SUCCESS,
	    email: email
	  };
	};
	
	var sendEmailFailure = exports.sendEmailFailure = function sendEmailFailure(error) {
	  return {
	    type: _ActionTypes.SEND_EMAIL_FAILURE,
	    error: error
	  };
	};
	var readFiles = function readFiles(file) {
	  return new Promise(function (resolve) {
	    var reader = new FileReader();
	    reader.onload = function () {
	      var base64Data = reader.result.split(',')[1];
	      var attachment = {
	        Name: file.name,
	        Data: base64Data
	      };
	      resolve(attachment);
	    };
	    reader.readAsDataURL(file);
	  });
	};
	
	var requestSendEmail = exports.requestSendEmail = function requestSendEmail(_ref, idCallBack) {
	  var Attachments = _ref.Attachments,
	      From = _ref.From,
	      To = _ref.To,
	      Body = _ref.Body,
	      Subject = _ref.Subject;
	  return function (dispatch, getState) {
	    dispatch(sendEmail());
	
	    var _getState = getState(),
	        token = _getState.loginReducer.token;
	
	    var attachments = [];
	    var promises = Array.from(Attachments).map(function (file) {
	      return new Promise(function (resolve) {
	        readFiles(file).then(function (attachment) {
	          attachments.push(attachment);
	          resolve(attachment);
	        });
	      });
	    });
	    Promise.all(promises).then(function () {
	      console.log(attachments, 'attachments');
	      var configMail = {
	        headers: { Authorization: 'Bearer ' + token },
	        method: 'POST',
	        url: '/api/QDataEmail/SendEmail',
	        data: {
	          From: From,
	          ToList: To,
	          Body: Body,
	          Subject: Subject,
	          Attachments: attachments,
	          AutoFillIfEmpty: 'true'
	        },
	        maxBodyLength: 30 * 1024 * 1024,
	        maxContentLength: 30 * 1024 * 1024
	      };
	      (0, _Api.custom)(configMail).then(function (res) {
	        dispatch(sendEmailSuccess(res.data));
	        if (idCallBack) {
	          idCallBack(res.data);
	        }
	      }).catch(function (err) {
	        return dispatch(sendEmailFailure(err));
	      });
	    });
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(sendEmail, 'sendEmail', 'D:/a/1/s/src/web/employee/src/actions/Email.js');
	
	  __REACT_HOT_LOADER__.register(sendEmailSuccess, 'sendEmailSuccess', 'D:/a/1/s/src/web/employee/src/actions/Email.js');
	
	  __REACT_HOT_LOADER__.register(sendEmailFailure, 'sendEmailFailure', 'D:/a/1/s/src/web/employee/src/actions/Email.js');
	
	  __REACT_HOT_LOADER__.register(readFiles, 'readFiles', 'D:/a/1/s/src/web/employee/src/actions/Email.js');
	
	  __REACT_HOT_LOADER__.register(requestSendEmail, 'requestSendEmail', 'D:/a/1/s/src/web/employee/src/actions/Email.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.update = exports.requestBankUpdateFailure = exports.requestBankUpdateSuccess = exports.requestbankupdate = exports.clearNewAccount = exports.createNewAccount = exports.setStatus = exports.fetch = exports.fetchBankBranches = exports.setBankBranches = exports.requestBankBranches = exports.requestBankFailure = exports.requestBankSuccess = exports.requestBank = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _xSelect = __webpack_require__(188);
	
	var _Api = __webpack_require__(21);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var requestBank = exports.requestBank = function requestBank() {
	  return {
	    type: types.REQUEST_BANK
	  };
	};
	
	var requestBankSuccess = exports.requestBankSuccess = function requestBankSuccess(accounts) {
	  return {
	    type: types.REQUEST_BANK_SUCCESS,
	    accounts: accounts
	  };
	};
	
	var requestBankFailure = exports.requestBankFailure = function requestBankFailure(error) {
	  return {
	    type: types.REQUEST_BANK_FAILURE,
	    error: error
	  };
	};
	
	var requestBankBranches = exports.requestBankBranches = function requestBankBranches() {
	  return {
	    type: types.REQUEST_BANK_BRANCHES
	  };
	};
	
	var setBankBranches = exports.setBankBranches = function setBankBranches(branches) {
	  return {
	    type: types.SET_BANK_BRANCHES,
	    branches: branches
	  };
	};
	
	var fetchBankBranches = exports.fetchBankBranches = function fetchBankBranches() {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        token = _getState.loginReducer.user.token;
	
	    var config = {
	      entity: 'SysBankBranch',
	      headers: { Authorization: 'Bearer ' + token }
	    };
	
	    return (0, _Api.list)(config).then(function (_ref) {
	      var data = _ref.data;
	      return dispatch(setBankBranches(data));
	    }).catch(function (err) {
	      return dispatch(requestBankFailure(err));
	    });
	  };
	};
	
	var fetch = exports.fetch = function fetch() {
	  return function (dispatch, getState) {
	    dispatch(requestBank());
	    dispatch(requestBankBranches());
	    dispatch(fetchBankBranches());
	
	    var _getState2 = getState(),
	        _getState2$loginReduc = _getState2.loginReducer.user,
	        EmployeeMasterID = _getState2$loginReduc.EmployeeMasterID,
	        token = _getState2$loginReduc.token;
	
	    var config = {
	      entity: 'EmployeeMasterBank',
	      headers: { Authorization: 'Bearer ' + token },
	      data: (0, _xSelect.xSelectSingle)([
	      // TODO: Find solution for this
	      { field: 'EmployeeMasterID', value: EmployeeMasterID, relation: 'eq' }])
	    };
	
	    return (0, _Api.list)(config).then(function (_ref2) {
	      var data = _ref2.data;
	      return dispatch(requestBankSuccess(data.filter(function (x) {
	        return x.BankAccountType === 1 && new Date(x.Endda).getTime() > Date.now();
	      })));
	    }).catch(function (err) {
	      return dispatch(requestBankFailure(err));
	    });
	  };
	};
	
	var setStatus = exports.setStatus = function setStatus(status) {
	  return {
	    type: types.SET_ACCOUNT_STATUS,
	    status: status
	  };
	};
	
	var createNewAccount = exports.createNewAccount = function createNewAccount() {
	  return {
	    type: types.CREATE_NEW_ACCOUNT
	  };
	};
	
	var clearNewAccount = exports.clearNewAccount = function clearNewAccount() {
	  return {
	    type: types.CLEAR_NEW_ACCOUNT
	  };
	};
	
	var requestbankupdate = exports.requestbankupdate = function requestbankupdate() {
	  return {
	    type: types.REQUEST_BANK_UPDATE
	  };
	};
	
	var requestBankUpdateSuccess = exports.requestBankUpdateSuccess = function requestBankUpdateSuccess(account) {
	  return {
	    type: types.REQUEST_BANK_UPDATE_SUCCESS,
	    account: account
	  };
	};
	
	var requestBankUpdateFailure = exports.requestBankUpdateFailure = function requestBankUpdateFailure(error) {
	  return {
	    type: types.REQUEST_BANK_UPDATE_FAILURE,
	    error: error
	  };
	};
	
	var update = exports.update = function update(emb) {
	  return function (dispatch, getState) {
	    /* Start the loading animation for the account that is being saved */
	    dispatch(setStatus({ id: emb.EmployeeMasterBankID, value: 'ACCOUNT_SAVING' }));
	    /* Check if the account is a new account */
	    var isNew = emb.EmployeeMasterBankID === 'NEW_ACCOUNT';
	    var data = emb;
	
	    /* If the account is new we don't want to send the fake id to qdata */
	    if (isNew) {
	      delete data.EmployeeMasterBankID;
	    }
	
	    var _getState3 = getState(),
	        _getState3$loginReduc = _getState3.loginReducer.user,
	        token = _getState3$loginReduc.token,
	        EmployeeMasterID = _getState3$loginReduc.EmployeeMasterID;
	
	    var config = {
	      entity: 'EmployeeMasterBank',
	      headers: { Authorization: 'Bearer ' + token },
	      data: _extends({}, data, {
	        EmployeeMasterID: EmployeeMasterID,
	        BankAccountType: 1
	      })
	    };
	
	    /* If we are a new acount we need to create and not save */
	    if (isNew) {
	      (0, _Api.create)(config).then(function (res) {
	        /* When created we need to remove the new account item from the view */
	        dispatch(clearNewAccount());
	        dispatch(requestBankUpdateSuccess(res.data));
	      }).catch(function (error) {
	        return dispatch(requestBankUpdateFailure(error));
	      });
	    } else {
	      (0, _Api.save)(config).then(function (res) {
	        return dispatch(requestBankUpdateSuccess(res.data));
	      }).catch(function (error) {
	        return dispatch(requestBankUpdateFailure(error));
	      });
	    }
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestBank, 'requestBank', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(requestBankSuccess, 'requestBankSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(requestBankFailure, 'requestBankFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(requestBankBranches, 'requestBankBranches', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(setBankBranches, 'setBankBranches', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(fetchBankBranches, 'fetchBankBranches', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(fetch, 'fetch', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(setStatus, 'setStatus', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(createNewAccount, 'createNewAccount', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(clearNewAccount, 'clearNewAccount', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(requestbankupdate, 'requestbankupdate', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(requestBankUpdateSuccess, 'requestBankUpdateSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(requestBankUpdateFailure, 'requestBankUpdateFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(update, 'update', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBank.js');
	}();

	;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.update = exports.requestTaxCardUpdateFailure = exports.requestTaxCardUpdateSuccess = exports.requestTaxCardUpdate = exports.createTaxCard = exports.requestCreateTaxCardsFailure = exports.requestCreateTaxCardsSuccess = exports.requestCreateTaxCards = exports.fetchTaxCards = exports.requestTaxCardsFailure = exports.requestTaxCardsSuccess = exports.requestTaxCards = exports.requestTaxDiscountInfo = exports.setTaxDiscount = exports.requestTaxCardInfo = exports.setTaxCardInfo = exports.setStatus = undefined;
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Api = __webpack_require__(21);
	
	var _omit = __webpack_require__(1505);
	
	var _omit2 = _interopRequireDefault(_omit);
	
	var _get = __webpack_require__(96);
	
	var _get2 = _interopRequireDefault(_get);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var setStatus = exports.setStatus = function setStatus(status) {
	  return {
	    type: types.SET_TAX_CARD_STATUS,
	    status: status
	  };
	};
	
	var setTaxCardInfo = exports.setTaxCardInfo = function setTaxCardInfo(taxCardInfo) {
	  return {
	    type: types.SET_TAX_CARD_INFO,
	    taxCardInfo: taxCardInfo
	  };
	};
	
	var requestTaxCardInfo = exports.requestTaxCardInfo = function requestTaxCardInfo() {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        token = _getState.loginReducer.user.token,
	        taxCardInfo = _getState.EmployeeTaxCardsReducer.taxCardInfo,
	        valuesByKey = _getState.WebValuesReducer.valuesByKey;
	
	    var templateConfig = valuesByKey['Info.EmployeeMasterTaxCard.XapEmailTemplateID'];
	    if (!taxCardInfo && templateConfig && templateConfig.Value) {
	      var config = {
	        entity: 'XapEmailTemplate',
	        entityID: Number(templateConfig.Value),
	        headers: { Authorization: 'Bearer ' + token }
	      };
	      return (0, _Api.read)(config).then(function (_ref) {
	        var data = _ref.data;
	        return dispatch(setTaxCardInfo(data));
	      });
	    }
	    return null;
	  };
	};
	
	var setTaxDiscount = exports.setTaxDiscount = function setTaxDiscount() {
	  var taxDiscount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	  return {
	    type: types.SET_TAX_DISCOUNT,
	    taxDiscount: taxDiscount
	  };
	};
	
	var requestTaxDiscountInfo = exports.requestTaxDiscountInfo = function requestTaxDiscountInfo() {
	  return function (dispatch, getState) {
	    var _getState2 = getState(),
	        taxDiscount = _getState2.EmployeeTaxCardsReducer.taxDiscount,
	        token = _getState2.loginReducer.user.token;
	
	    if (!taxDiscount) {
	      var now = new Date().toISOString();
	      var config = {
	        entity: 'PayTax',
	        headers: { Authorization: 'Bearer' + token },
	        params: {
	          $filter: 'PayTaxBegda le datetime\'' + now + '\' and PayTaxEndda ge datetime\'' + now + '\'',
	          $select: 'TaxDiscountMonth'
	        }
	      };
	
	      return (0, _Api.list)(config).then(function (_ref2) {
	        var data = _ref2.data;
	        return dispatch(setTaxDiscount((0, _get2.default)(data, '[0].TaxDiscountMonth')));
	      });
	    }
	    return null;
	  };
	};
	
	var requestTaxCards = exports.requestTaxCards = function requestTaxCards() {
	  return {
	    type: types.REQUEST_TAX_CARDS
	  };
	};
	
	var requestTaxCardsSuccess = exports.requestTaxCardsSuccess = function requestTaxCardsSuccess(taxCards) {
	  return {
	    type: types.REQUEST_TAX_CARDS_SUCCESS,
	    taxCards: taxCards
	  };
	};
	
	var requestTaxCardsFailure = exports.requestTaxCardsFailure = function requestTaxCardsFailure(error) {
	  return {
	    type: types.REQUEST_TAX_CARDS_FAILURE,
	    error: error
	  };
	};
	
	var fetchTaxCards = exports.fetchTaxCards = function fetchTaxCards() {
	  return function (dispatch, getState) {
	    dispatch(requestTaxCards());
	    dispatch(requestTaxCardInfo());
	    dispatch(requestTaxDiscountInfo());
	    var now = new Date().toISOString();
	
	    var _getState3 = getState(),
	        _getState3$loginReduc = _getState3.loginReducer.user,
	        EmployeeMasterID = _getState3$loginReduc.EmployeeMasterID,
	        token = _getState3$loginReduc.token;
	
	    var config = {
	      entity: 'EmployeeMasterTaxCard',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: 'EmployeeMasterID eq ' + EmployeeMasterID + ' and Begda le datetime\'' + now + '\' and Endda ge datetime\'' + now + '\''
	      }
	    };
	
	    return (0, _Api.list)(config).then(function (_ref3) {
	      var data = _ref3.data;
	      return dispatch(requestTaxCardsSuccess(data));
	    }).catch(function (err) {
	      return dispatch(requestTaxCardsFailure(err));
	    });
	  };
	};
	
	var requestCreateTaxCards = exports.requestCreateTaxCards = function requestCreateTaxCards() {
	  return {
	    type: types.REQUEST_CREATE_TAX_CARDS
	  };
	};
	
	var requestCreateTaxCardsSuccess = exports.requestCreateTaxCardsSuccess = function requestCreateTaxCardsSuccess(data) {
	  return {
	    type: types.REQUEST_CREATE_TAX_CARDS_SUCCESS,
	    data: data
	  };
	};
	
	var requestCreateTaxCardsFailure = exports.requestCreateTaxCardsFailure = function requestCreateTaxCardsFailure(error) {
	  return {
	    type: types.REQUEST_CREATE_TAX_CARDS_FAILURE,
	    error: error
	  };
	};
	
	var createTaxCard = exports.createTaxCard = function createTaxCard(_ref4) {
	  var TaxCardType = _ref4.TaxCardType,
	      Unused = _ref4.Unused,
	      Prosent = _ref4.Prosent,
	      DateLastUsed = _ref4.DateLastUsed;
	  return function (dispatch, getState) {
	    dispatch(requestCreateTaxCards());
	
	    var DateIn = new Date().toISOString();
	    var Begda = DateIn;
	    var Endda = new Date('9999/12/31').toISOString();
	
	    var _getState4 = getState(),
	        _getState4$loginReduc = _getState4.loginReducer.user,
	        EmployeeMasterID = _getState4$loginReduc.EmployeeMasterID,
	        token = _getState4$loginReduc.token;
	
	    var config = {
	      entity: 'EmployeeMasterTaxCard',
	      headers: { Authorization: 'Bearer ' + token },
	      data: {
	        EmployeeMasterID: EmployeeMasterID,
	        DateIn: DateIn,
	        Begda: Begda,
	        Endda: Endda,
	        TaxCardType: TaxCardType,
	        Unused: Unused,
	        Prosent: Prosent,
	        DateLastUsed: DateLastUsed
	      }
	    };
	
	    return (0, _Api.create)(config).then(function (res) {
	      return dispatch(requestCreateTaxCardsSuccess(res.data));
	    }).catch(function (err) {
	      return dispatch(requestCreateTaxCardsFailure(err));
	    });
	  };
	};
	
	var requestTaxCardUpdate = exports.requestTaxCardUpdate = function requestTaxCardUpdate() {
	  return {
	    type: types.REQUEST_UPDATE_TAX_CARD
	  };
	};
	
	var requestTaxCardUpdateSuccess = exports.requestTaxCardUpdateSuccess = function requestTaxCardUpdateSuccess(data) {
	  return {
	    type: types.REQUEST_UPDATE_TAX_CARD_SUCCESS,
	    data: data
	  };
	};
	
	var requestTaxCardUpdateFailure = exports.requestTaxCardUpdateFailure = function requestTaxCardUpdateFailure(error) {
	  return {
	    type: types.REQUEST_UPDATE_TAX_CARD_FAILURE,
	    error: error
	  };
	};
	
	var update = exports.update = function update(card) {
	  return function (dispatch, getState) {
	    dispatch(setStatus({ id: card.TaxCardType, value: 'TAX_CARD_SAVING' }));
	    var data = (0, _omit2.default)(card, ['EmployeeMaster', 'EntityId', 'KeyID', 'ModifyDate', 'RowVersion', 'UniqueID']);
	
	    var _getState5 = getState(),
	        token = _getState5.loginReducer.user.token;
	
	    var config = {
	      entity: 'EmployeeMasterTaxCard',
	      headers: { Authorization: 'Bearer ' + token },
	      data: data
	    };
	    return (0, _Api.save)(config).then(function (res) {
	      return dispatch(requestTaxCardUpdateSuccess(res.data));
	    }).catch(function (err) {
	      return dispatch(requestTaxCardUpdateFailure(err));
	    });
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(setStatus, 'setStatus', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(setTaxCardInfo, 'setTaxCardInfo', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(requestTaxCardInfo, 'requestTaxCardInfo', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(setTaxDiscount, 'setTaxDiscount', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(requestTaxDiscountInfo, 'requestTaxDiscountInfo', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(requestTaxCards, 'requestTaxCards', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(requestTaxCardsSuccess, 'requestTaxCardsSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(requestTaxCardsFailure, 'requestTaxCardsFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(fetchTaxCards, 'fetchTaxCards', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(requestCreateTaxCards, 'requestCreateTaxCards', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(requestCreateTaxCardsSuccess, 'requestCreateTaxCardsSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(requestCreateTaxCardsFailure, 'requestCreateTaxCardsFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(createTaxCard, 'createTaxCard', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(requestTaxCardUpdate, 'requestTaxCardUpdate', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(requestTaxCardUpdateSuccess, 'requestTaxCardUpdateSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(requestTaxCardUpdateFailure, 'requestTaxCardUpdateFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(update, 'update', 'D:/a/1/s/src/web/employee/src/actions/EmployeeTaxCards.js');
	}();

	;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.forgotPassword = exports.changePassword = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _config = __webpack_require__(54);
	
	var _reapop = __webpack_require__(44);
	
	var _axios = __webpack_require__(179);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var changePassword = exports.changePassword = function changePassword(data) {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
	      var requestConfig;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              requestConfig = {
	                url: _config.apiUrl + '/kjarni/api/v2/ResetPassword',
	                method: 'POST',
	                data: _extends({}, data)
	              };
	              _context.next = 4;
	              return (0, _axios2.default)(requestConfig);
	
	            case 4:
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.ResetPassword.Success' }),
	                status: 'success',
	                dismissible: true,
	                dismissAfter: 5000
	              }));
	              _context.next = 10;
	              break;
	
	            case 7:
	              _context.prev = 7;
	              _context.t0 = _context['catch'](0);
	
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.ResetPassword.Error' }),
	                status: 'error',
	                dismissible: true,
	                dismissAfter: 5000
	              }));
	
	            case 10:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 7]]);
	    }));
	
	    return function (_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var forgotPassword = exports.forgotPassword = function forgotPassword(data) {
	  return function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	      var requestConfig;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _context2.prev = 0;
	              requestConfig = {
	                url: _config.apiUrl + '/kjarni/api/v2/ForgotPassword',
	                method: 'POST',
	                data: _extends({}, data)
	              };
	              _context2.next = 4;
	              return (0, _axios2.default)(requestConfig);
	
	            case 4:
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'forgotPassword.notification' }),
	                status: 'success',
	                dismissible: true,
	                dismissAfter: 5000
	              }));
	              _context2.next = 10;
	              break;
	
	            case 7:
	              _context2.prev = 7;
	              _context2.t0 = _context2['catch'](0);
	
	              console.log(_context2.t0);
	
	            case 10:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[0, 7]]);
	    }));
	
	    return function (_x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(changePassword, 'changePassword', 'D:/a/1/s/src/web/employee/src/actions/account/resetPassword.js');
	
	  __REACT_HOT_LOADER__.register(forgotPassword, 'forgotPassword', 'D:/a/1/s/src/web/employee/src/actions/account/resetPassword.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _normalize = __webpack_require__(103);
	
	var _KBenefit = __webpack_require__(1027);
	
	var _KBenefit2 = _interopRequireDefault(_KBenefit);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var fileInput = void 0;
	
	var KBenefit = function KBenefit(_ref) {
	  var FileRepositoryObjectDocumentTypeID = _ref.FileRepositoryObjectDocumentTypeID,
	      Email = _ref.Email,
	      HrBenefitName = _ref.HrBenefitName,
	      HrBenefitText = _ref.HrBenefitText,
	      XapEmailTemplateBody = _ref.XapEmailTemplateBody,
	      employeeName = _ref.employeeName,
	      onEmail = _ref.onEmail,
	      onUpload = _ref.onUpload,
	      HrBenefitID = _ref.HrBenefitID,
	      onRequestGrant = _ref.onRequestGrant,
	      HrBenefitType = _ref.HrBenefitType,
	      Link = _ref.Link,
	      PayRecordSum = _ref.PayRecordSum,
	      EndDate = _ref.EndDate,
	      Amount = _ref.Amount,
	      loading = _ref.loading;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      files = _useState2[0],
	      setFiles = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(0),
	      _useState4 = _slicedToArray(_useState3, 2),
	      amount = _useState4[0],
	      setAmount = _useState4[1];
	
	  var handleAmountInput = function handleAmountInput(e) {
	    var value = e.target.value;
	
	    if (value) {
	      setAmount((0, _normalize.normalizeNumber)(value));
	    }
	  };
	
	  var handleFile = function handleFile(e) {
	    var fileArray = Array.from(e.target.files);
	    setFiles(fileArray || []);
	  };
	
	  var submitFile = function submitFile(e) {
	    e.preventDefault();
	    if (!FileRepositoryObjectDocumentTypeID || !files.length) return;
	    onUpload(files, FileRepositoryObjectDocumentTypeID, function () {
	      if (fileInput) fileInput.value = '';
	    }, Email, function () {
	      return onEmail({
	        To: Email.split(','),
	        Subject: HrBenefitName + ' - ' + employeeName,
	        Attachments: files,
	        Body: HrBenefitText || XapEmailTemplateBody
	      });
	    });
	  };
	
	  var requestGrant = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!(!HrBenefitID || !amount || !FileRepositoryObjectDocumentTypeID || !files.length)) {
	                _context.next = 2;
	                break;
	              }
	
	              return _context.abrupt('return');
	
	            case 2:
	              _context.prev = 2;
	
	              onRequestGrant(HrBenefitID, Number(amount), files, FileRepositoryObjectDocumentTypeID, function () {
	                if (fileInput) fileInput.value = '';
	              }, Email, function () {
	                return onEmail({
	                  To: Email.split(','),
	                  Subject: HrBenefitName + ' - ' + employeeName,
	                  Attachments: files,
	                  Body: HrBenefitText || XapEmailTemplateBody
	                });
	              });
	              _context.next = 9;
	              break;
	
	            case 6:
	              _context.prev = 6;
	              _context.t0 = _context['catch'](2);
	              throw _context.t0;
	
	            case 9:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 6]]);
	    }));
	
	    return function requestGrant() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var body = XapEmailTemplateBody || HrBenefitText || '';
	
	  var chooseButton = function chooseButton() {
	    if (HrBenefitType === 2) {
	      return _react2.default.createElement(_materialUi.RaisedButton, {
	        style: _KBenefit2.default.actionButton,
	        disabled: amount > Amount - Number(PayRecordSum) || !files.length || loading,
	        label: loading ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'benefit.loading' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'benefit.request' }),
	        onClick: requestGrant,
	        'data-cy': 'submit-grant'
	      });
	    }
	    if (Link) {
	      return _react2.default.createElement(_materialUi.RaisedButton, {
	        style: _KBenefit2.default.actionButton,
	        icon: _react2.default.createElement(
	          _materialUi.FontIcon,
	          { className: 'material-icons' },
	          'link'
	        ),
	        labelPosition: 'before',
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'benefit.apply' }),
	        target: '_blank',
	        href: Link
	      });
	    }
	    if (FileRepositoryObjectDocumentTypeID !== 0 && Email) {
	      return _react2.default.createElement(_materialUi.RaisedButton, {
	        style: _KBenefit2.default.actionButton,
	        disabled: !files.length,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'benefit.sendFile' }),
	        onClick: submitFile
	      });
	    }
	    return null;
	  };
	
	  var remainingAmount = 0;
	  if (Amount) {
	    remainingAmount = Amount - Number(PayRecordSum || 0);
	  }
	
	  return _react2.default.createElement(
	    _materialUi.Paper,
	    { style: _KBenefit2.default.container, zDepth: 0, 'data-cy': 'single-grant' },
	    _react2.default.createElement(_KTitle2.default, { style: _KBenefit2.default.title, title: HrBenefitName }),
	    _react2.default.createElement('div', { style: _KBenefit2.default.description, dangerouslySetInnerHTML: { __html: body } }),
	    _react2.default.createElement('div', { style: _KBenefit2.default.times }),
	    EndDate ? _react2.default.createElement(
	      'div',
	      { style: _KBenefit2.default.amount },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'benefit.validUntil', values: { val: (0, _dateTools2.default)(EndDate) } })
	    ) : _react2.default.createElement('div', null),
	    Amount ? _react2.default.createElement(
	      'div',
	      { style: _KBenefit2.default.amount },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'benefit.amount', values: { val: Amount.toLocaleString('de', { maximumFractionDigits: 2 }) } })
	    ) : _react2.default.createElement('div', null),
	    Amount ? _react2.default.createElement(
	      'div',
	      { style: _KBenefit2.default.amount },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'benefit.payRecordSumRemaining', values: { val: remainingAmount.toLocaleString('de', { maximumFractionDigits: 2 }) } })
	    ) : _react2.default.createElement('div', null),
	    HrBenefitType === 2 ? _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_materialUi.TextField, {
	        style: _KBenefit2.default.amountInput,
	        floatingLabelFixed: true,
	        floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'benefit.receipt' }),
	        hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'benefit.receipt.hint' }),
	        type: 'number',
	        onChange: handleAmountInput,
	        'data-cy': 'grant-amount'
	      })
	    ) : _react2.default.createElement('div', null),
	    FileRepositoryObjectDocumentTypeID !== 0 && onUpload && _react2.default.createElement('input', {
	      style: _KBenefit2.default.fileInput,
	      type: 'file',
	      ref: function ref(x) {
	        fileInput = x;
	      },
	      multiple: true,
	      onChange: handleFile
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: _KBenefit2.default.action },
	      chooseButton()
	    )
	  );
	};
	
	KBenefit.propTypes = {
	  HrBenefitID: _propTypes2.default.number,
	  HrBenefitName: _propTypes2.default.string,
	  HrBenefitText: _propTypes2.default.string,
	  HrBenefitType: _propTypes2.default.number,
	  Link: _propTypes2.default.string,
	  FileRepositoryObjectDocumentTypeID: _propTypes2.default.number,
	  Email: _propTypes2.default.string,
	  PayRecordSum: _propTypes2.default.string,
	  onUpload: _propTypes2.default.func,
	  onRequestGrant: _propTypes2.default.func,
	  onEmail: _propTypes2.default.func,
	  XapEmailTemplateBody: _propTypes2.default.string,
	  EndDate: _propTypes2.default.string,
	  employeeName: _propTypes2.default.string,
	  Amount: _propTypes2.default.number.isRequired,
	  loading: _propTypes2.default.bool.isRequired
	};
	
	KBenefit.defaultProps = {
	  onUpload: null,
	  onEmail: null,
	  employeeName: ''
	};
	
	var _default = KBenefit;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fileInput, 'fileInput', 'D:/a/1/s/src/web/employee/src/components/KJRN/KBenefit.js');
	
	  __REACT_HOT_LOADER__.register(KBenefit, 'KBenefit', 'D:/a/1/s/src/web/employee/src/components/KJRN/KBenefit.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KBenefit.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FontIcon = __webpack_require__(83);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatusIcon = function StatusIcon(_ref) {
	  var type = _ref.type;
	
	  var icon = {
	    0: 'label_outline', 1: 'label_outline', 2: 'done', 3: 'lock_outline', 4: 'done_all', 5: 'priority_high'
	  };
	  var color = {
	    0: _colors2.default.errorColor, 1: _colors2.default.warningColor, 2: _colors2.default.successColor, 3: '#a1a1a1', 4: _colors2.default.successColor, 5: _colors2.default.errorColor
	  };
	  if (type === -1 || type === 3) {
	    return _react2.default.createElement('div', null);
	  }
	  return _react2.default.createElement(
	    _FontIcon2.default,
	    {
	      color: color[type],
	      className: 'material-icons',
	      style: { marginRight: 8 }
	    },
	    icon[type]
	  );
	};
	
	StatusIcon.propTypes = {
	  type: _propTypes2.default.oneOf([-1, 0, 1, 2, 3, 4, 5]).isRequired
	};
	
	var _default = StatusIcon;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(StatusIcon, 'StatusIcon', 'D:/a/1/s/src/web/employee/src/components/StatusIcon.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/StatusIcon.js');
	}();

	;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(67);
	
	var _InputTypes = __webpack_require__(91);
	
	var _CheckboxInput = __webpack_require__(878);
	
	var _CheckboxInput2 = _interopRequireDefault(_CheckboxInput);
	
	var _DateInput = __webpack_require__(879);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _EmailInput = __webpack_require__(880);
	
	var _EmailInput2 = _interopRequireDefault(_EmailInput);
	
	var _linkField = __webpack_require__(1034);
	
	var _linkField2 = _interopRequireDefault(_linkField);
	
	var _NumberInput = __webpack_require__(882);
	
	var _NumberInput2 = _interopRequireDefault(_NumberInput);
	
	var _PhoneInput = __webpack_require__(883);
	
	var _PhoneInput2 = _interopRequireDefault(_PhoneInput);
	
	var _SelectInput = __webpack_require__(884);
	
	var _SelectInput2 = _interopRequireDefault(_SelectInput);
	
	var _selectOptions = __webpack_require__(1036);
	
	var _selectOptions2 = _interopRequireDefault(_selectOptions);
	
	var _TextInput = __webpack_require__(430);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _AddOptionInput = __webpack_require__(877);
	
	var _AddOptionInput2 = _interopRequireDefault(_AddOptionInput);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RootField = function (_React$Component) {
	  _inherits(RootField, _React$Component);
	
	  function RootField(props) {
	    _classCallCheck(this, RootField);
	
	    var _this = _possibleConstructorReturn(this, (RootField.__proto__ || Object.getPrototypeOf(RootField)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(RootField, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.lookup) {
	        var lookupValue = nextProps.lookupValue,
	            _nextProps$lookup = nextProps.lookup,
	            entity = _nextProps$lookup.entity,
	            link = _nextProps$lookup.link,
	            label = _nextProps$lookup.label,
	            value = _nextProps$lookup.value,
	            number = _nextProps$lookup.number,
	            orderByValue = _nextProps$lookup.orderByValue,
	            token = nextProps.token;
	
	        (0, _selectOptions2.default)({
	          entity: entity, field: link, fieldValue: lookupValue, token: token, label: label, value: value, number: number, orderByValue: orderByValue
	        }).then(function (options) {
	          return _this2.setState({ options: options });
	        });
	      }
	      if (nextProps.link) {
	        var linkValue = nextProps.linkValue,
	            _nextProps$link = nextProps.link,
	            _entity = _nextProps$link.entity,
	            _value = _nextProps$link.value,
	            _token = nextProps.token,
	            dispatch = nextProps.dispatch,
	            formName = nextProps.formName,
	            formData = nextProps.formData;
	
	        linkValue && (0, _linkField2.default)({
	          token: _token, entity: _entity, entityID: linkValue, value: _value
	        }).then(function (linkedValue) {
	          linkedValue !== formData.values[_value] && dispatch((0, _reduxForm.change)(formName, _value, linkedValue));
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          type = _props.type,
	          name = _props.name,
	          allowAddOption = _props.allowAddOption,
	          label = _props.label,
	          lookup = _props.lookup;
	      // fix warning: https://reactjs.org/warnings/unknown-prop.html
	
	      var _props2 = this.props,
	          lookupValue = _props2.lookupValue,
	          linkValue = _props2.linkValue,
	          formName = _props2.formName,
	          formData = _props2.formData,
	          valuesByKey = _props2.valuesByKey,
	          rest = _objectWithoutProperties(_props2, ['lookupValue', 'linkValue', 'formName', 'formData', 'valuesByKey']);
	
	      var options = this.state.options;
	
	      var addOption = allowAddOption && valuesByKey['Show.AddOption.' + formName + '.' + lookup.entity] && valuesByKey['Show.AddOption.' + formName + '.' + lookup.entity].Value === 'true' ? _react2.default.createElement(_AddOptionInput2.default, {
	        entity: lookup.entity,
	        entityField: lookup.value,
	        entityForm: formName,
	        entityLink: lookup.link,
	        entityLookup: lookup.lookupValue,
	        inputField: lookup.label,
	        label: label
	      }) : null;
	      var field = null;
	      switch (type) {
	        case _InputTypes.NUMBER_FIELD:
	          field = _react2.default.createElement(_reduxForm.Field, _extends({}, rest, { name: name, component: _NumberInput2.default }));
	          break;
	        case _InputTypes.DATE:
	          field = _react2.default.createElement(_reduxForm.Field, _extends({}, rest, { name: name, component: _DateInput2.default }));
	          break;
	        case _InputTypes.TEXT_FIELD:
	          field = _react2.default.createElement(_reduxForm.Field, _extends({}, rest, { name: name, component: _TextInput2.default }));
	          break;
	        case _InputTypes.EMAIL:
	          field = _react2.default.createElement(_reduxForm.Field, _extends({}, rest, { name: name, component: _EmailInput2.default }));
	          break;
	        case _InputTypes.PHONE:
	          field = _react2.default.createElement(_reduxForm.Field, _extends({}, rest, { name: name, component: _PhoneInput2.default }));
	          break;
	        case _InputTypes.SCALE:
	        case _InputTypes.RADIO:
	        case _InputTypes.SELECT_ENUM:
	          field = _react2.default.createElement(_reduxForm.Field, _extends({}, rest, { name: name, component: _SelectInput2.default }));
	          break;
	        case _InputTypes.CHECKBOX:
	          field = _react2.default.createElement(_reduxForm.Field, _extends({}, rest, { name: name, component: _CheckboxInput2.default }));
	          break;
	        case _InputTypes.SELECT_LOOKUP:
	          field = _react2.default.createElement(_reduxForm.Field, _extends({}, rest, { name: name, component: _SelectInput2.default, options: options || [] }));
	          break;
	        case _InputTypes.ATTACHMENT:
	          field = _react2.default.createElement(_reduxForm.Field, _extends({}, rest, { name: name, component: 'input', type: 'file' }));
	          break;
	        case _InputTypes.HIDDEN:
	          field = _react2.default.createElement('div', null);
	          break;
	        default:
	          return _react2.default.createElement(
	            'span',
	            null,
	            'THIS TYPE OF INPUT IS NOT SUPPORTED: ' + type
	          );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        field,
	        addOption
	      );
	    }
	  }]);
	
	  return RootField;
	}(_react2.default.Component);
	
	RootField.propTypes = {
	  type: _propTypes2.default.string.isRequired,
	  name: _propTypes2.default.string.isRequired,
	  lookupValue: _propTypes2.default.any,
	  lookup: _propTypes2.default.object,
	  linkValue: _propTypes2.default.any,
	  link: _propTypes2.default.object,
	  token: _propTypes2.default.string,
	  dispatch: _propTypes2.default.func.isRequired,
	  formName: _propTypes2.default.string,
	  formData: _propTypes2.default.object,
	  allowAddOption: _propTypes2.default.bool,
	  valuesByKey: _propTypes2.default.object,
	  label: _propTypes2.default.node
	};
	
	var _default = (0, _reactRedux.connect)(function (state) {
	  return { valuesByKey: state.WebValuesReducer.valuesByKey };
	})(RootField);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RootField, 'RootField', 'D:/a/1/s/src/web/employee/src/components/form/RootField.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/form/RootField.js');
	}();

	;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(67);
	
	var _flowRight = __webpack_require__(202);
	
	var _flowRight2 = _interopRequireDefault(_flowRight);
	
	var _RootField = __webpack_require__(428);
	
	var _RootField2 = _interopRequireDefault(_RootField);
	
	var _EntityCRUD = __webpack_require__(220);
	
	var CRUDActions = _interopRequireWildcard(_EntityCRUD);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RootForm = function (_React$Component) {
	  _inherits(RootForm, _React$Component);
	
	  function RootForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RootForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RootForm.__proto__ || Object.getPrototypeOf(RootForm)).call.apply(_ref, [this].concat(args))), _this), _this.isInvalid = function () {
	      var _this2;
	
	      return (_this2 = _this).__isInvalid__REACT_HOT_LOADER__.apply(_this2, arguments);
	    }, _this.isDirty = function () {
	      var _this3;
	
	      return (_this3 = _this).__isDirty__REACT_HOT_LOADER__.apply(_this3, arguments);
	    }, _this.save = function () {
	      var _this4;
	
	      return (_this4 = _this).__save__REACT_HOT_LOADER__.apply(_this4, arguments);
	    }, _this.create = function () {
	      var _this5;
	
	      return (_this5 = _this).__create__REACT_HOT_LOADER__.apply(_this5, arguments);
	    }, _this.submitForm = function () {
	      var _this6;
	
	      return (_this6 = _this).__submitForm__REACT_HOT_LOADER__.apply(_this6, arguments);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RootForm, [{
	    key: '__submitForm__REACT_HOT_LOADER__',
	    value: function __submitForm__REACT_HOT_LOADER__() {
	      return this.__submitForm__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__create__REACT_HOT_LOADER__',
	    value: function __create__REACT_HOT_LOADER__() {
	      return this.__create__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__save__REACT_HOT_LOADER__',
	    value: function __save__REACT_HOT_LOADER__() {
	      return this.__save__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__isDirty__REACT_HOT_LOADER__',
	    value: function __isDirty__REACT_HOT_LOADER__() {
	      return this.__isDirty__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__isInvalid__REACT_HOT_LOADER__',
	    value: function __isInvalid__REACT_HOT_LOADER__() {
	      return this.__isInvalid__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this7 = this;
	
	      if (!this.props.provideController) {
	        return;
	      }
	      this.props.provideController({
	        save: function save() {
	          return _this7.save();
	        },
	        create: function create() {
	          return _this7.create();
	        },
	        isInvalid: function isInvalid() {
	          return _this7.isInvalid();
	        },
	        isDirty: function isDirty() {
	          return _this7.isDirty();
	        },
	        submitForm: function submitForm() {
	          return _this7.submitForm();
	        },
	        handleSubmit: function handleSubmit(f) {
	          return _this7.props.handleSubmit(f);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (!this.props.provideController) {
	        return;
	      }
	      this.props.provideController(null);
	    }
	  }, {
	    key: '__isInvalid__REACT_HOT_LOADER__',
	    value: function __isInvalid__REACT_HOT_LOADER__() {
	      return this.props.invalid;
	    }
	  }, {
	    key: '__isDirty__REACT_HOT_LOADER__',
	    value: function __isDirty__REACT_HOT_LOADER__() {
	      return this.props.dirty;
	    }
	  }, {
	    key: '__save__REACT_HOT_LOADER__',
	    value: function __save__REACT_HOT_LOADER__() {
	      if (this.isInvalid()) {
	        return;
	      }
	      var _props = this.props,
	          dispatch = _props.dispatch,
	          dataFetch = _props.dataFetch,
	          formData = _props.formData,
	          formName = _props.formName,
	          entityName = _props.entityName;
	
	      dispatch(CRUDActions.save(entityName || formName, formData.values, dataFetch));
	    }
	  }, {
	    key: '__create__REACT_HOT_LOADER__',
	    value: function __create__REACT_HOT_LOADER__() {
	      if (this.isInvalid()) {
	        return;
	      }
	      var _props2 = this.props,
	          dispatch = _props2.dispatch,
	          dataFetch = _props2.dataFetch,
	          formData = _props2.formData,
	          formName = _props2.formName,
	          entityName = _props2.entityName;
	
	      dispatch(CRUDActions.create(entityName || formName, formData.values, dataFetch));
	    }
	  }, {
	    key: '__submitForm__REACT_HOT_LOADER__',
	    value: function __submitForm__REACT_HOT_LOADER__() {
	      return this.form.submit();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _props3 = this.props,
	          fields = _props3.fields,
	          lookups = _props3.lookups,
	          token = _props3.token,
	          dispatch = _props3.dispatch,
	          formName = _props3.formName,
	          formData = _props3.formData;
	
	
	      return _react2.default.createElement(
	        'form',
	        { ref: function ref(form) {
	            _this8.form = form;
	          } },
	        fields.map(function (f, i) {
	          return _react2.default.createElement(_RootField2.default, _extends({
	            key: i
	          }, f, {
	            token: token,
	            lookupValue: f.lookup ? lookups[f.lookup.lookupValue] : '',
	            linkValue: f.link ? lookups[f.link.linkValue] : '',
	            dispatch: dispatch,
	            formName: formName,
	            formData: formData
	          }));
	        })
	      );
	    }
	  }]);
	
	  return RootForm;
	}(_react2.default.Component);
	
	RootForm.defaultProps = {
	  formData: {},
	  lookups: {},
	  entityName: '',
	  dataFetch: function dataFetch() {
	    return null;
	  }
	};
	
	RootForm.propTypes = {
	  fields: _propTypes2.default.array.isRequired,
	  formData: _propTypes2.default.object,
	  lookups: _propTypes2.default.object,
	  token: _propTypes2.default.string.isRequired,
	  provideController: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  dataFetch: _propTypes2.default.func,
	  formName: _propTypes2.default.string.isRequired,
	  entityName: _propTypes2.default.string,
	  invalid: _propTypes2.default.bool.isRequired,
	  dirty: _propTypes2.default.bool.isRequired,
	  handleSubmit: _propTypes2.default.func
	};
	
	// Handle variable names for the redux-form
	
	var _default = (0, _flowRight2.default)((0, _reactRedux.connect)(function (state, props) {
	  var selector = (0, _reduxForm.formValueSelector)(props.formName);
	  return {
	    form: props.formName,
	    formData: state.form[props.formName],
	    validate: props.validate,
	    initialValues: props.initialValues,
	    lookups: selector.apply(undefined, [state].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(props.fields.filter(function (f) {
	      return f.lookup;
	    }).map(function (l) {
	      return l.lookup.lookupValue;
	    })), _toConsumableArray(props.fields.filter(function (f) {
	      return f.link;
	    }).map(function (l) {
	      return l.link.linkValue;
	    }))))), ['forceObject'])),
	    token: state.loginReducer.user.token
	  };
	}), (0, _reduxForm.reduxForm)({}))(RootForm);
	
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(RootForm, 'RootForm', 'D:/a/1/s/src/web/employee/src/components/form/RootForm.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/form/RootForm.js');
	}();

	;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var TextInput = function TextInput(_ref) {
	  var input = _ref.input,
	      label = _ref.label,
	      _ref$meta = _ref.meta,
	      error = _ref$meta.error,
	      touched = _ref$meta.touched,
	      warning = _ref$meta.warning,
	      rows = _ref.rows,
	      multiLine = _ref.multiLine,
	      rowsMax = _ref.rowsMax,
	      hintText = _ref.hintText,
	      customStyle = _ref.customStyle,
	      custom = _objectWithoutProperties(_ref, ['input', 'label', 'meta', 'rows', 'multiLine', 'rowsMax', 'hintText', 'customStyle']);
	
	  return _react2.default.createElement(_TextField2.default, _extends({}, input, custom, {
	    hintText: hintText,
	    style: _extends({}, customStyle),
	    floatingLabelText: label,
	    errorText: touched && (error || warning),
	    fullWidth: true,
	    multiLine: multiLine,
	    rows: rows,
	    rowsMax: rowsMax
	  }));
	};
	
	TextInput.propTypes = {
	  rows: 1,
	  rowsMax: 1,
	  multiLine: false,
	  hintText: '',
	  label: ''
	};
	
	TextInput.propTypes = {
	  input: _propTypes2.default.object.isRequired,
	  meta: _propTypes2.default.object.isRequired,
	  label: _propTypes2.default.node,
	  customStyle: _propTypes2.default.object,
	  rows: _propTypes2.default.number,
	  rowsMax: _propTypes2.default.number,
	  multiLine: _propTypes2.default.bool,
	  hintText: _propTypes2.default.node
	};
	
	var _default = TextInput;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TextInput, 'TextInput', 'D:/a/1/s/src/web/employee/src/components/form/TextInput.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/form/TextInput.js');
	}();

	;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _sortBy = __webpack_require__(578);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _reverse = __webpack_require__(1508);
	
	var _reverse2 = _interopRequireDefault(_reverse);
	
	var _reactMotion = __webpack_require__(1678);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Table = __webpack_require__(273);
	
	var _IconButton = __webpack_require__(64);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PanelTableRow = __webpack_require__(885);
	
	var _PanelTableRow2 = _interopRequireDefault(_PanelTableRow);
	
	var _DataTypes = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  middle: {
	    verticalAlign: 'middle'
	  },
	  sortIcon: {
	    color: '#9e9e9e',
	    fontSize: 18
	  },
	  sortButton: {
	    padding: 8,
	    paddingLeft: 4,
	    width: 'auto',
	    height: 'auto'
	  },
	  tableColumn: {
	    whiteSpace: 'normal',
	    width: 120
	  },
	  emptyText: {
	    width: '100%',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    paddingTop: 32,
	    paddingBottom: 32,
	    color: '#b3b3b3',
	    fontSize: 16
	  }
	};
	
	var PanelTable = function (_React$Component) {
	  _inherits(PanelTable, _React$Component);
	
	  function PanelTable(props) {
	    _classCallCheck(this, PanelTable);
	
	    var _this = _possibleConstructorReturn(this, (PanelTable.__proto__ || Object.getPrototypeOf(PanelTable)).call(this, props));
	
	    _this.state = {
	      dataSource: props.dataSource,
	      descending: true,
	      orderBy: ''
	    };
	    _this.sort = _this.sort.bind(_this);
	    return _this;
	  }
	
	  _createClass(PanelTable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          dataSource = _props.dataSource,
	          initSort = _props.initSort;
	
	      if (dataSource && dataSource.length && initSort) {
	        this.sort(null, this.props.initSort);
	      }
	    }
	
	    /* Sort the table by one of the row fields */
	
	  }, {
	    key: 'sort',
	    value: function sort(event, fieldKey) {
	      var _state = this.state,
	          dataSource = _state.dataSource,
	          descending = _state.descending;
	      var type = dataSource[0][fieldKey].type;
	
	
	      var sortedDataSource = void 0;
	
	      switch (type) {
	        case _DataTypes.DATE:
	          sortedDataSource = (0, _sortBy2.default)(dataSource, function (o) {
	            return (0, _moment2.default)(o[fieldKey].value, 'DD.MM.YYYY').format('X');
	          });
	          break;
	        case _DataTypes.NUMBER:
	          sortedDataSource = (0, _sortBy2.default)(dataSource, function (o) {
	            return o[fieldKey].value;
	          });
	          break;
	        default:
	          sortedDataSource = dataSource.sort(function (a, b) {
	            return a[fieldKey].value.localeCompare(b[fieldKey].value, 'is');
	          });
	      }
	
	      var newState = {
	        dataSource: descending ? sortedDataSource : (0, _reverse2.default)(sortedDataSource),
	        descending: !descending,
	        orderBy: fieldKey
	      };
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state2 = this.state,
	          dataSource = _state2.dataSource,
	          descending = _state2.descending,
	          orderBy = _state2.orderBy;
	      var _props2 = this.props,
	          actions = _props2.actions,
	          emptyText = _props2.emptyText;
	
	      return dataSource && dataSource[0] ? _react2.default.createElement(
	        _Table.Table,
	        {
	          bodyStyle: { overflowX: 'none', overflowY: 'none' }
	        },
	        _react2.default.createElement(
	          _Table.TableHeader,
	          {
	            displaySelectAll: false,
	            adjustForCheckbox: false
	          },
	          _react2.default.createElement(
	            _Table.TableRow,
	            null,
	            dataSource[0].fields.map(function (f) {
	              return _react2.default.createElement(
	                _Table.TableHeaderColumn,
	                { key: f, style: _extends({}, styles.tableColumn, dataSource[0][f].style) },
	                _react2.default.createElement(
	                  'span',
	                  { style: { display: 'flex', alignItems: 'center' } },
	                  dataSource[0][f].label,
	                  _react2.default.createElement(
	                    _reactMotion.Motion,
	                    { style: { x: (0, _reactMotion.spring)(descending && f === orderBy ? 0 : 180) } },
	                    function (_ref) {
	                      var x = _ref.x;
	                      return _react2.default.createElement(
	                        _IconButton2.default,
	                        {
	                          iconClassName: 'material-icons',
	                          onClick: function onClick(e) {
	                            return _this2.sort(e, f);
	                          },
	                          iconStyle: _extends({}, styles.sortIcon, {
	                            transform: 'rotate3d(1, 0, 0, ' + x + 'deg)',
	                            WebkitTransform: 'rotate3d(1, 0, 0, ' + x + 'deg)'
	                          }),
	                          style: _extends({}, styles.sortButton, styles.middle)
	                        },
	                        'sort'
	                      );
	                    }
	                  )
	                )
	              );
	            }),
	            actions && _react2.default.createElement(
	              _Table.TableHeaderColumn,
	              { style: styles.tableColumn },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'panel.actions' })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _Table.TableBody,
	          {
	            displayRowCheckbox: false
	          },
	          (!dataSource || !dataSource.length) && _react2.default.createElement(
	            'span',
	            null,
	            'Empty'
	          ),
	          dataSource.map(function (d, i) {
	            return _react2.default.createElement(_PanelTableRow2.default, { item: d, key: i, columnStyle: styles.tableColumn, actions: true });
	          })
	        )
	      ) : _react2.default.createElement(
	        'div',
	        { style: styles.emptyText },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: emptyText })
	      );
	    }
	  }]);
	
	  return PanelTable;
	}(_react2.default.Component);
	
	PanelTable.propTypes = {
	  dataSource: _propTypes2.default.array,
	  emptyText: _propTypes2.default.string,
	  actions: _propTypes2.default.bool,
	  initSort: _propTypes2.default.string
	};
	
	PanelTable.defaultProps = {
	  actions: false,
	  emptyText: 'panel.empty'
	};
	
	var _default = PanelTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/panels/PanelTable.js');
	
	  __REACT_HOT_LOADER__.register(PanelTable, 'PanelTable', 'D:/a/1/s/src/web/employee/src/components/panels/PanelTable.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/panels/PanelTable.js');
	}();

	;

/***/ }),
/* 432 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var TAX_CARD_FIXED = exports.TAX_CARD_FIXED = 'TAX_CARD_FIXED';
	var TAX_CARD_SAVING = exports.TAX_CARD_SAVING = 'TAX_CARD_SAVING';
	var TAX_CARD_EDIT = exports.TAX_CARD_EDIT = 'TAX_CARD_EDIT';
	var TAX_CARD_CREATE = exports.TAX_CARD_CREATE = 'TAX_CARD_CREATE';
	
	var ACCOUNT_EDIT = exports.ACCOUNT_EDIT = 'ACCOUNT_EDIT';
	var ACCOUNT_SAVING = exports.ACCOUNT_SAVING = 'ACCOUNT_SAVING';
	var ACCOUNT_FIXED = exports.ACCOUNT_FIXED = 'ACCOUNT_FIXED';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TAX_CARD_FIXED, 'TAX_CARD_FIXED', 'D:/a/1/s/src/web/employee/src/constants/statuses.js');
	
	  __REACT_HOT_LOADER__.register(TAX_CARD_SAVING, 'TAX_CARD_SAVING', 'D:/a/1/s/src/web/employee/src/constants/statuses.js');
	
	  __REACT_HOT_LOADER__.register(TAX_CARD_EDIT, 'TAX_CARD_EDIT', 'D:/a/1/s/src/web/employee/src/constants/statuses.js');
	
	  __REACT_HOT_LOADER__.register(TAX_CARD_CREATE, 'TAX_CARD_CREATE', 'D:/a/1/s/src/web/employee/src/constants/statuses.js');
	
	  __REACT_HOT_LOADER__.register(ACCOUNT_EDIT, 'ACCOUNT_EDIT', 'D:/a/1/s/src/web/employee/src/constants/statuses.js');
	
	  __REACT_HOT_LOADER__.register(ACCOUNT_SAVING, 'ACCOUNT_SAVING', 'D:/a/1/s/src/web/employee/src/constants/statuses.js');
	
	  __REACT_HOT_LOADER__.register(ACCOUNT_FIXED, 'ACCOUNT_FIXED', 'D:/a/1/s/src/web/employee/src/constants/statuses.js');
	}();

	;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactHelmet = __webpack_require__(1654);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _reapop = __webpack_require__(44);
	
	var _reapop2 = _interopRequireDefault(_reapop);
	
	var _WebValues = __webpack_require__(850);
	
	var _language = __webpack_require__(282);
	
	var _en = __webpack_require__(1662);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _is = __webpack_require__(1663);
	
	var _is2 = _interopRequireDefault(_is);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Toolbar = __webpack_require__(871);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	var _package = __webpack_require__(1377);
	
	var _notifications = __webpack_require__(1029);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	// import Footer from '../components/Footer';
	
	var styles = {
	  grid: {
	    width: '100%',
	    padding: 0,
	    marginBottom: 0,
	    paddingTop: 64
	  }
	};
	
	(0, _reactIntl.addLocaleData)([].concat(_toConsumableArray(_en2.default), _toConsumableArray(_is2.default)));
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          isAuthenticated = _props.isAuthenticated,
	          fetchValues = _props.fetchValues;
	
	      isAuthenticated && fetchValues();
	    }
	    // Logic to check if the route being entered is suposed to be hidden from view.
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(_ref) {
	      var isAuthenticated = _ref.isAuthenticated,
	          routes = _ref.routes,
	          router = _ref.router,
	          fetchingValues = _ref.fetchingValues,
	          valuesLoaded = _ref.valuesLoaded,
	          valuesByKey = _ref.valuesByKey;
	
	      if (!valuesLoaded && !fetchingValues && isAuthenticated) {
	        this.props.fetchValues();
	      } else {
	        var _routes = routes[routes.length - 1],
	            ID = _routes.ID,
	            autoHide = _routes.autoHide;
	
	        if (valuesLoaded && valuesByKey && (!autoHide && valuesByKey['Hide.' + ID] && valuesByKey['Hide.' + ID].Value === 'true' || autoHide && (0, _lodash.get)(valuesByKey, ['Show.' + ID, 'Value']) !== 'true')) {
	          router.replace('/404');
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          routes = _props2.routes,
	          valuesLoaded = _props2.valuesLoaded,
	          isAuthenticated = _props2.isAuthenticated,
	          messages = _props2.messages,
	          language = _props2.language;
	
	      var title = routes.slice(-1)[0].name;
	      return _react2.default.createElement(
	        _reactIntl.IntlProvider,
	        {
	          locale: language,
	          messages: messages
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reapop2.default, { theme: _notifications2.default }),
	          _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	              'title',
	              null,
	              title || 'Starfsmannavefur'
	            ),
	            _react2.default.createElement('meta', { name: 'kjarni-version', content: _package.version })
	          ),
	          _react2.default.createElement(_Toolbar2.default, this.props),
	          _react2.default.createElement(
	            _reactFlexboxGrid.Grid,
	            { fluid: true, style: styles.grid },
	            valuesLoaded || !isAuthenticated ? this.props.children : _react2.default.createElement(_Loading2.default, null)
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react2.default.Component);
	
	function mapStateToProps(_ref2) {
	  var loginReducer = _ref2.loginReducer,
	      WebValuesReducer = _ref2.WebValuesReducer,
	      languageReducer = _ref2.languageReducer;
	
	  return _extends({
	    isAuthenticated: loginReducer.isAuthenticated,
	    valuesByKey: WebValuesReducer.valuesByKey,
	    valuesLoaded: WebValuesReducer.loaded,
	    fetchingValues: WebValuesReducer.isFetching
	  }, languageReducer);
	}
	
	App.propTypes = {
	  children: _propTypes2.default.object,
	  valuesByKey: _propTypes2.default.object,
	  router: _propTypes2.default.object,
	  messages: _propTypes2.default.object,
	  language: _propTypes2.default.string,
	  valuesLoaded: _propTypes2.default.bool,
	  fetchingValues: _propTypes2.default.bool,
	  isAuthenticated: _propTypes2.default.bool,
	  fetchValues: _propTypes2.default.func.isRequired,
	  routes: _propTypes2.default.array
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
	  return {
	    fetchValues: function fetchValues() {
	      return dispatch((0, _WebValues.fetchWebValues)());
	    },
	    requestLanguage: function requestLanguage(language) {
	      return dispatch((0, _language.requestLanguage)(language));
	    }
	  };
	})(App);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/App.js');
	
	  __REACT_HOT_LOADER__.register(App, 'App', 'D:/a/1/s/src/web/employee/src/containers/App.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/App.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/App.js');
	}();

	;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _leftPad = __webpack_require__(1381);
	
	var _leftPad2 = _interopRequireDefault(_leftPad);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _BankAccount = __webpack_require__(933);
	
	var _BankAccount2 = _interopRequireDefault(_BankAccount);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	// https://v0.material-ui.com/v0.20.0/#/components/text-field
	var TField = function TField(_ref) {
	  var input = _ref.input,
	      label = _ref.label,
	      customStyle = _ref.customStyle,
	      _ref$meta = _ref.meta,
	      error = _ref$meta.error,
	      active = _ref$meta.active,
	      touched = _ref$meta.touched,
	      pad = _ref.pad,
	      custom = _objectWithoutProperties(_ref, ['input', 'label', 'customStyle', 'meta', 'pad']);
	
	  return _react2.default.createElement(_TextField2.default, _extends({}, input, custom, {
	    style: _extends({}, customStyle, _BankAccount2.default.inputCon),
	    errorText: touched && error && (active ? error : ' '),
	    errorStyle: { minWidth: 100 },
	    inputStyle: _BankAccount2.default.input,
	    underlineDisabledStyle: _BankAccount2.default.inputDisabled,
	    floatingLabelText: label,
	    floatingLabelStyle: { top: '24px' },
	    onBlur: function onBlur(e) {
	      input.onBlur(e);
	      if (pad && input.value) {
	        input.onChange((0, _leftPad2.default)(input.value, pad, '0'));
	      }
	    }
	  }));
	};
	
	TField.propTypes = {
	  customStyle: _propTypes2.default.object,
	  input: _propTypes2.default.object,
	  meta: _propTypes2.default.object,
	  label: _propTypes2.default.node,
	  pad: _propTypes2.default.number
	};
	
	var _default = TField;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TField, 'TField', 'D:/a/1/s/src/web/employee/src/containers/pay/TField.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pay/TField.js');
	}();

	;

/***/ }),
/* 435 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _default = {
	  container: {
	    alignItems: 'center',
	    display: 'flex',
	    flexWrap: 'wrap',
	    justifyContent: 'space-between',
	    marginBottom: 8,
	    paddingBottom: 16,
	    paddingLeft: 16,
	    paddingRight: 16
	  },
	  editButton: {
	    height: 28,
	    lineHeight: '28px'
	  },
	  editButtonLabel: {
	    fontSize: 12,
	    paddingLeft: 6
	  },
	  inputCon: {
	    width: 120,
	    marginLeft: 8,
	    marginRight: 8,
	    cursor: 'default'
	  },
	  input: {
	    color: 'rgba(0, 0, 0, 0.870588)'
	  },
	  inputDisabled: {
	    borderBottomStyle: 'none'
	  }
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pay/styles/TaxCard.js');
	}();

	;

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};/* /common/init.js*//**
	 * @preserve Basic Primitives Diagram v3.7.8
	 * Copyright (c) 2013 - 2017 Basic Primitives Inc
	 *
	 * Non-commercial - Free
	 * http://creativecommons.org/licenses/by-nc/3.0/
	 *
	 * Commercial and government licenses:
	 * http://www.basicprimitives.com/pdf/license.pdf
	 *
	 *//* File: Basic Primitives (primitives.latest.js)*/var _jquery=__webpack_require__(198);var _jquery2=_interopRequireDefault(_jquery);__webpack_require__(528);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}var jQuery=_jquery2.default;(function(){var namespace=function namespace(name){var namespaces=name.split('.'),namespace=window,index;for(index=0;index<namespaces.length;index+=1){namespace=namespace[namespaces[index]]=namespace[namespaces[index]]||{};}return namespace;};namespace("primitives.common");namespace("primitives.common.perimeter");namespace("primitives.orgdiagram");namespace("primitives.famdiagram");namespace("primitives.text");namespace("primitives.callout");namespace("primitives.connector");namespace("primitives.shape");namespace("primitives.pdf");namespace("primitives.pdf.orgdiagram");namespace("primitives.pdf.famdiagram");})();/* /common/functions.js*//*
		Function: primitives.common.isNullOrEmpty
		Indicates whether the specified string is null or an Empty string.
	
		Parameters:
		value - The string to test.
		Returns:
		true if the value is null or an empty string(""); otherwise, false.
	*/primitives.common.isNullOrEmpty=function(value){var result=true,string;if(value!==undefined&&value!==null){string=value.toString();if(string.length>0){result=false;}}return result;};/*
		Function: primitives.common.isArray
		Indicates whether the specified value is array.
	
		Parameters:
		value - The value to test.
		Returns:
		true if the value is array; otherwise, false.
	*/primitives.common.isArray=Array.isArray||function(val){return val instanceof Array;};/*
		Function: primitives.common.loop
		Method to loop through array of object properties
	
		Parameters:
		thisArg - Call back function call context.
		items - array of items or object with properties to itterate on
		onItem - call back function to call on each item in the array or object. If call back function returns true then break itteration
	*/primitives.common.loop=function(thisArg,items,onItem){// onItem([index,key], value)
	var key,index,len;if(onItem!=null){if(primitives.common.isArray(items)){for(index=0,len=items.length;index<len;index+=1){if(onItem.call(thisArg,index,items[index])){break;}}}else{for(key in items){if(items.hasOwnProperty(key)){if(onItem.call(thisArg,key,items[key])){break;}}}}}};/*
		Function: primitives.common.splitCamelCaseName
		Split string of merged cameled words into array.
	
		Parameters:
		name - The string to split.
		Returns:
		array of split words
	*/primitives.common.splitCamelCaseName=function(name){var result=[];var word="";for(var i=0;i<name.length;i+=1){var c=name[i];if(c>='A'&&c<='Z'){if(word!==""){result.push(word);}word=c;}else{word+=c;}}if(word!==""){result.push(word);}return result;};/*
		Function: primitives.common.isEmptyObject
		Indicates whether the specified object is empty.
	
		Parameters:
		item - The object to test.
		Returns:
		true if the item is object otherwise, false.
	*/primitives.common.isObject=function(item){return item!==null&&(typeof item==='undefined'?'undefined':_typeof(item))=='object';};/*
		Function: primitives.common.isEmptyObject
		Indicates whether the specified object is empty.
	
		Parameters:
		item - The object to test.
		Returns:
		true if the item is object otherwise, false.
	*/primitives.common.isEmptyObject=function(item){var key;for(key in item){if(item.hasOwnProperty(key)){return false;}}return true;};/*
		Function: primitives.common.deepClone
		Makes deep copy of variable.
	
		Parameters:
		source - Source value.
		keepContext - if true then it makes _context reference property of every copied object
		callback - is function called for every object property function(result, source, property) {}
	
		Returns:
		Copy of cloned variable.
	*/primitives.common.cloneObject=function(source,isShallow){var result;if(source===null){result=null;}else if(source instanceof Array){if(isShallow){result=source.slice(0);}else{result=[];for(var index=0,len=source.length;index<len;index+=1){result.push(primitives.common.cloneObject(source[index],isShallow));}}}else{switch(typeof source==='undefined'?'undefined':_typeof(source)){case'object':result={};for(var property in source){if(source.hasOwnProperty(property)){if(isShallow){result[property]=source[property];}else{result[property]=primitives.common.cloneObject(source[property],isShallow);}}}break;default:result=source;break;}}return result;};/*
		Function: primitives.common.hashCode
		Returns hash code for specified string value.
	
		Parameters:
		value - The string to calculate hash code.
		Returns:
		int hash code.
	*/primitives.common.hashCode=function(value){var hash=0,character,i;/*ignore jslint start*/if(value.length>0){for(i=0;i<value.length;i+=1){character=value.charCodeAt(i);hash=(hash<<5)-hash+character;hash=hash&hash;}}/*ignore jslint end*/return hash;};/*
		Function: primitives.common.css
		This method assigns HTML element style attributes only if one of them does not match its current value.
		This function helps to reduce number of HTML page layout invalidations.
	
		Parameters:
		element - jQuery selector of element to be updated.
		attr - object containing style attributes.
	*/primitives.common.css=function(element,attr){var attribute,value;if(element.hasOwnProperty("cssHash")){for(attribute in attr){if(attr.hasOwnProperty(attribute)){value=attr[attribute];if(element.cssHash[attribute]!=value){element.cssHash[attribute]=value;element.css(attribute,value);}}}}else{element.css(attr);element.cssHash=attr;}};/*
		Function: primitives.common.stopPropogation
		This method uses various approaches used in different browsers to stop event propagation.
		Parameters:
		event - Event to be stopped.
	*/primitives.common.stopPropagation=function(event){if(event.stopPropagation!==undefined){event.stopPropagation();}else if(event.cancelBubble!==undefined){event.cancelBubble=true;}else if(event.preventDefault!==undefined){event.preventDefault();}};/*
		Function: primitives.common.indexOf
		Searches array for specified item and returns index (or -1 if not found)
		Parameters:
		vector - An array through which to search.
		item - The value to search for.
		Returns:
		Index of search item or -1 if not found.
	*/primitives.common.indexOf=function(vector,item,compFunc){var index,treeItem;for(index=0;index<vector.length;index+=1){treeItem=vector[index];if(compFunc!=null?compFunc(treeItem,item):treeItem===item){return index;}}return-1;};primitives.common._supportsSVG=null;/*
		Function: primitives.common.supportsSVG
		Indicates whether the browser supports SVG graphics.
	
		Returns:
		true if browser supports SVG graphics.
	*/primitives.common.supportsSVG=function(){if(primitives.common._supportsSVG===null){primitives.common._supportsSVG=document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#BasicStructure","1.1")||document.implementation.hasFeature("http://www.w3.org/TR/SVG11/feature#Shape","1.0");}return primitives.common._supportsSVG;};primitives.common._supportsVML=null;/*
		Function: primitives.common.supportsVML
		Indicates whether the browser supports VML graphics. It is applicable to Internet Explorer only. This graphics mode is depricated in favour of SVG.
	
		Returns:
		true if browser supports VML graphics.
	*/primitives.common.supportsVML=function(){var div,shape;if(primitives.common._supportsVML===null){primitives.common._supportsVML=false;if(!jQuery.support.opacity){div=document.createElement('div');div=document.body.appendChild(div);div.innerHTML='<v:shape adj="1" />';shape=div.firstChild;shape.style.behavior="url(#default#VML)";primitives.common._supportsVML=shape?_typeof(shape.adj)==="object":false;div.parentNode.removeChild(div);}}return primitives.common._supportsVML;};primitives.common._supportsCanvas=null;/*
		Function: primitives.common.supportsCanvas
		Indicates whether the browser supports HTML Canvas graphics.
	
		Returns:
		true if browser supports HTML Canvas graphics.
	*/primitives.common.supportsCanvas=function(){if(primitives.common._supportsCanvas===null){primitives.common._supportsCanvas=!!window.HTMLCanvasElement;}return primitives.common._supportsCanvas;};primitives.common.createGraphics=function(preferred,widget){var result=null,modes,key,index;modes=[preferred];for(key in primitives.common.GraphicsType){if(primitives.common.GraphicsType.hasOwnProperty(key)){modes.push(primitives.common.GraphicsType[key]);}}for(index=0;result===null&&index<modes.length;index+=1){switch(modes[index]){case 2/*primitives.common.GraphicsType.VML*/:if(primitives.common.supportsVML()){result=new primitives.common.VmlGraphics(widget);}break;case 0/*primitives.common.GraphicsType.SVG*/:if(primitives.common.supportsSVG()){result=new primitives.common.SvgGraphics(widget);}break;case 1/*primitives.common.GraphicsType.Canvas*/:if(primitives.common.supportsCanvas()){result=new primitives.common.CanvasGraphics(widget);}break;}}return result;};/*
		Function: primitives.common.getColorHexValue
		Converts color string into HEX color string.
	
		Parameters:
		color - regular HTML color string.
	
		Returns:
			Color value in form of HEX string.
	*/primitives.common.getColorHexValue=function(color){var digits,red,green,blue,rgb,colorIndex,colorKey;if(color.substr(0,1)==='#'){return color;}/*ignore jslint start*/digits=/(.*?)rgb\((\d+), (\d+), (\d+)\)/.exec(color);/*ignore jslint end*/if(digits!==null&&digits.length>0){red=parseInt(digits[2],10);green=parseInt(digits[3],10);blue=parseInt(digits[4],10);/*ignore jslint start*/rgb=(red<<16|green<<8|blue).toString(16);/*ignore jslint end*/return digits[1]+"000000".substr(0,6-rgb.length)+rgb;}if(primitives.common.ColorHexs===undefined){primitives.common.ColorHexs={};colorIndex=0;for(colorKey in primitives.common.Colors){if(primitives.common.Colors.hasOwnProperty(colorKey)){primitives.common.ColorHexs[colorKey.toUpperCase()]=primitives.common.Colors[colorKey];colorIndex+=1;}}}return primitives.common.ColorHexs[color.toUpperCase()];};/*
		Function: primitives.common.getColorName
			Converts color string into HTML color name string or return hex color string.
	
		Parameters:
		color - regular HTML color string.
	
		Returns:
			HTML Color name or HEX string.
	*/primitives.common.getColorName=function(color){var colorIndex,colorKey;color=primitives.common.getColorHexValue(color);if(primitives.common.ColorNames===undefined){primitives.common.ColorNames={};colorIndex=0;for(colorKey in primitives.common.Colors){if(primitives.common.Colors.hasOwnProperty(colorKey)){primitives.common.ColorNames[primitives.common.Colors[colorKey]]=colorKey;colorIndex+=1;}}}return primitives.common.ColorNames[color];};/*
		Function: primitives.common.getRed
			Gets red value of HEX color string.
	
		Parameters:
		color - HEX string color value.
	
		Returns:
			Int value.
	*/primitives.common.getRed=function(color){if(color.substr(0,1)==='#'&&color.length===7){return parseInt(color.substr(1,2),16);}return null;};/*
		Function: primitives.common.getGreen
			Gets green value of HEX color string.
	
		Parameters:
		color - HEX string color value.
	
		Returns:
			Int value.
	*/primitives.common.getGreen=function(color){if(color.substr(0,1)==='#'&&color.length===7){return parseInt(color.substr(3,2),16);}return null;};/*
		Function: primitives.common.getBlue
			Gets blue value of HEX color string.
	
		Parameters:
		color - HEX string color value.
	
		Returns:
			Int value.
	*/primitives.common.getBlue=function(color){if(color.substr(0,1)==='#'&&color.length===7){return parseInt(color.substr(5,2),16);}return null;};/*
		Function: primitives.common.beforeOpacity
			Calculates before opacity color value producing color you need after applying opacity.
	
		Parameters:
		color - Color you need after applying opacity.
		opacity - Value of opacity.
	
		Returns:
			HEX color value.
	*/primitives.common.beforeOpacity=function(color,opacity){var common=primitives.common,red,green,blue,rgb;color=common.getColorHexValue(color);red=Math.ceil((common.getRed(color)-(1.0-opacity)*255.0)/opacity);green=Math.ceil((common.getGreen(color)-(1.0-opacity)*255.0)/opacity);blue=Math.ceil((common.getBlue(color)-(1.0-opacity)*255.0)/opacity);/*ignore jslint start*/rgb=(red<<16|green<<8|blue).toString(16);/*ignore jslint end*/return'#'+"000000".substr(0,6-rgb.length)+rgb;};/*
		Function: primitives.common.highestContrast
			Calculates contrast between base color and two optional first and second colors
			and returns the one which has highest contrast.
	
		Parameters:
		baseColor - Base color to compare with.
		firstColor - First color.
		secondColor - Second color.
	
		Returns:
			Color value.
	*/primitives.common.highestContrast=function(baseColor,firstColor,secondColor){var result=firstColor,common=primitives.common,key=baseColor+","+firstColor+","+secondColor;if(common.highestContrasts===undefined){common.highestContrasts={};}if(common.highestContrasts.hasOwnProperty(key)){result=common.highestContrasts[key];}else{if(common.luminosity(firstColor,baseColor)<common.luminosity(secondColor,baseColor)){result=secondColor;}common.highestContrasts[key]=result;}return result;};/*
		Function: primitives.common.luminosity
			Calculates luminosity between two HEX string colors.
	
		Parameters:
		firstColor - First color.
		secondColor - Second color.
	
		Returns:
			Luminosity value
	*/primitives.common.luminosity=function(firstColor,secondColor){var result,common=primitives.common,first=common.getColorHexValue(firstColor),second=common.getColorHexValue(secondColor),firstLuminosity=0.2126*Math.pow(common.getRed(first)/255.0,2.2)+0.7152*Math.pow(common.getRed(first)/255.0,2.2)+0.0722*Math.pow(common.getRed(first)/255.0,2.2),secondLuminosity=0.2126*Math.pow(common.getRed(second)/255.0,2.2)+0.7152*Math.pow(common.getRed(second)/255.0,2.2)+0.0722*Math.pow(common.getRed(second)/255.0,2.2);if(firstLuminosity>secondLuminosity){result=(firstLuminosity+0.05)/(secondLuminosity+0.05);}else{result=(secondLuminosity+0.05)/(firstLuminosity+0.05);}return result;};/*
		Function: primitives.common.compareArrays
			Compares non-object non-sorted arrays.
	
		Parameters:
		array1 - First array.
		array2 - Second array.
	
		Returns:
			True if arrays are identical.
	*/primitives.common.compareArrays=function(array1,array2,getKeyFunc){var result=true,index,len,value,hashArray1;if(array1.length!=array2.length){result=false;}else{hashArray1={};for(index=0,len=array1.length;index<len;index+=1){value=getKeyFunc!=null?getKeyFunc(array1[index]):array1[index];if(hashArray1.hasOwnProperty(value)){hashArray1[value]+=1;}else{hashArray1[value]=1;}}for(index=0,len=array2.length;index<len;index+=1){value=getKeyFunc!=null?getKeyFunc(array2[index]):array2[index];if(!hashArray1.hasOwnProperty(value)){result=false;break;}else{hashArray1[value]-=1;if(hashArray1[value]<0){result=false;break;}}}}return result;};/* /common/mouse.js*//*global mouseDelayMet*/var mouseDelayMet=true;primitives.common.Mouse=function(){var data={distance:3,delay:0,element:null,name:null,onMouseStart:null,onMouseDrag:null,onMouseStop:null,onMouseCapture:null},cancel="input,textarea,button,select,option",mouseDownEvent,mouseStarted,started;function _mouseInit(element,options){data.element=element;for(var option in options){if(options.hasOwnProperty(option)){data[option]=options[option];}}data.element.bind("mousedown."+data.name,function(event){return _mouseDown(event);}).bind("click."+data.name,function(event){if(true===jQuery.data(event.target,data.name+".preventClickEvent")){jQuery.removeData(event.target,data.name+".preventClickEvent");event.stopImmediatePropagation();return false;}});started=false;}// make sure destroying one instance of mouse doesn't mess with
	// other instances of mouse
	function _mouseDestroy(){data.element.unbind("."+data.name);if(_mouseMoveDelegate){jQuery(document).unbind("mousemove."+data.name,_mouseMoveDelegate).unbind("mouseup."+data.name,_mouseUpDelegate);}}function _mouseDown(event){// don't let more than one widget handle mouseStart
	if(primitives.common.Mouse.MouseHandled){return;}// we may have missed mouseup (out of window)
	mouseStarted&&_mouseUp(event);//ignore jslint
	mouseDownEvent=event;var btnIsLeft=event.which===1,// event.target.nodeName works around a bug in IE 8 with
	// disabled inputs (#7620)
	elIsCancel=typeof cancel==="string"&&event.target.nodeName?jQuery(event.target).closest(cancel).length:false;if(!btnIsLeft||elIsCancel||!_mouseCapture(event)){return true;}mouseDelayMet=!data.delay;//ignore jslint
	if(!mouseDelayMet){_mouseDelayTimer=setTimeout(function(){//ignore jslint
	mouseDelayMet=true;//ignore jslint
	},data.delay);}if(_mouseDistanceMet(event)&&_mouseDelayMet(event)){mouseStarted=_mouseStart(event)!==false;if(!mouseStarted){event.preventDefault();return true;}}// Click event may never have fired (Gecko & Opera)
	if(true===jQuery.data(event.target,data.name+".preventClickEvent")){jQuery.removeData(event.target,data.name+".preventClickEvent");}jQuery(document).bind("mousemove."+data.name,_mouseMoveDelegate).bind("mouseup."+data.name,_mouseUpDelegate);event.preventDefault();primitives.common.Mouse.MouseHandled=true;return true;}// these delegates are required to keep context
	function _mouseMoveDelegate(event){return _mouseMove(event);}function _mouseUpDelegate(event){return _mouseUp(event);}function _mouseMove(event){// IE mouseup check - mouseup happened when mouse was out of window
	if(jQuery.ui.ie&&(!document.documentMode||document.documentMode<9)&&!event.button){return _mouseUp(event);}if(mouseStarted){_mouseDrag(event);return event.preventDefault();}if(_mouseDistanceMet(event)&&_mouseDelayMet(event)){mouseStarted=_mouseStart(mouseDownEvent,event)!==false;mouseStarted?_mouseDrag(event):_mouseUp(event);//ignore jslint
	}return!mouseStarted;}function _mouseUp(event){jQuery(document).unbind("mousemove."+data.name,_mouseMoveDelegate).unbind("mouseup."+data.name,_mouseUpDelegate);if(mouseStarted){mouseStarted=false;if(event.target===mouseDownEvent.target){jQuery.data(event.target,data.name+".preventClickEvent",true);}_mouseStop(event);}return false;}function _mouseDistanceMet(event){return Math.max(Math.abs(mouseDownEvent.pageX-event.pageX),Math.abs(mouseDownEvent.pageY-event.pageY))>=data.distance;}function _mouseDelayMet()/* event */{return mouseDelayMet;}function _mouseStart(event){if(data.onMouseStart!=null){data.onMouseStart(event);}}function _mouseDrag(event){if(data.onMouseDrag!=null){data.onMouseDrag(event);}}function _mouseStop(event){if(data.onMouseStop!=null){data.onMouseStop(event);}}function _mouseCapture(event){if(data.onMouseCapture!=null){return data.onMouseCapture(event);}return true;}function isStarted(){return mouseStarted;}return{init:_mouseInit,destroy:_mouseDestroy,isStarted:isStarted};};primitives.common.Mouse.MouseHandled=false;if(typeof jQuery!="undefined"){jQuery(document).mouseup(function(){primitives.common.Mouse.MouseHandled=false;});}/* /enums/AdviserPlacementType.js*//*
		Enum: primitives.common.AdviserPlacementType
			Defines item placement in tree relative to parent.
	
		Auto - Layout manager defined.
		Left - Item placed on the left side of parent.
		Right - Item placed on the right side of parent.
	*/primitives.common.AdviserPlacementType={Auto:0,Left:2,Right:3};primitives.orgdiagram.AdviserPlacementType=primitives.common.AdviserPlacementType;/* /enums/VerticalAlignmentType.js*//*
		Enum: primitives.common.VerticalAlignmentType
		Defines text label alignment inside text box boundaries.
	
		Top - Positined at the top of text box
		Middle - Aligned to the middle
		Bottom - Aligned to the bottom of text box
	*/primitives.common.VerticalAlignmentType={Top:0,Middle:1,Bottom:2};/* /enums/VectorRelationType.js*/primitives.common.VectorRelationType={None:0,Null:1,Collinear:2,Opposite:3};/* /enums/UpdateMode.js*//*
		Enum: primitives.common.UpdateMode
			Defines redraw mode of diagram.
	
		Recreate - Forces widget to make a full chart redraw. It is equivalent to initial chart creation.
		It removes everything from chart layout and recreares all elements again. For example when you
		open chart in jQuery UI dDialog you have to use this mode, since jQuery UI invalidates VML graphics elements in the DOM, so
		the only way to update chart is to recreate its contents.
		Refresh - This update mode is optimized for widget fast redraw caused by resize or changes of
		next options: <primitives.orgdiagram.Config.items>, <primitives.orgdiagram.Config.cursorItem>
		or <primitives.orgdiagram.Config.selectedItems>.
		PositonHighlight - This update mode redraws only <primitives.orgdiagram.Config.highlightItem>.
	
		See Also:
			<primitives.orgdiagram.Config.update>
	*/primitives.common.UpdateMode={Recreate:0,Refresh:1,PositonHighlight:2};primitives.orgdiagram.UpdateMode=primitives.common.UpdateMode;/* /enums/TextOrientationType.js*//*
		Enum: primitives.text.TextOrientationType
			Defines label orientation type.
	
		Horizontal - Regular horizontal text.
		RotateLeft - Rotate all text 90 degree.
		RotateRight - Rotate all text 270 degree.
	*/primitives.text.TextOrientationType={Horizontal:0,RotateLeft:1,RotateRight:2,Auto:3};/* /enums/SideFlag.js*/primitives.common.SideFlag={Top:1,Right:2,Bottom:4,Left:8};/* /enums/ShapeType.js*//*
		Enum: primitives.common.ShapeType
			Defines shape type.
	
		Rectangle - rectangle
		Oval - oval
		Triangle - triangle
		CrossOut - cross out
		Circle - circle
		Rhombus - rhombus
		Wedge - wedge
		FramedOval - Framed Oval
		FramedTriangle - Framed Triangle
		FramedWedge - Framed Wedge
		FramedRhombus - Framed Rhombus
	*/primitives.common.ShapeType={Rectangle:0,Oval:1,Triangle:2,CrossOut:3,Circle:4,Rhombus:5,Wedge:7,FramedOval:8,FramedTriangle:9,FramedWedge:10,FramedRhombus:11,None:6};/* /enums/SelectionPathMode.js*//*
		Enum: primitives.common.SelectionPathMode
			Defines the display mode for items between root item of diagram and selected items.
	
		None - Selection path items placed and sized as regular diagram items.
		FullStack - Selection path items are shown in normal template mode.
	*/primitives.common.SelectionPathMode={None:0,FullStack:1};primitives.orgdiagram.SelectionPathMode=primitives.common.SelectionPathMode;/* /enums/SegmentType.js*/primitives.common.SegmentType={Line:0,Move:1,QuadraticArc:2,CubicArc:3,Dot:4};/* /enums/RenderingMode.js*//*
		Enum: primitives.common.RenderingMode
		This enumeration is used as option in arguments of rendering events.
		It helps to tell template initialization stage,
		for example user can widgitize some parts of template on create
		and update and refresh them in template update stage.
	
		Create - Template is just created.
		Update - Template is reused and update needed.
	*/primitives.common.RenderingMode={Create:0,Update:1};/* /enums/PlacementType.js*//*
		Enum: primitives.common.PlacementType
			Defines element placement relative to rectangular area.
	
		Auto - Depends on implementation
		Left - Left side
		Top - Top side
		Right - Right side
		Bottom - Bottom side
		TopLeft - Top left side
		TopRight - Top right side
		BottomLeft - Bottom left side
		BottomRight - Bottom right side
		LeftTop - Left Top side
		LeftBottom - Left Bottom side
		RightTop - Right Top side
		RightBottom - Right Bottom side
	*/primitives.common.PlacementType={Auto:0,TopLeft:8,Top:1,TopRight:2,RightTop:11,Right:3,RightBottom:12,BottomRight:4,Bottom:5,BottomLeft:6,LeftBottom:10,Left:7,LeftTop:9};/* /enums/PageFitMode.js*//*
		Enum: primitives.common.PageFitMode
			Defines diagram auto fit mode.
	
		None - All diagram items are shown in normal template mode.
		PageWidth - Diagram tries to layout and auto size items in order to fit diagram into available page width.
		PageHeight - Diagram tries to layout and auto size items in order to fit diagram into available page height.
		FitToPage - Diagram tries to layout and auto size items in order to fit diagram into available page size.
		PrintPreview - Enable chart print preview mode. In this mode chart draws grid of pages in the background and aligns items, so they are not cut by page boundaries.
		AutoSize - Chart sets its placeholder div size to fit its contents without minimizing items.
	*/primitives.common.PageFitMode={None:0,PageWidth:1,PageHeight:2,FitToPage:3,PrintPreview:4,AutoSize:5,SelectionOnly:6};primitives.orgdiagram.PageFitMode=primitives.common.PageFitMode;/* /enums/OrientationType.js*//*
		Enum: primitives.common.OrientationType
			Defines diagram orientation type.
	
		Top - Vertical orientation having root item at the top.
		Bottom - Vertical orientation having root item at the bottom.
		Left - Horizontal orientation having root item on the left.
		Right - Horizontal orientation having root item on the right.
	*/primitives.common.OrientationType={Top:0,Bottom:1,Left:2,Right:3,None:4};primitives.orgdiagram.OrientationType=primitives.common.OrientationType;/* /enums/NeighboursSelectionMode.js*//*
		Enum: primitives.common.NeighboursSelectionMode
			Defines the display mode for items related to current cursor item in diagram.
	
		ParentsAndChildren - Parents and children of cursor item placed and sized as regular diagram items.
		ParentsChildrenSiblingsAndSpouses - Parents, children, siblings and spouses of cursor item placed and sized as regular diagram items.
	*/primitives.common.NeighboursSelectionMode={ParentsAndChildren:0,ParentsChildrenSiblingsAndSpouses:1};/* /enums/NavigationMode.js*//*
		Enum: primitives.common.NavigationMode
			Defines control navigation mode. By default control replicates interactivity of regular Tree control.
			It has highlight for mouse over feedback over nodes and it has cursor for showing currently selected single node in diagram.
			In order to avoid children nodes folding and unfolding, this functionality is done automatically for current cursor item.
			So cursor plays vital role for unfolding of nodes and zooming into area of user interest in diagram.
	
		Default - Highlight & Cursor
		CursorOnly - Cursor only.
		HighlightOnly - Highlight only. This mode is usefull for touch devices. Since it requires minimal layout changes and renderings.
		Inactive - No user interactivity.
	
		See Also:
			<primitives.orgdiagram.Config.navigationMode>
			<primitives.famdiagram.Config.navigationMode>
	*/primitives.common.NavigationMode={Default:0,CursorOnly:1,HighlightOnly:3,Inactive:2};/* /enums/LineType.js*//*
		Enum: primitives.common.LineType
			Defines type of line pattern. Dash and dot intervals depend on line width.
	
		Solid - Regular solid line.
		Dotted - Dots.
		Dashed - Dashes.
	*/primitives.common.LineType={Solid:0,Dotted:1,Dashed:2};/* /enums/Layers.js*/primitives.common.Layers={PrintPreview:1,BackgroundAnnotation:2,BackgroundAnnotations:3,BackgroundConnectorAnnotation:4,BackgroundHighlightPathAnnotations:5,Connector:6,ForegroundHighlightPathAnnotations:7,Highlight:8,Marker:9,Label:10,Cursor:11,Item:12,ForegroundAnnotations:13,ForegroundConnectorAnnotation:14,Annotation:15,Controls:16};/* /enums/LabelType.js*/primitives.common.LabelType={Regular:0,Dummy:1,Fixed:2};/* /enums/AnnotationType.js*//*
		Enum: primitives.common.AnnotationType
			Defines type of annotation object.
	
		Connector - Connector lines between two rectangular areas.
		Shape - Shape around rectanglur area.
		HighlightPath - Use highlight properties for connector lines between items.
	*/primitives.common.AnnotationType={Connector:0,Shape:1,HighlightPath:2,Label:3,Background:4};/* /enums/ChildrenPlacementType.js*//*
		Enum: primitives.common.ChildrenPlacementType
			Defines children placement shape.
	
		Auto - Children placement auto defined.
		Vertical - Children form vertical column.
		Horizontal - Children placed horizontally.
		Matrix - Children placed in form of matrix.
	*/primitives.common.ChildrenPlacementType={Auto:0,Vertical:1,Horizontal:2,Matrix:3};primitives.orgdiagram.ChildrenPlacementType=primitives.common.ChildrenPlacementType;/* /enums/Colors.js*//*
		Enum: primitives.common.Colors
			Named colors.
	
	*/primitives.common.Colors={AliceBlue:"#f0f8ff",AntiqueWhite:"#faebd7",Aqua:"#00ffff",Aquamarine:"#7fffd4",Azure:"#f0ffff",Beige:"#f5f5dc",Bisque:"#ffe4c4",Black:"#000000",BlanchedAlmond:"#ffebcd",Blue:"#0000ff",BlueViolet:"#8a2be2",Brown:"#a52a2a",BurlyWood:"#deb887",Bronze:"#cd7f32",CadetBlue:"#5f9ea0",ChartReuse:"#7fff00",Chocolate:"#d2691e",Coral:"#ff7f50",CornflowerBlue:"#6495ed",Cornsilk:"#fff8dc",Crimson:"#dc143c",Cyan:"#00ffff",DarkBlue:"#00008b",DarkCyan:"#008b8b",DarkGoldenrod:"#b8860b",DarkGray:"#a9a9a9",DarkGreen:"#006400",DarkKhaki:"#bdb76b",DarkMagenta:"#8b008b",DarkOliveGreen:"#556b2f",Darkorange:"#ff8c00",DarkOrchid:"#9932cc",DarkRed:"#8b0000",DarkSalmon:"#e9967a",DarkSeaGreen:"#8fbc8f",DarkSlateBlue:"#483d8b",DarkSlateGray:"#2f4f4f",DarkTurquoise:"#00ced1",DarkViolet:"#9400d3",DeepPink:"#ff1493",DeepSkyBlue:"#00bfff",DimGray:"#696969",DodgerBlue:"#1e90ff",FireBrick:"#b22222",FloralWhite:"#fffaf0",ForestGreen:"#228b22",Fuchsia:"#ff00ff",Gainsboro:"#dcdcdc",GhostWhite:"#f8f8ff",Gold:"#ffd700",Goldenrod:"#daa520",Gray:"#808080",Green:"#008000",GreenYellow:"#adff2f",Honeydew:"#f0fff0",Hotpink:"#ff69b4",IndianRed:"#cd5c5c",Indigo:"#4b0082",Ivory:"#fffff0",Khaki:"#f0e68c",Lavender:"#e6e6fa",LavenderBlush:"#fff0f5",Lawngreen:"#7cfc00",Lemonchiffon:"#fffacd",LightBlue:"#add8e6",LightCoral:"#f08080",LightCyan:"#e0ffff",LightGoldenrodYellow:"#fafad2",LightGray:"#d3d3d3",LightGreen:"#90ee90",LightPink:"#ffb6c1",LightSalmon:"#ffa07a",LightSeaGreen:"#20b2aa",LightSkyBlue:"#87cefa",LightSlateGray:"#778899",LightSteelBlue:"#b0c4de",LightYellow:"#ffffe0",Lime:"#00ff00",Limegreen:"#32cd32",Linen:"#faf0e6",Magenta:"#ff00ff",Maroon:"#800000",MediumAquamarine:"#66cdaa",MediumBlue:"#0000cd",MediumOrchid:"#ba55d3",MediumPurple:"#9370d8",MediumSeaGreen:"#3cb371",MediumSlateBlue:"#7b68ee",MediumSpringGreen:"#00fa9a",MediumTurquoise:"#48d1cc",MediumVioletRed:"#c71585",MidnightBlue:"#191970",MintCream:"#f5fffa",MistyRose:"#ffe4e1",Moccasin:"#ffe4b5",NavajoWhite:"#ffdead",Navy:"#000080",Oldlace:"#fdf5e6",Olive:"#808000",Olivedrab:"#6b8e23",Orange:"#ffa500",OrangeRed:"#ff4500",Orchid:"#da70d6",PaleGoldenRod:"#eee8aa",PaleGreen:"#98fb98",PaleTurquoise:"#afeeee",PaleVioletRed:"#d87093",Papayawhip:"#ffefd5",Peachpuff:"#ffdab9",Peru:"#cd853f",Pink:"#ffc0cb",Plum:"#dda0dd",PowderBlue:"#b0e0e6",Purple:"#800080",Red:"#ff0000",RosyBrown:"#bc8f8f",RoyalBlue:"#4169e1",SaddleBrown:"#8b4513",Salmon:"#fa8072",SandyBrown:"#f4a460",SeaGreen:"#2e8b57",Seashell:"#fff5ee",Sienna:"#a0522d",Silver:"#c0c0c0",SkyBlue:"#87ceeb",SlateBlue:"#6a5acd",SlateGray:"#708090",Snow:"#fffafa",SpringGreen:"#00ff7f",SteelBlue:"#3B53A7",Tan:"#d2b48c",Teal:"#008080",Thistle:"#d8bfd8",Tomato:"#ff6347",Turquoise:"#40e0d0",Violet:"#ee82ee",Wheat:"#f5deb3",White:"#ffffff",WhiteSmoke:"#f5f5f5",Yellow:"#ffff00",YellowGreen:"#9acd32"};/* /enums/ConnectorLabelPlacementType.js*//*
		Enum: primitives.common.ConnectorLabelPlacementType
		Defines connector label placement.
	
	
		From - Place at the "from" rectangle
		Between - Place along connector line, between rectangles
		To - Place at "to" rectangle
	*/primitives.common.ConnectorLabelPlacementType={From:0,Between:1,To:2};/* /enums/ConnectorPlacementType.js*//*
		Enum: primitives.common.ConnectorPlacementType
			Defines connector annotation shape placement mode between two rectangles.
	
		Offbeat - place connector annotation in the way that it does not overlap base hierarchy connector lines.
		Straight - direct connection between centers of rectangles.
	*/primitives.common.ConnectorPlacementType={Offbeat:0,Straight:1};/* /enums/ConnectorShapeType.js*//*
		Enum: primitives.common.ConnectorShapeType
			Defines connector shape style between two rectangles.
	
		SingleLine - Single line.
		DoubleLine - Double line.
	*/primitives.common.ConnectorShapeType={OneWay:0,TwoWay:1,BothWay:2};/* /enums/Visibility.js*//*
		Enum: primitives.common.Visibility
			Defines nodes visibility mode.
	
		Auto - Auto select best visibility mode.
		Normal - Show node in normal template mode.
		Dot - Show node as dot.
		Line - Show node as line.
		Invisible - Make node invisible.
	
		See Also:
	
			<primitives.orgdiagram.Config.minimalVisibility>
	*/primitives.common.Visibility={Auto:0,Normal:1,Dot:2,Line:3,Invisible:4};/* /enums/ConnectorStyleType.js*/primitives.common.ConnectorStyleType={Extra:0,Regular:1,Highlight:2};/* /enums/ElbowType.js*//*
		Enum: primitives.common.ElbowType
			Defines type of connector line elbow style.
	
		Dot - Two lines intersection marked with dot.
		Angular - Squared connection has angular .
		Dashed - Dashes.
	*/primitives.common.ElbowType={None:0,Dot:1,Bevel:2,Round:3};/* /enums/Enabled.js*//*
		Enum: primitives.common.Enabled
			Defines option state.
	
		Auto - Option state is auto defined.
		True - Enabled.
		False - Disabled.
	*/primitives.common.Enabled={Auto:0,True:1,False:2};/* /enums/GraphicsType.js*//*
		Enum: primitives.ocommon.GraphicsType
			Graphics type.
	
		VML - Vector Markup Language. It is only graphics mode available in IE6, IE7 and IE8.
		SVG - Scalable Vector Graphics. Proportionally scales on majority of device. It is not available on Android 2.3 devices and earlier.
		Canvas - HTML canvas graphics. It is available everywhere except IE6, IE7 and IE8. It requires widget redraw after zooming page.
	*/primitives.common.GraphicsType={SVG:0,Canvas:1,VML:2};/* /enums/GroupByType.js*//*
		Enum: primitives.common.GroupByType
			Defines objects gravity in chart.
	
		Parents - To parents.
		Children - To children.
	*/primitives.common.GroupByType={None:0,Parents:1,Children:2};/* /enums/HorizontalAlignmentType.js*//*
		Enum: primitives.common.HorizontalAlignmentType
		Defines text label alignment inside text box boundaries.
	
		Center - Positooned in the middle of the text box
		Left - Aligned to the begging of the text box
		Right - Aligned to the end of text box
	*/primitives.common.HorizontalAlignmentType={Center:0,Left:1,Right:2};/* /enums/ItemType.js*//*
		Enum: primitives.orgdiagram.ItemType
			Defines diagram item type.
	
		Regular - Regular item.
		Assistant - Child item which is placed at separate level above all other children, but below parent item. It has connection on its side.
		Adviser - Child item which is placed at the same level as parent item. It has connection on its side.
		SubAssistant - Child item which is placed at separate level above all other children, but below parent item.  It has connection on its top.
		SubAdviser - Child item placed at the same level as parent item. It has connection on its top.
		GeneralPartner - Child item placed at the same level as parent item and visually grouped with it together via sharing common parent and children.
		LimitedPartner - Child item placed at the same level as parent item and visually grouped with it via sharing common children.
		AdviserPartner - Child item placed at the same level as parent item. It has connection on its side. It is visually grouped with it via sharing common children.
	*/primitives.orgdiagram.ItemType={Regular:0,Assistant:1,SubAssistant:4,SuperAssistant:10,SuperAdviser:9,SubAdviser:5,Adviser:2,Director:11,GeneralPartner:6,LimitedPartner:7,AdviserPartner:8};/* /enums/ConnectorType.js*//*
		Enum: primitives.common.ConnectorType
			Defines diagram connectors style for dot and line elements.
	
		Squared - Connector lines use only right angles.
		Angular - Connector lines use angular lines comming from common vertex.
		Curved - Connector lines are splines comming from common vertex.
	*/primitives.common.ConnectorType={Squared:0,Angular:1,Curved:2};primitives.orgdiagram.ConnectorType=primitives.common.ConnectorType;/* /enums/ZOrderType.js*//*
		Enum: primitives.common.ZOrderType
			Defines elements Z order. This option is used to place annotations relative to chart.
	
		Auto - Auto selects best order depending on type of element.
		Background - Place element in chart background.
		Foreground - Place element into foreground.
	*/primitives.common.ZOrderType={Auto:0,Background:1,Foreground:2};/* /events/RenderEventArgs.js*//*
		Class: primitives.common.RenderEventArgs
			Rendering event details class.
	*/primitives.common.RenderEventArgs=function(){/*
		Property: element
			jQuery selector referencing template's root element.
		*/this.element=null;/*
		Property: context
			Reference to item.
		*/this.context=null;/*
		Property: templateName
			This is template name used to render this item.
	
			See Also:
			<primitives.orgdiagram.TemplateConfig>
			<primitives.orgdiagram.Config.templates> collection property.
		*/this.templateName=null;/*
		Property: renderingMode
			This option indicates current template state.
	
		Default:
			<primitives.common.RenderingMode.Update>
	
		See also:
			<primitives.common.RenderingMode>
		*/this.renderingMode=null;/*
		Property: isCursor
			Rendered item is cursor.
		*/this.isCursor=false;/*
		Property: isSelected
			Rendered item is selected.
		*/this.isSelected=false;};/* /graphics/shapes/BaseShape.js*/primitives.common.BaseShape=function(){};primitives.common.BaseShape.prototype._getLabelPosition=function(x,y,width,height,labelWidth,labelHeight,labelOffset,labelPlacement){var result=null;switch(labelPlacement){case 1/*primitives.common.PlacementType.Top*/:result=new primitives.common.Rect(x+width/2.0-labelWidth/2.0,y-labelOffset-labelHeight,labelWidth,labelHeight);break;case 2/*primitives.common.PlacementType.TopRight*/:result=new primitives.common.Rect(x+width-labelWidth,y-labelOffset-labelHeight,labelWidth,labelHeight);break;case 8/*primitives.common.PlacementType.TopLeft*/:result=new primitives.common.Rect(x,y-labelOffset-labelHeight,labelWidth,labelHeight);break;case 3/*primitives.common.PlacementType.Right*/:result=new primitives.common.Rect(x+width+labelOffset,y+height/2.0-labelHeight/2.0,labelWidth,labelHeight);break;case 11/*primitives.common.PlacementType.RightTop*/:result=new primitives.common.Rect(x+width+labelOffset,y,labelWidth,labelHeight);break;case 12/*primitives.common.PlacementType.RightBottom*/:result=new primitives.common.Rect(x+width+labelOffset,y+height-labelHeight,labelWidth,labelHeight);break;case 4/*primitives.common.PlacementType.BottomRight*/:result=new primitives.common.Rect(x+width-labelWidth,y+height+labelOffset,labelWidth,labelHeight);break;case 6/*primitives.common.PlacementType.BottomLeft*/:result=new primitives.common.Rect(x,y+height+labelOffset,labelWidth,labelHeight);break;case 7/*primitives.common.PlacementType.Left*/:result=new primitives.common.Rect(x-labelWidth-labelOffset,y+height/2.0-labelHeight/2.0,labelWidth,labelHeight);break;case 9/*primitives.common.PlacementType.LeftTop*/:result=new primitives.common.Rect(x-labelWidth-labelOffset,y,labelWidth,labelHeight);break;case 10/*primitives.common.PlacementType.LeftBottom*/:result=new primitives.common.Rect(x-labelWidth-labelOffset,y+height-labelHeight,labelWidth,labelHeight);break;case 0/*primitives.common.PlacementType.Auto*/://ignore jslint
	case 5/*primitives.common.PlacementType.Bottom*/://ignore jslint
	default://ignore jslint
	result=new primitives.common.Rect(x+width/2.0-labelWidth/2.0,y+height+labelOffset,labelWidth,labelHeight);break;}return result;};primitives.common.BaseShape.prototype._betweenPoint=function(first,second){return new primitives.common.Point((first.x+second.x)/2,(first.y+second.y)/2);};primitives.common.BaseShape.prototype._offsetPoint=function(first,second,offset){var result=null,distance=first.distanceTo(second);if(distance===0||offset===0){result=new primitives.common.Point(first);}else{result=new primitives.common.Point(first.x+(second.x-first.x)/distance*offset,first.y+(second.y-first.y)/distance*offset);}return result;};/* /graphics/shapes/Callout.js*/primitives.common.Callout=function(graphics){this.m_graphics=graphics;this.pointerPlacement=0/*primitives.common.PlacementType.Auto*/;this.cornerRadius="10%";this.offset=0;this.opacity=1;this.lineWidth=1;this.pointerWidth="10%";this.borderColor="#000000"/*primitives.common.Colors.Black*/;this.lineType=0/*primitives.common.LineType.Solid*/;this.fillColor="#d3d3d3"/*primitives.common.Colors.LightGray*/;this.m_map=[[8/*primitives.common.PlacementType.TopLeft*/,7/*primitives.common.PlacementType.Left*/,6/*primitives.common.PlacementType.BottomLeft*/],[1/*primitives.common.PlacementType.Top*/,null,5/*primitives.common.PlacementType.Bottom*/],[2/*primitives.common.PlacementType.TopRight*/,3/*primitives.common.PlacementType.Right*/,4/*primitives.common.PlacementType.BottomRight*/]];};primitives.common.Callout.prototype=new primitives.common.BaseShape();primitives.common.Callout.prototype.draw=function(snapPoint,position){position=new primitives.common.Rect(position).offset(this.offset);var pointA=new primitives.common.Point(position.x,position.y),pointB=new primitives.common.Point(position.right(),position.y),pointC=new primitives.common.Point(position.right(),position.bottom()),pointD=new primitives.common.Point(position.left(),position.bottom()),snapPoints=[null,null,null,null,null,null,null,null],points=[pointA,pointB,pointC,pointD],radius=this.m_graphics.getPxSize(this.cornerRadius,Math.min(pointA.distanceTo(pointB),pointB.distanceTo(pointC))),placementType,point,index,attr,linePaletteItem,buffer,polyline;attr={};if(this.fillColor!==null){attr.fillColor=this.fillColor;attr.opacity=this.opacity;}if(this.lineColor!==null){attr.lineColor=this.borderColor;}attr.lineWidth=this.lineWidth;attr.lineType=this.lineType;linePaletteItem=new primitives.common.PaletteItem(attr);buffer=new primitives.common.PolylinesBuffer();polyline=buffer.getPolyline(linePaletteItem);if(snapPoint!==null){placementType=this.pointerPlacement===0/*primitives.common.PlacementType.Auto*/?this._getPlacement(snapPoint,pointA,pointC):this.pointerPlacement;if(placementType!==null){snapPoints[placementType]=snapPoint;}}for(index=0;index<points.length;index+=1){this._drawSegment(polyline,points[0],points[1],points[2],this.pointerWidth,radius,snapPoints[1],snapPoints[2]);point=points.shift();points.push(point);point=snapPoints.shift();snapPoints.push(point);point=snapPoints.shift();snapPoints.push(point);}this.m_graphics.polylinesBuffer(buffer);};primitives.common.Callout.prototype._getPlacement=function(point,point1,point2){var row=null,column=null;if(point.x<point1.x){row=0;}else if(point.x>point2.x){row=2;}else{row=1;}if(point.y<point1.y){column=0;}else if(point.y>point2.y){column=2;}else{column=1;}return this.m_map[row][column];};primitives.common.Callout.prototype._drawSegment=function(polyline,pointA,pointB,pointC,base,radius,sideSnapPoint,cornerSnapPoint){var pointA1=this._offsetPoint(pointA,pointB,radius),pointB1=this._offsetPoint(pointB,pointA,radius),pointB2=this._offsetPoint(pointB,pointC,radius),pointS,pointS1,pointS2;base=this.m_graphics.getPxSize(base,pointA.distanceTo(pointB)/2.0);if(polyline.length()===0){polyline.addSegment(new primitives.common.MoveSegment(pointA1));}if(sideSnapPoint!==null){pointS=this._betweenPoint(pointA,pointB);pointS1=this._offsetPoint(pointS,pointA,base);pointS2=this._offsetPoint(pointS,pointB,base);polyline.addSegment(new primitives.common.LineSegment(pointS1));polyline.addSegment(new primitives.common.LineSegment(sideSnapPoint));polyline.addSegment(new primitives.common.LineSegment(pointS2));}polyline.addSegment(new primitives.common.LineSegment(pointB1));if(cornerSnapPoint!==null){polyline.addSegment(new primitives.common.LineSegment(cornerSnapPoint));polyline.addSegment(new primitives.common.LineSegment(pointB2));}else{polyline.addSegment(new primitives.common.QuadraticArcSegment(pointB,pointB2));}};/* /graphics/shapes/ConnectorOffbeat.js*/primitives.common.ConnectorOffbeat=function(){};primitives.common.ConnectorOffbeat.prototype=new primitives.common.BaseShape();primitives.common.ConnectorOffbeat.prototype.draw=function(buffer,linePaletteItem,fromRect,toRect,linesOffset,bundleOffset,labelSize,panelSize,connectorShapeType,labelOffset,labelPlacementType,hasLabel,connectorAnnotationOffsetResolver,onLabelPlacement){var minimalGap,connectorRect,fromPoint,toPoint,snapPoint,index,len,offsets,tempOffset,invertX,invertY,fromLabelPlacement=0/*primitives.common.PlacementType.Auto*/,toLabelPlacement=0/*primitives.common.PlacementType.Auto*/,labelPlacement=null,polyline,bothWay;polyline=buffer.getPolyline(linePaletteItem);offsets=[];switch(connectorShapeType){case 1/*primitives.common.ConnectorShapeType.TwoWay*/:offsets=[-linesOffset/2,linesOffset/2];bothWay=false;break;case 0/*primitives.common.ConnectorShapeType.OneWay*/:offsets=[0];bothWay=false;break;case 2/*primitives.common.ConnectorShapeType.BothWay*/:offsets=[0];bothWay=true;break;}minimalGap=Math.max(hasLabel?labelSize.width:0,linesOffset*5);if(fromRect.right()+minimalGap<toRect.left()||fromRect.left()>toRect.right()+minimalGap){if(fromRect.left()>toRect.right()){fromPoint=new primitives.common.Point(fromRect.left(),fromRect.verticalCenter());toPoint=new primitives.common.Point(toRect.right(),toRect.verticalCenter());}else{fromPoint=new primitives.common.Point(fromRect.right(),fromRect.verticalCenter());toPoint=new primitives.common.Point(toRect.left(),toRect.verticalCenter());}if(hasLabel){if(fromRect.left()>toRect.right()){fromLabelPlacement=7/*primitives.common.PlacementType.Left*/;toLabelPlacement=3/*primitives.common.PlacementType.Right*/;}else{fromLabelPlacement=3/*primitives.common.PlacementType.Right*/;toLabelPlacement=7/*primitives.common.PlacementType.Left*/;}}connectorRect=new primitives.common.Rect(fromPoint,toPoint);invertY=fromPoint.y<=toPoint.y;invertX=fromPoint.x<toPoint.x;if(connectorRect.height<connectorRect.width){/* horizontal single bended connector between boxes from right side to left side */if(connectorRect.height<linesOffset*2){connectorRect.offset(0,invertY?linesOffset*2:0,0,invertY?0:linesOffset*2);}for(index=0,len=offsets.length;index<len;index+=1){tempOffset=offsets[index];buffer.addInverted(function(invertedBuffer){var polyline=invertedBuffer.getPolyline(linePaletteItem);polyline.addSegment(new primitives.common.MoveSegment(fromPoint.x,fromPoint.y+tempOffset));polyline.addSegment(new primitives.common.QuadraticArcSegment(connectorRect.horizontalCenter(),(invertY?connectorRect.top():connectorRect.bottom())+tempOffset,toPoint.x,toPoint.y+tempOffset));if(bothWay){polyline.addArrow(linePaletteItem.lineWidth,function(polyline){polyline.mergeTo(buffer.getPolyline(polyline.paletteItem));});//ignore jslint
	}},index||connectorShapeType==0/*primitives.common.ConnectorShapeType.OneWay*/);//ignore jslint
	polyline.addArrow(linePaletteItem.lineWidth,function(polyline){polyline.mergeTo(buffer.getPolyline(polyline.paletteItem));});//ignore jslint
	}if(hasLabel){if(labelSize.width<connectorRect.width/5*2){snapPoint=primitives.common.QuadraticArcSegment.prototype.offsetPoint(fromPoint.x,fromPoint.y,connectorRect.horizontalCenter(),invertY?connectorRect.top():connectorRect.bottom(),toPoint.x,toPoint.y,0.5);}else{snapPoint=new primitives.common.Point(fromPoint.x,invertY?connectorRect.top():connectorRect.bottom());}labelPlacement=new primitives.common.Rect(snapPoint.x+(invertX?linesOffset:-labelSize.width-linesOffset),invertY?snapPoint.y-labelSize.height-linesOffset:snapPoint.y+linesOffset,labelSize.width,labelSize.height);}}else{/* horizontal double bended connector between boxes from right side to left side */for(index=0,len=offsets.length;index<len;index+=1){tempOffset=offsets[index];buffer.addInverted(function(invertedBuffer){var polyline=invertedBuffer.getPolyline(linePaletteItem);polyline.addSegment(new primitives.common.MoveSegment(fromPoint.x,fromPoint.y+tempOffset));polyline.addSegment(new primitives.common.QuadraticArcSegment(connectorRect.horizontalCenter()+tempOffset*(invertY!=invertX?1:-1),(invertY?connectorRect.top():connectorRect.bottom())+tempOffset,connectorRect.horizontalCenter()+tempOffset*(invertY!=invertX?1:-1),connectorRect.verticalCenter()+tempOffset));polyline.addSegment(new primitives.common.QuadraticArcSegment(connectorRect.horizontalCenter()+tempOffset*(invertY!=invertX?1:-1),(invertY?connectorRect.bottom():connectorRect.top())+tempOffset,toPoint.x,toPoint.y+tempOffset));if(bothWay){polyline.addArrow(linePaletteItem.lineWidth,function(polyline){polyline.mergeTo(buffer.getPolyline(polyline.paletteItem));});//ignore jslint
	}},index||connectorShapeType==0/*primitives.common.ConnectorShapeType.OneWay*/);//ignore jslint
	polyline.addArrow(linePaletteItem.lineWidth,function(polyline){polyline.mergeTo(buffer.getPolyline(polyline.paletteItem));});//ignore jslint
	}if(hasLabel){labelPlacement=new primitives.common.Rect(connectorRect.horizontalCenter()+(invertY!=invertX?linesOffset:-(linesOffset+labelSize.width)),connectorRect.verticalCenter()-labelSize.height/2,labelSize.width,labelSize.height);}}}else{if(fromRect.verticalCenter()<toRect.top()||fromRect.verticalCenter()>toRect.bottom()){/* vertical single bended connector between boxes from right side to right side */invertX=fromRect.x<panelSize.width/2;fromPoint=new primitives.common.Point(invertX?fromRect.right():fromRect.left(),fromRect.verticalCenter());toPoint=new primitives.common.Point(invertX?toRect.right():toRect.left(),toRect.verticalCenter());connectorRect=new primitives.common.Rect(fromPoint,toPoint);connectorRect.offset(linesOffset*10,0,linesOffset*10,0);invertY=fromPoint.y<=toPoint.y;for(index=0,len=offsets.length;index<len;index+=1){tempOffset=offsets[index];buffer.addInverted(function(invertedBuffer){var polyline=invertedBuffer.getPolyline(linePaletteItem);polyline.addSegment(new primitives.common.MoveSegment(fromPoint.x,fromPoint.y+tempOffset));polyline.addSegment(new primitives.common.QuadraticArcSegment(invertX?connectorRect.right()+tempOffset*(invertY?-1:1):connectorRect.left()-tempOffset*(invertY?-1:1),connectorRect.verticalCenter(),invertX?toRect.right():toRect.left(),toRect.verticalCenter()-tempOffset));if(bothWay){polyline.addArrow(linePaletteItem.lineWidth,function(polyline){polyline.mergeTo(buffer.getPolyline(polyline.paletteItem));});//ignore jslint
	}},index||connectorShapeType==0/*primitives.common.ConnectorShapeType.OneWay*/);//ignore jslint
	polyline.addArrow(linePaletteItem.lineWidth,function(polyline){polyline.mergeTo(buffer.getPolyline(polyline.paletteItem));});//ignore jslint
	}if(hasLabel){fromLabelPlacement=invertX?3/*primitives.common.PlacementType.Right*/:7/*primitives.common.PlacementType.Left*/;toLabelPlacement=fromLabelPlacement;snapPoint=primitives.common.QuadraticArcSegment.prototype.offsetPoint(fromPoint.x,fromPoint.y,invertX?connectorRect.right():connectorRect.left(),connectorRect.verticalCenter(),toPoint.x,toPoint.y,0.5);labelPlacement=new primitives.common.Rect(snapPoint.x+(invertX?linesOffset/2:-linesOffset/2-labelSize.width),snapPoint.y-labelSize.height/2,labelSize.width,labelSize.height);}}else{fromPoint=new primitives.common.Point(fromRect.horizontalCenter(),fromRect.top());toPoint=new primitives.common.Point(toRect.horizontalCenter(),toRect.top());connectorRect=new primitives.common.Rect(fromPoint,toPoint);connectorRect.offset(0,linesOffset*7,0,0);invertX=fromPoint.x<toPoint.x;for(index=0,len=offsets.length;index<len;index+=1){tempOffset=offsets[index];buffer.addInverted(function(invertedBuffer){var polyline=invertedBuffer.getPolyline(linePaletteItem);polyline.addSegment(new primitives.common.MoveSegment(fromPoint.x+tempOffset,fromPoint.y));polyline.addSegment(new primitives.common.QuadraticArcSegment(connectorRect.horizontalCenter(),connectorRect.top()-tempOffset*(invertX?-1:1),toRect.horizontalCenter()-tempOffset,toRect.top()));if(bothWay){polyline.addArrow(linePaletteItem.lineWidth,function(polyline){polyline.mergeTo(buffer.getPolyline(polyline.paletteItem));});//ignore jslint
	}},index||connectorShapeType==0/*primitives.common.ConnectorShapeType.OneWay*/);//ignore jslint
	polyline.addArrow(linePaletteItem.lineWidth,function(polyline){polyline.mergeTo(buffer.getPolyline(polyline.paletteItem));});//ignore jslint
	}if(hasLabel){fromLabelPlacement=1/*primitives.common.PlacementType.Top*/;toLabelPlacement=1/*primitives.common.PlacementType.Top*/;snapPoint=primitives.common.QuadraticArcSegment.prototype.offsetPoint(fromPoint.x,fromPoint.y,connectorRect.horizontalCenter(),connectorRect.top(),toPoint.x,toPoint.y,0.5);labelPlacement=new primitives.common.Rect(snapPoint.x-labelSize.width/2,snapPoint.y-(labelOffset+labelSize.height),labelSize.width,labelSize.height);}}}if(hasLabel){/* end points labels placement */switch(labelPlacementType){case 0/*primitives.common.ConnectorLabelPlacementType.From*/:labelPlacement=this._getLabelPosition(fromRect.x,fromRect.y,fromRect.width,fromRect.height,labelPlacement.width,labelPlacement.height,labelOffset,fromLabelPlacement);break;case 2/*primitives.common.ConnectorLabelPlacementType.To*/:labelPlacement=this._getLabelPosition(toRect.x,toRect.y,toRect.width,toRect.height,labelPlacement.width,labelPlacement.height,labelOffset,toLabelPlacement);break;default:break;}}if(onLabelPlacement!=null){onLabelPlacement(labelPlacement);}};/* /graphics/shapes/ConnectorStraight.js*/primitives.common.ConnectorStraight=function(){};primitives.common.ConnectorStraight.prototype=new primitives.common.BaseShape();primitives.common.ConnectorStraight.prototype.draw=function(buffer,linePaletteItem,fromRect,toRect,linesOffset,bundleOffset,labelSize,panelSize,connectorShapeType,labelOffset,labelPlacementType,hasLabel,connectorAnnotationOffsetResolver,onLabelPlacement){var fromPoint,toPoint,betweenPoint,vector,newVector,offset=linesOffset/2,labelPlacement=null,fromLabelPlacement=0/*primitives.common.PlacementType.Auto*/,toLabelPlacement=0/*primitives.common.PlacementType.Auto*/,self=this;vector=new primitives.common.Vector(fromRect.centerPoint(),toRect.centerPoint());fromRect.loopEdges(function(sideVector,placementType){fromPoint=sideVector.getIntersectionPoint(vector,true,1.0);fromLabelPlacement=placementType;return fromPoint!=null;});toRect.loopEdges(function(sideVector,placementType){toPoint=sideVector.getIntersectionPoint(vector,true,1.0);toLabelPlacement=placementType;return toPoint!=null;});if(fromPoint!=null&&toPoint!=null){var baseVector=new primitives.common.Vector(fromPoint,toPoint);connectorAnnotationOffsetResolver.getOffset(baseVector,function(offsetIndex,bundleSize,direction){var tempOffset=(offsetIndex*bundleOffset-(bundleSize-1)*bundleOffset/2.0)*direction;baseVector.offset(tempOffset);fromPoint=baseVector.from;toPoint=baseVector.to;switch(connectorShapeType){case 1/*primitives.common.ConnectorShapeType.TwoWay*/:newVector=new primitives.common.Vector(toPoint.clone(),fromPoint.clone());newVector.offset(offset);self._drawLine(buffer,linePaletteItem,newVector.from,newVector.to,false);newVector=new primitives.common.Vector(fromPoint.clone(),toPoint.clone());newVector.offset(offset);self._drawLine(buffer,linePaletteItem,newVector.from,newVector.to,false);break;case 0/*primitives.common.ConnectorShapeType.OneWay*/:self._drawLine(buffer,linePaletteItem,fromPoint,toPoint,false);break;case 2/*primitives.common.ConnectorShapeType.BothWay*/:self._drawLine(buffer,linePaletteItem,fromPoint,toPoint,true);break;}if(hasLabel){/* end points labels placement */switch(labelPlacementType){case 0/*primitives.common.ConnectorLabelPlacementType.From*/:labelPlacement=self._getLabelPositionBySnapPoint(fromPoint.x,fromPoint.y,labelSize.width,labelSize.height,labelOffset,fromLabelPlacement);break;case 1/*primitives.common.ConnectorLabelPlacementType.Between*/:betweenPoint=self._betweenPoint(fromPoint,toPoint);labelPlacement=self._getLabelPositionBySnapPoint(betweenPoint.x,betweenPoint.y,labelSize.width,labelSize.height,labelOffset,3/*primitives.common.PlacementType.Right*/);break;case 2/*primitives.common.ConnectorLabelPlacementType.To*/:labelPlacement=self._getLabelPositionBySnapPoint(toPoint.x,toPoint.y,labelSize.width,labelSize.height,labelOffset,toLabelPlacement);break;default:break;}if(onLabelPlacement!=null){onLabelPlacement.call(this,labelPlacement);}}});}};primitives.common.ConnectorStraight.prototype._drawLine=function(buffer,linePaletteItem,fromPoint,toPoint,bothWays){var polyline;buffer.addInverted(function(invertedBuffer){polyline=invertedBuffer.getPolyline(linePaletteItem);polyline.addSegment(new primitives.common.MoveSegment(fromPoint));polyline.addSegment(new primitives.common.LineSegment(toPoint));polyline.addArrow(linePaletteItem.lineWidth,function(polyline){polyline.mergeTo(buffer.getPolyline(polyline.paletteItem));});//ignore jslint
	},false);//ignore jslint
	if(bothWays){polyline=buffer.getPolyline(linePaletteItem);polyline.addArrow(linePaletteItem.lineWidth,function(polyline){polyline.mergeTo(buffer.getPolyline(polyline.paletteItem));});//ignore jslint
	}};primitives.common.ConnectorStraight.prototype._getLabelPositionBySnapPoint=function(x,y,labelWidth,labelHeight,labelOffset,placementType){var result=null;switch(placementType){case 0/*primitives.common.PlacementType.Auto*/:case 1/*primitives.common.PlacementType.Top*/:result=new primitives.common.Rect(x-labelWidth/2.0,y-labelOffset-labelHeight,labelWidth,labelHeight);break;case 3/*primitives.common.PlacementType.Right*/:result=new primitives.common.Rect(x+labelOffset,y-labelHeight/2.0,labelWidth,labelHeight);break;case 5/*primitives.common.PlacementType.Bottom*/:result=new primitives.common.Rect(x-labelWidth/2.0,y+labelOffset,labelWidth,labelHeight);break;case 7/*primitives.common.PlacementType.Left*/:result=new primitives.common.Rect(x-labelWidth-labelOffset,y-labelHeight/2.0,labelWidth,labelHeight);break;}return result;};/* /graphics/shapes/Marker.js*/primitives.common.Marker=function(){};primitives.common.Marker.Markers={};primitives.common.Marker.DrawCircle=function(polyline,position){var quarter=Math.min(position.width/2.0,position.height/2.0);position=new primitives.common.Rect(position.horizontalCenter()-quarter,position.verticalCenter()-quarter,quarter*2.0,quarter*2.0);primitives.common.Marker.DrawOval(polyline,position);};primitives.common.Marker.DrawRectangle=function(polyline,position){polyline.addSegment(new primitives.common.MoveSegment(position.x,position.verticalCenter()));polyline.addSegment(new primitives.common.LineSegment(position.x,position.y));polyline.addSegment(new primitives.common.LineSegment(position.right(),position.y));polyline.addSegment(new primitives.common.LineSegment(position.right(),position.bottom()));polyline.addSegment(new primitives.common.LineSegment(position.x,position.bottom()));polyline.addSegment(new primitives.common.LineSegment(position.x,position.verticalCenter()));};primitives.common.Marker.DrawOval=function(polyline,position){var cpX,cpY;cpX=position.width/2*0.5522848;cpY=position.height/2*0.5522848;polyline.addSegment(new primitives.common.MoveSegment(position.x,position.verticalCenter()));polyline.addSegment(new primitives.common.CubicArcSegment(position.x,position.verticalCenter()-cpY,position.horizontalCenter()-cpX,position.y,position.horizontalCenter(),position.y));polyline.addSegment(new primitives.common.CubicArcSegment(position.horizontalCenter()+cpX,position.y,position.right(),position.verticalCenter()-cpY,position.right(),position.verticalCenter()));polyline.addSegment(new primitives.common.CubicArcSegment(position.right(),position.verticalCenter()+cpY,position.horizontalCenter()+cpX,position.bottom(),position.horizontalCenter(),position.bottom()));polyline.addSegment(new primitives.common.CubicArcSegment(position.horizontalCenter()-cpX,position.bottom(),position.x,position.verticalCenter()+cpY,position.x,position.verticalCenter()));};primitives.common.Marker.DrawTriangle=function(polyline,position){polyline.addSegment(new primitives.common.MoveSegment(position.left(),position.bottom()));polyline.addSegment(new primitives.common.LineSegment(position.horizontalCenter(),position.y));polyline.addSegment(new primitives.common.LineSegment(position.right(),position.bottom()));polyline.addSegment(new primitives.common.LineSegment(position.left(),position.bottom()));};primitives.common.Marker.DrawCrossOut=function(polyline,position){polyline.addSegment(new primitives.common.MoveSegment(position.horizontalCenter(),position.verticalCenter()));polyline.addSegment(new primitives.common.LineSegment(position.x,position.y));polyline.addSegment(new primitives.common.MoveSegment(position.horizontalCenter(),position.verticalCenter()));polyline.addSegment(new primitives.common.LineSegment(position.right(),position.bottom()));polyline.addSegment(new primitives.common.MoveSegment(position.horizontalCenter(),position.verticalCenter()));polyline.addSegment(new primitives.common.LineSegment(position.right(),position.y));polyline.addSegment(new primitives.common.MoveSegment(position.horizontalCenter(),position.verticalCenter()));polyline.addSegment(new primitives.common.LineSegment(position.left(),position.bottom()));};primitives.common.Marker.DrawRhombus=function(polyline,position){polyline.addSegment(new primitives.common.MoveSegment(position.horizontalCenter(),position.bottom()));polyline.addSegment(new primitives.common.LineSegment(position.left(),position.verticalCenter()));polyline.addSegment(new primitives.common.LineSegment(position.horizontalCenter(),position.y));polyline.addSegment(new primitives.common.LineSegment(position.right(),position.verticalCenter()));polyline.addSegment(new primitives.common.LineSegment(position.horizontalCenter(),position.bottom()));};primitives.common.Marker.DrawWedge=function(polyline,position){polyline.addSegment(new primitives.common.MoveSegment(position.horizontalCenter(),position.y));polyline.addSegment(new primitives.common.LineSegment(position.right(),position.y));polyline.addSegment(new primitives.common.LineSegment(position.horizontalCenter(),position.bottom()));polyline.addSegment(new primitives.common.LineSegment(position.left(),position.y));polyline.addSegment(new primitives.common.LineSegment(position.horizontalCenter(),position.y));};primitives.common.Marker.DrawFramedOval=function(polyline,position){primitives.common.Marker.DrawRectangle(polyline,position);primitives.common.Marker.DrawOval(polyline,position);};primitives.common.Marker.DrawFramedTriangle=function(polyline,position){primitives.common.Marker.DrawRectangle(polyline,position);primitives.common.Marker.DrawTriangle(polyline,position);};primitives.common.Marker.DrawFramedWedge=function(polyline,position){primitives.common.Marker.DrawRectangle(polyline,position);primitives.common.Marker.DrawWedge(polyline,position);};primitives.common.Marker.DrawFramedRhombus=function(polyline,position){primitives.common.Marker.DrawRectangle(polyline,position);primitives.common.Marker.DrawRhombus(polyline,position);};primitives.common.Marker.DrawNone=function(polyline,position){};primitives.common.Marker.Markers[4/*primitives.common.ShapeType.Circle*/]=primitives.common.Marker.DrawCircle;primitives.common.Marker.Markers[0/*primitives.common.ShapeType.Rectangle*/]=primitives.common.Marker.DrawRectangle;primitives.common.Marker.Markers[1/*primitives.common.ShapeType.Oval*/]=primitives.common.Marker.DrawOval;primitives.common.Marker.Markers[2/*primitives.common.ShapeType.Triangle*/]=primitives.common.Marker.DrawTriangle;primitives.common.Marker.Markers[3/*primitives.common.ShapeType.CrossOut*/]=primitives.common.Marker.DrawCrossOut;primitives.common.Marker.Markers[5/*primitives.common.ShapeType.Rhombus*/]=primitives.common.Marker.DrawRhombus;primitives.common.Marker.Markers[7/*primitives.common.ShapeType.Wedge*/]=primitives.common.Marker.DrawWedge;primitives.common.Marker.Markers[8/*primitives.common.ShapeType.FramedOval*/]=primitives.common.Marker.DrawFramedOval;primitives.common.Marker.Markers[9/*primitives.common.ShapeType.FramedTriangle*/]=primitives.common.Marker.DrawFramedTriangle;primitives.common.Marker.Markers[10/*primitives.common.ShapeType.FramedWedge*/]=primitives.common.Marker.DrawFramedWedge;primitives.common.Marker.Markers[11/*primitives.common.ShapeType.FramedRhombus*/]=primitives.common.Marker.DrawFramedRhombus;primitives.common.Marker.Markers[6/*primitives.common.ShapeType.None*/]=primitives.common.Marker.DrawNone;primitives.common.Marker.prototype.draw=function(polylinesBuffer,shapeType,position,paletteItem){var polyline;// If you need to create custom multi-color marker type
	// create color palette object for every fragment
	// than request polyline of that that palette style
	// add fragment into received polyline
	polyline=polylinesBuffer.getPolyline(paletteItem);primitives.common.Marker.Markers[shapeType](polyline,position);};/* /graphics/shapes/Perimeter.js*/primitives.common.Perimeter=function(graphics){this.m_graphics=graphics;this.transform=null;this.lineWidth=1;this.opacity=1;this.fillColor=null;this.lineType=0/*primitives.common.LineType.Solid*/;this.borderColor=null;};primitives.common.Perimeter.prototype=new primitives.common.BaseShape();primitives.common.Perimeter.prototype.draw=function(perimeter){var paletteItem=new primitives.common.PaletteItem({lineColor:this.borderColor,lineWidth:this.lineWidth,fillColor:this.fillColor,lineType:this.lineType,opacity:this.opacity}),polyline=new primitives.common.Polyline(paletteItem),offset=this.lineWidth/2,prevSegment=null,prevPoint=null,prevPointIsVertical=null,connectionHash={},connection,element;perimeter.segments.iterate(function(item){var offsetX=0,offsetY=0,isVertical=false,newPoint,connection;if(offset>0){switch(item.orientationType){case 3/*primitives.common.OrientationType.Right*/:offsetX=-offset;isVertical=false;break;case 2/*primitives.common.OrientationType.Left*/:offsetX=offset;isVertical=false;break;case 0/*primitives.common.OrientationType.Top*/:offsetY=offset;isVertical=true;break;case 1/*primitives.common.OrientationType.Bottom*/:offsetY=-offset;isVertical=true;break;default:throw"Orientation is not defined!";}}if(polyline.length()===0){prevPoint=new primitives.common.MoveSegment(item.fromPoint);polyline.addSegment(prevPoint);connectionHash[perimeter.segments.endKey()]={point:prevPoint,isVertical:isVertical};}newPoint=null;if(perimeter.segments.item(item.oppositeKey)!=null){newPoint=new primitives.common.MoveSegment(item.toPoint.x+offsetX,item.toPoint.y+offsetY);}else{newPoint=new primitives.common.LineSegment(item.toPoint.x+offsetX,item.toPoint.y+offsetY);}polyline.addSegment(newPoint);if(offset>0){/* align previous point and new point offset */if(isVertical){prevPoint.y=newPoint.y;}else{prevPoint.x=newPoint.x;}if(prevSegment!=null){/* search for two sequential segments having and not having opposite segments */if(!perimeter.segments.item(prevSegment.oppositeKey)&&perimeter.segments.item(item.oppositeKey)!=null){if(connectionHash.hasOwnProperty(item.oppositeKey)){connection=connectionHash[item.oppositeKey];if(connection.isVertical){prevPoint.y=connection.point.y;}else{prevPoint.x=connection.point.x;}if(prevPointIsVertical){connection.point.y=prevPoint.y;}else{connection.point.x=prevPoint.x;}}else{connectionHash[item.oppositeKey]={point:prevPoint,isVertical:prevPointIsVertical};}}else if(perimeter.segments.item(prevSegment.oppositeKey)!=null&&!perimeter.segments.item(item.oppositeKey)){if(connectionHash.hasOwnProperty(prevSegment.key)){connection=connectionHash[prevSegment.key];if(connection.isVertical){prevPoint.y=connection.point.y;}else{prevPoint.x=connection.point.x;}if(prevPointIsVertical){connection.point.y=prevPoint.y;}else{connection.point.x=prevPoint.x;}}else{connectionHash[prevSegment.key]={point:prevPoint,isVertical:isVertical};}}}prevPointIsVertical=isVertical;prevSegment=item;}prevPoint=newPoint;});if(offset>0){if(!perimeter.segments.item(prevSegment.oppositeKey)){connection=connectionHash[prevSegment.key];if(connection.isVertical){prevPoint.y=connection.point.y;}else{prevPoint.x=connection.point.x;}if(prevPointIsVertical){connection.point.y=prevPoint.y;}else{connection.point.x=prevPoint.x;}}}polyline.transform(this.transform,true);element=this.m_graphics.polyline(polyline);};/* /graphics/shapes/Shape.js*/primitives.common.Shape=function(graphics){this.m_graphics=graphics;this.transform=null;this.orientationType=0/*primitives.common.OrientationType.Top*/;this.panelSize=null;this.shapeType=0/*primitives.common.ShapeType.Rectangle*/;this.offset=new primitives.common.Thickness(0,0,0,0);this.lineWidth=1;this.labelOffset=4;this.cornerRadius="10%";this.opacity=1;this.fillColor=null;this.labelSize=new primitives.common.Size(60,30);this.lineType=0/*primitives.common.LineType.Solid*/;this.borderColor=null;this.hasLabel=false;this.labelTemplate=null;this.labelPlacement=0/*primitives.common.PlacementType.Auto*/;};primitives.common.Shape.prototype=new primitives.common.BaseShape();primitives.common.Shape.prototype.draw=function(position,uiHash){var labelPlacement,calloutShape,linePaletteItem,buffer,marker;position=new primitives.common.Rect(position).offset(this.offset);this.transform=new primitives.common.Transform();this.transform.size=this.panelSize;this.transform.setOrientation(this.orientationType);/* label size */if(this.hasLabel){labelPlacement=this._getLabelPosition(position.x,position.y,position.width,position.height,this.labelSize.width,this.labelSize.height,this.labelOffset,this.labelPlacement);}switch(this.shapeType){case 0/*primitives.common.ShapeType.Rectangle*/:calloutShape=new primitives.common.Callout(this.m_graphics);calloutShape.cornerRadius=this.cornerRadius;calloutShape.opacity=this.opacity;calloutShape.lineWidth=this.lineWidth;calloutShape.lineType=this.lineType;calloutShape.borderColor=this.borderColor;calloutShape.fillColor=this.fillColor;calloutShape.draw(null,position);break;default:linePaletteItem=new primitives.common.PaletteItem({lineColor:this.borderColor,lineWidth:this.lineWidth,lineType:this.lineType,fillColor:this.fillColor,opacity:this.opacity});/* from rectangle */this.transform.transformRect(position.x,position.y,position.width,position.height,false,this,function(x,y,width,height){position=new primitives.common.Rect(x,y,width,height);});marker=new primitives.common.Marker();buffer=new primitives.common.PolylinesBuffer();marker.draw(buffer,this.shapeType,position,linePaletteItem);buffer.transform(this.transform,true);this.m_graphics.polylinesBuffer(buffer);break;}if(this.hasLabel){this.m_graphics.template(labelPlacement.x,labelPlacement.y,0,0,0,0,labelPlacement.width,labelPlacement.height,this.labelTemplate.template(),this.labelTemplate.getHashCode(),this.labelTemplate.render,uiHash,null);}};/* /graphics/structs/Point.js*//*
		Class: primitives.common.Point
		Class represents pair of x and y coordinates that defines a point in 2D plane.
	
		Parameters:
			point - <primitives.common.Point> object.
	
		Parameters:
			x - X coordinate of 2D point.
			y - Y coordinate of 2D point.
	*/primitives.common.Point=function(arg0,arg1){/*
		Property: x
			The x coordinate.
		*/this.x=null;/*
		Property: y
			The y coordinate.
		*/this.y=null;/*
		Property: context
			This property holds reference to context object associated with this datapoint.
		*/this.context=null;switch(arguments.length){case 1:this.x=arg0.x;this.y=arg0.y;this.context=arg0.context;break;case 2:this.x=arg0;this.y=arg1;break;default:break;}};/*
		Method: scale
			Scales width and height.
	*/primitives.common.Point.prototype.scale=function(scale){this.x=this.x*scale;this.x=this.x*scale;return this;};/*
		Method: distanceTo
			Returns distance to point.
	
		Parameters:
			point - <primitives.common.Point> object.
	
		Parameters:
			x - X coordinate of 2D point.
			y - Y coordinate of 2D point.
	*/primitives.common.Point.prototype.distanceTo=function(arg0,arg1){var x2=0,y2=0,a,b;switch(arguments.length){case 1:x2=arg0.x;y2=arg0.y;break;case 2:x2=arg0;y2=arg1;break;default:break;}a=this.x-x2;b=this.y-y2;return Math.sqrt(a*a+b*b);};primitives.common.Point.prototype.equalTo=function(point){return this.x==point.x&&this.y==point.y;};/*
		Method: swap
			Swaps values of two points.
	
		Parameters:
			point - <primitives.common.Point> object.
	*/primitives.common.Point.prototype.swap=function(point){var x=point.x,y=point.y;point.x=this.x;point.y=this.y;this.x=x;this.y=y;};/*
		Method: clone
			Clones current point.
	*/primitives.common.Point.prototype.clone=function(){return new primitives.common.Point(this);};/*
		Method: toString
			Returns rectangle location in form of CSS style string.
	
		Parameters:
			units - The string name of units. Uses "px" if not defined.
	
		Returns:
			CSS style string.
	*/primitives.common.Point.prototype.toString=function(units){var result="";units=units!==undefined?units:"px";result+="left:"+this.x+units+";";result+="top:"+this.y+units+";";return result;};/* /graphics/structs/MoveSegment.js*/primitives.common.MoveSegment=function(){this.parent=primitives.common.Point.prototype;this.parent.constructor.apply(this,arguments);this.segmentType=1/*primitives.common.SegmentType.Move*/;};primitives.common.MoveSegment.prototype=new primitives.common.Point();primitives.common.MoveSegment.prototype.clone=function(){return new primitives.common.MoveSegment(this);};primitives.common.MoveSegment.prototype.loop=function(thisArg,onItem){if(onItem!=null){onItem.call(thisArg,this.x,this.y,0);}};primitives.common.MoveSegment.prototype.setPoint=function(point,index){this.x=point.x;this.y=point.y;};primitives.common.MoveSegment.prototype.getEndPoint=function(){return this;};primitives.common.MoveSegment.prototype.invert=function(endPoint){this.x=endPoint.x;this.y=endPoint.y;};primitives.common.MoveSegment.prototype.transform=function(transform,forward){var self=this;transform.transformPoint(self.x,self.y,forward,self,function(x,y){self.x=x;self.y=y;});//ignore jslint
	};/* /graphics/structs/CubicArcSegment.js*/primitives.common.CubicArcSegment=function(arg0,arg1,arg2,arg3,arg4,arg5){this.parent=primitives.common.Point.prototype;this.x=null;this.y=null;this.cpX1=null;this.cpY1=null;this.cpX2=null;this.cpY2=null;switch(arguments.length){case 3:this.parent.constructor.apply(this,[arg2.x,arg2.y]);this.cpX1=arg0.x;this.cpY1=arg0.y;this.cpX2=arg1.x;this.cpY2=arg1.y;break;case 6:this.parent.constructor.apply(this,[arg4,arg5]);this.cpX1=arg0;this.cpY1=arg1;this.cpX2=arg2;this.cpY2=arg3;break;default:break;}this.segmentType=3/*primitives.common.SegmentType.CubicArc*/;};primitives.common.CubicArcSegment.prototype=new primitives.common.Point();primitives.common.CubicArcSegment.prototype.clone=function(){return new primitives.common.CubicArcSegment(this.cpX1,this.cpY1,this.cpX2,this.cpY2,this.x,this.y);};primitives.common.CubicArcSegment.prototype.loop=function(thisArg,onItem){if(onItem!=null){onItem.call(thisArg,this.cpX1,this.cpY1,0);onItem.call(thisArg,this.cpX2,this.cpY2,1);onItem.call(thisArg,this.x,this.y,2);}};primitives.common.CubicArcSegment.prototype.setPoint=function(point,index){switch(index){case 0:this.cpX1=point.x;this.cpY1=point.y;break;case 1:this.cpX2=point.x;this.cpY2=point.y;break;case 2:this.x=point.x;this.y=point.y;break;}};primitives.common.CubicArcSegment.prototype.getEndPoint=function(){return this;};primitives.common.CubicArcSegment.prototype.invert=function(endPoint){var tempX=this.cpX1,tempY=this.cpY1;this.x=endPoint.x;this.y=endPoint.y;this.cpX1=this.cpX2;this.cpY1=this.cpY2;this.cpX2=tempX;this.cpY2=tempY;};primitives.common.CubicArcSegment.prototype.transform=function(transform,forward){var self=this;transform.transform3Points(self.x,self.y,self.cpX1,self.cpY1,self.cpX2,self.cpY2,forward,self,function(x,y,cpX1,cpY1,cpX2,cpY2){self.x=x;self.y=y;self.cpX1=cpX1;self.cpY1=cpY1;self.cpX2=cpX2;self.cpY2=cpY2;});//ignore jslint
	};primitives.common.CubicArcSegment.prototype.trim=function(prevEndPoint,offset){var time=0.5,endPoint=this.offsetPoint(this.x,this.y,this.cpX2,this.cpY2,this.cpX1,this.cpY1,prevEndPoint.x,prevEndPoint.y,time),time2=0.1,endPoint2=this.offsetPoint(this.x,this.y,this.cpX2,this.cpY2,this.cpX1,this.cpY1,prevEndPoint.x,prevEndPoint.y,time2);time=offset*(time/endPoint.distanceTo(this.x,this.y)+time2/endPoint2.distanceTo(this.x,this.y))/2.0;endPoint=this.offsetPoint(this.x,this.y,this.cpX2,this.cpY2,this.cpX1,this.cpY1,prevEndPoint.x,prevEndPoint.y,time);this.x=endPoint.x;this.y=endPoint.y;return this;};primitives.common.CubicArcSegment.prototype.offsetPoint=function(x,y,cpX1,cpY1,cpX2,cpY2,x2,y2,time){return new primitives.common.Point((1-time)*(1-time)*(1-time)*x+3*(1-time)*(1-time)*time*cpX1+3*(1-time)*time*time*cpX2+time*time*time*x2,(1-time)*(1-time)*(1-time)*y+3*(1-time)*(1-time)*time*cpY1+3*(1-time)*time*time*cpY2+time*time*time*y2);};/* /graphics/structs/DotSegment.js*/primitives.common.DotSegment=function(x,y,width,height,cornerRadius){this.segmentType=4/*primitives.common.SegmentType.Dot*/;this.x=x;this.y=y;this.width=width;this.height=height;this.cornerRadius=cornerRadius;};/* /graphics/structs/Label.js*/primitives.common.Label=function(){this.text=null;this.position=null;// primitives.common.Rect
	this.weight=0;this.isActive=true;this.labelType=0/*primitives.common.LabelType.Regular*/;this.labelOrientation=0/*primitives.text.TextOrientationType.Horizontal*/;this.horizontalAlignmentType=0/*primitives.common.HorizontalAlignmentType.Center*/;this.verticalAlignmentType=2/*primitives.common.VerticalAlignmentType.Bottom*/;};/* /graphics/structs/LineSegment.js*/primitives.common.LineSegment=function(){this.parent=primitives.common.MoveSegment.prototype;this.parent.constructor.apply(this,arguments);this.segmentType=0/*primitives.common.SegmentType.Line*/;};primitives.common.LineSegment.prototype=new primitives.common.MoveSegment();primitives.common.LineSegment.prototype.clone=function(){return new primitives.common.LineSegment(this);};primitives.common.LineSegment.prototype.trim=function(prevEndPoint,offset){var endPoint=this.offsetPoint(this,prevEndPoint,offset);this.x=endPoint.x;this.y=endPoint.y;return this;};primitives.common.LineSegment.prototype.offsetPoint=function(first,second,offset){var result=null,distance=first.distanceTo(second);if(distance===0||offset===0){result=new primitives.common.Point(first);}else{result=new primitives.common.Point(first.x+(second.x-first.x)/distance*offset,first.y+(second.y-first.y)/distance*offset);}return result;};/* /graphics/structs/Matrix.js*//*
		Class: primitives.common.Matrix
		Class represents square matrix having 2 rows and 2 columns.
	
		Parameters:
			matrix - <primitives.common.Matrix> object.
	
		Parameters:
			a1 - top left.
			b1 - top right.
			a2 - bottom left
			b2 - bottom right
	*/primitives.common.Matrix=function(arg0,arg1,arg2,arg3){this.a1=null;this.b1=null;this.a2=null;this.b2=null;switch(arguments.length){case 1:this.a1=arg0.a1;this.b1=arg0.b1;this.a2=arg0.a2;this.b2=arg0.b2;break;case 4:this.a1=arg0;this.b1=arg1;this.a2=arg2;this.b2=arg3;break;default:break;}};primitives.common.Matrix.prototype.determinant=function(){return this.a1*this.b2-this.b1*this.a2;};/* /graphics/structs/PaletteItem.js*/primitives.common.PaletteItem=function(options){this.lineColor="#c0c0c0"/*primitives.common.Colors.Silver*/;this.lineWidth=1;this.lineType=0/*primitives.common.LineType.Solid*/;this.fillColor=null;this.opacity=null;this._key="";var property,properties,index,len;properties=['lineColor','lineWidth','lineType','fillColor','opacity'];for(index=0,len=properties.length;index<len;index+=1){property=properties[index];if(options!=null&&options.hasOwnProperty(property)){this[property]=options[property];}this._key+=(!primitives.common.isNullOrEmpty(this._key)?", ":"")+property+":"+this[property];}};primitives.common.PaletteItem.prototype.toAttr=function(){var attr={"lineWidth":this.lineWidth,"lineType":this.lineType};if(this.fillColor!==null){attr.fillColor=this.fillColor;}if(this.opacity!==null){attr.opacity=this.opacity;}if(this.lineColor!==null){attr.borderColor=this.lineColor;}return attr;};primitives.common.PaletteItem.prototype.toString=function(){return this._key;};/* /graphics/structs/PaletteManager.js*/primitives.common.PaletteManager=function(options,linesPalette){this.palette=[];this.cursor=0;var index,len;/* pallete based connectors */if(linesPalette.length===0){/* draw all extra as regular */this.palette=[new primitives.common.PaletteItem({lineColor:options.linesColor,lineWidth:options.linesWidth,lineType:options.linesType})];this.paletteLength=this.palette.length;this.regularIndex=0;}else{for(index=0,len=linesPalette.length;index<len;index+=1){this.palette.push(new primitives.common.PaletteItem(linesPalette[index]));}this.paletteLength=this.palette.length;/* regular */this.palette.push(new primitives.common.PaletteItem({lineColor:options.linesColor,lineWidth:options.linesWidth,lineType:options.linesType}));this.regularIndex=this.palette.length-1;}/* highlight */this.palette.push(new primitives.common.PaletteItem({lineColor:options.highlightLinesColor,lineWidth:options.highlightLinesWidth,lineType:options.highlightLinesType}));this.highlightIndex=this.palette.length-1;};primitives.common.PaletteManager.prototype.selectPalette=function(index){this.cursor=index%this.paletteLength;};primitives.common.PaletteManager.prototype.getPalette=function(connectorStyleType){var index=null;switch(connectorStyleType){case 1/*primitives.common.ConnectorStyleType.Regular*/:index=this.regularIndex;break;case 2/*primitives.common.ConnectorStyleType.Highlight*/:index=this.highlightIndex;break;case 0/*primitives.common.ConnectorStyleType.Extra*/:index=this.cursor;break;}return this.palette[index];};/* /graphics/structs/Polyline.js*/primitives.common.Polyline=function(newPaletteItem){var paletteItem=new primitives.common.PaletteItem(),segments=[],self,arrowPaletteItem;switch(arguments.length){case 1:paletteItem=newPaletteItem;break;}arrowPaletteItem=new primitives.common.PaletteItem({lineColor:paletteItem.lineColor,lineWidth:0,fillColor:paletteItem.lineColor,opacity:paletteItem.opacity||1});function getStartPoint(){var result=null;if(segments.length>0){result=segments[0].getEndPoint();}return result;}function getEndPoint(){var result=null;if(segments.length>0){result=segments[segments.length-1].getEndPoint();}return result;}function addSegment(segment){segments.push(segment);}function addSegments(newSegments){segments=segments.concat(newSegments);}function mergeTo(polyline){polyline.addSegments(segments);}function clone(){var index,len,result=new primitives.common.Polyline(paletteItem),cloneSegments=[],segment;for(index=0,len=segments.length;index<len;index+=1){segment=segments[index];cloneSegments.push(segment.clone());}result.addSegments(cloneSegments);return result;}function length(){return segments.length;}function loop(thisArg,onItem){var index,len,segment;if(onItem!=null){for(index=0,len=segments.length;index<len;index+=1){segment=segments[index];if(segment){if(onItem.call(thisArg,segment,index)){break;}}}}}function loopReversed(thisArg,onItem){var index,segment;if(onItem!=null){for(index=segments.length-1;index>=0;index-=1){segment=segments[index];if(segment){if(onItem.call(thisArg,segment,index)){break;}}}}}function transform(transformArg,forward){loop(this,function(segment){if(segment.transform!=null){segment.transform(transformArg,forward);}});}function isInvertable(){return primitives.common.isNullOrEmpty(paletteItem.fillColor);}function addInverted(polyline){var hasMoved=false,stack=[];if(isInvertable()){polyline.loopReversed(this,function(segment,index){if(segment.segmentType!=4/*primitives.common.SegmentType.Dot*/){if(!hasMoved){segments.push(new primitives.common.MoveSegment(segment.getEndPoint()));hasMoved=true;}stack.unshift(segment);if(stack.length>1){stack[1].invert(stack[0].getEndPoint());segments.push(stack[1]);stack.length=1;}}});}else{polyline.mergeTo(self);}}function _getArrow(fromX,fromY,toX,toY,length,width){var result=new primitives.common.Polyline(arrowPaletteItem),index,len,point,x,y,perimiter=[new primitives.common.Point(length,-width/2),new primitives.common.Point(0,0),new primitives.common.Point(length,width/2),new primitives.common.Point(length/4*3,0)],angle=Math.atan2(fromY-toY,fromX-toX);/* rotate and translate points */for(index=0,len=perimiter.length;index<len;index+=1){point=perimiter[index];x=point.x*Math.cos(angle)-point.y*Math.sin(angle);y=point.x*Math.sin(angle)+point.y*Math.cos(angle);point.x=x+toX;point.y=y+toY;}/* create arrow shape*/result.addSegment(new primitives.common.MoveSegment(perimiter[0].x,perimiter[0].y));result.addSegment(new primitives.common.LineSegment(perimiter[1].x,perimiter[1].y));result.addSegment(new primitives.common.LineSegment(perimiter[2].x,perimiter[2].y));result.addSegment(new primitives.common.QuadraticArcSegment(perimiter[3].x,perimiter[3].y,perimiter[0].x,perimiter[0].y));return result;}function addOffsetArrow(forward,lineWidth,offsetPercent,minimumDistance,onAddArrowSegments){var prevEndPoint,currentEndPoint,currentSegment,newEndPoint,newPrevEndPoint,polyline,len=segments.length,arrowTipLength=lineWidth*3,arrowTipWidth=lineWidth*2,offset,distance;switch(lineWidth){case 1:arrowTipLength=8;arrowTipWidth=6;break;case 2:arrowTipLength=12;arrowTipWidth=8;break;case 3:arrowTipLength=16;arrowTipWidth=10;break;}if(onAddArrowSegments!=null&&len>1){prevEndPoint=segments[len-2].getEndPoint();currentSegment=segments[len-1];if(currentSegment.offsetPoint!=null){currentEndPoint=new primitives.common.Point(currentSegment.getEndPoint());distance=prevEndPoint.distanceTo(currentEndPoint);if(distance>minimumDistance){offset=distance*offsetPercent;if(forward){newEndPoint=currentSegment.offsetPoint(prevEndPoint,currentEndPoint,offset);polyline=_getArrow(prevEndPoint.x,prevEndPoint.y,newEndPoint.x,newEndPoint.y,arrowTipLength,arrowTipWidth);}else{newPrevEndPoint=currentSegment.offsetPoint(currentEndPoint,prevEndPoint,offset);polyline=_getArrow(currentEndPoint.x,currentEndPoint.y,newPrevEndPoint.x,newPrevEndPoint.y,arrowTipLength,arrowTipWidth);}onAddArrowSegments(polyline);}}}}function addArrow(lineWidth,onAddArrowSegments){var prevEndPoint,currentEndPoint,currentSegment,newEndPoint,polyline,len=segments.length,arrowTipLength=lineWidth*3,arrowTipWidth=lineWidth*2;switch(lineWidth){case 1:arrowTipLength=8;arrowTipWidth=6;break;case 2:arrowTipLength=12;arrowTipWidth=8;break;case 3:arrowTipLength=16;arrowTipWidth=10;break;}if(onAddArrowSegments!=null&&len>1){prevEndPoint=segments[len-2].getEndPoint();currentSegment=segments[len-1];if(currentSegment.trim!=null){currentEndPoint=new primitives.common.Point(currentSegment.getEndPoint());newEndPoint=currentSegment.trim(prevEndPoint,arrowTipWidth);polyline=_getArrow(newEndPoint.x,newEndPoint.y,currentEndPoint.x,currentEndPoint.y,arrowTipLength,arrowTipWidth);onAddArrowSegments(polyline,newEndPoint);}}}function optimizeMoveSegments(){var index,len,cursorIndex,key,optimizedSegments,segment,nextSegment,links={},jumps=[],processed=[];for(index=0,len=segments.length;index<len-1;index+=1){segment=segments[index];nextSegment=segments[index+1];switch(segment.segmentType){case 0/*primitives.common.SegmentType.Line*/:case 2/*primitives.common.SegmentType.QuadraticArc*/:case 3/*primitives.common.SegmentType.CubicArc*/:switch(nextSegment.segmentType){case 1/*primitives.common.SegmentType.Move*/:case 4/*primitives.common.SegmentType.Dot*/:key=segment.x+"&"+segment.y;if(!links.hasOwnProperty(key)){links[key]=index;}break;default:break;}break;case 1/*primitives.common.SegmentType.Move*/:key=segment.x+"&"+segment.y;if(links.hasOwnProperty(key)&&!jumps[links[key]]){jumps[links[key]]=index+1;processed[index]=true;}break;default:break;}}optimizedSegments=[];for(index=0;index<len;index+=1){if(!processed[index]){segment=segments[index];optimizedSegments.push(segment);processed[index]=true;if(jumps[index]>0){cursorIndex=jumps[index];while(cursorIndex<len&&!processed[cursorIndex]){segment=segments[cursorIndex];optimizedSegments.push(segment);processed[cursorIndex]=true;if(jumps[cursorIndex]>0){cursorIndex=jumps[cursorIndex];}else{cursorIndex+=1;}}}}}segments=optimizedSegments;}function toString(){return paletteItem.toString();}/* private classes */function Vertex(segment,pointIndex){this.segment=segment;this.pointIndex=pointIndex;}Vertex.prototype.pushToSegment=function(point){this.segment.setPoint(point,this.pointIndex);};function _joinVectors(prev,current,offset,polyline,isLoop){var relationType=prev.relateTo(current),offset2=isLoop?0:offset,joinSegment,joinVector,newToPoint;if(relationType==2/*primitives.common.VectorRelationType.Collinear*/){/* Vectors are collinear vectors so we don't search for intersection */current.offset(offset2);}else{if(relationType==3/*primitives.common.VectorRelationType.Opposite*/&&current.from.context.pointIndex===0){/* Vectors are opposite vectors which belong to 2 different segments
						so we add an extra line segment in between of them
					*/joinSegment=new primitives.common.LineSegment(current.from);polyline.addSegment(joinSegment);current.offset(offset2);newToPoint=current.from.clone();newToPoint.context=new Vertex(joinSegment,0);joinVector=new primitives.common.Vector(prev.to.clone(),newToPoint);if(!isLoop){current.from=newToPoint.clone();}joinVector.offset(offset);joinVector.intersect(prev);joinVector.from.context.pushToSegment(joinVector.from);current.intersect(joinVector);if(isLoop){joinVector.to.context.pushToSegment(joinVector.to);}}else{current.offset(offset2);current.intersect(prev);}}current.from.context.pushToSegment(current.from);}function _closeVector(vectorStack,startVectors,offset,polyline){var startVector,prevVector=vectorStack[0],closurePoint=prevVector.to.context.segment.getEndPoint().toString();if(startVectors.hasOwnProperty(closurePoint)){startVector=startVectors[closurePoint];_joinVectors(prevVector,startVector,offset,polyline,true);delete startVectors[closurePoint];}prevVector.to.context.pushToSegment(prevVector.to);vectorStack.length=0;}function getOffsetPolyine(offset){var result=new primitives.common.Polyline(paletteItem),startVectors={},pointStack=[],vectorStack=[];loop(this,function(segment){var newSegment=segment.clone(),newPoint;switch(newSegment.segmentType){case 4/*primitives.common.SegmentType.Dot*/:case 1/*primitives.common.SegmentType.Move*/:if(vectorStack.length>0){_closeVector(vectorStack,startVectors,offset,result);}pointStack.length=0;if(newSegment.segmentType==1/*primitives.common.SegmentType.Move*/){newPoint=new primitives.common.Point(newSegment);newPoint.context=new Vertex(newSegment,0);pointStack.push(newPoint);}break;default:newSegment.loop(this,function(x,y,index){var newPoint=new primitives.common.Point(x,y),current,prev,closurePoint;newPoint.context=new Vertex(newSegment,index);pointStack.unshift(newPoint);if(pointStack.length>1){vectorStack.unshift(new primitives.common.Vector(pointStack[1].clone(),pointStack[0].clone()));pointStack.length=1;}switch(vectorStack.length){case 1:/* first Vector in stack we add to start Vectors collection for possible join into perimiter*/current=vectorStack[0];closurePoint=current.from.toString();startVectors[closurePoint]=current;current.offset(offset);current.from.context.pushToSegment(current.from);break;case 2:prev=vectorStack[1];current=vectorStack[0];_joinVectors(prev,current,offset,result,false);vectorStack.length=1;break;default:break;}});break;}result.addSegment(newSegment);});if(vectorStack.length>0){_closeVector(vectorStack,startVectors,offset,result);}return result;}self={paletteItem:paletteItem,arrowPaletteItem:arrowPaletteItem,addSegment:addSegment,addSegments:addSegments,mergeTo:mergeTo,length:length,loop:loop,loopReversed:loopReversed,transform:transform,isInvertable:isInvertable,addInverted:addInverted,addArrow:addArrow,addOffsetArrow:addOffsetArrow,optimizeMoveSegments:optimizeMoveSegments,getOffsetPolyine:getOffsetPolyine,toString:toString,getStartPoint:getStartPoint,getEndPoint:getEndPoint,clone:clone};return self;};/* /graphics/structs/PolylinesBuffer.js*/primitives.common.PolylinesBuffer=function(){var polylines={};function _getPolyline(polylines,paletteItem){if(!polylines[paletteItem.toString()]){polylines[paletteItem.toString()]=new primitives.common.Polyline(paletteItem);}return polylines[paletteItem.toString()];}function getPolyline(paletteItem){return _getPolyline(polylines,paletteItem);}function loop(thisArg,onItem){var key,polyline;if(onItem!=null){for(key in polylines){if(polylines.hasOwnProperty(key)){polyline=polylines[key];if(polyline){polyline.optimizeMoveSegments();if(onItem.call(thisArg,polyline)){break;}}}}}}function addInverted(callbackFun,copyOnly){var backupPolylines,backupPolyline;/* backup polylines */backupPolylines=polylines;polylines={};if(callbackFun!=null){callbackFun(this);}/* add inverted polylines to backup collection */loop(this,function(polyline){backupPolyline=_getPolyline(backupPolylines,polyline.paletteItem);if(!copyOnly){backupPolyline.addInverted(polyline);}else{polyline.mergeTo(backupPolyline);}});/* restore polylines */polylines=backupPolylines;}function transform(transformArg,forward){loop(this,function(polyline){polyline.transform(transformArg,forward);});}return{getPolyline:getPolyline,loop:loop,addInverted:addInverted,transform:transform};};/* /graphics/structs/QuadraticArcSegment.js*/primitives.common.QuadraticArcSegment=function(arg0,arg1,arg2,arg3){this.x=null;this.y=null;this.cpX=null;this.cpY=null;switch(arguments.length){case 2:this.x=arg1.x;this.y=arg1.y;this.cpX=arg0.x;this.cpY=arg0.y;break;case 4:this.cpX=arg0;this.cpY=arg1;this.x=arg2;this.y=arg3;break;default:break;}this.segmentType=2/*primitives.common.SegmentType.QuadraticArc*/;};primitives.common.QuadraticArcSegment.prototype.clone=function(){return new primitives.common.QuadraticArcSegment(this.cpX,this.cpY,this.x,this.y);};primitives.common.QuadraticArcSegment.prototype.loop=function(thisArg,onItem){if(onItem!=null){onItem.call(thisArg,this.cpX,this.cpY,0);onItem.call(thisArg,this.x,this.y,1);}};primitives.common.QuadraticArcSegment.prototype.setPoint=function(point,index){switch(index){case 0:this.cpX=point.x;this.cpY=point.y;break;case 1:this.x=point.x;this.y=point.y;break;}};primitives.common.QuadraticArcSegment.prototype.getEndPoint=function(){return this;};primitives.common.QuadraticArcSegment.prototype.invert=function(endPoint){this.x=endPoint.x;this.y=endPoint.y;};primitives.common.QuadraticArcSegment.prototype.transform=function(transform,forward){var self=this;transform.transformPoints(self.x,self.y,self.cpX,self.cpY,forward,self,function(x,y,cpX,cpY){self.x=x;self.y=y;self.cpX=cpX;self.cpY=cpY;});//ignore jslint
	};primitives.common.QuadraticArcSegment.prototype.trim=function(prevEndPoint,offset){var time=0.5,endPoint=this.offsetPoint(this.x,this.y,this.cpX,this.cpY,prevEndPoint.x,prevEndPoint.y,time),time2=0.1,endPoint2=this.offsetPoint(this.x,this.y,this.cpX,this.cpY,prevEndPoint.x,prevEndPoint.y,time2);time=offset*(time/endPoint.distanceTo(this.x,this.y)+time2/endPoint2.distanceTo(this.x,this.y))/2.0;endPoint=this.offsetPoint(this.x,this.y,this.cpX,this.cpY,prevEndPoint.x,prevEndPoint.y,time);this.x=endPoint.x;this.y=endPoint.y;return this;};primitives.common.QuadraticArcSegment.prototype.offsetPoint=function(firstX,firstY,controlX,controlY,secondX,secondY,time){return new primitives.common.Point((1-time)*(1-time)*firstX+2*(1-time)*time*controlX+time*time*secondX,(1-time)*(1-time)*firstY+2*(1-time)*time*controlY+time*time*secondY);};/* /graphics/structs/Rect.js*//*
		Class: primitives.common.Rect
		Class describes the width, height and location of rectangle.
	
		Parameters:
			rect - Copy constructor. It takes as a parameter copy of <primitives.common.Rect> object.
	
		Parameters:
			pointTopLeft - Top left point <primitives.common.Point> object.
			pointBottomRight - Bottom right point <primitives.common.Point> object.
	
		Parameters:
			x - The x coordinate of top left corner.
			y - The y coordinate of top left corner.
			width - Rect width.
			height - Rect height.
	*/primitives.common.Rect=function(arg0,arg1,arg2,arg3){/*
		Property: x
			The location x coordinate.
		*/this.x=null;/*
		Property: y
			The location y coordinate.
		*/this.y=null;/*
		Property: width
			The width of rectangle.
		*/this.width=null;/*
		Property: height
			The height of rectangle.
		*/this.height=null;switch(arguments.length){case 1:this.x=arg0.x;this.y=arg0.y;this.width=arg0.width;this.height=arg0.height;break;case 2:this.x=Math.min(arg0.x,arg1.x);this.y=Math.min(arg0.y,arg1.y);this.width=Math.abs(arg1.x-arg0.x);this.height=Math.abs(arg1.y-arg0.y);break;case 4:this.x=arg0;this.y=arg1;this.width=arg2;this.height=arg3;break;default:break;}};/*
		Method: left
			Gets the x-axis value of the left side of the rectangle.
	*/primitives.common.Rect.prototype.left=function(){return this.x;};/*
		Method: top
			Gets the y-axis value of the top side of the rectangle.
	*/primitives.common.Rect.prototype.top=function(){return this.y;};/*
		Method: right
			Gets the x-axis value of the right side of the rectangle.
	*/primitives.common.Rect.prototype.right=function(){return this.x+this.width;};/*
		Method: bottom
			Gets the y-axis value of the bottom of the rectangle.
	*/primitives.common.Rect.prototype.bottom=function(){return this.y+this.height;};/*
		Method: verticalCenter
			Gets the y-axis value of the center point of the rectangle.
	*/primitives.common.Rect.prototype.verticalCenter=function(){return this.y+this.height/2.0;};/*
		Method: horizontalCenter
			Gets the x-axis value of the center point of the rectangle.
	*/primitives.common.Rect.prototype.horizontalCenter=function(){return this.x+this.width/2.0;};/*
		Method: centerPoint
			Gets the point of the geometrical center of the rectangle.
	*/primitives.common.Rect.prototype.centerPoint=function(){return new primitives.common.Point(this.horizontalCenter(),this.verticalCenter());};/*
		Method: isEmpty
			Gets the value that indicates whether  the rectangle is the Empty rectangle.
	*/primitives.common.Rect.prototype.isEmpty=function(){return this.x===null||this.y===null||this.width===null||this.height===null||this.width<0||this.height<0;};/*
		Method: offset
			Expands the rectangle by using specified value in all directions.
	
		Parameters:
			value - The amount by which to expand or shrink the sides of the rectangle.
	
		Parameters:
			left - The amount by which to expand or shrink the left side of the rectangle.
			top - The amount by which to expand or shrink the top side of the rectangle.
			right - The amount by which to expand or shrink the right side of the rectangle.
			bottom - The amount by which to expand or shrink the bottom side of the rectangle.
	*/primitives.common.Rect.prototype.offset=function(arg0,arg1,arg2,arg3){switch(arguments.length){case 1:if(arg0!==null&&(typeof arg0==='undefined'?'undefined':_typeof(arg0))=="object"){this.x=this.x-arg0.left;this.y=this.y-arg0.top;this.width=this.width+arg0.left+arg0.right;this.height=this.height+arg0.top+arg0.bottom;}else{this.x=this.x-arg0;this.y=this.y-arg0;this.width=this.width+arg0*2.0;this.height=this.height+arg0*2.0;}break;case 4:this.x=this.x-arg0;this.y=this.y-arg1;this.width=this.width+arg0+arg2;this.height=this.height+arg1+arg3;break;}return this;};/*
		Method: scale
			Scales rectangle position.
	*/primitives.common.Rect.prototype.scale=function(scale){this.x=this.x*scale;this.y=this.y*scale;this.width=this.width*scale;this.height=this.height*scale;return this;};/*
		Method: translate
			Moves the rectangle to by the specified horizontal and vertical amounts.
	
		Parameters:
			x - The amount to move the rectangle horizontally.
			y - The amount to move the rectangle vertically.
	*/primitives.common.Rect.prototype.translate=function(x,y){this.x=this.x+x;this.y=this.y+y;return this;};/*
		Method: invert
			Inverts rectangle.
	*/primitives.common.Rect.prototype.invert=function(){var width=this.width,x=this.x;this.width=this.height;this.height=width;this.x=this.y;this.y=x;return this;};/*
		Method: loopEdges
			Loops edges of rectangle in the following order: Top, Right, Bottom, Left
	*/primitives.common.Rect.prototype.loopEdges=function(callback){// function(vector, placementType) {}
	var vertexes=[new primitives.common.Point(this.left(),this.top()),new primitives.common.Point(this.right(),this.top()),new primitives.common.Point(this.right(),this.bottom()),new primitives.common.Point(this.left(),this.bottom())],placements=[1/*primitives.common.PlacementType.Top*/,3/*primitives.common.PlacementType.Right*/,5/*primitives.common.PlacementType.Bottom*/,7/*primitives.common.PlacementType.Left*/];vertexes.push(vertexes[0]);if(callback!=null){for(var index=1,len=vertexes.length;index<len;index+=1){if(callback(new primitives.common.Vector(vertexes[index-1],vertexes[index]),placements[index-1])){break;}}}return this;};/*
		Method: contains
			Indicates whether the rectangle contains the specified point.
	
		Parameters:
			point - The point to check.
	
		Parameters:
			x - The x coordinate of the point to check.
			y - The y coordinate of the point to check.
	
		Returns:
			true if the rectangle contains the specified point; otherwise, false.
	*/primitives.common.Rect.prototype.contains=function(arg0,arg1){switch(arguments.length){case 1:return this.x<=arg0.x&&arg0.x<=this.x+this.width&&this.y<=arg0.y&&arg0.y<=this.y+this.height;case 2:return this.x<=arg0&&arg0<=this.x+this.width&&this.y<=arg1&&arg1<=this.y+this.height;default:return false;}};/*
		Method: cropByRect
			Crops the rectangle by the boundaries of specified rectangle.
	
		Parameters:
			rect - The rectangle to use as the crop boundaries.
	*/primitives.common.Rect.prototype.cropByRect=function(rect){if(this.x<rect.x){this.width-=rect.x-this.x;this.x=rect.x;}if(this.right()>rect.right()){this.width-=this.right()-rect.right();}if(this.y<rect.y){this.height-=rect.y-this.y;this.y=rect.y;}if(this.bottom()>rect.bottom()){this.height-=this.bottom()-rect.bottom();}if(this.isEmpty()){this.x=null;this.y=null;this.width=null;this.height=null;}return this;};/*
		Method: overlaps
			Returns true if the rectangle overlaps specified rectangle.
	
		Parameters:
			rect - The rectangle to use as overlaping rectangle.
	*/primitives.common.Rect.prototype.overlaps=function(rect){var result=true;if(this.x+this.width<rect.x||rect.x+rect.width<this.x||this.y+this.height<rect.y||rect.y+rect.height<this.y){result=false;}return result;};/*
		Method: addRect
			Expands the current rectangle to contain specified rectangle.
	
		Parameters:
			rect - The rectangle to contain.
	
		Parameters:
			x - The x coordinate of the point to contain.
			y - The y coordinate of the point to contain.
	
		Parameters:
			x - The x coordinate of top left corner.
			y - The y coordinate of top left corner.
			width - Rect width.
			height - Rect height.
	*/primitives.common.Rect.prototype.addRect=function(arg0,arg1,arg2,arg3){var right,bottom;switch(arguments.length){case 1:if(!arg0.isEmpty()){if(this.isEmpty()){this.x=arg0.x;this.y=arg0.y;this.width=arg0.width;this.height=arg0.height;}else{right=Math.max(this.right(),arg0.right());bottom=Math.max(this.bottom(),arg0.bottom());this.x=Math.min(this.x,arg0.x);this.y=Math.min(this.y,arg0.y);this.width=right-this.x;this.height=bottom-this.y;}}break;case 2:if(this.isEmpty()){this.x=arg0;this.y=arg1;this.width=0;this.height=0;}else{right=Math.max(this.right(),arg0);bottom=Math.max(this.bottom(),arg1);this.x=Math.min(this.x,arg0);this.y=Math.min(this.y,arg1);this.width=right-this.x;this.height=bottom-this.y;}break;case 4:if(this.isEmpty()){this.x=arg0;this.y=arg1;this.width=arg2;this.height=arg3;}else{right=Math.max(this.right(),arg0+arg2);bottom=Math.max(this.bottom(),arg1+arg3);this.x=Math.min(this.x,arg0);this.y=Math.min(this.y,arg1);this.width=right-this.x;this.height=bottom-this.y;}break;}return this;};/*
		Method: getCSS
			Returns rectangle location and size in form of CSS style object.
	
		Parameters:
			units - The string name of units. Uses "px" if not defined.
	
		Returns:
			CSS style object.
	*/primitives.common.Rect.prototype.getCSS=function(units){units=units!==undefined?units:"px";var result={left:this.x+units,top:this.y+units,width:this.width+units,height:this.height+units};return result;};/*
		Method: toString
			Returns rectangle location and size in form of CSS style string.
	
		Parameters:
			units - The string name of units. Uses "px" if not defined.
	
		Returns:
			CSS style string.
	*/primitives.common.Rect.prototype.toString=function(units){var result="";units=units!==undefined?units:"px";result+="left:"+this.x+units+";";result+="top:"+this.y+units+";";result+="width:"+this.width+units+";";result+="height:"+this.height+units+";";return result;};primitives.common.Rect.prototype.validate=function(){if(isNaN(this.x)||isNaN(this.y)||isNaN(this.width)||isNaN(this.height)){throw"Invalid rect position.";}};/* /graphics/structs/Size.js*//*
		Class: primitives.common.Size
		Class describes the size of an object.
	
		Parameters:
			size - Copy constructor. It takes as a parameter copy of <primitives.common.Size> object.
	
		Parameters:
			width - The initial width of the instance.
			height - The initial height of the instance.
	*/primitives.common.Size=function(arg0,arg1){/*
		Property: width
			The value that specifies the width of the size class.
		*/this.width=0;/*
		Property: height
			The value that specifies the height of the size class.
		*/this.height=0;switch(arguments.length){case 1:this.width=arg0.width;this.height=arg0.height;break;case 2:this.width=arg0;this.height=arg1;break;default:break;}};/*
		Method: invert
			Swaps width and height.
	*/primitives.common.Size.prototype.invert=function(){var width=this.width;this.width=this.height;this.height=width;return this;};/*
		Method: scale
			Scales width and height.
	*/primitives.common.Size.prototype.scale=function(scale){this.width=this.width*scale;this.height=this.height*scale;return this;};/*
		Method: getCSS
			Returns rectangle location and size in form of CSS style object.
	
		Parameters:
			units - The string name of units. Uses "px" if not defined.
	
		Returns:
			CSS style object.
	*/primitives.common.Size.prototype.getCSS=function(units){units=units!==undefined?units:"px";var result={left:this.x+units,top:this.y+units,width:this.width+units,height:this.height+units};return result;};/*
		Method: cropBySize
			Crops the size by the other size.
	
		Parameters:
			size - The size to use as the crop boundaries.
	*/primitives.common.Size.prototype.cropBySize=function(size){this.width=Math.min(this.width,size.width);this.height=Math.min(this.height,size.height);return this;};/*
		Method: addSize
			Extend size by the other size.
	
		Parameters:
			size - The size to use as extension.
	*/primitives.common.Size.prototype.addSize=function(size){this.width=Math.max(this.width,size.width);this.height=Math.max(this.height,size.height);return this;};primitives.common.Size.prototype.validate=function(){if(isNaN(this.width)||isNaN(this.height)){throw"Invalid size.";}};/* /graphics/structs/Thickness.js*//*
		Class: primitives.common.Thickness
		Class describes the thickness of a frame around rectangle.
	
		Parameters:
			left - The thickness for the left side of the rectangle.
			height - The thickness for the upper side of the rectangle.
			right - The thickness for the right side of the rectangle.
			bottom - The thickness for the bottom side of the rectangle.
	*/primitives.common.Thickness=function(left,top,right,bottom){/*
		Property: left
			The thickness for the left side of the rectangle.
		*/this.left=left;/*
		Property: top
			The thickness for the upper side of the rectangle.
		*/this.top=top;/*
		Property: right
			The thickness for the right side of the rectangle.
		*/this.right=right;/*
		Property: bottom
			The thickness for the bottom side of the rectangle.
		*/this.bottom=bottom;};/*
		Method: isEmpty
			Gets the value that indicates whether the thickness is the Empty.
	*/primitives.common.Thickness.prototype.isEmpty=function(){return this.left===0&&this.top===0&&this.right===0&&this.bottom===0;};/*
		Method: toString
			Returns thickness in form of CSS style string. It is conversion to padding style string.
	
		Parameters:
			units - The string name of units. Uses "px" if not defined.
	
		Returns:
			CSS style string.
	*/primitives.common.Thickness.prototype.toString=function(units){units=units!==undefined?units:"px";return this.left+units+", "+this.top+units+", "+this.right+units+", "+this.bottom+units;};/* /graphics/structs/Vector.js*//*
		Class: primitives.common.Vector
		Class represents pair of points that defines a vector in 2D plane.
	
		Parameters:
			vector - <primitives.common.Vector> object.
	
		Parameters:
			from - From 2D point.
			to - To 2D point.
	*/primitives.common.Vector=function(arg0,arg1){/*
		Property: from
			The from point of vector.
		*/this.from=null;/*
		Property: to
			The to point of vector.
		*/this.to=null;switch(arguments.length){case 1:this.from=arg0.from;this.to=arg0.to;break;case 2:this.from=arg0;this.to=arg1;break;default:break;}};primitives.common.Vector.prototype.isNull=function(){return this.from.x==this.to&&this.from.y==this.to.y;};/*
		Method: length
			Returns length of vector.
	
		Returns:
			Vector length.
	*/primitives.common.Vector.prototype.length=function(){return this.from.distanceTo(this.to);};primitives.common.Vector.prototype.equalTo=function(vector){return this.from.equalTo(vector.from)&&this.to.equalTo(vector.to);};primitives.common.Vector.prototype.getMiddlePoint=function(){return new primitives.common.Point((this.from.x+this.to.x)/2,(this.from.y+this.to.y)/2);};primitives.common.Vector.prototype.relateTo=function(vector){var result=0/*primitives.common.VectorRelationType.None*/,x1=this.to.x-this.from.x,y1=this.to.y-this.from.y,x2=vector.to.x-vector.from.x,y2=vector.to.y-vector.from.y,key=(x1?8:0)+(y1?4:0)+(x2?2:0)+(y2?1:0);switch(key){case 0://0000
	case 1://0001
	case 2://0010
	case 3://0011
	case 4://0100
	case 8://1000
	case 12://1100
	result=1/*primitives.common.VectorRelationType.Null*/;break;case 5://0101
	if(y1*y2>0){result=2/*primitives.common.VectorRelationType.Collinear*/;}else{result=3/*primitives.common.VectorRelationType.Opposite*/;}break;case 10://1010
	if(x1*x2>0){result=2/*primitives.common.VectorRelationType.Collinear*/;}else{result=3/*primitives.common.VectorRelationType.Opposite*/;}break;case 15://1111
	if(x1/x2==y1/y2){if(x1/x2>0){result=2/*primitives.common.VectorRelationType.Collinear*/;}else{result=3/*primitives.common.VectorRelationType.Opposite*/;}}break;}return result;};primitives.common.Vector.prototype.offset=function(offset){var length=this.length(),/* in order to rotate right multiply vector on 3D vector (0, 0, -1)*/x=(this.to.y-this.from.y)*offset/length,y=-(this.to.x-this.from.x)*offset/length;this.from.x+=x;this.from.y+=y;this.to.x+=x;this.to.y+=y;};primitives.common.Vector.prototype.getLine=function(){var x1=this.from.x,y1=this.from.y,x2=this.to.x,y2=this.to.y,a=y2-y1,b=x1-x2,c=x1*(y1-y2)+y1*(x2-x1);return[a,b,c];};primitives.common.Vector.prototype.getLineKey=function(){var line=this.getLine(),a=line[0],b=line[1],c=line[2],r=10000;if(b!==0){line=[Math.floor(a/b*r),1,Math.floor(c/b*r)];}else{line=[1,0,Math.floor(c/a*r)];}return line.toString();};primitives.common.Vector.prototype.intersect=function(vector){var v1=this.getLine(),v2=vector.getLine(),m=new primitives.common.Matrix(v1[0],v1[1],v2[0],v2[1]),d=m.determinant(),mx,my,dx,dy,x,y,result=false;if(d!==0){mx=new primitives.common.Matrix(-v1[2],v1[1],-v2[2],v2[1]);dx=mx.determinant();my=new primitives.common.Matrix(v1[0],-v1[2],v2[0],-v2[2]);dy=my.determinant();x=dx/d;y=dy/d;vector.to.x=x;vector.to.y=y;this.from.x=x;this.from.y=y;result=true;}return result;};primitives.common.Vector.prototype.getIntersectionPoint=function(vector,strict,rounding){var v1=this.getLine(),v2=vector.getLine(),m=new primitives.common.Matrix(v1[0],v1[1],v2[0],v2[1]),d=m.determinant(),mx,my,dx,dy,x,y,result=null;if(d!==0){mx=new primitives.common.Matrix(-v1[2],v1[1],-v2[2],v2[1]);dx=mx.determinant();my=new primitives.common.Matrix(v1[0],-v1[2],v2[0],-v2[2]);dy=my.determinant();x=dx/d;y=dy/d;if(strict){if(vector._contains(x,y,rounding)&&this._contains(x,y,rounding)){result=new primitives.common.Point(x,y);}}else{result=new primitives.common.Point(x,y);}}return result;};primitives.common.Vector.prototype._contains=function(x,y,rounding){var x1=Math.min(this.from.x,this.to.x),y1=Math.min(this.from.y,this.to.y),x2=Math.max(this.from.x,this.to.x),y2=Math.max(this.from.y,this.to.y);return x1-rounding<=x&&x<=x2+rounding&&y1-rounding<=y&&y<=y2+rounding;};/* /graphics/Graphics.js*/primitives.common.Graphics=function(element){this.m_element=element;this.m_placeholders={};this.m_activePlaceholder=null;this.m_cache=new primitives.common.Cache();this.graphicsType=null;this.hasGraphics=false;this.debug=false;this.layerNames={};primitives.common.loop(this,primitives.common.Layers,function(key,value){this.layerNames[value]=key;});};primitives.common.Graphics.prototype.clean=function(){var key,placeholder,layerKey,layer;this.m_cache.clear();this.m_cache=null;this.m_element=null;for(key in this.m_placeholders){if(this.m_placeholders.hasOwnProperty(key)){placeholder=this.m_placeholders[key];for(layerKey in placeholder.layers){if(placeholder.layers.hasOwnProperty(layerKey)){layer=placeholder.layers[layerKey];layer.canvas.remove();layer.canvas=null;}}placeholder.layers.length=0;placeholder.activeLayer=null;placeholder.size=null;placeholder.rect=null;placeholder.div=null;}}this.m_placeholders.length=0;this.m_activePlaceholder=null;};primitives.common.Graphics.prototype.resize=function(name,width,height){var placeholder=this.m_placeholders[name];if(placeholder!=null){this.resizePlaceholder(placeholder,width,height);}};primitives.common.Graphics.prototype.resizePlaceholder=function(placeholder,width,height){var layerKey,layer;placeholder.size=new primitives.common.Size(width,height);placeholder.rect=new primitives.common.Rect(0,0,width,height);for(layerKey in placeholder.layers){if(placeholder.layers.hasOwnProperty(layerKey)){layer=placeholder.layers[layerKey];if(layer.name!==-1){layer.canvas.css({"position":"absolute","width":"0px","height":"0px"});}}}};primitives.common.Graphics.prototype.begin=function(){this.m_cache.begin();};primitives.common.Graphics.prototype.end=function(){this.m_cache.end();};primitives.common.Graphics.prototype.reset=function(arg0,arg1){var placeholderName="none",layerName=-1;switch(arguments.length){case 1:if(typeof arg0==="string"){placeholderName=arg0;}else{layerName=arg0;}break;case 2:placeholderName=arg0;layerName=arg1;break;}this.m_cache.reset(placeholderName,layerName);};primitives.common.Graphics.prototype.activate=function(arg0,arg1){switch(arguments.length){case 1:if(typeof arg0==="string"){this._activatePlaceholder(arg0);this._activateLayer(-1);}else{this._activatePlaceholder("none");this._activateLayer(arg0);}break;case 2:this._activatePlaceholder(arg0);this._activateLayer(arg1);break;}return this.m_activePlaceholder;};primitives.common.Graphics.prototype._activatePlaceholder=function(placeholderName){var placeholder=this.m_placeholders[placeholderName],div;if(placeholder===undefined){div=null;if(placeholderName==="none"){div=this.m_element;}else{div=this.m_element.find("."+placeholderName);}placeholder=new primitives.common.Placeholder(placeholderName);placeholder.div=div;placeholder.size=new primitives.common.Size(div.innerWidth(),div.innerHeight());placeholder.rect=new primitives.common.Rect(0,0,placeholder.size.width,placeholder.size.height);this.m_placeholders[placeholderName]=placeholder;}this.m_activePlaceholder=placeholder;};primitives.common.Graphics.prototype._activateLayer=function(layerName){var layer=this.m_activePlaceholder.layers[layerName],placeholder,canvas,position,maximumLayer,layerKey;if(layer===undefined){placeholder=this.m_activePlaceholder;if(layerName===-1){layer=new primitives.common.Layer(layerName);layer.canvas=placeholder.div;}else{canvas=jQuery('<div></div>');canvas.addClass("Layer"+layerName);canvas.addClass("Layer"+this.layerNames[layerName]);position=new primitives.common.Rect(placeholder.rect);canvas.css({"position":"absolute","width":"0px","height":"0px"});maximumLayer=null;for(layerKey in placeholder.layers){if(placeholder.layers.hasOwnProperty(layerKey)){layer=placeholder.layers[layerKey];if(layer.name<layerName){maximumLayer=maximumLayer!==null?Math.max(maximumLayer,layer.name):layer.name;}}}layer=new primitives.common.Layer(layerName);layer.canvas=canvas;if(maximumLayer===null){placeholder.div.prepend(layer.canvas[0]);}else{layer.canvas.insertAfter(placeholder.layers[maximumLayer].canvas);}}placeholder.layers[layerName]=layer;}this.m_activePlaceholder.activeLayer=layer;};primitives.common.Graphics.prototype.text=function(x,y,width,height,label,orientation,horizontalAlignment,verticalAlignment,attr){var placeholder=this.m_activePlaceholder,style={"position":"absolute","padding":0,"margin":0,"text-align":this._getTextAlign(horizontalAlignment),"font-size":attr["font-size"],"font-family":attr["font-family"],"font-weight":attr["font-weight"],"font-style":attr["font-style"],"color":attr["font-color"],"line-height":1},rotation="",element,tdstyle;switch(orientation){case 0/*primitives.text.TextOrientationType.Horizontal*/:case 3/*primitives.text.TextOrientationType.Auto*/:style.left=x;style.top=y;style.width=width;style.height=height;break;case 1/*primitives.text.TextOrientationType.RotateLeft*/:style.left=x+Math.round(width/2.0-height/2.0);style.top=y+Math.round(height/2.0-width/2.0);style.width=height;style.height=width;rotation="rotate(-90deg)";break;case 2/*primitives.text.TextOrientationType.RotateRight*/:style.left=x+Math.round(width/2.0-height/2.0);style.top=y+Math.round(height/2.0-width/2.0);style.width=height;style.height=width;rotation="rotate(90deg)";break;}style["-webkit-transform-origin"]="center center";style["-moz-transform-origin"]="center center";style["-o-transform-origin"]="center center";style["-ms-transform-origin"]="center center";style["-webkit-transform"]=rotation;style["-moz-transform"]=rotation;style["-o-transform"]=rotation;style["-ms-transform"]=rotation;style.transform=rotation;style["max-width"]=style.width;style["max-height"]=style.height;label=label.replace(new RegExp("\n",'g'),"<br/>");switch(verticalAlignment){case 0/*primitives.common.VerticalAlignmentType.Top*/:if(this.debug){style.border="solid 1px black";}element=this.m_cache.get(placeholder.name,placeholder.activeLayer.name,"text");if(element===null){element=jQuery("<div></div>");element.css(style);element.html(label);placeholder.activeLayer.canvas.append(element);this.m_cache.put(placeholder.name,placeholder.activeLayer.name,"text",element);}else{element.css(style);element.html(label);}break;default:style["border-collapse"]="collapse";tdstyle={"vertical-align":this._getVerticalAlignment(verticalAlignment),"padding":0};if(this.debug){tdstyle.border="solid 1px black";}element=this.m_cache.get(placeholder.name,placeholder.activeLayer.name,"textintable");if(element===null){element=jQuery('<table><tbody><tr><td></td></tr></tbody></table>');primitives.common.css(element,style);element.find("td").css(tdstyle).html(label);placeholder.activeLayer.canvas.append(element);this.m_cache.put(placeholder.name,placeholder.activeLayer.name,"textintable",element);}else{primitives.common.css(element,style);element.find("td").css(tdstyle).html(label);}break;}};primitives.common.Graphics.prototype._getTextAlign=function(alignment){var result=null;switch(alignment){case 0/*primitives.common.HorizontalAlignmentType.Center*/:result="center";break;case 1/*primitives.common.HorizontalAlignmentType.Left*/:result="left";break;case 2/*primitives.common.HorizontalAlignmentType.Right*/:result="right";break;}return result;};primitives.common.Graphics.prototype._getVerticalAlignment=function(alignment){var result=null;switch(alignment){case 1/*primitives.common.VerticalAlignmentType.Middle*/:result="middle";break;case 0/*primitives.common.VerticalAlignmentType.Top*/:result="top";break;case 2/*primitives.common.VerticalAlignmentType.Bottom*/:result="bottom";break;}return result;};primitives.common.Graphics.prototype.polylinesBuffer=function(buffer){buffer.loop(this,function(polyline){if(polyline.length()>0){this.polyline(polyline);}});};primitives.common.Graphics.prototype.polyline=function(polylineData){var fromX=null,fromY=null,attr=polylineData.paletteItem.toAttr();polylineData.loop(this,function(segment){switch(segment.segmentType){case 1/*primitives.common.SegmentType.Move*/:fromX=Math.round(segment.x)+0.5;fromY=Math.round(segment.y)+0.5;break;case 0/*primitives.common.SegmentType.Line*/:this.rightAngleLine(fromX,fromY,Math.round(segment.x)+0.5,Math.round(segment.y)+0.5,attr);fromX=Math.round(segment.x)+0.5;fromY=Math.round(segment.y)+0.5;break;case 4/*primitives.common.SegmentType.Dot*/:this.dot(segment.x,segment.y,segment.width,segment.height,segment.cornerRadius,attr);break;}});};primitives.common.Graphics.prototype.dot=function(cx,cy,width,height,cornerRadius,attr){var placeholder=this.m_activePlaceholder,element=this.m_cache.get(placeholder.name,placeholder.activeLayer.name,"dot"),hasBorder=attr.lineWidth!==undefined&&attr.borderColor!==undefined,style={"position":"absolute","width":width-(hasBorder?1:0),"top":Math.round(cy),"left":Math.round(cx),"padding":0,"margin":0,"line-height":"0px","overflow":"hidden","height":height-(hasBorder?1:0),"background":attr.fillColor,"-moz-border-radius":cornerRadius,"-webkit-border-radius":cornerRadius,"-khtml-border-radius":cornerRadius,"border-radius":cornerRadius,"font-size":"0px","border-style":hasBorder?"Solid":"None","border-width":hasBorder?"1px":"0px","border-color":hasBorder?attr.borderColor:""};if(element===null){element=jQuery('<div></div>');primitives.common.css(element,style);placeholder.activeLayer.canvas.append(element);this.m_cache.put(placeholder.name,placeholder.activeLayer.name,"dot",element);}else{primitives.common.css(element,style);}};primitives.common.Graphics.prototype.rightAngleLine=function(fromX,fromY,toX,toY,attr){var placeholder=this.m_activePlaceholder,isVertical=Math.abs(toY-fromY)>Math.abs(toX-fromX),lineWidth=attr.lineWidth,style={"position":"absolute","top":Math.round(Math.min(fromY,toY)-(isVertical?0:lineWidth/2.0)),"left":Math.round(Math.min(fromX,toX)-(isVertical?lineWidth/2.0:0)),"padding":0,"margin":0,"opacity":0.5,"line-height":"0px","overflow":"hidden","background":attr.borderColor,"font-size":"0px"},element;if(isVertical){style.width=lineWidth;style.height=Math.abs(Math.round(toY-fromY));}else{style.width=Math.abs(Math.round(toX-fromX));style.height=lineWidth;}element=this.m_cache.get(placeholder.name,placeholder.activeLayer.name,"rect");if(element===null){element=jQuery("<div></div>");primitives.common.css(element,style);placeholder.activeLayer.canvas.append(element);this.m_cache.put(placeholder.name,placeholder.activeLayer.name,"rect",element);}else{primitives.common.css(element,style);}};primitives.common.Graphics.prototype.template=function(x,y,width,height,contentx,contenty,contentWidth,contentHeight,template,hashCode,onRenderTemplate,uiHash,attr){//ignore jslint
	var placeholder=this.m_activePlaceholder,element,templateKey="template"+(hashCode!==null?hashCode:primitives.common.hashCode(template)),gap=0,style;element=this.m_cache.get(placeholder.name,placeholder.activeLayer.name,templateKey);if(attr!==null){if(attr["border-width"]!==undefined){gap=this.getPxSize(attr["border-width"]);}}style={"width":contentWidth-gap+"px","height":contentHeight-gap+"px","top":y+contenty+"px","left":x+contentx+"px"};jQuery.extend(style,attr);if(uiHash==null){uiHash=new primitives.common.RenderEventArgs();}if(element==null){element=jQuery(template);jQuery.extend(style,{"position":"absolute","padding":"0px","margin":"0px"},attr);primitives.common.css(element,style);uiHash.element=element;uiHash.renderingMode=0/*primitives.common.RenderingMode.Create*/;if(onRenderTemplate!==null){onRenderTemplate(null,uiHash);}placeholder.activeLayer.canvas.append(element);this.m_cache.put(placeholder.name,placeholder.activeLayer.name,templateKey,element);}else{uiHash.element=element;uiHash.renderingMode=1/*primitives.common.RenderingMode.Update*/;primitives.common.css(element,style);if(onRenderTemplate!==null){onRenderTemplate(null,uiHash);}}return element;};primitives.common.Graphics.prototype.getPxSize=function(value,base){var result=value;if(typeof value==="string"){if(value.indexOf("pt")>0){result=parseInt(value,10)*96/72;}else if(value.indexOf("%")>0){result=parseFloat(value)/100.0*base;}else{result=parseInt(value,10);}}return result;};/* /graphics/Cache.js*/primitives.common.Cache=function(){this.threshold=20;this.m_visible={};this.m_invisible={};};primitives.common.Cache.prototype.begin=function(){var placeholder,type,index,control;for(placeholder in this.m_visible){if(this.m_visible.hasOwnProperty(placeholder)){for(type in this.m_visible[placeholder]){if(this.m_visible[placeholder].hasOwnProperty(type)){for(index=this.m_visible[placeholder][type].length-1;index>=0;index-=1){control=this.m_visible[placeholder][type][index];control.css({"visibility":"hidden"});this.m_invisible[placeholder][type].push(control);}this.m_visible[placeholder][type].length=0;}}}}};primitives.common.Cache.prototype.end=function(){var placeholder,type,control;for(placeholder in this.m_visible){if(this.m_visible.hasOwnProperty(placeholder)){for(type in this.m_visible[placeholder]){if(this.m_visible[placeholder].hasOwnProperty(type)){control=null;if(this.m_invisible[placeholder][type].length>this.threshold){while((control=this.m_invisible[placeholder][type].pop())!==undefined){control.remove();}}}}}}};primitives.common.Cache.prototype.reset=function(placeholder,layer){placeholder=placeholder+"-"+layer;var control=null,type,index;for(type in this.m_visible[placeholder]){if(this.m_visible[placeholder].hasOwnProperty(type)){for(index=this.m_visible[placeholder][type].length-1;index>=0;index-=1){control=this.m_visible[placeholder][type][index];this.m_invisible[placeholder][type].push(control);control.css({"visibility":"hidden"});}this.m_visible[placeholder][type].length=0;}}};primitives.common.Cache.prototype.clear=function(){var placeholder,type,control;for(placeholder in this.m_visible){if(this.m_visible.hasOwnProperty(placeholder)){for(type in this.m_visible[placeholder]){if(this.m_visible[placeholder].hasOwnProperty(type)){control=null;while((control=this.m_visible[placeholder][type].pop())!==undefined){control.remove();}while((control=this.m_invisible[placeholder][type].pop())!==undefined){control.remove();}}}}}};primitives.common.Cache.prototype.get=function(placeholder,layer,type){placeholder=placeholder+"-"+layer;var result=null;if(this.m_visible[placeholder]===undefined){this.m_visible[placeholder]={};this.m_invisible[placeholder]={};}if(this.m_visible[placeholder][type]===undefined){this.m_visible[placeholder][type]=[];this.m_invisible[placeholder][type]=[];}result=this.m_invisible[placeholder][type].pop()||null;if(result!==null){this.m_visible[placeholder][type].push(result);result.css({"visibility":"inherit"});}return result;};primitives.common.Cache.prototype.put=function(placeholder,layer,type,control){placeholder=placeholder+"-"+layer;this.m_visible[placeholder][type].push(control);};/* /graphics/CanvasGraphics.js*/primitives.common.CanvasGraphics=function(element){this.parent=primitives.common.Graphics.prototype;this.parent.constructor.apply(this,arguments);this.graphicsType=1/*primitives.common.GraphicsType.Canvas*/;this.m_maximum=8000;// Search for maximum size of canvas element
	};primitives.common.CanvasGraphics.prototype=new primitives.common.Graphics();primitives.common.CanvasGraphics.prototype.clean=function(){var key,placeholder,layerKey,layer;for(key in this.m_placeholders){if(this.m_placeholders.hasOwnProperty(key)){placeholder=this.m_placeholders[key];for(layerKey in placeholder.layers){if(placeholder.layers.hasOwnProperty(layerKey)){layer=placeholder.layers[layerKey];if(layer.canvascanvas!==null){layer.canvascanvas.remove();layer.canvascanvas=null;}}}}}this.parent.clean.apply(this,arguments);};primitives.common.CanvasGraphics.prototype._activatePlaceholder=function(placeholderName){var placeholder,width,height;this.parent._activatePlaceholder.apply(this,arguments);placeholder=this.m_activePlaceholder;width=placeholder.size.width;height=placeholder.size.height;if(width>this.m_maximum||height>this.m_maximum){placeholder.hasGraphics=false;}else{placeholder.hasGraphics=true;}};primitives.common.CanvasGraphics.prototype.resizePlaceholder=function(placeholder,width,height){var layerKey,layer;this.parent.resizePlaceholder.apply(this,arguments);for(layerKey in placeholder.layers){if(placeholder.layers.hasOwnProperty(layerKey)){layer=placeholder.layers[layerKey];if(layer.canvascanvas!==null){layer.canvascanvas.css({"position":"absolute","width":width+"px","height":height+"px"});layer.canvascanvas.attr({"width":width+"px","height":height+"px"});}}}};primitives.common.CanvasGraphics.prototype.begin=function(){var key,placeholder,layerKey,layer,width,height;this.parent.begin.apply(this);for(key in this.m_placeholders){if(this.m_placeholders.hasOwnProperty(key)){placeholder=this.m_placeholders[key];width=placeholder.size.width;height=placeholder.size.height;for(layerKey in placeholder.layers){if(placeholder.layers.hasOwnProperty(layerKey)){layer=placeholder.layers[layerKey];if(layer.canvascanvas!==null){layer.canvascontext.clearRect(0,0,width,height);}}}}}};primitives.common.Graphics.prototype._getContext=function(placeholder,layer){var width=placeholder.size.width,height=placeholder.size.height;if(layer.canvascanvas===null){layer.canvascanvas=jQuery('<canvas></canvas>');layer.canvascanvas.attr({"width":width+"px","height":height+"px"});placeholder.activeLayer.canvas.prepend(layer.canvascanvas);layer.canvascontext=layer.canvascanvas[0].getContext('2d');}return layer.canvascontext;};primitives.common.CanvasGraphics.prototype.reset=function(arg0,arg1){var placeholderName="none",layerName=-1,placeholder,layer,width,height;switch(arguments.length){case 1:if(typeof arg0==="string"){placeholderName=arg0;}else{layerName=arg0;}break;case 2:placeholderName=arg0;layerName=arg1;break;}this.parent.reset.apply(this,arguments);placeholder=this.m_placeholders[placeholderName];if(placeholder!==undefined){width=placeholder.size.width;height=placeholder.size.height;layer=placeholder.layers[layerName];if(layer!==undefined&&layer.canvascanvas!==null){layer.canvascontext.clearRect(0,0,width,height);}}};primitives.common.CanvasGraphics.prototype.polyline=function(polylineData){var placeholder=this.m_activePlaceholder,layer,context,attr=polylineData.paletteItem.toAttr(),dashes,step,cornerRadius;if(!placeholder.hasGraphics){this.parent.polyline.apply(this,arguments);}else{layer=placeholder.activeLayer;context=this._getContext(placeholder,layer);context.save();if(attr.lineWidth!==undefined&&attr.borderColor!==undefined){context.strokeStyle=attr.borderColor;context.lineWidth=attr.lineWidth;}else{context.lineWidth=0;context.strokeStyle="Transparent";}if(attr.lineType!=null){step=Math.round(attr.lineWidth)||1;switch(attr.lineType){case 0/*primitives.common.LineType.Solid*/:dashes=[];break;case 1/*primitives.common.LineType.Dotted*/:dashes=[step,step];break;case 2/*primitives.common.LineType.Dashed*/:dashes=[step*5,step*3];break;}if(context.setLineDash!==undefined){context.setLineDash(dashes);}else if(context.webkitLineDash!==undefined){context.webkitLineDash=dashes;}else if(context.mozDash!==undefined){context.mozDash=dashes;}}context.beginPath();polylineData.loop(this,function(segment){switch(segment.segmentType){case 1/*primitives.common.SegmentType.Move*/:context.moveTo(Math.round(segment.x)+0.5,Math.round(segment.y)+0.5);break;case 0/*primitives.common.SegmentType.Line*/:context.lineTo(Math.round(segment.x)+0.5,Math.round(segment.y)+0.5);break;case 4/*primitives.common.SegmentType.Dot*/:if(segment.width==segment.height&&segment.width/2.0<=segment.cornerRadius){// circle dot
	context.moveTo(Math.round(segment.x)+segment.width+0.5,Math.round(segment.y)+segment.height/2.0+0.5);context.arc(Math.round(segment.x)+segment.width/2.0+0.5,Math.round(segment.y)+segment.height/2.0+0.5,Math.round(segment.width/2.0),0,2*Math.PI,false);}else if(segment.cornerRadius===0){// square
	context.moveTo(Math.round(segment.x)+0.5,Math.round(segment.y)+0.5);context.lineTo(Math.round(segment.x+segment.width)+0.5,Math.round(segment.y)+0.5);context.lineTo(Math.round(segment.x+segment.width)+0.5,Math.round(segment.y+segment.height)+0.5);context.lineTo(Math.round(segment.x)+0.5,Math.round(segment.y+segment.height)+0.5);context.lineTo(Math.round(segment.x)+0.5,Math.round(segment.y)+0.5);}else{// rounded corners rectangle
	cornerRadius=Math.min(segment.cornerRadius,Math.min(segment.width/2.0,segment.height/2.0));context.moveTo(Math.round(segment.x)+0.5,Math.round(segment.y+cornerRadius)+0.5);context.arc(Math.round(segment.x+cornerRadius)+0.5,Math.round(segment.y+cornerRadius)+0.5,Math.round(cornerRadius),Math.PI,-Math.PI/2.0,false);context.lineTo(Math.round(segment.x+segment.width-cornerRadius)+0.5,Math.round(segment.y)+0.5);context.arc(Math.round(segment.x+segment.width-cornerRadius)+0.5,Math.round(segment.y+cornerRadius)+0.5,Math.round(cornerRadius),-Math.PI/2.0,0,false);context.lineTo(Math.round(segment.x+segment.width)+0.5,Math.round(segment.y+segment.height-cornerRadius)+0.5);context.arc(Math.round(segment.x+segment.width-cornerRadius)+0.5,Math.round(segment.y+segment.height-cornerRadius)+0.5,Math.round(cornerRadius),0,Math.PI/2.0,false);context.lineTo(Math.round(segment.x+cornerRadius)+0.5,Math.round(segment.y+segment.height)+0.5);context.arc(Math.round(segment.x+cornerRadius)+0.5,Math.round(segment.y+segment.height-cornerRadius)+0.5,Math.round(cornerRadius),Math.PI/2.0,Math.PI,false);context.lineTo(Math.round(segment.x)+0.5,Math.round(segment.y+cornerRadius)+0.5);}break;case 2/*primitives.common.SegmentType.QuadraticArc*/:context.quadraticCurveTo(Math.round(segment.cpX)+0.5,Math.round(segment.cpY)+0.5,Math.round(segment.x)+0.5,Math.round(segment.y)+0.5);break;case 3/*primitives.common.SegmentType.CubicArc*/:context.bezierCurveTo(Math.round(segment.cpX1)+0.5,Math.round(segment.cpY1)+0.5,Math.round(segment.cpX2)+0.5,Math.round(segment.cpY2)+0.5,Math.round(segment.x)+0.5,Math.round(segment.y)+0.5);break;}});if(attr.opacity!=null){context.globalAlpha=attr.opacity;}if(attr.lineWidth!==undefined){context.stroke();}if(attr.fillColor!==undefined){context.fillStyle=attr.fillColor;context.fill();}context.restore();}};/* /graphics/Element.js*/primitives.common.Element=function(arg0,arg1){this.ns=null;this.name=null;this.attr={};this.style={};this.children=[];switch(arguments.length){case 1:this.name=arg0;break;case 2:this.ns=arg0;this.name=arg1;break;default:break;}};primitives.common.Element.prototype.setAttribute=function(key,value){this.attr[key]=value;};primitives.common.Element.prototype.appendChild=function(child){this.children[this.children.length]=child;};primitives.common.Element.prototype.create=function(ie8mode){var result=null,name,child,index;if(this.ns!==null){result=document.createElementNS(this.ns,this.name);}else{result=document.createElement(this.name);}for(name in this.attr){if(this.attr.hasOwnProperty(name)){if(ie8mode!==undefined){result[name]=this.attr[name];}else{result.setAttribute(name,this.attr[name]);}}}for(name in this.style){if(this.style.hasOwnProperty(name)){result.style[name]=this.style[name];}}for(index=0;index<this.children.length;index+=1){child=this.children[index];if(typeof child==="string"){result.appendChild(document.createTextNode(child));}else{result.appendChild(child.create(ie8mode));}}return result;};primitives.common.Element.prototype.update=function(target,ie8mode){var name,length,index,child,value;for(name in this.style){if(this.style.hasOwnProperty(name)){value=this.style[name];if(target.style[name]!==value){target.style[name]=value;}}}for(name in this.attr){if(this.attr.hasOwnProperty(name)){value=this.attr[name];if(ie8mode!==undefined){/* if you see exception here, it may be result of following situations:
						1. You moved chart from one DOM node to another manually, it invalidates VML graphics in IE6, IE7 modes
						so it is impossable to reuse VML items in DOM anymore. You have to update chart with Recreate option instead of refresh.
						2. You made changes in Polyline graphics primitive and added extra sub nodes to it, so number and type of children for shape
							have been changed, so sub nodes mismatch is a reason for this exception.
					*/if(target[name]!==value){target[name]=value;}}else{if(target.getAttribute(name)!==value){target.setAttribute(name,value);}}}}length=this.children.length;for(index=0;index<length;index+=1){child=this.children[index];if(typeof child==="string"){if(target.innerHtml!==child){target.innerHtml=child;}}else{this.children[index].update(target.children[index],ie8mode);}}};/* /graphics/Layer.js*/primitives.common.Layer=function(name){this.name=name;this.canvas=null;this.canvascanvas=null;this.svgcanvas=null;};/* /graphics/Placeholder.js*/primitives.common.Placeholder=function(name){this.name=name;this.layers={};this.activeLayer=null;this.size=null;this.rect=null;this.div=null;this.hasGraphics=true;};/* /graphics/SvgGraphics.js*/primitives.common.SvgGraphics=function(element){this.parent=primitives.common.Graphics.prototype;this.parent.constructor.apply(this,arguments);this._svgxmlns="http://www.w3.org/2000/svg";this.graphicsType=0/*primitives.common.GraphicsType.SVG*/;this.hasGraphics=true;};primitives.common.SvgGraphics.prototype=new primitives.common.Graphics();primitives.common.SvgGraphics.prototype.clean=function(){var key,placeholder,layerKey,layer;for(key in this.m_placeholders){if(this.m_placeholders.hasOwnProperty(key)){placeholder=this.m_placeholders[key];for(layerKey in placeholder.layers){if(placeholder.layers.hasOwnProperty(layerKey)){layer=placeholder.layers[layerKey];if(layer.svgcanvas!==null){layer.svgcanvas.remove();layer.svgcanvas=null;}}}}}this.parent.clean.apply(this,arguments);};primitives.common.SvgGraphics.prototype.resizePlaceholder=function(placeholder,width,height){var layerKey,layer,position;this.parent.resizePlaceholder.apply(this,arguments);for(layerKey in placeholder.layers){if(placeholder.layers.hasOwnProperty(layerKey)){layer=placeholder.layers[layerKey];if(layer.svgcanvas!==null){position={"position":"absolute","width":width+"px","height":height+"px"};layer.svgcanvas.css(position);layer.svgcanvas.attr({"viewBox":"0 0 "+width+" "+height});}}}};primitives.common.SvgGraphics.prototype._getCanvas=function(){var placeholder=this.m_activePlaceholder,layer=placeholder.activeLayer,panelSize=placeholder.rect;if(layer.svgcanvas===null){layer.svgcanvas=jQuery('<svg version = "1.1"></svg>');layer.svgcanvas.attr({"viewBox":panelSize.x+" "+panelSize.y+" "+panelSize.width+" "+panelSize.height});layer.svgcanvas.css({"width":panelSize.width+"px","height":panelSize.height+"px"});placeholder.activeLayer.canvas.prepend(layer.svgcanvas);}return layer.svgcanvas;};primitives.common.SvgGraphics.prototype.polyline=function(polylineData){var placeholder=this.m_activePlaceholder,polyline,data,attr=polylineData.paletteItem.toAttr(),element,svgcanvas,step,radius,cornerRadius;polyline=new primitives.common.Element(this._svgxmlns,"path");if(attr.fillColor!==undefined){polyline.setAttribute("fill",attr.fillColor);polyline.setAttribute("fill-opacity",attr.opacity);}else{polyline.setAttribute("fill-opacity",0);}if(attr.lineWidth!==undefined&&attr.borderColor!==undefined){polyline.setAttribute("stroke",attr.borderColor);polyline.setAttribute("stroke-width",attr.lineWidth);if(attr.opacity!==undefined){polyline.setAttribute("stroke-opacity",attr.opacity);}else{polyline.setAttribute("stroke-opacity",1);}}else{polyline.setAttribute("stroke","transparent");polyline.setAttribute("stroke-width",0);}if(attr.lineType!=null){step=Math.round(attr.lineWidth)||1;switch(attr.lineType){case 0/*primitives.common.LineType.Solid*/:polyline.setAttribute("stroke-dasharray","");break;case 1/*primitives.common.LineType.Dotted*/:polyline.setAttribute("stroke-dasharray",step+","+step);break;case 2/*primitives.common.LineType.Dashed*/:polyline.setAttribute("stroke-dasharray",step*5+","+step*3);break;}}data="";polylineData.loop(this,function(segment){switch(segment.segmentType){case 1/*primitives.common.SegmentType.Move*/:data+="M"+(Math.round(segment.x)+0.5)+" "+(Math.round(segment.y)+0.5);break;case 0/*primitives.common.SegmentType.Line*/:data+="L"+(Math.round(segment.x)+0.5)+" "+(Math.round(segment.y)+0.5);break;case 2/*primitives.common.SegmentType.QuadraticArc*/:data+="Q"+(Math.round(segment.cpX)+0.5)+" "+(Math.round(segment.cpY)+0.5)+" "+(Math.round(segment.x)+0.5)+" "+(Math.round(segment.y)+0.5);break;case 4/*primitives.common.SegmentType.Dot*/:// A rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y
	if(segment.width==segment.height&&segment.width/2.0<=segment.cornerRadius){// dot
	radius=segment.width/2.0;data+="M"+(Math.round(segment.x)+0.5)+" "+(Math.round(segment.y)+segment.height/2.0+0.5);data+="A"+radius+" "+radius+" 0 0 0 "+(Math.round(segment.x+segment.width)+0.5)+" "+(Math.round(segment.y)+segment.height/2.0+0.5);data+="A"+radius+" "+radius+" 0 0 0 "+(Math.round(segment.x)+0.5)+" "+(Math.round(segment.y)+segment.height/2.0+0.5);}else if(segment.cornerRadius===0){// square
	data+="M"+(Math.round(segment.x)+0.5)+" "+(Math.round(segment.y)+0.5);data+="L"+(Math.round(segment.x+segment.width)+0.5)+" "+(Math.round(segment.y)+0.5);data+="L"+(Math.round(segment.x+segment.width)+0.5)+" "+(Math.round(segment.y+segment.height)+0.5);data+="L"+(Math.round(segment.x)+0.5)+" "+(Math.round(segment.y+segment.height)+0.5);data+="L"+(Math.round(segment.x)+0.5)+" "+(Math.round(segment.y)+0.5);}else{cornerRadius=Math.min(segment.cornerRadius,Math.min(segment.width/2.0,segment.height/2.0));data+="M"+(Math.round(segment.x)+0.5)+" "+(Math.round(segment.y+cornerRadius)+0.5);data+="A"+Math.round(cornerRadius)+" "+Math.round(cornerRadius)+" 0 0 1 "+(Math.round(segment.x+cornerRadius)+0.5)+" "+(Math.round(segment.y)+0.5);data+="L"+(Math.round(segment.x+segment.width-cornerRadius)+0.5)+" "+(Math.round(segment.y)+0.5);data+="A"+Math.round(cornerRadius)+" "+Math.round(cornerRadius)+" 0 0 1 "+(Math.round(segment.x+segment.width)+0.5)+" "+(Math.round(segment.y+cornerRadius)+0.5);data+="L"+(Math.round(segment.x+segment.width)+0.5)+" "+(Math.round(segment.y+segment.height-cornerRadius)+0.5);data+="A"+Math.round(cornerRadius)+" "+Math.round(cornerRadius)+" 0 0 1 "+(Math.round(segment.x+segment.width-cornerRadius)+0.5)+" "+(Math.round(segment.y+segment.height)+0.5);data+="L"+(Math.round(segment.x+cornerRadius)+0.5)+" "+(Math.round(segment.y+segment.height)+0.5);data+="A"+Math.round(cornerRadius)+" "+Math.round(cornerRadius)+" 0 0 1 "+(Math.round(segment.x)+0.5)+" "+(Math.round(segment.y+segment.height-cornerRadius)+0.5);data+="L"+(Math.round(segment.x)+0.5)+" "+(Math.round(segment.y+cornerRadius)+0.5);}break;case 3/*primitives.common.SegmentType.CubicArc*/:data+="C"+(Math.round(segment.cpX1)+0.5)+" "+(Math.round(segment.cpY1)+0.5)+" "+(Math.round(segment.cpX2)+0.5)+" "+(Math.round(segment.cpY2)+0.5)+" "+(Math.round(segment.x)+0.5)+" "+(Math.round(segment.y)+0.5);break;}});polyline.setAttribute("d",data);element=this.m_cache.get(placeholder.name,placeholder.activeLayer.name,"path");if(element===null){element=jQuery(polyline.create());svgcanvas=this._getCanvas();svgcanvas.append(element);this.m_cache.put(placeholder.name,placeholder.activeLayer.name,"path",element);}else{polyline.update(element[0]);}};/* /graphics/Transform.js*/primitives.common.Transform=function(){this.invertArea=false;this.invertHorizontally=false;this.invertVertically=false;this.size=null;};primitives.common.Transform.prototype.setOrientation=function(orientationType){switch(orientationType){case 0/*primitives.common.OrientationType.Top*/:this.invertArea=false;this.invertHorizontally=false;this.invertVertically=false;break;case 1/*primitives.common.OrientationType.Bottom*/:this.invertArea=false;this.invertHorizontally=false;this.invertVertically=true;break;case 2/*primitives.common.OrientationType.Left*/:this.invertArea=true;this.invertHorizontally=false;this.invertVertically=false;break;case 3/*primitives.common.OrientationType.Right*/:this.invertArea=true;this.invertHorizontally=true;this.invertVertically=false;break;}};primitives.common.Transform.prototype.getOrientation=function(orientationType){var result=orientationType;if(this.invertHorizontally){switch(orientationType){case 2/*primitives.common.OrientationType.Left*/:result=3/*primitives.common.OrientationType.Right*/;break;case 3/*primitives.common.OrientationType.Right*/:result=2/*primitives.common.OrientationType.Left*/;break;}}if(this.invertVertically){switch(orientationType){case 0/*primitives.common.OrientationType.Top*/:result=1/*primitives.common.OrientationType.Bottom*/;break;case 1/*primitives.common.OrientationType.Bottom*/:result=0/*primitives.common.OrientationType.Top*/;break;}}if(this.invertArea){switch(result){case 0/*primitives.common.OrientationType.Top*/:result=2/*primitives.common.OrientationType.Left*/;break;case 1/*primitives.common.OrientationType.Bottom*/:result=3/*primitives.common.OrientationType.Right*/;break;case 2/*primitives.common.OrientationType.Left*/:result=0/*primitives.common.OrientationType.Top*/;break;case 3/*primitives.common.OrientationType.Right*/:result=1/*primitives.common.OrientationType.Bottom*/;break;}}return result;};primitives.common.Transform.prototype.transformPoint=function(x,y,forward,self,func){var value;if(forward){if(this.invertArea){value=x;x=y;y=value;}}if(this.invertHorizontally){x=this.size.width-x;}if(this.invertVertically){y=this.size.height-y;}if(!forward){if(this.invertArea){value=x;x=y;y=value;}}func.call(self,x,y);};primitives.common.Transform.prototype.transformPoints=function(x,y,x2,y2,forward,self,func){var value;if(forward){if(this.invertArea){value=x;x=y;y=value;value=x2;x2=y2;y2=value;}}if(this.invertHorizontally){x=this.size.width-x;x2=this.size.width-x2;}if(this.invertVertically){y=this.size.height-y;y2=this.size.height-y2;}if(!forward){if(this.invertArea){value=x;x=y;y=value;value=x2;x2=y2;y2=value;}}func.call(self,x,y,x2,y2);};primitives.common.Transform.prototype.transform3Points=function(x,y,x2,y2,x3,y3,forward,self,func){var value;if(forward){if(this.invertArea){value=x;x=y;y=value;value=x2;x2=y2;y2=value;value=x3;x3=y3;y3=value;}}if(this.invertHorizontally){x=this.size.width-x;x2=this.size.width-x2;x3=this.size.width-x3;}if(this.invertVertically){y=this.size.height-y;y2=this.size.height-y2;y3=this.size.height-y3;}if(!forward){if(this.invertArea){value=x;x=y;y=value;value=x2;x2=y2;y2=value;value=x3;x3=y3;y3=value;}}func.call(self,x,y,x2,y2,x3,y3);};primitives.common.Transform.prototype.transformRect=function(x,y,width,height,forward,self,func){var value;if(forward){if(this.invertArea){value=x;x=y;y=value;value=width;width=height;height=value;}}if(this.invertHorizontally){x=this.size.width-x-width;}if(this.invertVertically){y=this.size.height-y-height;}if(!forward){if(this.invertArea){value=x;x=y;y=value;value=width;width=height;height=value;}}func.call(self,x,y,width,height);};/* /graphics/VmlGraphics.js*/primitives.common.VmlGraphics=function(element){var vmlStyle,names,index;this.parent=primitives.common.Graphics.prototype;this.parent.constructor.apply(this,arguments);this.prefix="rvml";this.ie8mode=document.documentMode&&document.documentMode>=8;try{/*ignore jslint start*/eval('document.namespaces');/*ignore jslint end*/}catch(ex){}if(!document.namespaces[this.prefix]){document.namespaces.add(this.prefix,'urn:schemas-microsoft-com:vml');}if(!primitives.common.VmlGraphics.prototype.vmlStyle){vmlStyle=primitives.common.VmlGraphics.prototype.vmlStyle=document.createStyleSheet();names=[" *","fill","shape","path","textpath","stroke"];for(index=0;index<names.length;index+=1){vmlStyle.addRule(this.prefix+"\\:"+names[index],"behavior:url(#default#VML); position:absolute;");}}this.graphicsType=2/*primitives.common.GraphicsType.VML*/;this.hasGraphics=true;};primitives.common.VmlGraphics.prototype=new primitives.common.Graphics();primitives.common.VmlGraphics.prototype.text=function(x,y,width,height,label,orientation,horizontalAlignment,verticalAlignment,attr){var placeholder,rotateLeft,textRect,textRectCoordSize,line,path,lineHeight,textHeight,fromPoint,toPoint,textpath,element;switch(orientation){case 0/*primitives.text.TextOrientationType.Horizontal*/:case 3/*primitives.text.TextOrientationType.Auto*/:this.parent.text.call(this,x,y,width,height,label,orientation,horizontalAlignment,verticalAlignment,attr);break;default:placeholder=this.m_activePlaceholder;rotateLeft=orientation===1/*primitives.text.TextOrientationType.RotateLeft*/;textRect=new primitives.common.Rect(x,y,width,height);textRectCoordSize=new primitives.common.Rect(0,0,width*10,height*10);line=new primitives.common.Element(this.prefix+":shape");line.setAttribute("CoordSize",textRectCoordSize.width+","+textRectCoordSize.height);line.setAttribute("filled",true);line.setAttribute("stroked",false);line.setAttribute("fillcolor",attr["font-color"]);line.style.top=textRect.y+"px";line.style.left=textRect.x+"px";line.style.width=textRect.width+"px";line.style.height=textRect.height+"px";line.style['font-family']=attr['font-family'];path=new primitives.common.Element(this.prefix+":path");path.setAttribute("TextPathOk",true);lineHeight=10*Math.floor(this.getPxSize(attr['font-size']))*1.6/* ~ line height*/;textHeight=lineHeight*Math.max(label.split('\n').length-1,1);fromPoint=null;toPoint=null;if(rotateLeft){switch(verticalAlignment){case 0/*primitives.common.VerticalAlignmentType.Top*/:fromPoint=new primitives.common.Point(textRectCoordSize.x+textHeight/2.0,textRectCoordSize.bottom());toPoint=new primitives.common.Point(textRectCoordSize.x+textHeight/2.0,textRectCoordSize.y);break;case 1/*primitives.common.VerticalAlignmentType.Middle*/:fromPoint=new primitives.common.Point(textRectCoordSize.horizontalCenter(),textRectCoordSize.bottom());toPoint=new primitives.common.Point(textRectCoordSize.horizontalCenter(),textRectCoordSize.y);break;case 2/*primitives.common.VerticalAlignmentType.Bottom*/:fromPoint=new primitives.common.Point(textRectCoordSize.right()-textHeight/2.0,textRectCoordSize.bottom());toPoint=new primitives.common.Point(textRectCoordSize.right()-textHeight/2.0,textRectCoordSize.y);break;}}else{switch(verticalAlignment){case 0/*primitives.common.VerticalAlignmentType.Top*/:fromPoint=new primitives.common.Point(textRectCoordSize.right()-textHeight/2.0,textRectCoordSize.y);toPoint=new primitives.common.Point(textRectCoordSize.right()-textHeight/2.0,textRectCoordSize.bottom());break;case 1/*primitives.common.VerticalAlignmentType.Middle*/:fromPoint=new primitives.common.Point(textRectCoordSize.horizontalCenter(),textRectCoordSize.y);toPoint=new primitives.common.Point(textRectCoordSize.horizontalCenter(),textRectCoordSize.bottom());break;case 2/*primitives.common.VerticalAlignmentType.Bottom*/:fromPoint=new primitives.common.Point(textRectCoordSize.x+textHeight/2.0,textRectCoordSize.y);toPoint=new primitives.common.Point(textRectCoordSize.x+textHeight/2.0,textRectCoordSize.bottom());break;}}path.setAttribute("v"," m"+fromPoint.x+","+fromPoint.y+" l"+toPoint.x+","+toPoint.y+" e");textpath=new primitives.common.Element(this.prefix+":textpath");textpath.setAttribute("on",true);textpath.setAttribute("string",label);textpath.style.trim=false;textpath.style['v-text-align']=this._getTextAlign(horizontalAlignment);textpath.style['font']="normal normal normal "+attr['font-size']+"pt "+attr['font-family'];//ignore jslint
	line.appendChild(path);line.appendChild(textpath);element=this.m_cache.get(placeholder.name,placeholder.activeLayer.name,"vmltext");if(element===null){element=jQuery(line.create(this.ie8mode));placeholder.activeLayer.canvas.append(element);this.m_cache.put(placeholder.name,placeholder.activeLayer.name,"vmltext",element);}else{line.update(element[0],this.ie8mode);}break;}};primitives.common.VmlGraphics.prototype.polyline=function(polylineData){var placeholder=this.m_activePlaceholder,rect=new primitives.common.Rect(placeholder.rect),rectCoordSize=new primitives.common.Rect(0,0,rect.width*10,rect.height*10),shape=new primitives.common.Element(this.prefix+":shape"),data,path,stroke,fill,element,x,y,x2,y2,value,signature,attr=polylineData.paletteItem.toAttr();if(attr.borderColor!==undefined&&attr.lineWidth!==undefined){shape.setAttribute("strokecolor",attr.borderColor);shape.setAttribute("strokeweight",attr.lineWidth);shape.setAttribute("stroked",true);}else{shape.setAttribute("stroked",false);}shape.setAttribute("CoordSize",rectCoordSize.width+","+rectCoordSize.height);shape.style.top=rect.y+"px";shape.style.left=rect.x+"px";shape.style.width=rect.width+"px";shape.style.height=rect.height+"px";data="";polylineData.loop(this,function(segment){switch(segment.segmentType){case 1/*primitives.common.SegmentType.Move*/:data+=" m"+10*Math.round(segment.x)+","+10*Math.round(segment.y);break;case 0/*primitives.common.SegmentType.Line*/:data+=" l"+10*Math.round(segment.x)+","+10*Math.round(segment.y);break;case 4/*primitives.common.SegmentType.Dot*/:x=Math.round(segment.x);y=Math.round(segment.y);x2=Math.round(segment.x+segment.width);y2=Math.round(segment.y+segment.height);if(x>x2){value=x;x=x2;x2=value;}if(y>y2){value=y;y=y2;y2=value;}x=10*x+5;y=10*y+5;x2=10*x2-5;y2=10*y2-5;data+=" m"+x+","+y;data+=" l"+x2+","+y;data+=" l"+x2+","+y2;data+=" l"+x+","+y2;data+=" l"+x+","+y;break;case 2/*primitives.common.SegmentType.QuadraticArc*/:data+=" qb"+10*Math.round(segment.cpX)+","+10*Math.round(segment.cpY)+" l"+10*Math.round(segment.x)+","+10*Math.round(segment.y);break;case 3/*primitives.common.SegmentType.CubicArc*/:data+=" c"+10*Math.round(segment.cpX1)+","+10*Math.round(segment.cpY1)+","+10*Math.round(segment.cpX2)+","+10*Math.round(segment.cpY2)+","+10*Math.round(segment.x)+","+10*Math.round(segment.y);//ignore jslint
	break;}});data+=" e";signature="shapepath";path=new primitives.common.Element(this.prefix+":path");path.setAttribute("v",data);shape.appendChild(path);if(attr.lineType!=null){stroke=new primitives.common.Element(this.prefix+":stroke");switch(attr.lineType){case 0/*primitives.common.LineType.Solid*/:stroke.setAttribute("dashstyle","Solid");break;case 1/*primitives.common.LineType.Dotted*/:stroke.setAttribute("dashstyle","ShortDot");break;case 2/*primitives.common.LineType.Dashed*/:stroke.setAttribute("dashstyle","Dash");break;}shape.appendChild(stroke);signature+="stroke";}if(attr.fillColor!==null){shape.setAttribute("filled",true);fill=new primitives.common.Element(this.prefix+":fill");fill.setAttribute("opacity",attr.opacity);fill.setAttribute("color",attr.fillColor);shape.appendChild(fill);signature+="fill";}else{shape.setAttribute("filled",false);}element=this.m_cache.get(placeholder.name,placeholder.activeLayer.name,signature);if(element===null){element=jQuery(shape.create(this.ie8mode));placeholder.activeLayer.canvas.append(element);this.m_cache.put(placeholder.name,placeholder.activeLayer.name,signature,element);}else{shape.update(element[0],this.ie8mode);}};/* /OptionsReaders/ArrayReader.js*/primitives.common.ArrayReader=function(itemTemplate,containsUniqueItems,uniquePropertyKey,createSourceHash,isOrdered){this.itemTemplate=itemTemplate;this.containsUniqueItems=containsUniqueItems;this.uniquePropertyKey=uniquePropertyKey;this.containsPrimitiveValues=primitives.common.isNullOrEmpty(uniquePropertyKey);this.createSourceHash=createSourceHash;this.isOrdered=isOrdered;};primitives.common.ArrayReader.prototype.read=function(target,source,path,context){var result=[],resultHash={},hash,sequence,resultSequence={},sourceHash={},item,itemid,index,len,newHashObject,sequencePath=path+"-seq";/* validate source array */if(!source||!primitives.common.isArray(source)){source=[];}/* hash values for tracking changes */hash=context.hash[path]||{};sequence=context.hash[sequencePath]||{};for(index=0,len=source.length;index<len;index+=1){item=source[index];itemid=this.containsUniqueItems?this.containsPrimitiveValues?item:item[this.uniquePropertyKey]:index;if(!resultHash.hasOwnProperty(itemid)){newHashObject=this.itemTemplate.read(hash[itemid]||{},item,path+"-"+index,context);result.push(newHashObject);resultHash[itemid]=newHashObject;resultSequence[index]=itemid;if(this.createSourceHash){sourceHash[itemid]=item;}if(this.isOrdered){if(sequence[index]!=resultSequence[index]){context.isChanged=true;}}}}context.hash[path]=resultHash;context.hash[sequencePath]=resultSequence;if(this.createSourceHash){context.sourceHash[path]=sourceHash;}if(target==null||target.length!=result.length){context.isChanged=true;}return result;};/* /OptionsReaders/EnumerationReader.js*/primitives.common.EnumerationReader=function(enumeration,isNullable,defaultValue){this.enumeration=enumeration;this.isNullable=isNullable;this.defaultValue=defaultValue;this.hash={};/* collect valid enumeration values */for(var key in enumeration){this.hash[enumeration[key]]=key;}};primitives.common.EnumerationReader.prototype.read=function(target,source,path,context){var result=null;if(source===null||typeof source=="undefined"||!this.hash.hasOwnProperty(source)){source=this.isNullable?null:this.defaultValue;}result=source;if(target!==source){context.isChanged=true;}return result;};/* /OptionsReaders/FunctionReader.js*/primitives.common.FunctionReader=function(){};primitives.common.FunctionReader.prototype.read=function(target,source,path,context){var result=null;result=typeof source=="function"?source:null;return result;};/* /OptionsReaders/ObjectReader.js*/primitives.common.ObjectReader=function(dataTemplate,isNullable,defaultValue){this.dataTemplate=dataTemplate;this.isNullable=isNullable;this.defaultValue=defaultValue;};primitives.common.ObjectReader.prototype.read=function(target,source,path,context){var result=null,property,propertyDataTemplate;if(!source){source=this.isNullable?null:this.defaultValue;}if(primitives.common.isObject(source)){result={};for(property in this.dataTemplate){if(this.dataTemplate.hasOwnProperty(property)){propertyDataTemplate=this.dataTemplate[property];result[property]=propertyDataTemplate.read(primitives.common.isObject(target)?target[property]:null,source[property],path+"-"+property,context);}}}else{result=source;if(target!==source){context.isChanged=true;}}return result;};/* /OptionsReaders/ValueReader.js*/primitives.common.ValueReader=function(acceptedTypes,isNullable,defaultValue){this.acceptedTypes=acceptedTypes;this.isNullable=isNullable;this.defaultValue=defaultValue;this.hash={};/* collect valid enumeration values */for(var index=0;index<acceptedTypes.length;index+=1){var acceptedType=acceptedTypes[index];this.hash[acceptedType]=true;}};primitives.common.ValueReader.prototype.read=function(target,source,path,context){var result=null;if(source===null||typeof source=="undefined"||!this.hash.hasOwnProperty(typeof source==='undefined'?'undefined':_typeof(source))){source=this.isNullable?null:this.defaultValue;}result=source;if(target!==source){context.isChanged=true;}return result;};/* /Controls/FamDiagram/events/EventArgs.js*//*
		Class: primitives.famdiagram.EventArgs
			Event details class.
	*/primitives.famdiagram.EventArgs=function(){/*
		Property: oldContext
			Reference to associated previous item in hierarchy.
		*/this.oldContext=null;/*
		Property: context
			Reference to associated new item in hierarchy.
		*/this.context=null;/*
		Property: parentItems
			Collection of immidiate parent items of item in context.
		*/this.parentItems=[];/*
		Property: childrenItems
			Collection of immidiate children items of item in context.
		*/this.childrenItems=[];/*
		Property: position
			Absolute item position on diagram.
	
		See also:
			<primitives.common.Rect>
		*/this.position=null;/*
		Property: name
			Relative object name.
	
		*/this.name=null;/*
		Property: cancel
			Allows cancelation of coupled event processing. This option allows to cancel layout update
			and subsequent <primitives.famdiagram.Config.onCursorChanged> event
			in handler of <primitives.famdiagram.Config.onCursorChanging> event.
		*/this.cancel=false;};/* /Controls/FamDiagram/configs/TemplateConfig.js*//*
		Class: primitives.famdiagram.TemplateConfig
			User defines item template class. It may optionaly define template for item,
			custom cursor and highlight. If template is null then default template is used.
	
		See Also:
			<primitives.famdiagram.Config.templates>
	*/primitives.famdiagram.TemplateConfig=function(){/*
		Property: name
			Every template should have unique name. It is used as reference when
			custom template is defined in <primitives.famdiagram.ItemConfig.templateName>.
		*/this.name=null;/*
		Property: isActive
			If it is true then item having this template is selectable in hierarchy and it has mouse over highlight.
	
		True - Item is clickable.
		False - Item is inactive and user cannot set cursor item or highlight.
	
		Default:
			true
		*/this.isActive=true;/*
		Property: itemSize
		This is item size of type <primitives.common.Size>, templates should have
		fixed size, so famDiagram uses this value in order to layout items properly.
		*/this.itemSize=new primitives.common.Size(120,100);/*
		Property: itemBorderWidth
			Item template border width.
		*/this.itemBorderWidth=1;/*
		Property: itemTemplate
		Item template, if it is null then default item template is used. It supposed
		to be div html element containing named elements inside for setting them
		in <primitives.famdiagram.Config.onItemRender> event.
		*/this.itemTemplate=null;/*
			Property: minimizedItemShapeType
				Defines minimized item shape. The border line width is set with <primitives.famdiagram.TemplateConfig.minimizedItemBorderWidth>
				By default minimized item is rounded rectangle filled with item title color.
	
	
			See also:
				<primitives.famdiagram.TemplateConfig.minimizedItemCornerRadius>
				<primitives.famdiagram.ItemConfig.itemTitleColor>
				<primitives.famdiagram.ItemConfig.minimizedItemShapeType>
	
			Default:
				null
		*/this.minimizedItemShapeType=null;/*
		Property: minimizedItemSize
		This is size dot used to display item in minimized form, type of <primitives.common.Size>.
		*/this.minimizedItemSize=new primitives.common.Size(4,4);/*
		Property: minimizedItemCornerRadius
		Set corner radias for dots in order to display them as squares having rounded corners.
		By default it is null and dots displayed as cycles. If corner radius set to 0 then they are displayed as regular squares.
		*/this.minimizedItemCornerRadius=null;/*
		Property: minimizedItemLineWidth
			Minimized item shape border width.
		*/this.minimizedItemLineWidth=1;/*
		Property: minimizedItemBorderColor
			Minimized item line color. By default it is the same as <primitives.famdiagram.ItemConfig.itemTitleColor>
		*/this.minimizedItemBorderColor=null;/*
		Property: minimizedItemLineType
			Minimized item shape border line type.
		*/this.minimizedItemLineType=0/*primitives.common.LineType.Solid*/;/*
		Property: minimizedItemFillColor
			Minimized item fill color. By default it is the same as <primitives.famdiagram.ItemConfig.itemTitleColor>
		*/this.minimizedItemFillColor=null;/*
		Property: minimizedItemOpacity
			Minimized item fill color opacity.
		*/this.minimizedItemOpacity=1;/*
		Property: highlightPadding
		This padding around item defines relative size of highlight object,
		ts type is <primitives.common.Thickness>.
		*/this.highlightPadding=new primitives.common.Thickness(2,2,2,2);/*
		Property: highlightBorderWidth
			Highlight border width.
		*/this.highlightBorderWidth=1;/*
		Property: highlightTemplate
		Highlight template, if it is null then default highlight template is used.
		It supposed to be div html element containing named elements inside for
		setting them in <primitives.famdiagram.Config.onHighlightRender> event.
		*/this.highlightTemplate=null;/*
		Property: cursorPadding
		This padding around item defines relative size of cursor object,
		its type is <primitives.common.Thickness>.
		*/this.cursorPadding=new primitives.common.Thickness(3,3,3,3);/*
		Property: cursorBorderWidth
			Cursor border width.
		*/this.cursorBorderWidth=2;/*
		Property: cursorTemplate
		Cursor template, if it is null then default cursor template is used.
		It supposed to be div html element containing named elements inside
		for setting them in <primitives.famdiagram.Config.onCursorRender> event.
		*/this.cursorTemplate=null;/*
		Property: buttons
			Custom user buttons displayed on right side of item. This collection provides simple way to define context buttons for every template.
	
		See also:
			<primitives.famdiagram.ButtonConfig>
		*/this.buttons=null;};/* /Controls/FamDiagram/configs/BackgroundAnnotationConfig.js*//*
		Class: primitives.famdiagram.BackgroundAnnotationConfig
			Options class. Populate annotation collection with instances of this object to draw background area around items.
			Shape is drawn as eclosed area with perimiter line around. If items cannot share one annotation then it draws as many areas as needed to show backgorund for every item.
			It does not overlap neighboring items. If line width is set then it draws perimiter line as well.
		See Also:
			<primitives.famdiagram.Config.annotations>
	*/primitives.famdiagram.BackgroundAnnotationConfig=function(arg0){var property;/*
		Property: annotationType
			Annotation type. All various annotations are defined in annotation collection property of <primitives.famdiagram.Config>.
			So this property is needed to define annotation type when we use JavaScript non-prototype objects.
			See other annotations as well.
	
		Default:
			<primitives.common.AnnotationType.Background>
	
		See Also:
			<primitives.famdiagram.Config.annotations>
			<primitives.famdiagram.ConnectorAnnotationConfig>
			<primitives.famdiagram.ShapeAnnotationConfig>
			<primitives.famdiagram.LabelAnnotationConfig>
			<primitives.famdiagram.HighlightPathAnnotationConfig>
		*/this.annotationType=4/*primitives.common.AnnotationType.Background*/;/*
		Property: items
			Array of items ids in hierarchy.
		See Also:
			<primitives.orgdiagram.ItemConfig.id>
		*/this.items=[];/*
		Property: zOrderType
			Defines annotation Z order placement relative to chart items. Chart items are drawn in layers on top of each other. We can draw annotations under the items or over them.
			If you place annotations over items then you block mouse events of UI elements in them. Browsers don't support mouse events transparentcy consistently.
			So in order to avoid mouse events blocking of UI elements in item templates you have to place annotation items under them.
			Take into account that chart default buttons are drawn on top of everyhting, so they are never blocked by annotations drawn over items.
	
		Default:
			<primitives.common.ZOrderType.Auto>
		*/this.zOrderType=0/*primitives.common.ZOrderType.Auto*/;/*
		Property: lineWidth
			Border line width.
		*/this.lineWidth=2;/*
		Property: opacity
			Background color opacity. For applicable shapes only.
		*/this.opacity=1;/*
		Property: borderColor
			Shape border line color.
	
		Default:
			null
		*/this.borderColor=null;/*
		Property: fillColor
			Fill Color.
	
		Default:
			null
		*/this.fillColor=null;/*
		Property: lineType
			Connector's line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.lineType=0/*primitives.common.LineType.Solid*/;/*
		Property: selectItems
			Always show annotated items in normal state. Setting this option is equivalent to adding annotated items to collection of selected items.
	
		Default:
			true
	
		See Also:
			<primitives.famdiagram.Config.selectedItems>
		*/this.selectItems=false;switch(arguments.length){case 1:if(arg0!==null){if(arg0 instanceof Array){this.items=arg0;}else if((typeof arg0==='undefined'?'undefined':_typeof(arg0))=="object"){for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}}}break;}};/* /Controls/FamDiagram/configs/ButtonConfig.js*//*
		Class: primitives.famdiagram.ButtonConfig
			Options class. Custom user button options class.
			Buttons displayed on the right side of items.
			See jQuery UI Button options description for details.
			In order to receive button click event make binding
			to <primitives.famdiagram.Config.onButtonClick>.
	
		See Also:
			<primitives.famdiagram.Config.buttons>
	*/primitives.famdiagram.ButtonConfig=function(name,icon,tooltip){/*
		Property: name
			It should be unique string name of the button.
			It is needed to distinguish click events from different butons.
		*/this.name=name;/*
		Property: icon
		Name of icon used in jQuery UI.
		*/this.icon=icon;/*
		Property: text
		Whether to show any text -when set to false (display no text),
		icon must be enabled, otherwise it'll be ignored.
		*/this.text=false;/*
		Property: label
		Text to show on the button.
		*/this.label=null;/*
		Property: tooltip
		Button tooltip content. Tooltip is based on jQuery UI tooltip widget, so it should be part of jQuery UI distribution in order to make this property work.
		*/this.tooltip=tooltip;/*
		Property: size
		Size of the button of type <primitives.common.Size>.
		*/this.size=new primitives.common.Size(16,16);};/* /Controls/FamDiagram/configs/Config.js*//*
		Class: primitives.famdiagram.Config
			jQuery famDiagram Widget options class. Multi-parent hierarchical chart configuration.
	
	*/primitives.famdiagram.Config=function(name){this.name=name!==undefined?name:"FamDiagram";this.classPrefix="famdiagram";/*
			Property: navigationMode
				Defines control navigation mode. By default control replicates interactivity of regular Tree control.
				It has highlight for mouse over feedback and it has cursor for showing currently selected single node in diagram.
				In order to avoid creation of plus/minus buttons for children nodes folding and unfolding,
				this functionality is done automatically for current cursor item. This is especially true for family diagram,
				because it has no logical root, so cursor plays vital role for unfolding of nodes
				and zooming into area of user interest in diagram.
				Use this option to disable highlight which does not make sense on touch devices or make control inactive completly.
	
			See Also:
				<primitives.common.NavigationMode>
			Default:
				<primitives.common.NavigationMode.Default>
		*/this.navigationMode=0/*primitives.common.NavigationMode.Default*/;/*
			Property: graphicsType
				Preferable graphics type. If preferred graphics type
				is not supported widget switches to first available.
	
			Default:
				<primitives.common.GraphicsType.SVG>
		*/this.graphicsType=0/*primitives.common.GraphicsType.SVG*/;/*
			Property: pageFitMode
				Defines the way diagram is fit into page. By default chart minimize items when it has not enough space to fit all of them into screen.
				Chart has its maximum size when all items shown in full size and  its minimal size when all items shown as dots.
				It is equivalent of full zoom out of the chart items, dot size items are not readable, but such presentation of them
				gives possibility to overview chart layout. So chart tryes to combine both presenation modes and keep chart as small
				as possible in order to give user possibility to see big picture. Collapsed items provide ideal way for analitical reiew of
				diagram. If chart shown in its maximum size when all items are unfolded, it becomes impossible
				to navigate betwen parents close to the root item. In such mode chart is usable only at bottom levels when children are close to their parents.
				If we try to navigate up to the root of hierarchy, gaps between parents sometimes as big as screen size. So in order to solve these
				issues chart partially collapses hierarchy into dots and lines depending on this option.
	
			See also:
				<primitives.famdiagram.Config.minimalVisibility>
				<primitives.famdiagram.Config.printPreviewPageSize>
	
			Default:
				<primitives.common.PageFitMode.FitToPage>
		*/this.pageFitMode=3/*primitives.common.PageFitMode.FitToPage*/;/*
			Property: minimalVisibility
				Defines minimal allowed item form size for page fit mode. See description for pageFitMode.
	
			See also:
				<primitives.famdiagram.Config.pageFitMode>
	
			Default:
				<primitives.common.Visibility.Dot>
		*/this.minimalVisibility=2/*primitives.common.Visibility.Dot*/;/*
			Property: orientationType
				Chart orientation. Chart can be rotated left, right and bottom.
				Rotation to the right side is equivalent to left side placement
				in countries writing from right to left, so it is important for localization.
	
			Default:
				<primitives.common.OrientationType.Top>
		*/this.orientationType=0/*primitives.common.OrientationType.Top*/;/*
		Property: verticalAlignment
			Defines items vertical alignment relative to each other within one level of hierarchy.
			It does not affect levels having same size items.
	
		Default:
			<primitives.common.VerticalAlignmentType.Middle>
		*/this.verticalAlignment=1/*primitives.common.VerticalAlignmentType.Middle*/;/*
			Property: arrowsDirection
				Sets direction of connector lines arrows.
	
			Default:
				<primitives.common.GroupByType.None>
		*/this.arrowsDirection=0/*primitives.common.GroupByType.None*/;/*
		Property: showExtraArrows
			Show extra horizontal arrows on top of connectors for easy navigation between parents and children through connector lines.
			This options if off by default for organizational diagram.
	
		Default:
			false
		*/this.showExtraArrows=true;/*
		Property: extraArrowsMinimumSpace
			If diagram is small relations between objects are easy to trace, so mutual positions of parents and children are enough to navigate from parent to children and backward.
			If diagram is large and one row of children exceeds screen width then it use this option to activate horizontal arrows for large intervals between items.
	
		Default:
			30
		*/this.extraArrowsMinimumSpace=30;/*
			Property: groupByType
				Defines the way item gravitates to parent or child layout having big vertical gap between levels.
	
			Default:
				<primitives.common.GroupByType.Children>
		*/this.groupByType=2/*primitives.common.GroupByType.Children*/;/*
		Property: alignBylevels
			This option keeps items at the same levels after connections bundling.
	
		Default:
			true
		*/this.alignBylevels=true;/*
			Property: elbowType
				Style squared connectors with custom elbows.
	
			Default:
				<primitives.common.ElbowType.None>
		*/this.elbowType=3/*primitives.common.ElbowType.Round*/;/*
			Property: bevelSize
				Size of connector bevel.
	
			Default:
				4
		*/this.bevelSize=4;/*
			Property: elbowDotSize
				Size of elbow dot.
	
			Default:
				4
		*/this.elbowDotSize=4;/*
		Property: emptyDiagramMessage
			Empty message in order to avoid blank screen. This option is supposed to say user that chart is empty when no data inside.
		*/this.emptyDiagramMessage="Diagram is empty.";/*
		Property: items
			This is chart items collection. It is regular array of items of type ItemConfig. Items reference each other via parents collection property.
			So every item may have multiple parents in chart. If parents collection is empty or set to null then item supposed to be root parent.
			If items loop each other they are ignored as well. It is applications responsiblity to avoid such issues.
	
		See Also:
			<primitives.famdiagram.ItemConfig>
			<primitives.famdiagram.ItemConfig.id>
			<primitives.famdiagram.ItemConfig.parents>
		*/this.items=[];/*
		Property: annotations
			Defines array of annotaions objects. Chart supports several types of annotations. They are drawn on top of chart and they may block view of some of them.
			So chart's layout mechanism does not account available annotations. Don't over use this feature.
			The design assumes only few of them being displayed simultanuosly. This is especially true for connectors.
	
		See also:
			<primitives.famdiagram.ConnectorAnnotationConfig>
			<primitives.famdiagram.ShapeAnnotationConfig>
			<primitives.famdiagram.LabelAnnotationConfig>
			<primitives.famdiagram.BackgroundAnnotationConfig>
			<primitives.famdiagram.HighlightPathAnnotationConfig>
		*/this.annotations=[];/*
		Property: cursorItem
			Cursor item id - it is single item selection mode, user selects new cursor item on mouse click.
			Cursor defines current local zoom placement or in other words current navigation item in the chart,
			all items relative to cursor always shoun in full size. So user can see all possible items around cursor in full size
			and can continue navigation around chart. So when user navigates from one item to another clicking on thems and changing cursor item
			in chart, chart minimizes items going out of cursor scope and shows in full size items relative to new cursor position.
			If it is null then no cursor shown on diagram.
	
		See Also:
			<primitives.famdiagram.ItemConfig.id>
			<primitives.famdiagram.Config.onCursorChanging>
			<primitives.famdiagram.Config.onCursorChanged>
		*/this.cursorItem=null;/*
		Property: highlightItem
			Highlighted item id. Highlight is mouse over affect, but using this option applicatin can set highlight at any item
			in the chart programmatically. It can be used for chart syncronization with other controls on UI having mouse over effect.
			See primitives.famdiagram.Config.update method arguments description for fast chart update.
			If it is null then no highlight shown on diagram.
	
		See Also:
			<primitives.famdiagram.ItemConfig.id>
			<primitives.famdiagram.Config.onHighlightChanging>
			<primitives.famdiagram.Config.onHighlightChanged>
		*/this.highlightItem=null;/*
		Property: highlightGravityRadius
			The normal item has mouse over feedback in form of highlight border only when mouse pointer is inside of its boundaries.
			When items is minimized its marker can be so small that it is going to be difficult for end user to place mouse pointer inside of it.
			This option defines highlight gravity radius, so minimized item gets highlighted when mouse pointer does not overlap marker but it is within gravity radius of its boundaries.
			This property is ignored when nearest item is outside of screen boundaries and not visible to end user.
		*/this.highlightGravityRadius=40;/*
		Property: selectedItems
			Defines array of selected item ids. Chart allows to select items via checking checkboxes under items. Checkboxes are
			shown only for full size items. So when item is selected it is always shown in full size, so check box always visible for selcted items.
			User can navigate around large diagram and check intrested items in order to keep them opened. So that way chart provides
			means to show several items on large diagram and fit everything into minimal space ideally into available screen space.
			Application can select items programmatically using this array or receive notifications from chart about user selections with following events.
	
		See Also:
			<primitives.famdiagram.ItemConfig.id>
			<primitives.famdiagram.Config.onSelectionChanging>
			<primitives.famdiagram.Config.onSelectionChanged>
		*/this.selectedItems=[];/*
		Property: hasSelectorCheckbox
			This option controls selection check boxes visibility.
	
		Auto - Checkbox shown only for current cursor item only.
		True - Every full size item has selection check box.
		False - No check boxes. Application can still programmatically select some items in the chart.
		Application may provide custom item template having checkbox inside of item. If application defined check box inside of item template has name="checkbox"
		it is auto used as default selection check box.
	
		Default:
			<primitives.common.Enabled.Auto>
	
		See Also:
			<primitives.famdiagram.ItemConfig.hasSelectorCheckbox>
			<primitives.famdiagram.Config.onSelectionChanging>
			<primitives.famdiagram.Config.onSelectionChanged>
		*/this.hasSelectorCheckbox=0/*primitives.common.Enabled.Auto*/;/*
			Property: selectCheckBoxLabel
				Select check box label.
		*/this.selectCheckBoxLabel="Selected";/*
		Property: selectionPathMode
			Defines the way items between root item and selectedItems displayed in diagram. Chart always shows all items between cursor item and its root in full size.
			But if cursor positioned on root item, then chart shows in full size only selected items in the chart. So this option controls items size between
			selected items and root item of the chart. By default all items betwen root and selected items shown in full size.
	
		Default:
			<primitives.common.SelectionPathMode.FullStack>
		*/this.selectionPathMode=0/*primitives.common.SelectionPathMode.None*/;/*
		Property: neighboursSelectionMode
			Defines the display mode for items related to current cursor item in diagram. By default only parents and children are shown in regular size without minimization.
	
		Default:
			<primitives.common.NeighboursSelectionMode.ParentsAndChildren>
		*/this.neighboursSelectionMode=0/*primitives.common.NeighboursSelectionMode.ParentsAndChildren*/;/*
		Property: templates
			Custom user templates collection. TemplateConfig is complex object providing options to customize item's content template,
			cursor tempate and highlight template. Every template config should have unique name property, which is used by chart and its item configs
			to reference them. Chart's defaultTemplateName allows to make template default for all items in the chart. On other hand user may define templates
			to individual items in the chart by templateName property of item config.
	
		See also:
			<primitives.famdiagram.TemplateConfig>
			<primitives.famdiagram.Config.defaultTemplateName>
			<primitives.famdiagram.ItemConfig.templateName>
		*/this.templates=[];/*
			Property: defaultTemplateName
				This is template name used to render items having no <primitives.famdiagram.ItemConfig.templateName> defined.
	
	
			See Also:
				<primitives.famdiagram.TemplateConfig>
				<primitives.famdiagram.TemplateConfig.name>
				<primitives.famdiagram.Config.templates>
		*/this.defaultTemplateName=null;/*
			Property: defaultLabelAnnotationTemplate
				This is name of template used to render label annotations having no <primitives.famdiagram.LabelAnnotationConfig.templateName> defined.
				Label annotations are labels placed inside diagram layout. They occupy space and digram gurantees no overlapping of them.
	
			See Also:
				<primitives.famdiagram.LabelAnnotationConfig>
				<primitives.famdiagram.TemplateConfig>
				<primitives.famdiagram.TemplateConfig.name>
				<primitives.famdiagram.Config.templates>
		*/this.defaultLabelAnnotationTemplate=null;/*
		Property: hasButtons
			This option controls user buttons visibility.
	
		Auto - Buttons visible only for cursor item.
		True - Every normal item has buttons visible.
		False - No buttons.
	
		Default:
			<primitives.common.Enabled.Auto>
		*/this.hasButtons=0/*primitives.common.Enabled.Auto*/;/*
		Property: buttons
			Custom user buttons displayed on right side of item. This collection provides simple way to define context buttons for every item.
			The only limitation, they are all the same. So if you need to have unique buttons for every item, then you have to
			customize cursor templates and manually create custom buttons inside of them.
	
		See also:
			<primitives.famdiagram.ButtonConfig>
		*/this.buttons=[];/*
		Event: onHighlightChanging
			Notifies about changing highlight item <primitives.famdiagram.Config.highlightItem> in diagram.
			This coupled event with <primitives.famdiagram.Config.onHighlightChanged>, it is fired before highlight update.
	
		See also:
			<primitives.famdiagram.EventArgs>
		*/this.onHighlightChanging=null;/*
		Event: onHighlightChanged
			Notifies about changed highlight item <primitives.famdiagram.Config.highlightItem> in diagram.
	
		See also:
			<primitives.famdiagram.EventArgs>
		*/this.onHighlightChanged=null;/*
		Event: onCursorChanging
			Notifies about changing cursor item <primitives.famdiagram.Config.cursorItem> in diagram.
			This coupled event with <primitives.famdiagram.Config.onCursorChanged>, it is fired before layout update.
	
		See also:
			<primitives.famdiagram.EventArgs>
		*/this.onCursorChanging=null;/*
		Event: onCursorChanged
			Notifies about changed cursor item <primitives.famdiagram.Config.cursorItem> in diagram .
	
		See also:
			<primitives.famdiagram.EventArgs>
		*/this.onCursorChanged=null;/*
		Event: onSelectionChanging
			Notifies about changing selected items collection of <primitives.famdiagram.Config.selectedItems>.
	
		See also:
			<primitives.famdiagram.EventArgs>
		*/this.onSelectionChanging=null;/*
		Event: onSelectionChanged
			Notifies about changes in collection of <primitives.famdiagram.Config.selectedItems>.
	
		See also:
			<primitives.famdiagram.EventArgs>
		*/this.onSelectionChanged=null;/*
		Event: onButtonClick
			Notifies about click of custom user button defined in colelction of <primitives.famdiagram.Config.buttons>.
	
		See also:
			<primitives.famdiagram.EventArgs>
		*/this.onButtonClick=null;/*
		Event: onMouseClick
			On mouse click event.
	
		See also:
			<primitives.famdiagram.EventArgs>
		*/this.onMouseClick=null;/*
		Event: onMouseDblClick
			On mouse double click event.
	
		See also:
			<primitives.famdiagram.EventArgs>
		*/this.onMouseDblClick=null;/*
		Event: onItemRender
			Item templates don't provide means to bind data of items into templates. So this event handler gives application such possibility.
			If application uses custom templates then this method is called to populate template with items properties.
	
		See also:
			<primitives.common.RenderEventArgs>
			<primitives.famdiagram.TemplateConfig>
			<primitives.famdiagram.Config.templates>
		*/this.onItemRender=null;/*
		Event: onHighlightRender
			If user defined custom highlight template for item template
			then this method is called to populate it with context data.
	
		See also:
			<primitives.common.RenderEventArgs>
			<primitives.famdiagram.TemplateConfig>
			<primitives.famdiagram.Config.templates>
		*/this.onHighlightRender=null;/*
		Event: onCursorRender
			If user defined custom cursor template for item template
			then this method is called to populate it with context data.
	
		See also:
			<primitives.common.RenderEventArgs>
			<primitives.famdiagram.TemplateConfig>
			<primitives.famdiagram.Config.templates>
		*/this.onCursorRender=null;/*
		Property: normalLevelShift
			Defines interval after level of items in  diagram having items in normal state.
		*/this.normalLevelShift=20;/*
		Property: dotLevelShift
			Defines interval after level of items in  diagram having all items in dot state.
		*/this.dotLevelShift=20;/*
		Property: lineLevelShift
			Defines interval after level of items in  diagram having items in line state.
		*/this.lineLevelShift=10;/*
		Property: normalItemsInterval
			Defines interval between items at the same level in  diagram having items in normal state.
		*/this.normalItemsInterval=10;/*
		Property: dotItemsInterval
			Defines interval between items at the same level in  diagram having items in dot state.
		*/this.dotItemsInterval=1;/*
		Property: lineItemsInterval
			Defines interval between items at the same level in  diagram having items in line state.
		*/this.lineItemsInterval=2;/*
		Property: cousinsIntervalMultiplier
			Use this interval multiplier between cousins in hiearchy. The idea of this option to make extra space between cousins.
			So children belonging to different parents have extra gap between them.
	
		*/this.cousinsIntervalMultiplier=5;/*
		method: update
			Makes full redraw of diagram contents reevaluating all options. This method has to be called explisitly after all options are set in order to update widget contents.
	
		Parameters:
			updateMode: This parameter defines severaty of update <primitives.common.UpdateMode>.
			For example <primitives.common.UpdateMode.Refresh> updates only
			items and selection reusing existing elements where ever it is possible.
	
		See also:
			<primitives.common.UpdateMode>
	
		Default:
			<primitives.common.UpdateMode.Recreate>
		*//*
		Property: itemTitleFirstFontColor
		This property customizes default template title font color.
		Item background color sometimes play a role of logical value and
		can vary over a wide range, so as a result title having
		default font color may become unreadable. Widgets selects the best font color
		between this option and <primitives.famdiagram.Config.itemTitleSecondFontColor>.
	
		See Also:
			<primitives.famdiagram.ItemConfig.itemTitleColor>
			<primitives.famdiagram.Config.itemTitleSecondFontColor>
			<primitives.common.highestContrast>
	
		*/this.itemTitleFirstFontColor="#ffffff"/*primitives.common.Colors.White*/;/*
		Property: itemTitleSecondFontColor
		Default template title second font color.
		*/this.itemTitleSecondFontColor="#000080"/*primitives.common.Colors.Navy*/;/*
			Property: minimizedItemShapeType
				Defines minimized item shape. The border line width is set with <primitives.famdiagram.TemplateConfig.minimizedItemBorderWidth>
				By default minimized item is rounded rectangle filled with item title color.
	
	
			See also:
				<primitives.famdiagram.TemplateConfig.minimizedItemCornerRadius>
				<primitives.famdiagram.ItemConfig.itemTitleColor>
				<primitives.famdiagram.ItemConfig.minimizedItemShapeType>
	
			Default:
				<primitives.common.ShapeType.None>
		*/this.minimizedItemShapeType=6/*primitives.common.ShapeType.None*/;/*
		Property: linesColor
			Connectors lines color. Connectors are basic connections betwen chart items
			defining their logical relationships, don't mix with connector annotations.
		*/this.linesColor="#c0c0c0"/*primitives.common.Colors.Silver*/;/*
		Property: linesWidth
			Connectors lines width.
		*/this.linesWidth=1;/*
		Property: linesType
			Connectors line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.linesType=0/*primitives.common.LineType.Solid*/;/*
		Property: showNeigboursConnectorsHighlighted
			Show connection lines between current cursor item and its neighbours highlighted. Neighbours selection mode is defined by neighboursSelectionMode option.
		See also:
			<primitives.famdiagram.Config.neighboursSelectionMode>,
			<primitives.famdiagram.Config.highlightLinesColor>,
			<primitives.famdiagram.Config.highlightLinesWidth>,
			<primitives.famdiagram.Config.highlightLinesType>
		Default:
			false
		*/this.showNeigboursConnectorsHighlighted=false;/*
		Property: highlightLinesColor
			Connectors highlight line color. Connectors are basic connections betwen chart items
			defining their logical relationships, don't mix with connector annotations.
		*/this.highlightLinesColor="#ff0000"/*primitives.common.Colors.Red*/;/*
		Property: highlightLinesWidth
			Connectors highlight line width.
		*/this.highlightLinesWidth=1;/*
		Property: highlightLinesType
			Connectors highlight line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.highlightLinesType=0/*primitives.common.LineType.Solid*/;/*
		Property: linesPalette
			This collection contains elements of type PaletteItemConfig. It is used to draw connector lines between families in different styles.
			It is similar concept to regular line chart having lines intersections.
			If this collection is empty then default linesColor, linesWidth and linesType are used for all connector lines.
	
		See Also:
			<primitives.famdiagram.PaletteItemConfig>
		*/this.linesPalette=[];/*
		Property: showCallout
			This option controls callout visibility for dotted items.
	
		Default:
			true
		*/this.showCallout=true;/*
		Property: calloutPlacementOffset
			Set this property value depending on size and intervals between markers so callout annotation does not overlap neighbouring items of marker it is shown for.
		*/this.calloutPlacementOffset=100;/*
		Property: defaultCalloutTemplateName
			This is template name used to render callouts for dotted items.
			Actual callout template name is defined by following sequence:
			<primitives.famdiagram.ItemConfig.calloutTemplateName>
			<primitives.famdiagram.ItemConfig.templateName>
			<primitives.famdiagram.Config.defaultCalloutTemplateName>
			<primitives.famdiagram.Config.defaultTemplateName>
	
	
		See Also:
			<primitives.famdiagram.Config.templates> collection property.
	
		Default:
			null
		*/this.defaultCalloutTemplateName=null;/*
		Property: calloutfillColor
			Annotation callout fill color.
		*/this.calloutfillColor="#000000";/*
		Property: calloutBorderColor
			Annotation callout border color.
		*/this.calloutBorderColor=null;/*
		Property: calloutOffset
			Annotation callout offset.
		*/this.calloutOffset=4;/*
		Property: calloutCornerRadius
			Annotation callout corner radius.
		*/this.calloutCornerRadius=4;/*
		Property: calloutPointerWidth
			Annotation callout pointer base width.
		*/this.calloutPointerWidth="10%";/*
		Property: calloutLineWidth
			Annotation callout border line width.
		*/this.calloutLineWidth=1;/*
		Property: calloutOpacity
			Annotation callout opacity.
		*/this.calloutOpacity=0.2;/*
		Property: buttonsPanelSize
			User buttons panel size.
		*/this.buttonsPanelSize=28;/*
		Property: groupTitlePanelSize
			Group title panel size.
		*/this.groupTitlePanelSize=24;/*
		Property: checkBoxPanelSize
			Selection check box panel size.
		*/this.checkBoxPanelSize=24;/*
			Property: groupTitleOrientation
				Group title direction style.
	
			Default:
				<primitives.text.TextDirection.Auto>
		*/this.groupTitleOrientation=2/*primitives.text.TextOrientationType.RotateRight*/;/*
			Property: groupTitleVerticalAlignment
				Group title vertical alignment.
	
			Default:
				<primitives.common.VerticalAlignmentType.Center>
		*/this.groupTitleVerticalAlignment=1/*primitives.common.VerticalAlignmentType.Middle*/;/*
			Property: groupTitleHorizontalAlignment
				Group title horizontal alignment.
	
			Default:
				<primitives.common.HorizontalAlignmentType.Center>
		*/this.groupTitleHorizontalAlignment=0/*primitives.common.HorizontalAlignmentType.Center*/;/*
			Property: groupTitleFontSize
				Group title font size.
	
			Default:
				15
		*/this.groupTitleFontSize="12px";/*
			Property: groupTitleFontFamily
				Group title font family.
	
			Default:
				"Arial"
		*/this.groupTitleFontFamily="Arial";/*
			Property: groupTitleColor
				Group title color.
	
			Default:
				<primitives.common.Colors.Black>
		*/this.groupTitleColor="#4169e1"/*primitives.common.Colors.RoyalBlue*/;/*
			Property: groupTitleFontWeight
				Group title font weight: normal | bold
	
			Default:
				"normal"
		*/this.groupTitleFontWeight="normal";/*
			Property: groupTitleFontStyle
				Group title font style: normal | italic
	
			Default:
				"normal"
		*/this.groupTitleFontStyle="normal";this.distance=3;/*
		Property: scale
			CSS3 scale transform.
		*/this.scale=1;/*
		Property: minimumScale
			Minimum CSS3 scale transform. Available on mobile safary only.
		*/this.minimumScale=0.5;/*
		Property: maximumScale
			Maximum CSS3 scale transform. Available on mobile safary only.
		*/this.maximumScale=1;/*
		Property: showLabels
			This option controls labels visibility for minimized items. If you need to show labels outside of borders of regular items then use item template for customization.
			Labels placed inside HTML DIV element and long strings are wrapped inside.
			User can control labels position relative to its item. Chart does not meassure labels and does reserve space for them,
			so if label overlap each other then horizontal or vertical intervals between rows and items shoud be manually increased.
	
		Auto - depends on available space.
		True - always shown.
		False - hidden.
	
		See Also:
			<primitives.famdiagram.ItemConfig.label>
			<primitives.famdiagram.Config.labelSize>
			<primitives.famdiagram.Config.normalItemsInterval>
			<primitives.famdiagram.Config.dotItemsInterval>
			<primitives.famdiagram.Config.lineItemsInterval>
			<primitives.famdiagram.Config.normalLevelShift>
			<primitives.famdiagram.Config.dotLevelShift>
			<primitives.famdiagram.Config.lineLevelShift>
	
		Default:
			<primitives.common.Enabled.Auto>
		*/this.showLabels=0/*primitives.common.Enabled.Auto*/;/*
		Property: labelSize
			Defines label size. It is needed to avoid labels overlapping. If one label overlaps another label or item it will be hidden.
			Label string is wrapped when its length exceeds available width.
	
		Default:
			new <primitives.common.Size>(80, 24);
		*/this.labelSize=new primitives.common.Size(80,24);/*
		Property: labelOffset
			Defines label offset from dot in pixels.
	
		Default:
			1;
		*/this.labelOffset=1;/*
		Property: labelOrientation
			Defines label orientation.
	
		See Also:
		<primitives.text.TextOrientationType>
	
		Default:
			<primitives.text.TextOrientationType.Horizontal>
		*/this.labelOrientation=0/*primitives.text.TextOrientationType.Horizontal*/;/*
		Property: labelPlacement
			Defines label placement relative to its dot.
			Label is aligned to opposite side of its box.
	
		See Also:
		<primitives.common.PlacementType>
	
		Default:
			<primitives.common.PlacementType.Top>
		*/this.labelPlacement=1/*primitives.common.PlacementType.Top*/;/*
		Property: labelFontSize
			Label font size.
	
		Default:
			10px
	*/this.labelFontSize="10px";/*
			Property: labelFontFamily
				Label font family.
	
			Default:
				"Arial"
		*/this.labelFontFamily="Arial";/*
			Property: labelColor
				Label color.
	
			Default:
				primitives.common.Colors.Black
		*/this.labelColor="#000000"/*primitives.common.Colors.Black*/;/*
			Property: labelFontWeight
				Font weight: normal | bold
	
			Default:
				"normal"
		*/this.labelFontWeight="normal";/*
		Property: labelFontStyle
			Font style: normal | italic
	
		Default:
			"normal"
		*/this.labelFontStyle="normal";/*
		Property: enablePanning
			Enable chart panning with mouse drag & drop for desktop browsers.
			Disable it if you need to support items Drag & Drop.
	
		Default:
			true
		*/this.enablePanning=true;/*
		Property: printPreviewPageSize
			Defines print preview page size in pixels.
	
		Default:
			new <primitives.common.Size>(612, 792);
		*/this.printPreviewPageSize=new primitives.common.Size(612,792);/*
		Property: autoSizeMinimum
			Defines minimum diagram size in autosize mode. If diagram has no elements, it is going to be of this size on the page.
		Default:
			new <primitives.common.Size>(800, 600);
		*/this.autoSizeMinimum=new primitives.common.Size(800,600);/*
		Property: autoSizeMaximum
			Defines maximum diagram size in autosize mode.
		Default:
			new <primitives.common.Size>(1024, 768);
		*/this.autoSizeMaximum=new primitives.common.Size(1024,768);};/* /Controls/FamDiagram/configs/ConnectorAnnotationConfig.js*//*
		Class: primitives.famdiagram.ConnectorAnnotationConfig
			Options class. Populate annotation collection with instances of this objects to draw connector between two items.
	
		See Also:
			<primitives.famdiagram.Config.annotations>
	*/primitives.famdiagram.ConnectorAnnotationConfig=function(arg0,arg1){var property;/*
		Property: annotationType
			Annotation type. All various annotations are defined in annotation collection property of <primitives.famdiagram.Config>.
			So this property is needed to define annotation type when we use JavaScript non-prototype objects.
			See other annotations as well.
	
		Default:
			<primitives.common.AnnotationType.Connector>
	
		See Also:
			<primitives.famdiagram.Config.annotations>
			<primitives.famdiagram.ShapeAnnotationConfig>
			<primitives.famdiagram.LabelAnnotationConfig>
			<primitives.famdiagram.BackgroundAnnotationConfig>
			<primitives.famdiagram.HighlightPathAnnotationConfig>
		*/this.annotationType=0/*primitives.common.AnnotationType.Connector*/;/*
		Property: zOrderType
			Defines annotation Z order placement relative to chart items. Chart items are drawn in layers on top of each other. We can draw annotations under the items or over them.
			If you place annotations over items then you block mouse events of UI elements in them. Browsers don't support mouse events transparentcy consistently.
			So in order to avoid mouse events blocking of UI elements in item templates you have to place annotation items under them.
			Take into account that chart default buttons are drawn on top of everyhting, so they are never blocked by annotations drawn over items.
	
		Default:
			<primitives.common.ZOrderType.Foreground>
		*/this.zOrderType=2/*primitives.common.ZOrderType.Foreground*/;/*
		Property: fromItem
			Reference to from item in hierarchy.
		See Also:
			<primitives.famdiagram.ItemConfig.id>
		*/this.fromItem=null;/*
		Property: toItem
			Reference to from item in hierarchy.
		See Also:
			<primitives.famdiagram.ItemConfig.id>
		*/this.toItem=null;/*
		Property: connectorShapeType
			Connector shape type.
	
		Default:
			<primitives.common.ConnectorShapeType.OneWay>
		*/this.connectorShapeType=0/*primitives.common.ConnectorShapeType.OneWay*/;/*
		Property: connectorPlacementType
			Defines connector annotation shape placement mode between two items.
			It uses off beat placement mode as default in order to avoid overlapping
			of base hierarchy connecting lines.
	
		Default:
			<primitives.common.ConnectorPlacementType.Offbeat>
	*/this.connectorPlacementType=0/*primitives.common.ConnectorPlacementType.Offbeat*/;/*
		Property: labelPlacementType
			Label placement type along connection line(s).
	
		Default:
			<primitives.common.ConnectorLabelPlacementType.Between>
		*/this.labelPlacementType=1/*primitives.common.ConnectorLabelPlacementType.Between*/;/*
		Property: offset
			Connector's from and to points offset off the rectangles side. Connectors connection points can be outside of rectangles and inside for negative offset value.
		See also:
			<primitives.common.Thickness>
		*/this.offset=new primitives.common.Thickness(0,0,0,0);/*
		Property: lineWidth
			Border line width.
		*/this.lineWidth=2;/*
		Property: color
			Connector's color.
	
		Default:
			<primitives.common.Colors.Black>
		*/this.color="#000000"/*primitives.common.Colors.Black*/;/*
		Property: lineType
			Connector's line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.lineType=0/*primitives.common.LineType.Solid*/;/*
		Property: selectItems
			Always show annotated items in normal state. Setting this option is equivalent to adding annotated items to collection of selected items.
	
		Default:
			true
	
		See Also:
			<primitives.famdiagram.Config.selectedItems>
		*/this.selectItems=true;/*
		Property: label
			Annotation label text. Label styled with css class name "bp-connector-label".
		*/this.label=null;/*
		Property: labelSize
			Annotation label size.
	
		Default:
			new <primitives.common.Size>(60, 30);
		*/this.labelSize=new primitives.common.Size(60,30);switch(arguments.length){case 1:for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}break;case 2:this.fromItem=arg0;this.toItem=arg1;break;}};/* /Controls/FamDiagram/configs/HighlightPathAnnotationConfig.js*//*
		Class: primitives.famdiagram.HighlightPathAnnotationConfig
			Options class. Populate annotation collection with instances of this objects to draw path between items.
			Path is drawn along base connection lines displaying relationships between item of the chart.
		See Also:
			<primitives.famdiagram.Config.annotations>
	*/primitives.famdiagram.HighlightPathAnnotationConfig=function(arg0){var property;/*
		Property: annotationType
			Annotation type. All various annotations are defined in annotation collection property of <primitives.famdiagram.Config>.
			So this property is needed to define annotation type when we use JavaScript non-prototype objects.
			See other annotations as well.
	
		Default:
			<primitives.common.AnnotationType.HighlightPath>
	
		See Also:
			<primitives.famdiagram.Config.annotations>
			<primitives.famdiagram.ConnectorAnnotationConfig>
			<primitives.famdiagram.ShapeAnnotationConfig>
			<primitives.famdiagram.LabelAnnotationConfig>
			<primitives.famdiagram.BackgroundAnnotationConfig>
		*/this.annotationType=2/*primitives.common.AnnotationType.HighlightPath*/;/*
		Property: zOrderType
			Defines annotation Z order placement relative to chart items. Chart items are drawn in layers on top of each other.
			Highlight path annotations can be placed under main connectors wire or over.
	
		Default:
			<primitives.common.ZOrderType.Foreground>
		*/this.zOrderType=2/*primitives.common.ZOrderType.Foreground*/;/*
		Property: items
			Array of item ids in hierarchy.
		See Also:
			<primitives.famdiagram.ItemConfig.id>
		*/this.items=[];/*
		Property: lineWidth
			Border line width.
		*/this.lineWidth=2;/*
		Property: color
			Connector's color.
	
		Default:
			<primitives.common.Colors.Black>
		*/this.color="#ff0000"/*primitives.common.Colors.Red*/;/*
		Property: lineType
			Connector's line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.lineType=0/*primitives.common.LineType.Solid*/;/*
		Property: opacity
			Connector's line opacity.
		*/this.opacity=1;/*
		Property: showArrows
			This option controls arrows visibility along highlight path.
	
		Default:
			true
		*/this.showArrows=true;/*
		Property: selectItems
			Always show annotated items in normal state. Setting this option is equivalent to adding annotated items to collection of selected items.
	
		Default:
			true
	
		See Also:
			<primitives.famdiagram.Config.selectedItems>
		*/this.selectItems=false;switch(arguments.length){case 1:if(arg0!==null){if(arg0 instanceof Array){this.items=arg0;}else if((typeof arg0==='undefined'?'undefined':_typeof(arg0))=="object"){for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}}}break;}};/* /Controls/FamDiagram/configs/ItemConfig.js*//*
		Class: primitives.famdiagram.ItemConfig
			Defines item in family chart hierarchy.
			User is supposed to create hierarchy of this items and assign it to <primitives.famdiagram.Config.items> collection property.
			Widget contains some generic properties used in default item template,
			but user can add as many custom properties to this class as needed.
			Just be careful and avoid widget malfunction.
	
		See Also:
			<primitives.famdiagram.Config.items>
	*/primitives.famdiagram.ItemConfig=function(arg0,arg1,arg2,arg3,arg4){var property;/*
		Property: id
		Unique item id.
		*/this.id=null;/*
		Property: parents
		Collection of parent id's. If parents collection is empty [] then item placed as a root item.
		*/this.parents=[];/*
		Property: spouses
		Collection of spouses id's. Items in this collection share common connector line whether they have common children or not.
		*/this.spouses=[];/*
		Property: title
		Default template title property.
		*/this.title=null;/*
		Property: description
		Default template description element.
		*/this.description=null;/*
		Property: image
		Url to image. This property is used in default template.
		*/this.image=null;/*
		Property: context
		User context object.
		*/this.context=null;/*
		Property: itemTitleColor
		Default template title background color. The same color is used to draw minimized/dotted item.
		*/this.itemTitleColor="#4169e1"/*primitives.common.Colors.RoyalBlue*/;/*
		Property: minimizedItemShapeType
			Defines minimized/dotted item shape type. By default it is set by ItemTemplate.minimizedItemShapeType property.
			Use this property to set marker type individually per item.
	
		See Also:
			<primitives.common.ShapeType>
		*/this.minimizedItemShapeType=null;/*
		Property: groupTitle
		Auxiliary group title property. Displayed vertically on the side of item.
		*/this.groupTitle=null;/*
		Property: groupTitleColor
		Group title background color.
		*/this.groupTitleColor="#4169e1"/*primitives.common.Colors.RoyalBlue*/;/*
		Property: isActive
			If it is true then item is selectable in hierarchy and it has mouse over highlight.
	
		True - Item is clickable.
		False - Item is inactive and user cannot set cursor item or highlight.
	
		Default:
			true
		*/this.isActive=true;/*
		Property: hasSelectorCheckbox
			If it is true then selection check box is shown for the item.
			Selected items are always shown in normal form, so if item is
			selected then its selection check box is visible and checked.
	
		Auto - Depends on <primitives.famdiagram.Config.hasSelectorCheckbox> setting.
		True - Selection check box is visible.
		False - No selection check box.
	
		Default:
		<primitives.common.Enabled.Auto>
		*/this.hasSelectorCheckbox=0/*primitives.common.Enabled.Auto*/;/*
		Property: hasButtons
			This option controls buttons panel visibility.
	
		Auto - Depends on <primitives.famdiagram.Config.hasButtons> setting.
		True - Has buttons panel.
		False - No buttons panel.
	
		Default:
		<primitives.common.Enabled.Auto>
		*/this.hasButtons=0/*primitives.common.Enabled.Auto*/;/*
		Property: templateName
			This is template name used to render this item.
	
			See Also:
			<primitives.famdiagram.TemplateConfig>
			<primitives.famdiagram.Config.templates> collection property.
		*/this.templateName=null;/*
		Property: showCallout
			This option controls items callout visibility.
	
		Auto - depends on <primitives.famdiagram.Config.showCallout> option
		True - shown
		False - hidden
	
		Default:
			<primitives.common.Enabled.Auto>
		*/this.showCallout=0/*primitives.common.Enabled.Auto*/;/*
		Property: calloutTemplateName
			This is template name used to render callout for dotted item.
			Actual callout template name is defined by following sequence:
			<primitives.famdiagram.ItemConfig.calloutTemplateName>
			<primitives.famdiagram.ItemConfig.templateName>
			<primitives.famdiagram.Config.defaultCalloutTemplateName>
			<primitives.famdiagram.Config.defaultTemplateName>
	
		See Also:
			<primitives.famdiagram.Config.templates> collection property.
		Default:
			null
		*/this.calloutTemplateName=null;/*
		Property: label
		Items label text.
		*/this.label=null;/*
		Property: showLabel
			This option controls items label visibility. Label is displayed in form of div having text inside, long string is wrapped inside of it.
			User can control labels position relative to its item. Chart does not preserve space for label.
	
		Auto - depends on <primitives.famdiagram.Config.labelOrientation> setting.
		True - always shown.
		False - hidden.
	
		See Also:
		<primitives.famdiagram.ItemConfig.label>
		<primitives.famdiagram.Config.labelSize>
	
		Default:
			<primitives.common.Enabled.Auto>
		*/this.showLabel=0/*primitives.common.Enabled.Auto*/;/*
		Property: labelSize
			Defines label size. It is needed to avoid labels overlapping. If one label overlaps another label or item it will be hidden.
			Label string is wrapped when its length exceeds available width.
			By default it is equal to charts <primitives.famdiagram.Config.labelSize>.
	
		See Also:
			<primitives.common.Size>
		Default:
			null;
		*/this.labelSize=null;/*
		Property: labelOrientation
			Defines label orientation.
			In default <primitives.text.TextOrientationType.Auto> mode it depends on chart <primitives.famdiagram.Config.labelOrientation> setting.
	
		See Also:
		<primitives.famdiagram.Config.labelOrientation>
		<primitives.text.TextOrientationType>
	
		Default:
			<primitives.text.TextOrientationType.Auto>
		*/this.labelOrientation=3/*primitives.text.TextOrientationType.Auto*/;/*
		Property: labelPlacement
			Defines label placement relative to the item.
			In default <primitives.common.PlacementType.Auto> mode it depends on chart <primitives.famdiagram.Config.labelPlacement> setting.
	
		See Also:
			<primitives.famdiagram.Config.labelPlacement>
			<primitives.common.PlacementType>
	
		Default:
			<primitives.common.PlacementType.Auto>
		*/this.labelPlacement=0/*primitives.common.PlacementType.Auto*/;switch(arguments.length){case 1:for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}break;case 5:this.id=arg0;this.parent=arg1;this.title=arg2;this.description=arg3;this.image=arg4;break;}};/* /Controls/FamDiagram/configs/LabelAnnotationConfig.js*//*
		Class: primitives.famdiagram.LabelAnnotationConfig
			Options class. Populate annotation collection with instances of this object to draw labels between items in diagram layout.
			This label annotation is created over connection line going from item to its children or parents.
			It is required that label annotation references subset of item's parents or children.
			If you need to create cross chart reference then use connector annotation.
	
		See Also:
			<primitives.famdiagram.Config.annotations>
	*/primitives.famdiagram.LabelAnnotationConfig=function(arg0,arg1){var property;/*
		Property: annotationType
			Annotation type. All various annotations are defined in annotation collection property of <primitives.famdiagram.Config>.
			So this property is needed to define annotation type when we use JavaScript non-prototype objects.
			See other annotations as well.
	
		Default:
			<primitives.common.AnnotationType.Label>
	
		See Also:
			<primitives.famdiagram.Config.annotations>
			<primitives.famdiagram.ConnectorAnnotationConfig>
			<primitives.famdiagram.ShapeAnnotationConfig>
			<primitives.famdiagram.BackgroundAnnotationConfig>
			<primitives.famdiagram.HighlightPathAnnotationConfig>
		*/this.annotationType=3/*primitives.common.AnnotationType.Label*/;/*
		Property: fromItem
			This is the item you are creating annotation for.
		See Also:
			<primitives.famdiagram.ItemConfig.id>
		*/this.fromItem=null;/*
		Property: toItems
			This collection should contain only child or parent items of annotated item.
			You cannot add child and parent items at the same time.
			It may contain sub set of child or parent items. In that case existing annotation labels are drawn as a cascade.
	
		See Also:
			<primitives.famdiagram.ItemConfig.id>
		*/this.toItems=[];/*
		Property: label
			Annotation label text. Label styled with css class name "bp-connector-label".
		*/this.title=null;/*
		Property: itemTitleColor
		Default template title background color.
		*/this.itemTitleColor="#4169e1"/*primitives.common.Colors.RoyalBlue*/;/*
		Property: templateName
			This is template name used to render this label.
	
			See Also:
			<primitives.famdiagram.TemplateConfig>
			<primitives.famdiagram.Config.templates>
			<primitives.famdiagram.Config.onItemRender>
		*/this.templateName=null;switch(arguments.length){case 1:for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}break;case 2:this.fromItem=arg0;this.toItem=arg1;break;}};/* /Controls/FamDiagram/configs/PaletteItemConfig.js*//*
		Class: primitives.famdiagram.PaletteItemConfig
			This class is used to define cross family connectors styles.
			Multi-parent charts are supposed to have multiple cross hierarchy connectors, so in order to trace them more easely on chart
			every connector may have separate style. It is the same strategy as for visualization of regular line charts.
	
		See Also:
			<primitives.famdiagram.Config.linesPalette>
	*/primitives.famdiagram.PaletteItemConfig=function(arg0,arg1,arg2){var property;/*
		Property: lineColor
			Line color.
	
		Default:
			<primitives.common.Colors.Silver>
		*/this.lineColor="#c0c0c0"/*primitives.common.Colors.Silver*/;/*
		Property: lineWidth
			Line width.
		Default:
			1
		*/this.lineWidth=1;/*
		Property: lineType
			Line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.lineType=0/*primitives.common.LineType.Solid*/;switch(arguments.length){case 1:for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}break;case 3:this.lineColor=arg0;this.lineWidth=arg1;this.lineType=arg2;break;}};/* /Controls/FamDiagram/configs/ShapeAnnotationConfig.js*//*
		Class: primitives.famdiagram.ShapeAnnotationConfig
			Options class. Populate annotation collection with instances of this objects to draw shape benith or on top of several items.
			Shape is drawn as rectangular area.
		See Also:
			<primitives.famdiagram.Config.annotations>
	*/primitives.famdiagram.ShapeAnnotationConfig=function(arg0){var property;/*
		Property: annotationType
			Annotation type. All various annotations are defined in annotation collection property of <primitives.famdiagram.Config>.
			So this property is needed to define annotation type when we use JavaScript non-prototype objects.
			See other annotations as well.
	
		Default:
			<primitives.common.AnnotationType.Shape>
	
		See Also:
			<primitives.famdiagram.Config.annotations>
			<primitives.famdiagram.ConnectorAnnotationConfig>
			<primitives.famdiagram.LabelAnnotationConfig>
			<primitives.famdiagram.BackgroundAnnotationConfig>
			<primitives.famdiagram.HighlightPathAnnotationConfig>
		*/this.annotationType=1/*primitives.common.AnnotationType.Shape*/;/*
		Property: zOrderType
			Defines annotation Z order placement relative to chart items. Chart items are drawn in layers on top of each other. We can draw annotations under the items or over them.
			If you place annotations over items then you block mouse events of UI elements in them. Browsers don't support mouse events transparentcy consistently.
			So in order to avoid mouse events blocking of UI elements in item templates you have to place annotation items under them.
			Take into account that chart default buttons are drawn on top of everyhting, so they are never blocked by annotations drawn over items.
	
		Default:
			<primitives.common.ZOrderType.Auto>
		*/this.zOrderType=0/*primitives.common.ZOrderType.Auto*/;/*
		Property: items
			Array of items ids in hierarchy.
		See Also:
			<primitives.famdiagram.ItemConfig.id>
		*/this.items=[];/*
		Property: shapeType
			Shape type.
	
		Default:
			<primitives.common.ShapeType.Rectangle>
		*/this.shapeType=0/*primitives.common.ShapeType.Rectangle*/;/*
		Property: offset
			Connector's from and to points offset off the rectangles side. Connectors connection points can be outside of rectangles and inside for negative offset value.
		See also:
			<primitives.common.Thickness>
		*/this.offset=new primitives.common.Thickness(0,0,0,0);/*
		Property: lineWidth
			Border line width.
		*/this.lineWidth=2;/*
		Property: cornerRadius
			Body corner radius in percents or pixels. For applicable shapes only.
		*/this.cornerRadius="10%";/*
		Property: opacity
			Background color opacity. For applicable shapes only.
		*/this.opacity=1;/*
		Property: borderColor
			Shape border line color.
	
		Default:
			null
		*/this.borderColor=null;/*
		Property: fillColor
			Fill Color.
	
		Default:
			null
		*/this.fillColor=null;/*
		Property: lineType
			Connector's line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.lineType=0/*primitives.common.LineType.Solid*/;/*
		Property: selectItems
			Always show annotated items in normal state. Setting this option is equivalent to adding annotated items to collection of selected items.
	
		Default:
			true
	
		See Also:
			<primitives.famdiagram.Config.selectedItems>
		*/this.selectItems=false;/*
		Property: label
			Annotation label text. Label styled with css class name "bp-connector-label".
		*/this.label=null;/*
		Property: labelSize
			Annotation label size.
	
		Default:
			new <primitives.common.Size>(60, 30);
		*/this.labelSize=new primitives.common.Size(60,30);/*
		Property: labelPlacement
			Defines label placement relative to the shape.
	
		See Also:
			<primitives.famdiagram.Config.labelPlacement>
			<primitives.common.PlacementType>
	
		Default:
			<primitives.common.PlacementType.Auto>
		*/this.labelPlacement=0/*primitives.common.PlacementType.Auto*/;/*
		Property: labelOffset
			Defines label offset from shape in pixels.
	
		Default:
			4;
		*/this.labelOffset=4;switch(arguments.length){case 1:if(arg0!==null){if(arg0 instanceof Array){this.items=arg0;}else if((typeof arg0==='undefined'?'undefined':_typeof(arg0))=="object"){for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}}}break;}};/* /Controls/FamDiagram/models/CrossingsItem.js*/primitives.famdiagram.CrossingsItem=function(){this.childid=null;this.edges=[];};/* /Controls/FamDiagram/models/EdgeItem.js*/primitives.famdiagram.EdgeItem=function(key0,val0,key1,val1){this.values=[val0,val1];this[key0]=0;this[key1]=1;};primitives.famdiagram.EdgeItem.prototype.getNear=function(key){return this.values[this[key]];};primitives.famdiagram.EdgeItem.prototype.getFar=function(key){return this.values[Math.abs(this[key]-1)];};primitives.famdiagram.EdgeItem.prototype.setNear=function(key,value){this.values[this[key]]=value;};primitives.famdiagram.EdgeItem.prototype.setFar=function(key,value){this.values[Math.abs(this[key]-1)]=value;};primitives.famdiagram.EdgeItem.prototype.toString=function(){return this.parent+','+this.child;};/* /Controls/FamDiagram/models/ExtraGravity.js*/primitives.famdiagram.ExtraGravity=function(level){this.commonParent=null;// primitives.orgdiagram.OrgItem.id
	this.fromParent=null;// primitives.orgdiagram.OrgItem.id
	this.toParent=null;// primitives.orgdiagram.OrgItem.id
	this.level=level;};/* /Controls/FamDiagram/models/Family.js*/primitives.famdiagram.Family=function(id){this.id=null;this.familyPriority=1;this.childFamilies=[];this.items=[];this.links=[];/* array of FamLink's */this.backLinks=[];/* array of FamLink's */if(arguments.length==1){this.id=id;}};/* /Controls/FamDiagram/models/FamilyEdge.js*/primitives.famdiagram.FamilyEdge=function(parentid,childid){this.parentid=parentid;this.childid=childid;this.key=parentid+","+childid;};/* /Controls/FamDiagram/models/FamilyItem.js*/primitives.famdiagram.FamilyItem=function(arg0){var property;this.id=null;this.familyId=null;this.itemConfig=null;this.isVisible=true;this.isActive=true;// item is clickable
	this.isLevelNeutral=false;// This option allows to place fake item in between of original item levels
	this.level=null;this.levelGravity=0/*primitives.common.GroupByType.None*/;// If item can be moved between its parent and children levels in diagram, this option defines preference
	this.hideParentConnection=false;this.hideChildrenConnection=false;switch(arguments.length){case 1:for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}break;}};/* /Controls/FamDiagram/models/FamLink.js*/primitives.famdiagram.FamLink=function(fromItem,toItem){this.fromItem=fromItem;/* FamilyItem.id */this.toItem=toItem;/* FamilyItem.id */};/* /Controls/FamDiagram/models/Slot.js*/primitives.famdiagram.Slot=function(itemid){this.id=null;this.prev=null;/* prev slot id */this.next=null;/* next slot id */this.position=null;this.balance=0;this.itemId=itemid;/* if itemId is null then this slot is empty */this.left={};/* total number of children at the level on the left side of this slot */this.right={};/* total number of children at the level on the right side of this slot */this.crossings={};/* number of connections crossing this slot from side to side at the level */};primitives.famdiagram.Slot.prototype.clone=function(){var result=new primitives.famdiagram.Slot(),level;result.itemId=this.itemId;for(level in this.left){if(this.left.hasOwnProperty(level)){result.left[level]=this.left[level];}}for(level in this.right){if(this.right.hasOwnProperty(level)){result.right[level]=this.right[level];}}for(level in this.crossings){if(this.crossings.hasOwnProperty(level)){result.crossings[level]=this.crossings[level];}}return result;};/* /Controls/FamDiagram/models/Slots.js*/primitives.famdiagram.Slots=function(){this.first=null;this.last=null;this.slots={};this.items={};this.counter=0;};primitives.famdiagram.Slots.prototype.add=function(slot){slot.id=this.counter;this.counter+=1;this.slots[slot.id]=slot;if(slot.itemId!=null){this.items[slot.itemId]=slot;}if(this.last==null){this.last=slot.id;this.first=slot.id;}else{this.slots[this.last].next=slot.id;slot.prev=this.last;this.last=slot.id;}};primitives.famdiagram.Slots.prototype.insertBefore=function(beforeSlot,slot){slot.id=this.counter;this.counter+=1;this.slots[slot.id]=slot;if(slot.itemId!=null){this.items[slot.itemId]=slot;}if(beforeSlot.prev==null){slot.next=beforeSlot.id;this.first=slot.id;}else{var prevSlot=this.slots[beforeSlot.prev];prevSlot.next=slot.id;slot.next=beforeSlot.id;beforeSlot.prev=slot.id;slot.prev=prevSlot.id;}};primitives.famdiagram.Slots.prototype.loop=function(callback,startSlot){var slotid=startSlot!=null?startSlot.id:this.first,slot;while(slotid!=null){slot=this.slots[slotid];if(callback(slot)){break;}slotid=slot.next;}};primitives.famdiagram.Slots.prototype.backwardLoop=function(callback,startSlot){var slotid=startSlot!=null?startSlot.id:this.last,slot;while(slotid!=null){slot=this.slots[slotid];if(callback(slot)){break;}slotid=slot.prev;}};primitives.famdiagram.Slots.prototype.getSlot=function(itemId){return this.items[itemId];};/* /Controls/FamDiagram/Tasks/Options/Annotations/LabelAnnotationOptionTask.js*/primitives.famdiagram.LabelAnnotationOptionTask=function(splitAnnotationsOptionTask,logicalFamilyTask,defaultLabelAnnotationConfig){var _data={annotations:[],configs:{},maximumId:null},_hash={};var _dataTemplate=new primitives.common.ArrayReader(new primitives.common.ObjectReader({zOrderType:new primitives.common.EnumerationReader(primitives.common.ZOrderType,false,defaultLabelAnnotationConfig.zOrderType),fromItem:new primitives.common.ValueReader(["string","number"],true),toItems:new primitives.common.ArrayReader(new primitives.common.ValueReader(["string","number"],true),true),title:new primitives.common.ValueReader(["string"],true),itemTitleColor:new primitives.common.ValueReader(["string"],false,defaultLabelAnnotationConfig.itemTitleColor),templateName:new primitives.common.ValueReader(["string"],true)},false),false,null,true);function process(){var context={isChanged:false,hash:_hash,sourceHash:{}},maximumId=logicalFamilyTask.getMaximumId(),index,len,annotation;_data.annotations=_dataTemplate.read(_data.annotations,splitAnnotationsOptionTask.getAnnotations(3/*primitives.common.AnnotationType.Label*/),"annotations",context);_data.configs={};/* here we assign unique id to every annotation used in layout
				and populate configs hash mapping id to source annotation
				these source items used as context objects in rendering cycle
			*/var sourceItems=context.sourceHash.annotations;for(index=0,len=_data.annotations.length;index<len;index+=1){annotation=_data.annotations[index];maximumId+=1;annotation.id=maximumId;_data.configs[annotation.id]=sourceItems[index];}_data.maximumId=maximumId;return context.isChanged;}function getAnnotations(){return _data.annotations;}function getMaximumId(){return _data.maximumId;}function getConfig(itemId){return _data.configs[itemId];}return{process:process,getAnnotations:getAnnotations,getMaximumId:getMaximumId,getConfig:getConfig};};/* /Controls/FamDiagram/Tasks/Options/Annotations/LabelAnnotationPlacementOptionTask.js*/primitives.famdiagram.LabelAnnotationPlacementOptionTask=function(labelAnnotationOptionTask,defaultLabelAnnotationConfig){var _data={annotations:[]},_hash={};var _dataTemplate=new primitives.common.ArrayReader(new primitives.common.ObjectReader({id:new primitives.common.ValueReader(["number"],true),fromItem:new primitives.common.ValueReader(["string","number"],true),toItems:new primitives.common.ArrayReader(new primitives.common.ValueReader(["string","number"],true),true)}),true,"id");function process(){var context={isChanged:false,hash:_hash};_data.annotations=_dataTemplate.read(_data.annotations,labelAnnotationOptionTask.getAnnotations(),"annotations",context);return context.isChanged;}function getAnnotations(){return _data.annotations;}function getMaximumId(){return labelAnnotationOptionTask.getMaximumId();}return{process:process,getAnnotations:getAnnotations,getMaximumId:getMaximumId};};/* /Controls/FamDiagram/Tasks/Options/Annotations/LabelAnnotationTemplateOptionTask.js*/primitives.famdiagram.LabelAnnotationTemplateOptionTask=function(labelAnnotationOptionTask,defaultLabelAnnotationConfig){var _data={annotations:[]},_hash={};var _dataTemplate=new primitives.common.ArrayReader(new primitives.common.ObjectReader({id:new primitives.common.ValueReader(["number"],true),title:new primitives.common.ValueReader(["string"],true),itemTitleColor:new primitives.common.ValueReader(["string"],false,defaultLabelAnnotationConfig.itemTitleColor),templateName:new primitives.common.ValueReader(["string"],true)}),true,"id");function process(){var context={isChanged:false,hash:_hash};_data.annotations=_dataTemplate.read(_data.annotations,labelAnnotationOptionTask.getAnnotations(),"annotations",context);return context.isChanged;}function getAnnotations(){return _data.annotations;}return{process:process,getAnnotations:getAnnotations};};/* /Controls/FamDiagram/Tasks/Options/Selection/NeighboursSelectionModeOptionTask.js*/primitives.famdiagram.NeighboursSelectionModeOptionTask=function(optionsTask,defaultConfig){var _data={};var _dataTemplate=new primitives.common.ObjectReader({neighboursSelectionMode:new primitives.common.EnumerationReader(primitives.common.NeighboursSelectionMode,false,defaultConfig.neighboursSelectionMode)});function process(){var context={isChanged:false};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getNeighboursSelectionMode(){return _data.neighboursSelectionMode;}return{process:process,getNeighboursSelectionMode:getNeighboursSelectionMode};};/* /Controls/FamDiagram/Tasks/Options/ItemsOptionTask.js*/primitives.famdiagram.ItemsOptionTask=function(optionsTask,defaultItemConfig){var _data={},_hash={},_sourceHash={};var _dataTemplate=new primitives.common.ObjectReader({items:new primitives.common.ArrayReader(new primitives.common.ObjectReader({id:new primitives.common.ValueReader(["string","number"],true),parents:new primitives.common.ArrayReader(new primitives.common.ValueReader(["string","number"],true),true),isActive:new primitives.common.ValueReader(["boolean"],false,defaultItemConfig.isActive)}),true,"id",true)});function process(){var context={isChanged:false,hash:_hash,sourceHash:_sourceHash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getItems(){return _data.items;}function getConfig(itemId){return _sourceHash["options-items"][itemId];}return{process:process,getItems:getItems,getConfig:getConfig};};/* /Controls/FamDiagram/Tasks/Options/LinePaletteOptionTask.js*/primitives.famdiagram.LinePaletteOptionTask=function(optionsTask,defaultPaletteItemConfig){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({linesPalette:new primitives.common.ArrayReader(new primitives.common.ObjectReader({lineColor:new primitives.common.ValueReader(["string"],false,defaultPaletteItemConfig.lineColor),lineWidth:new primitives.common.ValueReader(["number"],false,defaultPaletteItemConfig.lineWidth),lineType:new primitives.common.EnumerationReader(primitives.common.LineType,false,defaultPaletteItemConfig.lineType)}),false)});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getOptions(){return _data;}return{process:process,getOptions:getOptions};};/* /Controls/FamDiagram/Tasks/Options/NormalizeOptionTask.js*/primitives.famdiagram.NormalizeOptionTask=function(optionsTask,defaultConfig){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({groupByType:new primitives.common.EnumerationReader(primitives.common.GroupByType,false,defaultConfig.groupByType),alignBylevels:new primitives.common.ValueReader(["boolean"],false,defaultConfig.alignBylevels)});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getOptions(){return _data;}return{process:process,getOptions:getOptions};};/* /Controls/FamDiagram/Tasks/Options/OptionsTask.js*//* eliminate invisible items */primitives.famdiagram.OptionsTask=function(getOptions){function process(){return true;}return{process:process,getOptions:getOptions,description:"Raw options."};};/* /Controls/FamDiagram/Tasks/Options/SpousesOptionTask.js*/primitives.famdiagram.SpousesOptionTask=function(optionsTask,defaultItemConfig){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({items:new primitives.common.ArrayReader(new primitives.common.ObjectReader({id:new primitives.common.ValueReader(["string","number"],true),spouses:new primitives.common.ArrayReader(new primitives.common.ValueReader(["string","number"],true),true)}),true,"id")});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getItems(){return _data.items;}return{process:process,getItems:getItems};};/* /Controls/FamDiagram/Tasks/Options/VisualTreeOptionTask.js*/primitives.famdiagram.VisualTreeOptionTask=function(optionsTask){var _data={leavesPlacementType:2/*primitives.common.ChildrenPlacementType.Horizontal*/,childrenPlacementType:2/*primitives.common.ChildrenPlacementType.Horizontal*/,maximumColumnsInMatrix:6,horizontalAlignment:0/*primitives.common.HorizontalAlignmentType.Center*/};function process(){return false;}function getOptions(){return _data;}return{process:process,getOptions:getOptions};};/* /Controls/FamDiagram/Tasks/Templates/CombinedTemplateParamsTask.js*/primitives.famdiagram.CombinedTemplateParamsTask=function(itemTemplateParamsTask,labelAnnotationTemplateParamsTask){function process(){return true;}function getTemplateParams(itemId){return itemTemplateParamsTask.getTemplateParams(itemId)||labelAnnotationTemplateParamsTask.getTemplateParams(itemId);}return{process:process,getTemplateParams:getTemplateParams};};/* /Controls/FamDiagram/Tasks/Templates/LabelAnnotationTemplateParamsTask.js*/primitives.famdiagram.LabelAnnotationTemplateParamsTask=function(itemsSizesOptionTask,labelAnnotationTemplateOptionTask,readTemplatesTask){var _data={items:{}// TemplateParams
	};function process(){var itemsSizesOptions=itemsSizesOptionTask.getOptions(),items=labelAnnotationTemplateOptionTask.getAnnotations(),index,len;_data.items={};for(index=0,len=items.length;index<len;index+=1){var annotation=items[index],templateParams=new primitives.orgdiagram.TemplateParams(),template=readTemplatesTask.getTemplate(annotation.templateName,itemsSizesOptions.defaultLabelAnnotationTemplate,readTemplatesTask.DefaultWidgetLabelAnnotationTemplateName);templateParams.template=template;_data.items[annotation.id]=templateParams;}return true;}function getTemplateParams(itemId){return _data.items[itemId];}return{process:process,getTemplateParams:getTemplateParams};};/* /Controls/FamDiagram/Tasks/Transformations/Selection/CursorNeighboursTask.js*/primitives.famdiagram.CursorNeighboursTask=function(cursorItemTask,neighboursSelectionModeOptionTask,navigationFamilyTask){var _data={items:[]};function process(){var cursorTreeItemId=cursorItemTask.getCursorTreeItem(),navigationFamily=navigationFamilyTask.getNavigationFamily(),neighboursSelectionMode=neighboursSelectionModeOptionTask.getNeighboursSelectionMode();_data.items=getCursorNeighbours(cursorTreeItemId,neighboursSelectionMode,navigationFamily);return true;}function getCursorNeighbours(cursorTreeItemId,neighboursSelectionMode,navigationFamily){var result=[],processed={},treeItem;if(cursorTreeItemId!==null){switch(neighboursSelectionMode){case 0/*primitives.common.NeighboursSelectionMode.ParentsAndChildren*/:navigationFamily.loopParents(this,cursorTreeItemId,function(itemid,orgItem){if(!processed.hasOwnProperty(itemid)){processed[itemid]=true;result.push(itemid);}if(orgItem.isActive){return navigationFamily.SKIP;}});navigationFamily.loopChildren(this,cursorTreeItemId,function(itemid,orgItem){if(!processed.hasOwnProperty(itemid)){processed[itemid]=true;result.push(itemid);}if(orgItem.isActive){return navigationFamily.SKIP;}});break;case 1/*primitives.common.NeighboursSelectionMode.ParentsChildrenSiblingsAndSpouses*/:navigationFamily.loopNeighbours(this,cursorTreeItemId,function(itemid,orgItem){if(!processed.hasOwnProperty(itemid)){processed[itemid]=true;result.push(itemid);}if(orgItem.isActive){return true;}});break;}}return result;}function getItems(){return _data.items;}return{process:process,getItems:getItems};};/* /Controls/FamDiagram/Tasks/Transformations/AddLabelAnnotationsTask.js*/primitives.famdiagram.AddLabelAnnotationsTask=function(labelAnnotationPlacementOptionTask,logicalFamilyTask){var _data={logicalFamily:null,maximumId:null},_defaultLabelAnnotationTemplateName;function process(debug){var index,len,itemConfig,logicalFamily=logicalFamilyTask.getLogicalFamily(),annotations=labelAnnotationPlacementOptionTask.getAnnotations();logicalFamily=logicalFamily.clone();addLabelAnnotations(logicalFamily,annotations);_data.logicalFamily=logicalFamily;_data.maximumId=labelAnnotationPlacementOptionTask.getMaximumId();if(debug&&!logicalFamily.validate()){throw"References are broken in family structure!";}return true;}function addLabelAnnotations(logicalFamily,annotations){var edges=primitives.common.graph(),/* edge item is new primitives.famdiagram.EdgeItem(fromItem, toItem); */configsHash={},configs,config,fromItem,index,len;if(annotations.length>0){/* group annotations by from item */for(index=0,len=annotations.length;index<len;index+=1){config=annotations[index];if(!configsHash.hasOwnProperty(config.fromItem)){configsHash[config.fromItem]=[config];/* create edges hash for item */logicalFamily.loopChildren(this,config.fromItem,function(childid,child,level){edges.addEdge(config.fromItem,childid,new primitives.famdiagram.EdgeItem(config.fromItem,config.fromItem,childid,childid));return logicalFamily.SKIP;});//ignore jslint
	logicalFamily.loopParents(this,config.fromItem,function(parentid,parent,level){edges.addEdge(parentid,config.fromItem,new primitives.famdiagram.EdgeItem(parentid,parentid,config.fromItem,config.fromItem));return logicalFamily.SKIP;});//ignore jslint
	}else{configsHash[config.fromItem].push(config);}}for(fromItem in configsHash){if(configsHash.hasOwnProperty(fromItem)){configs=configsHash[fromItem];/* process annotations having greater number of references first */configs.sort(function(a,b){return b.toItems.length-a.toItems.length;});//ignore jslint
	for(index=0;index<configs.length;index+=1){config=configs[index];addLabelAnnotation(logicalFamily,edges,config.fromItem,config.toItems,function(){/* add label annotation as new diagram family item */return new primitives.famdiagram.FamilyItem({id:config.id,isVisible:true,isLevelNeutral:true,isActive:false,itemConfig:config});});//ignore jslint
	}}}}}function addLabelAnnotation(logicalFamily,edges,fromItem,toItems,onCreate){var edge,isValid=true,commonParentId=null,toItem,index,len,bundleItem,bundleItems=[];for(index=0,len=toItems.length;index<len;index+=1){toItem=toItems[index];edge=edges.edge(fromItem,toItem);if(edge!=null){if(commonParentId==null){commonParentId=edge.getFar(toItem);}else{if(commonParentId!=edge.getFar(toItem)){isValid=false;break;}}bundleItems.push(edge.getNear(toItem));}else{isValid=false;break;}}if(isValid){bundleItem=onCreate();if(logicalFamily.bundleParents(commonParentId,bundleItems,bundleItem.id,bundleItem)){bundleItem.levelGravity=2/*primitives.common.GroupByType.Children*/;isValid=true;}else if(logicalFamily.bundleChildren(commonParentId,bundleItems,bundleItem.id,bundleItem)){bundleItem.levelGravity=1/*primitives.common.GroupByType.Parents*/;isValid=true;}else if(logicalFamily.bundleParents(commonParentId,toItems,bundleItem.id,bundleItem)){bundleItem.levelGravity=2/*primitives.common.GroupByType.Children*/;isValid=true;}else if(logicalFamily.bundleParents(commonParentId,toItems,bundleItem.id,bundleItem)){bundleItem.levelGravity=1/*primitives.common.GroupByType.Parents*/;isValid=true;}if(isValid){for(index=0,len=toItems.length;index<len;index+=1){toItem=toItems[index];edge=edges.edge(fromItem,toItem);edge.setFar(toItem,bundleItem.id);}}}}function getNavigationFamily(){return _data.logicalFamily;}function getMaximumId(){return _data.maximumId;}return{process:process,getNavigationFamily:getNavigationFamily,getMaximumId:getMaximumId};};/* /Controls/FamDiagram/Tasks/Transformations/AddSpousesTask.js*/primitives.famdiagram.AddSpousesTask=function(spousesOptionTask,removeLoopsTask){var _data={logicalFamily:null,maximumId:null};function process(debug){var logicalFamily=removeLoopsTask.getLogicalFamily(),maximumId=removeLoopsTask.getMaximumId(),items=spousesOptionTask.getItems();logicalFamily=logicalFamily.clone();maximumId=addFakeChildrenForSpouses(logicalFamily,items,maximumId,debug);_data.logicalFamily=logicalFamily;_data.maximumId=maximumId;if(debug&&!logicalFamily.validate()){throw"References are broken in family structure!";}return true;}function addFakeChildrenForSpouses(logicalFamily,items,maximumId,debug){var couple,fakeChild,index,len,itemConfig,spouseIndex,spouseLen,spouses;for(index=0,len=items.length;index<len;index+=1){itemConfig=items[index];spouses=itemConfig.spouses.slice(0);for(spouseIndex=0,spouseLen=spouses.length;spouseIndex<spouseLen;spouseIndex+=1){couple=[itemConfig.id,spouses[spouseIndex]];if(!logicalFamily.hasCommonChild(couple)){/* create fake child item to keep spouses together */maximumId+=1;fakeChild=new primitives.famdiagram.FamilyItem({id:maximumId,isVisible:false,isActive:false,isLevelNeutral:true,hideParentConnection:true,hideChildrenConnection:true,itemConfig:{title:"fake child #"+maximumId,description:"This is fake child keeps spouses together."},levelGravity:1/*primitives.common.GroupByType.Parents*/});logicalFamily.add(couple,fakeChild.id,fakeChild);}}}return maximumId;}function getLogicalFamily(){return _data.logicalFamily;}function getMaximumId(){return _data.maximumId;}return{process:process,getLogicalFamily:getLogicalFamily,getMaximumId:getMaximumId};};/* /Controls/FamDiagram/Tasks/Transformations/ItemsPositionsTask.js*/primitives.famdiagram.ItemsPositionsTask=function(currentControlSizeTask,scaleOptionTask,orientationOptionTask,itemsSizesOptionTask,connectorsOptionTask,visualTreeOptionTask,normalizeLogicalFamilyTask,orgTreeTask,intervalsTask,itemTemplateParamsTask,cursorItemTask,combinedNormalVisibilityItemsTask){var _data={treeItemsPositions:{},// primitives.orgdiagram.TreeItemPosition();
	treeLevelsPositions:[],// primitives.orgdiagram.TreeLevelPosition()
	panelSize:null// primitives.common.Rect();
	},_logicalFamily,_treeLevels,_orientationOptions,_connectorsOptions,_visualTreeOptions,_itemsSizesOptions,_scaleOptions;function process(){var panelSize,panelRect,scale;_itemsSizesOptions=itemsSizesOptionTask.getOptions();_orientationOptions=orientationOptionTask.getOptions();_connectorsOptions=connectorsOptionTask.getOptions();_visualTreeOptions=visualTreeOptionTask.getOptions();_logicalFamily=normalizeLogicalFamilyTask.getLogicalFamily();_treeLevels=orgTreeTask.getTreeLevels();_data.treeLevelsPositions=[];_data.treeItemsPositions={};panelSize=currentControlSizeTask.getOptimalPanelSize();_scaleOptions=scaleOptionTask.getOptions();scale=_scaleOptions.scale;panelSize.scale(1.0/scale);panelRect=new primitives.common.Rect(0,0,panelSize.width,panelSize.height);_data.panelSize=positionTreeItems(panelRect);recalcItemsPositions();return true;}/*  Position */function positionTreeItems(panelSize){var placeholderSize=new primitives.common.Rect(0,0,0,0),levelVisibilities,visibilities,level,index,minimalPlaceholderSize,leftMargin,rightMargin,cursorIndex,pageSize;switch(_orientationOptions.orientationType){case 2/*primitives.common.OrientationType.Left*/:case 3/*primitives.common.OrientationType.Right*/:panelSize.invert();break;}if(!_treeLevels.isEmpty()){switch(_itemsSizesOptions.pageFitMode){case 0/*primitives.common.PageFitMode.None*/:case 4/*primitives.common.PageFitMode.PrintPreview*/:case 5/*primitives.common.PageFitMode.AutoSize*/:levelVisibilities=[new primitives.orgdiagram.LevelVisibility(0,1/*primitives.common.Visibility.Normal*/)];placeholderSize=setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,0);break;default:levelVisibilities=[new primitives.orgdiagram.LevelVisibility(0,1/*primitives.common.Visibility.Normal*/)];visibilities=[];switch(_itemsSizesOptions.minimalVisibility){case 1/*primitives.common.Visibility.Normal*/:break;case 2/*primitives.common.Visibility.Dot*/:visibilities.push(2/*primitives.common.Visibility.Dot*/);break;case 0/*primitives.common.Visibility.Auto*/:case 3/*primitives.common.Visibility.Line*/:case 4/*primitives.common.Visibility.Invisible*/:visibilities.push(2/*primitives.common.Visibility.Dot*/);visibilities.push(3/*primitives.common.Visibility.Line*/);break;}_treeLevels.loopLevelsReversed(this,function(level,levelContext){var index;for(index=0;index<visibilities.length;index+=1){levelVisibilities.push(new primitives.orgdiagram.LevelVisibility(level,visibilities[index]));}});// Find minimal placeholder size to hold completly folded diagram
	minimalPlaceholderSize=setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,levelVisibilities.length-1);minimalPlaceholderSize.addRect(panelSize);minimalPlaceholderSize.offset(0,0,5,5);leftMargin=null;rightMargin=null;cursorIndex=null;// Maximized
	placeholderSize=setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,0);if(!checkDiagramSize(placeholderSize,minimalPlaceholderSize)){leftMargin=0;// Minimized
	placeholderSize=setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,levelVisibilities.length-1);if(checkDiagramSize(placeholderSize,minimalPlaceholderSize)){rightMargin=levelVisibilities.length-1;cursorIndex=rightMargin;while(rightMargin-leftMargin>1){cursorIndex=Math.floor((rightMargin+leftMargin)/2.0);placeholderSize=setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,cursorIndex);if(checkDiagramSize(placeholderSize,minimalPlaceholderSize)){rightMargin=cursorIndex;}else{leftMargin=cursorIndex;}}if(rightMargin!==cursorIndex){placeholderSize=setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,rightMargin);}}}break;}}return placeholderSize;}function setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,cursorIndex){var index,levelVisibility;_data.treeLevelsPositions=[];_treeLevels.loopLevels(this,function(index,levelContext){var treeLevelPosition=new primitives.orgdiagram.TreeLevelPosition();treeLevelPosition.currentvisibility=1/*primitives.common.Visibility.Normal*/;_data.treeLevelsPositions.push(treeLevelPosition);});for(index=0;index<=cursorIndex;index+=1){levelVisibility=levelVisibilities[index];_data.treeLevelsPositions[levelVisibility.level].currentvisibility=levelVisibility.currentvisibility;}recalcItemsSize();setOffsets();recalcLevelsDepth();shiftLevels();return new primitives.common.Rect(0,0,Math.round(getDiagramWidth()),Math.round(getDiagramHeight()));}function checkDiagramSize(diagramSize,panelSize){var result=false;switch(_itemsSizesOptions.pageFitMode){case 1/*primitives.common.PageFitMode.PageWidth*/:if(panelSize.width>=diagramSize.width){result=true;}break;case 2/*primitives.common.PageFitMode.PageHeight*/:if(panelSize.height>=diagramSize.height){result=true;}break;case 3/*primitives.common.PageFitMode.FitToPage*/:if(panelSize.height>=diagramSize.height&&panelSize.width>=diagramSize.width){result=true;}break;}return result;}function getDiagramHeight(){var len=_data.treeLevelsPositions.length,treeLevel=_data.treeLevelsPositions[len-1];return treeLevel.shift+treeLevel.nextLevelShift;}function getDiagramWidth(){var result=0;_treeLevels.loopLevels(this,function(levelIndex,level){var levelLength=_treeLevels.getLevelLength(levelIndex);if(levelLength>0){var itemid=_treeLevels.getItemAtPosition(levelIndex,levelLength-1),treeItemPosition=_data.treeItemsPositions[itemid];result=Math.max(result,treeItemPosition.offset+treeItemPosition.actualSize.width+treeItemPosition.rightPadding);}});return result;}function recalcItemsSize(){var cursorItemId=cursorItemTask.getCursorTreeItem();_data.treeItemsPositions={};_treeLevels.loopLevels(this,function(levelIndex,treeLevel){var treeLevelPosition=_data.treeLevelsPositions[levelIndex];_treeLevels.loopLevelItems(this,levelIndex,function(treeItemId,treeItem,position){var treeItemPosition=new primitives.orgdiagram.TreeItemPosition(),treeItemVisibility=combinedNormalVisibilityItemsTask.isItemSelected(treeItemId)?1/*primitives.common.Visibility.Normal*/:!treeItem.isVisible?4/*primitives.common.Visibility.Invisible*/:0/*primitives.common.Visibility.Auto*/,treeItemtemplate=itemTemplateParamsTask.getTemplateParams(treeItemId);treeItemPosition.actualVisibility=treeItemVisibility===0/*primitives.common.Visibility.Auto*/?treeLevelPosition.currentvisibility:treeItemVisibility;treeItemPosition.setSize(cursorItemId==treeItemId,treeItemtemplate,_itemsSizesOptions,_orientationOptions);_data.treeItemsPositions[treeItemId]=treeItemPosition;});});}function recalcLevelsDepth(){var minimalDepth,dotsDepth;_treeLevels.loopLevels(this,function(levelIndex,treeLevel){var treeLevelPosition=_data.treeLevelsPositions[levelIndex];treeLevelPosition.shift=0.0;treeLevelPosition.depth=0.0;treeLevelPosition.actualVisibility=4/*primitives.common.Visibility.Invisible*/;minimalDepth=null;/* minimum  height of non-dot items in level */dotsDepth=null;/* maximum dots height */_treeLevels.loopLevelItems(this,levelIndex,function(itemid,treeItem,position){var treeItemPosition=_data.treeItemsPositions[itemid];treeLevelPosition.depth=Math.max(treeLevelPosition.depth,treeItemPosition.actualSize.height);switch(treeItemPosition.actualVisibility){case 2/*primitives.common.Visibility.Dot*/:case 3/*primitives.common.Visibility.Line*/:case 4/*primitives.common.Visibility.Invisible*/:dotsDepth=!dotsDepth?treeItemPosition.actualSize.height:Math.min(dotsDepth,treeItemPosition.actualSize.height);break;default:minimalDepth=!minimalDepth?treeItemPosition.actualSize.height:Math.min(minimalDepth,treeItemPosition.actualSize.height);break;}treeLevelPosition.actualVisibility=Math.min(treeLevelPosition.actualVisibility,treeItemPosition.actualVisibility);});if(minimalDepth==null){minimalDepth=treeLevelPosition.depth;}if(dotsDepth!=null&&dotsDepth>minimalDepth){minimalDepth=dotsDepth;}switch(_itemsSizesOptions.verticalAlignment){case 0/*primitives.common.VerticalAlignmentType.Top*/:treeLevelPosition.horizontalConnectorsDepth=minimalDepth/2.0;break;case 1/*primitives.common.VerticalAlignmentType.Middle*/:treeLevelPosition.horizontalConnectorsDepth=treeLevelPosition.depth/2.0;break;case 2/*primitives.common.VerticalAlignmentType.Bottom*/:treeLevelPosition.horizontalConnectorsDepth=treeLevelPosition.depth-minimalDepth/2.0;break;}});}function shiftLevels(){var shift=_itemsSizesOptions.lineLevelShift,index,len,treeLevelPosition,treeLevelConnectorStackSize,childrenSpace=0,parentsSpace=0,arrowTipLength=_connectorsOptions.linesWidth*8;switch(_connectorsOptions.arrowsDirection){case 1/*primitives.common.GroupByType.Parents*/:childrenSpace=arrowTipLength;parentsSpace=0;break;case 2/*primitives.common.GroupByType.Children*/:childrenSpace=0;parentsSpace=arrowTipLength;break;}for(index=0,len=_data.treeLevelsPositions.length;index<len;index+=1){treeLevelPosition=_data.treeLevelsPositions[index];treeLevelConnectorStackSize=orgTreeTask.getConnectorsStacksSizes(index);shift+=treeLevelPosition.setShift(shift,getLevelSpace(treeLevelPosition.actualVisibility),parentsSpace,childrenSpace,treeLevelConnectorStackSize.parentsStackSize);}}function getLevelSpace(visibility){var result=0.0;switch(visibility){case 1/*primitives.common.Visibility.Normal*/:result=_itemsSizesOptions.normalLevelShift;break;case 2/*primitives.common.Visibility.Dot*/:result=_itemsSizesOptions.dotLevelShift;break;case 3/*primitives.common.Visibility.Line*/:case 4/*primitives.common.Visibility.Invisible*/:result=_itemsSizesOptions.lineLevelShift;break;}return result;}function setOffsets(){var index,len;for(index=0,len=_data.treeLevelsPositions.length;index<len;index+=1){_data.treeLevelsPositions[index].currentOffset=0.0;}var treeLevels=_treeLevels,family=_logicalFamily.getPlanarFamily(_treeLevels),alignmentGroups=[],alignmentGroup,alignmentGroupByParent={};// create alignment groups
	index=0,treeLevels.loopLevels(this,function(levelIndex,level){treeLevels.loopLevelItems(this,levelIndex,function(itemid,item,position){if(!alignmentGroupByParent.hasOwnProperty(itemid)){var childrenCount=family.countChildren(itemid);if(childrenCount>0){var alignmentGroup=new AlignmentGroup(levelIndex,index);index+=1;alignmentGroup.addTop(position);family.loopChildren(this,itemid,function(childid,child){alignmentGroup.addBottom(treeLevels.getItemPosition(childid));if(childrenCount==1){family.loopParents(this,childid,function(parentid){alignmentGroup.addTop(treeLevels.getItemPosition(parentid));alignmentGroupByParent[parentid]=alignmentGroup;return family.SKIP;});}return family.SKIP;});alignmentGroups.push(alignmentGroup);alignmentGroupByParent[itemid]=alignmentGroup;}}});});var dependencyGroupsByItem={},dependencyGroups=[],counter=0,topMiddle,bottomMiddle;// create dependency groups out of alignment groups
	for(index=0,len=alignmentGroups.length;index<len;index+=1){alignmentGroup=alignmentGroups[index];topMiddle=alignmentGroup.topMiddle();bottomMiddle=alignmentGroup.bottomMiddle();if(topMiddle!=null&&bottomMiddle!=null){var topItem=treeLevels.getItemAtPosition(alignmentGroup.level,topMiddle),bottomItem=treeLevels.getItemAtPosition(alignmentGroup.level+1,bottomMiddle),dependencyGroup=dependencyGroupsByItem[topItem];if(dependencyGroup==null){dependencyGroup=new DependencyGroup(counter);counter+=1;dependencyGroup.add(alignmentGroup.level,topItem);dependencyGroupsByItem[topItem]=dependencyGroup;dependencyGroups.push(dependencyGroup);}dependencyGroup.add(alignmentGroup.level+1,bottomItem);dependencyGroupsByItem[bottomItem]=dependencyGroup;}}// create dependency groups out of all other items
	treeLevels.loopLevels(this,function(levelIndex,level){treeLevels.loopLevelItems(this,levelIndex,function(itemid,item,position){var dependencyGroup=dependencyGroupsByItem[itemid];if(dependencyGroup==null){dependencyGroup=new DependencyGroup(counter);counter+=1;dependencyGroup.add(levelIndex,itemid);dependencyGroupsByItem[itemid]=dependencyGroup;dependencyGroups.push(dependencyGroup);}});});var dependencies=new primitives.common.dependencies();// add horizontal depenedencies
	treeLevels.loopLevels(this,function(levelIndex,level){var previous=null;treeLevels.loopLevelItems(this,levelIndex,function(itemid,item,position){var dependencyGroup=dependencyGroupsByItem[itemid];if(previous!=null){dependencies.add(previous,dependencyGroup.id,new Dependency(null));}previous=dependencyGroup.id;});});//var crossEdges = new primitives.common.graph();
	// add criss cross alignment group dependencies
	for(index=0,len=alignmentGroups.length;index<len;index+=1){alignmentGroup=alignmentGroups[index];alignmentGroup.loopDependencies(function(fromPosition,fromLevel,fromIsMeasured,toPosition,toLevel,toIsMeasured){var fromItem=treeLevels.getItemAtPosition(fromLevel,fromPosition),toItem=treeLevels.getItemAtPosition(toLevel,toPosition),fromGroup=dependencyGroupsByItem[fromItem],toGroup=dependencyGroupsByItem[toItem];dependencies.add(fromGroup.id,toGroup.id,new Dependency(fromIsMeasured?fromItem:toItem));});}var groupOffsets={},rightMargin=0;dependencies.loopTopoForward(this,function(itemid,position){var offset=0;dependencies.loopBackward(this,itemid,function(from,edge){var distanceTo=getDependencyGroupsDistance(dependencyGroups[from],dependencyGroups[itemid],edge.itemToMeasure);offset=Math.max(offset,groupOffsets[from]+distanceTo);});groupOffsets[itemid]=offset;rightMargin=Math.max(rightMargin,offset);});var fixedGroups={},rightItem;for(index=0,len=alignmentGroups.length;index<len;index+=1){alignmentGroup=alignmentGroups[index];rightItem=null;alignmentGroup.getRightPosition(this,function(level,position){var item=treeLevels.getItemAtPosition(level,position);fixedGroups[dependencyGroupsByItem[item].id]=true;});}dependencies.loopTopoBackward(this,function(itemid,position){if(!fixedGroups.hasOwnProperty(itemid)){var offset=null;dependencies.loopForward(this,itemid,function(to,edge){var distanceTo=getDependencyGroupsDistance(dependencyGroups[itemid],dependencyGroups[to],edge.itemToMeasure);if(offset==null){offset=groupOffsets[to]-distanceTo;}else{offset=Math.min(offset,groupOffsets[to]-distanceTo);}});if(offset!=null){groupOffsets[itemid]=offset;}}});var groupOffsets2={};dependencies.loopTopoBackward(this,function(itemid,position){var offset=rightMargin;dependencies.loopForward(this,itemid,function(to,edge){var distanceTo=getDependencyGroupsDistance(dependencyGroups[itemid],dependencyGroups[to],edge.itemToMeasure);offset=Math.min(offset,groupOffsets[to]-distanceTo);});groupOffsets2[itemid]=offset;});var fixedGroups2={};for(index=0,len=alignmentGroups.length;index<len;index+=1){alignmentGroup=alignmentGroups[index];alignmentGroup.getLeftPosition(this,function(level,position){var item=treeLevels.getItemAtPosition(level,position);fixedGroups2[dependencyGroupsByItem[item].id]=true;});}dependencies.loopTopoForward(this,function(itemid,position){if(!fixedGroups2.hasOwnProperty(itemid)){position=null;dependencies.loopBackward(this,itemid,function(from,edge){var distanceTo=getDependencyGroupsDistance(dependencyGroups[from],dependencyGroups[itemid],edge.itemToMeasure);if(position==null){position=groupOffsets2[from]+distanceTo;}else{position=Math.max(position,groupOffsets2[from]+distanceTo);}});if(position!=null){groupOffsets2[itemid]=position;}}});var distancesReverted={};for(var itemid in groupOffsets){if(groupOffsets.hasOwnProperty(itemid)){groupOffsets[itemid]=(groupOffsets[itemid]+groupOffsets2[itemid])/2.0;}}// fix left margin to 0
	var correction=null;dependencies.loopTopoForward(this,function(groupid,position,layer){var dependencyGroup=dependencyGroups[groupid],groupOffset=groupOffsets[groupid];if(layer==0){dependencyGroup.loop(this,function(itemid){var treeItemPosition=_data.treeItemsPositions[itemid],treeItemVisibility=treeItemPosition.actualVisibility,treeItemPadding=intervalsTask.getInterval(treeItemVisibility)/2.0,itemOffset=groupOffset-treeItemPosition.actualSize.width/2;correction=correction==null?itemOffset:Math.min(itemOffset,correction);});}else{return true;}});correction=correction||0;// offset items inside of dependency groups
	var groupOffset;for(var groupIndex=0,groupLen=dependencyGroups.length;groupIndex<groupLen;groupIndex+=1){dependencyGroup=dependencyGroups[groupIndex];groupOffset=groupOffsets[dependencyGroup.id]||0;dependencyGroup.loop(this,function(itemid){var treeItemPosition=_data.treeItemsPositions[itemid],treeItemVisibility=treeItemPosition.actualVisibility,treeItemPadding=intervalsTask.getInterval(treeItemVisibility)/2.0;treeItemPosition.leftPadding=treeItemPadding;treeItemPosition.rightPadding=treeItemPadding;treeItemPosition.offset=groupOffset-treeItemPosition.actualSize.width/2-correction;});}}function AlignmentGroup(level,id){this.id=id;this.level=level;this.topLeft=null;this.topRight=null;this.bottomLeft=null;this.bottomRight=null;this.topItems={};this.bottomItems={};this.addTop=function(position){this.topItems[position]=true;if(this.topLeft==null){this.topLeft=position;this.topRight=position;}else{this.topLeft=Math.min(this.topLeft,position);this.topRight=Math.max(this.topRight,position);}};this.addBottom=function(position){this.bottomItems[position]=true;if(this.bottomLeft==null){this.bottomLeft=position;this.bottomRight=position;}else{this.bottomLeft=Math.min(this.bottomLeft,position);this.bottomRight=Math.max(this.bottomRight,position);}};this.topMiddle=function(){var result=null;if(this.topLeft==this.topRight){result=this.topLeft;}else if((this.topRight-this.topLeft)%2===0){result=(this.topRight+this.topLeft)/2;while(!this.topItems.hasOwnProperty(result)){result+=1;}}return result;};this.bottomMiddle=function(){var result=null;if(this.bottomLeft==this.bottomRight){result=this.bottomLeft;}else if((this.bottomRight-this.bottomLeft)%2===0){result=(this.bottomRight+this.bottomLeft)/2;while(!this.bottomItems.hasOwnProperty(result)){result+=1;}}return result;};this.loopDependencies=function(onDependency){// onDependency = function(from, to)
	var topMiddle=this.topMiddle();var bottomMiddle=this.bottomMiddle();if(topMiddle==null){var topLeft=Math.floor((this.topRight+this.topLeft)/2.0);var topRight=Math.ceil((this.topRight+this.topLeft)/2.0);onDependency(topLeft,this.level,true,bottomMiddle,this.level+1,false);onDependency(bottomMiddle,this.level+1,false,topRight,this.level,true);}else if(bottomMiddle==null){var bottomLeft=Math.floor((this.bottomRight+this.bottomLeft)/2.0);var bottomRight=Math.ceil((this.bottomRight+this.bottomLeft)/2.0);onDependency(bottomLeft,this.level+1,true,topMiddle,this.level,false);onDependency(topMiddle,this.level,false,bottomRight,this.level+1,true);}};this.loopPositions=function(onPosition){// onPosition = function(position, level)
	var position;for(position=this.topLeft;position<=this.topRight;position+=1){onPosition(position,this.level);}for(position=this.bottomLeft;position<=this.bottomRight;position+=1){onPosition(position,this.level+1);}};this.getLeftPosition=function(thisArg,onPosition){// onPosition = function(level, position)
	if(this.topLeft!=this.topRight){onPosition.call(thisArg,this.level,this.topLeft);}else if(this.bottomLeft!=this.bottomRight){onPosition.call(thisArg,this.level+1,this.bottomLeft);}};this.getRightPosition=function(thisArg,onPosition){// onPosition = function(level, position)
	if(this.topLeft!=this.topRight){onPosition.call(thisArg,this.level,this.topRight);}else if(this.bottomLeft!=this.bottomRight){onPosition.call(thisArg,this.level+1,this.bottomRight);}};}function DependencyGroup(id){this.id=id;this.items={};// items[levelIndex] = itemId;
	this.minimum=null;this.maximum=null;this.add=function(levelIndex,itemid){this.items[levelIndex]=itemid;this.minimum=this.minimum!=null?Math.min(this.minimum,levelIndex):levelIndex;this.maximum=this.maximum!=null?Math.max(this.maximum,levelIndex):levelIndex;};this.loop=function(thisArg,onItem){// onItem = function(itemid) {}
	var items=this.items;for(var levelIndex=this.minimum;levelIndex<=this.maximum;levelIndex+=1){onItem.call(thisArg,items[levelIndex],levelIndex);}};}function Distances(source,offset){this.offset=0;this.items={};// items[itemid] = { fromid: distance, fromid2: distance2 }
	if(source!=null){this.items=source.items;// share items collection
	this.offset=source.offset+offset;}this.merge=function(source,offset){var items=source.items,sourceOffset=source.offset+offset;for(var itemid in items){if(items.hasOwnProperty(itemid)){this.items[itemid]=Math.max(this.items[itemid]||0,items[itemid]+sourceOffset);}}};this.loop=function(thisArg,onItem){// onItem = function(itemid, distance) {}
	var items=this.items;for(var itemid in items){if(items.hasOwnProperty(itemid)){onItem.call(thisArg,itemid,items[itemid]+this.offset);}}};}function Dependency(item){this.itemToMeasure=item;}function getDependencyGroupsDistance(item1,item2,edgeItem){var result=0;if(edgeItem==null){var minimum=Math.max(item1.minimum,item2.minimum),maximum=Math.min(item1.maximum,item2.maximum);for(var level=minimum;level<=maximum;level+=1){result=Math.max(result,getItemsDistance(item1.items[level],item2.items[level]));}}else{result=getItemsDistance(edgeItem,null);}return result;}function getItemsDistance(itemid1,itemid2){var result=0;if(itemid1!=null){var treeItemPosition1=_data.treeItemsPositions[itemid1],treeItemVisibility1=treeItemPosition1.actualVisibility,treeItemPadding1=intervalsTask.getInterval(treeItemVisibility1)/2.0,treeItemSize1=treeItemPosition1.actualSize.width;result+=treeItemSize1/2.0+treeItemPadding1;}if(itemid2!=null){var treeItemPosition2=_data.treeItemsPositions[itemid2],treeItemVisibility2=treeItemPosition2.actualVisibility,treeItemPadding2=intervalsTask.getInterval(treeItemVisibility2)/2.0,treeItemSize2=treeItemPosition2.actualSize.width;result+=treeItemSize2/2.0+treeItemPadding2;}return result;}function recalcItemsPositions(){_treeLevels.loopLevels(this,function(levelIndex,treeLevel){var treeLevelPosition=_data.treeLevelsPositions[levelIndex];_treeLevels.loopLevelItems(this,levelIndex,function(itemid,treeItem,position){var treeItemPosition=_data.treeItemsPositions[itemid];treeItemPosition.setPosition(treeLevelPosition,_itemsSizesOptions,_orientationOptions);});});}function getTreeLevelsPositions(){return _data.treeLevelsPositions;}function getItemPosition(itemid){return _data.treeItemsPositions[itemid];}function getItemsPositions(){return _data.treeItemsPositions;}function getContentSize(){return _data.panelSize;}return{process:process,getTreeLevelsPositions:getTreeLevelsPositions,getItemsPositions:getItemsPositions,getItemPosition:getItemPosition,getContentSize:getContentSize};};/* /Controls/FamDiagram/Tasks/Transformations/LevelsTask.js*//*  This task transforms normolized logical family into levels of nodes. Every node is connected only to parents and children located at neighbouring levels.
		This task is responsible to place nodes at levels in the most optimial way in terms of visualization. It is responsible to place parents close to its children and vise versa.
		It is responsible to minimize number of connectors intersections in graph.
	
		The current approach to optimize items placement is to transform family into hierarchy of nodes and order
		nodes children in the way minimizing number of intersections between connection lines.
		1. Extract families into _families array of type FamilyItem. Family is sub tree of items _logicalFamily.
			In order to extract families out of _logicalFamily we count from bottom to roots total number of descendants for eevry item and then extract
			sub hierarchy having minimum number of members. This process is repeated till all nodes are extracted into separate families.
				_orgPartners - When we extract families we store links to parents in other branches having the same children of
				some already extracted item as partner in _orgPartners hash
			This hash table is used to create links collections between families
			The _orgTree collection is used to define final org hierarchy used to balance nodes in levels.
		2. Use links in families to build family graph
		3. Find maximum spanning tree of family graph
		4. Since spanning tree is the tree we calculate number of descendants in every branch. So when we join families into one
			org chart we sort them taking first child family having maximum number of links to its parent family
			sortedFamilies collection
		5. Using sortedFamilies collection we merge roots of families back to primary org chart. The rule of that backword merging is
			to find ancestor in target tree having level less then root item of merged family.
			this is done without extra collection creation via making changes in
				_orgTree
			If family has no links it is added to root of _orgTree
		6. Balance organizational chart in order to place items having extra connections close to each other.
			Assign every extra link to every pair of parent nodes up to the root.
		7. Scan _orgTree hierarchy from root to bottom and balance children using extra links collected from children
			So at the top most level we know number of links between children, so we sort them, then number of overlappings between branches should be minimal
			Balancing algorithms finds maximum spanning tree in connections between children and groups them from bottom of that tree up to the root
			In the way when groups having maximum mutual links placed close to each other.
	*/primitives.famdiagram.LevelsTask=function(normalizeLogicalFamilyTask,defaultItemConfig,itemTemplateParamsTask){var _data={maximumId:null,/* maximum of OrgItem.id */treeLevels:null,/* primitives.common.TreeLevels */activeTreeLevels:null,/* primitives.common.TreeLevels */bundles:null,/* array of primitives.orgdiagram.ConnectorBundle objects */connectorStacks:null/* array of primitives.orgdiagram.TreeLevelConnectorStackSize objects,
				it keeps total number of horizontal connectors lines between parents and children stack on top of each other */},_orgTree,/*tree primitives.orgdiagram.OrgItem */_orgPartners,/* Creates extra partners collection of relations between visual tree items
				They are used to draw connectors between items in different branches of organizational chart*/_itemByChildrenKey={},_minimumLevel,_maximumLevel,_properties=['title','description','image','itemTitleColor','groupTitle','groupTitleColor','isActive','hasSelectorCheckbox','hasButtons','templateName','showCallout','calloutTemplateName','label','showLabel','labelSize','labelOrientation','labelPlacement','minimizedItemShapeType'],_nullTreeLevelConnectorStackSize=new primitives.orgdiagram.TreeLevelConnectorStackSize();function process(){var logicalFamily=normalizeLogicalFamilyTask.getLogicalFamily();logicalFamily=logicalFamily.clone();_orgTree=primitives.common.tree();_data.maximumId=normalizeLogicalFamilyTask.getMaximumId();_orgPartners={};_itemByChildrenKey={};_minimumLevel=null;_maximumLevel=null;createOrgTree(logicalFamily);_data.treeLevels=primitives.common.TreeLevels();_data.activeTreeLevels=primitives.common.TreeLevels();_orgTree.loopLevels(this,function(treeItemId,treeItem,levelIndex){var templateParams=itemTemplateParamsTask.getTemplateParams(treeItemId);_data.treeLevels.addItem(levelIndex,treeItemId,treeItem);if(templateParams!=null&&templateParams.isActive&&treeItem.isVisible){_data.activeTreeLevels.addItem(levelIndex,treeItemId,treeItem);}});_data.bundles=[];_data.connectorStacks=[];recalcLevelsDepth(_data.bundles,_data.connectorStacks,_data.treeLevels,_orgTree,_orgPartners);return true;}function createOrgTree(logicalFamily){var index,len,index2,len2,famItem,familiesGraph,/* primitives.common.graph */link,links,fromFamily,toFamily,sortedFamilies=[],sortedFamiliesHash,attachedFamilies,userItem,familyId,family,familyRootItem,fromItem,toItem,rootItem,rootItems,bestRootItem,bestReference,spanningTree,extraGravities,grandChildren,parsedId,itemsHavingSpouses,spouses,orgItemRoot,famItemsExtracted,families=[],families2;if(logicalFamily.hasNodes()>0){/* create hash of extracted family items */famItemsExtracted={};familyId=0;families2=[];logicalFamily.loopRoots(this,function(grandParentId,grandParent){//ignore jslint
	family=new primitives.famdiagram.Family(familyId);/* _extractOrgChart method extracts hiearchy of family members starting from grandParent and takes only non extracted family items
					 * For every extracted item it assigns its familyId, it is used for building families relations graph and finding cross family links
					*/extractOrgChart(grandParentId,logicalFamily,famItemsExtracted,family);families.push(family);families2.push(family);familyId+=1;});families2.sort(function(a,b){/* sort families by root item level ASC and size DESC */var aLevel=a.items[0].level,bLevel=b.items[0].level;return aLevel!=bLevel?aLevel-bLevel:b.items.length-a.items.length;});sortedFamilies=[];sortedFamiliesHash={};if(families.length>0){/* Build families graph */familiesGraph=primitives.common.graph();for(index=0,len=families.length;index<len;index+=1){family=families[index];for(index2=0,len2=family.links.length;index2<len2;index2+=1){link=family.links[index2];fromFamily=logicalFamily.node(link.fromItem).familyId;toFamily=logicalFamily.node(link.toItem).familyId;if(fromFamily!=toFamily){familiesGraph.addEdge(fromFamily,toFamily,{weight:0});familiesGraph.edge(fromFamily,toFamily).weight+=1;}families[toFamily].backLinks.push(new primitives.famdiagram.FamLink(link.toItem,link.fromItem));}}/* Flatten families graph into array for merging */while(sortedFamilies.length<families.length){for(index=0,len=families2.length;index<len;index+=1){family=families2[index];if(!sortedFamiliesHash.hasOwnProperty(family.id)){/* find maximum spanning tree of families graph*/spanningTree=familiesGraph.getSpanningTree(family.id,function(edge){return-edge.weight;});//ignore jslint
	if(spanningTree.node(family.id)!=null){/* count number of sub families for every family in spanning tree and sorts child families desc*/spanningTree.loopPostOrder(this,function(nodeid,node,parentid,parent){var family=families[nodeid],parentFamily=families[parentid],children=[];if(parentid!=null){parentFamily.familyPriority=parentFamily.familyPriority+family.familyPriority;}children=[];spanningTree.loopChildren(this,nodeid,function(childid,child,index){children.push(childid);});children.sort(function(a,b){return families[a].familyPriority-families[b].familyPriority;});spanningTree.arrangeChildren(nodeid,children);});//ignore jslint
	/* merge tree items in pre order sequence */spanningTree.loopPreOrder(this,function(familyid,node){sortedFamilies.push(familyid);sortedFamiliesHash[familyid]=true;});//ignore jslint
	}else{/* family has no links to any other family so we add it as orphant */sortedFamilies.push(family.id);sortedFamiliesHash[family.id]=true;}}}}}/* create chart root */_data.maximumId+=1;orgItemRoot=createOrgItem(_data.maximumId,null/*parent id*/,null,_minimumLevel-1,null/* userItem */);orgItemRoot.hideParentConnection=true;orgItemRoot.hideChildrenConnection=true;orgItemRoot.title="internal root";orgItemRoot.isVisible=false;orgItemRoot.isActive=false;orgItemRoot.childIndex=0;/* Place family roots to organizational chart */attachedFamilies={};for(index=0,len=sortedFamilies.length;index<len;index+=1){family=families[sortedFamilies[index]];rootItems={};// Hash where key = rootItem.id and value is number of references
	bestRootItem=orgItemRoot;bestReference=0;links=family.links.concat(family.backLinks);for(index2=0;index2<links.length;index2+=1){link=links[index2];toItem=_orgTree.node(link.toItem);fromItem=_orgTree.node(link.fromItem);if(attachedFamilies[toItem.familyId]===true){familyRootItem=family.items[0];rootItem=toItem;if(rootItem.level>=familyRootItem.level){_orgTree.loopParents(this,rootItem.id,function(nodeid,node){rootItem=node;if(node.level<familyRootItem.level){return true;}});//ignore jslint
	}if(rootItems.hasOwnProperty(rootItem.id)){rootItems[rootItem.id]+=1;}else{rootItems[rootItem.id]=1;}/* family may be nested to multiple places, so we select root item having maximum connections with our new sub family */if(bestReference<rootItems[rootItem.id]){bestRootItem=rootItem;bestReference=rootItems[rootItem.id];}}}attachFamilyToOrgChart(bestRootItem,family);attachedFamilies[family.id]=true;}/* balance organizational chart in order to place items having extra connections close to each other */extraGravities=getExtraGravity();/* count number of vertical connections for every item */grandChildren=getGrandChildren();/* scan _orgTree hierarchy from root to bottom and balance its children */balanceOrgTree(_orgTree,extraGravities,grandChildren);}}function getGrandChildren(){var result={};/* Key = primitives.orgdiagram.OrgItem.id, Value= Hash {} having Key = level and Value = number of grand children*/_orgTree.loopPostOrder(this,function(itemId,orgItem,parentId,parent){var level;_minimumLevel=_minimumLevel!=null?Math.min(_minimumLevel,orgItem.level):orgItem.level;_maximumLevel=_maximumLevel!=null?Math.max(_maximumLevel,orgItem.level):orgItem.level;if(parentId!=null){if(!result[parentId]){result[parentId]={};}level=orgItem.level-1;/* project children qty to parent level, it is needed to match cross hierarchy connectors levels*/if(!result[parentId][level]){result[parentId][level]=1;}else{result[parentId][level]+=1;}if(result[itemId]!=null){for(level in result[itemId]){if(result[itemId].hasOwnProperty(level)){if(!result[parentId][level]){result[parentId][level]=result[itemId][level];}else{result[parentId][level]+=result[itemId][level];}}}}}});return result;}function balanceOrgTree(orgTree,extraGravities,grandChildren){var index2,len2,index3,len3,extraGravity,childExtraGravities,sortedChildren,subChildren,subOrgItem,leftId='__left__',rightId='__right__',levelExtraGravities,sequence;orgTree.loopLevels(this,function(parentOrgItemId,parentOrgItem,levelid){var graph=primitives.common.graph(),graphGravities={},firstOrgItem=null,toItemId;/* build gravities graph for children */sortedChildren=[];orgTree.loopChildren(this,parentOrgItem.id,function(childOrgItemId,childOrgItem,index){var levelKey;if(firstOrgItem==null){firstOrgItem=childOrgItem;}graphGravities[childOrgItem.id]={};if(extraGravities.hasOwnProperty(childOrgItem.id)){childExtraGravities=extraGravities[childOrgItem.id];for(levelKey in childExtraGravities){if(childExtraGravities.hasOwnProperty(levelKey)){levelExtraGravities=childExtraGravities[levelKey];graphGravities[childOrgItem.id][levelKey]={};for(index2=0,len2=levelExtraGravities.length;index2<len2;index2+=1){extraGravity=levelExtraGravities[index2];if(extraGravity.commonParent==parentOrgItem.id){/* this is link between two children */toItemId=extraGravity.toParent;}else{/* this is external link on left or on right side, we create virtual graph item ids for external links */if(orgTree.node(extraGravity.fromParent).childIndex<orgTree.node(extraGravity.toParent).childIndex){toItemId=rightId;}else{toItemId=leftId;}}/* add connection to graph */if(childOrgItem.id!=toItemId){graph.addEdge(childOrgItem.id,toItemId,{weight:0});graph.edge(childOrgItem.id,toItemId).weight+=1.0;if(graphGravities[childOrgItem.id][levelKey][toItemId]==null){graphGravities[childOrgItem.id][levelKey][toItemId]=0;}graphGravities[childOrgItem.id][levelKey][toItemId]+=1;}}}}}/* add extra zero connection to graph when child org item has no connections
						it is connected to the first item in the graph with zero link
					*/if(index>0){graph.addEdge(childOrgItem.id,firstOrgItem.id,{weight:0});}});if(firstOrgItem!=null){/* sort items in graph from the most connected to the least */sequence=graph.getGrowthSequence(function(a){return a.weight;});//ignore jslint
	if(sequence.length===0){sequence=[firstOrgItem.id];}/* sort children from top to down */subChildren=balanceItems(sequence,leftId,rightId,graphGravities,grandChildren);/* save items indexes for further use */for(index3=0,len3=subChildren.length;index3<len3;index3+=1){subOrgItem=orgTree.node(subChildren[index3]);subOrgItem.childIndex=index3;sortedChildren.push(subOrgItem.id);}}orgTree.arrangeChildren(parentOrgItem.id,sortedChildren);});}function balanceItems(sequence,leftId,rightId,graphGravities,grandChildren){var result=[],index,slots,position,itemid,bestSlot,bestSlotValue,bestSlotDistance,bestSlotBalance,bestSlotCrossings,slotValue,slotDistance,slotBalance,slotCrossings,itemGrandChildren,cloneSlot,itemSlot,level,levelGravities,toItemId,toItemSlot;slots=new primitives.famdiagram.Slots();slots.add(new primitives.famdiagram.Slot(leftId));slots.add(new primitives.famdiagram.Slot(null));/* first empty slot */slots.add(new primitives.famdiagram.Slot(rightId));/* set initital positions */position=0;slots.loop(function(slot){position+=1;slot.position=position;});for(index=0;index<sequence.length;index+=1){itemid=sequence[index];/* ignore left and right margin */if(itemid!=leftId&&itemid!=rightId){bestSlot=null;bestSlotValue=null;bestSlotDistance=null;bestSlotBalance=null;bestSlotCrossings=null;slots.loop(function(slot){var level,toItemId,levelGravities,toItemSlot;if(slot.itemId==null){itemGrandChildren=grandChildren[itemid];slotValue=0;slotDistance=0;slotBalance=0;slotCrossings=0;for(level in slot.crossings){if(slot.crossings.hasOwnProperty(level)){if(itemGrandChildren&&itemGrandChildren[level]!=null){slotValue+=slot.crossings[level]*itemGrandChildren[level];}slotCrossings+=slot.crossings[level];}}for(level in graphGravities[itemid]){if(graphGravities[itemid].hasOwnProperty(level)){levelGravities=graphGravities[itemid][level];for(toItemId in levelGravities){if(levelGravities.hasOwnProperty(toItemId)){toItemSlot=slots.getSlot(toItemId);if(toItemSlot!=null){if(toItemSlot.position<slot.position){/* on the left side */slotValue+=(slot.left[level]||0.0)-(toItemSlot.left[level]||0.0);slotBalance+=Math.abs(toItemSlot.balance+1);}else{/* on the right side */slotValue+=(slot.right[level]||0.0)-(toItemSlot.right[level]||0.0);slotBalance+=Math.abs(toItemSlot.balance-1);}slotDistance+=Math.abs(toItemSlot.position-slot.position);}}}}}if(bestSlotValue==null||bestSlotValue>slotValue||bestSlotValue==slotValue&&(bestSlotDistance>slotDistance||bestSlotDistance==slotDistance&&(bestSlotBalance>slotBalance||bestSlotBalance==slotBalance&&bestSlotCrossings>slotCrossings))){bestSlotValue=slotValue;bestSlot=slot;bestSlotDistance=slotDistance;bestSlotBalance=slotBalance;bestSlotCrossings=slotCrossings;}}});//ignore jslint
	/* insert item into found slot*/cloneSlot=bestSlot.clone();itemSlot=bestSlot.clone();itemSlot.itemId=itemid;slots.insertBefore(bestSlot,cloneSlot);slots.insertBefore(bestSlot,itemSlot);/* add new item grand children qty to all slots to their grand totals for right & left sides */itemSlot.position=0;position=0;slots.loop(function(slot){var level,itemGrandChildren;if(slot.id!=itemSlot.id){itemGrandChildren=grandChildren[itemid];for(level in itemGrandChildren){if(itemGrandChildren.hasOwnProperty(level)){if(!slot.left[level]){slot.left[level]=itemGrandChildren[level];}else{slot.left[level]+=itemGrandChildren[level];}}}position+=1;slot.position=position;}},itemSlot);//ignore jslint
	position=0;slots.backwardLoop(function(slot){var level,itemGrandChildren;if(slot.id!=itemSlot.id){itemGrandChildren=grandChildren[itemid];for(level in grandChildren[itemid]){if(grandChildren[itemid].hasOwnProperty(level)){if(!slot.right[level]){slot.right[level]=itemGrandChildren[level];}else{slot.right[level]+=itemGrandChildren[level];}}}position-=1;slot.position=position;}},itemSlot);//ignore jslint
	/* add crossings */for(level in graphGravities[itemid]){if(graphGravities[itemid].hasOwnProperty(level)){levelGravities=graphGravities[itemid][level];for(toItemId in levelGravities){if(levelGravities.hasOwnProperty(toItemId)){toItemSlot=slots.getSlot(toItemId);if(toItemSlot!=null){if(toItemSlot.position<0){/* on the left side */toItemSlot.balance+=1;itemSlot.balance-=1;slots.backwardLoop(function(slot){if(slot.id!=itemSlot.id){if(slot.id!=toItemSlot.id){if(!slot.crossings[level]){slot.crossings[level]=levelGravities[toItemId];}else{slot.crossings[level]+=levelGravities[toItemId];}}else{return true;}}},itemSlot);//ignore jslint
	}else{/* on the right side */toItemSlot.balance-=1;itemSlot.balance+=1;slots.loop(function(slot){if(slot.id!=itemSlot.id){if(slot.id!=toItemSlot.id){if(!slot.crossings[level]){slot.crossings[level]=levelGravities[toItemId];}else{slot.crossings[level]+=levelGravities[toItemId];}}else{return true;}}},itemSlot);//ignore jslint
	}}}}}}}}slots.loop(function(slot){var itemId=slot.itemId;if(itemId!=null&&itemId!=leftId&&itemId!=rightId){result.push(itemId);}});return result;}function getExtraGravity(){var orgItemId,orgItem,result={},/* Key = primitives.orgdiagram.OrgItem.id, Value= Hash {} having Key = level and Value = [] array of primitives.famdiagram.ExtraGravity objects*/index,len,extraPartners,extraPartner;/* collect gravities for extra partners */for(orgItemId in _orgPartners){if(_orgPartners.hasOwnProperty(orgItemId)){orgItem=_orgTree.node(orgItemId);extraPartners=_orgPartners[orgItemId];for(index=0,len=extraPartners.length;index<len;index+=1){extraPartner=_orgTree.node(extraPartners[index]);addExtraGravitiesForConnection(result,extraPartner,orgItem);}}}return result;}function addExtraGravitiesForConnection(extraGravities,fromItem,toItem){var extraGravityFrom=new primitives.famdiagram.ExtraGravity(fromItem.level),extraGravityTo=new primitives.famdiagram.ExtraGravity(toItem.level);/* find common parent for evry child and orgItem and create connector for evey parent in selection path */_orgTree.zipUp(this,fromItem.id,toItem.id,function(fromItemId,parentFromItemId,toItemId,parentToItemId){/* all parent items in chain up to the common root share the same gravity object for one connector */addExtraGravityForItem(extraGravities,fromItemId,extraGravityFrom);addExtraGravityForItem(extraGravities,toItemId,extraGravityTo);/* initialize gravity objects */if(parentFromItemId==parentToItemId){extraGravityFrom.commonParent=parentFromItemId;extraGravityFrom.fromParent=fromItemId;extraGravityFrom.toParent=toItemId;extraGravityTo.commonParent=parentFromItemId;extraGravityTo.fromParent=toItemId;extraGravityTo.toParent=fromItemId;return true;}});}function addExtraGravityForItem(extraGravities,id,extraGravity){if(!extraGravities.hasOwnProperty(id)){extraGravities[id]={};}if(extraGravities[id][extraGravity.level]==null){extraGravities[id][extraGravity.level]=[];}extraGravities[id][extraGravity.level].push(extraGravity);}function attachFamilyToOrgChart(parent,family){var levelIndex,familyRoot=family.items[0],newOrgItem=null,rootItem=parent;// fill in levels between parent and family root with invisible items
	for(levelIndex=parent.level+1;levelIndex<familyRoot.level;levelIndex+=1){_data.maximumId+=1;newOrgItem=createOrgItem(_data.maximumId,rootItem.id,null,levelIndex,null/* userItem */);newOrgItem.title="shift";newOrgItem.isVisible=false;newOrgItem.isActive=false;newOrgItem.hideParentConnection=true;newOrgItem.hideChildrenConnection=true;family.items.push(newOrgItem);rootItem=newOrgItem;}// attach family root
	familyRoot.hideParentConnection=true;_orgTree.adopt(rootItem.id,familyRoot.id,familyRoot);}function extractOrgChart(grandParentId,logicalFamily,famItemsExtracted,family){var index,len,children=[],tempChildren,childItem,rootItem=null,newOrgItem,grandParent=logicalFamily.node(grandParentId);/* extract root item */newOrgItem=createOrgItem(grandParent.id,rootItem,family.id,grandParent.level,grandParent.itemConfig);newOrgItem.hideParentConnection=true;newOrgItem.isVisible=grandParent.isVisible;newOrgItem.isActive=grandParent.isActive;newOrgItem.hideParentConnection=grandParent.hideParentConnection;newOrgItem.hideChildrenConnection=grandParent.hideChildrenConnection;family.items.push(newOrgItem);famItemsExtracted[grandParent.id]=true;grandParent.familyId=family.id;/* extract its children */children=extractChildren(grandParent,logicalFamily,famItemsExtracted,family);while(children.length>0){tempChildren=[];for(index=0,len=children.length;index<len;index+=1){childItem=children[index];tempChildren=tempChildren.concat(extractChildren(childItem,logicalFamily,famItemsExtracted,family));}children=tempChildren;}}function extractChildren(parentItem,logicalFamily,famItemsExtracted,family){var result=[],firstChild=null,partnerItem=null,newOrgItem;if(logicalFamily.countChildren(parentItem.id)==1){firstChild=logicalFamily.firstChild(parentItem.id);}if(_itemByChildrenKey[firstChild]!=null){/* all children already extracted */partnerItem=_itemByChildrenKey[firstChild];if(_orgPartners[partnerItem.id]==null){_orgPartners[partnerItem.id]=[];}_orgPartners[partnerItem.id].push(parentItem.id);family.links.push(new primitives.famdiagram.FamLink(parentItem.id,firstChild));}else{if(firstChild!=null){_itemByChildrenKey[firstChild]=parentItem;}logicalFamily.loopChildren(this,parentItem.id,function(childid,childItem,levelIndex){if(famItemsExtracted[childItem.id]){throw"Many to many relations should not exist at this stage";}result.push(childItem);newOrgItem=createOrgItem(childItem.id,parentItem.id,family.id,childItem.level,childItem.itemConfig);newOrgItem.hideParentConnection=childItem.hideParentConnection;newOrgItem.hideChildrenConnection=childItem.hideChildrenConnection;newOrgItem.isVisible=childItem.isVisible;newOrgItem.isActive=childItem.isActive;family.items.push(newOrgItem);famItemsExtracted[childItem.id]=true;childItem.familyId=family.id;return logicalFamily.SKIP;});}return result;}function createOrgItem(id,parentId,familyId,level,userItem){var orgItem=new primitives.orgdiagram.OrgItem({}),index,len,property;// OrgItem id coinsides with ItemConfig id since we don't add any new org items to user's org chart definition
	orgItem.id=id;orgItem.familyId=familyId;orgItem.level=level;for(index=0,len=_properties.length;index<len;index+=1){property=_properties[index];orgItem[property]=userItem!=null&&userItem[property]!==undefined?userItem[property]:defaultItemConfig[property];}_orgTree.add(parentId,orgItem.id,orgItem);return orgItem;}function recalcLevelsDepth(bundles,connectorStacks,treeLevels,orgTree,orgPartners){var index,len,index2,len2,index3,len3,itemPosition,bundle,bundlesToStack,processed={},startIndex,endIndex,stackSegments;treeLevels.loopLevels(this,function(levelIndex,treeLevel){var stacksSizes=new primitives.orgdiagram.TreeLevelConnectorStackSize();connectorStacks[levelIndex]=stacksSizes;bundlesToStack=[];treeLevels.loopLevelItems(this,levelIndex,function(itemid,treeItem,position){var fromItems=[],toItems=[],partners;if(!processed.hasOwnProperty(itemid)){processed[itemid]=true;if(!treeItem.hideChildrenConnection){fromItems.push(itemid);}partners=orgPartners[itemid];if(partners!=null){for(index=0,len=partners.length;index<len;index+=1){var partner=partners[index];processed[partner]=true;fromItems.push(partner);}}orgTree.loopChildren(this,itemid,function(childid,child,index){if(!child.hideParentConnection){toItems.push(childid);}});//ignore jslint
	if(fromItems.length>1||toItems.length>0){/* if bundle has more than one parent without children we draw connection line between parents *//* if bundles has no parents, but has children we draw connectors between children, top loop */bundle=new primitives.orgdiagram.ConnectorBundle();bundle.fromLevel=levelIndex;bundle.fromItems=fromItems;bundle.toItems=toItems;bundles.push(bundle);if(fromItems.length>1){bundlesToStack.push(bundle);}}}});if(bundlesToStack.length>0){/* find minimum and maximum partner index at level */stackSegments=primitives.common.pile();for(index2=0,len2=bundlesToStack.length;index2<len2;index2+=1){bundle=bundlesToStack[index2];startIndex=null;endIndex=null;for(index3=0,len3=bundle.fromItems.length;index3<len3;index3+=1){itemPosition=treeLevels.getItemPosition(bundle.fromItems[index3]);startIndex=startIndex!=null?Math.min(startIndex,itemPosition):itemPosition;endIndex=endIndex!=null?Math.max(endIndex,itemPosition):itemPosition;}stackSegments.add(startIndex,endIndex,bundle);}stacksSizes.parentsStackSize=stackSegments.resolve(this,function(from,to,bundle,offset){bundle.fromOffset=offset+1;});//ignore jslint
	}});}function getMaximumId(){return _data.maximumId;}function getTreeLevels(){return _data.treeLevels;}function getActiveTreeLevels(){return _data.activeTreeLevels;}function getBundles(){return _data.bundles;}function getConnectorsStacksSizes(levelid){return _data.connectorStacks[levelid]||_nullTreeLevelConnectorStackSize;}return{process:process,getMaximumId:getMaximumId,getTreeLevels:getTreeLevels,getActiveTreeLevels:getActiveTreeLevels,getBundles:getBundles,getConnectorsStacksSizes:getConnectorsStacksSizes};};/* /Controls/FamDiagram/Tasks/Transformations/LogicalFamilyTask.js*/primitives.famdiagram.LogicalFamilyTask=function(itemsOptionTask){var _data={logicalFamily:null,maximumId:null};function process(debug){var index,len,itemConfig,famItem,items=itemsOptionTask.getItems(),logicalFamily=primitives.common.family(),/*family contains primitives.famdiagram.ItemConfig */maximumId=0,parsedId;if(items.length>0){for(index=0,len=items.length;index<len;index+=1){itemConfig=items[index];if(itemConfig!=null){famItem=new primitives.famdiagram.FamilyItem({id:itemConfig.id,itemConfig:itemConfig,isActive:itemConfig.isActive});logicalFamily.add(itemConfig.parents,famItem.id,famItem);parsedId=parseInt(itemConfig.id,10);maximumId=Math.max(isNaN(parsedId)?0:parsedId,maximumId);}}}_data.logicalFamily=logicalFamily;_data.maximumId=maximumId;if(debug&&!logicalFamily.validate()){throw"References are broken in family structure!";}return true;}function getLogicalFamily(){return _data.logicalFamily;}function getMaximumId(){return _data.maximumId;}return{process:process,getLogicalFamily:getLogicalFamily,getMaximumId:getMaximumId};};/* /Controls/FamDiagram/Tasks/Transformations/NormalizeLogicalFamilyTask.js*//*	1. Topologically sort _logicalFamily items and assign levels.
		2. Optimize references. Transform M:N relations to M:1:N where it is possible.
		3. Eliminate Many to Many relations. Logical family consists of 1:M and M:1 relations only.
		4. Resort items, so original visible items stay at the same level.
		5. Fill in missed items between levels. So that way we have invisible items between parent/child family items if they have gap between levels.
			Such invisible family items have isVisible option set to false.
	*/primitives.famdiagram.NormalizeLogicalFamilyTask=function(normalizeOptionTask,addSpousesTask){var _data={logicalFamily:null,maximumId:null},_normalizeOptions;function process(debug){var logicalFamily=addSpousesTask.getLogicalFamily(),maximumId=addSpousesTask.getMaximumId();_normalizeOptions=normalizeOptionTask.getOptions();logicalFamily=logicalFamily.clone();maximumId=normalize(logicalFamily,maximumId,debug);_data.logicalFamily=logicalFamily;_data.maximumId=maximumId;if(debug&&!logicalFamily.validate()){throw"References are broken in family structure!";}return true;}function normalize(logicalFamily,maximumId,debug){var index,len,index2,len2,famItem,familiesGraph,/* primitives.common.graph */link,links,fromFamily,toFamily,sortedFamilies=[],sortedFamiliesHash,attachedFamilies,userItem,familyId,family,familyRootItem,fromItem,toItem,rootItem,rootItems,bestRootItem,bestReference,spanningTree,extraGravities,grandChildren,parsedId,itemsHavingSpouses,spouses,orgItemRoot,famItemsExtracted,families2;if(logicalFamily.hasNodes()>0){/* Distribute FamilyItem-s by levels. Item levels aligned to bottom. */logicalFamily.loopLevels(this,_normalizeOptions.groupByType==1/*primitives.common.GroupByType.Parents*/,function(itemid,item,levelIndex){item.level=levelIndex;});/* Optimize family references. Bundle connectors where it is possible */logicalFamily.optimizeReferences(function(){maximumId+=1;return new primitives.famdiagram.FamilyItem({id:maximumId,isVisible:false,isActive:false,itemConfig:{title:"bundle #"+maximumId,description:" This item was created by references optimizer."},levelGravity:2/*primitives.common.GroupByType.Children*/});});//ignore jslint
	if(debug&&!logicalFamily.validate()){throw"References are broken in family structure!";}if(debug&&logicalFamily.hasLoops()){throw"Structure has loops!";}/* eliminate many to many connections in chart, every connection should be ether child or parent relation. */logicalFamily.eliminateManyToMany(function(){maximumId+=1;return new primitives.famdiagram.FamilyItem({id:maximumId,isVisible:false,isActive:false,itemConfig:{title:"dummy #"+maximumId,description:"This is item used to eliminate M:M relations."},levelGravity:2/*primitives.common.GroupByType.Children*/,hideParentConnection:false,hideChildrenConnection:false});}//ignore jslint
	);if(debug&&!logicalFamily.validate()){throw"References are broken in family structure!";}/* enumerate */if(_normalizeOptions.alignBylevels){/* Distribute FamilyItem-s by levels. The original family items visible to user should keep their levels after all transformations */resortItemsBylevels(logicalFamily);}else{logicalFamily.loopLevels(this,_normalizeOptions.groupByType==1/*primitives.common.GroupByType.Parents*/,function(itemid,item,levelIndex){item.level=levelIndex;});}if(debug){validate(logicalFamily,false);}/* Fill in items between parent/child relations having gaps in levels */fillInItems(logicalFamily,function(){var result;maximumId+=1;result=new primitives.famdiagram.FamilyItem({id:maximumId,levelGravity:2/*primitives.common.GroupByType.Children*/,isVisible:false,isActive:false,itemConfig:{title:"extension #"+maximumId,description:"This is item used to fill gaps in levels."}});return result;}//ignore jslint
	);if(debug){validate(logicalFamily,true);}}return maximumId;}function resortItemsBylevels(logicalFamily){var itemsAtLevels=[],minimumLevel=null,maximumLevel=null,currentLevel,index,itemsAtLevel;logicalFamily.loop(this,function(famItemId,famItem){famItem.originalLevel=famItem.level;famItem.level=null;if(famItem.originalLevel!=null){if(!itemsAtLevels[famItem.originalLevel]){itemsAtLevels[famItem.originalLevel]={};}itemsAtLevels[famItem.originalLevel][famItemId]=famItem;minimumLevel=minimumLevel!=null?Math.min(famItem.originalLevel,minimumLevel):famItem.originalLevel;maximumLevel=maximumLevel!=null?Math.max(famItem.originalLevel,maximumLevel):famItem.originalLevel;}});/* assign levels*/for(index=minimumLevel;index<=maximumLevel;index+=1){itemsAtLevel=itemsAtLevels[index];setLevelsForItems(itemsAtLevel,logicalFamily);}logicalFamily.loopTopo(this,function(famItemId,famItem,position){var level;if(famItem.levelGravity==1/*primitives.common.GroupByType.Parents*/){level=null;logicalFamily.loopParents(this,famItemId,function(childItemId,childFamItem,levelIndex){level=level==null?childFamItem.level+1:Math.max(childFamItem.level+1,level);return logicalFamily.SKIP;});//ignore jslint
	famItem.level=!level?famItem.level:level;}});}function setLevelsForItems(items,logicalFamily){var level=0,key,famItem,nextItems;for(key in items){if(items.hasOwnProperty(key)){logicalFamily.loopParents(this,key,function(parentid,parent,levelIndex){level=Math.max(parent.level+1,level);return logicalFamily.SKIP;});//ignore jslint
	}}for(key in items){if(items.hasOwnProperty(key)){famItem=items[key];famItem.level=level;}}while(!primitives.common.isEmptyObject(items)){nextItems={};for(key in items){if(items.hasOwnProperty(key)){famItem=items[key];logicalFamily.loopChildren(this,key,function(childid,child,levelIndex){if(child.originalLevel==null||child.isLevelNeutral){child.level=child.level==null?famItem.level+1:Math.max(child.level,famItem.level+1);nextItems[childid]=child;}return logicalFamily.SKIP;});//ignore jslint
	}}items=nextItems;}}function fillInItems(logicalFamily,createFamItem){var bundleItem;logicalFamily.loop(this,function(famItemId,famItem){var extNeeded=true,itemsToBundle;while(extNeeded){extNeeded=false;/* extend children down */itemsToBundle=[];logicalFamily.loopParents(this,famItemId,function(parentItemId,parentItem,level){if(famItem.level-1>parentItem.level){itemsToBundle.push(parentItemId);}return logicalFamily.SKIP;});//ignore jslint
	if(itemsToBundle.length>1){bundleItem=createFamItem(famItem);bundleItem.level=famItem.level-1;bundleItem.hideParentConnection=false;bundleItem.hideChildrenConnection=false;logicalFamily.bundleParents(famItemId,itemsToBundle,bundleItem.id,bundleItem);extNeeded=true;famItemId=bundleItem.id;famItem=bundleItem;}}});logicalFamily.loop(this,function(famItemId,famItem){var extNeeded=true,itemsToBundle,isSingleExtension=true;while(extNeeded){extNeeded=false;/* extend children down */itemsToBundle=[];logicalFamily.loopChildren(this,famItemId,function(childItemId,childItem,level){if(famItem.level+1<childItem.level){itemsToBundle.push(childItemId);}else{isSingleExtension=false;}return logicalFamily.SKIP;});//ignore jslint
	if(itemsToBundle.length>1){bundleItem=createFamItem(famItem);bundleItem.level=famItem.level+1;if(isSingleExtension){bundleItem.hideParentConnection=false;bundleItem.hideChildrenConnection=false;}logicalFamily.bundleChildren(famItemId,itemsToBundle,bundleItem.id,bundleItem);extNeeded=true;famItemId=bundleItem.id;famItem=bundleItem;}}});logicalFamily.loop(this,function(famItemId,famItem){var extNeeded=true,itemsToBundle;while(extNeeded){extNeeded=false;/* extend children down */itemsToBundle=[];logicalFamily.loopParents(this,famItemId,function(parentItemId,parentItem,level){if(famItem.level-1>parentItem.level){itemsToBundle.push(parentItemId);}return logicalFamily.SKIP;});//ignore jslint
	if(itemsToBundle.length>0){bundleItem=createFamItem(famItem);bundleItem.level=famItem.level-1;bundleItem.hideParentConnection=false;bundleItem.hideChildrenConnection=false;logicalFamily.bundleParents(famItemId,itemsToBundle,bundleItem.id,bundleItem);extNeeded=true;famItemId=bundleItem.id;famItem=bundleItem;}}});}function validate(logicalFamily,strongValidate){/* test consistency of references in family tree */if(!logicalFamily.validate()){throw"Family structure failed to pass validation!";}logicalFamily.loop(this,function(famItemId,famItem){logicalFamily.loopChildren(this,famItemId,function(childid,child,level){if(child.level===null||famItem.level===null||(strongValidate?child.level!=famItem.level+1:child.level<=famItem.level)){throw"Family tree is broken. Children/Parents or levels mismatch!";}return logicalFamily.SKIP;});});}function getLogicalFamily(){return _data.logicalFamily;}function getMaximumId(){return _data.maximumId;}return{process:process,getLogicalFamily:getLogicalFamily,getMaximumId:getMaximumId};};/* /Controls/FamDiagram/Tasks/Transformations/RemoveLoopsTask.js*/primitives.famdiagram.RemoveLoopsTask=function(itemsOptionTask,addLabelAnnotationsTask){var _data={logicalFamily:null,maximumId:null};function process(debug){var logicalFamily=addLabelAnnotationsTask.getNavigationFamily(),maximumId=addLabelAnnotationsTask.getMaximumId(),items=itemsOptionTask.getItems();logicalFamily=logicalFamily.clone();maximumId=removeLoops(items,logicalFamily,maximumId,debug);_data.logicalFamily=logicalFamily;_data.maximumId=maximumId;if(debug&&!logicalFamily.validate()){throw"References are broken in family structure!";}return true;}function removeLoops(items,logicalFamily,maximumId,debug){var tempFamily,fakeChild,fakeParent,index,len,index2,len2,nodesToRemove,parents,userItem;tempFamily=logicalFamily.clone();logicalFamily.loopTopo(this,function(itemid,item,levelIndex){tempFamily.removeNode(itemid);});if(tempFamily.hasNodes()){/* remove parents of the first remaining item in user order*/for(index=0,len=items.length;index<len;index+=1){userItem=items[index];if(tempFamily.node(userItem.id)!=null){parents=[];tempFamily.loopParents(this,userItem.id,function(parentid,parent,level){parents.push(parentid);return tempFamily.SKIP;});//ignore jslint
	for(index2=0,len2=parents.length;index2<len2;index2+=1){/* remove relation in temp structure */tempFamily.removeRelation(parents[index2],userItem.id);/* reverse relation in actual structure*/logicalFamily.removeRelation(parents[index2],userItem.id);}/* create fake parent and child items to loop item to its parent */maximumId+=1;/* add fake parent */fakeParent=new primitives.famdiagram.FamilyItem({id:maximumId,isVisible:false,isActive:true,isLevelNeutral:true,hideParentConnection:true,hideChildrenConnection:true,itemConfig:{title:"fake parent #"+maximumId,description:"This is fake parent item was created by loops reversal."}});logicalFamily.add([],fakeParent.id,fakeParent);logicalFamily.adopt([fakeParent.id],userItem.id);for(index2=0,len2=parents.length;index2<len2;index2+=1){maximumId+=1;/* add fake child */fakeChild=new primitives.famdiagram.FamilyItem({id:maximumId,isVisible:false,isActive:true,isLevelNeutral:true,hideParentConnection:true,hideChildrenConnection:true,itemConfig:{title:"fake child #"+maximumId,description:"This is fake child item was created by loops reversal."}});logicalFamily.add([fakeParent.id,parents[index2]],fakeChild.id,fakeChild);}/* loop is broken, so continue items removable in topological order */nodesToRemove=[];tempFamily.loopTopo(this,function(itemid,item,levelIndex){nodesToRemove.push(itemid);});//ignore jslint
	for(index2=0,len2=nodesToRemove.length;index2<len2;index2+=1){tempFamily.removeNode(nodesToRemove[index2]);}}}}return maximumId;}function getLogicalFamily(){return _data.logicalFamily;}function getMaximumId(){return _data.maximumId;}return{process:process,getLogicalFamily:getLogicalFamily,getMaximumId:getMaximumId};};/* /Controls/FamDiagram/Templates/LabelAnnotationTemplate.js*/primitives.common.LabelAnnotationTemplate=function(){var _template=create(),_hashCode=primitives.common.hashCode(_template);function create(){var template=jQuery('<div class="bp-label-annotation"></div>');template.addClass("bp-item");return template.wrap('<div>').parent().html();}function template(){return _template;}function getHashCode(){return _hashCode;}function render(event,data){var itemConfig=data.context;data.element.text(itemConfig.title);}return{template:template,getHashCode:getHashCode,render:render};};/* /Controls/FamDiagram/Control.js*/primitives.famdiagram.Control=function(element,options){function createTaskManager(getOptions,getGraphics,getLayout){var tasks=new primitives.common.TaskManager();// Dependencies
	tasks.addDependency('options',getOptions);tasks.addDependency('graphics',getGraphics);tasks.addDependency('layout',getLayout);tasks.addDependency('defaultConfig',new primitives.famdiagram.Config());tasks.addDependency('defaultItemConfig',new primitives.famdiagram.ItemConfig());tasks.addDependency('defaultTemplateConfig',new primitives.famdiagram.TemplateConfig());tasks.addDependency('defaultButtonConfig',new primitives.famdiagram.ButtonConfig());tasks.addDependency('defaultPaletteItemConfig',new primitives.famdiagram.PaletteItemConfig());tasks.addDependency('defaultBackgroundAnnotationConfig',new primitives.famdiagram.BackgroundAnnotationConfig());tasks.addDependency('defaultConnectorAnnotationConfig',new primitives.famdiagram.ConnectorAnnotationConfig());tasks.addDependency('defaultHighlightPathAnnotationConfig',new primitives.famdiagram.HighlightPathAnnotationConfig());tasks.addDependency('defaultShapeAnnotationConfig',new primitives.famdiagram.ShapeAnnotationConfig());tasks.addDependency('defaultLabelAnnotationConfig',new primitives.famdiagram.LabelAnnotationConfig());tasks.addDependency('isFamilyChartMode',true);/* in regular org diagram we hide branch if it contains only invisible nodes,
			in the family chart we use invisible items to draw connectors across multiple levels */tasks.addDependency('showElbowDots',true);/* in regular org chart we don;t have situations when connector lines cross, but we have such situations in
			family tree so we need extra visual attribute to distinguish intersections betwen connectors */tasks.addDependency('null',null);tasks.addDependency('foreground',2/*primitives.common.ZOrderType.Foreground*/);tasks.addDependency('background',1/*primitives.common.ZOrderType.Background*/);// Options
	tasks.addTask('OptionsTask',['options'],primitives.famdiagram.OptionsTask,"#000000"/*primitives.common.Colors.Black*/);// Layout
	tasks.addTask('CurrentControlSizeTask',['layout','OptionsTask','ItemsSizesOptionTask'],primitives.orgdiagram.CurrentControlSizeTask,"#000000"/*primitives.common.Colors.Black*/);tasks.addTask('CurrentScrollPositionTask',['layout','OptionsTask'],primitives.orgdiagram.CurrentScrollPositionTask,"#000000"/*primitives.common.Colors.Black*/);tasks.addTask('CalloutOptionTask',['OptionsTask','defaultConfig','defaultItemConfig'],primitives.orgdiagram.CalloutOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ConnectorsOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.ConnectorsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ItemsOptionTask',['OptionsTask','defaultItemConfig'],primitives.famdiagram.ItemsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('SpousesOptionTask',['OptionsTask','defaultItemConfig'],primitives.famdiagram.SpousesOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ItemsSizesOptionTask',['OptionsTask','defaultConfig','defaultItemConfig','defaultButtonConfig'],primitives.orgdiagram.ItemsSizesOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('LabelsOptionTask',['OptionsTask','defaultConfig','defaultItemConfig'],primitives.orgdiagram.LabelsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('PrintPreviewOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.PrintPreviewOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('TemplatesOptionTask',['OptionsTask','defaultConfig','defaultButtonConfig','defaultTemplateConfig'],primitives.orgdiagram.TemplatesOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('OrientationOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.OrientationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('VisualTreeOptionTask',['OptionsTask'],primitives.famdiagram.VisualTreeOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('MinimizedItemsOptionTask',['OptionsTask'],primitives.orgdiagram.MinimizedItemsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('NormalizeOptionTask',['OptionsTask','defaultConfig'],primitives.famdiagram.NormalizeOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('LinePaletteOptionTask',['OptionsTask','defaultPaletteItemConfig'],primitives.famdiagram.LinePaletteOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('CursorItemOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.CursorItemOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('HighlightItemOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.HighlightItemOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('SelectedItemsOptionTask',['OptionsTask'],primitives.orgdiagram.SelectedItemsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('CursorSelectionPathModeOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.CursorSelectionPathModeOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('NeighboursSelectionModeOptionTask',['OptionsTask','defaultConfig'],primitives.famdiagram.NeighboursSelectionModeOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('SplitAnnotationsOptionTask',['OptionsTask'],primitives.orgdiagram.SplitAnnotationsOptionTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ForegroundShapeAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultShapeAnnotationConfig','foreground'],primitives.orgdiagram.ShapeAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundShapeAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultShapeAnnotationConfig','background'],primitives.orgdiagram.ShapeAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ForegroundHighlightPathAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultHighlightPathAnnotationConfig','foreground'],primitives.orgdiagram.HighlightPathAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundHighlightPathAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultHighlightPathAnnotationConfig','background'],primitives.orgdiagram.HighlightPathAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ForegroundConnectorAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultConnectorAnnotationConfig','foreground'],primitives.orgdiagram.ConnectorAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundConnectorAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultConnectorAnnotationConfig','background'],primitives.orgdiagram.ConnectorAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultBackgroundAnnotationConfig'],primitives.orgdiagram.BackgroundAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ScaleOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.ScaleOptionTask,"#000080"/*primitives.common.Colors.Navy*/);// Transformations
	tasks.addTask('IntervalsTask',['ItemsSizesOptionTask'],primitives.orgdiagram.IntervalsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('LogicalFamilyTask',['ItemsOptionTask'],primitives.famdiagram.LogicalFamilyTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('LabelAnnotationOptionTask',['SplitAnnotationsOptionTask','LogicalFamilyTask','defaultLabelAnnotationConfig'],primitives.famdiagram.LabelAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('LabelAnnotationTemplateOptionTask',['LabelAnnotationOptionTask','defaultLabelAnnotationConfig'],primitives.famdiagram.LabelAnnotationTemplateOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('LabelAnnotationPlacementOptionTask',['LabelAnnotationOptionTask','defaultLabelAnnotationConfig'],primitives.famdiagram.LabelAnnotationPlacementOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('CombinedContextsTask',['ItemsOptionTask','LabelAnnotationOptionTask'],primitives.orgdiagram.CombinedContextsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('AddLabelAnnotationsTask',['LabelAnnotationPlacementOptionTask','LogicalFamilyTask'],primitives.famdiagram.AddLabelAnnotationsTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('RemoveLoopsTask',['ItemsOptionTask','AddLabelAnnotationsTask'],primitives.famdiagram.RemoveLoopsTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('AddSpousesTask',['SpousesOptionTask','RemoveLoopsTask'],primitives.famdiagram.AddSpousesTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('NormalizeLogicalFamilyTask',['NormalizeOptionTask','AddSpousesTask'],primitives.famdiagram.NormalizeLogicalFamilyTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('LevelsTask',['NormalizeLogicalFamilyTask','defaultItemConfig','CombinedTemplateParamsTask'],primitives.famdiagram.LevelsTask,"#ff0000"/*primitives.common.Colors.Red*/);// Transformations / Templates
	tasks.addTask('ReadTemplatesTask',['TemplatesOptionTask'],primitives.orgdiagram.ReadTemplatesTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ItemTemplateParamsTask',['ItemsSizesOptionTask','CursorItemOptionTask','ReadTemplatesTask'],primitives.orgdiagram.ItemTemplateParamsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('LabelAnnotationTemplateParamsTask',['ItemsSizesOptionTask','LabelAnnotationTemplateOptionTask','ReadTemplatesTask'],primitives.famdiagram.LabelAnnotationTemplateParamsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CombinedTemplateParamsTask',['ItemTemplateParamsTask','LabelAnnotationTemplateParamsTask'],primitives.famdiagram.CombinedTemplateParamsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('GroupTitleTemplateTask',['TemplatesOptionTask'],primitives.orgdiagram.GroupTitleTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CheckBoxTemplateTask',['ItemsSizesOptionTask'],primitives.orgdiagram.CheckBoxTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ButtonsTemplateTask',['ItemsSizesOptionTask'],primitives.orgdiagram.ButtonsTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('AnnotationLabelTemplateTask',['ItemsOptionTask'],primitives.orgdiagram.AnnotationLabelTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('PrintPreviewTemplateTask',['ItemsOptionTask'],primitives.orgdiagram.PrintPreviewTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ConnectionsGraphTask',['graphics','CreateTransformTask','ConnectorsOptionTask','LevelsTask','AlignDiagramTask'],primitives.orgdiagram.ConnectionsGraphTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Transformations/Selections
	tasks.addTask('HighlightItemTask',['HighlightItemOptionTask','LevelsTask'],primitives.orgdiagram.HighlightItemTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CursorItemTask',['CursorItemOptionTask','LevelsTask'],primitives.orgdiagram.CursorItemTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CursorNeighboursTask',['CursorItemTask','NeighboursSelectionModeOptionTask','AddLabelAnnotationsTask'],primitives.famdiagram.CursorNeighboursTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('SelectedItemsTask',['SelectedItemsOptionTask'],primitives.orgdiagram.SelectedItemsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('SelectionPathItemsTask',['AddLabelAnnotationsTask','CursorItemTask','SelectedItemsTask','CursorSelectionPathModeOptionTask'],primitives.orgdiagram.SelectionPathItemsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByForegroundShapeAnnotationTask',['ForegroundShapeAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByBackgroundShapeAnnotationTask',['BackgroundShapeAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByBackgroundAnnotationTask',['BackgroundAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByForegroundHighlightPathAnnotationTask',['ForegroundHighlightPathAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByBackgroundHighlightPathAnnotationTask',['BackgroundHighlightPathAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByForegroundConnectorAnnotationTask',['ForegroundConnectorAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByConnectorAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByBackgroundConnectorAnnotationTask',['BackgroundConnectorAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByConnectorAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CombinedNormalVisibilityItemsTask',['ItemsSizesOptionTask','CursorItemTask','CursorNeighboursTask','SelectedItemsTask','SelectionPathItemsTask','NormalVisibilityItemsByForegroundShapeAnnotationTask','NormalVisibilityItemsByBackgroundShapeAnnotationTask','NormalVisibilityItemsByBackgroundAnnotationTask','NormalVisibilityItemsByForegroundHighlightPathAnnotationTask','NormalVisibilityItemsByBackgroundHighlightPathAnnotationTask','NormalVisibilityItemsByForegroundConnectorAnnotationTask','NormalVisibilityItemsByBackgroundConnectorAnnotationTask'],primitives.orgdiagram.CombinedNormalVisibilityItemsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ItemsPositionsTask',['CurrentControlSizeTask','ScaleOptionTask','OrientationOptionTask','ItemsSizesOptionTask','ConnectorsOptionTask','VisualTreeOptionTask','NormalizeLogicalFamilyTask','LevelsTask','IntervalsTask','CombinedTemplateParamsTask','CursorItemTask','CombinedNormalVisibilityItemsTask'],primitives.famdiagram.ItemsPositionsTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('AlignDiagramTask',['OrientationOptionTask','ItemsSizesOptionTask','VisualTreeOptionTask','ScaleOptionTask','PrintPreviewOptionTask','CurrentControlSizeTask','LevelsTask','ItemsPositionsTask','isFamilyChartMode'],primitives.orgdiagram.AlignDiagramTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('CreateTransformTask',['OrientationOptionTask','AlignDiagramTask'],primitives.orgdiagram.CreateTransformTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CenterOnCursorTask',['layout','CurrentControlSizeTask','CurrentScrollPositionTask','CursorItemTask','AlignDiagramTask','CreateTransformTask','ScaleOptionTask'],primitives.orgdiagram.CenterOnCursorTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Managers
	tasks.addTask('BackgroundAnnotationManagerTask',['ItemsSizesOptionTask','LevelsTask','AlignDiagramTask'],primitives.orgdiagram.BackgroundAnnotationManagerTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('PaletteManagerTask',['ConnectorsOptionTask','LinePaletteOptionTask'],primitives.orgdiagram.PaletteManagerTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Apply Layout Changes
	tasks.addTask('ApplyLayoutChangesTask',['graphics','layout','ItemsSizesOptionTask','PrintPreviewOptionTask','CurrentControlSizeTask','ScaleOptionTask','AlignDiagramTask'],primitives.orgdiagram.ApplyLayoutChangesTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Renders
	tasks.addTask('DrawBackgroundHighlightPathAnnotationTask',['graphics','ConnectorsOptionTask','ForegroundHighlightPathAnnotationOptionTask','ConnectionsGraphTask','foreground'],primitives.orgdiagram.DrawHighlightPathAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('DrawForegroundHighlightPathAnnotationTask',['graphics','ConnectorsOptionTask','BackgroundHighlightPathAnnotationOptionTask','ConnectionsGraphTask','background'],primitives.orgdiagram.DrawHighlightPathAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('DrawBackgroundAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','BackgroundAnnotationOptionTask','AddLabelAnnotationsTask','AlignDiagramTask','BackgroundAnnotationManagerTask'],primitives.orgdiagram.DrawBackgroundAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawForegroundConnectorAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','ForegroundConnectorAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','foreground'],primitives.orgdiagram.DrawConnectorAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawBackgroundConnectorAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','BackgroundConnectorAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','background'],primitives.orgdiagram.DrawConnectorAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawForegroundShapeAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','ForegroundShapeAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','foreground'],primitives.orgdiagram.DrawShapeAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawBackgroundShapeAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','BackgroundShapeAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','background'],primitives.orgdiagram.DrawShapeAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawCursorTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','CombinedContextsTask','AlignDiagramTask','CombinedTemplateParamsTask','CursorItemTask','SelectedItemsTask'],primitives.orgdiagram.DrawCursorTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawHighlightTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','CombinedContextsTask','AlignDiagramTask','CombinedTemplateParamsTask','HighlightItemTask','CursorItemTask','SelectedItemsTask'],primitives.orgdiagram.DrawHighlightTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawHighlightAnnotationTask',['layout','graphics','CreateTransformTask','ApplyLayoutChangesTask','ScaleOptionTask','CombinedContextsTask','CalloutOptionTask','ReadTemplatesTask','AlignDiagramTask','CenterOnCursorTask','HighlightItemTask','CursorItemTask','SelectedItemsTask'],primitives.orgdiagram.DrawHighlightAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawTreeItemsTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','ItemsSizesOptionTask','CombinedContextsTask','AlignDiagramTask','CombinedTemplateParamsTask','CursorItemTask','SelectedItemsTask','GroupTitleTemplateTask','CheckBoxTemplateTask','ButtonsTemplateTask'],primitives.orgdiagram.DrawTreeItemsTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawMinimizedItemsTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','MinimizedItemsOptionTask','CombinedTemplateParamsTask','AlignDiagramTask'],primitives.orgdiagram.DrawMinimizedItemsTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawConnectorsTask',['graphics','ConnectionsGraphTask','ConnectorsOptionTask','showElbowDots','PaletteManagerTask'],primitives.orgdiagram.DrawConnectorsTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawItemLabelsTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','LabelsOptionTask','LevelsTask','AlignDiagramTask'],primitives.orgdiagram.DrawItemLabelsTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawPrintPreviewTask',['graphics','ApplyLayoutChangesTask','PrintPreviewOptionTask','AlignDiagramTask','PrintPreviewTemplateTask','ScaleOptionTask'],primitives.orgdiagram.DrawPrintPreviewTask,"#008000"/*primitives.common.Colors.Green*/);return tasks;}function createEventArgs(data,oldTreeItemId,newTreeItemId,name){var result=new primitives.famdiagram.EventArgs(),combinedContextsTask=data.tasks.getTask("CombinedContextsTask"),alignDiagramTask=data.tasks.getTask("AlignDiagramTask"),logicalFamilyTask=data.tasks.getTask("LogicalFamilyTask"),oldItemConfig=combinedContextsTask.getConfig(oldTreeItemId),newItemConfig=combinedContextsTask.getConfig(newTreeItemId),family=logicalFamilyTask.getLogicalFamily(),itemPosition,offset,panelOffset;if(oldItemConfig&&oldItemConfig.id!=null){result.oldContext=oldItemConfig;}if(newItemConfig&&newItemConfig.id!=null){result.context=newItemConfig;family.loopParents(this,newItemConfig.id,function(itemid,item,levelIndex){if(levelIndex>0){return family.BREAK;}result.parentItems.push(combinedContextsTask.getConfig(itemid));});family.loopChildren(this,newItemConfig.id,function(itemid,item,levelIndex){if(levelIndex>0){return family.BREAK;}result.childrenItems.push(combinedContextsTask.getConfig(itemid));});panelOffset=data.layout.mousePanel.offset();offset=data.layout.element.offset();itemPosition=alignDiagramTask.getItemPosition(newTreeItemId);result.position=new primitives.common.Rect(itemPosition.actualPosition).translate(panelOffset.left,panelOffset.top).translate(-offset.left,-offset.top);}if(name!=null){result.name=name;}return result;}return primitives.orgdiagram.BaseControl(element,options,createTaskManager,createEventArgs);};/* /Controls/OrgDiagram/Configs/TemplateConfig.js*//*
		Class: primitives.orgdiagram.TemplateConfig
			User defines item template class. It may optionaly define template for item,
			custom cursor and highlight. If template is null then default template is used.
	
		See Also:
			<primitives.orgdiagram.Config.templates>
	*/primitives.orgdiagram.TemplateConfig=function(){/*
		Property: name
			Every template should have unique name. It is used as reference when
			custom template is defined in <primitives.orgdiagram.ItemConfig.templateName>.
		*/this.name=null;/*
		Property: isActive
			If it is true then item having this template is selectable in hierarchy and it has mouse over highlight.
	
		True - Item is clickable.
		False - Item is inactive and user cannot set cursor item or highlight.
	
		Default:
			true
		*/this.isActive=true;/*
		Property: itemSize
		This is item size of type <primitives.common.Size>, templates should have
		fixed size, so orgDiagram uses this value in order to layout items properly.
		*/this.itemSize=new primitives.common.Size(120,100);/*
		Property: itemBorderWidth
			Item template border width.
		*/this.itemBorderWidth=1;/*
		Property: itemTemplate
		Item template, if it is null then default item template is used. It supposed
		to be div html element containing named elements inside for setting them
		in <primitives.orgdiagram.Config.onItemRender> event.
		*/this.itemTemplate=null;/*
			Property: minimizedItemShapeType
				Defines minimized item shape. The border line width is set with <primitives.orgdiagram.TemplateConfig.minimizedItemBorderWidth>
				By default minimized item is rounded rectangle filled with item title color.
	
	
			See also:
				<primitives.orgdiagram.TemplateConfig.minimizedItemCornerRadius>
				<primitives.orgdiagram.ItemConfig.itemTitleColor>
				<primitives.orgdiagram.ItemConfig.minimizedItemShapeType>
	
			Default:
				null
		*/this.minimizedItemShapeType=null;/*
		Property: minimizedItemSize
		This is size dot used to display item in minimized form, type of <primitives.common.Size>.
		*/this.minimizedItemSize=new primitives.common.Size(4,4);/*
		Property: minimizedItemCornerRadius
		Set corner radias for dots in order to display them as squares having rounded corners.
		By default it is null and dots displayed as cycles. If corner radius set to 0 then they are displayed as regular squares.
		*/this.minimizedItemCornerRadius=null;/*
		Property: minimizedItemLineWidth
			Minimized item shape border width.
		*/this.minimizedItemLineWidth=1;/*
		Property: minimizedItemBorderColor
			Minimized item line color. By default it is the same as <primitives.orgdiagram.ItemConfig.itemTitleColor>
		*/this.minimizedItemBorderColor=null;/*
		Property: minimizedItemLineType
			Minimized item shape border line type.
		*/this.minimizedItemLineType=0/*primitives.common.LineType.Solid*/;/*
		Property: minimizedItemFillColor
			Minimized item fill color. By default it is the same as <primitives.orgdiagram.ItemConfig.itemTitleColor>
		*/this.minimizedItemFillColor=null;/*
		Property: minimizedItemOpacity
			Minimized item fill color opacity.
		*/this.minimizedItemOpacity=1;/*
		Property: highlightPadding
		This padding around item defines relative size of highlight object,
		its type is <primitives.common.Thickness>.
		*/this.highlightPadding=new primitives.common.Thickness(2,2,2,2);/*
		Property: highlightBorderWidth
			Highlight border width.
		*/this.highlightBorderWidth=1;/*
		Property: highlightTemplate
		Highlight template, if it is null then default highlight template is used.
		It supposed to be div html element containing named elements inside for
		setting them in <primitives.orgdiagram.Config.onHighlightRender> event.
		*/this.highlightTemplate=null;/*
		Property: cursorPadding
		This padding around item defines relative size of cursor object,
		its type is <primitives.common.Thickness>.
		*/this.cursorPadding=new primitives.common.Thickness(3,3,3,3);/*
		Property: cursorBorderWidth
			Cursor border width.
		*/this.cursorBorderWidth=2;/*
		Property: cursorTemplate
		Cursor template, if it is null then default cursor template is used.
		It supposed to be div html element containing named elements inside
		for setting them in <primitives.orgdiagram.Config.onCursorRender> event.
		*/this.cursorTemplate=null;/*
		Property: buttons
			Custom user buttons displayed on right side of item. This collection provides simple way to define context buttons for every template.
	
		See also:
			<primitives.orgdiagram.ButtonConfig>
		*/this.buttons=null;};/* /Controls/OrgDiagram/Configs/BackgroundAnnotationConfig.js*//*
		Class: primitives.orgdiagram.BackgroundAnnotationConfig
			Options class. Populate annotation collection with instances of this object to draw background area around items.
			Shape is drawn as eclosed area with perimiter line around. If items cannot share one annotation then it draws as many areas as needed to show backgorund for every item.
			It does not overlap neighboring items. If line width is set then it draws perimiter line as well.
		See Also:
			<primitives.orgdiagram.Config.annotations>
	*/primitives.orgdiagram.BackgroundAnnotationConfig=function(arg0){var property;/*
		Property: annotationType
			Annotation type. All various annotations are defined in annotations collection property of <primitives.orgdiagram.Config>.
			So this property is needed to define annotation type when we use JavaScript non-prototype objects.
			See other annotations as well.
	
		Default:
			<primitives.common.AnnotationType.Background>
	
		See Also:
			<primitives.orgdiagram.Config.annotations>
			<primitives.orgdiagram.ConnectorAnnotationConfig>
			<primitives.orgdiagram.ShapeAnnotationConfig>
			<primitives.orgdiagram.HighlightPathAnnotationConfig>
		*/this.annotationType=4/*primitives.common.AnnotationType.Background*/;/*
		Property: items
			Array of items ids in hierarchy.
		See Also:
			<primitives.orgdiagram.ItemConfig.id>
		*/this.items=[];/*
		Property: includeChildren
			Include all descendants of every item in items collection. If you add root item then all chart items are going to be added to annotation.
	
		Default:
			false
		*/this.includeChildren=false;/*
		Property: zOrderType
			Defines annotation Z order placement relative to chart items. Chart items are drawn in layers on top of each other. We can draw annotations under the items or over them.
			If you place annotations over items then you block mouse events of UI elements in them. Browsers don't support mouse events transparentcy consistently.
			So in order to avoid mouse events blocking of UI elements in item templates you have to place annotation items under them.
			Take into account that chart default buttons are drawn on top of everyhting, so they are never blocked by annotations drawn over items.
	
		Default:
			<primitives.common.ZOrderType.Auto>
		*/this.zOrderType=0/*primitives.common.ZOrderType.Auto*/;/*
		Property: lineWidth
			Border line width.
		*/this.lineWidth=2;/*
		Property: opacity
			Background color opacity. For applicable shapes only.
		*/this.opacity=1;/*
		Property: borderColor
			Shape border line color.
	
		Default:
			null
		*/this.borderColor=null;/*
		Property: fillColor
			Fill Color.
	
		Default:
			null
		*/this.fillColor=null;/*
		Property: lineType
			Connector's line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.lineType=0/*primitives.common.LineType.Solid*/;/*
		Property: selectItems
			Always show annotated items in normal state. Setting this option is equivalent to adding annotated items to collection of selected items.
	
		Default:
			true
	
		See Also:
			<primitives.orgdiagram.Config.selectedItems>
		*/this.selectItems=false;switch(arguments.length){case 1:if(arg0!==null){if(arg0 instanceof Array){this.items=arg0;}else if((typeof arg0==='undefined'?'undefined':_typeof(arg0))=="object"){for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}}}break;}};/* /Controls/OrgDiagram/Configs/ButtonConfig.js*//*
		Class: primitives.orgdiagram.ButtonConfig
			Options class. Custom user button options class.
			Buttons displayed on the right side of item.
			See jQuery UI Button options description for details.
			In order to receive button click event make binding
			to <primitives.orgdiagram.Config.onButtonClick>.
	
		See Also:
			<primitives.orgdiagram.Config.buttons>
	*/primitives.orgdiagram.ButtonConfig=function(name,icon,tooltip){/*
		Property: name
			It should be unique string name of the button.
			It is needed to distinguish click events from different butons.
		*/this.name=name;/*
		Property: icon
		Name of icon used in jQuery UI.
		*/this.icon=icon;/*
		Property: text
		Whether to show any text -when set to false (display no text),
		icon must be enabled, otherwise it'll be ignored.
		*/this.text=false;/*
		Property: label
		Text to show on the button.
		*/this.label=null;/*
		Property: tooltip
		Button tooltip content. Tooltip is based on jQuery UI tooltip widget, so it should be part of jQuery UI distribution in order to make this property work.
		*/this.tooltip=tooltip;/*
		Property: size
		Size of the button of type <primitives.common.Size>.
		*/this.size=new primitives.common.Size(16,16);};/* /Controls/OrgDiagram/Configs/Config.js*//*
		Class: primitives.orgdiagram.Config
			jQuery orgDiagram Widget options class. Organizational chart configuration object.
	
	*/primitives.orgdiagram.Config=function(name){this.name=name!==undefined?name:"OrgDiagram";this.classPrefix="orgdiagram";/*
			Property: navigationMode
				Defines control navigation mode. By default control replicates interactivity of regular Tree control.
				It has highlight for mouse over feedback and it has cursor for showing currently selected single node in diagram.
				In order to avoid creation of plus/minus buttons for children nodes folding and unfolding,
				this functionality is done automatically for current cursor item. This is especially true for family diagram,
				because it has no logical root, so cursor plays vital role for unfolding of nodes
				and zooming into area of user interest in diagram.
				Use this option to disable highlight which does not make sense on touch devices or make control inactive completly.
	
			See Also:
				<primitives.common.NavigationMode>
			Default:
				<primitives.common.NavigationMode.Default>
		*/this.navigationMode=0/*primitives.common.NavigationMode.Default*/;/*
			Property: graphicsType
				Preferable graphics type. If preferred graphics type
				is not supported widget switches to first available.
	
			Default:
				<primitives.common.GraphicsType.SVG>
		*/this.graphicsType=0/*primitives.common.GraphicsType.SVG*/;/*
			Property: pageFitMode
				Defines the way diagram is fit into page. By default chart minimize items when it has not enough space to fit all of them into screen.
				Chart has its maximum size when all items shown in full size and  its minimal size when all items shown as dots.
				It is equivalent of full zoom out of the chart items, dot size items are not readable, but such presentation of them
				gives possibility to overview chart layout. So chart tryes to combine both presenation modes and keep chart as small
				as possible in order to give user possibility to see big picture. Collapsed items provide ideal way for analitical reiew of
				organizational diagram. If chart shown in its maximum size when all items are unfolded, it becomes impossible
				to navigate betwen parents close to the root item. In such mode chart is usable only at bottom levels when children are close to their parents.
				If we try to navigate up to the root of hierarchy, gaps between parents sometimes as big as screen size. So in order to solve these
				issues chart partially collapses hierarchy into dots and lines depending on this option.
	
			See also:
				<primitives.orgdiagram.Config.minimalVisibility>
				<primitives.famdiagram.Config.printPreviewPageSize>
	
			Default:
				<primitives.common.PageFitMode.FitToPage>
		*/this.pageFitMode=3/*primitives.common.PageFitMode.FitToPage*/;/*
			Property: minimalVisibility
				Defines minimal allowed item form size for page fit mode. See description for pageFitMode.
	
			See also:
				<primitives.orgdiagram.Config.pageFitMode>
	
			Default:
				<primitives.common.Visibility.Dot>
		*/this.minimalVisibility=2/*primitives.common.Visibility.Dot*/;/*
			Property: orientationType
				Chart orientation. Chart can be rotated left, right and bottom.
				Rotation to the right side is equivalent to left side placement
				in countries writing from right to left, so it is important for localization.
	
			Default:
				<primitives.common.OrientationType.Top>
		*/this.orientationType=0/*primitives.common.OrientationType.Top*/;/*
			Property: horizontalAlignment
				Defines items horizontal alignment relative to their parent.
				This is usefull for control localization for right-to-left countries.
	
			Default:
				<primitives.common.HorizontalAlignmentType.Center>
		*/this.horizontalAlignment=0/*primitives.common.HorizontalAlignmentType.Center*/;/*
		Property: verticalAlignment
			Defines items vertical alignment relative to each other within one level of hierarchy.
			It does not affect levels having same size items.
	
		Default:
			<primitives.common.VerticalAlignmentType.Middle>
	*/this.verticalAlignment=1/*primitives.common.VerticalAlignmentType.Middle*/;/*
			Property: arrowsDirection
				Sets direction of connector lines arrows.
	
			Default:
				<primitives.common.GroupByType.None>
		*/this.arrowsDirection=0/*primitives.common.GroupByType.None*/;/*
			Property: showExtraArrows
				Show extra horizontal arrows on top of connectors for easy navigation between parents and children through connector lines.
				This options if off by default for organizational diagram.
	
			Default:
				false
		*/this.showExtraArrows=false;/*
		Property: extraArrowsMinimumSpace
			If diagram is small relations between objects are easy to trace, so mutual positions of parents and children are enough to navigate from parent to children and backward.
			If diagram is large and one row of children exceeds screen width then it use this option to activate horizontal arrows for large intervals between items.
	
		Default:
			30
		*/this.extraArrowsMinimumSpace=30;/*
			Property: showHorizontalArrows
				Show extra horizontal arrows for easy navigation to connection line between parents and children.
	
			Default:
				false
		*/this.showHorizontalArrows=false;/*
			Property: connectorType
				Defines connector lines style for dot and line elements. If elements are in their normal full size
				form they are connected with squired connection lines. So this option controls connector lines style for dots only.
	
			Default:
				<primitives.common.ConnectorType.Squared>
		*/this.connectorType=0/*primitives.common.ConnectorType.Squared*/;/*
			Property: bevelSize
				Size of squared connector bevel.
	
			Default:
				4
		*/this.bevelSize=4;/*
			Property: elbowType
				Style squared connectors with custom elbows.
	
			Default:
				<primitives.common.ElbowType.None>
		*/this.elbowType=0/*primitives.common.ElbowType.None*/;/*
			Property: elbowDotSize
				Size of elbow dot.
	
			Default:
				4
		*/this.elbowDotSize=4;/*
		Property: emptyDiagramMessage
			Empty message in order to avoid blank screen. This option is supposed to say user that chart is empty when no data inside.
		*/this.emptyDiagramMessage="Diagram is empty.";/*
		Property: items
			This is chart items collection. It is regular array of items of type ItemConfig. Items reference each other via parent property.
			So every item may have only one parent in chart. If parent set to null then item displayed at root of chart.
			Chart can have multiple root items simultaniously. If item references missing item, then it is ignored.
			If items loop each other they are ignored as well. It is applications responsiblity to avoid such issues.
	
		See Also:
			<primitives.orgdiagram.ItemConfig>
			<primitives.orgdiagram.ItemConfig.id>
			<primitives.orgdiagram.ItemConfig.parent>
		*/this.items=[];/*
		Property: annotations
			Array of annotaion objects. Chart supports several types of annotations. By default they are drawn on top of chart items and they block mouse events of UI elements placed in item templates.
			The design assumes only few of them being displayed simultanuosly in other words chart does not resolve mutual overlaps of annotations, so don't over use them.
			This is especially true for connectors and background annotations.
	
		See also:
			<primitives.orgdiagram.ConnectorAnnotationConfig>
			<primitives.orgdiagram.ShapeAnnotationConfig>
			<primitives.orgdiagram.BackgroundAnnotationConfig>
			<primitives.orgdiagram.HighlightPathAnnotationConfig>
		*/this.annotations=[];/*
		Property: cursorItem
			Cursor item id - it is single item selection mode, user selects new cursor item on mouse click.
			Cursor defines current local zoom placement or in other words current navigation item in the chart,
			all items relative to cursor always shoun in full size. So user can see all possible items around cursor in full size
			and can continue navigation around chart. So when user navigates from one item to another clicking on thems and changing cursor item
			in chart, chart minimizes items going out of cursor scope and shows in full size items relative to new cursor position.
			If it is null then no cursor shown on diagram.
	
		See Also:
			<primitives.orgdiagram.ItemConfig.id>
			<primitives.orgdiagram.Config.onCursorChanging>
			<primitives.orgdiagram.Config.onCursorChanged>
		*/this.cursorItem=null;/*
		Property: highlightItem
			Highlighted item id. Highlight is mouse over affect, but using this option applicatin can set highlight at any item
			in the chart programmatically. It can be used for chart syncronization with other controls on UI having mouse over effect.
			See primitives.orgdiagram.Config.update method arguments description for fast chart update.
			If it is null then no highlight shown on diagram.
	
		See Also:
			<primitives.orgdiagram.ItemConfig.id>
			<primitives.orgdiagram.Config.onHighlightChanging>
			<primitives.orgdiagram.Config.onHighlightChanged>
		*/this.highlightItem=null;/*
		Property: highlightGravityRadius
			The normal item has mouse over feedback in form of highlight border only when mouse pointer is inside of its boundaries.
			When items is minimized its marker can be so small that it is going to be difficult for end user to place mouse pointer inside of it.
			This option defines highlight gravity radius, so minimized item gets highlighted when mouse pointer does not overlap marker but it is within gravity radius of its boundaries.
			This property is ignored when nearest item is outside of screen boundaries and not visible to end user.
		*/this.highlightGravityRadius=40;/*
		Property: selectedItems
			Defines array of selected item ids. Chart allows to select items via checking checkboxes under items. Checkboxes are
			shown only for full size items. So when item is selected it is always shown in full size, so check box always visible for selcted items.
			User can navigate around large diagram and check intrested items in order to keep them opened. So that way chart provides
			means to show several items on large diagram and fit everything into minimal space ideally into available screen space.
			Application can select items programmatically using this array or receive notifications from chart about user selections with following events.
	
		See Also:
			<primitives.orgdiagram.ItemConfig.id>
			<primitives.orgdiagram.Config.onSelectionChanging>
			<primitives.orgdiagram.Config.onSelectionChanged>
		*/this.selectedItems=[];/*
		Property: hasSelectorCheckbox
			This option controls selection check boxes visibility.
	
		Auto - Checkbox shown only for current cursor item only.
		True - Every full size item has selection check box.
		False - No check boxes. Application can still programmatically select some items in the chart.
		Application may provide custom item template having checkbox inside of item. If application defined check box inside of item template has name="checkbox"
		it is auto used as default selection check box.
	
		Default:
			<primitives.common.Enabled.Auto>
	
		See Also:
			<primitives.orgdiagram.ItemConfig.hasSelectorCheckbox>
			<primitives.orgdiagram.Config.onSelectionChanging>
			<primitives.orgdiagram.Config.onSelectionChanged>
		*/this.hasSelectorCheckbox=0/*primitives.common.Enabled.Auto*/;/*
			Property: selectCheckBoxLabel
				Selection check box label.
		*/this.selectCheckBoxLabel="Selected";/*
		Property: selectionPathMode
			Defines the way items between root item and selectedItems displayed in diagram. Chart always shows all items between cursor item and its root in full size.
			But if cursor positioned on root item, then chart shows in full size only selected items in the chart. So this option controls items size between
			selected items and root item of the chart. By default all items betwen root and selected items shown in full size.
	
		Default:
			<primitives.common.SelectionPathMode.FullStack>
		*/this.selectionPathMode=1/*primitives.common.SelectionPathMode.FullStack*/;/*
		Property: templates
			Custom user templates collection. TemplateConfig is complex object providing options to customize item's content template,
			cursor tempate and highlight template. Every template config should have unique name property, which is used by chart and its item configs
			to reference them. Chart's defaultTemplateName allows to make template default for all items in the chart. On other hand user may define templates
			to individual items in the chart by templateName property of item config.
	
		See also:
			<primitives.orgdiagram.TemplateConfig>
			<primitives.orgdiagram.Config.defaultTemplateName>
			<primitives.orgdiagram.ItemConfig.templateName>
		*/this.templates=[];/*
			Property: defaultTemplateName
				This is template name used to render items having no <primitives.orgdiagram.ItemConfig.templateName> defined.
	
	
			See Also:
				<primitives.orgdiagram.TemplateConfig>
				<primitives.orgdiagram.TemplateConfig.name>
				<primitives.orgdiagram.Config.templates>
		*/this.defaultTemplateName=null;/*
		Property: hasButtons
			This option controls user buttons visibility.
	
		Auto - Buttons visible only for cursor item.
		True - Every normal item has buttons visible.
		False - No buttons.
	
		Default:
			<primitives.common.Enabled.Auto>
		*/this.hasButtons=0/*primitives.common.Enabled.Auto*/;/*
		Property: buttons
			Custom user buttons displayed on right side of item. This collection provides simple way to define context buttons for every item.
			The only limitation, they are all the same. So if you need to have unique buttons for every item, then you have to
			customize cursor templates and manually create custom buttons inside of them.
	
		See also:
			<primitives.orgdiagram.ButtonConfig>
		*/this.buttons=[];/*
		Event: onHighlightChanging
			Notifies about changing highlight item <primitives.orgdiagram.Config.highlightItem> in diagram.
			This coupled event with <primitives.orgdiagram.Config.onHighlightChanged>, it is fired before highlight update.
	
		See also:
			<primitives.orgdiagram.EventArgs>
		*/this.onHighlightChanging=null;/*
		Event: onHighlightChanged
			Notifies about changed highlight item <primitives.orgdiagram.Config.highlightItem> in diagram.
	
		See also:
			<primitives.orgdiagram.EventArgs>
		*/this.onHighlightChanged=null;/*
		Event: onCursorChanging
			Notifies about changing cursor item <primitives.orgdiagram.Config.cursorItem> in diagram.
			This coupled event with <primitives.orgdiagram.Config.onCursorChanged>, it is fired before layout update.
	
		See also:
			<primitives.orgdiagram.EventArgs>
		*/this.onCursorChanging=null;/*
		Event: onCursorChanged
			Notifies about changed cursor item <primitives.orgdiagram.Config.cursorItem> in diagram .
	
		See also:
			<primitives.orgdiagram.EventArgs>
		*/this.onCursorChanged=null;/*
		Event: onSelectionChanging
			Notifies about changing selected items collection of <primitives.orgdiagram.Config.selectedItems>.
	
		See also:
			<primitives.orgdiagram.EventArgs>
		*/this.onSelectionChanging=null;/*
		Event: onSelectionChanged
			Notifies about changes in collection of <primitives.orgdiagram.Config.selectedItems>.
	
		See also:
			<primitives.orgdiagram.EventArgs>
		*/this.onSelectionChanged=null;/*
		Event: onButtonClick
			Notifies about click of custom user button defined in colelction of <primitives.orgdiagram.Config.buttons>.
	
		See also:
			<primitives.orgdiagram.EventArgs>
		*/this.onButtonClick=null;/*
		Event: onMouseClick
			On mouse click event.
	
		See also:
			<primitives.orgdiagram.EventArgs>
		*/this.onMouseClick=null;/*
		Event: onMouseDblClick
			On mouse double click event.
	
		See also:
			<primitives.orgdiagram.EventArgs>
		*/this.onMouseDblClick=null;/*
		Event: onItemRender
			Item templates don't provide means to bind data of items into templates. So this event handler gives application such possibility.
			If application uses custom templates then this method is called to populate template with items properties.
	
		See also:
			<primitives.common.RenderEventArgs>
			<primitives.orgdiagram.TemplateConfig>
			<primitives.orgdiagram.Config.templates>
		*/this.onItemRender=null;/*
		Event: onHighlightRender
			If user defined custom highlight template for item template
			then this method is called to populate it with context data.
	
		See also:
			<primitives.common.RenderEventArgs>
			<primitives.orgdiagram.TemplateConfig>
			<primitives.orgdiagram.Config.templates>
		*/this.onHighlightRender=null;/*
		Event: onCursorRender
			If user defined custom cursor template for item template
			then this method is called to populate it with context data.
	
		See also:
			<primitives.common.RenderEventArgs>
			<primitives.orgdiagram.TemplateConfig>
			<primitives.orgdiagram.Config.templates>
		*/this.onCursorRender=null;/*
		Property: normalLevelShift
			Defines interval after level of items in  diagram having items in normal state.
		*/this.normalLevelShift=20;/*
		Property: dotLevelShift
			Defines interval after level of items in  diagram having all items in dot state.
		*/this.dotLevelShift=20;/*
		Property: lineLevelShift
			Defines interval after level of items in  diagram having items in line state.
		*/this.lineLevelShift=10;/*
		Property: normalItemsInterval
			Defines interval between items at the same level in  diagram having items in normal state.
		*/this.normalItemsInterval=10;/*
		Property: dotItemsInterval
			Defines interval between items at the same level in  diagram having items in dot state.
		*/this.dotItemsInterval=1;/*
		Property: lineItemsInterval
			Defines interval between items at the same level in  diagram having items in line state.
		*/this.lineItemsInterval=2;/*
		Property: cousinsIntervalMultiplier
			Use this interval multiplier between cousins in hiearchy. The idea of this option to make extra space between cousins.
			So children belonging to different parents have extra gap between them.
	
		*/this.cousinsIntervalMultiplier=5;/*
		method: update
			Makes full redraw of diagram contents reevaluating all options. This method has to be called explisitly after all options are set in order to update widget contents.
	
		Parameters:
			updateMode: This parameter defines severaty of update <primitives.common.UpdateMode>.
			For example <primitives.common.UpdateMode.Refresh> updates only
			items and selection reusing existing elements where ever it is possible.
	
		See also:
			<primitives.common.UpdateMode>
	
		Default:
			<primitives.common.UpdateMode.Recreate>
		*//*
		Property: itemTitleFirstFontColor
		This property customizes default template title font color.
		Item background color sometimes play a role of logical value and
		can vary over a wide range, so as a result title having
		default font color may become unreadable. Widgets selects the best font color
		between this option and <primitives.orgdiagram.Config.itemTitleSecondFontColor>.
	
		See Also:
			<primitives.orgdiagram.ItemConfig.itemTitleColor>
			<primitives.orgdiagram.Config.itemTitleSecondFontColor>
			<primitives.common.highestContrast>
	
		*/this.itemTitleFirstFontColor="#ffffff"/*primitives.common.Colors.White*/;/*
		Property: itemTitleSecondFontColor
		Default template title second font color.
		*/this.itemTitleSecondFontColor="#000080"/*primitives.common.Colors.Navy*/;/*
			Property: minimizedItemShapeType
				Defines minimized item shape. The border line width is set with <primitives.orgdiagram.TemplateConfig.minimizedItemBorderWidth>
				By default minimized item is rounded rectangle filled with item title color.
	
	
			See also:
				<primitives.orgdiagram.TemplateConfig.minimizedItemCornerRadius>
				<primitives.orgdiagram.ItemConfig.itemTitleColor>
				<primitives.orgdiagram.ItemConfig.minimizedItemShapeType>
	
			Default:
				<primitives.common.ShapeType.None>
		*/this.minimizedItemShapeType=6/*primitives.common.ShapeType.None*/;/*
		Property: linesColor
			Connectors lines color. Connectors are basic connections betwen chart items
			defining their logical relationships, don't mix with connector annotations.
		*/this.linesColor="#c0c0c0"/*primitives.common.Colors.Silver*/;/*
		Property: linesWidth
			Connectors lines width.
		*/this.linesWidth=1;/*
		Property: linesType
			Connectors line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.linesType=0/*primitives.common.LineType.Solid*/;/*
		Property: highlightLinesColor
			Connectors highlight line color. Connectors are basic connections betwen chart items
			defining their logical relationships, don't mix with connector annotations.
		*/this.highlightLinesColor="#ff0000"/*primitives.common.Colors.Red*/;/*
		Property: highlightLinesWidth
			Connectors highlight line width.
		*/this.highlightLinesWidth=1;/*
		Property: highlightLinesType
			Connectors highlight line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.highlightLinesType=0/*primitives.common.LineType.Solid*/;/*
		Property: showCallout
			This option controls callout visibility for dotted/(markers) items.
	
		Default:
			true
		*/this.showCallout=true;/*
		Property: calloutPlacementOffset
			Set this property value depending on size and intervals between markers so callout annotation does not overlap neighbouring items of marker it is shown for.
		*/this.calloutPlacementOffset=100;/*
		Property: defaultCalloutTemplateName
			This is template name used to render callouts for dotted items.
			Actual callout template name is defined by following sequence:
			<primitives.orgdiagram.ItemConfig.calloutTemplateName>
			<primitives.orgdiagram.ItemConfig.templateName>
			<primitives.orgdiagram.Config.defaultCalloutTemplateName>
			<primitives.orgdiagram.Config.defaultTemplateName>
	
	
		See Also:
			<primitives.orgdiagram.Config.templates> collection property.
	
		Default:
			null
		*/this.defaultCalloutTemplateName=null;/*
		Property: calloutfillColor
			Annotation callout fill color.
		*/this.calloutfillColor="#000000";/*
		Property: calloutBorderColor
			Annotation callout border color.
		*/this.calloutBorderColor=null;/*
		Property: calloutOffset
			Annotation callout offset.
		*/this.calloutOffset=4;/*
		Property: calloutCornerRadius
			Annotation callout corner radius.
		*/this.calloutCornerRadius=4;/*
		Property: calloutPointerWidth
			Annotation callout pointer base width.
		*/this.calloutPointerWidth="10%";/*
		Property: calloutLineWidth
			Annotation callout border line width.
		*/this.calloutLineWidth=1;/*
		Property: calloutOpacity
			Annotation callout opacity.
		*/this.calloutOpacity=0.2;/*
		Property: childrenPlacementType
			Defines children placement form.
		*/this.childrenPlacementType=2/*primitives.common.ChildrenPlacementType.Horizontal*/;/*
		Property: leavesPlacementType
			Defines leaves placement form. Leaves are children having no sub children.
		*/this.leavesPlacementType=2/*primitives.common.ChildrenPlacementType.Horizontal*/;/*
		Property: maximumColumnsInMatrix
			Maximum number of columns for matrix leaves layout. Leaves are children having no sub children.
		*/this.maximumColumnsInMatrix=6;/*
		Property: buttonsPanelSize
			User buttons panel size.
		*/this.buttonsPanelSize=28;/*
		Property: groupTitlePanelSize
			Group title panel size.
		*/this.groupTitlePanelSize=24;/*
		Property: checkBoxPanelSize
			Selection check box panel size.
		*/this.checkBoxPanelSize=24;/*
			Property: groupTitleOrientation
				Group title direction style.
	
			Default:
				<primitives.text.TextDirection.Auto>
		*/this.groupTitleOrientation=2/*primitives.text.TextOrientationType.RotateRight*/;/*
			Property: groupTitleVerticalAlignment
				Group title vertical alignment.
	
			Default:
				<primitives.common.VerticalAlignmentType.Center>
		*/this.groupTitleVerticalAlignment=1/*primitives.common.VerticalAlignmentType.Middle*/;/*
			Property: groupTitleHorizontalAlignment
				Group title horizontal alignment.
	
			Default:
				<primitives.common.HorizontalAlignmentType.Center>
		*/this.groupTitleHorizontalAlignment=0/*primitives.common.HorizontalAlignmentType.Center*/;/*
			Property: groupTitleFontSize
				Group title font size.
	
			Default:
				15
		*/this.groupTitleFontSize="12px";/*
			Property: groupTitleFontFamily
				Group title font family.
	
			Default:
				"Arial"
		*/this.groupTitleFontFamily="Arial";/*
			Property: groupTitleColor
				Group title color.
	
			Default:
				<primitives.common.Colors.Black>
		*/this.groupTitleColor="#4169e1"/*primitives.common.Colors.RoyalBlue*/;/*
			Property: groupTitleFontWeight
				Group title font weight: normal | bold
	
			Default:
				"normal"
		*/this.groupTitleFontWeight="normal";/*
			Property: groupTitleFontStyle
				Group title font style: normal | italic
	
			Default:
				"normal"
		*/this.groupTitleFontStyle="normal";this.distance=3;/*
		Property: scale
			CSS3 scale transform.
		*/this.scale=1;/*
		Property: minimumScale
			Minimum CSS3 scale transform.
		*/this.minimumScale=0.5;/*
		Property: maximumScale
			Maximum CSS3 scale transform.
		*/this.maximumScale=2;/*
		Property: showLabels
			This option controls labels visibility for minimized items. If you need to show labels outside of borders of regular items then use item template for customization.
			Labels placed inside HTML DIV element and long strings are wrapped inside.
			User can control labels position relative to its item. Chart does not meassure labels and does reserve space for them,
			so if label overlap each other then horizontal or vertical intervals between rows and items shoud be manually increased.
	
		Auto - depends on available space.
		True - always shown.
		False - hidden.
	
		See Also:
			<primitives.orgdiagram.ItemConfig.label>
			<primitives.orgdiagram.Config.labelSize>
			<primitives.orgdiagram.Config.normalItemsInterval>
			<primitives.orgdiagram.Config.dotItemsInterval>
			<primitives.orgdiagram.Config.lineItemsInterval>
			<primitives.orgdiagram.Config.normalLevelShift>
			<primitives.orgdiagram.Config.dotLevelShift>
			<primitives.orgdiagram.Config.lineLevelShift>
	
		Default:
			<primitives.common.Enabled.Auto>
		*/this.showLabels=0/*primitives.common.Enabled.Auto*/;/*
		Property: labelSize
			Defines label size. It is needed to avoid labels overlapping. If one label overlaps another label or item it will be hidden.
			Label string is wrapped when its length exceeds available width.
	
		Default:
			new <primitives.common.Size>(80, 24);
		*/this.labelSize=new primitives.common.Size(80,24);/*
		Property: labelOffset
			Defines label offset from dot in pixels.
	
		Default:
			1;
		*/this.labelOffset=1;/*
		Property: labelOrientation
			Defines label orientation.
	
		See Also:
		<primitives.text.TextOrientationType>
	
		Default:
			<primitives.text.TextOrientationType.Horizontal>
		*/this.labelOrientation=0/*primitives.text.TextOrientationType.Horizontal*/;/*
		Property: labelPlacement
			Defines label placement relative to its dot.
			Label is aligned to opposite side of its box.
	
		See Also:
		<primitives.common.PlacementType>
	
		Default:
			<primitives.common.PlacementType.Top>
		*/this.labelPlacement=1/*primitives.common.PlacementType.Top*/;/*
			Property: labelFontSize
				Label font size.
	
			Default:
				10px
		*/this.labelFontSize="10px";/*
			Property: labelFontFamily
				Label font family.
	
			Default:
				"Arial"
		*/this.labelFontFamily="Arial";/*
			Property: labelColor
				Label color.
	
			Default:
				primitives.common.Colors.Black
		*/this.labelColor="#000000"/*primitives.common.Colors.Black*/;/*
			Property: labelFontWeight
				Font weight: normal | bold
	
			Default:
				"normal"
		*/this.labelFontWeight="normal";/*
		Property: labelFontStyle
			Font style: normal | italic
	
		Default:
			"normal"
		*/this.labelFontStyle="normal";/*
		Property: enablePanning
			Enable chart panning with mouse drag & drop for desktop browsers.
			Disable it if you need to support items Drag & Drop.
	
		Default:
			true
		*/this.enablePanning=true;/*
		Property: printPreviewPageSize
			Defines print preview page size in pixels.
	
		Default:
			new <primitives.common.Size>(612, 792);
		*/this.printPreviewPageSize=new primitives.common.Size(612,792);/*
		Property: autoSizeMinimum
			Defines minimum diagram size in autosize mode. If diagram has no elements, it is going to be of this size on the page.
		Default:
			new <primitives.common.Size>(800, 600);
		*/this.autoSizeMinimum=new primitives.common.Size(800,600);/*
		Property: autoSizeMaximum
			Defines maximum diagram size in autosize mode.
		Default:
			new <primitives.common.Size>(1024, 768);
		*/this.autoSizeMaximum=new primitives.common.Size(1024,768);};/* /Controls/OrgDiagram/Configs/ConnectorAnnotationConfig.js*//*
		Class: primitives.orgdiagram.ConnectorAnnotationConfig
			Options class. Populate annotation collection with instances of this objects to draw connector between two items.
	
		See Also:
			<primitives.orgdiagram.Config.annotations>
	*/primitives.orgdiagram.ConnectorAnnotationConfig=function(arg0,arg1){var property;/*
		Property: annotationType
			Annotation type. All various annotations are defined in annotations collection property of <primitives.orgdiagram.Config>.
			So this property is needed to define annotation type when we use JavaScript non-prototype objects.
			See other annotations as well.
	
		Default:
			<primitives.common.AnnotationType.Connector>
	
		See Also:
			<primitives.orgdiagram.Config.annotations>
			<primitives.orgdiagram.ShapeAnnotationConfig>
			<primitives.orgdiagram.BackgroundAnnotationConfig>
			<primitives.orgdiagram.HighlightPathAnnotationConfig>
		*/this.annotationType=0/*primitives.common.AnnotationType.Connector*/;/*
		Property: zOrderType
			Defines annotation Z order placement relative to chart items. Chart items are drawn in layers on top of each other. We can draw annotations under the items or over them.
			If you place annotations over items then you block mouse events of UI elements in them. Browsers don't support mouse events transparentcy consistently.
			So in order to avoid mouse events blocking of UI elements in item templates you have to place annotation items under them.
			Take into account that chart default buttons are drawn on top of everyhting, so they are never blocked by annotations drawn over items.
	
		Default:
			<primitives.common.ZOrderType.Foreground>
		*/this.zOrderType=2/*primitives.common.ZOrderType.Foreground*/;/*
		Property: fromItem
			Reference to from item in hierarchy.
		See Also:
			<primitives.orgdiagram.ItemConfig.id>
		*/this.fromItem=null;/*
		Property: toItem
			Reference to from item in hierarchy.
		See Also:
			<primitives.orgdiagram.ItemConfig.id>
		*/this.toItem=null;/*
		Property: connectorShapeType
			Connector shape type.
	
		Default:
			<primitives.common.ConnectorShapeType.OneWay>
		*/this.connectorShapeType=0/*primitives.common.ConnectorShapeType.OneWay*/;/*
			Property: connectorPlacementType
				Defines connector annotation shape placement mode between two items.
				It uses off beat placement mode as default in order to avoid overlapping
				of base hierarchy connecting lines.
	
			Default:
				<primitives.common.ConnectorPlacementType.Offbeat>
		*/this.connectorPlacementType=0/*primitives.common.ConnectorPlacementType.Offbeat*/;/*
		Property: labelPlacementType
			Label placement type along connection line(s).
	
		Default:
			<primitives.common.ConnectorLabelPlacementType.Between>
		*/this.labelPlacementType=1/*primitives.common.ConnectorLabelPlacementType.Between*/;/*
		Property: offset
			Connector's from and to points offset off the rectangles side. Connectors connection points can be outside of rectangles and inside for negative offset value.
		See also:
			<primitives.common.Thickness>
		*/this.offset=new primitives.common.Thickness(0,0,0,0);/*
		Property: lineWidth
			Border line width.
		*/this.lineWidth=2;/*
		Property: color
			Connector's color.
	
		Default:
			<primitives.common.Colors.Black>
		*/this.color="#000000"/*primitives.common.Colors.Black*/;/*
		Property: lineType
			Connector's line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.lineType=0/*primitives.common.LineType.Solid*/;/*
		Property: selectItems
			Always show annotated items in normal state. Setting this option is equivalent to adding annotated items to collection of selected items.
	
		Default:
			true
	
		See Also:
			<primitives.orgdiagram.Config.selectedItems>
		*/this.selectItems=true;/*
		Property: label
			Annotation label text. Label styled with css class name "bp-connector-label".
		*/this.label=null;/*
		Property: labelSize
			Annotation label size.
	
		Default:
			new <primitives.common.Size>(60, 30);
		*/this.labelSize=new primitives.common.Size(60,30);switch(arguments.length){case 1:for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}break;case 2:this.fromItem=arg0;this.toItem=arg1;break;}};/* /Controls/OrgDiagram/Configs/HighlightPathAnnotationConfig.js*//*
		Class: primitives.orgdiagram.HighlightPathAnnotationConfig
			Options class. Populate annotation collection with instances of this objects to draw path between items.
			Path is drawn along base connection lines displaying relationships between item of the chart.
		See Also:
			<primitives.orgdiagram.Config.annotations>
	*/primitives.orgdiagram.HighlightPathAnnotationConfig=function(arg0){var property;/*
		Property: annotationType
			Annotation type. All various annotations are defined in annotations collection property of <primitives.orgdiagram.Config>.
			So this property is needed to define annotation type when we use JavaScript non-prototype objects.
			See other annotations as well.
	
		Default:
			<primitives.common.AnnotationType.HighlightPath>
	
		See Also:
			<primitives.orgdiagram.Config.annotations>
			<primitives.orgdiagram.ConnectorAnnotationConfig>
			<primitives.orgdiagram.ShapeAnnotationConfig>
			<primitives.orgdiagram.BackgroundAnnotationConfig>
		*/this.annotationType=2/*primitives.common.AnnotationType.HighlightPath*/;/*
		Property: zOrderType
			Defines annotation Z order placement relative to chart items. Chart items are drawn in layers on top of each other.
			Highlight path annotations can be placed under main connectors wire or over.
	
		Default:
			<primitives.common.ZOrderType.Foreground>
		*/this.zOrderType=2/*primitives.common.ZOrderType.Foreground*/;/*
		Property: items
			Array of item ids in hierarchy.
		See Also:
			<primitives.orgdiagram.ItemConfig.id>
		*/this.items=[];/*
		Property: lineWidth
			Border line width.
		*/this.lineWidth=2;/*
		Property: color
			Connector's color.
	
		Default:
			<primitives.common.Colors.Black>
		*/this.color="#ff0000"/*primitives.common.Colors.Red*/;/*
		Property: lineType
			Connector's line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.lineType=0/*primitives.common.LineType.Solid*/;/*
		Property: opacity
			Connector's line opacity.
		*/this.opacity=1;/*
		Property: showArrows
			This option controls arrows visibility along highlight path.
	
		Default:
			true
		*/this.showArrows=true;/*
		Property: selectItems
			Always show annotated items in normal state. Setting this option is equivalent to adding annotated items to collection of selected items.
	
		Default:
			true
	
		See Also:
			<primitives.orgdiagram.Config.selectedItems>
		*/this.selectItems=false;switch(arguments.length){case 1:if(arg0!==null){if(arg0 instanceof Array){this.items=arg0;}else if((typeof arg0==='undefined'?'undefined':_typeof(arg0))=="object"){for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}}}break;}};/* /Controls/OrgDiagram/Configs/ItemConfig.js*//*
		Class: primitives.orgdiagram.ItemConfig
			Defines item in diagram hierarchy.
			User is supposed to create hierarchy of this items and assign it to <primitives.orgdiagram.Config.items> collection property.
			Widget contains some generic properties used in default item template,
			but user can add as many custom properties to this class as needed.
			Just be careful and avoid widget malfunction.
	
		See Also:
			<primitives.orgdiagram.Config.items>
	*/primitives.orgdiagram.ItemConfig=function(arg0,arg1,arg2,arg3,arg4){var property;/*
		Property: id
		Unique item id.
		*/this.id=null;/*
		Property: parent
		Parent id. If parent is null then item placed as a root item.
		*/this.parent=null;/*
		Property: title
		Default template title property.
		*/this.title=null;/*
		Property: description
		Default template description element.
		*/this.description=null;/*
		Property: image
		Url to image. This property is used in default template.
		*/this.image=null;/*
		Property: context
		User context object.
		*/this.context=null;/*
		Property: itemTitleColor
		Default template title background color.
		*/this.itemTitleColor="#4169e1"/*primitives.common.Colors.RoyalBlue*/;/*
		Property: minimizedItemShapeType
			Defines minimized/dotted item shape type. By default it is set by ItemTemplate.minimizedItemShapeType property.
			Use this property to set marker type individually per item.
	
		See Also:
			<primitives.common.ShapeType>
		*/this.minimizedItemShapeType=null;/*
		Property: groupTitle
		Auxiliary group title property. Displayed vertically on the side of item.
		*/this.groupTitle=null;/*
		Property: groupTitleColor
		Group title background color.
		*/this.groupTitleColor="#4169e1"/*primitives.common.Colors.RoyalBlue*/;/*
		Property: isVisible
			If it is true then item is shown and selectable in hierarchy.
			If item is hidden and it has visible children then only connector line is drawn instead of it.
	
		True - Item is shown.
		False - Item is hidden.
	
		Default:
			true
		*/this.isVisible=true;/*
		Property: isActive
			If it is true then item is selectable in hierarchy and it has mouse over highlight.
	
		True - Item is clickable.
		False - Item is inactive and user cannot set cursor item or highlight.
	
		Default:
			true
		*/this.isActive=true;/*
		Property: hasSelectorCheckbox
			If it is true then selection check box is shown for the item.
			Selected items are always shown in normal form, so if item is
			selected then its selection check box is visible and checked.
	
		Auto - Depends on <primitives.orgdiagram.Config.hasSelectorCheckbox> setting.
		True - Selection check box is visible.
		False - No selection check box.
	
		Default:
		<primitives.common.Enabled.Auto>
		*/this.hasSelectorCheckbox=0/*primitives.common.Enabled.Auto*/;/*
		Property: hasButtons
			This option controls buttons panel visibility.
	
		Auto - Depends on <primitives.orgdiagram.Config.hasButtons> setting.
		True - Has buttons panel.
		False - No buttons panel.
	
		Default:
		<primitives.common.Enabled.Auto>
		*/this.hasButtons=0/*primitives.common.Enabled.Auto*/;/*
			Property: itemType
				This property defines how item should be shown.
				So far it is only possible to make it invisible.
	
			See Also:
				<primitives.orgdiagram.ItemType>
	
			Deafult:
				<primitives.orgdiagram.ItemType.Regular>
		*/this.itemType=0/*primitives.orgdiagram.ItemType.Regular*/;/*
			Property: adviserPlacementType
				In case of item types <primitives.orgdiagram.ItemType.Assistant>
				and <primitives.orgdiagram.ItemType.Adviser> this option defines item
				placement side relative to parent. By default items placed on
				the right side of parent item.
	
			Deafult:
				<primitives.common.AdviserPlacementType.Auto>
		*/this.adviserPlacementType=0/*primitives.common.AdviserPlacementType.Auto*/;/*
		Property: childrenPlacementType
			Defines children placement form.
		*/this.childrenPlacementType=0/*primitives.common.ChildrenPlacementType.Auto*/;/*
		Property: directorsPlacementType
			Defines directors placement form.
		*/this.directorsPlacementType=0/*primitives.common.ChildrenPlacementType.Auto*/;/*
		Property: leftAdvisersPlacementType
			Defines left advisers placement form.
		*/this.leftAdvisersPlacementType=0/*primitives.common.ChildrenPlacementType.Auto*/;/*
		Property: rightAdvisersPlacementType
			Defines right advisers placement form.
		*/this.rightAdvisersPlacementType=0/*primitives.common.ChildrenPlacementType.Auto*/;/*
		Property: groupName
			Defines group name for applicabale item types, every group of items placed as separate level.
		*/this.groupName=null;/*
		Property: templateName
			This is template name used to render this item.
	
			See Also:
			<primitives.orgdiagram.TemplateConfig>
			<primitives.orgdiagram.Config.templates> collection property.
		*/this.templateName=null;/*
		Property: showCallout
			This option controls items callout visibility.
	
		Auto - depends on <primitives.orgdiagram.Config.showCallout> option
		True - shown
		False - hidden
	
		Default:
			<primitives.common.Enabled.Auto>
		*/this.showCallout=0/*primitives.common.Enabled.Auto*/;/*
		Property: calloutTemplateName
			This is template name used to render callout for dotted item.
			Actual callout template name is defined by following sequence:
			<primitives.orgdiagram.ItemConfig.calloutTemplateName>
			<primitives.orgdiagram.ItemConfig.templateName>
			<primitives.orgdiagram.Config.defaultCalloutTemplateName>
			<primitives.orgdiagram.Config.defaultTemplateName>
	
		See Also:
			<primitives.orgdiagram.Config.templates> collection property.
		Default:
			null
		*/this.calloutTemplateName=null;/*
		Property: label
		Items label text.
		*/this.label=null;/*
		Property: showLabel
			This option controls items label visibility. Label is displayed in form of div having text inside, long string is wrapped inside of it.
			User can control labels position relative to its item. Chart does not preserve space for label.
	
		Auto - depends on <primitives.orgdiagram.Config.labelOrientation> setting.
		True - always shown.
		False - hidden.
	
		See Also:
		<primitives.orgdiagram.ItemConfig.label>
		<primitives.orgdiagram.Config.labelSize>
	
		Default:
			<primitives.common.Enabled.Auto>
		*/this.showLabel=0/*primitives.common.Enabled.Auto*/;/*
		Property: labelSize
			Defines label size. It is needed to avoid labels overlapping. If one label overlaps another label or item it will be hidden.
			Label string is wrapped when its length exceeds available width.
			By default it is equal to charts <primitives.orgdiagram.Config.labelSize>.
	
		See Also:
			<primitives.common.Size>
		Default:
			null;
		*/this.labelSize=null;/*
		Property: labelOrientation
			Defines label orientation.
			In default <primitives.text.TextOrientationType.Auto> mode it depends on chart <primitives.orgdiagram.Config.labelOrientation> setting.
	
		See Also:
		<primitives.orgdiagram.Config.labelOrientation>
		<primitives.text.TextOrientationType>
	
		Default:
			<primitives.text.TextOrientationType.Auto>
		*/this.labelOrientation=3/*primitives.text.TextOrientationType.Auto*/;/*
		Property: labelPlacement
			Defines label placement relative to the item.
			In default <primitives.common.PlacementType.Auto> mode it depends on chart <primitives.orgdiagram.Config.labelPlacement> setting.
	
		See Also:
			<primitives.orgdiagram.Config.labelPlacement>
			<primitives.common.PlacementType>
	
		Default:
			<primitives.common.PlacementType.Auto>
		*/this.labelPlacement=0/*primitives.common.PlacementType.Auto*/;switch(arguments.length){case 1:for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}break;case 5:this.id=arg0;this.parent=arg1;this.title=arg2;this.description=arg3;this.image=arg4;break;}};/* /Controls/OrgDiagram/Configs/ShapeAnnotationConfig.js*//*
		Class: primitives.orgdiagram.ShapeAnnotationConfig
			Options class. Populate annotation collection with instances of this objects to draw shape benith or on top of several items.
			Shape is drawn as rectangular area.
		See Also:
			<primitives.orgdiagram.Config.annotations>
	*/primitives.orgdiagram.ShapeAnnotationConfig=function(arg0){var property;/*
		Property: annotationType
			Annotation type. All various annotations are defined in annotations collection property of <primitives.orgdiagram.Config>.
			So this property is needed to define annotation type when we use JavaScript non-prototype objects.
			See other annotations as well.
	
		Default:
			<primitives.common.AnnotationType.Shape>
	
		See Also:
			<primitives.orgdiagram.Config.annotations>
			<primitives.orgdiagram.ConnectorAnnotationConfig>
			<primitives.orgdiagram.BackgroundAnnotationConfig>
			<primitives.orgdiagram.HighlightPathAnnotationConfig>
		*/this.annotationType=1/*primitives.common.AnnotationType.Shape*/;/*
		Property: zOrderType
			Defines annotation Z order placement relative to chart items. Chart items are drawn in layers on top of each other. We can draw annotations under the items or over them.
			If you place annotations over items then you block mouse events of UI elements in them. Browsers don't support mouse events transparentcy consistently.
			So in order to avoid mouse events blocking of UI elements in item templates you have to place annotation items under them.
			Take into account that chart default buttons are drawn on top of everyhting, so they are never blocked by annotations drawn over items.
	
		Default:
			<primitives.common.ZOrderType.Auto>
		*/this.zOrderType=0/*primitives.common.ZOrderType.Auto*/;/*
		Property: items
			Array of items ids in hierarchy.
		See Also:
			<primitives.orgdiagram.ItemConfig.id>
		*/this.items=[];/*
		Property: shapeType
			Shape type.
	
		Default:
			<primitives.common.ShapeType.Rectangle>
		*/this.shapeType=0/*primitives.common.ShapeType.Rectangle*/;/*
		Property: offset
			Connector's from and to points offset off the rectangles side. Connectors connection points can be outside of rectangles and inside for negative offset value.
		See also:
			<primitives.common.Thickness>
		*/this.offset=new primitives.common.Thickness(0,0,0,0);/*
		Property: lineWidth
			Border line width.
		*/this.lineWidth=2;/*
		Property: cornerRadius
			Body corner radius in percents or pixels. For applicable shapes only.
		*/this.cornerRadius="10%";/*
		Property: opacity
			Background color opacity. For applicable shapes only.
		*/this.opacity=1;/*
		Property: borderColor
			Shape border line color.
	
		Default:
			null
		*/this.borderColor=null;/*
		Property: fillColor
			Fill Color.
	
		Default:
			null
		*/this.fillColor=null;/*
		Property: lineType
			Connector's line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.lineType=0/*primitives.common.LineType.Solid*/;/*
		Property: selectItems
			Always show annotated items in normal state. Setting this option is equivalent to adding annotated items to collection of selected items.
	
		Default:
			true
	
		See Also:
			<primitives.orgdiagram.Config.selectedItems>
		*/this.selectItems=false;/*
		Property: label
			Annotation label text. Label styled with css class name "bp-connector-label".
		*/this.label=null;/*
		Property: labelSize
			Annotation label size.
	
		Default:
			new <primitives.common.Size>(60, 30);
		*/this.labelSize=new primitives.common.Size(60,30);/*
		Property: labelPlacement
			Defines label placement relative to the shape.
	
		See Also:
			<primitives.orgdiagram.Config.labelPlacement>
			<primitives.common.PlacementType>
	
		Default:
			<primitives.common.PlacementType.Auto>
		*/this.labelPlacement=0/*primitives.common.PlacementType.Auto*/;/*
		Property: labelOffset
			Defines label offset from shape in pixels.
	
		Default:
			4;
		*/this.labelOffset=4;switch(arguments.length){case 1:if(arg0!==null){if(arg0 instanceof Array){this.items=arg0;}else if((typeof arg0==='undefined'?'undefined':_typeof(arg0))=="object"){for(property in arg0){if(arg0.hasOwnProperty(property)){this[property]=arg0[property];}}}}break;}};/* /Controls/OrgDiagram/Events/EventArgs.js*//*
		Class: primitives.orgdiagram.EventArgs
			Event details class.
	*/primitives.orgdiagram.EventArgs=function(){/*
		Property: oldContext
			Reference to associated previous item in hierarchy.
		*/this.oldContext=null;/*
		Property: context
			Reference to associated new item in hierarchy.
		*/this.context=null;/*
		Property: parentItem
			Reference parent item of item in context.
		*/this.parentItem=null;/*
		Property: position
			Absolute item position on diagram.
	
		See also:
			<primitives.common.Rect>
		*/this.position=null;/*
		Property: name
			Relative object name.
	
		*/this.name=null;/*
		Property: cancel
			Allows cancelation of coupled event processing. This option allows to cancel layout update
			and subsequent <primitives.orgdiagram.Config.onCursorChanged> event
			in handler of <primitives.orgdiagram.Config.onCursorChanging> event.
		*/this.cancel=false;};/* /Controls/OrgDiagram/Models/ConnectorBundle.js*/primitives.orgdiagram.ConnectorBundle=function(){this.isVertical=true;this.fromLevel=null;this.fromItems=[];this.toItems=[];this.fromOffset=0;this.toOffset=0;};/* /Controls/OrgDiagram/Models/LevelVisibility.js*/primitives.orgdiagram.LevelVisibility=function(level,currentvisibility){this.level=level;this.currentvisibility=currentvisibility;};/* /Controls/OrgDiagram/Models/OrgItem.js*//* This is model class is used to define intermediate organizational chart structure */primitives.orgdiagram.OrgItem=function(options){var index,len,property;this.id=null;// Unique org item id.
	this.isVisible=true;// If it is true then item is shown and selectable in hierarchy.
	this.isActive=true;// If it is true then item is clickable in hierarchy.
	this.hasVisibleChildren=false;// If it is true then item is Visible or one of its children in hierarchy.
	this.itemType=0/*primitives.orgdiagram.ItemType.Regular*/;// This property defines how item should be placed in chart.
	this.adviserPlacementType=0/*primitives.common.AdviserPlacementType.Auto*/;// Left or Right placement relative to parent
	this.childrenPlacementType=0/*primitives.common.ChildrenPlacementType.Auto*/;// Children shape
	this.level=null;this.hideParentConnection=false;this.hideChildrenConnection=false;/* org tree balancing properties */this.childIndex=null;// Item index in array of parent's children
	// Folowing properties we copy from user's item config to new OrgItem instance
	// If user's property is undefined we take default value from ItemConfig
	var properties=['id','parent','isVisible','isActive','itemType','adviserPlacementType','childrenPlacementType'];/* copy general org chart items properties */for(index=0,len=properties.length;index<len;index+=1){property=properties[index];if(options.hasOwnProperty(property)){this[property]=options[property];}}};/* /Controls/OrgDiagram/Models/Template.js*/primitives.orgdiagram.Template=function(options,templateConfig){this.templateConfig=null;this.itemTemplate=null;this.highlightTemplate=null;this.dotHighlightTemplate=null;this.cursorTemplate=null;if(templateConfig!=null){this.templateConfig=templateConfig;this.itemTemplate=primitives.common.isNullOrEmpty(templateConfig.itemTemplate)?new primitives.common.ItemTemplate(options,templateConfig):new primitives.common.UserTemplate(options,templateConfig.itemTemplate,options.onItemRender);this.highlightTemplate=primitives.common.isNullOrEmpty(templateConfig.highlightTemplate)?new primitives.common.HighlightTemplate(options,templateConfig):new primitives.common.UserTemplate(options,templateConfig.highlightTemplate,options.onHighlightRender);this.dotHighlightTemplate=new primitives.common.DotHighlightTemplate(options,templateConfig);this.cursorTemplate=primitives.common.isNullOrEmpty(templateConfig.cursorTemplate)?new primitives.common.CursorTemplate(options,templateConfig):new primitives.common.UserTemplate(options,templateConfig.cursorTemplate,options.onCursorRender);}};/* /Controls/OrgDiagram/Models/TemplateParams.js*/primitives.orgdiagram.TemplateParams=function(){this.template=null;this.isActive=false;this.hasSelectorCheckbox=false;this.hasButtons=false;this.hasGroupTitle=false;this.buttons=[];};/* /Controls/OrgDiagram/Models/TreeItem.js*//* This is model class used to define visual structure of chart */primitives.orgdiagram.TreeItem=function(){/* auto generated internal item id */this.id=null;/* Visual child id which is supposed to be straight under it */this.visualAggregatorId=null;this.visualDepth=1;// private
	this.partners=[];/* thess are nodes connected with bottom line together into one family, family is group of items having common set of children */this.visibility=1/*primitives.common.Visibility.Normal*/;this.actualItemType=null;// primitives.orgdiagram.ItemType
	this.connectorPlacement=0;// primitives.common.SideFlag
	this.gravity=0;// primitives.common.HorizontalAlignmentType.Center
	/* This value is used to increase gap between neighboring left item in hiearchy */this.relationDegree=0;};/* /Controls/OrgDiagram/Models/TreeItemPosition.js*//* This is model class used to define visual structure of chart */primitives.orgdiagram.TreeItemPosition=function(source){this.partnerConnectorOffset=0;this.level=null;this.levelPosition=null;this.offset=0;this.leftPadding=0;this.rightPadding=0;this.actualVisibility=1/*primitives.common.Visibility.Normal*/;this.actualSize=null;this.actualPosition=null;this.contentPosition=null;if(source!=null){for(var property in source){if(source.hasOwnProperty(property)){switch(property){case'actualPosition':this.actualPosition=new primitives.common.Rect(source.actualPosition);break;default:this[property]=source[property];break;}}}}};primitives.orgdiagram.TreeItemPosition.prototype.setSize=function(isCursor,treeItemTemplate,itemsSizesOptions,orientationOptions){var templateConfig;switch(this.actualVisibility){case 1/*primitives.common.Visibility.Normal*/:templateConfig=treeItemTemplate.template.templateConfig;this.actualSize=new primitives.common.Size(templateConfig.itemSize);this.contentPosition=new primitives.common.Rect(0,0,this.actualSize.width,this.actualSize.height);if(isCursor){this.actualSize.height+=templateConfig.cursorPadding.top+templateConfig.cursorPadding.bottom;this.actualSize.width+=templateConfig.cursorPadding.left+templateConfig.cursorPadding.right;this.contentPosition.x=templateConfig.cursorPadding.left;this.contentPosition.y=templateConfig.cursorPadding.top;}if(treeItemTemplate.hasSelectorCheckbox){this.actualSize.height+=itemsSizesOptions.checkBoxPanelSize;}if(treeItemTemplate.hasButtons){this.actualSize.width+=itemsSizesOptions.buttonsPanelSize;}if(treeItemTemplate.hasGroupTitle){this.actualSize.width+=itemsSizesOptions.groupTitlePanelSize;this.contentPosition.x+=itemsSizesOptions.groupTitlePanelSize;}break;case 2/*primitives.common.Visibility.Dot*/:templateConfig=treeItemTemplate.template.templateConfig;this.actualSize=new primitives.common.Size(templateConfig.minimizedItemSize);break;case 3/*primitives.common.Visibility.Line*/:case 4/*primitives.common.Visibility.Invisible*/:this.actualSize=new primitives.common.Size();break;}switch(orientationOptions.orientationType){case 2/*primitives.common.OrientationType.Left*/:case 3/*primitives.common.OrientationType.Right*/:this.actualSize.invert();break;}};primitives.orgdiagram.TreeItemPosition.prototype.setPosition=function(treeLevelPosition,itemsSizesOptions,orientationOptions){var itemShift=0;switch(this.actualVisibility){case 1/*primitives.common.Visibility.Normal*/:switch(itemsSizesOptions.verticalAlignment){case 0/*primitives.common.VerticalAlignmentType.Top*/:itemShift=0;break;case 1/*primitives.common.VerticalAlignmentType.Middle*/:itemShift=(treeLevelPosition.depth-this.actualSize.height)/2.0;break;case 2/*primitives.common.VerticalAlignmentType.Bottom*/:itemShift=treeLevelPosition.depth-this.actualSize.height;break;}break;case 2/*primitives.common.Visibility.Dot*/:case 3/*primitives.common.Visibility.Line*/:case 4/*primitives.common.Visibility.Invisible*/:itemShift=treeLevelPosition.horizontalConnectorsDepth-this.actualSize.height/2.0;break;}this.actualPosition=new primitives.common.Rect(this.offset,treeLevelPosition.shift+itemShift,this.actualSize.width,this.actualSize.height);this.actualPosition.validate();};/* /Controls/OrgDiagram/Models/TreeLevelConnectorStackSize.js*/primitives.orgdiagram.TreeLevelConnectorStackSize=function(){this.parentsStackSize=0;/* number of overlapping horiontal connection lines between partners in level */this.childrenStackSize=0;/* number of overlapping horiontal connection lines between children in level */};/* /Controls/OrgDiagram/Models/TreeLevelPosition.js*/primitives.orgdiagram.TreeLevelPosition=function(source){this.currentvisibility=1/*primitives.common.Visibility.Normal*/;this.actualVisibility=1/*primitives.common.Visibility.Normal*/;this.shift=0.0;/* top abolute position of items in level */this.depth=0.0;/* maximum  height of items in level */this.nextLevelShift=0.0;/* next level relative position */this.horizontalConnectorsDepth=0;/* relative position of horizontal connectors between items */this.topConnectorShift=0.0;/* relative position of top connector horizontal line */this.connectorShift=0.0;/* relative position of bottom horizontal line */this.levelSpace=0.0;/* user interval between prev level and this one based on options set by user, if number of horizontal connections is bigger that one it is proportionally increased */this.currentOffset=0.0;/* this is x axis coordinate offset, it used to calculate horizontal items position in level */this.labels=[];this.labelsRect=null;this.showLabels=true;this.hasFixedLabels=false;if(source!=null){for(var property in source){if(source.hasOwnProperty(property)){this[property]=source[property];}}}};primitives.orgdiagram.TreeLevelPosition.prototype.setShift=function(shift,levelSpace,topConnectorSpace,connectorSpace,partnerConnectorOffset){this.shift=shift;this.levelSpace=levelSpace;this.topConnectorShift=-levelSpace/2.0-topConnectorSpace;this.connectorShift=this.depth+connectorSpace+(partnerConnectorOffset+1)*(levelSpace/2.0);this.nextLevelShift=topConnectorSpace+this.depth+connectorSpace+levelSpace+partnerConnectorOffset*levelSpace/2.0;return this.nextLevelShift;};primitives.orgdiagram.TreeLevelPosition.prototype.shiftDown=function(shift){this.shift+=shift;};primitives.orgdiagram.TreeLevelPosition.prototype.toString=function(){return this.currentvisibility;};/* /Controls/OrgDiagram/Tasks/Layout/AlignDiagramTask.js*/primitives.orgdiagram.AlignDiagramTask=function(orientationOptionTask,itemsSizesOptionTask,visualTreeOptionTask,scaleOptionTask,printPreviewOptionTask,currentControlSizeTask,visualTreeLevelsTask,itemsPositionsTask,isFamilyChartMode){var _data={treeItemsPositions:{},// primitives.orgdiagram.TreeItemPosition();
	treeLevelsPositions:[],// primitives.orgdiagram.TreeLevelPosition()
	panelSize:null// primitives.common.Rect();
	},_treeLevels,_activeTreeLevels,_treeItemsPositions,_treeLevelsPositions,_options,_orientationOptions,_printPreviewOptions,_visualTreeOptions,_scaleOptions;function process(){var placeholderSize=new primitives.common.Size(itemsPositionsTask.getContentSize()),panelSize=new primitives.common.Size(currentControlSizeTask.getOptimalPanelSize());_treeLevels=visualTreeLevelsTask.getTreeLevels();_activeTreeLevels=visualTreeLevelsTask.getActiveTreeLevels();_treeItemsPositions=itemsPositionsTask.getItemsPositions();_treeLevelsPositions=itemsPositionsTask.getTreeLevelsPositions();_options=itemsSizesOptionTask.getOptions();_orientationOptions=orientationOptionTask.getOptions();_printPreviewOptions=printPreviewOptionTask.getOptions();_visualTreeOptions=visualTreeOptionTask.getOptions();_scaleOptions=scaleOptionTask.getOptions();switch(_orientationOptions.orientationType){case 2/*primitives.common.OrientationType.Left*/:case 3/*primitives.common.OrientationType.Right*/:panelSize.invert();break;}panelSize.scale(1.0/_scaleOptions.scale);// By default we translate everything forward
	_data.panelSize=panelSize;_data.treeItemsPositions=_treeItemsPositions;_data.treeLevelsPositions=_treeLevelsPositions;switch(_options.pageFitMode){case 4/*primitives.common.PageFitMode.PrintPreview*/:_data.treeItemsPositions={};_data.treeLevelsPositions=[];_data.panelSize=stretchToAvoidPageMargins(_data.treeItemsPositions,_data.treeLevelsPositions);break;case 5/*primitives.common.PageFitMode.AutoSize*/:_data.panelSize=new primitives.common.Size(placeholderSize);break;default:_data.panelSize=new primitives.common.Size(placeholderSize);if(placeholderSize.width<panelSize.width){_data.treeItemsPositions={};stretchToWidth(_data.treeItemsPositions,placeholderSize.width,panelSize.width);_data.panelSize.width=panelSize.width;}if(placeholderSize.height<panelSize.height){_data.panelSize.height=panelSize.height;}break;}switch(_orientationOptions.orientationType){case 2/*primitives.common.OrientationType.Left*/:case 3/*primitives.common.OrientationType.Right*/:_data.panelSize.invert();break;}return true;}function stretchToWidth(treeItemsPositions,treeWidth,panelWidth){var offset;if(isFamilyChartMode){offset=(panelWidth-treeWidth)/2.0;}else{switch(_visualTreeOptions.horizontalAlignment){case 1/*primitives.common.HorizontalAlignmentType.Left*/:offset=0;break;case 2/*primitives.common.HorizontalAlignmentType.Right*/:offset=panelWidth-treeWidth;break;case 0/*primitives.common.HorizontalAlignmentType.Center*/:offset=(panelWidth-treeWidth)/2.0;break;}}translateItemPositions(treeItemsPositions,offset,0);}function translateItemPositions(treeItemsPositions,offsetX,offsetY){var treeItemid,treeItemPosition;for(treeItemid in _treeItemsPositions){if(_treeItemsPositions.hasOwnProperty(treeItemid)){treeItemPosition=new primitives.orgdiagram.TreeItemPosition(_treeItemsPositions[treeItemid]);treeItemPosition.actualPosition.translate(offsetX,offsetY);treeItemsPositions[treeItemid]=treeItemPosition;}}}function stretchToAvoidPageMargins(treeItemsPositions,treeLevelsPositions){var pageSize=new primitives.common.Size(_printPreviewOptions.printPreviewPageSize),treeLevelsItems,sortedItems,index,len,globalOffset,pageRightMargin,pageBottomMargin,item,treeLevel;pageSize.scale(1.0/_scaleOptions.scale);switch(_orientationOptions.orientationType){case 2/*primitives.common.OrientationType.Left*/:case 3/*primitives.common.OrientationType.Right*/:pageSize.invert();break;}/* streatch horizontally */globalOffset=0;pageRightMargin=pageSize.width;_treeLevels.loopMerged(this,function(treeItemid){var treeItemPosition=_treeItemsPositions[treeItemid],actualPosition=treeItemPosition.actualPosition;return actualPosition.x;},function(treeItemid,treeItem){var treeItemPosition=new primitives.orgdiagram.TreeItemPosition(_treeItemsPositions[treeItemid]);treeItemsPositions[treeItemid]=treeItemPosition;if(treeItemPosition.actualPosition.left()+globalOffset<pageRightMargin&&treeItemPosition.actualPosition.right()+globalOffset>pageRightMargin){globalOffset+=pageRightMargin-treeItemPosition.actualPosition.left()-globalOffset+_options.normalItemsInterval/2.0;}treeItemPosition.actualPosition.translate(globalOffset,0);if(treeItemPosition.actualPosition.left()>pageRightMargin){pageRightMargin+=pageSize.width;}});/* streatch vertically */globalOffset=0;pageBottomMargin=pageSize.height;_treeLevels.loopLevels(this,function(index,levelContext){var treeLevelPosition=new primitives.orgdiagram.TreeLevelPosition(_treeLevelsPositions[index]);if(treeLevelPosition.shift+globalOffset<pageBottomMargin&&treeLevelPosition.shift+treeLevelPosition.depth+globalOffset>pageBottomMargin){globalOffset+=pageBottomMargin-treeLevelPosition.shift-globalOffset+_options.normalLevelShift/2.0;}treeLevelPosition.shiftDown(globalOffset);_treeLevels.loopLevelItems(this,index,function(treeItemId){var treeItemPosition=treeItemsPositions[treeItemId];treeItemPosition.actualPosition.translate(0,globalOffset);});if(treeLevelPosition.shift>pageBottomMargin){pageBottomMargin+=pageSize.height;}treeLevelsPositions.push(treeLevelPosition);});return new primitives.common.Size(pageRightMargin+1,pageBottomMargin+1);}function getTreeItemForMousePosition(x,y,gravityRadius){var result=null,index,bestIndex=null,bestDistance=null,distance,len,treeLevel,scale=_scaleOptions.scale;x=x/scale;y=y/scale;_activeTreeLevels.loopLevels(this,function(index,level){var treeLevelPosition=_data.treeLevelsPositions[index];if(y>treeLevelPosition.shift+treeLevelPosition.topConnectorShift&&y<=treeLevelPosition.shift+treeLevelPosition.connectorShift){bestIndex=index;return true;}distance=Math.min(Math.abs(y-(treeLevelPosition.shift+treeLevelPosition.topConnectorShift)),Math.abs(y-(treeLevelPosition.shift+treeLevelPosition.connectorShift)));if(bestDistance==null||bestDistance>distance){bestDistance=distance;bestIndex=index;}});if(bestIndex!=null){result=_activeTreeLevels.binarySearch(this,bestIndex,function(itemId){var treeItemPosition=_data.treeItemsPositions[itemId];switch(treeItemPosition.actualVisibility){case 1/*primitives.common.Visibility.Normal*/:if(treeItemPosition.actualPosition.contains(x,y)){return 0;}//ignore jslint
	case 2/*primitives.common.Visibility.Dot*/://ignore jslint
	case 3/*primitives.common.Visibility.Line*/:return x-treeItemPosition.actualPosition.horizontalCenter();case 4/*primitives.common.Visibility.Invisible*/:throw"Clickable items collection should contain only visible items.";}});//ignore jslint
	}if(result!=null){var treeItemPosition=_data.treeItemsPositions[result];switch(treeItemPosition.actualVisibility){case 1/*primitives.common.Visibility.Normal*/:break;default:if(Math.abs(x-treeItemPosition.actualPosition.horizontalCenter())>Math.max(gravityRadius,treeItemPosition.actualPosition.width/2.0)||Math.abs(y-treeItemPosition.actualPosition.verticalCenter())>Math.max(gravityRadius,treeItemPosition.actualPosition.height/2.0)){result=null;}break;}}return result;}function getNextLevelTreeItem(fromTreeItem,isBelow){var fromTreeItemPosition=_data.treeItemsPositions[fromTreeItem],horizontalCenter=fromTreeItemPosition.actualPosition.horizontalCenter(),bestTreeItemId=fromTreeItem,bestDistance=null,distance;_activeTreeLevels.loopLevelsFromItem(this,fromTreeItem,isBelow,function(levelIndex){_activeTreeLevels.loopLevelItems(this,levelIndex,function(itemid,item){var treeItemPosition=_data.treeItemsPositions[itemid];if(treeItemPosition.actualVisibility==1/*primitives.common.Visibility.Normal*/){distance=Math.abs(horizontalCenter-treeItemPosition.actualPosition.horizontalCenter());if(distance<bestDistance||bestDistance==null){bestDistance=distance;bestTreeItemId=itemid;}else{return true;// break
	}}});if(bestDistance!=null){return true;// break
	}});return bestTreeItemId;}function getNextTreeItem(fromTreeItem,isLeft){var result=fromTreeItem.id,treeItemPosition;_activeTreeLevels.loopFromItem(this,fromTreeItem,isLeft,function(treeItemId){treeItemPosition=_treeItemsPositions[treeItemId];if(treeItemPosition.actualVisibility==1/*primitives.common.Visibility.Normal*/){result=treeItemId;return true;}});return result;}function getTreeLevelsPositions(){return _data.treeLevelsPositions;}function getItemPosition(itemid){return _data.treeItemsPositions[itemid];}function getItemsPositions(){return _data.treeItemsPositions;}function getContentSize(){return _data.panelSize;}return{process:process,getTreeLevelsPositions:getTreeLevelsPositions,getItemPosition:getItemPosition,getItemsPositions:getItemsPositions,getContentSize:getContentSize,getTreeItemForMousePosition:getTreeItemForMousePosition,getNextLevelTreeItem:getNextLevelTreeItem,getNextTreeItem:getNextTreeItem};};/* /Controls/OrgDiagram/Tasks/Layout/ApplyLayoutChangesTask.js*/primitives.orgdiagram.ApplyLayoutChangesTask=function(getGraphics,getLayout,itemsSizesOptionTask,printPreviewOptionTask,currentControlSizeTask,scaleOptionTask,alignDiagramTask){var _data={scrollPanelSize:null},_printPreviewOptions,_itemsSizesOptions;function process(){var layout=getLayout(),graphics=getGraphics(),scaleOptions=scaleOptionTask.getOptions(),scale=scaleOptions.scale;_printPreviewOptions=printPreviewOptionTask.getOptions();_itemsSizesOptions=itemsSizesOptionTask.getOptions();/* set size of panel with content */var mousePanelSize=new primitives.common.Size(alignDiagramTask.getContentSize());mousePanelSize.scale(1*scale);layout.mousePanel.css(mousePanelSize.getCSS());/* set size of panel with content */var panelSize=new primitives.common.Size(alignDiagramTask.getContentSize());layout.placeholder.css(panelSize.getCSS());graphics.resize("placeholder",panelSize.width,panelSize.height);/* resize element to fit placeholder if control in autosize or print preview mode */switch(_printPreviewOptions.pageFitMode){case 5/*primitives.common.PageFitMode.AutoSize*/://ignore jslint
	_data.scrollPanelSize=new primitives.common.Size(mousePanelSize.width+25,mousePanelSize.height+25);_data.scrollPanelSize.cropBySize(_itemsSizesOptions.autoSizeMaximum);_data.scrollPanelSize.addSize(_itemsSizesOptions.autoSizeMinimum);//ignore jslint
	layout.element.css({"width":_data.scrollPanelSize.width+"px","height":_data.scrollPanelSize.height+"px"});break;case 4/*primitives.common.PageFitMode.PrintPreview*/:_data.scrollPanelSize=new primitives.common.Size(mousePanelSize.width+25,mousePanelSize.height+25);layout.element.css({"width":_data.scrollPanelSize.width+"px","height":_data.scrollPanelSize.height+"px"});break;default:_data.scrollPanelSize=new primitives.common.Size(currentControlSizeTask.getScrollPanelSize());break;}/* set scroll of content *//* pixel alignment of scroll panel */var position=layout.element.offset();layout.scrollPanel.css({"top":"0px","left":"0px","width":_data.scrollPanelSize.width+"px","height":_data.scrollPanelSize.height+"px","margin-bottom":"0px","margin-right":"0px","margin-top":-position.top+Math.floor(position.top)+"px","margin-left":-position.left+Math.floor(position.left)+"px"});/* set CSS scale of content */var scaletext="scale("+scale+","+scale+")";layout.placeholder.css({"transform-origin":"0 0","transform":scaletext,"-ms-transform":scaletext,/* IE 9 */"-webkit-transform":scaletext,/* Safari and Chrome */"-o-transform":scaletext,/* Opera */"-moz-transform":scaletext/* Firefox */});return true;}function getOptimalPanelSize(){return new primitives.common.Size(_data.scrollPanelSize.width-25,_data.scrollPanelSize.height-25);}return{process:process,getOptimalPanelSize:getOptimalPanelSize};};/* /Controls/OrgDiagram/Tasks/Layout/CenterOnCursorTask.js*//*
		This method should try to keep cursor item as close as possible to its previous position
	*/primitives.orgdiagram.CenterOnCursorTask=function(getLayout,currentControlSizeTask,currentScrollPositionTask,cursorItemTask,alignDiagramTask,createTransformTask,scaleOptionTask){var _data={placeholderOffset:null},_transform;function process(){var snapRect,layout=getLayout(),cursorTreeItemId=cursorItemTask.getCursorTreeItem(),treeItemPosition=alignDiagramTask.getItemPosition(cursorTreeItemId),contentSize=alignDiagramTask.getContentSize(),scrollPanelSize,scaleOptions=scaleOptionTask.getOptions(),scale=scaleOptions.scale;_data.placeholderOffset=currentScrollPositionTask.getPlaceholderOffset();if(layout.forceCenterOnCursor){_transform=createTransformTask.getTransform();if(treeItemPosition!=null){snapRect=getTransformedItemPosition(treeItemPosition.actualPosition);snapRect.scale(scale);contentSize.scale(scale);scrollPanelSize=currentControlSizeTask.getScrollPanelSize();_data.placeholderOffset=new primitives.common.Point(Math.max(Math.min(snapRect.horizontalCenter()-scrollPanelSize.width/2,contentSize.width-scrollPanelSize.width),0),Math.max(Math.min(snapRect.verticalCenter()-scrollPanelSize.height/2,contentSize.height-scrollPanelSize.height),0));}}return true;}function isAnnotationNeeded(snapRect,panelPosition){return!panelPosition.overlaps(snapRect);}function getTransformedItemPosition(position){var result=false;_transform.transformRect(position.x,position.y,position.width,position.height,true,this,function(x,y,width,height){result=new primitives.common.Rect(x,y,width,height);});return result;}function getPlaceholderOffset(){return _data.placeholderOffset;}return{process:process,getPlaceholderOffset:getPlaceholderOffset};};/* /Controls/OrgDiagram/Tasks/Layout/CreateTransformTask.js*/primitives.orgdiagram.CreateTransformTask=function(orientationOptionTask,alignDiagramTask){var _data={transform:null},_activeTreeLevels;function process(){var orientationOptions=orientationOptionTask.getOptions();var panelSize=new primitives.common.Size(alignDiagramTask.getContentSize());_data.transform=new primitives.common.Transform();_data.transform.setOrientation(orientationOptions.orientationType);_data.transform.size=new primitives.common.Size(panelSize);return true;}function getTreeItemForMousePosition(x,y,gravityRadius){var result=null;_data.transform.transformPoint(x,y,false,this,function(x,y){result=alignDiagramTask.getTreeItemForMousePosition(x,y,gravityRadius);});return result;}function getTransform(){return _data.transform;}return{process:process,getTransform:getTransform,getTreeItemForMousePosition:getTreeItemForMousePosition,description:"Create oordiante system tranfromation object."};};/* /Controls/OrgDiagram/Tasks/Layout/CurrentControlSizeTask.js*/primitives.orgdiagram.CurrentControlSizeTask=function(getLayout,optionsTask,itemsSizesOptionTask){var _data={scrollPanelSize:null},_hash={},_dataTemplate=new primitives.common.ObjectReader({scrollPanelSize:new primitives.common.ObjectReader({width:new primitives.common.ValueReader(["number"],true),height:new primitives.common.ValueReader(["number"],true)},true)});function process(){var context={isChanged:false,hash:_hash},layout=getLayout(),currentLayout={scrollPanelSize:new primitives.common.Size(layout.element.outerWidth(),layout.element.outerHeight())},result=false,options=itemsSizesOptionTask.getOptions();_data=_dataTemplate.read(_data,currentLayout,"layout",context);switch(options.pageFitMode){case 1/*primitives.common.PageFitMode.PageWidth*/:case 2/*primitives.common.PageFitMode.PageHeight*/:case 3/*primitives.common.PageFitMode.FitToPage*/:result=context.isChanged;break;default:break;}return result;}function getScrollPanelSize(){return _data.scrollPanelSize;}function getOptimalPanelSize(){return new primitives.common.Size(_data.scrollPanelSize.width-25,_data.scrollPanelSize.height-25);}return{process:process,getScrollPanelSize:getScrollPanelSize,getOptimalPanelSize:getOptimalPanelSize};};/* /Controls/OrgDiagram/Tasks/Layout/CurrentScrollPositionTask.js*/primitives.orgdiagram.CurrentScrollPositionTask=function(getLayout,optionsTask){var _data={placeholderOffset:null},_hash={},_dataTemplate=new primitives.common.ObjectReader({placeholderOffset:new primitives.common.ObjectReader({x:new primitives.common.ValueReader(["number"],true),y:new primitives.common.ValueReader(["number"],true)},true)});function process(){var context={isChanged:false,hash:_hash},layout=getLayout(),currentLayout={placeholderOffset:new primitives.common.Point(layout.scrollPanel.scrollLeft(),layout.scrollPanel.scrollTop())};_data=_dataTemplate.read(_data,currentLayout,"layout",context);return context.isChanged;}function getPlaceholderOffset(){return _data.placeholderOffset;}return{process:process,getPlaceholderOffset:getPlaceholderOffset};};/* /Controls/OrgDiagram/Tasks/Options/Annotations/BackgroundAnnotationOptionTask.js*/primitives.orgdiagram.BackgroundAnnotationOptionTask=function(splitAnnotationsOptionTask,defaultBackgroundAnnotationConfig){var _annotations=[],_hash={};var _dataTemplate=new primitives.common.ArrayReader(new primitives.common.ObjectReader({items:new primitives.common.ArrayReader(new primitives.common.ValueReader(["string","number"],true),true),includeChildren:new primitives.common.ValueReader(["boolean"],false,defaultBackgroundAnnotationConfig.includeChildren),zOrderType:new primitives.common.EnumerationReader(primitives.common.ZOrderType,false,defaultBackgroundAnnotationConfig.zOrderType),lineWidth:new primitives.common.ValueReader(["number"],false,defaultBackgroundAnnotationConfig.lineWidth),opacity:new primitives.common.ValueReader(["number"],false,defaultBackgroundAnnotationConfig.opacity),borderColor:new primitives.common.ValueReader(["string"],false,defaultBackgroundAnnotationConfig.borderColor),fillColor:new primitives.common.ValueReader(["string"],false,defaultBackgroundAnnotationConfig.fillColor),lineType:new primitives.common.EnumerationReader(primitives.common.LineType,false,defaultBackgroundAnnotationConfig.lineType),selectItems:new primitives.common.ValueReader(["boolean"],false,defaultBackgroundAnnotationConfig.selectItems)}),false);function process(){var context={isChanged:false,hash:_hash};_annotations=_dataTemplate.read(_annotations,splitAnnotationsOptionTask.getAnnotations(4/*primitives.common.AnnotationType.Background*/,null),"annotations",context);return context.isChanged;}function getAnnotations(){return _annotations;}return{process:process,getAnnotations:getAnnotations};};/* /Controls/OrgDiagram/Tasks/Options/Annotations/ConnectorAnnotationOptionTask.js*/primitives.orgdiagram.ConnectorAnnotationOptionTask=function(splitAnnotationsOptionTask,defaultConnectorAnnotationConfig,zOrderType){var _annotations=[],_hash={};var _dataTemplate=new primitives.common.ArrayReader(new primitives.common.ObjectReader({zOrderType:new primitives.common.EnumerationReader(primitives.common.ZOrderType,false,defaultConnectorAnnotationConfig.zOrderType),fromItem:new primitives.common.ValueReader(["string","number"],true),toItem:new primitives.common.ValueReader(["string","number"],true),connectorShapeType:new primitives.common.EnumerationReader(primitives.common.ShapeType,false,defaultConnectorAnnotationConfig.connectorShapeType),connectorPlacementType:new primitives.common.EnumerationReader(primitives.common.ConnectorPlacementType,false,defaultConnectorAnnotationConfig.connectorPlacementType),labelPlacementType:new primitives.common.EnumerationReader(primitives.common.ConnectorLabelPlacementType,false,defaultConnectorAnnotationConfig.labelPlacementType),offset:new primitives.common.ObjectReader({left:new primitives.common.ValueReader(["number"],false,defaultConnectorAnnotationConfig.offset.left),top:new primitives.common.ValueReader(["number"],false,defaultConnectorAnnotationConfig.offset.top),right:new primitives.common.ValueReader(["number"],false,defaultConnectorAnnotationConfig.offset.right),bottom:new primitives.common.ValueReader(["number"],false,defaultConnectorAnnotationConfig.offset.bottom)},false,defaultConnectorAnnotationConfig.offset),lineWidth:new primitives.common.ValueReader(["number"],false,defaultConnectorAnnotationConfig.lineWidth),color:new primitives.common.ValueReader(["string"],false,defaultConnectorAnnotationConfig.color),lineType:new primitives.common.EnumerationReader(primitives.common.LineType,false,defaultConnectorAnnotationConfig.lineType),selectItems:new primitives.common.ValueReader(["boolean"],false,defaultConnectorAnnotationConfig.selectItems),label:new primitives.common.ValueReader(["string"],false,defaultConnectorAnnotationConfig.label),labelSize:new primitives.common.ObjectReader({width:new primitives.common.ValueReader(["number"],false,defaultConnectorAnnotationConfig.labelSize.width),height:new primitives.common.ValueReader(["number"],false,defaultConnectorAnnotationConfig.labelSize.height)},false,defaultConnectorAnnotationConfig.labelSize)}),false);function process(){var context={isChanged:false,hash:_hash};_annotations=_dataTemplate.read(_annotations,splitAnnotationsOptionTask.getAnnotations(0/*primitives.common.AnnotationType.Connector*/,zOrderType),"annotations",context);return context.isChanged;}function getAnnotations(){return _annotations;}return{process:process,getAnnotations:getAnnotations};};/* /Controls/OrgDiagram/Tasks/Options/Annotations/HighlightPathAnnotationOptionTask.js*/primitives.orgdiagram.HighlightPathAnnotationOptionTask=function(splitAnnotationsOptionTask,defaultHighlightPathAnnotationConfig,zOrderType){var _data={},_annotations=[],_hash={};var _dataAnnotationsTemplate=new primitives.common.ArrayReader(new primitives.common.ObjectReader({zOrderType:new primitives.common.EnumerationReader(primitives.common.ZOrderType,false,defaultHighlightPathAnnotationConfig.zOrderType),lineWidth:new primitives.common.ValueReader(["number"],false,defaultHighlightPathAnnotationConfig.lineWidth),opacity:new primitives.common.ValueReader(["number"],false,defaultHighlightPathAnnotationConfig.opacity),color:new primitives.common.ValueReader(["string"],false,defaultHighlightPathAnnotationConfig.color),lineType:new primitives.common.EnumerationReader(primitives.common.LineType,false,defaultHighlightPathAnnotationConfig.lineType),items:new primitives.common.ArrayReader(new primitives.common.ValueReader(["string","number"],true),false),selectItems:new primitives.common.ValueReader(["boolean"],false,defaultHighlightPathAnnotationConfig.selectItems),showArrows:new primitives.common.ValueReader(["boolean"],false,defaultHighlightPathAnnotationConfig.showArrows)},false));function process(){var context={isChanged:false,hash:_hash};_annotations=_dataAnnotationsTemplate.read(_annotations,splitAnnotationsOptionTask.getAnnotations(2/*primitives.common.AnnotationType.HighlightPath*/,zOrderType),"annotations",context);return context.isChanged;}function getAnnotations(){return _annotations;}return{process:process,getAnnotations:getAnnotations};};/* /Controls/OrgDiagram/Tasks/Options/Annotations/ShapeAnnotationOptionTask.js*/primitives.orgdiagram.ShapeAnnotationOptionTask=function(splitAnnotationsOptionTask,defaultShapeAnnotationConfig,zOrderType){var _annotations=[],_hash={};var _dataTemplate=new primitives.common.ArrayReader(new primitives.common.ObjectReader({zOrderType:new primitives.common.EnumerationReader(primitives.common.ZOrderType,false,defaultShapeAnnotationConfig.zOrderType),items:new primitives.common.ArrayReader(new primitives.common.ValueReader(["string","number"],true),true),shapeType:new primitives.common.EnumerationReader(primitives.common.ShapeType,false,defaultShapeAnnotationConfig.shapeType),offset:new primitives.common.ObjectReader({left:new primitives.common.ValueReader(["number"],false,defaultShapeAnnotationConfig.offset.left),top:new primitives.common.ValueReader(["number"],false,defaultShapeAnnotationConfig.offset.top),right:new primitives.common.ValueReader(["number"],false,defaultShapeAnnotationConfig.offset.right),bottom:new primitives.common.ValueReader(["number"],false,defaultShapeAnnotationConfig.offset.bottom)},false,defaultShapeAnnotationConfig.offset),lineWidth:new primitives.common.ValueReader(["number"],false,defaultShapeAnnotationConfig.lineWidth),cornerRadius:new primitives.common.ValueReader(["string"],false,defaultShapeAnnotationConfig.cornerRadius),opacity:new primitives.common.ValueReader(["number"],false,defaultShapeAnnotationConfig.opacity),borderColor:new primitives.common.ValueReader(["string"],false,defaultShapeAnnotationConfig.borderColor),fillColor:new primitives.common.ValueReader(["string"],false,defaultShapeAnnotationConfig.fillColor),lineType:new primitives.common.EnumerationReader(primitives.common.LineType,false,defaultShapeAnnotationConfig.lineType),selectItems:new primitives.common.ValueReader(["boolean"],false,defaultShapeAnnotationConfig.selectItems),label:new primitives.common.ValueReader(["string"],false,defaultShapeAnnotationConfig.label),labelSize:new primitives.common.ObjectReader({width:new primitives.common.ValueReader(["number"],false,defaultShapeAnnotationConfig.labelSize.width),height:new primitives.common.ValueReader(["number"],false,defaultShapeAnnotationConfig.labelSize.height)},false,defaultShapeAnnotationConfig.labelSize),labelPlacement:new primitives.common.EnumerationReader(primitives.common.PlacementType,false,defaultShapeAnnotationConfig.labelPlacement),labelOffset:new primitives.common.ValueReader(["number"],false,defaultShapeAnnotationConfig.labelOffset)},false));function process(){var context={isChanged:false,hash:_hash};_annotations=_dataTemplate.read(_annotations,splitAnnotationsOptionTask.getAnnotations(1/*primitives.common.AnnotationType.Shape*/,zOrderType),"annotations",context);return context.isChanged;}function getAnnotations(){return _annotations;}return{process:process,getAnnotations:getAnnotations};};/* /Controls/OrgDiagram/Tasks/Options/Annotations/SplitAnnotationsOptionTask.js*/primitives.orgdiagram.SplitAnnotationsOptionTask=function(optionsTask){var _data={annotations:{}};function process(){var options=optionsTask.getOptions(),annotations=options.annotations,index,len,annotationConfig,annotationType,zOrderType,key,hash={};if(primitives.common.isArray(annotations)){for(index=0,len=annotations.length;index<len;index+=1){annotationConfig=annotations[index];annotationType=annotationConfig.annotationType;switch(annotationType){case 1/*primitives.common.AnnotationType.Shape*/:case 0/*primitives.common.AnnotationType.Connector*/:case 2/*primitives.common.AnnotationType.HighlightPath*/:switch(annotationConfig.zOrderType){case 1/*primitives.common.ZOrderType.Background*/:zOrderType=1/*primitives.common.ZOrderType.Background*/;break;case 2/*primitives.common.ZOrderType.Foreground*/:case 0/*primitives.common.ZOrderType.Auto*/://ignore jslint
	default:zOrderType=2/*primitives.common.ZOrderType.Foreground*/;break;}break;case 4/*primitives.common.AnnotationType.Background*/:case 3/*primitives.common.AnnotationType.Label*/://ignore jslint
	default:zOrderType=null;break;}if(annotationType!=null){key=annotationType*1000+(zOrderType||0);if(!hash.hasOwnProperty(key)){hash[key]=[];}hash[key].push(annotationConfig);}}}_data.annotations=hash;return true;}function getAnnotations(annotationType,zOrderType){var key=annotationType*1000+(zOrderType||0);return _data.annotations[key];}return{process:process,getAnnotations:getAnnotations};};/* /Controls/OrgDiagram/Tasks/Options/Selection/CursorItemOptionTask.js*/primitives.orgdiagram.CursorItemOptionTask=function(optionsTask,defaultConfig){var _data={};var _dataTemplate=new primitives.common.ObjectReader({cursorItem:new primitives.common.ValueReader(["string","number"],true),navigationMode:new primitives.common.EnumerationReader(primitives.common.NavigationMode,false,defaultConfig.navigationMode)});function process(){var context={isChanged:false};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getCursorItem(){return _data.cursorItem;}function hasCursorEnabled(){switch(_data.navigationMode){case 0/*primitives.common.NavigationMode.Default*/:case 1/*primitives.common.NavigationMode.CursorOnly*/:return true;}return false;}return{process:process,getCursorItem:getCursorItem,hasCursorEnabled:hasCursorEnabled,description:"Checks currenct cursor item option."};};/* /Controls/OrgDiagram/Tasks/Options/Selection/CursorSelectionPathModeOptionTask.js*/primitives.orgdiagram.CursorSelectionPathModeOptionTask=function(optionsTask,defaultConfig){var _data={};var _dataTemplate=new primitives.common.ObjectReader({selectionPathMode:new primitives.common.EnumerationReader(primitives.common.SelectionPathMode,false,defaultConfig.selectionPathMode)});function process(){var context={isChanged:false};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getSelectionPathMode(){return _data.selectionPathMode;}return{process:process,getSelectionPathMode:getSelectionPathMode,description:"Checks cursor selection path option."};};/* /Controls/OrgDiagram/Tasks/Options/Selection/HighlightItemOptionTask.js*/primitives.orgdiagram.HighlightItemOptionTask=function(optionsTask,defaultConfig){var _data={};var _dataTemplate=new primitives.common.ObjectReader({highlightItem:new primitives.common.ValueReader(["string","number"],true),navigationMode:new primitives.common.EnumerationReader(primitives.common.NavigationMode,false,defaultConfig.navigationMode),highlightGravityRadius:new primitives.common.ValueReader(["number"],false,defaultConfig.highlightGravityRadius)});function process(){var context={isChanged:false};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getHighlightItem(){return _data.highlightItem;}function getGravityRadius(){return _data.highlightGravityRadius;}function hasHighlightEnabled(){switch(_data.navigationMode){case 0/*primitives.common.NavigationMode.Default*/:case 3/*primitives.common.NavigationMode.HighlightOnly*/:return true;}return false;}return{process:process,getHighlightItem:getHighlightItem,hasHighlightEnabled:hasHighlightEnabled,getGravityRadius:getGravityRadius,description:"Checks highlight item option."};};/* /Controls/OrgDiagram/Tasks/Options/Selection/SelectedItemsOptionTask.js*/primitives.orgdiagram.SelectedItemsOptionTask=function(optionsTask){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({selectedItems:new primitives.common.ArrayReader(new primitives.common.ValueReader(["string","number"],true),true)});function process(){var context={isChanged:false,hash:_hash},options=optionsTask.getOptions();_data=_dataTemplate.read(_data,options,"options",context);return context.isChanged;}function getSelectedItems(){return _data.selectedItems;}return{process:process,getSelectedItems:getSelectedItems,description:"Checks user selected items option."};};/* /Controls/OrgDiagram/Tasks/Options/CalloutOptionTask.js*/primitives.orgdiagram.CalloutOptionTask=function(optionsTask,defaultConfig,defaultItemConfig){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({showCallout:new primitives.common.ValueReader(["boolean"],false,defaultConfig.showCallout),calloutPlacementOffset:new primitives.common.ValueReader(["number"],false,defaultConfig.calloutPlacementOffset),orientationType:new primitives.common.EnumerationReader(primitives.common.OrientationType,false,defaultConfig.orientationType),defaultTemplateName:new primitives.common.ValueReader(["string"],true),defaultCalloutTemplateName:new primitives.common.ValueReader(["string"],true),calloutfillColor:new primitives.common.ValueReader(["string"],false,defaultConfig.calloutfillColor),calloutBorderColor:new primitives.common.ValueReader(["string"],true),calloutOffset:new primitives.common.ValueReader(["number"],false,defaultConfig.calloutOffset),calloutCornerRadius:new primitives.common.ValueReader(["string"],false,defaultConfig.calloutCornerRadius),calloutPointerWidth:new primitives.common.ValueReader(["string"],false,defaultConfig.calloutPointerWidth),calloutLineWidth:new primitives.common.ValueReader(["number"],false,defaultConfig.calloutLineWidth),calloutOpacity:new primitives.common.ValueReader(["number"],false,defaultConfig.calloutOpacity),items:new primitives.common.ArrayReader(new primitives.common.ObjectReader({id:new primitives.common.ValueReader(["string","number"],true),showCallout:new primitives.common.ValueReader(["boolean"],false,defaultItemConfig.showCallout),calloutTemplateName:new primitives.common.ValueReader(["string"],true),templateName:new primitives.common.ValueReader(["string"],true)}),true,"id")});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getItemOptions(itemid){return _hash["options-items"][itemid];}function getOptions(){return _data;}return{process:process,getOptions:getOptions,getItemOptions:getItemOptions,description:"Checks item callout options."};};/* /Controls/OrgDiagram/Tasks/Options/ConnectorsOptionTask.js*/primitives.orgdiagram.ConnectorsOptionTask=function(optionsTask,defaultConfig){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({arrowsDirection:new primitives.common.EnumerationReader(primitives.common.GroupByType,false,defaultConfig.arrowsDirection),showExtraArrows:new primitives.common.ValueReader(["boolean"],false,defaultConfig.showExtraArrows),extraArrowsMinimumSpace:new primitives.common.ValueReader(["number"],false,defaultConfig.extraArrowsMinimumSpace),connectorType:new primitives.common.EnumerationReader(primitives.common.ConnectorType,false,defaultConfig.hasOwnProperty("connectorType")?defaultConfig.connectorType:0/*primitives.common.ConnectorType.Squared*/),showNeigboursConnectorsHighlighted:new primitives.common.EnumerationReader(primitives.common.ConnectorType,false,defaultConfig.hasOwnProperty("showNeigboursConnectorsHighlighted")?defaultConfig.showNeigboursConnectorsHighlighted:false),elbowType:new primitives.common.EnumerationReader(primitives.common.ElbowType,false,defaultConfig.elbowType),bevelSize:new primitives.common.ValueReader(["number"],false,defaultConfig.bevelSize),elbowDotSize:new primitives.common.ValueReader(["number"],false,defaultConfig.elbowDotSize),linesColor:new primitives.common.ValueReader(["string"],false,defaultConfig.linesColor),linesWidth:new primitives.common.ValueReader(["number"],false,defaultConfig.linesWidth),linesType:new primitives.common.EnumerationReader(primitives.common.LineType,false,defaultConfig.linesType),highlightLinesColor:new primitives.common.ValueReader(["string"],false,defaultConfig.highlightLinesColor),highlightLinesWidth:new primitives.common.ValueReader(["number"],false,defaultConfig.highlightLinesWidth),highlightLinesType:new primitives.common.EnumerationReader(primitives.common.LineType,false,defaultConfig.highlightLinesType)});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getOptions(){return _data;}return{process:process,getOptions:getOptions,description:"Checks connector lines drawing options."};};/* /Controls/OrgDiagram/Tasks/Options/ItemsOptionTask.js*/primitives.orgdiagram.ItemsOptionTask=function(optionsTask,defaultItemConfig){var _data={},_hash={},_sourceHash={};var _dataTemplate=new primitives.common.ObjectReader({items:new primitives.common.ArrayReader(new primitives.common.ObjectReader({id:new primitives.common.ValueReader(["string","number"],true),parent:new primitives.common.ValueReader(["string","number"],true),itemType:new primitives.common.EnumerationReader(primitives.orgdiagram.ItemType,false,defaultItemConfig.itemType),adviserPlacementType:new primitives.common.EnumerationReader(primitives.common.AdviserPlacementType,false,defaultItemConfig.adviserPlacementType),childrenPlacementType:new primitives.common.EnumerationReader(primitives.common.ChildrenPlacementType,false,defaultItemConfig.childrenPlacementType),isVisible:new primitives.common.ValueReader(["boolean"],false,defaultItemConfig.isVisible),isActive:new primitives.common.ValueReader(["boolean"],false,defaultItemConfig.isActive)}),true,"id",true,true)});function process(){var context={isChanged:false,hash:_hash,sourceHash:_sourceHash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getItems(){return _data.items;}function getConfig(itemId){return _sourceHash["options-items"][itemId];}return{process:process,getItems:getItems,getConfig:getConfig,description:"Checks items configuration options effecting their placement in layout."};};/* /Controls/OrgDiagram/Tasks/Options/ItemsSizesOptionTask.js*/primitives.orgdiagram.ItemsSizesOptionTask=function(optionsTask,defaultConfig,defaultItemConfig,defaultButtonConfig){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({/*item template options*/defaultTemplateName:new primitives.common.ValueReader(["string"],true),defaultLabelAnnotationTemplate:new primitives.common.ValueReader(["string"],true),hasSelectorCheckbox:new primitives.common.EnumerationReader(primitives.common.Enabled,false,defaultConfig.hasSelectorCheckbox),hasButtons:new primitives.common.EnumerationReader(primitives.common.Enabled,false,defaultConfig.hasButtons),buttonsPanelSize:new primitives.common.ValueReader(["number"],false,defaultConfig.buttonsPanelSize),groupTitlePanelSize:new primitives.common.ValueReader(["number"],false,defaultConfig.groupTitlePanelSize),checkBoxPanelSize:new primitives.common.ValueReader(["number"],false,defaultConfig.checkBoxPanelSize),selectCheckBoxLabel:new primitives.common.ValueReader(["string"],false,defaultConfig.selectCheckBoxLabel),buttons:new primitives.common.ArrayReader(new primitives.common.ObjectReader({name:new primitives.common.ValueReader(["string"],true),icon:new primitives.common.ValueReader(["string"],true),text:new primitives.common.ValueReader(["boolean"],false,false),tooltip:new primitives.common.ValueReader(["string"],true),size:new primitives.common.ObjectReader({width:new primitives.common.ValueReader(["number"],false,defaultButtonConfig.size.width),height:new primitives.common.ValueReader(["number"],false,defaultButtonConfig.size.height)},false,defaultButtonConfig.size)}),true,"name"),/* items visibility */pageFitMode:new primitives.common.EnumerationReader(primitives.common.PageFitMode,false,defaultConfig.pageFitMode),minimalVisibility:new primitives.common.EnumerationReader(primitives.common.Visibility,false,defaultConfig.minimalVisibility),selectionPathMode:new primitives.common.EnumerationReader(primitives.common.SelectionPathMode,false,defaultConfig.selectionPathMode),autoSizeMinimum:new primitives.common.ObjectReader({width:new primitives.common.ValueReader(["number"],false,defaultConfig.autoSizeMinimum.width),height:new primitives.common.ValueReader(["number"],false,defaultConfig.autoSizeMinimum.height)},false,defaultConfig.autoSizeMinimum),autoSizeMaximum:new primitives.common.ObjectReader({width:new primitives.common.ValueReader(["number"],false,defaultConfig.autoSizeMaximum.width),height:new primitives.common.ValueReader(["number"],false,defaultConfig.autoSizeMaximum.height)},false,defaultConfig.autoSizeMaximum),/* scale */scale:new primitives.common.ValueReader(["number"],false,defaultConfig.scale),maximumScale:new primitives.common.ValueReader(["number"],false,defaultConfig.maximumScale),minimumScale:new primitives.common.ValueReader(["number"],false,defaultConfig.minimumScale),/*intervals*/normalLevelShift:new primitives.common.ValueReader(["number"],false,defaultConfig.normalLevelShift),dotLevelShift:new primitives.common.ValueReader(["number"],false,defaultConfig.dotLevelShift),lineLevelShift:new primitives.common.ValueReader(["number"],false,defaultConfig.lineLevelShift),normalItemsInterval:new primitives.common.ValueReader(["number"],false,defaultConfig.normalItemsInterval),dotItemsInterval:new primitives.common.ValueReader(["number"],false,defaultConfig.dotItemsInterval),lineItemsInterval:new primitives.common.ValueReader(["number"],false,defaultConfig.lineItemsInterval),/*cousiins branches interval multiplier*/cousinsIntervalMultiplier:new primitives.common.ValueReader(["number"],false,defaultConfig.cousinsIntervalMultiplier),verticalAlignment:new primitives.common.EnumerationReader(primitives.common.VerticalAlignmentType,false,defaultConfig.verticalAlignment),items:new primitives.common.ArrayReader(new primitives.common.ObjectReader({id:new primitives.common.ValueReader(["string","number"],true),groupTitle:new primitives.common.ValueReader(["string","number"],true),isVisible:new primitives.common.ValueReader(["boolean","number"],false,defaultItemConfig.isVisible),isActive:new primitives.common.ValueReader(["boolean","number"],false,defaultItemConfig.isActive),hasSelectorCheckbox:new primitives.common.EnumerationReader(primitives.common.Enabled,false,defaultItemConfig.hasSelectorCheckbox),hasButtons:new primitives.common.EnumerationReader(primitives.common.Enabled,false,defaultItemConfig.hasButtons),templateName:new primitives.common.ValueReader(["string"],true)}),true,"id")});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getItemOptions(itemid){return _hash["options-items"][itemid];}function getOptions(){return _data;}return{process:process,getItemOptions:getItemOptions,getOptions:getOptions,description:"Checks items size options."};};/* /Controls/OrgDiagram/Tasks/Options/LabelsOptionTask.js*/primitives.orgdiagram.LabelsOptionTask=function(optionsTask,defaultConfig,defaultItemConfig){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({showLabels:new primitives.common.EnumerationReader(primitives.common.Enabled,false,defaultConfig.showLabels),labelOffset:new primitives.common.ValueReader(["number"],false,defaultConfig.labelOffset),labelFontSize:new primitives.common.ValueReader(["string"],false,defaultConfig.labelFontSize),labelFontFamily:new primitives.common.ValueReader(["string"],false,defaultConfig.labelFontFamily),labelFontStyle:new primitives.common.ValueReader(["string"],false,defaultConfig.labelFontStyle),labelFontWeight:new primitives.common.ValueReader(["string"],false,defaultConfig.labelFontWeight),labelColor:new primitives.common.ValueReader(["string"],false,defaultConfig.labelColor),labelSize:new primitives.common.ObjectReader({width:new primitives.common.ValueReader(["number"],false,defaultConfig.labelSize.width),height:new primitives.common.ValueReader(["number"],false,defaultConfig.labelSize.height)},false,defaultConfig.labelSize),labelOrientation:new primitives.common.EnumerationReader(primitives.text.TextOrientationType,false,defaultConfig.labelOrientation),labelPlacement:new primitives.common.EnumerationReader(primitives.common.PlacementType,false,defaultConfig.labelPlacement),arrowsDirection:new primitives.common.EnumerationReader(primitives.common.GroupByType,false,defaultConfig.arrowsDirection),items:new primitives.common.ArrayReader(new primitives.common.ObjectReader({id:new primitives.common.ValueReader(["string","number"],true),label:new primitives.common.ValueReader(["string","number"],true),showLabel:new primitives.common.EnumerationReader(primitives.common.Enabled,false,defaultItemConfig.showLabel),labelSize:new primitives.common.ObjectReader({width:new primitives.common.ValueReader(["number"],false,0),height:new primitives.common.ValueReader(["number"],false,0)},true),labelOrientation:new primitives.common.EnumerationReader(primitives.text.TextOrientationType,false,defaultItemConfig.labelOrientation),labelPlacement:new primitives.common.EnumerationReader(primitives.common.PlacementType,false,defaultItemConfig.labelPlacement)}),true,"id")});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getItemOptions(itemid){return _hash["options-items"][itemid];}function getOptions(){return _data;}return{process:process,getItemOptions:getItemOptions,getOptions:getOptions,description:"Checks items labels options."};};/* /Controls/OrgDiagram/Tasks/Options/MinimizedItemsOptionTask.js*/primitives.orgdiagram.MinimizedItemsOptionTask=function(optionsTask){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({minimizedItemShapeType:new primitives.common.EnumerationReader(primitives.common.ShapeType,true),items:new primitives.common.ArrayReader(new primitives.common.ObjectReader({id:new primitives.common.ValueReader(["string","number"],true),minimizedItemShapeType:new primitives.common.EnumerationReader(primitives.common.ShapeType,true),itemTitleColor:new primitives.common.ValueReader(["string"],true)}),true,"id")});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getItemOptions(itemid){return _hash["options-items"][itemid];}function getOptions(){return _data;}return{process:process,getItemOptions:getItemOptions,getOptions:getOptions,description:"Checks minimized items drawing options."};};/* /Controls/OrgDiagram/Tasks/Options/OptionsTask.js*/primitives.orgdiagram.OptionsTask=function(getOptions){function process(){return true;}return{process:process,getOptions:getOptions,description:"Raw options."};};/* /Controls/OrgDiagram/Tasks/Options/OrientationOptionTask.js*/primitives.orgdiagram.OrientationOptionTask=function(optionsTask,defaultConfig){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({orientationType:new primitives.common.EnumerationReader(primitives.common.OrientationType,false,defaultConfig.orientationType)});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getOptions(){return _data;}return{process:process,getOptions:getOptions,description:"Checks diagram orientation options."};};/* /Controls/OrgDiagram/Tasks/Options/PrintPreviewOptionTask.js*/primitives.orgdiagram.PrintPreviewOptionTask=function(optionsTask,defaultConfig){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({pageFitMode:new primitives.common.EnumerationReader(primitives.common.PageFitMode,false,defaultConfig.pageFitMode),printPreviewPageSize:new primitives.common.ObjectReader({width:new primitives.common.ValueReader(["number"],false,defaultConfig.printPreviewPageSize.width),height:new primitives.common.ValueReader(["number"],false,defaultConfig.printPreviewPageSize.height)},false,defaultConfig.printPreviewPageSize)});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getOptions(){return _data;}return{process:process,getOptions:getOptions,description:"Checks options of print preview mode."};};/* /Controls/OrgDiagram/Tasks/Options/ScaleOptionTask.js*/primitives.orgdiagram.ScaleOptionTask=function(optionsTask,defaultConfig){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({scale:new primitives.common.ValueReader(["number"],false,defaultConfig.scale),minimumScale:new primitives.common.ValueReader(["number"],false,defaultConfig.minimumScale),maximumScale:new primitives.common.ValueReader(["number"],false,defaultConfig.maximumScale)});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getOptions(){return _data;}return{process:process,getOptions:getOptions,description:"Checks control scale options."};};/* /Controls/OrgDiagram/Tasks/Options/TemplatesOptionTask.js*/primitives.orgdiagram.TemplatesOptionTask=function(optionsTask,defaultConfig,defaultButtonConfig,defaultTemplateConfig){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({groupTitleVerticalAlignment:new primitives.common.EnumerationReader(primitives.common.VerticalAlignmentType,false,defaultConfig.groupTitleVerticalAlignment),groupTitleHorizontalAlignment:new primitives.common.EnumerationReader(primitives.common.HorizontalAlignmentType,false,defaultConfig.groupTitleHorizontalAlignment),groupTitleOrientation:new primitives.common.EnumerationReader(primitives.text.TextOrientationType,false,defaultConfig.groupTitleOrientation),groupTitleFontSize:new primitives.common.ValueReader(["string"],false,defaultConfig.groupTitleFontSize),groupTitleFontFamily:new primitives.common.ValueReader(["string"],false,defaultConfig.groupTitleFontFamily),groupTitleColor:new primitives.common.ValueReader(["string"],false,defaultConfig.groupTitleColor),groupTitleFontWeight:new primitives.common.ValueReader(["string"],false,defaultConfig.groupTitleFontWeight),groupTitleFontStyle:new primitives.common.ValueReader(["string"],false,defaultConfig.groupTitleFontStyle),itemTitleFirstFontColor:new primitives.common.ValueReader(["string"],false,defaultConfig.itemTitleFirstFontColor),itemTitleSecondFontColor:new primitives.common.ValueReader(["string"],false,defaultConfig.itemTitleSecondFontColor),selectCheckBoxLabel:new primitives.common.ValueReader(["string"],false,defaultConfig.selectCheckBoxLabel),onItemRender:new primitives.common.FunctionReader(),onCursorRender:new primitives.common.FunctionReader(),onHighlightRender:new primitives.common.FunctionReader(),templates:new primitives.common.ArrayReader(new primitives.common.ObjectReader({name:new primitives.common.ValueReader(["string"],true),isActive:new primitives.common.ValueReader(["boolean"],false,defaultTemplateConfig.isActive),itemSize:new primitives.common.ObjectReader({width:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.itemSize.width),height:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.itemSize.height)},false,defaultTemplateConfig.itemSize),itemBorderWidth:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.itemBorderWidth),itemTemplate:new primitives.common.ValueReader(["string"],true),minimizedItemShapeType:new primitives.common.EnumerationReader(primitives.common.ShapeType,true),minimizedItemSize:new primitives.common.ObjectReader({width:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.minimizedItemSize.width),height:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.minimizedItemSize.height)},false,defaultTemplateConfig.minimizedItemSize),minimizedItemCornerRadius:new primitives.common.ValueReader(["number"],true),minimizedItemLineWidth:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.minimizedItemLineWidth),minimizedItemBorderColor:new primitives.common.ValueReader(["string"],true),minimizedItemLineType:new primitives.common.EnumerationReader(primitives.common.LineType,false,defaultTemplateConfig.minimizedItemLineType),minimizedItemFillColor:new primitives.common.ValueReader(["string"],true),minimizedItemOpacity:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.minimizedItemOpacity),highlightPadding:new primitives.common.ObjectReader({left:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.highlightPadding.left),top:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.highlightPadding.top),right:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.highlightPadding.right),bottom:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.highlightPadding.bottom)},false,defaultTemplateConfig.highlightPadding),highlightBorderWidth:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.highlightBorderWidth),highlightTemplate:new primitives.common.ValueReader(["string"],true),cursorPadding:new primitives.common.ObjectReader({left:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.cursorPadding.left),top:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.cursorPadding.top),right:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.cursorPadding.right),bottom:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.cursorPadding.bottom)},false,defaultTemplateConfig.cursorPadding),cursorBorderWidth:new primitives.common.ValueReader(["number"],false,defaultTemplateConfig.cursorBorderWidth),cursorTemplate:new primitives.common.ValueReader(["string"],true),buttons:new primitives.common.ArrayReader(new primitives.common.ObjectReader({name:new primitives.common.ValueReader(["string"],true),icon:new primitives.common.ValueReader(["string"],true),text:new primitives.common.ValueReader(["boolean"],false,false),tooltip:new primitives.common.ValueReader(["string"],true),size:new primitives.common.ObjectReader({width:new primitives.common.ValueReader(["number"],false,defaultButtonConfig.size.width),height:new primitives.common.ValueReader(["number"],false,defaultButtonConfig.size.height)},false,defaultButtonConfig.size)}),true,"name")}),true,"name")});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getOptions(){return _data;}return{process:process,getOptions:getOptions,description:"Checks items template options."};};/* /Controls/OrgDiagram/Tasks/Options/VisualTreeOptionTask.js*/primitives.orgdiagram.VisualTreeOptionTask=function(optionsTask,defaultConfig){var _data={},_hash={};var _dataTemplate=new primitives.common.ObjectReader({leavesPlacementType:new primitives.common.EnumerationReader(primitives.common.ChildrenPlacementType,false,defaultConfig.leavesPlacementType),childrenPlacementType:new primitives.common.EnumerationReader(primitives.common.ChildrenPlacementType,false,defaultConfig.childrenPlacementType),maximumColumnsInMatrix:new primitives.common.ValueReader(["number"],false,defaultConfig.maximumColumnsInMatrix),horizontalAlignment:new primitives.common.EnumerationReader(primitives.common.HorizontalAlignmentType,false,defaultConfig.horizontalAlignment)});function process(){var context={isChanged:false,hash:_hash};_data=_dataTemplate.read(_data,optionsTask.getOptions(),"options",context);return context.isChanged;}function getOptions(){return _data;}return{process:process,getOptions:getOptions,description:"Checks items layout options."};};/* /Controls/OrgDiagram/Tasks/Renders/OffsetResolver/CollinearVectorBundle.js*/primitives.orgdiagram.CollinearVectorBundle=function(){var _boundingRect=new primitives.common.Rect(),_vectors=[],_continuations=[];function addVector(vector,continuation){_vectors.push(vector);_continuations.push(continuation);_boundingRect.addRect(vector.from.x,vector.from.y);_boundingRect.addRect(vector.to.x,vector.to.y);}function loopProjections(callback){// calback(from, to)
	var index,len,vector;if(_boundingRect.width>_boundingRect.height){for(index=0,len=_vectors.length;index<len;index+=1){vector=_vectors[index];callback(vector.from.x,vector.to.x,_continuations[index]);}}else{for(index=0,len=_vectors.length;index<len;index+=1){vector=_vectors[index];callback(vector.from.y,vector.to.y,_continuations[index]);}}}function resolve(){if(_vectors.length==1){_continuations[0](0,1,1);}else{var stackSegments=primitives.common.pile();loopProjections(function(from,to,continuation){stackSegments.add(from,to,continuation);});var totalOffset=stackSegments.resolve(this,function(from,to,context,offset,bundleSize,direction){context(offset,bundleSize,direction);});}}return{addVector:addVector,resolve:resolve};};/* /Controls/OrgDiagram/Tasks/Renders/OffsetResolver/ConnectorAnnotationOffsetResolver.js*/primitives.orgdiagram.ConnectorAnnotationOffsetResolver=function(){var _bundles={};function getOffset(vector,callback){var key=vector.getLineKey();if(!_bundles.hasOwnProperty(key)){_bundles[key]=new primitives.orgdiagram.CollinearVectorBundle();}_bundles[key].addVector(vector,callback);}function resolve(){for(var key in _bundles){if(_bundles.hasOwnProperty(key)){var bundle=_bundles[key];bundle.resolve();}}}return{getOffset:getOffset,resolve:resolve};};/* /Controls/OrgDiagram/Tasks/Renders/DrawBackgroundAnnotationTask.js*/primitives.orgdiagram.DrawBackgroundAnnotationTask=function(getGraphics,createTranfromTask,applyLayoutChangesTask,backgroundAnnotationOptionTask,navigationFamilyTask,alignDiagramTask,backgroundAnnotationManagerTask){var _graphics,_transform;function process(){var annotations=backgroundAnnotationOptionTask.getAnnotations(),backgroundManager,navigationFamily;_graphics=getGraphics();_graphics.reset("placeholder",2/*primitives.common.Layers.BackgroundAnnotation*/);if(annotations.length>0){_transform=createTranfromTask.getTransform();backgroundManager=backgroundAnnotationManagerTask.getBackgroundManager();navigationFamily=navigationFamilyTask.getNavigationFamily();drawAnnotations(annotations,backgroundManager,navigationFamily);}return false;}function drawAnnotations(annotations,backgroundManager,navigationFamily){var panel,index,len,index2,len2,index3,len3,fromItem,toItem,shape,defaultConfig,items,itemsHash,item,position,properties,property,annotationConfig,uiHash,perimeters,treeItem,treeItemPosition;for(index=0,len=annotations.length;index<len;index+=1){annotationConfig=annotations[index];if(annotationConfig.items!=null&&annotationConfig.items.length>0){shape=new primitives.common.Perimeter(_graphics);shape.transform=_transform;defaultConfig=new primitives.orgdiagram.BackgroundAnnotationConfig();properties=["opacity","lineWidth","borderColor","fillColor","lineType"];for(index3=0,len3=properties.length;index3<len3;index3+=1){property=properties[index3];shape[property]=annotationConfig.hasOwnProperty(property)?annotationConfig[property]:defaultConfig[property];}panel=_graphics.activate("placeholder",2/*primitives.common.Layers.BackgroundAnnotation*/);items=[];itemsHash={};if(annotationConfig.includeChildren){for(index2=0,len2=annotationConfig.items.length;index2<len2;index2+=1){item=annotationConfig.items[index2];treeItemPosition=alignDiagramTask.getItemPosition(item);if(treeItemPosition!=null){itemsHash[item]=true;items.push(item);navigationFamily.loopChildren(this,item,function(childItemId,childItem){if(!itemsHash[childItemId]){itemsHash[childItemId]=true;items.push(childItemId);}});//ignore jslint
	}}}else{items=annotationConfig.items;}perimeters=backgroundManager.getMergedPerimeters(items);for(index2=0;index2<perimeters.length;index2+=1){shape.draw(perimeters[index2]);}}}}return{process:process};};/* /Controls/OrgDiagram/Tasks/Renders/DrawConnectorAnnotationTask.js*/primitives.orgdiagram.DrawConnectorAnnotationTask=function(getGraphics,createTranfromTask,applyLayoutChangesTask,orientationOptionTask,connectorAnnotationOptionTask,alignDiagramTask,annotationLabelTemplateTask,zOrderType){var _graphics,_transform,_orientationOptions,_annotationLabelTemplate,_panelSize;function process(){_graphics=getGraphics();_transform=createTranfromTask.getTransform();_orientationOptions=orientationOptionTask.getOptions();_annotationLabelTemplate=annotationLabelTemplateTask.getTemplate();_panelSize=new primitives.common.Size(alignDiagramTask.getContentSize());switch(zOrderType){case 1/*primitives.common.ZOrderType.Background*/://ignore jslint
	_graphics.reset("placeholder",4/*primitives.common.Layers.BackgroundConnectorAnnotation*/);break;case 2/*primitives.common.ZOrderType.Foreground*/://ignore jslint
	_graphics.reset("placeholder",14/*primitives.common.Layers.ForegroundConnectorAnnotation*/);break;}drawAnnotations(connectorAnnotationOptionTask.getAnnotations(),alignDiagramTask.getItemPosition);return false;}function drawAnnotations(annotations,getItemPosition){var panel,index,len,layer=14/*primitives.common.Layers.ForegroundConnectorAnnotation*/,fromItemPosition,fromActualPosition,toItemPosition,toActualPosition,shape,annotationConfig,uiHash,buffer=new primitives.common.PolylinesBuffer(),labelPlacement,connectorAnnotationOffsetResolver=primitives.orgdiagram.ConnectorAnnotationOffsetResolver(),maximumLineWidth=0;switch(zOrderType){case 1/*primitives.common.ZOrderType.Background*/://ignore jslint
	panel=_graphics.activate("placeholder",4/*primitives.common.Layers.BackgroundConnectorAnnotation*/);break;case 2/*primitives.common.ZOrderType.Foreground*/://ignore jslint
	panel=_graphics.activate("placeholder",14/*primitives.common.Layers.ForegroundConnectorAnnotation*/);break;}for(index=0,len=annotations.length;index<len;index+=1){annotationConfig=annotations[index];maximumLineWidth=Math.max(maximumLineWidth,annotationConfig.lineWidth);}for(index=0,len=annotations.length;index<len;index+=1){annotationConfig=annotations[index];if(annotationConfig.fromItem!=null&&annotationConfig.toItem!=null){fromItemPosition=getItemPosition(annotationConfig.fromItem);toItemPosition=getItemPosition(annotationConfig.toItem);if(fromItemPosition!=null&&toItemPosition!=null){fromActualPosition=fromItemPosition.actualPosition;toActualPosition=toItemPosition.actualPosition;switch(annotationConfig.connectorPlacementType){case 0/*primitives.common.ConnectorPlacementType.Offbeat*/:shape=new primitives.common.ConnectorOffbeat();break;case 1/*primitives.common.ConnectorPlacementType.Straight*/:shape=new primitives.common.ConnectorStraight();break;}/* rotate label size to user orientation */var labelSize;_transform.transformRect(0,0,annotationConfig.labelSize.width,annotationConfig.labelSize.height,false,this,function(x,y,width,height){labelSize=new primitives.common.Size(width,height);});/* rotate panel size to user orientation */var panelSize=null;_transform.transformRect(0,0,_panelSize.width,_panelSize.height,false,this,function(x,y,width,height){panelSize=new primitives.common.Size(width,height);});var linePaletteItem=new primitives.common.PaletteItem({lineColor:annotationConfig.color,lineWidth:annotationConfig.lineWidth,lineType:annotationConfig.lineType});var hasLabel=!primitives.common.isNullOrEmpty(annotationConfig.label);/* offset rectangles */var fromRect=new primitives.common.Rect(fromActualPosition).offset(annotationConfig.offset);var toRect=new primitives.common.Rect(toActualPosition).offset(annotationConfig.offset);var linesOffset=annotationConfig.lineWidth*3;var bundleOffset=maximumLineWidth*6;/* create connection lines */shape.draw(buffer,linePaletteItem,fromRect,toRect,linesOffset,bundleOffset,labelSize,panelSize,annotationConfig.connectorShapeType,4/*labelOffset*/,annotationConfig.labelPlacementType,hasLabel,connectorAnnotationOffsetResolver,function(labelPlacement){if(hasLabel&&labelPlacement!=null){/* translate result label placement back to users orientation */_transform.transformRect(labelPlacement.x,labelPlacement.y,labelPlacement.width,labelPlacement.height,true,this,function(x,y,width,height){labelPlacement=new primitives.common.Rect(x,y,width,height);});uiHash=new primitives.common.RenderEventArgs();uiHash.context=annotationConfig;/* draw label */_graphics.template(labelPlacement.x,labelPlacement.y,0,0,0,0,labelPlacement.width,labelPlacement.height,_annotationLabelTemplate.template(),_annotationLabelTemplate.getHashCode(),_annotationLabelTemplate.render,uiHash,null);}});}}}connectorAnnotationOffsetResolver.resolve();/* translate result polylines back to users orientation */buffer.transform(_transform,true);/* draw background polylines */_graphics.polylinesBuffer(buffer);}return{process:process};};/* /Controls/OrgDiagram/Tasks/Renders/DrawConnectorsTask.js*/primitives.orgdiagram.DrawConnectorsTask=function(getGraphics,connectionsGraphTask,connectorsOptionTask,showElbowDots,paletteManagerTask){var _debug=false;function process(){var graphics=getGraphics();var graph=connectionsGraphTask.getGraph();var connectorsOptions=connectorsOptionTask.getOptions();var paletteManager=paletteManagerTask.getPaletteManager();graphics.reset("placeholder",6/*primitives.common.Layers.Connector*/);graphics.activate("placeholder",6/*primitives.common.Layers.Connector*/);var buffer=new primitives.common.PolylinesBuffer();var elbowDotRadius=Math.round(connectorsOptions.elbowDotSize/2);//var polyline = buffer.getPolyline(paletteManager.getPalette(primitives.common.ConnectorStyleType.Regular));
	var processed={};var processedDots={};graph.loopNodes(this,null,function(itemid){graph.loopNodeEdges(this,itemid,function(to,connectorEdge){if(!processed.hasOwnProperty(to)){var paletteItem=null;if(connectorEdge.fromOffset<=1){paletteItem=paletteManager.getPalette(1/*primitives.common.ConnectorStyleType.Regular*/);}else{paletteManager.selectPalette(connectorEdge.fromOffset);paletteItem=paletteManager.getPalette(0/*primitives.common.ConnectorStyleType.Extra*/);}var polyline=buffer.getPolyline(paletteItem);/* draw intersection dots */if(showElbowDots&&connectorEdge.dotId!=null&&connectorsOptions.elbowType!=0/*primitives.common.ElbowType.None*/&&!processedDots.hasOwnProperty(connectorEdge.dotId)){var dotPolyline=buffer.getPolyline(polyline.arrowPaletteItem);var dotPoint=connectorEdge.dotId==connectorEdge.from?connectorEdge.polyline.getStartPoint():connectorEdge.polyline.getEndPoint();dotPolyline.addSegment(new primitives.common.DotSegment(dotPoint.x-elbowDotRadius,dotPoint.y-elbowDotRadius,elbowDotRadius*2,elbowDotRadius*2,elbowDotRadius));processedDots[connectorEdge.dotId]=true;}var arrowId=null;if(connectorEdge.parentsArrowId!=null&&connectorsOptions.arrowsDirection==1/*primitives.common.GroupByType.Parents*/){arrowId=connectorEdge.parentsArrowId;}else if(connectorEdge.childrenArrowId!=null&&connectorsOptions.arrowsDirection==2/*primitives.common.GroupByType.Children*/){arrowId=connectorEdge.childrenArrowId;}if(arrowId==null){var newSegment=connectorEdge.polyline.clone();if(connectorEdge.hasMiddle&&connectorsOptions.arrowsDirection!=0/*primitives.common.GroupByType.None*/){var isForward=true;if(connectorEdge.from==connectorEdge.middleParent){isForward=connectorsOptions.arrowsDirection==2/*primitives.common.GroupByType.Children*/;}else{isForward=connectorsOptions.arrowsDirection==1/*primitives.common.GroupByType.Parents*/;}newSegment.addOffsetArrow(isForward,connectorsOptions.linesWidth,0.4,connectorsOptions.extraArrowsMinimumSpace,function(arrowPolyline){arrowPolyline.mergeTo(buffer.getPolyline(polyline.arrowPaletteItem));});//ignore jslint
	}if(connectorEdge.from==itemid){newSegment.mergeTo(polyline);}else{polyline.addInverted(newSegment);}}else{if(arrowId==connectorEdge.to){connectorEdge.polyline.clone().mergeTo(polyline);}else{polyline.addInverted(connectorEdge.polyline.clone());}polyline.addArrow(connectorsOptions.linesWidth,function(arrowPolyline){arrowPolyline.mergeTo(buffer.getPolyline(arrowPolyline.paletteItem));});//ignore jslint
	}}});processed[itemid]=true;});graphics.polylinesBuffer(buffer);return false;}return{process:process};};/* /Controls/OrgDiagram/Tasks/Renders/DrawCursorTask.js*/primitives.orgdiagram.DrawCursorTask=function(getGraphics,createTranfromTask,applyLayoutChangesTask,combinedContextsTask,alignDiagramTask,itemTemplateParamsTask,cursorItemTask,selectedItemsTask){var _graphics,_transform;function process(){var treeItemId=cursorItemTask.getCursorTreeItem();_graphics=getGraphics();_graphics.reset("placeholder",11/*primitives.common.Layers.Cursor*/);if(treeItemId!=null){_transform=createTranfromTask.getTransform();drawCursor(treeItemId);}return false;}function drawCursor(treeItemId){var treeItem,uiHash,panel=_graphics.activate("placeholder",11/*primitives.common.Layers.Cursor*/),treeItemPosition=alignDiagramTask.getItemPosition(treeItemId),actualPosition=treeItemPosition.actualPosition,position=new primitives.common.Rect(treeItemPosition.contentPosition),templateParams=itemTemplateParamsTask.getTemplateParams(treeItemId),template=templateParams.template,templateConfig=template.templateConfig,cursorPadding=templateConfig.cursorPadding;position.offset(cursorPadding.left,cursorPadding.top,cursorPadding.right,cursorPadding.bottom);uiHash=new primitives.common.RenderEventArgs();uiHash.context=combinedContextsTask.getConfig(treeItemId);uiHash.isCursor=true;uiHash.isSelected=selectedItemsTask.isSelected(treeItemId);uiHash.templateName=templateConfig.name;_transform.transformRect(actualPosition.x,actualPosition.y,actualPosition.width,actualPosition.height,true,this,function(x,y,width,height){var element=_graphics.template(x,y,width,height,position.x,position.y,position.width,position.height,template.cursorTemplate.template(),template.cursorTemplate.getHashCode(),template.cursorTemplate.render,uiHash,{"border-width":templateConfig.cursorBorderWidth});});}return{process:process};};/* /Controls/OrgDiagram/Tasks/Renders/DrawHighlightAnnotationTask.js*/primitives.orgdiagram.DrawHighlightAnnotationTask=function(getLayout,getGraphics,createTranfromTask,applyLayoutChangesTask,scaleOptionTask,combinedContextsTask,calloutOptionTask,readTemplatesTask,alignDiagramTask,centerOnCursorTask,highlightItemTask,cursorItemTask,selectedItemsTask){var _graphics,_transform,_calloutShape=new primitives.common.Callout(getGraphics()),_options,_layout;function process(){var treeItemId=highlightItemTask.getHighlightTreeItem();_graphics=getGraphics();_graphics.reset("calloutplaceholder",15/*primitives.common.Layers.Annotation*/);if(treeItemId!==null){_transform=createTranfromTask.getTransform();_options=calloutOptionTask.getOptions();_layout=getLayout();drawHighlightAnnotation(treeItemId);}return false;}function drawHighlightAnnotation(treeItemId){var panel,itemConfig,calloutPanelPosition,position,uiHash,element,calloutTemplateName,calloutTemplate,showCallout=true,style,treeItemPosition=alignDiagramTask.getItemPosition(treeItemId),actualPosition=treeItemPosition.actualPosition;switch(treeItemPosition.actualVisibility){case 2/*primitives.common.Visibility.Dot*/:case 3/*primitives.common.Visibility.Line*/:case 1/*primitives.common.Visibility.Normal*/:itemConfig=calloutOptionTask.getItemOptions(treeItemId);switch(itemConfig.showCallout){case 2/*primitives.common.Enabled.False*/:showCallout=false;break;case 1/*primitives.common.Enabled.True*/:showCallout=false;break;default:showCallout=_options.showCallout;break;}if(showCallout){panel=_graphics.activate("placeholder",12/*primitives.common.Layers.Item*/);_transform.transformRect(actualPosition.x,actualPosition.y,actualPosition.width,actualPosition.height,true,this,function(x,y,width,height){var snapRect=new primitives.common.Rect(x,y,width,height),snapPoint=new primitives.common.Point(snapRect.horizontalCenter(),snapRect.verticalCenter()),panelPosition=getPanelPosition();if(treeItemPosition.actualVisibility!=1/*primitives.common.Visibility.Normal*/||!panelPosition.overlaps(snapRect)){calloutTemplateName=!primitives.common.isNullOrEmpty(itemConfig.calloutTemplateName)?itemConfig.calloutTemplateName:!primitives.common.isNullOrEmpty(itemConfig.templateName)?itemConfig.templateName:!primitives.common.isNullOrEmpty(_options.defaultCalloutTemplateName)?_options.defaultCalloutTemplateName:_options.defaultTemplateName;calloutTemplate=readTemplatesTask.getTemplate(calloutTemplateName,readTemplatesTask.DefaultWidgetTemplateName);position=getAnnotationPosition(snapPoint,panelPosition,calloutTemplate.templateConfig.itemSize);/* position callout div placeholder */calloutPanelPosition=new primitives.common.Rect(position);calloutPanelPosition.addRect(snapPoint.x,snapPoint.y);calloutPanelPosition.offset(50);style=calloutPanelPosition.getCSS();style.display="inherit";style.visibility="inherit";_layout.calloutPlaceholder.css(style);/* recalculate geometries */snapPoint.x-=calloutPanelPosition.x;snapPoint.y-=calloutPanelPosition.y;position.x-=calloutPanelPosition.x;position.y-=calloutPanelPosition.y;uiHash=new primitives.common.RenderEventArgs();uiHash.context=combinedContextsTask.getConfig(treeItemId);uiHash.isCursor=cursorItemTask.getCursorTreeItem()==treeItemId;uiHash.isSelected=selectedItemsTask.isSelected(treeItemId);uiHash.templateName=calloutTemplate.templateConfig.name;_graphics.resize("calloutplaceholder",calloutPanelPosition.width,calloutPanelPosition.height);panel=_graphics.activate("calloutplaceholder",15/*primitives.common.Layers.Annotation*/);element=_graphics.template(position.x,position.y,position.width,position.height,0,0,position.width,position.height,calloutTemplate.itemTemplate.template(),calloutTemplate.itemTemplate.getHashCode(),calloutTemplate.itemTemplate.render,uiHash,null);_calloutShape.pointerPlacement=0/*primitives.common.PlacementType.Auto*/;_calloutShape.cornerRadius=_options.calloutCornerRadius;_calloutShape.offset=_options.calloutOffset;_calloutShape.opacity=_options.calloutOpacity;_calloutShape.lineWidth=_options.calloutLineWidth;_calloutShape.pointerWidth=_options.calloutPointerWidth;_calloutShape.borderColor=_options.calloutBorderColor;_calloutShape.fillColor=_options.calloutfillColor;_calloutShape.draw(snapPoint,position);}else{_layout.calloutPlaceholder.css({"display":"none","visibility":"hidden"});}});}else{_layout.calloutPlaceholder.css({"display":"none","visibility":"hidden"});}break;case 4/*primitives.common.Visibility.Invisible*/:_layout.calloutPlaceholder.css({"display":"none","visibility":"hidden"});break;}}function hideHighlightAnnotation(){_layout.calloutPlaceholder.css({"display":"none","visibility":"hidden"});}function getPanelPosition(){var scaleOptions=scaleOptionTask.getOptions(),scale=scaleOptions.scale,placeholderOffset=new primitives.common.Point(centerOnCursorTask.getPlaceholderOffset()),panelSize=alignDiagramTask.getContentSize(),optimalPanelSize=applyLayoutChangesTask.getOptimalPanelSize();placeholderOffset.scale(1.0/scale);optimalPanelSize.scale(1.0/scale);return new primitives.common.Rect(placeholderOffset.x,placeholderOffset.y,Math.min(optimalPanelSize.width,panelSize.width),Math.min(optimalPanelSize.height,panelSize.height));}function getAnnotationPosition(snapPoint,panelRect,itemSize){var result=new primitives.common.Rect(snapPoint.x,snapPoint.y,itemSize.width,itemSize.height);switch(_options.orientationType){case 0/*primitives.common.OrientationType.Top*/:case 1/*primitives.common.OrientationType.Bottom*/:result.y-=itemSize.height/4.0;if(snapPoint.x<panelRect.horizontalCenter()){result.x+=_options.calloutPlacementOffset;}else{result.x-=_options.calloutPlacementOffset+itemSize.width;}break;default:result.x-=itemSize.width/4.0;if(snapPoint.y<panelRect.verticalCenter()){result.y+=_options.calloutPlacementOffset;}else{result.y-=_options.calloutPlacementOffset+itemSize.height;}break;}// If annotation clipped then move it back into view port
	if(result.x<panelRect.x){result.x=panelRect.x+5;}else if(result.right()>panelRect.right()){result.x-=result.right()-panelRect.right()+5;}if(result.y<panelRect.y){result.y=panelRect.y+5;}else if(result.bottom()>panelRect.bottom()){result.y-=result.bottom()-panelRect.bottom()+5;}return result;}return{process:process};};/* /Controls/OrgDiagram/Tasks/Renders/DrawHighlightPathAnnotationTask.js*/primitives.orgdiagram.DrawHighlightPathAnnotationTask=function(getGraphics,connectorsOptionTask,highlightPathAnnotationOptionTask,connectionsGraphTask,zOrderType){function process(){var graph=connectionsGraphTask.getGraph(),highlightOptions=connectorsOptionTask.getOptions(),annotations=highlightPathAnnotationOptionTask.getAnnotations(),graphics=getGraphics();switch(zOrderType){case 1/*primitives.common.ZOrderType.Background*/://ignore jslint
	graphics.reset("placeholder",5/*primitives.common.Layers.BackgroundHighlightPathAnnotations*/);break;case 2/*primitives.common.ZOrderType.Foreground*/://ignore jslint
	graphics.reset("placeholder",7/*primitives.common.Layers.ForegroundHighlightPathAnnotations*/);break;}drawAnnotations(graphics,highlightOptions,annotations,graph);return false;}function drawAnnotations(graphics,highlightOptions,annotations,graph){var index,len,index2,len2,index3,len3,firstItemId,nextItemId,treeItem,path,items,connectorEdge,annotationConfig,panel,buffer,from,to;if(annotations.length>0){buffer=new primitives.common.PolylinesBuffer();switch(zOrderType){case 1/*primitives.common.ZOrderType.Background*/://ignore jslint
	panel=graphics.activate("placeholder",5/*primitives.common.Layers.BackgroundHighlightPathAnnotations*/);break;case 2/*primitives.common.ZOrderType.Foreground*/://ignore jslint
	panel=graphics.activate("placeholder",7/*primitives.common.Layers.ForegroundHighlightPathAnnotations*/);break;}/* group path segments by from node */var pairs={};for(index=0,len=annotations.length;index<len;index+=1){annotationConfig=annotations[index];if(annotationConfig.items!=null&&annotationConfig.items.length>0){items=annotationConfig.items.slice(0);firstItemId=items[0];if(graph.hasNode(firstItemId)){for(index2=1,len2=items.length;index2<len2;index2+=1){nextItemId=items[index2];if(graph.hasNode(nextItemId)){if(pairs.hasOwnProperty(firstItemId)){pairs[firstItemId].push(nextItemId);}else{pairs[firstItemId]=[nextItemId];}firstItemId=nextItemId;}}}}}/* get shortest paths */var paths={};for(from in pairs){paths[from]={};if(pairs.hasOwnProperty(from)){graph.getShortestPath(this,from,pairs[from],function(connectorEdge,fromItem,toItem){return connectorEdge.weight;},function(path2,to2){paths[from][to2]=path2;});//ignore jslint
	}}/* trace annotations */for(index=0,len=annotations.length;index<len;index+=1){annotationConfig=annotations[index];var paletteItem=new primitives.common.PaletteItem({lineColor:annotationConfig.color!=null?annotationConfig.color:highlightOptions.highlightLinesColor,lineWidth:annotationConfig.lineWidth!=null?annotationConfig.lineWidth:highlightOptions.highlightLinesWidth,lineType:annotationConfig.lineType!=null?annotationConfig.lineType:highlightOptions.highlightLinesType,fillColor:null,opacity:annotationConfig.opacity});var polyline=buffer.getPolyline(paletteItem);if(annotationConfig.items!=null&&annotationConfig.items.length>0){items=annotationConfig.items.slice(0);firstItemId=items[0];if(graph.hasNode(firstItemId)){for(index2=1,len2=items.length;index2<len2;index2+=1){nextItemId=items[index2];if(graph.hasNode(nextItemId)){path=paths[firstItemId][nextItemId]||[];for(index3=path.length-2;index3>=0;index3-=1){from=path[index3+1];to=path[index3];connectorEdge=graph.edge(from,to);if(connectorEdge.from==from){connectorEdge.polyline.clone().mergeTo(polyline);}else{polyline.addInverted(connectorEdge.polyline.clone());}if(annotationConfig.showArrows){if(to==connectorEdge.parentsArrowId||to==connectorEdge.childrenArrowId){polyline.addArrow(annotationConfig.lineWidth,function(arrowPolyline){arrowPolyline.mergeTo(buffer.getPolyline(arrowPolyline.paletteItem));});//ignore jslint
	}}}firstItemId=nextItemId;}}}}}graphics.polylinesBuffer(buffer);}}return{process:process};};/* /Controls/OrgDiagram/Tasks/Renders/DrawHighlightTask.js*/primitives.orgdiagram.DrawHighlightTask=function(getGraphics,createTranfromTask,applyLayoutChangesTask,combinedContextsTask,alignDiagramTask,itemTemplateParamsTask,highlightItemTask,cursorItemTask,selectedItemsTask){var _graphics,_transform,_levelsOfLabels=[];function process(){var treeItemId=highlightItemTask.getHighlightTreeItem();_graphics=getGraphics();_graphics.reset("placeholder",8/*primitives.common.Layers.Highlight*/);if(treeItemId!=null){_transform=createTranfromTask.getTransform();drawHighlight(treeItemId);}return false;}function drawHighlight(treeItemId){var uiHash,panel=_graphics.activate("placeholder",8/*primitives.common.Layers.Highlight*/),treeItemPosition=alignDiagramTask.getItemPosition(treeItemId),actualPosition=treeItemPosition.actualPosition,templateParams=itemTemplateParamsTask.getTemplateParams(treeItemId),template=templateParams.template,templateConfig=template.templateConfig,highlightPadding=templateConfig.highlightPadding;uiHash=new primitives.common.RenderEventArgs();uiHash.context=combinedContextsTask.getConfig(treeItemId);uiHash.isCursor=cursorItemTask.getCursorTreeItem()==treeItemId;uiHash.isSelected=selectedItemsTask.isSelected(treeItemId);uiHash.templateName=templateConfig.name;_transform.transformRect(actualPosition.x,actualPosition.y,actualPosition.width,actualPosition.height,true,this,function(x,y,width,height){var position=new primitives.common.Rect(0,0,Math.round(width),Math.round(height));position.offset(highlightPadding.left,highlightPadding.top,highlightPadding.right,highlightPadding.bottom);var element;if(treeItemPosition.actualVisibility==1/*primitives.common.Visibility.Normal*/){element=_graphics.template(x,y,width,height,position.x,position.y,position.width,position.height,template.highlightTemplate.template(),template.highlightTemplate.getHashCode(),template.highlightTemplate.render,uiHash,null);}else{element=_graphics.template(x,y,width,height,position.x,position.y,position.width-1,position.height-1,template.dotHighlightTemplate.template(),template.dotHighlightTemplate.getHashCode(),template.dotHighlightTemplate.render,uiHash,null);}});}return{process:process};};/* /Controls/OrgDiagram/Tasks/Renders/DrawItemLabelsTask.js*/primitives.orgdiagram.DrawItemLabelsTask=function(getGraphics,createTranfromTask,applyLayoutChangesTask,labelsOptionTask,visualTreeLevelsTask,alignDiagramTask){var _graphics,_transform,_treeLevels,_labelsOption;function process(){_graphics=getGraphics();_transform=createTranfromTask.getTransform();_labelsOption=labelsOptionTask.getOptions();_treeLevels=visualTreeLevelsTask.getTreeLevels();_graphics.reset("placeholder",10/*primitives.common.Layers.Label*/);redrawLabels();return false;}function redrawLabels(){var labels,label,label2,index,index2,len,levelIndex,levelsLen,attr,treeLevel,treeLevelFirst,treeLevelSecond;var levelsOfLabels=[];_treeLevels.loopLevels(this,function(levelIndex){var labels=[];_treeLevels.loopLevelItems(this,levelIndex,function(treeItemId){var labelOptions=labelsOptionTask.getItemOptions(treeItemId),treeItemPosition=alignDiagramTask.getItemPosition(treeItemId),actualPosition=treeItemPosition.actualPosition;if(labelOptions!=null){_transform.transformRect(actualPosition.x,actualPosition.y,actualPosition.width,actualPosition.height,true,this,function(x,y,width,height){switch(treeItemPosition.actualVisibility){case 1/*primitives.common.Visibility.Normal*/:if(_labelsOption.showLabels==0/*primitives.common.Enabled.Auto*/){// Don't allow dot's labels overlap normal items
	label=new primitives.common.Label();label.text="dummy";label.position=new primitives.common.Rect(x,y,width,height);label.weight=10000;label.labelType=1/*primitives.common.LabelType.Dummy*/;labels.push(label);}break;case 2/*primitives.common.Visibility.Dot*/:label=createLabel(x,y,width,height,labelOptions,treeItemPosition);if(label!=null){labels.push(label);}break;default:break;}});//ignore jslint
	}});levelsOfLabels[levelIndex]=labels;});var levelsRect=[],levelsHasFixedLabels=[],levelsShowLabels=[];if(_labelsOption.showLabels==0/*primitives.common.Enabled.Auto*/){// Calculate total labels space
	_treeLevels.loopLevels(this,function(levelIndex){var labels=levelsOfLabels[levelIndex],label,levelRect,hasFixedLabels=false;for(index=0,len=labels.length;index<len;index+=1){label=labels[index];if(levelRect==null){levelRect=new primitives.common.Rect(label.position);}else{levelRect.addRect(label.position);}hasFixedLabels=hasFixedLabels||label.labelType==2/*primitives.common.LabelType.Fixed*/;}levelsRect[levelIndex]=levelRect;levelsHasFixedLabels[levelIndex]=hasFixedLabels;});// Hide overlapping rows
	_treeLevels.loopLevelsReversed(this,function(levelIndex){var treeLevelFirstRect=levelsRect[levelIndex-1],treeLevelSecondRect=levelsRect[levelIndex];levelsShowLabels[levelIndex]=true;if(treeLevelFirstRect!=null&&treeLevelSecondRect!=null){if(treeLevelFirstRect.overlaps(treeLevelSecondRect)){levelsShowLabels[levelIndex]=false;}}});// Hide overlapping labels in non-hidden rows
	_treeLevels.loopLevels(this,function(levelIndex){labels=levelsOfLabels[levelIndex];if(levelsShowLabels[levelIndex]){for(index=0,len=labels.length;index<len;index+=1){label=labels[index];if(label.isActive){for(index2=index+1;index2<len;index2+=1){label2=labels[index2];if(label2.isActive){if(label.position.overlaps(label2.position)){if(label.weight>=label2.weight){if(label2.labelType==0/*primitives.common.LabelType.Regular*/){label2.isActive=false;}}else{if(label.labelType==0/*primitives.common.LabelType.Regular*/){label.isActive=false;}break;}}else{break;}}}}}}});}_graphics.activate("placeholder",10/*primitives.common.Layers.Label*/);attr={"font-size":_labelsOption.labelFontSize,"font-family":_labelsOption.labelFontFamily,"font-style":_labelsOption.labelFontStyle,"font-weight":_labelsOption.labelFontWeight,"font-color":_labelsOption.labelColor};_treeLevels.loopLevels(this,function(levelIndex){var labels;if(_labelsOption.showLabels==1/*primitives.common.Enabled.True*/||levelsShowLabels[levelIndex]||levelsHasFixedLabels[levelIndex]){labels=levelsOfLabels[levelIndex];for(index=0,len=labels.length;index<len;index+=1){label=labels[index];if(label.isActive){switch(label.labelType){case 0/*primitives.common.LabelType.Regular*/:case 2/*primitives.common.LabelType.Fixed*/:_graphics.text(label.position.x,label.position.y,label.position.width,label.position.height,label.text,label.labelOrientation,label.horizontalAlignmentType,label.verticalAlignmentType,attr);break;}}}}});}function createLabel(x,y,width,height,labelOptions,treeItemPosition){var labelWidth,labelHeight,result=null,labelOffset=_labelsOption.labelOffset,labelSize,labelPlacement;if(!primitives.common.isNullOrEmpty(labelOptions.label)){switch(labelOptions.showLabel){case 0/*primitives.common.Enabled.Auto*/:switch(_labelsOption.showLabels){case 0/*primitives.common.Enabled.Auto*/:switch(treeItemPosition.actualVisibility){case 3/*primitives.common.Visibility.Line*/:case 2/*primitives.common.Visibility.Dot*/:result=new primitives.common.Label();result.labelType=0/*primitives.common.LabelType.Regular*/;result.weight=treeItemPosition.leftPadding+treeItemPosition.rightPadding;break;default:break;}break;case 2/*primitives.common.Enabled.False*/:break;case 1/*primitives.common.Enabled.True*/:result=new primitives.common.Label();result.labelType=2/*primitives.common.LabelType.Fixed*/;result.weight=10000;break;}break;case 2/*primitives.common.Enabled.False*/:break;case 1/*primitives.common.Enabled.True*/:result=new primitives.common.Label();result.weight=10000;result.labelType=2/*primitives.common.LabelType.Fixed*/;break;}if(result!=null){result.text=labelOptions.label;labelSize=labelOptions.labelSize!=null?labelOptions.labelSize:_labelsOption.labelSize;result.labelOrientation=labelOptions.labelOrientation!=3/*primitives.text.TextOrientationType.Auto*/?labelOptions.labelOrientation:_labelsOption.labelOrientation!=3/*primitives.text.TextOrientationType.Auto*/?_labelsOption.labelOrientation:0/*primitives.text.TextOrientationType.Horizontal*/;labelPlacement=labelOptions.labelPlacement!=0/*primitives.common.PlacementType.Auto*/?labelOptions.labelPlacement:_labelsOption.labelPlacement!=0/*primitives.common.PlacementType.Auto*/?_labelsOption.labelPlacement:1/*primitives.common.PlacementType.Top*/;switch(result.labelOrientation){case 0/*primitives.text.TextOrientationType.Horizontal*/:labelWidth=labelSize.width;labelHeight=labelSize.height;break;case 1/*primitives.text.TextOrientationType.RotateLeft*/:case 2/*primitives.text.TextOrientationType.RotateRight*/:labelHeight=labelSize.width;labelWidth=labelSize.height;break;}switch(labelPlacement){case 0/*primitives.common.PlacementType.Auto*/:case 1/*primitives.common.PlacementType.Top*/:result.position=new primitives.common.Rect(x+width/2.0-labelWidth/2.0,y-labelOffset-labelHeight,labelWidth,labelHeight);switch(result.labelOrientation){case 0/*primitives.text.TextOrientationType.Horizontal*/:result.horizontalAlignmentType=0/*primitives.common.HorizontalAlignmentType.Center*/;result.verticalAlignmentType=2/*primitives.common.VerticalAlignmentType.Bottom*/;break;case 1/*primitives.text.TextOrientationType.RotateLeft*/:result.horizontalAlignmentType=1/*primitives.common.HorizontalAlignmentType.Left*/;result.verticalAlignmentType=1/*primitives.common.VerticalAlignmentType.Middle*/;break;case 2/*primitives.text.TextOrientationType.RotateRight*/:result.horizontalAlignmentType=2/*primitives.common.HorizontalAlignmentType.Right*/;result.verticalAlignmentType=1/*primitives.common.VerticalAlignmentType.Middle*/;break;}break;case 2/*primitives.common.PlacementType.TopRight*/:case 11/*primitives.common.PlacementType.RightTop*/:result.position=new primitives.common.Rect(x+width+labelOffset,y-labelOffset-labelHeight,labelWidth,labelHeight);switch(result.labelOrientation){case 0/*primitives.text.TextOrientationType.Horizontal*/:result.horizontalAlignmentType=1/*primitives.common.HorizontalAlignmentType.Left*/;result.verticalAlignmentType=2/*primitives.common.VerticalAlignmentType.Bottom*/;break;case 1/*primitives.text.TextOrientationType.RotateLeft*/:result.horizontalAlignmentType=1/*primitives.common.HorizontalAlignmentType.Left*/;result.verticalAlignmentType=0/*primitives.common.VerticalAlignmentType.Top*/;break;case 2/*primitives.text.TextOrientationType.RotateRight*/:result.horizontalAlignmentType=2/*primitives.common.HorizontalAlignmentType.Right*/;result.verticalAlignmentType=2/*primitives.common.VerticalAlignmentType.Bottom*/;break;}break;case 3/*primitives.common.PlacementType.Right*/:result.position=new primitives.common.Rect(x+width+labelOffset,y+height/2.0-labelHeight/2.0,labelWidth,labelHeight);switch(result.labelOrientation){case 0/*primitives.text.TextOrientationType.Horizontal*/:result.horizontalAlignmentType=1/*primitives.common.HorizontalAlignmentType.Left*/;result.verticalAlignmentType=1/*primitives.common.VerticalAlignmentType.Middle*/;break;case 1/*primitives.text.TextOrientationType.RotateLeft*/:result.horizontalAlignmentType=0/*primitives.common.HorizontalAlignmentType.Center*/;result.verticalAlignmentType=0/*primitives.common.VerticalAlignmentType.Top*/;break;case 2/*primitives.text.TextOrientationType.RotateRight*/:result.horizontalAlignmentType=0/*primitives.common.HorizontalAlignmentType.Center*/;result.verticalAlignmentType=2/*primitives.common.VerticalAlignmentType.Bottom*/;break;}break;case 4/*primitives.common.PlacementType.BottomRight*/:case 12/*primitives.common.PlacementType.RightBottom*/:result.position=new primitives.common.Rect(x+width+labelOffset,y+height+labelOffset,labelWidth,labelHeight);switch(result.labelOrientation){case 0/*primitives.text.TextOrientationType.Horizontal*/:result.horizontalAlignmentType=1/*primitives.common.HorizontalAlignmentType.Left*/;result.verticalAlignmentType=0/*primitives.common.VerticalAlignmentType.Top*/;break;case 1/*primitives.text.TextOrientationType.RotateLeft*/:result.horizontalAlignmentType=2/*primitives.common.HorizontalAlignmentType.Right*/;result.verticalAlignmentType=0/*primitives.common.VerticalAlignmentType.Top*/;break;case 2/*primitives.text.TextOrientationType.RotateRight*/:result.horizontalAlignmentType=1/*primitives.common.HorizontalAlignmentType.Left*/;result.verticalAlignmentType=2/*primitives.common.VerticalAlignmentType.Bottom*/;break;}break;case 5/*primitives.common.PlacementType.Bottom*/:result.position=new primitives.common.Rect(x+width/2.0-labelWidth/2.0,y+height+labelOffset,labelWidth,labelHeight);switch(result.labelOrientation){case 0/*primitives.text.TextOrientationType.Horizontal*/:result.horizontalAlignmentType=0/*primitives.common.HorizontalAlignmentType.Center*/;result.verticalAlignmentType=0/*primitives.common.VerticalAlignmentType.Top*/;break;case 1/*primitives.text.TextOrientationType.RotateLeft*/:result.horizontalAlignmentType=2/*primitives.common.HorizontalAlignmentType.Right*/;result.verticalAlignmentType=1/*primitives.common.VerticalAlignmentType.Middle*/;break;case 2/*primitives.text.TextOrientationType.RotateRight*/:result.horizontalAlignmentType=1/*primitives.common.HorizontalAlignmentType.Left*/;result.verticalAlignmentType=1/*primitives.common.VerticalAlignmentType.Middle*/;break;}break;case 6/*primitives.common.PlacementType.BottomLeft*/:case 10/*primitives.common.PlacementType.LeftBottom*/:result.position=new primitives.common.Rect(x-labelWidth-labelOffset,y+height+labelOffset,labelWidth,labelHeight);switch(result.labelOrientation){case 0/*primitives.text.TextOrientationType.Horizontal*/:result.horizontalAlignmentType=2/*primitives.common.HorizontalAlignmentType.Right*/;result.verticalAlignmentType=0/*primitives.common.VerticalAlignmentType.Top*/;break;case 1/*primitives.text.TextOrientationType.RotateLeft*/:result.horizontalAlignmentType=2/*primitives.common.HorizontalAlignmentType.Right*/;result.verticalAlignmentType=2/*primitives.common.VerticalAlignmentType.Bottom*/;break;case 2/*primitives.text.TextOrientationType.RotateRight*/:result.horizontalAlignmentType=1/*primitives.common.HorizontalAlignmentType.Left*/;result.verticalAlignmentType=0/*primitives.common.VerticalAlignmentType.Top*/;break;}break;case 7/*primitives.common.PlacementType.Left*/:result.position=new primitives.common.Rect(x-labelWidth-labelOffset,y+height/2.0-labelHeight/2.0,labelWidth,labelHeight);switch(result.labelOrientation){case 0/*primitives.text.TextOrientationType.Horizontal*/:result.horizontalAlignmentType=2/*primitives.common.HorizontalAlignmentType.Right*/;result.verticalAlignmentType=1/*primitives.common.VerticalAlignmentType.Middle*/;break;case 1/*primitives.text.TextOrientationType.RotateLeft*/:result.horizontalAlignmentType=0/*primitives.common.HorizontalAlignmentType.Center*/;result.verticalAlignmentType=2/*primitives.common.VerticalAlignmentType.Bottom*/;break;case 2/*primitives.text.TextOrientationType.RotateRight*/:result.horizontalAlignmentType=0/*primitives.common.HorizontalAlignmentType.Center*/;result.verticalAlignmentType=0/*primitives.common.VerticalAlignmentType.Top*/;break;}break;case 8/*primitives.common.PlacementType.TopLeft*/:case 9/*primitives.common.PlacementType.LeftTop*/:result.position=new primitives.common.Rect(x-labelWidth-labelOffset,y-labelOffset-labelHeight,labelWidth,labelHeight);switch(result.labelOrientation){case 0/*primitives.text.TextOrientationType.Horizontal*/:result.horizontalAlignmentType=2/*primitives.common.HorizontalAlignmentType.Right*/;result.verticalAlignmentType=2/*primitives.common.VerticalAlignmentType.Bottom*/;break;case 1/*primitives.text.TextOrientationType.RotateLeft*/:result.horizontalAlignmentType=1/*primitives.common.HorizontalAlignmentType.Left*/;result.verticalAlignmentType=2/*primitives.common.VerticalAlignmentType.Bottom*/;break;case 2/*primitives.text.TextOrientationType.RotateRight*/:result.horizontalAlignmentType=2/*primitives.common.HorizontalAlignmentType.Right*/;result.verticalAlignmentType=0/*primitives.common.VerticalAlignmentType.Top*/;break;}break;}}}return result;}return{process:process};};/* /Controls/OrgDiagram/Tasks/Renders/DrawMinimizedItemsTask.js*/primitives.orgdiagram.DrawMinimizedItemsTask=function(getGraphics,createTranfromTask,applyLayoutChangesTask,minimizedItemsOptionTask,itemTemplateParamsTask,alignDiagramTask){var _graphics,_transform,_debug=false,_options,_positions;function process(){_graphics=getGraphics();_transform=createTranfromTask.getTransform();_options=minimizedItemsOptionTask.getOptions();_positions=alignDiagramTask.getItemsPositions();_graphics.reset("placeholder",9/*primitives.common.Layers.Marker*/);drawMinimizedItems();return false;}function drawMinimizedItems(){var treeLevel,uiHash,element,markers=new primitives.common.PolylinesBuffer(),paletteItems={},polyline,index,len,label,marker=new primitives.common.Marker(),itemTitleColor,itemFillColor,minimizedItemShapeType,minimizedItemCornerRadius,treeItemPosition,actualPosition,minimizedItemsOptions,templateParams,templateConfig;for(var treeItemId in _positions){if(_positions.hasOwnProperty(treeItemId)){treeItemPosition=_positions[treeItemId],actualPosition=treeItemPosition.actualPosition,minimizedItemsOptions=minimizedItemsOptionTask.getItemOptions(treeItemId);_transform.transformRect(actualPosition.x,actualPosition.y,actualPosition.width,actualPosition.height,true,this,function(x,y,width,height){switch(treeItemPosition.actualVisibility){case 2/*primitives.common.Visibility.Dot*/:templateParams=itemTemplateParamsTask.getTemplateParams(treeItemId);templateConfig=templateParams.template.templateConfig;itemTitleColor=null;itemFillColor=null;minimizedItemShapeType=null;minimizedItemCornerRadius=0;/* use individual item options first */if(minimizedItemsOptions!=null){itemTitleColor=minimizedItemsOptions.itemTitleColor;itemFillColor=minimizedItemsOptions.itemTitleColor;minimizedItemShapeType=minimizedItemsOptions.minimizedItemShapeType;}/* use template config & control options next */itemTitleColor=itemTitleColor||templateConfig.minimizedItemBorderColor||"#000080"/*primitives.common.Colors.Navy*/;itemFillColor=itemFillColor||templateConfig.minimizedItemFillColor||"#000080"/*primitives.common.Colors.Navy*/;if(minimizedItemShapeType==null){minimizedItemShapeType=templateConfig.minimizedItemShapeType!==null?templateConfig.minimizedItemShapeType:_options.minimizedItemShapeType;}minimizedItemCornerRadius=templateConfig.minimizedItemCornerRadius===null?templateConfig.minimizedItemSize.width/2.0:templateConfig.minimizedItemCornerRadius;if(minimizedItemShapeType==null||minimizedItemShapeType==6/*primitives.common.ShapeType.None*/){polyline=markers.getPolyline(new primitives.common.PaletteItem({'lineColor':itemTitleColor,'lineWidth':templateConfig.minimizedItemLineWidth,'lineType':templateConfig.minimizedItemLineType,'fillColor':itemFillColor,'opacity':templateConfig.minimizedItemOpacity}));polyline.addSegment(new primitives.common.DotSegment(x,y,width,height,minimizedItemCornerRadius));}else{marker.draw(markers,minimizedItemShapeType,new primitives.common.Rect(x,y,width,height),new primitives.common.PaletteItem({'lineColor':itemTitleColor,'lineWidth':templateConfig.minimizedItemLineWidth,'lineType':templateConfig.minimizedItemLineType,'fillColor':itemFillColor,'opacity':templateConfig.minimizedItemOpacity}));}break;default:if(_debug){itemTitleColor="#ff0000"/*primitives.common.Colors.Red*/;if(!paletteItems.hasOwnProperty(itemTitleColor)){paletteItems[itemTitleColor]=new primitives.common.PaletteItem({'lineColor':itemTitleColor,'lineWidth':1,'lineType':0/*primitives.common.LineType.Solid*/,'fillColor':itemTitleColor,'opacity':1});}polyline=markers.getPolyline(paletteItems[itemTitleColor]);polyline.addSegment(new primitives.common.DotSegment(x-1,y-1,2,2,1));}break;}});//ignore jslint
	}}_graphics.activate("placeholder",9/*primitives.common.Layers.Marker*/);_graphics.polylinesBuffer(markers);}return{process:process};};/* /Controls/OrgDiagram/Tasks/Renders/DrawPrintPreviewTask.js*/primitives.orgdiagram.DrawPrintPreviewTask=function(getGraphics,applyLayoutChangesTask,printPreviewOptionTask,alignDiagramTask,printPreviewTemplateTask,scaleOptionTask){var _graphics;function process(){var options=printPreviewOptionTask.getOptions(),scaleOptions=scaleOptionTask.getOptions();_graphics=getGraphics();_graphics.reset("placeholder",1/*primitives.common.Layers.PrintPreview*/);if(options.pageFitMode==4/*primitives.common.PageFitMode.PrintPreview*/){drawPrintPreview(options,scaleOptions);}return false;}function drawPrintPreview(options,scaleOptions){var panel,layer=3/*primitives.common.Layers.BackgroundAnnotations*/,size=new primitives.common.Size(options.printPreviewPageSize),x,y,element,panelSize=alignDiagramTask.getContentSize(),printPreviewTemplate=printPreviewTemplateTask.getTemplate();size.scale(1.0/scaleOptions.scale);panel=_graphics.activate("placeholder",1/*primitives.common.Layers.PrintPreview*/);x=0;while((x+1)*size.width<panelSize.width){y=0;while((y+1)*size.height<panelSize.height){element=_graphics.template(x*size.width,y*size.height,size.width,size.height,0,0,size.width,size.height,printPreviewTemplate.template(),printPreviewTemplate.getHashCode(),printPreviewTemplate.render,null,null);element.data({"column":x,"row":y});y+=1;}x+=1;}}return{process:process};};/* /Controls/OrgDiagram/Tasks/Renders/DrawShapeAnnotationTask.js*/primitives.orgdiagram.DrawShapeAnnotationTask=function(getGraphics,createTransformTask,applyLayoutChangesTask,orientationOptionTask,shapeAnnotationOptionTask,alignDiagramTask,annotationLabelTemplateTask,zOrderType){var _graphics,_transform,_orientationOptions,_annotationLabelTemplate;function process(){_graphics=getGraphics();_transform=createTransformTask.getTransform();_orientationOptions=orientationOptionTask.getOptions();_annotationLabelTemplate=annotationLabelTemplateTask.getTemplate();switch(zOrderType){case 1/*primitives.common.ZOrderType.Background*/://ignore jslint
	_graphics.reset("placeholder",3/*primitives.common.Layers.BackgroundAnnotations*/);break;case 2/*primitives.common.ZOrderType.Foreground*/://ignore jslint
	_graphics.reset("placeholder",13/*primitives.common.Layers.ForegroundAnnotations*/);break;}_drawAnnotations(shapeAnnotationOptionTask.getAnnotations(),alignDiagramTask.getItemPosition);return false;}function _drawAnnotations(annotations,getItemPosition){var panel,layer=13/*primitives.common.Layers.ForegroundAnnotations*/,index,len,index2,len2,index3,len3,fromItem,toItem,shape,defaultConfig,items,itemsHash,itemPosition,position,properties,property,annotationConfig,uiHash,backgroundManager,perimeters,treeItem;switch(zOrderType){case 1/*primitives.common.ZOrderType.Background*/://ignore jslint
	panel=_graphics.activate("placeholder",3/*primitives.common.Layers.BackgroundAnnotations*/);break;case 2/*primitives.common.ZOrderType.Foreground*/://ignore jslint
	panel=_graphics.activate("placeholder",13/*primitives.common.Layers.ForegroundAnnotations*/);break;}for(index=0,len=annotations.length;index<len;index+=1){annotationConfig=annotations[index];if(annotationConfig.items!=null&&annotationConfig.items.length>0){position=new primitives.common.Rect();for(index2=0,len2=annotationConfig.items.length;index2<len2;index2+=1){itemPosition=getItemPosition(annotationConfig.items[index2]);if(itemPosition!=null){position.addRect(itemPosition.actualPosition);}}if(!position.isEmpty()){shape=new primitives.common.Shape(_graphics);defaultConfig=new primitives.orgdiagram.ShapeAnnotationConfig();properties=["opacity","cornerRadius","shapeType","offset","lineWidth","borderColor","fillColor","lineType","labelSize","labelOffset","labelPlacement","zOrderType"];for(index3=0,len3=properties.length;index3<len3;index3+=1){property=properties[index3];shape[property]=annotationConfig.hasOwnProperty(property)?annotationConfig[property]:defaultConfig[property];}shape.position=position;shape.orientationType=_orientationOptions.orientationType;shape.panelSize=panel.size;shape.labelTemplate=_annotationLabelTemplate;shape.hasLabel=annotationConfig.templateName!=null||annotationConfig.label!=null;uiHash=new primitives.common.RenderEventArgs();uiHash.context=annotationConfig;uiHash.templateName=shape.labelTemplate;_transform.transformRect(position.x,position.y,position.width,position.height,true,this,function(x,y,width,height){var position=new primitives.common.Rect(x,y,width,height);shape.draw(position,uiHash);});//ignore jslint
	}}}}return{process:process};};/* /Controls/OrgDiagram/Tasks/Renders/DrawTreeItemsTask.js*/primitives.orgdiagram.DrawTreeItemsTask=function(getGraphics,createTranfromTask,applyLayoutChangesTask,itemsSizesOptionTask,combinedContextsTask,alignDiagramTask,itemTemplateParamsTask,cursorItemTask,selectedItemsTask,groupTitleTemplateTask,checkBoxTemplateTask,buttonsTemplateTask){var _positions,_graphics,_transform,_itemsSizesOptions,_buttonsTemplate,_checkBoxTemplate,_groupTitleTemplate;function process(){_graphics=getGraphics();_itemsSizesOptions=itemsSizesOptionTask.getOptions();_positions=alignDiagramTask.getItemsPositions();_transform=createTranfromTask.getTransform();_buttonsTemplate=buttonsTemplateTask.getTemplate();_checkBoxTemplate=checkBoxTemplateTask.getTemplate();_groupTitleTemplate=groupTitleTemplateTask.getTemplate();_graphics.reset("placeholder",12/*primitives.common.Layers.Item*/);_graphics.reset("placeholder",16/*primitives.common.Layers.Controls*/);redrawTreeItems();return false;}function redrawTreeItems(){var uiHash,element,polyline,index,len,label,itemTitleColor,itemFillColor,cursorItemId=cursorItemTask.getCursorTreeItem(),treeItemPosition,actualPosition;for(var treeItemId in _positions){if(_positions.hasOwnProperty(treeItemId)){treeItemPosition=_positions[treeItemId],actualPosition=treeItemPosition.actualPosition;if(treeItemPosition.actualVisibility==1/*primitives.common.Visibility.Normal*/){_transform.transformRect(actualPosition.x,actualPosition.y,actualPosition.width,actualPosition.height,true,this,function(x,y,width,height){var templateParams=itemTemplateParamsTask.getTemplateParams(treeItemId),template=templateParams.template;uiHash=new primitives.common.RenderEventArgs();uiHash.context=combinedContextsTask.getConfig(treeItemId);uiHash.isCursor=treeItemId==cursorItemId;uiHash.isSelected=selectedItemsTask.isSelected(treeItemId);uiHash.templateName=template.templateConfig.name;_graphics.activate("placeholder",12/*primitives.common.Layers.Item*/);element=_graphics.template(x,y,width,height,treeItemPosition.contentPosition.x,treeItemPosition.contentPosition.y,treeItemPosition.contentPosition.width,treeItemPosition.contentPosition.height,template.itemTemplate.template(),template.itemTemplate.getHashCode(),template.itemTemplate.render,uiHash,{"border-width":template.templateConfig.itemBorderWidth});if(templateParams.hasGroupTitle){element=_graphics.template(x,y,width,height,2,treeItemPosition.contentPosition.y,_itemsSizesOptions.groupTitlePanelSize-4,treeItemPosition.contentPosition.height+2,_groupTitleTemplate.template(),_groupTitleTemplate.getHashCode(),_groupTitleTemplate.render,uiHash,null);}if(templateParams.hasSelectorCheckbox){_graphics.activate("placeholder",16/*primitives.common.Layers.Controls*/);element=_graphics.template(x,y,width,height,treeItemPosition.contentPosition.x,height-(_itemsSizesOptions.checkBoxPanelSize-4),treeItemPosition.contentPosition.width,_itemsSizesOptions.checkBoxPanelSize-4,_checkBoxTemplate.template(),_checkBoxTemplate.getHashCode(),_checkBoxTemplate.render,uiHash,null);}if(templateParams.hasButtons){_graphics.activate("placeholder",16/*primitives.common.Layers.Controls*/);element=_graphics.template(x,y,width,height,width-(_itemsSizesOptions.buttonsPanelSize-4),treeItemPosition.contentPosition.y,_itemsSizesOptions.buttonsPanelSize-4,Math.max(treeItemPosition.contentPosition.height,height-treeItemPosition.contentPosition.y),_buttonsTemplate.template(),template.templateConfig.name+_buttonsTemplate.getHashCode(),_buttonsTemplate.render,templateParams,null);}});//ignore jslint
	}}}}return{process:process};};/* /Controls/OrgDiagram/Tasks/Templates/AnnotationLabelTemplateTask.js*/primitives.orgdiagram.AnnotationLabelTemplateTask=function(itemsSizesOptionTask){var _data={template:null};function process(){return false;}function getTemplate(){if(_data.template==null){_data.template=new primitives.common.AnnotationLabelTemplate();}return _data.template;}return{process:process,getTemplate:getTemplate};};/* /Controls/OrgDiagram/Tasks/Templates/ButtonsTemplateTask.js*/primitives.orgdiagram.ButtonsTemplateTask=function(itemsSizesOptionTask){var _data={template:null};function process(){return false;}function getTemplate(){if(_data.template==null){_data.template=new primitives.common.ButtonsTemplate();}return _data.template;}return{process:process,getTemplate:getTemplate};};/* /Controls/OrgDiagram/Tasks/Templates/CheckboxTemplateTask.js*/primitives.orgdiagram.CheckBoxTemplateTask=function(itemsSizesOptionTask){var _data={template:null};function process(){_data.template=null;return true;}function getTemplate(){var options;if(_data.template==null){options=itemsSizesOptionTask.getOptions();_data.template=new primitives.common.CheckBoxTemplate(options.selectCheckBoxLabel);}return _data.template;}return{process:process,getTemplate:getTemplate};};/* /Controls/OrgDiagram/Tasks/Templates/GroupTitleTemplateTask.js*/primitives.orgdiagram.GroupTitleTemplateTask=function(templatesOptionTask){var _data={template:null};function process(){_data.template=null;return true;}function getTemplate(){var options;if(_data.template==null){options=templatesOptionTask.getOptions();_data.template=new primitives.common.GroupTitleTemplate(options);}return _data.template;}return{process:process,getTemplate:getTemplate};};/* /Controls/OrgDiagram/Tasks/Templates/ItemTemplateParamsTask.js*/primitives.orgdiagram.ItemTemplateParamsTask=function(itemsSizesOptionTask,cursorItemOptionTask,readTemplatesTask){var _data={items:{}// TemplateParams
	};function process(){var itemsSizesOptions=itemsSizesOptionTask.getOptions(),widgetHasButtons=itemsSizesOptions.buttons.length>0,cursorItem=cursorItemOptionTask.getCursorItem(),items=itemsSizesOptions.items,index,len;_data.items={};for(index=0,len=items.length;index<len;index+=1){var itemConfig=items[index],templateParams=new primitives.orgdiagram.TemplateParams(),isCursor=cursorItem==itemConfig.id,template=readTemplatesTask.getTemplate(itemConfig.templateName,itemsSizesOptions.defaultTemplateName,readTemplatesTask.DefaultWidgetTemplateName),templateConfig=template.templateConfig,templateHasButtons=templateConfig.buttons!=null&&templateConfig.buttons.length>0;templateParams.template=template;templateParams.hasSelectorCheckbox=getSelectionVisibility(isCursor,itemConfig.hasSelectorCheckbox,itemsSizesOptions.hasSelectorCheckbox);templateParams.hasButtons=(widgetHasButtons||templateHasButtons)&&getSelectionVisibility(isCursor,itemConfig.hasButtons,itemsSizesOptions.hasButtons);templateParams.hasGroupTitle=!primitives.common.isNullOrEmpty(itemConfig.groupTitle);templateParams.isActive=itemConfig.isActive&&templateConfig.isActive;if(templateParams.hasButtons){templateParams.buttons=templateHasButtons?templateConfig.buttons:itemsSizesOptions.buttons;}_data.items[itemConfig.id]=templateParams;}return true;}function getSelectionVisibility(isCursor,itemState,widgetState){var result=false;switch(itemState){case 0/*primitives.common.Enabled.Auto*/:switch(widgetState){case 0/*primitives.common.Enabled.Auto*/:result=isCursor;break;case 1/*primitives.common.Enabled.True*/:result=true;break;case 2/*primitives.common.Enabled.False*/:result=false;break;}break;case 1/*primitives.common.Enabled.True*/:result=true;break;case 2/*primitives.common.Enabled.False*/:result=false;break;}return result;}function getTemplateParams(orgItemId){return _data.items[orgItemId];}return{process:process,getTemplateParams:getTemplateParams};};/* /Controls/OrgDiagram/Tasks/Templates/PrintPreviewTemplateTask.js*/primitives.orgdiagram.PrintPreviewTemplateTask=function(itemsSizesOptionTask){var _data={template:null};function process(){return false;}function getTemplate(){if(_data.template==null){_data.template=new primitives.common.PrintPreviewTemplate();}return _data.template;}return{process:process,getTemplate:getTemplate};};/* /Controls/OrgDiagram/Tasks/Templates/ReadTemplatesTask.js*/primitives.orgdiagram.ReadTemplatesTask=function(templatesOptionTask){var _data={templates:{}},_defaultWidgetTemplateName="DefaultWidgetTemplate",_defaultWidgetLabelAnnotationTemplateName="DefaultWidgetLabelAnnotationTemplate";function process(){var index,len,templateConfig,templatesOptions=templatesOptionTask.getOptions(),templates=templatesOptions.templates;_data.templates={};_data.templates[_defaultWidgetTemplateName]=new primitives.orgdiagram.Template(templatesOptions,new primitives.orgdiagram.TemplateConfig());var labelAnnotationTemplateConfig=new primitives.orgdiagram.TemplateConfig();labelAnnotationTemplateConfig.name=_defaultWidgetLabelAnnotationTemplateName;labelAnnotationTemplateConfig.isActive=false;labelAnnotationTemplateConfig.itemSize=new primitives.common.Size(100,20);labelAnnotationTemplateConfig.minimizedItemSize=new primitives.common.Size(0,0);var labelAnnotationTemplate=new primitives.orgdiagram.Template();labelAnnotationTemplate.templateConfig=labelAnnotationTemplateConfig;labelAnnotationTemplate.minimizedItemCornerRadius=labelAnnotationTemplateConfig.minimizedItemSize.width/2;labelAnnotationTemplate.itemTemplate=new primitives.common.LabelAnnotationTemplate();labelAnnotationTemplate.dotHighlightTemplate=new primitives.common.DotHighlightTemplate(templatesOptions,labelAnnotationTemplateConfig);_data.templates[_defaultWidgetLabelAnnotationTemplateName]=labelAnnotationTemplate;for(index=0,len=templates.length;index<len;index+=1){templateConfig=templates[index];_data.templates[templateConfig.name]=new primitives.orgdiagram.Template(templatesOptions,templateConfig);}return true;}function getTemplate(templateName1,templateName2,templateName3){var result=_data.templates[templateName1]||_data.templates[templateName2]||_data.templates[templateName3];return result;}return{process:process,getTemplate:getTemplate,DefaultWidgetTemplateName:_defaultWidgetTemplateName,DefaultWidgetLabelAnnotationTemplateName:_defaultWidgetLabelAnnotationTemplateName};};/* /Controls/OrgDiagram/Tasks/Transformations/Selection/CombinedNormalVisibilityItemsTask.js*/primitives.orgdiagram.CombinedNormalVisibilityItemsTask=function(itemsSizesOptionTask,cursorItemTask,cursorNeighboursTask,selectedItemsTask,selectionPathItemsTask,normalVisibilityItemsByForegroundShapeAnnotationTask,normalVisibilityItemsByBackgroundShapeAnnotationTask,normalVisibilityItemsByBackgroundAnnotationTask,normalVisibilityItemsByForegroundHighlightPathAnnotationTask,normalVisibilityItemsByBackgroundHighlightPathAnnotationTask,normalVisibilityItemsByForegroundConnectorAnnotationTask,normalVisibilityItemsByBackgroundConnectorAnnotationTask){var _data={items:[]},_hash={},_sourceTasks=[cursorItemTask,cursorNeighboursTask,selectedItemsTask,selectionPathItemsTask,normalVisibilityItemsByForegroundShapeAnnotationTask,normalVisibilityItemsByBackgroundShapeAnnotationTask,normalVisibilityItemsByBackgroundAnnotationTask,normalVisibilityItemsByForegroundHighlightPathAnnotationTask,normalVisibilityItemsByBackgroundHighlightPathAnnotationTask,normalVisibilityItemsByForegroundConnectorAnnotationTask,normalVisibilityItemsByBackgroundConnectorAnnotationTask],_dataTemplate=new primitives.common.ArrayReader(new primitives.common.ValueReader(["string","number"],true),true);function process(){var context={isChanged:false,hash:_hash},itemsSizesOption=itemsSizesOptionTask.getOptions();_data.items=_dataTemplate.read(_data.items,getSelectedItems(_sourceTasks),"items",context);if(itemsSizesOption.pageFitMode==0/*primitives.common.PageFitMode.None*/||itemsSizesOption.minimalVisibility==1/*primitives.common.Visibility.Normal*/){context.isChanged=false;}return context.isChanged;}function getSelectedItems(sourceTasks){var result=[],sourceIndex,sourceLen,sourceTask,index,len,items,item,processed={};for(sourceIndex=0,sourceLen=sourceTasks.length;sourceIndex<sourceLen;sourceIndex+=1){sourceTask=sourceTasks[sourceIndex];items=sourceTask.getItems();for(index=0,len=items.length;index<len;index+=1){item=items[index];if(!processed.hasOwnProperty(item)){result.push(item);processed[item]=true;}}}return result;}function isItemSelected(treeItem){return _hash.items.hasOwnProperty(treeItem);}return{process:process,isItemSelected:isItemSelected};};/* /Controls/OrgDiagram/Tasks/Transformations/Selection/CursorItemTask.js*/primitives.orgdiagram.CursorItemTask=function(cursorItemOptionTask,visualTreeLevelsTask){var _data={cursorTreeItemId:null};function process(){var treeItemId=cursorItemOptionTask.getCursorItem(),activeTreeLevels=visualTreeLevelsTask.getActiveTreeLevels();_data.cursorTreeItemId=treeItemId!=null&&activeTreeLevels.hasItem(treeItemId)?treeItemId:null;return true;}function getCursorTreeItem(){return _data.cursorTreeItemId;}function getItems(){return _data.cursorTreeItemId!=null?[_data.cursorTreeItemId]:[];}return{process:process,getCursorTreeItem:getCursorTreeItem,getItems:getItems};};/* /Controls/OrgDiagram/Tasks/Transformations/Selection/CursorNeighboursTask.js*/primitives.orgdiagram.CursorNeighboursTask=function(cursorItemTask,navigationFamilyTask){var _data={items:[]};function process(){var navigationFamily=navigationFamilyTask.getNavigationFamily(),cursorTreeItemId=cursorItemTask.getCursorTreeItem();_data.items=getCursorNeighbours(cursorTreeItemId,navigationFamily);return true;}function getCursorNeighbours(cursorTreeItemId,navigationFamily){var result=[];if(cursorTreeItemId!==null){navigationFamily.loopNeighbours(this,cursorTreeItemId,function(treeItemId,treeItem,distance){if(treeItem.visibility===0/*primitives.common.Visibility.Auto*/){result.push(treeItemId);}return true;});}return result;}function getItems(){return _data.items;}return{process:process,getItems:getItems};};/* /Controls/OrgDiagram/Tasks/Transformations/Selection/HighlightItemTask.js*/primitives.orgdiagram.HighlightItemTask=function(highlightItemOptionTask,visualTreeLevelsTask){var _data={highlightTreeItemId:null};function process(){var treeItemId=highlightItemOptionTask.getHighlightItem(),activeTreeLevels=visualTreeLevelsTask.getActiveTreeLevels();_data.highlightTreeItemId=treeItemId!=null&&activeTreeLevels.hasItem(treeItemId)?treeItemId:null;return true;}function getHighlightTreeItem(){return _data.highlightTreeItemId;}return{process:process,getHighlightTreeItem:getHighlightTreeItem};};/* /Controls/OrgDiagram/Tasks/Transformations/Selection/NormalVisibilityItemsByAnnotationTask.js*/primitives.orgdiagram.NormalVisibilityItemsByAnnotationTask=function(annotationOptionTask){var _data={items:[]},_hash={};var _dataTemplate=new primitives.common.ArrayReader(new primitives.common.ValueReader(["string","number"],true),true);function process(){var context={isChanged:false,hash:_hash},annotations=annotationOptionTask.getAnnotations();_data.items=_dataTemplate.read(_data.items,getSelectedItems(annotations),"items",context);return context.isChanged;}function getSelectedItems(annotations){var result=[],processed={},index,len,index2,len2,items,item,annotation,treeItemId;for(index=0,len=annotations.length;index<len;index+=1){annotation=annotations[index];if(annotation.selectItems){items=annotation.items;for(index2=0,len2=items.length;index2<len2;index2+=1){treeItemId=items[index2];if(treeItemId!=null&&!processed.hasOwnProperty(treeItemId)){result.push(treeItemId);processed[treeItemId]=true;}}}}return result;}function getItems(){return _data.items;}return{process:process,getItems:getItems};};/* /Controls/OrgDiagram/Tasks/Transformations/Selection/NormalVisibilityItemsByConnectorAnnotationTask.js*/primitives.orgdiagram.NormalVisibilityItemsByConnectorAnnotationTask=function(connectorAnnotationOptionTask){var _data={items:[]},_hash={},_dataTemplate=new primitives.common.ArrayReader(new primitives.common.ValueReader(["string","number"],true),true);function process(){var context={isChanged:false,hash:_hash},annotations=connectorAnnotationOptionTask.getAnnotations();_data.items=_dataTemplate.read(_data.items,getSelectedItems(annotations),"items",context);return context.isChanged;}function getSelectedItems(annotations){var result=[],processed={},index,len,annotation,treeItem;for(index=0,len=annotations.length;index<len;index+=1){annotation=annotations[index];if(annotation.selectItems){if(annotation.fromItem!=null&&!processed.hasOwnProperty(annotation.fromItem)){result.push(annotation.fromItem);processed[annotation.fromItem]=true;}if(annotation.toItem!=null&&!processed.hasOwnProperty(annotation.toItem)){result.push(annotation.toItem);processed[annotation.toItem]=true;}}}return result;}function getItems(){return _data.items;}return{process:process,getItems:getItems};};/* /Controls/OrgDiagram/Tasks/Transformations/Selection/SelectedItemsTask.js*/primitives.orgdiagram.SelectedItemsTask=function(selectedItemsOptionTask){var _data={items:[]},_hash={},_dataTemplate=new primitives.common.ArrayReader(new primitives.common.ValueReader(["string","number"],true),true);function process(){var context={isChanged:false,hash:_hash},selectedItems=selectedItemsOptionTask.getSelectedItems();_data.items=_dataTemplate.read(_data.items,getSelectedItems(selectedItems),"items",context);return context.isChanged;}function getSelectedItems(selectedItems){var result=[],processed={},index,len,treeItemId;for(index=0,len=selectedItems.length;index<len;index+=1){treeItemId=selectedItems[index];if(treeItemId!=null&&!processed.hasOwnProperty(treeItemId)){result.push(treeItemId);processed[treeItemId]=true;}}return result;}function isSelected(itemid){return _hash.items.hasOwnProperty(itemid);}function getItems(){return _data.items;}return{process:process,getItems:getItems,isSelected:isSelected};};/* /Controls/OrgDiagram/Tasks/Transformations/Selection/SelectionPathItemsTask.js*/primitives.orgdiagram.SelectionPathItemsTask=function(navigationFamilyTask,cursorItemTask,selectedItemsTask,cursorSelectionPathModeOptionTask){var _data={items:[]};function process(){var selectionPathMode=cursorSelectionPathModeOptionTask.getSelectionPathMode(),navigationFamily=navigationFamilyTask.getNavigationFamily(),cursorTreeItemId=cursorItemTask.getCursorTreeItem(),selectedItems=selectedItemsTask.getItems().slice(0);selectedItems.push(cursorTreeItemId);_data.items=getSelectionPathItems(selectedItems,navigationFamily,selectionPathMode);return true;}function getSelectionPathItems(selectedItems,navigationFamily,selectionPathMode){var result=[],processed={},selectedItem,index,len;for(index=0,len=selectedItems.length;index<len;index+=1){selectedItem=selectedItems[index];/* show cursor full stack */switch(selectionPathMode){case 0/*primitives.common.SelectionPathMode.None*/:break;case 1/*primitives.common.SelectionPathMode.FullStack*/:/* select all parents up to the root */navigationFamily.loopParents(this,selectedItem,function(parentItemId,parentItem){if(processed[parentItemId]!=null){return navigationFamily.SKIP;}result.push(parentItemId);processed[parentItemId]=true;});break;}}return result;}function getItems(){return _data.items;}return{process:process,getItems:getItems};};/* /Controls/OrgDiagram/Tasks/Transformations/BackgroundAnnotationManagerTask.js*/primitives.orgdiagram.BackgroundAnnotationManagerTask=function(itemsSizesOptionTask,visualTreeLevelsTask,alignDiagramTask){var _data={backgroundManager:null},_treeLevels,_treeLevelsPositions,_treeItemsPositions,_options;function process(){_data.backgroundManager=null;_treeLevels=visualTreeLevelsTask.getTreeLevels();_treeLevelsPositions=alignDiagramTask.getTreeLevelsPositions();_treeItemsPositions=alignDiagramTask.getItemsPositions();_options=itemsSizesOptionTask.getOptions();return true;}function createBackgroundManager(){var result=new primitives.common.perimeter.Manager(),index,len,index2,len2,mergedTreeLevelOffsetsHashs,prevLevelOffsets,offsetsHash,visibleLayers,treeLevelOffsets,mergedTreeLevelOffsets,merged,prevTreeItemPosition,treeItemPosition,nextTreeItemPosition,offsets,offset,prevTreeLevelPosition,treeLevelPosition,nextTreeLevelPosition,perimeters,nextTreeLevel,treeLevel,prevTreeLevel;if(!_treeLevels.isEmpty()){// collect tree item offsets for visible levels only
	visibleLayers=[];treeLevelOffsets=[];_treeLevels.loopLevels(this,function(levelIndex){prevTreeItemPosition=null;treeItemPosition=null;treeLevelPosition=_treeLevelsPositions[levelIndex];if(treeLevelPosition.actualVisibility!=4/*primitives.common.Visibility.Invisible*/){visibleLayers.push(levelIndex);offsets=[];_treeLevels.loopLevelItems(this,levelIndex,function(treeItemId){nextTreeItemPosition=_treeItemsPositions[treeItemId];if(nextTreeItemPosition.actualVisibility!=4/*primitives.common.Visibility.Invisible*/){if(treeItemPosition!=null){addOffset(offsets,prevTreeItemPosition,treeItemPosition,nextTreeItemPosition);}prevTreeItemPosition=treeItemPosition;treeItemPosition=nextTreeItemPosition;}});if(treeItemPosition!=null){addOffset(offsets,prevTreeItemPosition,treeItemPosition,null);}treeLevelOffsets.push(offsets);}});if(treeLevelOffsets.length>0){// merge adjustent tree level offsets
	mergedTreeLevelOffsets=[];prevLevelOffsets=[];for(index=0,len=treeLevelOffsets.length;index<len;index+=1){merged=primitives.common.mergeSort([prevLevelOffsets,treeLevelOffsets[index]],null,true);mergedTreeLevelOffsets.push(merged);prevLevelOffsets=treeLevelOffsets[index];}mergedTreeLevelOffsets.push(primitives.common.mergeSort([treeLevelOffsets[index-1]],null,true));// we need extra level for last one
	// create offset hashs
	mergedTreeLevelOffsetsHashs=[];// array of hashes. Hash key = offset and hash value = offset index
	for(index=0,len=mergedTreeLevelOffsets.length;index<len;index+=1){offsetsHash={};offsets=mergedTreeLevelOffsets[index];for(index2=0,len2=offsets.length;index2<len2;index2+=1){offset=offsets[index2];offsetsHash[offset]=index2;}mergedTreeLevelOffsetsHashs.push(offsetsHash);}// create perimeters for tree levels having visible items
	perimeters=[];prevTreeLevel=null;treeLevel=null;for(index=0,len=visibleLayers.length;index<len;index+=1){nextTreeLevel=visibleLayers[index];if(treeLevel!=null){addTreeLevelPerimeters(perimeters,index-1,mergedTreeLevelOffsetsHashs,mergedTreeLevelOffsets,_treeLevelsPositions[prevTreeLevel],treeLevel,_treeLevelsPositions[treeLevel],_treeLevelsPositions[nextTreeLevel]);}prevTreeLevel=treeLevel;treeLevel=nextTreeLevel;}if(treeLevel!=null){addTreeLevelPerimeters(perimeters,index-1,mergedTreeLevelOffsetsHashs,mergedTreeLevelOffsets,_treeLevelsPositions[prevTreeLevel],treeLevel,_treeLevelsPositions[treeLevel],null);}// Load perimeters into manager
	result.add(perimeters);}}return result;}function addTreeLevelPerimeters(perimeters,index,hashes,offsets,prevTreeLevelPosition,levelIndex,treeLevelPosition,nextTreeLevelPosition){var interval=Math.floor(_options.normalItemsInterval/2),y=prevTreeLevelPosition!=null?Math.floor((prevTreeLevelPosition.shift+prevTreeLevelPosition.depth)*3/7+treeLevelPosition.shift*4/7):treeLevelPosition.shift-interval,y2=nextTreeLevelPosition!=null?Math.floor((treeLevelPosition.shift+treeLevelPosition.depth)*3/7+nextTreeLevelPosition.shift*4/7):treeLevelPosition.shift+treeLevelPosition.depth+interval,prevItemPosition=null,itemPosition=null,nextItemPosition,orgItem,nextOrgItem;_treeLevels.loopLevelItems(this,levelIndex,function(treeItemId,nextOrgItem){nextItemPosition=_treeItemsPositions[treeItemId];if(nextItemPosition.actualVisibility!=4/*primitives.common.Visibility.Invisible*/){if(itemPosition!=null){addPerimeter(perimeters,hashes[index],hashes[index+1],offsets[index],offsets[index+1],y,y2,prevItemPosition,itemPosition,nextItemPosition,orgItem.id);}prevItemPosition=itemPosition;itemPosition=nextItemPosition;orgItem=nextOrgItem;}});if(itemPosition!=null){addPerimeter(perimeters,hashes[index],hashes[index+1],offsets[index],offsets[index+1],y,y2,prevItemPosition,itemPosition,null,orgItem.id);}}function addOffset(offsets,prevItemPosition,itemPosition,nextItemPosition){var interval=Math.floor(_options.normalItemsInterval/2),x=prevItemPosition!=null?Math.floor(prevItemPosition.actualPosition.right()*3/7+itemPosition.actualPosition.x*4/7):itemPosition.actualPosition.x-interval,x2=nextItemPosition!=null?Math.floor(itemPosition.actualPosition.right()*3/7+nextItemPosition.actualPosition.x*4/7):itemPosition.actualPosition.right()+interval;offsets.push(x);offsets.push(x2);}function addPerimeter(perimeters,topHash,bottomHash,topOffsets,bottomOffsets,y,y2,prevItemPosition,itemPosition,nextItemPosition,itemid){var segments=[],SegmentItem=primitives.common.perimeter.SegmentItem,interval=Math.floor(_options.normalItemsInterval/2),x=prevItemPosition!=null?Math.floor(prevItemPosition.actualPosition.right()*3/7+itemPosition.actualPosition.x*4/7):itemPosition.actualPosition.x-interval,x2=nextItemPosition!=null?Math.floor(itemPosition.actualPosition.right()*3/7+nextItemPosition.actualPosition.x*4/7):itemPosition.actualPosition.right()+interval,index;// left side
	segments.push(new SegmentItem(x,y,x,y2));// bottom side
	for(index=bottomHash[x]+1;index<=bottomHash[x2];index+=1){segments.push(new SegmentItem(bottomOffsets[index-1],y2,bottomOffsets[index],y2));}// right side
	segments.push(new SegmentItem(x2,y2,x2,y));// top side
	for(index=topHash[x2]-1;index>=topHash[x];index-=1){segments.push(new SegmentItem(topOffsets[index+1],y,topOffsets[index],y));}perimeters.push(new primitives.common.perimeter.Item(itemid,segments));}function getBackgroundManager(){if(_data.backgroundManager==null){_data.backgroundManager=createBackgroundManager();}return _data.backgroundManager;}return{process:process,getBackgroundManager:getBackgroundManager};};/* /Controls/OrgDiagram/Tasks/Transformations/CombinedContextsTask.js*/primitives.orgdiagram.CombinedContextsTask=function(task1,task2){function process(){return true;}function getConfig(itemId){return task1.getConfig(itemId)||task2!=null&&task2.getConfig(itemId);}return{process:process,getConfig:getConfig};};/* /Controls/OrgDiagram/Tasks/Transformations/ConnectionsGraphTask.js*/primitives.orgdiagram.ConnectionsGraphTask=function(getGraphics,createTranfromTask,connectorsOptionTask,visualTreeLevelsTask,alignDiagramTask){var _data={graph:null},_graphics,_transform,_connectorsOptions,_bundles,_treeLevels,_treeLevelsPositions,_treeItemsPositions,_nodeid;function process(){_graphics=getGraphics();_transform=createTranfromTask.getTransform();_connectorsOptions=connectorsOptionTask.getOptions();_bundles=visualTreeLevelsTask.getBundles();_treeLevels=visualTreeLevelsTask.getTreeLevels();_treeLevelsPositions=alignDiagramTask.getTreeLevelsPositions();_treeItemsPositions=alignDiagramTask.getItemsPositions();_data.graph=createConnectionsGraph(_bundles);return true;}function createConnectionsGraph(bundles){var graph=primitives.common.graph(),panel=_graphics.activate("placeholder",6/*primitives.common.Layers.Connector*/),index,len;_nodeid=0;for(index=0,len=bundles.length;index<len;index+=1){var bundle=bundles[index];if(bundle.isVertical){traceVerticalBundle(graph,bundle,panel.hasGraphics);}else{traceHorizontalBundle(graph,bundle);}}return graph;}function ConnectorEdge(from,to,polyline,parentsArrowId,childrenArrowId,dotId,weight,fromOffset,hasMiddle,middleParent){this.polyline=polyline;this.from=from;this.to=to;this.weight=weight||0;this.fromOffset=fromOffset||0;this.parentsArrowId=parentsArrowId;this.childrenArrowId=childrenArrowId;this.dotId=dotId;/* draw extra arrows along long segments, the hasMiddle should be true and middleParent is parent point id */this.hasMiddle=hasMiddle;this.middleParent=middleParent;}function traceHorizontalBundle(graph,bundle){var fromItemId=bundle.fromItems[0],toItemId=bundle.toItems[0],fromItemPosition=_treeItemsPositions[fromItemId],toItemPosition=_treeItemsPositions[toItemId],treeLevelPosition=_treeLevelsPositions[bundle.fromLevel],polyline=new primitives.common.Polyline();if(fromItemPosition.actualPosition.x<toItemPosition.actualPosition.x){_transform.transformPoints(fromItemPosition.actualPosition.right(),treeLevelPosition.shift+treeLevelPosition.horizontalConnectorsDepth,toItemPosition.actualPosition.x,treeLevelPosition.shift+treeLevelPosition.horizontalConnectorsDepth,true,this,function(fromX,fromY,toX,toY){polyline.addSegment(new primitives.common.MoveSegment(fromX,fromY));polyline.addSegment(new primitives.common.LineSegment(toX,toY));});//ignore jslint
	}else{_transform.transformPoints(fromItemPosition.actualPosition.x,treeLevelPosition.shift+treeLevelPosition.horizontalConnectorsDepth,toItemPosition.actualPosition.right(),treeLevelPosition.shift+treeLevelPosition.horizontalConnectorsDepth,true,this,function(fromX,fromY,toX,toY){polyline.addSegment(new primitives.common.MoveSegment(fromX,fromY));polyline.addSegment(new primitives.common.LineSegment(toX,toY));});//ignore jslint
	}var toItemIsVisible=toItemPosition.actualVisibility!==4/*primitives.common.Visibility.Invisible*/;var fromItemIsVisible=fromItemPosition.actualVisibility!==4/*primitives.common.Visibility.Invisible*/;graph.addEdge(fromItemId,toItemId,new ConnectorEdge(fromItemId,toItemId,polyline,toItemIsVisible?toItemId:null,fromItemIsVisible?fromItemId:null,toItemIsVisible||fromItemIsVisible?1000.0:10));}function ConnectorDestination(options){this.id=null;this.x=null;this.y=null;this.bundleid=null;this.hasElbow=false;this.elbowPoint1=null;this.elbowPoint2=null;this.visibility=null;this.isSquared=true;for(var key in options){if(options.hasOwnProperty(key)){this[key]=options[key];}}}function getId(){var result="_"+_nodeid;_nodeid+=1;return result;}function traceVerticalBundle(graph,bundle,hasGraphics){var parentTreeLevelPosition=_treeLevelsPositions[bundle.fromLevel],treeLevelPosition,connectorsStacksSizes=visualTreeLevelsTask.getConnectorsStacksSizes(bundle.fromLevel),points,parents,children,items,treeItem,treeItemId,treeItemPosition,treeItemHighlightPath,index,len,isSquared,hasSquared,parentHorizontalCenter,partnersConnectorOffset,connectorPoint,connectorStep,chartHasSquaredConnectors=_connectorsOptions.connectorType===0/*primitives.common.ConnectorType.Squared*/,paletteItem,polyline;/* Find offset of horizontal connector line between partners */if(bundle.fromOffset>0){partnersConnectorOffset=parentTreeLevelPosition.shift+parentTreeLevelPosition.connectorShift-parentTreeLevelPosition.levelSpace/2*(connectorsStacksSizes.parentsStackSize-bundle.fromOffset+1);}else{partnersConnectorOffset=parentTreeLevelPosition.shift+parentTreeLevelPosition.connectorShift;}/* Draw fork for parents */parents=[];if(bundle.fromItems.length>0){items=bundle.fromItems;for(index=0,len=items.length;index<len;index+=1){treeItemId=items[index];treeItemPosition=_treeItemsPositions[treeItemId];connectorPoint=new ConnectorDestination({id:treeItemId,bundleid:getId(),x:treeItemPosition.actualPosition.horizontalCenter(),y:treeItemPosition.actualPosition.bottom(),isSquared:true,visibility:treeItemPosition.actualVisibility});parents.push(connectorPoint);}parents.sort(function(a,b){return a.x-b.x;});}children=[];if(bundle.toItems.length>0){hasSquared=false;items=bundle.toItems;for(index=0;index<items.length;index+=1){treeItemId=items[index];treeLevelPosition=_treeLevelsPositions[_treeLevels.getLevelIndex(treeItemId)];treeItemPosition=_treeItemsPositions[treeItemId];isSquared=true;if(hasGraphics){switch(treeItemPosition.actualVisibility){case 2/*primitives.common.Visibility.Dot*/:case 3/*primitives.common.Visibility.Line*/:isSquared=chartHasSquaredConnectors;break;}}connectorStep=0;connectorPoint=new ConnectorDestination({id:treeItemId,bundleid:getId(),x:treeItemPosition.actualPosition.horizontalCenter()+connectorStep,y:treeItemPosition.actualPosition.top(),isSquared:isSquared,visibility:treeItemPosition.actualVisibility});children.push(connectorPoint);/* is true if any child point has squared connector */hasSquared=hasSquared||connectorPoint.isSquared;}children.sort(function(a,b){return a.x-b.x;});}if(children.length==1){parentHorizontalCenter=children[0].x;}else if(parents.length==1){parentHorizontalCenter=parents[0].x;}else if(children.length>0&&parents.length>0){parentHorizontalCenter=(parents[0].x+parents[parents.length-1].x+children[0].x+children[children.length-1].x)/4.0;}else if(children.length>0){parentHorizontalCenter=(children[0].x+children[children.length-1].x)/2.0;}else{parentHorizontalCenter=(parents[0].x+parents[parents.length-1].x)/2.0;}var topCenterPoint=null;if(parents.length>0){topCenterPoint=new ConnectorDestination({id:getId(),x:parentHorizontalCenter,y:partnersConnectorOffset});traceTopConnectors(graph,topCenterPoint,parents,true,hasGraphics,true,bundle.fromOffset,_connectorsOptions.showExtraArrows&&children.length>0);}var bottomCenterPoint=null;if(children.length>0){bottomCenterPoint=new ConnectorDestination({id:getId(),x:parentHorizontalCenter,y:parentTreeLevelPosition.shift+parentTreeLevelPosition.connectorShift});if(topCenterPoint!=null&&bottomCenterPoint.y==topCenterPoint.y){bottomCenterPoint=topCenterPoint;}traceTopConnectors(graph,bottomCenterPoint,children,hasSquared,hasGraphics,false,0,_connectorsOptions.showExtraArrows&&parents.length>0);}/* draw connector line between children and parents */if(topCenterPoint!=null&&bottomCenterPoint!=null&&topCenterPoint.id!=bottomCenterPoint.id){_transform.transformPoints(topCenterPoint.x,topCenterPoint.y,bottomCenterPoint.x,bottomCenterPoint.y,true,this,function(fromX,fromY,toX,toY){var polyline=new primitives.common.Polyline();polyline.addSegment(new primitives.common.MoveSegment(fromX,fromY));polyline.addSegment(new primitives.common.LineSegment(toX,toY));graph.addEdge(topCenterPoint.id,bottomCenterPoint.id,new ConnectorEdge(topCenterPoint.id,bottomCenterPoint.id,polyline,null,null,null,0/* weight */));});}}function traceTopConnectors(graph,parentPoint,points,hasSquared,hasGraphics,isParents,fromOffset,showHorizontalArrows){var startIndex,endIndex,len,connectorPoint,curvedPoints=[],bundlePoint,connectorDestination,index,polyline,bevelSize,fromPoint,fromPointId,toPoint,toPointId;if(hasSquared){/* draw curved or angular lines on left side of pack */curvedPoints=[];for(startIndex=0,len=points.length;startIndex<len;startIndex+=1){connectorPoint=points[startIndex];if(connectorPoint.x<parentPoint.x&&!connectorPoint.isSquared){curvedPoints.push(connectorPoint);}else{break;}}len=curvedPoints.length;if(len>0){connectorDestination=curvedPoints[len-1];bundlePoint=connectorDestination.x==parentPoint.x?parentPoint:new ConnectorDestination({id:connectorDestination.bundleid,x:connectorDestination.x,y:parentPoint.y});traceAngularConnectors(graph,bundlePoint,curvedPoints,false);}/* draw curved or angular lines on right side of pack */curvedPoints=[];for(endIndex=points.length-1;endIndex>=startIndex;endIndex-=1){connectorPoint=points[endIndex];if(connectorPoint.x>parentPoint.x&&!connectorPoint.isSquared){curvedPoints.push(connectorPoint);}else{break;}}len=curvedPoints.length;if(len>0){connectorDestination=curvedPoints[len-1];bundlePoint=connectorDestination.x==parentPoint.x?parentPoint:new ConnectorDestination({id:connectorDestination.bundleid,x:connectorDestination.x,y:parentPoint.y});traceAngularConnectors(graph,bundlePoint,curvedPoints,false);}/* calculate elbows of vertical connectors */for(index=startIndex;index<=endIndex;index+=1){connectorPoint=points[index];bevelSize=_connectorsOptions.bevelSize;if(bevelSize<2){bevelSize=0;}if(hasGraphics){switch(_connectorsOptions.elbowType){case 2/*primitives.common.ElbowType.Bevel*/:case 3/*primitives.common.ElbowType.Round*/:if(bevelSize>0&&Math.abs(parentPoint.x-connectorPoint.x)>bevelSize&&Math.abs(parentPoint.y-connectorPoint.y)>bevelSize){connectorPoint.hasElbow=true;connectorPoint.elbowPoint1=new primitives.common.Point(connectorPoint.x,parentPoint.y+(parentPoint.y>connectorPoint.y?-bevelSize:bevelSize));connectorPoint.elbowPoint2=new primitives.common.Point(connectorPoint.x+(parentPoint.x>connectorPoint.x?bevelSize:-bevelSize),parentPoint.y);}break;default:break;}}/* draw vertical segment */polyline=new primitives.common.Polyline();if(connectorPoint.hasElbow){_transform.transform3Points(connectorPoint.elbowPoint2.x,connectorPoint.elbowPoint2.y,connectorPoint.elbowPoint1.x,connectorPoint.elbowPoint2.y,connectorPoint.elbowPoint1.x,connectorPoint.elbowPoint1.y,true,this,function(fromX,fromY,toX,toY,toX2,toY2){switch(_connectorsOptions.elbowType){case 2/*primitives.common.ElbowType.Bevel*/:polyline.addSegment(new primitives.common.MoveSegment(fromX,fromY));polyline.addSegment(new primitives.common.LineSegment(toX2,toY2));break;case 3/*primitives.common.ElbowType.Round*/:polyline.addSegment(new primitives.common.MoveSegment(fromX,fromY));polyline.addSegment(new primitives.common.CubicArcSegment(fromX,fromY,toX,toY,toX2,toY2));break;}});//ignore jslint
	_transform.transformPoints(connectorPoint.elbowPoint1.x,connectorPoint.elbowPoint1.y,connectorPoint.x,connectorPoint.y,true,this,function(fromX,fromY,toX,toY){polyline.addSegment(new primitives.common.LineSegment(toX,toY));});//ignore jslint
	}else{_transform.transformPoints(connectorPoint.x,parentPoint.y,connectorPoint.x,connectorPoint.y,true,this,function(fromX,fromY,toX,toY){polyline.addSegment(new primitives.common.MoveSegment(fromX,fromY));polyline.addSegment(new primitives.common.LineSegment(toX,toY));});//ignore jslint
	}var bundleid=connectorPoint.x==parentPoint.x?parentPoint.id:connectorPoint.bundleid;var isVisible=connectorPoint.visibility!==4/*primitives.common.Visibility.Invisible*/;graph.addEdge(bundleid,connectorPoint.id,new ConnectorEdge(bundleid,connectorPoint.id,polyline,isParents&&isVisible?connectorPoint.id:null,!isParents&&isVisible?connectorPoint.id:null,null,isVisible?1000.0:10/* weight*/,fromOffset));}/* draw segments on the right of parent point */startIndex=Math.max(startIndex-1,0);endIndex=Math.min(endIndex+1,points.length-1);fromPoint=parentPoint;fromPointId=parentPoint.id;for(index=startIndex;index<=endIndex;index+=1){toPoint=points[index];toPointId=toPoint.bundleid;if(toPoint.x>fromPoint.x){polyline=new primitives.common.Polyline();_transform.transformPoints(fromPoint.x,parentPoint.y,toPoint.elbowPoint2!=null?toPoint.elbowPoint2.x:toPoint.x,parentPoint.y,true,this,function(startX,startY,endX,endY){polyline.addSegment(new primitives.common.MoveSegment(startX,startY));polyline.addSegment(new primitives.common.LineSegment(endX,endY));});//ignore jslint
	graph.addEdge(fromPointId,toPointId,new ConnectorEdge(fromPointId,toPointId,polyline,null,null,fromPointId,Math.abs(toPoint.x-fromPoint.x)/10000.0/* weight */,fromOffset,/* draw middle arrows */showHorizontalArrows,isParents?toPointId:fromPointId));fromPoint=toPoint;fromPointId=toPointId;}}/* draw segments on the left of parent point */fromPoint=parentPoint;fromPointId=parentPoint.id;for(index=endIndex;index>=startIndex;index-=1){toPoint=points[index];toPointId=toPoint.bundleid;if(toPoint.x<fromPoint.x){polyline=new primitives.common.Polyline();_transform.transformPoints(fromPoint.x,parentPoint.y,toPoint.elbowPoint2!=null?toPoint.elbowPoint2.x:toPoint.x,parentPoint.y,true,this,function(startX,startY,endX,endY){polyline.addSegment(new primitives.common.MoveSegment(startX,startY));polyline.addSegment(new primitives.common.LineSegment(endX,endY));});//ignore jslint
	graph.addEdge(fromPointId,toPointId,new ConnectorEdge(fromPointId,toPointId,polyline,null,null,fromPointId,Math.abs(toPoint.x-fromPoint.x)/10000.0/* weight */,fromOffset,/* draw middle arrows */showHorizontalArrows,isParents?toPointId:fromPointId));fromPoint=toPoint;fromPointId=toPointId;}}}else{/* all lines are angular or curved */traceAngularConnectors(graph,parentPoint,points,true);}}function traceAngularConnectors(graph,bundlePoint,points,drawToBundle){var index,len,rect,point,polyline;for(index=0,len=points.length;index<len;index+=1){point=points[index];polyline=new primitives.common.Polyline();_transform.transformPoint(bundlePoint.x,bundlePoint.y,true,this,function(x,y){polyline.addSegment(new primitives.common.MoveSegment(x,y));});//ignore jslint
	switch(_connectorsOptions.connectorType){case 1/*primitives.common.ConnectorType.Angular*/:_transform.transformPoint(point.x,point.y,true,this,function(x,y){polyline.addSegment(new primitives.common.LineSegment(x,y));});//ignore jslint
	break;case 2/*primitives.common.ConnectorType.Curved*/:rect=new primitives.common.Rect(bundlePoint,point);if(drawToBundle){if(bundlePoint.x>rect.x){_transform.transform3Points(rect.right(),rect.verticalCenter(),rect.x,rect.verticalCenter(),rect.x,rect.bottom(),true,this,function(cpX1,cpY1,cpX2,cpY2,x,y){polyline.addSegment(new primitives.common.CubicArcSegment(cpX1,cpY1,cpX2,cpY2,x,y));});//ignore jslint
	}else{_transform.transform3Points(rect.x,rect.verticalCenter(),rect.right(),rect.verticalCenter(),rect.right(),rect.bottom(),true,this,function(cpX1,cpY1,cpX2,cpY2,x,y){polyline.addSegment(new primitives.common.CubicArcSegment(cpX1,cpY1,cpX2,cpY2,x,y));});//ignore jslint
	}}else{if(bundlePoint.x>rect.x){_transform.transformPoints(rect.x,rect.y,rect.x,rect.bottom(),true,this,function(cpX,cpY,x,y){polyline.addSegment(new primitives.common.QuadraticArcSegment(cpX,cpY,x,y));});//ignore jslint
	}else{_transform.transformPoints(rect.right(),rect.y,rect.right(),rect.bottom(),true,this,function(cpX,cpY,x,y){polyline.addSegment(new primitives.common.QuadraticArcSegment(cpX,cpY,x,y));});//ignore jslint
	}}break;}var isVisible=point.visibility!==4/*primitives.common.Visibility.Invisible*/;graph.addEdge(bundlePoint.id,point.id,new ConnectorEdge(bundlePoint.id,point.id,polyline,null,isVisible?point.id:null,isVisible?1000.0:10));}}function getGraph(){return _data.graph;}return{process:process,getGraph:getGraph};};/* /Controls/OrgDiagram/Tasks/Transformations/IntervalsTask.js*/primitives.orgdiagram.IntervalsTask=function(itemsSizesOptionTask){var intervals={};function process(){var options=itemsSizesOptionTask.getOptions();intervals[1/*primitives.common.Visibility.Normal*/]=options.normalItemsInterval;intervals[2/*primitives.common.Visibility.Dot*/]=options.dotItemsInterval;intervals[3/*primitives.common.Visibility.Line*/]=options.lineItemsInterval;intervals[4/*primitives.common.Visibility.Invisible*/]=options.lineItemsInterval;return true;}function getInterval(visibility){return intervals[visibility];}return{process:process,getInterval:getInterval};};/* /Controls/OrgDiagram/Tasks/Transformations/ItemsPositionsTask.js*/primitives.orgdiagram.ItemsPositionsTask=function(currentControlSizeTask,scaleOptionTask,orientationOptionTask,itemsSizesOptionTask,connectorsOptionTask,visualTreeOptionTask,intervalsTask,visualTreeTask,visualTreeLevelsTask,visualTreeMarginsTask,itemTemplateParamsTask,cursorItemTask,combinedNormalVisibilityItemsTask){var _data={treeItemsPositions:{},// primitives.orgdiagram.TreeItemPosition();
	treeLevelsPositions:[],// primitives.orgdiagram.TreeLevelPosition()
	panelSize:null// primitives.common.Rect();
	},_treeLevels,_visualTree,_leftMargins,_rightMargins,_orientationOptions,_connectorsOptions,_visualTreeOptions,_itemsSizesOptions,_scaleOptions;function process(){var panelSize,panelRect,scale;_itemsSizesOptions=itemsSizesOptionTask.getOptions();_orientationOptions=orientationOptionTask.getOptions();_connectorsOptions=connectorsOptionTask.getOptions();_visualTreeOptions=visualTreeOptionTask.getOptions();_treeLevels=visualTreeLevelsTask.getTreeLevels();_visualTree=visualTreeTask.getVisualTree();_leftMargins=visualTreeMarginsTask.getLeftMargins();_rightMargins=visualTreeMarginsTask.getRightMargins();_data.treeLevelsPositions=[];_data.treeItemsPositions={};panelSize=currentControlSizeTask.getOptimalPanelSize();_scaleOptions=scaleOptionTask.getOptions();scale=_scaleOptions.scale;panelSize.scale(1.0/scale);panelRect=new primitives.common.Rect(0,0,panelSize.width,panelSize.height);_data.panelSize=positionTreeItems(panelRect);recalcItemsPositions();return true;}/*  Position */function positionTreeItems(panelSize){var placeholderSize=new primitives.common.Rect(0,0,0,0),levelVisibilities,visibilities,level,index,minimalPlaceholderSize,leftMargin,rightMargin,cursorIndex,pageSize;switch(_orientationOptions.orientationType){case 2/*primitives.common.OrientationType.Left*/:case 3/*primitives.common.OrientationType.Right*/:panelSize.invert();break;}if(!_treeLevels.isEmpty()){switch(_itemsSizesOptions.pageFitMode){case 0/*primitives.common.PageFitMode.None*/:case 4/*primitives.common.PageFitMode.PrintPreview*/:case 5/*primitives.common.PageFitMode.AutoSize*/:levelVisibilities=[new primitives.orgdiagram.LevelVisibility(0,1/*primitives.common.Visibility.Normal*/)];placeholderSize=setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,0);break;default:levelVisibilities=[new primitives.orgdiagram.LevelVisibility(0,1/*primitives.common.Visibility.Normal*/)];visibilities=[];switch(_itemsSizesOptions.minimalVisibility){case 1/*primitives.common.Visibility.Normal*/:break;case 2/*primitives.common.Visibility.Dot*/:visibilities.push(2/*primitives.common.Visibility.Dot*/);break;case 0/*primitives.common.Visibility.Auto*/:case 3/*primitives.common.Visibility.Line*/:case 4/*primitives.common.Visibility.Invisible*/:visibilities.push(2/*primitives.common.Visibility.Dot*/);visibilities.push(3/*primitives.common.Visibility.Line*/);break;}_treeLevels.loopLevelsReversed(this,function(level,levelContext){var index;for(index=0;index<visibilities.length;index+=1){levelVisibilities.push(new primitives.orgdiagram.LevelVisibility(level,visibilities[index]));}});// Find minimal placeholder size to hold completly folded diagram
	minimalPlaceholderSize=setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,levelVisibilities.length-1);minimalPlaceholderSize.addRect(panelSize);minimalPlaceholderSize.offset(0,0,5,5);leftMargin=null;rightMargin=null;cursorIndex=null;// Maximized
	placeholderSize=setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,0);if(!checkDiagramSize(placeholderSize,minimalPlaceholderSize)){leftMargin=0;// Minimized
	placeholderSize=setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,levelVisibilities.length-1);if(checkDiagramSize(placeholderSize,minimalPlaceholderSize)){rightMargin=levelVisibilities.length-1;cursorIndex=rightMargin;while(rightMargin-leftMargin>1){cursorIndex=Math.floor((rightMargin+leftMargin)/2.0);placeholderSize=setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,cursorIndex);if(checkDiagramSize(placeholderSize,minimalPlaceholderSize)){rightMargin=cursorIndex;}else{leftMargin=cursorIndex;}}if(rightMargin!==cursorIndex){placeholderSize=setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,rightMargin);}}}break;}}return placeholderSize;}function setTreeLevelsVisibilityAndPositionTreeItems(levelVisibilities,cursorIndex){var index,levelVisibility;_data.treeLevelsPositions=[];_treeLevels.loopLevels(this,function(index,levelContext){var treeLevelPosition=new primitives.orgdiagram.TreeLevelPosition();treeLevelPosition.currentvisibility=1/*primitives.common.Visibility.Normal*/;_data.treeLevelsPositions.push(treeLevelPosition);});for(index=0;index<=cursorIndex;index+=1){levelVisibility=levelVisibilities[index];_data.treeLevelsPositions[levelVisibility.level].currentvisibility=levelVisibility.currentvisibility;}recalcItemsSize();setOffsets();recalcLevelsDepth();shiftLevels();return new primitives.common.Rect(0,0,Math.round(getDiagramWidth()),Math.round(getDiagramHeight()));}function checkDiagramSize(diagramSize,panelSize){var result=false;switch(_itemsSizesOptions.pageFitMode){case 1/*primitives.common.PageFitMode.PageWidth*/:if(panelSize.width>=diagramSize.width){result=true;}break;case 2/*primitives.common.PageFitMode.PageHeight*/:if(panelSize.height>=diagramSize.height){result=true;}break;case 3/*primitives.common.PageFitMode.FitToPage*/:if(panelSize.height>=diagramSize.height&&panelSize.width>=diagramSize.width){result=true;}break;}return result;}function getDiagramHeight(){var len=_data.treeLevelsPositions.length,treeLevel=_data.treeLevelsPositions[len-1];return treeLevel.shift+treeLevel.nextLevelShift;}function getDiagramWidth(){var result=0,index,len;for(index=0,len=_data.treeLevelsPositions.length;index<len;index+=1){result=Math.max(result,_data.treeLevelsPositions[index].currentOffset);}result+=_itemsSizesOptions.normalItemsInterval;return result;}function recalcItemsSize(){var cursorItemId=cursorItemTask.getCursorTreeItem();_data.treeItemsPositions={};_treeLevels.loopLevels(this,function(levelIndex,treeLevel){var treeLevelPosition=_data.treeLevelsPositions[levelIndex];_treeLevels.loopLevelItems(this,levelIndex,function(treeItemId,treeItem,position){var treeItemPosition=new primitives.orgdiagram.TreeItemPosition(),treeItemVisibility=combinedNormalVisibilityItemsTask.isItemSelected(treeItemId)?1/*primitives.common.Visibility.Normal*/:treeItem.visibility,treeItemtemplate=itemTemplateParamsTask.getTemplateParams(treeItemId);treeItemPosition.actualVisibility=treeItemVisibility===0/*primitives.common.Visibility.Auto*/?treeLevelPosition.currentvisibility:treeItemVisibility;treeItemPosition.setSize(cursorItemId==treeItemId,treeItemtemplate,_itemsSizesOptions,_orientationOptions);_data.treeItemsPositions[treeItemId]=treeItemPosition;});});}function recalcLevelsDepth(){var index,len,index2,len2,index3,len3,treeItem,treeLevel,treeItems,itemPosition,treeItemsHavingPartners,treeItemsGroup,partners,partner,levelOffset,minimalDepth,dotsDepth,startIndex,endIndex,stackSegments;_treeLevels.loopLevels(this,function(levelIndex,treeLevel){var treeLevelPosition=_data.treeLevelsPositions[levelIndex];treeLevelPosition.shift=0.0;treeLevelPosition.depth=0.0;treeLevelPosition.actualVisibility=4/*primitives.common.Visibility.Invisible*/;treeItemsHavingPartners=[];minimalDepth=null;/* minimum  height of non-dot items in level */dotsDepth=null;/* maximum dots height */_treeLevels.loopLevelItems(this,levelIndex,function(itemid,treeItem,position){var treeItemPosition=_data.treeItemsPositions[itemid];treeLevelPosition.depth=Math.max(treeLevelPosition.depth,treeItemPosition.actualSize.height);switch(treeItemPosition.actualVisibility){case 2/*primitives.common.Visibility.Dot*/:case 3/*primitives.common.Visibility.Line*/:case 4/*primitives.common.Visibility.Invisible*/:dotsDepth=!dotsDepth?treeItemPosition.actualSize.height:Math.min(dotsDepth,treeItemPosition.actualSize.height);break;default:minimalDepth=!minimalDepth?treeItemPosition.actualSize.height:Math.min(minimalDepth,treeItemPosition.actualSize.height);break;}treeLevelPosition.actualVisibility=Math.min(treeLevelPosition.actualVisibility,treeItemPosition.actualVisibility);});if(minimalDepth==null){minimalDepth=treeLevelPosition.depth;}if(dotsDepth!=null&&dotsDepth>minimalDepth){minimalDepth=dotsDepth;}switch(_itemsSizesOptions.verticalAlignment){case 0/*primitives.common.VerticalAlignmentType.Top*/:treeLevelPosition.horizontalConnectorsDepth=minimalDepth/2.0;break;case 1/*primitives.common.VerticalAlignmentType.Middle*/:treeLevelPosition.horizontalConnectorsDepth=treeLevelPosition.depth/2.0;break;case 2/*primitives.common.VerticalAlignmentType.Bottom*/:treeLevelPosition.horizontalConnectorsDepth=treeLevelPosition.depth-minimalDepth/2.0;break;}});}function shiftLevels(){var shift=_itemsSizesOptions.lineLevelShift,index,len,treeLevelPosition,treeLevelConnectorStackSize,childrenSpace=0,parentsSpace=0,arrowTipLength=_connectorsOptions.linesWidth*8;switch(_connectorsOptions.arrowsDirection){case 1/*primitives.common.GroupByType.Parents*/:childrenSpace=arrowTipLength;parentsSpace=0;break;case 2/*primitives.common.GroupByType.Children*/:childrenSpace=0;parentsSpace=arrowTipLength;break;}for(index=0,len=_data.treeLevelsPositions.length;index<len;index+=1){treeLevelPosition=_data.treeLevelsPositions[index];treeLevelConnectorStackSize=visualTreeLevelsTask.getConnectorsStacksSizes(index);shift+=treeLevelPosition.setShift(shift,getLevelSpace(treeLevelPosition.actualVisibility),parentsSpace,childrenSpace,treeLevelConnectorStackSize.parentsStackSize);}}function getLevelSpace(visibility){var result=0.0;switch(visibility){case 1/*primitives.common.Visibility.Normal*/:result=_itemsSizesOptions.normalLevelShift;break;case 2/*primitives.common.Visibility.Dot*/:result=_itemsSizesOptions.dotLevelShift;break;case 3/*primitives.common.Visibility.Line*/:case 4/*primitives.common.Visibility.Invisible*/:result=_itemsSizesOptions.lineLevelShift;break;}return result;}function setOffsets(){var index,len;for(index=0,len=_data.treeLevelsPositions.length;index<len;index+=1){_data.treeLevelsPositions[index].currentOffset=0.0;}_visualTree.loopPostOrder(this,function(treeItemId,treeItem,parentid,parent){var treeItemPosition=_data.treeItemsPositions[treeItemId],treeItemVisibility=treeItemPosition.actualVisibility,treeItemLevelIndex=_treeLevels.getLevelIndex(treeItemId),treeLevelPosition=_data.treeLevelsPositions[treeItemLevelIndex],treeItemPadding=intervalsTask.getInterval(treeItemVisibility===0/*primitives.common.Visibility.Auto*/?treeLevelPosition.currentvisibility:treeItemVisibility)/2.0,index,len,offset,siblings,gaps,gap,leftMargin,parentItem,groups,items,item1,item2,groupIndex,groupOffset,group,sibling,cousinsInterval=treeLevelPosition.currentOffset>0?treeItemPadding*treeItem.relationDegree*_itemsSizesOptions.cousinsIntervalMultiplier:0,arrowTipLength=_connectorsOptions.linesWidth*8;treeItemPosition.leftPadding=treeItemPadding+cousinsInterval;treeItemPosition.rightPadding=treeItemPadding;if(_connectorsOptions.arrowsDirection!=0/*primitives.common.GroupByType.None*/){if(treeItem.connectorPlacement&8/*primitives.common.SideFlag.Left*/){treeItemPosition.leftPadding+=arrowTipLength;}if(treeItem.connectorPlacement&2/*primitives.common.SideFlag.Right*/){treeItemPosition.rightPadding+=arrowTipLength;}}treeItemPosition.offset=treeLevelPosition.currentOffset+treeItemPosition.leftPadding;treeLevelPosition.currentOffset=treeItemPosition.offset+treeItemPosition.actualSize.width+treeItemPosition.rightPadding;if(_visualTree.hasChildren(treeItemId)){offset=getChildrenOffset(treeItem);if(offset>0){offsetItemChildren(treeItem,offset);}else if(offset<0){offset=-offset;offsetItem(treeItem,offset);siblings=null;gaps={};leftMargin=null;parentItem=_visualTree.parent(treeItem.id);if(parentItem!==null){_visualTree.loopChildrenReversed(this,parentItem.id,function(childItemId,childItem,index){if(childItem===treeItem){siblings=[];}else if(siblings!==null){gap=getGapBetweenSiblings(childItem,treeItem);gaps[childItem.id]=gap;if(gap>0){siblings.splice(0,0,childItem);}else{leftMargin=childItem;return true;}}});if(siblings.length>0){groups=null;if(leftMargin!==null){items=[leftMargin];items=items.concat(siblings);items.push(treeItem);groups=[[leftMargin]];for(index=1,len=items.length;index<len;index+=1){item1=items[index-1];item2=items[index];if(item1.gravity==2/*primitives.common.HorizontalAlignmentType.Right*/||item2.gravity==1/*primitives.common.HorizontalAlignmentType.Left*/){groups[groups.length-1].push(item2);}else{groups.push([item2]);}}}else{groups=[siblings.slice(0)];groups[groups.length-1].push(treeItem);}// align items to the right
	if(groups.length>0){siblings=groups[groups.length-1];for(index=siblings.length-2;index>=0;index-=1){sibling=siblings[index];gap=gaps[sibling.id];offset=Math.min(gap,offset);offsetItem(sibling,offset);offsetItemChildren(sibling,offset);}}// spread items proportionally
	groupOffset=offset/(groups.length-1);for(groupIndex=groups.length-2;groupIndex>0;groupIndex-=1){group=groups[groupIndex];for(index=group.length-1;index>=0;index-=1){sibling=group[index];gap=gaps[sibling.id];offset=Math.min(groupIndex*groupOffset,Math.min(gap,offset));offsetItem(sibling,offset);offsetItemChildren(sibling,offset);}}}}}}});}function getGapBetweenSiblings(leftItem,rightItem){var result=null,rightMargins=getRightMargins(leftItem),leftMargins=getLeftMargins(rightItem),depth=Math.min(rightMargins.length,leftMargins.length),index,gap;for(index=0;index<depth;index+=1){gap=leftMargins[index]-rightMargins[index];result=result!==null?Math.min(result,gap):gap;if(gap<=0){break;}}return Math.floor(result);}function getRightMargins(treeItem){var result=[],rightMargins,index,len,marginItemPosition;rightMargins=_rightMargins[treeItem.id];if(rightMargins===undefined){rightMargins=[];}rightMargins=rightMargins.slice();rightMargins.splice(0,0,treeItem.id);for(index=0,len=rightMargins.length;index<len;index+=1){marginItemPosition=_data.treeItemsPositions[rightMargins[index]];result[index]=marginItemPosition.offset+marginItemPosition.actualSize.width+marginItemPosition.rightPadding;}return result;}function getLeftMargins(treeItem){var result=[],leftMargins,index,len,marginItemPosition;leftMargins=_leftMargins[treeItem.id];if(leftMargins===undefined){leftMargins=[];}leftMargins=leftMargins.slice();leftMargins.splice(0,0,treeItem.id);for(index=0,len=leftMargins.length;index<len;index+=1){marginItemPosition=_data.treeItemsPositions[leftMargins[index]];result[index]=marginItemPosition.offset-marginItemPosition.leftPadding;}return result;}function getChildrenOffset(treeItem){var treeItemPosition=_data.treeItemsPositions[treeItem.id],treeItemCenterOffset=treeItemPosition.offset+treeItemPosition.actualSize.width/2.0,childrenCenterOffset=null,firstItem,firstItemPosition,lastItem,lastItemPosition,visualAggregatorPosition;if(treeItem.visualAggregatorId===null){firstItem=null;_visualTree.loopChildren(this,treeItem.id,function(childItemId,childItem,index){firstItem=childItem;if(firstItem.connectorPlacement&1/*primitives.common.SideFlag.Top*/){return true;}});firstItemPosition=_data.treeItemsPositions[firstItem.id];lastItem=null;_visualTree.loopChildrenReversed(this,treeItem.id,function(childItemId,childItem,index){lastItem=childItem;if(lastItem.connectorPlacement&1/*primitives.common.SideFlag.Top*/){return true;}});lastItemPosition=_data.treeItemsPositions[lastItem.id];switch(_visualTreeOptions.horizontalAlignment){case 1/*primitives.common.HorizontalAlignmentType.Left*/:childrenCenterOffset=firstItemPosition.offset+firstItemPosition.actualSize.width/2.0;break;case 2/*primitives.common.HorizontalAlignmentType.Right*/:childrenCenterOffset=lastItemPosition.offset+lastItemPosition.actualSize.width/2.0;break;case 0/*primitives.common.HorizontalAlignmentType.Center*/:childrenCenterOffset=(firstItemPosition.offset+lastItemPosition.offset+lastItemPosition.actualSize.width)/2.0;break;}}else{visualAggregatorPosition=_data.treeItemsPositions[treeItem.visualAggregatorId];childrenCenterOffset=visualAggregatorPosition.offset+visualAggregatorPosition.actualSize.width/2.0;}var i=treeItemCenterOffset-childrenCenterOffset;return treeItemCenterOffset-childrenCenterOffset;}function offsetItem(treeItem,offset){var treeItemPosition=_data.treeItemsPositions[treeItem.id];treeItemPosition.offset+=offset;var treeLevelPosition=_data.treeLevelsPositions[_treeLevels.getLevelIndex(treeItem.id)];treeLevelPosition.currentOffset=Math.max(treeLevelPosition.currentOffset,treeItemPosition.offset+treeItemPosition.actualSize.width+treeItemPosition.rightPadding);}function offsetItemChildren(treeItem,offset){var childTreeItemPosition,treeLevelPosition;_visualTree.loopLevels(this,treeItem.id,function(childItemId,childItem,levelid){childTreeItemPosition=_data.treeItemsPositions[childItemId];childTreeItemPosition.offset+=offset;treeLevelPosition=_data.treeLevelsPositions[_treeLevels.getLevelIndex(childItemId)];treeLevelPosition.currentOffset=Math.max(treeLevelPosition.currentOffset,childTreeItemPosition.offset+childTreeItemPosition.actualSize.width);return true;});}function recalcItemsPositions(){_treeLevels.loopLevels(this,function(levelIndex,treeLevel){var treeLevelPosition=_data.treeLevelsPositions[levelIndex];_treeLevels.loopLevelItems(this,levelIndex,function(itemid,treeItem,position){var treeItemPosition=_data.treeItemsPositions[itemid];treeItemPosition.setPosition(treeLevelPosition,_itemsSizesOptions,_orientationOptions);});});}function getTreeLevelsPositions(){return _data.treeLevelsPositions;}function getItemPosition(itemid){return _data.treeItemsPositions[itemid];}function getItemsPositions(){return _data.treeItemsPositions;}function getContentSize(){return _data.panelSize;}return{process:process,getTreeLevelsPositions:getTreeLevelsPositions,getItemsPositions:getItemsPositions,getItemPosition:getItemPosition,getContentSize:getContentSize};};/* /Controls/OrgDiagram/Tasks/Transformations/OrgTreeTask.js*/primitives.orgdiagram.OrgTreeTask=function(itemsOptionTask){var _data={orgTree:null,/*tree primitives.orgdiagram.OrgItem */maximumId:null/* maximum of OrgItem.id */};function process(){createOrgTree(itemsOptionTask.getItems());return true;}function createOrgTree(items){var orgItem,orgItemRoot,userItem,index,len,index2,len2,property,maximumId=0,parsedId,// Organizational chart definition
	orgTree=primitives.common.tree(),rootItemConfig;/* convert items to hash table */for(index=0,len=items.length;index<len;index+=1){userItem=items[index];/* user should define unique id for every ItemConfig otherwise we ignore it
					if parent does not exists in the tree then item is considered as root item
				*/if(userItem.id!=null){/* Organizational chart ItemConfig is almost the same as OrgItem
						except options used to draw connectors in multi parent chart
					*/orgItem=new primitives.orgdiagram.OrgItem(userItem);// OrgItem id coinsides with ItemConfig id since we don't add any new org items to user's org chart definition
	parsedId=parseInt(userItem.id,10);maximumId=Math.max(isNaN(parsedId)?0:parsedId,maximumId);// Collect org items
	orgTree.add(userItem.parent,orgItem.id,orgItem);/* We ignore looped items, it is applications responsibility to control data consistency */}}/* create chart root item config */maximumId+=1;rootItemConfig=new primitives.orgdiagram.ItemConfig();rootItemConfig.id=maximumId;rootItemConfig.title="internal root";rootItemConfig.isVisible=false;rootItemConfig.isActive=false;/* create chart org root item */orgItemRoot=new primitives.orgdiagram.OrgItem(rootItemConfig);orgItemRoot.hideParentConnection=true;orgItemRoot.hideChildrenConnection=true;orgTree.add(null,orgItemRoot.id,orgItemRoot);orgTree.loopLevels(this,function(nodeid,node,levelid){if(levelid>0){return orgTree.BREAK;}if(orgItemRoot.id!=nodeid){orgTree.adopt(orgItemRoot.id,nodeid);/* root item must be regular */node.itemType=0/*primitives.orgdiagram.ItemType.Regular*/;}});hideRootConnectors(orgTree);_data.orgTree=orgTree;_data.maximumId=maximumId;return true;}function hideRootConnectors(orgTree){orgTree.loopLevels(this,function(nodeid,node,levelid){var allRegular=true;if(!node.isVisible){orgTree.loopChildren(this,nodeid,function(childid,child,index){if(child.itemType!=0/*primitives.orgdiagram.ItemType.Regular*/){allRegular=false;return true;// break
	}});//ignore jslint
	if(allRegular){node.hideChildrenConnection=true;orgTree.loopChildren(this,nodeid,function(childid,child,index){child.hideParentConnection=true;});}else{return orgTree.SKIP;// skip children
	}}else{return orgTree.SKIP;}});}function getOrgTree(){return _data.orgTree;}function getMaximumId(){return _data.maximumId;}return{process:process,getOrgTree:getOrgTree,getMaximumId:getMaximumId};};/* /Controls/OrgDiagram/Tasks/Transformations/PalleteManagerTask.js*/primitives.orgdiagram.PaletteManagerTask=function(connectorsOptionTask,linePaletteOptionTask){var _paletteManager;function process(){var linesPalette=[];if(linePaletteOptionTask!=null){linesPalette=linePaletteOptionTask.getOptions().linesPalette;}_paletteManager=new primitives.common.PaletteManager(connectorsOptionTask.getOptions(),linesPalette);return true;}function getPaletteManager(){return _paletteManager;}return{process:process,getPaletteManager:getPaletteManager};};/* /Controls/OrgDiagram/Tasks/Transformations/VisualTreeLevelsTask.js*//* Read visual tree
			populate treeLevels array of type TreeLevel
				TreeLevel object contains ordered list of all its items
				plus when items added to that collection we store level & levelPosition in item
	*/primitives.orgdiagram.VisualTreeLevelsTask=function(visualTreeTask,itemTemplateParamsTask){var _data={treeLevels:null,/* primitives.common.TreeLevels */activeTreeLevels:null,/* primitives.common.TreeLevels */bundles:null,/* array of primitives.orgdiagram.ConnectorBundle objects */connectorStacks:null/* array of primitives.orgdiagram.TreeLevelConnectorStackSize objects,
				it keeps total number of horizontal connectors lines between parents and children stack on top of each other */},_nullTreeLevelConnectorStackSize=new primitives.orgdiagram.TreeLevelConnectorStackSize();function process(){var visualTree=visualTreeTask.getVisualTree();_data.treeLevels=primitives.common.TreeLevels();_data.activeTreeLevels=primitives.common.TreeLevels();visualTree.loopLevels(this,function(treeItemId,treeItem,levelIndex){var templateParams=itemTemplateParamsTask.getTemplateParams(treeItemId);_data.treeLevels.addItem(levelIndex,treeItemId,treeItem);if(templateParams!=null&&templateParams.isActive&&treeItem.visibility!=4/*primitives.common.Visibility.Invisible*/){_data.activeTreeLevels.addItem(levelIndex,treeItemId,treeItem);}});_data.bundles=[];_data.connectorStacks=[];recalcLevelsDepth(_data.bundles,_data.connectorStacks,_data.treeLevels,visualTree);return true;}function recalcLevelsDepth(bundles,connectorStacks,treeLevels,orgTree,orgPartners){var index,len,index2,len2,index3,len3,treeItem,itemPosition,bundle,bundlesToStack,bundlesByItemmId={},startIndex,endIndex,stackSegments;treeLevels.loopLevels(this,function(levelIndex,treeLevel){var stacksSizes=new primitives.orgdiagram.TreeLevelConnectorStackSize();connectorStacks[levelIndex]=stacksSizes;bundlesToStack=[];treeLevels.loopLevelItems(this,levelIndex,function(itemid,treeItem,position){var parents=[];if(!bundlesByItemmId.hasOwnProperty(itemid)){if(treeItem.connectorPlacement&4/*primitives.common.SideFlag.Bottom*/){parents.push(itemid);}parents=parents.concat(treeItem.partners);if(parents.length>0){bundle=new primitives.orgdiagram.ConnectorBundle();bundle.fromLevel=levelIndex;bundle.fromItems=parents;bundle.toItems=[];for(var index=0,len=parents.length;index<len;index+=1){bundlesByItemmId[parents[index]]=bundle;}orgTree.loopChildren(this,itemid,function(childid,child,index){if(child.connectorPlacement&1/*primitives.common.SideFlag.Top*/){bundle.toItems.push(childid);}});//ignore jslint
	if(parents.length>1){bundlesToStack.push(bundle);}if(bundle.fromItems.length>1||bundle.toItems.length>0){bundles.push(bundle);}}}if(treeItem.connectorPlacement&8/*primitives.common.SideFlag.Left*/){bundle=new primitives.orgdiagram.ConnectorBundle();bundle.isVertical=false;bundle.fromLevel=levelIndex;bundle.fromItems=[itemid];bundle.toItems=[treeLevels.getPrevItem(itemid)];bundles.push(bundle);}if(treeItem.connectorPlacement&2/*primitives.common.SideFlag.Right*/){bundle=new primitives.orgdiagram.ConnectorBundle();bundle.isVertical=false;bundle.fromLevel=levelIndex;bundle.fromItems=[itemid];bundle.toItems=[treeLevels.getNextItem(itemid)];bundles.push(bundle);}});if(bundlesToStack.length>0){/* find minimum and maximum partner index at level */stackSegments=primitives.common.pile();for(index2=0,len2=bundlesToStack.length;index2<len2;index2+=1){bundle=bundlesToStack[index2];startIndex=null;endIndex=null;for(index3=0,len3=bundle.fromItems.length;index3<len3;index3+=1){itemPosition=treeLevels.getItemPosition(bundle.fromItems[index3]);startIndex=startIndex!=null?Math.min(startIndex,itemPosition):itemPosition;endIndex=endIndex!=null?Math.max(endIndex,itemPosition):itemPosition;}stackSegments.add(startIndex,endIndex,bundle);}stacksSizes.parentsStackSize=stackSegments.resolve(this,function(from,to,bundle,offset){bundle.fromOffset=offset+1;});//ignore jslint
	}});}function getTreeLevels(){return _data.treeLevels;}function getActiveTreeLevels(){return _data.activeTreeLevels;}function getBundles(){return _data.bundles;}function getConnectorsStacksSizes(levelid){return _data.connectorStacks[levelid]||_nullTreeLevelConnectorStackSize;}return{process:process,getTreeLevels:getTreeLevels,getActiveTreeLevels:getActiveTreeLevels,getBundles:getBundles,getConnectorsStacksSizes:getConnectorsStacksSizes};};/* /Controls/OrgDiagram/Tasks/Transformations/VisualTreeMarginsTask.js*//* Read visual tree and create leftMargins & rightMargins collections
	   for every tree item in visual hierarchy they are used to for horizontal alignment of visual tree items
	*/primitives.orgdiagram.VisualTreeMarginsTask=function(visualTreeTask){var _data={leftMargins:{},rightMargins:{}};function process(){_data.leftMargins={},_data.rightMargins={};updateVisualTreeMargins(visualTreeTask.getVisualTree(),_data.leftMargins,_data.rightMargins);return true;}function updateVisualTreeMargins(visualTree,leftMargins,rightMargins){visualTree.loop(this,function(nodeid,node){leftMargins[nodeid]=[];rightMargins[nodeid]=[];});visualTree.loopPostOrder(this,function(nodeid,node,parentid,parent){var parentLeftMargins=leftMargins[parentid],parentRightMargins=rightMargins[parentid],nodeLeftMargins=leftMargins[nodeid],nodeRightMargins=rightMargins[nodeid],index,len;if(parentid!=null){/* update parent left margins */if(!parentLeftMargins[0]){parentLeftMargins[0]=nodeid;}for(index=0,len=nodeLeftMargins.length;index<len;index+=1){if(!parentLeftMargins[index+1]){parentLeftMargins[index+1]=nodeLeftMargins[index];}}/* update parent rights margins */parentRightMargins[0]=nodeid;for(index=0,len=nodeRightMargins.length;index<len;index+=1){parentRightMargins[index+1]=nodeRightMargins[index];}}});}function getLeftMargins(){return _data.leftMargins;}function getRightMargins(){return _data.rightMargins;}return{process:process,getLeftMargins:getLeftMargins,getRightMargins:getRightMargins};};/* /Controls/OrgDiagram/Tasks/Transformations/VisualTreeTask.js*//* method uses structures created in orgTreeTask to create visual tree used to render chart
		It populates visualTree structure with TreeItem objects.
	
		1. Create invisble visual root item, so all orphants added to it, but since it is invisible, no connections are going to be drawn betwen them
		2. Loop orgTree nodes and populate visual tree hierarchy: visualTree
	*/primitives.orgdiagram.VisualTreeTask=function(orgTreeTask,itemTemplateParamsTask,visualTreeOptionTask,isFamilyChartMode){var _data={visualTree:null,/* primitives.common.tree(); key: primitives.orgdiagram.TreeItem.id value:primitives.orgdiagram.TreeItem */navigationFamily:null/* family structure where key: TreeItem.id and value: TreeItem */},_treeItemCounter;function process(){var orgTree=orgTreeTask.getOrgTree(),options=visualTreeOptionTask.getOptions();_data.visualTree=primitives.common.tree();_data.navigationFamily=primitives.common.family();_treeItemCounter=orgTreeTask.getMaximumId();if(orgTree.hasNodes()){createVisualTreeItems(orgTree,options,_data.visualTree);}return true;}function createVisualTreeItems(orgTree,options,visualTree){var treeItem,visualParent,visualAggregator,leftSiblingIndex,rightSiblingIndex,index,len,childIndex,childrenLen,depth,rowDepths,rowDepth,rowAggregators={},rowAggregator,rowChildren={},children,leftSiblingOffset,rightSiblingOffset,partners={},tempPartners;/* org tree item has visible children */orgTree.loopPostOrder(this,function(nodeid,node,parentid,parent){node.hasVisibleChildren=node.isVisible||node.hasVisibleChildren;if(parent!=null){parent.hasVisibleChildren=parent.hasVisibleChildren||node.hasVisibleChildren;}});orgTree.loopLevels(this,function(parentOrgItemId,parentOrgItem,levelid){var logicalParentItem,regularChildren,shiftParent;if(!isFamilyChartMode&&!parentOrgItem.hasVisibleChildren){return orgTree.SKIP;}logicalParentItem=visualTree.node(parentOrgItemId);if(!logicalParentItem){logicalParentItem=getNewTreeItem({visibility:4/*primitives.common.Visibility.Invisible*/,connectorPlacement:0,parentId:null,actualItemType:0/*primitives.orgdiagram.ItemType.Regular*/},parentOrgItem);visualTree.add(null,parentOrgItemId,logicalParentItem);}/* find left and right siblings margins of logical parent item
					they are needed to properly place GeneralPartner & LimitedPartner nodes. */leftSiblingOffset=0;rightSiblingOffset=0;if((index=visualTree.indexOf(parentOrgItemId))!=null){leftSiblingOffset=index;rightSiblingOffset=visualTree.countSiblings(parentOrgItemId)-index-1;}/* populate children */regularChildren=[];/* children added after all other custom item types */orgTree.loopChildren(this,parentOrgItemId,function(orgItemId,orgItem,index){if(isFamilyChartMode||orgItem.hasVisibleChildren){treeItem=getNewTreeItem({parentId:parentOrgItemId,actualItemType:orgItem.itemType},orgItem);switch(logicalParentItem.actualItemType){case 7/*primitives.orgdiagram.ItemType.LimitedPartner*/:case 8/*primitives.orgdiagram.ItemType.AdviserPartner*/:case 6/*primitives.orgdiagram.ItemType.GeneralPartner*/:switch(treeItem.actualItemType){case 7/*primitives.orgdiagram.ItemType.LimitedPartner*/:case 8/*primitives.orgdiagram.ItemType.AdviserPartner*/:case 6/*primitives.orgdiagram.ItemType.GeneralPartner*/:/* Don't support partner of partner */treeItem.actualItemType=2/*primitives.orgdiagram.ItemType.Adviser*/;break;case 0/*primitives.orgdiagram.ItemType.Regular*/:/* Don't support regular children of partner */treeItem.actualItemType=1/*primitives.orgdiagram.ItemType.Assistant*/;break;}break;}switch(treeItem.actualItemType){case 5/*primitives.orgdiagram.ItemType.SubAdviser*/:defineNavigationParent(logicalParentItem,treeItem);treeItem.connectorPlacement=1/*primitives.common.SideFlag.Top*/|4/*primitives.common.SideFlag.Bottom*/;shiftParent=getNewTreeItem({visibility:4/*primitives.common.Visibility.Invisible*/});visualTree.add(shiftParent.id,treeItem.id,treeItem);treeItem=shiftParent;//ignore jslint
	case 8/*primitives.orgdiagram.ItemType.AdviserPartner*/://ignore jslint
	case 2/*primitives.orgdiagram.ItemType.Adviser*/://ignore jslint
	visualParent=visualTree.parent(parentOrgItemId);if(logicalParentItem.connectorPlacement&2/*primitives.common.SideFlag.Right*/){leftSiblingIndex=findLeftSiblingIndex(visualTree,_data.navigationFamily,logicalParentItem);visualTree.add(visualParent.id,treeItem.id,treeItem,leftSiblingIndex+1);treeItem.connectorPlacement=2/*primitives.common.SideFlag.Right*/|4/*primitives.common.SideFlag.Bottom*/;treeItem.gravity=2/*primitives.common.HorizontalAlignmentType.Right*/;}else if(logicalParentItem.connectorPlacement&8/*primitives.common.SideFlag.Left*/){rightSiblingIndex=findRightSiblingIndex(visualTree,_data.navigationFamily,logicalParentItem);visualTree.add(visualParent.id,treeItem.id,treeItem,rightSiblingIndex);treeItem.connectorPlacement=8/*primitives.common.SideFlag.Left*/|4/*primitives.common.SideFlag.Bottom*/;treeItem.gravity=1/*primitives.common.HorizontalAlignmentType.Left*/;}else{switch(orgItem.adviserPlacementType){case 2/*primitives.common.AdviserPlacementType.Left*/:leftSiblingIndex=findLeftSiblingIndex(visualTree,_data.navigationFamily,logicalParentItem);visualTree.add(visualParent.id,treeItem.id,treeItem,leftSiblingIndex+1);treeItem.connectorPlacement=2/*primitives.common.SideFlag.Right*/|4/*primitives.common.SideFlag.Bottom*/;treeItem.gravity=2/*primitives.common.HorizontalAlignmentType.Right*/;break;default:rightSiblingIndex=findRightSiblingIndex(visualTree,_data.navigationFamily,logicalParentItem);visualTree.add(visualParent.id,treeItem.id,treeItem,rightSiblingIndex);treeItem.connectorPlacement=8/*primitives.common.SideFlag.Left*/|4/*primitives.common.SideFlag.Bottom*/;treeItem.gravity=1/*primitives.common.HorizontalAlignmentType.Left*/;break;}}switch(treeItem.actualItemType){case 5/*primitives.orgdiagram.ItemType.SubAdviser*/:break;case 8/*primitives.orgdiagram.ItemType.AdviserPartner*/:if(logicalParentItem.parentId!=null){defineNavigationParent(visualTree.node(logicalParentItem.parentId),treeItem);}else{defineNavigationParent(logicalParentItem,treeItem,true);}break;case 2/*primitives.orgdiagram.ItemType.Adviser*/:defineNavigationParent(logicalParentItem,treeItem);break;}break;case 4/*primitives.orgdiagram.ItemType.SubAssistant*/:defineNavigationParent(logicalParentItem,treeItem);treeItem.connectorPlacement=1/*primitives.common.SideFlag.Top*/|4/*primitives.common.SideFlag.Bottom*/;shiftParent=getNewTreeItem({visibility:4/*primitives.common.Visibility.Invisible*/});visualTree.add(shiftParent.id,treeItem.id,treeItem);treeItem=shiftParent;//ignore jslint
	case 1/*primitives.orgdiagram.ItemType.Assistant*/://ignore jslint
	if(logicalParentItem.visualAggregatorId===null){createNewVisualAggregator(visualTree,logicalParentItem,false);}switch(orgItem.adviserPlacementType){case 2/*primitives.common.AdviserPlacementType.Left*/:visualTree.add(parentOrgItemId,treeItem.id,treeItem,0);treeItem.connectorPlacement=2/*primitives.common.SideFlag.Right*/|4/*primitives.common.SideFlag.Bottom*/;treeItem.gravity=2/*primitives.common.HorizontalAlignmentType.Right*/;break;default:visualTree.add(parentOrgItemId,treeItem.id,treeItem);treeItem.connectorPlacement=8/*primitives.common.SideFlag.Left*/|4/*primitives.common.SideFlag.Bottom*/;treeItem.gravity=1/*primitives.common.HorizontalAlignmentType.Left*/;break;}if(treeItem.actualItemType==1/*primitives.orgdiagram.ItemType.Assistant*/){defineNavigationParent(logicalParentItem,treeItem);}break;case 0/*primitives.orgdiagram.ItemType.Regular*/:regularChildren.push(treeItem);defineNavigationParent(logicalParentItem,treeItem);break;case 7/*primitives.orgdiagram.ItemType.LimitedPartner*/:case 6/*primitives.orgdiagram.ItemType.GeneralPartner*/:visualParent=visualTree.parent(parentOrgItemId);if(logicalParentItem.connectorPlacement&2/*primitives.common.SideFlag.Right*/){visualTree.add(visualParent.id,treeItem.id,treeItem,leftSiblingOffset);treeItem.connectorPlacement=2/*primitives.common.SideFlag.Right*/|4/*primitives.common.SideFlag.Bottom*/;treeItem.gravity=2/*primitives.common.HorizontalAlignmentType.Right*/;}else if(logicalParentItem.connectorPlacement&8/*primitives.common.SideFlag.Left*/){visualTree.add(visualParent.id,treeItem.id,treeItem,visualTree.countChildren(visualParent.id)-rightSiblingOffset);treeItem.connectorPlacement=8/*primitives.common.SideFlag.Left*/|4/*primitives.common.SideFlag.Bottom*/;treeItem.gravity=1/*primitives.common.HorizontalAlignmentType.Left*/;}else{switch(orgItem.adviserPlacementType){case 2/*primitives.common.AdviserPlacementType.Left*/:visualTree.add(visualParent.id,treeItem.id,treeItem,leftSiblingOffset);treeItem.gravity=2/*primitives.common.HorizontalAlignmentType.Right*/;break;default:visualTree.add(visualParent.id,treeItem.id,treeItem,visualTree.countChildren(visualParent.id)-rightSiblingOffset);treeItem.gravity=1/*primitives.common.HorizontalAlignmentType.Left*/;break;}switch(treeItem.actualItemType){case 6/*primitives.orgdiagram.ItemType.GeneralPartner*/:treeItem.connectorPlacement=1/*primitives.common.SideFlag.Top*/|4/*primitives.common.SideFlag.Bottom*/;break;case 7/*primitives.orgdiagram.ItemType.LimitedPartner*/:treeItem.connectorPlacement=4/*primitives.common.SideFlag.Bottom*/;break;}}if(logicalParentItem.parentId!=null){defineNavigationParent(visualTree.node(logicalParentItem.parentId),treeItem);}else{defineNavigationParent(logicalParentItem,treeItem,true);}break;}}});/* collect partners, add logicalParentItem into partners collection */switch(logicalParentItem.actualItemType){case 7/*primitives.orgdiagram.ItemType.LimitedPartner*/:case 8/*primitives.orgdiagram.ItemType.AdviserPartner*/:case 6/*primitives.orgdiagram.ItemType.GeneralPartner*/:break;default:tempPartners=[];if((visualParent=visualTree.parent(parentOrgItemId))!=null){visualTree.loopChildrenRange(this,visualParent.id,leftSiblingOffset,visualTree.countChildren(visualParent.id)-rightSiblingOffset,function(childItemId,childItem,index){if(childItem.id==parentOrgItemId){tempPartners.push(childItem);}else{switch(childItem.actualItemType){case 7/*primitives.orgdiagram.ItemType.LimitedPartner*/:case 8/*primitives.orgdiagram.ItemType.AdviserPartner*/:case 6/*primitives.orgdiagram.ItemType.GeneralPartner*/:if(orgTree.parentid(childItem.id)==parentOrgItemId){tempPartners.push(childItem);}break;}}});}if(tempPartners.length>1){partners[parentOrgItemId]=tempPartners;}break;}/* add children */rowAggregators[parentOrgItemId]=[];rowChildren[parentOrgItemId]=[];layoutChildren(orgTree,visualTree,options,logicalParentItem,regularChildren,parentOrgItem.childrenPlacementType,rowAggregators[parentOrgItemId],rowChildren[parentOrgItemId]);});/* transform tree to place children sub branches inside of hierarchy */orgTree.loopPostOrder(this,function(nodeid,node,parentid,parent){var logicalParentItem=visualTree.node(nodeid),itemRowChildren,itemRowAggregators,hasChildren;if(logicalParentItem!=null){itemRowChildren=rowChildren[nodeid];itemRowAggregators=rowAggregators[nodeid];/* Move assistants children inside */depth=getAssitantsDepth(visualTree,logicalParentItem);if(depth>0){logicalParentItem.visualDepth=depth+1;if(logicalParentItem.visualAggregatorId!==null){visualAggregator=visualTree.node(logicalParentItem.visualAggregatorId);hasChildren=visualTree.hasChildren(visualAggregator.id);for(index=0;index<depth-1;index+=1){visualAggregator=createNewVisualAggregator(visualTree,visualAggregator,!hasChildren);}}}/* Move advisers children inside */depth=getAdvisersDepth(visualTree,logicalParentItem);if(depth>1){logicalParentItem.visualDepth+=depth-1;hasChildren=visualTree.hasChildren(nodeid);visualAggregator=logicalParentItem;for(index=0;index<depth-1;index+=1){visualAggregator=createNewVisualAggregator(visualTree,visualAggregator,!hasChildren);}}/* Move children of children inside */rowDepths=[];for(index=0,len=itemRowChildren.length;index<len;index+=1){children=itemRowChildren[index];rowDepths[index]=0;for(childIndex=0,childrenLen=children.length;childIndex<childrenLen;childIndex+=1){rowDepths[index]=Math.max(rowDepths[index],getItemDepth(visualTree,children[childIndex]));}}for(index=0,len=rowDepths.length;index<len;index+=1){rowDepth=rowDepths[index];if(rowDepth>1){for(childIndex=0,childrenLen=itemRowAggregators[index].length;childIndex<childrenLen;childIndex+=1){rowAggregator=itemRowAggregators[index][childIndex];if(visualTree.hasChildren(rowAggregator.id)){depth=rowDepth;while(depth>1){rowAggregator=createNewVisualAggregator(visualTree,rowAggregator,false);depth-=1;}}}}}/* Align heights of partner branches in order to draw connector lines between them and logical parent children */if(partners[nodeid]!=null){/* partners collection includes treeItem so we should have at least 2 items */layoutPartners(visualTree,logicalParentItem,partners[nodeid]);}}});}function layoutPartners(visualTree,treeItem,partners){var partner,index,len,depth,maxDepth=0,visualPartners=[],visualPartner,visualParent,visualAggregator,leftSiblingIndex,gravity;/* Find maximum depth required to enclose partners branches */for(index=0,len=partners.length;index<len;index+=1){partner=partners[index];maxDepth=Math.max(maxDepth,partner.visualDepth);}/* Extend visual aggregators lines and ensure that connector lines are visible */for(index=0,len=partners.length;index<len;index+=1){partner=partners[index];visualPartner=getLastVisualAggregator(visualTree,partner);depth=1;visualAggregator=partner;while(visualAggregator.visualAggregatorId!=null){visualAggregator=visualTree.node(visualAggregator.visualAggregatorId);visualAggregator.connectorPlacement=1/*primitives.common.SideFlag.Top*/|4/*primitives.common.SideFlag.Bottom*/;depth+=1;}while(depth<maxDepth){visualPartner=createNewVisualAggregator(visualTree,visualPartner,false);depth+=1;}visualPartners.push(getLastVisualAggregator(visualTree,visualPartner).id);}visualAggregator=getLastVisualAggregator(visualTree,treeItem);if(visualTree.hasChildren(visualAggregator.id)){/* Select middle partner */visualPartner=partners[Math.floor(partners.length/2)];if(partners.length>1&&partners.length%2===0){/* insert invisble partner for alignemnt */visualParent=visualTree.parent(visualPartner.id);leftSiblingIndex=findLeftSiblingIndex(visualTree,_data.navigationFamily,visualPartner);gravity=visualTree.getChild(visualParent.id,leftSiblingIndex).gravity||visualTree.getChild(visualParent.id,leftSiblingIndex+1).gravity;// visualParent.id,
	visualPartner=getNewTreeItem({visibility:4/*primitives.common.Visibility.Invisible*/,connectorPlacement:visualPartner.connectorPlacement&(8/*primitives.common.SideFlag.Left*/|2/*primitives.common.SideFlag.Right*/),gravity:gravity});visualTree.add(visualParent.id,visualPartner.id,visualPartner,leftSiblingIndex+1);depth=1;while(depth<maxDepth){visualPartner=createNewVisualAggregator(visualTree,visualPartner,false);visualPartner.connectorPlacement=0;depth+=1;}}/* every child logically belongs to every partner */for(index=0,len=partners.length;index<len;index+=1){partner=partners[index];/* select all parents up to the root */_data.navigationFamily.loopChildren(this,treeItem.id,function(childItemId,childItem,level){switch(childItem.actualItemType){case 5/*primitives.orgdiagram.ItemType.SubAdviser*/:case 2/*primitives.orgdiagram.ItemType.Adviser*/:case 4/*primitives.orgdiagram.ItemType.SubAssistant*/:case 1/*primitives.orgdiagram.ItemType.Assistant*/:break;default:/* partners share only regular items */if(treeItem.id!=partner.id){defineNavigationParent(partner,childItem);}break;}return _data.navigationFamily.SKIP;});//ignore jslint
	}/* Move children to new visual partner node */visualPartner=getLastVisualAggregator(visualTree,visualPartner);visualTree.moveChildren(visualAggregator.id,visualPartner.id);}/* Store collection of visual partners to draw connector lines*/visualPartner.partners=visualPartners;}function getLastVisualAggregator(visualTree,treeItem){var result=treeItem;while(result.visualAggregatorId!=null){result=visualTree.node(result.visualAggregatorId);}return result;}function getAdvisersDepth(visualTree,treeItem){var result=0,parentItem=visualTree.parent(treeItem.id),treeItemIndex,position,childItem;if(parentItem!==null){treeItemIndex=visualTree.indexOf(treeItem.id);position=1;while((childItem=visualTree.getChild(parentItem.id,treeItemIndex+position))!=null){if(childItem.connectorPlacement&8/*primitives.common.SideFlag.Left*/){result=Math.max(result,getItemDepth(visualTree,childItem));position+=1;}else{break;}}position=1;while((childItem=visualTree.getChild(parentItem.id,treeItemIndex-position))!=null){if(childItem.connectorPlacement&2/*primitives.common.SideFlag.Right*/){result=Math.max(result,getItemDepth(visualTree,childItem));position+=1;}else{break;}}}return result;}function getAssitantsDepth(visualTree,treeItem){var result=0;if(treeItem.visualAggregatorId!=null){visualTree.loopLevels(this,treeItem.id,function(childItemId,childItem,level){if(treeItem.visualAggregatorId==childItemId){return visualTree.SKIP;}result=level+1;});}return result;}function getItemDepth(visualTree,treeItem){var result=0;visualTree.loopLevels(this,treeItem.id,function(childid,child,level){result=level+1;});return result+1;}function layoutChildren(orgTree,visualTree,options,treeItem,regularChildren,childrenPlacementType,rowAggregators,rowChildren){var visualParent,currentVisualParent,leftChildItem,rightChildItem,newAggregatorItem,childItem,orgChildItem,width,height,twinColumns,column,row,index,len,singleItemPlacement,hideParentConnector=treeItem.visibility==4/*primitives.common.Visibility.Invisible*/&&treeItem.connectorPlacement===0;switch(options.horizontalAlignment){case 0/*primitives.common.HorizontalAlignmentType.Center*/:case 1/*primitives.common.HorizontalAlignmentType.Left*/:singleItemPlacement=3/*primitives.common.AdviserPlacementType.Right*/;break;case 2/*primitives.common.HorizontalAlignmentType.Right*/:singleItemPlacement=2/*primitives.common.AdviserPlacementType.Left*/;break;}if(childrenPlacementType===0/*primitives.common.ChildrenPlacementType.Auto*/){if(hasRegularLeavesOnly(orgTree,treeItem)){childrenPlacementType=options.leavesPlacementType===0/*primitives.common.ChildrenPlacementType.Auto*/?3/*primitives.common.ChildrenPlacementType.Matrix*/:options.leavesPlacementType;}else{childrenPlacementType=options.childrenPlacementType===0/*primitives.common.ChildrenPlacementType.Auto*/?2/*primitives.common.ChildrenPlacementType.Horizontal*/:options.childrenPlacementType;}}visualParent=treeItem;/* if node has assitants then it has visual aggregator child node */if(treeItem.visualAggregatorId!==null){visualParent=visualTree.node(treeItem.visualAggregatorId);}if(childrenPlacementType==3/*primitives.common.ChildrenPlacementType.Matrix*/&&regularChildren.length<3){childrenPlacementType=2/*primitives.common.ChildrenPlacementType.Horizontal*/;}switch(childrenPlacementType){case 2/*primitives.common.ChildrenPlacementType.Horizontal*/:for(index=0,len=regularChildren.length;index<len;index+=1){childItem=regularChildren[index];orgChildItem=orgTree.node(childItem.id);visualTree.add(visualParent.id,childItem.id,childItem);childItem.connectorPlacement=(orgChildItem.hideParentConnection?0:1/*primitives.common.SideFlag.Top*/)|(orgChildItem.hideChildrenConnection?0:4/*primitives.common.SideFlag.Bottom*/);if(index===0){childItem.relationDegree=1;}}break;case 3/*primitives.common.ChildrenPlacementType.Matrix*/:width=Math.min(options.maximumColumnsInMatrix,Math.ceil(Math.sqrt(regularChildren.length)));height=Math.ceil(regularChildren.length/width);twinColumns=Math.ceil(width/2.0);for(column=0;column<twinColumns;column+=1){currentVisualParent=visualParent;for(row=0;row<height;row+=1){leftChildItem=getMatrixItem(regularChildren,column*2,row,width);rightChildItem=getMatrixItem(regularChildren,column*2+1,row,width);if(rowAggregators[row]===undefined){rowAggregators[row]=[];rowChildren[row]=[];}if(leftChildItem!==null){if(column===0){leftChildItem.relationDegree=1;}visualTree.add(currentVisualParent.id,leftChildItem.id,leftChildItem);leftChildItem.connectorPlacement=(hideParentConnector?0:2/*primitives.common.SideFlag.Right*/)|4/*primitives.common.SideFlag.Bottom*/;leftChildItem.gravity=2/*primitives.common.HorizontalAlignmentType.Right*/;rowChildren[row].push(leftChildItem);}if(leftChildItem!==null||rightChildItem!==null){// currentVisualParent.id,
	newAggregatorItem=getNewTreeItem({visibility:4/*primitives.common.Visibility.Invisible*/,connectorPlacement:hideParentConnector?0:1/*primitives.common.SideFlag.Top*/|4/*primitives.common.SideFlag.Bottom*/});visualTree.add(currentVisualParent.id,newAggregatorItem.id,newAggregatorItem);rowAggregators[row].push(newAggregatorItem);}if(rightChildItem!==null){visualTree.add(currentVisualParent.id,rightChildItem.id,rightChildItem);rightChildItem.connectorPlacement=(hideParentConnector?0:8/*primitives.common.SideFlag.Left*/)|4/*primitives.common.SideFlag.Bottom*/;rightChildItem.gravity=1/*primitives.common.HorizontalAlignmentType.Left*/;rowChildren[row].push(rightChildItem);}currentVisualParent=newAggregatorItem;}}if(width>2){// No center alignment to aggregator required
	visualParent.visualAggregatorId=null;}break;case 1/*primitives.common.ChildrenPlacementType.Vertical*/:for(index=0,len=regularChildren.length;index<len;index+=1){childItem=regularChildren[index];// visualParent.id,
	newAggregatorItem=getNewTreeItem({visibility:4/*primitives.common.Visibility.Invisible*/,connectorPlacement:hideParentConnector?0:1/*primitives.common.SideFlag.Top*/|4/*primitives.common.SideFlag.Bottom*/});switch(singleItemPlacement){case 2/*primitives.common.AdviserPlacementType.Left*/:visualTree.add(visualParent.id,childItem.id,childItem);visualTree.add(visualParent.id,newAggregatorItem.id,newAggregatorItem);childItem.connectorPlacement=(hideParentConnector?0:2/*primitives.common.SideFlag.Right*/)|4/*primitives.common.SideFlag.Bottom*/;childItem.gravity=2/*primitives.common.HorizontalAlignmentType.Right*/;break;case 3/*primitives.common.AdviserPlacementType.Right*/:visualTree.add(visualParent.id,newAggregatorItem.id,newAggregatorItem);visualTree.add(visualParent.id,childItem.id,childItem);childItem.connectorPlacement=(hideParentConnector?0:8/*primitives.common.SideFlag.Left*/)|4/*primitives.common.SideFlag.Bottom*/;childItem.gravity=1/*primitives.common.HorizontalAlignmentType.Left*/;break;}rowAggregators[index]=[newAggregatorItem];rowChildren[index]=[childItem];visualParent=newAggregatorItem;}break;default:throw"Children placement is undefined!";}}function getMatrixItem(items,x,y,width){var result,isOdd=width%2>0,index;if(isOdd){if(x===width-1){x=items.length;}else if(x===width){x=width-1;}}index=y*width+x;result=index>items.length-1?null:items[index];return result;}function hasRegularLeavesOnly(orgTree,treeItem){var hasChildren=false,hasLeavesOnly=true;orgTree.loopChildren(this,treeItem.id,function(nodeid,node,index){hasChildren=true;if(node.itemType===0/*primitives.orgdiagram.ItemType.Regular*/&&orgTree.hasChildren(nodeid)){hasLeavesOnly=false;return true;// break
	}});return hasChildren&&hasLeavesOnly;}/* Sibling is the first item which does not belongs to items logical hierarchy */function findLeftSiblingIndex(visualTree,navigationFamily,treeItem){var result=null,ignore={},visualParent=visualTree.parent(treeItem.id);visualTree.loopChildrenReversed(this,visualParent.id,function(childItemId,childItem,index){if(result===null){if(childItemId==treeItem.id){result=-1;ignore[treeItem.id]=true;navigationFamily.loopChildren(this,treeItem.id,function(childid,child,level){if(level>0){return navigationFamily.BREAK;}ignore[childid]=true;});}}else{if(!ignore.hasOwnProperty(childItemId)){result=index;return true;//ignore jslint
	}else{navigationFamily.loopChildren(this,childItem.id,function(childid,child,level){if(level>0){return navigationFamily.BREAK;}ignore[childid]=true;});}}});return result;}/* Sibling is the first item which does not belongs to items logical hierarchy */function findRightSiblingIndex(visualTree,navigationFamily,treeItem){var result=null,ignore={},visualParent=visualTree.parent(treeItem.id);visualTree.loopChildren(this,visualParent.id,function(childItemId,childItem,index,lastIndex){if(result===null){if(childItemId==treeItem.id){result=lastIndex+1;ignore[treeItem.id]=true;navigationFamily.loopChildren(this,treeItem.id,function(childid,child,level){if(level>0){return navigationFamily.BREAK;}ignore[childid]=true;});}}else{if(!ignore.hasOwnProperty(childItemId)){result=index;return true;//ignore jslint
	}else{navigationFamily.loopChildren(this,childItemId,function(childid,child,level){if(level>0){return navigationFamily.BREAK;}ignore[childid]=true;});}}});return result;}function createNewVisualAggregator(visualTree,treeItem,hideChildrenConnector){var newAggregatorItem,hideParentConnector=treeItem.visibility==4/*primitives.common.Visibility.Invisible*/&&treeItem.connectorPlacement===0||hideChildrenConnector;newAggregatorItem=getNewTreeItem({visibility:4/*primitives.common.Visibility.Invisible*/,visualAggregatorId:treeItem.visualAggregatorId,connectorPlacement:hideParentConnector?0:1/*primitives.common.SideFlag.Top*/|4/*primitives.common.SideFlag.Bottom*/});visualTree.insert(treeItem.id,newAggregatorItem.id,newAggregatorItem);treeItem.visualAggregatorId=newAggregatorItem.id;return newAggregatorItem;}function getNewTreeItem(properties,orgItem){var result=new primitives.orgdiagram.TreeItem(),optionKey;for(optionKey in properties){if(properties.hasOwnProperty(optionKey)){result[optionKey]=properties[optionKey];}}if(orgItem!=null){result.id=orgItem.id;result.visibility=orgItem.isVisible?0/*primitives.common.Visibility.Auto*/:4/*primitives.common.Visibility.Invisible*/;}else{_treeItemCounter+=1;result.id=_treeItemCounter;}return result;}function defineNavigationParent(parentItem,treeItem,skipFirstParent){var parents=[];/* take logicalParentItem when it is visible or collect all visible immidiate parents of logicalParentItem */if(skipFirstParent||parentItem.visibility==4/*primitives.common.Visibility.Invisible*/||!itemTemplateParamsTask.getTemplateParams(parentItem.id).isActive){_data.navigationFamily.loopParents(this,parentItem.id,function(parentid,parent,level){if(parent.visibility!=4/*primitives.common.Visibility.Invisible*/&&itemTemplateParamsTask.getTemplateParams(parentid).isActive){parents.push(parentid);return _data.navigationFamily.SKIP;}});}else{parents.push(parentItem.id);}if(_data.navigationFamily.node(treeItem.id)!=null){_data.navigationFamily.adopt(parents,treeItem.id);}else{_data.navigationFamily.add(parents,treeItem.id,treeItem);}}function getVisualTree(){return _data.visualTree;}function getNavigationFamily(){return _data.navigationFamily;}function getConnectionsFamily(){return _data.connectionsFamily;}return{process:process,getVisualTree:getVisualTree,getNavigationFamily:getNavigationFamily,getConnectionsFamily:getConnectionsFamily};};/* /Controls/OrgDiagram/Templates/AnnotationLabelTemplate.js*//* jshint latedef: true, unused: false */primitives.common.AnnotationLabelTemplate=function(){var _template=create(),_hashCode=primitives.common.hashCode(_template);function create(){var template=jQuery('<div></div>');template.addClass("bp-item bp-corner-all bp-connector-label");return template.wrap('<div>').parent().html();}function template(){return _template;}function getHashCode(){return _hashCode;}function render(event,data){var annotationConfig=data.context;data.element.html(annotationConfig.label);}return{template:template,getHashCode:getHashCode,render:render};};/* /Controls/OrgDiagram/Templates/ButtonsTemplate.js*/primitives.common.ButtonsTemplate=function(options){var _template=create(),_hashCode=primitives.common.hashCode(_template);function create(){var template=jQuery("<ul></ul>");template.css({position:"absolute"}).addClass("ui-widget ui-helper-clearfix");return template.wrap('<div>').parent().html();}function template(){return _template;}function getHashCode(){return _hashCode;}function render(event,data){var name="orgdiagram",topOffset=0,buttonsInterval=10,buttonConfig,buttons=data.buttons,button,index;switch(data.renderingMode){case 0/*primitives.common.RenderingMode.Create*/:for(index=0;index<buttons.length;index+=1){buttonConfig=buttons[index];button=jQuery('<li data-buttonname="'+buttonConfig.name+'"></li>').css({position:"absolute",top:topOffset+"px",left:"0px",width:buttonConfig.size.width+"px",height:buttonConfig.size.height+"px",padding:"3px"}).addClass(name+"button");data.element.append(button);button.button({icons:{primary:buttonConfig.icon},text:buttonConfig.text,label:buttonConfig.label});if(!primitives.common.isNullOrEmpty(buttonConfig.tooltip)){if(button.tooltip!=null){button.tooltip({content:buttonConfig.tooltip});}}topOffset+=buttonsInterval+buttonConfig.size.height;}break;case 1/*primitives.common.RenderingMode.Update*/:break;}}return{template:template,getHashCode:getHashCode,render:render};};/* /Controls/OrgDiagram/Templates/CheckBoxTemplate.js*/primitives.common.CheckBoxTemplate=function(selectCheckBoxLabel){var _template=create(),_hashCode=primitives.common.hashCode(_template);function create(){var template=jQuery('<div></div>');template.addClass("bp-item bp-selectioncheckbox-frame");template.append(jQuery('<label><nobr><input type="checkbox" name="checkbox" class="bp-selectioncheckbox" />&nbsp;<span name="selectiontext" class="bp-selectiontext">'+selectCheckBoxLabel+'</span></nobr></label>'));return template.wrap('<div>').parent().html();}function template(){return _template;}function getHashCode(){return _hashCode;}function render(event,data){var checkBox=data.element.find("[name=checkbox]");checkBox.prop("checked",data.isSelected);}return{template:template,getHashCode:getHashCode,render:render};};/* /Controls/OrgDiagram/Templates/CursorTemplate.js*/primitives.common.CursorTemplate=function(options,itemTemplateConfig){var _template=create(itemTemplateConfig),_hashCode=primitives.common.hashCode(_template);function create(config){var cursorTemplate=jQuery("<div></div>").css({width:config.itemSize.width+config.cursorPadding.left+config.cursorPadding.right+"px",height:config.itemSize.height+config.cursorPadding.top+config.cursorPadding.bottom+"px","border-width":config.cursorBorderWidth+"px"}).addClass("bp-item bp-corner-all bp-cursor-frame");return cursorTemplate.wrap('<div>').parent().html();}function template(){return _template;}function getHashCode(){return _hashCode;}function render(event,data){}return{template:template,getHashCode:getHashCode,render:render};};/* /Controls/OrgDiagram/Templates/DotHighlightTemplate.js*/primitives.common.DotHighlightTemplate=function(options,itemTemplateConfig){var _template=create(itemTemplateConfig),_hashCode=primitives.common.hashCode(_template);function create(config){var radius=config.minimizedItemCornerRadius+config.highlightPadding.left,highlightTemplate=jQuery("<div></div>").css({"border-width":config.highlightBorderWidth+"px","-moz-border-radius":radius,"-webkit-border-radius":radius,"-khtml-border-radius":radius,"border-radius":radius}).addClass("bp-item bp-highlight-dot-frame");return highlightTemplate.wrap('<div>').parent().html();}function template(){return _template;}function getHashCode(){return _hashCode;}function render(event,data){}return{template:template,getHashCode:getHashCode,render:render};};/* /Controls/OrgDiagram/Templates/GroupTitleTemplate.js*/primitives.common.GroupTitleTemplate=function(options){var _template=create(),_hashCode=primitives.common.hashCode(_template);function create(){var template=jQuery('<div></div>');template.addClass("bp-item bp-corner-all bp-grouptitle-frame");return template.wrap('<div>').parent().html();}function template(){return _template;}function getHashCode(){return _hashCode;}function render(event,data){var config=new primitives.text.Config(),itemConfig=data.context,groupTitleColor=itemConfig.groupTitleColor||options.groupTitleColor;config.orientation=options.groupTitleOrientation;config.verticalAlignment=options.groupTitleVerticalAlignment;config.horizontalAlignment=options.groupTitleHorizontalAlignment;config.text=itemConfig.groupTitle;config.fontSize=options.groupTitleFontSize;config.color=primitives.common.highestContrast(groupTitleColor,options.itemTitleSecondFontColor,options.itemTitleFirstFontColor);config.fontFamily=options.groupTitleFontFamily;config.fontWeight=options.groupTitleFontWeight;config.fontStyle=options.groupTitleFontStyle;switch(data.renderingMode){case 0/*primitives.common.RenderingMode.Create*/:data.element.bpText(config);break;case 1/*primitives.common.RenderingMode.Update*/:data.element.bpText("option",config);data.element.bpText("update");break;}primitives.common.css(data.element,{"background":groupTitleColor});}return{template:template,getHashCode:getHashCode,render:render};};/* /Controls/OrgDiagram/Templates/HighlightTemplate.js*/primitives.common.HighlightTemplate=function(options,itemTemplateConfig){var _template=create(itemTemplateConfig),_hashCode=primitives.common.hashCode(template);function create(config){var highlightTemplate=jQuery("<div></div>").css({"border-width":config.highlightBorderWidth+"px"}).addClass("bp-item bp-corner-all bp-highlight-frame");return highlightTemplate.wrap('<div>').parent().html();}function template(){return _template;}function getHashCode(){return _hashCode;}function render(event,data){}return{template:template,getHashCode:getHashCode,render:render};};/* /Controls/OrgDiagram/Templates/ItemTemplate.js*/primitives.common.ItemTemplate=function(options,itemTemplateConfig){var _template=create(itemTemplateConfig),_hashCode=primitives.common.hashCode(template);function create(config){var contentSize=new primitives.common.Size(config.itemSize),itemTemplate,titleBackground,title,photoborder,photo,description;contentSize.width-=config.itemBorderWidth*2;contentSize.height-=config.itemBorderWidth*2;itemTemplate=jQuery('<div></div>').css({"border-width":config.itemBorderWidth+"px"}).addClass("bp-item bp-corner-all bt-item-frame");titleBackground=jQuery('<div name="titleBackground"></div>').css({top:"2px",left:"2px",width:contentSize.width-4+"px",height:"18px"}).addClass("bp-item bp-corner-all bp-title-frame");itemTemplate.append(titleBackground);title=jQuery('<div name="title"></div>').css({top:"1px",left:"4px",width:contentSize.width-4-4*2+"px",height:"16px"}).addClass("bp-item bp-title");titleBackground.append(title);photoborder=jQuery("<div></div>").css({top:"24px",left:"2px",width:"50px",height:"60px"}).addClass("bp-item bp-photo-frame");itemTemplate.append(photoborder);photo=jQuery('<img name="photo" alt=""></img>').css({width:"50px",height:"60px"});photoborder.append(photo);description=jQuery('<div name="description"></div>').css({top:"24px",left:"56px",width:contentSize.width-4-56+"px",height:"74px"}).addClass("bp-item bp-description");itemTemplate.append(description);return itemTemplate.wrap('<div>').parent().html();}function template(){return _template;}function getHashCode(){return _hashCode;}function render(event,data){var itemConfig=data.context,itemTitleColor=itemConfig.itemTitleColor!=null?itemConfig.itemTitleColor:"#4169e1"/*primitives.common.Colors.RoyalBlue*/,color=primitives.common.highestContrast(itemTitleColor,options.itemTitleSecondFontColor,options.itemTitleFirstFontColor);data.element.find("[name=titleBackground]").css({"background":itemTitleColor});data.element.find("[name=photo]").attr({"src":itemConfig.image,"alt":itemConfig.title});data.element.find("[name=title]").css({"color":color}).text(itemConfig.title);data.element.find("[name=description]").text(itemConfig.description);}return{template:template,getHashCode:getHashCode,render:render};};/* /Controls/OrgDiagram/Templates/PrintPreviewTemplate.js*/primitives.common.PrintPreviewTemplate=function(options){var _template=create(),_hashCode=primitives.common.hashCode(template);function create(){var template=jQuery('<div></div>');template.addClass("bp-item bp-printpreview");return template.wrap('<div>').parent().html();}function template(){return _template;}function getHashCode(){return _hashCode;}function render(event,data){}return{template:template,getHashCode:getHashCode,render:render};};/* /Controls/OrgDiagram/Templates/UserTemplate.js*/primitives.common.UserTemplate=function(options,content,onRender){var _hashCode=primitives.common.hashCode(content);function template(){return content;}function getHashCode(){return _hashCode;}function render(event,data){if(onRender!=null){onRender(event,data);}else{var itemConfig=data.context,itemTitleColor=itemConfig.itemTitleColor!=null?itemConfig.itemTitleColor:"#4169e1"/*primitives.common.Colors.RoyalBlue*/,color=primitives.common.highestContrast(itemTitleColor,options.itemTitleSecondFontColor,options.itemTitleFirstFontColor);data.element.find("[name=titleBackground]").css({"background":itemTitleColor});data.element.find("[name=photo]").attr({"src":itemConfig.image,"alt":itemConfig.title});data.element.find("[name=title]").css({"color":color}).text(itemConfig.title);data.element.find("[name=description]").text(itemConfig.description);}}return{template:template,getHashCode:getHashCode,render:render};};/* /Controls/OrgDiagram/BaseControl.js*/primitives.orgdiagram.BaseControl=function(element,options,taskManagerFactory,eventArgsFactory){var _data={name:"orgdiagram",options:options,tasks:null,graphics:null,mouse:null,layout:{element:element,scrollPanel:null,mousePanel:null,placeholder:null,calloutPlaceholder:null,forceCenterOnCursor:true}},_dragStartPosition,_cancelMouseClick,_scale,_debug=false;function update(updateMode){switch(updateMode){case 1/*primitives.common.UpdateMode.Refresh*/:refresh(true,_debug);break;case 2/*primitives.common.UpdateMode.PositonHighlight*/:positionHighlight(_debug);break;default:redraw();break;}}function destroy(){unbind(_data.layout);cleanLayout(_data.layout,_data.name);_data.tasks=null;_data.graphics=null;}function redraw(){destroyMouse();unbind(_data.layout);cleanLayout(_data.layout,_data.name);createLayout(_data.layout,_data.name);createMouse();bind(_data.layout);_data.tasks=taskManagerFactory(getOptions,getGraphics,getLayout);_data.graphics=primitives.common.createGraphics(_data.options.graphicsType,_data.layout.element);_data.graphics.debug=_debug;refresh(true,_debug);}function refresh(forceCenterOnCursor,debug){var centerOnCursorTask,placeholderOffset;//_data.layout.scrollPanel.css({
	//	"display": "none",
	//	"-webkit-overflow-scrolling": "auto"
	//});
	//this.graphics.begin();
	_data.layout.forceCenterOnCursor=forceCenterOnCursor;_data.tasks.process('OptionsTask',null,debug);_data.graphics.end();//_data.layout.scrollPanel.css({
	//	"display": "block"
	//});
	if(forceCenterOnCursor){/* scroll to offset */centerOnCursorTask=_data.tasks.getTask("CenterOnCursorTask");placeholderOffset=centerOnCursorTask.getPlaceholderOffset();_data.layout.scrollPanel.scrollLeft(placeholderOffset.x);_data.layout.scrollPanel.scrollTop(placeholderOffset.y);}//_data.layout.scrollPanel.css({
	//	"-webkit-overflow-scrolling": "touch"
	//});
	}function positionHighlight(debug){_data.layout.forceCenterOnCursor=false;_data.tasks.process('HighlightItemOptionTask',null,debug);_data.graphics.end();}function setOptions(options){for(var option in options){if(options.hasOwnProperty(option)){_data.options[option]=options[option];}}}function getOptions(){return _data.options;}function getOption(option){return _data.options[option];}function setOption(option,value){return _data.options[option]=value;}function getGraphics(){return _data.graphics;}function getLayout(){return _data.layout;}function createLayout(layout,name){var scrollPanelRect=new primitives.common.Rect(0,0,layout.element.outerWidth(),layout.element.outerHeight()),placeholderRect=new primitives.common.Rect(scrollPanelRect),position=layout.element.offset(),scrollPanel,mousePanel,placeholder,calloutPlaceholder;/* root scroll panel */scrollPanel=jQuery('<div tabindex="0"></div>');scrollPanel.css({"position":"relative","overflow":"auto","-webkit-overflow-scrolling":"touch","top":"0px","left":"0px","width":scrollPanelRect.width+"px","height":scrollPanelRect.height+"px","padding":"0px","margin-bottom":"0px","margin-right":"0px","margin-top":-position.top+Math.floor(position.top)+"px",/* fixes div pixel alignment */"margin-left":-position.left+Math.floor(position.left)+"px"});scrollPanel.addClass(name);/* mouse tracking events panel */mousePanel=jQuery('<div></div>');mousePanel.css({position:"absolute",overflow:"hidden",top:"0px",left:"0px"});mousePanel.addClass(name);mousePanel.css(placeholderRect.getCSS());/* contents scalable panel */placeholder=jQuery('<div></div>');placeholder.css({position:"absolute",overflow:"hidden",top:"0px",left:"0px"});placeholder.addClass("placeholder");placeholder.addClass(name);placeholder.css(placeholderRect.getCSS());/* callout panel */calloutPlaceholder=jQuery('<div></div>');calloutPlaceholder.css({position:"absolute",overflow:"visible"});calloutPlaceholder.addClass("calloutplaceholder");calloutPlaceholder.addClass(name);calloutPlaceholder.css({top:"0px",left:"0px",width:"0px",height:"0px"});/* append panels */scrollPanel.append(mousePanel);mousePanel.append(placeholder);placeholder.append(calloutPlaceholder);layout.element.append(scrollPanel);/* save references */layout.scrollPanel=scrollPanel;layout.mousePanel=mousePanel;layout.placeholder=placeholder;layout.calloutPlaceholder=calloutPlaceholder;}function cleanLayout(layout,name){layout.element.find("."+name).remove();}function createMouse(){if(_data.options.enablePanning){_data.mouse=new primitives.common.Mouse();_data.mouse.init(_data.layout.mousePanel,{name:_data.name,onMouseDrag:mouseDrag,onMouseStop:mouseStop,onMouseCapture:mouseCapture});}}function destroyMouse(){if(_data.mouse!=null){_data.mouse.destroy();}}function bind(layout){layout.mousePanel.mousemove(function(e){onMouseMove(e);}).click(function(e){onMouseClick(e);}).dblclick(function(e){onMouseDblClick(e);});layout.scrollPanel.keydown(function(e){onKeyDown(e);});}function unbind(layout){if(layout.mousePanel!=null){layout.mousePanel.unbind("mousemove");layout.mousePanel.unbind("click");layout.mousePanel.unbind("dblclick");}if(layout.scrollPanel!=null){layout.scrollPanel.unbind("keydown");}}function onMouseMove(event){var placeholderOffset=_data.layout.mousePanel.offset(),x=event.pageX-placeholderOffset.left,y=event.pageY-placeholderOffset.top,createTransformTask=_data.tasks.getTask("CreateTransformTask"),highlightItemOptionTask=_data.tasks.getTask("HighlightItemOptionTask"),itemId;if(!_data.mouse||!_data.mouse.isStarted()){_cancelMouseClick=false;if(highlightItemOptionTask.hasHighlightEnabled()){itemId=createTransformTask.getTreeItemForMousePosition(x,y,highlightItemOptionTask.getGravityRadius());setHighlightItem(event,itemId);}}}function onMouseClick(event){if(!_data.mouse||!_data.mouse.isStarted()){var placeholderOffset=_data.layout.mousePanel.offset(),x=event.pageX-placeholderOffset.left,y=event.pageY-placeholderOffset.top,createTransformTask=_data.tasks.getTask("CreateTransformTask"),cursorItemOptionTask=_data.tasks.getTask("CursorItemOptionTask"),highlightItemOptionTask=_data.tasks.getTask("HighlightItemOptionTask"),item,newCursorItemId=createTransformTask.getTreeItemForMousePosition(x,y,highlightItemOptionTask.getGravityRadius()),target,button,buttonname,eventArgs,position,selectedItems;if(newCursorItemId!==null){if(!_cancelMouseClick){target=jQuery(event.target);if(target.hasClass(_data.name+"button")||target.parent("."+_data.name+"button").length>0){button=target.hasClass(_data.name+"button")?target:target.parent("."+_data.name+"button");buttonname=button.data("buttonname");eventArgs=getEventArgs(null,newCursorItemId,buttonname);trigger("onButtonClick",event,eventArgs);}else if(target.attr("name")==="selectiontext"){}else if(target.attr("name")==="checkbox"){//ignore jslint
	selectedItems=(_data.options.selectedItems||[]).slice(0);eventArgs=getEventArgs(null,newCursorItemId,buttonname);trigger("onSelectionChanging",event,eventArgs);position=primitives.common.indexOf(selectedItems,newCursorItemId);if(position>=0){selectedItems.splice(position,1);}else{selectedItems.push(newCursorItemId);}_data.options.selectedItems=selectedItems;trigger("onSelectionChanged",event,eventArgs);}else{eventArgs=getEventArgs(null,newCursorItemId);trigger("onMouseClick",event,eventArgs);if(!eventArgs.cancel){if(cursorItemOptionTask.hasCursorEnabled()){setCursorItem(event,newCursorItemId);_data.layout.scrollPanel.focus();}}}}}}_cancelMouseClick=false;}function onMouseDblClick(event){var eventArgs,highlightItemTask=_data.tasks.getTask("HighlightItemTask"),highlightTreeItem=highlightItemTask.getHighlightTreeItem();if(highlightTreeItem!==null){if(!_cancelMouseClick){eventArgs=getEventArgs(null,highlightTreeItem);trigger("onMouseDblClick",event,eventArgs);}}_cancelMouseClick=false;}function onKeyDown(event){var highlightItemTask=_data.tasks.getTask("HighlightItemTask"),highlightItemOptionTask=_data.tasks.getTask("HighlightItemOptionTask"),cursorItemTask=_data.tasks.getTask("CursorItemTask"),cursorItemOptionTask=_data.tasks.getTask("CursorItemOptionTask"),alignDiagramTask=_data.tasks.getTask('AlignDiagramTask'),createTransformTask=_data.tasks.getTask('CreateTransformTask'),transform=createTransformTask.getTransform(),navigationItem=null,newNavigationItem,direction=null,accepted,layout=_data.layout;if(highlightItemOptionTask.hasHighlightEnabled()&&cursorItemOptionTask.hasCursorEnabled()){navigationItem=highlightItemTask.getHighlightTreeItem();if(navigationItem===null){navigationItem=cursorItemTask.getCursorTreeItem();}}else if(highlightItemOptionTask.hasHighlightEnabled()){navigationItem=highlightItemTask.getHighlightTreeItem();}else if(cursorItemOptionTask.hasCursorEnabled()){navigationItem=cursorItemTask.getCursorTreeItem();}if(navigationItem!=null){switch(event.which){case 13:/*Enter*/if(cursorItemOptionTask.hasCursorEnabled()){setCursorItem(event,navigationItem);event.preventDefault();layout.scrollPanel.focus();}break;case 40:/*Down*/direction=1/*primitives.common.OrientationType.Bottom*/;break;case 38:/*Up*/direction=0/*primitives.common.OrientationType.Top*/;break;case 37:/*Left*/direction=2/*primitives.common.OrientationType.Left*/;break;case 39:/*Right*/direction=3/*primitives.common.OrientationType.Right*/;break;}if(direction!=null){accepted=false;while(!accepted){accepted=true;direction=transform.getOrientation(direction);switch(direction){case 0/*primitives.common.OrientationType.Top*/:newNavigationItem=alignDiagramTask.getNextLevelTreeItem(navigationItem,false);break;case 1/*primitives.common.OrientationType.Bottom*/:newNavigationItem=alignDiagramTask.getNextLevelTreeItem(navigationItem,true);break;case 2/*primitives.common.OrientationType.Left*/:newNavigationItem=alignDiagramTask.getNextTreeItem(navigationItem,true);break;case 3/*primitives.common.OrientationType.Right*/:newNavigationItem=alignDiagramTask.getNextTreeItem(navigationItem,false);break;}if(newNavigationItem!=null){event.preventDefault();if(highlightItemOptionTask.hasHighlightEnabled()){setHighlightItem(event,newNavigationItem);}else if(cursorItemOptionTask.hasCursorEnabled()){setCursorItem(event,newNavigationItem);}}}layout.scrollPanel.focus();}}}function onGestureStart(e){var scaleOptionTask=_data.taks.getTask("ScaleOptionTask"),options=scaleOptionTask.getOptions();_scale=options.scale;e.preventDefault();}function onGestureChange(e){var scale=Math.round(_scale*e.scale*10.0)/10.0,scaleOptionTask=_data.taks.getTask("ScaleOptionTask"),options=scaleOptionTask.getOptions();if(scale>options.maximumScale){scale=options.maximumScale;}else if(scale<options.minimumScale){scale=options.minimumScale;}_data.options.scale=scale;refresh(false,false);e.preventDefault();}function mouseDrag(event){var position=new primitives.common.Point(event.pageX,event.pageY),left=-position.x+_dragStartPosition.x,top=-position.y+_dragStartPosition.y,scrollPanel=_data.layout.scrollPanel;scrollPanel.css('visibility','hidden');scrollPanel.scrollLeft(left).scrollTop(top);scrollPanel.css('visibility','inherit');return false;}function mouseStop(event){//ignore jslint
	_cancelMouseClick=true;}function mouseCapture(event){var scrollPanel=_data.layout.scrollPanel;_dragStartPosition=new primitives.common.Point(scrollPanel.scrollLeft()+event.pageX,scrollPanel.scrollTop()+event.pageY);return true;}function setHighlightItem(event,newHighlightItemId){var result=true,eventArgs;if(newHighlightItemId!==null){if(newHighlightItemId!==_data.options.highlightItem){eventArgs=getEventArgs(_data.options.highlightItem,newHighlightItemId);_data.options.highlightItem=newHighlightItemId;trigger("onHighlightChanging",event,eventArgs);if(!eventArgs.cancel){refresh(false,false);trigger("onHighlightChanged",event,eventArgs);}else{result=false;}}}else{if(_data.options.highlightItem!==null){eventArgs=getEventArgs(_data.options.highlightItem,null);_data.options.highlightItem=null;trigger("onHighlightChanging",event,eventArgs);if(!eventArgs.cancel){refresh(false,false);trigger("onHighlightChanged",event,eventArgs);}else{result=false;}}}return result;}function setCursorItem(event,newCursorItemId){var eventArgs;if(newCursorItemId!==_data.options.cursorItem){eventArgs=getEventArgs(_data.options.cursorItem,newCursorItemId);_data.options.cursorItem=newCursorItemId;trigger("onCursorChanging",event,eventArgs);if(!eventArgs.cancel){refresh(true,_debug);trigger("onCursorChanged",event,eventArgs);}}}function getEventArgs(oldTreeItemId,newTreeItemId,name){return eventArgsFactory(_data,oldTreeItemId,newTreeItemId,name);}function trigger(eventHandlerName,event,eventArgs){var eventHandler=_data.options[eventHandlerName];if(eventHandler!=null){eventHandler(event,eventArgs);}}function getProcessDiagramConfig(){var tasks=taskManagerFactory(getOptions,getGraphics,getLayout);return tasks.getProcessDiagramConfig();}update();/* init control on create */return{destroy:destroy,setOptions:setOptions,getOptions:getOptions,setOption:setOption,getOption:getOption,update:update,getProcessDiagramConfig:getProcessDiagramConfig};};/* /Controls/OrgDiagram/Control.js*/primitives.orgdiagram.Control=function(element,options){function createTaskManager(getOptions,getGraphics,getLayout){var tasks=new primitives.common.TaskManager();// Dependencies
	tasks.addDependency('options',getOptions);tasks.addDependency('graphics',getGraphics);tasks.addDependency('layout',getLayout);tasks.addDependency('defaultConfig',new primitives.orgdiagram.Config());tasks.addDependency('defaultItemConfig',new primitives.orgdiagram.ItemConfig());tasks.addDependency('defaultTemplateConfig',new primitives.orgdiagram.TemplateConfig());tasks.addDependency('defaultButtonConfig',new primitives.orgdiagram.ButtonConfig());tasks.addDependency('defaultBackgroundAnnotationConfig',new primitives.orgdiagram.BackgroundAnnotationConfig());tasks.addDependency('defaultConnectorAnnotationConfig',new primitives.orgdiagram.ConnectorAnnotationConfig());tasks.addDependency('defaultHighlightPathAnnotationConfig',new primitives.orgdiagram.HighlightPathAnnotationConfig());tasks.addDependency('defaultShapeAnnotationConfig',new primitives.orgdiagram.ShapeAnnotationConfig());tasks.addDependency('isFamilyChartMode',false);tasks.addDependency('showElbowDots',false);tasks.addDependency('null',null);tasks.addDependency('foreground',2/*primitives.common.ZOrderType.Foreground*/);tasks.addDependency('background',1/*primitives.common.ZOrderType.Background*/);// Options
	tasks.addTask('OptionsTask',['options'],primitives.orgdiagram.OptionsTask,"#000000"/*primitives.common.Colors.Black*/);// Layout
	tasks.addTask('CurrentControlSizeTask',['layout','OptionsTask','ItemsSizesOptionTask'],primitives.orgdiagram.CurrentControlSizeTask,"#000000"/*primitives.common.Colors.Black*/);tasks.addTask('CurrentScrollPositionTask',['layout','OptionsTask'],primitives.orgdiagram.CurrentScrollPositionTask,"#000000"/*primitives.common.Colors.Black*/);tasks.addTask('CalloutOptionTask',['OptionsTask','defaultConfig','defaultItemConfig'],primitives.orgdiagram.CalloutOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ConnectorsOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.ConnectorsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ItemsOptionTask',['OptionsTask','defaultItemConfig'],primitives.orgdiagram.ItemsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ItemsSizesOptionTask',['OptionsTask','defaultConfig','defaultItemConfig','defaultButtonConfig'],primitives.orgdiagram.ItemsSizesOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('LabelsOptionTask',['OptionsTask','defaultConfig','defaultItemConfig'],primitives.orgdiagram.LabelsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('PrintPreviewOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.PrintPreviewOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('TemplatesOptionTask',['OptionsTask','defaultConfig','defaultButtonConfig','defaultTemplateConfig'],primitives.orgdiagram.TemplatesOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('OrientationOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.OrientationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('VisualTreeOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.VisualTreeOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('MinimizedItemsOptionTask',['OptionsTask'],primitives.orgdiagram.MinimizedItemsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('CursorItemOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.CursorItemOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('HighlightItemOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.HighlightItemOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('SelectedItemsOptionTask',['OptionsTask'],primitives.orgdiagram.SelectedItemsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('CursorSelectionPathModeOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.CursorSelectionPathModeOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('SplitAnnotationsOptionTask',['OptionsTask'],primitives.orgdiagram.SplitAnnotationsOptionTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ForegroundShapeAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultShapeAnnotationConfig','foreground'],primitives.orgdiagram.ShapeAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundShapeAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultShapeAnnotationConfig','background'],primitives.orgdiagram.ShapeAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ForegroundHighlightPathAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultHighlightPathAnnotationConfig','foreground'],primitives.orgdiagram.HighlightPathAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundHighlightPathAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultHighlightPathAnnotationConfig','background'],primitives.orgdiagram.HighlightPathAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ForegroundConnectorAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultConnectorAnnotationConfig','foreground'],primitives.orgdiagram.ConnectorAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundConnectorAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultConnectorAnnotationConfig','background'],primitives.orgdiagram.ConnectorAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultBackgroundAnnotationConfig'],primitives.orgdiagram.BackgroundAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ScaleOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.ScaleOptionTask,"#000080"/*primitives.common.Colors.Navy*/);// Transformations
	tasks.addTask('CombinedContextsTask',['ItemsOptionTask'],primitives.orgdiagram.CombinedContextsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('IntervalsTask',['ItemsSizesOptionTask'],primitives.orgdiagram.IntervalsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('OrgTreeTask',['ItemsOptionTask'],primitives.orgdiagram.OrgTreeTask,"#ff0000"/*primitives.common.Colors.Red*/);// Transformations / Templates
	tasks.addTask('ReadTemplatesTask',['TemplatesOptionTask'],primitives.orgdiagram.ReadTemplatesTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ItemTemplateParamsTask',['ItemsSizesOptionTask','CursorItemOptionTask','ReadTemplatesTask'],primitives.orgdiagram.ItemTemplateParamsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('GroupTitleTemplateTask',['TemplatesOptionTask'],primitives.orgdiagram.GroupTitleTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CheckBoxTemplateTask',['ItemsSizesOptionTask'],primitives.orgdiagram.CheckBoxTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ButtonsTemplateTask',['ItemsSizesOptionTask'],primitives.orgdiagram.ButtonsTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('AnnotationLabelTemplateTask',['ItemsOptionTask'],primitives.orgdiagram.AnnotationLabelTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('PrintPreviewTemplateTask',['ItemsOptionTask'],primitives.orgdiagram.PrintPreviewTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('VisualTreeTask',['OrgTreeTask','ItemTemplateParamsTask','VisualTreeOptionTask','isFamilyChartMode'],primitives.orgdiagram.VisualTreeTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('VisualTreeLevelsTask',['VisualTreeTask','ItemTemplateParamsTask'],primitives.orgdiagram.VisualTreeLevelsTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('VisualTreeMarginsTask',['VisualTreeTask'],primitives.orgdiagram.VisualTreeMarginsTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('ConnectionsGraphTask',['graphics','CreateTransformTask','ConnectorsOptionTask','VisualTreeLevelsTask','AlignDiagramTask'],primitives.orgdiagram.ConnectionsGraphTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Transformations/Selections
	tasks.addTask('HighlightItemTask',['HighlightItemOptionTask','VisualTreeLevelsTask'],primitives.orgdiagram.HighlightItemTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CursorItemTask',['CursorItemOptionTask','VisualTreeLevelsTask'],primitives.orgdiagram.CursorItemTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CursorNeighboursTask',['CursorItemTask','VisualTreeTask'],primitives.orgdiagram.CursorNeighboursTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('SelectedItemsTask',['SelectedItemsOptionTask'],primitives.orgdiagram.SelectedItemsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('SelectionPathItemsTask',['VisualTreeTask','CursorItemTask','SelectedItemsTask','CursorSelectionPathModeOptionTask'],primitives.orgdiagram.SelectionPathItemsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByForegroundShapeAnnotationTask',['ForegroundShapeAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByBackgroundShapeAnnotationTask',['BackgroundShapeAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByBackgroundAnnotationTask',['BackgroundAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByForegroundHighlightPathAnnotationTask',['ForegroundHighlightPathAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByBackgroundHighlightPathAnnotationTask',['BackgroundHighlightPathAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByForegroundConnectorAnnotationTask',['ForegroundConnectorAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByConnectorAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('NormalVisibilityItemsByBackgroundConnectorAnnotationTask',['BackgroundConnectorAnnotationOptionTask'],primitives.orgdiagram.NormalVisibilityItemsByConnectorAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CombinedNormalVisibilityItemsTask',['ItemsSizesOptionTask','CursorItemTask','CursorNeighboursTask','SelectedItemsTask','SelectionPathItemsTask','NormalVisibilityItemsByForegroundShapeAnnotationTask','NormalVisibilityItemsByBackgroundShapeAnnotationTask','NormalVisibilityItemsByBackgroundAnnotationTask','NormalVisibilityItemsByForegroundHighlightPathAnnotationTask','NormalVisibilityItemsByBackgroundHighlightPathAnnotationTask','NormalVisibilityItemsByForegroundConnectorAnnotationTask','NormalVisibilityItemsByBackgroundConnectorAnnotationTask'],primitives.orgdiagram.CombinedNormalVisibilityItemsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ItemsPositionsTask',['CurrentControlSizeTask','ScaleOptionTask','OrientationOptionTask','ItemsSizesOptionTask','ConnectorsOptionTask','VisualTreeOptionTask','IntervalsTask','VisualTreeTask','VisualTreeLevelsTask','VisualTreeMarginsTask','ItemTemplateParamsTask','CursorItemTask','CombinedNormalVisibilityItemsTask'],primitives.orgdiagram.ItemsPositionsTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('AlignDiagramTask',['OrientationOptionTask','ItemsSizesOptionTask','VisualTreeOptionTask','ScaleOptionTask','PrintPreviewOptionTask','CurrentControlSizeTask','VisualTreeLevelsTask','ItemsPositionsTask','isFamilyChartMode'],primitives.orgdiagram.AlignDiagramTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('CreateTransformTask',['OrientationOptionTask','AlignDiagramTask'],primitives.orgdiagram.CreateTransformTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CenterOnCursorTask',['layout','CurrentControlSizeTask','CurrentScrollPositionTask','CursorItemTask','AlignDiagramTask','CreateTransformTask','ScaleOptionTask'],primitives.orgdiagram.CenterOnCursorTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Managers
	tasks.addTask('BackgroundAnnotationManagerTask',['ItemsSizesOptionTask','VisualTreeLevelsTask','AlignDiagramTask'],primitives.orgdiagram.BackgroundAnnotationManagerTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('PaletteManagerTask',['ConnectorsOptionTask','null'],primitives.orgdiagram.PaletteManagerTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Apply Layout Changes
	tasks.addTask('ApplyLayoutChangesTask',['graphics','layout','ItemsSizesOptionTask','PrintPreviewOptionTask','CurrentControlSizeTask','ScaleOptionTask','AlignDiagramTask'],primitives.orgdiagram.ApplyLayoutChangesTask,"#008000"/*primitives.common.Colors.Green*/);// Renders
	tasks.addTask('DrawBackgroundAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','BackgroundAnnotationOptionTask','VisualTreeTask','AlignDiagramTask','BackgroundAnnotationManagerTask'],primitives.orgdiagram.DrawBackgroundAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawBackgroundHighlightPathAnnotationTask',['graphics','ConnectorsOptionTask','ForegroundHighlightPathAnnotationOptionTask','ConnectionsGraphTask','foreground'],primitives.orgdiagram.DrawHighlightPathAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('DrawForegroundHighlightPathAnnotationTask',['graphics','ConnectorsOptionTask','BackgroundHighlightPathAnnotationOptionTask','ConnectionsGraphTask','background'],primitives.orgdiagram.DrawHighlightPathAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('DrawForegroundConnectorAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','ForegroundConnectorAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','foreground'],primitives.orgdiagram.DrawConnectorAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawBackgroundConnectorAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','BackgroundConnectorAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','background'],primitives.orgdiagram.DrawConnectorAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawForegroundShapeAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','ForegroundShapeAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','foreground'],primitives.orgdiagram.DrawShapeAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawBackgroundShapeAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','BackgroundShapeAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','background'],primitives.orgdiagram.DrawShapeAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawCursorTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','CombinedContextsTask','AlignDiagramTask','ItemTemplateParamsTask','CursorItemTask','SelectedItemsTask'],primitives.orgdiagram.DrawCursorTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawHighlightTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','CombinedContextsTask','AlignDiagramTask','ItemTemplateParamsTask','HighlightItemTask','CursorItemTask','SelectedItemsTask'],primitives.orgdiagram.DrawHighlightTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawHighlightAnnotationTask',['layout','graphics','CreateTransformTask','ApplyLayoutChangesTask','ScaleOptionTask','CombinedContextsTask','CalloutOptionTask','ReadTemplatesTask','AlignDiagramTask','CenterOnCursorTask','HighlightItemTask','CursorItemTask','SelectedItemsTask'],primitives.orgdiagram.DrawHighlightAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawTreeItemsTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','ItemsSizesOptionTask','CombinedContextsTask','AlignDiagramTask','ItemTemplateParamsTask','CursorItemTask','SelectedItemsTask','GroupTitleTemplateTask','CheckBoxTemplateTask','ButtonsTemplateTask'],primitives.orgdiagram.DrawTreeItemsTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawMinimizedItemsTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','MinimizedItemsOptionTask','ItemTemplateParamsTask','AlignDiagramTask'],primitives.orgdiagram.DrawMinimizedItemsTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawConnectorsTask',['graphics','ConnectionsGraphTask','ConnectorsOptionTask','showElbowDots','PaletteManagerTask'],primitives.orgdiagram.DrawConnectorsTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawItemLabelsTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','LabelsOptionTask','VisualTreeLevelsTask','AlignDiagramTask'],primitives.orgdiagram.DrawItemLabelsTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawPrintPreviewTask',['graphics','ApplyLayoutChangesTask','PrintPreviewOptionTask','AlignDiagramTask','PrintPreviewTemplateTask','ScaleOptionTask'],primitives.orgdiagram.DrawPrintPreviewTask,"#008000"/*primitives.common.Colors.Green*/);return tasks;}function createEventArgs(data,oldTreeItemId,newTreeItemId,name){var result=new primitives.orgdiagram.EventArgs(),combinedContextsTask=data.tasks.getTask("CombinedContextsTask"),alignDiagramTask=data.tasks.getTask("AlignDiagramTask"),oldItemConfig=combinedContextsTask.getConfig(oldTreeItemId),newItemConfig=combinedContextsTask.getConfig(newTreeItemId),itemPosition,actualPosition,offset,panelOffset;if(oldItemConfig&&oldItemConfig.id!=null){result.oldContext=oldItemConfig;}if(newItemConfig&&newItemConfig.id!=null){result.context=newItemConfig;if(newItemConfig.parent!==null){result.parentItem=combinedContextsTask.getConfig(newItemConfig.parent);}panelOffset=data.layout.mousePanel.offset();offset=data.layout.element.offset();itemPosition=alignDiagramTask.getItemPosition(newTreeItemId),result.position=new primitives.common.Rect(itemPosition.actualPosition).translate(panelOffset.left,panelOffset.top).translate(-offset.left,-offset.top);}if(name!=null){result.name=name;}return result;}return primitives.orgdiagram.BaseControl(element,options,createTaskManager,createEventArgs);};/* /algorithms/Perimeter/PerimeterItem.js*/primitives.common.perimeter.Item=function(id,segments){var index,len,segment;this.id=id;this.segments=new primitives.common.LinkedHashItems();if(segments!=null){for(index=0,len=segments.length;index<len;index+=1){segment=segments[index];this.segments.add(segment.key,segment);}}};/* /algorithms/Perimeter/PerimeterManager.js*/primitives.common.perimeter.Manager=function(perimeterItems){var perimetersHash={},// hash of permiter items by id
	perimetersBySegmentKey={};// hash of permiter items by segment id
	function add(perimeterItems){var index,len,perimeterItem;for(index=0,len=perimeterItems.length;index<len;index+=1){perimeterItem=perimeterItems[index];perimetersHash[perimeterItem.id]=perimeterItem;perimeterItem.segments.iterate(function(item){perimetersBySegmentKey[item.key]=perimeterItem;});//ignore jslint
	}}function _moveCursor(segments,cursorSegment){var result=segments.nextKey(cursorSegment.key),nextKey;while(cursorSegment!=null&&cursorSegment.oppositeKey==(nextKey=result||segments.startKey())){if(result!=null){result=segments.nextKey(result);}segments.remove(cursorSegment.key);segments.remove(nextKey);cursorSegment=segments.item(result!=null?segments.prevKey(result):segments.endKey());}return result;}function getMergedPerimeters(items){var result=[],// array of merged Perimeter Items
	itemsToMerge={},// hash contains PerimeterItem.id merged into output array of Perimeter Items
	index,len,item,targetPerimeter,perimeter,cursor,cursorSegment,adjadjacentPerimeter;for(index=0,len=items.length;index<len;index+=1){item=items[index];itemsToMerge[item]=!perimetersHash.hasOwnProperty(item);}for(index=0,len=items.length;index<len;index+=1){item=items[index];if(!itemsToMerge[item]){itemsToMerge[item]=true;targetPerimeter=new primitives.common.perimeter.Item(item);// Copy first perimeter to target
	perimeter=perimetersHash[item];perimeter.segments.iterate(function(segment){targetPerimeter.segments.add(segment.key,segment);});//ignore jslint
	result.push(targetPerimeter);// Create cursor and scan target perimeter segments
	cursor=targetPerimeter.segments.startKey();while(cursor!=null){cursorSegment=targetPerimeter.segments.item(cursor);if(perimetersBySegmentKey.hasOwnProperty(cursorSegment.oppositeKey)){adjadjacentPerimeter=perimetersBySegmentKey[cursorSegment.oppositeKey];if(itemsToMerge.hasOwnProperty(adjadjacentPerimeter.id)&&!itemsToMerge[adjadjacentPerimeter.id]){itemsToMerge[adjadjacentPerimeter.id]=true;adjadjacentPerimeter.segments.iterateBack(function(segment){if(segment.key!=cursorSegment.oppositeKey){targetPerimeter.segments.insertAfter(cursor,segment.key,segment);}},cursorSegment.oppositeKey,null);//ignore jslint
	adjadjacentPerimeter.segments.iterateBack(function(segment){targetPerimeter.segments.insertAfter(cursor,segment.key,segment);},null,cursorSegment.oppositeKey);//ignore jslint
	}}cursor=_moveCursor(targetPerimeter.segments,cursorSegment);}}}return result;}if(perimeterItems!=null){add(perimeterItems);}return{add:add,getMergedPerimeters:getMergedPerimeters};};/* /algorithms/Perimeter/PerimeterSegmentItem.js*/primitives.common.perimeter.SegmentItem=function(arg0,arg1,arg2,arg3){this.fromPoint=null;this.toPoint=null;switch(arguments.length){case 2:this.fromPoint=arg0;this.toPoint=arg1;break;case 4:this.fromPoint=new primitives.common.Point(arg0,arg1);this.toPoint=new primitives.common.Point(arg2,arg3);break;default:break;}var fromKey=this.fromPoint.toString(),toKey=this.toPoint.toString();if(fromKey==toKey){throw"Null length segment!";}this.key=fromKey+' - '+toKey;this.oppositeKey=toKey+' - '+fromKey;this.orientationType=null;if(this.fromPoint.y>this.toPoint.y){this.orientationType=3/*primitives.common.OrientationType.Right*/;}else if(this.fromPoint.y<this.toPoint.y){this.orientationType=2/*primitives.common.OrientationType.Left*/;}else if(this.fromPoint.x>this.toPoint.x){this.orientationType=0/*primitives.common.OrientationType.Top*/;}else{this.orientationType=1/*primitives.common.OrientationType.Bottom*/;}};/* /algorithms/algorithms.js*//*
		Function: primitives.common.mergeSort
			Merges array of sorted arrays into one using call back function for comparison.
	
		Parameters:
			arrays - Array of sorted arrays of objects.
			getItemWeight - Call back function used to get items weight.
			ignoreDuplicates - return distinct items only.
	
		Returns:
			Array of merged sorted items.
	*/primitives.common.mergeSort=function(arrays,getItemWeight,ignoreDuplicates){var result=null,firstArray,secondArray,mergedArray,arrayIndex,firstIndex,secondIndex,firstLen,secondLen,firstItem,secondItem,firstItemWeight,secondItemWeight,currentValue;switch(arrays.length){case 0:result=[];break;default:firstArray=[];for(arrayIndex=0;arrayIndex<arrays.length;arrayIndex+=1){secondArray=arrays[arrayIndex];mergedArray=[];firstLen=firstArray.length;secondLen=secondArray.length;firstIndex=0;secondIndex=0;firstItem=null;firstItemWeight=null;secondItem=null;secondItemWeight=null;if(firstLen>0){firstItem=firstArray[firstIndex];firstItemWeight=!getItemWeight?firstItem:getItemWeight(firstItem);}if(secondLen>0){secondItem=secondArray[secondIndex];secondItemWeight=!getItemWeight?secondItem:getItemWeight(secondItem);}currentValue=null;while(firstIndex<firstLen||secondIndex<secondLen){if(firstIndex>=firstLen){if(!ignoreDuplicates||currentValue!=secondItem){mergedArray.push(secondItem);currentValue=secondItem;}secondIndex+=1;if(secondIndex<secondLen){secondItem=secondArray[secondIndex];secondItemWeight=!getItemWeight?secondItem:getItemWeight(secondItem);}}else{if(secondIndex>=secondLen){if(!ignoreDuplicates||currentValue!=firstItem){mergedArray.push(firstItem);currentValue=firstItem;}firstIndex+=1;if(firstIndex<firstLen){firstItem=firstArray[firstIndex];firstItemWeight=!getItemWeight?firstItem:getItemWeight(firstItem);}}else{if(firstItemWeight<secondItemWeight){if(!ignoreDuplicates||currentValue!=firstItem){mergedArray.push(firstItem);currentValue=firstItem;}firstIndex+=1;if(firstIndex<firstLen){firstItem=firstArray[firstIndex];firstItemWeight=!getItemWeight?firstItem:getItemWeight(firstItem);}}else{if(!ignoreDuplicates||currentValue!=secondItem){mergedArray.push(secondItem);currentValue=secondItem;}secondIndex+=1;if(secondIndex<secondLen){secondItem=secondArray[secondIndex];secondItemWeight=!getItemWeight?secondItem:getItemWeight(secondItem);}}}}}firstArray=mergedArray;}result=firstArray;break;}return result;};/*
		Function: primitives.common.binarySearch
			Search sorted list of elements for nearest item.
	
		Parameters:
			items - Array of elements.
			funcDistance - Call back function used to get ditance for current item.
	
		Returns:
			Nearest item.
	*/primitives.common.binarySearch=function(items,funcDistance){var result=null,distance,bestDistance,minimum=0,maximum=items.length-1,middle,item;if(items.length>0){result=items[minimum];distance=funcDistance(result);if(distance>0){bestDistance=Math.abs(distance);item=items[maximum];distance=funcDistance(item);if(distance>=0){result=item;}else{distance=Math.abs(distance);if(bestDistance>distance){bestDistance=distance;result=item;}while(minimum+1<maximum){middle=Math.round((minimum+maximum)/2.0);item=items[middle];distance=funcDistance(item);if(distance===0){result=item;break;}else{if(distance>0){minimum=middle;}else{maximum=middle;}distance=Math.abs(distance);if(bestDistance>distance){bestDistance=distance;result=item;}}}}}}return result;};/* /algorithms/dependencies.js*/primitives.common.dependencies=function(){var _forwardEdges={},_forwardCount={},_backwardEdges={},_backwardCount={};function add(from,to,edge){if(from==null||to==null){throw"Node id should not be null!";}if((_forwardEdges[from]==null||_forwardEdges[from][to]==null)&&edge!=null){if(_forwardEdges[from]==null){_forwardEdges[from]={};_forwardCount[from]=0;}if(_forwardEdges[from][to]==null){_forwardEdges[from][to]=edge;_forwardCount[from]+=1;}if(_backwardEdges[to]==null){_backwardEdges[to]={};_backwardCount[to]=0;}if(_backwardEdges[to][from]==null){_backwardEdges[to][from]=edge;_backwardCount[to]+=1;}}}function dependency(from,to){var result=null;if(_forwardEdges[from]!=null&&_forwardEdges[from][to]){result=_forwardEdges[from][to];}return result;}function dependencyBackward(from,to){var result=null;if(_backwardEdges[from]!=null&&_backwardEdges[from][to]){result=_backwardEdges[from][to];}return result;}function countForward(from){return _forwardCount[from]||0;}function countBackword(from){return _backwardCount[from]||0;}function _loop(thisArg,collection,from,onEdge){var itemid,items=collection[from];if(items!=null){for(itemid in items){if(items.hasOwnProperty(itemid)){if(onEdge.call(thisArg,itemid,items[itemid])){break;}}}}}function loopForward(thisArg,from,onEdge){// onItem(to, edge)
	if(onEdge!=null){if(from!=null){_loop(thisArg,_forwardEdges,from,onEdge);}}}function loopBackward(thisArg,to,onEdge){// onItem(from, edge)
	if(onEdge!=null){if(to!=null){_loop(thisArg,_backwardEdges,to,onEdge);}}}function firstForward(from){var result=null;if(from!=null){_loop(this,_forwardEdges,from,function(to,edge){result=to;return true;});}return result;}function firstBackward(to){var result=null;if(to!=null){_loop(this,_backwardEdges,to,function(from,edge){result=from;return true;});}return result;}function _loopTopo(thisArg,forwardCol,forwardCount,backwardCol,backwardCount,onItem){// onItem(itemid, position, layer)
	var index,len,nodeid,references,queue,newQueue,position,layer;if(onItem!=null){/* count parents for every node */queue=[];references={};for(nodeid in backwardCount){if(backwardCount.hasOwnProperty(nodeid)){references[nodeid]=backwardCount[nodeid];}}for(nodeid in forwardCol){if(forwardCol.hasOwnProperty(nodeid)){if(!references.hasOwnProperty(nodeid)){references[nodeid]=0;queue.push(nodeid);}}}/* itterate queue and reduce reference counts via children */position=0;layer=0;while(queue.length>0){newQueue=[];for(index=0,len=queue.length;index<len;index+=1){nodeid=queue[index];if(onItem.call(thisArg,nodeid,position,layer)){newQueue=[];break;}position+=1;_loop(this,forwardCol,nodeid,function(itemid){references[itemid]-=1;if(references[itemid]===0){newQueue.push(itemid);}});//ignore jslint
	}queue=newQueue;layer+=1;}}}function loopTopoForward(thisArg,onItem){// onItem(itemid, position)
	_loopTopo(thisArg,_forwardEdges,_forwardCount,_backwardEdges,_backwardCount,onItem);}function loopTopoBackward(thisArg,onItem){// onItem(itemid, position)
	_loopTopo(thisArg,_backwardEdges,_backwardCount,_forwardEdges,_forwardCount,onItem);}return{add:add,dependency:dependency,dependencyBackward:dependencyBackward,countForward:countForward,countBackword:countBackword,loopForward:loopForward,loopBackward:loopBackward,firstForward:firstForward,firstBackward:firstBackward,loopTopoForward:loopTopoForward,loopTopoBackward:loopTopoBackward};};/* /algorithms/family.js*/primitives.common.family=function(source){var _roots={},// children hash of orphant parent id
	_rootsCount={},_children={},// children hash by node id
	_childrenCount={},_parents={},// parents hash by node id
	_parentsCount={},_nodes={},// nodes by node id
	BREAK=1,SKIP=2;_init(source);function _init(source){if(primitives.common.isObject(source)){_roots=primitives.common.cloneObject(source.roots,false);_rootsCount=primitives.common.cloneObject(source.rootsCount,true);_children=primitives.common.cloneObject(source.children,false);_childrenCount=primitives.common.cloneObject(source.childrenCount,true);_parents=primitives.common.cloneObject(source.parents,false);_parentsCount=primitives.common.cloneObject(source.parentsCount,true);_nodes=primitives.common.cloneObject(source.nodes,true);}}function _loop(thisArg,collection,itemid,onItem){var item,items;if(onItem!=null){items=collection[itemid];if(items!=null){for(item in items){if(items.hasOwnProperty(item)){if(onItem.call(thisArg,item)){break;}}}}}}function add(parents,nodeid,node){var index,len,parentid,processed={};if(!parents||parents.length===0){parents=[null];}if(_nodes[nodeid]==null&&node!=null){_nodes[nodeid]=node;for(index=0,len=parents.length;index<len;index+=1){parentid=parents[index];if(processed[parentid]==null&&parentid!=nodeid){processed[parentid]=true;if(_nodes[parentid]!=null){if(_parents[nodeid]==null){_parents[nodeid]={};_parentsCount[nodeid]=0;}if(!_parents[nodeid][parentid]){_parents[nodeid][parentid]=true;_parentsCount[nodeid]+=1;}if(_children[parentid]==null){_children[parentid]={};_childrenCount[parentid]=0;}if(!_children[parentid][nodeid]){_children[parentid][nodeid]=true;_childrenCount[parentid]+=1;}}else{if(_roots[parentid]==null){_roots[parentid]={};_rootsCount[parentid]=0;}if(!_roots[parentid][nodeid]){_roots[parentid][nodeid]=true;_rootsCount[parentid]+=1;}}}}if(_roots[nodeid]!=null){_children[nodeid]=_roots[nodeid];_childrenCount[nodeid]=_rootsCount[nodeid];delete _roots[nodeid];delete _rootsCount[nodeid];_loop(this,_children,nodeid,function(itemid){if(_parents[itemid]==null){_parents[itemid]={};_parentsCount[itemid]=0;}if(!_parents[itemid][nodeid]){_parents[itemid][nodeid]=true;_parentsCount[itemid]+=1;}});}}}function node(nodeid){return _nodes[nodeid];}function adopt(parents,nodeid){var index,len,parentid;if(_nodes[nodeid]!=null){for(index=0,len=parents.length;index<len;index+=1){parentid=parents[index];if(_parents[nodeid]==null){_parents[nodeid]={};_parentsCount[nodeid]=0;}if(parentid!=nodeid&&_nodes[parentid]!=null){if(!_parents[nodeid][parentid]){_parents[nodeid][parentid]=true;_parentsCount[nodeid]+=1;}if(_children[parentid]==null){_children[parentid]={};_childrenCount[parentid]=0;}if(!_children[parentid][nodeid]){_children[parentid][nodeid]=true;_childrenCount[parentid]+=1;}}else{throw"Item cannot be parent of itself and parent should exist in the structure!";}}}else{throw"Child should be in hierarchy!";}}function removeNode(nodeid){if(_nodes[nodeid]!=null){_loop(this,_children,nodeid,function(itemid){delete _parents[itemid][nodeid];_parentsCount[itemid]-=1;if(!_parentsCount[itemid]){delete _parents[itemid];delete _parentsCount[itemid];if(_roots[null]==null){_roots[null]={};_rootsCount[null]=0;}if(!_roots[null][itemid]){_roots[null][itemid]=true;_rootsCount[null]+=1;}}});_loop(this,_parents,nodeid,function(itemid){delete _children[itemid][nodeid];_childrenCount[itemid]-=1;if(!_childrenCount[itemid]){delete _children[itemid];delete _childrenCount[itemid];}});if(_roots[null]!=null&&_roots[null][nodeid]!=null){delete _roots[null][nodeid];_rootsCount[null]-=1;if(!_rootsCount[null]){delete _roots[null];delete _rootsCount[null];}}delete _children[nodeid];delete _childrenCount[nodeid];delete _parents[nodeid];delete _parentsCount[nodeid];delete _nodes[nodeid];}}function _removeChildReference(parentid,childid){var result=false;if(_children[parentid]!=null&&_children[parentid][childid]!=null){delete _children[parentid][childid];_childrenCount[parentid]-=1;delete _parents[childid][parentid];_parentsCount[childid]-=1;if(!_childrenCount[parentid]){delete _children[parentid];delete _childrenCount[parentid];}if(!_parents[childid]){delete _parents[childid];delete _parentsCount[childid];if(_roots[null]==null){_roots[null]={};_rootsCount[null]=0;}_roots[null][childid]=true;_rootsCount[null]+=1;}result=true;}return result;}function removeRelation(fromid,toid){var result=false;if(_nodes[fromid]!=null&&_nodes[toid]!=null){result=_removeChildReference(fromid,toid)||_removeChildReference(toid,fromid);}return result;}function hasNodes(){return!primitives.common.isEmptyObject(_nodes);}function loop(thisArg,onItem){var item;if(onItem!=null){for(item in _nodes){if(_nodes.hasOwnProperty(item)){if(onItem.call(thisArg,item,_nodes[item])){break;}}}}}function _loopItems(thisArg,collection,items,onItem){// onItem(itemid, item, levelIndex)
	var newItems,itemid,processed={},levelIndex=0,hasItems=true;while(hasItems){newItems={};hasItems=false;for(itemid in items){if(items.hasOwnProperty(itemid)){if(!processed[itemid]){processed[itemid]=true;switch(onItem.call(thisArg,itemid,_nodes[itemid],levelIndex)){case 1/*BREAK*/:newItems={};hasItems=false;break;case 2/*SKIP*/:break;default:_loop(this,collection,itemid,function(newItemId){if(!processed[newItemId]){newItems[newItemId]=true;hasItems=true;}});//ignore jslint
	break;}}}}items=newItems;levelIndex+=1;}}function loopChildren(thisArg,nodeid,onItem){// onItem(itemid, item, levelIndex)
	if(onItem!=null){if(nodeid!=null&&_nodes[nodeid]!=null&&_children[nodeid]!=null){_loopItems(thisArg,_children,_children[nodeid],onItem);}}}function loopParents(thisArg,nodeid,onItem){// onItem(itemid, item, levelIndex)
	if(onItem!=null){if(nodeid!=null&&_nodes[nodeid]!=null&&_parents[nodeid]!=null){_loopItems(thisArg,_parents,_parents[nodeid],onItem);}}}function _loopTopo(thisArg,backwardCol,backwardCount,forwardCol,forwardCount,onItem){// onItem(itemid, item, position)
	var index,len,nodeid,references,queue,newQueue,position;if(onItem!=null){/* count parents for every node */queue=[];references={};for(nodeid in _nodes){if(_nodes.hasOwnProperty(nodeid)){references[nodeid]=backwardCount[nodeid]||0;if(!references[nodeid]){queue.push(nodeid);}}}/* itterate queue and reduce reference counts via children */position=0;while(queue.length>0){newQueue=[];for(index=0,len=queue.length;index<len;index+=1){nodeid=queue[index];if(onItem.call(thisArg,nodeid,_nodes[nodeid],position)){newQueue=[];break;}position+=1;_loop(this,forwardCol,nodeid,function(itemid){references[itemid]-=1;if(references[itemid]===0){newQueue.push(itemid);}});//ignore jslint
	}queue=newQueue;}}}function loopTopo(thisArg,onItem){// onItem(itemid, item, position)
	_loopTopo(thisArg,_parents,_parentsCount,_children,_childrenCount,onItem);}function loopTopoReversed(thisArg,onItem){// onItem(itemid, item, position)
	_loopTopo(thisArg,_children,_childrenCount,_parents,_parentsCount,onItem);}/* argument parentAligned set to true alignes nodes to top otherwise to bottom */function loopLevels(thisArg,parentAligned,onItem){// onItem(itemid, item, levelIndex)
	var topoSorted=[],topoSortedPositions={},processed={},margin=[],/* result items distribution by levels */levels={},levelIndex,groups={},hasGroups,newGroups,groupIndex,group,itemsAtLevel,itemid,minimumLevel=null,loopFunc=parentAligned?loopTopo:loopTopoReversed,index,len,mIndex,mLen,mItem,mLevel,topoSortedItem,bestPosition,bestItem,bestLevel,bestIsParent,newMargin,hasNeighbours;function Group(){this.items={};this.minimumLevel=null;}Group.prototype.addItemToLevel=function(itemid,level){var items=this.items[level];if(!items){items=[itemid];this.items[level]=items;}else{items.push(itemid);}this.minimumLevel=this.minimumLevel==null?level:Math.min(this.minimumLevel,level);};function addItemToLevel(itemid,index,level){var group=groups[index];if(!group){group=new Group();groups[index]=group;}group.addItemToLevel(itemid,level);minimumLevel=minimumLevel==null?level:Math.min(minimumLevel,level);levels[itemid]=level;processed[itemid]=true;}if(onItem!=null){/* sort items topologically */loopFunc(this,function(itemid,item,position){topoSorted.push(itemid);topoSortedPositions[itemid]=position;});/* search for the first available non processed item in topological order */for(index=0,len=topoSorted.length;index<len;index+=1){topoSortedItem=topoSorted[index];if(processed[topoSortedItem]==null){margin.push(topoSortedItem);addItemToLevel(topoSortedItem,index,0);/* use regular graph breadth first search */while(margin.length>0){bestPosition=null;bestItem=null;bestLevel=null;bestIsParent=!parentAligned;newMargin=[];for(mIndex=0,mLen=margin.length;mIndex<mLen;mIndex+=1){mItem=margin[mIndex];mLevel=levels[mItem];hasNeighbours=false;if(parentAligned){_loop(this,_parents,mItem,function(parentid){var topoSortedPosition;if(!processed[parentid]){hasNeighbours=true;topoSortedPosition=topoSortedPositions[parentid];if(bestPosition==null||!bestIsParent||bestPosition<topoSortedPosition||bestPosition==topoSortedPosition&&bestLevel>mLevel-1){bestPosition=topoSortedPosition;bestItem=parentid;bestLevel=mLevel-1;bestIsParent=true;}}});//ignore jslint
	_loop(this,_children,mItem,function(childid){var topoSortedPosition;if(!processed[childid]){hasNeighbours=true;topoSortedPosition=topoSortedPositions[childid];if(bestPosition==null||!bestIsParent&&(bestPosition>topoSortedPosition||bestPosition==topoSortedPosition&&bestLevel<mLevel+1)){bestPosition=topoSortedPosition;bestItem=childid;bestLevel=mLevel+1;bestIsParent=false;}}});//ignore jslint
	}else{_loop(this,_children,mItem,function(childid){var topoSortedPosition;if(!processed[childid]){hasNeighbours=true;topoSortedPosition=topoSortedPositions[childid];if(bestPosition==null||bestIsParent||bestPosition<topoSortedPosition||bestPosition==topoSortedPosition&&bestLevel<mLevel+1){bestPosition=topoSortedPosition;bestItem=childid;bestLevel=mLevel+1;bestIsParent=false;}}});//ignore jslint
	_loop(this,_parents,mItem,function(parentid){var topoSortedPosition;if(!processed[parentid]){hasNeighbours=true;topoSortedPosition=topoSortedPositions[parentid];if(bestPosition==null||bestIsParent&&(bestPosition>topoSortedPosition||bestPosition==topoSortedPosition&&bestLevel>mLevel-1)){bestPosition=topoSortedPosition;bestItem=parentid;bestLevel=mLevel-1;bestIsParent=true;}}});//ignore jslint
	}if(hasNeighbours){newMargin.push(mItem);}}if(bestItem!=null){newMargin.push(bestItem);addItemToLevel(bestItem,index,bestLevel);}margin=newMargin;}}}hasGroups=true;levelIndex=minimumLevel;while(hasGroups){newGroups={};hasGroups=false;for(groupIndex in groups){if(groups.hasOwnProperty(groupIndex)){group=groups[groupIndex];itemsAtLevel=group.items[group.minimumLevel-minimumLevel+levelIndex];if(itemsAtLevel!=null){newGroups[groupIndex]=group;hasGroups=true;for(index=0,len=itemsAtLevel.length;index<len;index+=1){itemid=itemsAtLevel[index];if(onItem.call(thisArg,itemid,_nodes[itemid],levelIndex-minimumLevel)){hasGroups=false;return true;}}}}}groups=newGroups;levelIndex+=1;}}}function loopRoots(thisArg,onItem){// onItem(itemid, item)
	var result=null,minimum,counter=0,famMembers={},famCount={},isRoot,roots={},processed={},famItemId,member,members,rootid,membersRoots,memberRoots,memberRoot,index,len;loopTopoReversed(this,function(famItemId,famItem,position){/* every node has at least itself in members */if(!famMembers.hasOwnProperty(famItemId)){famMembers[famItemId]={};famCount[famItemId]=0;}famMembers[famItemId][famItemId]=true;famCount[famItemId]+=1;isRoot=true;loopParents(this,famItem.id,function(parentid,parent,levelIndex){var items,itemid;isRoot=false;if(!famMembers.hasOwnProperty(parentid)){famMembers[parentid]={};famCount[parentid]=0;}/* push famItem members to parent members collection */if(!famCount[parentid]&&_parentsCount[famItemId]==1){famMembers[parentid]=famMembers[famItemId];famCount[parentid]=famCount[famItemId];}else{items=famMembers[famItemId];for(itemid in items){if(items.hasOwnProperty(itemid)){if(!famMembers[parentid][itemid]){famMembers[parentid][itemid]=true;famCount[parentid]+=1;}}}}return SKIP;});if(isRoot){roots[famItemId]=true;counter+=1;}});/* create collection of roots per member */membersRoots={};for(rootid in roots){if(roots.hasOwnProperty(rootid)){members=famMembers[rootid];for(member in members){if(members.hasOwnProperty(member)){if(!membersRoots[member]){membersRoots[member]=[];}membersRoots[member].push(rootid.toString());}}}}/* loop minimal sub tree roots */while(counter>0){minimum=null;for(famItemId in roots){if(roots.hasOwnProperty(famItemId)){if(!minimum||famCount[famItemId]<minimum){minimum=famCount[famItemId];result=famItemId;}}}if(result!=null){if(onItem!=null){onItem.call(thisArg,result,_nodes[result]);}members=famMembers[result];for(member in members){if(members.hasOwnProperty(member)){if(!processed[member]){memberRoots=membersRoots[member];for(index=0,len=memberRoots.length;index<len;index+=1){memberRoot=memberRoots[index];famCount[memberRoot]-=1;}processed[member]=true;}}}delete roots[result];counter-=1;}}}function findLargestRoot(){var result=null,maximum,famMembers={},famCount={},isRoot;maximum=null;loopTopoReversed(this,function(famItemId,famItem,position){/* every node has at least itself in members */if(!famMembers.hasOwnProperty(famItemId)){famMembers[famItemId]={};famCount[famItemId]=0;}famMembers[famItemId][famItemId]=true;famCount[famItemId]+=1;isRoot=true;loopParents(this,famItem.id,function(parentid,parent,levelIndex){var items,itemid;isRoot=false;if(!famMembers.hasOwnProperty(parentid)){famMembers[parentid]={};famCount[parentid]=0;}/* push famItem members to parent members collection */if(!famCount[parentid]&&_parentsCount[famItemId]==1){famMembers[parentid]=famMembers[famItemId];famCount[parentid]=famCount[famItemId];}else{items=famMembers[famItemId];for(itemid in items){if(items.hasOwnProperty(itemid)){famMembers[parentid][itemid]=true;famCount[parentid]+=1;}}}return SKIP;});if(isRoot&&(!maximum||famCount[famItemId]>maximum)){maximum=famCount[famItemId];result=famItemId;}});return result;}/* common child should belong only to the given collection of parents, *//* if child's parents don't match given parents, it is not considered as common child */function hasCommonChild(parents){var result=false,parentsHash,childrenHash,parentsCount,pIndex,pLen,parent,child;/* convert parents collection to hash, remove duplicates and ignore non-existing items */parentsHash={};parentsCount=0;for(pIndex=0,pLen=parents.length;pIndex<pLen;pIndex+=1){parent=parents[pIndex];if(_nodes[parent]!=null&&!parentsHash[parent]){parentsHash[parent]=true;parentsCount+=1;}}/* collect number of parents referencing each child */childrenHash={};for(parent in parentsHash){if(parentsHash.hasOwnProperty(parent)){_loop(this,_children,parent,function(child){if(!childrenHash[child]){childrenHash[child]=1;}else{childrenHash[child]+=1;}});//ignore jslint
	}}/* find common child having number of references equal to number of existing parents */for(child in childrenHash){if(childrenHash.hasOwnProperty(child)){if(_parents[child]!=null&&(_parentsCount[child]||0)==childrenHash[child]&&childrenHash[child]==parentsCount){result=true;break;}}}return result;}function _bundleNodes(fromItem,items,bundleItemId,bundleItem,backwardCol,backwardCount,forwardCol,forwardCount,checkChildren){var isValid=false,index,len,child;if(_nodes[fromItem]!=null&&forwardCol[fromItem]!=null){/* validate target items */isValid=true;if(checkChildren){/* if we add new bundle all items should present */for(index=0,len=items.length;index<len;index+=1){child=items[index];if(_nodes[child]==null||forwardCol[fromItem][child]==null){isValid=false;}}}if(isValid){if(bundleItem!=null){/* add bundle node */_nodes[bundleItemId]=bundleItem;}if(_nodes[bundleItemId]!=null){/* update references */if(!backwardCol[bundleItemId]){backwardCol[bundleItemId]={};backwardCount[bundleItemId]=0;}if(!forwardCol[bundleItemId]){forwardCol[bundleItemId]={};forwardCount[bundleItemId]=0;}if(!backwardCol[bundleItemId][fromItem]){backwardCol[bundleItemId][fromItem]=true;backwardCount[bundleItemId]+=1;}if(!forwardCol[fromItem][bundleItemId]){forwardCol[fromItem][bundleItemId]=true;forwardCount[fromItem]+=1;}for(index=0,len=items.length;index<len;index+=1){child=items[index];if(bundleItemId!=child){if(forwardCol[fromItem][child]!=null){delete forwardCol[fromItem][child];forwardCount[fromItem]-=1;}if(backwardCol[child][fromItem]!=null){delete backwardCol[child][fromItem];backwardCount[child]-=1;}if(!backwardCol[child][bundleItemId]){backwardCol[child][bundleItemId]=true;backwardCount[child]+=1;}if(!forwardCol[bundleItemId][child]){forwardCol[bundleItemId][child]=true;forwardCount[bundleItemId]+=1;}}}}}}return isValid;}function bundleChildren(parent,children,bundleItemId,bundleItem){return _bundleNodes(parent,children,bundleItemId,bundleItem,_parents,_parentsCount,_children,_childrenCount,true);}function bundleParents(child,parents,bundleItemId,bundleItem){return _bundleNodes(child,parents,bundleItemId,bundleItem,_children,_childrenCount,_parents,_parentsCount,true);}function ReferenceItem(){this.id="";this.key="";this.children=[];this.childrenHash={};this.processed=false;}function ReferencesEdge(arg0){this.items=[];this.weight=0;this.difference=0;if(arguments.length>0){this.difference=arg0;}}function _getReferencesGraph(currentItems){var result=primitives.common.graph(),item,parents,index1,index2,len,from,to,difference,processed={};for(item in currentItems){if(currentItems.hasOwnProperty(item)){_loop(this,_children,item,function(child){if(!processed.hasOwnProperty(child)){processed[child]=true;/* create array of parents from hash references */parents=[];_loop(this,_parents,child,function(parent){parents.push(parent);});/* create all possible combinations between items */for(index1=0,len=parents.length;index1<len-1;index1+=1){from=parents[index1];if(currentItems.hasOwnProperty(from)){for(index2=index1+1;index2<len;index2+=1){to=parents[index2];if(currentItems.hasOwnProperty(to)){difference=Math.abs(currentItems[from].children.length-currentItems[to].children.length);var edge=result.edge(from,to);if(edge==null){edge=new ReferencesEdge(difference);result.addEdge(from,to,edge);}edge.items.push(child);edge.weight+=1;}}}}}});//ignore jslint
	}}return result;}function optimizeReferences(onNewBundleItem){var sharedItemsByKey={},sharedItemsById={},currentItems={},nodeid,newReferenceItem,nextItems,graph,node,maximumTree,counter=0,power=10,processed;if(onNewBundleItem!=null){for(nodeid in _nodes){counter+=1;if(_nodes.hasOwnProperty(nodeid)){newReferenceItem=new ReferenceItem();_loop(this,_children,nodeid,function(child){newReferenceItem.children.push(child);newReferenceItem.childrenHash[child]=true;});//ignore jslint
	newReferenceItem.children.sort();newReferenceItem.id=nodeid;newReferenceItem.key=newReferenceItem.children.join(",");currentItems[newReferenceItem.id]=newReferenceItem;}}power=Math.pow(10,counter.toString().length);while(!primitives.common.isEmptyObject(currentItems)){nextItems={};processed={};graph=_getReferencesGraph(currentItems);for(nodeid in currentItems){if(currentItems.hasOwnProperty(nodeid)){node=currentItems[nodeid];if(!node.processed){maximumTree=graph.getSpanningTree(nodeid,function(edge){return edge.weight*power+power-edge.difference;});//ignore jslint
	maximumTree.loopLevels(this,function(treeKey,treeKeyNode,levelid){currentItems[treeKey].processed=true;maximumTree.loopChildren(this,treeKey,function(child,childNode){var relation=graph.edge(treeKey,child),nextBundleItem=null,newItem,key,index,len,childrenToBind,isSharedItem,relationItem;currentItems[child].processed=true;if(relation.weight>1){key=relation.items.join(',');if(!sharedItemsByKey.hasOwnProperty(key)){newItem=onNewBundleItem();_nodes[newItem.id]=newItem;/* add new bundle node to the family */nextBundleItem=new ReferenceItem();nextBundleItem.id=newItem.id;nextBundleItem.key=key;for(index=0,len=relation.items.length;index<len;index+=1){relationItem=relation.items[index];nextBundleItem.children.push(relationItem);nextBundleItem.childrenHash[relationItem]=true;processed[relationItem]=true;}nextBundleItem.children.sort();sharedItemsByKey[nextBundleItem.key]=nextBundleItem;sharedItemsById[nextBundleItem.id]=nextBundleItem;nextItems[nextBundleItem.id]=nextBundleItem;processed[nextBundleItem.id]=nextBundleItem;childrenToBind=nextBundleItem.children.slice(0);loopChildren(this,treeKeyNode.replacementItem||treeKey,function(childid,child,level){// if child item is bundle and it is not child of new bundle item
	if(!nextBundleItem.childrenHash[childid]&&sharedItemsById[childid]!=null){isSharedItem=true;// if all children of that child are in the next bundle item we add it to that new bundle item as well
	loopChildren(this,childid,function(childid,child,level){if(!nextBundleItem.childrenHash[childid]){isSharedItem=false;return 1/*BREAK*/;}if(!processed.hasOwnProperty(childid)){return SKIP;}});if(isSharedItem){childrenToBind.push(childid);}}return 2/*SKIP*/;});_bundleNodes(treeKeyNode.replacementItem||treeKey,childrenToBind,nextBundleItem.id,newItem,_parents,_parentsCount,_children,_childrenCount,false);if((_childrenCount[treeKey]||0)<=1&&treeKeyNode.replacementItem==null){treeKeyNode.replacementItem=nextBundleItem.id;}}else{nextBundleItem=sharedItemsByKey[key];}/* don't add shared item to itself on next items loop*/if(nextBundleItem.id!=child){childrenToBind=nextBundleItem.children.slice(0);loopChildren(this,childNode.replacementItem||child,function(childid,child,level){if(sharedItemsById[childid]!=null&&!nextBundleItem.childrenHash[childid]){isSharedItem=true;loopChildren(this,childid,function(childid,child,level){if(!nextBundleItem.childrenHash[childid]){isSharedItem=false;return 1/*BREAK*/;}if(!processed.hasOwnProperty(childid)){return 2/*SKIP*/;}return SKIP;});if(isSharedItem){childrenToBind.push(childid);}}return 2/*SKIP*/;});_bundleNodes(childNode.replacementItem||child,childrenToBind,nextBundleItem.id,null,_parents,_parentsCount,_children,_childrenCount,false);/* if all items bundled then use bundle item for following transformations of references instead of original item if references graph*/if((_childrenCount[child]||0)<=1&&childNode.replacementItem==null){childNode.replacementItem=nextBundleItem.id;}}}});});//ignore jslint
	}}}currentItems=nextItems;}}}function eliminateManyToMany(onNewBundleItem){var parent,bundleNode;for(parent in _children){if(_children.hasOwnProperty(parent)){if((_childrenCount[parent]||0)>1){_loop(this,_children,parent,function(child){if((_parentsCount[child]||0)>1){bundleNode=onNewBundleItem();bundleChildren(parent,[child],bundleNode.id,bundleNode);}});//ignore jslint
	}}}}function FamilyEdge(parentid,childid){this.parentid=parentid;this.childid=childid;this.key=parentid+","+childid;}function getPlanarFamily(treeLevels){var result=new primitives.common.family(),familyEdgeIndex,familyEdgeLen,familyEdgeKey;treeLevels.loopLevels(this,function(levelIndex,treeLevel){var sequence=new primitives.common.LinkedHashItems(),crossings={},familyEdges={},firstBucket=[];treeLevels.loopLevelItems(this,levelIndex,function(parentid,parentItem,position){loopChildren(this,parentid,function(childid,childItem){var childPosition=treeLevels.getItemPosition(childid);var familyEdge=new FamilyEdge(parentid,childid);familyEdges[familyEdge.key]=familyEdge;var crossEdges=[];if(sequence.isEmpty()){sequence.add(childPosition,[familyEdge]);}else{sequence.iterateBack(function(sequenceItem,itemPosition){if(itemPosition<childPosition){// add new sequence after itemPosition and exit
	sequence.insertAfter(itemPosition,childPosition,[familyEdge]);return true;}else if(itemPosition==childPosition){// add new link to exisitng sequenceItem and exit
	sequenceItem.push(familyEdge);return true;}else{// merge links into output
	for(var crossEdgesIndex=0,crossEdgesLen=sequenceItem.length;crossEdgesIndex<crossEdgesLen;crossEdgesIndex+=1){var crossEdge=sequenceItem[crossEdgesIndex];if(crossEdge.parentid!=parentid){crossEdges.push(crossEdge);}}}});if(sequence.startKey()>childPosition){sequence.unshift(childPosition,[familyEdge]);}}crossings[familyEdge.key]=crossEdges;for(var crossEdgesIndex=0,crossEdgesLen=crossEdges.length;crossEdgesIndex<crossEdgesLen;crossEdgesIndex+=1){crossings[crossEdges[crossEdgesIndex].key].push(familyEdge);}return SKIP;});if(countChildren(parentid)==1){var childid=firstChild(parentid);if(countParents(childid)==1){var familyEdge=new FamilyEdge(parentid,childid);firstBucket.push(familyEdge.key);}}});// distribute edges by number of crossings into buckets
	var buckets=[],crossEdges;for(var familyEdgeKey in crossings){crossEdges=crossings[familyEdgeKey];var len=crossEdges.length;if(buckets[len]!=null){buckets[len].push(familyEdgeKey);}else{buckets[len]=[familyEdgeKey];}}var processed={};// leave single parent child relations
	buckets.unshift(firstBucket);// break relations having
	for(var bucketIndex=0,bucketsLen=buckets.length;bucketIndex<bucketsLen;bucketIndex+=1){var bucket=buckets[bucketIndex];if(bucket!=null){for(familyEdgeIndex=0,familyEdgeLen=bucket.length;familyEdgeIndex<familyEdgeLen;familyEdgeIndex+=1){familyEdgeKey=bucket[familyEdgeIndex];if(!processed.hasOwnProperty(familyEdgeKey)){processed[familyEdgeKey]=true;var familyEdge=familyEdges[familyEdgeKey];if(result.node(familyEdge.parentid)==null){result.add(null,familyEdge.parentid,{});}if(result.node(familyEdge.childid)==null){result.add([familyEdge.parentid],familyEdge.childid,{});}else{result.adopt([familyEdge.parentid],familyEdge.childid);}crossEdges=crossings[familyEdgeKey];for(var crossEdgesIndex=0,crossEdgesLen=crossEdges.length;crossEdgesIndex<crossEdgesLen;crossEdgesIndex+=1){processed[crossEdges[crossEdgesIndex].key]=true;}}}}}});return result;}function countChildren(parent){return _childrenCount[parent]||0;}function countParents(child){return _parentsCount[child]||0;}function firstChild(parent){var result=null,children=_children[parent]||{};for(result in children){if(children.hasOwnProperty(result)){return result;//ignore jslint
	}}return null;}function firstParent(child){var result=null,parents=_parents[child]||{};for(result in parents){if(parents.hasOwnProperty(result)){return result;//ignore jslint
	}}return null;}function loopNeighbours(thisArg,itemid,onItem){var processed={};if(onItem!=null){loopChildren(this,itemid,function(childid,child,childLevel){if(!processed.hasOwnProperty(childid)){processed[childid]=null;if(onItem.call(thisArg,childid,child,1)){processed[childid]=SKIP;loopParents(this,childid,function(parentid,parent,parentLevel){if(!processed.hasOwnProperty(parentid)){processed[parentid]=null;if(onItem.call(thisArg,parentid,parent,2)){processed[parentid]=SKIP;}}return processed[parentid];});}}return processed[childid];});loopParents(this,itemid,function(parentid,parent,parentLevel){if(!processed.hasOwnProperty(parentid)){processed[parentid]=null;if(onItem.call(thisArg,parentid,parent,1)){processed[parentid]=SKIP;loopChildren(this,parentid,function(childid,child,childLevel){if(!processed.hasOwnProperty(childid)){processed[childid]=true;if(onItem.call(thisArg,childid,child,2)){processed[childid]=SKIP;}}return processed[childid];});}}return processed[parentid];});}}function validate(info){var parent,child;function _count(items){var result=0,key;if(items!=null){for(key in items){if(items.hasOwnProperty(key)){result+=1;}}}return result;}loop(this,function(nodeId,node){_loop(this,_children,nodeId,function(child){if(!_parents.hasOwnProperty(child)||!_parents[child].hasOwnProperty(nodeId)){if(info!=null){info.message="Child #"+child+" does not reference parent #"+nodeId;}return false;}});_loop(this,_parents,nodeId,function(parent){if(!_children.hasOwnProperty(parent)||!_children[parent].hasOwnProperty(nodeId)){if(info!=null){info.message="Parent #"+parent+" does not reference child #"+nodeId;}return false;}});});for(parent in _parents){if(_parents.hasOwnProperty(parent)){if((_parentsCount[parent]||0)!=_count(_parents[parent])){if(info!=null){info.message="Parents count for item #"+parent+" missmatch.";}return false;}if(_parents.hasOwnProperty(parent)&&!_nodes.hasOwnProperty(parent)){if(info!=null){info.message="Orphant parents for item #"+parent;}return false;}}}for(child in _children){if(_children.hasOwnProperty(child)){if((_childrenCount[child]||0)!=_count(_children[child])){if(info!=null){info.message="Children count for item "+child+" missmatch.";}return false;}if(_children.hasOwnProperty(child)&&!_nodes.hasOwnProperty(child)){if(info!=null){info.message="Orphant children of item "+child;}return false;}}}for(child in _roots){if(_roots.hasOwnProperty(child)){if((_rootsCount[child]||0)!=_count(_roots[child])){if(info!=null){info.message="Root children count for item @"+child+" missmatch.";}return false;}_loop(this,_roots,child,function(nodeid){if(!_nodes.hasOwnProperty(nodeid)){if(info!=null){info.message="Child #"+nodeid+"of root #"+child+" does not exists.";}return false;}});//ignore jslint
	}}return true;}function hasLoops(){var tempFamily=clone();loopTopo(this,function(itemid,item,levelIndex){tempFamily.removeNode(itemid);});return tempFamily.hasNodes();}function clone(){return primitives.common.family({roots:_roots,rootsCount:_rootsCount,children:_children,childrenCount:_childrenCount,parents:_parents,parentsCount:_parentsCount,nodes:_nodes});}/* Private objects */return{/* family structure modification */add:add,adopt:adopt,bundleChildren:bundleChildren,bundleParents:bundleParents,optimizeReferences:optimizeReferences,eliminateManyToMany:eliminateManyToMany,getPlanarFamily:getPlanarFamily,removeNode:removeNode,removeRelation:removeRelation,/* referencing and looping */node:node,loop:loop,loopLevels:loopLevels,loopTopo:loopTopo,loopTopoReversed:loopTopoReversed,loopChildren:loopChildren,loopParents:loopParents,findLargestRoot:findLargestRoot,loopRoots:loopRoots,hasNodes:hasNodes,hasCommonChild:hasCommonChild,loopNeighbours:loopNeighbours,countChildren:countChildren,countParents:countParents,firstParent:firstParent,firstChild:firstChild,/* force validation */validate:validate,hasLoops:hasLoops,clone:clone,// callback return codes
	BREAK:BREAK,// break loop immidiatly
	SKIP:SKIP// skip loop of current node children
	};};/* /algorithms/FibonacciHeap.js*/primitives.common.FibonacciHeap=function(isMaximum){var root=null,count=0,nodes={};function Result(node){this.key=node.key;this.priority=node.priority;this.item=node.item;}function Node(key,priority,item){this.key=key;this.priority=priority;this.item=item;this.degree=0;this.marked=false;this.parent=null;this.child=null;this.left=null;this.right=null;}function validate(){var totalNodes=0;for(var key in nodes){if(nodes.hasOwnProperty(key)){var node=nodes[key];totalNodes+=1;if(node.child!=null){if(!nodes.hasOwnProperty(node.child)){throw"Child does not exists";}var ref=nodes[node.child];if(ref.parent!=node.key){throw"Child references wrong parent";}}if(node.parent!=null){if(!nodes.hasOwnProperty(node.parent)){throw"Parent does not exists";}}if(node.left!=null){if(!nodes.hasOwnProperty(node.left)){throw"Left does not exists";}ref=nodes[node.left];if(ref.right!=node.key){throw"Left references wrong right";}}if(node.right!=null){if(!nodes.hasOwnProperty(node.right)){throw"Right does not exists";}ref=nodes[node.right];if(ref.left!=node.key){throw"Right references wrong left";}}}}if(root==null&&totalNodes>0){throw"Orphans";}if(root!=null){if(!nodes.hasOwnProperty(root)){throw"Root node does not exists";}node=nodes[root];if(node.parent!=null){throw"Root node has parent reference";}var children=[root];var processed={};var totalChildren=0;while(children.length>0){var newChildren=[];for(var index=0,len=children.length;index<len;index+=1){var child=nodes[children[index]];while(!processed.hasOwnProperty(child.key)){processed[child.key]=true;totalChildren+=1;if(child.child!=null){newChildren.push(child.child);}child=nodes[child.right];}}children=newChildren;}if(totalNodes!=totalChildren){throw"Tree has loops or orpants";}}}function add(key,priority,item){if(nodes.hasOwnProperty(key)){throw"Duplicate keys are not supported!";}var newNode=new Node(key,priority,item);nodes[key]=newNode;if(root==null){newNode.left=key;newNode.right=key;root=key;}else{var rootNode=nodes[root];_insert(rootNode,newNode);if(isMaximum?rootNode.priority<newNode.priority:rootNode.priority>newNode.priority){root=key;}}count+=1;}function _insert(node,newNode){var rightNode=nodes[node.right];newNode.right=node.right;newNode.left=node.key;node.right=newNode.key;rightNode.left=newNode.key;}function _exclude(node){var prevNode=nodes[node.left],nextNode=nodes[node.right];prevNode.right=nextNode.key;nextNode.left=prevNode.key;node.right=node.key;node.left=node.key;}function getPriority(key){var result=null;if(nodes.hasOwnProperty(key)){result=nodes[key].priority;}return result;}function heapRoot(){var result=null;if(root!=null){result=new Result(nodes[root]);}return result;}function extractRoot(){var result=heapRoot();if(result!=null){var rootNode=nodes[root],nextNode=nodes[rootNode.right];if(rootNode.child!=null){var childNode=nodes[rootNode.child],childNodeLeft=nodes[childNode.left];rootNode.right=childNode.key;nextNode.left=childNodeLeft.key;childNode.left=rootNode.key;childNodeLeft.right=nextNode.key;_exclude(rootNode);delete nodes[rootNode.key];root=null;_consolidate(childNode.key);}else{_exclude(rootNode);delete nodes[rootNode.key];root=null;if(nextNode.key!=rootNode.key){_consolidate(nextNode.key);}}count-=1;}return result;}function _consolidate(startKey){var pairs=[],pairedNode,processed={},key=startKey;while(!processed.hasOwnProperty(key)){var node=nodes[key],nextKey=node.right;processed[key]=true;node.parent=null;while((pairedNode=pairs[node.degree])!=null){if(isMaximum?node.priority>pairedNode.priority:node.priority<pairedNode.priority){_union(node,pairedNode);}else{_union(pairedNode,node);node=pairedNode;}pairs[node.degree-1]=null;}pairs[node.degree]=node;if(root==null||nodes[root]==null||(isMaximum?nodes[root].priority<=node.priority:nodes[root].priority>=node.priority)){root=node.key;}key=nextKey;}}function _union(node1,node2){node1.degree+=1;_exclude(node2);var child=nodes[node1.child];if(child!=null){_insert(child,node2);if(isMaximum?child.priority<node2.priority:child.priority>node2.priority){node1.child=node2.key;}}else{node1.child=node2.key;}node2.parent=node1.key;}function setPriority(key,priority){var node=nodes[key];if(isMaximum?node.priority>priority:node.priority<priority){throw"Priority increase is not supported";}node.priority=priority;if(node.parent!=null){var parentNode=nodes[node.parent];if(isMaximum?parentNode.priority<node.priority:parentNode.priority>node.priority){_cut(parentNode,node);_cascadeCut(parentNode);}}if(isMaximum?nodes[root].priority<node.priority:nodes[root].priority>node.priority){root=node.key;}}function _cut(parentNode,node){node.marked=false;node.parent=null;if(node.right==node.key){parentNode.child=null;}else{parentNode.child=node.right;_exclude(node);}parentNode.degree-=1;_insert(nodes[root],node);}function _cascadeCut(node){if(node.parent!=null){if(node.marked){var parentNode=nodes[node.parent];_cut(parentNode,node);_cascadeCut(parentNode);}else{node.marked=true;}}}function deleteKey(key){setPriority(key,isMaximum?Infinity:-1);extractRoot();}return{add:add,getPriority:getPriority,setPriority:setPriority,heapRoot:heapRoot,extractRoot:extractRoot,deleteKey:deleteKey,validate:validate};};/* /algorithms/graph.js*/primitives.common.graph=function(){var _edges={};function addEdge(from,to,edge){if((_edges[from]==null||_edges[from][to]==null)&&edge!=null){if(_edges[from]==null){_edges[from]={};}_edges[from][to]=edge;if(_edges[to]==null){_edges[to]={};}_edges[to][from]=edge;}}function edge(from,to){var result=null;if(_edges[from]!=null&&_edges[from][to]){result=_edges[from][to];}return result;}function hasNode(from){return _edges.hasOwnProperty(from);}function loopNodeEdges(thisArg,itemid,onEdge){// onEdge = function(to, edge) {}
	var neighbours,neighbourKey;if(onEdge!=null){neighbours=_edges[itemid];if(neighbours!=null){for(neighbourKey in neighbours){if(neighbours.hasOwnProperty(neighbourKey)){onEdge.call(thisArg,neighbourKey,neighbours[neighbourKey]);}}}}}function loopNodes(thisArg,startNode,onItem){// onItem = function(itemid) {}
	var processed={};if(startNode==null){for(startNode in _edges){if(_edges.hasOwnProperty(startNode)){if(!processed.hasOwnProperty[startNode]){_loopNodes(this,startNode,processed,onItem);}}}}else{_loopNodes(this,startNode,processed,onItem);}}function _loopNodes(thisArg,startNode,processed,onItem){// onItem = function(itemid) {}
	/* Graph */var margin=[],marginKey,newMargin,index,len,neighbours,neighbourKey;margin.push(startNode);processed[startNode]=true;if(onItem!=null){while(margin.length>0){newMargin=[];/* itterate neighbours of every node on margin */for(index=0,len=margin.length;index<len;index+=1){marginKey=margin[index];onItem.call(thisArg,marginKey);neighbours=_edges[marginKey];for(neighbourKey in neighbours){if(neighbours.hasOwnProperty(neighbourKey)&&!processed.hasOwnProperty(neighbourKey)){processed[neighbourKey]=true;newMargin.push(neighbourKey);}}}margin=newMargin;}}}/*
			Function: primitives.common.graph.getSpanningTree
				Get maximum spanning tree. Graph may have disconnected sub graphs, so start node is nessasary.
	
			Parameters:
			startNode - The node to start searching for maximum spanning tree. Graph is not nessasary connected
			getWeightFunc - Call back function to get weight of edge. function(edge)
	
			Returns:
				primitives.common.tree structure
		*/function getSpanningTree(startNode,getWeightFunc){var result=primitives.common.tree(),margin=primitives.common.FibonacciHeap(true),marginNode,parents={},/* if parent for item is set then it was laready visited */neighbours,neighbourKey,neighbourWeight,currentWeight;/* add start node to margin */margin.add(startNode,0,null/*parent of root node is null*/);parents[startNode]=null;/* search graph */while((marginNode=margin.extractRoot())!=null){/* itterate neighbours of every node on margin */neighbours=_edges[marginNode.key];for(neighbourKey in neighbours){if(neighbours.hasOwnProperty(neighbourKey)&&!result.node(neighbourKey)){neighbourWeight=getWeightFunc!=null?getWeightFunc(neighbours[neighbourKey]):neighbours[neighbourKey];currentWeight=margin.getPriority(neighbourKey);if(currentWeight==null){margin.add(neighbourKey,neighbourWeight,null);parents[neighbourKey]=marginNode.key.toString();}else{if(currentWeight<=neighbourWeight){/* improve node distance */margin.setPriority(neighbourKey,neighbourWeight);parents[neighbourKey]=marginNode.key.toString();}}}}/* add next margin item to resul tree */result.add(parents[marginNode.key],marginNode.key.toString(),{});}return result;}function _findStartNode(onEdgeWeight){var result=null,fromItem,toItems,toItem,weight=0,maxWeight=null;for(fromItem in _edges){if(_edges.hasOwnProperty(fromItem)){toItems=_edges[fromItem];weight=0;for(toItem in toItems){if(toItems.hasOwnProperty(toItem)){weight+=onEdgeWeight(toItems[toItem]);}}if(weight>maxWeight||maxWeight==null){result=fromItem;maxWeight=weight;}}}return result;}/*
			Function: primitives.common.graph.getGrowthSequence
				Get graph growth sequence. The sequence of spanning tree growth.
	
			Parameters:
				onEdgeWeight - Call back function to weight edge of graph. function(edge)
	
			Returns:
				Array of items.
		*/function getGrowthSequence(onEdgeWeight){var result=[],/* [] array of id-s */startNode,margin={},marginKey,itemsToRemove=[],/* if margin item has no neighbours to expand we remove it from margin*/hasNeighbours,processed={},/* if item is set then it was already visited */marginLength=0,/* curent margin length */nextMarginKey,nextMarginWeight,bestWeight,neighbours,neighbourKey,neighbourWeight,index,len;if(onEdgeWeight!=null){startNode=_findStartNode(onEdgeWeight);if(startNode!=null){result.push(startNode);/* add start node to margin */margin[startNode]=true;marginLength+=1;/* add startNode to result tree */processed[startNode]=null;/* search graph */while(marginLength>0){itemsToRemove=[];nextMarginKey=null;nextMarginWeight=null;bestWeight={};/* itterate neighbours of every node on margin */for(marginKey in margin){if(margin.hasOwnProperty(marginKey)){neighbours=_edges[marginKey];hasNeighbours=false;for(neighbourKey in neighbours){if(neighbours.hasOwnProperty(neighbourKey)&&!processed.hasOwnProperty(neighbourKey)){neighbourWeight=onEdgeWeight(neighbours[neighbourKey]);hasNeighbours=true;if(bestWeight[neighbourKey]==null){bestWeight[neighbourKey]=0;}bestWeight[neighbourKey]+=neighbourWeight;if(!nextMarginWeight||bestWeight[neighbourKey]>nextMarginWeight){nextMarginKey=neighbourKey;nextMarginWeight=bestWeight[neighbourKey];}}}if(!hasNeighbours){itemsToRemove.push(marginKey);}}}if(nextMarginKey==null){/* no items to expand to exit*/break;}else{margin[nextMarginKey]=true;marginLength+=1;processed[nextMarginKey]=true;/* add next margin item to result sequence */result.push(nextMarginKey);}for(index=0,len=itemsToRemove.length;index<len;index+=1){/* delete visited node from margin */delete margin[itemsToRemove[index]];marginLength-=1;}}}}return result;}/*
			Function: primitives.common.graph.getShortestPath
			Get shortest path between two nodes in graph. Start and end nodes supposed to have connection path. All connections have the same weight.
	
			Parameters:
			startNode - The node to start.
			endNode - The end node.
			getWeightFunc - Call back function to weight edge of graph. function(edge, fromItem, toItem)
	
			Returns:
				Array containing nodes names of connection path.
		*/function getShortestPath(thisArg,startNode,endNodes,getWeightFunc,onPathFound){// getWeightFunc = function(edge, fromItem, toItem), onPathFound = function(path, to)
	var margin=primitives.common.FibonacciHeap(false),distance={},breadcramps={},bestNodeOnMargin,key,children,newDistance,path,currentNode,endNodesHash={},index,len,endsCount=0,endsFound=0;/* create hash table of end nodes to find */for(index=0,len=endNodes.length;index<len;index+=1){key=endNodes[index];if(!endNodesHash.hasOwnProperty(key)){endsCount+=1;endNodesHash[key]=true;}}/* add start node to margin */margin.add(startNode,0,null);breadcramps[startNode]=null;/* search graph */while((bestNodeOnMargin=margin.extractRoot())!=null){/* itterate neighbours of selected node on margin */children=_edges[bestNodeOnMargin.key];for(key in children){if(children.hasOwnProperty(key)){newDistance=bestNodeOnMargin.priority+(getWeightFunc!=null?getWeightFunc.call(thisArg,children[key],bestNodeOnMargin,key):1);distance=margin.getPriority(key);if(distance!=null){if(distance>newDistance){margin.setPriority(key,newDistance);breadcramps[key]=bestNodeOnMargin.key;}}else{if(!breadcramps.hasOwnProperty(key)){margin.add(key,newDistance,null);breadcramps[key]=bestNodeOnMargin.key;}}}}if(endNodesHash.hasOwnProperty(bestNodeOnMargin.key)){/* trace path */path=[];currentNode=bestNodeOnMargin.key;while(currentNode!=null){path.push(currentNode);currentNode=breadcramps[currentNode];}onPathFound.call(thisArg,path,bestNodeOnMargin.key);endsFound+=1;if(endsFound>=endsCount){break;}}}}return{addEdge:addEdge,edge:edge,hasNode:hasNode,loopNodes:loopNodes,loopNodeEdges:loopNodeEdges,getSpanningTree:getSpanningTree,getGrowthSequence:getGrowthSequence,getShortestPath:getShortestPath};};/* /algorithms/LinkedHashItems.js*/primitives.common.LinkedHashItems=function(){var segmentsHash={},nextKeys={},prevKeys={},startSegmentKey=null,endSegmentKey=null;function add(key,item){if(segmentsHash.hasOwnProperty(key)){throw"Duplicate segments are not supported!";}segmentsHash[key]=item;nextKeys[key]=null;if(endSegmentKey==null){startSegmentKey=key;prevKeys[key]=null;}else{nextKeys[endSegmentKey]=key;prevKeys[key]=endSegmentKey;}endSegmentKey=key;}function isEmpty(){return startSegmentKey==null;}function item(key){return segmentsHash[key];}function nextKey(key){return nextKeys[key];}function prevKey(key){return prevKeys[key];}function startKey(){return startSegmentKey;}function endKey(){return endSegmentKey;}function unshift(key,item){if(segmentsHash.hasOwnProperty(key)){throw"Duplicate segments are not supported!";}segmentsHash[key]=item;prevKeys[key]=null;if(startSegmentKey==null){endSegmentKey=key;nextKeys[key]=null;}else{prevKeys[startSegmentKey]=key;nextKeys[key]=startSegmentKey;}startSegmentKey=key;}function insertAfter(afterKey,key,item){if(segmentsHash.hasOwnProperty(key)){throw"Duplicate segments are not supported!";}if(afterKey==null){unshift(key,item);}else{var nextKey=nextKeys[afterKey];if(nextKey==null){add(key,item);}else{segmentsHash[key]=item;nextKeys[afterKey]=key;nextKeys[key]=nextKey;prevKeys[nextKey]=key;prevKeys[key]=afterKey;}}}function remove(key){var prevKey=prevKeys[key],nextKey=nextKeys[key];if(prevKey!=null){nextKeys[prevKey]=nextKey;}else{startSegmentKey=nextKey;}if(nextKey!=null){prevKeys[nextKey]=prevKey;}else{endSegmentKey=prevKey;}delete segmentsHash[key];delete nextKeys[key];delete prevKeys[key];}function empty(){segmentsHash={};nextKeys={};prevKeys={};startSegmentKey=null;endSegmentKey=null;}function _iterate(forward,onItem,startKey,endKey){var key=startKey,segment;if(key==null){key=forward?startSegmentKey:endSegmentKey;}if(onItem!=null){while(key!=null){segment=segmentsHash[key];if(segment!=null){if(onItem(segment,key)){return;}}if(key==endKey){key=null;}else{key=forward?nextKeys[key]:prevKeys[key];}}}}function iterate(onItem,startKey,endKey){_iterate(true,onItem,startKey,endKey);}function iterateBack(onItem,startKey,endKey){_iterate(false,onItem,startKey,endKey);}function validate(info){var key,prevKey,nextKey;for(key in segmentsHash){if(segmentsHash.hasOwnProperty(key)){if(!nextKeys.hasOwnProperty(key)||!prevKeys.hasOwnProperty(key)){if(info!=null){info.message="Orphant key found!";}return false;}}}if(!segmentsHash.hasOwnProperty(startSegmentKey)||!segmentsHash.hasOwnProperty(endSegmentKey)){if(info!=null){info.message="Start or end values are missing!";}return false;}for(key in nextKeys){if(nextKeys.hasOwnProperty(key)){if(!segmentsHash.hasOwnProperty(key)||!prevKeys.hasOwnProperty(key)){if(info!=null){info.message="Orphant key found!";}return false;}nextKey=nextKeys[key];if(nextKey&&!nextKeys.hasOwnProperty(nextKey)){if(info!=null){info.message="Next key not found!";}return false;}}}for(key in prevKeys){if(prevKeys.hasOwnProperty(key)){if(!segmentsHash.hasOwnProperty(key)||!nextKeys.hasOwnProperty(key)){if(info!=null){info.message="Orphant key found!";}return false;}prevKey=prevKeys[key];if(prevKey&&!prevKeys.hasOwnProperty(prevKey)){if(info!=null){info.message="Prev key not found!";}return false;}}}return true;}function toArray(){var result=[];iterate(function(item){result.push(item);});return result;}return{add:add,item:item,nextKey:nextKey,prevKey:prevKey,startKey:startKey,endKey:endKey,unshift:unshift,insertAfter:insertAfter,remove:remove,isEmpty:isEmpty,iterate:iterate,iterateBack:iterateBack,empty:empty,toArray:toArray,validate:validate};};/* /algorithms/pile.js*//*
		Class: primitives.common.pile
			Sorts and stack segments on top of each other so they occupy minimum number of rows.
	*/primitives.common.pile=function(){var _items=[];/*
			Function: add
				Add segment to pile object.
	
			Parameters:
				from - Left margin of segment.
				to - Right margin of segment.
				context - Any reference to user object. It is returned as parameter in callback function of resolve method.
	
			See Also:
				<primitives.common.pile>
		*/function add(from,to,context){if(from<to){_items.push(new Segment(from,to,context,1));}else{_items.push(new Segment(to,from,context,-1));}}/*
			Function: resolve
				Sorts and stack segments on top of each other so they occupy minimum number of rows.
	
			Parameters:
				thisArg - Context of onItemStacked callback function call.
				onItemStacked - Call back function used to set segment offset. function(from, to, context, offset) {}
	
			Returns:
				Number of stacked rows in pile.
	
			See Also:
				<primitives.common.pile>
		*/function resolve(thisArg,onItem){// function(from, to, context, offset) {}
	var hash,backtraceNext,backtraceTaken,items,item,rowItems,rows,rowIndex,index,offset=0;if(onItem!=null){items=_items.slice(0);items.sort(function(a,b){return a.from-b.from;});rows=[];while(items.length>0){hash={};backtraceNext={};backtraceTaken={};getMax(0,items,hash,backtraceNext,backtraceTaken);rowItems=[];rows[offset]=[];index=0;while(backtraceNext.hasOwnProperty(index)){if(backtraceTaken[index]){rowItems.push(index);rows[offset].push(items[index]);}index=backtraceNext[index];}for(index=rowItems.length-1;index>=0;index-=1){items.splice(rowItems[index],1);}offset+=1;}for(rowIndex=0;rowIndex<offset;rowIndex+=1){rowItems=rows[rowIndex];for(index=0;index<rowItems.length;index+=1){item=rowItems[index];if(onItem.call(thisArg,item.from,item.to,item.context,rowIndex,offset,item.direction)){return offset;}}}}return offset;}function Segment(from,to,context,direction){this.context=context;this.from=from;this.to=to;this.offset=null;this.direction=direction;}function getMax(index,items,hash,backtraceNext,backtraceTaken){var result=0;if(index>=items.length){return 0;}if(hash.hasOwnProperty(index)){return hash[index];}var item=items[index];var withoutItem=getMax(index+1,items,hash,backtraceNext,backtraceTaken);var nextIndex=index+1;while(nextIndex<items.length){var nextItem=items[nextIndex];if(nextItem.from>=item.to){break;}nextIndex+=1;}var withItem=1+getMax(nextIndex,items,hash,backtraceNext,backtraceTaken);if(withItem>withoutItem){hash[index]=withItem;backtraceNext[index]=nextIndex;backtraceTaken[index]=true;}else{hash[index]=withoutItem;backtraceNext[index]=index+1;backtraceTaken[index]=false;}return hash[index];}return{add:add,resolve:resolve};};/* /algorithms/tree.js*/primitives.common.tree=function(source){var _nodes={},// objects attached to nodes
	_parents={},// parent node id for every node id. Both of them should exists in the tree.
	_children={},// children node ids for every node id. All children and node itself should be in the tree.
	_roots={},// id of non existing parent. If parent does not exists in the tree this hash contains its id.
	_rootChildren={},// children of non existing parent. If parent id does not exists in the tree this collection contains it existing children.
	BREAK=1,SKIP=2;_init(source);function _init(source){if(primitives.common.isObject(source)){_nodes=primitives.common.cloneObject(source.nodes,true);_parents=primitives.common.cloneObject(source.parents,true);_children=primitives.common.cloneObject(source.children,false);_roots=primitives.common.cloneObject(source.roots,false);_rootChildren=primitives.common.cloneObject(source.rootChildren,true);}}function loop(thisArg,onItem){var item;if(onItem!=null){for(item in _nodes){if(_nodes.hasOwnProperty(item)){if(onItem.call(thisArg,item,_nodes[item])){break;}}}}}function loopLevels(thisArg,arg0,arg1){// onItem(nodeid, node, levelid) if function returns true loop is continued on item's children
	var levelIndex=0,items=[],itemid,onItem,newItems,key,index,len;switch(arguments.length){case 2:onItem=arg0;break;case 3:itemid=arg0;onItem=arg1;break;}if(onItem!=null){if(itemid==null){for(key in _rootChildren){if(_rootChildren.hasOwnProperty(key)){items=items.concat(_rootChildren[key]);}}}else{if(_children[itemid]!=null){items=items.concat(_children[itemid]);}}while(items.length>0){newItems=[];for(index=0,len=items.length;index<len;index+=1){itemid=items[index];switch(onItem.call(thisArg,itemid,_nodes[itemid],levelIndex)){case BREAK:newItems=[];break;case SKIP:break;default:if(_children[itemid]!=null){newItems=newItems.concat(_children[itemid]);}break;}}items=newItems;levelIndex+=1;}}}/* children first - parent last */function loopPostOrder(thisArg,onItem){// onItem(nodeid, node, parentid, parent) if function returns true loop exits
	var stack=[],nodeid,key,index,prevParent,children;if(onItem!=null){for(key in _rootChildren){if(_rootChildren.hasOwnProperty(key)){stack=stack.concat(_rootChildren[key]);}}while(stack.length>0){nodeid=stack[stack.length-1];if(nodeid!=prevParent&&(children=_children[nodeid])!=null){for(index=children.length-1;index>=0;index-=1){stack.push(children[index]);}}else{stack.pop();prevParent=_parents[nodeid];if(onItem.call(thisArg,nodeid,_nodes[nodeid],prevParent,_nodes[prevParent])){break;}}}}}/* parent first - children next */function loopPreOrder(thisArg,onItem){// onItem(nodeid, node, parentid, parent) if function returns true loop exits
	var stack=[],nodeid,key,index,prevParent,children;if(onItem!=null){for(key in _rootChildren){if(_rootChildren.hasOwnProperty(key)){stack=stack.concat(_rootChildren[key]);}}while(stack.length>0){nodeid=stack[stack.length-1];if(nodeid!=prevParent){if(onItem.call(thisArg,nodeid,_nodes[nodeid],prevParent,_nodes[prevParent])){break;}}if(nodeid!=prevParent&&(children=_children[nodeid])!=null){for(index=children.length-1;index>=0;index-=1){stack.push(children[index]);}}else{stack.pop();prevParent=_parents[nodeid];}}}}function zipUp(thisArg,firstNodeId,secondNodeid,onZip){// onZip(firstNodeId, firstParentId, secondNodeid, secondParentId)
	var firstParentId,secondParentId;if(onZip!=null){while(firstNodeId!=null&&secondNodeid!=null&&firstNodeId!=secondNodeid){firstParentId=_parents[firstNodeId];secondParentId=_parents[secondNodeid];if(onZip.call(thisArg,firstNodeId,firstParentId,secondNodeid,secondParentId)){break;}firstNodeId=firstParentId;secondNodeid=secondParentId;}}}function loopParents(thisArg,nodeid,onItem){// onItem(nodeid, node)
	var parentid=nodeid;if(_nodes[parentid]!=null){if(onItem!=null){while((parentid=_parents[parentid])!=null){if(onItem.call(thisArg,parentid,_nodes[parentid])){break;}}}}}function loopChildren(thisArg,nodeid,onItem){// onItem(nodeid, node, index, lastIndex)
	var items,itemid,index,len;if(_nodes[nodeid]!=null){items=_children[nodeid];if(items!=null){for(index=0,len=items.length;index<len;index+=1){itemid=items[index];if(onItem.call(thisArg,itemid,_nodes[itemid],index,len-1)){break;}}}}}function loopChildrenRange(thisArg,nodeid,fromIndex,toIndex,onItem){// onItem(nodeid, node, index)
	var items,itemid,index,len;if(_nodes[nodeid]!=null){items=_children[nodeid];if(items!=null){if(fromIndex<toIndex){fromIndex=Math.max(fromIndex,0);toIndex=Math.min(toIndex,items.length-1);for(index=fromIndex;index<=toIndex;index+=1){itemid=items[index];if(onItem.call(thisArg,itemid,_nodes[itemid],index,len-1)){break;}}}else{fromIndex=Math.min(fromIndex,items.length-1);toIndex=Math.max(0,toIndex);for(index=fromIndex;index>=toIndex;index-=1){itemid=items[index];if(onItem.call(thisArg,itemid,_nodes[itemid],index,len-1)){break;}}}}}}function loopChildrenReversed(thisArg,nodeid,onItem){// onItem(nodeid, node, index, lastIndex)
	var items,itemid,index,lastIndex;if(_nodes[nodeid]!=null){items=_children[nodeid];lastIndex=items.length-1;if(items!=null){for(index=lastIndex;index>=0;index-=1){itemid=items[index];if(onItem.call(thisArg,itemid,_nodes[itemid],index,lastIndex)){break;}}}}}function arrangeChildren(nodeid,children){var childid,index,len;children=children.slice(0);if(_nodes[nodeid]!=null){if(_children[nodeid]!=null){if(_children[nodeid].length==children.length){for(index=0,len=children.length;index<len;index+=1){childid=children[index];if(_parents[childid]!=nodeid){throw"Child "+childid+" does not belong to given node!";}}_children[nodeid]=children;}else{throw"Collections of children don't match each other!";}}else{if(children.length>0){throw"Collections of children don't match each other!";}}}}function add(parentid,nodeid,node,position){var index,len,children,childid;if(_nodes[nodeid]!=null){throw"Node already exists";}if(nodeid!=null&&node!=null&&_nodes[nodeid]==null){if(_nodes[parentid]!=null){_parents[nodeid]=parentid;// existing parent
	if(_children[parentid]!=null){if(position==null){_children[parentid].push(nodeid);}else{_children[parentid].splice(position,0,nodeid);}}else{_children[parentid]=[nodeid];}}else{_roots[nodeid]=parentid;// missing parent
	if(_rootChildren[parentid]!=null){if(position==null){_rootChildren[parentid].push(nodeid);}else{_rootChildren[parentid].splice(position,0,nodeid);}}else{_rootChildren[parentid]=[nodeid];}}_nodes[nodeid]=node;if(_rootChildren[nodeid]!=null){_children[nodeid]=_rootChildren[nodeid];delete _rootChildren[nodeid];children=_children[nodeid];for(index=0,len=children.length;index<len;index+=1){childid=children[index];delete _roots[childid];_parents[childid]=nodeid;}}}}function insert(nodeid,bundleid,bundle){if(_nodes[nodeid]!=null&&bundleid!=null&&_nodes[bundleid]==null&&bundle!=null){_nodes[bundleid]=bundle;if(_children[nodeid]!=null){_children[bundleid]=_children[nodeid];}_children[nodeid]=[bundleid];loopChildren(this,bundleid,function(childid,node,index){_parents[childid]=bundleid;});_parents[bundleid]=nodeid;}}function moveChildren(fromNodeid,toNodeId){if(_nodes[fromNodeid]!=null&&_nodes[toNodeId]!=null&&fromNodeid!=toNodeId){if(_children[fromNodeid]!=null){loopChildren(this,fromNodeid,function(childid,node,index){_parents[childid]=toNodeId;});if(_children[toNodeId]!=null){_children[toNodeId]=_children[toNodeId].concat(_children[fromNodeid]);}else{_children[toNodeId]=_children[fromNodeid];}delete _children[fromNodeid];}}}function hasNodes(){return!primitives.common.isEmptyObject(_rootChildren);}function parentid(nodeid){var result=null;if(_parents[nodeid]!=null){result=_parents[nodeid];}return result;}function parent(nodeid){var result=null;if(_parents[nodeid]!=null){result=_nodes[_parents[nodeid]];}return result;}function hasChildren(nodeid){return _children[nodeid]!=null;}function countChildren(nodeid){return _children[nodeid]!=null?_children[nodeid].length:0;}function countSiblings(nodeid){var parent=parentid(nodeid);return parent!=null?_children[parent].length:0;}function indexOf(nodeid){var parent=parentid(nodeid);return parent!=null?primitives.common.indexOf(_children[parent],nodeid):null;}function getChild(parentid,index){var result=null,children;if((children=_children[parentid])!=null){result=_nodes[children[index]];}return result;}function _splice(collection,nodeid){var index,len=collection.length;for(index=0;index<len;index+=1){if(collection[index]==nodeid){collection.splice(index,1);return len-1;}}return len;}function adopt(parentid,nodeid){if(_nodes[parentid]!=null&&_nodes[nodeid]!=null){if(parentid!=nodeid){if(_roots.hasOwnProperty(nodeid)){if(!_splice(_rootChildren[_roots[nodeid]],nodeid)){delete _rootChildren[_roots[nodeid]];}delete _roots[nodeid];}if(_parents.hasOwnProperty(nodeid)){if(!_splice(_children[_parents[nodeid]],nodeid)){delete _children[_parents[nodeid]];}}_parents[nodeid]=parentid;if(_children[parentid]!=null){_children[parentid].push(nodeid);}else{_children[parentid]=[nodeid];}}else{throw"Item cannot be parent of itself!";}}else{throw"Both parent and child should be in hierarchy!";}}function node(nodeid){return _nodes[nodeid];}function validate(){var result=true,key;for(key in _roots){if(_roots.hasOwnProperty(key)){if(_roots[key]!=null){result=false;break;}}}return result;}function clone(){return primitives.common.family({nodes:_nodes,parents:_parents,children:_children,roots:_roots,rootChildren:_rootChildren});}function loopNeighbours(thisArg,itemid,distance,onItem){var processed={},margin=[itemid],newMargin,currentDistance=0;if(onItem!=null){if(_nodes.hasOwnProperty(itemid)){processed[itemid]=true;while(margin.length>0){newMargin=[];for(var index=0,len=margin.length;index<len;index+=1){var marginid=margin[index];if(currentDistance>0){if(onItem.call(thisArg,marginid,_nodes[marginid],currentDistance)){return;}}if(currentDistance<distance){_loopNeighbours(this,marginid,function(neighbourid,neighbour){if(!processed.hasOwnProperty(neighbourid)){newMargin.push(neighbourid);processed[neighbourid]=true;}});}}margin=newMargin;currentDistance+=1;}}}}function _loopNeighbours(thisArg,itemid,onItem){if(onItem!=null){if(_nodes.hasOwnProperty(itemid)){/* loop parent */var parentItemId=parentid(itemid);if(parentItemId!=null){if(onItem.call(thisArg,parentItemId,_nodes[parentItemId])){return;}}/* loop siblings */loopChildren(thisArg,parentItemId,function(childItemId,childItem){if(childItemId!=itemid){if(onItem.call(thisArg,childItemId,childItem)){return;}}});/* loop actual children */loopChildren(thisArg,itemid,function(childItemId,childItem){if(onItem.call(thisArg,childItemId,childItem)){return;}});}}}return{loop:loop,loopLevels:loopLevels,loopParents:loopParents,loopChildren:loopChildren,loopChildrenRange:loopChildrenRange,loopChildrenReversed:loopChildrenReversed,loopPostOrder:loopPostOrder,/* children first - parent last */loopPreOrder:loopPreOrder,/* parent first - children next */loopNeighbours:loopNeighbours,/* loop items by distance. Siblings are as far as parent and children */zipUp:zipUp,parentid:parentid,parent:parent,adopt:adopt,moveChildren:moveChildren,node:node,add:add,insert:insert,hasNodes:hasNodes,hasChildren:hasChildren,countChildren:countChildren,countSiblings:countSiblings,indexOf:indexOf,getChild:getChild,arrangeChildren:arrangeChildren,/* force validation */validate:validate,clone:clone,// callback return codes
	BREAK:BREAK,// break loop immidiatly
	SKIP:SKIP// skip loop of current node children
	};};/* /algorithms/TreeLevels.js*/primitives.common.TreeLevels=function(source){var _levels=[],_items={},_minimum=null,_maximum=null;_init(source);function _init(source){if(primitives.common.isObject(source)){_levels=primitives.common.cloneObject(source.levels,true);_items=primitives.common.cloneObject(source.items,true);_minimum=primitives.common.cloneObject(source.minimum,true);_maximum=primitives.common.cloneObject(source.maximum,true);}}function LevelContext(context){this.context=context;this.items=[];}function ItemContext(context,position,level){this.context=context;this.position=position;this.level=level;}function isEmpty(){return!_levels.length;}function addLevel(level,context){var treeLevel=createLevel(level);treeLevel.context=context;}function getLevelIndex(itemid){return _items.hasOwnProperty(itemid)?_items[itemid].level:null;}function getItemPosition(itemid){return _items.hasOwnProperty(itemid)?_items[itemid].position:null;}function getItemAtPosition(levelIndex,position){var level=_levels[levelIndex],itemid=null;if(level!=null){itemid=level.items[position];}return itemid;}function getPrevItem(itemid){var result=null;if(_items.hasOwnProperty(itemid)){var item=_items[itemid],level=_levels[item.level];result=level.items[item.position-1];}return result;}function getNextItem(itemid){var result=null;if(_items.hasOwnProperty(itemid)){var item=_items[itemid],level=_levels[item.level];result=level.items[item.position+1];}return result;}function hasItem(itemid){return _items.hasOwnProperty(itemid);}function hasLevel(levelIndex){return _levels[levelIndex]!=null;}function createLevel(index){if(_levels[index]==null){_levels[index]=new LevelContext(null);_minimum=_minimum===null?index:Math.min(_minimum,index);_maximum=_maximum===null?index:Math.max(_maximum,index);}return _levels[index];}function addItem(levelIndex,itemid,context){var level;if(!_items.hasOwnProperty(itemid)){level=createLevel(levelIndex);level.items.push(itemid);_items[itemid]=new ItemContext(context,level.items.length-1,levelIndex);}else{throw"Duplicate item id.";}}function loopLevels(thisArg,onItem){// function onItem(levelIndex, level)
	var index,level;if(onItem!=null){for(index=_minimum;index<=_maximum;index+=1){level=_levels[index];if(level!=null){if(onItem.call(thisArg,index,level.context)){break;}}}}}function loopLevelsReversed(thisArg,onItem){// function onItem(levelIndex, level)
	var index,level;if(onItem!=null){for(index=_maximum;index>=_minimum;index-=1){level=_levels[index];if(level!=null){if(onItem.call(thisArg,index,level.context)){break;}}}}}function getLevelLength(levelIndex){var result=0,level=_levels[levelIndex];if(level!=null){result=level.items.length;}return result;}function loopLevelItems(thisArg,levelIndex,onItem){// function onItem(itemid, item, position)
	var index,len,level,itemid;if(onItem!=null){level=_levels[levelIndex];if(level!=null){for(index=0,len=level.items.length;index<len;index+=1){itemid=level.items[index];if(onItem.call(thisArg,itemid,_items[itemid].context,index)){break;}}}}}function loopItems(thisArg,onItem){// function onItem(itemid, item, position, levelIndex, level)
	var index,len,level,levelIndex,items,itemid;if(onItem!=null){for(levelIndex=_minimum;levelIndex<=_maximum;levelIndex+=1){level=_levels[levelIndex];if(level!=null){items=level.items;for(index=0,len=items.length;index<len;index+=1){itemid=items[index];if(onItem.call(thisArg,itemid,_items[itemid].context,index,levelIndex,level.context)){return;}}}}}}function binarySearch(thisArg,levelIndex,onGetDistance){var result=null,level;if(onGetDistance!=null){level=_levels[levelIndex];if(level!=null){result=primitives.common.binarySearch(level.items,onGetDistance);}}return result;}function loopMerged(thisArg,getItemWeight,onItem){var index,len,level,itemid,levelsItems=[],sortedItems;for(index=0,len=_levels.length;index<len;index+=1){level=_levels[index];levelsItems.push(level.items);}sortedItems=primitives.common.mergeSort(levelsItems,getItemWeight);if(onItem!=null){for(index=0,len=sortedItems.length;index<len;index+=1){itemid=sortedItems[index];if(onItem.call(thisArg,itemid,_items[itemid].context)){break;}}}}function loopFromItem(thisArg,itemid,isLeft,onItem){var context,index,len,items,nextItemId;if(_items.hasOwnProperty(itemid)){context=_items[itemid];items=_levels[context.level].items;if(onItem!=null){if(isLeft){for(index=context.position-1;index>=0;index-=1){nextItemId=items[index];if(onItem.call(thisArg,nextItemId,_items[nextItemId].context)){break;}}}else{for(index=context.position+1,len=items.length;index<len;index+=1){nextItemId=items[index];if(onItem.call(thisArg,nextItemId,_items[nextItemId].context)){break;}}}}}}function loopLevelsFromItem(thisArg,itemid,isBelow,onItem){// function(levelIndex, level)
	var context,index,len,items,item,nextItemId,nextLevels;if(_items.hasOwnProperty(itemid)){context=_items[itemid];if(onItem!=null){if(isBelow){for(index=context.level+1;index<=_maximum;index+=1){if(onItem.call(thisArg,index,_levels[index].context)){break;}}}else{for(index=context.level-1;index>=_minimum;index-=1){if(onItem.call(thisArg,index,_levels[index].context)){break;}}}}}}function clone(){return primitives.common.family({levels:_levels,items:_items,minimum:_minimum,maximum:_maximum});}return{addlevel:addLevel,hasLevel:hasLevel,hasItem:hasItem,addItem:addItem,getLevelIndex:getLevelIndex,getItemPosition:getItemPosition,getItemAtPosition:getItemAtPosition,loopLevels:loopLevels,loopLevelsReversed:loopLevelsReversed,loopLevelItems:loopLevelItems,getLevelLength:getLevelLength,loopItems:loopItems,binarySearch:binarySearch,loopMerged:loopMerged,loopFromItem:loopFromItem,loopLevelsFromItem:loopLevelsFromItem,getPrevItem:getPrevItem,getNextItem:getNextItem,isEmpty:isEmpty,clone:clone};};/* /Managers/DependencyManager.js*/primitives.common.DependencyManager=function(){var hash={};function register(key,value){hash[key]=value;return value;}function resolve(){var args=[],deps=arguments[0],func=arguments[1],scope=arguments[2]||{};return function(){var a=Array.prototype.slice.call(arguments,0);for(var i=0;i<deps.length;i+=1){var d=deps[i];args.push(hash[d]&&d!==''?hash[d]:a.shift());}args=args.concat(a);return func.apply(scope||{},args);};}return{register:register,resolve:resolve};};/* /Managers/TaskInfo.js*/primitives.common.TaskInfo=function(name,dependencies,factory,color){this.name=name;this.dependencies=dependencies;this.factory=factory;this.task=null;this.color=color;};/* /Managers/TaskManager.js*/primitives.common.TaskManager=function(){var _taskFamily=new primitives.common.family();var _dependencies=new primitives.common.DependencyManager();var _tasks=[];function addTask(taskName,taskDependencies,factory,color){if(_tasks.length>0){throw"Task Manager is already initialized";}_taskFamily.add(taskDependencies,taskName,new primitives.common.TaskInfo(taskName,taskDependencies,factory,color));}function getTask(taskName){var taskInfo=_taskFamily.node(taskName);return taskInfo&&taskInfo.task;}function addDependency(name,dependency){if(_tasks.length>0){throw"Task Manager is already initialized";}_dependencies.register(name,dependency);}function process(startTask,stopTask,debug){var hasChanges=false,logtime=debug;if(_tasks.length===0){_taskFamily.loopTopo(this,function(taskName,taskInfo){taskInfo.task=_dependencies.register(taskName,_dependencies.resolve(taskInfo.dependencies,taskInfo.factory)());_tasks.push(taskInfo);});}if(debug){console.log("-- process --");}var isRequired={};for(var index=0,len=_tasks.length;index<len;index+=1){var taskInfo=_tasks[index],dependents=[];if(taskInfo.name==startTask||isRequired.hasOwnProperty(taskInfo.name)){if(logtime){var startAt=performance.now();}if(hasChanges=taskInfo.task.process(debug)){_taskFamily.loopChildren(this,taskInfo.name,function(childTaskName,childTaskInfo){isRequired[childTaskName]=true;if(debug){dependents.push(childTaskName);}return _taskFamily.SKIP;});}if(logtime){var endAt=performance.now();}if(debug){var spentTime=Math.round(endAt-startAt,2);console.log(index+". "+taskInfo.name+(", "+spentTime+" ms. ")+(hasChanges?" - forces: "+dependents.toString():""));}}if(taskInfo.name==stopTask){return;}}}function getProcessDiagramConfig(){var result=new primitives.famdiagram.Config();if(_tasks.length===0){_taskFamily.loopTopo(this,function(taskName,taskInfo){taskInfo.task=_dependencies.register(taskName,_dependencies.resolve(taskInfo.dependencies,taskInfo.factory)());_tasks.push(taskInfo);});}for(var index=0,len=_tasks.length;index<len;index+=1){var taskInfo=_tasks[index];var itemConfig=new primitives.famdiagram.ItemConfig();itemConfig.id=taskInfo.name;itemConfig.title=primitives.common.splitCamelCaseName(taskInfo.name).join(" ");itemConfig.description=taskInfo.task.description||"";itemConfig.itemTitleColor=taskInfo.color;itemConfig.parents=[];_taskFamily.loopParents(this,taskInfo.name,function(parentTaskName,parentTaskInfo){itemConfig.parents.push(parentTaskName);return _taskFamily.SKIP;});result.items.push(itemConfig);}return result;}return{addTask:addTask,addDependency:addDependency,getTask:getTask,process:process,getProcessDiagramConfig:getProcessDiagramConfig};};/* /pdf/graphics/graphics.js*/primitives.pdf.graphics=function(doc){this._doc=doc,this._context=this._doc;this._dummyPlaceholder=new primitives.common.Placeholder();};primitives.pdf.graphics.prototype.clean=function(){};primitives.pdf.graphics.prototype.resize=function(name,width,height){};primitives.pdf.graphics.prototype.begin=function(){};primitives.pdf.graphics.prototype.end=function(){};primitives.pdf.graphics.prototype.reset=function(arg0,arg1){};primitives.pdf.graphics.prototype.activate=function(arg0,arg1){return this._dummyPlaceholder;};primitives.pdf.graphics.prototype.text=function(x,y,width,height,label,orientation,horizontalAlignment,verticalAlignment,attr){};primitives.pdf.graphics.prototype.polylinesBuffer=function(buffer){buffer.loop(this,function(polyline){if(polyline.length()>0){this.polyline(polyline);}});};primitives.pdf.graphics.prototype.polyline=function(polylineData){var placeholder=this.m_activePlaceholder,attr=polylineData.paletteItem.toAttr(),step,cornerRadius,doc=this._doc;doc.save();polylineData.loop(this,function(segment){switch(segment.segmentType){case 1/*primitives.common.SegmentType.Move*/:doc.moveTo(Math.round(segment.x)+0.5,Math.round(segment.y)+0.5);break;case 0/*primitives.common.SegmentType.Line*/:doc.lineTo(Math.round(segment.x)+0.5,Math.round(segment.y)+0.5);break;case 4/*primitives.common.SegmentType.Dot*/:if(segment.width==segment.height&&segment.width/2.0<=segment.cornerRadius){// circle dot
	doc.roundedRect(Math.round(segment.x)+0.5,Math.round(segment.y)+0.5,segment.width,segment.height,Math.min(segment.width,segment.height)/2.0);}else if(segment.cornerRadius===0){// square
	doc.moveTo(Math.round(segment.x)+0.5,Math.round(segment.y)+0.5);doc.lineTo(Math.round(segment.x+segment.width)+0.5,Math.round(segment.y)+0.5);doc.lineTo(Math.round(segment.x+segment.width)+0.5,Math.round(segment.y+segment.height)+0.5);doc.lineTo(Math.round(segment.x)+0.5,Math.round(segment.y+segment.height)+0.5);doc.lineTo(Math.round(segment.x)+0.5,Math.round(segment.y)+0.5);}else{// rounded corners rectangle
	cornerRadius=Math.min(segment.cornerRadius,Math.min(segment.width/2.0,segment.height/2.0));doc.roundedRect(Math.round(segment.x)+0.5,Math.round(segment.y)+0.5,segment.width,segment.height,cornerRadius);}break;case 2/*primitives.common.SegmentType.QuadraticArc*/:doc.quadraticCurveTo(Math.round(segment.cpX)+0.5,Math.round(segment.cpY)+0.5,Math.round(segment.x)+0.5,Math.round(segment.y)+0.5);break;case 3/*primitives.common.SegmentType.CubicArc*/:doc.bezierCurveTo(Math.round(segment.cpX1)+0.5,Math.round(segment.cpY1)+0.5,Math.round(segment.cpX2)+0.5,Math.round(segment.cpY2)+0.5,Math.round(segment.x)+0.5,Math.round(segment.y)+0.5);break;}});doc.lineJoin('round');if(attr.lineType!=null){step=Math.round(attr.lineWidth)||1;switch(attr.lineType){case 0/*primitives.common.LineType.Solid*/:break;case 1/*primitives.common.LineType.Dotted*/:doc.dash(step,step*2);break;case 2/*primitives.common.LineType.Dashed*/:doc.dash(step*5,step*3);break;}}if(attr.lineWidth!==undefined&&attr.fillColor!==undefined){doc.lineWidth(attr.lineWidth).fillOpacity(attr.opacity).fillAndStroke(attr.fillColor,attr.borderColor);}else if(attr.lineWidth!==undefined){doc.lineWidth(attr.lineWidth).stroke(attr.borderColor);}else if(attr.fillColor!==undefined){doc.fillOpacity(attr.opacity).fillColor(attr.fillColor);}doc.restore();};primitives.pdf.graphics.prototype.rightAngleLine=function(fromX,fromY,toX,toY,attr){};primitives.pdf.graphics.prototype.template=function(x,y,width,height,contentx,contenty,contentWidth,contentHeight,template,hashCode,onRenderTemplate,uiHash,attr){//ignore jslint
	var gap=0;if(attr!==null){if(attr["border-width"]!==undefined){gap=this.getPxSize(attr["border-width"]);}}var position=new primitives.common.Rect(x+contentx,y+contenty,contentWidth-gap,contentHeight-gap);if(uiHash==null){uiHash=new primitives.common.RenderEventArgs();}if(onRenderTemplate!==null){onRenderTemplate(this._doc,position,uiHash);}};primitives.pdf.graphics.prototype.getPxSize=function(value,base){var result=value;if(typeof value==="string"){if(value.indexOf("pt")>0){result=parseInt(value,10)*96/72;}else if(value.indexOf("%")>0){result=parseFloat(value)/100.0*base;}else{result=parseInt(value,10);}}return result;};/* /pdf/FamDiagram/Plugin.js*/primitives.pdf.famdiagram.Plugin=function(options){var _data={name:"famdiagram",doc:null,options:options,tasks:null,graphics:null},_scale,_debug=false;function getOptions(){return _data.options;}function getGraphics(){return _data.graphics;}function createTaskManager(){var tasks=new primitives.common.TaskManager();// Dependencies
	tasks.addDependency('options',getOptions);tasks.addDependency('graphics',getGraphics);tasks.addDependency('defaultConfig',new primitives.famdiagram.Config());tasks.addDependency('defaultItemConfig',new primitives.famdiagram.ItemConfig());tasks.addDependency('defaultTemplateConfig',new primitives.famdiagram.TemplateConfig());tasks.addDependency('defaultButtonConfig',new primitives.famdiagram.ButtonConfig());tasks.addDependency('defaultPaletteItemConfig',new primitives.famdiagram.PaletteItemConfig());tasks.addDependency('defaultBackgroundAnnotationConfig',new primitives.famdiagram.BackgroundAnnotationConfig());tasks.addDependency('defaultConnectorAnnotationConfig',new primitives.famdiagram.ConnectorAnnotationConfig());tasks.addDependency('defaultHighlightPathAnnotationConfig',new primitives.famdiagram.HighlightPathAnnotationConfig());tasks.addDependency('defaultShapeAnnotationConfig',new primitives.famdiagram.ShapeAnnotationConfig());tasks.addDependency('defaultLabelAnnotationConfig',new primitives.famdiagram.LabelAnnotationConfig());tasks.addDependency('isFamilyChartMode',true);/* in regular org diagram we hide branch if it contains only invisible nodes,
			in the family chart we use invisible items to draw connectors across multiple levels */tasks.addDependency('showElbowDots',true);/* in regular org chart we don;t have situations when connector lines cross, but we have such situations in
			family tree so we need extra visual attribute to distinguish intersections betwen connectors */tasks.addDependency('null',null);tasks.addDependency('foreground',2/*primitives.common.ZOrderType.Foreground*/);tasks.addDependency('background',1/*primitives.common.ZOrderType.Background*/);// Options
	tasks.addTask('OptionsTask',['options'],primitives.famdiagram.OptionsTask,"#000000"/*primitives.common.Colors.Black*/);tasks.addTask('CalloutOptionTask',['OptionsTask','defaultConfig','defaultItemConfig'],primitives.orgdiagram.CalloutOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ConnectorsOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.ConnectorsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ItemsOptionTask',['OptionsTask','defaultItemConfig'],primitives.famdiagram.ItemsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('SpousesOptionTask',['OptionsTask','defaultItemConfig'],primitives.famdiagram.SpousesOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ItemsSizesOptionTask',['OptionsTask','defaultConfig','defaultItemConfig','defaultButtonConfig'],primitives.orgdiagram.ItemsSizesOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('PrintPreviewOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.PrintPreviewOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('TemplatesOptionTask',['OptionsTask','defaultConfig','defaultButtonConfig','defaultTemplateConfig'],primitives.orgdiagram.TemplatesOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('OrientationOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.OrientationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('VisualTreeOptionTask',['OptionsTask'],primitives.famdiagram.VisualTreeOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('NormalizeOptionTask',['OptionsTask','defaultConfig'],primitives.famdiagram.NormalizeOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('LinePaletteOptionTask',['OptionsTask','defaultPaletteItemConfig'],primitives.famdiagram.LinePaletteOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('CursorItemOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.CursorItemOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('HighlightItemOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.HighlightItemOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('SelectedItemsOptionTask',['OptionsTask'],primitives.orgdiagram.SelectedItemsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('SplitAnnotationsOptionTask',['OptionsTask'],primitives.orgdiagram.SplitAnnotationsOptionTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ForegroundShapeAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultShapeAnnotationConfig','foreground'],primitives.orgdiagram.ShapeAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundShapeAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultShapeAnnotationConfig','background'],primitives.orgdiagram.ShapeAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ForegroundHighlightPathAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultHighlightPathAnnotationConfig','foreground'],primitives.orgdiagram.HighlightPathAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundHighlightPathAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultHighlightPathAnnotationConfig','background'],primitives.orgdiagram.HighlightPathAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ForegroundConnectorAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultConnectorAnnotationConfig','foreground'],primitives.orgdiagram.ConnectorAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundConnectorAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultConnectorAnnotationConfig','background'],primitives.orgdiagram.ConnectorAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultBackgroundAnnotationConfig'],primitives.orgdiagram.BackgroundAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ScaleOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.ScaleOptionTask,"#000080"/*primitives.common.Colors.Navy*/);// Transformations
	tasks.addTask('IntervalsTask',['ItemsSizesOptionTask'],primitives.orgdiagram.IntervalsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('LogicalFamilyTask',['ItemsOptionTask'],primitives.famdiagram.LogicalFamilyTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('LabelAnnotationOptionTask',['SplitAnnotationsOptionTask','LogicalFamilyTask','defaultLabelAnnotationConfig'],primitives.famdiagram.LabelAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('LabelAnnotationTemplateOptionTask',['LabelAnnotationOptionTask','defaultLabelAnnotationConfig'],primitives.famdiagram.LabelAnnotationTemplateOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('LabelAnnotationPlacementOptionTask',['LabelAnnotationOptionTask','defaultLabelAnnotationConfig'],primitives.famdiagram.LabelAnnotationPlacementOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('CombinedContextsTask',['ItemsOptionTask','LabelAnnotationOptionTask'],primitives.orgdiagram.CombinedContextsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('AddLabelAnnotationsTask',['LabelAnnotationPlacementOptionTask','LogicalFamilyTask'],primitives.famdiagram.AddLabelAnnotationsTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('RemoveLoopsTask',['ItemsOptionTask','AddLabelAnnotationsTask'],primitives.famdiagram.RemoveLoopsTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('AddSpousesTask',['SpousesOptionTask','RemoveLoopsTask'],primitives.famdiagram.AddSpousesTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('NormalizeLogicalFamilyTask',['NormalizeOptionTask','AddSpousesTask'],primitives.famdiagram.NormalizeLogicalFamilyTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('LevelsTask',['NormalizeLogicalFamilyTask','defaultItemConfig','CombinedTemplateParamsTask'],primitives.famdiagram.LevelsTask,"#ff0000"/*primitives.common.Colors.Red*/);// Transformations / Templates
	tasks.addTask('ReadTemplatesTask',['TemplatesOptionTask'],primitives.pdf.orgdiagram.ReadTemplatesTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ItemTemplateParamsTask',['ItemsSizesOptionTask','CursorItemOptionTask','ReadTemplatesTask'],primitives.orgdiagram.ItemTemplateParamsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('LabelAnnotationTemplateParamsTask',['ItemsSizesOptionTask','LabelAnnotationTemplateOptionTask','ReadTemplatesTask'],primitives.famdiagram.LabelAnnotationTemplateParamsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CombinedTemplateParamsTask',['ItemTemplateParamsTask','LabelAnnotationTemplateParamsTask'],primitives.famdiagram.CombinedTemplateParamsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('GroupTitleTemplateTask',['TemplatesOptionTask'],primitives.pdf.orgdiagram.GroupTitleTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CheckBoxTemplateTask',['ItemsSizesOptionTask'],primitives.pdf.orgdiagram.CheckBoxTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ButtonsTemplateTask',['ItemsSizesOptionTask'],primitives.pdf.orgdiagram.ButtonsTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('AnnotationLabelTemplateTask',['ItemsOptionTask'],primitives.pdf.orgdiagram.AnnotationLabelTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('PrintPreviewTemplateTask',['ItemsOptionTask'],primitives.pdf.orgdiagram.PrintPreviewTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ConnectionsGraphTask',['graphics','CreateTransformTask','ConnectorsOptionTask','LevelsTask','AlignDiagramTask'],primitives.orgdiagram.ConnectionsGraphTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Transformations/Selections
	tasks.addTask('HighlightItemTask',['HighlightItemOptionTask','LevelsTask'],primitives.orgdiagram.HighlightItemTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CursorItemTask',['CursorItemOptionTask','LevelsTask'],primitives.orgdiagram.CursorItemTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('SelectedItemsTask',['SelectedItemsOptionTask'],primitives.orgdiagram.SelectedItemsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CombinedNormalVisibilityItemsTask',['OptionsTask'],primitives.pdf.orgdiagram.DummyCombinedNormalVisibilityItemsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CurrentControlSizeTask',['OptionsTask'],primitives.pdf.orgdiagram.DummyCurrentControlSizeTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ItemsPositionsTask',['CurrentControlSizeTask','ScaleOptionTask','OrientationOptionTask','ItemsSizesOptionTask','ConnectorsOptionTask','VisualTreeOptionTask','NormalizeLogicalFamilyTask','LevelsTask','IntervalsTask','CombinedTemplateParamsTask','CursorItemTask','CombinedNormalVisibilityItemsTask'],primitives.famdiagram.ItemsPositionsTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('AlignDiagramTask',['OrientationOptionTask','ItemsSizesOptionTask','VisualTreeOptionTask','ScaleOptionTask','PrintPreviewOptionTask','CurrentControlSizeTask','LevelsTask','ItemsPositionsTask','isFamilyChartMode'],primitives.orgdiagram.AlignDiagramTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('CreateTransformTask',['OrientationOptionTask','AlignDiagramTask'],primitives.orgdiagram.CreateTransformTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Managers
	tasks.addTask('BackgroundAnnotationManagerTask',['ItemsSizesOptionTask','LevelsTask','AlignDiagramTask'],primitives.orgdiagram.BackgroundAnnotationManagerTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('PaletteManagerTask',['ConnectorsOptionTask','LinePaletteOptionTask'],primitives.orgdiagram.PaletteManagerTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Renders
	tasks.addTask('DrawBackgroundAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','BackgroundAnnotationOptionTask','AddLabelAnnotationsTask','AlignDiagramTask','BackgroundAnnotationManagerTask'],primitives.orgdiagram.DrawBackgroundAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawBackgroundShapeAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','BackgroundShapeAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','background','DrawBackgroundAnnotationTask'],primitives.orgdiagram.DrawShapeAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawBackgroundConnectorAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','BackgroundConnectorAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','background','DrawBackgroundShapeAnnotationTask'],primitives.orgdiagram.DrawConnectorAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawBackgroundHighlightPathAnnotationTask',['graphics','ConnectorsOptionTask','ForegroundHighlightPathAnnotationOptionTask','ConnectionsGraphTask','foreground','DrawBackgroundConnectorAnnotationTask'],primitives.orgdiagram.DrawHighlightPathAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('DrawConnectorsTask',['graphics','ConnectionsGraphTask','ConnectorsOptionTask','showElbowDots','PaletteManagerTask','DrawBackgroundHighlightPathAnnotationTask'],primitives.orgdiagram.DrawConnectorsTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawForegroundHighlightPathAnnotationTask',['graphics','ConnectorsOptionTask','BackgroundHighlightPathAnnotationOptionTask','ConnectionsGraphTask','background','DrawConnectorsTask'],primitives.orgdiagram.DrawHighlightPathAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('DrawTreeItemsTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','ItemsSizesOptionTask','CombinedContextsTask','AlignDiagramTask','CombinedTemplateParamsTask','CursorItemTask','SelectedItemsTask','GroupTitleTemplateTask','CheckBoxTemplateTask','ButtonsTemplateTask','DrawForegroundHighlightPathAnnotationTask'],primitives.orgdiagram.DrawTreeItemsTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawCursorTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','CombinedContextsTask','AlignDiagramTask','CombinedTemplateParamsTask','CursorItemTask','SelectedItemsTask','DrawTreeItemsTask'],primitives.orgdiagram.DrawCursorTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawHighlightTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','CombinedContextsTask','AlignDiagramTask','CombinedTemplateParamsTask','HighlightItemTask','CursorItemTask','SelectedItemsTask','DrawCursorTask'],primitives.orgdiagram.DrawHighlightTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawForegroundShapeAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','ForegroundShapeAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','foreground','DrawHighlightTask'],primitives.orgdiagram.DrawShapeAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawForegroundConnectorAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','ForegroundConnectorAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','foreground','DrawForegroundShapeAnnotationTask'],primitives.orgdiagram.DrawConnectorAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawPrintPreviewTask',['graphics','ApplyLayoutChangesTask','PrintPreviewOptionTask','AlignDiagramTask','PrintPreviewTemplateTask','ScaleOptionTask','DrawForegroundConnectorAnnotationTask'],primitives.orgdiagram.DrawPrintPreviewTask,"#008000"/*primitives.common.Colors.Green*/);return tasks;}function createEventArgs(data,oldTreeItemId,newTreeItemId,name){var result=new primitives.famdiagram.EventArgs(),combinedContextsTask=data.tasks.getTask("CombinedContextsTask"),alignDiagramTask=data.tasks.getTask("AlignDiagramTask"),navigationFamilyTask=data.tasks.getTask("AddLabelAnnotationsTask"),oldItemConfig=combinedContextsTask.getConfig(oldTreeItemId),newItemConfig=combinedContextsTask.getConfig(newTreeItemId),navigationFamily=navigationFamilyTask.getNavigationFamily(),itemPosition;if(oldItemConfig&&oldItemConfig.id!=null){result.oldContext=oldItemConfig;}if(newItemConfig&&newItemConfig.id!=null){result.context=newItemConfig;navigationFamily.loopParents(this,newItemConfig.id,function(itemid,item,levelIndex){if(levelIndex>0){return navigationFamily.BREAK;}result.parentItems.push(combinedContextsTask.getConfig(itemid));});itemPosition=alignDiagramTask.getItemPosition(newTreeItemId);result.position=new primitives.common.Rect(itemPosition.actualPosition);}if(name!=null){result.name=name;}return result;}function trigger(eventHandlerName,event,eventArgs){var eventHandler=_data.options[eventHandlerName];if(eventHandler!=null){eventHandler(event,eventArgs);}}function _disableNotAvailableFunctionality(){/* disable functionality not available in PDF */_data.options.hasButtons=2/*primitives.common.Enabled.False*/;_data.options.pageFitMode=5/*primitives.common.PageFitMode.AutoSize*/;_data.options.autoSizeMaximum=new primitives.common.Size(100000,100000);}function draw(doc,positionX,positionY){_data.doc=doc;_data.tasks=createTaskManager(getOptions,getGraphics);_data.graphics=new primitives.pdf.graphics(_data.doc);_data.graphics.debug=_debug;_disableNotAvailableFunctionality();_data.doc.save();_data.doc.translate(positionX,positionY);_data.tasks.process('OptionsTask',null,_debug);_data.doc.restore();var alignDiagramTask=_data.tasks.getTask("AlignDiagramTask");return new primitives.common.Size(alignDiagramTask.getContentSize());}function getSize(){_data.tasks=createTaskManager(getOptions,getGraphics);_disableNotAvailableFunctionality();_data.tasks.process('OptionsTask','AlignDiagramTask',_debug);var alignDiagramTask=_data.tasks.getTask("AlignDiagramTask");return new primitives.common.Size(alignDiagramTask.getContentSize());}return{draw:draw,getSize:getSize};};/* /pdf/Models/Template.js*/primitives.pdf.Template=function(options,templateConfig){this.templateConfig=null;this.itemTemplate=null;this.highlightTemplate=null;this.dotHighlightTemplate=null;this.cursorTemplate=null;if(templateConfig!=null){this.templateConfig=templateConfig;this.itemTemplate=primitives.common.isNullOrEmpty(templateConfig.itemTemplate)?new primitives.pdf.ItemTemplate(options,templateConfig):new primitives.pdf.UserTemplate(options,templateConfig,options.onItemRender);this.highlightTemplate=primitives.common.isNullOrEmpty(templateConfig.highlightTemplate)?new primitives.pdf.HighlightTemplate(options,templateConfig):new primitives.pdf.UserTemplate(options,templateConfig,options.onHighlightRender);this.dotHighlightTemplate=new primitives.pdf.DummyTemplate(options,templateConfig);this.cursorTemplate=primitives.common.isNullOrEmpty(templateConfig.cursorTemplate)?new primitives.pdf.CursorTemplate(options,templateConfig):new primitives.pdf.UserTemplate(options,templateConfig,options.onCursorRender);}};/* /pdf/OrgDiagram/Tasks/Layout/DummyCurrentControlSizeTask.js*/primitives.pdf.orgdiagram.DummyCurrentControlSizeTask=function(optionsTask){function process(){return true;}function getScrollPanelSize(){return new primitives.common.Size(800,600);}function getOptimalPanelSize(){return new primitives.common.Size(800-25,600-25);}return{process:process,getScrollPanelSize:getScrollPanelSize,getOptimalPanelSize:getOptimalPanelSize};};/* /pdf/OrgDiagram/Tasks/Templates/AnnotationLabelTemplateTask.js*/primitives.pdf.orgdiagram.AnnotationLabelTemplateTask=function(itemsSizesOptionTask){var _data={template:null};function process(){return false;}function getTemplate(){if(_data.template==null){_data.template=new primitives.pdf.AnnotationLabelTemplate();}return _data.template;}return{process:process,getTemplate:getTemplate};};/* /pdf/OrgDiagram/Tasks/Templates/ButtonsTemplateTask.js*/primitives.pdf.orgdiagram.ButtonsTemplateTask=function(itemsSizesOptionTask){var _data={template:null};function process(){return false;}function getTemplate(){if(_data.template==null){_data.template=new primitives.pdf.DummyTemplate();}return _data.template;}return{process:process,getTemplate:getTemplate};};/* /pdf/OrgDiagram/Tasks/Templates/CheckboxTemplateTask.js*/primitives.pdf.orgdiagram.CheckBoxTemplateTask=function(itemsSizesOptionTask){var _data={template:null};function process(){_data.template=null;return true;}function getTemplate(){var options;if(_data.template==null){options=itemsSizesOptionTask.getOptions();_data.template=new primitives.pdf.CheckBoxTemplate(options.selectCheckBoxLabel);}return _data.template;}return{process:process,getTemplate:getTemplate};};/* /pdf/OrgDiagram/Tasks/Templates/GroupTitleTemplateTask.js*/primitives.pdf.orgdiagram.GroupTitleTemplateTask=function(templatesOptionTask){var _data={template:null};function process(){_data.template=null;return true;}function getTemplate(){var options;if(_data.template==null){options=templatesOptionTask.getOptions();_data.template=new primitives.pdf.GroupTitleTemplate(options.itemTitleFirstFontColor,options.itemTitleSecondFontColor);}return _data.template;}return{process:process,getTemplate:getTemplate};};/* /pdf/OrgDiagram/Tasks/Templates/PrintPreviewTemplateTask.js*/primitives.pdf.orgdiagram.PrintPreviewTemplateTask=function(itemsSizesOptionTask){var _data={template:null};function process(){return false;}function getTemplate(){if(_data.template==null){_data.template=new primitives.pdf.PrintPreviewTemplate();}return _data.template;}return{process:process,getTemplate:getTemplate};};/* /pdf/OrgDiagram/Tasks/Templates/ReadTemplatesTask.js*/primitives.pdf.orgdiagram.ReadTemplatesTask=function(templatesOptionTask){var _data={templates:{}},_defaultWidgetTemplateName="DefaultWidgetTemplate",_defaultWidgetLabelAnnotationTemplateName="DefaultWidgetLabelAnnotationTemplate";function process(){var index,len,templateConfig,templatesOptions=templatesOptionTask.getOptions(),templates=templatesOptions.templates;_data.templates={};_data.templates[_defaultWidgetTemplateName]=new primitives.pdf.Template(templatesOptions,new primitives.orgdiagram.TemplateConfig());var labelAnnotationTemplateConfig=new primitives.orgdiagram.TemplateConfig();labelAnnotationTemplateConfig.name=_defaultWidgetLabelAnnotationTemplateName;labelAnnotationTemplateConfig.isActive=false;labelAnnotationTemplateConfig.itemSize=new primitives.common.Size(100,20);labelAnnotationTemplateConfig.minimizedItemSize=new primitives.common.Size(0,0);var labelAnnotationTemplate=new primitives.pdf.Template();labelAnnotationTemplate.templateConfig=labelAnnotationTemplateConfig;labelAnnotationTemplate.minimizedItemCornerRadius=labelAnnotationTemplateConfig.minimizedItemSize.width/2;labelAnnotationTemplate.itemTemplate=new primitives.pdf.LabelAnnotationTemplate();labelAnnotationTemplate.dotHighlightTemplate=new primitives.pdf.DummyTemplate();_data.templates[_defaultWidgetLabelAnnotationTemplateName]=labelAnnotationTemplate;for(index=0,len=templates.length;index<len;index+=1){templateConfig=templates[index];_data.templates[templateConfig.name]=new primitives.pdf.Template(templatesOptions,templateConfig);}return true;}function getTemplate(templateName1,templateName2,templateName3){var result=_data.templates[templateName1]||_data.templates[templateName2]||_data.templates[templateName3];return result;}return{process:process,getTemplate:getTemplate,DefaultWidgetTemplateName:_defaultWidgetTemplateName,DefaultWidgetLabelAnnotationTemplateName:_defaultWidgetLabelAnnotationTemplateName};};/* /pdf/OrgDiagram/Tasks/Transformations/Selection/DummyCombinedNormalVisibilityItemsTask.js*/primitives.pdf.orgdiagram.DummyCombinedNormalVisibilityItemsTask=function(optionsTask){function process(){return true;}function isItemSelected(treeItem){return false;}return{process:process,isItemSelected:isItemSelected};};/* /pdf/OrgDiagram/Plugin.js*/primitives.pdf.orgdiagram.Plugin=function(options){var _data={name:"orgdiagram",doc:null,options:options,tasks:null,graphics:null},_scale,_debug=false;function getOptions(){return _data.options;}function getGraphics(){return _data.graphics;}function createTaskManager(){var tasks=new primitives.common.TaskManager();// Dependencies
	tasks.addDependency('options',getOptions);tasks.addDependency('graphics',getGraphics);tasks.addDependency('defaultConfig',new primitives.orgdiagram.Config());tasks.addDependency('defaultItemConfig',new primitives.orgdiagram.ItemConfig());tasks.addDependency('defaultTemplateConfig',new primitives.orgdiagram.TemplateConfig());tasks.addDependency('defaultButtonConfig',new primitives.orgdiagram.ButtonConfig());tasks.addDependency('defaultBackgroundAnnotationConfig',new primitives.orgdiagram.BackgroundAnnotationConfig());tasks.addDependency('defaultConnectorAnnotationConfig',new primitives.orgdiagram.ConnectorAnnotationConfig());tasks.addDependency('defaultHighlightPathAnnotationConfig',new primitives.orgdiagram.HighlightPathAnnotationConfig());tasks.addDependency('defaultShapeAnnotationConfig',new primitives.orgdiagram.ShapeAnnotationConfig());tasks.addDependency('isFamilyChartMode',false);tasks.addDependency('showElbowDots',false);tasks.addDependency('null',null);tasks.addDependency('foreground',2/*primitives.common.ZOrderType.Foreground*/);tasks.addDependency('background',1/*primitives.common.ZOrderType.Background*/);// Options
	tasks.addTask('OptionsTask',['options'],primitives.orgdiagram.OptionsTask,"#000000"/*primitives.common.Colors.Black*/);tasks.addTask('CalloutOptionTask',['OptionsTask','defaultConfig','defaultItemConfig'],primitives.orgdiagram.CalloutOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ConnectorsOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.ConnectorsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ItemsOptionTask',['OptionsTask','defaultItemConfig'],primitives.orgdiagram.ItemsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ItemsSizesOptionTask',['OptionsTask','defaultConfig','defaultItemConfig','defaultButtonConfig'],primitives.orgdiagram.ItemsSizesOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('PrintPreviewOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.PrintPreviewOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('TemplatesOptionTask',['OptionsTask','defaultConfig','defaultButtonConfig','defaultTemplateConfig'],primitives.orgdiagram.TemplatesOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('OrientationOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.OrientationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('VisualTreeOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.VisualTreeOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('CursorItemOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.CursorItemOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('HighlightItemOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.HighlightItemOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('SelectedItemsOptionTask',['OptionsTask'],primitives.orgdiagram.SelectedItemsOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('SplitAnnotationsOptionTask',['OptionsTask'],primitives.orgdiagram.SplitAnnotationsOptionTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ForegroundShapeAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultShapeAnnotationConfig','foreground'],primitives.orgdiagram.ShapeAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundShapeAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultShapeAnnotationConfig','background'],primitives.orgdiagram.ShapeAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ForegroundHighlightPathAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultHighlightPathAnnotationConfig','foreground'],primitives.orgdiagram.HighlightPathAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundHighlightPathAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultHighlightPathAnnotationConfig','background'],primitives.orgdiagram.HighlightPathAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ForegroundConnectorAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultConnectorAnnotationConfig','foreground'],primitives.orgdiagram.ConnectorAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundConnectorAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultConnectorAnnotationConfig','background'],primitives.orgdiagram.ConnectorAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('BackgroundAnnotationOptionTask',['SplitAnnotationsOptionTask','defaultBackgroundAnnotationConfig'],primitives.orgdiagram.BackgroundAnnotationOptionTask,"#000080"/*primitives.common.Colors.Navy*/);tasks.addTask('ScaleOptionTask',['OptionsTask','defaultConfig'],primitives.orgdiagram.ScaleOptionTask,"#000080"/*primitives.common.Colors.Navy*/);// Transformations
	tasks.addTask('CombinedContextsTask',['ItemsOptionTask'],primitives.orgdiagram.CombinedContextsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('IntervalsTask',['ItemsSizesOptionTask'],primitives.orgdiagram.IntervalsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('OrgTreeTask',['ItemsOptionTask'],primitives.orgdiagram.OrgTreeTask,"#ff0000"/*primitives.common.Colors.Red*/);// Transformations / Templates
	tasks.addTask('ReadTemplatesTask',['TemplatesOptionTask'],primitives.pdf.orgdiagram.ReadTemplatesTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// TODO: Add jsPDF templates
	tasks.addTask('ItemTemplateParamsTask',['ItemsSizesOptionTask','CursorItemOptionTask','ReadTemplatesTask'],primitives.orgdiagram.ItemTemplateParamsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('GroupTitleTemplateTask',['TemplatesOptionTask'],primitives.pdf.orgdiagram.GroupTitleTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CheckBoxTemplateTask',['ItemsSizesOptionTask'],primitives.pdf.orgdiagram.CheckBoxTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ButtonsTemplateTask',['ItemsSizesOptionTask'],primitives.pdf.orgdiagram.ButtonsTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('AnnotationLabelTemplateTask',['ItemsOptionTask'],primitives.pdf.orgdiagram.AnnotationLabelTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('PrintPreviewTemplateTask',['ItemsOptionTask'],primitives.pdf.orgdiagram.PrintPreviewTemplateTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('VisualTreeTask',['OrgTreeTask','ItemTemplateParamsTask','VisualTreeOptionTask','isFamilyChartMode'],primitives.orgdiagram.VisualTreeTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('VisualTreeLevelsTask',['VisualTreeTask','ItemTemplateParamsTask'],primitives.orgdiagram.VisualTreeLevelsTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('VisualTreeMarginsTask',['VisualTreeTask'],primitives.orgdiagram.VisualTreeMarginsTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('ConnectionsGraphTask',['graphics','CreateTransformTask','ConnectorsOptionTask','VisualTreeLevelsTask','AlignDiagramTask'],primitives.orgdiagram.ConnectionsGraphTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Transformations/Selections
	tasks.addTask('HighlightItemTask',['HighlightItemOptionTask','VisualTreeLevelsTask'],primitives.orgdiagram.HighlightItemTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CursorItemTask',['CursorItemOptionTask','VisualTreeLevelsTask'],primitives.orgdiagram.CursorItemTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('SelectedItemsTask',['SelectedItemsOptionTask'],primitives.orgdiagram.SelectedItemsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CombinedNormalVisibilityItemsTask',['OptionsTask'],primitives.pdf.orgdiagram.DummyCombinedNormalVisibilityItemsTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('CurrentControlSizeTask',['OptionsTask'],primitives.pdf.orgdiagram.DummyCurrentControlSizeTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('ItemsPositionsTask',['CurrentControlSizeTask','ScaleOptionTask','OrientationOptionTask','ItemsSizesOptionTask','ConnectorsOptionTask','VisualTreeOptionTask','IntervalsTask','VisualTreeTask','VisualTreeLevelsTask','VisualTreeMarginsTask','ItemTemplateParamsTask','CursorItemTask','CombinedNormalVisibilityItemsTask'],primitives.orgdiagram.ItemsPositionsTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('AlignDiagramTask',['OrientationOptionTask','ItemsSizesOptionTask','VisualTreeOptionTask','ScaleOptionTask','PrintPreviewOptionTask','CurrentControlSizeTask','VisualTreeLevelsTask','ItemsPositionsTask','isFamilyChartMode'],primitives.orgdiagram.AlignDiagramTask,"#ff0000"/*primitives.common.Colors.Red*/);tasks.addTask('CreateTransformTask',['OrientationOptionTask','AlignDiagramTask'],primitives.orgdiagram.CreateTransformTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Managers
	tasks.addTask('BackgroundAnnotationManagerTask',['ItemsSizesOptionTask','VisualTreeLevelsTask','AlignDiagramTask'],primitives.orgdiagram.BackgroundAnnotationManagerTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('PaletteManagerTask',['ConnectorsOptionTask','null'],primitives.orgdiagram.PaletteManagerTask,"#00ffff"/*primitives.common.Colors.Cyan*/);// Renders
	tasks.addTask('DrawBackgroundAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','BackgroundAnnotationOptionTask','VisualTreeTask','AlignDiagramTask','BackgroundAnnotationManagerTask'],primitives.orgdiagram.DrawBackgroundAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawBackgroundShapeAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','BackgroundShapeAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','background','DrawBackgroundAnnotationTask'/*dummy dependency enforeces drawing order */],primitives.orgdiagram.DrawShapeAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawBackgroundConnectorAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','BackgroundConnectorAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','background','DrawBackgroundShapeAnnotationTask'],primitives.orgdiagram.DrawConnectorAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawTreeItemsTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','ItemsSizesOptionTask','CombinedContextsTask','AlignDiagramTask','ItemTemplateParamsTask','CursorItemTask','SelectedItemsTask','GroupTitleTemplateTask','CheckBoxTemplateTask','ButtonsTemplateTask','DrawBackgroundConnectorAnnotationTask'],primitives.orgdiagram.DrawTreeItemsTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawBackgroundHighlightPathAnnotationTask',['graphics','ConnectorsOptionTask','ForegroundHighlightPathAnnotationOptionTask','ConnectionsGraphTask','foreground','DrawTreeItemsTask'],primitives.orgdiagram.DrawHighlightPathAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('DrawConnectorsTask',['graphics','ConnectionsGraphTask','ConnectorsOptionTask','showElbowDots','PaletteManagerTask','DrawBackgroundHighlightPathAnnotationTask'],primitives.orgdiagram.DrawConnectorsTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawForegroundHighlightPathAnnotationTask',['graphics','ConnectorsOptionTask','BackgroundHighlightPathAnnotationOptionTask','ConnectionsGraphTask','background','DrawConnectorsTask'],primitives.orgdiagram.DrawHighlightPathAnnotationTask,"#00ffff"/*primitives.common.Colors.Cyan*/);tasks.addTask('DrawForegroundShapeAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','ForegroundShapeAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','foreground','DrawForegroundHighlightPathAnnotationTask'],primitives.orgdiagram.DrawShapeAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawForegroundConnectorAnnotationTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','OrientationOptionTask','ForegroundConnectorAnnotationOptionTask','AlignDiagramTask','AnnotationLabelTemplateTask','foreground','DrawForegroundShapeAnnotationTask'],primitives.orgdiagram.DrawConnectorAnnotationTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawCursorTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','CombinedContextsTask','AlignDiagramTask','ItemTemplateParamsTask','CursorItemTask','SelectedItemsTask','DrawForegroundConnectorAnnotationTask'],primitives.orgdiagram.DrawCursorTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawHighlightTask',['graphics','CreateTransformTask','ApplyLayoutChangesTask','CombinedContextsTask','AlignDiagramTask','ItemTemplateParamsTask','HighlightItemTask','CursorItemTask','SelectedItemsTask','DrawCursorTask'],primitives.orgdiagram.DrawHighlightTask,"#008000"/*primitives.common.Colors.Green*/);tasks.addTask('DrawPrintPreviewTask',['graphics','ApplyLayoutChangesTask','PrintPreviewOptionTask','AlignDiagramTask','PrintPreviewTemplateTask','ScaleOptionTask','DrawHighlightTask'],primitives.orgdiagram.DrawPrintPreviewTask,"#008000"/*primitives.common.Colors.Green*/);return tasks;}function createEventArgs(data,oldTreeItemId,newTreeItemId,name){var result=new primitives.orgdiagram.EventArgs(),combinedContextsTask=data.tasks.getTask("CombinedContextsTask"),alignDiagramTask=data.tasks.getTask("AlignDiagramTask"),oldItemConfig=combinedContextsTask.getConfig(oldTreeItemId),newItemConfig=combinedContextsTask.getConfig(newTreeItemId),itemPosition,actualPosition;if(oldItemConfig&&oldItemConfig.id!=null){result.oldContext=oldItemConfig;}if(newItemConfig&&newItemConfig.id!=null){result.context=newItemConfig;if(newItemConfig.parent!==null){result.parentItem=combinedContextsTask.getConfig(newItemConfig.parent);}itemPosition=alignDiagramTask.getItemPosition(newTreeItemId),result.position=new primitives.common.Rect(itemPosition.actualPosition);}if(name!=null){result.name=name;}return result;}function trigger(eventHandlerName,event,eventArgs){var eventHandler=_data.options[eventHandlerName];if(eventHandler!=null){eventHandler(event,eventArgs);}}function _disableNotAvailableFunctionality(){/* disable functionality not available in PDF */_data.options.hasButtons=2/*primitives.common.Enabled.False*/;_data.options.pageFitMode=5/*primitives.common.PageFitMode.AutoSize*/;_data.options.autoSizeMaximum=new primitives.common.Size(100000,100000);}function draw(doc,positionX,positionY){_data.doc=doc;_data.tasks=createTaskManager(getOptions,getGraphics);_data.graphics=new primitives.pdf.graphics(_data.doc);_data.graphics.debug=_debug;_disableNotAvailableFunctionality();_data.doc.save();_data.doc.translate(positionX,positionY);_data.tasks.process('OptionsTask',null,_debug);_data.doc.restore();var alignDiagramTask=_data.tasks.getTask("AlignDiagramTask");return new primitives.common.Size(alignDiagramTask.getContentSize());}function getSize(){_data.tasks=createTaskManager(getOptions,getGraphics);_disableNotAvailableFunctionality();_data.tasks.process('OptionsTask','AlignDiagramTask',_debug);var alignDiagramTask=_data.tasks.getTask("AlignDiagramTask");return new primitives.common.Size(alignDiagramTask.getContentSize());}return{draw:draw,getSize:getSize};};/* /pdf/Templates/AnnotationLabelTemplate.js*//* jshint latedef: true, unused: false */primitives.pdf.AnnotationLabelTemplate=function(){function template(){return{};}function getHashCode(){return 0;}function render(doc,position,data){var annotationConfig=data.context;doc.save();doc.font('Helvetica',12).text(annotationConfig.label,position.x,position.y,{width:position.width,height:position.height,align:'center'});doc.restore();}return{template:template,getHashCode:getHashCode,render:render};};/* /pdf/Templates/CheckBoxTemplate.js*/primitives.pdf.CheckBoxTemplate=function(selectCheckBoxLabel){var _checked='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAF/SURBVDhPpZM7rwFREMf/u4hEY5vVkigoSERiKwq1QqOh28R30QnFRqnSKHwFn0C37Sbi0SCE2KzE41wzd/feG48g91ftmdn5zznzkLLZrNhutzidTvgEv98PRVEgxeNx0e12EYvFcDweXfdjZFmGEIKDx+MxdF0HotGomEwmV/tnUAzFyqT8KrNHLpdDJpPBZrPh81UHLPAO7XYb6/Ua8/kcpmnC5/NBkqT3BJbLJRqNBgKBACqVCgqFAg6HA/veEiiVSlBVFZfLBZ1Ox7V+81KAMtPVV6sV+v2+a/2FBeg9RDqdhqZp/E1Mp1O0Wi32V6tVLuAtLEBvGw6HmM1m2O/3yOfz7CyXy4hEItz3ZrPJtr/8dIEKUiwWYRgGX3e32yGZTOJ8PnMBB4MBB9xy14VarcaZFosFQqEQHMdBvV5HIpFw/3gATZNlWTxdHr1eT4TDYZFKpVzLPRRDsU9HeTQaCdu23dM91wKzwNNlCgaDXINHW0pF95bpn+us4AsY2TIOZFyZ9AAAAABJRU5ErkJggg==',_unchecked='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAACjSURBVDhPrZNNCsQgDEY/f2q33sCCN+iNPJlXE2/gTtDiVBln1TJo+zZBJS+YELLvewkhIOeMETjnkFKCaK2LtRbbtiGl9H2+hlKKUkpLds7BGAMopYr3/rwfo+bUXFrN/yrfcXrQBDMwxkAImRfEGFucFnTeEdT/zNIEy7K0wyi/KfSGjPJoCp13BDM9EEK0eLtM67riOI7LLa0F+zI9XGeJDyTldfBA9FNyAAAAAElFTkSuQmCC';function template(){return{};}function getHashCode(){return 0;}function render(doc,position,data){var image=data.isSelected?_checked:_unchecked;doc.save();/* photo */doc.image(image,position.x,position.y);doc.font('Helvetica',11).text(selectCheckBoxLabel,position.x+20,position.y+4,{ellipsis:true,width:position.width-4,height:position.height,align:'left'});doc.restore();}return{template:template,getHashCode:getHashCode,render:render};};/* /pdf/Templates/CursorTemplate.js*/primitives.pdf.CursorTemplate=function(options,itemTemplateConfig){var _config=itemTemplateConfig;function template(){return{};}function getHashCode(){return 0;}function render(doc,position,data){doc.save();/* item border */doc.roundedRect(position.x,position.y,position.width,position.height,4).lineWidth(_config.cursorBorderWidth).stroke('#fbd850');doc.restore();}return{template:template,getHashCode:getHashCode,render:render};};/* /pdf/Templates/DummyTemplate.js*/primitives.pdf.DummyTemplate=function(){function template(){return{};}function getHashCode(){return 0;}function render(){}return{template:template,getHashCode:getHashCode,render:render};};/* /pdf/Templates/GroupTitleTemplate.js*/primitives.pdf.GroupTitleTemplate=function(itemTitleFirstFontColor,itemTitleSecondFontColor){function template(){return{};}function getHashCode(){return 0;}function render(doc,position,data){var config=new primitives.text.Config(),itemConfig=data.context,groupTitleColor=itemConfig.groupTitleColor||"#4169e1"/*primitives.common.Colors.RoyalBlue*/,color=primitives.common.highestContrast(groupTitleColor,itemTitleSecondFontColor,itemTitleFirstFontColor);/* title background */doc.save();doc.translate(position.width,0).rotate(90,{origin:[position.x,position.y]});doc.fillColor(groupTitleColor).roundedRect(position.x,position.y,position.height-2,position.width,4).fill();/* title */doc.fillColor(color).font('Helvetica',12).text(itemConfig.groupTitle,position.x+4,position.y+6,{ellipsis:true,width:position.height-4,height:position.width-4,align:'center'});doc.restore();}return{template:template,getHashCode:getHashCode,render:render};};/* /pdf/Templates/HighlightTemplate.js*/primitives.pdf.HighlightTemplate=function(options,itemTemplateConfig){var _config=itemTemplateConfig;function template(){return{};}function getHashCode(){return 0;}function render(doc,position,data){doc.save();/* border */doc.roundedRect(position.x,position.y,position.width,position.height,4).lineWidth(_config.highlightBorderWidth).stroke('#fbcb09');doc.restore();}return{template:template,getHashCode:getHashCode,render:render};};/* /pdf/Templates/ItemTemplate.js*/primitives.pdf.ItemTemplate=function(options,itemTemplateConfig){var _config=itemTemplateConfig;function template(){return{};}function getHashCode(){return 0;}function render(doc,position,data){var itemConfig=data.context,itemTitleColor=itemConfig.itemTitleColor!=null?itemConfig.itemTitleColor:"#4169e1"/*primitives.common.Colors.RoyalBlue*/,color=primitives.common.highestContrast(itemTitleColor,options.itemTitleSecondFontColor,options.itemTitleFirstFontColor),contentSize=new primitives.common.Size(_config.itemSize);contentSize.width-=_config.itemBorderWidth*2;contentSize.height-=_config.itemBorderWidth*2;doc.save();/* item border */doc.roundedRect(position.x,position.y,position.width,position.height,4).lineWidth(_config.itemBorderWidth).stroke('#dddddd');/* title background */doc.fillColor(itemTitleColor).roundedRect(position.x+2,position.y+2,contentSize.width-4,18,2).fill();/* title */doc.fillColor(color).font('Helvetica',12).text(itemConfig.title,position.x+4,position.y+7,{ellipsis:true,width:contentSize.width-4-4*2,height:16,align:'left'});/* photo */if(itemConfig.image!=null){doc.image(itemConfig.image,position.x+3,position.y+24);}/* photo frame */doc.rect(position.x+3,position.y+24,50,60).stroke('#cccccc');/* description */doc.fillColor('black').font('Helvetica',10).text(itemConfig.description,position.x+56,position.y+24,{ellipsis:true,width:contentSize.width-4-56,height:74,align:'left'});doc.restore();}return{template:template,getHashCode:getHashCode,render:render};};/* /pdf/Templates/LabelAnnotationTemplate.js*/primitives.pdf.LabelAnnotationTemplate=function(){function template(){return{};}function getHashCode(){return 0;}function render(doc,position,data){var itemConfig=data.context;doc.save();doc.font('Helvetica',12).text(itemConfig.title,position.x,position.y,{width:position.width,height:position.height,align:'center'});doc.restore();}return{template:template,getHashCode:getHashCode,render:render};};/* /pdf/Templates/PrintPreviewTemplate.js*/primitives.pdf.PrintPreviewTemplate=function(options){function template(){return{};}function getHashCode(){return 0;}function render(doc,position,data){doc.save();/* border */doc.roundedRect(position.x,position.y,position.width,position.height,0).doc.dash(2,4).lineWidth(1).stroke('#cccccc');doc.restore();}return{template:template,getHashCode:getHashCode,render:render};};/* /pdf/Templates/UserTemplate.js*/primitives.pdf.UserTemplate=function(options,itemTemplateConfig,onRender){function template(){return{};}function getHashCode(){return 0;}function render(doc,position,data){if(onRender!=null){onRender(doc,position,data);}else{var itemTemplate=primitives.pdf.ItemTemplate(options,itemTemplateConfig);itemTemplate.render(doc,position,data);}}return{template:template,getHashCode:getHashCode,render:render};};/* /Widgets/callout/configs/Config.js*//*
		Class: primitives.callout.Config
			Callout options class.
	
	*/primitives.callout.Config=function(){this.classPrefix="bpcallout";/*
			Property: graphicsType
				Preferable graphics type. If preferred graphics type is not supported widget switches to first available.
	
			Default:
				<primitives.common.GraphicsType.SVG>
		*/this.graphicsType=1/*primitives.common.GraphicsType.Canvas*/;/*
			Property: pointerPlacement
				Defines pointer connection side or corner.
	
			Default:
				<primitives.common.PlacementType.Auto>
		*/this.pointerPlacement=0/*primitives.common.PlacementType.Auto*/;/*
		Property: position
			Defines callout body position.
	
		Type:
			<primitives.common.Rect>.
		*/this.position=null;/*
		Property: snapPoint
			Callout snap point.
	
		Type:
			<primitives.common.Point>.
		*/this.snapPoint=null;/*
		Property: cornerRadius
			Body corner radius in percents or pixels.
		*/this.cornerRadius="10%";/*
		Property: offset
			Body rectangle offset.
		*/this.offset=0;/*
		Property: opacity
			Background color opacity.
		*/this.opacity=1;/*
		Property: lineWidth
			Border line width.
		*/this.lineWidth=1;/*
		Property: lineType
			Connector's line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.lineType=0/*primitives.common.LineType.Solid*/;/*
		Property: pointerWidth
			Pointer base width in percents or pixels.
		*/this.pointerWidth="10%";/*
		Property: borderColor
			Border Color.
	
		Default:
			<primitives.common.Colors.Black>
		*/this.borderColor="#000000"/*primitives.common.Colors.Black*/;/*
		Property: fillColor
			Fill Color.
	
		Default:
			<primitives.common.Colors.Gray>
		*/this.fillColor="#d3d3d3"/*primitives.common.Colors.LightGray*/;/*
		method: update
			Makes full redraw of callout widget contents reevaluating all options.
		*/};/* /Widgets/callout/controllers/Controller.js*/primitives.callout.Controller=function(){this.widgetEventPrefix="bpcallout";this.options=new primitives.callout.Config();this.m_placeholder=null;this.m_panelSize=null;this.m_graphics=null;this.m_shape=null;};primitives.callout.Controller.prototype._create=function(){this.element.addClass("ui-widget");this._createLayout();this._redraw();};primitives.callout.Controller.prototype.destroy=function(){this._cleanLayout();};primitives.callout.Controller.prototype._createLayout=function(){this.m_panelSize=new primitives.common.Rect(0,0,this.element.outerWidth(),this.element.outerHeight());this.m_placeholder=jQuery('<div></div>');this.m_placeholder.css({"position":"relative","overflow":"hidden","top":"0px","left":"0px","padding":"0px","margin":"0px"});this.m_placeholder.css(this.m_panelSize.getCSS());this.m_placeholder.addClass("placeholder");this.m_placeholder.addClass(this.widgetEventPrefix);this.element.append(this.m_placeholder);this.m_graphics=primitives.common.createGraphics(this.options.graphicsType,this.element);this.m_shape=new primitives.common.Callout(this.m_graphics);};primitives.callout.Controller.prototype._cleanLayout=function(){if(this.m_graphics!==null){this.m_graphics.clean();}this.m_graphics=null;this.element.find("."+this.widgetEventPrefix).remove();};primitives.callout.Controller.prototype._updateLayout=function(){this.m_panelSize=new primitives.common.Rect(0,0,this.element.innerWidth(),this.element.innerHeight());this.m_placeholder.css(this.m_panelSize.getCSS());};primitives.callout.Controller.prototype.update=function(recreate){if(recreate){this._cleanLayout();this._createLayout();this._redraw();}else{this._updateLayout();this.m_graphics.resize("placeholder",this.m_panelSize.width,this.m_panelSize.height);this.m_graphics.begin();this._redraw();this.m_graphics.end();}};primitives.callout.Controller.prototype._redraw=function(){var names=["pointerPlacement","cornerRadius","offset","opacity","lineWidth","lineType","pointerWidth","borderColor","fillColor"],index,name;this.m_graphics.activate("placeholder");for(index=0;index<names.length;index+=1){name=names[index];this.m_shape[name]=this.options[name];}this.m_shape.draw(this.options.snapPoint,this.options.position);};primitives.callout.Controller.prototype._setOption=function(key,value){jQuery.Widget.prototype._setOption.apply(this,arguments);switch(key){case"disabled":var handles=jQuery([]);if(value){handles.filter(".ui-state-focus").blur();handles.removeClass("ui-state-hover");handles.propAttr("disabled",true);this.element.addClass("ui-disabled");}else{handles.propAttr("disabled",false);this.element.removeClass("ui-disabled");}break;default:break;}};/* /Widgets/callout/callout.js*//*
	 * jQuery UI Callout
	 *
	 * Basic Primitives Callout.
	 *
	 * Depends:
	 *	jquery.ui.core.js
	 *	jquery.ui.widget.js
	 */if(typeof jQuery!="undefined"){(function($){$.widget("ui.bpCallout",new primitives.callout.Controller());})(jQuery);};/* /Widgets/connector/configs/Config.js*//*
		Class: primitives.connector.Config
			Connector options class.
	
	*/primitives.connector.Config=function(){this.classPrefix="bpconnector";/*
			Property: graphicsType
				Preferable graphics type. If preferred graphics type is not supported widget switches to first available.
	
			Default:
				<primitives.common.GraphicsType.SVG>
		*/this.graphicsType=1/*primitives.common.GraphicsType.Canvas*/;/*
			Property: orientationType
				Diagram orientation.
	
			Default:
				<primitives.common.OrientationType.Top>
		*/this.orientationType=0/*primitives.common.OrientationType.Top*/;/*
			Property: connectorPlacementType
				Defines connector annotation shape placement mode between two rectangles.
				It uses off beat placement mode as default in order to avoid overlapping
				of base hierarchy connector lines.
	
			Default:
				<primitives.common.ConnectorPlacementType.Offbeat>
		*/this.connectorPlacementType=0/*primitives.common.ConnectorPlacementType.Offbeat*/;/*
			Property: connectorShapeType
				Connector shape type.
	
			Default:
				<primitives.common.ConnectorShapeType.OneWay>
		*/this.connectorShapeType=0/*primitives.common.ConnectorShapeType.OneWay*/;/*
		Property: position
			Defines connectors starting rectangle position.
	
		Type:
			<primitives.common.Rect>.
		*/this.fromRectangle=null;/*
		Property: position
			Defines connectors ending rectangle position.
	
		Type:
			<primitives.common.Rect>.
		*/this.toRectangle=null;/*
		Property: offset
			Connector's from and to points offset off the rectangles side. Connectors connection points can be outside of rectangles and inside for negative offset value.
		See also:
			<primitives.common.Thickness>
		*/this.offset=new primitives.common.Thickness(0,0,0,0);/*
		Property: lineWidth
			Border line width.
		*/this.lineWidth=3;/*
		Property: color
			Connector's color.
	
		Default:
			<primitives.common.Colors.Black>
		*/this.color="#000000"/*primitives.common.Colors.Black*/;/*
		Property: lineType
			Connector's line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.lineType=0/*primitives.common.LineType.Solid*/;/*
		Property: label
			Annotation label text. Label styled with css class name "bp-connector-label".
		*/this.label=null;/*
		Property: labelSize
			Defines label size. It is needed to preserve space for label without overlapping connected items.
	
		Default:
			new <primitives.common.Size>(60, 30);
		*/this.labelSize=new primitives.common.Size(60,30);/*
		Property: labelPlacementType
			Defines conector label placement. Label can be placed between rectangles along connector line or close to one of them.
	
		Default:
			new <primitives.common.Size>(60, 30);
		*/this.labelPlacementType=1/*primitives.common.ConnectorLabelPlacementType.Between*/;/*
		method: update
			Makes full redraw of connector widget contents reevaluating all options.
		*/};/* /Widgets/connector/controllers/AnnotationLabelTemplate.js*/primitives.connector.AnnotationLabelTemplate=function(options){var _template=create(),_hashCode=primitives.common.hashCode(_template);function create(){var template=jQuery('<div></div>');template.addClass("bp-item bp-corner-all bp-connector-label");return template.wrap('<div>').parent().html();}function template(){return _template;}function getHashCode(){return _hashCode;}function render(event,data){data.element.html(options.label);}return{template:template,getHashCode:getHashCode,render:render};};/* /Widgets/connector/controllers/Controller.js*/primitives.connector.Controller=function(){this.widgetEventPrefix="bpconnector";this.options=new primitives.connector.Config();this._placeholder=null;this._panelSize=null;this._graphics=null;this._labelTemplate=null;};primitives.connector.Controller.prototype._create=function(){var self=this;this.element.addClass("ui-widget");this._labelTemplate=primitives.connector.AnnotationLabelTemplate(this.options);this._createLayout();this._redraw();};primitives.connector.Controller.prototype.destroy=function(){this._cleanLayout();};primitives.connector.Controller.prototype._createLayout=function(){this._panelSize=new primitives.common.Rect(0,0,this.element.outerWidth(),this.element.outerHeight());this._placeholder=jQuery('<div></div>');this._placeholder.css({"position":"relative","overflow":"hidden","top":"0px","left":"0px","padding":"0px","margin":"0px"});this._placeholder.css(this._panelSize.getCSS());this._placeholder.addClass("placeholder");this._placeholder.addClass(this.widgetEventPrefix);this.element.append(this._placeholder);this._graphics=primitives.common.createGraphics(this.options.graphicsType,this.element);};primitives.connector.Controller.prototype._cleanLayout=function(){if(this._graphics!==null){this._graphics.clean();}this._graphics=null;this.element.find("."+this.widgetEventPrefix).remove();};primitives.connector.Controller.prototype._updateLayout=function(){this._panelSize=new primitives.common.Rect(0,0,this.element.innerWidth(),this.element.innerHeight());this._placeholder.css(this._panelSize.getCSS());};primitives.connector.Controller.prototype.update=function(recreate){if(recreate){this._cleanLayout();this._createLayout();this._redraw();}else{this._updateLayout();this._graphics.resize("placeholder",this._panelSize.width,this._panelSize.height);this._graphics.begin();this._redraw();this._graphics.end();}};primitives.connector.Controller.prototype._redraw=function(){var annotationConfig=this.options,shape,uiHash,transform=new primitives.common.Transform(),panel=this._graphics.activate("placeholder"),buffer=new primitives.common.PolylinesBuffer(),self=this,connectorAnnotationOffsetResolver=primitives.orgdiagram.ConnectorAnnotationOffsetResolver();transform.size=new primitives.common.Size(this._panelSize.width,this._panelSize.height);transform.setOrientation(annotationConfig.orientationType);if(annotationConfig.fromRectangle!=null&&annotationConfig.toRectangle!=null){var fromRect=annotationConfig.fromRectangle,toRect=annotationConfig.toRectangle;/* translate rectangles to Top orientation *//* from rectangle */transform.transformRect(fromRect.x,fromRect.y,fromRect.width,fromRect.height,false,this,function(x,y,width,height){fromRect=new primitives.common.Rect(x,y,width,height);});/* to rectangle */transform.transformRect(toRect.x,toRect.y,toRect.width,toRect.height,false,this,function(x,y,width,height){toRect=new primitives.common.Rect(x,y,width,height);});switch(annotationConfig.connectorPlacementType){case 0/*primitives.common.ConnectorPlacementType.Offbeat*/:shape=new primitives.common.ConnectorOffbeat();break;case 1/*primitives.common.ConnectorPlacementType.Straight*/:shape=new primitives.common.ConnectorStraight();break;}/* rotate label size to user orientation */var labelSize;transform.transformRect(0,0,annotationConfig.labelSize.width,annotationConfig.labelSize.height,false,this,function(x,y,width,height){labelSize=new primitives.common.Size(width,height);});/* rotate panel size to user orientation */var panelSize=null;transform.transformRect(0,0,panel.size.width,panel.size.height,false,this,function(x,y,width,height){panelSize=new primitives.common.Size(width,height);});var linePaletteItem=new primitives.common.PaletteItem({lineColor:annotationConfig.color,lineWidth:annotationConfig.lineWidth,lineType:annotationConfig.lineType});var hasLabel=!primitives.common.isNullOrEmpty(annotationConfig.label);/* offset rectangles */fromRect=new primitives.common.Rect(fromRect).offset(annotationConfig.offset);toRect=new primitives.common.Rect(toRect).offset(annotationConfig.offset);var linesOffset=annotationConfig.lineWidth*6;/* create connection lines */shape.draw(buffer,linePaletteItem,fromRect,toRect,linesOffset,0,labelSize,panelSize,annotationConfig.connectorShapeType,4/*labelOffset*/,annotationConfig.labelPlacementType,hasLabel,connectorAnnotationOffsetResolver,function(labelPlacement){if(hasLabel&&labelPlacement!=null){/* translate result label placement back to users orientation */transform.transformRect(labelPlacement.x,labelPlacement.y,labelPlacement.width,labelPlacement.height,true,self,function(x,y,width,height){labelPlacement=new primitives.common.Rect(x,y,width,height);});uiHash=new primitives.common.RenderEventArgs();uiHash.context=annotationConfig;/* draw label */self._graphics.template(labelPlacement.x,labelPlacement.y,0,0,0,0,labelPlacement.width,labelPlacement.height,self._labelTemplate.template(),self._labelTemplate.getHashCode(),self._labelTemplate.render,uiHash,null);}});connectorAnnotationOffsetResolver.resolve();}/* translate result polylines back to users orientation */buffer.transform(transform,true);/* draw background polylines */this._graphics.polylinesBuffer(buffer);};primitives.connector.Controller.prototype._setOption=function(key,value){jQuery.Widget.prototype._setOption.apply(this,arguments);switch(key){case"disabled":var handles=jQuery([]);if(value){handles.filter(".ui-state-focus").blur();handles.removeClass("ui-state-hover");handles.propAttr("disabled",true);this.element.addClass("ui-disabled");}else{handles.propAttr("disabled",false);this.element.removeClass("ui-disabled");}break;default:break;}};/* /Widgets/connector/connector.js*//*
	 * jQuery UI Connector
	 *
	 * Basic Primitives Connector.
	 *
	 * Depends:
	 *	jquery.ui.core.js
	 *	jquery.ui.widget.js
	 */if(typeof jQuery!="undefined"){(function($){$.widget("ui.bpConnector",new primitives.connector.Controller());})(jQuery);};/* /Widgets/diagrams/Widget.js*/primitives.orgdiagram.Widget=function(Config,controlFactory){this.widgetEventPrefix="orgdiagram";this.options=new Config();this.control=null;this.controlFactory=controlFactory;};primitives.orgdiagram.Widget.prototype._create=function(){this.element.addClass("ui-widget");this.control=new this.controlFactory(this.element,this._readOptions(this.options));};primitives.orgdiagram.Widget.prototype.destroy=function(){this.control.destroy();};primitives.orgdiagram.Widget.prototype.update=function(updateMode){this.control.update(updateMode);};primitives.orgdiagram.Widget.prototype._setOption=function(key,value){jQuery.Widget.prototype._setOption.apply(this,arguments);switch(key){case"disabled":var handles=jQuery([]);if(value){handles.filter(".ui-state-focus").blur();handles.removeClass("ui-state-hover");handles.propAttr("disabled",true);this.element.addClass("ui-disabled");}else{handles.propAttr("disabled",false);this.element.removeClass("ui-disabled");}break;default:break;}this.control.setOptions(this._readOptions(this.options));};primitives.orgdiagram.Widget.prototype._readOptions=function(options){var result={},self=this;/* shallow copy */for(var property in options){if(options.hasOwnProperty(property)){switch(property){case'onHighlightChanged':case'onCursorChanged':case'onSelectionChanging':case'onButtonClick':case'onMouseClick':case'onMouseDblClick':case'onItemRender':case'onHighlightRender':result[property]=function(property){return function(event,eventArgs){self._trigger(property,event,eventArgs);};}(property);break;case'onHighlightChanging':result[property]=function(event,eventArgs){var options=self.control.getOptions();self.options.highlightItem=options.highlightItem;self._trigger("onHighlightChanging",event,eventArgs);};break;case'onCursorChanging':result[property]=function(event,eventArgs){var options=self.control.getOptions();self.options.cursorItem=options.cursorItem;self._trigger("onCursorChanging",event,eventArgs);};break;case'onSelectionChanged':result[property]=function(event,eventArgs){var options=self.control.getOptions();self.options.selectedItems=options.selectedItems;self._trigger("onSelectionChanged",event,eventArgs);};break;default:result[property]=options[property];break;}}}return result;};/* /Widgets/diagrams/orgDiagram.js*//*
	 * jQuery UI Diagram
	 *
	 * Basic Primitives organization diagram.
	 *
	 * Depends:
	 *	jquery.ui.core.js
	 *	jquery.ui.widget.js
	 */if(typeof jQuery!="undefined"){(function($){$.widget("ui.orgDiagram",new primitives.orgdiagram.Widget(primitives.orgdiagram.Config,primitives.orgdiagram.Control));})(jQuery);};/* /Widgets/diagrams/famDiagram.js*//*
	 * jQuery UI Diagram
	 *
	 * Basic Primitives family diagram.
	 *
	 * Depends:
	 *	jquery.ui.core.js
	 *	jquery.ui.widget.js
	 */if(typeof jQuery!="undefined"){(function($){$.widget("ui.famDiagram",new primitives.orgdiagram.Widget(primitives.famdiagram.Config,primitives.famdiagram.Control));})(jQuery);};/* /Widgets/shape/configs/Config.js*//*
		Class: primitives.connector.Config
			Connector options class.
	
	*/primitives.shape.Config=function(){this.classPrefix="bpconnector";/*
			Property: graphicsType
				Preferable graphics type. If preferred graphics type is not supported widget switches to first available.
	
			Default:
				<primitives.common.GraphicsType.SVG>
		*/this.graphicsType=1/*primitives.common.GraphicsType.Canvas*/;/*
			Property: orientationType
				Diagram orientation.
	
			Default:
				<primitives.common.OrientationType.Top>
		*/this.orientationType=0/*primitives.common.OrientationType.Top*/;/*
			Property: shapeType
				Shape type.
	
			Default:
				<primitives.common.ShapeType.Rectangle>
		*/this.shapeType=0/*primitives.common.ShapeType.Rectangle*/;/*
		Property: position
			Defines shapes rectangle position.
	
		Type:
			<primitives.common.Rect>.
		*/this.position=null;/*
		Property: offset
			Connector's from and to points offset off the rectangles side. Connectors connection points can be outside of rectangles and inside for negative offset value.
		See also:
			<primitives.common.Thickness>
		*/this.offset=new primitives.common.Thickness(0,0,0,0);/*
		Property: lineWidth
			Border line width.
		*/this.lineWidth=2;/*
		Property: cornerRadius
			Body corner radius in percents or pixels.
		*/this.cornerRadius="10%";/*
		Property: opacity
			Background color opacity.
		*/this.opacity=1;/*
		Property: borderColor
			Shape border line color.
	
		Default:
			<primitives.common.Colors.Black>
		*/this.borderColor=null;/*
		Property: fillColor
			Fill Color.
	
		Default:
			<primitives.common.Colors.Gray>
		*/this.fillColor=null;/*
		Property: lineType
			Connector's line pattern.
	
		Default:
			<primitives.common.LineType.Solid>
		*/this.lineType=0/*primitives.common.LineType.Solid*/;/*
		Property: label
			Annotation label text. Label styled with css class name "bp-connector-label".
		*/this.label=null;/*
		Property: labelSize
			Defines label size. It is needed to preserve space for label without overlapping connected items.
	
		Default:
			new <primitives.common.Size>(60, 30);
		*/this.labelSize=new primitives.common.Size(60,30);/*
		Property: labelPlacement
			Defines label placement relative to the shape.
	
		See Also:
			<primitives.orgdiagram.Config.labelPlacement>
			<primitives.common.PlacementType>
	
		Default:
			<primitives.common.PlacementType.Auto>
		*/this.labelPlacement=0/*primitives.common.PlacementType.Auto*/;/*
		Property: labelOffset
			Defines label offset from shape in pixels.
	
		Default:
			4;
		*/this.labelOffset=4;/*
		method: update
			Makes full redraw of connector widget contents reevaluating all options.
		*/};/* /Widgets/shape/controllers/AnnotationLabelTemplate.js*/primitives.shape.AnnotationLabelTemplate=function(options){var _template=create(),_hashCode=primitives.common.hashCode(_template);function create(){var template=jQuery('<div></div>');template.addClass("bp-item bp-corner-all bp-connector-label");return template.wrap('<div>').parent().html();}function template(){return _template;}function getHashCode(){return _hashCode;}function render(event,data){data.element.html(options.label);}return{template:template,getHashCode:getHashCode,render:render};};/* /Widgets/shape/controllers/Controller.js*/primitives.shape.Controller=function(){this.widgetEventPrefix="bpshape";this.options=new primitives.shape.Config();this.m_placeholder=null;this.m_panelSize=null;this.m_graphics=null;this.m_shape=null;this._labelTemplate=null;};primitives.shape.Controller.prototype._create=function(){var self=this;this.element.addClass("ui-widget");this._labelTemplate=primitives.shape.AnnotationLabelTemplate(this.options);this._createLayout();this._redraw();};primitives.shape.Controller.prototype.destroy=function(){this._cleanLayout();};primitives.shape.Controller.prototype._createLayout=function(){this.m_panelSize=new primitives.common.Rect(0,0,this.element.outerWidth(),this.element.outerHeight());this.m_placeholder=jQuery('<div></div>');this.m_placeholder.css({"position":"relative","overflow":"hidden","top":"0px","left":"0px","padding":"0px","margin":"0px"});this.m_placeholder.css(this.m_panelSize.getCSS());this.m_placeholder.addClass("placeholder");this.m_placeholder.addClass(this.widgetEventPrefix);this.element.append(this.m_placeholder);this.m_graphics=primitives.common.createGraphics(this.options.graphicsType,this.element);};primitives.shape.Controller.prototype._cleanLayout=function(){if(this.m_graphics!==null){this.m_graphics.clean();}this.m_graphics=null;this.element.find("."+this.widgetEventPrefix).remove();};primitives.shape.Controller.prototype._updateLayout=function(){this.m_panelSize=new primitives.common.Rect(0,0,this.element.innerWidth(),this.element.innerHeight());this.m_placeholder.css(this.m_panelSize.getCSS());};primitives.shape.Controller.prototype.update=function(recreate){if(recreate){this._cleanLayout();this._createLayout();this._redraw();}else{this._updateLayout();this.m_graphics.resize("placeholder",this.m_panelSize.width,this.m_panelSize.height);this.m_graphics.begin();this._redraw();this.m_graphics.end();}};primitives.shape.Controller.prototype._redraw=function(){var names=["orientationType","shapeType","offset","lineWidth","borderColor","lineType","labelSize","labelOffset","labelPlacement","cornerRadius","opacity","fillColor"],index,name;this.m_graphics.activate("placeholder");this.m_shape=new primitives.common.Shape(this.m_graphics);for(index=0;index<names.length;index+=1){name=names[index];this.m_shape[name]=this.options[name];}this.m_shape.hasLabel=!primitives.common.isNullOrEmpty(this.options.label);this.m_shape.labelTemplate=this._labelTemplate;this.m_shape.panelSize=new primitives.common.Size(this.m_panelSize.width,this.m_panelSize.height);this.m_shape.draw(this.options.position);};primitives.shape.Controller.prototype._setOption=function(key,value){jQuery.Widget.prototype._setOption.apply(this,arguments);switch(key){case"disabled":var handles=jQuery([]);if(value){handles.filter(".ui-state-focus").blur();handles.removeClass("ui-state-hover");handles.propAttr("disabled",true);this.element.addClass("ui-disabled");}else{handles.propAttr("disabled",false);this.element.removeClass("ui-disabled");}break;default:break;}};/* /Widgets/shape/shape.js*//*
	 * jQuery UI Shape
	 *
	 * Basic Primitives Shape.
	 *
	 * Depends:
	 *	jquery.ui.core.js
	 *	jquery.ui.widget.js
	 */if(typeof jQuery!="undefined"){(function($){$.widget("ui.bpShape",new primitives.shape.Controller());})(jQuery);};/* /Widgets/text/configs/Config.js*//*
		Class: primitives.text.Config
			Text options class.
	
	*/primitives.text.Config=function(){this.classPrefix="bptext";/*
			Property: graphicsType
				Preferable graphics type. If preferred graphics type is not supported widget switches to first available.
	
			Default:
				<primitives.common.GraphicsType.SVG>
		*/this.graphicsType=0/*primitives.common.GraphicsType.SVG*/;/*
			Property: textDirection
				Direction style.
	
			Default:
				<primitives.text.TextDirection.Auto>
		*/this.orientation=0/*primitives.text.TextOrientationType.Horizontal*/;/*
			Property: text
				Text
		*/this.text="";/*
			Property: verticalAlignment
				Vertical alignment.
	
			Default:
				<primitives.common.VerticalAlignmentType.Center>
		*/this.verticalAlignment=1/*primitives.common.VerticalAlignmentType.Middle*/;/*
			Property: horizontalAlignment
				Horizontal alignment.
	
			Default:
				<primitives.common.HorizontalAlignmentType.Center>
		*/this.horizontalAlignment=0/*primitives.common.HorizontalAlignmentType.Center*/;/*
			Property: fontSize
				Font size.
	
			Default:
				15
		*/this.fontSize="16px";/*
			Property: fontFamily
				Font family.
	
			Default:
				"Arial"
		*/this.fontFamily="Arial";/*
			Property: color
				Color.
	
			Default:
				<primitives.common.Colors.Black>
		*/this.color="#000000"/*primitives.common.Colors.Black*/;/*
			Property: fontWeight
				Font weight: normal | bold
	
			Default:
				"normal"
		*/this.fontWeight="normal";/*
			Property: fontStyle
				Font style: normal | italic
	
			Default:
				"normal"
		*/this.fontStyle="normal";/*
		method: update
			Makes full redraw of text widget contents reevaluating all options.
		*/};/* /Widgets/text/controllers/Controller.js*/primitives.text.Controller=function(){this.widgetEventPrefix="bptext";this.options=new primitives.text.Config();this.m_placeholder=null;this.m_panelSize=null;this.m_graphics=null;};primitives.text.Controller.prototype._create=function(){this.element.addClass("ui-widget");this._createLayout();this._redraw();};primitives.text.Controller.prototype.destroy=function(){this._cleanLayout();};primitives.text.Controller.prototype._createLayout=function(){this.m_panelSize=new primitives.common.Rect(0,0,this.element.outerWidth(),this.element.outerHeight());this.m_placeholder=jQuery('<div></div>');this.m_placeholder.css({"position":"relative","overflow":"hidden","top":"0px","left":"0px","padding":"0px","margin":"0px"});this.m_placeholder.css(this.m_panelSize.getCSS());this.m_placeholder.addClass("placeholder");this.m_placeholder.addClass(this.widgetEventPrefix);this.element.append(this.m_placeholder);this.m_graphics=primitives.common.createGraphics(this.options.graphicsType,this.element);};primitives.text.Controller.prototype._cleanLayout=function(){if(this.m_graphics!==null){this.m_graphics.clean();}this.m_graphics=null;this.element.find("."+this.widgetEventPrefix).remove();};primitives.text.Controller.prototype._updateLayout=function(){this.m_panelSize=new primitives.common.Rect(0,0,this.element.innerWidth(),this.element.innerHeight());this.m_placeholder.css(this.m_panelSize.getCSS());};primitives.text.Controller.prototype.update=function(recreate){if(recreate){this._cleanLayout();this._createLayout();this._redraw();}else{this._updateLayout();this.m_graphics.resize("placeholder",this.m_panelSize.width,this.m_panelSize.height);this.m_graphics.begin();this._redraw();this.m_graphics.end();}};primitives.text.Controller.prototype._redraw=function(){var panel=this.m_graphics.activate("placeholder"),attr={"font-size":this.options.fontSize,"font-family":this.options.fontFamily,"font-style":this.options.fontStyle,"font-weight":this.options.fontWeight,"font-color":this.options.color};this.m_graphics.text(panel.rect.x,panel.rect.y,panel.rect.width,panel.rect.height,this.options.text,this.options.orientation,this.options.horizontalAlignment,this.options.verticalAlignment,attr);};primitives.text.Controller.prototype._setOption=function(key,value){jQuery.Widget.prototype._setOption.apply(this,arguments);switch(key){case"disabled":var handles=jQuery([]);if(value){handles.filter(".ui-state-focus").blur();handles.removeClass("ui-state-hover");handles.propAttr("disabled",true);this.element.addClass("ui-disabled");}else{handles.propAttr("disabled",false);this.element.removeClass("ui-disabled");}break;default:break;}};/* /Widgets/text/text.js*//*
	 * jQuery UI Text
	 *
	 * Basic Primitives Text.
	 *
	 * Depends:
	 *	jquery.ui.core.js
	 *	jquery.ui.widget.js
	 */if(typeof jQuery!="undefined"){(function($){$.widget("ui.bpText",new primitives.text.Controller());})(jQuery);};;var _temp=function(){if(typeof __REACT_HOT_LOADER__==='undefined'){return;}__REACT_HOT_LOADER__.register(jQuery,'jQuery','D:/a/1/s/src/web/employee/src/orgchart/primitives.js');__REACT_HOT_LOADER__.register(mouseDelayMet,'mouseDelayMet','D:/a/1/s/src/web/employee/src/orgchart/primitives.js');}();;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.mapCareer = mapCareer;
	exports.default = careerReducer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _ActionTypes = __webpack_require__(18);
	
	var _DataTypes = __webpack_require__(85);
	
	var _EmployeeMasterCareer = __webpack_require__(898);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapCareer(c) {
	  return {
	    fields: _EmployeeMasterCareer.fields,
	    detailFields: _EmployeeMasterCareer.detailFields,
	    entityMap: _EmployeeMasterCareer.entityMap,
	    Entity: c.Entity,
	    CareerEmployer: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'career.employer' })
	      ),
	      value: c.CareerEmployer,
	      type: _DataTypes.STRING,
	      entity: 'CareerEmployer'
	    },
	    CareerJob: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'career.job' })
	      ),
	      value: c.CareerJob,
	      type: _DataTypes.STRING,
	      entity: 'CareerJob'
	    },
	    CareerCity: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'career.city' })
	      ),
	      value: c.CareerCity,
	      type: _DataTypes.STRING,
	      entity: 'CareerCity'
	    },
	    CareerCountryName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'career.country' })
	      ),
	      value: c.CareerCountryName,
	      type: _DataTypes.STRING,
	      entity: 'CareerCountryID'
	    },
	    CareerPeriodBegda: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'career.from' })
	      ),
	      value: (0, _dateTools2.default)(c.CareerPeriodBegda),
	      type: _DataTypes.DATE,
	      entity: 'CareerPeriodBegda'
	    },
	    CareerPeriodEnda: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'career.to' })
	      ),
	      value: (0, _dateTools2.default)(c.CareerPeriodEnda),
	      type: _DataTypes.DATE,
	      entity: 'CareerPeriodEnda'
	    }
	  };
	}
	
	function careerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.REQUEST_CAREER:
	      return _extends({}, state, {
	        isFetching: true,
	        careerData: [],
	        loaded: false
	      });
	
	    case _ActionTypes.REQUEST_CAREER_FAILURE:
	      return _extends({}, state, {
	        isFetching: false,
	        error: action.error,
	        loaded: true
	      });
	
	    case _ActionTypes.REQUEST_CAREER_SUCCESS:
	      return _extends({}, state, {
	        isFetching: false,
	        careerData: action.careerData.map(mapCareer),
	        lastUpdated: action.receivedAt,
	        loaded: true
	      });
	
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapCareer, 'mapCareer', 'D:/a/1/s/src/web/employee/src/reducers/careerReducer.js');
	
	  __REACT_HOT_LOADER__.register(careerReducer, 'careerReducer', 'D:/a/1/s/src/web/employee/src/reducers/careerReducer.js');
	}();

	;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.mapCertificate = mapCertificate;
	exports.default = careerReducer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _ActionTypes = __webpack_require__(18);
	
	var _DataTypes = __webpack_require__(85);
	
	var _EmployeeMasterCertificate = __webpack_require__(899);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapCertificate(c) {
	  return {
	    fields: _EmployeeMasterCertificate.fields,
	    detailFields: _EmployeeMasterCertificate.detailFields,
	    entityMap: _EmployeeMasterCertificate.entityMap,
	    Entity: c.Entity,
	    CertificateName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'certificate.name' })
	      ),
	      value: c.CertificateName,
	      type: _DataTypes.STRING,
	      entity: 'HrCertificateID'
	    },
	    CertificateTypeName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'certificate.type' })
	      ),
	      value: c.CertificateTypeName,
	      type: _DataTypes.STRING,
	      entity: 'CertificateType'
	    },
	    CertificatePeriodBegda: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'certificate.from' })
	      ),
	      value: (0, _dateTools2.default)(c.CertificatePeriodBegda),
	      type: _DataTypes.DATE,
	      entity: 'CertificatePeriodBegda'
	    },
	    CertificatePeriodEnda: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'certificate.to' })
	      ),
	      value: (0, _dateTools2.default)(c.CertificatePeriodEnda),
	      type: _DataTypes.DATE,
	      entity: 'CertificatePeriodEnda'
	    }
	  };
	}
	
	function careerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.REQUEST_CERTIFICATE:
	      return _extends({}, state, {
	        isFetching: true,
	        loaded: false,
	        certificateData: []
	      });
	
	    case _ActionTypes.REQUEST_CERTIFICATE_FAILURE:
	      return _extends({}, state, {
	        isFetching: false,
	        loaded: true,
	        certificateData: [],
	        error: action.error
	      });
	
	    case _ActionTypes.REQUEST_CERTIFICATE_SUCCESS:
	      {
	        return _extends({}, state, {
	          isFetching: false,
	          lastUpdated: action.receivedAt,
	          loaded: true,
	          certificateData: action.certificateList.map(mapCertificate)
	        });
	      }
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapCertificate, 'mapCertificate', 'D:/a/1/s/src/web/employee/src/reducers/certificateReducer.js');
	
	  __REACT_HOT_LOADER__.register(careerReducer, 'careerReducer', 'D:/a/1/s/src/web/employee/src/reducers/certificateReducer.js');
	}();

	;

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.mapCourseTimes = mapCourseTimes;
	exports.mapEmplyeeCourses = mapEmplyeeCourses;
	exports.default = coursesReducer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _ActionTypes = __webpack_require__(18);
	
	var _DataTypes = __webpack_require__(85);
	
	var _EmployeeMasterCourse = __webpack_require__(900);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapCourseTimes(ct) {
	  return {
	    fields: ['CourseTimeDate', 'CourseTimeBegti', 'CourseTimeEndti', 'HrLocationName', 'HrRoomName'],
	    CourseTimeDate: {
	      type: _DataTypes.DATE,
	      value: (0, _dateTools2.default)(ct.CourseTimeDate),
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.date' })
	      ),
	      style: {
	        width: 92
	      }
	    },
	    CourseTimeBegti: {
	      type: _DataTypes.TIME,
	      value: (0, _dateTools.convertTime)(ct.CourseTimeBegti),
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.start' })
	      ),
	      style: {
	        width: 64
	      }
	    },
	    CourseTimeEndti: {
	      type: _DataTypes.TIME,
	      value: (0, _dateTools.convertTime)(ct.CourseTimeEndti),
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.end' })
	      ),
	      style: {
	        width: 64
	      }
	    },
	    HrLocationName: {
	      type: _DataTypes.STRING,
	      value: ct.HrLocationName,
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.location' })
	      ),
	      style: {
	        width: 100
	      }
	    },
	    HrRoomName: {
	      type: _DataTypes.STRING,
	      value: ct.HrRoomName,
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.room' })
	      ),
	      style: {
	        width: 100
	      }
	    }
	  };
	}
	
	function renderTimeDuration(hours) {
	  return _react2.default.createElement(_reactIntl.FormattedMessage, {
	    id: 'courses.duration.value',
	    values: {
	      hours: Math.floor(_moment2.default.duration(hours, 'hours').asMinutes() / 60),
	      minutes: (0, _lodash.round)(_moment2.default.duration(hours, 'hours').asMinutes() % 60)
	    }
	  });
	}
	
	function mapCourse(c) {
	  var price = Math.ceil(c.CourseCost / c.CourseMaxAttendance);
	  return {
	    fields: ['CourseName', 'CourseStatusPlannedName', 'CourseBegda', 'CourseEndda', 'CourseHours', 'AttendingName'],
	    detailFields: ['CourseName', 'CourseStatusPlannedName', 'CourseBegda', 'CourseEndda', 'CourseHours', 'AttendingName', 'CourseTypeName', 'CourseGroupName', 'CourseInstructor', 'CourseInstructorEmployeeName', 'CourseDescriptionHtml', 'CourseTimes', 'CourseCost', 'CourseDeadlineStart', 'CourseDeadlineEnd'],
	    CourseInstructor: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.instructor' })
	      ),
	      type: _DataTypes.STRING,
	      value: c.CourseInstructor
	    },
	    CourseInstructorEmployeeName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.instructor' })
	      ),
	      type: _DataTypes.STRING,
	      value: c.CourseInstructorEmployeeName
	    },
	    CourseTypeName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.type' })
	      ),
	      type: _DataTypes.STRING,
	      value: c.CourseTypeName,
	      entityValue: c.HrCourseType
	    },
	    CourseGroupName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.group' })
	      ),
	      type: _DataTypes.STRING,
	      value: c.CourseGroupName,
	      entityValue: c.HrCourseGroupID
	    },
	    CourseDescriptionHtml: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.description' })
	      ),
	      type: _DataTypes.HTML,
	      value: c.CourseDescriptionHtml || c.CourseDescription
	    },
	    CourseTimes: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.times' })
	      ),
	      type: _DataTypes.TABLE,
	      value: c.CourseTimes.map(mapCourseTimes)
	    },
	    CourseID: {
	      type: _DataTypes.NUMBER,
	      value: c.CourseID
	    },
	    CourseAttendeeID: {
	      value: c.MainCourseAttendeeID,
	      type: _DataTypes.NUMBER
	    },
	    CourseAttendingAvailable: {
	      value: c.CourseAttendeeRegistered < c.CourseMaxAttendance,
	      type: _DataTypes.BOOL
	    },
	    CourseName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.name' })
	      ),
	      value: c.CourseName,
	      type: _DataTypes.STRING,
	      style: { width: 135 }
	    },
	    AttendingName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.registered' })
	      ),
	      value: c.CourseAttendeeRegistered + '/' + c.CourseMaxAttendance,
	      type: _DataTypes.STRING,
	      style: { width: 75 }
	    },
	    CourseStatusPlannedName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.status' })
	      ),
	      value: c.CourseStatusPlannedName,
	      type: _DataTypes.STRING,
	      style: { width: 70 }
	    },
	    CourseHours: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.length' })
	      ),
	      value: renderTimeDuration(c.CourseHours),
	      type: _DataTypes.STRING,
	      style: { width: 95 }
	    },
	    CourseBegda: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.start' })
	      ),
	      value: (0, _dateTools2.default)(c.CourseBegda),
	      entityValue: c.CourseBegda,
	      type: _DataTypes.DATE,
	      style: { width: 70 }
	    },
	    CourseEndda: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.end' })
	      ),
	      value: (0, _dateTools2.default)(c.CourseEndda),
	      type: _DataTypes.DATE,
	      style: { width: 75 }
	    },
	    CourseCost: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.price' })
	      ),
	      type: _DataTypes.STRING,
	      value: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.pricePerAttendee', values: { price: price, attendees: c.CourseMaxAttendance } }),
	      style: { width: 70 }
	    },
	    CourseDeadlineStart: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.CourseDeadlineStart' })
	      ),
	      type: _DataTypes.NUMBER,
	      value: _react2.default.createElement(
	        'span',
	        null,
	        c.CourseDeadlineStart,
	        ' ',
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'hours', values: { val: c.CourseDeadlineStart } })
	      ),
	      style: { width: 70 }
	    },
	    CourseDeadlineEnd: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.CourseDeadlineEnd' })
	      ),
	      type: _DataTypes.NUMBER,
	      value: _react2.default.createElement(
	        'span',
	        null,
	        c.CourseDeadlineEnd,
	        ' ',
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'hours', values: { val: c.CourseDeadlineEnd } })
	      ),
	      style: { width: 70 }
	    },
	    entity: c.Entity
	  };
	}
	
	function mapEmplyeeCourses(c) {
	  return {
	    fields: _EmployeeMasterCourse.fields,
	    detailFields: _EmployeeMasterCourse.detailFields,
	    entityMap: _EmployeeMasterCourse.entityMap,
	    Entity: c.Entity,
	    HrRoomName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.room' })
	      ),
	      value: c.HrRoomName,
	      Type: _DataTypes.STRING,
	      entity: 'HrRoomID'
	    },
	    CourseDescription: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.description' })
	      ),
	      value: c.CourseDescription,
	      type: _DataTypes.STRING,
	      entity: 'CourseDescription'
	    },
	    Comments: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.comments' })
	      ),
	      value: c.Comments,
	      type: _DataTypes.STRING,
	      entity: 'Comments'
	    },
	    CourseName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.name' })
	      ),
	      value: c.CourseName,
	      type: _DataTypes.STRING,
	      entity: 'CourseName'
	    },
	    CourseTypeName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.type' })
	      ),
	      value: c.CourseTypeName,
	      type: _DataTypes.STRING,
	      entity: 'CourseType'
	    },
	    CourseGroupName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.group' })
	      ),
	      value: c.CourseGroupName,
	      type: _DataTypes.STRING,
	      entity: 'CourseGroupID'
	    },
	    CourseHrLocationName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.location' })
	      ),
	      value: c.CourseHrLocationName,
	      type: _DataTypes.STRING,
	      entity: 'HrLocationID'
	    },
	    CourseLength: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.length' })
	      ),
	      value: (0, _dateTools.duration)(c.CourseLength),
	      type: _DataTypes.STRING,
	      entity: 'CourseLength'
	    },
	    CoursePoints: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.points' })
	      ),
	      value: c.CoursePoints,
	      type: _DataTypes.NUMBER,
	      entity: 'CoursePoints'
	    },
	    CoursePeriodBegda: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.start' })
	      ),
	      value: (0, _dateTools2.default)(c.CoursePeriodBegda),
	      type: _DataTypes.DATE,
	      entity: 'CoursePeriodBegda'
	    },
	    CoursePeriodEnda: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.end' })
	      ),
	      value: (0, _dateTools2.default)(c.CoursePeriodEnda),
	      type: _DataTypes.DATE,
	      entity: 'CoursePeriodEnda'
	    }
	  };
	}
	
	function coursesReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { coursesLoaded: false };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.REQUEST_EMPLOYEE_MASTER_COURSES:
	      {
	        return _extends({}, state, action);
	      }
	    case _ActionTypes.REQUEST_EMPLOYEE_MASTER_COURSES_FAILURE:
	      {
	        return _extends({}, state, action);
	      }
	    case _ActionTypes.REQUEST_EMPLOYEE_MASTER_COURSES_SUCCESS:
	      {
	        return _extends({}, state, action, {
	          employeeMasterCoursesData: action.employeeMasterCourses.map(mapEmplyeeCourses)
	        });
	      }
	    /* *******************COURSES********************************* */
	    case _ActionTypes.REQUEST_COURSES:
	      {
	        return _extends({}, state, {
	          coursesLoaded: false,
	          courses: [],
	          sentAt: Date.now(),
	          error: null
	        });
	      }
	    case _ActionTypes.REQUEST_COURSES_FAILURE:
	      {
	        return _extends({}, state, {
	          coursesLoaded: true,
	          courses: [],
	          receivedAt: Date.now(),
	          coursesError: action.coursesError
	        });
	      }
	    case _ActionTypes.REQUEST_COURSES_SUCCESS:
	      {
	        return _extends({}, state, {
	          coursesLoaded: true,
	          receivedAt: Date.now(),
	          error: null,
	          allCourses: action.allCourses,
	          attendingCourses: action.attendingCourses.map(mapCourse),
	          openCourses: action.openCourses.map(mapCourse)
	        });
	      }
	    case _ActionTypes.REQUEST_COURSE_ATTENDANCE:
	      return _extends({}, state);
	    case _ActionTypes.REQUEST_COURSE_ATTENDANCE_SUCCESS:
	      return _extends({}, state);
	    case _ActionTypes.REQUEST_COURSE_ATTENDANCE_FAILURE:
	      return _extends({}, state, {
	        coursesError: action.error
	      });
	    case _ActionTypes.REQUEST_COURSE_LEAVE:
	      return _extends({}, state);
	    case _ActionTypes.REQUEST_COURSE_LEAVE_SUCCESS:
	      return _extends({}, state);
	    case _ActionTypes.REQUEST_COURSE_LEAVE_FAILURE:
	      return _extends({}, state, {
	        coursesError: action.error
	      });
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapCourseTimes, 'mapCourseTimes', 'D:/a/1/s/src/web/employee/src/reducers/coursesReducer.js');
	
	  __REACT_HOT_LOADER__.register(renderTimeDuration, 'renderTimeDuration', 'D:/a/1/s/src/web/employee/src/reducers/coursesReducer.js');
	
	  __REACT_HOT_LOADER__.register(mapCourse, 'mapCourse', 'D:/a/1/s/src/web/employee/src/reducers/coursesReducer.js');
	
	  __REACT_HOT_LOADER__.register(mapEmplyeeCourses, 'mapEmplyeeCourses', 'D:/a/1/s/src/web/employee/src/reducers/coursesReducer.js');
	
	  __REACT_HOT_LOADER__.register(coursesReducer, 'coursesReducer', 'D:/a/1/s/src/web/employee/src/reducers/coursesReducer.js');
	}();

	;

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.mapEducation = mapEducation;
	exports.default = educationReducer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _ActionTypes = __webpack_require__(18);
	
	var _DataTypes = __webpack_require__(85);
	
	var _EmployeeMasterEducation = __webpack_require__(901);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapEducation(e) {
	  return {
	    fields: _EmployeeMasterEducation.fields,
	    detailFields: _EmployeeMasterEducation.detailFields,
	    entityMap: _EmployeeMasterEducation.entityMap,
	    Entity: e.Entity,
	    EducationTypeName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.type' })
	      ),
	      value: e.EducationTypeName,
	      type: _DataTypes.STRING,
	      entity: 'EducationType'
	    },
	    EducationHrSchoolName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.school' })
	      ),
	      value: e.EducationHrSchoolName,
	      type: _DataTypes.STRING,
	      entity: 'EducationHrSchoolID'
	    },
	    EducationHrDegreeName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.degree' })
	      ),
	      value: e.EducationHrDegreeName,
	      type: _DataTypes.STRING,
	      entity: 'EducationHrDegreeID'
	    },
	    EducationHrBranchOfStudy1Name: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.branch1' })
	      ),
	      value: e.EducationHrBranchOfStudy1Name,
	      type: _DataTypes.STRING,
	      entity: 'EducationHrBranchOfStudy1ID'
	    },
	    EducationHrBranchOfStudy2Name: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.branch2' })
	      ),
	      value: e.EducationHrBranchOfStudy2Name,
	      type: _DataTypes.STRING,
	      entity: 'EducationHrBranchOfStudy2ID'
	    },
	    EducationPeriodBegda: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.start' })
	      ),
	      value: (0, _dateTools2.default)(e.EducationPeriodBegda),
	      type: _DataTypes.DATE,
	      entity: 'EducationPeriodBegda'
	    },
	    EducationPeriodEnda: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.end' })
	      ),
	      value: (0, _dateTools2.default)(e.EducationPeriodEnda),
	      type: _DataTypes.DATE,
	      entity: 'EducationPeriodEnda'
	    },
	    EducationGrade: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.grade' })
	      ),
	      value: e.EducationGrade,
	      type: _DataTypes.STRING,
	      entity: 'EducationGrade'
	    },
	    EducationHighestText: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.highest' })
	      ),
	      value: e.EducationHighestText,
	      type: _DataTypes.STRING,
	      entity: 'EducationHighest'
	    },
	    EducationFurtherInfo: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.info' })
	      ),
	      value: e.EducationFurtherInfo,
	      type: _DataTypes.STRING,
	      entity: 'EducationFurtherInfo'
	    },
	    EducationCountryName: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.country' })
	      ),
	      value: e.EducationCountryName,
	      type: _DataTypes.STRING
	    }
	  };
	}
	
	function educationReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.REQUEST_EDUCATION:
	      {
	        return _extends({}, state, action);
	      }
	    case _ActionTypes.REQUEST_EDUCATION_FAILURE:
	      {
	        return _extends({}, state, action);
	      }
	    case _ActionTypes.REQUEST_EDUCATION_SUCCESS:
	      {
	        return _extends({}, state, action, {
	          educationData: action.employeeMasterEducationList.map(mapEducation)
	        });
	      }
	    default:
	      {
	        return state;
	      }
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapEducation, 'mapEducation', 'D:/a/1/s/src/web/employee/src/reducers/educationReducer.js');
	
	  __REACT_HOT_LOADER__.register(educationReducer, 'educationReducer', 'D:/a/1/s/src/web/employee/src/reducers/educationReducer.js');
	}();

	;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.mapLoans = mapLoans;
	exports.default = loansReducer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _ActionTypes = __webpack_require__(18);
	
	var _EmployeeMasterObjectOnLoan = __webpack_require__(902);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapLoans(q) {
	  return {
	    fields: _EmployeeMasterObjectOnLoan.fields,
	    detailFields: _EmployeeMasterObjectOnLoan.detailFields,
	    entityMap: _EmployeeMasterObjectOnLoan.entityMap,
	    Entity: q.Entity,
	    ObjectTypeName: {
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loan.type' }),
	      value: q.ObjectTypeName,
	      entity: 'ObjectType'
	    },
	    Amount: {
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loan.amount' }),
	      value: q.Amount,
	      entity: 'Amount'
	    },
	    Pieces: {
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loan.pieces' }),
	      value: q.Pieces,
	      entity: 'Pieces'
	    },
	    ObjectNumber: {
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loan.objectNumber' }),
	      value: q.ObjectNumber,
	      entity: 'ObjectNumber'
	    },
	    Begda: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loan.begda' })
	      ),
	      value: (0, _dateTools2.default)(q.Begda),
	      entity: 'Begda'
	    },
	    Endda: {
	      label: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loan.endda' })
	      ),
	      value: (0, _dateTools2.default)(q.Endda),
	      entity: 'Endda'
	    }
	  };
	}
	
	function loansReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.REQUEST_LOANS:
	      return _extends({}, state, {
	        loaded: false,
	        isFetching: true,
	        loansData: []
	      });
	
	    case _ActionTypes.REQUEST_LOANS_FAILURE:
	      return _extends({}, state, {
	        loaded: true,
	        isFetching: false,
	        error: action.error,
	        loansData: []
	      });
	
	    case _ActionTypes.REQUEST_LOANS_SUCCESS:
	      return _extends({}, state, {
	        loaded: true,
	        isFetching: false,
	        lastUpdated: action.receivedAt,
	        loansData: action.loansData.map(mapLoans)
	      });
	
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapLoans, 'mapLoans', 'D:/a/1/s/src/web/employee/src/reducers/loansReducer.js');
	
	  __REACT_HOT_LOADER__.register(loansReducer, 'loansReducer', 'D:/a/1/s/src/web/employee/src/reducers/loansReducer.js');
	}();

	;

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.mapQualification = mapQualification;
	exports.default = qualificationReducer;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _ActionTypes = __webpack_require__(18);
	
	var _DataTypes = __webpack_require__(85);
	
	var _EmployeeMasterQualification = __webpack_require__(903);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapQualification(q) {
	  return {
	    fields: _EmployeeMasterQualification.fields,
	    detailFields: _EmployeeMasterQualification.detailFields,
	    entityMap: _EmployeeMasterQualification.entityMap,
	    Entity: q.Entity,
	    HrQualificationScaleID: {
	      value: q.HrQualificationScaleID,
	      entity: 'HrQualificationScaleID'
	    },
	    QualificationTypeName: {
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qualification.type' }),
	      value: q.QualificationTypeName,
	      type: _DataTypes.STRING,
	      entity: 'QualificationType'
	    },
	    QualificationName: {
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qualification.name' }),
	      value: q.QualificationName,
	      type: _DataTypes.STRING,
	      entity: 'HrQualificationID'
	    },
	    HrQualificationScaleEntryName: {
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qualification.scale' }),
	      value: q.HrQualificationScaleEntryName,
	      type: _DataTypes.STRING,
	      entity: 'HrQualificationScaleEntryID'
	    }
	  };
	}
	
	function qualificationReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.REQUEST_QUALIFICATION:
	      return _extends({}, state, {
	        loaded: false,
	        isFetching: true,
	        qualificationData: []
	      });
	
	    case _ActionTypes.REQUEST_QUALIFICATION_FAILURE:
	      return _extends({}, state, {
	        loaded: true,
	        isFetching: false,
	        error: action.error,
	        qualificationData: []
	      });
	
	    case _ActionTypes.REQUEST_QUALIFICATION_SUCCESS:
	      return _extends({}, state, {
	        loaded: true,
	        isFetching: false,
	        lastUpdated: action.receivedAt,
	        qualificationData: action.qualificationData.map(mapQualification)
	      });
	
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapQualification, 'mapQualification', 'D:/a/1/s/src/web/employee/src/reducers/qualificationReducer.js');
	
	  __REACT_HOT_LOADER__.register(qualificationReducer, 'qualificationReducer', 'D:/a/1/s/src/web/employee/src/reducers/qualificationReducer.js');
	}();

	;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _materialUi = __webpack_require__(17);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { getSettingsByKey, setSettingByKey } from '../utils/localSettings';
	
	var Pagination = function Pagination(_ref) {
	  var data = _ref.data,
	      itemsPerPage = _ref.itemsPerPage,
	      setItemsPerPage = _ref.setItemsPerPage,
	      currentPage = _ref.currentPage,
	      setCurrentPage = _ref.setCurrentPage,
	      children = _ref.children;
	
	  // const [currentPage, setCurrentPage] = useState(1);
	  // const [itemsPerPage, setItemsPerPage] = useState(initialItemsPerPage);
	
	  var totalPages = (0, _react.useMemo)(function () {
	    return Math.ceil(data.length / itemsPerPage);
	  }, [data.length, itemsPerPage]);
	  var currentData = (0, _react.useMemo)(function () {
	    var startIndex = (currentPage - 1) * itemsPerPage;
	    var endIndex = startIndex + itemsPerPage;
	    return data.slice(startIndex, endIndex);
	  }, [data, currentPage, itemsPerPage]);
	
	  var goToPage = function goToPage(page) {
	    if (page >= 1 && page <= totalPages) {
	      setCurrentPage(page);
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    null,
	    children(currentData),
	    _react2.default.createElement(
	      'div',
	      { className: 'pagination', style: { display: 'flex', justifyContent: 'end', padding: 8 } },
	      _react2.default.createElement(
	        'div',
	        { style: { marginTop: 3 } },
	        _react2.default.createElement(
	          _materialUi.RaisedButton,
	          { style: { minWidth: 30, marginRight: 12 }, onClick: function onClick() {
	              return goToPage(currentPage - 1);
	            } },
	          '<'
	        ),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Pagination.TotalPages', values: { page: currentPage, pages: totalPages } }),
	        _react2.default.createElement(
	          _materialUi.RaisedButton,
	          { style: { minWidth: 30, marginLeft: 12 }, onClick: function onClick() {
	              return goToPage(currentPage + 1);
	            } },
	          '>'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _materialUi.SelectField,
	          {
	            style: { marginLeft: 12, marginRight: 8, width: 140 },
	            value: itemsPerPage,
	            onChange: function onChange(event, index, value) {
	              setItemsPerPage(value);
	              data.length ? setCurrentPage(1) : setCurrentPage(0);
	            }
	          },
	          _react2.default.createElement(_materialUi.MenuItem, { value: 10, primaryText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Pagination.PerPage', values: { items: 10 } }) }),
	          _react2.default.createElement(_materialUi.MenuItem, { value: 20, primaryText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Pagination.PerPage', values: { items: 20 } }) }),
	          _react2.default.createElement(_materialUi.MenuItem, { value: 50, primaryText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Pagination.PerPage', values: { items: 50 } }) }),
	          _react2.default.createElement(_materialUi.MenuItem, { value: 100, primaryText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Pagination.PerPage', values: { items: 100 } }) })
	        )
	      )
	    )
	  );
	};
	
	Pagination.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  data: _propTypes2.default.array.isRequired,
	  itemsPerPage: _propTypes2.default.number.isRequired,
	  setItemsPerPage: _propTypes2.default.func.isRequired,
	  currentPage: _propTypes2.default.number.isRequired,
	  setCurrentPage: _propTypes2.default.func.isRequired
	};
	
	var _default = Pagination;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Pagination, 'Pagination', 'D:/a/1/s/src/web/employee/src/shared/Pagination.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/shared/Pagination.js');
	}();

	;

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Table = __webpack_require__(273);
	
	var _lodash = __webpack_require__(8);
	
	var _actions = __webpack_require__(987);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  tag: {
	    fontSize: 14,
	    color: 'white',
	    borderRadius: 24,
	    padding: 6,
	    textAlign: 'center',
	    width: 80
	  },
	  tableColumn: {
	    whiteSpace: 'normal',
	    width: 120
	  }
	};
	
	var ApprovalRequests = function ApprovalRequests() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      approvalRequestsReducer = _useSelector.approvalRequestsReducer;
	
	  var approvalRequests = approvalRequestsReducer.approvalRequests,
	      error = approvalRequestsReducer.error,
	      hasError = approvalRequestsReducer.hasError,
	      loading = approvalRequestsReducer.loading;
	
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _actions.fetchApprovalRequests)());
	  }, [dispatch]);
	  var getTag = function getTag(status) {
	    switch (status) {
	      case 'Pending':
	      case 'Expired':
	        return _react2.default.createElement(
	          'div',
	          { style: _extends({}, styles.tag, { backgroundColor: _colors2.default.grey }) },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approval.status.Pending' })
	        );
	      case 'Accepted':
	        return _react2.default.createElement(
	          'div',
	          { style: _extends({}, styles.tag, { backgroundColor: _colors2.default.successColor }) },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approval.status.Accepted' })
	        );
	      case 'Rejected':
	        return _react2.default.createElement(
	          'div',
	          { style: _extends({}, styles.tag, { backgroundColor: _colors2.default.errorColor }) },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approval.status.Rejected' })
	        );
	      case 'Canceled':
	        return _react2.default.createElement(
	          'div',
	          { style: _extends({}, styles.tag, { backgroundColor: _colors2.default.warningColor }) },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approval.status.Canceled' })
	        );
	      default:
	        return null;
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    { style: { maxWidth: 960, margin: 'auto' } },
	    _react2.default.createElement(
	      'div',
	      { style: { margin: 16 } },
	      _react2.default.createElement(_KTitle2.default, { containerStyle: { maxWidth: 1400, margin: 'auto' }, key: 'hb', title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dash.title.approvals' }) })
	    ),
	    loading && _react2.default.createElement(_Loading2.default, { height: '70vh' }),
	    !loading && hasError && _react2.default.createElement(_PanelMessage2.default, {
	      type: 'error',
	      iconName: 'error',
	      message: error && error.Message ? error.Message : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvals.error' })
	    }),
	    _react2.default.createElement(
	      _materialUi.Table,
	      { selectable: false },
	      _react2.default.createElement(
	        _Table.TableHeader,
	        { displaySelectAll: false, adjustForCheckbox: false },
	        _react2.default.createElement(
	          _Table.TableRow,
	          null,
	          _react2.default.createElement(
	            _Table.TableHeaderColumn,
	            { styles: styles.tableColumn },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approval.type' })
	          ),
	          _react2.default.createElement(
	            _Table.TableHeaderColumn,
	            { styles: styles.tableColumn },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approval.date.from' })
	          ),
	          _react2.default.createElement(
	            _Table.TableHeaderColumn,
	            { styles: styles.tableColumn },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approval.date.to' })
	          ),
	          _react2.default.createElement(
	            _Table.TableHeaderColumn,
	            { styles: styles.tableColumn },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approval.status' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Table.TableBody,
	        { displayRowCheckbox: false },
	        !loading && (0, _lodash.map)(approvalRequests, function (_ref) {
	          var EmployeeDetailApprovalRequestType = _ref.EmployeeDetailApprovalRequestType,
	              PeriodBegda = _ref.PeriodBegda,
	              PeriodEndda = _ref.PeriodEndda,
	              ApprovalRequestStatus = _ref.ApprovalRequestStatus;
	          return _react2.default.createElement(
	            _Table.TableRow,
	            null,
	            _react2.default.createElement(
	              _Table.TableRowColumn,
	              { styles: styles.tableColumn },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approval.type.' + EmployeeDetailApprovalRequestType })
	            ),
	            _react2.default.createElement(
	              _Table.TableRowColumn,
	              { styles: styles.tableColumn },
	              PeriodBegda && (0, _moment2.default)(PeriodBegda).format('DD.MM.YYYY')
	            ),
	            _react2.default.createElement(
	              _Table.TableRowColumn,
	              { styles: styles.tableColumn },
	              PeriodEndda && (0, _moment2.default)(PeriodEndda).format('DD.MM.YYYY')
	            ),
	            _react2.default.createElement(
	              _Table.TableRowColumn,
	              { styles: styles.tableColumn },
	              getTag(ApprovalRequestStatus)
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	var _default = ApprovalRequests;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/ApprovalRequests.js');
	
	  __REACT_HOT_LOADER__.register(ApprovalRequests, 'ApprovalRequests', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/ApprovalRequests.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/ApprovalRequests.js');
	}();

	;

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(8);
	
	var _sortInternational = __webpack_require__(810);
	
	var _sortInternational2 = _interopRequireDefault(_sortInternational);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactDatepicker = __webpack_require__(211);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _actions = __webpack_require__(992);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _InOutTable = __webpack_require__(991);
	
	var _InOutTable2 = _interopRequireDefault(_InOutTable);
	
	var _localSettings = __webpack_require__(187);
	
	var _constants = __webpack_require__(226);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var labelStyle = {
	  display: 'inline-block',
	  padding: 12,
	  color: 'white',
	  marginRight: 6
	};
	
	var InOut = function InOut(_ref) {
	  var inOutInitialize = _ref.inOutInitialize,
	      setTimePeriod = _ref.setTimePeriod,
	      datesBetween = _ref.datesBetween,
	      start = _ref.start,
	      end = _ref.end,
	      error = _ref.error,
	      hasError = _ref.hasError,
	      clockTypesById = _ref.clockTypesById,
	      initializeFailed = _ref.initializeFailed,
	      language = _ref.language,
	      employees = _ref.employees,
	      orgCompanyUnits = _ref.orgCompanyUnits,
	      loading = _ref.loading,
	      initializing = _ref.initializing,
	      initialized = _ref.initialized,
	      inOutFilters = _ref.inOutFilters;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      companyUnits = _useState2[0],
	      setCompanyUnits = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      dataSource = _useState4[0],
	      setDataSource = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      clockEntryTypes = _useState6[0],
	      setClockEntryTypes = _useState6[1];
	
	  var _useState7 = (0, _react.useState)((0, _localSettings.getSettingByKey)(_constants.IN_OUT_FILTERS) || {
	    orgCompanyUnitId: [0],
	    employeeId: [],
	    typeId: []
	  }),
	      _useState8 = _slicedToArray(_useState7, 2),
	      selectedValues = _useState8[0],
	      setSelectedValues = _useState8[1];
	
	  var inOutExtraTypes = [{ id: 'absence', value: language === 'is' ? 'Fjarvera' : 'Absence' }];
	
	  (0, _react.useEffect)(function () {
	    if (!(0, _lodash.isEmpty)(clockTypesById)) {
	      setClockEntryTypes((0, _lodash.map)(clockTypesById));
	    }
	  }, [clockTypesById]);
	
	  (0, _react.useEffect)(function () {
	    if (inOutFilters) {
	      setSelectedValues(inOutFilters);
	    }
	  }, [inOutFilters]);
	
	  (0, _react.useEffect)(function () {
	    inOutInitialize();
	  }, []);
	
	  var filterByType = function filterByType(data) {
	    var result = [];
	    var typeId = selectedValues.typeId;
	
	    if (!typeId.length) {
	      return data;
	    }
	    (0, _lodash.map)(data, function (emp) {
	      var clocksFiltered = [];
	      if (typeId.includes('absence')) {
	        clocksFiltered = (0, _lodash.filter)(emp.ClockCardEntries, function (c) {
	          return !c.Active || c.Active && typeId.includes(c.ClockCardEntryTypeName_EN);
	        });
	      } else {
	        clocksFiltered = (0, _lodash.filter)(emp.ClockCardEntries, function (c) {
	          return c.Active && typeId.includes(c.ClockCardEntryTypeName_EN);
	        });
	      }
	      if (clocksFiltered.length) {
	        result.push(_extends({}, emp, { ClockCardEntries: clocksFiltered }));
	      }
	    });
	    return result;
	  };
	
	  var filterByEmployee = function filterByEmployee() {
	    var employeeId = selectedValues.employeeId;
	
	    if (employeeId.length) {
	      var filtered = (0, _lodash.filter)(employees, function (e) {
	        return employeeId.includes(e.EmployeeDetailID);
	      });
	      return filtered.length ? filtered : employees;
	    }
	    return employees;
	  };
	
	  var filterData = function filterData() {
	    if (selectedValues.orgCompanyUnitId.length === 0) {
	      setDataSource([]);
	    } else {
	      var data = filterByEmployee();
	      var result = filterByType(data);
	      setDataSource(result);
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    filterData();
	  }, [selectedValues]);
	
	  (0, _react.useEffect)(function () {
	    filterData();
	  }, [employees]);
	
	  (0, _react.useEffect)(function () {
	    if (initialized) {
	      var nullOption = { OrgCompanyUnitID: null, OrgCompanyUnitName: language === 'is' ? 'Velja allar' : 'Select all' };
	      setCompanyUnits([nullOption].concat(_toConsumableArray(orgCompanyUnits.sort((0, _sortInternational2.default)('OrgCompanyUnitName')))));
	    }
	  }, [initialized, orgCompanyUnits]);
	
	  if (initializing) return _react2.default.createElement(_Loading2.default, null);
	
	  if (initializeFailed || hasError) {
	    return _react2.default.createElement(_PanelMessage2.default, {
	      message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.initialize.error', values: { error: error } }),
	      iconName: 'error',
	      type: 'error'
	    });
	  }
	
	  var isPeriod = (0, _moment2.default)(end).format('DD/MM/YYYY') === (0, _moment2.default)(start).add(1, 'month').add(-1, 'day').format('DD/MM/YYYY');
	
	  var isMonth = (0, _moment2.default)(start).format('DD/MM/YYYY') === (0, _moment2.default)(start).startOf('month').format('DD/MM/YYYY') && (0, _moment2.default)(end).format('DD/MM/YYYY') === (0, _moment2.default)(end).endOf('month').format('DD/MM/YYYY');
	
	  var setLastPeriod = function setLastPeriod() {
	    if (isMonth) {
	      setTimePeriod((0, _moment2.default)(start).add(-1, 'month'), (0, _moment2.default)(end).add(-1, 'month').endOf('month'), (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	    } else if (isPeriod) {
	      setTimePeriod((0, _moment2.default)(start).add(-1, 'month'), (0, _moment2.default)(start).add(-1, 'day'), (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	    } else {
	      var numberOfDays = (0, _moment2.default)(end).diff(start, 'days') + 1;
	      setTimePeriod((0, _moment2.default)(start).add(-numberOfDays, 'days'), (0, _moment2.default)(end).add(-numberOfDays, 'days'), (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	    }
	  };
	
	  var setNextPeriod = function setNextPeriod() {
	    if (isMonth) {
	      setTimePeriod((0, _moment2.default)(start).add(1, 'month'), (0, _moment2.default)(end).add(1, 'month').endOf('month'), (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	    } else if (isPeriod) {
	      setTimePeriod((0, _moment2.default)(start).add(1, 'month'), (0, _moment2.default)(start).add(2, 'month').add(-1, 'day'), (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	    } else {
	      var numberOfDays = (0, _moment2.default)(end).diff(start, 'days') + 1;
	      setTimePeriod((0, _moment2.default)(start).add(numberOfDays, 'days'), (0, _moment2.default)(end).add(numberOfDays, 'days'), (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	    }
	  };
	  var setStartDate = function setStartDate(date) {
	    setTimePeriod(date, end, (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	  };
	
	  var setEndDate = function setEndDate(date) {
	    setTimePeriod(start, date, (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	  };
	
	  var getTitle = function getTitle(date) {
	    return _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'div',
	        null,
	        date.dateString.substring(0, 5)
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        date.dayOfWeek
	      )
	    );
	  };
	
	  var dateTable = {
	    key: 'TeriaEmployeeCafeteriaPurchaseID',
	    columns: [{ title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'name' }), dataIndex: 'EmployeeName', width: 220 }].concat(_toConsumableArray((0, _lodash.map)(datesBetween, function (d) {
	      return _extends({
	        title: getTitle(d), dataIndex: d.dateString, width: 40 }, d);
	    })))
	  };
	
	  var onCompanyUnitChange = function onCompanyUnitChange(unitIds) {
	    var ids = [];
	    if (unitIds.includes(null)) {
	      if (unitIds[unitIds.length - 1] === null) {
	        // if last element is null, then all units are selected
	        var allIds = (0, _lodash.map)(companyUnits.slice(1), 'OrgCompanyUnitID');
	        ids = [null];
	        setTimePeriod(start, end, allIds);
	      } else {
	        // user selects other unit after selecting all
	        ids = (0, _lodash.filter)(unitIds, function (val) {
	          return val;
	        });
	        setTimePeriod(start, end, ids);
	      }
	    } else {
	      ids = unitIds;
	      setTimePeriod(start, end, unitIds);
	    }
	    (0, _localSettings.setSettingByKey)(_constants.IN_OUT_FILTERS, _extends({}, selectedValues, { orgCompanyUnitId: ids }));
	    setSelectedValues(_extends({}, selectedValues, { orgCompanyUnitId: ids }));
	  };
	  var onEmployeeChange = function onEmployeeChange(empId) {
	    (0, _localSettings.setSettingByKey)(_constants.IN_OUT_FILTERS, _extends({}, selectedValues, { employeeId: empId }));
	    setSelectedValues(_extends({}, selectedValues, { employeeId: empId }));
	  };
	  var onTypeChange = function onTypeChange(type) {
	    (0, _localSettings.setSettingByKey)(_constants.IN_OUT_FILTERS, _extends({}, selectedValues, { typeId: type }));
	    setSelectedValues(_extends({}, selectedValues, { typeId: type }));
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: { maxWidth: 1400, margin: 'auto' } },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_KTitle2.default, { containerStyle: { marginTop: 12 }, key: 'hb', title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'inOut.title' }) })
	      ),
	      _react2.default.createElement(
	        _reactFlexboxGrid.Row,
	        { middle: 'xs', center: 'xs' },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              display: 'flex',
	              alignItems: 'center',
	              paddingTop: 12,
	              justifyContent: 'space-between'
	            }
	          },
	          _react2.default.createElement(
	            _materialUi.IconButton,
	            { onClick: setLastPeriod, style: { marginRight: 12 } },
	            _react2.default.createElement(
	              _materialUi.FontIcon,
	              { className: 'material-icons' },
	              'arrow_back'
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: 18, fontWeight: 400 } },
	            _react2.default.createElement(_reactDatepicker2.default, {
	              className: 'smallPicker',
	              selected: (0, _moment2.default)(start),
	              onChange: setStartDate,
	              dateFormat: 'DD.MMM YYYY',
	              selectsStart: true,
	              startDate: (0, _moment2.default)(start),
	              endDate: (0, _moment2.default)(end)
	            }),
	            ' - ',
	            _react2.default.createElement(_reactDatepicker2.default, {
	              selected: (0, _moment2.default)(end),
	              onChange: setEndDate,
	              dateFormat: 'DD.MMM YYYY',
	              selectsEnd: true,
	              startDate: (0, _moment2.default)(start),
	              endDate: (0, _moment2.default)(end),
	              minDate: (0, _moment2.default)(start)
	            })
	          ),
	          _react2.default.createElement(
	            _materialUi.IconButton,
	            { onClick: setNextPeriod, style: { marginLeft: 12 } },
	            _react2.default.createElement(
	              _materialUi.FontIcon,
	              { className: 'material-icons' },
	              'arrow_forward'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { marginTop: 12 } },
	        (0, _lodash.map)(clockEntryTypes, function (type) {
	          return _react2.default.createElement(
	            'div',
	            { key: type.id, style: _extends({}, labelStyle, { backgroundColor: type.color }) },
	            type.value_short,
	            ' - ',
	            type.value
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: _extends({}, labelStyle, { backgroundColor: _colors2.default.errorColor }) },
	          'FV - ',
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'inOut.type.absence' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: _extends({}, labelStyle, { backgroundColor: _colors2.default.warningColor }) },
	          '* - ',
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'inOut.type.moreThanOne' })
	        )
	      ),
	      _react2.default.createElement(
	        _reactFlexboxGrid.Row,
	        { style: { maxWidth: 1400, margin: 'auto' } },
	        _react2.default.createElement(
	          _materialUi.SelectField,
	          {
	            multiple: true,
	            style: { width: 360, marginRight: 12 },
	            floatingLabelFixed: true,
	            floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.department' }),
	            value: (0, _lodash.get)(selectedValues, 'orgCompanyUnitId').length && (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'),
	            onChange: function onChange(event, index, value) {
	              return onCompanyUnitChange(value);
	            }
	          },
	          (0, _lodash.map)(companyUnits, function (_ref2) {
	            var OrgCompanyUnitID = _ref2.OrgCompanyUnitID,
	                OrgCompanyUnitName = _ref2.OrgCompanyUnitName;
	            return _react2.default.createElement(_materialUi.MenuItem, {
	              key: OrgCompanyUnitID,
	              value: OrgCompanyUnitID,
	              primaryText: OrgCompanyUnitName,
	              insetChildren: true,
	              checked: (0, _lodash.get)(selectedValues, 'unitId') && (0, _lodash.get)(selectedValues, 'unitId').indexOf(OrgCompanyUnitID) > -1
	            });
	          })
	        ),
	        _react2.default.createElement(
	          _materialUi.SelectField,
	          {
	            multiple: true,
	            style: { width: 280, marginRight: 12 },
	            floatingLabelFixed: true,
	            floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employee' }),
	            value: (0, _lodash.get)(selectedValues, 'employeeId'),
	            onChange: function onChange(event, index, value) {
	              return onEmployeeChange(value);
	            },
	            disabled: loading
	          },
	          (0, _lodash.map)([].concat(_toConsumableArray(employees)), function (_ref3) {
	            var EmployeeDetailID = _ref3.EmployeeDetailID,
	                EmployeeName = _ref3.EmployeeName;
	            return _react2.default.createElement(_materialUi.MenuItem, {
	              key: EmployeeDetailID,
	              value: EmployeeDetailID,
	              primaryText: EmployeeName,
	              insetChildren: true,
	              checked: (0, _lodash.get)(selectedValues, 'employeeId') && (0, _lodash.get)(selectedValues, 'employeeId').indexOf(EmployeeDetailID) > -1
	            });
	          })
	        ),
	        _react2.default.createElement(
	          _materialUi.SelectField,
	          {
	            multiple: true,
	            style: { width: 200 },
	            floatingLabelFixed: true,
	            floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'inOut.type' }),
	            value: (0, _lodash.get)(selectedValues, 'typeId'),
	            onChange: function onChange(event, index, value) {
	              return onTypeChange(value);
	            },
	            disabled: loading
	          },
	          (0, _lodash.map)([].concat(inOutExtraTypes, _toConsumableArray(clockEntryTypes)), function (_ref4) {
	            var id = _ref4.id,
	                value = _ref4.value;
	            return _react2.default.createElement(_materialUi.MenuItem, {
	              key: id,
	              value: id,
	              primaryText: value,
	              insetChildren: true,
	              checked: (0, _lodash.get)(selectedValues, 'typeId') && (0, _lodash.get)(selectedValues, 'typeId').indexOf(id) > -1
	            });
	          })
	        )
	      ),
	      datesBetween.length ? _react2.default.createElement(_InOutTable2.default, { table: dateTable, entries: dataSource }) : null
	    )
	  );
	};
	
	InOut.propTypes = {
	  clockTypesById: _propTypes2.default.PropTypes.shape({}).isRequired,
	  datesBetween: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
	  inOutInitialize: _propTypes2.default.func.isRequired,
	  setTimePeriod: _propTypes2.default.func.isRequired,
	  hasError: _propTypes2.default.bool.isRequired,
	  initializeFailed: _propTypes2.default.bool.isRequired,
	  start: _propTypes2.default.shape({}).isRequired,
	  end: _propTypes2.default.shape({}).isRequired,
	  error: _propTypes2.default.string,
	  language: _propTypes2.default.string.isRequired,
	  employees: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
	  orgCompanyUnits: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
	  loading: _propTypes2.default.bool.isRequired,
	  initializing: _propTypes2.default.bool.isRequired,
	  initialized: _propTypes2.default.bool.isRequired,
	  inOutFilters: _propTypes2.default.shape({}).isRequired
	};
	
	InOut.defaultProps = {
	  error: null
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref5) {
	  var inOutReducer = _ref5.inOutReducer,
	      languageReducer = _ref5.languageReducer;
	  return _extends({}, inOutReducer, languageReducer);
	}, function (dispatch) {
	  return {
	    inOutInitialize: function inOutInitialize() {
	      return dispatch((0, _actions.initialize)());
	    },
	    setTimePeriod: function setTimePeriod(from, to, unitId) {
	      return dispatch((0, _actions.changePeriod)(from, to, unitId));
	    }
	  };
	})(InOut);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(labelStyle, 'labelStyle', 'D:/a/1/s/src/web/employee/src/sites/inOut/InOut.js');
	
	  __REACT_HOT_LOADER__.register(InOut, 'InOut', 'D:/a/1/s/src/web/employee/src/sites/inOut/InOut.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/inOut/InOut.js');
	}();

	;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _base = __webpack_require__(455);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _actions = __webpack_require__(996);
	
	var _normalize = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Paytickets = function Paytickets() {
	  var _useState = (0, _react.useState)(new Date().getFullYear() - 1),
	      _useState2 = _slicedToArray(_useState, 2),
	      payYear = _useState2[0],
	      setPayYear = _useState2[1];
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      payticketReducer = _useSelector.payticketReducer,
	      languageReducer = _useSelector.languageReducer;
	
	  var paytickets = payticketReducer.paytickets,
	      payYearOptions = payticketReducer.payYearOptions,
	      hasError = payticketReducer.hasError,
	      error = payticketReducer.error,
	      loading = payticketReducer.loading;
	  var language = languageReducer.language;
	
	  _moment2.default.locale(language);
	
	  (0, _react.useEffect)(function () {
	    var lastYear = new Date().getFullYear() - 1;
	    dispatch((0, _actions.fetchUserPaytickets)(lastYear));
	  }, [dispatch]);
	
	  var fetchTicket = function fetchTicket(year) {
	    setPayYear(year);
	    dispatch((0, _actions.fetchUserPaytickets)(year));
	  };
	
	  var setMargin = function setMargin(row, i) {
	    return { marginBottom: row.length - 1 !== i ? 8 : 0 };
	  };
	
	  return _react2.default.createElement(
	    _reactFlexboxGrid.Col,
	    { xs: 12, sm: 12, md: 8, mdOffset: 2, style: { paddingTop: 0, paddingBottom: 16 } },
	    _react2.default.createElement(
	      _materialUi.Subheader,
	      { style: _base2.default.subheader },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payticket.title' })
	    ),
	    _react2.default.createElement(
	      _materialUi.SelectField,
	      {
	        style: { paddingLeft: 16 },
	        className: 'no-print',
	        floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payticket.select' }),
	        value: payYear,
	        onChange: function onChange(a, b, value) {
	          return fetchTicket(value);
	        }
	      },
	      payYearOptions.map(function (y) {
	        return _react2.default.createElement(_materialUi.MenuItem, { key: y, value: y, primaryText: y });
	      })
	    ),
	    loading && _react2.default.createElement(_Loading2.default, { height: '70vh' }),
	    !loading && !hasError && paytickets.length === 0 && _react2.default.createElement(_PanelMessage2.default, { message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payticket.empty' }), type: 'info', iconName: 'info' }),
	    !loading && hasError && _react2.default.createElement(
	      _reactFlexboxGrid.Col,
	      { xs: 12, sm: 12, md: 8, mdOffset: 2, style: { paddingTop: 0, paddingBottom: 16 } },
	      _react2.default.createElement(_PanelMessage2.default, {
	        type: 'error',
	        iconName: 'error',
	        message: error && error.Message ? error.Message : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payticket.error' })
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { maxWidth: 960, margin: 'auto' } },
	      !loading && paytickets.length > 0 && (0, _lodash.map)(paytickets, function (_ref, i) {
	        var firstRow = _ref.firstRow,
	            restRows = _ref.restRows,
	            EmployeeName = _ref.EmployeeName,
	            Address = _ref.Address,
	            PostCode = _ref.PostCode,
	            PostCodeName = _ref.PostCodeName,
	            EntityNR = _ref.EntityNR,
	            Header = _ref.Header;
	        return _react2.default.createElement(
	          _materialUi.Paper,
	          { key: i, style: { marginTop: 24 } },
	          _react2.default.createElement(
	            'div',
	            { className: 'pay-ticket-table-container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'pay-ticket-table-header' },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payticket.ticket' }),
	              ' ',
	              payYear
	            ),
	            _react2.default.createElement(
	              'table',
	              { className: 'pay-ticket-table' },
	              _react2.default.createElement(
	                'tbody',
	                null,
	                _react2.default.createElement(
	                  'tr',
	                  { style: { backgroundColor: '#F5F5F5' } },
	                  _react2.default.createElement(
	                    'th',
	                    { style: { textAlign: 'center', width: 120 } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payticket.column' })
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { textAlign: 'left', width: 300 } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payticket.name' })
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { textAlign: 'right', minWidth: 100 } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payticket.total' })
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { textAlign: 'center', minWidth: 100 } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payticket.field' })
	                  ),
	                  _react2.default.createElement(
	                    'th',
	                    { style: { textAlign: 'right', paddingRight: 36 } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payticket.totalField' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'tr',
	                  null,
	                  _react2.default.createElement(
	                    'td',
	                    { style: { textAlign: 'center' } },
	                    (0, _lodash.map)(firstRow, function (col, index) {
	                      return _react2.default.createElement(
	                        'div',
	                        { key: index, style: setMargin(firstRow, index) },
	                        (0, _lodash.get)(col, 'PaySalaryID')
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    null,
	                    (0, _lodash.map)(firstRow, function (col, index) {
	                      return _react2.default.createElement(
	                        'div',
	                        { key: index, style: setMargin(firstRow, index) },
	                        (0, _lodash.get)(col, 'PaySalaryName')
	                      );
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'td',
	                    { style: { textAlign: 'right' } },
	                    (0, _lodash.map)(firstRow, function (col, index) {
	                      return _react2.default.createElement(
	                        'div',
	                        { key: index, style: setMargin(firstRow, index) },
	                        (0, _normalize.unitRender)((0, _lodash.get)(col, 'Samtals'), 0) + ' kr.'
	                      );
	                    })
	                  ),
	                  _react2.default.createElement('td', null),
	                  _react2.default.createElement('td', null)
	                ),
	                (0, _lodash.map)(restRows, function (row, index) {
	                  return _react2.default.createElement(
	                    'tr',
	                    { key: index },
	                    _react2.default.createElement(
	                      'td',
	                      { style: { textAlign: 'center' } },
	                      (0, _lodash.get)(row, 'PaySalaryID')
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      null,
	                      (0, _lodash.get)(row, 'PaySalaryName')
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { textAlign: 'right' } },
	                      (0, _lodash.get)(row, 'Samtals') && (0, _normalize.unitRender)((0, _lodash.get)(row, 'Samtals'), 0) + ' kr.'
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { textAlign: 'center' } },
	                      (0, _lodash.get)(row, 'SkNr')
	                    ),
	                    _react2.default.createElement(
	                      'td',
	                      { style: { textAlign: 'right', fontWeight: 900, paddingRight: 36 } },
	                      (0, _lodash.get)(row, 'TotalPayField') && (0, _normalize.unitRender)((0, _lodash.get)(row, 'TotalPayField'), 0) + ' kr.'
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'pay-ticket-table-footer' },
	              _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  EmployeeName
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  Address
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  PostCode + ' ' + PostCodeName
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  EntityNR
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: { textAlign: 'right' } },
	                _react2.default.createElement('div', null),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _lodash.get)(Header, 'OrgCompanyName')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _lodash.get)(Header, 'Address')
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  (0, _lodash.get)(Header, 'PostCode') + ' ' + (0, _lodash.get)(Header, 'PostCodeName')
	                )
	              )
	            )
	          )
	        );
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            marginTop: 18,
	            display: 'flex',
	            width: '100%',
	            justifyContent: 'space-between',
	            alignItems: 'end'
	          }
	        },
	        _react2.default.createElement('div', null),
	        !loading && paytickets.length > 0 && _react2.default.createElement(_materialUi.RaisedButton, {
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'print' }),
	          primary: true,
	          onClick: function onClick() {
	            return window.print();
	          },
	          className: 'no-print'
	        })
	      )
	    )
	  );
	};
	
	var _default = Paytickets;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Paytickets, 'Paytickets', 'D:/a/1/s/src/web/employee/src/sites/payTickets/Paytickets.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/payTickets/Paytickets.js');
	}();

	;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactDatepicker = __webpack_require__(211);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _PurchasesTable = __webpack_require__(1000);
	
	var _PurchasesTable2 = _interopRequireDefault(_PurchasesTable);
	
	var _actions = __webpack_require__(1001);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  headline: {
	    fontSize: 24,
	    paddingTop: 16,
	    marginBottom: 12,
	    fontWeight: 400
	  },
	  tab: {
	    wordWrap: 'break-word',
	    whiteSpace: 'normal'
	  }
	};
	
	var Teria = function Teria(_ref) {
	  var teriaInitialize = _ref.teriaInitialize,
	      setTimePeriod = _ref.setTimePeriod,
	      start = _ref.start,
	      end = _ref.end,
	      error = _ref.error,
	      hasError = _ref.hasError,
	      initializeFailed = _ref.initializeFailed;
	
	  var _useState = (0, _react.useState)('CAFE'),
	      _useState2 = _slicedToArray(_useState, 2),
	      activeTab = _useState2[0],
	      setActiveTab = _useState2[1];
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.teriaReducer;
	  }),
	      employeePurchases = _useSelector.employeePurchases,
	      guestPurchases = _useSelector.guestPurchases,
	      showStores = _useSelector.showStores,
	      showCafes = _useSelector.showCafes,
	      loading = _useSelector.loading,
	      initializing = _useSelector.initializing,
	      initialized = _useSelector.initialized;
	
	  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
	    return state.languageReducer;
	  }),
	      language = _useSelector2.language;
	
	  var showBothTabs = showCafes && showStores;
	  var showCafeOnly = showCafes && !showStores;
	  var showStoreOnly = !showCafes && showStores;
	
	  var showBothTables = employeePurchases.length > 0 && guestPurchases.length > 0;
	  var isDataEmpty = !loading && !employeePurchases.length && !guestPurchases.length;
	
	  (0, _react.useEffect)(function () {
	    teriaInitialize();
	  }, []);
	
	  (0, _react.useEffect)(function () {
	    if (initialized) {
	      if (showBothTabs || showCafeOnly) {
	        setActiveTab('CAFE');
	      }
	      if (showStoreOnly) {
	        setActiveTab('STORE');
	      }
	    }
	  }, [initialized]);
	
	  var getTitle = function getTitle() {
	    if (showCafeOnly) return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'teria.cafeteria' });
	    if (showStoreOnly) return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'teria.store' });
	    return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'teria.title' });
	  };
	
	  if (initializing) return _react2.default.createElement(_Loading2.default, null);
	
	  if (initializeFailed || hasError) {
	    return _react2.default.createElement(_PanelMessage2.default, {
	      message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.initialize.error', values: { error: error } }),
	      iconName: 'error',
	      type: 'error'
	    });
	  }
	
	  if (!showCafes && !showStores) {
	    return _react2.default.createElement(_PanelMessage2.default, {
	      message: 'Hvorki m\xF6tuneyti n\xE9 verslun eru \xED notkun.',
	      iconName: 'error',
	      type: 'error'
	    });
	  }
	
	  var isPeriod = (0, _moment2.default)(end).format('DD/MM/YYYY') === (0, _moment2.default)(start).add(1, 'month').add(-1, 'day').format('DD/MM/YYYY');
	
	  var isMonth = (0, _moment2.default)(start).format('DD/MM/YYYY') === (0, _moment2.default)(start).startOf('month').format('DD/MM/YYYY') && (0, _moment2.default)(end).format('DD/MM/YYYY') === (0, _moment2.default)(end).endOf('month').format('DD/MM/YYYY');
	
	  function handleActive(tab) {
	    var type = tab.props.index === 0 ? 'CAFE' : 'STORE';
	    setActiveTab(type);
	    setTimePeriod(start, end, type);
	  }
	
	  var setLastPeriod = function setLastPeriod() {
	    if (isMonth) {
	      setTimePeriod((0, _moment2.default)(start).add(-1, 'month'), (0, _moment2.default)(end).add(-1, 'month').endOf('month'), activeTab);
	    } else if (isPeriod) {
	      setTimePeriod((0, _moment2.default)(start).add(-1, 'month'), (0, _moment2.default)(start).add(-1, 'day'), activeTab);
	    } else {
	      var numberOfDays = (0, _moment2.default)(end).diff(start, 'days') + 1;
	      setTimePeriod((0, _moment2.default)(start).add(-numberOfDays, 'days'), (0, _moment2.default)(end).add(-numberOfDays, 'days'), activeTab);
	    }
	  };
	
	  var setNextPeriod = function setNextPeriod() {
	    if (isMonth) {
	      setTimePeriod((0, _moment2.default)(start).add(1, 'month'), (0, _moment2.default)(end).add(1, 'month').endOf('month'), activeTab);
	    } else if (isPeriod) {
	      setTimePeriod((0, _moment2.default)(start).add(1, 'month'), (0, _moment2.default)(start).add(2, 'month').add(-1, 'day'), activeTab);
	    } else {
	      var numberOfDays = (0, _moment2.default)(end).diff(start, 'days') + 1;
	      setTimePeriod((0, _moment2.default)(start).add(numberOfDays, 'days'), (0, _moment2.default)(end).add(numberOfDays, 'days'), activeTab);
	    }
	  };
	  var setStartDate = function setStartDate(date) {
	    setTimePeriod(date, end);
	  };
	
	  var setEndDate = function setEndDate(date) {
	    setTimePeriod(start, date);
	  };
	
	  var dateColumn = {
	    title: 'time.Date',
	    dataIndex: 'PurchaseDateTime',
	    width: 65,
	    render: function render(dataIndex) {
	      return (0, _moment2.default)(dataIndex).format('DD.MM.YY');
	    }
	  };
	  var priceColumn = {
	    title: 'teria.price',
	    dataIndex: 'Price',
	    width: 65,
	    render: function render(dataIndex) {
	      return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ISK', values: { amount: dataIndex } });
	    }
	  };
	
	  var employeeTable = {
	    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employee' }),
	    key: 'TeriaEmployeeCafeteriaPurchaseID',
	    columns: [dateColumn, { title: 'teria.cafeteria', dataIndex: 'CafeteriaName', width: 110 }, priceColumn, {
	      title: 'teria.cafeteria.description',
	      dataIndex: language === 'is' ? 'Description' : 'DescriptionAlternative',
	      width: 110
	    }, { title: 'teria.cafeteria.type', dataIndex: 'IsGuestPurchase', render: function render(isGuest) {
	        return _react2.default.createElement(_reactIntl.FormattedMessage, { id: isGuest ? 'teria.cafeteria.employeeGuest' : 'employee' });
	      } }]
	  };
	  var guestTable = {
	    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'teria.guests' }),
	    key: 'TeriaEmployeeCafeteriaCompanyGuestPurchaseID',
	    columns: [dateColumn, { title: 'teria.cafeteria', dataIndex: 'CafeteriaName' }, priceColumn]
	  };
	  var employeeTableStore = {
	    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'teria.cafeteria' }),
	    key: 'TeriaEmployeeStorePurchases',
	    columns: [dateColumn, { title: 'teria.product', dataIndex: 'ProductName' }, priceColumn, { title: 'teria.store', dataIndex: 'StoreName' }]
	  };
	
	  var renderCafeteriaContent = _react2.default.createElement(
	    _reactFlexboxGrid.Row,
	    { style: { maxWidth: 1400, margin: 'auto' } },
	    isDataEmpty ? _react2.default.createElement(
	      'div',
	      { style: { margin: 'auto', marginTop: 24 } },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'teria.noProducts' })
	    ) : null,
	    loading ? _react2.default.createElement(_materialUi.LinearProgress, { mode: 'indeterminate', style: { marginTop: 24 } }) : null,
	    _react2.default.createElement(
	      _reactFlexboxGrid.Col,
	      { lg: showBothTables ? 6 : 12, md: 12 },
	      employeePurchases.length ? _react2.default.createElement(_PurchasesTable2.default, { table: employeeTable, entries: employeePurchases, showTitle: showBothTables }) : null
	    ),
	    _react2.default.createElement(
	      _reactFlexboxGrid.Col,
	      { lg: showBothTables ? 6 : 12, md: 12 },
	      guestPurchases.length ? _react2.default.createElement(_PurchasesTable2.default, { table: guestTable, entries: guestPurchases, showTitle: guestPurchases.length > 0 }) : null
	    )
	  );
	
	  var renderStoreContent = _react2.default.createElement(
	    _reactFlexboxGrid.Row,
	    { style: { maxWidth: 1400, margin: 'auto' } },
	    loading ? _react2.default.createElement(_materialUi.LinearProgress, { mode: 'indeterminate', style: { marginTop: 24 } }) : null,
	    isDataEmpty ? _react2.default.createElement(
	      'div',
	      { style: { margin: 'auto', marginTop: 24 } },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'teria.noProducts' })
	    ) : null,
	    _react2.default.createElement(
	      _reactFlexboxGrid.Col,
	      { lg: showBothTables ? 6 : 12, md: 12 },
	      employeePurchases.length ? _react2.default.createElement(_PurchasesTable2.default, { table: employeeTableStore, entries: employeePurchases, showTitle: showBothTables }) : null
	    )
	  );
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_KTitle2.default, { containerStyle: { maxWidth: 1400, margin: 'auto', marginTop: 12 }, key: 'hb', title: getTitle() })
	    ),
	    _react2.default.createElement(
	      _reactFlexboxGrid.Row,
	      { middle: 'xs', center: 'xs' },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex',
	            alignItems: 'center',
	            paddingTop: 12,
	            justifyContent: 'space-between'
	          }
	        },
	        _react2.default.createElement(
	          _materialUi.IconButton,
	          { onClick: setLastPeriod, style: { marginRight: 12 } },
	          _react2.default.createElement(
	            _materialUi.FontIcon,
	            { className: 'material-icons' },
	            'arrow_back'
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: { fontSize: 18, fontWeight: 400 } },
	          _react2.default.createElement(_reactDatepicker2.default, {
	            className: 'smallPicker',
	            selected: (0, _moment2.default)(start),
	            onChange: setStartDate,
	            dateFormat: 'DD.MMM YYYY',
	            selectsStart: true,
	            startDate: (0, _moment2.default)(start),
	            endDate: (0, _moment2.default)(end)
	          }),
	          ' - ',
	          _react2.default.createElement(_reactDatepicker2.default, {
	            selected: (0, _moment2.default)(end),
	            onChange: setEndDate,
	            dateFormat: 'DD.MMM YYYY',
	            selectsEnd: true,
	            startDate: (0, _moment2.default)(start),
	            endDate: (0, _moment2.default)(end),
	            minDate: (0, _moment2.default)(start)
	          })
	        ),
	        _react2.default.createElement(
	          _materialUi.IconButton,
	          { onClick: setNextPeriod, style: { marginLeft: 12 } },
	          _react2.default.createElement(
	            _materialUi.FontIcon,
	            { className: 'material-icons' },
	            'arrow_forward'
	          )
	        )
	      )
	    ),
	    showBothTabs && _react2.default.createElement(
	      _materialUi.Tabs,
	      {
	        tabItemContainerStyle: { backgroundColor: '#fff' },
	        inkBarStyle: { backgroundColor: _colors2.default.primary1Color },
	        style: { paddingTop: 24, maxWidth: 1400, margin: 'auto' }
	      },
	      _react2.default.createElement(
	        _materialUi.Tab,
	        {
	          className: 'Cafeteria',
	          onActive: handleActive,
	          style: _extends({}, styles.tab, { color: '' + (activeTab === 'CAFE' ? 'rgb(0,0,0)' : 'rgba(0,0,0, 0.4)') }),
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'teria.cafeteria' })
	        },
	        renderCafeteriaContent
	      ),
	      _react2.default.createElement(
	        _materialUi.Tab,
	        {
	          onActive: handleActive,
	          style: _extends({}, styles.tab, { color: '' + (activeTab === 'STORE' ? 'rgb(0,0,0)' : 'rgba(0,0,0, 0.4)') }),
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'teria.store' })
	        },
	        renderStoreContent
	      )
	    ),
	    showCafeOnly && renderCafeteriaContent,
	    showStoreOnly && renderStoreContent
	  );
	};
	
	Teria.propTypes = {
	  teriaInitialize: _propTypes2.default.func.isRequired,
	  setTimePeriod: _propTypes2.default.func.isRequired,
	  hasError: _propTypes2.default.bool.isRequired,
	  initializeFailed: _propTypes2.default.bool.isRequired,
	  start: _propTypes2.default.shape({}).isRequired,
	  end: _propTypes2.default.shape({}).isRequired,
	  error: _propTypes2.default.string
	};
	
	Teria.defaultProps = {
	  error: null
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref2) {
	  var teriaReducer = _ref2.teriaReducer;
	  return _extends({}, teriaReducer);
	}, function (dispatch) {
	  return {
	    teriaInitialize: function teriaInitialize() {
	      return dispatch((0, _actions.initialize)());
	    },
	    setTimePeriod: function setTimePeriod(from, to, type) {
	      return dispatch((0, _actions.changePeriod)(from, to, type));
	    }
	  };
	})(Teria);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/sites/teria/Teria.js');
	
	  __REACT_HOT_LOADER__.register(Teria, 'Teria', 'D:/a/1/s/src/web/employee/src/sites/teria/Teria.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/teria/Teria.js');
	}();

	;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactRedux = __webpack_require__(12);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _DayEntryForm = __webpack_require__(1008);
	
	var _DayEntryForm2 = _interopRequireDefault(_DayEntryForm);
	
	var _TimeSpanEntryForm = __webpack_require__(1011);
	
	var _TimeSpanEntryForm2 = _interopRequireDefault(_TimeSpanEntryForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EntryModal = function EntryModal(_ref) {
	  var modalState = _ref.modalState,
	      closeModal = _ref.closeModal,
	      entryTypes = _ref.entryTypes,
	      selectedEntries = _ref.selectedEntries,
	      workingHours = _ref.workingHours,
	      deselectAll = _ref.deselectAll,
	      valuesByKey = _ref.valuesByKey,
	      entriesByDate = _ref.entriesByDate,
	      holidays = _ref.holidays,
	      initialDate = _ref.initialDate,
	      isEdit = _ref.isEdit,
	      dispatch = _ref.dispatch,
	      start = _ref.start,
	      end = _ref.end,
	      timeEmailTypes = _ref.timeEmailTypes;
	
	  var _useState = (0, _react.useState)({}),
	      _useState2 = _slicedToArray(_useState, 2),
	      defaultValues = _useState2[0],
	      setDefaultValues = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      toggleValue = _useState4[0],
	      setToggleValue = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      toggleValueNotAvaliable = _useState6[0],
	      setToggleValueNotAvaliable = _useState6[1];
	
	  var _useState7 = (0, _react.useState)('wholeDay'),
	      _useState8 = _slicedToArray(_useState7, 2),
	      primaryButton = _useState8[0],
	      setPrimaryButton = _useState8[1];
	
	  var workingHour = (0, _lodash.find)(workingHours, function (h) {
	    return (0, _moment2.default)().isSameOrAfter((0, _lodash.get)(h, 'Begda')) && (0, _moment2.default)().isSameOrBefore((0, _lodash.get)(h, 'Endda'));
	  });
	  var hrsPerDay = (0, _lodash.get)(workingHour, 'HrsPrDay', 0).toFixed(2);
	
	  var whichButton = function whichButton(hours) {
	    if (hrsPerDay <= 0.00) {
	      setPrimaryButton('');
	    } else if (hours === hrsPerDay) {
	      setPrimaryButton('wholeDay');
	    } else if (hours === (hrsPerDay / 2).toFixed(2)) {
	      setPrimaryButton('halfDay');
	    } else {
	      setPrimaryButton('');
	    }
	  };
	
	  var emptyEntry = {
	    clockCardEntryTypeID: null,
	    clockCardEntryComment: '',
	    actualClockTime: 0,
	    clockTimeHasError: false
	  };
	  var getRemainingHours = function getRemainingHours(date) {
	    var currentDate = date ? (0, _moment2.default)(date).format('DD/MM/YY') : (0, _moment2.default)().format('DD/MM/YY');
	    var employeeEntries = (0, _lodash.get)(entriesByDate, currentDate);
	    if (employeeEntries && employeeEntries.length > 0) {
	      var total = (0, _lodash.sumBy)(employeeEntries, 'ActualClockTime');
	      var expected = employeeEntries[0].ExpectedClockTime;
	      var remaining = (expected - total).toFixed(2);
	      return remaining < 0 ? 0 : parseFloat(remaining);
	    }
	    return hrsPerDay;
	  };
	
	  var setDefault = function setDefault() {
	    var clockIn = initialDate || (0, _moment2.default)();
	    var clockOut = initialDate || (0, _moment2.default)();
	    var remaining = (0, _lodash.size)(selectedEntries) === 0 ? getRemainingHours(initialDate) : hrsPerDay;
	    var employeeEntries = (0, _lodash.get)(entriesByDate, clockIn.format('DD/MM/YY'));
	    if (employeeEntries && employeeEntries.length > 0) {
	      var lastEntry = (0, _lodash.get)((0, _lodash.last)((0, _lodash.orderBy)(employeeEntries, 'ClockOut')), 'ClockOut');
	      clockIn = (0, _moment2.default)(lastEntry);
	    } else {
	      clockIn = clockIn.set({
	        hour: 8, minute: 0, second: 0, millisecond: 0
	      });
	    }
	    clockOut = (0, _moment2.default)(clockIn).add(remaining, 'hours');
	    setToggleValueNotAvaliable(false);
	    setDefaultValues(_extends({}, emptyEntry, {
	      // eslint-disable-next-line
	      date: initialDate ? initialDate.format('YYYY-MM-DD') : (0, _moment2.default)().format('YYYY-MM-DD'),
	      timeIn: clockIn.format('YYYY-MM-DD HH:mm:ss'),
	      timeOut: clockOut.format('YYYY-MM-DD HH:mm:ss'),
	      registerWeekends: false,
	      registerRedDays: false,
	      dateFrom: '',
	      dateTo: '',
	      hours: parseFloat(remaining)
	    }));
	    whichButton(hrsPerDay);
	  };
	  (0, _react.useEffect)(function () {
	    if ((0, _lodash.size)(selectedEntries) !== 0) {
	      var entry = selectedEntries[0];
	      setToggleValueNotAvaliable(true);
	      var clockIn = (0, _moment2.default)((0, _lodash.get)(entry, 'ClockIn'));
	      var clockOut = (0, _moment2.default)((0, _lodash.get)(entry, 'ClockOut'));
	      var duration = _moment2.default.duration((0, _moment2.default)(clockOut).diff((0, _moment2.default)(clockIn)));
	      var hours = duration.asHours().toFixed(2);
	      whichButton(hours);
	      setDefaultValues({
	        date: (0, _moment2.default)(clockIn).format('YYYY-MM-DD'),
	        timeIn: clockIn.format('YYYY-MM-DD HH:mm:ss'),
	        timeOut: clockOut.format('YYYY-MM-DD HH:mm:ss'),
	        clockCardEntryTypeID: entry.ClockCardEntryTypeID,
	        clockCardEntryComment: entry.ClockCardEntryComment,
	        actualClockTime: entry.ActualClockTime,
	        clockTimeHasError: false,
	        hours: hours
	      });
	    } else {
	      setDefault();
	    }
	  }, [selectedEntries, initialDate]);
	
	  (0, _react.useEffect)(function () {
	    setDefault();
	  }, [toggleValue]);
	
	  var clearAndClose = function clearAndClose() {
	    setDefaultValues(defaultValues);
	    if (defaultValues.hours) {
	      whichButton(defaultValues.hours);
	    }
	
	    closeModal();
	    setToggleValueNotAvaliable(false);
	    setToggleValue(false);
	    if (deselectAll) {
	      deselectAll();
	    }
	  };
	
	  return _react2.default.createElement(
	    _materialUi.Dialog,
	    {
	      contentStyle: {
	        overflow: 'hidden',
	        maxWidth: 500,
	        width: '100%'
	      },
	      bodyStyle: {
	        overflowY: 'auto'
	      },
	      modal: true,
	      open: modalState,
	      onRequestClose: clearAndClose
	    },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_KTitle2.default, {
	        style: {
	          marginLeft: 0,
	          display: 'flex',
	          alignItems: 'center',
	          flexDirection: 'row'
	        },
	        title: _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(
	            _materialUi.FontIcon,
	            {
	              style: {
	                marginRight: 6, fontSize: 28, color: 'inherit'
	              },
	              className: 'material-icons'
	            },
	            'alarm_on'
	          ),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.CreateEntry' })
	        ),
	        subtitleStyle: { margin: 0, fontSize: 12, lineHeight: '1' }
	      }),
	      !toggleValueNotAvaliable && _react2.default.createElement(_materialUi.Toggle, {
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.span' }),
	        labelPosition: 'right',
	        defaultToggled: toggleValue,
	        onToggle: function onToggle() {
	          setToggleValue(!toggleValue);
	        },
	        style: { marginTop: 20, width: 50 }
	      }),
	      !toggleValue ? _react2.default.createElement(_DayEntryForm2.default, {
	        defaultValues: defaultValues,
	        selectedEntries: selectedEntries,
	        hrsPerDay: hrsPerDay,
	        entryTypes: entryTypes,
	        primaryButton: primaryButton,
	        setPrimaryButton: setPrimaryButton,
	        clearAndClose: clearAndClose,
	        whichButton: whichButton,
	        valuesByKey: valuesByKey,
	        entriesByDate: entriesByDate,
	        getRemainingHours: getRemainingHours,
	        holidays: holidays,
	        isEdit: isEdit,
	        dispatch: dispatch,
	        start: start,
	        end: end,
	        timeEmailTypes: timeEmailTypes
	      }) : _react2.default.createElement(_TimeSpanEntryForm2.default, {
	        defaultValues: defaultValues,
	        selectedEntries: selectedEntries,
	        entryTypes: entryTypes,
	        clearAndClose: clearAndClose,
	        holidays: holidays,
	        dispatch: dispatch,
	        start: start,
	        end: end,
	        timeEmailTypes: timeEmailTypes
	      })
	    )
	  );
	};
	
	EntryModal.propTypes = {
	  modalState: _propTypes2.default.bool.isRequired,
	  closeModal: _propTypes2.default.func.isRequired,
	  entryTypes: _propTypes2.default.shape({}).isRequired,
	  workingHours: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
	  selectedEntries: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    ClockCardEntryID: _propTypes2.default.number,
	    ClockIn: _propTypes2.default.string,
	    ClockOut: _propTypes2.default.string,
	    ActualClockTime: _propTypes2.default.number,
	    ClockTimeHasError: _propTypes2.default.bool,
	    ClockCardEntryTypeID: _propTypes2.default.number,
	    ClockCardEntryComment: _propTypes2.default.string
	  })),
	  deselectAll: _propTypes2.default.func,
	  valuesByKey: _propTypes2.default.object,
	  entriesByDate: _propTypes2.default.shape({}).isRequired,
	  holidays: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
	  initialDate: _propTypes2.default.oneOfType([_propTypes2.default.shape({}), _propTypes2.default.string]),
	  isEdit: _propTypes2.default.bool,
	  dispatch: _propTypes2.default.func.isRequired,
	  start: _propTypes2.default.object.isRequired,
	  end: _propTypes2.default.object.isRequired,
	  timeEmailTypes: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref2) {
	  var timeReducer = _ref2.timeReducer,
	      WebValuesReducer = _ref2.WebValuesReducer,
	      EmployeeHolidayReducer = _ref2.EmployeeHolidayReducer;
	  return {
	    entryTypes: timeReducer.entryTypes,
	    workingHours: timeReducer.workingHours,
	    valuesByKey: WebValuesReducer.valuesByKey,
	    holidays: EmployeeHolidayReducer.holidays,
	    start: timeReducer.start,
	    end: timeReducer.end,
	    timeEmailTypes: timeReducer.timeEmailTypes
	  };
	}, function (dispatch) {
	  return { dispatch: dispatch };
	})(EntryModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EntryModal, 'EntryModal', 'D:/a/1/s/src/web/employee/src/sites/time/components/EntryModal.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/time/components/EntryModal.js');
	}();

	;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(291);
	
	var _reducer = __webpack_require__(1012);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _TimeOverview = __webpack_require__(1006);
	
	var _TimeOverview2 = _interopRequireDefault(_TimeOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  name: _constants.name,
	  TimeOverview: _TimeOverview2.default,
	  reducer: _reducer2.default
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/time/index.js');
	}();

	;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _Api = __webpack_require__(21);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	/**
	 * Custom hook for managing clock card entries API calls
	 * Provides functions to create and update clock card entries
	 *
	 * Important: UseAccrualsIfNeeded should always be set to false in the first request.
	 * If the API response status is "WARNING" when registering holiday, it means that accruals will be taken from
	 * the employee's holiday accrual (ávinnsla) balance. The user must confirm this action by sending another request
	 * with UseAccrualsIfNeeded set to true.
	 */
	var useClockCardEntries = function useClockCardEntries() {
	  /**
	   * Creates new clock card entries
	   * @param {Object} data - Clock card entry data
	   * @param {number} data.EmployeeDetailID - Employee detail ID
	   * @param {number} data.ClockCardEntryTypeID - Entry type ID
	   * @param {string} data.Comment - Entry comment
	   * @param {string} data.PeriodBegda - Start date/time (ISO string)
	   * @param {string} data.PeriodEndda - End date/time (ISO string)
	   * @param {number} data.HoursPerDay - Hours per day
	   * @param {boolean} data.IncludesWeekends - Include weekends flag
	   * @param {boolean} data.IncludesRedDays - Include red days flag
	   * @param {boolean} data.UseAccrualsIfNeeded - Use accruals if needed. Set to false for initial request.
	   *                                             If response status is "WARNING", user must confirm and resend with true.
	   * @returns {Promise<Object|null>} Response with status and messages, or null on error
	   */
	  var createClockCardEntries = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
	      var requestConfig, res, status, messages;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              requestConfig = {
	                url: '/kjarni/api/v2/ClockCardEntries/CreateClockCardEntries',
	                method: 'POST',
	                data: data
	              };
	              _context.prev = 1;
	              _context.t0 = _lodash.get;
	              _context.next = 5;
	              return (0, _Api.custom)(requestConfig);
	
	            case 5:
	              _context.t1 = _context.sent;
	              res = (0, _context.t0)(_context.t1, 'data');
	              status = (0, _lodash.get)(res, 'Status');
	              messages = (0, _lodash.filter)((0, _lodash.get)(res, 'Messages'), function (m) {
	                return m.Language === (localStorage.language === 'is' ? 'IS' : 'EN');
	              });
	              return _context.abrupt('return', {
	                status: status,
	                messages: (0, _lodash.map)(messages, 'Message')
	              });
	
	            case 12:
	              _context.prev = 12;
	              _context.t2 = _context['catch'](1);
	
	              console.log('Error during clock card entry request', _context.t2);
	              return _context.abrupt('return', null);
	
	            case 16:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[1, 12]]);
	    }));
	
	    return function createClockCardEntries(_x) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  /**
	   * Updates existing clock card entries
	   * @param {Object} data - Update data
	   * @param {number[]} data.ClockCardEntryIDs - Array of entry IDs to update
	   * @param {number} data.ClockCardEntryTypeID - New entry type ID
	   * @param {string} data.ClockCardEntryComment - New comment
	   * @param {string} data.PeriodBegda - New clock in time (ISO string)
	   * @param {string} data.PeriodEndda - New clock out time (ISO string)
	   * @param {boolean} data.IncludesWeekends - Include weekends flag
	   * @param {boolean} data.IncludesRedDays - Include red days flag
	   * @param {boolean} data.UseAccrualsIfNeeded - Use accruals if needed. Set to false for initial request.
	   *                                             If response status is "WARNING", user must confirm and resend with true.
	   * @returns {Promise<Object|null>} Response with status and messages, or null on error
	   */
	  var updateClockCardEntries = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
	      var requestConfig, res, status, messages;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              requestConfig = {
	                url: '/kjarni/api/v2/ClockCardEntries/UpdateClockCardEntries',
	                method: 'POST',
	                data: data
	              };
	              _context2.prev = 1;
	              _context2.t0 = _lodash.get;
	              _context2.next = 5;
	              return (0, _Api.custom)(requestConfig);
	
	            case 5:
	              _context2.t1 = _context2.sent;
	              res = (0, _context2.t0)(_context2.t1, 'data');
	              status = (0, _lodash.get)(res, 'Status');
	              messages = (0, _lodash.filter)((0, _lodash.get)(res, 'Messages'), function (m) {
	                return m.Language === (localStorage.language === 'is' ? 'IS' : 'EN');
	              });
	              return _context2.abrupt('return', {
	                status: status,
	                messages: (0, _lodash.map)(messages, 'Message')
	              });
	
	            case 12:
	              _context2.prev = 12;
	              _context2.t2 = _context2['catch'](1);
	
	              console.log('Error during clock card entry request', _context2.t2);
	              return _context2.abrupt('return', null);
	
	            case 16:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[1, 12]]);
	    }));
	
	    return function updateClockCardEntries(_x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  return {
	    createClockCardEntries: createClockCardEntries,
	    updateClockCardEntries: updateClockCardEntries
	  };
	};
	
	var _default = useClockCardEntries;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(useClockCardEntries, 'useClockCardEntries', 'D:/a/1/s/src/web/employee/src/sites/time/useClockCardEntries.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/time/useClockCardEntries.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactCardFlip = __webpack_require__(1645);
	
	var _reactCardFlip2 = _interopRequireDefault(_reactCardFlip);
	
	var _TransportationGrant = __webpack_require__(294);
	
	var _TransportationGrant2 = _interopRequireDefault(_TransportationGrant);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _FrontCard = __webpack_require__(1014);
	
	var _FrontCard2 = _interopRequireDefault(_FrontCard);
	
	var _BackCard = __webpack_require__(1013);
	
	var _BackCard2 = _interopRequireDefault(_BackCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransportationGrant = function TransportationGrant(_ref) {
	  var loading = _ref.loading,
	      grant = _ref.grant,
	      embed = _ref.embed,
	      onSubmit = _ref.onSubmit;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      flip = _useState2[0],
	      setFlip = _useState2[1];
	
	  var getOnClick = function getOnClick(value) {
	    return function () {
	      return setFlip(value);
	    };
	  };
	
	  if (loading) {
	    return _react2.default.createElement(
	      'div',
	      { style: _TransportationGrant2.default.container },
	      _react2.default.createElement(
	        'div',
	        { style: _TransportationGrant2.default.card },
	        _react2.default.createElement(_TLoading2.default, null)
	      )
	    );
	  }
	
	  if (!grant || !grant.Months) {
	    return _react2.default.createElement(
	      'div',
	      { style: _TransportationGrant2.default.container },
	      _react2.default.createElement(
	        'div',
	        { style: _TransportationGrant2.default.card },
	        _react2.default.createElement(_TMessage2.default, { type: 'warning', message: 'transportationGrant.error' })
	      )
	    );
	  }
	
	  return _react2.default.createElement(
	    _reactCardFlip2.default,
	    {
	      isFlipped: flip,
	      containerStyle: embed ? _TransportationGrant2.default.embedContainer : _TransportationGrant2.default.container
	    },
	    _react2.default.createElement(_FrontCard2.default, { embed: embed, grant: grant, loading: loading, handleClick: getOnClick }),
	    _react2.default.createElement(_BackCard2.default, { embed: embed, grant: grant, loading: loading, handleClick: getOnClick, onSubmit: onSubmit })
	  );
	};
	
	TransportationGrant.propTypes = {
	  loading: _propTypes2.default.bool,
	  onSubmit: _propTypes2.default.func.isRequired,
	  embed: _propTypes2.default.bool,
	  grant: _propTypes2.default.shape({
	    HrTransportationGrantID: _propTypes2.default.number.isRequired,
	    HrTransportationGrantName: _propTypes2.default.string.isRequired,
	    PublicTransportation: _propTypes2.default.string,
	    Cycling: _propTypes2.default.string,
	    Walking: _propTypes2.default.string,
	    TransportationCard: _propTypes2.default.string,
	    Months: _propTypes2.default.number,
	    AmountPerMonth: _propTypes2.default.string,
	    Previous: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      Begda: _propTypes2.default.string,
	      Endda: _propTypes2.default.string
	    }))
	  }).isRequired
	};
	
	TransportationGrant.defaultProps = {
	  loading: false,
	  embed: false
	};
	
	var _default = TransportationGrant;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TransportationGrant, 'TransportationGrant', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/TransportationGrant.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/TransportationGrant.js');
	}();

	;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.register = exports.requestEmployeeTransportGrantRegisterFailure = exports.requestEmployeeTransportGrantRegisterSuccess = exports.requestEmployeeTransportGrantRegister = exports.fetch = exports.requestTransportGrantsFailure = exports.requestTransportGrantsSuccess = exports.requestTransportGrants = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reapop = __webpack_require__(44);
	
	var _lodash = __webpack_require__(8);
	
	var _Api = __webpack_require__(21);
	
	var _constants = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var requestTransportGrants = exports.requestTransportGrants = function requestTransportGrants() {
	  return {
	    type: _constants.REQUEST_TRANSPORT_GRANTS
	  };
	};
	
	var requestTransportGrantsSuccess = exports.requestTransportGrantsSuccess = function requestTransportGrantsSuccess(transportationGrants) {
	  return {
	    type: _constants.REQUEST_TRANSPORT_GRANTS_SUCCESS,
	    transportationGrants: transportationGrants
	  };
	};
	
	var requestTransportGrantsFailure = exports.requestTransportGrantsFailure = function requestTransportGrantsFailure(error) {
	  return {
	    type: _constants.REQUEST_TRANSPORT_GRANTS_FAILURE,
	    error: error
	  };
	};
	
	var fetch = exports.fetch = function fetch() {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, _getState$loginReduce, DefaultEmployeeDetailID, EmployeeMasterID, token, now, orgConfig, orgRes, org, grantsConfig, grantsRes, grants, emailTemplateIds, emailTemplateConfig, emTransportConfig, _ref2, _ref3, emTransportsRes, emailTemplateRes, emTransports, emailTemplates, grantsCombine;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              dispatch(requestTransportGrants());
	
	              _context.prev = 1;
	              _getState = getState(), _getState$loginReduce = _getState.loginReducer.user, DefaultEmployeeDetailID = _getState$loginReduce.DefaultEmployeeDetailID, EmployeeMasterID = _getState$loginReduce.EmployeeMasterID, token = _getState$loginReduce.token;
	
	              if (DefaultEmployeeDetailID) {
	                _context.next = 5;
	                break;
	              }
	
	              throw new Error('The user is missing a DefaultEmployeeDetailID');
	
	            case 5:
	              now = new Date().toISOString();
	              orgConfig = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: '/kjarni/api/v2/EmployeeDetailOrgs/' + DefaultEmployeeDetailID + '/ByEmployeeDetailID',
	                params: {
	                  $filter: 'Begda lt ' + now + ' and Endda gt ' + now,
	                  $select: 'EmployeeStatus,EmployeeGroup'
	                }
	              };
	              _context.next = 9;
	              return (0, _Api.custom)(orgConfig);
	
	            case 9:
	              orgRes = _context.sent;
	              org = (0, _lodash.get)(orgRes, 'data.value[0]');
	
	              if (org) {
	                _context.next = 13;
	                break;
	              }
	
	              throw new Error('No EmployeeDetailOrg');
	
	            case 13:
	              grantsConfig = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: '/kjarni/api/v2/HrTransportationGrants',
	                params: {
	                  $filter: 'EmployeeStatus in (\'' + org.EmployeeStatus + '\', \'None\') and EmployeeGroup in (\'' + org.EmployeeGroup + '\', \'None\')'
	                }
	              };
	              _context.next = 16;
	              return (0, _Api.custom)(grantsConfig);
	
	            case 16:
	              grantsRes = _context.sent;
	              grants = (0, _lodash.get)(grantsRes, 'data.value', []);
	
	              if ((0, _lodash.size)(grants)) {
	                _context.next = 21;
	                break;
	              }
	
	              // If there are no transportation grants we don't need to fetch more data.
	              dispatch(requestTransportGrantsSuccess([]));
	              return _context.abrupt('return');
	
	            case 21:
	              emailTemplateIds = (0, _lodash.map)(grants, 'XapEmailTemplateID');
	              emailTemplateConfig = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: '/kjarni/api/v2/XapEmailTemplates',
	                params: {
	                  $filter: 'XapEmailTemplateID in (' + (0, _lodash.join)(emailTemplateIds, ',') + ')'
	                }
	              };
	              emTransportConfig = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: '/kjarni/api/v2/EmployeeMasterTransportations',
	                params: {
	                  $filter: 'Endda gt ' + now + ' and EmployeeMasterID eq ' + EmployeeMasterID
	                }
	              };
	              _context.next = 26;
	              return Promise.all([(0, _Api.custom)(emTransportConfig), (0, _Api.custom)(emailTemplateConfig)]);
	
	            case 26:
	              _ref2 = _context.sent;
	              _ref3 = _slicedToArray(_ref2, 2);
	              emTransportsRes = _ref3[0];
	              emailTemplateRes = _ref3[1];
	              emTransports = (0, _lodash.groupBy)((0, _lodash.reverse)((0, _lodash.get)(emTransportsRes, 'data.value')), 'HrTransportationGrantID');
	              emailTemplates = (0, _lodash.keyBy)((0, _lodash.get)(emailTemplateRes, 'data.value'), 'XapEmailTemplateID');
	              grantsCombine = (0, _lodash.map)(grants, function (grant) {
	                return _extends({}, grant, {
	                  Previous: (0, _lodash.get)(emTransports, grant.HrTransportationGrantID),
	                  EmailTemplate: (0, _lodash.get)(emailTemplates, grant.XapEmailTemplateID)
	                });
	              });
	
	              dispatch(requestTransportGrantsSuccess(grantsCombine));
	              _context.next = 39;
	              break;
	
	            case 36:
	              _context.prev = 36;
	              _context.t0 = _context['catch'](1);
	
	              dispatch(requestTransportGrantsFailure(_context.t0.error || _context.t0));
	
	            case 39:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[1, 36]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var requestEmployeeTransportGrantRegister = exports.requestEmployeeTransportGrantRegister = function requestEmployeeTransportGrantRegister(transportationGrantId) {
	  return {
	    type: _constants.EMPLOYEE_TRANSPORT_GRANT_REGISTER,
	    transportationGrantId: transportationGrantId
	  };
	};
	
	var requestEmployeeTransportGrantRegisterSuccess = exports.requestEmployeeTransportGrantRegisterSuccess = function requestEmployeeTransportGrantRegisterSuccess(transportationGrantId, employeeMasterTransportations) {
	  return {
	    type: _constants.EMPLOYEE_TRANSPORT_GRANT_REGISTER_SUCCESS,
	    transportationGrantId: transportationGrantId,
	    employeeMasterTransportations: employeeMasterTransportations
	  };
	};
	
	var requestEmployeeTransportGrantRegisterFailure = exports.requestEmployeeTransportGrantRegisterFailure = function requestEmployeeTransportGrantRegisterFailure(error, transportationGrantId) {
	  return {
	    type: _constants.EMPLOYEE_TRANSPORT_GRANT_REGISTER_FAILURE,
	    transportationGrantId: transportationGrantId,
	    error: error
	  };
	};
	
	var register = exports.register = function register(transportGrant) {
	  return function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	      var HrTransportationGrantID, _getState2, _getState2$loginReduc, token, EmployeeMasterID, registerConfig, now, emTransportsConfig, emTransportsRes, emTransports;
	
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!(!transportGrant || !transportGrant.HrTransportationGrantID)) {
	                _context2.next = 2;
	                break;
	              }
	
	              return _context2.abrupt('return', dispatch(requestEmployeeTransportGrantRegisterFailure(new Error('Missing TransportationGrant data/ID'))));
	
	            case 2:
	              HrTransportationGrantID = transportGrant.HrTransportationGrantID;
	              _context2.prev = 3;
	
	              dispatch(requestEmployeeTransportGrantRegister(HrTransportationGrantID));
	              _getState2 = getState(), _getState2$loginReduc = _getState2.loginReducer, token = _getState2$loginReduc.token, EmployeeMasterID = _getState2$loginReduc.user.EmployeeMasterID;
	              registerConfig = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: '/api/EmployeeTransportationGrant/Register',
	                method: 'POST',
	                data: transportGrant
	              };
	              _context2.next = 9;
	              return (0, _Api.custom)(registerConfig);
	
	            case 9:
	              now = new Date().toISOString();
	              emTransportsConfig = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: '/kjarni/api/v2/EmployeeMasterTransportations',
	                params: {
	                  $filter: 'Endda gt ' + now + ' and EmployeeMasterID eq ' + EmployeeMasterID + ' and HrTransportationGrantID eq ' + HrTransportationGrantID
	                }
	              };
	
	
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.transportRegister.title' }),
	                message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.transportRegister.message' }),
	                status: 'success',
	                dismissible: true,
	                dismissAfter: 6000
	              }));
	
	              _context2.next = 14;
	              return (0, _Api.custom)(emTransportsConfig);
	
	            case 14:
	              emTransportsRes = _context2.sent;
	              emTransports = (0, _lodash.get)(emTransportsRes, 'data.value');
	              return _context2.abrupt('return', dispatch(requestEmployeeTransportGrantRegisterSuccess(HrTransportationGrantID, emTransports)));
	
	            case 19:
	              _context2.prev = 19;
	              _context2.t0 = _context2['catch'](3);
	              return _context2.abrupt('return', dispatch(requestEmployeeTransportGrantRegisterFailure(_context2.t0, HrTransportationGrantID)));
	
	            case 22:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[3, 19]]);
	    }));
	
	    return function (_x3, _x4) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestTransportGrants, 'requestTransportGrants', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestTransportGrantsSuccess, 'requestTransportGrantsSuccess', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestTransportGrantsFailure, 'requestTransportGrantsFailure', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetch, 'fetch', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeTransportGrantRegister, 'requestEmployeeTransportGrantRegister', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeTransportGrantRegisterSuccess, 'requestEmployeeTransportGrantRegisterSuccess', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestEmployeeTransportGrantRegisterFailure, 'requestEmployeeTransportGrantRegisterFailure', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/actions.js');
	
	  __REACT_HOT_LOADER__.register(register, 'register', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/actions.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(8);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactDatepicker = __webpack_require__(211);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _actions = __webpack_require__(1018);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _VacationTable = __webpack_require__(1017);
	
	var _VacationTable2 = _interopRequireDefault(_VacationTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var labelStyle = {
	  display: 'inline-block',
	  padding: 12,
	  color: 'white',
	  marginRight: 6
	};
	
	var VacationApprovals = function VacationApprovals(_ref) {
	  var vacationInitialize = _ref.vacationInitialize,
	      setTimePeriod = _ref.setTimePeriod,
	      datesBetween = _ref.datesBetween,
	      start = _ref.start,
	      end = _ref.end,
	      error = _ref.error,
	      hasError = _ref.hasError,
	      approvalStatusTypes = _ref.approvalStatusTypes,
	      initializeFailed = _ref.initializeFailed;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      dataSource = _useState2[0],
	      setDataSource = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({
	    employeeId: []
	  }),
	      _useState4 = _slicedToArray(_useState3, 2),
	      selectedValues = _useState4[0],
	      setSelectedValues = _useState4[1];
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.vacationApprovalsReducer;
	  }),
	      employees = _useSelector.employees,
	      loading = _useSelector.loading,
	      initializing = _useSelector.initializing;
	
	  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
	    return state.profileReducer;
	  }),
	      employeeDetailOrgList = _useSelector2.employeeDetailOrgList,
	      employeeMaster = _useSelector2.employeeMaster;
	
	  (0, _react.useEffect)(function () {
	    var DefaultEmployeeDetailID = (0, _lodash.get)(employeeMaster, 'DefaultEmployeeDetailID');
	    if (DefaultEmployeeDetailID && employeeDetailOrgList && employeeDetailOrgList.length) {
	      var defaultCompanyUnit = (0, _lodash.find)(employeeDetailOrgList, function (unit) {
	        return unit.EmployeeDetailID === DefaultEmployeeDetailID;
	      });
	      setSelectedValues(_extends({}, selectedValues, { orgCompanyUnitId: (0, _lodash.get)(defaultCompanyUnit, 'OrgCompanyUnitID') }));
	    }
	  }, [employeeMaster, employeeDetailOrgList]);
	
	  (0, _react.useEffect)(function () {
	    vacationInitialize();
	  }, []);
	
	  var filterByEmployee = function filterByEmployee() {
	    var employeeId = selectedValues.employeeId;
	
	    if (employeeId.length) {
	      var filtered = (0, _lodash.filter)(employees, function (e) {
	        return employeeId.includes(e.EmployeeDetailID);
	      });
	      return filtered.length ? filtered : employees;
	    }
	    return employees;
	  };
	
	  var filterData = function filterData() {
	    var data = filterByEmployee();
	    setDataSource(data);
	  };
	
	  (0, _react.useEffect)(function () {
	    filterData();
	  }, [selectedValues]);
	
	  (0, _react.useEffect)(function () {
	    filterData();
	  }, [employees]);
	
	  if (initializing) return _react2.default.createElement(_Loading2.default, null);
	
	  if (initializeFailed || hasError) {
	    return _react2.default.createElement(_PanelMessage2.default, {
	      message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.initialize.error', values: { error: error } }),
	      iconName: 'error',
	      type: 'error'
	    });
	  }
	
	  var isPeriod = (0, _moment2.default)(end).format('DD/MM/YYYY') === (0, _moment2.default)(start).add(1, 'month').add(-1, 'day').format('DD/MM/YYYY');
	
	  var isMonth = (0, _moment2.default)(start).format('DD/MM/YYYY') === (0, _moment2.default)(start).startOf('month').format('DD/MM/YYYY') && (0, _moment2.default)(end).format('DD/MM/YYYY') === (0, _moment2.default)(end).endOf('month').format('DD/MM/YYYY');
	
	  var setLastPeriod = function setLastPeriod() {
	    if (isMonth) {
	      setTimePeriod((0, _moment2.default)(start).add(-1, 'month'), (0, _moment2.default)(end).add(-1, 'month').endOf('month'), (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	    } else if (isPeriod) {
	      setTimePeriod((0, _moment2.default)(start).add(-1, 'month'), (0, _moment2.default)(start).add(-1, 'day'), (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	    } else {
	      var numberOfDays = (0, _moment2.default)(end).diff(start, 'days') + 1;
	      setTimePeriod((0, _moment2.default)(start).add(-numberOfDays, 'days'), (0, _moment2.default)(end).add(-numberOfDays, 'days'), (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	    }
	  };
	
	  var setNextPeriod = function setNextPeriod() {
	    if (isMonth) {
	      setTimePeriod((0, _moment2.default)(start).add(1, 'month'), (0, _moment2.default)(end).add(1, 'month').endOf('month'), (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	    } else if (isPeriod) {
	      setTimePeriod((0, _moment2.default)(start).add(1, 'month'), (0, _moment2.default)(start).add(2, 'month').add(-1, 'day'), (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	    } else {
	      var numberOfDays = (0, _moment2.default)(end).diff(start, 'days') + 1;
	      setTimePeriod((0, _moment2.default)(start).add(numberOfDays, 'days'), (0, _moment2.default)(end).add(numberOfDays, 'days'), (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	    }
	  };
	  var setStartDate = function setStartDate(date) {
	    setTimePeriod(date, end, (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	  };
	
	  var setEndDate = function setEndDate(date) {
	    setTimePeriod(start, date, (0, _lodash.get)(selectedValues, 'orgCompanyUnitId'));
	  };
	
	  var getTitle = function getTitle(date) {
	    return _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'center' } },
	      _react2.default.createElement(
	        'div',
	        null,
	        date.dateString.substring(0, 5)
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        date.dayOfWeek
	      )
	    );
	  };
	
	  var dateTable = {
	    key: 'TeriaEmployeeCafeteriaPurchaseID',
	    columns: [{ title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'name' }), dataIndex: 'EmployeeName', width: 220 }].concat(_toConsumableArray((0, _lodash.map)(datesBetween, function (d) {
	      return _extends({
	        title: getTitle(d), dataIndex: d.dateString, width: 40 }, d);
	    })))
	  };
	
	  var onEmployeeChange = function onEmployeeChange(empId) {
	    setSelectedValues(_extends({}, selectedValues, { employeeId: empId }));
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: { maxWidth: 1600, margin: 'auto' } },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_KTitle2.default, { containerStyle: { marginTop: 12 }, key: 'hb', title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holiday.vacationApprovals' }) })
	      ),
	      _react2.default.createElement(
	        _reactFlexboxGrid.Row,
	        { middle: 'xs', center: 'xs' },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              display: 'flex',
	              alignItems: 'center',
	              paddingTop: 12,
	              justifyContent: 'space-between'
	            }
	          },
	          _react2.default.createElement(
	            _materialUi.IconButton,
	            { onClick: setLastPeriod, style: { marginRight: 12 } },
	            _react2.default.createElement(
	              _materialUi.FontIcon,
	              { className: 'material-icons' },
	              'arrow_back'
	            )
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: 18, fontWeight: 400 } },
	            _react2.default.createElement(_reactDatepicker2.default, {
	              className: 'smallPicker',
	              selected: (0, _moment2.default)(start),
	              onChange: setStartDate,
	              dateFormat: 'DD.MMM YYYY',
	              selectsStart: true,
	              startDate: (0, _moment2.default)(start),
	              endDate: (0, _moment2.default)(end)
	            }),
	            ' - ',
	            _react2.default.createElement(_reactDatepicker2.default, {
	              selected: (0, _moment2.default)(end),
	              onChange: setEndDate,
	              dateFormat: 'DD.MMM YYYY',
	              selectsEnd: true,
	              startDate: (0, _moment2.default)(start),
	              endDate: (0, _moment2.default)(end),
	              minDate: (0, _moment2.default)(start)
	            })
	          ),
	          _react2.default.createElement(
	            _materialUi.IconButton,
	            { onClick: setNextPeriod, style: { marginLeft: 12 } },
	            _react2.default.createElement(
	              _materialUi.FontIcon,
	              { className: 'material-icons' },
	              'arrow_forward'
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { marginTop: 12 } },
	        (0, _lodash.map)(approvalStatusTypes, function (type) {
	          return _react2.default.createElement(
	            'div',
	            { key: type.id, style: _extends({}, labelStyle, { backgroundColor: type.color }) },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holiday.' + type.value })
	          );
	        })
	      ),
	      _react2.default.createElement(
	        _reactFlexboxGrid.Row,
	        { style: { maxWidth: 1400, margin: 'auto' } },
	        _react2.default.createElement(
	          _materialUi.SelectField,
	          {
	            multiple: true,
	            style: { width: 280, marginRight: 12 },
	            floatingLabelFixed: true,
	            floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employee' }),
	            value: (0, _lodash.get)(selectedValues, 'employeeId'),
	            onChange: function onChange(event, index, value) {
	              return onEmployeeChange(value);
	            },
	            disabled: loading
	          },
	          (0, _lodash.map)(employees, function (_ref2) {
	            var EmployeeDetailID = _ref2.EmployeeDetailID,
	                EmployeeName = _ref2.EmployeeName;
	            return _react2.default.createElement(_materialUi.MenuItem, {
	              key: EmployeeDetailID,
	              value: EmployeeDetailID,
	              primaryText: EmployeeName,
	              insetChildren: true,
	              checked: (0, _lodash.get)(selectedValues, 'employeeId') && (0, _lodash.get)(selectedValues, 'employeeId').indexOf(EmployeeDetailID) > -1
	            });
	          })
	        )
	      ),
	      datesBetween.length ? _react2.default.createElement(_VacationTable2.default, { table: dateTable, entries: dataSource }) : null
	    )
	  );
	};
	
	VacationApprovals.propTypes = {
	  approvalStatusTypes: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
	  datesBetween: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
	  vacationInitialize: _propTypes2.default.func.isRequired,
	  setTimePeriod: _propTypes2.default.func.isRequired,
	  hasError: _propTypes2.default.bool.isRequired,
	  initializeFailed: _propTypes2.default.bool.isRequired,
	  start: _propTypes2.default.shape({}).isRequired,
	  end: _propTypes2.default.shape({}).isRequired,
	  error: _propTypes2.default.string
	};
	
	VacationApprovals.defaultProps = {
	  error: null
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref3) {
	  var vacationApprovalsReducer = _ref3.vacationApprovalsReducer;
	  return _extends({}, vacationApprovalsReducer);
	}, function (dispatch) {
	  return {
	    vacationInitialize: function vacationInitialize() {
	      return dispatch((0, _actions.initialize)());
	    },
	    setTimePeriod: function setTimePeriod(from, to, unitId) {
	      return dispatch((0, _actions.changePeriod)(from, to, unitId));
	    }
	  };
	})(VacationApprovals);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(labelStyle, 'labelStyle', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/VacationApprovals.js');
	
	  __REACT_HOT_LOADER__.register(VacationApprovals, 'VacationApprovals', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/VacationApprovals.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/VacationApprovals.js');
	}();

	;

/***/ }),
/* 454 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _default = {
	  title: {
	    fontWeight: 500,
	    fontSize: 22,
	    display: 'flex',
	    alignItems: 'center',
	    color: 'rgba(0, 0, 0, 0.9)'
	  },
	  info: {
	    padding: 6,
	    display: 'flex',
	    alignItems: 'center',
	    marginBottom: 12
	  },
	  subInfo: {
	    paddingLeft: 6,
	    fontSize: 16,
	    color: 'rgba(0, 0, 0, 0.541176)'
	  },
	  header: {
	    marginTop: 16,
	    paddingLeft: 0,
	    fontSize: 20,
	    fontWeight: '300',
	    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif'
	  },
	  appraisal: {
	    marginTop: 16,
	    padding: 6,
	    display: 'flex',
	    flex: 1,
	    flexDirection: 'column'
	  },
	  content: {
	    margin: 6,
	    fontSize: 20
	  },
	  date: {
	    padding: 12,
	    display: 'flex',
	    flexDirection: 'row',
	    justifyContent: 'space-between',
	    alignItems: 'center',
	    fontSize: 18,
	    color: 'rgba(0, 0, 0, 0.541176)',
	    flexWrap: 'wrap'
	  }
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/styles/AppraisalList.js');
	}();

	;

/***/ }),
/* 455 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _default = {
	  subheader: {
	    fontSize: 20,
	    fontWeight: 300,
	    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	    paddingLeft: 8,
	    paddingRight: 8,
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'space-between'
	  }
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/styles/base.js');
	}();

	;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getGender = undefined;
	
	var _lodash = __webpack_require__(8);
	
	var genders = {
	  en: {
	    0: 'None',
	    1: 'Male',
	    2: 'Female',
	    3: 'Gender Neutral'
	  },
	  is: {
	    0: 'Óskilgreint',
	    1: 'Karl',
	    2: 'Kona',
	    3: 'Kynsegin'
	  }
	};
	
	var _default = genders;
	exports.default = _default;
	var getGender = exports.getGender = function getGender(lang, type) {
	  return (0, _lodash.get)(genders, [lang, type]);
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(genders, 'genders', 'D:/a/1/s/src/web/employee/src/utils/genders.js');
	
	  __REACT_HOT_LOADER__.register(getGender, 'getGender', 'D:/a/1/s/src/web/employee/src/utils/genders.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/utils/genders.js');
	}();

	;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAttendeeMsg = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/prefer-default-export
	var getAttendeeMsg = exports.getAttendeeMsg = function getAttendeeMsg(CourseAttendees, EmployeeMasterID, Gender) {
	  var found = (0, _lodash.find)(CourseAttendees, ['EmployeeMasterID', EmployeeMasterID]);
	  var attendeeType = (0, _lodash.get)(found, 'CourseAttendeeType', 0);
	  return _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courseAttendeeType.' + attendeeType, values: { Gender: Gender } });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getAttendeeMsg, 'getAttendeeMsg', 'D:/a/1/s/src/web/employee/src/utils/helpers.js');
	}();

	;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(1294);
	
	__webpack_require__(1039);
	
	__webpack_require__(1053);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1054), __esModule: true };

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1059), __esModule: true };

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1061), __esModule: true };

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(460);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(459);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
	};

/***/ }),
/* 464 */
[1857, 298, 75],
/* 465 */
[1861, 152, 106],
/* 466 */
[1865, 104, 150, 465],
/* 467 */
[1866, 298],
/* 468 */
[1871, 228, 105, 474, 151, 153, 1074, 304, 471, 75],
/* 469 */
[1878, 229, 192, 154, 308, 121, 466, 104],
/* 470 */
[1880, 472, 301],
/* 471 */
[1881, 121, 155, 305],
/* 472 */
[1882, 121, 154, 1067, 305],
/* 473 */
[1884, 105, 55, 150],
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(151);


/***/ }),
/* 475 */
[1892, 307],
/* 476 */
[1898, 464, 75, 153, 55],
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(76);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(43);
	var toAbsoluteIndex = __webpack_require__(130);
	var toLength = __webpack_require__(34);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(123);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(56);
	var toObject = __webpack_require__(43);
	var IObject = __webpack_require__(194);
	var toLength = __webpack_require__(34);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(56);
	var isObject = __webpack_require__(28);
	var invoke = __webpack_require__(487);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(42).f;
	var create = __webpack_require__(124);
	var redefineAll = __webpack_require__(128);
	var ctx = __webpack_require__(77);
	var anInstance = __webpack_require__(122);
	var forOf = __webpack_require__(123);
	var $iterDefine = __webpack_require__(323);
	var step = __webpack_require__(490);
	var setSpecies = __webpack_require__(129);
	var DESCRIPTORS = __webpack_require__(36);
	var fastKey = __webpack_require__(110).fastKey;
	var validate = __webpack_require__(132);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(156);
	var from = __webpack_require__(479);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(128);
	var getWeak = __webpack_require__(110).getWeak;
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(28);
	var anInstance = __webpack_require__(122);
	var forOf = __webpack_require__(123);
	var createArrayMethod = __webpack_require__(86);
	var $has = __webpack_require__(69);
	var validate = __webpack_require__(132);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(235);
	var isObject = __webpack_require__(28);
	var toLength = __webpack_require__(34);
	var ctx = __webpack_require__(77);
	var IS_CONCAT_SPREADABLE = __webpack_require__(31)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 486 */
[1865, 36, 27, 316],
/* 487 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(28);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 489 */
[1869, 22],
/* 490 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(325);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 492 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 493 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 494 */
[1874, 36, 126, 239, 195, 43, 194, 27],
/* 495 */
[1877, 42, 22, 126, 36],
/* 496 */
[1879, 72, 125],
/* 497 */
[1882, 69, 72, 232, 330],
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(36);
	var getKeys = __webpack_require__(126);
	var toIObject = __webpack_require__(72);
	var isEnum = __webpack_require__(195).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(125);
	var gOPS = __webpack_require__(239);
	var anObject = __webpack_require__(22);
	var Reflect = __webpack_require__(25).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(25).parseFloat;
	var $trim = __webpack_require__(159).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(333) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(25).parseInt;
	var $trim = __webpack_require__(159).trim;
	var ws = __webpack_require__(333);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 502 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(28);
	var newPromiseCapability = __webpack_require__(327);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 504 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(34);
	var repeat = __webpack_require__(332);
	var defined = __webpack_require__(87);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(79);
	var toLength = __webpack_require__(34);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 507 */
[1896, 31],
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(482);
	var validate = __webpack_require__(132);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(233)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(156);
	var test = {};
	test[__webpack_require__(31)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(61)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(328);
	__webpack_require__(4)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(36) && /./g.flags != 'g') __webpack_require__(42).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(193)
	});


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(482);
	var validate = __webpack_require__(132);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(233)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 513 */
[1908, 25, 69, 36, 4, 61, 110, 27, 196, 158, 131, 31, 507, 336, 1101, 235, 22, 28, 43, 72, 89, 127, 124, 496, 70, 239, 42, 126, 125, 195, 109, 60],
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(25);
	var each = __webpack_require__(86)(0);
	var redefine = __webpack_require__(61);
	var meta = __webpack_require__(110);
	var assign = __webpack_require__(494);
	var weak = __webpack_require__(484);
	var isObject = __webpack_require__(28);
	var validate = __webpack_require__(132);
	var NATIVE_WEAK_MAP = __webpack_require__(132);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(233)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(1331);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
	 * A saveAs() FileSaver implementation.
	 * 1.3.2
	 * 2016-06-16 18:25:19
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: MIT
	 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
	 */
	
	/*global self */
	/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */
	
	/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
	
	var saveAs = saveAs || (function(view) {
		"use strict";
		// IE <10 is explicitly unsupported
		if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
			return;
		}
		var
			  doc = view.document
			  // only get URL when necessary in case Blob.js hasn't overridden it yet
			, get_URL = function() {
				return view.URL || view.webkitURL || view;
			}
			, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
			, can_use_save_link = "download" in save_link
			, click = function(node) {
				var event = new MouseEvent("click");
				node.dispatchEvent(event);
			}
			, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
			, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
			, throw_outside = function(ex) {
				(view.setImmediate || view.setTimeout)(function() {
					throw ex;
				}, 0);
			}
			, force_saveable_type = "application/octet-stream"
			// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
			, arbitrary_revoke_timeout = 1000 * 40 // in ms
			, revoke = function(file) {
				var revoker = function() {
					if (typeof file === "string") { // file is an object URL
						get_URL().revokeObjectURL(file);
					} else { // file is a File
						file.remove();
					}
				};
				setTimeout(revoker, arbitrary_revoke_timeout);
			}
			, dispatch = function(filesaver, event_types, event) {
				event_types = [].concat(event_types);
				var i = event_types.length;
				while (i--) {
					var listener = filesaver["on" + event_types[i]];
					if (typeof listener === "function") {
						try {
							listener.call(filesaver, event || filesaver);
						} catch (ex) {
							throw_outside(ex);
						}
					}
				}
			}
			, auto_bom = function(blob) {
				// prepend BOM for UTF-8 XML and text/* types (including HTML)
				// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
				if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
					return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
				}
				return blob;
			}
			, FileSaver = function(blob, name, no_auto_bom) {
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				// First try a.download, then web filesystem, then object URLs
				var
					  filesaver = this
					, type = blob.type
					, force = type === force_saveable_type
					, object_url
					, dispatch_all = function() {
						dispatch(filesaver, "writestart progress write writeend".split(" "));
					}
					// on any filesys errors revert to saving with object URLs
					, fs_error = function() {
						if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
							// Safari doesn't allow downloading of blob urls
							var reader = new FileReader();
							reader.onloadend = function() {
								var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
								var popup = view.open(url, '_blank');
								if(!popup) view.location.href = url;
								url=undefined; // release reference before dispatching
								filesaver.readyState = filesaver.DONE;
								dispatch_all();
							};
							reader.readAsDataURL(blob);
							filesaver.readyState = filesaver.INIT;
							return;
						}
						// don't create more object URLs than needed
						if (!object_url) {
							object_url = get_URL().createObjectURL(blob);
						}
						if (force) {
							view.location.href = object_url;
						} else {
							var opened = view.open(object_url, "_blank");
							if (!opened) {
								// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
								view.location.href = object_url;
							}
						}
						filesaver.readyState = filesaver.DONE;
						dispatch_all();
						revoke(object_url);
					}
				;
				filesaver.readyState = filesaver.INIT;
	
				if (can_use_save_link) {
					object_url = get_URL().createObjectURL(blob);
					setTimeout(function() {
						save_link.href = object_url;
						save_link.download = name;
						click(save_link);
						dispatch_all();
						revoke(object_url);
						filesaver.readyState = filesaver.DONE;
					});
					return;
				}
	
				fs_error();
			}
			, FS_proto = FileSaver.prototype
			, saveAs = function(blob, name, no_auto_bom) {
				return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
			}
		;
		// IE 10+ (native saveAs)
		if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
			return function(blob, name, no_auto_bom) {
				name = name || blob.name || "download";
	
				if (!no_auto_bom) {
					blob = auto_bom(blob);
				}
				return navigator.msSaveOrOpenBlob(blob, name);
			};
		}
	
		FS_proto.abort = function(){};
		FS_proto.readyState = FS_proto.INIT = 0;
		FS_proto.WRITING = 1;
		FS_proto.DONE = 2;
	
		FS_proto.error =
		FS_proto.onwritestart =
		FS_proto.onprogress =
		FS_proto.onwrite =
		FS_proto.onabort =
		FS_proto.onerror =
		FS_proto.onwriteend =
			null;
	
		return saveAs;
	}(
		   typeof self !== "undefined" && self
		|| typeof window !== "undefined" && window
		|| this.content
	));
	// `self` is undefined in Firefox for Android content script context
	// while `this` is nsIContentFrameMessageManager
	// with an attribute `content` that corresponds to the window
	
	if (typeof module !== "undefined" && module.exports) {
	  module.exports.saveAs = saveAs;
	} else if (("function" !== "undefined" && __webpack_require__(813) !== null) && (__webpack_require__(1846) !== null)) {
	  !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    return saveAs;
	  }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(345);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(1641);
	
	var _runTransitionHook = __webpack_require__(345);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(160);
	
	var _PathUtils = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ }),
/* 520 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 521 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}
	module.exports = exports["default"];

/***/ }),
/* 522 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(1360)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(1850);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ }),
/* 524 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery UI Widget 1.12.1
	 * http://jqueryui.com
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 */
	
	//>>label: Widget
	//>>group: Core
	//>>description: Provides a factory for creating stateful widgets with a common API.
	//>>docs: http://api.jqueryui.com/jQuery.widget/
	//>>demos: http://jqueryui.com/widget/
	
	( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(198), __webpack_require__(1372) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	}( function( $ ) {
	
	var widgetUuid = 0;
	var widgetSlice = Array.prototype.slice;
	
	$.cleanData = ( function( orig ) {
		return function( elems ) {
			var events, elem, i;
			for ( i = 0; ( elem = elems[ i ] ) != null; i++ ) {
				try {
	
					// Only trigger remove when necessary to save time
					events = $._data( elem, "events" );
					if ( events && events.remove ) {
						$( elem ).triggerHandler( "remove" );
					}
	
				// Http://bugs.jquery.com/ticket/8235
				} catch ( e ) {}
			}
			orig( elems );
		};
	} )( $.cleanData );
	
	$.widget = function( name, base, prototype ) {
		var existingConstructor, constructor, basePrototype;
	
		// ProxiedPrototype allows the provided prototype to remain unmodified
		// so that it can be used as a mixin for multiple widgets (#8876)
		var proxiedPrototype = {};
	
		var namespace = name.split( "." )[ 0 ];
		name = name.split( "." )[ 1 ];
		var fullName = namespace + "-" + name;
	
		if ( !prototype ) {
			prototype = base;
			base = $.Widget;
		}
	
		if ( $.isArray( prototype ) ) {
			prototype = $.extend.apply( null, [ {} ].concat( prototype ) );
		}
	
		// Create selector for plugin
		$.expr[ ":" ][ fullName.toLowerCase() ] = function( elem ) {
			return !!$.data( elem, fullName );
		};
	
		$[ namespace ] = $[ namespace ] || {};
		existingConstructor = $[ namespace ][ name ];
		constructor = $[ namespace ][ name ] = function( options, element ) {
	
			// Allow instantiation without "new" keyword
			if ( !this._createWidget ) {
				return new constructor( options, element );
			}
	
			// Allow instantiation without initializing for simple inheritance
			// must use "new" keyword (the code above always passes args)
			if ( arguments.length ) {
				this._createWidget( options, element );
			}
		};
	
		// Extend with the existing constructor to carry over any static properties
		$.extend( constructor, existingConstructor, {
			version: prototype.version,
	
			// Copy the object used to create the prototype in case we need to
			// redefine the widget later
			_proto: $.extend( {}, prototype ),
	
			// Track widgets that inherit from this widget in case this widget is
			// redefined after a widget inherits from it
			_childConstructors: []
		} );
	
		basePrototype = new base();
	
		// We need to make the options hash a property directly on the new instance
		// otherwise we'll modify the options hash on the prototype that we're
		// inheriting from
		basePrototype.options = $.widget.extend( {}, basePrototype.options );
		$.each( prototype, function( prop, value ) {
			if ( !$.isFunction( value ) ) {
				proxiedPrototype[ prop ] = value;
				return;
			}
			proxiedPrototype[ prop ] = ( function() {
				function _super() {
					return base.prototype[ prop ].apply( this, arguments );
				}
	
				function _superApply( args ) {
					return base.prototype[ prop ].apply( this, args );
				}
	
				return function() {
					var __super = this._super;
					var __superApply = this._superApply;
					var returnValue;
	
					this._super = _super;
					this._superApply = _superApply;
	
					returnValue = value.apply( this, arguments );
	
					this._super = __super;
					this._superApply = __superApply;
	
					return returnValue;
				};
			} )();
		} );
		constructor.prototype = $.widget.extend( basePrototype, {
	
			// TODO: remove support for widgetEventPrefix
			// always use the name + a colon as the prefix, e.g., draggable:start
			// don't prefix for widgets that aren't DOM-based
			widgetEventPrefix: existingConstructor ? ( basePrototype.widgetEventPrefix || name ) : name
		}, proxiedPrototype, {
			constructor: constructor,
			namespace: namespace,
			widgetName: name,
			widgetFullName: fullName
		} );
	
		// If this widget is being redefined then we need to find all widgets that
		// are inheriting from it and redefine all of them so that they inherit from
		// the new version of this widget. We're essentially trying to replace one
		// level in the prototype chain.
		if ( existingConstructor ) {
			$.each( existingConstructor._childConstructors, function( i, child ) {
				var childPrototype = child.prototype;
	
				// Redefine the child widget using the same prototype that was
				// originally used, but inherit from the new version of the base
				$.widget( childPrototype.namespace + "." + childPrototype.widgetName, constructor,
					child._proto );
			} );
	
			// Remove the list of existing child constructors from the old constructor
			// so the old child constructors can be garbage collected
			delete existingConstructor._childConstructors;
		} else {
			base._childConstructors.push( constructor );
		}
	
		$.widget.bridge( name, constructor );
	
		return constructor;
	};
	
	$.widget.extend = function( target ) {
		var input = widgetSlice.call( arguments, 1 );
		var inputIndex = 0;
		var inputLength = input.length;
		var key;
		var value;
	
		for ( ; inputIndex < inputLength; inputIndex++ ) {
			for ( key in input[ inputIndex ] ) {
				value = input[ inputIndex ][ key ];
				if ( input[ inputIndex ].hasOwnProperty( key ) && value !== undefined ) {
	
					// Clone objects
					if ( $.isPlainObject( value ) ) {
						target[ key ] = $.isPlainObject( target[ key ] ) ?
							$.widget.extend( {}, target[ key ], value ) :
	
							// Don't extend strings, arrays, etc. with objects
							$.widget.extend( {}, value );
	
					// Copy everything else by reference
					} else {
						target[ key ] = value;
					}
				}
			}
		}
		return target;
	};
	
	$.widget.bridge = function( name, object ) {
		var fullName = object.prototype.widgetFullName || name;
		$.fn[ name ] = function( options ) {
			var isMethodCall = typeof options === "string";
			var args = widgetSlice.call( arguments, 1 );
			var returnValue = this;
	
			if ( isMethodCall ) {
	
				// If this is an empty collection, we need to have the instance method
				// return undefined instead of the jQuery instance
				if ( !this.length && options === "instance" ) {
					returnValue = undefined;
				} else {
					this.each( function() {
						var methodValue;
						var instance = $.data( this, fullName );
	
						if ( options === "instance" ) {
							returnValue = instance;
							return false;
						}
	
						if ( !instance ) {
							return $.error( "cannot call methods on " + name +
								" prior to initialization; " +
								"attempted to call method '" + options + "'" );
						}
	
						if ( !$.isFunction( instance[ options ] ) || options.charAt( 0 ) === "_" ) {
							return $.error( "no such method '" + options + "' for " + name +
								" widget instance" );
						}
	
						methodValue = instance[ options ].apply( instance, args );
	
						if ( methodValue !== instance && methodValue !== undefined ) {
							returnValue = methodValue && methodValue.jquery ?
								returnValue.pushStack( methodValue.get() ) :
								methodValue;
							return false;
						}
					} );
				}
			} else {
	
				// Allow multiple hashes to be passed on init
				if ( args.length ) {
					options = $.widget.extend.apply( null, [ options ].concat( args ) );
				}
	
				this.each( function() {
					var instance = $.data( this, fullName );
					if ( instance ) {
						instance.option( options || {} );
						if ( instance._init ) {
							instance._init();
						}
					} else {
						$.data( this, fullName, new object( options, this ) );
					}
				} );
			}
	
			return returnValue;
		};
	};
	
	$.Widget = function( /* options, element */ ) {};
	$.Widget._childConstructors = [];
	
	$.Widget.prototype = {
		widgetName: "widget",
		widgetEventPrefix: "",
		defaultElement: "<div>",
	
		options: {
			classes: {},
			disabled: false,
	
			// Callbacks
			create: null
		},
	
		_createWidget: function( options, element ) {
			element = $( element || this.defaultElement || this )[ 0 ];
			this.element = $( element );
			this.uuid = widgetUuid++;
			this.eventNamespace = "." + this.widgetName + this.uuid;
	
			this.bindings = $();
			this.hoverable = $();
			this.focusable = $();
			this.classesElementLookup = {};
	
			if ( element !== this ) {
				$.data( element, this.widgetFullName, this );
				this._on( true, this.element, {
					remove: function( event ) {
						if ( event.target === element ) {
							this.destroy();
						}
					}
				} );
				this.document = $( element.style ?
	
					// Element within the document
					element.ownerDocument :
	
					// Element is window or document
					element.document || element );
				this.window = $( this.document[ 0 ].defaultView || this.document[ 0 ].parentWindow );
			}
	
			this.options = $.widget.extend( {},
				this.options,
				this._getCreateOptions(),
				options );
	
			this._create();
	
			if ( this.options.disabled ) {
				this._setOptionDisabled( this.options.disabled );
			}
	
			this._trigger( "create", null, this._getCreateEventData() );
			this._init();
		},
	
		_getCreateOptions: function() {
			return {};
		},
	
		_getCreateEventData: $.noop,
	
		_create: $.noop,
	
		_init: $.noop,
	
		destroy: function() {
			var that = this;
	
			this._destroy();
			$.each( this.classesElementLookup, function( key, value ) {
				that._removeClass( value, key );
			} );
	
			// We can probably remove the unbind calls in 2.0
			// all event bindings should go through this._on()
			this.element
				.off( this.eventNamespace )
				.removeData( this.widgetFullName );
			this.widget()
				.off( this.eventNamespace )
				.removeAttr( "aria-disabled" );
	
			// Clean up events and states
			this.bindings.off( this.eventNamespace );
		},
	
		_destroy: $.noop,
	
		widget: function() {
			return this.element;
		},
	
		option: function( key, value ) {
			var options = key;
			var parts;
			var curOption;
			var i;
	
			if ( arguments.length === 0 ) {
	
				// Don't return a reference to the internal hash
				return $.widget.extend( {}, this.options );
			}
	
			if ( typeof key === "string" ) {
	
				// Handle nested keys, e.g., "foo.bar" => { foo: { bar: ___ } }
				options = {};
				parts = key.split( "." );
				key = parts.shift();
				if ( parts.length ) {
					curOption = options[ key ] = $.widget.extend( {}, this.options[ key ] );
					for ( i = 0; i < parts.length - 1; i++ ) {
						curOption[ parts[ i ] ] = curOption[ parts[ i ] ] || {};
						curOption = curOption[ parts[ i ] ];
					}
					key = parts.pop();
					if ( arguments.length === 1 ) {
						return curOption[ key ] === undefined ? null : curOption[ key ];
					}
					curOption[ key ] = value;
				} else {
					if ( arguments.length === 1 ) {
						return this.options[ key ] === undefined ? null : this.options[ key ];
					}
					options[ key ] = value;
				}
			}
	
			this._setOptions( options );
	
			return this;
		},
	
		_setOptions: function( options ) {
			var key;
	
			for ( key in options ) {
				this._setOption( key, options[ key ] );
			}
	
			return this;
		},
	
		_setOption: function( key, value ) {
			if ( key === "classes" ) {
				this._setOptionClasses( value );
			}
	
			this.options[ key ] = value;
	
			if ( key === "disabled" ) {
				this._setOptionDisabled( value );
			}
	
			return this;
		},
	
		_setOptionClasses: function( value ) {
			var classKey, elements, currentElements;
	
			for ( classKey in value ) {
				currentElements = this.classesElementLookup[ classKey ];
				if ( value[ classKey ] === this.options.classes[ classKey ] ||
						!currentElements ||
						!currentElements.length ) {
					continue;
				}
	
				// We are doing this to create a new jQuery object because the _removeClass() call
				// on the next line is going to destroy the reference to the current elements being
				// tracked. We need to save a copy of this collection so that we can add the new classes
				// below.
				elements = $( currentElements.get() );
				this._removeClass( currentElements, classKey );
	
				// We don't use _addClass() here, because that uses this.options.classes
				// for generating the string of classes. We want to use the value passed in from
				// _setOption(), this is the new value of the classes option which was passed to
				// _setOption(). We pass this value directly to _classes().
				elements.addClass( this._classes( {
					element: elements,
					keys: classKey,
					classes: value,
					add: true
				} ) );
			}
		},
	
		_setOptionDisabled: function( value ) {
			this._toggleClass( this.widget(), this.widgetFullName + "-disabled", null, !!value );
	
			// If the widget is becoming disabled, then nothing is interactive
			if ( value ) {
				this._removeClass( this.hoverable, null, "ui-state-hover" );
				this._removeClass( this.focusable, null, "ui-state-focus" );
			}
		},
	
		enable: function() {
			return this._setOptions( { disabled: false } );
		},
	
		disable: function() {
			return this._setOptions( { disabled: true } );
		},
	
		_classes: function( options ) {
			var full = [];
			var that = this;
	
			options = $.extend( {
				element: this.element,
				classes: this.options.classes || {}
			}, options );
	
			function processClassString( classes, checkOption ) {
				var current, i;
				for ( i = 0; i < classes.length; i++ ) {
					current = that.classesElementLookup[ classes[ i ] ] || $();
					if ( options.add ) {
						current = $( $.unique( current.get().concat( options.element.get() ) ) );
					} else {
						current = $( current.not( options.element ).get() );
					}
					that.classesElementLookup[ classes[ i ] ] = current;
					full.push( classes[ i ] );
					if ( checkOption && options.classes[ classes[ i ] ] ) {
						full.push( options.classes[ classes[ i ] ] );
					}
				}
			}
	
			this._on( options.element, {
				"remove": "_untrackClassesElement"
			} );
	
			if ( options.keys ) {
				processClassString( options.keys.match( /\S+/g ) || [], true );
			}
			if ( options.extra ) {
				processClassString( options.extra.match( /\S+/g ) || [] );
			}
	
			return full.join( " " );
		},
	
		_untrackClassesElement: function( event ) {
			var that = this;
			$.each( that.classesElementLookup, function( key, value ) {
				if ( $.inArray( event.target, value ) !== -1 ) {
					that.classesElementLookup[ key ] = $( value.not( event.target ).get() );
				}
			} );
		},
	
		_removeClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, false );
		},
	
		_addClass: function( element, keys, extra ) {
			return this._toggleClass( element, keys, extra, true );
		},
	
		_toggleClass: function( element, keys, extra, add ) {
			add = ( typeof add === "boolean" ) ? add : extra;
			var shift = ( typeof element === "string" || element === null ),
				options = {
					extra: shift ? keys : extra,
					keys: shift ? element : keys,
					element: shift ? this.element : element,
					add: add
				};
			options.element.toggleClass( this._classes( options ), add );
			return this;
		},
	
		_on: function( suppressDisabledCheck, element, handlers ) {
			var delegateElement;
			var instance = this;
	
			// No suppressDisabledCheck flag, shuffle arguments
			if ( typeof suppressDisabledCheck !== "boolean" ) {
				handlers = element;
				element = suppressDisabledCheck;
				suppressDisabledCheck = false;
			}
	
			// No element argument, shuffle and use this.element
			if ( !handlers ) {
				handlers = element;
				element = this.element;
				delegateElement = this.widget();
			} else {
				element = delegateElement = $( element );
				this.bindings = this.bindings.add( element );
			}
	
			$.each( handlers, function( event, handler ) {
				function handlerProxy() {
	
					// Allow widgets to customize the disabled handling
					// - disabled as an array instead of boolean
					// - disabled class as method for disabling individual parts
					if ( !suppressDisabledCheck &&
							( instance.options.disabled === true ||
							$( this ).hasClass( "ui-state-disabled" ) ) ) {
						return;
					}
					return ( typeof handler === "string" ? instance[ handler ] : handler )
						.apply( instance, arguments );
				}
	
				// Copy the guid so direct unbinding works
				if ( typeof handler !== "string" ) {
					handlerProxy.guid = handler.guid =
						handler.guid || handlerProxy.guid || $.guid++;
				}
	
				var match = event.match( /^([\w:-]*)\s*(.*)$/ );
				var eventName = match[ 1 ] + instance.eventNamespace;
				var selector = match[ 2 ];
	
				if ( selector ) {
					delegateElement.on( eventName, selector, handlerProxy );
				} else {
					element.on( eventName, handlerProxy );
				}
			} );
		},
	
		_off: function( element, eventName ) {
			eventName = ( eventName || "" ).split( " " ).join( this.eventNamespace + " " ) +
				this.eventNamespace;
			element.off( eventName ).off( eventName );
	
			// Clear the stack to avoid memory leaks (#10056)
			this.bindings = $( this.bindings.not( element ).get() );
			this.focusable = $( this.focusable.not( element ).get() );
			this.hoverable = $( this.hoverable.not( element ).get() );
		},
	
		_delay: function( handler, delay ) {
			function handlerProxy() {
				return ( typeof handler === "string" ? instance[ handler ] : handler )
					.apply( instance, arguments );
			}
			var instance = this;
			return setTimeout( handlerProxy, delay || 0 );
		},
	
		_hoverable: function( element ) {
			this.hoverable = this.hoverable.add( element );
			this._on( element, {
				mouseenter: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-hover" );
				},
				mouseleave: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-hover" );
				}
			} );
		},
	
		_focusable: function( element ) {
			this.focusable = this.focusable.add( element );
			this._on( element, {
				focusin: function( event ) {
					this._addClass( $( event.currentTarget ), null, "ui-state-focus" );
				},
				focusout: function( event ) {
					this._removeClass( $( event.currentTarget ), null, "ui-state-focus" );
				}
			} );
		},
	
		_trigger: function( type, event, data ) {
			var prop, orig;
			var callback = this.options[ type ];
	
			data = data || {};
			event = $.Event( event );
			event.type = ( type === this.widgetEventPrefix ?
				type :
				this.widgetEventPrefix + type ).toLowerCase();
	
			// The original event may come from any element
			// so we need to reset the target on the new event
			event.target = this.element[ 0 ];
	
			// Copy original event properties over to the new event
			orig = event.originalEvent;
			if ( orig ) {
				for ( prop in orig ) {
					if ( !( prop in event ) ) {
						event[ prop ] = orig[ prop ];
					}
				}
			}
	
			this.element.trigger( event, data );
			return !( $.isFunction( callback ) &&
				callback.apply( this.element[ 0 ], [ event ].concat( data ) ) === false ||
				event.isDefaultPrevented() );
		}
	};
	
	$.each( { show: "fadeIn", hide: "fadeOut" }, function( method, defaultEffect ) {
		$.Widget.prototype[ "_" + method ] = function( element, options, callback ) {
			if ( typeof options === "string" ) {
				options = { effect: options };
			}
	
			var hasOptions;
			var effectName = !options ?
				method :
				options === true || typeof options === "number" ?
					defaultEffect :
					options.effect || defaultEffect;
	
			options = options || {};
			if ( typeof options === "number" ) {
				options = { duration: options };
			}
	
			hasOptions = !$.isEmptyObject( options );
			options.complete = callback;
	
			if ( options.delay ) {
				element.delay( options.delay );
			}
	
			if ( hasOptions && $.effects && $.effects.effect[ effectName ] ) {
				element[ method ]( options );
			} else if ( effectName !== method && element[ effectName ] ) {
				element[ effectName ]( options.duration, options.easing, callback );
			} else {
				element.queue( function( next ) {
					$( this )[ method ]();
					if ( callback ) {
						callback.call( element[ 0 ] );
					}
					next();
				} );
			}
		};
	} );
	
	return $.widget;
	
	} ) );


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(135),
	    root = __webpack_require__(80);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(351),
	    setCacheAdd = __webpack_require__(1480),
	    setCacheHas = __webpack_require__(1481);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(80);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(135),
	    root = __webpack_require__(80);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 533 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 534 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(1421),
	    isArguments = __webpack_require__(205),
	    isArray = __webpack_require__(41),
	    isBuffer = __webpack_require__(206),
	    isIndex = __webpack_require__(258),
	    isTypedArray = __webpack_require__(266);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(164),
	    eq = __webpack_require__(201);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ }),
/* 537 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(355),
	    keys = __webpack_require__(99);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(352),
	    isArray = __webpack_require__(41);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(260),
	    nativeKeys = __webpack_require__(1475);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(251),
	    isArrayLike = __webpack_require__(97);
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	module.exports = baseMap;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(163),
	    baseGet = __webpack_require__(199),
	    baseIteratee = __webpack_require__(112),
	    baseMap = __webpack_require__(541),
	    baseSortBy = __webpack_require__(1420),
	    baseUnary = __webpack_require__(255),
	    compareMultiple = __webpack_require__(1431),
	    identity = __webpack_require__(203),
	    isArray = __webpack_require__(41);
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        }
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	module.exports = baseOrderBy;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(353),
	    castPath = __webpack_require__(165),
	    isIndex = __webpack_require__(258),
	    isObject = __webpack_require__(63),
	    toKey = __webpack_require__(136);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	      return object;
	    }
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(1490);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ }),
/* 545 */
/***/ (function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(203);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(80);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(361);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayAggregator = __webpack_require__(1388),
	    baseAggregator = __webpack_require__(1393),
	    baseIteratee = __webpack_require__(112),
	    isArray = __webpack_require__(41);
	
	/**
	 * Creates a function like `_.groupBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} [initializer] The accumulator object initializer.
	 * @returns {Function} Returns the new aggregator function.
	 */
	function createAggregator(setter, initializer) {
	  return function(collection, iteratee) {
	    var func = isArray(collection) ? arrayAggregator : baseAggregator,
	        accumulator = initializer ? initializer() : {};
	
	    return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
	  };
	}
	
	module.exports = createAggregator;


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(135);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(530),
	    arraySome = __webpack_require__(1391),
	    cacheHas = __webpack_require__(545);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 552 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(539),
	    getSymbols = __webpack_require__(364),
	    keys = __webpack_require__(99);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(539),
	    getSymbolsIn = __webpack_require__(557),
	    keysIn = __webpack_require__(168);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	var metaMap = __webpack_require__(1474),
	    noop = __webpack_require__(577);
	
	/**
	 * Gets metadata for `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {*} Returns the metadata for `func`.
	 */
	var getData = !metaMap ? noop : function(func) {
	  return metaMap.get(func);
	};
	
	module.exports = getData;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	var realNames = __webpack_require__(1479);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the name of `func`.
	 *
	 * @private
	 * @param {Function} func The function to query.
	 * @returns {string} Returns the function name.
	 */
	function getFuncName(func) {
	  var result = (func.name + ''),
	      array = realNames[result],
	      length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	  while (length--) {
	    var data = array[length],
	        otherFunc = data.func;
	    if (otherFunc == null || otherFunc == func) {
	      return data.name;
	    }
	  }
	  return result;
	}
	
	module.exports = getFuncName;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(352),
	    getPrototype = __webpack_require__(363),
	    getSymbols = __webpack_require__(364),
	    stubArray = __webpack_require__(579);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(354),
	    getPrototype = __webpack_require__(363),
	    isPrototype = __webpack_require__(260);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(63);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 560 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ }),
/* 561 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(1387);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ }),
/* 563 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(1419),
	    shortOut = __webpack_require__(1482);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(1473);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ }),
/* 566 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 567 */
/***/ (function(module, exports) {

	/**
	 * Creates an array with all falsey values removed. The values `false`, `null`,
	 * `0`, `""`, `undefined`, and `NaN` are falsey.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to compact.
	 * @returns {Array} Returns the new array of filtered values.
	 * @example
	 *
	 * _.compact([0, 1, false, 2, '', 3]);
	 * // => [1, 2, 3]
	 */
	function compact(array) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = compact;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(252);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(252);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Recursively flattens `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flattenDeep([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, 3, 4, 5]
	 */
	function flattenDeep(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, INFINITY) : [];
	}
	
	module.exports = flattenDeep;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(355),
	    castFunction = __webpack_require__(546),
	    keysIn = __webpack_require__(168);
	
	/**
	 * Iterates over own and inherited enumerable string keyed properties of an
	 * object and invokes `iteratee` for each property. The iteratee is invoked
	 * with three arguments: (value, key, object). Iteratee functions may exit
	 * iteration early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forInRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forIn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	 */
	function forIn(object, iteratee) {
	  return object == null
	    ? object
	    : baseFor(object, castFunction(iteratee), keysIn);
	}
	
	module.exports = forIn;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(1399),
	    hasPath = __webpack_require__(1449);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(97),
	    isObjectLike = __webpack_require__(81);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(254);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are compared by strict equality, i.e. `===`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(254);
	
	/**
	 * This method is like `_.isEqual` except that it accepts `customizer` which
	 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	 * are handled by the method instead. The `customizer` is invoked with up to
	 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * function isGreeting(value) {
	 *   return /^h(?:i|ello)$/.test(value);
	 * }
	 *
	 * function customizer(objValue, othValue) {
	 *   if (isGreeting(objValue) && isGreeting(othValue)) {
	 *     return true;
	 *   }
	 * }
	 *
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqualWith(array, other, customizer);
	 * // => true
	 */
	function isEqualWith(value, other, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	}
	
	module.exports = isEqualWith;


/***/ }),
/* 575 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(1411),
	    createAssigner = __webpack_require__(1435);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ }),
/* 577 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(252),
	    baseOrderBy = __webpack_require__(542),
	    baseRest = __webpack_require__(357),
	    isIterateeCall = __webpack_require__(259);
	
	/**
	 * Creates an array of elements, sorted in ascending order by the results of
	 * running each element in a collection thru each iteratee. This method
	 * performs a stable sort, that is, it preserves the original sort order of
	 * equal elements. The iteratees are invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {...(Function|Function[])} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 36 },
	 *   { 'user': 'fred',   'age': 30 },
	 *   { 'user': 'barney', 'age': 34 }
	 * ];
	 *
	 * _.sortBy(users, [function(o) { return o.user; }]);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
	 *
	 * _.sortBy(users, ['user', 'age']);
	 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
	 */
	var sortBy = baseRest(function(collection, iteratees) {
	  if (collection == null) {
	    return [];
	  }
	  var length = iteratees.length;
	  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	    iteratees = [];
	  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	    iteratees = [iteratees[0]];
	  }
	  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	});
	
	module.exports = sortBy;


/***/ }),
/* 579 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(581);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(544),
	    isObject = __webpack_require__(63),
	    isSymbol = __webpack_require__(167);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(112),
	    baseUniq = __webpack_require__(360);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The order of result values is determined by the
	 * order they occur in the array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	
	module.exports = uniqBy;


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(1423),
	    keys = __webpack_require__(99);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AppBar = __webpack_require__(1519);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AppBar2.default;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Avatar = __webpack_require__(1522);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar2.default;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(84);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var selected = props.selected;
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var color = selected ? bottomNavigation.selectedColor : bottomNavigation.unselectedColor;
	
	  var styles = {
	    root: {
	      transition: 'padding-top 0.3s',
	      paddingTop: selected ? 6 : 8,
	      paddingBottom: 10,
	      paddingLeft: 12,
	      paddingRight: 12,
	      minWidth: 80,
	      maxWidth: 168
	    },
	    label: {
	      fontSize: selected ? bottomNavigation.selectedFontSize : bottomNavigation.unselectedFontSize,
	      transition: 'color 0.3s, font-size 0.3s',
	      color: color
	    },
	    icon: {
	      display: 'block',
	      /**
	       * Used to ensure SVG icons are centered
	       */
	      width: '100%'
	    },
	    iconColor: color
	  };
	
	  return styles;
	}
	
	var BottomNavigationItem = function BottomNavigationItem(props, context) {
	  var label = props.label,
	      icon = props.icon,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['label', 'icon', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var styledIcon = (0, _react.cloneElement)(icon, {
	    style: (0, _simpleAssign2.default)({}, styles.icon, icon.props.style),
	    color: icon.props.color || styles.iconColor
	  });
	
	  return _react2.default.createElement(
	    _EnhancedButton2.default,
	    (0, _extends3.default)({}, other, { style: (0, _simpleAssign2.default)({}, styles.root, style) }),
	    styledIcon,
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles(styles.label) },
	      label
	    )
	  );
	};
	
	BottomNavigationItem.propTypes =  false ? {
	  /**
	   * Set the icon representing the view for this item.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * Set the label describing the view for this item.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	BottomNavigationItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = BottomNavigationItem;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      padding: 8,
	      position: 'relative'
	    },
	    action: {
	      marginRight: 8
	    }
	  };
	}
	
	var CardActions = function (_Component) {
	  (0, _inherits3.default)(CardActions, _Component);
	
	  function CardActions() {
	    (0, _classCallCheck3.default)(this, CardActions);
	    return (0, _possibleConstructorReturn3.default)(this, (CardActions.__proto__ || (0, _getPrototypeOf2.default)(CardActions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        styledChildren
	      );
	    }
	  }]);
	  return CardActions;
	}(_react.Component);
	
	CardActions.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardActions.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Action.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = CardActions;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keyboardArrowUp = __webpack_require__(1612);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardArrowDown = __webpack_require__(1611);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _IconButton = __webpack_require__(64);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      top: 0,
	      bottom: 0,
	      right: 4,
	      margin: 'auto',
	      position: 'absolute'
	    }
	  };
	}
	
	var CardExpandable = function (_Component) {
	  (0, _inherits3.default)(CardExpandable, _Component);
	
	  function CardExpandable() {
	    (0, _classCallCheck3.default)(this, CardExpandable);
	    return (0, _possibleConstructorReturn3.default)(this, (CardExpandable.__proto__ || (0, _getPrototypeOf2.default)(CardExpandable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardExpandable, [{
	    key: 'render',
	    value: function render() {
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _IconButton2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          onClick: this.props.onExpanding,
	          iconStyle: this.props.iconStyle
	        },
	        this.props.expanded ? this.props.openIcon : this.props.closeIcon
	      );
	    }
	  }]);
	  return CardExpandable;
	}(_react.Component);
	
	CardExpandable.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardExpandable.defaultProps = {
	  closeIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
	  openIcon: _react2.default.createElement(_keyboardArrowUp2.default, null)
	};
	CardExpandable.propTypes =  false ? {
	  closeIcon: _propTypes2.default.node,
	  expanded: _propTypes2.default.bool,
	  iconStyle: _propTypes2.default.object,
	  onExpanding: _propTypes2.default.func.isRequired,
	  openIcon: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : {};
	exports.default = CardExpandable;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Avatar = __webpack_require__(585);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontWeight: card.fontWeight,
	      boxSizing: 'border-box',
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    text: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      whiteSpace: 'normal',
	      paddingRight: '90px'
	    },
	    avatar: {
	      marginRight: 16
	    },
	    title: {
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      fontSize: 15
	    },
	    subtitle: {
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block',
	      fontSize: 14
	    }
	  };
	}
	
	var CardHeader = function (_Component) {
	  (0, _inherits3.default)(CardHeader, _Component);
	
	  function CardHeader() {
	    (0, _classCallCheck3.default)(this, CardHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (CardHeader.__proto__ || (0, _getPrototypeOf2.default)(CardHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          avatarProp = _props.avatar,
	          children = _props.children,
	          closeIcon = _props.closeIcon,
	          expandable = _props.expandable,
	          openIcon = _props.openIcon,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          textStyle = _props.textStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          iconStyle = _props.iconStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'avatar', 'children', 'closeIcon', 'expandable', 'openIcon', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'textStyle', 'title', 'titleColor', 'titleStyle', 'iconStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var avatar = avatarProp;
	
	      if ((0, _react.isValidElement)(avatarProp)) {
	        avatar = _react2.default.cloneElement(avatar, {
	          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
	        });
	      } else if (avatar !== null) {
	        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        avatar,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	            title
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	            subtitle
	          )
	        ),
	        children
	      );
	    }
	  }]);
	  return CardHeader;
	}(_react.Component);
	
	CardHeader.muiName = 'CardHeader';
	CardHeader.defaultProps = {
	  avatar: null
	};
	CardHeader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardHeader.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
	   * If `avatar` is an `Avatar` or other element, it will be rendered.
	   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
	   */
	  avatar: _propTypes2.default.node,
	  /**
	   * Can be used to render elements inside the Card Header.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
	   */
	  closeIcon: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Override the iconStyle of the Icon Button.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Can be used to pass a openIcon if you don't like the default expandable open Icon.
	   */
	  openIcon: _propTypes2.default.node,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Can be used to render a subtitle in Card Header.
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the text.
	   */
	  textStyle: _propTypes2.default.object,
	  /**
	   * Can be used to render a title in Card Header.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _propTypes2.default.object
	} : {};
	exports.default = CardHeader;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardMedia = context.muiTheme.cardMedia;
	
	
	  return {
	    root: {
	      position: 'relative'
	    },
	    overlayContainer: {
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0
	    },
	    overlay: {
	      height: '100%',
	      position: 'relative'
	    },
	    overlayContent: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      left: 0,
	      paddingTop: 8,
	      background: cardMedia.overlayContentBackground
	    },
	    media: {},
	    mediaChild: {
	      verticalAlign: 'top',
	      maxWidth: '100%',
	      minWidth: '100%',
	      width: '100%'
	    }
	  };
	}
	
	var CardMedia = function (_Component) {
	  (0, _inherits3.default)(CardMedia, _Component);
	
	  function CardMedia() {
	    (0, _classCallCheck3.default)(this, CardMedia);
	    return (0, _possibleConstructorReturn3.default)(this, (CardMedia.__proto__ || (0, _getPrototypeOf2.default)(CardMedia)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardMedia, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          mediaStyle = _props.mediaStyle,
	          overlay = _props.overlay,
	          overlayContainerStyle = _props.overlayContainerStyle,
	          overlayContentStyle = _props.overlayContentStyle,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
	      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
	      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
	      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      var titleColor = this.context.muiTheme.cardMedia.titleColor;
	      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
	      var color = this.context.muiTheme.cardMedia.color;
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        if (!child) {
	          return child;
	        }
	
	        return _react2.default.cloneElement(child, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
	        });
	      });
	
	      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
	        var childMuiName = child && child.type ? child.type.muiName : null;
	
	        if (childMuiName === 'CardHeader' || childMuiName === 'CardTitle') {
	          return _react2.default.cloneElement(child, {
	            titleColor: titleColor,
	            subtitleColor: subtitleColor
	          });
	        } else if (childMuiName === 'CardText') {
	          return _react2.default.cloneElement(child, {
	            color: color
	          });
	        } else {
	          return child;
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedMediaStyle) },
	          styledChildren
	        ),
	        overlay ? _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedOverlayContainerStyle) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(extendedOverlayStyle) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(extendedOverlayContentStyle) },
	              overlayChildren
	            )
	          )
	        ) : ''
	      );
	    }
	  }]);
	  return CardMedia;
	}(_react.Component);
	
	CardMedia.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardMedia.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Media.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the Card Media.
	   */
	  mediaStyle: _propTypes2.default.object,
	  /**
	   * Can be used to render overlay element in Card Media.
	   */
	  overlay: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the overlay container.
	   */
	  overlayContainerStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the overlay content.
	   */
	  overlayContentStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the overlay element.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = CardMedia;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardText = context.muiTheme.cardText;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontSize: 14,
	      color: props.color || cardText.textColor
	    }
	  };
	}
	
	var CardText = function (_Component) {
	  (0, _inherits3.default)(CardText, _Component);
	
	  function CardText() {
	    (0, _classCallCheck3.default)(this, CardText);
	    return (0, _possibleConstructorReturn3.default)(this, (CardText.__proto__ || (0, _getPrototypeOf2.default)(CardText)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          color = _props.color,
	          expandable = _props.expandable,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        children
	      );
	    }
	  }]);
	  return CardText;
	}(_react.Component);
	
	CardText.muiName = 'CardText';
	CardText.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardText.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Text.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the CardText color.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = CardText;

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      position: 'relative'
	    },
	    title: {
	      fontSize: 24,
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      lineHeight: '36px'
	    },
	    subtitle: {
	      fontSize: 14,
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block'
	    }
	  };
	}
	
	var CardTitle = function (_Component) {
	  (0, _inherits3.default)(CardTitle, _Component);
	
	  function CardTitle() {
	    (0, _classCallCheck3.default)(this, CardTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (CardTitle.__proto__ || (0, _getPrototypeOf2.default)(CardTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          closeIcon = _props.closeIcon,
	          expandable = _props.expandable,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'closeIcon', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
	      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
	      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedTitleStyle) },
	          title
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedSubtitleStyle) },
	          subtitle
	        ),
	        children
	      );
	    }
	  }]);
	  return CardTitle;
	}(_react.Component);
	
	CardTitle.muiName = 'CardTitle';
	CardTitle.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardTitle.propTypes =  false ? {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Title.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
	   */
	  closeIcon: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Can be used to render a subtitle in the Card Title.
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _propTypes2.default.object,
	  /**
	   * Can be used to render a title in the Card Title.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _propTypes2.default.object
	} : {};
	exports.default = CardTitle;

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = function Divider(props, context) {
	  var inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      prepareStyles = _context$muiTheme.prepareStyles;
	
	
	  var styles = {
	    root: {
	      margin: 0,
	      marginTop: -1,
	      marginLeft: inset ? 72 : 0,
	      height: 1,
	      border: 'none',
	      backgroundColor: baseTheme.palette.borderColor
	    }
	  };
	
	  return _react2.default.createElement('hr', (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }));
	};
	
	Divider.muiName = 'Divider';
	
	Divider.propTypes =  false ? {
	  /**
	   * If true, the `Divider` will be indented.
	   */
	  inset: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	Divider.defaultProps = {
	  inset: false
	};
	
	Divider.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Divider;

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Drawer = __webpack_require__(1545);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Drawer2.default;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(462);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _titleBar;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      gridTile = _context$muiTheme.gridTile;
	
	
	  var actionPos = props.actionIcon && props.actionPosition;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'block',
	      height: '100%',
	      overflow: 'hidden'
	    },
	    titleBar: (_titleBar = {
	      position: 'absolute',
	      left: 0,
	      right: 0
	    }, (0, _defineProperty3.default)(_titleBar, props.titlePosition, 0), (0, _defineProperty3.default)(_titleBar, 'height', props.subtitle ? 68 : 48), (0, _defineProperty3.default)(_titleBar, 'background', props.titleBackground), (0, _defineProperty3.default)(_titleBar, 'display', 'flex'), (0, _defineProperty3.default)(_titleBar, 'alignItems', 'center'), _titleBar),
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: actionPos !== 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginRight: actionPos === 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      color: gridTile.textColor,
	      overflow: 'hidden'
	    },
	    title: {
	      fontSize: '16px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    subtitle: {
	      fontSize: '12px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    actionIcon: {
	      order: actionPos === 'left' ? -1 : 1
	    },
	    childImg: {
	      height: '100%',
	      transform: 'translateX(-50%)',
	      position: 'relative',
	      left: '50%'
	    }
	  };
	  return styles;
	}
	
	var GridTile = function (_Component) {
	  (0, _inherits3.default)(GridTile, _Component);
	
	  function GridTile() {
	    (0, _classCallCheck3.default)(this, GridTile);
	    return (0, _possibleConstructorReturn3.default)(this, (GridTile.__proto__ || (0, _getPrototypeOf2.default)(GridTile)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridTile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'ensureImageCover',
	    value: function ensureImageCover() {
	      var _this2 = this;
	
	      var imgEl = this.refs.img;
	
	      if (imgEl) {
	        var fit = function fit() {
	          if (imgEl.offsetWidth < imgEl.parentNode.offsetWidth) {
	            var isRtl = _this2.context.muiTheme.isRtl;
	
	            imgEl.style.height = 'auto';
	            if (isRtl) {
	              imgEl.style.right = '0';
	            } else {
	              imgEl.style.left = '0';
	            }
	            imgEl.style.width = '100%';
	            imgEl.style.top = '50%';
	            imgEl.style.transform = imgEl.style.WebkitTransform = 'translateY(-50%)';
	          }
	          imgEl.removeEventListener('load', fit);
	          imgEl = null; // prevent closure memory leak
	        };
	        if (imgEl.complete) {
	          fit();
	        } else {
	          imgEl.addEventListener('load', fit);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          subtitle = _props.subtitle,
	          titlePosition = _props.titlePosition,
	          titleBackground = _props.titleBackground,
	          titleStyle = _props.titleStyle,
	          subtitleStyle = _props.subtitleStyle,
	          actionIcon = _props.actionIcon,
	          actionPosition = _props.actionPosition,
	          style = _props.style,
	          children = _props.children,
	          containerElement = _props.containerElement,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'subtitle', 'titlePosition', 'titleBackground', 'titleStyle', 'subtitleStyle', 'actionIcon', 'actionPosition', 'style', 'children', 'containerElement']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var titleBar = null;
	
	      if (title) {
	        titleBar = _react2.default.createElement(
	          'div',
	          { key: 'titlebar', style: prepareStyles(styles.titleBar) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.titleWrap) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	              title
	            ),
	            subtitle ? _react2.default.createElement(
	              'div',
	              { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	              subtitle
	            ) : null
	          ),
	          actionIcon ? _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.actionIcon) },
	            actionIcon
	          ) : null
	        );
	      }
	
	      var newChildren = children;
	
	      // if there is a single image passed as children
	      // clone it and add our styles
	      if (_react2.default.Children.count(children) === 1) {
	        newChildren = _react2.default.Children.map(children, function (child) {
	          if (child.type === 'img') {
	            return _react2.default.cloneElement(child, {
	              key: 'img',
	              ref: 'img',
	              style: prepareStyles((0, _simpleAssign2.default)({}, styles.childImg, child.props.style))
	            });
	          } else {
	            return child;
	          }
	        });
	      }
	
	      var containerProps = (0, _extends3.default)({
	        style: prepareStyles(mergedRootStyles)
	      }, other);
	
	      return _react2.default.isValidElement(containerElement) ? _react2.default.cloneElement(containerElement, containerProps, [newChildren, titleBar]) : _react2.default.createElement(containerElement, containerProps, [newChildren, titleBar]);
	    }
	  }]);
	  return GridTile;
	}(_react.Component);
	
	GridTile.defaultProps = {
	  titlePosition: 'bottom',
	  titleBackground: 'rgba(0, 0, 0, 0.4)',
	  actionPosition: 'right',
	  cols: 1,
	  rows: 1,
	  containerElement: 'div'
	};
	GridTile.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	GridTile.propTypes =  false ? {
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _propTypes2.default.element,
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in whichcase GridTile takes care of making the image "cover" available space
	   * (similar to background-size: cover or to object-fit:cover).
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _propTypes2.default.number,
	  /**
	   * Either a string used as tag name for the tile root element, or a ReactElement.
	   * This is useful when you have, for example, a custom implementation of
	   * a navigation link (that knows about your routes) and you want to use it as the primary tile action.
	   * In case you pass a ReactElement, please ensure that it passes all props,
	   * accepts styles overrides and render it's children.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the subtitle element.
	   */
	  subtitleStyle: _propTypes2.default.object,
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Style used for title bar background.
	   * Useful for setting custom gradients for example
	   */
	  titleBackground: _propTypes2.default.string,
	  /**
	   * Position of the title bar (container of title, subtitle and action icon).
	   */
	  titlePosition: _propTypes2.default.oneOf(['top', 'bottom']),
	  /**
	   * Override the inline-styles of the title element.
	   */
	  titleStyle: _propTypes2.default.object
	} : {};
	exports.default = GridTile;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.IconMenu = undefined;
	
	var _IconMenu2 = __webpack_require__(1555);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _MenuItem2 = __webpack_require__(377);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.IconMenu = _IconMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _IconMenu3.default;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelectable = undefined;
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colorManipulator = __webpack_require__(90);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeSelectable = function makeSelectable(MyComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(_class, _Component);
	
	    function _class() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3.default)(this, _class);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(args))), _this), _this.hasSelectedDescendant = function (previousValue, child) {
	        if (_react2.default.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
	          return child.props.nestedItems.reduce(_this.hasSelectedDescendant, previousValue);
	        }
	        return previousValue || _this.isChildSelected(child, _this.props);
	      }, _this.handleItemClick = function (event, item) {
	        var itemValue = item.props.value;
	
	        if (itemValue !== _this.props.value) {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, itemValue);
	          }
	        }
	      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(_class, [{
	      key: 'extendChild',
	      value: function extendChild(child, styles, selectedItemStyle) {
	        var _this2 = this;
	
	        if (child && child.type && child.type.muiName === 'ListItem') {
	          var selected = this.isChildSelected(child, this.props);
	          var selectedChildrenStyles = void 0;
	          if (selected) {
	            selectedChildrenStyles = (0, _simpleAssign2.default)({}, styles, selectedItemStyle);
	          }
	
	          var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);
	
	          this.keyIndex += 1;
	
	          return _react2.default.cloneElement(child, {
	            onClick: function onClick(event) {
	              _this2.handleItemClick(event, child);
	              if (child.props.onClick) {
	                child.props.onClick(event);
	              }
	            },
	            key: this.keyIndex,
	            style: mergedChildrenStyles,
	            nestedItems: child.props.nestedItems.map(function (child) {
	              return _this2.extendChild(child, styles, selectedItemStyle);
	            }),
	            initiallyOpen: this.isInitiallyOpen(child)
	          });
	        } else {
	          return child;
	        }
	      }
	    }, {
	      key: 'isInitiallyOpen',
	      value: function isInitiallyOpen(child) {
	        if (child.props.initiallyOpen) {
	          return child.props.initiallyOpen;
	        }
	        return this.hasSelectedDescendant(false, child);
	      }
	    }, {
	      key: 'isChildSelected',
	      value: function isChildSelected(child, props) {
	        return props.value === child.props.value;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            children = _props.children,
	            selectedItemStyle = _props.selectedItemStyle,
	            other = (0, _objectWithoutProperties3.default)(_props, ['children', 'selectedItemStyle']);
	
	
	        this.keyIndex = 0;
	        var styles = {};
	
	        if (!selectedItemStyle) {
	          var textColor = this.context.muiTheme.baseTheme.palette.textColor;
	          styles.backgroundColor = (0, _colorManipulator.fade)(textColor, 0.2);
	        }
	
	        return _react2.default.createElement(
	          MyComponent,
	          (0, _extends3.default)({}, other, this.state),
	          _react.Children.map(children, function (child) {
	            return _this3.extendChild(child, styles, selectedItemStyle);
	          })
	        );
	      }
	    }]);
	    return _class;
	  }(_react.Component), _class.propTypes = {
	    children: _propTypes2.default.node,
	    onChange: _propTypes2.default.func,
	    selectedItemStyle: _propTypes2.default.object,
	    value: _propTypes2.default.any
	  }, _class.contextTypes = {
	    muiTheme: _propTypes2.default.object.isRequired
	  }, _temp2;
	};
	
	exports.makeSelectable = makeSelectable;
	exports.default = makeSelectable;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.Menu = undefined;
	
	var _Menu2 = __webpack_require__(270);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(113);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _Menu3.default;

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedSwitch = __webpack_require__(381);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _radioButtonUnchecked = __webpack_require__(1624);
	
	var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);
	
	var _radioButtonChecked = __webpack_require__(1623);
	
	var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var radioButton = context.muiTheme.radioButton;
	
	
	  return {
	    icon: {
	      height: radioButton.size,
	      width: radioButton.size
	    },
	    target: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(1)',
	      fill: radioButton.borderColor
	    },
	    fill: {
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(0)',
	      transformOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut(),
	      fill: radioButton.checkedColor
	    },
	    targetWhenChecked: {
	      opacity: 0,
	      transform: 'scale(0)'
	    },
	    fillWhenChecked: {
	      opacity: 1,
	      transform: 'scale(1)'
	    },
	    targetWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    fillWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    label: {
	      color: props.disabled ? radioButton.labelDisabledColor : radioButton.labelColor
	    },
	    ripple: {
	      color: props.checked ? radioButton.checkedColor : radioButton.borderColor
	    }
	  };
	}
	
	var RadioButton = function (_Component) {
	  (0, _inherits3.default)(RadioButton, _Component);
	
	  function RadioButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButton.__proto__ || (0, _getPrototypeOf2.default)(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleSwitch = function (event) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, _this.props.value);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // Only called when selected, not when unselected.
	
	
	  (0, _createClass3.default)(RadioButton, [{
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	
	    // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
	    // RadioButton's checked value.
	
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.enhancedSwitch.getValue();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          checked = _props.checked,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onCheck = _props.onCheck,
	          uncheckedIcon = _props.uncheckedIcon,
	          disabled = _props.disabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checkedIcon', 'checked', 'iconStyle', 'labelStyle', 'labelPosition', 'onCheck', 'uncheckedIcon', 'disabled']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var uncheckedStyles = (0, _simpleAssign2.default)(styles.target, checked && styles.targetWhenChecked, iconStyle, disabled && styles.targetWhenDisabled);
	
	      var checkedStyles = (0, _simpleAssign2.default)(styles.fill, checked && styles.fillWhenChecked, iconStyle, disabled && styles.fillWhenDisabled);
	
	      var uncheckedElement = _react2.default.isValidElement(uncheckedIcon) ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(uncheckedStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonUnchecked2.default, { style: uncheckedStyles });
	
	      var checkedElement = _react2.default.isValidElement(checkedIcon) ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkedStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonChecked2.default, { style: checkedStyles });
	
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	      var mergedLabelStyle = (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, {
	        ref: 'enhancedSwitch',
	        inputType: 'radio',
	        checked: checked,
	        switched: checked,
	        disabled: disabled,
	        rippleColor: styles.ripple.color,
	        iconStyle: mergedIconStyle,
	        labelStyle: mergedLabelStyle,
	        labelPosition: labelPosition,
	        onSwitch: this.handleSwitch,
	        switchElement: _react2.default.createElement(
	          'div',
	          null,
	          uncheckedElement,
	          checkedElement
	        )
	      }));
	    }
	  }]);
	  return RadioButton;
	}(_react.Component);
	
	RadioButton.defaultProps = {
	  checked: false,
	  disabled: false,
	  labelPosition: 'right'
	};
	RadioButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RadioButton.propTypes =  false ? {
	  /**
	   * @ignore
	   * checked if true
	   * Used internally by `RadioButtonGroup`.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * The icon element to show when the radio button is checked.
	   */
	  checkedIcon: _propTypes2.default.element,
	  /**
	   * If true, the radio button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * Used internally by `RadioButtonGroup`. Use the `labelPosition` property of `RadioButtonGroup` instead.
	   * Where the label will be placed next to the radio button.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Override the inline-styles of the label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * Callback function fired when the radio button is checked. Note that this
	   * function will not be called if the radio button is part of a
	   * radio button group: in this case, use the `onChange` property of
	   * `RadioButtonGroup`.
	   *
	   * @param {object} event `change` event targeting the element.
	   * @param {string} value The element's `value`.
	   */
	  onCheck: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The icon element to show when the radio button is unchecked.
	   */
	  uncheckedIcon: _propTypes2.default.element,
	  /**
	   * The value of the radio button.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = RadioButton;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RadioButton = __webpack_require__(599);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioButtonGroup = function (_Component) {
	  (0, _inherits3.default)(RadioButtonGroup, _Component);
	
	  function RadioButtonGroup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButtonGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButtonGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      numberCheckedRadioButtons: 0,
	      selected: ''
	    }, _this.handleChange = function (event, newSelection) {
	      _this.updateRadioButtons(newSelection);
	
	      // Successful update
	      if (_this.state.numberCheckedRadioButtons === 0) {
	        if (_this.props.onChange) _this.props.onChange(event, newSelection);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RadioButtonGroup, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var cnt = 0;
	      var selected = '';
	      var _props = this.props,
	          valueSelected = _props.valueSelected,
	          defaultSelected = _props.defaultSelected;
	
	      if (valueSelected !== undefined) {
	        selected = valueSelected;
	      } else if (defaultSelected !== undefined) {
	        selected = defaultSelected;
	      }
	
	      _react2.default.Children.forEach(this.props.children, function (option) {
	        if (_this2.hasCheckAttribute(option)) cnt++;
	      }, this);
	
	      this.setState({
	        numberCheckedRadioButtons: cnt,
	        selected: selected
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasOwnProperty('valueSelected')) {
	        this.setState({
	          selected: nextProps.valueSelected
	        });
	      }
	    }
	  }, {
	    key: 'hasCheckAttribute',
	    value: function hasCheckAttribute(radioButton) {
	      return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
	    }
	  }, {
	    key: 'updateRadioButtons',
	    value: function updateRadioButtons(newSelection) {
	      if (this.state.numberCheckedRadioButtons === 0) {
	        this.setState({ selected: newSelection });
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot select a different radio button while another radio button\n        has the \'checked\' property set to true.') : void 0;
	      }
	    }
	  }, {
	    key: 'getSelectedValue',
	    value: function getSelectedValue() {
	      return this.state.selected;
	    }
	  }, {
	    key: 'setSelectedValue',
	    value: function setSelectedValue(newSelectionValue) {
	      this.updateRadioButtons(newSelectionValue);
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	      this.setSelectedValue('');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var options = _react2.default.Children.map(this.props.children, function (option) {
	        var _option$props = option.props,
	            name = _option$props.name,
	            value = _option$props.value,
	            label = _option$props.label,
	            onCheck = _option$props.onCheck,
	            other = (0, _objectWithoutProperties3.default)(_option$props, ['name', 'value', 'label', 'onCheck']);
	
	
	        return _react2.default.createElement(_RadioButton2.default, (0, _extends3.default)({}, other, {
	          ref: option.props.value,
	          name: _this3.props.name,
	          key: option.props.value,
	          value: option.props.value,
	          label: option.props.label,
	          labelPosition: _this3.props.labelPosition,
	          onCheck: _this3.handleChange,
	          checked: option.props.value === _this3.state.selected
	        }));
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: prepareStyles((0, _simpleAssign2.default)({}, this.props.style)),
	          className: this.props.className
	        },
	        options
	      );
	    }
	  }]);
	  return RadioButtonGroup;
	}(_react.Component);
	
	RadioButtonGroup.defaultProps = {
	  style: {}
	};
	RadioButtonGroup.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RadioButtonGroup.propTypes =  false ? {
	  /**
	   * Should be used to pass `RadioButton` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The `value` property of the radio button that will be
	   * selected by default. This takes precedence over the `checked` property
	   * of the `RadioButton` elements.
	   */
	  defaultSelected: _propTypes2.default.any,
	  /**
	   * Where the label will be placed for all child radio buttons.
	   * This takes precedence over the `labelPosition` property of the
	   * `RadioButton` elements.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * The name that will be applied to all child radio buttons.
	   */
	  name: _propTypes2.default.string.isRequired,
	  /**
	   * Callback function that is fired when a radio button has
	   * been checked.
	   *
	   * @param {object} event `change` event targeting the selected
	   * radio button.
	   * @param {*} value The `value` of the selected radio button.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The `value` of the currently selected radio button.
	   */
	  valueSelected: _propTypes2.default.any
	} : {};
	exports.default = RadioButtonGroup;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.RadioButtonGroup = exports.RadioButton = undefined;
	
	var _RadioButton2 = __webpack_require__(599);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(600);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.default = _RadioButton3.default;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _typeof2 = __webpack_require__(190);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _checkCircle = __webpack_require__(1609);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var active = _ref.active,
	      completed = _ref.completed,
	      disabled = _ref.disabled;
	  var muiTheme = _ref2.muiTheme,
	      stepper = _ref2.stepper;
	  var _muiTheme$stepper = muiTheme.stepper,
	      textColor = _muiTheme$stepper.textColor,
	      disabledTextColor = _muiTheme$stepper.disabledTextColor,
	      iconColor = _muiTheme$stepper.iconColor,
	      inactiveIconColor = _muiTheme$stepper.inactiveIconColor;
	  var baseTheme = muiTheme.baseTheme;
	  var orientation = stepper.orientation;
	
	
	  var styles = {
	    root: {
	      height: orientation === 'horizontal' ? 72 : 64,
	      color: textColor,
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: 14,
	      paddingLeft: 14,
	      paddingRight: 14
	    },
	    icon: {
	      color: iconColor,
	      display: 'block',
	      fontSize: 24,
	      width: 24,
	      height: 24
	    },
	    iconContainer: {
	      paddingRight: 8
	    }
	  };
	
	  if (active) {
	    styles.root.fontWeight = 500;
	  }
	
	  if (!completed && !active) {
	    styles.icon.color = inactiveIconColor;
	  }
	
	  if (disabled) {
	    styles.icon.color = inactiveIconColor;
	    styles.root.color = disabledTextColor;
	    styles.root.cursor = 'default';
	  }
	
	  return styles;
	};
	
	var renderIcon = function renderIcon(completed, icon, styles) {
	  var iconType = typeof icon === 'undefined' ? 'undefined' : (0, _typeof3.default)(icon);
	
	  if (iconType === 'number' || iconType === 'string') {
	    if (completed) {
	      return _react2.default.createElement(_checkCircle2.default, {
	        color: styles.icon.color,
	        style: styles.icon
	      });
	    }
	
	    return _react2.default.createElement(
	      _SvgIcon2.default,
	      { color: styles.icon.color, style: styles.icon },
	      _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	      _react2.default.createElement(
	        'text',
	        {
	          x: '12',
	          y: '16',
	          textAnchor: 'middle',
	          fontSize: '12',
	          fill: '#fff'
	        },
	        icon
	      )
	    );
	  }
	
	  return icon;
	};
	
	var StepLabel = function StepLabel(props, context) {
	  var active = props.active,
	      children = props.children,
	      completed = props.completed,
	      userIcon = props.icon,
	      iconContainerStyle = props.iconContainerStyle,
	      last = props.last,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'children', 'completed', 'icon', 'iconContainerStyle', 'last', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	  var icon = renderIcon(completed, userIcon, styles);
	
	  return _react2.default.createElement(
	    'span',
	    (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	    icon && _react2.default.createElement(
	      'span',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.iconContainer, iconContainerStyle)) },
	      icon
	    ),
	    children
	  );
	};
	
	StepLabel.muiName = 'StepLabel';
	
	StepLabel.propTypes =  false ? {
	  /**
	   * Sets active styling. Overrides disabled coloring.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * The label text node
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Sets completed styling. Overrides disabled coloring.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Sets disabled styling.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	StepLabel.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	
	exports.default = StepLabel;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toConsumableArray2 = __webpack_require__(189);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _typeof2 = __webpack_require__(190);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Checkbox = __webpack_require__(269);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableRowColumn = __webpack_require__(272);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	var _ClickAwayListener = __webpack_require__(380);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableBody = function (_Component) {
	  (0, _inherits3.default)(TableBody, _Component);
	
	  function TableBody() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableBody);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableBody.__proto__ || (0, _getPrototypeOf2.default)(TableBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedRows: []
	    }, _this.isControlled = false, _this.handleClickAway = function () {
	      if (_this.props.deselectOnClickaway && _this.state.selectedRows.length > 0) {
	        var selectedRows = [];
	        _this.setState({ selectedRows: selectedRows });
	        if (_this.props.onRowSelection) {
	          _this.props.onRowSelection(selectedRows);
	        }
	      }
	    }, _this.onRowClick = function (event, rowNumber) {
	      event.stopPropagation();
	
	      if (_this.props.selectable) {
	        // Prevent text selection while selecting rows.
	        if (window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects.length > 0) {
	          window.getSelection().removeAllRanges();
	        }
	        _this.processRowSelection(event, rowNumber);
	      }
	    }, _this.onCellClick = function (event, rowNumber, columnNumber) {
	      event.stopPropagation();
	      if (_this.props.onCellClick) {
	        _this.props.onCellClick(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	    }, _this.onCellHover = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHover) {
	        _this.props.onCellHover(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHover(event, rowNumber);
	    }, _this.onCellHoverExit = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHoverExit) {
	        _this.props.onCellHoverExit(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHoverExit(event, rowNumber);
	    }, _this.onRowHover = function (event, rowNumber) {
	      if (_this.props.onRowHover) {
	        _this.props.onRowHover(rowNumber);
	      }
	    }, _this.onRowHoverExit = function (event, rowNumber) {
	      if (_this.props.onRowHoverExit) {
	        _this.props.onRowHoverExit(rowNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableBody, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.preScanRows) {
	        this.setState({
	          selectedRows: this.getSelectedRows(this.props)
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (!this.props.preScanRows) {
	        this.setState({ // eslint-disable-line react/no-did-mount-set-state
	          selectedRows: this.getSelectedRows(this.props)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
	        if (!nextProps.allRowsSelected) {
	          this.setState({
	            selectedRows: []
	          });
	          return;
	        }
	      }
	
	      this.setState({
	        selectedRows: this.getSelectedRows(nextProps)
	      });
	    }
	  }, {
	    key: 'createRows',
	    value: function createRows() {
	      var _this2 = this;
	
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var rowNumber = 0;
	      var handlers = {
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowClick: this.onRowClick
	      };
	
	      return _react2.default.Children.map(this.props.children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          var props = {
	            hoverable: _this2.props.showRowHover,
	            selected: _this2.isRowSelected(rowNumber),
	            striped: _this2.props.stripedRows && rowNumber % 2 === 0,
	            rowNumber: rowNumber++
	          };
	
	          if (rowNumber === numChildren) {
	            props.displayBorder = false;
	          }
	
	          var children = [_this2.createRowCheckboxColumn(props)];
	
	          _react2.default.Children.forEach(child.props.children, function (child) {
	            children.push(child);
	          });
	
	          return _react2.default.cloneElement(child, (0, _extends3.default)({}, props, handlers), children);
	        }
	      });
	    }
	  }, {
	    key: 'createRowCheckboxColumn',
	    value: function createRowCheckboxColumn(rowProps) {
	      if (!this.props.displayRowCheckbox) {
	        return null;
	      }
	
	      var name = rowProps.rowNumber + '-cb';
	      var disabled = !this.props.selectable;
	
	      return _react2.default.createElement(
	        _TableRowColumn2.default,
	        {
	          key: name,
	          columnNumber: 0,
	          style: {
	            width: 24,
	            cursor: disabled ? 'default' : 'inherit'
	          }
	        },
	        _react2.default.createElement(_Checkbox2.default, {
	          name: name,
	          value: 'selected',
	          disabled: disabled,
	          checked: rowProps.selected
	        })
	      );
	    }
	  }, {
	    key: 'getSelectedRows',
	    value: function getSelectedRows(props) {
	      var _this3 = this;
	
	      var selectedRows = [];
	
	      if (props.selectable) {
	        var index = 0;
	        _react2.default.Children.forEach(props.children, function (child) {
	          if (_react2.default.isValidElement(child)) {
	            if (child.props.selected !== undefined) {
	              _this3.isControlled = true;
	            }
	
	            if (child.props.selected && (selectedRows.length === 0 || props.multiSelectable)) {
	              selectedRows.push(index);
	            }
	
	            index++;
	          }
	        });
	      }
	
	      return selectedRows;
	    }
	  }, {
	    key: 'isRowSelected',
	    value: function isRowSelected(rowNumber) {
	      var _this4 = this;
	
	      if (this.props.allRowsSelected) {
	        return true;
	      }
	
	      return this.state.selectedRows.some(function (row) {
	        if ((typeof row === 'undefined' ? 'undefined' : (0, _typeof3.default)(row)) === 'object') {
	          if (_this4.isValueInRange(rowNumber, row)) {
	            return true;
	          }
	        } else {
	          if (row === rowNumber) {
	            return true;
	          }
	        }
	
	        return false;
	      });
	    }
	  }, {
	    key: 'isValueInRange',
	    value: function isValueInRange(value, range) {
	      if (!range) return false;
	
	      if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'processRowSelection',
	    value: function processRowSelection(event, rowNumber) {
	      var selectedRows = [].concat((0, _toConsumableArray3.default)(this.state.selectedRows));
	
	      if (event.shiftKey && this.props.multiSelectable && selectedRows.length > 0) {
	        var lastIndex = selectedRows.length - 1;
	        var lastSelection = selectedRows[lastIndex];
	
	        if ((typeof lastSelection === 'undefined' ? 'undefined' : (0, _typeof3.default)(lastSelection)) === 'object') {
	          lastSelection.end = rowNumber;
	        } else {
	          selectedRows.splice(lastIndex, 1, {
	            start: lastSelection,
	            end: rowNumber
	          });
	        }
	      } else if ((event.ctrlKey && !event.metaKey || event.metaKey && !event.ctrlKey) && this.props.multiSelectable) {
	        var idx = selectedRows.indexOf(rowNumber);
	        if (idx < 0) {
	          var foundRange = false;
	          for (var i = 0; i < selectedRows.length; i++) {
	            var range = selectedRows[i];
	            if ((typeof range === 'undefined' ? 'undefined' : (0, _typeof3.default)(range)) !== 'object') continue;
	
	            if (this.isValueInRange(rowNumber, range)) {
	              var _selectedRows;
	
	              foundRange = true;
	              var values = this.splitRange(range, rowNumber);
	              (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat((0, _toConsumableArray3.default)(values)));
	            }
	          }
	
	          if (!foundRange) selectedRows.push(rowNumber);
	        } else {
	          selectedRows.splice(idx, 1);
	        }
	      } else {
	        if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
	          selectedRows = [];
	        } else {
	          selectedRows = [rowNumber];
	        }
	      }
	
	      if (!this.isControlled) {
	        this.setState({ selectedRows: selectedRows });
	      }
	
	      if (this.props.onRowSelection) {
	        this.props.onRowSelection(this.flattenRanges(selectedRows));
	      }
	    }
	  }, {
	    key: 'splitRange',
	    value: function splitRange(range, splitPoint) {
	      var splitValues = [];
	      var startOffset = range.start - splitPoint;
	      var endOffset = range.end - splitPoint;
	
	      // Process start half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, startOffset)));
	
	      // Process end half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, endOffset)));
	
	      return splitValues;
	    }
	  }, {
	    key: 'genRangeOfValues',
	    value: function genRangeOfValues(start, offset) {
	      var values = [];
	      var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
	      while (offset !== 0) {
	        values.push(start + offset);
	        offset += dir;
	      }
	
	      return values;
	    }
	  }, {
	    key: 'flattenRanges',
	    value: function flattenRanges(selectedRows) {
	      var _this5 = this;
	
	      return selectedRows.reduce(function (rows, row) {
	        if ((typeof row === 'undefined' ? 'undefined' : (0, _typeof3.default)(row)) === 'object') {
	          var values = _this5.genRangeOfValues(row.end, row.start - row.end);
	          rows.push.apply(rows, [row.end].concat((0, _toConsumableArray3.default)(values)));
	        } else {
	          rows.push(row);
	        }
	
	        return rows;
	      }, []).sort();
	    }
	  }, {
	    key: 'getColumnId',
	    value: function getColumnId(columnNumber) {
	      return columnNumber - 1;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          allRowsSelected = _props.allRowsSelected,
	          multiSelectable = _props.multiSelectable,
	          onCellClick = _props.onCellClick,
	          onCellHover = _props.onCellHover,
	          onCellHoverExit = _props.onCellHoverExit,
	          onRowHover = _props.onRowHover,
	          onRowHoverExit = _props.onRowHoverExit,
	          onRowSelection = _props.onRowSelection,
	          selectable = _props.selectable,
	          deselectOnClickaway = _props.deselectOnClickaway,
	          showRowHover = _props.showRowHover,
	          stripedRows = _props.stripedRows,
	          displayRowCheckbox = _props.displayRowCheckbox,
	          preScanRows = _props.preScanRows,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'allRowsSelected', 'multiSelectable', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowHover', 'onRowHoverExit', 'onRowSelection', 'selectable', 'deselectOnClickaway', 'showRowHover', 'stripedRows', 'displayRowCheckbox', 'preScanRows']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'tbody',
	          (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	          this.createRows()
	        )
	      );
	    }
	  }]);
	  return TableBody;
	}(_react.Component);
	
	TableBody.muiName = 'TableBody';
	TableBody.defaultProps = {
	  allRowsSelected: false,
	  deselectOnClickaway: true,
	  displayRowCheckbox: true,
	  multiSelectable: false,
	  preScanRows: true,
	  selectable: true,
	  style: {}
	};
	TableBody.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableBody.propTypes =  false ? {
	  /**
	   * @ignore
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _propTypes2.default.bool,
	  /**
	   * Children passed to table body.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Controls whether or not to deselect all selected
	   * rows after clicking outside the table.
	   */
	  deselectOnClickaway: _propTypes2.default.bool,
	  /**
	   * Controls the display of the row checkbox. The default value is true.
	   */
	  displayRowCheckbox: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Callback function for when a cell is clicked.
	   */
	  onCellClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered. rowNumber
	   * is the row number of the hovered row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer
	   * hovered. rowNumber is the row number of the row
	   * that is no longer hovered.
	   */
	  onRowHoverExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a row is selected. selectedRows is an
	   * array of all row selections. If all rows have been selected,
	   * the string "all" will be returned instead to indicate that
	   * all rows have been selected.
	   */
	  onRowSelection: _propTypes2.default.func,
	  /**
	   * Controls whether or not the rows are pre-scanned to determine
	   * initial state. If your table has a large number of rows and
	   * you are experiencing a delay in rendering, turn off this property.
	   */
	  preScanRows: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * If true, table rows can be selected. If multiple
	   * row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _propTypes2.default.bool,
	  /**
	   * If true, table rows will be highlighted when
	   * the cursor is hovering over the row. The default
	   * value is false.
	   */
	  showRowHover: _propTypes2.default.bool,
	  /**
	   * If true, every other table row starting
	   * with the first row will be striped. The default value is false.
	   */
	  stripedRows: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableBody;

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(189);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TableRowColumn = __webpack_require__(272);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableFooter = context.muiTheme.tableFooter;
	
	
	  return {
	    cell: {
	      borderTop: '1px solid ' + tableFooter.borderColor,
	      verticalAlign: 'bottom',
	      padding: 20,
	      textAlign: 'left',
	      whiteSpace: 'nowrap'
	    }
	  };
	}
	
	var TableFooter = function (_Component) {
	  (0, _inherits3.default)(TableFooter, _Component);
	
	  function TableFooter() {
	    (0, _classCallCheck3.default)(this, TableFooter);
	    return (0, _possibleConstructorReturn3.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf2.default)(TableFooter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TableFooter, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          adjustForCheckbox = _props.adjustForCheckbox,
	          children = _props.children,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['adjustForCheckbox', 'children', 'className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var footerRows = _react2.default.Children.map(children, function (child, rowNumber) {
	        var newChildProps = {
	          displayBorder: false,
	          key: 'f-' + rowNumber,
	          rowNumber: rowNumber,
	          style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	        };
	
	        var newDescendants = void 0;
	
	        if (adjustForCheckbox) {
	          newDescendants = [_react2.default.createElement(_TableRowColumn2.default, { key: 'fpcb' + rowNumber, style: { width: 24 } })].concat((0, _toConsumableArray3.default)(_react2.default.Children.toArray(child.props.children)));
	        } else {
	          newDescendants = child.props.children;
	        }
	
	        return _react2.default.cloneElement(child, newChildProps, newDescendants);
	      });
	
	      return _react2.default.createElement(
	        'tfoot',
	        (0, _extends3.default)({ className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        footerRows
	      );
	    }
	  }]);
	  return TableFooter;
	}(_react.Component);
	
	TableFooter.muiName = 'TableFooter';
	TableFooter.defaultProps = {
	  adjustForCheckbox: true,
	  style: {}
	};
	TableFooter.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableFooter.propTypes =  false ? {
	  /**
	   * @ignore
	   * Controls whether or not header rows should be adjusted
	   * for a checkbox column. If the select all checkbox is true,
	   * this property will not influence the number of columns.
	   * This is mainly useful for "super header" rows so that
	   * the checkbox column does not create an offset that needs
	   * to be accounted for manually.
	   */
	  adjustForCheckbox: _propTypes2.default.bool,
	  /**
	   * Children passed to table footer.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableFooter;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Checkbox = __webpack_require__(269);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableHeaderColumn = __webpack_require__(379);
	
	var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeader = context.muiTheme.tableHeader;
	
	
	  return {
	    root: {
	      borderBottom: '1px solid ' + tableHeader.borderColor
	    }
	  };
	}
	
	var TableHeader = function (_Component) {
	  (0, _inherits3.default)(TableHeader, _Component);
	
	  function TableHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeader.__proto__ || (0, _getPrototypeOf2.default)(TableHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCheckAll = function (event, checked) {
	      if (_this.props.onSelectAll) {
	        _this.props.onSelectAll(checked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeader, [{
	    key: 'createSuperHeaderRows',
	    value: function createSuperHeaderRows() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      if (numChildren === 1) return undefined;
	
	      var superHeaders = [];
	      for (var index = 0; index < numChildren - 1; index++) {
	        var child = this.props.children[index];
	
	        if (!_react2.default.isValidElement(child)) continue;
	
	        var props = {
	          key: 'sh' + index,
	          rowNumber: index
	        };
	        superHeaders.push(this.createSuperHeaderRow(child, props));
	      }
	
	      if (superHeaders.length) return superHeaders;
	    }
	  }, {
	    key: 'createSuperHeaderRow',
	    value: function createSuperHeaderRow(child, props) {
	      var children = [];
	      if (this.props.adjustForCheckbox) {
	        children.push(this.getCheckboxPlaceholder(props));
	      }
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'createBaseHeaderRow',
	    value: function createBaseHeaderRow() {
	      var childrenArray = _react2.default.Children.toArray(this.props.children);
	      var numChildren = childrenArray.length;
	      if (numChildren < 1) {
	        return null;
	      }
	
	      var child = childrenArray[numChildren - 1];
	
	      var props = {
	        key: 'h' + numChildren,
	        rowNumber: numChildren
	      };
	
	      var children = [this.getSelectAllCheckboxColumn(props)];
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'getCheckboxPlaceholder',
	    value: function getCheckboxPlaceholder(props) {
	      if (!this.props.adjustForCheckbox) return null;
	
	      var disabled = !this.props.enableSelectAll;
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(_TableHeaderColumn2.default, {
	        key: key,
	        style: {
	          width: 24,
	          cursor: disabled ? 'default' : 'inherit'
	        }
	      });
	    }
	  }, {
	    key: 'getSelectAllCheckboxColumn',
	    value: function getSelectAllCheckboxColumn(props) {
	      if (!this.props.displaySelectAll) return this.getCheckboxPlaceholder(props);
	
	      var disabled = !this.props.enableSelectAll;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        key: 'selectallcb',
	        name: 'selectallcb',
	        value: 'selected',
	        disabled: disabled,
	        checked: this.props.selectAllSelected,
	        onCheck: this.handleCheckAll
	      });
	
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(
	        _TableHeaderColumn2.default,
	        {
	          key: key,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var superHeaderRows = this.createSuperHeaderRows();
	      var baseHeaderRow = this.createBaseHeaderRow();
	
	      return _react2.default.createElement(
	        'thead',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        superHeaderRows,
	        baseHeaderRow
	      );
	    }
	  }]);
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.muiName = 'TableHeader';
	TableHeader.defaultProps = {
	  adjustForCheckbox: true,
	  displaySelectAll: true,
	  enableSelectAll: true,
	  selectAllSelected: false
	};
	TableHeader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableHeader.propTypes =  false ? {
	  /**
	   * Controls whether or not header rows should be
	   * adjusted for a checkbox column. If the select all
	   * checkbox is true, this property will not influence
	   * the number of columns. This is mainly useful for
	   * "super header" rows so that the checkbox column
	   * does not create an offset that needs to be accounted
	   * for manually.
	   */
	  adjustForCheckbox: _propTypes2.default.bool,
	  /**
	   * Children passed to table header.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Controls whether or not the select all checkbox is displayed.
	   */
	  displaySelectAll: _propTypes2.default.bool,
	  /**
	   * If set to true, the select all button will be interactable.
	   * If set to false, the button will not be interactable.
	   * To hide the checkbox, set displaySelectAll to false.
	   */
	  enableSelectAll: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Callback when select all has been checked.
	   */
	  onSelectAll: _propTypes2.default.func,
	  /**
	   * @ignore
	   * True when select all has been checked.
	   */
	  selectAllSelected: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableHeader;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var tableRow = context.muiTheme.tableRow;
	
	
	  var cellBgColor = 'inherit';
	  if (props.hovered || state.hovered) {
	    cellBgColor = tableRow.hoverColor;
	  } else if (props.selected) {
	    cellBgColor = tableRow.selectedColor;
	  } else if (props.striped) {
	    cellBgColor = tableRow.stripeColor;
	  }
	
	  return {
	    root: {
	      borderBottom: props.displayBorder && '1px solid ' + tableRow.borderColor,
	      color: tableRow.textColor,
	      height: tableRow.height
	    },
	    cell: {
	      backgroundColor: cellBgColor
	    }
	  };
	}
	
	var TableRow = function (_Component) {
	  (0, _inherits3.default)(TableRow, _Component);
	
	  function TableRow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRow.__proto__ || (0, _getPrototypeOf2.default)(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onCellClick = function (event, columnIndex) {
	      if (_this.props.selectable && _this.props.onCellClick) {
	        _this.props.onCellClick(event, _this.props.rowNumber, columnIndex);
	      }
	      event.ctrlKey = true;
	      _this.onRowClick(event);
	    }, _this.onCellHover = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onCellHover) _this.props.onCellHover(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHover(event);
	      }
	    }, _this.onCellHoverExit = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHoverExit(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRow, [{
	    key: 'onRowClick',
	    value: function onRowClick(event) {
	      if (this.props.selectable && this.props.onRowClick) {
	        this.props.onRowClick(event, this.props.rowNumber);
	      }
	    }
	  }, {
	    key: 'onRowHover',
	    value: function onRowHover(event) {
	      if (this.props.onRowHover) {
	        this.props.onRowHover(event, this.props.rowNumber);
	      }
	    }
	  }, {
	    key: 'onRowHoverExit',
	    value: function onRowHoverExit(event) {
	      if (this.props.onRowHoverExit) {
	        this.props.onRowHoverExit(event, this.props.rowNumber);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          displayBorder = _props.displayBorder,
	          hoverable = _props.hoverable,
	          hovered = _props.hovered,
	          onCellClick = _props.onCellClick,
	          onCellHover = _props.onCellHover,
	          onCellHoverExit = _props.onCellHoverExit,
	          onRowClick = _props.onRowClick,
	          onRowHover = _props.onRowHover,
	          onRowHoverExit = _props.onRowHoverExit,
	          rowNumber = _props.rowNumber,
	          selectable = _props.selectable,
	          selected = _props.selected,
	          striped = _props.striped,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'displayBorder', 'hoverable', 'hovered', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var rowColumns = _react2.default.Children.map(this.props.children, function (child, columnNumber) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            columnNumber: columnNumber,
	            hoverable: _this2.props.hoverable,
	            key: _this2.props.rowNumber + '-' + columnNumber,
	            onClick: _this2.onCellClick,
	            onHover: _this2.onCellHover,
	            onHoverExit: _this2.onCellHoverExit,
	            style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'tr',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other),
	        rowColumns
	      );
	    }
	  }]);
	  return TableRow;
	}(_react.Component);
	
	TableRow.defaultProps = {
	  displayBorder: true,
	  hoverable: false,
	  hovered: false,
	  selectable: true,
	  striped: false
	};
	TableRow.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TableRow.propTypes =  false ? {
	  /**
	   * Children passed to table row.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, row border will be displayed for the row.
	   * If false, no border will be drawn.
	   */
	  displayBorder: _propTypes2.default.bool,
	  /**
	   * Controls whether or not the row responds to hover events.
	   */
	  hoverable: _propTypes2.default.bool,
	  /**
	   * Controls whether or not the row should be rendered as being
	   * hovered. This property is evaluated in addition to this.state.hovered
	   * and can be used to synchronize the hovered state with some other
	   * external events.
	   */
	  hovered: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when row is clicked.
	   */
	  onRowClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _propTypes2.default.func,
	  /**
	   * Number to identify the row. This property is
	   * automatically populated when used with the TableBody component.
	   */
	  rowNumber: _propTypes2.default.number,
	  /**
	   * If true, table rows can be selected. If multiple row
	   * selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _propTypes2.default.bool,
	  /**
	   * Indicates that a particular row is selected.
	   * This property can be used to programmatically select rows.
	   */
	  selected: _propTypes2.default.bool,
	  /**
	   * Indicates whether or not the row is striped.
	   */
	  striped: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = TableRow;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(84);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    root: {
	      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
	      fontWeight: 500,
	      fontSize: 14,
	      width: props.width,
	      textTransform: 'uppercase',
	      padding: 0
	    },
	    button: {
	      display: 'flex',
	      flexDirection: 'column',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: props.label && props.icon ? 72 : 48
	    }
	  };
	}
	
	var Tab = function (_Component) {
	  (0, _inherits3.default)(Tab, _Component);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(_this.props.value, event, _this);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          index = _props.index,
	          onActive = _props.onActive,
	          onClick = _props.onClick,
	          selected = _props.selected,
	          label = _props.label,
	          buttonStyle = _props.buttonStyle,
	          style = _props.style,
	          value = _props.value,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['icon', 'index', 'onActive', 'onClick', 'selected', 'label', 'buttonStyle', 'style', 'value', 'width']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (icon && _react2.default.isValidElement(icon)) {
	        iconElement = _react2.default.cloneElement(icon, {
	          style: {
	            fontSize: 24,
	            color: icon.props && icon.props.style && icon.props.style.color ? icon.props.style.color : styles.root.color,
	            marginBottom: label ? 5 : 0
	          }
	        });
	      }
	
	      var rippleOpacity = 0.3;
	      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          focusRippleColor: rippleColor,
	          touchRippleColor: rippleColor,
	          focusRippleOpacity: rippleOpacity,
	          touchRippleOpacity: rippleOpacity,
	          onClick: this.handleClick
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: (0, _simpleAssign2.default)(styles.button, buttonStyle) },
	          iconElement,
	          label
	        )
	      );
	    }
	  }]);
	  return Tab;
	}(_react.Component);
	
	Tab.muiName = 'Tab';
	Tab.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Tab.propTypes =  false ? {
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _propTypes2.default.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  index: _propTypes2.default.any,
	  /**
	   * Sets the text value of the tab item to the string specified.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * Fired when the active tab changes by touch or tap.
	   * Use this event to specify any functionality when an active tab changes.
	   * For example - we are using this to route to home when the third tab becomes active.
	   * This function will always recieve the active tab as it\'s first argument.
	   */
	  onActive: _propTypes2.default.func,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Defines if the current tab is selected or not.
	   * The Tabs component is responsible for setting this property.
	   */
	  selected: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * If value prop passed to Tabs component, this value prop is also required.
	   * It assigns a value to the tab so that it can be selected by the Tabs.
	   */
	  value: _propTypes2.default.any,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  width: _propTypes2.default.string
	} : {};
	exports.default = Tab;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _slicedToArray2 = __webpack_require__(296);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _timeUtils = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var styles = {
	    root: {
	      directionInvariant: true,
	      display: 'inline-block',
	      position: 'absolute',
	      width: 32,
	      height: 32,
	      borderRadius: '100%',
	      left: 'calc(50% - 16px)',
	      top: 10,
	      textAlign: 'center',
	      paddingTop: 5,
	      userSelect: 'none', /* Chrome all / Safari all */
	      fontSize: '1.1em',
	      pointerEvents: 'none',
	      boxSizing: 'border-box'
	    }
	  };
	
	  var muiTheme = context.muiTheme;
	
	
	  var pos = props.value;
	
	  if (props.type === 'hour') {
	    pos %= 12;
	  } else {
	    pos = pos / 5;
	  }
	
	  var positions = [[0, 5], [54.5, 16.6], [94.4, 59.5], [109, 114], [94.4, 168.5], [54.5, 208.4], [0, 223], [-54.5, 208.4], [-94.4, 168.5], [-109, 114], [-94.4, 59.5], [-54.5, 19.6]];
	
	  var innerPositions = [[0, 40], [36.9, 49.9], [64, 77], [74, 114], [64, 151], [37, 178], [0, 188], [-37, 178], [-64, 151], [-74, 114], [-64, 77], [-37, 50]];
	
	  if (props.isSelected) {
	    styles.root.backgroundColor = muiTheme.timePicker.accentColor;
	    styles.root.color = muiTheme.timePicker.selectTextColor;
	  }
	
	  var transformPos = positions[pos];
	
	  if ((0, _timeUtils.isInner)(props)) {
	    styles.root.width = 28;
	    styles.root.height = 28;
	    styles.root.left = 'calc(50% - 14px)';
	    transformPos = innerPositions[pos];
	  }
	
	  var _transformPos = transformPos,
	      _transformPos2 = (0, _slicedToArray3.default)(_transformPos, 2),
	      x = _transformPos2[0],
	      y = _transformPos2[1];
	
	  styles.root.transform = 'translate(' + x + 'px, ' + y + 'px)';
	
	  return styles;
	}
	
	var ClockNumber = function (_Component) {
	  (0, _inherits3.default)(ClockNumber, _Component);
	
	  function ClockNumber() {
	    (0, _classCallCheck3.default)(this, ClockNumber);
	    return (0, _possibleConstructorReturn3.default)(this, (ClockNumber.__proto__ || (0, _getPrototypeOf2.default)(ClockNumber)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ClockNumber, [{
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var clockNumber = this.props.value === 0 ? '00' : this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles(styles.root) },
	        clockNumber
	      );
	    }
	  }]);
	  return ClockNumber;
	}(_react.Component);
	
	ClockNumber.defaultProps = {
	  value: 0,
	  type: 'minute',
	  isSelected: false
	};
	ClockNumber.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ClockNumber.propTypes =  false ? {
	  isSelected: _propTypes2.default.bool,
	  onSelected: _propTypes2.default.func,
	  type: _propTypes2.default.oneOf(['hour', 'minute']),
	  value: _propTypes2.default.number
	} : {};
	exports.default = ClockNumber;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _timeUtils = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calcAngle(value, base) {
	  value %= base;
	  var angle = 360 / base * value;
	  return angle;
	}
	
	function getStyles(props, context, state) {
	  var hasSelected = props.hasSelected,
	      type = props.type,
	      value = props.value;
	  var inner = state.inner;
	  var timePicker = context.muiTheme.timePicker;
	
	  var angle = type === 'hour' ? calcAngle(value, 12) : calcAngle(value, 60);
	
	  var styles = {
	    root: {
	      height: inner ? '30%' : '40%',
	      background: timePicker.accentColor,
	      width: 2,
	      left: 'calc(50% - 1px)',
	      position: 'absolute',
	      bottom: '50%',
	      transformOrigin: 'bottom',
	      pointerEvents: 'none',
	      transform: 'rotateZ(' + angle + 'deg)'
	    },
	    mark: {
	      boxSizing: 'content-box',
	      background: timePicker.selectTextColor,
	      border: '4px solid ' + timePicker.accentColor,
	      display: hasSelected && 'none',
	      width: 7,
	      height: 7,
	      position: 'absolute',
	      top: -5,
	      left: -6,
	      borderRadius: '100%'
	    }
	  };
	
	  return styles;
	}
	
	var ClockPointer = function (_Component) {
	  (0, _inherits3.default)(ClockPointer, _Component);
	
	  function ClockPointer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockPointer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockPointer.__proto__ || (0, _getPrototypeOf2.default)(ClockPointer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      inner: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockPointer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(this.props)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(nextProps)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.value === null) {
	        return _react2.default.createElement('span', null);
	      }
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement('div', { style: prepareStyles(styles.mark) })
	      );
	    }
	  }]);
	  return ClockPointer;
	}(_react.Component);
	
	ClockPointer.defaultProps = {
	  hasSelected: false,
	  value: null,
	  type: 'minute'
	};
	ClockPointer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ClockPointer.propTypes =  false ? {
	  hasSelected: _propTypes2.default.bool,
	  type: _propTypes2.default.oneOf(['hour', 'minute']),
	  value: _propTypes2.default.number
	} : {};
	exports.default = ClockPointer;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Toggle = __webpack_require__(1595);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Toggle2.default;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var firstChild = props.firstChild,
	      lastChild = props.lastChild;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  var marginHorizontal = baseTheme.spacing.desktopGutter;
	  var marginVertical = (toolbar.height - button.height) / 2;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      marginLeft: firstChild ? -marginHorizontal : undefined,
	      marginRight: lastChild ? -marginHorizontal : undefined,
	      display: 'flex',
	      justifyContent: 'space-between',
	      alignItems: 'center'
	    },
	    dropDownMenu: {
	      root: {
	        color: toolbar.color, // removes hover color change, we want to keep it
	        marginRight: baseTheme.spacing.desktopGutter,
	        flex: 1,
	        whiteSpace: 'nowrap'
	      },
	      controlBg: {
	        backgroundColor: toolbar.menuHoverColor,
	        borderRadius: 0
	      },
	      underline: {
	        display: 'none'
	      }
	    },
	    button: {
	      margin: marginVertical + 'px ' + marginHorizontal + 'px',
	      position: 'relative'
	    },
	    icon: {
	      root: {
	        cursor: 'pointer',
	        lineHeight: toolbar.height + 'px',
	        paddingLeft: baseTheme.spacing.desktopGutter
	      }
	    },
	    span: {
	      color: toolbar.iconColor,
	      lineHeight: toolbar.height + 'px'
	    }
	  };
	
	  return styles;
	}
	
	var ToolbarGroup = function (_Component) {
	  (0, _inherits3.default)(ToolbarGroup, _Component);
	
	  function ToolbarGroup() {
	    (0, _classCallCheck3.default)(this, ToolbarGroup);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarGroup.__proto__ || (0, _getPrototypeOf2.default)(ToolbarGroup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarGroup, [{
	    key: 'handleMouseLeaveFontIcon',
	    value: function handleMouseLeaveFontIcon(style) {
	      return function (event) {
	        event.target.style.zIndex = 'auto';
	        event.target.style.color = style.root.color;
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          firstChild = _props.firstChild,
	          lastChild = _props.lastChild,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'firstChild', 'lastChild', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (!currentChild) {
	          return null;
	        }
	        if (!currentChild.type) {
	          return currentChild;
	        }
	        switch (currentChild.type.muiName) {
	          case 'DropDownMenu':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.dropDownMenu.root, currentChild.props.style),
	              underlineStyle: styles.dropDownMenu.underline
	            });
	          case 'RaisedButton':
	          case 'FlatButton':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.button, currentChild.props.style)
	            });
	          case 'FontIcon':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.icon.root, currentChild.props.style),
	              color: currentChild.props.color || _this2.context.muiTheme.toolbar.iconColor,
	              hoverColor: currentChild.props.hoverColor || _this2.context.muiTheme.toolbar.hoverColor
	            });
	          case 'ToolbarSeparator':
	          case 'ToolbarTitle':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.span, currentChild.props.style)
	            });
	          default:
	            return currentChild;
	        }
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        newChildren
	      );
	    }
	  }]);
	  return ToolbarGroup;
	}(_react.Component);
	
	ToolbarGroup.defaultProps = {
	  firstChild: false,
	  lastChild: false
	};
	ToolbarGroup.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ToolbarGroup.propTypes =  false ? {
	  /**
	   * Can be any node or number of nodes.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
	   * to prevent setting the left gap.
	   */
	  firstChild: _propTypes2.default.bool,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
	   * to prevent setting the right gap.
	   */
	  lastChild: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ToolbarGroup;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      backgroundColor: toolbar.separatorColor,
	      display: 'block',
	      height: baseTheme.spacing.desktopGutterMore,
	      marginLeft: baseTheme.spacing.desktopGutter,
	      width: 1
	    }
	  };
	}
	
	var ToolbarSeparator = function (_Component) {
	  (0, _inherits3.default)(ToolbarSeparator, _Component);
	
	  function ToolbarSeparator() {
	    (0, _classCallCheck3.default)(this, ToolbarSeparator);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarSeparator.__proto__ || (0, _getPrototypeOf2.default)(ToolbarSeparator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarSeparator, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
	    }
	  }]);
	  return ToolbarSeparator;
	}(_react.Component);
	
	ToolbarSeparator.muiName = 'ToolbarSeparator';
	ToolbarSeparator.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ToolbarSeparator.propTypes =  false ? {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ToolbarSeparator;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      lineHeight: toolbar.height + 'px',
	      fontSize: toolbar.titleFontSize,
	      fontFamily: baseTheme.fontFamily,
	      position: 'relative',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    }
	  };
	}
	
	var ToolbarTitle = function (_Component) {
	  (0, _inherits3.default)(ToolbarTitle, _Component);
	
	  function ToolbarTitle() {
	    (0, _classCallCheck3.default)(this, ToolbarTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarTitle.__proto__ || (0, _getPrototypeOf2.default)(ToolbarTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          text = _props.text,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'text']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style))
	        }, other),
	        text
	      );
	    }
	  }]);
	  return ToolbarTitle;
	}(_react.Component);
	
	ToolbarTitle.muiName = 'ToolbarTitle';
	ToolbarTitle.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ToolbarTitle.propTypes =  false ? {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The text to be displayed.
	   */
	  text: _propTypes2.default.node
	} : {};
	exports.default = ToolbarTitle;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = undefined;
	
	var _Toolbar2 = __webpack_require__(1596);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(611);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(612);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(613);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;
	exports.default = _Toolbar3.default;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _AutoLockScrolling = __webpack_require__(1597);
	
	var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var overlay = context.muiTheme.overlay;
	
	
	  var style = {
	    root: {
	      position: 'fixed',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: '-100%',
	      opacity: 0,
	      backgroundColor: overlay.backgroundColor,
	      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)
	
	      // Two ways to promote overlay to its own render layer
	      willChange: 'opacity',
	      transform: 'translateZ(0)',
	
	      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    }
	  };
	
	  if (props.show) {
	    (0, _simpleAssign2.default)(style.root, {
	      left: 0,
	      opacity: 1,
	      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    });
	  }
	
	  return style;
	}
	
	var Overlay = function (_Component) {
	  (0, _inherits3.default)(Overlay, _Component);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Overlay, [{
	    key: 'setOpacity',
	    value: function setOpacity(opacity) {
	      this.refs.overlay.style.opacity = opacity;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoLockScrolling = _props.autoLockScrolling,
	          show = _props.show,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
	      );
	    }
	  }]);
	  return Overlay;
	}(_react.Component);
	
	Overlay.defaultProps = {
	  autoLockScrolling: true,
	  style: {},
	  transitionEnabled: true
	};
	Overlay.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Overlay.propTypes =  false ? {
	  autoLockScrolling: _propTypes2.default.bool,
	  show: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  transitionEnabled: _propTypes2.default.bool
	} : {};
	exports.default = Overlay;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _dom = __webpack_require__(623);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
	var RenderToLayer = function (_Component) {
	  (0, _inherits3.default)(RenderToLayer, _Component);
	
	  function RenderToLayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RenderToLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (!_this.props.componentClickAway) {
	        return;
	      }
	
	      if (!_this.props.open) {
	        return;
	      }
	
	      var el = _this.layer;
	      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
	        _this.props.componentClickAway(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RenderToLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unrenderLayer();
	    }
	  }, {
	    key: 'getLayer',
	    value: function getLayer() {
	      return this.layer;
	    }
	  }, {
	    key: 'unrenderLayer',
	    value: function unrenderLayer() {
	      if (!this.layer) {
	        return;
	      }
	
	      if (this.props.useLayerForClickAway) {
	        this.layer.style.position = 'relative';
	        this.layer.removeEventListener('click', this.onClickAway);
	      } else {
	        window.removeEventListener('click', this.onClickAway);
	      }
	
	      (0, _reactDom.unmountComponentAtNode)(this.layer);
	      document.body.removeChild(this.layer);
	      this.layer = null;
	    }
	
	    /**
	     * By calling this method in componentDidMount() and
	     * componentDidUpdate(), you're effectively creating a "wormhole" that
	     * funnels React's hierarchical updates through to a DOM node on an
	     * entirely different part of the page.
	     */
	
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _this2 = this;
	
	      var _props = this.props,
	          open = _props.open,
	          render = _props.render;
	
	
	      if (open) {
	        if (!this.layer) {
	          this.layer = document.createElement('div');
	          document.body.appendChild(this.layer);
	
	          if (this.props.useLayerForClickAway) {
	            this.layer.addEventListener('click', this.onClickAway);
	            this.layer.style.position = 'fixed';
	            this.layer.style.top = 0;
	            this.layer.style.bottom = 0;
	            this.layer.style.left = 0;
	            this.layer.style.right = 0;
	            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
	          } else {
	            setTimeout(function () {
	              window.addEventListener('click', _this2.onClickAway);
	            }, 0);
	          }
	        }
	
	        var layerElement = render();
	        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
	      } else {
	        this.unrenderLayer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return RenderToLayer;
	}(_react.Component);
	
	RenderToLayer.defaultProps = {
	  useLayerForClickAway: true
	};
	RenderToLayer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RenderToLayer.propTypes =  false ? {
	  componentClickAway: _propTypes2.default.func,
	  open: _propTypes2.default.bool.isRequired,
	  render: _propTypes2.default.func.isRequired,
	  useLayerForClickAway: _propTypes2.default.bool
	} : {};
	exports.default = RenderToLayer;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var verticalPosition = props.verticalPosition;
	  var horizontalPosition = props.horizontalPosition;
	  var touchMarginOffset = props.touch ? 10 : 0;
	  var touchOffsetTop = props.touch ? -20 : -10;
	  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      zIndex = _context$muiTheme.zIndex,
	      tooltip = _context$muiTheme.tooltip,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: '10px',
	      lineHeight: '22px',
	      padding: '0 8px',
	      zIndex: zIndex.tooltip,
	      color: tooltip.color,
	      overflow: 'hidden',
	      top: -10000,
	      borderRadius: borderRadius,
	      userSelect: 'none',
	      opacity: 0,
	      right: horizontalPosition === 'left' ? 12 : null,
	      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : horizontalPosition === 'right' ? 12 : null,
	      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    label: {
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    ripple: {
	      position: 'absolute',
	      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	      top: verticalPosition === 'bottom' ? 0 : '100%',
	      transform: 'translate(-50%, -50%)',
	      borderRadius: '50%',
	      backgroundColor: 'transparent',
	      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    },
	    rootWhenShown: {
	      top: verticalPosition === 'top' ? touchOffsetTop : 36,
	      opacity: tooltip.opacity,
	      transform: 'translate(0px, ' + offset + 'px)',
	      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    rootWhenTouched: {
	      fontSize: '14px',
	      lineHeight: '32px',
	      padding: '0 16px'
	    },
	    rippleWhenShown: {
	      backgroundColor: tooltip.rippleBackgroundColor,
	      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    }
	  };
	
	  return styles;
	}
	
	var Tooltip = function (_Component) {
	  (0, _inherits3.default)(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      offsetWidth: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setRippleSize();
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setRippleSize();
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var ripple = this.refs.ripple;
	      var tooltip = this.refs.tooltip;
	      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);
	
	      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	      if (this.props.show) {
	        ripple.style.height = rippleDiameter + 'px';
	        ripple.style.width = rippleDiameter + 'px';
	      } else {
	        ripple.style.width = '0px';
	        ripple.style.height = '0px';
	      }
	    }
	  }, {
	    key: 'setTooltipPosition',
	    value: function setTooltipPosition() {
	      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          horizontalPosition = _props.horizontalPosition,
	          label = _props.label,
	          show = _props.show,
	          touch = _props.touch,
	          verticalPosition = _props.verticalPosition,
	          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: 'tooltip',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
	        }),
	        _react2.default.createElement('div', {
	          ref: 'ripple',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          label
	        )
	      );
	    }
	  }]);
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Tooltip.propTypes =  false ? {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  horizontalPosition: _propTypes2.default.oneOf(['left', 'right', 'center']),
	  label: _propTypes2.default.node.isRequired,
	  show: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  touch: _propTypes2.default.bool,
	  verticalPosition: _propTypes2.default.oneOf(['top', 'bottom'])
	} : {};
	exports.default = Tooltip;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(189);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toArray2 = __webpack_require__(463);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _TransitionGroup = __webpack_require__(214);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _dom = __webpack_require__(623);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _CircleRipple = __webpack_require__(1599);
	
	var _CircleRipple2 = _interopRequireDefault(_CircleRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Remove the first element of the array
	var shift = function shift(_ref) {
	  var _ref2 = (0, _toArray3.default)(_ref),
	      newArray = _ref2.slice(1);
	
	  return newArray;
	};
	
	var TouchRipple = function (_Component) {
	  (0, _inherits3.default)(TouchRipple, _Component);
	
	  function TouchRipple(props, context) {
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    // Touch start produces a mouse down event for compat reasons. To avoid
	    // showing ripples twice we skip showing a ripple for the first mouse down
	    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    // to avoid re-rendering when we change it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));
	
	    _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.start(event, false);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.end();
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.end();
	    };
	
	    _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      // If the user is swiping (not just tapping), save the position so we can
	      // abort ripples if the user appears to be scrolling.
	      if (_this.props.abortOnScroll && event.touches) {
	        _this.startListeningForScrollAbort(event);
	        _this.startTime = Date.now();
	      }
	      _this.start(event, true);
	    };
	
	    _this.handleTouchEnd = function () {
	      _this.end();
	    };
	
	    _this.handleTouchMove = function (event) {
	      // Stop trying to abort if we're already 300ms into the animation
	      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
	      if (timeSinceStart > 300) {
	        _this.stopListeningForScrollAbort();
	        return;
	      }
	
	      // If the user is scrolling...
	      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
	      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
	      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
	      if (deltaY > 6 || deltaX > 6) {
	        var currentRipples = _this.state.ripples;
	        var ripple = currentRipples[0];
	        // This clone will replace the ripple in ReactTransitionGroup with a
	        // version that will disappear immediately when removed from the DOM
	        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
	        // Remove the old ripple and replace it with the new updated one
	        currentRipples = shift(currentRipples);
	        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
	        _this.setState({ ripples: currentRipples }, function () {
	          // Call end after we've set the ripple to abort otherwise the setState
	          // in end() merges with this and the ripple abort fails
	          _this.end();
	        });
	      }
	    };
	
	    _this.ignoreNextMouseDown = false;
	
	    _this.state = {
	      // This prop allows us to only render the ReactTransitionGroup
	      // on the first click of the component, making the inital render faster.
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'start',
	    value: function start(event, isRippleTouchGenerated) {
	      var theme = this.context.muiTheme.ripple;
	
	      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
	        this.ignoreNextMouseDown = false;
	        return;
	      }
	
	      var ripples = this.state.ripples;
	
	      // Add a ripple to the ripples array
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
	        key: this.state.nextKey,
	        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
	        color: this.props.color || theme.color,
	        opacity: this.props.opacity,
	        touchGenerated: isRippleTouchGenerated
	      })]);
	
	      this.ignoreNextMouseDown = isRippleTouchGenerated;
	      this.setState({
	        hasRipples: true,
	        nextKey: this.state.nextKey + 1,
	        ripples: ripples
	      });
	    }
	  }, {
	    key: 'end',
	    value: function end() {
	      var currentRipples = this.state.ripples;
	      this.setState({
	        ripples: shift(currentRipples)
	      });
	      if (this.props.abortOnScroll) {
	        this.stopListeningForScrollAbort();
	      }
	    }
	
	    // Check if the user seems to be scrolling and abort the animation if so
	
	  }, {
	    key: 'startListeningForScrollAbort',
	    value: function startListeningForScrollAbort(event) {
	      this.firstTouchY = event.touches[0].clientY;
	      this.firstTouchX = event.touches[0].clientX;
	      // Note that when scolling Chrome throttles this event to every 200ms
	      // Also note we don't listen for scroll events directly as there's no general
	      // way to cover cases like scrolling within containers on the page
	      document.body.addEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'stopListeningForScrollAbort',
	    value: function stopListeningForScrollAbort() {
	      document.body.removeEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'getRippleStyle',
	    value: function getRippleStyle(event) {
	      var el = _reactDom2.default.findDOMNode(this);
	      var elHeight = el.offsetHeight;
	      var elWidth = el.offsetWidth;
	      var offset = _dom2.default.offset(el);
	      var isTouchEvent = event.touches && event.touches.length;
	      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
	      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
	      var pointerX = pageX - offset.left;
	      var pointerY = pageY - offset.top;
	      var topLeftDiag = this.calcDiag(pointerX, pointerY);
	      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
	      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
	      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
	      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	      var rippleSize = rippleRadius * 2;
	      var left = pointerX - rippleRadius;
	      var top = pointerY - rippleRadius;
	
	      return {
	        directionInvariant: true,
	        height: rippleSize,
	        width: rippleSize,
	        top: top,
	        left: left
	      };
	    }
	  }, {
	    key: 'calcDiag',
	    value: function calcDiag(a, b) {
	      return Math.sqrt(a * a + b * b);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style;
	      var _state = this.state,
	          hasRipples = _state.hasRipples,
	          ripples = _state.ripples;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var rippleGroup = void 0;
	
	      if (hasRipples) {
	        var mergedStyles = (0, _simpleAssign2.default)({
	          height: '100%',
	          width: '100%',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          overflow: 'hidden',
	          pointerEvents: 'none',
	          zIndex: 1 // This is also needed so that ripples do not bleed past a parent border radius.
	        }, style);
	
	        rippleGroup = _react2.default.createElement(
	          _TransitionGroup2.default,
	          { style: prepareStyles(mergedStyles) },
	          ripples
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        },
	        rippleGroup,
	        children
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.defaultProps = {
	  abortOnScroll: true
	};
	TouchRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TouchRipple.propTypes =  false ? {
	  abortOnScroll: _propTypes2.default.bool,
	  centerRipple: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : {};
	exports.default = TouchRipple;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getMuiTheme = __webpack_require__(620);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MuiThemeProvider = function (_Component) {
	  (0, _inherits3.default)(MuiThemeProvider, _Component);
	
	  function MuiThemeProvider() {
	    (0, _classCallCheck3.default)(this, MuiThemeProvider);
	    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react.Component);
	
	MuiThemeProvider.childContextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	MuiThemeProvider.propTypes =  false ? {
	  children: _propTypes2.default.element,
	  muiTheme: _propTypes2.default.object
	} : {};
	exports.default = MuiThemeProvider;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(189);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = getMuiTheme;
	
	var _lodash = __webpack_require__(1382);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _colorManipulator = __webpack_require__(90);
	
	var _lightBaseTheme = __webpack_require__(1606);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(1608);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _autoprefixer = __webpack_require__(1625);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(1628);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(1629);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	var _compose = __webpack_require__(1729);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _typography = __webpack_require__(1607);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _colors = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(muiTheme) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = _lodash2.default.apply(undefined, [{
	    zIndex: _zIndex2.default,
	    isRtl: false,
	    userAgent: undefined
	  }, _lightBaseTheme2.default, muiTheme].concat(more));
	
	  var _muiTheme = muiTheme,
	      spacing = _muiTheme.spacing,
	      fontFamily = _muiTheme.fontFamily,
	      palette = _muiTheme.palette;
	
	  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };
	
	  muiTheme = (0, _lodash2.default)({
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement,
	      titleFontWeight: _typography2.default.fontWeightNormal,
	      padding: spacing.desktopGutter
	    },
	    avatar: {
	      color: palette.canvasColor,
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    bottomNavigation: {
	      backgroundColor: palette.canvasColor,
	      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      selectedColor: palette.primary1Color,
	      height: 56,
	      unselectedFontSize: 12,
	      selectedFontSize: 14
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    card: {
	      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    cardMedia: {
	      color: _colors.darkWhite,
	      overlayContentBackground: _colors.lightBlack,
	      titleColor: _colors.darkWhite,
	      subtitleColor: _colors.lightWhite
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    chip: {
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
	      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
	      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      fontSize: 14,
	      fontWeight: _typography2.default.fontWeightNormal,
	      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor,
	      calendarYearBackgroundColor: palette.canvasColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color
	    },
	    dialog: {
	      titleFontSize: 22,
	      bodyFontSize: 16,
	      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    enhancedButton: {
	      tapHighlightColor: _colors.transparent
	    },
	    flatButton: {
	      color: _colors.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.primary1Color,
	      secondaryTextColor: palette.accent1Color,
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.primary1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor,
	      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
	    },
	    gridTile: {
	      textColor: _colors.white
	    },
	    icon: {
	      color: palette.canvasColor,
	      backgroundColor: palette.primary1Color
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    drawer: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18,
	      secondaryTextColor: palette.secondaryTextColor,
	      leftIconColor: _colors.grey600,
	      rightIconColor: _colors.grey600
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color,
	      rightIconDesktopFill: _colors.grey600
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    overlay: {
	      backgroundColor: _colors.lightBlack
	    },
	    paper: {
	      color: palette.textColor,
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    ripple: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    subheader: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    stepper: {
	      backgroundColor: 'transparent',
	      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
	      iconColor: palette.primary1Color,
	      hoveredIconColor: _colors.grey700,
	      inactiveIconColor: _colors.grey500,
	      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
	      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
	      connectorLineColor: _colors.grey400
	    },
	    svgIcon: {
	      color: palette.textColor
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.disabledColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.alternateTextColor,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
	      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
	      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
	    },
	    tooltip: {
	      color: _colors.white,
	      rippleBackgroundColor: _colors.grey700,
	      opacity: 0.9
	    }
	  }, muiTheme, {
	    baseTheme: baseTheme, // To provide backward compatibility.
	    rawTheme: baseTheme // To provide backward compatibility.
	  });
	
	  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	
	  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));
	
	  return muiTheme;
	}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopDrawerMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.extendChildren = extendChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function extendChildren(children, extendedProps, extendedChildren) {
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	    return _react2.default.cloneElement(child, newProps, newChildren);
	  });
	}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  }
	};

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            ss : '%d sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	})));


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arDz;
	
	})));


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arKw;
	
	})));


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arLy;
	
	})));


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return arMa;
	
	})));


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            ss : '%d ثانية',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return arSa;
	
	})));


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss : '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return arTn;
	
	})));


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            ss : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ar;
	
	})));


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyə',
	            ss : '%d saniyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return az;
	
	})));


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return be;
	
	})));


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bg;
	
	})));


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var bm = moment.defineLocale('bm', {
	        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
	        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'MMMM [tile] D [san] YYYY',
	            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bi lɛrɛ] LT',
	            nextDay : '[Sini lɛrɛ] LT',
	            nextWeek : 'dddd [don lɛrɛ] LT',
	            lastDay : '[Kunu lɛrɛ] LT',
	            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s kɔnɔ',
	            past : 'a bɛ %s bɔ',
	            s : 'sanga dama dama',
	            ss : 'sekondi %d',
	            m : 'miniti kelen',
	            mm : 'miniti %d',
	            h : 'lɛrɛ kelen',
	            hh : 'lɛrɛ %d',
	            d : 'tile kelen',
	            dd : 'tile %d',
	            M : 'kalo kelen',
	            MM : 'kalo %d',
	            y : 'san kelen',
	            yy : 'san %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return bm;
	
	})));


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            ss : '%d সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bn;
	
	})));


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            ss : '%d སྐར་ཆ།',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return bo;
	
	})));


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            ss : '%d eilenn',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	})));


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return bs;
	
	})));


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : {
	            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
	            isFormat: /D[oD]?(\s)+MMMM/
	        },
	        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [de] YYYY',
	            ll : 'D MMM YYYY',
	            LLL : 'D MMMM [de] YYYY [a les] H:mm',
	            lll : 'D MMM YYYY, H:mm',
	            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll : 'ddd D MMM YYYY, H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'd\'aquí %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            ss : '%d segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	})));


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	
	    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
	    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	})));


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            ss : '%d ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return cv;
	
	})));


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	})));


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay : '[i dag kl.] LT',
	            nextDay : '[i morgen kl.] LT',
	            nextWeek : 'på dddd [kl.] LT',
	            lastDay : '[i går kl.] LT',
	            lastWeek : '[i] dddd[s kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            ss : '%d sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	})));


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deAt;
	
	})));


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return deCh;
	
	})));


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            ss : '%d Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	})));


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            ss : 'd% ސިކުންތު',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return dv;
	
	})));


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            ss : '%d δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	})));


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enSG = moment.defineLocale('en-SG', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enSG;
	
	})));


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enAu = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enAu;
	
	})));


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enCa = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enCa;
	
	})));


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enGb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enGb;
	
	})));


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIe = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enIe;
	
	})));


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enIl = moment.defineLocale('en-il', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return enIl;
	
	})));


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var enNz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            ss : '%d seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return enNz;
	
	})));


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-a de] MMMM, YYYY',
	            LLL : 'D[-a de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'post %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            ss : '%d sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eo;
	
	})));


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return esDo;
	
	})));


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'MM/DD/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return esUs;
	
	})));


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
	    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex : monthsRegex,
	        monthsShortRegex : monthsRegex,
	        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	})));


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'ss': [number + 'sekundi', number + 'sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	})));


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            ss : '%d segundo',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return eu;
	
	})));


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چند ثانیه',
	            ss : 'ثانیه d%',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return fa;
	
	})));


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                return isFuture ? 'sekunnin' : 'sekuntia';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	})));


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            ss : '%d sekundir',
	            m : 'ein minuttur',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaður',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	})));


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        }
	    });
	
	    return frCa;
	
	})));


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return frCh;
	
	})));


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Aujourd’hui à] LT',
	            nextDay : '[Demain à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[Hier à] LT',
	            lastWeek : 'dddd [dernier à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            ss : '%d secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	})));


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            ss : '%d sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	})));


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	    var months = [
	        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
	    ];
	
	    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];
	
	    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];
	
	    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];
	
	    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné aig] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d mí',
	            y: 'bliain',
	            yy: '%d bliain'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ga;
	
	})));


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            ss : '%d diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	})));


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            ss : '%d segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	})));


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['thodde secondanim', 'thodde second'],
	            'ss': [number + ' secondanim', number + ' second'],
	            'm': ['eka mintan', 'ek minute'],
	            'mm': [number + ' mintanim', number + ' mintam'],
	            'h': ['eka voran', 'ek vor'],
	            'hh': [number + ' voranim', number + ' voram'],
	            'd': ['eka disan', 'ek dis'],
	            'dd': [number + ' disanim', number + ' dis'],
	            'M': ['eka mhoinean', 'ek mhoino'],
	            'MM': [number + ' mhoineanim', number + ' mhoine'],
	            'y': ['eka vorsan', 'ek voros'],
	            'yy': [number + ' vorsanim', number + ' vorsam']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
	        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
	        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'A h:mm [vazta]',
	            LTS : 'A h:mm:ss [vazta]',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY A h:mm [vazta]',
	            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
	        },
	        calendar : {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Ieta to] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fatlo] dddd[,] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s',
	            past : '%s adim',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /rati|sokalli|donparam|sanje/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokalli') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokalli';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        }
	    });
	
	    return gomLatn;
	
	})));


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	            '1': '૧',
	            '2': '૨',
	            '3': '૩',
	            '4': '૪',
	            '5': '૫',
	            '6': '૬',
	            '7': '૭',
	            '8': '૮',
	            '9': '૯',
	            '0': '૦'
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0'
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
	        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પેહલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ'
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6 // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return gu;
	
	})));


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            ss : '%d שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	})));


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            ss : '%d सेकंड',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return hi;
	
	})));


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            ss     : translate,
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hr;
	
	})));


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return hu;
	
	})));


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            ss : '%d վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return hyAm;
	
	})));


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            ss : '%d detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return id;
	
	})));


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	})));


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var itCh = moment.defineLocale('it-ch', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return itCh;
	
	})));


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
	        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            ss : '%d secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	})));


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日 dddd HH:mm',
	            l : 'YYYY/MM/DD',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日(ddd) HH:mm'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : function (now) {
	                if (now.week() < this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay : '[昨日] LT',
	            lastWeek : function (now) {
	                if (this.week() < now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            ss : '%d秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	})));


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            ss : '%d detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return jv;
	
	})));


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            ss : '%d წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	})));


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            ss : '%d секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return kk;
	
	})));


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '១',
	        '2': '២',
	        '3': '៣',
	        '4': '៤',
	        '5': '៥',
	        '6': '៦',
	        '7': '៧',
	        '8': '៨',
	        '9': '៩',
	        '0': '០'
	    }, numberMap = {
	        '១': '1',
	        '២': '2',
	        '៣': '3',
	        '៤': '4',
	        '៥': '5',
	        '៦': '6',
	        '៧': '7',
	        '៨': '8',
	        '៩': '9',
	        '០': '0'
	    };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
	        ordinal : 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	})));


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '೧',
	        '2': '೨',
	        '3': '೩',
	        '4': '೪',
	        '5': '೫',
	        '6': '೬',
	        '7': '೭',
	        '8': '೮',
	        '9': '೯',
	        '0': '೦'
	    },
	    numberMap = {
	        '೧': '1',
	        '೨': '2',
	        '೩': '3',
	        '೪': '4',
	        '೫': '5',
	        '೬': '6',
	        '೭': '7',
	        '೮': '8',
	        '೯': '9',
	        '೦': '0'
	    };
	
	    var kn = moment.defineLocale('kn', {
	        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
	        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
	        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[ಇಂದು] LT',
	            nextDay : '[ನಾಳೆ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ನಿನ್ನೆ] LT',
	            lastWeek : '[ಕೊನೆಯ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ನಂತರ',
	            past : '%s ಹಿಂದೆ',
	            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss : '%d ಸೆಕೆಂಡುಗಳು',
	            m : 'ಒಂದು ನಿಮಿಷ',
	            mm : '%d ನಿಮಿಷ',
	            h : 'ಒಂದು ಗಂಟೆ',
	            hh : '%d ಗಂಟೆ',
	            d : 'ಒಂದು ದಿನ',
	            dd : '%d ದಿನ',
	            M : 'ಒಂದು ತಿಂಗಳು',
	            MM : '%d ತಿಂಗಳು',
	            y : 'ಒಂದು ವರ್ಷ',
	            yy : '%d ವರ್ಷ'
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal : function (number) {
	            return number + 'ನೇ';
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return kn;
	
	})));


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h:mm',
	            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
	            l : 'YYYY.MM.DD.',
	            ll : 'YYYY년 MMMM D일',
	            lll : 'YYYY년 MMMM D일 A h:mm',
	            llll : 'YYYY년 MMMM D일 dddd A h:mm'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '1분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	})));


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    },
	    months = [
	        'کانونی دووەم',
	        'شوبات',
	        'ئازار',
	        'نیسان',
	        'ئایار',
	        'حوزەیران',
	        'تەمموز',
	        'ئاب',
	        'ئەیلوول',
	        'تشرینی یەكەم',
	        'تشرینی دووەم',
	        'كانونی یەکەم'
	    ];
	
	
	    var ku = moment.defineLocale('ku', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar : {
	            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay : '[به‌یانی كاتژمێر] LT',
	            nextWeek : 'dddd [كاتژمێر] LT',
	            lastDay : '[دوێنێ كاتژمێر] LT',
	            lastWeek : 'dddd [كاتژمێر] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'له‌ %s',
	            past : '%s',
	            s : 'چه‌ند چركه‌یه‌ك',
	            ss : 'چركه‌ %d',
	            m : 'یه‌ك خوله‌ك',
	            mm : '%d خوله‌ك',
	            h : 'یه‌ك كاتژمێر',
	            hh : '%d كاتژمێر',
	            d : 'یه‌ك ڕۆژ',
	            dd : '%d ڕۆژ',
	            M : 'یه‌ك مانگ',
	            MM : '%d مانگ',
	            y : 'یه‌ك ساڵ',
	            yy : '%d ساڵ'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return ku;
	
	})));


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кечээ саат] LT',
	            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            ss : '%d секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ky;
	
	})));


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            ss : '%d Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	})));


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss : '%d ວິນາທີ' ,
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	})));


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss' : 'sekundė_sekundžių_sekundes',
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            ss : translate,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	})));


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var units = {
	        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	})));


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return me;
	
	})));


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	})));


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            ss : '%d секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return mk;
	
	})));


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            ss : '%d സെക്കൻഡ്',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	})));


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
	        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY оны MMMMын D',
	            LLL : 'YYYY оны MMMMын D HH:mm',
	            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM : function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar : {
	            sameDay : '[Өнөөдөр] LT',
	            nextDay : '[Маргааш] LT',
	            nextWeek : '[Ирэх] dddd LT',
	            lastDay : '[Өчигдөр] LT',
	            lastWeek : '[Өнгөрсөн] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s дараа',
	            past : '%s өмнө',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        }
	    });
	
	    return mn;
	
	})));


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'ss': output = '%d सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'ss': output = '%d सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return mr;
	
	})));


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var msMy = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return msMy;
	
	})));


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            ss : '%d saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ms;
	
	})));


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var mt = moment.defineLocale('mt', {
	        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
	        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
	        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Illum fil-]LT',
	            nextDay : '[Għada fil-]LT',
	            nextWeek : 'dddd [fil-]LT',
	            lastDay : '[Il-bieraħ fil-]LT',
	            lastWeek : 'dddd [li għadda] [fil-]LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'f’ %s',
	            past : '%s ilu',
	            s : 'ftit sekondi',
	            ss : '%d sekondi',
	            m : 'minuta',
	            mm : '%d minuti',
	            h : 'siegħa',
	            hh : '%d siegħat',
	            d : 'ġurnata',
	            dd : '%d ġranet',
	            M : 'xahar',
	            MM : '%d xhur',
	            y : 'sena',
	            yy : '%d sni'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mt;
	
	})));


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss : '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return my;
	
	})));


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            ss : '%d sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	})));


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            ss : '%d सेकेण्ड',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ne;
	
	})));


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nlBe;
	
	})));


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            ss : '%d seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	})));


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            ss : '%d sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	})));


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : '[ਅਗਲਾ] dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            ss : '%d ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return paIn;
	
	})));


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	})));


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'poucos segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return ptBr;
	
	})));


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            ss : '%d segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	})));


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'ss': 'secunde',
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            ss : relativeTimeWithPlural,
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return ro;
	
	})));


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., H:mm',
	            LLLL : 'dddd, D MMMM YYYY г., H:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ru;
	
	})));


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوري',
	        'فيبروري',
	        'مارچ',
	        'اپريل',
	        'مئي',
	        'جون',
	        'جولاءِ',
	        'آگسٽ',
	        'سيپٽمبر',
	        'آڪٽوبر',
	        'نومبر',
	        'ڊسمبر'
	    ];
	    var days = [
	        'آچر',
	        'سومر',
	        'اڱارو',
	        'اربع',
	        'خميس',
	        'جمع',
	        'ڇنڇر'
	    ];
	
	    var sd = moment.defineLocale('sd', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[اڄ] LT',
	            nextDay : '[سڀاڻي] LT',
	            nextWeek : 'dddd [اڳين هفتي تي] LT',
	            lastDay : '[ڪالهه] LT',
	            lastWeek : '[گزريل هفتي] dddd [تي] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s پوء',
	            past : '%s اڳ',
	            s : 'چند سيڪنڊ',
	            ss : '%d سيڪنڊ',
	            m : 'هڪ منٽ',
	            mm : '%d منٽ',
	            h : 'هڪ ڪلاڪ',
	            hh : '%d ڪلاڪ',
	            d : 'هڪ ڏينهن',
	            dd : '%d ڏينهن',
	            M : 'هڪ مهينو',
	            MM : '%d مهينا',
	            y : 'هڪ سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sd;
	
	})));


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	})));


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            ss : 'තත්පර %d',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	})));


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	                break;
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            ss : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	})));


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            ss     : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sl;
	
	})));


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            ss : '%d sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	})));


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return srCyrl;
	
	})));


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            ss     : translator.translate,
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sr;
	
	})));


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            ss : '%d mzuzwana',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	})));


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            ss : '%d sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	})));


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            ss : 'sekunde %d',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return sw;
	
	})));


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            ss : '%d விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return ta;
	
	})));


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            ss : '%d సెకన్లు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        dayOfMonthOrdinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 6th is the first week of the year.
	        }
	    });
	
	    return te;
	
	})));


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tet = moment.defineLocale('tet', {
	        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'iha %s',
	            past : '%s liuba',
	            s : 'minutu balun',
	            ss : 'minutu %d',
	            m : 'minutu ida',
	            mm : 'minutu %d',
	            h : 'oras ida',
	            hh : 'oras %d',
	            d : 'loron ida',
	            dd : 'loron %d',
	            M : 'fulan ida',
	            MM : 'fulan %d',
	            y : 'tinan ida',
	            yy : 'tinan %d'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tet;
	
	})));


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум'
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
	        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Имрӯз соати] LT',
	            nextDay : '[Пагоҳ соати] LT',
	            lastDay : '[Дирӯз соати] LT',
	            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'баъди %s',
	            past : '%s пеш',
	            s : 'якчанд сония',
	            m : 'як дақиқа',
	            mm : '%d дақиқа',
	            h : 'як соат',
	            hh : '%d соат',
	            d : 'як рӯз',
	            dd : '%d рӯз',
	            M : 'як моҳ',
	            MM : '%d моҳ',
	            y : 'як сол',
	            yy : '%d сол'
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1th is the first week of the year.
	        }
	    });
	
	    return tg;
	
	})));


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            ss : '%d วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	})));


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            ss : '%d segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlPh;
	
	})));


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            ss : translate,
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	})));


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[gelecek] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            ss : '%d saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {  // special case for zero
	                        return number + '\'ıncı';
	                    }
	                    var a = number % 10,
	                        b = number % 100 - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return tr;
	
	})));


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            ss : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'ss': [number + ' secunds', '' + number + ' secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	})));


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            ss : '%d imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzmLatn;
	
	})));


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            ss : '%d ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 12th is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	})));


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js language configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل'
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ugCn;
	
	})));


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        };
	
	        if (m === true) {
	            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            ss : relativeTimeWithPlural,
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uk;
	
	})));


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var months = [
	        'جنوری',
	        'فروری',
	        'مارچ',
	        'اپریل',
	        'مئی',
	        'جون',
	        'جولائی',
	        'اگست',
	        'ستمبر',
	        'اکتوبر',
	        'نومبر',
	        'دسمبر'
	    ];
	    var days = [
	        'اتوار',
	        'پیر',
	        'منگل',
	        'بدھ',
	        'جمعرات',
	        'جمعہ',
	        'ہفتہ'
	    ];
	
	    var ur = moment.defineLocale('ur', {
	        months : months,
	        monthsShort : months,
	        weekdays : days,
	        weekdaysShort : days,
	        weekdaysMin : days,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd، D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /صبح|شام/,
	        isPM : function (input) {
	            return 'شام' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar : {
	            sameDay : '[آج بوقت] LT',
	            nextDay : '[کل بوقت] LT',
	            nextWeek : 'dddd [بوقت] LT',
	            lastDay : '[گذشتہ روز بوقت] LT',
	            lastWeek : '[گذشتہ] dddd [بوقت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s بعد',
	            past : '%s قبل',
	            s : 'چند سیکنڈ',
	            ss : '%d سیکنڈ',
	            m : 'ایک منٹ',
	            mm : '%d منٹ',
	            h : 'ایک گھنٹہ',
	            hh : '%d گھنٹے',
	            d : 'ایک دن',
	            dd : '%d دن',
	            M : 'ایک ماہ',
	            MM : '%d ماہ',
	            y : 'ایک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ur;
	
	})));


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
	        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
	        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Bugun soat] LT [da]',
	            nextDay : '[Ertaga] LT [da]',
	            nextWeek : 'dddd [kuni soat] LT [da]',
	            lastDay : '[Kecha soat] LT [da]',
	            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Yaqin %s ichida',
	            past : 'Bir necha %s oldin',
	            s : 'soniya',
	            ss : '%d soniya',
	            m : 'bir daqiqa',
	            mm : '%d daqiqa',
	            h : 'bir soat',
	            hh : '%d soat',
	            d : 'bir kun',
	            dd : '%d kun',
	            M : 'bir oy',
	            MM : '%d oy',
	            y : 'bir yil',
	            yy : '%d yil'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 7th is the first week of the year.
	        }
	    });
	
	    return uzLatn;
	
	})));


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            ss : '%d фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	})));


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            ss : '%d giây' ,
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	})));


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            ss : '%d s~écóñ~ds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return xPseudo;
	
	})));


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var yo = moment.defineLocale('yo', {
	        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Ònì ni] LT',
	            nextDay : '[Ọ̀la ni] LT',
	            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	            lastDay : '[Àna ni] LT',
	            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ní %s',
	            past : '%s kọjá',
	            s : 'ìsẹjú aayá die',
	            ss :'aayá %d',
	            m : 'ìsẹjú kan',
	            mm : 'ìsẹjú %d',
	            h : 'wákati kan',
	            hh : 'wákati %d',
	            d : 'ọjọ́ kan',
	            dd : 'ọjọ́ %d',
	            M : 'osù kan',
	            MM : 'osù %d',
	            y : 'ọdún kan',
	            yy : 'ọdún %d'
	        },
	        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
	        ordinal : 'ọjọ́ %d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return yo;
	
	})));


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah点mm分',
	            LLLL : 'YYYY年M月D日ddddAh点mm分',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            ss : '%d 秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zhCn;
	
	})));


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhHk;
	
	})));


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日 HH:mm',
	            LLLL : 'YYYY年M月D日dddd HH:mm',
	            l : 'YYYY/M/D',
	            ll : 'YYYY年M月D日',
	            lll : 'YYYY年M月D日 HH:mm',
	            llll : 'YYYY年M月D日dddd HH:mm'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天] LT',
	            nextDay : '[明天] LT',
	            nextWeek : '[下]dddd LT',
	            lastDay : '[昨天] LT',
	            lastWeek : '[上]dddd LT',
	            sameElse : 'L'
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            ss : '%d 秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zhTw;
	
	})));


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(752);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(1635);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),
/* 752 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ViewportSizeType = exports.ColumnSizeType = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ColumnSizeType = exports.ColumnSizeType = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]);
	var ViewportSizeType = exports.ViewportSizeType = _propTypes2.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']);

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var ReCAPTCHA =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReCAPTCHA, _React$Component);
	
	  function ReCAPTCHA() {
	    var _this;
	
	    _this = _React$Component.call(this) || this;
	    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
	    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
	    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
	    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
	    return _this;
	  }
	
	  var _proto = ReCAPTCHA.prototype;
	
	  _proto.getValue = function getValue() {
	    if (this.props.grecaptcha && this._widgetId !== undefined) {
	      return this.props.grecaptcha.getResponse(this._widgetId);
	    }
	
	    return null;
	  };
	
	  _proto.getWidgetId = function getWidgetId() {
	    if (this.props.grecaptcha && this._widgetId !== undefined) {
	      return this._widgetId;
	    }
	
	    return null;
	  };
	
	  _proto.execute = function execute() {
	    var grecaptcha = this.props.grecaptcha;
	
	    if (grecaptcha && this._widgetId !== undefined) {
	      return grecaptcha.execute(this._widgetId);
	    } else {
	      this._executeRequested = true;
	    }
	  };
	
	  _proto.executeAsync = function executeAsync() {
	    var _this2 = this;
	
	    return new Promise(function (resolve, reject) {
	      _this2.executionResolve = resolve;
	      _this2.executionReject = reject;
	
	      _this2.execute();
	    });
	  };
	
	  _proto.reset = function reset() {
	    if (this.props.grecaptcha && this._widgetId !== undefined) {
	      this.props.grecaptcha.reset(this._widgetId);
	    }
	  };
	
	  _proto.handleExpired = function handleExpired() {
	    if (this.props.onExpired) {
	      this.props.onExpired();
	    } else {
	      this.handleChange(null);
	    }
	  };
	
	  _proto.handleErrored = function handleErrored() {
	    if (this.props.onErrored) {
	      this.props.onErrored();
	    }
	
	    if (this.executionReject) {
	      this.executionReject();
	      delete this.executionResolve;
	      delete this.executionReject;
	    }
	  };
	
	  _proto.handleChange = function handleChange(token) {
	    if (this.props.onChange) {
	      this.props.onChange(token);
	    }
	
	    if (this.executionResolve) {
	      this.executionResolve(token);
	      delete this.executionReject;
	      delete this.executionResolve;
	    }
	  };
	
	  _proto.explicitRender = function explicitRender() {
	    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
	      var wrapper = document.createElement("div");
	      this._widgetId = this.props.grecaptcha.render(wrapper, {
	        sitekey: this.props.sitekey,
	        callback: this.handleChange,
	        theme: this.props.theme,
	        type: this.props.type,
	        tabindex: this.props.tabindex,
	        "expired-callback": this.handleExpired,
	        "error-callback": this.handleErrored,
	        size: this.props.size,
	        stoken: this.props.stoken,
	        hl: this.props.hl,
	        badge: this.props.badge
	      });
	      this.captcha.appendChild(wrapper);
	    }
	
	    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
	      this._executeRequested = false;
	      this.execute();
	    }
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.explicitRender();
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate() {
	    this.explicitRender();
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    if (this._widgetId !== undefined) {
	      this.delayOfCaptchaIframeRemoving();
	      this.reset();
	    }
	  };
	
	  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
	    var temporaryNode = document.createElement("div");
	    document.body.appendChild(temporaryNode);
	    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node
	
	    while (this.captcha.firstChild) {
	      temporaryNode.appendChild(this.captcha.firstChild);
	    } // delete the temporary node after reset will be done
	
	
	    setTimeout(function () {
	      document.body.removeChild(temporaryNode);
	    }, 5000);
	  };
	
	  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
	    this.captcha = elem;
	  };
	
	  _proto.render = function render() {
	    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.
	
	    /* eslint-disable no-unused-vars */
	    var _this$props = this.props,
	        sitekey = _this$props.sitekey,
	        onChange = _this$props.onChange,
	        theme = _this$props.theme,
	        type = _this$props.type,
	        tabindex = _this$props.tabindex,
	        onExpired = _this$props.onExpired,
	        onErrored = _this$props.onErrored,
	        size = _this$props.size,
	        stoken = _this$props.stoken,
	        grecaptcha = _this$props.grecaptcha,
	        badge = _this$props.badge,
	        hl = _this$props.hl,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
	    /* eslint-enable no-unused-vars */
	
	
	    return _react["default"].createElement("div", _extends({}, childProps, {
	      ref: this.handleRecaptchaRef
	    }));
	  };
	
	  return ReCAPTCHA;
	}(_react["default"].Component);
	
	exports["default"] = ReCAPTCHA;
	ReCAPTCHA.displayName = "ReCAPTCHA";
	ReCAPTCHA.propTypes = {
	  sitekey: _propTypes["default"].string.isRequired,
	  onChange: _propTypes["default"].func,
	  grecaptcha: _propTypes["default"].object,
	  theme: _propTypes["default"].oneOf(["dark", "light"]),
	  type: _propTypes["default"].oneOf(["image", "audio"]),
	  tabindex: _propTypes["default"].number,
	  onExpired: _propTypes["default"].func,
	  onErrored: _propTypes["default"].func,
	  size: _propTypes["default"].oneOf(["compact", "normal", "invisible"]),
	  stoken: _propTypes["default"].string,
	  hl: _propTypes["default"].string,
	  badge: _propTypes["default"].oneOf(["bottomright", "bottomleft", "inline"])
	};
	ReCAPTCHA.defaultProps = {
	  onChange: function onChange() {},
	  theme: "light",
	  type: "image",
	  tabindex: 0,
	  size: "normal",
	  badge: "bottomright"
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.assertNodeList = assertNodeList;
	exports.setElement = setElement;
	exports.validateElement = validateElement;
	exports.hide = hide;
	exports.show = show;
	exports.documentNotReadyOrSSRTesting = documentNotReadyOrSSRTesting;
	exports.resetForTesting = resetForTesting;
	
	var _warning = __webpack_require__(1673);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _safeHTMLElement = __webpack_require__(390);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var globalElement = null;
	
	function assertNodeList(nodeList, selector) {
	  if (!nodeList || !nodeList.length) {
	    throw new Error("react-modal: No elements were found for selector " + selector + ".");
	  }
	}
	
	function setElement(element) {
	  var useElement = element;
	  if (typeof useElement === "string" && _safeHTMLElement.canUseDOM) {
	    var el = document.querySelectorAll(useElement);
	    assertNodeList(el, useElement);
	    useElement = "length" in el ? el[0] : el;
	  }
	  globalElement = useElement || globalElement;
	  return globalElement;
	}
	
	function validateElement(appElement) {
	  if (!appElement && !globalElement) {
	    (0, _warning2.default)(false, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" "));
	
	    return false;
	  }
	
	  return true;
	}
	
	function hide(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).setAttribute("aria-hidden", "true");
	  }
	}
	
	function show(appElement) {
	  if (validateElement(appElement)) {
	    (appElement || globalElement).removeAttribute("aria-hidden");
	  }
	}
	
	function documentNotReadyOrSSRTesting() {
	  globalElement = null;
	}
	
	function resetForTesting() {
	  globalElement = null;
	}

/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// Tracks portals that are open and emits events to subscribers
	
	var PortalOpenInstances = function PortalOpenInstances() {
	  var _this = this;
	
	  _classCallCheck(this, PortalOpenInstances);
	
	  this.register = function (openInstance) {
	    if (_this.openInstances.indexOf(openInstance) !== -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Cannot register modal instance that's already open");
	      }
	      return;
	    }
	    _this.openInstances.push(openInstance);
	    _this.emit("register");
	  };
	
	  this.deregister = function (openInstance) {
	    var index = _this.openInstances.indexOf(openInstance);
	    if (index === -1) {
	      if (false) {
	        // eslint-disable-next-line no-console
	        console.warn("React-Modal: Unable to deregister " + openInstance + " as " + "it was never registered");
	      }
	      return;
	    }
	    _this.openInstances.splice(index, 1);
	    _this.emit("deregister");
	  };
	
	  this.subscribe = function (callback) {
	    _this.subscribers.push(callback);
	  };
	
	  this.emit = function (eventType) {
	    _this.subscribers.forEach(function (subscriber) {
	      return subscriber(eventType,
	      // shallow copy to avoid accidental mutation
	      _this.openInstances.slice());
	    });
	  };
	
	  this.openInstances = [];
	  this.subscribers = [];
	};
	
	var portalOpenInstances = new PortalOpenInstances();
	
	exports.default = portalOpenInstances;
	module.exports = exports["default"];

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findTabbableDescendants;
	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	var tabbableNode = /input|select|textarea|button|object/;
	
	function hidesContents(element) {
	  var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
	
	  // If the node is empty, this is good enough
	  if (zeroSize && !element.innerHTML) return true;
	
	  // Otherwise we need to check some styles
	  var style = window.getComputedStyle(element);
	  return zeroSize ? style.getPropertyValue("overflow") !== "visible" ||
	  // if 'overflow: visible' set, check if there is actually any overflow
	  element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
	}
	
	function visible(element) {
	  var parentElement = element;
	  while (parentElement) {
	    if (parentElement === document.body) break;
	    if (hidesContents(parentElement)) return false;
	    parentElement = parentElement.parentNode;
	  }
	  return true;
	}
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  var res = tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
	  return res && visible(element);
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute("tabindex");
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll("*"), 0).filter(tabbable);
	}
	module.exports = exports["default"];

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
	  gentle: { stiffness: 120, damping: 14 },
	  wobbly: { stiffness: 180, damping: 12 },
	  stiff: { stiffness: 210, damping: 20 }
	};
	module.exports = exports["default"];

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setRef = exports.shallowEqual = exports.safeInvoke = exports.unwrapArray = void 0;
	
	/**
	 * Takes an argument and if it's an array, returns the first item in the array,
	 * otherwise returns the argument. Used for Preact compatibility.
	 */
	var unwrapArray = function unwrapArray(arg) {
	  return Array.isArray(arg) ? arg[0] : arg;
	};
	/**
	 * Takes a maybe-undefined function and arbitrary args and invokes the function
	 * only if it is defined.
	 */
	
	
	exports.unwrapArray = unwrapArray;
	
	var safeInvoke = function safeInvoke(fn) {
	  if (typeof fn === "function") {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return fn.apply(void 0, args);
	  }
	};
	/**
	 * Does a shallow equality check of two objects by comparing the reference
	 * equality of each value.
	 */
	
	
	exports.safeInvoke = safeInvoke;
	
	var shallowEqual = function shallowEqual(objA, objB) {
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (bKeys.length !== aKeys.length) {
	    return false;
	  }
	
	  for (var i = 0; i < bKeys.length; i++) {
	    var key = aKeys[i];
	
	    if (objA[key] !== objB[key]) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Sets a ref using either a ref callback or a ref object
	 */
	
	
	exports.shallowEqual = shallowEqual;
	
	var setRef = function setRef(ref, node) {
	  // if its a function call it
	  if (typeof ref === "function") {
	    return safeInvoke(ref, node);
	  } // otherwise we should treat it as a ref object
	  else if (ref != null) {
	      ref.current = node;
	    }
	};
	
	exports.setRef = setRef;

/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = connectAdvanced;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(1697));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(770);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(396));
	
	var _useIsomorphicLayoutEffect = __webpack_require__(767);
	
	var _Context = __webpack_require__(139);
	
	// Define some constant arrays just to avoid re-creating these
	var EMPTY_ARRAY = [];
	var NO_SUBSCRIPTION_ARRAY = [null, null];
	
	var stringifyComponent = function stringifyComponent(Comp) {
	  try {
	    return JSON.stringify(Comp);
	  } catch (err) {
	    return String(Comp);
	  }
	};
	
	function storeStateUpdatesReducer(state, action) {
	  var updateCount = state[1];
	  return [action.payload, updateCount + 1];
	}
	
	function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    return effectFunc.apply(void 0, effectArgs);
	  }, dependencies);
	}
	
	function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
	  // We want to capture the wrapper props and child props we used for later comparisons
	  lastWrapperProps.current = wrapperProps;
	  lastChildProps.current = actualChildProps;
	  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
	
	  if (childPropsFromStoreUpdate.current) {
	    childPropsFromStoreUpdate.current = null;
	    notifyNestedSubs();
	  }
	}
	
	function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
	  // If we're not subscribed to the store, nothing to do here
	  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
	
	  var didUnsubscribe = false;
	  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
	
	  var checkForUpdates = function checkForUpdates() {
	    if (didUnsubscribe) {
	      // Don't run stale listeners.
	      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
	      return;
	    }
	
	    var latestStoreState = store.getState();
	    var newChildProps, error;
	
	    try {
	      // Actually run the selector with the most recent store state and wrapper props
	      // to determine what the child props should be
	      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
	    } catch (e) {
	      error = e;
	      lastThrownError = e;
	    }
	
	    if (!error) {
	      lastThrownError = null;
	    } // If the child props haven't changed, nothing to do here - cascade the subscription update
	
	
	    if (newChildProps === lastChildProps.current) {
	      if (!renderIsScheduled.current) {
	        notifyNestedSubs();
	      }
	    } else {
	      // Save references to the new child props.  Note that we track the "child props from store update"
	      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
	      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
	      // forcing another re-render, which we don't want.
	      lastChildProps.current = newChildProps;
	      childPropsFromStoreUpdate.current = newChildProps;
	      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
	
	      forceComponentUpdateDispatch({
	        type: 'STORE_UPDATED',
	        payload: {
	          error: error
	        }
	      });
	    }
	  }; // Actually subscribe to the nearest connected ancestor (or store)
	
	
	  subscription.onStateChange = checkForUpdates;
	  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
	  // changed since we began.
	
	  checkForUpdates();
	
	  var unsubscribeWrapper = function unsubscribeWrapper() {
	    didUnsubscribe = true;
	    subscription.tryUnsubscribe();
	    subscription.onStateChange = null;
	
	    if (lastThrownError) {
	      // It's possible that we caught an error due to a bad mapState function, but the
	      // parent re-rendered without this component and we're about to unmount.
	      // This shouldn't happen as long as we do top-down subscriptions correctly, but
	      // if we ever do those wrong, this throw will surface the error in our tests.
	      // In that case, throw the error from here so it doesn't get lost.
	      throw lastThrownError;
	    }
	  };
	
	  return unsubscribeWrapper;
	}
	
	var initStateUpdates = function initStateUpdates() {
	  return [null, 0];
	};
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      _ref2$forwardRef = _ref2.forwardRef,
	      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
	      _ref2$context = _ref2.context,
	      context = _ref2$context === void 0 ? _Context.ReactReduxContext : _ref2$context,
	      connectOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"]);
	
	  if (false) {
	    if (renderCountProp !== undefined) {
	      throw new Error("renderCountProp is removed. render counting is built into the latest React Dev Tools profiling extension");
	    }
	
	    if (withRef) {
	      throw new Error('withRef is removed. To access the wrapped instance, use a ref on the connected component');
	    }
	
	    var customStoreWarningMessage = 'To use a custom Redux store for specific components, create a custom React context with ' + "React.createContext(), and pass the context object to React Redux's Provider and specific components" + ' like: <Provider context={MyContext}><ConnectedComponent context={MyContext} /></Provider>. ' + 'You may also pass a {context : MyContext} option to connect';
	
	    if (storeKey !== 'store') {
	      throw new Error('storeKey has been removed and does not do anything. ' + customStoreWarningMessage);
	    }
	  }
	
	  var Context = context;
	  return function wrapWithConnect(WrappedComponent) {
	    if (false) {
	      throw new Error("You must pass a component to the function returned by " + (methodName + ". Instead received " + stringifyComponent(WrappedComponent)));
	    }
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2["default"])({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	    var pure = connectOptions.pure;
	
	    function createChildSelector(store) {
	      return selectorFactory(store.dispatch, selectorFactoryOptions);
	    } // If we aren't running in "pure" mode, we don't want to memoize values.
	    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
	    // that just executes the given callback immediately.
	
	
	    var usePureOnlyMemo = pure ? _react.useMemo : function (callback) {
	      return callback();
	    };
	
	    function ConnectFunction(props) {
	      var _useMemo = (0, _react.useMemo)(function () {
	        // Distinguish between actual "data" props that were passed to the wrapper component,
	        // and values needed to control behavior (forwarded refs, alternate context instances).
	        // To maintain the wrapperProps object reference, memoize this destructuring.
	        var reactReduxForwardedRef = props.reactReduxForwardedRef,
	            wrapperProps = (0, _objectWithoutPropertiesLoose2["default"])(props, ["reactReduxForwardedRef"]);
	        return [props.context, reactReduxForwardedRef, wrapperProps];
	      }, [props]),
	          propsContext = _useMemo[0],
	          reactReduxForwardedRef = _useMemo[1],
	          wrapperProps = _useMemo[2];
	
	      var ContextToUse = (0, _react.useMemo)(function () {
	        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
	        // Memoize the check that determines which context instance we should use.
	        return propsContext && propsContext.Consumer && (0, _reactIs.isContextConsumer)( /*#__PURE__*/_react["default"].createElement(propsContext.Consumer, null)) ? propsContext : Context;
	      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available
	
	      var contextValue = (0, _react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
	      // We'll check to see if it _looks_ like a Redux store first.
	      // This allows us to pass through a `store` prop that is just a plain value.
	
	      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
	      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
	
	      if (false) {
	        throw new Error("Could not find \"store\" in the context of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + "or pass a custom React context provider to <Provider> and the corresponding " + ("React context consumer to " + displayName + " in connect options."));
	      } // Based on the previous check, one of these must be true
	
	
	      var store = didStoreComeFromProps ? props.store : contextValue.store;
	      var childPropsSelector = (0, _react.useMemo)(function () {
	        // The child props selector needs the store reference as an input.
	        // Re-create this selector whenever the store changes.
	        return createChildSelector(store);
	      }, [store]);
	
	      var _useMemo2 = (0, _react.useMemo)(function () {
	        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var subscription = new _Subscription["default"](store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `subscription` will then be null. This can
	        // probably be avoided if Subscription's listeners logic is changed to not call listeners
	        // that have been unsubscribed in the  middle of the notification loop.
	
	        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
	        return [subscription, notifyNestedSubs];
	      }, [store, didStoreComeFromProps, contextValue]),
	          subscription = _useMemo2[0],
	          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
	      // and memoize that value to avoid unnecessary context updates.
	
	
	      var overriddenContextValue = (0, _react.useMemo)(function () {
	        if (didStoreComeFromProps) {
	          // This component is directly subscribed to a store from props.
	          // We don't want descendants reading from this store - pass down whatever
	          // the existing context value is from the nearest connected ancestor.
	          return contextValue;
	        } // Otherwise, put this component's subscription instance into context, so that
	        // connected descendants won't update until after this component is done
	
	
	        return (0, _extends2["default"])({}, contextValue, {
	          subscription: subscription
	        });
	      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
	      // causes a change to the calculated child component props (or we caught an error in mapState)
	
	      var _useReducer = (0, _react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
	          _useReducer$ = _useReducer[0],
	          previousStateUpdateResult = _useReducer$[0],
	          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
	
	
	      if (previousStateUpdateResult && previousStateUpdateResult.error) {
	        throw previousStateUpdateResult.error;
	      } // Set up refs to coordinate values between the subscription effect and the render logic
	
	
	      var lastChildProps = (0, _react.useRef)();
	      var lastWrapperProps = (0, _react.useRef)(wrapperProps);
	      var childPropsFromStoreUpdate = (0, _react.useRef)();
	      var renderIsScheduled = (0, _react.useRef)(false);
	      var actualChildProps = usePureOnlyMemo(function () {
	        // Tricky logic here:
	        // - This render may have been triggered by a Redux store update that produced new child props
	        // - However, we may have gotten new wrapper props after that
	        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
	        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
	        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
	        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
	          return childPropsFromStoreUpdate.current;
	        } // TODO We're reading the store directly in render() here. Bad idea?
	        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
	        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
	        // to determine what the child props should be.
	
	
	        return childPropsSelector(store.getState(), wrapperProps);
	      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
	      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
	      // just useEffect instead to avoid the warning, since neither will run anyway.
	
	      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes
	
	      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
	      // We memoize the elements for the rendered child component as an optimization.
	
	      var renderedWrappedComponent = (0, _react.useMemo)(function () {
	        return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, actualChildProps, {
	          ref: reactReduxForwardedRef
	        }));
	      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
	      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
	
	      var renderedChild = (0, _react.useMemo)(function () {
	        if (shouldHandleStateChanges) {
	          // If this component is subscribed to store updates, we need to pass its own
	          // subscription instance down to our descendants. That means rendering the same
	          // Context instance, and putting a different value into the context.
	          return /*#__PURE__*/_react["default"].createElement(ContextToUse.Provider, {
	            value: overriddenContextValue
	          }, renderedWrappedComponent);
	        }
	
	        return renderedWrappedComponent;
	      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
	      return renderedChild;
	    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
	
	
	    var Connect = pure ? _react["default"].memo(ConnectFunction) : ConnectFunction;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	
	    if (forwardRef) {
	      var forwarded = _react["default"].forwardRef(function forwardConnectRef(props, ref) {
	        return /*#__PURE__*/_react["default"].createElement(Connect, (0, _extends2["default"])({}, props, {
	          reactReduxForwardedRef: ref
	        }));
	      });
	
	      forwarded.displayName = displayName;
	      forwarded.WrappedComponent = WrappedComponent;
	      return (0, _hoistNonReactStatics["default"])(forwarded, WrappedComponent);
	    }
	
	    return (0, _hoistNonReactStatics["default"])(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(768));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	//
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	//
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject["default"])(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useReduxContext = useReduxContext;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(139);
	
	/**
	 * A hook to access the value of the `ReactReduxContext`. This is a low-level
	 * hook that you should usually not need to call directly.
	 *
	 * @returns {any} the value of the `ReactReduxContext`
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useReduxContext } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const { store } = useReduxContext()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	function useReduxContext() {
	  var contextValue = (0, _react.useContext)(_Context.ReactReduxContext);
	
	  if (false) {
	    throw new Error('could not find react-redux context value; please ensure the component is wrapped in a <Provider>');
	  }
	
	  return contextValue;
	}

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createStoreHook = createStoreHook;
	exports.useStore = void 0;
	
	var _react = __webpack_require__(1);
	
	var _Context = __webpack_require__(139);
	
	var _useReduxContext2 = __webpack_require__(763);
	
	/**
	 * Hook factory, which creates a `useStore` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useStore` hook bound to the specified context.
	 */
	function createStoreHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useStore() {
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store;
	
	    return store;
	  };
	}
	/**
	 * A hook to access the redux store.
	 *
	 * @returns {any} the redux store
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useStore } from 'react-redux'
	 *
	 * export const ExampleComponent = () => {
	 *   const store = useStore()
	 *   return <div>{store.getState()}</div>
	 * }
	 */
	
	
	var useStore = /*#__PURE__*/createStoreHook();
	exports.useStore = useStore;

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.getBatch = exports.setBatch = void 0;
	
	// Default to a dummy "batch" implementation that just runs the callback
	function defaultNoopBatch(callback) {
	  callback();
	}
	
	var batch = defaultNoopBatch; // Allow injecting another batching function later
	
	var setBatch = function setBatch(newBatch) {
	  return batch = newBatch;
	}; // Supply a getter just to skip dealing with ESM bindings
	
	
	exports.setBatch = setBatch;
	
	var getBatch = function getBatch() {
	  return batch;
	};
	
	exports.getBatch = getBatch;

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.useIsomorphicLayoutEffect = void 0;
	
	var _react = __webpack_require__(1);
	
	// React currently throws a warning when using useLayoutEffect on the server.
	// To get around it, we can conditionally useEffect on the server (no-op) and
	// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
	// subscription callback always has the selector from the latest render commit
	// available, otherwise a store update may happen between render and the effect,
	// which may cause missed updates; we also must ensure the store subscription
	// is created synchronously, otherwise a store update may occur before the
	// subscription is created and an inconsistent state may be observed
	var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _react.useLayoutEffect : _react.useEffect;
	exports.useIsomorphicLayoutEffect = useIsomorphicLayoutEffect;

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(1695));
	
	var _warning = _interopRequireDefault(__webpack_require__(769));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject["default"])(value)) {
	    (0, _warning["default"])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ }),
/* 770 */
[1912, 1698],
/* 771 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(95);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(399);
	
	var _ContextUtils = __webpack_require__(398);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, (0, _propTypes.shape)({ current: _propTypes.elementType })])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(95);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(116);
	
	var _PatternUtils = __webpack_require__(176);
	
	var _InternalPropTypes = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ }),
/* 776 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(519);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(518);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(1329);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(780);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(1709);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(1706);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(1713);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(1710);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(1715);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(519);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(518);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.types = exports.actions = exports.updateNotification = exports.notify = exports.addNotification = undefined;
	exports.removeNotification = removeNotification;
	exports.removeNotifications = removeNotifications;
	
	var _helpers = __webpack_require__(402);
	
	var _constants = __webpack_require__(215);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// An array to store notifications object
	var INITIAL_STATE = [];
	// Action types
	var ADD_NOTIFICATION = 'ADD_NOTIFICATION';
	var UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION';
	var REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
	var REMOVE_NOTIFICATIONS = 'REMOVE_NOTIFICATIONS';
	
	/**
	 * Add a notification (thunk action creator)
	 *
	 * We use a thunk here to create an ADD_NOTIFICATION action
	 * and only return the notification object.
	 * @param {Object} notification
	 * @returns {Object} notification
	 */
	var addNotification = exports.addNotification = function addNotification(notification) {
	  return function (dispatch) {
	    if (!notification.id) {
	      notification.id = new Date().getTime();
	    }
	    notification = (0, _helpers.treatNotification)(notification);
	    // if there is an image, we preload it
	    // and add notification when image is loaded
	    if (notification.image) {
	      (0, _helpers.preloadImage)(notification.image, dispatch.bind(undefined, _addNotification(notification)));
	    } else {
	      dispatch(_addNotification(notification));
	    }
	    return notification;
	  };
	};
	
	/**
	 * Add a notification (action creator)
	 *
	 * @param {Object} notification
	 * @returns {{type: string, payload: {Object}}}
	 * @private
	 */
	function _addNotification(notification) {
	  return {
	    type: ADD_NOTIFICATION,
	    payload: notification
	  };
	}
	
	/**
	 * Update or create a notification
	 * @param {Object} notification
	 * @returns {{type: string, payload: {Object}}}
	 */
	var notify = exports.notify = function notify(notification) {
	  return function (dispatch, getState) {
	    var notifications = getState().notifications;
	    var doesNotifExist = notifications.find(function (notif) {
	      return notif.id === notification.id;
	    });
	
	    if (doesNotifExist) {
	      return dispatch(updateNotification(notification));
	    }
	
	    return dispatch(addNotification(notification));
	  };
	};
	
	/**
	 * Update a notification (thunk action creator)
	 *
	 * We use a thunk here to create an UPDATE_NOTIFICATION action
	 * and only return the notification object.
	 * @param {Object} notification
	 * @returns {Object} notification
	 */
	var updateNotification = exports.updateNotification = function updateNotification(notification) {
	  return function (dispatch, getState) {
	    if (!notification.id) {
	      throw new Error('A notification must have an `id` property to be updated');
	    }
	
	    var notifications = getState().notifications;
	    var index = notifications.findIndex(function (oldNotification) {
	      return oldNotification.id === notification.id;
	    });
	    var currNotification = notifications[index];
	
	    notification = (0, _helpers.treatNotification)(notification);
	
	    // if image is different, then we preload it
	    // and update notification when image is loaded
	    if (notification.image && (!currNotification.image || currNotification.image && notification.image !== currNotification.image)) {
	      (0, _helpers.preloadImage)(notification.image, dispatch.bind(undefined, _updateNotification(notification)));
	    } else {
	      dispatch(_updateNotification(notification));
	    }
	    return notification;
	  };
	};
	
	/**
	 * Update a notification (action creator)
	 *
	 * @param {Object} notification
	 * @returns {{type: string, payload: {Object}}}
	 * @private
	 */
	function _updateNotification(notification) {
	  return {
	    type: UPDATE_NOTIFICATION,
	    payload: notification
	  };
	}
	
	/**
	 * Remove a notification (action creator)
	 *
	 * @param {Object} notification
	 * @returns {{type: string, payload: {Object}}}
	 */
	function removeNotification(notification) {
	  return {
	    type: REMOVE_NOTIFICATION,
	    payload: notification
	  };
	}
	
	/**
	 * Remove all notifications (action creator)
	 *
	 * @returns {{type: string}}
	 */
	function removeNotifications() {
	  return {
	    type: REMOVE_NOTIFICATIONS
	  };
	}
	
	// Action creators
	var actions = exports.actions = {
	  addNotification: addNotification,
	  updateNotification: updateNotification,
	  removeNotification: removeNotification,
	  removeNotifications: removeNotifications
	};
	
	// Actions types
	var types = exports.types = {
	  ADD_NOTIFICATION: ADD_NOTIFICATION,
	  UPDATE_NOTIFICATION: UPDATE_NOTIFICATION,
	  REMOVE_NOTIFICATION: REMOVE_NOTIFICATION,
	  REMOVE_NOTIFICATIONS: REMOVE_NOTIFICATIONS
	};
	
	// Reducers
	
	exports.default = function () {
	  var defaultNotification = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_NOTIFICATION;
	
	  return function () {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
	    var _ref = arguments[1];
	    var type = _ref.type,
	        payload = _ref.payload;
	
	    switch (type) {
	      case ADD_NOTIFICATION:
	        var notification = Object.assign({}, defaultNotification, payload);
	        return [].concat(_toConsumableArray(state), [notification]);
	      case UPDATE_NOTIFICATION:
	        return state.map(function (notification) {
	          if (notification.id === payload.id) {
	            return Object.assign({}, defaultNotification, payload);
	          }
	          return notification;
	        });
	      case REMOVE_NOTIFICATION:
	        return state.filter(function (notification) {
	          return notification.id !== payload;
	        });
	      case REMOVE_NOTIFICATIONS:
	        return [];
	      default:
	        return state;
	    }
	  };
	};

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(1731);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(1730);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = handleAction;
	
	var _invariant = _interopRequireDefault(__webpack_require__(32));
	
	var _isFunction = _interopRequireDefault(__webpack_require__(276));
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(217));
	
	var _identity = _interopRequireDefault(__webpack_require__(404));
	
	var _isNil = _interopRequireDefault(__webpack_require__(790));
	
	var _isUndefined = _interopRequireDefault(__webpack_require__(1746));
	
	var _toString = _interopRequireDefault(__webpack_require__(792));
	
	var _constants = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleAction(type, reducer, defaultState) {
	  if (reducer === void 0) {
	    reducer = _identity.default;
	  }
	
	  var types = (0, _toString.default)(type).split(_constants.ACTION_TYPE_DELIMITER);
	  (0, _invariant.default)(!(0, _isUndefined.default)(defaultState), "defaultState for reducer handling " + types.join(', ') + " should be defined");
	  (0, _invariant.default)((0, _isFunction.default)(reducer) || (0, _isPlainObject.default)(reducer), 'Expected reducer to be a function or object with next and throw reducers');
	
	  var _ref = (0, _isFunction.default)(reducer) ? [reducer, reducer] : [reducer.next, reducer.throw].map(function (aReducer) {
	    return (0, _isNil.default)(aReducer) ? _identity.default : aReducer;
	  }),
	      nextReducer = _ref[0],
	      throwReducer = _ref[1];
	
	  return function (state, action) {
	    if (state === void 0) {
	      state = defaultState;
	    }
	
	    var actionType = action.type;
	
	    if (!actionType || types.indexOf((0, _toString.default)(actionType)) === -1) {
	      return state;
	    }
	
	    return (action.error === true ? throwReducer : nextReducer)(state, action);
	  };
	}

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _toCamelCase = _interopRequireDefault(__webpack_require__(1841));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var namespacer = '/';
	
	var _default = function _default(type) {
	  return type.indexOf(namespacer) === -1 ? (0, _toCamelCase.default)(type) : type.split(namespacer).map(_toCamelCase.default).join(namespacer);
	};
	
	exports.default = _default;

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _constants = __webpack_require__(216);
	
	var _ownKeys = _interopRequireDefault(__webpack_require__(405));
	
	var _get = _interopRequireDefault(__webpack_require__(788));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = function _default(predicate) {
	  return function flatten(map, _temp, partialFlatMap, partialFlatActionType) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        _ref$namespace = _ref.namespace,
	        namespace = _ref$namespace === void 0 ? _constants.DEFAULT_NAMESPACE : _ref$namespace,
	        prefix = _ref.prefix;
	
	    if (partialFlatMap === void 0) {
	      partialFlatMap = {};
	    }
	
	    if (partialFlatActionType === void 0) {
	      partialFlatActionType = '';
	    }
	
	    function connectNamespace(type) {
	      var _ref2;
	
	      if (!partialFlatActionType) return type;
	      var types = type.toString().split(_constants.ACTION_TYPE_DELIMITER);
	      var partials = partialFlatActionType.split(_constants.ACTION_TYPE_DELIMITER);
	      return (_ref2 = []).concat.apply(_ref2, partials.map(function (p) {
	        return types.map(function (t) {
	          return "" + p + namespace + t;
	        });
	      })).join(_constants.ACTION_TYPE_DELIMITER);
	    }
	
	    function connectPrefix(type) {
	      if (partialFlatActionType || !prefix || prefix && new RegExp("^" + prefix + namespace).test(type)) {
	        return type;
	      }
	
	      return "" + prefix + namespace + type;
	    }
	
	    (0, _ownKeys.default)(map).forEach(function (type) {
	      var nextNamespace = connectPrefix(connectNamespace(type));
	      var mapValue = (0, _get.default)(type, map);
	
	      if (predicate(mapValue)) {
	        flatten(mapValue, {
	          namespace: namespace,
	          prefix: prefix
	        }, partialFlatMap, nextNamespace);
	      } else {
	        partialFlatMap[nextNamespace] = mapValue;
	      }
	    });
	    return partialFlatMap;
	  };
	};
	
	exports.default = _default;

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = get;
	
	var _isMap = _interopRequireDefault(__webpack_require__(277));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function get(key, x) {
	  return (0, _isMap.default)(x) ? x.get(key) : x[key];
	}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return value.length === 0;
	};
	
	exports.default = _default;

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return value === null || value === undefined;
	};
	
	exports.default = _default;

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return typeof value === 'string';
	};
	
	exports.default = _default;

/***/ }),
/* 792 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return value.toString();
	};
	
	exports.default = _default;

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.isSubmissionError = isSubmissionError;
	exports.SubmissionError = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _es6Error = _interopRequireDefault(__webpack_require__(1315));
	
	var __FLAG__ = '@@redux-form/submission-error-flag';
	
	var SubmissionError = /*#__PURE__*/function (_ExtendableError) {
	  (0, _inheritsLoose2["default"])(SubmissionError, _ExtendableError);
	
	  /** @private */
	  function SubmissionError(errors) {
	    var _this;
	
	    _this = _ExtendableError.call(this, 'Submit Validation Failed') || this;
	    _this.errors = errors;
	    return _this;
	  }
	
	  return SubmissionError;
	}(_es6Error["default"]);
	
	exports.SubmissionError = SubmissionError;
	SubmissionError.__FLAG__ = __FLAG__;
	
	function isSubmissionError(error) {
	  return (error && error.constructor && error.constructor.__FLAG__ === __FLAG__) === true;
	}

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _actionTypes = __webpack_require__(406);
	
	var arrayInsert = function arrayInsert(form, field, index, value) {
	  return {
	    type: _actionTypes.ARRAY_INSERT,
	    meta: {
	      form: form,
	      field: field,
	      index: index
	    },
	    payload: value
	  };
	};
	
	var arrayMove = function arrayMove(form, field, from, to) {
	  return {
	    type: _actionTypes.ARRAY_MOVE,
	    meta: {
	      form: form,
	      field: field,
	      from: from,
	      to: to
	    }
	  };
	};
	
	var arrayPop = function arrayPop(form, field) {
	  return {
	    type: _actionTypes.ARRAY_POP,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var arrayPush = function arrayPush(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_PUSH,
	    meta: {
	      form: form,
	      field: field
	    },
	    payload: value
	  };
	};
	
	var arrayRemove = function arrayRemove(form, field, index) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE,
	    meta: {
	      form: form,
	      field: field,
	      index: index
	    }
	  };
	};
	
	var arrayRemoveAll = function arrayRemoveAll(form, field) {
	  return {
	    type: _actionTypes.ARRAY_REMOVE_ALL,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var arrayShift = function arrayShift(form, field) {
	  return {
	    type: _actionTypes.ARRAY_SHIFT,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var arraySplice = function arraySplice(form, field, index, removeNum, value) {
	  var action = {
	    type: _actionTypes.ARRAY_SPLICE,
	    meta: {
	      form: form,
	      field: field,
	      index: index,
	      removeNum: removeNum
	    }
	  };
	
	  if (value !== undefined) {
	    action.payload = value;
	  }
	
	  return action;
	};
	
	var arraySwap = function arraySwap(form, field, indexA, indexB) {
	  if (indexA === indexB) {
	    throw new Error('Swap indices cannot be equal');
	  }
	
	  if (indexA < 0 || indexB < 0) {
	    throw new Error('Swap indices cannot be negative');
	  }
	
	  return {
	    type: _actionTypes.ARRAY_SWAP,
	    meta: {
	      form: form,
	      field: field,
	      indexA: indexA,
	      indexB: indexB
	    }
	  };
	};
	
	var arrayUnshift = function arrayUnshift(form, field, value) {
	  return {
	    type: _actionTypes.ARRAY_UNSHIFT,
	    meta: {
	      form: form,
	      field: field
	    },
	    payload: value
	  };
	};
	
	var autofill = function autofill(form, field, value) {
	  return {
	    type: _actionTypes.AUTOFILL,
	    meta: {
	      form: form,
	      field: field
	    },
	    payload: value
	  };
	};
	
	var blur = function blur(form, field, value, touch) {
	  return {
	    type: _actionTypes.BLUR,
	    meta: {
	      form: form,
	      field: field,
	      touch: touch
	    },
	    payload: value
	  };
	};
	
	var change = function change(form, field, value, touch, persistentSubmitErrors) {
	  return {
	    type: _actionTypes.CHANGE,
	    meta: {
	      form: form,
	      field: field,
	      touch: touch,
	      persistentSubmitErrors: persistentSubmitErrors
	    },
	    payload: value
	  };
	};
	
	var clearSubmit = function clearSubmit(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var clearSubmitErrors = function clearSubmitErrors(form) {
	  return {
	    type: _actionTypes.CLEAR_SUBMIT_ERRORS,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var clearAsyncError = function clearAsyncError(form, field) {
	  return {
	    type: _actionTypes.CLEAR_ASYNC_ERROR,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
	  for (var _len = arguments.length, fields = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    fields[_key - 3] = arguments[_key];
	  }
	
	  return {
	    type: _actionTypes.CLEAR_FIELDS,
	    meta: {
	      form: form,
	      keepTouched: keepTouched,
	      persistentSubmitErrors: persistentSubmitErrors,
	      fields: fields
	    }
	  };
	};
	
	var destroy = function destroy() {
	  for (var _len2 = arguments.length, form = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    form[_key2] = arguments[_key2];
	  }
	
	  return {
	    type: _actionTypes.DESTROY,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var focus = function focus(form, field) {
	  return {
	    type: _actionTypes.FOCUS,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var initialize = function initialize(form, values, keepDirty, otherMeta) {
	  if (otherMeta === void 0) {
	    otherMeta = {};
	  }
	
	  if (keepDirty instanceof Object) {
	    otherMeta = keepDirty;
	    keepDirty = false;
	  }
	
	  return {
	    type: _actionTypes.INITIALIZE,
	    meta: (0, _extends2["default"])({
	      form: form,
	      keepDirty: keepDirty
	    }, otherMeta),
	    payload: values
	  };
	};
	
	var registerField = function registerField(form, name, type) {
	  return {
	    type: _actionTypes.REGISTER_FIELD,
	    meta: {
	      form: form
	    },
	    payload: {
	      name: name,
	      type: type
	    }
	  };
	};
	
	var reset = function reset(form) {
	  return {
	    type: _actionTypes.RESET,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var resetSection = function resetSection(form) {
	  for (var _len3 = arguments.length, sections = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	    sections[_key3 - 1] = arguments[_key3];
	  }
	
	  return {
	    type: _actionTypes.RESET_SECTION,
	    meta: {
	      form: form,
	      sections: sections
	    }
	  };
	};
	
	var startAsyncValidation = function startAsyncValidation(form, field) {
	  return {
	    type: _actionTypes.START_ASYNC_VALIDATION,
	    meta: {
	      form: form,
	      field: field
	    }
	  };
	};
	
	var startSubmit = function startSubmit(form) {
	  return {
	    type: _actionTypes.START_SUBMIT,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var stopAsyncValidation = function stopAsyncValidation(form, errors) {
	  return {
	    type: _actionTypes.STOP_ASYNC_VALIDATION,
	    meta: {
	      form: form
	    },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var stopSubmit = function stopSubmit(form, errors) {
	  return {
	    type: _actionTypes.STOP_SUBMIT,
	    meta: {
	      form: form
	    },
	    payload: errors,
	    error: !!(errors && Object.keys(errors).length)
	  };
	};
	
	var submit = function submit(form) {
	  return {
	    type: _actionTypes.SUBMIT,
	    meta: {
	      form: form
	    }
	  };
	};
	
	var setSubmitFailed = function setSubmitFailed(form) {
	  for (var _len4 = arguments.length, fields = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	    fields[_key4 - 1] = arguments[_key4];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_FAILED,
	    meta: {
	      form: form,
	      fields: fields
	    },
	    error: true
	  };
	};
	
	var setSubmitSucceeded = function setSubmitSucceeded(form) {
	  for (var _len5 = arguments.length, fields = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	    fields[_key5 - 1] = arguments[_key5];
	  }
	
	  return {
	    type: _actionTypes.SET_SUBMIT_SUCCEEDED,
	    meta: {
	      form: form,
	      fields: fields
	    },
	    error: false
	  };
	};
	
	var touch = function touch(form) {
	  for (var _len6 = arguments.length, fields = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
	    fields[_key6 - 1] = arguments[_key6];
	  }
	
	  return {
	    type: _actionTypes.TOUCH,
	    meta: {
	      form: form,
	      fields: fields
	    }
	  };
	};
	
	var unregisterField = function unregisterField(form, name, destroyOnUnmount) {
	  if (destroyOnUnmount === void 0) {
	    destroyOnUnmount = true;
	  }
	
	  return {
	    type: _actionTypes.UNREGISTER_FIELD,
	    meta: {
	      form: form
	    },
	    payload: {
	      name: name,
	      destroyOnUnmount: destroyOnUnmount
	    }
	  };
	};
	
	var untouch = function untouch(form) {
	  for (var _len7 = arguments.length, fields = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
	    fields[_key7 - 1] = arguments[_key7];
	  }
	
	  return {
	    type: _actionTypes.UNTOUCH,
	    meta: {
	      form: form,
	      fields: fields
	    }
	  };
	};
	
	var updateSyncErrors = function updateSyncErrors(form, syncErrors, error) {
	  if (syncErrors === void 0) {
	    syncErrors = {};
	  }
	
	  return {
	    type: _actionTypes.UPDATE_SYNC_ERRORS,
	    meta: {
	      form: form
	    },
	    payload: {
	      syncErrors: syncErrors,
	      error: error
	    }
	  };
	};
	
	var updateSyncWarnings = function updateSyncWarnings(form, syncWarnings, warning) {
	  if (syncWarnings === void 0) {
	    syncWarnings = {};
	  }
	
	  return {
	    type: _actionTypes.UPDATE_SYNC_WARNINGS,
	    meta: {
	      form: form
	    },
	    payload: {
	      syncWarnings: syncWarnings,
	      warning: warning
	    }
	  };
	};
	
	var actions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift,
	  autofill: autofill,
	  blur: blur,
	  change: change,
	  clearFields: clearFields,
	  clearSubmit: clearSubmit,
	  clearSubmitErrors: clearSubmitErrors,
	  clearAsyncError: clearAsyncError,
	  destroy: destroy,
	  focus: focus,
	  initialize: initialize,
	  registerField: registerField,
	  reset: reset,
	  resetSection: resetSection,
	  startAsyncValidation: startAsyncValidation,
	  startSubmit: startSubmit,
	  stopAsyncValidation: stopAsyncValidation,
	  stopSubmit: stopSubmit,
	  submit: submit,
	  setSubmitFailed: setSubmitFailed,
	  setSubmitSucceeded: setSubmitSucceeded,
	  touch: touch,
	  unregisterField: unregisterField,
	  untouch: untouch,
	  updateSyncErrors: updateSyncErrors,
	  updateSyncWarnings: updateSyncWarnings
	};
	var _default = actions;
	exports["default"] = _default;

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createFieldProps;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var processProps = function processProps(type, props, _value, deepEqual) {
	  var value = props.value;
	
	  if (type === 'checkbox') {
	    return (0, _extends2["default"])({}, props, {
	      checked: !!value
	    });
	  }
	
	  if (type === 'radio') {
	    return (0, _extends2["default"])({}, props, {
	      checked: deepEqual(value, _value),
	      value: _value
	    });
	  }
	
	  if (type === 'select-multiple') {
	    return (0, _extends2["default"])({}, props, {
	      value: value || []
	    });
	  }
	
	  if (type === 'file') {
	    return (0, _extends2["default"])({}, props, {
	      value: value || undefined
	    });
	  }
	
	  return props;
	};
	
	function createFieldProps(_ref, name, _ref2) {
	  var getIn = _ref.getIn,
	      toJS = _ref.toJS,
	      deepEqual = _ref.deepEqual;
	  var asyncError = _ref2.asyncError,
	      asyncValidating = _ref2.asyncValidating,
	      onBlur = _ref2.onBlur,
	      onChange = _ref2.onChange,
	      onDrop = _ref2.onDrop,
	      onDragStart = _ref2.onDragStart,
	      dirty = _ref2.dirty,
	      dispatch = _ref2.dispatch,
	      onFocus = _ref2.onFocus,
	      form = _ref2.form,
	      format = _ref2.format,
	      initial = _ref2.initial,
	      parse = _ref2.parse,
	      pristine = _ref2.pristine,
	      props = _ref2.props,
	      state = _ref2.state,
	      submitError = _ref2.submitError,
	      submitFailed = _ref2.submitFailed,
	      submitting = _ref2.submitting,
	      syncError = _ref2.syncError,
	      syncWarning = _ref2.syncWarning,
	      validate = _ref2.validate,
	      value = _ref2.value,
	      _value = _ref2._value,
	      warn = _ref2.warn,
	      custom = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["asyncError", "asyncValidating", "onBlur", "onChange", "onDrop", "onDragStart", "dirty", "dispatch", "onFocus", "form", "format", "initial", "parse", "pristine", "props", "state", "submitError", "submitFailed", "submitting", "syncError", "syncWarning", "validate", "value", "_value", "warn"]);
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	
	  var formatFieldValue = function formatFieldValue(value, format) {
	    if (format === null) {
	      return value;
	    }
	
	    var defaultFormattedValue = value == null ? '' : value;
	    return format ? format(value, name) : defaultFormattedValue;
	  };
	
	  var formattedFieldValue = formatFieldValue(value, format);
	  return {
	    input: processProps(custom.type, {
	      name: name,
	      onBlur: onBlur,
	      onChange: onChange,
	      onDragStart: onDragStart,
	      onDrop: onDrop,
	      onFocus: onFocus,
	      value: formattedFieldValue
	    }, _value, deepEqual),
	    meta: (0, _extends2["default"])({}, toJS(state), {
	      active: !!(state && getIn(state, 'active')),
	      asyncValidating: asyncValidating,
	      autofilled: !!(state && getIn(state, 'autofilled')),
	      dirty: dirty,
	      dispatch: dispatch,
	      error: error,
	      form: form,
	      initial: initial,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: !!submitting,
	      submitFailed: !!submitFailed,
	      touched: !!(state && getIn(state, 'touched')),
	      valid: !error,
	      visited: !!(state && getIn(state, 'visited'))
	    }),
	    custom: (0, _extends2["default"])({}, custom, {}, props)
	  };
	}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
	  var initialized = _ref.initialized,
	      trigger = _ref.trigger,
	      pristine = _ref.pristine,
	      syncValidationPasses = _ref.syncValidationPasses;
	
	  if (!syncValidationPasses) {
	    return false;
	  }
	
	  switch (trigger) {
	    case 'blur':
	    case 'change':
	      // blurring
	      return true;
	
	    case 'submit':
	      // submitting, so only async validate if form is dirty or was never initialized
	      // conversely, DON'T async validate if the form is pristine just as it was initialized
	      return !pristine || !initialized;
	
	    default:
	      return false;
	  }
	};
	
	var _default = defaultShouldAsyncValidate;
	exports["default"] = _default;

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldError = function defaultShouldError(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	var _default = defaultShouldError;
	exports["default"] = _default;

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldValidate = function defaultShouldValidate(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	var _default = defaultShouldValidate;
	exports["default"] = _default;

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var defaultShouldWarn = function defaultShouldWarn(_ref) {
	  var values = _ref.values,
	      nextProps = _ref.nextProps,
	      initialRender = _ref.initialRender,
	      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
	      fieldValidatorKeys = _ref.fieldValidatorKeys,
	      structure = _ref.structure;
	
	  if (initialRender) {
	    return true;
	  }
	
	  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
	};
	
	var _default = defaultShouldWarn;
	exports["default"] = _default;

/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getValue = _interopRequireDefault(__webpack_require__(1769));
	
	var _isReactNative = _interopRequireDefault(__webpack_require__(802));
	
	var onChangeValue = function onChangeValue(event, _ref) {
	  var name = _ref.name,
	      parse = _ref.parse,
	      normalize = _ref.normalize;
	  // read value from input
	  var value = (0, _getValue["default"])(event, _isReactNative["default"]); // parse value if we have a parser
	
	  if (parse) {
	    value = parse(value, name);
	  } // normalize value
	
	
	  if (normalize) {
	    value = normalize(name, value);
	  }
	
	  return value;
	};
	
	var _default = onChangeValue;
	exports["default"] = _default;

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isEvent = _interopRequireDefault(__webpack_require__(407));
	
	var silenceEvent = function silenceEvent(event) {
	  var is = (0, _isEvent["default"])(event);
	
	  if (is) {
	    event.preventDefault();
	  }
	
	  return is;
	};
	
	var _default = silenceEvent;
	exports["default"] = _default;

/***/ }),
/* 802 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';
	var _default = isReactNative;
	exports["default"] = _default;

/***/ }),
/* 803 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createIsPristine;
	
	function createIsPristine(_ref) {
	  var deepEqual = _ref.deepEqual,
	      empty = _ref.empty,
	      getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      var formState = nonNullGetFormState(state);
	
	      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      if (fields && fields.length) {
	        return fields.every(function (field) {
	          var fieldInitial = getIn(formState, form + ".initial." + field);
	          var fieldValue = getIn(formState, form + ".values." + field);
	          return deepEqual(fieldInitial, fieldValue);
	        });
	      }
	
	      var initial = getIn(formState, form + ".initial") || empty;
	      var values = getIn(formState, form + ".values") || initial;
	      return deepEqual(initial, values);
	    };
	  };
	}

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isEqualWith2 = _interopRequireDefault(__webpack_require__(574));
	
	var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
	  // https://lodash.com/docs/4.17.4#isEqualWith
	  if (stack) {
	    // Shallow compares
	    // For 1st level, stack === undefined.
	    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
	    // For 2nd level and up, stack !== undefined.
	    //   -> Compare by === operator
	    return objectValue === otherValue;
	  }
	};
	
	var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
	  var propsEqual = (0, _isEqualWith2["default"])(instance.props, nextProps, customizer);
	  var stateEqual = (0, _isEqualWith2["default"])(instance.state, nextState, customizer);
	  return !propsEqual || !stateEqual;
	};
	
	var _default = shallowCompare;
	exports["default"] = _default;

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(265);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1839);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	'use strict';
	
	var $Object = Object;
	var $TypeError = TypeError;
	
	module.exports = function flags() {
		if (this != null && this !== $Object(this)) {
			throw new $TypeError('RegExp.prototype.flags getter called on non-object');
		}
		var result = '';
		if (this.global) {
			result += 'g';
		}
		if (this.ignoreCase) {
			result += 'i';
		}
		if (this.multiline) {
			result += 'm';
		}
		if (this.dotAll) {
			result += 's';
		}
		if (this.unicode) {
			result += 'u';
		}
		if (this.sticky) {
			result += 'y';
		}
		return result;
	};


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(808);
	
	var supportsDescriptors = __webpack_require__(340).supportsDescriptors;
	var $gOPD = Object.getOwnPropertyDescriptor;
	var $TypeError = TypeError;
	
	module.exports = function getPolyfill() {
		if (!supportsDescriptors) {
			throw new $TypeError('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		if ((/a/mig).flags === 'gim') {
			var descriptor = $gOPD(RegExp.prototype, 'flags');
			if (descriptor && typeof descriptor.get === 'function' && typeof (/a/).dotAll === 'boolean') {
				return descriptor.get;
			}
		}
		return implementation;
	};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var groperty = __webpack_require__(1319)
	  , defaultAlphabet = 'aāáǎàâãąbcćčçdďðeēéěèêëęėfgğhıiīíǐìîïįjklłmnńňñoōóǒòôpqrřsśšştťuųūúǔùůûüǖǘǚǜvwxyýzźżžþæœøõåäö';
	
	function international ( propList, alphabet ) {
	  alphabet = alphabet || defaultAlphabet;
	
	  return function(a, b) {
	    var i = -1
	      , aIndex
	      , bIndex;
	
	    if ( propList ) {
	      a = groperty(a, propList);
	      b = groperty(b, propList);
	    }
	
	    a = String(a || '').toLowerCase();
	    b = String(b || '').toLowerCase();
	
	    do {
	      i++;
	      if (!a[i] && b[i]) return -1;
	      if (a[i] && !b[i]) return 1;
	      aIndex = alphabet.indexOf(a[i]);
	      bIndex = alphabet.indexOf(b[i]);
	      if (aIndex === -1 || bIndex === -1) {
	        if (a[i] < b[i]) return -1;
	        if (a[i] > b[i]) return 1;
	      }
	    } while (aIndex === bIndex && i < a.length && i < b.length);
	
	    return aIndex - bIndex;
	  };
	}
	
	if (typeof module === 'object' && module.hasOwnProperty('exports')) {
	  module.exports = international;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1299);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {"hmr":true}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(142)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../css-loader/index.js!../../postcss-loader/index.js!../../sass-loader/index.js?outputStyle=expanded!./react-datepicker.css", function() {
				var newContent = require("!!../../css-loader/index.js!../../postcss-loader/index.js!../../sass-loader/index.js?outputStyle=expanded!./react-datepicker.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1303);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {"hmr":true}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(142)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js?outputStyle=expanded!./primitives.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js?outputStyle=expanded!./primitives.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	    } else if (Array.isArray(headers)) {
	      headers.forEach(function(header) {
	        this.append(header[0], header[1])
	      }, this)
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
	    // https://tools.ietf.org/html/rfc7230#section-3.2
	    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
	    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status === undefined ? 200 : options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      } else if (request.credentials === 'omit') {
	        xhr.withCredentials = false
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*! cpexcel.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W100 */
	var cptable = {version:"1.15.0"};
	cptable[437] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜ¢£¥₧ƒáíóúñÑªº¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[620] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàąçêëèïîćÄĄĘęłôöĆûùŚÖÜ¢Ł¥śƒŹŻóÓńŃźż¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[737] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρσςτυφχψ░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀ωάέήϊίόύϋώΆΈΉΊΌΎΏ±≥≤ΪΫ÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[850] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø×ƒáíóúñÑªº¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ðÐÊËÈıÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµþÞÚÛÙýÝ¯´­±‗¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[852] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäůćçłëŐőîŹÄĆÉĹĺôöĽľŚśÖÜŤťŁ×čáíóúĄąŽžĘę¬źČş«»░▒▓│┤ÁÂĚŞ╣║╗╝Żż┐└┴┬├─┼Ăă╚╔╩╦╠═╬¤đĐĎËďŇÍÎě┘┌█▄ŢŮ▀ÓßÔŃńňŠšŔÚŕŰýÝţ´­˝˛ˇ˘§÷¸°¨˙űŘř■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[857] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîıÄÅÉæÆôöòûùİÖÜø£ØŞşáíóúñÑĞğ¿®¬½¼¡«»░▒▓│┤ÁÂÀ©╣║╗╝¢¥┐└┴┬├─┼ãÃ╚╔╩╦╠═╬¤ºªÊËÈ�ÍÎÏ┘┌█▄¦Ì▀ÓßÔÒõÕµ�×ÚÛÙìÿ¯´­±�¾¶§÷¸°¨·¹³²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[861] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèÐðÞÄÅÉæÆôöþûÝýÖÜø£Ø₧ƒáíóúÁÍÓÚ¿⌐¬½¼¡«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[865] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÇüéâäàåçêëèïîìÄÅÉæÆôöòûùÿÖÜø£Ø₧ƒáíóúñÑªº¿⌐¬½¼¡«¤░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[866] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмноп░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀рстуфхцчшщъыьэюяЁёЄєЇїЎў°∙·√№¤■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[874] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€����…�����������‘’“”•–—�������� กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮฯะัาำิีึืฺุู����฿เแโใไๅๆ็่้๊๋์ํ๎๏๐๑๒๓๔๕๖๗๘๙๚๛����", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[895] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ČüéďäĎŤčěĚĹÍľǪÄÁÉžŽôöÓůÚýÖÜŠĽÝŘťáíóúňŇŮÔšřŕŔ¼§«»░▒▓│┤╡╢╖╕╣║╗╝╜╛┐└┴┬├─┼╞╟╚╔╩╦╠═╬╧╨╤╥╙╘╒╓╫╪┘┌█▄▌▐▀αßΓπΣσµτΦΘΩδ∞φε∩≡±≥≤⌠⌡÷≈°∙·√ⁿ²■ ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[932] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������｡｢｣､･ｦｧｨｩｪｫｬｭｮｯｰｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝﾞﾟ��������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈〉《》「」『』【】＋－±×�÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓�����������∈∋⊆⊇⊂⊃∪∩��������∧∨￢⇒⇔∀∃�����������∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬�������Å‰♯♭♪†‡¶����◯���".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�������������������������������������������������������������������������������０１２３４５６７８９�������ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ�������ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ����ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん��������������".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミ�ムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ��������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�����������������������������������������".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмн�опрстуфхцчшщъыьэюя�������������─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂�����������������������������������������������������������������".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[135] = "����������������������������������������������������������������①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮⑯⑰⑱⑲⑳ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡��������㍻�〝〟№㏍℡㊤㊥㊦㊧㊨㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪���������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭���".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円�園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改���".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫�橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄���".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救�朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈���".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨�劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向���".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降�項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷���".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止�死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周���".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳�準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾���".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨�逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線���".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻�操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只���".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄�逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓���".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬�凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入���".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅�楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美���".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷�斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋���".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆�摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒���".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲�沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯���".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕��������������������������������������������弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲���".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭�凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨���".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸�噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩���".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀�它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏���".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠�怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛���".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫�捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼���".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎�梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣���".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯�麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌���".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[224] = "����������������������������������������������������������������漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝�烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱���".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿�痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬���".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰�窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆���".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷�縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋���".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤�艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈���".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬�蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞���".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧�諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊���".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜�轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮���".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙�閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰���".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃�騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈���".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯�黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙�������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[237] = "����������������������������������������������������������������纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏�塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱���".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙�蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑��ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ￢￤＇＂���".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[250] = "����������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊�兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯���".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神�祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙���".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑������������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	return {"enc": e, "dec": d }; })();
	cptable[936] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "����������������������������������������������������������������丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪乫乬乭乮乯乲乴乵乶乷乸乹乺乻乼乽乿亀亁亂亃亄亅亇亊�亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂伃伄伅伆伇伈伋伌伒伓伔伕伖伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾伿佀佁佂佄佅佇佈佉佊佋佌佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "����������������������������������������������������������������侤侫侭侰侱侲侳侴侶侷侸侹侺侻侼侽侾俀俁係俆俇俈俉俋俌俍俒俓俔俕俖俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿倀倁倂倃倄倅倆倇倈倉倊�個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯倰倱倲倳倴倵倶倷倸倹倻倽倿偀偁偂偄偅偆偉偊偋偍偐偑偒偓偔偖偗偘偙偛偝偞偟偠偡偢偣偤偦偧偨偩偪偫偭偮偯偰偱偲偳側偵偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎傏傐傑傒傓傔傕傖傗傘備傚傛傜傝傞傟傠傡傢傤傦傪傫傭傮傯傰傱傳傴債傶傷傸傹傼�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "����������������������������������������������������������������傽傾傿僀僁僂僃僄僅僆僇僈僉僊僋僌働僎僐僑僒僓僔僕僗僘僙僛僜僝僞僟僠僡僢僣僤僥僨僩僪僫僯僰僱僲僴僶僷僸價僺僼僽僾僿儀儁儂儃億儅儈�儉儊儌儍儎儏儐儑儓儔儕儖儗儘儙儚儛儜儝儞償儠儢儣儤儥儦儧儨儩優儫儬儭儮儯儰儱儲儳儴儵儶儷儸儹儺儻儼儽儾兂兇兊兌兎兏児兒兓兗兘兙兛兝兞兟兠兡兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦冧冨冩冪冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒凓凔凕凖凗�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "����������������������������������������������������������������凘凙凚凜凞凟凢凣凥処凧凨凩凪凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄剅剆則剈剉剋剎剏剒剓剕剗剘�剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳剴創剶剷剸剹剺剻剼剾劀劃劄劅劆劇劉劊劋劌劍劎劏劑劒劔劕劖劗劘劙劚劜劤劥劦劧劮劯劰労劵劶劷劸効劺劻劼劽勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務勚勛勜勝勞勠勡勢勣勥勦勧勨勩勪勫勬勭勮勯勱勲勳勴勵勶勷勸勻勼勽匁匂匃匄匇匉匊匋匌匎�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "����������������������������������������������������������������匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯匰匱匲匳匴匵匶匷匸匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏�厐厑厒厓厔厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯厰厱厲厳厴厵厷厸厹厺厼厽厾叀參叄叅叆叇収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝呞呟呠呡呣呥呧呩呪呫呬呭呮呯呰呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "����������������������������������������������������������������咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠員哢哣哤哫哬哯哰哱哴哵哶哷哸哹哻哾唀唂唃唄唅唈唊唋唌唍唎唒唓唕唖唗唘唙唚唜唝唞唟唡唥唦�唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋啌啍啎問啑啒啓啔啗啘啙啚啛啝啞啟啠啢啣啨啩啫啯啰啱啲啳啴啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠喡喢喣喤喥喦喨喩喪喫喬喭單喯喰喲喴営喸喺喼喿嗀嗁嗂嗃嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗嗘嗙嗚嗛嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸嗹嗺嗻嗼嗿嘂嘃嘄嘅�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "����������������������������������������������������������������嘆嘇嘊嘋嘍嘐嘑嘒嘓嘔嘕嘖嘗嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀噁噂噃噄噅噆噇噈噉噊噋噏噐噑噒噓噕噖噚噛噝噞噟噠噡�噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽噾噿嚀嚁嚂嚃嚄嚇嚈嚉嚊嚋嚌嚍嚐嚑嚒嚔嚕嚖嚗嚘嚙嚚嚛嚜嚝嚞嚟嚠嚡嚢嚤嚥嚦嚧嚨嚩嚪嚫嚬嚭嚮嚰嚱嚲嚳嚴嚵嚶嚸嚹嚺嚻嚽嚾嚿囀囁囂囃囄囅囆囇囈囉囋囌囍囎囏囐囑囒囓囕囖囘囙囜団囥囦囧囨囩囪囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國圌圍圎圏圐圑�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "����������������������������������������������������������������園圓圔圕圖圗團圙圚圛圝圞圠圡圢圤圥圦圧圫圱圲圴圵圶圷圸圼圽圿坁坃坄坅坆坈坉坋坒坓坔坕坖坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀�垁垇垈垉垊垍垎垏垐垑垔垕垖垗垘垙垚垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹垺垻垼垽垾垿埀埁埄埅埆埇埈埉埊埌埍埐埑埓埖埗埛埜埞埡埢埣埥埦埧埨埩埪埫埬埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥堦堧堨堩堫堬堭堮堯報堲堳場堶堷堸堹堺堻堼堽�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "����������������������������������������������������������������堾堿塀塁塂塃塅塆塇塈塉塊塋塎塏塐塒塓塕塖塗塙塚塛塜塝塟塠塡塢塣塤塦塧塨塩塪塭塮塯塰塱塲塳塴塵塶塷塸塹塺塻塼塽塿墂墄墆墇墈墊墋墌�墍墎墏墐墑墔墕墖増墘墛墜墝墠墡墢墣墤墥墦墧墪墫墬墭墮墯墰墱墲墳墴墵墶墷墸墹墺墻墽墾墿壀壂壃壄壆壇壈壉壊壋壌壍壎壏壐壒壓壔壖壗壘壙壚壛壜壝壞壟壠壡壢壣壥壦壧壨壩壪壭壯壱売壴壵壷壸壺壻壼壽壾壿夀夁夃夅夆夈変夊夋夌夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "����������������������������������������������������������������夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛奜奝奞奟奡奣奤奦奧奨奩奪奫奬奭奮奯奰奱奲奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦�妧妬妭妰妱妳妴妵妶妷妸妺妼妽妿姀姁姂姃姄姅姇姈姉姌姍姎姏姕姖姙姛姞姟姠姡姢姤姦姧姩姪姫姭姮姯姰姱姲姳姴姵姶姷姸姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪娫娬娭娮娯娰娳娵娷娸娹娺娻娽娾娿婁婂婃婄婅婇婈婋婌婍婎婏婐婑婒婓婔婖婗婘婙婛婜婝婞婟婠�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "����������������������������������������������������������������婡婣婤婥婦婨婩婫婬婭婮婯婰婱婲婳婸婹婻婼婽婾媀媁媂媃媄媅媆媇媈媉媊媋媌媍媎媏媐媑媓媔媕媖媗媘媙媜媝媞媟媠媡媢媣媤媥媦媧媨媩媫媬�媭媮媯媰媱媴媶媷媹媺媻媼媽媿嫀嫃嫄嫅嫆嫇嫈嫊嫋嫍嫎嫏嫐嫑嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬嫭嫮嫯嫰嫲嫳嫴嫵嫶嫷嫸嫹嫺嫻嫼嫽嫾嫿嬀嬁嬂嬃嬄嬅嬆嬇嬈嬊嬋嬌嬍嬎嬏嬐嬑嬒嬓嬔嬕嬘嬙嬚嬛嬜嬝嬞嬟嬠嬡嬢嬣嬤嬥嬦嬧嬨嬩嬪嬫嬬嬭嬮嬯嬰嬱嬳嬵嬶嬸嬹嬺嬻嬼嬽嬾嬿孁孂孃孄孅孆孇�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "����������������������������������������������������������������孈孉孊孋孌孍孎孏孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏�寑寔寕寖寗寘寙寚寛寜寠寢寣實寧審寪寫寬寭寯寱寲寳寴寵寶寷寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧屨屩屪屫屬屭屰屲屳屴屵屶屷屸屻屼屽屾岀岃岄岅岆岇岉岊岋岎岏岒岓岕岝岞岟岠岡岤岥岦岧岨�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "����������������������������������������������������������������岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅峆峇峈峉峊峌峍峎峏峐峑峓峔峕峖峗峘峚峛峜峝峞峟峠峢峣峧峩峫峬峮峯峱峲峳峴峵島峷峸峹峺峼峽峾峿崀�崁崄崅崈崉崊崋崌崍崏崐崑崒崓崕崗崘崙崚崜崝崟崠崡崢崣崥崨崪崫崬崯崰崱崲崳崵崶崷崸崹崺崻崼崿嵀嵁嵂嵃嵄嵅嵆嵈嵉嵍嵎嵏嵐嵑嵒嵓嵔嵕嵖嵗嵙嵚嵜嵞嵟嵠嵡嵢嵣嵤嵥嵦嵧嵨嵪嵭嵮嵰嵱嵲嵳嵵嵶嵷嵸嵹嵺嵻嵼嵽嵾嵿嶀嶁嶃嶄嶅嶆嶇嶈嶉嶊嶋嶌嶍嶎嶏嶐嶑嶒嶓嶔嶕嶖嶗嶘嶚嶛嶜嶞嶟嶠�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "����������������������������������������������������������������嶡嶢嶣嶤嶥嶦嶧嶨嶩嶪嶫嶬嶭嶮嶯嶰嶱嶲嶳嶴嶵嶶嶸嶹嶺嶻嶼嶽嶾嶿巀巁巂巃巄巆巇巈巉巊巋巌巎巏巐巑巒巓巔巕巖巗巘巙巚巜巟巠巣巤巪巬巭�巰巵巶巸巹巺巻巼巿帀帄帇帉帊帋帍帎帒帓帗帞帟帠帡帢帣帤帥帨帩帪師帬帯帰帲帳帴帵帶帹帺帾帿幀幁幃幆幇幈幉幊幋幍幎幏幐幑幒幓幖幗幘幙幚幜幝幟幠幣幤幥幦幧幨幩幪幫幬幭幮幯幰幱幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨庩庪庫庬庮庯庰庱庲庴庺庻庼庽庿廀廁廂廃廄廅�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "����������������������������������������������������������������廆廇廈廋廌廍廎廏廐廔廕廗廘廙廚廜廝廞廟廠廡廢廣廤廥廦廧廩廫廬廭廮廯廰廱廲廳廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤�弨弫弬弮弰弲弳弴張弶強弸弻弽弾弿彁彂彃彄彅彆彇彈彉彊彋彌彍彎彏彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢徣徤徥徦徧復徫徬徯徰徱徲徳徴徶徸徹徺徻徾徿忀忁忂忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "����������������������������������������������������������������怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰怱怲怳怴怶怷怸怹怺怽怾恀恄恅恆恇恈恉恊恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀�悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽悾悿惀惁惂惃惄惇惈惉惌惍惎惏惐惒惓惔惖惗惙惛惞惡惢惣惤惥惪惱惲惵惷惸惻惼惽惾惿愂愃愄愅愇愊愋愌愐愑愒愓愔愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬愭愮愯愰愱愲愳愴愵愶愷愸愹愺愻愼愽愾慀慁慂慃慄慅慆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "����������������������������������������������������������������慇慉態慍慏慐慒慓慔慖慗慘慙慚慛慜慞慟慠慡慣慤慥慦慩慪慫慬慭慮慯慱慲慳慴慶慸慹慺慻慼慽慾慿憀憁憂憃憄憅憆憇憈憉憊憌憍憏憐憑憒憓憕�憖憗憘憙憚憛憜憞憟憠憡憢憣憤憥憦憪憫憭憮憯憰憱憲憳憴憵憶憸憹憺憻憼憽憿懀懁懃懄懅懆懇應懌懍懎懏懐懓懕懖懗懘懙懚懛懜懝懞懟懠懡懢懣懤懥懧懨懩懪懫懬懭懮懯懰懱懲懳懴懶懷懸懹懺懻懼懽懾戀戁戂戃戄戅戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸戹戺戻戼扂扄扅扆扊�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "����������������������������������������������������������������扏扐払扖扗扙扚扜扝扞扟扠扡扢扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋抌抍抎抏抐抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁�拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳挴挵挶挷挸挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖捗捘捙捚捛捜捝捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙掚掛掜掝掞掟採掤掦掫掯掱掲掵掶掹掻掽掿揀�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "����������������������������������������������������������������揁揂揃揅揇揈揊揋揌揑揓揔揕揗揘揙揚換揜揝揟揢揤揥揦揧揨揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆搇搈搉搊損搎搑搒搕搖搗搘搙搚搝搟搢搣搤�搥搧搨搩搫搮搯搰搱搲搳搵搶搷搸搹搻搼搾摀摂摃摉摋摌摍摎摏摐摑摓摕摖摗摙摚摛摜摝摟摠摡摢摣摤摥摦摨摪摫摬摮摯摰摱摲摳摴摵摶摷摻摼摽摾摿撀撁撃撆撈撉撊撋撌撍撎撏撐撓撔撗撘撚撛撜撝撟撠撡撢撣撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆擇擈擉擊擋擌擏擑擓擔擕擖擙據�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "����������������������������������������������������������������擛擜擝擟擠擡擣擥擧擨擩擪擫擬擭擮擯擰擱擲擳擴擵擶擷擸擹擺擻擼擽擾擿攁攂攃攄攅攆攇攈攊攋攌攍攎攏攐攑攓攔攕攖攗攙攚攛攜攝攞攟攠攡�攢攣攤攦攧攨攩攪攬攭攰攱攲攳攷攺攼攽敀敁敂敃敄敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數敹敺敻敼敽敾敿斀斁斂斃斄斅斆斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱斲斳斴斵斶斷斸斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘旙旚旛旜旝旞旟旡旣旤旪旫�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "����������������������������������������������������������������旲旳旴旵旸旹旻旼旽旾旿昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷昸昹昺昻昽昿晀時晄晅晆晇晈晉晊晍晎晐晑晘�晙晛晜晝晞晠晢晣晥晧晩晪晫晬晭晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘暙暚暛暜暞暟暠暡暢暣暤暥暦暩暪暫暬暭暯暰暱暲暳暵暶暷暸暺暻暼暽暿曀曁曂曃曄曅曆曇曈曉曊曋曌曍曎曏曐曑曒曓曔曕曖曗曘曚曞曟曠曡曢曣曤曥曧曨曪曫曬曭曮曯曱曵曶書曺曻曽朁朂會�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "����������������������������������������������������������������朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠朡朢朣朤朥朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗杘杙杚杛杝杢杣杤杦杧杫杬杮東杴杶�杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹枺枻枼枽枾枿柀柂柅柆柇柈柉柊柋柌柍柎柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵柶柷柸柹柺査柼柾栁栂栃栄栆栍栐栒栔栕栘栙栚栛栜栞栟栠栢栣栤栥栦栧栨栫栬栭栮栯栰栱栴栵栶栺栻栿桇桋桍桏桒桖桗桘桙桚桛�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "����������������������������������������������������������������桜桝桞桟桪桬桭桮桯桰桱桲桳桵桸桹桺桻桼桽桾桿梀梂梄梇梈梉梊梋梌梍梎梐梑梒梔梕梖梘梙梚梛梜條梞梟梠梡梣梤梥梩梪梫梬梮梱梲梴梶梷梸�梹梺梻梼梽梾梿棁棃棄棅棆棇棈棊棌棎棏棐棑棓棔棖棗棙棛棜棝棞棟棡棢棤棥棦棧棨棩棪棫棬棭棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆椇椈椉椊椌椏椑椓椔椕椖椗椘椙椚椛検椝椞椡椢椣椥椦椧椨椩椪椫椬椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃楄楅楆楇楈楉楊楋楌楍楎楏楐楑楒楓楕楖楘楙楛楜楟�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "����������������������������������������������������������������楡楢楤楥楧楨楩楪楬業楯楰楲楳楴極楶楺楻楽楾楿榁榃榅榊榋榌榎榏榐榑榒榓榖榗榙榚榝榞榟榠榡榢榣榤榥榦榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽�榾榿槀槂槃槄槅槆槇槈槉構槍槏槑槒槓槕槖槗様槙槚槜槝槞槡槢槣槤槥槦槧槨槩槪槫槬槮槯槰槱槳槴槵槶槷槸槹槺槻槼槾樀樁樂樃樄樅樆樇樈樉樋樌樍樎樏樐樑樒樓樔樕樖標樚樛樜樝樞樠樢樣樤樥樦樧権樫樬樭樮樰樲樳樴樶樷樸樹樺樻樼樿橀橁橂橃橅橆橈橉橊橋橌橍橎橏橑橒橓橔橕橖橗橚�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "����������������������������������������������������������������橜橝橞機橠橢橣橤橦橧橨橩橪橫橬橭橮橯橰橲橳橴橵橶橷橸橺橻橽橾橿檁檂檃檅檆檇檈檉檊檋檌檍檏檒檓檔檕檖檘檙檚檛檜檝檞檟檡檢檣檤檥檦�檧檨檪檭檮檯檰檱檲檳檴檵檶檷檸檹檺檻檼檽檾檿櫀櫁櫂櫃櫄櫅櫆櫇櫈櫉櫊櫋櫌櫍櫎櫏櫐櫑櫒櫓櫔櫕櫖櫗櫘櫙櫚櫛櫜櫝櫞櫟櫠櫡櫢櫣櫤櫥櫦櫧櫨櫩櫪櫫櫬櫭櫮櫯櫰櫱櫲櫳櫴櫵櫶櫷櫸櫹櫺櫻櫼櫽櫾櫿欀欁欂欃欄欅欆欇欈欉權欋欌欍欎欏欐欑欒欓欔欕欖欗欘欙欚欛欜欝欞欟欥欦欨欩欪欫欬欭欮�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "����������������������������������������������������������������欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍歎歏歐歑歒歓歔歕歖歗歘歚歛歜歝歞歟歠歡歨歩歫歬歭歮歯歰歱歲歳歴歵歶歷歸歺歽歾歿殀殅殈�殌殎殏殐殑殔殕殗殘殙殜殝殞殟殠殢殣殤殥殦殧殨殩殫殬殭殮殯殰殱殲殶殸殹殺殻殼殽殾毀毃毄毆毇毈毉毊毌毎毐毑毘毚毜毝毞毟毠毢毣毤毥毦毧毨毩毬毭毮毰毱毲毴毶毷毸毺毻毼毾毿氀氁氂氃氄氈氉氊氋氌氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋汌汍汎汏汑汒汓汖汘�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "����������������������������������������������������������������汙汚汢汣汥汦汧汫汬汭汮汯汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘�泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟洠洡洢洣洤洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽浾浿涀涁涃涄涆涇涊涋涍涏涐涒涖涗涘涙涚涜涢涥涬涭涰涱涳涴涶涷涹涺涻涼涽涾淁淂淃淈淉淊�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "����������������������������������������������������������������淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽淾淿渀渁渂渃渄渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵�渶渷渹渻渼渽渾渿湀湁湂湅湆湇湈湉湊湋湌湏湐湑湒湕湗湙湚湜湝湞湠湡湢湣湤湥湦湧湨湩湪湬湭湯湰湱湲湳湴湵湶湷湸湹湺湻湼湽満溁溂溄溇溈溊溋溌溍溎溑溒溓溔溕準溗溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪滫滬滭滮滯�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "����������������������������������������������������������������滰滱滲滳滵滶滷滸滺滻滼滽滾滿漀漁漃漄漅漇漈漊漋漌漍漎漐漑漒漖漗漘漙漚漛漜漝漞漟漡漢漣漥漦漧漨漬漮漰漲漴漵漷漸漹漺漻漼漽漿潀潁潂�潃潄潅潈潉潊潌潎潏潐潑潒潓潔潕潖潗潙潚潛潝潟潠潡潣潤潥潧潨潩潪潫潬潯潰潱潳潵潶潷潹潻潽潾潿澀澁澂澃澅澆澇澊澋澏澐澑澒澓澔澕澖澗澘澙澚澛澝澞澟澠澢澣澤澥澦澨澩澪澫澬澭澮澯澰澱澲澴澵澷澸澺澻澼澽澾澿濁濃濄濅濆濇濈濊濋濌濍濎濏濐濓濔濕濖濗濘濙濚濛濜濝濟濢濣濤濥�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "����������������������������������������������������������������濦濧濨濩濪濫濬濭濰濱濲濳濴濵濶濷濸濹濺濻濼濽濾濿瀀瀁瀂瀃瀄瀅瀆瀇瀈瀉瀊瀋瀌瀍瀎瀏瀐瀒瀓瀔瀕瀖瀗瀘瀙瀜瀝瀞瀟瀠瀡瀢瀤瀥瀦瀧瀨瀩瀪�瀫瀬瀭瀮瀯瀰瀱瀲瀳瀴瀶瀷瀸瀺瀻瀼瀽瀾瀿灀灁灂灃灄灅灆灇灈灉灊灋灍灎灐灑灒灓灔灕灖灗灘灙灚灛灜灝灟灠灡灢灣灤灥灦灧灨灩灪灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞炟炠炡炢炣炤炥炦炧炨炩炪炰炲炴炵炶為炾炿烄烅烆烇烉烋烌烍烎烏烐烑烒烓烔烕烖烗烚�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "����������������������������������������������������������������烜烝烞烠烡烢烣烥烪烮烰烱烲烳烴烵烶烸烺烻烼烾烿焀焁焂焃焄焅焆焇焈焋焌焍焎焏焑焒焔焗焛焜焝焞焟焠無焢焣焤焥焧焨焩焪焫焬焭焮焲焳焴�焵焷焸焹焺焻焼焽焾焿煀煁煂煃煄煆煇煈煉煋煍煏煐煑煒煓煔煕煖煗煘煙煚煛煝煟煠煡煢煣煥煩煪煫煬煭煯煰煱煴煵煶煷煹煻煼煾煿熀熁熂熃熅熆熇熈熉熋熌熍熎熐熑熒熓熕熖熗熚熛熜熝熞熡熢熣熤熥熦熧熩熪熫熭熮熯熰熱熲熴熶熷熸熺熻熼熽熾熿燀燁燂燄燅燆燇燈燉燊燋燌燍燏燐燑燒燓�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "����������������������������������������������������������������燖燗燘燙燚燛燜燝燞營燡燢燣燤燦燨燩燪燫燬燭燯燰燱燲燳燴燵燶燷燸燺燻燼燽燾燿爀爁爂爃爄爅爇爈爉爊爋爌爍爎爏爐爑爒爓爔爕爖爗爘爙爚�爛爜爞爟爠爡爢爣爤爥爦爧爩爫爭爮爯爲爳爴爺爼爾牀牁牂牃牄牅牆牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅犆犇犈犉犌犎犐犑犓犔犕犖犗犘犙犚犛犜犝犞犠犡犢犣犤犥犦犧犨犩犪犫犮犱犲犳犵犺犻犼犽犾犿狀狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������︵︶︹︺︿﹀︽︾﹁﹂﹃﹄��︻︼︷︸︱�︳︴����������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═║╒╓╔╕╖╗╘╙╚╛╜╝╞╟╠╡╢╣╤╥╦╧╨╩╪╫╬╭╮╯╰╱╲╳▁▂▃▄▅▆▇�█▉▊▋▌▍▎▏▓▔▕▼▽◢◣◤◥☉⊕〒〝〞�����������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ�ńň�ɡ����ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������〡〢〣〤〥〦〧〨〩㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤�℡㈱�‐���ー゛゜ヽヾ〆ゝゞ﹉﹊﹋﹌﹍﹎﹏﹐﹑﹒﹔﹕﹖﹗﹙﹚﹛﹜﹝﹞﹟﹠﹡�﹢﹣﹤﹥﹦﹨﹩﹪﹫�������������〇�������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������狜狝狟狢狣狤狥狦狧狪狫狵狶狹狽狾狿猀猂猄猅猆猇猈猉猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀獁獂獃獄獅獆獇獈�獉獊獋獌獎獏獑獓獔獕獖獘獙獚獛獜獝獞獟獡獢獣獤獥獦獧獨獩獪獫獮獰獱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������獲獳獴獵獶獷獸獹獺獻獼獽獿玀玁玂玃玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣玤玥玦玧玨玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃珄珅珆珇�珋珌珎珒珓珔珕珖珗珘珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳珴珵珶珷�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������珸珹珺珻珼珽現珿琀琁琂琄琇琈琋琌琍琎琑琒琓琔琕琖琗琘琙琜琝琞琟琠琡琣琤琧琩琫琭琯琱琲琷琸琹琺琻琽琾琿瑀瑂瑃瑄瑅瑆瑇瑈瑉瑊瑋瑌瑍�瑎瑏瑐瑑瑒瑓瑔瑖瑘瑝瑠瑡瑢瑣瑤瑥瑦瑧瑨瑩瑪瑫瑬瑮瑯瑱瑲瑳瑴瑵瑸瑹瑺�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑璒璓璔璕璖璗璘璙璚璛璝璟璠璡璢璣璤璥璦璪璫璬璭璮璯環璱璲璳璴璵璶璷璸璹璻璼璽璾璿瓀瓁瓂瓃瓄瓅瓆瓇�瓈瓉瓊瓋瓌瓍瓎瓏瓐瓑瓓瓔瓕瓖瓗瓘瓙瓚瓛瓝瓟瓡瓥瓧瓨瓩瓪瓫瓬瓭瓰瓱瓲�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������瓳瓵瓸瓹瓺瓻瓼瓽瓾甀甁甂甃甅甆甇甈甉甊甋甌甎甐甒甔甕甖甗甛甝甞甠甡產産甤甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘�畝畞畟畠畡畢畣畤畧畨畩畫畬畭畮畯異畱畳畵當畷畺畻畼畽畾疀疁疂疄疅疇�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦疧疨疩疪疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇�瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������癅癆癇癈癉癊癋癎癏癐癑癒癓癕癗癘癙癚癛癝癟癠癡癢癤癥癦癧癨癩癪癬癭癮癰癱癲癳癴癵癶癷癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛�皜皝皞皟皠皡皢皣皥皦皧皨皩皪皫皬皭皯皰皳皵皶皷皸皹皺皻皼皽皾盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������盄盇盉盋盌盓盕盙盚盜盝盞盠盡盢監盤盦盧盨盩盪盫盬盭盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎眏眐眑眒眓眔眕眖眗眘眛眜眝眞眡眣眤眥眧眪眫�眬眮眰眱眲眳眴眹眻眽眾眿睂睄睅睆睈睉睊睋睌睍睎睏睒睓睔睕睖睗睘睙睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������睝睞睟睠睤睧睩睪睭睮睯睰睱睲睳睴睵睶睷睸睺睻睼瞁瞂瞃瞆瞇瞈瞉瞊瞋瞏瞐瞓瞔瞕瞖瞗瞘瞙瞚瞛瞜瞝瞞瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶瞷瞸瞹瞺�瞼瞾矀矁矂矃矄矅矆矇矈矉矊矋矌矎矏矐矑矒矓矔矕矖矘矙矚矝矞矟矠矡矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃砄砅砆砇砈砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚�硛硜硞硟硠硡硢硣硤硥硦硧硨硩硯硰硱硲硳硴硵硶硸硹硺硻硽硾硿碀碁碂碃场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨碩碪碫碬碭碮碯碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚磛磜磝磞磟磠磡磢磣�磤磥磦磧磩磪磫磭磮磯磰磱磳磵磶磸磹磻磼磽磾磿礀礂礃礄礆礇礈礉礊礋礌础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������礍礎礏礐礑礒礔礕礖礗礘礙礚礛礜礝礟礠礡礢礣礥礦礧礨礩礪礫礬礭礮礯礰礱礲礳礵礶礷礸礹礽礿祂祃祄祅祇祊祋祌祍祎祏祐祑祒祔祕祘祙祡祣�祤祦祩祪祫祬祮祰祱祲祳祴祵祶祹祻祼祽祾祿禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������禓禔禕禖禗禘禙禛禜禝禞禟禠禡禢禣禤禥禦禨禩禪禫禬禭禮禯禰禱禲禴禵禶禷禸禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙秚秛秜秝秞秠秡秢秥秨秪�秬秮秱秲秳秴秵秶秷秹秺秼秾秿稁稄稅稇稈稉稊稌稏稐稑稒稓稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������稝稟稡稢稤稥稦稧稨稩稪稫稬稭種稯稰稱稲稴稵稶稸稺稾穀穁穂穃穄穅穇穈穉穊穋穌積穎穏穐穒穓穔穕穖穘穙穚穛穜穝穞穟穠穡穢穣穤穥穦穧穨�穩穪穫穬穭穮穯穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������窣窤窧窩窪窫窮窯窰窱窲窴窵窶窷窸窹窺窻窼窽窾竀竁竂竃竄竅竆竇竈竉竊竌竍竎竏竐竑竒竓竔竕竗竘竚竛竜竝竡竢竤竧竨竩竪竫竬竮竰竱竲竳�竴竵競竷竸竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������笯笰笲笴笵笶笷笹笻笽笿筀筁筂筃筄筆筈筊筍筎筓筕筗筙筜筞筟筡筣筤筥筦筧筨筩筪筫筬筭筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆箇箈箉箊箋箌箎箏�箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹箺箻箼箽箾箿節篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������篅篈築篊篋篍篎篏篐篒篔篕篖篗篘篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲篳篴篵篶篸篹篺篻篽篿簀簁簂簃簄簅簆簈簉簊簍簎簐簑簒簓簔簕簗簘簙�簚簛簜簝簞簠簡簢簣簤簥簨簩簫簬簭簮簯簰簱簲簳簴簵簶簷簹簺簻簼簽簾籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������籃籄籅籆籇籈籉籊籋籌籎籏籐籑籒籓籔籕籖籗籘籙籚籛籜籝籞籟籠籡籢籣籤籥籦籧籨籩籪籫籬籭籮籯籰籱籲籵籶籷籸籹籺籾籿粀粁粂粃粄粅粆粇�粈粊粋粌粍粎粏粐粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴粵粶粷粸粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������粿糀糂糃糄糆糉糋糎糏糐糑糒糓糔糘糚糛糝糞糡糢糣糤糥糦糧糩糪糫糬糭糮糰糱糲糳糴糵糶糷糹糺糼糽糾糿紀紁紂紃約紅紆紇紈紉紋紌納紎紏紐�紑紒紓純紕紖紗紘紙級紛紜紝紞紟紡紣紤紥紦紨紩紪紬紭紮細紱紲紳紴紵紶肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������紷紸紹紺紻紼紽紾紿絀絁終絃組絅絆絇絈絉絊絋経絍絎絏結絑絒絓絔絕絖絗絘絙絚絛絜絝絞絟絠絡絢絣絤絥給絧絨絩絪絫絬絭絯絰統絲絳絴絵絶�絸絹絺絻絼絽絾絿綀綁綂綃綄綅綆綇綈綉綊綋綌綍綎綏綐綑綒經綔綕綖綗綘健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������継続綛綜綝綞綟綠綡綢綣綤綥綧綨綩綪綫綬維綯綰綱網綳綴綵綶綷綸綹綺綻綼綽綾綿緀緁緂緃緄緅緆緇緈緉緊緋緌緍緎総緐緑緒緓緔緕緖緗緘緙�線緛緜緝緞緟締緡緢緣緤緥緦緧編緩緪緫緬緭緮緯緰緱緲緳練緵緶緷緸緹緺尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������緻緼緽緾緿縀縁縂縃縄縅縆縇縈縉縊縋縌縍縎縏縐縑縒縓縔縕縖縗縘縙縚縛縜縝縞縟縠縡縢縣縤縥縦縧縨縩縪縫縬縭縮縯縰縱縲縳縴縵縶縷縸縹�縺縼總績縿繀繂繃繄繅繆繈繉繊繋繌繍繎繏繐繑繒繓織繕繖繗繘繙繚繛繜繝俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������繞繟繠繡繢繣繤繥繦繧繨繩繪繫繬繭繮繯繰繱繲繳繴繵繶繷繸繹繺繻繼繽繾繿纀纁纃纄纅纆纇纈纉纊纋續纍纎纏纐纑纒纓纔纕纖纗纘纙纚纜纝纞�纮纴纻纼绖绤绬绹缊缐缞缷缹缻缼缽缾缿罀罁罃罆罇罈罉罊罋罌罍罎罏罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������罖罙罛罜罝罞罠罣罤罥罦罧罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂羃羄羅羆羇羈羉羋羍羏羐羑羒羓羕羖羗羘羙羛羜羠羢羣羥羦羨義羪羫羬羭羮羱�羳羴羵羶羷羺羻羾翀翂翃翄翆翇翈翉翋翍翏翐翑習翓翖翗翙翚翛翜翝翞翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������翤翧翨翪翫翬翭翯翲翴翵翶翷翸翹翺翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫耬耭耮耯耰耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗�聙聛聜聝聞聟聠聡聢聣聤聥聦聧聨聫聬聭聮聯聰聲聳聴聵聶職聸聹聺聻聼聽隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������聾肁肂肅肈肊肍肎肏肐肑肒肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇胈胉胊胋胏胐胑胒胓胔胕胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋�脌脕脗脙脛脜脝脟脠脡脢脣脤脥脦脧脨脩脪脫脭脮脰脳脴脵脷脹脺脻脼脽脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������腀腁腂腃腄腅腇腉腍腎腏腒腖腗腘腛腜腝腞腟腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃膄膅膆膇膉膋膌膍膎膐膒膓膔膕膖膗膙膚膞膟膠膡膢膤膥�膧膩膫膬膭膮膯膰膱膲膴膵膶膷膸膹膼膽膾膿臄臅臇臈臉臋臍臎臏臐臑臒臓摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������臔臕臖臗臘臙臚臛臜臝臞臟臠臡臢臤臥臦臨臩臫臮臯臰臱臲臵臶臷臸臹臺臽臿舃與興舉舊舋舎舏舑舓舕舖舗舘舙舚舝舠舤舥舦舧舩舮舲舺舼舽舿�艀艁艂艃艅艆艈艊艌艍艎艐艑艒艓艔艕艖艗艙艛艜艝艞艠艡艢艣艤艥艦艧艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸�苺苼苽苾苿茀茊茋茍茐茒茓茖茘茙茝茞茟茠茡茢茣茤茥茦茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "����������������������������������������������������������������茾茿荁荂荄荅荈荊荋荌荍荎荓荕荖荗荘荙荝荢荰荱荲荳荴荵荶荹荺荾荿莀莁莂莃莄莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡莢莣莤莥莦莧莬莭莮�莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "����������������������������������������������������������������菮華菳菴菵菶菷菺菻菼菾菿萀萂萅萇萈萉萊萐萒萓萔萕萖萗萙萚萛萞萟萠萡萢萣萩萪萫萬萭萮萯萰萲萳萴萵萶萷萹萺萻萾萿葀葁葂葃葄葅葇葈葉�葊葋葌葍葎葏葐葒葓葔葕葖葘葝葞葟葠葢葤葥葦葧葨葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "����������������������������������������������������������������葽葾葿蒀蒁蒃蒄蒅蒆蒊蒍蒏蒐蒑蒒蒓蒔蒕蒖蒘蒚蒛蒝蒞蒟蒠蒢蒣蒤蒥蒦蒧蒨蒩蒪蒫蒬蒭蒮蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗�蓘蓙蓚蓛蓜蓞蓡蓢蓤蓧蓨蓩蓪蓫蓭蓮蓯蓱蓲蓳蓴蓵蓶蓷蓸蓹蓺蓻蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������蔃蔄蔅蔆蔇蔈蔉蔊蔋蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢蔣蔤蔥蔦蔧蔨蔩蔪蔭蔮蔯蔰蔱蔲蔳蔴蔵蔶蔾蔿蕀蕁蕂蕄蕅蕆蕇蕋蕌蕍蕎蕏蕐蕑蕒蕓蕔蕕�蕗蕘蕚蕛蕜蕝蕟蕠蕡蕢蕣蕥蕦蕧蕩蕪蕫蕬蕭蕮蕯蕰蕱蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������薂薃薆薈薉薊薋薌薍薎薐薑薒薓薔薕薖薗薘薙薚薝薞薟薠薡薢薣薥薦薧薩薫薬薭薱薲薳薴薵薶薸薺薻薼薽薾薿藀藂藃藄藅藆藇藈藊藋藌藍藎藑藒�藔藖藗藘藙藚藛藝藞藟藠藡藢藣藥藦藧藨藪藫藬藭藮藯藰藱藲藳藴藵藶藷藸恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������藹藺藼藽藾蘀蘁蘂蘃蘄蘆蘇蘈蘉蘊蘋蘌蘍蘎蘏蘐蘒蘓蘔蘕蘗蘘蘙蘚蘛蘜蘝蘞蘟蘠蘡蘢蘣蘤蘥蘦蘨蘪蘫蘬蘭蘮蘯蘰蘱蘲蘳蘴蘵蘶蘷蘹蘺蘻蘽蘾蘿虀�虁虂虃虄虅虆虇虈虉虊虋虌虒虓處虖虗虘虙虛虜虝號虠虡虣虤虥虦虧虨虩虪獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������虭虯虰虲虳虴虵虶虷虸蚃蚄蚅蚆蚇蚈蚉蚎蚏蚐蚑蚒蚔蚖蚗蚘蚙蚚蚛蚞蚟蚠蚡蚢蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻蚼蚽蚾蚿蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜�蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀蝁蝂蝃蝄蝅蝆蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚蝛蝜蝝蝞蝟蝡蝢蝦蝧蝨蝩蝪蝫蝬蝭蝯蝱蝲蝳蝵�蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎螏螐螑螒螔螕螖螘螙螚螛螜螝螞螠螡螢螣螤巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁蟂蟃蟄蟅蟇蟈蟉蟌蟍蟎蟏蟐蟔蟕蟖蟗蟘蟙蟚蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯蟰蟱蟲蟳蟴蟵蟶蟷蟸�蟺蟻蟼蟽蟿蠀蠁蠂蠄蠅蠆蠇蠈蠉蠋蠌蠍蠎蠏蠐蠑蠒蠔蠗蠘蠙蠚蠜蠝蠞蠟蠠蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������蠤蠥蠦蠧蠨蠩蠪蠫蠬蠭蠮蠯蠰蠱蠳蠴蠵蠶蠷蠸蠺蠻蠽蠾蠿衁衂衃衆衇衈衉衊衋衎衏衐衑衒術衕衖衘衚衛衜衝衞衟衠衦衧衪衭衯衱衳衴衵衶衸衹衺�衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗袘袙袚袛袝袞袟袠袡袣袥袦袧袨袩袪小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������袬袮袯袰袲袳袴袵袶袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚裛補裝裞裠裡裦裧裩裪裫裬裭裮裯裲裵裶裷裺裻製裿褀褁褃褄褅褆複褈�褉褋褌褍褎褏褑褔褕褖褗褘褜褝褞褟褠褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������褸褹褺褻褼褽褾褿襀襂襃襅襆襇襈襉襊襋襌襍襎襏襐襑襒襓襔襕襖襗襘襙襚襛襜襝襠襡襢襣襤襥襧襨襩襪襫襬襭襮襯襰襱襲襳襴襵襶襷襸襹襺襼�襽襾覀覂覄覅覇覈覉覊見覌覍覎規覐覑覒覓覔覕視覗覘覙覚覛覜覝覞覟覠覡摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������覢覣覤覥覦覧覨覩親覫覬覭覮覯覰覱覲観覴覵覶覷覸覹覺覻覼覽覾覿觀觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴觵觶觷觸觹觺�觻觼觽觾觿訁訂訃訄訅訆計訉訊訋訌訍討訏訐訑訒訓訔訕訖託記訙訚訛訜訝印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������訞訟訠訡訢訣訤訥訦訧訨訩訪訫訬設訮訯訰許訲訳訴訵訶訷訸訹診註証訽訿詀詁詂詃詄詅詆詇詉詊詋詌詍詎詏詐詑詒詓詔評詖詗詘詙詚詛詜詝詞�詟詠詡詢詣詤詥試詧詨詩詪詫詬詭詮詯詰話該詳詴詵詶詷詸詺詻詼詽詾詿誀浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������誁誂誃誄誅誆誇誈誋誌認誎誏誐誑誒誔誕誖誗誘誙誚誛誜誝語誟誠誡誢誣誤誥誦誧誨誩說誫説読誮誯誰誱課誳誴誵誶誷誸誹誺誻誼誽誾調諀諁諂�諃諄諅諆談諈諉諊請諌諍諎諏諐諑諒諓諔諕論諗諘諙諚諛諜諝諞諟諠諡諢諣铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������諤諥諦諧諨諩諪諫諬諭諮諯諰諱諲諳諴諵諶諷諸諹諺諻諼諽諾諿謀謁謂謃謄謅謆謈謉謊謋謌謍謎謏謐謑謒謓謔謕謖謗謘謙謚講謜謝謞謟謠謡謢謣�謤謥謧謨謩謪謫謬謭謮謯謰謱謲謳謴謵謶謷謸謹謺謻謼謽謾謿譀譁譂譃譄譅帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������譆譇譈證譊譋譌譍譎譏譐譑譒譓譔譕譖譗識譙譚譛譜譝譞譟譠譡譢譣譤譥譧譨譩譪譫譭譮譯議譱譲譳譴譵譶護譸譹譺譻譼譽譾譿讀讁讂讃讄讅讆�讇讈讉變讋讌讍讎讏讐讑讒讓讔讕讖讗讘讙讚讛讜讝讞讟讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������谸谹谺谻谼谽谾谿豀豂豃豄豅豈豊豋豍豎豏豐豑豒豓豔豖豗豘豙豛豜豝豞豟豠豣豤豥豦豧豨豩豬豭豮豯豰豱豲豴豵豶豷豻豼豽豾豿貀貁貃貄貆貇�貈貋貍貎貏貐貑貒貓貕貖貗貙貚貛貜貝貞貟負財貢貣貤貥貦貧貨販貪貫責貭亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������貮貯貰貱貲貳貴貵貶買貸貹貺費貼貽貾貿賀賁賂賃賄賅賆資賈賉賊賋賌賍賎賏賐賑賒賓賔賕賖賗賘賙賚賛賜賝賞賟賠賡賢賣賤賥賦賧賨賩質賫賬�賭賮賯賰賱賲賳賴賵賶賷賸賹賺賻購賽賾賿贀贁贂贃贄贅贆贇贈贉贊贋贌贍佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������贎贏贐贑贒贓贔贕贖贗贘贙贚贛贜贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸赹赺赻赼赽赾赿趀趂趃趆趇趈趉趌趍趎趏趐趒趓趕趖趗趘趙趚趛趜趝趞趠趡�趢趤趥趦趧趨趩趪趫趬趭趮趯趰趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾跿踀踁踂踃踄踆踇踈踋踍踎踐踑踒踓踕踖踗踘踙踚踛踜踠踡踤踥踦踧踨踫踭踰踲踳踴踶踷踸踻踼踾�踿蹃蹅蹆蹌蹍蹎蹏蹐蹓蹔蹕蹖蹗蹘蹚蹛蹜蹝蹞蹟蹠蹡蹢蹣蹤蹥蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������蹳蹵蹷蹸蹹蹺蹻蹽蹾躀躂躃躄躆躈躉躊躋躌躍躎躑躒躓躕躖躗躘躙躚躛躝躟躠躡躢躣躤躥躦躧躨躩躪躭躮躰躱躳躴躵躶躷躸躹躻躼躽躾躿軀軁軂�軃軄軅軆軇軈軉車軋軌軍軏軐軑軒軓軔軕軖軗軘軙軚軛軜軝軞軟軠軡転軣軤堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������軥軦軧軨軩軪軫軬軭軮軯軰軱軲軳軴軵軶軷軸軹軺軻軼軽軾軿輀輁輂較輄輅輆輇輈載輊輋輌輍輎輏輐輑輒輓輔輕輖輗輘輙輚輛輜輝輞輟輠輡輢輣�輤輥輦輧輨輩輪輫輬輭輮輯輰輱輲輳輴輵輶輷輸輹輺輻輼輽輾輿轀轁轂轃轄荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������轅轆轇轈轉轊轋轌轍轎轏轐轑轒轓轔轕轖轗轘轙轚轛轜轝轞轟轠轡轢轣轤轥轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆�迉迊迋迌迍迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������這逜連逤逥逧逨逩逪逫逬逰週進逳逴逷逹逺逽逿遀遃遅遆遈遉遊運遌過達違遖遙遚遜遝遞遟遠遡遤遦遧適遪遫遬遯遰遱遲遳遶遷選遹遺遻遼遾邁�還邅邆邇邉邊邌邍邎邏邐邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅鄆鄇鄈鄉鄊鄋鄌鄍鄎鄏鄐鄑鄒鄓鄔鄕鄖鄗鄘鄚鄛鄜�鄝鄟鄠鄡鄤鄥鄦鄧鄨鄩鄪鄫鄬鄭鄮鄰鄲鄳鄴鄵鄶鄷鄸鄺鄻鄼鄽鄾鄿酀酁酂酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀醁醂醃醄醆醈醊醎醏醓醔醕醖醗醘醙醜醝醞醟醠醡醤醥醦醧醨醩醫醬醰醱醲醳醶醷醸醹醻�醼醽醾醿釀釁釂釃釄釅釆釈釋釐釒釓釔釕釖釗釘釙釚釛針釞釟釠釡釢釣釤釥帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������釦釧釨釩釪釫釬釭釮釯釰釱釲釳釴釵釶釷釸釹釺釻釼釽釾釿鈀鈁鈂鈃鈄鈅鈆鈇鈈鈉鈊鈋鈌鈍鈎鈏鈐鈑鈒鈓鈔鈕鈖鈗鈘鈙鈚鈛鈜鈝鈞鈟鈠鈡鈢鈣鈤�鈥鈦鈧鈨鈩鈪鈫鈬鈭鈮鈯鈰鈱鈲鈳鈴鈵鈶鈷鈸鈹鈺鈻鈼鈽鈾鈿鉀鉁鉂鉃鉄鉅狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������鉆鉇鉈鉉鉊鉋鉌鉍鉎鉏鉐鉑鉒鉓鉔鉕鉖鉗鉘鉙鉚鉛鉜鉝鉞鉟鉠鉡鉢鉣鉤鉥鉦鉧鉨鉩鉪鉫鉬鉭鉮鉯鉰鉱鉲鉳鉵鉶鉷鉸鉹鉺鉻鉼鉽鉾鉿銀銁銂銃銄銅�銆銇銈銉銊銋銌銍銏銐銑銒銓銔銕銖銗銘銙銚銛銜銝銞銟銠銡銢銣銤銥銦銧恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������銨銩銪銫銬銭銯銰銱銲銳銴銵銶銷銸銹銺銻銼銽銾銿鋀鋁鋂鋃鋄鋅鋆鋇鋉鋊鋋鋌鋍鋎鋏鋐鋑鋒鋓鋔鋕鋖鋗鋘鋙鋚鋛鋜鋝鋞鋟鋠鋡鋢鋣鋤鋥鋦鋧鋨�鋩鋪鋫鋬鋭鋮鋯鋰鋱鋲鋳鋴鋵鋶鋷鋸鋹鋺鋻鋼鋽鋾鋿錀錁錂錃錄錅錆錇錈錉洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������錊錋錌錍錎錏錐錑錒錓錔錕錖錗錘錙錚錛錜錝錞錟錠錡錢錣錤錥錦錧錨錩錪錫錬錭錮錯錰錱録錳錴錵錶錷錸錹錺錻錼錽錿鍀鍁鍂鍃鍄鍅鍆鍇鍈鍉�鍊鍋鍌鍍鍎鍏鍐鍑鍒鍓鍔鍕鍖鍗鍘鍙鍚鍛鍜鍝鍞鍟鍠鍡鍢鍣鍤鍥鍦鍧鍨鍩鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������鍬鍭鍮鍯鍰鍱鍲鍳鍴鍵鍶鍷鍸鍹鍺鍻鍼鍽鍾鍿鎀鎁鎂鎃鎄鎅鎆鎇鎈鎉鎊鎋鎌鎍鎎鎐鎑鎒鎓鎔鎕鎖鎗鎘鎙鎚鎛鎜鎝鎞鎟鎠鎡鎢鎣鎤鎥鎦鎧鎨鎩鎪鎫�鎬鎭鎮鎯鎰鎱鎲鎳鎴鎵鎶鎷鎸鎹鎺鎻鎼鎽鎾鎿鏀鏁鏂鏃鏄鏅鏆鏇鏈鏉鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������鏎鏏鏐鏑鏒鏓鏔鏕鏗鏘鏙鏚鏛鏜鏝鏞鏟鏠鏡鏢鏣鏤鏥鏦鏧鏨鏩鏪鏫鏬鏭鏮鏯鏰鏱鏲鏳鏴鏵鏶鏷鏸鏹鏺鏻鏼鏽鏾鏿鐀鐁鐂鐃鐄鐅鐆鐇鐈鐉鐊鐋鐌鐍�鐎鐏鐐鐑鐒鐓鐔鐕鐖鐗鐘鐙鐚鐛鐜鐝鐞鐟鐠鐡鐢鐣鐤鐥鐦鐧鐨鐩鐪鐫鐬鐭鐮纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������鐯鐰鐱鐲鐳鐴鐵鐶鐷鐸鐹鐺鐻鐼鐽鐿鑀鑁鑂鑃鑄鑅鑆鑇鑈鑉鑊鑋鑌鑍鑎鑏鑐鑑鑒鑓鑔鑕鑖鑗鑘鑙鑚鑛鑜鑝鑞鑟鑠鑡鑢鑣鑤鑥鑦鑧鑨鑩鑪鑬鑭鑮鑯�鑰鑱鑲鑳鑴鑵鑶鑷鑸鑹鑺鑻鑼鑽鑾鑿钀钁钂钃钄钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������锧锳锽镃镈镋镕镚镠镮镴镵長镸镹镺镻镼镽镾門閁閂閃閄閅閆閇閈閉閊開閌閍閎閏閐閑閒間閔閕閖閗閘閙閚閛閜閝閞閟閠閡関閣閤閥閦閧閨閩閪�閫閬閭閮閯閰閱閲閳閴閵閶閷閸閹閺閻閼閽閾閿闀闁闂闃闄闅闆闇闈闉闊闋椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������闌闍闎闏闐闑闒闓闔闕闖闗闘闙闚闛關闝闞闟闠闡闢闣闤闥闦闧闬闿阇阓阘阛阞阠阣阤阥阦阧阨阩阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗�陘陙陚陜陝陞陠陣陥陦陫陭陮陯陰陱陳陸陹険陻陼陽陾陿隀隁隂隃隄隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������隌階隑隒隓隕隖隚際隝隞隟隠隡隢隣隤隥隦隨隩險隫隬隭隮隯隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖雗雘雙雚雛雜雝雞雟雡離難雤雥雦雧雫�雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗霘霙霚霛霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������霡霢霣霤霥霦霧霨霩霫霬霮霯霱霳霴霵霶霷霺霻霼霽霿靀靁靂靃靄靅靆靇靈靉靊靋靌靍靎靏靐靑靔靕靗靘靚靜靝靟靣靤靦靧靨靪靫靬靭靮靯靰靱�靲靵靷靸靹靺靻靽靾靿鞀鞁鞂鞃鞄鞆鞇鞈鞉鞊鞌鞎鞏鞐鞓鞕鞖鞗鞙鞚鞛鞜鞝臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������鞞鞟鞡鞢鞤鞥鞦鞧鞨鞩鞪鞬鞮鞰鞱鞳鞵鞶鞷鞸鞹鞺鞻鞼鞽鞾鞿韀韁韂韃韄韅韆韇韈韉韊韋韌韍韎韏韐韑韒韓韔韕韖韗韘韙韚韛韜韝韞韟韠韡韢韣�韤韥韨韮韯韰韱韲韴韷韸韹韺韻韼韽韾響頀頁頂頃頄項順頇須頉頊頋頌頍頎怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������頏預頑頒頓頔頕頖頗領頙頚頛頜頝頞頟頠頡頢頣頤頥頦頧頨頩頪頫頬頭頮頯頰頱頲頳頴頵頶頷頸頹頺頻頼頽頾頿顀顁顂顃顄顅顆顇顈顉顊顋題額�顎顏顐顑顒顓顔顕顖顗願顙顚顛顜顝類顟顠顡顢顣顤顥顦顧顨顩顪顫顬顭顮睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������顯顰顱顲顳顴颋颎颒颕颙颣風颩颪颫颬颭颮颯颰颱颲颳颴颵颶颷颸颹颺颻颼颽颾颿飀飁飂飃飄飅飆飇飈飉飊飋飌飍飏飐飔飖飗飛飜飝飠飡飢飣飤�飥飦飩飪飫飬飭飮飯飰飱飲飳飴飵飶飷飸飹飺飻飼飽飾飿餀餁餂餃餄餅餆餇铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������餈餉養餋餌餎餏餑餒餓餔餕餖餗餘餙餚餛餜餝餞餟餠餡餢餣餤餥餦餧館餩餪餫餬餭餯餰餱餲餳餴餵餶餷餸餹餺餻餼餽餾餿饀饁饂饃饄饅饆饇饈饉�饊饋饌饍饎饏饐饑饒饓饖饗饘饙饚饛饜饝饞饟饠饡饢饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������馌馎馚馛馜馝馞馟馠馡馢馣馤馦馧馩馪馫馬馭馮馯馰馱馲馳馴馵馶馷馸馹馺馻馼馽馾馿駀駁駂駃駄駅駆駇駈駉駊駋駌駍駎駏駐駑駒駓駔駕駖駗駘�駙駚駛駜駝駞駟駠駡駢駣駤駥駦駧駨駩駪駫駬駭駮駯駰駱駲駳駴駵駶駷駸駹瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������駺駻駼駽駾駿騀騁騂騃騄騅騆騇騈騉騊騋騌騍騎騏騐騑騒験騔騕騖騗騘騙騚騛騜騝騞騟騠騡騢騣騤騥騦騧騨騩騪騫騬騭騮騯騰騱騲騳騴騵騶騷騸�騹騺騻騼騽騾騿驀驁驂驃驄驅驆驇驈驉驊驋驌驍驎驏驐驑驒驓驔驕驖驗驘驙颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������驚驛驜驝驞驟驠驡驢驣驤驥驦驧驨驩驪驫驲骃骉骍骎骔骕骙骦骩骪骫骬骭骮骯骲骳骴骵骹骻骽骾骿髃髄髆髇髈髉髊髍髎髏髐髒體髕髖髗髙髚髛髜�髝髞髠髢髣髤髥髧髨髩髪髬髮髰髱髲髳髴髵髶髷髸髺髼髽髾髿鬀鬁鬂鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������鬇鬉鬊鬋鬌鬍鬎鬐鬑鬒鬔鬕鬖鬗鬘鬙鬚鬛鬜鬝鬞鬠鬡鬢鬤鬥鬦鬧鬨鬩鬪鬫鬬鬭鬮鬰鬱鬳鬴鬵鬶鬷鬸鬹鬺鬽鬾鬿魀魆魊魋魌魎魐魒魓魕魖魗魘魙魚�魛魜魝魞魟魠魡魢魣魤魥魦魧魨魩魪魫魬魭魮魯魰魱魲魳魴魵魶魷魸魹魺魻簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������魼魽魾魿鮀鮁鮂鮃鮄鮅鮆鮇鮈鮉鮊鮋鮌鮍鮎鮏鮐鮑鮒鮓鮔鮕鮖鮗鮘鮙鮚鮛鮜鮝鮞鮟鮠鮡鮢鮣鮤鮥鮦鮧鮨鮩鮪鮫鮬鮭鮮鮯鮰鮱鮲鮳鮴鮵鮶鮷鮸鮹鮺�鮻鮼鮽鮾鮿鯀鯁鯂鯃鯄鯅鯆鯇鯈鯉鯊鯋鯌鯍鯎鯏鯐鯑鯒鯓鯔鯕鯖鯗鯘鯙鯚鯛酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������鯜鯝鯞鯟鯠鯡鯢鯣鯤鯥鯦鯧鯨鯩鯪鯫鯬鯭鯮鯯鯰鯱鯲鯳鯴鯵鯶鯷鯸鯹鯺鯻鯼鯽鯾鯿鰀鰁鰂鰃鰄鰅鰆鰇鰈鰉鰊鰋鰌鰍鰎鰏鰐鰑鰒鰓鰔鰕鰖鰗鰘鰙鰚�鰛鰜鰝鰞鰟鰠鰡鰢鰣鰤鰥鰦鰧鰨鰩鰪鰫鰬鰭鰮鰯鰰鰱鰲鰳鰴鰵鰶鰷鰸鰹鰺鰻觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������鰼鰽鰾鰿鱀鱁鱂鱃鱄鱅鱆鱇鱈鱉鱊鱋鱌鱍鱎鱏鱐鱑鱒鱓鱔鱕鱖鱗鱘鱙鱚鱛鱜鱝鱞鱟鱠鱡鱢鱣鱤鱥鱦鱧鱨鱩鱪鱫鱬鱭鱮鱯鱰鱱鱲鱳鱴鱵鱶鱷鱸鱹鱺�鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾鲿鳀鳁鳂鳈鳉鳑鳒鳚鳛鳠鳡鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������鳣鳤鳥鳦鳧鳨鳩鳪鳫鳬鳭鳮鳯鳰鳱鳲鳳鳴鳵鳶鳷鳸鳹鳺鳻鳼鳽鳾鳿鴀鴁鴂鴃鴄鴅鴆鴇鴈鴉鴊鴋鴌鴍鴎鴏鴐鴑鴒鴓鴔鴕鴖鴗鴘鴙鴚鴛鴜鴝鴞鴟鴠鴡�鴢鴣鴤鴥鴦鴧鴨鴩鴪鴫鴬鴭鴮鴯鴰鴱鴲鴳鴴鴵鴶鴷鴸鴹鴺鴻鴼鴽鴾鴿鵀鵁鵂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������鵃鵄鵅鵆鵇鵈鵉鵊鵋鵌鵍鵎鵏鵐鵑鵒鵓鵔鵕鵖鵗鵘鵙鵚鵛鵜鵝鵞鵟鵠鵡鵢鵣鵤鵥鵦鵧鵨鵩鵪鵫鵬鵭鵮鵯鵰鵱鵲鵳鵴鵵鵶鵷鵸鵹鵺鵻鵼鵽鵾鵿鶀鶁�鶂鶃鶄鶅鶆鶇鶈鶉鶊鶋鶌鶍鶎鶏鶐鶑鶒鶓鶔鶕鶖鶗鶘鶙鶚鶛鶜鶝鶞鶟鶠鶡鶢�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "����������������������������������������������������������������鶣鶤鶥鶦鶧鶨鶩鶪鶫鶬鶭鶮鶯鶰鶱鶲鶳鶴鶵鶶鶷鶸鶹鶺鶻鶼鶽鶾鶿鷀鷁鷂鷃鷄鷅鷆鷇鷈鷉鷊鷋鷌鷍鷎鷏鷐鷑鷒鷓鷔鷕鷖鷗鷘鷙鷚鷛鷜鷝鷞鷟鷠鷡�鷢鷣鷤鷥鷦鷧鷨鷩鷪鷫鷬鷭鷮鷯鷰鷱鷲鷳鷴鷵鷶鷷鷸鷹鷺鷻鷼鷽鷾鷿鸀鸁鸂�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "����������������������������������������������������������������鸃鸄鸅鸆鸇鸈鸉鸊鸋鸌鸍鸎鸏鸐鸑鸒鸓鸔鸕鸖鸗鸘鸙鸚鸛鸜鸝鸞鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴鹵鹶鹷鹸鹹鹺鹻鹼鹽麀�麁麃麄麅麆麉麊麌麍麎麏麐麑麔麕麖麗麘麙麚麛麜麞麠麡麢麣麤麥麧麨麩麪�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "����������������������������������������������������������������麫麬麭麮麯麰麱麲麳麵麶麷麹麺麼麿黀黁黂黃黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰黱黲黳黴黵黶黷黸黺黽黿鼀鼁鼂鼃鼄鼅�鼆鼇鼈鼉鼊鼌鼏鼑鼒鼔鼕鼖鼘鼚鼛鼜鼝鼞鼟鼡鼣鼤鼥鼦鼧鼨鼩鼪鼫鼭鼮鼰鼱�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "����������������������������������������������������������������鼲鼳鼴鼵鼶鼸鼺鼼鼿齀齁齂齃齅齆齇齈齉齊齋齌齍齎齏齒齓齔齕齖齗齘齙齚齛齜齝齞齟齠齡齢齣齤齥齦齧齨齩齪齫齬齭齮齯齰齱齲齳齴齵齶齷齸�齹齺齻齼齽齾龁龂龍龎龏龐龑龒龓龔龕龖龗龘龜龝龞龡龢龣龤龥郎凉秊裏隣�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	D[254] = "����������������������������������������������������������������兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩��������������������������������������������������������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[254].length; ++j) if(D[254][j].charCodeAt(0) !== 0xFFFD) { e[D[254][j]] = 65024 + j; d[65024 + j] = D[254][j];}
	return {"enc": e, "dec": d }; })();
	cptable[949] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[129] = "�����������������������������������������������������������������갂갃갅갆갋갌갍갎갏갘갞갟갡갢갣갥갦갧갨갩갪갫갮갲갳갴������갵갶갷갺갻갽갾갿걁걂걃걄걅걆걇걈걉걊걌걎걏걐걑걒걓걕������걖걗걙걚걛걝걞걟걠걡걢걣걤걥걦걧걨걩걪걫걬걭걮걯걲걳걵걶걹걻걼걽걾걿겂겇겈겍겎겏겑겒겓겕겖겗겘겙겚겛겞겢겣겤겥겦겧겫겭겮겱겲겳겴겵겶겷겺겾겿곀곂곃곅곆곇곉곊곋곍곎곏곐곑곒곓곔곖곘곙곚곛곜곝곞곟곢곣곥곦곩곫곭곮곲곴곷곸곹곺곻곾곿괁괂괃괅괇괈괉괊괋괎괐괒괓�".split("");
	for(j = 0; j != D[129].length; ++j) if(D[129][j].charCodeAt(0) !== 0xFFFD) { e[D[129][j]] = 33024 + j; d[33024 + j] = D[129][j];}
	D[130] = "�����������������������������������������������������������������괔괕괖괗괙괚괛괝괞괟괡괢괣괤괥괦괧괨괪괫괮괯괰괱괲괳������괶괷괹괺괻괽괾괿굀굁굂굃굆굈굊굋굌굍굎굏굑굒굓굕굖굗������굙굚굛굜굝굞굟굠굢굤굥굦굧굨굩굪굫굮굯굱굲굷굸굹굺굾궀궃궄궅궆궇궊궋궍궎궏궑궒궓궔궕궖궗궘궙궚궛궞궟궠궡궢궣궥궦궧궨궩궪궫궬궭궮궯궰궱궲궳궴궵궶궸궹궺궻궼궽궾궿귂귃귅귆귇귉귊귋귌귍귎귏귒귔귕귖귗귘귙귚귛귝귞귟귡귢귣귥귦귧귨귩귪귫귬귭귮귯귰귱귲귳귴귵귶귷�".split("");
	for(j = 0; j != D[130].length; ++j) if(D[130][j].charCodeAt(0) !== 0xFFFD) { e[D[130][j]] = 33280 + j; d[33280 + j] = D[130][j];}
	D[131] = "�����������������������������������������������������������������귺귻귽귾긂긃긄긅긆긇긊긌긎긏긐긑긒긓긕긖긗긘긙긚긛긜������긝긞긟긠긡긢긣긤긥긦긧긨긩긪긫긬긭긮긯긲긳긵긶긹긻긼������긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗깘깙깚깛깞깢깣깤깦깧깪깫깭깮깯깱깲깳깴깵깶깷깺깾깿꺀꺁꺂꺃꺆꺇꺈꺉꺊꺋꺍꺎꺏꺐꺑꺒꺓꺔꺕꺖꺗꺘꺙꺚꺛꺜꺝꺞꺟꺠꺡꺢꺣꺤꺥꺦꺧꺨꺩꺪꺫꺬꺭꺮꺯꺰꺱꺲꺳꺴꺵꺶꺷꺸꺹꺺꺻꺿껁껂껃껅껆껇껈껉껊껋껎껒껓껔껕껖껗껚껛껝껞껟껠껡껢껣껤껥�".split("");
	for(j = 0; j != D[131].length; ++j) if(D[131][j].charCodeAt(0) !== 0xFFFD) { e[D[131][j]] = 33536 + j; d[33536 + j] = D[131][j];}
	D[132] = "�����������������������������������������������������������������껦껧껩껪껬껮껯껰껱껲껳껵껶껷껹껺껻껽껾껿꼀꼁꼂꼃꼄꼅������꼆꼉꼊꼋꼌꼎꼏꼑꼒꼓꼔꼕꼖꼗꼘꼙꼚꼛꼜꼝꼞꼟꼠꼡꼢꼣������꼤꼥꼦꼧꼨꼩꼪꼫꼮꼯꼱꼳꼵꼶꼷꼸꼹꼺꼻꼾꽀꽄꽅꽆꽇꽊꽋꽌꽍꽎꽏꽑꽒꽓꽔꽕꽖꽗꽘꽙꽚꽛꽞꽟꽠꽡꽢꽣꽦꽧꽨꽩꽪꽫꽬꽭꽮꽯꽰꽱꽲꽳꽴꽵꽶꽷꽸꽺꽻꽼꽽꽾꽿꾁꾂꾃꾅꾆꾇꾉꾊꾋꾌꾍꾎꾏꾒꾓꾔꾖꾗꾘꾙꾚꾛꾝꾞꾟꾠꾡꾢꾣꾤꾥꾦꾧꾨꾩꾪꾫꾬꾭꾮꾯꾰꾱꾲꾳꾴꾵꾶꾷꾺꾻꾽꾾�".split("");
	for(j = 0; j != D[132].length; ++j) if(D[132][j].charCodeAt(0) !== 0xFFFD) { e[D[132][j]] = 33792 + j; d[33792 + j] = D[132][j];}
	D[133] = "�����������������������������������������������������������������꾿꿁꿂꿃꿄꿅꿆꿊꿌꿏꿐꿑꿒꿓꿕꿖꿗꿘꿙꿚꿛꿝꿞꿟꿠꿡������꿢꿣꿤꿥꿦꿧꿪꿫꿬꿭꿮꿯꿲꿳꿵꿶꿷꿹꿺꿻꿼꿽꿾꿿뀂뀃������뀅뀆뀇뀈뀉뀊뀋뀍뀎뀏뀑뀒뀓뀕뀖뀗뀘뀙뀚뀛뀞뀟뀠뀡뀢뀣뀤뀥뀦뀧뀩뀪뀫뀬뀭뀮뀯뀰뀱뀲뀳뀴뀵뀶뀷뀸뀹뀺뀻뀼뀽뀾뀿끀끁끂끃끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞끟끠끡끢끣끤끥끦끧끨끩끪끫끬끭끮끯끰끱끲끳끴끵끶끷끸끹끺끻끾끿낁낂낃낅낆낇낈낉낊낋낎낐낒낓낔낕낖낗낛낝낞낣낤�".split("");
	for(j = 0; j != D[133].length; ++j) if(D[133][j].charCodeAt(0) !== 0xFFFD) { e[D[133][j]] = 34048 + j; d[34048 + j] = D[133][j];}
	D[134] = "�����������������������������������������������������������������낥낦낧낪낰낲낶낷낹낺낻낽낾낿냀냁냂냃냆냊냋냌냍냎냏냒������냓냕냖냗냙냚냛냜냝냞냟냡냢냣냤냦냧냨냩냪냫냬냭냮냯냰������냱냲냳냴냵냶냷냸냹냺냻냼냽냾냿넀넁넂넃넄넅넆넇넊넍넎넏넑넔넕넖넗넚넞넟넠넡넢넦넧넩넪넫넭넮넯넰넱넲넳넶넺넻넼넽넾넿녂녃녅녆녇녉녊녋녌녍녎녏녒녓녖녗녙녚녛녝녞녟녡녢녣녤녥녦녧녨녩녪녫녬녭녮녯녰녱녲녳녴녵녶녷녺녻녽녾녿놁놃놄놅놆놇놊놌놎놏놐놑놕놖놗놙놚놛놝�".split("");
	for(j = 0; j != D[134].length; ++j) if(D[134][j].charCodeAt(0) !== 0xFFFD) { e[D[134][j]] = 34304 + j; d[34304 + j] = D[134][j];}
	D[135] = "�����������������������������������������������������������������놞놟놠놡놢놣놤놥놦놧놩놪놫놬놭놮놯놰놱놲놳놴놵놶놷놸������놹놺놻놼놽놾놿뇀뇁뇂뇃뇄뇅뇆뇇뇈뇉뇊뇋뇍뇎뇏뇑뇒뇓뇕������뇖뇗뇘뇙뇚뇛뇞뇠뇡뇢뇣뇤뇥뇦뇧뇪뇫뇭뇮뇯뇱뇲뇳뇴뇵뇶뇷뇸뇺뇼뇾뇿눀눁눂눃눆눇눉눊눍눎눏눐눑눒눓눖눘눚눛눜눝눞눟눡눢눣눤눥눦눧눨눩눪눫눬눭눮눯눰눱눲눳눵눶눷눸눹눺눻눽눾눿뉀뉁뉂뉃뉄뉅뉆뉇뉈뉉뉊뉋뉌뉍뉎뉏뉐뉑뉒뉓뉔뉕뉖뉗뉙뉚뉛뉝뉞뉟뉡뉢뉣뉤뉥뉦뉧뉪뉫뉬뉭뉮�".split("");
	for(j = 0; j != D[135].length; ++j) if(D[135][j].charCodeAt(0) !== 0xFFFD) { e[D[135][j]] = 34560 + j; d[34560 + j] = D[135][j];}
	D[136] = "�����������������������������������������������������������������뉯뉰뉱뉲뉳뉶뉷뉸뉹뉺뉻뉽뉾뉿늀늁늂늃늆늇늈늊늋늌늍늎������늏늒늓늕늖늗늛늜늝늞늟늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷������늸늹늺늻늼늽늾늿닀닁닂닃닄닅닆닇닊닋닍닎닏닑닓닔닕닖닗닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉댊댋댌댍댎댏댒댖댗댘댙댚댛댝댞댟댠댡댢댣댤댥댦댧댨댩댪댫댬댭댮댯댰댱댲댳댴댵댶댷댸댹댺댻댼댽댾댿덀덁덂덃덄덅덆덇덈덉덊덋덌덍덎덏덐덑덒덓덗덙덚덝덠덡덢덣�".split("");
	for(j = 0; j != D[136].length; ++j) if(D[136][j].charCodeAt(0) !== 0xFFFD) { e[D[136][j]] = 34816 + j; d[34816 + j] = D[136][j];}
	D[137] = "�����������������������������������������������������������������덦덨덪덬덭덯덲덳덵덶덷덹덺덻덼덽덾덿뎂뎆뎇뎈뎉뎊뎋뎍������뎎뎏뎑뎒뎓뎕뎖뎗뎘뎙뎚뎛뎜뎝뎞뎟뎢뎣뎤뎥뎦뎧뎩뎪뎫뎭������뎮뎯뎰뎱뎲뎳뎴뎵뎶뎷뎸뎹뎺뎻뎼뎽뎾뎿돀돁돂돃돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩돪돫돬돭돮돯돰돱돲돳돴돵돶돷돸돹돺돻돽돾돿됀됁됂됃됄됅됆됇됈됉됊됋됌됍됎됏됑됒됓됔됕됖됗됙됚됛됝됞됟됡됢됣됤됥됦됧됪됬됭됮됯됰됱됲됳됵됶됷됸됹됺됻됼됽됾됿둀둁둂둃둄�".split("");
	for(j = 0; j != D[137].length; ++j) if(D[137][j].charCodeAt(0) !== 0xFFFD) { e[D[137][j]] = 35072 + j; d[35072 + j] = D[137][j];}
	D[138] = "�����������������������������������������������������������������둅둆둇둈둉둊둋둌둍둎둏둒둓둕둖둗둙둚둛둜둝둞둟둢둤둦������둧둨둩둪둫둭둮둯둰둱둲둳둴둵둶둷둸둹둺둻둼둽둾둿뒁뒂������뒃뒄뒅뒆뒇뒉뒊뒋뒌뒍뒎뒏뒐뒑뒒뒓뒔뒕뒖뒗뒘뒙뒚뒛뒜뒞뒟뒠뒡뒢뒣뒥뒦뒧뒩뒪뒫뒭뒮뒯뒰뒱뒲뒳뒴뒶뒸뒺뒻뒼뒽뒾뒿듁듂듃듅듆듇듉듊듋듌듍듎듏듑듒듓듔듖듗듘듙듚듛듞듟듡듢듥듧듨듩듪듫듮듰듲듳듴듵듶듷듹듺듻듼듽듾듿딀딁딂딃딄딅딆딇딈딉딊딋딌딍딎딏딐딑딒딓딖딗딙딚딝�".split("");
	for(j = 0; j != D[138].length; ++j) if(D[138][j].charCodeAt(0) !== 0xFFFD) { e[D[138][j]] = 35328 + j; d[35328 + j] = D[138][j];}
	D[139] = "�����������������������������������������������������������������딞딟딠딡딢딣딦딫딬딭딮딯딲딳딵딶딷딹딺딻딼딽딾딿땂땆������땇땈땉땊땎땏땑땒땓땕땖땗땘땙땚땛땞땢땣땤땥땦땧땨땩땪������땫땬땭땮땯땰땱땲땳땴땵땶땷땸땹땺땻땼땽땾땿떀떁떂떃떄떅떆떇떈떉떊떋떌떍떎떏떐떑떒떓떔떕떖떗떘떙떚떛떜떝떞떟떢떣떥떦떧떩떬떭떮떯떲떶떷떸떹떺떾떿뗁뗂뗃뗅뗆뗇뗈뗉뗊뗋뗎뗒뗓뗔뗕뗖뗗뗙뗚뗛뗜뗝뗞뗟뗠뗡뗢뗣뗤뗥뗦뗧뗨뗩뗪뗫뗭뗮뗯뗰뗱뗲뗳뗴뗵뗶뗷뗸뗹뗺뗻뗼뗽뗾뗿�".split("");
	for(j = 0; j != D[139].length; ++j) if(D[139][j].charCodeAt(0) !== 0xFFFD) { e[D[139][j]] = 35584 + j; d[35584 + j] = D[139][j];}
	D[140] = "�����������������������������������������������������������������똀똁똂똃똄똅똆똇똈똉똊똋똌똍똎똏똒똓똕똖똗똙똚똛똜똝������똞똟똠똡똢똣똤똦똧똨똩똪똫똭똮똯똰똱똲똳똵똶똷똸똹똺������똻똼똽똾똿뙀뙁뙂뙃뙄뙅뙆뙇뙉뙊뙋뙌뙍뙎뙏뙐뙑뙒뙓뙔뙕뙖뙗뙘뙙뙚뙛뙜뙝뙞뙟뙠뙡뙢뙣뙥뙦뙧뙩뙪뙫뙬뙭뙮뙯뙰뙱뙲뙳뙴뙵뙶뙷뙸뙹뙺뙻뙼뙽뙾뙿뚀뚁뚂뚃뚄뚅뚆뚇뚈뚉뚊뚋뚌뚍뚎뚏뚐뚑뚒뚓뚔뚕뚖뚗뚘뚙뚚뚛뚞뚟뚡뚢뚣뚥뚦뚧뚨뚩뚪뚭뚮뚯뚰뚲뚳뚴뚵뚶뚷뚸뚹뚺뚻뚼뚽뚾뚿뛀뛁뛂�".split("");
	for(j = 0; j != D[140].length; ++j) if(D[140][j].charCodeAt(0) !== 0xFFFD) { e[D[140][j]] = 35840 + j; d[35840 + j] = D[140][j];}
	D[141] = "�����������������������������������������������������������������뛃뛄뛅뛆뛇뛈뛉뛊뛋뛌뛍뛎뛏뛐뛑뛒뛓뛕뛖뛗뛘뛙뛚뛛뛜뛝������뛞뛟뛠뛡뛢뛣뛤뛥뛦뛧뛨뛩뛪뛫뛬뛭뛮뛯뛱뛲뛳뛵뛶뛷뛹뛺������뛻뛼뛽뛾뛿뜂뜃뜄뜆뜇뜈뜉뜊뜋뜌뜍뜎뜏뜐뜑뜒뜓뜔뜕뜖뜗뜘뜙뜚뜛뜜뜝뜞뜟뜠뜡뜢뜣뜤뜥뜦뜧뜪뜫뜭뜮뜱뜲뜳뜴뜵뜶뜷뜺뜼뜽뜾뜿띀띁띂띃띅띆띇띉띊띋띍띎띏띐띑띒띓띖띗띘띙띚띛띜띝띞띟띡띢띣띥띦띧띩띪띫띬띭띮띯띲띴띶띷띸띹띺띻띾띿랁랂랃랅랆랇랈랉랊랋랎랓랔랕랚랛랝랞�".split("");
	for(j = 0; j != D[141].length; ++j) if(D[141][j].charCodeAt(0) !== 0xFFFD) { e[D[141][j]] = 36096 + j; d[36096 + j] = D[141][j];}
	D[142] = "�����������������������������������������������������������������랟랡랢랣랤랥랦랧랪랮랯랰랱랲랳랶랷랹랺랻랼랽랾랿럀럁������럂럃럄럅럆럈럊럋럌럍럎럏럐럑럒럓럔럕럖럗럘럙럚럛럜럝������럞럟럠럡럢럣럤럥럦럧럨럩럪럫럮럯럱럲럳럵럶럷럸럹럺럻럾렂렃렄렅렆렊렋렍렎렏렑렒렓렔렕렖렗렚렜렞렟렠렡렢렣렦렧렩렪렫렭렮렯렰렱렲렳렶렺렻렼렽렾렿롁롂롃롅롆롇롈롉롊롋롌롍롎롏롐롒롔롕롖롗롘롙롚롛롞롟롡롢롣롥롦롧롨롩롪롫롮롰롲롳롴롵롶롷롹롺롻롽롾롿뢀뢁뢂뢃뢄�".split("");
	for(j = 0; j != D[142].length; ++j) if(D[142][j].charCodeAt(0) !== 0xFFFD) { e[D[142][j]] = 36352 + j; d[36352 + j] = D[142][j];}
	D[143] = "�����������������������������������������������������������������뢅뢆뢇뢈뢉뢊뢋뢌뢎뢏뢐뢑뢒뢓뢔뢕뢖뢗뢘뢙뢚뢛뢜뢝뢞뢟������뢠뢡뢢뢣뢤뢥뢦뢧뢩뢪뢫뢬뢭뢮뢯뢱뢲뢳뢵뢶뢷뢹뢺뢻뢼뢽������뢾뢿룂룄룆룇룈룉룊룋룍룎룏룑룒룓룕룖룗룘룙룚룛룜룞룠룢룣룤룥룦룧룪룫룭룮룯룱룲룳룴룵룶룷룺룼룾룿뤀뤁뤂뤃뤅뤆뤇뤈뤉뤊뤋뤌뤍뤎뤏뤐뤑뤒뤓뤔뤕뤖뤗뤙뤚뤛뤜뤝뤞뤟뤡뤢뤣뤤뤥뤦뤧뤨뤩뤪뤫뤬뤭뤮뤯뤰뤱뤲뤳뤴뤵뤶뤷뤸뤹뤺뤻뤾뤿륁륂륃륅륆륇륈륉륊륋륍륎륐륒륓륔륕륖륗�".split("");
	for(j = 0; j != D[143].length; ++j) if(D[143][j].charCodeAt(0) !== 0xFFFD) { e[D[143][j]] = 36608 + j; d[36608 + j] = D[143][j];}
	D[144] = "�����������������������������������������������������������������륚륛륝륞륟륡륢륣륤륥륦륧륪륬륮륯륰륱륲륳륶륷륹륺륻륽������륾륿릀릁릂릃릆릈릋릌릏릐릑릒릓릔릕릖릗릘릙릚릛릜릝릞������릟릠릡릢릣릤릥릦릧릨릩릪릫릮릯릱릲릳릵릶릷릸릹릺릻릾맀맂맃맄맅맆맇맊맋맍맓맔맕맖맗맚맜맟맠맢맦맧맩맪맫맭맮맯맰맱맲맳맶맻맼맽맾맿먂먃먄먅먆먇먉먊먋먌먍먎먏먐먑먒먓먔먖먗먘먙먚먛먜먝먞먟먠먡먢먣먤먥먦먧먨먩먪먫먬먭먮먯먰먱먲먳먴먵먶먷먺먻먽먾먿멁멃멄멅멆�".split("");
	for(j = 0; j != D[144].length; ++j) if(D[144][j].charCodeAt(0) !== 0xFFFD) { e[D[144][j]] = 36864 + j; d[36864 + j] = D[144][j];}
	D[145] = "�����������������������������������������������������������������멇멊멌멏멐멑멒멖멗멙멚멛멝멞멟멠멡멢멣멦멪멫멬멭멮멯������멲멳멵멶멷멹멺멻멼멽멾멿몀몁몂몆몈몉몊몋몍몎몏몐몑몒������몓몔몕몖몗몘몙몚몛몜몝몞몟몠몡몢몣몤몥몦몧몪몭몮몯몱몳몴몵몶몷몺몼몾몿뫀뫁뫂뫃뫅뫆뫇뫉뫊뫋뫌뫍뫎뫏뫐뫑뫒뫓뫔뫕뫖뫗뫚뫛뫜뫝뫞뫟뫠뫡뫢뫣뫤뫥뫦뫧뫨뫩뫪뫫뫬뫭뫮뫯뫰뫱뫲뫳뫴뫵뫶뫷뫸뫹뫺뫻뫽뫾뫿묁묂묃묅묆묇묈묉묊묋묌묎묐묒묓묔묕묖묗묙묚묛묝묞묟묡묢묣묤묥묦묧�".split("");
	for(j = 0; j != D[145].length; ++j) if(D[145][j].charCodeAt(0) !== 0xFFFD) { e[D[145][j]] = 37120 + j; d[37120 + j] = D[145][j];}
	D[146] = "�����������������������������������������������������������������묨묪묬묭묮묯묰묱묲묳묷묹묺묿뭀뭁뭂뭃뭆뭈뭊뭋뭌뭎뭑뭒������뭓뭕뭖뭗뭙뭚뭛뭜뭝뭞뭟뭠뭢뭤뭥뭦뭧뭨뭩뭪뭫뭭뭮뭯뭰뭱������뭲뭳뭴뭵뭶뭷뭸뭹뭺뭻뭼뭽뭾뭿뮀뮁뮂뮃뮄뮅뮆뮇뮉뮊뮋뮍뮎뮏뮑뮒뮓뮔뮕뮖뮗뮘뮙뮚뮛뮜뮝뮞뮟뮠뮡뮢뮣뮥뮦뮧뮩뮪뮫뮭뮮뮯뮰뮱뮲뮳뮵뮶뮸뮹뮺뮻뮼뮽뮾뮿믁믂믃믅믆믇믉믊믋믌믍믎믏믑믒믔믕믖믗믘믙믚믛믜믝믞믟믠믡믢믣믤믥믦믧믨믩믪믫믬믭믮믯믰믱믲믳믴믵믶믷믺믻믽믾밁�".split("");
	for(j = 0; j != D[146].length; ++j) if(D[146][j].charCodeAt(0) !== 0xFFFD) { e[D[146][j]] = 37376 + j; d[37376 + j] = D[146][j];}
	D[147] = "�����������������������������������������������������������������밃밄밅밆밇밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵������밶밷밹밺밻밼밽밾밿뱂뱆뱇뱈뱊뱋뱎뱏뱑뱒뱓뱔뱕뱖뱗뱘뱙������뱚뱛뱜뱞뱟뱠뱡뱢뱣뱤뱥뱦뱧뱨뱩뱪뱫뱬뱭뱮뱯뱰뱱뱲뱳뱴뱵뱶뱷뱸뱹뱺뱻뱼뱽뱾뱿벀벁벂벃벆벇벉벊벍벏벐벑벒벓벖벘벛벜벝벞벟벢벣벥벦벩벪벫벬벭벮벯벲벶벷벸벹벺벻벾벿볁볂볃볅볆볇볈볉볊볋볌볎볒볓볔볖볗볙볚볛볝볞볟볠볡볢볣볤볥볦볧볨볩볪볫볬볭볮볯볰볱볲볳볷볹볺볻볽�".split("");
	for(j = 0; j != D[147].length; ++j) if(D[147][j].charCodeAt(0) !== 0xFFFD) { e[D[147][j]] = 37632 + j; d[37632 + j] = D[147][j];}
	D[148] = "�����������������������������������������������������������������볾볿봀봁봂봃봆봈봊봋봌봍봎봏봑봒봓봕봖봗봘봙봚봛봜봝������봞봟봠봡봢봣봥봦봧봨봩봪봫봭봮봯봰봱봲봳봴봵봶봷봸봹������봺봻봼봽봾봿뵁뵂뵃뵄뵅뵆뵇뵊뵋뵍뵎뵏뵑뵒뵓뵔뵕뵖뵗뵚뵛뵜뵝뵞뵟뵠뵡뵢뵣뵥뵦뵧뵩뵪뵫뵬뵭뵮뵯뵰뵱뵲뵳뵴뵵뵶뵷뵸뵹뵺뵻뵼뵽뵾뵿붂붃붅붆붋붌붍붎붏붒붔붖붗붘붛붝붞붟붠붡붢붣붥붦붧붨붩붪붫붬붭붮붯붱붲붳붴붵붶붷붹붺붻붼붽붾붿뷀뷁뷂뷃뷄뷅뷆뷇뷈뷉뷊뷋뷌뷍뷎뷏뷐뷑�".split("");
	for(j = 0; j != D[148].length; ++j) if(D[148][j].charCodeAt(0) !== 0xFFFD) { e[D[148][j]] = 37888 + j; d[37888 + j] = D[148][j];}
	D[149] = "�����������������������������������������������������������������뷒뷓뷖뷗뷙뷚뷛뷝뷞뷟뷠뷡뷢뷣뷤뷥뷦뷧뷨뷪뷫뷬뷭뷮뷯뷱������뷲뷳뷵뷶뷷뷹뷺뷻뷼뷽뷾뷿븁븂븄븆븇븈븉븊븋븎븏븑븒븓������븕븖븗븘븙븚븛븞븠븡븢븣븤븥븦븧븨븩븪븫븬븭븮븯븰븱븲븳븴븵븶븷븸븹븺븻븼븽븾븿빀빁빂빃빆빇빉빊빋빍빏빐빑빒빓빖빘빜빝빞빟빢빣빥빦빧빩빫빬빭빮빯빲빶빷빸빹빺빾빿뺁뺂뺃뺅뺆뺇뺈뺉뺊뺋뺎뺒뺓뺔뺕뺖뺗뺚뺛뺜뺝뺞뺟뺠뺡뺢뺣뺤뺥뺦뺧뺩뺪뺫뺬뺭뺮뺯뺰뺱뺲뺳뺴뺵뺶뺷�".split("");
	for(j = 0; j != D[149].length; ++j) if(D[149][j].charCodeAt(0) !== 0xFFFD) { e[D[149][j]] = 38144 + j; d[38144 + j] = D[149][j];}
	D[150] = "�����������������������������������������������������������������뺸뺹뺺뺻뺼뺽뺾뺿뻀뻁뻂뻃뻄뻅뻆뻇뻈뻉뻊뻋뻌뻍뻎뻏뻒뻓������뻕뻖뻙뻚뻛뻜뻝뻞뻟뻡뻢뻦뻧뻨뻩뻪뻫뻭뻮뻯뻰뻱뻲뻳뻴뻵������뻶뻷뻸뻹뻺뻻뻼뻽뻾뻿뼀뼂뼃뼄뼅뼆뼇뼊뼋뼌뼍뼎뼏뼐뼑뼒뼓뼔뼕뼖뼗뼚뼞뼟뼠뼡뼢뼣뼤뼥뼦뼧뼨뼩뼪뼫뼬뼭뼮뼯뼰뼱뼲뼳뼴뼵뼶뼷뼸뼹뼺뼻뼼뼽뼾뼿뽂뽃뽅뽆뽇뽉뽊뽋뽌뽍뽎뽏뽒뽓뽔뽖뽗뽘뽙뽚뽛뽜뽝뽞뽟뽠뽡뽢뽣뽤뽥뽦뽧뽨뽩뽪뽫뽬뽭뽮뽯뽰뽱뽲뽳뽴뽵뽶뽷뽸뽹뽺뽻뽼뽽뽾뽿뾀뾁뾂�".split("");
	for(j = 0; j != D[150].length; ++j) if(D[150][j].charCodeAt(0) !== 0xFFFD) { e[D[150][j]] = 38400 + j; d[38400 + j] = D[150][j];}
	D[151] = "�����������������������������������������������������������������뾃뾄뾅뾆뾇뾈뾉뾊뾋뾌뾍뾎뾏뾐뾑뾒뾓뾕뾖뾗뾘뾙뾚뾛뾜뾝������뾞뾟뾠뾡뾢뾣뾤뾥뾦뾧뾨뾩뾪뾫뾬뾭뾮뾯뾱뾲뾳뾴뾵뾶뾷뾸������뾹뾺뾻뾼뾽뾾뾿뿀뿁뿂뿃뿄뿆뿇뿈뿉뿊뿋뿎뿏뿑뿒뿓뿕뿖뿗뿘뿙뿚뿛뿝뿞뿠뿢뿣뿤뿥뿦뿧뿨뿩뿪뿫뿬뿭뿮뿯뿰뿱뿲뿳뿴뿵뿶뿷뿸뿹뿺뿻뿼뿽뿾뿿쀀쀁쀂쀃쀄쀅쀆쀇쀈쀉쀊쀋쀌쀍쀎쀏쀐쀑쀒쀓쀔쀕쀖쀗쀘쀙쀚쀛쀜쀝쀞쀟쀠쀡쀢쀣쀤쀥쀦쀧쀨쀩쀪쀫쀬쀭쀮쀯쀰쀱쀲쀳쀴쀵쀶쀷쀸쀹쀺쀻쀽쀾쀿�".split("");
	for(j = 0; j != D[151].length; ++j) if(D[151][j].charCodeAt(0) !== 0xFFFD) { e[D[151][j]] = 38656 + j; d[38656 + j] = D[151][j];}
	D[152] = "�����������������������������������������������������������������쁀쁁쁂쁃쁄쁅쁆쁇쁈쁉쁊쁋쁌쁍쁎쁏쁐쁒쁓쁔쁕쁖쁗쁙쁚쁛������쁝쁞쁟쁡쁢쁣쁤쁥쁦쁧쁪쁫쁬쁭쁮쁯쁰쁱쁲쁳쁴쁵쁶쁷쁸쁹������쁺쁻쁼쁽쁾쁿삀삁삂삃삄삅삆삇삈삉삊삋삌삍삎삏삒삓삕삖삗삙삚삛삜삝삞삟삢삤삦삧삨삩삪삫삮삱삲삷삸삹삺삻삾샂샃샄샆샇샊샋샍샎샏샑샒샓샔샕샖샗샚샞샟샠샡샢샣샦샧샩샪샫샭샮샯샰샱샲샳샶샸샺샻샼샽샾샿섁섂섃섅섆섇섉섊섋섌섍섎섏섑섒섓섔섖섗섘섙섚섛섡섢섥섨섩섪섫섮�".split("");
	for(j = 0; j != D[152].length; ++j) if(D[152][j].charCodeAt(0) !== 0xFFFD) { e[D[152][j]] = 38912 + j; d[38912 + j] = D[152][j];}
	D[153] = "�����������������������������������������������������������������섲섳섴섵섷섺섻섽섾섿셁셂셃셄셅셆셇셊셎셏셐셑셒셓셖셗������셙셚셛셝셞셟셠셡셢셣셦셪셫셬셭셮셯셱셲셳셵셶셷셹셺셻������셼셽셾셿솀솁솂솃솄솆솇솈솉솊솋솏솑솒솓솕솗솘솙솚솛솞솠솢솣솤솦솧솪솫솭솮솯솱솲솳솴솵솶솷솸솹솺솻솼솾솿쇀쇁쇂쇃쇅쇆쇇쇉쇊쇋쇍쇎쇏쇐쇑쇒쇓쇕쇖쇙쇚쇛쇜쇝쇞쇟쇡쇢쇣쇥쇦쇧쇩쇪쇫쇬쇭쇮쇯쇲쇴쇵쇶쇷쇸쇹쇺쇻쇾쇿숁숂숃숅숆숇숈숉숊숋숎숐숒숓숔숕숖숗숚숛숝숞숡숢숣�".split("");
	for(j = 0; j != D[153].length; ++j) if(D[153][j].charCodeAt(0) !== 0xFFFD) { e[D[153][j]] = 39168 + j; d[39168 + j] = D[153][j];}
	D[154] = "�����������������������������������������������������������������숤숥숦숧숪숬숮숰숳숵숶숷숸숹숺숻숼숽숾숿쉀쉁쉂쉃쉄쉅������쉆쉇쉉쉊쉋쉌쉍쉎쉏쉒쉓쉕쉖쉗쉙쉚쉛쉜쉝쉞쉟쉡쉢쉣쉤쉦������쉧쉨쉩쉪쉫쉮쉯쉱쉲쉳쉵쉶쉷쉸쉹쉺쉻쉾슀슂슃슄슅슆슇슊슋슌슍슎슏슑슒슓슔슕슖슗슙슚슜슞슟슠슡슢슣슦슧슩슪슫슮슯슰슱슲슳슶슸슺슻슼슽슾슿싀싁싂싃싄싅싆싇싈싉싊싋싌싍싎싏싐싑싒싓싔싕싖싗싘싙싚싛싞싟싡싢싥싦싧싨싩싪싮싰싲싳싴싵싷싺싽싾싿쌁쌂쌃쌄쌅쌆쌇쌊쌋쌎쌏�".split("");
	for(j = 0; j != D[154].length; ++j) if(D[154][j].charCodeAt(0) !== 0xFFFD) { e[D[154][j]] = 39424 + j; d[39424 + j] = D[154][j];}
	D[155] = "�����������������������������������������������������������������쌐쌑쌒쌖쌗쌙쌚쌛쌝쌞쌟쌠쌡쌢쌣쌦쌧쌪쌫쌬쌭쌮쌯쌰쌱쌲������쌳쌴쌵쌶쌷쌸쌹쌺쌻쌼쌽쌾쌿썀썁썂썃썄썆썇썈썉썊썋썌썍������썎썏썐썑썒썓썔썕썖썗썘썙썚썛썜썝썞썟썠썡썢썣썤썥썦썧썪썫썭썮썯썱썳썴썵썶썷썺썻썾썿쎀쎁쎂쎃쎅쎆쎇쎉쎊쎋쎍쎎쎏쎐쎑쎒쎓쎔쎕쎖쎗쎘쎙쎚쎛쎜쎝쎞쎟쎠쎡쎢쎣쎤쎥쎦쎧쎨쎩쎪쎫쎬쎭쎮쎯쎰쎱쎲쎳쎴쎵쎶쎷쎸쎹쎺쎻쎼쎽쎾쎿쏁쏂쏃쏄쏅쏆쏇쏈쏉쏊쏋쏌쏍쏎쏏쏐쏑쏒쏓쏔쏕쏖쏗쏚�".split("");
	for(j = 0; j != D[155].length; ++j) if(D[155][j].charCodeAt(0) !== 0xFFFD) { e[D[155][j]] = 39680 + j; d[39680 + j] = D[155][j];}
	D[156] = "�����������������������������������������������������������������쏛쏝쏞쏡쏣쏤쏥쏦쏧쏪쏫쏬쏮쏯쏰쏱쏲쏳쏶쏷쏹쏺쏻쏼쏽쏾������쏿쐀쐁쐂쐃쐄쐅쐆쐇쐉쐊쐋쐌쐍쐎쐏쐑쐒쐓쐔쐕쐖쐗쐘쐙쐚������쐛쐜쐝쐞쐟쐠쐡쐢쐣쐥쐦쐧쐨쐩쐪쐫쐭쐮쐯쐱쐲쐳쐵쐶쐷쐸쐹쐺쐻쐾쐿쑀쑁쑂쑃쑄쑅쑆쑇쑉쑊쑋쑌쑍쑎쑏쑐쑑쑒쑓쑔쑕쑖쑗쑘쑙쑚쑛쑜쑝쑞쑟쑠쑡쑢쑣쑦쑧쑩쑪쑫쑭쑮쑯쑰쑱쑲쑳쑶쑷쑸쑺쑻쑼쑽쑾쑿쒁쒂쒃쒄쒅쒆쒇쒈쒉쒊쒋쒌쒍쒎쒏쒐쒑쒒쒓쒕쒖쒗쒘쒙쒚쒛쒝쒞쒟쒠쒡쒢쒣쒤쒥쒦쒧쒨쒩�".split("");
	for(j = 0; j != D[156].length; ++j) if(D[156][j].charCodeAt(0) !== 0xFFFD) { e[D[156][j]] = 39936 + j; d[39936 + j] = D[156][j];}
	D[157] = "�����������������������������������������������������������������쒪쒫쒬쒭쒮쒯쒰쒱쒲쒳쒴쒵쒶쒷쒹쒺쒻쒽쒾쒿쓀쓁쓂쓃쓄쓅������쓆쓇쓈쓉쓊쓋쓌쓍쓎쓏쓐쓑쓒쓓쓔쓕쓖쓗쓘쓙쓚쓛쓜쓝쓞쓟������쓠쓡쓢쓣쓤쓥쓦쓧쓨쓪쓫쓬쓭쓮쓯쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂씃씄씅씆씇씈씉씊씋씍씎씏씑씒씓씕씖씗씘씙씚씛씝씞씟씠씡씢씣씤씥씦씧씪씫씭씮씯씱씲씳씴씵씶씷씺씼씾씿앀앁앂앃앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩앪앫앬앭앮앯앲앶앷앸앹앺앻앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔�".split("");
	for(j = 0; j != D[157].length; ++j) if(D[157][j].charCodeAt(0) !== 0xFFFD) { e[D[157][j]] = 40192 + j; d[40192 + j] = D[157][j];}
	D[158] = "�����������������������������������������������������������������얖얙얚얛얝얞얟얡얢얣얤얥얦얧얨얪얫얬얭얮얯얰얱얲얳얶������얷얺얿엀엁엂엃엋엍엏엒엓엕엖엗엙엚엛엜엝엞엟엢엤엦엧������엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑옒옓옔옕옖옗옚옝옞옟옠옡옢옣옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉왊왋왌왍왎왏왒왖왗왘왙왚왛왞왟왡왢왣왤왥왦왧왨왩왪왫왭왮왰왲왳왴왵왶왷왺왻왽왾왿욁욂욃욄욅욆욇욊욌욎욏욐욑욒욓욖욗욙욚욛욝욞욟욠욡욢욣욦�".split("");
	for(j = 0; j != D[158].length; ++j) if(D[158][j].charCodeAt(0) !== 0xFFFD) { e[D[158][j]] = 40448 + j; d[40448 + j] = D[158][j];}
	D[159] = "�����������������������������������������������������������������욨욪욫욬욭욮욯욲욳욵욶욷욻욼욽욾욿웂웄웆웇웈웉웊웋웎������웏웑웒웓웕웖웗웘웙웚웛웞웟웢웣웤웥웦웧웪웫웭웮웯웱웲������웳웴웵웶웷웺웻웼웾웿윀윁윂윃윆윇윉윊윋윍윎윏윐윑윒윓윖윘윚윛윜윝윞윟윢윣윥윦윧윩윪윫윬윭윮윯윲윴윶윸윹윺윻윾윿읁읂읃읅읆읇읈읉읋읎읐읙읚읛읝읞읟읡읢읣읤읥읦읧읩읪읬읭읮읯읰읱읲읳읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛잜잝잞잟잢잧잨잩잪잫잮잯잱잲잳잵잶잷�".split("");
	for(j = 0; j != D[159].length; ++j) if(D[159][j].charCodeAt(0) !== 0xFFFD) { e[D[159][j]] = 40704 + j; d[40704 + j] = D[159][j];}
	D[160] = "�����������������������������������������������������������������잸잹잺잻잾쟂쟃쟄쟅쟆쟇쟊쟋쟍쟏쟑쟒쟓쟔쟕쟖쟗쟙쟚쟛쟜������쟞쟟쟠쟡쟢쟣쟥쟦쟧쟩쟪쟫쟭쟮쟯쟰쟱쟲쟳쟴쟵쟶쟷쟸쟹쟺������쟻쟼쟽쟾쟿젂젃젅젆젇젉젋젌젍젎젏젒젔젗젘젙젚젛젞젟젡젢젣젥젦젧젨젩젪젫젮젰젲젳젴젵젶젷젹젺젻젽젾젿졁졂졃졄졅졆졇졊졋졎졏졐졑졒졓졕졖졗졘졙졚졛졜졝졞졟졠졡졢졣졤졥졦졧졨졩졪졫졬졭졮졯졲졳졵졶졷졹졻졼졽졾졿좂좄좈좉좊좎좏좐좑좒좓좕좖좗좘좙좚좛좜좞좠좢좣좤�".split("");
	for(j = 0; j != D[160].length; ++j) if(D[160][j].charCodeAt(0) !== 0xFFFD) { e[D[160][j]] = 40960 + j; d[40960 + j] = D[160][j];}
	D[161] = "�����������������������������������������������������������������좥좦좧좩좪좫좬좭좮좯좰좱좲좳좴좵좶좷좸좹좺좻좾좿죀죁������죂죃죅죆죇죉죊죋죍죎죏죐죑죒죓죖죘죚죛죜죝죞죟죢죣죥������죦죧죨죩죪죫죬죭죮죯죰죱죲죳죴죶죷죸죹죺죻죾죿줁줂줃줇줈줉줊줋줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈〉《》「」『』【】±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "�����������������������������������������������������������������줐줒줓줔줕줖줗줙줚줛줜줝줞줟줠줡줢줣줤줥줦줧줨줩줪줫������줭줮줯줰줱줲줳줵줶줷줸줹줺줻줼줽줾줿쥀쥁쥂쥃쥄쥅쥆쥇������쥈쥉쥊쥋쥌쥍쥎쥏쥒쥓쥕쥖쥗쥙쥚쥛쥜쥝쥞쥟쥢쥤쥥쥦쥧쥨쥩쥪쥫쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®������������������������".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������쥱쥲쥳쥵쥶쥷쥸쥹쥺쥻쥽쥾쥿즀즁즂즃즄즅즆즇즊즋즍즎즏������즑즒즓즔즕즖즗즚즜즞즟즠즡즢즣즤즥즦즧즨즩즪즫즬즭즮������즯즰즱즲즳즴즵즶즷즸즹즺즻즼즽즾즿짂짃짅짆짉짋짌짍짎짏짒짔짗짘짛！＂＃＄％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［￦］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������짞짟짡짣짥짦짨짩짪짫짮짲짳짴짵짶짷짺짻짽짾짿쨁쨂쨃쨄������쨅쨆쨇쨊쨎쨏쨐쨑쨒쨓쨕쨖쨗쨙쨚쨛쨜쨝쨞쨟쨠쨡쨢쨣쨤쨥������쨦쨧쨨쨪쨫쨬쨭쨮쨯쨰쨱쨲쨳쨴쨵쨶쨷쨸쨹쨺쨻쨼쨽쨾쨿쩀쩁쩂쩃쩄쩅쩆ㄱㄲㄳㄴㄵㄶㄷㄸㄹㄺㄻㄼㄽㄾㄿㅀㅁㅂㅃㅄㅅㅆㅇㅈㅉㅊㅋㅌㅍㅎㅏㅐㅑㅒㅓㅔㅕㅖㅗㅘㅙㅚㅛㅜㅝㅞㅟㅠㅡㅢㅣㅤㅥㅦㅧㅨㅩㅪㅫㅬㅭㅮㅯㅰㅱㅲㅳㅴㅵㅶㅷㅸㅹㅺㅻㅼㅽㅾㅿㆀㆁㆂㆃㆄㆅㆆㆇㆈㆉㆊㆋㆌㆍㆎ�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������쩇쩈쩉쩊쩋쩎쩏쩑쩒쩓쩕쩖쩗쩘쩙쩚쩛쩞쩢쩣쩤쩥쩦쩧쩩쩪������쩫쩬쩭쩮쩯쩰쩱쩲쩳쩴쩵쩶쩷쩸쩹쩺쩻쩼쩾쩿쪀쪁쪂쪃쪅쪆������쪇쪈쪉쪊쪋쪌쪍쪎쪏쪐쪑쪒쪓쪔쪕쪖쪗쪙쪚쪛쪜쪝쪞쪟쪠쪡쪢쪣쪤쪥쪦쪧ⅰⅱⅲⅳⅴⅵⅶⅷⅸⅹ�����ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ�������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω�������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������쪨쪩쪪쪫쪬쪭쪮쪯쪰쪱쪲쪳쪴쪵쪶쪷쪸쪹쪺쪻쪾쪿쫁쫂쫃쫅������쫆쫇쫈쫉쫊쫋쫎쫐쫒쫔쫕쫖쫗쫚쫛쫜쫝쫞쫟쫡쫢쫣쫤쫥쫦쫧������쫨쫩쫪쫫쫭쫮쫯쫰쫱쫲쫳쫵쫶쫷쫸쫹쫺쫻쫼쫽쫾쫿쬀쬁쬂쬃쬄쬅쬆쬇쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃╄╅╆╇╈╉╊���������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������쬋쬌쬍쬎쬏쬑쬒쬓쬕쬖쬗쬙쬚쬛쬜쬝쬞쬟쬢쬣쬤쬥쬦쬧쬨쬩������쬪쬫쬬쬭쬮쬯쬰쬱쬲쬳쬴쬵쬶쬷쬸쬹쬺쬻쬼쬽쬾쬿쭀쭂쭃쭄������쭅쭆쭇쭊쭋쭍쭎쭏쭑쭒쭓쭔쭕쭖쭗쭚쭛쭜쭞쭟쭠쭡쭢쭣쭥쭦쭧쭨쭩쭪쭫쭬㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙㎚㎛㎜㎝㎞㎟㎠㎡㎢㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰㎱㎲㎳㎴㎵㎶㎷㎸㎹㎀㎁㎂㎃㎄㎺㎻㎼㎽㎾㎿㎐㎑㎒㎓㎔Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆����������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������쭭쭮쭯쭰쭱쭲쭳쭴쭵쭶쭷쭺쭻쭼쭽쭾쭿쮀쮁쮂쮃쮄쮅쮆쮇쮈������쮉쮊쮋쮌쮍쮎쮏쮐쮑쮒쮓쮔쮕쮖쮗쮘쮙쮚쮛쮝쮞쮟쮠쮡쮢쮣������쮤쮥쮦쮧쮨쮩쮪쮫쮬쮭쮮쮯쮰쮱쮲쮳쮴쮵쮶쮷쮹쮺쮻쮼쮽쮾쮿쯀쯁쯂쯃쯄ÆÐªĦ�Ĳ�ĿŁØŒºÞŦŊ�㉠㉡㉢㉣㉤㉥㉦㉧㉨㉩㉪㉫㉬㉭㉮㉯㉰㉱㉲㉳㉴㉵㉶㉷㉸㉹㉺㉻ⓐⓑⓒⓓⓔⓕⓖⓗⓘⓙⓚⓛⓜⓝⓞⓟⓠⓡⓢⓣⓤⓥⓦⓧⓨⓩ①②③④⑤⑥⑦⑧⑨⑩⑪⑫⑬⑭⑮½⅓⅔¼¾⅛⅜⅝⅞�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "�����������������������������������������������������������������쯅쯆쯇쯈쯉쯊쯋쯌쯍쯎쯏쯐쯑쯒쯓쯕쯖쯗쯘쯙쯚쯛쯜쯝쯞쯟������쯠쯡쯢쯣쯥쯦쯨쯪쯫쯬쯭쯮쯯쯰쯱쯲쯳쯴쯵쯶쯷쯸쯹쯺쯻쯼������쯽쯾쯿찀찁찂찃찄찅찆찇찈찉찊찋찎찏찑찒찓찕찖찗찘찙찚찛찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀㈁㈂㈃㈄㈅㈆㈇㈈㈉㈊㈋㈌㈍㈎㈏㈐㈑㈒㈓㈔㈕㈖㈗㈘㈙㈚㈛⒜⒝⒞⒟⒠⒡⒢⒣⒤⒥⒦⒧⒨⒩⒪⒫⒬⒭⒮⒯⒰⒱⒲⒳⒴⒵⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂¹²³⁴ⁿ₁₂₃₄�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "�����������������������������������������������������������������찥찦찪찫찭찯찱찲찳찴찵찶찷찺찿챀챁챂챃챆챇챉챊챋챍챎������챏챐챑챒챓챖챚챛챜챝챞챟챡챢챣챥챧챩챪챫챬챭챮챯챱챲������챳챴챶챷챸챹챺챻챼챽챾챿첀첁첂첃첄첅첆첇첈첉첊첋첌첍첎첏첐첑첒첓ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "�����������������������������������������������������������������첔첕첖첗첚첛첝첞첟첡첢첣첤첥첦첧첪첮첯첰첱첲첳첶첷첹������첺첻첽첾첿쳀쳁쳂쳃쳆쳈쳊쳋쳌쳍쳎쳏쳑쳒쳓쳕쳖쳗쳘쳙쳚������쳛쳜쳝쳞쳟쳠쳡쳢쳣쳥쳦쳧쳨쳩쳪쳫쳭쳮쳯쳱쳲쳳쳴쳵쳶쳷쳸쳹쳺쳻쳼쳽ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "�����������������������������������������������������������������쳾쳿촀촂촃촄촅촆촇촊촋촍촎촏촑촒촓촔촕촖촗촚촜촞촟촠������촡촢촣촥촦촧촩촪촫촭촮촯촰촱촲촳촴촵촶촷촸촺촻촼촽촾������촿쵀쵁쵂쵃쵄쵅쵆쵇쵈쵉쵊쵋쵌쵍쵎쵏쵐쵑쵒쵓쵔쵕쵖쵗쵘쵙쵚쵛쵝쵞쵟АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "�����������������������������������������������������������������쵡쵢쵣쵥쵦쵧쵨쵩쵪쵫쵮쵰쵲쵳쵴쵵쵶쵷쵹쵺쵻쵼쵽쵾쵿춀������춁춂춃춄춅춆춇춉춊춋춌춍춎춏춐춑춒춓춖춗춙춚춛춝춞춟������춠춡춢춣춦춨춪춫춬춭춮춯춱춲춳춴춵춶춷춸춹춺춻춼춽춾춿췀췁췂췃췅�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "�����������������������������������������������������������������췆췇췈췉췊췋췍췎췏췑췒췓췔췕췖췗췘췙췚췛췜췝췞췟췠췡������췢췣췤췥췦췧췩췪췫췭췮췯췱췲췳췴췵췶췷췺췼췾췿츀츁츂������츃츅츆츇츉츊츋츍츎츏츐츑츒츓츕츖츗츘츚츛츜츝츞츟츢츣츥츦츧츩츪츫�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "�����������������������������������������������������������������츬츭츮츯츲츴츶츷츸츹츺츻츼츽츾츿칀칁칂칃칄칅칆칇칈칉������칊칋칌칍칎칏칐칑칒칓칔칕칖칗칚칛칝칞칢칣칤칥칦칧칪칬������칮칯칰칱칲칳칶칷칹칺칻칽칾칿캀캁캂캃캆캈캊캋캌캍캎캏캒캓캕캖캗캙�����������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "�����������������������������������������������������������������캚캛캜캝캞캟캢캦캧캨캩캪캫캮캯캰캱캲캳캴캵캶캷캸캹캺������캻캼캽캾캿컀컂컃컄컅컆컇컈컉컊컋컌컍컎컏컐컑컒컓컔컕������컖컗컘컙컚컛컜컝컞컟컠컡컢컣컦컧컩컪컭컮컯컰컱컲컳컶컺컻컼컽컾컿가각간갇갈갉갊감갑값갓갔강갖갗같갚갛개객갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������켂켃켅켆켇켉켊켋켌켍켎켏켒켔켖켗켘켙켚켛켝켞켟켡켢켣������켥켦켧켨켩켪켫켮켲켳켴켵켶켷켹켺켻켼켽켾켿콀콁콂콃콄������콅콆콇콈콉콊콋콌콍콎콏콐콑콒콓콖콗콙콚콛콝콞콟콠콡콢콣콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������콭콮콯콲콳콵콶콷콹콺콻콼콽콾콿쾁쾂쾃쾄쾆쾇쾈쾉쾊쾋쾍������쾎쾏쾐쾑쾒쾓쾔쾕쾖쾗쾘쾙쾚쾛쾜쾝쾞쾟쾠쾢쾣쾤쾥쾦쾧쾩������쾪쾫쾬쾭쾮쾯쾱쾲쾳쾴쾵쾶쾷쾸쾹쾺쾻쾼쾽쾾쾿쿀쿁쿂쿃쿅쿆쿇쿈쿉쿊쿋깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������쿌쿍쿎쿏쿐쿑쿒쿓쿔쿕쿖쿗쿘쿙쿚쿛쿜쿝쿞쿟쿢쿣쿥쿦쿧쿩������쿪쿫쿬쿭쿮쿯쿲쿴쿶쿷쿸쿹쿺쿻쿽쿾쿿퀁퀂퀃퀅퀆퀇퀈퀉퀊������퀋퀌퀍퀎퀏퀐퀒퀓퀔퀕퀖퀗퀙퀚퀛퀜퀝퀞퀟퀠퀡퀢퀣퀤퀥퀦퀧퀨퀩퀪퀫퀬끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫났낭낮낯낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������퀮퀯퀰퀱퀲퀳퀶퀷퀹퀺퀻퀽퀾퀿큀큁큂큃큆큈큊큋큌큍큎큏������큑큒큓큕큖큗큙큚큛큜큝큞큟큡큢큣큤큥큦큧큨큩큪큫큮큯������큱큲큳큵큶큷큸큹큺큻큾큿킀킂킃킄킅킆킇킈킉킊킋킌킍킎킏킐킑킒킓킔뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫달닭닮닯닳담답닷닸당닺닻닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������킕킖킗킘킙킚킛킜킝킞킟킠킡킢킣킦킧킩킪킫킭킮킯킰킱킲������킳킶킸킺킻킼킽킾킿탂탃탅탆탇탊탋탌탍탎탏탒탖탗탘탙탚������탛탞탟탡탢탣탥탦탧탨탩탪탫탮탲탳탴탵탶탷탹탺탻탼탽탾탿턀턁턂턃턄덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������턅턆턇턈턉턊턋턌턎턏턐턑턒턓턔턕턖턗턘턙턚턛턜턝턞턟������턠턡턢턣턤턥턦턧턨턩턪턫턬턭턮턯턲턳턵턶턷턹턻턼턽턾������턿텂텆텇텈텉텊텋텎텏텑텒텓텕텖텗텘텙텚텛텞텠텢텣텤텥텦텧텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������텮텯텰텱텲텳텴텵텶텷텸텹텺텻텽텾텿톀톁톂톃톅톆톇톉톊������톋톌톍톎톏톐톑톒톓톔톕톖톗톘톙톚톛톜톝톞톟톢톣톥톦톧������톩톪톫톬톭톮톯톲톴톶톷톸톹톻톽톾톿퇁퇂퇃퇄퇅퇆퇇퇈퇉퇊퇋퇌퇍퇎퇏래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������퇐퇑퇒퇓퇔퇕퇖퇗퇙퇚퇛퇜퇝퇞퇟퇠퇡퇢퇣퇤퇥퇦퇧퇨퇩퇪������퇫퇬퇭퇮퇯퇰퇱퇲퇳퇵퇶퇷퇹퇺퇻퇼퇽퇾퇿툀툁툂툃툄툅툆������툈툊툋툌툍툎툏툑툒툓툔툕툖툗툘툙툚툛툜툝툞툟툠툡툢툣툤툥툦툧툨툩륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많맏말맑맒맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������툪툫툮툯툱툲툳툵툶툷툸툹툺툻툾퉀퉂퉃퉄퉅퉆퉇퉉퉊퉋퉌������퉍퉎퉏퉐퉑퉒퉓퉔퉕퉖퉗퉘퉙퉚퉛퉝퉞퉟퉠퉡퉢퉣퉥퉦퉧퉨������퉩퉪퉫퉬퉭퉮퉯퉰퉱퉲퉳퉴퉵퉶퉷퉸퉹퉺퉻퉼퉽퉾퉿튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바박밖밗반받발밝밞밟밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������튍튎튏튒튓튔튖튗튘튙튚튛튝튞튟튡튢튣튥튦튧튨튩튪튫튭������튮튯튰튲튳튴튵튶튷튺튻튽튾틁틃틄틅틆틇틊틌틍틎틏틐틑������틒틓틕틖틗틙틚틛틝틞틟틠틡틢틣틦틧틨틩틪틫틬틭틮틯틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������틻틼틽틾틿팂팄팆팇팈팉팊팋팏팑팒팓팕팗팘팙팚팛팞팢팣������팤팦팧팪팫팭팮팯팱팲팳팴팵팶팷팺팾팿퍀퍁퍂퍃퍆퍇퍈퍉������퍊퍋퍌퍍퍎퍏퍐퍑퍒퍓퍔퍕퍖퍗퍘퍙퍚퍛퍜퍝퍞퍟퍠퍡퍢퍣퍤퍥퍦퍧퍨퍩빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������퍪퍫퍬퍭퍮퍯퍰퍱퍲퍳퍴퍵퍶퍷퍸퍹퍺퍻퍾퍿펁펂펃펅펆펇������펈펉펊펋펎펒펓펔펕펖펗펚펛펝펞펟펡펢펣펤펥펦펧펪펬펮������펯펰펱펲펳펵펶펷펹펺펻펽펾펿폀폁폂폃폆폇폊폋폌폍폎폏폑폒폓폔폕폖샥샨샬샴샵샷샹섀섄섈섐섕서석섞섟선섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������폗폙폚폛폜폝폞폟폠폢폤폥폦폧폨폩폪폫폮폯폱폲폳폵폶폷������폸폹폺폻폾퐀퐂퐃퐄퐅퐆퐇퐉퐊퐋퐌퐍퐎퐏퐐퐑퐒퐓퐔퐕퐖������퐗퐘퐙퐚퐛퐜퐞퐟퐠퐡퐢퐣퐤퐥퐦퐧퐨퐩퐪퐫퐬퐭퐮퐯퐰퐱퐲퐳퐴퐵퐶퐷숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������퐸퐹퐺퐻퐼퐽퐾퐿푁푂푃푅푆푇푈푉푊푋푌푍푎푏푐푑푒푓������푔푕푖푗푘푙푚푛푝푞푟푡푢푣푥푦푧푨푩푪푫푬푮푰푱푲������푳푴푵푶푷푺푻푽푾풁풃풄풅풆풇풊풌풎풏풐풑풒풓풕풖풗풘풙풚풛풜풝쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄업없엇었엉엊엌엎�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������풞풟풠풡풢풣풤풥풦풧풨풪풫풬풭풮풯풰풱풲풳풴풵풶풷풸������풹풺풻풼풽풾풿퓀퓁퓂퓃퓄퓅퓆퓇퓈퓉퓊퓋퓍퓎퓏퓑퓒퓓퓕������퓖퓗퓘퓙퓚퓛퓝퓞퓠퓡퓢퓣퓤퓥퓦퓧퓩퓪퓫퓭퓮퓯퓱퓲퓳퓴퓵퓶퓷퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염엽엾엿였영옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������퓾퓿픀픁픂픃픅픆픇픉픊픋픍픎픏픐픑픒픓픖픘픙픚픛픜픝������픞픟픠픡픢픣픤픥픦픧픨픩픪픫픬픭픮픯픰픱픲픳픴픵픶픷������픸픹픺픻픾픿핁핂핃핅핆핇핈핉핊핋핎핐핒핓핔핕핖핗핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응읒읓읔읕읖읗의읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������핤핦핧핪핬핮핯핰핱핲핳핶핷핹핺핻핽핾핿햀햁햂햃햆햊햋������햌햍햎햏햑햒햓햔햕햖햗햘햙햚햛햜햝햞햟햠햡햢햣햤햦햧������햨햩햪햫햬햭햮햯햰햱햲햳햴햵햶햷햸햹햺햻햼햽햾햿헀헁헂헃헄헅헆헇점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������헊헋헍헎헏헑헓헔헕헖헗헚헜헞헟헠헡헢헣헦헧헩헪헫헭헮������헯헰헱헲헳헶헸헺헻헼헽헾헿혂혃혅혆혇혉혊혋혌혍혎혏혒������혖혗혘혙혚혛혝혞혟혡혢혣혥혦혧혨혩혪혫혬혮혯혰혱혲혳혴혵혶혷혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝홞홟홠홡������홢홣홤홥홦홨홪홫홬홭홮홯홲홳홵홶홷홸홹홺홻홼홽홾홿횀������횁횂횄횆횇횈횉횊횋횎횏횑횒횓횕횖횗횘횙횚횛횜횞횠횢횣횤횥횦횧횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������횫횭횮횯횱횲횳횴횵횶횷횸횺횼횽횾횿훀훁훂훃훆훇훉훊훋������훍훎훏훐훒훓훕훖훘훚훛훜훝훞훟훡훢훣훥훦훧훩훪훫훬훭������훮훯훱훲훳훴훶훷훸훹훺훻훾훿휁휂휃휅휆휇휈휉휊휋휌휍휎휏휐휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������휕휖휗휚휛휝휞휟휡휢휣휤휥휦휧휪휬휮휯휰휱휲휳휶휷휹������휺휻휽휾휿흀흁흂흃흅흆흈흊흋흌흍흎흏흒흓흕흚흛흜흝흞������흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵흶흷흸흹흺흻흾흿힀힂힃힄힅힆힇힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������힍힎힏힑힒힓힔힕힖힗힚힜힞힟힠힡힢힣������������������������������������������������������������������������������퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩羅蘿螺裸邏那樂洛烙珞落諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������納臘蠟衲囊娘廊朗浪狼郎乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧老蘆虜路露駑魯鷺碌祿綠菉錄鹿論壟弄濃籠聾膿農惱牢磊腦賂雷尿壘屢樓淚漏累縷陋嫩訥杻紐勒肋凜凌稜綾能菱陵尼泥匿溺多茶�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	D[250] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型�".split("");
	for(j = 0; j != D[250].length; ++j) if(D[250][j].charCodeAt(0) !== 0xFFFD) { e[D[250][j]] = 64000 + j; d[64000 + j] = D[250][j];}
	D[251] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵�".split("");
	for(j = 0; j != D[251].length; ++j) if(D[251][j].charCodeAt(0) !== 0xFFFD) { e[D[251][j]] = 64256 + j; d[64256 + j] = D[251][j];}
	D[252] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆�".split("");
	for(j = 0; j != D[252].length; ++j) if(D[252][j].charCodeAt(0) !== 0xFFFD) { e[D[252][j]] = 64512 + j; d[64512 + j] = D[252][j];}
	D[253] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰�".split("");
	for(j = 0; j != D[253].length; ++j) if(D[253][j].charCodeAt(0) !== 0xFFFD) { e[D[253][j]] = 64768 + j; d[64768 + j] = D[253][j];}
	return {"enc": e, "dec": d }; })();
	cptable[950] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~��������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "����������������������������������������������������������������　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚����������������������������������﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢﹣﹤﹥﹦～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "����������������������������������������������������������������＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁▂▃▄▅▆▇█▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭����������������������������������╮╰╯═╞╪╡◢◣◥◤╱╲╳０１２３４５６７８９ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ〡〢〣〤〥〦〧〨〩十卄卅ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖ�".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "����������������������������������������������������������������ｗｘｙｚΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩαβγδεζηθικλμνξοπρστυφχψωㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏ����������������������������������ㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ˙ˉˊˇˋ���������������������������������€������������������������������".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "����������������������������������������������������������������一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才����������������������������������丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙�".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "����������������������������������������������������������������世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外����������������������������������央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全�".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "����������������������������������������������������������������共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年����������������������������������式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣�".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "����������������������������������������������������������������作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍����������������������������������均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠�".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "����������������������������������������������������������������杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒����������������������������������芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵�".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "����������������������������������������������������������������咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居����������������������������������屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊�".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[170] = "����������������������������������������������������������������昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠����������������������������������炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附�".split("");
	for(j = 0; j != D[170].length; ++j) if(D[170][j].charCodeAt(0) !== 0xFFFD) { e[D[170][j]] = 43520 + j; d[43520 + j] = D[170][j];}
	D[171] = "����������������������������������������������������������������陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品����������������������������������哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷�".split("");
	for(j = 0; j != D[171].length; ++j) if(D[171][j].charCodeAt(0) !== 0xFFFD) { e[D[171][j]] = 43776 + j; d[43776 + j] = D[171][j];}
	D[172] = "����������������������������������������������������������������拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗����������������������������������活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄�".split("");
	for(j = 0; j != D[172].length; ++j) if(D[172][j].charCodeAt(0) !== 0xFFFD) { e[D[172][j]] = 44032 + j; d[44032 + j] = D[172][j];}
	D[173] = "����������������������������������������������������������������耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥����������������������������������迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪�".split("");
	for(j = 0; j != D[173].length; ++j) if(D[173][j].charCodeAt(0) !== 0xFFFD) { e[D[173][j]] = 44288 + j; d[44288 + j] = D[173][j];}
	D[174] = "����������������������������������������������������������������哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙����������������������������������恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓�".split("");
	for(j = 0; j != D[174].length; ++j) if(D[174][j].charCodeAt(0) !== 0xFFFD) { e[D[174][j]] = 44544 + j; d[44544 + j] = D[174][j];}
	D[175] = "����������������������������������������������������������������浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷����������������������������������砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃�".split("");
	for(j = 0; j != D[175].length; ++j) if(D[175][j].charCodeAt(0) !== 0xFFFD) { e[D[175][j]] = 44800 + j; d[44800 + j] = D[175][j];}
	D[176] = "����������������������������������������������������������������虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡����������������������������������陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "����������������������������������������������������������������娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽����������������������������������情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "����������������������������������������������������������������毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶����������������������������������瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "����������������������������������������������������������������莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途����������������������������������部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "����������������������������������������������������������������婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍����������������������������������插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "����������������������������������������������������������������溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘����������������������������������窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "����������������������������������������������������������������詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑����������������������������������間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "����������������������������������������������������������������媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業����������������������������������楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "����������������������������������������������������������������睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫����������������������������������腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "����������������������������������������������������������������辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴����������������������������������飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "����������������������������������������������������������������愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢����������������������������������滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "����������������������������������������������������������������罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤����������������������������������說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "����������������������������������������������������������������劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂����������������������������������慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "����������������������������������������������������������������瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯����������������������������������翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "����������������������������������������������������������������輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉����������������������������������鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "����������������������������������������������������������������濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊����������������������������������縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "����������������������������������������������������������������錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇����������������������������������嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "����������������������������������������������������������������瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪����������������������������������薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "����������������������������������������������������������������駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘����������������������������������癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "����������������������������������������������������������������鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸����������������������������������獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "����������������������������������������������������������������願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼����������������������������������纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "����������������������������������������������������������������護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬����������������������������������禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "����������������������������������������������������������������讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲���������������������������������������������������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[201] = "����������������������������������������������������������������乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕����������������������������������氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "����������������������������������������������������������������汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘����������������������������������吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "����������������������������������������������������������������杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓����������������������������������芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "����������������������������������������������������������������坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋����������������������������������怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "����������������������������������������������������������������泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺����������������������������������矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "����������������������������������������������������������������哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛����������������������������������峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "����������������������������������������������������������������柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂����������������������������������洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "����������������������������������������������������������������穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪����������������������������������苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "����������������������������������������������������������������唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧����������������������������������恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "����������������������������������������������������������������毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸����������������������������������牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "����������������������������������������������������������������笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢����������������������������������荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "����������������������������������������������������������������酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅����������������������������������唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "����������������������������������������������������������������崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟����������������������������������捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "����������������������������������������������������������������淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏����������������������������������痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "����������������������������������������������������������������耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷����������������������������������蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪�".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "����������������������������������������������������������������釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷����������������������������������堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "����������������������������������������������������������������惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒����������������������������������晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "����������������������������������������������������������������湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖����������������������������������琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "����������������������������������������������������������������罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳����������������������������������菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "����������������������������������������������������������������軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈����������������������������������隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "����������������������������������������������������������������媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤����������������������������������搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "����������������������������������������������������������������毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓����������������������������������煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "����������������������������������������������������������������稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯����������������������������������腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "����������������������������������������������������������������觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿����������������������������������遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "����������������������������������������������������������������凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠����������������������������������寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "����������������������������������������������������������������榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊����������������������������������漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "����������������������������������������������������������������禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞����������������������������������耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "����������������������������������������������������������������裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍����������������������������������銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "����������������������������������������������������������������噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉����������������������������������憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "����������������������������������������������������������������澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙����������������������������������獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "����������������������������������������������������������������膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢����������������������������������蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "����������������������������������������������������������������踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓����������������������������������銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "����������������������������������������������������������������噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺����������������������������������憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "����������������������������������������������������������������澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙����������������������������������瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "����������������������������������������������������������������蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠����������������������������������諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "����������������������������������������������������������������錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕����������������������������������魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "����������������������������������������������������������������檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶����������������������������������瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "����������������������������������������������������������������蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞����������������������������������謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "����������������������������������������������������������������鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰����������������������������������鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "����������������������������������������������������������������璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒����������������������������������臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "����������������������������������������������������������������蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪����������������������������������鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "����������������������������������������������������������������徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛����������������������������������礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "����������������������������������������������������������������譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦����������������������������������鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "����������������������������������������������������������������嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩����������������������������������禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "����������������������������������������������������������������鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛����������������������������������鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "����������������������������������������������������������������蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺����������������������������������騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "����������������������������������������������������������������糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊����������������������������������驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	D[248] = "����������������������������������������������������������������讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏����������������������������������齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚�".split("");
	for(j = 0; j != D[248].length; ++j) if(D[248][j].charCodeAt(0) !== 0xFFFD) { e[D[248][j]] = 63488 + j; d[63488 + j] = D[248][j];}
	D[249] = "����������������������������������������������������������������纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊����������������������������������龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓�".split("");
	for(j = 0; j != D[249].length; ++j) if(D[249][j].charCodeAt(0) !== 0xFFFD) { e[D[249][j]] = 63744 + j; d[63744 + j] = D[249][j];}
	return {"enc": e, "dec": d }; })();
	cptable[1250] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰Š‹ŚŤŽŹ�‘’“”•–—�™š›śťžź ˇ˘Ł¤Ą¦§¨©Ş«¬­®Ż°±˛ł´µ¶·¸ąş»Ľ˝ľżŔÁÂĂÄĹĆÇČÉĘËĚÍÎĎĐŃŇÓÔŐÖ×ŘŮÚŰÜÝŢßŕáâăäĺćçčéęëěíîďđńňóôőö÷řůúűüýţ˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1251] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬­®Ї°±Ііґµ¶·ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1252] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ�Ž��‘’“”•–—˜™š›œ�žŸ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1253] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡�‰�‹�����‘’“”•–—�™�›���� ΅Ά£¤¥¦§¨©�«¬­®―°±²³΄µ¶·ΈΉΊ»Ό½ΎΏΐΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡ�ΣΤΥΦΧΨΩΪΫάέήίΰαβγδεζηθικλμνξοπρςστυφχψωϊϋόύώ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1254] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰Š‹Œ����‘’“”•–—˜™š›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏĞÑÒÓÔÕÖ×ØÙÚÛÜİŞßàáâãäåæçèéêëìíîïğñòóôõö÷øùúûüışÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1255] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹�����‘’“”•–—˜™�›���� ¡¢£₪¥¦§¨©×«¬­®¯°±²³´µ¶·¸¹÷»¼½¾¿ְֱֲֳִֵֶַָֹ�ֻּֽ־ֿ׀ׁׂ׃װױײ׳״�������אבגדהוזחטיךכלםמןנסעףפץצקרשת��‎‏�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1256] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€پ‚ƒ„…†‡ˆ‰ٹ‹Œچژڈگ‘’“”•–—ک™ڑ›œ‌‍ں ،¢£¤¥¦§¨©ھ«¬­®¯°±²³´µ¶·¸¹؛»¼½¾؟ہءآأؤإئابةتثجحخدذرزسشصض×طظعغـفقكàلâمنهوçèéêëىيîïًٌٍَôُِ÷ّùْûü‎‏ے", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1257] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚�„…†‡�‰�‹�¨ˇ¸�‘’“”•–—�™�›�¯˛� �¢£¤�¦§Ø©Ŗ«¬­®Æ°±²³´µ¶·ø¹ŗ»¼½¾æĄĮĀĆÄÅĘĒČÉŹĖĢĶĪĻŠŃŅÓŌÕÖ×ŲŁŚŪÜŻŽßąįāćäåęēčéźėģķīļšńņóōõö÷ųłśūüżž˙", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[1258] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~€�‚ƒ„…†‡ˆ‰�‹Œ����‘’“”•–—˜™�›œ��Ÿ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂĂÄÅÆÇÈÉÊË̀ÍÎÏĐÑ̉ÓÔƠÖ×ØÙÚÛÜỮßàáâăäåæçèéêë́íîïđṇ̃óôơö÷øùúûüư₫ÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10000] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤‹›ﬁﬂ‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10006] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~Ä¹²É³ÖÜ΅àâä΄¨çéèêë£™îï•½‰ôö¦­ùûü†ΓΔΘΛΞΠß®©ΣΪ§≠°·Α±≤≥¥ΒΕΖΗΙΚΜΦΫΨΩάΝ¬ΟΡ≈Τ«»… ΥΧΆΈœ–―“”‘’÷ΉΊΌΎέήίόΏύαβψδεφγηιξκλμνοπώρστθωςχυζϊϋΐΰ�", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10007] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~АБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ†°¢£§•¶І®©™Ђђ≠Ѓѓ∞±≤≥іµ∂ЈЄєЇїЉљЊњјЅ¬√ƒ≈∆«»… ЋћЌќѕ–—“”‘’÷„ЎўЏџ№Ёёяабвгдежзийклмнопрстуфхцчшщъыьэю¤", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10008] = (function(){ var d = [], e = {}, D = [], j;
	D[0] = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~���������������������������������������������������������������������������������������".split("");
	for(j = 0; j != D[0].length; ++j) if(D[0][j].charCodeAt(0) !== 0xFFFD) { e[D[0][j]] = 0 + j; d[0 + j] = D[0][j];}
	D[161] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������　、。・ˉˇ¨〃々―～�…‘’“”〔〕〈〉《》「」『』〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓�".split("");
	for(j = 0; j != D[161].length; ++j) if(D[161][j].charCodeAt(0) !== 0xFFFD) { e[D[161][j]] = 41216 + j; d[41216 + j] = D[161][j];}
	D[162] = "���������������������������������������������������������������������������������������������������������������������������������������������������������������������������������⒈⒉⒊⒋⒌⒍⒎⒏⒐⒑⒒⒓⒔⒕⒖⒗⒘⒙⒚⒛⑴⑵⑶⑷⑸⑹⑺⑻⑼⑽⑾⑿⒀⒁⒂⒃⒄⒅⒆⒇①②③④⑤⑥⑦⑧⑨⑩��㈠㈡㈢㈣㈤㈥㈦㈧㈨㈩��ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩⅪⅫ���".split("");
	for(j = 0; j != D[162].length; ++j) if(D[162][j].charCodeAt(0) !== 0xFFFD) { e[D[162][j]] = 41472 + j; d[41472 + j] = D[162][j];}
	D[163] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������！＂＃￥％＆＇（）＊＋，－．／０１２３４５６７８９：；＜＝＞？＠ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺ［＼］＾＿｀ａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ｛｜｝￣�".split("");
	for(j = 0; j != D[163].length; ++j) if(D[163][j].charCodeAt(0) !== 0xFFFD) { e[D[163][j]] = 41728 + j; d[41728 + j] = D[163][j];}
	D[164] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわゐゑをん������������".split("");
	for(j = 0; j != D[164].length; ++j) if(D[164][j].charCodeAt(0) !== 0xFFFD) { e[D[164][j]] = 41984 + j; d[41984 + j] = D[164][j];}
	D[165] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヰヱヲンヴヵヶ���������".split("");
	for(j = 0; j != D[165].length; ++j) if(D[165][j].charCodeAt(0) !== 0xFFFD) { e[D[165][j]] = 42240 + j; d[42240 + j] = D[165][j];}
	D[166] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ��������αβγδεζηθικλμνξοπρστυφχψω���������������������������������������".split("");
	for(j = 0; j != D[166].length; ++j) if(D[166][j].charCodeAt(0) !== 0xFFFD) { e[D[166][j]] = 42496 + j; d[42496 + j] = D[166][j];}
	D[167] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ���������������абвгдеёжзийклмнопрстуфхцчшщъыьэюя��������������".split("");
	for(j = 0; j != D[167].length; ++j) if(D[167][j].charCodeAt(0) !== 0xFFFD) { e[D[167][j]] = 42752 + j; d[42752 + j] = D[167][j];}
	D[168] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüê����������ㄅㄆㄇㄈㄉㄊㄋㄌㄍㄎㄏㄐㄑㄒㄓㄔㄕㄖㄗㄘㄙㄚㄛㄜㄝㄞㄟㄠㄡㄢㄣㄤㄥㄦㄧㄨㄩ����������������������".split("");
	for(j = 0; j != D[168].length; ++j) if(D[168][j].charCodeAt(0) !== 0xFFFD) { e[D[168][j]] = 43008 + j; d[43008 + j] = D[168][j];}
	D[169] = "��������������������������������������������������������������������������������������������������������������������������������������������������������������������─━│┃┄┅┆┇┈┉┊┋┌┍┎┏┐┑┒┓└┕┖┗┘┙┚┛├┝┞┟┠┡┢┣┤┥┦┧┨┩┪┫┬┭┮┯┰┱┲┳┴┵┶┷┸┹┺┻┼┽┾┿╀╁╂╃╄╅╆╇╈╉╊╋����������������".split("");
	for(j = 0; j != D[169].length; ++j) if(D[169][j].charCodeAt(0) !== 0xFFFD) { e[D[169][j]] = 43264 + j; d[43264 + j] = D[169][j];}
	D[176] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥�".split("");
	for(j = 0; j != D[176].length; ++j) if(D[176][j].charCodeAt(0) !== 0xFFFD) { e[D[176][j]] = 45056 + j; d[45056 + j] = D[176][j];}
	D[177] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳�".split("");
	for(j = 0; j != D[177].length; ++j) if(D[177][j].charCodeAt(0) !== 0xFFFD) { e[D[177][j]] = 45312 + j; d[45312 + j] = D[177][j];}
	D[178] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖�".split("");
	for(j = 0; j != D[178].length; ++j) if(D[178][j].charCodeAt(0) !== 0xFFFD) { e[D[178][j]] = 45568 + j; d[45568 + j] = D[178][j];}
	D[179] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚�".split("");
	for(j = 0; j != D[179].length; ++j) if(D[179][j].charCodeAt(0) !== 0xFFFD) { e[D[179][j]] = 45824 + j; d[45824 + j] = D[179][j];}
	D[180] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮�".split("");
	for(j = 0; j != D[180].length; ++j) if(D[180][j].charCodeAt(0) !== 0xFFFD) { e[D[180][j]] = 46080 + j; d[46080 + j] = D[180][j];}
	D[181] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠�".split("");
	for(j = 0; j != D[181].length; ++j) if(D[181][j].charCodeAt(0) !== 0xFFFD) { e[D[181][j]] = 46336 + j; d[46336 + j] = D[181][j];}
	D[182] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二�".split("");
	for(j = 0; j != D[182].length; ++j) if(D[182][j].charCodeAt(0) !== 0xFFFD) { e[D[182][j]] = 46592 + j; d[46592 + j] = D[182][j];}
	D[183] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服�".split("");
	for(j = 0; j != D[183].length; ++j) if(D[183][j].charCodeAt(0) !== 0xFFFD) { e[D[183][j]] = 46848 + j; d[46848 + j] = D[183][j];}
	D[184] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹�".split("");
	for(j = 0; j != D[184].length; ++j) if(D[184][j].charCodeAt(0) !== 0xFFFD) { e[D[184][j]] = 47104 + j; d[47104 + j] = D[184][j];}
	D[185] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈�".split("");
	for(j = 0; j != D[185].length; ++j) if(D[185][j].charCodeAt(0) !== 0xFFFD) { e[D[185][j]] = 47360 + j; d[47360 + j] = D[185][j];}
	D[186] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖�".split("");
	for(j = 0; j != D[186].length; ++j) if(D[186][j].charCodeAt(0) !== 0xFFFD) { e[D[186][j]] = 47616 + j; d[47616 + j] = D[186][j];}
	D[187] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕�".split("");
	for(j = 0; j != D[187].length; ++j) if(D[187][j].charCodeAt(0) !== 0xFFFD) { e[D[187][j]] = 47872 + j; d[47872 + j] = D[187][j];}
	D[188] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件�".split("");
	for(j = 0; j != D[188].length; ++j) if(D[188][j].charCodeAt(0) !== 0xFFFD) { e[D[188][j]] = 48128 + j; d[48128 + j] = D[188][j];}
	D[189] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸�".split("");
	for(j = 0; j != D[189].length; ++j) if(D[189][j].charCodeAt(0) !== 0xFFFD) { e[D[189][j]] = 48384 + j; d[48384 + j] = D[189][j];}
	D[190] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻�".split("");
	for(j = 0; j != D[190].length; ++j) if(D[190][j].charCodeAt(0) !== 0xFFFD) { e[D[190][j]] = 48640 + j; d[48640 + j] = D[190][j];}
	D[191] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀�".split("");
	for(j = 0; j != D[191].length; ++j) if(D[191][j].charCodeAt(0) !== 0xFFFD) { e[D[191][j]] = 48896 + j; d[48896 + j] = D[191][j];}
	D[192] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐�".split("");
	for(j = 0; j != D[192].length; ++j) if(D[192][j].charCodeAt(0) !== 0xFFFD) { e[D[192][j]] = 49152 + j; d[49152 + j] = D[192][j];}
	D[193] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿�".split("");
	for(j = 0; j != D[193].length; ++j) if(D[193][j].charCodeAt(0) !== 0xFFFD) { e[D[193][j]] = 49408 + j; d[49408 + j] = D[193][j];}
	D[194] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫�".split("");
	for(j = 0; j != D[194].length; ++j) if(D[194][j].charCodeAt(0) !== 0xFFFD) { e[D[194][j]] = 49664 + j; d[49664 + j] = D[194][j];}
	D[195] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸�".split("");
	for(j = 0; j != D[195].length; ++j) if(D[195][j].charCodeAt(0) !== 0xFFFD) { e[D[195][j]] = 49920 + j; d[49920 + j] = D[195][j];}
	D[196] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁�".split("");
	for(j = 0; j != D[196].length; ++j) if(D[196][j].charCodeAt(0) !== 0xFFFD) { e[D[196][j]] = 50176 + j; d[50176 + j] = D[196][j];}
	D[197] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗�".split("");
	for(j = 0; j != D[197].length; ++j) if(D[197][j].charCodeAt(0) !== 0xFFFD) { e[D[197][j]] = 50432 + j; d[50432 + j] = D[197][j];}
	D[198] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐�".split("");
	for(j = 0; j != D[198].length; ++j) if(D[198][j].charCodeAt(0) !== 0xFFFD) { e[D[198][j]] = 50688 + j; d[50688 + j] = D[198][j];}
	D[199] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠�".split("");
	for(j = 0; j != D[199].length; ++j) if(D[199][j].charCodeAt(0) !== 0xFFFD) { e[D[199][j]] = 50944 + j; d[50944 + j] = D[199][j];}
	D[200] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁�".split("");
	for(j = 0; j != D[200].length; ++j) if(D[200][j].charCodeAt(0) !== 0xFFFD) { e[D[200][j]] = 51200 + j; d[51200 + j] = D[200][j];}
	D[201] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳�".split("");
	for(j = 0; j != D[201].length; ++j) if(D[201][j].charCodeAt(0) !== 0xFFFD) { e[D[201][j]] = 51456 + j; d[51456 + j] = D[201][j];}
	D[202] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱�".split("");
	for(j = 0; j != D[202].length; ++j) if(D[202][j].charCodeAt(0) !== 0xFFFD) { e[D[202][j]] = 51712 + j; d[51712 + j] = D[202][j];}
	D[203] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔�".split("");
	for(j = 0; j != D[203].length; ++j) if(D[203][j].charCodeAt(0) !== 0xFFFD) { e[D[203][j]] = 51968 + j; d[51968 + j] = D[203][j];}
	D[204] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃�".split("");
	for(j = 0; j != D[204].length; ++j) if(D[204][j].charCodeAt(0) !== 0xFFFD) { e[D[204][j]] = 52224 + j; d[52224 + j] = D[204][j];}
	D[205] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威�".split("");
	for(j = 0; j != D[205].length; ++j) if(D[205][j].charCodeAt(0) !== 0xFFFD) { e[D[205][j]] = 52480 + j; d[52480 + j] = D[205][j];}
	D[206] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺�".split("");
	for(j = 0; j != D[206].length; ++j) if(D[206][j].charCodeAt(0) !== 0xFFFD) { e[D[206][j]] = 52736 + j; d[52736 + j] = D[206][j];}
	D[207] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓�".split("");
	for(j = 0; j != D[207].length; ++j) if(D[207][j].charCodeAt(0) !== 0xFFFD) { e[D[207][j]] = 52992 + j; d[52992 + j] = D[207][j];}
	D[208] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄�".split("");
	for(j = 0; j != D[208].length; ++j) if(D[208][j].charCodeAt(0) !== 0xFFFD) { e[D[208][j]] = 53248 + j; d[53248 + j] = D[208][j];}
	D[209] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶�".split("");
	for(j = 0; j != D[209].length; ++j) if(D[209][j].charCodeAt(0) !== 0xFFFD) { e[D[209][j]] = 53504 + j; d[53504 + j] = D[209][j];}
	D[210] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐�".split("");
	for(j = 0; j != D[210].length; ++j) if(D[210][j].charCodeAt(0) !== 0xFFFD) { e[D[210][j]] = 53760 + j; d[53760 + j] = D[210][j];}
	D[211] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉�".split("");
	for(j = 0; j != D[211].length; ++j) if(D[211][j].charCodeAt(0) !== 0xFFFD) { e[D[211][j]] = 54016 + j; d[54016 + j] = D[211][j];}
	D[212] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧�".split("");
	for(j = 0; j != D[212].length; ++j) if(D[212][j].charCodeAt(0) !== 0xFFFD) { e[D[212][j]] = 54272 + j; d[54272 + j] = D[212][j];}
	D[213] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政�".split("");
	for(j = 0; j != D[213].length; ++j) if(D[213][j].charCodeAt(0) !== 0xFFFD) { e[D[213][j]] = 54528 + j; d[54528 + j] = D[213][j];}
	D[214] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑�".split("");
	for(j = 0; j != D[214].length; ++j) if(D[214][j].charCodeAt(0) !== 0xFFFD) { e[D[214][j]] = 54784 + j; d[54784 + j] = D[214][j];}
	D[215] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座������".split("");
	for(j = 0; j != D[215].length; ++j) if(D[215][j].charCodeAt(0) !== 0xFFFD) { e[D[215][j]] = 55040 + j; d[55040 + j] = D[215][j];}
	D[216] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝�".split("");
	for(j = 0; j != D[216].length; ++j) if(D[216][j].charCodeAt(0) !== 0xFFFD) { e[D[216][j]] = 55296 + j; d[55296 + j] = D[216][j];}
	D[217] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼�".split("");
	for(j = 0; j != D[217].length; ++j) if(D[217][j].charCodeAt(0) !== 0xFFFD) { e[D[217][j]] = 55552 + j; d[55552 + j] = D[217][j];}
	D[218] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺�".split("");
	for(j = 0; j != D[218].length; ++j) if(D[218][j].charCodeAt(0) !== 0xFFFD) { e[D[218][j]] = 55808 + j; d[55808 + j] = D[218][j];}
	D[219] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝�".split("");
	for(j = 0; j != D[219].length; ++j) if(D[219][j].charCodeAt(0) !== 0xFFFD) { e[D[219][j]] = 56064 + j; d[56064 + j] = D[219][j];}
	D[220] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥�".split("");
	for(j = 0; j != D[220].length; ++j) if(D[220][j].charCodeAt(0) !== 0xFFFD) { e[D[220][j]] = 56320 + j; d[56320 + j] = D[220][j];}
	D[221] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺�".split("");
	for(j = 0; j != D[221].length; ++j) if(D[221][j].charCodeAt(0) !== 0xFFFD) { e[D[221][j]] = 56576 + j; d[56576 + j] = D[221][j];}
	D[222] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖�".split("");
	for(j = 0; j != D[222].length; ++j) if(D[222][j].charCodeAt(0) !== 0xFFFD) { e[D[222][j]] = 56832 + j; d[56832 + j] = D[222][j];}
	D[223] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼�".split("");
	for(j = 0; j != D[223].length; ++j) if(D[223][j].charCodeAt(0) !== 0xFFFD) { e[D[223][j]] = 57088 + j; d[57088 + j] = D[223][j];}
	D[224] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼�".split("");
	for(j = 0; j != D[224].length; ++j) if(D[224][j].charCodeAt(0) !== 0xFFFD) { e[D[224][j]] = 57344 + j; d[57344 + j] = D[224][j];}
	D[225] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺�".split("");
	for(j = 0; j != D[225].length; ++j) if(D[225][j].charCodeAt(0) !== 0xFFFD) { e[D[225][j]] = 57600 + j; d[57600 + j] = D[225][j];}
	D[226] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧饨饩饪饫饬饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂�".split("");
	for(j = 0; j != D[226].length; ++j) if(D[226][j].charCodeAt(0) !== 0xFFFD) { e[D[226][j]] = 57856 + j; d[57856 + j] = D[226][j];}
	D[227] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾�".split("");
	for(j = 0; j != D[227].length; ++j) if(D[227][j].charCodeAt(0) !== 0xFFFD) { e[D[227][j]] = 58112 + j; d[58112 + j] = D[227][j];}
	D[228] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑�".split("");
	for(j = 0; j != D[228].length; ++j) if(D[228][j].charCodeAt(0) !== 0xFFFD) { e[D[228][j]] = 58368 + j; d[58368 + j] = D[228][j];}
	D[229] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣�".split("");
	for(j = 0; j != D[229].length; ++j) if(D[229][j].charCodeAt(0) !== 0xFFFD) { e[D[229][j]] = 58624 + j; d[58624 + j] = D[229][j];}
	D[230] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩�".split("");
	for(j = 0; j != D[230].length; ++j) if(D[230][j].charCodeAt(0) !== 0xFFFD) { e[D[230][j]] = 58880 + j; d[58880 + j] = D[230][j];}
	D[231] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡缢缣缤缥缦缧缪缫缬缭缯缰缱缲缳缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬�".split("");
	for(j = 0; j != D[231].length; ++j) if(D[231][j].charCodeAt(0) !== 0xFFFD) { e[D[231][j]] = 59136 + j; d[59136 + j] = D[231][j];}
	D[232] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹�".split("");
	for(j = 0; j != D[232].length; ++j) if(D[232][j].charCodeAt(0) !== 0xFFFD) { e[D[232][j]] = 59392 + j; d[59392 + j] = D[232][j];}
	D[233] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋�".split("");
	for(j = 0; j != D[233].length; ++j) if(D[233][j].charCodeAt(0) !== 0xFFFD) { e[D[233][j]] = 59648 + j; d[59648 + j] = D[233][j];}
	D[234] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰�".split("");
	for(j = 0; j != D[234].length; ++j) if(D[234][j].charCodeAt(0) !== 0xFFFD) { e[D[234][j]] = 59904 + j; d[59904 + j] = D[234][j];}
	D[235] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻�".split("");
	for(j = 0; j != D[235].length; ++j) if(D[235][j].charCodeAt(0) !== 0xFFFD) { e[D[235][j]] = 60160 + j; d[60160 + j] = D[235][j];}
	D[236] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐�".split("");
	for(j = 0; j != D[236].length; ++j) if(D[236][j].charCodeAt(0) !== 0xFFFD) { e[D[236][j]] = 60416 + j; d[60416 + j] = D[236][j];}
	D[237] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨�".split("");
	for(j = 0; j != D[237].length; ++j) if(D[237][j].charCodeAt(0) !== 0xFFFD) { e[D[237][j]] = 60672 + j; d[60672 + j] = D[237][j];}
	D[238] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶钷钸钹钺钼钽钿铄铈铉铊铋铌铍铎铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪�".split("");
	for(j = 0; j != D[238].length; ++j) if(D[238][j].charCodeAt(0) !== 0xFFFD) { e[D[238][j]] = 60928 + j; d[60928 + j] = D[238][j];}
	D[239] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒锓锔锕锖锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤镥镦镧镨镩镪镫镬镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔�".split("");
	for(j = 0; j != D[239].length; ++j) if(D[239][j].charCodeAt(0) !== 0xFFFD) { e[D[239][j]] = 61184 + j; d[61184 + j] = D[239][j];}
	D[240] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨鸩鸪鸫鸬鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦鹧鹨鹩鹪鹫鹬鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙�".split("");
	for(j = 0; j != D[240].length; ++j) if(D[240][j].charCodeAt(0) !== 0xFFFD) { e[D[240][j]] = 61440 + j; d[61440 + j] = D[240][j];}
	D[241] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃�".split("");
	for(j = 0; j != D[241].length; ++j) if(D[241][j].charCodeAt(0) !== 0xFFFD) { e[D[241][j]] = 61696 + j; d[61696 + j] = D[241][j];}
	D[242] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒�".split("");
	for(j = 0; j != D[242].length; ++j) if(D[242][j].charCodeAt(0) !== 0xFFFD) { e[D[242][j]] = 61952 + j; d[61952 + j] = D[242][j];}
	D[243] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋�".split("");
	for(j = 0; j != D[243].length; ++j) if(D[243][j].charCodeAt(0) !== 0xFFFD) { e[D[243][j]] = 62208 + j; d[62208 + j] = D[243][j];}
	D[244] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤�".split("");
	for(j = 0; j != D[244].length; ++j) if(D[244][j].charCodeAt(0) !== 0xFFFD) { e[D[244][j]] = 62464 + j; d[62464 + j] = D[244][j];}
	D[245] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜�".split("");
	for(j = 0; j != D[245].length; ++j) if(D[245][j].charCodeAt(0) !== 0xFFFD) { e[D[245][j]] = 62720 + j; d[62720 + j] = D[245][j];}
	D[246] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅龆龇龈龉龊龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞鲟鲠鲡鲢鲣鲥鲦鲧鲨鲩鲫鲭鲮鲰鲱鲲鲳鲴鲵鲶鲷鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋�".split("");
	for(j = 0; j != D[246].length; ++j) if(D[246][j].charCodeAt(0) !== 0xFFFD) { e[D[246][j]] = 62976 + j; d[62976 + j] = D[246][j];}
	D[247] = "�����������������������������������������������������������������������������������������������������������������������������������������������������������������鳌鳍鳎鳏鳐鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄�".split("");
	for(j = 0; j != D[247].length; ++j) if(D[247][j].charCodeAt(0) !== 0xFFFD) { e[D[247][j]] = 63232 + j; d[63232 + j] = D[247][j];}
	return {"enc": e, "dec": d }; })();
	cptable[10029] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄĀāÉĄÖÜáąČäčĆćéŹźĎíďĒēĖóėôöõúĚěü†°Ę£§•¶ß®©™ę¨≠ģĮįĪ≤≥īĶ∂∑łĻļĽľĹĺŅņŃ¬√ńŇ∆«»… ňŐÕőŌ–—“”‘’÷◊ōŔŕŘ‹›řŖŗŠ‚„šŚśÁŤťÍŽžŪÓÔūŮÚůŰűŲųÝýķŻŁżĢˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10079] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûüÝ°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸ⁄¤ÐðÞþý·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙıˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[10081] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ÄÅÇÉÑÖÜáàâäãåçéèêëíìîïñóòôöõúùûü†°¢£§•¶ß®©™´¨≠ÆØ∞±≤≥¥µ∂∑∏π∫ªºΩæø¿¡¬√ƒ≈∆«»… ÀÃÕŒœ–—“”‘’÷◊ÿŸĞğİıŞş‡·‚„‰ÂÊÁËÈÍÎÏÌÓÔ�ÒÚÛÙ�ˆ˜¯˘˙˚¸˝˛ˇ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	cptable[28591] = (function(){ var d = "\u0000\u0001\u0002\u0003\u0004\u0005\u0006\u0007\b\t\n\u000b\f\r\u000e\u000f\u0010\u0011\u0012\u0013\u0014\u0015\u0016\u0017\u0018\u0019\u001a\u001b\u001c\u001d\u001e\u001f !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~ ¡¢£¤¥¦§¨©ª«¬­®¯°±²³´µ¶·¸¹º»¼½¾¿ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖ×ØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõö÷øùúûüýþÿ", D = [], e = {}; for(var i=0;i!=d.length;++i) { if(d.charCodeAt(i) !== 0xFFFD) e[d.charAt(i)] = i; D[i] = d.charAt(i); } return {"enc": e, "dec": D }; })();
	// eslint-disable-next-line no-undef
	if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = cptable;
	/*! cputils.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ft=javascript: */
	/*jshint newcap: false */
	(function(root, factory) {
	  /*jshint ignore:start */
	  /*eslint-disable */
	  "use strict";
	  if(typeof cptable === "undefined") {
	    if(true){
	      var cpt = cptable;
	      if (typeof module !== 'undefined' && module.exports && typeof DO_NOT_EXPORT_CODEPAGE === 'undefined') module.exports = factory(cpt);
	      else root.cptable = factory(cpt);
	    } else throw new Error("cptable not found");
	  } else cptable = factory(cptable);
	  /*eslint-enable */
	  /*jshint ignore:end */
	}(this, function(cpt){
	  "use strict";
	  /*global module, Buffer */
	  var magic = {
	    "1200":"utf16le",
	    "1201":"utf16be",
	    "12000":"utf32le",
	    "12001":"utf32be",
	    "16969":"utf64le",
	    "20127":"ascii",
	    "65000":"utf7",
	    "65001":"utf8"
	  };
	
	  var sbcs_cache = [874,1250,1251,1252,1253,1254,1255,1256,10000];
	  var dbcs_cache = [932,936,949,950];
	  var magic_cache = [65001];
	  var magic_decode = {};
	  var magic_encode = {};
	  var cpdcache = {};
	  var cpecache = {};
	
	  var sfcc = function sfcc(x) { return String.fromCharCode(x); };
	  var cca = function cca(x) { return x.charCodeAt(0); };
	
	  var has_buf = (typeof Buffer !== 'undefined');
	  var Buffer_from = function(){};
	  if(has_buf) {
	    var nbfs = !Buffer.from;
	    if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
	    Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
	    // $FlowIgnore
	    if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };
	
	    var mdl = 1024, mdb = Buffer.allocUnsafe(mdl);
	    var make_EE = function make_EE(E){
	      var EE = Buffer.allocUnsafe(65536);
	      for(var i = 0; i < 65536;++i) EE[i] = 0;
	      var keys = Object.keys(E), len = keys.length;
	      for(var ee = 0, e = keys[ee]; ee < len; ++ee) {
	        if(!(e = keys[ee])) continue;
	        EE[e.charCodeAt(0)] = E[e];
	      }
	      return EE;
	    };
	    var sbcs_encode = function make_sbcs_encode(cp) {
	      var EE = make_EE(cpt[cp].enc);
	      return function sbcs_e(data, ofmt) {
	        var len = data.length;
	        var out, i=0, j=0, D=0, w=0;
	        if(typeof data === 'string') {
	          out = Buffer.allocUnsafe(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data.charCodeAt(i)];
	        } else if(Buffer.isBuffer(data)) {
	          out = Buffer.allocUnsafe(2*len);
	          j = 0;
	          for(i = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) out[j++] = EE[D];
	            else if(D < 224) { out[j++] = EE[((D&31)<<6)+(data[i+1]&63)]; ++i; }
	            else if(D < 240) { out[j++] = EE[((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63)]; i+=2; }
	            else {
	              w = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3;
	              if(w < 65536) out[j++] = EE[w];
	              else { w -= 65536; out[j++] = EE[0xD800 + ((w>>10)&1023)]; out[j++] = EE[0xDC00 + (w&1023)]; }
	            }
	          }
	          out = out.slice(0,j);
	        } else {
	          out = Buffer.allocUnsafe(len);
	          for(i = 0; i < len; ++i) out[i] = EE[data[i].charCodeAt(0)];
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var sbcs_decode = function make_sbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = Buffer.allocUnsafe(131072), d=0, c="";
	      for(d=0;d<D.length;++d) {
	        if(!(c=D[d])) continue;
	        var w = c.charCodeAt(0);
	        DD[2*d] = w&255; DD[2*d+1] = w>>8;
	      }
	      return function sbcs_d(data) {
	        var len = data.length, i=0, j=0;
	        if(2 * len > mdl) { mdl = 2 * len; mdb = Buffer.allocUnsafe(mdl); }
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            mdb[2*i] = DD[j]; mdb[2*i+1] = DD[j+1];
	          }
	        }
	        return mdb.slice(0, 2 * len).toString('ucs2');
	      };
	    };
	    var dbcs_encode = function make_dbcs_encode(cp) {
	      var E = cpt[cp].enc;
	      var EE = Buffer.allocUnsafe(131072);
	      for(var i = 0; i < 131072; ++i) EE[i] = 0;
	      var keys = Object.keys(E);
	      for(var ee = 0, e = keys[ee]; ee < keys.length; ++ee) {
	        if(!(e = keys[ee])) continue;
	        var f = e.charCodeAt(0);
	        EE[2*f] = E[e] & 255; EE[2*f+1] = E[e]>>8;
	      }
	      return function dbcs_e(data, ofmt) {
	        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, jj=0, k=0, D=0;
	        if(typeof data === 'string') {
	          for(i = k = 0; i < len; ++i) {
	            j = data.charCodeAt(i)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	          out = out.slice(0,k);
	        } else if(Buffer.isBuffer(data)) {
	          for(i = k = 0; i < len; ++i) {
	            D = data[i];
	            if(D < 128) j = D;
	            else if(D < 224) { j = ((D&31)<<6)+(data[i+1]&63); ++i; }
	            else if(D < 240) { j = ((D&15)<<12)+((data[i+1]&63)<<6)+(data[i+2]&63); i+=2; }
	            else { j = ((D&7)<<18)+((data[i+1]&63)<<12)+((data[i+2]&63)<<6)+(data[i+3]&63); i+=3; }
	            if(j<65536) { j*=2; out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j]; }
	            else { jj = j-65536;
	              j=2*(0xD800 + ((jj>>10)&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	              j=2*(0xDC00 + (jj&1023)); out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	            }
	          }
	          out = out.slice(0,k);
	        } else {
	          for(i = k = 0; i < len; i++) {
	            j = data[i].charCodeAt(0)*2;
	            out[k++] = EE[j+1] || EE[j]; if(EE[j+1] > 0) out[k++] = EE[j];
	          }
	        }
	        if(!ofmt || ofmt === 'buf') return out;
	        if(ofmt !== 'arr') return out.toString('binary');
	        return [].slice.call(out);
	      };
	    };
	    var dbcs_decode = function make_dbcs_decode(cp) {
	      var D = cpt[cp].dec;
	      var DD = Buffer.allocUnsafe(131072), d=0, c, w=0, j=0, i=0;
	      for(i = 0; i < 65536; ++i) { DD[2*i] = 0xFF; DD[2*i+1] = 0xFD;}
	      for(d = 0; d < D.length; ++d) {
	        if(!(c=D[d])) continue;
	        w = c.charCodeAt(0);
	        j = 2*d;
	        DD[j] = w&255; DD[j+1] = w>>8;
	      }
	      return function dbcs_d(data) {
	        var len = data.length, out = Buffer.allocUnsafe(2*len), i=0, j=0, k=0;
	        if(Buffer.isBuffer(data)) {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else if(typeof data === "string") {
	          for(i = 0; i < len; i++) {
	            j = 2*data.charCodeAt(i);
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data.charCodeAt(i)<<8)+data.charCodeAt(i+1)); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        } else {
	          for(i = 0; i < len; i++) {
	            j = 2*data[i];
	            if(DD[j]===0xFF && DD[j+1]===0xFD) { j=2*((data[i]<<8)+data[i+1]); ++i; }
	            out[k++] = DD[j]; out[k++] = DD[j+1];
	          }
	        }
	        return out.slice(0,k).toString('ucs2');
	      };
	    };
	    magic_decode[65001] = function utf8_d(data) {
	      if(typeof data === "string") return utf8_d(data.split("").map(cca));
	      var len = data.length, w = 0, ww = 0;
	      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
	      var i = 0;
	      if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	      for(var j = 1, k = 0, D = 0; i < len; i+=j) {
	        j = 1; D = data[i];
	        if(D < 128) w = D;
	        else if(D < 224) { w=(D&31)*64+(data[i+1]&63); j=2; }
	        else if(D < 240) { w=((D&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	        else { w=(D&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	        if(w < 65536) { mdb[k++] = w&255; mdb[k++] = w>>8; }
	        else {
	          w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	          mdb[k++] = ww&255; mdb[k++] = ww>>>8; mdb[k++] = w&255; mdb[k++] = (w>>>8)&255;
	        }
	      }
	      return mdb.slice(0,k).toString('ucs2');
	    };
	    magic_encode[65001] = function utf8_e(data, ofmt) {
	      if(has_buf && Buffer.isBuffer(data)) {
	        if(!ofmt || ofmt === 'buf') return data;
	        if(ofmt !== 'arr') return data.toString('binary');
	        return [].slice.call(data);
	      }
	      var len = data.length, w = 0, ww = 0, j = 0;
	      var direct = typeof data === "string";
	      if(4 * len > mdl) { mdl = 4 * len; mdb = Buffer.allocUnsafe(mdl); }
	      for(var i = 0; i < len; ++i) {
	        w = direct ? data.charCodeAt(i) : data[i].charCodeAt(0);
	        if(w <= 0x007F) mdb[j++] = w;
	        else if(w <= 0x07FF) {
	          mdb[j++] = 192 + (w >> 6);
	          mdb[j++] = 128 + (w&63);
	        } else if(w >= 0xD800 && w <= 0xDFFF) {
	          w -= 0xD800; ++i;
	          ww = (direct ? data.charCodeAt(i) : data[i].charCodeAt(0)) - 0xDC00 + (w << 10);
	          mdb[j++] = 240 + ((ww>>>18) & 0x07);
	          mdb[j++] = 144 + ((ww>>>12) & 0x3F);
	          mdb[j++] = 128 + ((ww>>>6) & 0x3F);
	          mdb[j++] = 128 + (ww & 0x3F);
	        } else {
	          mdb[j++] = 224 + (w >> 12);
	          mdb[j++] = 128 + ((w >> 6)&63);
	          mdb[j++] = 128 + (w&63);
	        }
	      }
	      if(!ofmt || ofmt === 'buf') return mdb.slice(0,j);
	      if(ofmt !== 'arr') return mdb.slice(0,j).toString('binary');
	      return [].slice.call(mdb, 0, j);
	    };
	  }
	
	  var encache = function encache() {
	    if(has_buf) {
	      if(cpdcache[sbcs_cache[0]]) return;
	      var i=0, s=0;
	      for(i = 0; i < sbcs_cache.length; ++i) {
	        s = sbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = sbcs_decode(s);
	          cpecache[s] = sbcs_encode(s);
	        }
	      }
	      for(i = 0; i < dbcs_cache.length; ++i) {
	        s = dbcs_cache[i];
	        if(cpt[s]) {
	          cpdcache[s] = dbcs_decode(s);
	          cpecache[s] = dbcs_encode(s);
	        }
	      }
	      for(i = 0; i < magic_cache.length; ++i) {
	        s = magic_cache[i];
	        if(magic_decode[s]) cpdcache[s] = magic_decode[s];
	        if(magic_encode[s]) cpecache[s] = magic_encode[s];
	      }
	    }
	  };
	  var null_enc = function(data, ofmt) { void ofmt; return ""; };
	  var cp_decache = function cp_decache(cp) { delete cpdcache[cp]; delete cpecache[cp]; };
	  var decache = function decache() {
	    if(has_buf) {
	      if(!cpdcache[sbcs_cache[0]]) return;
	      sbcs_cache.forEach(cp_decache);
	      dbcs_cache.forEach(cp_decache);
	      magic_cache.forEach(cp_decache);
	    }
	    last_enc = null_enc; last_cp = 0;
	  };
	  var cache = {
	    encache: encache,
	    decache: decache,
	    sbcs: sbcs_cache,
	    dbcs: dbcs_cache
	  };
	
	  encache();
	
	  var BM = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
	  var SetD = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'(),-./:?";
	  var last_enc = null_enc, last_cp = 0;
	  var encode = function encode(cp, data, ofmt) {
	    if(cp === last_cp && last_enc) { return last_enc(data, ofmt); }
	    if(cpecache[cp]) { last_enc = cpecache[last_cp=cp]; return last_enc(data, ofmt); }
	    if(has_buf && Buffer.isBuffer(data)) data = data.toString('utf8');
	    var len = data.length;
	    var out = has_buf ? Buffer.allocUnsafe(4*len) : [], w=0, i=0, j = 0, ww=0;
	    var C = cpt[cp], E, M = "";
	    var isstr = typeof data === 'string';
	    if(C && (E=C.enc)) for(i = 0; i < len; ++i, ++j) {
	      w = E[isstr? data.charAt(i) : data[i]];
	      if(w > 255) {
	        out[j] = w>>8;
	        out[++j] = w&255;
	      } else out[j] = w&255;
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(has_buf && isstr) { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else if(w <= 0x07FF) {
	            out[j]   = 192 + (w >> 6);
	            out[++j] = 128 + (w&63);
	          } else if(w >= 0xD800 && w <= 0xDFFF) {
	            w -= 0xD800;
	            ww = (isstr ? data.charCodeAt(++i) : data[++i].charCodeAt(0)) - 0xDC00 + (w << 10);
	            out[j]   = 240 + ((ww>>>18) & 0x07);
	            out[++j] = 144 + ((ww>>>12) & 0x3F);
	            out[++j] = 128 + ((ww>>>6) & 0x3F);
	            out[++j] = 128 + (ww & 0x3F);
	          } else {
	            out[j]   = 224 + (w >> 12);
	            out[++j] = 128 + ((w >> 6)&63);
	            out[++j] = 128 + (w&63);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i, ++j) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w <= 0x007F) out[j] = w;
	          else throw new Error("bad ascii " + w);
	        }
	        break;
	      case "utf16le":
	        if(has_buf && typeof data === "string") { out = Buffer_from(data, M); j = out.length; break; }
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w&255;
	          out[j++] = w>>8;
	        }
	        break;
	      case "utf16be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          out[j++] = w>>8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32le":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255; w >>= 8;
	          out[j++] = w&255;
	        }
	        break;
	      case "utf32be":
	        for(i = 0; i < len; ++i) {
	          w = isstr ? data.charCodeAt(i) : data[i].charCodeAt(0);
	          if(w >= 0xD800 && w <= 0xDFFF) w = 0x10000 + ((w - 0xD800) << 10) + (data[++i].charCodeAt(0) - 0xDC00);
	          out[j+3] = w&255; w >>= 8;
	          out[j+2] = w&255; w >>= 8;
	          out[j+1] = w&255; w >>= 8;
	          out[j] = w&255;
	          j+=4;
	        }
	        break;
	      case "utf7":
	        for(i = 0; i < len; i++) {
	          var c = isstr ? data.charAt(i) : data[i].charAt(0);
	          if(c === "+") { out[j++] = 0x2b; out[j++] = 0x2d; continue; }
	          if(SetD.indexOf(c) > -1) { out[j++] = c.charCodeAt(0); continue; }
	          var tt = encode(1201, c);
	          out[j++] = 0x2b;
	          out[j++] = BM.charCodeAt(tt[0]>>2);
	          out[j++] = BM.charCodeAt(((tt[0]&0x03)<<4) + ((tt[1]||0)>>4));
	          out[j++] = BM.charCodeAt(((tt[1]&0x0F)<<2) + ((tt[2]||0)>>6));
	          out[j++] = 0x2d;
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    out = out.slice(0,j);
	    if(!has_buf) return (ofmt == 'str') ? (out).map(sfcc).join("") : out;
	    if(!ofmt || ofmt === 'buf') return out;
	    if(ofmt !== 'arr') return out.toString('binary');
	    return [].slice.call(out);
	  };
	  var decode = function decode(cp, data) {
	    var F; if((F=cpdcache[cp])) return F(data);
	    if(typeof data === "string") return decode(cp, data.split("").map(cca));
	    var len = data.length, out = new Array(len), s="", w=0, i=0, j=1, k=0, ww=0;
	    var C = cpt[cp], D, M="";
	    if(C && (D=C.dec)) {
	      for(i = 0; i < len; i+=j) {
	        j = 2;
	        s = D[(data[i]<<8)+ data[i+1]];
	        if(!s) {
	          j = 1;
	          s = D[data[i]];
	        }
	        if(!s) throw new Error('Unrecognized code: ' + data[i] + ' ' + data[i+j-1] + ' ' + i + ' ' + j + ' ' + D[data[i]]);
	        out[k++] = s;
	      }
	    }
	    else if((M=magic[cp])) switch(M) {
	      case "utf8":
	        if(len >= 3 && data[0] == 0xEF) if(data[1] == 0xBB && data[2] == 0xBF) i = 3;
	        for(; i < len; i+=j) {
	          j = 1;
	          if(data[i] < 128) w = data[i];
	          else if(data[i] < 224) { w=(data[i]&31)*64+(data[i+1]&63); j=2; }
	          else if(data[i] < 240) { w=((data[i]&15)<<12)+(data[i+1]&63)*64+(data[i+2]&63); j=3; }
	          else { w=(data[i]&7)*262144+((data[i+1]&63)<<12)+(data[i+2]&63)*64+(data[i+3]&63); j=4; }
	          if(w < 65536) { out[k++] = String.fromCharCode(w); }
	          else {
	            w -= 65536; ww = 0xD800 + ((w>>10)&1023); w = 0xDC00 + (w&1023);
	            out[k++] = String.fromCharCode(ww); out[k++] = String.fromCharCode(w);
	          }
	        }
	        break;
	      case "ascii":
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        for(i = 0; i < len; i++) out[i] = String.fromCharCode(data[i]);
	        k = len; break;
	      case "utf16le":
	        if(len >= 2 && data[0] == 0xFF) if(data[1] == 0xFE) i = 2;
	        if(has_buf && Buffer.isBuffer(data)) return data.toString(M);
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i+1]<<8) + data[i]);
	        }
	        break;
	      case "utf16be":
	        if(len >= 2 && data[0] == 0xFE) if(data[1] == 0xFF) i = 2;
	        j = 2;
	        for(; i+1 < len; i+=j) {
	          out[k++] = String.fromCharCode((data[i]<<8) + data[i+1]);
	        }
	        break;
	      case "utf32le":
	        if(len >= 4 && data[0] == 0xFF) if(data[1] == 0xFE && data[2] === 0 && data[3] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i+3]<<24) + (data[i+2]<<16) + (data[i+1]<<8) + (data[i]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf32be":
	        if(len >= 4 && data[3] == 0xFF) if(data[2] == 0xFE && data[1] === 0 && data[0] === 0) i = 4;
	        j = 4;
	        for(; i < len; i+=j) {
	          w = (data[i]<<24) + (data[i+1]<<16) + (data[i+2]<<8) + (data[i+3]);
	          if(w > 0xFFFF) {
	            w -= 0x10000;
	            out[k++] = String.fromCharCode(0xD800 + ((w >> 10) & 0x3FF));
	            out[k++] = String.fromCharCode(0xDC00 + (w & 0x3FF));
	          }
	          else out[k++] = String.fromCharCode(w);
	        }
	        break;
	      case "utf7":
	        if(len >= 4 && data[0] == 0x2B && data[1] == 0x2F && data[2] == 0x76) {
	          if(len >= 5 && data[3] == 0x38 && data[4] == 0x2D) i = 5;
	          else if(data[3] == 0x38 || data[3] == 0x39 || data[3] == 0x2B || data[3] == 0x2F) i = 4;
	        }
	        for(; i < len; i+=j) {
	          if(data[i] !== 0x2b) { j=1; out[k++] = String.fromCharCode(data[i]); continue; }
	          j=1;
	          if(data[i+1] === 0x2d) { j = 2; out[k++] = "+"; continue; }
	          // eslint-disable-next-line no-useless-escape
	          while(String.fromCharCode(data[i+j]).match(/[A-Za-z0-9+\/]/)) j++;
	          var dash = 0;
	          if(data[i+j] === 0x2d) { ++j; dash=1; }
	          var tt = [];
	          var o64 = "";
	          var c1=0, c2=0, c3=0;
	          var e1=0, e2=0, e3=0, e4=0;
	          for(var l = 1; l < j - dash;) {
	            e1 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            e2 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            c1 = e1 << 2 | e2 >> 4;
	            tt.push(c1);
	            e3 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e3 === -1) break;
	            c2 = (e2 & 15) << 4 | e3 >> 2;
	            tt.push(c2);
	            e4 = BM.indexOf(String.fromCharCode(data[i+l++]));
	            if(e4 === -1) break;
	            c3 = (e3 & 3) << 6 | e4;
	            if(e4 < 64) tt.push(c3);
	          }
	          o64 = decode(1201, tt);
	          for(l = 0; l < o64.length; ++l) out[k++] = o64.charAt(l);
	        }
	        break;
	      default: throw new Error("Unsupported magic: " + cp + " " + magic[cp]);
	    }
	    else throw new Error("Unrecognized CP: " + cp);
	    return out.slice(0,k).join("");
	  };
	  var hascp = function hascp(cp) { return !!(cpt[cp] || magic[cp]); };
	  cpt.utils = { decode: decode, encode: encode, hascp: hascp, magic: magic, cache:cache };
	  return cpt;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(297).Buffer))

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _getPrototypeOf(o);
	}
	
	module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(410);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  Object.defineProperty(subClass, "prototype", {
	    writable: false
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(49);
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(279)["default"];
	
	var assertThisInitialized = __webpack_require__(219);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  } else if (call !== void 0) {
	    throw new TypeError("Derived constructors may only return object or undefined");
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * Application Insights JavaScript SDK - React Plugin, 3.1.0
	 * Copyright (c) Microsoft and contributors. All rights reserved.
	 */
	(function (global, factory) {
	     true ? factory(exports) :
	    typeof define === 'function' && define.amd ? define(['exports'], factory) :
	    (factory((global.Microsoft = global.Microsoft || {}, global.Microsoft.ApplicationInsights = global.Microsoft.ApplicationInsights || {})));
	}(this, (function (exports) { 'use strict';
	
	    var strShimFunction = "function";
	    var strShimObject = "object";
	    var strShimUndefined = "undefined";
	    var strShimPrototype = "prototype";
	    var strShimHasOwnProperty = "hasOwnProperty";
	    /**
	     * Returns the current global scope object, for a normal web page this will be the current
	     * window, for a Web Worker this will be current worker global scope via "self". The internal
	     * implementation returns the first available instance object in the following order
	     * - globalThis (New standard)
	     * - self (Will return the current window instance for supported browsers)
	     * - window (fallback for older browser implementations)
	     * - global (NodeJS standard)
	     * - <null> (When all else fails)
	     * While the return type is a Window for the normal case, not all environments will support all
	     * of the properties or functions.
	     */
	    function getGlobal() {
	        if (typeof globalThis !== strShimUndefined && globalThis) {
	            return globalThis;
	        }
	        if (typeof self !== strShimUndefined && self) {
	            return self;
	        }
	        if (typeof window !== strShimUndefined && window) {
	            return window;
	        }
	        if (typeof global !== strShimUndefined && global) {
	            return global;
	        }
	        return null;
	    }
	    /**
	     * Creates an object that has the specified prototype, and that optionally contains specified properties. This helper exists to avoid adding a polyfil
	     * for older browsers that do not define Object.create eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
	     * Note: For consistency this will not use the Object.create implementation if it exists as this would cause a testing requirement to test with and without the implementations
	     * @param obj Object to use as a prototype. May be null
	     */
	    function objCreateFn(obj) {
	        var func = Object["create"];
	        // Use build in Object.create
	        if (func) {
	            // Use Object create method if it exists
	            return func(obj);
	        }
	        if (obj == null) {
	            return {};
	        }
	        var type = typeof obj;
	        if (type !== strShimObject && type !== strShimFunction) {
	            throw new TypeError('Object prototype may only be an Object:' + obj);
	        }
	        function tmpFunc() { }
	        tmpFunc[strShimPrototype] = obj;
	        return new tmpFunc();
	    }
	    function __assignFn(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object[strShimPrototype][strShimHasOwnProperty].call(s, p)) {
	                    t[p] = s[p];
	                }
	            }
	        }
	        return t;
	    }
	    // tslint:disable-next-line: only-arrow-functions
	    var __extendStaticsFn = function (d, b) {
	        __extendStaticsFn = Object["setPrototypeOf"] ||
	            // tslint:disable-next-line: only-arrow-functions
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            // tslint:disable-next-line: only-arrow-functions
	            function (d, b) {
	                for (var p in b) {
	                    if (b[strShimHasOwnProperty](p)) {
	                        d[p] = b[p];
	                    }
	                }
	            };
	        return __extendStaticsFn(d, b);
	    };
	    function __extendsFn(d, b) {
	        __extendStaticsFn(d, b);
	        function __() { this.constructor = d; }
	        // tslint:disable-next-line: ban-comma-operator
	        d[strShimPrototype] = b === null ? objCreateFn(b) : (__[strShimPrototype] = b[strShimPrototype], new __());
	    }
	    var globalObj = getGlobal() || {};
	    // tslint:disable: only-arrow-functions
	    (function (root, assignFn, extendsFn) {
	        // Assign the globally scoped versions of the functions -- used when consuming individual ts files
	        // If check is to support NativeScript where these are marked as readonly
	        if (!root.__assign) {
	            root.__assign = Object.assign || assignFn;
	        }
	        if (!root.__extends) {
	            root.__extends = extendsFn;
	        }
	    })(globalObj, __assignFn, __extendsFn);
	    // Assign local variables that will be used for embedded scenarios, if check is to support NativeScript where these are marked as readonly
	    if (!__assign) {
	        __assign = globalObj.__assign;
	    }
	    if (!__extends) {
	        __extends = globalObj.__extends;
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	
	
	    /**
	     * The EventsDiscardedReason enumeration contains a set of values that specify the reason for discarding an event.
	     */
	    var EventsDiscardedReason = {
	        /**
	         * Unknown.
	         */
	        Unknown: 0,
	        /**
	         * Status set to non-retryable.
	         */
	        NonRetryableStatus: 1,
	        /**
	         * The event is invalid.
	         */
	        InvalidEvent: 2,
	        /**
	         * The size of the event is too large.
	         */
	        SizeLimitExceeded: 3,
	        /**
	         * The server is not accepting events from this instrumentation key.
	         */
	        KillSwitch: 4,
	        /**
	         * The event queue is full.
	         */
	        QueueFull: 5
	    };
	
	    /*!
	     * Microsoft Dynamic Proto Utility, 1.1.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    /**
	     * Constant string defined to support minimization
	     * @ignore
	     */
	    var Constructor = 'constructor';
	    /**
	     * Constant string defined to support minimization
	     * @ignore
	     */
	    var Prototype = 'prototype';
	    /**
	     * Constant string defined to support minimization
	     * @ignore
	     */
	    var strFunction = 'function';
	    /**
	     * Used to define the name of the instance function lookup table
	     * @ignore
	     */
	    var DynInstFuncTable = '_dynInstFuncs';
	    /**
	     * Name used to tag the dynamic prototype function
	     * @ignore
	     */
	    var DynProxyTag = '_isDynProxy';
	    /**
	     * Name added to a prototype to define the dynamic prototype "class" name used to lookup the function table
	     * @ignore
	     */
	    var DynClassName = '_dynClass';
	    /**
	     * Prefix added to the classname to avoid any name clashes with other instance level properties
	     * @ignore
	     */
	    var DynClassNamePrefix = '_dynCls$';
	    /**
	     * A tag which is used to check if we have already to attempted to set the instance function if one is not present
	     * @ignore
	     */
	    var DynInstChkTag = '_dynInstChk';
	    /**
	     * A tag which is used to check if we are allows to try and set an instance function is one is not present. Using the same
	     * tag name as the function level but a different const name for readability only.
	     */
	    var DynAllowInstChkTag = DynInstChkTag;
	    /**
	     * The global (imported) instances where the global performance options are stored
	     */
	    var DynProtoDefaultOptions = '_dfOpts';
	    /**
	     * Value used as the name of a class when it cannot be determined
	     * @ignore
	     */
	    var UnknownValue = '_unknown_';
	    /**
	     * Constant string defined to support minimization
	     * @ignore
	     */
	    var str__Proto = "__proto__";
	    /**
	     * Constant string defined to support minimization
	     * @ignore
	     */
	    var strUseBaseInst = 'useBaseInst';
	    /**
	     * Constant string defined to support minimization
	     * @ignore
	     */
	    var strSetInstFuncs = 'setInstFuncs';
	    var Obj = Object;
	    /**
	     * Pre-lookup to check if we are running on a modern browser (i.e. not IE8)
	     * @ignore
	     */
	    var _objGetPrototypeOf = Obj["getPrototypeOf"];
	    /**
	     * Internal Global used to generate a unique dynamic class name, every new class will increase this value
	     * @ignore
	     */
	    var _dynamicNames = 0;
	    /**
	     * Helper to check if the object contains a property of the name
	     * @ignore
	     */
	    function _hasOwnProperty(obj, prop) {
	        return obj && Obj[Prototype].hasOwnProperty.call(obj, prop);
	    }
	    /**
	     * Helper used to check whether the target is an Object prototype or Array prototype
	     * @ignore
	     */
	    function _isObjectOrArrayPrototype(target) {
	        return target && (target === Obj[Prototype] || target === Array[Prototype]);
	    }
	    /**
	     * Helper used to check whether the target is an Object prototype, Array prototype or Function prototype
	     * @ignore
	     */
	    function _isObjectArrayOrFunctionPrototype(target) {
	        return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
	    }
	    /**
	     * Helper used to get the prototype of the target object as getPrototypeOf is not available in an ES3 environment.
	     * @ignore
	     */
	    function _getObjProto(target) {
	        if (target) {
	            // This method doesn't existing in older browsers (e.g. IE8)
	            if (_objGetPrototypeOf) {
	                return _objGetPrototypeOf(target);
	            }
	            // target[Constructor] May break if the constructor has been changed or removed
	            var newProto = target[str__Proto] || target[Prototype] || target[Constructor];
	            if (newProto) {
	                return newProto;
	            }
	        }
	        return null;
	    }
	    /**
	     * Helper to get the properties of an object, including none enumerable ones as functions on a prototype in ES6
	     * are not enumerable.
	     * @param target
	     */
	    function _forEachProp(target, func) {
	        var props = [];
	        var getOwnProps = Obj["getOwnPropertyNames"];
	        if (getOwnProps) {
	            props = getOwnProps(target);
	        }
	        else {
	            for (var name_1 in target) {
	                if (typeof name_1 === "string" && _hasOwnProperty(target, name_1)) {
	                    props.push(name_1);
	                }
	            }
	        }
	        if (props && props.length > 0) {
	            for (var lp = 0; lp < props.length; lp++) {
	                func(props[lp]);
	            }
	        }
	    }
	    /**
	     * Helper function to check whether the provided function name is a potential candidate for dynamic
	     * callback and prototype generation.
	     * @param target The target object, may be a prototype or class object
	     * @param funcName The function name
	     * @param skipOwn Skips the check for own property
	     * @ignore
	     */
	    function _isDynamicCandidate(target, funcName, skipOwn) {
	        return (funcName !== Constructor && typeof target[funcName] === strFunction && (skipOwn || _hasOwnProperty(target, funcName)));
	    }
	    /**
	     * Helper to throw a TypeError exception
	     * @param message the message
	     * @ignore
	     */
	    function _throwTypeError(message) {
	        throw new TypeError("DynamicProto: " + message);
	    }
	    /**
	     * Returns a collection of the instance functions that are defined directly on the thisTarget object, it does
	     * not return any inherited functions
	     * @param thisTarget The object to get the instance functions from
	     * @ignore
	     */
	    function _getInstanceFuncs(thisTarget) {
	        // Get the base proto
	        var instFuncs = {};
	        // Save any existing instance functions
	        _forEachProp(thisTarget, function (name) {
	            // Don't include any dynamic prototype instances - as we only want the real functions
	            if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
	                // Create an instance callback for passing the base function to the caller
	                instFuncs[name] = thisTarget[name];
	            }
	        });
	        return instFuncs;
	    }
	    /**
	     * Returns whether the value is included in the array
	     * @param values The array of values
	     * @param value  The value
	     */
	    function _hasVisited(values, value) {
	        for (var lp = values.length - 1; lp >= 0; lp--) {
	            if (values[lp] === value) {
	                return true;
	            }
	        }
	        return false;
	    }
	    /**
	     * Returns an object that contains callback functions for all "base/super" functions, this is used to "save"
	     * enabling calling super.xxx() functions without requiring that the base "class" has defined a prototype references
	     * @param target The current instance
	     * @ignore
	     */
	    function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
	        function _instFuncProxy(target, funcHost, funcName) {
	            var theFunc = funcHost[funcName];
	            if (theFunc[DynProxyTag] && useBaseInst) {
	                // grab and reuse the hosted looking function (if available) otherwise the original passed function
	                var instFuncTable = target[DynInstFuncTable] || {};
	                if (instFuncTable[DynAllowInstChkTag] !== false) {
	                    theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
	                }
	            }
	            return function () {
	                return theFunc.apply(target, arguments);
	            };
	        }
	        // Start creating a new baseFuncs by creating proxies for the instance functions (as they may get replaced)
	        var baseFuncs = {};
	        _forEachProp(instFuncs, function (name) {
	            // Create an instance callback for passing the base function to the caller
	            baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
	        });
	        // Get the base prototype functions
	        var baseProto = _getObjProto(classProto);
	        var visited = [];
	        // Don't include base object functions for Object, Array or Function
	        while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
	            // look for prototype functions
	            _forEachProp(baseProto, function (name) {
	                // Don't include any dynamic prototype instances - as we only want the real functions
	                // For IE 7/8 the prototype lookup doesn't provide the full chain so we need to bypass the 
	                // hasOwnProperty check we get all of the methods, main difference is that IE7/8 doesn't return
	                // the Object prototype methods while bypassing the check
	                if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf)) {
	                    // Create an instance callback for passing the base function to the caller
	                    baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
	                }
	            });
	            // We need to find all possible functions that might be overloaded by walking the entire prototype chain
	            // This avoids the caller from needing to check whether it's direct base class implements the function or not
	            // by walking the entire chain it simplifies the usage and issues from upgrading any of the base classes.
	            visited.push(baseProto);
	            baseProto = _getObjProto(baseProto);
	        }
	        return baseFuncs;
	    }
	    function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
	        var instFunc = null;
	        // We need to check whether the class name is defined directly on this prototype otherwise
	        // it will walk the proto chain and return any parent proto classname.
	        if (target && _hasOwnProperty(proto, DynClassName)) {
	            var instFuncTable = target[DynInstFuncTable] || {};
	            instFunc = (instFuncTable[proto[DynClassName]] || {})[funcName];
	            if (!instFunc) {
	                // Avoid stack overflow from recursive calling the same function
	                _throwTypeError("Missing [" + funcName + "] " + strFunction);
	            }
	            // We have the instance function, lets check it we can speed up further calls
	            // by adding the instance function back directly on the instance (avoiding the dynamic func lookup)
	            if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
	                // If the instance already has an instance function we can't replace it
	                var canAddInst = !_hasOwnProperty(target, funcName);
	                // Get current prototype
	                var objProto = _getObjProto(target);
	                var visited = [];
	                // Lookup the function starting at the top (instance level prototype) and traverse down, if the first matching function
	                // if nothing is found or if the first hit is a dynamic proto instance then we can safely add an instance shortcut
	                while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
	                    var protoFunc = objProto[funcName];
	                    if (protoFunc) {
	                        canAddInst = (protoFunc === currentDynProtoProxy);
	                        break;
	                    }
	                    // We need to find all possible initial functions to ensure that we don't bypass a valid override function
	                    visited.push(objProto);
	                    objProto = _getObjProto(objProto);
	                }
	                try {
	                    if (canAddInst) {
	                        // This instance doesn't have an instance func and the class hierarchy does have a higher level prototype version
	                        // so it's safe to directly assign for any subsequent calls (for better performance)
	                        target[funcName] = instFunc;
	                    }
	                    // Block further attempts to set the instance function for any
	                    instFunc[DynInstChkTag] = 1;
	                }
	                catch (e) {
	                    // Don't crash if the object is readonly or the runtime doesn't allow changing this
	                    // And set a flag so we don't try again for any function
	                    instFuncTable[DynAllowInstChkTag] = false;
	                }
	            }
	        }
	        return instFunc;
	    }
	    function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
	        var protoFunc = proto[funcName];
	        // Check that the prototype function is not a self reference -- try to avoid stack overflow!
	        if (protoFunc === currentDynProtoProxy) {
	            // It is so lookup the base prototype
	            protoFunc = _getObjProto(proto)[funcName];
	        }
	        if (typeof protoFunc !== strFunction) {
	            _throwTypeError("[" + funcName + "] is not a " + strFunction);
	        }
	        return protoFunc;
	    }
	    /**
	     * Add the required dynamic prototype methods to the the class prototype
	     * @param proto - The class prototype
	     * @param className - The instance classname
	     * @param target - The target instance
	     * @param baseInstFuncs - The base instance functions
	     * @param setInstanceFunc - Flag to allow prototype function to reset the instance function if one does not exist
	     * @ignore
	     */
	    function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
	        function _createDynamicPrototype(proto, funcName) {
	            var dynProtoProxy = function () {
	                // Use the instance or prototype function
	                var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
	                return instFunc.apply(this, arguments);
	            };
	            // Tag this function as a proxy to support replacing dynamic proxy elements (primary use case is for unit testing
	            // via which can dynamically replace the prototype function reference)
	            dynProtoProxy[DynProxyTag] = 1;
	            return dynProtoProxy;
	        }
	        if (!_isObjectOrArrayPrototype(proto)) {
	            var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || {};
	            var instFuncs_1 = instFuncTable[className] = (instFuncTable[className] || {}); // fetch and assign if as it may not exist yet
	            // Set whether we are allow to lookup instances, if someone has set to false then do not re-enable
	            if (instFuncTable[DynAllowInstChkTag] !== false) {
	                instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
	            }
	            _forEachProp(target, function (name) {
	                // Only add overridden functions
	                if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
	                    // Save the instance Function to the lookup table and remove it from the instance as it's not a dynamic proto function
	                    instFuncs_1[name] = target[name];
	                    delete target[name];
	                    // Add a dynamic proto if one doesn't exist or if a prototype function exists and it's not a dynamic one
	                    if (!_hasOwnProperty(proto, name) || (proto[name] && !proto[name][DynProxyTag])) {
	                        proto[name] = _createDynamicPrototype(proto, name);
	                    }
	                }
	            });
	        }
	    }
	    /**
	     * Checks whether the passed prototype object appears to be correct by walking the prototype hierarchy of the instance
	     * @param classProto The class prototype instance
	     * @param thisTarget The current instance that will be checked whether the passed prototype instance is in the hierarchy
	     * @ignore
	     */
	    function _checkPrototype(classProto, thisTarget) {
	        var thisProto = _getObjProto(thisTarget);
	        while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto)) {
	            if (thisProto === classProto) {
	                return true;
	            }
	            thisProto = _getObjProto(thisProto);
	        }
	        return false;
	    }
	    /**
	     * Gets the current prototype name using the ES6 name if available otherwise falling back to a use unknown as the name.
	     * It's not critical for this to return a name, it's used to decorate the generated unique name for easier debugging only.
	     * @param target
	     * @param unknownValue
	     * @ignore
	     */
	    function _getObjName(target, unknownValue) {
	        if (_hasOwnProperty(target, Prototype)) {
	            // Look like a prototype
	            return target.name || unknownValue || UnknownValue;
	        }
	        return (((target || {})[Constructor]) || {}).name || unknownValue || UnknownValue;
	    }
	    /**
	     * Helper function when creating dynamic (inline) functions for classes, this helper performs the following tasks :-
	     * - Saves references to all defined base class functions
	     * - Calls the delegateFunc with the current target (this) and a base object reference that can be used to call all "super" functions.
	     * - Will populate the class prototype for all overridden functions to support class extension that call the prototype instance.
	     * Callers should use this helper when declaring all function within the constructor of a class, as mentioned above the delegateFunc is
	     * passed both the target "this" and an object that can be used to call any base (super) functions, using this based object in place of
	     * super.XXX() (which gets expanded to _super.prototype.XXX()) provides a better minification outcome and also ensures the correct "this"
	     * context is maintained as TypeScript creates incorrect references using super.XXXX() for dynamically defined functions i.e. Functions
	     * defined in the constructor or some other function (rather than declared as complete typescript functions).
	     * ### Usage
	     * ```typescript
	     * import dynamicProto from "@microsoft/dynamicproto-js";
	     * class ExampleClass extends BaseClass {
	     *     constructor() {
	     *         dynamicProto(ExampleClass, this, (_self, base) => {
	     *             // This will define a function that will be converted to a prototype function
	     *             _self.newFunc = () => {
	     *                 // Access any "this" instance property
	     *                 if (_self.someProperty) {
	     *                     ...
	     *                 }
	     *             }
	     *             // This will define a function that will be converted to a prototype function
	     *             _self.myFunction = () => {
	     *                 // Access any "this" instance property
	     *                 if (_self.someProperty) {
	     *                     // Call the base version of the function that we are overriding
	     *                     base.myFunction();
	     *                 }
	     *                 ...
	     *             }
	     *             _self.initialize = () => {
	     *                 ...
	     *             }
	     *             // Warnings: While the following will work as _self is simply a reference to
	     *             // this, if anyone overrides myFunction() the overridden will be called first
	     *             // as the normal JavaScript method resolution will occur and the defined
	     *             // _self.initialize() function is actually gets removed from the instance and
	     *             // a proxy prototype version is created to reference the created method.
	     *             _self.initialize();
	     *         });
	     *     }
	     * }
	     * ```
	     * @typeparam DPType This is the generic type of the class, used to keep intellisense valid
	     * @typeparam DPCls The type that contains the prototype of the current class
	     * @param theClass - This is the current class instance which contains the prototype for the current class
	     * @param target - The current "this" (target) reference, when the class has been extended this.prototype will not be the 'theClass' value.
	     * @param delegateFunc - The callback function (closure) that will create the dynamic function
	     * @param options - Additional options to configure how the dynamic prototype operates
	     */
	    function dynamicProto(theClass, target, delegateFunc, options) {
	        // Make sure that the passed theClass argument looks correct
	        if (!_hasOwnProperty(theClass, Prototype)) {
	            _throwTypeError("theClass is an invalid class definition.");
	        }
	        // Quick check to make sure that the passed theClass argument looks correct (this is a common copy/paste error)
	        var classProto = theClass[Prototype];
	        if (!_checkPrototype(classProto, target)) {
	            _throwTypeError("[" + _getObjName(theClass) + "] is not in class hierarchy of [" + _getObjName(target) + "]");
	        }
	        var className = null;
	        if (_hasOwnProperty(classProto, DynClassName)) {
	            // Only grab the class name if it's defined on this prototype (i.e. don't walk the prototype chain)
	            className = classProto[DynClassName];
	        }
	        else {
	            // As not all browser support name on the prototype creating a unique dynamic one if we have not already
	            // assigned one, so we can use a simple string as the lookup rather than an object for the dynamic instance
	            // function table lookup.
	            className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _dynamicNames;
	            _dynamicNames++;
	            classProto[DynClassName] = className;
	        }
	        var perfOptions = dynamicProto[DynProtoDefaultOptions];
	        var useBaseInst = !!perfOptions[strUseBaseInst];
	        if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
	            useBaseInst = !!options[strUseBaseInst];
	        }
	        // Get the current instance functions
	        var instFuncs = _getInstanceFuncs(target);
	        // Get all of the functions for any base instance (before they are potentially overridden)
	        var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
	        // Execute the delegate passing in both the current target "this" and "base" function references
	        // Note casting the same type as we don't actually have the base class here and this will provide some intellisense support
	        delegateFunc(target, baseFuncs);
	        // Don't allow setting instance functions for older IE instances
	        var setInstanceFunc = !!_objGetPrototypeOf && !!perfOptions[strSetInstFuncs];
	        if (setInstanceFunc && options) {
	            setInstanceFunc = !!options[strSetInstFuncs];
	        }
	        // Populate the Prototype for any overridden instance functions
	        _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
	    }
	    /**
	     * Exposes the default global options to allow global configuration, if the global values are disabled these will override
	     * any passed values. This is primarily exposed to support unit-testing without the need for individual classes to expose
	     * their internal usage of dynamic proto.
	     */
	    var perfDefaults = {
	        setInstFuncs: true,
	        useBaseInst: true
	    };
	    // And expose for testing
	    dynamicProto[DynProtoDefaultOptions] = perfDefaults;
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	
	
	    var LoggingSeverity;
	    (function (LoggingSeverity) {
	        /**
	         * Error will be sent as internal telemetry
	         */
	        LoggingSeverity[LoggingSeverity["CRITICAL"] = 1] = "CRITICAL";
	        /**
	         * Error will NOT be sent as internal telemetry, and will only be shown in browser console
	         */
	        LoggingSeverity[LoggingSeverity["WARNING"] = 2] = "WARNING";
	    })(LoggingSeverity || (LoggingSeverity = {}));
	    /**
	     * Internal message ID. Please create a new one for every conceptually different message. Please keep alphabetically ordered
	     */
	    var _InternalMessageId = {
	        // Non user actionable
	        BrowserDoesNotSupportLocalStorage: 0,
	        BrowserCannotReadLocalStorage: 1,
	        BrowserCannotReadSessionStorage: 2,
	        BrowserCannotWriteLocalStorage: 3,
	        BrowserCannotWriteSessionStorage: 4,
	        BrowserFailedRemovalFromLocalStorage: 5,
	        BrowserFailedRemovalFromSessionStorage: 6,
	        CannotSendEmptyTelemetry: 7,
	        ClientPerformanceMathError: 8,
	        ErrorParsingAISessionCookie: 9,
	        ErrorPVCalc: 10,
	        ExceptionWhileLoggingError: 11,
	        FailedAddingTelemetryToBuffer: 12,
	        FailedMonitorAjaxAbort: 13,
	        FailedMonitorAjaxDur: 14,
	        FailedMonitorAjaxOpen: 15,
	        FailedMonitorAjaxRSC: 16,
	        FailedMonitorAjaxSend: 17,
	        FailedMonitorAjaxGetCorrelationHeader: 18,
	        FailedToAddHandlerForOnBeforeUnload: 19,
	        FailedToSendQueuedTelemetry: 20,
	        FailedToReportDataLoss: 21,
	        FlushFailed: 22,
	        MessageLimitPerPVExceeded: 23,
	        MissingRequiredFieldSpecification: 24,
	        NavigationTimingNotSupported: 25,
	        OnError: 26,
	        SessionRenewalDateIsZero: 27,
	        SenderNotInitialized: 28,
	        StartTrackEventFailed: 29,
	        StopTrackEventFailed: 30,
	        StartTrackFailed: 31,
	        StopTrackFailed: 32,
	        TelemetrySampledAndNotSent: 33,
	        TrackEventFailed: 34,
	        TrackExceptionFailed: 35,
	        TrackMetricFailed: 36,
	        TrackPVFailed: 37,
	        TrackPVFailedCalc: 38,
	        TrackTraceFailed: 39,
	        TransmissionFailed: 40,
	        FailedToSetStorageBuffer: 41,
	        FailedToRestoreStorageBuffer: 42,
	        InvalidBackendResponse: 43,
	        FailedToFixDepricatedValues: 44,
	        InvalidDurationValue: 45,
	        TelemetryEnvelopeInvalid: 46,
	        CreateEnvelopeError: 47,
	        // User actionable
	        CannotSerializeObject: 48,
	        CannotSerializeObjectNonSerializable: 49,
	        CircularReferenceDetected: 50,
	        ClearAuthContextFailed: 51,
	        ExceptionTruncated: 52,
	        IllegalCharsInName: 53,
	        ItemNotInArray: 54,
	        MaxAjaxPerPVExceeded: 55,
	        MessageTruncated: 56,
	        NameTooLong: 57,
	        SampleRateOutOfRange: 58,
	        SetAuthContextFailed: 59,
	        SetAuthContextFailedAccountName: 60,
	        StringValueTooLong: 61,
	        StartCalledMoreThanOnce: 62,
	        StopCalledWithoutStart: 63,
	        TelemetryInitializerFailed: 64,
	        TrackArgumentsNotSpecified: 65,
	        UrlTooLong: 66,
	        SessionStorageBufferFull: 67,
	        CannotAccessCookie: 68,
	        IdTooLong: 69,
	        InvalidEvent: 70,
	        FailedMonitorAjaxSetRequestHeader: 71,
	        SendBrowserInfoOnUserInit: 72,
	        PluginException: 73,
	        NotificationException: 74,
	        SnippetScriptLoadFailure: 99,
	        InvalidInstrumentationKey: 100,
	        CannotParseAiBlobValue: 101,
	        InvalidContentBlob: 102,
	        TrackPageActionEventFailed: 103
	    };
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    // RESTRICT and AVOID circular dependencies you should not import other contained modules or export the contents of this file directly
	    // Added to help with minfication
	    var strOnPrefix = "on";
	    var strAttachEvent = "attachEvent";
	    var strAddEventHelper = "addEventListener";
	    var strDetachEvent = "detachEvent";
	    var strRemoveEventListener = "removeEventListener";
	    var strHasOwnProperty = "hasOwnProperty";
	    var ObjClass = Object;
	    var ObjProto = ObjClass[strShimPrototype];
	    var _objHasOwnProperty = ObjProto[strHasOwnProperty];
	    var _objDefineProperty = ObjClass["defineProperty"];
	    function objToString(obj) {
	        return ObjProto.toString.call(obj);
	    }
	    function isTypeof(value, theType) {
	        return typeof value === theType;
	    }
	    function isUndefined(value) {
	        return value === undefined || typeof value === strShimUndefined;
	    }
	    function isNullOrUndefined(value) {
	        return (value === null || isUndefined(value));
	    }
	    function isNotNullOrUndefined(value) {
	        return !isNullOrUndefined(value);
	    }
	    function hasOwnProperty(obj, prop) {
	        return obj && _objHasOwnProperty.call(obj, prop);
	    }
	    function isObject(value) {
	        // Changing to inline for performance
	        return typeof value === strShimObject;
	    }
	    function isFunction(value) {
	        // Changing to inline for performance
	        return typeof value === strShimFunction;
	    }
	    /**
	     * Binds the specified function to an event, so that the function gets called whenever the event fires on the object
	     * @param obj Object to add the event too.
	     * @param eventNameWithoutOn String that specifies any of the standard DHTML Events without "on" prefix
	     * @param handlerRef Pointer that specifies the function to call when event fires
	     * @param useCapture [Optional] Defaults to false
	     * @returns True if the function was bound successfully to the event, otherwise false
	     */
	    function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
	        if (useCapture === void 0) { useCapture = false; }
	        var result = false;
	        if (!isNullOrUndefined(obj)) {
	            try {
	                if (!isNullOrUndefined(obj[strAddEventHelper])) {
	                    // all browsers except IE before version 9
	                    obj[strAddEventHelper](eventNameWithoutOn, handlerRef, useCapture);
	                    result = true;
	                }
	                else if (!isNullOrUndefined(obj[strAttachEvent])) {
	                    // IE before version 9                    
	                    obj[strAttachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
	                    result = true;
	                }
	            }
	            catch (e) {
	                // Just Ignore any error so that we don't break any execution path
	            }
	        }
	        return result;
	    }
	    /**
	     * Removes an event handler for the specified event
	     * @param Object to remove the event from
	     * @param eventNameWithoutOn {string} - The name of the event
	     * @param handlerRef {any} - The callback function that needs to be executed for the given event
	     * @param useCapture [Optional] Defaults to false
	     */
	    function detachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
	        if (useCapture === void 0) { useCapture = false; }
	        if (!isNullOrUndefined(obj)) {
	            try {
	                if (!isNullOrUndefined(obj[strRemoveEventListener])) {
	                    obj[strRemoveEventListener](eventNameWithoutOn, handlerRef, useCapture);
	                }
	                else if (!isNullOrUndefined(obj[strDetachEvent])) {
	                    obj[strDetachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
	                }
	            }
	            catch (e) {
	                // Just Ignore any error so that we don't break any execution path
	            }
	        }
	    }
	    /**
	     * This is a helper function for the equivalent of arForEach(objKeys(target), callbackFn), this is a
	     * performance optimization to avoid the creation of a new array for large objects
	     * @param target The target object to find and process the keys
	     * @param callbackfn The function to call with the details
	     */
	    function objForEachKey(target, callbackfn) {
	        if (target) {
	            for (var prop in target) {
	                if (_objHasOwnProperty.call(target, prop)) {
	                    callbackfn.call(target, prop, target[prop]);
	                }
	            }
	        }
	    }
	    /**
	     * The strEndsWith() method determines whether a string ends with the characters of a specified string, returning true or false as appropriate.
	     * @param value - The value to check whether it ends with the search value.
	     * @param search - The characters to be searched for at the end of the value.
	     * @returns true if the given search value is found at the end of the string, otherwise false.
	     */
	    function strEndsWith(value, search) {
	        if (value && search) {
	            var searchLen = search.length;
	            var valLen = value.length;
	            if (value === search) {
	                return true;
	            }
	            else if (valLen >= searchLen) {
	                var pos = valLen - 1;
	                for (var lp = searchLen - 1; lp >= 0; lp--) {
	                    if (value[pos] != search[lp]) {
	                        return false;
	                    }
	                    pos--;
	                }
	                return true;
	            }
	        }
	        return false;
	    }
	    /**
	     * A simple wrapper (for minification support) to check if the value contains the search string.
	     * @param value - The string value to check for the existence of the search value
	     * @param search - The value search within the value
	     */
	    function strContains(value, search) {
	        if (value && search) {
	            return value.indexOf(search) !== -1;
	        }
	        return false;
	    }
	    /**
	     * Check if an object is of type Date
	     */
	    function isDate(obj) {
	        return objToString(obj) === "[object Date]";
	    }
	    /**
	     * Check if an object is of type Array
	     */
	    function isArray(obj) {
	        return objToString(obj) === "[object Array]";
	    }
	    /**
	     * Check if an object is of type Error
	     */
	    function isError(obj) {
	        return objToString(obj) === "[object Error]";
	    }
	    /**
	     * Checks if the type of value is a string.
	     * @param {any} value - Value to be checked.
	     * @return {boolean} True if the value is a string, false otherwise.
	     */
	    function isString(value) {
	        // Changing to inline for performance
	        return typeof value === "string";
	    }
	    /**
	     * Checks if the type of value is a number.
	     * @param {any} value - Value to be checked.
	     * @return {boolean} True if the value is a number, false otherwise.
	     */
	    function isNumber(value) {
	        // Changing to inline for performance
	        return typeof value === "number";
	    }
	    /**
	     * Checks if the type of value is a boolean.
	     * @param {any} value - Value to be checked.
	     * @return {boolean} True if the value is a boolean, false otherwise.
	     */
	    function isBoolean(value) {
	        // Changing to inline for performance
	        return typeof value === "boolean";
	    }
	    /**
	     * Convert a date to I.S.O. format in IE8
	     */
	    function toISOString(date) {
	        if (isDate(date)) {
	            var pad = function (num) {
	                var r = String(num);
	                if (r.length === 1) {
	                    r = "0" + r;
	                }
	                return r;
	            };
	            return date.getUTCFullYear()
	                + "-" + pad(date.getUTCMonth() + 1)
	                + "-" + pad(date.getUTCDate())
	                + "T" + pad(date.getUTCHours())
	                + ":" + pad(date.getUTCMinutes())
	                + ":" + pad(date.getUTCSeconds())
	                + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5)
	                + "Z";
	        }
	    }
	    /**
	     * Performs the specified action for each element in an array. This helper exists to avoid adding a polyfil for older browsers
	     * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
	     * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
	     * cause a testing requirement to test with and without the implementations
	     * @param callbackfn  A function that accepts up to three arguments. forEach calls the callbackfn function one time for each element in the array. It can return -1 to break out of the loop
	     * @param thisArg  [Optional] An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
	     */
	    function arrForEach(arr, callbackfn, thisArg) {
	        var len = arr.length;
	        for (var idx = 0; idx < len; idx++) {
	            if (idx in arr) {
	                if (callbackfn.call(thisArg || arr, arr[idx], idx, arr) === -1) {
	                    break;
	                }
	            }
	        }
	    }
	    /**
	     * Returns the index of the first occurrence of a value in an array. This helper exists to avoid adding a polyfil for older browsers
	     * that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype
	     * implementation. Note: For consistency this will not use the Array.prototype.xxxx implementation if it exists as this would
	     * cause a testing requirement to test with and without the implementations
	     * @param searchElement The value to locate in the array.
	     * @param fromIndex The array index at which to begin the search. If fromIndex is omitted, the search starts at index 0.
	     */
	    function arrIndexOf(arr, searchElement, fromIndex) {
	        var len = arr.length;
	        var from = fromIndex || 0;
	        for (var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++) {
	            if (lp in arr && arr[lp] === searchElement) {
	                return lp;
	            }
	        }
	        return -1;
	    }
	    /**
	     * Calls a defined callback function on each element of an array, and returns an array that contains the results. This helper exists
	     * to avoid adding a polyfil for older browsers that do not define Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page
	     * checks for presence/absence of the prototype implementation. Note: For consistency this will not use the Array.prototype.xxxx
	     * implementation if it exists as this would cause a testing requirement to test with and without the implementations
	     * @param callbackfn A function that accepts up to three arguments. The map method calls the callbackfn function one time for each element in the array.
	     * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
	     */
	    function arrMap(arr, callbackfn, thisArg) {
	        var len = arr.length;
	        var _this = thisArg || arr;
	        var results = new Array(len);
	        for (var lp = 0; lp < len; lp++) {
	            if (lp in arr) {
	                results[lp] = callbackfn.call(_this, arr[lp], arr);
	            }
	        }
	        return results;
	    }
	    /**
	     * Calls the specified callback function for all the elements in an array. The return value of the callback function is the accumulated result, and is
	     * provided as an argument in the next call to the callback function. This helper exists to avoid adding a polyfil for older browsers that do not define
	     * Array.prototype.xxxx (eg. ES3 only, IE8) just in case any page checks for presence/absence of the prototype implementation. Note: For consistency
	     * this will not use the Array.prototype.xxxx implementation if it exists as this would cause a testing requirement to test with and without the implementations
	     * @param callbackfn A function that accepts up to four arguments. The reduce method calls the callbackfn function one time for each element in the array.
	     * @param initialValue If initialValue is specified, it is used as the initial value to start the accumulation. The first call to the callbackfn function provides this value as an argument instead of an array value.
	     */
	    function arrReduce(arr, callbackfn, initialValue) {
	        var len = arr.length;
	        var lp = 0;
	        var value;
	        // Specifically checking the number of passed arguments as the value could be anything
	        if (arguments.length >= 3) {
	            value = arguments[2];
	        }
	        else {
	            while (lp < len && !(lp in arr)) {
	                lp++;
	            }
	            value = arr[lp++];
	        }
	        while (lp < len) {
	            if (lp in arr) {
	                value = callbackfn(value, arr[lp], lp, arr);
	            }
	            lp++;
	        }
	        return value;
	    }
	    /**
	     * helper method to trim strings (IE8 does not implement String.prototype.trim)
	     */
	    function strTrim(str) {
	        if (typeof str !== "string") {
	            return str;
	        }
	        return str.replace(/^\s+|\s+$/g, "");
	    }
	    var _objKeysHasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString');
	    var _objKeysDontEnums = [
	        'toString',
	        'toLocaleString',
	        'valueOf',
	        'hasOwnProperty',
	        'isPrototypeOf',
	        'propertyIsEnumerable',
	        'constructor'
	    ];
	    /**
	     * Returns the names of the enumerable string properties and methods of an object. This helper exists to avoid adding a polyfil for older browsers
	     * that do not define Object.keys eg. ES3 only, IE8 just in case any page checks for presence/absence of the prototype implementation.
	     * Note: For consistency this will not use the Object.keys implementation if it exists as this would cause a testing requirement to test with and without the implementations
	     * @param obj Object that contains the properties and methods. This can be an object that you created or an existing Document Object Model (DOM) object.
	     */
	    function objKeys(obj) {
	        var objType = typeof obj;
	        if (objType !== strShimFunction && (objType !== strShimObject || obj === null)) {
	            throw new TypeError('objKeys called on non-object');
	        }
	        var result = [];
	        for (var prop in obj) {
	            if (obj && _objHasOwnProperty.call(obj, prop)) {
	                result.push(prop);
	            }
	        }
	        if (_objKeysHasDontEnumBug) {
	            var dontEnumsLength = _objKeysDontEnums.length;
	            for (var lp = 0; lp < dontEnumsLength; lp++) {
	                if (obj && _objHasOwnProperty.call(obj, _objKeysDontEnums[lp])) {
	                    result.push(_objKeysDontEnums[lp]);
	                }
	            }
	        }
	        return result;
	    }
	    /**
	     * Try to define get/set object property accessors for the target object/prototype, this will provide compatibility with
	     * existing API definition when run within an ES5+ container that supports accessors but still enable the code to be loaded
	     * and executed in an ES3 container, providing basic IE8 compatibility.
	     * @param target The object on which to define the property.
	     * @param prop The name of the property to be defined or modified.
	     * @param getProp The getter function to wire against the getter.
	     * @param setProp The setter function to wire against the setter.
	     * @returns True if it was able to create the accessors otherwise false
	     */
	    function objDefineAccessors(target, prop, getProp, setProp) {
	        if (_objDefineProperty) {
	            try {
	                var descriptor = {
	                    enumerable: true,
	                    configurable: true
	                };
	                if (getProp) {
	                    descriptor.get = getProp;
	                }
	                if (setProp) {
	                    descriptor.set = setProp;
	                }
	                _objDefineProperty(target, prop, descriptor);
	                return true;
	            }
	            catch (e) {
	                // IE8 Defines a defineProperty on Object but it's only supported for DOM elements so it will throw
	                // We will just ignore this here.
	            }
	        }
	        return false;
	    }
	    /**
	     * Return the current time via the Date now() function (if available) and falls back to (new Date()).getTime() if now() is unavailable (IE8 or less)
	     * https://caniuse.com/#search=Date.now
	     */
	    function dateNow() {
	        var dt = Date;
	        if (dt.now) {
	            return dt.now();
	        }
	        return new dt().getTime();
	    }
	    /**
	     * Returns the name of object if it's an Error. Otherwise, returns empty string.
	     */
	    function getExceptionName(object) {
	        if (isError(object)) {
	            return object.name;
	        }
	        return "";
	    }
	    /**
	     * Sets the provided value on the target instance using the field name when the provided chk function returns true, the chk
	     * function will only be called if the new value is no equal to the original value.
	     * @param target - The target object
	     * @param field - The key of the target
	     * @param value - The value to set
	     * @param valChk - [Optional] Callback to check the value that if supplied will be called check if the new value can be set
	     * @param srcChk - [Optional] Callback to check to original value that if supplied will be called if the new value should be set (if allowed)
	     * @returns The existing or new value, depending what was set
	     */
	    function setValue(target, field, value, valChk, srcChk) {
	        var theValue = value;
	        if (target) {
	            theValue = target[field];
	            if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
	                theValue = value;
	                target[field] = theValue;
	            }
	        }
	        return theValue;
	    }
	    /**
	     * Returns the current value from the target object if not null or undefined otherwise sets the new value and returns it
	     * @param target - The target object to return or set the default value
	     * @param field - The key for the field to set on the target
	     * @param defValue - [Optional] The value to set if not already present, when not provided a empty object will be added
	     */
	    function getSetValue(target, field, defValue) {
	        var theValue;
	        if (target) {
	            theValue = target[field];
	            if (!theValue && isNullOrUndefined(theValue)) {
	                // Supports having the default as null
	                theValue = !isUndefined(defValue) ? defValue : {};
	                target[field] = theValue;
	            }
	        }
	        else {
	            // Expanded for performance so we only check defValue if required
	            theValue = !isUndefined(defValue) ? defValue : {};
	        }
	        return theValue;
	    }
	    function isNotTruthy(value) {
	        return !value;
	    }
	    function isTruthy(value) {
	        return !!value;
	    }
	    function throwError(message) {
	        throw new Error(message);
	    }
	    /**
	     * Simpler helper to create a dynamic class that implements the interface and populates the values with the defaults.
	     * Only instance properties (hasOwnProperty) values are copied from the defaults to the new instance
	     * @param defaults Simple helper
	     */
	    function createClassFromInterface(defaults) {
	        return /** @class */ (function () {
	            function class_1() {
	                var _this = this;
	                if (defaults) {
	                    objForEachKey(defaults, function (field, value) {
	                        _this[field] = value;
	                    });
	                }
	            }
	            return class_1;
	        }());
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    /**
	     * This file exists to hold environment utilities that are required to check and
	     * validate the current operating environment. Unless otherwise required, please
	     * only defined methods (functions) in this class so that users of these
	     * functions/properties only need to include those that are used within their own modules.
	     */
	    var strUndefined = strShimUndefined;
	    var strObject = strShimObject;
	    var strWindow = "window";
	    var strDocument = "document";
	    var strNavigator = "navigator";
	    var strLocation = "location";
	    var strConsole = "console";
	    var strPerformance = "performance";
	    var strJSON = "JSON";
	    var strCrypto = "crypto";
	    var strMsCrypto = "msCrypto";
	    var strMsie = "msie";
	    var strTrident = "trident/";
	    var _isTrident = null;
	    var _navUserAgentCheck = null;
	    var _enableMocks = false;
	    /**
	     * Returns the current global scope object, for a normal web page this will be the current
	     * window, for a Web Worker this will be current worker global scope via "self". The internal
	     * implementation returns the first available instance object in the following order
	     * - globalThis (New standard)
	     * - self (Will return the current window instance for supported browsers)
	     * - window (fallback for older browser implementations)
	     * - global (NodeJS standard)
	     * - <null> (When all else fails)
	     * While the return type is a Window for the normal case, not all environments will support all
	     * of the properties or functions.
	     */
	    var getGlobal$1 = getGlobal;
	    /**
	     * Return the named global object if available, will return null if the object is not available.
	     * @param name The globally named object
	     */
	    function getGlobalInst(name) {
	        var gbl = getGlobal$1();
	        if (gbl && gbl[name]) {
	            return gbl[name];
	        }
	        // Test workaround, for environments where <global>.window (when global == window) doesn't return the base window
	        if (name === strWindow && hasWindow()) {
	            // tslint:disable-next-line: no-angle-bracket-type-assertion
	            return window;
	        }
	        return null;
	    }
	    /**
	     * Checks if window object is available, this is required as we support the API running without a
	     * window /document (eg. Node server, electron webworkers) and if we attempt to assign a window
	     * object to a local variable or pass as an argument an "Uncaught ReferenceError: window is not defined"
	     * exception will be thrown.
	     * Defined as a function to support lazy / late binding environments.
	     */
	    function hasWindow() {
	        return Boolean(typeof window === strObject && window);
	    }
	    /**
	     * Returns the global window object if it is present otherwise null.
	     * This helper is used to access the window object without causing an exception
	     * "Uncaught ReferenceError: window is not defined"
	     */
	    function getWindow() {
	        if (hasWindow()) {
	            return window;
	        }
	        // Return the global instance or null
	        return getGlobalInst(strWindow);
	    }
	    /**
	     * Checks if document object is available, this is required as we support the API running without a
	     * window /document (eg. Node server, electron webworkers) and if we attempt to assign a document
	     * object to a local variable or pass as an argument an "Uncaught ReferenceError: document is not defined"
	     * exception will be thrown.
	     * Defined as a function to support lazy / late binding environments.
	     */
	    function hasDocument() {
	        return Boolean(typeof document === strObject && document);
	    }
	    /**
	     * Returns the global document object if it is present otherwise null.
	     * This helper is used to access the document object without causing an exception
	     * "Uncaught ReferenceError: document is not defined"
	     */
	    function getDocument() {
	        if (hasDocument()) {
	            return document;
	        }
	        return getGlobalInst(strDocument);
	    }
	    /**
	     * Checks if navigator object is available, this is required as we support the API running without a
	     * window /document (eg. Node server, electron webworkers) and if we attempt to assign a navigator
	     * object to a local variable or pass as an argument an "Uncaught ReferenceError: navigator is not defined"
	     * exception will be thrown.
	     * Defined as a function to support lazy / late binding environments.
	     */
	    function hasNavigator() {
	        return Boolean(typeof navigator === strObject && navigator);
	    }
	    /**
	     * Returns the global navigator object if it is present otherwise null.
	     * This helper is used to access the navigator object without causing an exception
	     * "Uncaught ReferenceError: navigator is not defined"
	     */
	    function getNavigator() {
	        if (hasNavigator()) {
	            return navigator;
	        }
	        return getGlobalInst(strNavigator);
	    }
	    /**
	     * Returns the global location object if it is present otherwise null.
	     * This helper is used to access the location object without causing an exception
	     * "Uncaught ReferenceError: location is not defined"
	     */
	    function getLocation(checkForMock) {
	        if (checkForMock && _enableMocks) {
	            var mockLocation = getGlobalInst("__mockLocation");
	            if (mockLocation) {
	                return mockLocation;
	            }
	        }
	        if (typeof location === strObject && location) {
	            return location;
	        }
	        return getGlobalInst(strLocation);
	    }
	    /**
	     * Returns the global console object
	     */
	    function getConsole() {
	        if (typeof console !== strUndefined) {
	            return console;
	        }
	        return getGlobalInst(strConsole);
	    }
	    /**
	     * Returns the performance object if it is present otherwise null.
	     * This helper is used to access the performance object from the current
	     * global instance which could be window or globalThis for a web worker
	     */
	    function getPerformance() {
	        return getGlobalInst(strPerformance);
	    }
	    /**
	     * Checks if JSON object is available, this is required as we support the API running without a
	     * window /document (eg. Node server, electron webworkers) and if we attempt to assign a history
	     * object to a local variable or pass as an argument an "Uncaught ReferenceError: JSON is not defined"
	     * exception will be thrown.
	     * Defined as a function to support lazy / late binding environments.
	     */
	    function hasJSON() {
	        return Boolean((typeof JSON === strObject && JSON) || getGlobalInst(strJSON) !== null);
	    }
	    /**
	     * Returns the global JSON object if it is present otherwise null.
	     * This helper is used to access the JSON object without causing an exception
	     * "Uncaught ReferenceError: JSON is not defined"
	     */
	    function getJSON() {
	        if (hasJSON()) {
	            return JSON || getGlobalInst(strJSON);
	        }
	        return null;
	    }
	    /**
	     * Returns the crypto object if it is present otherwise null.
	     * This helper is used to access the crypto object from the current
	     * global instance which could be window or globalThis for a web worker
	     */
	    function getCrypto() {
	        return getGlobalInst(strCrypto);
	    }
	    /**
	     * Returns the crypto object if it is present otherwise null.
	     * This helper is used to access the crypto object from the current
	     * global instance which could be window or globalThis for a web worker
	     */
	    function getMsCrypto() {
	        return getGlobalInst(strMsCrypto);
	    }
	    /**
	     * Identifies whether the current environment appears to be IE
	     */
	    function isIE() {
	        var nav = getNavigator();
	        if (nav && (nav.userAgent !== _navUserAgentCheck || _isTrident === null)) {
	            // Added to support test mocking of the user agent
	            _navUserAgentCheck = nav.userAgent;
	            var userAgent = (_navUserAgentCheck || "").toLowerCase();
	            _isTrident = (strContains(userAgent, strMsie) || strContains(userAgent, strTrident));
	        }
	        return _isTrident;
	    }
	    /**
	     * Returns string representation of an object suitable for diagnostics logging.
	     */
	    function dumpObj(object) {
	        var objectTypeDump = Object[strShimPrototype].toString.call(object);
	        var propertyValueDump = "";
	        if (objectTypeDump === "[object Error]") {
	            propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object.name + "'";
	        }
	        else if (hasJSON()) {
	            propertyValueDump = getJSON().stringify(object);
	        }
	        return objectTypeDump + propertyValueDump;
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    /**
	     * For user non actionable traces use AI Internal prefix.
	     */
	    var AiNonUserActionablePrefix = "AI (Internal): ";
	    /**
	     * Prefix of the traces in portal.
	     */
	    var AiUserActionablePrefix = "AI: ";
	    /**
	     *  Session storage key for the prefix for the key indicating message type already logged
	     */
	    var AIInternalMessagePrefix = "AITR_";
	    function _sanitizeDiagnosticText(text) {
	        if (text) {
	            return "\"" + text.replace(/\"/g, "") + "\"";
	        }
	        return "";
	    }
	    var _InternalLogMessage = /** @class */ (function () {
	        function _InternalLogMessage(msgId, msg, isUserAct, properties) {
	            if (isUserAct === void 0) { isUserAct = false; }
	            var _self = this;
	            _self.messageId = msgId;
	            _self.message =
	                (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
	                    msgId;
	            var strProps = "";
	            if (hasJSON()) {
	                strProps = getJSON().stringify(properties);
	            }
	            var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : "") +
	                (properties ? " props:" + _sanitizeDiagnosticText(strProps) : "");
	            _self.message += diagnosticText;
	        }
	        _InternalLogMessage.dataType = "MessageData";
	        return _InternalLogMessage;
	    }());
	    function safeGetLogger(core, config) {
	        return (core || {}).logger || new DiagnosticLogger(config);
	    }
	    var DiagnosticLogger = /** @class */ (function () {
	        function DiagnosticLogger(config) {
	            this.identifier = 'DiagnosticLogger';
	            /**
	             * The internal logging queue
	             */
	            this.queue = [];
	            /**
	             * Count of internal messages sent
	             */
	            var _messageCount = 0;
	            /**
	             * Holds information about what message types were already logged to console or sent to server.
	             */
	            var _messageLogged = {};
	            dynamicProto(DiagnosticLogger, this, function (_self) {
	                if (isNullOrUndefined(config)) {
	                    config = {};
	                }
	                _self.consoleLoggingLevel = function () { return _getConfigValue('loggingLevelConsole', 0); };
	                _self.telemetryLoggingLevel = function () { return _getConfigValue('loggingLevelTelemetry', 1); };
	                _self.maxInternalMessageLimit = function () { return _getConfigValue('maxMessageLimit', 25); };
	                _self.enableDebugExceptions = function () { return _getConfigValue('enableDebugExceptions', false); };
	                /**
	                 * This method will throw exceptions in debug mode or attempt to log the error as a console warning.
	                 * @param severity {LoggingSeverity} - The severity of the log message
	                 * @param message {_InternalLogMessage} - The log message.
	                 */
	                _self.throwInternal = function (severity, msgId, msg, properties, isUserAct) {
	                    if (isUserAct === void 0) { isUserAct = false; }
	                    var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
	                    if (_self.enableDebugExceptions()) {
	                        throw message;
	                    }
	                    else {
	                        if (!isUndefined(message) && !!message && !isUndefined(message.message)) {
	                            var logLevel = _self.consoleLoggingLevel();
	                            if (isUserAct) {
	                                // check if this message type was already logged to console for this page view and if so, don't log it again
	                                var messageKey = +message.messageId;
	                                if (!_messageLogged[messageKey] && logLevel >= LoggingSeverity.WARNING) {
	                                    _self.warnToConsole(message.message);
	                                    _messageLogged[messageKey] = true;
	                                }
	                            }
	                            else {
	                                // don't log internal AI traces in the console, unless the verbose logging is enabled
	                                if (logLevel >= LoggingSeverity.WARNING) {
	                                    _self.warnToConsole(message.message);
	                                }
	                            }
	                            _self.logInternalMessage(severity, message);
	                        }
	                    }
	                };
	                /**
	                 * This will write a warning to the console if possible
	                 * @param message {string} - The warning message
	                 */
	                _self.warnToConsole = function (message) {
	                    var theConsole = getConsole();
	                    if (!!theConsole) {
	                        var logFunc = 'log';
	                        if (theConsole.warn) {
	                            logFunc = 'warn';
	                        }
	                        if (isFunction(theConsole[logFunc])) {
	                            theConsole[logFunc](message);
	                        }
	                    }
	                };
	                /**
	                 * Resets the internal message count
	                 */
	                _self.resetInternalMessageCount = function () {
	                    _messageCount = 0;
	                    _messageLogged = {};
	                };
	                /**
	                 * Logs a message to the internal queue.
	                 * @param severity {LoggingSeverity} - The severity of the log message
	                 * @param message {_InternalLogMessage} - The message to log.
	                 */
	                _self.logInternalMessage = function (severity, message) {
	                    if (_areInternalMessagesThrottled()) {
	                        return;
	                    }
	                    // check if this message type was already logged for this session and if so, don't log it again
	                    var logMessage = true;
	                    var messageKey = AIInternalMessagePrefix + message.messageId;
	                    // if the session storage is not available, limit to only one message type per page view
	                    if (_messageLogged[messageKey]) {
	                        logMessage = false;
	                    }
	                    else {
	                        _messageLogged[messageKey] = true;
	                    }
	                    if (logMessage) {
	                        // Push the event in the internal queue
	                        if (severity <= _self.telemetryLoggingLevel()) {
	                            _self.queue.push(message);
	                            _messageCount++;
	                        }
	                        // When throttle limit reached, send a special event
	                        if (_messageCount === _self.maxInternalMessageLimit()) {
	                            var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
	                            var throttleMessage = new _InternalLogMessage(_InternalMessageId.MessageLimitPerPVExceeded, throttleLimitMessage, false);
	                            _self.queue.push(throttleMessage);
	                            _self.warnToConsole(throttleLimitMessage);
	                        }
	                    }
	                };
	                function _getConfigValue(name, defValue) {
	                    var value = config[name];
	                    if (!isNullOrUndefined(value)) {
	                        return value;
	                    }
	                    return defValue;
	                }
	                function _areInternalMessagesThrottled() {
	                    return _messageCount >= _self.maxInternalMessageLimit();
	                }
	            });
	        }
	    // Removed Stub for DiagnosticLogger.prototype.enableDebugExceptions.
	    // Removed Stub for DiagnosticLogger.prototype.consoleLoggingLevel.
	    // Removed Stub for DiagnosticLogger.prototype.telemetryLoggingLevel.
	    // Removed Stub for DiagnosticLogger.prototype.maxInternalMessageLimit.
	    // Removed Stub for DiagnosticLogger.prototype.throwInternal.
	    // Removed Stub for DiagnosticLogger.prototype.warnToConsole.
	    // Removed Stub for DiagnosticLogger.prototype.resetInternalMessageCount.
	    // Removed Stub for DiagnosticLogger.prototype.logInternalMessage.
	        return DiagnosticLogger;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var strExecutionContextKey = "ctx";
	    var PerfEvent = /** @class */ (function () {
	        function PerfEvent(name, payloadDetails, isAsync) {
	            var _self = this;
	            var accessorDefined = false;
	            _self.start = dateNow();
	            _self.name = name;
	            _self.isAsync = isAsync;
	            _self.isChildEvt = function () { return false; };
	            if (isFunction(payloadDetails)) {
	                // Create an accessor to minimize the potential performance impact of executing the payloadDetails callback
	                var theDetails_1;
	                accessorDefined = objDefineAccessors(_self, 'payload', function () {
	                    // Delay the execution of the payloadDetails until needed
	                    if (!theDetails_1 && isFunction(payloadDetails)) {
	                        theDetails_1 = payloadDetails();
	                        // clear it out now so the referenced objects can be garbage collected
	                        payloadDetails = null;
	                    }
	                    return theDetails_1;
	                });
	            }
	            _self.getCtx = function (key) {
	                if (key) {
	                    // The parent and child links are located directly on the object (for better viewing in the DebugPlugin)
	                    if (key === PerfEvent.ParentContextKey || key === PerfEvent.ChildrenContextKey) {
	                        return _self[key];
	                    }
	                    return (_self[strExecutionContextKey] || {})[key];
	                }
	                return null;
	            };
	            _self.setCtx = function (key, value) {
	                if (key) {
	                    // Put the parent and child links directly on the object (for better viewing in the DebugPlugin)
	                    if (key === PerfEvent.ParentContextKey) {
	                        // Simple assumption, if we are setting a parent then we must be a child
	                        if (!_self[key]) {
	                            _self.isChildEvt = function () { return true; };
	                        }
	                        _self[key] = value;
	                    }
	                    else if (key === PerfEvent.ChildrenContextKey) {
	                        _self[key] = value;
	                    }
	                    else {
	                        var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
	                        ctx[key] = value;
	                    }
	                }
	            };
	            _self.complete = function () {
	                var childTime = 0;
	                var childEvts = _self.getCtx(PerfEvent.ChildrenContextKey);
	                if (isArray(childEvts)) {
	                    for (var lp = 0; lp < childEvts.length; lp++) {
	                        var childEvt = childEvts[lp];
	                        if (childEvt) {
	                            childTime += childEvt.time;
	                        }
	                    }
	                }
	                _self.time = dateNow() - _self.start;
	                _self.exTime = _self.time - childTime;
	                _self.complete = function () { };
	                if (!accessorDefined && isFunction(payloadDetails)) {
	                    // If we couldn't define the property set during complete -- to minimize the perf impact until after the time
	                    _self.payload = payloadDetails();
	                }
	            };
	        }
	        PerfEvent.ParentContextKey = "parent";
	        PerfEvent.ChildrenContextKey = "childEvts";
	        return PerfEvent;
	    }());
	    var PerfManager = /** @class */ (function () {
	        function PerfManager(manager) {
	            /**
	             * General bucket used for execution context set and retrieved via setCtx() and getCtx.
	             * Defined as private so it can be visualized via the DebugPlugin
	             */
	            this.ctx = {};
	            dynamicProto(PerfManager, this, function (_self) {
	                _self.create = function (src, payloadDetails, isAsync) {
	                    // TODO (@MSNev): at some point we will want to add additional configuration to "select" which events to instrument
	                    // for now this is just a simple do everything.
	                    return new PerfEvent(src, payloadDetails, isAsync);
	                };
	                _self.fire = function (perfEvent) {
	                    if (perfEvent) {
	                        perfEvent.complete();
	                        if (manager) {
	                            manager.perfEvent(perfEvent);
	                        }
	                    }
	                };
	                _self.setCtx = function (key, value) {
	                    if (key) {
	                        var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
	                        ctx[key] = value;
	                    }
	                };
	                _self.getCtx = function (key) {
	                    return (_self[strExecutionContextKey] || {})[key];
	                };
	            });
	        }
	    // Removed Stub for PerfManager.prototype.create.
	    // Removed Stub for PerfManager.prototype.fire.
	    // Removed Stub for PerfManager.prototype.setCtx.
	    // Removed Stub for PerfManager.prototype.getCtx.
	        return PerfManager;
	    }());
	    var doPerfActiveKey = "CoreUtils.doPerf";
	    /**
	     * Helper function to wrap a function with a perf event
	     * @param mgrSource - The Performance Manager or a Performance provider source (may be null)
	     * @param getSource - The callback to create the source name for the event (if perf monitoring is enabled)
	     * @param func - The function to call and measure
	     * @param details - A function to return the payload details
	     * @param isAsync - Is the event / function being call asynchronously or synchronously
	     */
	    function doPerf(mgrSource, getSource, func, details, isAsync) {
	        if (mgrSource) {
	            var perfMgr = mgrSource;
	            if (perfMgr && isFunction(perfMgr["getPerfMgr"])) {
	                // Looks like a perf manager provider object
	                perfMgr = perfMgr["getPerfMgr"]();
	            }
	            if (perfMgr) {
	                var perfEvt = void 0;
	                var currentActive = perfMgr.getCtx(doPerfActiveKey);
	                try {
	                    perfEvt = perfMgr.create(getSource(), details, isAsync);
	                    if (perfEvt) {
	                        if (currentActive && perfEvt.setCtx) {
	                            perfEvt.setCtx(PerfEvent.ParentContextKey, currentActive);
	                            if (currentActive.getCtx && currentActive.setCtx) {
	                                var children = currentActive.getCtx(PerfEvent.ChildrenContextKey);
	                                if (!children) {
	                                    children = [];
	                                    currentActive.setCtx(PerfEvent.ChildrenContextKey, children);
	                                }
	                                children.push(perfEvt);
	                            }
	                        }
	                        // Set this event as the active event now
	                        perfMgr.setCtx(doPerfActiveKey, perfEvt);
	                        return func(perfEvt);
	                    }
	                }
	                catch (ex) {
	                    if (perfEvt && perfEvt.setCtx) {
	                        perfEvt.setCtx("exception", ex);
	                    }
	                }
	                finally {
	                    // fire the perf event
	                    if (perfEvt) {
	                        perfMgr.fire(perfEvt);
	                    }
	                    // Reset the active event to the previous value
	                    perfMgr.setCtx(doPerfActiveKey, currentActive);
	                }
	            }
	        }
	        return func();
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var TelemetryPluginChain = /** @class */ (function () {
	        function TelemetryPluginChain(plugin, defItemCtx) {
	            var _self = this;
	            var _nextProxy = null;
	            var _hasProcessTelemetry = isFunction(plugin.processTelemetry);
	            var _hasSetNext = isFunction(plugin.setNextPlugin);
	            _self._hasRun = false;
	            _self.getPlugin = function () {
	                return plugin;
	            };
	            _self.getNext = function () {
	                return _nextProxy;
	            };
	            _self.setNext = function (nextPlugin) {
	                _nextProxy = nextPlugin;
	            };
	            _self.processTelemetry = function (env, itemCtx) {
	                if (!itemCtx) {
	                    // Looks like a plugin didn't pass the (optional) context, so restore to the default
	                    itemCtx = defItemCtx;
	                }
	                var identifier = plugin ? plugin.identifier : "TelemetryPluginChain";
	                doPerf(itemCtx ? itemCtx.core() : null, function () { return identifier + ":processTelemetry"; }, function () {
	                    if (plugin && _hasProcessTelemetry) {
	                        _self._hasRun = true;
	                        try {
	                            // Ensure that we keep the context in sync (for processNext()), just in case a plugin
	                            // doesn't calls processTelemetry() instead of itemContext.processNext() or some 
	                            // other form of error occurred
	                            itemCtx.setNext(_nextProxy);
	                            if (_hasSetNext) {
	                                // Backward compatibility setting the next plugin on the instance
	                                plugin.setNextPlugin(_nextProxy);
	                            }
	                            // Set a flag on the next plugin so we know if it was attempted to be executed
	                            _nextProxy && (_nextProxy._hasRun = false);
	                            plugin.processTelemetry(env, itemCtx);
	                        }
	                        catch (error) {
	                            var hasRun = _nextProxy && _nextProxy._hasRun;
	                            if (!_nextProxy || !hasRun) {
	                                // Either we have no next plugin or the current one did not attempt to call the next plugin
	                                // Which means the current one is the root of the failure so log/report this failure
	                                itemCtx.diagLog().throwInternal(LoggingSeverity.CRITICAL, _InternalMessageId.PluginException, "Plugin [" + plugin.identifier + "] failed during processTelemetry - " + error);
	                            }
	                            if (_nextProxy && !hasRun) {
	                                // As part of the failure the current plugin did not attempt to call the next plugin in the cahin
	                                // So rather than leave the pipeline dead in the water we call the next plugin
	                                _nextProxy.processTelemetry(env, itemCtx);
	                            }
	                        }
	                    }
	                    else if (_nextProxy) {
	                        _self._hasRun = true;
	                        // The underlying plugin is either not defined or does not have a processTelemetry implementation
	                        // so we still want the next plugin to be executed.
	                        _nextProxy.processTelemetry(env, itemCtx);
	                    }
	                }, function () { return ({ item: env }); }, !(env.sync));
	            };
	        }
	        return TelemetryPluginChain;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    /**
	     * Creates the instance execution chain for the plugins
	     */
	    function _createProxyChain(plugins, itemCtx) {
	        var proxies = [];
	        if (plugins && plugins.length > 0) {
	            // Create the proxies and wire up the next plugin chain
	            var lastProxy = null;
	            for (var idx = 0; idx < plugins.length; idx++) {
	                var thePlugin = plugins[idx];
	                if (thePlugin && isFunction(thePlugin.processTelemetry)) {
	                    // Only add plugins that are processors
	                    var newProxy = new TelemetryPluginChain(thePlugin, itemCtx);
	                    proxies.push(newProxy);
	                    if (lastProxy) {
	                        // Set this new proxy as the next for the previous one
	                        lastProxy.setNext(newProxy);
	                    }
	                    lastProxy = newProxy;
	                }
	            }
	        }
	        return proxies.length > 0 ? proxies[0] : null;
	    }
	    function _copyProxyChain(proxy, itemCtx, startAt) {
	        var plugins = [];
	        var add = startAt ? false : true;
	        if (proxy) {
	            while (proxy) {
	                var thePlugin = proxy.getPlugin();
	                if (add || thePlugin === startAt) {
	                    add = true;
	                    plugins.push(thePlugin);
	                }
	                proxy = proxy.getNext();
	            }
	        }
	        if (!add) {
	            plugins.push(startAt);
	        }
	        return _createProxyChain(plugins, itemCtx);
	    }
	    function _copyPluginChain(srcPlugins, itemCtx, startAt) {
	        var plugins = srcPlugins;
	        var add = false;
	        if (startAt && srcPlugins) {
	            plugins = [];
	            arrForEach(srcPlugins, function (thePlugin) {
	                if (add || thePlugin === startAt) {
	                    add = true;
	                    plugins.push(thePlugin);
	                }
	            });
	        }
	        if (startAt && !add) {
	            if (!plugins) {
	                plugins = [];
	            }
	            plugins.push(startAt);
	        }
	        return _createProxyChain(plugins, itemCtx);
	    }
	    var ProcessTelemetryContext = /** @class */ (function () {
	        /**
	         * Creates a new Telemetry Item context with the current config, core and plugin execution chain
	         * @param plugins - The plugin instances that will be executed
	         * @param config - The current config
	         * @param core - The current core instance
	         */
	        function ProcessTelemetryContext(plugins, config, core, startAt) {
	            var _self = this;
	            var _nextProxy = null; // Null == No next plugin
	            // There is no next element (null) vs not defined (undefined)
	            if (startAt !== null) {
	                if (plugins && isFunction(plugins.getPlugin)) {
	                    // We have a proxy chain object
	                    _nextProxy = _copyProxyChain(plugins, _self, startAt || plugins.getPlugin());
	                }
	                else {
	                    // We just have an array
	                    if (startAt) {
	                        _nextProxy = _copyPluginChain(plugins, _self, startAt);
	                    }
	                    else if (isUndefined(startAt)) {
	                        // Undefined means copy the existing chain
	                        _nextProxy = _createProxyChain(plugins, _self);
	                    }
	                }
	            }
	            _self.core = function () {
	                return core;
	            };
	            _self.diagLog = function () {
	                return safeGetLogger(core, config);
	            };
	            _self.getCfg = function () {
	                return config;
	            };
	            _self.getExtCfg = function (identifier, defaultValue) {
	                if (defaultValue === void 0) { defaultValue = {}; }
	                var theConfig;
	                if (config) {
	                    var extConfig = config.extensionConfig;
	                    if (extConfig && identifier) {
	                        theConfig = extConfig[identifier];
	                    }
	                }
	                return (theConfig ? theConfig : defaultValue);
	            };
	            _self.getConfig = function (identifier, field, defaultValue) {
	                if (defaultValue === void 0) { defaultValue = false; }
	                var theValue;
	                var extConfig = _self.getExtCfg(identifier, null);
	                if (extConfig && !isNullOrUndefined(extConfig[field])) {
	                    theValue = extConfig[field];
	                }
	                else if (config && !isNullOrUndefined(config[field])) {
	                    theValue = config[field];
	                }
	                return !isNullOrUndefined(theValue) ? theValue : defaultValue;
	            };
	            _self.hasNext = function () {
	                return _nextProxy != null;
	            };
	            _self.getNext = function () {
	                return _nextProxy;
	            };
	            _self.setNext = function (nextPlugin) {
	                _nextProxy = nextPlugin;
	            };
	            _self.processNext = function (env) {
	                var nextPlugin = _nextProxy;
	                if (nextPlugin) {
	                    // Automatically move to the next plugin
	                    _nextProxy = nextPlugin.getNext();
	                    nextPlugin.processTelemetry(env, _self);
	                }
	            };
	            _self.createNew = function (plugins, startAt) {
	                if (plugins === void 0) { plugins = null; }
	                return new ProcessTelemetryContext(plugins || _nextProxy, config, core, startAt);
	            };
	        }
	        return ProcessTelemetryContext;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	
	
	    var strIKey = "iKey";
	    var strExtensionConfig = "extensionConfig";
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var strGetPlugin = "getPlugin";
	    /**
	     * BaseTelemetryPlugin provides a basic implementation of the ITelemetryPlugin interface so that plugins
	     * can avoid implementation the same set of boiler plate code as well as provide a base
	     * implementation so that new default implementations can be added without breaking all plugins.
	     */
	    var BaseTelemetryPlugin = /** @class */ (function () {
	        function BaseTelemetryPlugin() {
	            var _self = this;
	            var _isinitialized = false;
	            var _rootCtx = null; // Used as the root context, holding the current config and initialized core
	            var _nextPlugin = null; // Used for backward compatibility where plugins don't call the main pipeline
	            _self.core = null;
	            _self.diagLog = function (itemCtx) {
	                return _self._getTelCtx(itemCtx).diagLog();
	            };
	            _self.isInitialized = function () {
	                return _isinitialized;
	            };
	            _self.setInitialized = function (isInitialized) {
	                _isinitialized = isInitialized;
	            };
	            // _self.getNextPlugin = () => DO NOT IMPLEMENT
	            // Sub-classes of this base class *should* not be relying on this value and instead
	            // should use processNext() function. If you require access to the plugin use the
	            // IProcessTelemetryContext.getNext().getPlugin() while in the pipeline, Note getNext() may return null.
	            _self.setNextPlugin = function (next) {
	                _nextPlugin = next;
	            };
	            _self.processNext = function (env, itemCtx) {
	                if (itemCtx) {
	                    // Normal core execution sequence
	                    itemCtx.processNext(env);
	                }
	                else if (_nextPlugin && isFunction(_nextPlugin.processTelemetry)) {
	                    // Looks like backward compatibility or out of band processing. And as it looks 
	                    // like a ITelemetryPlugin or ITelemetryPluginChain, just call processTelemetry
	                    _nextPlugin.processTelemetry(env, null);
	                }
	            };
	            _self._getTelCtx = function (currentCtx) {
	                if (currentCtx === void 0) { currentCtx = null; }
	                var itemCtx = currentCtx;
	                if (!itemCtx) {
	                    var rootCtx = _rootCtx || new ProcessTelemetryContext(null, {}, _self.core);
	                    // tslint:disable-next-line: prefer-conditional-expression
	                    if (_nextPlugin && _nextPlugin[strGetPlugin]) {
	                        // Looks like a chain object
	                        itemCtx = rootCtx.createNew(null, _nextPlugin[strGetPlugin]);
	                    }
	                    else {
	                        itemCtx = rootCtx.createNew(null, _nextPlugin);
	                    }
	                }
	                return itemCtx;
	            };
	            _self._baseTelInit = function (config, core, extensions, pluginChain) {
	                if (config) {
	                    // Make sure the extensionConfig exists
	                    setValue(config, strExtensionConfig, [], null, isNullOrUndefined);
	                }
	                if (!pluginChain && core) {
	                    // Get the first plugin from the core
	                    pluginChain = core.getProcessTelContext().getNext();
	                }
	                var nextPlugin = _nextPlugin;
	                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
	                    // If it looks like a proxy/chain then get the plugin
	                    nextPlugin = _nextPlugin[strGetPlugin]();
	                }
	                // Support legacy plugins where core was defined as a property
	                _self.core = core;
	                _rootCtx = new ProcessTelemetryContext(pluginChain, config, core, nextPlugin);
	                _isinitialized = true;
	            };
	        }
	        BaseTelemetryPlugin.prototype.initialize = function (config, core, extensions, pluginChain) {
	            this._baseTelInit(config, core, extensions, pluginChain);
	        };
	        return BaseTelemetryPlugin;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var processTelemetry = "processTelemetry";
	    var priority = "priority";
	    var setNextPlugin = "setNextPlugin";
	    var isInitialized = "isInitialized";
	    /**
	     * Initialize the queue of plugins
	     * @param plugins - The array of plugins to initialize and setting of the next plugin
	     * @param config The current config for the instance
	     * @param core THe current core instance
	     * @param extensions The extensions
	     */
	    function initializePlugins(processContext, extensions) {
	        // Set the next plugin and identified the uninitialized plugins
	        var initPlugins = [];
	        var lastPlugin = null;
	        var proxy = processContext.getNext();
	        while (proxy) {
	            var thePlugin = proxy.getPlugin();
	            if (thePlugin) {
	                if (lastPlugin &&
	                    isFunction(lastPlugin[setNextPlugin]) &&
	                    isFunction(thePlugin[processTelemetry])) {
	                    // Set this plugin as the next for the previous one
	                    lastPlugin[setNextPlugin](thePlugin);
	                }
	                if (!isFunction(thePlugin[isInitialized]) || !thePlugin[isInitialized]()) {
	                    initPlugins.push(thePlugin);
	                }
	                lastPlugin = thePlugin;
	                proxy = proxy.getNext();
	            }
	        }
	        // Now initiatilize the plugins
	        arrForEach(initPlugins, function (thePlugin) {
	            thePlugin.initialize(processContext.getCfg(), processContext.core(), extensions, processContext.getNext());
	        });
	    }
	    function sortPlugins(plugins) {
	        // Sort by priority
	        return plugins.sort(function (extA, extB) {
	            var result = 0;
	            var bHasProcess = isFunction(extB[processTelemetry]);
	            if (isFunction(extA[processTelemetry])) {
	                result = bHasProcess ? extA[priority] - extB[priority] : 1;
	            }
	            else if (bHasProcess) {
	                result = -1;
	            }
	            return result;
	        });
	        // sort complete    
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var ChannelControllerPriority = 500;
	    var ChannelValidationMessage = "Channel has invalid priority";
	    var ChannelController = /** @class */ (function (_super) {
	        __extends(ChannelController, _super);
	        function ChannelController() {
	            var _this = _super.call(this) || this;
	            _this.identifier = "ChannelControllerPlugin";
	            _this.priority = ChannelControllerPriority; // in reserved range 100 to 200
	            var _channelQueue;
	            dynamicProto(ChannelController, _this, function (_self, _base) {
	                _self.setNextPlugin = function (next) {
	                    // The Channel controller is last in pipeline
	                };
	                _self.processTelemetry = function (item, itemCtx) {
	                    if (_channelQueue) {
	                        arrForEach(_channelQueue, function (queues) {
	                            // pass on to first item in queue
	                            if (queues.length > 0) {
	                                // Copying the item context as we could have mutiple chains that are executing asynchronously
	                                // and calling _getDefTelCtx as it's possible that the caller doesn't pass any context
	                                var chainCtx = _this._getTelCtx(itemCtx).createNew(queues);
	                                chainCtx.processNext(item);
	                            }
	                        });
	                    }
	                };
	                _self.getChannelControls = function () {
	                    return _channelQueue;
	                };
	                _self.initialize = function (config, core, extensions) {
	                    if (_self.isInitialized()) {
	                        // already initialized
	                        return;
	                    }
	                    _base.initialize(config, core, extensions);
	                    _createChannelQueues((config || {}).channels, extensions);
	                    // Initialize the Queues
	                    arrForEach(_channelQueue, function (queue) { return initializePlugins(new ProcessTelemetryContext(queue, config, core), extensions); });
	                };
	            });
	            function _checkQueuePriority(queue) {
	                arrForEach(queue, function (queueItem) {
	                    if (queueItem.priority < ChannelControllerPriority) {
	                        throwError(ChannelValidationMessage + queueItem.identifier);
	                    }
	                });
	            }
	            function _addChannelQueue(queue) {
	                if (queue && queue.length > 0) {
	                    queue = queue.sort(function (a, b) {
	                        return a.priority - b.priority;
	                    });
	                    _checkQueuePriority(queue);
	                    _channelQueue.push(queue);
	                }
	            }
	            function _createChannelQueues(channels, extensions) {
	                _channelQueue = [];
	                if (channels) {
	                    // Add and sort the configuration channel queues
	                    arrForEach(channels, function (queue) { return _addChannelQueue(queue); });
	                }
	                if (extensions) {
	                    // Create a new channel queue for any extensions with a priority > the ChannelControllerPriority
	                    var extensionQueue_1 = [];
	                    arrForEach(extensions, function (plugin) {
	                        if (plugin.priority > ChannelControllerPriority) {
	                            extensionQueue_1.push(plugin);
	                        }
	                    });
	                    _addChannelQueue(extensionQueue_1);
	                }
	            }
	            return _this;
	        }
	    // Removed Stub for ChannelController.prototype.getChannelControls.
	    // Removed Stub for ChannelController.prototype.initialize.
	        /**
	         * Static constructor, attempt to create accessors
	         */
	        // tslint:disable-next-line
	        ChannelController._staticInit = (function () {
	            var proto = ChannelController.prototype;
	            // Dynamically create get/set property accessors
	            objDefineAccessors(proto, "ChannelControls", proto.getChannelControls);
	            objDefineAccessors(proto, "channelQueue", proto.getChannelControls);
	        })();
	        return ChannelController;
	    }(BaseTelemetryPlugin));
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var strToGMTString = "toGMTString";
	    var strToUTCString = "toUTCString";
	    var strCookie = "cookie";
	    var strExpires = "expires";
	    var strEnabled = "enabled";
	    var strIsCookieUseDisabled = "isCookieUseDisabled";
	    var strDisableCookiesUsage = "disableCookiesUsage";
	    var strConfigCookieMgr = "_ckMgr";
	    var strEmpty = "";
	    var _supportsCookies = null;
	    var _allowUaSameSite = null;
	    var _parsedCookieValue = null;
	    var _doc = getDocument();
	    var _cookieCache = {};
	    var _globalCookieConfig = {};
	    /**
	     * @ignore
	     * DO NOT USE or export from the module, this is exposed as public to support backward compatibility of previous static utility methods only.
	     * If you want to manager cookies either use the ICookieMgr available from the core instance via getCookieMgr() or create
	     * your own instance of the CookieMgr and use that.
	     * Using this directly for enabling / disabling cookie handling will not only affect your usage but EVERY user of cookies.
	     * Example, if you are using a shared component that is also using Application Insights you will affect their cookie handling.
	     * @param logger - The DiagnosticLogger to use for reporting errors.
	     */
	    function _gblCookieMgr(config, logger) {
	        // Stash the global instance against the BaseCookieMgr class
	        var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
	        if (!inst) {
	            // Note: not using the getSetValue() helper as that would require always creating a temporary cookieMgr
	            // that ultimately is never used
	            inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
	            _globalCookieConfig[strConfigCookieMgr] = inst;
	        }
	        return inst;
	    }
	    function _isMgrEnabled(cookieMgr) {
	        if (cookieMgr) {
	            return cookieMgr.isEnabled();
	        }
	        return true;
	    }
	    function _createCookieMgrConfig(rootConfig) {
	        var cookieMgrCfg = rootConfig.cookieCfg = rootConfig.cookieCfg || {};
	        // Sets the values from the root config if not already present on the cookieMgrCfg
	        setValue(cookieMgrCfg, "domain", rootConfig.cookieDomain, isNotNullOrUndefined, isNullOrUndefined);
	        setValue(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, isNullOrUndefined);
	        if (isNullOrUndefined(cookieMgrCfg[strEnabled])) {
	            // Set the enabled from the provided setting or the legacy root values
	            var cookieEnabled = void 0;
	            if (!isUndefined(rootConfig[strIsCookieUseDisabled])) {
	                cookieEnabled = !rootConfig[strIsCookieUseDisabled];
	            }
	            if (!isUndefined(rootConfig[strDisableCookiesUsage])) {
	                cookieEnabled = !rootConfig[strDisableCookiesUsage];
	            }
	            cookieMgrCfg[strEnabled] = cookieEnabled;
	        }
	        return cookieMgrCfg;
	    }
	    function createCookieMgr(rootConfig, logger) {
	        var cookieMgrConfig = _createCookieMgrConfig(rootConfig || _globalCookieConfig);
	        var _path = cookieMgrConfig.path || "/";
	        var _domain = cookieMgrConfig.domain;
	        // Explicitly checking against false, so that setting to undefined will === true
	        var _enabled = cookieMgrConfig[strEnabled] !== false;
	        var cookieMgr = {
	            isEnabled: function () {
	                var enabled = _enabled && areCookiesSupported(logger);
	                // Using an indirect lookup for any global cookie manager to support tree shaking for SDK's
	                // that don't use the "applicationinsights-core" version of the default cookie function
	                var gblManager = _globalCookieConfig[strConfigCookieMgr];
	                if (enabled && gblManager && cookieMgr !== gblManager) {
	                    // Make sure the GlobalCookie Manager instance (if not this instance) is also enabled.
	                    // As the global (deprecated) functions may have been called (for backward compatibility)
	                    enabled = _isMgrEnabled(gblManager);
	                }
	                return enabled;
	            },
	            setEnabled: function (value) {
	                // Explicitly checking against false, so that setting to undefined will === true
	                _enabled = value !== false;
	            },
	            set: function (name, value, maxAgeSec, domain, path) {
	                if (_isMgrEnabled(cookieMgr)) {
	                    var values = {};
	                    var theValue = strTrim(value || strEmpty);
	                    var idx = theValue.indexOf(";");
	                    if (idx !== -1) {
	                        theValue = strTrim(value.substring(0, idx));
	                        values = _extractParts(value.substring(idx + 1));
	                    }
	                    // Only update domain if not already present (isUndefined) and the value is truthy (not null, undefined or empty string)
	                    setValue(values, "domain", domain || _domain, isTruthy, isUndefined);
	                    if (!isNullOrUndefined(maxAgeSec)) {
	                        var _isIE = isIE();
	                        if (isUndefined(values[strExpires])) {
	                            var nowMs = dateNow();
	                            // Only add expires if not already present
	                            var expireMs = nowMs + (maxAgeSec * 1000);
	                            // Sanity check, if zero or -ve then ignore
	                            if (expireMs > 0) {
	                                var expiry = new Date();
	                                expiry.setTime(expireMs);
	                                setValue(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || strEmpty, isTruthy);
	                            }
	                        }
	                        if (!_isIE) {
	                            // Only replace if not already present
	                            setValue(values, "max-age", strEmpty + maxAgeSec, null, isUndefined);
	                        }
	                    }
	                    var location_1 = getLocation();
	                    if (location_1 && location_1.protocol === "https:") {
	                        setValue(values, "secure", null, null, isUndefined);
	                        // Only set same site if not also secure
	                        if (_allowUaSameSite === null) {
	                            _allowUaSameSite = !uaDisallowsSameSiteNone((getNavigator() || {}).userAgent);
	                        }
	                        if (_allowUaSameSite) {
	                            setValue(values, "SameSite", "None", null, isUndefined);
	                        }
	                    }
	                    setValue(values, "path", path || _path, null, isUndefined);
	                    var setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
	                    setCookieFn(name, _formatCookieValue(theValue, values));
	                }
	            },
	            get: function (name) {
	                var value = strEmpty;
	                if (_isMgrEnabled(cookieMgr)) {
	                    value = (cookieMgrConfig.getCookie || _getCookieValue)(name);
	                }
	                return value;
	            },
	            del: function (name, path) {
	                if (_isMgrEnabled(cookieMgr)) {
	                    // Only remove the cookie if the manager and cookie support has not been disabled
	                    cookieMgr.purge(name, path);
	                }
	            },
	            purge: function (name, path) {
	                if (areCookiesSupported(logger)) {
	                    // Setting the expiration date in the past immediately removes the cookie
	                    var values = (_a = {},
	                        _a["path"] = path ? path : "/",
	                        _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT",
	                        _a);
	                    if (!isIE()) {
	                        // Set max age to expire now
	                        values["max-age"] = "0";
	                    }
	                    var delCookie = cookieMgrConfig.delCookie || _setCookieValue;
	                    delCookie(name, _formatCookieValue(strEmpty, values));
	                }
	                var _a;
	            }
	        };
	        // Associated this cookie manager with the config
	        cookieMgr[strConfigCookieMgr] = cookieMgr;
	        return cookieMgr;
	    }
	    /*
	    * Helper method to tell if document.cookie object is supported by the runtime
	    */
	    function areCookiesSupported(logger) {
	        if (_supportsCookies === null) {
	            _supportsCookies = false;
	            try {
	                var doc = _doc || {};
	                _supportsCookies = doc[strCookie] !== undefined;
	            }
	            catch (e) {
	                logger && logger.throwInternal(LoggingSeverity.WARNING, _InternalMessageId.CannotAccessCookie, "Cannot access document.cookie - " + getExceptionName(e), { exception: dumpObj(e) });
	            }
	        }
	        return _supportsCookies;
	    }
	    function _extractParts(theValue) {
	        var values = {};
	        if (theValue && theValue.length) {
	            var parts = strTrim(theValue).split(";");
	            arrForEach(parts, function (thePart) {
	                thePart = strTrim(thePart || strEmpty);
	                if (thePart) {
	                    var idx = thePart.indexOf("=");
	                    if (idx === -1) {
	                        values[thePart] = null;
	                    }
	                    else {
	                        values[strTrim(thePart.substring(0, idx))] = strTrim(thePart.substring(idx + 1));
	                    }
	                }
	            });
	        }
	        return values;
	    }
	    function _formatDate(theDate, func) {
	        if (isFunction(theDate[func])) {
	            return theDate[func]();
	        }
	        return null;
	    }
	    function _formatCookieValue(value, values) {
	        var cookieValue = value || strEmpty;
	        objForEachKey(values, function (name, theValue) {
	            cookieValue += "; " + name + (!isNullOrUndefined(theValue) ? "=" + theValue : strEmpty);
	        });
	        return cookieValue;
	    }
	    function _getCookieValue(name) {
	        var cookieValue = strEmpty;
	        if (_doc) {
	            var theCookie = _doc[strCookie] || strEmpty;
	            if (_parsedCookieValue !== theCookie) {
	                _cookieCache = _extractParts(theCookie);
	                _parsedCookieValue = theCookie;
	            }
	            cookieValue = strTrim(_cookieCache[name] || strEmpty);
	        }
	        return cookieValue;
	    }
	    function _setCookieValue(name, cookieValue) {
	        if (_doc) {
	            _doc[strCookie] = name + "=" + cookieValue;
	        }
	    }
	    function uaDisallowsSameSiteNone(userAgent) {
	        if (!isString(userAgent)) {
	            return false;
	        }
	        // Cover all iOS based browsers here. This includes:
	        // - Safari on iOS 12 for iPhone, iPod Touch, iPad
	        // - WkWebview on iOS 12 for iPhone, iPod Touch, iPad
	        // - Chrome on iOS 12 for iPhone, iPod Touch, iPad
	        // All of which are broken by SameSite=None, because they use the iOS networking stack
	        if (strContains(userAgent, "CPU iPhone OS 12") || strContains(userAgent, "iPad; CPU OS 12")) {
	            return true;
	        }
	        // Cover Mac OS X based browsers that use the Mac OS networking stack. This includes:
	        // - Safari on Mac OS X
	        // This does not include:
	        // - Internal browser on Mac OS X
	        // - Chrome on Mac OS X
	        // - Chromium on Mac OS X
	        // Because they do not use the Mac OS networking stack.
	        if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strContains(userAgent, "Version/") && strContains(userAgent, "Safari")) {
	            return true;
	        }
	        // Cover Mac OS X internal browsers that use the Mac OS networking stack. This includes:
	        // - Internal browser on Mac OS X
	        // This does not include:
	        // - Safari on Mac OS X
	        // - Chrome on Mac OS X
	        // - Chromium on Mac OS X
	        // Because they do not use the Mac OS networking stack.
	        if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strEndsWith(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
	            return true;
	        }
	        // Cover Chrome 50-69, because some versions are broken by SameSite=None, and none in this range require it.
	        // Note: this covers some pre-Chromium Edge versions, but pre-Chromim Edge does not require SameSite=None, so this is fine.
	        // Note: this regex applies to Windows, Mac OS X, and Linux, deliberately.
	        if (strContains(userAgent, "Chrome/5") || strContains(userAgent, "Chrome/6")) {
	            return true;
	        }
	        // Unreal Engine runs Chromium 59, but does not advertise as Chrome until 4.23. Treat versions of Unreal
	        // that don't specify their Chrome version as lacking support for SameSite=None.
	        if (strContains(userAgent, "UnrealEngine") && !strContains(userAgent, "Chrome")) {
	            return true;
	        }
	        // UCBrowser < 12.13.2 ignores Set-Cookie headers with SameSite=None
	        // NB: this rule isn't complete - you need regex to make a complete rule.
	        // See: https://www.chromium.org/updates/same-site/incompatible-clients
	        if (strContains(userAgent, "UCBrowser/12") || strContains(userAgent, "UCBrowser/11")) {
	            return true;
	        }
	        return false;
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var validationError = "Extensions must provide callback to initialize";
	    var strNotificationManager = "_notificationManager";
	    var BaseCore = /** @class */ (function () {
	        function BaseCore() {
	            var _isInitialized = false;
	            var _eventQueue;
	            var _channelController;
	            var _notificationManager;
	            var _perfManager;
	            var _cookieManager;
	            dynamicProto(BaseCore, this, function (_self) {
	                _self._extensions = new Array();
	                _channelController = new ChannelController();
	                _self.logger = objCreateFn({
	                    throwInternal: function (severity, msgId, msg, properties, isUserAct) {
	                        if (isUserAct === void 0) { isUserAct = false; }
	                    },
	                    warnToConsole: function (message) { },
	                    resetInternalMessageCount: function () { }
	                });
	                _eventQueue = [];
	                _self.isInitialized = function () { return _isInitialized; };
	                _self.initialize = function (config, extensions, logger, notificationManager) {
	                    // Make sure core is only initialized once
	                    if (_self.isInitialized()) {
	                        throwError("Core should not be initialized more than once");
	                    }
	                    if (!config || isNullOrUndefined(config.instrumentationKey)) {
	                        throwError("Please provide instrumentation key");
	                    }
	                    _notificationManager = notificationManager;
	                    // For backward compatibility only
	                    _self[strNotificationManager] = notificationManager;
	                    _self.config = config || {};
	                    config.extensions = isNullOrUndefined(config.extensions) ? [] : config.extensions;
	                    // add notification to the extensions in the config so other plugins can access it
	                    var extConfig = getSetValue(config, strExtensionConfig);
	                    extConfig.NotificationManager = notificationManager;
	                    if (logger) {
	                        _self.logger = logger;
	                    }
	                    // Concat all available extensions
	                    var allExtensions = [];
	                    allExtensions.push.apply(allExtensions, extensions.concat(config.extensions));
	                    allExtensions = sortPlugins(allExtensions);
	                    var coreExtensions = [];
	                    // Check if any two extensions have the same priority, then warn to console
	                    // And extract the local extensions from the 
	                    var extPriorities = {};
	                    // Extension validation
	                    arrForEach(allExtensions, function (ext) {
	                        if (isNullOrUndefined(ext) || isNullOrUndefined(ext.initialize)) {
	                            throwError(validationError);
	                        }
	                        var extPriority = ext.priority;
	                        var identifier = ext.identifier;
	                        if (ext && extPriority) {
	                            if (!isNullOrUndefined(extPriorities[extPriority])) {
	                                logger.warnToConsole("Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
	                            }
	                            else {
	                                // set a value
	                                extPriorities[extPriority] = identifier;
	                            }
	                        }
	                        // Split extensions to core and channelController
	                        if (!extPriority || extPriority < _channelController.priority) {
	                            // Add to core extension that will be managed by BaseCore
	                            coreExtensions.push(ext);
	                        }
	                    });
	                    // Validation complete
	                    // Add the channelController to the complete extension collection and
	                    // to the end of the core extensions
	                    allExtensions.push(_channelController);
	                    coreExtensions.push(_channelController);
	                    // Sort the complete set of extensions by priority
	                    allExtensions = sortPlugins(allExtensions);
	                    _self._extensions = allExtensions;
	                    // initialize channel controller first, this will initialize all channel plugins
	                    initializePlugins(new ProcessTelemetryContext([_channelController], config, _self), allExtensions);
	                    initializePlugins(new ProcessTelemetryContext(coreExtensions, config, _self), allExtensions);
	                    // Now reset the extensions to just those being managed by Basecore
	                    _self._extensions = coreExtensions;
	                    if (_self.getTransmissionControls().length === 0) {
	                        throwError("No channels available");
	                    }
	                    _isInitialized = true;
	                    _self.releaseQueue();
	                };
	                _self.getTransmissionControls = function () {
	                    return _channelController.getChannelControls();
	                };
	                _self.track = function (telemetryItem) {
	                    // setup default iKey if not passed in
	                    setValue(telemetryItem, strIKey, _self.config.instrumentationKey, null, isNotTruthy);
	                    // add default timestamp if not passed in
	                    setValue(telemetryItem, "time", toISOString(new Date()), null, isNotTruthy);
	                    // Common Schema 4.0
	                    setValue(telemetryItem, "ver", "4.0", null, isNullOrUndefined);
	                    if (_self.isInitialized()) {
	                        // Process the telemetry plugin chain
	                        _self.getProcessTelContext().processNext(telemetryItem);
	                    }
	                    else {
	                        // Queue events until all extensions are initialized
	                        _eventQueue.push(telemetryItem);
	                    }
	                };
	                _self.getProcessTelContext = function () {
	                    var extensions = _self._extensions;
	                    var thePlugins = extensions;
	                    // invoke any common telemetry processors before sending through pipeline
	                    if (!extensions || extensions.length === 0) {
	                        // Pass to Channel controller so data is sent to correct channel queues
	                        thePlugins = [_channelController];
	                    }
	                    return new ProcessTelemetryContext(thePlugins, _self.config, _self);
	                };
	                _self.getNotifyMgr = function () {
	                    if (!_notificationManager) {
	                        // Create Dummy notification manager
	                        _notificationManager = objCreateFn({
	                            addNotificationListener: function (listener) { },
	                            removeNotificationListener: function (listener) { },
	                            eventsSent: function (events) { },
	                            eventsDiscarded: function (events, reason) { },
	                            eventsSendRequest: function (sendReason, isAsync) { }
	                        });
	                        // For backward compatibility only
	                        _self[strNotificationManager] = _notificationManager;
	                    }
	                    return _notificationManager;
	                };
	                _self.getCookieMgr = function () {
	                    if (!_cookieManager) {
	                        _cookieManager = createCookieMgr(_self.config, _self.logger);
	                    }
	                    return _cookieManager;
	                };
	                _self.setCookieMgr = function (cookieMgr) {
	                    _cookieManager = cookieMgr;
	                };
	                _self.getPerfMgr = function () {
	                    if (!_perfManager) {
	                        if (_self.config && _self.config.enablePerfMgr) {
	                            _perfManager = new PerfManager(_self.getNotifyMgr());
	                        }
	                    }
	                    return _perfManager;
	                };
	                _self.setPerfMgr = function (perfMgr) {
	                    _perfManager = perfMgr;
	                };
	                _self.eventCnt = function () {
	                    return _eventQueue.length;
	                };
	                _self.releaseQueue = function () {
	                    if (_eventQueue.length > 0) {
	                        arrForEach(_eventQueue, function (event) {
	                            _self.getProcessTelContext().processNext(event);
	                        });
	                        _eventQueue = [];
	                    }
	                };
	            });
	        }
	    // Removed Stub for BaseCore.prototype.initialize.
	    // Removed Stub for BaseCore.prototype.getTransmissionControls.
	    // Removed Stub for BaseCore.prototype.track.
	    // Removed Stub for BaseCore.prototype.getProcessTelContext.
	    // Removed Stub for BaseCore.prototype.getNotifyMgr.
	    // Removed Stub for BaseCore.prototype.getCookieMgr.
	    // Removed Stub for BaseCore.prototype.setCookieMgr.
	    // Removed Stub for BaseCore.prototype.getPerfMgr.
	    // Removed Stub for BaseCore.prototype.setPerfMgr.
	    // Removed Stub for BaseCore.prototype.eventCnt.
	    // Removed Stub for BaseCore.prototype.releaseQueue.
	        return BaseCore;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    /**
	     * Class to manage sending notifications to all the listeners.
	     */
	    var NotificationManager = /** @class */ (function () {
	        function NotificationManager(config) {
	            this.listeners = [];
	            var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
	            dynamicProto(NotificationManager, this, function (_self) {
	                _self.addNotificationListener = function (listener) {
	                    _self.listeners.push(listener);
	                };
	                /**
	                 * Removes all instances of the listener.
	                 * @param {INotificationListener} listener - AWTNotificationListener to remove.
	                 */
	                _self.removeNotificationListener = function (listener) {
	                    var index = arrIndexOf(_self.listeners, listener);
	                    while (index > -1) {
	                        _self.listeners.splice(index, 1);
	                        index = arrIndexOf(_self.listeners, listener);
	                    }
	                };
	                /**
	                 * Notification for events sent.
	                 * @param {ITelemetryItem[]} events - The array of events that have been sent.
	                 */
	                _self.eventsSent = function (events) {
	                    arrForEach(_self.listeners, function (listener) {
	                        if (listener && listener.eventsSent) {
	                            setTimeout(function () { return listener.eventsSent(events); }, 0);
	                        }
	                    });
	                };
	                /**
	                 * Notification for events being discarded.
	                 * @param {ITelemetryItem[]} events - The array of events that have been discarded by the SDK.
	                 * @param {number} reason           - The reason for which the SDK discarded the events. The EventsDiscardedReason
	                 * constant should be used to check the different values.
	                 */
	                _self.eventsDiscarded = function (events, reason) {
	                    arrForEach(_self.listeners, function (listener) {
	                        if (listener && listener.eventsDiscarded) {
	                            setTimeout(function () { return listener.eventsDiscarded(events, reason); }, 0);
	                        }
	                    });
	                };
	                /**
	                 * [Optional] A function called when the events have been requested to be sent to the sever.
	                 * @param {number} sendReason - The reason why the event batch is being sent.
	                 * @param {boolean} isAsync   - A flag which identifies whether the requests are being sent in an async or sync manner.
	                 */
	                _self.eventsSendRequest = function (sendReason, isAsync) {
	                    arrForEach(_self.listeners, function (listener) {
	                        if (listener && listener.eventsSendRequest) {
	                            if (isAsync) {
	                                setTimeout(function () { return listener.eventsSendRequest(sendReason, isAsync); }, 0);
	                            }
	                            else {
	                                try {
	                                    listener.eventsSendRequest(sendReason, isAsync);
	                                }
	                                catch (e) {
	                                    // Catch errors to ensure we don't block sending the requests
	                                }
	                            }
	                        }
	                    });
	                };
	                _self.perfEvent = function (perfEvent) {
	                    if (perfEvent) {
	                        // Send all events or only parent events
	                        if (perfEvtsSendAll || !perfEvent.isChildEvt()) {
	                            arrForEach(_self.listeners, function (listener) {
	                                if (listener && listener.perfEvent) {
	                                    if (perfEvent.isAsync) {
	                                        setTimeout(function () { return listener.perfEvent(perfEvent); }, 0);
	                                    }
	                                    else {
	                                        try {
	                                            listener.perfEvent(perfEvent);
	                                        }
	                                        catch (e) {
	                                            // Catch errors to ensure we don't block sending the requests
	                                        }
	                                    }
	                                }
	                            });
	                        }
	                    }
	                };
	            });
	        }
	    // Removed Stub for NotificationManager.prototype.addNotificationListener.
	    // Removed Stub for NotificationManager.prototype.removeNotificationListener.
	    // Removed Stub for NotificationManager.prototype.eventsSent.
	    // Removed Stub for NotificationManager.prototype.eventsDiscarded.
	    // Removed Stub for NotificationManager.prototype.eventsSendRequest.
	        return NotificationManager;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var AppInsightsCore = /** @class */ (function (_super) {
	        __extends(AppInsightsCore, _super);
	        function AppInsightsCore() {
	            var _this = _super.call(this) || this;
	            dynamicProto(AppInsightsCore, _this, function (_self, _base) {
	                _self.initialize = function (config, extensions, logger, notificationManager) {
	                    _base.initialize(config, extensions, logger || new DiagnosticLogger(config), notificationManager || new NotificationManager(config));
	                };
	                _self.track = function (telemetryItem) {
	                    doPerf(_self.getPerfMgr(), function () { return "AppInsightsCore:track"; }, function () {
	                        if (telemetryItem === null) {
	                            _notifyInvalidEvent(telemetryItem);
	                            // throw error
	                            throwError("Invalid telemetry item");
	                        }
	                        // do basic validation before sending it through the pipeline
	                        _validateTelemetryItem(telemetryItem);
	                        _base.track(telemetryItem);
	                    }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
	                };
	                /**
	                 * Adds a notification listener. The SDK calls methods on the listener when an appropriate notification is raised.
	                 * The added plugins must raise notifications. If the plugins do not implement the notifications, then no methods will be
	                 * called.
	                 * @param {INotificationListener} listener - An INotificationListener object.
	                 */
	                _self.addNotificationListener = function (listener) {
	                    var manager = _self.getNotifyMgr();
	                    if (manager) {
	                        manager.addNotificationListener(listener);
	                    }
	                };
	                /**
	                 * Removes all instances of the listener.
	                 * @param {INotificationListener} listener - INotificationListener to remove.
	                 */
	                _self.removeNotificationListener = function (listener) {
	                    var manager = _self.getNotifyMgr();
	                    if (manager) {
	                        manager.removeNotificationListener(listener);
	                    }
	                };
	                /**
	                 * Periodically check logger.queue for
	                 */
	                _self.pollInternalLogs = function (eventName) {
	                    var interval = _self.config.diagnosticLogInterval;
	                    if (!interval || !(interval > 0)) {
	                        interval = 10000;
	                    }
	                    return setInterval(function () {
	                        var queue = _self.logger ? _self.logger.queue : [];
	                        arrForEach(queue, function (logMessage) {
	                            var item = {
	                                name: eventName ? eventName : "InternalMessageId: " + logMessage.messageId,
	                                iKey: _self.config.instrumentationKey,
	                                time: toISOString(new Date()),
	                                baseType: _InternalLogMessage.dataType,
	                                baseData: { message: logMessage.message }
	                            };
	                            _self.track(item);
	                        });
	                        queue.length = 0;
	                    }, interval);
	                };
	                function _validateTelemetryItem(telemetryItem) {
	                    if (isNullOrUndefined(telemetryItem.name)) {
	                        _notifyInvalidEvent(telemetryItem);
	                        throw Error("telemetry name required");
	                    }
	                }
	                function _notifyInvalidEvent(telemetryItem) {
	                    var manager = _self.getNotifyMgr();
	                    if (manager) {
	                        manager.eventsDiscarded([telemetryItem], EventsDiscardedReason.InvalidEvent);
	                    }
	                }
	            });
	            return _this;
	        }
	    // Removed Stub for AppInsightsCore.prototype.initialize.
	    // Removed Stub for AppInsightsCore.prototype.track.
	    // Removed Stub for AppInsightsCore.prototype.addNotificationListener.
	    // Removed Stub for AppInsightsCore.prototype.removeNotificationListener.
	    // Removed Stub for AppInsightsCore.prototype.pollInternalLogs.
	        return AppInsightsCore;
	    }(BaseCore));
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var UInt32Mask = 0x100000000;
	    var MaxUInt32 = 0xffffffff;
	    // MWC based Random generator (for IE)
	    var _mwcSeeded = false;
	    var _mwcW = 123456789;
	    var _mwcZ = 987654321;
	    // Takes any integer
	    function _mwcSeed(seedValue) {
	        if (seedValue < 0) {
	            // Make sure we end up with a positive number and not -ve one.
	            seedValue >>>= 0;
	        }
	        _mwcW = (123456789 + seedValue) & MaxUInt32;
	        _mwcZ = (987654321 - seedValue) & MaxUInt32;
	        _mwcSeeded = true;
	    }
	    function _autoSeedMwc() {
	        // Simple initialization using default Math.random() - So we inherit any entropy from the browser
	        // and bitwise XOR with the current milliseconds
	        try {
	            var now = dateNow() & 0x7fffffff;
	            _mwcSeed(((Math.random() * UInt32Mask) ^ now) + now);
	        }
	        catch (e) {
	            // Don't crash if something goes wrong
	        }
	    }
	    /**
	     * Generate a random value between 0 and maxValue, max value should be limited to a 32-bit maximum.
	     * So maxValue(16) will produce a number from 0..16 (range of 17)
	     * @param maxValue
	     */
	    function randomValue(maxValue) {
	        if (maxValue > 0) {
	            return Math.floor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
	        }
	        return 0;
	    }
	    /**
	     * generate a random 32-bit number (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), defaults un-unsigned.
	     * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
	     */
	    function random32(signed) {
	        var value;
	        var c = getCrypto() || getMsCrypto();
	        if (c && c.getRandomValues) {
	            // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
	            value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
	        }
	        else if (isIE()) {
	            // For IE 6, 7, 8 (especially on XP) Math.random is not very random
	            if (!_mwcSeeded) {
	                // Set the seed for the Mwc algorithm
	                _autoSeedMwc();
	            }
	            // Don't use Math.random for IE
	            // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
	            value = mwcRandom32() & MaxUInt32;
	        }
	        else {
	            // Make sure the number is converted into the specified range (-0x80000000..0x7FFFFFFF)
	            value = Math.floor((UInt32Mask * Math.random()) | 0);
	        }
	        if (!signed) {
	            // Make sure we end up with a positive number and not -ve one.
	            value >>>= 0;
	        }
	        return value;
	    }
	    /**
	     * Seed the MWC random number generator with the specified seed or a random value
	     * @param value - optional the number to used as the seed, if undefined, null or zero a random value will be chosen
	     */
	    function mwcRandomSeed(value) {
	        if (!value) {
	            _autoSeedMwc();
	        }
	        else {
	            _mwcSeed(value);
	        }
	    }
	    /**
	     * Generate a random 32-bit number between (0x000000..0xFFFFFFFF) or (-0x80000000..0x7FFFFFFF), using MWC (Multiply with carry)
	     * instead of Math.random() defaults to un-signed.
	     * Used as a replacement random generator for IE to avoid issues with older IE instances.
	     * @param signed - True to return a signed 32-bit number (-0x80000000..0x7FFFFFFF) otherwise an unsigned one (0x000000..0xFFFFFFFF)
	     */
	    function mwcRandom32(signed) {
	        _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
	        _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
	        var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
	        if (!signed) {
	            // Make sure we end up with a positive number and not -ve one.
	            value >>>= 0;
	        }
	        return value;
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var _cookieMgrs = null;
	    var _canUseCookies; // legacy supported config
	    /**
	     * Trys to add an event handler for the specified event to the window, body and document
	     * @param eventName {string} - The name of the event
	     * @param callback {any} - The callback function that needs to be executed for the given event
	     * @return {boolean} - true if the handler was successfully added
	     */
	    function addEventHandler(eventName, callback) {
	        var result = false;
	        var w = getWindow();
	        if (w) {
	            result = attachEvent(w, eventName, callback);
	            result = attachEvent(w["body"], eventName, callback) || result;
	        }
	        var doc = getDocument();
	        if (doc) {
	            result = EventHelper.Attach(doc, eventName, callback) || result;
	        }
	        return result;
	    }
	    function newGuid() {
	        function randomHexDigit() {
	            return randomValue(15); // Get a random value from 0..15
	        }
	        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(GuidRegex, function (c) {
	            var r = (randomHexDigit() | 0), v = (c === 'x' ? r : r & 0x3 | 0x8);
	            return v.toString(16);
	        });
	    }
	    /**
	     * Return the current value of the Performance Api now() function (if available) and fallback to dateNow() if it is unavailable (IE9 or less)
	     * https://caniuse.com/#search=performance.now
	     */
	    function perfNow() {
	        var perf = getPerformance();
	        if (perf && perf.now) {
	            return perf.now();
	        }
	        return dateNow();
	    }
	    /**
	     * Generate random base64 id string.
	     * The default length is 22 which is 132-bits so almost the same as a GUID but as base64 (the previous default was 5)
	     * @param maxLength - Optional value to specify the length of the id to be generated, defaults to 22
	     */
	    function newId(maxLength) {
	        if (maxLength === void 0) { maxLength = 22; }
	        var base64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	        // Start with an initial random number, consuming the value in reverse byte order
	        var number = random32() >>> 0; // Make sure it's a +ve number
	        var chars = 0;
	        var result = "";
	        while (result.length < maxLength) {
	            chars++;
	            result += base64chars.charAt(number & 0x3F);
	            number >>>= 6; // Zero fill with right shift
	            if (chars === 5) {
	                // 5 base64 characters === 30 bits so we don't have enough bits for another base64 char
	                // So add on another 30 bits and make sure it's +ve
	                number = (((random32() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
	                chars = 0; // We need to reset the number every 5 chars (30 bits)
	            }
	        }
	        return result;
	    }
	    /**
	     * generate W3C trace id
	     */
	    function generateW3CId() {
	        var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
	        // rfc4122 version 4 UUID without dashes and with lowercase letters
	        var oct = "", tmp;
	        for (var a = 0; a < 4; a++) {
	            tmp = random32();
	            oct +=
	                hexValues[tmp & 0xF] +
	                    hexValues[tmp >> 4 & 0xF] +
	                    hexValues[tmp >> 8 & 0xF] +
	                    hexValues[tmp >> 12 & 0xF] +
	                    hexValues[tmp >> 16 & 0xF] +
	                    hexValues[tmp >> 20 & 0xF] +
	                    hexValues[tmp >> 24 & 0xF] +
	                    hexValues[tmp >> 28 & 0xF];
	        }
	        // "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
	        var clockSequenceHi = hexValues[8 + (random32() & 0x03) | 0];
	        return oct.substr(0, 8) + oct.substr(9, 4) + "4" + oct.substr(13, 3) + clockSequenceHi + oct.substr(16, 3) + oct.substr(19, 12);
	    }
	    /**
	     * Provides a collection of utility functions, included for backward compatibility with previous releases.
	     * @deprecated Marking this instance as deprecated in favor of direct usage of the helper functions
	     * as direct usage provides better tree-shaking and minification by avoiding the inclusion of the unused items
	     * in your resulting code.
	     */
	    var CoreUtils = {
	        _canUseCookies: undefined,
	        isTypeof: isTypeof,
	        isUndefined: isUndefined,
	        isNullOrUndefined: isNullOrUndefined,
	        hasOwnProperty: hasOwnProperty,
	        isFunction: isFunction,
	        isObject: isObject,
	        isDate: isDate,
	        isArray: isArray,
	        isError: isError,
	        isString: isString,
	        isNumber: isNumber,
	        isBoolean: isBoolean,
	        toISOString: toISOString,
	        arrForEach: arrForEach,
	        arrIndexOf: arrIndexOf,
	        arrMap: arrMap,
	        arrReduce: arrReduce,
	        strTrim: strTrim,
	        objCreate: objCreateFn,
	        objKeys: objKeys,
	        objDefineAccessors: objDefineAccessors,
	        addEventHandler: addEventHandler,
	        dateNow: dateNow,
	        isIE: isIE,
	        disableCookies: disableCookies,
	        newGuid: newGuid,
	        perfNow: perfNow,
	        newId: newId,
	        randomValue: randomValue,
	        random32: random32,
	        mwcRandomSeed: mwcRandomSeed,
	        mwcRandom32: mwcRandom32,
	        generateW3CId: generateW3CId
	    };
	    var GuidRegex = /[xy]/g;
	    var EventHelper = {
	        Attach: attachEvent,
	        AttachEvent: attachEvent,
	        Detach: detachEvent,
	        DetachEvent: detachEvent
	    };
	    /**
	     * Helper to support backward compatibility for users that use the legacy cookie handling functions and the use the internal
	     * CoreUtils._canUseCookies global flag to enable/disable cookies usage.
	     * Note: This has the following deliberate side-effects
	     * - Creates the global (legacy) cookie manager if it does not already exist
	     * - Attempts to add "listeners" to the CoreUtils._canUseCookies property to support the legacy usage
	     * @param config
	     * @param logger
	     * @returns
	     */
	    function _legacyCookieMgr(config, logger) {
	        var cookieMgr = _gblCookieMgr(config, logger);
	        var legacyCanUseCookies = CoreUtils._canUseCookies;
	        if (_cookieMgrs === null) {
	            _cookieMgrs = [];
	            _canUseCookies = legacyCanUseCookies;
	            // Dynamically create get/set property accessors for backward compatibility for enabling / disabling cookies
	            // this WILL NOT work for ES3 browsers (< IE8)
	            objDefineAccessors(CoreUtils, "_canUseCookies", function () {
	                return _canUseCookies;
	            }, function (value) {
	                _canUseCookies = value;
	                arrForEach(_cookieMgrs, function (mgr) {
	                    mgr.setEnabled(value);
	                });
	            });
	        }
	        if (arrIndexOf(_cookieMgrs, cookieMgr) === -1) {
	            _cookieMgrs.push(cookieMgr);
	        }
	        if (isBoolean(legacyCanUseCookies)) {
	            cookieMgr.setEnabled(legacyCanUseCookies);
	        }
	        if (isBoolean(_canUseCookies)) {
	            cookieMgr.setEnabled(_canUseCookies);
	        }
	        return cookieMgr;
	    }
	    /**
	     * @deprecated - Use the core.getCookieMgr().disable()
	     * Force the SDK not to store and read any data from cookies.
	     */
	    function disableCookies() {
	        _legacyCookieMgr().setEnabled(false);
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.0
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	
	    /**
	     * ReactPlugin.ts
	     * @copyright Microsoft 2019
	     */
	    var ReactPlugin = /** @class */ (function (_super) {
	        __extends(ReactPlugin, _super);
	        function ReactPlugin() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this.priority = 185;
	            _this.identifier = 'ReactPlugin';
	            return _this;
	        }
	        ReactPlugin.prototype.initialize = function (config, core, extensions, pluginChain) {
	            var _this = this;
	            _super.prototype.initialize.call(this, config, core, extensions, pluginChain);
	            this._extensionConfig =
	                config.extensionConfig && config.extensionConfig[this.identifier]
	                    ? config.extensionConfig[this.identifier]
	                    : { history: null };
	            CoreUtils.arrForEach(extensions, function (ext) {
	                var identifier = ext.identifier;
	                if (identifier === 'ApplicationInsightsAnalytics') {
	                    _this._analyticsPlugin = ext;
	                }
	            });
	            if (this._extensionConfig.history) {
	                this.addHistoryListener(this._extensionConfig.history);
	                var pageViewTelemetry = {
	                    uri: this._extensionConfig.history.location.pathname
	                };
	                this.trackPageView(pageViewTelemetry);
	            }
	        };
	        /**
	         * Add Part A fields to the event
	         * @param event The event that needs to be processed
	         */
	        ReactPlugin.prototype.processTelemetry = function (event, itemCtx) {
	            this.processNext(event, itemCtx);
	        };
	        ReactPlugin.prototype.trackMetric = function (metric, customProperties) {
	            if (this._analyticsPlugin) {
	                this._analyticsPlugin.trackMetric(metric, customProperties);
	            }
	            else {
	                this.diagLog().throwInternal(LoggingSeverity.CRITICAL, _InternalMessageId.TelemetryInitializerFailed, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
	            }
	        };
	        ReactPlugin.prototype.trackPageView = function (pageView) {
	            if (this._analyticsPlugin) {
	                this._analyticsPlugin.trackPageView(pageView);
	            }
	            else {
	                this.diagLog().throwInternal(LoggingSeverity.CRITICAL, _InternalMessageId.TelemetryInitializerFailed, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
	            }
	        };
	        ReactPlugin.prototype.trackEvent = function (event, customProperties) {
	            if (this._analyticsPlugin) {
	                this._analyticsPlugin.trackEvent(event, customProperties);
	            }
	            else {
	                this.diagLog().throwInternal(LoggingSeverity.CRITICAL, _InternalMessageId.TelemetryInitializerFailed, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
	            }
	        };
	        ReactPlugin.prototype.trackException = function (exception, customProperties) {
	            if (this._analyticsPlugin) {
	                this._analyticsPlugin.trackException(exception, customProperties);
	            }
	            else {
	                this.diagLog().throwInternal(LoggingSeverity.CRITICAL, _InternalMessageId.TelemetryInitializerFailed, "Analytics plugin is not available, React plugin telemetry will not be sent: ");
	            }
	        };
	        ReactPlugin.prototype.addHistoryListener = function (history) {
	            var _this = this;
	            var locationListener = function (location, action) {
	                // Timeout to ensure any changes to the DOM made by route changes get included in pageView telemetry
	                setTimeout(function () {
	                    var pageViewTelemetry = { uri: location.pathname };
	                    _this.trackPageView(pageViewTelemetry);
	                }, 500);
	            };
	            history.listen(locationListener);
	        };
	        return ReactPlugin;
	    }(BaseTelemetryPlugin));
	
	    function createCommonjsModule(fn, module) {
	    	return module = { exports: {} }, fn(module, module.exports), module.exports;
	    }
	
	    /*
	    object-assign
	    (c) Sindre Sorhus
	    @license MIT
	    */
	    /* eslint-disable no-unused-vars */
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
	    var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	    function toObject(val) {
	    	if (val === null || val === undefined) {
	    		throw new TypeError('Object.assign cannot be called with null or undefined');
	    	}
	
	    	return Object(val);
	    }
	
	    function shouldUseNative() {
	    	try {
	    		if (!Object.assign) {
	    			return false;
	    		}
	
	    		// Detect buggy property enumeration order in older V8 versions.
	
	    		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
	    		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
	    		test1[5] = 'de';
	    		if (Object.getOwnPropertyNames(test1)[0] === '5') {
	    			return false;
	    		}
	
	    		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
	    		var test2 = {};
	    		for (var i = 0; i < 10; i++) {
	    			test2['_' + String.fromCharCode(i)] = i;
	    		}
	    		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
	    			return test2[n];
	    		});
	    		if (order2.join('') !== '0123456789') {
	    			return false;
	    		}
	
	    		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
	    		var test3 = {};
	    		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
	    			test3[letter] = letter;
	    		});
	    		if (Object.keys(Object.assign({}, test3)).join('') !==
	    				'abcdefghijklmnopqrst') {
	    			return false;
	    		}
	
	    		return true;
	    	} catch (err) {
	    		// We don't expect any of the above to throw, but better to be safe.
	    		return false;
	    	}
	    }
	
	    var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	    	var from;
	    	var to = toObject(target);
	    	var symbols;
	
	    	for (var s = 1; s < arguments.length; s++) {
	    		from = Object(arguments[s]);
	
	    		for (var key in from) {
	    			if (hasOwnProperty$1.call(from, key)) {
	    				to[key] = from[key];
	    			}
	    		}
	
	    		if (getOwnPropertySymbols) {
	    			symbols = getOwnPropertySymbols(from);
	    			for (var i = 0; i < symbols.length; i++) {
	    				if (propIsEnumerable.call(from, symbols[i])) {
	    					to[symbols[i]] = from[symbols[i]];
	    				}
	    			}
	    		}
	    	}
	
	    	return to;
	    };
	
	    var react_production_min = createCommonjsModule(function (module, exports) {
	    var n=60103,p=60106;exports.Fragment=60107;exports.StrictMode=60108;exports.Profiler=60114;var q=60109,r=60110,t=60112;exports.Suspense=60113;var u=60115,v=60116;
	    if("function"===typeof Symbol&&Symbol.for){var w=Symbol.for;n=w("react.element");p=w("react.portal");exports.Fragment=w("react.fragment");exports.StrictMode=w("react.strict_mode");exports.Profiler=w("react.profiler");q=w("react.provider");r=w("react.context");t=w("react.forward_ref");exports.Suspense=w("react.suspense");u=w("react.memo");v=w("react.lazy");}var x="function"===typeof Symbol&&Symbol.iterator;
	    function y(a){if(null===a||"object"!==typeof a)return null;a=x&&a[x]||a["@@iterator"];return "function"===typeof a?a:null}function z(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
	    var A={isMounted:function(){return !1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},B={};function C(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A;}C.prototype.isReactComponent={};C.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(z(85));this.updater.enqueueSetState(this,a,b,"setState");};C.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate");};
	    function D(){}D.prototype=C.prototype;function E(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A;}var F=E.prototype=new D;F.constructor=E;objectAssign(F,C.prototype);F.isPureReactComponent=!0;var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
	    function J(a,b,c){var e,d={},k=null,h=null;if(null!=b)for(e in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)H.call(b,e)&&!I.hasOwnProperty(e)&&(d[e]=b[e]);var g=arguments.length-2;if(1===g)d.children=c;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];d.children=f;}if(a&&a.defaultProps)for(e in g=a.defaultProps,g)void 0===d[e]&&(d[e]=g[e]);return {$$typeof:n,type:a,key:k,ref:h,props:d,_owner:G.current}}
	    function K(a,b){return {$$typeof:n,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function L(a){return "object"===typeof a&&null!==a&&a.$$typeof===n}function escape(a){var b={"=":"=0",":":"=2"};return "$"+a.replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g;function N(a,b){return "object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
	    function O(a,b,c,e,d){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case n:case p:h=!0;}}if(h)return h=a,d=d(h),a=""===e?"."+N(h,0):e,Array.isArray(d)?(c="",null!=a&&(c=a.replace(M,"$&/")+"/"),O(d,b,c,"",function(a){return a})):null!=d&&(L(d)&&(d=K(d,c+(!d.key||h&&h.key===d.key?"":(""+d.key).replace(M,"$&/")+"/")+a)),b.push(d)),1;h=0;e=""===e?".":e+":";if(Array.isArray(a))for(var g=
	    0;g<a.length;g++){k=a[g];var f=e+N(k,g);h+=O(k,b,c,f,d);}else if(f=y(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=e+N(k,g++),h+=O(k,b,c,f,d);else if("object"===k)throw b=""+a,Error(z(31,"[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b));return h}function P(a,b,c){if(null==a)return a;var e=[],d=0;O(a,e,"","",function(a){return b.call(c,a,d++)});return e}
	    function Q(a){if(-1===a._status){var b=a._result;b=b();a._status=0;a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b);},function(b){0===a._status&&(a._status=2,a._result=b);});}if(1===a._status)return a._result;throw a._result;}var R={current:null};function S(){var a=R.current;if(null===a)throw Error(z(321));return a}var T={ReactCurrentDispatcher:R,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:G,IsSomeRendererActing:{current:!1},assign:objectAssign};
	    exports.Children={map:P,forEach:function(a,b,c){P(a,function(){b.apply(this,arguments);},c);},count:function(a){var b=0;P(a,function(){b++;});return b},toArray:function(a){return P(a,function(a){return a})||[]},only:function(a){if(!L(a))throw Error(z(143));return a}};exports.Component=C;exports.PureComponent=E;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T;
	    exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(z(267,a));var e=objectAssign({},a.props),d=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)H.call(b,f)&&!I.hasOwnProperty(f)&&(e[f]=void 0===b[f]&&void 0!==g?g[f]:b[f]);}var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){g=Array(f);for(var m=0;m<f;m++)g[m]=arguments[m+2];e.children=g;}return {$$typeof:n,type:a.type,
	    key:d,ref:k,props:e,_owner:h}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:r,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:q,_context:a};return a.Consumer=a};exports.createElement=J;exports.createFactory=function(a){var b=J.bind(null,a);b.type=a;return b};exports.createRef=function(){return {current:null}};exports.forwardRef=function(a){return {$$typeof:t,render:a}};exports.isValidElement=L;
	    exports.lazy=function(a){return {$$typeof:v,_payload:{_status:-1,_result:a},_init:Q}};exports.memo=function(a,b){return {$$typeof:u,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return S().useCallback(a,b)};exports.useContext=function(a,b){return S().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return S().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return S().useImperativeHandle(a,b,c)};
	    exports.useLayoutEffect=function(a,b){return S().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return S().useMemo(a,b)};exports.useReducer=function(a,b,c){return S().useReducer(a,b,c)};exports.useRef=function(a){return S().useRef(a)};exports.useState=function(a){return S().useState(a)};exports.version="17.0.2";
	    });
	    var react_production_min_1 = react_production_min.Fragment;
	    var react_production_min_2 = react_production_min.StrictMode;
	    var react_production_min_3 = react_production_min.Profiler;
	    var react_production_min_4 = react_production_min.Suspense;
	    var react_production_min_5 = react_production_min.Children;
	    var react_production_min_6 = react_production_min.Component;
	    var react_production_min_7 = react_production_min.PureComponent;
	    var react_production_min_8 = react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
	    var react_production_min_9 = react_production_min.cloneElement;
	    var react_production_min_10 = react_production_min.createContext;
	    var react_production_min_11 = react_production_min.createElement;
	    var react_production_min_12 = react_production_min.createFactory;
	    var react_production_min_13 = react_production_min.createRef;
	    var react_production_min_14 = react_production_min.forwardRef;
	    var react_production_min_15 = react_production_min.isValidElement;
	    var react_production_min_16 = react_production_min.lazy;
	    var react_production_min_17 = react_production_min.memo;
	    var react_production_min_18 = react_production_min.useCallback;
	    var react_production_min_19 = react_production_min.useContext;
	    var react_production_min_20 = react_production_min.useDebugValue;
	    var react_production_min_21 = react_production_min.useEffect;
	    var react_production_min_22 = react_production_min.useImperativeHandle;
	    var react_production_min_23 = react_production_min.useLayoutEffect;
	    var react_production_min_24 = react_production_min.useMemo;
	    var react_production_min_25 = react_production_min.useReducer;
	    var react_production_min_26 = react_production_min.useRef;
	    var react_production_min_27 = react_production_min.useState;
	    var react_production_min_28 = react_production_min.version;
	
	    var react_development = createCommonjsModule(function (module, exports) {
	
	    if (false) {
	      (function() {
	
	    var _assign = objectAssign;
	
	    // TODO: this is special because it gets imported during build.
	    var ReactVersion = '17.0.2';
	
	    // ATTENTION
	    // When adding new symbols to this file,
	    // Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
	    // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	    // nor polyfill, then a plain number is used for performance.
	    var REACT_ELEMENT_TYPE = 0xeac7;
	    var REACT_PORTAL_TYPE = 0xeaca;
	    exports.Fragment = 0xeacb;
	    exports.StrictMode = 0xeacc;
	    exports.Profiler = 0xead2;
	    var REACT_PROVIDER_TYPE = 0xeacd;
	    var REACT_CONTEXT_TYPE = 0xeace;
	    var REACT_FORWARD_REF_TYPE = 0xead0;
	    exports.Suspense = 0xead1;
	    var REACT_SUSPENSE_LIST_TYPE = 0xead8;
	    var REACT_MEMO_TYPE = 0xead3;
	    var REACT_LAZY_TYPE = 0xead4;
	    var REACT_BLOCK_TYPE = 0xead9;
	    var REACT_SERVER_BLOCK_TYPE = 0xeada;
	    var REACT_FUNDAMENTAL_TYPE = 0xead5;
	    var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
	    var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;
	
	    if (typeof Symbol === 'function' && Symbol.for) {
	      var symbolFor = Symbol.for;
	      REACT_ELEMENT_TYPE = symbolFor('react.element');
	      REACT_PORTAL_TYPE = symbolFor('react.portal');
	      exports.Fragment = symbolFor('react.fragment');
	      exports.StrictMode = symbolFor('react.strict_mode');
	      exports.Profiler = symbolFor('react.profiler');
	      REACT_PROVIDER_TYPE = symbolFor('react.provider');
	      REACT_CONTEXT_TYPE = symbolFor('react.context');
	      REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
	      exports.Suspense = symbolFor('react.suspense');
	      REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
	      REACT_MEMO_TYPE = symbolFor('react.memo');
	      REACT_LAZY_TYPE = symbolFor('react.lazy');
	      REACT_BLOCK_TYPE = symbolFor('react.block');
	      REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
	      REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
	      REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
	      REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
	    }
	
	    var MAYBE_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	    var FAUX_ITERATOR_SYMBOL = '@@iterator';
	    function getIteratorFn(maybeIterable) {
	      if (maybeIterable === null || typeof maybeIterable !== 'object') {
	        return null;
	      }
	
	      var maybeIterator = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL];
	
	      if (typeof maybeIterator === 'function') {
	        return maybeIterator;
	      }
	
	      return null;
	    }
	
	    /**
	     * Keeps track of the current dispatcher.
	     */
	    var ReactCurrentDispatcher = {
	      /**
	       * @internal
	       * @type {ReactComponent}
	       */
	      current: null
	    };
	
	    /**
	     * Keeps track of the current batch's configuration such as how long an update
	     * should suspend for if it needs to.
	     */
	    var ReactCurrentBatchConfig = {
	      transition: 0
	    };
	
	    /**
	     * Keeps track of the current owner.
	     *
	     * The current owner is the component who should own any components that are
	     * currently being constructed.
	     */
	    var ReactCurrentOwner = {
	      /**
	       * @internal
	       * @type {ReactComponent}
	       */
	      current: null
	    };
	
	    var ReactDebugCurrentFrame = {};
	    var currentExtraStackFrame = null;
	    function setExtraStackFrame(stack) {
	      {
	        currentExtraStackFrame = stack;
	      }
	    }
	
	    {
	      ReactDebugCurrentFrame.setExtraStackFrame = function (stack) {
	        {
	          currentExtraStackFrame = stack;
	        }
	      }; // Stack implementation injected by the current renderer.
	
	
	      ReactDebugCurrentFrame.getCurrentStack = null;
	
	      ReactDebugCurrentFrame.getStackAddendum = function () {
	        var stack = ''; // Add an extra top frame while an element is being validated
	
	        if (currentExtraStackFrame) {
	          stack += currentExtraStackFrame;
	        } // Delegate to the injected renderer-specific implementation
	
	
	        var impl = ReactDebugCurrentFrame.getCurrentStack;
	
	        if (impl) {
	          stack += impl() || '';
	        }
	
	        return stack;
	      };
	    }
	
	    /**
	     * Used by act() to track whether you're inside an act() scope.
	     */
	    var IsSomeRendererActing = {
	      current: false
	    };
	
	    var ReactSharedInternals = {
	      ReactCurrentDispatcher: ReactCurrentDispatcher,
	      ReactCurrentBatchConfig: ReactCurrentBatchConfig,
	      ReactCurrentOwner: ReactCurrentOwner,
	      IsSomeRendererActing: IsSomeRendererActing,
	      // Used by renderers to avoid bundling object-assign twice in UMD bundles:
	      assign: _assign
	    };
	
	    {
	      ReactSharedInternals.ReactDebugCurrentFrame = ReactDebugCurrentFrame;
	    }
	
	    // by calls to these methods by a Babel plugin.
	    //
	    // In PROD (or in packages without access to React internals),
	    // they are left as they are instead.
	
	    function warn(format) {
	      {
	        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        printWarning('warn', format, args);
	      }
	    }
	    function error(format) {
	      {
	        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	          args[_key2 - 1] = arguments[_key2];
	        }
	
	        printWarning('error', format, args);
	      }
	    }
	
	    function printWarning(level, format, args) {
	      // When changing this logic, you might want to also
	      // update consoleWithStackDev.www.js as well.
	      {
	        var ReactDebugCurrentFrame = ReactSharedInternals.ReactDebugCurrentFrame;
	        var stack = ReactDebugCurrentFrame.getStackAddendum();
	
	        if (stack !== '') {
	          format += '%s';
	          args = args.concat([stack]);
	        }
	
	        var argsWithFormat = args.map(function (item) {
	          return '' + item;
	        }); // Careful: RN currently depends on this prefix
	
	        argsWithFormat.unshift('Warning: ' + format); // We intentionally don't use spread (or .apply) directly because it
	        // breaks IE9: https://github.com/facebook/react/issues/13610
	        // eslint-disable-next-line react-internal/no-production-logging
	
	        Function.prototype.apply.call(console[level], console, argsWithFormat);
	      }
	    }
	
	    var didWarnStateUpdateForUnmountedComponent = {};
	
	    function warnNoop(publicInstance, callerName) {
	      {
	        var _constructor = publicInstance.constructor;
	        var componentName = _constructor && (_constructor.displayName || _constructor.name) || 'ReactClass';
	        var warningKey = componentName + "." + callerName;
	
	        if (didWarnStateUpdateForUnmountedComponent[warningKey]) {
	          return;
	        }
	
	        error("Can't call %s on a component that is not yet mounted. " + 'This is a no-op, but it might indicate a bug in your application. ' + 'Instead, assign to `this.state` directly or define a `state = {};` ' + 'class property with the desired state in the %s component.', callerName, componentName);
	
	        didWarnStateUpdateForUnmountedComponent[warningKey] = true;
	      }
	    }
	    /**
	     * This is the abstract API for an update queue.
	     */
	
	
	    var ReactNoopUpdateQueue = {
	      /**
	       * Checks whether or not this composite component is mounted.
	       * @param {ReactClass} publicInstance The instance we want to test.
	       * @return {boolean} True if mounted, false otherwise.
	       * @protected
	       * @final
	       */
	      isMounted: function (publicInstance) {
	        return false;
	      },
	
	      /**
	       * Forces an update. This should only be invoked when it is known with
	       * certainty that we are **not** in a DOM transaction.
	       *
	       * You may want to call this when you know that some deeper aspect of the
	       * component's state has changed but `setState` was not called.
	       *
	       * This will not invoke `shouldComponentUpdate`, but it will invoke
	       * `componentWillUpdate` and `componentDidUpdate`.
	       *
	       * @param {ReactClass} publicInstance The instance that should rerender.
	       * @param {?function} callback Called after component is updated.
	       * @param {?string} callerName name of the calling function in the public API.
	       * @internal
	       */
	      enqueueForceUpdate: function (publicInstance, callback, callerName) {
	        warnNoop(publicInstance, 'forceUpdate');
	      },
	
	      /**
	       * Replaces all of the state. Always use this or `setState` to mutate state.
	       * You should treat `this.state` as immutable.
	       *
	       * There is no guarantee that `this.state` will be immediately updated, so
	       * accessing `this.state` after calling this method may return the old value.
	       *
	       * @param {ReactClass} publicInstance The instance that should rerender.
	       * @param {object} completeState Next state.
	       * @param {?function} callback Called after component is updated.
	       * @param {?string} callerName name of the calling function in the public API.
	       * @internal
	       */
	      enqueueReplaceState: function (publicInstance, completeState, callback, callerName) {
	        warnNoop(publicInstance, 'replaceState');
	      },
	
	      /**
	       * Sets a subset of the state. This only exists because _pendingState is
	       * internal. This provides a merging strategy that is not available to deep
	       * properties which is confusing. TODO: Expose pendingState or don't use it
	       * during the merge.
	       *
	       * @param {ReactClass} publicInstance The instance that should rerender.
	       * @param {object} partialState Next partial state to be merged with state.
	       * @param {?function} callback Called after component is updated.
	       * @param {?string} Name of the calling function in the public API.
	       * @internal
	       */
	      enqueueSetState: function (publicInstance, partialState, callback, callerName) {
	        warnNoop(publicInstance, 'setState');
	      }
	    };
	
	    var emptyObject = {};
	
	    {
	      (function(obj) { /* ai_es3_polyfil freeze */ var func = Object["freeze"]; if (func) { return func(obj); } return obj; })(emptyObject);
	    }
	    /**
	     * Base class helpers for the updating state of a component.
	     */
	
	
	    function Component(props, context, updater) {
	      this.props = props;
	      this.context = context; // If a component has string refs, we will assign a different object later.
	
	      this.refs = emptyObject; // We initialize the default updater but the real one gets injected by the
	      // renderer.
	
	      this.updater = updater || ReactNoopUpdateQueue;
	    }
	
	    Component.prototype.isReactComponent = {};
	    /**
	     * Sets a subset of the state. Always use this to mutate
	     * state. You should treat `this.state` as immutable.
	     *
	     * There is no guarantee that `this.state` will be immediately updated, so
	     * accessing `this.state` after calling this method may return the old value.
	     *
	     * There is no guarantee that calls to `setState` will run synchronously,
	     * as they may eventually be batched together.  You can provide an optional
	     * callback that will be executed when the call to setState is actually
	     * completed.
	     *
	     * When a function is provided to setState, it will be called at some point in
	     * the future (not synchronously). It will be called with the up to date
	     * component arguments (state, props, context). These values can be different
	     * from this.* because your function may be called after receiveProps but before
	     * shouldComponentUpdate, and this new state, props, and context will not yet be
	     * assigned to this.
	     *
	     * @param {object|function} partialState Next partial state or function to
	     *        produce next partial state to be merged with current state.
	     * @param {?function} callback Called after state is updated.
	     * @final
	     * @protected
	     */
	
	    Component.prototype.setState = function (partialState, callback) {
	      if (!(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null)) {
	        {
	          throw Error( "setState(...): takes an object of state variables to update or a function which returns an object of state variables." );
	        }
	      }
	
	      this.updater.enqueueSetState(this, partialState, callback, 'setState');
	    };
	    /**
	     * Forces an update. This should only be invoked when it is known with
	     * certainty that we are **not** in a DOM transaction.
	     *
	     * You may want to call this when you know that some deeper aspect of the
	     * component's state has changed but `setState` was not called.
	     *
	     * This will not invoke `shouldComponentUpdate`, but it will invoke
	     * `componentWillUpdate` and `componentDidUpdate`.
	     *
	     * @param {?function} callback Called after update is complete.
	     * @final
	     * @protected
	     */
	
	
	    Component.prototype.forceUpdate = function (callback) {
	      this.updater.enqueueForceUpdate(this, callback, 'forceUpdate');
	    };
	    /**
	     * Deprecated APIs. These APIs used to exist on classic React classes but since
	     * we would like to deprecate them, we're not going to move them over to this
	     * modern base class. Instead, we define a getter that warns if it's accessed.
	     */
	
	
	    {
	      var deprecatedAPIs = {
	        isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	        replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	      };
	
	      var defineDeprecationWarning = function (methodName, info) {
	        (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(Component.prototype, methodName, {
	          get: function () {
	            warn('%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	
	            return undefined;
	          }
	        });
	      };
	
	      for (var fnName in deprecatedAPIs) {
	        if (deprecatedAPIs.hasOwnProperty(fnName)) {
	          defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	        }
	      }
	    }
	
	    function ComponentDummy() {}
	
	    ComponentDummy.prototype = Component.prototype;
	    /**
	     * Convenience component with default shallow equality check for sCU.
	     */
	
	    function PureComponent(props, context, updater) {
	      this.props = props;
	      this.context = context; // If a component has string refs, we will assign a different object later.
	
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	    }
	
	    var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
	    pureComponentPrototype.constructor = PureComponent; // Avoid an extra prototype jump for these methods.
	
	    _assign(pureComponentPrototype, Component.prototype);
	
	    pureComponentPrototype.isPureReactComponent = true;
	
	    // an immutable object with a single mutable value
	    function createRef() {
	      var refObject = {
	        current: null
	      };
	
	      {
	        (function(obj) { /* ai_es3_polyfil seal */ var func = Object["seal"]; if (func) { return func(obj); } return obj; })(refObject);
	      }
	
	      return refObject;
	    }
	
	    function getWrappedName(outerType, innerType, wrapperName) {
	      var functionName = innerType.displayName || innerType.name || '';
	      return outerType.displayName || (functionName !== '' ? wrapperName + "(" + functionName + ")" : wrapperName);
	    }
	
	    function getContextName(type) {
	      return type.displayName || 'Context';
	    }
	
	    function getComponentName(type) {
	      if (type == null) {
	        // Host root, text node or just invalid type.
	        return null;
	      }
	
	      {
	        if (typeof type.tag === 'number') {
	          error('Received an unexpected object in getComponentName(). ' + 'This is likely a bug in React. Please file an issue.');
	        }
	      }
	
	      if (typeof type === 'function') {
	        return type.displayName || type.name || null;
	      }
	
	      if (typeof type === 'string') {
	        return type;
	      }
	
	      switch (type) {
	        case exports.Fragment:
	          return 'Fragment';
	
	        case REACT_PORTAL_TYPE:
	          return 'Portal';
	
	        case exports.Profiler:
	          return 'Profiler';
	
	        case exports.StrictMode:
	          return 'StrictMode';
	
	        case exports.Suspense:
	          return 'Suspense';
	
	        case REACT_SUSPENSE_LIST_TYPE:
	          return 'SuspenseList';
	      }
	
	      if (typeof type === 'object') {
	        switch (type.$$typeof) {
	          case REACT_CONTEXT_TYPE:
	            var context = type;
	            return getContextName(context) + '.Consumer';
	
	          case REACT_PROVIDER_TYPE:
	            var provider = type;
	            return getContextName(provider._context) + '.Provider';
	
	          case REACT_FORWARD_REF_TYPE:
	            return getWrappedName(type, type.render, 'ForwardRef');
	
	          case REACT_MEMO_TYPE:
	            return getComponentName(type.type);
	
	          case REACT_BLOCK_TYPE:
	            return getComponentName(type._render);
	
	          case REACT_LAZY_TYPE:
	            {
	              var lazyComponent = type;
	              var payload = lazyComponent._payload;
	              var init = lazyComponent._init;
	
	              try {
	                return getComponentName(init(payload));
	              } catch (x) {
	                return null;
	              }
	            }
	        }
	      }
	
	      return null;
	    }
	
	    var hasOwnProperty = Object.prototype.hasOwnProperty;
	    var RESERVED_PROPS = {
	      key: true,
	      ref: true,
	      __self: true,
	      __source: true
	    };
	    var specialPropKeyWarningShown, specialPropRefWarningShown, didWarnAboutStringRefs;
	
	    {
	      didWarnAboutStringRefs = {};
	    }
	
	    function hasValidRef(config) {
	      {
	        if (hasOwnProperty.call(config, 'ref')) {
	          var getter = (function(obj, prop) { /* ai_es3_polyfil getOwnPropertyDescriptor */var func = Object["getOwnPropertyDescriptor"]; if (func) { return func(obj, prop); } return undefined; })(config, 'ref').get;
	
	          if (getter && getter.isReactWarning) {
	            return false;
	          }
	        }
	      }
	
	      return config.ref !== undefined;
	    }
	
	    function hasValidKey(config) {
	      {
	        if (hasOwnProperty.call(config, 'key')) {
	          var getter = (function(obj, prop) { /* ai_es3_polyfil getOwnPropertyDescriptor */var func = Object["getOwnPropertyDescriptor"]; if (func) { return func(obj, prop); } return undefined; })(config, 'key').get;
	
	          if (getter && getter.isReactWarning) {
	            return false;
	          }
	        }
	      }
	
	      return config.key !== undefined;
	    }
	
	    function defineKeyPropWarningGetter(props, displayName) {
	      var warnAboutAccessingKey = function () {
	        {
	          if (!specialPropKeyWarningShown) {
	            specialPropKeyWarningShown = true;
	
	            error('%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	          }
	        }
	      };
	
	      warnAboutAccessingKey.isReactWarning = true;
	      (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(props, 'key', {
	        get: warnAboutAccessingKey,
	        configurable: true
	      });
	    }
	
	    function defineRefPropWarningGetter(props, displayName) {
	      var warnAboutAccessingRef = function () {
	        {
	          if (!specialPropRefWarningShown) {
	            specialPropRefWarningShown = true;
	
	            error('%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://reactjs.org/link/special-props)', displayName);
	          }
	        }
	      };
	
	      warnAboutAccessingRef.isReactWarning = true;
	      (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(props, 'ref', {
	        get: warnAboutAccessingRef,
	        configurable: true
	      });
	    }
	
	    function warnIfStringRefCannotBeAutoConverted(config) {
	      {
	        if (typeof config.ref === 'string' && ReactCurrentOwner.current && config.__self && ReactCurrentOwner.current.stateNode !== config.__self) {
	          var componentName = getComponentName(ReactCurrentOwner.current.type);
	
	          if (!didWarnAboutStringRefs[componentName]) {
	            error('Component "%s" contains the string ref "%s". ' + 'Support for string refs will be removed in a future major release. ' + 'This case cannot be automatically converted to an arrow function. ' + 'We ask you to manually fix this case by using useRef() or createRef() instead. ' + 'Learn more about using refs safely here: ' + 'https://reactjs.org/link/strict-mode-string-ref', componentName, config.ref);
	
	            didWarnAboutStringRefs[componentName] = true;
	          }
	        }
	      }
	    }
	    /**
	     * Factory method to create a new React element. This no longer adheres to
	     * the class pattern, so do not use new to call it. Also, instanceof check
	     * will not work. Instead test $$typeof field against Symbol.for('react.element') to check
	     * if something is a React Element.
	     *
	     * @param {*} type
	     * @param {*} props
	     * @param {*} key
	     * @param {string|object} ref
	     * @param {*} owner
	     * @param {*} self A *temporary* helper to detect places where `this` is
	     * different from the `owner` when React.createElement is called, so that we
	     * can warn. We want to get rid of owner and replace string `ref`s with arrow
	     * functions, and as long as `this` and owner are the same, there will be no
	     * change in behavior.
	     * @param {*} source An annotation object (added by a transpiler or otherwise)
	     * indicating filename, line number, and/or other information.
	     * @internal
	     */
	
	
	    var ReactElement = function (type, key, ref, self, source, owner, props) {
	      var element = {
	        // This tag allows us to uniquely identify this as a React Element
	        $$typeof: REACT_ELEMENT_TYPE,
	        // Built-in properties that belong on the element
	        type: type,
	        key: key,
	        ref: ref,
	        props: props,
	        // Record the component responsible for creating this element.
	        _owner: owner
	      };
	
	      {
	        // The validation flag is currently mutative. We put it on
	        // an external backing store so that we can freeze the whole object.
	        // This can be replaced with a WeakMap once they are implemented in
	        // commonly used development environments.
	        element._store = {}; // To make comparing ReactElements easier for testing purposes, we make
	        // the validation flag non-enumerable (where possible, which should
	        // include every environment we run tests in), so the test framework
	        // ignores it.
	
	        (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(element._store, 'validated', {
	          configurable: false,
	          enumerable: false,
	          writable: true,
	          value: false
	        }); // self and source are DEV only properties.
	
	        (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(element, '_self', {
	          configurable: false,
	          enumerable: false,
	          writable: false,
	          value: self
	        }); // Two elements created in two different places should be considered
	        // equal for testing purposes and therefore we hide it from enumeration.
	
	        (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(element, '_source', {
	          configurable: false,
	          enumerable: false,
	          writable: false,
	          value: source
	        });
	
	        if (Object.freeze) {
	          (function(obj) { /* ai_es3_polyfil freeze */ var func = Object["freeze"]; if (func) { return func(obj); } return obj; })(element.props);
	          (function(obj) { /* ai_es3_polyfil freeze */ var func = Object["freeze"]; if (func) { return func(obj); } return obj; })(element);
	        }
	      }
	
	      return element;
	    };
	    /**
	     * Create and return a new ReactElement of the given type.
	     * See https://reactjs.org/docs/react-api.html#createelement
	     */
	
	    function createElement(type, config, children) {
	      var propName; // Reserved names are extracted
	
	      var props = {};
	      var key = null;
	      var ref = null;
	      var self = null;
	      var source = null;
	
	      if (config != null) {
	        if (hasValidRef(config)) {
	          ref = config.ref;
	
	          {
	            warnIfStringRefCannotBeAutoConverted(config);
	          }
	        }
	
	        if (hasValidKey(config)) {
	          key = '' + config.key;
	        }
	
	        self = config.__self === undefined ? null : config.__self;
	        source = config.__source === undefined ? null : config.__source; // Remaining properties are added to a new props object
	
	        for (propName in config) {
	          if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	            props[propName] = config[propName];
	          }
	        }
	      } // Children can be more than one argument, and those are transferred onto
	      // the newly allocated props object.
	
	
	      var childrenLength = arguments.length - 2;
	
	      if (childrenLength === 1) {
	        props.children = children;
	      } else if (childrenLength > 1) {
	        var childArray = Array(childrenLength);
	
	        for (var i = 0; i < childrenLength; i++) {
	          childArray[i] = arguments[i + 2];
	        }
	
	        {
	          if (Object.freeze) {
	            (function(obj) { /* ai_es3_polyfil freeze */ var func = Object["freeze"]; if (func) { return func(obj); } return obj; })(childArray);
	          }
	        }
	
	        props.children = childArray;
	      } // Resolve default props
	
	
	      if (type && type.defaultProps) {
	        var defaultProps = type.defaultProps;
	
	        for (propName in defaultProps) {
	          if (props[propName] === undefined) {
	            props[propName] = defaultProps[propName];
	          }
	        }
	      }
	
	      {
	        if (key || ref) {
	          var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	
	          if (key) {
	            defineKeyPropWarningGetter(props, displayName);
	          }
	
	          if (ref) {
	            defineRefPropWarningGetter(props, displayName);
	          }
	        }
	      }
	
	      return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	    }
	    function cloneAndReplaceKey(oldElement, newKey) {
	      var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	      return newElement;
	    }
	    /**
	     * Clone and return a new ReactElement using element as the starting point.
	     * See https://reactjs.org/docs/react-api.html#cloneelement
	     */
	
	    function cloneElement(element, config, children) {
	      if (!!(element === null || element === undefined)) {
	        {
	          throw Error( "React.cloneElement(...): The argument must be a React element, but you passed " + element + "." );
	        }
	      }
	
	      var propName; // Original props are copied
	
	      var props = _assign({}, element.props); // Reserved names are extracted
	
	
	      var key = element.key;
	      var ref = element.ref; // Self is preserved since the owner is preserved.
	
	      var self = element._self; // Source is preserved since cloneElement is unlikely to be targeted by a
	      // transpiler, and the original source is probably a better indicator of the
	      // true owner.
	
	      var source = element._source; // Owner will be preserved, unless ref is overridden
	
	      var owner = element._owner;
	
	      if (config != null) {
	        if (hasValidRef(config)) {
	          // Silently steal the ref from the parent.
	          ref = config.ref;
	          owner = ReactCurrentOwner.current;
	        }
	
	        if (hasValidKey(config)) {
	          key = '' + config.key;
	        } // Remaining properties override existing props
	
	
	        var defaultProps;
	
	        if (element.type && element.type.defaultProps) {
	          defaultProps = element.type.defaultProps;
	        }
	
	        for (propName in config) {
	          if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	            if (config[propName] === undefined && defaultProps !== undefined) {
	              // Resolve default props
	              props[propName] = defaultProps[propName];
	            } else {
	              props[propName] = config[propName];
	            }
	          }
	        }
	      } // Children can be more than one argument, and those are transferred onto
	      // the newly allocated props object.
	
	
	      var childrenLength = arguments.length - 2;
	
	      if (childrenLength === 1) {
	        props.children = children;
	      } else if (childrenLength > 1) {
	        var childArray = Array(childrenLength);
	
	        for (var i = 0; i < childrenLength; i++) {
	          childArray[i] = arguments[i + 2];
	        }
	
	        props.children = childArray;
	      }
	
	      return ReactElement(element.type, key, ref, self, source, owner, props);
	    }
	    /**
	     * Verifies the object is a ReactElement.
	     * See https://reactjs.org/docs/react-api.html#isvalidelement
	     * @param {?object} object
	     * @return {boolean} True if `object` is a ReactElement.
	     * @final
	     */
	
	    function isValidElement(object) {
	      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	    }
	
	    var SEPARATOR = '.';
	    var SUBSEPARATOR = ':';
	    /**
	     * Escape and wrap key so it is safe to use as a reactid
	     *
	     * @param {string} key to be escaped.
	     * @return {string} the escaped key.
	     */
	
	    function escape(key) {
	      var escapeRegex = /[=:]/g;
	      var escaperLookup = {
	        '=': '=0',
	        ':': '=2'
	      };
	      var escapedString = key.replace(escapeRegex, function (match) {
	        return escaperLookup[match];
	      });
	      return '$' + escapedString;
	    }
	    /**
	     * TODO: Test that a single child and an array with one item have the same key
	     * pattern.
	     */
	
	
	    var didWarnAboutMaps = false;
	    var userProvidedKeyEscapeRegex = /\/+/g;
	
	    function escapeUserProvidedKey(text) {
	      return text.replace(userProvidedKeyEscapeRegex, '$&/');
	    }
	    /**
	     * Generate a key string that identifies a element within a set.
	     *
	     * @param {*} element A element that could contain a manual key.
	     * @param {number} index Index that is used if a manual key is not provided.
	     * @return {string}
	     */
	
	
	    function getElementKey(element, index) {
	      // Do some typechecking here since we call this blindly. We want to ensure
	      // that we don't block potential future ES APIs.
	      if (typeof element === 'object' && element !== null && element.key != null) {
	        // Explicit key
	        return escape('' + element.key);
	      } // Implicit key determined by the index in the set
	
	
	      return index.toString(36);
	    }
	
	    function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
	      var type = typeof children;
	
	      if (type === 'undefined' || type === 'boolean') {
	        // All of the above are perceived as null.
	        children = null;
	      }
	
	      var invokeCallback = false;
	
	      if (children === null) {
	        invokeCallback = true;
	      } else {
	        switch (type) {
	          case 'string':
	          case 'number':
	            invokeCallback = true;
	            break;
	
	          case 'object':
	            switch (children.$$typeof) {
	              case REACT_ELEMENT_TYPE:
	              case REACT_PORTAL_TYPE:
	                invokeCallback = true;
	            }
	
	        }
	      }
	
	      if (invokeCallback) {
	        var _child = children;
	        var mappedChild = callback(_child); // If it's the only child, treat the name as if it was wrapped in an array
	        // so that it's consistent if the number of children grows:
	
	        var childKey = nameSoFar === '' ? SEPARATOR + getElementKey(_child, 0) : nameSoFar;
	
	        if (Array.isArray(mappedChild)) {
	          var escapedChildKey = '';
	
	          if (childKey != null) {
	            escapedChildKey = escapeUserProvidedKey(childKey) + '/';
	          }
	
	          mapIntoArray(mappedChild, array, escapedChildKey, '', function (c) {
	            return c;
	          });
	        } else if (mappedChild != null) {
	          if (isValidElement(mappedChild)) {
	            mappedChild = cloneAndReplaceKey(mappedChild, // Keep both the (mapped) and old keys if they differ, just as
	            // traverseAllChildren used to do for objects as children
	            escapedPrefix + ( // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
	            mappedChild.key && (!_child || _child.key !== mappedChild.key) ? // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
	            escapeUserProvidedKey('' + mappedChild.key) + '/' : '') + childKey);
	          }
	
	          array.push(mappedChild);
	        }
	
	        return 1;
	      }
	
	      var child;
	      var nextName;
	      var subtreeCount = 0; // Count of children found in the current subtree.
	
	      var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	      if (Array.isArray(children)) {
	        for (var i = 0; i < children.length; i++) {
	          child = children[i];
	          nextName = nextNamePrefix + getElementKey(child, i);
	          subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
	        }
	      } else {
	        var iteratorFn = getIteratorFn(children);
	
	        if (typeof iteratorFn === 'function') {
	          var iterableChildren = children;
	
	          {
	            // Warn about using Maps as children
	            if (iteratorFn === iterableChildren.entries) {
	              if (!didWarnAboutMaps) {
	                warn('Using Maps as children is not supported. ' + 'Use an array of keyed ReactElements instead.');
	              }
	
	              didWarnAboutMaps = true;
	            }
	          }
	
	          var iterator = iteratorFn.call(iterableChildren);
	          var step;
	          var ii = 0;
	
	          while (!(step = iterator.next()).done) {
	            child = step.value;
	            nextName = nextNamePrefix + getElementKey(child, ii++);
	            subtreeCount += mapIntoArray(child, array, escapedPrefix, nextName, callback);
	          }
	        } else if (type === 'object') {
	          var childrenString = '' + children;
	
	          {
	            {
	              throw Error( "Objects are not valid as a React child (found: " + (childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString) + "). If you meant to render a collection of children, use an array instead." );
	            }
	          }
	        }
	      }
	
	      return subtreeCount;
	    }
	
	    /**
	     * Maps children that are typically specified as `props.children`.
	     *
	     * See https://reactjs.org/docs/react-api.html#reactchildrenmap
	     *
	     * The provided mapFunction(child, index) will be called for each
	     * leaf child.
	     *
	     * @param {?*} children Children tree container.
	     * @param {function(*, int)} func The map function.
	     * @param {*} context Context for mapFunction.
	     * @return {object} Object containing the ordered map of results.
	     */
	    function mapChildren(children, func, context) {
	      if (children == null) {
	        return children;
	      }
	
	      var result = [];
	      var count = 0;
	      mapIntoArray(children, result, '', '', function (child) {
	        return func.call(context, child, count++);
	      });
	      return result;
	    }
	    /**
	     * Count the number of children that are typically specified as
	     * `props.children`.
	     *
	     * See https://reactjs.org/docs/react-api.html#reactchildrencount
	     *
	     * @param {?*} children Children tree container.
	     * @return {number} The number of children.
	     */
	
	
	    function countChildren(children) {
	      var n = 0;
	      mapChildren(children, function () {
	        n++; // Don't return anything
	      });
	      return n;
	    }
	
	    /**
	     * Iterates through children that are typically specified as `props.children`.
	     *
	     * See https://reactjs.org/docs/react-api.html#reactchildrenforeach
	     *
	     * The provided forEachFunc(child, index) will be called for each
	     * leaf child.
	     *
	     * @param {?*} children Children tree container.
	     * @param {function(*, int)} forEachFunc
	     * @param {*} forEachContext Context for forEachContext.
	     */
	    function forEachChildren(children, forEachFunc, forEachContext) {
	      mapChildren(children, function () {
	        forEachFunc.apply(this, arguments); // Don't return anything.
	      }, forEachContext);
	    }
	    /**
	     * Flatten a children object (typically specified as `props.children`) and
	     * return an array with appropriately re-keyed children.
	     *
	     * See https://reactjs.org/docs/react-api.html#reactchildrentoarray
	     */
	
	
	    function toArray(children) {
	      return mapChildren(children, function (child) {
	        return child;
	      }) || [];
	    }
	    /**
	     * Returns the first child in a collection of children and verifies that there
	     * is only one child in the collection.
	     *
	     * See https://reactjs.org/docs/react-api.html#reactchildrenonly
	     *
	     * The current implementation of this function assumes that a single child gets
	     * passed without a wrapper, but the purpose of this helper function is to
	     * abstract away the particular structure of children.
	     *
	     * @param {?object} children Child collection structure.
	     * @return {ReactElement} The first and only `ReactElement` contained in the
	     * structure.
	     */
	
	
	    function onlyChild(children) {
	      if (!isValidElement(children)) {
	        {
	          throw Error( "React.Children.only expected to receive a single React element child." );
	        }
	      }
	
	      return children;
	    }
	
	    function createContext(defaultValue, calculateChangedBits) {
	      if (calculateChangedBits === undefined) {
	        calculateChangedBits = null;
	      } else {
	        {
	          if (calculateChangedBits !== null && typeof calculateChangedBits !== 'function') {
	            error('createContext: Expected the optional second argument to be a ' + 'function. Instead received: %s', calculateChangedBits);
	          }
	        }
	      }
	
	      var context = {
	        $$typeof: REACT_CONTEXT_TYPE,
	        _calculateChangedBits: calculateChangedBits,
	        // As a workaround to support multiple concurrent renderers, we categorize
	        // some renderers as primary and others as secondary. We only expect
	        // there to be two concurrent renderers at most: React Native (primary) and
	        // Fabric (secondary); React DOM (primary) and React ART (secondary).
	        // Secondary renderers store their context values on separate fields.
	        _currentValue: defaultValue,
	        _currentValue2: defaultValue,
	        // Used to track how many concurrent renderers this context currently
	        // supports within in a single renderer. Such as parallel server rendering.
	        _threadCount: 0,
	        // These are circular
	        Provider: null,
	        Consumer: null
	      };
	      context.Provider = {
	        $$typeof: REACT_PROVIDER_TYPE,
	        _context: context
	      };
	      var hasWarnedAboutUsingNestedContextConsumers = false;
	      var hasWarnedAboutUsingConsumerProvider = false;
	      var hasWarnedAboutDisplayNameOnConsumer = false;
	
	      {
	        // A separate object, but proxies back to the original context object for
	        // backwards compatibility. It has a different $$typeof, so we can properly
	        // warn for the incorrect usage of Context as a Consumer.
	        var Consumer = {
	          $$typeof: REACT_CONTEXT_TYPE,
	          _context: context,
	          _calculateChangedBits: context._calculateChangedBits
	        }; // $FlowFixMe: Flow complains about not setting a value, which is intentional here
	
	        Object.defineProperties(Consumer, {
	          Provider: {
	            get: function () {
	              if (!hasWarnedAboutUsingConsumerProvider) {
	                hasWarnedAboutUsingConsumerProvider = true;
	
	                error('Rendering <Context.Consumer.Provider> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Provider> instead?');
	              }
	
	              return context.Provider;
	            },
	            set: function (_Provider) {
	              context.Provider = _Provider;
	            }
	          },
	          _currentValue: {
	            get: function () {
	              return context._currentValue;
	            },
	            set: function (_currentValue) {
	              context._currentValue = _currentValue;
	            }
	          },
	          _currentValue2: {
	            get: function () {
	              return context._currentValue2;
	            },
	            set: function (_currentValue2) {
	              context._currentValue2 = _currentValue2;
	            }
	          },
	          _threadCount: {
	            get: function () {
	              return context._threadCount;
	            },
	            set: function (_threadCount) {
	              context._threadCount = _threadCount;
	            }
	          },
	          Consumer: {
	            get: function () {
	              if (!hasWarnedAboutUsingNestedContextConsumers) {
	                hasWarnedAboutUsingNestedContextConsumers = true;
	
	                error('Rendering <Context.Consumer.Consumer> is not supported and will be removed in ' + 'a future major release. Did you mean to render <Context.Consumer> instead?');
	              }
	
	              return context.Consumer;
	            }
	          },
	          displayName: {
	            get: function () {
	              return context.displayName;
	            },
	            set: function (displayName) {
	              if (!hasWarnedAboutDisplayNameOnConsumer) {
	                warn('Setting `displayName` on Context.Consumer has no effect. ' + "You should set it directly on the context with Context.displayName = '%s'.", displayName);
	
	                hasWarnedAboutDisplayNameOnConsumer = true;
	              }
	            }
	          }
	        }); // $FlowFixMe: Flow complains about missing properties because it doesn't understand defineProperty
	
	        context.Consumer = Consumer;
	      }
	
	      {
	        context._currentRenderer = null;
	        context._currentRenderer2 = null;
	      }
	
	      return context;
	    }
	
	    var Uninitialized = -1;
	    var Pending = 0;
	    var Resolved = 1;
	    var Rejected = 2;
	
	    function lazyInitializer(payload) {
	      if (payload._status === Uninitialized) {
	        var ctor = payload._result;
	        var thenable = ctor(); // Transition to the next state.
	
	        var pending = payload;
	        pending._status = Pending;
	        pending._result = thenable;
	        thenable.then(function (moduleObject) {
	          if (payload._status === Pending) {
	            var defaultExport = moduleObject.default;
	
	            {
	              if (defaultExport === undefined) {
	                error('lazy: Expected the result of a dynamic import() call. ' + 'Instead received: %s\n\nYour code should look like: \n  ' + // Break up imports to avoid accidentally parsing them as dependencies.
	                'const MyComponent = lazy(() => imp' + "ort('./MyComponent'))", moduleObject);
	              }
	            } // Transition to the next state.
	
	
	            var resolved = payload;
	            resolved._status = Resolved;
	            resolved._result = defaultExport;
	          }
	        }, function (error) {
	          if (payload._status === Pending) {
	            // Transition to the next state.
	            var rejected = payload;
	            rejected._status = Rejected;
	            rejected._result = error;
	          }
	        });
	      }
	
	      if (payload._status === Resolved) {
	        return payload._result;
	      } else {
	        throw payload._result;
	      }
	    }
	
	    function lazy(ctor) {
	      var payload = {
	        // We use these fields to store the result.
	        _status: -1,
	        _result: ctor
	      };
	      var lazyType = {
	        $$typeof: REACT_LAZY_TYPE,
	        _payload: payload,
	        _init: lazyInitializer
	      };
	
	      {
	        // In production, this would just set it on the object.
	        var defaultProps;
	        var propTypes; // $FlowFixMe
	
	        Object.defineProperties(lazyType, {
	          defaultProps: {
	            configurable: true,
	            get: function () {
	              return defaultProps;
	            },
	            set: function (newDefaultProps) {
	              error('React.lazy(...): It is not supported to assign `defaultProps` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');
	
	              defaultProps = newDefaultProps; // Match production behavior more closely:
	              // $FlowFixMe
	
	              (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(lazyType, 'defaultProps', {
	                enumerable: true
	              });
	            }
	          },
	          propTypes: {
	            configurable: true,
	            get: function () {
	              return propTypes;
	            },
	            set: function (newPropTypes) {
	              error('React.lazy(...): It is not supported to assign `propTypes` to ' + 'a lazy component import. Either specify them where the component ' + 'is defined, or create a wrapping component around it.');
	
	              propTypes = newPropTypes; // Match production behavior more closely:
	              // $FlowFixMe
	
	              (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(lazyType, 'propTypes', {
	                enumerable: true
	              });
	            }
	          }
	        });
	      }
	
	      return lazyType;
	    }
	
	    function forwardRef(render) {
	      {
	        if (render != null && render.$$typeof === REACT_MEMO_TYPE) {
	          error('forwardRef requires a render function but received a `memo` ' + 'component. Instead of forwardRef(memo(...)), use ' + 'memo(forwardRef(...)).');
	        } else if (typeof render !== 'function') {
	          error('forwardRef requires a render function but was given %s.', render === null ? 'null' : typeof render);
	        } else {
	          if (render.length !== 0 && render.length !== 2) {
	            error('forwardRef render functions accept exactly two parameters: props and ref. %s', render.length === 1 ? 'Did you forget to use the ref parameter?' : 'Any additional parameter will be undefined.');
	          }
	        }
	
	        if (render != null) {
	          if (render.defaultProps != null || render.propTypes != null) {
	            error('forwardRef render functions do not support propTypes or defaultProps. ' + 'Did you accidentally pass a React component?');
	          }
	        }
	      }
	
	      var elementType = {
	        $$typeof: REACT_FORWARD_REF_TYPE,
	        render: render
	      };
	
	      {
	        var ownName;
	        (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(elementType, 'displayName', {
	          enumerable: false,
	          configurable: true,
	          get: function () {
	            return ownName;
	          },
	          set: function (name) {
	            ownName = name;
	
	            if (render.displayName == null) {
	              render.displayName = name;
	            }
	          }
	        });
	      }
	
	      return elementType;
	    }
	
	    // Filter certain DOM attributes (e.g. src, href) if their values are empty strings.
	
	    var enableScopeAPI = false; // Experimental Create Event Handle API.
	
	    function isValidElementType(type) {
	      if (typeof type === 'string' || typeof type === 'function') {
	        return true;
	      } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).
	
	
	      if (type === exports.Fragment || type === exports.Profiler || type === REACT_DEBUG_TRACING_MODE_TYPE || type === exports.StrictMode || type === exports.Suspense || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
	        return true;
	      }
	
	      if (typeof type === 'object' && type !== null) {
	        if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
	          return true;
	        }
	      }
	
	      return false;
	    }
	
	    function memo(type, compare) {
	      {
	        if (!isValidElementType(type)) {
	          error('memo: The first argument must be a component. Instead ' + 'received: %s', type === null ? 'null' : typeof type);
	        }
	      }
	
	      var elementType = {
	        $$typeof: REACT_MEMO_TYPE,
	        type: type,
	        compare: compare === undefined ? null : compare
	      };
	
	      {
	        var ownName;
	        (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(elementType, 'displayName', {
	          enumerable: false,
	          configurable: true,
	          get: function () {
	            return ownName;
	          },
	          set: function (name) {
	            ownName = name;
	
	            if (type.displayName == null) {
	              type.displayName = name;
	            }
	          }
	        });
	      }
	
	      return elementType;
	    }
	
	    function resolveDispatcher() {
	      var dispatcher = ReactCurrentDispatcher.current;
	
	      if (!(dispatcher !== null)) {
	        {
	          throw Error( "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem." );
	        }
	      }
	
	      return dispatcher;
	    }
	
	    function useContext(Context, unstable_observedBits) {
	      var dispatcher = resolveDispatcher();
	
	      {
	        if (unstable_observedBits !== undefined) {
	          error('useContext() second argument is reserved for future ' + 'use in React. Passing it is not supported. ' + 'You passed: %s.%s', unstable_observedBits, typeof unstable_observedBits === 'number' && Array.isArray(arguments[2]) ? '\n\nDid you call array.map(useContext)? ' + 'Calling Hooks inside a loop is not supported. ' + 'Learn more at https://reactjs.org/link/rules-of-hooks' : '');
	        } // TODO: add a more generic warning for invalid values.
	
	
	        if (Context._context !== undefined) {
	          var realContext = Context._context; // Don't deduplicate because this legitimately causes bugs
	          // and nobody should be using this in existing code.
	
	          if (realContext.Consumer === Context) {
	            error('Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be ' + 'removed in a future major release. Did you mean to call useContext(Context) instead?');
	          } else if (realContext.Provider === Context) {
	            error('Calling useContext(Context.Provider) is not supported. ' + 'Did you mean to call useContext(Context) instead?');
	          }
	        }
	      }
	
	      return dispatcher.useContext(Context, unstable_observedBits);
	    }
	    function useState(initialState) {
	      var dispatcher = resolveDispatcher();
	      return dispatcher.useState(initialState);
	    }
	    function useReducer(reducer, initialArg, init) {
	      var dispatcher = resolveDispatcher();
	      return dispatcher.useReducer(reducer, initialArg, init);
	    }
	    function useRef(initialValue) {
	      var dispatcher = resolveDispatcher();
	      return dispatcher.useRef(initialValue);
	    }
	    function useEffect(create, deps) {
	      var dispatcher = resolveDispatcher();
	      return dispatcher.useEffect(create, deps);
	    }
	    function useLayoutEffect(create, deps) {
	      var dispatcher = resolveDispatcher();
	      return dispatcher.useLayoutEffect(create, deps);
	    }
	    function useCallback(callback, deps) {
	      var dispatcher = resolveDispatcher();
	      return dispatcher.useCallback(callback, deps);
	    }
	    function useMemo(create, deps) {
	      var dispatcher = resolveDispatcher();
	      return dispatcher.useMemo(create, deps);
	    }
	    function useImperativeHandle(ref, create, deps) {
	      var dispatcher = resolveDispatcher();
	      return dispatcher.useImperativeHandle(ref, create, deps);
	    }
	    function useDebugValue(value, formatterFn) {
	      {
	        var dispatcher = resolveDispatcher();
	        return dispatcher.useDebugValue(value, formatterFn);
	      }
	    }
	
	    // Helpers to patch console.logs to avoid logging during side-effect free
	    // replaying on render function. This currently only patches the object
	    // lazily which won't cover if the log function was extracted eagerly.
	    // We could also eagerly patch the method.
	    var disabledDepth = 0;
	    var prevLog;
	    var prevInfo;
	    var prevWarn;
	    var prevError;
	    var prevGroup;
	    var prevGroupCollapsed;
	    var prevGroupEnd;
	
	    function disabledLog() {}
	
	    disabledLog.__reactDisabledLog = true;
	    function disableLogs() {
	      {
	        if (disabledDepth === 0) {
	          /* eslint-disable react-internal/no-production-logging */
	          prevLog = console.log;
	          prevInfo = console.info;
	          prevWarn = console.warn;
	          prevError = console.error;
	          prevGroup = console.group;
	          prevGroupCollapsed = console.groupCollapsed;
	          prevGroupEnd = console.groupEnd; // https://github.com/facebook/react/issues/19099
	
	          var props = {
	            configurable: true,
	            enumerable: true,
	            value: disabledLog,
	            writable: true
	          }; // $FlowFixMe Flow thinks console is immutable.
	
	          Object.defineProperties(console, {
	            info: props,
	            log: props,
	            warn: props,
	            error: props,
	            group: props,
	            groupCollapsed: props,
	            groupEnd: props
	          });
	          /* eslint-enable react-internal/no-production-logging */
	        }
	
	        disabledDepth++;
	      }
	    }
	    function reenableLogs() {
	      {
	        disabledDepth--;
	
	        if (disabledDepth === 0) {
	          /* eslint-disable react-internal/no-production-logging */
	          var props = {
	            configurable: true,
	            enumerable: true,
	            writable: true
	          }; // $FlowFixMe Flow thinks console is immutable.
	
	          Object.defineProperties(console, {
	            log: _assign({}, props, {
	              value: prevLog
	            }),
	            info: _assign({}, props, {
	              value: prevInfo
	            }),
	            warn: _assign({}, props, {
	              value: prevWarn
	            }),
	            error: _assign({}, props, {
	              value: prevError
	            }),
	            group: _assign({}, props, {
	              value: prevGroup
	            }),
	            groupCollapsed: _assign({}, props, {
	              value: prevGroupCollapsed
	            }),
	            groupEnd: _assign({}, props, {
	              value: prevGroupEnd
	            })
	          });
	          /* eslint-enable react-internal/no-production-logging */
	        }
	
	        if (disabledDepth < 0) {
	          error('disabledDepth fell below zero. ' + 'This is a bug in React. Please file an issue.');
	        }
	      }
	    }
	
	    var ReactCurrentDispatcher$1 = ReactSharedInternals.ReactCurrentDispatcher;
	    var prefix;
	    function describeBuiltInComponentFrame(name, source, ownerFn) {
	      {
	        if (prefix === undefined) {
	          // Extract the VM specific prefix used by each line.
	          try {
	            throw Error();
	          } catch (x) {
	            var match = x.stack.trim().match(/\n( *(at )?)/);
	            prefix = match && match[1] || '';
	          }
	        } // We use the prefix to ensure our stacks line up with native stack frames.
	
	
	        return '\n' + prefix + name;
	      }
	    }
	    var reentry = false;
	    var componentFrameCache;
	
	    {
	      var PossiblyWeakMap = typeof WeakMap === 'function' ? WeakMap : Map;
	      componentFrameCache = new PossiblyWeakMap();
	    }
	
	    function describeNativeComponentFrame(fn, construct) {
	      // If something asked for a stack inside a fake render, it should get ignored.
	      if (!fn || reentry) {
	        return '';
	      }
	
	      {
	        var frame = componentFrameCache.get(fn);
	
	        if (frame !== undefined) {
	          return frame;
	        }
	      }
	
	      var control;
	      reentry = true;
	      var previousPrepareStackTrace = Error.prepareStackTrace; // $FlowFixMe It does accept undefined.
	
	      Error.prepareStackTrace = undefined;
	      var previousDispatcher;
	
	      {
	        previousDispatcher = ReactCurrentDispatcher$1.current; // Set the dispatcher in DEV because this might be call in the render function
	        // for warnings.
	
	        ReactCurrentDispatcher$1.current = null;
	        disableLogs();
	      }
	
	      try {
	        // This should throw.
	        if (construct) {
	          // Something should be setting the props in the constructor.
	          var Fake = function () {
	            throw Error();
	          }; // $FlowFixMe
	
	
	          (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(Fake.prototype, 'props', {
	            set: function () {
	              // We use a throwing setter instead of frozen or non-writable props
	              // because that won't throw in a non-strict mode function.
	              throw Error();
	            }
	          });
	
	          if (typeof Reflect === 'object' && Reflect.construct) {
	            // We construct a different control for this case to include any extra
	            // frames added by the construct call.
	            try {
	              Reflect.construct(Fake, []);
	            } catch (x) {
	              control = x;
	            }
	
	            Reflect.construct(fn, [], Fake);
	          } else {
	            try {
	              Fake.call();
	            } catch (x) {
	              control = x;
	            }
	
	            fn.call(Fake.prototype);
	          }
	        } else {
	          try {
	            throw Error();
	          } catch (x) {
	            control = x;
	          }
	
	          fn();
	        }
	      } catch (sample) {
	        // This is inlined manually because closure doesn't do it for us.
	        if (sample && control && typeof sample.stack === 'string') {
	          // This extracts the first frame from the sample that isn't also in the control.
	          // Skipping one frame that we assume is the frame that calls the two.
	          var sampleLines = sample.stack.split('\n');
	          var controlLines = control.stack.split('\n');
	          var s = sampleLines.length - 1;
	          var c = controlLines.length - 1;
	
	          while (s >= 1 && c >= 0 && sampleLines[s] !== controlLines[c]) {
	            // We expect at least one stack frame to be shared.
	            // Typically this will be the root most one. However, stack frames may be
	            // cut off due to maximum stack limits. In this case, one maybe cut off
	            // earlier than the other. We assume that the sample is longer or the same
	            // and there for cut off earlier. So we should find the root most frame in
	            // the sample somewhere in the control.
	            c--;
	          }
	
	          for (; s >= 1 && c >= 0; s--, c--) {
	            // Next we find the first one that isn't the same which should be the
	            // frame that called our sample function and the control.
	            if (sampleLines[s] !== controlLines[c]) {
	              // In V8, the first line is describing the message but other VMs don't.
	              // If we're about to return the first line, and the control is also on the same
	              // line, that's a pretty good indicator that our sample threw at same line as
	              // the control. I.e. before we entered the sample frame. So we ignore this result.
	              // This can happen if you passed a class to function component, or non-function.
	              if (s !== 1 || c !== 1) {
	                do {
	                  s--;
	                  c--; // We may still have similar intermediate frames from the construct call.
	                  // The next one that isn't the same should be our match though.
	
	                  if (c < 0 || sampleLines[s] !== controlLines[c]) {
	                    // V8 adds a "new" prefix for native classes. Let's remove it to make it prettier.
	                    var _frame = '\n' + sampleLines[s].replace(' at new ', ' at ');
	
	                    {
	                      if (typeof fn === 'function') {
	                        componentFrameCache.set(fn, _frame);
	                      }
	                    } // Return the line we found.
	
	
	                    return _frame;
	                  }
	                } while (s >= 1 && c >= 0);
	              }
	
	              break;
	            }
	          }
	        }
	      } finally {
	        reentry = false;
	
	        {
	          ReactCurrentDispatcher$1.current = previousDispatcher;
	          reenableLogs();
	        }
	
	        Error.prepareStackTrace = previousPrepareStackTrace;
	      } // Fallback to just using the name if we couldn't make it throw.
	
	
	      var name = fn ? fn.displayName || fn.name : '';
	      var syntheticFrame = name ? describeBuiltInComponentFrame(name) : '';
	
	      {
	        if (typeof fn === 'function') {
	          componentFrameCache.set(fn, syntheticFrame);
	        }
	      }
	
	      return syntheticFrame;
	    }
	    function describeFunctionComponentFrame(fn, source, ownerFn) {
	      {
	        return describeNativeComponentFrame(fn, false);
	      }
	    }
	
	    function shouldConstruct(Component) {
	      var prototype = Component.prototype;
	      return !!(prototype && prototype.isReactComponent);
	    }
	
	    function describeUnknownElementTypeFrameInDEV(type, source, ownerFn) {
	
	      if (type == null) {
	        return '';
	      }
	
	      if (typeof type === 'function') {
	        {
	          return describeNativeComponentFrame(type, shouldConstruct(type));
	        }
	      }
	
	      if (typeof type === 'string') {
	        return describeBuiltInComponentFrame(type);
	      }
	
	      switch (type) {
	        case exports.Suspense:
	          return describeBuiltInComponentFrame('Suspense');
	
	        case REACT_SUSPENSE_LIST_TYPE:
	          return describeBuiltInComponentFrame('SuspenseList');
	      }
	
	      if (typeof type === 'object') {
	        switch (type.$$typeof) {
	          case REACT_FORWARD_REF_TYPE:
	            return describeFunctionComponentFrame(type.render);
	
	          case REACT_MEMO_TYPE:
	            // Memo may contain any component type so we recursively resolve it.
	            return describeUnknownElementTypeFrameInDEV(type.type, source, ownerFn);
	
	          case REACT_BLOCK_TYPE:
	            return describeFunctionComponentFrame(type._render);
	
	          case REACT_LAZY_TYPE:
	            {
	              var lazyComponent = type;
	              var payload = lazyComponent._payload;
	              var init = lazyComponent._init;
	
	              try {
	                // Lazy may contain any component type so we recursively resolve it.
	                return describeUnknownElementTypeFrameInDEV(init(payload), source, ownerFn);
	              } catch (x) {}
	            }
	        }
	      }
	
	      return '';
	    }
	
	    var loggedTypeFailures = {};
	    var ReactDebugCurrentFrame$1 = ReactSharedInternals.ReactDebugCurrentFrame;
	
	    function setCurrentlyValidatingElement(element) {
	      {
	        if (element) {
	          var owner = element._owner;
	          var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	          ReactDebugCurrentFrame$1.setExtraStackFrame(stack);
	        } else {
	          ReactDebugCurrentFrame$1.setExtraStackFrame(null);
	        }
	      }
	    }
	
	    function checkPropTypes(typeSpecs, values, location, componentName, element) {
	      {
	        // $FlowFixMe This is okay but Flow doesn't know it.
	        var has = Function.call.bind(Object.prototype.hasOwnProperty);
	
	        for (var typeSpecName in typeSpecs) {
	          if (has(typeSpecs, typeSpecName)) {
	            var error$1 = void 0; // Prop type validation may throw. In case they do, we don't want to
	            // fail the render phase where it didn't fail before. So we log it.
	            // After these have been cleaned up, we'll let them throw.
	
	            try {
	              // This is intentionally an invariant that gets caught. It's the same
	              // behavior as without this statement except with a better message.
	              if (typeof typeSpecs[typeSpecName] !== 'function') {
	                var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
	                err.name = 'Invariant Violation';
	                throw err;
	              }
	
	              error$1 = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED');
	            } catch (ex) {
	              error$1 = ex;
	            }
	
	            if (error$1 && !(error$1 instanceof Error)) {
	              setCurrentlyValidatingElement(element);
	
	              error('%s: type specification of %s' + ' `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error$1);
	
	              setCurrentlyValidatingElement(null);
	            }
	
	            if (error$1 instanceof Error && !(error$1.message in loggedTypeFailures)) {
	              // Only monitor this failure once because there tends to be a lot of the
	              // same error.
	              loggedTypeFailures[error$1.message] = true;
	              setCurrentlyValidatingElement(element);
	
	              error('Failed %s type: %s', location, error$1.message);
	
	              setCurrentlyValidatingElement(null);
	            }
	          }
	        }
	      }
	    }
	
	    function setCurrentlyValidatingElement$1(element) {
	      {
	        if (element) {
	          var owner = element._owner;
	          var stack = describeUnknownElementTypeFrameInDEV(element.type, element._source, owner ? owner.type : null);
	          setExtraStackFrame(stack);
	        } else {
	          setExtraStackFrame(null);
	        }
	      }
	    }
	
	    var propTypesMisspellWarningShown;
	
	    {
	      propTypesMisspellWarningShown = false;
	    }
	
	    function getDeclarationErrorAddendum() {
	      if (ReactCurrentOwner.current) {
	        var name = getComponentName(ReactCurrentOwner.current.type);
	
	        if (name) {
	          return '\n\nCheck the render method of `' + name + '`.';
	        }
	      }
	
	      return '';
	    }
	
	    function getSourceInfoErrorAddendum(source) {
	      if (source !== undefined) {
	        var fileName = source.fileName.replace(/^.*[\\\/]/, '');
	        var lineNumber = source.lineNumber;
	        return '\n\nCheck your code at ' + fileName + ':' + lineNumber + '.';
	      }
	
	      return '';
	    }
	
	    function getSourceInfoErrorAddendumForProps(elementProps) {
	      if (elementProps !== null && elementProps !== undefined) {
	        return getSourceInfoErrorAddendum(elementProps.__source);
	      }
	
	      return '';
	    }
	    /**
	     * Warn if there's no key explicitly set on dynamic arrays of children or
	     * object keys are not valid. This allows us to keep track of children between
	     * updates.
	     */
	
	
	    var ownerHasKeyUseWarning = {};
	
	    function getCurrentComponentErrorInfo(parentType) {
	      var info = getDeclarationErrorAddendum();
	
	      if (!info) {
	        var parentName = typeof parentType === 'string' ? parentType : parentType.displayName || parentType.name;
	
	        if (parentName) {
	          info = "\n\nCheck the top-level render call using <" + parentName + ">.";
	        }
	      }
	
	      return info;
	    }
	    /**
	     * Warn if the element doesn't have an explicit key assigned to it.
	     * This element is in an array. The array could grow and shrink or be
	     * reordered. All children that haven't already been validated are required to
	     * have a "key" property assigned to it. Error statuses are cached so a warning
	     * will only be shown once.
	     *
	     * @internal
	     * @param {ReactElement} element Element that requires a key.
	     * @param {*} parentType element's parent's type.
	     */
	
	
	    function validateExplicitKey(element, parentType) {
	      if (!element._store || element._store.validated || element.key != null) {
	        return;
	      }
	
	      element._store.validated = true;
	      var currentComponentErrorInfo = getCurrentComponentErrorInfo(parentType);
	
	      if (ownerHasKeyUseWarning[currentComponentErrorInfo]) {
	        return;
	      }
	
	      ownerHasKeyUseWarning[currentComponentErrorInfo] = true; // Usually the current owner is the offender, but if it accepts children as a
	      // property, it may be the creator of the child that's responsible for
	      // assigning it a key.
	
	      var childOwner = '';
	
	      if (element && element._owner && element._owner !== ReactCurrentOwner.current) {
	        // Give the component that originally created this child.
	        childOwner = " It was passed a child from " + getComponentName(element._owner.type) + ".";
	      }
	
	      {
	        setCurrentlyValidatingElement$1(element);
	
	        error('Each child in a list should have a unique "key" prop.' + '%s%s See https://reactjs.org/link/warning-keys for more information.', currentComponentErrorInfo, childOwner);
	
	        setCurrentlyValidatingElement$1(null);
	      }
	    }
	    /**
	     * Ensure that every element either is passed in a static location, in an
	     * array with an explicit keys property defined, or in an object literal
	     * with valid key property.
	     *
	     * @internal
	     * @param {ReactNode} node Statically passed child of any type.
	     * @param {*} parentType node's parent's type.
	     */
	
	
	    function validateChildKeys(node, parentType) {
	      if (typeof node !== 'object') {
	        return;
	      }
	
	      if (Array.isArray(node)) {
	        for (var i = 0; i < node.length; i++) {
	          var child = node[i];
	
	          if (isValidElement(child)) {
	            validateExplicitKey(child, parentType);
	          }
	        }
	      } else if (isValidElement(node)) {
	        // This element was passed in a valid location.
	        if (node._store) {
	          node._store.validated = true;
	        }
	      } else if (node) {
	        var iteratorFn = getIteratorFn(node);
	
	        if (typeof iteratorFn === 'function') {
	          // Entry iterators used to provide implicit keys,
	          // but now we print a separate warning for them later.
	          if (iteratorFn !== node.entries) {
	            var iterator = iteratorFn.call(node);
	            var step;
	
	            while (!(step = iterator.next()).done) {
	              if (isValidElement(step.value)) {
	                validateExplicitKey(step.value, parentType);
	              }
	            }
	          }
	        }
	      }
	    }
	    /**
	     * Given an element, validate that its props follow the propTypes definition,
	     * provided by the type.
	     *
	     * @param {ReactElement} element
	     */
	
	
	    function validatePropTypes(element) {
	      {
	        var type = element.type;
	
	        if (type === null || type === undefined || typeof type === 'string') {
	          return;
	        }
	
	        var propTypes;
	
	        if (typeof type === 'function') {
	          propTypes = type.propTypes;
	        } else if (typeof type === 'object' && (type.$$typeof === REACT_FORWARD_REF_TYPE || // Note: Memo only checks outer props here.
	        // Inner props are checked in the reconciler.
	        type.$$typeof === REACT_MEMO_TYPE)) {
	          propTypes = type.propTypes;
	        } else {
	          return;
	        }
	
	        if (propTypes) {
	          // Intentionally inside to avoid triggering lazy initializers:
	          var name = getComponentName(type);
	          checkPropTypes(propTypes, element.props, 'prop', name, element);
	        } else if (type.PropTypes !== undefined && !propTypesMisspellWarningShown) {
	          propTypesMisspellWarningShown = true; // Intentionally inside to avoid triggering lazy initializers:
	
	          var _name = getComponentName(type);
	
	          error('Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?', _name || 'Unknown');
	        }
	
	        if (typeof type.getDefaultProps === 'function' && !type.getDefaultProps.isReactClassApproved) {
	          error('getDefaultProps is only used on classic React.createClass ' + 'definitions. Use a static property named `defaultProps` instead.');
	        }
	      }
	    }
	    /**
	     * Given a fragment, validate that it can only be provided with fragment props
	     * @param {ReactElement} fragment
	     */
	
	
	    function validateFragmentProps(fragment) {
	      {
	        var keys = Object.keys(fragment.props);
	
	        for (var i = 0; i < keys.length; i++) {
	          var key = keys[i];
	
	          if (key !== 'children' && key !== 'key') {
	            setCurrentlyValidatingElement$1(fragment);
	
	            error('Invalid prop `%s` supplied to `React.Fragment`. ' + 'React.Fragment can only have `key` and `children` props.', key);
	
	            setCurrentlyValidatingElement$1(null);
	            break;
	          }
	        }
	
	        if (fragment.ref !== null) {
	          setCurrentlyValidatingElement$1(fragment);
	
	          error('Invalid attribute `ref` supplied to `React.Fragment`.');
	
	          setCurrentlyValidatingElement$1(null);
	        }
	      }
	    }
	    function createElementWithValidation(type, props, children) {
	      var validType = isValidElementType(type); // We warn in this case but don't throw. We expect the element creation to
	      // succeed and there will likely be errors in render.
	
	      if (!validType) {
	        var info = '';
	
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in, or you might have mixed up default and named imports.";
	        }
	
	        var sourceInfo = getSourceInfoErrorAddendumForProps(props);
	
	        if (sourceInfo) {
	          info += sourceInfo;
	        } else {
	          info += getDeclarationErrorAddendum();
	        }
	
	        var typeString;
	
	        if (type === null) {
	          typeString = 'null';
	        } else if (Array.isArray(type)) {
	          typeString = 'array';
	        } else if (type !== undefined && type.$$typeof === REACT_ELEMENT_TYPE) {
	          typeString = "<" + (getComponentName(type.type) || 'Unknown') + " />";
	          info = ' Did you accidentally export a JSX literal instead of a component?';
	        } else {
	          typeString = typeof type;
	        }
	
	        {
	          error('React.createElement: type is invalid -- expected a string (for ' + 'built-in components) or a class/function (for composite ' + 'components) but got: %s.%s', typeString, info);
	        }
	      }
	
	      var element = createElement.apply(this, arguments); // The result can be nullish if a mock or a custom function is used.
	      // TODO: Drop this when these are no longer allowed as the type argument.
	
	      if (element == null) {
	        return element;
	      } // Skip key warning if the type isn't valid since our key validation logic
	      // doesn't expect a non-string/function type and can throw confusing errors.
	      // We don't want exception behavior to differ between dev and prod.
	      // (Rendering will throw with a helpful message and as soon as the type is
	      // fixed, the key warnings will appear.)
	
	
	      if (validType) {
	        for (var i = 2; i < arguments.length; i++) {
	          validateChildKeys(arguments[i], type);
	        }
	      }
	
	      if (type === exports.Fragment) {
	        validateFragmentProps(element);
	      } else {
	        validatePropTypes(element);
	      }
	
	      return element;
	    }
	    var didWarnAboutDeprecatedCreateFactory = false;
	    function createFactoryWithValidation(type) {
	      var validatedFactory = createElementWithValidation.bind(null, type);
	      validatedFactory.type = type;
	
	      {
	        if (!didWarnAboutDeprecatedCreateFactory) {
	          didWarnAboutDeprecatedCreateFactory = true;
	
	          warn('React.createFactory() is deprecated and will be removed in ' + 'a future major release. Consider using JSX ' + 'or use React.createElement() directly instead.');
	        } // Legacy hook: remove it
	
	
	        (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(validatedFactory, 'type', {
	          enumerable: false,
	          get: function () {
	            warn('Factory.type is deprecated. Access the class directly ' + 'before passing it to createFactory.');
	
	            (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(this, 'type', {
	              value: type
	            });
	            return type;
	          }
	        });
	      }
	
	      return validatedFactory;
	    }
	    function cloneElementWithValidation(element, props, children) {
	      var newElement = cloneElement.apply(this, arguments);
	
	      for (var i = 2; i < arguments.length; i++) {
	        validateChildKeys(arguments[i], newElement.type);
	      }
	
	      validatePropTypes(newElement);
	      return newElement;
	    }
	
	    {
	
	      try {
	        var frozenObject = (function(obj) { /* ai_es3_polyfil freeze */ var func = Object["freeze"]; if (func) { return func(obj); } return obj; })({});
	        /* eslint-enable no-new */
	      } catch (e) {
	      }
	    }
	
	    var createElement$1 =  createElementWithValidation ;
	    var cloneElement$1 =  cloneElementWithValidation ;
	    var createFactory =  createFactoryWithValidation ;
	    var Children = {
	      map: mapChildren,
	      forEach: forEachChildren,
	      count: countChildren,
	      toArray: toArray,
	      only: onlyChild
	    };
	
	    exports.Children = Children;
	    exports.Component = Component;
	    exports.PureComponent = PureComponent;
	    exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ReactSharedInternals;
	    exports.cloneElement = cloneElement$1;
	    exports.createContext = createContext;
	    exports.createElement = createElement$1;
	    exports.createFactory = createFactory;
	    exports.createRef = createRef;
	    exports.forwardRef = forwardRef;
	    exports.isValidElement = isValidElement;
	    exports.lazy = lazy;
	    exports.memo = memo;
	    exports.useCallback = useCallback;
	    exports.useContext = useContext;
	    exports.useDebugValue = useDebugValue;
	    exports.useEffect = useEffect;
	    exports.useImperativeHandle = useImperativeHandle;
	    exports.useLayoutEffect = useLayoutEffect;
	    exports.useMemo = useMemo;
	    exports.useReducer = useReducer;
	    exports.useRef = useRef;
	    exports.useState = useState;
	    exports.version = ReactVersion;
	      })();
	    }
	    });
	    var react_development_1 = react_development.Fragment;
	    var react_development_2 = react_development.StrictMode;
	    var react_development_3 = react_development.Profiler;
	    var react_development_4 = react_development.Suspense;
	    var react_development_5 = react_development.Children;
	    var react_development_6 = react_development.Component;
	    var react_development_7 = react_development.PureComponent;
	    var react_development_8 = react_development.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
	    var react_development_9 = react_development.cloneElement;
	    var react_development_10 = react_development.createContext;
	    var react_development_11 = react_development.createElement;
	    var react_development_12 = react_development.createFactory;
	    var react_development_13 = react_development.createRef;
	    var react_development_14 = react_development.forwardRef;
	    var react_development_15 = react_development.isValidElement;
	    var react_development_16 = react_development.lazy;
	    var react_development_17 = react_development.memo;
	    var react_development_18 = react_development.useCallback;
	    var react_development_19 = react_development.useContext;
	    var react_development_20 = react_development.useDebugValue;
	    var react_development_21 = react_development.useEffect;
	    var react_development_22 = react_development.useImperativeHandle;
	    var react_development_23 = react_development.useLayoutEffect;
	    var react_development_24 = react_development.useMemo;
	    var react_development_25 = react_development.useReducer;
	    var react_development_26 = react_development.useRef;
	    var react_development_27 = react_development.useState;
	    var react_development_28 = react_development.version;
	
	    var react = createCommonjsModule(function (module) {
	
	    if (true) {
	      module.exports = react_production_min;
	    } else {
	      module.exports = react_development;
	    }
	    });
	    var react_1 = react.Children;
	    var react_2 = react.Component;
	    var react_3 = react.PropTypes;
	    var react_4 = react.createElement;
	    var react_5 = react.createContext;
	    var react_6 = react.useContext;
	    var react_7 = react.useState;
	    var react_8 = react.useEffect;
	    var react_9 = react.useRef;
	
	    /**
	     * Higher-order component function to hook Application Insights tracking
	     * in a React component's lifecycle.
	     *
	     * @param reactPlugin ReactPlugin instance
	     * @param Component the React component to be instrumented
	     * @param componentName (optional) component name
	     * @param className (optional) className of the HOC div
	     */
	    function withAITracking(reactPlugin, Component, componentName, className) {
	        if (componentName === undefined || componentName === null || typeof componentName !== 'string') {
	            componentName = Component.prototype &&
	                Component.prototype.constructor &&
	                Component.prototype.constructor.name ||
	                'Unknown';
	        }
	        if (className === undefined || className === null || typeof className !== 'string') {
	            className = '';
	        }
	        return /** @class */ (function (_super) {
	            __extends(class_1, _super);
	            function class_1() {
	                var _this = _super !== null && _super.apply(this, arguments) || this;
	                _this._mountTimestamp = 0;
	                _this._firstActiveTimestamp = 0;
	                _this._idleStartTimestamp = 0;
	                _this._lastActiveTimestamp = 0;
	                _this._totalIdleTime = 0;
	                _this._idleCount = 0;
	                _this._idleTimeout = 5000;
	                _this.trackActivity = function (e) {
	                    if (_this._firstActiveTimestamp === 0) {
	                        _this._firstActiveTimestamp = CoreUtils.dateNow();
	                        _this._lastActiveTimestamp = _this._firstActiveTimestamp;
	                    }
	                    else {
	                        _this._lastActiveTimestamp = CoreUtils.dateNow();
	                    }
	                    if (_this._idleStartTimestamp > 0) {
	                        var lastIdleTime = _this._lastActiveTimestamp - _this._idleStartTimestamp;
	                        _this._totalIdleTime += lastIdleTime;
	                        _this._idleStartTimestamp = 0;
	                    }
	                };
	                return _this;
	            }
	            class_1.prototype.componentDidMount = function () {
	                var _this = this;
	                this._mountTimestamp = CoreUtils.dateNow();
	                this._firstActiveTimestamp = 0;
	                this._totalIdleTime = 0;
	                this._lastActiveTimestamp = 0;
	                this._idleStartTimestamp = 0;
	                this._idleCount = 0;
	                this._intervalId = setInterval(function () {
	                    if (_this._lastActiveTimestamp > 0 && _this._idleStartTimestamp === 0 && CoreUtils.dateNow() - _this._lastActiveTimestamp >= _this._idleTimeout) {
	                        _this._idleStartTimestamp = CoreUtils.dateNow();
	                        _this._idleCount++;
	                    }
	                }, 100);
	            };
	            class_1.prototype.componentWillUnmount = function () {
	                if (this._mountTimestamp === 0) {
	                    throw new Error('withAITracking:componentWillUnmount: mountTimestamp is not initialized.');
	                }
	                if (this._intervalId) {
	                    clearInterval(this._intervalId);
	                }
	                if (this._firstActiveTimestamp === 0) {
	                    return;
	                }
	                var engagementTime = this.getEngagementTimeSeconds();
	                var metricData = {
	                    average: engagementTime,
	                    name: 'React Component Engaged Time (seconds)',
	                    sampleCount: 1
	                };
	                var additionalProperties = { 'Component Name': componentName };
	                reactPlugin.trackMetric(metricData, additionalProperties);
	            };
	            class_1.prototype.render = function () {
	                return (react_4("div", { onKeyDown: this.trackActivity, onMouseMove: this.trackActivity, onScroll: this.trackActivity, onMouseDown: this.trackActivity, onTouchStart: this.trackActivity, onTouchMove: this.trackActivity, className: className },
	                    react_4(Component, __assign({}, this.props))));
	            };
	            class_1.prototype.getEngagementTimeSeconds = function () {
	                return (CoreUtils.dateNow() - this._firstActiveTimestamp - this._totalIdleTime - this._idleCount * this._idleTimeout) / 1000;
	            };
	            return class_1;
	        }(react_2));
	    }
	
	    var DataSanitizer = /** @class */ (function () {
	        function DataSanitizer() {
	        }
	        DataSanitizer.sanitizeKeyAndAddUniqueness = function (logger, key, map) {
	            var origLength = key.length;
	            var field = DataSanitizer.sanitizeKey(logger, key);
	            // validation truncated the length.  We need to add uniqueness
	            if (field.length !== origLength) {
	                var i = 0;
	                var uniqueField = field;
	                while (map[uniqueField] !== undefined) {
	                    i++;
	                    uniqueField = field.substring(0, DataSanitizer.MAX_NAME_LENGTH - 3) + DataSanitizer.padNumber(i);
	                }
	                field = uniqueField;
	            }
	            return field;
	        };
	        DataSanitizer.sanitizeKey = function (logger, name) {
	            var nameTrunc;
	            if (name) {
	                // Remove any leading or trailing whitepace
	                name = DataSanitizer.trim(name.toString());
	                // truncate the string to 150 chars
	                if (name.length > DataSanitizer.MAX_NAME_LENGTH) {
	                    nameTrunc = name.substring(0, DataSanitizer.MAX_NAME_LENGTH);
	                    logger.throwInternal(LoggingSeverity.WARNING, _InternalMessageId.NameTooLong, "name is too long.  It has been truncated to " + DataSanitizer.MAX_NAME_LENGTH + " characters.", { name: name }, true);
	                }
	            }
	            return nameTrunc || name;
	        };
	        DataSanitizer.sanitizeString = function (logger, value, maxLength) {
	            if (maxLength === void 0) { maxLength = DataSanitizer.MAX_STRING_LENGTH; }
	            var valueTrunc;
	            if (value) {
	                maxLength = maxLength ? maxLength : DataSanitizer.MAX_STRING_LENGTH; // in case default parameters dont work
	                value = DataSanitizer.trim(value);
	                if (value.toString().length > maxLength) {
	                    valueTrunc = value.toString().substring(0, maxLength);
	                    logger.throwInternal(LoggingSeverity.WARNING, _InternalMessageId.StringValueTooLong, "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
	                }
	            }
	            return valueTrunc || value;
	        };
	        DataSanitizer.sanitizeUrl = function (logger, url) {
	            return DataSanitizer.sanitizeInput(logger, url, DataSanitizer.MAX_URL_LENGTH, _InternalMessageId.UrlTooLong);
	        };
	        DataSanitizer.sanitizeMessage = function (logger, message) {
	            var messageTrunc;
	            if (message) {
	                if (message.length > DataSanitizer.MAX_MESSAGE_LENGTH) {
	                    messageTrunc = message.substring(0, DataSanitizer.MAX_MESSAGE_LENGTH);
	                    logger.throwInternal(LoggingSeverity.WARNING, _InternalMessageId.MessageTruncated, "message is too long, it has been truncated to " + DataSanitizer.MAX_MESSAGE_LENGTH + " characters.", { message: message }, true);
	                }
	            }
	            return messageTrunc || message;
	        };
	        DataSanitizer.sanitizeException = function (logger, exception) {
	            var exceptionTrunc;
	            if (exception) {
	                if (exception.length > DataSanitizer.MAX_EXCEPTION_LENGTH) {
	                    exceptionTrunc = exception.substring(0, DataSanitizer.MAX_EXCEPTION_LENGTH);
	                    logger.throwInternal(LoggingSeverity.WARNING, _InternalMessageId.ExceptionTruncated, "exception is too long, it has been truncated to " + DataSanitizer.MAX_EXCEPTION_LENGTH + " characters.", { exception: exception }, true);
	                }
	            }
	            return exceptionTrunc || exception;
	        };
	        DataSanitizer.sanitizeProperties = function (logger, properties) {
	            if (properties) {
	                var tempProps_1 = {};
	                objForEachKey(properties, function (prop, value) {
	                    if (isObject(value) && hasJSON()) {
	                        // Stringify any part C properties
	                        try {
	                            value = getJSON().stringify(value);
	                        }
	                        catch (e) {
	                            logger.throwInternal(LoggingSeverity.WARNING, _InternalMessageId.CannotSerializeObjectNonSerializable, "custom property is not valid", { exception: e }, true);
	                        }
	                    }
	                    value = DataSanitizer.sanitizeString(logger, value, DataSanitizer.MAX_PROPERTY_LENGTH);
	                    prop = DataSanitizer.sanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
	                    tempProps_1[prop] = value;
	                });
	                properties = tempProps_1;
	            }
	            return properties;
	        };
	        DataSanitizer.sanitizeMeasurements = function (logger, measurements) {
	            if (measurements) {
	                var tempMeasurements_1 = {};
	                objForEachKey(measurements, function (measure, value) {
	                    measure = DataSanitizer.sanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
	                    tempMeasurements_1[measure] = value;
	                });
	                measurements = tempMeasurements_1;
	            }
	            return measurements;
	        };
	        DataSanitizer.sanitizeId = function (logger, id) {
	            return id ? DataSanitizer.sanitizeInput(logger, id, DataSanitizer.MAX_ID_LENGTH, _InternalMessageId.IdTooLong).toString() : id;
	        };
	        DataSanitizer.sanitizeInput = function (logger, input, maxLength, _msgId) {
	            var inputTrunc;
	            if (input) {
	                input = DataSanitizer.trim(input);
	                if (input.length > maxLength) {
	                    inputTrunc = input.substring(0, maxLength);
	                    logger.throwInternal(LoggingSeverity.WARNING, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
	                }
	            }
	            return inputTrunc || input;
	        };
	        DataSanitizer.padNumber = function (num) {
	            var s = "00" + num;
	            return s.substr(s.length - 3);
	        };
	        /**
	         * helper method to trim strings (IE8 does not implement String.prototype.trim)
	         */
	        DataSanitizer.trim = function (str) {
	            if (!isString(str)) {
	                return str;
	            }
	            return str.replace(/^\s+|\s+$/g, "");
	        };
	        /**
	         * Max length allowed for custom names.
	         */
	        DataSanitizer.MAX_NAME_LENGTH = 150;
	        /**
	         * Max length allowed for Id field in page views.
	         */
	        DataSanitizer.MAX_ID_LENGTH = 128;
	        /**
	         * Max length allowed for custom values.
	         */
	        DataSanitizer.MAX_PROPERTY_LENGTH = 8192;
	        /**
	         * Max length allowed for names
	         */
	        DataSanitizer.MAX_STRING_LENGTH = 1024;
	        /**
	         * Max length allowed for url.
	         */
	        DataSanitizer.MAX_URL_LENGTH = 2048;
	        /**
	         * Max length allowed for messages.
	         */
	        DataSanitizer.MAX_MESSAGE_LENGTH = 32768;
	        /**
	         * Max length allowed for exceptions.
	         */
	        DataSanitizer.MAX_EXCEPTION_LENGTH = 32768;
	        return DataSanitizer;
	    }());
	
	    /**
	     * Convert ms to c# time span format
	     */
	    function msToTimeSpan(totalms) {
	        if (isNaN(totalms) || totalms < 0) {
	            totalms = 0;
	        }
	        totalms = Math.round(totalms);
	        var ms = "" + totalms % 1000;
	        var sec = "" + Math.floor(totalms / 1000) % 60;
	        var min = "" + Math.floor(totalms / (1000 * 60)) % 60;
	        var hour = "" + Math.floor(totalms / (1000 * 60 * 60)) % 24;
	        var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
	        ms = ms.length === 1 ? "00" + ms : ms.length === 2 ? "0" + ms : ms;
	        sec = sec.length < 2 ? "0" + sec : sec;
	        min = min.length < 2 ? "0" + min : min;
	        hour = hour.length < 2 ? "0" + hour : hour;
	        return (days > 0 ? days + "." : "") + hour + ":" + min + ":" + sec + "." + ms;
	    }
	
	    var strNotSpecified = "not_specified";
	
	    /**
	     * Type of storage to differentiate between local storage and session storage
	     */
	    var StorageType;
	    (function (StorageType) {
	        StorageType[StorageType["LocalStorage"] = 0] = "LocalStorage";
	        StorageType[StorageType["SessionStorage"] = 1] = "SessionStorage";
	    })(StorageType || (StorageType = {}));
	    /**
	     * Enum is used in aiDataContract to describe how fields are serialized.
	     * For instance: (Fieldtype.Required | FieldType.Array) will mark the field as required and indicate it's an array
	     */
	    var FieldType;
	    (function (FieldType) {
	        FieldType[FieldType["Default"] = 0] = "Default";
	        FieldType[FieldType["Required"] = 1] = "Required";
	        FieldType[FieldType["Array"] = 2] = "Array";
	        FieldType[FieldType["Hidden"] = 4] = "Hidden";
	    })(FieldType || (FieldType = {}));
	    var DistributedTracingModes;
	    (function (DistributedTracingModes) {
	        /**
	         * (Default) Send Application Insights correlation headers
	         */
	        DistributedTracingModes[DistributedTracingModes["AI"] = 0] = "AI";
	        /**
	         * Send both W3C Trace Context headers and back-compatibility Application Insights headers
	         */
	        DistributedTracingModes[DistributedTracingModes["AI_AND_W3C"] = 1] = "AI_AND_W3C";
	        /**
	         * Send W3C Trace Context headers
	         */
	        DistributedTracingModes[DistributedTracingModes["W3C"] = 2] = "W3C";
	    })(DistributedTracingModes || (DistributedTracingModes = {}));
	
	    var _document = getDocument() || {};
	    var _htmlAnchorIdx = 0;
	    // Use an array of temporary values as it's possible for multiple calls to parseUrl() will be called with different URLs
	    // Using a cache size of 5 for now as it current depth usage is at least 2, so adding a minor buffer to handle future updates
	    var _htmlAnchorElement = [null, null, null, null, null];
	    function urlParseUrl(url) {
	        var anchorIdx = _htmlAnchorIdx;
	        var anchorCache = _htmlAnchorElement;
	        var tempAnchor = anchorCache[anchorIdx];
	        if (!_document.createElement) {
	            // Always create the temp instance if createElement is not available
	            tempAnchor = { host: urlParseHost(url, true) };
	        }
	        else if (!anchorCache[anchorIdx]) {
	            // Create and cache the unattached anchor instance 
	            tempAnchor = anchorCache[anchorIdx] = _document.createElement('a');
	        }
	        tempAnchor.href = url;
	        // Move the cache index forward
	        anchorIdx++;
	        if (anchorIdx >= anchorCache.length) {
	            anchorIdx = 0;
	        }
	        _htmlAnchorIdx = anchorIdx;
	        return tempAnchor;
	    }
	    // Fallback method to grab host from url if document.createElement method is not available
	    function urlParseHost(url, inclPort) {
	        var fullHost = urlParseFullHost(url, inclPort);
	        if (fullHost) {
	            var match = fullHost.match(/(www[0-9]?\.)?(.[^/:]+)(\:[\d]+)?/i);
	            if (match != null && match.length > 3 && isString(match[2]) && match[2].length > 0) {
	                return match[2] + (match[3] || "");
	            }
	        }
	        return fullHost;
	    }
	    function urlParseFullHost(url, inclPort) {
	        var result = null;
	        if (url) {
	            var match = url.match(/(\w*):\/\/(.[^/:]+)(\:[\d]+)?/i);
	            if (match != null && match.length > 2 && isString(match[2]) && match[2].length > 0) {
	                result = match[2] || "";
	                if (inclPort && match.length > 2) {
	                    var protocol = (match[1] || "").toLowerCase();
	                    var port = match[3] || "";
	                    // IE includes the standard port so pass it off if it's the same as the protocol
	                    if (protocol === "http" && port === ":80") {
	                        port = "";
	                    }
	                    else if (protocol === "https" && port === ":443") {
	                        port = "";
	                    }
	                    result += port;
	                }
	            }
	        }
	        return result;
	    }
	
	    function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
	        var target, name = commandName, data = commandName;
	        if (absoluteUrl && absoluteUrl.length > 0) {
	            var parsedUrl = urlParseUrl(absoluteUrl);
	            target = parsedUrl.host;
	            if (!name) {
	                if (parsedUrl.pathname != null) {
	                    var pathName = (parsedUrl.pathname.length === 0) ? "/" : parsedUrl.pathname;
	                    if (pathName.charAt(0) !== '/') {
	                        pathName = "/" + pathName;
	                    }
	                    data = parsedUrl.pathname;
	                    name = DataSanitizer.sanitizeString(logger, method ? method + " " + pathName : pathName);
	                }
	                else {
	                    name = DataSanitizer.sanitizeString(logger, absoluteUrl);
	                }
	            }
	        }
	        else {
	            target = commandName;
	            name = commandName;
	        }
	        return {
	            target: target,
	            name: name,
	            data: data
	        };
	    }
	
	    // THIS FILE WAS AUTOGENERATED
	    /**
	     * Data struct to contain only C section with custom fields.
	     */
	    var Base = /** @class */ (function () {
	        function Base() {
	        }
	        return Base;
	    }());
	
	    /**
	     * Data struct to contain both B and C sections.
	     */
	    var Data = /** @class */ (function (_super) {
	        __extends(Data, _super);
	        function Data() {
	            return _super.call(this) || this;
	        }
	        return Data;
	    }(Base));
	
	    /**
	     * System variables for a telemetry item.
	     */
	    var Envelope = /** @class */ (function () {
	        function Envelope() {
	            /**
	             * Envelope version. For internal use only. By assigning this the default, it will not be serialized within the payload unless changed to a value other than #1.
	             */
	            this.ver = 1;
	            /**
	             * Sampling rate used in application. This telemetry item represents 1 / sampleRate actual telemetry items.
	             */
	            this.sampleRate = 100.0;
	            /**
	             * Key/value collection of context properties. See ContextTagKeys for information on available properties.
	             */
	            this.tags = {};
	        }
	        return Envelope;
	    }());
	
	    var Envelope$1 = /** @class */ (function (_super) {
	        __extends(Envelope$$1, _super);
	        /**
	         * Constructs a new instance of telemetry data.
	         */
	        function Envelope$$1(logger, data, name) {
	            var _this = _super.call(this) || this;
	            _this.name = DataSanitizer.sanitizeString(logger, name) || strNotSpecified;
	            _this.data = data;
	            _this.time = toISOString(new Date());
	            _this.aiDataContract = {
	                time: FieldType.Required,
	                iKey: FieldType.Required,
	                name: FieldType.Required,
	                sampleRate: function () {
	                    return (_this.sampleRate === 100) ? FieldType.Hidden : FieldType.Required;
	                },
	                tags: FieldType.Required,
	                data: FieldType.Required
	            };
	            return _this;
	        }
	        return Envelope$$1;
	    }(Envelope));
	
	    /**
	     * Instances of Event represent structured event records that can be grouped and searched by their properties. Event data item also creates a metric of event count by name.
	     */
	    var EventData = /** @class */ (function () {
	        function EventData() {
	            /**
	             * Schema version
	             */
	            this.ver = 2;
	            /**
	             * Collection of custom properties.
	             */
	            this.properties = {};
	            /**
	             * Collection of custom measurements.
	             */
	            this.measurements = {};
	        }
	        return EventData;
	    }());
	
	    var Event$1 = /** @class */ (function (_super) {
	        __extends(Event, _super);
	        /**
	         * Constructs a new instance of the EventTelemetry object
	         */
	        function Event(logger, name, properties, measurements) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                ver: FieldType.Required,
	                name: FieldType.Required,
	                properties: FieldType.Default,
	                measurements: FieldType.Default
	            };
	            _this.name = DataSanitizer.sanitizeString(logger, name) || strNotSpecified;
	            _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
	            _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	            return _this;
	        }
	        Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
	        Event.dataType = "EventData";
	        return Event;
	    }(EventData));
	
	    // THIS FILE WAS AUTOGENERATED
	    /**
	     * Stack frame information.
	     */
	    var StackFrame = /** @class */ (function () {
	        function StackFrame() {
	        }
	        return StackFrame;
	    }());
	
	    /**
	     * An instance of Exception represents a handled or unhandled exception that occurred during execution of the monitored application.
	     */
	    var ExceptionData = /** @class */ (function () {
	        function ExceptionData() {
	            /**
	             * Schema version
	             */
	            this.ver = 2;
	            /**
	             * Exception chain - list of inner exceptions.
	             */
	            this.exceptions = [];
	            /**
	             * Collection of custom properties.
	             */
	            this.properties = {};
	            /**
	             * Collection of custom measurements.
	             */
	            this.measurements = {};
	        }
	        return ExceptionData;
	    }());
	
	    /**
	     * Exception details of the exception in a chain.
	     */
	    var ExceptionDetails = /** @class */ (function () {
	        function ExceptionDetails() {
	            /**
	             * Indicates if full exception stack is provided in the exception. The stack may be trimmed, such as in the case of a StackOverflow exception.
	             */
	            this.hasFullStack = true;
	            /**
	             * List of stack frames. Either stack or parsedStack should have a value.
	             */
	            this.parsedStack = [];
	        }
	        return ExceptionDetails;
	    }());
	
	    var strError = "error";
	    function _isExceptionDetailsInternal(value) {
	        return "hasFullStack" in value && "typeName" in value;
	    }
	    function _isExceptionInternal(value) {
	        return ("ver" in value && "exceptions" in value && "properties" in value);
	    }
	    function _getErrorType(errorType) {
	        // Gets the Error Type by passing the constructor (used to get the true type of native error object).
	        var typeName = "";
	        if (errorType) {
	            typeName = errorType.typeName || errorType.name || "";
	            if (!typeName) {
	                try {
	                    var funcNameRegex = /function (.{1,})\(/;
	                    var results = (funcNameRegex).exec((errorType).constructor.toString());
	                    typeName = (results && results.length > 1) ? results[1] : "";
	                }
	                catch (e) {
	                    // Ignore
	                }
	            }
	        }
	        return typeName;
	    }
	    var Exception = /** @class */ (function (_super) {
	        __extends(Exception, _super);
	        /**
	         * Constructs a new instance of the ExceptionTelemetry object
	         */
	        function Exception(logger, exception, properties, measurements, severityLevel, id) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                ver: FieldType.Required,
	                exceptions: FieldType.Required,
	                severityLevel: FieldType.Default,
	                properties: FieldType.Default,
	                measurements: FieldType.Default
	            };
	            if (!_isExceptionInternal(exception)) {
	                _this.exceptions = [new _ExceptionDetails(logger, exception)];
	                _this.properties = DataSanitizer.sanitizeProperties(logger, properties) || {};
	                _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	                if (severityLevel) {
	                    _this.severityLevel = severityLevel;
	                }
	                if (id) {
	                    _this.id = id;
	                }
	            }
	            else {
	                _this.exceptions = exception.exceptions;
	                _this.properties = exception.properties;
	                _this.measurements = exception.measurements;
	                if (exception.severityLevel) {
	                    _this.severityLevel = exception.severityLevel;
	                }
	                if (exception.id) {
	                    _this.id = exception.id;
	                }
	                if (exception.problemGroup) {
	                    _this.problemGroup = exception.problemGroup;
	                }
	                // bool/int types, use isNullOrUndefined
	                _this.ver = 2; // TODO: handle the CS"4.0" ==> breeze 2 conversion in a better way
	                if (!isNullOrUndefined(exception.isManual)) {
	                    _this.isManual = exception.isManual;
	                }
	            }
	            return _this;
	        }
	        Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
	            var exceptions = exception.exceptions
	                && arrMap(exception.exceptions, function (ex) { return _ExceptionDetails.CreateFromInterface(logger, ex); });
	            var exceptionData = new Exception(logger, __assign({}, exception, { exceptions: exceptions }), properties, measurements);
	            return exceptionData;
	        };
	        Exception.prototype.toInterface = function () {
	            var _a = this, exceptions = _a.exceptions, properties = _a.properties, measurements = _a.measurements, severityLevel = _a.severityLevel, ver = _a.ver, problemGroup = _a.problemGroup, id = _a.id, isManual = _a.isManual;
	            var exceptionDetailsInterface = exceptions instanceof Array
	                && arrMap(exceptions, function (exception) { return exception.toInterface(); })
	                || undefined;
	            return {
	                ver: "4.0",
	                exceptions: exceptionDetailsInterface,
	                severityLevel: severityLevel,
	                properties: properties,
	                measurements: measurements,
	                problemGroup: problemGroup,
	                id: id,
	                isManual: isManual
	            };
	        };
	        /**
	         * Creates a simple exception with 1 stack frame. Useful for manual constracting of exception.
	         */
	        Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
	            return {
	                exceptions: [
	                    {
	                        hasFullStack: true,
	                        message: message,
	                        stack: details,
	                        typeName: typeName
	                    }
	                ]
	            };
	        };
	        Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
	        Exception.dataType = "ExceptionData";
	        return Exception;
	    }(ExceptionData));
	    var _ExceptionDetails = /** @class */ (function (_super) {
	        __extends(_ExceptionDetails, _super);
	        function _ExceptionDetails(logger, exception) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                id: FieldType.Default,
	                outerId: FieldType.Default,
	                typeName: FieldType.Required,
	                message: FieldType.Required,
	                hasFullStack: FieldType.Default,
	                stack: FieldType.Default,
	                parsedStack: FieldType.Array
	            };
	            if (!_isExceptionDetailsInternal(exception)) {
	                var error = exception;
	                if (!isError(error)) {
	                    error = error[strError] || error.evt || error;
	                }
	                _this.typeName = DataSanitizer.sanitizeString(logger, _getErrorType(error)) || strNotSpecified;
	                _this.message = DataSanitizer.sanitizeMessage(logger, exception.message) || strNotSpecified;
	                var stack = exception.stack;
	                _this.parsedStack = _ExceptionDetails.parseStack(stack);
	                _this.stack = DataSanitizer.sanitizeException(logger, stack);
	                _this.hasFullStack = isArray(_this.parsedStack) && _this.parsedStack.length > 0;
	            }
	            else {
	                _this.typeName = exception.typeName;
	                _this.message = exception.message;
	                _this.stack = exception.stack;
	                _this.parsedStack = exception.parsedStack;
	                _this.hasFullStack = exception.hasFullStack;
	            }
	            return _this;
	        }
	        _ExceptionDetails.prototype.toInterface = function () {
	            var parsedStack = this.parsedStack instanceof Array
	                && arrMap(this.parsedStack, function (frame) { return frame.toInterface(); });
	            var exceptionDetailsInterface = {
	                id: this.id,
	                outerId: this.outerId,
	                typeName: this.typeName,
	                message: this.message,
	                hasFullStack: this.hasFullStack,
	                stack: this.stack,
	                parsedStack: parsedStack || undefined
	            };
	            return exceptionDetailsInterface;
	        };
	        _ExceptionDetails.CreateFromInterface = function (logger, exception) {
	            var parsedStack = (exception.parsedStack instanceof Array
	                && arrMap(exception.parsedStack, function (frame) { return _StackFrame.CreateFromInterface(frame); }))
	                || exception.parsedStack;
	            var exceptionDetails = new _ExceptionDetails(logger, __assign({}, exception, { parsedStack: parsedStack }));
	            return exceptionDetails;
	        };
	        _ExceptionDetails.parseStack = function (stack) {
	            var parsedStack;
	            if (isString(stack)) {
	                var frames_1 = stack.split('\n');
	                parsedStack = [];
	                var level = 0;
	                var totalSizeInBytes = 0;
	                for (var i = 0; i <= frames_1.length; i++) {
	                    var frame = frames_1[i];
	                    if (_StackFrame.regex.test(frame)) {
	                        var parsedFrame = new _StackFrame(frames_1[i], level++);
	                        totalSizeInBytes += parsedFrame.sizeInBytes;
	                        parsedStack.push(parsedFrame);
	                    }
	                }
	                // DP Constraint - exception parsed stack must be < 32KB
	                // remove frames from the middle to meet the threshold
	                var exceptionParsedStackThreshold = 32 * 1024;
	                if (totalSizeInBytes > exceptionParsedStackThreshold) {
	                    var left = 0;
	                    var right = parsedStack.length - 1;
	                    var size = 0;
	                    var acceptedLeft = left;
	                    var acceptedRight = right;
	                    while (left < right) {
	                        // check size
	                        var lSize = parsedStack[left].sizeInBytes;
	                        var rSize = parsedStack[right].sizeInBytes;
	                        size += lSize + rSize;
	                        if (size > exceptionParsedStackThreshold) {
	                            // remove extra frames from the middle
	                            var howMany = acceptedRight - acceptedLeft + 1;
	                            parsedStack.splice(acceptedLeft, howMany);
	                            break;
	                        }
	                        // update pointers
	                        acceptedLeft = left;
	                        acceptedRight = right;
	                        left++;
	                        right--;
	                    }
	                }
	            }
	            return parsedStack;
	        };
	        return _ExceptionDetails;
	    }(ExceptionDetails));
	    var _StackFrame = /** @class */ (function (_super) {
	        __extends(_StackFrame, _super);
	        function _StackFrame(sourceFrame, level) {
	            var _this = _super.call(this) || this;
	            _this.sizeInBytes = 0;
	            _this.aiDataContract = {
	                level: FieldType.Required,
	                method: FieldType.Required,
	                assembly: FieldType.Default,
	                fileName: FieldType.Default,
	                line: FieldType.Default
	            };
	            // Not converting this to isString() as typescript uses this logic to "understand" the different
	            // types for the 2 different code paths
	            if (typeof sourceFrame === "string") {
	                var frame = sourceFrame;
	                _this.level = level;
	                _this.method = "<no_method>";
	                _this.assembly = strTrim(frame);
	                _this.fileName = "";
	                _this.line = 0;
	                var matches = frame.match(_StackFrame.regex);
	                if (matches && matches.length >= 5) {
	                    _this.method = strTrim(matches[2]) || _this.method;
	                    _this.fileName = strTrim(matches[4]);
	                    _this.line = parseInt(matches[5]) || 0;
	                }
	            }
	            else {
	                _this.level = sourceFrame.level;
	                _this.method = sourceFrame.method;
	                _this.assembly = sourceFrame.assembly;
	                _this.fileName = sourceFrame.fileName;
	                _this.line = sourceFrame.line;
	                _this.sizeInBytes = 0;
	            }
	            _this.sizeInBytes += _this.method.length;
	            _this.sizeInBytes += _this.fileName.length;
	            _this.sizeInBytes += _this.assembly.length;
	            // todo: these might need to be removed depending on how the back-end settles on their size calculation
	            _this.sizeInBytes += _StackFrame.baseSize;
	            _this.sizeInBytes += _this.level.toString().length;
	            _this.sizeInBytes += _this.line.toString().length;
	            return _this;
	        }
	        _StackFrame.CreateFromInterface = function (frame) {
	            return new _StackFrame(frame, null /* level is available in frame interface */);
	        };
	        _StackFrame.prototype.toInterface = function () {
	            return {
	                level: this.level,
	                method: this.method,
	                assembly: this.assembly,
	                fileName: this.fileName,
	                line: this.line
	            };
	        };
	        // regex to match stack frames from ie/chrome/ff
	        // methodName=$2, fileName=$4, lineNo=$5, column=$6
	        _StackFrame.regex = /^([\s]+at)?(.*?)(\@|\s\(|\s)([^\(\@\n]+):([0-9]+):([0-9]+)(\)?)$/;
	        _StackFrame.baseSize = 58; // '{"method":"","level":,"assembly":"","fileName":"","line":}'.length
	        return _StackFrame;
	    }(StackFrame));
	
	    /**
	     * An instance of the Metric item is a list of measurements (single data points) and/or aggregations.
	     */
	    var MetricData = /** @class */ (function () {
	        function MetricData() {
	            /**
	             * Schema version
	             */
	            this.ver = 2;
	            /**
	             * List of metrics. Only one metric in the list is currently supported by Application Insights storage. If multiple data points were sent only the first one will be used.
	             */
	            this.metrics = [];
	            /**
	             * Collection of custom properties.
	             */
	            this.properties = {};
	            /**
	             * Collection of custom measurements.
	             */
	            this.measurements = {};
	        }
	        return MetricData;
	    }());
	
	    // THIS FILE WAS AUTOGENERATED
	    /**
	     * Type of the metric data measurement.
	     */
	    var DataPointType;
	    (function (DataPointType) {
	        DataPointType[DataPointType["Measurement"] = 0] = "Measurement";
	        DataPointType[DataPointType["Aggregation"] = 1] = "Aggregation";
	    })(DataPointType || (DataPointType = {}));
	
	    /**
	     * Metric data single measurement.
	     */
	    var DataPoint = /** @class */ (function () {
	        function DataPoint() {
	            /**
	             * Metric type. Single measurement or the aggregated value.
	             */
	            this.kind = DataPointType.Measurement;
	        }
	        return DataPoint;
	    }());
	
	    var DataPoint$1 = /** @class */ (function (_super) {
	        __extends(DataPoint$$1, _super);
	        function DataPoint$$1() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            /**
	             * The data contract for serializing this object.
	             */
	            _this.aiDataContract = {
	                name: FieldType.Required,
	                kind: FieldType.Default,
	                value: FieldType.Required,
	                count: FieldType.Default,
	                min: FieldType.Default,
	                max: FieldType.Default,
	                stdDev: FieldType.Default
	            };
	            return _this;
	        }
	        return DataPoint$$1;
	    }(DataPoint));
	
	    var Metric = /** @class */ (function (_super) {
	        __extends(Metric, _super);
	        /**
	         * Constructs a new instance of the MetricTelemetry object
	         */
	        function Metric(logger, name, value, count, min, max, properties, measurements) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                ver: FieldType.Required,
	                metrics: FieldType.Required,
	                properties: FieldType.Default
	            };
	            var dataPoint = new DataPoint$1();
	            dataPoint.count = count > 0 ? count : undefined;
	            dataPoint.max = isNaN(max) || max === null ? undefined : max;
	            dataPoint.min = isNaN(min) || min === null ? undefined : min;
	            dataPoint.name = DataSanitizer.sanitizeString(logger, name) || strNotSpecified;
	            dataPoint.value = value;
	            _this.metrics = [dataPoint];
	            _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
	            _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	            return _this;
	        }
	        Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
	        Metric.dataType = "MetricData";
	        return Metric;
	    }(MetricData));
	
	    /**
	     * An instance of PageView represents a generic action on a page like a button click. It is also the base type for PageView.
	     */
	    var PageViewData = /** @class */ (function (_super) {
	        __extends(PageViewData, _super);
	        function PageViewData() {
	            var _this = _super.call(this) || this;
	            /**
	             * Schema version
	             */
	            _this.ver = 2;
	            /**
	             * Collection of custom properties.
	             */
	            _this.properties = {};
	            /**
	             * Collection of custom measurements.
	             */
	            _this.measurements = {};
	            return _this;
	        }
	        return PageViewData;
	    }(EventData));
	
	    var PageView = /** @class */ (function (_super) {
	        __extends(PageView, _super);
	        /**
	         * Constructs a new instance of the PageEventTelemetry object
	         */
	        function PageView(logger, name, url, durationMs, properties, measurements, id) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                ver: FieldType.Required,
	                name: FieldType.Default,
	                url: FieldType.Default,
	                duration: FieldType.Default,
	                properties: FieldType.Default,
	                measurements: FieldType.Default,
	                id: FieldType.Default
	            };
	            _this.id = DataSanitizer.sanitizeId(logger, id);
	            _this.url = DataSanitizer.sanitizeUrl(logger, url);
	            _this.name = DataSanitizer.sanitizeString(logger, name) || strNotSpecified;
	            if (!isNaN(durationMs)) {
	                _this.duration = msToTimeSpan(durationMs);
	            }
	            _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
	            _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	            return _this;
	        }
	        PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
	        PageView.dataType = "PageviewData";
	        return PageView;
	    }(PageViewData));
	
	    /**
	     * An instance of Remote Dependency represents an interaction of the monitored component with a remote component/service like SQL or an HTTP endpoint.
	     */
	    var RemoteDependencyData = /** @class */ (function () {
	        function RemoteDependencyData() {
	            /**
	             * Schema version
	             */
	            this.ver = 2;
	            /**
	             * Indication of successful or unsuccessful call.
	             */
	            this.success = true;
	            /**
	             * Collection of custom properties.
	             */
	            this.properties = {};
	            /**
	             * Collection of custom measurements.
	             */
	            this.measurements = {};
	        }
	        return RemoteDependencyData;
	    }());
	
	    var RemoteDependencyData$1 = /** @class */ (function (_super) {
	        __extends(RemoteDependencyData$$1, _super);
	        /**
	         * Constructs a new instance of the RemoteDependencyData object
	         */
	        function RemoteDependencyData$$1(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
	            if (requestAPI === void 0) { requestAPI = "Ajax"; }
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                id: FieldType.Required,
	                ver: FieldType.Required,
	                name: FieldType.Default,
	                resultCode: FieldType.Default,
	                duration: FieldType.Default,
	                success: FieldType.Default,
	                data: FieldType.Default,
	                target: FieldType.Default,
	                type: FieldType.Default,
	                properties: FieldType.Default,
	                measurements: FieldType.Default,
	                kind: FieldType.Default,
	                value: FieldType.Default,
	                count: FieldType.Default,
	                min: FieldType.Default,
	                max: FieldType.Default,
	                stdDev: FieldType.Default,
	                dependencyKind: FieldType.Default,
	                dependencySource: FieldType.Default,
	                commandName: FieldType.Default,
	                dependencyTypeName: FieldType.Default
	            };
	            _this.id = id;
	            _this.duration = msToTimeSpan(value);
	            _this.success = success;
	            _this.resultCode = resultCode + "";
	            _this.type = DataSanitizer.sanitizeString(logger, requestAPI);
	            var dependencyFields = AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName);
	            _this.data = DataSanitizer.sanitizeUrl(logger, commandName) || dependencyFields.data; // get a value from hosturl if commandName not available
	            _this.target = DataSanitizer.sanitizeString(logger, dependencyFields.target);
	            if (correlationContext) {
	                _this.target = _this.target + " | " + correlationContext;
	            }
	            _this.name = DataSanitizer.sanitizeString(logger, dependencyFields.name);
	            _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
	            _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	            return _this;
	        }
	        RemoteDependencyData$$1.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
	        RemoteDependencyData$$1.dataType = "RemoteDependencyData";
	        return RemoteDependencyData$$1;
	    }(RemoteDependencyData));
	
	    /**
	     * Instances of Message represent printf-like trace statements that are text-searched. Log4Net, NLog and other text-based log file entries are translated into intances of this type. The message does not have measurements.
	     */
	    var MessageData = /** @class */ (function () {
	        function MessageData() {
	            /**
	             * Schema version
	             */
	            this.ver = 2;
	            /**
	             * Collection of custom properties.
	             */
	            this.properties = {};
	            /**
	             * Collection of custom measurements.
	             */
	            this.measurements = {};
	        }
	        return MessageData;
	    }());
	
	    var Trace = /** @class */ (function (_super) {
	        __extends(Trace, _super);
	        /**
	         * Constructs a new instance of the TraceTelemetry object
	         */
	        function Trace(logger, message, severityLevel, properties, measurements) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                ver: FieldType.Required,
	                message: FieldType.Required,
	                severityLevel: FieldType.Default,
	                properties: FieldType.Default
	            };
	            message = message || strNotSpecified;
	            _this.message = DataSanitizer.sanitizeMessage(logger, message);
	            _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
	            _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	            if (severityLevel) {
	                _this.severityLevel = severityLevel;
	            }
	            return _this;
	        }
	        Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
	        Trace.dataType = "MessageData";
	        return Trace;
	    }(MessageData));
	
	    /**
	     * An instance of PageViewPerf represents: a page view with no performance data, a page view with performance data, or just the performance data of an earlier page request.
	     */
	    var PageViewPerfData = /** @class */ (function (_super) {
	        __extends(PageViewPerfData, _super);
	        function PageViewPerfData() {
	            var _this = _super.call(this) || this;
	            /**
	             * Schema version
	             */
	            _this.ver = 2;
	            /**
	             * Collection of custom properties.
	             */
	            _this.properties = {};
	            /**
	             * Collection of custom measurements.
	             */
	            _this.measurements = {};
	            return _this;
	        }
	        return PageViewPerfData;
	    }(PageViewData));
	
	    var PageViewPerformance = /** @class */ (function (_super) {
	        __extends(PageViewPerformance, _super);
	        /**
	         * Constructs a new instance of the PageEventTelemetry object
	         */
	        function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                ver: FieldType.Required,
	                name: FieldType.Default,
	                url: FieldType.Default,
	                duration: FieldType.Default,
	                perfTotal: FieldType.Default,
	                networkConnect: FieldType.Default,
	                sentRequest: FieldType.Default,
	                receivedResponse: FieldType.Default,
	                domProcessing: FieldType.Default,
	                properties: FieldType.Default,
	                measurements: FieldType.Default
	            };
	            _this.url = DataSanitizer.sanitizeUrl(logger, url);
	            _this.name = DataSanitizer.sanitizeString(logger, name) || strNotSpecified;
	            _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
	            _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	            if (cs4BaseData) {
	                _this.domProcessing = cs4BaseData.domProcessing;
	                _this.duration = cs4BaseData.duration;
	                _this.networkConnect = cs4BaseData.networkConnect;
	                _this.perfTotal = cs4BaseData.perfTotal;
	                _this.receivedResponse = cs4BaseData.receivedResponse;
	                _this.sentRequest = cs4BaseData.sentRequest;
	            }
	            return _this;
	        }
	        PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
	        PageViewPerformance.dataType = "PageviewPerformanceData";
	        return PageViewPerformance;
	    }(PageViewPerfData));
	
	    var Data$1 = /** @class */ (function (_super) {
	        __extends(Data$$1, _super);
	        /**
	         * Constructs a new instance of telemetry data.
	         */
	        function Data$$1(baseType, data) {
	            var _this = _super.call(this) || this;
	            /**
	             * The data contract for serializing this object.
	             */
	            _this.aiDataContract = {
	                baseType: FieldType.Required,
	                baseData: FieldType.Required
	            };
	            _this.baseType = baseType;
	            _this.baseData = data;
	            return _this;
	        }
	        return Data$$1;
	    }(Data));
	
	    // THIS FILE WAS AUTOGENERATED
	    /**
	     * Defines the level of severity for the event.
	     */
	    var SeverityLevel;
	    (function (SeverityLevel) {
	        SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
	        SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
	        SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
	        SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
	        SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
	    })(SeverityLevel || (SeverityLevel = {}));
	
	    function _aiNameFunc(baseName) {
	        var aiName = "ai." + baseName + ".";
	        return function (name) {
	            return aiName + name;
	        };
	    }
	    var _aiApplication = _aiNameFunc("application");
	    var _aiDevice = _aiNameFunc("device");
	    var _aiLocation = _aiNameFunc("location");
	    var _aiOperation = _aiNameFunc("operation");
	    var _aiSession = _aiNameFunc("session");
	    var _aiUser = _aiNameFunc("user");
	    var _aiCloud = _aiNameFunc("cloud");
	    var _aiInternal = _aiNameFunc("internal");
	    var ContextTagKeys = /** @class */ (function (_super) {
	        __extends(ContextTagKeys, _super);
	        function ContextTagKeys() {
	            return _super.call(this) || this;
	        }
	        return ContextTagKeys;
	    }(createClassFromInterface({
	        applicationVersion: _aiApplication("ver"),
	        applicationBuild: _aiApplication("build"),
	        applicationTypeId: _aiApplication("typeId"),
	        applicationId: _aiApplication("applicationId"),
	        applicationLayer: _aiApplication("layer"),
	        deviceId: _aiDevice("id"),
	        deviceIp: _aiDevice("ip"),
	        deviceLanguage: _aiDevice("language"),
	        deviceLocale: _aiDevice("locale"),
	        deviceModel: _aiDevice("model"),
	        deviceFriendlyName: _aiDevice("friendlyName"),
	        deviceNetwork: _aiDevice("network"),
	        deviceNetworkName: _aiDevice("networkName"),
	        deviceOEMName: _aiDevice("oemName"),
	        deviceOS: _aiDevice("os"),
	        deviceOSVersion: _aiDevice("osVersion"),
	        deviceRoleInstance: _aiDevice("roleInstance"),
	        deviceRoleName: _aiDevice("roleName"),
	        deviceScreenResolution: _aiDevice("screenResolution"),
	        deviceType: _aiDevice("type"),
	        deviceMachineName: _aiDevice("machineName"),
	        deviceVMName: _aiDevice("vmName"),
	        deviceBrowser: _aiDevice("browser"),
	        deviceBrowserVersion: _aiDevice("browserVersion"),
	        locationIp: _aiLocation("ip"),
	        locationCountry: _aiLocation("country"),
	        locationProvince: _aiLocation("province"),
	        locationCity: _aiLocation("city"),
	        operationId: _aiOperation("id"),
	        operationName: _aiOperation("name"),
	        operationParentId: _aiOperation("parentId"),
	        operationRootId: _aiOperation("rootId"),
	        operationSyntheticSource: _aiOperation("syntheticSource"),
	        operationCorrelationVector: _aiOperation("correlationVector"),
	        sessionId: _aiSession("id"),
	        sessionIsFirst: _aiSession("isFirst"),
	        sessionIsNew: _aiSession("isNew"),
	        userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
	        userAccountId: _aiUser("accountId"),
	        userAgent: _aiUser("userAgent"),
	        userId: _aiUser("id"),
	        userStoreRegion: _aiUser("storeRegion"),
	        userAuthUserId: _aiUser("authUserId"),
	        userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
	        userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
	        cloudName: _aiCloud("name"),
	        cloudRole: _aiCloud("role"),
	        cloudRoleVer: _aiCloud("roleVer"),
	        cloudRoleInstance: _aiCloud("roleInstance"),
	        cloudEnvironment: _aiCloud("environment"),
	        cloudLocation: _aiCloud("location"),
	        cloudDeploymentUnit: _aiCloud("deploymentUnit"),
	        internalNodeName: _aiInternal("nodeName"),
	        internalSdkVersion: _aiInternal("sdkVersion"),
	        internalAgentVersion: _aiInternal("agentVersion"),
	        internalSnippet: _aiInternal("snippet"),
	        internalSdkSrc: _aiInternal("sdkSrc")
	    })));
	
	    var CtxTagKeys = new ContextTagKeys();
	
	    var AppInsightsErrorBoundary = /** @class */ (function (_super) {
	        __extends(AppInsightsErrorBoundary, _super);
	        function AppInsightsErrorBoundary() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this.state = { hasError: false };
	            return _this;
	        }
	        AppInsightsErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
	            this.setState({ hasError: true });
	            this.props.appInsights.trackException({
	                error: error,
	                exception: error,
	                severityLevel: SeverityLevel.Error,
	                properties: errorInfo
	            });
	        };
	        AppInsightsErrorBoundary.prototype.render = function () {
	            if (this.state.hasError) {
	                var onError = this.props.onError;
	                return react.createElement(onError);
	            }
	            return this.props.children;
	        };
	        return AppInsightsErrorBoundary;
	    }(react.Component));
	
	    var AppInsightsContext = react_5(undefined);
	    var useAppInsightsContext = function () { return react_6(AppInsightsContext); };
	
	    /**
	     * ReactPlugin.ts
	     * @copyright Microsoft 2019
	     */
	    function useCustomEvent(reactPlugin, eventName, eventData, skipFirstRun) {
	        if (skipFirstRun === void 0) { skipFirstRun = true; }
	        var _a = react_7(eventData), data = _a[0], setData = _a[1];
	        var firstRun = react_9(skipFirstRun);
	        react_8(function () {
	            if (firstRun.current) {
	                firstRun.current = false;
	                return;
	            }
	            reactPlugin.trackEvent({ name: eventName }, data);
	        }, [reactPlugin, data, eventName]);
	        return setData;
	    }
	
	    function getEngagementTimeSeconds(trackedData) {
	        return ((CoreUtils.dateNow() -
	            trackedData.firstActiveTimestamp -
	            trackedData.totalIdleTime -
	            trackedData.idleCount * trackedData.idleTimeout) /
	            1000);
	    }
	    var useComponentTracking = function (reactPlugin, componentName) {
	        var tracking = react_9({
	            hookTimestamp: CoreUtils.dateNow(),
	            firstActiveTimestamp: 0,
	            totalIdleTime: 0,
	            lastActiveTimestamp: 0,
	            idleStartTimestamp: 0,
	            idleCount: 0,
	            idleTimeout: 5000
	        });
	        var savedCallback = react_9();
	        var callback = function () {
	            var trackedData = tracking.current;
	            if (trackedData.lastActiveTimestamp > 0 &&
	                trackedData.idleStartTimestamp === 0 &&
	                CoreUtils.dateNow() - trackedData.lastActiveTimestamp >= trackedData.idleTimeout) {
	                trackedData.idleStartTimestamp = CoreUtils.dateNow();
	                trackedData.idleCount++;
	            }
	        };
	        var delay = 100;
	        savedCallback.current = callback;
	        // Set up the interval.
	        react_8(function () {
	            var id = setInterval(savedCallback.current, delay);
	            return function () {
	                clearInterval(id);
	                var trackedData = tracking.current;
	                if (trackedData.hookTimestamp === 0) {
	                    throw new Error("useAppInsights:unload hook: hookTimestamp is not initialized.");
	                }
	                if (trackedData.firstActiveTimestamp === 0) {
	                    return;
	                }
	                var engagementTime = getEngagementTimeSeconds(trackedData);
	                var metricData = {
	                    average: engagementTime,
	                    name: "React Component Engaged Time (seconds)",
	                    sampleCount: 1
	                };
	                var additionalProperties = { "Component Name": componentName };
	                reactPlugin.trackMetric(metricData, additionalProperties);
	            };
	        }, []);
	        var trackActivity = function () {
	            var trackedData = tracking.current;
	            if (trackedData.firstActiveTimestamp === 0) {
	                trackedData.firstActiveTimestamp = CoreUtils.dateNow();
	                trackedData.lastActiveTimestamp = trackedData.firstActiveTimestamp;
	            }
	            else {
	                trackedData.lastActiveTimestamp = CoreUtils.dateNow();
	            }
	            if (trackedData.idleStartTimestamp > 0) {
	                var lastIdleTime = trackedData.lastActiveTimestamp - trackedData.idleStartTimestamp;
	                trackedData.totalIdleTime += lastIdleTime;
	                trackedData.idleStartTimestamp = 0;
	            }
	        };
	        return trackActivity;
	    };
	
	    exports.ReactPlugin = ReactPlugin;
	    exports.withAITracking = withAITracking;
	    exports.AppInsightsErrorBoundary = AppInsightsErrorBoundary;
	    exports.AppInsightsContext = AppInsightsContext;
	    exports.useAppInsightsContext = useAppInsightsContext;
	    exports.useTrackEvent = useCustomEvent;
	    exports.useTrackMetric = useComponentTracking;
	
	    (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=applicationinsights-react-js.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * Application Insights JavaScript SDK - Web, 2.6.1
	 * Copyright (c) Microsoft and contributors. All rights reserved.
	 */
	(function (global, factory) {
	     true ? factory(exports) :
	    typeof define === 'function' && define.amd ? define(['exports'], factory) :
	    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global.Microsoft = global.Microsoft || {}, global.Microsoft.ApplicationInsights = global.Microsoft.ApplicationInsights || {})));
	}(this, (function (exports) { 'use strict';
	
	    var strShimFunction = "function";
	    var strShimObject = "object";
	    var strShimUndefined = "undefined";
	    var strShimPrototype = "prototype";
	    var strShimHasOwnProperty = "hasOwnProperty";
	    function getGlobal$1() {
	        if (typeof globalThis !== strShimUndefined && globalThis) {
	            return globalThis;
	        }
	        if (typeof self !== strShimUndefined && self) {
	            return self;
	        }
	        if (typeof window !== strShimUndefined && window) {
	            return window;
	        }
	        if (typeof global !== strShimUndefined && global) {
	            return global;
	        }
	        return null;
	    }
	    function objCreateFn(obj) {
	        var func = Object["create"];
	        if (func) {
	            return func(obj);
	        }
	        if (obj == null) {
	            return {};
	        }
	        var type = typeof obj;
	        if (type !== strShimObject && type !== strShimFunction) {
	            throw new TypeError('Object prototype may only be an Object:' + obj);
	        }
	        function tmpFunc() { }
	        tmpFunc[strShimPrototype] = obj;
	        return new tmpFunc();
	    }
	    function __assignFn(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) {
	                if (Object[strShimPrototype][strShimHasOwnProperty].call(s, p)) {
	                    t[p] = s[p];
	                }
	            }
	        }
	        return t;
	    }
	    var __extendStaticsFn = function (d, b) {
	        __extendStaticsFn = Object["setPrototypeOf"] ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) {
	                for (var p in b) {
	                    if (b[strShimHasOwnProperty](p)) {
	                        d[p] = b[p];
	                    }
	                }
	            };
	        return __extendStaticsFn(d, b);
	    };
	    function __extendsFn(d, b) {
	        __extendStaticsFn(d, b);
	        function __() { this.constructor = d; }
	        d[strShimPrototype] = b === null ? objCreateFn(b) : (__[strShimPrototype] = b[strShimPrototype], new __());
	    }
	    var globalObj = getGlobal$1() || {};
	    (function (root, assignFn, extendsFn) {
	        if (!root.__assign) {
	            root.__assign = Object.assign || assignFn;
	        }
	        if (!root.__extends) {
	            root.__extends = extendsFn;
	        }
	    })(globalObj, __assignFn, __extendsFn);
	    if (!__assign) {
	        __assign = globalObj.__assign;
	    }
	    if (!__extends) {
	        __extends = globalObj.__extends;
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var EventsDiscardedReason = {
	        Unknown: 0,
	        NonRetryableStatus: 1,
	        InvalidEvent: 2,
	        SizeLimitExceeded: 3,
	        KillSwitch: 4,
	        QueueFull: 5
	    };
	
	    /*!
	     * Microsoft Dynamic Proto Utility, 1.1.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var Constructor = 'constructor';
	    var Prototype = 'prototype';
	    var strFunction$1 = 'function';
	    var DynInstFuncTable = '_dynInstFuncs';
	    var DynProxyTag = '_isDynProxy';
	    var DynClassName = '_dynClass';
	    var DynClassNamePrefix = '_dynCls$';
	    var DynInstChkTag = '_dynInstChk';
	    var DynAllowInstChkTag = DynInstChkTag;
	    var DynProtoDefaultOptions = '_dfOpts';
	    var UnknownValue = '_unknown_';
	    var str__Proto$1 = "__proto__";
	    var strUseBaseInst = 'useBaseInst';
	    var strSetInstFuncs = 'setInstFuncs';
	    var Obj = Object;
	    var _objGetPrototypeOf$1 = Obj["getPrototypeOf"];
	    var _dynamicNames = 0;
	    function _hasOwnProperty(obj, prop) {
	        return obj && Obj[Prototype].hasOwnProperty.call(obj, prop);
	    }
	    function _isObjectOrArrayPrototype(target) {
	        return target && (target === Obj[Prototype] || target === Array[Prototype]);
	    }
	    function _isObjectArrayOrFunctionPrototype(target) {
	        return _isObjectOrArrayPrototype(target) || target === Function[Prototype];
	    }
	    function _getObjProto$1(target) {
	        if (target) {
	            if (_objGetPrototypeOf$1) {
	                return _objGetPrototypeOf$1(target);
	            }
	            var newProto = target[str__Proto$1] || target[Prototype] || target[Constructor];
	            if (newProto) {
	                return newProto;
	            }
	        }
	        return null;
	    }
	    function _forEachProp(target, func) {
	        var props = [];
	        var getOwnProps = Obj["getOwnPropertyNames"];
	        if (getOwnProps) {
	            props = getOwnProps(target);
	        }
	        else {
	            for (var name_1 in target) {
	                if (typeof name_1 === "string" && _hasOwnProperty(target, name_1)) {
	                    props.push(name_1);
	                }
	            }
	        }
	        if (props && props.length > 0) {
	            for (var lp = 0; lp < props.length; lp++) {
	                func(props[lp]);
	            }
	        }
	    }
	    function _isDynamicCandidate(target, funcName, skipOwn) {
	        return (funcName !== Constructor && typeof target[funcName] === strFunction$1 && (skipOwn || _hasOwnProperty(target, funcName)));
	    }
	    function _throwTypeError(message) {
	        throw new TypeError("DynamicProto: " + message);
	    }
	    function _getInstanceFuncs(thisTarget) {
	        var instFuncs = {};
	        _forEachProp(thisTarget, function (name) {
	            if (!instFuncs[name] && _isDynamicCandidate(thisTarget, name, false)) {
	                instFuncs[name] = thisTarget[name];
	            }
	        });
	        return instFuncs;
	    }
	    function _hasVisited(values, value) {
	        for (var lp = values.length - 1; lp >= 0; lp--) {
	            if (values[lp] === value) {
	                return true;
	            }
	        }
	        return false;
	    }
	    function _getBaseFuncs(classProto, thisTarget, instFuncs, useBaseInst) {
	        function _instFuncProxy(target, funcHost, funcName) {
	            var theFunc = funcHost[funcName];
	            if (theFunc[DynProxyTag] && useBaseInst) {
	                var instFuncTable = target[DynInstFuncTable] || {};
	                if (instFuncTable[DynAllowInstChkTag] !== false) {
	                    theFunc = (instFuncTable[funcHost[DynClassName]] || {})[funcName] || theFunc;
	                }
	            }
	            return function () {
	                return theFunc.apply(target, arguments);
	            };
	        }
	        var baseFuncs = {};
	        _forEachProp(instFuncs, function (name) {
	            baseFuncs[name] = _instFuncProxy(thisTarget, instFuncs, name);
	        });
	        var baseProto = _getObjProto$1(classProto);
	        var visited = [];
	        while (baseProto && !_isObjectArrayOrFunctionPrototype(baseProto) && !_hasVisited(visited, baseProto)) {
	            _forEachProp(baseProto, function (name) {
	                if (!baseFuncs[name] && _isDynamicCandidate(baseProto, name, !_objGetPrototypeOf$1)) {
	                    baseFuncs[name] = _instFuncProxy(thisTarget, baseProto, name);
	                }
	            });
	            visited.push(baseProto);
	            baseProto = _getObjProto$1(baseProto);
	        }
	        return baseFuncs;
	    }
	    function _getInstFunc(target, funcName, proto, currentDynProtoProxy) {
	        var instFunc = null;
	        if (target && _hasOwnProperty(proto, DynClassName)) {
	            var instFuncTable = target[DynInstFuncTable] || {};
	            instFunc = (instFuncTable[proto[DynClassName]] || {})[funcName];
	            if (!instFunc) {
	                _throwTypeError("Missing [" + funcName + "] " + strFunction$1);
	            }
	            if (!instFunc[DynInstChkTag] && instFuncTable[DynAllowInstChkTag] !== false) {
	                var canAddInst = !_hasOwnProperty(target, funcName);
	                var objProto = _getObjProto$1(target);
	                var visited = [];
	                while (canAddInst && objProto && !_isObjectArrayOrFunctionPrototype(objProto) && !_hasVisited(visited, objProto)) {
	                    var protoFunc = objProto[funcName];
	                    if (protoFunc) {
	                        canAddInst = (protoFunc === currentDynProtoProxy);
	                        break;
	                    }
	                    visited.push(objProto);
	                    objProto = _getObjProto$1(objProto);
	                }
	                try {
	                    if (canAddInst) {
	                        target[funcName] = instFunc;
	                    }
	                    instFunc[DynInstChkTag] = 1;
	                }
	                catch (e) {
	                    instFuncTable[DynAllowInstChkTag] = false;
	                }
	            }
	        }
	        return instFunc;
	    }
	    function _getProtoFunc(funcName, proto, currentDynProtoProxy) {
	        var protoFunc = proto[funcName];
	        if (protoFunc === currentDynProtoProxy) {
	            protoFunc = _getObjProto$1(proto)[funcName];
	        }
	        if (typeof protoFunc !== strFunction$1) {
	            _throwTypeError("[" + funcName + "] is not a " + strFunction$1);
	        }
	        return protoFunc;
	    }
	    function _populatePrototype(proto, className, target, baseInstFuncs, setInstanceFunc) {
	        function _createDynamicPrototype(proto, funcName) {
	            var dynProtoProxy = function () {
	                var instFunc = _getInstFunc(this, funcName, proto, dynProtoProxy) || _getProtoFunc(funcName, proto, dynProtoProxy);
	                return instFunc.apply(this, arguments);
	            };
	            dynProtoProxy[DynProxyTag] = 1;
	            return dynProtoProxy;
	        }
	        if (!_isObjectOrArrayPrototype(proto)) {
	            var instFuncTable = target[DynInstFuncTable] = target[DynInstFuncTable] || {};
	            var instFuncs_1 = instFuncTable[className] = (instFuncTable[className] || {});
	            if (instFuncTable[DynAllowInstChkTag] !== false) {
	                instFuncTable[DynAllowInstChkTag] = !!setInstanceFunc;
	            }
	            _forEachProp(target, function (name) {
	                if (_isDynamicCandidate(target, name, false) && target[name] !== baseInstFuncs[name]) {
	                    instFuncs_1[name] = target[name];
	                    delete target[name];
	                    if (!_hasOwnProperty(proto, name) || (proto[name] && !proto[name][DynProxyTag])) {
	                        proto[name] = _createDynamicPrototype(proto, name);
	                    }
	                }
	            });
	        }
	    }
	    function _checkPrototype(classProto, thisTarget) {
	        var thisProto = _getObjProto$1(thisTarget);
	        while (thisProto && !_isObjectArrayOrFunctionPrototype(thisProto)) {
	            if (thisProto === classProto) {
	                return true;
	            }
	            thisProto = _getObjProto$1(thisProto);
	        }
	        return false;
	    }
	    function _getObjName(target, unknownValue) {
	        if (_hasOwnProperty(target, Prototype)) {
	            return target.name || unknownValue || UnknownValue;
	        }
	        return (((target || {})[Constructor]) || {}).name || unknownValue || UnknownValue;
	    }
	    function dynamicProto(theClass, target, delegateFunc, options) {
	        if (!_hasOwnProperty(theClass, Prototype)) {
	            _throwTypeError("theClass is an invalid class definition.");
	        }
	        var classProto = theClass[Prototype];
	        if (!_checkPrototype(classProto, target)) {
	            _throwTypeError("[" + _getObjName(theClass) + "] is not in class hierarchy of [" + _getObjName(target) + "]");
	        }
	        var className = null;
	        if (_hasOwnProperty(classProto, DynClassName)) {
	            className = classProto[DynClassName];
	        }
	        else {
	            className = DynClassNamePrefix + _getObjName(theClass, "_") + "$" + _dynamicNames;
	            _dynamicNames++;
	            classProto[DynClassName] = className;
	        }
	        var perfOptions = dynamicProto[DynProtoDefaultOptions];
	        var useBaseInst = !!perfOptions[strUseBaseInst];
	        if (useBaseInst && options && options[strUseBaseInst] !== undefined) {
	            useBaseInst = !!options[strUseBaseInst];
	        }
	        var instFuncs = _getInstanceFuncs(target);
	        var baseFuncs = _getBaseFuncs(classProto, target, instFuncs, useBaseInst);
	        delegateFunc(target, baseFuncs);
	        var setInstanceFunc = !!_objGetPrototypeOf$1 && !!perfOptions[strSetInstFuncs];
	        if (setInstanceFunc && options) {
	            setInstanceFunc = !!options[strSetInstFuncs];
	        }
	        _populatePrototype(classProto, className, target, instFuncs, setInstanceFunc !== false);
	    }
	    var perfDefaults = {
	        setInstFuncs: true,
	        useBaseInst: true
	    };
	    dynamicProto[DynProtoDefaultOptions] = perfDefaults;
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    exports.LoggingSeverity = void 0;
	    (function (LoggingSeverity) {
	        LoggingSeverity[LoggingSeverity["CRITICAL"] = 1] = "CRITICAL";
	        LoggingSeverity[LoggingSeverity["WARNING"] = 2] = "WARNING";
	    })(exports.LoggingSeverity || (exports.LoggingSeverity = {}));
	    var _InternalMessageId = {
	        BrowserDoesNotSupportLocalStorage: 0,
	        BrowserCannotReadLocalStorage: 1,
	        BrowserCannotReadSessionStorage: 2,
	        BrowserCannotWriteLocalStorage: 3,
	        BrowserCannotWriteSessionStorage: 4,
	        BrowserFailedRemovalFromLocalStorage: 5,
	        BrowserFailedRemovalFromSessionStorage: 6,
	        CannotSendEmptyTelemetry: 7,
	        ClientPerformanceMathError: 8,
	        ErrorParsingAISessionCookie: 9,
	        ErrorPVCalc: 10,
	        ExceptionWhileLoggingError: 11,
	        FailedAddingTelemetryToBuffer: 12,
	        FailedMonitorAjaxAbort: 13,
	        FailedMonitorAjaxDur: 14,
	        FailedMonitorAjaxOpen: 15,
	        FailedMonitorAjaxRSC: 16,
	        FailedMonitorAjaxSend: 17,
	        FailedMonitorAjaxGetCorrelationHeader: 18,
	        FailedToAddHandlerForOnBeforeUnload: 19,
	        FailedToSendQueuedTelemetry: 20,
	        FailedToReportDataLoss: 21,
	        FlushFailed: 22,
	        MessageLimitPerPVExceeded: 23,
	        MissingRequiredFieldSpecification: 24,
	        NavigationTimingNotSupported: 25,
	        OnError: 26,
	        SessionRenewalDateIsZero: 27,
	        SenderNotInitialized: 28,
	        StartTrackEventFailed: 29,
	        StopTrackEventFailed: 30,
	        StartTrackFailed: 31,
	        StopTrackFailed: 32,
	        TelemetrySampledAndNotSent: 33,
	        TrackEventFailed: 34,
	        TrackExceptionFailed: 35,
	        TrackMetricFailed: 36,
	        TrackPVFailed: 37,
	        TrackPVFailedCalc: 38,
	        TrackTraceFailed: 39,
	        TransmissionFailed: 40,
	        FailedToSetStorageBuffer: 41,
	        FailedToRestoreStorageBuffer: 42,
	        InvalidBackendResponse: 43,
	        FailedToFixDepricatedValues: 44,
	        InvalidDurationValue: 45,
	        TelemetryEnvelopeInvalid: 46,
	        CreateEnvelopeError: 47,
	        CannotSerializeObject: 48,
	        CannotSerializeObjectNonSerializable: 49,
	        CircularReferenceDetected: 50,
	        ClearAuthContextFailed: 51,
	        ExceptionTruncated: 52,
	        IllegalCharsInName: 53,
	        ItemNotInArray: 54,
	        MaxAjaxPerPVExceeded: 55,
	        MessageTruncated: 56,
	        NameTooLong: 57,
	        SampleRateOutOfRange: 58,
	        SetAuthContextFailed: 59,
	        SetAuthContextFailedAccountName: 60,
	        StringValueTooLong: 61,
	        StartCalledMoreThanOnce: 62,
	        StopCalledWithoutStart: 63,
	        TelemetryInitializerFailed: 64,
	        TrackArgumentsNotSpecified: 65,
	        UrlTooLong: 66,
	        SessionStorageBufferFull: 67,
	        CannotAccessCookie: 68,
	        IdTooLong: 69,
	        InvalidEvent: 70,
	        FailedMonitorAjaxSetRequestHeader: 71,
	        SendBrowserInfoOnUserInit: 72,
	        PluginException: 73,
	        NotificationException: 74,
	        SnippetScriptLoadFailure: 99,
	        InvalidInstrumentationKey: 100,
	        CannotParseAiBlobValue: 101,
	        InvalidContentBlob: 102,
	        TrackPageActionEventFailed: 103
	    };
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var strOnPrefix = "on";
	    var strAttachEvent = "attachEvent";
	    var strAddEventHelper = "addEventListener";
	    var strDetachEvent = "detachEvent";
	    var strRemoveEventListener = "removeEventListener";
	    var strHasOwnProperty = "hasOwnProperty";
	    var ObjClass = Object;
	    var ObjProto = ObjClass[strShimPrototype];
	    var _objHasOwnProperty = ObjProto[strHasOwnProperty];
	    var _objDefineProperty = ObjClass["defineProperty"];
	    var _objAssign = ObjClass["assign"];
	    function objToString(obj) {
	        return ObjProto.toString.call(obj);
	    }
	    function isTypeof(value, theType) {
	        return typeof value === theType;
	    }
	    function isUndefined(value) {
	        return value === undefined || typeof value === strShimUndefined;
	    }
	    function isNullOrUndefined(value) {
	        return (value === null || isUndefined(value));
	    }
	    function isNotNullOrUndefined(value) {
	        return !isNullOrUndefined(value);
	    }
	    function hasOwnProperty(obj, prop) {
	        return obj && _objHasOwnProperty.call(obj, prop);
	    }
	    function isObject(value) {
	        return typeof value === strShimObject;
	    }
	    function isFunction(value) {
	        return typeof value === strShimFunction;
	    }
	    function attachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
	        if (useCapture === void 0) { useCapture = false; }
	        var result = false;
	        if (!isNullOrUndefined(obj)) {
	            try {
	                if (!isNullOrUndefined(obj[strAddEventHelper])) {
	                    obj[strAddEventHelper](eventNameWithoutOn, handlerRef, useCapture);
	                    result = true;
	                }
	                else if (!isNullOrUndefined(obj[strAttachEvent])) {
	                    obj[strAttachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
	                    result = true;
	                }
	            }
	            catch (e) {
	            }
	        }
	        return result;
	    }
	    function detachEvent(obj, eventNameWithoutOn, handlerRef, useCapture) {
	        if (useCapture === void 0) { useCapture = false; }
	        if (!isNullOrUndefined(obj)) {
	            try {
	                if (!isNullOrUndefined(obj[strRemoveEventListener])) {
	                    obj[strRemoveEventListener](eventNameWithoutOn, handlerRef, useCapture);
	                }
	                else if (!isNullOrUndefined(obj[strDetachEvent])) {
	                    obj[strDetachEvent](strOnPrefix + eventNameWithoutOn, handlerRef);
	                }
	            }
	            catch (e) {
	            }
	        }
	    }
	    function normalizeJsName(name) {
	        var value = name;
	        var match = /([^\w\d_$])/g;
	        if (match.test(name)) {
	            value = name.replace(match, "_");
	        }
	        return value;
	    }
	    function objForEachKey(target, callbackfn) {
	        if (target) {
	            for (var prop in target) {
	                if (_objHasOwnProperty.call(target, prop)) {
	                    callbackfn.call(target, prop, target[prop]);
	                }
	            }
	        }
	    }
	    function strEndsWith(value, search) {
	        if (value && search) {
	            var searchLen = search.length;
	            var valLen = value.length;
	            if (value === search) {
	                return true;
	            }
	            else if (valLen >= searchLen) {
	                var pos = valLen - 1;
	                for (var lp = searchLen - 1; lp >= 0; lp--) {
	                    if (value[pos] != search[lp]) {
	                        return false;
	                    }
	                    pos--;
	                }
	                return true;
	            }
	        }
	        return false;
	    }
	    function strContains(value, search) {
	        if (value && search) {
	            return value.indexOf(search) !== -1;
	        }
	        return false;
	    }
	    function isDate(obj) {
	        return objToString(obj) === "[object Date]";
	    }
	    function isArray(obj) {
	        return objToString(obj) === "[object Array]";
	    }
	    function isError(obj) {
	        return objToString(obj) === "[object Error]";
	    }
	    function isString(value) {
	        return typeof value === "string";
	    }
	    function isNumber(value) {
	        return typeof value === "number";
	    }
	    function isBoolean(value) {
	        return typeof value === "boolean";
	    }
	    function toISOString(date) {
	        if (isDate(date)) {
	            var pad = function (num) {
	                var r = String(num);
	                if (r.length === 1) {
	                    r = "0" + r;
	                }
	                return r;
	            };
	            return date.getUTCFullYear()
	                + "-" + pad(date.getUTCMonth() + 1)
	                + "-" + pad(date.getUTCDate())
	                + "T" + pad(date.getUTCHours())
	                + ":" + pad(date.getUTCMinutes())
	                + ":" + pad(date.getUTCSeconds())
	                + "." + String((date.getUTCMilliseconds() / 1000).toFixed(3)).slice(2, 5)
	                + "Z";
	        }
	    }
	    function arrForEach(arr, callbackfn, thisArg) {
	        var len = arr.length;
	        for (var idx = 0; idx < len; idx++) {
	            if (idx in arr) {
	                if (callbackfn.call(thisArg || arr, arr[idx], idx, arr) === -1) {
	                    break;
	                }
	            }
	        }
	    }
	    function arrIndexOf(arr, searchElement, fromIndex) {
	        var len = arr.length;
	        var from = fromIndex || 0;
	        for (var lp = Math.max(from >= 0 ? from : len - Math.abs(from), 0); lp < len; lp++) {
	            if (lp in arr && arr[lp] === searchElement) {
	                return lp;
	            }
	        }
	        return -1;
	    }
	    function arrMap(arr, callbackfn, thisArg) {
	        var len = arr.length;
	        var _this = thisArg || arr;
	        var results = new Array(len);
	        for (var lp = 0; lp < len; lp++) {
	            if (lp in arr) {
	                results[lp] = callbackfn.call(_this, arr[lp], arr);
	            }
	        }
	        return results;
	    }
	    function arrReduce(arr, callbackfn, initialValue) {
	        var len = arr.length;
	        var lp = 0;
	        var value;
	        if (arguments.length >= 3) {
	            value = arguments[2];
	        }
	        else {
	            while (lp < len && !(lp in arr)) {
	                lp++;
	            }
	            value = arr[lp++];
	        }
	        while (lp < len) {
	            if (lp in arr) {
	                value = callbackfn(value, arr[lp], lp, arr);
	            }
	            lp++;
	        }
	        return value;
	    }
	    function strTrim(str) {
	        if (typeof str !== "string") {
	            return str;
	        }
	        return str.replace(/^\s+|\s+$/g, "");
	    }
	    var _objKeysHasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString');
	    var _objKeysDontEnums = [
	        'toString',
	        'toLocaleString',
	        'valueOf',
	        'hasOwnProperty',
	        'isPrototypeOf',
	        'propertyIsEnumerable',
	        'constructor'
	    ];
	    function objKeys(obj) {
	        var objType = typeof obj;
	        if (objType !== strShimFunction && (objType !== strShimObject || obj === null)) {
	            throw new TypeError('objKeys called on non-object');
	        }
	        var result = [];
	        for (var prop in obj) {
	            if (obj && _objHasOwnProperty.call(obj, prop)) {
	                result.push(prop);
	            }
	        }
	        if (_objKeysHasDontEnumBug) {
	            var dontEnumsLength = _objKeysDontEnums.length;
	            for (var lp = 0; lp < dontEnumsLength; lp++) {
	                if (obj && _objHasOwnProperty.call(obj, _objKeysDontEnums[lp])) {
	                    result.push(_objKeysDontEnums[lp]);
	                }
	            }
	        }
	        return result;
	    }
	    function objDefineAccessors(target, prop, getProp, setProp) {
	        if (_objDefineProperty) {
	            try {
	                var descriptor = {
	                    enumerable: true,
	                    configurable: true
	                };
	                if (getProp) {
	                    descriptor.get = getProp;
	                }
	                if (setProp) {
	                    descriptor.set = setProp;
	                }
	                _objDefineProperty(target, prop, descriptor);
	                return true;
	            }
	            catch (e) {
	            }
	        }
	        return false;
	    }
	    function dateNow() {
	        var dt = Date;
	        if (dt.now) {
	            return dt.now();
	        }
	        return new dt().getTime();
	    }
	    function getExceptionName(object) {
	        if (isError(object)) {
	            return object.name;
	        }
	        return "";
	    }
	    function setValue(target, field, value, valChk, srcChk) {
	        var theValue = value;
	        if (target) {
	            theValue = target[field];
	            if (theValue !== value && (!srcChk || srcChk(theValue)) && (!valChk || valChk(value))) {
	                theValue = value;
	                target[field] = theValue;
	            }
	        }
	        return theValue;
	    }
	    function getSetValue(target, field, defValue) {
	        var theValue;
	        if (target) {
	            theValue = target[field];
	            if (!theValue && isNullOrUndefined(theValue)) {
	                theValue = !isUndefined(defValue) ? defValue : {};
	                target[field] = theValue;
	            }
	        }
	        else {
	            theValue = !isUndefined(defValue) ? defValue : {};
	        }
	        return theValue;
	    }
	    function isNotTruthy(value) {
	        return !value;
	    }
	    function isTruthy(value) {
	        return !!value;
	    }
	    function throwError(message) {
	        throw new Error(message);
	    }
	    function proxyAssign(target, source, chkSet) {
	        if (target && source && target !== source && isObject(target) && isObject(source)) {
	            var _loop_1 = function (field) {
	                if (isString(field)) {
	                    var value = source[field];
	                    if (isFunction(value)) {
	                        if (!chkSet || chkSet(field, true, source, target)) {
	                            target[field] = (function (funcName) {
	                                return function () {
	                                    var originalArguments = arguments;
	                                    return source[funcName].apply(source, originalArguments);
	                                };
	                            })(field);
	                        }
	                    }
	                    else if (!chkSet || chkSet(field, false, source, target)) {
	                        if (hasOwnProperty(target, field)) {
	                            delete target[field];
	                        }
	                        if (!objDefineAccessors(target, field, function () {
	                            return source[field];
	                        }, function (theValue) {
	                            source[field] = theValue;
	                        })) {
	                            target[field] = value;
	                        }
	                    }
	                }
	            };
	            for (var field in source) {
	                _loop_1(field);
	            }
	        }
	        return target;
	    }
	    function createClassFromInterface(defaults) {
	        return /** @class */ (function () {
	            function class_1() {
	                var _this = this;
	                if (defaults) {
	                    objForEachKey(defaults, function (field, value) {
	                        _this[field] = value;
	                    });
	                }
	            }
	            return class_1;
	        }());
	    }
	    function optimizeObject(theObject) {
	        if (theObject) {
	            theObject = ObjClass(_objAssign ? _objAssign({}, theObject) : theObject);
	        }
	        return theObject;
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var strUndefined = strShimUndefined;
	    var strObject = strShimObject;
	    var strPrototype = strShimPrototype;
	    var strFunction = strShimFunction;
	    var strWindow = "window";
	    var strDocument = "document";
	    var strNavigator = "navigator";
	    var strHistory = "history";
	    var strLocation = "location";
	    var strConsole = "console";
	    var strPerformance = "performance";
	    var strJSON = "JSON";
	    var strCrypto = "crypto";
	    var strMsCrypto = "msCrypto";
	    var strReactNative = "ReactNative";
	    var strMsie = "msie";
	    var strTrident = "trident/";
	    var _isTrident = null;
	    var _navUserAgentCheck = null;
	    var _enableMocks = false;
	    var getGlobal = getGlobal$1;
	    function getGlobalInst(name) {
	        var gbl = getGlobal();
	        if (gbl && gbl[name]) {
	            return gbl[name];
	        }
	        if (name === strWindow && hasWindow()) {
	            return window;
	        }
	        return null;
	    }
	    function hasWindow() {
	        return Boolean(typeof window === strObject && window);
	    }
	    function getWindow() {
	        if (hasWindow()) {
	            return window;
	        }
	        return getGlobalInst(strWindow);
	    }
	    function hasDocument() {
	        return Boolean(typeof document === strObject && document);
	    }
	    function getDocument() {
	        if (hasDocument()) {
	            return document;
	        }
	        return getGlobalInst(strDocument);
	    }
	    function hasNavigator() {
	        return Boolean(typeof navigator === strObject && navigator);
	    }
	    function getNavigator() {
	        if (hasNavigator()) {
	            return navigator;
	        }
	        return getGlobalInst(strNavigator);
	    }
	    function hasHistory() {
	        return Boolean(typeof history === strObject && history);
	    }
	    function getHistory() {
	        if (hasHistory()) {
	            return history;
	        }
	        return getGlobalInst(strHistory);
	    }
	    function getLocation(checkForMock) {
	        if (checkForMock && _enableMocks) {
	            var mockLocation = getGlobalInst("__mockLocation");
	            if (mockLocation) {
	                return mockLocation;
	            }
	        }
	        if (typeof location === strObject && location) {
	            return location;
	        }
	        return getGlobalInst(strLocation);
	    }
	    function getConsole() {
	        if (typeof console !== strUndefined) {
	            return console;
	        }
	        return getGlobalInst(strConsole);
	    }
	    function getPerformance() {
	        return getGlobalInst(strPerformance);
	    }
	    function hasJSON() {
	        return Boolean((typeof JSON === strObject && JSON) || getGlobalInst(strJSON) !== null);
	    }
	    function getJSON() {
	        if (hasJSON()) {
	            return JSON || getGlobalInst(strJSON);
	        }
	        return null;
	    }
	    function getCrypto() {
	        return getGlobalInst(strCrypto);
	    }
	    function getMsCrypto() {
	        return getGlobalInst(strMsCrypto);
	    }
	    function isReactNative() {
	        var nav = getNavigator();
	        if (nav && nav.product) {
	            return nav.product === strReactNative;
	        }
	        return false;
	    }
	    function isIE() {
	        var nav = getNavigator();
	        if (nav && (nav.userAgent !== _navUserAgentCheck || _isTrident === null)) {
	            _navUserAgentCheck = nav.userAgent;
	            var userAgent = (_navUserAgentCheck || "").toLowerCase();
	            _isTrident = (strContains(userAgent, strMsie) || strContains(userAgent, strTrident));
	        }
	        return _isTrident;
	    }
	    function getIEVersion(userAgentStr) {
	        if (userAgentStr === void 0) { userAgentStr = null; }
	        var myNav = userAgentStr ? userAgentStr.toLowerCase() : "";
	        if (!userAgentStr) {
	            var navigator_1 = getNavigator() || {};
	            myNav = navigator_1 ? (navigator_1.userAgent || "").toLowerCase() : "";
	        }
	        if (strContains(myNav, strMsie)) {
	            return parseInt(myNav.split(strMsie)[1]);
	        }
	        else if (strContains(myNav, strTrident)) {
	            var tridentVer = parseInt(myNav.split(strTrident)[1]);
	            if (tridentVer) {
	                return tridentVer + 4;
	            }
	        }
	        return null;
	    }
	    function dumpObj(object) {
	        var objectTypeDump = Object[strShimPrototype].toString.call(object);
	        var propertyValueDump = "";
	        if (objectTypeDump === "[object Error]") {
	            propertyValueDump = "{ stack: '" + object.stack + "', message: '" + object.message + "', name: '" + object.name + "'";
	        }
	        else if (hasJSON()) {
	            propertyValueDump = getJSON().stringify(object);
	        }
	        return objectTypeDump + propertyValueDump;
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var AiNonUserActionablePrefix = "AI (Internal): ";
	    var AiUserActionablePrefix = "AI: ";
	    var AIInternalMessagePrefix = "AITR_";
	    function _sanitizeDiagnosticText(text) {
	        if (text) {
	            return "\"" + text.replace(/\"/g, "") + "\"";
	        }
	        return "";
	    }
	    var _InternalLogMessage = /** @class */ (function () {
	        function _InternalLogMessage(msgId, msg, isUserAct, properties) {
	            if (isUserAct === void 0) { isUserAct = false; }
	            var _self = this;
	            _self.messageId = msgId;
	            _self.message =
	                (isUserAct ? AiUserActionablePrefix : AiNonUserActionablePrefix) +
	                    msgId;
	            var strProps = "";
	            if (hasJSON()) {
	                strProps = getJSON().stringify(properties);
	            }
	            var diagnosticText = (msg ? " message:" + _sanitizeDiagnosticText(msg) : "") +
	                (properties ? " props:" + _sanitizeDiagnosticText(strProps) : "");
	            _self.message += diagnosticText;
	        }
	        _InternalLogMessage.dataType = "MessageData";
	        return _InternalLogMessage;
	    }());
	    function safeGetLogger(core, config) {
	        return (core || {}).logger || new DiagnosticLogger(config);
	    }
	    var DiagnosticLogger = /** @class */ (function () {
	        function DiagnosticLogger(config) {
	            this.identifier = 'DiagnosticLogger';
	            this.queue = [];
	            var _messageCount = 0;
	            var _messageLogged = {};
	            dynamicProto(DiagnosticLogger, this, function (_self) {
	                if (isNullOrUndefined(config)) {
	                    config = {};
	                }
	                _self.consoleLoggingLevel = function () { return _getConfigValue('loggingLevelConsole', 0); };
	                _self.telemetryLoggingLevel = function () { return _getConfigValue('loggingLevelTelemetry', 1); };
	                _self.maxInternalMessageLimit = function () { return _getConfigValue('maxMessageLimit', 25); };
	                _self.enableDebugExceptions = function () { return _getConfigValue('enableDebugExceptions', false); };
	                _self.throwInternal = function (severity, msgId, msg, properties, isUserAct) {
	                    if (isUserAct === void 0) { isUserAct = false; }
	                    var message = new _InternalLogMessage(msgId, msg, isUserAct, properties);
	                    if (_self.enableDebugExceptions()) {
	                        throw message;
	                    }
	                    else {
	                        if (!isUndefined(message) && !!message && !isUndefined(message.message)) {
	                            var logLevel = _self.consoleLoggingLevel();
	                            if (isUserAct) {
	                                var messageKey = +message.messageId;
	                                if (!_messageLogged[messageKey] && logLevel >= exports.LoggingSeverity.WARNING) {
	                                    _self.warnToConsole(message.message);
	                                    _messageLogged[messageKey] = true;
	                                }
	                            }
	                            else {
	                                if (logLevel >= exports.LoggingSeverity.WARNING) {
	                                    _self.warnToConsole(message.message);
	                                }
	                            }
	                            _self.logInternalMessage(severity, message);
	                        }
	                    }
	                };
	                _self.warnToConsole = function (message) {
	                    var theConsole = getConsole();
	                    if (!!theConsole) {
	                        var logFunc = 'log';
	                        if (theConsole.warn) {
	                            logFunc = 'warn';
	                        }
	                        if (isFunction(theConsole[logFunc])) {
	                            theConsole[logFunc](message);
	                        }
	                    }
	                };
	                _self.resetInternalMessageCount = function () {
	                    _messageCount = 0;
	                    _messageLogged = {};
	                };
	                _self.logInternalMessage = function (severity, message) {
	                    if (_areInternalMessagesThrottled()) {
	                        return;
	                    }
	                    var logMessage = true;
	                    var messageKey = AIInternalMessagePrefix + message.messageId;
	                    if (_messageLogged[messageKey]) {
	                        logMessage = false;
	                    }
	                    else {
	                        _messageLogged[messageKey] = true;
	                    }
	                    if (logMessage) {
	                        if (severity <= _self.telemetryLoggingLevel()) {
	                            _self.queue.push(message);
	                            _messageCount++;
	                        }
	                        if (_messageCount === _self.maxInternalMessageLimit()) {
	                            var throttleLimitMessage = "Internal events throttle limit per PageView reached for this app.";
	                            var throttleMessage = new _InternalLogMessage(_InternalMessageId.MessageLimitPerPVExceeded, throttleLimitMessage, false);
	                            _self.queue.push(throttleMessage);
	                            _self.warnToConsole(throttleLimitMessage);
	                        }
	                    }
	                };
	                function _getConfigValue(name, defValue) {
	                    var value = config[name];
	                    if (!isNullOrUndefined(value)) {
	                        return value;
	                    }
	                    return defValue;
	                }
	                function _areInternalMessagesThrottled() {
	                    return _messageCount >= _self.maxInternalMessageLimit();
	                }
	            });
	        }
	        return DiagnosticLogger;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var strExecutionContextKey = "ctx";
	    var PerfEvent = /** @class */ (function () {
	        function PerfEvent(name, payloadDetails, isAsync) {
	            var _self = this;
	            var accessorDefined = false;
	            _self.start = dateNow();
	            _self.name = name;
	            _self.isAsync = isAsync;
	            _self.isChildEvt = function () { return false; };
	            if (isFunction(payloadDetails)) {
	                var theDetails_1;
	                accessorDefined = objDefineAccessors(_self, 'payload', function () {
	                    if (!theDetails_1 && isFunction(payloadDetails)) {
	                        theDetails_1 = payloadDetails();
	                        payloadDetails = null;
	                    }
	                    return theDetails_1;
	                });
	            }
	            _self.getCtx = function (key) {
	                if (key) {
	                    if (key === PerfEvent.ParentContextKey || key === PerfEvent.ChildrenContextKey) {
	                        return _self[key];
	                    }
	                    return (_self[strExecutionContextKey] || {})[key];
	                }
	                return null;
	            };
	            _self.setCtx = function (key, value) {
	                if (key) {
	                    if (key === PerfEvent.ParentContextKey) {
	                        if (!_self[key]) {
	                            _self.isChildEvt = function () { return true; };
	                        }
	                        _self[key] = value;
	                    }
	                    else if (key === PerfEvent.ChildrenContextKey) {
	                        _self[key] = value;
	                    }
	                    else {
	                        var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
	                        ctx[key] = value;
	                    }
	                }
	            };
	            _self.complete = function () {
	                var childTime = 0;
	                var childEvts = _self.getCtx(PerfEvent.ChildrenContextKey);
	                if (isArray(childEvts)) {
	                    for (var lp = 0; lp < childEvts.length; lp++) {
	                        var childEvt = childEvts[lp];
	                        if (childEvt) {
	                            childTime += childEvt.time;
	                        }
	                    }
	                }
	                _self.time = dateNow() - _self.start;
	                _self.exTime = _self.time - childTime;
	                _self.complete = function () { };
	                if (!accessorDefined && isFunction(payloadDetails)) {
	                    _self.payload = payloadDetails();
	                }
	            };
	        }
	        PerfEvent.ParentContextKey = "parent";
	        PerfEvent.ChildrenContextKey = "childEvts";
	        return PerfEvent;
	    }());
	    var PerfManager = /** @class */ (function () {
	        function PerfManager(manager) {
	            this.ctx = {};
	            dynamicProto(PerfManager, this, function (_self) {
	                _self.create = function (src, payloadDetails, isAsync) {
	                    return new PerfEvent(src, payloadDetails, isAsync);
	                };
	                _self.fire = function (perfEvent) {
	                    if (perfEvent) {
	                        perfEvent.complete();
	                        if (manager) {
	                            manager.perfEvent(perfEvent);
	                        }
	                    }
	                };
	                _self.setCtx = function (key, value) {
	                    if (key) {
	                        var ctx = _self[strExecutionContextKey] = _self[strExecutionContextKey] || {};
	                        ctx[key] = value;
	                    }
	                };
	                _self.getCtx = function (key) {
	                    return (_self[strExecutionContextKey] || {})[key];
	                };
	            });
	        }
	        return PerfManager;
	    }());
	    var doPerfActiveKey = "CoreUtils.doPerf";
	    function doPerf(mgrSource, getSource, func, details, isAsync) {
	        if (mgrSource) {
	            var perfMgr = mgrSource;
	            if (perfMgr && isFunction(perfMgr["getPerfMgr"])) {
	                perfMgr = perfMgr["getPerfMgr"]();
	            }
	            if (perfMgr) {
	                var perfEvt = void 0;
	                var currentActive = perfMgr.getCtx(doPerfActiveKey);
	                try {
	                    perfEvt = perfMgr.create(getSource(), details, isAsync);
	                    if (perfEvt) {
	                        if (currentActive && perfEvt.setCtx) {
	                            perfEvt.setCtx(PerfEvent.ParentContextKey, currentActive);
	                            if (currentActive.getCtx && currentActive.setCtx) {
	                                var children = currentActive.getCtx(PerfEvent.ChildrenContextKey);
	                                if (!children) {
	                                    children = [];
	                                    currentActive.setCtx(PerfEvent.ChildrenContextKey, children);
	                                }
	                                children.push(perfEvt);
	                            }
	                        }
	                        perfMgr.setCtx(doPerfActiveKey, perfEvt);
	                        return func(perfEvt);
	                    }
	                }
	                catch (ex) {
	                    if (perfEvt && perfEvt.setCtx) {
	                        perfEvt.setCtx("exception", ex);
	                    }
	                }
	                finally {
	                    if (perfEvt) {
	                        perfMgr.fire(perfEvt);
	                    }
	                    perfMgr.setCtx(doPerfActiveKey, currentActive);
	                }
	            }
	        }
	        return func();
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var TelemetryPluginChain = /** @class */ (function () {
	        function TelemetryPluginChain(plugin, defItemCtx) {
	            var _self = this;
	            var _nextProxy = null;
	            var _hasProcessTelemetry = isFunction(plugin.processTelemetry);
	            var _hasSetNext = isFunction(plugin.setNextPlugin);
	            _self._hasRun = false;
	            _self.getPlugin = function () {
	                return plugin;
	            };
	            _self.getNext = function () {
	                return _nextProxy;
	            };
	            _self.setNext = function (nextPlugin) {
	                _nextProxy = nextPlugin;
	            };
	            _self.processTelemetry = function (env, itemCtx) {
	                if (!itemCtx) {
	                    itemCtx = defItemCtx;
	                }
	                var identifier = plugin ? plugin.identifier : "TelemetryPluginChain";
	                doPerf(itemCtx ? itemCtx.core() : null, function () { return identifier + ":processTelemetry"; }, function () {
	                    if (plugin && _hasProcessTelemetry) {
	                        _self._hasRun = true;
	                        try {
	                            itemCtx.setNext(_nextProxy);
	                            if (_hasSetNext) {
	                                plugin.setNextPlugin(_nextProxy);
	                            }
	                            _nextProxy && (_nextProxy._hasRun = false);
	                            plugin.processTelemetry(env, itemCtx);
	                        }
	                        catch (error) {
	                            var hasRun = _nextProxy && _nextProxy._hasRun;
	                            if (!_nextProxy || !hasRun) {
	                                itemCtx.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.PluginException, "Plugin [" + plugin.identifier + "] failed during processTelemetry - " + error);
	                            }
	                            if (_nextProxy && !hasRun) {
	                                _nextProxy.processTelemetry(env, itemCtx);
	                            }
	                        }
	                    }
	                    else if (_nextProxy) {
	                        _self._hasRun = true;
	                        _nextProxy.processTelemetry(env, itemCtx);
	                    }
	                }, function () { return ({ item: env }); }, !(env.sync));
	            };
	        }
	        return TelemetryPluginChain;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    function _createProxyChain(plugins, itemCtx) {
	        var proxies = [];
	        if (plugins && plugins.length > 0) {
	            var lastProxy = null;
	            for (var idx = 0; idx < plugins.length; idx++) {
	                var thePlugin = plugins[idx];
	                if (thePlugin && isFunction(thePlugin.processTelemetry)) {
	                    var newProxy = new TelemetryPluginChain(thePlugin, itemCtx);
	                    proxies.push(newProxy);
	                    if (lastProxy) {
	                        lastProxy.setNext(newProxy);
	                    }
	                    lastProxy = newProxy;
	                }
	            }
	        }
	        return proxies.length > 0 ? proxies[0] : null;
	    }
	    function _copyProxyChain(proxy, itemCtx, startAt) {
	        var plugins = [];
	        var add = startAt ? false : true;
	        if (proxy) {
	            while (proxy) {
	                var thePlugin = proxy.getPlugin();
	                if (add || thePlugin === startAt) {
	                    add = true;
	                    plugins.push(thePlugin);
	                }
	                proxy = proxy.getNext();
	            }
	        }
	        if (!add) {
	            plugins.push(startAt);
	        }
	        return _createProxyChain(plugins, itemCtx);
	    }
	    function _copyPluginChain(srcPlugins, itemCtx, startAt) {
	        var plugins = srcPlugins;
	        var add = false;
	        if (startAt && srcPlugins) {
	            plugins = [];
	            arrForEach(srcPlugins, function (thePlugin) {
	                if (add || thePlugin === startAt) {
	                    add = true;
	                    plugins.push(thePlugin);
	                }
	            });
	        }
	        if (startAt && !add) {
	            if (!plugins) {
	                plugins = [];
	            }
	            plugins.push(startAt);
	        }
	        return _createProxyChain(plugins, itemCtx);
	    }
	    var ProcessTelemetryContext = /** @class */ (function () {
	        function ProcessTelemetryContext(plugins, config, core, startAt) {
	            var _self = this;
	            var _nextProxy = null;
	            if (startAt !== null) {
	                if (plugins && isFunction(plugins.getPlugin)) {
	                    _nextProxy = _copyProxyChain(plugins, _self, startAt || plugins.getPlugin());
	                }
	                else {
	                    if (startAt) {
	                        _nextProxy = _copyPluginChain(plugins, _self, startAt);
	                    }
	                    else if (isUndefined(startAt)) {
	                        _nextProxy = _createProxyChain(plugins, _self);
	                    }
	                }
	            }
	            _self.core = function () {
	                return core;
	            };
	            _self.diagLog = function () {
	                return safeGetLogger(core, config);
	            };
	            _self.getCfg = function () {
	                return config;
	            };
	            _self.getExtCfg = function (identifier, defaultValue) {
	                if (defaultValue === void 0) { defaultValue = {}; }
	                var theConfig;
	                if (config) {
	                    var extConfig = config.extensionConfig;
	                    if (extConfig && identifier) {
	                        theConfig = extConfig[identifier];
	                    }
	                }
	                return (theConfig ? theConfig : defaultValue);
	            };
	            _self.getConfig = function (identifier, field, defaultValue) {
	                if (defaultValue === void 0) { defaultValue = false; }
	                var theValue;
	                var extConfig = _self.getExtCfg(identifier, null);
	                if (extConfig && !isNullOrUndefined(extConfig[field])) {
	                    theValue = extConfig[field];
	                }
	                else if (config && !isNullOrUndefined(config[field])) {
	                    theValue = config[field];
	                }
	                return !isNullOrUndefined(theValue) ? theValue : defaultValue;
	            };
	            _self.hasNext = function () {
	                return _nextProxy != null;
	            };
	            _self.getNext = function () {
	                return _nextProxy;
	            };
	            _self.setNext = function (nextPlugin) {
	                _nextProxy = nextPlugin;
	            };
	            _self.processNext = function (env) {
	                var nextPlugin = _nextProxy;
	                if (nextPlugin) {
	                    _nextProxy = nextPlugin.getNext();
	                    nextPlugin.processTelemetry(env, _self);
	                }
	            };
	            _self.createNew = function (plugins, startAt) {
	                if (plugins === void 0) { plugins = null; }
	                return new ProcessTelemetryContext(plugins || _nextProxy, config, core, startAt);
	            };
	        }
	        return ProcessTelemetryContext;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var strIKey = "iKey";
	    var strExtensionConfig = "extensionConfig";
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var strGetPlugin = "getPlugin";
	    var BaseTelemetryPlugin = /** @class */ (function () {
	        function BaseTelemetryPlugin() {
	            var _self = this;
	            var _isinitialized = false;
	            var _rootCtx = null;
	            var _nextPlugin = null;
	            _self.core = null;
	            _self.diagLog = function (itemCtx) {
	                return _self._getTelCtx(itemCtx).diagLog();
	            };
	            _self.isInitialized = function () {
	                return _isinitialized;
	            };
	            _self.setInitialized = function (isInitialized) {
	                _isinitialized = isInitialized;
	            };
	            _self.setNextPlugin = function (next) {
	                _nextPlugin = next;
	            };
	            _self.processNext = function (env, itemCtx) {
	                if (itemCtx) {
	                    itemCtx.processNext(env);
	                }
	                else if (_nextPlugin && isFunction(_nextPlugin.processTelemetry)) {
	                    _nextPlugin.processTelemetry(env, null);
	                }
	            };
	            _self._getTelCtx = function (currentCtx) {
	                if (currentCtx === void 0) { currentCtx = null; }
	                var itemCtx = currentCtx;
	                if (!itemCtx) {
	                    var rootCtx = _rootCtx || new ProcessTelemetryContext(null, {}, _self.core);
	                    if (_nextPlugin && _nextPlugin[strGetPlugin]) {
	                        itemCtx = rootCtx.createNew(null, _nextPlugin[strGetPlugin]);
	                    }
	                    else {
	                        itemCtx = rootCtx.createNew(null, _nextPlugin);
	                    }
	                }
	                return itemCtx;
	            };
	            _self._baseTelInit = function (config, core, extensions, pluginChain) {
	                if (config) {
	                    setValue(config, strExtensionConfig, [], null, isNullOrUndefined);
	                }
	                if (!pluginChain && core) {
	                    pluginChain = core.getProcessTelContext().getNext();
	                }
	                var nextPlugin = _nextPlugin;
	                if (_nextPlugin && _nextPlugin[strGetPlugin]) {
	                    nextPlugin = _nextPlugin[strGetPlugin]();
	                }
	                _self.core = core;
	                _rootCtx = new ProcessTelemetryContext(pluginChain, config, core, nextPlugin);
	                _isinitialized = true;
	            };
	        }
	        BaseTelemetryPlugin.prototype.initialize = function (config, core, extensions, pluginChain) {
	            this._baseTelInit(config, core, extensions, pluginChain);
	        };
	        return BaseTelemetryPlugin;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var processTelemetry = "processTelemetry";
	    var priority = "priority";
	    var setNextPlugin = "setNextPlugin";
	    var isInitialized = "isInitialized";
	    function initializePlugins(processContext, extensions) {
	        var initPlugins = [];
	        var lastPlugin = null;
	        var proxy = processContext.getNext();
	        while (proxy) {
	            var thePlugin = proxy.getPlugin();
	            if (thePlugin) {
	                if (lastPlugin &&
	                    isFunction(lastPlugin[setNextPlugin]) &&
	                    isFunction(thePlugin[processTelemetry])) {
	                    lastPlugin[setNextPlugin](thePlugin);
	                }
	                if (!isFunction(thePlugin[isInitialized]) || !thePlugin[isInitialized]()) {
	                    initPlugins.push(thePlugin);
	                }
	                lastPlugin = thePlugin;
	                proxy = proxy.getNext();
	            }
	        }
	        arrForEach(initPlugins, function (thePlugin) {
	            thePlugin.initialize(processContext.getCfg(), processContext.core(), extensions, processContext.getNext());
	        });
	    }
	    function sortPlugins(plugins) {
	        return plugins.sort(function (extA, extB) {
	            var result = 0;
	            var bHasProcess = isFunction(extB[processTelemetry]);
	            if (isFunction(extA[processTelemetry])) {
	                result = bHasProcess ? extA[priority] - extB[priority] : 1;
	            }
	            else if (bHasProcess) {
	                result = -1;
	            }
	            return result;
	        });
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var ChannelControllerPriority = 500;
	    var ChannelValidationMessage = "Channel has invalid priority";
	    var ChannelController = /** @class */ (function (_super) {
	        __extends(ChannelController, _super);
	        function ChannelController() {
	            var _this = _super.call(this) || this;
	            _this.identifier = "ChannelControllerPlugin";
	            _this.priority = ChannelControllerPriority;
	            var _channelQueue;
	            dynamicProto(ChannelController, _this, function (_self, _base) {
	                _self.setNextPlugin = function (next) {
	                };
	                _self.processTelemetry = function (item, itemCtx) {
	                    if (_channelQueue) {
	                        arrForEach(_channelQueue, function (queues) {
	                            if (queues.length > 0) {
	                                var chainCtx = _this._getTelCtx(itemCtx).createNew(queues);
	                                chainCtx.processNext(item);
	                            }
	                        });
	                    }
	                };
	                _self.getChannelControls = function () {
	                    return _channelQueue;
	                };
	                _self.initialize = function (config, core, extensions) {
	                    if (_self.isInitialized()) {
	                        return;
	                    }
	                    _base.initialize(config, core, extensions);
	                    _createChannelQueues((config || {}).channels, extensions);
	                    arrForEach(_channelQueue, function (queue) { return initializePlugins(new ProcessTelemetryContext(queue, config, core), extensions); });
	                };
	            });
	            function _checkQueuePriority(queue) {
	                arrForEach(queue, function (queueItem) {
	                    if (queueItem.priority < ChannelControllerPriority) {
	                        throwError(ChannelValidationMessage + queueItem.identifier);
	                    }
	                });
	            }
	            function _addChannelQueue(queue) {
	                if (queue && queue.length > 0) {
	                    queue = queue.sort(function (a, b) {
	                        return a.priority - b.priority;
	                    });
	                    _checkQueuePriority(queue);
	                    _channelQueue.push(queue);
	                }
	            }
	            function _createChannelQueues(channels, extensions) {
	                _channelQueue = [];
	                if (channels) {
	                    arrForEach(channels, function (queue) { return _addChannelQueue(queue); });
	                }
	                if (extensions) {
	                    var extensionQueue_1 = [];
	                    arrForEach(extensions, function (plugin) {
	                        if (plugin.priority > ChannelControllerPriority) {
	                            extensionQueue_1.push(plugin);
	                        }
	                    });
	                    _addChannelQueue(extensionQueue_1);
	                }
	            }
	            return _this;
	        }
	        ChannelController._staticInit = (function () {
	            var proto = ChannelController.prototype;
	            objDefineAccessors(proto, "ChannelControls", proto.getChannelControls);
	            objDefineAccessors(proto, "channelQueue", proto.getChannelControls);
	        })();
	        return ChannelController;
	    }(BaseTelemetryPlugin));
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var strToGMTString = "toGMTString";
	    var strToUTCString = "toUTCString";
	    var strCookie = "cookie";
	    var strExpires = "expires";
	    var strEnabled = "enabled";
	    var strIsCookieUseDisabled = "isCookieUseDisabled";
	    var strDisableCookiesUsage = "disableCookiesUsage";
	    var strConfigCookieMgr = "_ckMgr";
	    var strEmpty = "";
	    var _supportsCookies = null;
	    var _allowUaSameSite = null;
	    var _parsedCookieValue = null;
	    var _doc = getDocument();
	    var _cookieCache = {};
	    var _globalCookieConfig = {};
	    function _gblCookieMgr(config, logger) {
	        var inst = createCookieMgr[strConfigCookieMgr] || _globalCookieConfig[strConfigCookieMgr];
	        if (!inst) {
	            inst = createCookieMgr[strConfigCookieMgr] = createCookieMgr(config, logger);
	            _globalCookieConfig[strConfigCookieMgr] = inst;
	        }
	        return inst;
	    }
	    function _isMgrEnabled(cookieMgr) {
	        if (cookieMgr) {
	            return cookieMgr.isEnabled();
	        }
	        return true;
	    }
	    function _createCookieMgrConfig(rootConfig) {
	        var cookieMgrCfg = rootConfig.cookieCfg = rootConfig.cookieCfg || {};
	        setValue(cookieMgrCfg, "domain", rootConfig.cookieDomain, isNotNullOrUndefined, isNullOrUndefined);
	        setValue(cookieMgrCfg, "path", rootConfig.cookiePath || "/", null, isNullOrUndefined);
	        if (isNullOrUndefined(cookieMgrCfg[strEnabled])) {
	            var cookieEnabled = void 0;
	            if (!isUndefined(rootConfig[strIsCookieUseDisabled])) {
	                cookieEnabled = !rootConfig[strIsCookieUseDisabled];
	            }
	            if (!isUndefined(rootConfig[strDisableCookiesUsage])) {
	                cookieEnabled = !rootConfig[strDisableCookiesUsage];
	            }
	            cookieMgrCfg[strEnabled] = cookieEnabled;
	        }
	        return cookieMgrCfg;
	    }
	    function safeGetCookieMgr(core, config) {
	        var cookieMgr;
	        if (core) {
	            cookieMgr = core.getCookieMgr();
	        }
	        else if (config) {
	            var cookieCfg = (config || {}).cookieCfg;
	            if (cookieCfg[strConfigCookieMgr]) {
	                cookieMgr = cookieCfg[strConfigCookieMgr];
	            }
	            else {
	                cookieMgr = createCookieMgr(config);
	            }
	        }
	        if (!cookieMgr) {
	            cookieMgr = _gblCookieMgr(config, (core || {}).logger);
	        }
	        return cookieMgr;
	    }
	    function createCookieMgr(rootConfig, logger) {
	        var cookieMgrConfig = _createCookieMgrConfig(rootConfig || _globalCookieConfig);
	        var _path = cookieMgrConfig.path || "/";
	        var _domain = cookieMgrConfig.domain;
	        var _enabled = cookieMgrConfig[strEnabled] !== false;
	        var cookieMgr = {
	            isEnabled: function () {
	                var enabled = _enabled && areCookiesSupported(logger);
	                var gblManager = _globalCookieConfig[strConfigCookieMgr];
	                if (enabled && gblManager && cookieMgr !== gblManager) {
	                    enabled = _isMgrEnabled(gblManager);
	                }
	                return enabled;
	            },
	            setEnabled: function (value) {
	                _enabled = value !== false;
	            },
	            set: function (name, value, maxAgeSec, domain, path) {
	                if (_isMgrEnabled(cookieMgr)) {
	                    var values = {};
	                    var theValue = strTrim(value || strEmpty);
	                    var idx = theValue.indexOf(";");
	                    if (idx !== -1) {
	                        theValue = strTrim(value.substring(0, idx));
	                        values = _extractParts(value.substring(idx + 1));
	                    }
	                    setValue(values, "domain", domain || _domain, isTruthy, isUndefined);
	                    if (!isNullOrUndefined(maxAgeSec)) {
	                        var _isIE = isIE();
	                        if (isUndefined(values[strExpires])) {
	                            var nowMs = dateNow();
	                            var expireMs = nowMs + (maxAgeSec * 1000);
	                            if (expireMs > 0) {
	                                var expiry = new Date();
	                                expiry.setTime(expireMs);
	                                setValue(values, strExpires, _formatDate(expiry, !_isIE ? strToUTCString : strToGMTString) || _formatDate(expiry, _isIE ? strToGMTString : strToUTCString) || strEmpty, isTruthy);
	                            }
	                        }
	                        if (!_isIE) {
	                            setValue(values, "max-age", strEmpty + maxAgeSec, null, isUndefined);
	                        }
	                    }
	                    var location_1 = getLocation();
	                    if (location_1 && location_1.protocol === "https:") {
	                        setValue(values, "secure", null, null, isUndefined);
	                        if (_allowUaSameSite === null) {
	                            _allowUaSameSite = !uaDisallowsSameSiteNone((getNavigator() || {}).userAgent);
	                        }
	                        if (_allowUaSameSite) {
	                            setValue(values, "SameSite", "None", null, isUndefined);
	                        }
	                    }
	                    setValue(values, "path", path || _path, null, isUndefined);
	                    var setCookieFn = cookieMgrConfig.setCookie || _setCookieValue;
	                    setCookieFn(name, _formatCookieValue(theValue, values));
	                }
	            },
	            get: function (name) {
	                var value = strEmpty;
	                if (_isMgrEnabled(cookieMgr)) {
	                    value = (cookieMgrConfig.getCookie || _getCookieValue)(name);
	                }
	                return value;
	            },
	            del: function (name, path) {
	                if (_isMgrEnabled(cookieMgr)) {
	                    cookieMgr.purge(name, path);
	                }
	            },
	            purge: function (name, path) {
	                if (areCookiesSupported(logger)) {
	                    var values = (_a = {},
	                        _a["path"] = path ? path : "/",
	                        _a[strExpires] = "Thu, 01 Jan 1970 00:00:01 GMT",
	                        _a);
	                    if (!isIE()) {
	                        values["max-age"] = "0";
	                    }
	                    var delCookie = cookieMgrConfig.delCookie || _setCookieValue;
	                    delCookie(name, _formatCookieValue(strEmpty, values));
	                }
	                var _a;
	            }
	        };
	        cookieMgr[strConfigCookieMgr] = cookieMgr;
	        return cookieMgr;
	    }
	    function areCookiesSupported(logger) {
	        if (_supportsCookies === null) {
	            _supportsCookies = false;
	            try {
	                var doc = _doc || {};
	                _supportsCookies = doc[strCookie] !== undefined;
	            }
	            catch (e) {
	                logger && logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.CannotAccessCookie, "Cannot access document.cookie - " + getExceptionName(e), { exception: dumpObj(e) });
	            }
	        }
	        return _supportsCookies;
	    }
	    function _extractParts(theValue) {
	        var values = {};
	        if (theValue && theValue.length) {
	            var parts = strTrim(theValue).split(";");
	            arrForEach(parts, function (thePart) {
	                thePart = strTrim(thePart || strEmpty);
	                if (thePart) {
	                    var idx = thePart.indexOf("=");
	                    if (idx === -1) {
	                        values[thePart] = null;
	                    }
	                    else {
	                        values[strTrim(thePart.substring(0, idx))] = strTrim(thePart.substring(idx + 1));
	                    }
	                }
	            });
	        }
	        return values;
	    }
	    function _formatDate(theDate, func) {
	        if (isFunction(theDate[func])) {
	            return theDate[func]();
	        }
	        return null;
	    }
	    function _formatCookieValue(value, values) {
	        var cookieValue = value || strEmpty;
	        objForEachKey(values, function (name, theValue) {
	            cookieValue += "; " + name + (!isNullOrUndefined(theValue) ? "=" + theValue : strEmpty);
	        });
	        return cookieValue;
	    }
	    function _getCookieValue(name) {
	        var cookieValue = strEmpty;
	        if (_doc) {
	            var theCookie = _doc[strCookie] || strEmpty;
	            if (_parsedCookieValue !== theCookie) {
	                _cookieCache = _extractParts(theCookie);
	                _parsedCookieValue = theCookie;
	            }
	            cookieValue = strTrim(_cookieCache[name] || strEmpty);
	        }
	        return cookieValue;
	    }
	    function _setCookieValue(name, cookieValue) {
	        if (_doc) {
	            _doc[strCookie] = name + "=" + cookieValue;
	        }
	    }
	    function uaDisallowsSameSiteNone(userAgent) {
	        if (!isString(userAgent)) {
	            return false;
	        }
	        if (strContains(userAgent, "CPU iPhone OS 12") || strContains(userAgent, "iPad; CPU OS 12")) {
	            return true;
	        }
	        if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strContains(userAgent, "Version/") && strContains(userAgent, "Safari")) {
	            return true;
	        }
	        if (strContains(userAgent, "Macintosh; Intel Mac OS X 10_14") && strEndsWith(userAgent, "AppleWebKit/605.1.15 (KHTML, like Gecko)")) {
	            return true;
	        }
	        if (strContains(userAgent, "Chrome/5") || strContains(userAgent, "Chrome/6")) {
	            return true;
	        }
	        if (strContains(userAgent, "UnrealEngine") && !strContains(userAgent, "Chrome")) {
	            return true;
	        }
	        if (strContains(userAgent, "UCBrowser/12") || strContains(userAgent, "UCBrowser/11")) {
	            return true;
	        }
	        return false;
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var validationError = "Extensions must provide callback to initialize";
	    var strNotificationManager = "_notificationManager";
	    var BaseCore = /** @class */ (function () {
	        function BaseCore() {
	            var _isInitialized = false;
	            var _eventQueue;
	            var _channelController;
	            var _notificationManager;
	            var _perfManager;
	            var _cookieManager;
	            dynamicProto(BaseCore, this, function (_self) {
	                _self._extensions = new Array();
	                _channelController = new ChannelController();
	                _self.logger = objCreateFn({
	                    throwInternal: function (severity, msgId, msg, properties, isUserAct) {
	                    },
	                    warnToConsole: function (message) { },
	                    resetInternalMessageCount: function () { }
	                });
	                _eventQueue = [];
	                _self.isInitialized = function () { return _isInitialized; };
	                _self.initialize = function (config, extensions, logger, notificationManager) {
	                    if (_self.isInitialized()) {
	                        throwError("Core should not be initialized more than once");
	                    }
	                    if (!config || isNullOrUndefined(config.instrumentationKey)) {
	                        throwError("Please provide instrumentation key");
	                    }
	                    _notificationManager = notificationManager;
	                    _self[strNotificationManager] = notificationManager;
	                    _self.config = config || {};
	                    config.extensions = isNullOrUndefined(config.extensions) ? [] : config.extensions;
	                    var extConfig = getSetValue(config, strExtensionConfig);
	                    extConfig.NotificationManager = notificationManager;
	                    if (logger) {
	                        _self.logger = logger;
	                    }
	                    var allExtensions = [];
	                    allExtensions.push.apply(allExtensions, extensions.concat(config.extensions));
	                    allExtensions = sortPlugins(allExtensions);
	                    var coreExtensions = [];
	                    var extPriorities = {};
	                    arrForEach(allExtensions, function (ext) {
	                        if (isNullOrUndefined(ext) || isNullOrUndefined(ext.initialize)) {
	                            throwError(validationError);
	                        }
	                        var extPriority = ext.priority;
	                        var identifier = ext.identifier;
	                        if (ext && extPriority) {
	                            if (!isNullOrUndefined(extPriorities[extPriority])) {
	                                logger.warnToConsole("Two extensions have same priority #" + extPriority + " - " + extPriorities[extPriority] + ", " + identifier);
	                            }
	                            else {
	                                extPriorities[extPriority] = identifier;
	                            }
	                        }
	                        if (!extPriority || extPriority < _channelController.priority) {
	                            coreExtensions.push(ext);
	                        }
	                    });
	                    allExtensions.push(_channelController);
	                    coreExtensions.push(_channelController);
	                    allExtensions = sortPlugins(allExtensions);
	                    _self._extensions = allExtensions;
	                    initializePlugins(new ProcessTelemetryContext([_channelController], config, _self), allExtensions);
	                    initializePlugins(new ProcessTelemetryContext(coreExtensions, config, _self), allExtensions);
	                    _self._extensions = coreExtensions;
	                    if (_self.getTransmissionControls().length === 0) {
	                        throwError("No channels available");
	                    }
	                    _isInitialized = true;
	                    _self.releaseQueue();
	                };
	                _self.getTransmissionControls = function () {
	                    return _channelController.getChannelControls();
	                };
	                _self.track = function (telemetryItem) {
	                    setValue(telemetryItem, strIKey, _self.config.instrumentationKey, null, isNotTruthy);
	                    setValue(telemetryItem, "time", toISOString(new Date()), null, isNotTruthy);
	                    setValue(telemetryItem, "ver", "4.0", null, isNullOrUndefined);
	                    if (_self.isInitialized()) {
	                        _self.getProcessTelContext().processNext(telemetryItem);
	                    }
	                    else {
	                        _eventQueue.push(telemetryItem);
	                    }
	                };
	                _self.getProcessTelContext = function () {
	                    var extensions = _self._extensions;
	                    var thePlugins = extensions;
	                    if (!extensions || extensions.length === 0) {
	                        thePlugins = [_channelController];
	                    }
	                    return new ProcessTelemetryContext(thePlugins, _self.config, _self);
	                };
	                _self.getNotifyMgr = function () {
	                    if (!_notificationManager) {
	                        _notificationManager = objCreateFn({
	                            addNotificationListener: function (listener) { },
	                            removeNotificationListener: function (listener) { },
	                            eventsSent: function (events) { },
	                            eventsDiscarded: function (events, reason) { },
	                            eventsSendRequest: function (sendReason, isAsync) { }
	                        });
	                        _self[strNotificationManager] = _notificationManager;
	                    }
	                    return _notificationManager;
	                };
	                _self.getCookieMgr = function () {
	                    if (!_cookieManager) {
	                        _cookieManager = createCookieMgr(_self.config, _self.logger);
	                    }
	                    return _cookieManager;
	                };
	                _self.setCookieMgr = function (cookieMgr) {
	                    _cookieManager = cookieMgr;
	                };
	                _self.getPerfMgr = function () {
	                    if (!_perfManager) {
	                        if (_self.config && _self.config.enablePerfMgr) {
	                            _perfManager = new PerfManager(_self.getNotifyMgr());
	                        }
	                    }
	                    return _perfManager;
	                };
	                _self.setPerfMgr = function (perfMgr) {
	                    _perfManager = perfMgr;
	                };
	                _self.eventCnt = function () {
	                    return _eventQueue.length;
	                };
	                _self.releaseQueue = function () {
	                    if (_eventQueue.length > 0) {
	                        arrForEach(_eventQueue, function (event) {
	                            _self.getProcessTelContext().processNext(event);
	                        });
	                        _eventQueue = [];
	                    }
	                };
	            });
	        }
	        return BaseCore;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var NotificationManager = /** @class */ (function () {
	        function NotificationManager(config) {
	            this.listeners = [];
	            var perfEvtsSendAll = !!(config || {}).perfEvtsSendAll;
	            dynamicProto(NotificationManager, this, function (_self) {
	                _self.addNotificationListener = function (listener) {
	                    _self.listeners.push(listener);
	                };
	                _self.removeNotificationListener = function (listener) {
	                    var index = arrIndexOf(_self.listeners, listener);
	                    while (index > -1) {
	                        _self.listeners.splice(index, 1);
	                        index = arrIndexOf(_self.listeners, listener);
	                    }
	                };
	                _self.eventsSent = function (events) {
	                    arrForEach(_self.listeners, function (listener) {
	                        if (listener && listener.eventsSent) {
	                            setTimeout(function () { return listener.eventsSent(events); }, 0);
	                        }
	                    });
	                };
	                _self.eventsDiscarded = function (events, reason) {
	                    arrForEach(_self.listeners, function (listener) {
	                        if (listener && listener.eventsDiscarded) {
	                            setTimeout(function () { return listener.eventsDiscarded(events, reason); }, 0);
	                        }
	                    });
	                };
	                _self.eventsSendRequest = function (sendReason, isAsync) {
	                    arrForEach(_self.listeners, function (listener) {
	                        if (listener && listener.eventsSendRequest) {
	                            if (isAsync) {
	                                setTimeout(function () { return listener.eventsSendRequest(sendReason, isAsync); }, 0);
	                            }
	                            else {
	                                try {
	                                    listener.eventsSendRequest(sendReason, isAsync);
	                                }
	                                catch (e) {
	                                }
	                            }
	                        }
	                    });
	                };
	                _self.perfEvent = function (perfEvent) {
	                    if (perfEvent) {
	                        if (perfEvtsSendAll || !perfEvent.isChildEvt()) {
	                            arrForEach(_self.listeners, function (listener) {
	                                if (listener && listener.perfEvent) {
	                                    if (perfEvent.isAsync) {
	                                        setTimeout(function () { return listener.perfEvent(perfEvent); }, 0);
	                                    }
	                                    else {
	                                        try {
	                                            listener.perfEvent(perfEvent);
	                                        }
	                                        catch (e) {
	                                        }
	                                    }
	                                }
	                            });
	                        }
	                    }
	                };
	            });
	        }
	        return NotificationManager;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var AppInsightsCore = /** @class */ (function (_super) {
	        __extends(AppInsightsCore, _super);
	        function AppInsightsCore() {
	            var _this = _super.call(this) || this;
	            dynamicProto(AppInsightsCore, _this, function (_self, _base) {
	                _self.initialize = function (config, extensions, logger, notificationManager) {
	                    _base.initialize(config, extensions, logger || new DiagnosticLogger(config), notificationManager || new NotificationManager(config));
	                };
	                _self.track = function (telemetryItem) {
	                    doPerf(_self.getPerfMgr(), function () { return "AppInsightsCore:track"; }, function () {
	                        if (telemetryItem === null) {
	                            _notifyInvalidEvent(telemetryItem);
	                            throwError("Invalid telemetry item");
	                        }
	                        _validateTelemetryItem(telemetryItem);
	                        _base.track(telemetryItem);
	                    }, function () { return ({ item: telemetryItem }); }, !(telemetryItem.sync));
	                };
	                _self.addNotificationListener = function (listener) {
	                    var manager = _self.getNotifyMgr();
	                    if (manager) {
	                        manager.addNotificationListener(listener);
	                    }
	                };
	                _self.removeNotificationListener = function (listener) {
	                    var manager = _self.getNotifyMgr();
	                    if (manager) {
	                        manager.removeNotificationListener(listener);
	                    }
	                };
	                _self.pollInternalLogs = function (eventName) {
	                    var interval = _self.config.diagnosticLogInterval;
	                    if (!interval || !(interval > 0)) {
	                        interval = 10000;
	                    }
	                    return setInterval(function () {
	                        var queue = _self.logger ? _self.logger.queue : [];
	                        arrForEach(queue, function (logMessage) {
	                            var item = {
	                                name: eventName ? eventName : "InternalMessageId: " + logMessage.messageId,
	                                iKey: _self.config.instrumentationKey,
	                                time: toISOString(new Date()),
	                                baseType: _InternalLogMessage.dataType,
	                                baseData: { message: logMessage.message }
	                            };
	                            _self.track(item);
	                        });
	                        queue.length = 0;
	                    }, interval);
	                };
	                function _validateTelemetryItem(telemetryItem) {
	                    if (isNullOrUndefined(telemetryItem.name)) {
	                        _notifyInvalidEvent(telemetryItem);
	                        throw Error("telemetry name required");
	                    }
	                }
	                function _notifyInvalidEvent(telemetryItem) {
	                    var manager = _self.getNotifyMgr();
	                    if (manager) {
	                        manager.eventsDiscarded([telemetryItem], EventsDiscardedReason.InvalidEvent);
	                    }
	                }
	            });
	            return _this;
	        }
	        return AppInsightsCore;
	    }(BaseCore));
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var UInt32Mask = 0x100000000;
	    var MaxUInt32 = 0xffffffff;
	    var _mwcSeeded = false;
	    var _mwcW = 123456789;
	    var _mwcZ = 987654321;
	    function _mwcSeed(seedValue) {
	        if (seedValue < 0) {
	            seedValue >>>= 0;
	        }
	        _mwcW = (123456789 + seedValue) & MaxUInt32;
	        _mwcZ = (987654321 - seedValue) & MaxUInt32;
	        _mwcSeeded = true;
	    }
	    function _autoSeedMwc() {
	        try {
	            var now = dateNow() & 0x7fffffff;
	            _mwcSeed(((Math.random() * UInt32Mask) ^ now) + now);
	        }
	        catch (e) {
	        }
	    }
	    function randomValue(maxValue) {
	        if (maxValue > 0) {
	            return Math.floor((random32() / MaxUInt32) * (maxValue + 1)) >>> 0;
	        }
	        return 0;
	    }
	    function random32(signed) {
	        var value;
	        var c = getCrypto() || getMsCrypto();
	        if (c && c.getRandomValues) {
	            value = c.getRandomValues(new Uint32Array(1))[0] & MaxUInt32;
	        }
	        else if (isIE()) {
	            if (!_mwcSeeded) {
	                _autoSeedMwc();
	            }
	            value = mwcRandom32() & MaxUInt32;
	        }
	        else {
	            value = Math.floor((UInt32Mask * Math.random()) | 0);
	        }
	        if (!signed) {
	            value >>>= 0;
	        }
	        return value;
	    }
	    function mwcRandomSeed(value) {
	        if (!value) {
	            _autoSeedMwc();
	        }
	        else {
	            _mwcSeed(value);
	        }
	    }
	    function mwcRandom32(signed) {
	        _mwcZ = (36969 * (_mwcZ & 0xFFFF) + (_mwcZ >> 16)) & MaxUInt32;
	        _mwcW = (18000 * (_mwcW & 0xFFFF) + (_mwcW >> 16)) & MaxUInt32;
	        var value = (((_mwcZ << 16) + (_mwcW & 0xFFFF)) >>> 0) & MaxUInt32 | 0;
	        if (!signed) {
	            value >>>= 0;
	        }
	        return value;
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var _cookieMgrs = null;
	    var _canUseCookies;
	    function addEventHandler(eventName, callback) {
	        var result = false;
	        var w = getWindow();
	        if (w) {
	            result = attachEvent(w, eventName, callback);
	            result = attachEvent(w["body"], eventName, callback) || result;
	        }
	        var doc = getDocument();
	        if (doc) {
	            result = EventHelper.Attach(doc, eventName, callback) || result;
	        }
	        return result;
	    }
	    function newGuid() {
	        function randomHexDigit() {
	            return randomValue(15);
	        }
	        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(GuidRegex, function (c) {
	            var r = (randomHexDigit() | 0), v = (c === 'x' ? r : r & 0x3 | 0x8);
	            return v.toString(16);
	        });
	    }
	    function perfNow() {
	        var perf = getPerformance();
	        if (perf && perf.now) {
	            return perf.now();
	        }
	        return dateNow();
	    }
	    function newId(maxLength) {
	        if (maxLength === void 0) { maxLength = 22; }
	        var base64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
	        var number = random32() >>> 0;
	        var chars = 0;
	        var result = "";
	        while (result.length < maxLength) {
	            chars++;
	            result += base64chars.charAt(number & 0x3F);
	            number >>>= 6;
	            if (chars === 5) {
	                number = (((random32() << 2) & 0xFFFFFFFF) | (number & 0x03)) >>> 0;
	                chars = 0;
	            }
	        }
	        return result;
	    }
	    function generateW3CId() {
	        var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
	        var oct = "", tmp;
	        for (var a = 0; a < 4; a++) {
	            tmp = random32();
	            oct +=
	                hexValues[tmp & 0xF] +
	                    hexValues[tmp >> 4 & 0xF] +
	                    hexValues[tmp >> 8 & 0xF] +
	                    hexValues[tmp >> 12 & 0xF] +
	                    hexValues[tmp >> 16 & 0xF] +
	                    hexValues[tmp >> 20 & 0xF] +
	                    hexValues[tmp >> 24 & 0xF] +
	                    hexValues[tmp >> 28 & 0xF];
	        }
	        var clockSequenceHi = hexValues[8 + (random32() & 0x03) | 0];
	        return oct.substr(0, 8) + oct.substr(9, 4) + "4" + oct.substr(13, 3) + clockSequenceHi + oct.substr(16, 3) + oct.substr(19, 12);
	    }
	    var CoreUtils = {
	        _canUseCookies: undefined,
	        isTypeof: isTypeof,
	        isUndefined: isUndefined,
	        isNullOrUndefined: isNullOrUndefined,
	        hasOwnProperty: hasOwnProperty,
	        isFunction: isFunction,
	        isObject: isObject,
	        isDate: isDate,
	        isArray: isArray,
	        isError: isError,
	        isString: isString,
	        isNumber: isNumber,
	        isBoolean: isBoolean,
	        toISOString: toISOString,
	        arrForEach: arrForEach,
	        arrIndexOf: arrIndexOf,
	        arrMap: arrMap,
	        arrReduce: arrReduce,
	        strTrim: strTrim,
	        objCreate: objCreateFn,
	        objKeys: objKeys,
	        objDefineAccessors: objDefineAccessors,
	        addEventHandler: addEventHandler,
	        dateNow: dateNow,
	        isIE: isIE,
	        disableCookies: disableCookies,
	        newGuid: newGuid,
	        perfNow: perfNow,
	        newId: newId,
	        randomValue: randomValue,
	        random32: random32,
	        mwcRandomSeed: mwcRandomSeed,
	        mwcRandom32: mwcRandom32,
	        generateW3CId: generateW3CId
	    };
	    var GuidRegex = /[xy]/g;
	    var EventHelper = {
	        Attach: attachEvent,
	        AttachEvent: attachEvent,
	        Detach: detachEvent,
	        DetachEvent: detachEvent
	    };
	    function _legacyCookieMgr(config, logger) {
	        var cookieMgr = _gblCookieMgr(config, logger);
	        var legacyCanUseCookies = CoreUtils._canUseCookies;
	        if (_cookieMgrs === null) {
	            _cookieMgrs = [];
	            _canUseCookies = legacyCanUseCookies;
	            objDefineAccessors(CoreUtils, "_canUseCookies", function () {
	                return _canUseCookies;
	            }, function (value) {
	                _canUseCookies = value;
	                arrForEach(_cookieMgrs, function (mgr) {
	                    mgr.setEnabled(value);
	                });
	            });
	        }
	        if (arrIndexOf(_cookieMgrs, cookieMgr) === -1) {
	            _cookieMgrs.push(cookieMgr);
	        }
	        if (isBoolean(legacyCanUseCookies)) {
	            cookieMgr.setEnabled(legacyCanUseCookies);
	        }
	        if (isBoolean(_canUseCookies)) {
	            cookieMgr.setEnabled(_canUseCookies);
	        }
	        return cookieMgr;
	    }
	    function disableCookies() {
	        _legacyCookieMgr().setEnabled(false);
	    }
	    function canUseCookies(logger) {
	        return _legacyCookieMgr(null, logger).isEnabled();
	    }
	    function getCookie(logger, name) {
	        return _legacyCookieMgr(null, logger).get(name);
	    }
	    function setCookie(logger, name, value, domain) {
	        _legacyCookieMgr(null, logger).set(name, value, null, domain);
	    }
	    function deleteCookie(logger, name) {
	        return _legacyCookieMgr(null, logger).del(name);
	    }
	
	    /*!
	     * Application Insights JavaScript SDK - Core, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var aiInstrumentHooks = "_aiHooks";
	    var cbNames = [
	        "req", "rsp", "hkErr", "fnErr"
	    ];
	    var str__Proto = "__proto__";
	    var strConstructor = "constructor";
	    function _arrLoop(arr, fn) {
	        if (arr) {
	            for (var lp = 0; lp < arr.length; lp++) {
	                if (fn(arr[lp], lp)) {
	                    break;
	                }
	            }
	        }
	    }
	    function _doCallbacks(hooks, callDetails, cbArgs, hookCtx, type) {
	        if (type >= 0  && type <= 2 ) {
	            _arrLoop(hooks, function (hook, idx) {
	                var cbks = hook.cbks;
	                var cb = cbks[cbNames[type]];
	                if (cb) {
	                    callDetails.ctx = function () {
	                        var ctx = hookCtx[idx] = (hookCtx[idx] || {});
	                        return ctx;
	                    };
	                    try {
	                        cb.apply(callDetails.inst, cbArgs);
	                    }
	                    catch (err) {
	                        var orgEx = callDetails.err;
	                        try {
	                            var hookErrorCb = cbks[cbNames[2 ]];
	                            if (hookErrorCb) {
	                                callDetails.err = err;
	                                hookErrorCb.apply(callDetails.inst, cbArgs);
	                            }
	                        }
	                        catch (e) {
	                        }
	                        finally {
	                            callDetails.err = orgEx;
	                        }
	                    }
	                }
	            });
	        }
	    }
	    function _createFunctionHook(aiHook) {
	        return function () {
	            var funcThis = this;
	            var orgArgs = arguments;
	            var hooks = aiHook.h;
	            var funcArgs = {
	                name: aiHook.n,
	                inst: funcThis,
	                ctx: null,
	                set: _replaceArg
	            };
	            var hookCtx = [];
	            var cbArgs = _createArgs([funcArgs], orgArgs);
	            function _createArgs(target, theArgs) {
	                _arrLoop(theArgs, function (arg) {
	                    target.push(arg);
	                });
	                return target;
	            }
	            function _replaceArg(idx, value) {
	                orgArgs = _createArgs([], orgArgs);
	                orgArgs[idx] = value;
	                cbArgs = _createArgs([funcArgs], orgArgs);
	            }
	            _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 0 );
	            var theFunc = aiHook.f;
	            try {
	                funcArgs.rslt = theFunc.apply(funcThis, orgArgs);
	            }
	            catch (err) {
	                funcArgs.err = err;
	                _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 3 );
	                throw err;
	            }
	            _doCallbacks(hooks, funcArgs, cbArgs, hookCtx, 1 );
	            return funcArgs.rslt;
	        };
	    }
	    var _objGetPrototypeOf = Object["getPrototypeOf"];
	    function _getObjProto(target) {
	        if (target) {
	            if (_objGetPrototypeOf) {
	                return _objGetPrototypeOf(target);
	            }
	            var newProto = target[str__Proto] || target[strPrototype] || target[strConstructor];
	            if (newProto) {
	                return newProto;
	            }
	        }
	        return null;
	    }
	    function _getOwner(target, name, checkPrototype) {
	        var owner = null;
	        if (target) {
	            if (hasOwnProperty(target, name)) {
	                owner = target;
	            }
	            else if (checkPrototype) {
	                owner = _getOwner(_getObjProto(target), name, false);
	            }
	        }
	        return owner;
	    }
	    function InstrumentProto(target, funcName, callbacks) {
	        if (target) {
	            return InstrumentFunc(target[strPrototype], funcName, callbacks, false);
	        }
	        return null;
	    }
	    function InstrumentFunc(target, funcName, callbacks, checkPrototype) {
	        if (checkPrototype === void 0) { checkPrototype = true; }
	        if (target && funcName && callbacks) {
	            var owner = _getOwner(target, funcName, checkPrototype);
	            if (owner) {
	                var fn = owner[funcName];
	                if (typeof fn === strFunction) {
	                    var aiHook_1 = fn[aiInstrumentHooks];
	                    if (!aiHook_1) {
	                        aiHook_1 = {
	                            i: 0,
	                            n: funcName,
	                            f: fn,
	                            h: []
	                        };
	                        var newFunc = _createFunctionHook(aiHook_1);
	                        newFunc[aiInstrumentHooks] = aiHook_1;
	                        owner[funcName] = newFunc;
	                    }
	                    var theHook = {
	                        id: aiHook_1.i,
	                        cbks: callbacks,
	                        rm: function () {
	                            var id = this.id;
	                            _arrLoop(aiHook_1.h, function (hook, idx) {
	                                if (hook.id === id) {
	                                    aiHook_1.h.splice(idx, 1);
	                                    return 1;
	                                }
	                            });
	                        }
	                    };
	                    aiHook_1.i++;
	                    aiHook_1.h.push(theHook);
	                    return theHook;
	                }
	            }
	        }
	        return null;
	    }
	
	    var RequestHeaders = {
	        requestContextHeader: "Request-Context",
	        requestContextTargetKey: "appId",
	        requestContextAppIdFormat: "appId=cid-v1:",
	        requestIdHeader: "Request-Id",
	        traceParentHeader: "traceparent",
	        traceStateHeader: "tracestate",
	        sdkContextHeader: "Sdk-Context",
	        sdkContextHeaderAppIdRequest: "appId",
	        requestContextHeaderLowerCase: "request-context"
	    };
	
	    var DataSanitizer = /** @class */ (function () {
	        function DataSanitizer() {
	        }
	        DataSanitizer.sanitizeKeyAndAddUniqueness = function (logger, key, map) {
	            var origLength = key.length;
	            var field = DataSanitizer.sanitizeKey(logger, key);
	            if (field.length !== origLength) {
	                var i = 0;
	                var uniqueField = field;
	                while (map[uniqueField] !== undefined) {
	                    i++;
	                    uniqueField = field.substring(0, DataSanitizer.MAX_NAME_LENGTH - 3) + DataSanitizer.padNumber(i);
	                }
	                field = uniqueField;
	            }
	            return field;
	        };
	        DataSanitizer.sanitizeKey = function (logger, name) {
	            var nameTrunc;
	            if (name) {
	                name = DataSanitizer.trim(name.toString());
	                if (name.length > DataSanitizer.MAX_NAME_LENGTH) {
	                    nameTrunc = name.substring(0, DataSanitizer.MAX_NAME_LENGTH);
	                    logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.NameTooLong, "name is too long.  It has been truncated to " + DataSanitizer.MAX_NAME_LENGTH + " characters.", { name: name }, true);
	                }
	            }
	            return nameTrunc || name;
	        };
	        DataSanitizer.sanitizeString = function (logger, value, maxLength) {
	            if (maxLength === void 0) { maxLength = DataSanitizer.MAX_STRING_LENGTH; }
	            var valueTrunc;
	            if (value) {
	                maxLength = maxLength ? maxLength : DataSanitizer.MAX_STRING_LENGTH;
	                value = DataSanitizer.trim(value);
	                if (value.toString().length > maxLength) {
	                    valueTrunc = value.toString().substring(0, maxLength);
	                    logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.StringValueTooLong, "string value is too long. It has been truncated to " + maxLength + " characters.", { value: value }, true);
	                }
	            }
	            return valueTrunc || value;
	        };
	        DataSanitizer.sanitizeUrl = function (logger, url) {
	            return DataSanitizer.sanitizeInput(logger, url, DataSanitizer.MAX_URL_LENGTH, _InternalMessageId.UrlTooLong);
	        };
	        DataSanitizer.sanitizeMessage = function (logger, message) {
	            var messageTrunc;
	            if (message) {
	                if (message.length > DataSanitizer.MAX_MESSAGE_LENGTH) {
	                    messageTrunc = message.substring(0, DataSanitizer.MAX_MESSAGE_LENGTH);
	                    logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.MessageTruncated, "message is too long, it has been truncated to " + DataSanitizer.MAX_MESSAGE_LENGTH + " characters.", { message: message }, true);
	                }
	            }
	            return messageTrunc || message;
	        };
	        DataSanitizer.sanitizeException = function (logger, exception) {
	            var exceptionTrunc;
	            if (exception) {
	                if (exception.length > DataSanitizer.MAX_EXCEPTION_LENGTH) {
	                    exceptionTrunc = exception.substring(0, DataSanitizer.MAX_EXCEPTION_LENGTH);
	                    logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.ExceptionTruncated, "exception is too long, it has been truncated to " + DataSanitizer.MAX_EXCEPTION_LENGTH + " characters.", { exception: exception }, true);
	                }
	            }
	            return exceptionTrunc || exception;
	        };
	        DataSanitizer.sanitizeProperties = function (logger, properties) {
	            if (properties) {
	                var tempProps_1 = {};
	                objForEachKey(properties, function (prop, value) {
	                    if (isObject(value) && hasJSON()) {
	                        try {
	                            value = getJSON().stringify(value);
	                        }
	                        catch (e) {
	                            logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.CannotSerializeObjectNonSerializable, "custom property is not valid", { exception: e }, true);
	                        }
	                    }
	                    value = DataSanitizer.sanitizeString(logger, value, DataSanitizer.MAX_PROPERTY_LENGTH);
	                    prop = DataSanitizer.sanitizeKeyAndAddUniqueness(logger, prop, tempProps_1);
	                    tempProps_1[prop] = value;
	                });
	                properties = tempProps_1;
	            }
	            return properties;
	        };
	        DataSanitizer.sanitizeMeasurements = function (logger, measurements) {
	            if (measurements) {
	                var tempMeasurements_1 = {};
	                objForEachKey(measurements, function (measure, value) {
	                    measure = DataSanitizer.sanitizeKeyAndAddUniqueness(logger, measure, tempMeasurements_1);
	                    tempMeasurements_1[measure] = value;
	                });
	                measurements = tempMeasurements_1;
	            }
	            return measurements;
	        };
	        DataSanitizer.sanitizeId = function (logger, id) {
	            return id ? DataSanitizer.sanitizeInput(logger, id, DataSanitizer.MAX_ID_LENGTH, _InternalMessageId.IdTooLong).toString() : id;
	        };
	        DataSanitizer.sanitizeInput = function (logger, input, maxLength, _msgId) {
	            var inputTrunc;
	            if (input) {
	                input = DataSanitizer.trim(input);
	                if (input.length > maxLength) {
	                    inputTrunc = input.substring(0, maxLength);
	                    logger.throwInternal(exports.LoggingSeverity.WARNING, _msgId, "input is too long, it has been truncated to " + maxLength + " characters.", { data: input }, true);
	                }
	            }
	            return inputTrunc || input;
	        };
	        DataSanitizer.padNumber = function (num) {
	            var s = "00" + num;
	            return s.substr(s.length - 3);
	        };
	        DataSanitizer.trim = function (str) {
	            if (!isString(str)) {
	                return str;
	            }
	            return str.replace(/^\s+|\s+$/g, "");
	        };
	        DataSanitizer.MAX_NAME_LENGTH = 150;
	        DataSanitizer.MAX_ID_LENGTH = 128;
	        DataSanitizer.MAX_PROPERTY_LENGTH = 8192;
	        DataSanitizer.MAX_STRING_LENGTH = 1024;
	        DataSanitizer.MAX_URL_LENGTH = 2048;
	        DataSanitizer.MAX_MESSAGE_LENGTH = 32768;
	        DataSanitizer.MAX_EXCEPTION_LENGTH = 32768;
	        return DataSanitizer;
	    }());
	
	    function createDomEvent(eventName) {
	        var event = null;
	        if (isFunction(Event)) {
	            event = new Event(eventName);
	        }
	        else {
	            var doc = getDocument();
	            if (doc && doc.createEvent) {
	                event = doc.createEvent("Event");
	                event.initEvent(eventName, true, true);
	            }
	        }
	        return event;
	    }
	
	    function stringToBoolOrDefault(str, defaultValue) {
	        if (defaultValue === void 0) { defaultValue = false; }
	        if (str === undefined || str === null) {
	            return defaultValue;
	        }
	        return str.toString().toLowerCase() === "true";
	    }
	    function msToTimeSpan(totalms) {
	        if (isNaN(totalms) || totalms < 0) {
	            totalms = 0;
	        }
	        totalms = Math.round(totalms);
	        var ms = "" + totalms % 1000;
	        var sec = "" + Math.floor(totalms / 1000) % 60;
	        var min = "" + Math.floor(totalms / (1000 * 60)) % 60;
	        var hour = "" + Math.floor(totalms / (1000 * 60 * 60)) % 24;
	        var days = Math.floor(totalms / (1000 * 60 * 60 * 24));
	        ms = ms.length === 1 ? "00" + ms : ms.length === 2 ? "0" + ms : ms;
	        sec = sec.length < 2 ? "0" + sec : sec;
	        min = min.length < 2 ? "0" + min : min;
	        hour = hour.length < 2 ? "0" + hour : hour;
	        return (days > 0 ? days + "." : "") + hour + ":" + min + ":" + sec + "." + ms;
	    }
	    function isBeaconApiSupported() {
	        var nav = getNavigator();
	        return ('sendBeacon' in nav && nav.sendBeacon);
	    }
	    function getExtensionByName(extensions, identifier) {
	        var extension = null;
	        arrForEach(extensions, function (value) {
	            if (value.identifier === identifier) {
	                extension = value;
	                return -1;
	            }
	        });
	        return extension;
	    }
	    function isCrossOriginError(message, url, lineNumber, columnNumber, error) {
	        return !error && isString(message) && (message === "Script error." || message === "Script error");
	    }
	
	    var DisabledPropertyName = "Microsoft_ApplicationInsights_BypassAjaxInstrumentation";
	    var SampleRate = "sampleRate";
	    var ProcessLegacy = "ProcessLegacy";
	    var HttpMethod = "http.method";
	    var DEFAULT_BREEZE_ENDPOINT = "https://dc.services.visualstudio.com";
	    var strNotSpecified = "not_specified";
	
	    var StorageType;
	    (function (StorageType) {
	        StorageType[StorageType["LocalStorage"] = 0] = "LocalStorage";
	        StorageType[StorageType["SessionStorage"] = 1] = "SessionStorage";
	    })(StorageType || (StorageType = {}));
	    var FieldType;
	    (function (FieldType) {
	        FieldType[FieldType["Default"] = 0] = "Default";
	        FieldType[FieldType["Required"] = 1] = "Required";
	        FieldType[FieldType["Array"] = 2] = "Array";
	        FieldType[FieldType["Hidden"] = 4] = "Hidden";
	    })(FieldType || (FieldType = {}));
	    exports.DistributedTracingModes = void 0;
	    (function (DistributedTracingModes) {
	        DistributedTracingModes[DistributedTracingModes["AI"] = 0] = "AI";
	        DistributedTracingModes[DistributedTracingModes["AI_AND_W3C"] = 1] = "AI_AND_W3C";
	        DistributedTracingModes[DistributedTracingModes["W3C"] = 2] = "W3C";
	    })(exports.DistributedTracingModes || (exports.DistributedTracingModes = {}));
	
	    var _canUseLocalStorage = undefined;
	    var _canUseSessionStorage = undefined;
	    function _getLocalStorageObject() {
	        if (utlCanUseLocalStorage()) {
	            return _getVerifiedStorageObject(StorageType.LocalStorage);
	        }
	        return null;
	    }
	    function _getVerifiedStorageObject(storageType) {
	        try {
	            if (isNullOrUndefined(getGlobal())) {
	                return null;
	            }
	            var uid = new Date;
	            var storage = getGlobalInst(storageType === StorageType.LocalStorage ? "localStorage" : "sessionStorage");
	            storage.setItem(uid.toString(), uid.toString());
	            var fail = storage.getItem(uid.toString()) !== uid.toString();
	            storage.removeItem(uid.toString());
	            if (!fail) {
	                return storage;
	            }
	        }
	        catch (exception) {
	        }
	        return null;
	    }
	    function _getSessionStorageObject() {
	        if (utlCanUseSessionStorage()) {
	            return _getVerifiedStorageObject(StorageType.SessionStorage);
	        }
	        return null;
	    }
	    function utlDisableStorage() {
	        _canUseLocalStorage = false;
	        _canUseSessionStorage = false;
	    }
	    function utlCanUseLocalStorage() {
	        if (_canUseLocalStorage === undefined) {
	            _canUseLocalStorage = !!_getVerifiedStorageObject(StorageType.LocalStorage);
	        }
	        return _canUseLocalStorage;
	    }
	    function utlGetLocalStorage(logger, name) {
	        var storage = _getLocalStorageObject();
	        if (storage !== null) {
	            try {
	                return storage.getItem(name);
	            }
	            catch (e) {
	                _canUseLocalStorage = false;
	                logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.BrowserCannotReadLocalStorage, "Browser failed read of local storage. " + getExceptionName(e), { exception: dumpObj(e) });
	            }
	        }
	        return null;
	    }
	    function utlSetLocalStorage(logger, name, data) {
	        var storage = _getLocalStorageObject();
	        if (storage !== null) {
	            try {
	                storage.setItem(name, data);
	                return true;
	            }
	            catch (e) {
	                _canUseLocalStorage = false;
	                logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.BrowserCannotWriteLocalStorage, "Browser failed write to local storage. " + getExceptionName(e), { exception: dumpObj(e) });
	            }
	        }
	        return false;
	    }
	    function utlRemoveStorage(logger, name) {
	        var storage = _getLocalStorageObject();
	        if (storage !== null) {
	            try {
	                storage.removeItem(name);
	                return true;
	            }
	            catch (e) {
	                _canUseLocalStorage = false;
	                logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.BrowserFailedRemovalFromLocalStorage, "Browser failed removal of local storage item. " + getExceptionName(e), { exception: dumpObj(e) });
	            }
	        }
	        return false;
	    }
	    function utlCanUseSessionStorage() {
	        if (_canUseSessionStorage === undefined) {
	            _canUseSessionStorage = !!_getVerifiedStorageObject(StorageType.SessionStorage);
	        }
	        return _canUseSessionStorage;
	    }
	    function utlGetSessionStorageKeys() {
	        var keys = [];
	        if (utlCanUseSessionStorage()) {
	            objForEachKey(getGlobalInst("sessionStorage"), function (key) {
	                keys.push(key);
	            });
	        }
	        return keys;
	    }
	    function utlGetSessionStorage(logger, name) {
	        var storage = _getSessionStorageObject();
	        if (storage !== null) {
	            try {
	                return storage.getItem(name);
	            }
	            catch (e) {
	                _canUseSessionStorage = false;
	                logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.BrowserCannotReadSessionStorage, "Browser failed read of session storage. " + getExceptionName(e), { exception: dumpObj(e) });
	            }
	        }
	        return null;
	    }
	    function utlSetSessionStorage(logger, name, data) {
	        var storage = _getSessionStorageObject();
	        if (storage !== null) {
	            try {
	                storage.setItem(name, data);
	                return true;
	            }
	            catch (e) {
	                _canUseSessionStorage = false;
	                logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.BrowserCannotWriteSessionStorage, "Browser failed write to session storage. " + getExceptionName(e), { exception: dumpObj(e) });
	            }
	        }
	        return false;
	    }
	    function utlRemoveSessionStorage(logger, name) {
	        var storage = _getSessionStorageObject();
	        if (storage !== null) {
	            try {
	                storage.removeItem(name);
	                return true;
	            }
	            catch (e) {
	                _canUseSessionStorage = false;
	                logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.BrowserFailedRemovalFromSessionStorage, "Browser failed removal of session storage item. " + getExceptionName(e), { exception: dumpObj(e) });
	            }
	        }
	        return false;
	    }
	
	    var _document = getDocument() || {};
	    var _htmlAnchorIdx = 0;
	    var _htmlAnchorElement = [null, null, null, null, null];
	    function urlParseUrl(url) {
	        var anchorIdx = _htmlAnchorIdx;
	        var anchorCache = _htmlAnchorElement;
	        var tempAnchor = anchorCache[anchorIdx];
	        if (!_document.createElement) {
	            tempAnchor = { host: urlParseHost(url, true) };
	        }
	        else if (!anchorCache[anchorIdx]) {
	            tempAnchor = anchorCache[anchorIdx] = _document.createElement('a');
	        }
	        tempAnchor.href = url;
	        anchorIdx++;
	        if (anchorIdx >= anchorCache.length) {
	            anchorIdx = 0;
	        }
	        _htmlAnchorIdx = anchorIdx;
	        return tempAnchor;
	    }
	    function urlGetAbsoluteUrl(url) {
	        var result;
	        var a = urlParseUrl(url);
	        if (a) {
	            result = a.href;
	        }
	        return result;
	    }
	    function urlGetPathName(url) {
	        var result;
	        var a = urlParseUrl(url);
	        if (a) {
	            result = a.pathname;
	        }
	        return result;
	    }
	    function urlGetCompleteUrl(method, absoluteUrl) {
	        if (method) {
	            return method.toUpperCase() + " " + absoluteUrl;
	        }
	        return absoluteUrl;
	    }
	    function urlParseHost(url, inclPort) {
	        var fullHost = urlParseFullHost(url, inclPort);
	        if (fullHost) {
	            var match = fullHost.match(/(www[0-9]?\.)?(.[^/:]+)(\:[\d]+)?/i);
	            if (match != null && match.length > 3 && isString(match[2]) && match[2].length > 0) {
	                return match[2] + (match[3] || "");
	            }
	        }
	        return fullHost;
	    }
	    function urlParseFullHost(url, inclPort) {
	        var result = null;
	        if (url) {
	            var match = url.match(/(\w*):\/\/(.[^/:]+)(\:[\d]+)?/i);
	            if (match != null && match.length > 2 && isString(match[2]) && match[2].length > 0) {
	                result = match[2] || "";
	                if (inclPort && match.length > 2) {
	                    var protocol = (match[1] || "").toLowerCase();
	                    var port = match[3] || "";
	                    if (protocol === "http" && port === ":80") {
	                        port = "";
	                    }
	                    else if (protocol === "https" && port === ":443") {
	                        port = "";
	                    }
	                    result += port;
	                }
	            }
	        }
	        return result;
	    }
	
	    var _internalEndpoints = [
	        "https://dc.services.visualstudio.com/v2/track",
	        "https://breeze.aimon.applicationinsights.io/v2/track",
	        "https://dc-int.services.visualstudio.com/v2/track"
	    ];
	    function isInternalApplicationInsightsEndpoint(endpointUrl) {
	        return _internalEndpoints.indexOf(endpointUrl.toLowerCase()) !== -1;
	    }
	    var Util = {
	        NotSpecified: strNotSpecified,
	        createDomEvent: createDomEvent,
	        disableStorage: utlDisableStorage,
	        isInternalApplicationInsightsEndpoint: isInternalApplicationInsightsEndpoint,
	        canUseLocalStorage: utlCanUseLocalStorage,
	        getStorage: utlGetLocalStorage,
	        setStorage: utlSetLocalStorage,
	        removeStorage: utlRemoveStorage,
	        canUseSessionStorage: utlCanUseSessionStorage,
	        getSessionStorageKeys: utlGetSessionStorageKeys,
	        getSessionStorage: utlGetSessionStorage,
	        setSessionStorage: utlSetSessionStorage,
	        removeSessionStorage: utlRemoveSessionStorage,
	        disableCookies: disableCookies,
	        canUseCookies: canUseCookies,
	        disallowsSameSiteNone: uaDisallowsSameSiteNone,
	        setCookie: setCookie,
	        stringToBoolOrDefault: stringToBoolOrDefault,
	        getCookie: getCookie,
	        deleteCookie: deleteCookie,
	        trim: strTrim,
	        newId: newId,
	        random32: function () {
	            return random32(true);
	        },
	        generateW3CId: generateW3CId,
	        isArray: isArray,
	        isError: isError,
	        isDate: isDate,
	        toISOStringForIE8: toISOString,
	        getIEVersion: getIEVersion,
	        msToTimeSpan: msToTimeSpan,
	        isCrossOriginError: isCrossOriginError,
	        dump: dumpObj,
	        getExceptionName: getExceptionName,
	        addEventHandler: attachEvent,
	        IsBeaconApiSupported: isBeaconApiSupported,
	        getExtension: getExtensionByName
	    };
	    var UrlHelper = {
	        parseUrl: urlParseUrl,
	        getAbsoluteUrl: urlGetAbsoluteUrl,
	        getPathName: urlGetPathName,
	        getCompleteUrl: urlGetCompleteUrl,
	        parseHost: urlParseHost,
	        parseFullHost: urlParseFullHost
	    };
	    var CorrelationIdHelper = {
	        correlationIdPrefix: "cid-v1:",
	        canIncludeCorrelationHeader: function (config, requestUrl, currentHost) {
	            if (!requestUrl || (config && config.disableCorrelationHeaders)) {
	                return false;
	            }
	            if (config && config.correlationHeaderExcludePatterns) {
	                for (var i = 0; i < config.correlationHeaderExcludePatterns.length; i++) {
	                    if (config.correlationHeaderExcludePatterns[i].test(requestUrl)) {
	                        return false;
	                    }
	                }
	            }
	            var requestHost = urlParseUrl(requestUrl).host.toLowerCase();
	            if (requestHost && (requestHost.indexOf(":443") !== -1 || requestHost.indexOf(":80") !== -1)) {
	                requestHost = (urlParseFullHost(requestUrl, true) || "").toLowerCase();
	            }
	            if ((!config || !config.enableCorsCorrelation) && requestHost !== currentHost) {
	                return false;
	            }
	            var includedDomains = config && config.correlationHeaderDomains;
	            if (includedDomains) {
	                var matchExists_1;
	                arrForEach(includedDomains, function (domain) {
	                    var regex = new RegExp(domain.toLowerCase().replace(/\./g, "\.").replace(/\*/g, ".*"));
	                    matchExists_1 = matchExists_1 || regex.test(requestHost);
	                });
	                if (!matchExists_1) {
	                    return false;
	                }
	            }
	            var excludedDomains = config && config.correlationHeaderExcludedDomains;
	            if (!excludedDomains || excludedDomains.length === 0) {
	                return true;
	            }
	            for (var i = 0; i < excludedDomains.length; i++) {
	                var regex = new RegExp(excludedDomains[i].toLowerCase().replace(/\./g, "\.").replace(/\*/g, ".*"));
	                if (regex.test(requestHost)) {
	                    return false;
	                }
	            }
	            return requestHost && requestHost.length > 0;
	        },
	        getCorrelationContext: function (responseHeader) {
	            if (responseHeader) {
	                var correlationId = CorrelationIdHelper.getCorrelationContextValue(responseHeader, RequestHeaders.requestContextTargetKey);
	                if (correlationId && correlationId !== CorrelationIdHelper.correlationIdPrefix) {
	                    return correlationId;
	                }
	            }
	        },
	        getCorrelationContextValue: function (responseHeader, key) {
	            if (responseHeader) {
	                var keyValues = responseHeader.split(",");
	                for (var i = 0; i < keyValues.length; ++i) {
	                    var keyValue = keyValues[i].split("=");
	                    if (keyValue.length === 2 && keyValue[0] === key) {
	                        return keyValue[1];
	                    }
	                }
	            }
	        }
	    };
	    function AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName) {
	        var target, name = commandName, data = commandName;
	        if (absoluteUrl && absoluteUrl.length > 0) {
	            var parsedUrl = urlParseUrl(absoluteUrl);
	            target = parsedUrl.host;
	            if (!name) {
	                if (parsedUrl.pathname != null) {
	                    var pathName = (parsedUrl.pathname.length === 0) ? "/" : parsedUrl.pathname;
	                    if (pathName.charAt(0) !== '/') {
	                        pathName = "/" + pathName;
	                    }
	                    data = parsedUrl.pathname;
	                    name = DataSanitizer.sanitizeString(logger, method ? method + " " + pathName : pathName);
	                }
	                else {
	                    name = DataSanitizer.sanitizeString(logger, absoluteUrl);
	                }
	            }
	        }
	        else {
	            target = commandName;
	            name = commandName;
	        }
	        return {
	            target: target,
	            name: name,
	            data: data
	        };
	    }
	    function dateTimeUtilsNow() {
	        var perf = getPerformance();
	        if (perf && perf.now && perf.timing) {
	            var now = perf.now() + perf.timing.navigationStart;
	            if (now > 0) {
	                return now;
	            }
	        }
	        return dateNow();
	    }
	    function dateTimeUtilsDuration(start, end) {
	        var result = null;
	        if (start !== 0 && end !== 0 && !isNullOrUndefined(start) && !isNullOrUndefined(end)) {
	            result = end - start;
	        }
	        return result;
	    }
	    var DateTimeUtils = {
	        Now: dateTimeUtilsNow,
	        GetDuration: dateTimeUtilsDuration
	    };
	
	    var _FIELDS_SEPARATOR = ";";
	    var _FIELD_KEY_VALUE_SEPARATOR = "=";
	    function parseConnectionString(connectionString) {
	        if (!connectionString) {
	            return {};
	        }
	        var kvPairs = connectionString.split(_FIELDS_SEPARATOR);
	        var result = arrReduce(kvPairs, function (fields, kv) {
	            var kvParts = kv.split(_FIELD_KEY_VALUE_SEPARATOR);
	            if (kvParts.length === 2) {
	                var key = kvParts[0].toLowerCase();
	                var value = kvParts[1];
	                fields[key] = value;
	            }
	            return fields;
	        }, {});
	        if (objKeys(result).length > 0) {
	            if (result.endpointsuffix) {
	                var locationPrefix = result.location ? result.location + "." : "";
	                result.ingestionendpoint = result.ingestionendpoint || ("https://" + locationPrefix + "dc." + result.endpointsuffix);
	            }
	            result.ingestionendpoint = result.ingestionendpoint || DEFAULT_BREEZE_ENDPOINT;
	        }
	        return result;
	    }
	    var ConnectionStringParser = {
	        parse: parseConnectionString
	    };
	
	    var Base = /** @class */ (function () {
	        function Base() {
	        }
	        return Base;
	    }());
	
	    var Data$1 = /** @class */ (function (_super) {
	        __extends(Data, _super);
	        function Data() {
	            return _super.call(this) || this;
	        }
	        return Data;
	    }(Base));
	
	    var Envelope$1 = /** @class */ (function () {
	        function Envelope() {
	            this.ver = 1;
	            this.sampleRate = 100.0;
	            this.tags = {};
	        }
	        return Envelope;
	    }());
	
	    var Envelope = /** @class */ (function (_super) {
	        __extends(Envelope, _super);
	        function Envelope(logger, data, name) {
	            var _this = _super.call(this) || this;
	            _this.name = DataSanitizer.sanitizeString(logger, name) || strNotSpecified;
	            _this.data = data;
	            _this.time = toISOString(new Date());
	            _this.aiDataContract = {
	                time: FieldType.Required,
	                iKey: FieldType.Required,
	                name: FieldType.Required,
	                sampleRate: function () {
	                    return (_this.sampleRate === 100) ? FieldType.Hidden : FieldType.Required;
	                },
	                tags: FieldType.Required,
	                data: FieldType.Required
	            };
	            return _this;
	        }
	        return Envelope;
	    }(Envelope$1));
	
	    var EventData = /** @class */ (function () {
	        function EventData() {
	            this.ver = 2;
	            this.properties = {};
	            this.measurements = {};
	        }
	        return EventData;
	    }());
	
	    var Event$1 = /** @class */ (function (_super) {
	        __extends(Event, _super);
	        function Event(logger, name, properties, measurements) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                ver: FieldType.Required,
	                name: FieldType.Required,
	                properties: FieldType.Default,
	                measurements: FieldType.Default
	            };
	            _this.name = DataSanitizer.sanitizeString(logger, name) || strNotSpecified;
	            _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
	            _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	            return _this;
	        }
	        Event.envelopeType = "Microsoft.ApplicationInsights.{0}.Event";
	        Event.dataType = "EventData";
	        return Event;
	    }(EventData));
	
	    var StackFrame = /** @class */ (function () {
	        function StackFrame() {
	        }
	        return StackFrame;
	    }());
	
	    var ExceptionData = /** @class */ (function () {
	        function ExceptionData() {
	            this.ver = 2;
	            this.exceptions = [];
	            this.properties = {};
	            this.measurements = {};
	        }
	        return ExceptionData;
	    }());
	
	    var ExceptionDetails = /** @class */ (function () {
	        function ExceptionDetails() {
	            this.hasFullStack = true;
	            this.parsedStack = [];
	        }
	        return ExceptionDetails;
	    }());
	
	    var strError = "error";
	    function _isExceptionDetailsInternal(value) {
	        return "hasFullStack" in value && "typeName" in value;
	    }
	    function _isExceptionInternal(value) {
	        return ("ver" in value && "exceptions" in value && "properties" in value);
	    }
	    function _getErrorType(errorType) {
	        var typeName = "";
	        if (errorType) {
	            typeName = errorType.typeName || errorType.name || "";
	            if (!typeName) {
	                try {
	                    var funcNameRegex = /function (.{1,})\(/;
	                    var results = (funcNameRegex).exec((errorType).constructor.toString());
	                    typeName = (results && results.length > 1) ? results[1] : "";
	                }
	                catch (e) {
	                }
	            }
	        }
	        return typeName;
	    }
	    var Exception = /** @class */ (function (_super) {
	        __extends(Exception, _super);
	        function Exception(logger, exception, properties, measurements, severityLevel, id) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                ver: FieldType.Required,
	                exceptions: FieldType.Required,
	                severityLevel: FieldType.Default,
	                properties: FieldType.Default,
	                measurements: FieldType.Default
	            };
	            if (!_isExceptionInternal(exception)) {
	                _this.exceptions = [new _ExceptionDetails(logger, exception)];
	                _this.properties = DataSanitizer.sanitizeProperties(logger, properties) || {};
	                _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	                if (severityLevel) {
	                    _this.severityLevel = severityLevel;
	                }
	                if (id) {
	                    _this.id = id;
	                }
	            }
	            else {
	                _this.exceptions = exception.exceptions;
	                _this.properties = exception.properties;
	                _this.measurements = exception.measurements;
	                if (exception.severityLevel) {
	                    _this.severityLevel = exception.severityLevel;
	                }
	                if (exception.id) {
	                    _this.id = exception.id;
	                }
	                if (exception.problemGroup) {
	                    _this.problemGroup = exception.problemGroup;
	                }
	                _this.ver = 2;
	                if (!isNullOrUndefined(exception.isManual)) {
	                    _this.isManual = exception.isManual;
	                }
	            }
	            return _this;
	        }
	        Exception.CreateFromInterface = function (logger, exception, properties, measurements) {
	            var exceptions = exception.exceptions
	                && arrMap(exception.exceptions, function (ex) { return _ExceptionDetails.CreateFromInterface(logger, ex); });
	            var exceptionData = new Exception(logger, __assign({}, exception, { exceptions: exceptions }), properties, measurements);
	            return exceptionData;
	        };
	        Exception.prototype.toInterface = function () {
	            var _a = this, exceptions = _a.exceptions, properties = _a.properties, measurements = _a.measurements, severityLevel = _a.severityLevel; _a.ver; var problemGroup = _a.problemGroup, id = _a.id, isManual = _a.isManual;
	            var exceptionDetailsInterface = exceptions instanceof Array
	                && arrMap(exceptions, function (exception) { return exception.toInterface(); })
	                || undefined;
	            return {
	                ver: "4.0",
	                exceptions: exceptionDetailsInterface,
	                severityLevel: severityLevel,
	                properties: properties,
	                measurements: measurements,
	                problemGroup: problemGroup,
	                id: id,
	                isManual: isManual
	            };
	        };
	        Exception.CreateSimpleException = function (message, typeName, assembly, fileName, details, line) {
	            return {
	                exceptions: [
	                    {
	                        hasFullStack: true,
	                        message: message,
	                        stack: details,
	                        typeName: typeName
	                    }
	                ]
	            };
	        };
	        Exception.envelopeType = "Microsoft.ApplicationInsights.{0}.Exception";
	        Exception.dataType = "ExceptionData";
	        return Exception;
	    }(ExceptionData));
	    var _ExceptionDetails = /** @class */ (function (_super) {
	        __extends(_ExceptionDetails, _super);
	        function _ExceptionDetails(logger, exception) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                id: FieldType.Default,
	                outerId: FieldType.Default,
	                typeName: FieldType.Required,
	                message: FieldType.Required,
	                hasFullStack: FieldType.Default,
	                stack: FieldType.Default,
	                parsedStack: FieldType.Array
	            };
	            if (!_isExceptionDetailsInternal(exception)) {
	                var error = exception;
	                if (!isError(error)) {
	                    error = error[strError] || error.evt || error;
	                }
	                _this.typeName = DataSanitizer.sanitizeString(logger, _getErrorType(error)) || strNotSpecified;
	                _this.message = DataSanitizer.sanitizeMessage(logger, exception.message) || strNotSpecified;
	                var stack = exception.stack;
	                _this.parsedStack = _ExceptionDetails.parseStack(stack);
	                _this.stack = DataSanitizer.sanitizeException(logger, stack);
	                _this.hasFullStack = isArray(_this.parsedStack) && _this.parsedStack.length > 0;
	            }
	            else {
	                _this.typeName = exception.typeName;
	                _this.message = exception.message;
	                _this.stack = exception.stack;
	                _this.parsedStack = exception.parsedStack;
	                _this.hasFullStack = exception.hasFullStack;
	            }
	            return _this;
	        }
	        _ExceptionDetails.prototype.toInterface = function () {
	            var parsedStack = this.parsedStack instanceof Array
	                && arrMap(this.parsedStack, function (frame) { return frame.toInterface(); });
	            var exceptionDetailsInterface = {
	                id: this.id,
	                outerId: this.outerId,
	                typeName: this.typeName,
	                message: this.message,
	                hasFullStack: this.hasFullStack,
	                stack: this.stack,
	                parsedStack: parsedStack || undefined
	            };
	            return exceptionDetailsInterface;
	        };
	        _ExceptionDetails.CreateFromInterface = function (logger, exception) {
	            var parsedStack = (exception.parsedStack instanceof Array
	                && arrMap(exception.parsedStack, function (frame) { return _StackFrame.CreateFromInterface(frame); }))
	                || exception.parsedStack;
	            var exceptionDetails = new _ExceptionDetails(logger, __assign({}, exception, { parsedStack: parsedStack }));
	            return exceptionDetails;
	        };
	        _ExceptionDetails.parseStack = function (stack) {
	            var parsedStack;
	            if (isString(stack)) {
	                var frames_1 = stack.split('\n');
	                parsedStack = [];
	                var level = 0;
	                var totalSizeInBytes = 0;
	                for (var i = 0; i <= frames_1.length; i++) {
	                    var frame = frames_1[i];
	                    if (_StackFrame.regex.test(frame)) {
	                        var parsedFrame = new _StackFrame(frames_1[i], level++);
	                        totalSizeInBytes += parsedFrame.sizeInBytes;
	                        parsedStack.push(parsedFrame);
	                    }
	                }
	                var exceptionParsedStackThreshold = 32 * 1024;
	                if (totalSizeInBytes > exceptionParsedStackThreshold) {
	                    var left = 0;
	                    var right = parsedStack.length - 1;
	                    var size = 0;
	                    var acceptedLeft = left;
	                    var acceptedRight = right;
	                    while (left < right) {
	                        var lSize = parsedStack[left].sizeInBytes;
	                        var rSize = parsedStack[right].sizeInBytes;
	                        size += lSize + rSize;
	                        if (size > exceptionParsedStackThreshold) {
	                            var howMany = acceptedRight - acceptedLeft + 1;
	                            parsedStack.splice(acceptedLeft, howMany);
	                            break;
	                        }
	                        acceptedLeft = left;
	                        acceptedRight = right;
	                        left++;
	                        right--;
	                    }
	                }
	            }
	            return parsedStack;
	        };
	        return _ExceptionDetails;
	    }(ExceptionDetails));
	    var _StackFrame = /** @class */ (function (_super) {
	        __extends(_StackFrame, _super);
	        function _StackFrame(sourceFrame, level) {
	            var _this = _super.call(this) || this;
	            _this.sizeInBytes = 0;
	            _this.aiDataContract = {
	                level: FieldType.Required,
	                method: FieldType.Required,
	                assembly: FieldType.Default,
	                fileName: FieldType.Default,
	                line: FieldType.Default
	            };
	            if (typeof sourceFrame === "string") {
	                var frame = sourceFrame;
	                _this.level = level;
	                _this.method = "<no_method>";
	                _this.assembly = strTrim(frame);
	                _this.fileName = "";
	                _this.line = 0;
	                var matches = frame.match(_StackFrame.regex);
	                if (matches && matches.length >= 5) {
	                    _this.method = strTrim(matches[2]) || _this.method;
	                    _this.fileName = strTrim(matches[4]);
	                    _this.line = parseInt(matches[5]) || 0;
	                }
	            }
	            else {
	                _this.level = sourceFrame.level;
	                _this.method = sourceFrame.method;
	                _this.assembly = sourceFrame.assembly;
	                _this.fileName = sourceFrame.fileName;
	                _this.line = sourceFrame.line;
	                _this.sizeInBytes = 0;
	            }
	            _this.sizeInBytes += _this.method.length;
	            _this.sizeInBytes += _this.fileName.length;
	            _this.sizeInBytes += _this.assembly.length;
	            _this.sizeInBytes += _StackFrame.baseSize;
	            _this.sizeInBytes += _this.level.toString().length;
	            _this.sizeInBytes += _this.line.toString().length;
	            return _this;
	        }
	        _StackFrame.CreateFromInterface = function (frame) {
	            return new _StackFrame(frame, null );
	        };
	        _StackFrame.prototype.toInterface = function () {
	            return {
	                level: this.level,
	                method: this.method,
	                assembly: this.assembly,
	                fileName: this.fileName,
	                line: this.line
	            };
	        };
	        _StackFrame.regex = /^([\s]+at)?(.*?)(\@|\s\(|\s)([^\(\@\n]+):([0-9]+):([0-9]+)(\)?)$/;
	        _StackFrame.baseSize = 58;
	        return _StackFrame;
	    }(StackFrame));
	
	    var MetricData = /** @class */ (function () {
	        function MetricData() {
	            this.ver = 2;
	            this.metrics = [];
	            this.properties = {};
	            this.measurements = {};
	        }
	        return MetricData;
	    }());
	
	    var DataPointType;
	    (function (DataPointType) {
	        DataPointType[DataPointType["Measurement"] = 0] = "Measurement";
	        DataPointType[DataPointType["Aggregation"] = 1] = "Aggregation";
	    })(DataPointType || (DataPointType = {}));
	
	    var DataPoint$1 = /** @class */ (function () {
	        function DataPoint() {
	            this.kind = DataPointType.Measurement;
	        }
	        return DataPoint;
	    }());
	
	    var DataPoint = /** @class */ (function (_super) {
	        __extends(DataPoint, _super);
	        function DataPoint() {
	            var _this = _super !== null && _super.apply(this, arguments) || this;
	            _this.aiDataContract = {
	                name: FieldType.Required,
	                kind: FieldType.Default,
	                value: FieldType.Required,
	                count: FieldType.Default,
	                min: FieldType.Default,
	                max: FieldType.Default,
	                stdDev: FieldType.Default
	            };
	            return _this;
	        }
	        return DataPoint;
	    }(DataPoint$1));
	
	    var Metric = /** @class */ (function (_super) {
	        __extends(Metric, _super);
	        function Metric(logger, name, value, count, min, max, properties, measurements) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                ver: FieldType.Required,
	                metrics: FieldType.Required,
	                properties: FieldType.Default
	            };
	            var dataPoint = new DataPoint();
	            dataPoint.count = count > 0 ? count : undefined;
	            dataPoint.max = isNaN(max) || max === null ? undefined : max;
	            dataPoint.min = isNaN(min) || min === null ? undefined : min;
	            dataPoint.name = DataSanitizer.sanitizeString(logger, name) || strNotSpecified;
	            dataPoint.value = value;
	            _this.metrics = [dataPoint];
	            _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
	            _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	            return _this;
	        }
	        Metric.envelopeType = "Microsoft.ApplicationInsights.{0}.Metric";
	        Metric.dataType = "MetricData";
	        return Metric;
	    }(MetricData));
	
	    var PageViewData = /** @class */ (function (_super) {
	        __extends(PageViewData, _super);
	        function PageViewData() {
	            var _this = _super.call(this) || this;
	            _this.ver = 2;
	            _this.properties = {};
	            _this.measurements = {};
	            return _this;
	        }
	        return PageViewData;
	    }(EventData));
	
	    var PageView = /** @class */ (function (_super) {
	        __extends(PageView, _super);
	        function PageView(logger, name, url, durationMs, properties, measurements, id) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                ver: FieldType.Required,
	                name: FieldType.Default,
	                url: FieldType.Default,
	                duration: FieldType.Default,
	                properties: FieldType.Default,
	                measurements: FieldType.Default,
	                id: FieldType.Default
	            };
	            _this.id = DataSanitizer.sanitizeId(logger, id);
	            _this.url = DataSanitizer.sanitizeUrl(logger, url);
	            _this.name = DataSanitizer.sanitizeString(logger, name) || strNotSpecified;
	            if (!isNaN(durationMs)) {
	                _this.duration = msToTimeSpan(durationMs);
	            }
	            _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
	            _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	            return _this;
	        }
	        PageView.envelopeType = "Microsoft.ApplicationInsights.{0}.Pageview";
	        PageView.dataType = "PageviewData";
	        return PageView;
	    }(PageViewData));
	
	    var RemoteDependencyData$1 = /** @class */ (function () {
	        function RemoteDependencyData() {
	            this.ver = 2;
	            this.success = true;
	            this.properties = {};
	            this.measurements = {};
	        }
	        return RemoteDependencyData;
	    }());
	
	    var RemoteDependencyData = /** @class */ (function (_super) {
	        __extends(RemoteDependencyData, _super);
	        function RemoteDependencyData(logger, id, absoluteUrl, commandName, value, success, resultCode, method, requestAPI, correlationContext, properties, measurements) {
	            if (requestAPI === void 0) { requestAPI = "Ajax"; }
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                id: FieldType.Required,
	                ver: FieldType.Required,
	                name: FieldType.Default,
	                resultCode: FieldType.Default,
	                duration: FieldType.Default,
	                success: FieldType.Default,
	                data: FieldType.Default,
	                target: FieldType.Default,
	                type: FieldType.Default,
	                properties: FieldType.Default,
	                measurements: FieldType.Default,
	                kind: FieldType.Default,
	                value: FieldType.Default,
	                count: FieldType.Default,
	                min: FieldType.Default,
	                max: FieldType.Default,
	                stdDev: FieldType.Default,
	                dependencyKind: FieldType.Default,
	                dependencySource: FieldType.Default,
	                commandName: FieldType.Default,
	                dependencyTypeName: FieldType.Default
	            };
	            _this.id = id;
	            _this.duration = msToTimeSpan(value);
	            _this.success = success;
	            _this.resultCode = resultCode + "";
	            _this.type = DataSanitizer.sanitizeString(logger, requestAPI);
	            var dependencyFields = AjaxHelperParseDependencyPath(logger, absoluteUrl, method, commandName);
	            _this.data = DataSanitizer.sanitizeUrl(logger, commandName) || dependencyFields.data;
	            _this.target = DataSanitizer.sanitizeString(logger, dependencyFields.target);
	            if (correlationContext) {
	                _this.target = _this.target + " | " + correlationContext;
	            }
	            _this.name = DataSanitizer.sanitizeString(logger, dependencyFields.name);
	            _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
	            _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	            return _this;
	        }
	        RemoteDependencyData.envelopeType = "Microsoft.ApplicationInsights.{0}.RemoteDependency";
	        RemoteDependencyData.dataType = "RemoteDependencyData";
	        return RemoteDependencyData;
	    }(RemoteDependencyData$1));
	
	    var MessageData = /** @class */ (function () {
	        function MessageData() {
	            this.ver = 2;
	            this.properties = {};
	            this.measurements = {};
	        }
	        return MessageData;
	    }());
	
	    var Trace = /** @class */ (function (_super) {
	        __extends(Trace, _super);
	        function Trace(logger, message, severityLevel, properties, measurements) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                ver: FieldType.Required,
	                message: FieldType.Required,
	                severityLevel: FieldType.Default,
	                properties: FieldType.Default
	            };
	            message = message || strNotSpecified;
	            _this.message = DataSanitizer.sanitizeMessage(logger, message);
	            _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
	            _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	            if (severityLevel) {
	                _this.severityLevel = severityLevel;
	            }
	            return _this;
	        }
	        Trace.envelopeType = "Microsoft.ApplicationInsights.{0}.Message";
	        Trace.dataType = "MessageData";
	        return Trace;
	    }(MessageData));
	
	    var PageViewPerfData = /** @class */ (function (_super) {
	        __extends(PageViewPerfData, _super);
	        function PageViewPerfData() {
	            var _this = _super.call(this) || this;
	            _this.ver = 2;
	            _this.properties = {};
	            _this.measurements = {};
	            return _this;
	        }
	        return PageViewPerfData;
	    }(PageViewData));
	
	    var PageViewPerformance = /** @class */ (function (_super) {
	        __extends(PageViewPerformance, _super);
	        function PageViewPerformance(logger, name, url, unused, properties, measurements, cs4BaseData) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                ver: FieldType.Required,
	                name: FieldType.Default,
	                url: FieldType.Default,
	                duration: FieldType.Default,
	                perfTotal: FieldType.Default,
	                networkConnect: FieldType.Default,
	                sentRequest: FieldType.Default,
	                receivedResponse: FieldType.Default,
	                domProcessing: FieldType.Default,
	                properties: FieldType.Default,
	                measurements: FieldType.Default
	            };
	            _this.url = DataSanitizer.sanitizeUrl(logger, url);
	            _this.name = DataSanitizer.sanitizeString(logger, name) || strNotSpecified;
	            _this.properties = DataSanitizer.sanitizeProperties(logger, properties);
	            _this.measurements = DataSanitizer.sanitizeMeasurements(logger, measurements);
	            if (cs4BaseData) {
	                _this.domProcessing = cs4BaseData.domProcessing;
	                _this.duration = cs4BaseData.duration;
	                _this.networkConnect = cs4BaseData.networkConnect;
	                _this.perfTotal = cs4BaseData.perfTotal;
	                _this.receivedResponse = cs4BaseData.receivedResponse;
	                _this.sentRequest = cs4BaseData.sentRequest;
	            }
	            return _this;
	        }
	        PageViewPerformance.envelopeType = "Microsoft.ApplicationInsights.{0}.PageviewPerformance";
	        PageViewPerformance.dataType = "PageviewPerformanceData";
	        return PageViewPerformance;
	    }(PageViewPerfData));
	
	    var Data = /** @class */ (function (_super) {
	        __extends(Data, _super);
	        function Data(baseType, data) {
	            var _this = _super.call(this) || this;
	            _this.aiDataContract = {
	                baseType: FieldType.Required,
	                baseData: FieldType.Required
	            };
	            _this.baseType = baseType;
	            _this.baseData = data;
	            return _this;
	        }
	        return Data;
	    }(Data$1));
	
	    exports.SeverityLevel = void 0;
	    (function (SeverityLevel) {
	        SeverityLevel[SeverityLevel["Verbose"] = 0] = "Verbose";
	        SeverityLevel[SeverityLevel["Information"] = 1] = "Information";
	        SeverityLevel[SeverityLevel["Warning"] = 2] = "Warning";
	        SeverityLevel[SeverityLevel["Error"] = 3] = "Error";
	        SeverityLevel[SeverityLevel["Critical"] = 4] = "Critical";
	    })(exports.SeverityLevel || (exports.SeverityLevel = {}));
	
	    var ConfigurationManager = /** @class */ (function () {
	        function ConfigurationManager() {
	        }
	        ConfigurationManager.getConfig = function (config, field, identifier, defaultValue) {
	            if (defaultValue === void 0) { defaultValue = false; }
	            var configValue;
	            if (identifier && config.extensionConfig && config.extensionConfig[identifier] && !isNullOrUndefined(config.extensionConfig[identifier][field])) {
	                configValue = config.extensionConfig[identifier][field];
	            }
	            else {
	                configValue = config[field];
	            }
	            return !isNullOrUndefined(configValue) ? configValue : defaultValue;
	        };
	        return ConfigurationManager;
	    }());
	
	    function _aiNameFunc(baseName) {
	        var aiName = "ai." + baseName + ".";
	        return function (name) {
	            return aiName + name;
	        };
	    }
	    var _aiApplication = _aiNameFunc("application");
	    var _aiDevice = _aiNameFunc("device");
	    var _aiLocation = _aiNameFunc("location");
	    var _aiOperation = _aiNameFunc("operation");
	    var _aiSession = _aiNameFunc("session");
	    var _aiUser = _aiNameFunc("user");
	    var _aiCloud = _aiNameFunc("cloud");
	    var _aiInternal = _aiNameFunc("internal");
	    var ContextTagKeys = /** @class */ (function (_super) {
	        __extends(ContextTagKeys, _super);
	        function ContextTagKeys() {
	            return _super.call(this) || this;
	        }
	        return ContextTagKeys;
	    }(createClassFromInterface({
	        applicationVersion: _aiApplication("ver"),
	        applicationBuild: _aiApplication("build"),
	        applicationTypeId: _aiApplication("typeId"),
	        applicationId: _aiApplication("applicationId"),
	        applicationLayer: _aiApplication("layer"),
	        deviceId: _aiDevice("id"),
	        deviceIp: _aiDevice("ip"),
	        deviceLanguage: _aiDevice("language"),
	        deviceLocale: _aiDevice("locale"),
	        deviceModel: _aiDevice("model"),
	        deviceFriendlyName: _aiDevice("friendlyName"),
	        deviceNetwork: _aiDevice("network"),
	        deviceNetworkName: _aiDevice("networkName"),
	        deviceOEMName: _aiDevice("oemName"),
	        deviceOS: _aiDevice("os"),
	        deviceOSVersion: _aiDevice("osVersion"),
	        deviceRoleInstance: _aiDevice("roleInstance"),
	        deviceRoleName: _aiDevice("roleName"),
	        deviceScreenResolution: _aiDevice("screenResolution"),
	        deviceType: _aiDevice("type"),
	        deviceMachineName: _aiDevice("machineName"),
	        deviceVMName: _aiDevice("vmName"),
	        deviceBrowser: _aiDevice("browser"),
	        deviceBrowserVersion: _aiDevice("browserVersion"),
	        locationIp: _aiLocation("ip"),
	        locationCountry: _aiLocation("country"),
	        locationProvince: _aiLocation("province"),
	        locationCity: _aiLocation("city"),
	        operationId: _aiOperation("id"),
	        operationName: _aiOperation("name"),
	        operationParentId: _aiOperation("parentId"),
	        operationRootId: _aiOperation("rootId"),
	        operationSyntheticSource: _aiOperation("syntheticSource"),
	        operationCorrelationVector: _aiOperation("correlationVector"),
	        sessionId: _aiSession("id"),
	        sessionIsFirst: _aiSession("isFirst"),
	        sessionIsNew: _aiSession("isNew"),
	        userAccountAcquisitionDate: _aiUser("accountAcquisitionDate"),
	        userAccountId: _aiUser("accountId"),
	        userAgent: _aiUser("userAgent"),
	        userId: _aiUser("id"),
	        userStoreRegion: _aiUser("storeRegion"),
	        userAuthUserId: _aiUser("authUserId"),
	        userAnonymousUserAcquisitionDate: _aiUser("anonUserAcquisitionDate"),
	        userAuthenticatedUserAcquisitionDate: _aiUser("authUserAcquisitionDate"),
	        cloudName: _aiCloud("name"),
	        cloudRole: _aiCloud("role"),
	        cloudRoleVer: _aiCloud("roleVer"),
	        cloudRoleInstance: _aiCloud("roleInstance"),
	        cloudEnvironment: _aiCloud("environment"),
	        cloudLocation: _aiCloud("location"),
	        cloudDeploymentUnit: _aiCloud("deploymentUnit"),
	        internalNodeName: _aiInternal("nodeName"),
	        internalSdkVersion: _aiInternal("sdkVersion"),
	        internalAgentVersion: _aiInternal("agentVersion"),
	        internalSnippet: _aiInternal("snippet"),
	        internalSdkSrc: _aiInternal("sdkSrc")
	    })));
	
	    var TelemetryItemCreator = /** @class */ (function () {
	        function TelemetryItemCreator() {
	        }
	        TelemetryItemCreator.create = function (item, baseType, envelopeName, logger, customProperties, systemProperties) {
	            envelopeName = DataSanitizer.sanitizeString(logger, envelopeName) || strNotSpecified;
	            if (isNullOrUndefined(item) ||
	                isNullOrUndefined(baseType) ||
	                isNullOrUndefined(envelopeName)) {
	                throw Error("Input doesn't contain all required fields");
	            }
	            var telemetryItem = {
	                name: envelopeName,
	                time: toISOString(new Date()),
	                iKey: "",
	                ext: systemProperties ? systemProperties : {},
	                tags: [],
	                data: {},
	                baseType: baseType,
	                baseData: item
	            };
	            if (!isNullOrUndefined(customProperties)) {
	                objForEachKey(customProperties, function (prop, value) {
	                    telemetryItem.data[prop] = value;
	                });
	            }
	            return telemetryItem;
	        };
	        return TelemetryItemCreator;
	    }());
	
	    var Extensions = {
	        UserExt: "user",
	        DeviceExt: "device",
	        TraceExt: "trace",
	        WebExt: "web",
	        AppExt: "app",
	        OSExt: "os",
	        SessionExt: "ses",
	        SDKExt: "sdk"
	    };
	    var CtxTagKeys = new ContextTagKeys();
	
	    var PropertiesPluginIdentifier = "AppInsightsPropertiesPlugin";
	    var BreezeChannelIdentifier = "AppInsightsChannelPlugin";
	    var AnalyticsPluginIdentifier = "ApplicationInsightsAnalytics";
	
	    /*!
	     * Application Insights JavaScript SDK - Web Analytics, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var PageViewManager = /** @class */ (function () {
	        function PageViewManager(appInsights, overridePageViewDuration, core, pageViewPerformanceManager) {
	            dynamicProto(PageViewManager, this, function (_self) {
	                var intervalHandle = null;
	                var itemQueue = [];
	                var pageViewPerformanceSent = false;
	                var _logger;
	                if (core) {
	                    _logger = core.logger;
	                }
	                function _flushChannels() {
	                    if (core) {
	                        arrForEach(core.getTransmissionControls(), function (queues) {
	                            arrForEach(queues, function (q) { return q.flush(true); });
	                        });
	                    }
	                }
	                function _addQueue(cb) {
	                    itemQueue.push(cb);
	                    if (!intervalHandle) {
	                        intervalHandle = setInterval((function () {
	                            var allItems = itemQueue.slice(0);
	                            var doFlush = false;
	                            itemQueue = [];
	                            arrForEach(allItems, function (item) {
	                                if (!item()) {
	                                    itemQueue.push(item);
	                                }
	                                else {
	                                    doFlush = true;
	                                }
	                            });
	                            if (itemQueue.length === 0) {
	                                clearInterval(intervalHandle);
	                                intervalHandle = null;
	                            }
	                            if (doFlush) {
	                                _flushChannels();
	                            }
	                        }), 100);
	                    }
	                }
	                _self.trackPageView = function (pageView, customProperties) {
	                    var name = pageView.name;
	                    if (isNullOrUndefined(name) || typeof name !== "string") {
	                        var doc = getDocument();
	                        name = pageView.name = doc && doc.title || "";
	                    }
	                    var uri = pageView.uri;
	                    if (isNullOrUndefined(uri) || typeof uri !== "string") {
	                        var location_1 = getLocation();
	                        uri = pageView.uri = location_1 && location_1.href || "";
	                    }
	                    if (!pageViewPerformanceManager.isPerformanceTimingSupported()) {
	                        appInsights.sendPageViewInternal(pageView, customProperties);
	                        _flushChannels();
	                        _logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.NavigationTimingNotSupported, "trackPageView: navigation timing API used for calculation of page duration is not supported in this browser. This page view will be collected without duration and timing info.");
	                        return;
	                    }
	                    var pageViewSent = false;
	                    var customDuration;
	                    var start = pageViewPerformanceManager.getPerformanceTiming().navigationStart;
	                    if (start > 0) {
	                        customDuration = dateTimeUtilsDuration(start, +new Date);
	                        if (!pageViewPerformanceManager.shouldCollectDuration(customDuration)) {
	                            customDuration = undefined;
	                        }
	                    }
	                    var duration;
	                    if (!isNullOrUndefined(customProperties) &&
	                        !isNullOrUndefined(customProperties.duration)) {
	                        duration = customProperties.duration;
	                    }
	                    if (overridePageViewDuration || !isNaN(duration)) {
	                        if (isNaN(duration)) {
	                            if (!customProperties) {
	                                customProperties = {};
	                            }
	                            customProperties["duration"] = customDuration;
	                        }
	                        appInsights.sendPageViewInternal(pageView, customProperties);
	                        _flushChannels();
	                        pageViewSent = true;
	                    }
	                    var maxDurationLimit = 60000;
	                    if (!customProperties) {
	                        customProperties = {};
	                    }
	                    _addQueue(function () {
	                        var processed = false;
	                        try {
	                            if (pageViewPerformanceManager.isPerformanceTimingDataReady()) {
	                                processed = true;
	                                var pageViewPerformance = {
	                                    name: name,
	                                    uri: uri
	                                };
	                                pageViewPerformanceManager.populatePageViewPerformanceEvent(pageViewPerformance);
	                                if (!pageViewPerformance.isValid && !pageViewSent) {
	                                    customProperties["duration"] = customDuration;
	                                    appInsights.sendPageViewInternal(pageView, customProperties);
	                                }
	                                else {
	                                    if (!pageViewSent) {
	                                        customProperties["duration"] = pageViewPerformance.durationMs;
	                                        appInsights.sendPageViewInternal(pageView, customProperties);
	                                    }
	                                    if (!pageViewPerformanceSent) {
	                                        appInsights.sendPageViewPerformanceInternal(pageViewPerformance, customProperties);
	                                        pageViewPerformanceSent = true;
	                                    }
	                                }
	                            }
	                            else if (start > 0 && dateTimeUtilsDuration(start, +new Date) > maxDurationLimit) {
	                                processed = true;
	                                if (!pageViewSent) {
	                                    customProperties["duration"] = maxDurationLimit;
	                                    appInsights.sendPageViewInternal(pageView, customProperties);
	                                }
	                            }
	                        }
	                        catch (e) {
	                            _logger.throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.TrackPVFailedCalc, "trackPageView failed on page load calculation: " + getExceptionName(e), { exception: dumpObj(e) });
	                        }
	                        return processed;
	                    });
	                };
	            });
	        }
	        return PageViewManager;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Web Analytics, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var PageVisitTimeManager = /** @class */ (function () {
	        function PageVisitTimeManager(logger, pageVisitTimeTrackingHandler) {
	            this.prevPageVisitDataKeyName = "prevPageVisitData";
	            this.pageVisitTimeTrackingHandler = pageVisitTimeTrackingHandler;
	            this._logger = logger;
	        }
	        PageVisitTimeManager.prototype.trackPreviousPageVisit = function (currentPageName, currentPageUrl) {
	            try {
	                var prevPageVisitTimeData = this.restartPageVisitTimer(currentPageName, currentPageUrl);
	                if (prevPageVisitTimeData) {
	                    this.pageVisitTimeTrackingHandler(prevPageVisitTimeData.pageName, prevPageVisitTimeData.pageUrl, prevPageVisitTimeData.pageVisitTime);
	                }
	            }
	            catch (e) {
	                this._logger.warnToConsole("Auto track page visit time failed, metric will not be collected: " + dumpObj(e));
	            }
	        };
	        PageVisitTimeManager.prototype.restartPageVisitTimer = function (pageName, pageUrl) {
	            try {
	                var prevPageVisitData = this.stopPageVisitTimer();
	                this.startPageVisitTimer(pageName, pageUrl);
	                return prevPageVisitData;
	            }
	            catch (e) {
	                this._logger.warnToConsole("Call to restart failed: " + dumpObj(e));
	                return null;
	            }
	        };
	        PageVisitTimeManager.prototype.startPageVisitTimer = function (pageName, pageUrl) {
	            try {
	                if (utlCanUseSessionStorage()) {
	                    if (utlGetSessionStorage(this._logger, this.prevPageVisitDataKeyName) != null) {
	                        throwError("Cannot call startPageVisit consecutively without first calling stopPageVisit");
	                    }
	                    var currPageVisitData = new PageVisitData(pageName, pageUrl);
	                    var currPageVisitDataStr = getJSON().stringify(currPageVisitData);
	                    utlSetSessionStorage(this._logger, this.prevPageVisitDataKeyName, currPageVisitDataStr);
	                }
	            }
	            catch (e) {
	                this._logger.warnToConsole("Call to start failed: " + dumpObj(e));
	            }
	        };
	        PageVisitTimeManager.prototype.stopPageVisitTimer = function () {
	            try {
	                if (utlCanUseSessionStorage()) {
	                    var pageVisitEndTime = dateNow();
	                    var pageVisitDataJsonStr = utlGetSessionStorage(this._logger, this.prevPageVisitDataKeyName);
	                    if (pageVisitDataJsonStr && hasJSON()) {
	                        var prevPageVisitData = getJSON().parse(pageVisitDataJsonStr);
	                        prevPageVisitData.pageVisitTime = pageVisitEndTime - prevPageVisitData.pageVisitStartTime;
	                        utlRemoveSessionStorage(this._logger, this.prevPageVisitDataKeyName);
	                        return prevPageVisitData;
	                    }
	                    else {
	                        return null;
	                    }
	                }
	                return null;
	            }
	            catch (e) {
	                this._logger.warnToConsole("Stop page visit timer failed: " + dumpObj(e));
	                return null;
	            }
	        };
	        return PageVisitTimeManager;
	    }());
	    var PageVisitData = /** @class */ (function () {
	        function PageVisitData(pageName, pageUrl) {
	            this.pageVisitStartTime = dateNow();
	            this.pageName = pageName;
	            this.pageUrl = pageUrl;
	        }
	        return PageVisitData;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Web Analytics, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var PageViewPerformanceManager = /** @class */ (function () {
	        function PageViewPerformanceManager(core) {
	            this.MAX_DURATION_ALLOWED = 3600000;
	            if (core) {
	                this._logger = core.logger;
	            }
	        }
	        PageViewPerformanceManager.prototype.populatePageViewPerformanceEvent = function (pageViewPerformance) {
	            pageViewPerformance.isValid = false;
	            var navigationTiming = this.getPerformanceNavigationTiming();
	            var timing = this.getPerformanceTiming();
	            if (navigationTiming || timing) {
	                if (navigationTiming) {
	                    var total = navigationTiming.duration;
	                    var network = dateTimeUtilsDuration(navigationTiming.startTime, navigationTiming.connectEnd);
	                    var request = dateTimeUtilsDuration(navigationTiming.requestStart, navigationTiming.responseStart);
	                    var response = dateTimeUtilsDuration(navigationTiming.responseStart, navigationTiming.responseEnd);
	                    var dom = dateTimeUtilsDuration(navigationTiming.responseEnd, navigationTiming.loadEventEnd);
	                }
	                else {
	                    var total = dateTimeUtilsDuration(timing.navigationStart, timing.loadEventEnd);
	                    var network = dateTimeUtilsDuration(timing.navigationStart, timing.connectEnd);
	                    var request = dateTimeUtilsDuration(timing.requestStart, timing.responseStart);
	                    var response = dateTimeUtilsDuration(timing.responseStart, timing.responseEnd);
	                    var dom = dateTimeUtilsDuration(timing.responseEnd, timing.loadEventEnd);
	                }
	                if (total === 0) {
	                    this._logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.ErrorPVCalc, "error calculating page view performance.", { total: total, network: network, request: request, response: response, dom: dom });
	                }
	                else if (!this.shouldCollectDuration(total, network, request, response, dom)) {
	                    this._logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.InvalidDurationValue, "Invalid page load duration value. Browser perf data won't be sent.", { total: total, network: network, request: request, response: response, dom: dom });
	                }
	                else if (total < Math.floor(network) + Math.floor(request) + Math.floor(response) + Math.floor(dom)) {
	                    this._logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.ClientPerformanceMathError, "client performance math error.", { total: total, network: network, request: request, response: response, dom: dom });
	                }
	                else {
	                    pageViewPerformance.durationMs = total;
	                    pageViewPerformance.perfTotal = pageViewPerformance.duration = msToTimeSpan(total);
	                    pageViewPerformance.networkConnect = msToTimeSpan(network);
	                    pageViewPerformance.sentRequest = msToTimeSpan(request);
	                    pageViewPerformance.receivedResponse = msToTimeSpan(response);
	                    pageViewPerformance.domProcessing = msToTimeSpan(dom);
	                    pageViewPerformance.isValid = true;
	                }
	            }
	        };
	        PageViewPerformanceManager.prototype.getPerformanceTiming = function () {
	            if (this.isPerformanceTimingSupported()) {
	                return getPerformance().timing;
	            }
	            return null;
	        };
	        PageViewPerformanceManager.prototype.getPerformanceNavigationTiming = function () {
	            if (this.isPerformanceNavigationTimingSupported()) {
	                return getPerformance().getEntriesByType("navigation")[0];
	            }
	            return null;
	        };
	        PageViewPerformanceManager.prototype.isPerformanceNavigationTimingSupported = function () {
	            var perf = getPerformance();
	            return perf && perf.getEntriesByType && perf.getEntriesByType("navigation").length > 0;
	        };
	        PageViewPerformanceManager.prototype.isPerformanceTimingSupported = function () {
	            var perf = getPerformance();
	            return perf && perf.timing;
	        };
	        PageViewPerformanceManager.prototype.isPerformanceTimingDataReady = function () {
	            var perf = getPerformance();
	            var timing = perf ? perf.timing : 0;
	            return timing
	                && timing.domainLookupStart > 0
	                && timing.navigationStart > 0
	                && timing.responseStart > 0
	                && timing.requestStart > 0
	                && timing.loadEventEnd > 0
	                && timing.responseEnd > 0
	                && timing.connectEnd > 0
	                && timing.domLoading > 0;
	        };
	        PageViewPerformanceManager.prototype.shouldCollectDuration = function () {
	            var durations = [];
	            for (var _i = 0; _i < arguments.length; _i++) {
	                durations[_i] = arguments[_i];
	            }
	            var _navigator = getNavigator() || {};
	            var botAgentNames = ['googlebot', 'adsbot-google', 'apis-google', 'mediapartners-google'];
	            var userAgent = _navigator.userAgent;
	            var isGoogleBot = false;
	            if (userAgent) {
	                for (var i = 0; i < botAgentNames.length; i++) {
	                    isGoogleBot = isGoogleBot || userAgent.toLowerCase().indexOf(botAgentNames[i]) !== -1;
	                }
	            }
	            if (isGoogleBot) {
	                return false;
	            }
	            else {
	                for (var i = 0; i < durations.length; i++) {
	                    if (durations[i] < 0 || durations[i] >= this.MAX_DURATION_ALLOWED) {
	                        return false;
	                    }
	                }
	            }
	            return true;
	        };
	        return PageViewPerformanceManager;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Web Analytics, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var durationProperty = "duration";
	    function _dispatchEvent(target, evnt) {
	        if (target && target.dispatchEvent && evnt) {
	            target.dispatchEvent(evnt);
	        }
	    }
	    function _formatMessage(message) {
	        if (message && !isString(message)) {
	            if (isFunction(message.toString)) {
	                message = message.toString();
	            }
	            else {
	                message = JSON.stringify(message);
	            }
	        }
	        return message;
	    }
	    var ApplicationInsights = /** @class */ (function (_super) {
	        __extends(ApplicationInsights, _super);
	        function ApplicationInsights() {
	            var _this = _super.call(this) || this;
	            _this.identifier = AnalyticsPluginIdentifier;
	            _this.priority = 180;
	            _this.autoRoutePVDelay = 500;
	            var _eventTracking;
	            var _pageTracking;
	            var _properties;
	            var _prevUri;
	            var _currUri;
	            dynamicProto(ApplicationInsights, _this, function (_self, _base) {
	                var location = getLocation(true);
	                _prevUri = location && location.href || "";
	                _self.getCookieMgr = function () {
	                    return safeGetCookieMgr(_self.core);
	                };
	                _self.processTelemetry = function (env, itemCtx) {
	                    doPerf(_self.core, function () { return _self.identifier + ":processTelemetry"; }, function () {
	                        var doNotSendItem = false;
	                        var telemetryInitializersCount = _self._telemetryInitializers.length;
	                        itemCtx = _self._getTelCtx(itemCtx);
	                        for (var i = 0; i < telemetryInitializersCount; ++i) {
	                            var telemetryInitializer = _self._telemetryInitializers[i];
	                            if (telemetryInitializer) {
	                                try {
	                                    if (telemetryInitializer.apply(null, [env]) === false) {
	                                        doNotSendItem = true;
	                                        break;
	                                    }
	                                }
	                                catch (e) {
	                                    itemCtx.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.TelemetryInitializerFailed, "One of telemetry initializers failed, telemetry item will not be sent: " + getExceptionName(e), { exception: dumpObj(e) }, true);
	                                }
	                            }
	                        }
	                        if (!doNotSendItem) {
	                            _self.processNext(env, itemCtx);
	                        }
	                    }, function () { return ({ item: env }); }, !(env.sync));
	                };
	                _self.trackEvent = function (event, customProperties) {
	                    try {
	                        var telemetryItem = TelemetryItemCreator.create(event, Event$1.dataType, Event$1.envelopeType, _self.diagLog(), customProperties);
	                        _self.core.track(telemetryItem);
	                    }
	                    catch (e) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.TrackTraceFailed, "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                };
	                _self.startTrackEvent = function (name) {
	                    try {
	                        _eventTracking.start(name);
	                    }
	                    catch (e) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.StartTrackEventFailed, "startTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                };
	                _self.stopTrackEvent = function (name, properties, measurements) {
	                    try {
	                        _eventTracking.stop(name, undefined, properties);
	                    }
	                    catch (e) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.StopTrackEventFailed, "stopTrackEvent failed, event will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                };
	                _self.trackTrace = function (trace, customProperties) {
	                    try {
	                        var telemetryItem = TelemetryItemCreator.create(trace, Trace.dataType, Trace.envelopeType, _self.diagLog(), customProperties);
	                        _self.core.track(telemetryItem);
	                    }
	                    catch (e) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.TrackTraceFailed, "trackTrace failed, trace will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                };
	                _self.trackMetric = function (metric, customProperties) {
	                    try {
	                        var telemetryItem = TelemetryItemCreator.create(metric, Metric.dataType, Metric.envelopeType, _self.diagLog(), customProperties);
	                        _self.core.track(telemetryItem);
	                    }
	                    catch (e) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.TrackMetricFailed, "trackMetric failed, metric will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                };
	                _self.trackPageView = function (pageView, customProperties) {
	                    try {
	                        var inPv = pageView || {};
	                        _self._pageViewManager.trackPageView(inPv, __assign({}, inPv.properties, inPv.measurements, customProperties));
	                        if (_self.config.autoTrackPageVisitTime) {
	                            _self._pageVisitTimeManager.trackPreviousPageVisit(inPv.name, inPv.uri);
	                        }
	                    }
	                    catch (e) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.TrackPVFailed, "trackPageView failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                };
	                _self.sendPageViewInternal = function (pageView, properties, systemProperties) {
	                    var doc = getDocument();
	                    if (doc) {
	                        pageView.refUri = pageView.refUri === undefined ? doc.referrer : pageView.refUri;
	                    }
	                    var telemetryItem = TelemetryItemCreator.create(pageView, PageView.dataType, PageView.envelopeType, _self.diagLog(), properties, systemProperties);
	                    _self.core.track(telemetryItem);
	                };
	                _self.sendPageViewPerformanceInternal = function (pageViewPerformance, properties, systemProperties) {
	                    var telemetryItem = TelemetryItemCreator.create(pageViewPerformance, PageViewPerformance.dataType, PageViewPerformance.envelopeType, _self.diagLog(), properties, systemProperties);
	                    _self.core.track(telemetryItem);
	                };
	                _self.trackPageViewPerformance = function (pageViewPerformance, customProperties) {
	                    try {
	                        _self._pageViewPerformanceManager.populatePageViewPerformanceEvent(pageViewPerformance);
	                        _self.sendPageViewPerformanceInternal(pageViewPerformance, customProperties);
	                    }
	                    catch (e) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.TrackPVFailed, "trackPageViewPerformance failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                };
	                _self.startTrackPage = function (name) {
	                    try {
	                        if (typeof name !== "string") {
	                            var doc = getDocument();
	                            name = doc && doc.title || "";
	                        }
	                        _pageTracking.start(name);
	                    }
	                    catch (e) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.StartTrackFailed, "startTrackPage failed, page view may not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                };
	                _self.stopTrackPage = function (name, url, properties, measurement) {
	                    try {
	                        if (typeof name !== "string") {
	                            var doc = getDocument();
	                            name = doc && doc.title || "";
	                        }
	                        if (typeof url !== "string") {
	                            var loc = getLocation();
	                            url = loc && loc.href || "";
	                        }
	                        _pageTracking.stop(name, url, properties, measurement);
	                        if (_self.config.autoTrackPageVisitTime) {
	                            _self._pageVisitTimeManager.trackPreviousPageVisit(name, url);
	                        }
	                    }
	                    catch (e) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.StopTrackFailed, "stopTrackPage failed, page view will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                };
	                _self.sendExceptionInternal = function (exception, customProperties, systemProperties) {
	                    var exceptionPartB = new Exception(_self.diagLog(), exception.exception || new Error(strNotSpecified), exception.properties, exception.measurements, exception.severityLevel, exception.id).toInterface();
	                    var telemetryItem = TelemetryItemCreator.create(exceptionPartB, Exception.dataType, Exception.envelopeType, _self.diagLog(), customProperties, systemProperties);
	                    _self.core.track(telemetryItem);
	                };
	                _self.trackException = function (exception, customProperties) {
	                    try {
	                        _self.sendExceptionInternal(exception, customProperties);
	                    }
	                    catch (e) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.TrackExceptionFailed, "trackException failed, exception will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                };
	                _self._onerror = function (exception) {
	                    try {
	                        var properties_1 = {
	                            url: (exception && exception.url) || (getDocument() || {}).URL,
	                            lineNumber: exception.lineNumber,
	                            columnNumber: exception.columnNumber,
	                            message: exception.message
	                        };
	                        if (isCrossOriginError(exception.message, exception.url, exception.lineNumber, exception.columnNumber, exception.error)) {
	                            _sendCORSException(properties_1.url);
	                        }
	                        else {
	                            if (!isError(exception.error)) {
	                                var stack = "window.onerror@" + properties_1.url + ":" + exception.lineNumber + ":" + (exception.columnNumber || 0);
	                                exception.error = new Error(exception.message);
	                                exception.error.stack = stack;
	                            }
	                            _self.trackException({ exception: exception.error, severityLevel: exports.SeverityLevel.Error }, properties_1);
	                        }
	                    }
	                    catch (e) {
	                        var errorString = exception.error ?
	                            (exception.error.name + ", " + exception.error.message)
	                            : "null";
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.ExceptionWhileLoggingError, "_onError threw exception while logging error, error will not be collected: "
	                            + getExceptionName(e), { exception: dumpObj(e), errorString: errorString });
	                    }
	                };
	                _self.addTelemetryInitializer = function (telemetryInitializer) {
	                    _self._telemetryInitializers.push(telemetryInitializer);
	                };
	                _self.initialize = function (config, core, extensions, pluginChain) {
	                    if (_self.isInitialized()) {
	                        return;
	                    }
	                    if (isNullOrUndefined(core)) {
	                        throw Error("Error initializing");
	                    }
	                    _base.initialize(config, core, extensions, pluginChain);
	                    _self.setInitialized(false);
	                    var ctx = _self._getTelCtx();
	                    var identifier = _self.identifier;
	                    _self.config = ctx.getExtCfg(identifier);
	                    var defaults = ApplicationInsights.getDefaultConfig();
	                    if (defaults !== undefined) {
	                        objForEachKey(defaults, function (field, value) {
	                            _self.config[field] = ctx.getConfig(identifier, field, value);
	                            if (_self.config[field] === undefined) {
	                                _self.config[field] = value;
	                            }
	                        });
	                    }
	                    if (_self.config.isStorageUseDisabled) {
	                        utlDisableStorage();
	                    }
	                    var configGetters = {
	                        instrumentationKey: function () { return config.instrumentationKey; },
	                        accountId: function () { return _self.config.accountId || config.accountId; },
	                        sessionRenewalMs: function () { return _self.config.sessionRenewalMs || config.sessionRenewalMs; },
	                        sessionExpirationMs: function () { return _self.config.sessionExpirationMs || config.sessionExpirationMs; },
	                        sampleRate: function () { return _self.config.samplingPercentage || config.samplingPercentage; },
	                        sdkExtension: function () { return _self.config.sdkExtension || config.sdkExtension; },
	                        isBrowserLinkTrackingEnabled: function () { return _self.config.isBrowserLinkTrackingEnabled || config.isBrowserLinkTrackingEnabled; },
	                        appId: function () { return _self.config.appId || config.appId; }
	                    };
	                    _self._pageViewPerformanceManager = new PageViewPerformanceManager(_self.core);
	                    _self._pageViewManager = new PageViewManager(_this, _self.config.overridePageViewDuration, _self.core, _self._pageViewPerformanceManager);
	                    _self._pageVisitTimeManager = new PageVisitTimeManager(_self.diagLog(), function (pageName, pageUrl, pageVisitTime) { return trackPageVisitTime(pageName, pageUrl, pageVisitTime); });
	                    _self._telemetryInitializers = _self._telemetryInitializers || [];
	                    _addDefaultTelemetryInitializers(configGetters);
	                    _eventTracking = new Timing(_self.diagLog(), "trackEvent");
	                    _eventTracking.action =
	                        function (name, url, duration, properties) {
	                            if (!properties) {
	                                properties = {};
	                            }
	                            properties[durationProperty] = duration.toString();
	                            _self.trackEvent({ name: name, properties: properties });
	                        };
	                    _pageTracking = new Timing(_self.diagLog(), "trackPageView");
	                    _pageTracking.action = function (name, url, duration, properties, measurements) {
	                        if (isNullOrUndefined(properties)) {
	                            properties = {};
	                        }
	                        properties[durationProperty] = duration.toString();
	                        var pageViewItem = {
	                            name: name,
	                            uri: url,
	                            properties: properties,
	                            measurements: measurements
	                        };
	                        _self.sendPageViewInternal(pageViewItem, properties);
	                    };
	                    var _window = getWindow();
	                    var _history = getHistory();
	                    var _location = getLocation(true);
	                    var instance = _this;
	                    if (_self.config.disableExceptionTracking === false &&
	                        !_self.config.autoExceptionInstrumented && _window) {
	                        var onerror_1 = "onerror";
	                        var originalOnError_1 = _window[onerror_1];
	                        _window.onerror = function (message, url, lineNumber, columnNumber, error) {
	                            var handled = originalOnError_1 && originalOnError_1(message, url, lineNumber, columnNumber, error);
	                            if (handled !== true) {
	                                instance._onerror({
	                                    message: _formatMessage(message),
	                                    url: url,
	                                    lineNumber: lineNumber,
	                                    columnNumber: columnNumber,
	                                    error: error
	                                });
	                            }
	                            return handled;
	                        };
	                        _self.config.autoExceptionInstrumented = true;
	                    }
	                    if (_self.config.disableExceptionTracking === false &&
	                        _self.config.enableUnhandledPromiseRejectionTracking === true &&
	                        !_self.config.autoUnhandledPromiseInstrumented && _window) {
	                        var onunhandledrejection = "onunhandledrejection";
	                        var originalOnUnhandledRejection_1 = _window[onunhandledrejection];
	                        _window[onunhandledrejection] = function (error) {
	                            var handled = originalOnUnhandledRejection_1 && originalOnUnhandledRejection_1.call(_window, error);
	                            if (handled !== true) {
	                                instance._onerror({
	                                    message: error.reason.toString(),
	                                    error: error.reason instanceof Error ? error.reason : new Error(error.reason.toString()),
	                                    url: _location ? _location.href : "",
	                                    lineNumber: 0,
	                                    columnNumber: 0
	                                });
	                            }
	                            return handled;
	                        };
	                        _self.config.autoUnhandledPromiseInstrumented = true;
	                    }
	                    if (_self.config.enableAutoRouteTracking === true
	                        && _history && isFunction(_history.pushState) && isFunction(_history.replaceState)
	                        && _window
	                        && typeof Event !== "undefined") {
	                        var _self_1 = _this;
	                        arrForEach(extensions, function (extension) {
	                            if (extension.identifier === PropertiesPluginIdentifier) {
	                                _properties = extension;
	                            }
	                        });
	                        _history.pushState = (function (f) { return function pushState() {
	                            var ret = f.apply(this, arguments);
	                            _dispatchEvent(_window, createDomEvent(_self_1.config.namePrefix + "pushState"));
	                            _dispatchEvent(_window, createDomEvent(_self_1.config.namePrefix + "locationchange"));
	                            return ret;
	                        }; })(_history.pushState);
	                        _history.replaceState = (function (f) { return function replaceState() {
	                            var ret = f.apply(this, arguments);
	                            _dispatchEvent(_window, createDomEvent(_self_1.config.namePrefix + "replaceState"));
	                            _dispatchEvent(_window, createDomEvent(_self_1.config.namePrefix + "locationchange"));
	                            return ret;
	                        }; })(_history.replaceState);
	                        if (_window.addEventListener) {
	                            _window.addEventListener(_self_1.config.namePrefix + "popstate", function () {
	                                _dispatchEvent(_window, createDomEvent(_self_1.config.namePrefix + "locationchange"));
	                            });
	                            _window.addEventListener(_self_1.config.namePrefix + "locationchange", function () {
	                                if (_properties && _properties.context && _properties.context.telemetryTrace) {
	                                    _properties.context.telemetryTrace.traceID = generateW3CId();
	                                    _properties.context.telemetryTrace.name = _location && _location.pathname || "_unknown_";
	                                }
	                                if (_currUri) {
	                                    _prevUri = _currUri;
	                                    _currUri = _location && _location.href || "";
	                                }
	                                else {
	                                    _currUri = _location && _location.href || "";
	                                }
	                                setTimeout((function (uri) {
	                                    _self_1.trackPageView({ refUri: uri, properties: { duration: 0 } });
	                                }).bind(_this, _prevUri), _self_1.autoRoutePVDelay);
	                            });
	                        }
	                    }
	                    _self.setInitialized(true);
	                };
	                function trackPageVisitTime(pageName, pageUrl, pageVisitTime) {
	                    var properties = { PageName: pageName, PageUrl: pageUrl };
	                    _self.trackMetric({
	                        name: "PageVisitTime",
	                        average: pageVisitTime,
	                        max: pageVisitTime,
	                        min: pageVisitTime,
	                        sampleCount: 1
	                    }, properties);
	                }
	                function _addDefaultTelemetryInitializers(configGetters) {
	                    if (!configGetters.isBrowserLinkTrackingEnabled()) {
	                        var browserLinkPaths_1 = ['/browserLinkSignalR/', '/__browserLink/'];
	                        var dropBrowserLinkRequests = function (envelope) {
	                            if (envelope.baseType === RemoteDependencyData.dataType) {
	                                var remoteData = envelope.baseData;
	                                if (remoteData) {
	                                    for (var i = 0; i < browserLinkPaths_1.length; i++) {
	                                        if (remoteData.target && remoteData.target.indexOf(browserLinkPaths_1[i]) >= 0) {
	                                            return false;
	                                        }
	                                    }
	                                }
	                            }
	                            return true;
	                        };
	                        _addTelemetryInitializer(dropBrowserLinkRequests);
	                    }
	                }
	                function _addTelemetryInitializer(telemetryInitializer) {
	                    _self._telemetryInitializers.push(telemetryInitializer);
	                }
	                function _sendCORSException(url) {
	                    var exception = {
	                        message: "Script error: The browser's same-origin policy prevents us from getting the details of this exception. Consider using the 'crossorigin' attribute.",
	                        url: url,
	                        lineNumber: 0,
	                        columnNumber: 0,
	                        error: undefined
	                    };
	                    var telemetryItem = TelemetryItemCreator.create(exception, Exception.dataType, Exception.envelopeType, _self.diagLog(), { url: url });
	                    _self.core.track(telemetryItem);
	                }
	            });
	            return _this;
	        }
	        ApplicationInsights.getDefaultConfig = function (config) {
	            if (!config) {
	                config = {};
	            }
	            config.sessionRenewalMs = 30 * 60 * 1000;
	            config.sessionExpirationMs = 24 * 60 * 60 * 1000;
	            config.disableExceptionTracking = stringToBoolOrDefault(config.disableExceptionTracking);
	            config.autoTrackPageVisitTime = stringToBoolOrDefault(config.autoTrackPageVisitTime);
	            config.overridePageViewDuration = stringToBoolOrDefault(config.overridePageViewDuration);
	            config.enableUnhandledPromiseRejectionTracking = stringToBoolOrDefault(config.enableUnhandledPromiseRejectionTracking);
	            if (isNaN(config.samplingPercentage) || config.samplingPercentage <= 0 || config.samplingPercentage >= 100) {
	                config.samplingPercentage = 100;
	            }
	            config.isStorageUseDisabled = stringToBoolOrDefault(config.isStorageUseDisabled);
	            config.isBrowserLinkTrackingEnabled = stringToBoolOrDefault(config.isBrowserLinkTrackingEnabled);
	            config.enableAutoRouteTracking = stringToBoolOrDefault(config.enableAutoRouteTracking);
	            config.namePrefix = config.namePrefix || "";
	            return config;
	        };
	        ApplicationInsights.Version = "2.6.1";
	        return ApplicationInsights;
	    }(BaseTelemetryPlugin));
	    var Timing = /** @class */ (function () {
	        function Timing(logger, name) {
	            var _self = this;
	            var _events = {};
	            _self.start = function (name) {
	                if (typeof _events[name] !== "undefined") {
	                    logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.StartCalledMoreThanOnce, "start was called more than once for this event without calling stop.", { name: name, key: name }, true);
	                }
	                _events[name] = +new Date;
	            };
	            _self.stop = function (name, url, properties, measurements) {
	                var start = _events[name];
	                if (isNaN(start)) {
	                    logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.StopCalledWithoutStart, "stop was called without a corresponding start.", { name: name, key: name }, true);
	                }
	                else {
	                    var end = +new Date;
	                    var duration = dateTimeUtilsDuration(start, end);
	                    _self.action(name, url, duration, properties, measurements);
	                }
	                delete _events[name];
	                _events[name] = undefined;
	            };
	        }
	        return Timing;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Channel, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var ArraySendBuffer = /** @class */ (function () {
	        function ArraySendBuffer(config) {
	            var _buffer = [];
	            dynamicProto(ArraySendBuffer, this, function (_self) {
	                _self.enqueue = function (payload) {
	                    _buffer.push(payload);
	                };
	                _self.count = function () {
	                    return _buffer.length;
	                };
	                _self.clear = function () {
	                    _buffer.length = 0;
	                };
	                _self.getItems = function () {
	                    return _buffer.slice(0);
	                };
	                _self.batchPayloads = function (payload) {
	                    if (payload && payload.length > 0) {
	                        var batch = config.emitLineDelimitedJson() ?
	                            payload.join("\n") :
	                            "[" + payload.join(",") + "]";
	                        return batch;
	                    }
	                    return null;
	                };
	                _self.markAsSent = function (payload) {
	                    _self.clear();
	                };
	                _self.clearSent = function (payload) {
	                };
	            });
	        }
	        return ArraySendBuffer;
	    }());
	    var SessionStorageSendBuffer = /** @class */ (function () {
	        function SessionStorageSendBuffer(logger, config) {
	            var _bufferFullMessageSent = false;
	            var _buffer;
	            dynamicProto(SessionStorageSendBuffer, this, function (_self) {
	                var bufferItems = _getBuffer(SessionStorageSendBuffer.BUFFER_KEY);
	                var notDeliveredItems = _getBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY);
	                _buffer = bufferItems.concat(notDeliveredItems);
	                if (_buffer.length > SessionStorageSendBuffer.MAX_BUFFER_SIZE) {
	                    _buffer.length = SessionStorageSendBuffer.MAX_BUFFER_SIZE;
	                }
	                _setBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY, []);
	                _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _buffer);
	                _self.enqueue = function (payload) {
	                    if (_buffer.length >= SessionStorageSendBuffer.MAX_BUFFER_SIZE) {
	                        if (!_bufferFullMessageSent) {
	                            logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.SessionStorageBufferFull, "Maximum buffer size reached: " + _buffer.length, true);
	                            _bufferFullMessageSent = true;
	                        }
	                        return;
	                    }
	                    _buffer.push(payload);
	                    _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _buffer);
	                };
	                _self.count = function () {
	                    return _buffer.length;
	                };
	                _self.clear = function () {
	                    _buffer = [];
	                    _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, []);
	                    _setBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY, []);
	                    _bufferFullMessageSent = false;
	                };
	                _self.getItems = function () {
	                    return _buffer.slice(0);
	                };
	                _self.batchPayloads = function (payload) {
	                    if (payload && payload.length > 0) {
	                        var batch = config.emitLineDelimitedJson() ?
	                            payload.join("\n") :
	                            "[" + payload.join(",") + "]";
	                        return batch;
	                    }
	                    return null;
	                };
	                _self.markAsSent = function (payload) {
	                    _buffer = _removePayloadsFromBuffer(payload, _buffer);
	                    _setBuffer(SessionStorageSendBuffer.BUFFER_KEY, _buffer);
	                    var sentElements = _getBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY);
	                    if (sentElements instanceof Array && payload instanceof Array) {
	                        sentElements = sentElements.concat(payload);
	                        if (sentElements.length > SessionStorageSendBuffer.MAX_BUFFER_SIZE) {
	                            logger.throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.SessionStorageBufferFull, "Sent buffer reached its maximum size: " + sentElements.length, true);
	                            sentElements.length = SessionStorageSendBuffer.MAX_BUFFER_SIZE;
	                        }
	                        _setBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY, sentElements);
	                    }
	                };
	                _self.clearSent = function (payload) {
	                    var sentElements = _getBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY);
	                    sentElements = _removePayloadsFromBuffer(payload, sentElements);
	                    _setBuffer(SessionStorageSendBuffer.SENT_BUFFER_KEY, sentElements);
	                };
	                function _removePayloadsFromBuffer(payloads, buffer) {
	                    var remaining = [];
	                    arrForEach(buffer, function (value) {
	                        if (!isFunction(value) && arrIndexOf(payloads, value) === -1) {
	                            remaining.push(value);
	                        }
	                    });
	                    return remaining;
	                }
	                function _getBuffer(key) {
	                    var prefixedKey = key;
	                    try {
	                        prefixedKey = config.namePrefix && config.namePrefix() ? config.namePrefix() + "_" + prefixedKey : prefixedKey;
	                        var bufferJson = utlGetSessionStorage(logger, prefixedKey);
	                        if (bufferJson) {
	                            var buffer = getJSON().parse(bufferJson);
	                            if (isString(buffer)) {
	                                buffer = getJSON().parse(buffer);
	                            }
	                            if (buffer && isArray(buffer)) {
	                                return buffer;
	                            }
	                        }
	                    }
	                    catch (e) {
	                        logger.throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.FailedToRestoreStorageBuffer, " storage key: " + prefixedKey + ", " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                    return [];
	                }
	                function _setBuffer(key, buffer) {
	                    var prefixedKey = key;
	                    try {
	                        prefixedKey = config.namePrefix && config.namePrefix() ? config.namePrefix() + "_" + prefixedKey : prefixedKey;
	                        var bufferJson = JSON.stringify(buffer);
	                        utlSetSessionStorage(logger, prefixedKey, bufferJson);
	                    }
	                    catch (e) {
	                        utlSetSessionStorage(logger, prefixedKey, JSON.stringify([]));
	                        logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.FailedToSetStorageBuffer, " storage key: " + prefixedKey + ", " + getExceptionName(e) + ". Buffer cleared", { exception: dumpObj(e) });
	                    }
	                }
	            });
	        }
	        SessionStorageSendBuffer.BUFFER_KEY = "AI_buffer";
	        SessionStorageSendBuffer.SENT_BUFFER_KEY = "AI_sentBuffer";
	        SessionStorageSendBuffer.MAX_BUFFER_SIZE = 2000;
	        return SessionStorageSendBuffer;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Channel, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var strBaseType = 'baseType';
	    var strBaseData = 'baseData';
	    var strProperties$1 = 'properties';
	    var strTrue = 'true';
	    function _setValueIf(target, field, value) {
	        return setValue(target, field, value, isTruthy);
	    }
	    var EnvelopeCreator = /** @class */ (function () {
	        function EnvelopeCreator() {
	        }
	        EnvelopeCreator.extractPropsAndMeasurements = function (data, properties, measurements) {
	            if (!isNullOrUndefined(data)) {
	                objForEachKey(data, function (key, value) {
	                    if (isNumber(value)) {
	                        measurements[key] = value;
	                    }
	                    else if (isString(value)) {
	                        properties[key] = value;
	                    }
	                    else if (hasJSON()) {
	                        properties[key] = getJSON().stringify(value);
	                    }
	                });
	            }
	        };
	        EnvelopeCreator.createEnvelope = function (logger, envelopeType, telemetryItem, data) {
	            var envelope = new Envelope(logger, data, envelopeType);
	            _setValueIf(envelope, 'sampleRate', telemetryItem[SampleRate]);
	            if ((telemetryItem[strBaseData] || {}).startTime) {
	                envelope.time = toISOString(telemetryItem[strBaseData].startTime);
	            }
	            envelope.iKey = telemetryItem.iKey;
	            var iKeyNoDashes = telemetryItem.iKey.replace(/-/g, "");
	            envelope.name = envelope.name.replace("{0}", iKeyNoDashes);
	            EnvelopeCreator.extractPartAExtensions(telemetryItem, envelope);
	            telemetryItem.tags = telemetryItem.tags || [];
	            return optimizeObject(envelope);
	        };
	        EnvelopeCreator.extractPartAExtensions = function (item, env) {
	            var envTags = env.tags = env.tags || {};
	            var itmExt = item.ext = item.ext || {};
	            var itmTags = item.tags = item.tags || [];
	            var extUser = itmExt.user;
	            if (extUser) {
	                _setValueIf(envTags, CtxTagKeys.userAuthUserId, extUser.authId);
	                _setValueIf(envTags, CtxTagKeys.userId, extUser.id || extUser.localId);
	            }
	            var extApp = itmExt.app;
	            if (extApp) {
	                _setValueIf(envTags, CtxTagKeys.sessionId, extApp.sesId);
	            }
	            var extDevice = itmExt.device;
	            if (extDevice) {
	                _setValueIf(envTags, CtxTagKeys.deviceId, extDevice.id || extDevice.localId);
	                _setValueIf(envTags, CtxTagKeys.deviceType, extDevice.deviceClass);
	                _setValueIf(envTags, CtxTagKeys.deviceIp, extDevice.ip);
	                _setValueIf(envTags, CtxTagKeys.deviceModel, extDevice.model);
	                _setValueIf(envTags, CtxTagKeys.deviceType, extDevice.deviceType);
	            }
	            var web = item.ext.web;
	            if (web) {
	                _setValueIf(envTags, CtxTagKeys.deviceLanguage, web.browserLang);
	                _setValueIf(envTags, CtxTagKeys.deviceBrowserVersion, web.browserVer);
	                _setValueIf(envTags, CtxTagKeys.deviceBrowser, web.browser);
	                var envData = env.data = env.data || {};
	                var envBaseData = envData[strBaseData] = envData[strBaseData] || {};
	                var envProps = envBaseData[strProperties$1] = envBaseData[strProperties$1] || {};
	                _setValueIf(envProps, 'domain', web.domain);
	                _setValueIf(envProps, 'isManual', web.isManual ? strTrue : null);
	                _setValueIf(envProps, 'screenRes', web.screenRes);
	                _setValueIf(envProps, 'userConsent', web.userConsent ? strTrue : null);
	            }
	            var extOs = itmExt.os;
	            if (extOs) {
	                _setValueIf(envTags, CtxTagKeys.deviceOS, extOs.name);
	            }
	            var extTrace = itmExt.trace;
	            if (extTrace) {
	                _setValueIf(envTags, CtxTagKeys.operationParentId, extTrace.parentID);
	                _setValueIf(envTags, CtxTagKeys.operationName, extTrace.name);
	                _setValueIf(envTags, CtxTagKeys.operationId, extTrace.traceID);
	            }
	            var tgs = {};
	            for (var i = itmTags.length - 1; i >= 0; i--) {
	                var tg = itmTags[i];
	                objForEachKey(tg, function (key, value) {
	                    tgs[key] = value;
	                });
	                itmTags.splice(i, 1);
	            }
	            objForEachKey(itmTags, function (tg, value) {
	                tgs[tg] = value;
	            });
	            var theTags = __assign({}, envTags, tgs);
	            if (!theTags[CtxTagKeys.internalSdkVersion]) {
	                theTags[CtxTagKeys.internalSdkVersion] = "javascript:" + EnvelopeCreator.Version;
	            }
	            env.tags = optimizeObject(theTags);
	        };
	        EnvelopeCreator.prototype.Init = function (logger, telemetryItem) {
	            this._logger = logger;
	            if (isNullOrUndefined(telemetryItem[strBaseData])) {
	                this._logger.throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.TelemetryEnvelopeInvalid, "telemetryItem.baseData cannot be null.");
	            }
	        };
	        EnvelopeCreator.Version = "2.6.1";
	        return EnvelopeCreator;
	    }());
	    var DependencyEnvelopeCreator = /** @class */ (function (_super) {
	        __extends(DependencyEnvelopeCreator, _super);
	        function DependencyEnvelopeCreator() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        DependencyEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
	            _super.prototype.Init.call(this, logger, telemetryItem);
	            var customMeasurements = telemetryItem[strBaseData].measurements || {};
	            var customProperties = telemetryItem[strBaseData][strProperties$1] || {};
	            EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, customProperties, customMeasurements);
	            var bd = telemetryItem[strBaseData];
	            if (isNullOrUndefined(bd)) {
	                logger.warnToConsole("Invalid input for dependency data");
	                return null;
	            }
	            var method = bd[strProperties$1] && bd[strProperties$1][HttpMethod] ? bd[strProperties$1][HttpMethod] : "GET";
	            var remoteDepData = new RemoteDependencyData(logger, bd.id, bd.target, bd.name, bd.duration, bd.success, bd.responseCode, method, bd.type, bd.correlationContext, customProperties, customMeasurements);
	            var data = new Data(RemoteDependencyData.dataType, remoteDepData);
	            return EnvelopeCreator.createEnvelope(logger, RemoteDependencyData.envelopeType, telemetryItem, data);
	        };
	        DependencyEnvelopeCreator.DependencyEnvelopeCreator = new DependencyEnvelopeCreator();
	        return DependencyEnvelopeCreator;
	    }(EnvelopeCreator));
	    var EventEnvelopeCreator = /** @class */ (function (_super) {
	        __extends(EventEnvelopeCreator, _super);
	        function EventEnvelopeCreator() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        EventEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
	            _super.prototype.Init.call(this, logger, telemetryItem);
	            var customProperties = {};
	            var customMeasurements = {};
	            if (telemetryItem[strBaseType] !== Event$1.dataType) {
	                customProperties['baseTypeSource'] = telemetryItem[strBaseType];
	            }
	            if (telemetryItem[strBaseType] === Event$1.dataType) {
	                customProperties = telemetryItem[strBaseData][strProperties$1] || {};
	                customMeasurements = telemetryItem[strBaseData].measurements || {};
	            }
	            else {
	                if (telemetryItem[strBaseData]) {
	                    EnvelopeCreator.extractPropsAndMeasurements(telemetryItem[strBaseData], customProperties, customMeasurements);
	                }
	            }
	            EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, customProperties, customMeasurements);
	            var eventName = telemetryItem[strBaseData].name;
	            var eventData = new Event$1(logger, eventName, customProperties, customMeasurements);
	            var data = new Data(Event$1.dataType, eventData);
	            return EnvelopeCreator.createEnvelope(logger, Event$1.envelopeType, telemetryItem, data);
	        };
	        EventEnvelopeCreator.EventEnvelopeCreator = new EventEnvelopeCreator();
	        return EventEnvelopeCreator;
	    }(EnvelopeCreator));
	    var ExceptionEnvelopeCreator = /** @class */ (function (_super) {
	        __extends(ExceptionEnvelopeCreator, _super);
	        function ExceptionEnvelopeCreator() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        ExceptionEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
	            _super.prototype.Init.call(this, logger, telemetryItem);
	            var customMeasurements = telemetryItem[strBaseData].measurements || {};
	            var customProperties = telemetryItem[strBaseData][strProperties$1] || {};
	            EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, customProperties, customMeasurements);
	            var bd = telemetryItem[strBaseData];
	            var exData = Exception.CreateFromInterface(logger, bd, customProperties, customMeasurements);
	            var data = new Data(Exception.dataType, exData);
	            return EnvelopeCreator.createEnvelope(logger, Exception.envelopeType, telemetryItem, data);
	        };
	        ExceptionEnvelopeCreator.ExceptionEnvelopeCreator = new ExceptionEnvelopeCreator();
	        return ExceptionEnvelopeCreator;
	    }(EnvelopeCreator));
	    var MetricEnvelopeCreator = /** @class */ (function (_super) {
	        __extends(MetricEnvelopeCreator, _super);
	        function MetricEnvelopeCreator() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        MetricEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
	            _super.prototype.Init.call(this, logger, telemetryItem);
	            var baseData = telemetryItem[strBaseData];
	            var props = baseData[strProperties$1] || {};
	            var measurements = baseData.measurements || {};
	            EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, props, measurements);
	            var baseMetricData = new Metric(logger, baseData.name, baseData.average, baseData.sampleCount, baseData.min, baseData.max, props, measurements);
	            var data = new Data(Metric.dataType, baseMetricData);
	            return EnvelopeCreator.createEnvelope(logger, Metric.envelopeType, telemetryItem, data);
	        };
	        MetricEnvelopeCreator.MetricEnvelopeCreator = new MetricEnvelopeCreator();
	        return MetricEnvelopeCreator;
	    }(EnvelopeCreator));
	    var PageViewEnvelopeCreator = /** @class */ (function (_super) {
	        __extends(PageViewEnvelopeCreator, _super);
	        function PageViewEnvelopeCreator() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        PageViewEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
	            _super.prototype.Init.call(this, logger, telemetryItem);
	            var strDuration = "duration";
	            var duration;
	            var baseData = telemetryItem[strBaseData];
	            if (!isNullOrUndefined(baseData) &&
	                !isNullOrUndefined(baseData[strProperties$1]) &&
	                !isNullOrUndefined(baseData[strProperties$1][strDuration])) {
	                duration = baseData[strProperties$1][strDuration];
	                delete baseData[strProperties$1][strDuration];
	            }
	            else if (!isNullOrUndefined(telemetryItem.data) &&
	                !isNullOrUndefined(telemetryItem.data[strDuration])) {
	                duration = telemetryItem.data[strDuration];
	                delete telemetryItem.data[strDuration];
	            }
	            var bd = telemetryItem[strBaseData];
	            var currentContextId;
	            if (((telemetryItem.ext || {}).trace || {}).traceID) {
	                currentContextId = telemetryItem.ext.trace.traceID;
	            }
	            var id = bd.id || currentContextId;
	            var name = bd.name;
	            var url = bd.uri;
	            var properties = bd[strProperties$1] || {};
	            var measurements = bd.measurements || {};
	            if (!isNullOrUndefined(bd.refUri)) {
	                properties["refUri"] = bd.refUri;
	            }
	            if (!isNullOrUndefined(bd.pageType)) {
	                properties["pageType"] = bd.pageType;
	            }
	            if (!isNullOrUndefined(bd.isLoggedIn)) {
	                properties["isLoggedIn"] = bd.isLoggedIn.toString();
	            }
	            if (!isNullOrUndefined(bd[strProperties$1])) {
	                var pageTags = bd[strProperties$1];
	                objForEachKey(pageTags, function (key, value) {
	                    properties[key] = value;
	                });
	            }
	            EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, properties, measurements);
	            var pageViewData = new PageView(logger, name, url, duration, properties, measurements, id);
	            var data = new Data(PageView.dataType, pageViewData);
	            return EnvelopeCreator.createEnvelope(logger, PageView.envelopeType, telemetryItem, data);
	        };
	        PageViewEnvelopeCreator.PageViewEnvelopeCreator = new PageViewEnvelopeCreator();
	        return PageViewEnvelopeCreator;
	    }(EnvelopeCreator));
	    var PageViewPerformanceEnvelopeCreator = /** @class */ (function (_super) {
	        __extends(PageViewPerformanceEnvelopeCreator, _super);
	        function PageViewPerformanceEnvelopeCreator() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        PageViewPerformanceEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
	            _super.prototype.Init.call(this, logger, telemetryItem);
	            var bd = telemetryItem[strBaseData];
	            var name = bd.name;
	            var url = bd.uri || bd.url;
	            var properties = bd[strProperties$1] || {};
	            var measurements = bd.measurements || {};
	            EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, properties, measurements);
	            var baseData = new PageViewPerformance(logger, name, url, undefined, properties, measurements, bd);
	            var data = new Data(PageViewPerformance.dataType, baseData);
	            return EnvelopeCreator.createEnvelope(logger, PageViewPerformance.envelopeType, telemetryItem, data);
	        };
	        PageViewPerformanceEnvelopeCreator.PageViewPerformanceEnvelopeCreator = new PageViewPerformanceEnvelopeCreator();
	        return PageViewPerformanceEnvelopeCreator;
	    }(EnvelopeCreator));
	    var TraceEnvelopeCreator = /** @class */ (function (_super) {
	        __extends(TraceEnvelopeCreator, _super);
	        function TraceEnvelopeCreator() {
	            return _super !== null && _super.apply(this, arguments) || this;
	        }
	        TraceEnvelopeCreator.prototype.Create = function (logger, telemetryItem) {
	            _super.prototype.Init.call(this, logger, telemetryItem);
	            var message = telemetryItem[strBaseData].message;
	            var severityLevel = telemetryItem[strBaseData].severityLevel;
	            var props = telemetryItem[strBaseData][strProperties$1] || {};
	            var measurements = telemetryItem[strBaseData].measurements || {};
	            EnvelopeCreator.extractPropsAndMeasurements(telemetryItem.data, props, measurements);
	            var baseData = new Trace(logger, message, severityLevel, props, measurements);
	            var data = new Data(Trace.dataType, baseData);
	            return EnvelopeCreator.createEnvelope(logger, Trace.envelopeType, telemetryItem, data);
	        };
	        TraceEnvelopeCreator.TraceEnvelopeCreator = new TraceEnvelopeCreator();
	        return TraceEnvelopeCreator;
	    }(EnvelopeCreator));
	
	    /*!
	     * Application Insights JavaScript SDK - Channel, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var Serializer = /** @class */ (function () {
	        function Serializer(logger) {
	            dynamicProto(Serializer, this, function (_self) {
	                _self.serialize = function (input) {
	                    var output = _serializeObject(input, "root");
	                    try {
	                        return getJSON().stringify(output);
	                    }
	                    catch (e) {
	                        logger.throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.CannotSerializeObject, (e && isFunction(e.toString)) ? e.toString() : "Error serializing object", null, true);
	                    }
	                };
	                function _serializeObject(source, name) {
	                    var circularReferenceCheck = "__aiCircularRefCheck";
	                    var output = {};
	                    if (!source) {
	                        logger.throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.CannotSerializeObject, "cannot serialize object because it is null or undefined", { name: name }, true);
	                        return output;
	                    }
	                    if (source[circularReferenceCheck]) {
	                        logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.CircularReferenceDetected, "Circular reference detected while serializing object", { name: name }, true);
	                        return output;
	                    }
	                    if (!source.aiDataContract) {
	                        if (name === "measurements") {
	                            output = _serializeStringMap(source, "number", name);
	                        }
	                        else if (name === "properties") {
	                            output = _serializeStringMap(source, "string", name);
	                        }
	                        else if (name === "tags") {
	                            output = _serializeStringMap(source, "string", name);
	                        }
	                        else if (isArray(source)) {
	                            output = _serializeArray(source, name);
	                        }
	                        else {
	                            logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.CannotSerializeObjectNonSerializable, "Attempting to serialize an object which does not implement ISerializable", { name: name }, true);
	                            try {
	                                getJSON().stringify(source);
	                                output = source;
	                            }
	                            catch (e) {
	                                logger.throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.CannotSerializeObject, (e && isFunction(e.toString)) ? e.toString() : "Error serializing object", null, true);
	                            }
	                        }
	                        return output;
	                    }
	                    source[circularReferenceCheck] = true;
	                    objForEachKey(source.aiDataContract, function (field, contract) {
	                        var isRequired = (isFunction(contract)) ? (contract() & FieldType.Required) : (contract & FieldType.Required);
	                        var isHidden = (isFunction(contract)) ? (contract() & FieldType.Hidden) : (contract & FieldType.Hidden);
	                        var isArray = contract & FieldType.Array;
	                        var isPresent = source[field] !== undefined;
	                        var isObj = isObject(source[field]) && source[field] !== null;
	                        if (isRequired && !isPresent && !isArray) {
	                            logger.throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.MissingRequiredFieldSpecification, "Missing required field specification. The field is required but not present on source", { field: field, name: name });
	                        }
	                        else if (!isHidden) {
	                            var value = void 0;
	                            if (isObj) {
	                                if (isArray) {
	                                    value = _serializeArray(source[field], field);
	                                }
	                                else {
	                                    value = _serializeObject(source[field], field);
	                                }
	                            }
	                            else {
	                                value = source[field];
	                            }
	                            if (value !== undefined) {
	                                output[field] = value;
	                            }
	                        }
	                    });
	                    delete source[circularReferenceCheck];
	                    return output;
	                }
	                function _serializeArray(sources, name) {
	                    var output;
	                    if (!!sources) {
	                        if (!isArray(sources)) {
	                            logger.throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.ItemNotInArray, "This field was specified as an array in the contract but the item is not an array.\r\n", { name: name }, true);
	                        }
	                        else {
	                            output = [];
	                            for (var i = 0; i < sources.length; i++) {
	                                var source = sources[i];
	                                var item = _serializeObject(source, name + "[" + i + "]");
	                                output.push(item);
	                            }
	                        }
	                    }
	                    return output;
	                }
	                function _serializeStringMap(map, expectedType, name) {
	                    var output;
	                    if (map) {
	                        output = {};
	                        objForEachKey(map, function (field, value) {
	                            if (expectedType === "string") {
	                                if (value === undefined) {
	                                    output[field] = "undefined";
	                                }
	                                else if (value === null) {
	                                    output[field] = "null";
	                                }
	                                else if (!value.toString) {
	                                    output[field] = "invalid field: toString() is not defined.";
	                                }
	                                else {
	                                    output[field] = value.toString();
	                                }
	                            }
	                            else if (expectedType === "number") {
	                                if (value === undefined) {
	                                    output[field] = "undefined";
	                                }
	                                else if (value === null) {
	                                    output[field] = "null";
	                                }
	                                else {
	                                    var num = parseFloat(value);
	                                    if (isNaN(num)) {
	                                        output[field] = "NaN";
	                                    }
	                                    else {
	                                        output[field] = num;
	                                    }
	                                }
	                            }
	                            else {
	                                output[field] = "invalid field: " + name + " is of unknown type.";
	                                logger.throwInternal(exports.LoggingSeverity.CRITICAL, output[field], null, true);
	                            }
	                        });
	                    }
	                    return output;
	                }
	            });
	        }
	        return Serializer;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Channel, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var OfflineListener = /** @class */ (function () {
	        function OfflineListener() {
	            var _window = getWindow();
	            var _document = getDocument();
	            var isListening = false;
	            var _onlineStatus = true;
	            dynamicProto(OfflineListener, this, function (_self) {
	                try {
	                    if (_window) {
	                        if (EventHelper.Attach(_window, 'online', _setOnline)) {
	                            EventHelper.Attach(_window, 'offline', _setOffline);
	                            isListening = true;
	                        }
	                    }
	                    if (_document) {
	                        var target = _document.body || _document;
	                        if (!isUndefined(target.ononline)) {
	                            target.ononline = _setOnline;
	                            target.onoffline = _setOffline;
	                            isListening = true;
	                        }
	                    }
	                }
	                catch (e) {
	                    isListening = false;
	                }
	                _self.isListening = isListening;
	                _self.isOnline = function () {
	                    var result = true;
	                    var _navigator = getNavigator();
	                    if (isListening) {
	                        result = _onlineStatus;
	                    }
	                    else if (_navigator && !isNullOrUndefined(_navigator.onLine)) {
	                        result = _navigator.onLine;
	                    }
	                    return result;
	                };
	                _self.isOffline = function () {
	                    return !_self.isOnline();
	                };
	                function _setOnline() {
	                    _onlineStatus = true;
	                }
	                function _setOffline() {
	                    _onlineStatus = false;
	                }
	            });
	        }
	        OfflineListener.Offline = new OfflineListener;
	        return OfflineListener;
	    }());
	    var Offline = OfflineListener.Offline;
	
	    /*!
	     * Application Insights JavaScript SDK - Channel, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var HashCodeScoreGenerator = /** @class */ (function () {
	        function HashCodeScoreGenerator() {
	        }
	        HashCodeScoreGenerator.prototype.getHashCodeScore = function (key) {
	            var score = this.getHashCode(key) / HashCodeScoreGenerator.INT_MAX_VALUE;
	            return score * 100;
	        };
	        HashCodeScoreGenerator.prototype.getHashCode = function (input) {
	            if (input === "") {
	                return 0;
	            }
	            while (input.length < HashCodeScoreGenerator.MIN_INPUT_LENGTH) {
	                input = input.concat(input);
	            }
	            var hash = 5381;
	            for (var i = 0; i < input.length; ++i) {
	                hash = ((hash << 5) + hash) + input.charCodeAt(i);
	                hash = hash & hash;
	            }
	            return Math.abs(hash);
	        };
	        HashCodeScoreGenerator.INT_MAX_VALUE = 2147483647;
	        HashCodeScoreGenerator.MIN_INPUT_LENGTH = 8;
	        return HashCodeScoreGenerator;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Channel, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var SamplingScoreGenerator = /** @class */ (function () {
	        function SamplingScoreGenerator() {
	            this.hashCodeGeneragor = new HashCodeScoreGenerator();
	            this.keys = new ContextTagKeys();
	        }
	        SamplingScoreGenerator.prototype.getSamplingScore = function (item) {
	            var score = 0;
	            if (item.tags && item.tags[this.keys.userId]) {
	                score = this.hashCodeGeneragor.getHashCodeScore(item.tags[this.keys.userId]);
	            }
	            else if (item.ext && item.ext.user && item.ext.user.id) {
	                score = this.hashCodeGeneragor.getHashCodeScore(item.ext.user.id);
	            }
	            else if (item.tags && item.tags[this.keys.operationId]) {
	                score = this.hashCodeGeneragor.getHashCodeScore(item.tags[this.keys.operationId]);
	            }
	            else if (item.ext && item.ext.telemetryTrace && item.ext.telemetryTrace.traceID) {
	                score = this.hashCodeGeneragor.getHashCodeScore(item.ext.telemetryTrace.traceID);
	            }
	            else {
	                score = (Math.random() * 100);
	            }
	            return score;
	        };
	        return SamplingScoreGenerator;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Channel, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var Sample = /** @class */ (function () {
	        function Sample(sampleRate, logger) {
	            this.INT_MAX_VALUE = 2147483647;
	            this._logger = logger || safeGetLogger(null);
	            if (sampleRate > 100 || sampleRate < 0) {
	                this._logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.SampleRateOutOfRange, "Sampling rate is out of range (0..100). Sampling will be disabled, you may be sending too much data which may affect your AI service level.", { samplingRate: sampleRate }, true);
	                this.sampleRate = 100;
	            }
	            this.sampleRate = sampleRate;
	            this.samplingScoreGenerator = new SamplingScoreGenerator();
	        }
	        Sample.prototype.isSampledIn = function (envelope) {
	            var samplingPercentage = this.sampleRate;
	            var isSampledIn = false;
	            if (samplingPercentage === null || samplingPercentage === undefined || samplingPercentage >= 100) {
	                return true;
	            }
	            else if (envelope.baseType === Metric.dataType) {
	                return true;
	            }
	            isSampledIn = this.samplingScoreGenerator.getSamplingScore(envelope) < samplingPercentage;
	            return isSampledIn;
	        };
	        return Sample;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Channel, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    function _getResponseText(xhr) {
	        try {
	            return xhr.responseText;
	        }
	        catch (e) {
	        }
	        return null;
	    }
	    var Sender = /** @class */ (function (_super) {
	        __extends(Sender, _super);
	        function Sender() {
	            var _this = _super.call(this) || this;
	            _this.priority = 1001;
	            _this.identifier = BreezeChannelIdentifier;
	            _this._XMLHttpRequestSupported = false;
	            var _consecutiveErrors;
	            var _retryAt;
	            var _lastSend;
	            var _timeoutHandle;
	            var _serializer;
	            var _stamp_specific_redirects;
	            dynamicProto(Sender, _this, function (_self, _base) {
	                function _notImplemented() {
	                    throwError("Method not implemented.");
	                }
	                _self.pause = _notImplemented;
	                _self.resume = _notImplemented;
	                _self.flush = function () {
	                    try {
	                        _self.triggerSend(true, null, 1 );
	                    }
	                    catch (e) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.FlushFailed, "flush failed, telemetry will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                };
	                _self.onunloadFlush = function () {
	                    if ((_self._senderConfig.onunloadDisableBeacon() === false || _self._senderConfig.isBeaconApiDisabled() === false) && isBeaconApiSupported()) {
	                        try {
	                            _self.triggerSend(true, _beaconSender, 2 );
	                        }
	                        catch (e) {
	                            _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.FailedToSendQueuedTelemetry, "failed to flush with beacon sender on page unload, telemetry will not be collected: " + getExceptionName(e), { exception: dumpObj(e) });
	                        }
	                    }
	                    else {
	                        _self.flush();
	                    }
	                };
	                _self.teardown = _notImplemented;
	                _self.initialize = function (config, core, extensions, pluginChain) {
	                    _base.initialize(config, core, extensions, pluginChain);
	                    var ctx = _self._getTelCtx();
	                    var identifier = _self.identifier;
	                    _serializer = new Serializer(core.logger);
	                    _consecutiveErrors = 0;
	                    _retryAt = null;
	                    _lastSend = 0;
	                    _self._sender = null;
	                    _stamp_specific_redirects = 0;
	                    var defaultConfig = Sender._getDefaultAppInsightsChannelConfig();
	                    _self._senderConfig = Sender._getEmptyAppInsightsChannelConfig();
	                    objForEachKey(defaultConfig, function (field, value) {
	                        _self._senderConfig[field] = function () { return ctx.getConfig(identifier, field, value()); };
	                    });
	                    _self._buffer = (_self._senderConfig.enableSessionStorageBuffer() && utlCanUseSessionStorage())
	                        ? new SessionStorageSendBuffer(_self.diagLog(), _self._senderConfig) : new ArraySendBuffer(_self._senderConfig);
	                    _self._sample = new Sample(_self._senderConfig.samplingPercentage(), _self.diagLog());
	                    if (!_validateInstrumentationKey(config)) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.InvalidInstrumentationKey, "Invalid Instrumentation key " + config.instrumentationKey);
	                    }
	                    if (!_self._senderConfig.isBeaconApiDisabled() && isBeaconApiSupported()) {
	                        _self._sender = _beaconSender;
	                    }
	                    else {
	                        if (typeof XMLHttpRequest !== undefined) {
	                            var xhr = getGlobalInst("XMLHttpRequest");
	                            if (xhr) {
	                                var testXhr = new xhr();
	                                if ("withCredentials" in testXhr) {
	                                    _self._sender = _xhrSender;
	                                    _self._XMLHttpRequestSupported = true;
	                                }
	                                else if (typeof XDomainRequest !== undefined) {
	                                    _self._sender = _xdrSender;
	                                }
	                            }
	                        }
	                    }
	                };
	                _self.processTelemetry = function (telemetryItem, itemCtx) {
	                    itemCtx = _self._getTelCtx(itemCtx);
	                    try {
	                        if (_self._senderConfig.disableTelemetry()) {
	                            return;
	                        }
	                        if (!telemetryItem) {
	                            itemCtx.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.CannotSendEmptyTelemetry, "Cannot send empty telemetry");
	                            return;
	                        }
	                        if (telemetryItem.baseData && !telemetryItem.baseType) {
	                            itemCtx.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.InvalidEvent, "Cannot send telemetry without baseData and baseType");
	                            return;
	                        }
	                        if (!telemetryItem.baseType) {
	                            telemetryItem.baseType = "EventData";
	                        }
	                        if (!_self._sender) {
	                            itemCtx.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.SenderNotInitialized, "Sender was not initialized");
	                            return;
	                        }
	                        if (!_isSampledIn(telemetryItem)) {
	                            itemCtx.diagLog().throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.TelemetrySampledAndNotSent, "Telemetry item was sampled out and not sent", { SampleRate: _self._sample.sampleRate });
	                            return;
	                        }
	                        else {
	                            telemetryItem[SampleRate] = _self._sample.sampleRate;
	                        }
	                        var aiEnvelope_1 = Sender.constructEnvelope(telemetryItem, _self._senderConfig.instrumentationKey(), itemCtx.diagLog());
	                        if (!aiEnvelope_1) {
	                            itemCtx.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.CreateEnvelopeError, "Unable to create an AppInsights envelope");
	                            return;
	                        }
	                        var doNotSendItem_1 = false;
	                        if (telemetryItem.tags && telemetryItem.tags[ProcessLegacy]) {
	                            arrForEach(telemetryItem.tags[ProcessLegacy], function (callBack) {
	                                try {
	                                    if (callBack && callBack(aiEnvelope_1) === false) {
	                                        doNotSendItem_1 = true;
	                                        itemCtx.diagLog().warnToConsole("Telemetry processor check returns false");
	                                    }
	                                }
	                                catch (e) {
	                                    itemCtx.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.TelemetryInitializerFailed, "One of telemetry initializers failed, telemetry item will not be sent: " + getExceptionName(e), { exception: dumpObj(e) }, true);
	                                }
	                            });
	                            delete telemetryItem.tags[ProcessLegacy];
	                        }
	                        if (doNotSendItem_1) {
	                            return;
	                        }
	                        var payload = _serializer.serialize(aiEnvelope_1);
	                        var bufferPayload = _self._buffer.getItems();
	                        var batch = _self._buffer.batchPayloads(bufferPayload);
	                        if (batch && (batch.length + payload.length > _self._senderConfig.maxBatchSizeInBytes())) {
	                            _self.triggerSend(true, null, 10 );
	                        }
	                        _self._buffer.enqueue(payload);
	                        _setupTimer();
	                    }
	                    catch (e) {
	                        itemCtx.diagLog().throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.FailedAddingTelemetryToBuffer, "Failed adding telemetry to the sender's buffer, some telemetry will be lost: " + getExceptionName(e), { exception: dumpObj(e) });
	                    }
	                    _self.processNext(telemetryItem, itemCtx);
	                };
	                _self._xhrReadyStateChange = function (xhr, payload, countOfItemsInPayload) {
	                    if (xhr.readyState === 4) {
	                        var response = null;
	                        if (!_self._appId) {
	                            response = _parseResponse(_getResponseText(xhr) || xhr.response);
	                            if (response && response.appId) {
	                                _self._appId = response.appId;
	                            }
	                        }
	                        if ((xhr.status < 200 || xhr.status >= 300) && xhr.status !== 0) {
	                            if (xhr.status == 301 || xhr.status == 308) {
	                                if (!_checkAndUpdateEndPointUrl(xhr)) {
	                                    _self._onError(payload, _formatErrorMessageXhr(xhr));
	                                    return;
	                                }
	                            }
	                            if (!_self._senderConfig.isRetryDisabled() && _isRetriable(xhr.status)) {
	                                _resendPayload(payload);
	                                _self.diagLog().throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.TransmissionFailed, ". " +
	                                    "Response code " + xhr.status + ". Will retry to send " + payload.length + " items.");
	                            }
	                            else {
	                                _self._onError(payload, _formatErrorMessageXhr(xhr));
	                            }
	                        }
	                        else if (Offline.isOffline()) {
	                            if (!_self._senderConfig.isRetryDisabled()) {
	                                var offlineBackOffMultiplier = 10;
	                                _resendPayload(payload, offlineBackOffMultiplier);
	                                _self.diagLog().throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.TransmissionFailed, ". Offline - Response Code: " + xhr.status + ". Offline status: " + Offline.isOffline() + ". Will retry to send " + payload.length + " items.");
	                            }
	                        }
	                        else {
	                            _checkAndUpdateEndPointUrl(xhr);
	                            if (xhr.status === 206) {
	                                if (!response) {
	                                    response = _parseResponse(_getResponseText(xhr) || xhr.response);
	                                }
	                                if (response && !_self._senderConfig.isRetryDisabled()) {
	                                    _self._onPartialSuccess(payload, response);
	                                }
	                                else {
	                                    _self._onError(payload, _formatErrorMessageXhr(xhr));
	                                }
	                            }
	                            else {
	                                _consecutiveErrors = 0;
	                                _self._onSuccess(payload, countOfItemsInPayload);
	                            }
	                        }
	                    }
	                };
	                _self.triggerSend = function (async, forcedSender, sendReason) {
	                    if (async === void 0) { async = true; }
	                    try {
	                        if (!_self._senderConfig.disableTelemetry()) {
	                            if (_self._buffer.count() > 0) {
	                                var payload = _self._buffer.getItems();
	                                _notifySendRequest(sendReason || 0 , async);
	                                if (forcedSender) {
	                                    forcedSender.call(_this, payload, async);
	                                }
	                                else {
	                                    _self._sender(payload, async);
	                                }
	                            }
	                            _lastSend = +new Date;
	                        }
	                        else {
	                            _self._buffer.clear();
	                        }
	                        clearTimeout(_timeoutHandle);
	                        _timeoutHandle = null;
	                        _retryAt = null;
	                    }
	                    catch (e) {
	                        var ieVer = getIEVersion();
	                        if (!ieVer || ieVer > 9) {
	                            _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.TransmissionFailed, "Telemetry transmission failed, some telemetry will be lost: " + getExceptionName(e), { exception: dumpObj(e) });
	                        }
	                    }
	                };
	                _self._onError = function (payload, message, event) {
	                    _self.diagLog().throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.OnError, "Failed to send telemetry.", { message: message });
	                    _self._buffer.clearSent(payload);
	                };
	                _self._onPartialSuccess = function (payload, results) {
	                    var failed = [];
	                    var retry = [];
	                    var errors = results.errors.reverse();
	                    for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
	                        var error = errors_1[_i];
	                        var extracted = payload.splice(error.index, 1)[0];
	                        if (_isRetriable(error.statusCode)) {
	                            retry.push(extracted);
	                        }
	                        else {
	                            failed.push(extracted);
	                        }
	                    }
	                    if (payload.length > 0) {
	                        _self._onSuccess(payload, results.itemsAccepted);
	                    }
	                    if (failed.length > 0) {
	                        _self._onError(failed, _formatErrorMessageXhr(null, ['partial success', results.itemsAccepted, 'of', results.itemsReceived].join(' ')));
	                    }
	                    if (retry.length > 0) {
	                        _resendPayload(retry);
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.TransmissionFailed, "Partial success. " +
	                            "Delivered: " + payload.length + ", Failed: " + failed.length +
	                            ". Will retry to send " + retry.length + " our of " + results.itemsReceived + " items");
	                    }
	                };
	                _self._onSuccess = function (payload, countOfItemsInPayload) {
	                    _self._buffer.clearSent(payload);
	                };
	                _self._xdrOnLoad = function (xdr, payload) {
	                    var responseText = _getResponseText(xdr);
	                    if (xdr && (responseText + "" === "200" || responseText === "")) {
	                        _consecutiveErrors = 0;
	                        _self._onSuccess(payload, 0);
	                    }
	                    else {
	                        var results = _parseResponse(responseText);
	                        if (results && results.itemsReceived && results.itemsReceived > results.itemsAccepted
	                            && !_self._senderConfig.isRetryDisabled()) {
	                            _self._onPartialSuccess(payload, results);
	                        }
	                        else {
	                            _self._onError(payload, _formatErrorMessageXdr(xdr));
	                        }
	                    }
	                };
	                function _isSampledIn(envelope) {
	                    return _self._sample.isSampledIn(envelope);
	                }
	                function _checkAndUpdateEndPointUrl(xhr) {
	                    var responseUrl = xhr.responseURL;
	                    if (_stamp_specific_redirects >= 10) {
	                        return false;
	                    }
	                    if (!isNullOrUndefined(responseUrl) && responseUrl !== '') {
	                        if (responseUrl !== _self._senderConfig.endpointUrl()) {
	                            _self._senderConfig.endpointUrl = function () { return responseUrl; };
	                            ++_stamp_specific_redirects;
	                            return true;
	                        }
	                    }
	                    return false;
	                }
	                function _beaconSender(payload, isAsync) {
	                    var url = _self._senderConfig.endpointUrl();
	                    var batch = _self._buffer.batchPayloads(payload);
	                    var plainTextBatch = new Blob([batch], { type: 'text/plain;charset=UTF-8' });
	                    var queued = getNavigator().sendBeacon(url, plainTextBatch);
	                    if (queued) {
	                        _self._buffer.markAsSent(payload);
	                        _self._onSuccess(payload, payload.length);
	                    }
	                    else {
	                        _xhrSender(payload, true);
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.TransmissionFailed, ". " + "Failed to send telemetry with Beacon API, retried with xhrSender.");
	                    }
	                }
	                function _xhrSender(payload, isAsync) {
	                    var xhr = new XMLHttpRequest();
	                    var endPointUrl = _self._senderConfig.endpointUrl();
	                    try {
	                        xhr[DisabledPropertyName] = true;
	                    }
	                    catch (e) {
	                    }
	                    xhr.open("POST", endPointUrl, isAsync);
	                    xhr.setRequestHeader("Content-type", "application/json");
	                    if (isInternalApplicationInsightsEndpoint(endPointUrl)) {
	                        xhr.setRequestHeader(RequestHeaders.sdkContextHeader, RequestHeaders.sdkContextHeaderAppIdRequest);
	                    }
	                    xhr.onreadystatechange = function () { return _self._xhrReadyStateChange(xhr, payload, payload.length); };
	                    xhr.onerror = function (event) { return _self._onError(payload, _formatErrorMessageXhr(xhr), event); };
	                    var batch = _self._buffer.batchPayloads(payload);
	                    xhr.send(batch);
	                    _self._buffer.markAsSent(payload);
	                }
	                function _parseResponse(response) {
	                    try {
	                        if (response && response !== "") {
	                            var result = getJSON().parse(response);
	                            if (result && result.itemsReceived && result.itemsReceived >= result.itemsAccepted &&
	                                result.itemsReceived - result.itemsAccepted === result.errors.length) {
	                                return result;
	                            }
	                        }
	                    }
	                    catch (e) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.InvalidBackendResponse, "Cannot parse the response. " + getExceptionName(e), {
	                            response: response
	                        });
	                    }
	                    return null;
	                }
	                function _resendPayload(payload, linearFactor) {
	                    if (linearFactor === void 0) { linearFactor = 1; }
	                    if (!payload || payload.length === 0) {
	                        return;
	                    }
	                    _self._buffer.clearSent(payload);
	                    _consecutiveErrors++;
	                    for (var _i = 0, payload_1 = payload; _i < payload_1.length; _i++) {
	                        var item = payload_1[_i];
	                        _self._buffer.enqueue(item);
	                    }
	                    _setRetryTime(linearFactor);
	                    _setupTimer();
	                }
	                function _setRetryTime(linearFactor) {
	                    var SlotDelayInSeconds = 10;
	                    var delayInSeconds;
	                    if (_consecutiveErrors <= 1) {
	                        delayInSeconds = SlotDelayInSeconds;
	                    }
	                    else {
	                        var backOffSlot = (Math.pow(2, _consecutiveErrors) - 1) / 2;
	                        var backOffDelay = Math.floor(Math.random() * backOffSlot * SlotDelayInSeconds) + 1;
	                        backOffDelay = linearFactor * backOffDelay;
	                        delayInSeconds = Math.max(Math.min(backOffDelay, 3600), SlotDelayInSeconds);
	                    }
	                    var retryAfterTimeSpan = dateNow() + (delayInSeconds * 1000);
	                    _retryAt = retryAfterTimeSpan;
	                }
	                function _setupTimer() {
	                    if (!_timeoutHandle) {
	                        var retryInterval = _retryAt ? Math.max(0, _retryAt - dateNow()) : 0;
	                        var timerValue = Math.max(_self._senderConfig.maxBatchInterval(), retryInterval);
	                        _timeoutHandle = setTimeout(function () {
	                            _self.triggerSend(true, null, 1 );
	                        }, timerValue);
	                    }
	                }
	                function _isRetriable(statusCode) {
	                    return statusCode === 408
	                        || statusCode === 429
	                        || statusCode === 500
	                        || statusCode === 503;
	                }
	                function _formatErrorMessageXhr(xhr, message) {
	                    if (xhr) {
	                        return "XMLHttpRequest,Status:" + xhr.status + ",Response:" + _getResponseText(xhr) || xhr.response || "";
	                    }
	                    return message;
	                }
	                function _xdrSender(payload, isAsync) {
	                    var _window = getWindow();
	                    var xdr = new XDomainRequest();
	                    xdr.onload = function () { return _self._xdrOnLoad(xdr, payload); };
	                    xdr.onerror = function (event) { return _self._onError(payload, _formatErrorMessageXdr(xdr), event); };
	                    var hostingProtocol = _window && _window.location && _window.location.protocol || "";
	                    if (_self._senderConfig.endpointUrl().lastIndexOf(hostingProtocol, 0) !== 0) {
	                        _self.diagLog().throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.TransmissionFailed, ". " +
	                            "Cannot send XDomain request. The endpoint URL protocol doesn't match the hosting page protocol.");
	                        _self._buffer.clear();
	                        return;
	                    }
	                    var endpointUrl = _self._senderConfig.endpointUrl().replace(/^(https?:)/, "");
	                    xdr.open('POST', endpointUrl);
	                    var batch = _self._buffer.batchPayloads(payload);
	                    xdr.send(batch);
	                    _self._buffer.markAsSent(payload);
	                }
	                function _formatErrorMessageXdr(xdr, message) {
	                    if (xdr) {
	                        return "XDomainRequest,Response:" + _getResponseText(xdr) || "";
	                    }
	                    return message;
	                }
	                function _getNotifyMgr() {
	                    var func = 'getNotifyMgr';
	                    if (_self.core[func]) {
	                        return _self.core[func]();
	                    }
	                    return _self.core['_notificationManager'];
	                }
	                function _notifySendRequest(sendRequest, isAsync) {
	                    var manager = _getNotifyMgr();
	                    if (manager && manager.eventsSendRequest) {
	                        try {
	                            manager.eventsSendRequest(sendRequest, isAsync);
	                        }
	                        catch (e) {
	                            _self.diagLog().throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.NotificationException, "send request notification failed: " + getExceptionName(e), { exception: dumpObj(e) });
	                        }
	                    }
	                }
	                function _validateInstrumentationKey(config) {
	                    var disableIKeyValidationFlag = isNullOrUndefined(config.disableInstrumentationKeyValidation) ? false : config.disableInstrumentationKeyValidation;
	                    if (disableIKeyValidationFlag) {
	                        return true;
	                    }
	                    var UUID_Regex = '^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$';
	                    var regexp = new RegExp(UUID_Regex);
	                    return regexp.test(config.instrumentationKey);
	                }
	            });
	            return _this;
	        }
	        Sender.constructEnvelope = function (orig, iKey, logger) {
	            var envelope;
	            if (iKey !== orig.iKey && !isNullOrUndefined(iKey)) {
	                envelope = __assign({}, orig, { iKey: iKey });
	            }
	            else {
	                envelope = orig;
	            }
	            switch (envelope.baseType) {
	                case Event$1.dataType:
	                    return EventEnvelopeCreator.EventEnvelopeCreator.Create(logger, envelope);
	                case Trace.dataType:
	                    return TraceEnvelopeCreator.TraceEnvelopeCreator.Create(logger, envelope);
	                case PageView.dataType:
	                    return PageViewEnvelopeCreator.PageViewEnvelopeCreator.Create(logger, envelope);
	                case PageViewPerformance.dataType:
	                    return PageViewPerformanceEnvelopeCreator.PageViewPerformanceEnvelopeCreator.Create(logger, envelope);
	                case Exception.dataType:
	                    return ExceptionEnvelopeCreator.ExceptionEnvelopeCreator.Create(logger, envelope);
	                case Metric.dataType:
	                    return MetricEnvelopeCreator.MetricEnvelopeCreator.Create(logger, envelope);
	                case RemoteDependencyData.dataType:
	                    return DependencyEnvelopeCreator.DependencyEnvelopeCreator.Create(logger, envelope);
	                default:
	                    return EventEnvelopeCreator.EventEnvelopeCreator.Create(logger, envelope);
	            }
	        };
	        Sender._getDefaultAppInsightsChannelConfig = function () {
	            return {
	                endpointUrl: function () { return "https://dc.services.visualstudio.com/v2/track"; },
	                emitLineDelimitedJson: function () { return false; },
	                maxBatchInterval: function () { return 15000; },
	                maxBatchSizeInBytes: function () { return 102400; },
	                disableTelemetry: function () { return false; },
	                enableSessionStorageBuffer: function () { return true; },
	                isRetryDisabled: function () { return false; },
	                isBeaconApiDisabled: function () { return true; },
	                onunloadDisableBeacon: function () { return false; },
	                instrumentationKey: function () { return undefined; },
	                namePrefix: function () { return undefined; },
	                samplingPercentage: function () { return 100; }
	            };
	        };
	        Sender._getEmptyAppInsightsChannelConfig = function () {
	            return {
	                endpointUrl: undefined,
	                emitLineDelimitedJson: undefined,
	                maxBatchInterval: undefined,
	                maxBatchSizeInBytes: undefined,
	                disableTelemetry: undefined,
	                enableSessionStorageBuffer: undefined,
	                isRetryDisabled: undefined,
	                isBeaconApiDisabled: undefined,
	                onunloadDisableBeacon: undefined,
	                instrumentationKey: undefined,
	                namePrefix: undefined,
	                samplingPercentage: undefined
	            };
	        };
	        return Sender;
	    }(BaseTelemetryPlugin));
	
	    /*!
	     * Application Insights JavaScript SDK - Properties Plugin, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var cookieNameConst = 'ai_session';
	    var Session = /** @class */ (function () {
	        function Session() {
	        }
	        return Session;
	    }());
	    var _SessionManager = /** @class */ (function () {
	        function _SessionManager(config, core) {
	            var self = this;
	            var _storageNamePrefix;
	            var _cookieUpdatedTimestamp;
	            var _logger = safeGetLogger(core);
	            var _cookieManager = safeGetCookieMgr(core);
	            dynamicProto(_SessionManager, self, function (_self) {
	                if (!config) {
	                    config = {};
	                }
	                if (!isFunction(config.sessionExpirationMs)) {
	                    config.sessionExpirationMs = function () { return _SessionManager.acquisitionSpan; };
	                }
	                if (!isFunction(config.sessionRenewalMs)) {
	                    config.sessionRenewalMs = function () { return _SessionManager.renewalSpan; };
	                }
	                _self.config = config;
	                _storageNamePrefix = function () { return _self.config.namePrefix && _self.config.namePrefix() ? cookieNameConst + _self.config.namePrefix() : cookieNameConst; };
	                _self.automaticSession = new Session();
	                _self.update = function () {
	                    var nowMs = dateNow();
	                    var isExpired = false;
	                    var session = _self.automaticSession;
	                    if (!session.id) {
	                        isExpired = !_initializeAutomaticSession(session);
	                    }
	                    var sessionExpirationMs = _self.config.sessionExpirationMs();
	                    if (!isExpired && sessionExpirationMs > 0) {
	                        var sessionRenewalMs = _self.config.sessionRenewalMs();
	                        var timeSinceAcqMs = nowMs - session.acquisitionDate;
	                        var timeSinceRenewalMs = nowMs - session.renewalDate;
	                        isExpired = timeSinceAcqMs < 0 || timeSinceRenewalMs < 0;
	                        isExpired = isExpired || timeSinceAcqMs > sessionExpirationMs;
	                        isExpired = isExpired || timeSinceRenewalMs > sessionRenewalMs;
	                    }
	                    if (isExpired) {
	                        _renew(nowMs);
	                    }
	                    else {
	                        if (!_cookieUpdatedTimestamp || nowMs - _cookieUpdatedTimestamp > _SessionManager.cookieUpdateInterval) {
	                            _setCookie(session, nowMs);
	                        }
	                    }
	                };
	                _self.backup = function () {
	                    var session = _self.automaticSession;
	                    _setStorage(session.id, session.acquisitionDate, session.renewalDate);
	                };
	                function _initializeAutomaticSession(session, now) {
	                    var isValid = false;
	                    var cookieValue = _cookieManager.get(_storageNamePrefix());
	                    if (cookieValue && isFunction(cookieValue.split)) {
	                        isValid = _initializeAutomaticSessionWithData(session, cookieValue);
	                    }
	                    else {
	                        var storageValue = utlGetLocalStorage(_logger, _storageNamePrefix());
	                        if (storageValue) {
	                            isValid = _initializeAutomaticSessionWithData(session, storageValue);
	                        }
	                    }
	                    return isValid || !!session.id;
	                }
	                function _initializeAutomaticSessionWithData(session, sessionData) {
	                    var isValid = false;
	                    var sessionReset = ", session will be reset";
	                    var tokens = sessionData.split("|");
	                    if (tokens.length >= 2) {
	                        try {
	                            var acqMs = +tokens[1] || 0;
	                            var renewalMs = +tokens[2] || 0;
	                            if (isNaN(acqMs) || acqMs <= 0) {
	                                _logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.SessionRenewalDateIsZero, "AI session acquisition date is 0" + sessionReset);
	                            }
	                            else if (isNaN(renewalMs) || renewalMs <= 0) {
	                                _logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.SessionRenewalDateIsZero, "AI session renewal date is 0" + sessionReset);
	                            }
	                            else if (tokens[0]) {
	                                session.id = tokens[0];
	                                session.acquisitionDate = acqMs;
	                                session.renewalDate = renewalMs;
	                                isValid = true;
	                            }
	                        }
	                        catch (e) {
	                            _logger.throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.ErrorParsingAISessionCookie, "Error parsing ai_session value [" + (sessionData || "") + "]" + sessionReset + " - " + getExceptionName(e), { exception: dumpObj(e) });
	                        }
	                    }
	                    return isValid;
	                }
	                function _renew(nowMs) {
	                    var theConfig = (_self.config || {});
	                    var getNewId = (theConfig.getNewId ? theConfig.getNewId() : null) || newId;
	                    _self.automaticSession.id = getNewId(theConfig.idLength ? theConfig.idLength() : 22);
	                    _self.automaticSession.acquisitionDate = nowMs;
	                    _setCookie(_self.automaticSession, nowMs);
	                    if (!utlCanUseLocalStorage()) {
	                        _logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.BrowserDoesNotSupportLocalStorage, "Browser does not support local storage. Session durations will be inaccurate.");
	                    }
	                }
	                function _setCookie(session, nowMs) {
	                    var acq = session.acquisitionDate;
	                    session.renewalDate = nowMs;
	                    var config = _self.config;
	                    var renewalPeriodMs = config.sessionRenewalMs();
	                    var acqTimeLeftMs = (acq + config.sessionExpirationMs()) - nowMs;
	                    var cookie = [session.id, acq, nowMs];
	                    var maxAgeSec = 0;
	                    if (acqTimeLeftMs < renewalPeriodMs) {
	                        maxAgeSec = acqTimeLeftMs / 1000;
	                    }
	                    else {
	                        maxAgeSec = renewalPeriodMs / 1000;
	                    }
	                    var cookieDomain = config.cookieDomain ? config.cookieDomain() : null;
	                    _cookieManager.set(_storageNamePrefix(), cookie.join('|'), config.sessionExpirationMs() > 0 ? maxAgeSec : null, cookieDomain);
	                    _cookieUpdatedTimestamp = nowMs;
	                }
	                function _setStorage(guid, acq, renewal) {
	                    utlSetLocalStorage(_logger, _storageNamePrefix(), [guid, acq, renewal].join('|'));
	                }
	            });
	        }
	        _SessionManager.acquisitionSpan = 86400000;
	        _SessionManager.renewalSpan = 1800000;
	        _SessionManager.cookieUpdateInterval = 60000;
	        return _SessionManager;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Properties Plugin, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var Application = /** @class */ (function () {
	        function Application() {
	        }
	        return Application;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Properties Plugin, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var Device = /** @class */ (function () {
	        function Device() {
	            this.id = "browser";
	            this.deviceClass = "Browser";
	        }
	        return Device;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Properties Plugin, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var Version = "2.6.1";
	    var Internal = /** @class */ (function () {
	        function Internal(config) {
	            this.sdkVersion = (config.sdkExtension && config.sdkExtension() ? config.sdkExtension() + "_" : "") + "javascript:" + Version;
	        }
	        return Internal;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Properties Plugin, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    function _validateUserInput(id) {
	        if (typeof id !== 'string' ||
	            !id ||
	            id.match(/,|;|=| |\|/)) {
	            return false;
	        }
	        return true;
	    }
	    var User = /** @class */ (function () {
	        function User(config, core) {
	            this.isNewUser = false;
	            var _logger = safeGetLogger(core);
	            var _cookieManager = safeGetCookieMgr(core);
	            dynamicProto(User, this, function (_self) {
	                var cookie = _cookieManager.get(User.userCookieName);
	                if (cookie) {
	                    _self.isNewUser = false;
	                    var params = cookie.split(User.cookieSeparator);
	                    if (params.length > 0) {
	                        _self.id = params[0];
	                    }
	                }
	                _self.config = config;
	                if (!_self.id) {
	                    var theConfig = (config || {});
	                    var getNewId = (theConfig.getNewId ? theConfig.getNewId() : null) || newId;
	                    _self.id = getNewId(theConfig.idLength ? config.idLength() : 22);
	                    var oneYear = 31536000;
	                    var acqStr = toISOString(new Date());
	                    _self.accountAcquisitionDate = acqStr;
	                    _self.isNewUser = true;
	                    var newCookie = [_self.id, acqStr];
	                    _cookieManager.set(User.userCookieName, newCookie.join(User.cookieSeparator), oneYear);
	                    var name_1 = config.namePrefix && config.namePrefix() ? config.namePrefix() + 'ai_session' : 'ai_session';
	                    utlRemoveStorage(_logger, name_1);
	                }
	                _self.accountId = config.accountId ? config.accountId() : undefined;
	                var authCookie = _cookieManager.get(User.authUserCookieName);
	                if (authCookie) {
	                    authCookie = decodeURI(authCookie);
	                    var authCookieString = authCookie.split(User.cookieSeparator);
	                    if (authCookieString[0]) {
	                        _self.authenticatedId = authCookieString[0];
	                    }
	                    if (authCookieString.length > 1 && authCookieString[1]) {
	                        _self.accountId = authCookieString[1];
	                    }
	                }
	                _self.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
	                    if (storeInCookie === void 0) { storeInCookie = false; }
	                    var isInvalidInput = !_validateUserInput(authenticatedUserId) || (accountId && !_validateUserInput(accountId));
	                    if (isInvalidInput) {
	                        _logger.throwInternal(exports.LoggingSeverity.WARNING, _InternalMessageId.SetAuthContextFailedAccountName, "Setting auth user context failed. " +
	                            "User auth/account id should be of type string, and not contain commas, semi-colons, equal signs, spaces, or vertical-bars.", true);
	                        return;
	                    }
	                    _self.authenticatedId = authenticatedUserId;
	                    var authCookie = _self.authenticatedId;
	                    if (accountId) {
	                        _self.accountId = accountId;
	                        authCookie = [_self.authenticatedId, _self.accountId].join(User.cookieSeparator);
	                    }
	                    if (storeInCookie) {
	                        _cookieManager.set(User.authUserCookieName, encodeURI(authCookie));
	                    }
	                };
	                _self.clearAuthenticatedUserContext = function () {
	                    _self.authenticatedId = null;
	                    _self.accountId = null;
	                    _cookieManager.del(User.authUserCookieName);
	                };
	            });
	        }
	        User.cookieSeparator = '|';
	        User.userCookieName = 'ai_user';
	        User.authUserCookieName = 'ai_authUser';
	        return User;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Properties Plugin, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var Location = /** @class */ (function () {
	        function Location() {
	        }
	        return Location;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Properties Plugin, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var TelemetryTrace = /** @class */ (function () {
	        function TelemetryTrace(id, parentId, name, logger) {
	            var _self = this;
	            _self.traceID = id || generateW3CId();
	            _self.parentID = parentId;
	            _self.name = name;
	            var location = getLocation();
	            if (!name && location && location.pathname) {
	                _self.name = location.pathname;
	            }
	            _self.name = DataSanitizer.sanitizeString(logger, _self.name);
	        }
	        return TelemetryTrace;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Properties Plugin, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var strExt = "ext";
	    var strTags = "tags";
	    function _removeEmpty(target, name) {
	        if (target && target[name] && objKeys(target[name]).length === 0) {
	            delete target[name];
	        }
	    }
	    var TelemetryContext = /** @class */ (function () {
	        function TelemetryContext(core, defaultConfig) {
	            var _this = this;
	            var logger = core.logger;
	            this.appId = function () { return null; };
	            dynamicProto(TelemetryContext, this, function (_self) {
	                _self.application = new Application();
	                _self.internal = new Internal(defaultConfig);
	                if (hasWindow()) {
	                    _self.sessionManager = new _SessionManager(defaultConfig, core);
	                    _self.device = new Device();
	                    _self.location = new Location();
	                    _self.user = new User(defaultConfig, core);
	                    _self.telemetryTrace = new TelemetryTrace(undefined, undefined, undefined, logger);
	                    _self.session = new Session();
	                }
	                _self.applySessionContext = function (evt, itemCtx) {
	                    var session = _self.session;
	                    var sessionManager = _self.sessionManager;
	                    if (session && isString(session.id)) {
	                        setValue(getSetValue(evt.ext, Extensions.AppExt), "sesId", session.id);
	                    }
	                    else if (sessionManager && sessionManager.automaticSession) {
	                        setValue(getSetValue(evt.ext, Extensions.AppExt), "sesId", sessionManager.automaticSession.id, isString);
	                    }
	                };
	                _self.applyOperatingSystemContxt = function (evt, itemCtx) {
	                    setValue(evt.ext, Extensions.OSExt, _self.os);
	                };
	                _self.applyApplicationContext = function (evt, itemCtx) {
	                    var application = _self.application;
	                    if (application) {
	                        var tags = getSetValue(evt, strTags);
	                        setValue(tags, CtxTagKeys.applicationVersion, application.ver, isString);
	                        setValue(tags, CtxTagKeys.applicationBuild, application.build, isString);
	                    }
	                };
	                _self.applyDeviceContext = function (evt, itemCtx) {
	                    var device = _self.device;
	                    if (device) {
	                        var extDevice = getSetValue(getSetValue(evt, strExt), Extensions.DeviceExt);
	                        setValue(extDevice, "localId", device.id, isString);
	                        setValue(extDevice, "ip", device.ip, isString);
	                        setValue(extDevice, "model", device.model, isString);
	                        setValue(extDevice, "deviceClass", device.deviceClass, isString);
	                    }
	                };
	                _self.applyInternalContext = function (evt, itemCtx) {
	                    var internal = _self.internal;
	                    if (internal) {
	                        var tags = getSetValue(evt, strTags);
	                        setValue(tags, CtxTagKeys.internalAgentVersion, internal.agentVersion, isString);
	                        setValue(tags, CtxTagKeys.internalSdkVersion, internal.sdkVersion, isString);
	                        if (evt.baseType === _InternalLogMessage.dataType || evt.baseType === PageView.dataType) {
	                            setValue(tags, CtxTagKeys.internalSnippet, internal.snippetVer, isString);
	                            setValue(tags, CtxTagKeys.internalSdkSrc, internal.sdkSrc, isString);
	                        }
	                    }
	                };
	                _self.applyLocationContext = function (evt, itemCtx) {
	                    var location = _this.location;
	                    if (location) {
	                        setValue(getSetValue(evt, strTags, []), CtxTagKeys.locationIp, location.ip, isString);
	                    }
	                };
	                _self.applyOperationContext = function (evt, itemCtx) {
	                    var telemetryTrace = _self.telemetryTrace;
	                    if (telemetryTrace) {
	                        var extTrace = getSetValue(getSetValue(evt, strExt), Extensions.TraceExt, { traceID: undefined, parentID: undefined });
	                        setValue(extTrace, "traceID", telemetryTrace.traceID, isString);
	                        setValue(extTrace, "name", telemetryTrace.name, isString);
	                        setValue(extTrace, "parentID", telemetryTrace.parentID, isString);
	                    }
	                };
	                _self.applyWebContext = function (evt, itemCtx) {
	                    var web = _this.web;
	                    if (web) {
	                        setValue(getSetValue(evt, strExt), Extensions.WebExt, web);
	                    }
	                };
	                _self.applyUserContext = function (evt, itemCtx) {
	                    var user = _self.user;
	                    if (user) {
	                        var tags = getSetValue(evt, strTags, []);
	                        setValue(tags, CtxTagKeys.userAccountId, user.accountId, isString);
	                        var extUser = getSetValue(getSetValue(evt, strExt), Extensions.UserExt);
	                        setValue(extUser, "id", user.id, isString);
	                        setValue(extUser, "authId", user.authenticatedId, isString);
	                    }
	                };
	                _self.cleanUp = function (evt, itemCtx) {
	                    var ext = evt.ext;
	                    if (ext) {
	                        _removeEmpty(ext, Extensions.DeviceExt);
	                        _removeEmpty(ext, Extensions.UserExt);
	                        _removeEmpty(ext, Extensions.WebExt);
	                        _removeEmpty(ext, Extensions.OSExt);
	                        _removeEmpty(ext, Extensions.AppExt);
	                        _removeEmpty(ext, Extensions.TraceExt);
	                    }
	                };
	            });
	        }
	        return TelemetryContext;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Properties Plugin, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var PropertiesPlugin = /** @class */ (function (_super) {
	        __extends(PropertiesPlugin, _super);
	        function PropertiesPlugin() {
	            var _this = _super.call(this) || this;
	            _this.priority = 110;
	            _this.identifier = PropertiesPluginIdentifier;
	            var _breezeChannel;
	            var _extensionConfig;
	            dynamicProto(PropertiesPlugin, _this, function (_self, _base) {
	                _self.initialize = function (config, core, extensions, pluginChain) {
	                    _base.initialize(config, core, extensions, pluginChain);
	                    var ctx = _self._getTelCtx();
	                    var identifier = _self.identifier;
	                    var defaultConfig = PropertiesPlugin.getDefaultConfig();
	                    _extensionConfig = _extensionConfig || {};
	                    objForEachKey(defaultConfig, function (field, value) {
	                        _extensionConfig[field] = function () { return ctx.getConfig(identifier, field, value()); };
	                    });
	                    _self.context = new TelemetryContext(core, _extensionConfig);
	                    _breezeChannel = getExtensionByName(extensions, BreezeChannelIdentifier);
	                    _self.context.appId = function () { return _breezeChannel ? _breezeChannel["_appId"] : null; };
	                    _self["_extConfig"] = _extensionConfig;
	                };
	                _self.processTelemetry = function (event, itemCtx) {
	                    if (isNullOrUndefined(event)) ;
	                    else {
	                        itemCtx = _self._getTelCtx(itemCtx);
	                        if (event.name === PageView.envelopeType) {
	                            itemCtx.diagLog().resetInternalMessageCount();
	                        }
	                        var theContext = (_self.context || {});
	                        if (theContext.session) {
	                            if (typeof _self.context.session.id !== "string" && theContext.sessionManager) {
	                                theContext.sessionManager.update();
	                            }
	                        }
	                        _processTelemetryInternal(event, itemCtx);
	                        if (theContext.user && theContext.user.isNewUser) {
	                            theContext.user.isNewUser = false;
	                            var message = new _InternalLogMessage(_InternalMessageId.SendBrowserInfoOnUserInit, ((getNavigator() || {}).userAgent || ""));
	                            itemCtx.diagLog().logInternalMessage(exports.LoggingSeverity.CRITICAL, message);
	                        }
	                        _self.processNext(event, itemCtx);
	                    }
	                };
	                function _processTelemetryInternal(evt, itemCtx) {
	                    getSetValue(evt, "tags", []);
	                    getSetValue(evt, "ext", {});
	                    var ctx = _self.context;
	                    ctx.applySessionContext(evt, itemCtx);
	                    ctx.applyApplicationContext(evt, itemCtx);
	                    ctx.applyDeviceContext(evt, itemCtx);
	                    ctx.applyOperationContext(evt, itemCtx);
	                    ctx.applyUserContext(evt, itemCtx);
	                    ctx.applyOperatingSystemContxt(evt, itemCtx);
	                    ctx.applyWebContext(evt, itemCtx);
	                    ctx.applyLocationContext(evt, itemCtx);
	                    ctx.applyInternalContext(evt, itemCtx);
	                    ctx.cleanUp(evt, itemCtx);
	                }
	            });
	            return _this;
	        }
	        PropertiesPlugin.getDefaultConfig = function () {
	            var defaultConfig = {
	                instrumentationKey: function () { return undefined; },
	                accountId: function () { return null; },
	                sessionRenewalMs: function () { return 30 * 60 * 1000; },
	                samplingPercentage: function () { return 100; },
	                sessionExpirationMs: function () { return 24 * 60 * 60 * 1000; },
	                cookieDomain: function () { return null; },
	                sdkExtension: function () { return null; },
	                isBrowserLinkTrackingEnabled: function () { return false; },
	                appId: function () { return null; },
	                namePrefix: function () { return undefined; },
	                idLength: function () { return 22; },
	                getNewId: function () { return null; }
	            };
	            return defaultConfig;
	        };
	        return PropertiesPlugin;
	    }(BaseTelemetryPlugin));
	
	    /*!
	     * Application Insights JavaScript SDK - Dependencies Plugin, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var strProperties = "properties";
	    function _calcPerfDuration(resourceEntry, start, end) {
	        var result = 0;
	        var from = resourceEntry[start];
	        var to = resourceEntry[end];
	        if (from && to) {
	            result = dateTimeUtilsDuration(from, to);
	        }
	        return result;
	    }
	    function _setPerfDuration(props, name, resourceEntry, start, end) {
	        var result = 0;
	        var value = _calcPerfDuration(resourceEntry, start, end);
	        if (value) {
	            result = _setPerfValue(props, name, msToTimeSpan(value));
	        }
	        return result;
	    }
	    function _setPerfValue(props, name, value) {
	        var strPerf = "ajaxPerf";
	        var result = 0;
	        if (props && name && value) {
	            var perfData = props[strPerf] = (props[strPerf] || {});
	            perfData[name] = value;
	            result = 1;
	        }
	        return result;
	    }
	    function _populatePerfData(ajaxData, dependency) {
	        var resourceEntry = ajaxData.perfTiming;
	        var props = dependency[strProperties] || {};
	        var propsSet = 0;
	        var strName = "name";
	        var strStart = "Start";
	        var strEnd = "End";
	        var strDomainLookup = "domainLookup";
	        var strConnect = "connect";
	        var strRedirect = "redirect";
	        var strRequest = "request";
	        var strResponse = "response";
	        var strDuration = "duration";
	        var strStartTime = "startTime";
	        var strDomainLookupStart = strDomainLookup + strStart;
	        var strDomainLookupEnd = strDomainLookup + strEnd;
	        var strConnectStart = strConnect + strStart;
	        var strConnectEnd = strConnect + strEnd;
	        var strRequestStart = strRequest + strStart;
	        var strRequestEnd = strRequest + strEnd;
	        var strResponseStart = strResponse + strStart;
	        var strResponseEnd = strResponse + strEnd;
	        var strRedirectStart = strRedirect + strStart;
	        var strRedirectEnd = strRedirect = strEnd;
	        var strTransferSize = "transferSize";
	        var strEncodedBodySize = "encodedBodySize";
	        var strDecodedBodySize = "decodedBodySize";
	        var strServerTiming = "serverTiming";
	        if (resourceEntry) {
	            propsSet |= _setPerfDuration(props, strRedirect, resourceEntry, strRedirectStart, strRedirectEnd);
	            propsSet |= _setPerfDuration(props, strDomainLookup, resourceEntry, strDomainLookupStart, strDomainLookupEnd);
	            propsSet |= _setPerfDuration(props, strConnect, resourceEntry, strConnectStart, strConnectEnd);
	            propsSet |= _setPerfDuration(props, strRequest, resourceEntry, strRequestStart, strRequestEnd);
	            propsSet |= _setPerfDuration(props, strResponse, resourceEntry, strResponseStart, strResponseEnd);
	            propsSet |= _setPerfDuration(props, "networkConnect", resourceEntry, strStartTime, strConnectEnd);
	            propsSet |= _setPerfDuration(props, "sentRequest", resourceEntry, strRequestStart, strResponseEnd);
	            var duration = resourceEntry[strDuration];
	            if (!duration) {
	                duration = _calcPerfDuration(resourceEntry, strStartTime, strResponseEnd) || 0;
	            }
	            propsSet |= _setPerfValue(props, strDuration, duration);
	            propsSet |= _setPerfValue(props, "perfTotal", duration);
	            var serverTiming = resourceEntry[strServerTiming];
	            if (serverTiming) {
	                var server_1 = {};
	                arrForEach(serverTiming, function (value, idx) {
	                    var name = normalizeJsName(value[strName] || "" + idx);
	                    var newValue = server_1[name] || {};
	                    objForEachKey(value, function (key, val) {
	                        if (key !== strName && isString(val) || isNumber(val)) {
	                            if (newValue[key]) {
	                                val = newValue[key] + ";" + val;
	                            }
	                            if (val || !isString(val)) {
	                                newValue[key] = val;
	                            }
	                        }
	                    });
	                    server_1[name] = newValue;
	                });
	                propsSet |= _setPerfValue(props, strServerTiming, server_1);
	            }
	            propsSet |= _setPerfValue(props, strTransferSize, resourceEntry[strTransferSize]);
	            propsSet |= _setPerfValue(props, strEncodedBodySize, resourceEntry[strEncodedBodySize]);
	            propsSet |= _setPerfValue(props, strDecodedBodySize, resourceEntry[strDecodedBodySize]);
	        }
	        else {
	            if (ajaxData.perfMark) {
	                propsSet |= _setPerfValue(props, "missing", ajaxData.perfAttempts);
	            }
	        }
	        if (propsSet) {
	            dependency[strProperties] = props;
	        }
	    }
	    var XHRMonitoringState = /** @class */ (function () {
	        function XHRMonitoringState() {
	            var self = this;
	            self.openDone = false;
	            self.setRequestHeaderDone = false;
	            self.sendDone = false;
	            self.abortDone = false;
	            self.stateChangeAttached = false;
	        }
	        return XHRMonitoringState;
	    }());
	    var ajaxRecord = /** @class */ (function () {
	        function ajaxRecord(traceID, spanID, logger) {
	            var self = this;
	            var _logger = logger;
	            var strResponseText = "responseText";
	            self.perfMark = null;
	            self.completed = false;
	            self.requestHeadersSize = null;
	            self.requestHeaders = null;
	            self.responseReceivingDuration = null;
	            self.callbackDuration = null;
	            self.ajaxTotalDuration = null;
	            self.aborted = 0;
	            self.pageUrl = null;
	            self.requestUrl = null;
	            self.requestSize = 0;
	            self.method = null;
	            self.status = null;
	            self.requestSentTime = null;
	            self.responseStartedTime = null;
	            self.responseFinishedTime = null;
	            self.callbackFinishedTime = null;
	            self.endTime = null;
	            self.xhrMonitoringState = new XHRMonitoringState();
	            self.clientFailure = 0;
	            self.traceID = traceID;
	            self.spanID = spanID;
	            dynamicProto(ajaxRecord, self, function (self) {
	                self.getAbsoluteUrl = function () {
	                    return self.requestUrl ? urlGetAbsoluteUrl(self.requestUrl) : null;
	                };
	                self.getPathName = function () {
	                    return self.requestUrl ? DataSanitizer.sanitizeUrl(_logger, urlGetCompleteUrl(self.method, self.requestUrl)) : null;
	                };
	                self.CreateTrackItem = function (ajaxType, enableRequestHeaderTracking, getResponse) {
	                    self.ajaxTotalDuration = Math.round(dateTimeUtilsDuration(self.requestSentTime, self.responseFinishedTime) * 1000) / 1000;
	                    if (self.ajaxTotalDuration < 0) {
	                        return null;
	                    }
	                    var dependency = (_a = {
	                            id: "|" + self.traceID + "." + self.spanID,
	                            target: self.getAbsoluteUrl(),
	                            name: self.getPathName(),
	                            type: ajaxType,
	                            startTime: null,
	                            duration: self.ajaxTotalDuration,
	                            success: (+(self.status)) >= 200 && (+(self.status)) < 400,
	                            responseCode: (+(self.status)),
	                            method: self.method
	                        },
	                        _a[strProperties] = { HttpMethod: self.method },
	                        _a);
	                    if (self.requestSentTime) {
	                        dependency.startTime = new Date();
	                        dependency.startTime.setTime(self.requestSentTime);
	                    }
	                    _populatePerfData(self, dependency);
	                    if (enableRequestHeaderTracking) {
	                        if (objKeys(self.requestHeaders).length > 0) {
	                            dependency[strProperties] = dependency[strProperties] || {};
	                            dependency[strProperties].requestHeaders = self.requestHeaders;
	                        }
	                    }
	                    if (getResponse) {
	                        var response = getResponse();
	                        if (response) {
	                            var correlationContext = response.correlationContext;
	                            if (correlationContext) {
	                                dependency.correlationContext =  correlationContext;
	                            }
	                            if (response.headerMap) {
	                                if (objKeys(response.headerMap).length > 0) {
	                                    dependency[strProperties] = dependency[strProperties] || {};
	                                    dependency[strProperties].responseHeaders = response.headerMap;
	                                }
	                            }
	                            if (self.status >= 400) {
	                                var responseType = response.type;
	                                dependency[strProperties] = dependency[strProperties] || {};
	                                if (responseType === "" || responseType === "text") {
	                                    dependency[strProperties][strResponseText] = response[strResponseText] ? response.statusText + " - " + response[strResponseText] : response.statusText;
	                                }
	                                if (responseType === "json") {
	                                    dependency[strProperties][strResponseText] = response.response ? response.statusText + " - " + JSON.stringify(response.response) : response.statusText;
	                                }
	                            }
	                        }
	                    }
	                    return dependency;
	                    var _a;
	                };
	            });
	        }
	        return ajaxRecord;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Dependencies Plugin, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var Traceparent = /** @class */ (function () {
	        function Traceparent(traceId, spanId) {
	            var self = this;
	            self.traceFlag = Traceparent.DEFAULT_TRACE_FLAG;
	            self.version = Traceparent.DEFAULT_VERSION;
	            if (traceId && Traceparent.isValidTraceId(traceId)) {
	                self.traceId = traceId;
	            }
	            else {
	                self.traceId = generateW3CId();
	            }
	            if (spanId && Traceparent.isValidSpanId(spanId)) {
	                self.spanId = spanId;
	            }
	            else {
	                self.spanId = generateW3CId().substr(0, 16);
	            }
	        }
	        Traceparent.isValidTraceId = function (id) {
	            return id.match(/^[0-9a-f]{32}$/) && id !== "00000000000000000000000000000000";
	        };
	        Traceparent.isValidSpanId = function (id) {
	            return id.match(/^[0-9a-f]{16}$/) && id !== "0000000000000000";
	        };
	        Traceparent.prototype.toString = function () {
	            var self = this;
	            return self.version + "-" + self.traceId + "-" + self.spanId + "-" + self.traceFlag;
	        };
	        Traceparent.DEFAULT_TRACE_FLAG = "01";
	        Traceparent.DEFAULT_VERSION = "00";
	        return Traceparent;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Dependencies Plugin, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var AJAX_MONITOR_PREFIX = "ai.ajxmn.";
	    var strDiagLog = "diagLog";
	    var strAjaxData = "ajaxData";
	    var strThrowInternal = "throwInternal";
	    var strFetch = "fetch";
	    var _markCount = 0;
	    function _supportsFetch() {
	        var _global = getGlobal();
	        if (!_global ||
	            isNullOrUndefined(_global.Request) ||
	            isNullOrUndefined(_global.Request[strPrototype]) ||
	            isNullOrUndefined(_global[strFetch])) {
	            return null;
	        }
	        return _global[strFetch];
	    }
	    function _supportsAjaxMonitoring(ajaxMonitorInstance) {
	        var result = false;
	        if (typeof XMLHttpRequest !== strUndefined && !isNullOrUndefined(XMLHttpRequest)) {
	            var proto = XMLHttpRequest[strPrototype];
	            result = !isNullOrUndefined(proto) &&
	                !isNullOrUndefined(proto.open) &&
	                !isNullOrUndefined(proto.send) &&
	                !isNullOrUndefined(proto.abort);
	        }
	        var ieVer = getIEVersion();
	        if (ieVer && ieVer < 9) {
	            result = false;
	        }
	        if (result) {
	            try {
	                var xhr = new XMLHttpRequest();
	                xhr[strAjaxData] = {};
	                var theOpen = XMLHttpRequest[strPrototype].open;
	                XMLHttpRequest[strPrototype].open = theOpen;
	            }
	            catch (e) {
	                result = false;
	                _throwInternalCritical(ajaxMonitorInstance, _InternalMessageId.FailedMonitorAjaxOpen, "Failed to enable XMLHttpRequest monitoring, extension is not supported", {
	                    exception: dumpObj(e)
	                });
	            }
	        }
	        return result;
	    }
	    function _getFailedAjaxDiagnosticsMessage(xhr) {
	        var result = "";
	        try {
	            if (!isNullOrUndefined(xhr) &&
	                !isNullOrUndefined(xhr[strAjaxData]) &&
	                !isNullOrUndefined(xhr[strAjaxData].requestUrl)) {
	                result += "(url: '" + xhr[strAjaxData].requestUrl + "')";
	            }
	        }
	        catch (e) { }
	        return result;
	    }
	    function _throwInternalCritical(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
	        ajaxMonitorInstance[strDiagLog]()[strThrowInternal](exports.LoggingSeverity.CRITICAL, msgId, message, properties, isUserAct);
	    }
	    function _throwInternalWarning(ajaxMonitorInstance, msgId, message, properties, isUserAct) {
	        ajaxMonitorInstance[strDiagLog]()[strThrowInternal](exports.LoggingSeverity.WARNING, msgId, message, properties, isUserAct);
	    }
	    function _createErrorCallbackFunc(ajaxMonitorInstance, internalMessage, message) {
	        return function (args) {
	            _throwInternalCritical(ajaxMonitorInstance, internalMessage, message, {
	                ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(args.inst),
	                exception: dumpObj(args.err)
	            });
	        };
	    }
	    function _indexOf(value, match) {
	        if (value && match) {
	            return value.indexOf(match);
	        }
	        return -1;
	    }
	    var AjaxMonitor = /** @class */ (function (_super) {
	        __extends(AjaxMonitor, _super);
	        function AjaxMonitor() {
	            var _this = _super.call(this) || this;
	            _this.identifier = AjaxMonitor.identifier;
	            _this.priority = 120;
	            var strTrackDependencyDataInternal = "trackDependencyDataInternal";
	            var location = getLocation();
	            var _fetchInitialized = false;
	            var _xhrInitialized = false;
	            var _currentWindowHost = location && location.host && location.host.toLowerCase();
	            var _config = AjaxMonitor.getEmptyConfig();
	            var _enableRequestHeaderTracking = false;
	            var _trackAjaxAttempts = 0;
	            var _context;
	            var _isUsingW3CHeaders;
	            var _isUsingAIHeaders;
	            var _markPrefix;
	            var _enableAjaxPerfTracking = false;
	            var _maxAjaxCallsPerView = 0;
	            var _enableResponseHeaderTracking = false;
	            var _hooks = [];
	            var _disabledUrls = {};
	            dynamicProto(AjaxMonitor, _this, function (_self, base) {
	                _self.initialize = function (config, core, extensions, pluginChain) {
	                    if (!_self.isInitialized()) {
	                        base.initialize(config, core, extensions, pluginChain);
	                        var ctx_1 = _self._getTelCtx();
	                        var defaultConfig = AjaxMonitor.getDefaultConfig();
	                        objForEachKey(defaultConfig, function (field, value) {
	                            _config[field] = ctx_1.getConfig(AjaxMonitor.identifier, field, value);
	                        });
	                        var distributedTracingMode = _config.distributedTracingMode;
	                        _enableRequestHeaderTracking = _config.enableRequestHeaderTracking;
	                        _enableAjaxPerfTracking = _config.enableAjaxPerfTracking;
	                        _maxAjaxCallsPerView = _config.maxAjaxCallsPerView;
	                        _enableResponseHeaderTracking = _config.enableResponseHeaderTracking;
	                        _isUsingAIHeaders = distributedTracingMode === exports.DistributedTracingModes.AI || distributedTracingMode === exports.DistributedTracingModes.AI_AND_W3C;
	                        _isUsingW3CHeaders = distributedTracingMode === exports.DistributedTracingModes.AI_AND_W3C || distributedTracingMode === exports.DistributedTracingModes.W3C;
	                        if (_enableAjaxPerfTracking) {
	                            var iKey = config.instrumentationKey || "unkwn";
	                            if (iKey.length > 5) {
	                                _markPrefix = AJAX_MONITOR_PREFIX + iKey.substring(iKey.length - 5) + ".";
	                            }
	                            else {
	                                _markPrefix = AJAX_MONITOR_PREFIX + iKey + ".";
	                            }
	                        }
	                        if (_config.disableAjaxTracking === false) {
	                            _instrumentXhr();
	                        }
	                        _instrumentFetch();
	                        if (extensions.length > 0 && extensions) {
	                            var propExt = void 0, extIx = 0;
	                            while (!propExt && extIx < extensions.length) {
	                                if (extensions[extIx] && extensions[extIx].identifier === PropertiesPluginIdentifier) {
	                                    propExt = extensions[extIx];
	                                }
	                                extIx++;
	                            }
	                            if (propExt) {
	                                _context = propExt.context;
	                            }
	                        }
	                    }
	                };
	                _self.teardown = function () {
	                    arrForEach(_hooks, function (fn) {
	                        fn.rm();
	                    });
	                    _hooks = [];
	                    _fetchInitialized = false;
	                    _xhrInitialized = false;
	                    _self.setInitialized(false);
	                };
	                _self.trackDependencyData = function (dependency, properties) {
	                    _self[strTrackDependencyDataInternal](dependency, properties);
	                };
	                _self.includeCorrelationHeaders = function (ajaxData, input, init, xhr) {
	                    var currentWindowHost = _self["_currentWindowHost"] || _currentWindowHost;
	                    if (input) {
	                        if (CorrelationIdHelper.canIncludeCorrelationHeader(_config, ajaxData.getAbsoluteUrl(), currentWindowHost)) {
	                            if (!init) {
	                                init = {};
	                            }
	                            init.headers = new Headers(init.headers || (input instanceof Request ? (input.headers || {}) : {}));
	                            if (_isUsingAIHeaders) {
	                                var id = "|" + ajaxData.traceID + "." + ajaxData.spanID;
	                                init.headers.set(RequestHeaders.requestIdHeader, id);
	                                if (_enableRequestHeaderTracking) {
	                                    ajaxData.requestHeaders[RequestHeaders.requestIdHeader] = id;
	                                }
	                            }
	                            var appId = _config.appId || (_context && _context.appId());
	                            if (appId) {
	                                init.headers.set(RequestHeaders.requestContextHeader, RequestHeaders.requestContextAppIdFormat + appId);
	                                if (_enableRequestHeaderTracking) {
	                                    ajaxData.requestHeaders[RequestHeaders.requestContextHeader] = RequestHeaders.requestContextAppIdFormat + appId;
	                                }
	                            }
	                            if (_isUsingW3CHeaders) {
	                                var traceparent = new Traceparent(ajaxData.traceID, ajaxData.spanID);
	                                init.headers.set(RequestHeaders.traceParentHeader, traceparent.toString());
	                                if (_enableRequestHeaderTracking) {
	                                    ajaxData.requestHeaders[RequestHeaders.traceParentHeader] = traceparent.toString();
	                                }
	                            }
	                        }
	                        return init;
	                    }
	                    else if (xhr) {
	                        if (CorrelationIdHelper.canIncludeCorrelationHeader(_config, ajaxData.getAbsoluteUrl(), currentWindowHost)) {
	                            if (_isUsingAIHeaders) {
	                                var id = "|" + ajaxData.traceID + "." + ajaxData.spanID;
	                                xhr.setRequestHeader(RequestHeaders.requestIdHeader, id);
	                                if (_enableRequestHeaderTracking) {
	                                    ajaxData.requestHeaders[RequestHeaders.requestIdHeader] = id;
	                                }
	                            }
	                            var appId = _config.appId || (_context && _context.appId());
	                            if (appId) {
	                                xhr.setRequestHeader(RequestHeaders.requestContextHeader, RequestHeaders.requestContextAppIdFormat + appId);
	                                if (_enableRequestHeaderTracking) {
	                                    ajaxData.requestHeaders[RequestHeaders.requestContextHeader] = RequestHeaders.requestContextAppIdFormat + appId;
	                                }
	                            }
	                            if (_isUsingW3CHeaders) {
	                                var traceparent = new Traceparent(ajaxData.traceID, ajaxData.spanID);
	                                xhr.setRequestHeader(RequestHeaders.traceParentHeader, traceparent.toString());
	                                if (_enableRequestHeaderTracking) {
	                                    ajaxData.requestHeaders[RequestHeaders.traceParentHeader] = traceparent.toString();
	                                }
	                            }
	                        }
	                        return xhr;
	                    }
	                    return undefined;
	                };
	                _self[strTrackDependencyDataInternal] = function (dependency, properties, systemProperties) {
	                    if (_maxAjaxCallsPerView === -1 || _trackAjaxAttempts < _maxAjaxCallsPerView) {
	                        if ((_config.distributedTracingMode === exports.DistributedTracingModes.W3C
	                            || _config.distributedTracingMode === exports.DistributedTracingModes.AI_AND_W3C)
	                            && typeof dependency.id === "string" && dependency.id[dependency.id.length - 1] !== ".") {
	                            dependency.id += ".";
	                        }
	                        if (isNullOrUndefined(dependency.startTime)) {
	                            dependency.startTime = new Date();
	                        }
	                        var item = TelemetryItemCreator.create(dependency, RemoteDependencyData.dataType, RemoteDependencyData.envelopeType, _self[strDiagLog](), properties, systemProperties);
	                        _self.core.track(item);
	                    }
	                    else if (_trackAjaxAttempts === _maxAjaxCallsPerView) {
	                        _throwInternalCritical(_self, _InternalMessageId.MaxAjaxPerPVExceeded, "Maximum ajax per page view limit reached, ajax monitoring is paused until the next trackPageView(). In order to increase the limit set the maxAjaxCallsPerView configuration parameter.", true);
	                    }
	                    ++_trackAjaxAttempts;
	                };
	                function _instrumentFetch() {
	                    var fetch = _supportsFetch();
	                    if (!fetch) {
	                        return;
	                    }
	                    var global = getGlobal();
	                    var isPolyfill = fetch.polyfill;
	                    if (_config.disableFetchTracking === false) {
	                        _hooks.push(InstrumentFunc(global, strFetch, {
	                            req: function (callDetails, input, init) {
	                                var fetchData;
	                                if (_fetchInitialized &&
	                                    !_isDisabledRequest(null, input, init) &&
	                                    !(isPolyfill && _xhrInitialized)) {
	                                    var ctx = callDetails.ctx();
	                                    fetchData = _createFetchRecord(input, init);
	                                    var newInit = _self.includeCorrelationHeaders(fetchData, input, init);
	                                    if (newInit !== init) {
	                                        callDetails.set(1, newInit);
	                                    }
	                                    ctx.data = fetchData;
	                                }
	                            },
	                            rsp: function (callDetails, input) {
	                                var fetchData = callDetails.ctx().data;
	                                if (fetchData) {
	                                    callDetails.rslt = callDetails.rslt.then(function (response) {
	                                        _reportFetchMetrics(callDetails, (response || {}).status, response, fetchData, function () {
	                                            var ajaxResponse = {
	                                                statusText: response.statusText,
	                                                headerMap: null,
	                                                correlationContext: _getFetchCorrelationContext(response)
	                                            };
	                                            if (_enableResponseHeaderTracking) {
	                                                var responseHeaderMap_1 = {};
	                                                response.headers.forEach(function (value, name) {
	                                                    responseHeaderMap_1[name] = value;
	                                                });
	                                                ajaxResponse.headerMap = responseHeaderMap_1;
	                                            }
	                                            return ajaxResponse;
	                                        });
	                                        return response;
	                                    })["catch"](function (reason) {
	                                        _reportFetchMetrics(callDetails, 0, input, fetchData, null, { error: reason.message });
	                                        throw reason;
	                                    });
	                                }
	                            },
	                            hkErr: _createErrorCallbackFunc(_self, _InternalMessageId.FailedMonitorAjaxOpen, "Failed to monitor Window.fetch, monitoring data for this fetch call may be incorrect.")
	                        }));
	                        _fetchInitialized = true;
	                    }
	                    else if (isPolyfill) {
	                        _hooks.push(InstrumentFunc(global, strFetch, {
	                            req: function (callDetails, input, init) {
	                                _isDisabledRequest(null, input, init);
	                            }
	                        }));
	                    }
	                    if (isPolyfill) {
	                        global[strFetch].polyfill = isPolyfill;
	                    }
	                }
	                function _hookProto(target, funcName, callbacks) {
	                    _hooks.push(InstrumentProto(target, funcName, callbacks));
	                }
	                function _instrumentXhr() {
	                    if (_supportsAjaxMonitoring(_self) && !_xhrInitialized) {
	                        _hookProto(XMLHttpRequest, "open", {
	                            req: function (args, method, url, async) {
	                                var xhr = args.inst;
	                                var ajaxData = xhr[strAjaxData];
	                                if (!_isDisabledRequest(xhr, url) && _isMonitoredXhrInstance(xhr, true) &&
	                                    (!ajaxData || !ajaxData.xhrMonitoringState.openDone)) {
	                                    _openHandler(xhr, method, url, async);
	                                }
	                            },
	                            hkErr: _createErrorCallbackFunc(_self, _InternalMessageId.FailedMonitorAjaxOpen, "Failed to monitor XMLHttpRequest.open, monitoring data for this ajax call may be incorrect.")
	                        });
	                        _hookProto(XMLHttpRequest, "send", {
	                            req: function (args, context) {
	                                var xhr = args.inst;
	                                var ajaxData = xhr[strAjaxData];
	                                if (_isMonitoredXhrInstance(xhr) && !ajaxData.xhrMonitoringState.sendDone) {
	                                    _createMarkId("xhr", ajaxData);
	                                    ajaxData.requestSentTime = dateTimeUtilsNow();
	                                    xhr = _self.includeCorrelationHeaders(ajaxData, undefined, undefined, xhr);
	                                    ajaxData.xhrMonitoringState.sendDone = true;
	                                }
	                            },
	                            hkErr: _createErrorCallbackFunc(_self, _InternalMessageId.FailedMonitorAjaxSend, "Failed to monitor XMLHttpRequest, monitoring data for this ajax call may be incorrect.")
	                        });
	                        _hookProto(XMLHttpRequest, "abort", {
	                            req: function (args) {
	                                var xhr = args.inst;
	                                var ajaxData = xhr[strAjaxData];
	                                if (_isMonitoredXhrInstance(xhr) && !ajaxData.xhrMonitoringState.abortDone) {
	                                    ajaxData.aborted = 1;
	                                    ajaxData.xhrMonitoringState.abortDone = true;
	                                }
	                            },
	                            hkErr: _createErrorCallbackFunc(_self, _InternalMessageId.FailedMonitorAjaxAbort, "Failed to monitor XMLHttpRequest.abort, monitoring data for this ajax call may be incorrect.")
	                        });
	                        if (_enableRequestHeaderTracking) {
	                            _hookProto(XMLHttpRequest, "setRequestHeader", {
	                                req: function (args, header, value) {
	                                    var xhr = args.inst;
	                                    if (_isMonitoredXhrInstance(xhr)) {
	                                        xhr[strAjaxData].requestHeaders[header] = value;
	                                    }
	                                },
	                                hkErr: _createErrorCallbackFunc(_self, _InternalMessageId.FailedMonitorAjaxSetRequestHeader, "Failed to monitor XMLHttpRequest.setRequestHeader, monitoring data for this ajax call may be incorrect.")
	                            });
	                        }
	                        _xhrInitialized = true;
	                    }
	                }
	                function _isDisabledRequest(xhr, request, init) {
	                    var isDisabled = false;
	                    var theUrl = ((!isString(request) ? (request || {}).url || "" : request) || "").toLowerCase();
	                    var idx = _indexOf(theUrl, "?");
	                    var idx2 = _indexOf(theUrl, "#");
	                    if (idx === -1 || (idx2 !== -1 && idx2 < idx)) {
	                        idx = idx2;
	                    }
	                    if (idx !== -1) {
	                        theUrl = theUrl.substring(0, idx);
	                    }
	                    if (!isNullOrUndefined(xhr)) {
	                        isDisabled = xhr[DisabledPropertyName] === true || theUrl[DisabledPropertyName] === true;
	                    }
	                    else if (!isNullOrUndefined(request)) {
	                        isDisabled = (typeof request === 'object' ? request[DisabledPropertyName] === true : false) ||
	                            (init ? init[DisabledPropertyName] === true : false);
	                    }
	                    if (isDisabled) {
	                        if (!_disabledUrls[theUrl]) {
	                            _disabledUrls[theUrl] = 1;
	                        }
	                    }
	                    else {
	                        if (_disabledUrls[theUrl]) {
	                            isDisabled = true;
	                        }
	                    }
	                    return isDisabled;
	                }
	                function _isMonitoredXhrInstance(xhr, excludeAjaxDataValidation) {
	                    var ajaxValidation = true;
	                    var initialized = _xhrInitialized;
	                    if (!isNullOrUndefined(xhr)) {
	                        ajaxValidation = excludeAjaxDataValidation === true || !isNullOrUndefined(xhr[strAjaxData]);
	                    }
	                    return initialized
	                        && ajaxValidation;
	                }
	                function _openHandler(xhr, method, url, async) {
	                    var traceID = (_context && _context.telemetryTrace && _context.telemetryTrace.traceID) || generateW3CId();
	                    var spanID = generateW3CId().substr(0, 16);
	                    var ajaxData = new ajaxRecord(traceID, spanID, _self[strDiagLog]());
	                    ajaxData.method = method;
	                    ajaxData.requestUrl = url;
	                    ajaxData.xhrMonitoringState.openDone = true;
	                    ajaxData.requestHeaders = {};
	                    ajaxData.async = async;
	                    xhr[strAjaxData] = ajaxData;
	                    _attachToOnReadyStateChange(xhr);
	                }
	                function _attachToOnReadyStateChange(xhr) {
	                    xhr[strAjaxData].xhrMonitoringState.stateChangeAttached = EventHelper.Attach(xhr, "readystatechange", function () {
	                        try {
	                            if (xhr && xhr.readyState === 4 && _isMonitoredXhrInstance(xhr)) {
	                                _onAjaxComplete(xhr);
	                            }
	                        }
	                        catch (e) {
	                            var exceptionText = dumpObj(e);
	                            if (!exceptionText || _indexOf(exceptionText.toLowerCase(), "c00c023f") === -1) {
	                                _throwInternalCritical(_self, _InternalMessageId.FailedMonitorAjaxRSC, "Failed to monitor XMLHttpRequest 'readystatechange' event handler, monitoring data for this ajax call may be incorrect.", {
	                                    ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(xhr),
	                                    exception: exceptionText
	                                });
	                            }
	                        }
	                    });
	                }
	                function _getResponseText(xhr) {
	                    try {
	                        var responseType = xhr.responseType;
	                        if (responseType === "" || responseType === "text") {
	                            return xhr.responseText;
	                        }
	                    }
	                    catch (e) {
	                    }
	                    return null;
	                }
	                function _onAjaxComplete(xhr) {
	                    var ajaxData = xhr[strAjaxData];
	                    ajaxData.responseFinishedTime = dateTimeUtilsNow();
	                    ajaxData.status = xhr.status;
	                    function _reportXhrError(e, failedProps) {
	                        var errorProps = failedProps || {};
	                        errorProps["ajaxDiagnosticsMessage"] = _getFailedAjaxDiagnosticsMessage(xhr);
	                        if (e) {
	                            errorProps["exception"] = dumpObj(e);
	                        }
	                        _throwInternalWarning(_self, _InternalMessageId.FailedMonitorAjaxDur, "Failed to calculate the duration of the ajax call, monitoring data for this ajax call won't be sent.", errorProps);
	                    }
	                    _findPerfResourceEntry("xmlhttprequest", ajaxData, function () {
	                        try {
	                            var dependency = ajaxData.CreateTrackItem("Ajax", _enableRequestHeaderTracking, function () {
	                                var ajaxResponse = {
	                                    statusText: xhr.statusText,
	                                    headerMap: null,
	                                    correlationContext: _getAjaxCorrelationContext(xhr),
	                                    type: xhr.responseType,
	                                    responseText: _getResponseText(xhr),
	                                    response: xhr.response
	                                };
	                                if (_enableResponseHeaderTracking) {
	                                    var headers = xhr.getAllResponseHeaders();
	                                    if (headers) {
	                                        var arr = strTrim(headers).split(/[\r\n]+/);
	                                        var responseHeaderMap_2 = {};
	                                        arrForEach(arr, function (line) {
	                                            var parts = line.split(': ');
	                                            var header = parts.shift();
	                                            var value = parts.join(': ');
	                                            responseHeaderMap_2[header] = value;
	                                        });
	                                        ajaxResponse.headerMap = responseHeaderMap_2;
	                                    }
	                                }
	                                return ajaxResponse;
	                            });
	                            if (dependency) {
	                                _self[strTrackDependencyDataInternal](dependency);
	                            }
	                            else {
	                                _reportXhrError(null, {
	                                    requestSentTime: ajaxData.requestSentTime,
	                                    responseFinishedTime: ajaxData.responseFinishedTime
	                                });
	                            }
	                        }
	                        finally {
	                            try {
	                                xhr[strAjaxData] = null;
	                            }
	                            catch (e) {
	                            }
	                        }
	                    }, function (e) {
	                        _reportXhrError(e, null);
	                    });
	                }
	                function _getAjaxCorrelationContext(xhr) {
	                    try {
	                        var responseHeadersString = xhr.getAllResponseHeaders();
	                        if (responseHeadersString !== null) {
	                            var index = _indexOf(responseHeadersString.toLowerCase(), RequestHeaders.requestContextHeaderLowerCase);
	                            if (index !== -1) {
	                                var responseHeader = xhr.getResponseHeader(RequestHeaders.requestContextHeader);
	                                return CorrelationIdHelper.getCorrelationContext(responseHeader);
	                            }
	                        }
	                    }
	                    catch (e) {
	                        _throwInternalWarning(_self, _InternalMessageId.FailedMonitorAjaxGetCorrelationHeader, "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.", {
	                            ajaxDiagnosticsMessage: _getFailedAjaxDiagnosticsMessage(xhr),
	                            exception: dumpObj(e)
	                        });
	                    }
	                }
	                function _createMarkId(type, ajaxData) {
	                    if (ajaxData.requestUrl && _markPrefix && _enableAjaxPerfTracking) {
	                        var performance_1 = getPerformance();
	                        if (performance_1 && isFunction(performance_1.mark)) {
	                            _markCount++;
	                            var markId = _markPrefix + type + "#" + _markCount;
	                            performance_1.mark(markId);
	                            var entries = performance_1.getEntriesByName(markId);
	                            if (entries && entries.length === 1) {
	                                ajaxData.perfMark = entries[0];
	                            }
	                        }
	                    }
	                }
	                function _findPerfResourceEntry(initiatorType, ajaxData, trackCallback, reportError) {
	                    var perfMark = ajaxData.perfMark;
	                    var performance = getPerformance();
	                    var maxAttempts = _config.maxAjaxPerfLookupAttempts;
	                    var retryDelay = _config.ajaxPerfLookupDelay;
	                    var requestUrl = ajaxData.requestUrl;
	                    var attempt = 0;
	                    (function locateResourceTiming() {
	                        try {
	                            if (performance && perfMark) {
	                                attempt++;
	                                var perfTiming = null;
	                                var entries = performance.getEntries();
	                                for (var lp = entries.length - 1; lp >= 0; lp--) {
	                                    var entry = entries[lp];
	                                    if (entry) {
	                                        if (entry.entryType === "resource") {
	                                            if (entry.initiatorType === initiatorType &&
	                                                (_indexOf(entry.name, requestUrl) !== -1 || _indexOf(requestUrl, entry.name) !== -1)) {
	                                                perfTiming = entry;
	                                            }
	                                        }
	                                        else if (entry.entryType === "mark" && entry.name === perfMark.name) {
	                                            ajaxData.perfTiming = perfTiming;
	                                            break;
	                                        }
	                                        if (entry.startTime < perfMark.startTime - 1000) {
	                                            break;
	                                        }
	                                    }
	                                }
	                            }
	                            if (!perfMark ||
	                                ajaxData.perfTiming ||
	                                attempt >= maxAttempts ||
	                                ajaxData.async === false) {
	                                if (perfMark && isFunction(performance.clearMarks)) {
	                                    performance.clearMarks(perfMark.name);
	                                }
	                                ajaxData.perfAttempts = attempt;
	                                trackCallback();
	                            }
	                            else {
	                                setTimeout(locateResourceTiming, retryDelay);
	                            }
	                        }
	                        catch (e) {
	                            reportError(e);
	                        }
	                    })();
	                }
	                function _createFetchRecord(input, init) {
	                    var traceID = (_context && _context.telemetryTrace && _context.telemetryTrace.traceID) || generateW3CId();
	                    var spanID = generateW3CId().substr(0, 16);
	                    var ajaxData = new ajaxRecord(traceID, spanID, _self[strDiagLog]());
	                    ajaxData.requestSentTime = dateTimeUtilsNow();
	                    if (input instanceof Request) {
	                        ajaxData.requestUrl = input ? input.url : "";
	                    }
	                    else {
	                        ajaxData.requestUrl = input;
	                    }
	                    var method = "GET";
	                    if (init && init.method) {
	                        method = init.method;
	                    }
	                    else if (input && input instanceof Request) {
	                        method = input.method;
	                    }
	                    ajaxData.method = method;
	                    var requestHeaders = {};
	                    if (_enableRequestHeaderTracking) {
	                        var headers = new Headers((init ? init.headers : 0) || (input instanceof Request ? (input.headers || {}) : {}));
	                        headers.forEach(function (value, key) {
	                            requestHeaders[key] = value;
	                        });
	                    }
	                    ajaxData.requestHeaders = requestHeaders;
	                    _createMarkId("fetch", ajaxData);
	                    return ajaxData;
	                }
	                function _getFailedFetchDiagnosticsMessage(input) {
	                    var result = "";
	                    try {
	                        if (!isNullOrUndefined(input)) {
	                            if (typeof (input) === "string") {
	                                result += "(url: '" + input + "')";
	                            }
	                            else {
	                                result += "(url: '" + input.url + "')";
	                            }
	                        }
	                    }
	                    catch (e) {
	                        _throwInternalCritical(_self, _InternalMessageId.FailedMonitorAjaxOpen, "Failed to grab failed fetch diagnostics message", { exception: dumpObj(e) });
	                    }
	                    return result;
	                }
	                function _reportFetchMetrics(callDetails, status, input, ajaxData, getResponse, properties) {
	                    if (!ajaxData) {
	                        return;
	                    }
	                    function _reportFetchError(msgId, e, failedProps) {
	                        var errorProps = failedProps || {};
	                        errorProps["fetchDiagnosticsMessage"] = _getFailedFetchDiagnosticsMessage(input);
	                        if (e) {
	                            errorProps["exception"] = dumpObj(e);
	                        }
	                        _throwInternalWarning(_self, msgId, "Failed to calculate the duration of the fetch call, monitoring data for this fetch call won't be sent.", errorProps);
	                    }
	                    ajaxData.responseFinishedTime = dateTimeUtilsNow();
	                    ajaxData.status = status;
	                    _findPerfResourceEntry("fetch", ajaxData, function () {
	                        var dependency = ajaxData.CreateTrackItem("Fetch", _enableRequestHeaderTracking, getResponse);
	                        if (dependency) {
	                            _self[strTrackDependencyDataInternal](dependency);
	                        }
	                        else {
	                            _reportFetchError(_InternalMessageId.FailedMonitorAjaxDur, null, {
	                                requestSentTime: ajaxData.requestSentTime,
	                                responseFinishedTime: ajaxData.responseFinishedTime
	                            });
	                        }
	                    }, function (e) {
	                        _reportFetchError(_InternalMessageId.FailedMonitorAjaxGetCorrelationHeader, e, null);
	                    });
	                }
	                function _getFetchCorrelationContext(response) {
	                    if (response && response.headers) {
	                        try {
	                            var responseHeader = response.headers.get(RequestHeaders.requestContextHeader);
	                            return CorrelationIdHelper.getCorrelationContext(responseHeader);
	                        }
	                        catch (e) {
	                            _throwInternalWarning(_self, _InternalMessageId.FailedMonitorAjaxGetCorrelationHeader, "Failed to get Request-Context correlation header as it may be not included in the response or not accessible.", {
	                                fetchDiagnosticsMessage: _getFailedFetchDiagnosticsMessage(response),
	                                exception: dumpObj(e)
	                            });
	                        }
	                    }
	                }
	            });
	            return _this;
	        }
	        AjaxMonitor.getDefaultConfig = function () {
	            var config = {
	                maxAjaxCallsPerView: 500,
	                disableAjaxTracking: false,
	                disableFetchTracking: true,
	                disableCorrelationHeaders: false,
	                distributedTracingMode: exports.DistributedTracingModes.AI_AND_W3C,
	                correlationHeaderExcludedDomains: [
	                    "*.blob.core.windows.net",
	                    "*.blob.core.chinacloudapi.cn",
	                    "*.blob.core.cloudapi.de",
	                    "*.blob.core.usgovcloudapi.net"
	                ],
	                correlationHeaderDomains: undefined,
	                appId: undefined,
	                enableCorsCorrelation: false,
	                enableRequestHeaderTracking: false,
	                enableResponseHeaderTracking: false,
	                enableAjaxErrorStatusText: false,
	                enableAjaxPerfTracking: false,
	                maxAjaxPerfLookupAttempts: 3,
	                ajaxPerfLookupDelay: 25
	            };
	            return config;
	        };
	        AjaxMonitor.getEmptyConfig = function () {
	            var emptyConfig = this.getDefaultConfig();
	            objForEachKey(emptyConfig, function (value) {
	                emptyConfig[value] = undefined;
	            });
	            return emptyConfig;
	        };
	        AjaxMonitor.prototype.processTelemetry = function (item, itemCtx) {
	            this.processNext(item, itemCtx);
	        };
	        AjaxMonitor.identifier = "AjaxDependencyPlugin";
	        return AjaxMonitor;
	    }(BaseTelemetryPlugin));
	
	    /*!
	     * Application Insights JavaScript SDK - Web, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var _internalSdkSrc;
	    var _ignoreUpdateSnippetProperties$1 = [
	        "snippet", "dependencies", "properties", "_snippetVersion", "appInsightsNew", "getSKUDefaults",
	    ];
	    var Telemetry = {
	        __proto__: null,
	        PropertiesPluginIdentifier: PropertiesPluginIdentifier,
	        BreezeChannelIdentifier: BreezeChannelIdentifier,
	        AnalyticsPluginIdentifier: AnalyticsPluginIdentifier,
	        Util: Util,
	        CorrelationIdHelper: CorrelationIdHelper,
	        UrlHelper: UrlHelper,
	        DateTimeUtils: DateTimeUtils,
	        ConnectionStringParser: ConnectionStringParser,
	        FieldType: FieldType,
	        RequestHeaders: RequestHeaders,
	        DisabledPropertyName: DisabledPropertyName,
	        ProcessLegacy: ProcessLegacy,
	        SampleRate: SampleRate,
	        HttpMethod: HttpMethod,
	        DEFAULT_BREEZE_ENDPOINT: DEFAULT_BREEZE_ENDPOINT,
	        AIData: Data$1,
	        AIBase: Base,
	        Envelope: Envelope,
	        Event: Event$1,
	        Exception: Exception,
	        Metric: Metric,
	        PageView: PageView,
	        PageViewData: PageViewData,
	        RemoteDependencyData: RemoteDependencyData,
	        Trace: Trace,
	        PageViewPerformance: PageViewPerformance,
	        Data: Data,
	        SeverityLevel: exports.SeverityLevel,
	        ConfigurationManager: ConfigurationManager,
	        ContextTagKeys: ContextTagKeys,
	        DataSanitizer: DataSanitizer,
	        TelemetryItemCreator: TelemetryItemCreator,
	        CtxTagKeys: CtxTagKeys,
	        Extensions: Extensions,
	        DistributedTracingModes: exports.DistributedTracingModes
	    };
	    var Initialization = /** @class */ (function () {
	        function Initialization(snippet) {
	            var _self = this;
	            _self._snippetVersion = "" + (snippet.sv || snippet.version || "");
	            snippet.queue = snippet.queue || [];
	            snippet.version = snippet.version || 2.0;
	            var config = snippet.config || {};
	            if (config.connectionString) {
	                var cs = parseConnectionString(config.connectionString);
	                var ingest = cs.ingestionendpoint;
	                config.endpointUrl = ingest ? ingest + "/v2/track" : config.endpointUrl;
	                config.instrumentationKey = cs.instrumentationkey || config.instrumentationKey;
	            }
	            _self.appInsights = new ApplicationInsights();
	            _self.properties = new PropertiesPlugin();
	            _self.dependencies = new AjaxMonitor();
	            _self.core = new AppInsightsCore();
	            _self.snippet = snippet;
	            _self.config = config;
	            _self.getSKUDefaults();
	        }
	        Initialization.prototype.getCookieMgr = function () {
	            return this.appInsights.getCookieMgr();
	        };
	        Initialization.prototype.trackEvent = function (event, customProperties) {
	            this.appInsights.trackEvent(event, customProperties);
	        };
	        Initialization.prototype.trackPageView = function (pageView) {
	            var inPv = pageView || {};
	            this.appInsights.trackPageView(inPv);
	        };
	        Initialization.prototype.trackPageViewPerformance = function (pageViewPerformance) {
	            var inPvp = pageViewPerformance || {};
	            this.appInsights.trackPageViewPerformance(inPvp);
	        };
	        Initialization.prototype.trackException = function (exception) {
	            if (exception && !exception.exception && exception.error) {
	                exception.exception = exception.error;
	            }
	            this.appInsights.trackException(exception);
	        };
	        Initialization.prototype._onerror = function (exception) {
	            this.appInsights._onerror(exception);
	        };
	        Initialization.prototype.trackTrace = function (trace, customProperties) {
	            this.appInsights.trackTrace(trace, customProperties);
	        };
	        Initialization.prototype.trackMetric = function (metric, customProperties) {
	            this.appInsights.trackMetric(metric, customProperties);
	        };
	        Initialization.prototype.startTrackPage = function (name) {
	            this.appInsights.startTrackPage(name);
	        };
	        Initialization.prototype.stopTrackPage = function (name, url, customProperties, measurements) {
	            this.appInsights.stopTrackPage(name, url, customProperties, measurements);
	        };
	        Initialization.prototype.startTrackEvent = function (name) {
	            this.appInsights.startTrackEvent(name);
	        };
	        Initialization.prototype.stopTrackEvent = function (name, properties, measurements) {
	            this.appInsights.stopTrackEvent(name, properties, measurements);
	        };
	        Initialization.prototype.addTelemetryInitializer = function (telemetryInitializer) {
	            return this.appInsights.addTelemetryInitializer(telemetryInitializer);
	        };
	        Initialization.prototype.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
	            if (storeInCookie === void 0) { storeInCookie = false; }
	            this.properties.context.user.setAuthenticatedUserContext(authenticatedUserId, accountId, storeInCookie);
	        };
	        Initialization.prototype.clearAuthenticatedUserContext = function () {
	            this.properties.context.user.clearAuthenticatedUserContext();
	        };
	        Initialization.prototype.trackDependencyData = function (dependency) {
	            this.dependencies.trackDependencyData(dependency);
	        };
	        Initialization.prototype.flush = function (async) {
	            var _this = this;
	            if (async === void 0) { async = true; }
	            doPerf(this.core, function () { return "AISKU.flush"; }, function () {
	                arrForEach(_this.core.getTransmissionControls(), function (channels) {
	                    arrForEach(channels, function (channel) {
	                        channel.flush(async);
	                    });
	                });
	            }, null, async);
	        };
	        Initialization.prototype.onunloadFlush = function (async) {
	            if (async === void 0) { async = true; }
	            arrForEach(this.core.getTransmissionControls(), function (channels) {
	                arrForEach(channels, function (channel) {
	                    if (channel.onunloadFlush) {
	                        channel.onunloadFlush();
	                    }
	                    else {
	                        channel.flush(async);
	                    }
	                });
	            });
	        };
	        Initialization.prototype.loadAppInsights = function (legacyMode, logger, notificationManager) {
	            var _this = this;
	            if (legacyMode === void 0) { legacyMode = false; }
	            var _self = this;
	            function _updateSnippetProperties(snippet) {
	                if (snippet) {
	                    var snippetVer = "";
	                    if (!isNullOrUndefined(_self._snippetVersion)) {
	                        snippetVer += _self._snippetVersion;
	                    }
	                    if (legacyMode) {
	                        snippetVer += ".lg";
	                    }
	                    if (_self.context && _self.context.internal) {
	                        _self.context.internal.snippetVer = snippetVer || "-";
	                    }
	                    objForEachKey(_self, function (field, value) {
	                        if (isString(field) &&
	                            !isFunction(value) &&
	                            field && field[0] !== "_" &&
	                            _ignoreUpdateSnippetProperties$1.indexOf(field) === -1) {
	                            snippet[field] = value;
	                        }
	                    });
	                }
	            }
	            if (legacyMode && _self.config.extensions && _self.config.extensions.length > 0) {
	                throwError("Extensions not allowed in legacy mode");
	            }
	            doPerf(_self.core, function () { return "AISKU.loadAppInsights"; }, function () {
	                var extensions = [];
	                var appInsightsChannel = new Sender();
	                extensions.push(appInsightsChannel);
	                extensions.push(_self.properties);
	                extensions.push(_self.dependencies);
	                extensions.push(_self.appInsights);
	                _self.core.initialize(_self.config, extensions, logger, notificationManager);
	                _self.context = _self.properties.context;
	                if (_internalSdkSrc && _self.context) {
	                    _self.context.internal.sdkSrc = _internalSdkSrc;
	                }
	                _updateSnippetProperties(_self.snippet);
	                _self.emptyQueue();
	                _self.pollInternalLogs();
	                _self.addHousekeepingBeforeUnload(_this);
	            });
	            return _self;
	        };
	        Initialization.prototype.updateSnippetDefinitions = function (snippet) {
	            proxyAssign(snippet, this, function (name) {
	                return name && _ignoreUpdateSnippetProperties$1.indexOf(name) === -1;
	            });
	        };
	        Initialization.prototype.emptyQueue = function () {
	            var _self = this;
	            try {
	                if (isArray(_self.snippet.queue)) {
	                    var length_1 = _self.snippet.queue.length;
	                    for (var i = 0; i < length_1; i++) {
	                        var call = _self.snippet.queue[i];
	                        call();
	                    }
	                    _self.snippet.queue = undefined;
	                    delete _self.snippet.queue;
	                }
	            }
	            catch (exception) {
	                if (exception && isFunction(exception.toString)) {
	                    exception.toString();
	                }
	            }
	        };
	        Initialization.prototype.pollInternalLogs = function () {
	            this.core.pollInternalLogs();
	        };
	        Initialization.prototype.addHousekeepingBeforeUnload = function (appInsightsInstance) {
	            if (hasWindow() || hasDocument()) {
	                var performHousekeeping = function () {
	                    appInsightsInstance.onunloadFlush(false);
	                    arrForEach(appInsightsInstance.appInsights.core['_extensions'], function (ext) {
	                        if (ext.identifier === PropertiesPluginIdentifier) {
	                            if (ext && ext.context && ext.context._sessionManager) {
	                                ext.context._sessionManager.backup();
	                            }
	                            return -1;
	                        }
	                    });
	                };
	                if (!appInsightsInstance.appInsights.config.disableFlushOnBeforeUnload) {
	                    var added = addEventHandler('beforeunload', performHousekeeping);
	                    added = addEventHandler('pagehide', performHousekeeping) || added;
	                    if (!added && !isReactNative()) {
	                        appInsightsInstance.appInsights.core.logger.throwInternal(exports.LoggingSeverity.CRITICAL, _InternalMessageId.FailedToAddHandlerForOnBeforeUnload, 'Could not add handler for beforeunload and pagehide');
	                    }
	                }
	                if (!appInsightsInstance.appInsights.config.disableFlushOnUnload) {
	                    addEventHandler('pagehide', performHousekeeping);
	                }
	            }
	        };
	        Initialization.prototype.getSKUDefaults = function () {
	            var _self = this;
	            _self.config.diagnosticLogInterval =
	                _self.config.diagnosticLogInterval && _self.config.diagnosticLogInterval > 0 ? _self.config.diagnosticLogInterval : 10000;
	        };
	        return Initialization;
	    }());
	    (function () {
	        var sdkSrc = null;
	        var isModule = false;
	        var cdns = [
	            "://js.monitor.azure.com/",
	            "://az416426.vo.msecnd.net/"
	        ];
	        try {
	            var scrpt = (document || {}).currentScript;
	            if (scrpt) {
	                sdkSrc = scrpt.src;
	            }
	        }
	        catch (e) {
	        }
	        if (sdkSrc) {
	            try {
	                var url = sdkSrc.toLowerCase();
	                if (url) {
	                    var src = "";
	                    for (var idx = 0; idx < cdns.length; idx++) {
	                        if (url.indexOf(cdns[idx]) !== -1) {
	                            src = "cdn" + (idx + 1);
	                            if (url.indexOf("/scripts/") === -1) {
	                                if (url.indexOf("/next/") !== -1) {
	                                    src += "-next";
	                                }
	                                else if (url.indexOf("/beta/") !== -1) {
	                                    src += "-beta";
	                                }
	                            }
	                            _internalSdkSrc = src + (isModule ? ".mod" : "");
	                            break;
	                        }
	                    }
	                }
	            }
	            catch (e) {
	            }
	        }
	    })();
	
	    /*!
	     * Application Insights JavaScript SDK - Web, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var _ignoreUpdateSnippetProperties = [
	        "snippet", "getDefaultConfig", "_hasLegacyInitializers", "_queue", "_processLegacyInitializers"
	    ];
	    var AppInsightsDeprecated = /** @class */ (function () {
	        function AppInsightsDeprecated(snippet, appInsightsNew) {
	            this._hasLegacyInitializers = false;
	            this._queue = [];
	            this.config = AppInsightsDeprecated.getDefaultConfig(snippet.config);
	            this.appInsightsNew = appInsightsNew;
	            this.context = { addTelemetryInitializer: this.addTelemetryInitializers.bind(this) };
	        }
	        AppInsightsDeprecated.getDefaultConfig = function (config) {
	            if (!config) {
	                config = {};
	            }
	            config.endpointUrl = config.endpointUrl || "https://dc.services.visualstudio.com/v2/track";
	            config.sessionRenewalMs = 30 * 60 * 1000;
	            config.sessionExpirationMs = 24 * 60 * 60 * 1000;
	            config.maxBatchSizeInBytes = config.maxBatchSizeInBytes > 0 ? config.maxBatchSizeInBytes : 102400;
	            config.maxBatchInterval = !isNaN(config.maxBatchInterval) ? config.maxBatchInterval : 15000;
	            config.enableDebug = stringToBoolOrDefault(config.enableDebug);
	            config.disableExceptionTracking = stringToBoolOrDefault(config.disableExceptionTracking);
	            config.disableTelemetry = stringToBoolOrDefault(config.disableTelemetry);
	            config.verboseLogging = stringToBoolOrDefault(config.verboseLogging);
	            config.emitLineDelimitedJson = stringToBoolOrDefault(config.emitLineDelimitedJson);
	            config.diagnosticLogInterval = config.diagnosticLogInterval || 10000;
	            config.autoTrackPageVisitTime = stringToBoolOrDefault(config.autoTrackPageVisitTime);
	            if (isNaN(config.samplingPercentage) || config.samplingPercentage <= 0 || config.samplingPercentage >= 100) {
	                config.samplingPercentage = 100;
	            }
	            config.disableAjaxTracking = stringToBoolOrDefault(config.disableAjaxTracking);
	            config.maxAjaxCallsPerView = !isNaN(config.maxAjaxCallsPerView) ? config.maxAjaxCallsPerView : 500;
	            config.isBeaconApiDisabled = stringToBoolOrDefault(config.isBeaconApiDisabled, true);
	            config.disableCorrelationHeaders = stringToBoolOrDefault(config.disableCorrelationHeaders);
	            config.correlationHeaderExcludedDomains = config.correlationHeaderExcludedDomains || [
	                "*.blob.core.windows.net",
	                "*.blob.core.chinacloudapi.cn",
	                "*.blob.core.cloudapi.de",
	                "*.blob.core.usgovcloudapi.net"
	            ];
	            config.disableFlushOnBeforeUnload = stringToBoolOrDefault(config.disableFlushOnBeforeUnload);
	            config.disableFlushOnUnload = stringToBoolOrDefault(config.disableFlushOnUnload, config.disableFlushOnBeforeUnload);
	            config.enableSessionStorageBuffer = stringToBoolOrDefault(config.enableSessionStorageBuffer, true);
	            config.isRetryDisabled = stringToBoolOrDefault(config.isRetryDisabled);
	            config.isCookieUseDisabled = stringToBoolOrDefault(config.isCookieUseDisabled);
	            config.isStorageUseDisabled = stringToBoolOrDefault(config.isStorageUseDisabled);
	            config.isBrowserLinkTrackingEnabled = stringToBoolOrDefault(config.isBrowserLinkTrackingEnabled);
	            config.enableCorsCorrelation = stringToBoolOrDefault(config.enableCorsCorrelation);
	            return config;
	        };
	        AppInsightsDeprecated.prototype.addTelemetryInitializers = function (callBack) {
	            var _this = this;
	            if (!this._hasLegacyInitializers) {
	                this.appInsightsNew.addTelemetryInitializer(function (item) {
	                    _this._processLegacyInitializers(item);
	                });
	                this._hasLegacyInitializers = true;
	            }
	            this._queue.push(callBack);
	        };
	        AppInsightsDeprecated.prototype.getCookieMgr = function () {
	            return this.appInsightsNew.getCookieMgr();
	        };
	        AppInsightsDeprecated.prototype.startTrackPage = function (name) {
	            this.appInsightsNew.startTrackPage(name);
	        };
	        AppInsightsDeprecated.prototype.stopTrackPage = function (name, url, properties, measurements) {
	            this.appInsightsNew.stopTrackPage(name, url, properties);
	        };
	        AppInsightsDeprecated.prototype.trackPageView = function (name, url, properties, measurements, duration) {
	            var telemetry = {
	                name: name,
	                uri: url,
	                properties: properties,
	                measurements: measurements
	            };
	            this.appInsightsNew.trackPageView(telemetry);
	        };
	        AppInsightsDeprecated.prototype.trackEvent = function (name, properties, measurements) {
	            this.appInsightsNew.trackEvent({ name: name });
	        };
	        AppInsightsDeprecated.prototype.trackDependency = function (id, method, absoluteUrl, pathName, totalTime, success, resultCode) {
	            this.appInsightsNew.trackDependencyData({
	                id: id,
	                target: absoluteUrl,
	                type: pathName,
	                duration: totalTime,
	                properties: { HttpMethod: method },
	                success: success,
	                responseCode: resultCode
	            });
	        };
	        AppInsightsDeprecated.prototype.trackException = function (exception, handledAt, properties, measurements, severityLevel) {
	            this.appInsightsNew.trackException({
	                exception: exception
	            });
	        };
	        AppInsightsDeprecated.prototype.trackMetric = function (name, average, sampleCount, min, max, properties) {
	            this.appInsightsNew.trackMetric({ name: name, average: average, sampleCount: sampleCount, min: min, max: max });
	        };
	        AppInsightsDeprecated.prototype.trackTrace = function (message, properties, severityLevel) {
	            this.appInsightsNew.trackTrace({ message: message, severityLevel: severityLevel });
	        };
	        AppInsightsDeprecated.prototype.flush = function (async) {
	            this.appInsightsNew.flush(async);
	        };
	        AppInsightsDeprecated.prototype.setAuthenticatedUserContext = function (authenticatedUserId, accountId, storeInCookie) {
	            this.appInsightsNew.context.user.setAuthenticatedUserContext(authenticatedUserId, accountId, storeInCookie);
	        };
	        AppInsightsDeprecated.prototype.clearAuthenticatedUserContext = function () {
	            this.appInsightsNew.context.user.clearAuthenticatedUserContext();
	        };
	        AppInsightsDeprecated.prototype._onerror = function (message, url, lineNumber, columnNumber, error) {
	            this.appInsightsNew._onerror({ message: message, url: url, lineNumber: lineNumber, columnNumber: columnNumber, error: error });
	        };
	        AppInsightsDeprecated.prototype.startTrackEvent = function (name) {
	            this.appInsightsNew.startTrackEvent(name);
	        };
	        AppInsightsDeprecated.prototype.stopTrackEvent = function (name, properties, measurements) {
	            this.appInsightsNew.stopTrackEvent(name, properties, measurements);
	        };
	        AppInsightsDeprecated.prototype.downloadAndSetup = function (config) {
	            throwError("downloadAndSetup not implemented in web SKU");
	        };
	        AppInsightsDeprecated.prototype.updateSnippetDefinitions = function (snippet) {
	            proxyAssign(snippet, this, function (name) {
	                return name && _ignoreUpdateSnippetProperties.indexOf(name) === -1;
	            });
	        };
	        AppInsightsDeprecated.prototype.loadAppInsights = function () {
	            var _this = this;
	            if (this.config["iKey"]) {
	                var originalTrackPageView_1 = this.trackPageView;
	                this.trackPageView = function (pagePath, properties, measurements) {
	                    originalTrackPageView_1.apply(_this, [null, pagePath, properties, measurements]);
	                };
	            }
	            var legacyPageView = "logPageView";
	            if (typeof this.snippet[legacyPageView] === "function") {
	                this[legacyPageView] = function (pagePath, properties, measurements) {
	                    _this.trackPageView(null, pagePath, properties, measurements);
	                };
	            }
	            var legacyEvent = "logEvent";
	            if (typeof this.snippet[legacyEvent] === "function") {
	                this[legacyEvent] = function (name, props, measurements) {
	                    _this.trackEvent(name, props, measurements);
	                };
	            }
	            return this;
	        };
	        AppInsightsDeprecated.prototype._processLegacyInitializers = function (item) {
	            item.tags[ProcessLegacy] = this._queue;
	            return item;
	        };
	        return AppInsightsDeprecated;
	    }());
	
	    /*!
	     * Application Insights JavaScript SDK - Web, 2.6.1
	     * Copyright (c) Microsoft and contributors. All rights reserved.
	     */
	    var ApplicationInsightsContainer = /** @class */ (function () {
	        function ApplicationInsightsContainer() {
	        }
	        ApplicationInsightsContainer.getAppInsights = function (snippet, version) {
	            var initialization = new Initialization(snippet);
	            var legacyMode = version !== 2.0 ? true : false;
	            _legacyCookieMgr();
	            if (version === 2.0) {
	                initialization.updateSnippetDefinitions(snippet);
	                initialization.loadAppInsights(legacyMode);
	                return initialization;
	            }
	            else {
	                var legacy = new AppInsightsDeprecated(snippet, initialization);
	                legacy.updateSnippetDefinitions(snippet);
	                initialization.loadAppInsights(legacyMode);
	                return legacy;
	            }
	        };
	        return ApplicationInsightsContainer;
	    }());
	
	    exports.AppInsightsCore = AppInsightsCore;
	    exports.ApplicationAnalytics = ApplicationInsights;
	    exports.ApplicationInsights = Initialization;
	    exports.ApplicationInsightsContainer = ApplicationInsightsContainer;
	    exports.BaseCore = BaseCore;
	    exports.BaseTelemetryPlugin = BaseTelemetryPlugin;
	    exports.CoreUtils = CoreUtils;
	    exports.DependenciesPlugin = AjaxMonitor;
	    exports.Event = Event$1;
	    exports.Exception = Exception;
	    exports.Metric = Metric;
	    exports.NotificationManager = NotificationManager;
	    exports.PageView = PageView;
	    exports.PageViewPerformance = PageViewPerformance;
	    exports.PerfEvent = PerfEvent;
	    exports.PerfManager = PerfManager;
	    exports.PropertiesPlugin = PropertiesPlugin;
	    exports.RemoteDependencyData = RemoteDependencyData;
	    exports.Sender = Sender;
	    exports.Telemetry = Telemetry;
	    exports.Trace = Trace;
	    exports.Util = Util;
	    exports._InternalMessageId = _InternalMessageId;
	    exports.doPerf = doPerf;
	
	    (function(obj, prop, descriptor) { /* ai_es3_polyfil defineProperty */ var func = Object["defineProperty"]; if (func) { try { return func(obj, prop, descriptor); } catch(e) { /* IE8 defines defineProperty, but will throw */ } } if (descriptor && typeof descriptor.value !== undefined) { obj[prop] = descriptor.value; } return obj; })(exports, '__esModule', { value: true });
	
	})));
	//# sourceMappingURL=applicationinsights-web.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	var utils = __webpack_require__(59);
	var bind = __webpack_require__(417);
	var Axios = __webpack_require__(826);
	var mergeConfig = __webpack_require__(415);
	var defaults = __webpack_require__(416);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(mergeConfig(axios.defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(412);
	axios.CancelToken = __webpack_require__(825);
	axios.isCancel = __webpack_require__(413);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(840);
	
	// Expose isAxiosError
	axios.isAxiosError = __webpack_require__(836);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	var Cancel = __webpack_require__(412);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	var utils = __webpack_require__(59);
	var buildURL = __webpack_require__(418);
	var InterceptorManager = __webpack_require__(827);
	var dispatchRequest = __webpack_require__(829);
	var mergeConfig = __webpack_require__(415);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = arguments[1] || {};
	    config.url = arguments[0];
	  } else {
	    config = config || {};
	  }
	
	  config = mergeConfig(this.defaults, config);
	
	  // Set config.method
	  if (config.method) {
	    config.method = config.method.toLowerCase();
	  } else if (this.defaults.method) {
	    config.method = this.defaults.method.toLowerCase();
	  } else {
	    config.method = 'get';
	  }
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	Axios.prototype.getUri = function getUri(config) {
	  config = mergeConfig(this.defaults, config);
	  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: (config || {}).data
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(mergeConfig(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(59);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isAbsoluteURL = __webpack_require__(835);
	var combineURLs = __webpack_require__(833);
	
	/**
	 * Creates a new URL by combining the baseURL with the requestedURL,
	 * only when the requestedURL is not already an absolute URL.
	 * If the requestURL is absolute, this function returns the requestedURL untouched.
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} requestedURL Absolute or relative URL to combine
	 * @returns {string} The combined full path
	 */
	module.exports = function buildFullPath(baseURL, requestedURL) {
	  if (baseURL && !isAbsoluteURL(requestedURL)) {
	    return combineURLs(baseURL, requestedURL);
	  }
	  return requestedURL;
	};


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	var utils = __webpack_require__(59);
	var transformData = __webpack_require__(832);
	var isCancel = __webpack_require__(413);
	var defaults = __webpack_require__(416);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	
	  error.request = request;
	  error.response = response;
	  error.isAxiosError = true;
	
	  error.toJSON = function toJSON() {
	    return {
	      // Standard
	      message: this.message,
	      name: this.name,
	      // Microsoft
	      description: this.description,
	      number: this.number,
	      // Mozilla
	      fileName: this.fileName,
	      lineNumber: this.lineNumber,
	      columnNumber: this.columnNumber,
	      stack: this.stack,
	      // Axios
	      config: this.config,
	      code: this.code
	    };
	  };
	  return error;
	};


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(414);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(59);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 833 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(59);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	    (function standardBrowserEnv() {
	      return {
	        write: function write(name, value, expires, path, domain, secure) {
	          var cookie = [];
	          cookie.push(name + '=' + encodeURIComponent(value));
	
	          if (utils.isNumber(expires)) {
	            cookie.push('expires=' + new Date(expires).toGMTString());
	          }
	
	          if (utils.isString(path)) {
	            cookie.push('path=' + path);
	          }
	
	          if (utils.isString(domain)) {
	            cookie.push('domain=' + domain);
	          }
	
	          if (secure === true) {
	            cookie.push('secure');
	          }
	
	          document.cookie = cookie.join('; ');
	        },
	
	        read: function read(name) {
	          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	          return (match ? decodeURIComponent(match[3]) : null);
	        },
	
	        remove: function remove(name) {
	          this.write(name, '', Date.now() - 86400000);
	        }
	      };
	    })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return {
	        write: function write() {},
	        read: function read() { return null; },
	        remove: function remove() {}
	      };
	    })()
	);


/***/ }),
/* 835 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 836 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the payload is an error thrown by Axios
	 *
	 * @param {*} payload The value to test
	 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
	 */
	module.exports = function isAxiosError(payload) {
	  return (typeof payload === 'object') && (payload.isAxiosError === true);
	};


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(59);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	    (function standardBrowserEnv() {
	      var msie = /(msie|trident)/i.test(navigator.userAgent);
	      var urlParsingNode = document.createElement('a');
	      var originURL;
	
	      /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	      function resolveURL(url) {
	        var href = url;
	
	        if (msie) {
	        // IE needs attribute set twice to normalize properties
	          urlParsingNode.setAttribute('href', href);
	          href = urlParsingNode.href;
	        }
	
	        urlParsingNode.setAttribute('href', href);
	
	        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	        return {
	          href: urlParsingNode.href,
	          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	          host: urlParsingNode.host,
	          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	          hostname: urlParsingNode.hostname,
	          port: urlParsingNode.port,
	          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	            urlParsingNode.pathname :
	            '/' + urlParsingNode.pathname
	        };
	      }
	
	      originURL = resolveURL(window.location.href);
	
	      /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	      return function isURLSameOrigin(requestURL) {
	        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	        return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	      };
	    })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	    (function nonStandardBrowserEnv() {
	      return function isURLSameOrigin() {
	        return true;
	      };
	    })()
	);


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(59);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(59);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 840 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	Object.defineProperty(exports, "__esModule", { value: !0 });var t,
	    e = __webpack_require__(1),
	    n = (t = e) && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && "default" in t ? t.default : t,
	    r = __webpack_require__(409),
	    o = e.createContext({ instance: r.stubbedPublicClientApplication, inProgress: r.InteractionStatus.None, accounts: [], logger: new r.Logger({}) }),
	    a = o.Consumer;function i(t, e) {
	  return "function" == typeof t ? t(e) : t;
	}var c = function c() {
	  return e.useContext(o);
	};function u(t, e) {
	  var n = t.getAllAccounts();return n.length > 0 && (e.homeAccountId || e.localAccountId || e.username) && n.filter(function (t) {
	    return !(e.username && e.username.toLowerCase() !== t.username.toLowerCase() || e.homeAccountId && e.homeAccountId.toLowerCase() !== t.homeAccountId.toLowerCase() || e.localAccountId && e.localAccountId.toLowerCase() !== t.localAccountId.toLowerCase());
	  })[0] || null;
	}function s(t) {
	  var n = c(),
	      o = n.instance,
	      a = n.inProgress,
	      i = a === r.InteractionStatus.Startup ? null : u(o, t),
	      s = e.useState(i),
	      l = s[0],
	      f = s[1];return e.useEffect(function () {
	    f(u(o, t));
	  }, [a, t, o]), l;
	}function l(t, e, n) {
	  return n && (n.username || n.homeAccountId || n.localAccountId) ? !!e : t.length > 0;
	}function f(t) {
	  var n = c(),
	      o = n.accounts,
	      a = n.inProgress,
	      i = s(t || {}),
	      u = a !== r.InteractionStatus.Startup && l(o, i, t),
	      f = e.useState(u),
	      h = f[0],
	      v = f[1];return e.useEffect(function () {
	    v(l(o, i, t));
	  }, [o, i, t]), h;
	}function h(t, e, n, r, o, a, i) {
	  try {
	    var c = t[a](i),
	        u = c.value;
	  } catch (t) {
	    return void n(t);
	  }c.done ? e(u) : Promise.resolve(u).then(r, o);
	}var v,
	    p = (function (t) {
	  var e = function (t) {
	    var e = Object.prototype,
	        n = e.hasOwnProperty,
	        r = "function" == typeof Symbol ? Symbol : {},
	        o = r.iterator || "@@iterator",
	        a = r.asyncIterator || "@@asyncIterator",
	        i = r.toStringTag || "@@toStringTag";function c(t, e, n) {
	      return Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }), t[e];
	    }try {
	      c({}, "");
	    } catch (t) {
	      c = function c(t, e, n) {
	        return t[e] = n;
	      };
	    }function u(t, e, n, r) {
	      var o = Object.create((e && e.prototype instanceof f ? e : f).prototype),
	          a = new S(r || []);return o._invoke = function (t, e, n) {
	        var r = "suspendedStart";return function (o, a) {
	          if ("executing" === r) throw new Error("Generator is already running");if ("completed" === r) {
	            if ("throw" === o) throw a;return { value: void 0, done: !0 };
	          }for (n.method = o, n.arg = a;;) {
	            var i = n.delegate;if (i) {
	              var c = w(i, n);if (c) {
	                if (c === l) continue;return c;
	              }
	            }if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
	              if ("suspendedStart" === r) throw r = "completed", n.arg;n.dispatchException(n.arg);
	            } else "return" === n.method && n.abrupt("return", n.arg);r = "executing";var u = s(t, e, n);if ("normal" === u.type) {
	              if (r = n.done ? "completed" : "suspendedYield", u.arg === l) continue;return { value: u.arg, done: n.done };
	            }"throw" === u.type && (r = "completed", n.method = "throw", n.arg = u.arg);
	          }
	        };
	      }(t, n, a), o;
	    }function s(t, e, n) {
	      try {
	        return { type: "normal", arg: t.call(e, n) };
	      } catch (t) {
	        return { type: "throw", arg: t };
	      }
	    }t.wrap = u;var l = {};function f() {}function h() {}function v() {}var p = {};p[o] = function () {
	      return this;
	    };var d = Object.getPrototypeOf,
	        m = d && d(d(A([])));m && m !== e && n.call(m, o) && (p = m);var g = v.prototype = f.prototype = Object.create(p);function y(t) {
	      ["next", "throw", "return"].forEach(function (e) {
	        c(t, e, function (t) {
	          return this._invoke(e, t);
	        });
	      });
	    }function E(t, e) {
	      var r;this._invoke = function (o, a) {
	        function i() {
	          return new e(function (r, i) {
	            !function r(o, a, i, c) {
	              var u = s(t[o], t, a);if ("throw" !== u.type) {
	                var l = u.arg,
	                    f = l.value;return f && "object" == (typeof f === "undefined" ? "undefined" : _typeof(f)) && n.call(f, "__await") ? e.resolve(f.__await).then(function (t) {
	                  r("next", t, i, c);
	                }, function (t) {
	                  r("throw", t, i, c);
	                }) : e.resolve(f).then(function (t) {
	                  l.value = t, i(l);
	                }, function (t) {
	                  return r("throw", t, i, c);
	                });
	              }c(u.arg);
	            }(o, a, r, i);
	          });
	        }return r = r ? r.then(i, i) : i();
	      };
	    }function w(t, e) {
	      var n = t.iterator[e.method];if (void 0 === n) {
	        if (e.delegate = null, "throw" === e.method) {
	          if (t.iterator.return && (e.method = "return", e.arg = void 0, w(t, e), "throw" === e.method)) return l;e.method = "throw", e.arg = new TypeError("The iterator does not provide a 'throw' method");
	        }return l;
	      }var r = s(n, t.iterator, e.arg);if ("throw" === r.type) return e.method = "throw", e.arg = r.arg, e.delegate = null, l;var o = r.arg;return o ? o.done ? (e[t.resultName] = o.value, e.next = t.nextLoc, "return" !== e.method && (e.method = "next", e.arg = void 0), e.delegate = null, l) : o : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, l);
	    }function I(t) {
	      var e = { tryLoc: t[0] };1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
	    }function b(t) {
	      var e = t.completion || {};e.type = "normal", delete e.arg, t.completion = e;
	    }function S(t) {
	      this.tryEntries = [{ tryLoc: "root" }], t.forEach(I, this), this.reset(!0);
	    }function A(t) {
	      if (t) {
	        var e = t[o];if (e) return e.call(t);if ("function" == typeof t.next) return t;if (!isNaN(t.length)) {
	          var r = -1,
	              a = function e() {
	            for (; ++r < t.length;) {
	              if (n.call(t, r)) return e.value = t[r], e.done = !1, e;
	            }return e.value = void 0, e.done = !0, e;
	          };return a.next = a;
	        }
	      }return { next: L };
	    }function L() {
	      return { value: void 0, done: !0 };
	    }return h.prototype = g.constructor = v, v.constructor = h, h.displayName = c(v, i, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
	      var e = "function" == typeof t && t.constructor;return !!e && (e === h || "GeneratorFunction" === (e.displayName || e.name));
	    }, t.mark = function (t) {
	      return Object.setPrototypeOf ? Object.setPrototypeOf(t, v) : (t.__proto__ = v, c(t, i, "GeneratorFunction")), t.prototype = Object.create(g), t;
	    }, t.awrap = function (t) {
	      return { __await: t };
	    }, y(E.prototype), E.prototype[a] = function () {
	      return this;
	    }, t.AsyncIterator = E, t.async = function (e, n, r, o, a) {
	      void 0 === a && (a = Promise);var i = new E(u(e, n, r, o), a);return t.isGeneratorFunction(n) ? i : i.next().then(function (t) {
	        return t.done ? t.value : i.next();
	      });
	    }, y(g), c(g, i, "Generator"), g[o] = function () {
	      return this;
	    }, g.toString = function () {
	      return "[object Generator]";
	    }, t.keys = function (t) {
	      var e = [];for (var n in t) {
	        e.push(n);
	      }return e.reverse(), function n() {
	        for (; e.length;) {
	          var r = e.pop();if (r in t) return n.value = r, n.done = !1, n;
	        }return n.done = !0, n;
	      };
	    }, t.values = A, S.prototype = { constructor: S, reset: function reset(t) {
	        if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(b), !t) for (var e in this) {
	          "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
	        }
	      }, stop: function stop() {
	        this.done = !0;var t = this.tryEntries[0].completion;if ("throw" === t.type) throw t.arg;return this.rval;
	      }, dispatchException: function dispatchException(t) {
	        if (this.done) throw t;var e = this;function r(n, r) {
	          return i.type = "throw", i.arg = t, e.next = n, r && (e.method = "next", e.arg = void 0), !!r;
	        }for (var o = this.tryEntries.length - 1; o >= 0; --o) {
	          var a = this.tryEntries[o],
	              i = a.completion;if ("root" === a.tryLoc) return r("end");if (a.tryLoc <= this.prev) {
	            var c = n.call(a, "catchLoc"),
	                u = n.call(a, "finallyLoc");if (c && u) {
	              if (this.prev < a.catchLoc) return r(a.catchLoc, !0);if (this.prev < a.finallyLoc) return r(a.finallyLoc);
	            } else if (c) {
	              if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
	            } else {
	              if (!u) throw new Error("try statement without catch or finally");if (this.prev < a.finallyLoc) return r(a.finallyLoc);
	            }
	          }
	        }
	      }, abrupt: function abrupt(t, e) {
	        for (var r = this.tryEntries.length - 1; r >= 0; --r) {
	          var o = this.tryEntries[r];if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
	            var a = o;break;
	          }
	        }a && ("break" === t || "continue" === t) && a.tryLoc <= e && e <= a.finallyLoc && (a = null);var i = a ? a.completion : {};return i.type = t, i.arg = e, a ? (this.method = "next", this.next = a.finallyLoc, l) : this.complete(i);
	      }, complete: function complete(t, e) {
	        if ("throw" === t.type) throw t.arg;return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), l;
	      }, finish: function finish(t) {
	        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
	          var n = this.tryEntries[e];if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), b(n), l;
	        }
	      }, catch: function _catch(t) {
	        for (var e = this.tryEntries.length - 1; e >= 0; --e) {
	          var n = this.tryEntries[e];if (n.tryLoc === t) {
	            var r = n.completion;if ("throw" === r.type) {
	              var o = r.arg;b(n);
	            }return o;
	          }
	        }throw new Error("illegal catch attempt");
	      }, delegateYield: function delegateYield(t, e, n) {
	        return this.delegate = { iterator: A(t), resultName: e, nextLoc: n }, "next" === this.method && (this.arg = void 0), l;
	      } }, t;
	  }(t.exports);try {
	    regeneratorRuntime = e;
	  } catch (t) {
	    Function("r", "regeneratorRuntime = r")(e);
	  }
	}(v = { exports: {} }), v.exports);function d(t, n, o) {
	  var a = c(),
	      i = a.instance,
	      u = a.inProgress,
	      s = a.logger,
	      l = f(o),
	      v = e.useState([null, null]),
	      d = v[0],
	      m = d[0],
	      g = d[1],
	      y = v[1],
	      E = e.useState(!1),
	      w = E[0],
	      I = E[1],
	      b = e.useCallback(function () {
	    var e,
	        o = (e = p.mark(function e(o, a) {
	      var c;return p.wrap(function (e) {
	        for (;;) {
	          switch (e.prev = e.next) {case 0:
	              c = a || n, e.t0 = o || t, e.next = e.t0 === r.InteractionType.Popup ? 5 : e.t0 === r.InteractionType.Redirect ? 7 : e.t0 === r.InteractionType.Silent ? 9 : 11;break;case 5:
	              return s.verbose("useMsalAuthentication - Calling loginPopup"), e.abrupt("return", i.loginPopup(c));case 7:
	              return s.verbose("useMsalAuthentication - Calling loginRedirect"), e.abrupt("return", i.loginRedirect(c).then(null));case 9:
	              return s.verbose("useMsalAuthentication - Calling ssoSilent"), e.abrupt("return", i.ssoSilent(c));case 11:
	              throw "Invalid interaction type provided.";case 12:case "end":
	              return e.stop();}
	        }
	      }, e);
	    }), function () {
	      var t = this,
	          n = arguments;return new Promise(function (r, o) {
	        var a = e.apply(t, n);function i(t) {
	          h(a, r, o, i, c, "next", t);
	        }function c(t) {
	          h(a, r, o, i, c, "throw", t);
	        }i(void 0);
	      });
	    });return function (t, e) {
	      return o.apply(this, arguments);
	    };
	  }(), [i, t, n, s]);return e.useEffect(function () {
	    var t = i.addEventCallback(function (t) {
	      switch (t.eventType) {case r.EventType.LOGIN_SUCCESS:case r.EventType.SSO_SILENT_SUCCESS:
	          t.payload && y([t.payload, null]);break;case r.EventType.LOGIN_FAILURE:case r.EventType.SSO_SILENT_FAILURE:
	          t.error && y([null, t.error]);}
	    });return s.verbose("useMsalAuthentication - Registered event callback with id: " + t), function () {
	      t && (s.verbose("useMsalAuthentication - Removing event callback " + t), i.removeEventCallback(t));
	    };
	  }, [i, s]), e.useEffect(function () {
	    w || g || l || u !== r.InteractionStatus.None || (s.info("useMsalAuthentication - No user is authenticated, attempting to login"), I(!0), b().catch(function () {}));
	  }, [l, u, g, w, b, s]), { login: b, result: m, error: g };
	}exports.AuthenticatedTemplate = function (t) {
	  var o = t.username,
	      a = t.homeAccountId,
	      u = t.localAccountId,
	      s = t.children,
	      l = c();return f(e.useMemo(function () {
	    return { username: o, homeAccountId: a, localAccountId: u };
	  }, [o, a, u])) && l.inProgress !== r.InteractionStatus.Startup ? n.createElement(n.Fragment, null, i(s, l)) : null;
	}, exports.MsalAuthenticationTemplate = function (t) {
	  var o = t.interactionType,
	      a = t.username,
	      u = t.homeAccountId,
	      s = t.localAccountId,
	      l = t.authenticationRequest,
	      h = t.loadingComponent,
	      v = t.errorComponent,
	      p = t.children,
	      m = e.useMemo(function () {
	    return { username: a, homeAccountId: u, localAccountId: s };
	  }, [a, u, s]),
	      g = c(),
	      y = d(o, l, m),
	      E = f(m);if (y.error && g.inProgress === r.InteractionStatus.None) {
	    if (v) return n.createElement(v, Object.assign({}, y));throw y.error;
	  }return E ? n.createElement(n.Fragment, null, i(p, y)) : h && g.inProgress !== r.InteractionStatus.None ? n.createElement(h, Object.assign({}, g)) : null;
	}, exports.MsalConsumer = a, exports.MsalContext = o, exports.MsalProvider = function (t) {
	  var a = t.instance,
	      i = t.children;e.useEffect(function () {
	    a.initializeWrapperLibrary(r.WrapperSKU.React, "1.0.0-beta.0");
	  }, [a]);var c = e.useMemo(function () {
	    return a.getLogger().clone("@azure/msal-react", "1.0.0-beta.0");
	  }, [a]),
	      u = e.useState([]),
	      s = u[0],
	      l = u[1],
	      f = e.useState(r.InteractionStatus.Startup),
	      h = f[0],
	      v = f[1];return e.useEffect(function () {
	    var t = a.addEventCallback(function (t) {
	      switch (t.eventType) {case r.EventType.LOGIN_SUCCESS:case r.EventType.SSO_SILENT_SUCCESS:case r.EventType.HANDLE_REDIRECT_END:case r.EventType.LOGIN_FAILURE:case r.EventType.SSO_SILENT_FAILURE:case r.EventType.LOGOUT_FAILURE:case r.EventType.ACQUIRE_TOKEN_SUCCESS:case r.EventType.ACQUIRE_TOKEN_FAILURE:
	          var e = a.getAllAccounts();!function (t, e) {
	            if (t.length !== e.length) return !1;var n = [].concat(e);return t.every(function (t) {
	              var e = n.shift();return !(!t || !e) && t.homeAccountId === e.homeAccountId && t.localAccountId === e.localAccountId && t.username === e.username;
	            });
	          }(e, s) ? (c.info("MsalProvider - updating account state"), l(e)) : c.info("MsalProvider - no account changes");}
	    });return c.verbose("MsalProvider - Registered event callback with id: " + t), function () {
	      t && (c.verbose("MsalProvider - Removing event callback " + t), a.removeEventCallback(t));
	    };
	  }, [a, s, c]), e.useEffect(function () {
	    var t = a.addEventCallback(function (t) {
	      var e = r.EventMessageUtils.getInteractionStatusFromEvent(t);null !== e && (c.info("MsalProvider - " + t.eventType + " results in setting inProgress to " + e), v(e));
	    });return c.verbose("MsalProvider - Registered event callback with id: " + t), a.handleRedirectPromise().catch(function () {}), function () {
	      t && (c.verbose("MsalProvider - Removing event callback " + t), a.removeEventCallback(t));
	    };
	  }, [a, c]), n.createElement(o.Provider, { value: { instance: a, inProgress: h, accounts: s, logger: c } }, i);
	}, exports.UnauthenticatedTemplate = function (t) {
	  var o = t.username,
	      a = t.homeAccountId,
	      u = t.localAccountId,
	      s = t.children,
	      l = c();return f(e.useMemo(function () {
	    return { username: o, homeAccountId: a, localAccountId: u };
	  }, [o, a, u])) || l.inProgress === r.InteractionStatus.Startup ? null : n.createElement(n.Fragment, null, i(s, l));
	}, exports.useAccount = s, exports.useIsAuthenticated = f, exports.useMsal = c, exports.useMsalAuthentication = d, exports.withMsal = function (t) {
	  var e = function e(_e) {
	    var r = c();return n.createElement(t, Object.assign({}, _e, { msalContext: r }));
	  };return e.displayName = "withMsal(" + (t.displayName || t.name || "Component") + ")", e;
	};
	//# sourceMappingURL=msal-react.cjs.production.min.js.map
	
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(t, "t", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(n, "n", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(o, "o", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(a, "a", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(i, "i", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(c, "c", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(u, "u", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(s, "s", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(l, "l", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(f, "f", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(h, "h", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(v, "v", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(p, "p", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	
	  __REACT_HOT_LOADER__.register(d, "d", "D:/a/1/s/src/web/employee/node_modules/@azure/msal-react/dist/msal-react.cjs.production.min.js");
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createApprovalRequest = exports.approvalRequestFailure = exports.approvalRequestSuccess = exports.approvalRequestCreate = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reapop = __webpack_require__(44);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ActionTypes = __webpack_require__(18);
	
	var _Api = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var approvalRequestCreate = exports.approvalRequestCreate = function approvalRequestCreate() {
	  return {
	    type: _ActionTypes.APPROVAL_REQUEST_CREATE
	  };
	};
	
	var approvalRequestSuccess = exports.approvalRequestSuccess = function approvalRequestSuccess() {
	  return {
	    type: _ActionTypes.APPROVAL_REQUEST_SUCCESS
	  };
	};
	
	var approvalRequestFailure = exports.approvalRequestFailure = function approvalRequestFailure() {
	  return {
	    type: _ActionTypes.APPROVAL_REQUEST_FAILURE
	  };
	};
	
	var createApprovalRequest = exports.createApprovalRequest = function createApprovalRequest(data, cb) {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var payload, _getState, DefaultEmployeeDetailID, ConnectedID, requestConfig, errorData, errorMessageJsonString, missingEmailError, parsedError;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              payload = data;
	              _context.prev = 1;
	
	              dispatch(approvalRequestCreate());
	              _getState = getState(), DefaultEmployeeDetailID = _getState.loginReducer.user.DefaultEmployeeDetailID;
	              ConnectedID = payload.ConnectedID;
	
	              delete payload.ConnectedID;
	              requestConfig = {
	                url: '/kjarni/api/v2/EmployeeDetailApprovalRequests',
	                method: 'POST',
	                data: _extends({}, payload, ConnectedID && { ConnectedID: ConnectedID }, {
	                  EmployeeDetailID: DefaultEmployeeDetailID,
	                  ExpirationDate: (0, _moment2.default)((0, _lodash.get)(payload, 'PeriodBegda', new Date())).toISOString(),
	                  PeriodBegda: (0, _moment2.default)((0, _lodash.get)(payload, 'PeriodBegda', new Date())).toISOString(),
	                  PeriodEndda: (0, _moment2.default)((0, _lodash.get)(payload, 'PeriodEndda', new Date())).toISOString()
	                })
	              };
	              _context.next = 9;
	              return (0, _Api.custom)(requestConfig);
	
	            case 9:
	              dispatch(approvalRequestSuccess());
	              // Notificaiton on success
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.create.success' }),
	                status: 'success',
	                dismissible: true,
	                dismissAfter: 5000
	              }));
	              cb();
	              _context.next = 22;
	              break;
	
	            case 14:
	              _context.prev = 14;
	              _context.t0 = _context['catch'](1);
	
	              // Notification on error
	              errorData = (0, _lodash.get)(_context.t0, 'response.data');
	              errorMessageJsonString = (0, _lodash.get)(errorData, 'error.message');
	              missingEmailError = false;
	
	              try {
	                parsedError = JSON.parse(errorMessageJsonString);
	
	                if ((0, _lodash.get)(parsedError, 'Errors[0].UserMessage') === 'Error_EmailWorkMissing') {
	                  missingEmailError = true;
	                }
	              } catch (parseError) {
	                console.log('Error parsing error message json string', parseError);
	              }
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.create.error' }),
	                message: missingEmailError ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.create.error.missingEmail' }) : (0, _lodash.get)(_context.t0, 'message'),
	                status: 'error',
	                dismissible: true,
	                dismissAfter: 12000
	              }));
	              dispatch(approvalRequestFailure());
	
	            case 22:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[1, 14]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(approvalRequestCreate, 'approvalRequestCreate', 'D:/a/1/s/src/web/employee/src/actions/ApprovalRequests.js');
	
	  __REACT_HOT_LOADER__.register(approvalRequestSuccess, 'approvalRequestSuccess', 'D:/a/1/s/src/web/employee/src/actions/ApprovalRequests.js');
	
	  __REACT_HOT_LOADER__.register(approvalRequestFailure, 'approvalRequestFailure', 'D:/a/1/s/src/web/employee/src/actions/ApprovalRequests.js');
	
	  __REACT_HOT_LOADER__.register(createApprovalRequest, 'createApprovalRequest', 'D:/a/1/s/src/web/employee/src/actions/ApprovalRequests.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchBirthdays = exports.requestBirthdaysFailure = exports.requestBirthdaysSuccess = exports.requestBirthdays = undefined;
	
	var _ActionTypes = __webpack_require__(18);
	
	var _Api = __webpack_require__(21);
	
	var requestBirthdays = exports.requestBirthdays = function requestBirthdays() {
	  return {
	    type: _ActionTypes.REQUEST_BIRTHDAYS
	  };
	};
	
	var requestBirthdaysSuccess = exports.requestBirthdaysSuccess = function requestBirthdaysSuccess(birthdays) {
	  return {
	    type: _ActionTypes.REQUEST_BIRTHDAYS_SUCCESS,
	    birthdays: birthdays
	  };
	};
	
	var requestBirthdaysFailure = exports.requestBirthdaysFailure = function requestBirthdaysFailure(error) {
	  return {
	    type: _ActionTypes.REQUEST_BIRTHDAYS_FAILURE,
	    error: error
	  };
	};
	
	var fetchBirthdays = exports.fetchBirthdays = function fetchBirthdays() {
	  return function (dispatch, getState) {
	    dispatch(requestBirthdays());
	
	    var _getState = getState(),
	        token = _getState.loginReducer.token;
	
	    var config = {
	      url: 'api/HrData/EmployeeBirthday',
	      headers: { Authorization: 'Bearer ' + token },
	      method: 'GET'
	    };
	
	    (0, _Api.custom)(config).then(function (res) {
	      return dispatch(requestBirthdaysSuccess(res.data));
	    }).catch(function (err) {
	      return dispatch(requestBirthdaysSuccess(err));
	    });
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestBirthdays, 'requestBirthdays', 'D:/a/1/s/src/web/employee/src/actions/Birthdays.js');
	
	  __REACT_HOT_LOADER__.register(requestBirthdaysSuccess, 'requestBirthdaysSuccess', 'D:/a/1/s/src/web/employee/src/actions/Birthdays.js');
	
	  __REACT_HOT_LOADER__.register(requestBirthdaysFailure, 'requestBirthdaysFailure', 'D:/a/1/s/src/web/employee/src/actions/Birthdays.js');
	
	  __REACT_HOT_LOADER__.register(fetchBirthdays, 'fetchBirthdays', 'D:/a/1/s/src/web/employee/src/actions/Birthdays.js');
	}();

	;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.submitQuestionnaire = exports.requestSubmitQuestionnaireFailure = exports.requestSubmitQuestionnaireSuccess = exports.requestSubmitQuestionnaire = exports.fetchQuestionnaire = exports.requestQuestionnaireFailure = exports.requestQuestionnaireSuccess = exports.requestQuestionnaire = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['-'], ['-']);
	
	exports.sortChildren = sortChildren;
	exports.fetchOptions = fetchOptions;
	
	var _orderBy = __webpack_require__(372);
	
	var _orderBy2 = _interopRequireDefault(_orderBy);
	
	var _flattenDeep = __webpack_require__(569);
	
	var _flattenDeep2 = _interopRequireDefault(_flattenDeep);
	
	var _compact = __webpack_require__(567);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	var _find2 = __webpack_require__(263);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _keys = __webpack_require__(99);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _startsWith = __webpack_require__(1510);
	
	var _startsWith2 = _interopRequireDefault(_startsWith);
	
	var _Api = __webpack_require__(21);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var requestQuestionnaire = exports.requestQuestionnaire = function requestQuestionnaire(RootQAElementID) {
	  return {
	    type: types.COURSE_QUEST_REQUEST,
	    RootQAElementID: RootQAElementID
	  };
	};
	
	var requestQuestionnaireSuccess = exports.requestQuestionnaireSuccess = function requestQuestionnaireSuccess(_ref) {
	  var questionnaire = _ref.questionnaire;
	  return {
	    type: types.COURSE_QUEST_SUCCESS,
	    questionnaire: questionnaire
	  };
	};
	
	var requestQuestionnaireFailure = exports.requestQuestionnaireFailure = function requestQuestionnaireFailure(questionnaireError) {
	  return {
	    type: types.COURSE_QUEST_FAILURE,
	    questionnaireError: questionnaireError
	  };
	};
	
	function sortChildren(obj) {
	  if (obj.Children) {
	    return _extends({}, obj.Entity, obj, { Children: (0, _orderBy2.default)(obj.Children.map(sortChildren), ['Order'], ['asc']) });
	  }
	  return _extends({}, obj.Entity, obj);
	}
	
	var flattenChildren = function flattenChildren(obj) {
	  if (obj.Children) {
	    return [obj].concat(_toConsumableArray((0, _flattenDeep2.default)(obj.Children.map(flattenChildren))));
	  }
	  return obj;
	};
	
	function fetchOptions(qae, token) {
	  var QAInputID = qae.QAInputID;
	
	  var config = {
	    entity: 'QAInput',
	    entityID: QAInputID,
	    headers: { Authorization: 'Bearer ' + token }
	  };
	
	  return (0, _Api.read)(config).then(function (_ref2) {
	    var data = _ref2.data;
	    return _extends({}, qae, { QAInput: data });
	  });
	}
	
	/**
	 * Takes in the id of the root element and collects
	 * the needed data to construct tehe questionnaire.
	 *
	 * @param {number} RootQAElementID
	 * The root QAElement to build the questionnaire from
	 */
	var fetchQuestionnaire = exports.fetchQuestionnaire = function fetchQuestionnaire(RootQAElementID, onSuccess) {
	  return function (dispatch, getState) {
	    dispatch(requestQuestionnaire(RootQAElementID));
	
	    var _getState = getState(),
	        token = _getState.loginReducer.user.token;
	
	    if (!RootQAElementID) {
	      return dispatch(requestQuestionnaireFailure(new Error('Engar viðbótaspurningar eru skráð á þetta námskeið.')));
	    }
	    var configElement = {
	      entity: 'QAElement',
	      entityID: RootQAElementID,
	      headers: { Authorization: 'Bearer ' + token }
	    };
	    return (0, _Api.readWM)(configElement).then(function (QAElement) {
	      if (!QAElement.data) {
	        return dispatch(requestQuestionnaireFailure(new Error('Námskeiðsmatið er ekki með neinar spurningar.')));
	      }
	      if (!QAElement.data.Children || !QAElement.data.Children.length) {
	        return dispatch(onSuccess());
	      }
	      var initQAElements = flattenChildren(sortChildren(QAElement.data));
	      var QAElements = initQAElements.map(function (e) {
	        if (e.QAInput) {
	          return _extends({}, e, e.Entity, { QAInput: _extends({}, e.QAInput.Entity, e.QAInput) });
	        }
	        return _extends({}, e, e.Entity);
	      });
	      return dispatch(requestQuestionnaireSuccess({
	        questionnaire: {
	          RootQAElementID: RootQAElementID,
	          QAElement: sortChildren(QAElement.data),
	          QAElements: QAElements
	        }
	      }));
	    }).catch(function (error) {
	      return dispatch(requestQuestionnaireFailure(error));
	    });
	  };
	};
	
	var requestSubmitQuestionnaire = exports.requestSubmitQuestionnaire = function requestSubmitQuestionnaire() {
	  return {
	    type: types.COURSE_QUEST_SUBMIT_REQUEST
	  };
	};
	var requestSubmitQuestionnaireSuccess = exports.requestSubmitQuestionnaireSuccess = function requestSubmitQuestionnaireSuccess() {
	  return {
	    type: types.COURSE_QUEST_SUBMIT_SUCCESS
	  };
	};
	var requestSubmitQuestionnaireFailure = exports.requestSubmitQuestionnaireFailure = function requestSubmitQuestionnaireFailure(questionnaireError) {
	  return {
	    type: types.COURSE_QUEST_SUBMIT_FAILURE,
	    questionnaireError: questionnaireError
	  };
	};
	
	var convertFormData = function convertFormData(formData, answerRoot, questionnaire, CourseQuestionnaireAnswers) {
	  /* NOTE:
	      CHECKBOX
	        * get QAAnswerValue from redux form value
	        * get QAAnswerText from redux form name last group
	      NOTE: ATTACHMENT questions put on hold!
	      ATTACHMENT
	        * on load of file send to repo
	        * QAAnswerText is the file name
	        * QAAnswerValue is the GUID of the file returned from repo
	      TEXT_FIELDS
	        * QAAnswerValue and QAAnswerText are set to the rf value
	      DATE
	        * set QAAnswerText to human version
	        * set QAAnswerValue to datetime stamp
	      RADIO AND SCALE
	        * set QAAnswerText to the option label
	        * set QAAnswerValue to QAInputOptionID or HrQualificationScaleEntryID
	  */
	
	  var QAElements = questionnaire.QAElements;
	
	  var RootAnswerID = answerRoot;
	
	  /* Map through all the fields submited through the Redux form */
	  var ansrs = (0, _map2.default)((0, _keys2.default)(formData), function (key) {
	    if ((0, _startsWith2.default)(key, 'COMMENT')) {
	      return null;
	    }
	    var QAAnswerValue = formData[key];
	    /* Split the key into its components
	    example: '345-34045'
	    becomes ['345', '34045'] */
	    var qaKeys = key.split(_templateObject);
	
	    /* We use the Redux field names to identify information about the elements */
	    var QAInputAnswerType = Number(qaKeys[0]);
	    var QAElementID = Number(qaKeys[1]);
	    var QAInputOptionLabel = qaKeys[2];
	
	    /* QAElement information */
	
	    var _find = (0, _find3.default)(QAElements, ['QAElementID', QAElementID]),
	        QAInput = _find.QAInput,
	        Order = _find.Order,
	        Level = _find.Level,
	        QAElementParentID = _find.QAElementParentID,
	        AllowComment = _find.AllowComment;
	
	    var option = QAInputAnswerType === 6 ? (0, _find3.default)(QAInput.HrQualificationScaleEntries, ['HrQualificationScaleEntryID', QAAnswerValue]) : (0, _find3.default)(QAInput.QAInputOptions, ['QAInputOptionID', QAAnswerValue]);
	
	    var checkBoxText = atob(QAInputOptionLabel || '');
	    var optionText = option ? option.HrQualificationScaleEntryName || option.QAInputOptionLabel : '';
	    var QAAnswerText = checkBoxText || optionText || QAAnswerValue;
	    var QAAnswerComment = null;
	
	    if (AllowComment) {
	      QAAnswerComment = formData['COMMENT-' + QAInputAnswerType + '-' + QAElementID];
	    }
	
	    /* If the Element is higher than 2 the Element is inside a group, then
	    we have to set the correct QAAnswerParentID. */
	    var QAAnswerParent = Level <= 2 ? RootAnswerID : (0, _find3.default)(CourseQuestionnaireAnswers, ['QAElementID', QAElementParentID]);
	    var QAAnswerParentID = QAAnswerParent.QAAnswerID;
	
	    var def = {
	      QAAnswerParentID: QAAnswerParentID,
	      QAElementID: QAElementID,
	      QAAnswerValue: QAAnswerValue,
	      QAAnswerText: QAAnswerText,
	      QAAnswerComment: QAAnswerComment,
	      QAAnswerOrder: Order,
	      RootAnswerID: RootAnswerID
	    };
	
	    return def;
	  });
	
	  return (0, _compact2.default)(ansrs);
	};
	
	var submitQuestionnaire = exports.submitQuestionnaire = function submitQuestionnaire(formData, onSuccess) {
	  return function (dispatch, getState) {
	    var _getState2 = getState(),
	        token = _getState2.loginReducer.user.token,
	        questionnaire = _getState2.CourseQuestionnaireReducer.questionnaire;
	
	    dispatch(requestSubmitQuestionnaire(questionnaire.RootQAElementID));
	    var createRoot = {
	      entity: 'QAAnswer',
	      headers: { Authorization: 'Bearer ' + token },
	      data: { QAElementID: questionnaire.RootQAElementID }
	    };
	    (0, _Api.create)(createRoot).then(function (_ref3) {
	      var data = _ref3.data;
	
	      var answerRoot = data.QAAnswerID;
	      var groups = questionnaire.QAElements.filter(function (e) {
	        return e.QAElementType === 2;
	      });
	
	      var answerGroups = groups.map(function (_ref4) {
	        var QAElementID = _ref4.QAElementID,
	            Label = _ref4.Label,
	            Order = _ref4.Order;
	        return (0, _Api.create)({
	          entity: 'QAAnswer',
	          headers: { Authorization: 'Bearer ' + token },
	          data: {
	            QAAnswerParentID: data.QAAnswerID,
	            RootAnswerID: data.QAAnswerID,
	            QAElementID: QAElementID,
	            QAAnswerValue: Label,
	            QAAnswerText: Label,
	            QAAnswerOrder: Order
	          }
	        });
	      });
	      Promise.all(answerGroups).then(function (CEAnswers) {
	        var CourseQuestionnaireAnswers = CEAnswers.map(function (x) {
	          return _extends({}, x.data);
	        });
	        var QAAnswers = convertFormData(formData, answerRoot, questionnaire, CourseQuestionnaireAnswers);
	        return Promise.all(QAAnswers.map(function (ansData) {
	          return (0, _Api.create)({ entity: 'QAAnswer', data: ansData, headers: { Authorization: 'Bearer ' + token } });
	        })).then(function () {
	          onSuccess(answerRoot);
	          dispatch(requestSubmitQuestionnaireSuccess());
	        }).catch(function (error) {
	          return dispatch(requestSubmitQuestionnaireFailure(error));
	        });
	      }).catch(function (error) {
	        return dispatch(requestSubmitQuestionnaireFailure(error));
	      });
	    }).catch(function (error) {
	      return dispatch(requestSubmitQuestionnaireFailure(error));
	    });
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestQuestionnaire, 'requestQuestionnaire', 'D:/a/1/s/src/web/employee/src/actions/CourseQuestionnaire.js');
	
	  __REACT_HOT_LOADER__.register(requestQuestionnaireSuccess, 'requestQuestionnaireSuccess', 'D:/a/1/s/src/web/employee/src/actions/CourseQuestionnaire.js');
	
	  __REACT_HOT_LOADER__.register(requestQuestionnaireFailure, 'requestQuestionnaireFailure', 'D:/a/1/s/src/web/employee/src/actions/CourseQuestionnaire.js');
	
	  __REACT_HOT_LOADER__.register(sortChildren, 'sortChildren', 'D:/a/1/s/src/web/employee/src/actions/CourseQuestionnaire.js');
	
	  __REACT_HOT_LOADER__.register(flattenChildren, 'flattenChildren', 'D:/a/1/s/src/web/employee/src/actions/CourseQuestionnaire.js');
	
	  __REACT_HOT_LOADER__.register(fetchOptions, 'fetchOptions', 'D:/a/1/s/src/web/employee/src/actions/CourseQuestionnaire.js');
	
	  __REACT_HOT_LOADER__.register(fetchQuestionnaire, 'fetchQuestionnaire', 'D:/a/1/s/src/web/employee/src/actions/CourseQuestionnaire.js');
	
	  __REACT_HOT_LOADER__.register(requestSubmitQuestionnaire, 'requestSubmitQuestionnaire', 'D:/a/1/s/src/web/employee/src/actions/CourseQuestionnaire.js');
	
	  __REACT_HOT_LOADER__.register(requestSubmitQuestionnaireSuccess, 'requestSubmitQuestionnaireSuccess', 'D:/a/1/s/src/web/employee/src/actions/CourseQuestionnaire.js');
	
	  __REACT_HOT_LOADER__.register(requestSubmitQuestionnaireFailure, 'requestSubmitQuestionnaireFailure', 'D:/a/1/s/src/web/employee/src/actions/CourseQuestionnaire.js');
	
	  __REACT_HOT_LOADER__.register(convertFormData, 'convertFormData', 'D:/a/1/s/src/web/employee/src/actions/CourseQuestionnaire.js');
	
	  __REACT_HOT_LOADER__.register(submitQuestionnaire, 'submitQuestionnaire', 'D:/a/1/s/src/web/employee/src/actions/CourseQuestionnaire.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchBonuses = exports.requestBonusesFailure = exports.requestBonusesSuccess = exports.requestBonuses = undefined;
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Api = __webpack_require__(21);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var requestBonuses = exports.requestBonuses = function requestBonuses() {
	  return {
	    type: types.REQUEST_BONUSES
	  };
	};
	
	var requestBonusesSuccess = exports.requestBonusesSuccess = function requestBonusesSuccess(bonuses) {
	  return {
	    type: types.REQUEST_BONUSES_SUCCESS,
	    bonuses: bonuses
	  };
	};
	
	var requestBonusesFailure = exports.requestBonusesFailure = function requestBonusesFailure(error) {
	  return {
	    type: types.REQUEST_BONUSES_FAILURE,
	    error: error
	  };
	};
	
	var fetchBonuses = exports.fetchBonuses = function fetchBonuses(employeeDetailId) {
	  return function (dispatch, getState) {
	    dispatch(requestBonuses());
	
	    var _getState = getState(),
	        token = _getState.loginReducer.user.token;
	
	    var config = {
	      headers: { Authorization: 'Bearer ' + token },
	      method: 'GET',
	      url: '/kjarni/api/v2/EmployeeDetailBasicPays',
	      params: {
	        $filter: 'EmployeeDetailID eq ' + employeeDetailId
	      }
	    };
	
	    return (0, _Api.custom)(config).then(function (_ref) {
	      var data = _ref.data;
	
	      dispatch(requestBonusesSuccess(data.value));
	    }).catch(function (err) {
	      return dispatch(requestBonusesFailure(err));
	    });
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestBonuses, 'requestBonuses', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBonuses.js');
	
	  __REACT_HOT_LOADER__.register(requestBonusesSuccess, 'requestBonusesSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBonuses.js');
	
	  __REACT_HOT_LOADER__.register(requestBonusesFailure, 'requestBonusesFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBonuses.js');
	
	  __REACT_HOT_LOADER__.register(fetchBonuses, 'fetchBonuses', 'D:/a/1/s/src/web/employee/src/actions/EmployeeBonuses.js');
	}();

	;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	exports.setActive = setActive;
	exports.fetchData = fetchData;
	
	var _forEach = __webpack_require__(1497);
	
	var _forEach2 = _interopRequireDefault(_forEach);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Api = __webpack_require__(21);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function requestOrgChartData() {
	  return {
	    type: types.ORGCHART_REQUEST_DATA
	  };
	}
	
	function requestOrgChartDataSuccess(data) {
	  return {
	    type: types.ORGCHART_REQUEST_DATA_SUCCESS,
	    data: data
	  };
	}
	
	function requestOrgChartDataFailure(error) {
	  return {
	    type: types.ORGCHART_REQUEST_DATA_FAILURE,
	    error: error
	  };
	}
	
	function setActive(id) {
	  return {
	    type: types.ORGCHART_SET_ACTIVE_NODE,
	    nodeId: id
	  };
	}
	
	/*
	 * formatting for basicprimitives itemconfig (https://www.basicprimitives.com/index.php?option=com_local&view=local&Itemid=43&lang=en#primitives.orgdiagram.ItemConfig)
	 */
	
	var formatEmployee = function formatEmployee(employee, ind) {
	  var newEmp = {
	    id: ind,
	    parent: 'companyUnit' + employee.DepartmentID,
	    OrgCompanyUnitID: employee.DepartmentID,
	    templateName: 'employeeTemplate',
	    description: employee.Title,
	    title: employee.Name,
	    phone: employee.Phone,
	    email: employee.Email,
	    itemTitleColor: '#859DEE',
	    hasSelectorCheckbox: false,
	    hasButtons: false
	  };
	  return newEmp;
	};
	
	/*
	 * Fetch only needed info for the OrgChart and add the className department
	 * the className prop is used for css by the orgChart library
	 */
	var formatCompanyUnit = function formatCompanyUnit(unit) {
	  var retUnit = {
	    title: unit.OrgCompanyUnitName,
	    id: 'companyUnit' + unit.OrgCompanyUnitID,
	    label: unit.OrgCompanyUnitName,
	    showLabel: true,
	    OrgCompanyUnitID: unit.OrgCompanyUnitID,
	    OrgCompanyID: unit.OrgCompanyID,
	    OrgCompanyUnitParentID: unit.OrgCompanyUnitParentID,
	    itemTitleColor: '#63a4ff',
	    templateName: 'companyUnitTemplate',
	    setChildrenMatrix: true
	  };
	  if (unit.OrgCompanyUnitParentID === 0) {
	    retUnit.parent = 'company' + unit.OrgCompanyID;
	  } else {
	    retUnit.parent = 'companyUnit' + unit.OrgCompanyUnitParentID;
	  }
	  return retUnit;
	};
	
	/*
	 * Fetch only needed info for the OrgChart and add the className company
	 * the className prop is used for css by the orgChart library
	 */
	var formatCompany = function formatCompany(company) {
	  return {
	    title: company.OrgCompanyName,
	    showLabel: true,
	    label: company.OrgCompanyName,
	    OrgCompanyID: company.OrgCompanyID,
	    id: 'company' + company.OrgCompanyID,
	    parent: null,
	    templateName: 'companyTemplate',
	    itemTitleColor: '#004ba0'
	  };
	};
	
	function fetchEmployees() {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        token = _getState.loginReducer.user.token;
	
	    var config = {
	      url: 'api/HrData/EmployeesSearch',
	      headers: { Authorization: 'Bearer ' + token }
	    };
	
	    return (0, _Api.custom)(config).then(function (_ref) {
	      var data = _ref.data;
	      return data.map(formatEmployee);
	    }).catch(function (err) {
	      throw err;
	    });
	  };
	}
	
	/*
	 * Checks all companyUnits, if a companyunit has a child that is also a companyunit then the children will be
	 * formatted horizontally instead of in a matrix, companyUnits with only employees as children will have it's
	 * children layout in a matrix
	 * this property is called childrenPlacementType and is set in EmployeeOrgChart container in the render function.
	 */
	
	var formatCompanyUnitChildren = function formatCompanyUnitChildren(companyUnits) {
	  var newUnits = companyUnits;
	  (0, _forEach2.default)(companyUnits, function (unit) {
	    if (unit.OrgCompanyUnitParentID !== 0) {
	      newUnits = newUnits.map(function (newUnit) {
	        var retUnit = newUnit;
	        if (newUnit.OrgCompanyUnitID === unit.OrgCompanyUnitParentID) {
	          retUnit.setChildrenMatrix = false;
	        }
	        return retUnit;
	      });
	    }
	  });
	  return newUnits;
	};
	
	function fetchCompanyUnit() {
	  return function (dispatch, getState) {
	    var _getState2 = getState(),
	        token = _getState2.loginReducer.user.token;
	
	    var config = { entity: 'OrgCompanyUnit', headers: { Authorization: 'Bearer ' + token } };
	    return (0, _Api.list)(config).then(function (_ref2) {
	      var data = _ref2.data;
	      return data.filter(function (unit) {
	        return !unit.Disabled;
	      }).map(formatCompanyUnit);
	    }).then(function (res) {
	      return formatCompanyUnitChildren(res);
	    }).catch(function (err) {
	      throw err;
	    });
	  };
	}
	
	function fetchCompany() {
	  return function (dispatch, getState) {
	    var _getState3 = getState(),
	        token = _getState3.loginReducer.user.token;
	
	    var config = { entity: 'OrgCompany', headers: { Authorization: 'Bearer ' + token } };
	    return (0, _Api.list)(config).then(function (_ref3) {
	      var data = _ref3.data;
	      return data.map(formatCompany);
	    }).catch(function (err) {
	      throw err;
	    });
	  };
	}
	
	function fetchData() {
	  return function (dispatch) {
	    dispatch(requestOrgChartData());
	    Promise.all([dispatch(fetchCompany()), dispatch(fetchCompanyUnit()), dispatch(fetchEmployees())]).then(function (_ref4) {
	      var _ref5 = _slicedToArray(_ref4, 3),
	          companies = _ref5[0],
	          units = _ref5[1],
	          employees = _ref5[2];
	
	      dispatch(requestOrgChartDataSuccess([].concat(_toConsumableArray(companies), _toConsumableArray(employees), _toConsumableArray(units))));
	    }, function (err) {
	      return dispatch(requestOrgChartDataFailure(err));
	    });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestOrgChartData, 'requestOrgChartData', 'D:/a/1/s/src/web/employee/src/actions/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(requestOrgChartDataSuccess, 'requestOrgChartDataSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(requestOrgChartDataFailure, 'requestOrgChartDataFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(setActive, 'setActive', 'D:/a/1/s/src/web/employee/src/actions/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(formatEmployee, 'formatEmployee', 'D:/a/1/s/src/web/employee/src/actions/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(formatCompanyUnit, 'formatCompanyUnit', 'D:/a/1/s/src/web/employee/src/actions/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(formatCompany, 'formatCompany', 'D:/a/1/s/src/web/employee/src/actions/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(fetchEmployees, 'fetchEmployees', 'D:/a/1/s/src/web/employee/src/actions/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(formatCompanyUnitChildren, 'formatCompanyUnitChildren', 'D:/a/1/s/src/web/employee/src/actions/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(fetchCompanyUnit, 'fetchCompanyUnit', 'D:/a/1/s/src/web/employee/src/actions/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(fetchCompany, 'fetchCompany', 'D:/a/1/s/src/web/employee/src/actions/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(fetchData, 'fetchData', 'D:/a/1/s/src/web/employee/src/actions/EmployeeOrgChart.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _templateObject = _taggedTemplateLiteral([','], [',']),
	    _templateObject2 = _taggedTemplateLiteral([' or '], [' or ']);
	
	exports.requestSearch = requestSearch;
	exports.requestSearchSuccess = requestSearchSuccess;
	exports.requestSearchSuccessAll = requestSearchSuccessAll;
	exports.requestSearchFailure = requestSearchFailure;
	exports.requestSearchClear = requestSearchClear;
	exports.fetch = fetch;
	exports.fetchByQualification = fetchByQualification;
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _Api = __webpack_require__(21);
	
	var _trim = __webpack_require__(1515);
	
	var _trim2 = _interopRequireDefault(_trim);
	
	var _isEqual = __webpack_require__(573);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	var _isEmpty = __webpack_require__(98);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _unionWith = __webpack_require__(1516);
	
	var _unionWith2 = _interopRequireDefault(_unionWith);
	
	var _groupBy = __webpack_require__(1498);
	
	var _groupBy2 = _interopRequireDefault(_groupBy);
	
	var _filter = __webpack_require__(262);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _get = __webpack_require__(96);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _compact = __webpack_require__(567);
	
	var _compact2 = _interopRequireDefault(_compact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); } // import _ from 'lodash';
	
	
	function requestSearch(query) {
	  return {
	    type: types.SEARCH_REQUEST,
	    query: query
	  };
	}
	
	function requestSearchSuccess(resultData) {
	  return {
	    type: types.SEARCH_REQUEST_SUCCESS,
	    resultData: resultData
	  };
	}
	
	function requestSearchSuccessAll(resultData) {
	  return {
	    type: types.SEARCH_REQUEST_SUCCESS_ALL,
	    resultData: resultData
	  };
	}
	
	function requestSearchFailure(error) {
	  return {
	    type: types.SEARCH_REQUEST_FAILURE,
	    error: error
	  };
	}
	
	function requestSearchClear() {
	  return {
	    type: types.SEARCH_REQUEST_CLEAR
	  };
	}
	
	function fetch(search) {
	  return function (dispatch, getState) {
	    var searchstring = search.replace(/:\s*/, ':');
	    dispatch(requestSearch(searchstring));
	
	    var _getState = getState(),
	        query = _getState.EmployeeSearch.query,
	        token = _getState.loginReducer.user.token;
	
	    var config = {
	      url: 'api/HrData/EmployeesSearch',
	      headers: { Authorization: 'Bearer ' + token },
	      method: 'GET',
	      params: {
	        searchstring: searchstring
	      }
	    };
	
	    return (0, _Api.custom)(config).then(function (res) {
	      return query === searchstring && dispatch(requestSearchSuccessAll(res.data));
	    }).catch(function (err) {
	      return dispatch(requestSearchFailure(err));
	    });
	  };
	}
	
	function fetchByQualification(searchstring, qualificationTypes) {
	  return function (dispatch, getState) {
	    dispatch(requestSearch(searchstring));
	    if (!searchstring) {
	      return dispatch(requestSearchSuccess([]));
	    }
	
	    var _getState2 = getState(),
	        token = _getState2.loginReducer.user.token;
	
	    var qualifications = searchstring.split(',').filter(function (x) {
	      return !(0, _isEmpty2.default)(x);
	    });
	    var qualificationTypesList = qualificationTypes ? qualificationTypes.split(_templateObject).filter(function (x) {
	      return !(0, _isEmpty2.default)(x);
	    }) : [];
	    var config = {
	      entity: 'EmployeeMasterQualification',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: qualifications.map(function (q) {
	          return 'indexof(tolower(QualificationName), tolower(\'' + (0, _trim2.default)(q) + '\')) ge 0';
	        }).join(_templateObject2) + ' ' + (qualificationTypes.length === 0 ? '' : 'and (' + qualificationTypesList.map(function (q) {
	          return 'Entity/QualificationType eq ' + q;
	        }).join(_templateObject2) + ')'),
	        $expand: 'Entity',
	        $select: 'Entity/EmployeeMasterID,QualificationName'
	      }
	    };
	    return (0, _Api.listWM)(config).then(function (_ref) {
	      var data = _ref.data;
	
	      /* Fetch all the qualifications that matched the search and filter out
	          the EmployeeMasterIDs of the employess that have all the
	          qualifications searched for.
	          */
	      var employees = (0, _map2.default)((0, _filter2.default)((0, _groupBy2.default)((0, _unionWith2.default)(data, _isEqual2.default), 'EmployeeMasterID'), function (x) {
	        return x.length >= qualifications.length;
	      }), function (x) {
	        return (0, _get2.default)(x, '[0].EmployeeMasterID');
	      });
	      // If we had no employess that cover all qualifications we return nothing.
	      if (employees.length === 0) {
	        dispatch(requestSearchSuccessAll([]));
	      } else {
	        var all = (0, _map2.default)(employees, function (emID) {
	          return (0, _Api.custom)({
	            url: 'api/HrData/EmployeesSearch',
	            headers: { Authorization: 'Bearer ' + token },
	            method: 'GET',
	            params: {
	              searchstring: 'ID:' + emID
	            }
	          });
	        });
	        Promise.all(all)
	        /*
	        We fetch all the users that matched the required qualifications.
	        */
	        .then(function (res) {
	          return dispatch(requestSearchSuccess((0, _compact2.default)((0, _map2.default)(res, function (r) {
	            if (r.data && r.data.length) {
	              return r.data[0];
	            }
	            return undefined;
	          }))));
	        }).catch(function (error) {
	          return dispatch(requestSearchFailure(error));
	        });
	      }
	    }).catch(function (error) {
	      return dispatch(requestSearchFailure(error));
	    });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestSearch, 'requestSearch', 'D:/a/1/s/src/web/employee/src/actions/EmployeeSearch.js');
	
	  __REACT_HOT_LOADER__.register(requestSearchSuccess, 'requestSearchSuccess', 'D:/a/1/s/src/web/employee/src/actions/EmployeeSearch.js');
	
	  __REACT_HOT_LOADER__.register(requestSearchSuccessAll, 'requestSearchSuccessAll', 'D:/a/1/s/src/web/employee/src/actions/EmployeeSearch.js');
	
	  __REACT_HOT_LOADER__.register(requestSearchFailure, 'requestSearchFailure', 'D:/a/1/s/src/web/employee/src/actions/EmployeeSearch.js');
	
	  __REACT_HOT_LOADER__.register(requestSearchClear, 'requestSearchClear', 'D:/a/1/s/src/web/employee/src/actions/EmployeeSearch.js');
	
	  __REACT_HOT_LOADER__.register(fetch, 'fetch', 'D:/a/1/s/src/web/employee/src/actions/EmployeeSearch.js');
	
	  __REACT_HOT_LOADER__.register(fetchByQualification, 'fetchByQualification', 'D:/a/1/s/src/web/employee/src/actions/EmployeeSearch.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usePerDiemState = exports.calculate = exports.calculateReset = exports.calculateFailure = exports.calculateSuccess = exports.calculateRequest = exports.createPerDiemApprovalRequest = exports.perDiemApprovalFailure = exports.perDiemApprovalSuccess = exports.perDiemApproval = exports.initApproval = exports.initApprovalFailure = exports.initApprovalSuccess = exports.initApprovalRequest = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ActionTypes = __webpack_require__(18);
	
	var TYPES = _interopRequireWildcard(_ActionTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reapop = __webpack_require__(44);
	
	var _Api = __webpack_require__(21);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var API2 = '/kjarni/api/v2';
	var getData = function getData(entity) {
	  return (0, _Api.custom)({ url: API2 + '/' + entity, method: 'GET' });
	};
	var postData = function postData(entity, data) {
	  return (0, _Api.custom)({ url: API2 + '/' + entity, method: 'POST', data: data });
	};
	
	var initApprovalRequest = exports.initApprovalRequest = function initApprovalRequest() {
	  return {
	    type: TYPES.PERDIEM_INIT_APPROVAL_REQUEST
	  };
	};
	
	var initApprovalSuccess = exports.initApprovalSuccess = function initApprovalSuccess(data) {
	  return {
	    type: TYPES.PERDIEM_INIT_APPROVAL_SUCCESS,
	    data: data
	  };
	};
	
	var initApprovalFailure = exports.initApprovalFailure = function initApprovalFailure(error) {
	  return {
	    type: TYPES.PERDIEM_INIT_APPROVAL_FAILURE,
	    error: error
	  };
	};
	
	var initApproval = exports.initApproval = function initApproval() {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, valuesByKey, fixedAmountType, _ref2, _ref3, perDiemListRes, perDiemLocationListRes, perDiemTypeListRes, data;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _getState = getState(), valuesByKey = _getState.WebValuesReducer.valuesByKey;
	              fixedAmountType = (0, _lodash.get)(valuesByKey, ['PerDiem.IsFixed.Type', 'Value']);
	
	              dispatch(initApprovalRequest());
	
	              _context.next = 6;
	              return Promise.all([getData('PerDiems'), getData('PerDiemLocations'), getData('PerDiemTypes')]);
	
	            case 6:
	              _ref2 = _context.sent;
	              _ref3 = _slicedToArray(_ref2, 3);
	              perDiemListRes = _ref3[0];
	              perDiemLocationListRes = _ref3[1];
	              perDiemTypeListRes = _ref3[2];
	              data = {
	                perDiemList: (0, _lodash.get)(perDiemListRes, 'data.value', []),
	                perDiemLocationList: (0, _lodash.get)(perDiemLocationListRes, 'data.value', []),
	                perDiemTypeList: (0, _lodash.get)(perDiemTypeListRes, 'data.value', []),
	                perDiemAmountTypeFixed: fixedAmountType
	              };
	
	              dispatch(initApprovalSuccess(data));
	              _context.next = 18;
	              break;
	
	            case 15:
	              _context.prev = 15;
	              _context.t0 = _context['catch'](0);
	
	              dispatch(initApprovalFailure(_context.t0));
	
	            case 18:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 15]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var perDiemApproval = exports.perDiemApproval = function perDiemApproval() {
	  return {
	    type: TYPES.PERDIEM_APPROVAL_REQUEST
	  };
	};
	
	var perDiemApprovalSuccess = exports.perDiemApprovalSuccess = function perDiemApprovalSuccess() {
	  return {
	    type: TYPES.PERDIEM_APPROVAL_SUCCESS
	  };
	};
	
	var perDiemApprovalFailure = exports.perDiemApprovalFailure = function perDiemApprovalFailure(error) {
	  return {
	    type: TYPES.PERDIEM_APPROVAL_FAILURE,
	    error: error
	  };
	};
	
	var createPerDiemApprovalRequest = exports.createPerDiemApprovalRequest = function createPerDiemApprovalRequest(data, callback) {
	  return function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	      var _getState2, DefaultEmployeeDetailID, editedData;
	
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              dispatch(perDiemApproval());
	              _context2.prev = 1;
	              _getState2 = getState(), DefaultEmployeeDetailID = _getState2.loginReducer.user.DefaultEmployeeDetailID;
	              editedData = _extends({}, data, {
	                EmployeeDetailID: DefaultEmployeeDetailID,
	                EmployeeDetailApprovalRequestType: 'PerDiemRecordsHandler',
	                RequestTitle: 'Dagpeningabeiðni/Per diem request',
	                ExpirationDate: (0, _moment2.default)('9999-12-31 00:00:00.000').toISOString()
	              });
	              _context2.next = 6;
	              return postData('EmployeeDetailApprovalRequests', editedData);
	
	            case 6:
	              dispatch(perDiemApprovalSuccess());
	              // Notificaiton on success
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.create.success' }),
	                status: 'success',
	                dismissible: true,
	                dismissAfter: 5000
	              }));
	              callback();
	              _context2.next = 16;
	              break;
	
	            case 11:
	              _context2.prev = 11;
	              _context2.t0 = _context2['catch'](1);
	
	              dispatch(perDiemApprovalFailure(_context2.t0));
	              // Notification on error
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.create.error' }),
	                message: (0, _lodash.get)(_context2.t0, 'message'),
	                status: 'error',
	                dismissible: true,
	                dismissAfter: 12000
	              }));
	              callback();
	
	            case 16:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[1, 11]]);
	    }));
	
	    return function (_x3, _x4) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	};
	
	var calculateRequest = exports.calculateRequest = function calculateRequest() {
	  return {
	    type: TYPES.CALCULATE_REQUEST
	  };
	};
	
	var calculateSuccess = exports.calculateSuccess = function calculateSuccess(calculatedRecord) {
	  return {
	    type: TYPES.CALCULATE_SUCCESS,
	    calculatedRecord: calculatedRecord
	  };
	};
	
	var calculateFailure = exports.calculateFailure = function calculateFailure(error) {
	  return {
	    type: TYPES.CALCULATE_FAILURE,
	    error: error
	  };
	};
	
	var calculateReset = exports.calculateReset = function calculateReset() {
	  return {
	    type: TYPES.CALCULATE_RESET
	  };
	};
	
	var calculate = exports.calculate = function calculate(data) {
	  return function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	      var res, record;
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              if (!data) {
	                dispatch(calculateReset());
	              }
	              dispatch(calculateRequest());
	              _context3.prev = 2;
	              _context3.next = 5;
	              return postData('PerDiemRecords/Calculate', data);
	
	            case 5:
	              res = _context3.sent;
	              record = (0, _lodash.get)(res, 'data');
	
	              dispatch(calculateSuccess(record));
	              _context3.next = 13;
	              break;
	
	            case 10:
	              _context3.prev = 10;
	              _context3.t0 = _context3['catch'](2);
	
	              dispatch(calculateFailure(_context3.t0));
	
	            case 13:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[2, 10]]);
	    }));
	
	    return function (_x5) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	};
	
	var usePerDiemState = exports.usePerDiemState = function usePerDiemState() {
	  return (0, _reactRedux.useSelector)(function (state) {
	    return state.perDiemReducer;
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(API2, 'API2', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(getData, 'getData', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(postData, 'postData', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(initApprovalRequest, 'initApprovalRequest', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(initApprovalSuccess, 'initApprovalSuccess', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(initApprovalFailure, 'initApprovalFailure', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(initApproval, 'initApproval', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(perDiemApproval, 'perDiemApproval', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(perDiemApprovalSuccess, 'perDiemApprovalSuccess', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(perDiemApprovalFailure, 'perDiemApprovalFailure', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(createPerDiemApprovalRequest, 'createPerDiemApprovalRequest', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(calculateRequest, 'calculateRequest', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(calculateSuccess, 'calculateSuccess', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(calculateFailure, 'calculateFailure', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(calculateReset, 'calculateReset', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(calculate, 'calculate', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(usePerDiemState, 'usePerDiemState', 'D:/a/1/s/src/web/employee/src/actions/PerDiem.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.newPasswordRequest = newPasswordRequest;
	exports.newPasswordSuccess = newPasswordSuccess;
	exports.newPasswordFailure = newPasswordFailure;
	exports.newPassword = newPassword;
	
	var _reapop = __webpack_require__(44);
	
	var _reduxForm = __webpack_require__(67);
	
	var _Api = __webpack_require__(21);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function newPasswordRequest() {
	  return {
	    type: types.NEW_PASSWORD_REQUEST
	  };
	}
	
	function newPasswordSuccess() {
	  return {
	    type: types.NEW_PASSWORD_SUCCESS
	  };
	}
	
	function newPasswordFailure(error) {
	  return {
	    type: types.NEW_PASSWORD_FAILURE,
	    error: error
	  };
	}
	
	function newPassword(_ref) {
	  var OldPassword = _ref.OldPassword,
	      NewPassword = _ref.NewPassword,
	      ConfirmPassword = _ref.ConfirmPassword;
	
	  return function (dispatch, getState) {
	    dispatch(newPasswordRequest());
	
	    var _getState = getState(),
	        token = _getState.loginReducer.user.token;
	
	    var config = {
	      url: '/api/Account/ChangePassword',
	      method: 'POST',
	      headers: { Authorization: 'Bearer ' + token },
	      data: {
	        OldPassword: OldPassword,
	        NewPassword: NewPassword,
	        ConfirmPassword: ConfirmPassword
	      }
	    };
	
	    (0, _Api.custom)(config).then(function () {
	      dispatch(newPasswordSuccess());
	      dispatch((0, _reduxForm.reset)('NewPassword'));
	      dispatch((0, _reapop.addNotification)({
	        title: 'Vistað',
	        message: 'Nýtt lykilorð hefur verið vistað',
	        status: 'success',
	        dismissable: true,
	        dismissAfter: 4000
	      }));
	    }).catch(function (error) {
	      console.log('error', error);
	      var innerMessage = (0, _lodash.get)(error, ['ModelState', 'model.NewPassword', 0]);
	      if (innerMessage) {
	        (0, _lodash.set)(error, 'Message', innerMessage);
	      }
	      dispatch(newPasswordFailure(error));
	    });
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(newPasswordRequest, 'newPasswordRequest', 'D:/a/1/s/src/web/employee/src/actions/Settings.js');
	
	  __REACT_HOT_LOADER__.register(newPasswordSuccess, 'newPasswordSuccess', 'D:/a/1/s/src/web/employee/src/actions/Settings.js');
	
	  __REACT_HOT_LOADER__.register(newPasswordFailure, 'newPasswordFailure', 'D:/a/1/s/src/web/employee/src/actions/Settings.js');
	
	  __REACT_HOT_LOADER__.register(newPassword, 'newPassword', 'D:/a/1/s/src/web/employee/src/actions/Settings.js');
	}();

	;

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchWebValues = exports.requestWebValuesFailure = exports.requestWebValuesSuccess = exports.requestWebValues = undefined;
	
	var _ActionTypes = __webpack_require__(18);
	
	var TYPES = _interopRequireWildcard(_ActionTypes);
	
	var _Api = __webpack_require__(21);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var requestWebValues = exports.requestWebValues = function requestWebValues() {
	  return {
	    type: TYPES.REQUEST_WEB_VALUES
	  };
	};
	
	var requestWebValuesSuccess = exports.requestWebValuesSuccess = function requestWebValuesSuccess(_ref) {
	  var valuesKeyed = _ref.valuesKeyed,
	      links = _ref.links;
	  return {
	    type: TYPES.REQUEST_WEB_VALUES_SUCCESS,
	    links: links,
	    valuesByKey: valuesKeyed
	  };
	};
	
	var requestWebValuesFailure = exports.requestWebValuesFailure = function requestWebValuesFailure(error) {
	  return {
	    type: TYPES.REQUEST_WEB_VALUES_FAILURE,
	    error: error
	  };
	};
	
	var fetchWebValues = exports.fetchWebValues = function fetchWebValues(cb) {
	  return function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, token, _getState$WebValuesRe, timeStamp, valuesByKey, webValuesRequest, webValues, valuesKeyed, links;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	              _getState = getState(), token = _getState.loginReducer.user.token, _getState$WebValuesRe = _getState.WebValuesReducer, timeStamp = _getState$WebValuesRe.timeStamp, valuesByKey = _getState$WebValuesRe.valuesByKey;
	              // If we fetched the values recently we do not fetch them again
	
	              if (!(timeStamp && Date.now() > timeStamp + 360000)) {
	                _context.next = 6;
	                break;
	              }
	
	              cb && cb(valuesByKey);
	              _context.next = 18;
	              break;
	
	            case 6:
	              dispatch(requestWebValues());
	              webValuesRequest = {
	                headers: { Authorization: 'Bearer ' + token },
	                url: "/kjarni/api/v2/WebValues/MyWebValues(code='Employee.Web')",
	                method: 'GET'
	              };
	              _context.t0 = _lodash.get;
	              _context.next = 11;
	              return (0, _Api.custom)(webValuesRequest);
	
	            case 11:
	              _context.t1 = _context.sent;
	              _context.t2 = [];
	              webValues = (0, _context.t0)(_context.t1, 'data.value', _context.t2);
	              valuesKeyed = (0, _lodash.keyBy)(webValues, function (x) {
	                return (0, _lodash.replace)(x.Code, 'Employee.Web.', '');
	              });
	              links = (0, _lodash.orderBy)((0, _lodash.map)((0, _lodash.pickBy)(valuesKeyed, function (x) {
	                return x.Code.startsWith('Employee.Web.Link');
	              }), function (x) {
	                return x;
	              }), 'Description');
	
	              dispatch(requestWebValuesSuccess({ valuesKeyed: valuesKeyed, links: links }));
	              cb && cb(valuesKeyed);
	
	            case 18:
	              _context.next = 24;
	              break;
	
	            case 20:
	              _context.prev = 20;
	              _context.t3 = _context['catch'](0);
	
	              dispatch(requestWebValuesFailure(_context.t3));
	              window.location.replace('/account?logout=true');
	
	            case 24:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 20]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestWebValues, 'requestWebValues', 'D:/a/1/s/src/web/employee/src/actions/WebValues.js');
	
	  __REACT_HOT_LOADER__.register(requestWebValuesSuccess, 'requestWebValuesSuccess', 'D:/a/1/s/src/web/employee/src/actions/WebValues.js');
	
	  __REACT_HOT_LOADER__.register(requestWebValuesFailure, 'requestWebValuesFailure', 'D:/a/1/s/src/web/employee/src/actions/WebValues.js');
	
	  __REACT_HOT_LOADER__.register(fetchWebValues, 'fetchWebValues', 'D:/a/1/s/src/web/employee/src/actions/WebValues.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logoutFailure = logoutFailure;
	exports.logoutSuccess = logoutSuccess;
	exports.default = logoutUser;
	
	var _forIn = __webpack_require__(570);
	
	var _forIn2 = _interopRequireDefault(_forIn);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* eslint global-require: 0 */
	function logoutRequest() {
	  return {
	    type: types.LOGOUT_REQUEST,
	    isFetching: true
	  };
	}
	
	function logoutFailure(error) {
	  return {
	    type: types.LOGOUT_FAILURE,
	    error: error
	  };
	}
	
	function logoutSuccess() {
	  return {
	    type: types.LOGOUT_SUCCESS
	  };
	}
	
	function logoutUser() {
	  return function (dispatch) {
	    dispatch(logoutRequest());
	    var _localStorage = localStorage,
	        language = _localStorage.language,
	        appraisals = _localStorage.appraisals,
	        localSettings = _localStorage.localSettings;
	
	    var appraisalsJSON = null;
	    localStorage.clear();
	    // When we log out we check if we need to clear some old appraisal data
	    if (appraisals && appraisals !== 'undefined') {
	      appraisalsJSON = JSON.parse(appraisals);
	      (0, _forIn2.default)(appraisalsJSON, function (_ref, key) {
	        var expires = _ref.expires;
	
	        if (expires < Date.now()) {
	          appraisalsJSON[key] = '';
	        }
	      });
	      localStorage.appraisals = appraisalsJSON ? JSON.stringify(appraisalsJSON) : appraisals;
	      localStorage.localSettings = localSettings;
	    } else {
	      localStorage.removeItem('appraisals');
	    }
	    localStorage.language = language;
	    dispatch(logoutSuccess());
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(logoutRequest, 'logoutRequest', 'D:/a/1/s/src/web/employee/src/actions/account/logout.js');
	
	  __REACT_HOT_LOADER__.register(logoutFailure, 'logoutFailure', 'D:/a/1/s/src/web/employee/src/actions/account/logout.js');
	
	  __REACT_HOT_LOADER__.register(logoutSuccess, 'logoutSuccess', 'D:/a/1/s/src/web/employee/src/actions/account/logout.js');
	
	  __REACT_HOT_LOADER__.register(logoutUser, 'logoutUser', 'D:/a/1/s/src/web/employee/src/actions/account/logout.js');
	}();

	;

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchCareer = fetchCareer;
	exports.fetchCareerIfNeeded = fetchCareerIfNeeded;
	
	var _isEmpty = __webpack_require__(98);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _Api = __webpack_require__(21);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestCareer() {
	  return {
	    type: types.REQUEST_CAREER
	  };
	}
	
	function requestCareerSuccess(careerData) {
	  return {
	    type: types.REQUEST_CAREER_SUCCESS,
	    careerData: careerData,
	    receivedAt: Date.now()
	  };
	}
	
	function requestCareerFailure(error) {
	  return {
	    type: types.REQUEST_CAREER_FAILURE,
	    error: error
	  };
	}
	
	function fetchCareer() {
	  return function (dispatch, getState) {
	    dispatch(requestCareer());
	
	    var _getState = getState(),
	        _getState$loginReduce = _getState.loginReducer.user,
	        EmployeeMasterID = _getState$loginReduce.EmployeeMasterID,
	        token = _getState$loginReduce.token;
	
	    var fetchConfig = {
	      entity: 'EmployeeMasterCareer',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: 'Entity/EmployeeMasterID eq ' + EmployeeMasterID
	      }
	    };
	
	    (0, _Api.listWM)(fetchConfig).then(function (_ref) {
	      var data = _ref.data;
	      return dispatch(requestCareerSuccess(data));
	    }).catch(function (error) {
	      return dispatch(requestCareerFailure(error));
	    });
	  };
	}
	
	function fetchCareerIfNeeded() {
	  return function (dispatch, getState) {
	    return (0, _isEmpty2.default)(getState().careerReducer.careerData) && dispatch(fetchCareer());
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestCareer, 'requestCareer', 'D:/a/1/s/src/web/employee/src/actions/career.js');
	
	  __REACT_HOT_LOADER__.register(requestCareerSuccess, 'requestCareerSuccess', 'D:/a/1/s/src/web/employee/src/actions/career.js');
	
	  __REACT_HOT_LOADER__.register(requestCareerFailure, 'requestCareerFailure', 'D:/a/1/s/src/web/employee/src/actions/career.js');
	
	  __REACT_HOT_LOADER__.register(fetchCareer, 'fetchCareer', 'D:/a/1/s/src/web/employee/src/actions/career.js');
	
	  __REACT_HOT_LOADER__.register(fetchCareerIfNeeded, 'fetchCareerIfNeeded', 'D:/a/1/s/src/web/employee/src/actions/career.js');
	}();

	;

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchCertificate = fetchCertificate;
	exports.fetchCertificateIfNeeded = fetchCertificateIfNeeded;
	
	var _isEmpty = __webpack_require__(98);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _Api = __webpack_require__(21);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestCertificate() {
	  return {
	    type: types.REQUEST_CERTIFICATE
	  };
	}
	
	function requestCertificateSuccess(certificateList) {
	  return {
	    type: types.REQUEST_CERTIFICATE_SUCCESS,
	    certificateList: certificateList,
	    receivedAt: Date.now()
	  };
	}
	
	function requestCertificateFailure(error) {
	  return {
	    type: types.REQUEST_CERTIFICATE_FAILURE,
	    error: error
	  };
	}
	
	function fetchCertificate() {
	  return function (dispatch, getState) {
	    dispatch(requestCertificate());
	
	    var _getState = getState(),
	        _getState$loginReduce = _getState.loginReducer.user,
	        EmployeeMasterID = _getState$loginReduce.EmployeeMasterID,
	        token = _getState$loginReduce.token;
	
	    var fetchConfig = {
	      entity: 'EmployeeMasterCertificate',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: 'Entity/EmployeeMasterID eq ' + EmployeeMasterID
	      }
	    };
	
	    (0, _Api.listWM)(fetchConfig).then(function (_ref) {
	      var data = _ref.data;
	      return dispatch(requestCertificateSuccess(data));
	    }).catch(function (error) {
	      return dispatch(requestCertificateFailure(error));
	    });
	  };
	}
	
	function fetchCertificateIfNeeded() {
	  return function (dispatch, getState) {
	    return (0, _isEmpty2.default)(getState().certificateReducer.certificateData) && dispatch(fetchCertificate());
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestCertificate, 'requestCertificate', 'D:/a/1/s/src/web/employee/src/actions/certificate.js');
	
	  __REACT_HOT_LOADER__.register(requestCertificateSuccess, 'requestCertificateSuccess', 'D:/a/1/s/src/web/employee/src/actions/certificate.js');
	
	  __REACT_HOT_LOADER__.register(requestCertificateFailure, 'requestCertificateFailure', 'D:/a/1/s/src/web/employee/src/actions/certificate.js');
	
	  __REACT_HOT_LOADER__.register(fetchCertificate, 'fetchCertificate', 'D:/a/1/s/src/web/employee/src/actions/certificate.js');
	
	  __REACT_HOT_LOADER__.register(fetchCertificateIfNeeded, 'fetchCertificateIfNeeded', 'D:/a/1/s/src/web/employee/src/actions/certificate.js');
	}();

	;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchEducation = fetchEducation;
	exports.fetchEducationIfNeeded = fetchEducationIfNeeded;
	
	var _isEmpty = __webpack_require__(98);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _Api = __webpack_require__(21);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestEducation() {
	  return {
	    type: types.REQUEST_EDUCATION,
	    isFetching: true,
	    employeeMasterEducationList: [],
	    loaded: false,
	    error: null
	  };
	}
	
	function requestEducationSuccess(employeeMasterEducationList) {
	  return {
	    type: types.REQUEST_EDUCATION_SUCCESS,
	    employeeMasterEducationList: employeeMasterEducationList,
	    receivedAt: Date.now(),
	    isFetching: false,
	    loaded: true
	  };
	}
	
	function requestEducationFailure(error) {
	  return {
	    type: types.REQUEST_EDUCATION_FAILURE,
	    isFetching: false,
	    loaded: true,
	    error: error
	  };
	}
	
	function fetchEducation() {
	  return function (dispatch, getState) {
	    dispatch(requestEducation());
	
	    var _getState = getState(),
	        _getState$loginReduce = _getState.loginReducer.user,
	        EmployeeMasterID = _getState$loginReduce.EmployeeMasterID,
	        token = _getState$loginReduce.token;
	
	    var fetchConfig = {
	      entity: 'EmployeeMasterEducation',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: 'Entity/EmployeeMasterID eq ' + EmployeeMasterID
	      }
	    };
	
	    (0, _Api.listWM)(fetchConfig).then(function (_ref) {
	      var data = _ref.data;
	      return dispatch(requestEducationSuccess(data));
	    }).catch(function (error) {
	      return dispatch(requestEducationFailure(error));
	    });
	  };
	}
	
	function fetchEducationIfNeeded() {
	  return function (dispatch, getState) {
	    return (0, _isEmpty2.default)(getState().educationReducer.educationData) && dispatch(fetchEducation());
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestEducation, 'requestEducation', 'D:/a/1/s/src/web/employee/src/actions/education.js');
	
	  __REACT_HOT_LOADER__.register(requestEducationSuccess, 'requestEducationSuccess', 'D:/a/1/s/src/web/employee/src/actions/education.js');
	
	  __REACT_HOT_LOADER__.register(requestEducationFailure, 'requestEducationFailure', 'D:/a/1/s/src/web/employee/src/actions/education.js');
	
	  __REACT_HOT_LOADER__.register(fetchEducation, 'fetchEducation', 'D:/a/1/s/src/web/employee/src/actions/education.js');
	
	  __REACT_HOT_LOADER__.register(fetchEducationIfNeeded, 'fetchEducationIfNeeded', 'D:/a/1/s/src/web/employee/src/actions/education.js');
	}();

	;

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchLoans = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.fetchLoansIfNeeded = fetchLoansIfNeeded;
	
	var _lodash = __webpack_require__(8);
	
	var _Api = __webpack_require__(21);
	
	var _xSelect = __webpack_require__(188);
	
	var _ActionTypes = __webpack_require__(18);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function requestLoans() {
	  return {
	    type: _ActionTypes.REQUEST_LOANS
	  };
	}
	
	function requestLoansSuccess(loansData) {
	  return {
	    type: _ActionTypes.REQUEST_LOANS_SUCCESS,
	    loansData: loansData,
	    receivedAt: Date.now()
	  };
	}
	
	function requestLoansFailure(error) {
	  return {
	    type: _ActionTypes.REQUEST_LOANS_FAILURE,
	    error: error
	  };
	}
	
	var fetchLoans = exports.fetchLoans = function fetchLoans() {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, _getState$loginReduce, EmployeeMasterID, token, config, configObjectTypes, _ref2, objectsOnLoan, _ref3, objectTypes, objectTypesByKey, data;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              dispatch(requestLoans());
	
	              _getState = getState(), _getState$loginReduce = _getState.loginReducer.user, EmployeeMasterID = _getState$loginReduce.EmployeeMasterID, token = _getState$loginReduce.token;
	              config = {
	                entity: 'EmployeeMasterObjectOnLoan',
	                headers: { Authorization: 'Bearer ' + token },
	                data: (0, _xSelect.xSelectSingle)([{ field: 'EmployeeMasterID', value: EmployeeMasterID, relation: 'eq' }])
	              };
	              configObjectTypes = {
	                entity: 'HrObjectType',
	                headers: { Authorization: 'Bearer ' + token }
	              };
	              _context.prev = 4;
	              _context.next = 7;
	              return (0, _Api.list)(config);
	
	            case 7:
	              _ref2 = _context.sent;
	              objectsOnLoan = _ref2.data;
	              _context.next = 11;
	              return (0, _Api.list)(configObjectTypes);
	
	            case 11:
	              _ref3 = _context.sent;
	              objectTypes = _ref3.data;
	              objectTypesByKey = (0, _lodash.keyBy)(objectTypes, 'HrObjectTypeID');
	              data = (0, _lodash.map)(objectsOnLoan, function (object) {
	                return _extends({}, object, { ObjectTypeName: (0, _lodash.get)(objectTypesByKey, [object.ObjectType, 'HrObjectTypeName'], '') });
	              });
	
	              dispatch(requestLoansSuccess((0, _lodash.map)(data, function (e) {
	                return _extends({}, e, { Entity: e });
	              })));
	              _context.next = 21;
	              break;
	
	            case 18:
	              _context.prev = 18;
	              _context.t0 = _context['catch'](4);
	
	              dispatch(requestLoansFailure(_context.t0));
	
	            case 21:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[4, 18]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	function fetchLoansIfNeeded() {
	  return function (dispatch, getState) {
	    (0, _lodash.isEmpty)(getState().loansReducer.loansData) && dispatch(fetchLoans());
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestLoans, 'requestLoans', 'D:/a/1/s/src/web/employee/src/actions/loans.js');
	
	  __REACT_HOT_LOADER__.register(requestLoansSuccess, 'requestLoansSuccess', 'D:/a/1/s/src/web/employee/src/actions/loans.js');
	
	  __REACT_HOT_LOADER__.register(requestLoansFailure, 'requestLoansFailure', 'D:/a/1/s/src/web/employee/src/actions/loans.js');
	
	  __REACT_HOT_LOADER__.register(fetchLoans, 'fetchLoans', 'D:/a/1/s/src/web/employee/src/actions/loans.js');
	
	  __REACT_HOT_LOADER__.register(fetchLoansIfNeeded, 'fetchLoansIfNeeded', 'D:/a/1/s/src/web/employee/src/actions/loans.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchQualification = fetchQualification;
	exports.fetchQualificationIfNeeded = fetchQualificationIfNeeded;
	
	var _isEmpty = __webpack_require__(98);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _Api = __webpack_require__(21);
	
	var _ActionTypes = __webpack_require__(18);
	
	var types = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestQualification() {
	  return {
	    type: types.REQUEST_QUALIFICATION
	  };
	}
	
	function requestQualificationSuccess(qualificationData) {
	  return {
	    type: types.REQUEST_QUALIFICATION_SUCCESS,
	    qualificationData: qualificationData,
	    receivedAt: Date.now()
	  };
	}
	
	function requestQualificationFailure(error) {
	  return {
	    type: types.REQUEST_QUALIFICATION_FAILURE,
	    error: error
	  };
	}
	
	function fetchQualification() {
	  return function (dispatch, getState) {
	    dispatch(requestQualification());
	
	    var _getState = getState(),
	        _getState$loginReduce = _getState.loginReducer.user,
	        EmployeeMasterID = _getState$loginReduce.EmployeeMasterID,
	        token = _getState$loginReduce.token;
	
	    var fetchConfig = {
	      entity: 'EmployeeMasterQualification',
	      headers: { Authorization: 'Bearer ' + token },
	      params: {
	        $filter: 'Entity/EmployeeMasterID eq ' + EmployeeMasterID
	      }
	    };
	
	    (0, _Api.listWM)(fetchConfig).then(function (_ref) {
	      var data = _ref.data;
	      return dispatch(requestQualificationSuccess(data));
	    }).catch(function (error) {
	      return dispatch(requestQualificationFailure(error));
	    });
	  };
	}
	
	function fetchQualificationIfNeeded() {
	  return function (dispatch, getState) {
	    (0, _isEmpty2.default)(getState().qualificationReducer.qualificationData) && dispatch(fetchQualification());
	  };
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestQualification, 'requestQualification', 'D:/a/1/s/src/web/employee/src/actions/qualification.js');
	
	  __REACT_HOT_LOADER__.register(requestQualificationSuccess, 'requestQualificationSuccess', 'D:/a/1/s/src/web/employee/src/actions/qualification.js');
	
	  __REACT_HOT_LOADER__.register(requestQualificationFailure, 'requestQualificationFailure', 'D:/a/1/s/src/web/employee/src/actions/qualification.js');
	
	  __REACT_HOT_LOADER__.register(fetchQualification, 'fetchQualification', 'D:/a/1/s/src/web/employee/src/actions/qualification.js');
	
	  __REACT_HOT_LOADER__.register(fetchQualificationIfNeeded, 'fetchQualificationIfNeeded', 'D:/a/1/s/src/web/employee/src/actions/qualification.js');
	}();

	;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  acceptContainer: {
	    paddingTop: 16,
	    paddingBottom: 16
	  },
	  agreementItem: {
	    display: 'flex',
	    flexDirection: 'column',
	    flex: 1,
	    paddingLeft: 32,
	    paddingRight: 32,
	    paddingTop: 16,
	    paddingBottom: 16,
	    marginLeft: 16,
	    marginRight: 16,
	    borderLeft: 'solid 10px #f5aa0a'
	  },
	  action: {
	    margin: 8
	  },
	  infoButton: {
	    marginTop: 16
	  },
	  warning: {
	    fontSize: 14,
	    color: _colors2.default.errorColor
	  }
	};
	
	var Agreement = function (_React$Component) {
	  _inherits(Agreement, _React$Component);
	
	  function Agreement(props) {
	    _classCallCheck(this, Agreement);
	
	    var _this = _possibleConstructorReturn(this, (Agreement.__proto__ || Object.getPrototypeOf(Agreement)).call(this, props));
	
	    _this.onCheck = function () {
	      return _this.__onCheck__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.onAccept = function () {
	      return _this.__onAccept__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleClose = function () {
	      return _this.__handleClose__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleFile = function () {
	      return _this.__handleFile__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = {
	      dialogOpen: false,
	      file: null
	    };
	    return _this;
	  }
	
	  _createClass(Agreement, [{
	    key: '__handleFile__REACT_HOT_LOADER__',
	    value: function __handleFile__REACT_HOT_LOADER__() {
	      return this.__handleFile__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleClose__REACT_HOT_LOADER__',
	    value: function __handleClose__REACT_HOT_LOADER__() {
	      return this.__handleClose__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__onAccept__REACT_HOT_LOADER__',
	    value: function __onAccept__REACT_HOT_LOADER__() {
	      return this.__onAccept__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__onCheck__REACT_HOT_LOADER__',
	    value: function __onCheck__REACT_HOT_LOADER__() {
	      return this.__onCheck__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__onCheck__REACT_HOT_LOADER__',
	    value: function __onCheck__REACT_HOT_LOADER__() {
	      this.setState({ dialogOpen: true });
	    }
	  }, {
	    key: '__onAccept__REACT_HOT_LOADER__',
	    value: function __onAccept__REACT_HOT_LOADER__() {
	      var _props = this.props,
	          HrAgreementID = _props.HrAgreementID,
	          EmployeeDetailID = _props.EmployeeDetailID,
	          FileRepositoryObjectDocumentTypeID = _props.FileRepositoryObjectDocumentTypeID;
	      var file = this.state.file;
	
	      this.props.handleAgreement(HrAgreementID, EmployeeDetailID, file, FileRepositoryObjectDocumentTypeID);
	      this.handleClose();
	    }
	  }, {
	    key: '__handleClose__REACT_HOT_LOADER__',
	    value: function __handleClose__REACT_HOT_LOADER__() {
	      return this.setState({ dialogOpen: false });
	    }
	  }, {
	    key: '__handleFile__REACT_HOT_LOADER__',
	    value: function __handleFile__REACT_HOT_LOADER__(e) {
	      return this.setState({ file: e.target.files[0] });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          HrAgreementText = _props2.HrAgreementText,
	          Link = _props2.Link,
	          FileRepositoryObjectDocumentTypeID = _props2.FileRepositoryObjectDocumentTypeID,
	          answer = _props2.answer;
	      var file = this.state.file;
	
	      var answerYes = answer && answer.EmployeeDetailAgreementAnswer === 1;
	      var actions = [_react2.default.createElement(_materialUi.RaisedButton, {
	        onClick: this.onAccept,
	        primary: true,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'agreement.yes' }),
	        style: styles.action
	      }), _react2.default.createElement(_materialUi.RaisedButton, {
	        onClick: this.handleClose,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'agreement.no' }),
	        style: styles.action
	      })];
	      return _react2.default.createElement(
	        _materialUi.Paper,
	        { 'data-cy': 'agreement-paper', style: _extends({}, styles.agreementItem, { borderLeftColor: answerYes ? _colors2.default.successColor : _colors2.default.warningColor }) },
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            actions: actions,
	            modal: true,
	            open: this.state.dialogOpen,
	            onRequestClose: this.handleClose
	          },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'agreement.dialog' })
	        ),
	        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: HrAgreementText } }),
	        FileRepositoryObjectDocumentTypeID !== 0 && !answerYes && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('input', { type: 'file', onChange: this.handleFile }),
	          !file && _react2.default.createElement(
	            'span',
	            { style: styles.warning },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'agreement.noFile' })
	          )
	        ),
	        Link && _react2.default.createElement(
	          'div',
	          { style: styles.infoButton },
	          _react2.default.createElement(_materialUi.RaisedButton, {
	            target: '_blank',
	            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'agreement.moreInfo' }),
	            href: Link
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.acceptContainer },
	          _react2.default.createElement(_materialUi.Checkbox, {
	            checked: answerYes,
	            disabled: !file && FileRepositoryObjectDocumentTypeID !== 0 && !answerYes,
	            onCheck: this.onCheck,
	            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'agreement.sign' })
	          })
	        )
	      );
	    }
	  }]);
	
	  return Agreement;
	}(_react2.default.Component);
	
	Agreement.propTypes = {
	  HrAgreementText: _propTypes2.default.string.isRequired,
	  HrAgreementID: _propTypes2.default.number.isRequired,
	  FileRepositoryObjectDocumentTypeID: _propTypes2.default.number.isRequired,
	  EmployeeDetailID: _propTypes2.default.string.isRequired,
	  Link: _propTypes2.default.string,
	  handleAgreement: _propTypes2.default.func.isRequired,
	  answer: _propTypes2.default.object
	};
	
	var _default = Agreement;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/Agreement.js');
	
	  __REACT_HOT_LOADER__.register(Agreement, 'Agreement', 'D:/a/1/s/src/web/employee/src/components/Agreement.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/Agreement.js');
	}();

	;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _Subheader = __webpack_require__(115);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _reactIntl = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  apple: {
	    borderRadius: '13px',
	    display: 'inline-block',
	    overflow: 'hidden'
	  },
	  android: {
	    display: 'inline-block',
	    overflow: 'hidden'
	  },
	  subheader: {
	    fontSize: 20,
	    fontWeight: 300,
	    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	    paddingLeft: 8,
	    paddingRight: 8
	  },
	  container: {
	    padding: 8,
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'space-around',
	    flexWrap: 'wrap'
	  },
	  description: {
	    fontSize: 16,
	    fontWeight: 300,
	    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	    padding: 8,
	    marginTop: 0,
	    marginBottom: 16,
	    textAlign: 'center'
	  },
	  paper: {
	    padding: 16,
	    margin: 8
	  }
	};
	
	/* eslint jsx-a11y/anchor-has-content: 0 */
	var AppLinks = function AppLinks() {
	  return _react2.default.createElement(
	    _reactFlexboxGrid.Col,
	    { xs: 12, sm: 8, smOffset: 2, md: 6, mdOffset: 3 },
	    _react2.default.createElement(
	      _Subheader2.default,
	      { style: styles.subheader },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appLinks.title' })
	    ),
	    _react2.default.createElement(
	      _Paper2.default,
	      { style: styles.paper },
	      _react2.default.createElement(
	        'p',
	        { style: styles.description },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appLinks.message' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: styles.container },
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://apps.apple.com/us/app/kjarni/id1540767408?itsct=apps_box_badge&itscg=30200',
	            style: styles.apple
	          },
	          _react2.default.createElement('img', {
	            src: 'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&releaseDate=1606003200',
	            alt: 'Download on the App Store',
	            style: {
	              borderRadius: 13, width: 166, height: 55
	            }
	          })
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            href: 'https://play.google.com/store/apps/details?id=is.origo.kjarni.android&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1',
	            style: styles.android
	          },
	          _react2.default.createElement('img', {
	            alt: 'Get it on Google Play',
	            src: 'https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png',
	            style: { width: 195, height: 80 }
	          })
	        )
	      )
	    )
	  );
	};
	
	var _default = AppLinks;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/AppLinks.js');
	
	  __REACT_HOT_LOADER__.register(AppLinks, 'AppLinks', 'D:/a/1/s/src/web/employee/src/components/AppLinks.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/AppLinks.js');
	}();

	;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _AppraisalList = __webpack_require__(454);
	
	var _AppraisalList2 = _interopRequireDefault(_AppraisalList);
	
	var _StatusIcon = __webpack_require__(427);
	
	var _StatusIcon2 = _interopRequireDefault(_StatusIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppraisalItem = function AppraisalItem(_ref) {
	  var appraisal = _ref.appraisal,
	      isManager = _ref.isManager,
	      _onClick = _ref.onClick;
	
	  var manDue = new Date(appraisal.ManagerDueDate);
	  manDue.setHours(23, 59, 59);
	  var manStat = appraisal.ManagerStatus;
	
	  var empDue = new Date(appraisal.EmployeeDueDate);
	  empDue.setHours(23, 59, 59);
	  var empStat = appraisal.EmployeeStatus;
	
	  var finDue = new Date(appraisal.FinalAppraisalDate);
	  finDue.setHours(23, 59, 59);
	  var finStat = appraisal.FinalStatus;
	
	  var dueDate = isManager ? manDue : empDue;
	  var stat = isManager ? manStat : empStat;
	
	  var managerLock = empStat === 2 && manStat === 2 || finDue.getTime() < Date.now() ? false : manStat === 2 && empDue.getTime() > Date.now();
	
	  var notManagerLock = finStat === 2 || finDue.getTime() < Date.now() ? false : empStat === 2 || empDue.getTime() < Date.now();
	
	  var lock = isManager ? managerLock : notManagerLock;
	
	  /* eslint no-nested-ternary: 0 */
	  var status = lock ? 3 : finStat === 2 ? 4 : -1;
	
	  var statusMsg = finStat === 2 ? _react2.default.createElement(
	    'span',
	    { style: { color: _colors2.default.successColor } },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.finished' })
	  ) : finDue.getTime() < Date.now() ? _react2.default.createElement(
	    'span',
	    { style: { color: _colors2.default.warningColor } },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.submit.fail' })
	  ) : dueDate.getTime() < Date.now() && stat !== 2 ? _react2.default.createElement(
	    'span',
	    { style: { color: _colors2.default.errorColor } },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.answer.fail' })
	  ) : stat === 2 && _react2.default.createElement(
	    'span',
	    { style: { color: _colors2.default.successColor } },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.answer' })
	  );
	
	  return _react2.default.createElement(
	    _Paper2.default,
	    {
	      key: appraisal.PMAppraisalID,
	      onClick: function onClick() {
	        return _onClick(appraisal.PMAppraisalID);
	      },
	      style: _extends({}, _AppraisalList2.default.appraisal, { cursor: 'pointer' })
	    },
	    _react2.default.createElement(
	      'div',
	      { style: _AppraisalList2.default.date },
	      _react2.default.createElement(
	        'span',
	        { style: _AppraisalList2.default.title },
	        _react2.default.createElement(_StatusIcon2.default, { type: status }),
	        appraisal.PMFormTitle
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'expires' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          ' ' + (0, _dateTools2.default)(empDue)
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactFlexboxGrid.Row,
	      { style: _AppraisalList2.default.content },
	      _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 12, sm: 6, md: 5 },
	        _react2.default.createElement(
	          'span',
	          { style: _AppraisalList2.default.subInfo },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.employee' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: _AppraisalList2.default.info },
	          status && _react2.default.createElement(_StatusIcon2.default, { type: appraisal.EmployeeStatus }),
	          appraisal.EmployeeName
	        )
	      ),
	      _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 12, sm: 6, md: 5 },
	        _react2.default.createElement(
	          'span',
	          { style: _AppraisalList2.default.subInfo },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.manager' })
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: _AppraisalList2.default.info },
	          _react2.default.createElement(_StatusIcon2.default, { type: appraisal.ManagerStatus }),
	          appraisal.ManagerName
	        )
	      ),
	      _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 12, sm: 6, md: 2, style: { display: 'flex', alignItems: 'end', justifyContent: 'end' } },
	        _react2.default.createElement(
	          'div',
	          { style: _extends({}, _AppraisalList2.default.info) },
	          statusMsg
	        )
	      )
	    )
	  );
	};
	
	AppraisalItem.propTypes = {
	  appraisal: _propTypes2.default.object.isRequired,
	  isManager: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func.isRequired
	};
	
	var _default = AppraisalItem;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(AppraisalItem, 'AppraisalItem', 'D:/a/1/s/src/web/employee/src/components/AppraisalItem.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/AppraisalItem.js');
	}();

	;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _CircularProgress = __webpack_require__(170);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _Subheader = __webpack_require__(115);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _SelectField = __webpack_require__(271);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(113);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _Appraisal = __webpack_require__(180);
	
	var _AppraisalList = __webpack_require__(454);
	
	var _AppraisalList2 = _interopRequireDefault(_AppraisalList);
	
	var _AppraisalItem = __webpack_require__(859);
	
	var _AppraisalItem2 = _interopRequireDefault(_AppraisalItem);
	
	var _getAppraisalTitle = __webpack_require__(148);
	
	var _getAppraisalTitle2 = _interopRequireDefault(_getAppraisalTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AppraisalList = function AppraisalList(_ref) {
	  var appraisals = _ref.appraisals,
	      onClick = _ref.onClick,
	      loading = _ref.loading,
	      isManager = _ref.isManager,
	      yearOptions = _ref.yearOptions,
	      year = _ref.year,
	      employee = _ref.employee,
	      dispatch = _ref.dispatch,
	      valuesByKey = _ref.valuesByKey;
	
	  var appraisalTitle = (0, _getAppraisalTitle2.default)(valuesByKey);
	
	  var setYear = function setYear(val) {
	    var method = isManager ? _Appraisal.setManagerYear : _Appraisal.setEmployeeYear;
	    dispatch(method(val));
	  };
	
	  var handleEmployee = function handleEmployee(value) {
	    dispatch((0, _Appraisal.setEmployee)(value));
	  };
	
	  var employeesMap = appraisals.reduce(function (acc, a) {
	    return acc.set(a.EmployeeMasterID, a.EmployeeName);
	  }, new Map());
	  var employees = [];
	  employeesMap.forEach(function (value, key) {
	    return employees.push({ name: value, id: key });
	  });
	
	  var filter = function filter(a) {
	    return (!year || new Date(a.FinalAppraisalDate).getFullYear() === year) && (!employee || a.EmployeeMasterID === employee);
	  };
	
	  var filteredAppraisals = appraisals.filter(filter).map(function (a) {
	    return _react2.default.createElement(_AppraisalItem2.default, { appraisal: a, isManager: isManager, onClick: onClick, key: a.PMAppraisalID });
	  });
	
	  var found = appraisals.some(filter);
	
	  if (loading) return _react2.default.createElement(_CircularProgress2.default, null);
	
	  return _react2.default.createElement(
	    _reactFlexboxGrid.Col,
	    { xs: 12, sm: 12, md: 10, mdOffset: 1 },
	    _react2.default.createElement(
	      _Subheader2.default,
	      { style: _AppraisalList2.default.header },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: appraisalTitle })
	    ),
	    _react2.default.createElement(
	      _reactFlexboxGrid.Row,
	      { middle: 'xs', center: 'xs' },
	      _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: true, style: { textAlign: 'left' } },
	        _react2.default.createElement(
	          _SelectField2.default,
	          {
	            floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.select.year' }),
	            value: year,
	            onChange: function onChange(a, b, value) {
	              return setYear(value);
	            }
	          },
	          _react2.default.createElement(_MenuItem2.default, { key: 0, value: 0, primaryText: ' ' }),
	          yearOptions.map(function (y) {
	            return _react2.default.createElement(_MenuItem2.default, { key: y, value: y, primaryText: y });
	          })
	        ),
	        _react2.default.createElement('span', { style: { padding: '10px' } }),
	        isManager && _react2.default.createElement(
	          _SelectField2.default,
	          {
	            style: { width: '400px' },
	            floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.select.employee' }),
	            value: employee,
	            onChange: function onChange(a, b, value) {
	              return handleEmployee(value);
	            }
	          },
	          _react2.default.createElement(_MenuItem2.default, { key: 0, value: 0, primaryText: ' ' }),
	          employees.map(function (e) {
	            return _react2.default.createElement(_MenuItem2.default, { key: e.id, value: e.id, primaryText: e.name });
	          })
	        ),
	        !found && _react2.default.createElement(_PanelMessage2.default, { type: 'info', iconName: 'info', message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.noAppraisal', values: { year: year } }) }),
	        filteredAppraisals
	      )
	    )
	  );
	};
	
	AppraisalList.propTypes = {
	  appraisals: _propTypes2.default.array.isRequired,
	  loading: _propTypes2.default.bool.isRequired,
	  onClick: _propTypes2.default.func.isRequired,
	  isManager: _propTypes2.default.bool.isRequired,
	  yearOptions: _propTypes2.default.array.isRequired,
	  year: _propTypes2.default.number.isRequired,
	  employee: _propTypes2.default.number,
	  dispatch: _propTypes2.default.func.isRequired,
	  valuesByKey: _propTypes2.default.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    valuesByKey: state.WebValuesReducer.valuesByKey
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(AppraisalList);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(AppraisalList, 'AppraisalList', 'D:/a/1/s/src/web/employee/src/components/AppraisalList.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/components/AppraisalList.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/AppraisalList.js');
	}();

	;

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KListItem = __webpack_require__(184);
	
	var _KListItem2 = _interopRequireDefault(_KListItem);
	
	var _PanelTable = __webpack_require__(431);
	
	var _PanelTable2 = _interopRequireDefault(_PanelTable);
	
	var _DataTypes = __webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DetailListItem = function DetailListItem(_ref) {
	  var type = _ref.type,
	      value = _ref.value,
	      label = _ref.label,
	      href = _ref.href,
	      ID = _ref.ID;
	  return type === _DataTypes.TABLE ? _react2.default.createElement(_PanelTable2.default, { dataSource: value }) : _react2.default.createElement(_KListItem2.default, {
	    style: {
	      padding: 12,
	      overflow: 'auto'
	    },
	    innerDivStyle: { padding: 0 },
	    disabled: !href
	    /* eslint react/no-danger: 0 */
	    , primaryText: type === _DataTypes.HTML ? _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: value } }) : value,
	    secondaryText: label,
	    'data-cy': ID
	  });
	};
	
	DetailListItem.propTypes = {
	  type: _propTypes2.default.string,
	  href: _propTypes2.default.string,
	  ID: _propTypes2.default.string,
	  label: _propTypes2.default.node,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.array])
	};
	
	var _default = DetailListItem;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(DetailListItem, 'DetailListItem', 'D:/a/1/s/src/web/employee/src/components/DetailListItem.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/DetailListItem.js');
	}();

	;

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(67);
	
	var _FileInput = __webpack_require__(881);
	
	var _FileInput2 = _interopRequireDefault(_FileInput);
	
	var _iconSelect = __webpack_require__(295);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _FontIcon = __webpack_require__(83);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _RaisedButton = __webpack_require__(114);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _SelectField = __webpack_require__(271);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(113);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _CircularProgress = __webpack_require__(170);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _reactIntl = __webpack_require__(5);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  paper: {
	    padding: 16,
	    marginBottom: 16,
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    maxWidth: 350,
	    marginLeft: 'auto',
	    marginRight: 'auto'
	  },
	  fileInput: {
	    cursor: 'pointer',
	    position: 'absolute',
	    top: 0,
	    bottom: 0,
	    right: 0,
	    left: 0,
	    width: '100%',
	    opacity: 0
	  }
	};
	
	var validate = function validate(values) {
	  var errors = {};
	
	  if (!values.fileType) {
	    errors.fileType = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.errorType' });
	  }
	
	  if (!values.file) {
	    errors.file = 'NO_FILE';
	  } else if (values.file.size > 11000000) {
	    /* eslint no-underscore-dangle: 0 */
	    errors._error = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.errorSize' });
	  }
	
	  return errors;
	};
	
	var FileUpload = function (_React$Component) {
	  _inherits(FileUpload, _React$Component);
	
	  function FileUpload(props) {
	    _classCallCheck(this, FileUpload);
	
	    var _this = _possibleConstructorReturn(this, (FileUpload.__proto__ || Object.getPrototypeOf(FileUpload)).call(this, props));
	
	    _this.state = {
	      fileName: ''
	    };
	    return _this;
	  }
	
	  _createClass(FileUpload, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var fileName = this.state.fileName;
	      var _props = this.props,
	          handleSubmit = _props.handleSubmit,
	          selectOptions = _props.selectOptions,
	          uploading = _props.uploading,
	          invalid = _props.invalid,
	          error = _props.error;
	
	
	      var options = selectOptions.map(function (_ref) {
	        var FileRepositoryObjectDocumentTypeID = _ref.FileRepositoryObjectDocumentTypeID,
	            Name = _ref.Name;
	        return _react2.default.createElement(_MenuItem2.default, {
	          value: FileRepositoryObjectDocumentTypeID,
	          key: '' + Name + FileRepositoryObjectDocumentTypeID,
	          primaryText: Name,
	          'data-cy': Name
	        });
	      });
	
	      return _react2.default.createElement(
	        'form',
	        { onSubmit: handleSubmit },
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: styles.paper },
	          _react2.default.createElement(
	            _RaisedButton2.default,
	            {
	              fullWidth: true,
	              style: { marginBottom: 8 },
	              label: fileName || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.chooseFile' }),
	              secondary: !fileName,
	              icon: _react2.default.createElement(
	                _FontIcon2.default,
	                { className: 'material-icons' },
	                fileName ? (0, _iconSelect.iconSelect)(fileName) : 'file_upload'
	              ),
	              containerElement: 'label',
	              disabled: uploading
	            },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'file',
	              type: 'file',
	              component: _FileInput2.default,
	              style: styles.fileInput,
	              onChange: function onChange(e, file) {
	                return _this2.setState({ fileName: file ? file.name : '' });
	              }
	            })
	          ),
	          error && _react2.default.createElement(
	            'span',
	            { style: { color: _colors2.default.errorColor } },
	            error
	          ),
	          _react2.default.createElement(_reduxForm.Field, {
	            name: 'fileType',
	            component: function component(_ref2) {
	              var input = _ref2.input,
	                  meta = _ref2.meta;
	              return _react2.default.createElement(
	                _SelectField2.default,
	                _extends({}, input, {
	                  errorText: meta.touched && meta.error,
	                  style: { marginBottom: 16 },
	                  onChange: function onChange(event, index, value) {
	                    return input.onChange(value);
	                  },
	                  hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.fileType' }),
	                  disabled: uploading,
	                  'data-cy': 'select-file-type'
	                }),
	                options
	              );
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: {
	                display: 'flex', alignItems: 'center', width: '100%', justifyContent: 'flex-end'
	              }
	            },
	            uploading && _react2.default.createElement(_CircularProgress2.default, { style: { marginRight: 16, lineHeight: '24px' }, size: 24, thickness: 2 }),
	            _react2.default.createElement(_RaisedButton2.default, {
	              style: { alignSelf: 'flex-end' },
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.save' }),
	              type: 'submit',
	              disabled: uploading || invalid,
	              primary: true,
	              icon: _react2.default.createElement(
	                _FontIcon2.default,
	                { className: 'material-icons' },
	                'save'
	              )
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return FileUpload;
	}(_react2.default.Component);
	
	FileUpload.propTypes = {
	  handleSubmit: _propTypes2.default.func.isRequired,
	  invalid: _propTypes2.default.bool.isRequired,
	  uploading: _propTypes2.default.bool.isRequired,
	  error: _propTypes2.default.object,
	  selectOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    FileRepositoryObjectDocumentTypeID: _propTypes2.default.number,
	    Name: _propTypes2.default.string
	  }))
	};
	
	var _default = (0, _reduxForm.reduxForm)({
	  form: 'fileUpload',
	  validate: validate
	})(FileUpload);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/FileUpload.js');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', 'D:/a/1/s/src/web/employee/src/components/FileUpload.js');
	
	  __REACT_HOT_LOADER__.register(FileUpload, 'FileUpload', 'D:/a/1/s/src/web/employee/src/components/FileUpload.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/FileUpload.js');
	}();

	;

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _KValue = __webpack_require__(283);
	
	var _KValue2 = _interopRequireDefault(_KValue);
	
	var _HolidayEntry = __webpack_require__(1026);
	
	var _HolidayEntry2 = _interopRequireDefault(_HolidayEntry);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _HolidayOverview = __webpack_require__(864);
	
	var _HolidayOverview2 = _interopRequireDefault(_HolidayOverview);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var loadingStyle = {
	  alignItems: 'center',
	  display: 'flex',
	  justifyContent: 'center',
	  marginBottom: 16,
	  marginTop: '40px',
	  padding: 16
	};
	
	var HolidayEntry = function HolidayEntry(props) {
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      expanded = _useState2[0],
	      setExpanded = _useState2[1];
	
	  var toggleExpanded = function toggleExpanded() {
	    setExpanded(!expanded);
	  };
	
	  var FirstOfMai = props.FirstOfMai,
	      Sum = props.Sum,
	      Taken = props.Taken,
	      WorkTimePerDay = props.WorkTimePerDay,
	      showByHour = props.showByHour,
	      Overview = props.Overview,
	      holidayInfo = props.holidayInfo,
	      earnedHolidayInfo = props.earnedHolidayInfo,
	      fetchingByYear = props.fetchingByYear,
	      selectedYear = props.selectedYear,
	      selectComponent = props.selectComponent;
	
	  var earnedHolidayYear = (0, _lodash.get)(earnedHolidayInfo, 'PayWageCollectYear');
	  var allowance = (0, _lodash.get)(earnedHolidayInfo, 'allowance');
	  var earned = (0, _lodash.get)(earnedHolidayInfo, 'Earned', 0);
	  var earnedWorkTimePerDay = (0, _lodash.get)(earnedHolidayInfo, 'WorkTimePerDay', 0);
	
	  var holidayLeft = 0;
	  if (FirstOfMai > Taken) {
	    holidayLeft = (1 - Taken / FirstOfMai) * 100;
	  }
	
	  var holidayCollected = 0;
	  if (allowance > earned) {
	    holidayCollected = earned / allowance * 100;
	  }
	
	  var divider = WorkTimePerDay;
	  var earnedDivider = earnedWorkTimePerDay;
	  var formatId = 'holiday.days';
	  if (showByHour) {
	    divider = 1;
	    earnedDivider = 1;
	    formatId = 'holiday.hours';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: _HolidayEntry2.default.container },
	    _react2.default.createElement(
	      'div',
	      { style: _HolidayEntry2.default.containerItem },
	      selectComponent,
	      fetchingByYear ? _react2.default.createElement(_TLoading2.default, null) : _react2.default.createElement(
	        'div',
	        null,
	        FirstOfMai === undefined ? _react2.default.createElement(_PanelMessage2.default, {
	          type: 'info',
	          iconName: 'info',
	          message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.empty' })
	        }) : _react2.default.createElement(
	          _materialUi.Card,
	          { expanded: expanded, style: { padding: 16, border: 'none', boxShadow: 'none' } },
	          _react2.default.createElement(
	            'div',
	            {
	              style: {
	                color: 'rgba(0, 0, 0, 0.54)',
	                fontSize: 14,
	                textAlign: 'center',
	                marginBottom: 12
	              }
	            },
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'tile.holiday.period',
	              values: { year: selectedYear, nextYear: selectedYear + 1 }
	            })
	          ),
	          _react2.default.createElement(_materialUi.Divider, null),
	          _react2.default.createElement(
	            'div',
	            { style: _HolidayEntry2.default.mainValueContainer },
	            _react2.default.createElement(
	              'div',
	              { style: _HolidayEntry2.default.mainValue },
	              _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: formatId,
	                values: { val: (Sum / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: _HolidayEntry2.default.subtitleValue },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.sum' })
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: _HolidayEntry2.default.chart },
	              _react2.default.createElement('div', { style: _extends({}, _HolidayEntry2.default.chartBar, { width: holidayLeft + '%' }) })
	            )
	          ),
	          _react2.default.createElement('div', null),
	          _react2.default.createElement(_materialUi.Divider, null),
	          _react2.default.createElement(
	            'div',
	            { style: _HolidayEntry2.default.valueContainer },
	            _react2.default.createElement(_KValue2.default, {
	              value: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: formatId,
	                values: { val: (FirstOfMai / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
	              }),
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.firstOfMay', values: { year: selectedYear } })
	            }),
	            _react2.default.createElement(_KValue2.default, {
	              value: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: formatId,
	                values: { val: (Taken / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
	              }),
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.taken', values: { year: selectedYear } })
	            })
	          ),
	          _react2.default.createElement(_materialUi.Divider, null),
	          _react2.default.createElement(_KFlatButton2.default, {
	            style: _HolidayEntry2.default.actionButton,
	            containerStyle: _HolidayEntry2.default.action,
	            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holiday.usedVacation' }),
	            onClick: toggleExpanded,
	            iconName: expanded ? 'expand_less' : 'expand_more'
	          }),
	          _react2.default.createElement(
	            _materialUi.CardText,
	            { expandable: true },
	            _react2.default.createElement(_HolidayOverview2.default, { overview: Overview, divider: divider })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: _HolidayEntry2.default.containerItem },
	      _react2.default.createElement(_KTitle2.default, {
	        style: _HolidayEntry2.default.title,
	        containerStyle: { marginBottom: 18 },
	        subtitleStyle: _HolidayEntry2.default.subtitle,
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, {
	          id: 'holiday.title.year',
	          values: { year: earnedHolidayYear + 1 }
	        })
	      }),
	      _react2.default.createElement(
	        _materialUi.Paper,
	        { zDepth: 0, style: _HolidayEntry2.default.paper },
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              color: 'rgba(0, 0, 0, 0.54)',
	              fontSize: 14,
	              textAlign: 'center',
	              marginBottom: 12
	            }
	          },
	          _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'tile.holiday.period',
	            values: { year: earnedHolidayYear + 1, nextYear: earnedHolidayYear + 2 }
	          })
	        ),
	        _react2.default.createElement(_materialUi.Divider, null),
	        _react2.default.createElement(
	          'div',
	          { style: _HolidayEntry2.default.mainValueContainer },
	          _react2.default.createElement(
	            'div',
	            { style: _HolidayEntry2.default.mainValue },
	            _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: formatId,
	              values: { val: (earned / earnedDivider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: _HolidayEntry2.default.subtitleValue },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.earned1' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: _HolidayEntry2.default.chart },
	            _react2.default.createElement('div', { style: _extends({}, _HolidayEntry2.default.chartBar, { width: holidayCollected + '%' }) })
	          )
	        ),
	        _react2.default.createElement(_materialUi.Divider, null),
	        _react2.default.createElement(
	          'div',
	          { style: _HolidayEntry2.default.valueContainer },
	          _react2.default.createElement(_KValue2.default, {
	            value: _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: formatId,
	              values: { val: (allowance / earnedDivider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
	            }),
	            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.allowance' })
	          }),
	          _react2.default.createElement(_KValue2.default, {
	            value: _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'holiday.hours',
	              values: { val: earnedWorkTimePerDay.toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
	            }),
	            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.workTime' })
	          })
	        )
	      ),
	      holidayInfo && _react2.default.createElement(
	        _materialUi.Paper,
	        { style: loadingStyle },
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: holidayInfo.TextBody } })
	      )
	    )
	  );
	};
	
	HolidayEntry.propTypes = {
	  FirstOfMai: _propTypes2.default.number,
	  Sum: _propTypes2.default.number,
	  Taken: _propTypes2.default.number,
	  WorkTimePerDay: _propTypes2.default.number,
	  showByHour: _propTypes2.default.bool,
	  Overview: _propTypes2.default.object.isRequired,
	  holidayInfo: _propTypes2.default.object,
	  earnedHolidayInfo: _propTypes2.default.object,
	  fetchingByYear: _propTypes2.default.bool.isRequired,
	  selectedYear: _propTypes2.default.number.isRequired,
	  selectComponent: _propTypes2.default.element
	};
	
	HolidayEntry.defaultProps = {
	  Sum: 0
	};
	
	var mapStateToProps = function mapStateToProps(_ref) {
	  var EmployeeHolidayReducer = _ref.EmployeeHolidayReducer;
	  return {
	    holidayInfo: EmployeeHolidayReducer.holidayInfo
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(HolidayEntry);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(loadingStyle, 'loadingStyle', 'D:/a/1/s/src/web/employee/src/components/HolidayEntry.js');
	
	  __REACT_HOT_LOADER__.register(HolidayEntry, 'HolidayEntry', 'D:/a/1/s/src/web/employee/src/components/HolidayEntry.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/components/HolidayEntry.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/HolidayEntry.js');
	}();

	;

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _get = __webpack_require__(96);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _chunk = __webpack_require__(1493);
	
	var _chunk2 = _interopRequireDefault(_chunk);
	
	var _KValue = __webpack_require__(283);
	
	var _KValue2 = _interopRequireDefault(_KValue);
	
	var _Divider = __webpack_require__(172);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HolidayOverview = function HolidayOverview(_ref) {
	  var overview = _ref.overview,
	      divider = _ref.divider;
	
	  var allMonths = ['May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March', 'April'];
	  var chunked = (0, _chunk2.default)(allMonths, 3);
	  var winterAddition = (0, _get2.default)(overview, 'WinterAddition', 0);
	  var winterAdditionFormatted = (winterAddition / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    (0, _map2.default)(chunked, function (months, index) {
	      return _react2.default.createElement(
	        'div',
	        {
	          key: 'row-' + index,
	          style: {
	            paddingBottom: '16px',
	            display: 'flex',
	            flexDirection: 'row',
	            justifyItems: 'space-between'
	          }
	        },
	        (0, _map2.default)(months, function (month) {
	          return _react2.default.createElement(_KValue2.default, {
	            key: 'month-' + month,
	            value: ((0, _get2.default)(overview, month, 0) / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
	            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: month })
	          });
	        })
	      );
	    }),
	    winterAddition > 0 && _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(_Divider2.default, { style: { margin: 12 } }),
	      _react2.default.createElement(_KValue2.default, {
	        key: 'holiday-winterAddition',
	        value: winterAdditionFormatted,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holidayOverview.winterAddition.title' })
	      })
	    )
	  );
	};
	
	HolidayOverview.propTypes = {
	  overview: _propTypes2.default.object.isRequired,
	  divider: _propTypes2.default.number.isRequired
	};
	
	var _default = HolidayOverview;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(HolidayOverview, 'HolidayOverview', 'D:/a/1/s/src/web/employee/src/components/HolidayOverview.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/HolidayOverview.js');
	}();

	;

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  container: {
	    margin: '6px 12px',
	    height: 48,
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    flex: '1 0 auto'
	  },
	  button: {
	    color: 'white',
	    borderRadius: 4,
	    backgroundColor: _colors2.default.mainButton,
	    textDecoration: 'none',
	    outline: 'none',
	    border: 'none',
	    fontWeight: 500,
	    height: '100%',
	    width: '100%',
	    paddingLeft: 24,
	    paddingRight: 24,
	    fontSize: 16,
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    cursor: 'pointer'
	  }
	};
	
	var KButtonLink = function KButtonLink(_ref) {
	  var href = _ref.href,
	      label = _ref.label;
	  return _react2.default.createElement(
	    'div',
	    { style: styles.container },
	    _react2.default.createElement(
	      'a',
	      { style: styles.button, href: href },
	      label
	    )
	  );
	};
	
	KButtonLink.propTypes = {
	  label: _propTypes2.default.node.isRequired,
	  href: _propTypes2.default.string.isRequired
	};
	
	var _default = KButtonLink;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/KJRN/KButtonLink.js');
	
	  __REACT_HOT_LOADER__.register(KButtonLink, 'KButtonLink', 'D:/a/1/s/src/web/employee/src/components/KJRN/KButtonLink.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KButtonLink.js');
	}();

	;

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _dateTools = __webpack_require__(35);
	
	var _helpers = __webpack_require__(457);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  container: {
	    maxWidth: 380,
	    width: '100%',
	    minWidth: 300,
	    borderRadius: 8,
	    margin: '24px 10px',
	    height: 460,
	    display: 'flex',
	    flexDirection: 'column',
	    flex: 1,
	    padding: 36,
	    paddingBottom: 24
	  },
	  action: {
	    minHeight: 40,
	    maxHeight: 40,
	    justifyContent: 'center',
	    flex: '0 1 auto',
	    marginLeft: 0,
	    marginRight: 0
	  },
	  actionButton: {
	    fontSize: 14,
	    maxWidth: 'none',
	    padding: 0,
	    whiteSpace: 'nowrap',
	    color: _colors2.default.titleColor
	  },
	  actionContainer: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    marginTop: 18
	  },
	  divider: {},
	  times: {
	    marginTop: 'auto',
	    marginBottom: 18,
	    display: 'flex',
	    justifyContent: 'space-between'
	  },
	  topContainer: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    alignItems: 'center'
	  },
	  title: {
	    margin: 0,
	    fontSize: 20,
	    fontWeight: 600,
	    marginTop: 18,
	    marginBottom: 18
	  },
	  tagContainer: {
	    display: 'flex',
	    alignItems: 'center'
	  },
	  attending: {
	    alignSelf: 'flex-end',
	    backgroundColor: _colors2.default.successColor,
	    padding: 6,
	    borderRadius: 4,
	    color: 'white'
	  },
	  info: {
	    alignSelf: 'flex-end',
	    backgroundColor: _colors2.default.infoColor,
	    padding: 6,
	    borderRadius: 4,
	    marginLeft: 4,
	    color: 'white'
	  },
	  urgent: {
	    backgroundColor: _colors2.default.warningColor,
	    padding: 6,
	    borderRadius: 4,
	    color: 'white',
	    marginLeft: 4,
	    whiteSpace: 'nowrap'
	  },
	  critical: {
	    backgroundColor: _colors2.default.errorColor,
	    padding: 6,
	    borderRadius: 4,
	    color: 'white',
	    marginLeft: 4,
	    whiteSpace: 'nowrap'
	  },
	  description: {
	    color: _colors2.default.subtitleColor,
	    overflow: 'hidden',
	    maxHeight: 178
	  },
	  type: {
	    paddingTop: 6,
	    paddingBottom: 6,
	    paddingRight: 6,
	    color: _colors2.default.primary1Color
	  }
	};
	
	var KCourse = function (_React$Component) {
	  _inherits(KCourse, _React$Component);
	
	  function KCourse(props) {
	    _classCallCheck(this, KCourse);
	
	    var _this = _possibleConstructorReturn(this, (KCourse.__proto__ || Object.getPrototypeOf(KCourse)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(KCourse, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          useGroup = _props.useGroup,
	          CourseName = _props.CourseName,
	          CourseGroupName = _props.CourseGroupName,
	          CourseTypeName = _props.CourseTypeName,
	          CourseBegda = _props.CourseBegda,
	          CourseHours = _props.CourseHours,
	          CourseDescriptionHtml = _props.CourseDescriptionHtml,
	          attending = _props.attending,
	          actions = _props.actions,
	          Gender = _props.Gender,
	          EmployeeMasterID = _props.EmployeeMasterID,
	          _props$entity = _props.entity,
	          CoursePoints = _props$entity.CoursePoints,
	          CourseAttendees = _props$entity.CourseAttendees,
	          CourseRequiresApproval = _props$entity.CourseRequiresApproval;
	
	
	      var thisWeek = new Date();
	      thisWeek.setDate(thisWeek.getDate() + 5);
	      var tomorrow = new Date();
	      tomorrow.setHours(23, 59, 59);
	      tomorrow.setDate(tomorrow.getDate() + 1);
	      var today = new Date();
	      today.setHours(23, 59, 59);
	      var now = new Date();
	      var startTime = new Date(CourseBegda.entityValue).getTime();
	      var showToday = startTime < today && startTime > now.getTime();
	      var showStarted = startTime < today && startTime < now.getTime() && !showToday;
	      var showTomorrow = startTime < tomorrow.getTime() && !showStarted && !showToday;
	      var showThisWeek = startTime < thisWeek.getTime() && !showStarted && !showTomorrow && !showToday;
	
	      var attendeeMsg = (0, _helpers.getAttendeeMsg)(CourseAttendees, EmployeeMasterID, Gender);
	
	      return _react2.default.createElement(
	        _materialUi.Paper,
	        { style: styles.container, zDepth: 0 },
	        _react2.default.createElement(
	          'div',
	          { style: styles.topContainer },
	          useGroup ? _react2.default.createElement(
	            'div',
	            { style: styles.type },
	            CourseGroupName.value || '-'
	          ) : _react2.default.createElement(
	            'div',
	            { style: styles.type },
	            CourseTypeName.value || '-'
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.tagContainer },
	            CourseRequiresApproval && !attending && _react2.default.createElement(
	              'div',
	              { style: styles.info },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.requiresApproval' })
	            ),
	            attending && _react2.default.createElement(
	              'div',
	              { style: styles.attending },
	              attendeeMsg
	            ),
	            showToday && _react2.default.createElement(
	              'div',
	              { style: styles.urgent },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.today' })
	            ),
	            showStarted && _react2.default.createElement(
	              'div',
	              { style: styles.critical },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.started' })
	            ),
	            showTomorrow && _react2.default.createElement(
	              'div',
	              { style: styles.urgent },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.tomorrow' })
	            ),
	            showThisWeek && _react2.default.createElement(
	              'div',
	              { style: styles.urgent },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.soon' })
	            ),
	            CoursePoints ? _react2.default.createElement(
	              'div',
	              { style: styles.info },
	              CoursePoints
	            ) : null
	          )
	        ),
	        _react2.default.createElement(_KTitle2.default, {
	          style: styles.title,
	          title: CourseName.value
	        }),
	        CourseDescriptionHtml.value ? _react2.default.createElement('div', { style: styles.description, dangerouslySetInnerHTML: { __html: CourseDescriptionHtml.value } }) : _react2.default.createElement(
	          'div',
	          { style: styles.description },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.noDescription' })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.times },
	          _react2.default.createElement(
	            'div',
	            { style: styles.dateTime },
	            (0, _dateTools.dateTime)(CourseBegda.entityValue)
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.length },
	            CourseHours.value
	          )
	        ),
	        _react2.default.createElement(_materialUi.Divider, { style: styles.divider }),
	        _react2.default.createElement(
	          'div',
	          { style: styles.actionContainer },
	          (0, _lodash.map)((0, _lodash.reverse)(actions), function (a, i) {
	            var style = _extends({}, styles.actionButton);
	            if (a.primary) {
	              style.color = _colors2.default.primary1Color;
	            } else if (a.secondary) {
	              style.color = _colors2.default.errorColor;
	            }
	            return _react2.default.createElement(_KFlatButton2.default, {
	              key: i,
	              containerStyle: styles.action,
	              style: style,
	              onClick: a.action,
	              label: a.label,
	              disabled: a.disabled
	            });
	          })
	        )
	      );
	    }
	  }]);
	
	  return KCourse;
	}(_react2.default.Component);
	
	KCourse.propTypes = {
	  attending: _propTypes2.default.bool,
	  CourseName: _propTypes2.default.object,
	  CourseHours: _propTypes2.default.object,
	  useGroup: _propTypes2.default.bool,
	  CourseBegda: _propTypes2.default.object,
	  entity: _propTypes2.default.shape({
	    CoursePoints: _propTypes2.default.number,
	    CourseAttendees: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	    CourseRequiresApproval: _propTypes2.default.bool
	  }),
	  CourseGroupName: _propTypes2.default.object,
	  CourseTypeName: _propTypes2.default.object,
	  CourseDescriptionHtml: _propTypes2.default.object,
	  actions: _propTypes2.default.array,
	  Gender: _propTypes2.default.string.isRequired,
	  EmployeeMasterID: _propTypes2.default.number.isRequired
	};
	
	var _default = KCourse;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/KJRN/KCourse.js');
	
	  __REACT_HOT_LOADER__.register(KCourse, 'KCourse', 'D:/a/1/s/src/web/employee/src/components/KJRN/KCourse.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KCourse.js');
	}();

	;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _KAvatar = __webpack_require__(183);
	
	var _KAvatar2 = _interopRequireDefault(_KAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  container: {
	    display: 'flex',
	    alignItems: 'center',
	    marginTop: 36,
	    marginBottom: 24
	  },
	  title: {
	    fontSize: 28
	  },
	  avatar: {
	    marginLeft: 12,
	    marginRight: 12
	  }
	};
	
	var KHero = function KHero(_ref) {
	  var title = _ref.title,
	      imgSrc = _ref.imgSrc,
	      subtitle = _ref.subtitle,
	      masterId = _ref.masterId;
	  return _react2.default.createElement(
	    'div',
	    { style: styles.container },
	    _react2.default.createElement(_KAvatar2.default, { imgSrc: imgSrc, style: styles.avatar, masterId: masterId }),
	    _react2.default.createElement(_KTitle2.default, { subtitle: subtitle, title: title, style: styles.title })
	  );
	};
	
	KHero.propTypes = {
	  title: _propTypes2.default.node.isRequired,
	  masterId: _propTypes2.default.number,
	  subtitle: _propTypes2.default.node,
	  imgSrc: _propTypes2.default.string
	};
	
	var _default = KHero;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/KJRN/KHero.js');
	
	  __REACT_HOT_LOADER__.register(KHero, 'KHero', 'D:/a/1/s/src/web/employee/src/components/KJRN/KHero.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KHero.js');
	}();

	;

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  tile: {
	    display: 'flex',
	    flexGrow: 1,
	    height: 500,
	    backgroundColor: 'white',
	    borderRadius: 8,
	    width: '100%',
	    overflow: 'auto'
	  },
	  tileContainer: {
	    minWidth: 300,
	    width: '100%',
	    marginTop: 36,
	    marginLeft: 24,
	    marginRight: 24
	  },
	  title: {
	    margin: 0,
	    marginTop: 12,
	    marginBottom: 12,
	    fontWeight: 600
	  }
	};
	
	var KTile = function KTile(_ref) {
	  var title = _ref.title,
	      children = _ref.children,
	      containerStyle = _ref.containerStyle,
	      className = _ref.className,
	      cy = _ref.cy;
	  return _react2.default.createElement(
	    'div',
	    { 'data-cy': cy, className: 'ktile-width' + (className || ''), style: _extends({}, styles.tileContainer, containerStyle) },
	    _react2.default.createElement(_KTitle2.default, { style: styles.title, title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: title }) }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.tile },
	      children
	    )
	  );
	};
	
	KTile.propTypes = {
	  children: _propTypes2.default.node,
	  title: _propTypes2.default.node,
	  containerStyle: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  cy: _propTypes2.default.string
	};
	
	var _default = KTile;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/KJRN/KTile.js');
	
	  __REACT_HOT_LOADER__.register(KTile, 'KTile', 'D:/a/1/s/src/web/employee/src/components/KJRN/KTile.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/KJRN/KTile.js');
	}();

	;

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _RaisedButton = __webpack_require__(114);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageNotFound = function (_React$Component) {
	  _inherits(PageNotFound, _React$Component);
	
	  function PageNotFound(props) {
	    _classCallCheck(this, PageNotFound);
	
	    var _this = _possibleConstructorReturn(this, (PageNotFound.__proto__ || Object.getPrototypeOf(PageNotFound)).call(this, props));
	
	    _this.handleRoute = _this.handleRoute.bind(_this);
	    return _this;
	  }
	
	  _createClass(PageNotFound, [{
	    key: 'handleRoute',
	    value: function handleRoute() {
	      this.context.router.push('/');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _reactFlexboxGrid.Row,
	        { center: 'xs', middle: 'xs', style: { padding: 16 } },
	        _react2.default.createElement(
	          _reactFlexboxGrid.Col,
	          { xs: 12, sm: 6 },
	          _react2.default.createElement(
	            _Paper2.default,
	            null,
	            _react2.default.createElement(
	              _reactFlexboxGrid.Row,
	              { center: 'xs', middle: 'xs' },
	              _react2.default.createElement(
	                _reactFlexboxGrid.Col,
	                { xs: 12, style: { paddingTop: 20, fontSize: 65, fontWeight: 300 } },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  '404'
	                )
	              ),
	              _react2.default.createElement(
	                _reactFlexboxGrid.Col,
	                { xs: 12, style: { paddingBottom: 20, paddingTop: 10 } },
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: 20, fontWeight: 300 } },
	                  '\xDEessi s\xED\xF0a er ekki til!'
	                )
	              ),
	              _react2.default.createElement(
	                _reactFlexboxGrid.Col,
	                { xs: 12, style: { paddingBottom: 20 } },
	                _react2.default.createElement(_RaisedButton2.default, {
	                  secondary: true,
	                  label: 'Heim',
	                  onClick: this.handleRoute
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PageNotFound;
	}(_react2.default.Component);
	
	PageNotFound.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	var _default = PageNotFound;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PageNotFound, 'PageNotFound', 'D:/a/1/s/src/web/employee/src/components/PageNotFound.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/PageNotFound.js');
	}();

	;

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectComponent = function SelectComponent(_ref) {
	  var value = _ref.value,
	      onChange = _ref.onChange,
	      options = _ref.options,
	      _ref$placeholder = _ref.placeholder,
	      placeholder = _ref$placeholder === undefined ? 'Select an option' : _ref$placeholder,
	      _ref$style = _ref.style,
	      style = _ref$style === undefined ? {} : _ref$style,
	      _ref$optionStyle = _ref.optionStyle,
	      optionStyle = _ref$optionStyle === undefined ? {} : _ref$optionStyle,
	      _ref$dropdownStyle = _ref.dropdownStyle,
	      dropdownStyle = _ref$dropdownStyle === undefined ? {} : _ref$dropdownStyle;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      isOpen = _useState2[0],
	      setIsOpen = _useState2[1];
	
	  var selectRef = (0, _react.useRef)(null);
	
	  var isMobile = window.innerWidth <= 768;
	
	  (0, _react.useEffect)(function () {
	    var handleClickOutside = function handleClickOutside(event) {
	      if (selectRef.current && !selectRef.current.contains(event.target)) {
	        setIsOpen(false);
	      }
	    };
	
	    document.addEventListener('mousedown', handleClickOutside);
	    return function () {
	      document.removeEventListener('mousedown', handleClickOutside);
	    };
	  }, []);
	
	  var handleSelectClick = function handleSelectClick() {
	    setIsOpen(!isOpen);
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    if (event.key === 'Enter' || event.key === ' ') {
	      event.preventDefault();
	      setIsOpen(!isOpen);
	    } else if (event.key === 'Escape') {
	      setIsOpen(false);
	    }
	  };
	
	  var handleOptionClick = function handleOptionClick(optionValue) {
	    onChange(optionValue);
	    setIsOpen(false);
	  };
	
	  var selectedOption = options.find(function (option) {
	    return option.value === value;
	  });
	  var displayText = selectedOption ? selectedOption.label : placeholder;
	
	  var defaultSelectStyle = _extends({
	    position: 'relative',
	    display: 'inline-block',
	    minWidth: '328px',
	    backgroundColor: '#fff',
	    border: '1px solid #ccc',
	    borderRadius: '4px',
	    cursor: 'pointer',
	    userSelect: 'none'
	  }, style);
	
	  var selectBoxStyle = {
	    padding: 8,
	    paddingRight: isMobile ? 40 : 35,
	    fontSize: 14,
	    minHeight: isMobile ? '48px' : 'auto',
	    display: 'flex',
	    alignItems: 'center',
	    color: '#333',
	    backgroundColor: '#fff',
	    border: 'none',
	    outline: 'none',
	    width: '100%',
	    boxSizing: 'border-box'
	  };
	
	  var arrowStyle = {
	    position: 'absolute',
	    right: '12px',
	    top: '50%',
	    transform: 'translateY(-50%) ' + (isOpen ? 'rotate(180deg)' : 'rotate(0deg)'),
	    transition: 'transform 0.2s ease',
	    pointerEvents: 'none',
	    width: '0',
	    height: '0',
	    borderLeft: '4px solid transparent',
	    borderRight: '4px solid transparent',
	    borderTop: '6px solid #999'
	  };
	
	  var defaultDropdownStyle = _extends({
	    position: 'absolute',
	    top: '100%',
	    left: '0',
	    right: '0',
	    backgroundColor: '#fff',
	    border: '1px solid #ccc',
	    borderTop: 'none',
	    borderRadius: '0 0 4px 4px',
	    maxHeight: '300px',
	    overflowY: 'auto',
	    zIndex: 1000,
	    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
	  }, dropdownStyle);
	
	  var defaultOptionStyle = _extends({
	    padding: isMobile ? '16px 12px' : '12px 8px',
	    fontSize: isMobile ? '14px' : '14px',
	    minHeight: isMobile ? '48px' : '40px',
	    backgroundColor: '#fff',
	    color: '#333',
	    cursor: 'pointer',
	    borderBottom: '1px solid #f0f0f0',
	    display: 'flex',
	    alignItems: 'center',
	    transition: 'background-color 0.2s ease'
	  }, optionStyle);
	
	  return _react2.default.createElement(
	    'div',
	    { ref: selectRef, style: defaultSelectStyle },
	    _react2.default.createElement(
	      'div',
	      {
	        style: selectBoxStyle,
	        onClick: handleSelectClick,
	        onKeyDown: handleKeyDown,
	        role: 'button',
	        tabIndex: 0
	      },
	      displayText
	    ),
	    _react2.default.createElement('div', { style: arrowStyle }),
	    isOpen && _react2.default.createElement(
	      'div',
	      { style: defaultDropdownStyle },
	      options.map(function (option) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: option.value,
	            style: _extends({}, defaultOptionStyle, {
	              backgroundColor: option.value === value ? '#f5f5f5' : '#fff'
	            }),
	            onClick: function onClick() {
	              return handleOptionClick(option.value);
	            },
	            onKeyDown: function onKeyDown(e) {
	              if (e.key === 'Enter' || e.key === ' ') {
	                e.preventDefault();
	                handleOptionClick(option.value);
	              }
	            },
	            role: 'option',
	            'aria-selected': option.value === value,
	            tabIndex: 0,
	            onMouseEnter: function onMouseEnter(e) {
	              e.target.style.backgroundColor = '#f0f0f0';
	            },
	            onMouseLeave: function onMouseLeave(e) {
	              e.target.style.backgroundColor = option.value === value ? '#f5f5f5' : '#fff';
	            }
	          },
	          option.label
	        );
	      })
	    )
	  );
	};
	
	SelectComponent.propTypes = {
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	  onChange: _propTypes2.default.func.isRequired,
	  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
	    label: _propTypes2.default.string.isRequired
	  })).isRequired,
	  placeholder: _propTypes2.default.string,
	  style: _propTypes2.default.object,
	  optionStyle: _propTypes2.default.object,
	  dropdownStyle: _propTypes2.default.object
	};
	
	var _default = SelectComponent;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SelectComponent, 'SelectComponent', 'D:/a/1/s/src/web/employee/src/components/SelectComponent.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/SelectComponent.js');
	}();

	;

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AppBar = __webpack_require__(584);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	var _MenuItem = __webpack_require__(113);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _FlatButton = __webpack_require__(82);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _FontIcon = __webpack_require__(83);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _IconButton = __webpack_require__(64);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Divider = __webpack_require__(172);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Drawer = __webpack_require__(594);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(54);
	
	var _reactIntl = __webpack_require__(5);
	
	var _findIndex = __webpack_require__(368);
	
	var _findIndex2 = _interopRequireDefault(_findIndex);
	
	var _msalReact = __webpack_require__(419);
	
	var _lodash = __webpack_require__(8);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _getAppraisalTitle = __webpack_require__(148);
	
	var _getAppraisalTitle2 = _interopRequireDefault(_getAppraisalTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  title: {
	    cursor: 'pointer',
	    fontSize: 24,
	    fontWeight: 100
	  },
	  logo: {
	    cursor: 'pointer',
	    backgroundImage: 'url(' + _config.logo + ')',
	    backgroundSize: 'contain',
	    backgroundRepeat: 'no-repeat',
	    height: 50,
	    minWidth: _config.logoWidth
	  },
	  link: {
	    color: '#fff',
	    textDecoration: 'none'
	  },
	  dropdownColor: {
	    color: '#000',
	    textDecoration: 'none',
	    fontWeight: 300
	  },
	  menu: {
	    height: 48,
	    marginTop: 0,
	    minWidth: 60
	  },
	  menuIcon: {
	    color: _colors2.default.appBarTextColor
	  },
	  menuLabel: {
	    fontWeight: 400,
	    fontSize: 16,
	    color: _colors2.default.appBarTextColor
	  },
	  searchFieldInput: {
	    color: _colors2.default.appBarTextColor
	  },
	  searchFieldInputHint: {
	    color: _colors2.default.appBarTextColorHint
	  },
	  searchField: {
	    width: 150
	  },
	  appBar: {
	    backgroundColor: _colors2.default.appBarColor,
	    paddingLeft: 16,
	    paddingRight: 16,
	    position: 'fixed',
	    zIndex: 10000
	  },
	  drawer: {
	    paddingTop: 64
	  }
	};
	
	// IDEA: Add Badge to route to notify user about unfinished items
	var routes = [{ iconName: 'person', to: { pathname: '/me' }, title: 'toolbar.profile' }, {
	  iconName: 'school', to: { pathname: '/events' }, title: 'toolbar.courses', ID: 'Learning'
	}, {
	  iconName: 'search', to: { pathname: '/search' }, title: 'toolbar.search', ID: 'Search'
	}, {
	  iconName: 'account_balance', to: { pathname: '/pay' }, title: 'toolbar.payroll', ID: 'Payroll'
	}, {
	  iconName: 'beach_access', to: { pathname: '/holiday' }, title: 'toolbar.holiday', ID: 'Holiday'
	}, {
	  iconName: 'event_available', to: { pathname: '/vacations' }, title: 'holiday.vacationApprovals', ID: 'VacationApprovals', autoHide: true
	}, {
	  iconName: 'view_list', to: { pathname: '/approvals' }, title: 'dash.title.approvals', ID: 'ApprovalRequests', autoHide: true
	}, {
	  iconName: 'local_atm', to: { pathname: '/payslip' }, title: 'toolbar.payslip', ID: 'PaySlip'
	}, {
	  iconName: 'request_quote', to: { pathname: '/paytickets' }, title: 'dash.title.paytickets', ID: 'PayTicket', autoHide: true
	}, {
	  iconName: 'question_answer', to: { pathname: '/pmappraisals' }, title: 'toolbar.appraisal', ID: 'PM'
	}, {
	  iconName: 'folder_open', to: { pathname: '/files' }, title: 'toolbar.repository', ID: 'Repository'
	}, {
	  iconName: 'edit', to: { pathname: '/agreements' }, title: 'toolbar.agreements', ID: 'Agreements'
	}, {
	  iconName: 'fitness_center', to: { pathname: '/benefits' }, title: 'toolbar.benefits', ID: 'Benefits'
	}, {
	  iconName: 'receipt', to: { pathname: '/grants' }, title: 'toolbar.grants', ID: 'Grants'
	}, {
	  iconName: 'directions_bike', to: { pathname: '/transportation' }, title: 'toolbar.transportationGrants', ID: 'TransportationGrants'
	}, {
	  iconName: 'device_hub', to: { pathname: '/orgchart' }, title: 'toolbar.orgchart', ID: 'OrgChart'
	}, {
	  iconName: 'coffee', to: { pathname: '/teria' }, title: 'teria.title', ID: 'Teria', autoHide: true
	}, {
	  iconName: 'schedule', to: { pathname: '/time' }, title: 'time.title', ID: 'Time', autoHide: true
	}, {
	  iconName: 'group', to: { pathname: '/inOut' }, title: 'inOut.title', ID: 'InOut', autoHide: true
	}, {
	  iconName: 'settings', to: { pathname: '/settings' }, title: 'toolbar.settings', ID: 'Settings'
	}];
	var searchRoute = function searchRoute(query) {
	  return { pathname: '/search', query: { query: query } };
	};
	
	var LogoutItem = function LogoutItem(_ref) {
	  var router = _ref.router,
	      onClose = _ref.onClose;
	
	  var _useMsal = (0, _msalReact.useMsal)(),
	      instance = _useMsal.instance;
	
	  var handleLogout = function handleLogout() {
	    onClose();
	    if (_config.useSSO) {
	      instance.logout();
	    } else {
	      router.push({ pathname: '/account', query: { logout: true } });
	    }
	  };
	
	  return _react2.default.createElement(
	    _MenuItem2.default,
	    {
	      leftIcon: _react2.default.createElement(
	        _FontIcon2.default,
	        { color: _colors2.default.errorColor, className: 'material-icons' },
	        'exit_to_app'
	      ),
	      onClick: handleLogout,
	      style: styles.dropdownColor
	    },
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'toolbar.logout' })
	  );
	};
	
	LogoutItem.propTypes = {
	  router: _propTypes2.default.object.isRequired,
	  onClose: _propTypes2.default.func.isRequired
	};
	
	var Toolbar = function (_Component) {
	  _inherits(Toolbar, _Component);
	
	  function Toolbar(props) {
	    _classCallCheck(this, Toolbar);
	
	    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, props));
	
	    _this.handleClose = function () {
	      return _this.__handleClose__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleOpen = function () {
	      return _this.__handleOpen__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleSearch = function () {
	      return _this.__handleSearch__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleQueryChange = function () {
	      return _this.__handleQueryChange__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleEnter = function () {
	      return _this.__handleEnter__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = {
	      open: false,
	      searchQuery: ''
	    };
	    return _this;
	  }
	
	  _createClass(Toolbar, [{
	    key: '__handleEnter__REACT_HOT_LOADER__',
	    value: function __handleEnter__REACT_HOT_LOADER__() {
	      return this.__handleEnter__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleQueryChange__REACT_HOT_LOADER__',
	    value: function __handleQueryChange__REACT_HOT_LOADER__() {
	      return this.__handleQueryChange__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleSearch__REACT_HOT_LOADER__',
	    value: function __handleSearch__REACT_HOT_LOADER__() {
	      return this.__handleSearch__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleOpen__REACT_HOT_LOADER__',
	    value: function __handleOpen__REACT_HOT_LOADER__() {
	      return this.__handleOpen__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleClose__REACT_HOT_LOADER__',
	    value: function __handleClose__REACT_HOT_LOADER__() {
	      return this.__handleClose__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleClose__REACT_HOT_LOADER__',
	    value: function __handleClose__REACT_HOT_LOADER__() {
	      return this.setState({ open: false });
	    }
	  }, {
	    key: '__handleOpen__REACT_HOT_LOADER__',
	    value: function __handleOpen__REACT_HOT_LOADER__() {
	      return this.setState({ open: true });
	    }
	  }, {
	    key: '__handleSearch__REACT_HOT_LOADER__',
	    value: function __handleSearch__REACT_HOT_LOADER__() {
	      if (this.state.searchQuery) {
	        this.context.router.push(searchRoute(this.state.searchQuery));
	        this.setState({ searchQuery: '' });
	      }
	    }
	  }, {
	    key: '__handleQueryChange__REACT_HOT_LOADER__',
	    value: function __handleQueryChange__REACT_HOT_LOADER__(ev) {
	      return this.setState({ searchQuery: ev.target.value });
	    }
	  }, {
	    key: '__handleEnter__REACT_HOT_LOADER__',
	
	
	    // BUG: Keyboard not hiding after search on iPad/Mobile
	    value: function __handleEnter__REACT_HOT_LOADER__(_ref2) {
	      var keyCode = _ref2.keyCode;
	      return keyCode === 13 && this.handleSearch();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          isAuthenticated = _props.isAuthenticated,
	          valuesByKey = _props.valuesByKey,
	          language = _props.language,
	          requestLanguage = _props.requestLanguage,
	          router = this.context.router,
	          searchQuery = this.state.searchQuery;
	      var path = this.props.routes.slice(-1)[0].path;
	
	      if (!isAuthenticated) {
	        return _react2.default.createElement('div', null);
	      }
	      if (valuesByKey) {
	        var useEvents = (0, _lodash.get)(valuesByKey, ['Use.Events', 'Value']) === 'true';
	        if (useEvents) {
	          var idx = (0, _findIndex2.default)(routes, ['ID', 'Learning']);
	          routes[idx].title = 'toolbar.events';
	          routes[idx].iconName = 'event';
	        }
	        if ((0, _lodash.get)(valuesByKey, ['Appraisal.Title'])) {
	          var customTitle = (0, _getAppraisalTitle2.default)(valuesByKey);
	          var pmIndex = (0, _findIndex2.default)(routes, ['ID', 'PM']);
	          if (pmIndex !== -1) {
	            routes[pmIndex].title = customTitle;
	          }
	          // Use archive version of custom title for old appraisals
	          var oldPmIndex = (0, _findIndex2.default)(routes, ['ID', 'PM']);
	          if (oldPmIndex !== -1 && customTitle !== 'appraisal.title') {
	            routes[oldPmIndex].title = customTitle + '.archive';
	          }
	        }
	        // show correct title if store or cafeteria is not in use
	        var hideStore = (0, _lodash.get)(valuesByKey, ['Hide.Teria.Store', 'Value']) === 'true';
	        var hideCafeteria = (0, _lodash.get)(valuesByKey, ['Hide.Teria.Cafeteria', 'Value']) === 'true';
	        var teriaIndex = (0, _findIndex2.default)(routes, ['ID', 'Teria']);
	        if (hideStore && !hideCafeteria) {
	          routes[teriaIndex].title = 'teria.cafeteria';
	        } else if (!hideStore && hideCafeteria) {
	          routes[teriaIndex].title = 'teria.store';
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'toolbarContainer no-print' },
	        _react2.default.createElement(_AppBar2.default, {
	          style: styles.appBar,
	          titleStyle: { display: 'flex', alignItems: 'center' },
	          title: _react2.default.createElement('div', { style: styles.logo }),
	          onTitleClick: function onTitleClick() {
	            return router.push({ pathname: '/' });
	          },
	          showMenuIconButton: false,
	          iconElementRight: _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', alignItems: 'center', marginLeft: 8 } },
	            path !== 'search' && !(valuesByKey && valuesByKey['Hide.Search'] && valuesByKey['Hide.Search'].Value === 'true') && _react2.default.createElement(
	              'div',
	              { className: 'hide-mobile', style: { display: 'flex', alignItems: 'center' } },
	              _react2.default.createElement(_TextField2.default, {
	                id: 'searchField',
	                hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'toolbar.searchField' }),
	                value: searchQuery,
	                style: styles.searchField,
	                inputStyle: styles.searchFieldInput,
	                hintStyle: styles.searchFieldInputHint,
	                onKeyDown: this.handleEnter,
	                onChange: this.handleQueryChange
	              }),
	              _react2.default.createElement(
	                _IconButton2.default,
	                { iconStyle: styles.menuIcon, onClick: this.handleSearch, iconClassName: 'material-icons' },
	                'search'
	              )
	            ),
	            _react2.default.createElement(_FlatButton2.default, {
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { className: 'hide-mobile', id: 'toolbar.menu' }),
	              labelPosition: 'before',
	              labelStyle: styles.menuLabel,
	              hoverColor: 'transparent',
	              onClick: this.handleOpen,
	              style: styles.menu,
	              'data-cy': 'menu-button',
	              icon: _react2.default.createElement(
	                _FontIcon2.default,
	                { style: styles.menuIcon, className: 'material-icons' },
	                'menu'
	              )
	            })
	          )
	        }),
	        _react2.default.createElement(
	          _Drawer2.default,
	          {
	            docked: false,
	            width: 250,
	            open: this.state.open,
	            openSecondary: true,
	            onRequestChange: function onRequestChange(open) {
	              return _this2.setState({ open: open });
	            },
	            containerStyle: styles.drawer
	          },
	          valuesByKey && (0, _lodash.filter)(routes, function (_ref3) {
	            var ID = _ref3.ID,
	                autoHide = _ref3.autoHide;
	            return !autoHide && (0, _lodash.get)(valuesByKey, ['Hide.' + ID, 'Value']) !== 'true' || autoHide && (0, _lodash.get)(valuesByKey, ['Show.' + ID, 'Value']) === 'true';
	          }).map(function (_ref4, index) {
	            var to = _ref4.to,
	                title = _ref4.title,
	                divider = _ref4.divider,
	                iconName = _ref4.iconName;
	            return _react2.default.createElement(
	              'div',
	              { key: index },
	              divider && _react2.default.createElement(_Divider2.default, null),
	              _react2.default.createElement(
	                _MenuItem2.default,
	                {
	                  leftIcon: iconName && _react2.default.createElement(
	                    _FontIcon2.default,
	                    { className: 'material-icons' },
	                    iconName
	                  ),
	                  onClick: function onClick() {
	                    _this2.handleClose();router.push(to);
	                  },
	                  style: styles.dropdownColor
	                },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: title })
	              )
	            );
	          }),
	          _react2.default.createElement(_Divider2.default, null),
	          _react2.default.createElement(LogoutItem, { router: router, onClose: this.handleClose }),
	          _react2.default.createElement(_Divider2.default, null),
	          _react2.default.createElement(
	            _MenuItem2.default,
	            {
	              leftIcon: _react2.default.createElement(
	                _FontIcon2.default,
	                { className: 'material-icons' },
	                'language'
	              ),
	              onClick: function onClick() {
	                _this2.handleClose();
	                requestLanguage(language === 'en' ? 'is' : 'en');
	              },
	              style: styles.dropdownColor
	            },
	            language === 'en' ? 'Íslenska' : 'English'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Toolbar;
	}(_react.Component);
	
	Toolbar.contextTypes = {
	  router: _propTypes2.default.object.isRequired,
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	Toolbar.propTypes = {
	  isAuthenticated: _propTypes2.default.bool,
	  valuesByKey: _propTypes2.default.object,
	  routes: _propTypes2.default.array,
	  language: _propTypes2.default.string,
	  requestLanguage: _propTypes2.default.func
	};
	
	var _default = Toolbar;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/Toolbar.js');
	
	  __REACT_HOT_LOADER__.register(routes, 'routes', 'D:/a/1/s/src/web/employee/src/components/Toolbar.js');
	
	  __REACT_HOT_LOADER__.register(searchRoute, 'searchRoute', 'D:/a/1/s/src/web/employee/src/components/Toolbar.js');
	
	  __REACT_HOT_LOADER__.register(LogoutItem, 'LogoutItem', 'D:/a/1/s/src/web/employee/src/components/Toolbar.js');
	
	  __REACT_HOT_LOADER__.register(Toolbar, 'Toolbar', 'D:/a/1/s/src/web/employee/src/components/Toolbar.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/Toolbar.js');
	}();

	;

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  toggle: {
	    color: 'rgb(70, 130, 180)',
	    marginLeft: 4,
	    cursor: 'pointer'
	  }
	};
	
	var Truncate = function (_React$Component) {
	  _inherits(Truncate, _React$Component);
	
	  function Truncate(props) {
	    _classCallCheck(this, Truncate);
	
	    var _this = _possibleConstructorReturn(this, (Truncate.__proto__ || Object.getPrototypeOf(Truncate)).call(this, props));
	
	    _this.toggleExpand = function () {
	      return _this.__toggleExpand__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = {
	      expanded: false
	    };
	    return _this;
	  }
	
	  _createClass(Truncate, [{
	    key: '__toggleExpand__REACT_HOT_LOADER__',
	    value: function __toggleExpand__REACT_HOT_LOADER__() {
	      return this.__toggleExpand__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__toggleExpand__REACT_HOT_LOADER__',
	    value: function __toggleExpand__REACT_HOT_LOADER__(e) {
	      e.preventDefault();
	      this.setState({ expanded: !this.state.expanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var expanded = this.state.expanded;
	      var _props = this.props,
	          length = _props.length,
	          message = _props.message;
	
	      if (!message) {
	        return _react2.default.createElement('span', null);
	      }
	      if (message.length < length) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          message
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          message.slice(0, expanded ? undefined : length),
	          expanded ? '' : '...',
	          expanded ? _react2.default.createElement(
	            'div',
	            { onKeyDown: '', tabIndex: '0', role: 'button', style: styles.toggle, href: '', onClick: this.toggleExpand },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Truncate.Less' })
	          ) : _react2.default.createElement(
	            'div',
	            { onKeyDown: '', tabIndex: '0', role: 'button', style: styles.toggle, href: '', onClick: this.toggleExpand },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Truncate.More' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Truncate;
	}(_react2.default.Component);
	
	var _default = Truncate;
	exports.default = _default;
	
	
	Truncate.defaultProps = {
	  length: 300,
	  message: ''
	};
	
	Truncate.propTypes = {
	  length: _propTypes2.default.number,
	  message: _propTypes2.default.string
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/Truncate.js');
	
	  __REACT_HOT_LOADER__.register(Truncate, 'Truncate', 'D:/a/1/s/src/web/employee/src/components/Truncate.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/Truncate.js');
	}();

	;

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _materialUi = __webpack_require__(17);
	
	var _login = __webpack_require__(144);
	
	var _config = __webpack_require__(54);
	
	var _lodash = __webpack_require__(8);
	
	var _reactGoogleRecaptcha = __webpack_require__(1652);
	
	var _reactGoogleRecaptcha2 = _interopRequireDefault(_reactGoogleRecaptcha);
	
	var _settings = __webpack_require__(54);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _reactIntl = __webpack_require__(5);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _KButton = __webpack_require__(146);
	
	var _KButton2 = _interopRequireDefault(_KButton);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _resetPassword = __webpack_require__(425);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  input: {
	    marginTop: 0
	  },
	  divider: {
	    marginTop: 0
	  },
	  cardContent: {
	    paddingTop: 0,
	    paddingRight: 8,
	    paddingLeft: 8
	  },
	  root: {
	    marginTop: 12,
	    marginBottom: 12
	  },
	  message: {
	    textAlign: 'center',
	    padding: 24,
	    textTransform: 'uppercase',
	    fontWeight: 500
	  },
	  sso: {
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    justifyContent: 'center',
	    padding: 16,
	    marginBottom: 16
	  },
	  switch: {
	    textAlign: 'center',
	    marginTop: 32
	  },
	  actions: {
	    display: 'flex',
	    alignItems: 'center',
	    flexWrap: 'wrap'
	  },
	  containerSSO: {
	    marginTop: '10vh',
	    zIndex: 100
	  },
	  container: {
	    marginTop: '5vh',
	    display: 'flex',
	    flexDirection: 'row',
	    maxWidth: 600,
	    width: '100%',
	    flexWrap: 'wrap',
	    zIndex: 100
	  },
	  underlineStyle: {
	    borderColor: _colors2.default.primaryColor1,
	    color: _colors2.default.primaryColor1
	  },
	  titleContainer: {
	    display: 'flex',
	    flex: '1 1 90%',
	    alignItems: 'flex-start',
	    flexDirection: 'column',
	    paddingTop: 10
	  },
	  inputContainer: {
	    display: 'flex',
	    flexDirection: 'column',
	    width: 'calc(100% - 24px)',
	    padding: 12
	  },
	  backContainer: {
	    flex: 1
	  }
	};
	var ForgotPassword = function ForgotPassword(_ref) {
	  var sendRequest = _ref.sendRequest,
	      goBack = _ref.goBack;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      recaptchaToken = _useState2[0],
	      setRecaptchaToken = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      username = _useState4[0],
	      setUsername = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      validationError = _useState6[0],
	      setValidationError = _useState6[1];
	
	  var recaptchaRef = _react2.default.createRef();
	  var onSubmit = function onSubmit() {
	    if ((0, _lodash.isEmpty)(username) || (0, _lodash.isEmpty)(recaptchaToken)) {
	      setValidationError(true);
	    } else {
	      sendRequest({ Username: username, Recaptcha: recaptchaToken });
	      goBack();
	    }
	  };
	  return _react2.default.createElement(
	    'div',
	    { style: styles.container },
	    _react2.default.createElement(
	      'div',
	      { style: styles.titleContainer },
	      _react2.default.createElement(_KButton2.default, {
	        flat: true,
	        buttonStyle: { fontSize: 14 },
	        containerStyle: { height: 32, width: 150, alignSelf: 'flex-end' },
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'back' }),
	        onClick: goBack
	      }),
	      _react2.default.createElement(_KTitle2.default, { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.forgotPassword' }) }),
	      _react2.default.createElement(
	        'div',
	        { style: styles.inputContainer },
	        _react2.default.createElement(_materialUi.TextField, {
	          type: 'text',
	          hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.usernameemail' }),
	          style: styles.root,
	          inputStyle: styles.input,
	          underlineFocusStyle: styles.underlineStyle,
	          autoComplete: 'off',
	          autoCorrect: 'off',
	          onChange: function onChange(e) {
	            return setUsername((0, _lodash.get)(e, 'target.value'));
	          },
	          autoCapitalize: 'off',
	          spellCheck: 'false',
	          fullWidth: true,
	          id: 'username'
	        }),
	        _react2.default.createElement(_reactGoogleRecaptcha2.default, {
	          sitekey: _settings.recaptchaKey,
	          onChange: function onChange(val) {
	            return setRecaptchaToken(val);
	          },
	          ref: recaptchaRef
	        }),
	        _react2.default.createElement(_KButton2.default, {
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'submit' }),
	          containerStyle: { width: 200, alignSelf: 'center', marginTop: '5vh' },
	          onClick: onSubmit
	        }),
	        validationError && _react2.default.createElement(_PanelMessage2.default, {
	          message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'forgotPassword.validationError' }),
	          iconName: 'warning',
	          type: 'warning'
	        })
	      )
	    )
	  );
	};
	
	ForgotPassword.propTypes = {
	  sendRequest: _propTypes2.default.func,
	  goBack: _propTypes2.default.func
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref2) {
	  var languageReducer = _ref2.languageReducer;
	  return _extends({}, languageReducer);
	}, function (dispatch) {
	  return {
	    goBack: function goBack() {
	      return dispatch((0, _login.loginStep)(_config.useSSO ? 'sso' : 'initial'));
	    },
	    sendRequest: function sendRequest(data) {
	      return dispatch((0, _resetPassword.forgotPassword)(data));
	    }
	  };
	})(ForgotPassword);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/account/ForgotPassword.js');
	
	  __REACT_HOT_LOADER__.register(ForgotPassword, 'ForgotPassword', 'D:/a/1/s/src/web/employee/src/components/account/ForgotPassword.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/account/ForgotPassword.js');
	}();

	;

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LinearProgress = __webpack_require__(374);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactRedux = __webpack_require__(12);
	
	var _settings = __webpack_require__(54);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _reactIntl = __webpack_require__(5);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _KButtonLink = __webpack_require__(865);
	
	var _KButtonLink2 = _interopRequireDefault(_KButtonLink);
	
	var _login = __webpack_require__(144);
	
	var _KButton = __webpack_require__(146);
	
	var _KButton2 = _interopRequireDefault(_KButton);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import RaisedButton from 'material-ui/RaisedButton';
	// import FlatButton from 'material-ui/FlatButton';
	// import { CardActions, CardText } from 'material-ui/Card';
	
	// import Paper from 'material-ui/Paper';
	// import Divider from 'material-ui/Divider';
	
	// import { Col } from 'react-flexbox-grid';
	
	// import { apiUrl, useSSO, hideXapLogin } from 'config';
	
	
	var styles = {
	  input: {
	    marginTop: 0
	  },
	  divider: {
	    marginTop: 0
	  },
	  cardContent: {
	    paddingTop: 0,
	    paddingRight: 8,
	    paddingLeft: 8
	  },
	  root: {
	    marginTop: 12
	  },
	  message: {
	    textAlign: 'center',
	    padding: 24,
	    textTransform: 'uppercase',
	    fontWeight: 500
	  },
	  sso: {
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    justifyContent: 'center',
	    padding: 16,
	    marginBottom: 16
	  },
	  switch: {
	    textAlign: 'center',
	    marginTop: 32
	  },
	  actions: {
	    display: 'flex',
	    alignItems: 'center',
	    flexWrap: 'wrap'
	  },
	  containerSSO: {
	    marginTop: '10vh',
	    zIndex: 100
	  },
	  container: {
	    marginTop: '5vh',
	    display: 'flex',
	    flexDirection: 'row',
	    maxWidth: 600,
	    width: '100%',
	    flexWrap: 'wrap',
	    zIndex: 100
	  },
	  underlineStyle: {
	    borderColor: _colors2.default.primaryColor1,
	    color: _colors2.default.primaryColor1
	  },
	  titleContainer: {
	    display: 'flex',
	    flex: '1 1 90%',
	    alignItems: 'flex-start',
	    flexDirection: 'column',
	    paddingTop: 10
	  },
	  inputContainer: {
	    display: 'flex',
	    flexDirection: 'column',
	    width: 'calc(100% - 24px)',
	    padding: 12
	  },
	  backContainer: {
	    flex: 1
	  }
	};
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	    _this.setXapLogin = function () {
	      return _this.__setXapLogin__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.setSSOLogin = function () {
	      return _this.__setSSOLogin__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.forgotPassword = function () {
	      return _this.__forgotPassword__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.loginUser = function () {
	      return _this.__loginUser__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleKeyDown = function () {
	      return _this.__handleKeyDown__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handlePasswordChange = function () {
	      return _this.__handlePasswordChange__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleUsernameChange = function () {
	      return _this.__handleUsernameChange__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: '__handleUsernameChange__REACT_HOT_LOADER__',
	    value: function __handleUsernameChange__REACT_HOT_LOADER__() {
	      return this.__handleUsernameChange__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handlePasswordChange__REACT_HOT_LOADER__',
	    value: function __handlePasswordChange__REACT_HOT_LOADER__() {
	      return this.__handlePasswordChange__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleKeyDown__REACT_HOT_LOADER__',
	    value: function __handleKeyDown__REACT_HOT_LOADER__() {
	      return this.__handleKeyDown__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__loginUser__REACT_HOT_LOADER__',
	    value: function __loginUser__REACT_HOT_LOADER__() {
	      return this.__loginUser__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__forgotPassword__REACT_HOT_LOADER__',
	    value: function __forgotPassword__REACT_HOT_LOADER__() {
	      return this.__forgotPassword__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__setSSOLogin__REACT_HOT_LOADER__',
	    value: function __setSSOLogin__REACT_HOT_LOADER__() {
	      return this.__setSSOLogin__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__setXapLogin__REACT_HOT_LOADER__',
	    value: function __setXapLogin__REACT_HOT_LOADER__() {
	      return this.__setXapLogin__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__setXapLogin__REACT_HOT_LOADER__',
	    value: function __setXapLogin__REACT_HOT_LOADER__() {
	      return this.props.dispatch((0, _login.loginStep)('xap'));
	    }
	  }, {
	    key: '__setSSOLogin__REACT_HOT_LOADER__',
	    value: function __setSSOLogin__REACT_HOT_LOADER__() {
	      return this.props.dispatch((0, _login.loginStep)('sso'));
	    }
	  }, {
	    key: '__forgotPassword__REACT_HOT_LOADER__',
	    value: function __forgotPassword__REACT_HOT_LOADER__() {
	      return this.props.dispatch((0, _login.loginStep)('forgotPassword'));
	    }
	  }, {
	    key: '__loginUser__REACT_HOT_LOADER__',
	    value: function __loginUser__REACT_HOT_LOADER__() {
	      var dispatch = this.props.dispatch,
	          _state = this.state,
	          username = _state.username,
	          password = _state.password;
	
	      dispatch((0, _login.loginUser)(username, encodeURIComponent(password)));
	    }
	  }, {
	    key: '__handleKeyDown__REACT_HOT_LOADER__',
	    value: function __handleKeyDown__REACT_HOT_LOADER__(event) {
	      if (event.key === 'Enter' && event.target.id === 'password') {
	        this.password.blur();
	        this.loginUser();
	      } else if (event.key === 'Enter') {
	        this.password.focus();
	      }
	    }
	  }, {
	    key: '__handlePasswordChange__REACT_HOT_LOADER__',
	    value: function __handlePasswordChange__REACT_HOT_LOADER__(ev) {
	      return this.setState({ password: ev.target.value });
	    }
	  }, {
	    key: '__handleUsernameChange__REACT_HOT_LOADER__',
	    value: function __handleUsernameChange__REACT_HOT_LOADER__(ev) {
	      return this.setState({ username: ev.target.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var handleUsernameChange = this.handleUsernameChange,
	          handlePasswordChange = this.handlePasswordChange,
	          handleKeyDown = this.handleKeyDown,
	          _state2 = this.state,
	          username = _state2.username,
	          password = _state2.password,
	          _props = this.props,
	          sso = _props.sso,
	          ssoLoading = _props.ssoLoading,
	          validationError = _props.validationError,
	          loading = _props.loading,
	          error = _props.error;
	
	      // TODO: Fix error message when no internet and when cannot connect to kjarni
	
	      var errorMessage = error && error.Message === 'The user name or password is incorrect.' ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.wrongPassword' }) : error && error.Message;
	
	      if (ssoLoading) {
	        return _react2.default.createElement(_Loading2.default, null);
	      }
	
	      if (sso) {
	        return _react2.default.createElement(
	          'div',
	          { style: styles.containerSSO },
	          _react2.default.createElement(_KTitle2.default, { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.ssoTitle' }), style: { marginBottom: '5vh' } }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.actions },
	            _react2.default.createElement(_KButtonLink2.default, {
	              href: _settings.apiUrl + '/api/qdata/route?url=' + encodeURIComponent(window.location.origin),
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.loginWindows' })
	            }),
	            !_settings.hideXapLogin && _react2.default.createElement(_KButton2.default, {
	              onClick: this.setXapLogin,
	              flat: true,
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.loginWithXap' })
	            })
	          )
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.container },
	        _settings.useSSO && _react2.default.createElement(
	          'div',
	          { style: styles.backContainer },
	          _react2.default.createElement(
	            _materialUi.IconButton,
	            { onClick: this.setSSOLogin },
	            _react2.default.createElement(
	              _materialUi.FontIcon,
	              { className: 'material-icons' },
	              'arrow_back'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.titleContainer },
	          _react2.default.createElement(_KTitle2.default, { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.title' }) }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.inputContainer },
	            _react2.default.createElement(_materialUi.TextField, {
	              type: 'text',
	              hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.usernameemail' }),
	              style: styles.root,
	              inputStyle: styles.input,
	              value: username || '',
	              onKeyDown: handleKeyDown,
	              onChange: handleUsernameChange,
	              underlineFocusStyle: styles.underlineStyle,
	              autoComplete: 'off',
	              autoCorrect: 'off',
	              autoCapitalize: 'off',
	              spellCheck: 'false',
	              ref: function ref(u) {
	                _this2.username = u;
	              },
	              fullWidth: true,
	              id: 'username'
	            }),
	            _react2.default.createElement(_materialUi.TextField, {
	              type: 'password',
	              hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.password' }),
	              style: styles.root,
	              inputStyle: styles.input,
	              value: password || '',
	              onKeyDown: handleKeyDown,
	              onChange: handlePasswordChange,
	              underlineFocusStyle: styles.underlineStyle,
	              fullWidth: true,
	              ref: function ref(p) {
	                _this2.password = p;
	              },
	              id: 'password'
	            }),
	            !_settings.hideXapLogin && _react2.default.createElement(_KButton2.default, {
	              flat: true,
	              buttonStyle: { fontSize: 14 },
	              containerStyle: { height: 32, width: 150, alignSelf: 'flex-end' },
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.forgotPassword' }),
	              onClick: this.forgotPassword,
	              disabled: ssoLoading || loading
	            }),
	            loading && _react2.default.createElement(_LinearProgress2.default, { mode: 'indeterminate' }),
	            _react2.default.createElement(_KButton2.default, {
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.login' }),
	              disabled: ssoLoading || loading,
	              containerStyle: { width: 200, alignSelf: 'center', marginTop: '5vh' },
	              onClick: this.loginUser
	            }),
	            validationError && validationError.Message && _react2.default.createElement(_PanelMessage2.default, { message: validationError.Message, iconName: 'warning', type: 'warning' }),
	            error && error.Message && _react2.default.createElement(_PanelMessage2.default, { message: errorMessage, iconName: 'error', type: 'error' })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	Login.propTypes = {
	  validationError: _propTypes2.default.object,
	  error: _propTypes2.default.object,
	  loading: _propTypes2.default.bool,
	  ssoLoading: _propTypes2.default.bool,
	  dispatch: _propTypes2.default.func.isRequired,
	  sso: _propTypes2.default.bool
	};
	
	Login.contextTypes = {
	  muiTheme: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	  return _extends({}, state.loginReducer);
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(Login);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/account/Login.js');
	
	  __REACT_HOT_LOADER__.register(Login, 'Login', 'D:/a/1/s/src/web/employee/src/components/account/Login.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/components/account/Login.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/account/Login.js');
	}();

	;

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _language = __webpack_require__(282);
	
	var _materialUi = __webpack_require__(17);
	
	var _index = __webpack_require__(388);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _resetPassword = __webpack_require__(425);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ResetPassword = function ResetPassword(_ref) {
	  var language = _ref.language,
	      changeLang = _ref.changeLang,
	      router = _ref.router,
	      submitRequest = _ref.submitRequest;
	
	  var _useForm = (0, _index.useForm)(),
	      control = _useForm.control,
	      handleSubmit = _useForm.handleSubmit,
	      getValues = _useForm.getValues,
	      errors = _useForm.errors;
	
	  var onSubmit = function onSubmit(_ref2) {
	    var ConfirmPassword = _ref2.ConfirmPassword,
	        NewPassword = _ref2.NewPassword,
	        Username = _ref2.Username;
	
	    var Code = (0, _lodash.get)(router, 'params.code', '');
	    var data = {
	      ConfirmPassword: ConfirmPassword,
	      NewPassword: NewPassword,
	      Username: Username,
	      Code: Code
	    };
	    submitRequest(data);
	    router.push('/account');
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: { maxWidth: 350, margin: 'auto' } },
	    _react2.default.createElement(_KTitle2.default, {
	      style: {
	        marginLeft: 0,
	        display: 'flex',
	        alignItems: 'center',
	        flexDirection: 'row'
	      },
	      title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'pickNewPassword' }),
	      subtitleStyle: { margin: 0, fontSize: 12, lineHeight: '1' },
	      subtitle: _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.pattern' })
	      )
	    }),
	    _react2.default.createElement(
	      'form',
	      null,
	      _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', flexDirection: 'column', marginTop: 24 } },
	        _react2.default.createElement(_index.Controller, {
	          as: _react2.default.createElement(_materialUi.TextField, {
	            fullWidth: true,
	            type: 'input',
	            hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.usernameemail' }),
	            errorText: errors.Username ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : ''
	          }),
	          name: 'Username',
	          control: control,
	          defaultValue: '',
	          style: { marginBottom: 12 },
	          rules: { required: true }
	        }),
	        _react2.default.createElement(_index.Controller, {
	          as: _react2.default.createElement(_materialUi.TextField, {
	            fullWidth: true,
	            type: 'password',
	            hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.password' }),
	            errorText: errors.NewPassword ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.' + (0, _lodash.get)(errors, 'NewPassword.type') }) : ''
	          }),
	          name: 'NewPassword',
	          control: control,
	          defaultValue: '',
	          style: { marginBottom: 12 },
	          rules: {
	            required: true,
	            pattern: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*[^a-zA-Z\d]).{12,}$/
	          }
	        }),
	        _react2.default.createElement(_index.Controller, {
	          as: _react2.default.createElement(_materialUi.TextField, {
	            fullWidth: true,
	            type: 'password',
	            hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.confirmPassword' }),
	            errorText: errors.ConfirmPassword ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.' + (0, _lodash.get)(errors, 'ConfirmPassword.type') }) : ''
	          }),
	          name: 'ConfirmPassword',
	          control: control,
	          defaultValue: '',
	          style: { marginBottom: 12 },
	          rules: {
	            required: true,
	            validate: {
	              matchesPreviousPassword: function matchesPreviousPassword(value) {
	                var _getValues = getValues(),
	                    NewPassword = _getValues.NewPassword;
	
	                return NewPassword === value || 'editPanel.passwordMissmatch';
	              }
	            }
	          }
	        })
	      ),
	      _react2.default.createElement(_materialUi.RaisedButton, {
	        fullWidth: true,
	        style: { marginTop: 16 },
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'submit' }),
	        disabled: !(0, _lodash.isEmpty)(errors),
	        primary: true,
	        onClick: handleSubmit(function (data) {
	          return onSubmit(data);
	        })
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { marginTop: 124, textAlign: 'center' } },
	      _react2.default.createElement(_materialUi.FlatButton, {
	        icon: _react2.default.createElement(
	          _materialUi.FontIcon,
	          { style: { marginRight: 12 }, className: 'material-icons' },
	          'language'
	        ),
	        labelPosition: 'before',
	        onClick: function onClick() {
	          changeLang(language === 'en' ? 'is' : 'en');
	        },
	        label: language === 'en' ? 'Íslenska' : 'English'
	      })
	    )
	  );
	};
	ResetPassword.propTypes = {
	  language: _propTypes2.default.string,
	  changeLang: _propTypes2.default.func,
	  router: _propTypes2.default.object,
	  submitRequest: _propTypes2.default.func
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref3) {
	  var languageReducer = _ref3.languageReducer;
	  return _extends({}, languageReducer);
	}, function (dispatch) {
	  return {
	    submitRequest: function submitRequest(data) {
	      return dispatch((0, _resetPassword.changePassword)(data));
	    },
	    changeLang: function changeLang(language) {
	      return dispatch((0, _language.setLanguage)(language));
	    }
	  };
	})(ResetPassword);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ResetPassword, 'ResetPassword', 'D:/a/1/s/src/web/employee/src/components/account/ResetPassword.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/account/ResetPassword.js');
	}();

	;

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KButton = __webpack_require__(146);
	
	var _KButton2 = _interopRequireDefault(_KButton);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _login = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  input: {
	    marginTop: 0
	  },
	  divider: {
	    marginTop: 24
	  },
	  cardContent: {
	    paddingTop: 0,
	    paddingRight: 8,
	    paddingLeft: 8
	  },
	  root: {
	    marginTop: 12
	  },
	  message: {
	    textAlign: 'center',
	    padding: 24,
	    textTransform: 'uppercase',
	    fontWeight: 500
	  },
	  sso: {
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    justifyContent: 'center',
	    padding: 16,
	    marginBottom: 16
	  },
	  switch: {
	    textAlign: 'center',
	    marginTop: 32
	  },
	  actions: {
	    display: 'flex',
	    alignItems: 'center',
	    flexWrap: 'wrap'
	  },
	  containerSSO: {
	    marginTop: '10vh',
	    zIndex: 100
	  },
	  container: {
	    marginTop: '5vh',
	    display: 'flex',
	    flexDirection: 'row',
	    maxWidth: 600,
	    width: '100%',
	    flexWrap: 'wrap',
	    zIndex: 100
	  },
	  underlineStyle: {
	    borderColor: _colors2.default.primaryColor1,
	    color: _colors2.default.primaryColor1
	  },
	  titleContainer: {
	    display: 'flex',
	    flex: '1 1 90%',
	    alignItems: 'flex-start',
	    flexDirection: 'column',
	    paddingTop: 10
	  },
	  inputContainer: {
	    display: 'flex',
	    flexDirection: 'column',
	    width: 'calc(100% - 24px)',
	    padding: 12
	  },
	  backContainer: {
	    flex: 1
	  }
	};
	
	var TwoFactor = function TwoFactor(_ref) {
	  var loading = _ref.loading,
	      securityCode = _ref.securityCode,
	      login = _ref.login,
	      validationError = _ref.validationError,
	      error = _ref.error;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      appView = _useState2[0],
	      setAppView = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(''),
	      _useState4 = _slicedToArray(_useState3, 2),
	      value = _useState4[0],
	      setValue = _useState4[1];
	
	  var validateInput = function validateInput() {
	    if (appView && value.length !== 10) return false;else if (!appView && value.length !== 7) return false;
	    return true;
	  };
	
	  var handleLogin = function handleLogin() {
	    login(value, appView);
	  };
	  var handleKeyDown = function handleKeyDown(event) {
	    if (event.key === 'Enter') {
	      handleLogin();
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.containerSSO },
	    _react2.default.createElement(_KTitle2.default, { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: appView ? 'account.mobileAppTitle' : 'account.mobileTitle' }), style: { marginBottom: '2vh' } }),
	    _react2.default.createElement(
	      'div',
	      { style: styles.inputContainer },
	      _react2.default.createElement(_materialUi.TextField, {
	        type: 'text',
	        hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: appView ? 'account.ssn' : 'account.phoneNumber' }),
	        style: styles.root,
	        inputStyle: styles.input,
	        value: value || '',
	        onKeyDown: handleKeyDown,
	        onChange: function onChange(e) {
	          return setValue(e.target.value);
	        },
	        underlineFocusStyle: styles.underlineStyle,
	        autoComplete: 'off',
	        autoCorrect: 'off',
	        autoCapitalize: 'off',
	        spellCheck: 'false',
	        fullWidth: true,
	        id: 'phonenumberOrSSN'
	      })
	    ),
	    securityCode && _react2.default.createElement(
	      'div',
	      { style: { fontWeight: 600, textAlign: 'center', marginTop: 16 } },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.securityCode' }),
	      ': ',
	      securityCode
	    ),
	    validationError && validationError.Message && _react2.default.createElement(_PanelMessage2.default, { message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: validationError.Message }), iconName: 'warning', type: 'warning' }),
	    error && _react2.default.createElement(_PanelMessage2.default, { message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: error.Message || 'account.login.error.default' }), iconName: 'error', type: 'error' }),
	    _react2.default.createElement(_KButton2.default, {
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.login' }),
	      disabled: loading,
	      containerStyle: { width: 200, alignSelf: 'center', marginTop: '2vh' },
	      onClick: handleLogin
	    }),
	    loading && _react2.default.createElement(_materialUi.LinearProgress, { mode: 'indeterminate' }),
	    _react2.default.createElement(_KButton2.default, {
	      flat: true,
	      containerStyle: { width: 200, alignSelf: 'center', marginTop: '2vh' },
	      label: appView ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.mobileTitle' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'account.mobileAppButton' }),
	      onClick: function onClick() {
	        return setAppView(!appView);
	      },
	      disabled: loading
	    })
	  );
	};
	
	TwoFactor.propTypes = {
	  validationError: _propTypes2.default.object,
	  error: _propTypes2.default.object,
	  loading: _propTypes2.default.bool,
	  login: _propTypes2.default.func.isRequired,
	  securityCode: _propTypes2.default.string
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref2) {
	  var loginReducer = _ref2.loginReducer;
	  return _extends({}, loginReducer);
	}, function (dispatch) {
	  return {
	    login: function login(identifier, appView) {
	      return dispatch((0, _login.twoFactorLogin)(identifier, appView));
	    }
	  };
	})(TwoFactor);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/account/TwoFactor.js');
	
	  __REACT_HOT_LOADER__.register(TwoFactor, 'TwoFactor', 'D:/a/1/s/src/web/employee/src/components/account/TwoFactor.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/account/TwoFactor.js');
	}();

	;

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(67);
	
	var _EntityCRUD = __webpack_require__(220);
	
	var actionCreators = _interopRequireWildcard(_EntityCRUD);
	
	var _Dialog = __webpack_require__(171);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _FlatButton = __webpack_require__(82);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  container: {
	    marginTop: 14
	  },
	  button: {
	    cursor: 'pointer',
	    userSelect: 'none',
	    outline: 'none',
	    color: _colors2.default.primary1Color
	  }
	};
	
	var AddOpitonInput = function (_React$Component) {
	  _inherits(AddOpitonInput, _React$Component);
	
	  function AddOpitonInput(props) {
	    _classCallCheck(this, AddOpitonInput);
	
	    var _this = _possibleConstructorReturn(this, (AddOpitonInput.__proto__ || Object.getPrototypeOf(AddOpitonInput)).call(this, props));
	
	    _this.onInputChange = function () {
	      return _this.__onInputChange__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.createOption = function () {
	      return _this.__createOption__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.openOptionDialog = function () {
	      return _this.__openOptionDialog__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.closeOptionDialog = function () {
	      return _this.__closeOptionDialog__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = {
	      dialogOpen: false,
	      inputValue: ''
	    };
	    return _this;
	  }
	
	  _createClass(AddOpitonInput, [{
	    key: '__closeOptionDialog__REACT_HOT_LOADER__',
	    value: function __closeOptionDialog__REACT_HOT_LOADER__() {
	      return this.__closeOptionDialog__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__openOptionDialog__REACT_HOT_LOADER__',
	    value: function __openOptionDialog__REACT_HOT_LOADER__() {
	      return this.__openOptionDialog__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__createOption__REACT_HOT_LOADER__',
	    value: function __createOption__REACT_HOT_LOADER__() {
	      return this.__createOption__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__onInputChange__REACT_HOT_LOADER__',
	    value: function __onInputChange__REACT_HOT_LOADER__() {
	      return this.__onInputChange__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__onInputChange__REACT_HOT_LOADER__',
	    value: function __onInputChange__REACT_HOT_LOADER__(ev) {
	      return this.setState({ inputValue: ev.target.value });
	    }
	  }, {
	    key: '__createOption__REACT_HOT_LOADER__',
	    value: function __createOption__REACT_HOT_LOADER__() {
	      var _create;
	
	      var _props = this.props,
	          entity = _props.entity,
	          entityField = _props.entityField,
	          entityForm = _props.entityForm,
	          entityLink = _props.entityLink,
	          onSave = _props.onSave,
	          create = _props.create,
	          inputField = _props.inputField,
	          lookupValue = _props.lookupValue;
	      var inputValue = this.state.inputValue;
	
	      create(entity, (_create = {}, _defineProperty(_create, inputField, inputValue), _defineProperty(_create, entityLink, lookupValue), _create), function (newEntity) {
	        return (0, _reduxForm.change)(entityForm, entityField, newEntity[entity + 'ID'] || 0);
	      });
	      this.closeOptionDialog();
	      onSave && onSave();
	    }
	  }, {
	    key: '__openOptionDialog__REACT_HOT_LOADER__',
	    value: function __openOptionDialog__REACT_HOT_LOADER__() {
	      return this.setState({ dialogOpen: true, inputValue: '' });
	    }
	  }, {
	    key: '__closeOptionDialog__REACT_HOT_LOADER__',
	    value: function __closeOptionDialog__REACT_HOT_LOADER__() {
	      return this.setState({ dialogOpen: false, inputValue: '' });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dialogOpen = _state.dialogOpen,
	          inputValue = _state.inputValue;
	      var label = this.props.label;
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        secondary: true,
	        onClick: this.closeOptionDialog,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'addOption.cancel' })
	      }), _react2.default.createElement(_FlatButton2.default, {
	        primary: true,
	        onClick: this.createOption,
	        disabled: !inputValue.length,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'addOption.add' })
	      })];
	      return _react2.default.createElement(
	        'div',
	        { style: styles.container },
	        _react2.default.createElement(
	          _Dialog2.default,
	          {
	            actions: actions,
	            open: dialogOpen
	          },
	          _react2.default.createElement(_TextField2.default, {
	            onChange: this.onInputChange,
	            value: inputValue,
	            hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'addOption.placeholder', values: { label: label } }),
	            fullWidth: true
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.button, role: 'button', onKeyDown: function onKeyDown() {
	              return null;
	            }, tabIndex: '0', onClick: this.openOptionDialog },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'addOption.action', values: { label: label } })
	        )
	      );
	    }
	  }]);
	
	  return AddOpitonInput;
	}(_react2.default.Component);
	
	AddOpitonInput.propTypes = {
	  label: _propTypes2.default.node.isRequired,
	  entity: _propTypes2.default.string.isRequired,
	  entityField: _propTypes2.default.string,
	  entityForm: _propTypes2.default.string,
	  entityLink: _propTypes2.default.string,
	  inputField: _propTypes2.default.string,
	  lookupValue: _propTypes2.default.any,
	  onSave: _propTypes2.default.func,
	  create: _propTypes2.default.func
	};
	
	var _default = (0, _reactRedux.connect)(function (state, wrapperProps) {
	  // If we have no link to worry about we do not need to fetch a value form the form
	  if (!wrapperProps.entityForm || !wrapperProps.entityLookup) {
	    return {};
	  }
	  var selector = (0, _reduxForm.formValueSelector)(wrapperProps.entityForm);
	  return {
	    lookupValue: selector(state, wrapperProps.entityLookup)
	  };
	}, actionCreators)(AddOpitonInput);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/form/AddOptionInput.js');
	
	  __REACT_HOT_LOADER__.register(AddOpitonInput, 'AddOpitonInput', 'D:/a/1/s/src/web/employee/src/components/form/AddOptionInput.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/form/AddOptionInput.js');
	}();

	;

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Checkbox = __webpack_require__(269);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckboxInput = function CheckboxInput(_ref) {
	  var input = _ref.input,
	      label = _ref.label,
	      disabled = _ref.disabled;
	  return _react2.default.createElement(_Checkbox2.default, _extends({}, input, {
	    label: label
	    /* eslint no-unneeded-ternary: 0 */
	    , checked: input.value ? true : false,
	    onCheck: input.onChange,
	    style: { maxWidth: 320 },
	    iconStyle: { marginRight: 4 },
	    disabled: disabled
	  }));
	};
	
	CheckboxInput.propTypes = {
	  input: _propTypes2.default.object.isRequired,
	  label: _propTypes2.default.node.isRequired,
	  disabled: _propTypes2.default.bool
	};
	
	var _default = CheckboxInput;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(CheckboxInput, 'CheckboxInput', 'D:/a/1/s/src/web/employee/src/components/form/CheckboxInput.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/form/CheckboxInput.js');
	}();

	;

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(811);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint jsx-a11y/label-has-for: 0 */
	
	// import DatePicker from 'react-datepicker';
	
	
	_moment2.default.locale('is');
	
	var styles = {
	  defaultInput: {
	    outline: 'none',
	    border: 'none',
	    fontSize: 16,
	    color: 'rgba(0,0,0,0.83)'
	  }
	};
	
	var DateInput = function (_React$Component) {
	  _inherits(DateInput, _React$Component);
	
	  function DateInput() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, DateInput);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateInput.__proto__ || Object.getPrototypeOf(DateInput)).call.apply(_ref, [this].concat(args))), _this), _this.dateChanged = function () {
	      var _this2;
	
	      return (_this2 = _this).__dateChanged__REACT_HOT_LOADER__.apply(_this2, arguments);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(DateInput, [{
	    key: '__dateChanged__REACT_HOT_LOADER__',
	    value: function __dateChanged__REACT_HOT_LOADER__() {
	      return this.__dateChanged__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'componentWillUpdate',
	
	    // Cleanup before re-render
	    value: function componentWillUpdate() {
	      if (this.dateInput && this.dateInput.hasAttribute('data-has-picker')) {
	        this.dateInput.removeEventListener('change', this.dateChanged);
	      }
	    }
	
	    // If we have a date input and it has a picker attribute bind the event
	
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.dateInput && this.dateInput.hasAttribute('data-has-picker')) {
	        this.dateInput.addEventListener('change', this.dateChanged);
	      }
	    }
	  }, {
	    key: '__dateChanged__REACT_HOT_LOADER__',
	    value: function __dateChanged__REACT_HOT_LOADER__(event) {
	      var value = event.target.value;
	      if (value) {
	        var date = new Date(value);
	        this.props.input.onChange(date ? date.toISOString() : '');
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          input = _props.input,
	          label = _props.label,
	          _props$meta = _props.meta,
	          active = _props$meta.active,
	          error = _props$meta.error,
	          warning = _props$meta.warning,
	          touched = _props$meta.touched,
	          disabled = _props.disabled;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'date-root' },
	        _react2.default.createElement(
	          'label',
	          { htmlFor: input.name, className: 'date-label' },
	          label
	        ),
	        _react2.default.createElement('input', {
	          value: input.value ? input.value.split('T')[0] : undefined,
	          id: input.name,
	          disabled: disabled,
	          type: 'date',
	          style: styles.defaultInput,
	          ref: function ref(inp) {
	            _this3.dateInput = inp;
	          },
	          onChange: this.dateChanged,
	          onBlur: function onBlur() {
	            return input.onBlur();
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement('hr', { className: 'date-underline' }),
	          _react2.default.createElement('hr', { className: 'date-underline-active ' + (active ? 'date-underline-active-scale' : '') }),
	          _react2.default.createElement('hr', { className: 'date-underline-error ' + (touched && (error || warning) ? 'date-underline-active-scale' : '') })
	        ),
	        touched && (error || warning) && _react2.default.createElement(
	          'div',
	          { className: 'date-error-text' },
	          error || warning
	        )
	      );
	    }
	  }]);
	
	  return DateInput;
	}(_react2.default.Component);
	
	DateInput.propTypes = {
	  input: _propTypes2.default.object,
	  label: _propTypes2.default.node.isRequired,
	  meta: _propTypes2.default.object.isRequired,
	  disabled: _propTypes2.default.bool
	};
	
	var _default = DateInput;
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/form/DateInput.js');
	
	  __REACT_HOT_LOADER__.register(DateInput, 'DateInput', 'D:/a/1/s/src/web/employee/src/components/form/DateInput.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/form/DateInput.js');
	}();

	;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmailInput = function EmailInput(_ref) {
	  var input = _ref.input,
	      label = _ref.label,
	      error = _ref.meta.error;
	  return _react2.default.createElement(_TextField2.default, _extends({}, input, {
	    floatingLabelText: label,
	    errorText: error,
	    type: 'email',
	    fullWidth: true
	  }));
	};
	
	EmailInput.defaultProps = {
	  label: ''
	};
	
	EmailInput.propTypes = {
	  input: _propTypes2.default.object.isRequired,
	  meta: _propTypes2.default.object.isRequired,
	  label: _propTypes2.default.node
	};
	
	var _default = EmailInput;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EmailInput, 'EmailInput', 'D:/a/1/s/src/web/employee/src/components/form/EmailInput.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/form/EmailInput.js');
	}();

	;

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var FileInput = function FileInput(_ref) {
	  var input = _ref.input,
	      style = _ref.style;
	
	  var value = input.value,
	      inputProps = _objectWithoutProperties(input, ['value']);
	
	  var handleChange = function handleChange(e) {
	    input.onChange(e.target.files[0] || {});
	  };
	
	  return _react2.default.createElement('input', _extends({}, inputProps, {
	    style: style,
	    type: 'file',
	    onChange: handleChange,
	    onBlur: function onBlur() {}
	  }));
	};
	
	FileInput.propTypes = {
	  input: _propTypes2.default.object,
	  style: _propTypes2.default.object
	};
	
	var _default = FileInput;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FileInput, 'FileInput', 'D:/a/1/s/src/web/employee/src/components/form/FileInput.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/form/FileInput.js');
	}();

	;

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NumberInput = function NumberInput(_ref) {
	  var input = _ref.input,
	      label = _ref.label,
	      _ref$meta = _ref.meta,
	      error = _ref$meta.error,
	      touched = _ref$meta.touched,
	      disabled = _ref.disabled;
	  return _react2.default.createElement(_TextField2.default, _extends({}, input, {
	    floatingLabelText: label,
	    errorText: touched && error,
	    type: 'number',
	    fullWidth: true,
	    disabled: disabled
	  }));
	};
	
	NumberInput.propTypes = {
	  input: _propTypes2.default.object,
	  meta: _propTypes2.default.object.isRequired,
	  label: _propTypes2.default.node.isRequired,
	  disabled: _propTypes2.default.bool
	};
	
	var _default = NumberInput;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(NumberInput, 'NumberInput', 'D:/a/1/s/src/web/employee/src/components/form/NumberInput.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/form/NumberInput.js');
	}();

	;

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PhoneInput = function PhoneInput(_ref) {
	  var input = _ref.input,
	      label = _ref.label,
	      error = _ref.meta.error,
	      disabled = _ref.disabled;
	  return _react2.default.createElement(_TextField2.default, _extends({}, input, {
	    floatingLabelText: label,
	    errorText: error,
	    fullWidth: true,
	    type: 'tel',
	    disabled: disabled
	  }));
	};
	
	PhoneInput.defaultProps = {
	  label: ''
	};
	
	PhoneInput.propTypes = {
	  input: _propTypes2.default.object.isRequired,
	  meta: _propTypes2.default.object.isRequired,
	  label: _propTypes2.default.node,
	  disabled: _propTypes2.default.bool
	};
	
	var _default = PhoneInput;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PhoneInput, 'PhoneInput', 'D:/a/1/s/src/web/employee/src/components/form/PhoneInput.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/form/PhoneInput.js');
	}();

	;

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SelectField = __webpack_require__(271);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	var _MenuItem = __webpack_require__(113);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectInput = function (_React$Component) {
	  _inherits(SelectInput, _React$Component);
	
	  function SelectInput(props) {
	    _classCallCheck(this, SelectInput);
	
	    var _this = _possibleConstructorReturn(this, (SelectInput.__proto__ || Object.getPrototypeOf(SelectInput)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(SelectInput, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          input = _props.input,
	          label = _props.label,
	          _props$meta = _props.meta,
	          error = _props$meta.error,
	          touched = _props$meta.touched,
	          warning = _props$meta.warning,
	          options = _props.options,
	          hintText = _props.hintText,
	          disabled = _props.disabled;
	
	      return !options || !options.length ? _react2.default.createElement('div', null) : _react2.default.createElement(
	        _SelectField2.default,
	        _extends({}, input, {
	          hintText: hintText,
	          ref: function ref(s) {
	            _this2.select = s;
	          },
	          floatingLabelText: label,
	          errorText: touched && (error || warning),
	          onChange: function onChange(e, i, v) {
	            return input.onChange(v, i, v);
	          },
	          onBlur: function onBlur() {
	            return null;
	          },
	          value: input.value,
	          fullWidth: true,
	          disabled: disabled
	        }),
	        options.map(function (o, i) {
	          return _react2.default.createElement(_MenuItem2.default, { value: o.value, primaryText: o.label, key: i });
	        })
	      );
	    }
	  }]);
	
	  return SelectInput;
	}(_react2.default.Component);
	
	SelectInput.defaultProps = {
	  hintText: '',
	  label: ''
	};
	
	SelectInput.propTypes = {
	  input: _propTypes2.default.object.isRequired,
	  meta: _propTypes2.default.object.isRequired,
	  label: _propTypes2.default.node,
	  options: _propTypes2.default.array.isRequired,
	  hintText: _propTypes2.default.node,
	  disabled: _propTypes2.default.bool
	};
	
	var _default = SelectInput;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SelectInput, 'SelectInput', 'D:/a/1/s/src/web/employee/src/components/form/SelectInput.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/form/SelectInput.js');
	}();

	;

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Table = __webpack_require__(273);
	
	var _FontIcon = __webpack_require__(83);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _FlatButton = __webpack_require__(82);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  button: {
	    minWidth: 0
	  },
	  buttonColumn: {}
	};
	
	var PanelTableRow = function PanelTableRow(props) {
	  var item = props.item,
	      columnStyle = props.columnStyle;
	
	  return _react2.default.createElement(
	    _Table.TableRow,
	    null,
	    item.fields.map(function (k) {
	      return _react2.default.createElement(
	        _Table.TableRowColumn,
	        {
	          key: k,
	          style: _extends({}, columnStyle, item[k].style)
	        },
	        item[k].value
	      );
	    }),
	    item.actions && _react2.default.createElement(
	      _Table.TableRowColumn,
	      { style: columnStyle },
	      item.actions && item.actions.map(function (a, i) {
	        var icon = a.iconName ? _react2.default.createElement(
	          _FontIcon2.default,
	          { className: 'material-icons' },
	          a.iconName
	        ) : null;
	        return _react2.default.createElement(_FlatButton2.default, {
	          primary: !a.secondary && a.primary,
	          secondary: a.secondary && !a.primary,
	          key: i,
	          onClick: a.action,
	          disabled: a.disabled,
	          style: styles.button,
	          label: a.label,
	          icon: icon
	        });
	      })
	    )
	  );
	};
	
	PanelTableRow.propTypes = {
	  item: _propTypes2.default.object.isRequired,
	  columnStyle: _propTypes2.default.object
	};
	
	PanelTableRow.defaultProps = {
	  columnStyle: {}
	};
	
	var _default = PanelTableRow;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/components/panels/PanelTableRow.js');
	
	  __REACT_HOT_LOADER__.register(PanelTableRow, 'PanelTableRow', 'D:/a/1/s/src/web/employee/src/components/panels/PanelTableRow.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/panels/PanelTableRow.js');
	}();

	;

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _careerReducer = __webpack_require__(437);
	
	var _career = __webpack_require__(852);
	
	var _EditPanel = __webpack_require__(147);
	
	var _EditPanel2 = _interopRequireDefault(_EditPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Career = function Career(_ref) {
	  var loaded = _ref.loaded,
	      dispatch = _ref.dispatch,
	      careerData = _ref.careerData,
	      showErrorMessage = _ref.showErrorMessage,
	      errorMessage = _ref.errorMessage,
	      EmployeeMasterID = _ref.EmployeeMasterID;
	  return _react2.default.createElement(_EditPanel2.default, {
	    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'career.title' }),
	    emptyText: 'career.empty',
	    loaded: loaded,
	    showErrorMessage: showErrorMessage,
	    errorMessage: errorMessage,
	    onOpen: function onOpen() {
	      return dispatch((0, _career.fetchCareerIfNeeded)());
	    },
	    modelName: 'EmployeeMasterCareer',
	    dataSource: careerData,
	    mapModel: _careerReducer.mapCareer,
	    EmployeeMasterID: EmployeeMasterID,
	    fetchData: _career.fetchCareer
	  });
	};
	
	function mapStateToProps(state) {
	  return {
	    loaded: state.careerReducer.loaded,
	    form: state.form.EmployeeMasterCareer,
	    careerData: state.careerReducer.careerData,
	    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
	    showErrorMessage: (state.careerReducer.error && state.careerReducer.error.Message.length) > 0,
	    errorMessage: state.educationReducer.error && state.educationReducer.error.Message || ''
	  };
	}
	
	Career.propTypes = {
	  loaded: _propTypes2.default.bool,
	  dispatch: _propTypes2.default.func.isRequired,
	  careerData: _propTypes2.default.array,
	  showErrorMessage: _propTypes2.default.bool,
	  errorMessage: _propTypes2.default.string,
	  EmployeeMasterID: _propTypes2.default.number
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(Career);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Career, 'Career', 'D:/a/1/s/src/web/employee/src/components/profile/Career.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/components/profile/Career.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/profile/Career.js');
	}();

	;

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _certificateReducer = __webpack_require__(438);
	
	var _certificate = __webpack_require__(853);
	
	var _EditPanel = __webpack_require__(147);
	
	var _EditPanel2 = _interopRequireDefault(_EditPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Certificate = function Certificate(_ref) {
	  var loaded = _ref.loaded,
	      dispatch = _ref.dispatch,
	      certificateData = _ref.certificateData,
	      showErrorMessage = _ref.showErrorMessage,
	      errorMessage = _ref.errorMessage,
	      EmployeeMasterID = _ref.EmployeeMasterID;
	  return _react2.default.createElement(_EditPanel2.default, {
	    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'certificate.title' }),
	    emptyText: 'certificate.empty',
	    loaded: loaded,
	    showErrorMessage: showErrorMessage,
	    errorMessage: errorMessage,
	    onOpen: function onOpen() {
	      return dispatch((0, _certificate.fetchCertificateIfNeeded)());
	    },
	    modelName: 'EmployeeMasterCertificate',
	    dataSource: certificateData,
	    mapModel: _certificateReducer.mapCertificate,
	    EmployeeMasterID: EmployeeMasterID,
	    fetchData: _certificate.fetchCertificate
	  });
	};
	
	function mapStateToProps(state) {
	  return {
	    loaded: state.certificateReducer.loaded,
	    certificateData: state.certificateReducer.certificateData,
	    form: state.form.EmployeeMasterCertificate,
	    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
	    showErrorMessage: (state.certificateReducer.error && state.certificateReducer.error.Message.length) > 0,
	    errorMessage: state.educationReducer.error && state.educationReducer.error.Message || ''
	  };
	}
	
	Certificate.propTypes = {
	  loaded: _propTypes2.default.bool,
	  dispatch: _propTypes2.default.func.isRequired,
	  certificateData: _propTypes2.default.array,
	  showErrorMessage: _propTypes2.default.bool,
	  errorMessage: _propTypes2.default.string,
	  EmployeeMasterID: _propTypes2.default.number
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(Certificate);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Certificate, 'Certificate', 'D:/a/1/s/src/web/employee/src/components/profile/Certificate.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/components/profile/Certificate.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/profile/Certificate.js');
	}();

	;

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _educationReducer = __webpack_require__(440);
	
	var _education = __webpack_require__(854);
	
	var _EditPanel = __webpack_require__(147);
	
	var _EditPanel2 = _interopRequireDefault(_EditPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Education = function Education(_ref) {
	  var educationData = _ref.educationData,
	      showErrorMessage = _ref.showErrorMessage,
	      errorMessage = _ref.errorMessage,
	      loaded = _ref.loaded,
	      EmployeeMasterID = _ref.EmployeeMasterID,
	      dispatch = _ref.dispatch;
	  return _react2.default.createElement(_EditPanel2.default, {
	    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.title' }),
	    emptyText: 'education.empty',
	    loaded: loaded,
	    showErrorMessage: showErrorMessage,
	    errorMessage: errorMessage,
	    onOpen: function onOpen() {
	      return dispatch((0, _education.fetchEducationIfNeeded)());
	    },
	    modelName: 'EmployeeMasterEducation',
	    dataSource: educationData,
	    mapModel: _educationReducer.mapEducation,
	    EmployeeMasterID: EmployeeMasterID,
	    fetchData: _education.fetchEducation
	  });
	};
	
	function mapStateToProps(state) {
	  return {
	    loaded: state.educationReducer.loaded,
	    educationData: state.educationReducer.educationData,
	    form: state.form.EmployeeMasterEducation,
	    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
	    showErrorMessage: (state.educationReducer.error && state.educationReducer.error.Message.length) > 0,
	    errorMessage: state.educationReducer.error && state.educationReducer.error.Message || ''
	  };
	}
	
	Education.propTypes = {
	  loaded: _propTypes2.default.bool,
	  dispatch: _propTypes2.default.func.isRequired,
	  educationData: _propTypes2.default.array,
	  showErrorMessage: _propTypes2.default.bool,
	  errorMessage: _propTypes2.default.string,
	  EmployeeMasterID: _propTypes2.default.number
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(Education);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Education, 'Education', 'D:/a/1/s/src/web/employee/src/components/profile/Education.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/components/profile/Education.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/profile/Education.js');
	}();

	;

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(12);
	
	var _valuesByKey = __webpack_require__(92);
	
	var _KTabs = __webpack_require__(223);
	
	var _KTabs2 = _interopRequireDefault(_KTabs);
	
	var _KTab = __webpack_require__(222);
	
	var _KTab2 = _interopRequireDefault(_KTab);
	
	var _Certificate = __webpack_require__(887);
	
	var _Certificate2 = _interopRequireDefault(_Certificate);
	
	var _Qualification = __webpack_require__(896);
	
	var _Qualification2 = _interopRequireDefault(_Qualification);
	
	var _EmployeeMasterCourses = __webpack_require__(893);
	
	var _EmployeeMasterCourses2 = _interopRequireDefault(_EmployeeMasterCourses);
	
	var _Education = __webpack_require__(888);
	
	var _Education2 = _interopRequireDefault(_Education);
	
	var _Career = __webpack_require__(886);
	
	var _Career2 = _interopRequireDefault(_Career);
	
	var _ObjectsonLoan = __webpack_require__(895);
	
	var _ObjectsonLoan2 = _interopRequireDefault(_ObjectsonLoan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeBottonTabs = function EmployeeBottonTabs(_ref) {
	  var valuesByKey = _ref.valuesByKey;
	
	  var notHide = function notHide(key) {
	    return (0, _valuesByKey.shouldNotHide)(valuesByKey, key);
	  };
	
	  return _react2.default.createElement(
	    _KTabs2.default,
	    null,
	    notHide('EmployeeMasterEducation') && _react2.default.createElement(
	      _KTab2.default,
	      { name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.title' }) },
	      _react2.default.createElement(_Education2.default, null)
	    ),
	    notHide('EmployeeMasterCertificate') && _react2.default.createElement(
	      _KTab2.default,
	      { name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'certificate.title' }) },
	      _react2.default.createElement(_Certificate2.default, null)
	    ),
	    notHide('EmployeeMasterCareer') && _react2.default.createElement(
	      _KTab2.default,
	      { name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'career.title' }) },
	      _react2.default.createElement(_Career2.default, null)
	    ),
	    notHide('EmployeeMasterQualification') && _react2.default.createElement(
	      _KTab2.default,
	      { name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qualification.title' }) },
	      _react2.default.createElement(_Qualification2.default, null)
	    ),
	    notHide('EmployeeMasterCourse') && _react2.default.createElement(
	      _KTab2.default,
	      { name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.title' }) },
	      _react2.default.createElement(_EmployeeMasterCourses2.default, null)
	    ),
	    notHide('EmployeeMasterObjectOnLoan') && _react2.default.createElement(
	      _KTab2.default,
	      { name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loan.title' }) },
	      _react2.default.createElement(_ObjectsonLoan2.default, null)
	    )
	  );
	};
	
	EmployeeBottonTabs.propTypes = {
	  valuesByKey: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    valuesByKey: state.WebValuesReducer.valuesByKey
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(EmployeeBottonTabs);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EmployeeBottonTabs, 'EmployeeBottonTabs', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeBottonTabs.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeBottonTabs.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeBottonTabs.js');
	}();

	;

/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable jsx-a11y/interactive-supports-focus */
	/* eslint-disable jsx-a11y/click-events-have-key-events */
	
	
	var _templateObject = _taggedTemplateLiteral([','], [',']),
	    _templateObject2 = _taggedTemplateLiteral([' '], [' ']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(12);
	
	var _materialUi = __webpack_require__(17);
	
	var _translations = __webpack_require__(1037);
	
	var _DetailList = __webpack_require__(221);
	
	var _DetailList2 = _interopRequireDefault(_DetailList);
	
	var _Files = __webpack_require__(117);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var fix = { overflow: 'visible' }; // fix material-ui https://my.origo.is/browse/APPAIL-7744
	
	var EmployeeCompanyConnectionTable = function EmployeeCompanyConnectionTable(_ref) {
	  var employeeCompanyConnection = _ref.employeeCompanyConnection,
	      valuesByKey = _ref.valuesByKey,
	      language = _ref.language;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      FileReducer = _useSelector.FileReducer;
	
	  var fileById = FileReducer.fileById;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      fileName = _useState2[0],
	      setFileName = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      isSharePoint = _useState4[0],
	      setIsSharePoint = _useState4[1];
	
	  var EmployeeDetailID = employeeCompanyConnection.EmployeeDetailID,
	      EmployeeGroup = employeeCompanyConnection.EmployeeGroup,
	      EmployeeGroupName = employeeCompanyConnection.EmployeeGroupName,
	      EmployeeStatus = employeeCompanyConnection.EmployeeStatus,
	      EmployeeStatusName = employeeCompanyConnection.EmployeeStatusName,
	      ManagerName = employeeCompanyConnection.ManagerName,
	      OrgCompanyName = employeeCompanyConnection.OrgCompanyName,
	      OrgCompanyPositionAlternativeName = employeeCompanyConnection.OrgCompanyPositionAlternativeName,
	      OrgCompanyPositionName = employeeCompanyConnection.OrgCompanyPositionName,
	      OrgCompanyUnitDivisionName = employeeCompanyConnection.OrgCompanyUnitDivisionName,
	      OrgCompanyUnitName = employeeCompanyConnection.OrgCompanyUnitName,
	      OrgLocationMain = employeeCompanyConnection.OrgLocationMain,
	      OrgLocationSub = employeeCompanyConnection.OrgLocationSub,
	      JobDescriptionDocumentID = employeeCompanyConnection.JobDescriptionDocumentID;
	
	
	  var showJobDescription = function showJobDescription() {
	    if (isSharePoint) {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'a',
	          {
	            target: '_blank',
	            rel: 'noopener noreferrer',
	            href: JobDescriptionDocumentID,
	            style: { display: 'flex', alignItems: 'center', color: _colors2.default.primary1Color }
	          },
	          fileName,
	          _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _materialUi.FontIcon,
	              {
	                className: 'material-icons',
	                style: { marginLeft: 5 }
	              },
	              ' launch'
	            )
	          )
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      'div',
	      {
	        role: 'button',
	        onClick: function onClick() {
	          (0, _Files.download)(fileById);
	        },
	        style: { display: 'flex', alignItems: 'center', cursor: 'pointer' }
	      },
	      _react2.default.createElement(
	        'span',
	        {
	          style: { color: _colors2.default.primary1Color, textDecoration: 'underline' }
	        },
	        '' + fileById.Name + fileById.Extension
	      ),
	      _react2.default.createElement(
	        _materialUi.FontIcon,
	        {
	          className: 'material-icons',
	          style: { marginLeft: 5 }
	        },
	        ' file_download'
	      )
	    );
	  };
	
	  (0, _react.useEffect)(function () {
	    if (JobDescriptionDocumentID !== null) {
	      var decoded = decodeURI(JobDescriptionDocumentID);
	      var splitted = decoded.split('/');
	
	      if (splitted[0] === 'https:' || splitted[0] === 'http:') {
	        var noArguments = splitted[splitted.length - 1].split('?');
	        setFileName(noArguments[0]);
	        setIsSharePoint(true);
	      } else {
	        dispatch((0, _Files.getFileById)(JobDescriptionDocumentID));
	        var docName = '' + fileById.Name + fileById.Extension;
	
	        setFileName(docName);
	        setIsSharePoint(false);
	      }
	    }
	  }, [dispatch]);
	
	  var items = [{
	    label: _react2.default.createElement(
	      'div',
	      { style: fix, 'data-cy': 'EmployeeDetailOrg.OrgCompanyName' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.org.company' })
	    ),
	    value: OrgCompanyName,
	    ID: 'EmployeeDetailOrg.OrgCompanyName'
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.org.division' })
	    ),
	    value: OrgCompanyUnitDivisionName,
	    ID: 'EmployeeDetailOrg.OrgCompanyUnitDivisionName'
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.org.unit' })
	    ),
	    value: OrgCompanyUnitName,
	    ID: 'EmployeeDetailOrg.OrgCompanyUnitName'
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.org.position' })
	    ),
	    value: OrgCompanyPositionName,
	    ID: 'EmployeeDetailOrg.OrgCompanyPositionName'
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.org.positionAlt' })
	    ),
	    value: OrgCompanyPositionAlternativeName,
	    ID: 'EmployeeDetailOrg.OrgCompanyPositionAlternativeName'
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.org.location' })
	    ),
	    value: OrgLocationSub ? OrgLocationMain + ', ' + OrgLocationSub : OrgLocationMain,
	    ID: 'EmployeeDetailOrg.OrgLocationMain'
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.org.manager' })
	    ),
	    value: ManagerName,
	    ID: 'EmployeeDetailOrg.ManagerName'
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.org.status' })
	    ),
	    value: language === 'is' ? EmployeeStatusName : (0, _translations.getEmployeeStatus)(EmployeeStatus),
	    ID: 'EmployeeDetailOrg.EmployeeStatusName'
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.org.group' })
	    ),
	    value: language === 'is' ? EmployeeGroupName : (0, _translations.getEmployeeGroup)(EmployeeGroup),
	    ID: 'EmployeeDetailOrg.EmployeeGroupName'
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.org.employeeDetailID' })
	    ),
	    value: EmployeeDetailID,
	    ID: 'EmployeeDetailOrg.EmployeeDetailID'
	  }];
	
	  var shouldShowJobDescription = valuesByKey['Show.EmployeeDetailOrg.JobDescription'];
	  if (shouldShowJobDescription !== undefined) {
	    if (shouldShowJobDescription.Value === 'true') {
	      items.push({
	        label: _react2.default.createElement(
	          'div',
	          { style: fix },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.org.jobDescription' })
	        ),
	        value: JobDescriptionDocumentID !== null && showJobDescription(),
	        ID: 'EmployeeDetailOrg.JobDescription'
	      });
	    }
	  }
	
	  var costCenterConfig = valuesByKey['Show.EmployeeDetailOrg.OrgCompanyCostCenter'];
	  if (costCenterConfig && costCenterConfig.Value) {
	    var costCenterIDs = (0, _lodash.map)(costCenterConfig.Value.split(_templateObject), _lodash.trim);
	    items.push({
	      label: _react2.default.createElement(
	        'div',
	        { style: fix },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.org.costCenter' })
	      ),
	      value: (0, _lodash.map)(costCenterIDs, function (x) {
	        return employeeCompanyConnection['OrgCompanyCostCenter' + x];
	      }).join(_templateObject2)
	    });
	  }
	
	  var show = function show(key) {
	    return (0, _lodash.get)(valuesByKey, ['Hide.' + key, 'Value']) !== 'true';
	  };
	
	  var dataSource = items.filter(function (x) {
	    return x.value && show(x.ID);
	  });
	
	  return _react2.default.createElement(_DetailList2.default, {
	    containerStyle: {
	      flexFlow: 'row wrap',
	      justifyContent: 'space-between'
	    },
	    dataSource: dataSource
	  });
	};
	
	EmployeeCompanyConnectionTable.propTypes = {
	  employeeCompanyConnection: _propTypes2.default.object.isRequired,
	  language: _propTypes2.default.string.isRequired,
	  valuesByKey: _propTypes2.default.object.isRequired
	};
	
	var _default = EmployeeCompanyConnectionTable;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fix, 'fix', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeCompanyConnectionTable.js');
	
	  __REACT_HOT_LOADER__.register(EmployeeCompanyConnectionTable, 'EmployeeCompanyConnectionTable', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeCompanyConnectionTable.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeCompanyConnectionTable.js');
	}();

	;

/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _lodash = __webpack_require__(8);
	
	var _KTabs = __webpack_require__(223);
	
	var _KTabs2 = _interopRequireDefault(_KTabs);
	
	var _KTab = __webpack_require__(222);
	
	var _KTab2 = _interopRequireDefault(_KTab);
	
	var _EmployeeCompanyConnectionTable = __webpack_require__(890);
	
	var _EmployeeCompanyConnectionTable2 = _interopRequireDefault(_EmployeeCompanyConnectionTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeCompanyConnectionsTabs = function EmployeeCompanyConnectionsTabs(_ref) {
	  var employeeDetailOrgList = _ref.employeeDetailOrgList,
	      language = _ref.language,
	      valuesByKey = _ref.valuesByKey;
	  return _react2.default.createElement(
	    _KTabs2.default,
	    null,
	    (0, _lodash.map)(employeeDetailOrgList, function (obj, i) {
	      return _react2.default.createElement(
	        _KTab2.default,
	        { style: { padding: 12 }, key: i, name: obj.OrgCompanyPositionName },
	        _react2.default.createElement(_EmployeeCompanyConnectionTable2.default, {
	          employeeCompanyConnection: obj,
	          valuesByKey: valuesByKey,
	          language: language
	        })
	      );
	    })
	  );
	};
	
	EmployeeCompanyConnectionsTabs.propTypes = {
	  employeeDetailOrgList: _propTypes2.default.array.isRequired,
	  valuesByKey: _propTypes2.default.object.isRequired,
	  language: _propTypes2.default.string.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var languageReducer = _ref2.languageReducer,
	      profileReducer = _ref2.profileReducer,
	      WebValuesReducer = _ref2.WebValuesReducer;
	  return {
	    language: languageReducer.language,
	    valuesByKey: WebValuesReducer.valuesByKey,
	    employeeDetailOrgList: profileReducer.employeeDetailOrgList
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(EmployeeCompanyConnectionsTabs);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EmployeeCompanyConnectionsTabs, 'EmployeeCompanyConnectionsTabs', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeCompanyConnectionsTabs.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeCompanyConnectionsTabs.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeCompanyConnectionsTabs.js');
	}();

	;

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	// import { custom } from 'utils/Api';
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactModal = __webpack_require__(391);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _PostCodes = __webpack_require__(1031);
	
	var _PostCodes2 = _interopRequireDefault(_PostCodes);
	
	var _genders = __webpack_require__(456);
	
	var _genders2 = _interopRequireDefault(_genders);
	
	var _valuesByKey = __webpack_require__(92);
	
	var _RootForm = __webpack_require__(429);
	
	var _RootForm2 = _interopRequireDefault(_RootForm);
	
	var _Alert = __webpack_require__(145);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _EntityCRUD = __webpack_require__(220);
	
	var CRUDActions = _interopRequireWildcard(_EntityCRUD);
	
	var _profile = __webpack_require__(118);
	
	var _InputTypes = __webpack_require__(91);
	
	var _IdentificationCard = __webpack_require__(894);
	
	var _IdentificationCard2 = _interopRequireDefault(_IdentificationCard);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var childControlers = {}; // must be out of the function scope
	var ctl = {};
	
	function validate(values) {
	  var errors = {};
	
	  if (values.Email && !/^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i.test(values.Email)) {
	    errors.Email = 'Netfang er ekki gilt';
	  }
	
	  if (values.PhoneNumberMobile && !/^\+?[0-9,-?,.?,(?,)?]{7,}$/i.test(values.PhoneNumberMobile)) {
	    errors.PhoneNumberMobile = 'Símanúmer er ekki gilt';
	  }
	
	  return errors;
	}
	
	var mapChildFields = function mapChildFields(child) {
	  return {
	    fields: [{
	      type: _InputTypes.TEXT_FIELD,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.child.name' }),
	      name: 'ChildName',
	      value: child.ChildName
	    }, {
	      type: _InputTypes.NUMBER_FIELD,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.child.birthYear' }),
	      name: 'Birthyear',
	      value: child.Birthyear
	    }, {
	      type: _InputTypes.SELECT_ENUM,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.child.gender' }),
	      name: 'GenderType',
	      value: child.GenderType,
	      options: [{
	        value: 0,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.gender.unknown' })
	      }, {
	        value: 1,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.gender.male' })
	      }, {
	        value: 2,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.gender.female' })
	      }]
	    }],
	    Entity: child
	  };
	};
	
	var EmployeeEditForm = function EmployeeEditForm(_ref) {
	  var employeeGeneral = _ref.employeeGeneral,
	      language = _ref.language,
	      valuesByKey = _ref.valuesByKey,
	      controller = _ref.controller,
	      dispatch = _ref.dispatch;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      open = _useState2[0],
	      setOpen = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(false),
	      _useState4 = _slicedToArray(_useState3, 2),
	      secondOpen = _useState4[0],
	      setSecondOpen = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      thirdOpen = _useState6[0],
	      setThirdOpen = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      alertOpen = _useState8[0],
	      setAlertOpen = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      refreshData = _useState10[0],
	      setRefreshData = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(employeeGeneral.EmployeeMasterChildren || []),
	      _useState12 = _slicedToArray(_useState11, 2),
	      masterChildren = _useState12[0],
	      setMasterChildren = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      alertText = _useState14[0],
	      setAlertText = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(),
	      _useState16 = _slicedToArray(_useState15, 2),
	      alertAction = _useState16[0],
	      setAlertAction = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(employeeGeneral.IdentificationCard || ''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      identification = _useState18[0],
	      setIdentification = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      changedIdentification = _useState20[0],
	      setChangedIdentification = _useState20[1];
	  // const [postCodes, setPostCodes] = useState({});
	
	
	  var editIdentification = (0, _lodash.get)(valuesByKey, ['Edit.EmployeeMaster.IdentificationCard', 'Value']) === 'true';
	
	  // useEffect(() => {
	  //   custom({
	  //     url: '/kjarni/api/v2/SysPostalCodes',
	  //     method: 'GET',
	  //     headers: { Authorization: `Bearer ${token}` },
	  //   }).then(({ data }) => {
	  //     const mapped = {};
	  //     const records = (data.value || data)
	  //       .filter(r => !employeeGeneral.LegalCountry || r.SysCountryID === employeeGeneral.LegalCountry);
	  //     records.forEach(({ PostalCode, PostalCodeName }) => {
	  //       mapped[PostalCode] = PostalCodeName;
	  //     });
	  //     setPostCodes(mapped);
	  //   }).catch(() => { });
	  // }, []);
	
	  var openDialog = function openDialog() {
	    return setOpen(true);
	  };
	  var closeDialog = function closeDialog() {
	    return setOpen(false);
	  };
	  var openSecondDialog = function openSecondDialog() {
	    setSecondOpen(true);
	    setRefreshData(false);
	  };
	  var openThirdDialog = function openThirdDialog() {
	    setThirdOpen(true);
	    setRefreshData(false);
	  };
	  var closeSecondDialog = function closeSecondDialog() {
	    setOpen(false);
	    setSecondOpen(false);
	    setAlertOpen(false);
	    setMasterChildren(employeeGeneral.EmployeeMasterChildren || []);
	    if (refreshData) dispatch((0, _profile.fetchEmployeeMaster)());
	  };
	  var shouldCloseSecond = function shouldCloseSecond() {
	    // Check if any of the child forms is dirty
	    var oneIsDirty = (0, _lodash.map)(masterChildren, function (c, i) {
	      return childControlers[i].isDirty();
	    }).reduce(function (x, y) {
	      return x || y;
	    }, false);
	    if (oneIsDirty) {
	      setAlertOpen(true);
	      setAlertText(_react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.alert' }));
	      setAlertAction(closeSecondDialog);
	    } else {
	      closeSecondDialog();
	    }
	  };
	
	  var onKeyPress = function onKeyPress(event) {
	    if (event.keyCode === 27) {
	      if (open) {
	        closeDialog();
	      } else if (secondOpen) {
	        shouldCloseSecond();
	      }
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    window.addEventListener('keydown', onKeyPress);
	    controller({
	      editProfile: openDialog,
	      editFamily: openSecondDialog,
	      editRelative: openThirdDialog
	    });
	
	    return function () {
	      window.removeEventListener('keydown', onKeyPress);
	    };
	  });
	
	  var save = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (!ctl.isInvalid()) {
	                _context.next = 2;
	                break;
	              }
	
	              return _context.abrupt('return');
	
	            case 2:
	              if (changedIdentification) {
	                dispatch((0, _profile.patchIdentificationCard)({ IdentificationCard: identification, EmployeeDetailID: employeeGeneral.EmployeeDetailID }, employeeGeneral.EmployeeDetailID));
	                setChangedIdentification(false);
	              }
	              ctl.save();
	              closeDialog();
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function save() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  var closeAlert = function closeAlert() {
	    return setAlertOpen(false);
	  };
	
	  var addChild = function addChild() {
	    var EmployeeMasterID = employeeGeneral.EmployeeMasterID;
	
	    setMasterChildren([].concat(_toConsumableArray(masterChildren), [{ EmployeeMasterID: EmployeeMasterID }]));
	  };
	
	  var removeChild = function removeChild(EmployeeMasterChild, index) {
	    if (EmployeeMasterChild) {
	      dispatch(CRUDActions.remove('EmployeeMasterChild', _extends({}, EmployeeMasterChild)));
	    }
	    setMasterChildren((0, _lodash.filter)(masterChildren, function (c, i) {
	      return i !== index;
	    }));
	    setRefreshData(true);
	  };
	
	  var secondSave = function secondSave(id, i) {
	    if (childControlers[i].isInvalid()) {
	      return;
	    }
	    id ? childControlers[i].save() : childControlers[i].create();
	  };
	
	  var saveAll = function saveAll() {
	    (0, _lodash.map)(masterChildren, function (c, i) {
	      return secondSave(c.EmployeeMasterChildID, i);
	    });
	    closeSecondDialog();
	  };
	
	  var Address = employeeGeneral.Address,
	      PostCode = employeeGeneral.PostCode,
	      RelativeName = employeeGeneral.RelativeName,
	      RelativeAssociation = employeeGeneral.RelativeAssociation,
	      RelativePhoneNumber = employeeGeneral.RelativePhoneNumber,
	      RelativeName2 = employeeGeneral.RelativeName2,
	      RelativeAssociation2 = employeeGeneral.RelativeAssociation2,
	      RelativePhoneNumber2 = employeeGeneral.RelativePhoneNumber2,
	      RelativePhoneNumberMobile = employeeGeneral.RelativePhoneNumberMobile,
	      RelativePhoneNumberMobile2 = employeeGeneral.RelativePhoneNumberMobile2,
	      RelativeEmail = employeeGeneral.RelativeEmail,
	      RelativeEmail2 = employeeGeneral.RelativeEmail2,
	      RelativeAddress = employeeGeneral.RelativeAddress,
	      RelativeAddress2 = employeeGeneral.RelativeAddress2,
	      Email = employeeGeneral.Email,
	      PhoneNumberHome = employeeGeneral.PhoneNumberHome,
	      PhoneNumberMobile = employeeGeneral.PhoneNumberMobile,
	      Entity = employeeGeneral.Entity,
	      GenderType = employeeGeneral.GenderType,
	      PhoneNumberMobileCountryCode = employeeGeneral.PhoneNumberMobileCountryCode,
	      Tetra = employeeGeneral.Tetra;
	
	  var secondCardActions = [];
	
	  if ((0, _valuesByKey.shouldEdit)(valuesByKey, 'EmployeeMaster')) {
	    secondCardActions.push(_react2.default.createElement(_materialUi.RaisedButton, {
	      key: '1',
	      primary: true,
	      onClick: openDialog,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.editProfile' }),
	      labelStyle: { fontSize: 12 }
	    }));
	  }
	
	  if ((0, _valuesByKey.shouldEdit)(valuesByKey, 'EmployeeMasterChild') && (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMasterChild')) {
	    secondCardActions.push(_react2.default.createElement(_materialUi.RaisedButton, {
	      key: '2',
	      primary: true,
	      onClick: openSecondDialog,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.editChildren' }),
	      labelStyle: { fontSize: 12 }
	    }));
	  }
	  if ((0, _valuesByKey.shouldEdit)(valuesByKey, 'Relative') && (0, _valuesByKey.shouldNotHide)(valuesByKey, 'Relative')) {
	    secondCardActions.push(_react2.default.createElement(_materialUi.RaisedButton, {
	      key: '3',
	      primary: true,
	      onClick: openThirdDialog,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relative' }),
	      labelStyle: { fontSize: 12 }
	    }));
	  }
	
	  var actions = [_react2.default.createElement(_materialUi.RaisedButton, {
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'alert.cancel' }),
	    onClick: closeDialog,
	    style: { marginRight: 8 }
	  }), _react2.default.createElement(_materialUi.RaisedButton, {
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.save' }),
	    primary: true,
	    onClick: save
	  })];
	
	  var secondActions = [_react2.default.createElement(_materialUi.RaisedButton, {
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'alert.cancel' }),
	    onClick: closeSecondDialog
	  }), _react2.default.createElement(_materialUi.RaisedButton, {
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.saveclose' }),
	    primary: true,
	    onClick: saveAll,
	    style: { marginLeft: 8 }
	  })];
	  var thirdActions = [_react2.default.createElement(_materialUi.RaisedButton, {
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'alert.cancel' }),
	    onClick: function onClick() {
	      return setThirdOpen(false);
	    },
	    style: { marginRight: 8 }
	  }), _react2.default.createElement(_materialUi.RaisedButton, {
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.save' }),
	    primary: true,
	    onClick: save
	  })];
	
	  var relativeAssociationOptions = [{ value: null, label: '' }, { value: 0, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAssociation.unknown' }) }, { value: 1, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAssociation.spouse' }) }, { value: 2, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAssociation.parent' }) }, { value: 3, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAssociation.sibling' }) }, { value: 4, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAssociation.relative' }) }, { value: 5, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAssociation.other' }) }];
	
	  var allFields = [{
	    type: _InputTypes.SELECT_ENUM,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.gender' }),
	    name: 'GenderType',
	    value: GenderType,
	    options: (0, _lodash.map)(Object.entries(_genders2.default[language]), function (_ref3) {
	      var _ref4 = _slicedToArray(_ref3, 2),
	          value = _ref4[0],
	          label = _ref4[1];
	
	      return {
	        value: Number(value),
	        label: label
	      };
	    })
	  }, {
	    type: _InputTypes.TEXT_FIELD,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.addressStreet' }),
	    name: 'Address',
	    value: Address
	  }, {
	    type: _InputTypes.SELECT_ENUM,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.addressPlace' }),
	    name: 'PostCode',
	    value: PostCode,
	    // options: map(Object.entries(Object.keys(postCodes).length ? postCodes : PostCodes), ([value, label]) => ({
	    //   value,
	    //   label: `${value} ${label}`,
	    // })),
	    options: (0, _lodash.map)(Object.entries(_PostCodes2.default), function (_ref5) {
	      var _ref6 = _slicedToArray(_ref5, 2),
	          value = _ref6[0],
	          label = _ref6[1];
	
	      return {
	        value: value,
	        label: value + ' ' + label
	      };
	    })
	  }, {
	    type: _InputTypes.EMAIL,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.email' }),
	    name: 'Email',
	    value: Email
	  }, {
	    type: _InputTypes.PHONE,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.countryCode.mobile' }),
	    name: 'PhoneNumberMobileCountryCode',
	    value: PhoneNumberMobileCountryCode
	  }, {
	    type: _InputTypes.PHONE,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.mobile' }),
	    name: 'PhoneNumberMobile',
	    value: PhoneNumberMobile
	  }, {
	    type: _InputTypes.PHONE,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.tetra' }),
	    name: 'Tetra',
	    value: Tetra
	  }, {
	    type: _InputTypes.PHONE,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.phone' }),
	    name: 'PhoneNumberHome',
	    value: PhoneNumberHome
	  }];
	  var relativeFields = [{
	    type: _InputTypes.TEXT_FIELD,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeName' }),
	    name: 'RelativeName',
	    value: RelativeName
	  }, {
	    type: _InputTypes.PHONE,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativePhone' }),
	    name: 'RelativePhoneNumber',
	    value: RelativePhoneNumber
	  }, {
	    type: _InputTypes.PHONE,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativePhoneMobile' }),
	    name: 'RelativePhoneNumberMobile',
	    value: RelativePhoneNumberMobile
	  }, {
	    type: _InputTypes.SELECT_ENUM,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeRelation' }),
	    name: 'RelativeAssociation',
	    value: RelativeAssociation,
	    options: relativeAssociationOptions
	  }, {
	    type: _InputTypes.EMAIL,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeEmail' }),
	    name: 'RelativeEmail',
	    value: RelativeEmail
	  }, {
	    type: _InputTypes.TEXT_FIELD,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAddress' }),
	    name: 'RelativeAddress',
	    value: RelativeAddress
	  }];
	  var relative2Fields = [{
	    type: _InputTypes.TEXT_FIELD,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeName' }),
	    name: 'RelativeName2',
	    value: RelativeName2
	  }, {
	    type: _InputTypes.PHONE,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativePhone' }),
	    name: 'RelativePhoneNumber2',
	    value: RelativePhoneNumber2
	  }, {
	    type: _InputTypes.PHONE,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativePhoneMobile' }),
	    name: 'RelativePhoneNumberMobile2',
	    value: RelativePhoneNumberMobile2
	  }, {
	    type: _InputTypes.SELECT_ENUM,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeRelation' }),
	    name: 'RelativeAssociation2',
	    value: RelativeAssociation2,
	    options: relativeAssociationOptions
	  }, {
	    type: _InputTypes.EMAIL,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeEmail' }),
	    name: 'RelativeEmail2',
	    value: RelativeEmail2
	  }, {
	    type: _InputTypes.TEXT_FIELD,
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAddress' }),
	    name: 'RelativeAddress2',
	    value: RelativeAddress2
	  }];
	
	  var filteredFields = (0, _lodash.filter)(allFields, function (field) {
	    return field.name === 'PhoneNumberMobileCountryCode' ? (0, _valuesByKey.shouldEdit)(valuesByKey, 'EmployeeMaster.PhoneNumberMobile') : (0, _valuesByKey.shouldEdit)(valuesByKey, 'EmployeeMaster.' + field.name);
	  });
	
	  var childFields = (0, _lodash.map)(masterChildren, mapChildFields);
	
	  var modalStyles = {
	    content: {
	      top: '10%',
	      left: '20%',
	      right: '20%',
	      padding: 20
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactModal2.default,
	      {
	        isOpen: open,
	        style: modalStyles
	      },
	      _react2.default.createElement(
	        'div',
	        { style: { height: '65vh', minWidth: '50vw', marginBottom: editIdentification === true ? 30 : 0 } },
	        _react2.default.createElement(
	          _materialUi.IconButton,
	          {
	            style: { margin: -12, float: 'right' },
	            iconClassName: 'material-icons',
	            onClick: closeDialog
	          },
	          'close'
	        ),
	        _react2.default.createElement(_RootForm2.default, {
	          formName: 'EmployeeMaster',
	          fields: filteredFields,
	          initialValues: Entity,
	          provideController: function provideController(x) {
	            ctl = x;
	          },
	          dataFetch: _profile.fetchEmployeeMaster,
	          validate: validate
	        }),
	        editIdentification === true && _react2.default.createElement(_IdentificationCard2.default, {
	          identification: identification,
	          setIdentification: setIdentification,
	          setChangedIdentification: setChangedIdentification
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: { marginTop: 20, marginBottom: 20, float: 'right' } },
	          actions
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactModal2.default,
	      {
	        style: modalStyles,
	        isOpen: secondOpen
	      },
	      _react2.default.createElement(
	        'div',
	        { style: { height: '65vh', minWidth: '50vw' } },
	        _react2.default.createElement(
	          _materialUi.IconButton,
	          {
	            style: { margin: -12, float: 'right' },
	            iconClassName: 'material-icons',
	            onClick: shouldCloseSecond
	          },
	          'close'
	        ),
	        _react2.default.createElement(_Alert2.default, {
	          open: alertOpen,
	          onOk: alertAction,
	          onCancel: closeAlert,
	          text: alertText
	        }),
	        (0, _lodash.map)(childFields, function (c, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i, style: { marginBottom: 48 } },
	            _react2.default.createElement(_RootForm2.default, {
	              formName: 'EmployeeMasterChild' + i,
	              entityName: 'EmployeeMasterChild',
	              fields: c.fields,
	              initialValues: c.Entity,
	              provideController: function provideController(x) {
	                childControlers[i] = x;
	              },
	              dataFetch: childFields.length === i + 1 ? _profile.fetchEmployeeMaster : null
	            }),
	            _react2.default.createElement(_materialUi.FlatButton, {
	              secondary: true,
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.delete' }),
	              onClick: function onClick() {
	                return removeChild(c.Entity, i);
	              },
	              style: { float: 'right' }
	            })
	          );
	        }),
	        _react2.default.createElement(_materialUi.FlatButton, {
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.add' }),
	          primary: true,
	          onClick: addChild
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 20, marginTop: 20, float: 'right' } },
	          secondActions
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _reactModal2.default,
	      {
	        style: modalStyles,
	        isOpen: thirdOpen
	      },
	      _react2.default.createElement(
	        'div',
	        { style: { height: '65vh', minWidth: '50vw' } },
	        _react2.default.createElement(
	          _materialUi.IconButton,
	          {
	            style: { margin: -12, float: 'right' },
	            iconClassName: 'material-icons',
	            onClick: function onClick() {
	              return setThirdOpen(false);
	            }
	          },
	          'close'
	        ),
	        _react2.default.createElement(_Alert2.default, {
	          open: alertOpen,
	          onOk: alertAction,
	          onCancel: closeAlert,
	          text: alertText
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: { fontSize: 16, fontWeight: 600 } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relative' })
	        ),
	        _react2.default.createElement(_RootForm2.default, {
	          formName: 'EmployeeMaster',
	          fields: relativeFields,
	          initialValues: Entity,
	          provideController: function provideController(x) {
	            ctl = x;
	          },
	          dataFetch: _profile.fetchEmployeeMaster,
	          validate: validate
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: { marginTop: 32, fontSize: 16, fontWeight: 600 } },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relative2' })
	        ),
	        _react2.default.createElement(_RootForm2.default, {
	          formName: 'EmployeeMaster',
	          fields: relative2Fields,
	          initialValues: Entity,
	          provideController: function provideController(x) {
	            ctl = x;
	          },
	          dataFetch: _profile.fetchEmployeeMaster,
	          validate: validate
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: { marginTop: 20, marginBottom: 20, float: 'right' } },
	          thirdActions
	        )
	      )
	    )
	  );
	};
	
	EmployeeEditForm.propTypes = {
	  employeeGeneral: _propTypes2.default.object.isRequired,
	  valuesByKey: _propTypes2.default.object,
	  dispatch: _propTypes2.default.func,
	  controller: _propTypes2.default.func,
	  language: _propTypes2.default.string
	  // token: PropTypes.string,
	};
	
	var mapStateToProps = function mapStateToProps(_ref7) {
	  var languageReducer = _ref7.languageReducer,
	      profileReducer = _ref7.profileReducer,
	      WebValuesReducer = _ref7.WebValuesReducer;
	  return {
	    language: languageReducer.language,
	    employeeGeneral: profileReducer.employeeMaster,
	    valuesByKey: WebValuesReducer.valuesByKey
	    // token: loginReducer.user.token,
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(EmployeeEditForm);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(childControlers, 'childControlers', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeEditForm.js');
	
	  __REACT_HOT_LOADER__.register(ctl, 'ctl', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeEditForm.js');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeEditForm.js');
	
	  __REACT_HOT_LOADER__.register(mapChildFields, 'mapChildFields', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeEditForm.js');
	
	  __REACT_HOT_LOADER__.register(EmployeeEditForm, 'EmployeeEditForm', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeEditForm.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeEditForm.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeEditForm.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _coursesReducer = __webpack_require__(439);
	
	var _courses = __webpack_require__(281);
	
	var _EditPanel = __webpack_require__(147);
	
	var _EditPanel2 = _interopRequireDefault(_EditPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeMasterCourses = function EmployeeMasterCourses(_ref) {
	  var employeeMasterCoursesData = _ref.employeeMasterCoursesData,
	      showErrorMessage = _ref.showErrorMessage,
	      errorMessage = _ref.errorMessage,
	      loaded = _ref.loaded,
	      EmployeeMasterID = _ref.EmployeeMasterID,
	      dispatch = _ref.dispatch;
	  return _react2.default.createElement(_EditPanel2.default, {
	    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'course.title' }),
	    emptyText: 'course.empty',
	    loaded: loaded,
	    showErrorMessage: showErrorMessage,
	    errorMessage: errorMessage,
	    onOpen: function onOpen() {
	      return dispatch((0, _courses.fetchEmployeeMasterCoursesIfNeeded)());
	    },
	    modelName: 'EmployeeMasterCourse',
	    dataSource: employeeMasterCoursesData,
	    mapModel: _coursesReducer.mapEmplyeeCourses,
	    EmployeeMasterID: EmployeeMasterID,
	    fetchData: _courses.fetchEmployeeMasterCourses,
	    initSort: 'CoursePeriodBegda'
	  });
	};
	
	function mapStateToProps(state) {
	  return {
	    loaded: state.coursesReducer.employeeMasterCoursesLoaded,
	    employeeMasterCoursesData: state.coursesReducer.employeeMasterCoursesData,
	    form: state.form.EmployeeMasterCourse,
	    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
	    showErrorMessage: (state.coursesReducer.employeeMasterCoursesError && state.coursesReducer.employeeMasterCourseserror.Message.length) > 0,
	    errorMessage: state.educationReducer.error && state.educationReducer.error.Message || ''
	  };
	}
	
	EmployeeMasterCourses.propTypes = {
	  loaded: _propTypes2.default.bool,
	  dispatch: _propTypes2.default.func.isRequired,
	  showErrorMessage: _propTypes2.default.bool,
	  errorMessage: _propTypes2.default.string,
	  EmployeeMasterID: _propTypes2.default.number,
	  employeeMasterCoursesData: _propTypes2.default.array
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(EmployeeMasterCourses);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EmployeeMasterCourses, 'EmployeeMasterCourses', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeMasterCourses.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeMasterCourses.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/profile/EmployeeMasterCourses.js');
	}();

	;

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _materialUi = __webpack_require__(17);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IdentificationCard = function IdentificationCard(_ref) {
	  var setChangedIdentification = _ref.setChangedIdentification,
	      identification = _ref.identification,
	      setIdentification = _ref.setIdentification;
	  return _react2.default.createElement(
	    'div',
	    { style: { marginTop: 14 } },
	    _react2.default.createElement(_materialUi.TextField, {
	      type: 'text',
	      floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.accessCard' }),
	      value: identification,
	      onChange: function onChange(ev) {
	        setChangedIdentification(true);
	        setIdentification(ev.target.value);
	      },
	      fullWidth: true,
	      id: 'identification'
	    })
	  );
	};
	IdentificationCard.propTypes = {
	  setChangedIdentification: _propTypes2.default.func,
	  identification: _propTypes2.default.string,
	  setIdentification: _propTypes2.default.func
	};
	
	var _default = IdentificationCard;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(IdentificationCard, 'IdentificationCard', 'D:/a/1/s/src/web/employee/src/components/profile/IdentificationCard.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/profile/IdentificationCard.js');
	}();

	;

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _loans = __webpack_require__(855);
	
	var _loansReducer = __webpack_require__(441);
	
	var _EditPanel = __webpack_require__(147);
	
	var _EditPanel2 = _interopRequireDefault(_EditPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ObjectsonLoan = function ObjectsonLoan(_ref) {
	  var loaded = _ref.loaded,
	      dispatch = _ref.dispatch,
	      showErrorMessage = _ref.showErrorMessage,
	      errorMessage = _ref.errorMessage,
	      loansData = _ref.loansData,
	      EmployeeMasterID = _ref.EmployeeMasterID;
	  return _react2.default.createElement(_EditPanel2.default, {
	    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'loan.title' }),
	    emptyText: 'loan.empty',
	    loaded: loaded,
	    showErrorMessage: showErrorMessage,
	    errorMessage: errorMessage,
	    onOpen: function onOpen() {
	      return dispatch((0, _loans.fetchLoansIfNeeded)());
	    },
	    modelName: 'EmployeeMasterObjectOnLoan',
	    dataSource: loansData,
	    mapModel: _loansReducer.mapLoans,
	    EmployeeMasterID: EmployeeMasterID,
	    fetchData: _loans.fetchLoans
	  });
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    form: state.form.EmployeeMasterObjectOnLoan, // needed for EditPanel
	    loaded: state.loansReducer.loaded,
	    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
	    loansData: state.loansReducer.loansData,
	    showErrorMessage: (state.loansReducer.error && state.loansReducer.error.Message.length) > 0,
	    errorMessage: (0, _lodash.get)(state.educationReducer, ['error', 'Message'], '')
	  };
	};
	
	ObjectsonLoan.propTypes = {
	  loaded: _propTypes2.default.bool,
	  dispatch: _propTypes2.default.func.isRequired,
	  loansData: _propTypes2.default.array,
	  showErrorMessage: _propTypes2.default.bool,
	  errorMessage: _propTypes2.default.string,
	  EmployeeMasterID: _propTypes2.default.number
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(ObjectsonLoan);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ObjectsonLoan, 'ObjectsonLoan', 'D:/a/1/s/src/web/employee/src/components/profile/ObjectsonLoan.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/components/profile/ObjectsonLoan.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/profile/ObjectsonLoan.js');
	}();

	;

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _qualification = __webpack_require__(856);
	
	var _qualificationReducer = __webpack_require__(442);
	
	var _EditPanel = __webpack_require__(147);
	
	var _EditPanel2 = _interopRequireDefault(_EditPanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Qualification = function Qualification(_ref) {
	  var loaded = _ref.loaded,
	      dispatch = _ref.dispatch,
	      showErrorMessage = _ref.showErrorMessage,
	      errorMessage = _ref.errorMessage,
	      qualificationData = _ref.qualificationData,
	      EmployeeMasterID = _ref.EmployeeMasterID;
	  return _react2.default.createElement(_EditPanel2.default, {
	    title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qualification.title' }),
	    emptyText: 'qualification.empty',
	    loaded: loaded,
	    showErrorMessage: showErrorMessage,
	    errorMessage: errorMessage,
	    onOpen: function onOpen() {
	      return dispatch((0, _qualification.fetchQualificationIfNeeded)());
	    },
	    modelName: 'EmployeeMasterQualification',
	    dataSource: qualificationData,
	    mapModel: _qualificationReducer.mapQualification,
	    EmployeeMasterID: EmployeeMasterID,
	    fetchData: _qualification.fetchQualification
	  });
	};
	
	function mapStateToProps(state) {
	  return {
	    loaded: state.qualificationReducer.loaded,
	    form: state.form.EmployeeMasterQualification,
	    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
	    qualificationData: state.qualificationReducer.qualificationData,
	    showErrorMessage: (state.qualificationReducer.error && state.qualificationReducer.error.Message.length) > 0,
	    errorMessage: state.educationReducer.error && state.educationReducer.error.Message || ''
	  };
	}
	
	Qualification.propTypes = {
	  loaded: _propTypes2.default.bool,
	  dispatch: _propTypes2.default.func.isRequired,
	  qualificationData: _propTypes2.default.array,
	  showErrorMessage: _propTypes2.default.bool,
	  errorMessage: _propTypes2.default.string,
	  EmployeeMasterID: _propTypes2.default.number
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(Qualification);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Qualification, 'Qualification', 'D:/a/1/s/src/web/employee/src/components/profile/Qualification.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/components/profile/Qualification.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/components/profile/Qualification.js');
	}();

	;

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var apiUrl = exports.apiUrl = '#{Kjarni.EmployeeWeb.apiUrl}'; // https://qdata.kjarni.applicon.is:port
	var supportEmail = exports.supportEmail = '#{Kjarni.EmployeeWeb.supportEmail}'; // applicon@applicon.is
	var customer = exports.customer = '#{Kjarni.EmployeeWeb.customer}'; // dev
	/* eslint global-require: 0 */
	var logo = exports.logo = '#{Kjarni.EmployeeWeb.logo}'; // logo.png
	var theme = exports.theme = '#{Kjarni.EmployeeWeb.theme}'; // {}
	var tags = exports.tags = [customer];
	var applicationInsightsInstrumentationKey = exports.applicationInsightsInstrumentationKey = '#{Kjarni.Monitoring.InstrumentationKey}';
	var siteName = exports.siteName = '#{Kjarni.Tenant.SiteName}';
	var useSSO = exports.useSSO = '#{Kjarni.EmployeeWeb.useSSO}'; // true | false
	var hiddenFeatures = exports.hiddenFeatures = '#{Kjarni.EmployeeWeb.hiddenFeatures}'; // {} | {"appraisals":"true"}
	var reverseListItemLabels = exports.reverseListItemLabels = '#{Kjarni.EmployeeWeb.ReverseListItemLabels}';
	var hideXapLogin = exports.hideXapLogin = '#{Kjarni.EmployeeWeb.HideXAPLogin}';
	var useMobileLogin = exports.useMobileLogin = '#{Kjarni.EmployeeWeb.useMobileLogin}'; // true | false
	
	var msalTenantID = exports.msalTenantID = '#{Kjarni.Authentication.MSAL.TenantID}';
	var msalApplicationID = exports.msalApplicationID = '#{Kjarni.Authentication.MSAL.ApplicationID}';
	var msalScope = exports.msalScope = '#{Kjarni.Authentication.MSAL.ApiScope}';
	
	var recaptchaKey = exports.recaptchaKey = '#{Kjarni.EmployeeWeb.RecaptchaKey}';
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(apiUrl, 'apiUrl', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(supportEmail, 'supportEmail', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(customer, 'customer', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(logo, 'logo', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(theme, 'theme', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(tags, 'tags', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(applicationInsightsInstrumentationKey, 'applicationInsightsInstrumentationKey', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(siteName, 'siteName', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(useSSO, 'useSSO', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(hiddenFeatures, 'hiddenFeatures', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(reverseListItemLabels, 'reverseListItemLabels', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(hideXapLogin, 'hideXapLogin', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(useMobileLogin, 'useMobileLogin', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(msalTenantID, 'msalTenantID', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(msalApplicationID, 'msalApplicationID', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(msalScope, 'msalScope', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	
	  __REACT_HOT_LOADER__.register(recaptchaKey, 'recaptchaKey', 'D:/a/1/s/src/web/employee/src/config/octopus/index.js');
	}();

	;

/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.entityMap = exports.detailFields = exports.fields = undefined;
	
	var _InputTypes = __webpack_require__(91);
	
	var fields = exports.fields = ['CareerEmployer', 'CareerJob', 'CareerCity', 'CareerCountryName'];
	
	var detailFields = exports.detailFields = [].concat(fields, ['CareerPeriodBegda', 'CareerPeriodEnda']);
	
	var entityMap = exports.entityMap = {
	  EmployeeMasterID: {
	    type: _InputTypes.HIDDEN
	  },
	  EmployeeMasterCareerID: {
	    type: _InputTypes.HIDDEN
	  },
	  CareerEmployer: {
	    type: _InputTypes.TEXT_FIELD
	  },
	  CareerJob: {
	    type: _InputTypes.TEXT_FIELD
	  },
	  CareerCity: {
	    type: _InputTypes.TEXT_FIELD
	  },
	  CareerCountryID: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'SysCountry',
	      value: 'SysCountryID',
	      label: 'SysCountryName'
	    }
	  },
	  CareerPeriodBegda: {
	    type: _InputTypes.DATE
	  },
	  CareerPeriodEnda: {
	    type: _InputTypes.DATE
	  }
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fields, 'fields', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterCareer.js');
	
	  __REACT_HOT_LOADER__.register(detailFields, 'detailFields', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterCareer.js');
	
	  __REACT_HOT_LOADER__.register(entityMap, 'entityMap', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterCareer.js');
	}();

	;

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.entityMap = exports.detailFields = exports.fields = undefined;
	
	var _InputTypes = __webpack_require__(91);
	
	var fields = exports.fields = ['CertificateTypeName', 'CertificateName', 'CertificatePeriodBegda', 'CertificatePeriodEnda'];
	
	var detailFields = exports.detailFields = [].concat(fields);
	
	var entityMap = exports.entityMap = {
	  EmployeeMasterID: {
	    type: _InputTypes.HIDDEN
	  },
	  CertificateType: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrCertificateType?$filter=Disabled eq false',
	      value: 'HrCertificateTypeID',
	      label: 'HrCertificateTypeName'
	    }
	  },
	  HrCertificateID: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrCertificate?$filter=Disabled eq false',
	      link: 'HrCertificateType',
	      lookupValue: 'CertificateType',
	      value: 'HrCertificateID',
	      label: 'HrCertificateName',
	      number: true
	    }
	  },
	  EmployeeMasterCertificateID: {
	    type: _InputTypes.HIDDEN
	  },
	  CertificatePeriodBegda: {
	    type: _InputTypes.DATE
	  },
	  CertificatePeriodEnda: {
	    type: _InputTypes.DATE
	  }
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fields, 'fields', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterCertificate.js');
	
	  __REACT_HOT_LOADER__.register(detailFields, 'detailFields', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterCertificate.js');
	
	  __REACT_HOT_LOADER__.register(entityMap, 'entityMap', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterCertificate.js');
	}();

	;

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.entityMap = exports.detailFields = exports.fields = undefined;
	
	var _InputTypes = __webpack_require__(91);
	
	var fields = exports.fields = ['CourseName', 'CourseHrLocationName', 'CourseLength', 'CoursePeriodBegda', 'CoursePeriodEnda'];
	
	var detailFields = exports.detailFields = ['CourseName', 'CourseTypeName', 'CourseGroupName', 'CourseHrLocationName', 'HrRoomName', 'CourseLength', 'CourseDescription', 'Comments', 'CoursePeriodBegda', 'CoursePeriodEnda', 'CoursePoints'];
	
	var entityMap = exports.entityMap = {
	  EmployeeMasterID: {
	    type: _InputTypes.HIDDEN
	  },
	  EmployeeMasterCourseID: {
	    type: _InputTypes.HIDDEN
	  },
	  CourseLength: {
	    type: _InputTypes.NUMBER_FIELD
	  },
	  CourseName: {
	    type: _InputTypes.TEXT_FIELD
	  },
	  CourseDescription: {
	    type: _InputTypes.TEXT_FIELD
	  },
	  Comments: {
	    type: _InputTypes.TEXT_FIELD
	  },
	  CoursePoints: {
	    type: _InputTypes.HIDDEN
	  },
	  HrRoomID: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrRoom',
	      value: 'HrRoomID',
	      label: 'HrRoomName'
	    }
	  },
	  HrLocationID: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrLocation',
	      value: 'HrLocationID',
	      label: 'HrLocationName'
	    }
	  },
	  CourseType: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrCourseType?$filter=Disabled eq false',
	      value: 'CourseType',
	      label: 'CourseTypeName'
	    }
	  },
	  CourseGroupID: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrCourseGroup?$filter=Disabled eq false',
	      value: 'HrCourseGroupID',
	      label: 'HrCourseGroupName'
	    }
	  },
	  CoursePeriodBegda: {
	    type: _InputTypes.DATE
	  },
	  CoursePeriodEnda: {
	    type: _InputTypes.DATE
	  }
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fields, 'fields', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterCourse.js');
	
	  __REACT_HOT_LOADER__.register(detailFields, 'detailFields', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterCourse.js');
	
	  __REACT_HOT_LOADER__.register(entityMap, 'entityMap', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterCourse.js');
	}();

	;

/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.entityMap = exports.detailFields = exports.fields = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _InputTypes = __webpack_require__(91);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var fields = exports.fields = ['EducationTypeName', 'EducationHrSchoolName', 'EducationHrDegreeName', 'EducationHrBranchOfStudy1Name'];
	
	var detailFields = exports.detailFields = ['EducationTypeName', 'EducationHrSchoolName', 'EducationHrDegreeName', 'EducationHrBranchOfStudy1Name', 'EducationHrBranchOfStudy2Name', 'EducationPeriodBegda', 'EducationPeriodEnda', 'EducationGrade', 'EducationHighestText', 'EducationFurtherInfo', 'EducationCountryName'];
	
	var entityMap = exports.entityMap = {
	  EmployeeMasterID: {
	    type: _InputTypes.HIDDEN
	  },
	  EmployeeMasterEducationID: {
	    type: _InputTypes.HIDDEN
	  },
	  EducationGrade: {
	    type: _InputTypes.NUMBER_FIELD
	  },
	  EducationHighest: {
	    type: _InputTypes.SELECT_ENUM,
	    options: [{ value: false, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.no' }) }, { value: true, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.yes' }) }]
	  },
	  EducationHrBranchOfStudy1ID: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrBranchOfStudy',
	      link: 'HrEducationType',
	      lookupValue: 'EducationType',
	      value: 'HrBranchOfStudyID',
	      label: 'HrBranchOfStudyName'
	    }
	  },
	  EducationHrBranchOfStudy2ID: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrBranchOfStudy',
	      link: 'HrEducationType',
	      lookupValue: 'EducationType',
	      value: 'HrBranchOfStudyID',
	      label: 'HrBranchOfStudyName'
	    }
	  },
	  EducationHrDegreeID: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrDegree',
	      link: 'HrEducationType',
	      lookupValue: 'EducationType',
	      value: 'HrDegreeID',
	      label: 'HrDegreeName'
	    }
	  },
	  EducationHrSchoolID: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrSchool',
	      link: 'HrEducationType',
	      lookupValue: 'EducationType',
	      value: 'HrSchoolID',
	      label: 'HrSchoolName'
	    }
	  },
	  EducationPeriodBegda: {
	    type: _InputTypes.DATE
	  },
	  EducationPeriodEnda: {
	    type: _InputTypes.DATE
	  },
	  EducationType: {
	    type: _InputTypes.SELECT_ENUM,
	    options: [{ value: 0, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.type.unknown' }) }, { value: 1, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.type.university' }) }, { value: 2, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.type.internship' }) }, { value: 3, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.type.primary' }) }, { value: 4, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.type.apprentice' }) }, { value: 5, label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'education.type.highschool' }) }]
	  },
	  EducationFurtherInfo: {
	    type: _InputTypes.TEXT_FIELD
	  }
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fields, 'fields', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterEducation.js');
	
	  __REACT_HOT_LOADER__.register(detailFields, 'detailFields', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterEducation.js');
	
	  __REACT_HOT_LOADER__.register(entityMap, 'entityMap', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterEducation.js');
	}();

	;

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.entityMap = exports.detailFields = exports.fields = undefined;
	
	var _InputTypes = __webpack_require__(91);
	
	var fields = exports.fields = ['ObjectTypeName', 'Pieces', 'ObjectNumber', 'Amount', 'Begda', 'Endda'];
	
	var detailFields = exports.detailFields = [].concat(fields);
	
	var entityMap = exports.entityMap = {
	  EmployeeMasterID: {
	    type: _InputTypes.HIDDEN
	  },
	  ObjectType: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrObjectType',
	      value: 'HrObjectTypeID',
	      label: 'HrObjectTypeName'
	    }
	  },
	  Pieces: {
	    type: _InputTypes.NUMBER_FIELD
	  },
	  ObjectNumber: {
	    type: _InputTypes.NUMBER_FIELD
	  },
	  Amount: {
	    type: _InputTypes.NUMBER_FIELD
	  },
	  Begda: {
	    type: _InputTypes.DATE
	  },
	  Endda: {
	    type: _InputTypes.DATE
	  }
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fields, 'fields', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterObjectOnLoan.js');
	
	  __REACT_HOT_LOADER__.register(detailFields, 'detailFields', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterObjectOnLoan.js');
	
	  __REACT_HOT_LOADER__.register(entityMap, 'entityMap', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterObjectOnLoan.js');
	}();

	;

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.entityMap = exports.detailFields = exports.fields = undefined;
	
	var _InputTypes = __webpack_require__(91);
	
	var fields = exports.fields = ['QualificationTypeName', 'QualificationName', 'HrQualificationScaleEntryName'];
	
	var detailFields = exports.detailFields = [].concat(fields);
	
	var entityMap = exports.entityMap = {
	  EmployeeMasterID: {
	    type: _InputTypes.HIDDEN
	  },
	  EmployeeMasterQualificationID: {
	    type: _InputTypes.HIDDEN
	  },
	  QualificationType: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrQualificationType?$filter=Disabled eq false',
	      value: 'HrQualificationTypeID',
	      label: 'HrQualificationTypeName'
	    }
	  },
	  HrQualificationID: {
	    allowAddOption: true,
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrQualification?$filter=Disabled eq false',
	      link: 'HrQualificationTypeID',
	      lookupValue: 'QualificationType',
	      value: 'HrQualificationID',
	      label: 'HrQualificationName',
	      number: true
	    },
	    link: {
	      entity: 'HrQualification?$filter=Disabled eq false',
	      linkValue: 'HrQualificationID',
	      value: 'HrQualificationScaleID'
	    }
	  },
	  HrQualificationScaleEntryID: {
	    type: _InputTypes.SELECT_LOOKUP,
	    lookup: {
	      entity: 'HrQualificationScaleEntry',
	      link: 'HrQualificationScaleID',
	      lookupValue: 'HrQualificationScaleID',
	      value: 'HrQualificationScaleEntryID',
	      label: 'HrQualificationScaleEntryName',
	      number: true,
	      orderByValue: true
	    }
	  }
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(fields, 'fields', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterQualification.js');
	
	  __REACT_HOT_LOADER__.register(detailFields, 'detailFields', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterQualification.js');
	
	  __REACT_HOT_LOADER__.register(entityMap, 'entityMap', 'D:/a/1/s/src/web/employee/src/constants/fields/EmployeeMasterQualification.js');
	}();

	;

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _config = __webpack_require__(54);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _login = __webpack_require__(144);
	
	var _logout = __webpack_require__(851);
	
	var _logout2 = _interopRequireDefault(_logout);
	
	var _Login = __webpack_require__(874);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _ForgotPassword = __webpack_require__(873);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	var _TwoFactor = __webpack_require__(876);
	
	var _TwoFactor2 = _interopRequireDefault(_TwoFactor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  container: {
	    display: 'flex',
	    flex: 1,
	    flexDirection: 'column',
	    alignItems: 'center',
	    paddingLeft: 12,
	    paddingRight: 12,
	    backgroundColor: 'white',
	    height: '100vh',
	    marginTop: -64
	  },
	  logo: {
	    maxHeight: 150,
	    maxWidth: 220
	  },
	  logoContainer: {
	    display: 'flex',
	    alignItems: 'center',
	    maxWidth: 800,
	    marginTop: '6%',
	    width: '100%'
	  },
	  art1: {
	    bottom: 0,
	    right: 0,
	    position: 'absolute',
	    width: 0,
	    height: 0,
	    borderBottom: '40vw solid rgb(35, 95, 167)',
	    borderLeft: '55vw solid transparent',
	    opacity: 0.3,
	    borderBottomColor: _colors2.default.loginColor
	  },
	  art2: {
	    bottom: 0,
	    right: 0,
	    position: 'absolute',
	    width: 0,
	    height: 0,
	    borderBottom: '25vw solid rgb(35, 95, 167)',
	    borderLeft: '60vw solid transparent',
	    opacity: 0.4,
	    borderBottomColor: _colors2.default.loginColor
	  },
	  art3: {
	    bottom: 0,
	    right: 0,
	    position: 'absolute',
	    width: 0,
	    height: 0,
	    borderBottom: '15vw solid rgb(35, 95, 167)',
	    borderLeft: '100vw solid transparent',
	    opacity: 0.7,
	    borderBottomColor: _colors2.default.loginColor
	  }
	};
	
	var Account = function (_Component) {
	  _inherits(Account, _Component);
	
	  function Account() {
	    _classCallCheck(this, Account);
	
	    return _possibleConstructorReturn(this, (Account.__proto__ || Object.getPrototypeOf(Account)).apply(this, arguments));
	  }
	
	  _createClass(Account, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          dispatch = _props.dispatch,
	          logout = _props.location.query.logout,
	          isAuthenticated = _props.isAuthenticated;
	
	      if (logout && isAuthenticated) {
	        dispatch((0, _logout2.default)());
	      }
	      if (_config.useSSO) {
	        dispatch((0, _login.loginStep)('sso'));
	      } else if (_config.useMobileLogin) {
	        dispatch((0, _login.loginStep)('mobile'));
	      } else {
	        dispatch((0, _login.loginStep)('initial'));
	      }
	    }
	  }, {
	    key: 'renderLogin',
	    value: function renderLogin() {
	      switch (this.props.step) {
	        case 'forgotPassword':
	          return _react2.default.createElement(_ForgotPassword2.default, null);
	        case 'sso':
	          return _react2.default.createElement(_Login2.default, { sso: true });
	        case 'mobile':
	          return _react2.default.createElement(_TwoFactor2.default, null);
	        default:
	          return _react2.default.createElement(_Login2.default, null);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return (
	        /*
	        <Row style={{ margin: 0 }}>
	          <Col xs={12} smOffset={2} sm={8} mdOffset={3} md={6} lgOffset={4} lg={4}>
	            <div style={styles.logoContainer}><img style={styles.logo} src={logo} alt="logo" /></div>
	            {this.renderLogin()}
	          </Col>
	        </Row>
	        */
	        _react2.default.createElement(
	          'div',
	          { style: styles.container },
	          _react2.default.createElement(
	            'div',
	            { style: styles.logoContainer },
	            _react2.default.createElement('img', { style: styles.logo, src: _config.logo, alt: 'logo' })
	          ),
	          this.renderLogin(),
	          _react2.default.createElement('div', { style: styles.art1 }),
	          _react2.default.createElement('div', { style: styles.art2 }),
	          _react2.default.createElement('div', { style: styles.art3 })
	        )
	      );
	    }
	  }]);
	
	  return Account;
	}(_react.Component);
	
	Account.propTypes = {
	  isAuthenticated: _propTypes2.default.bool,
	  step: _propTypes2.default.string,
	  dispatch: _propTypes2.default.func.isRequired,
	  location: _propTypes2.default.object
	};
	
	Account.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	function mapStateToProps(state) {
	  var isAuthenticated = state.loginReducer.isAuthenticated;
	  var step = state.loginReducer.step;
	  return { isAuthenticated: isAuthenticated, step: step };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(Account);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/Account.js');
	
	  __REACT_HOT_LOADER__.register(Account, 'Account', 'D:/a/1/s/src/web/employee/src/containers/Account.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/Account.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Account.js');
	}();

	;

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _Agreements = __webpack_require__(420);
	
	var _Agreement = __webpack_require__(857);
	
	var _Agreement2 = _interopRequireDefault(_Agreement);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _materialUi = __webpack_require__(17);
	
	var _forIn = __webpack_require__(570);
	
	var _forIn2 = _interopRequireDefault(_forIn);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _isEmpty = __webpack_require__(98);
	
	var _isEmpty2 = _interopRequireDefault(_isEmpty);
	
	var _reactIntl = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  header: {
	    fontSize: 20,
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'space-between',
	    maxWidth: 860
	  },
	  container: {
	    maxWidth: 720,
	    width: '100%'
	  },
	  main: {
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    paddingBottom: 16
	  },
	  empty: {
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    fontSize: 20,
	    fontWeight: 500,
	    opacity: 0.8
	  }
	};
	
	var Agreements = function (_React$Component) {
	  _inherits(Agreements, _React$Component);
	
	  function Agreements() {
	    _classCallCheck(this, Agreements);
	
	    return _possibleConstructorReturn(this, (Agreements.__proto__ || Object.getPrototypeOf(Agreements)).apply(this, arguments));
	  }
	
	  _createClass(Agreements, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetch();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          agreementsByID = _props.agreementsByID,
	          agreementsLoading = _props.agreementsLoading,
	          hasError = _props.hasError,
	          agreementsError = _props.agreementsError;
	
	
	      if (agreementsLoading) {
	        return _react2.default.createElement(_Loading2.default, null);
	      }
	
	      if (hasError) {
	        return _react2.default.createElement(_PanelMessage2.default, {
	          type: 'error',
	          iconName: 'error',
	          message: agreementsError.message || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'agreements.error' })
	        });
	      }
	
	      var A = [_react2.default.createElement(
	        _materialUi.Subheader,
	        { key: 'head', style: styles.header },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'agreements.title' })
	      )];
	
	      (0, _forIn2.default)(agreementsByID, function (_ref, edID) {
	        var label = _ref.label,
	            agreements = _ref.agreements,
	            answers = _ref.answers;
	
	        var section = _react2.default.createElement(
	          'div',
	          { style: styles.container, key: '' + label },
	          _react2.default.createElement(
	            _materialUi.Subheader,
	            null,
	            label
	          ),
	          (0, _isEmpty2.default)(agreements) && _react2.default.createElement(_PanelMessage2.default, {
	            type: 'info',
	            iconName: 'info',
	            message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'agreements.empty' })
	          }),
	          (0, _map2.default)(agreements, function (a) {
	            return _react2.default.createElement(_Agreement2.default, _extends({}, a, {
	              EmployeeDetailID: edID,
	              handleAgreement: _this2.props.handleAgreement,
	              answer: answers[a.HrAgreementID],
	              key: '' + label + a.HrAgreementID
	            }));
	          })
	        );
	        A.push(section);
	      });
	
	      if (A.length === 1) {
	        var empty = _react2.default.createElement(
	          'div',
	          { style: styles.empty, key: 'empty' },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'agreements.empty' })
	        );
	        A.push(empty);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.main },
	        A
	      );
	    }
	  }]);
	
	  return Agreements;
	}(_react2.default.Component);
	
	Agreements.propTypes = {
	  agreementsByID: _propTypes2.default.object.isRequired,
	  fetch: _propTypes2.default.func.isRequired,
	  handleAgreement: _propTypes2.default.func.isRequired,
	  agreementsLoading: _propTypes2.default.bool.isRequired,
	  agreementsError: _propTypes2.default.object,
	  hasError: _propTypes2.default.bool.isRequired
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref2) {
	  var AgreementsReducer = _ref2.AgreementsReducer;
	  return _extends({}, AgreementsReducer);
	}, function (dispatch) {
	  return {
	    fetch: function fetch() {
	      return dispatch((0, _Agreements.fetchAgreements)());
	    },
	    handleAgreement: function handleAgreement() {
	      return dispatch(_Agreements.handleAgreement.apply(undefined, arguments));
	    }
	  };
	})(Agreements);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/Agreements.js');
	
	  __REACT_HOT_LOADER__.register(Agreements, 'Agreements', 'D:/a/1/s/src/web/employee/src/containers/Agreements.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Agreements.js');
	}();

	;

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _templateObject = _taggedTemplateLiteral(['-'], ['-']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(67);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _lodash = __webpack_require__(8);
	
	var _materialUi = __webpack_require__(17);
	
	var _dateTools = __webpack_require__(35);
	
	var _Appraisal = __webpack_require__(1023);
	
	var _Appraisal2 = _interopRequireDefault(_Appraisal);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _QAElement = __webpack_require__(284);
	
	var _QAElement2 = _interopRequireDefault(_QAElement);
	
	var _Alert = __webpack_require__(145);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _Appraisal3 = __webpack_require__(180);
	
	var _answersToFormState = __webpack_require__(955);
	
	var _answersToFormState2 = _interopRequireDefault(_answersToFormState);
	
	var _validateAppraisal = __webpack_require__(957);
	
	var _validateAppraisal2 = _interopRequireDefault(_validateAppraisal);
	
	var _getAppraisalTitle = __webpack_require__(148);
	
	var _getAppraisalTitle2 = _interopRequireDefault(_getAppraisalTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var saveToStorage = function saveToStorage(data, id) {
	  if (!id) {
	    return;
	  }
	  var appraisalsString = localStorage.appraisals || '{}';
	  var appraisals = JSON.parse(appraisalsString);
	  localStorage.appraisals = JSON.stringify(_extends({}, appraisals, _defineProperty({}, id, _extends({}, data, { expires: Date.now() + 8 * 60 * 60 * 1000 }))));
	};
	
	var Appraisal = function (_React$Component) {
	  _inherits(Appraisal, _React$Component);
	
	  function Appraisal(props) {
	    _classCallCheck(this, Appraisal);
	
	    var _this = _possibleConstructorReturn(this, (Appraisal.__proto__ || Object.getPrototypeOf(Appraisal)).call(this, props));
	
	    _this.getAnswerDom = function () {
	      return _this.__getAnswerDom__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.willLeave = function () {
	      return _this.__willLeave__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.createAnswers = function () {
	      return _this.__createAnswers__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleSubmit = function () {
	      return _this.__handleSubmit__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleSave = function () {
	      return _this.__handleSave__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleNav = function () {
	      return _this.__handleNav__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = { alertOpen: false };
	    return _this;
	  }
	
	  _createClass(Appraisal, [{
	    key: '__handleNav__REACT_HOT_LOADER__',
	    value: function __handleNav__REACT_HOT_LOADER__() {
	      return this.__handleNav__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleSave__REACT_HOT_LOADER__',
	    value: function __handleSave__REACT_HOT_LOADER__() {
	      return this.__handleSave__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__handleSubmit__REACT_HOT_LOADER__',
	    value: function __handleSubmit__REACT_HOT_LOADER__() {
	      return this.__handleSubmit__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__createAnswers__REACT_HOT_LOADER__',
	    value: function __createAnswers__REACT_HOT_LOADER__() {
	      return this.__createAnswers__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__willLeave__REACT_HOT_LOADER__',
	    value: function __willLeave__REACT_HOT_LOADER__() {
	      return this.__willLeave__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__getAnswerDom__REACT_HOT_LOADER__',
	    value: function __getAnswerDom__REACT_HOT_LOADER__() {
	      return this.__getAnswerDom__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var dispatch = this.props.dispatch;
	
	      this.props.router.setRouteLeaveHook(this.props.route, this.willLeave);
	      var id = this.props.router.params.appraisalId;
	      dispatch((0, _Appraisal3.fetchAppraisalByIdIfNeeded)(id));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var submitSucceeded = props.submitSucceeded,
	          pristine = props.pristine;
	
	      if (!pristine && !submitSucceeded) {
	        window.onbeforeunload = function () {
	          return 'Áður en þú yfirgefur síðuna vertu viss um að öll svör séu vistuð.';
	        };
	      } else {
	        window.onbeforeunload = undefined;
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.onbeforeunload = undefined;
	    }
	
	    /* eslint react/no-find-dom-node: 0 */
	
	  }, {
	    key: '__getAnswerDom__REACT_HOT_LOADER__',
	    value: function __getAnswerDom__REACT_HOT_LOADER__() {
	      return btoa(document.getElementById('fmat').outerHTML);
	    }
	  }, {
	    key: 'unlockFocus',
	    value: function unlockFocus() {
	      var _this2 = this;
	
	      return function () {
	        return _this2.lockFocus();
	      };
	    }
	  }, {
	    key: 'lockFocus',
	    value: function lockFocus() {
	      var _this3 = this;
	
	      return function () {
	        return _this3.unlockFocus();
	      };
	    }
	  }, {
	    key: '__willLeave__REACT_HOT_LOADER__',
	
	
	    /*
	        TODO: questions
	          * Do we want the Employee to be able to see his answers after submitting?
	          * How are we usign the final answers?
	        TODO: isFinal is still messed, need to look at both due dates.
	    */
	
	    // TODO: When saving attachments need to go through all files in file list and save to that person.
	    // Create special util to implement this functionality so it can be used later.
	
	    /* BUG?NOTE: maybe nota good idea to include the input type in the field name
	    it may cause problems when trying to fill the form with answers */
	    /* TODO: Move this logic to action file */
	    value: function __willLeave__REACT_HOT_LOADER__() {
	      var _props = this.props,
	          submitSucceeded = _props.submitSucceeded,
	          pristine = _props.pristine;
	
	      if (!pristine && !submitSucceeded) {
	        return 'Áður en þú yfirgefur síðuna vertu viss um að öll svör séu vistuð.';
	      }
	      return true;
	    }
	  }, {
	    key: '__createAnswers__REACT_HOT_LOADER__',
	    value: function __createAnswers__REACT_HOT_LOADER__(data) {
	      /* NOTE:
	          CHECKBOX
	            * get QAAnswerValue from redux form value
	            * get QAAnswerText from redux form name last group
	          NOTE: ATTACHMENT questions put on hold!
	          ATTACHMENT
	            * on load of file send to repo
	            * QAAnswerText is the file name
	            * QAAnswerValue is the GUID of the file returned from repo
	          TEXT_FIELDS
	            * QAAnswerValue and QAAnswerText are set to the rf value
	          DATE
	            * set QAAnswerText to human version
	            * set QAAnswerValue to datetime stamp
	          RADIO AND SCALE
	            * set QAAnswerText to the option label
	            * set QAAnswerValue to QAInputOptionID or HrQualificationScaleEntryID
	      */
	
	      /* Find the ID of the Appraisal from the router */
	      var id = this.props.router.params.appraisalId;
	
	      /* Extract the Appraisal information from props/state */
	      var appraisal = this.props.appraisalsById[id];
	
	      var answers = this.props.appraisalAnswers[id];
	
	      var stateAnswers = answers.employeeAnswers.QAAnswers;
	      var RootAnswerID = answers.employeeAnswers.RootAnswerID;
	
	      var QAElements = appraisal.PMForm.QAElements;
	
	      /* Track which checkbox answers to delete */
	      var checkboxesToDelete = [];
	
	      /* Map through all the fields submited through the Redux form */
	      var ansrs = (0, _lodash.map)((0, _lodash.keys)(data), function (key) {
	        if ((0, _lodash.startsWith)(key, 'COMMENT') || key === 'expires') {
	          return null;
	        }
	        var QAAnswerValue = data[key];
	
	        /* Split the key into its components
	        example: '345-34045'
	        becomes ['345', '34045'] */
	        var qkeys = key.split(_templateObject);
	
	        /* We use the Redux field names to identify information about the elements */
	        var QAInputAnswerType = Number(qkeys[0]);
	        var QAElementID = Number(qkeys[1]);
	        var QAInputOptionLabel = qkeys[2];
	
	        /* For unchecked checkboxes, mark existing answer for deletion */
	        if (QAAnswerValue === false) {
	          if (QAInputAnswerType === 3) {
	            var _existingAnswers = stateAnswers.filter(function (ans) {
	              return ans.QAElementID === QAElementID;
	            });
	            var _existing = (0, _lodash.find)(_existingAnswers, ['QAAnswerText', atob(QAInputOptionLabel)]);
	            if (_existing && _existing.QAAnswerID) {
	              checkboxesToDelete.push(_existing.QAAnswerID);
	            }
	          }
	          return null;
	        }
	
	        /* QAElement information */
	
	        var _find = (0, _lodash.find)(QAElements, ['QAElementID', QAElementID]),
	            QAInput = _find.QAInput,
	            Order = _find.Order,
	            Level = _find.Level,
	            QAElementParentID = _find.QAElementParentID,
	            AllowComment = _find.AllowComment;
	
	        var option = QAInputAnswerType === 6 ? (0, _lodash.find)(QAInput.HrQualificationScaleEntries, ['HrQualificationScaleEntryID', QAAnswerValue]) : (0, _lodash.find)(QAInput.QAInputOptions, ['QAInputOptionID', QAAnswerValue]);
	
	        var checkBoxText = atob(QAInputOptionLabel || '');
	        var optionText = option ? option.HrQualificationScaleEntryName || option.QAInputOptionLabel : '';
	        var QAAnswerText = checkBoxText || optionText || QAAnswerValue;
	        var QAAnswerComment = null;
	
	        if (AllowComment) {
	          QAAnswerComment = data['COMMENT-' + QAInputAnswerType + '-' + QAElementID];
	        }
	
	        /* If the Element is higher than 2 the Element is inside a group, then
	        we have to set the correct QAAnswerParentID. */
	        var QAAnswerParentID = Level <= 2 ? RootAnswerID : (0, _lodash.find)(stateAnswers, ['QAElementID', QAElementParentID]).QAAnswerID;
	
	        var existing = void 0;
	        var existingValue = void 0;
	        var existingComment = void 0;
	        var existingID = void 0;
	        var existingAnswers = stateAnswers.filter(function (ans) {
	          return ans.QAElementID === QAElementID;
	        });
	        // Check existingAnswers to see if we are adding a new answer or updating one.
	        if (existingAnswers.length) {
	          /* If we have a checkbox question we have to see if
	           this option alread has an answer */
	          if (QAInputAnswerType === 3) {
	            existing = (0, _lodash.find)(existingAnswers, ['QAAnswerText', atob(QAInputOptionLabel)]);
	          } else {
	            existing = existingAnswers[0];
	          }
	          existingValue = existing && existing.QAAnswerValue;
	          existingID = existing && existing.QAAnswerID;
	          existingComment = existing && existing.QAAnswerComment;
	        }
	
	        if ((0, _lodash.isEqual)(existingValue, QAAnswerValue) && (0, _lodash.isEqual)(existingComment, QAAnswerComment)) {
	          return undefined;
	        }
	
	        var def = {
	          QAAnswerParentID: QAAnswerParentID,
	          QAElementID: QAElementID,
	          QAAnswerValue: QAAnswerValue,
	          QAAnswerText: QAAnswerText,
	          QAAnswerComment: QAAnswerComment,
	          QAAnswerOrder: Order,
	          RootAnswerID: RootAnswerID
	        };
	
	        if (existingID) {
	          return _extends({ QAAnswerID: existingID }, def);
	        }
	
	        return def;
	      });
	
	      return { answersToSave: (0, _lodash.compact)(ansrs), answersToDelete: checkboxesToDelete };
	    }
	  }, {
	    key: '__handleSubmit__REACT_HOT_LOADER__',
	    value: function __handleSubmit__REACT_HOT_LOADER__(data) {
	      var error = (0, _validateAppraisal2.default)(data, this.props);
	      if (!(0, _lodash.isEmpty)(error)) {
	        this.setState({ alertOpen: false });
	        throw new _reduxForm.SubmissionError(error);
	      } else {
	        /* Find the ID of the Appraisal from the router */
	        var id = this.props.router.params.appraisalId;
	        saveToStorage(data, id);
	
	        var _createAnswers = this.createAnswers(data),
	            answersToSave = _createAnswers.answersToSave,
	            answersToDelete = _createAnswers.answersToDelete;
	
	        return this.props.dispatch((0, _Appraisal3.submitAppraisal)(answersToSave, answersToDelete, id));
	      }
	    }
	  }, {
	    key: '__handleSave__REACT_HOT_LOADER__',
	    value: function __handleSave__REACT_HOT_LOADER__(data) {
	      var id = this.props.router.params.appraisalId;
	      saveToStorage(data, id);
	
	      var _createAnswers2 = this.createAnswers(data),
	          answersToSave = _createAnswers2.answersToSave,
	          answersToDelete = _createAnswers2.answersToDelete;
	
	      return this.props.dispatch((0, _Appraisal3.saveAppraisal)(answersToSave, answersToDelete, id));
	    }
	  }, {
	    key: '__handleNav__REACT_HOT_LOADER__',
	    value: function __handleNav__REACT_HOT_LOADER__() {
	      this.context.router.push('/appraisals');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props2 = this.props,
	          errorMessage = _props2.errorMessage,
	          detailIDs = _props2.detailIDs,
	          loadingById = _props2.loadingById,
	          appraisalsById = _props2.appraisalsById,
	          handleSubmit = _props2.handleSubmit,
	          isSubmitting = _props2.isSubmitting,
	          isSaving = _props2.isSaving,
	          invalid = _props2.invalid,
	          submitFailed = _props2.submitFailed,
	          router = _props2.router,
	          appraisalAnswers = _props2.appraisalAnswers,
	          valuesByKey = _props2.valuesByKey;
	
	
	      var appraisalTitle = (0, _getAppraisalTitle2.default)(valuesByKey);
	
	      if (errorMessage) {
	        return _react2.default.createElement(
	          _reactFlexboxGrid.Col,
	          { xs: 12, sm: 10, smOffset: 1, md: 8, mdOffset: 2 },
	          _react2.default.createElement(_PanelMessage2.default, {
	            type: 'error',
	            iconName: 'error',
	            message: (0, _lodash.get)(errorMessage, 'message') || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.error' })
	          })
	        );
	      }
	
	      var id = router.params.appraisalId;
	
	      if ((0, _lodash.isUndefined)(loadingById[id]) || loadingById[id]) {
	        return _react2.default.createElement(_Loading2.default, null);
	      }
	
	      var _appraisalsById$id = appraisalsById[id],
	          EmployeeDetailID = _appraisalsById$id.EmployeeDetailID,
	          EmployeeDueDate = _appraisalsById$id.EmployeeDueDate,
	          EmployeeName = _appraisalsById$id.EmployeeName,
	          EmployeeStatus = _appraisalsById$id.EmployeeStatus,
	          FinalAppraisalDate = _appraisalsById$id.FinalAppraisalDate,
	          FinalStatus = _appraisalsById$id.FinalStatus,
	          ManagerDueDate = _appraisalsById$id.ManagerDueDate,
	          ManagerName = _appraisalsById$id.ManagerName,
	          ManagerStatus = _appraisalsById$id.ManagerStatus,
	          PMForm = _appraisalsById$id.PMForm,
	          PMFormTitle = _appraisalsById$id.PMFormTitle;
	      var alertOpen = this.state.alertOpen;
	
	      var isEmployee = (0, _lodash.includes)(detailIDs, EmployeeDetailID);
	      var manDue = new Date(ManagerDueDate);
	      manDue.setHours(23, 59, 59);
	      var empDue = new Date(EmployeeDueDate);
	      empDue.setHours(23, 59, 59);
	      var finDue = new Date(FinalAppraisalDate);
	      finDue.setHours(23, 59, 59);
	      var dueDate = empDue;
	      var qaElements = PMForm.QAElements;
	      // const lock = isEmployee && ((dueDate.getTime() < Date.now()) || EmployeeStatus === 2);
	      var showAnswers = ManagerStatus === 2 && EmployeeStatus === 2 || ManagerStatus === 2 && empDue.getTime() < Date.now() || empDue.getTime() < Date.now() && empDue.getTime() < Date.now() || finDue.getTime() < Date.now();
	      var showOnlyEmployeeAnswers = EmployeeStatus === 2 && (ManagerStatus !== 2 || FinalStatus !== 2);
	      var isReview = FinalStatus === 2 || finDue.getTime() < Date.now();
	
	      var _appraisalAnswers$id = appraisalAnswers[id],
	          finalAnswers = _appraisalAnswers$id.finalAnswers,
	          employeeAnswers = _appraisalAnswers$id.employeeAnswers,
	          managerAnswers = _appraisalAnswers$id.managerAnswers;
	
	
	      if (!isEmployee) {
	        return _react2.default.createElement(
	          _reactFlexboxGrid.Col,
	          { xs: 12, sm: 10, smOffset: 1, md: 8, mdOffset: 2 },
	          _react2.default.createElement(_PanelMessage2.default, {
	            type: 'warning',
	            iconName: 'warning',
	            message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.error.mine' })
	          })
	        );
	      }
	
	      // if (lock && !isReview) {
	      //   return (
	      //     <Col xs={12} sm={10} smOffset={1} md={8} mdOffset={2}>
	      //       <PanelMessage
	      //         type="info"
	      //         iconName="info"
	      //         action={() => router.replace('/appraisals')}
	      //         actionLabel="Til baka"
	      //         message={<FormattedMessage id="appraisal.error.closed" />}
	      //       />
	      //     </Col>
	      //   );
	      // }
	
	      return _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 12, md: 10, mdOffset: 1, style: { paddingBottom: 16 }, id: 'fmat' },
	        _react2.default.createElement(
	          _materialUi.Subheader,
	          { onClick: this.handleNav, style: _Appraisal2.default.subheader },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: appraisalTitle })
	        ),
	        _react2.default.createElement(
	          _materialUi.Paper,
	          { style: { marginBottom: 16 } },
	          _react2.default.createElement(
	            'div',
	            { style: _Appraisal2.default.root },
	            _react2.default.createElement(
	              'span',
	              { style: _Appraisal2.default.header },
	              PMFormTitle
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: _Appraisal2.default.info },
	              _react2.default.createElement(
	                'div',
	                { style: _Appraisal2.default.infoItem },
	                _react2.default.createElement(
	                  'span',
	                  { style: _Appraisal2.default.infoMessage },
	                  EmployeeName
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: _Appraisal2.default.label },
	                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.employee' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: _Appraisal2.default.infoItem },
	                _react2.default.createElement(
	                  'span',
	                  { style: _Appraisal2.default.infoMessage },
	                  ManagerName
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: _Appraisal2.default.label },
	                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.manager' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: _Appraisal2.default.infoItem },
	                dueDate.getTime() < Date.now() ? _react2.default.createElement(
	                  'span',
	                  { style: _Appraisal2.default.errorText },
	                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.expired' })
	                ) : _react2.default.createElement(
	                  'span',
	                  { style: _Appraisal2.default.infoMessage },
	                  (0, _dateTools.fromNow)(dueDate)
	                ),
	                _react2.default.createElement(
	                  'span',
	                  { style: _Appraisal2.default.label },
	                  _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.timeToFinish' })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_Alert2.default, {
	            open: alertOpen,
	            onOk: handleSubmit(this.handleSubmit),
	            onCancel: function onCancel() {
	              return _this4.setState({ alertOpen: false });
	            },
	            text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.alert.submit' })
	          })
	        ),
	        _react2.default.createElement(
	          'form',
	          null,
	          qaElements.map(function (e) {
	            return _react2.default.createElement(_QAElement2.default, _extends({
	              showAnswers: showAnswers,
	              showOnlyEmployeeAnswers: showOnlyEmployeeAnswers,
	              noInput: isReview || showOnlyEmployeeAnswers,
	              employeeAnswers: employeeAnswers || showOnlyEmployeeAnswers ? employeeAnswers.QAAnswers : [],
	              managerAnswers: managerAnswers ? managerAnswers.QAAnswers : [],
	              finalAnswers: finalAnswers ? finalAnswers.QAAnswers : [],
	              key: e.QAElementID
	            }, e));
	          }),
	          (submitFailed || invalid) && _react2.default.createElement(
	            _reactFlexboxGrid.Col,
	            { xs: 12, sm: 10, smOffset: 1, md: 8, mdOffset: 2 },
	            _react2.default.createElement(_PanelMessage2.default, { iconName: 'error', type: 'error', message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.error.required' }) })
	          ),
	          !isReview && !showOnlyEmployeeAnswers && _react2.default.createElement(
	            'div',
	            { style: _Appraisal2.default.actions },
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              style: _Appraisal2.default.action,
	              onClick: handleSubmit(this.handleSave),
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.save' }),
	              disabled: invalid || isSubmitting || isSaving,
	              icon: isSaving && !isSubmitting && _react2.default.createElement(_materialUi.CircularProgress, { size: 22 })
	            }),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              style: _Appraisal2.default.action,
	              primary: true,
	              onClick: function onClick() {
	                return _this4.setState({ alertOpen: true });
	              } // handleSubmit(this.handleSubmit)}
	              , label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'send' }),
	              disabled: invalid || isSubmitting || isSaving,
	              icon: isSubmitting && _react2.default.createElement(_materialUi.CircularProgress, { size: 22 })
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Appraisal;
	}(_react2.default.Component);
	
	Appraisal.propTypes = {
	  appraisalAnswers: _propTypes2.default.object,
	  appraisalsById: _propTypes2.default.object,
	  detailIDs: _propTypes2.default.array,
	  dispatch: _propTypes2.default.func,
	  EmployeeMasterID: _propTypes2.default.number,
	  errorMessage: _propTypes2.default.node,
	  handleSubmit: _propTypes2.default.func,
	  invalid: _propTypes2.default.bool,
	  isSaving: _propTypes2.default.bool,
	  isSubmitting: _propTypes2.default.bool,
	  loadingById: _propTypes2.default.object,
	  pristine: _propTypes2.default.bool,
	  route: _propTypes2.default.object,
	  router: _propTypes2.default.object,
	  submitFailed: _propTypes2.default.bool,
	  submitSucceeded: _propTypes2.default.bool,
	  valuesByKey: _propTypes2.default.object
	};
	
	Appraisal.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state, props) {
	  var formState = state.form;
	  if (formState.appraisal && !(0, _lodash.isEmpty)(formState.appraisal.values)) {
	    saveToStorage(formState.appraisal.values, props.router.params.appraisalId);
	  }
	  return _extends({}, state.Appraisal, {
	    detailIDs: state.loginReducer.user.detailIDs,
	    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
	    initialValues: (0, _answersToFormState2.default)(state, props),
	    errorMessage: state.Appraisal.error && state.Appraisal.error.Message || state.Appraisal.error,
	    valuesByKey: state.WebValuesReducer.valuesByKey
	  });
	};
	
	var _default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps), (0, _reduxForm.reduxForm)({
	  form: 'appraisal',
	  warn: _validateAppraisal2.default
	}))(Appraisal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(saveToStorage, 'saveToStorage', 'D:/a/1/s/src/web/employee/src/containers/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(Appraisal, 'Appraisal', 'D:/a/1/s/src/web/employee/src/containers/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Appraisal.js');
	}();

	;

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _DataTypes = __webpack_require__(85);
	
	var _AppraisalList = __webpack_require__(860);
	
	var _AppraisalList2 = _interopRequireDefault(_AppraisalList);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _Appraisal = __webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { FormattedMessage } from 'react-intl';
	// import { Tabs, Tab } from 'material-ui/Tabs';
	
	// import pallet from 'constants/colors';
	
	
	// const styles = {
	//   tab: {
	//     wordWrap: 'break-word',
	//     whiteSpace: 'normal',
	//   },
	// };
	
	var Appraisals = function (_React$Component) {
	  _inherits(Appraisals, _React$Component);
	
	  function Appraisals(props) {
	    _classCallCheck(this, Appraisals);
	
	    var _this = _possibleConstructorReturn(this, (Appraisals.__proto__ || Object.getPrototypeOf(Appraisals)).call(this, props));
	
	    _this.getWidth = function () {
	      return _this.__getWidth__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.handleRoute = _this.handleRoute.bind(_this);
	    return _this;
	  }
	
	  _createClass(Appraisals, [{
	    key: '__getWidth__REACT_HOT_LOADER__',
	    value: function __getWidth__REACT_HOT_LOADER__() {
	      return this.__getWidth__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _Appraisal.fetchAppraisalIfNeeded)());
	    }
	  }, {
	    key: '__getWidth__REACT_HOT_LOADER__',
	    value: function __getWidth__REACT_HOT_LOADER__() {
	      return window.innerWidth;
	    }
	  }, {
	    key: 'handleRoute',
	    value: function handleRoute(pmId) {
	      this.context.router.push('/appraisals/' + pmId);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          appraisal = _props.appraisal,
	          managerAppraisal = _props.managerAppraisal,
	          hasError = _props.hasError;
	
	
	      if (hasError) {
	        return _react2.default.createElement(_PanelMessage2.default, {
	          message: appraisal.error && appraisal.error.Message || managerAppraisal.error && managerAppraisal.error.Message,
	          type: 'error',
	          iconName: 'error'
	        });
	      }
	
	      if (managerAppraisal.loading || appraisal.loading) {
	        return _react2.default.createElement(_Loading2.default, null);
	      }
	
	      var myAppraisals = _react2.default.createElement(_AppraisalList2.default, _extends({
	        onClick: this.handleRoute,
	        isManager: false
	      }, appraisal));
	
	      if (!managerAppraisal.appraisals.length) return myAppraisals;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { position: 'relative', zIndex: 1199, paddingBottom: 16 } },
	        myAppraisals
	      );
	    }
	  }]);
	
	  return Appraisals;
	}(_react2.default.Component);
	
	Appraisals.propTypes = {
	  dispatch: _propTypes2.default.func,
	  appraisal: _propTypes2.default.object,
	  managerAppraisal: _propTypes2.default.object,
	  tab: _propTypes2.default.oneOf([_DataTypes.MANAGER_TAB, _DataTypes.EMPLOYEE_TAB]).isRequired,
	  hasError: _propTypes2.default.object
	};
	
	Appraisals.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    appraisal: _extends({}, state.Appraisal),
	    managerAppraisal: _extends({}, state.ManagerAppraisal),
	    hasError: state.Appraisal.error || state.Appraisal.error,
	    tab: state.Appraisal.tab
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(Appraisals);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Appraisals, 'Appraisals', 'D:/a/1/s/src/web/employee/src/containers/Appraisals.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/Appraisals.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Appraisals.js');
	}();

	;

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reactRedux = __webpack_require__(12);
	
	var _Benefits = __webpack_require__(181);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reapop = __webpack_require__(44);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _filter = __webpack_require__(262);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _includes = __webpack_require__(204);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _get = __webpack_require__(96);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _KBenefit = __webpack_require__(426);
	
	var _KBenefit2 = _interopRequireDefault(_KBenefit);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _Files = __webpack_require__(117);
	
	var _profile = __webpack_require__(118);
	
	var _Email = __webpack_require__(422);
	
	var _Benefits2 = __webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  container: {
	    paddingTop: 16,
	    paddingBottom: 16,
	    display: 'flex',
	    alignItems: 'center',
	    flexDirection: 'row',
	    flexWrap: 'wrap',
	    maxWidth: 1344,
	    margin: 'auto'
	  },
	  titleContainer: {
	    width: '100%'
	  },
	  title: {
	    fontSize: 32,
	    marginTop: 12,
	    marginBottom: 12
	  }
	};
	
	var Benefits = function (_Component) {
	  _inherits(Benefits, _Component);
	
	  function Benefits(props) {
	    _classCallCheck(this, Benefits);
	
	    var _this = _possibleConstructorReturn(this, (Benefits.__proto__ || Object.getPrototypeOf(Benefits)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Benefits, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var fetch = this.props.fetch;
	
	      fetch();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          benefits = _props.benefits,
	          loaded = _props.loaded,
	          onBenefitUpload = _props.onBenefitUpload,
	          onSendEmail = _props.onSendEmail,
	          employeeName = _props.employeeName,
	          onRequestGrant = _props.onRequestGrant,
	          benefitLoadingById = _props.benefitLoadingById;
	
	      if (!loaded) {
	        return _react2.default.createElement(_Loading2.default, null);
	      }
	      if (!benefits || !benefits.length) {
	        return _react2.default.createElement(_PanelMessage2.default, {
	          message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'benefit.empty' }),
	          iconName: 'info',
	          type: 'info'
	        });
	      }
	      var isGrants = window.location.pathname === '/grants';
	      var benefitTypes = isGrants ? [1, 2] : [0];
	      var hb = (0, _filter2.default)(benefits, function (benefit) {
	        return (0, _includes2.default)(benefitTypes, benefit.HrBenefitType);
	      });
	      var grants = [_react2.default.createElement(_KTitle2.default, { containerStyle: styles.titleContainer, key: 'hb', title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: isGrants ? 'benefit.grant.title' : 'benefit.health.title' }) }), (0, _map2.default)(hb, function (benefit, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key, style: { margin: 24 } },
	          _react2.default.createElement(_KBenefit2.default, _extends({}, benefit, {
	            loading: (0, _get2.default)(benefitLoadingById, benefit.HrBenefitID, false),
	            onUpload: onBenefitUpload,
	            onRequestGrant: onRequestGrant,
	            onEmail: onSendEmail,
	            employeeName: employeeName
	          }))
	        );
	      })];
	      return _react2.default.createElement(
	        'div',
	        { style: styles.container },
	        !hb || !hb.length ? _react2.default.createElement('div', null) : grants
	      );
	    }
	  }]);
	
	  return Benefits;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    valuesByKey: state.WebValuesReducer.valuesByKey,
	    loaded: state.BenefitsReducer.loaded,
	    benefits: state.BenefitsReducer.benefits,
	    benefitLoadingById: state.BenefitsReducer.benefitLoadingById,
	    employeeName: state.profileReducer.employeeMaster ? state.profileReducer.employeeMaster.EmployeeName : ''
	  };
	}
	
	Benefits.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	Benefits.propTypes = {
	  loaded: _propTypes2.default.bool,
	  fetch: _propTypes2.default.func.isRequired,
	  valuesByKey: _propTypes2.default.object,
	  benefitLoadingById: _propTypes2.default.object,
	  benefits: _propTypes2.default.array,
	  onBenefitUpload: _propTypes2.default.func.isRequired,
	  onRequestGrant: _propTypes2.default.func.isRequired,
	  onSendEmail: _propTypes2.default.func.isRequired,
	  employeeName: _propTypes2.default.string
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
	  return {
	    fetch: function fetch() {
	      dispatch((0, _Benefits.fetchBenefits)());dispatch((0, _Files.initUpload)());dispatch((0, _profile.fetchProfileIfNeeded)());
	    },
	    onRequestGrant: function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var _args = arguments;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                return _context.abrupt('return', dispatch(_Benefits.fitnessGrantRegisterAndUpload.apply(undefined, _args)));
	
	              case 1:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined);
	      }));
	
	      return function onRequestGrant() {
	        return _ref.apply(this, arguments);
	      };
	    }(),
	    onBenefitUpload: function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(files, fileType, cb, Email, EmailCallBack) {
	        return regeneratorRuntime.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                return _context2.abrupt('return', dispatch((0, _Benefits2.benefitUpload)({ files: files, fileType: fileType }, cb, Email, EmailCallBack)));
	
	              case 1:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, undefined);
	      }));
	
	      return function onBenefitUpload(_x, _x2, _x3, _x4, _x5) {
	        return _ref2.apply(this, arguments);
	      };
	    }(),
	    onSendEmail: function onSendEmail(email) {
	      return dispatch((0, _Email.requestSendEmail)(email, function () {
	        dispatch((0, _reapop.addNotification)({
	          title: 'Sent',
	          message: 'Tölvupóstur hefur verið sendur með viðhengi',
	          status: 'success',
	          dismissible: true,
	          dismissAfter: 4000
	        }));
	      }));
	    }
	  };
	})(Benefits);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(Benefits, 'Benefits', 'D:/a/1/s/src/web/employee/src/containers/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/Benefits.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Benefits.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(67);
	
	var _CourseEvaluation = __webpack_require__(421);
	
	var _reactIntl = __webpack_require__(5);
	
	var _flowRight = __webpack_require__(202);
	
	var _flowRight2 = _interopRequireDefault(_flowRight);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _merge = __webpack_require__(576);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _find2 = __webpack_require__(263);
	
	var _find3 = _interopRequireDefault(_find2);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _QAElement = __webpack_require__(284);
	
	var _QAElement2 = _interopRequireDefault(_QAElement);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Subheader = __webpack_require__(115);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _RaisedButton = __webpack_require__(114);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _KListItem = __webpack_require__(184);
	
	var _KListItem2 = _interopRequireDefault(_KListItem);
	
	var _CircularProgress = __webpack_require__(170);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  header: {
	    paddingLeft: 0,
	    fontSize: 20,
	    fontWeight: 300,
	    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif'
	  },
	  info: {
	    display: 'flex',
	    flexDirection: 'row',
	    flexWrap: 'wrap',
	    marginBottom: 16
	  },
	  infoItem: {
	    minWidth: 200,
	    display: 'flex',
	    flex: 1
	  }
	};
	
	var validate = function validate(values, props) {
	  var error = {};
	  var evaluation = props.evaluation;
	
	  if (!evaluation) {
	    return error;
	  }
	  var questions = evaluation.CourseEvaluation.QAElements.filter(function (q) {
	    return q.QAElementType === 3;
	  });
	
	  (0, _map2.default)(questions, function (_ref) {
	    var QAElementID = _ref.QAElementID,
	        QAInput = _ref.QAInput,
	        MinAnswers = _ref.MinAnswers;
	
	    /* No validation on checkbox questions */
	    if (QAInput.QAInputAnswerType === 3) {
	      return;
	    }
	    var key = QAInput.QAInputAnswerType + '-' + QAElementID;
	    /* First check if element is equired */
	    if (MinAnswers > 0 && !values[key]) {
	      error[key] = 'Þetta svæði verður að vera útfyllt';
	      /* Second check if element has mask */
	    } else if (QAInput && QAInput.QAMaskEntity) {
	      if (QAInput.QAInputAnswerType === 5) {
	        return;
	      }
	      var _QAInput$QAMaskEntity = QAInput.QAMaskEntity,
	          QAMaskString = _QAInput$QAMaskEntity.QAMaskString,
	          QAMaskDescription = _QAInput$QAMaskEntity.QAMaskDescription;
	      /* Create regex for the mask */
	
	      var re = new RegExp(QAMaskString, 'i');
	      if (!re.test(values[key])) {
	        error[key] = QAMaskDescription;
	      }
	    }
	  });
	
	  return error;
	};
	
	var CourseEvaluation = function (_React$Component) {
	  _inherits(CourseEvaluation, _React$Component);
	
	  function CourseEvaluation() {
	    var _ref2;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CourseEvaluation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = CourseEvaluation.__proto__ || Object.getPrototypeOf(CourseEvaluation)).call.apply(_ref2, [this].concat(args))), _this), _this.save = function () {
	      var _this2;
	
	      return (_this2 = _this).__save__REACT_HOT_LOADER__.apply(_this2, arguments);
	    }, _this.submit = function () {
	      var _this3;
	
	      return (_this3 = _this).__submit__REACT_HOT_LOADER__.apply(_this3, arguments);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CourseEvaluation, [{
	    key: '__submit__REACT_HOT_LOADER__',
	    value: function __submit__REACT_HOT_LOADER__() {
	      return this.__submit__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__save__REACT_HOT_LOADER__',
	    value: function __save__REACT_HOT_LOADER__() {
	      return this.__save__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetch(this.props.routeParams.CourseAttendeeID);
	      window.scrollTo(0, 0);
	    }
	  }, {
	    key: '__save__REACT_HOT_LOADER__',
	    value: function __save__REACT_HOT_LOADER__(data, dispatch) {
	      return dispatch((0, _CourseEvaluation.saveEvaluation)(data, this.props.routeParams.CourseAttendeeID));
	    }
	  }, {
	    key: '__submit__REACT_HOT_LOADER__',
	    value: function __submit__REACT_HOT_LOADER__(data, dispatch) {
	      return dispatch((0, _CourseEvaluation.submitEvaluation)(data, this.props.routeParams.CourseAttendeeID));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          evaluationSaving = _props.evaluationSaving,
	          evaluationSubmitting = _props.evaluationSubmitting,
	          evaluationError = _props.evaluationError,
	          hasEvaluationError = _props.hasEvaluationError,
	          handleSubmit = _props.handleSubmit,
	          evaluation = _props.evaluation,
	          loaded = _props.loaded,
	          invalid = _props.invalid;
	
	
	      if (hasEvaluationError) {
	        return _react2.default.createElement(_PanelMessage2.default, { message: evaluationError && (evaluationError.message || evaluationError.Message), type: 'error', iconName: 'error' });
	      }
	
	      if (!loaded) {
	        return _react2.default.createElement(_Loading2.default, null);
	      }
	
	      var isSubmitted = evaluation && evaluation.CourseAttendee && evaluation.CourseAttendee.EvaluationStatus === 2;
	
	      return _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 12, md: 10, mdOffset: 1, style: { paddingBottom: 16 } },
	        _react2.default.createElement(
	          _Subheader2.default,
	          { style: styles.header },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courseEval.title' })
	        ),
	        isSubmitted && _react2.default.createElement(_PanelMessage2.default, {
	          type: 'success',
	          iconName: 'check',
	          message: 'B\xFAi\xF0 er a\xF0 skila \xFEessu n\xE1mskei\xF0smati'
	        }),
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: styles.info },
	          _react2.default.createElement(
	            'div',
	            { style: styles.infoItem },
	            _react2.default.createElement(_KListItem2.default, {
	              disabled: true,
	              primaryText: evaluation.CourseAttendee.CourseName,
	              secondaryText: 'N\xE1mskei\xF0'
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.infoItem },
	            _react2.default.createElement(_KListItem2.default, {
	              disabled: true,
	              primaryText: evaluation.CourseEvaluation.CourseEvaluationName,
	              secondaryText: 'N\xE1mskei\xF0smat'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'form',
	          null,
	          evaluation.CourseEvaluation.QAElements.map(function (e) {
	            return _react2.default.createElement(_QAElement2.default, _extends({
	              key: e.QAElementID,
	              disabled: isSubmitted
	            }, e));
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'flex', justifyContent: 'flex-end' } },
	            _react2.default.createElement(_RaisedButton2.default, {
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courseEval.save' }),
	              primary: true,
	              icon: evaluationSaving && _react2.default.createElement(_CircularProgress2.default, { style: { lineHeight: '16px' }, size: 16, thickness: 2 }),
	              disabled: evaluationSaving || evaluationSubmitting || isSubmitted,
	              onClick: handleSubmit(this.save)
	            }),
	            _react2.default.createElement(_RaisedButton2.default, {
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courseEval.submit' }),
	              icon: evaluationSubmitting && _react2.default.createElement(_CircularProgress2.default, { style: { lineHeight: '16px' }, size: 16, thickness: 2 }),
	              secondary: true,
	              style: { marginLeft: 16 },
	              disabled: invalid || evaluationSaving || evaluationSubmitting || isSubmitted,
	              onClick: handleSubmit(this.submit)
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CourseEvaluation;
	}(_react2.default.Component);
	
	CourseEvaluation.propTypes = {
	  routeParams: _propTypes2.default.shape({
	    CourseAttendeeID: _propTypes2.default.string.isRequired
	  }),
	  handleSubmit: _propTypes2.default.func.isRequired,
	  fetch: _propTypes2.default.func.isRequired,
	  evaluationError: _propTypes2.default.shape({
	    message: _propTypes2.default.string,
	    Message: _propTypes2.default.string
	  }),
	  evaluation: _propTypes2.default.shape({
	    CourseAttendee: _propTypes2.default.shape({
	      CourseName: _propTypes2.default.string,
	      EvaluationStatus: _propTypes2.default.oneOf([0, 1, 2])
	    }),
	    CourseEvaluation: _propTypes2.default.shape({
	      CourseEvaluationName: _propTypes2.default.string,
	      QAElements: _propTypes2.default.array
	    })
	  }),
	  hasEvaluationError: _propTypes2.default.bool.isRequired,
	  loaded: _propTypes2.default.bool.isRequired,
	  invalid: _propTypes2.default.bool.isRequired,
	  evaluationSaving: _propTypes2.default.bool.isRequired,
	  evaluationSubmitting: _propTypes2.default.bool.isRequired
	};
	
	var answersFromEvaluation = function answersFromEvaluation(evaluation) {
	  if (!evaluation || !evaluation.CourseEvaluation || !evaluation.CourseEvaluationAnswers) {
	    return {};
	  }
	  var QAAnswers = evaluation.CourseEvaluationAnswers;
	  var QAElements = evaluation.CourseEvaluation.QAElements;
	
	  var elems = (0, _map2.default)(QAAnswers, function (_ref3) {
	    var _ref6;
	
	    var QAElementID = _ref3.QAElementID,
	        QAAnswerText = _ref3.QAAnswerText,
	        QAAnswerValue = _ref3.QAAnswerValue,
	        QAAnswerComment = _ref3.QAAnswerComment;
	
	    var _find = (0, _find3.default)(QAElements, ['QAElementID', QAElementID]),
	        QAInput = _find.QAInput;
	
	    if (!QAInput) {
	      return {};
	    }
	    var QAInputAnswerType = QAInput.QAInputAnswerType;
	
	    var key = QAInputAnswerType + '-' + QAElementID + (QAInputAnswerType === 3 ? '-' + btoa(QAAnswerText) : '');
	    if (QAInputAnswerType === 3) {
	      var _ref4;
	
	      return _ref4 = {}, _defineProperty(_ref4, key, QAAnswerValue === 'true'), _defineProperty(_ref4, 'COMMENT-' + QAInputAnswerType + '-' + QAElementID, QAAnswerComment), _ref4;
	    } else if (QAInputAnswerType === 2 || QAInputAnswerType === 6) {
	      var _ref5;
	
	      return _ref5 = {}, _defineProperty(_ref5, key, Number(QAAnswerValue)), _defineProperty(_ref5, 'COMMENT-' + QAInputAnswerType + '-' + QAElementID, QAAnswerComment), _ref5;
	    }
	    return _ref6 = {}, _defineProperty(_ref6, key, QAAnswerValue), _defineProperty(_ref6, 'COMMENT-' + QAInputAnswerType + '-' + QAElementID, QAAnswerComment), _ref6;
	  });
	  // Merge the array of fields into one state object.
	  return _merge2.default.apply(undefined, _toConsumableArray(elems));
	};
	
	var _default = (0, _flowRight2.default)((0, _reactRedux.connect)(function (_ref7, _ref8) {
	  var CourseEvaluationReducer = _ref7.CourseEvaluationReducer;
	  var routeParams = _ref8.routeParams;
	  return _extends({}, CourseEvaluationReducer, {
	    evaluation: CourseEvaluationReducer.evaluationById[routeParams.CourseAttendeeID],
	    loaded: CourseEvaluationReducer.evaluationLoadedById[routeParams.CourseAttendeeID] || false,
	    initialValues: answersFromEvaluation(CourseEvaluationReducer.evaluationById[routeParams.CourseAttendeeID])
	  });
	}, function (dispatch) {
	  return {
	    fetch: function fetch(id) {
	      return dispatch((0, _CourseEvaluation.fetchEvaluation)(id));
	    }
	  };
	}), (0, _reduxForm.reduxForm)({
	  form: 'evaluation',
	  enableReinitialize: true,
	  validate: validate
	}))(CourseEvaluation);
	
	exports.default = _default;
	;
	
	var _temp2 = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', 'D:/a/1/s/src/web/employee/src/containers/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(CourseEvaluation, 'CourseEvaluation', 'D:/a/1/s/src/web/employee/src/containers/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(answersFromEvaluation, 'answersFromEvaluation', 'D:/a/1/s/src/web/employee/src/containers/CourseEvaluation.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/CourseEvaluation.js');
	}();

	;

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactModal = __webpack_require__(391);
	
	var _reactModal2 = _interopRequireDefault(_reactModal);
	
	var _valuesByKey = __webpack_require__(92);
	
	var _courses = __webpack_require__(281);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _Alert = __webpack_require__(145);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _DetailList = __webpack_require__(221);
	
	var _DetailList2 = _interopRequireDefault(_DetailList);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _KCourse = __webpack_require__(866);
	
	var _KCourse2 = _interopRequireDefault(_KCourse);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _Questionnaire = __webpack_require__(920);
	
	var _Questionnaire2 = _interopRequireDefault(_Questionnaire);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  container: {
	    paddingTop: 16,
	    paddingBottom: 16,
	    display: 'flex',
	    alignItems: 'center',
	    flexDirection: 'row',
	    flexWrap: 'wrap',
	    maxWidth: 1344,
	    margin: 'auto'
	  },
	  titleContainer: {
	    width: '100%'
	  },
	  title: {
	    fontSize: 32,
	    marginTop: 12,
	    marginBottom: 12
	  }
	};
	
	var optFields = ['CourseCost', 'CourseDeadlineStart', 'CourseDeadlineEnd'];
	
	var attendIsOk = function attendIsOk(_ref) {
	  var CourseDeadlineStart = _ref.entity.CourseDeadlineStart,
	      CourseAttendingAvailable = _ref.CourseAttendingAvailable,
	      CourseBegda = _ref.CourseBegda;
	
	  if (!CourseAttendingAvailable.value) return false;
	  var start = new Date(CourseBegda.entityValue);
	  var buffer = CourseDeadlineStart || 0;
	  start.setHours(start.getHours() - buffer);
	  if (Date.now() < start.getTime()) return true;
	  return false;
	};
	
	var leaveIsOk = function leaveIsOk(_ref2) {
	  var CourseDeadlineEnd = _ref2.entity.CourseDeadlineEnd,
	      CourseStatusPlannedName = _ref2.CourseStatusPlannedName,
	      CourseBegda = _ref2.CourseBegda;
	
	  if (CourseStatusPlannedName.value !== 'Virkt') return false;
	  var start = new Date(CourseBegda.entityValue);
	  var buffer = CourseDeadlineEnd || 0;
	  start.setHours(start.getHours() - buffer);
	  if (Date.now() < start.getTime()) return true;
	  return false;
	};
	
	var Courses = function (_Component) {
	  _inherits(Courses, _Component);
	
	  function Courses(props) {
	    _classCallCheck(this, Courses);
	
	    var _this = _possibleConstructorReturn(this, (Courses.__proto__ || Object.getPrototypeOf(Courses)).call(this, props));
	
	    _this.onKeyPress = function () {
	      return _this.__onKeyPress__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.checkRoute = function () {
	      return _this.__checkRoute__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.mapAttendAction = function () {
	      return _this.__mapAttendAction__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.mapLeaveAction = function () {
	      return _this.__mapLeaveAction__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.closeDialog = function () {
	      return _this.__closeDialog__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.closeAlert = function () {
	      return _this.__closeAlert__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.closeQuestionnaire = function () {
	      return _this.__closeQuestionnaire__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.leave = function () {
	      return _this.__leave__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.attend = function () {
	      return _this.__attend__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.attendCheck = (0, _lodash.debounce)(function (courseId, questionnaireRootID) {
	      if (questionnaireRootID) {
	        _this.setState({
	          dialogOpen: false,
	          questionnaireDialogOpen: true,
	          questionnaireRootID: questionnaireRootID,
	          questionnaireCourseId: courseId
	        });
	      } else {
	        _this.attend(courseId);
	      }
	    }, 1200, {
	      leading: true,
	      trailing: false
	    });
	
	    _this.state = {
	      alertOpen: false,
	      dialogOpen: false,
	      dialogContent: [],
	      questionnaireDialogOpen: false,
	      questionnaireRootID: null,
	      questionnaireCourseId: 0
	    };
	    return _this;
	  }
	
	  _createClass(Courses, [{
	    key: '__attend__REACT_HOT_LOADER__',
	    value: function __attend__REACT_HOT_LOADER__() {
	      return this.__attend__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__leave__REACT_HOT_LOADER__',
	    value: function __leave__REACT_HOT_LOADER__() {
	      return this.__leave__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__closeQuestionnaire__REACT_HOT_LOADER__',
	    value: function __closeQuestionnaire__REACT_HOT_LOADER__() {
	      return this.__closeQuestionnaire__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__closeAlert__REACT_HOT_LOADER__',
	    value: function __closeAlert__REACT_HOT_LOADER__() {
	      return this.__closeAlert__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__closeDialog__REACT_HOT_LOADER__',
	    value: function __closeDialog__REACT_HOT_LOADER__() {
	      return this.__closeDialog__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__mapLeaveAction__REACT_HOT_LOADER__',
	    value: function __mapLeaveAction__REACT_HOT_LOADER__() {
	      return this.__mapLeaveAction__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__mapAttendAction__REACT_HOT_LOADER__',
	    value: function __mapAttendAction__REACT_HOT_LOADER__() {
	      return this.__mapAttendAction__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__checkRoute__REACT_HOT_LOADER__',
	    value: function __checkRoute__REACT_HOT_LOADER__() {
	      return this.__checkRoute__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__onKeyPress__REACT_HOT_LOADER__',
	    value: function __onKeyPress__REACT_HOT_LOADER__() {
	      return this.__onKeyPress__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _courses.fetchCoursesIfNeeded)());
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('keydown', this.onKeyPress);
	      this.checkRoute(this.props);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.checkRoute(nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this.onKeyPress);
	    }
	  }, {
	    key: '__onKeyPress__REACT_HOT_LOADER__',
	    value: function __onKeyPress__REACT_HOT_LOADER__(event) {
	      if (event.keyCode === 27 && this.state.dialogOpen) {
	        this.closeDialog();
	      }
	    }
	  }, {
	    key: 'getContent',
	    value: function getContent(current) {
	      var valuesByKey = this.props.valuesByKey;
	
	      return current.detailFields.filter(function (f) {
	        return !optFields.includes(f) ? true : (0, _lodash.get)(valuesByKey, ['Show.Course.' + f, 'Value']) === 'true';
	      }).map(function (f) {
	        return current[f];
	      });
	    }
	  }, {
	    key: '__checkRoute__REACT_HOT_LOADER__',
	    value: function __checkRoute__REACT_HOT_LOADER__(props) {
	      var _this2 = this;
	
	      var courseId = props.router.params.courseId;
	      if (props.loaded && courseId) {
	        var current = props.openCourses.find(function (o) {
	          return o.CourseID.value.toString() === courseId;
	        });
	        if (current !== undefined) {
	          var dialogContent = this.getContent(current);
	          var dialogAction = _react2.default.createElement(_materialUi.RaisedButton, {
	            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.attend' }),
	            primary: true,
	            disabled: !attendIsOk(current),
	            onClick: function onClick() {
	              return _this2.attendCheck(current.CourseID.value, current.entity.QAElementID);
	            }
	          });
	          this.setState({ dialogContent: dialogContent, dialogOpen: true, dialogAction: dialogAction });
	        } else {
	          current = props.attendingCourses.find(function (a) {
	            return a.CourseID.value.toString() === courseId;
	          });
	          if (current === undefined) return;
	          var _dialogContent = this.getContent(current);
	          var _dialogAction = _react2.default.createElement(_materialUi.RaisedButton, {
	            'data-cy': 'button-leave',
	            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.leave' }),
	            secondary: true,
	            disabled: !leaveIsOk(current),
	            onClick: function onClick() {
	              return _this2.setState({ courseId: current.CourseID.value, courseAttendeeId: current.CourseAttendeeID.value, alertOpen: true });
	            }
	          });
	          this.setState({ dialogContent: _dialogContent, dialogOpen: true, dialogAction: _dialogAction });
	        }
	      }
	    }
	  }, {
	    key: '__mapAttendAction__REACT_HOT_LOADER__',
	    value: function __mapAttendAction__REACT_HOT_LOADER__(c) {
	      var _this3 = this;
	
	      var dialogContent = this.getContent(c);
	      var dialogAction = _react2.default.createElement(_materialUi.RaisedButton, {
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.attend' }),
	        primary: true,
	        disabled: !attendIsOk(c),
	        onClick: function onClick() {
	          return _this3.attendCheck(c.CourseID.value, c.entity.QAElementID);
	        }
	      });
	      return _extends({}, c, {
	        actions: [{
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.attend' }),
	          primary: true,
	          disabled: !attendIsOk(c),
	          action: function action() {
	            return _this3.attendCheck(c.CourseID.value, c.entity.QAElementID);
	          }
	        }, {
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.details' }),
	          action: function action() {
	            _this3.setState({ dialogContent: dialogContent, dialogOpen: true, dialogAction: dialogAction });
	          }
	        }]
	      });
	    }
	  }, {
	    key: '__mapLeaveAction__REACT_HOT_LOADER__',
	    value: function __mapLeaveAction__REACT_HOT_LOADER__(c) {
	      var _this4 = this;
	
	      var dialogContent = this.getContent(c);
	      var dialogAction = _react2.default.createElement(_materialUi.RaisedButton, {
	        'data-cy': 'button-leave',
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.leave' }),
	        secondary: true,
	        disabled: !leaveIsOk(c),
	        onClick: function onClick() {
	          return _this4.setState({ courseId: c.CourseID.value, courseAttendeeId: c.CourseAttendeeID.value, alertOpen: true });
	        }
	      });
	      return _extends({}, c, {
	        actions: [{
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.leave' }),
	          secondary: true,
	          disabled: !leaveIsOk(c),
	          action: function action() {
	            return _this4.setState({ courseId: c.CourseID.value, courseAttendeeId: c.CourseAttendeeID.value, alertOpen: true });
	          } // this.props.dispatch(leaveCourse(c.CourseAttendeeID.value)),
	        }, {
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.details' }),
	          action: function action() {
	            return _this4.setState({ dialogContent: dialogContent, dialogOpen: true, dialogAction: dialogAction });
	          }
	        }]
	      });
	    }
	  }, {
	    key: '__closeDialog__REACT_HOT_LOADER__',
	    value: function __closeDialog__REACT_HOT_LOADER__() {
	      var _this5 = this;
	
	      this.setState({ dialogOpen: false, dialogContent: [], dialogAction: null }, function () {
	        if (_this5.props.location.query.dashboard) _this5.context.router.push({ pathname: '/' });
	        if (_this5.context.router.params.courseId) _this5.context.router.push({ pathname: '/events' });
	      });
	    }
	  }, {
	    key: '__closeAlert__REACT_HOT_LOADER__',
	    value: function __closeAlert__REACT_HOT_LOADER__() {
	      return this.setState({ alertOpen: false });
	    }
	  }, {
	    key: '__closeQuestionnaire__REACT_HOT_LOADER__',
	    value: function __closeQuestionnaire__REACT_HOT_LOADER__() {
	      return this.setState({ questionnaireDialogOpen: false, questionnaireRootID: null, questionnaireCourseId: 0 });
	    }
	  }, {
	    key: '__leave__REACT_HOT_LOADER__',
	    value: function __leave__REACT_HOT_LOADER__() {
	      this.props.dispatch((0, _courses.leaveCourse)(this.state.courseAttendeeId, this.state.courseId));this.closeAlert();this.closeDialog();
	    }
	  }, {
	    key: '__attend__REACT_HOT_LOADER__',
	    value: function __attend__REACT_HOT_LOADER__(courseId, answerRootId) {
	      this.props.dispatch((0, _courses.attendCourse)(courseId, answerRootId));
	      this.closeQuestionnaire();
	      this.closeDialog();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this6 = this;
	
	      var _props = this.props,
	          openCourses = _props.openCourses,
	          attendingCourses = _props.attendingCourses,
	          showErrorMessage = _props.showErrorMessage,
	          coursesError = _props.coursesError,
	          loaded = _props.loaded,
	          valuesByKey = _props.valuesByKey,
	          Gender = _props.Gender,
	          EmployeeMasterID = _props.EmployeeMasterID;
	      var _state = this.state,
	          alertOpen = _state.alertOpen,
	          dialogOpen = _state.dialogOpen,
	          dialogContent = _state.dialogContent,
	          dialogAction = _state.dialogAction,
	          questionnaireDialogOpen = _state.questionnaireDialogOpen,
	          questionnaireRootID = _state.questionnaireRootID,
	          questionnaireCourseId = _state.questionnaireCourseId;
	
	
	      if (!loaded) {
	        return _react2.default.createElement(_Loading2.default, null);
	      }
	
	      if (showErrorMessage) {
	        return _react2.default.createElement(_PanelMessage2.default, { message: coursesError, iconName: 'error', type: 'error' });
	      }
	
	      var useGroup = (0, _valuesByKey.shouldUse)(valuesByKey, 'CourseGroup');
	      var useEvents = (0, _valuesByKey.shouldUse)(valuesByKey, 'Events');
	      var useCourseOrderReverse = (0, _valuesByKey.shouldUse)(valuesByKey, 'CourseOrderReverse');
	
	      var attendingCoursesWithActions = (0, _lodash.map)(attendingCourses, this.mapLeaveAction);
	      var openCoursesWithAction = (0, _lodash.map)(openCourses, this.mapAttendAction);
	
	      var groupedOpenCourses = useGroup ? (0, _lodash.groupBy)(openCoursesWithAction, function (c) {
	        return c.CourseGroupName.entityValue;
	      }) : (0, _lodash.groupBy)(openCoursesWithAction, function (c) {
	        return c.CourseTypeName.entityValue;
	      });
	
	      var attMess = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.attending' });
	
	      if (Gender === '1') {
	        attMess = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.attending.male' });
	      } else if (Gender === '2') {
	        attMess = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.attending.female' });
	      }
	
	      var attendingC = attendingCoursesWithActions && attendingCoursesWithActions.length ? [_react2.default.createElement(_KTitle2.default, { containerStyle: styles.titleContainer, key: 'wertyuio', title: attMess }), (0, _lodash.map)((0, _lodash.orderBy)(attendingCoursesWithActions, [function (c) {
	        return new Date(c.CourseBegda.entityValue).getTime();
	      }], ['asc']), function (course) {
	        return _react2.default.createElement(_KCourse2.default, _extends({ Gender: Gender, useGroup: useGroup, key: course.CourseID.value, attending: true, EmployeeMasterID: EmployeeMasterID }, course));
	      })] : [];
	
	      var openC = (0, _lodash.map)(groupedOpenCourses, function (group, key) {
	        return [_react2.default.createElement(_KTitle2.default, { containerStyle: styles.titleContainer, key: key, title: useGroup ? group[0].CourseGroupName.value : group[0].CourseTypeName.value }), (0, _lodash.map)((0, _lodash.orderBy)(group, [function (c) {
	          return new Date(c.CourseBegda.entityValue).getTime();
	        }], ['asc']), function (course) {
	          return _react2.default.createElement(_KCourse2.default, _extends({ Gender: Gender, useGroup: useGroup, key: course.CourseID.value, EmployeeMasterID: EmployeeMasterID }, course));
	        })];
	      });
	
	      var courses = [attendingC, openC];
	      var empty = !courses || !(0, _lodash.flattenDeep)(courses).length;
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.container },
	        _react2.default.createElement(_KTitle2.default, {
	          title: useEvents ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'events.title' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.title' }),
	          style: styles.title,
	          containerStyle: styles.titleContainer
	        }),
	        _react2.default.createElement(
	          _materialUi.Dialog,
	          {
	            contentStyle: { overflow: 'hidden' },
	            open: dialogOpen,
	            onRequestClose: this.closeDialog,
	            autoScrollBodyContent: true,
	            actions: [dialogAction]
	          },
	          _react2.default.createElement(
	            _materialUi.IconButton,
	            {
	              style: { margin: -24, float: 'right' },
	              iconClassName: 'material-icons',
	              onClick: this.closeDialog
	            },
	            'close'
	          ),
	          _react2.default.createElement(_DetailList2.default, { itemMaxWidth: 350, dataSource: dialogContent })
	        ),
	        questionnaireRootID && _react2.default.createElement(
	          _reactModal2.default
	          // overlayStyle={{ padding: 0 }}
	          ,
	          { isOpen: questionnaireDialogOpen,
	            onRequestClose: this.closeQuestionnaire,
	            style: {
	              content: {
	                top: '50%',
	                left: '50%',
	                right: 'auto',
	                bottom: 'auto',
	                marginRight: '-50%',
	                transform: 'translate(-50%, -50%)'
	              }
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { style: { minWidth: '50vw', height: '64vh' } },
	            _react2.default.createElement(_Questionnaire2.default, {
	              questionnaireRootID: questionnaireRootID,
	              onSuccess: function onSuccess(answerRootId) {
	                return _this6.attend(questionnaireCourseId, answerRootId);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(_Alert2.default, {
	          open: alertOpen,
	          onOk: this.leave,
	          onCancel: this.closeAlert,
	          text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.alert' })
	        }),
	        empty && _react2.default.createElement(
	          'div',
	          { style: { marginLeft: 16 } },
	          _react2.default.createElement(_PanelMessage2.default, { type: 'info', iconName: 'info', message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courses.empty' }) })
	        ),
	        useCourseOrderReverse ? (0, _lodash.reverse)(courses) : courses
	      );
	    }
	  }]);
	
	  return Courses;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  return {
	    valuesByKey: state.WebValuesReducer.valuesByKey,
	    loaded: state.coursesReducer.coursesLoaded,
	    gender: state.loginReducer.user.GenderType,
	    openCourses: state.coursesReducer.openCourses,
	    attendingCourses: state.coursesReducer.attendingCourses,
	    showErrorMessage: (state.coursesReducer.coursesError && state.coursesReducer.coursesError.Message.length) > 0,
	    coursesError: state.coursesReducer.coursesError && state.coursesReducer.coursesError.Message,
	    Gender: state.loginReducer.user && state.loginReducer.user.Gender,
	    EmployeeMasterID: (0, _lodash.get)(state, 'loginReducer.user.EmployeeMasterID', 0)
	  };
	}
	
	Courses.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	Courses.propTypes = {
	  loaded: _propTypes2.default.bool,
	  dispatch: _propTypes2.default.func.isRequired,
	  openCourses: _propTypes2.default.array,
	  attendingCourses: _propTypes2.default.array,
	  showErrorMessage: _propTypes2.default.bool,
	  coursesError: _propTypes2.default.string,
	  Gender: _propTypes2.default.string.isRequired,
	  EmployeeMasterID: _propTypes2.default.number.isRequired,
	  valuesByKey: _propTypes2.default.object,
	  location: _propTypes2.default.object
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(Courses);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/Courses.js');
	
	  __REACT_HOT_LOADER__.register(optFields, 'optFields', 'D:/a/1/s/src/web/employee/src/containers/Courses.js');
	
	  __REACT_HOT_LOADER__.register(attendIsOk, 'attendIsOk', 'D:/a/1/s/src/web/employee/src/containers/Courses.js');
	
	  __REACT_HOT_LOADER__.register(leaveIsOk, 'leaveIsOk', 'D:/a/1/s/src/web/employee/src/containers/Courses.js');
	
	  __REACT_HOT_LOADER__.register(Courses, 'Courses', 'D:/a/1/s/src/web/employee/src/containers/Courses.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/Courses.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Courses.js');
	}();

	;

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _lodash = __webpack_require__(8);
	
	var _valuesByKey = __webpack_require__(92);
	
	var _TPMAppraisals = __webpack_require__(947);
	
	var _TPMAppraisals2 = _interopRequireDefault(_TPMAppraisals);
	
	var _TProfile = __webpack_require__(950);
	
	var _TProfile2 = _interopRequireDefault(_TProfile);
	
	var _TBirthdays = __webpack_require__(938);
	
	var _TBirthdays2 = _interopRequireDefault(_TBirthdays);
	
	var _TEvents = __webpack_require__(941);
	
	var _TEvents2 = _interopRequireDefault(_TEvents);
	
	var _TLinks = __webpack_require__(946);
	
	var _TLinks2 = _interopRequireDefault(_TLinks);
	
	var _THoliday = __webpack_require__(944);
	
	var _THoliday2 = _interopRequireDefault(_THoliday);
	
	var _TEvaluations = __webpack_require__(940);
	
	var _TEvaluations2 = _interopRequireDefault(_TEvaluations);
	
	var _TGrants = __webpack_require__(943);
	
	var _TGrants2 = _interopRequireDefault(_TGrants);
	
	var _TBenefits = __webpack_require__(937);
	
	var _TBenefits2 = _interopRequireDefault(_TBenefits);
	
	var _TAgreements = __webpack_require__(936);
	
	var _TAgreements2 = _interopRequireDefault(_TAgreements);
	
	var _TTransportationGrants = __webpack_require__(953);
	
	var _TTransportationGrants2 = _interopRequireDefault(_TTransportationGrants);
	
	var _TTime = __webpack_require__(951);
	
	var _TTime2 = _interopRequireDefault(_TTime);
	
	var _KTile = __webpack_require__(868);
	
	var _KTile2 = _interopRequireDefault(_KTile);
	
	var _getAppraisalTitle = __webpack_require__(148);
	
	var _getAppraisalTitle2 = _interopRequireDefault(_getAppraisalTitle);
	
	var _TEmployeeMasterCourseRequest = __webpack_require__(939);
	
	var _TEmployeeMasterCourseRequest2 = _interopRequireDefault(_TEmployeeMasterCourseRequest);
	
	var _THolidayRequest = __webpack_require__(945);
	
	var _THolidayRequest2 = _interopRequireDefault(_THolidayRequest);
	
	var _TPayslips = __webpack_require__(948);
	
	var _TPayslips2 = _interopRequireDefault(_TPayslips);
	
	var _TFiles = __webpack_require__(942);
	
	var _TFiles2 = _interopRequireDefault(_TFiles);
	
	var _TTimeEntries = __webpack_require__(952);
	
	var _TTimeEntries2 = _interopRequireDefault(_TTimeEntries);
	
	var _TPerDiem = __webpack_require__(949);
	
	var _TPerDiem2 = _interopRequireDefault(_TPerDiem);
	
	var _CourseEvaluation = __webpack_require__(421);
	
	var _Appraisal = __webpack_require__(180);
	
	var _api = __webpack_require__(225);
	
	var _courses = __webpack_require__(281);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  tiles: {
	    display: 'flex',
	    alignItems: 'center',
	    flexDirection: 'row',
	    justifyContent: 'center',
	    flexWrap: 'wrap',
	    maxWidth: 1344,
	    margin: 'auto',
	    marginBottom: 36
	  }
	};
	
	var tileConfig = {
	  profile: {
	    title: 'dash.title.profile',
	    component: function component() {
	      return _react2.default.createElement(_TProfile2.default, null);
	    }
	  },
	  holiday: {
	    title: 'dash.title.holiday',
	    component: function component() {
	      return _react2.default.createElement(_THoliday2.default, null);
	    }
	  },
	  events: {
	    title: 'dash.title.courses',
	    component: function component() {
	      return _react2.default.createElement(_TEvents2.default, null);
	    }
	  },
	  evaluations: {
	    title: 'dash.title.evaluations',
	    component: function component() {
	      return _react2.default.createElement(_TEvaluations2.default, null);
	    }
	  },
	  appraisals: {
	    title: 'dash.title.appraisals',
	    component: function component() {
	      return _react2.default.createElement(_TPMAppraisals2.default, null);
	    }
	  },
	  birthdays: {
	    title: 'dash.title.birthdays',
	    component: function component() {
	      return _react2.default.createElement(_TBirthdays2.default, null);
	    }
	  },
	  links: {
	    title: 'dash.title.links',
	    component: function component() {
	      return _react2.default.createElement(_TLinks2.default, null);
	    }
	  },
	  grants: {
	    title: 'dash.title.grants',
	    component: function component() {
	      return _react2.default.createElement(_TGrants2.default, null);
	    }
	  },
	  benefits: {
	    title: 'dash.title.benefits',
	    component: function component() {
	      return _react2.default.createElement(_TBenefits2.default, null);
	    }
	  },
	  transportations: {
	    title: 'dash.title.transportations',
	    component: function component() {
	      return _react2.default.createElement(_TTransportationGrants2.default, null);
	    }
	  },
	  agreements: {
	    title: 'dash.title.agreements',
	    component: function component() {
	      return _react2.default.createElement(_TAgreements2.default, null);
	    }
	  },
	  time: {
	    title: 'dash.title.punchClock',
	    component: function component() {
	      return _react2.default.createElement(_TTime2.default, null);
	    }
	  },
	  timeentries: {
	    title: 'dash.title.timeEntries',
	    component: function component() {
	      return _react2.default.createElement(_TTimeEntries2.default, null);
	    }
	  },
	  courseapprovalrequest: {
	    title: 'dash.title.courseApprovalRequest',
	    component: function component() {
	      return _react2.default.createElement(_TEmployeeMasterCourseRequest2.default, null);
	    }
	  },
	  holidayapprovalrequest: {
	    title: 'dash.title.holidayApprovalRequest',
	    component: function component() {
	      return _react2.default.createElement(_THolidayRequest2.default, null);
	    }
	  },
	  payslips: {
	    title: 'dash.title.payslips',
	    component: function component() {
	      return _react2.default.createElement(_TPayslips2.default, null);
	    }
	  },
	  files: {
	    title: 'dash.title.files',
	    component: function component() {
	      return _react2.default.createElement(_TFiles2.default, null);
	    }
	  },
	  perdiem: {
	    title: 'dash.title.perDiem',
	    component: function component() {
	      return _react2.default.createElement(_TPerDiem2.default, null);
	    }
	  }
	};
	
	var defaultTiles = Object.keys(tileConfig);
	
	var Dashboard = function Dashboard(_ref) {
	  var valuesByKey = _ref.valuesByKey,
	      links = _ref.links;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      _useSelector$CourseEv = _useSelector.CourseEvaluationReducer,
	      evaluations = _useSelector$CourseEv.evaluations,
	      evaluationsLoaded = _useSelector$CourseEv.evaluationsLoaded,
	      _useSelector$Appraisa = _useSelector.Appraisal,
	      openAppraisals = _useSelector$Appraisa.openAppraisals,
	      appraisalLoading = _useSelector$Appraisa.loading,
	      _useSelector$coursesR = _useSelector.coursesReducer,
	      allCourses = _useSelector$coursesR.allCourses,
	      coursesLoaded = _useSelector$coursesR.coursesLoaded;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      filtered = _useState2[0],
	      setFiltered = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      newPMAppraisals = _useState4[0],
	      setNewPMAppraisals = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      newAppraisalsLoaded = _useState6[0],
	      setNewAppraisalsLoaded = _useState6[1];
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _CourseEvaluation.fetchEvaluations)());
	    dispatch((0, _Appraisal.fetchAppraisal)());
	    dispatch((0, _courses.fetchCoursesIfNeeded)());
	
	    // Fetch new PM appraisals
	    (0, _api.getPMEmployeeAppraisals)().then(function (response) {
	      var filteredAppraisals = (response.data || []).filter(function (a) {
	        return a.EmployeeDetailID === Number(localStorage.DefaultEmployeeDetailID);
	      });
	      setNewPMAppraisals(filteredAppraisals);
	      setNewAppraisalsLoaded(true);
	    }).catch(function () {
	      setNewPMAppraisals([]);
	      setNewAppraisalsLoaded(true);
	    });
	  }, [dispatch]);
	
	  // Keep archive title for old appraisals, use custom title from WebValues if exists
	  var customAppraisalTitle = (0, _getAppraisalTitle2.default)(valuesByKey);
	  if (customAppraisalTitle !== 'dash.title.appraisals') {
	    tileConfig.appraisals.title = customAppraisalTitle;
	  }
	  var timeTitle = (0, _lodash.get)(valuesByKey, ['TimeRegistration.Title', 'Value']);
	  if (timeTitle === 'Absence') {
	    tileConfig.timeentries.title = 'dash.title.timeEntries.Absence';
	  }
	  if ((0, _valuesByKey.shouldUse)(valuesByKey, 'Events')) {
	    tileConfig.events.title = 'dash.title.events';
	  }
	  if ((0, _lodash.isEmpty)(links)) {
	    tileConfig.links.hide = true;
	  }
	
	  var visibleTiles = (0, _lodash.get)(valuesByKey.Dashboard, 'Value');
	  var tiles = visibleTiles ? (0, _lodash.split)((0, _lodash.replace)((0, _lodash.toLower)(visibleTiles), /\s/, ''), ',') : defaultTiles;
	
	  (0, _react.useEffect)(function () {
	    if (evaluationsLoaded && coursesLoaded && !appraisalLoading && newAppraisalsLoaded) {
	      // APPAIL-9694 => hide events, evaluations and appraisals if no data
	      setFiltered((0, _lodash.filter)(tiles, function (t) {
	        var shouldShowTile = (0, _lodash.has)(tileConfig, t) && !tileConfig[t].hide;
	        if (t === 'events') {
	          return allCourses.length && shouldShowTile;
	        } else if (t === 'evaluations') {
	          return evaluations.length && shouldShowTile;
	        } else if (t === 'appraisals') {
	          var hasAppraisals = openAppraisals.length > 0 || newPMAppraisals.length > 0;
	          return hasAppraisals && shouldShowTile;
	        } else if (shouldShowTile) {
	          return true;
	        }
	        return false;
	      }));
	    }
	  }, [evaluationsLoaded, appraisalLoading, coursesLoaded, openAppraisals, newAppraisalsLoaded, newPMAppraisals]);
	
	  if (!evaluationsLoaded || !coursesLoaded || appraisalLoading || !newAppraisalsLoaded) {
	    return _react2.default.createElement(_Loading2.default, null);
	  }
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: styles.tiles },
	      (0, _lodash.map)(filtered, function (t) {
	        return _react2.default.createElement(
	          _KTile2.default,
	          { key: t, cy: t, title: tileConfig[t].title },
	          tileConfig[t].component()
	        );
	      })
	    )
	  );
	};
	
	Dashboard.propTypes = {
	  valuesByKey: _propTypes2.default.object,
	  links: _propTypes2.default.array
	};
	
	var _default = (0, _reactRedux.connect)(function (state) {
	  return _extends({}, state.WebValuesReducer);
	})(Dashboard);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/Dashboard.js');
	
	  __REACT_HOT_LOADER__.register(tileConfig, 'tileConfig', 'D:/a/1/s/src/web/employee/src/containers/Dashboard.js');
	
	  __REACT_HOT_LOADER__.register(defaultTiles, 'defaultTiles', 'D:/a/1/s/src/web/employee/src/containers/Dashboard.js');
	
	  __REACT_HOT_LOADER__.register(Dashboard, 'Dashboard', 'D:/a/1/s/src/web/employee/src/containers/Dashboard.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Dashboard.js');
	}();

	;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _EmployeeHoliday = __webpack_require__(182);
	
	var _HolidayEntry = __webpack_require__(863);
	
	var _HolidayEntry2 = _interopRequireDefault(_HolidayEntry);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _localSettings = __webpack_require__(187);
	
	var _EmployeeHoliday2 = __webpack_require__(1024);
	
	var _EmployeeHoliday3 = _interopRequireDefault(_EmployeeHoliday2);
	
	var _EmployeeHoliday4 = __webpack_require__(182);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _SelectComponent = __webpack_require__(870);
	
	var _SelectComponent2 = _interopRequireDefault(_SelectComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HOLIDAY_LOCAL_KEY = 'showHolidayByHour';
	
	var EmployeeHoliday = function EmployeeHoliday(_ref) {
	  var loaded = _ref.loaded,
	      error = _ref.error,
	      hasError = _ref.hasError,
	      holidays = _ref.holidays,
	      holidayOverview = _ref.holidayOverview,
	      overviewLoaded = _ref.overviewLoaded,
	      fetchInfo = _ref.fetchInfo,
	      fetchByYear = _ref.fetchByYear,
	      holidayPayYear = _ref.holidayPayYear,
	      fetchingByYear = _ref.fetchingByYear,
	      earnedHolidayInfo = _ref.earnedHolidayInfo;
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.languageReducer;
	  }),
	      language = _useSelector.language;
	
	  var _useState = (0, _react.useState)((0, _localSettings.getSettingByKey)(HOLIDAY_LOCAL_KEY) || false),
	      _useState2 = _slicedToArray(_useState, 2),
	      showByHour = _useState2[0],
	      setShowByHour = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      yearOptions = _useState4[0],
	      setYearOptions = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(2025),
	      _useState6 = _slicedToArray(_useState5, 2),
	      selectedYear = _useState6[0],
	      setSelectedYear = _useState6[1];
	
	  var holiday = (0, _lodash.get)(holidays, '0', null);
	
	  (0, _react.useEffect)(function () {
	    if (holidayPayYear) {
	      setSelectedYear(holidayPayYear);
	      var years = [holidayPayYear, holidayPayYear - 1];
	      setYearOptions(years);
	    }
	  }, [holidayPayYear]);
	
	  (0, _react.useEffect)(function () {
	    fetchInfo();
	  }, []);
	
	  var toggleShowByHour = function toggleShowByHour() {
	    (0, _localSettings.setSettingByKey)(HOLIDAY_LOCAL_KEY, !showByHour);
	    setShowByHour(!showByHour);
	  };
	
	  var onFetchByYear = function onFetchByYear(year) {
	    var yearNumber = parseInt(year, 10);
	    setSelectedYear(yearNumber);
	    fetchByYear(yearNumber);
	  };
	
	  var holidaySelect = _react2.default.createElement(
	    'div',
	    { style: { marginBottom: 9, textAlign: 'center' } },
	    _react2.default.createElement(_SelectComponent2.default, {
	      value: selectedYear,
	      onChange: onFetchByYear,
	      options: yearOptions.map(function (year) {
	        return { value: year, label: (language === 'is' ? 'Orlofsárið ' : 'Vacation ') + ' ' + year };
	      })
	    })
	  );
	
	  if (!loaded || !overviewLoaded) {
	    return _react2.default.createElement(_Loading2.default, null);
	  }
	
	  if (hasError) {
	    return _react2.default.createElement(
	      _reactFlexboxGrid.Col,
	      { xs: 12, sm: 12, md: 6, mdOffset: 3 },
	      _react2.default.createElement(_PanelMessage2.default, {
	        type: 'error',
	        iconName: 'error',
	        message: error.Message || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holiday.error' })
	      })
	    );
	  }
	
	  if ((!holidays || !holidays.length) && !earnedHolidayInfo) {
	    return _react2.default.createElement(
	      _reactFlexboxGrid.Col,
	      { xs: 12, sm: 12, md: 6, mdOffset: 3 },
	      _react2.default.createElement(_PanelMessage2.default, {
	        type: 'info',
	        iconName: 'info',
	        message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.empty' })
	      })
	    );
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: _EmployeeHoliday3.default.content },
	    _react2.default.createElement(
	      'div',
	      { style: _EmployeeHoliday3.default.header },
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_KTitle2.default, { containerStyle: { maxWidth: 1400, margin: 'auto' }, key: 'hb', title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holiday.title' }) })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: _EmployeeHoliday3.default.checkbox },
	        _react2.default.createElement(_materialUi.Checkbox, {
	          onCheck: toggleShowByHour,
	          checked: showByHour,
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holiday.showByHour' }),
	          labelPosition: 'right'
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _reactFlexboxGrid.Col,
	      { style: _EmployeeHoliday3.default.wrap, xs: true },
	      _react2.default.createElement(_HolidayEntry2.default, _extends({
	        showByHour: showByHour,
	        earnedHolidayInfo: earnedHolidayInfo,
	        Overview: holidayOverview,
	        fetchingByYear: fetchingByYear,
	        selectedYear: selectedYear,
	        selectComponent: holidaySelect
	      }, holiday))
	    )
	  );
	};
	
	EmployeeHoliday.propTypes = {
	  loaded: _propTypes2.default.bool.isRequired,
	  holidays: _propTypes2.default.array.isRequired,
	  holidayOverview: _propTypes2.default.object,
	  overviewLoaded: _propTypes2.default.bool.isRequired,
	  error: _propTypes2.default.object,
	  hasError: _propTypes2.default.bool.isRequired,
	  fetchInfo: _propTypes2.default.func.isRequired,
	  fetchByYear: _propTypes2.default.func.isRequired,
	  holidayPayYear: _propTypes2.default.number.isRequired,
	  earnedHolidayInfo: _propTypes2.default.object.isRequired,
	  fetchingByYear: _propTypes2.default.bool.isRequired
	};
	
	EmployeeHoliday.defaultProps = {
	  error: null,
	  holidayOverview: {}
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var EmployeeHolidayReducer = _ref2.EmployeeHolidayReducer;
	  return _extends({}, EmployeeHolidayReducer);
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
	  return {
	    fetchByYear: function fetchByYear(year) {
	      dispatch((0, _EmployeeHoliday4.fetchHolidayByYear)(year));
	    },
	    fetchInfo: function fetchInfo() {
	      dispatch((0, _EmployeeHoliday.fetch)());
	      dispatch((0, _EmployeeHoliday.fetchHolidayOverview)());
	      dispatch((0, _EmployeeHoliday.requestHolidayInfo)());
	    }
	  };
	})(EmployeeHoliday);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(HOLIDAY_LOCAL_KEY, 'HOLIDAY_LOCAL_KEY', 'D:/a/1/s/src/web/employee/src/containers/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(EmployeeHoliday, 'EmployeeHoliday', 'D:/a/1/s/src/web/employee/src/containers/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/EmployeeHoliday.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/EmployeeHoliday.js');
	}();

	;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global primitives */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactRedux = __webpack_require__(12);
	
	var _jquery = __webpack_require__(198);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _lodash = __webpack_require__(8);
	
	__webpack_require__(436);
	
	__webpack_require__(812);
	
	__webpack_require__(1835);
	
	var _orgChart = __webpack_require__(1035);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _EmployeeOrgChart = __webpack_require__(846);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _primitives$orgdiagra = primitives.orgdiagram,
	    TemplateConfig = _primitives$orgdiagra.TemplateConfig,
	    Config = _primitives$orgdiagra.Config,
	    ItemConfig = _primitives$orgdiagra.ItemConfig,
	    UpdateMode = _primitives$orgdiagra.UpdateMode;
	var _primitives$common = primitives.common,
	    Size = _primitives$common.Size,
	    Thickness = _primitives$common.Thickness,
	    GraphicsType = _primitives$common.GraphicsType,
	    PlacementType = _primitives$common.PlacementType,
	    Enabled = _primitives$common.Enabled,
	    _primitives$common$Ch = _primitives$common.ChildrenPlacementType,
	    Matrix = _primitives$common$Ch.Matrix,
	    Horizontal = _primitives$common$Ch.Horizontal;
	
	
	var styles = {
	  diagram: {
	    width: '100%',
	    height: '100%',
	    outlineWidth: 0,
	    overflow: 'hidden'
	  },
	  paper: {
	    overflow: 'hidden',
	    padding: 16,
	    margin: 16,
	    height: '100%'
	  },
	  errorMessage: {
	    textAlign: 'center',
	    padding: 24,
	    textTransform: 'uppercase',
	    fontWeight: 500,
	    color: _colors2.default.errorColor
	  }
	};
	
	// https://www.basicprimitives.com/index.php?option=com_local&view=local&Itemid=43&lang=en#primitives.orgdiagram.TemplateConfig
	var getCompanyTemplate = function getCompanyTemplate() {
	  var template = new TemplateConfig({
	    name: 'companyTemplate',
	    itemSize: new Size(150, 77),
	    minimizedItemSize: new Size(15, 15),
	    highlightPadding: new Thickness(0, 0, 0, 0),
	    cursorPadding: new Thickness(0, 0, 0, 0)
	  });
	  template.itemTemplate = (0, _orgChart.generateCompanyTemplate)(template, 'business');
	  template.highlightTemplate = (0, _orgChart.generateHighlightTemplate)(template);
	  return template;
	};
	
	var getCompanyUnitTemplate = function getCompanyUnitTemplate() {
	  var template = new TemplateConfig({
	    name: 'companyUnitTemplate',
	    itemSize: new Size(150, 77),
	    minimizedItemSize: new Size(10, 10),
	    highlightPadding: new Thickness(0, 0, 0, 0),
	    cursorPadding: new Thickness(0, 0, 0, 0)
	  });
	  template.itemTemplate = (0, _orgChart.generateCompanyTemplate)(template, 'group');
	  template.highlightTemplate = (0, _orgChart.generateHighlightTemplate)(template);
	  return template;
	};
	
	var getEmployeeTemplate = function getEmployeeTemplate() {
	  var template = new TemplateConfig({
	    name: 'employeeTemplate',
	    itemSize: new Size(200, 105),
	    highlightPadding: new Thickness(0, 0, 0, 0),
	    cursorPadding: new Thickness(0, 0, 0, 0)
	  });
	  template.itemTemplate = (0, _orgChart.generateEmployeeTemplate)(template);
	  template.highlightTemplate = (0, _orgChart.generateHighlightTemplate)(template);
	  return template;
	};
	
	// update fields on initial render, on resize, on update
	function onTemplateRender(event, data) {
	  var context = data.context,
	      templateName = data.templateName,
	      element = data.element;
	
	  var fields = ['title'];
	  if (templateName === 'employeeTemplate') fields.push('description', 'phone', 'email');
	
	  fields.forEach(function (field) {
	    var el = element.find('[name=' + field + ']');
	    if (el.text() !== context[field]) {
	      el.text(context[field]);
	      el[0].setAttribute('title', context[field]);
	    }
	  });
	}
	
	// https://www.basicprimitives.com/index.php?option=com_local&view=local&Itemid=43&lang=en#primitives.orgdiagram.Config
	var configureDiagram = function configureDiagram(items, cursorItem) {
	  var options = new Config();
	  options = _extends({}, options, {
	    items: items,
	    enablePanning: !navigator.userAgent.includes('Safari'), // Safari only not support panning (2016)
	    hasButtons: false,
	    // NOTE: This might have to change for different browsers (to Canvar / VML see basicprimitives documentation)
	    graphicsType: GraphicsType.SVG,
	    placementType: PlacementType.Bottom,
	    templates: [getCompanyTemplate(), getCompanyUnitTemplate(), getEmployeeTemplate()],
	    hasSelectorCheckbox: Enabled.False,
	    cursorItem: cursorItem,
	    onItemRender: onTemplateRender,
	    normalLevelShift: 25,
	    normalItemsInterval: 25,
	    dotLevelShift: 35,
	    dotItemsInterval: 8,
	    lineLevelShift: 10,
	    lineItemsInterval: 5
	  });
	  return options;
	};
	
	var EmployeeOrgChart = function EmployeeOrgChart(_ref) {
	  var data = _ref.data,
	      dispatch = _ref.dispatch,
	      isFetching = _ref.isFetching,
	      cursorItem = _ref.cursorItem,
	      error = _ref.error;
	
	
	  var adjustPlaceholder = function adjustPlaceholder() {
	    var bodyWidth = (0, _jquery2.default)(window).width() - 64;
	    var bodyHeight = (0, _jquery2.default)(window).height() - 180;
	    (0, _jquery2.default)('#orgdiagram').css({
	      width: bodyWidth + 'px',
	      height: bodyHeight + 'px',
	      transform: 'translateZ(0)'
	    });
	  };
	
	  var onWindowResize = function onWindowResize() {
	    adjustPlaceholder();
	    (0, _jquery2.default)('#orgdiagram').orgDiagram('update', UpdateMode.Refresh);
	  };
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _EmployeeOrgChart.fetchData)());
	    adjustPlaceholder();
	    window.addEventListener('resize', onWindowResize);
	    return function () {
	      window.removeEventListener('resize', onWindowResize);
	    };
	  }, []);
	
	  if (!isFetching && !(0, _lodash.isEmpty)(data)) {
	    var items = (0, _lodash.map)(data, function (d) {
	      return new ItemConfig(_extends({}, d, {
	        childrenPlacementType: d.setChildrenMatrix ? Matrix : Horizontal
	      }));
	    });
	    var config = configureDiagram(items, cursorItem);
	    (0, _jquery2.default)('#orgdiagram').orgDiagram(config); // DOM must be rendered to call this method!
	  }
	
	  return _react2.default.createElement(
	    _materialUi.Paper,
	    { style: styles.paper },
	    error && _react2.default.createElement(
	      'div',
	      { style: styles.errorMessage },
	      'Ekki t\xF3kst a\xF0 birta g\xF6gnin: ' + error.Message
	    ),
	    isFetching && _react2.default.createElement(_materialUi.LinearProgress, { mode: 'indeterminate' }),
	    _react2.default.createElement('div', { id: 'orgdiagram', style: styles.diagram })
	  );
	};
	
	EmployeeOrgChart.propTypes = {
	  dispatch: _propTypes2.default.func,
	  data: _propTypes2.default.array,
	  isFetching: _propTypes2.default.bool,
	  cursorItem: _propTypes2.default.number,
	  error: _propTypes2.default.object
	};
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    data: state.EmployeeOrgChart.data,
	    isFetching: state.EmployeeOrgChart.isFetching,
	    cursorItem: state.EmployeeOrgChart.cursorItem
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(EmployeeOrgChart);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TemplateConfig, 'TemplateConfig', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(Config, 'Config', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(ItemConfig, 'ItemConfig', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(UpdateMode, 'UpdateMode', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(Size, 'Size', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(Thickness, 'Thickness', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(GraphicsType, 'GraphicsType', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(PlacementType, 'PlacementType', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(Enabled, 'Enabled', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(Matrix, 'Matrix', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(Horizontal, 'Horizontal', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(getCompanyTemplate, 'getCompanyTemplate', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(getCompanyUnitTemplate, 'getCompanyUnitTemplate', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(getEmployeeTemplate, 'getEmployeeTemplate', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(onTemplateRender, 'onTemplateRender', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(configureDiagram, 'configureDiagram', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(EmployeeOrgChart, 'EmployeeOrgChart', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/EmployeeOrgChart.js');
	}();

	;

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	// import Avatar from 'material-ui/Avatar';
	
	
	var _templateObject = _taggedTemplateLiteral([';'], [';']);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _redux = __webpack_require__(178);
	
	var _lodash = __webpack_require__(8);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _FlatButton = __webpack_require__(82);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _FontIcon = __webpack_require__(83);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _IconButton = __webpack_require__(64);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _Toggle = __webpack_require__(610);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _List = __webpack_require__(173);
	
	var _LinearProgress = __webpack_require__(374);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	var _reactList = __webpack_require__(1666);
	
	var _reactList2 = _interopRequireDefault(_reactList);
	
	var _throttle = __webpack_require__(1512);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _EmployeeSearch = __webpack_require__(847);
	
	var actionCreators = _interopRequireWildcard(_EmployeeSearch);
	
	var _EmployeeSearch2 = __webpack_require__(1025);
	
	var _EmployeeSearch3 = _interopRequireDefault(_EmployeeSearch2);
	
	var _EmployeeSearchDialog = __webpack_require__(915);
	
	var _EmployeeSearchDialog2 = _interopRequireDefault(_EmployeeSearchDialog);
	
	var _KAvatar = __webpack_require__(183);
	
	var _KAvatar2 = _interopRequireDefault(_KAvatar);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var FM = function FM(_ref) {
	  var id = _ref.id;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.' + id })
	  );
	};
	FM.propTypes = { id: _propTypes2.default.string.isRequired };
	
	var EmployeeSearch = function EmployeeSearch(props) {
	  var loaded = props.loaded,
	      resultData = props.resultData,
	      error = props.error,
	      valuesByKey = props.valuesByKey;
	
	  var query = props.location.query.query;
	
	  var _useState = (0, _react.useState)(query || ''),
	      _useState2 = _slicedToArray(_useState, 2),
	      inputValue = _useState2[0],
	      setInputValue = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      dialogContent = _useState4[0],
	      setDialogContent = _useState4[1];
	  // const [hideProfile, setHideProfile] = useState({});
	
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      searchByQualification = _useState6[0],
	      setSearchByQualification = _useState6[1];
	
	  var search = (0, _throttle2.default)(function (q) {
	    var qualificationTypes = valuesByKey['Show.QualificationSearch.Type'] && valuesByKey['Show.QualificationSearch.Type'].Value ? valuesByKey['Show.QualificationSearch.Type'].Value : '';
	    if (searchByQualification) {
	      props.actions.fetchByQualification(q, qualificationTypes);
	    } else {
	      props.actions.fetch(q);
	    }
	  }, 500);
	
	  var handleDialogClose = function handleDialogClose() {
	    setDialogContent(null);
	  };
	
	  var onKeyPress = function onKeyPress(event) {
	    if (event.keyCode === 27) {
	      handleDialogClose();
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    if (query) search(query);
	    window.addEventListener('keydown', onKeyPress);
	    return function () {
	      window.removeEventListener('keydown', onKeyPress);
	    };
	  }, [query]);
	
	  var onClickSearch = function onClickSearch(q) {
	    setSearchByQualification(false);
	    handleDialogClose();
	    search(q);
	    setInputValue(q);
	  };
	
	  var handleChange = function handleChange(ev) {
	    return setInputValue(ev.target.value);
	  };
	
	  var toggleQualificationSearch = function toggleQualificationSearch(ev, val) {
	    setSearchByQualification(val);
	    props.actions.requestSearchClear();
	  };
	
	  var keyDownText = function keyDownText(ev) {
	    if (ev.keyCode === 13) {
	      var value = ev.target.value;
	
	      setInputValue(value);
	      search(value);
	    }
	  };
	
	  // const handleError = (index) => {
	  //   setHideProfile({ ...hideProfile, [index]: true });
	  // };
	
	  var handleDialogOpen = function handleDialogOpen(index) {
	    setDialogContent(props.resultData[index]);
	  };
	
	  var renderRow = function renderRow(index) {
	    var _props$resultData$ind = props.resultData[index],
	        ImageUrl = _props$resultData$ind.ImageUrl,
	        Name = _props$resultData$ind.Name,
	        Department = _props$resultData$ind.Department,
	        Title = _props$resultData$ind.Title,
	        Qualifications = _props$resultData$ind.Qualifications,
	        EmployeeDetailID = _props$resultData$ind.EmployeeDetailID;
	
	    var queryQualifications = Qualifications && Qualifications.filter(function (q) {
	      return q.Qualification && q.Qualification.toLowerCase().includes(props.query.toLowerCase());
	    });
	    return _react2.default.createElement(_List.ListItem, {
	      key: EmployeeDetailID,
	      leftAvatar: _react2.default.createElement(_KAvatar2.default, {
	        imgSrc: ImageUrl,
	        style: _EmployeeSearch3.default.avatar,
	        masterId: (0, _lodash.floor)(EmployeeDetailID / 10, 0),
	        size: 40
	      }),
	      primaryText: Name,
	      secondaryText: _react2.default.createElement(
	        'div',
	        { style: { height: '100%' } },
	        _react2.default.createElement(
	          'p',
	          { style: _EmployeeSearch3.default.secondaryText },
	          Title + ', ' + Department
	        ),
	        searchByQualification && queryQualifications.length > 0 && _react2.default.createElement(
	          'div',
	          {
	            style: {
	              marginLeft: -4,
	              overflow: 'hidden',
	              whiteSpace: 'nowrap',
	              textOverflow: 'ellipsis'
	            }
	          },
	          _react2.default.createElement(
	            _FontIcon2.default,
	            { className: 'material-icons', style: _EmployeeSearch3.default.secondaryText },
	            'flag'
	          ),
	          _react2.default.createElement(
	            'p',
	            { style: _EmployeeSearch3.default.secondaryText },
	            queryQualifications.map(function (q) {
	              return q.Qualification;
	            }).join(', ')
	          )
	        )
	      ),
	      onClick: function onClick() {
	        return handleDialogOpen(index);
	      }
	    });
	  };
	
	  return _react2.default.createElement(
	    _reactFlexboxGrid.Col,
	    { xs: 12, md: 8, lg: 6, mdOffset: 2, lgOffset: 3 },
	    dialogContent && _react2.default.createElement(_EmployeeSearchDialog2.default, {
	      dialogOpen: Boolean(dialogContent),
	      dialogContent: dialogContent,
	      inputValue: inputValue,
	      handleDialogClose: handleDialogClose,
	      onClickSearch: onClickSearch
	    }),
	    _react2.default.createElement(
	      _Paper2.default,
	      { style: { marginTop: 16 } },
	      _react2.default.createElement(
	        _reactFlexboxGrid.Row,
	        { middle: 'xs', style: { paddingRight: 16, paddingLeft: 16 } },
	        _react2.default.createElement(
	          _reactFlexboxGrid.Col,
	          { xs: true },
	          _react2.default.createElement(_TextField2.default, {
	            hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.placeholder' }),
	            style: _EmployeeSearch3.default.root,
	            underlineShow: false,
	            onChange: handleChange,
	            onKeyDown: keyDownText,
	            autoComplete: 'off',
	            autoCorrect: 'off',
	            autoCapitalize: 'off',
	            spellCheck: 'false',
	            value: inputValue
	          })
	        ),
	        _react2.default.createElement(
	          _reactFlexboxGrid.Col,
	          null,
	          _react2.default.createElement(_FlatButton2.default, {
	            primary: true,
	            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.button' }),
	            labelPosition: 'before',
	            onClick: function onClick() {
	              return search(inputValue);
	            },
	            icon: _react2.default.createElement(
	              _FontIcon2.default,
	              { className: 'material-icons' },
	              'search'
	            )
	          })
	        )
	      ),
	      !loaded && _react2.default.createElement(_LinearProgress2.default, { mode: 'indeterminate' })
	    ),
	    valuesByKey['Show.QualificationSearch'] && valuesByKey['Show.QualificationSearch'].Value === 'true' && _react2.default.createElement(
	      _reactFlexboxGrid.Row,
	      { end: 'xs', style: { margin: 8 } },
	      _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 11, md: 8 },
	        _react2.default.createElement(_Toggle2.default, {
	          onToggle: toggleQualificationSearch,
	          toggled: searchByQualification,
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.qualificationToggle' })
	        })
	      ),
	      valuesByKey['Info.QualificationSearch'] && _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 1 },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            iconClassName: 'material-icons',
	            style: _EmployeeSearch3.default.infoButton,
	            tooltipPosition: 'bottom-left',
	            tooltip: _react2.default.createElement(
	              'div',
	              { style: _EmployeeSearch3.default.infoList },
	              valuesByKey['Info.QualificationSearch'].Value.split(_templateObject).map(function (x, key) {
	                return _react2.default.createElement(
	                  'span',
	                  { key: key },
	                  x
	                );
	              })
	            )
	          },
	          'info_outline'
	        )
	      )
	    ),
	    loaded && !resultData.length && inputValue && _react2.default.createElement(
	      'div',
	      { style: _EmployeeSearch3.default.message },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.noresult' })
	    ),
	    error && _react2.default.createElement(
	      'div',
	      { style: _EmployeeSearch3.default.errorMessage },
	      'Villa vi\xF0 leit: ' + (error.Message || error.message)
	    ),
	    resultData.length > 0 && _react2.default.createElement(
	      _Paper2.default,
	      { style: _EmployeeSearch3.default.result },
	      _react2.default.createElement(
	        _List.List,
	        { style: { overflow: 'auto', height: 'calc(100vh - 275px)' } },
	        _react2.default.createElement(_reactList2.default, {
	          itemRenderer: renderRow,
	          length: props.resultData.length,
	          useStaticSize: true
	          // type="variable"
	        })
	      )
	    )
	  );
	};
	
	EmployeeSearch.propTypes = {
	  loaded: _propTypes2.default.bool,
	  resultData: _propTypes2.default.array,
	  actions: _propTypes2.default.object,
	  location: _propTypes2.default.object,
	  error: _propTypes2.default.object,
	  valuesByKey: _propTypes2.default.object,
	  query: _propTypes2.default.string
	};
	
	var _default = (0, _reactRedux.connect)(function (state) {
	  return _extends({}, state.EmployeeSearch, { valuesByKey: state.WebValuesReducer.valuesByKey });
	}, function (dispatch) {
	  return { actions: (0, _redux.bindActionCreators)(actionCreators, dispatch) };
	})(EmployeeSearch);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FM, 'FM', 'D:/a/1/s/src/web/employee/src/containers/EmployeeSearch.js');
	
	  __REACT_HOT_LOADER__.register(EmployeeSearch, 'EmployeeSearch', 'D:/a/1/s/src/web/employee/src/containers/EmployeeSearch.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/EmployeeSearch.js');
	}();

	;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _Dialog = __webpack_require__(171);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _IconButton = __webpack_require__(64);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _List = __webpack_require__(173);
	
	var _get = __webpack_require__(96);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _includes = __webpack_require__(204);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _KAvatar = __webpack_require__(183);
	
	var _KAvatar2 = _interopRequireDefault(_KAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  dialogTitle: {
	    display: 'flex',
	    alignItems: 'center'
	  },
	  avatar: {
	    objectFit: 'cover',
	    objectPosition: '50% 30%'
	  },
	  link: {
	    outline: 'none',
	    cursor: 'pointer'
	  }
	};
	
	var fields = [{
	  label: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.title' })
	  ),
	  value: 'Title',
	  searchLink: true,
	  ID: 'EmployeeDetailOrg.OrgCompanyPositionName'
	}, {
	  label: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.department' })
	  ),
	  value: 'Department',
	  searchLink: true,
	  ID: 'EmployeeDetailOrg.OrgCompanyUnitName'
	}, {
	  label: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.costCenter' })
	  ),
	  value: 'CostCenter',
	  searchLink: true,
	  ID: 'EmployeeDetailOrg.OrgCompanyCostCenter'
	}, {
	  label: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.division' })
	  ),
	  value: 'Division',
	  searchLink: true,
	  ID: 'EmployeeDetailOrg.OrgCompanyUnitDivisionName'
	}, {
	  label: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.company' })
	  ),
	  value: 'Company',
	  searchLink: true,
	  ID: 'EmployeeDetailOrg.OrgCompanyName'
	}, {
	  label: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.manager' })
	  ),
	  value: 'Manager',
	  searchLink: true,
	  searchLinkPrefix: 'manager:',
	  ID: 'EmployeeDetailOrg.ManagerName'
	}, {
	  label: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.phone' })
	  ),
	  value: 'Phone',
	  ID: 'EmployeeMaster.PhoneNumberBuisness'
	}, {
	  label: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.mobile' })
	  ),
	  value: 'Mobile',
	  ID: 'EmployeeMaster.PhoneNumberMobile'
	}, {
	  label: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.email' })
	  ),
	  value: 'Email',
	  ID: 'EmployeeMaster.EmailWork'
	}, {
	  label: _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'employeeSearch.location' })
	  ),
	  value: 'Location',
	  ID: 'EmployeeDetailOrg.OrgLocationMain'
	}];
	
	var EmployeeSearchDialog = function EmployeeSearchDialog(_ref) {
	  var dialogOpen = _ref.dialogOpen,
	      dialogContent = _ref.dialogContent,
	      inputValue = _ref.inputValue,
	      handleDialogClose = _ref.handleDialogClose,
	      onClickSearch = _ref.onClickSearch,
	      valuesByKey = _ref.valuesByKey;
	
	
	  var show = function show(key) {
	    return (0, _get2.default)(valuesByKey, ['Hide.' + key, 'Value']) !== 'true';
	  };
	
	  return _react2.default.createElement(
	    _Dialog2.default,
	    {
	      contentStyle: { overflow: 'hidden', minWidth: 310 },
	      open: dialogOpen,
	      title: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            style: { margin: -24, float: 'right' },
	            iconClassName: 'material-icons',
	            onClick: handleDialogClose
	          },
	          'close'
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: styles.dialogTitle },
	          _react2.default.createElement(_KAvatar2.default, {
	            size: 50,
	            imgSrc: dialogContent.ImageUrl,
	            masterId: (0, _lodash.floor)(dialogContent.EmployeeDetailID / 10, 0),
	            style: _extends({}, styles.avatar, { marginRight: 16 })
	          }),
	          dialogContent.Name
	        )
	      ),
	      onRequestClose: handleDialogClose,
	      autoScrollBodyContent: true,
	      modal: true
	    },
	    _react2.default.createElement(
	      _List.List,
	      null,
	      fields.filter(function (_ref2) {
	        var value = _ref2.value,
	            ID = _ref2.ID;
	        return dialogContent[value] && show(ID);
	      }).map(function (_ref3, key) {
	        var label = _ref3.label,
	            value = _ref3.value,
	            searchLink = _ref3.searchLink,
	            searchLinkPrefix = _ref3.searchLinkPrefix;
	        return _react2.default.createElement(_List.ListItem, {
	          key: key,
	          disabled: true,
	          style: { padding: 8, backgroundColor: inputValue && (0, _includes2.default)(dialogContent[value], inputValue.replace(/manager:\s*/i, '')) ? '#fff4bf' : '' },
	          primaryText: searchLink ? _react2.default.createElement(
	            'div',
	            { style: styles.link, role: 'button', tabIndex: '0', onKeyDown: null, onClick: function onClick() {
	                return onClickSearch('' + (searchLinkPrefix || '') + dialogContent[value]);
	              } },
	            dialogContent[value]
	          ) : dialogContent[value],
	          secondaryText: label
	        });
	      }),
	      dialogContent.Qualifications && _react2.default.createElement(_List.ListItem, {
	        disabled: true,
	        style: { padding: 8 },
	        secondaryText: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qualification.title' })
	        ),
	        primaryText: dialogContent.Qualifications.length > 0 ? dialogContent.Qualifications.map(function (q) {
	          return q.Qualification;
	        }).join(', ') : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'panel.empty' })
	      })
	    )
	  );
	};
	
	EmployeeSearchDialog.propTypes = {
	  dialogOpen: _propTypes2.default.bool.isRequired,
	  dialogContent: _propTypes2.default.object.isRequired,
	  inputValue: _propTypes2.default.string.isRequired,
	  handleDialogClose: _propTypes2.default.func.isRequired,
	  onClickSearch: _propTypes2.default.func.isRequired,
	  valuesByKey: _propTypes2.default.object.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(_ref4) {
	  var WebValuesReducer = _ref4.WebValuesReducer;
	  return { valuesByKey: WebValuesReducer.valuesByKey };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(EmployeeSearchDialog);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/EmployeeSearchDialog.js');
	
	  __REACT_HOT_LOADER__.register(fields, 'fields', 'D:/a/1/s/src/web/employee/src/containers/EmployeeSearchDialog.js');
	
	  __REACT_HOT_LOADER__.register(EmployeeSearchDialog, 'EmployeeSearchDialog', 'D:/a/1/s/src/web/employee/src/containers/EmployeeSearchDialog.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/EmployeeSearchDialog.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/EmployeeSearchDialog.js');
	}();

	;

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _Files = __webpack_require__(117);
	
	var _profile = __webpack_require__(118);
	
	var _keys = __webpack_require__(99);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _includes = __webpack_require__(204);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _toLower = __webpack_require__(1513);
	
	var _toLower2 = _interopRequireDefault(_toLower);
	
	var _deburr = __webpack_require__(1496);
	
	var _deburr2 = _interopRequireDefault(_deburr);
	
	var _iconSelect = __webpack_require__(295);
	
	var _detectBrowser = __webpack_require__(1308);
	
	var _detectBrowser2 = _interopRequireDefault(_detectBrowser);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _Alert = __webpack_require__(145);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _FileUpload = __webpack_require__(862);
	
	var _FileUpload2 = _interopRequireDefault(_FileUpload);
	
	var _List = __webpack_require__(173);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Subheader = __webpack_require__(115);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _FontIcon = __webpack_require__(83);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _IconMenu = __webpack_require__(596);
	
	var _IconMenu2 = _interopRequireDefault(_IconMenu);
	
	var _IconButton = __webpack_require__(64);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _MenuItem = __webpack_require__(113);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Divider = __webpack_require__(172);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _dateTools = __webpack_require__(35);
	
	var _FlatButton = __webpack_require__(82);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Toolbar = __webpack_require__(614);
	
	var _DropDownMenu = __webpack_require__(373);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	var _sortBy = __webpack_require__(578);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  subheader: {
	    fontSize: 20,
	    fontWeight: 300,
	    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	    paddingLeft: 8,
	    paddingRight: 8,
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'space-between'
	  }
	};
	
	var Files = function (_React$Component) {
	  _inherits(Files, _React$Component);
	
	  function Files(props) {
	    _classCallCheck(this, Files);
	
	    var _this = _possibleConstructorReturn(this, (Files.__proto__ || Object.getPrototypeOf(Files)).call(this, props));
	
	    _this.openAlert = function () {
	      return _this.__openAlert__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.closeAlert = function () {
	      return _this.__closeAlert__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.alertOnOk = function () {
	      return _this.__alertOnOk__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.alertOnCancel = function () {
	      return _this.__alertOnCancel__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.keyDownText = function () {
	      return _this.__keyDownText__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = {
	      alertFileName: '',
	      removeDoc: null,
	      searchFilter: '',
	      alertOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(Files, [{
	    key: '__keyDownText__REACT_HOT_LOADER__',
	    value: function __keyDownText__REACT_HOT_LOADER__() {
	      return this.__keyDownText__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__alertOnCancel__REACT_HOT_LOADER__',
	    value: function __alertOnCancel__REACT_HOT_LOADER__() {
	      return this.__alertOnCancel__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__alertOnOk__REACT_HOT_LOADER__',
	    value: function __alertOnOk__REACT_HOT_LOADER__() {
	      return this.__alertOnOk__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__closeAlert__REACT_HOT_LOADER__',
	    value: function __closeAlert__REACT_HOT_LOADER__() {
	      return this.__closeAlert__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__openAlert__REACT_HOT_LOADER__',
	    value: function __openAlert__REACT_HOT_LOADER__() {
	      return this.__openAlert__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.init();
	      // this.props.fetch();
	    }
	  }, {
	    key: '__openAlert__REACT_HOT_LOADER__',
	    value: function __openAlert__REACT_HOT_LOADER__(alertFileName, removeDoc) {
	      return this.setState({ alertOpen: true, removeDoc: removeDoc, alertFileName: alertFileName });
	    }
	  }, {
	    key: '__closeAlert__REACT_HOT_LOADER__',
	    value: function __closeAlert__REACT_HOT_LOADER__() {
	      return this.setState({ alertOpen: false, removeDoc: null, alertFileName: '' });
	    }
	  }, {
	    key: '__alertOnOk__REACT_HOT_LOADER__',
	    value: function __alertOnOk__REACT_HOT_LOADER__() {
	      if (this.state.removeDoc) {
	        this.props.remove(this.state.removeDoc);
	        this.closeAlert();
	      }
	    }
	  }, {
	    key: '__alertOnCancel__REACT_HOT_LOADER__',
	    value: function __alertOnCancel__REACT_HOT_LOADER__() {
	      return this.closeAlert();
	    }
	  }, {
	    key: '__keyDownText__REACT_HOT_LOADER__',
	    value: function __keyDownText__REACT_HOT_LOADER__(ev) {
	      if (ev.keyCode === 13) {
	        var searchFilter = ev.target.value;
	        this.setState({ searchFilter: searchFilter });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          loaded = _props.loaded,
	          error = _props.error,
	          hasError = _props.hasError,
	          uploadHasError = _props.uploadHasError,
	          groupedFiles = _props.groupedFiles,
	          groupFilter = _props.groupFilter,
	          files = _props.files,
	          fetch = _props.fetch,
	          download = _props.download,
	          upload = _props.upload,
	          documentTypes = _props.documentTypes,
	          documentTypesById = _props.documentTypesById,
	          uploading = _props.uploading,
	          setFilter = _props.setFilter,
	          hideUpload = _props.hideUpload;
	      var _state = this.state,
	          alertOpen = _state.alertOpen,
	          alertFileName = _state.alertFileName;
	
	
	      if (!loaded) {
	        return _react2.default.createElement(_Loading2.default, null);
	      }
	      if (hasError) {
	        return _react2.default.createElement(
	          _reactFlexboxGrid.Col,
	          { xs: 12, sm: 12, md: 8, mdOffset: 2, style: { paddingTop: 0, paddingBottom: 16 } },
	          _react2.default.createElement(_PanelMessage2.default, {
	            type: 'error',
	            iconName: 'error',
	            message: error && error.Message ? error.Message : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.error' })
	          })
	        );
	      }
	      var groups = (0, _sortBy2.default)((0, _keys2.default)(groupedFiles), function (o) {
	        return (0, _lodash.get)(documentTypesById, [o, 'Name']);
	      });
	
	      var displayFiles = groupFilter ? groupedFiles[groupFilter] : files;
	
	      var displayFilesFilter = this.state.searchFilter ? displayFiles.filter(function (x) {
	        return (0, _includes2.default)((0, _toLower2.default)((0, _deburr2.default)('' + x.Name + x.Extension)), (0, _toLower2.default)((0, _deburr2.default)(_this2.state.searchFilter)));
	      }) : displayFiles;
	
	      return _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 12, sm: 12, md: 8, mdOffset: 2, style: { paddingTop: 0, paddingBottom: 16 } },
	        !hideUpload && _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _Subheader2.default,
	            { style: styles.subheader },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.uploadTitle' })
	          ),
	          _react2.default.createElement(_FileUpload2.default, { onSubmit: upload, selectOptions: documentTypes, uploading: uploading })
	        ),
	        uploadHasError && _react2.default.createElement(_PanelMessage2.default, {
	          type: 'error',
	          iconName: 'error',
	          message: error && error.Message ? error.Message : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.error' })
	        }),
	        _react2.default.createElement(
	          _Subheader2.default,
	          { style: styles.subheader },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.title' })
	        ),
	        _react2.default.createElement(
	          _Toolbar.Toolbar,
	          null,
	          _react2.default.createElement(
	            _Toolbar.ToolbarGroup,
	            { firstChild: true },
	            _react2.default.createElement(
	              _DropDownMenu2.default,
	              {
	                value: groupFilter || 13371337,
	                style: { margin: 0, flex: '0 1 auto', maxWidth: 200 },
	                iconButton: _react2.default.createElement(
	                  _FontIcon2.default,
	                  { className: 'material-icons' },
	                  'filter_list'
	                )
	              },
	              [_react2.default.createElement(_MenuItem2.default, {
	                key: 'all',
	                value: 13371337,
	                primaryText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.all' }),
	                onClick: function onClick() {
	                  return setFilter(null);
	                }
	              })].concat(_toConsumableArray(groups.map(function (v, i) {
	                return _react2.default.createElement(_MenuItem2.default, {
	                  key: i,
	                  value: v,
	                  primaryText: '' + (documentTypesById[v] && documentTypesById[v].Name),
	                  onClick: function onClick() {
	                    return setFilter(v);
	                  }
	                });
	              })))
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', alignItems: 'center' }, className: 'hide-mobile' },
	              _react2.default.createElement(_Toolbar.ToolbarSeparator, { style: { margin: 0 } }),
	              _react2.default.createElement(
	                _FontIcon2.default,
	                {
	                  style: { marginLeft: 8, marginRight: 8 },
	                  className: 'material-icons',
	                  onClick: function onClick() {
	                    return _this2.filterInput.focus();
	                  }
	                },
	                'search'
	              ),
	              _react2.default.createElement(_TextField2.default, {
	                ref: function ref(r) {
	                  _this2.filterInput = r;
	                },
	                hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.search' }),
	                onKeyDown: this.keyDownText,
	                onChange: function onChange(e) {
	                  if (_detectBrowser2.default.name !== 'ie') {
	                    _this2.setState({ searchFilter: e.target.value });
	                  }
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _Toolbar.ToolbarGroup,
	            { lastChild: true },
	            _react2.default.createElement(_FlatButton2.default, {
	              style: { margin: 10 },
	              onClick: fetch,
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.refresh' }),
	              icon: _react2.default.createElement(
	                _FontIcon2.default,
	                { className: 'material-icons' },
	                'refresh'
	              )
	            })
	          )
	        ),
	        loaded && files.length < 1 && hideUpload && _react2.default.createElement(_PanelMessage2.default, { message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.noFiles' }), type: 'info', iconName: 'info' }),
	        loaded && files.length < 1 && !hideUpload && _react2.default.createElement(_PanelMessage2.default, { message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.noFiles.CanAdd' }), type: 'info', iconName: 'info' }),
	        loaded && displayFilesFilter.length < 1 && files.length > 0 && _react2.default.createElement(_PanelMessage2.default, { message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.noFilesFilter' }), type: 'info', iconName: 'info' }),
	        _react2.default.createElement(
	          _Paper2.default,
	          null,
	          displayFilesFilter.map(function (x) {
	            return _react2.default.createElement(
	              'div',
	              { key: x.DocumentId },
	              _react2.default.createElement(_List.ListItem, {
	                className: 'cy-list-item',
	                leftIcon: _react2.default.createElement(
	                  _FontIcon2.default,
	                  { className: 'material-icons' },
	                  (0, _iconSelect.iconSelect)(x.Extension)
	                ),
	                primaryText: '' + x.Name + x.Extension,
	                secondaryText: (documentTypesById[x.ObjectDocumentType] && documentTypesById[x.ObjectDocumentType].Name) + ' ' + (0, _dateTools.dateTime)(x.AddDate),
	                disabled: true,
	                rightIconButton: _react2.default.createElement(
	                  _IconMenu2.default,
	                  {
	                    anchorOrigin: { horizontal: 'right', vertical: 'top' },
	                    targetOrigin: { horizontal: 'right', vertical: 'top' },
	                    iconButtonElement: _react2.default.createElement(
	                      _IconButton2.default,
	                      null,
	                      _react2.default.createElement(
	                        _FontIcon2.default,
	                        { className: 'material-icons' },
	                        'more_vert'
	                      )
	                    )
	                  },
	                  _react2.default.createElement(_MenuItem2.default, {
	                    primaryText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.download' }),
	                    onClick: function onClick() {
	                      return download(x.DocumentId);
	                    },
	                    leftIcon: _react2.default.createElement(
	                      _FontIcon2.default,
	                      { className: 'material-icons' },
	                      'file_download'
	                    )
	                  }),
	                  _react2.default.createElement(_Divider2.default, null),
	                  _react2.default.createElement(_MenuItem2.default, {
	                    style: { color: '#cd5c5c' },
	                    primaryText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.delete' }),
	                    onClick: function onClick() {
	                      return _this2.openAlert('' + x.Name + x.Extension, x);
	                    },
	                    leftIcon: _react2.default.createElement(
	                      _FontIcon2.default,
	                      { color: '#cd5c5c', className: 'material-icons' },
	                      'delete'
	                    )
	                  })
	                )
	              }),
	              _react2.default.createElement(_Divider2.default, null)
	            );
	          })
	        ),
	        _react2.default.createElement(_Alert2.default, {
	          open: alertOpen,
	          text: _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.alert' }),
	            _react2.default.createElement(
	              'strong',
	              null,
	              alertFileName
	            ),
	            '?'
	          ),
	          onOk: this.alertOnOk,
	          onCancel: this.alertOnCancel
	        })
	      );
	    }
	  }]);
	
	  return Files;
	}(_react2.default.Component);
	
	Files.propTypes = {
	  fetch: _propTypes2.default.func.isRequired,
	  setFilter: _propTypes2.default.func.isRequired,
	  download: _propTypes2.default.func.isRequired,
	  upload: _propTypes2.default.func.isRequired,
	  init: _propTypes2.default.func.isRequired,
	  remove: _propTypes2.default.func.isRequired,
	  loaded: _propTypes2.default.bool.isRequired,
	  uploading: _propTypes2.default.bool.isRequired,
	  hasError: _propTypes2.default.bool.isRequired,
	  uploadHasError: _propTypes2.default.bool.isRequired,
	  error: _propTypes2.default.object,
	  documentTypesById: _propTypes2.default.object,
	  documentTypes: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    FileRepositoryObjectDocumentTypeID: _propTypes2.default.number,
	    Name: _propTypes2.default.string
	  })),
	  groupedFiles: _propTypes2.default.object,
	  groupFilter: _propTypes2.default.string,
	  files: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    Name: _propTypes2.default.string,
	    Extension: _propTypes2.default.string,
	    DocumentId: _propTypes2.default.string,
	    ObjectDocumentTypeName: _propTypes2.default.string,
	    AddDate: _propTypes2.default.string
	  })),
	  hideUpload: _propTypes2.default.bool
	};
	
	var checkHideUpload = function checkHideUpload(vbk) {
	  return vbk['Hide.FileUpload'] && vbk['Hide.FileUpload'].Value === 'true';
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref) {
	  var FileReducer = _ref.FileReducer,
	      valuesByKey = _ref.WebValuesReducer.valuesByKey;
	  return _extends({}, FileReducer, { hideUpload: checkHideUpload(valuesByKey) });
	}, function (dispatch) {
	  return {
	    fetch: function fetch() {
	      return dispatch((0, _Files.fetchUserFiles)());
	    },
	    init: function init() {
	      dispatch((0, _Files.initUpload)());dispatch((0, _profile.fetchProfileIfNeeded)());
	    },
	    download: function download(id) {
	      return dispatch((0, _Files.downloadFile)(id));
	    },
	    upload: function upload(formData) {
	      return dispatch((0, _Files.uploadFile)(formData));
	    },
	    remove: function remove(id) {
	      return dispatch((0, _Files.deleteFile)(id));
	    },
	    setFilter: function setFilter(filter) {
	      return dispatch((0, _Files.setGroupFilter)(filter));
	    }
	  };
	})(Files);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/Files.js');
	
	  __REACT_HOT_LOADER__.register(Files, 'Files', 'D:/a/1/s/src/web/employee/src/containers/Files.js');
	
	  __REACT_HOT_LOADER__.register(checkHideUpload, 'checkHideUpload', 'D:/a/1/s/src/web/employee/src/containers/Files.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Files.js');
	}();

	;

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _Settings = __webpack_require__(849);
	
	var _flowRight = __webpack_require__(202);
	
	var _flowRight2 = _interopRequireDefault(_flowRight);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _CircularProgress = __webpack_require__(170);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	var _RaisedButton = __webpack_require__(114);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _Subheader = __webpack_require__(115);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _reactIntl = __webpack_require__(5);
	
	var _TextInput = __webpack_require__(430);
	
	var _TextInput2 = _interopRequireDefault(_TextInput);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _reduxForm = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  paper: {
	    padding: 16,
	    margin: 8
	  },
	  submit: {
	    marginTop: 8
	  },
	  subheader: {
	    fontSize: 20,
	    fontWeight: 300,
	    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	    paddingLeft: 8,
	    paddingRight: 8
	  }
	};
	
	var validate = function validate(_ref) {
	  var OldPassword = _ref.OldPassword,
	      NewPassword = _ref.NewPassword,
	      ConfirmPassword = _ref.ConfirmPassword;
	
	  var errors = {};
	
	  if (!OldPassword) {
	    errors.OldPassword = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.required' }); // 'Þarf að fylla út';
	  }
	
	  if (!NewPassword) {
	    errors.NewPassword = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.required' }); // 'Þarf að fylla út';
	  } else if (NewPassword.length < 12) {
	    errors.NewPassword = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.length' }); // 'Þarf að vera 12 stafir að lengd';
	  } else if (!NewPassword.match(/(?=.*?[A-Z])/)) {
	    errors.NewPassword = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.capital' }); // 'Þarf að innihalda hástaf';
	  } else if (!NewPassword.match(/(?=.*?[a-z])/)) {
	    errors.NewPassword = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.letter' }); // 'Þarf að innihalda lástaf';
	  } else if (!NewPassword.match(/(?=.*?[0-9])/)) {
	    errors.NewPassword = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.number' }); // 'Þarf að innihalda tölustaf';
	  } else if (!NewPassword.match(/(?=.*?[\\#?!@$%^&*-/])/)) {
	    errors.NewPassword = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.special' }); // 'Þarf að innihalda tákn';
	  }
	
	  if (!ConfirmPassword) {
	    errors.ConfirmPassword = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.required' }); // 'Þarf að fylla út';
	  } else if (ConfirmPassword !== NewPassword) {
	    errors.ConfirmPassword = _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.match' }); // 'Lykilorðin stemma ekki';
	  }
	
	  return errors;
	};
	
	var NewPassword = function (_React$Component) {
	  _inherits(NewPassword, _React$Component);
	
	  function NewPassword(props) {
	    _classCallCheck(this, NewPassword);
	
	    var _this = _possibleConstructorReturn(this, (NewPassword.__proto__ || Object.getPrototypeOf(NewPassword)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(NewPassword, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          newPasswordLoading = _props.newPasswordLoading,
	          handleSubmit = _props.handleSubmit,
	          hasError = _props.hasError,
	          newPasswordError = _props.newPasswordError,
	          invalid = _props.invalid;
	
	
	      return _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 12, sm: 8, smOffset: 2, md: 6, mdOffset: 3, style: { paddingTop: 16, paddingBottom: 16 } },
	        _react2.default.createElement(
	          _Subheader2.default,
	          { style: styles.subheader },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.title' })
	        ),
	        hasError && !newPasswordLoading && newPasswordError && _react2.default.createElement(_PanelMessage2.default, {
	          iconName: 'error',
	          type: 'error',
	          message: newPasswordError.Message !== 'The request is invalid.' ? newPasswordError.Message : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.error' })
	        }),
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: styles.paper },
	          newPasswordLoading && _react2.default.createElement(_CircularProgress2.default, null),
	          _react2.default.createElement(
	            'form',
	            { onSubmit: handleSubmit },
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'OldPassword',
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.currentPassword' }),
	              floatingLabelFixed: true,
	              component: _TextInput2.default,
	              type: 'password',
	              customStyle: { marginTop: 0 }
	            }),
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'NewPassword',
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.newPassword' }),
	              floatingLabelFixed: true,
	              component: _TextInput2.default,
	              type: 'password',
	              customStyle: { marginTop: 0 }
	            }),
	            _react2.default.createElement(_reduxForm.Field, {
	              name: 'ConfirmPassword',
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.newPasswordConfirm' }),
	              floatingLabelFixed: true,
	              component: _TextInput2.default,
	              type: 'password',
	              customStyle: { marginTop: 0 }
	            }),
	            _react2.default.createElement(_RaisedButton2.default, {
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'newPassword.save' }),
	              style: styles.submit,
	              icon: newPasswordLoading && _react2.default.createElement(_CircularProgress2.default, { style: { lineHeight: '16px' }, size: 16, thickness: 2 }),
	              type: 'submit',
	              primary: true,
	              fullWidth: true,
	              disabled: invalid || newPasswordLoading
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return NewPassword;
	}(_react2.default.Component);
	
	NewPassword.propTypes = {
	  newPasswordLoading: _propTypes2.default.bool.isRequired,
	  hasError: _propTypes2.default.bool.isRequired,
	  invalid: _propTypes2.default.bool.isRequired,
	  handleSubmit: _propTypes2.default.func.isRequired,
	  newPasswordError: _propTypes2.default.object
	};
	
	var _default = (0, _flowRight2.default)((0, _reactRedux.connect)(function (_ref2) {
	  var SettingsReducer = _ref2.SettingsReducer;
	  return _extends({}, SettingsReducer, {
	    form: 'NewPassword',
	    validate: validate
	  });
	}, function (dispatch) {
	  return {
	    onSubmit: function onSubmit(data) {
	      return dispatch((0, _Settings.newPassword)(data));
	    }
	  };
	}), (0, _reduxForm.reduxForm)({}))(NewPassword);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/NewPassword.js');
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', 'D:/a/1/s/src/web/employee/src/containers/NewPassword.js');
	
	  __REACT_HOT_LOADER__.register(NewPassword, 'NewPassword', 'D:/a/1/s/src/web/employee/src/containers/NewPassword.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/NewPassword.js');
	}();

	;

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _Files = __webpack_require__(117);
	
	var _base = __webpack_require__(455);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Payslip = function Payslip() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      FileReducer = _useSelector.FileReducer,
	      languageReducer = _useSelector.languageReducer;
	
	  var payslipsLoaded = FileReducer.payslipsLoaded,
	      payslips = FileReducer.payslips,
	      hasError = FileReducer.hasError,
	      error = FileReducer.error,
	      payYear = FileReducer.payYear,
	      payYearOptions = FileReducer.payYearOptions;
	  var language = languageReducer.language;
	
	  _moment2.default.locale(language);
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _Files.initPayYear)());
	  }, []);
	
	  if (!payslipsLoaded) {
	    return _react2.default.createElement(_Loading2.default, null);
	  }
	
	  if (hasError) {
	    return _react2.default.createElement(
	      _reactFlexboxGrid.Col,
	      { xs: 12, sm: 12, md: 8, mdOffset: 2, style: { paddingTop: 0, paddingBottom: 16 } },
	      _react2.default.createElement(_PanelMessage2.default, {
	        type: 'error',
	        iconName: 'error',
	        message: error && error.Message ? error.Message : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payslip.error' })
	      })
	    );
	  }
	
	  var setYear = function setYear(year) {
	    dispatch((0, _Files.setPayYear)(year));
	    dispatch((0, _Files.fetchUserPayslips)());
	  };
	
	  var download = function download(id) {
	    return dispatch((0, _Files.downloadFile)(id));
	  };
	
	  return _react2.default.createElement(
	    _reactFlexboxGrid.Col,
	    { xs: 12, sm: 12, md: 8, mdOffset: 2, style: { paddingTop: 0, paddingBottom: 16 } },
	    _react2.default.createElement(
	      _materialUi.Subheader,
	      { style: _base2.default.subheader },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payslip.title' })
	    ),
	    _react2.default.createElement(
	      _materialUi.SelectField,
	      {
	        disabled: payYearOptions.length === 0,
	        floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payslip.select' }),
	        value: payYear,
	        onChange: function onChange(a, b, value) {
	          return setYear(value);
	        }
	      },
	      payYearOptions.map(function (y) {
	        return _react2.default.createElement(_materialUi.MenuItem, { key: y, value: y, primaryText: y });
	      })
	    ),
	    payslipsLoaded && payslips.length < 1 && _react2.default.createElement(_PanelMessage2.default, { message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payslip.empty' }), type: 'info', iconName: 'info' }),
	    _react2.default.createElement(
	      _materialUi.Paper,
	      null,
	      payslips.map(function (slip) {
	        return _react2.default.createElement(
	          'div',
	          { key: slip.PaySlipGuid },
	          _react2.default.createElement(_materialUi.ListItem, {
	            primaryText: (0, _lodash.capitalize)((0, _moment2.default)().month(slip.PayMonth).format('MMMM')),
	            disabled: true,
	            secondaryText: (0, _moment2.default)(slip.PayPeriodBegda).format('LL') + ' - ' + (0, _moment2.default)(slip.PayPeriodEndda).format('LL'),
	            rightIconButton: _react2.default.createElement(_materialUi.FlatButton, {
	              style: { top: 'auto', right: 16 },
	              onClick: function onClick() {
	                return download(slip.PaySlipGuid);
	              },
	              icon: _react2.default.createElement(
	                _materialUi.FontIcon,
	                { className: 'material-icons' },
	                'file_download'
	              ),
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payslip.download' })
	            })
	          }),
	          _react2.default.createElement(_materialUi.Divider, null)
	        );
	      })
	    )
	  );
	};
	
	var _default = Payslip;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Payslip, 'Payslip', 'D:/a/1/s/src/web/employee/src/containers/Payslip.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Payslip.js');
	}();

	;

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _reactTime = __webpack_require__(1719);
	
	var _reactTime2 = _interopRequireDefault(_reactTime);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _RaisedButton = __webpack_require__(114);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _dateTools = __webpack_require__(35);
	
	var _valuesByKey = __webpack_require__(92);
	
	var _genders = __webpack_require__(456);
	
	var _KTabs = __webpack_require__(223);
	
	var _KTabs2 = _interopRequireDefault(_KTabs);
	
	var _materialUi = __webpack_require__(17);
	
	var _KTab = __webpack_require__(222);
	
	var _KTab2 = _interopRequireDefault(_KTab);
	
	var _KHero = __webpack_require__(867);
	
	var _KHero2 = _interopRequireDefault(_KHero);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _profile = __webpack_require__(118);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _EmployeeCompanyConnectionsTabs = __webpack_require__(891);
	
	var _EmployeeCompanyConnectionsTabs2 = _interopRequireDefault(_EmployeeCompanyConnectionsTabs);
	
	var _EmployeeEditForm = __webpack_require__(892);
	
	var _EmployeeEditForm2 = _interopRequireDefault(_EmployeeEditForm);
	
	var _EmployeeBottonTabs = __webpack_require__(889);
	
	var _EmployeeBottonTabs2 = _interopRequireDefault(_EmployeeBottonTabs);
	
	var _DetailList = __webpack_require__(221);
	
	var _DetailList2 = _interopRequireDefault(_DetailList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var flexJustify = {
	  display: 'flex', justifyContent: 'center', width: '100%', marginBottom: 24
	};
	
	var fix = { overflow: 'visible' }; // fix material-ui https://my.origo.is/browse/APPAIL-7744
	
	var Profile = function Profile() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      profileReducer = _useSelector.profileReducer,
	      WebValuesReducer = _useSelector.WebValuesReducer,
	      languageReducer = _useSelector.languageReducer;
	
	  var masterError = profileReducer.masterError,
	      detailError = profileReducer.detailError,
	      employeeMaster = profileReducer.employeeMaster,
	      employeeMasterLoaded = profileReducer.employeeMasterLoaded,
	      employeeDetailOrgListLoaded = profileReducer.employeeDetailOrgListLoaded;
	  var valuesByKey = WebValuesReducer.valuesByKey;
	  var language = languageReducer.language;
	
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _profile.fetchProfileIfNeeded)());
	  }, []);
	
	  if (!(employeeMasterLoaded && employeeDetailOrgListLoaded)) {
	    return _react2.default.createElement(_Loading2.default, null);
	  }
	
	  if ((0, _lodash.isError)(masterError) || (0, _lodash.isError)(detailError)) {
	    return _react2.default.createElement(
	      _reactFlexboxGrid.Col,
	      { xs: 12, sm: 12, md: 6, mdOffset: 3 },
	      _react2.default.createElement(_PanelMessage2.default, {
	        type: 'error',
	        iconName: 'error',
	        message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relog' })
	      })
	    );
	  }
	
	  var _controller = void 0;
	  var editProfile = function editProfile() {
	    return _controller.editProfile();
	  };
	  var editFamily = function editFamily() {
	    return _controller.editFamily();
	  };
	  var editRelative = function editRelative() {
	    return _controller.editRelative();
	  };
	
	  var relativeAssociationOptions = {
	    0: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAssociation.unknown' }),
	    1: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAssociation.spouse' }),
	    2: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAssociation.parent' }),
	    3: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAssociation.sibling' }),
	    4: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAssociation.relative' }),
	    5: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAssociation.other' })
	  };
	  var Address = employeeMaster.Address,
	      LegalAddress = employeeMaster.LegalAddress,
	      LegalPostCode = employeeMaster.LegalPostCode,
	      LegalPostCodeName = employeeMaster.LegalPostCodeName,
	      PostCode = employeeMaster.PostCode,
	      PostCodeName = employeeMaster.PostCodeName,
	      RelativeName = employeeMaster.RelativeName,
	      RelativePhoneNumber = employeeMaster.RelativePhoneNumber,
	      RecrutingDateYearMonthDays = employeeMaster.RecrutingDateYearMonthDays,
	      RecrutingDatePayYearMonthDays = employeeMaster.RecrutingDatePayYearMonthDays,
	      RelativeName2 = employeeMaster.RelativeName2,
	      RelativePhoneNumber2 = employeeMaster.RelativePhoneNumber2,
	      RelativeAssociation = employeeMaster.RelativeAssociation,
	      RelativeAssociation2 = employeeMaster.RelativeAssociation2,
	      RelativePhoneNumberMobile = employeeMaster.RelativePhoneNumberMobile,
	      RelativePhoneNumberMobile2 = employeeMaster.RelativePhoneNumberMobile2,
	      RelativeEmail = employeeMaster.RelativeEmail,
	      RelativeEmail2 = employeeMaster.RelativeEmail2,
	      RelativeAddress = employeeMaster.RelativeAddress,
	      RelativeAddress2 = employeeMaster.RelativeAddress2;
	
	
	  var detailData = [{
	    label: _react2.default.createElement(
	      'div',
	      { style: fix, 'data-cy': 'EmployeeMaster.EntityNR' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.ssn' })
	    ),
	    value: employeeMaster.EntityNR,
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.EntityNR')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.age' })
	    ),
	    value: employeeMaster.Age,
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.Age')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix, 'data-cy': 'EmployeeMaster.GenderTypeName' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.gender' })
	    ),
	    value: (0, _genders.getGender)(language, employeeMaster.GenderType),
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.GenderTypeName')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix, 'data-cy': 'EmployeeMaster.LastHireDate' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.lastHire' })
	    ),
	    value: _react2.default.createElement(_reactTime2.default, { value: employeeMaster.LastHireDate || new Date(), format: 'DD.MM.YYYY' }),
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.LastHireDate')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.recruitingDate' })
	    ),
	    value: (0, _dateTools.fromNowLocale)(language, RecrutingDateYearMonthDays),
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.RecrutingDate')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.recruitingDatePay' })
	    ),
	    value: (0, _dateTools.fromNowLocale)(language, RecrutingDatePayYearMonthDays),
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.RecrutingDatePay')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.legalAddress' })
	    ),
	    value: [LegalAddress, LegalPostCode, LegalPostCodeName].filter(function (x) {
	      return x;
	    }).join(', '),
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.LegalAddress')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.address' })
	    ),
	    value: [Address, PostCode, PostCodeName].filter(function (x) {
	      return x;
	    }).join(', '),
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.Address')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.username' })
	    ),
	    value: employeeMaster.UserName,
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.UserName')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix, 'data-cy': 'EmployeeMaster.EmployeeMasterID' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.employeeMasterID' })
	    ),
	    value: employeeMaster.EmployeeMasterID,
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.EmployeeMasterID')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix, 'data-cy': 'EmployeeMaster.PhoneNumberBuisness' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.workPhone' })
	    ),
	    value: employeeMaster.PhoneNumberBuisness,
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.PhoneNumberBuisness')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.mobile' })
	    ),
	    value: (employeeMaster.PhoneNumberMobileCountryCode || '') + ' ' + (employeeMaster.PhoneNumberMobile || ''),
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.PhoneNumberMobile')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.tetra' })
	    ),
	    value: employeeMaster.Tetra,
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.Tetra')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix, 'data-cy': 'EmployeeMaster.PhoneNumberHome' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.phone' })
	    ),
	    value: employeeMaster.PhoneNumberHome,
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.PhoneNumberHome')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix, 'data-cy': 'EmployeeMaster.EmailWork' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.workEmail' })
	    ),
	    value: employeeMaster.EmailWork,
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.EmailWork')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix, 'data-cy': 'EmployeeMaster.Email' },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.email' })
	    ),
	    value: employeeMaster.Email,
	    visible: (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.Email')
	  }, {
	    label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.accessCard' })
	    ),
	    value: employeeMaster.IdentificationCard,
	    visible: (0, _valuesByKey.shouldShow)(valuesByKey, 'EmployeeDetail.IdentificationCard')
	  }];
	
	  var filteredData = (0, _lodash.filter)(detailData, function (x) {
	    return x.visible;
	  });
	
	  var children = (0, _lodash.map)(employeeMaster.EmployeeMasterChildren, function (c) {
	    return {
	      label: _react2.default.createElement(
	        'div',
	        { style: fix },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.child.name' })
	      ), value: c.ChildName + ', (' + c.Birthyear + ')'
	    };
	  });
	  var relative1 = [{ label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeName' })
	    ), value: RelativeName, visible: !!RelativeName }, { label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativePhone' })
	    ), value: RelativePhoneNumber, visible: !!RelativePhoneNumber }, { label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativePhoneMobile' })
	    ), value: RelativePhoneNumberMobile, visible: !!RelativePhoneNumberMobile }, { label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeRelation' })
	    ), value: (0, _lodash.get)(relativeAssociationOptions, RelativeAssociation), visible: !!RelativeAssociation }, { label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeEmail' })
	    ), value: RelativeEmail, visible: !!RelativeEmail }, { label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAddress' })
	    ), value: RelativeAddress, visible: !!RelativeAddress }];
	  var relative2 = [{ label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeName' })
	    ), value: RelativeName2, visible: !!RelativeName2 }, { label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativePhone' })
	    ), value: RelativePhoneNumber2, visible: !!RelativePhoneNumber2 }, { label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativePhoneMobile' })
	    ), value: RelativePhoneNumberMobile2, visible: !!RelativePhoneNumberMobile2 }, { label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeRelation' })
	    ), value: (0, _lodash.get)(relativeAssociationOptions, RelativeAssociation2), visible: !!RelativeAssociation2 }, { label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeEmail' })
	    ), value: RelativeEmail2, visible: !!RelativeEmail2 }, { label: _react2.default.createElement(
	      'div',
	      { style: fix },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relativeAddress' })
	    ), value: RelativeAddress2, visible: !!RelativeAddress2 }];
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactFlexboxGrid.Row,
	      { style: { margin: 0 }, className: 'no-print' },
	      _react2.default.createElement(_EmployeeEditForm2.default, {
	        dispatch: dispatch,
	        controller: function controller(ctrl) {
	          _controller = ctrl;
	        }
	      }),
	      _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 12, lgOffset: 1, lg: 10 },
	        _react2.default.createElement(_KHero2.default, {
	          title: employeeMaster.EmployeeName,
	          imgSrc: employeeMaster.ImageUrl,
	          masterId: employeeMaster.EmployeeMasterID
	        })
	      ),
	      _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { style: flexJustify, xs: 12, sm: 12, md: 12, lg: 6, lgOffset: 1 },
	        _react2.default.createElement(
	          _KTabs2.default,
	          null,
	          _react2.default.createElement(
	            _KTab2.default,
	            { style: { padding: 12 }, name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.employeeMaster' }) },
	            _react2.default.createElement(_DetailList2.default, {
	              containerStyle: {
	                flexFlow: 'row wrap',
	                justifyContent: 'space-between'
	              },
	              itemMaxWidth: '50%',
	              dataSource: filteredData
	            }),
	            (0, _valuesByKey.shouldEdit)(valuesByKey, 'EmployeeMaster') && _react2.default.createElement(_KFlatButton2.default, {
	              iconName: 'edit',
	              containerStyle: { justifyContent: 'flex-end' },
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.editProfile' }),
	              onClick: editProfile
	            })
	          ),
	          (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMasterChild') && _react2.default.createElement(
	            _KTab2.default,
	            { style: { padding: 12 }, name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.family' }) },
	            _react2.default.createElement(_DetailList2.default, { dataSource: children }),
	            _react2.default.createElement(_KFlatButton2.default, {
	              iconName: 'edit',
	              onClick: editFamily,
	              containerStyle: { justifyContent: 'flex-end' },
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.editProfile' })
	            })
	          ),
	          (0, _valuesByKey.shouldNotHide)(valuesByKey, 'EmployeeMaster.Relative') && _react2.default.createElement(
	            _KTab2.default,
	            { style: { padding: 12 }, name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.tab.relative' }) },
	            _react2.default.createElement(
	              'div',
	              { style: { marginTop: 12, fontSize: 14, fontWeight: 600 } },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relative' })
	            ),
	            _react2.default.createElement(_DetailList2.default, { dataSource: relative1 }),
	            _react2.default.createElement(_materialUi.Divider, { style: { margin: 16 } }),
	            _react2.default.createElement(
	              'div',
	              { style: { marginTop: 12, fontSize: 14, fontWeight: 600 } },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.relative2' })
	            ),
	            _react2.default.createElement(_DetailList2.default, { dataSource: relative2 }),
	            _react2.default.createElement(_KFlatButton2.default, {
	              iconName: 'edit',
	              onClick: editRelative,
	              containerStyle: { justifyContent: 'flex-end' },
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'profile.editProfile' })
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { style: flexJustify, xs: 12, sm: 12, md: 12, lg: 4 },
	        _react2.default.createElement(_EmployeeCompanyConnectionsTabs2.default, null)
	      )
	    ),
	    _react2.default.createElement(
	      _reactFlexboxGrid.Row,
	      { style: { margin: 0 } },
	      _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: 12, sm: 12, md: 12, lg: 10, lgOffset: 1, style: _extends({}, flexJustify, { position: 'relative' }) },
	        _react2.default.createElement(_RaisedButton2.default, {
	          style: { position: 'absolute', right: 16, top: 12 },
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'print' }),
	          primary: true,
	          onClick: function onClick() {
	            return window.print();
	          },
	          className: 'no-print'
	        }),
	        _react2.default.createElement(_EmployeeBottonTabs2.default, null)
	      )
	    )
	  );
	};
	
	var _default = Profile;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(flexJustify, 'flexJustify', 'D:/a/1/s/src/web/employee/src/containers/Profile.js');
	
	  __REACT_HOT_LOADER__.register(fix, 'fix', 'D:/a/1/s/src/web/employee/src/containers/Profile.js');
	
	  __REACT_HOT_LOADER__.register(Profile, 'Profile', 'D:/a/1/s/src/web/employee/src/containers/Profile.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Profile.js');
	}();

	;

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reduxForm = __webpack_require__(67);
	
	var _QAElement = __webpack_require__(284);
	
	var _QAElement2 = _interopRequireDefault(_QAElement);
	
	var _KButton = __webpack_require__(146);
	
	var _KButton2 = _interopRequireDefault(_KButton);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _reactIntl = __webpack_require__(5);
	
	var _CourseQuestionnaire = __webpack_require__(844);
	
	var _flowRight = __webpack_require__(202);
	
	var _flowRight2 = _interopRequireDefault(_flowRight);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validate = function validate(values, props) {
	  var error = {};
	  var questionnaire = props.questionnaire;
	
	  if (!questionnaire) {
	    return error;
	  }
	  var questions = questionnaire.QAElements.filter(function (q) {
	    return q.QAElementType === 3;
	  });
	
	  (0, _map2.default)(questions, function (_ref) {
	    var QAElementID = _ref.QAElementID,
	        QAInput = _ref.QAInput,
	        MinAnswers = _ref.MinAnswers;
	
	    /* No validation on checkbox questions */
	    if (QAInput.QAInputAnswerType === 3) {
	      return;
	    }
	    var key = QAInput.QAInputAnswerType + '-' + QAElementID;
	    /* First check if element is equired */
	    if (MinAnswers > 0 && !values[key]) {
	      error[key] = 'Þetta svæði verður að vera útfyllt';
	      /* Second check if element has mask */
	    } else if (QAInput && QAInput.QAMaskEntity) {
	      if (QAInput.QAInputAnswerType === 5) {
	        return;
	      }
	      var _QAInput$QAMaskEntity = QAInput.QAMaskEntity,
	          QAMaskString = _QAInput$QAMaskEntity.QAMaskString,
	          QAMaskDescription = _QAInput$QAMaskEntity.QAMaskDescription;
	      /* Create regex for the mask */
	
	      var re = new RegExp(QAMaskString, 'i');
	      if (!re.test(values[key])) {
	        error[key] = QAMaskDescription;
	      }
	    }
	  });
	
	  return error;
	};
	
	var Questionnaire = function (_React$Component) {
	  _inherits(Questionnaire, _React$Component);
	
	  function Questionnaire(props) {
	    _classCallCheck(this, Questionnaire);
	
	    var _this = _possibleConstructorReturn(this, (Questionnaire.__proto__ || Object.getPrototypeOf(Questionnaire)).call(this, props));
	
	    _this.submit = function () {
	      return _this.__submit__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Questionnaire, [{
	    key: '__submit__REACT_HOT_LOADER__',
	    value: function __submit__REACT_HOT_LOADER__() {
	      return this.__submit__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetch();
	    }
	  }, {
	    key: '__submit__REACT_HOT_LOADER__',
	    value: function __submit__REACT_HOT_LOADER__(data, dispatch) {
	      return dispatch((0, _CourseQuestionnaire.submitQuestionnaire)(data, this.props.onSuccess));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          questionnaire = _props.questionnaire,
	          handleSubmit = _props.handleSubmit,
	          invalid = _props.invalid,
	          isSubmitted = _props.isSubmitted,
	          questionnaireError = _props.questionnaireError,
	          submitFailed = _props.submitFailed;
	
	
	      if (questionnaireError) {
	        return _react2.default.createElement(_PanelMessage2.default, { message: questionnaireError.message || questionnaireError.Message, type: 'error', iconName: 'error' });
	      }
	
	      if (!questionnaire) {
	        return _react2.default.createElement(_Loading2.default, null);
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_KTitle2.default, { title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'questionnaire.title' }) }),
	        _react2.default.createElement(
	          'form',
	          null,
	          questionnaire.QAElements.map(function (e) {
	            return _react2.default.createElement(_QAElement2.default, _extends({
	              key: e.QAElementID
	            }, e));
	          }),
	          submitFailed && _react2.default.createElement(_PanelMessage2.default, { message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'questionnaire.submitFailed' }), type: 'warning', iconName: 'warning' }),
	          _react2.default.createElement(_KButton2.default, {
	            onClick: handleSubmit(this.submit),
	            disabled: invalid || isSubmitted,
	            label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'questionnaire.submit' })
	          })
	        )
	      );
	    }
	  }]);
	
	  return Questionnaire;
	}(_react2.default.Component);
	
	/**
	 * Props
	 * - onSaveSuccess
	 * - onSaveFailure
	 * - QuestionnaireRootID
	 */
	
	Questionnaire.propTypes = {
	  questionnaireRootID: _propTypes2.default.number,
	  questionnaire: _propTypes2.default.shape({
	    QAElements: _propTypes2.default.array,
	    QAElementID: _propTypes2.default.number,
	    QAElement: _propTypes2.default.object
	  }),
	  questionnaireError: _propTypes2.default.shape({
	    message: _propTypes2.default.string,
	    Message: _propTypes2.default.string
	  }),
	  onSuccess: _propTypes2.default.func,
	  fetch: _propTypes2.default.func,
	  handleSubmit: _propTypes2.default.func.isRequired,
	  isSubmitted: _propTypes2.default.bool,
	  invalid: _propTypes2.default.bool,
	  submitFailed: _propTypes2.default.bool
	};
	
	var _default = (0, _flowRight2.default)((0, _reactRedux.connect)(function (state) {
	  return _extends({}, state.CourseQuestionnaireReducer, { initialValues: {} });
	}, function (dispatch, props) {
	  return {
	    fetch: function fetch() {
	      return dispatch((0, _CourseQuestionnaire.fetchQuestionnaire)(props.questionnaireRootID, props.onSuccess));
	    }
	  };
	}), (0, _reduxForm.reduxForm)({
	  form: 'questionnaire',
	  validate: validate,
	  shouldValidate: function shouldValidate() {
	    return true;
	  }
	}))(Questionnaire);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(validate, 'validate', 'D:/a/1/s/src/web/employee/src/containers/Questionnaire.js');
	
	  __REACT_HOT_LOADER__.register(Questionnaire, 'Questionnaire', 'D:/a/1/s/src/web/employee/src/containers/Questionnaire.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Questionnaire.js');
	}();

	;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint global-require: 0 */
	if (true) {
	  module.exports = __webpack_require__(922);
	} else {
	  module.exports = require('./Root.dev');
	}
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _MuiThemeProvider = __webpack_require__(619);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _getMuiTheme = __webpack_require__(620);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _white = __webpack_require__(1030);
	
	var _white2 = _interopRequireDefault(_white);
	
	var _routes = __webpack_require__(986);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Root = function Root(props) {
	  return _react2.default.createElement(
	    _reactRedux.Provider,
	    { store: props.store },
	    _react2.default.createElement(
	      _MuiThemeProvider2.default,
	      { muiTheme: (0, _getMuiTheme2.default)(_extends({}, _white2.default, { palette: _extends({}, _white2.default.palette, _colors2.default) })) },
	      _react2.default.createElement(_routes2.default, { store: props.store })
	    )
	  );
	};
	
	Root.propTypes = {
	  store: _propTypes2.default.object
	};
	
	var _default = Root;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Root, 'Root', 'D:/a/1/s/src/web/employee/src/containers/Root.prod.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Root.prod.js');
	}();

	;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _config = __webpack_require__(54);
	
	var _lodash = __webpack_require__(8);
	
	var _msalBrowser = __webpack_require__(409);
	
	var _msalReact = __webpack_require__(419);
	
	var _reactRedux = __webpack_require__(12);
	
	var _materialUi = __webpack_require__(17);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _App = __webpack_require__(433);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Api = __webpack_require__(21);
	
	var _login = __webpack_require__(144);
	
	var _KButton = __webpack_require__(146);
	
	var _KButton2 = _interopRequireDefault(_KButton);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var styles = {
	  container: {
	    display: 'flex',
	    flex: 1,
	    flexDirection: 'column',
	    alignItems: 'center',
	    paddingLeft: 12,
	    paddingRight: 12,
	    backgroundColor: 'white',
	    height: '100vh'
	  },
	  logo: {
	    maxHeight: 150,
	    maxWidth: 220
	  },
	  logoContainer: {
	    display: 'flex',
	    alignItems: 'center',
	    maxWidth: 800,
	    marginTop: '6%',
	    width: '100%'
	  },
	  art1: {
	    bottom: 0,
	    right: 0,
	    position: 'absolute',
	    width: 0,
	    height: 0,
	    borderBottom: '40vw solid rgb(35, 95, 167)',
	    borderLeft: '55vw solid transparent',
	    opacity: 0.3,
	    borderBottomColor: _colors2.default.loginColor
	  },
	  art2: {
	    bottom: 0,
	    right: 0,
	    position: 'absolute',
	    width: 0,
	    height: 0,
	    borderBottom: '25vw solid rgb(35, 95, 167)',
	    borderLeft: '60vw solid transparent',
	    opacity: 0.4,
	    borderBottomColor: _colors2.default.loginColor
	  },
	  art3: {
	    bottom: 0,
	    right: 0,
	    position: 'absolute',
	    width: 0,
	    height: 0,
	    borderBottom: '15vw solid rgb(35, 95, 167)',
	    borderLeft: '100vw solid transparent',
	    opacity: 0.7,
	    borderBottomColor: _colors2.default.loginColor
	  },
	  error: {
	    padding: 12,
	    color: '#d52212',
	    whiteSpace: 'pre-wrap'
	  }
	};
	
	var MSALAuth = function MSALAuth() {
	  var request = {
	    scopes: ['api://' + _config.msalApplicationID + '/' + _config.msalScope]
	  };
	
	  var _useMsalAuthenticatio = (0, _msalReact.useMsalAuthentication)(_msalBrowser.InteractionType.Redirect, request),
	      login = _useMsalAuthenticatio.login,
	      error = _useMsalAuthenticatio.error;
	
	  var _useMsal = (0, _msalReact.useMsal)(),
	      inProgress = _useMsal.inProgress;
	
	  var isAuthenticated = (0, _msalReact.useIsAuthenticated)();
	  var loading = inProgress !== _msalBrowser.InteractionStatus.None;
	
	  if (isAuthenticated) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.container },
	    _react2.default.createElement(
	      'div',
	      { style: styles.logoContainer },
	      _react2.default.createElement('img', { style: styles.logo, src: _config.logo, alt: 'logo' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { width: 320, marginTop: '10em', padding: 16 } },
	      _react2.default.createElement(_KTitle2.default, { title: 'Innskr\xE1ning', style: { marginBottom: 32 } }),
	      _react2.default.createElement(_KButton2.default, {
	        disabled: loading,
	        onClick: login,
	        label: 'Innskr\xE1 me\xF0 Microsoft'
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%'
	          }
	        },
	        loading ? _react2.default.createElement(_materialUi.CircularProgress, null) : null,
	        error ? _react2.default.createElement(
	          'div',
	          { style: styles.error },
	          error.errorMessage || error.message
	        ) : null
	      )
	    ),
	    _react2.default.createElement('div', { style: styles.art1 }),
	    _react2.default.createElement('div', { style: styles.art2 }),
	    _react2.default.createElement('div', { style: styles.art3 })
	  );
	};
	
	var UserWrapper = function UserWrapper(_ref) {
	  var children = _ref.children;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useMsal2 = (0, _msalReact.useMsal)(),
	      accounts = _useMsal2.accounts,
	      instance = _useMsal2.instance,
	      inProgress = _useMsal2.inProgress;
	
	  (0, _react.useEffect)(function () {
	    if (inProgress === _msalBrowser.InteractionStatus.None) {
	      dispatch((0, _login.sso)());
	    }
	  }, [dispatch, _login.sso]);
	  var username = (0, _lodash.get)(accounts, [0, 'username']);
	  var isAuthenticated = (0, _reactRedux.useSelector)(function (state) {
	    return (0, _lodash.get)(state, 'loginReducer.isAuthenticated');
	  });
	  var error = (0, _reactRedux.useSelector)(function (state) {
	    return (0, _lodash.get)(state, 'loginReducer.error');
	  });
	
	  if (error) {
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          width: '100%', height: '50vh', display: 'flex', justifyContent: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
	          }
	        },
	        _react2.default.createElement(_PanelMessage2.default, {
	          iconName: 'error',
	          type: 'error',
	          message: _react2.default.createElement(
	            'span',
	            { style: { marginRight: 12 } },
	            'Error authenticating',
	            _react2.default.createElement('br', null),
	            error.myUserInfo ? 'Kjarna user not configured for email: ' + username : ''
	          ),
	          action: function action() {
	            return instance.logout();
	          },
	          actionLabel: 'Logout'
	        })
	      )
	    );
	  }
	
	  if (!isAuthenticated) {
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          width: '100%', height: '50vh', display: 'flex', justifyContent: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'
	          }
	        },
	        _react2.default.createElement(_materialUi.CircularProgress, { size: 70 }),
	        _react2.default.createElement(
	          'span',
	          { style: { fontSize: 18, fontWeight: 600, marginTop: 12 } },
	          'Loading...'
	        )
	      )
	    );
	  }
	
	  return children;
	};
	
	var pca = void 0;
	
	if (_config.useSSO) {
	  var configuration = {
	    auth: {
	      clientId: _config.msalApplicationID,
	      authority: 'https://login.microsoftonline.com/' + _config.msalTenantID,
	      redirectUri: '' + window.location.origin
	    }
	  };
	  pca = new _msalBrowser.PublicClientApplication(configuration);
	  (0, _Api.injectQDataInterceptor)(function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(config) {
	      var account, request, accessToken, response, _response, authorization;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              (0, _lodash.set)(config, 'headers.Content-Type', 'application/json');
	              (0, _lodash.set)(config, 'headers.Accept', 'application/json');
	              account = (0, _lodash.get)(pca.getAllAccounts(), 0);
	
	              if (account) {
	                _context.next = 5;
	                break;
	              }
	
	              return _context.abrupt('return', config);
	
	            case 5:
	              request = {
	                scopes: ['api://' + _config.msalApplicationID + '/' + _config.msalScope],
	                account: account
	              };
	              accessToken = '';
	              _context.prev = 7;
	              _context.next = 10;
	              return pca.acquireTokenSilent(request);
	
	            case 10:
	              response = _context.sent;
	
	              accessToken = (0, _lodash.get)(response, 'accessToken');
	              _context.next = 20;
	              break;
	
	            case 14:
	              _context.prev = 14;
	              _context.t0 = _context['catch'](7);
	              _context.next = 18;
	              return pca.acquireTokenRedirect(request);
	
	            case 18:
	              _response = _context.sent;
	
	              accessToken = (0, _lodash.get)(_response, 'accessToken');
	
	            case 20:
	              authorization = accessToken ? 'Bearer ' + accessToken : undefined;
	
	              (0, _lodash.set)(config, 'headers.Authorization', authorization);
	              return _context.abrupt('return', config);
	
	            case 23:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[7, 14]]);
	    }));
	
	    return function (_x) {
	      return _ref2.apply(this, arguments);
	    };
	  }());
	}
	
	var SSOApp = function SSOApp(props) {
	  return _react2.default.createElement(
	    _msalReact.MsalProvider,
	    { instance: pca },
	    _react2.default.createElement(MSALAuth, null),
	    _react2.default.createElement(
	      _msalReact.AuthenticatedTemplate,
	      null,
	      _react2.default.createElement(
	        UserWrapper,
	        null,
	        _react2.default.createElement(_App2.default, props)
	      )
	    )
	  );
	};
	
	UserWrapper.propTypes = {
	  children: _propTypes2.default.arrayOf(_propTypes2.default.node)
	};
	
	var _default = SSOApp;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/SSOApp.js');
	
	  __REACT_HOT_LOADER__.register(MSALAuth, 'MSALAuth', 'D:/a/1/s/src/web/employee/src/containers/SSOApp.js');
	
	  __REACT_HOT_LOADER__.register(UserWrapper, 'UserWrapper', 'D:/a/1/s/src/web/employee/src/containers/SSOApp.js');
	
	  __REACT_HOT_LOADER__.register(pca, 'pca', 'D:/a/1/s/src/web/employee/src/containers/SSOApp.js');
	
	  __REACT_HOT_LOADER__.register(SSOApp, 'SSOApp', 'D:/a/1/s/src/web/employee/src/containers/SSOApp.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/SSOApp.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AppLinks = __webpack_require__(858);
	
	var _AppLinks2 = _interopRequireDefault(_AppLinks);
	
	var _reactRedux = __webpack_require__(12);
	
	var _NewPassword = __webpack_require__(917);
	
	var _NewPassword2 = _interopRequireDefault(_NewPassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Settings = function Settings(_ref) {
	  var valuesByKey = _ref.valuesByKey;
	  return _react2.default.createElement(
	    'div',
	    { style: { paddingBottom: 8 } },
	    (!valuesByKey['Hide.Settings.NewPassword'] || valuesByKey['Hide.Settings.NewPassword'].Value !== 'true') && _react2.default.createElement(_NewPassword2.default, null),
	    (!valuesByKey['Hide.Settings.AppLinks'] || valuesByKey['Hide.Settings.AppLinks'].Value !== 'true') && _react2.default.createElement(_AppLinks2.default, null)
	  );
	};
	
	Settings.propTypes = {
	  valuesByKey: _propTypes2.default.object
	};
	
	var _default = (0, _reactRedux.connect)(function (state) {
	  return { valuesByKey: state.WebValuesReducer.valuesByKey };
	})(Settings);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Settings, 'Settings', 'D:/a/1/s/src/web/employee/src/containers/Settings.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/Settings.js');
	}();

	;

/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(17);
	
	var _List = __webpack_require__(173);
	
	var _EmployeeBonuses = __webpack_require__(845);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _Cards = __webpack_require__(119);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bonuses = function Bonuses(_ref) {
	  var bonusesError = _ref.bonusesError,
	      bonusesLoading = _ref.bonusesLoading,
	      bonuses = _ref.bonuses,
	      detailId = _ref.detailId;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  (0, _react.useEffect)(function () {
	    // dispatch(fetchTaxCards());
	    // dispatch(requestTaxDiscountInfo());
	    dispatch((0, _EmployeeBonuses.fetchBonuses)(detailId));
	  }, [dispatch]);
	
	  if (bonusesLoading) return _react2.default.createElement(
	    _materialUi.Paper,
	    { style: _Cards2.default.loading },
	    _react2.default.createElement(_materialUi.CircularProgress, null)
	  );
	
	  if (bonusesError) {
	    return _react2.default.createElement(_PanelMessage2.default, {
	      type: 'error',
	      iconName: 'error',
	      message: bonusesError.Message || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'bank.error' })
	    });
	  }
	
	  var bonusObject = (0, _lodash.find)(bonuses, function (b) {
	    return (0, _moment2.default)(b.Endda).isAfter();
	  });
	
	  var bonusKeys = ['PayLifelongEducationBonus', 'PayEducationBonus', 'PayManagementBonus', 'PayLoyaltyBonus'];
	
	  var renderPercent = function renderPercent(value) {
	    return (0, _lodash.round)(value * 100) + ' %';
	  };
	
	  var renderItem = function renderItem(key) {
	    var bonusValue = (0, _lodash.get)(bonusObject, key);
	    return bonusValue ? _react2.default.createElement(
	      _List.ListItem,
	      { key: key, disabled: true, style: { display: 'flex', justifyContent: 'space-between' } },
	      _react2.default.createElement(
	        'span',
	        { style: { fontSize: 14 } },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: key }),
	        ': '
	      ),
	      renderPercent(bonusValue)
	    ) : null;
	  };
	
	  var items = (0, _lodash.compact)((0, _lodash.map)(bonusKeys, function (item) {
	    return renderItem(item);
	  }));
	
	  if (items.length === 0) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _materialUi.Subheader,
	      { style: _Cards2.default.subheader },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Bonuses' })
	    ),
	    _react2.default.createElement(
	      _materialUi.Paper,
	      null,
	      _react2.default.createElement(
	        _List.List,
	        null,
	        items
	      )
	    )
	  );
	};
	
	// import { fetchTaxCards, requestTaxDiscountInfo } from 'actions/EmployeeTaxCards';
	
	
	Bonuses.propTypes = {
	  bonusesError: _propTypes2.default.object,
	  bonusesLoading: _propTypes2.default.bool,
	  bonuses: _propTypes2.default.array,
	  detailId: _propTypes2.default.number
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var EmployeePensionAndUnionReducer = _ref2.EmployeePensionAndUnionReducer;
	  return {
	    bonuses: EmployeePensionAndUnionReducer.bonuses,
	    bonusesError: EmployeePensionAndUnionReducer.bonusesError,
	    bonusesLoading: EmployeePensionAndUnionReducer.bonusesLoading
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(Bonuses);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Bonuses, 'Bonuses', 'D:/a/1/s/src/web/employee/src/containers/pay/Bonuses.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/pay/Bonuses.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pay/Bonuses.js');
	}();

	;

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _EmployeeBank = __webpack_require__(423);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _EmployeeBankAccount = __webpack_require__(927);
	
	var _EmployeeBankAccount2 = _interopRequireDefault(_EmployeeBankAccount);
	
	var _Cards = __webpack_require__(119);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/** Wrapper Component for EmployeeBankAccount */
	var EmployeeBank = function EmployeeBank(_ref) {
	  var loaded = _ref.loaded,
	      branchesLoaded = _ref.branchesLoaded,
	      error = _ref.error,
	      hasError = _ref.hasError,
	      accounts = _ref.accounts,
	      dispatch = _ref.dispatch;
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _EmployeeBank.fetch)());
	  }, []);
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      valuesByKey = _useSelector.WebValuesReducer.valuesByKey;
	
	  var editBank = (0, _lodash.get)(valuesByKey, ['Edit.EmployeeMasterBank', 'Value']) !== 'false';
	
	  var renderAccounts = function renderAccounts() {
	    if (!loaded || !branchesLoaded) return _react2.default.createElement(
	      _materialUi.Paper,
	      { style: _Cards2.default.loading },
	      _react2.default.createElement(_materialUi.CircularProgress, null)
	    );
	
	    if (hasError) {
	      return _react2.default.createElement(_PanelMessage2.default, {
	        zDepth: 1,
	        type: 'error',
	        iconName: 'error',
	        message: error.Message || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'bank.error' })
	      });
	    }
	
	    if ((0, _lodash.isEmpty)(accounts)) {
	      return _react2.default.createElement(_PanelMessage2.default, {
	        message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'bank.none' }),
	        iconName: 'info',
	        type: 'info',
	        action: editBank ? function () {
	          return dispatch((0, _EmployeeBank.createNewAccount)());
	        } : null,
	        actionLabel: editBank ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'bank.add' }) : null
	      });
	    }
	
	    return (0, _lodash.map)(accounts, function (a, i) {
	      return _react2.default.createElement(_EmployeeBankAccount2.default, { key: i, account: a });
	    });
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _materialUi.Subheader,
	      { style: _Cards2.default.subheader },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'bank.title' })
	    ),
	    renderAccounts()
	  );
	};
	
	EmployeeBank.propTypes = {
	  loaded: _propTypes2.default.bool.isRequired,
	  branchesLoaded: _propTypes2.default.bool.isRequired,
	  error: _propTypes2.default.object,
	  hasError: _propTypes2.default.bool.isRequired,
	  accounts: _propTypes2.default.object,
	  dispatch: _propTypes2.default.func.isRequired
	};
	
	EmployeeBank.defaultProps = {
	  error: null,
	  accounts: {}
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var EmployeeBankReducer = _ref2.EmployeeBankReducer;
	  return _extends({}, EmployeeBankReducer);
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(EmployeeBank);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EmployeeBank, 'EmployeeBank', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeBank.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeBank.js');
	}();

	;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reduxForm = __webpack_require__(67);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _flowRight = __webpack_require__(202);
	
	var _flowRight2 = _interopRequireDefault(_flowRight);
	
	var _normalize = __webpack_require__(103);
	
	var _EmployeeBank = __webpack_require__(423);
	
	var _lodash = __webpack_require__(8);
	
	var _statuses = __webpack_require__(432);
	
	var _TaxCard = __webpack_require__(435);
	
	var _TaxCard2 = _interopRequireDefault(_TaxCard);
	
	var _TField = __webpack_require__(434);
	
	var _TField2 = _interopRequireDefault(_TField);
	
	var _helpers = __webpack_require__(224);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeBankAccount = function EmployeeBankAccount(props) {
	  var status = props.status,
	      invalid = props.invalid;
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      valuesByKey = _useSelector.WebValuesReducer.valuesByKey;
	
	  var onEdit = function onEdit() {
	    return props.setStatus({ id: props.account.EmployeeMasterBankID, value: _statuses.ACCOUNT_EDIT });
	  };
	  var onSave = function onSave(data) {
	    props.update(data);
	  };
	
	  var editIcon = status === _statuses.ACCOUNT_SAVING ? _react2.default.createElement(_materialUi.CircularProgress, { style: { lineHeight: '14px' }, size: 14, thickness: 2 }) : _react2.default.createElement(
	    _materialUi.FontIcon,
	    { style: { fontSize: 16 }, className: 'material-icons' },
	    'edit'
	  );
	  var btnIcon = status === _statuses.ACCOUNT_EDIT ? _react2.default.createElement(
	    _materialUi.FontIcon,
	    { style: { fontSize: 16 }, className: 'material-icons' },
	    'save'
	  ) : editIcon;
	
	  var editBank = (0, _lodash.get)(valuesByKey, ['Edit.EmployeeMasterBank', 'Value']) !== 'false';
	
	  return _react2.default.createElement(
	    _materialUi.Paper,
	    null,
	    _react2.default.createElement(
	      'form',
	      { style: _extends({}, _TaxCard2.default.container, { paddingTop: 16 }) },
	      _react2.default.createElement(_reduxForm.Field, {
	        name: 'BankID',
	        component: _TField2.default,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'bank.branch' }),
	        customStyle: { width: 120 },
	        disabled: status === _statuses.ACCOUNT_FIXED,
	        pad: 4,
	        maxLength: '4',
	        normalize: _normalize.normalizeNumber
	      }),
	      _react2.default.createElement(_reduxForm.Field, {
	        name: 'BankAccountLedger',
	        component: _TField2.default,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'bank.ledger' }),
	        customStyle: { width: 120 },
	        disabled: status === _statuses.ACCOUNT_FIXED,
	        pad: 2,
	        maxLength: '2',
	        normalize: _normalize.normalizeNumber
	      }),
	      _react2.default.createElement(_reduxForm.Field, {
	        name: 'BankAccountNR',
	        component: _TField2.default,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'bank.account' }),
	        customStyle: { width: 120 },
	        disabled: status === _statuses.ACCOUNT_FIXED,
	        pad: 6,
	        maxLength: '6',
	        normalize: _normalize.normalizeNumber
	      }),
	      editBank && _react2.default.createElement(_materialUi.FlatButton, {
	        style: _TaxCard2.default.editButton,
	        labelStyle: _TaxCard2.default.editButtonLabel,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: status === _statuses.ACCOUNT_EDIT ? 'bank.save' : 'bank.edit' }),
	        onClick: status === _statuses.ACCOUNT_EDIT ? props.handleSubmit(onSave) : onEdit,
	        primary: status === _statuses.ACCOUNT_EDIT,
	        disabled: status === _statuses.ACCOUNT_EDIT ? invalid : status === _statuses.ACCOUNT_SAVING,
	        icon: btnIcon
	      })
	    )
	  );
	};
	
	EmployeeBankAccount.propTypes = {
	  handleSubmit: _propTypes2.default.func.isRequired,
	  update: _propTypes2.default.func.isRequired,
	  status: _propTypes2.default.oneOf([_statuses.ACCOUNT_EDIT, _statuses.ACCOUNT_SAVING, _statuses.ACCOUNT_FIXED]),
	  account: _propTypes2.default.object.isRequired,
	  setStatus: _propTypes2.default.func.isRequired,
	  invalid: _propTypes2.default.bool.isRequired
	};
	
	EmployeeBankAccount.defaultProps = {
	  status: _statuses.ACCOUNT_FIXED
	};
	
	var _default = (0, _flowRight2.default)((0, _reactRedux.connect)(function (state, props) {
	  return {
	    form: 'EBA-' + props.account.EmployeeMasterBankID,
	    initialValues: props.account,
	    status: state.EmployeeBankReducer['status-' + props.account.EmployeeMasterBankID],
	    bankBranches: state.EmployeeBankReducer.bankBranches,
	    bankLedgers: state.EmployeeBankReducer.bankLedgers,
	    validateBankAccount: _helpers.validateBankAccount
	  };
	}, function (dispatch) {
	  return {
	    update: function update(emb) {
	      return dispatch((0, _EmployeeBank.update)(emb));
	    },
	    setStatus: function setStatus(status) {
	      return dispatch((0, _EmployeeBank.setStatus)(status));
	    }
	  };
	}), (0, _reduxForm.reduxForm)({}))(EmployeeBankAccount);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EmployeeBankAccount, 'EmployeeBankAccount', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeBankAccount.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeBankAccount.js');
	}();

	;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(12);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _EmployeePensionAndUnion = __webpack_require__(280);
	
	var _Cards = __webpack_require__(119);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _helpers = __webpack_require__(224);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeePayUnion = function EmployeePayUnion(_ref) {
	  var fetchUnion = _ref.fetchUnion,
	      unions = _ref.unions,
	      unionLoading = _ref.unionLoading,
	      unionError = _ref.unionError,
	      detailId = _ref.detailId;
	
	  (0, _react.useEffect)(function () {
	    fetchUnion(detailId);
	  }, []);
	
	  var valid = (0, _lodash.filter)(unions, function (u) {
	    return (0, _moment2.default)().isBetween((0, _moment2.default)(u.Begda), (0, _moment2.default)(u.Endda));
	  });
	  var latest = valid[0];
	  var history = (0, _lodash.filter)(valid, function (p) {
	    return p.EmployeeDetailUnionID !== (0, _lodash.get)(latest, 'EmployeeDetailUnionID');
	  });
	
	  if (unionLoading) return _react2.default.createElement(
	    _materialUi.Paper,
	    { style: _Cards2.default.loading },
	    _react2.default.createElement(_materialUi.CircularProgress, null)
	  );
	
	  if (unionError) {
	    return _react2.default.createElement(_PanelMessage2.default, {
	      type: 'error',
	      iconName: 'error',
	      zDepth: 1,
	      message: unionError.Message || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error', values: { name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Union' }) } })
	    });
	  }
	
	  var renderList = function renderList() {
	    return _react2.default.createElement(
	      _materialUi.Paper,
	      { zDepth: 1 },
	      (0, _helpers.renderUnionRow)(latest),
	      (0, _lodash.map)(history, function (u) {
	        return (0, _helpers.renderUnionRow)(u);
	      })
	    );
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _materialUi.Subheader,
	      { style: _Cards2.default.subheader },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Union' })
	    ),
	    !(0, _lodash.isEmpty)(latest) ? renderList() : _react2.default.createElement(_PanelMessage2.default, {
	      zDepth: 1,
	      message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'No.pay.union' }),
	      iconName: 'info',
	      type: 'info'
	    })
	  );
	};
	
	EmployeePayUnion.propTypes = {
	  fetchUnion: _propTypes2.default.func,
	  unions: _propTypes2.default.array,
	  unionLoading: _propTypes2.default.bool,
	  unionError: _propTypes2.default.object,
	  detailId: _propTypes2.default.number
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var EmployeePensionAndUnionReducer = _ref2.EmployeePensionAndUnionReducer;
	  return {
	    unions: EmployeePensionAndUnionReducer.unions,
	    unionLoading: EmployeePensionAndUnionReducer.unionLoading,
	    unionError: EmployeePensionAndUnionReducer.unionError
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchUnion: function fetchUnion(detailId) {
	      return dispatch((0, _EmployeePensionAndUnion.fetchUnionData)(detailId));
	    }
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EmployeePayUnion);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EmployeePayUnion, 'EmployeePayUnion', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeePayUnion.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeePayUnion.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeePayUnion.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeePayUnion.js');
	}();

	;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // /* eslint-disable */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(12);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _EmployeePensionAndUnion = __webpack_require__(280);
	
	var _Cards = __webpack_require__(119);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import { renderList } from './helpers';
	
	var EmployeePension = function EmployeePension(_ref) {
	  var fetchPension = _ref.fetchPension,
	      pensions = _ref.pensions,
	      privatePensions = _ref.privatePensions,
	      pensionLoading = _ref.pensionLoading,
	      pensionError = _ref.pensionError,
	      detailId = _ref.detailId;
	
	
	  (0, _react.useEffect)(function () {
	    fetchPension(detailId);
	  }, []);
	
	  var latestPension = (0, _lodash.filter)(pensions, function (p) {
	    return (0, _moment2.default)().isBetween((0, _moment2.default)(p.Begda), (0, _moment2.default)(p.Endda));
	  });
	
	  var latestPrivatePension = (0, _lodash.filter)(privatePensions, function (p) {
	    return (0, _moment2.default)().isBetween((0, _moment2.default)(p.Begda), (0, _moment2.default)(p.Endda));
	  });
	
	  var renderRow = function renderRow(obj) {
	    return _react2.default.createElement(
	      'div',
	      { style: _Cards2.default.row, key: obj.EmployeeDetailPensionID },
	      _react2.default.createElement(
	        'div',
	        { style: _Cards2.default.col1 },
	        _react2.default.createElement(
	          'span',
	          { style: _Cards2.default.label },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Pension.fund.number' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          obj.PayPensionID
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: _Cards2.default.col2 },
	        _react2.default.createElement(
	          'span',
	          { style: _Cards2.default.label },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Pension.fund' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          obj.PayPensionName
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: _extends({}, _Cards2.default.col3, _Cards2.default.alignRight) },
	        _react2.default.createElement(
	          'span',
	          { style: _Cards2.default.label },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Pension.employee.percentage' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          obj.PercentEmployee
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: _extends({}, _Cards2.default.col4, _Cards2.default.alignRight) },
	        _react2.default.createElement(
	          'span',
	          { style: _extends({}, _Cards2.default.label, { whiteSpace: 'nowrap', marginLeft: 8 }) },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Pension.company.percentage' })
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          obj.PercentCompany
	        )
	      )
	    );
	  };
	
	  if (pensionLoading) return _react2.default.createElement(
	    _materialUi.Paper,
	    { style: _Cards2.default.loading },
	    _react2.default.createElement(_materialUi.CircularProgress, null)
	  );
	
	  if (pensionError) {
	    return _react2.default.createElement(_PanelMessage2.default, {
	      type: 'error',
	      iconName: 'error',
	      zDepth: 1,
	      message: pensionError.Message || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error', values: { name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Pension.fund' }) } })
	    });
	  }
	
	  // const msg = str => (
	  //   <PanelMessage style={{ paddingLeft: '0px !important' }} zDepth={1} message={<FormattedMessage id={str} />} iconName="info" type="info" />
	  // );
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _materialUi.Subheader,
	      { style: _Cards2.default.subheader },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Pension.fund' })
	    ),
	    latestPension.length ? _react2.default.createElement(
	      _materialUi.Paper,
	      { zDepth: 1 },
	      (0, _lodash.map)(latestPension, function (p) {
	        return renderRow(p);
	      })
	    ) : _react2.default.createElement(_PanelMessage2.default, {
	      zDepth: 1,
	      message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'No.pension.fund' }),
	      iconName: 'info',
	      type: 'info'
	    }),
	    _react2.default.createElement(
	      _materialUi.Subheader,
	      { style: _Cards2.default.subheader },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'Private.pension.fund' })
	    ),
	    latestPrivatePension.length ? _react2.default.createElement(
	      _materialUi.Paper,
	      { zDepth: 1 },
	      (0, _lodash.map)(latestPrivatePension, function (p) {
	        return renderRow(p);
	      })
	    ) : _react2.default.createElement(_PanelMessage2.default, {
	      zDepth: 1,
	      message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'No.private.pension.fund' }),
	      iconName: 'info',
	      type: 'info'
	    })
	  );
	};
	
	EmployeePension.propTypes = {
	  fetchPension: _propTypes2.default.func,
	  pensions: _propTypes2.default.array,
	  privatePensions: _propTypes2.default.array,
	  pensionLoading: _propTypes2.default.bool,
	  pensionError: _propTypes2.default.object,
	  detailId: _propTypes2.default.number
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var EmployeePensionAndUnionReducer = _ref2.EmployeePensionAndUnionReducer;
	  return {
	    pensions: EmployeePensionAndUnionReducer.pensions,
	    privatePensions: EmployeePensionAndUnionReducer.privatePensions,
	    pensionLoading: EmployeePensionAndUnionReducer.pensionLoading,
	    pensionError: EmployeePensionAndUnionReducer.pensionError
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchPension: function fetchPension(detailId) {
	      return dispatch((0, _EmployeePensionAndUnion.fetchPensionData)(detailId));
	    }
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EmployeePension);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EmployeePension, 'EmployeePension', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeePension.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeePension.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeePension.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeePension.js');
	}();

	;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable react/jsx-indent-props */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reduxForm = __webpack_require__(67);
	
	var _reactRedux = __webpack_require__(12);
	
	var _lodash = __webpack_require__(8);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _normalize = __webpack_require__(103);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	var _valuesByKey = __webpack_require__(92);
	
	var _EmployeeTaxCards = __webpack_require__(424);
	
	var _statuses = __webpack_require__(432);
	
	var _TField = __webpack_require__(434);
	
	var _TField2 = _interopRequireDefault(_TField);
	
	var _helpers = __webpack_require__(224);
	
	var _TaxCard = __webpack_require__(435);
	
	var _TaxCard2 = _interopRequireDefault(_TaxCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeTaxCard = function EmployeeTaxCard(props) {
	  var card = props.card,
	      handleSubmit = props.handleSubmit,
	      invalid = props.invalid,
	      status = props.status,
	      valuesByKey = props.valuesByKey,
	      lastUsedOptions = props.lastUsedOptions,
	      cardType = props.cardType,
	      createCard = props.createCard;
	
	
	  var cardName = cardType === 1 ? 'EmployeeMasterTaxCard' : 'EmployeeMasterTaxCardSpouse';
	
	  var startCreate = function startCreate() {
	    return props.setStatus({ id: cardType, value: _statuses.TAX_CARD_CREATE });
	  };
	
	  if ((0, _lodash.isEmpty)(card) && status !== _statuses.TAX_CARD_CREATE) {
	    if (cardType === 2 && !(0, _valuesByKey.shouldCreate)(valuesByKey, cardName)) return null;
	
	    return _react2.default.createElement(_PanelMessage2.default, {
	      message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'taxCard.none.' + cardName }),
	      iconName: 'info',
	      type: 'info',
	      action: (0, _valuesByKey.shouldCreate)(valuesByKey, cardName) ? startCreate : null,
	      actionLabel: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'taxCard.create' })
	    });
	  }
	
	  var onEdit = function onEdit() {
	    return props.setStatus({ id: cardType, value: _statuses.TAX_CARD_EDIT });
	  };
	  var onSave = function onSave(data) {
	    return props.update(data);
	  };
	  var onCreate = function onCreate(data) {
	    return createCard(_extends({}, data, { TaxCardType: cardType }));
	  };
	
	  var fieldEnabled = function fieldEnabled(key) {
	    return status === _statuses.TAX_CARD_CREATE && (0, _valuesByKey.shouldCreate)(valuesByKey, cardName) || (0, _valuesByKey.shouldEdit)(valuesByKey, 'EmployeeMasterTaxCard.' + key);
	  };
	
	  var buttonEnabled = function buttonEnabled() {
	    return status === _statuses.TAX_CARD_CREATE && (0, _valuesByKey.shouldCreate)(valuesByKey, cardName) || (0, _valuesByKey.shouldEdit)(valuesByKey, 'EmployeeMasterTaxCard');
	  };
	
	  var isEditing = status === _statuses.TAX_CARD_EDIT || status === _statuses.TAX_CARD_CREATE;
	
	  var currentMonth = new Date().getMonth();
	
	  var allowLastUsedEdit = (0, _lodash.get)(card, 'DateLastUsed') ? new Date(card.DateLastUsed).getTime() < new Date(new Date().getFullYear(), 0, 1).getTime() : true;
	
	  var editIcon = status === _statuses.TAX_CARD_SAVING ? _react2.default.createElement(_materialUi.CircularProgress, { style: { lineHeight: '14px' }, size: 14, thickness: 2 }) : _react2.default.createElement(
	    _materialUi.FontIcon,
	    { style: { fontSize: 16 }, className: 'material-icons' },
	    'edit'
	  );
	
	  var btnIcon = isEditing ? _react2.default.createElement(
	    _materialUi.FontIcon,
	    { style: { fontSize: 16 }, className: 'material-icons' },
	    'save'
	  ) : editIcon;
	
	  var chooseMethod = function chooseMethod() {
	    if (status === _statuses.TAX_CARD_EDIT) return handleSubmit(onSave);
	    if (status === _statuses.TAX_CARD_CREATE) return handleSubmit(onCreate);
	    return onEdit;
	  };
	
	  return _react2.default.createElement(
	    _materialUi.Paper,
	    null,
	    _react2.default.createElement(
	      _materialUi.Subheader,
	      null,
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: cardType === 1 ? 'taxCard.title.employee' : 'taxCard.title.spouse' })
	    ),
	    _react2.default.createElement(
	      'form',
	      { style: _TaxCard2.default.container },
	      _react2.default.createElement(_reduxForm.Field, {
	        name: 'Prosent',
	        component: _TField2.default,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'taxCard.percent' }),
	        customStyle: { width: 120 },
	        disabled: status === _statuses.TAX_CARD_FIXED,
	        maxLength: '3',
	        normalize: _normalize.normalizeNumberRange0to100
	      }),
	      _react2.default.createElement(_reduxForm.Field, {
	        name: 'Unused',
	        component: _TField2.default,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'taxCard.unused' }),
	        customStyle: { width: 120 },
	        disabled: status === _statuses.TAX_CARD_FIXED || !fieldEnabled('Unused'),
	        normalize: _normalize.normalizeNumber
	      }),
	      allowLastUsedEdit ? _react2.default.createElement(_reduxForm.Field, {
	        name: 'DateLastUsed',
	        component: function component(field) {
	          return _react2.default.createElement(
	            _materialUi.SelectField,
	            _extends({}, field.input, {
	              style: _TaxCard2.default.inputCon,
	              selectedMenuItemStyle: { cursor: 'default' },
	              underlineDisabledStyle: _TaxCard2.default.inputDisabled,
	              onChange: function onChange(e, i, v) {
	                return field.input.onChange(v, i, v);
	              },
	              onBlur: function onBlur() {
	                return null;
	              },
	              onFocus: function onFocus() {
	                return null;
	              },
	              floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'taxCard.lastUsed' }),
	              floatingLabelFixed: true,
	              disabled: status === _statuses.TAX_CARD_FIXED || !fieldEnabled('DateLastUsed')
	            }),
	            lastUsedOptions.map(function (x) {
	              return _react2.default.createElement(_materialUi.MenuItem, _extends({}, x, { disabled: x.key < currentMonth }));
	            })
	          );
	        }
	      }) : _react2.default.createElement(_materialUi.TextField, {
	        floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'taxCard.lastUsed' }),
	        style: _TaxCard2.default.inputCon,
	        underlineDisabledStyle: _TaxCard2.default.inputDisabled,
	        floatingLabelFixed: true,
	        disabled: true,
	        inputStyle: _TaxCard2.default.input,
	        value: (0, _dateTools2.default)((0, _lodash.get)(card, 'DateLastUsed'))
	      }),
	      buttonEnabled() && _react2.default.createElement(_materialUi.FlatButton, {
	        style: _TaxCard2.default.editButton,
	        labelStyle: _TaxCard2.default.editButtonLabel,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: isEditing ? 'taxCard.save' : 'taxCard.edit' }),
	        onClick: chooseMethod(),
	        primary: isEditing,
	        disabled: isEditing ? invalid : status === _statuses.TAX_CARD_SAVING,
	        icon: btnIcon
	      })
	    )
	  );
	};
	
	EmployeeTaxCard.propTypes = {
	  cardType: _propTypes2.default.number.isRequired,
	  card: _propTypes2.default.object,
	  valuesByKey: _propTypes2.default.object.isRequired,
	  handleSubmit: _propTypes2.default.func.isRequired, // needed for RootForm
	  setStatus: _propTypes2.default.func.isRequired,
	  update: _propTypes2.default.func.isRequired,
	  status: _propTypes2.default.oneOf([_statuses.TAX_CARD_FIXED, _statuses.TAX_CARD_SAVING, _statuses.TAX_CARD_EDIT, _statuses.TAX_CARD_CREATE]),
	  invalid: _propTypes2.default.bool.isRequired,
	  lastUsedOptions: _propTypes2.default.array.isRequired,
	  createCard: _propTypes2.default.func.isRequired
	};
	
	EmployeeTaxCard.defaultProps = {
	  status: _statuses.TAX_CARD_FIXED
	};
	
	var mapStateToProps = function mapStateToProps(_ref, props) {
	  var EmployeeTaxCardsReducer = _ref.EmployeeTaxCardsReducer,
	      WebValuesReducer = _ref.WebValuesReducer;
	
	  var card = props.cardType === 1 ? EmployeeTaxCardsReducer.employeeTaxCard : EmployeeTaxCardsReducer.spouseTaxCard;
	  return {
	    card: card,
	    status: EmployeeTaxCardsReducer['status-' + props.cardType],
	    valuesByKey: WebValuesReducer.valuesByKey,
	    lastUsedOptions: EmployeeTaxCardsReducer.lastUsedOptions,
	    // required fields for RootForm:
	    form: 'EMTaxCard-' + props.cardType,
	    initialValues: card,
	    validate: function validate(values) {
	      return (0, _helpers.validateTaxCard)(values, EmployeeTaxCardsReducer.taxDiscount);
	    }
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    setStatus: function setStatus(status) {
	      return dispatch((0, _EmployeeTaxCards.setStatus)(status));
	    },
	    update: function update(data) {
	      return dispatch((0, _EmployeeTaxCards.update)(data));
	    },
	    createCard: function createCard(data) {
	      return dispatch((0, _EmployeeTaxCards.createTaxCard)(data));
	    }
	  };
	};
	
	var _default = (0, _lodash.flowRight)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), (0, _reduxForm.reduxForm)({}))(EmployeeTaxCard);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EmployeeTaxCard, 'EmployeeTaxCard', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeTaxCard.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeTaxCard.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeTaxCard.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeTaxCard.js');
	}();

	;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _EmployeeTaxCards = __webpack_require__(424);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _Cards = __webpack_require__(119);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _EmployeeTaxCard = __webpack_require__(930);
	
	var _EmployeeTaxCard2 = _interopRequireDefault(_EmployeeTaxCard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeTaxCards = function EmployeeTaxCards(_ref) {
	  var hasError = _ref.hasError,
	      taxCardsError = _ref.taxCardsError,
	      taxCardsLoading = _ref.taxCardsLoading,
	      taxCardInfo = _ref.taxCardInfo,
	      fetchCards = _ref.fetchCards;
	
	  (0, _react.useEffect)(function () {
	    fetchCards();
	  }, []);
	
	  if (taxCardsLoading) return _react2.default.createElement(
	    _materialUi.Paper,
	    { style: _Cards2.default.loading },
	    _react2.default.createElement(_materialUi.CircularProgress, null)
	  );
	
	  if (hasError) {
	    return _react2.default.createElement(_PanelMessage2.default, {
	      type: 'error',
	      iconName: 'error',
	      message: taxCardsError.Message || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error', values: { name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'taxCards.title' }) } })
	    });
	  }
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _materialUi.Subheader,
	      { style: _Cards2.default.subheader },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'taxCards.title' })
	    ),
	    _react2.default.createElement(_EmployeeTaxCard2.default, { cardType: 1 }),
	    _react2.default.createElement(_EmployeeTaxCard2.default, { cardType: 2 }),
	    taxCardInfo && _react2.default.createElement(
	      _materialUi.Paper,
	      { style: _Cards2.default.loading },
	      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: taxCardInfo.TextBody } })
	    )
	  );
	};
	
	EmployeeTaxCards.propTypes = {
	  hasError: _propTypes2.default.bool,
	  taxCardsError: _propTypes2.default.object,
	  taxCardsLoading: _propTypes2.default.bool,
	  taxCardInfo: _propTypes2.default.object,
	  fetchCards: _propTypes2.default.func
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var EmployeeTaxCardsReducer = _ref2.EmployeeTaxCardsReducer,
	      WebValuesReducer = _ref2.WebValuesReducer;
	  return {
	    hasError: EmployeeTaxCardsReducer.hasError,
	    taxCardsError: EmployeeTaxCardsReducer.taxCardsError,
	    taxCardsLoading: EmployeeTaxCardsReducer.taxCardsLoading,
	    taxCardInfo: EmployeeTaxCardsReducer.taxCardInfo,
	    valuesByKey: WebValuesReducer.valuesByKey
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, function (dispatch) {
	  return {
	    fetchCards: function fetchCards() {
	      dispatch((0, _EmployeeTaxCards.fetchTaxCards)());
	      dispatch((0, _EmployeeTaxCards.requestTaxDiscountInfo)());
	    }
	  };
	})(EmployeeTaxCards);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EmployeeTaxCards, 'EmployeeTaxCards', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeTaxCards.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeTaxCards.js');
	}();

	;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(12);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _EmployeePensionAndUnion = __webpack_require__(280);
	
	var _Cards = __webpack_require__(119);
	
	var _Cards2 = _interopRequireDefault(_Cards);
	
	var _helpers = __webpack_require__(224);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EmployeeUnion = function EmployeeUnion(_ref) {
	  var fetchEmployeeUnion = _ref.fetchEmployeeUnion,
	      employeeUnions = _ref.employeeUnions,
	      employeeUnionLoading = _ref.employeeUnionLoading,
	      employeeUnionError = _ref.employeeUnionError,
	      detailId = _ref.detailId;
	
	  (0, _react.useEffect)(function () {
	    fetchEmployeeUnion(detailId);
	  }, []);
	
	  var valid = (0, _lodash.filter)(employeeUnions, function (u) {
	    return (0, _moment2.default)().isBetween((0, _moment2.default)(u.Begda), (0, _moment2.default)(u.Endda));
	  });
	  var latest = valid[0];
	  var history = (0, _lodash.filter)(valid, function (p) {
	    return p.EmployeeDetailUnionID !== (0, _lodash.get)(latest, 'EmployeeDetailUnionID');
	  });
	
	  if (employeeUnionLoading) return _react2.default.createElement(
	    _materialUi.Paper,
	    { style: _Cards2.default.loading },
	    _react2.default.createElement(_materialUi.CircularProgress, null)
	  );
	
	  if (employeeUnionError) {
	    return _react2.default.createElement(_PanelMessage2.default, {
	      type: 'error',
	      iconName: 'error',
	      zDepth: 1,
	      message: employeeUnionError.Message || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'error', values: { name: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'EmployeeUnion' }) } })
	    });
	  }
	
	  var renderList = function renderList() {
	    return _react2.default.createElement(
	      _materialUi.Paper,
	      null,
	      (0, _helpers.renderUnionRow)(latest),
	      (0, _lodash.map)(history, function (u) {
	        return (0, _helpers.renderUnionRow)(u);
	      })
	    );
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _materialUi.Subheader,
	      { style: _Cards2.default.subheader },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'EmployeeUnion' })
	    ),
	    !(0, _lodash.isEmpty)(latest) ? renderList() : _react2.default.createElement(_PanelMessage2.default, {
	      zDepth: 1,
	      message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'No.employee.union' }),
	      iconName: 'info',
	      type: 'info'
	    })
	  );
	};
	
	EmployeeUnion.propTypes = {
	  fetchEmployeeUnion: _propTypes2.default.func,
	  employeeUnions: _propTypes2.default.array,
	  employeeUnionLoading: _propTypes2.default.bool,
	  employeeUnionError: _propTypes2.default.object,
	  detailId: _propTypes2.default.number
	};
	
	var mapStateToProps = function mapStateToProps(_ref2) {
	  var EmployeePensionAndUnionReducer = _ref2.EmployeePensionAndUnionReducer;
	  return {
	    employeeUnions: EmployeePensionAndUnionReducer.employeeUnions,
	    employeeUnionLoading: EmployeePensionAndUnionReducer.employeeUnionLoading,
	    employeeUnionError: EmployeePensionAndUnionReducer.employeeUnionError
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    fetchEmployeeUnion: function fetchEmployeeUnion(detailId) {
	      return dispatch((0, _EmployeePensionAndUnion.fetchEmployeeUnionData)(detailId));
	    }
	  };
	};
	
	var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EmployeeUnion);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EmployeeUnion, 'EmployeeUnion', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeUnion.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeUnion.js');
	
	  __REACT_HOT_LOADER__.register(mapDispatchToProps, 'mapDispatchToProps', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeUnion.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pay/EmployeeUnion.js');
	}();

	;

/***/ }),
/* 933 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var styles = {
	  container: {
	    paddingLeft: 16,
	    paddingRight: 16,
	    paddingTop: 16,
	    paddingBottom: 16,
	    display: 'flex',
	    justifyContent: 'space-between',
	    marginTop: 8,
	    marginBottom: 8
	  },
	  editButton: {
	    height: 28,
	    lineHeight: '28px',
	    marginTop: '14px'
	  },
	  editButtonLabel: {
	    fontSize: 12,
	    paddingLeft: 6
	  },
	  inputCon: {
	    marginLeft: 8,
	    marginRight: 8,
	    cursor: 'default'
	  },
	  input: {
	    color: 'rgba(0, 0, 0, 0.870588)'
	  },
	  inputDisabled: {
	    borderBottomStyle: 'none'
	  }
	};
	
	var _default = styles;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/pay/styles/BankAccount.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pay/styles/BankAccount.js');
	}();

	;

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise, global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _dateTools = __webpack_require__(35);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reapop = __webpack_require__(44);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _getAppraisalTitle = __webpack_require__(148);
	
	var _getAppraisalTitle2 = _interopRequireDefault(_getAppraisalTitle);
	
	var _api = __webpack_require__(225);
	
	var _appraisalEnums = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var FINISHED = _appraisalEnums.STATUS.FINISHED;
	var EMPLOYEE = _appraisalEnums.ANSWER_TYPES.EMPLOYEE,
	    MANAGER = _appraisalEnums.ANSWER_TYPES.MANAGER,
	    FINAL = _appraisalEnums.ANSWER_TYPES.FINAL;
	
	
	var styles = {
	  subheader: {
	    paddingLeft: 0,
	    fontSize: 18,
	    fontWeight: 500,
	    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif'
	  },
	  root: {
	    padding: 16
	  },
	  header: {
	    fontSize: 20,
	    fontWeight: 500
	  },
	  appraisalDescription: {
	    marginBottom: 24,
	    display: 'block'
	  },
	  info: {
	    paddingTop: 16,
	    display: 'flex',
	    flexDirection: 'row',
	    justifyContent: 'space-between',
	    flexWrap: 'wrap'
	  },
	  infoItem: {
	    display: 'flex',
	    flexDirection: 'column',
	    padding: 6,
	    minWidth: 260,
	    overflow: 'hidden'
	  },
	  infoMessage: {
	    flex: 1,
	    flexBasis: 24
	  },
	  label: {
	    flex: 1,
	    flexBasis: 24,
	    color: 'rgb(176, 176, 176)'
	  },
	  errorText: {
	    color: 'rgb(244, 67, 54)'
	  },
	  questionRoot: {
	    padding: 16
	  },
	  question: {
	    display: 'flex',
	    flexDirection: 'column',
	    paddingBottom: 16,
	    fontWeight: 500
	  },
	  description: {
	    color: 'rgb(95, 95, 95)',
	    fontSize: 14,
	    fontWeight: 'normal'
	  },
	  input: {
	    marginBottom: 16,
	    marginTop: 8
	    // padding: 8,
	  },
	  actions: {
	    display: 'flex',
	    justifyContent: 'flex-end'
	  },
	  action: {
	    marginLeft: 16
	  },
	  groupTitle: {
	    fontSize: 14,
	    fontWeight: 500,
	    color: 'rgb(0, 0, 0, 0.87)',
	    marginBottom: 8,
	    marginTop: 8
	  }
	};
	
	var PMAppraisal = function PMAppraisal(_ref, context) {
	  var params = _ref.params,
	      dispatch = _ref.dispatch,
	      valuesByKey = _ref.valuesByKey;
	  var appraisalId = params.appraisalId;
	
	  var _useState = (0, _react.useState)(null),
	      _useState2 = _slicedToArray(_useState, 2),
	      appraisal = _useState2[0],
	      setAppraisal = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      loading = _useState4[0],
	      setLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      error = _useState6[0],
	      setError = _useState6[1];
	
	  var _useState7 = (0, _react.useState)({}),
	      _useState8 = _slicedToArray(_useState7, 2),
	      formData = _useState8[0],
	      setFormData = _useState8[1];
	
	  var _useState9 = (0, _react.useState)('IS'),
	      _useState10 = _slicedToArray(_useState9, 2),
	      language = _useState10[0],
	      setLanguage = _useState10[1];
	
	  var _useState11 = (0, _react.useState)({}),
	      _useState12 = _slicedToArray(_useState11, 2),
	      validationErrors = _useState12[0],
	      setValidationErrors = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      isSaving = _useState14[0],
	      setIsSaving = _useState14[1];
	
	  (0, _react.useEffect)(function () {
	    var fetchAppraisal = function () {
	      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var response, loadedFormData;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	
	                setLoading(true);
	                _context.next = 4;
	                return (0, _api.getPMEmployeeAppraisal)(appraisalId);
	
	              case 4:
	                response = _context.sent;
	
	                setAppraisal(response.data);
	
	                // Set default language from appraisal
	                if (response.data && response.data.DefaultLanguage) {
	                  setLanguage(response.data.DefaultLanguage);
	                }
	
	                // Load existing answers into form if not finished
	                if (response.data && response.data.EmployeeStatus !== FINISHED) {
	                  loadedFormData = {};
	
	
	                  response.data.Groups.forEach(function (group) {
	                    group.Questions.forEach(function (question) {
	                      if (question.IsEmployeeQuestion && question.Answers) {
	                        var employeeAnswers = question.Answers.filter(function (a) {
	                          return a.AnswerType === EMPLOYEE;
	                        });
	
	                        employeeAnswers.forEach(function (answer) {
	                          var questionId = question.PMEmployeeAppraisalGroupQuestionID;
	
	                          if (answer.IsComment || answer.Comment) {
	                            // This is a comment
	                            if (!loadedFormData[questionId]) {
	                              loadedFormData[questionId] = {};
	                            }
	                            loadedFormData[questionId].comment = answer.Answer || answer.Comment;
	                          } else {
	                            // This is the main answer
	                            if (!loadedFormData[questionId]) {
	                              loadedFormData[questionId] = {};
	                            }
	
	                            var value = answer.Answer;
	
	                            // Parse based on question type
	                            if (question.QuestionType === 'Multiple') {
	                              // Parse JSON array
	                              try {
	                                value = JSON.parse(value);
	                              } catch (e) {
	                                value = [];
	                              }
	                            } else if (question.QuestionType === 'Date') {
	                              // Convert to Date object
	                              value = value ? new Date(value) : null;
	                            } else if (question.QuestionType === 'Single' || question.QuestionType === 'Scale') {
	                              // Parse as number (OptionID)
	                              value = parseInt(value, 10);
	                            }
	                            // For Text and Bool, keep as string
	
	                            loadedFormData[questionId].value = value;
	                          }
	                        });
	                      }
	                    });
	                  });
	
	                  setFormData(loadedFormData);
	                }
	
	                setError(null);
	                _context.next = 14;
	                break;
	
	              case 11:
	                _context.prev = 11;
	                _context.t0 = _context['catch'](0);
	
	                setError(_context.t0);
	
	              case 14:
	                _context.prev = 14;
	
	                setLoading(false);
	                return _context.finish(14);
	
	              case 17:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 11, 14, 17]]);
	      }));
	
	      return function fetchAppraisal() {
	        return _ref2.apply(this, arguments);
	      };
	    }();
	
	    if (appraisalId) {
	      fetchAppraisal();
	    }
	  }, [appraisalId]);
	
	  if (loading) {
	    return _react2.default.createElement(_Loading2.default, null);
	  }
	
	  if (error) {
	    return _react2.default.createElement(
	      _reactFlexboxGrid.Col,
	      { xs: 12, sm: 10, smOffset: 1, md: 8, mdOffset: 2 },
	      _react2.default.createElement(_PanelMessage2.default, {
	        type: 'error',
	        iconName: 'error',
	        message: error.message || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.error' })
	      })
	    );
	  }
	
	  if (!appraisal) {
	    return null;
	  }
	
	  var EmployeeName = appraisal.EmployeeName,
	      ManagerEmployeeName = appraisal.ManagerEmployeeName,
	      EmployeeDueDate = appraisal.EmployeeDueDate,
	      FinalDueDate = appraisal.FinalDueDate,
	      EmployeeStatus = appraisal.EmployeeStatus,
	      ManagerStatus = appraisal.ManagerStatus,
	      FinalStatus = appraisal.FinalStatus,
	      Groups = appraisal.Groups,
	      Title = appraisal.Title,
	      Description = appraisal.Description,
	      DefaultLanguage = appraisal.DefaultLanguage,
	      Languages = appraisal.Languages,
	      FinalResult = appraisal.FinalResult;
	
	
	  var empDue = new Date(EmployeeDueDate);
	  empDue.setHours(23, 59, 59);
	  var dueDate = empDue;
	
	  var finalDue = null;
	  if (FinalDueDate) {
	    finalDue = new Date(FinalDueDate);
	    finalDue.setHours(23, 59, 59);
	  }
	
	  var isDueExpired = dueDate.getTime() < Date.now() || finalDue && finalDue.getTime() < Date.now();
	  var isFinished = EmployeeStatus === FINISHED || isDueExpired;
	  var allFinished = EmployeeStatus === FINISHED && ManagerStatus === FINISHED && FinalStatus === FINISHED;
	
	  var handleNav = function handleNav() {
	    context.router.push('/pmappraisals');
	  };
	
	  var handleInputChange = function handleInputChange(questionId, value) {
	    var isComment = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    setFormData(_extends({}, formData, _defineProperty({}, questionId, _extends({}, formData[questionId], _defineProperty({}, isComment ? 'comment' : 'value', value)))));
	  };
	
	  var transformFormValuesToAnswers = function transformFormValuesToAnswers(values) {
	    var answers = [];
	
	    Object.entries(values).forEach(function (_ref3) {
	      var _ref4 = _slicedToArray(_ref3, 2),
	          questionId = _ref4[0],
	          data = _ref4[1];
	
	      if (!data) return;
	
	      var value = data.value,
	          comment = data.comment;
	
	      // Add main answer if value exists
	
	      if (value !== undefined && value !== null && value !== '') {
	        var answerValue = value;
	
	        // Handle arrays (multiple choice)
	        if (Array.isArray(value)) {
	          answerValue = JSON.stringify(value);
	        } else if (value instanceof Date) {
	          answerValue = value.toISOString();
	        } else if (typeof value !== 'string') {
	          answerValue = String(value);
	        }
	
	        answers.push({
	          PMEmployeeAppraisalQuestionID: parseInt(questionId, 10),
	          Answer: answerValue,
	          AnswerType: EMPLOYEE
	        });
	      }
	
	      // Add comment if exists
	      if (comment) {
	        answers.push({
	          PMEmployeeAppraisalQuestionID: parseInt(questionId, 10),
	          Answer: comment,
	          AnswerType: EMPLOYEE,
	          IsComment: true
	        });
	      }
	    });
	
	    return answers;
	  };
	
	  var validateRequiredFields = function validateRequiredFields() {
	    var errors = {};
	    var isValid = true;
	
	    if (Groups) {
	      Groups.forEach(function (group) {
	        group.Questions.forEach(function (question) {
	          if (question.IsEmployeeQuestion && question.IsRequired) {
	            var answerData = formData[question.PMEmployeeAppraisalGroupQuestionID];
	            var value = answerData ? answerData.value : null;
	
	            // Check if value is empty
	            if (!value || value === '' || Array.isArray(value) && value.length === 0) {
	              errors[question.PMEmployeeAppraisalGroupQuestionID] = true;
	              isValid = false;
	            }
	          }
	        });
	      });
	    }
	
	    setValidationErrors(errors);
	    return isValid;
	  };
	
	  var handleSubmit = function () {
	    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(status) {
	      var answers, payload;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              if (!(status === 'Finished')) {
	                _context2.next = 3;
	                break;
	              }
	
	              if (validateRequiredFields()) {
	                _context2.next = 3;
	                break;
	              }
	
	              return _context2.abrupt('return');
	
	            case 3:
	              answers = transformFormValuesToAnswers(formData);
	              payload = {
	                Answers: answers,
	                EmployeeStatus: status
	              };
	              _context2.prev = 5;
	
	              setIsSaving(true);
	              _context2.next = 9;
	              return (0, _api.updatePMEmployeeAppraisal)(payload, appraisalId);
	
	            case 9:
	
	              // Success - navigate back or show success message
	              if (status === 'Finished') {
	                dispatch((0, _reapop.addNotification)({
	                  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.notification.submitted' }),
	                  message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.notification.submitted.message' }),
	                  status: 'success',
	                  dismissible: true,
	                  dismissAfter: 4000
	                }));
	                context.router.push('/pmappraisals');
	              } else {
	                dispatch((0, _reapop.addNotification)({
	                  title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.notification.saved' }),
	                  message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.notification.saved.message' }),
	                  status: 'success',
	                  dismissible: true,
	                  dismissAfter: 4000
	                }));
	                // Clear validation errors on successful save
	                setValidationErrors({});
	              }
	              _context2.next = 16;
	              break;
	
	            case 12:
	              _context2.prev = 12;
	              _context2.t0 = _context2['catch'](5);
	
	              dispatch((0, _reapop.addNotification)({
	                title: 'Error',
	                message: _context2.t0.message || 'Failed to save appraisal',
	                status: 'error',
	                dismissible: true,
	                dismissAfter: 5000
	              }));
	              console.error('Error submitting appraisal:', _context2.t0);
	
	            case 16:
	              _context2.prev = 16;
	
	              setIsSaving(false);
	              return _context2.finish(16);
	
	            case 19:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[5, 12, 16, 19]]);
	    }));
	
	    return function handleSubmit(_x2) {
	      return _ref5.apply(this, arguments);
	    };
	  }();
	
	  var getAnswerDisplayText = function getAnswerDisplayText(question) {
	    var answerType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPLOYEE;
	
	    var answers = question.Answers ? question.Answers.filter(function (a) {
	      return a.AnswerType === answerType && !a.IsComment;
	    }) : [];
	    if (!answers.length) return '-';
	
	    var answer = answers[0];
	    var QuestionType = question.QuestionType,
	        Options = question.Options;
	
	
	    if (QuestionType === 'Text') {
	      return answer.Answer || '-';
	    }
	
	    if (QuestionType === 'Bool') {
	      var yesText = language === 'IS' ? 'Já' : 'Yes';
	      var noText = language === 'IS' ? 'Nei' : 'No';
	      return answer.Answer === 'true' ? yesText : noText;
	    }
	
	    if (QuestionType === 'Date') {
	      return answer.Answer ? new Date(answer.Answer).toLocaleDateString(language === 'IS' ? 'is-IS' : 'en-US') : '-';
	    }
	
	    if (QuestionType === 'Single' || QuestionType === 'Scale') {
	      var optionId = parseInt(answer.Answer, 10);
	      var option = Options.find(function (o) {
	        return o.OptionID === optionId;
	      });
	      if (option) {
	        var text = (0, _lodash.get)(option, ['Text', language]) || (0, _lodash.get)(option, ['Text', 'IS']) || (0, _lodash.get)(option, ['Text', 'EN']) || '';
	        return QuestionType === 'Scale' && option.ScaleValue ? text + ' (' + option.ScaleValue + ')' : text;
	      }
	      return '-';
	    }
	
	    if (QuestionType === 'Multiple') {
	      try {
	        var optionIds = JSON.parse(answer.Answer);
	        var selectedOptions = Options.filter(function (o) {
	          return optionIds.includes(o.OptionID);
	        });
	        return selectedOptions.map(function (o) {
	          return (0, _lodash.get)(o, ['Text', language]) || (0, _lodash.get)(o, ['Text', 'IS']) || (0, _lodash.get)(o, ['Text', 'EN']) || '';
	        }).join(', ') || '-';
	      } catch (e) {
	        return '-';
	      }
	    }
	
	    return '-';
	  };
	
	  var getAnswerComment = function getAnswerComment(question) {
	    var answerType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EMPLOYEE;
	
	    var answers = question.Answers ? question.Answers.filter(function (a) {
	      return a.AnswerType === answerType && a.IsComment;
	    }) : [];
	    return answers.length ? answers[0].Answer : '';
	  };
	
	  // Use custom appraisal title from WebValues if exists
	  var appraisalTitle = (0, _getAppraisalTitle2.default)(valuesByKey);
	
	  return _react2.default.createElement(
	    _reactFlexboxGrid.Col,
	    { xs: 12, md: 10, mdOffset: 1, style: { paddingBottom: 16 } },
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' } },
	      _react2.default.createElement(
	        _materialUi.Subheader,
	        { style: styles.subheader },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: appraisalTitle })
	      ),
	      Languages && Languages.length > 1 && _react2.default.createElement(
	        _materialUi.SelectField,
	        {
	          value: language,
	          onChange: function onChange(e, index, value) {
	            return setLanguage(value);
	          },
	          style: { width: 120 }
	        },
	        Languages.map(function (lang) {
	          return _react2.default.createElement(_materialUi.MenuItem, { key: lang, value: lang, primaryText: lang });
	        })
	      )
	    ),
	    _react2.default.createElement(
	      _materialUi.Paper,
	      { style: { marginBottom: 16 } },
	      _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(
	          'span',
	          { style: styles.header },
	          (0, _lodash.get)(Title, language) || ''
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: styles.appraisalDescription },
	          (0, _lodash.get)(Description, language) || ''
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: styles.info },
	          _react2.default.createElement(
	            'div',
	            { style: styles.infoItem },
	            _react2.default.createElement(
	              'span',
	              { style: styles.infoMessage },
	              EmployeeName
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: styles.label },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.employee' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.infoItem },
	            _react2.default.createElement(
	              'span',
	              { style: styles.infoMessage },
	              ManagerEmployeeName
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: styles.label },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.manager' })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.infoItem },
	            dueDate.getTime() < Date.now() ? _react2.default.createElement(
	              'span',
	              { style: styles.errorText },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.expired' })
	            ) : _react2.default.createElement(
	              'span',
	              { style: styles.infoMessage },
	              (0, _dateTools.fromNow)(dueDate)
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: styles.label },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.timeToFinish' })
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'form',
	      null,
	      Groups && Groups.map(function (group, groupIndex) {
	        return _react2.default.createElement(
	          'div',
	          { key: group.PMAppraisalGroupID },
	          group.Questions && group.Questions.some(function (q) {
	            return q.IsEmployeeQuestion || allFinished && q.IsManagerQuestion;
	          }) && _react2.default.createElement(
	            'div',
	            { style: styles.groupTitle },
	            (0, _lodash.get)(group, ['Text', language]) || (0, _lodash.get)(group, ['Text', 'IS']) || (0, _lodash.get)(group, ['Text', 'EN']) || ''
	          ),
	          group.Questions && group.Questions.map(function (question) {
	            // When not finished, only show employee questions
	            // When all finished, show all questions
	            if (!isFinished && !question.IsEmployeeQuestion) return null;
	            if (isFinished && !allFinished && !question.IsEmployeeQuestion) return null;
	            if (allFinished && !question.IsEmployeeQuestion && !question.IsManagerQuestion) return null;
	
	            var PMEmployeeAppraisalGroupQuestionID = question.PMEmployeeAppraisalGroupQuestionID,
	                Text = question.Text,
	                Description = question.Description,
	                QuestionType = question.QuestionType,
	                Options = question.Options,
	                AllowComment = question.AllowComment,
	                IsEmployeeQuestion = question.IsEmployeeQuestion,
	                IsManagerQuestion = question.IsManagerQuestion;
	
	
	            var questionText = (0, _lodash.get)(Text, language) || (0, _lodash.get)(Text, 'IS') || (0, _lodash.get)(Text, 'EN') || '';
	            var descriptionText = (0, _lodash.get)(Description, language) || (0, _lodash.get)(Description, 'IS') || (0, _lodash.get)(Description, 'EN') || '';
	            var answerData = formData[PMEmployeeAppraisalGroupQuestionID] || {};
	            var value = answerData.value || '';
	            var comment = answerData.comment || '';
	            var hasError = validationErrors[PMEmployeeAppraisalGroupQuestionID];
	            var isRequired = question.IsRequired;
	
	            return _react2.default.createElement(
	              _materialUi.Paper,
	              { key: PMEmployeeAppraisalGroupQuestionID, style: { marginBottom: 16 } },
	              _react2.default.createElement(
	                'div',
	                { style: styles.questionRoot },
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.question },
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    questionText,
	                    isRequired && _react2.default.createElement(
	                      'span',
	                      { style: { color: 'rgb(244, 67, 54)', marginLeft: 4 } },
	                      '*'
	                    )
	                  ),
	                  descriptionText && _react2.default.createElement(
	                    'span',
	                    { style: styles.description },
	                    descriptionText
	                  ),
	                  hasError && _react2.default.createElement(
	                    'span',
	                    { style: { color: 'rgb(244, 67, 54)', fontSize: 12, marginTop: 4 } },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' })
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.input },
	                  isFinished ?
	                  // Read-only view
	                  _react2.default.createElement(
	                    'div',
	                    null,
	                    allFinished && _react2.default.createElement(
	                      'div',
	                      {
	                        style: {
	                          display: 'flex',
	                          flexDirection: 'row',
	                          gap: 32,
	                          marginBottom: 16
	                        }
	                      },
	                      IsEmployeeQuestion && _react2.default.createElement(
	                        'div',
	                        { style: { flex: 1 } },
	                        _react2.default.createElement(
	                          'span',
	                          { style: styles.label },
	                          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.answer.employee' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: 14, color: 'rgba(0, 0, 0, 0.87)' } },
	                          getAnswerDisplayText(question, EMPLOYEE)
	                        ),
	                        AllowComment && getAnswerComment(question, EMPLOYEE) && _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: 14, color: 'rgb(95, 95, 95)', marginTop: 8 } },
	                          getAnswerComment(question, EMPLOYEE)
	                        )
	                      ),
	                      IsManagerQuestion && _react2.default.createElement(
	                        'div',
	                        { style: { flex: 1 } },
	                        _react2.default.createElement(
	                          'span',
	                          { style: styles.label },
	                          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.answer.manager' })
	                        ),
	                        _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: 14, color: 'rgba(0, 0, 0, 0.87)' } },
	                          getAnswerDisplayText(question, MANAGER)
	                        ),
	                        AllowComment && getAnswerComment(question, MANAGER) && _react2.default.createElement(
	                          'div',
	                          { style: { fontSize: 14, color: 'rgb(95, 95, 95)', marginTop: 8 } },
	                          getAnswerComment(question, MANAGER)
	                        )
	                      )
	                    ),
	                    !allFinished && _react2.default.createElement(
	                      'div',
	                      { style: { marginBottom: 16 } },
	                      _react2.default.createElement(
	                        'span',
	                        { style: styles.label },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.answer.employee' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { style: { fontSize: 14, color: 'rgba(0, 0, 0, 0.87)' } },
	                        getAnswerDisplayText(question, EMPLOYEE)
	                      ),
	                      AllowComment && getAnswerComment(question, EMPLOYEE) && _react2.default.createElement(
	                        'div',
	                        { style: { fontSize: 14, color: 'rgb(95, 95, 95)', marginTop: 8 } },
	                        getAnswerComment(question, EMPLOYEE)
	                      )
	                    ),
	                    allFinished && _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(
	                        'span',
	                        { style: styles.label },
	                        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.answer.final' })
	                      ),
	                      _react2.default.createElement(
	                        'div',
	                        { style: { fontSize: 14, color: 'rgba(0, 0, 0, 0.87)' } },
	                        getAnswerDisplayText(question, FINAL)
	                      ),
	                      AllowComment && getAnswerComment(question, FINAL) && _react2.default.createElement(
	                        'div',
	                        { style: { fontSize: 14, color: 'rgb(95, 95, 95)', marginTop: 8 } },
	                        getAnswerComment(question, FINAL)
	                      )
	                    )
	                  ) :
	                  // Editable form
	                  _react2.default.createElement(
	                    _react2.default.Fragment,
	                    null,
	                    QuestionType === 'Text' && _react2.default.createElement(_materialUi.TextField, {
	                      fullWidth: true,
	                      multiLine: true,
	                      rowsMax: 6,
	                      hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'qaelement.input.text' }),
	                      value: value,
	                      onChange: function onChange(e, newValue) {
	                        return handleInputChange(PMEmployeeAppraisalGroupQuestionID, newValue);
	                      }
	                    }),
	                    QuestionType === 'Date' && _react2.default.createElement(_materialUi.DatePicker, {
	                      fullWidth: true,
	                      hintText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Date' }),
	                      value: value ? new Date(value) : null,
	                      onChange: function onChange(e, date) {
	                        return handleInputChange(PMEmployeeAppraisalGroupQuestionID, date);
	                      },
	                      DateTimeFormat: global.Intl.DateTimeFormat,
	                      locale: language === 'IS' ? 'is-IS' : 'en-US',
	                      cancelLabel: language === 'IS' ? 'Hætta við' : 'Cancel',
	                      okLabel: language === 'IS' ? 'Í lagi' : 'OK'
	                    }),
	                    QuestionType === 'Bool' && _react2.default.createElement(
	                      _materialUi.RadioButtonGroup,
	                      {
	                        name: 'question-' + PMEmployeeAppraisalGroupQuestionID,
	                        valueSelected: value,
	                        onChange: function onChange(e, newValue) {
	                          return handleInputChange(PMEmployeeAppraisalGroupQuestionID, newValue);
	                        }
	                      },
	                      _react2.default.createElement(_materialUi.RadioButton, {
	                        value: 'true',
	                        label: language === 'IS' ? 'Já' : 'Yes',
	                        style: { marginBottom: 8 }
	                      }),
	                      _react2.default.createElement(_materialUi.RadioButton, {
	                        value: 'false',
	                        label: language === 'IS' ? 'Nei' : 'No',
	                        style: { marginBottom: 8 }
	                      })
	                    ),
	                    QuestionType === 'Single' && Options && _react2.default.createElement(
	                      _materialUi.RadioButtonGroup,
	                      {
	                        name: 'question-' + PMEmployeeAppraisalGroupQuestionID,
	                        valueSelected: value,
	                        onChange: function onChange(e, newValue) {
	                          return handleInputChange(PMEmployeeAppraisalGroupQuestionID, newValue);
	                        }
	                      },
	                      Options.map(function (option) {
	                        return _react2.default.createElement(_materialUi.RadioButton, {
	                          key: option.OptionID,
	                          value: option.OptionID,
	                          label: (0, _lodash.get)(option, ['Text', language]),
	                          style: { marginBottom: 8 }
	                        });
	                      })
	                    ),
	                    QuestionType === 'Multiple' && Options && _react2.default.createElement(
	                      'div',
	                      null,
	                      Options.map(function (option) {
	                        var selectedValues = Array.isArray(value) ? value : [];
	                        var isChecked = selectedValues.includes(option.OptionID);
	                        return _react2.default.createElement(_materialUi.Checkbox, {
	                          key: option.OptionID,
	                          label: (0, _lodash.get)(option, ['Text', language]),
	                          checked: isChecked,
	                          onCheck: function onCheck(e, checked) {
	                            var newValues = checked ? [].concat(_toConsumableArray(selectedValues), [option.OptionID]) : selectedValues.filter(function (id) {
	                              return id !== option.OptionID;
	                            });
	                            handleInputChange(PMEmployeeAppraisalGroupQuestionID, newValues);
	                          },
	                          style: { marginBottom: 8 }
	                        });
	                      })
	                    ),
	                    QuestionType === 'Scale' && Options && _react2.default.createElement(
	                      _materialUi.RadioButtonGroup,
	                      {
	                        name: 'question-' + PMEmployeeAppraisalGroupQuestionID,
	                        valueSelected: value,
	                        onChange: function onChange(e, newValue) {
	                          return handleInputChange(PMEmployeeAppraisalGroupQuestionID, newValue);
	                        }
	                      },
	                      Options.map(function (option) {
	                        return _react2.default.createElement(_materialUi.RadioButton, {
	                          key: option.OptionID,
	                          value: option.OptionID,
	                          label: (0, _lodash.get)(option, ['Text', language]) + ' ' + (option.ScaleValue ? '(' + option.ScaleValue + ')' : ''),
	                          style: { marginBottom: 8 }
	                        });
	                      })
	                    ),
	                    AllowComment && _react2.default.createElement(_materialUi.TextField, {
	                      fullWidth: true,
	                      multiLine: true
	                      // rows={2}
	                      , rowsMax: 4,
	                      hintText: 'Add comment...',
	                      floatingLabelText: 'Comment',
	                      value: comment,
	                      onChange: function onChange(e, newValue) {
	                        return handleInputChange(PMEmployeeAppraisalGroupQuestionID, newValue, true);
	                      },
	                      style: { marginTop: 16 }
	                    })
	                  )
	                )
	              )
	            );
	          })
	        );
	      }),
	      !isFinished && _react2.default.createElement(
	        'div',
	        { style: styles.actions },
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.save' }),
	          onClick: function onClick() {
	            return handleSubmit('Started');
	          },
	          disabled: isSaving,
	          style: styles.action
	        }),
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          primary: true,
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'send' }),
	          onClick: function onClick() {
	            return handleSubmit('Finished');
	          },
	          disabled: isSaving,
	          style: styles.action
	        })
	      )
	    ),
	    allFinished && FinalResult && _react2.default.createElement(
	      _materialUi.Paper,
	      { style: { marginTop: 16, padding: 16 } },
	      _react2.default.createElement(
	        'div',
	        { style: { fontSize: 16, fontWeight: 500, marginBottom: 8 } },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.finalResult' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { fontSize: 14, whiteSpace: 'pre-wrap' } },
	        FinalResult
	      )
	    )
	  );
	};
	
	PMAppraisal.propTypes = {
	  params: _propTypes2.default.object.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  valuesByKey: _propTypes2.default.object
	};
	
	PMAppraisal.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	var _default = (0, _reactRedux.connect)(function (state) {
	  return { valuesByKey: state.WebValuesReducer.valuesByKey };
	})(PMAppraisal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FINISHED, 'FINISHED', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisal.js');
	
	  __REACT_HOT_LOADER__.register(EMPLOYEE, 'EMPLOYEE', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisal.js');
	
	  __REACT_HOT_LOADER__.register(MANAGER, 'MANAGER', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisal.js');
	
	  __REACT_HOT_LOADER__.register(FINAL, 'FINAL', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisal.js');
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisal.js');
	
	  __REACT_HOT_LOADER__.register(PMAppraisal, 'PMAppraisal', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisal.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisal.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19), (function() { return this; }())))

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(12);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _StatusIcon = __webpack_require__(427);
	
	var _StatusIcon2 = _interopRequireDefault(_StatusIcon);
	
	var _getAppraisalTitle = __webpack_require__(148);
	
	var _getAppraisalTitle2 = _interopRequireDefault(_getAppraisalTitle);
	
	var _Appraisal = __webpack_require__(180);
	
	var _api = __webpack_require__(225);
	
	var _appraisalEnums = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var STARTED = _appraisalEnums.STATUS.STARTED,
	    FINISHED = _appraisalEnums.STATUS.FINISHED,
	    NONE = _appraisalEnums.STATUS.NONE;
	
	// Helper function to convert numeric status to string status (for old appraisals)
	
	var convertStatus = function convertStatus(numericStatus) {
	  if (numericStatus === FINISHED) return 'Finished';
	  if (numericStatus === STARTED) return 'Started';
	  return 'None';
	};
	
	// Helper function to normalize old appraisal data to match new structure
	var normalizeOldAppraisal = function normalizeOldAppraisal(appraisal) {
	  return _extends({}, appraisal, {
	    type: 'old',
	    // Map old field names to new ones for consistent display
	    PMEmployeeAppraisalID: appraisal.PMAppraisalID,
	    Title: { IS: appraisal.PMFormTitle },
	    DefaultLanguage: 'IS',
	    ManagerEmployeeName: appraisal.ManagerName,
	    FinalDueDate: appraisal.FinalAppraisalDate,
	    // Convert numeric status to string status
	    EmployeeStatus: convertStatus(appraisal.EmployeeStatus),
	    ManagerStatus: convertStatus(appraisal.ManagerStatus),
	    FinalStatus: convertStatus(appraisal.FinalStatus)
	  });
	};
	
	var styles = {
	  header: {
	    paddingLeft: 0,
	    paddingBottom: 8,
	    fontSize: 20
	  },
	  appraisal: {
	    padding: 16,
	    marginBottom: 16,
	    cursor: 'pointer',
	    transition: 'box-shadow 0.3s'
	  },
	  title: {
	    fontSize: 18,
	    fontWeight: 500,
	    display: 'flex',
	    alignItems: 'center',
	    gap: 8,
	    marginBottom: 8
	  },
	  date: {
	    fontSize: 14,
	    color: 'rgba(0, 0, 0, 0.54)',
	    marginBottom: 16
	  },
	  info: {
	    display: 'flex',
	    flexDirection: 'column',
	    gap: 4
	  },
	  label: {
	    fontSize: 12,
	    color: 'rgba(0, 0, 0, 0.54)'
	  },
	  value: {
	    fontSize: 16,
	    fontWeight: 500,
	    display: 'flex',
	    alignItems: 'center',
	    gap: 8
	  },
	  statusMessage: {
	    fontSize: 14,
	    fontWeight: 500,
	    textAlign: 'right'
	  }
	};
	
	var PMAppraisals = function PMAppraisals(_ref, context) {
	  var valuesByKey = _ref.valuesByKey;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      appraisals = _useState2[0],
	      setAppraisals = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      loading = _useState4[0],
	      setLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      error = _useState6[0],
	      setError = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(0),
	      _useState8 = _slicedToArray(_useState7, 2),
	      year = _useState8[0],
	      setYear = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(null),
	      _useState10 = _slicedToArray(_useState9, 2),
	      newAppraisals = _useState10[0],
	      setNewAppraisals = _useState10[1]; // null = not yet fetched
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      _useSelector$Appraisa = _useSelector.Appraisal,
	      allOldAppraisals = _useSelector$Appraisa.appraisals,
	      appraisalLoading = _useSelector$Appraisa.loading;
	
	  // Fetch old appraisals into redux store on mount
	
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _Appraisal.fetchAppraisal)());
	  }, []);
	
	  // Fetch new appraisals once on mount
	  (0, _react.useEffect)(function () {
	    (0, _api.getPMEmployeeAppraisals)().then(function (_ref2) {
	      var _ref2$data = _ref2.data,
	          data = _ref2$data === undefined ? [] : _ref2$data;
	
	      var filtered = data.filter(function (a) {
	        return a.EmployeeDetailID === Number(localStorage.DefaultEmployeeDetailID);
	      }).map(function (a) {
	        return _extends({}, a, { type: 'new' });
	      });
	      setNewAppraisals(filtered);
	    }).catch(function () {
	      return setNewAppraisals([]);
	    });
	  }, []);
	
	  // Combine once both fetches are done
	  (0, _react.useEffect)(function () {
	    if (newAppraisals === null || appraisalLoading) return;
	
	    try {
	      var normalizedOldAppraisals = allOldAppraisals.map(normalizeOldAppraisal);
	      var combined = [].concat(_toConsumableArray(newAppraisals), _toConsumableArray(normalizedOldAppraisals)).sort(function (a, b) {
	        return new Date(b.EmployeeDueDate) - new Date(a.EmployeeDueDate);
	      });
	
	      setAppraisals(combined);
	
	      if (combined.length > 0) {
	        var mostRecentYear = new Date(combined[0].EmployeeDueDate).getFullYear();
	        setYear(mostRecentYear);
	      }
	
	      setError(null);
	    } catch (err) {
	      setError(err);
	    } finally {
	      setLoading(false);
	    }
	  }, [newAppraisals, appraisalLoading, allOldAppraisals]);
	
	  var handleClick = function handleClick(appraisal) {
	    if (appraisal.type === 'old') {
	      context.router.push('/appraisals/' + appraisal.PMAppraisalID);
	    } else {
	      context.router.push('/pmappraisals/' + appraisal.PMEmployeeAppraisalID);
	    }
	  };
	
	  if (loading) {
	    return _react2.default.createElement(_Loading2.default, null);
	  }
	
	  if (error) {
	    return _react2.default.createElement(
	      _reactFlexboxGrid.Col,
	      { xs: 12, sm: 10, smOffset: 1, md: 8, mdOffset: 2 },
	      _react2.default.createElement(_PanelMessage2.default, {
	        type: 'error',
	        iconName: 'error',
	        message: error.message || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.error' })
	      })
	    );
	  }
	
	  // Extract unique years
	  var years = [].concat(_toConsumableArray(new Set(appraisals.map(function (a) {
	    return new Date(a.EmployeeDueDate).getFullYear();
	  })))).sort(function (a, b) {
	    return a - b;
	  });
	
	  // Filter by year
	  var filteredAppraisals = year ? appraisals.filter(function (a) {
	    return new Date(a.EmployeeDueDate).getFullYear() === year;
	  }) : appraisals;
	
	  var getStatusMessage = function getStatusMessage(appraisal) {
	    var empDue = new Date(appraisal.EmployeeDueDate);
	    empDue.setHours(23, 59, 59);
	    var now = Date.now();
	
	    if (appraisal.EmployeeStatus === FINISHED || appraisal.EmployeeStatus === 'Finished') {
	      return _react2.default.createElement(
	        'span',
	        { style: { color: _colors2.default.successColor } },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.answer' })
	      );
	    }
	
	    if (empDue.getTime() < now) {
	      return _react2.default.createElement(
	        'span',
	        { style: { color: _colors2.default.errorColor } },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.expired' })
	      );
	    }
	
	    if (appraisal.EmployeeStatus === STARTED || appraisal.EmployeeStatus === 'Started') {
	      return _react2.default.createElement(
	        'span',
	        { style: { color: _colors2.default.primary1Color } },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.inProgress' })
	      );
	    }
	
	    return _react2.default.createElement(
	      'span',
	      { style: { color: _colors2.default.warningColor } },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.notStarted' })
	    );
	  };
	
	  var getStatusIcon = function getStatusIcon(status) {
	    if (status === FINISHED || status === 'Finished') return FINISHED;
	    if (status === STARTED || status === 'Started') return STARTED;
	    return NONE;
	  };
	
	  // Use custom appraisal title from WebValues if exists
	  var appraisalTitle = (0, _getAppraisalTitle2.default)(valuesByKey);
	
	  return _react2.default.createElement(
	    _reactFlexboxGrid.Col,
	    { xs: 12, sm: 12, md: 10, mdOffset: 1, style: { paddingBottom: 16 } },
	    _react2.default.createElement(
	      _materialUi.Subheader,
	      { style: styles.header },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: appraisalTitle })
	    ),
	    _react2.default.createElement(
	      _reactFlexboxGrid.Row,
	      { middle: 'xs' },
	      _react2.default.createElement(
	        _reactFlexboxGrid.Col,
	        { xs: true, style: { textAlign: 'left' } },
	        _react2.default.createElement(
	          _materialUi.SelectField,
	          {
	            floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.select.year' }),
	            value: year,
	            onChange: function onChange(e, index, value) {
	              return setYear(value);
	            }
	          },
	          _react2.default.createElement(_materialUi.MenuItem, { value: 0, primaryText: ' ' }),
	          years.map(function (y) {
	            return _react2.default.createElement(_materialUi.MenuItem, { key: y, value: y, primaryText: y });
	          })
	        ),
	        filteredAppraisals.length === 0 ? _react2.default.createElement(_PanelMessage2.default, {
	          type: 'info',
	          iconName: 'info',
	          message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.noAppraisal', values: { year: year } })
	        }) : filteredAppraisals.map(function (appraisal) {
	          var empDue = new Date(appraisal.EmployeeDueDate);
	          empDue.setHours(23, 59, 59);
	
	          return _react2.default.createElement(
	            _materialUi.Paper,
	            {
	              key: appraisal.PMEmployeeAppraisalID,
	              style: styles.appraisal,
	              onClick: function onClick() {
	                return handleClick(appraisal);
	              },
	              zDepth: 1
	            },
	            _react2.default.createElement(
	              'div',
	              { style: styles.title },
	              _react2.default.createElement(_StatusIcon2.default, { type: getStatusIcon(appraisal.EmployeeStatus) }),
	              (0, _lodash.get)(appraisal.Title, appraisal.DefaultLanguage) || (0, _lodash.get)(appraisal.Title, 'IS') || 'Appraisal'
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: styles.date },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'expires' }),
	              ' ',
	              (0, _dateTools2.default)(empDue)
	            ),
	            _react2.default.createElement(
	              _reactFlexboxGrid.Row,
	              null,
	              _react2.default.createElement(
	                _reactFlexboxGrid.Col,
	                { xs: 12, sm: 5, md: 4 },
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.info },
	                  _react2.default.createElement(
	                    'span',
	                    { style: styles.label },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.employee' })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { style: styles.value },
	                    _react2.default.createElement(_StatusIcon2.default, { type: getStatusIcon(appraisal.EmployeeStatus) }),
	                    appraisal.EmployeeName
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactFlexboxGrid.Col,
	                { xs: 12, sm: 5, md: 4 },
	                _react2.default.createElement(
	                  'div',
	                  { style: styles.info },
	                  _react2.default.createElement(
	                    'span',
	                    { style: styles.label },
	                    _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'appraisal.manager' })
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { style: styles.value },
	                    _react2.default.createElement(_StatusIcon2.default, { type: getStatusIcon(appraisal.ManagerStatus) }),
	                    appraisal.ManagerEmployeeName
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _reactFlexboxGrid.Col,
	                { xs: 12, sm: 2, md: 4 },
	                _react2.default.createElement(
	                  'div',
	                  { style: _extends({}, styles.info, { alignItems: 'flex-end' }) },
	                  _react2.default.createElement(
	                    'span',
	                    { style: styles.statusMessage },
	                    getStatusMessage(appraisal)
	                  )
	                )
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	PMAppraisals.propTypes = {
	  valuesByKey: _propTypes2.default.object
	};
	
	PMAppraisals.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	var _default = (0, _reactRedux.connect)(function (state) {
	  return { valuesByKey: state.WebValuesReducer.valuesByKey };
	})(PMAppraisals);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(STARTED, 'STARTED', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(FINISHED, 'FINISHED', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(NONE, 'NONE', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(convertStatus, 'convertStatus', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(normalizeOldAppraisal, 'normalizeOldAppraisal', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(PMAppraisals, 'PMAppraisals', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/pmappraisals/PMAppraisals.js');
	}();

	;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _Agreements = __webpack_require__(420);
	
	var _TBenefits = __webpack_require__(74);
	
	var _TBenefits2 = _interopRequireDefault(_TBenefits);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TAgreements = function TAgreements() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.AgreementsReducer;
	  }),
	      agreementsByID = _useSelector.agreementsByID,
	      agreementsLoading = _useSelector.agreementsLoading,
	      hasError = _useSelector.hasError,
	      agreementsError = _useSelector.agreementsError;
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _Agreements.fetchAgreements)());
	  }, []);
	
	  if (agreementsLoading) {
	    return _react2.default.createElement(_TLoading2.default, null);
	  }
	
	  if (hasError) {
	    return _react2.default.createElement(_TMessage2.default, { type: 'error', message: 'tile.error', values: { error: (0, _lodash.get)(agreementsError, 'message') } });
	  }
	
	  var res = [];
	  (0, _lodash.forIn)(agreementsByID, function (_ref) {
	    var label = _ref.label,
	        agreements = _ref.agreements;
	
	    res = (0, _lodash.map)(agreements, function (a) {
	      return _react2.default.createElement(
	        'div',
	        { key: '' + label + a.HrAgreementID },
	        _react2.default.createElement(_materialUi.ListItem, {
	          className: 'agreement-item',
	          innerDivStyle: _TBenefits2.default.link,
	          primaryText: a.HrAgreementText,
	          hoverColor: 'transparent',
	          onClick: function onClick() {
	            return dispatch((0, _reactRouterRedux.push)('/agreements'));
	          }
	        }),
	        _react2.default.createElement(_materialUi.Divider, { key: 'div', style: _TBenefits2.default.spacer })
	      );
	    });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    { style: _TBenefits2.default.container },
	    res,
	    _react2.default.createElement(_KFlatButton2.default, {
	      style: _TBenefits2.default.actionButton,
	      onClick: function onClick() {
	        return dispatch((0, _reactRouterRedux.push)('/agreements'));
	      },
	      containerStyle: _TBenefits2.default.action,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.goto' })
	    })
	  );
	};
	
	var _default = TAgreements;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TAgreements, 'TAgreements', 'D:/a/1/s/src/web/employee/src/containers/tiles/TAgreements.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TAgreements.js');
	}();

	;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Benefits = __webpack_require__(181);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _filter = __webpack_require__(262);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _TBenefits = __webpack_require__(74);
	
	var _TBenefits2 = _interopRequireDefault(_TBenefits);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TBenefits = function TBenefits() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.BenefitsReducer;
	  }),
	      benefits = _useSelector.benefits,
	      loaded = _useSelector.loaded;
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _Benefits.fetchBenefits)());
	  }, []);
	
	  if (!loaded) {
	    return _react2.default.createElement(_TLoading2.default, null);
	  }
	
	  var hb = (0, _filter2.default)(benefits, function (benefit) {
	    return benefit.HrBenefitType === 0;
	  });
	  if (!hb || !hb.length) {
	    return _react2.default.createElement(_TMessage2.default, { message: 'tile.benefits.empty' });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: _TBenefits2.default.container },
	    _react2.default.createElement(
	      'div',
	      { style: { maxHeight: 422, overflow: 'auto', height: '100%' } },
	      (0, _map2.default)(hb, function (benefit, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(_materialUi.ListItem, {
	            innerDivStyle: _TBenefits2.default.link,
	            primaryText: benefit.HrBenefitName,
	            hoverColor: 'transparent',
	            onClick: function onClick() {
	              return dispatch((0, _reactRouterRedux.push)('/benefits'));
	            }
	          }),
	          _react2.default.createElement(_materialUi.Divider, { key: 'div', style: _TBenefits2.default.spacer })
	        );
	      })
	    ),
	    _react2.default.createElement(_KFlatButton2.default, {
	      style: _TBenefits2.default.actionButton,
	      onClick: function onClick() {
	        return dispatch((0, _reactRouterRedux.push)('/benefits'));
	      },
	      containerStyle: _TBenefits2.default.action,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.goto' }),
	      'data-cy': 'benefits-button'
	    })
	  );
	};
	
	var _default = TBenefits;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TBenefits, 'TBenefits', 'D:/a/1/s/src/web/employee/src/containers/tiles/TBenefits.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TBenefits.js');
	}();

	;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _Birthdays = __webpack_require__(843);
	
	var _KAvatar = __webpack_require__(183);
	
	var _KAvatar2 = _interopRequireDefault(_KAvatar);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  container: {
	    width: 'calc(100% - 52px)',
	    height: 'calc(100% - 36px)',
	    paddingLeft: 26,
	    paddingRight: 26,
	    paddingTop: 26,
	    paddingBottom: 10,
	    display: 'flex',
	    flexWrap: 'wrap',
	    justifyContent: 'center'
	  },
	  birthday: {
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    flex: 1,
	    minWidth: 130,
	    padding: 12,
	    textAlign: 'center'
	  },
	  name: {
	    marginTop: 8,
	    height: 36,
	    overflow: 'hidden',
	    textOverflow: 'ellipsis'
	  },
	  age: {
	    marginTop: 4,
	    fontWeight: 600
	  }
	};
	
	var TBirthdays = function TBirthdays() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.BirthdaysReducer;
	  }),
	      birthdays = _useSelector.birthdays,
	      loaded = _useSelector.loaded,
	      hasError = _useSelector.hasError;
	
	  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
	    return state.WebValuesReducer;
	  }),
	      valuesByKey = _useSelector2.valuesByKey;
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _Birthdays.fetchBirthdays)());
	  }, []);
	
	  if (hasError) {
	    return _react2.default.createElement(_TMessage2.default, { type: 'error', message: 'tile.birthdays.error' });
	  }
	
	  if (!loaded) {
	    return _react2.default.createElement(_TLoading2.default, null);
	  }
	
	  if (!birthdays || !birthdays.length) {
	    return _react2.default.createElement(_TMessage2.default, { message: 'tile.birthdays.empty' });
	  }
	  return _react2.default.createElement(
	    'div',
	    { style: styles.container },
	    (0, _map2.default)(birthdays, function (birthday, i) {
	      return _react2.default.createElement(
	        'div',
	        { key: '' + i, style: styles.birthday },
	        _react2.default.createElement(_KAvatar2.default, { imgSrc: birthday.ImageUrl, masterId: birthday.EmployeeMasterID }),
	        _react2.default.createElement(
	          'div',
	          { style: styles.name },
	          birthday.Name
	        ),
	        (!valuesByKey['Hide.Birthdays.Age'] || valuesByKey['Hide.Birthdays.Age'].Value !== 'true') && _react2.default.createElement(
	          'div',
	          { style: styles.age },
	          birthday.Age
	        )
	      );
	    })
	  );
	};
	
	var _default = TBirthdays;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/tiles/TBirthdays.js');
	
	  __REACT_HOT_LOADER__.register(TBirthdays, 'TBirthdays', 'D:/a/1/s/src/web/employee/src/containers/tiles/TBirthdays.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TBirthdays.js');
	}();

	;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _lodash = __webpack_require__(8);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _index = __webpack_require__(388);
	
	var _sortInternational = __webpack_require__(810);
	
	var _sortInternational2 = _interopRequireDefault(_sortInternational);
	
	var _TBenefits = __webpack_require__(74);
	
	var _TBenefits2 = _interopRequireDefault(_TBenefits);
	
	var _normalize = __webpack_require__(103);
	
	var _Puzzle = __webpack_require__(959);
	
	var _Puzzle2 = _interopRequireDefault(_Puzzle);
	
	var _ApprovalRequests = __webpack_require__(842);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var countries = __webpack_require__(1038);
	countries.registerLocale(__webpack_require__(1374));
	countries.registerLocale(__webpack_require__(1375));
	
	var TEmployeeMasterCourseRequest = function TEmployeeMasterCourseRequest(_ref) {
	  var loading = _ref.loading,
	      submitRequest = _ref.submitRequest;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      showDialog = _useState2[0],
	      setShowDialog = _useState2[1];
	
	  var openDialog = function openDialog() {
	    return setShowDialog(true);
	  };
	  var closeDialog = function closeDialog() {
	    return setShowDialog(false);
	  };
	
	  var _useForm = (0, _index.useForm)(),
	      handleSubmit = _useForm.handleSubmit,
	      errors = _useForm.errors,
	      control = _useForm.control,
	      setValue = _useForm.setValue;
	
	  var actions = [_react2.default.createElement(_materialUi.FlatButton, {
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'alert.cancel' }),
	    disabled: loading,
	    secondary: true,
	    onClick: closeDialog
	  }), _react2.default.createElement(_materialUi.RaisedButton, {
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'submit' }),
	    icon: _react2.default.createElement(
	      _materialUi.FontIcon,
	      { className: 'material-icons' },
	      'send'
	    ),
	    disabled: loading || !(0, _lodash.isEmpty)(errors),
	    primary: true,
	    onClick: handleSubmit(function (data) {
	      return submitRequest(data, closeDialog);
	    })
	  })];
	
	  var sortCountries = function sortCountries(a, b) {
	    var internationalCompare = (0, _sortInternational2.default)('text');
	    return internationalCompare(a, b);
	  };
	  var handleNumberInput = function handleNumberInput(name) {
	    return function (e) {
	      var value = e.target.value;
	
	      if (value) {
	        var cost = (0, _normalize.normalizeNumber)(value);
	        setValue(name, cost, { shouldValidate: true, shouldDirty: true });
	      } else {
	        setValue(name, '', { shouldValidate: true, shouldDirty: true });
	      }
	    };
	  };
	  return _react2.default.createElement(
	    'div',
	    { style: _TBenefits2.default.container },
	    _react2.default.createElement(
	      _materialUi.Dialog,
	      {
	        open: showDialog,
	        actions: actions,
	        contentStyle: {
	          overflow: 'hidden',
	          maxWidth: 500,
	          width: '100%'
	        },
	        bodyStyle: {
	          overflowY: 'auto'
	        },
	        modal: true
	      },
	      loading ? _react2.default.createElement(
	        'div',
	        {
	          style: {
	            backgroundColor: 'rgba(0, 0, 0, 0.34)',
	            position: 'absolute',
	            zIndex: 10,
	            top: 0,
	            left: 0,
	            width: '100%',
	            height: '100%',
	            display: 'flex',
	            alignItems: 'center',
	            justifyContent: 'center'
	          }
	        },
	        _react2.default.createElement(
	          _materialUi.Paper,
	          {
	            style: {
	              padding: 32,
	              display: 'flex',
	              flexDirection: 'column',
	              alignItems: 'center'
	            }
	          },
	          _react2.default.createElement(_materialUi.CircularProgress, { style: { marginBottom: 24 }, size: 100 }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'sending.message' })
	        )
	      ) : null,
	      _react2.default.createElement(_KTitle2.default, {
	        style: {
	          marginLeft: 0,
	          display: 'flex',
	          alignItems: 'center',
	          flexDirection: 'row'
	        },
	        title: _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(
	            _materialUi.FontIcon,
	            {
	              style: {
	                marginRight: 6, fontSize: 28, color: 'inherit'
	              },
	              className: 'material-icons'
	            },
	            'school'
	          ),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dash.title.courseApprovalRequest' })
	        ),
	        subtitleStyle: { margin: 0, fontSize: 12, lineHeight: '1' },
	        subtitle: _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courseApprovalRequest.description' })
	        )
	      }),
	      _react2.default.createElement(
	        'form',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', flexDirection: 'column' } },
	          _react2.default.createElement(_index.Controller, {
	            as: _react2.default.createElement(_materialUi.TextField, {
	              fullWidth: true,
	              floatingLabelFixed: true,
	              floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.form.title' }),
	              errorText: errors.RequestTitle ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : ''
	            }),
	            name: 'RequestTitle',
	            control: control,
	            defaultValue: '',
	            rules: { required: true }
	          }),
	          _react2.default.createElement(_index.Controller, {
	            as: _react2.default.createElement(_materialUi.TextField, {
	              fullWidth: true,
	              floatingLabelFixed: true,
	              floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.form.description' }),
	              errorText: errors.RequestDescription ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : '',
	              multiLine: true,
	              rows: 3
	            }),
	            name: 'RequestDescription',
	            control: control,
	            defaultValue: '',
	            rules: { required: true }
	          }),
	          _react2.default.createElement(_index.Controller, {
	            as: _react2.default.createElement(_materialUi.TextField, {
	              fullWidth: true,
	              floatingLabelFixed: true,
	              floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.form.organizer' })
	            }),
	            name: 'Info',
	            control: control,
	            defaultValue: ''
	          }),
	          _react2.default.createElement(_index.Controller, {
	            as: _react2.default.createElement(_materialUi.TextField, {
	              fullWidth: true,
	              type: 'date',
	              floatingLabelFixed: true,
	              floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.form.from' }),
	              errorText: errors.PeriodBegda ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : ''
	            }),
	            name: 'PeriodBegda',
	            control: control,
	            defaultValue: '',
	            rules: { required: true }
	          }),
	          _react2.default.createElement(_index.Controller, {
	            as: _react2.default.createElement(_materialUi.TextField, {
	              fullWidth: true,
	              type: 'date',
	              floatingLabelFixed: true,
	              floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.form.to' }),
	              errorText: errors.PeriodEndda ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : ''
	            }),
	            name: 'PeriodEndda',
	            control: control,
	            defaultValue: '',
	            rules: { required: true }
	          }),
	          _react2.default.createElement(_index.Controller, {
	            render: function render(_ref2) {
	              var onChange = _ref2.onChange,
	                  onBlur = _ref2.onBlur,
	                  value = _ref2.value,
	                  name = _ref2.name,
	                  ref = _ref2.ref;
	              return _react2.default.createElement(_materialUi.TextField, {
	                fullWidth: true,
	                type: 'number',
	                floatingLabelFixed: true,
	                floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.form.totalHours' }),
	                min: 0,
	                step: 0.1,
	                onChange: onChange,
	                onBlur: onBlur,
	                value: value,
	                name: name,
	                inputRef: ref
	              });
	            },
	            name: 'Duration',
	            control: control
	          }),
	          _react2.default.createElement(_index.Controller, {
	            render: function render(_ref3) {
	              var _onChange = _ref3.onChange,
	                  onBlur = _ref3.onBlur,
	                  value = _ref3.value,
	                  name = _ref3.name,
	                  ref = _ref3.ref;
	              return _react2.default.createElement(
	                _materialUi.SelectField,
	                {
	                  name: name,
	                  onBlur: onBlur,
	                  inputRef: ref,
	                  onChange: function onChange(_, __, val) {
	                    return _onChange(val);
	                  },
	                  fullWidth: true,
	                  floatingLabelFixed: true,
	                  value: value,
	                  floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.form.location' })
	                },
	                _react2.default.createElement(_materialUi.MenuItem, { primaryText: '\xCDsland', value: 'IS', key: 'IS.1' }),
	                _react2.default.createElement(_materialUi.Divider, null),
	                (0, _lodash.map)((0, _lodash.map)(countries.getNames('is'), function (country, code) {
	                  return { text: country, val: code };
	                }).sort(sortCountries), function (_ref4) {
	                  var text = _ref4.text,
	                      val = _ref4.val;
	                  return _react2.default.createElement(_materialUi.MenuItem, { key: val, primaryText: text, value: val });
	                })
	              );
	            },
	            name: 'Location',
	            control: control,
	            defaultValue: ''
	          }),
	          _react2.default.createElement(_index.Controller, {
	            render: function render(_ref5) {
	              var onBlur = _ref5.onBlur,
	                  value = _ref5.value,
	                  name = _ref5.name,
	                  ref = _ref5.ref;
	              return _react2.default.createElement(_materialUi.TextField, {
	                fullWidth: true,
	                type: 'number',
	                floatingLabelFixed: true,
	                floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.form.cost' }),
	                min: 0,
	                onChange: handleNumberInput(name),
	                onBlur: onBlur,
	                value: value,
	                name: name,
	                inputRef: ref
	              });
	            },
	            name: 'Cost',
	            control: control
	          })
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          height: '100%',
	          display: 'flex',
	          flexDirection: 'column',
	          alignItems: 'center',
	          justifyContent: 'center'
	        }
	      },
	      _react2.default.createElement(_Puzzle2.default, null),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            padding: 8,
	            marginBottom: 12,
	            marginTop: 12,
	            display: 'flex',
	            flexDirection: 'row'
	          }
	        },
	        _react2.default.createElement(
	          _materialUi.FontIcon,
	          { style: { marginRight: 8 }, color: _colors2.default.infoColor, className: 'material-icons' },
	          'info'
	        ),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courseApprovalRequest.description' })
	      ),
	      _react2.default.createElement(_materialUi.RaisedButton, {
	        primary: true,
	        style: { marginBottom: 12 },
	        onClick: openDialog,
	        'data-cy': 'employee-master-course-approval-request-button',
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'courseApprovalRequest.button' })
	      })
	    )
	  );
	};
	
	TEmployeeMasterCourseRequest.propTypes = {
	  loading: _propTypes2.default.bool.isRequired,
	  submitRequest: _propTypes2.default.func.isRequired
	};
	
	TEmployeeMasterCourseRequest.defaultProps = {};
	
	var _default = (0, _reactRedux.connect)(function (_ref6) {
	  var approvalRequestReducer = _ref6.approvalRequestReducer;
	  return approvalRequestReducer;
	}, function (dispatch) {
	  return {
	    submitRequest: function submitRequest(data, cb) {
	      return dispatch((0, _ApprovalRequests.createApprovalRequest)(_extends({}, data, {
	        EmployeeDetailApprovalRequestType: 'EmployeeMasterCoursesHandler'
	      }), cb));
	    }
	  };
	})(TEmployeeMasterCourseRequest);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TEmployeeMasterCourseRequest, 'TEmployeeMasterCourseRequest', 'D:/a/1/s/src/web/employee/src/containers/tiles/TEmployeeMasterCourseRequest.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TEmployeeMasterCourseRequest.js');
	}();

	;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import KFlatButton from 'components/KJRN/KFlatButton';
	
	var styles = {
	  container: {
	    width: 'calc(100% - 72px)',
	    height: 'calc(100% - 20px)',
	    paddingLeft: 36,
	    paddingRight: 36,
	    paddingTop: 10,
	    paddingBottom: 10
	  },
	  evaluation: {},
	  evaluationInner: {
	    paddingLeft: 0,
	    paddingRight: 0,
	    paddingTop: 26,
	    paddingBottom: 26
	  },
	  tag: {
	    marginTop: 12,
	    borderRadius: 4,
	    padding: 6,
	    color: 'white',
	    display: 'table'
	  },
	  actionButton: {
	    fontWeight: 600,
	    color: _colors2.default.primary1Color,
	    maxWidth: 150,
	    textTransform: 'uppercase',
	    backgroundColor: 'transparent'
	  }
	};
	/* eslint-disable-next-line react/prefer-stateless-function */
	
	var TEvaluations = function (_React$Component) {
	  _inherits(TEvaluations, _React$Component);
	
	  function TEvaluations() {
	    _classCallCheck(this, TEvaluations);
	
	    return _possibleConstructorReturn(this, (TEvaluations.__proto__ || Object.getPrototypeOf(TEvaluations)).apply(this, arguments));
	  }
	
	  _createClass(TEvaluations, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          evaluations = _props.evaluations,
	          evaluationsLoaded = _props.evaluationsLoaded,
	          hasError = _props.hasError;
	
	
	      if (hasError) {
	        return _react2.default.createElement(_TMessage2.default, { type: 'error', message: 'tile.evaluation.error' });
	      }
	
	      if (!evaluationsLoaded) {
	        return _react2.default.createElement(_TLoading2.default, null);
	      }
	
	      if (!evaluations || !evaluations.length) {
	        return _react2.default.createElement(_TMessage2.default, { message: 'tile.evaluation.empty' });
	      }
	
	      // const text = { 0: 'tile.evaluation.start', 1: 'tile.evaluation.handin' };
	      // const statusStyle = { 0: { backgroundColor: pallet.errorColor }, 1: { backgroundColor: pallet.warningColor } };
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.container, 'data-cy': 'evaluations' },
	        evaluations.map(function (x, i) {
	          return _react2.default.createElement(
	            'div',
	            { key: i },
	            _react2.default.createElement(_materialUi.ListItem, {
	              disabled: true,
	              hoverColor: 'transparent',
	              style: styles.evaluation,
	              innerDivStyle: styles.evaluationInner
	              // onClick={() => this.context.router.push(`/evaluation/${x.CourseAttendeeID}`)}
	              , primaryText: _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  x.CourseName
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_materialUi.FlatButton, {
	                    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'answer' }),
	                    primary: true,
	                    style: styles.actionButton,
	                    onClick: function onClick() {
	                      return _this2.context.router.push('/evaluation/' + x.CourseAttendeeID);
	                    }
	                  })
	                )
	              )
	              // secondaryText={
	              //   <div style={{ ...statusStyle[x.EvaluationStatus], ...styles.tag }}>
	              //     <FormattedMessage id={text[x.EvaluationStatus]} />
	              //   </div>
	              // }
	            }),
	            _react2.default.createElement(_materialUi.Divider, null)
	          );
	        })
	      );
	    }
	  }]);
	
	  return TEvaluations;
	}(_react2.default.Component);
	
	TEvaluations.propTypes = {
	  evaluations: _propTypes2.default.array.isRequired,
	  hasError: _propTypes2.default.bool.isRequired,
	  // evaluationsError: PropTypes.object,
	  evaluationsLoaded: _propTypes2.default.bool.isRequired
	};
	
	TEvaluations.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref) {
	  var CourseEvaluationReducer = _ref.CourseEvaluationReducer;
	  return _extends({}, CourseEvaluationReducer);
	})(TEvaluations);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/tiles/TEvaluations.js');
	
	  __REACT_HOT_LOADER__.register(TEvaluations, 'TEvaluations', 'D:/a/1/s/src/web/employee/src/containers/tiles/TEvaluations.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TEvaluations.js');
	}();

	;

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _dateTools = __webpack_require__(35);
	
	var _valuesByKey = __webpack_require__(92);
	
	var _helpers = __webpack_require__(457);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	var _TEvents = __webpack_require__(954);
	
	var _TEvents2 = _interopRequireDefault(_TEvents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TEvents = function TEvents() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      coursesReducer = _useSelector.coursesReducer,
	      WebValuesReducer = _useSelector.WebValuesReducer,
	      loginReducer = _useSelector.loginReducer;
	
	  var allCourses = coursesReducer.allCourses,
	      coursesLoaded = coursesReducer.coursesLoaded,
	      error = coursesReducer.error;
	  var valuesByKey = WebValuesReducer.valuesByKey;
	  var _loginReducer$user = loginReducer.user,
	      Gender = _loginReducer$user.Gender,
	      EmployeeMasterID = _loginReducer$user.EmployeeMasterID;
	
	
	  var useEvents = (0, _valuesByKey.shouldUse)(valuesByKey, 'Events');
	
	  if (!coursesLoaded) {
	    return _react2.default.createElement(_TLoading2.default, null);
	  }
	
	  if (error) {
	    return _react2.default.createElement(_TMessage2.default, { type: 'error', message: useEvents ? 'tile.events.error' : 'tile.courses.error' });
	  }
	
	  if ((0, _lodash.isEmpty)(allCourses)) {
	    return _react2.default.createElement(_TMessage2.default, { message: useEvents ? 'tile.events.empty' : 'tile.courses.empty' });
	  }
	
	  var renderCourseRow = function renderCourseRow(course) {
	    return _react2.default.createElement(
	      'div',
	      { key: course.CourseID },
	      _react2.default.createElement(_materialUi.ListItem, {
	        innerDivStyle: _TEvents2.default.course,
	        hoverColor: 'transparent',
	        primaryText: course.CourseName,
	        secondaryText: _react2.default.createElement(
	          'div',
	          { style: _TEvents2.default.secondary },
	          (0, _dateTools.dateTime)(course.CourseBegda),
	          course.Attending && _react2.default.createElement(
	            'div',
	            { style: _TEvents2.default.tag },
	            (0, _helpers.getAttendeeMsg)(course.CourseAttendees, EmployeeMasterID, Gender)
	          )
	        ),
	        onClick: function onClick() {
	          return dispatch((0, _reactRouterRedux.push)({
	            pathname: '/events/' + course.CourseID,
	            query: { dashboard: true }
	          }));
	        }
	      }),
	      _react2.default.createElement(_materialUi.Divider, null)
	    );
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: _TEvents2.default.container },
	    _react2.default.createElement(
	      'div',
	      { style: { maxHeight: 422, overflow: 'auto', height: '100%' } },
	      (0, _lodash.map)(allCourses, renderCourseRow)
	    ),
	    _react2.default.createElement(_KFlatButton2.default, {
	      style: _TEvents2.default.actionButton,
	      onClick: function onClick() {
	        return dispatch((0, _reactRouterRedux.push)('/events'));
	      },
	      containerStyle: _TEvents2.default.action,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: useEvents ? 'tile.events.goto' : 'tile.courses.goto' })
	    })
	  );
	};
	
	var _default = TEvents;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TEvents, 'TEvents', 'D:/a/1/s/src/web/employee/src/containers/tiles/TEvents.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TEvents.js');
	}();

	;

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _lodash = __webpack_require__(8);
	
	var _materialUi = __webpack_require__(17);
	
	var _iconSelect = __webpack_require__(295);
	
	var _dateTools = __webpack_require__(35);
	
	var _Files = __webpack_require__(117);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _TBenefits = __webpack_require__(74);
	
	var _TBenefits2 = _interopRequireDefault(_TBenefits);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TFiles = function TFiles() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.FileReducer;
	  }),
	      loaded = _useSelector.loaded,
	      files = _useSelector.files,
	      documentTypesById = _useSelector.documentTypesById;
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _Files.fetchUserFiles)());
	  }, [dispatch]);
	
	  if (!loaded) return _react2.default.createElement(_TLoading2.default, null);
	
	  if ((0, _lodash.isEmpty)(files)) {
	    return _react2.default.createElement(
	      _TMessage2.default,
	      { message: 'tile.files.empty' },
	      _react2.default.createElement(_KFlatButton2.default, {
	        style: _TBenefits2.default.actionButton,
	        onClick: function onClick() {
	          return dispatch((0, _reactRouterRedux.push)('/files'));
	        },
	        containerStyle: _TBenefits2.default.action,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.files.goto' })
	      })
	    );
	  }
	
	  var gotoFiles = function gotoFiles() {
	    window.scrollTo({ top: 0 });
	    dispatch((0, _reactRouterRedux.push)('/files'));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: _TBenefits2.default.container },
	    _react2.default.createElement(
	      'div',
	      { style: { maxHeight: 422, overflow: 'auto', height: '100%' } },
	      _react2.default.createElement(
	        _materialUi.Paper,
	        null,
	        (0, _lodash.map)((0, _lodash.take)(files, 5), function (x) {
	          return _react2.default.createElement(
	            'div',
	            { key: x.DocumentId },
	            _react2.default.createElement(_materialUi.ListItem, {
	              style: { wordBreak: 'break-all' },
	              leftIcon: _react2.default.createElement(
	                _materialUi.FontIcon,
	                { className: 'material-icons' },
	                (0, _iconSelect.iconSelect)(x.Extension)
	              ),
	              primaryText: '' + x.Name + x.Extension,
	              secondaryText: (documentTypesById[x.ObjectDocumentType] && documentTypesById[x.ObjectDocumentType].Name) + ' ' + (0, _dateTools.dateTime)(x.AddDate),
	              disabled: true
	            }),
	            _react2.default.createElement(_materialUi.Divider, null)
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(_KFlatButton2.default, {
	      style: _TBenefits2.default.actionButton,
	      onClick: gotoFiles,
	      containerStyle: _TBenefits2.default.action,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.files.goto' })
	    })
	  );
	};
	
	var _default = TFiles;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TFiles, 'TFiles', 'D:/a/1/s/src/web/employee/src/containers/tiles/TFiles.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TFiles.js');
	}();

	;

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reapop = __webpack_require__(44);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _Benefits = __webpack_require__(181);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _KBenefit = __webpack_require__(426);
	
	var _KBenefit2 = _interopRequireDefault(_KBenefit);
	
	var _TBenefits = __webpack_require__(74);
	
	var _TBenefits2 = _interopRequireDefault(_TBenefits);
	
	var _Files = __webpack_require__(117);
	
	var _Email = __webpack_require__(422);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	var _Benefits2 = __webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var TGrants = function TGrants() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      BenefitsReducer = _useSelector.BenefitsReducer,
	      profileReducer = _useSelector.profileReducer;
	
	  var benefits = BenefitsReducer.benefits,
	      loaded = BenefitsReducer.loaded,
	      benefitLoadingById = BenefitsReducer.benefitLoadingById;
	
	  var employeeName = (0, _lodash.get)(profileReducer, ['employeeMaster', 'EmployeeName'], '');
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _Benefits.fetchBenefits)());
	    dispatch((0, _Files.initUpload)());
	  }, []);
	
	  if (!loaded) {
	    return _react2.default.createElement(_TLoading2.default, null);
	  }
	
	  var gr = (0, _lodash.filter)(benefits, function (benefit) {
	    return benefit.HrBenefitType === 1 || benefit.HrBenefitType === 2;
	  });
	
	  if (!gr || !gr.length) {
	    return _react2.default.createElement(_TMessage2.default, { message: 'tile.grants.empty' });
	  }
	
	  // const onBenefitUpload = (files, fileType, cb) => dispatch(uploadFiles({ files, fileType }, () => {
	  //   cb && cb();
	  //   dispatch(addNotification({
	  //     title: 'Vistað',
	  //     message: 'Viðhengi hefur verið vistað í skjalaskáp',
	  //     status: 'success',
	  //     dismissible: true,
	  //     dismissAfter: 4000,
	  //   }));
	  // }));
	
	  var onBenefitUpload = function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(files, fileType, cb, Email, EmailCallBack) {
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              return _context.abrupt('return', dispatch((0, _Benefits2.benefitUpload)({ files: files, fileType: fileType }, cb, Email, EmailCallBack)));
	
	            case 1:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function onBenefitUpload(_x, _x2, _x3, _x4, _x5) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	
	  var onSendEmail = function onSendEmail(email) {
	    return dispatch((0, _Email.requestSendEmail)(email, function () {
	      dispatch((0, _reapop.addNotification)({
	        title: 'Sent',
	        message: 'Tölvupóstur hefur verið sendur með viðhengi',
	        status: 'success',
	        dismissible: true,
	        dismissAfter: 4000
	      }));
	    }));
	  };
	
	  if (gr.length === 1) {
	    var benefit = (0, _lodash.get)(gr, 0);
	    return _react2.default.createElement(_KBenefit2.default, _extends({}, benefit, {
	      loading: (0, _lodash.get)(benefitLoadingById, benefit.HrBenefitID, false),
	      onUpload: onBenefitUpload,
	      onRequestGrant: function onRequestGrant() {
	        return dispatch(_Benefits2.fitnessGrantRegisterAndUpload.apply(undefined, arguments));
	      },
	      onEmail: onSendEmail,
	      employeeName: employeeName
	    }));
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: _TBenefits2.default.container },
	    _react2.default.createElement(
	      'div',
	      { style: { maxHeight: 422, overflow: 'auto', height: '100%' } },
	      (0, _lodash.map)(gr, function (grant, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(_materialUi.ListItem, {
	            innerDivStyle: _TBenefits2.default.link,
	            primaryText: grant.HrBenefitName,
	            hoverColor: 'transparent',
	            onClick: function onClick() {
	              return dispatch((0, _reactRouterRedux.push)('/grants'));
	            }
	          }),
	          _react2.default.createElement(_materialUi.Divider, { key: 'div', style: _TBenefits2.default.spacer })
	        );
	      })
	    ),
	    _react2.default.createElement(_KFlatButton2.default, {
	      'data-cy': 'grants-button',
	      style: _TBenefits2.default.actionButton,
	      onClick: function onClick() {
	        return dispatch((0, _reactRouterRedux.push)('/grants'));
	      },
	      containerStyle: _TBenefits2.default.action,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.goto' })
	    })
	  );
	};
	
	var _default = TGrants;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TGrants, 'TGrants', 'D:/a/1/s/src/web/employee/src/containers/tiles/TGrants.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TGrants.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _EmployeeHoliday = __webpack_require__(182);
	
	var _localSettings = __webpack_require__(187);
	
	var _reactIntl = __webpack_require__(5);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _KValue = __webpack_require__(283);
	
	var _KValue2 = _interopRequireDefault(_KValue);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _materialUi = __webpack_require__(17);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  container: {
	    width: 'calc(100% - 72px)',
	    height: 'calc(100% - 36px)',
	    paddingLeft: 36,
	    paddingRight: 36,
	    paddingTop: 26,
	    paddingBottom: 10,
	    display: 'flex',
	    flexDirection: 'column'
	  },
	  action: {
	    flex: '1 1 0',
	    justifyContent: 'center',
	    minHeight: 40,
	    maxHeight: 40
	  },
	  actionButton: {
	    maxWidth: 'none',
	    fontSize: 14
	  },
	  chart: {
	    width: 'calc(100% - 2px)',
	    height: 24,
	    borderRadius: 4,
	    overflow: 'hidden',
	    marginTop: 12,
	    marginBottom: 12,
	    backgroundColor: '#eeeeee'
	  },
	  chartBar: {
	    height: '100%',
	    backgroundColor: _colors2.default.primary3Color
	  },
	  content: {
	    display: 'flex',
	    flexDirection: 'column',
	    flex: '1 0 auto',
	    justifyContent: 'space-around'
	  },
	  row: {
	    display: 'flex'
	  },
	  title: {
	    fontSize: 18,
	    fontWeight: 'normal',
	    marginLeft: 0
	  },
	  spacer: {
	    marginTop: 30
	  },
	  mainValue: {
	    fontSize: 24
	  }
	};
	
	var THoliday = function (_React$Component) {
	  _inherits(THoliday, _React$Component);
	
	  function THoliday(props) {
	    _classCallCheck(this, THoliday);
	
	    var _this = _possibleConstructorReturn(this, (THoliday.__proto__ || Object.getPrototypeOf(THoliday)).call(this, props));
	
	    _this.state = { showByHour: (0, _localSettings.getSettingByKey)('showHolidayByHour') || false };
	    return _this;
	  }
	
	  _createClass(THoliday, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.fetch();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          loaded = _props.loaded,
	          hasError = _props.hasError,
	          holidays = _props.holidays;
	
	
	      if (!loaded) {
	        return _react2.default.createElement(_TLoading2.default, null);
	      }
	
	      if (hasError) {
	        return _react2.default.createElement(_TMessage2.default, { type: 'error', message: 'tile.holiday.error' });
	      }
	
	      if (!holidays || !holidays.length) {
	        return _react2.default.createElement(_TMessage2.default, { message: 'tile.holiday.empty' });
	      }
	
	      var _holidays$ = holidays[0],
	          FirstOfMai = _holidays$.FirstOfMai,
	          Sum = _holidays$.Sum,
	          PayWageCollectYear = _holidays$.PayWageCollectYear,
	          WorkTimePerDay = _holidays$.WorkTimePerDay,
	          Taken = _holidays$.Taken;
	
	
	      var left = 0;
	      if (FirstOfMai > Taken) {
	        left = (1 - Taken / FirstOfMai) * 100;
	      }
	
	      var divider = WorkTimePerDay;
	      var formatId = 'holiday.days';
	      if (this.state.showByHour) {
	        divider = 1;
	        formatId = 'holiday.hours';
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.container },
	        _react2.default.createElement(
	          'div',
	          { style: styles.content },
	          _react2.default.createElement(_KTitle2.default, {
	            containerStyle: { marginBottom: 8 },
	            style: styles.title,
	            subtitleStyle: { marginLeft: 0 },
	            title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holiday.title.year', values: { year: PayWageCollectYear } }),
	            subtitle: _react2.default.createElement(_reactIntl.FormattedMessage, {
	              id: 'tile.holiday.period',
	              values: { year: PayWageCollectYear, nextYear: PayWageCollectYear + 1 }
	            })
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: styles.row },
	            _react2.default.createElement(_KValue2.default, {
	              valueStyle: styles.mainValue,
	              value: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: formatId,
	                values: { val: (Sum / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
	              }),
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.sum' })
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.chart },
	            _react2.default.createElement('div', { style: _extends({}, styles.chartBar, { width: left + '%' }) })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: styles.row },
	            _react2.default.createElement(_KValue2.default, {
	              value: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: formatId,
	                values: { val: (FirstOfMai / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
	              }),
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.firstOfMay', values: { year: PayWageCollectYear } })
	            }),
	            _react2.default.createElement(_KValue2.default, {
	              value: _react2.default.createElement(_reactIntl.FormattedMessage, {
	                id: formatId,
	                values: { val: (Taken / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
	              }),
	              label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.taken', values: { year: PayWageCollectYear } })
	            })
	          )
	        ),
	        _react2.default.createElement(_materialUi.Divider, { key: 'div', style: styles.spacer }),
	        _react2.default.createElement(_KFlatButton2.default, {
	          style: styles.actionButton,
	          onClick: function onClick() {
	            return _this2.context.router.push('/holiday');
	          },
	          containerStyle: styles.action,
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.holiday.goto' })
	        })
	      );
	    }
	  }]);
	
	  return THoliday;
	}(_react2.default.Component);
	
	THoliday.propTypes = {
	  loaded: _propTypes2.default.bool.isRequired,
	  hasError: _propTypes2.default.bool.isRequired,
	  fetch: _propTypes2.default.func.isRequired,
	  holidays: _propTypes2.default.array.isRequired
	};
	
	THoliday.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref) {
	  var EmployeeHolidayReducer = _ref.EmployeeHolidayReducer;
	  return _extends({}, EmployeeHolidayReducer);
	}, function (dispatch) {
	  return { fetch: function fetch() {
	      return dispatch((0, _EmployeeHoliday.fetch)());
	    } };
	})(THoliday);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/tiles/THoliday.js');
	
	  __REACT_HOT_LOADER__.register(THoliday, 'THoliday', 'D:/a/1/s/src/web/employee/src/containers/tiles/THoliday.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/THoliday.js');
	}();

	;

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reapop = __webpack_require__(44);
	
	var _reactRedux = __webpack_require__(12);
	
	var _lodash = __webpack_require__(8);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _index = __webpack_require__(388);
	
	var _TBenefits = __webpack_require__(74);
	
	var _TBenefits2 = _interopRequireDefault(_TBenefits);
	
	var _Thinking = __webpack_require__(960);
	
	var _Thinking2 = _interopRequireDefault(_Thinking);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _Api = __webpack_require__(21);
	
	var _api = __webpack_require__(185);
	
	var _holidays = __webpack_require__(227);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _holidayResponseStatuses = __webpack_require__(285);
	
	var _holidayResponseStatuses2 = _interopRequireDefault(_holidayResponseStatuses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var errorStyle = {
	  color: 'red',
	  fontSize: '12px',
	  margintop: 20
	};
	
	var warningStyle = {
	  color: 'orange',
	  fontSize: '12px',
	  margintop: 20
	};
	
	var OK = _holidayResponseStatuses2.default.OK,
	    WARNING = _holidayResponseStatuses2.default.WARNING,
	    ERROR = _holidayResponseStatuses2.default.ERROR;
	
	
	var useWorkingHours = function useWorkingHours(detailId) {
	  var _useState = (0, _react.useState)(true),
	      _useState2 = _slicedToArray(_useState, 2),
	      loading = _useState2[0],
	      setLoading = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(null),
	      _useState4 = _slicedToArray(_useState3, 2),
	      data = _useState4[0],
	      setData = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      inKjarniTime = _useState6[0],
	      setInKjarniTime = _useState6[1];
	
	  (0, _react.useEffect)(function () {
	    var fetchWorkingHours = function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var res, result, ikt;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                setLoading(true);
	                _context.next = 3;
	                return (0, _Api.custom)((0, _api.getWorkingHoursToday)(detailId));
	
	              case 3:
	                res = _context.sent;
	                result = (0, _lodash.get)(res, 'data.value[0].HrsPrDay', 0);
	                ikt = (0, _lodash.get)(res, 'data.value[0].InKjarniTime', false);
	
	                setInKjarniTime(ikt);
	                setData(result);
	                setLoading(false);
	
	              case 9:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined);
	      }));
	
	      return function fetchWorkingHours() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	    if (detailId) {
	      fetchWorkingHours();
	    }
	  }, [detailId]);
	  return { loading: loading, data: data, inKjarniTime: inKjarniTime };
	};
	var THolidayRequest = function THolidayRequest(_ref2) {
	  var loading = _ref2.loading,
	      DefaultEmployeeDetailID = _ref2.DefaultEmployeeDetailID,
	      showSuccessNotification = _ref2.showSuccessNotification,
	      showErrorNotification = _ref2.showErrorNotification;
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      showDialog = _useState8[0],
	      setShowDialog = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      isDisabled = _useState10[0],
	      setIsDisabled = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(''),
	      _useState12 = _slicedToArray(_useState11, 2),
	      warningText = _useState12[0],
	      setWarningText = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      warningType = _useState14[0],
	      setWarningType = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      timeError = _useState16[0],
	      setTimeError = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      showHalfDayWarning = _useState18[0],
	      setShowHalfDayWarning = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(false),
	      _useState20 = _slicedToArray(_useState19, 2),
	      isConfirming = _useState20[0],
	      setIsConfirming = _useState20[1];
	
	  var validateAndSubmitRequest = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
	      var requestConfig, res;
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              requestConfig = {
	                url: '/kjarni/api/v2/ClockCardEntries/CreateEmployeeDetailApprovalRequest',
	                method: 'POST',
	                data: data
	              };
	              _context2.prev = 1;
	              _context2.next = 4;
	              return (0, _Api.custom)(requestConfig);
	
	            case 4:
	              res = _context2.sent;
	              return _context2.abrupt('return', res.data);
	
	            case 8:
	              _context2.prev = 8;
	              _context2.t0 = _context2['catch'](1);
	
	              showErrorNotification(_context2.t0);
	              return _context2.abrupt('return', null);
	
	            case 12:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined, [[1, 8]]);
	    }));
	
	    return function validateAndSubmitRequest(_x) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  var resetSubmitState = function resetSubmitState() {
	    setShowHalfDayWarning(false);
	    setIsDisabled(false);
	    setIsConfirming(false);
	    setWarningText('');
	    setWarningType('');
	  };
	
	  var openDialog = function openDialog() {
	    return setShowDialog(true);
	  };
	  var closeDialog = function closeDialog() {
	    resetSubmitState();
	    setTimeError('');
	    setShowDialog(false);
	  };
	
	  var _useWorkingHours = useWorkingHours(DefaultEmployeeDetailID),
	      workingHours = _useWorkingHours.data,
	      inKjarniTime = _useWorkingHours.inKjarniTime;
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      employeeDetailOrgList = _useSelector.profileReducer.employeeDetailOrgList,
	      valuesByKey = _useSelector.WebValuesReducer.valuesByKey;
	
	  var _useForm = (0, _index.useForm)(),
	      handleSubmit = _useForm.handleSubmit,
	      watch = _useForm.watch,
	      errors = _useForm.errors,
	      control = _useForm.control,
	      setValue = _useForm.setValue,
	      getValues = _useForm.getValues;
	
	  var employeeDetailOrg = (0, _lodash.find)(employeeDetailOrgList, function (d) {
	    return d.EmployeeDetailID === DefaultEmployeeDetailID;
	  });
	  var timeOfficerId = (0, _lodash.get)(employeeDetailOrg, 'EmployeeOfficerTimeID', 0);
	  var timeOfficerName = (0, _lodash.get)(employeeDetailOrg, 'EmployeeOfficerTimeName', '');
	  var showTimeOfficerSelect = (0, _lodash.get)(valuesByKey, ['HolidayRequest.TimeOfficerApproval', 'Value']) === 'true';
	  var managerName = (0, _lodash.get)(employeeDetailOrg, 'ManagerName', '');
	  var PeriodBegda = watch('PeriodBegda');
	  var PeriodEndda = watch('PeriodEndda');
	  var Duration = watch('Duration');
	  var ConnectedID = watch('ConnectedID');
	
	  var onSubmit = function () {
	    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
	      var payload, result, locale, messages, formattedMessage;
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              setIsDisabled(true);
	              payload = {
	                EmployeeDetailID: DefaultEmployeeDetailID,
	                Description: (0, _lodash.get)(data, 'RequestDescription', ''),
	                PeriodBegda: (0, _moment2.default)((0, _lodash.get)(data, 'PeriodBegda', new Date())).toISOString(),
	                PeriodEndda: (0, _moment2.default)((0, _lodash.get)(data, 'PeriodEndda', new Date())).toISOString(),
	                HoursPerDay: Number((0, _lodash.get)(data, 'Duration', 0)),
	                ApproverID: (0, _lodash.get)(data, 'RequestApproverID', 0),
	                IsUnpaidVacation: data.ConnectedID === 1,
	                IncludesWeekends: false,
	                IncludesRedDays: false,
	                UseAccrualsIfNeeded: isConfirming
	              };
	              _context3.next = 4;
	              return validateAndSubmitRequest(payload);
	
	            case 4:
	              result = _context3.sent;
	              locale = localStorage.language === 'is' ? 'IS' : 'EN';
	              messages = result.Messages.filter(function (m) {
	                return m.Language === locale;
	              });
	              formattedMessage = messages
	              // eslint-disable-next-line
	              .map(function (msg) {
	                return msg.Message.endsWith('.') ? msg.Message : msg.Message + '.';
	              }).join('\n');
	
	              if (result && result.Status === OK) {
	                closeDialog();
	                showSuccessNotification();
	              } else if (result && result.Status === WARNING) {
	                setWarningText(formattedMessage);
	                setWarningType('warning');
	                setIsConfirming(true);
	              } else if (result && result.Status === ERROR) {
	                setWarningText(formattedMessage);
	                setWarningType('error');
	              }
	              setIsDisabled(false);
	
	            case 10:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined);
	    }));
	
	    return function onSubmit(_x2) {
	      return _ref4.apply(this, arguments);
	    };
	  }();
	
	  (0, _react.useEffect)(function () {
	    resetSubmitState();
	    if (PeriodBegda && PeriodEndda && Duration) {
	      var isClockOutBeforeIn = (0, _moment2.default)(PeriodEndda).isBefore((0, _moment2.default)(PeriodBegda));
	      var isBeforeCurrentDate = (0, _moment2.default)(PeriodBegda).isBefore((0, _moment2.default)(), 'day');
	      if (isBeforeCurrentDate) {
	        setTimeError('holidayApprovalRequest.timeError.beforeCurrentDate');
	      } else if (isClockOutBeforeIn) {
	        setTimeError('holidayApprovalRequest.timeError');
	      } else {
	        setTimeError('');
	      }
	    }
	  }, [PeriodBegda, PeriodEndda, Duration, ConnectedID]);
	
	  var hasHalfDays = function hasHalfDays(startDate, endDate) {
	    if (!inKjarniTime) {
	      return false;
	    }
	    var currentDate = new Date(startDate);
	    while (currentDate <= endDate) {
	      if ((0, _holidays.isHalfDay)(currentDate)) {
	        return true;
	      }
	      currentDate.setDate(currentDate.getDate() + 1);
	    }
	    return false;
	  };
	  (0, _react.useEffect)(function () {
	    if (PeriodBegda && PeriodEndda) {
	      setShowHalfDayWarning(hasHalfDays((0, _moment2.default)(PeriodBegda), (0, _moment2.default)(PeriodEndda)));
	    }
	  }, [PeriodBegda, PeriodEndda]);
	
	  var actions = [_react2.default.createElement(_materialUi.FlatButton, {
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'alert.cancel' }),
	    disabled: loading,
	    secondary: true,
	    onClick: closeDialog
	  }), _react2.default.createElement(_materialUi.RaisedButton, {
	    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: isConfirming ? 'alert.ok' : 'submit' }),
	    icon: _react2.default.createElement(
	      _materialUi.FontIcon,
	      { className: 'material-icons' },
	      'send'
	    ),
	    disabled: loading || !(0, _lodash.isEmpty)(errors) || isDisabled,
	    primary: true,
	    onClick: handleSubmit(onSubmit)
	  })];
	  return _react2.default.createElement(
	    'div',
	    { style: _TBenefits2.default.container, 'data-cy': 'holiday-request' },
	    _react2.default.createElement(
	      _materialUi.Dialog,
	      {
	        open: showDialog,
	        actions: actions,
	        contentStyle: {
	          overflow: 'hidden',
	          maxWidth: 500,
	          width: '100%'
	        },
	        bodyStyle: {
	          overflowY: 'auto'
	        },
	        modal: true
	      },
	      loading ? _react2.default.createElement(
	        'div',
	        {
	          style: {
	            backgroundColor: 'rgba(0, 0, 0, 0.34)',
	            position: 'absolute',
	            zIndex: 10,
	            top: 0,
	            left: 0,
	            width: '100%',
	            height: '100%',
	            display: 'flex',
	            alignItems: 'center',
	            justifyContent: 'center'
	          }
	        },
	        _react2.default.createElement(
	          _materialUi.Paper,
	          {
	            style: {
	              padding: 32,
	              display: 'flex',
	              flexDirection: 'column',
	              alignItems: 'center'
	            }
	          },
	          _react2.default.createElement(_materialUi.CircularProgress, { style: { marginBottom: 24 }, size: 100 }),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'sending.message' })
	        )
	      ) : null,
	      _react2.default.createElement(_KTitle2.default, {
	        style: {
	          marginLeft: 0,
	          display: 'flex',
	          alignItems: 'center',
	          flexDirection: 'row'
	        },
	        title: _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(
	            _materialUi.FontIcon,
	            {
	              style: {
	                marginRight: 6, fontSize: 28, color: 'inherit'
	              },
	              className: 'material-icons'
	            },
	            'school'
	          ),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dash.title.holidayApprovalRequest' })
	        ),
	        subtitleStyle: { margin: 0, fontSize: 12, lineHeight: '1' },
	        subtitle: _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holidayApprovalRequest.description' })
	        )
	      }),
	      _react2.default.createElement(
	        'form',
	        { style: { marginBottom: 32 } },
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', flexDirection: 'column' } },
	          _react2.default.createElement(_index.Controller, {
	            as: _react2.default.createElement(_materialUi.TextField, {
	              fullWidth: true,
	              floatingLabelFixed: true,
	              floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.form.description' }),
	              errorText: errors.RequestDescription ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : '',
	              multiLine: true,
	              rows: 3
	            }),
	            name: 'RequestDescription',
	            control: control,
	            defaultValue: '',
	            rules: { required: true }
	          }),
	          _react2.default.createElement(_index.Controller, {
	            render: function render(_ref5) {
	              var _onChange = _ref5.onChange,
	                  _onBlur = _ref5.onBlur,
	                  value = _ref5.value,
	                  name = _ref5.name,
	                  ref = _ref5.ref;
	              return _react2.default.createElement(_materialUi.TextField, {
	                name: name,
	                inputRef: ref,
	                fullWidth: true,
	                type: 'date',
	                value: value,
	                onChange: function onChange(e) {
	                  return _onChange(e.target.value);
	                },
	                onBlur: function onBlur(e) {
	                  _onBlur();
	                  var currentEndda = getValues('PeriodEndda');
	                  if (e.target.value && !currentEndda) {
	                    setValue('PeriodEndda', e.target.value);
	                  }
	                },
	                min: new Date().toISOString().split('T')[0],
	                floatingLabelFixed: true,
	                floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.form.from' }),
	                errorText: errors.PeriodBegda ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : ''
	              });
	            },
	            name: 'PeriodBegda',
	            control: control,
	            defaultValue: '',
	            rules: { required: true }
	          }),
	          _react2.default.createElement(_index.Controller, {
	            as: _react2.default.createElement(_materialUi.TextField, {
	              fullWidth: true,
	              type: 'date',
	              min: new Date().toISOString().split('T')[0],
	              floatingLabelFixed: true,
	              floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.form.to' }),
	              errorText: errors.PeriodEndda ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : ''
	            }),
	            name: 'PeriodEndda',
	            control: control,
	            defaultValue: '',
	            rules: { required: true }
	          }),
	          showHalfDayWarning && _react2.default.createElement(
	            'div',
	            { style: warningStyle },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.HalfDayWarning.Description' })
	          ),
	          timeError && _react2.default.createElement(
	            'div',
	            { style: errorStyle },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: timeError })
	          ),
	          _react2.default.createElement(_index.Controller, {
	            render: function render(_ref6) {
	              var _onChange2 = _ref6.onChange,
	                  onBlur = _ref6.onBlur,
	                  value = _ref6.value,
	                  name = _ref6.name,
	                  ref = _ref6.ref;
	              return _react2.default.createElement(
	                _materialUi.SelectField,
	                {
	                  name: name,
	                  onBlur: onBlur,
	                  inputRef: ref,
	                  onChange: function onChange(_, __, val) {
	                    return _onChange2(val);
	                  },
	                  fullWidth: true,
	                  floatingLabelFixed: true,
	                  value: value,
	                  floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Type' })
	                },
	                _react2.default.createElement(_materialUi.MenuItem, { primaryText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holiday' }), value: 0, key: 0 }),
	                _react2.default.createElement(_materialUi.MenuItem, { primaryText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holiday.unpaid' }), value: 1, key: 1 })
	              );
	            },
	            name: 'ConnectedID',
	            control: control,
	            defaultValue: 0
	          }),
	          _react2.default.createElement(_index.Controller, {
	            as: _react2.default.createElement(_materialUi.TextField, {
	              fullWidth: true,
	              type: 'number',
	              floatingLabelFixed: true,
	              floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.form.hoursPerDay' }),
	              min: 0,
	              step: 0.01
	            }),
	            defaultValue: workingHours,
	            name: 'Duration',
	            control: control,
	            errorText: warningText,
	            errorStyle: _extends({}, warningType === 'warning' && { color: _colors2.default.warningColor }),
	            rules: { required: true }
	          }),
	          showTimeOfficerSelect && timeOfficerId ? _react2.default.createElement(_index.Controller, {
	            render: function render(_ref7) {
	              var _onChange3 = _ref7.onChange,
	                  onBlur = _ref7.onBlur,
	                  value = _ref7.value,
	                  name = _ref7.name,
	                  ref = _ref7.ref;
	              return _react2.default.createElement(
	                _materialUi.SelectField,
	                {
	                  name: name,
	                  onBlur: onBlur,
	                  inputRef: ref,
	                  onChange: function onChange(_, __, val) {
	                    return _onChange3(val);
	                  },
	                  fullWidth: true,
	                  floatingLabelFixed: true,
	                  value: value,
	                  floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Approver' })
	                },
	                _react2.default.createElement(_materialUi.MenuItem, { primaryText: managerName, value: 0, key: 0 }),
	                _react2.default.createElement(_materialUi.MenuItem, { primaryText: timeOfficerName, value: timeOfficerId, key: timeOfficerId })
	              );
	            },
	            name: 'RequestApproverID',
	            control: control,
	            defaultValue: timeOfficerId
	          }) : null
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          height: '100%',
	          display: 'flex',
	          flexDirection: 'column',
	          alignItems: 'center',
	          justifyContent: 'center'
	        }
	      },
	      _react2.default.createElement(_Thinking2.default, null),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            padding: 8,
	            marginBottom: 12,
	            marginTop: 12,
	            display: 'flex',
	            flexDirection: 'row'
	          }
	        },
	        _react2.default.createElement(
	          _materialUi.FontIcon,
	          { style: { marginRight: 8 }, color: _colors2.default.infoColor, className: 'material-icons' },
	          'info'
	        ),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holidayApprovalRequest.description' })
	      ),
	      _react2.default.createElement(_materialUi.RaisedButton, {
	        primary: true,
	        style: { marginBottom: 12 },
	        onClick: openDialog,
	        'data-cy': 'holiday-request-button',
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'holidayApprovalRequest.button' })
	      })
	    )
	  );
	};
	
	THolidayRequest.propTypes = {
	  loading: _propTypes2.default.bool.isRequired,
	  showSuccessNotification: _propTypes2.default.func.isRequired,
	  showErrorNotification: _propTypes2.default.func.isRequired,
	  DefaultEmployeeDetailID: _propTypes2.default.number.isRequired
	};
	
	THolidayRequest.defaultProps = {};
	
	var _default = (0, _reactRedux.connect)(function (_ref8) {
	  var approvalRequestReducer = _ref8.approvalRequestReducer,
	      loginReducer = _ref8.loginReducer;
	  return _extends({}, approvalRequestReducer, {
	    DefaultEmployeeDetailID: (0, _lodash.get)(loginReducer, 'user.DefaultEmployeeDetailID', 0)
	  });
	}, function (dispatch) {
	  return {
	    showSuccessNotification: function showSuccessNotification() {
	      return dispatch((0, _reapop.addNotification)({
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'approvalRequest.create.success' }),
	        status: 'success',
	        dismissible: true,
	        dismissAfter: 5000
	      }));
	    },
	    showErrorNotification: function showErrorNotification(err) {
	      return dispatch((0, _reapop.addNotification)({
	        title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'notification.error.title' }),
	        message: err.message || 'Villa kom upp við að stofna færslu í kjarna',
	        status: 'error',
	        dismissible: true,
	        dismissAfter: 5000
	      }));
	    }
	  };
	})(THolidayRequest);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(errorStyle, 'errorStyle', 'D:/a/1/s/src/web/employee/src/containers/tiles/THolidayRequest.js');
	
	  __REACT_HOT_LOADER__.register(warningStyle, 'warningStyle', 'D:/a/1/s/src/web/employee/src/containers/tiles/THolidayRequest.js');
	
	  __REACT_HOT_LOADER__.register(OK, 'OK', 'D:/a/1/s/src/web/employee/src/containers/tiles/THolidayRequest.js');
	
	  __REACT_HOT_LOADER__.register(WARNING, 'WARNING', 'D:/a/1/s/src/web/employee/src/containers/tiles/THolidayRequest.js');
	
	  __REACT_HOT_LOADER__.register(ERROR, 'ERROR', 'D:/a/1/s/src/web/employee/src/containers/tiles/THolidayRequest.js');
	
	  __REACT_HOT_LOADER__.register(useWorkingHours, 'useWorkingHours', 'D:/a/1/s/src/web/employee/src/containers/tiles/THolidayRequest.js');
	
	  __REACT_HOT_LOADER__.register(THolidayRequest, 'THolidayRequest', 'D:/a/1/s/src/web/employee/src/containers/tiles/THolidayRequest.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/THolidayRequest.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  container: {
	    width: 'calc(100% - 72px)',
	    height: 'calc(100% - 20px)',
	    paddingLeft: 36,
	    paddingRight: 36,
	    paddingTop: 10,
	    paddingBottom: 10
	  },
	  link: {
	    marginTop: 12,
	    marginBottom: 12,
	    paddingLeft: 0
	  },
	  tag: {
	    marginTop: 12,
	    borderRadius: 4,
	    padding: 6,
	    color: 'white',
	    display: 'table'
	  }
	};
	
	var TLinks = function TLinks() {
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.WebValuesReducer;
	  }),
	      links = _useSelector.links;
	
	  var sorted = (0, _lodash.sortBy)(links, 'WebValueID');
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.container },
	    (0, _lodash.map)(sorted, function (link) {
	      return _react2.default.createElement(
	        'div',
	        { key: link.Code },
	        _react2.default.createElement(_materialUi.ListItem, {
	          rightIcon: _react2.default.createElement(
	            _materialUi.FontIcon,
	            { className: 'material-icons' },
	            'link'
	          ),
	          innerDivStyle: styles.link,
	          target: '_blank',
	          href: link.Value,
	          primaryText: link.Description,
	          hoverColor: 'transparent'
	        }),
	        _react2.default.createElement(_materialUi.Divider, null)
	      );
	    })
	  );
	};
	
	var _default = TLinks;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/tiles/TLinks.js');
	
	  __REACT_HOT_LOADER__.register(TLinks, 'TLinks', 'D:/a/1/s/src/web/employee/src/containers/tiles/TLinks.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TLinks.js');
	}();

	;

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _api = __webpack_require__(225);
	
	var _appraisalEnums = __webpack_require__(286);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var STARTED = _appraisalEnums.STATUS.STARTED,
	    FINISHED = _appraisalEnums.STATUS.FINISHED,
	    NONE = _appraisalEnums.STATUS.NONE;
	
	// Helper function to convert numeric status to string status (for old appraisals)
	
	var convertStatus = function convertStatus(numericStatus) {
	  if (numericStatus === FINISHED) return 'Finished';
	  if (numericStatus === STARTED) return 'Started';
	  return 'None';
	};
	
	// Helper function to normalize old appraisal data
	var normalizeOldAppraisal = function normalizeOldAppraisal(appraisal) {
	  return _extends({}, appraisal, {
	    type: 'old',
	    PMEmployeeAppraisalID: appraisal.PMAppraisalID,
	    Title: { IS: appraisal.PMFormTitle },
	    DefaultLanguage: 'IS',
	    ManagerEmployeeName: appraisal.ManagerName,
	    EmployeeStatus: convertStatus(appraisal.EmployeeStatus),
	    ManagerStatus: convertStatus(appraisal.ManagerStatus),
	    FinalStatus: convertStatus(appraisal.FinalStatus)
	  });
	};
	
	var styles = {
	  container: {
	    width: 'calc(100% - 72px)',
	    height: 'calc(100% - 26px)',
	    paddingLeft: 36,
	    paddingRight: 36,
	    paddingTop: 18,
	    paddingBottom: 8,
	    display: 'flex',
	    flexDirection: 'column'
	  },
	  action: {
	    flex: '1 1 0',
	    justifyContent: 'center',
	    minHeight: 40,
	    maxHeight: 40
	  },
	  actionButton: {
	    maxWidth: 'none',
	    fontSize: 14
	  },
	  appraisal: {
	    paddingLeft: 0,
	    paddingRight: 0,
	    paddingTop: 18,
	    paddingBottom: 18
	  },
	  secondary: {
	    display: 'flex',
	    alignItems: 'center',
	    height: 40,
	    justifyContent: 'space-between'
	  },
	  tag: {
	    fontSize: 14,
	    color: 'white',
	    borderRadius: 4,
	    padding: 6
	  }
	};
	
	var TPMAppraisals = function TPMAppraisals(props, context) {
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      newAppraisals = _useState2[0],
	      setNewAppraisals = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(true),
	      _useState4 = _slicedToArray(_useState3, 2),
	      loading = _useState4[0],
	      setLoading = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(null),
	      _useState6 = _slicedToArray(_useState5, 2),
	      error = _useState6[0],
	      setError = _useState6[1];
	
	  var EmployeeMasterID = Number(localStorage.EmployeeMasterID);
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      _useSelector$Appraisa = _useSelector.Appraisal,
	      oldAppraisals = _useSelector$Appraisa.openAppraisals,
	      appraisalLoading = _useSelector$Appraisa.loading;
	
	  // Fetch new appraisals from API
	
	
	  (0, _react.useEffect)(function () {
	    var fetchNewAppraisals = function () {
	      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	        var newResponse, filtered;
	        return regeneratorRuntime.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	
	                setLoading(true);
	                _context.next = 4;
	                return (0, _api.getPMEmployeeAppraisals)().catch(function () {
	                  return { data: [] };
	                });
	
	              case 4:
	                newResponse = _context.sent;
	                filtered = (newResponse.data || []).map(function (a) {
	                  return _extends({}, a, { type: 'new' });
	                }).filter(function (a) {
	                  return a.EmployeeDetailID === Number(localStorage.DefaultEmployeeDetailID);
	                });
	
	
	                setNewAppraisals(filtered);
	                setError(null);
	                _context.next = 13;
	                break;
	
	              case 10:
	                _context.prev = 10;
	                _context.t0 = _context['catch'](0);
	
	                setError(_context.t0);
	
	              case 13:
	                _context.prev = 13;
	
	                setLoading(false);
	                return _context.finish(13);
	
	              case 16:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, undefined, [[0, 10, 13, 16]]);
	      }));
	
	      return function fetchNewAppraisals() {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    fetchNewAppraisals();
	  }, [EmployeeMasterID]);
	
	  if (error) {
	    return _react2.default.createElement(_TMessage2.default, { type: 'error', message: 'tile.pmappraisals.error' });
	  }
	
	  if (loading || appraisalLoading) {
	    return _react2.default.createElement(_TLoading2.default, null);
	  }
	
	  var today = new Date();
	  today.setHours(0, 0, 0, 0);
	
	  // Combine old appraisals from Redux with new appraisals from API
	  var normalizedOldAppraisals = (oldAppraisals || []).map(normalizeOldAppraisal);
	  var combined = [].concat(_toConsumableArray(newAppraisals), _toConsumableArray(normalizedOldAppraisals));
	
	  // Filter for non-expired appraisals and where at least one status is not finished
	  var list = combined.filter(function (a) {
	    if (a.Expired) return false;
	    // Check both numeric (new) and string (old) statuses
	    var allFinished = (a.EmployeeStatus === FINISHED || a.EmployeeStatus === 'Finished') && (a.ManagerStatus === FINISHED || a.ManagerStatus === 'Finished') && (a.FinalStatus === FINISHED || a.FinalStatus === 'Finished');
	    return !allFinished;
	  });
	
	  if (!list || !list.length) {
	    return _react2.default.createElement(
	      _TMessage2.default,
	      { message: 'tile.appraisals.empty' },
	      _react2.default.createElement(_KFlatButton2.default, {
	        style: styles.actionButton,
	        onClick: function onClick() {
	          return context.router.push('/pmappraisals');
	        },
	        containerStyle: styles.action,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.appraisals.goto' })
	      })
	    );
	  }
	
	  var getStatusTag = function getStatusTag(appraisal) {
	    if (appraisal.EmployeeStatus === NONE || appraisal.EmployeeStatus === 'None') {
	      return _react2.default.createElement(
	        'div',
	        { style: _extends({}, styles.tag, { backgroundColor: _colors2.default.errorColor }) },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.appraisals.start' })
	      );
	    }
	    if (appraisal.EmployeeStatus === STARTED || appraisal.EmployeeStatus === 'Started') {
	      return _react2.default.createElement(
	        'div',
	        { style: _extends({}, styles.tag, { backgroundColor: _colors2.default.warningColor }) },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.appraisals.handin' })
	      );
	    }
	    return null;
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: styles.container },
	    list.map(function (appr) {
	      return _react2.default.createElement(
	        'div',
	        { key: appr.PMEmployeeAppraisalID },
	        _react2.default.createElement(_materialUi.ListItem, {
	          className: 'pmappraisal-item',
	          innerDivStyle: styles.appraisal,
	          hoverColor: 'transparent',
	          primaryText: (0, _lodash.get)(appr, ['Title', appr.DefaultLanguage]) || 'Enginn titill',
	          secondaryText: _react2.default.createElement(
	            'div',
	            { style: styles.secondary },
	            (0, _dateTools2.default)(appr.EmployeeDueDate),
	            getStatusTag(appr)
	          ),
	          onClick: function onClick() {
	            if (appr.type === 'old') {
	              context.router.push('/appraisals/' + appr.PMAppraisalID);
	            } else {
	              context.router.push('/pmappraisals/' + appr.PMEmployeeAppraisalID);
	            }
	          }
	        }),
	        _react2.default.createElement(_materialUi.Divider, null)
	      );
	    }),
	    _react2.default.createElement(_KFlatButton2.default, {
	      style: styles.actionButton,
	      onClick: function onClick() {
	        return context.router.push('/pmappraisals');
	      },
	      containerStyle: styles.action,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.appraisals.goto' })
	    })
	  );
	};
	
	TPMAppraisals.contextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	
	var _default = TPMAppraisals;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(STARTED, 'STARTED', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(FINISHED, 'FINISHED', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(NONE, 'NONE', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(convertStatus, 'convertStatus', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(normalizeOldAppraisal, 'normalizeOldAppraisal', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(TPMAppraisals, 'TPMAppraisals', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPMAppraisals.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPMAppraisals.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _materialUi = __webpack_require__(17);
	
	var _Files = __webpack_require__(117);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _TBenefits = __webpack_require__(74);
	
	var _TBenefits2 = _interopRequireDefault(_TBenefits);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TPayslips = function TPayslips() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      FileReducer = _useSelector.FileReducer,
	      languageReducer = _useSelector.languageReducer;
	
	  var payslipsLoaded = FileReducer.payslipsLoaded,
	      payslips = FileReducer.payslips,
	      payYear = FileReducer.payYear,
	      payYearOptions = FileReducer.payYearOptions,
	      hasError = FileReducer.hasError,
	      error = FileReducer.error;
	  var language = languageReducer.language;
	
	  _moment2.default.locale(language);
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _Files.initPayYear)());
	  }, [dispatch]);
	
	  if (!payslipsLoaded) return _react2.default.createElement(_TLoading2.default, null);
	
	  if (hasError) {
	    return _react2.default.createElement(_PanelMessage2.default, {
	      type: 'error',
	      iconName: 'error',
	      message: error && error.Message ? error.Message : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payslip.error' })
	    });
	  }
	
	  if ((0, _lodash.isEmpty)(payslips)) {
	    return _react2.default.createElement(
	      _TMessage2.default,
	      { message: 'tile.payslips.empty' },
	      _react2.default.createElement(_KFlatButton2.default, {
	        style: _TBenefits2.default.actionButton,
	        onClick: function onClick() {
	          return dispatch((0, _reactRouterRedux.push)('/payslip'));
	        },
	        containerStyle: _TBenefits2.default.action,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.payslips.goto' })
	      })
	    );
	  }
	
	  var setYear = function setYear(year) {
	    dispatch((0, _Files.setPayYear)(year));
	    dispatch((0, _Files.fetchUserPayslips)());
	  };
	
	  var download = function download(id) {
	    return dispatch((0, _Files.downloadFile)(id));
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: _TBenefits2.default.container },
	    _react2.default.createElement(
	      'div',
	      { style: { maxHeight: 422, overflow: 'auto', height: '100%' } },
	      _react2.default.createElement(
	        _materialUi.SelectField,
	        {
	          floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'payslip.select' }),
	          value: payYear,
	          onChange: function onChange(a, b, value) {
	            return setYear(value);
	          }
	        },
	        payYearOptions.map(function (y) {
	          return _react2.default.createElement(_materialUi.MenuItem, { key: y, value: y, primaryText: y });
	        })
	      ),
	      _react2.default.createElement(
	        _materialUi.Paper,
	        null,
	        payslips.map(function (slip) {
	          return _react2.default.createElement(_materialUi.ListItem, {
	            key: slip.PaySlipGuid,
	            style: { paddingLeft: 0 },
	            primaryText: (0, _lodash.capitalize)((0, _moment2.default)().month(slip.PayMonth).format('MMMM')),
	            disabled: true,
	            secondaryText: (0, _moment2.default)(slip.PayPeriodBegda).format('LL') + ' - ' + (0, _moment2.default)(slip.PayPeriodEndda).format('LL'),
	            rightIconButton: _react2.default.createElement(_materialUi.FlatButton, {
	              style: { top: 'auto', right: 0, minWidth: '24px' },
	              onClick: function onClick() {
	                return download(slip.PaySlipGuid);
	              },
	              icon: _react2.default.createElement(
	                _materialUi.FontIcon,
	                { className: 'material-icons' },
	                'file_download'
	              )
	            })
	          });
	        })
	      )
	    ),
	    _react2.default.createElement(_KFlatButton2.default, {
	      style: _TBenefits2.default.actionButton,
	      onClick: function onClick() {
	        return dispatch((0, _reactRouterRedux.push)('/payslip'));
	      },
	      containerStyle: _TBenefits2.default.action,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.payslips.goto' })
	    })
	  );
	};
	
	var _default = TPayslips;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TPayslips, 'TPayslips', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPayslips.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPayslips.js');
	}();

	;

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _RadioButton = __webpack_require__(601);
	
	var _TBenefits = __webpack_require__(74);
	
	var _TBenefits2 = _interopRequireDefault(_TBenefits);
	
	var _lodash = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(12);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _PerDiem = __webpack_require__(848);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _ActionTypes = __webpack_require__(18);
	
	var _PerDiem2 = __webpack_require__(958);
	
	var _PerDiem3 = _interopRequireDefault(_PerDiem2);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var labelStyle = {
	  color: 'rgba(0, 0, 0, 0.3)',
	  fontSize: '12px',
	  marginTop: '16px'
	};
	
	var errorStyle = {
	  color: 'red',
	  fontSize: '12px',
	  margintop: 20
	};
	
	var tableStyle = {
	  display: 'flex',
	  border: '1px solid'
	};
	
	var rowStyle = {
	  border: '1px solid',
	  paddingLeft: '4px',
	  paddingRight: '4px'
	};
	
	var labelColumn = {
	  backgroundColor: '#ddd',
	  width: '50%'
	};
	
	var isNumeric = function isNumeric(value) {
	  return !Number.isNaN(value - parseFloat(value));
	};
	
	var unitRender = function unitRender(n, digits) {
	  if (typeof digits !== 'number') digits = 2; // eslint-disable-line no-param-reassign
	  if (isNumeric(n)) n = (0, _lodash.toNumber)(n); // eslint-disable-line no-param-reassign
	  return !(0, _lodash.isNumber)(n) ? n : n.toLocaleString('de-DE', { maximumFractionDigits: digits, minimumFractionDigits: digits });
	};
	
	var currencyRender = function currencyRender(n) {
	  return n ? n.toLocaleString(
	  // Need to use German because Icelandic is not working
	  'de-DE', { maximumFractionDigits: 0, minimumFractionDigits: 0 }) : n;
	};
	
	var TPerDiem = function TPerDiem(_ref) {
	  var DefaultEmployeeDetailID = _ref.DefaultEmployeeDetailID;
	
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      WebValuesReducer = _useSelector.WebValuesReducer;
	
	  var valuesByKey = WebValuesReducer.valuesByKey;
	
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _PerDiem.initApproval)());
	  }, [dispatch]);
	
	  var _usePerDiemState = (0, _PerDiem.usePerDiemState)(),
	      perDiemList = _usePerDiemState.perDiemList,
	      perDiemLocationList = _usePerDiemState.perDiemLocationList,
	      perDiemTypeList = _usePerDiemState.perDiemTypeList,
	      perDiemListKeyed = _usePerDiemState.perDiemListKeyed,
	      perDiemLocationListKeyed = _usePerDiemState.perDiemLocationListKeyed,
	      perDiemAmountTypeFixed = _usePerDiemState.perDiemAmountTypeFixed,
	      calculating = _usePerDiemState.calculating,
	      calculatedRecord = _usePerDiemState.calculatedRecord;
	
	  var formInitialValues = {
	    PeriodBegda: '',
	    PeriodEndda: '',
	    Duration: 0,
	    Location: 0,
	    PerDiemTypeID: 0,
	    Info: '',
	    ConnectedID: 0
	  };
	
	  var _useState = (0, _react.useState)(perDiemList),
	      _useState2 = _slicedToArray(_useState, 2),
	      perDiems = _useState2[0],
	      setPerDiems = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(),
	      _useState4 = _slicedToArray(_useState3, 2),
	      selectedPerDiem = _useState4[0],
	      setSelectedPerDiem = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({}),
	      _useState6 = _slicedToArray(_useState5, 2),
	      errors = _useState6[0],
	      setErrors = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      dateError = _useState8[0],
	      setDateError = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      loading = _useState10[0],
	      setLoading = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      showDialog = _useState12[0],
	      setShowDialog = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(formInitialValues),
	      _useState14 = _slicedToArray(_useState13, 2),
	      form = _useState14[0],
	      setForm = _useState14[1];
	  // handle comment here because otherwise the modal rerenders on every keypress
	
	
	  var _useState15 = (0, _react.useState)(''),
	      _useState16 = _slicedToArray(_useState15, 2),
	      comment = _useState16[0],
	      setComment = _useState16[1];
	
	  var openDialog = function openDialog() {
	    return setShowDialog(true);
	  };
	  var closeDialog = function closeDialog() {
	    setForm(formInitialValues);
	    setSelectedPerDiem(null);
	    setShowDialog(false);
	  };
	
	  var defaultType = perDiemAmountTypeFixed || (0, _lodash.get)(valuesByKey, ['PerDiem.Default.Type', 'Value'], 'Total');
	
	  var commentRequired = (0, _lodash.get)(valuesByKey, ['PerDiem.Comment.Required', 'Value'], 'false') === 'true';
	  var getRadioLabel = function getRadioLabel(amountType) {
	    return _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', flexDirection: 'row' } },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiem.PerDiemAmountTypeEnum.' + amountType }),
	      selectedPerDiem ? _react2.default.createElement(
	        'div',
	        null,
	        ' - ',
	        currencyRender((0, _lodash.get)(selectedPerDiem, amountType + 'Amount', '')),
	        ' ',
	        (0, _lodash.get)(selectedPerDiem, 'Currency', '')
	      ) : null
	    );
	  };
	
	  var shouldCalculate = function shouldCalculate() {
	    if (calculating) return;
	    // missing DaysOverride days
	    var days = (0, _lodash.get)(form, 'Duration') ? Number((0, _lodash.get)(form, 'Duration')) : 0;
	    var daysOverride = days !== 0 ? days : undefined;
	    if ((0, _lodash.get)(form, 'ConnectedID') && (0, _lodash.get)(form, 'Location') && (0, _lodash.get)(form, 'Info') && (0, _lodash.get)(form, 'PeriodBegda') && (0, _lodash.get)(form, 'PeriodEndda') && DefaultEmployeeDetailID) {
	      dispatch((0, _PerDiem.calculate)({
	        EmployeeDetailID: DefaultEmployeeDetailID,
	        PerDiemID: (0, _lodash.get)(form, 'ConnectedID'),
	        DaysOverride: daysOverride,
	        PerDiemLocationID: (0, _lodash.get)(form, 'Location'),
	        PerDiemAmountType: (0, _lodash.get)(form, 'Info'),
	        Begda: (0, _moment2.default)((0, _lodash.get)(form, 'PeriodBegda')).startOf('day').toISOString(),
	        Endda: (0, _moment2.default)((0, _lodash.get)(form, 'PeriodEndda')).set({ hour: '23', minutes: '59', seconds: '59' }).toISOString()
	      }));
	    } else {
	      dispatch((0, _PerDiem.calculateReset)());
	    }
	  };
	
	  (0, _react.useEffect)(function () {
	    shouldCalculate();
	  }, [form, perDiems]);
	  var checkIfDateError = function checkIfDateError(PeriodBegda, PeriodEndda) {
	    var from = (0, _moment2.default)((0, _moment2.default)(PeriodBegda).format('YYYY-MM-DD'));
	    var to = (0, _moment2.default)((0, _moment2.default)(PeriodEndda).format('YYYY-MM-DD'));
	    var isPeriodBegdaBeforePeriodEndda = to.isBefore(from);
	    setDateError(isPeriodBegdaBeforePeriodEndda);
	  };
	
	  var getHours = function getHours(PeriodBegda, PeriodEndda) {
	    if (PeriodBegda && PeriodEndda) {
	      var timeFrom = (0, _moment2.default)(PeriodBegda);
	      var timeTo = (0, _moment2.default)(PeriodEndda);
	      var Days = timeTo.diff(timeFrom, 'Days') + 1;
	
	      if ((0, _lodash.isNaN)(Days)) {
	        Days = 0;
	      }
	      return Days;
	    }
	    return 0;
	  };
	
	  var radioIsDisabled = function radioIsDisabled(amountType) {
	    // If perDiemAmountTypeFixed from webValues is used, we only allow that type
	    var isDisabled = perDiemAmountTypeFixed && amountType !== perDiemAmountTypeFixed;
	    // Disable the radio if the amount is zero, no reason to allow that.
	    var amount = (0, _lodash.get)(selectedPerDiem, amountType + 'Amount', 0);
	    if (amount === 0) return true;
	    // If the perdiem is domestic we only allow selecting total
	    var domestic = (0, _lodash.get)(selectedPerDiem, 'PerDiemDomesticInternational');
	    return domestic === 'PerDiemDomestic' && amountType !== 'Total' || isDisabled;
	  };
	
	  var formChanged = function formChanged(key, value) {
	
	    if (key === 'Location') {
	      var type = (0, _lodash.get)(perDiemLocationListKeyed[value], 'PerDiemTypeID');
	      var filteredPerDiems = (0, _lodash.filter)(perDiemList, ['PerDiemTypeID', type]);
	      // if there is only one PerDiem to choose from, we use that as default.
	      var connectId = filteredPerDiems.length === 1 ? (0, _lodash.get)(filteredPerDiems[0], 'PerDiemID') : undefined;
	      if (connectId) {
	        setSelectedPerDiem(perDiemListKeyed[connectId]);
	      }
	      setPerDiems(filteredPerDiems);
	      setForm(_extends({}, form, {
	        Location: value,
	        PerDiemTypeID: type,
	        ConnectedID: connectId,
	        Info: connectId ? defaultType : ''
	      }));
	    }
	    if (key === 'ConnectedID') {
	      setSelectedPerDiem(perDiemListKeyed[value]);
	      setForm(_extends({}, form, { ConnectedID: value, Info: defaultType }));
	    }
	
	    if (key === 'PeriodEndda' || key === 'PeriodBegda') {
	      var days = 0;
	      if ((0, _lodash.get)(form, 'PeriodBegda') !== '' && key === 'PeriodEndda') {
	        days = getHours((0, _lodash.get)(form, 'PeriodBegda'), value);
	        checkIfDateError((0, _lodash.get)(form, 'PeriodBegda'), value, key);
	      } else if ((0, _lodash.get)(form, 'PeriodEndda') !== '' && key === 'PeriodBegda') {
	        days = getHours(value, (0, _lodash.get)(form, 'PeriodEndda'));
	        checkIfDateError(value, (0, _lodash.get)(form, 'PeriodEndda'), key);
	      }
	      setForm(_extends({}, form, _defineProperty({ Duration: days }, key, value)));
	    }
	    if (key === 'Info') {
	      setForm(_extends({}, form, _defineProperty({}, key, value)));
	    }
	
	    setErrors(_extends({}, errors, _defineProperty({}, key, !value)));
	  };
	  var areErrors = function areErrors() {
	    var commentError = commentRequired && !comment;
	    setErrors(_extends({}, (0, _lodash.mapValues)(form, function (val, key) {
	      return key !== 'PerDiemTypeID' && !val;
	    }), {
	      RequestDescription: commentError
	    }));
	    if (!(0, _lodash.get)(form, 'PeriodBegda') || !(0, _lodash.get)(form, 'PeriodEndda') || !(0, _lodash.get)(form, 'Duration') || !(0, _lodash.get)(form, 'ConnectedID') || !(0, _lodash.get)(form, 'Location') || !(0, _lodash.get)(form, 'Info') || commentError) return true;
	    return false;
	  };
	  var reset = function reset() {
	    setComment('');
	    setSelectedPerDiem(null);
	    setForm({});
	    setLoading(false);
	    closeDialog();
	  };
	
	  var submit = function submit() {
	    if (!areErrors()) {
	      setLoading(true);
	
	      var formObject = form;
	      delete formObject.PerDiemTypeID;
	      var Begda = (0, _moment2.default)(formObject.PeriodBegda).startOf('day').toISOString();
	      var Endda = (0, _moment2.default)(formObject.PeriodEndda).set({ hour: '23', minutes: '59', seconds: '59' }).toISOString();
	      var Location = (0, _lodash.toString)(formObject.Location);
	      var data = _extends({}, formObject, { PeriodBegda: Begda, PeriodEndda: Endda, Location: Location, RequestDescription: comment
	      });
	
	      dispatch((0, _PerDiem.createPerDiemApprovalRequest)(data, reset));
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: _TBenefits2.default.container },
	    _react2.default.createElement(
	      _materialUi.Dialog,
	      {
	        contentStyle: {
	          overflow: 'hidden',
	          maxWidth: 500,
	          width: '100%'
	        },
	        bodyStyle: {
	          overflowY: 'auto'
	        },
	        modal: true,
	        open: showDialog,
	        onRequestClose: closeDialog
	      },
	      _react2.default.createElement(_KTitle2.default, {
	        style: {
	          marginLeft: 0,
	          display: 'flex',
	          alignItems: 'center',
	          flexDirection: 'row'
	        },
	        title: _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(
	            _materialUi.FontIcon,
	            {
	              style: {
	                marginRight: 6, fontSize: 28, color: 'inherit'
	              },
	              className: 'material-icons'
	            },
	            'money'
	          ),
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'dash.title.perDiem' })
	        ),
	        subtitleStyle: { margin: 0, fontSize: 12, lineHeight: '1' },
	        subtitle: _react2.default.createElement(
	          _react2.default.Fragment,
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiem.Description' })
	        )
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: {
	            display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex', flexDirection: 'column' } },
	          _react2.default.createElement(_materialUi.TextField, {
	            id: 'PeriodBegda',
	            type: 'date',
	            floatingLabelFixed: true,
	            floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.DateIn' }),
	            errorText: errors.PeriodBegda ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : '',
	            value: (0, _lodash.get)(form, 'PeriodBegda'),
	            onChange: function onChange(event) {
	              formChanged('PeriodBegda', event.target.value);
	            }
	          }),
	          _react2.default.createElement(_materialUi.TextField, {
	            id: 'PeriodEndda',
	            type: 'date',
	            floatingLabelFixed: true,
	            floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.DateOut' }),
	            errorText: errors.PeriodBegda ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : '',
	            value: (0, _lodash.get)(form, 'PeriodEndda'),
	            onChange: function onChange(event) {
	              formChanged('PeriodEndda', event.target.value);
	            }
	          }),
	          dateError && _react2.default.createElement(
	            'div',
	            { style: errorStyle },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error.DateOutBeforeDateIn' })
	          )
	        ),
	        (0, _lodash.get)(form, 'PeriodBegda') !== '' && (0, _lodash.get)(form, 'PeriodEndda') !== '' && dateError !== true && _react2.default.createElement(
	          'div',
	          { style: { marginRight: 50 } },
	          getHours((0, _lodash.get)(form, 'PeriodBegda'), (0, _lodash.get)(form, 'PeriodEndda')),
	          ' ',
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiem.Days' })
	        )
	      ),
	      _react2.default.createElement(
	        _materialUi.SelectField,
	        {
	          fullWidth: true,
	          floatingLabelFixed: true,
	          floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiem.PerDiemLocationID' }),
	          value: (0, _lodash.get)(form, 'Location'),
	          onChange: function onChange(event, index, value) {
	            formChanged('Location', value);
	          }
	        },
	        (0, _lodash.map)(perDiemLocationList, function (_ref2) {
	          var PerDiemLocationID = _ref2.PerDiemLocationID,
	              PerDiemLocationName = _ref2.PerDiemLocationName;
	          return _react2.default.createElement(_materialUi.MenuItem, {
	            key: PerDiemLocationID,
	            value: PerDiemLocationID,
	            label: PerDiemLocationName,
	            primaryText: PerDiemLocationName
	          });
	        })
	      ),
	      errors.Location && _react2.default.createElement(
	        'div',
	        { style: errorStyle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' })
	      ),
	      _react2.default.createElement(_materialUi.TextField, {
	        id: 'PerDiemType',
	        type: 'text',
	        fullWidth: true,
	        floatingLabelFixed: true,
	        floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiem.PerDiemTypeID' }),
	        disabled: true,
	        defaultValue: (0, _lodash.get)((0, _lodash.find)(perDiemTypeList, function (p) {
	          return (0, _lodash.get)(form, 'PerDiemTypeID') === p.PerDiemTypeID;
	        }), 'PerDiemTypeName') || ''
	      }),
	      errors.PerDiemTypeID && _react2.default.createElement(
	        'div',
	        { style: errorStyle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' })
	      ),
	      _react2.default.createElement(
	        _materialUi.SelectField,
	        {
	          fullWidth: true,
	          floatingLabelFixed: true,
	          floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiem' }),
	          value: (0, _lodash.get)(form, 'ConnectedID'),
	          onChange: function onChange(event, index, value) {
	            formChanged('ConnectedID', value);
	          }
	        },
	        (0, _lodash.map)(perDiems, function (_ref3) {
	          var PerDiemID = _ref3.PerDiemID,
	              PerDiemDescription = _ref3.PerDiemDescription;
	          return _react2.default.createElement(_materialUi.MenuItem, {
	            key: PerDiemID,
	            value: PerDiemID,
	            label: PerDiemDescription,
	            primaryText: PerDiemDescription
	          });
	        })
	      ),
	      errors.ConnectedID && _react2.default.createElement(
	        'div',
	        { style: errorStyle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: labelStyle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiem.PerDiemAmountType' })
	      ),
	      _react2.default.createElement(
	        _RadioButton.RadioButtonGroup,
	        { name: 'PerDiemAmountType', valueSelected: (0, _lodash.get)(form, 'Info'), onChange: function onChange(_, val) {
	            return formChanged('Info', val);
	          } },
	        (0, _lodash.map)(_ActionTypes.PerDiemAmountTypeEnum, function (amountType) {
	          return _react2.default.createElement(_RadioButton.RadioButton, {
	            disabled: radioIsDisabled(amountType),
	            style: { display: 'block' },
	            key: amountType,
	            value: amountType,
	            label: getRadioLabel(amountType)
	          });
	        })
	      ),
	      calculatedRecord ? _react2.default.createElement(
	        'div',
	        null,
	        calculating ? _react2.default.createElement(_materialUi.CircularProgress, { style: { marginRight: 16, lineHeight: '24px' }, size: 24, thickness: 2 }) :
	        // eslint-disable-next-line react/jsx-indent
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '20px' } },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiemCalculated' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: tableStyle },
	            _react2.default.createElement(
	              'div',
	              { style: labelColumn },
	              (0, _lodash.get)(calculatedRecord, 'Currency') !== 'ISK' ? _react2.default.createElement(
	                'div',
	                { style: rowStyle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiemCalculated.ExchangeRate', values: { currency: (0, _lodash.get)(calculatedRecord, 'Currency') } })
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { style: rowStyle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiemCalculated.Days' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: rowStyle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiemCalculated.TotalAmountCurrency', values: { currency: (0, _lodash.get)(calculatedRecord, 'Currency') } })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: rowStyle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiemCalculated.TotalAmountISK' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: rowStyle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiemCalculated.EstimatedTaxISK' })
	              ),
	              (0, _lodash.get)(calculatedRecord, 'PaymentCurrency', 'None') === 'None' ? null : _react2.default.createElement(
	                'div',
	                { style: rowStyle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiemCalculated.TotalAmountPrepaidPaymentCurrency', values: { currency: (0, _lodash.get)(calculatedRecord, 'PaymentCurrency') } })
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { style: { width: '50%' } },
	              (0, _lodash.get)(calculatedRecord, 'Currency') !== 'ISK' ? _react2.default.createElement(
	                'div',
	                { style: rowStyle },
	                unitRender((0, _lodash.get)(calculatedRecord, 'ExchangeRate'))
	              ) : null,
	              _react2.default.createElement(
	                'div',
	                { style: rowStyle },
	                (0, _lodash.get)(calculatedRecord, 'DaysOverride') || (0, _lodash.get)(calculatedRecord, 'Days'),
	                ' '
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: rowStyle },
	                unitRender((0, _lodash.get)(calculatedRecord, 'TotalAmountCurrency'))
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: rowStyle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ISK', values: { amount: currencyRender((0, _lodash.get)(calculatedRecord, 'TotalAmountISK')) } })
	              ),
	              _react2.default.createElement(
	                'div',
	                { style: rowStyle },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ISK', values: { amount: currencyRender((0, _lodash.get)(calculatedRecord, 'EstimatedTaxISK')) } })
	              ),
	              (0, _lodash.get)(calculatedRecord, 'PaymentCurrency', 'None') === 'None' ? null : _react2.default.createElement(
	                'div',
	                { style: rowStyle },
	                unitRender((0, _lodash.get)(calculatedRecord, 'TotalAmountPrepaidISK') / (0, _lodash.get)(calculatedRecord, 'PaymentExchangeRate'))
	              )
	            )
	          )
	        )
	      ) : null,
	      _react2.default.createElement(_materialUi.TextField, {
	        id: 'RequestDescription',
	        type: 'text',
	        multiLine: true,
	        fullWidth: true,
	        floatingLabelFixed: true,
	        floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: commentRequired ? 'PerDiemComment.Custom' : 'comment' }),
	        errorText: errors.RequestDescription && commentRequired ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : '',
	        onChange: function onChange(event) {
	          return setComment(event.target.value);
	        }
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', justifyContent: 'flex-end', marginTop: 20 } },
	        _react2.default.createElement(_materialUi.FlatButton, {
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.cancel' }),
	          secondary: true,
	          onClick: function onClick() {
	            return closeDialog();
	          },
	          disabled: loading
	        }),
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          type: 'submit',
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.create' }),
	          primary: true,
	          onClick: submit,
	          disabled: loading || dateError,
	          loading: '' + loading
	        })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      {
	        style: {
	          height: '100%',
	          display: 'flex',
	          flexDirection: 'column',
	          alignItems: 'center',
	          justifyContent: 'center'
	        }
	      },
	      _react2.default.createElement(_PerDiem3.default, null),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            padding: 8,
	            marginBottom: 12,
	            marginTop: 12,
	            display: 'flex',
	            flexDirection: 'row'
	          }
	        },
	        _react2.default.createElement(
	          _materialUi.FontIcon,
	          { style: { marginRight: 8 }, color: _colors2.default.infoColor, className: 'material-icons' },
	          'info'
	        ),
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiem.Description' })
	      ),
	      _react2.default.createElement(_materialUi.RaisedButton, {
	        primary: true,
	        style: { marginBottom: 12 },
	        onClick: openDialog,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'PerDiem.Button' })
	      })
	    )
	  );
	};
	
	TPerDiem.propTypes = {
	  DefaultEmployeeDetailID: _propTypes2.default.number.isRequired
	};
	
	function mapStateToProps(state) {
	  return {
	    DefaultEmployeeDetailID: state.loginReducer.user.DefaultEmployeeDetailID
	  };
	}
	
	var _default = (0, _reactRedux.connect)(mapStateToProps)(TPerDiem);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(labelStyle, 'labelStyle', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPerDiem.js');
	
	  __REACT_HOT_LOADER__.register(errorStyle, 'errorStyle', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPerDiem.js');
	
	  __REACT_HOT_LOADER__.register(tableStyle, 'tableStyle', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPerDiem.js');
	
	  __REACT_HOT_LOADER__.register(rowStyle, 'rowStyle', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPerDiem.js');
	
	  __REACT_HOT_LOADER__.register(labelColumn, 'labelColumn', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPerDiem.js');
	
	  __REACT_HOT_LOADER__.register(isNumeric, 'isNumeric', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPerDiem.js');
	
	  __REACT_HOT_LOADER__.register(unitRender, 'unitRender', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPerDiem.js');
	
	  __REACT_HOT_LOADER__.register(currencyRender, 'currencyRender', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPerDiem.js');
	
	  __REACT_HOT_LOADER__.register(TPerDiem, 'TPerDiem', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPerDiem.js');
	
	  __REACT_HOT_LOADER__.register(mapStateToProps, 'mapStateToProps', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPerDiem.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TPerDiem.js');
	}();

	;

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _Divider = __webpack_require__(593);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _lodash = __webpack_require__(8);
	
	var _profile = __webpack_require__(118);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _KListItem = __webpack_require__(184);
	
	var _KListItem2 = _interopRequireDefault(_KListItem);
	
	var _TProfile = __webpack_require__(1028);
	
	var _TProfile2 = _interopRequireDefault(_TProfile);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _KAvatar = __webpack_require__(183);
	
	var _KAvatar2 = _interopRequireDefault(_KAvatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TProfile = function TProfile() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.profileReducer;
	  }),
	      employeeMasterLoaded = _useSelector.employeeMasterLoaded,
	      employeeDetailOrgListLoaded = _useSelector.employeeDetailOrgListLoaded,
	      detailError = _useSelector.detailError,
	      masterError = _useSelector.masterError,
	      employeeDetailOrgList = _useSelector.employeeDetailOrgList,
	      employeeMaster = _useSelector.employeeMaster;
	
	  var _useSelector2 = (0, _reactRedux.useSelector)(function (state) {
	    return state.WebValuesReducer;
	  }),
	      valuesByKey = _useSelector2.valuesByKey;
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _profile.fetchProfileIfNeeded)());
	  }, []);
	
	  if (!(employeeMasterLoaded && employeeDetailOrgListLoaded)) {
	    return _react2.default.createElement(_TLoading2.default, null);
	  }
	
	  if (detailError || masterError) {
	    return _react2.default.createElement(_TMessage2.default, { type: 'error', message: 'tile.profile.error' });
	  }
	
	  var employeeDetailOrg = (0, _lodash.find)(employeeDetailOrgList, function (d) {
	    return d.EmployeeDetailID === employeeMaster.DefaultEmployeeDetailID;
	  });
	
	  var show = function show(key) {
	    return (0, _lodash.get)(valuesByKey, ['Hide.' + key, 'Value']) !== 'true';
	  };
	
	  var search = function search(val) {
	    dispatch((0, _reactRouterRedux.push)('/search?query=' + val));
	  };
	
	  var getText = function getText(key) {
	    return (0, _lodash.get)(employeeDetailOrg, key, '');
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { style: _TProfile2.default.container },
	    _react2.default.createElement(
	      'div',
	      { style: _TProfile2.default.head },
	      _react2.default.createElement(_KAvatar2.default, {
	        imgSrc: employeeMaster.ImageUrl,
	        masterId: employeeMaster.EmployeeMasterID,
	        size: 50,
	        dataCy: 'EmployeeMaster.ImageUrl'
	      }),
	      _react2.default.createElement(_KTitle2.default, {
	        title: employeeMaster.EmployeeName,
	        style: _TProfile2.default.title,
	        dataCy: 'EmployeeMaster.EmployeeName'
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: _TProfile2.default.listContainer },
	      show('EmployeeDetailOrg.OrgCompanyPositionName') && _react2.default.createElement(_KListItem2.default, {
	        primaryText: getText('OrgCompanyPositionName'),
	        secondaryText: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.profile.position' })
	        ),
	        'data-cy': 'EmployeeDetailOrg.OrgCompanyPositionName',
	        onClick: function onClick() {
	          return search(getText('OrgCompanyPositionName'));
	        }
	      }),
	      show('EmployeeDetailOrg.OrgCompanyUnitName') && _react2.default.createElement(_KListItem2.default, {
	        primaryText: getText('OrgCompanyUnitName'),
	        secondaryText: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.profile.unit' })
	        ),
	        'data-cy': 'EmployeeDetailOrg.OrgCompanyUnitName',
	        onClick: function onClick() {
	          return search(getText('OrgCompanyUnitName'));
	        }
	      }),
	      show('EmployeeDetailOrg.OrgCompanyUnitDivisionName') && _react2.default.createElement(_KListItem2.default, {
	        primaryText: getText('OrgCompanyUnitDivisionName'),
	        secondaryText: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.profile.division' })
	        ),
	        'data-cy': 'EmployeeDetailOrg.OrgCompanyUnitDivisionName',
	        onClick: function onClick() {
	          return search(getText('OrgCompanyUnitDivisionName'));
	        }
	      }),
	      show('EmployeeDetailOrg.ManagerName') && (0, _lodash.get)(employeeDetailOrg, 'ManagerName', '') && _react2.default.createElement(_KListItem2.default, {
	        primaryText: getText('ManagerName'),
	        secondaryText: _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.profile.manager' })
	        ),
	        'data-cy': 'EmployeeDetailOrg.ManagerName',
	        onClick: function onClick() {
	          return search(getText('ManagerName'));
	        }
	      })
	    ),
	    _react2.default.createElement(_Divider2.default, { key: 'div' }),
	    _react2.default.createElement(_KFlatButton2.default, {
	      style: _TProfile2.default.actionButton,
	      onClick: function onClick() {
	        return dispatch((0, _reactRouterRedux.push)('/me'));
	      },
	      containerStyle: _TProfile2.default.action,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.profile.goto' })
	    })
	  );
	};
	
	var _default = TProfile;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TProfile, 'TProfile', 'D:/a/1/s/src/web/employee/src/containers/tiles/TProfile.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TProfile.js');
	}();

	;

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _TBenefits = __webpack_require__(74);
	
	var _TBenefits2 = _interopRequireDefault(_TBenefits);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	var _actions = __webpack_require__(149);
	
	var _PunchInTime = __webpack_require__(1010);
	
	var _PunchInTime2 = _interopRequireDefault(_PunchInTime);
	
	var _ExpectedHours = __webpack_require__(290);
	
	var _ExpectedHours2 = _interopRequireDefault(_ExpectedHours);
	
	var _Clock = __webpack_require__(1007);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TTime = function TTime() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.timeReducer;
	  }),
	      openEntryFetching = _useSelector.openEntryFetching,
	      openEntryFetched = _useSelector.openEntryFetched,
	      openEntryError = _useSelector.openEntryError,
	      openEntry = _useSelector.openEntry,
	      openEntryErrorMessage = _useSelector.openEntryErrorMessage,
	      isPunching = _useSelector.isPunching,
	      isPunchedIn = _useSelector.isPunchedIn,
	      initializeFailed = _useSelector.initializeFailed,
	      initializing = _useSelector.initializing,
	      hasError = _useSelector.hasError,
	      error = _useSelector.error;
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _actions.fetchOpenEntry)());
	    dispatch((0, _actions.initialize)());
	  }, []);
	
	  if (openEntryFetching || !openEntryFetched && !openEntryError || initializing) {
	    return _react2.default.createElement(_TLoading2.default, null);
	  }
	  if (openEntryError || hasError || initializeFailed) {
	    return _react2.default.createElement(_TMessage2.default, { type: 'error', message: 'tile.error', values: { error: openEntryErrorMessage || error } });
	  }
	  return _react2.default.createElement(
	    'div',
	    { style: _TBenefits2.default.container, 'data-cy': 'entries' },
	    _react2.default.createElement(
	      'div',
	      { style: {
	          maxHeight: 422, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'
	        }
	      },
	      _react2.default.createElement(_ExpectedHours2.default, null),
	      _react2.default.createElement(
	        'div',
	        { style: {
	            flex: 1, flexDirection: 'column', display: 'flex', alignItems: 'center', justifyContent: 'center'
	          }
	        },
	        _react2.default.createElement(_Clock2.default, null),
	        _react2.default.createElement(
	          'div',
	          { style: { marginTop: 24, textAlign: 'center' } },
	          isPunchedIn ? _react2.default.createElement(_materialUi.RaisedButton, { style: { marginBottom: 24 }, secondary: true, icon: _react2.default.createElement(
	              _materialUi.FontIcon,
	              { className: 'material-icons' },
	              'alarm_off'
	            ), label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.PunchOut' }), onClick: function onClick() {
	              return dispatch((0, _actions.punchInOut)());
	            }, disabled: isPunching }) : _react2.default.createElement(_materialUi.RaisedButton, { primary: true, style: { marginBottom: 24 }, icon: _react2.default.createElement(
	              _materialUi.FontIcon,
	              { className: 'material-icons' },
	              'alarm_on'
	            ), label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.PunchIn' }), onClick: function onClick() {
	              return dispatch((0, _actions.punchInOut)());
	            }, disabled: isPunching }),
	          _react2.default.createElement(
	            'div',
	            { style: { height: 28 } },
	            isPunchedIn ? _react2.default.createElement(_PunchInTime2.default, { openEntry: openEntry }) : null
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_materialUi.Divider, { style: { marginTop: 'auto' } }),
	    _react2.default.createElement(_KFlatButton2.default, {
	      'data-cy': 'time-button',
	      style: _TBenefits2.default.actionButton,
	      onClick: function onClick() {
	        return dispatch((0, _reactRouterRedux.push)('/time'));
	      },
	      containerStyle: _TBenefits2.default.action,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.time.goto' })
	    })
	  );
	};
	
	var _default = TTime;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TTime, 'TTime', 'D:/a/1/s/src/web/employee/src/containers/tiles/TTime.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TTime.js');
	}();

	;

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _TBenefits = __webpack_require__(74);
	
	var _TBenefits2 = _interopRequireDefault(_TBenefits);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	var _actions = __webpack_require__(149);
	
	var _ExpectedHours = __webpack_require__(290);
	
	var _ExpectedHours2 = _interopRequireDefault(_ExpectedHours);
	
	var _EntryModal = __webpack_require__(448);
	
	var _EntryModal2 = _interopRequireDefault(_EntryModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TTimeEntries = function TTimeEntries(_ref) {
	  var valuesByKey = _ref.valuesByKey;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      modalOpen = _useState2[0],
	      setModalOpen = _useState2[1];
	
	  var closeModal = function closeModal() {
	    return setModalOpen(false);
	  };
	  var openModal = function openModal() {
	    return setModalOpen(true);
	  };
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.timeReducer;
	  }),
	      openEntryFetching = _useSelector.openEntryFetching,
	      openEntryFetched = _useSelector.openEntryFetched,
	      openEntryError = _useSelector.openEntryError,
	      openEntryErrorMessage = _useSelector.openEntryErrorMessage,
	      isPunching = _useSelector.isPunching,
	      initializeFailed = _useSelector.initializeFailed,
	      initializing = _useSelector.initializing,
	      hasError = _useSelector.hasError,
	      error = _useSelector.error,
	      entries = _useSelector.entries;
	
	  var entriesByDate = (0, _lodash.groupBy)((0, _lodash.map)(entries, function (entry) {
	    return _extends({}, entry, { date: (0, _moment2.default)(entry.ClockIn).format('DD/MM/YY') });
	  }), 'date');
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _actions.fetchOpenEntry)());
	    dispatch((0, _actions.initialize)());
	  }, []);
	
	  if (openEntryFetching || !openEntryFetched && !openEntryError || initializing) {
	    return _react2.default.createElement(_TLoading2.default, null);
	  }
	  if (openEntryError || hasError || initializeFailed) {
	    return _react2.default.createElement(_TMessage2.default, { type: 'error', message: 'tile.error', values: { error: openEntryErrorMessage || error } });
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: _TBenefits2.default.container, 'data-cy': 'entries' },
	    _react2.default.createElement(_EntryModal2.default, {
	      modalState: modalOpen,
	      closeModal: closeModal,
	      selectedEntries: [],
	      entriesByDate: entriesByDate
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: {
	          maxHeight: 422, height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'
	        }
	      },
	      (0, _lodash.get)(valuesByKey, ['Hide.TimeEntries.ExpectedHours', 'Value']) !== 'true' ? _react2.default.createElement(_ExpectedHours2.default, null) : null,
	      _react2.default.createElement(
	        'div',
	        { style: {
	            flex: 1, flexDirection: 'column', display: 'flex', alignItems: 'center', justifyContent: 'center'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { style: { marginTop: 24, textAlign: 'center' } },
	          _react2.default.createElement(_materialUi.RaisedButton, { primary: true, style: { marginBottom: 24 }, icon: _react2.default.createElement(
	              _materialUi.FontIcon,
	              { className: 'material-icons' },
	              'alarm_on'
	            ), label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.CreateEntry' }), onClick: openModal, disabled: isPunching })
	        )
	      )
	    ),
	    _react2.default.createElement(_materialUi.Divider, { style: { marginTop: 'auto' } }),
	    _react2.default.createElement(_KFlatButton2.default, {
	      'data-cy': 'time-button',
	      style: _TBenefits2.default.actionButton,
	      onClick: function onClick() {
	        return dispatch((0, _reactRouterRedux.push)('/time'));
	      },
	      containerStyle: _TBenefits2.default.action,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.time.goto' })
	    })
	  );
	};
	TTimeEntries.propTypes = {
	  valuesByKey: _propTypes2.default.object
	};
	
	var _default = (0, _reactRedux.connect)(function (state) {
	  return { valuesByKey: state.WebValuesReducer.valuesByKey };
	})(TTimeEntries);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TTimeEntries, 'TTimeEntries', 'D:/a/1/s/src/web/employee/src/containers/tiles/TTimeEntries.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TTimeEntries.js');
	}();

	;

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _TBenefits = __webpack_require__(74);
	
	var _TBenefits2 = _interopRequireDefault(_TBenefits);
	
	var _KFlatButton = __webpack_require__(53);
	
	var _KFlatButton2 = _interopRequireDefault(_KFlatButton);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	var _TLoading = __webpack_require__(50);
	
	var _TLoading2 = _interopRequireDefault(_TLoading);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	var _transportationGrants = __webpack_require__(292);
	
	var _transportationGrants2 = _interopRequireDefault(_transportationGrants);
	
	var _actions = __webpack_require__(452);
	
	var _KListItem = __webpack_require__(184);
	
	var _KListItem2 = _interopRequireDefault(_KListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TTransportationGrants = function TTransportationGrants() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.TransportationGrantReducer;
	  }),
	      transportationGrants = _useSelector.transportationGrants,
	      registerLoadingById = _useSelector.registerLoadingById,
	      grantsLoading = _useSelector.grantsLoading,
	      grantsError = _useSelector.grantsError,
	      registerError = _useSelector.registerError;
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _actions.fetch)());
	  }, []);
	
	  if (grantsLoading) {
	    return _react2.default.createElement(_TLoading2.default, null);
	  }
	  if (grantsError || registerError) {
	    return _react2.default.createElement(_TMessage2.default, { type: 'error', message: 'transportationGrants.error', values: { error: grantsError } });
	  }
	  if (!transportationGrants || !transportationGrants.length) {
	    return _react2.default.createElement(_TMessage2.default, { message: 'transportationGrants.empty' });
	  }
	  if (transportationGrants.length === 1) {
	    var grant = (0, _lodash.head)(transportationGrants);
	    return _react2.default.createElement(_transportationGrants2.default.TransportationGrant, { embed: true, onSubmit: function onSubmit(transportGrant) {
	        return dispatch((0, _actions.register)(transportGrant));
	      }, grant: grant, loaded: registerLoadingById[grant.HrTransportationGrantID] });
	  }
	  return _react2.default.createElement(
	    'div',
	    { style: _TBenefits2.default.container },
	    _react2.default.createElement(
	      'div',
	      { style: { maxHeight: 422, overflow: 'auto', height: '100%' } },
	      (0, _lodash.map)(transportationGrants, function (grant, key) {
	        return _react2.default.createElement(
	          'div',
	          { key: key },
	          _react2.default.createElement(_KListItem2.default, {
	            innerDivStyle: _TBenefits2.default.link,
	            primaryText: grant.HrTransportationGrantName,
	            secondaryText: grant.Previous ? (0, _dateTools2.default)(grant.Previous.Begda) + ' - ' + (0, _dateTools2.default)(grant.Previous.Endda) : _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'unused' })
	            ),
	            hoverColor: 'transparent',
	            onClick: function onClick() {
	              return dispatch((0, _reactRouterRedux.push)('/transportation'));
	            }
	          }),
	          _react2.default.createElement(_materialUi.Divider, { key: 'div', style: _TBenefits2.default.spacer })
	        );
	      })
	    ),
	    _react2.default.createElement(_KFlatButton2.default, {
	      'data-cy': 'transportation-grants-button',
	      style: _TBenefits2.default.actionButton,
	      onClick: function onClick() {
	        return dispatch((0, _reactRouterRedux.push)('/transportation'));
	      },
	      containerStyle: _TBenefits2.default.action,
	      label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.transportations.goto' })
	    })
	  );
	};
	
	var _default = TTransportationGrants;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TTransportationGrants, 'TTransportationGrants', 'D:/a/1/s/src/web/employee/src/containers/tiles/TTransportationGrants.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/TTransportationGrants.js');
	}();

	;

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  container: {
	    width: 'calc(100% - 72px)',
	    height: 'calc(100% - 26px)',
	    paddingLeft: 36,
	    paddingRight: 36,
	    paddingTop: 18,
	    paddingBottom: 8,
	    display: 'flex',
	    flexDirection: 'column'
	  },
	  tag: {
	    fontSize: 14,
	    color: 'white',
	    borderRadius: 4,
	    padding: 6,
	    marginRight: 6,
	    backgroundColor: _colors2.default.successColor
	  },
	  course: {
	    paddingLeft: 0,
	    paddingRight: 0,
	    paddingTop: 12,
	    paddingBottom: 6
	  },
	  secondary: {
	    display: 'flex',
	    alignItems: 'center',
	    height: 40,
	    justifyContent: 'space-between'
	  },
	  action: {
	    flex: '1 1 0',
	    justifyContent: 'center',
	    minHeight: 40,
	    maxHeight: 40
	  },
	  actionButton: {
	    maxWidth: 'none',
	    fontSize: 14
	  }
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/tiles/styles/TEvents.js');
	}();

	;

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/* Create the initial state for the form form the retrieved answers */
	var answersFromAppraisal = function answersFromAppraisal(appraisal, answers) {
	  var QAAnswers = answers.QAAnswers; // state.Appraisal.appraisalAnswers[props.router.params.appraisalId][isManager ? 'managerAnswers' : 'employeeAnswers'];
	
	  var QAElements = appraisal.PMForm.QAElements;
	
	  var storageData = null;
	
	  /*
	      Logic to check if we have saved form data in local storage.
	      If we find data in local storage we prefer to load that
	      since it should only remain in local stoage if saving
	      did not succeed
	    */
	  var appraisalId = appraisal.PMAppraisalID;
	  var _localStorage = localStorage,
	      appraisals = _localStorage.appraisals;
	
	  if (appraisals) {
	    storageData = JSON.parse(appraisals);
	    if (!storageData[appraisalId] || storageData[appraisalId].expires < Date.now()) {
	      storageData = null;
	    } else {
	      storageData = storageData[appraisalId];
	    }
	  }
	
	  var elems = (0, _lodash.map)(QAAnswers, function (_ref) {
	    var _ref4;
	
	    var QAElementID = _ref.QAElementID,
	        QAAnswerText = _ref.QAAnswerText,
	        QAAnswerValue = _ref.QAAnswerValue,
	        QAAnswerComment = _ref.QAAnswerComment;
	
	    var _find = (0, _lodash.find)(QAElements, ['QAElementID', QAElementID]),
	        QAInput = _find.QAInput;
	
	    if (!QAInput) {
	      return {};
	    }
	    var QAInputAnswerType = QAInput.QAInputAnswerType;
	
	    var key = QAInputAnswerType + '-' + QAElementID + (QAInputAnswerType === 3 ? '-' + btoa(QAAnswerText) : '');
	    if (QAInputAnswerType === 3) {
	      var _ref2;
	
	      return _ref2 = {}, _defineProperty(_ref2, key, QAAnswerValue === 'true'), _defineProperty(_ref2, 'COMMENT-' + QAInputAnswerType + '-' + QAElementID, QAAnswerComment), _ref2;
	    } else if (QAInputAnswerType === 2 || QAInputAnswerType === 6) {
	      var _ref3;
	
	      return _ref3 = {}, _defineProperty(_ref3, key, Number(QAAnswerValue)), _defineProperty(_ref3, 'COMMENT-' + QAInputAnswerType + '-' + QAElementID, QAAnswerComment), _ref3;
	    }
	    return _ref4 = {}, _defineProperty(_ref4, key, QAAnswerValue), _defineProperty(_ref4, 'COMMENT-' + QAInputAnswerType + '-' + QAElementID, QAAnswerComment), _ref4;
	  });
	  // Merge the array of fields into one state object.
	  var mergeElems = _lodash.merge.apply(undefined, _toConsumableArray(elems));
	  // saveToStorage(mergeElems, appraisalId);
	  // Check if the
	  return storageData || mergeElems;
	};
	
	var _default = function _default(state, props) {
	  var appraisal = state.Appraisal.appraisalsById[props.router.params.appraisalId];
	  if (!appraisal) {
	    return undefined;
	  }
	  var answers = state.Appraisal.appraisalAnswers[props.router.params.appraisalId];
	  var EmployeeDueDate = appraisal.EmployeeDueDate,
	      ManagerStatus = appraisal.ManagerStatus,
	      EmployeeStatus = appraisal.EmployeeStatus;
	
	  var empDue = new Date(EmployeeDueDate);
	  empDue.setHours(23, 59, 59);
	  var showAnswers = ManagerStatus === 2 && EmployeeStatus === 2 || ManagerStatus === 2 && empDue.getTime() < Date.now();
	  if (showAnswers) {
	    var final = answersFromAppraisal(appraisal, answers.finalAnswers);
	    var manager = answersFromAppraisal(appraisal, answers.managerAnswers);
	    // Merge the manager answers into the final ones.
	    return (0, _lodash.merge)(manager, final);
	  }
	  return answersFromAppraisal(appraisal, answers.employeeAnswers);
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(answersFromAppraisal, 'answersFromAppraisal', 'D:/a/1/s/src/web/employee/src/containers/utils/answersToFormState.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/utils/answersToFormState.js');
	}();

	;

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.closeIcon = exports.openIcon = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openIcon = exports.openIcon = _react2.default.createElement(
	  _materialUi.FontIcon,
	  { style: { fontSize: 18 }, className: 'material-icons' },
	  'open_in_full'
	);
	var closeIcon = exports.closeIcon = _react2.default.createElement(
	  _materialUi.FontIcon,
	  { style: { fontSize: 18 }, className: 'material-icons' },
	  'close_fullscreen'
	);
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(openIcon, 'openIcon', 'D:/a/1/s/src/web/employee/src/containers/utils/icons.js');
	
	  __REACT_HOT_LOADER__.register(closeIcon, 'closeIcon', 'D:/a/1/s/src/web/employee/src/containers/utils/icons.js');
	}();

	;

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(8);
	
	var _default = function _default(values, props) {
	  var error = {};
	  var appraisal = props.appraisalsById[props.router.params.appraisalId];
	  if (!appraisal) {
	    return error;
	  }
	  var questions = appraisal.PMForm.QAElements.filter(function (q) {
	    return q.QAElementType === 3;
	  });
	
	  (0, _lodash.map)(questions, function (_ref) {
	    var QAElementID = _ref.QAElementID,
	        QAInput = _ref.QAInput,
	        MinAnswers = _ref.MinAnswers;
	
	    /* No validation on checkbox questions */
	    if (QAInput.QAInputAnswerType === 3) return;
	    var key = QAInput.QAInputAnswerType + '-' + QAElementID;
	    /* First check if element is required */
	    if (MinAnswers > 0 && !values[key]) {
	      error[key] = 'Þetta svæði verður að vera útfyllt';
	      /* Second check if element has mask */
	    } else if (QAInput && QAInput.QAMaskEntity) {
	      if (QAInput.QAInputAnswerType === 5) return;
	      var _QAInput$QAMaskEntity = QAInput.QAMaskEntity,
	          QAMaskString = _QAInput$QAMaskEntity.QAMaskString,
	          QAMaskDescription = _QAInput$QAMaskEntity.QAMaskDescription;
	      /* Create regex for the mask */
	
	      var re = new RegExp(QAMaskString, 'i');
	      if (!re.test(values[key])) {
	        error[key] = QAMaskDescription;
	      }
	    }
	  });
	
	  return error;
	};
	
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/containers/utils/validateAppraisal.js');
	}();

	;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function SvgComponent(props) {
	  return React.createElement(
	    "svg",
	    _extends({ width: "400", height: "1914", viewBox: "0 0 1914 1914", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
	    React.createElement("path", { d: "M1759.62 121.156H1507.08V384.408H1759.62V121.156Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1742.51 121.156H1489.97V384.408H1742.51V121.156Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M1742.58 384.484H1489.9V121.08H1742.58V384.484ZM1490.05 384.331H1742.43V121.271H1490.05V384.331Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1708.55 156.565H1523.93V349.037H1708.55V156.565Z", fill: "white" }),
	    React.createElement("path", { d: "M1523.93 350.3C1524.08 350.453 1522.32 352.482 1519.37 355.583C1516.42 358.684 1512.29 362.894 1507.62 367.488C1502.99 372.082 1498.7 376.139 1495.56 379.049C1492.42 381.958 1490.39 383.642 1490.24 383.489C1490.09 383.336 1491.81 381.307 1494.76 378.206C1497.71 375.106 1501.88 370.857 1506.51 366.301C1511.18 361.708 1515.43 357.612 1518.61 354.741C1521.78 351.831 1523.77 350.147 1523.93 350.3Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1708.55 349.841C1708.74 349.688 1710.73 351.449 1713.83 354.396C1716.93 357.344 1721.15 361.478 1725.74 366.148C1730.33 370.78 1734.39 375.067 1737.3 378.206C1740.21 381.345 1741.89 383.374 1741.74 383.527C1741.59 383.68 1739.56 381.958 1736.46 379.01C1733.36 376.063 1729.11 371.89 1724.55 367.258C1719.96 362.588 1715.86 358.339 1712.99 355.162C1710.08 351.985 1708.4 349.994 1708.55 349.841Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1708.05 157.063C1707.9 156.871 1709.66 154.881 1712.61 151.78C1715.56 148.679 1719.69 144.469 1724.36 139.875C1728.99 135.281 1733.28 131.224 1736.42 128.314C1739.56 125.405 1741.59 123.721 1741.74 123.874C1741.89 124.027 1740.17 126.018 1737.22 129.157C1734.28 132.257 1730.1 136.506 1725.47 141.062C1720.8 145.655 1716.55 149.751 1713.37 152.622C1710.24 155.532 1708.21 157.254 1708.05 157.063Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1523.43 157.56C1523.24 157.714 1521.25 155.953 1518.15 153.005C1515.05 150.058 1510.84 145.923 1506.24 141.253C1501.65 136.621 1497.59 132.334 1494.68 129.195C1491.77 126.056 1490.09 124.027 1490.24 123.874C1490.39 123.721 1492.38 125.444 1495.52 128.391C1498.62 131.339 1502.87 135.511 1507.43 140.143C1512.02 144.813 1516.12 149.062 1518.99 152.24C1521.9 155.378 1523.62 157.407 1523.43 157.56Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1708.05 349.037C1708.05 349.037 1708.02 348.692 1708.02 348.118C1708.02 347.467 1707.98 346.587 1707.98 345.439C1707.94 343.027 1707.94 339.544 1707.9 335.065C1707.86 325.954 1707.79 312.671 1707.71 295.828C1707.63 262.103 1707.48 214.1 1707.36 156.603L1708.09 157.331C1654.35 157.369 1591.22 157.407 1523.96 157.446L1524.77 156.642C1524.73 227.268 1524.69 293.378 1524.65 349.114L1523.96 348.424C1579.13 348.578 1625.06 348.692 1657.29 348.769C1673.37 348.846 1686.04 348.922 1694.73 348.96C1699.02 348.999 1702.35 349.037 1704.65 349.037C1705.72 349.037 1706.56 349.075 1707.21 349.075C1707.75 348.999 1708.05 348.999 1708.05 349.037C1708.05 349.037 1707.79 349.075 1707.25 349.075C1706.64 349.075 1705.83 349.114 1704.76 349.114C1702.5 349.114 1699.21 349.152 1695 349.19C1686.35 349.228 1673.72 349.305 1657.72 349.381C1625.41 349.458 1579.32 349.573 1523.96 349.726H1523.28V349.037C1523.24 293.301 1523.2 227.23 1523.16 156.565V155.761H1523.96C1591.22 155.8 1654.31 155.838 1708.09 155.876H1708.82V156.603C1708.67 214.291 1708.55 262.486 1708.47 296.287C1708.4 313.054 1708.32 326.26 1708.28 335.333C1708.24 339.773 1708.21 343.218 1708.21 345.592C1708.21 346.702 1708.17 347.544 1708.17 348.195C1708.09 348.769 1708.09 349.037 1708.05 349.037Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1647.04 221.986H1585.44V283.578H1647.04V221.986Z", fill: "#EBEBEB" }),
	    React.createElement("path", { d: "M425.75 178.347H142.555V473.562H425.75V178.347Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M406.571 178.346H123.376V473.562H406.571V178.346Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M406.648 473.638H123.3V178.232H406.648V473.638ZM123.491 473.447H406.495V178.423H123.491V473.447Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M368.521 218.005H161.465V433.827H368.521V218.005Z", fill: "white" }),
	    React.createElement("path", { d: "M161.465 435.282C161.618 435.473 159.666 437.732 156.374 441.215C153.082 444.699 148.411 449.446 143.205 454.575C137.999 459.705 133.214 464.26 129.693 467.514C126.171 470.767 123.874 472.681 123.721 472.49C123.529 472.299 125.482 470.078 128.812 466.557C132.104 463.073 136.774 458.326 142.019 453.197C147.225 448.067 152.048 443.474 155.57 440.22C159.015 437.005 161.274 435.091 161.465 435.282Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M368.521 434.746C368.713 434.593 370.971 436.545 374.455 439.837C377.938 443.129 382.685 447.799 387.814 453.006C392.944 458.212 397.499 462.997 400.753 466.518C404.007 470.04 405.921 472.337 405.729 472.49C405.538 472.681 403.318 470.729 399.796 467.399C396.312 464.107 391.566 459.437 386.436 454.192C381.307 448.986 376.713 444.163 373.459 440.641C370.205 437.196 368.33 434.937 368.521 434.746Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M367.947 218.579C367.794 218.387 369.746 216.129 373.038 212.645C376.33 209.162 381 204.415 386.206 199.286C391.412 194.156 396.197 189.601 399.719 186.347C403.241 183.093 405.538 181.179 405.691 181.371C405.882 181.562 403.93 183.782 400.6 187.304C397.308 190.788 392.637 195.534 387.393 200.664C382.187 205.793 377.364 210.387 373.842 213.641C370.359 216.895 368.1 218.808 367.947 218.579Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M160.891 219.115C160.7 219.268 158.441 217.316 154.958 214.024C151.474 210.731 146.728 206.061 141.598 200.855C136.469 195.649 131.913 190.864 128.659 187.342C125.406 183.821 123.492 181.524 123.683 181.371C123.874 181.179 126.095 183.132 129.616 186.462C133.1 189.754 137.847 194.424 142.976 199.669C148.106 204.875 152.699 209.698 155.953 213.22C159.169 216.703 161.083 218.962 160.891 219.115Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M367.947 433.866C367.947 433.866 367.909 433.483 367.909 432.832C367.909 432.105 367.87 431.109 367.87 429.808C367.832 427.09 367.832 423.224 367.794 418.171C367.756 407.95 367.679 393.059 367.602 374.187C367.488 336.366 367.373 282.545 367.181 218.043L367.985 218.847C307.694 218.885 236.915 218.923 161.503 218.962H161.465L162.383 218.043C162.345 297.244 162.307 371.393 162.269 433.866L161.465 433.062C223.325 433.215 274.85 433.368 310.986 433.445C329.016 433.521 343.218 433.598 352.979 433.636C357.803 433.674 361.516 433.712 364.081 433.712C365.306 433.751 366.263 433.751 366.952 433.751C367.602 433.827 367.909 433.827 367.947 433.866C367.947 433.866 367.641 433.904 367.028 433.904C366.339 433.904 365.42 433.942 364.234 433.942C361.669 433.98 358.032 433.98 353.286 434.019C343.563 434.057 329.437 434.134 311.484 434.21C275.233 434.325 223.555 434.44 161.465 434.631H160.661V433.827C160.622 371.316 160.584 297.206 160.546 218.005V217.086H161.465H161.503C236.915 217.124 307.694 217.163 367.985 217.201H368.789V218.005C368.636 282.698 368.483 336.711 368.368 374.646C368.291 393.442 368.215 408.256 368.177 418.439C368.138 423.415 368.1 427.281 368.1 429.923C368.1 431.186 368.062 432.143 368.062 432.832C367.985 433.559 367.947 433.866 367.947 433.866Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M299.541 291.387H230.445V360.483H299.541V291.387Z", fill: "#EBEBEB" }),
	    React.createElement("path", { d: "M210.425 1433.09C192.165 1421.64 171.264 1414.45 149.828 1412.23C139.913 1411.19 129.118 1411.5 121.156 1417.51C119.472 1418.77 117.826 1420.65 118.208 1422.75C118.476 1424.28 119.778 1425.39 121.003 1426.35C145.655 1445.11 182.978 1447.48 210.425 1433.09Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M208.856 1431.37C195.151 1420.65 181.332 1409.89 169.733 1396.91C158.096 1383.98 148.679 1368.59 145.196 1351.55C144.124 1346.38 143.818 1340.49 147.148 1336.35C178.308 1360.74 202.846 1392.24 208.856 1431.37Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M210.081 1432.86C207.746 1415.79 206.904 1398.25 210.808 1381.49C214.713 1364.72 223.862 1348.64 238.178 1339.07C243.576 1351.67 241.241 1366.17 237.451 1379.34C231.594 1399.71 222.369 1419.08 210.311 1436.5", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M240.666 1487.64C222.101 1489.9 205.947 1499.7 192.089 1512.25C178.232 1524.81 168.356 1541.73 164.298 1559.99C182.519 1558.88 197.946 1546.01 209.162 1531.62C220.378 1517.23 228.111 1501.42 240.437 1487.94", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M247.327 1496.4C232.359 1459.58 237.795 1415.17 261.184 1383.02C271.749 1420.69 267.845 1463.18 247.327 1496.4Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M287.713 1544.52C270.87 1543.49 253.72 1547.51 239.097 1555.93C224.474 1564.35 212.378 1577.14 204.837 1592.26C203.803 1594.32 202.885 1596.93 204.263 1598.76C205.449 1600.37 207.784 1600.53 209.775 1600.37C226.12 1599.3 240.59 1589.5 252.534 1578.28C264.477 1567.11 274.889 1554.17 288.096 1544.48", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M286.45 1541.92C277.76 1514.13 277.224 1483.81 284.918 1455.71C287.943 1444.61 293.072 1432.94 303.331 1427.73C304.212 1427.27 305.245 1426.89 306.164 1427.23C307.044 1427.58 307.542 1428.46 307.925 1429.3C311.561 1436.92 312.633 1445.57 312.25 1454.03C311.868 1462.49 310.107 1470.79 308.384 1479.06C305.169 1494.37 303.446 1510.8 295.024 1524C293.034 1527.14 291.273 1530.51 289.703 1533.88C288.096 1537.25 288.096 1538.4 286.641 1541.08", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M393.404 1557.84C385.48 1527.72 393.901 1491.16 412.888 1466.43C414.305 1464.59 416.142 1462.68 418.439 1462.87C421.922 1463.18 422.841 1467.85 422.688 1471.37C421.31 1502.18 411.012 1532.54 393.404 1557.84Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M403.05 1564.43C439.684 1573.96 481.677 1564.7 512.148 1542.22C494.08 1533.08 472.834 1530.47 453.082 1534.99C433.368 1539.51 415.338 1548.35 403.05 1564.43Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M411.165 1544.37C431.683 1510.91 470.997 1489.09 510.195 1487.1C505.678 1503.03 492.587 1515.43 477.811 1522.89C463.034 1530.36 446.536 1533.65 430.267 1536.79C423.951 1538.05 415.299 1539.39 411.165 1544.37Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M395.433 1446.98C400.983 1427.96 406.572 1408.74 408.103 1388.99C409.634 1369.24 406.802 1348.6 396.543 1331.65C377.403 1368.7 375.45 1412.03 394.858 1448.97", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M459.935 1414.37C482.328 1373.64 528.035 1341.14 574.315 1336.55C556.477 1380.99 507.823 1415.33 459.935 1414.37Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M445.848 1422.37C479.266 1427.46 507.746 1448.78 538.945 1461.72C545.605 1464.48 552.84 1466.7 559.999 1465.74C567.157 1464.78 574.239 1460 575.847 1452.96C577.186 1447.1 574.507 1440.9 570.334 1436.61C566.123 1432.32 560.573 1429.64 555.06 1427.35C521.068 1413.18 484.587 1412.84 448.757 1421.41", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M426.516 1445.8C434.095 1447.98 436.66 1451.88 442.67 1456.97C462.997 1474.28 487.381 1486.8 513.258 1493.26C515.938 1493.92 519.498 1494.18 520.838 1491.77C521.986 1489.63 520.531 1487.06 519 1485.19C508.129 1471.6 492.664 1462.33 476.356 1456.25C460.049 1450.16 445.962 1442.85 426.478 1444.42", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M404.696 1304.24C431.875 1329.62 470.155 1342.63 507.134 1339.11C508.818 1338.96 510.655 1338.69 511.804 1337.43C514.368 1334.63 511.306 1330.31 508.282 1327.93C478.156 1304.47 441.675 1294.74 404.696 1304.24Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M430.573 1294.78C466.48 1267.87 515.746 1259.72 558.39 1273.69C542.274 1289.54 519.957 1298.07 497.487 1300.45C475.016 1302.78 452.508 1300.26 430.573 1294.78Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M420.276 1229.74C417.329 1199.7 419.243 1175.96 417.137 1145.76C416.984 1143.35 416.448 1140.44 414.19 1139.56C411.051 1138.33 408.409 1142.2 407.414 1145.41C398.457 1173.24 403.356 1205.21 420.238 1229.09", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M418.133 1233.04C438.498 1220.44 453.81 1203.98 467.935 1184.65C477.773 1171.18 486.08 1155.06 483.821 1138.56C470.002 1138.29 456.872 1145.91 447.915 1156.4C438.919 1166.89 433.598 1180.02 429.617 1193.23C425.597 1206.47 422.803 1220.06 418.133 1233.04Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M467.054 1219.45C511.765 1202.91 553.49 1178.3 589.627 1147.18C575.004 1141.28 558.237 1144.8 543.576 1150.7C510.119 1164.21 482.825 1186.99 466.403 1219.1", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M431.875 1249.5C454.498 1251.99 477.467 1253.59 499.937 1249.84C521.986 1246.17 542.849 1237.4 563.482 1228.75C565.204 1228.02 567.042 1227.18 567.807 1225.46C568.611 1223.62 567.769 1221.36 566.276 1220.02C564.783 1218.68 562.793 1218.03 560.84 1217.5C538.408 1211.22 514.254 1214.16 492.204 1221.59C470.117 1229.02 452.01 1237.86 431.875 1249.5Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M302.68 1305.27C287.254 1274.11 288.249 1237.75 301.57 1205.63C310.949 1219.95 312.097 1238.13 310.375 1255.16C308.652 1272.2 303.484 1289.69 303.14 1306.8", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M241.049 1274.19C202.501 1273.46 163.953 1289.88 137.808 1318.17C157.024 1321.2 176.853 1316.22 194.347 1307.68C211.841 1299.15 227.383 1287.17 242.81 1275.26", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M199.592 1260.29C180.758 1258.76 162.613 1256.43 144.469 1261.98C126.324 1267.53 109.864 1280.12 102.476 1297.62C120.123 1299.61 137.999 1295.17 154.154 1287.85C170.269 1280.54 184.969 1270.4 199.592 1260.29Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M260.955 1260.94C243.997 1249.84 226.579 1238.51 206.827 1233.92C187.074 1229.32 164.183 1232.73 150.44 1247.58C166.441 1256.96 185.811 1258.07 204.339 1258.07C222.866 1258.07 245.605 1257.84 263.06 1264.04", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M261.069 1261.82C232.091 1233.34 221.067 1182.2 232.742 1143.27C255.519 1177.91 265.74 1220.63 261.069 1261.82Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M340.769 1181.17C346.243 1168.46 350.071 1155.1 354.97 1142.16C359.87 1129.22 365.957 1116.47 375.259 1106.22C384.523 1095.96 397.346 1088.3 411.166 1087.61C402.514 1126.77 376.484 1161.8 341.458 1181.36", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M326.375 1197.97C317.341 1185.53 306.852 1168.61 294.603 1159.31C282.315 1150.01 266.352 1144.38 251.385 1147.94C266.582 1175.2 295.368 1194.37 326.375 1197.97Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M329.246 1182.2C323.313 1167.12 317.341 1151.88 314.929 1135.88C312.518 1119.88 313.972 1102.77 322.164 1088.8C338.089 1118.89 343.218 1151.19 330.012 1182.55", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M340.922 1088.8C349.918 1058.98 377.25 1037.01 406.725 1026.94C410.438 1025.67 414.381 1024.6 418.247 1025.21C422.114 1025.83 425.942 1028.47 426.746 1032.3C427.817 1037.39 423.645 1041.9 419.702 1045.27C396.772 1064.91 369.785 1079.8 340.922 1088.8Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M341.266 1064.38C342.415 1045.16 343.601 1025.64 349.879 1007.41C356.119 989.193 368.177 972.121 385.709 964.12C388.695 983.528 380.12 1002.86 369.785 1019.59C359.449 1036.32 347.008 1052.09 340.769 1070.73", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M340.769 1077.62C333.304 1055.88 332.538 1028.28 319.523 1009.33C310.413 996.084 295.866 987.088 288.019 973.039C282.813 986.131 284.42 1001.21 289.856 1014.23C295.292 1027.24 304.288 1038.42 313.934 1048.68C323.581 1059.02 331.849 1066.75 340.769 1077.62Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M340.922 1717.74C340.348 1717.74 339.85 1572.73 339.812 1393.93C339.774 1215.05 340.195 1070.08 340.769 1070.08C341.343 1070.08 341.841 1215.05 341.879 1393.93C341.956 1572.73 341.496 1717.74 340.922 1717.74Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M467.628 1283.38C467.666 1283.53 465.714 1284.22 462.192 1285.4C458.288 1286.74 453.235 1288.43 447.187 1290.46C434.554 1294.78 417.175 1301.02 398.303 1308.75C379.622 1316.76 362.014 1323.26 351.984 1331.95C346.97 1336.24 344.098 1340.87 342.682 1344.28C341.227 1347.69 340.998 1349.75 340.806 1349.71C340.73 1349.71 340.768 1349.18 340.883 1348.18C341.036 1347.19 341.304 1345.73 341.955 1343.97C343.18 1340.41 345.974 1335.44 351.027 1330.84C356.08 1326.25 363.085 1322.11 371.124 1318.36C379.163 1314.61 388.082 1310.71 397.537 1306.8C416.448 1299.03 433.98 1293.02 446.765 1289.04C453.158 1287.05 458.364 1285.6 462.001 1284.6C465.599 1283.72 467.59 1283.26 467.628 1283.38Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M509.162 1181.36C509.201 1181.4 508.665 1181.97 507.631 1183.01C506.406 1184.15 504.875 1185.61 502.961 1187.37C498.635 1191.31 492.74 1196.63 485.582 1203.14C470.576 1216.5 450.249 1234.61 427.779 1254.63C405.194 1274.72 385.709 1293.9 372.196 1308.37C365.421 1315.61 360.1 1321.58 356.463 1325.75C354.779 1327.7 353.363 1329.27 352.253 1330.54C351.296 1331.61 350.721 1332.18 350.683 1332.14C350.645 1332.11 351.066 1331.45 351.908 1330.27C352.788 1329.12 354.052 1327.36 355.813 1325.22C359.258 1320.89 364.426 1314.73 371.086 1307.38C384.369 1292.64 403.739 1273.19 426.363 1253.1C449.024 1233.04 469.619 1215.05 484.586 1202.07C491.936 1195.75 497.985 1190.58 502.387 1186.79C504.377 1185.15 505.985 1183.81 507.287 1182.74C508.512 1181.78 509.124 1181.32 509.162 1181.36Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M403.472 1275.07C402.897 1274.8 407.606 1263.93 412.276 1250.15C417.023 1236.37 419.243 1224.77 419.855 1224.85C420.391 1224.88 419.051 1236.87 414.266 1250.8C411.893 1257.77 409.29 1263.89 407.261 1268.22C405.194 1272.58 403.701 1275.18 403.472 1275.07Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M341.075 1362.81C340.96 1362.88 339.735 1361.47 337.591 1358.79C335.218 1355.76 332.232 1351.93 328.672 1347.38C321.169 1337.69 310.834 1324.37 299.235 1309.75C287.636 1295.13 276.956 1282.04 269.262 1272.54C265.625 1268.02 262.563 1264.27 260.151 1261.29C258.007 1258.61 256.897 1257.08 257.012 1257C257.127 1256.92 258.467 1258.26 260.763 1260.79C263.099 1263.32 266.391 1266.99 270.372 1271.62C278.372 1280.89 289.244 1293.86 300.843 1308.49C312.441 1323.11 322.624 1336.62 329.821 1346.54C333.419 1351.48 336.29 1355.53 338.204 1358.37C340.156 1361.12 341.19 1362.73 341.075 1362.81Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M313.284 1327.17C312.939 1327.55 305.513 1318.75 301.646 1305.39C298.775 1295.97 298.661 1287.36 299.005 1283.41L299.924 1283.49C299.503 1285.17 299.197 1286.05 299.043 1286.02C298.89 1285.98 298.852 1285.06 299.005 1283.34L299.924 1283.41C300.268 1287.32 300.843 1295.62 303.637 1304.77C307.388 1317.71 313.858 1326.78 313.284 1327.17Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M277.415 1282.04C277.147 1282.34 274.774 1279.32 269.3 1277.33C263.864 1275.22 255.71 1274.76 246.753 1275.53C237.795 1276.18 229.756 1277.79 224.014 1279.2C218.272 1280.62 214.789 1281.73 214.674 1281.46C214.598 1281.23 217.928 1279.59 223.632 1277.79C229.335 1275.99 237.451 1274.11 246.6 1273.46C255.672 1272.7 264.247 1273.38 269.874 1275.99C275.539 1278.48 277.606 1282 277.415 1282.04Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M268.917 1271.09C268.763 1271.43 264.17 1269.17 256.476 1266.57C248.781 1263.93 237.795 1261.13 225.431 1260.18C213.028 1259.26 201.773 1260.33 193.735 1261.79C185.696 1263.24 180.834 1264.73 180.758 1264.39C180.719 1264.24 181.868 1263.78 184.05 1262.97C186.194 1262.17 189.409 1261.25 193.467 1260.33C201.506 1258.49 212.99 1257.15 225.584 1258.07C238.178 1259.07 249.317 1262.13 257.012 1265.15C260.84 1266.65 263.902 1268.06 265.892 1269.17C267.883 1270.32 268.993 1270.97 268.917 1271.09Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M340.769 1224.85C340.195 1225 336.137 1210.87 331.697 1193.3C327.256 1175.73 324.079 1161.38 324.653 1161.26C325.227 1161.11 329.285 1175.23 333.725 1192.8C338.204 1210.38 341.343 1224.73 340.769 1224.85Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M341.381 1224.85C340.769 1225.04 338.128 1215.62 331.314 1205.97C324.653 1196.14 316.193 1191.16 316.499 1190.7C316.614 1190.47 318.949 1191.35 322.203 1193.65C325.495 1195.94 329.514 1199.77 332.998 1204.79C340.118 1214.82 341.879 1224.81 341.381 1224.85Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M340.921 1640.45C340.692 1640.49 340.271 1636.97 338.625 1630.8C337.017 1624.64 333.954 1615.91 328.94 1605.69C318.91 1585.21 300.689 1559.26 277.53 1533.27C266.046 1520.14 254.906 1507.77 245.451 1495.94C235.996 1484.12 228.187 1472.86 222.521 1462.87C216.818 1452.92 213.104 1444.34 210.961 1438.33C209.889 1435.31 209.123 1432.94 208.702 1431.33C208.243 1429.72 208.051 1428.84 208.09 1428.84C208.281 1428.76 209.315 1432.17 211.726 1438.06C214.1 1443.96 218.004 1452.34 223.823 1462.14C229.641 1471.94 237.489 1483.04 246.982 1494.76C256.476 1506.47 267.615 1518.8 279.137 1531.93C302.373 1558 320.556 1584.29 330.318 1605.08C335.218 1615.45 338.089 1624.37 339.467 1630.65C340.156 1633.79 340.577 1636.24 340.768 1637.92C340.921 1639.53 340.998 1640.41 340.921 1640.45Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M455.417 1511.1C455.494 1511.26 453.312 1512.37 449.407 1514.47C445.541 1516.62 440.105 1519.98 433.827 1524.77C427.588 1529.55 420.583 1535.83 413.386 1543.41C406.228 1550.99 398.801 1559.8 391.26 1569.21C376.178 1588.12 362.091 1604.89 353.631 1618.25C349.343 1624.87 346.243 1630.46 344.176 1634.4C342.109 1638.31 341.037 1640.53 340.884 1640.45C340.807 1640.41 340.998 1639.84 341.458 1638.77C341.917 1637.69 342.53 1636.05 343.487 1634.06C345.324 1630 348.272 1624.26 352.406 1617.48C360.598 1603.78 374.608 1586.82 389.652 1567.91C397.193 1558.46 404.696 1549.65 412.008 1542.07C419.319 1534.53 426.516 1528.25 432.947 1523.58C439.378 1518.87 445.043 1515.7 449.025 1513.74C451.015 1512.75 452.623 1512.14 453.695 1511.68C454.805 1511.26 455.417 1511.03 455.417 1511.1Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M457.675 1553.06C457.714 1553.36 452.814 1553.94 445.005 1554.9C437.196 1555.89 426.324 1557.23 414.917 1560.83C403.548 1564.54 394.131 1570.17 387.968 1574.95C381.766 1579.74 378.819 1583.72 378.551 1583.49C378.436 1583.41 379.048 1582.34 380.426 1580.58C381.766 1578.82 383.986 1576.45 387.049 1573.81C393.097 1568.6 402.629 1562.63 414.266 1558.84C425.941 1555.16 436.966 1554.09 444.852 1553.44C452.737 1552.87 457.637 1552.79 457.675 1553.06Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M382.264 1578.9C381.613 1578.51 387.317 1569.79 391.757 1558.03C395.93 1546.17 396.887 1535.79 397.652 1535.91C397.92 1535.95 397.92 1538.55 397.423 1542.72C396.925 1546.89 395.93 1552.68 393.71 1558.76C391.489 1564.85 388.58 1569.94 386.36 1573.46C384.101 1576.98 382.494 1579.05 382.264 1578.9Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M492.51 1398.48C492.549 1398.56 491.821 1398.9 490.482 1399.55C488.912 1400.28 486.921 1401.16 484.51 1402.27C481.907 1403.38 478.73 1404.8 475.17 1406.71C471.571 1408.55 467.399 1410.46 463.035 1413.07C460.815 1414.33 458.518 1415.63 456.106 1417.01C453.694 1418.39 451.321 1420.03 448.795 1421.6C443.703 1424.7 438.574 1428.49 433.138 1432.4C422.458 1440.51 411.242 1450.08 400.447 1461.15C389.729 1472.33 380.541 1483.89 372.809 1494.83C369.096 1500.42 365.459 1505.67 362.55 1510.87C361.057 1513.44 359.487 1515.89 358.186 1518.34C356.923 1520.79 355.659 1523.12 354.473 1525.38C352.023 1529.82 350.262 1534.07 348.539 1537.71C346.778 1541.34 345.477 1544.56 344.443 1547.2C343.41 1549.65 342.606 1551.64 341.955 1553.25C341.343 1554.63 340.998 1555.35 340.96 1555.32C340.922 1555.28 341.113 1554.55 341.572 1553.1C342.147 1551.45 342.836 1549.42 343.716 1546.89C344.635 1544.18 345.821 1540.92 347.506 1537.21C349.152 1533.5 350.798 1529.21 353.209 1524.69C354.358 1522.4 355.545 1520.02 356.808 1517.53C358.071 1515.05 359.602 1512.6 361.095 1509.99C363.966 1504.71 367.564 1499.39 371.278 1493.76C378.972 1482.66 388.197 1470.99 398.992 1459.73C409.864 1448.55 421.233 1438.95 432.066 1430.87C437.579 1427 442.785 1423.21 447.952 1420.15C450.517 1418.58 452.929 1416.97 455.379 1415.63C457.829 1414.29 460.164 1413.03 462.422 1411.8C466.863 1409.24 471.112 1407.44 474.748 1405.68C478.385 1403.88 481.601 1402.58 484.28 1401.58C486.768 1400.63 488.797 1399.86 490.405 1399.25C491.745 1398.64 492.51 1398.41 492.51 1398.48Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M401.901 1459.2C401.71 1459.16 402.744 1455.64 406.878 1451.77C410.936 1447.9 418.324 1444.34 426.937 1444.07C435.511 1443.84 442.976 1446.26 448.067 1448.21C453.197 1450.2 456.144 1451.85 456.068 1452.08C455.953 1452.38 452.776 1451.23 447.608 1449.59C442.44 1448.02 435.167 1445.95 427.051 1446.14C418.936 1446.41 411.931 1449.51 407.873 1452.88C403.701 1456.25 402.246 1459.39 401.901 1459.2Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M388.351 1473.17C387.776 1472.86 392.868 1465.36 394.054 1454.6C395.394 1443.88 392.14 1435.42 392.791 1435.23C393.021 1435.16 394.169 1437.11 395.165 1440.63C396.16 1444.15 396.811 1449.24 396.16 1454.83C395.509 1460.42 393.672 1465.24 391.911 1468.42C390.112 1471.64 388.542 1473.32 388.351 1473.17Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M240.781 1661.2C243.92 1716.63 260.61 1772.98 286.296 1829.94H397.997C422.496 1773.51 438.038 1717.24 440.794 1661.2H240.781Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M422.688 1750.89C422.688 1751.46 385.901 1751.92 340.578 1751.92C295.216 1751.92 258.429 1751.46 258.429 1750.89C258.429 1750.31 295.178 1749.86 340.578 1749.86C385.901 1749.86 422.688 1750.31 422.688 1750.89Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M420.199 1770.95C420.199 1771.52 385.709 1771.98 343.218 1771.98C300.689 1771.98 266.237 1771.52 266.237 1770.95C266.237 1770.37 300.689 1769.91 343.218 1769.91C385.709 1769.91 420.199 1770.37 420.199 1770.95Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M288.095 1697.6C288.669 1697.6 289.129 1709.13 289.129 1723.33C289.129 1737.53 288.669 1749.05 288.095 1749.05C287.521 1749.05 287.062 1737.53 287.062 1723.33C287.062 1709.13 287.521 1697.6 288.095 1697.6Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M347.927 1697.6C348.501 1697.6 348.961 1709.55 348.961 1724.25C348.961 1738.95 348.501 1750.89 347.927 1750.89C347.353 1750.89 346.894 1738.95 346.894 1724.25C346.894 1709.55 347.353 1697.6 347.927 1697.6Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M404.122 1697.14C404.697 1697.14 405.156 1709.32 405.156 1724.32C405.156 1739.33 404.697 1751.5 404.122 1751.5C403.548 1751.5 403.089 1739.33 403.089 1724.32C403.089 1709.32 403.548 1697.14 404.122 1697.14Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M437.235 1697.6C437.235 1698.18 394.093 1698.64 340.922 1698.64C287.713 1698.64 244.571 1698.18 244.571 1697.6C244.571 1697.03 287.713 1696.57 340.922 1696.57C394.093 1696.57 437.235 1697.03 437.235 1697.6Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M347.276 699.069C347.237 709.137 339.046 717.252 328.978 717.214C318.91 717.176 310.795 708.984 310.833 698.916C310.871 688.849 319.063 680.733 329.131 680.771C339.199 680.771 347.352 689.002 347.276 699.069Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M292.612 675.604C312.632 654.588 345.17 653.937 365.727 674.647C375.029 684.025 389.613 669.594 380.311 660.215C352.137 631.811 305.895 632.003 278.218 661.057C269.108 670.589 283.501 685.212 292.612 675.604Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M255.136 637.783C273.74 617.686 299.77 605.092 327.294 604.479C355.583 603.829 382.876 615.466 402.514 635.678C411.739 645.133 426.286 630.701 417.098 621.246C393.824 597.359 360.865 583.196 327.37 583.961C294.641 584.727 262.907 599.197 240.666 623.198C231.747 632.883 246.14 647.506 255.136 637.783Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1506.05 1354.65H876.344V1645.08H1506.05V1354.65Z", fill: "#F5F5F5" }),
	    React.createElement("path", { d: "M1491.04 1631.38H890.737V1369.93H1491.04V1631.38ZM894.68 1627.47H1487.18V1373.87H894.68V1627.47Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1659.9 1354.65H1506.05V1645.08H1659.9V1354.65Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M892.689 1450.85C960.138 1450.85 1027.63 1450.85 1095.08 1450.85C1201.65 1450.85 1308.26 1450.85 1414.83 1450.85C1439.6 1450.85 1464.32 1450.85 1489.09 1450.85C1490.12 1450.85 1490.12 1449.28 1489.09 1449.28C1421.64 1449.28 1354.15 1449.28 1286.7 1449.28C1180.13 1449.28 1073.52 1449.28 966.952 1449.28C942.185 1449.28 917.456 1449.28 892.689 1449.28C891.694 1449.28 891.694 1450.85 892.689 1450.85Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1192.84 1450.05C1194.64 1424.28 1194.45 1396.95 1193.03 1371.15C1193 1370.12 1191.5 1370.12 1191.43 1371.15C1190.05 1396.95 1189.86 1424.25 1191.62 1450.05C1191.69 1450.81 1192.8 1450.81 1192.84 1450.05Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1353.39 1410.62C1353.39 1415.1 1349.75 1418.73 1345.27 1418.73C1340.79 1418.73 1337.16 1415.1 1337.16 1410.62C1337.16 1406.14 1340.79 1402.5 1345.27 1402.5C1349.75 1402.5 1353.39 1406.14 1353.39 1410.62Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1040.37 1410.62C1040.37 1415.1 1036.74 1418.73 1032.26 1418.73C1027.78 1418.73 1024.14 1415.1 1024.14 1410.62C1024.14 1406.14 1027.78 1402.5 1032.26 1402.5C1036.74 1402.5 1040.37 1406.14 1040.37 1410.62Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1199.04 1500.65C1199.04 1505.13 1195.41 1508.77 1190.93 1508.77C1186.45 1508.77 1182.81 1505.13 1182.81 1500.65C1182.81 1496.17 1186.45 1492.54 1190.93 1492.54C1195.41 1492.54 1199.04 1496.17 1199.04 1500.65Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M951.603 1645.08L919.218 1827.41H937.439L997.194 1645.08H951.603Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1461.49 1645.08L1488.59 1827.72H1470.37L1415.9 1645.08H1461.49Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1583.22 1645.08L1613.96 1827.72H1595.7L1537.63 1645.08H1583.22Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1198.47 1582.84C1198.47 1587.32 1194.83 1590.95 1190.35 1590.95C1185.88 1590.95 1182.24 1587.32 1182.24 1582.84C1182.24 1578.36 1185.88 1574.72 1190.35 1574.72C1194.83 1574.72 1198.47 1578.36 1198.47 1582.84Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M892.689 1540.77C960.138 1540.77 1027.63 1540.77 1095.08 1540.77C1201.65 1540.77 1308.26 1540.77 1414.83 1540.77C1439.6 1540.77 1464.32 1540.77 1489.09 1540.77C1490.12 1540.77 1490.12 1539.2 1489.09 1539.2C1421.64 1539.2 1354.15 1539.2 1286.7 1539.2C1180.13 1539.2 1073.52 1539.2 966.952 1539.2C942.185 1539.2 917.456 1539.2 892.689 1539.2C891.694 1539.2 891.694 1540.77 892.689 1540.77Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1315.98 1256.11L1315.78 1217.34L1125.37 1218.34L1125.58 1257.12L1315.98 1256.11Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1338.85 1353.85L1338.54 1293.64L1126.31 1294.76L1126.63 1354.97L1338.85 1353.85Z", fill: "#F5F5F5" }),
	    React.createElement("path", { d: "M1298 1353.43C1297.42 1353.43 1296.96 1339.95 1296.96 1323.3C1296.96 1306.65 1297.42 1293.17 1298 1293.17C1298.57 1293.17 1299.03 1306.65 1299.03 1323.3C1299.03 1339.95 1298.53 1353.43 1298 1353.43Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1306.88 1353.43C1306.31 1353.43 1305.85 1339.95 1305.85 1323.3C1305.85 1306.65 1306.31 1293.17 1306.88 1293.17C1307.45 1293.17 1307.91 1306.65 1307.91 1323.3C1307.91 1339.95 1307.45 1353.43 1306.88 1353.43Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1158.58 1353.43C1158.01 1353.43 1157.55 1339.95 1157.55 1323.3C1157.55 1306.65 1158.01 1293.17 1158.58 1293.17C1159.16 1293.17 1159.62 1306.65 1159.62 1323.3C1159.62 1339.95 1159.16 1353.43 1158.58 1353.43Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1167.5 1353.43C1166.93 1353.43 1166.47 1339.95 1166.47 1323.3C1166.47 1306.65 1166.93 1293.17 1167.5 1293.17C1168.08 1293.17 1168.54 1306.65 1168.54 1323.3C1168.54 1339.95 1168.08 1353.43 1167.5 1353.43Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1186.95 1324.3C1186.95 1323.72 1208.35 1323.26 1234.76 1323.26C1261.17 1323.26 1282.57 1323.72 1282.57 1324.3C1282.57 1324.87 1261.17 1325.33 1234.76 1325.33C1208.35 1325.33 1186.95 1324.87 1186.95 1324.3Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1418.54 1293.31L1418.34 1254.53L1156.46 1255.91L1156.67 1294.69L1418.54 1293.31Z", fill: "#EBEBEB" }),
	    React.createElement("path", { d: "M1381.07 1288.47C1374.21 1288.47 1368.7 1282.84 1368.7 1275.95C1368.7 1269.02 1374.25 1263.43 1381.07 1263.43C1387.92 1263.43 1393.43 1269.06 1393.43 1275.95C1393.43 1282.84 1387.92 1288.47 1381.07 1288.47Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1347.03 1279.79V1272.05H1171.74V1279.79H1347.03Z", fill: "#E0E0E0" }),
	    React.createElement("path", { d: "M1363.3 1175.2C1329.31 1192.8 1303.24 1223.12 1284.48 1256.54C1265.73 1289.92 1253.67 1326.56 1241.69 1362.96L1231.2 1550.57C1270.78 1483.27 1302.51 1404.15 1311.09 1326.56C1302.32 1325.79 1293.56 1324.99 1284.75 1324.22C1302.4 1321.54 1317.21 1308.72 1326.63 1293.56C1336.05 1278.4 1340.91 1260.9 1345.66 1243.68C1334.94 1245.29 1324.26 1246.86 1313.54 1248.46C1338.73 1231.58 1356.95 1204.75 1363.3 1175.2Z", fill: "#455A64" }),
	    React.createElement(
	      "g",
	      { opacity: "0.3" },
	      React.createElement("path", { d: "M1363.3 1175.2C1329.31 1192.8 1303.24 1223.12 1284.48 1256.54C1265.73 1289.92 1253.67 1326.56 1241.69 1362.96L1231.2 1550.57C1270.78 1483.27 1302.51 1404.15 1311.09 1326.56C1302.32 1325.79 1293.56 1324.99 1284.75 1324.22C1302.4 1321.54 1317.21 1308.72 1326.63 1293.56C1336.05 1278.4 1340.91 1260.9 1345.66 1243.68C1334.94 1245.29 1324.26 1246.86 1313.54 1248.46C1338.73 1231.58 1356.95 1204.75 1363.3 1175.2Z", fill: "black" })
	    ),
	    React.createElement("path", { d: "M1225.34 1594.44C1225.34 1594.44 1139.48 1491.66 1140.48 1393.55H1175.16C1175.16 1393.55 1137.49 1368.78 1140.48 1354.88C1143.46 1341.02 1144.46 1288.47 1144.46 1288.47L1176.19 1296.39C1176.19 1296.39 1152.42 1284.49 1149.43 1265.65C1146.45 1246.82 1156.36 1159.62 1156.36 1159.62C1156.36 1159.62 1195.03 1200.27 1206.89 1241.88C1218.8 1283.49 1250 1332.07 1240.85 1458.93C1231.66 1585.83 1225.34 1594.44 1225.34 1594.44Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M1268.87 1604.16C1268.87 1604.16 1361.89 1542.19 1382.56 1463.1L1354.65 1455.52C1354.65 1455.52 1390.37 1443.85 1391.02 1432.02C1391.67 1420.23 1402.35 1377.77 1402.35 1377.77L1375.13 1377.2C1375.13 1377.2 1396.88 1372.84 1403.38 1358.37C1409.89 1343.86 1420.99 1271.59 1420.99 1271.59C1420.99 1271.59 1381.03 1295.82 1362.35 1326.67C1343.67 1357.52 1307.95 1389.76 1287.59 1493.76C1267.22 1597.69 1268.87 1604.16 1268.87 1604.16Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M1179.79 1249.27C1179.83 1249.27 1179.94 1249.61 1180.13 1250.34C1180.33 1251.14 1180.59 1252.22 1180.9 1253.52C1181.55 1256.43 1182.47 1260.52 1183.66 1265.69C1184.84 1270.97 1186.26 1277.48 1187.75 1285.02C1189.28 1292.56 1191.08 1301.18 1192.84 1310.71C1196.56 1329.77 1200.42 1352.55 1204.44 1377.89C1208.31 1403.27 1212.21 1431.21 1215.62 1460.61C1218.99 1490.05 1221.59 1518.15 1223.62 1543.76C1225.5 1569.37 1226.91 1592.41 1227.68 1611.82C1228.14 1621.5 1228.37 1630.27 1228.6 1638C1228.86 1645.7 1228.98 1652.36 1229.02 1657.75C1229.06 1663.07 1229.09 1667.25 1229.09 1670.23C1229.09 1671.57 1229.06 1672.64 1229.06 1673.49C1229.06 1674.21 1229.02 1674.6 1228.98 1674.6C1228.94 1674.6 1228.9 1674.21 1228.86 1673.49C1228.83 1672.64 1228.75 1671.57 1228.71 1670.23C1228.6 1667.25 1228.44 1663.07 1228.25 1657.75C1228.1 1652.32 1227.87 1645.7 1227.49 1638C1227.14 1630.31 1226.84 1621.54 1226.26 1611.86C1225.34 1592.49 1223.77 1569.44 1221.78 1543.87C1219.68 1518.3 1217 1490.24 1213.67 1460.84C1210.22 1431.44 1206.43 1403.54 1202.64 1378.16C1198.74 1352.82 1194.99 1330.04 1191.47 1310.94C1189.82 1301.37 1188.1 1292.79 1186.68 1285.21C1185.26 1277.63 1184 1271.13 1182.89 1265.8C1181.86 1260.6 1181.05 1256.5 1180.48 1253.56C1180.25 1252.25 1180.06 1251.18 1179.9 1250.34C1179.79 1249.65 1179.75 1249.27 1179.79 1249.27Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1213.44 1657.37C1213.44 1657.37 1134.85 1568.22 1110.46 1514.32L1128.88 1506.43C1115.52 1508.65 1101.85 1502.91 1091.48 1494.18C1081.14 1485.46 1073.52 1474.01 1066.06 1462.72L1090.33 1458.62C1068.28 1452.42 1048.83 1437.38 1037.31 1417.55C1065.94 1422.26 1091.86 1437.99 1113.18 1457.63C1130.48 1473.55 1145.11 1492.04 1159.16 1510.91C1166.01 1520.14 1172.02 1529.94 1177.03 1540.27C1190.24 1567.6 1213.48 1624.64 1213.44 1657.37Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M1383.82 1323.45C1383.86 1323.45 1383.75 1323.8 1383.48 1324.37C1383.17 1325.06 1382.75 1325.9 1382.29 1326.98C1381.14 1329.39 1379.53 1332.68 1377.54 1336.89C1373.33 1345.47 1367.4 1357.91 1360.2 1373.37C1345.77 1404.26 1326.75 1447.41 1307.95 1495.94C1289.19 1544.52 1274.27 1589.23 1264.12 1621.81C1259.07 1638.08 1255.09 1651.32 1252.41 1660.47C1251.07 1664.91 1250.03 1668.43 1249.27 1671C1248.92 1672.11 1248.62 1672.99 1248.39 1673.72C1248.2 1674.33 1248.04 1674.64 1248.04 1674.64C1248 1674.64 1248.08 1674.29 1248.2 1673.68C1248.39 1672.95 1248.62 1672.03 1248.89 1670.88C1249.57 1668.28 1250.49 1664.76 1251.68 1660.24C1254.13 1651.02 1257.88 1637.73 1262.78 1621.39C1272.54 1588.7 1287.32 1543.83 1306.08 1495.22C1324.87 1446.64 1344.13 1403.54 1358.9 1372.76C1366.29 1357.37 1372.41 1345.01 1376.82 1336.51C1378.96 1332.37 1380.68 1329.12 1381.91 1326.75C1382.44 1325.71 1382.9 1324.91 1383.29 1324.22C1383.59 1323.72 1383.78 1323.45 1383.82 1323.45Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1220.1 1695.61C1219.95 1695.61 1219.52 1693.35 1218.87 1689.26C1218.26 1685.16 1217.23 1679.23 1215.73 1671.92C1212.86 1657.33 1207.77 1637.39 1199.81 1616.18C1191.77 1594.97 1182.39 1576.68 1174.93 1563.81C1171.21 1557.38 1168.08 1552.25 1165.82 1548.73C1163.6 1545.21 1162.41 1543.22 1162.53 1543.14C1162.64 1543.07 1164.02 1544.9 1166.47 1548.27C1168.92 1551.64 1172.25 1556.69 1176.15 1563.05C1183.96 1575.76 1193.61 1594.09 1201.69 1615.42C1209.72 1636.78 1214.59 1656.87 1217.15 1671.57C1218.45 1678.92 1219.26 1684.89 1219.64 1689.07C1220.06 1693.28 1220.25 1695.57 1220.1 1695.61Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1323.8 1674.64H1151.81V1709.74H1323.8V1674.64Z", fill: "#3B53A7" }),
	    React.createElement("path", { d: "M1168.19 1709.7L1186.79 1827.72H1290.72L1308.07 1709.7H1168.19Z", fill: "#3B53A7" }),
	    React.createElement("path", { d: "M1313.23 1709.7C1313.23 1710.24 1280.7 1710.69 1240.58 1710.69C1200.42 1710.69 1167.92 1710.24 1167.92 1709.7C1167.92 1709.16 1200.46 1708.7 1240.58 1708.7C1280.7 1708.7 1313.23 1709.16 1313.23 1709.7Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1113.53 1075.36C1326.57 1075.36 1499.27 901.474 1499.27 686.973C1499.27 472.472 1326.57 298.584 1113.53 298.584C900.484 298.584 727.779 472.472 727.779 686.973C727.779 901.474 900.484 1075.36 1113.53 1075.36Z", fill: "#E06255" }),
	    React.createElement(
	      "g",
	      { opacity: "0.3" },
	      React.createElement("path", { d: "M970.666 860.075C972.695 843.155 985.863 826.006 978.284 810.77C969.786 793.736 945.095 796.492 927.678 788.874C903.37 778.194 895.867 748.029 880.019 726.746C865.817 707.721 832.59 686.781 807.325 692.523C789.027 696.658 782.711 707.606 780.836 721.042C780.032 720.927 779.304 720.812 778.5 720.659C771.725 719.932 763.801 719.549 760.088 713.96C755.762 707.414 760.011 697.73 755.571 691.337C753.236 687.968 749.216 686.513 745.924 684.14C742.632 681.805 739.838 677.441 741.828 673.881C743.474 670.895 747.762 670.283 749.867 667.527C751.59 665.345 751.513 661.976 749.752 659.909C742.785 651.679 735.053 668.445 731.186 672.426C730.076 673.575 729.043 674.57 728.086 675.374V675.451C728.009 676.178 727.971 676.867 727.971 677.594C727.894 679.891 727.894 682.226 727.856 684.561C727.818 686.896 727.741 689.193 727.741 691.528C727.741 693.404 727.818 695.28 727.818 697.155C727.856 699.031 727.856 700.945 727.894 702.782C732.029 704.199 735.933 706.381 739.799 708.639C747.302 712.965 755.686 718.707 756.145 727.358C756.222 728.775 756.068 730.306 756.949 731.454C757.753 732.564 759.207 732.985 760.547 733.292C766.94 734.823 773.562 735.742 780.147 736.048C780.261 743.78 780.836 751.934 780.682 759.59C780.491 770.768 776.854 781.792 778.041 792.855C779.802 808.474 790.674 821.297 800.129 833.853C836.15 881.933 855.558 937.094 876.612 993.596C880.517 996.696 886.106 1000.87 890.125 1003.74C893.302 1006.04 896.211 1008.03 899.465 1010.21C902.719 1012.39 905.628 1014.27 908.959 1016.33C911.294 1017.79 911.791 1018.21 914.165 1019.63C913.859 1018.94 914.433 1020.09 914.127 1019.43C905.628 1000.83 905.628 975.03 923.888 965.804C927.371 964.043 931.353 963.048 934.185 960.369C942.301 952.674 935.64 936.826 943.755 929.132C948.349 924.845 955.469 925.151 961.134 922.586C971.317 917.878 974.609 904.824 973.843 893.608C973.078 882.354 969.403 871.253 970.666 860.075Z", fill: "black" })
	    ),
	    React.createElement(
	      "g",
	      { opacity: "0.3" },
	      React.createElement("path", { d: "M751.743 575.808C758.939 569.645 771.38 568.917 776.931 576.612C780.912 582.124 779.993 589.627 778.96 596.326C777.543 605.36 776.165 614.394 774.672 623.428C774.251 626.108 773.869 629.055 775.055 631.543C777.735 637.285 787.152 636.175 790.75 631.046C794.425 625.84 794.004 618.911 793.009 612.671C792.013 606.393 790.75 599.809 793.2 593.952C799.287 579.444 820.953 581.626 833.547 572.171C841.356 566.314 844.84 556.476 849.472 547.863C854.103 539.25 861.874 530.637 871.636 531.097C874.928 531.212 878.182 532.436 881.474 532.322C891.12 532.015 896.747 517.928 889.895 511.076C888.479 509.622 886.603 508.435 885.608 506.674C883.885 503.459 885.723 499.286 888.67 497.104C891.618 494.96 895.331 494.348 898.929 493.812C907.16 492.472 915.39 491.171 923.658 489.907C932.769 488.491 944.406 483.821 943.143 474.71C942.033 466.825 931.352 463.303 929.783 455.494C929.362 453.618 929.592 451.513 928.749 449.752C926.261 444.737 918.758 446.766 913.935 449.445C911.983 442.172 901.609 438.88 895.79 443.665C890.891 447.685 890.316 454.766 888.594 460.815C884.574 475.476 872.899 486.577 861.798 496.874C858.085 500.281 853.874 503.956 848.783 504.186C843.73 504.416 838.409 499.018 840.744 494.539C842.313 491.477 846.715 489.716 846.294 486.309C845.682 482.022 838.256 482.328 836.763 478.27C839.672 466.174 853.529 461.197 864.171 454.728C877.033 446.919 887.177 434.593 892.192 420.314C893.034 418.056 893.723 415.376 892.575 413.233C891.005 410.17 886.909 409.711 883.426 409.711C875.234 409.596 865.052 410.668 862.066 418.324C860.496 422.42 861.645 427.052 860.649 431.339C857.778 444.048 840.399 445.426 829.757 453.005C825.623 455.915 822.369 460.011 817.814 462.269C812.876 464.643 807.057 464.451 801.583 464.911C800.588 464.987 798.1 464.872 797.143 465.025C793.774 469.696 791.133 473.945 788.032 478.768C784.893 483.591 781.793 489.027 778.883 494.003C765.217 517.392 754.652 542.619 746.116 568.841C743.13 577.951 740.565 587.789 738.268 597.206C735.971 606.623 734.364 615.542 732.756 625.227C736.546 617.418 738.23 607.772 739.723 600.919C741.599 591.617 744.584 581.971 751.743 575.808Z", fill: "black" })
	    ),
	    React.createElement(
	      "g",
	      { opacity: "0.3" },
	      React.createElement("path", { d: "M1075.9 401.328C1079.53 396.543 1078.46 389.652 1080.84 384.14C1084.78 374.953 1096.95 371.661 1101.2 362.626C1102.85 359.143 1103.23 354.894 1106.06 352.291C1108.44 350.147 1111.96 349.688 1114.48 347.736C1120.19 343.372 1117.81 333.457 1111.77 329.629C1096.65 319.983 1068.82 331.122 1055.72 340.577C1038.92 352.75 1022.5 367.373 1000.14 365.957C993.979 365.574 987.586 363.851 981.806 366.072C976.026 368.254 972.466 376.905 977.442 380.58C980.198 382.609 984.141 382.034 987.242 383.489C993.022 386.169 993.596 394.514 990.763 400.179C987.969 405.883 982.878 410.132 979.547 415.529C976.332 420.774 974.839 427.052 975.413 433.215C975.796 437.464 977.289 441.904 980.658 444.584C987.624 450.135 998.19 445.388 1004.08 438.727C1009.98 432.066 1014.04 423.415 1021.69 418.86C1025.52 416.563 1029.89 415.529 1034.21 414.496C1043.93 412.199 1053.66 409.864 1063.38 407.567C1067.97 406.457 1072.99 405.117 1075.9 401.328Z", fill: "black" })
	    ),
	    React.createElement(
	      "g",
	      { opacity: "0.3" },
	      React.createElement("path", { d: "M1499.24 684.025C1499.2 678.475 1499.04 672.962 1498.74 667.488C1498.43 662.014 1498.24 656.464 1497.67 651.028C1497.25 646.626 1496.86 642.262 1496.25 637.898C1495.64 633.304 1495.06 628.06 1494.3 623.543C1492 609.954 1489.51 597.857 1485.8 584.765C1484.38 579.712 1481.93 574.353 1480.29 569.415C1478.68 564.477 1476.92 559.539 1475.12 554.677C1475.12 554.677 1475.12 554.677 1475.12 554.601C1473.17 550.926 1471.1 547.327 1468.84 543.806C1447.4 509.89 1416.28 483.247 1392.74 450.785C1385.05 440.22 1379.08 431.492 1365.45 429.425C1345.31 426.324 1335.13 437.77 1320.85 418.668C1317.02 413.539 1310.29 408.792 1304.62 411.816C1306.08 415.912 1307.61 420.008 1309.06 424.142C1309.37 424.985 1309.67 425.903 1309.56 426.822C1309.25 429.693 1304.96 430.497 1302.55 428.889C1300.1 427.243 1298.88 424.372 1297.19 421.999C1290.84 412.888 1275.95 411.74 1268.22 419.625C1267.91 415.797 1265.35 412.161 1261.82 410.591C1261.02 418.094 1252.41 423.645 1245.21 421.271C1244.06 417.558 1250.68 416.869 1253.02 413.692C1255.16 410.706 1252.6 406.534 1249.84 404.045C1242.57 397.691 1233 393.978 1223.31 393.748C1217.15 393.633 1210.49 394.782 1205.13 391.604C1202.03 389.767 1199.81 386.705 1196.63 384.944C1189.86 381.116 1181.36 384.637 1174.54 388.427C1165.2 393.633 1155.56 400.141 1152.27 410.323C1148.9 420.468 1156.29 434.172 1166.93 432.909C1169.61 432.526 1172.4 431.262 1175.04 431.99C1178.83 433.023 1180.52 437.426 1180.82 441.33C1181.13 445.158 1180.71 449.331 1182.58 452.738C1184.42 456.144 1189.97 457.867 1192.12 454.613C1197.13 449.867 1196.52 441.866 1195.22 435.09C1193.99 428.315 1192.57 420.697 1196.63 415.147C1200.73 409.596 1212.33 411.357 1211.52 418.209C1211.03 422.228 1206.47 425.176 1206.62 429.272C1206.81 433.406 1211.87 435.626 1216.04 435.435C1220.17 435.32 1224.39 433.789 1228.44 434.823C1232.54 435.78 1235.75 441.1 1232.85 444.086C1227.79 449.828 1214.59 439.99 1211.98 447.149C1211.26 448.986 1211.98 451.053 1211.79 453.006C1211.29 458.977 1203.79 461.197 1197.82 461.925C1191.85 462.614 1185.49 463.188 1180.06 460.662C1174.62 458.097 1170.91 450.977 1174.01 445.847C1170.95 443.665 1166.31 445.847 1164.67 449.254C1163.02 452.623 1163.52 456.642 1163.98 460.355C1157.63 458.939 1151.96 464.336 1148.36 469.619C1144.69 474.978 1141.2 481.218 1135.04 483.094C1128.8 484.969 1120.26 482.405 1117.05 488.032C1112.84 495.343 1125.05 504.645 1120.76 511.88C1118.31 515.976 1112.45 515.861 1107.82 517.124C1095.57 520.608 1091.29 538.561 1099.63 548.131C1107.94 557.701 1124.7 557.165 1133.55 548.016C1139.71 541.739 1142.2 532.896 1146.68 525.316C1151.12 517.814 1159.54 510.961 1167.96 513.411C1171.25 514.407 1174.05 516.703 1176.69 518.885C1180.78 522.292 1184.88 525.738 1188.94 529.183C1191.58 531.365 1194.41 534.121 1194.18 537.528C1193.95 540.284 1191.81 542.428 1190.89 544.992C1188.33 552.38 1199.01 559.386 1205.7 555.366C1212.48 551.347 1213.17 541.011 1208.58 534.695C1202.22 525.891 1187.9 521.527 1188.25 510.655C1195.56 504.683 1207.12 510.961 1211.37 519.46C1215.66 527.881 1215.77 537.872 1219.37 546.6C1222.97 555.404 1233.04 563.137 1241.46 558.85C1239.28 551.27 1237.13 543.767 1234.91 536.264C1240.27 532.245 1246.43 543.959 1252.87 542.006C1256.77 540.782 1257.27 535.154 1255.55 531.403C1253.9 527.613 1250.84 524.436 1250.11 520.34C1248.88 512.875 1257.19 506.253 1264.69 507.478C1272.12 508.703 1277.56 515.823 1278.97 523.211C1279.51 526.159 1279.66 529.259 1280.93 531.939C1283.72 537.796 1290.99 539.557 1296.96 542.006C1303.01 544.456 1309.21 550.505 1306.73 556.476C1305.58 559.118 1302.82 561.606 1303.78 564.285C1304.7 566.659 1308.22 567.692 1308.22 570.257C1308.14 571.98 1306.38 573.128 1304.81 573.779C1300.79 575.425 1296.39 575.961 1292.49 577.875C1288.58 579.712 1285.02 583.502 1285.33 587.751C1285.82 593.838 1293.06 596.785 1296.51 601.838C1299.8 606.661 1299.3 613.054 1301.4 618.566C1303.36 623.619 1307.38 627.601 1310.63 631.926C1320.77 645.707 1323.15 663.469 1328.09 679.853C1330.27 687.241 1334.33 695.471 1341.87 696.887C1346 697.615 1350.17 696.045 1354.08 694.514C1364.99 690.188 1376.36 685.557 1383.97 676.676C1391.67 667.756 1394.23 653.286 1386.35 644.559C1385.35 643.41 1384.09 642.377 1382.64 642.185C1380.57 641.956 1378.73 643.334 1376.89 644.214C1371.34 646.779 1364.49 644.635 1359.86 640.539C1355.26 636.52 1352.47 630.816 1349.71 625.342C1346.73 619.294 1343.74 613.207 1340.68 607.082C1344.28 604.02 1350.02 605.322 1353.73 608.307C1357.41 611.293 1359.67 615.619 1362.65 619.294C1371.76 630.663 1386.69 635.639 1401.16 637.362C1404.84 637.783 1408.63 638.089 1412.03 639.62C1422.83 644.559 1425.93 660.483 1437.38 663.928C1440.55 664.924 1444.07 664.732 1447.06 666.11C1451.58 668.254 1453.84 673.383 1455.18 678.207C1457.66 687.164 1458.54 696.619 1462.33 705.194C1466.05 713.731 1473.7 721.501 1482.97 721.616C1488.75 721.731 1494.03 719.052 1498.24 714.956C1498.74 706.534 1499.27 697.806 1499.27 689.27C1499.35 687.547 1499.35 685.786 1499.24 684.025Z", fill: "black" })
	    ),
	    React.createElement(
	      "g",
	      { opacity: "0.3" },
	      React.createElement("path", { d: "M1343.13 844.112C1337.39 845.261 1336.24 848.629 1333.1 852.878C1329.04 858.429 1323.22 863.98 1319.51 869.415C1313.23 878.679 1318.9 893.149 1310.63 900.92C1308.95 902.528 1306.76 903.561 1305.27 905.322C1301.94 909.188 1303.2 915.734 1307.26 918.797C1311.32 921.859 1317.25 921.629 1321.62 919.064C1325.98 916.461 1328.89 911.868 1330.42 907.045C1331.53 903.561 1332.14 899.58 1334.9 897.168C1339.61 893.034 1346.96 896.096 1353.16 895.216C1379.61 891.503 1368.28 839.136 1343.13 844.112Z", fill: "black" })
	    ),
	    React.createElement(
	      "g",
	      { opacity: "0.3" },
	      React.createElement("path", { d: "M1352.09 771.265C1367.32 758.097 1373.45 728.315 1354.54 721.463C1347.38 718.86 1339.15 720.965 1332.03 718.209C1322.77 714.611 1318.44 704.237 1315.11 694.859C1306.3 670.321 1297.54 645.745 1288.73 621.208C1283.45 606.432 1275.41 589.282 1259.83 587.1C1251.03 585.875 1242.45 590.086 1233.73 591.656C1203.6 597.13 1152.92 524.206 1129.95 573.281C1126.73 559.921 1105.07 564.936 1098.14 576.803C1091.21 588.67 1089.75 604.365 1078.77 612.595C1070.39 618.873 1058.1 619.255 1051.25 627.179C1046.42 632.768 1045.62 640.616 1045.01 647.966C1043.86 662.014 1042.67 676.025 1041.52 690.074C1040.6 701.404 1039.8 713.501 1045.43 723.377C1051.02 733.253 1065.68 738.727 1074.06 731.071C1077.93 727.55 1079.53 722.229 1082.71 718.056C1087.8 711.319 1097.1 708.142 1105.22 710.285C1112.07 712.085 1117.55 717.176 1122.37 722.344C1161.61 764.605 1175.66 824.743 1177.38 882.354C1177.68 892.881 1177.72 903.752 1181.59 913.552C1186.14 925.036 1195.71 934.338 1198.55 946.396C1200.73 955.66 1198.66 965.804 1202.64 974.456C1209.95 990.342 1234.34 991.031 1247.62 979.623C1260.9 968.254 1265.5 949.88 1268.18 932.577C1270.86 915.313 1272.62 897.092 1282.3 882.507C1288.31 873.473 1297.12 866.238 1301.33 856.247C1307.19 842.275 1302.86 825.7 1308.3 811.536C1315.49 792.779 1336.85 784.434 1352.09 771.265Z", fill: "black" })
	    ),
	    React.createElement("path", { d: "M864.4 1431.14C801.085 1436.19 748.412 1383.52 753.427 1320.16C757.408 1270.32 797.755 1229.94 847.595 1225.99C910.91 1220.94 963.584 1273.61 958.569 1336.97C954.626 1386.81 914.241 1427.19 864.4 1431.14Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M864.401 1431.14C864.401 1431.1 864.937 1430.98 866.047 1430.83C867.233 1430.64 868.841 1430.41 870.87 1430.1C873.014 1429.91 875.578 1429.26 878.641 1428.53C881.742 1427.96 885.148 1426.81 889.015 1425.51C896.632 1422.75 905.82 1418.62 915.198 1411.84C924.577 1405.11 934.109 1395.73 941.918 1383.48C945.975 1377.47 949.153 1370.5 952.024 1363.11C953.134 1359.32 954.665 1355.53 955.354 1351.48C955.775 1349.45 956.273 1347.46 956.617 1345.39C956.885 1343.32 957.153 1341.22 957.383 1339.11C957.727 1337.01 957.689 1334.86 957.766 1332.68C957.804 1330.5 957.88 1328.32 957.919 1326.13C957.689 1321.73 957.306 1317.29 956.694 1312.77C956.234 1310.55 955.775 1308.3 955.316 1306.04C955.086 1304.93 954.895 1303.78 954.588 1302.67L953.517 1299.34C952.789 1297.12 952.1 1294.86 951.373 1292.64C950.416 1290.46 949.459 1288.31 948.502 1286.09L947.047 1282.8C946.511 1281.73 945.861 1280.7 945.248 1279.66C944.023 1277.56 942.798 1275.45 941.573 1273.35C940.119 1271.36 938.702 1269.36 937.248 1267.37L935.027 1264.35L932.501 1261.56C926.07 1253.82 917.954 1247.43 909.188 1241.8C906.93 1240.5 904.671 1239.2 902.374 1237.9C900.039 1236.71 897.589 1235.75 895.178 1234.64C893.953 1234.11 892.766 1233.53 891.541 1233.08L887.752 1231.85C885.187 1231.12 882.699 1230.09 880.057 1229.55C869.607 1226.95 858.62 1226.38 847.596 1226.91C825.508 1228.71 804.914 1237.98 789.219 1251.64C773.333 1265.23 762.729 1283.3 757.523 1301.67C755.073 1310.94 753.925 1320.28 754.001 1329.35C753.848 1331.61 754.116 1333.87 754.307 1336.09C754.499 1338.31 754.69 1340.53 754.882 1342.71C755.724 1347.03 756.413 1351.32 757.523 1355.42C762.078 1371.88 770.385 1385.89 780.07 1396.68C789.755 1407.52 800.741 1415.13 811 1420.34C813.641 1421.53 816.168 1422.68 818.618 1423.75C821.068 1424.82 823.594 1425.43 825.929 1426.27C830.561 1428.04 835.117 1428.57 839.059 1429.49C847.098 1430.71 853.453 1431.21 857.74 1430.98C859.807 1430.98 861.453 1430.98 862.64 1430.98C863.827 1431.1 864.401 1431.1 864.401 1431.14C864.401 1431.17 863.827 1431.21 862.755 1431.29C861.568 1431.33 859.922 1431.4 857.855 1431.52C853.567 1431.86 847.175 1431.52 839.059 1430.41C835.04 1429.53 830.485 1429.03 825.776 1427.31C823.403 1426.5 820.838 1425.89 818.35 1424.86C815.862 1423.79 813.297 1422.64 810.617 1421.49C800.167 1416.32 789.027 1408.67 779.113 1397.76C769.237 1386.88 760.738 1372.72 756.03 1355.99C754.882 1351.82 754.154 1347.46 753.274 1343.09C753.082 1340.87 752.853 1338.61 752.661 1336.35C752.47 1334.1 752.164 1331.8 752.317 1329.5C752.202 1320.28 753.35 1310.78 755.839 1301.33C761.121 1282.61 771.878 1264.2 788.032 1250.3C804.033 1236.37 825.049 1226.91 847.558 1225.07C858.774 1224.5 869.99 1225.11 880.67 1227.75C883.349 1228.29 885.914 1229.32 888.517 1230.09L892.383 1231.31C893.647 1231.77 894.872 1232.39 896.097 1232.92C898.546 1234.03 901.073 1235.03 903.446 1236.25C905.781 1237.59 908.078 1238.93 910.375 1240.23C919.256 1245.98 927.563 1252.52 934.07 1260.37L936.635 1263.2L938.894 1266.26C940.387 1268.33 941.841 1270.36 943.296 1272.39C944.521 1274.57 945.784 1276.71 947.009 1278.86C947.621 1279.93 948.272 1280.96 948.808 1282.07L950.301 1285.44C951.258 1287.66 952.253 1289.88 953.21 1292.1C953.938 1294.4 954.665 1296.66 955.392 1298.96L956.464 1302.32C956.77 1303.47 956.923 1304.62 957.191 1305.77C957.651 1308.07 958.11 1310.36 958.57 1312.62C959.182 1317.18 959.527 1321.73 959.756 1326.21C959.68 1328.43 959.641 1330.65 959.603 1332.87C959.526 1335.05 959.565 1337.27 959.182 1339.42C958.914 1341.56 958.646 1343.7 958.378 1345.81C958.034 1347.92 957.498 1349.94 957.038 1352.01C956.311 1356.15 954.742 1359.97 953.593 1363.8C950.646 1371.27 947.353 1378.31 943.219 1384.4C935.219 1396.76 925.496 1406.18 915.964 1412.91C906.432 1419.69 897.092 1423.71 889.359 1426.39C885.455 1427.61 881.971 1428.72 878.832 1429.26C875.732 1429.91 873.129 1430.49 870.985 1430.64C868.918 1430.87 867.31 1431.02 866.123 1431.14C864.975 1431.14 864.401 1431.17 864.401 1431.14Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1529.63 732.756C1529.06 732.679 1529.78 722.573 1530.43 710.094C1531.12 697.615 1531.47 687.47 1532.04 687.47C1532.58 687.47 1533.11 697.653 1532.43 710.171C1531.81 722.765 1530.17 732.832 1529.63 732.756Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1510.26 821.183C1509.72 820.991 1512.63 811.268 1515.96 799.248C1519.29 787.228 1521.82 777.39 1522.4 777.505C1522.93 777.62 1521.25 787.687 1517.92 799.784C1514.51 811.88 1510.76 821.336 1510.26 821.183Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1472.21 903.293C1471.71 902.987 1476.65 894.144 1482.51 883.12C1488.36 872.095 1492.96 863.061 1493.49 863.291C1493.99 863.52 1490.2 872.975 1484.27 884.077C1478.37 895.139 1472.67 903.599 1472.21 903.293Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1417.39 975.298C1416.97 974.915 1423.71 967.297 1431.79 957.804C1439.9 948.31 1446.3 940.463 1446.75 940.808C1447.18 941.114 1441.43 949.535 1433.32 959.105C1425.16 968.637 1417.78 975.681 1417.39 975.298Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1348.45 1033.94C1348.15 1033.48 1356.34 1027.47 1366.25 1019.89C1376.2 1012.35 1384.13 1006.04 1384.51 1006.46C1384.86 1006.88 1377.47 1013.85 1367.44 1021.46C1357.45 1029.08 1348.72 1034.36 1348.45 1033.94Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1268.48 1076.4C1268.29 1075.86 1277.56 1071.8 1288.89 1066.52C1300.22 1061.27 1309.33 1056.83 1309.6 1057.33C1309.86 1057.79 1301.1 1063.04 1289.73 1068.32C1278.36 1073.6 1268.68 1076.89 1268.48 1076.4Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1181.28 1100.55C1181.21 1099.98 1191.12 1098.02 1203.33 1095.34C1215.54 1092.66 1225.38 1090.33 1225.53 1090.87C1225.69 1091.36 1216 1094.62 1203.75 1097.3C1191.5 1099.98 1181.36 1101.09 1181.28 1100.55Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1090.9 1105.41C1090.94 1104.88 1101.09 1104.68 1113.57 1105.03C1126.04 1104.68 1136.19 1104.88 1136.23 1105.41C1136.27 1105.95 1126.12 1106.67 1113.57 1107.02C1101.01 1106.67 1090.87 1105.95 1090.9 1105.41Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1001.52 1090.87C1001.67 1090.33 1011.55 1092.7 1023.72 1095.34C1035.93 1098.02 1045.89 1100.01 1045.77 1100.55C1045.69 1101.09 1035.55 1099.98 1023.3 1097.26C1011.05 1094.62 1001.4 1091.36 1001.52 1090.87Z", fill: "#263238" }),
	    React.createElement("path", { d: "M917.457 1057.33C917.725 1056.83 926.836 1061.27 938.167 1066.52C949.498 1071.76 958.761 1075.86 958.57 1076.4C958.378 1076.89 948.732 1073.64 937.324 1068.32C925.955 1063.04 917.189 1057.79 917.457 1057.33Z", fill: "#263238" }),
	    React.createElement("path", { d: "M842.62 1006.5C843.002 1006.07 850.926 1012.35 860.879 1019.89C870.794 1027.47 878.986 1033.45 878.679 1033.94C878.373 1034.4 869.684 1029.12 859.693 1021.5C849.663 1013.88 842.237 1006.88 842.62 1006.5Z", fill: "#263238" }),
	    React.createElement("path", { d: "M780.338 940.769C780.797 940.425 787.228 948.272 795.306 957.766C803.383 967.297 810.082 974.877 809.699 975.298C809.316 975.681 801.928 968.637 793.813 959.067C785.659 949.535 779.917 941.114 780.338 940.769Z", fill: "#263238" }),
	    React.createElement("path", { d: "M733.598 863.252C734.096 863.023 738.689 872.057 744.584 883.081C750.441 894.106 755.379 902.987 754.882 903.255C754.422 903.523 748.719 895.101 742.824 884C736.929 872.937 733.139 863.482 733.598 863.252Z", fill: "#263238" }),
	    React.createElement("path", { d: "M704.735 777.505C705.271 777.39 707.798 787.19 711.166 799.248C714.497 811.268 717.406 820.991 716.87 821.183C716.372 821.374 712.621 811.88 709.252 799.784C705.845 787.687 704.199 777.62 704.735 777.505Z", fill: "#263238" }),
	    React.createElement("path", { d: "M695.012 687.509C695.586 687.509 695.93 697.653 696.619 710.132C697.27 722.612 697.998 732.717 697.423 732.794C696.887 732.871 695.28 722.803 694.629 710.247C693.94 697.691 694.476 687.509 695.012 687.509Z", fill: "#263238" }),
	    React.createElement("path", { d: "M704.697 597.512C705.233 597.627 703.434 607.618 701.443 619.945C699.414 632.271 697.998 642.3 697.424 642.262C696.888 642.224 697.462 632.041 699.491 619.638C701.481 607.236 704.199 597.398 704.697 597.512Z", fill: "#263238" }),
	    React.createElement("path", { d: "M733.598 511.727C734.095 511.957 730.152 521.297 725.559 532.934C720.927 544.533 717.367 554.026 716.793 553.835C716.295 553.682 719.013 543.844 723.683 532.169C728.353 520.493 733.138 511.497 733.598 511.727Z", fill: "#263238" }),
	    React.createElement("path", { d: "M780.338 434.21C780.798 434.555 774.941 442.823 767.935 453.159C760.892 463.494 755.38 471.992 754.882 471.686C754.423 471.418 759.208 462.422 766.289 452.049C773.295 441.675 779.917 433.904 780.338 434.21Z", fill: "#263238" }),
	    React.createElement("path", { d: "M842.581 368.521C842.964 368.943 835.461 375.795 826.389 384.408C817.316 392.982 810.081 400.103 809.66 399.72C809.278 399.375 815.862 391.604 825.011 382.953C834.121 374.302 842.237 368.1 842.581 368.521Z", fill: "#263238" }),
	    React.createElement("path", { d: "M917.457 317.647C917.725 318.145 908.921 323.236 898.241 329.667C887.522 336.098 878.947 341.496 878.641 341.036C878.335 340.615 886.45 334.414 897.207 327.945C907.964 321.475 917.189 317.188 917.457 317.647Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1001.48 284.152C1001.63 284.688 991.95 287.751 980.121 291.732C968.293 295.713 958.761 299.12 958.531 298.622C958.34 298.125 967.565 293.876 979.47 289.856C991.414 285.837 1001.37 283.617 1001.48 284.152Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1090.83 269.568C1090.86 270.142 1080.76 271.022 1068.32 272.362C1055.88 273.702 1045.85 274.965 1045.73 274.391C1045.66 273.855 1055.61 271.711 1068.09 270.372C1080.61 269.032 1090.79 269.032 1090.83 269.568Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1181.24 274.429C1181.17 275.004 1171.1 273.702 1158.66 272.401C1146.22 271.061 1136.15 270.142 1136.15 269.606C1136.19 269.07 1146.37 269.07 1158.85 270.448C1171.37 271.711 1181.32 273.893 1181.24 274.429Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1268.48 298.584C1268.25 299.12 1258.72 295.675 1246.89 291.694C1235.07 287.712 1225.38 284.65 1225.53 284.114C1225.69 283.617 1235.64 285.799 1247.55 289.818C1259.41 293.799 1268.68 298.086 1268.48 298.584Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1348.41 341.036C1348.11 341.496 1339.49 336.098 1328.81 329.667C1318.13 323.198 1309.33 318.145 1309.6 317.647C1309.83 317.188 1319.09 321.475 1329.85 327.983C1340.6 334.414 1348.72 340.577 1348.41 341.036Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1417.36 399.643C1416.93 400.026 1409.7 392.906 1400.63 384.331C1391.55 375.718 1384.09 368.904 1384.43 368.483C1384.78 368.062 1392.89 374.264 1402 382.915C1411.15 391.528 1417.74 399.299 1417.36 399.643Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1472.21 471.648C1471.71 471.954 1466.2 463.456 1459.16 453.12C1452.15 442.785 1446.29 434.516 1446.75 434.172C1447.17 433.827 1453.76 441.598 1460.8 452.01C1467.85 462.384 1472.67 471.38 1472.21 471.648Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1510.26 553.797C1509.73 553.988 1506.17 544.495 1501.49 532.896C1496.86 521.297 1492.92 511.957 1493.46 511.689C1493.95 511.459 1498.7 520.455 1503.37 532.13C1508 543.806 1510.76 553.605 1510.26 553.797Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1529.63 642.185C1529.06 642.223 1527.64 632.194 1525.61 619.868C1523.62 607.542 1521.78 597.551 1522.36 597.436C1522.89 597.321 1525.57 607.159 1527.6 619.562C1529.63 631.926 1530.17 642.109 1529.63 642.185Z", fill: "#263238" }),
	    React.createElement("path", { d: "M893.8 1232.62C893.302 1232.39 908.576 1197.7 927.946 1155.14C947.315 1112.57 963.393 1078.23 963.891 1078.46C964.388 1078.69 949.115 1113.37 929.745 1155.98C910.413 1198.51 894.298 1232.85 893.8 1232.62Z", fill: "#263238" }),
	    React.createElement("path", { d: "M865.587 1330.31C875.004 1326.36 881.703 1316.64 881.741 1305.23C881.818 1290.27 870.487 1278.05 856.438 1278.02C842.389 1277.94 830.982 1290.04 830.905 1305C830.867 1316.53 837.604 1326.36 847.098 1330.31C807.976 1336.2 809.737 1378.73 809.737 1378.73L902.259 1379.15C902.298 1379.15 904.403 1336.16 865.587 1330.31Z", fill: "#ECC651" }),
	    React.createElement("path", { d: "M1630.04 1173.09C1572.27 1199.54 1504.75 1168.11 1487.79 1106.87C1474.43 1058.67 1498.55 1006.92 1543.99 986.131C1601.75 959.679 1669.28 991.107 1686.27 1052.36C1699.59 1100.51 1675.48 1152.27 1630.04 1173.09Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M1630.04 1173.09C1630.04 1173.05 1630.5 1172.78 1631.49 1172.25C1632.53 1171.67 1633.98 1170.91 1635.78 1169.91C1637.73 1168.99 1639.92 1167.5 1642.56 1165.78C1645.27 1164.17 1648.07 1161.91 1651.28 1159.39C1657.52 1154.18 1664.72 1147.18 1671.23 1137.57C1677.74 1128.04 1683.48 1115.94 1686.62 1101.77C1688.38 1094.73 1688.95 1087.08 1689.14 1079.19C1688.88 1075.25 1689.03 1071.19 1688.3 1067.13C1688 1065.1 1687.8 1063.04 1687.42 1060.97C1686.96 1058.94 1686.46 1056.87 1686 1054.81C1685.62 1052.7 1684.86 1050.71 1684.17 1048.64C1683.48 1046.58 1682.75 1044.51 1682.06 1042.44C1680.34 1038.42 1678.46 1034.33 1676.36 1030.31C1675.17 1028.35 1673.98 1026.44 1672.76 1024.45C1672.15 1023.49 1671.57 1022.46 1670.92 1021.5L1668.78 1018.75C1667.36 1016.91 1665.91 1015.03 1664.45 1013.16C1662.81 1011.43 1661.16 1009.75 1659.51 1007.99L1657.03 1005.39C1656.15 1004.54 1655.19 1003.82 1654.27 1003.05C1652.39 1001.48 1650.56 999.912 1648.68 998.342C1646.65 996.964 1644.62 995.586 1642.56 994.208L1639.46 992.141L1636.13 990.38C1627.44 985.327 1617.6 982.112 1607.49 979.815C1604.93 979.356 1602.36 978.934 1599.76 978.475C1597.16 978.169 1594.52 978.092 1591.87 977.901C1590.53 977.824 1589.23 977.671 1587.89 977.671L1583.91 977.824C1581.27 978.016 1578.55 977.901 1575.91 978.322C1565.19 979.47 1554.67 982.686 1544.48 986.973C1524.35 996.237 1508.19 1012.01 1498.09 1030.19C1487.83 1048.41 1484.08 1069.01 1485.46 1088.07C1486.34 1097.6 1488.44 1106.75 1491.62 1115.29C1492.23 1117.47 1493.26 1119.5 1494.22 1121.53C1495.18 1123.56 1496.1 1125.59 1497.02 1127.58C1499.27 1131.33 1501.42 1135.16 1503.87 1138.6C1513.78 1152.5 1526.42 1162.83 1539.16 1169.65C1551.99 1176.5 1564.89 1179.9 1576.33 1181.28C1579.2 1181.47 1582 1181.7 1584.68 1181.89C1587.36 1182.05 1589.92 1181.78 1592.41 1181.74C1597.39 1181.78 1601.83 1180.78 1605.85 1180.29C1613.81 1178.68 1619.93 1176.96 1623.88 1175.27C1625.83 1174.55 1627.36 1174.01 1628.47 1173.59C1629.47 1173.21 1630 1173.05 1630.04 1173.09C1630.04 1173.13 1629.54 1173.36 1628.51 1173.78C1627.4 1174.24 1625.91 1174.85 1623.99 1175.66C1620.09 1177.45 1613.96 1179.29 1605.92 1181.05C1601.87 1181.63 1597.39 1182.7 1592.37 1182.7C1589.88 1182.78 1587.28 1183.08 1584.56 1182.93C1581.84 1182.78 1579.05 1182.58 1576.14 1182.39C1564.58 1181.09 1551.45 1177.76 1538.44 1170.87C1525.46 1164.06 1512.6 1153.64 1502.45 1139.56C1499.93 1136.04 1497.78 1132.17 1495.45 1128.34C1494.49 1126.31 1493.53 1124.28 1492.58 1122.22C1491.62 1120.15 1490.55 1118.12 1489.9 1115.9C1486.64 1107.25 1484.46 1097.95 1483.54 1088.22C1482.09 1068.82 1485.88 1047.84 1496.29 1029.27C1506.55 1010.71 1523.05 994.629 1543.56 985.174C1553.94 980.772 1564.66 977.518 1575.57 976.37C1578.28 975.949 1581.04 976.063 1583.72 975.872L1587.78 975.719C1589.12 975.719 1590.5 975.872 1591.84 975.949C1594.52 976.178 1597.23 976.255 1599.87 976.561C1602.52 977.02 1605.12 977.48 1607.76 977.939C1618.1 980.274 1628.09 983.566 1636.93 988.734L1640.3 990.533L1643.44 992.639C1645.54 994.055 1647.61 995.471 1649.68 996.888C1651.59 998.496 1653.5 1000.1 1655.38 1001.67C1656.3 1002.48 1657.29 1003.24 1658.18 1004.08L1660.7 1006.73C1662.39 1008.49 1664.07 1010.25 1665.72 1011.97C1667.17 1013.88 1668.63 1015.76 1670.08 1017.64L1672.26 1020.43C1672.91 1021.39 1673.49 1022.42 1674.14 1023.42C1675.36 1025.41 1676.55 1027.4 1677.77 1029.39C1679.92 1033.48 1681.79 1037.62 1683.55 1041.75C1684.28 1043.86 1684.97 1045.96 1685.66 1048.07C1686.35 1050.17 1687.11 1052.2 1687.54 1054.35C1688 1056.45 1688.49 1058.56 1688.95 1060.62C1689.33 1062.73 1689.53 1064.83 1689.83 1066.9C1690.56 1071.04 1690.41 1075.17 1690.64 1079.15C1690.41 1087.19 1689.76 1094.92 1687.96 1102.04C1684.66 1116.4 1678.77 1128.57 1672.11 1138.18C1665.45 1147.79 1658.1 1154.79 1651.74 1159.96C1648.49 1162.45 1645.62 1164.71 1642.86 1166.24C1640.18 1167.92 1637.92 1169.34 1635.97 1170.22C1634.1 1171.14 1632.64 1171.87 1631.57 1172.36C1630.58 1172.86 1630.04 1173.09 1630.04 1173.09Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1596.58 1077.08C1606 1073.14 1612.7 1063.42 1612.74 1052.01C1612.81 1037.04 1601.48 1024.83 1587.43 1024.79C1573.39 1024.72 1561.98 1036.81 1561.9 1051.78C1561.86 1063.3 1568.6 1073.14 1578.09 1077.08C1538.97 1082.98 1540.73 1125.51 1540.73 1125.51L1633.26 1125.93C1633.26 1125.93 1635.36 1082.94 1596.58 1077.08Z", fill: "#3B53A7" }),
	    React.createElement("path", { d: "M1505.63 1016.75C1505.28 1017.18 1488.59 1004.54 1468.34 988.504C1448.09 972.465 1431.98 959.144 1432.32 958.684C1432.67 958.263 1449.36 970.896 1469.61 986.935C1489.82 1002.97 1505.97 1016.33 1505.63 1016.75Z", fill: "#263238" }),
	    React.createElement("path", { d: "M641.267 355.659C577.951 360.712 525.278 308.039 530.293 244.686C534.274 194.845 574.621 154.46 624.462 150.517C687.777 145.464 740.45 198.137 735.435 261.491C731.492 311.293 691.107 351.678 641.267 355.659Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M641.267 355.659C641.267 355.621 641.841 355.506 642.913 355.353C644.1 355.162 645.707 354.932 647.736 354.626C649.88 354.434 652.445 353.784 655.507 353.056C658.608 352.482 662.015 351.334 665.881 350.032C673.499 347.276 682.686 343.142 692.064 336.366C701.443 329.629 710.975 320.25 718.784 308.001C722.842 301.991 726.019 295.024 728.89 287.636C730 283.846 731.531 280.056 732.22 275.999C732.641 273.97 733.139 271.979 733.483 269.912C733.751 267.845 734.019 265.74 734.249 263.634C734.594 261.529 734.555 259.385 734.632 257.203C734.67 255.021 734.747 252.839 734.785 250.657C734.555 246.255 734.172 241.815 733.56 237.298C733.101 235.077 732.641 232.819 732.182 230.56C731.952 229.45 731.761 228.302 731.455 227.192L730.383 223.861C729.655 221.641 728.966 219.383 728.239 217.162C727.282 214.98 726.325 212.837 725.368 210.616L723.913 207.324C723.377 206.253 722.727 205.219 722.114 204.185C720.889 202.08 719.664 199.975 718.439 197.869C716.985 195.879 715.568 193.888 714.114 191.898L711.894 188.912L709.367 186.117C702.936 178.385 694.821 171.992 686.054 166.365C683.796 165.063 681.537 163.762 679.241 162.46C676.906 161.274 674.456 160.317 672.044 159.206C670.819 158.671 669.632 158.096 668.407 157.637L664.618 156.412C662.053 155.685 659.565 154.651 656.923 154.115C646.473 151.512 635.487 150.938 624.462 151.474C602.374 153.273 581.78 162.537 566.085 176.203C550.199 189.792 539.595 207.86 534.389 226.235C531.939 235.498 530.791 244.839 530.867 253.911C530.714 256.17 530.982 258.428 531.174 260.648C531.365 262.869 531.556 265.089 531.748 267.271C532.59 271.597 533.279 275.884 534.389 279.98C538.944 296.44 547.251 310.451 556.936 321.246C566.621 332.079 577.607 339.697 587.866 344.903C590.508 346.089 593.034 347.238 595.484 348.31C597.934 349.381 600.46 349.994 602.795 350.836C607.427 352.597 611.983 353.133 615.926 354.052C623.964 355.277 630.319 355.774 634.606 355.545C636.673 355.545 638.319 355.545 639.506 355.545C640.731 355.583 641.267 355.621 641.267 355.659C641.267 355.698 640.693 355.736 639.621 355.812C638.434 355.851 636.788 355.927 634.721 356.042C630.434 356.387 624.041 356.042 615.926 354.932C611.906 354.052 607.351 353.554 602.642 351.831C600.269 351.028 597.704 350.415 595.216 349.381C592.728 348.31 590.163 347.161 587.483 346.013C577.033 340.845 565.894 333.189 555.979 322.279C546.103 311.408 537.605 297.244 532.896 280.516C531.748 276.343 531.021 271.979 530.14 267.615C529.949 265.395 529.719 263.137 529.528 260.878C529.336 258.62 529.03 256.323 529.183 254.026C529.068 244.801 530.217 235.307 532.705 225.852C537.987 207.133 548.744 188.72 564.898 174.825C580.899 160.891 601.915 151.436 624.424 149.598C635.64 149.024 646.856 149.636 657.536 152.278C660.216 152.814 662.78 153.847 665.383 154.613L669.25 155.838C670.513 156.297 671.738 156.91 672.963 157.446C675.413 158.556 677.939 159.551 680.312 160.776C682.648 162.116 684.944 163.456 687.241 164.757C696.122 170.499 704.429 177.045 710.937 184.892L713.501 187.725L715.76 190.787C717.253 192.816 718.707 194.883 720.162 196.912C721.387 199.094 722.65 201.238 723.875 203.382C724.488 204.453 725.138 205.487 725.674 206.597L727.167 209.966C728.124 212.186 729.12 214.406 730.077 216.626C730.804 218.923 731.531 221.182 732.258 223.479L733.33 226.847C733.637 227.996 733.79 229.144 734.058 230.292C734.517 232.589 734.976 234.886 735.436 237.145C736.048 241.7 736.393 246.255 736.622 250.734C736.546 252.954 736.508 255.174 736.469 257.395C736.393 259.577 736.431 261.797 736.048 263.94C735.78 266.084 735.512 268.228 735.244 270.333C734.9 272.439 734.364 274.467 733.905 276.535C733.177 280.669 731.608 284.497 730.459 288.325C727.512 295.789 724.22 302.833 720.085 308.919C712.085 321.284 702.362 330.701 692.83 337.438C683.298 344.214 673.958 348.233 666.225 350.913C662.321 352.138 658.837 353.248 655.737 353.784C652.636 354.434 650.033 355.009 647.889 355.162C645.822 355.391 644.214 355.545 643.028 355.659C641.841 355.659 641.267 355.698 641.267 355.659Z", fill: "#263238" }),
	    React.createElement("path", { d: "M642.491 254.524C651.908 250.581 658.607 240.858 658.646 229.45C658.722 214.483 647.391 202.271 633.343 202.233C619.294 202.157 607.886 214.253 607.81 229.221C607.771 240.743 614.509 250.581 624.002 254.524C584.88 260.419 586.641 302.948 586.641 302.948L679.164 303.369C679.164 303.369 681.269 260.38 642.491 254.524Z", fill: "#3B53A7" }),
	    React.createElement("path", { d: "M800.588 409.634C800.244 410.055 777.773 392.14 750.441 369.632C723.109 347.123 701.213 328.519 701.558 328.098C701.902 327.677 724.373 345.592 751.704 368.1C779.036 390.609 800.933 409.213 800.588 409.634Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1309.44 229.795C1263.78 233.431 1225.76 195.419 1229.4 149.751C1232.27 113.806 1261.4 84.6753 1297.35 81.8043C1343.02 78.1677 1381.03 116.18 1377.39 161.848C1374.52 197.831 1345.39 226.924 1309.44 229.795Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M1309.44 229.795C1309.44 229.756 1309.83 229.68 1310.63 229.527C1311.51 229.374 1312.66 229.221 1314.11 228.991C1315.65 228.838 1317.52 228.378 1319.7 227.842C1321.92 227.421 1324.41 226.579 1327.17 225.622C1332.64 223.632 1339.26 220.646 1346 215.746C1352.74 210.884 1359.59 204.109 1365.22 195.304C1368.13 190.979 1370.42 185.964 1372.49 180.643C1374.25 175.246 1375.82 169.504 1376.36 163.379C1377.7 151.206 1375.74 137.77 1369.96 125.29C1368.74 122.075 1366.67 119.204 1364.99 116.103C1363.95 114.687 1362.92 113.232 1361.89 111.816L1360.32 109.672L1358.52 107.682C1353.89 102.131 1348.03 97.5374 1341.79 93.4797C1335.47 89.422 1328.28 86.7041 1320.85 84.6753C1313.35 82.7996 1305.42 82.3785 1297.5 82.7996C1281.65 84.1011 1266.84 90.7618 1255.55 100.562C1244.14 110.323 1236.52 123.3 1232.73 136.506C1229.25 149.828 1229.4 163.379 1232.69 175.169C1235.95 186.998 1241.92 197.104 1248.88 204.836C1255.85 212.645 1263.74 218.119 1271.13 221.909C1273 222.751 1274.84 223.593 1276.6 224.397C1278.36 225.163 1280.2 225.622 1281.88 226.196C1285.21 227.46 1288.47 227.881 1291.34 228.532C1297.12 229.412 1301.67 229.795 1304.77 229.642C1306.23 229.642 1307.41 229.642 1308.3 229.642C1309.02 229.756 1309.44 229.756 1309.44 229.795C1309.44 229.833 1309.06 229.871 1308.26 229.91C1307.34 229.948 1306.19 230.024 1304.74 230.101C1301.63 230.369 1297 230.139 1291.15 229.335C1288.24 228.723 1284.94 228.34 1281.54 227.115C1279.82 226.541 1277.98 226.12 1276.18 225.354C1274.38 224.589 1272.5 223.747 1270.59 222.904C1263.05 219.191 1254.97 213.679 1247.81 205.793C1240.65 197.946 1234.49 187.687 1231.08 175.59C1227.64 163.532 1227.41 149.675 1230.93 136.009C1234.72 122.458 1242.53 109.136 1254.21 99.0686C1265.77 89.0009 1281 82.1488 1297.31 80.809C1305.42 80.3879 1313.54 80.8473 1321.27 82.7613C1328.93 84.8284 1336.32 87.6229 1342.79 91.7954C1349.22 95.9296 1355.23 100.676 1359.94 106.38L1361.77 108.447L1363.38 110.667C1364.45 112.16 1365.52 113.615 1366.56 115.108C1368.28 118.285 1370.35 121.233 1371.61 124.525C1377.51 137.387 1379.42 151.129 1377.97 163.57C1377.39 169.81 1375.74 175.705 1373.91 181.179C1371.76 186.577 1369.39 191.668 1366.4 196.07C1360.62 204.989 1353.54 211.803 1346.65 216.665C1339.72 221.526 1333.02 224.436 1327.4 226.35C1324.56 227.23 1322.08 228.034 1319.82 228.378C1317.6 228.838 1315.72 229.259 1314.15 229.335C1312.7 229.489 1311.55 229.603 1310.63 229.68C1309.83 229.833 1309.44 229.833 1309.44 229.795Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1310.29 157.063C1317.06 154.23 1321.88 147.225 1321.92 138.956C1321.96 128.161 1313.81 119.357 1303.66 119.319C1293.52 119.28 1285.29 128.008 1285.25 138.803C1285.21 147.11 1290.07 154.192 1296.93 157.063C1268.71 161.312 1269.98 191.974 1269.98 191.974L1336.7 192.28C1336.74 192.319 1338.27 161.312 1310.29 157.063Z", fill: "#3B53A7" }),
	    React.createElement("path", { d: "M1283.91 227.421C1284.41 227.651 1278.55 242.236 1270.78 260.036C1263.05 277.836 1256.35 292.076 1255.85 291.847C1255.35 291.617 1261.21 277.032 1268.98 259.232C1276.71 241.47 1283.41 227.23 1283.91 227.421Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1668.7 657.076C1610.06 661.746 1561.25 612.939 1565.92 554.294C1569.6 508.129 1606.99 470.729 1653.16 467.054C1711.81 462.384 1760.61 511.191 1755.94 569.836C1752.23 616.002 1714.83 653.401 1668.7 657.076Z", fill: "#FAFAFA" }),
	    React.createElement("path", { d: "M1668.7 657.076C1668.7 657.038 1669.2 656.961 1670.23 656.77C1671.34 656.617 1672.84 656.387 1674.71 656.119C1676.7 655.928 1679.08 655.354 1681.91 654.665C1684.78 654.129 1687.96 653.057 1691.52 651.87C1698.6 649.305 1707.1 645.477 1715.79 639.199C1724.44 632.96 1733.28 624.27 1740.52 612.939C1744.27 607.35 1747.21 600.919 1749.89 594.106C1752.19 587.139 1754.22 579.751 1754.87 571.865C1756.59 556.17 1754.1 538.906 1746.64 522.79L1745.3 519.728C1744.8 518.732 1744.19 517.775 1743.65 516.818C1742.54 514.866 1741.4 512.914 1740.29 510.961C1738.95 509.124 1737.61 507.286 1736.27 505.411L1734.24 502.616L1731.9 500.052C1725.97 492.893 1718.43 486.96 1710.35 481.792C1702.24 476.548 1692.93 473.064 1683.36 470.461C1673.68 468.05 1663.5 467.514 1653.31 468.011C1632.87 469.696 1613.81 478.27 1599.26 490.903C1584.56 503.497 1574.76 520.225 1569.9 537.221C1567.64 545.796 1566.57 554.409 1566.65 562.831C1566.49 564.936 1566.76 567.003 1566.92 569.07C1567.11 571.138 1567.26 573.166 1567.45 575.195C1568.22 579.176 1568.87 583.157 1569.9 586.985C1574.11 602.221 1581.81 615.198 1590.76 625.189C1599.72 635.218 1609.87 642.3 1619.4 647.123C1621.85 648.233 1624.18 649.267 1626.48 650.301C1628.78 651.296 1631.11 651.87 1633.25 652.636C1637.54 654.243 1641.75 654.779 1645.43 655.622C1652.85 656.77 1658.75 657.229 1662.73 657C1664.64 657 1666.14 657 1667.25 657C1668.17 657.038 1668.66 657.038 1668.7 657.076C1668.7 657.114 1668.17 657.153 1667.17 657.229C1666.06 657.268 1664.57 657.344 1662.65 657.421C1658.67 657.765 1652.74 657.421 1645.24 656.387C1641.52 655.583 1637.27 655.124 1632.91 653.516C1630.73 652.789 1628.35 652.215 1626.02 651.258C1623.72 650.262 1621.31 649.229 1618.86 648.119C1609.18 643.334 1598.84 636.252 1589.69 626.146C1580.54 616.078 1572.66 602.948 1568.29 587.445C1567.22 583.579 1566.57 579.521 1565.77 575.463C1565.58 573.396 1565.38 571.329 1565.19 569.224C1565 567.118 1564.73 565.013 1564.89 562.869C1564.77 554.294 1565.84 545.49 1568.14 536.762C1573.04 519.383 1582.99 502.348 1597.96 489.448C1612.78 476.548 1632.26 467.782 1653.12 466.059C1663.53 465.523 1673.91 466.097 1683.82 468.547C1693.62 471.188 1703.08 474.787 1711.38 480.146C1719.61 485.467 1727.31 491.515 1733.36 498.827L1735.73 501.468L1737.8 504.301C1739.18 506.215 1740.52 508.09 1741.89 509.966C1743.04 511.957 1744.19 513.985 1745.34 515.938C1745.91 516.933 1746.49 517.89 1747.02 518.924L1748.4 522.024C1755.94 538.485 1758.43 556.055 1756.59 572.018C1755.87 580.018 1753.8 587.56 1751.43 594.603C1748.67 601.532 1745.64 608.039 1741.82 613.667C1734.39 625.112 1725.36 633.84 1716.55 640.08C1707.71 646.358 1699.06 650.071 1691.9 652.559C1688.26 653.708 1685.05 654.741 1682.18 655.2C1679.31 655.813 1676.89 656.349 1674.9 656.464C1672.99 656.655 1671.5 656.808 1670.39 656.923C1669.2 657.076 1668.7 657.114 1668.7 657.076Z", fill: "#263238" }),
	    React.createElement("path", { d: "M1669.77 563.673C1678.5 559.998 1684.7 551.04 1684.74 540.437C1684.78 526.58 1674.29 515.287 1661.28 515.21C1648.26 515.134 1637.7 526.35 1637.62 540.207C1637.58 550.887 1643.82 559.998 1652.62 563.673C1616.37 569.147 1618.02 608.537 1618.02 608.537L1703.73 608.92C1703.77 608.92 1705.72 569.109 1669.77 563.673Z", fill: "#ECC651" }),
	    React.createElement("path", { d: "M1568.48 585.454C1568.64 585.99 1558.42 589.091 1545.67 592.383C1532.92 595.675 1522.47 597.933 1522.32 597.398C1522.17 596.862 1532.39 593.761 1545.13 590.469C1557.92 587.177 1568.37 584.918 1568.48 585.454Z", fill: "#263238" }),
	    React.createElement("path", { d: "M439.301 1658.67L379.125 1737.8L349.573 1814.13C347.429 1819.64 341.113 1822.17 335.754 1819.68C332.768 1818.26 330.624 1815.54 330.05 1812.29C326.299 1791.62 312.939 1715.44 317.647 1709.89C323.121 1703.46 375.603 1622.19 375.603 1622.19L439.301 1658.67Z", fill: "#E06255" }),
	    React.createElement(
	      "g",
	      { opacity: "0.6" },
	      React.createElement("path", { d: "M335.754 1819.68L321.59 1704.46L319.102 1707.86C316.959 1710.81 315.925 1714.41 316.193 1718.04C316.959 1727.77 319.638 1754.53 329.782 1812.1C330.395 1815.51 332.615 1818.34 335.754 1819.68Z", fill: "white" })
	    ),
	    React.createElement(
	      "g",
	      { opacity: "0.6" },
	      React.createElement("path", { d: "M356.923 1690.48C357.919 1693.35 356.387 1696.88 353.555 1697.99C350.722 1699.1 347.124 1697.56 346.09 1694.73C345.018 1691.9 346.779 1687.61 349.688 1686.81C352.598 1686 356.732 1688.07 357.076 1691.06", fill: "white" })
	    ),
	    React.createElement("path", { d: "M342.836 1771.18C343.142 1771.71 348.003 1768.84 354.434 1770.03C360.904 1771.02 364.54 1775.39 365 1774.97C365.229 1774.81 364.655 1773.47 362.971 1771.83C361.287 1770.18 358.377 1768.5 354.817 1767.89C351.257 1767.27 347.927 1767.92 345.821 1768.88C343.678 1769.88 342.683 1770.99 342.836 1771.18Z", fill: "#263238" }),
	    React.createElement("path", { d: "M340.768 1786.11C340.883 1786.72 345.362 1785.99 350.415 1787.83C355.468 1789.55 358.53 1792.92 359.028 1792.5C359.564 1792.27 356.922 1787.75 351.142 1785.76C345.4 1783.73 340.5 1785.61 340.768 1786.11Z", fill: "#263238" }),
	    React.createElement("path", { d: "M342.185 1749.63C342.3 1750.28 349.19 1749.09 357.229 1751.27C365.344 1753.3 370.78 1757.66 371.201 1757.13C371.661 1756.78 366.493 1751.35 357.803 1749.13C349.152 1746.87 341.955 1749.13 342.185 1749.63Z", fill: "#263238" }),
	    React.createElement("path", { d: "M358.492 1724.05C358.339 1724.71 364.158 1726.05 370.091 1730.06C376.101 1733.97 379.623 1738.75 380.159 1738.41C380.656 1738.18 377.747 1732.48 371.316 1728.27C364.885 1723.94 358.492 1723.48 358.492 1724.05Z", fill: "#263238" }),
	    React.createElement("path", { d: "M375.565 1700.36C375.489 1701.01 381.881 1701.55 387.815 1706.29C393.825 1710.89 395.93 1716.97 396.543 1716.7C396.811 1716.63 396.657 1714.98 395.586 1712.57C394.514 1710.16 392.37 1707.06 389.155 1704.57C385.939 1702.08 382.417 1700.74 379.814 1700.32C377.211 1699.82 375.565 1700.09 375.565 1700.36Z", fill: "#263238" }),
	    React.createElement("path", { d: "M390.915 1701.7C391.03 1701.78 391.987 1700.82 393.25 1698.75C394.475 1696.68 396.006 1693.39 396.619 1689.03C396.849 1686.88 397.308 1684.32 395.853 1681.64C395.126 1680.3 393.327 1679.31 391.566 1679.65C389.882 1679.99 388.618 1681.1 387.661 1682.37C384.025 1687.54 384.829 1695.65 390.073 1700.55C395.394 1705.37 403.012 1705.87 408.486 1703.12C409.826 1702.35 411.165 1701.2 411.548 1699.36C411.931 1697.56 410.706 1695.8 409.404 1695.19C406.763 1693.81 404.237 1694.08 402.093 1694.12C397.691 1694.35 394.284 1695.42 392.064 1696.38C389.843 1697.34 388.733 1698.14 388.81 1698.25C388.925 1698.68 393.71 1695.77 402.131 1695.65C404.198 1695.69 406.648 1695.65 408.486 1696.76C409.404 1697.3 409.864 1698.14 409.672 1699.02C409.519 1699.9 408.601 1700.78 407.529 1701.35C402.973 1703.57 396.006 1703.08 391.604 1698.94C387.164 1694.85 386.475 1687.73 389.346 1683.52C390.035 1682.52 391.03 1681.72 391.987 1681.53C392.944 1681.33 393.824 1681.76 394.36 1682.6C395.471 1684.36 395.279 1686.81 395.126 1688.84C394.169 1697.18 390.494 1701.51 390.915 1701.7Z", fill: "#263238" }),
	    React.createElement("path", { d: "M501.965 1700.9L508.09 1781.7C508.09 1781.7 427.855 1809.19 427.511 1824.23L584.803 1823.89L580.439 1697.56L501.965 1700.9Z", fill: "#E06255" }),
	    React.createElement(
	      "g",
	      { opacity: "0.6" },
	      React.createElement("path", { d: "M556.4 1772.98C559.462 1773.7 561.721 1777.03 561.147 1780.13C560.572 1783.24 557.204 1785.53 554.103 1784.88C551.003 1784.23 548.208 1780.29 549.127 1777.3C550.045 1774.28 554.18 1771.79 557.012 1773.17", fill: "white" })
	    ),
	    React.createElement(
	      "g",
	      { opacity: "0.6" },
	      React.createElement("path", { d: "M584.803 1823.89L584.344 1811.14L432.487 1816.77C432.487 1816.77 427.473 1818.99 426.707 1825.38L584.803 1823.89Z", fill: "white" })
	    ),
	    React.createElement("path", { d: "M505.487 1781.02C505.525 1781.78 509.392 1781.97 513.258 1784.31C517.201 1786.53 519.268 1789.78 519.957 1789.44C520.646 1789.25 519.344 1784.73 514.598 1782.01C509.928 1779.22 505.296 1780.33 505.487 1781.02Z", fill: "#263238" }),
	    React.createElement("path", { d: "M489.295 1788.48C489.142 1789.25 492.511 1790.39 495.267 1793.53C498.099 1796.6 498.903 1800.08 499.669 1800C500.396 1800.08 500.741 1795.56 497.257 1791.73C493.812 1787.91 489.295 1787.75 489.295 1788.48Z", fill: "#263238" }),
	    React.createElement("path", { d: "M480.72 1808.58C481.409 1808.73 482.328 1804.83 480.184 1800.73C478.079 1796.6 474.404 1795.06 474.098 1795.71C473.677 1796.37 476.127 1798.51 477.811 1801.95C479.61 1805.32 479.955 1808.54 480.72 1808.58Z", fill: "#263238" }),
	    React.createElement("path", { d: "M506.138 1762.45C506.483 1763.14 509.966 1761.95 514.33 1762.07C518.694 1762.1 522.101 1763.41 522.484 1762.76C522.905 1762.18 519.498 1759.46 514.368 1759.39C509.239 1759.27 505.755 1761.84 506.138 1762.45Z", fill: "#263238" }),
	    React.createElement(
	      "g",
	      { opacity: "0.3" },
	      React.createElement("path", { d: "M503.19 1716.9L504.262 1731.29L581.473 1727.54L581.052 1714.52L503.19 1716.9Z", fill: "black" })
	    ),
	    React.createElement("path", { d: "M505.219 1746.1C505.219 1746.41 508.282 1746.79 513.105 1745.76C515.516 1745.26 518.311 1744.34 521.22 1742.89C522.675 1742.16 524.168 1741.32 525.661 1740.32C526.35 1739.83 527.192 1739.33 527.957 1738.37C528.761 1737.53 529.182 1735.5 528.149 1734.28C527.307 1733.09 525.852 1732.63 524.704 1732.67C523.555 1732.67 522.598 1732.94 521.756 1733.2C520.034 1733.7 518.387 1734.35 516.933 1735.08C513.985 1736.57 511.612 1738.37 509.851 1740.13C506.329 1743.65 505.219 1746.56 505.487 1746.72C505.832 1746.95 507.516 1744.5 511.114 1741.55C512.913 1740.09 515.21 1738.56 517.966 1737.3C519.344 1736.69 520.837 1736.15 522.445 1735.73C524.091 1735.23 525.508 1735.16 525.967 1735.88C526.12 1736.15 526.158 1736.27 525.814 1736.76C525.469 1737.22 524.818 1737.68 524.129 1738.18C522.79 1739.14 521.412 1739.98 520.072 1740.71C517.392 1742.16 514.789 1743.19 512.569 1743.92C508.128 1745.38 505.181 1745.68 505.219 1746.1Z", fill: "#263238" }),
	    React.createElement("path", { d: "M506.253 1747.18C506.521 1747.29 507.937 1744.46 508.014 1739.48C508.052 1736.99 507.669 1734.05 506.597 1730.91C506.061 1729.34 505.334 1727.77 504.415 1726.2C503.42 1724.67 502.233 1722.64 499.248 1722.41C497.678 1722.41 496.453 1723.67 496.032 1724.74C495.573 1725.82 495.496 1726.73 495.343 1727.65C495.113 1729.49 495.228 1731.29 495.534 1732.94C496.147 1736.27 497.64 1738.98 499.209 1740.94C502.425 1744.88 505.679 1745.68 505.717 1745.41C505.947 1745.03 503.229 1743.65 500.702 1739.83C499.477 1737.95 498.329 1735.42 497.908 1732.51C497.678 1731.06 497.64 1729.53 497.869 1727.96C498.061 1726.27 498.635 1724.9 499.248 1725.05C500.013 1725.01 501.391 1726.2 502.119 1727.5C502.999 1728.88 503.688 1730.29 504.224 1731.67C505.334 1734.47 505.87 1737.18 506.061 1739.48C506.559 1744.15 505.832 1747.06 506.253 1747.18Z", fill: "#263238" }),
	    React.createElement("path", { d: "M451.091 1009.48C451.091 1009.48 414.074 1080.45 414.074 1137.91C414.074 1150.05 489.18 1752.61 489.18 1752.61L595.483 1743.69L543.92 1186.95L560.61 1073.79L451.091 1009.48Z", fill: "#263238" }),
	    React.createElement("path", { d: "M687.777 1072.38C687.777 1072.38 662.933 1279.85 651.296 1359.78C639.084 1443.46 615.121 1459.27 615.121 1459.27L403.318 1727.16L333.687 1665.45L516.091 1391.4C516.091 1391.4 554.754 1064.26 553.146 1072.38C551.538 1080.45 687.777 1072.38 687.777 1072.38Z", fill: "#263238" }),
	    React.createElement("path", { d: "M611.332 1462.76C611.408 1462.79 610.757 1463.67 609.533 1465.32C608.154 1467.12 606.317 1469.45 604.058 1472.4C599.159 1478.72 592.307 1487.56 583.885 1498.36C566.889 1520.6 543.691 1550.99 518.005 1584.6C492.319 1618.33 468.93 1648.76 451.589 1670.5C442.938 1681.37 435.856 1690.1 430.88 1696.07C428.468 1698.9 426.554 1701.16 425.099 1702.89C423.76 1704.42 423.032 1705.22 422.956 1705.18C422.918 1705.14 423.53 1704.26 424.755 1702.62C426.133 1700.82 427.97 1698.48 430.229 1695.54C435.129 1689.22 441.981 1680.38 450.403 1669.58C467.399 1647.34 490.635 1616.95 516.282 1583.34C541.93 1549.61 565.357 1519.18 582.66 1497.48C591.311 1486.6 598.393 1477.88 603.369 1471.9C605.781 1469.07 607.695 1466.81 609.15 1465.09C610.566 1463.48 611.293 1462.68 611.332 1462.76Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M572.669 1144.53C572.975 1145.03 563.252 1151.12 552.534 1160.19C541.739 1169.22 534.083 1177.72 533.623 1177.34C533.432 1177.19 535.078 1174.81 538.179 1171.33C541.241 1167.85 545.796 1163.25 551.232 1158.66C556.668 1154.1 561.989 1150.39 565.97 1147.98C569.913 1145.57 572.516 1144.34 572.669 1144.53Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M534.465 1176.08C534.388 1176.57 528.493 1175.69 522.292 1171.9C516.091 1168.15 512.569 1163.33 512.99 1163.02C513.411 1162.64 517.431 1166.62 523.326 1170.18C529.221 1173.82 534.618 1175.5 534.465 1176.08Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M679.394 1127.58C679.317 1128.15 668.905 1126.89 656.004 1126.16C643.104 1125.43 632.615 1125.51 632.615 1124.93C632.577 1124.4 643.104 1123.4 656.119 1124.17C669.134 1124.86 679.508 1127.04 679.394 1127.58Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M539.288 1193.84C539.326 1193.84 539.326 1194.14 539.288 1194.8C539.211 1195.52 539.135 1196.44 539.058 1197.55C538.79 1200.15 538.446 1203.68 537.986 1208.16C536.953 1217.53 535.498 1230.78 533.737 1247.09C529.948 1280.08 524.703 1325.41 518.961 1375.44C518.311 1380.95 517.66 1386.39 517.086 1391.52L517.047 1391.75L516.932 1391.94C491.055 1430.79 468.011 1465.36 451.321 1490.43C443.014 1502.76 436.277 1512.71 431.53 1519.72C429.233 1523.05 427.434 1525.65 426.094 1527.6C425.52 1528.41 425.022 1529.06 424.639 1529.63C424.295 1530.09 424.103 1530.28 424.103 1530.28C424.065 1530.28 424.218 1530.01 424.486 1529.52C424.831 1528.94 425.252 1528.25 425.788 1527.41C427.051 1525.42 428.735 1522.74 430.917 1519.33C435.549 1512.21 442.095 1502.15 450.172 1489.7C466.747 1464.55 489.601 1429.83 515.248 1390.87L515.095 1391.29C515.708 1386.16 516.32 1380.72 516.971 1375.21C522.981 1325.18 528.378 1279.89 532.359 1246.89C534.388 1230.63 536.072 1217.38 537.259 1208.04C537.872 1203.6 538.331 1200.08 538.676 1197.47C538.829 1196.36 538.982 1195.48 539.097 1194.72C539.173 1194.14 539.25 1193.84 539.288 1193.84Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M491.898 676.522C491.898 676.522 454.728 698.84 443.589 718.63C432.449 738.459 372.885 872.095 375.374 895.599C377.862 919.141 433.636 945.325 433.636 945.325L491.898 869.76L457.216 846.218L491.898 802.846V676.522Z", fill: "#ECC651" }),
	    React.createElement("path", { d: "M551.921 657.268L491.898 676.522C491.898 676.522 464.643 935.448 451.015 972.618C437.388 1009.79 421.233 1061.7 421.233 1061.7C421.233 1061.7 441.369 1125.55 525.623 1135.46C609.877 1145.38 693.519 1093.85 693.519 1093.85C693.519 1093.85 721.004 973.958 735.857 864.937C750.709 755.915 739.608 690.992 739.608 690.992L645.057 654.55L551.921 657.268Z", fill: "#ECC651" }),
	    React.createElement("path", { d: "M433.636 945.363C433.636 945.363 568.611 972.35 617.609 914.241L603.408 864.937C603.408 864.937 514.253 886.029 486.386 876.957L433.636 945.363Z", fill: "#ECC651" }),
	    React.createElement("path", { d: "M615.351 857.778C615.351 857.778 640.501 808.167 643.218 807.555C645.936 806.942 685.556 793.047 685.556 793.047C685.556 793.047 687.661 798.483 685.556 803.038L699.758 804.837C699.758 804.837 697.653 813.603 692.791 814.828L697.921 819.345C697.921 819.345 693.671 825.164 688.236 827.537C682.8 829.91 678.857 827.537 678.857 827.537C678.857 827.537 680.656 830.829 672.503 835.959C664.349 841.088 647.889 864.937 647.889 864.937L615.351 857.778Z", fill: "#BA7F72" }),
	    React.createElement("path", { d: "M684.293 803.191C684.485 803.765 672.886 808.282 658.378 813.297C654.779 814.598 651.181 815.594 648.348 816.934C645.477 818.273 643.678 820.494 642.415 822.561C640.042 826.81 639.161 829.91 638.817 829.796C638.625 829.719 638.932 826.58 641.075 821.833C642.185 819.537 644.214 816.742 647.43 815.173C650.569 813.565 654.052 812.608 657.689 811.268C672.159 806.253 684.102 802.617 684.293 803.191Z", fill: "#8B5D54" }),
	    React.createElement("path", { d: "M693.518 814.828C693.595 815.096 690.915 816.283 686.36 817.431C681.805 818.656 675.412 819.69 668.636 821.527C661.861 823.364 656.157 826.236 652.597 829.068C648.999 831.863 647.391 834.313 647.085 834.121C646.893 834.045 648.042 831.212 651.602 827.92C655.085 824.628 661.057 821.336 668.062 819.46C675.067 817.584 681.46 816.78 686.054 815.976C690.609 815.173 693.442 814.56 693.518 814.828Z", fill: "#8B5D54" }),
	    React.createElement("path", { d: "M657.229 835.729C656.846 835.346 660.598 831.48 666.722 829.298C672.847 827.078 678.206 827.69 678.13 828.264C678.13 828.915 673.115 829.26 667.411 831.327C661.708 833.317 657.612 836.227 657.229 835.729Z", fill: "#EB996E" }),
	    React.createElement("path", { d: "M717.674 689.423C714.114 690.495 690.112 722.382 677.709 764.49C665.307 806.598 651.679 849.969 651.679 849.969L647.889 864.937L494.846 827.537L460.738 873.205C460.738 873.205 559.884 959.412 632.845 962.627C642.492 961.938 692.064 956.12 721.042 908.193C753.236 854.907 773.065 789.257 773.065 789.257C773.065 789.257 770.921 673.613 717.674 689.423Z", fill: "#ECC651" }),
	    React.createElement("path", { d: "M487.458 791.439C486.884 791.324 488.377 781.907 490.788 770.423C493.2 758.939 495.65 749.714 496.224 749.829C496.798 749.944 495.305 759.36 492.894 770.883C490.482 782.367 488.032 791.554 487.458 791.439Z", fill: "#263238" }),
	    React.createElement(
	      "g",
	      { opacity: "0.3" },
	      React.createElement("path", { d: "M593.646 955.354C585.645 951.985 577.989 947.468 569.415 946.167C559.002 944.597 550.275 947.66 539.862 949.306C508.856 954.167 485.696 950.454 456.45 949.191L454.881 958.187C467.743 968.216 483.935 971.432 500.281 971.125C515.095 970.857 529.642 966.034 544.456 966.455C556.131 966.761 567.462 970.36 578.755 973.346C597.627 978.36 617.341 981.423 636.673 978.513C685.173 971.202 711.165 926.108 719.281 908.346C716.448 912.94 702.285 929.783 698.571 933.649C667.641 965.728 619.255 966.149 593.646 955.354Z", fill: "black" })
	    ),
	    React.createElement("path", { d: "M626.223 820.264C626.07 820.8 617.457 818.465 607.044 815.058C596.632 811.651 588.326 808.474 588.479 807.938C588.632 807.402 597.245 809.737 607.657 813.144C618.107 816.551 626.414 819.728 626.223 820.264Z", fill: "white" }),
	    React.createElement("path", { d: "M742.862 867.004C742.9 867.004 742.824 867.31 742.632 867.884C742.402 868.573 742.134 869.415 741.79 870.411C740.986 872.593 739.646 875.77 737.656 879.751C733.675 887.675 727.014 898.738 717.635 911.523C712.927 917.916 707.529 924.768 701.29 931.697C698.189 935.18 694.782 938.626 691.107 942.032C687.279 945.401 682.762 948.042 678.015 950.339C668.407 954.665 657.957 958.569 646.588 960.522C635.257 962.665 623.122 962.474 611.179 960.177C599.197 957.766 587.981 953.823 577.454 949.421C572.095 947.392 567.08 944.827 562.065 942.607C557.127 940.157 552.342 937.745 547.71 935.257C529.259 925.228 513.45 914.777 500.588 905.552C487.726 896.288 477.735 888.211 470.997 882.469C467.629 879.598 465.064 877.301 463.341 875.732C461.619 874.124 460.776 873.282 460.815 873.205C460.853 873.167 461.083 873.358 461.542 873.741C462.078 874.2 462.767 874.736 463.609 875.425C465.523 876.995 468.164 879.177 471.495 881.895C478.385 887.445 488.491 895.331 501.43 904.442C514.368 913.514 530.178 923.811 548.591 933.687C553.184 936.137 558.008 938.511 562.908 940.922C567.922 943.104 572.899 945.669 578.22 947.621C588.708 951.985 599.848 955.89 611.6 958.225C623.352 960.483 635.218 960.675 646.32 958.608C657.459 956.732 667.833 952.904 677.288 948.693C681.958 946.473 686.361 943.908 689.997 940.731C693.634 937.439 697.002 934.032 700.141 930.587C706.419 923.735 711.817 916.997 716.602 910.681C726.095 898.049 732.871 887.177 737.082 879.368C739.149 875.464 740.603 872.363 741.522 870.219C741.943 869.224 742.249 868.42 742.556 867.769C742.709 867.272 742.862 867.004 742.862 867.004Z", fill: "#263238" }),
	    React.createElement("path", { d: "M685.136 740.527C685.212 740.527 685.021 741.407 684.562 743.053C684.064 744.891 683.413 747.264 682.609 750.25C680.772 756.681 678.169 765.677 675.03 776.74C668.369 799.325 659.182 830.37 648.923 865.243L648.655 866.162L647.621 865.894C643.985 864.975 639.621 864.095 635.487 863.176C597.015 854.946 562.295 846.907 537.337 840.323C524.857 837.069 514.828 834.16 507.938 832.092C504.646 831.021 502.004 830.178 500.014 829.566C498.215 828.953 497.296 828.609 497.296 828.532C497.334 828.456 498.291 828.685 500.129 829.183C502.157 829.719 504.799 830.446 508.129 831.365C515.096 833.203 525.164 835.92 537.681 838.983C562.678 845.222 597.436 853.032 635.908 861.262C640.157 862.219 644.176 862.984 648.349 864.094L647.047 864.745C657.574 829.987 666.953 798.98 673.767 776.433C677.174 765.447 679.968 756.528 681.959 750.097C682.916 747.149 683.681 744.814 684.255 743.015C684.753 741.331 685.059 740.488 685.136 740.527Z", fill: "#263238" }),
	    React.createElement("path", { d: "M465.6 872.325L421.961 873.932C417.597 874.086 413.539 870.104 411.663 863.865L377.517 744.163C375.374 735.895 379.929 729.234 387.394 728.736L445.043 725.1C454.307 725.1 459.284 729.081 460.93 736.086L483.4 830.829C488.185 850.964 479.227 871.827 465.6 872.325Z", fill: "#263238" }),
	    React.createElement("path", { d: "M502.923 815.823L491.324 791.286L472.261 784.931L478.118 808.397C470.615 811.995 459.399 813.871 452.929 810.311C446.46 806.751 421.157 781.563 416.372 783.974C411.587 786.386 407.338 792.166 411.702 797.679C416.066 803.191 439.799 820.34 434.9 825.393C430 830.446 402.668 808.244 394.591 809.928C386.552 811.574 381.652 816.244 386.131 819.651C390.571 823.02 401.596 834.121 403.548 838.945C403.051 844.993 400.218 853.529 402.821 855.022C406.687 857.204 420.2 861.874 422.956 861.989C424.411 862.066 434.593 866.047 443.972 869.836C454.537 874.086 466.251 874.353 476.969 870.602L482.443 868.688C490.98 865.702 496.645 857.625 496.53 848.591L496.339 830.485L502.923 815.823Z", fill: "#BA7F72" }),
	    React.createElement("path", { d: "M473.639 810.158C473.524 810.196 472.873 808.129 471.801 804.378C470.691 800.282 469.237 794.884 467.476 788.415C465.715 781.563 463.61 773.524 461.313 764.681C460.164 760.202 458.978 755.494 457.753 750.671C456.375 745.924 455.839 740.373 452.508 736.775C449.063 733.215 443.551 733.024 438.727 733.253C433.751 733.636 428.928 733.981 424.296 734.325C415.185 734.976 406.917 735.55 399.873 736.086C393.174 736.507 387.624 736.852 383.375 737.081C379.47 737.273 377.326 737.311 377.288 737.196C377.288 737.043 379.432 736.737 383.298 736.316C387.547 735.895 393.059 735.359 399.758 734.67C406.84 734.057 415.07 733.292 424.181 732.488C428.813 732.105 433.636 731.722 438.613 731.301C441.139 731.186 443.78 731.148 446.46 731.646C449.101 732.143 451.896 733.253 453.925 735.397C455.954 737.541 456.987 740.22 457.714 742.747C458.442 745.312 458.978 747.761 459.59 750.211C460.777 755.073 461.925 759.781 463.035 764.26C465.179 773.141 467.093 781.18 468.777 788.07C470.27 794.616 471.533 800.014 472.49 804.186C473.371 807.976 473.754 810.12 473.639 810.158Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M421.233 752.279C421.233 754.652 419.319 756.566 416.946 756.566C414.572 756.566 412.658 754.652 412.658 752.279C412.658 749.905 414.572 747.991 416.946 747.991C419.319 747.991 421.233 749.905 421.233 752.279Z", fill: "white" }),
	    React.createElement("path", { d: "M648.617 579.253C652.024 564.286 655.354 549.203 656.158 533.891C656.962 518.579 655.048 502.846 648.425 488.989C647.43 486.883 639.238 472.949 636.941 473.37C635.295 473.677 640.769 486.883 640.08 488.415C633.343 502.808 632.692 519.421 635.372 535.04C638.052 550.696 642.607 564.553 648.617 579.253Z", fill: "#263238" }),
	    React.createElement("path", { d: "M644.177 521.756C645.823 481.716 623.85 447.34 583.771 446.842L580.058 446.996C542.735 448.68 512.991 478.73 511.651 516.053C510.426 550.773 509.508 589.167 510.58 607.695C512.8 646.09 551.501 650.339 551.501 650.339L551.922 663.507C552.764 690.686 576.651 711.396 603.715 708.333C627.41 705.654 645.249 685.557 645.095 661.708L644.177 521.756Z", fill: "#BA7F72" }),
	    React.createElement("path", { d: "M551.501 650.339C551.501 650.339 575.885 651.219 600.959 633.84C600.959 633.84 590.355 662.014 551.845 660.292L551.501 650.339Z", fill: "#8B5D54" }),
	    React.createElement("path", { d: "M526.006 545.758C526.045 548.667 528.533 551.041 531.557 551.041C534.581 551.079 537.031 548.744 536.993 545.835C536.954 542.925 534.466 540.552 531.442 540.552C528.418 540.514 525.968 542.849 526.006 545.758Z", fill: "#263238" }),
	    React.createElement("path", { d: "M520.111 532.513C520.838 533.202 524.858 529.948 530.753 529.68C536.648 529.336 541.127 532.169 541.739 531.441C542.046 531.097 541.28 529.833 539.328 528.57C537.414 527.269 534.16 526.082 530.485 526.273C526.81 526.465 523.786 527.958 522.063 529.412C520.341 530.867 519.767 532.207 520.111 532.513Z", fill: "#263238" }),
	    React.createElement("path", { d: "M578.832 543.346C578.871 546.256 581.359 548.629 584.383 548.629C587.407 548.667 589.857 546.332 589.819 543.423C589.781 540.514 587.292 538.14 584.268 538.14C581.244 538.102 578.794 540.437 578.832 543.346Z", fill: "#263238" }),
	    React.createElement("path", { d: "M578.909 528.187C579.56 528.953 583.885 526.12 589.78 526.541C595.676 526.848 599.81 530.14 600.499 529.489C600.843 529.183 600.231 527.843 598.432 526.35C596.671 524.857 593.57 523.326 589.895 523.135C586.22 522.905 583.043 524.092 581.167 525.355C579.292 526.58 578.564 527.843 578.909 528.187Z", fill: "#263238" }),
	    React.createElement("path", { d: "M559.425 577.76C559.425 577.416 555.75 576.956 549.74 576.459C548.209 576.382 546.793 576.152 546.486 575.119C546.065 574.047 546.64 572.401 547.29 570.602C548.554 566.889 549.855 562.984 551.233 558.926C556.669 542.313 560.574 528.647 559.884 528.455C559.195 528.226 554.257 541.547 548.783 558.161C547.482 562.257 546.219 566.161 545.032 569.913C544.534 571.635 543.654 573.626 544.534 575.884C544.994 576.994 546.142 577.76 547.099 577.99C548.094 578.258 548.936 578.219 549.664 578.219C555.712 578.219 559.425 578.066 559.425 577.76Z", fill: "#263238" }),
	    React.createElement("path", { d: "M576.919 502.731C577.57 504.301 583.427 503.267 590.394 503.803C597.361 504.186 603.064 505.947 603.906 504.492C604.289 503.765 603.256 502.31 600.921 500.856C598.624 499.401 594.987 498.099 590.776 497.831C586.604 497.563 582.814 498.406 580.326 499.554C577.876 500.664 576.651 502.004 576.919 502.731Z", fill: "#263238" }),
	    React.createElement("path", { d: "M520.877 520.838C521.987 522.139 525.968 520.57 530.868 520.264C535.729 519.804 539.94 520.761 540.821 519.307C541.204 518.618 540.515 517.278 538.639 516.091C536.801 514.904 533.777 514.024 530.409 514.254C527.04 514.522 524.207 515.861 522.561 517.316C520.915 518.809 520.379 520.225 520.877 520.838Z", fill: "#263238" }),
	    React.createElement("path", { d: "M642.339 550.352C642.99 550.045 668.408 541.356 668.752 567.654C669.097 593.952 642.607 588.9 642.569 588.134C642.492 587.407 642.339 550.352 642.339 550.352Z", fill: "#BA7F72" }),
	    React.createElement("path", { d: "M650.454 578.066C650.569 577.99 650.913 578.372 651.679 578.717C652.444 579.062 653.746 579.291 655.124 578.755C657.88 577.683 660.177 573.243 660.253 568.496C660.292 566.085 659.756 563.826 658.875 561.95C658.033 560.036 656.77 558.697 655.392 558.467C654.014 558.161 653.018 559.003 652.712 559.768C652.368 560.496 652.559 561.032 652.406 561.07C652.329 561.147 651.832 560.649 652.023 559.539C652.138 559.003 652.406 558.39 653.018 557.893C653.631 557.357 654.55 557.089 655.545 557.204C657.574 557.319 659.411 559.156 660.368 561.223C661.44 563.29 662.091 565.855 662.053 568.535C661.938 573.855 659.296 578.832 655.507 579.98C653.669 580.478 652.1 579.942 651.296 579.33C650.492 578.717 650.339 578.105 650.454 578.066Z", fill: "#8B5D54" }),
	    React.createElement("path", { d: "M510.12 586.679C513.91 583.464 520.723 585.148 522.523 589.78C524.513 586.526 528.456 584.536 532.246 584.918C536.035 585.301 539.519 587.981 540.859 591.579C542.16 585.875 550.85 583.732 554.64 588.172C555.903 585.722 558.85 584.268 561.53 584.804C561.032 582.277 562.219 579.483 564.401 578.105C566.583 576.688 569.607 576.765 571.674 578.296C574.201 572.784 582.278 570.793 587.063 574.545C587.637 572.056 590.01 570.104 592.575 569.989C595.14 569.874 597.628 571.674 598.394 574.123C600.614 570.717 605.284 569.147 609.15 570.449C608.844 566.659 612.902 563.175 616.577 564.056C615.428 560.879 620.06 559.079 622.319 556.591C623.314 555.481 623.926 553.988 625.036 552.955C626.147 551.921 628.175 551.577 629.018 552.802C628.214 550.275 629.592 547.213 632.042 546.141C634.492 545.069 637.669 546.179 638.932 548.514C639.698 549.892 639.812 551.538 640.157 553.069C641.267 558.046 644.521 563.788 641.152 567.616C640.54 568.305 639.774 568.879 639.545 569.721C639.2 571.214 640.731 572.477 640.923 574.009C641.191 575.769 639.659 577.262 639.047 578.908C638.166 581.397 639.353 584.076 639.736 586.718C640.119 589.321 638.856 592.766 636.214 592.728C638.473 596.402 637.516 601.685 634.185 604.365C636.559 608.652 634.338 614.777 629.783 616.576C631.621 617.839 631.735 620.71 630.587 622.624C629.439 624.538 627.448 625.763 625.496 626.912C627.371 627.715 627.831 630.433 626.797 632.233C625.802 634.032 623.811 635.065 621.897 635.754C621.055 636.061 620.137 636.367 619.716 637.132C618.873 638.549 620.29 640.31 620.137 641.956C619.945 644.482 616.462 645.477 615.581 647.851C614.777 649.956 616.232 652.751 614.701 654.435C613.706 655.507 612.021 655.468 610.681 656.043C608.27 657.076 607.389 659.947 605.973 662.129C603.332 666.263 598.432 668.369 593.762 669.938C591.388 670.742 588.977 671.431 586.565 672.082C581.742 673.345 576.804 674.341 571.904 675.298C569.454 675.795 566.43 676.025 565.013 674.034C561.874 678.513 554.027 678.168 551.271 673.422C546.945 674.953 542.199 673.422 537.835 671.891C536.342 671.355 534.849 670.857 533.356 670.321C528.877 668.752 523.901 666.684 522.293 662.244C516.551 661.861 512.302 655.009 514.484 649.726C512.57 650.454 510.503 648.578 510.043 646.588C509.584 644.597 510.158 642.492 510.35 640.463C511.23 632.118 506.254 624.079 506.79 615.734C507.172 609.877 510.196 603.905 508.091 598.431C507.67 597.321 507.019 596.211 507.019 594.986C507.019 593.761 508.014 592.46 509.201 592.728C507.479 589.512 510.464 584.957 514.063 585.225", fill: "#263238" }),
	    React.createElement("path", { d: "M576.995 581.052C576.038 581.052 576.306 587.445 571.023 592.23C565.74 597.053 558.888 596.632 558.888 597.513C558.812 597.934 560.458 598.699 563.367 598.623C566.2 598.584 570.296 597.513 573.511 594.565C576.727 591.617 577.99 587.828 578.105 585.186C578.22 582.545 577.416 580.976 576.995 581.052Z", fill: "white" }),
	    React.createElement("path", { d: "M617.764 623.313C617.419 623.237 619.678 617.265 619.218 609.571C618.874 601.876 616.003 596.173 616.309 596.058C616.424 596.02 617.266 597.359 618.185 599.733C619.103 602.106 620.022 605.59 620.252 609.494C620.443 613.399 619.907 616.959 619.257 619.447C618.567 621.935 617.878 623.352 617.764 623.313Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M623.084 613.628C622.931 613.514 623.811 612.557 624.309 610.604C624.845 608.69 624.883 605.896 624.385 602.833C623.467 596.67 621.399 592 621.667 591.885C621.897 591.732 624.424 596.364 625.419 602.68C625.955 605.819 625.802 608.843 625.036 610.834C624.27 612.863 623.16 613.705 623.084 613.628Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M629.132 607.848C628.826 607.733 631.314 602.795 631.046 596.211C630.893 589.627 628.06 584.842 628.405 584.727C628.52 584.65 629.362 585.761 630.242 587.789C631.123 589.818 632.003 592.804 632.118 596.173C632.233 599.58 631.582 602.604 630.817 604.671C630.013 606.738 629.247 607.886 629.132 607.848Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M522.599 480.491C521.757 472.758 532.36 456.336 542.964 451.053C558.965 443.053 583.655 437.579 598.814 441.254C617.074 445.694 632.424 454.116 642.109 470.231C651.794 486.347 655.928 505.373 656.119 524.168C656.158 529.91 655.813 535.882 652.942 540.858C649.382 546.983 642.262 551.041 642.913 559.271C643.143 562.295 642.415 565.357 640.425 567.654C635.678 573.128 629.438 568.381 626.452 563.52C620.098 553.146 618.95 540.514 617.993 528.379C617.304 519.766 616.614 510.961 618.72 502.578C619.868 498.023 621.859 493.659 622.739 489.065C623.658 484.433 623.313 479.266 620.328 475.629C619.83 475.055 619.064 474.289 618.031 473.485C610.107 467.054 599.312 465.447 589.818 469.198C574.774 475.17 549.05 484.204 542.045 479.304C531.977 472.222 530.906 469.466 530.906 469.466L522.599 480.491Z", fill: "#263238" }),
	    React.createElement("path", { d: "M528.609 656.464C528.341 656.885 522.331 652.712 518.426 644.827C514.445 636.979 514.675 629.668 515.173 629.706C515.785 629.629 516.436 636.52 520.187 643.908C523.9 651.411 529.03 656.043 528.609 656.464Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M547.903 668.216C547.711 668.675 540.706 665.383 534.581 658.301C528.418 651.258 526.083 643.908 526.581 643.755C527.116 643.525 530.141 650.262 536.074 657C541.931 663.775 548.209 667.68 547.903 668.216Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M560.305 662.282C560.343 662.78 555.175 663.201 549.625 660.445C544.036 657.727 541.203 653.363 541.624 653.095C542.083 652.712 545.337 656.157 550.505 658.646C555.596 661.21 560.343 661.708 560.305 662.282Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M652.522 495.649C652.79 495.956 646.359 500.932 636.635 502.387C626.874 503.688 619.295 500.702 619.486 500.358C619.601 499.669 627.18 501.659 636.367 500.434C645.516 499.056 652.215 494.999 652.522 495.649Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M655.66 510.387C656.005 510.732 647.813 515.976 636.253 516.55C624.654 517.239 616.002 512.875 616.309 512.493C616.5 511.88 625.113 515.211 636.176 514.56C647.201 514.062 655.393 509.813 655.66 510.387Z", fill: "#455A64" }),
	    React.createElement("path", { d: "M1713.83 1827.72C1713.83 1828.25 1374.98 1828.71 957.038 1828.71C538.982 1828.71 200.166 1828.25 200.166 1827.72C200.166 1827.18 538.982 1826.72 957.038 1826.72C1374.94 1826.72 1713.83 1827.18 1713.83 1827.72Z", fill: "#263238" })
	  );
	}
	
	var _default = SvgComponent;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SvgComponent, "SvgComponent", "D:/a/1/s/src/web/employee/src/images/PerDiem.js");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "D:/a/1/s/src/web/employee/src/images/PerDiem.js");
	}();

	;

/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function SvgComponent(props) {
	  return React.createElement(
	    "svg",
	    _extends({ width: "327", height: "816", viewBox: "0 0 927 816", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
	    React.createElement(
	      "g",
	      { clipPath: "url(#clip0_4242_33230)" },
	      React.createElement("path", { d: "M305.499 15.9047H77.7788V414.211H305.499V15.9047Z", fill: "#FAFAFA" }),
	      React.createElement("path", { d: "M148.634 418.1C148.634 418.1 123.65 238.914 110.544 219.254C110.544 219.254 185.085 163.348 187.338 11.6026H74.2969V418.305H148.634V418.1Z", fill: "#EBEBEB" }),
	      React.createElement("path", { d: "M234.438 417.28C234.438 417.28 259.422 238.093 272.528 218.434C272.528 218.434 197.987 162.527 195.734 10.7819H308.98V417.484H234.438V417.28Z", fill: "#EBEBEB" }),
	      React.createElement("path", { d: "M311.439 0.751648H300.79H56.687V7.09997V15.9057V414.212V420.765V427.318H321.883V420.765V414.212V0.751648H311.439ZM123.447 222.329V323.697H77.7798V222.329H123.447ZM77.7798 214.956V110.107H123.447V215.161H77.7798V214.956ZM193.074 214.956V110.107H250.413V215.161H193.074V214.956ZM250.413 222.329V323.697H193.074V222.329H250.413ZM125.495 214.956V110.107H185.701V215.161H125.495V214.956ZM185.701 222.329V323.697H125.495V222.329H185.701ZM125.495 108.264V15.9057H185.701V108.264H125.495ZM185.701 325.745V414.212H125.495V325.745H185.701ZM193.074 325.745H250.413V414.212H193.074V325.745ZM193.074 108.264V15.9057H250.413V108.264H193.074ZM252.461 222.329H300.79V323.697H252.461V222.329ZM252.461 214.956V110.107H300.79V215.161H252.461V214.956ZM300.79 108.264H252.461V15.9057H300.79V108.264ZM123.447 15.9057V108.264H77.7798V15.9057H123.447ZM77.7798 325.745H123.447V414.212H77.7798V325.745ZM252.461 414.212V325.745H300.79V414.212H252.461Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M882.373 15.9047H654.653V414.211H882.373V15.9047Z", fill: "#FAFAFA" }),
	      React.createElement("path", { d: "M725.513 418.1C725.513 418.1 700.53 238.914 687.423 219.254C687.423 219.254 761.965 163.348 764.218 11.6026H650.972V418.305H725.513V418.1Z", fill: "#EBEBEB" }),
	      React.createElement("path", { d: "M811.316 417.28C811.316 417.28 836.3 238.093 849.406 218.434C849.406 218.434 774.865 162.527 772.612 10.7819H885.858V417.484H811.316V417.28Z", fill: "#EBEBEB" }),
	      React.createElement("path", { d: "M888.314 0.751648H877.666H633.562V7.09997V15.9057V414.212V420.765V427.318H898.758V420.765V414.212V0.751648H888.314ZM700.322 222.329V323.697H654.655V222.329H700.322ZM654.655 214.956V110.107H700.322V215.161H654.655V214.956ZM769.949 214.956V110.107H827.084V215.161H769.949V214.956ZM827.289 222.329V323.697H770.154V222.329H827.289ZM702.37 214.956V110.107H762.577V215.161H702.37V214.956ZM762.781 222.329V323.697H702.575V222.329H762.781ZM702.37 108.264V15.9057H762.577V108.264H702.37ZM762.781 325.745V414.212H702.575V325.745H762.781ZM769.949 325.745H827.084V414.212H769.949V325.745ZM769.949 108.264V15.9057H827.084V108.264H769.949ZM829.336 222.329H877.666V323.697H829.336V222.329ZM829.336 214.956V110.107H877.666V215.161H829.336V214.956ZM877.666 108.264H829.336V15.9057H877.666V108.264ZM700.322 15.9057V108.264H654.655V15.9057H700.322ZM654.655 325.745H700.322V414.212H654.655V325.745ZM829.336 414.212V325.745H877.666V414.212H829.336Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M438.813 111.949H383.521V181.781H438.813V111.949Z", fill: "#EBEBEB" }),
	      React.createElement("path", { d: "M415.262 180.348H407.685V182.191H415.262V180.348Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M412.805 136.112L402.771 137.545L398.88 147.17L405.228 155.157L415.467 153.723L419.358 144.098L412.805 136.112Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M417.72 142.256L407.481 143.689L403.59 153.314L409.938 161.506L420.178 159.867L424.069 150.447L417.72 142.256Z", fill: "#FAFAFA" }),
	      React.createElement("path", { d: "M416.286 111.129H408.709V112.767H416.286V111.129Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M572.949 18.7689H480.591V135.496H572.949V18.7689Z", fill: "#EBEBEB" }),
	      React.createElement("path", { d: "M534.039 132.832H521.138V135.903H534.039V132.832Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M529.943 58.9037L512.741 61.3611L506.393 77.3343L517.042 90.8501L534.244 88.3927L540.592 72.4195L529.943 58.9037Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M537.727 69.3465L520.729 71.8039L514.381 87.7771L525.03 101.293L542.027 98.8355L548.375 82.6575L537.727 69.3465Z", fill: "#FAFAFA" }),
	      React.createElement("path", { d: "M535.677 17.1281H522.776V19.7903H535.677V17.1281Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M418.336 505.335C405.844 507.383 400.11 522.742 401.339 535.439C402.363 548.135 407.687 560.422 406.254 573.119C404.411 589.092 392.328 602.608 390.895 618.786C389.257 637.626 402.567 654.623 406.663 673.054C408.711 682.064 408.301 691.689 411.783 700.29C417.517 714.83 434.104 724.045 449.463 721.383C464.822 718.721 477.109 704.181 477.519 688.618C477.723 674.078 468.918 660.357 469.942 645.818C470.761 635.169 477.109 624.93 475.676 614.281C474.037 601.584 462.365 592.574 458.064 580.491C453.968 568.409 457.859 555.098 456.426 542.401C453.764 519.261 441.067 503.492 418.336 505.335Z", fill: "#F5F5F5" }),
	      React.createElement("path", { d: "M354.238 615.712C352.19 636.805 361.405 661.789 372.259 680.015C383.113 698.24 399.905 712.985 419.564 721.176C421.817 722.2 424.479 722.815 426.322 721.381C427.756 720.152 427.96 717.9 427.96 716.057C428.165 693.735 420.793 671.618 407.687 653.802C394.58 635.576 375.535 622.061 354.238 615.712Z", fill: "#EBEBEB" }),
	      React.createElement("path", { d: "M445.776 763.98C445.366 763.16 444.957 761.932 444.342 760.498C443.114 757.426 441.27 753.126 438.813 747.802C433.898 737.153 426.936 722.613 417.925 707.254C408.915 691.895 399.699 678.38 392.737 668.959C389.255 664.249 386.388 660.359 384.34 657.901C383.316 656.672 382.702 655.648 382.088 654.829C381.678 654.215 381.269 653.805 381.269 653.805C381.269 653.805 381.678 654.01 382.088 654.829C382.702 655.648 383.521 656.468 384.545 657.696C386.593 660.154 389.665 663.84 393.146 668.55C400.314 677.97 409.529 691.281 418.539 706.64C427.55 722.204 434.717 736.743 439.223 747.597C441.475 752.921 443.318 757.426 444.547 760.498C445.161 761.932 445.571 763.16 445.776 763.98Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M432.67 563.7C432.67 563.7 432.874 564.314 432.874 565.748C433.079 567.181 433.079 569.025 433.284 571.482C433.694 576.602 434.103 583.974 434.718 592.984C435.946 611.005 437.38 635.989 439.428 663.635C441.271 691.281 443.318 716.265 444.752 734.286C445.366 743.296 445.981 750.464 446.39 755.583C446.595 758.041 446.595 759.884 446.8 761.317C446.8 762.546 446.8 763.365 446.8 763.365C446.8 763.365 446.595 762.751 446.595 761.317C446.39 759.884 446.185 758.041 445.981 755.583C445.571 750.464 444.752 743.092 443.933 734.286C442.295 716.265 440.247 691.281 438.404 663.635C436.561 635.989 434.922 611.005 434.103 592.984C433.694 583.974 433.284 576.806 433.079 571.482C433.079 569.025 432.874 567.181 432.874 565.748C432.67 564.519 432.67 563.7 432.67 563.7Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M413.216 735.103H466.051V774.012C466.051 788.143 454.583 799.406 440.657 799.406C427.142 799.406 416.083 788.757 415.264 775.446L413.216 735.103Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M926.2 800.022C926.2 800.227 718.958 800.637 463.387 800.637C207.815 800.637 0.573242 800.432 0.573242 800.022C0.573242 799.818 207.815 799.408 463.387 799.408C718.958 799.613 926.2 799.818 926.2 800.022Z", fill: "#263238" }),
	      React.createElement("path", { d: "M636.634 367.307L628.442 365.669C621.07 363.416 616.974 362.597 615.336 360.14C613.083 356.863 617.384 355.02 617.384 355.02C617.384 355.02 612.264 352.153 613.493 348.877C614.312 346.624 616.974 347.034 616.974 347.034C616.974 347.034 612.674 344.167 612.059 342.119C611.24 339.252 614.926 338.433 614.926 338.433C609.192 333.108 610.626 329.217 612.264 329.217C613.903 329.217 618.408 332.494 618.408 332.494C622.504 334.542 633.357 340.48 630.285 333.108C627.214 325.736 627.623 318.978 629.057 317.34C630.49 315.497 633.357 316.93 633.357 319.388C633.357 321.435 634.176 324.712 634.995 327.169C635.61 329.217 636.634 331.06 637.862 332.903C639.296 334.951 640.729 336.59 641.958 337.818L647.897 346.214L636.634 367.307Z", fill: "#FFBE9D" }),
	      React.createElement("path", { d: "M605.094 791.823L612.057 776.873L639.908 789.979L629.873 811.891L628.03 811.277C620.044 808.205 588.097 794.69 583.592 790.594C578.882 786.089 605.094 791.823 605.094 791.823Z", fill: "#3B53A7" }),
	      React.createElement(
	        "g",
	        { opacity: "0.3" },
	        React.createElement("path", { d: "M620.045 806.983C621.478 804.935 623.936 803.297 626.393 802.682C628.85 802.068 631.513 802.478 633.765 803.706L630.079 811.488L620.045 806.983Z", fill: "white" })
	      ),
	      React.createElement(
	        "g",
	        { opacity: "0.3" },
	        React.createElement("path", { d: "M592.195 789.576C592.195 789.576 582.775 788.143 583.184 789.986C583.594 791.829 615.54 806.778 630.08 811.898L630.285 811.283L593.014 794.286C593.014 794.286 593.628 790.395 592.195 789.576Z", fill: "white" })
	      ),
	      React.createElement("path", { d: "M630.695 811.488C630.695 811.488 630.49 811.488 630.285 811.283C629.876 811.078 629.466 810.874 628.852 810.669C627.418 810.054 625.78 809.44 623.732 808.621C619.432 806.778 613.288 804.116 606.735 801.044C600.182 797.972 594.243 795.105 590.148 793.057C588.1 792.033 586.461 791.214 585.233 790.395C584.823 790.19 584.209 789.986 583.799 789.576C584.209 789.781 584.618 789.985 585.233 790.19C586.666 790.805 588.304 791.624 590.352 792.648C594.653 794.696 600.387 797.563 606.94 800.634C613.493 803.706 619.432 806.368 623.732 808.211C625.78 809.03 627.418 809.85 628.852 810.464C629.466 810.669 629.876 810.874 630.285 811.078C630.49 811.283 630.695 811.488 630.695 811.488Z", fill: "#263238" }),
	      React.createElement("path", { d: "M592.81 794.696C592.605 794.696 593.22 793.468 593.015 791.829C592.81 790.191 591.991 789.167 592.196 789.167C592.196 789.167 593.22 790.191 593.424 791.829C593.424 793.468 592.81 794.696 592.81 794.696Z", fill: "#263238" }),
	      React.createElement("path", { d: "M602.843 794.277C602.843 794.277 602.638 793.663 602.433 792.844C602.228 792.024 602.228 791.41 602.433 791.41C602.433 791.41 602.638 792.024 602.843 792.844C603.048 793.663 603.048 794.277 602.843 794.277Z", fill: "#263238" }),
	      React.createElement("path", { d: "M605.709 794.281C605.709 794.281 605.299 793.871 605.095 793.257C604.89 792.643 604.685 792.028 604.685 792.028C604.685 792.028 605.095 792.438 605.299 793.052C605.709 793.666 605.914 794.076 605.709 794.281Z", fill: "#263238" }),
	      React.createElement("path", { d: "M608.373 792.237C608.373 792.237 607.554 792.032 606.735 791.828C605.915 791.418 605.301 791.008 605.301 791.008C605.301 791.008 606.12 791.213 606.939 791.418C607.758 791.828 608.373 792.032 608.373 792.237Z", fill: "#263238" }),
	      React.createElement("path", { d: "M609.808 790.6C609.808 790.6 608.989 790.6 607.965 790.395C606.941 789.986 606.327 789.371 606.327 789.371C606.327 789.371 607.146 789.781 607.965 789.985C608.989 790.395 609.808 790.395 609.808 790.6Z", fill: "#263238" }),
	      React.createElement("path", { d: "M633.768 803.498C633.768 803.498 632.949 803.089 631.72 802.679C630.491 802.27 628.444 801.86 626.396 802.474C624.348 802.884 622.71 804.113 621.686 805.137C620.662 806.161 620.252 806.98 620.252 806.98C620.252 806.98 620.252 806.775 620.457 806.365C620.662 805.956 621.071 805.546 621.481 804.932C622.505 803.908 624.143 802.679 626.191 802.065C628.444 801.45 630.491 801.86 631.72 802.474C632.335 802.679 632.949 803.089 633.154 803.294C633.563 803.294 633.768 803.498 633.768 803.498Z", fill: "#263238" }),
	      React.createElement("path", { d: "M636.223 790.594C636.223 790.594 635.199 793.257 633.765 796.533C632.332 799.81 631.103 802.267 630.898 802.267C630.898 802.267 631.922 799.605 633.356 796.328C634.789 793.052 636.223 790.594 636.223 790.594Z", fill: "#263238" }),
	      React.createElement("path", { d: "M617.791 802.47C617.791 802.47 615.743 802.061 613.49 801.037C611.237 800.013 609.599 798.989 609.599 798.784C609.599 798.784 611.442 799.603 613.695 800.627C615.947 801.856 617.791 802.47 617.791 802.47Z", fill: "#263238" }),
	      React.createElement("path", { d: "M623.32 805.138C623.32 805.138 622.911 805.548 622.706 805.752C622.297 806.162 622.092 806.367 621.887 806.367C621.887 806.367 621.887 805.957 622.297 805.548C622.706 805.138 623.116 804.933 623.32 805.138Z", fill: "#263238" }),
	      React.createElement("path", { d: "M626.392 803.501C626.392 803.501 626.187 803.706 625.778 803.911C625.368 804.115 624.958 804.115 624.958 804.115C624.958 804.115 625.163 803.911 625.573 803.706C625.982 803.501 626.392 803.501 626.392 803.501Z", fill: "#263238" }),
	      React.createElement("path", { d: "M630.08 803.706C630.08 803.706 629.671 803.706 629.261 803.501C628.851 803.501 628.442 803.501 628.442 803.501C628.442 803.501 628.851 803.092 629.466 803.092C629.671 803.297 630.08 803.706 630.08 803.706Z", fill: "#263238" }),
	      React.createElement("path", { d: "M632.333 804.112C632.333 804.317 632.128 804.317 631.924 804.317C631.719 804.317 631.514 804.112 631.514 804.112C631.514 803.907 631.719 803.907 631.924 803.907C632.128 803.907 632.333 804.112 632.333 804.112Z", fill: "#263238" }),
	      React.createElement("path", { d: "M840.805 800.018L833.842 785.069L861.693 771.758L872.137 793.465L870.499 794.489C862.922 798.585 832.204 814.763 826.265 815.582C819.712 816.606 840.805 800.018 840.805 800.018Z", fill: "#3B53A7" }),
	      React.createElement(
	        "g",
	        { opacity: "0.3" },
	        React.createElement("path", { d: "M861.897 798.171C861.283 795.714 861.488 792.847 862.716 790.594C863.945 788.341 865.788 786.498 868.246 785.474L871.932 793.256L861.897 798.171Z", fill: "white" })
	      ),
	      React.createElement(
	        "g",
	        { opacity: "0.3" },
	        React.createElement("path", { d: "M830.567 808.419C830.567 808.419 823.399 814.767 825.038 815.586C826.676 816.406 858.418 801.251 871.933 793.47L871.524 792.855L834.662 810.876C834.867 810.876 832.205 807.805 830.567 808.419Z", fill: "white" })
	      ),
	      React.createElement("path", { d: "M872.138 792.854C872.138 792.854 871.933 793.059 871.728 793.059C871.318 793.264 870.909 793.469 870.295 793.878C868.861 794.493 867.223 795.517 865.38 796.541C861.284 798.793 855.345 801.66 848.792 804.732C842.239 807.804 836.3 810.466 832 812.309C829.952 813.128 828.314 813.947 826.88 814.562C826.266 814.766 825.856 814.971 825.447 815.176C825.037 815.381 825.037 815.381 825.037 815.381C825.037 815.381 825.242 815.381 825.447 815.176C825.856 814.971 826.266 814.766 826.88 814.562C828.314 813.947 829.952 813.128 832 812.309C836.3 810.261 842.239 807.599 848.792 804.527C855.345 801.455 861.079 798.588 865.38 796.336C867.428 795.312 869.066 794.493 870.295 793.878C870.704 793.674 871.318 793.469 871.728 793.264C871.933 792.854 872.138 792.65 872.138 792.854Z", fill: "#263238" }),
	      React.createElement("path", { d: "M835.072 811.282C835.072 811.282 834.253 810.258 833.024 809.234C831.796 808.415 830.362 808.21 830.362 808.21C830.362 808.21 831.796 808.005 833.229 809.029C834.458 810.053 835.072 811.282 835.072 811.282Z", fill: "#263238" }),
	      React.createElement("path", { d: "M841.215 803.294C841.215 803.294 840.601 803.089 839.781 802.68C839.167 802.27 838.553 801.861 838.553 801.656C838.553 801.656 839.167 801.861 839.986 802.27C840.805 802.68 841.215 803.089 841.215 803.294Z", fill: "#263238" }),
	      React.createElement("path", { d: "M842.852 801.04C842.852 801.04 842.238 801.04 841.624 800.836C841.009 800.631 840.395 800.426 840.395 800.221C840.395 800.221 841.009 800.221 841.624 800.426C842.443 800.631 842.852 800.836 842.852 801.04Z", fill: "#263238" }),
	      React.createElement("path", { d: "M843.056 797.763C843.056 797.763 842.442 798.172 841.623 798.582C840.804 798.992 840.189 799.196 840.189 799.196C840.189 799.196 840.804 798.787 841.623 798.377C842.442 797.763 843.056 797.558 843.056 797.763Z", fill: "#263238" }),
	      React.createElement("path", { d: "M842.65 795.722C842.65 795.722 842.241 796.541 841.217 796.951C840.398 797.565 839.374 797.565 839.374 797.565C839.374 797.361 840.193 797.156 841.012 796.746C842.036 796.132 842.65 795.518 842.65 795.722Z", fill: "#263238" }),
	      React.createElement("path", { d: "M867.839 785.473C867.839 785.473 867.019 785.678 865.791 786.497C864.562 787.316 863.128 788.545 862.105 790.388C861.081 792.231 861.081 794.279 861.285 795.712C861.49 797.146 861.695 797.965 861.695 797.965C861.695 797.965 861.49 797.76 861.49 797.35C861.285 796.941 861.285 796.326 861.081 795.712C860.876 794.279 860.876 792.231 861.9 790.183C862.924 788.135 864.357 786.906 865.791 786.087C866.405 785.678 867.019 785.473 867.429 785.473C867.634 785.473 867.839 785.473 867.839 785.473Z", fill: "#263238" }),
	      React.createElement("path", { d: "M859.441 775.24C859.441 775.24 860.875 777.697 862.308 780.769C863.947 783.841 864.971 786.503 864.971 786.503C864.971 786.503 863.537 784.045 862.104 780.974C860.67 777.902 859.441 775.24 859.441 775.24Z", fill: "#263238" }),
	      React.createElement("path", { d: "M856.982 797.149C856.982 797.149 855.344 798.378 853.091 799.402C850.838 800.425 848.995 801.04 848.791 801.04C848.791 801.04 850.634 800.221 852.886 799.197C855.139 797.968 856.982 796.944 856.982 797.149Z", fill: "#263238" }),
	      React.createElement("path", { d: "M862.512 794.493C862.512 794.493 862.512 794.903 862.512 795.517C862.512 795.926 862.512 796.541 862.512 796.541C862.512 796.541 862.103 796.131 862.103 795.517C862.103 794.903 862.307 794.493 862.512 794.493Z", fill: "#263238" }),
	      React.createElement("path", { d: "M863.333 791.006C863.333 791.006 863.333 791.416 863.333 791.825C863.128 792.235 862.924 792.645 862.924 792.44C862.924 792.44 862.924 792.03 862.924 791.621C862.924 791.211 863.128 791.006 863.333 791.006Z", fill: "#263238" }),
	      React.createElement("path", { d: "M865.79 788.342C865.79 788.546 865.38 788.546 865.175 788.956C864.766 789.365 864.561 789.57 864.561 789.57C864.561 789.57 864.561 788.956 864.97 788.546C865.175 788.342 865.79 788.342 865.79 788.342Z", fill: "#263238" }),
	      React.createElement("path", { d: "M867.633 786.911C867.633 786.911 867.633 787.116 867.428 787.321C867.223 787.526 867.019 787.526 867.019 787.526C867.019 787.526 867.019 787.321 867.223 787.116C867.223 786.911 867.428 786.707 867.633 786.911Z", fill: "#263238" }),
	      React.createElement("path", { d: "M873.366 779.336L828.313 800.224L747.218 656.056C736.569 617.966 726.535 484.037 726.535 484.037L785.103 488.542C785.103 488.542 794.114 584.791 808.244 634.349L873.366 779.336Z", fill: "#263238" }),
	      React.createElement("path", { d: "M820.94 786.092C820.94 786.092 821.554 785.683 822.578 785.068C823.807 784.454 825.445 783.635 827.493 782.611C831.589 780.563 837.323 777.901 843.671 775.034C850.019 772.167 855.753 769.505 859.849 767.662C861.897 766.842 863.74 766.023 864.764 765.614C865.993 765.204 866.607 764.999 866.607 764.999C866.607 764.999 865.993 765.409 864.969 766.023C863.945 766.638 862.102 767.457 860.054 768.481C855.958 770.529 850.224 773.191 843.876 776.058C837.527 778.925 831.794 781.587 827.698 783.43C825.65 784.249 823.807 785.068 822.783 785.478C821.759 785.887 821.145 786.092 820.94 786.092Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M811.726 429.973C812.75 429.973 824.832 465.401 813.364 488.951C812.136 491.408 803.125 504.31 803.125 504.31C771.179 541.99 738.823 614.893 729.812 634.143C711.382 673.462 642.984 802.886 642.984 802.886L599.16 777.697L663.257 613.05L721.416 464.377L811.726 429.973Z", fill: "#263238" }),
	      React.createElement("path", { d: "M732.679 582.335C732.679 582.335 729.607 597.284 727.969 596.465C723.464 594.008 691.927 582.335 691.927 582.335L700.323 572.915L732.679 582.335Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M723.465 594.008C723.465 594.008 717.526 618.173 709.949 616.739C702.372 615.511 686.603 607.524 686.603 607.524L696.023 583.769L723.465 594.008Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M727.969 596.465L692.95 582.335L694.589 587.455L722.439 597.694L727.969 596.465Z", fill: "#263238" }),
	      React.createElement("path", { d: "M788.79 523.352C788.79 523.352 788.585 523.761 788.176 524.171C787.766 524.785 787.152 525.604 786.333 526.628C784.694 528.676 782.646 531.953 779.984 535.844C774.865 543.83 768.311 555.093 761.758 567.79C755.205 580.487 749.471 592.364 745.376 600.76C743.328 604.856 741.689 608.338 740.666 610.795C740.051 611.819 739.642 612.843 739.232 613.457C738.822 614.072 738.822 614.481 738.618 614.481C738.618 614.481 738.618 614.072 739.027 613.457C739.437 612.638 739.642 611.819 740.256 610.59C741.28 608.133 742.713 604.651 744.761 600.351C748.652 591.75 754.181 579.872 760.734 567.176C767.288 554.274 774.045 543.011 779.37 535.229C782.032 531.338 784.285 528.267 785.923 526.219C786.742 525.195 787.356 524.581 787.971 523.966C788.585 523.557 788.79 523.352 788.79 523.352Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M602.64 770.122C602.845 769.917 613.084 774.832 625.781 781.18C638.478 787.528 648.512 792.853 648.307 793.058C648.102 793.262 637.863 788.348 625.167 781.999C612.47 775.856 602.436 770.531 602.64 770.122Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M654.656 345.197C654.861 345.402 651.38 352.364 646.67 360.761C641.96 369.157 637.864 375.915 637.659 375.915C637.454 375.71 640.936 368.747 645.646 360.351C650.356 351.955 654.452 345.197 654.656 345.197Z", fill: "#263238" }),
	      React.createElement("path", { d: "M737.391 282.942C739.848 282.942 742.715 300.349 744.968 331.681C747.63 367.108 747.425 402.946 737.596 425.472C735.343 430.592 732.066 434.483 727.356 436.326C701.963 446.77 631.927 371.614 631.927 371.614L649.129 341.306L698.482 381.034C698.482 381.034 703.397 340.691 702.373 322.261C701.963 308.335 715.888 283.147 737.391 282.942Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M759.303 283.349C759.303 283.349 802.103 289.698 813.162 306.49C824.22 323.282 818.691 471.751 818.691 471.751L708.517 478.304C708.517 478.304 717.322 289.288 722.852 287.24C736.572 281.711 757.665 282.735 759.303 283.349Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M582.982 244.234C582.572 239.524 583.596 235.018 585.439 231.127C586.258 229.284 586.668 227.441 586.668 225.598V220.683H522.57C517.041 220.683 512.741 225.189 512.741 230.513V294.406H508.44C506.392 294.406 504.549 293.792 502.706 292.972C497.996 290.72 492.467 289.696 486.528 290.72C475.06 292.768 465.845 302.188 464.616 313.86C462.773 329.834 475.47 343.554 491.034 343.554C494.924 343.554 498.406 342.735 501.682 341.302C503.321 340.482 505.164 340.073 507.007 340.073H512.536V402.327C512.536 407.857 517.041 412.157 522.366 412.157H695.818C700.323 412.157 703.805 408.471 703.805 404.17V228.465C703.805 223.96 700.119 220.479 695.818 220.479H633.359V227.646C633.359 229.284 633.768 230.923 634.383 232.356C635.611 235.428 636.226 238.704 636.226 242.186C636.226 257.34 623.734 269.422 608.58 268.808C595.064 268.398 583.801 257.545 582.982 244.234Z", fill: "#3B53A7" }),
	      React.createElement("path", { d: "M716.092 314.885C716.092 314.885 716.092 315.295 716.297 316.114C716.297 317.138 716.297 318.162 716.297 319.595C716.297 322.872 716.297 327.172 716.502 332.701C716.502 343.76 716.707 358.914 716.297 375.706C715.888 392.498 715.068 407.653 713.84 418.711C713.225 424.24 712.611 428.541 712.201 431.612C711.997 433.046 711.792 434.275 711.587 435.094C711.382 435.913 711.382 436.322 711.382 436.322C711.382 436.322 711.382 435.913 711.382 435.094C711.382 434.275 711.587 433.046 711.792 431.612C712.201 428.541 712.611 424.035 713.021 418.711C714.045 407.857 714.864 392.703 715.068 375.911C715.478 359.119 715.478 343.965 715.478 332.906C715.478 327.582 715.683 323.076 715.683 319.8C715.683 318.366 715.683 317.138 715.888 316.319C715.888 315.295 715.888 314.885 716.092 314.885Z", fill: "#263238" }),
	      React.createElement("path", { d: "M781.417 213.31C779.574 224.574 779.779 234.403 785.308 241.571C786.332 243.004 787.765 244.438 788.584 246.076C789.404 247.714 790.018 249.557 789.404 251.4C788.994 253.039 787.561 254.267 785.922 254.472C784.284 254.882 782.441 254.267 781.417 253.039C781.622 255.496 780.598 258.363 778.345 259.592C776.093 260.616 772.611 259.182 772.611 256.725C772.611 256.725 774.045 262.459 767.492 261.435L771.997 222.526L781.417 213.31Z", fill: "#263238" }),
	      React.createElement("path", { d: "M752.136 299.315C741.282 299.315 732.886 289.895 734.115 279.246C734.729 273.512 735.343 268.597 735.343 268.597C735.343 268.597 721.008 266.345 720.804 252.01C720.599 237.675 723.056 204.705 723.056 204.705C739.644 197.537 758.894 199.994 773.024 211.053L775.072 212.691L770.157 282.318C769.542 291.943 761.761 299.315 752.136 299.315Z", fill: "#FFBE9D" }),
	      React.createElement("path", { d: "M726.946 230.713C727.765 229.894 727.765 228.665 727.15 227.846C726.331 227.027 725.102 227.027 724.283 227.641C723.464 228.46 723.464 229.689 724.079 230.508C724.693 231.532 726.126 231.532 726.946 230.713Z", fill: "#263238" }),
	      React.createElement("path", { d: "M722.851 226.208C723.056 226.412 724.489 225.388 726.537 225.388C728.585 225.388 730.018 226.412 730.223 226.208C730.428 226.003 730.018 225.593 729.404 225.184C728.79 224.774 727.766 224.16 726.537 224.364C725.308 224.364 724.284 224.774 723.67 225.388C723.056 225.798 722.851 226.208 722.851 226.208Z", fill: "#263238" }),
	      React.createElement("path", { d: "M745.788 229.28C744.764 229.894 744.559 231.123 745.173 232.147C745.788 233.17 747.016 233.375 748.04 232.761C749.064 232.147 749.269 230.918 748.655 229.894C748.04 228.87 746.607 228.665 745.788 229.28Z", fill: "#263238" }),
	      React.createElement("path", { d: "M744.354 228.048C744.559 228.253 745.992 227.229 748.04 227.229C750.088 227.229 751.521 228.253 751.726 228.048C751.931 227.844 751.521 227.434 750.907 227.024C750.292 226.615 749.269 226.001 748.04 226.205C746.811 226.205 745.787 226.615 745.173 227.229C744.559 227.434 744.354 227.844 744.354 228.048Z", fill: "#263238" }),
	      React.createElement("path", { d: "M736.572 244.231C736.572 244.026 735.344 243.821 733.296 243.617C732.682 243.617 732.272 243.412 732.272 243.207C732.272 242.797 732.477 242.388 732.682 241.773C733.091 240.545 733.705 239.111 734.32 237.678C736.572 231.944 738.006 227.234 737.596 227.234C737.392 227.029 735.344 231.739 733.091 237.473C732.682 238.906 732.067 240.135 731.658 241.569C731.453 242.183 731.043 242.797 731.453 243.617C731.658 244.026 732.067 244.436 732.272 244.436C732.682 244.64 732.886 244.64 733.091 244.64C735.139 244.436 736.368 244.436 736.572 244.231Z", fill: "#263238" }),
	      React.createElement("path", { d: "M742.919 246.483C744.967 245.255 737.185 249.555 733.294 249.35C733.294 249.35 735.547 253.036 739.642 251.603C743.943 249.965 742.919 246.483 742.919 246.483Z", fill: "white" }),
	      React.createElement("path", { d: "M735.342 268.393C735.342 268.393 744.352 269.213 753.977 263.069C753.977 263.069 749.472 273.308 735.342 272.079V268.393Z", fill: "#EB996E" }),
	      React.createElement("path", { d: "M775.274 226.62C775.684 226.62 785.923 225.8 784.285 237.883C782.647 249.965 770.974 244.231 770.974 243.821C770.974 243.617 775.274 226.62 775.274 226.62Z", fill: "#FFBE9D" }),
	      React.createElement("path", { d: "M775.273 240.337C775.273 240.337 775.478 240.542 775.887 240.746C776.297 240.951 776.706 241.156 777.525 240.951C778.959 240.746 780.188 238.698 780.597 236.651C780.802 235.627 780.802 234.398 780.392 233.579C780.188 232.555 779.573 231.941 778.959 231.736C778.345 231.531 777.73 231.736 777.73 232.145C777.525 232.555 777.525 232.76 777.525 232.76C777.525 232.76 777.321 232.555 777.525 231.941C777.525 231.736 777.73 231.531 778.14 231.326C778.549 231.121 778.959 231.121 779.368 231.121C780.392 231.326 781.007 232.35 781.212 233.374C781.621 234.398 781.621 235.627 781.416 236.855C781.007 239.313 779.368 241.361 777.525 241.565C776.706 241.565 775.887 241.361 775.682 240.951C775.273 240.542 775.273 240.337 775.273 240.337Z", fill: "#EB996E" }),
	      React.createElement("path", { d: "M719.368 203.481C719.778 201.024 722.235 198.976 724.692 199.59C721.416 199.385 718.958 195.494 720.187 192.423C721.416 189.351 725.716 187.917 728.378 189.965C726.945 188.327 725.307 186.689 724.692 184.641C723.873 182.593 724.283 179.931 726.126 178.497C727.969 177.269 730.426 177.473 732.269 178.497C735.136 179.931 737.389 182.593 740.461 184.026C743.533 185.255 747.014 185.05 750.29 185.255C753.977 185.665 757.663 186.893 760.325 189.351C762.987 191.808 764.83 195.494 764.421 199.181C768.926 198.976 773.841 199.181 777.322 202.048C776.708 198.566 778.346 194.47 781.213 192.218C784.899 189.556 790.019 189.146 794.114 190.989C795.957 191.808 798.005 193.037 798.62 195.085C799.439 197.747 797.801 200.819 795.548 202.662C791.452 206.143 785.718 207.577 780.394 206.348C781.213 208.396 781.623 210.853 781.418 213.106C781.213 216.997 777.936 221.092 776.708 224.779L776.503 227.236L774.046 237.27L767.697 236.656L769.335 215.359C769.335 215.359 770.564 206.348 762.782 206.758C755.001 207.167 743.942 215.154 728.993 212.082C726.535 211.672 724.078 211.058 722.03 209.625C720.187 208.396 718.958 205.938 719.368 203.481Z", fill: "#263238" }),
	      React.createElement("path", { d: "M802.922 212.9C802.922 212.9 801.488 214.128 798.826 214.743C796.164 215.357 792.068 215.357 788.177 213.514C784.286 211.671 781.829 208.394 780.6 205.732C779.372 203.07 779.372 201.432 779.372 201.432C779.576 201.432 779.781 203.07 781.215 205.527C782.443 207.78 784.901 210.852 788.587 212.695C792.273 214.538 796.164 214.538 798.621 214.128C801.284 213.514 802.717 212.695 802.922 212.9Z", fill: "#263238" }),
	      React.createElement("path", { d: "M787.765 224.573C787.56 224.573 787.765 223.345 787.356 221.502C786.946 219.659 785.922 217.201 784.284 214.539C782.646 212.081 781.212 209.624 780.393 207.781C779.574 205.938 779.369 204.709 779.574 204.709C779.779 204.709 780.188 205.733 781.007 207.576C781.827 209.214 783.465 211.467 785.103 214.129C786.741 216.792 787.765 219.454 787.97 221.502C788.175 223.549 787.765 224.778 787.765 224.573Z", fill: "#263238" }),
	      React.createElement("path", { d: "M681.484 343.146C673.907 338.436 665.101 332.497 660.801 329.016C652.814 322.258 653.428 321.644 654.452 320.824C656.91 318.572 668.787 332.088 667.968 327.582C666.944 323.077 651.585 312.838 654.248 310.79C657.729 307.923 670.016 322.258 671.04 323.487C672.064 324.511 673.702 323.077 672.678 322.053C671.245 320.62 655.476 305.67 658.753 302.803C660.596 301.165 663.053 305.056 663.053 305.056C663.053 305.056 676.774 320.21 678.412 318.777C680.05 317.343 672.269 308.128 669.402 305.261C666.535 302.394 666.739 299.936 668.992 299.732C670.63 299.527 679.436 308.333 682.098 311.2C684.76 314.067 692.133 322.258 691.723 315.295C691.314 308.128 693.566 302.599 695.204 301.575C696.843 300.551 698.891 302.394 698.071 304.442C697.457 306.08 697.252 309.152 697.252 311.609C697.252 313.452 697.457 315.5 698.071 317.343C698.481 318.981 699.095 320.415 699.505 321.644L704.42 334.955L692.337 350.313L681.484 343.146Z", fill: "#FFBE9D" }),
	      React.createElement("path", { d: "M800.665 297.688C803.122 298.302 818.276 306.084 818.481 340.488C818.686 367.724 816.638 428.135 798.002 437.146C789.606 441.242 776.91 441.242 765.646 434.074C734.314 413.801 679.022 348.679 679.022 348.679L703.801 322.262C703.801 322.262 768.104 387.793 770.971 385.335C775.067 381.649 768.718 350.317 772.2 319.395C774.862 297.278 785.101 293.592 800.665 297.688Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M704.008 322.876C704.008 322.876 703.803 323.08 703.598 323.285C703.189 323.695 702.779 324.104 702.369 324.514C701.141 325.743 699.502 327.381 697.25 329.634C692.949 334.139 686.806 340.897 680.253 350.112V349.702C697.659 367.519 723.258 393.526 751.518 422.401C758.48 428.749 766.672 433.664 775.273 435.917C779.573 436.941 784.079 437.35 788.174 436.531C792.27 435.712 796.161 433.664 799.233 431.002C805.376 425.678 809.062 418.51 811.315 411.547C813.568 404.585 814.387 397.827 815.206 391.683C816.844 379.396 817.663 369.157 818.073 362.194C818.278 358.713 818.482 356.051 818.482 354.208C818.482 353.389 818.482 352.569 818.482 352.16C818.482 352.774 818.482 353.389 818.482 354.208C818.482 356.051 818.482 358.713 818.278 362.194C818.073 369.157 817.254 379.191 815.615 391.683C814.796 397.827 814.182 404.789 811.724 411.752C809.472 418.715 805.786 426.087 799.437 431.616C796.161 434.278 792.475 436.531 787.969 437.35C783.669 438.169 778.959 437.965 774.658 436.736C765.853 434.483 757.457 429.568 750.494 423.015C722.029 394.141 696.84 367.928 679.434 350.112L679.229 349.907L679.434 349.702C686.191 340.487 692.335 333.729 696.635 329.429C698.888 327.176 700.526 325.538 701.755 324.514C702.369 324.104 702.779 323.695 703.189 323.285C703.803 323.08 704.008 322.876 704.008 322.876Z", fill: "#263238" }),
	      React.createElement("path", { d: "M704.008 322.056C704.008 322.056 704.213 322.056 704.417 322.26C704.622 322.465 705.032 322.875 705.441 323.284C706.26 324.103 707.489 325.332 709.127 326.97C712.404 330.247 716.909 334.752 722.848 340.486C728.787 346.22 735.749 352.978 743.736 360.35C747.627 364.037 751.927 367.927 756.228 372.023C760.733 375.914 765.238 380.214 769.949 384.105L769.129 384.515C769.334 382.058 769.334 379.6 769.539 376.938C770.358 363.422 771.177 350.521 771.792 338.848C772.201 332.909 772.406 327.38 773.02 322.26C773.635 317.141 774.863 312.226 776.911 308.13C778.959 304.035 781.826 300.963 784.693 299.12C787.765 297.072 790.837 296.458 793.294 296.253C795.751 296.048 797.799 296.458 799.028 296.867C800.257 297.277 800.871 297.686 800.871 297.686C800.871 297.686 800.257 297.481 799.028 297.072C797.799 296.662 795.956 296.458 793.499 296.662C791.041 296.867 788.174 297.686 785.103 299.734C782.236 301.782 779.573 304.649 777.526 308.745C775.478 312.636 774.249 317.346 773.839 322.465C773.225 327.585 773.225 333.114 772.815 339.053C772.201 350.725 771.382 363.627 770.563 377.143C770.358 379.805 770.358 382.262 770.153 384.72V385.744L769.334 385.129C764.419 381.034 759.914 376.938 755.409 372.842C751.108 368.747 746.808 364.856 742.917 361.17C734.93 353.797 727.968 346.835 722.234 341.101C716.5 335.367 711.79 330.657 708.718 327.38C707.08 325.742 706.056 324.513 705.237 323.489C704.827 323.08 704.622 322.67 704.417 322.465C704.008 322.056 704.008 322.056 704.008 322.056Z", fill: "#263238" }),
	      React.createElement("path", { d: "M690.082 359.323C689.877 359.323 691.106 357.48 693.154 355.023C695.202 352.361 698.069 348.879 701.345 344.988C704.622 341.098 707.694 337.821 710.151 335.364C712.404 332.906 714.042 331.473 714.042 331.677C714.247 331.677 712.813 333.316 710.765 335.978C708.308 338.845 705.441 342.121 702.369 345.808C699.093 349.494 696.226 352.77 693.768 355.637C691.72 357.89 690.287 359.528 690.082 359.323Z", fill: "#263238" }),
	      React.createElement("path", { d: "M775.273 399.873C775.069 399.873 773.84 396.391 772.202 392.091C770.563 387.79 769.13 384.309 769.335 384.104C769.54 383.899 771.383 387.176 773.021 391.681C774.864 396.187 775.683 399.873 775.273 399.873Z", fill: "#263238" }),
	      React.createElement("path", { d: "M781.005 395.572C780.8 395.777 777.933 393.319 774.452 390.247C770.971 387.176 768.308 384.309 768.513 384.104C768.718 383.899 771.585 386.357 775.066 389.428C778.548 392.705 781.21 395.367 781.005 395.572Z", fill: "#263238" }),
	      React.createElement("path", { d: "M167.677 700.702L101.941 760.09L83.9202 736.949L141.465 665.479L167.677 700.702Z", fill: "#FFBE9D" }),
	      React.createElement("path", { d: "M103.377 762.127L105.63 760.079L84.9467 734.481L75.5266 742.672L76.7553 744.311C82.2845 751.478 105.63 779.943 111.159 783.424C117.098 787.111 103.377 762.127 103.377 762.127Z", fill: "#E06255" }),
	      React.createElement(
	        "g",
	        { opacity: "0.5" },
	        React.createElement("path", { d: "M83.5116 751.685C85.3546 749.433 86.1738 746.771 85.969 743.904C85.7642 741.037 84.7403 738.579 82.6924 736.531L75.7297 742.675L83.5116 751.685Z", fill: "white" })
	      ),
	      React.createElement("path", { opacity: "0.5", d: "M109.725 774.827C109.725 774.827 114.026 784.042 111.978 784.247C109.93 784.452 85.356 756.396 75.5264 743.085L76.1407 742.676L104.606 775.646C104.606 775.441 108.292 773.394 109.725 774.827Z", fill: "white" }),
	      React.createElement("path", { d: "M75.7295 742.058C75.7295 742.058 75.7295 742.262 76.1391 742.467C76.3438 742.877 76.7534 743.286 77.163 743.696C78.1869 744.925 79.4156 746.563 80.8491 748.406C84.1257 752.297 88.4261 757.621 93.5458 763.355C98.6654 769.089 103.375 774.209 106.857 777.895C108.495 779.533 109.929 780.967 110.952 782.195C111.362 782.605 111.772 783.015 112.181 783.424C111.772 783.015 111.567 782.605 111.157 782.195C110.133 780.967 108.7 779.533 107.062 777.895C103.58 774.209 99.0749 769.089 93.9553 763.355C88.8357 757.621 84.3304 752.297 81.0539 748.406C79.6204 746.563 78.1869 745.129 77.163 743.901C76.7534 743.491 76.3438 743.082 76.1391 742.672C75.9343 742.058 75.7295 742.058 75.7295 742.058Z", fill: "#263238" }),
	      React.createElement("path", { d: "M104.196 775.644C104.196 775.644 105.425 774.825 107.063 774.62C108.701 774.415 110.135 774.825 110.135 774.62C110.135 774.62 108.701 773.801 107.063 774.211C105.22 774.62 104.196 775.644 104.196 775.644Z", fill: "#263238" }),
	      React.createElement("path", { d: "M101.532 765.206C101.532 765.41 102.352 765.206 103.171 765.206C103.99 765.001 104.809 764.796 104.809 764.796C104.809 764.591 103.99 764.796 103.171 764.796C102.147 765.001 101.532 765.206 101.532 765.206Z", fill: "#263238" }),
	      React.createElement("path", { d: "M100.921 762.336C100.921 762.541 101.536 762.541 102.355 762.745C103.174 762.745 103.788 762.745 103.788 762.745C103.788 762.541 103.174 762.541 102.355 762.336C101.536 762.131 100.921 762.131 100.921 762.336Z", fill: "#263238" }),
	      React.createElement("path", { d: "M101.943 759.058C101.943 759.058 102.352 759.672 102.967 760.492C103.581 761.106 104.195 761.72 104.195 761.72C104.195 761.72 103.786 761.106 103.172 760.287C102.762 759.468 102.148 758.853 101.943 759.058Z", fill: "#263238" }),
	      React.createElement("path", { d: "M103.377 757.213C103.377 757.213 103.582 758.032 104.196 759.056C104.81 759.876 105.63 760.49 105.63 760.285C105.63 760.285 105.015 759.671 104.401 758.647C103.787 757.828 103.377 757.009 103.377 757.213Z", fill: "#263238" }),
	      React.createElement("path", { d: "M82.897 736.532C82.897 736.532 83.5113 737.147 84.3305 738.375C85.1496 739.604 86.1735 741.447 86.1735 743.7C86.3783 745.952 85.5592 748 84.9448 749.229C84.1257 750.458 83.5113 751.277 83.5113 751.277C83.5113 751.277 83.7161 751.072 83.9209 750.867C84.1257 750.662 84.5353 750.048 84.9448 749.434C85.764 748.205 86.5831 746.157 86.3783 743.7C86.1735 741.242 85.3544 739.399 84.3305 738.171C83.9209 737.556 83.5113 737.147 83.1018 736.942C83.1018 736.737 82.897 736.532 82.897 736.532Z", fill: "#263238" }),
	      React.createElement("path", { d: "M88.6331 752.507C88.6331 752.507 89.657 754.35 91.5 756.398C93.3431 758.446 94.9814 759.879 94.9814 759.675C94.9814 759.675 93.5479 758.036 91.7048 756.193C90.0665 754.145 88.6331 752.507 88.6331 752.507Z", fill: "#263238" }),
	      React.createElement("path", { d: "M84.3311 747.794C84.1263 747.794 84.1263 748.204 83.9215 748.614C83.7167 749.023 83.512 749.433 83.512 749.638C83.512 749.638 83.9215 749.433 84.3311 748.818C84.5359 748.204 84.5359 747.794 84.3311 747.794Z", fill: "#263238" }),
	      React.createElement("path", { d: "M85.1508 743.902C84.946 743.902 84.946 744.312 84.946 744.722C84.946 745.131 84.946 745.541 85.1508 745.541C85.3556 745.541 85.3556 745.131 85.3556 744.722C85.1508 744.312 85.1508 743.902 85.1508 743.902Z", fill: "#263238" }),
	      React.createElement("path", { d: "M83.9224 740.421C83.9224 740.421 84.1271 740.83 84.3319 741.24C84.5367 741.649 84.5367 742.059 84.7415 742.059C84.9463 742.059 84.9463 741.649 84.7415 741.035C84.3319 740.625 83.9224 740.421 83.9224 740.421Z", fill: "#263238" }),
	      React.createElement("path", { d: "M82.6936 738.177C82.4888 738.177 82.4888 738.382 82.6936 738.792C82.6936 738.997 82.8984 739.201 83.1032 739.201C83.308 739.201 83.308 738.997 83.1032 738.587C82.8984 738.382 82.6936 738.177 82.6936 738.177Z", fill: "#263238" }),
	      React.createElement("path", { d: "M284.612 700.091L292.599 789.582H258.605L243.656 700.091H284.612Z", fill: "#FFBE9D" }),
	      React.createElement("path", { d: "M291.368 790.602L291.163 787.531L258.193 787.326L258.603 799.818H260.651C269.661 800.023 306.727 800.022 312.666 797.975C319.424 795.722 291.368 790.602 291.368 790.602Z", fill: "#E06255" }),
	      React.createElement(
	        "g",
	        { opacity: "0.5" },
	        React.createElement("path", { d: "M270.683 799.201C270.069 796.539 268.431 794.081 266.178 792.443C263.925 790.805 261.263 789.986 258.396 790.395L258.806 799.611L270.683 799.201Z", fill: "white" })
	      ),
	      React.createElement("path", { opacity: "0.5", d: "M305.089 793.672C305.089 793.672 314.919 796.129 313.69 797.768C312.461 799.406 275.191 800.635 258.603 799.815V798.996L302.222 797.768C302.427 797.972 303.246 793.672 305.089 793.672Z", fill: "white" }),
	      React.createElement("path", { d: "M258.396 798.999C258.396 798.999 258.601 798.999 259.011 798.999C259.42 798.999 260.035 798.999 260.649 798.999C262.287 798.999 264.335 798.999 266.588 798.999C271.707 798.999 278.465 798.999 286.247 798.589C293.824 798.384 300.787 797.975 305.906 797.565C308.159 797.36 310.207 797.155 311.845 797.155C312.459 797.155 313.074 796.951 313.483 796.951C313.074 796.951 312.459 796.951 311.845 796.951C310.207 796.951 308.159 797.155 305.906 797.36C300.787 797.565 294.029 797.975 286.247 798.179C278.67 798.384 271.707 798.589 266.588 798.589C264.335 798.589 262.287 798.589 260.649 798.589C260.035 798.589 259.42 798.589 259.011 798.589C258.601 798.999 258.396 798.999 258.396 798.999Z", fill: "#263238" }),
	      React.createElement("path", { d: "M302.426 798.385C302.631 798.385 302.631 796.952 303.45 795.518C304.269 794.085 305.498 793.266 305.498 793.266C305.498 793.266 304.065 793.88 303.246 795.518C302.222 796.952 302.426 798.385 302.426 798.385Z", fill: "#263238" }),
	      React.createElement("path", { d: "M292.597 793.876C292.597 793.876 293.211 793.262 293.621 792.648C294.03 791.828 294.44 791.214 294.235 791.214C294.235 791.214 293.621 791.828 293.211 792.443C292.802 793.057 292.597 793.876 292.597 793.876Z", fill: "#263238" }),
	      React.createElement("path", { d: "M289.934 792.444C289.934 792.444 290.548 792.239 290.958 791.625C291.572 791.01 291.982 790.601 291.777 790.601C291.777 790.601 291.163 790.805 290.753 791.42C290.139 792.034 289.934 792.444 289.934 792.444Z", fill: "#263238" }),
	      React.createElement("path", { d: "M288.091 789.578C288.091 789.783 288.91 789.783 289.73 789.783C290.754 789.783 291.368 789.578 291.368 789.578C291.368 789.374 290.549 789.374 289.73 789.374C288.91 789.374 288.091 789.374 288.091 789.578Z", fill: "#263238" }),
	      React.createElement("path", { d: "M287.476 787.325C287.476 787.325 288.295 787.734 289.319 787.734C290.343 787.734 291.367 787.53 291.367 787.325C291.367 787.12 290.548 787.325 289.524 787.325C288.295 787.325 287.476 787.325 287.476 787.325Z", fill: "#263238" }),
	      React.createElement("path", { d: "M258.602 790.197C258.602 790.197 259.625 789.993 261.059 790.197C262.492 790.402 264.54 790.812 266.383 792.245C268.226 793.679 269.25 795.317 269.865 796.75C270.479 798.184 270.479 799.003 270.479 799.003C270.479 799.003 270.479 798.798 270.479 798.389C270.479 797.979 270.274 797.365 270.07 796.546C269.66 795.112 268.431 793.269 266.588 791.836C264.745 790.402 262.492 789.993 261.059 789.788C260.24 789.788 259.625 789.788 259.216 789.993C259.011 789.993 258.602 789.993 258.602 790.197Z", fill: "#263238" }),
	      React.createElement("path", { d: "M274.779 795.723C274.779 795.927 276.827 796.132 279.489 795.927C282.151 795.927 284.199 795.518 284.199 795.313C284.199 795.108 282.151 795.518 279.489 795.518C276.827 795.723 274.779 795.723 274.779 795.723Z", fill: "#263238" }),
	      React.createElement("path", { d: "M268.228 795.927C268.228 795.927 268.433 796.336 268.638 796.951C268.843 797.36 269.047 797.77 269.047 797.77C269.252 797.77 269.252 797.156 268.843 796.746C268.843 796.132 268.433 795.927 268.228 795.927Z", fill: "#263238" }),
	      React.createElement("path", { d: "M265.768 793.062C265.768 793.062 265.973 793.472 266.178 793.882C266.587 794.291 266.792 794.496 266.997 794.291C266.997 794.291 266.792 793.882 266.587 793.472C266.178 793.267 265.768 793.062 265.768 793.062Z", fill: "#263238" }),
	      React.createElement("path", { d: "M262.288 791.83C262.288 792.035 262.698 791.83 263.312 792.035C263.722 792.24 264.131 792.445 264.336 792.445C264.336 792.445 264.131 791.83 263.517 791.83C262.698 791.421 262.288 791.625 262.288 791.83Z", fill: "#263238" }),
	      React.createElement("path", { d: "M259.829 791.214C259.829 791.419 260.033 791.419 260.238 791.624C260.443 791.624 260.853 791.624 260.853 791.624C260.853 791.419 260.648 791.419 260.443 791.214C260.033 791.214 259.829 791.214 259.829 791.214Z", fill: "#263238" }),
	      React.createElement("path", { d: "M225.021 436.725C225.021 436.725 251.438 612.84 247.752 621.441C243.861 630.042 158.056 717.895 158.056 717.895L125.905 662.603C125.905 662.603 182.835 599.529 182.016 596.457C181.197 593.181 141.059 422.595 141.059 422.595L225.021 436.725Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M234.441 501.853C234.236 500.01 212.733 451.885 212.733 451.885L223.177 437.141L225.02 436.731L234.441 501.853Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M125.701 420.143L124.063 426.696C119.353 445.946 122.22 466.22 132.049 483.422L203.929 608.135C209.048 616.941 212.734 626.566 214.987 636.396L232.803 717.081H291.781C291.781 717.081 284.409 661.789 278.061 621.446C273.146 590.934 232.394 496.528 212.734 451.885L225.021 436.935L203.724 433.454L125.701 420.143Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M214.372 451.479C214.167 451.479 215.396 454.551 217.444 459.261C219.491 464.176 222.154 470.729 225.021 478.101C227.888 485.473 230.345 492.231 232.188 497.146C234.031 502.061 235.055 505.133 235.26 504.928C235.26 504.928 235.055 504.109 234.85 502.675C234.441 501.242 233.826 499.194 233.007 496.736C231.369 491.822 229.116 485.064 226.045 477.487C223.178 470.114 220.311 463.357 218.263 458.647C217.239 456.189 216.215 454.346 215.6 453.117C214.781 452.298 214.372 451.479 214.372 451.479Z", fill: "#E06255" }),
	      React.createElement("path", { d: "M220.922 660.974C220.922 660.974 220.922 660.564 220.922 659.54C220.717 658.517 220.717 657.083 220.512 655.649C220.307 654.011 220.103 651.759 219.488 649.301C219.079 646.844 218.669 643.977 217.85 641.11C217.44 639.676 217.031 638.038 216.621 636.4C216.212 634.761 215.597 633.123 215.188 631.28C214.164 627.799 212.73 624.113 211.502 620.222C208.635 612.44 204.949 604.249 200.648 595.648C191.842 578.65 182.422 564.316 175.46 553.872C171.978 548.752 169.111 544.656 167.063 541.789C166.04 540.356 165.425 539.332 164.811 538.513C164.196 537.694 163.992 537.489 163.992 537.489C163.992 537.489 164.196 537.898 164.606 538.717C165.22 539.537 165.835 540.765 166.859 542.199C168.907 545.271 171.569 549.366 174.845 554.486C181.603 564.93 190.818 579.47 199.624 596.262C203.925 604.658 207.611 613.054 210.683 620.631C212.116 624.522 213.55 628.208 214.574 631.69C215.188 633.533 215.597 635.171 216.212 636.809C216.621 638.448 217.031 640.086 217.44 641.519C218.26 644.591 218.874 647.253 219.284 649.711C219.898 652.168 220.103 654.216 220.512 655.854C220.717 657.493 220.922 658.721 221.127 659.745C220.717 660.564 220.717 660.974 220.922 660.974Z", fill: "#E06255" }),
	      React.createElement("path", { d: "M135.323 477.692C135.323 477.692 135.118 477.487 134.913 477.078C134.504 476.668 134.094 475.849 133.685 475.03C134.708 472.982 137.575 470.115 142.49 469.091C144.948 468.477 147.61 468.477 150.682 468.887C153.753 469.296 156.825 470.32 160.102 471.344C163.378 472.573 166.86 473.597 170.341 475.44C173.822 477.283 177.099 480.15 178.737 484.45C179.556 486.498 179.761 488.955 179.147 491.003C178.532 493.256 177.508 495.304 176.485 497.147C175.461 499.195 174.642 501.242 174.642 503.495C174.642 505.748 175.87 507.796 177.508 509.229C181.399 513.12 187.338 513.939 192.048 516.192C196.963 518.649 200.649 522.745 202.902 527.045C205.154 531.346 206.178 536.261 205.974 540.561C205.769 545.066 204.131 548.957 202.083 552.029C197.987 558.377 192.253 561.449 188.362 562.678C186.314 563.292 184.676 563.497 183.652 563.702C182.628 563.702 182.014 563.702 182.014 563.702C182.014 563.497 184.266 563.702 188.157 562.268C192.048 560.835 197.373 557.763 201.468 551.62C203.516 548.548 204.95 544.657 205.154 540.356C205.359 536.056 204.335 531.551 202.083 527.25C199.83 522.95 196.144 519.059 191.639 516.806C189.386 515.577 186.724 514.963 184.062 513.939C181.399 512.915 178.737 511.687 176.689 509.639C174.846 508 173.618 505.543 173.618 503.086C173.413 500.628 174.437 498.376 175.461 496.328C176.485 494.28 177.508 492.437 178.123 490.389C178.737 488.341 178.532 486.293 177.713 484.45C176.28 480.559 173.208 477.897 169.931 476.054C166.655 474.211 163.174 472.982 159.897 471.958C156.62 470.73 153.549 469.91 150.682 469.296C147.815 468.887 145.153 468.887 142.695 469.296C137.985 470.32 135.118 472.982 133.889 474.825V474.62C134.299 475.44 134.708 476.259 134.913 476.668C135.323 477.487 135.323 477.692 135.323 477.692Z", fill: "#FAFAFA" }),
	      React.createElement("path", { d: "M284.201 661.179C284.201 661.384 282.767 659.541 279.286 658.107C277.648 657.493 275.395 656.878 272.733 656.469C270.071 656.059 266.999 655.854 263.722 655.24C260.446 654.626 256.76 653.602 253.278 651.759C249.797 649.711 246.52 647.049 243.858 643.363C238.534 636.195 236.486 625.137 240.377 615.512C242.22 610.597 245.292 606.501 246.111 601.791C246.93 597.081 245.701 592.576 244.268 588.48C242.834 584.385 241.196 580.494 240.377 576.398C239.353 572.507 239.558 568.616 240.377 565.34C242.015 558.582 245.906 554.281 248.773 552.029C251.845 549.776 253.893 549.162 253.893 549.162C253.893 549.366 252.05 549.981 249.183 552.438C246.316 554.896 242.629 559.196 241.196 565.544C240.377 568.821 240.377 572.507 241.196 576.193C242.015 580.084 243.653 583.77 245.292 588.071C246.725 592.166 248.159 596.876 247.339 601.996C246.52 606.911 243.449 611.211 241.605 615.921C237.919 625.342 239.762 635.99 244.882 642.953C247.339 646.434 250.616 649.301 253.893 651.144C257.169 653.192 260.855 654.216 264.132 654.626C267.408 655.24 270.48 655.445 273.142 656.059C275.805 656.469 278.057 657.288 279.695 657.902C281.538 658.721 282.562 659.541 283.382 660.155C283.996 660.769 284.405 661.179 284.201 661.179Z", fill: "#FAFAFA" }),
	      React.createElement("path", { d: "M256.759 719.953C256.554 719.953 256.554 717.291 255.325 713.195C254.916 711.147 253.892 708.69 252.663 706.233C251.434 703.775 249.796 701.113 247.748 698.451C245.7 695.993 243.448 693.741 241.195 692.102C238.943 690.464 236.895 689.031 234.847 688.007C230.956 686.164 228.499 685.345 228.499 685.14C228.499 685.14 229.113 685.14 230.342 685.549C230.956 685.754 231.57 685.959 232.389 686.164C233.209 686.368 234.232 686.778 235.052 687.188C237.099 688.007 239.352 689.44 241.605 691.079C243.857 692.922 246.11 694.969 248.363 697.632C250.41 700.294 252.049 702.956 253.277 705.618C254.506 708.28 255.325 710.738 255.735 712.786C255.94 713.81 256.144 714.834 256.144 715.653C256.349 716.472 256.349 717.291 256.349 717.905C256.759 719.339 256.759 719.953 256.759 719.953Z", fill: "#FAFAFA" }),
	      React.createElement("path", { d: "M226.452 488.34C226.452 488.34 226.247 488.34 225.633 488.544C225.018 488.544 224.404 488.749 223.38 488.749C221.332 488.954 218.261 488.749 214.779 487.93C211.298 487.111 206.997 485.473 203.106 482.606C199.011 479.943 195.325 475.848 192.458 470.933C189.795 466.018 188.567 460.489 188.567 455.779C188.362 450.864 189.386 446.563 190.615 443.082C191.843 439.601 193.277 436.939 194.505 435.3C195.12 434.481 195.529 433.867 195.939 433.457C196.349 433.048 196.553 432.843 196.553 432.843C196.758 433.048 193.482 436.324 191.229 443.287C190 446.768 189.386 450.864 189.591 455.779C189.795 460.489 191.024 465.608 193.482 470.523C196.144 475.233 199.83 479.124 203.721 481.786C207.612 484.449 211.503 486.292 214.984 487.111C221.947 488.749 226.452 487.93 226.452 488.34Z", fill: "#FAFAFA" }),
	      React.createElement("path", { d: "M174.026 603.226C174.026 603.226 174.436 603.43 175.255 603.635C176.074 604.045 177.098 604.659 178.327 605.478C180.989 607.116 184.88 609.779 188.361 614.284C190.204 616.537 191.638 619.199 192.662 622.475C193.685 625.752 194.095 629.438 193.276 633.124C192.661 636.81 191.023 640.701 187.951 643.568C184.88 646.435 180.374 647.459 177.917 650.736C175.255 654.012 174.845 658.313 174.436 662.204C174.026 666.094 173.821 670.19 172.388 673.672C170.954 677.358 168.087 679.815 165.22 681.453C162.353 683.092 159.077 683.911 156.415 684.116C150.681 684.525 146.175 683.501 143.104 682.887C141.67 682.477 140.441 682.272 139.622 682.068C138.803 681.863 138.394 681.658 138.394 681.658C138.394 681.658 138.803 681.658 139.622 681.863C140.441 682.068 141.67 682.272 143.104 682.477C146.175 683.092 150.681 683.911 156.21 683.501C158.872 683.296 161.944 682.477 164.811 680.839C167.678 679.201 170.135 676.743 171.569 673.467C172.797 670.19 173.207 666.299 173.412 662.204C173.617 660.156 173.821 658.108 174.436 656.06C175.05 654.012 175.869 651.964 177.303 650.121C180.17 646.64 184.675 645.616 187.542 642.954C190.409 640.292 192.047 636.605 192.662 633.124C193.276 629.643 193.071 625.957 192.047 622.885C191.023 619.813 189.59 617.151 187.951 614.898C184.675 610.393 180.784 607.731 178.327 606.093C177.098 605.273 176.074 604.659 175.255 604.25C174.231 603.43 174.026 603.226 174.026 603.226Z", fill: "#FAFAFA" }),
	      React.createElement("path", { d: "M180.171 179.522C168.908 176.655 156.621 183.823 150.887 194.062C145.153 204.301 145.153 216.793 147.815 228.261C148.839 232.971 150.477 237.886 149.453 242.801C148.225 247.92 144.129 252.016 142.286 256.931C138.6 266.351 143.31 277 148.02 286.01C150.068 290.106 152.935 294.816 157.44 295.635C162.56 296.659 167.065 292.563 171.365 289.696C178.942 284.577 188.362 282.529 197.168 283.962C207.407 285.601 216.623 291.335 226.862 291.539C236.077 291.744 245.293 286.829 250.412 279.048C253.484 274.337 254.508 267.17 250.207 263.484C247.34 261.231 242.835 261.231 240.378 258.569C237.306 255.292 238.535 249.968 240.173 245.668C241.811 241.367 243.45 236.248 240.583 232.766C237.306 228.875 230.548 229.49 227.476 225.394C224.2 221.093 227.681 215.155 227.476 209.83C227.272 205.12 224.2 200.82 220.514 197.953C216.623 195.086 216.213 194.267 210.889 184.642", fill: "#263238" }),
	      React.createElement("path", { d: "M164.404 273.11L205.361 276.591C205.361 276.591 235.26 272.291 246.728 347.856L291.985 346.013L294.033 376.117L231.574 379.189L224.201 374.683L225.021 436.733L121.809 429.156C124.062 415.026 135.12 396.595 138.806 384.718C135.12 375.298 114.232 337.003 113.208 317.548C110.546 263.69 164.404 273.11 164.404 273.11Z", fill: "#E06255" }),
	      React.createElement("path", { opacity: "0.3", d: "M228.91 328.607C228.91 328.607 236.077 336.798 236.282 343.761C236.487 354.819 233.62 360.553 237.101 372.635L227.272 375.093C227.272 375.093 225.838 372.226 227.067 365.878C228.296 359.529 230.753 351.952 231.982 344.99C233.415 335.16 228.91 328.607 228.91 328.607Z", fill: "black" }),
	      React.createElement("path", { d: "M227.272 374.887C227.272 374.887 227.067 374.068 226.658 372.43C226.453 370.792 226.248 368.539 226.658 365.672C227.067 362.805 227.681 359.528 228.705 355.842C229.729 352.156 230.958 348.265 231.368 343.965C231.982 339.664 231.572 335.569 230.139 332.292C228.705 328.811 226.658 326.149 224.815 324.101C221.128 319.8 218.466 317.548 218.671 317.343C218.671 317.343 219.49 317.752 220.719 318.776C221.948 319.8 223.586 321.438 225.634 323.486C227.477 325.534 229.729 328.401 231.163 331.882C232.801 335.364 233.211 339.869 232.596 344.17C231.982 348.47 230.753 352.566 229.729 356.047C228.705 359.733 227.886 363.01 227.477 365.672C227.067 368.539 227.067 370.792 227.067 372.225C227.272 373.863 227.272 374.887 227.272 374.887Z", fill: "#263238" }),
	      React.createElement(
	        "g",
	        { opacity: "0.2" },
	        React.createElement("path", { d: "M228.706 374.071C218.466 374.276 208.432 374.481 198.193 374.685C195.735 374.685 193.278 374.685 191.025 373.866C187.749 372.433 185.701 369.361 183.858 366.289C178.533 357.483 173.619 348.268 169.113 339.053C169.113 339.053 177.1 364.651 182.219 375.914C183.653 379.191 185.906 380.01 189.387 379.6C202.903 379.6 216.009 377.757 228.706 374.071Z", fill: "black" })
	      ),
	      React.createElement("path", { d: "M428.368 306.491C433.078 306.082 437.584 307.106 441.474 308.949C443.318 309.768 445.161 310.177 447.004 310.177H451.918V246.08C451.918 240.55 447.413 236.25 442.089 236.25H378.196V231.95C378.196 229.902 378.81 228.059 379.63 226.216C381.882 221.506 382.906 215.976 381.882 210.038C379.834 198.57 370.414 189.354 358.741 188.126C342.768 186.283 329.048 198.979 329.048 214.543C329.048 218.434 329.867 221.915 331.3 225.192C332.119 226.83 332.529 228.673 332.529 230.516V236.045H270.274C264.745 236.045 260.445 240.55 260.445 245.875V419.328C260.445 423.833 264.131 427.314 268.431 427.314H444.137C448.642 427.314 452.123 423.628 452.123 419.328V356.663H444.956C443.318 356.663 441.679 357.073 440.246 357.687C437.174 358.916 433.897 359.53 430.416 359.53C415.262 359.53 403.18 347.039 403.794 331.884C404.204 318.573 415.057 307.515 428.368 306.491Z", fill: "#3B53A7" }),
	      React.createElement("path", { opacity: "0.2", d: "M428.368 306.491C433.078 306.082 437.584 307.106 441.474 308.949C443.318 309.768 445.161 310.177 447.004 310.177H451.918V246.08C451.918 240.55 447.413 236.25 442.089 236.25H378.196V231.95C378.196 229.902 378.81 228.059 379.63 226.216C381.882 221.506 382.906 215.976 381.882 210.038C379.834 198.57 370.414 189.354 358.741 188.126C342.768 186.283 329.048 198.979 329.048 214.543C329.048 218.434 329.867 221.915 331.3 225.192C332.119 226.83 332.529 228.673 332.529 230.516V236.045H270.274C264.745 236.045 260.445 240.55 260.445 245.875V419.328C260.445 423.833 264.131 427.314 268.431 427.314H444.137C448.642 427.314 452.123 423.628 452.123 419.328V356.663H444.956C443.318 356.663 441.679 357.073 440.246 357.687C437.174 358.916 433.897 359.53 430.416 359.53C415.262 359.53 403.18 347.039 403.794 331.884C404.204 318.573 415.057 307.515 428.368 306.491Z", fill: "white" }),
	      React.createElement("path", { d: "M163.788 274.55L160.716 202.261L189.386 180.554L215.393 193.251C215.393 193.251 216.212 226.016 215.393 240.146C214.574 254.276 200.239 255.915 200.239 255.915C200.239 255.915 200.649 264.311 200.854 272.912C201.263 283.561 192.662 292.366 182.218 292.162C172.389 292.162 164.197 284.38 163.788 274.55Z", fill: "#FFBE9D" }),
	      React.createElement("path", { d: "M212.733 217.21C212.733 218.234 211.914 219.053 210.89 219.053C209.866 219.053 209.047 218.234 209.047 217.21C209.047 216.186 209.866 215.367 210.89 215.367C211.914 215.367 212.733 216.186 212.733 217.21Z", fill: "#263238" }),
	      React.createElement("path", { d: "M214.372 215.158C214.167 215.363 212.734 214.339 210.891 214.134C208.843 213.929 207.409 214.953 207.205 214.748C207.205 214.544 207.409 214.134 208.024 213.724C208.638 213.315 209.662 212.905 210.891 212.905C212.119 212.905 213.143 213.52 213.758 213.929C214.372 214.544 214.577 214.953 214.372 215.158Z", fill: "#263238" }),
	      React.createElement("path", { d: "M191.638 217.21C191.638 218.234 190.819 219.053 189.795 219.053C188.771 219.053 187.952 218.234 187.952 217.21C187.952 216.186 188.771 215.367 189.795 215.367C190.819 215.367 191.638 216.186 191.638 217.21Z", fill: "#263238" }),
	      React.createElement("path", { d: "M192.658 215.158C192.454 215.363 191.02 214.339 189.177 214.134C187.129 213.929 185.696 214.953 185.491 214.748C185.491 214.544 185.696 214.134 186.31 213.724C186.924 213.315 187.948 212.905 189.177 212.905C190.406 212.905 191.43 213.52 192.044 213.929C192.658 214.544 192.863 214.953 192.658 215.158Z", fill: "#263238" }),
	      React.createElement("path", { d: "M200.24 255.912C200.24 255.912 190.615 256.117 181.4 249.564C181.4 249.564 186.11 260.213 200.445 259.598L200.24 255.912Z", fill: "#EB996E" }),
	      React.createElement("path", { d: "M199.83 231.749C199.83 231.544 201.058 231.544 203.106 231.34C203.516 231.34 204.13 231.34 204.13 230.93C204.335 230.52 204.13 229.906 203.925 229.292C203.516 228.063 203.106 226.63 202.492 225.196C201.468 222.329 200.853 219.667 200.239 217.824C199.625 215.981 199.42 214.752 199.42 214.752C199.42 214.752 200.034 215.776 200.649 217.824C201.263 219.667 202.287 222.329 203.106 225.196C203.516 226.63 203.925 228.063 204.335 229.292C204.54 229.906 204.744 230.52 204.54 231.34C204.335 231.749 203.925 231.954 203.72 231.954C203.311 231.954 203.106 231.954 202.901 231.954C201.058 231.749 199.83 231.749 199.83 231.749Z", fill: "#263238" }),
	      React.createElement("path", { d: "M198.395 233.384C197.576 233.589 196.962 233.998 196.348 234.612C195.733 235.227 195.528 236.046 195.938 236.66C196.348 237.479 197.371 237.889 198.395 237.684C199.214 237.479 199.829 237.07 200.238 236.251C200.648 235.636 200.443 234.612 200.034 233.998C199.624 233.384 198.6 233.179 197.986 233.589", fill: "#EB996E" }),
	      React.createElement("path", { d: "M200.853 236.252C200.853 236.457 199.215 237.071 197.577 236.047C195.734 235.023 195.324 233.385 195.734 233.385C195.939 233.18 196.758 234.409 198.191 235.228C199.42 235.842 200.853 235.842 200.853 236.252Z", fill: "#263238" }),
	      React.createElement("path", { d: "M191.023 177.683C185.085 177.274 178.941 180.141 175.05 184.441C171.159 188.947 169.111 195.09 169.316 201.029C169.521 203.281 169.931 205.739 171.364 207.377C173.412 209.63 176.893 210.244 179.965 210.449C183.242 210.859 186.518 211.063 189.59 210.039C192.662 208.811 195.119 205.739 194.505 202.667C193.071 204.715 194.3 207.787 196.348 209.015C198.396 210.244 201.058 210.244 203.72 210.244C207.201 210.244 210.888 210.244 214.369 210.244C215.598 210.244 216.826 210.244 217.85 209.425C219.079 208.401 219.488 206.558 219.693 204.92C220.308 199.186 220.717 193.042 218.26 187.923C216.007 183.417 211.297 180.346 206.382 178.707C201.467 177.274 196.143 177.888 191.023 177.683Z", fill: "#263238" }),
	      React.createElement("path", { d: "M160.715 272.495C164.606 274.543 171.979 266.556 174.436 262.87C176.893 259.184 177.098 254.474 176.484 249.968C175.869 245.668 174.846 241.163 174.641 236.862C174.436 229.695 177.098 222.732 178.532 215.769C179.965 208.192 179.556 200.206 177.508 192.629C176.689 189.762 175.46 186.485 172.593 185.461C170.34 184.437 167.473 185.256 165.63 186.895C163.787 188.533 162.354 190.786 161.33 193.038L159.077 210.24L160.715 234.405V272.495Z", fill: "#263238" }),
	      React.createElement("path", { d: "M263.723 363.425L274.167 399.057C274.167 399.057 219.49 418.921 190.001 418.512C162.355 418.102 154.368 415.03 144.538 392.709C134.709 370.387 123.65 344.584 121.398 329.84C121.398 329.84 99.0763 267.995 158.873 274.138L167.065 321.239C167.065 321.239 173.618 343.151 174.232 344.38C178.738 356.257 184.471 373.459 190.001 375.507C195.53 377.35 263.723 363.425 263.723 363.425Z", fill: "#E06255" }),
	      React.createElement("path", { d: "M263.722 363.422C263.722 363.422 263.313 363.626 262.289 363.831C261.265 364.036 259.831 364.241 258.193 364.65C254.507 365.469 249.183 366.493 242.63 368.132C236.076 369.565 228.295 371.408 219.284 373.251C210.478 374.89 200.444 376.118 189.795 375.913H189.386L189.181 375.504C187.952 372.637 186.928 369.565 185.699 366.289C177.918 344.172 171.774 323.898 167.064 309.358C164.607 301.986 162.764 296.252 161.33 292.157C160.716 290.109 160.101 288.675 159.692 287.446C160.101 288.47 160.716 290.109 161.535 291.952C163.173 296.047 165.221 301.781 167.678 308.949C172.798 323.489 178.737 343.762 186.723 365.674C187.952 368.746 188.976 372.023 190.205 374.89L189.795 374.48C200.239 374.685 210.274 373.456 219.079 371.818C227.885 370.179 235.667 368.336 242.425 367.108C248.978 365.674 254.302 364.65 257.988 364.036C259.831 363.831 261.06 363.422 262.289 363.422C263.313 363.422 263.722 363.422 263.722 363.422Z", fill: "#263238" }),
	      React.createElement("path", { d: "M274.166 399.055C274.166 399.055 273.551 399.26 272.528 399.875C271.504 400.284 269.865 400.898 267.818 401.718C263.722 403.151 257.783 405.199 250.206 407.452C242.629 409.704 233.618 411.957 223.584 414.619C213.55 417.076 202.491 419.943 190.409 420.353C187.337 420.353 184.47 420.353 181.603 420.148C178.736 419.943 175.869 419.329 173.207 418.305C167.883 416.462 163.173 413.39 159.282 409.704C151.5 402.537 146.79 394.55 142.899 387.587C139.213 380.625 136.755 374.891 134.912 370.795C134.093 368.747 133.479 367.109 133.069 366.085C132.66 365.061 132.455 364.447 132.455 364.447C132.455 364.447 132.66 365.061 133.274 366.085C133.888 367.314 134.503 368.747 135.322 370.59C137.165 374.481 139.827 380.42 143.513 387.178C147.404 393.936 152.319 401.922 159.896 408.885C163.787 412.366 168.292 415.233 173.412 417.076C176.074 417.896 178.736 418.51 181.603 418.715C184.47 419.124 187.337 419.124 190.409 418.919C202.286 418.305 213.345 415.643 223.379 413.186C233.414 410.728 242.424 408.475 250.001 406.223C257.578 404.175 263.517 402.127 267.613 400.898C269.661 400.284 271.094 399.67 272.323 399.26C273.551 399.26 274.166 399.055 274.166 399.055Z", fill: "#263238" }),
	      React.createElement("path", { opacity: "0.2", d: "M142.491 387.18C142.491 387.18 152.731 426.499 179.353 425.68C205.77 424.861 230.958 413.597 230.958 413.597L229.73 412.369C229.73 412.369 184.677 421.994 172.185 416.055C148.43 404.382 142.491 387.18 142.491 387.18Z", fill: "black" }),
	      React.createElement("path", { d: "M270.481 394.956H278.877C286.455 394.137 290.755 394.137 292.803 392.089C295.67 389.427 291.779 386.765 291.779 386.765C291.779 386.765 297.308 384.922 296.694 381.44C296.284 379.188 293.827 378.983 293.827 378.983C293.827 378.983 298.742 377.14 299.561 375.092C300.789 372.43 297.513 370.792 297.513 370.792C304.066 366.696 303.452 362.6 302.018 362.191C300.585 361.781 295.26 364.239 295.26 364.239C290.96 365.467 279.082 369.153 283.383 362.6C287.888 356.047 288.707 349.289 287.683 347.446C286.659 345.398 283.588 346.217 283.178 348.47C282.768 350.518 281.335 353.59 280.106 355.842C279.082 357.685 277.649 359.324 276.215 360.757C274.372 362.395 272.734 363.829 271.3 364.853L263.928 372.02L270.481 394.956Z", fill: "#FFBE9D" })
	    ),
	    React.createElement(
	      "defs",
	      null,
	      React.createElement(
	        "clipPath",
	        { id: "clip0_4242_33230" },
	        React.createElement("rect", { width: "925.627", height: "815.043", fill: "white", transform: "translate(0.574219 0.746094)" })
	      )
	    )
	  );
	}
	
	var _default = SvgComponent;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(SvgComponent, "SvgComponent", "D:/a/1/s/src/web/employee/src/images/Puzzle.js");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "D:/a/1/s/src/web/employee/src/images/Puzzle.js");
	}();

	;

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function Thinking(props) {
	  return React.createElement(
	    "svg",
	    _extends({ width: "400", height: "917", viewBox: "0 0 1516 917", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
	    React.createElement(
	      "g",
	      { clipPath: "url(#clip0_4242_34229)" },
	      React.createElement("path", { d: "M1019.65 65.5592C1020.67 58.5965 1010.84 52.8625 1003.47 52.2482C999.989 52.0434 996.303 52.453 993.027 51.4291C985.859 48.9716 982.992 39.5515 975.825 36.4798C970.5 34.2271 964.562 36.275 959.442 38.7324C954.322 41.3946 949.203 44.4664 943.469 44.876C938.554 45.2855 933.025 43.4425 928.724 45.6951C925.448 47.5382 923.809 51.2243 920.738 53.4769C917.871 55.7295 913.98 56.1391 910.294 56.3439C906.607 56.5487 902.921 56.5487 899.645 58.187C896.368 59.6204 893.706 63.1018 894.32 66.7879L1019.65 65.5592Z", fill: "#FAFAFA" }),
	      React.createElement("path", { d: "M1396.45 76.2051C1397.48 69.2425 1387.65 63.5085 1380.27 62.8941C1376.79 62.6894 1373.11 63.0989 1369.83 62.075C1362.66 59.6176 1359.8 50.1975 1352.63 47.1257C1347.3 44.8731 1341.37 46.9209 1336.25 49.3783C1331.13 52.0405 1326.01 55.1123 1320.27 55.5219C1315.36 55.9315 1309.83 54.0884 1305.53 56.341C1302.25 58.1841 1300.61 61.8702 1297.54 64.1228C1294.67 66.3755 1290.78 66.785 1287.1 66.9898C1283.41 67.1946 1279.72 67.1946 1276.45 68.8329C1273.17 70.2664 1270.51 73.7477 1271.12 77.4338L1396.45 76.2051Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M250.068 114.297C251.092 107.334 241.262 101.6 233.89 100.986C230.409 100.781 226.723 101.191 223.446 100.167C216.279 97.7094 213.412 88.2893 206.244 85.2175C200.92 82.9649 194.981 85.0127 189.861 87.4701C184.742 90.1323 179.622 93.2041 173.888 93.6137C168.973 94.0232 163.444 92.1802 159.144 94.4328C155.867 96.2759 154.229 99.962 151.157 102.215C148.29 104.467 144.399 104.877 140.713 105.082C137.027 105.286 133.341 105.286 130.064 106.925C126.788 108.358 124.125 111.84 124.74 115.526L250.068 114.297Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M1170.99 148.088C1172.42 137.849 1158.08 129.453 1147.23 128.633C1142.11 128.224 1136.79 129.043 1131.87 127.405C1121.22 123.719 1117.13 109.998 1106.68 105.698C1098.9 102.421 1090.1 105.288 1082.52 109.179C1074.94 112.865 1067.57 117.78 1059.17 118.189C1051.8 118.599 1044.02 115.937 1037.67 119.418C1032.96 122.08 1030.5 127.609 1026 130.681C1021.7 133.753 1016.17 134.572 1010.84 134.777C1005.52 134.982 999.99 135.187 995.28 137.234C990.57 139.282 986.474 144.607 987.498 149.726L1170.99 148.088Z", fill: "#EBEBEB" }),
	      React.createElement("path", { d: "M446.047 168.361C447.276 159.555 434.784 152.183 425.364 151.364C420.859 150.955 416.149 151.774 412.053 150.135C402.838 146.859 399.152 134.981 390.141 131.295C383.383 128.428 375.601 130.886 369.253 134.162C362.7 137.439 356.352 141.534 348.979 141.944C342.631 142.354 335.873 140.101 330.344 143.173C326.248 145.425 323.996 150.135 320.31 153.002C316.623 155.665 311.709 156.279 307.203 156.484C302.493 156.689 297.783 156.689 293.688 158.736C289.387 160.579 285.906 165.085 286.93 169.59L446.047 168.361Z", fill: "#F5F5F5" }),
	      React.createElement("path", { d: "M499.495 365.974C491.099 346.929 462.429 340.785 446.866 354.915C439.289 337.508 412.667 332.184 398.946 345.495C398.741 335.665 391.983 326.45 382.768 323.174C373.553 319.897 362.494 323.173 356.351 330.546C353.893 312.525 339.354 296.552 321.537 292.456C303.721 288.36 283.857 296.347 273.823 311.706C246.381 298.599 210.135 308.839 193.547 334.437C183.103 317.644 155.048 316.416 143.375 332.389C132.931 319.897 114.705 314.163 99.1413 318.668C83.3729 323.173 71.0858 337.508 68.8332 353.686C49.5834 340.785 21.1183 355.734 11.4934 376.827H547.005C544.548 360.649 512.397 355.325 499.495 365.974Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M1157.26 881.624C1156.24 879.167 1153.78 877.733 1151.53 876.3C1133.3 864.422 1114.87 852.545 1096.65 840.667C1108.94 836.776 1116.1 821.622 1111.39 809.54C1105.86 795.205 1088.66 789.676 1073.71 786.399C1058.76 782.918 1041.56 778.003 1035.42 763.873C1032.35 756.91 1032.76 748.719 1029.48 741.756C1022.52 726.602 1002.65 723.94 987.703 716.363C965.996 705.51 952.685 682.574 932.001 670.082C919.509 662.71 904.151 658.614 896.164 646.327C893.911 643.05 892.478 639.159 889.201 636.907C886.13 634.654 880.396 634.859 879.167 638.545C878.757 639.978 878.962 641.617 879.372 643.05C891.044 697.523 932.82 739.913 958.828 789.471C976.44 823.056 987.088 860.327 1008.8 891.249L1075.96 913.161C1086.41 915.209 1096.85 916.233 1107.5 916.233C1127.78 916.233 1151.74 908.861 1157.06 889.406C1158.08 886.744 1158.49 883.877 1157.26 881.624Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M1340.75 798.07C1352.22 801.757 1359.8 812.405 1368.6 820.802C1377.41 829.198 1391.33 835.341 1401.16 828.379C1386.83 813.225 1372.29 798.071 1357.95 782.916L1275.83 785.579C1297.54 798.48 1302.66 829.403 1323.96 843.328C1314.74 829.198 1305.53 815.068 1297.54 800.118C1296.31 797.661 1295.08 794.18 1297.13 792.337C1298.16 791.517 1299.38 791.313 1300.61 791.313C1307.78 791.313 1313.92 796.637 1318.02 802.781C1321.91 808.719 1324.57 815.682 1328.87 821.621C1333.38 827.559 1339.52 832.065 1345.46 836.365C1355.7 843.738 1365.94 851.11 1376.18 858.482C1376.79 852.953 1373.93 847.424 1370.65 842.714C1364.3 833.293 1356.72 824.897 1348.12 817.525C1343 813.225 1337.68 809.334 1334.2 803.804C1333.58 802.985 1333.17 801.961 1333.17 800.733C1333.17 797.661 1337.68 797.047 1340.75 798.07Z", fill: "#F5F5F5" }),
	      React.createElement("path", { d: "M265.222 636.292C263.788 633.425 261.536 631.172 260.921 628.101C260.307 624.414 262.15 619.704 259.078 617.657C256.621 615.813 252.115 617.247 250.477 614.38L194.776 611.513C190.066 614.585 185.151 617.657 183.103 622.776C180.85 627.896 182.898 635.063 188.223 636.292C192.728 637.316 198.462 634.244 201.738 637.521C202.558 638.545 202.967 639.773 203.377 641.002C205.834 650.422 206.448 662.3 215.049 667.01C218.94 669.262 223.65 669.262 227.541 671.105C237.371 675.815 241.467 690.15 252.32 691.789C255.187 692.198 258.669 691.379 259.897 688.717C261.945 685.031 258.464 680.73 256.621 677.044C251.911 668.034 254.778 656.361 249.658 647.555C248.429 645.302 246.586 643.255 245.767 640.797C244.948 638.34 245.562 635.063 248.02 634.039C254.163 631.582 257.44 646.326 263.583 643.869C266.655 643.255 266.655 639.159 265.222 636.292Z", fill: "#F5F5F5" }),
	      React.createElement("path", { d: "M835.957 382.971H844.353C841.691 382.766 838.824 382.766 835.957 382.971Z", fill: "#F5F5F5" }),
	      React.createElement("path", { d: "M844.558 382.972C861.76 383.791 878.757 391.163 891.044 403.245C897.802 409.799 903.946 417.99 913.161 419.628C920.943 420.857 928.52 416.966 936.506 416.966C947.36 416.966 956.37 424.543 966.2 429.048C976.03 433.758 990.16 434.168 995.075 424.543C995.484 432.53 1003.88 437.649 1011.66 439.697C1019.44 441.95 1028.05 442.974 1033.78 448.503C1038.28 453.008 1041.15 460.38 1047.5 461.609C1050.98 462.223 1054.46 460.585 1057.94 459.971C1064.91 458.947 1071.66 462.633 1078.63 464.681C1085.38 466.729 1094.4 466.319 1097.67 459.971C1127.37 463.862 1157.06 467.753 1186.75 471.848C1197.2 473.282 1207.64 474.715 1218.29 474.92C1231.4 475.125 1244.71 473.487 1257.4 470.21C1263.96 468.367 1270.51 466.114 1277.06 464.066C1281.36 462.633 1285.87 461.199 1290.37 460.585C1295.08 459.971 1300 460.176 1304.71 460.176C1332.36 460.176 1359.18 451.165 1385.6 442.155C1426.35 428.229 1469.36 412.666 1495.36 378.466L844.558 382.972Z", fill: "#F5F5F5" }),
	      React.createElement("path", { d: "M14.3604 376.829C23.3709 384.815 42.6206 385.02 53.8838 389.116C58.5938 390.959 61.8704 394.85 65.9661 397.717C75.7958 405.089 89.7211 406.523 100.779 401.198C110.609 405.703 120.439 409.799 130.883 412.871C147.061 417.786 164.058 420.448 181.055 420.448C226.517 420.653 270.136 402.632 315.189 396.693C372.324 389.116 430.892 400.789 488.027 392.188C497.652 390.754 507.072 388.706 515.878 384.815C521.202 382.358 526.117 379.286 530.623 375.6L14.3604 376.829Z", fill: "#F5F5F5" }),
	      React.createElement("path", { d: "M619.909 476.356C619.909 476.56 553.559 476.97 471.645 476.97C389.731 476.97 323.381 476.765 323.381 476.356C323.381 475.946 389.731 475.741 471.645 475.741C553.559 475.741 619.909 475.946 619.909 476.356Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M651.651 489.87C651.651 490.074 625.848 490.484 593.901 490.484C561.955 490.484 536.152 490.279 536.152 489.87C536.152 489.665 561.955 489.255 593.901 489.255C625.643 489.46 651.651 489.665 651.651 489.87Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M320.309 807.698C320.309 807.902 268.293 808.312 204.196 808.312C140.098 808.312 88.0828 808.107 88.0828 807.698C88.0828 807.288 140.098 807.083 204.196 807.083C268.293 807.083 320.309 807.288 320.309 807.698Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M340.377 819.779C340.377 819.984 315.393 820.394 284.471 820.394C253.548 820.394 228.565 820.189 228.565 819.779C228.565 819.37 253.548 819.165 284.471 819.165C315.189 819.37 340.377 819.575 340.377 819.779Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M643.869 11.9087C643.869 11.9087 643.049 11.7039 641.411 11.2943C639.773 10.8848 637.52 10.68 634.653 11.0896C631.786 11.4991 628.51 12.7278 625.643 14.9805C622.776 17.4379 620.318 20.9192 619.294 25.2197V25.4245L618.885 26.858L618.27 25.4245C616.632 21.3288 613.765 18.257 610.489 16.0044C607.417 13.9565 603.936 12.9326 601.069 12.7278C595.335 12.3183 591.853 14.1613 591.853 13.9565C591.853 13.9565 592.672 13.547 594.106 12.9326C595.744 12.523 597.997 11.9087 601.069 12.1135C603.936 12.3183 607.622 13.1374 610.898 15.1852C614.175 17.2331 617.247 20.7144 619.09 25.0149H618.066V24.8101C619.09 20.3049 621.752 16.6187 624.824 14.1613C627.895 11.7039 631.581 10.4752 634.448 10.2704C637.52 9.86085 639.773 10.2704 641.411 10.68C643.254 11.2943 644.073 11.7039 643.869 11.9087Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M384.611 0.437622C384.611 0.437622 383.792 1.25676 382.563 2.89504C381.129 4.32853 379.491 6.78595 377.443 9.85772C373.552 15.7965 369.866 25.4214 369.866 36.4797C369.866 36.6845 369.866 36.6845 369.866 36.8893H368.842C367.204 26.0357 361.47 17.4348 356.555 12.3151C351.436 7.19552 347.545 5.14767 347.545 4.94289C347.545 4.94289 347.749 4.94289 348.364 5.35246C348.773 5.55724 349.593 5.96681 350.412 6.58116C352.05 7.60509 354.507 9.44815 357.17 11.9056C359.832 14.363 362.494 17.8443 364.951 21.94C367.204 26.0357 369.252 31.1553 370.071 36.6845H369.047C369.047 36.4797 369.047 36.4797 369.047 36.2749C368.842 25.0118 372.938 15.1821 377.034 9.24336C379.082 6.17159 380.925 3.91896 382.358 2.48547C382.972 1.66633 383.587 1.25676 383.996 0.847191C384.406 0.642407 384.611 0.437622 384.611 0.437622Z", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M1005.72 801.347L980.331 804.009L999.99 792.746L967.02 743.802L941.217 741.14L962.105 736.225L888.997 627.484H587.144L583.867 632.399L593.083 636.7L580.591 638.952C580.591 638.952 585.506 642.024 586.325 642.024C587.144 642.024 574.652 646.529 574.652 646.529L539.224 701.002L547.825 704.279L532.876 710.832L402.019 912.545H1080.47L1005.72 801.347Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M907.632 655.949C907.632 656.154 831.862 656.564 738.48 656.564C645.098 656.564 569.328 656.359 569.328 655.949C569.328 655.54 645.098 655.335 738.48 655.335C831.862 655.335 907.632 655.54 907.632 655.949Z", fill: "#263238" }),
	      React.createElement("path", { d: "M930.363 688.509C930.363 688.714 844.763 689.123 739.299 689.123C633.63 689.123 548.235 688.918 548.235 688.509C548.235 688.099 633.835 687.895 739.299 687.895C844.763 688.099 930.363 688.304 930.363 688.509Z", fill: "#263238" }),
	      React.createElement("path", { d: "M953.299 723.527C953.299 723.732 857.869 724.141 740.118 724.141C622.367 724.141 526.733 723.937 526.733 723.527C526.733 723.117 622.162 722.913 740.118 722.913C857.869 722.913 953.299 723.117 953.299 723.527Z", fill: "#263238" }),
	      React.createElement("path", { d: "M980.331 764.687C980.331 764.892 872.204 765.302 739.094 765.302C605.78 765.302 497.653 765.097 497.653 764.687C497.653 764.278 605.78 764.073 739.094 764.073C872.204 764.278 980.331 764.482 980.331 764.687Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1013.92 813.632C1013.92 813.837 892.068 813.837 741.756 813.632C591.445 813.223 469.598 812.813 469.598 812.404C469.598 812.199 591.445 812.199 741.756 812.404C892.068 812.813 1013.92 813.428 1013.92 813.632Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1045.04 862.373C1045.04 862.578 908.861 862.987 740.732 862.987C572.604 862.987 436.422 862.783 436.422 862.373C436.422 862.168 572.604 861.759 740.732 861.759C908.861 861.759 1045.04 861.963 1045.04 862.373Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1080.68 912.954C1080.68 913.159 928.725 913.569 741.552 913.569C554.174 913.569 402.224 913.364 402.224 912.954C402.224 912.75 554.174 912.34 741.552 912.34C928.725 912.34 1080.68 912.545 1080.68 912.954Z", fill: "#263238" }),
	      React.createElement("path", { d: "M578.134 696.7C578.134 696.905 577.724 696.905 576.905 696.905C576.291 696.905 575.676 696.905 575.676 696.7C575.676 696.495 576.086 696.495 576.905 696.495C577.519 696.495 578.134 696.495 578.134 696.7Z", fill: "#263238" }),
	      React.createElement("path", { d: "M669.877 694.45C669.877 694.655 652.675 694.655 631.582 694.655C610.285 694.655 593.287 694.655 593.287 694.45C593.287 694.245 610.489 694.245 631.582 694.245C652.675 694.245 669.877 694.245 669.877 694.45Z", fill: "#263238" }),
	      React.createElement("path", { d: "M678.274 701.207C678.274 701.412 661.276 701.412 640.184 701.412C619.091 701.412 602.094 701.412 602.094 701.207C602.094 701.002 619.091 701.002 640.184 701.002C661.276 701.002 678.274 701.002 678.274 701.207Z", fill: "#263238" }),
	      React.createElement("path", { d: "M903.127 707.147C903.127 707.351 892.273 707.351 878.962 707.351C865.651 707.351 854.798 707.351 854.798 707.147C854.798 706.942 865.651 706.942 878.962 706.942C892.478 706.942 903.127 707.147 903.127 707.147Z", fill: "#263238" }),
	      React.createElement("path", { d: "M932.206 749.741C932.206 749.741 931.387 749.741 929.544 749.946C927.701 750.151 925.243 750.151 921.967 750.355C915.414 750.355 905.789 750.56 893.911 749.331C882.034 748.307 868.108 746.26 852.545 743.802C836.981 741.345 819.984 738.478 801.963 737.249C783.942 736.02 766.535 737.044 751.176 740.116C735.817 742.983 722.302 747.488 711.038 751.174C699.775 755.065 690.97 758.547 684.621 761.004C681.549 762.233 679.092 763.052 677.454 763.871C679.092 763.257 681.549 762.233 684.621 761.004C690.765 758.547 699.775 755.065 710.834 750.97C722.097 747.079 735.613 742.778 750.971 739.707C766.33 736.635 783.737 735.611 801.963 736.84C819.984 738.068 837.186 740.935 852.545 743.393C868.108 745.85 882.034 747.898 893.911 749.127C905.789 750.355 915.414 750.355 921.967 750.355C925.243 750.151 927.701 750.151 929.544 749.946C931.182 749.741 932.206 749.741 932.206 749.741Z", fill: "#263238" }),
	      React.createElement("path", { d: "M920.329 841.073C920.329 841.277 818.755 841.277 693.427 841.277C568.099 841.277 466.526 841.277 466.526 841.073C466.526 840.868 568.099 840.868 693.427 840.868C818.551 840.868 920.329 840.868 920.329 841.073Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1024.36 837.187C1024.36 837.392 980.331 837.392 925.858 837.392C871.385 837.392 827.357 837.392 827.357 837.187C827.357 836.982 871.385 836.982 925.858 836.982C980.331 836.982 1024.36 836.982 1024.36 837.187Z", fill: "#263238" }),
	      React.createElement("path", { d: "M830.633 888.789C830.633 888.994 743.19 888.994 635.268 888.994C527.347 888.994 439.904 888.994 439.904 888.789C439.904 888.584 527.347 888.584 635.268 888.584C743.19 888.584 830.633 888.584 830.633 888.789Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1062.24 885.717C1062.24 885.922 987.293 885.922 894.73 885.922C802.168 885.922 727.217 885.922 727.217 885.717C727.217 885.513 802.168 885.513 894.73 885.513C987.293 885.513 1062.24 885.513 1062.24 885.717Z", fill: "#263238" }),
	      React.createElement("path", { d: "M973.982 786.601C973.982 786.806 911.933 786.806 835.548 786.806C758.958 786.806 697.113 786.806 697.113 786.601C697.113 786.396 759.163 786.396 835.548 786.396C911.933 786.396 973.982 786.601 973.982 786.601Z", fill: "#263238" }),
	      React.createElement("path", { d: "M705.306 741.346C705.306 741.551 666.192 741.551 617.862 741.551C569.533 741.551 530.419 741.551 530.419 741.346C530.419 741.141 569.533 741.141 617.862 741.141C666.192 741.141 705.306 741.141 705.306 741.346Z", fill: "#263238" }),
	      React.createElement("path", { d: "M827.56 706.532C827.56 706.737 802.372 706.737 771.245 706.737C740.117 706.737 714.929 706.737 714.929 706.532C714.929 706.327 740.117 706.327 771.245 706.327C802.167 706.327 827.56 706.532 827.56 706.532Z", fill: "#263238" }),
	      React.createElement("path", { d: "M899.031 676.017C899.031 676.222 862.784 676.222 817.936 676.222C773.088 676.222 736.841 676.222 736.841 676.017C736.841 675.813 773.088 675.813 817.936 675.813C862.784 675.813 899.031 676.017 899.031 676.017Z", fill: "#263238" }),
	      React.createElement("path", { d: "M686.26 638.133C686.26 638.338 667.829 638.338 645.098 638.338C622.367 638.338 603.936 638.338 603.936 638.133C603.936 637.928 622.367 637.928 645.098 637.928C668.034 637.928 686.26 637.928 686.26 638.133Z", fill: "#263238" }),
	      React.createElement("path", { d: "M529.19 808.515C529.19 808.515 529.19 808.105 529.19 807.491C529.19 806.877 529.394 805.853 529.804 804.624C530.623 802.167 532.876 799.095 536.357 796.023C543.525 789.879 555.197 781.893 571.171 776.364C587.144 770.63 607.622 767.353 630.149 768.991C633.016 769.196 635.883 769.606 638.545 769.811C641.412 770.22 644.279 770.63 647.146 771.244C650.013 771.858 652.88 772.677 655.747 774.111C658.409 775.544 660.866 777.797 662.095 780.459C663.528 783.326 663.528 786.808 662.095 789.47C660.661 792.337 657.999 794.385 655.337 796.023C652.675 797.661 649.603 798.89 646.736 800.119C645.303 800.733 643.664 801.347 642.231 801.757C640.797 802.166 639.159 802.781 637.521 803.19C625.029 807.081 612.332 808.72 600.045 808.72C593.902 808.72 587.963 808.105 582.024 807.286C579.157 806.877 576.29 806.262 573.423 805.648C571.99 805.238 570.556 804.829 569.532 803.6C568.508 802.576 568.304 800.733 568.918 799.504C570.147 796.842 572.809 795.204 575.061 793.975C577.519 792.542 579.976 791.518 582.434 790.494C587.349 788.446 592.468 787.012 597.383 786.193C607.213 784.35 616.633 784.76 625.029 786.398C626.053 786.603 627.077 786.808 628.101 787.217C629.125 787.627 629.944 788.446 630.149 789.47C630.558 790.494 630.149 791.518 629.534 792.337C628.92 793.156 628.101 793.77 627.282 794.18C625.643 795.204 623.8 795.613 621.957 796.023C620.114 796.433 618.476 796.842 616.838 797.047C610.284 798.276 604.346 799.095 599.636 799.504C594.926 799.914 591.239 799.914 588.782 799.914C586.325 799.914 584.891 799.914 584.891 799.914C585.505 799.914 586.529 799.914 588.782 799.914C591.239 799.914 594.926 799.709 599.636 799.3C604.346 798.89 610.08 798.276 616.838 796.842C618.476 796.433 620.114 796.228 621.957 795.818C623.8 795.409 625.643 794.999 627.282 793.975C628.101 793.566 628.92 792.951 629.534 792.132C630.149 791.313 630.353 790.289 630.149 789.47C629.944 788.446 629.125 787.832 628.101 787.422C627.282 787.012 626.258 786.808 625.029 786.603C616.633 784.965 607.213 784.76 597.383 786.398C592.468 787.217 587.553 788.651 582.638 790.699C580.181 791.722 577.724 792.746 575.266 794.18C572.809 795.409 570.351 797.047 569.327 799.504C568.713 800.733 568.918 802.166 569.942 803.19C570.761 804.214 572.194 804.829 573.628 805.033C576.495 805.648 579.362 806.262 582.229 806.672C587.963 807.491 594.106 808.105 600.045 808.105C612.332 808.105 624.824 806.467 637.316 802.576C638.75 802.167 640.388 801.552 641.821 801.143C643.255 800.528 644.893 799.914 646.327 799.504C649.194 798.276 652.265 797.047 654.928 795.409C657.59 793.77 660.047 791.722 661.481 789.06C662.914 786.398 662.914 783.121 661.481 780.255C660.252 777.592 657.794 775.34 655.337 774.111C652.675 772.677 649.808 771.858 646.941 771.449C644.074 770.834 641.207 770.63 638.34 770.015C635.473 769.606 632.606 769.401 629.944 769.196C607.622 767.558 587.144 770.63 571.171 776.364C555.197 781.893 543.525 789.879 536.357 796.023C532.671 799.095 530.623 802.167 529.804 804.624C529.394 805.853 529.19 806.672 529.19 807.286C529.19 808.105 529.19 808.515 529.19 808.515Z", fill: "#263238" }),
	      React.createElement("path", { d: "M566.05 720.458C557.859 722.916 549.872 723.121 542.5 720.458V646.122C551.101 641.821 558.883 642.231 566.05 646.122V720.458Z", fill: "#263238" }),
	      React.createElement("path", { d: "M566.256 646.327C566.256 646.327 566.051 646.532 565.437 646.737C564.823 646.942 564.003 647.351 562.979 647.761C560.932 648.375 558.065 648.989 554.583 649.194C551.307 649.194 548.235 648.785 546.187 647.966C545.163 647.556 544.344 647.351 543.73 647.146C543.115 646.942 542.911 646.737 542.911 646.737C542.911 646.737 544.139 647.146 546.187 647.761C548.235 648.375 551.102 648.785 554.379 648.785C557.655 648.785 560.522 648.17 562.57 647.556C564.823 646.737 566.051 646.122 566.256 646.327Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M562.16 645.713C562.16 645.713 561.955 646.123 561.136 646.532C560.522 646.942 559.293 647.147 557.86 647.351C556.426 647.556 554.788 647.761 552.945 647.556C551.921 647.556 551.102 647.351 550.078 647.351C549.668 647.147 549.054 647.147 548.645 646.532C548.235 645.918 548.644 645.099 549.259 644.894C550.283 644.484 551.307 644.484 552.535 644.484C553.559 644.484 554.583 644.484 555.402 644.689C555.812 644.689 556.426 644.894 556.836 644.894C557.245 645.099 557.86 645.099 558.065 645.713C558.269 646.328 557.86 646.737 557.45 646.737C557.041 646.737 556.631 646.737 556.222 646.737C554.993 646.737 553.969 646.532 552.945 646.532C552.126 646.532 551.716 646.532 551.716 646.328C551.716 646.328 552.126 646.328 552.945 646.328C553.969 646.328 555.198 646.328 556.222 646.328C556.631 646.328 557.041 646.328 557.245 646.328C557.655 646.328 557.86 645.918 557.655 645.713C557.245 645.099 556.222 645.099 555.402 644.894C553.559 644.689 551.511 644.689 549.464 645.304C549.054 645.508 548.849 645.918 549.054 646.328C549.259 646.737 549.873 646.942 550.283 646.942C551.307 647.147 552.331 647.147 553.15 647.351C554.993 647.351 556.631 647.351 558.065 647.147C559.498 646.942 560.522 646.737 561.341 646.532C561.751 645.918 562.16 645.713 562.16 645.713Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M541.887 691.376C541.887 691.376 541.887 691.172 541.887 690.967C541.887 690.557 542.092 690.148 542.092 689.738C542.296 688.305 542.501 686.871 542.911 685.233C543.525 681.342 544.549 676.018 545.368 670.079C546.392 664.14 547.006 658.816 547.621 654.925C547.826 653.286 548.03 651.648 548.235 650.419C548.235 650.01 548.44 649.6 548.44 649.191C548.44 649.6 548.44 650.01 548.235 650.419C548.03 651.853 547.826 653.286 547.826 655.129C547.416 659.02 546.597 664.345 545.778 670.284C544.754 676.222 543.935 681.547 543.116 685.438C542.706 687.076 542.501 688.714 542.092 689.943C542.092 690.352 541.887 690.762 541.887 691.172V691.376Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M565.846 658.207C565.846 658.207 565.231 657.797 564.207 657.592C563.183 657.387 561.34 657.387 559.702 658.411C557.859 659.435 556.426 661.278 554.992 663.531C553.559 665.784 552.125 668.446 550.896 671.313C548.439 677.047 546.801 682.371 545.777 686.262C545.367 688.105 544.753 689.539 544.548 690.972C544.343 691.382 544.343 691.791 544.139 692.201C544.139 692.406 543.934 692.61 543.934 692.61C543.934 692.61 543.934 692.406 543.934 692.201C543.934 691.791 544.139 691.382 544.139 690.972C544.548 689.539 544.958 688.105 545.367 686.262C546.391 682.371 548.029 676.842 550.487 671.108C551.716 668.241 553.149 665.579 554.583 663.326C556.016 661.074 557.654 659.026 559.497 658.002C561.34 656.978 563.183 656.978 564.207 657.387C565.231 657.797 565.846 658.207 565.846 658.207Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M557.86 697.932C557.86 697.932 558.27 698.136 558.474 698.956C558.679 699.775 558.679 701.208 557.451 702.232C556.222 703.256 553.764 702.846 552.331 701.003C550.897 699.16 550.897 696.498 551.512 693.836C551.921 692.402 552.126 691.174 552.741 689.74C553.355 688.307 554.379 686.873 556.017 686.464C557.655 685.849 559.498 686.873 560.522 688.307C561.751 689.74 562.365 691.379 563.185 693.017C564.413 696.498 564.618 700.594 563.799 704.485C562.775 708.376 560.727 712.267 557.246 714.724C555.607 715.953 553.355 716.772 551.102 716.157C549.054 715.543 547.621 713.7 546.802 711.857C545.983 710.014 545.983 707.966 546.187 705.918C546.392 704.075 546.597 702.232 546.802 700.389C547.826 693.222 549.874 686.873 552.536 681.958C555.198 677.044 558.475 673.972 560.932 671.924C563.389 670.081 565.028 669.467 565.028 669.467C565.028 669.467 564.618 669.671 564.004 670.081C563.389 670.49 562.365 671.105 561.137 672.129C558.679 673.972 555.607 677.248 552.945 682.163C550.283 686.873 548.235 693.222 547.211 700.594C547.007 702.437 546.597 704.28 546.597 706.123C546.392 707.966 546.597 710.014 547.211 711.857C547.826 713.7 549.259 715.338 551.307 715.748C553.15 716.362 555.403 715.543 557.041 714.519C560.522 712.062 562.57 708.376 563.389 704.485C564.413 700.594 564.004 696.703 562.775 693.426C562.161 691.788 561.341 690.15 560.318 688.921C559.294 687.692 557.655 686.668 556.017 687.283C554.584 687.692 553.56 689.126 552.945 690.355C552.331 691.788 552.126 693.222 551.717 694.45C551.102 697.112 551.102 699.775 552.536 701.413C553.764 703.256 556.222 703.461 557.451 702.642C558.679 701.822 558.679 700.389 558.474 699.57C558.27 698.341 557.86 697.932 557.86 697.932Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M942.035 716.565C933.843 719.023 925.857 719.228 918.485 716.565V642.229C927.086 637.928 934.867 638.338 942.035 642.229V716.565Z", fill: "#263238" }),
	      React.createElement("path", { d: "M942.035 642.227C942.035 642.227 941.83 642.432 941.216 642.636C940.602 642.841 939.783 643.251 938.759 643.66C936.711 644.275 933.844 644.889 930.362 645.094C927.086 645.094 924.014 644.684 921.966 643.865C920.942 643.456 920.123 643.251 919.509 643.046C918.894 642.841 918.69 642.636 918.69 642.636C918.69 642.636 919.918 643.046 921.966 643.66C924.014 644.275 926.881 644.684 930.158 644.684C933.434 644.684 936.301 644.07 938.349 643.456C940.806 642.841 942.035 642.227 942.035 642.227Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M937.94 641.821C937.94 641.821 937.735 642.231 936.916 642.64C936.302 643.05 935.073 643.255 933.639 643.459C932.206 643.664 930.568 643.869 928.725 643.664C927.701 643.664 926.882 643.459 925.858 643.459C925.448 643.255 924.834 643.255 924.424 642.64C924.015 642.026 924.424 641.207 925.038 641.002C926.062 640.592 927.086 640.592 928.315 640.592C929.339 640.592 930.363 640.592 931.182 640.797C931.592 640.797 932.206 641.002 932.616 641.002C933.025 641.207 933.639 641.207 933.844 641.821C934.049 642.435 933.639 642.845 933.23 642.845C932.82 642.845 932.411 642.845 932.001 642.845C930.772 642.845 929.748 642.64 928.725 642.64C927.905 642.64 927.496 642.64 927.496 642.435C927.496 642.435 927.905 642.435 928.725 642.435C929.748 642.435 930.977 642.435 932.001 642.435C932.411 642.435 932.82 642.435 933.025 642.435C933.435 642.435 933.639 642.026 933.435 641.821C933.025 641.207 932.001 641.207 931.182 641.002C929.339 640.797 927.291 640.797 925.243 641.411C924.834 641.616 924.629 642.026 924.834 642.435C925.038 642.845 925.653 643.05 926.062 643.05C927.086 643.254 928.11 643.255 928.929 643.459C930.772 643.459 932.411 643.459 933.844 643.254C935.278 643.05 936.302 642.845 937.121 642.64C937.53 642.026 937.94 641.616 937.94 641.821Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M917.666 687.284C917.666 687.284 917.666 687.079 917.666 686.874C917.666 686.465 917.87 686.055 917.87 685.645C918.075 684.212 918.28 682.778 918.69 681.14C919.304 677.249 920.328 671.925 921.147 665.986C922.171 660.047 922.785 654.723 923.4 650.832C923.604 649.194 923.809 647.555 924.014 646.327C924.014 645.917 924.219 645.508 924.219 645.098C924.219 645.508 924.219 645.917 924.014 646.327C923.809 647.76 923.604 649.194 923.604 651.037C923.195 654.928 922.376 660.252 921.557 666.191C920.533 672.13 919.714 677.454 918.894 681.345C918.485 682.983 918.28 684.621 917.87 685.85C917.87 686.26 917.666 686.669 917.666 687.079C917.666 687.284 917.666 687.284 917.666 687.284Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M941.625 654.314C941.625 654.314 941.011 653.905 939.987 653.7C938.963 653.495 937.12 653.495 935.482 654.519C933.639 655.543 932.205 657.386 930.772 659.639C929.338 661.891 927.905 664.554 926.676 667.421C924.219 673.155 922.58 678.479 921.556 682.37C921.147 684.213 920.533 685.646 920.328 687.08C920.123 687.49 920.123 687.899 919.918 688.309C919.918 688.513 919.713 688.718 919.713 688.718C919.713 688.718 919.713 688.513 919.713 688.309C919.713 687.899 919.918 687.49 919.918 687.08C920.328 685.646 920.737 684.213 921.147 682.37C922.171 678.479 923.809 672.95 926.267 667.216C927.495 664.349 928.929 661.687 930.362 659.434C931.796 657.181 933.434 655.134 935.277 654.11C937.12 653.086 938.963 653.086 939.987 653.495C941.216 653.905 941.625 654.314 941.625 654.314Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M933.844 694.037C933.844 694.037 934.253 694.241 934.458 695.06C934.663 695.88 934.663 697.313 933.434 698.337C932.206 699.361 929.748 698.951 928.315 697.108C926.881 695.265 926.881 692.603 927.496 689.941C927.905 688.507 928.11 687.279 928.724 685.845C929.339 684.412 930.363 682.978 932.001 682.569C933.639 681.954 935.482 682.978 936.506 684.412C937.735 685.845 938.349 687.483 939.168 689.122C940.397 692.603 940.602 696.699 939.783 700.59C938.759 704.481 936.711 708.371 933.23 710.829C931.591 712.058 929.339 712.877 927.086 712.262C925.038 711.648 923.605 709.805 922.785 707.962C921.966 706.119 921.966 704.071 922.171 702.023C922.376 700.18 922.581 698.337 922.785 696.494C923.809 689.326 925.857 682.978 928.519 678.063C931.182 673.148 934.458 670.077 936.916 668.029C939.373 666.186 941.011 665.571 941.011 665.571C941.011 665.571 940.602 665.776 939.987 666.186C939.373 666.595 938.349 667.21 937.12 668.234C934.663 670.077 931.591 673.353 928.929 678.268C926.267 682.978 924.219 689.326 923.195 696.699C922.99 698.542 922.581 700.385 922.581 702.228C922.376 704.071 922.581 706.119 923.195 707.962C923.809 709.805 925.243 711.443 927.291 711.853C929.134 712.467 931.386 711.648 933.025 710.624C936.506 708.167 938.554 704.481 939.373 700.59C940.397 696.699 939.987 692.808 938.759 689.531C938.144 687.893 937.325 686.255 936.301 685.026C935.277 683.797 933.639 682.773 932.001 683.388C930.567 683.797 929.543 685.231 928.929 686.459C928.315 687.893 928.11 689.326 927.7 690.555C927.086 693.217 927.086 695.88 928.519 697.518C929.748 699.361 932.206 699.566 933.434 698.747C934.663 697.927 934.663 696.494 934.458 695.675C934.253 694.241 933.639 694.037 933.844 694.037Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M469.393 873.022C460.177 875.889 451.372 876.094 442.976 873.022V790.084C452.6 785.374 461.201 785.784 469.393 790.084V873.022Z", fill: "#263238" }),
	      React.createElement("path", { d: "M469.392 790.083C469.392 790.083 468.983 790.288 468.368 790.493C467.754 790.697 466.935 791.107 465.706 791.516C463.453 792.336 460.177 792.95 456.491 792.95C452.805 792.95 449.528 792.336 447.275 791.721C446.047 791.312 445.228 791.107 444.613 790.697C443.999 790.493 443.589 790.288 443.589 790.288C443.589 790.288 445.023 790.697 447.275 791.312C449.528 791.926 452.805 792.54 456.491 792.336C460.177 792.336 463.453 791.721 465.706 790.902C467.959 790.697 469.392 790.083 469.392 790.083Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M464.887 789.467C464.887 789.467 464.682 789.876 463.863 790.286C463.044 790.696 461.815 790.9 460.177 791.31C458.539 791.515 456.696 791.719 454.648 791.515C453.624 791.515 452.6 791.31 451.371 791.105C450.757 790.9 450.143 790.9 449.733 790.286C449.323 789.672 449.733 788.852 450.347 788.443C450.962 788.033 451.576 788.033 452.19 788.033C452.805 788.033 453.419 787.829 454.033 787.829C455.262 787.829 456.286 787.829 457.31 788.033C457.924 788.033 458.334 788.238 458.743 788.238C459.153 788.443 459.767 788.443 459.972 789.057C460.382 789.672 459.767 790.286 459.358 790.286C458.948 790.491 458.539 790.286 458.129 790.286C456.696 790.286 455.467 790.081 454.443 790.081C453.624 790.081 453.01 789.876 453.01 789.876C453.01 789.876 453.419 789.876 454.443 789.876C455.672 789.876 456.9 789.876 458.129 789.876C458.539 789.876 458.948 789.876 459.358 789.876C459.767 789.876 459.972 789.467 459.767 789.057C459.358 788.443 458.129 788.443 457.105 788.238C456.081 788.033 455.057 788.033 453.829 788.033C452.805 788.033 451.371 788.033 450.552 788.443C450.143 788.648 449.733 789.262 450.143 789.672C450.347 790.081 450.962 790.286 451.576 790.286C452.6 790.491 453.829 790.491 454.853 790.696C456.9 790.9 458.743 790.696 460.382 790.491C462.02 790.286 463.249 790.081 464.068 789.672C464.477 789.672 464.887 789.467 464.887 789.467Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M442.156 840.462C442.156 840.462 442.156 840.257 442.156 840.052C442.156 839.643 442.361 839.233 442.361 838.619C442.565 837.185 442.975 835.547 443.18 833.499C443.999 829.199 445.023 823.26 446.047 816.707C447.071 810.154 447.89 804.01 448.504 799.71C448.709 797.662 448.914 796.024 449.119 794.59C449.119 794.181 449.323 793.566 449.323 793.157C449.323 792.747 449.323 792.747 449.323 792.747C449.323 792.747 449.323 792.952 449.323 793.157C449.323 793.566 449.323 793.976 449.119 794.59C448.914 796.024 448.709 797.867 448.504 799.71C447.89 804.01 447.275 810.154 446.252 816.707C445.228 823.26 444.204 829.199 443.385 833.499C442.975 835.547 442.565 837.185 442.361 838.619C442.156 839.028 442.156 839.643 441.951 840.052C442.361 840.257 442.156 840.462 442.156 840.462Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M468.983 803.392C468.983 803.392 468.369 802.982 467.14 802.573C465.911 802.368 464.068 802.368 462.021 803.392C459.973 804.416 458.334 806.668 456.696 809.126C455.058 811.583 453.624 814.655 452.191 817.727C449.324 824.075 447.686 830.014 446.457 834.519C445.843 836.567 445.433 838.205 445.023 839.638C444.819 840.048 444.819 840.662 444.614 841.072C444.614 841.482 444.409 841.482 444.409 841.482C444.409 841.482 444.409 841.277 444.409 841.072C444.409 840.662 444.614 840.253 444.819 839.638C445.228 838.205 445.638 836.362 446.047 834.519C447.276 830.218 448.914 824.075 451.781 817.727C453.215 814.45 454.648 811.583 456.287 809.126C457.925 806.668 459.563 804.416 461.611 803.187C463.659 802.163 465.707 802.163 466.935 802.368C468.369 802.982 468.983 803.392 468.983 803.392Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M460.178 847.835C460.178 847.835 460.587 848.039 460.997 849.063C461.202 849.882 461.202 851.521 459.768 852.749C458.335 853.773 455.672 853.569 454.034 851.521C452.396 849.473 452.396 846.401 453.215 843.329C453.624 841.896 453.829 840.257 454.648 838.619C455.263 836.981 456.491 835.547 458.335 834.933C459.154 834.728 460.178 834.728 461.202 835.138C462.021 835.547 462.84 836.162 463.454 836.981C464.683 838.414 465.502 840.258 466.321 842.305C467.755 846.196 467.959 850.702 466.935 855.002C465.912 859.302 463.659 863.603 459.563 866.47C457.72 867.903 455.058 868.723 452.805 867.903C450.553 867.289 448.914 865.241 448.095 863.193C447.276 861.146 447.276 858.893 447.276 856.64C447.481 854.592 447.686 852.34 448.095 850.497C449.324 842.51 451.577 835.343 454.648 830.018C457.72 824.694 461.202 821.008 464.068 818.96C466.731 816.912 468.574 816.093 468.574 816.093C468.574 816.093 468.164 816.298 467.345 816.707C466.526 817.117 465.502 817.936 464.068 818.96C461.406 821.008 457.72 824.694 454.853 830.018C451.781 835.343 449.734 842.51 448.505 850.497C448.3 852.545 447.891 854.592 447.686 856.64C447.481 858.688 447.686 860.941 448.505 862.989C449.324 865.036 450.962 866.88 453.01 867.494C455.263 868.108 457.515 867.289 459.358 866.06C463.249 863.398 465.502 859.098 466.526 854.797C467.55 850.497 467.345 846.196 465.912 842.305C465.297 840.462 464.273 838.619 463.045 837.186C461.816 835.752 459.973 834.728 458.335 835.343C456.696 835.957 455.468 837.391 454.853 838.824C454.239 840.258 453.829 841.896 453.42 843.329C452.601 846.196 452.805 849.268 454.239 851.111C455.672 853.159 458.335 853.364 459.563 852.34C460.997 851.316 460.997 849.678 460.792 848.858C460.587 848.039 460.178 847.835 460.178 847.835Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1032.76 873.023C1023.74 875.685 1014.94 876.094 1006.75 873.023V791.518C1016.17 786.808 1024.77 787.218 1032.76 791.518V873.023Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1032.76 791.519C1032.76 791.519 1032.35 791.724 1031.94 791.929C1031.32 792.134 1030.5 792.543 1029.27 792.953C1027.02 793.772 1023.74 794.386 1020.06 794.386C1016.37 794.386 1013.1 793.772 1010.84 793.158C1009.61 792.748 1008.8 792.543 1008.18 792.134C1007.57 791.929 1007.16 791.724 1007.16 791.724C1007.16 791.724 1008.59 792.134 1010.84 792.748C1013.1 793.363 1016.37 793.977 1019.85 793.772C1023.33 793.772 1026.61 793.158 1028.86 792.339C1031.32 791.929 1032.76 791.315 1032.76 791.519Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1028.46 790.904C1028.46 790.904 1028.25 791.314 1027.43 791.723C1026.61 792.133 1025.38 792.338 1023.95 792.747C1022.31 792.952 1020.47 793.157 1018.42 792.952C1017.4 792.952 1016.37 792.747 1015.14 792.543C1014.53 792.338 1013.92 792.338 1013.51 791.723C1013.1 791.109 1013.51 790.29 1014.12 789.88C1014.73 789.471 1015.35 789.471 1015.96 789.471C1016.58 789.471 1017.19 789.266 1017.6 789.266C1018.63 789.266 1019.85 789.266 1020.88 789.471C1021.49 789.471 1021.9 789.676 1022.31 789.676C1022.72 789.88 1023.34 789.88 1023.54 790.495C1023.95 791.109 1023.34 791.723 1022.93 791.723C1022.52 791.928 1022.11 791.723 1021.7 791.723C1020.47 791.723 1019.24 791.519 1018.01 791.519C1017.19 791.519 1016.58 791.314 1016.58 791.314C1016.58 791.314 1016.99 791.314 1018.01 791.314C1019.04 791.314 1020.26 791.314 1021.7 791.314C1022.11 791.314 1022.52 791.314 1022.93 791.314C1023.34 791.314 1023.54 790.904 1023.34 790.495C1022.93 789.88 1021.7 789.88 1020.88 789.676C1019.85 789.471 1018.83 789.471 1017.6 789.471C1016.58 789.471 1015.35 789.471 1014.33 789.88C1013.92 790.085 1013.51 790.699 1013.92 791.109C1014.12 791.519 1014.73 791.723 1015.14 791.723C1016.17 791.928 1017.4 791.928 1018.22 792.133C1020.26 792.338 1022.11 792.133 1023.54 791.928C1024.97 791.723 1026.2 791.519 1027.02 791.109C1028.05 791.109 1028.25 790.699 1028.46 790.904Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1006.13 840.869C1006.13 840.869 1006.13 840.664 1006.13 840.459C1006.13 840.05 1006.34 839.64 1006.34 839.026C1006.54 837.592 1006.95 835.954 1007.16 833.906C1007.98 829.606 1009 823.872 1010.02 817.319C1011.05 810.766 1011.87 804.827 1012.48 800.731C1012.69 798.888 1012.89 797.045 1013.1 795.611C1013.1 795.202 1013.3 794.588 1013.3 794.178C1013.3 793.768 1013.3 793.768 1013.3 793.768C1013.3 793.768 1013.3 793.973 1013.3 794.178C1013.3 794.588 1013.3 794.997 1013.1 795.611C1012.89 797.045 1012.69 798.683 1012.48 800.731C1012.07 805.032 1011.25 810.97 1010.23 817.523C1009.2 824.077 1008.18 829.811 1007.36 834.111C1006.95 835.954 1006.54 837.592 1006.34 839.026C1006.13 839.435 1006.13 840.05 1006.13 840.459C1006.13 840.869 1006.13 840.869 1006.13 840.869Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1032.35 804.623C1032.35 804.623 1031.73 804.214 1030.5 804.009C1029.27 803.804 1027.43 803.804 1025.59 804.828C1023.74 805.852 1021.9 808.105 1020.47 810.562C1018.83 813.02 1017.4 815.887 1015.96 818.958C1013.3 825.102 1011.46 831.041 1010.23 835.341C1009.61 837.389 1009.21 839.027 1008.8 840.461C1008.59 840.87 1008.59 841.485 1008.39 841.894C1008.39 842.304 1008.18 842.304 1008.18 842.304C1008.18 842.304 1008.18 842.099 1008.18 841.894C1008.18 841.485 1008.39 841.075 1008.59 840.461C1009 839.027 1009.41 837.389 1009.82 835.341C1011.05 831.041 1012.69 825.102 1015.35 818.754C1016.78 815.682 1018.22 812.815 1019.85 810.153C1021.49 807.695 1023.13 805.443 1025.18 804.419C1027.23 803.395 1029.07 803.395 1030.3 803.599C1031.94 804.214 1032.35 804.623 1032.35 804.623Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1023.74 848.248C1023.74 848.248 1024.15 848.452 1024.56 849.271C1024.77 850.091 1024.77 851.729 1023.34 852.753C1021.9 853.777 1019.24 853.572 1017.81 851.524C1016.17 849.476 1016.17 846.405 1016.99 843.538C1017.4 842.104 1017.6 840.466 1018.22 839.032C1018.83 837.599 1020.06 835.96 1021.7 835.346C1022.52 835.141 1023.54 835.141 1024.56 835.551C1025.38 835.96 1026.2 836.575 1026.82 837.394C1028.05 838.827 1028.86 840.671 1029.68 842.514C1031.12 846.405 1031.32 850.705 1030.3 855.005C1029.27 859.306 1027.02 863.606 1023.13 866.269C1021.29 867.497 1018.83 868.316 1016.58 867.702C1014.32 867.088 1012.69 865.04 1011.87 862.992C1011.05 860.944 1011.05 858.692 1011.05 856.644C1011.25 854.596 1011.46 852.548 1011.87 850.5C1013.1 842.514 1015.35 835.551 1018.22 830.227C1021.08 824.902 1024.77 821.421 1027.43 819.373C1030.09 817.325 1031.94 816.506 1031.94 816.506C1031.94 816.506 1031.53 816.711 1030.71 817.12C1029.89 817.53 1028.86 818.349 1027.43 819.373C1024.77 821.421 1021.29 824.902 1018.42 830.227C1015.55 835.551 1013.3 842.514 1012.07 850.295C1011.87 852.343 1011.46 854.391 1011.25 856.439C1011.05 858.487 1011.25 860.739 1012.07 862.582C1012.89 864.63 1014.32 866.269 1016.58 866.883C1018.63 867.497 1021.08 866.678 1022.93 865.449C1026.61 862.787 1028.86 858.692 1029.89 854.391C1030.91 850.091 1030.71 845.79 1029.27 842.104C1028.66 840.261 1027.64 838.418 1026.61 836.984C1025.38 835.551 1023.74 834.527 1021.9 835.141C1020.26 835.756 1019.03 837.189 1018.63 838.623C1018.01 840.056 1017.6 841.694 1017.4 843.128C1016.58 845.995 1016.78 848.862 1018.22 850.91C1019.65 852.753 1022.11 853.162 1023.54 852.138C1024.97 851.115 1024.97 849.476 1024.77 848.862C1024.15 848.452 1023.74 848.248 1023.74 848.248Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M962.105 736.428V743.391L942.036 741.138L962.105 736.428Z", fill: "#263238" }),
	      React.createElement("path", { d: "M999.99 792.744V802.164L980.74 803.802L999.99 792.744Z", fill: "#263238" }),
	      React.createElement("path", { d: "M584.072 632.604V638.542L593.082 636.904L584.072 632.604Z", fill: "#263238" }),
	      React.createElement("path", { d: "M580.795 639.157V644.686L586.529 642.228L580.795 639.157Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1069 740.731C1082.31 740.731 1095.62 737.045 1106.89 729.878C1104.43 730.697 1101.77 731.106 1099.31 730.697C1102.79 729.673 1105.86 727.42 1107.71 724.348C1095.83 726.396 1083.95 727.42 1071.87 727.01", fill: "#263238" }),
	      React.createElement("path", { d: "M1015.14 757.729L1015.35 786.808L999.989 792.133C999.989 792.133 1005.11 793.566 1004.49 796.229C1004.49 796.229 1009.2 795 1010.23 799.096L1018.01 789.88L1017.81 757.729H1015.14Z", fill: "#E06255" }),
	      React.createElement("path", { d: "M1020.06 771.244C1020.06 772.678 1018.62 774.111 1016.78 774.111C1014.94 774.316 1013.3 773.088 1013.1 771.654C1013.1 770.221 1014.53 768.787 1016.37 768.787C1018.22 768.582 1019.85 769.811 1020.06 771.244Z", fill: "#E06255" }),
	      React.createElement("path", { d: "M1029.48 757.729L1029.68 786.808L1014.32 792.133C1014.32 792.133 1019.44 793.566 1018.83 796.229C1018.83 796.229 1023.54 795 1024.56 799.096L1032.34 789.88L1032.14 757.729H1029.48Z", fill: "#E06255" }),
	      React.createElement("path", { d: "M1034.39 771.041C1034.39 772.475 1032.96 773.908 1031.12 773.908C1029.27 774.113 1027.63 772.885 1027.43 771.451C1027.22 770.018 1028.86 768.584 1030.71 768.584C1032.75 768.584 1034.39 769.608 1034.39 771.041Z", fill: "#E06255" }),
	      React.createElement("path", { d: "M976.644 684.828C976.644 684.828 982.378 683.189 984.426 680.937C986.269 678.684 992.617 671.312 1001.01 673.155C1009.41 674.998 1015.35 681.346 1015.14 687.695C1014.94 694.043 1015.14 701.825 1015.14 701.825L1083.34 727.013C1083.34 727.013 1062.04 756.093 1035.83 757.117C1035.83 757.117 1033.37 760.803 1030.5 760.598C1027.64 760.393 1024.56 757.117 1024.56 757.117C1024.56 757.117 1005.72 759.779 993.231 751.792C980.739 743.806 969.886 734.386 970.5 718.208C971.115 702.03 985.245 691.176 985.245 691.176L976.644 684.828Z", fill: "#FAFAFA" }),
	      React.createElement("path", { d: "M976.643 684.826C977.462 685.44 979.919 687.283 985.244 691.174L985.448 691.379L985.244 691.583C981.967 694.45 977.871 698.751 974.595 704.894C972.957 707.966 971.728 711.448 971.113 715.543C970.499 719.434 970.704 723.939 971.933 728.24C973.161 732.54 975.619 736.841 979.1 740.527C982.581 744.213 986.677 747.49 991.182 750.561C993.435 751.995 995.892 753.428 998.35 754.452C1001.01 755.476 1003.67 756.295 1006.54 756.705C1012.28 757.729 1018.42 757.934 1024.36 757.115H1024.56L1024.77 757.319C1026.2 758.753 1028.04 760.186 1030.09 760.596C1032.14 761.005 1033.98 759.162 1035.21 757.319L1035.42 757.115H1035.62C1045.86 756.5 1055.69 751.995 1064.29 745.442C1071.46 740.117 1077.6 733.769 1082.72 727.216L1082.93 727.83C1057.33 718.41 1033.98 709.604 1014.73 702.437H1014.53V702.232C1014.32 697.317 1014.32 692.607 1014.53 688.307C1014.53 686.054 1014.12 684.006 1013.09 682.368C1012.07 680.525 1010.64 679.092 1009.2 677.863C1006.13 675.405 1002.65 673.972 999.374 673.562C996.097 673.153 993.025 674.177 990.773 675.815C988.315 677.248 986.677 679.092 985.244 680.525C984.015 682.163 982.172 683.187 980.738 683.802C979.305 684.416 978.281 684.825 977.667 685.03C977.052 684.621 976.643 684.826 976.643 684.826C976.643 684.826 977.052 684.621 977.667 684.416C978.281 684.211 979.51 683.802 980.738 683.187C981.967 682.573 983.605 681.754 985.039 679.911C986.472 678.272 988.315 676.429 990.568 674.996C992.821 673.562 996.097 672.334 999.579 672.743C1003.06 673.153 1006.54 674.586 1009.61 677.044C1011.25 678.272 1012.68 679.911 1013.71 681.754C1014.73 683.597 1015.35 685.849 1015.35 688.102C1015.14 692.607 1015.35 697.113 1015.55 702.027L1015.35 701.618C1034.8 708.785 1058.15 717.386 1083.54 726.806L1084.15 727.011L1083.75 727.421C1078.42 734.179 1072.28 740.527 1065.11 745.851C1056.51 752.404 1046.27 757.114 1035.83 757.729L1036.24 757.524C1035.62 758.548 1034.8 759.367 1033.78 760.186C1032.75 760.801 1031.52 761.415 1030.3 761.21C1027.84 760.596 1026 759.162 1024.36 757.729L1024.77 757.934C1018.62 758.548 1012.48 758.343 1006.54 757.319C1003.67 756.705 1000.81 756.091 998.145 755.067C995.483 754.043 993.025 752.609 990.773 750.971C986.268 747.899 981.967 744.623 978.486 740.937C975.004 737.25 972.547 732.95 971.318 728.445C970.09 723.939 969.885 719.434 970.499 715.543C971.114 711.448 972.547 707.761 974.185 704.69C977.667 698.546 981.762 694.246 985.244 691.379V691.583C982.377 689.331 980.329 687.692 978.895 686.464C978.281 685.849 977.667 685.44 977.257 685.235C976.847 684.825 976.643 684.826 976.643 684.826Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1079.44 722.712C1070.84 712.063 1058.56 704.486 1045.25 701.414C1035.01 699.161 1024.15 699.571 1013.91 702.438L1014.53 702.233C1008.18 703.052 1002.04 705.51 996.712 709.196C994.459 710.834 992.207 712.882 992.207 715.749C992.207 718.206 994.254 720.049 996.302 721.688C1007.97 730.698 1022.51 736.023 1037.26 736.637C1052 737.251 1066.95 733.156 1079.24 724.964C1079.65 724.759 1080.06 724.35 1080.06 723.94C1080.06 723.531 1079.65 723.121 1079.44 722.712Z", fill: "#EBEBEB" }),
	      React.createElement("path", { d: "M997.327 683.597C997.327 684.826 996.303 685.85 995.074 685.85C993.846 685.85 992.822 684.826 992.822 683.597C992.822 682.369 993.846 681.345 995.074 681.345C996.508 681.345 997.327 682.369 997.327 683.597Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1051.8 717.387C1051.8 717.387 1051.59 717.592 1050.98 718.001C1050.57 718.206 1049.75 718.615 1048.73 719.025C1046.68 719.844 1043.4 720.254 1039.72 719.23L1039.92 718.411C1041.76 719.025 1042.17 721.482 1040.95 722.916C1039.72 724.349 1037.46 724.554 1035.83 723.735C1034.8 723.326 1033.98 722.916 1033.16 722.506L1033.78 721.892C1034.6 723.121 1034.39 724.759 1033.98 725.988C1033.37 727.216 1032.34 728.24 1031.32 728.65C1029.07 729.674 1026.82 729.059 1025.18 728.445C1023.54 727.831 1022.31 727.012 1021.7 726.397C1020.88 725.783 1020.47 725.578 1020.47 725.578C1020.47 725.578 1020.88 725.783 1021.7 726.192C1022.52 726.602 1023.74 727.421 1025.38 727.831C1027.02 728.445 1029.07 728.65 1031.12 727.831C1032.14 727.421 1032.96 726.602 1033.37 725.578C1033.78 724.554 1033.98 723.325 1033.16 722.302L1032.14 720.868L1033.78 721.687C1034.6 722.097 1035.42 722.711 1036.24 722.916C1037.67 723.53 1039.51 723.325 1040.33 722.302C1041.36 721.278 1040.95 719.435 1039.72 719.23L1039.92 718.411C1043.4 719.435 1046.47 719.23 1048.52 718.615C1050.57 718.001 1051.59 717.182 1051.8 717.387Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1076.99 725.783C1076.99 725.783 1076.99 725.988 1076.78 726.193C1076.58 726.398 1076.17 726.603 1075.76 727.012C1074.94 727.831 1073.51 728.855 1071.66 729.674C1067.98 731.722 1061.83 733.77 1054.46 732.541L1054.67 731.722C1056.3 732.337 1057.74 733.36 1058.97 734.794L1059.38 735.203L1058.76 735.408C1054.05 736.637 1048.52 736.637 1042.99 735.203L1040.33 734.589L1042.99 734.384C1043.61 734.384 1044.43 734.999 1044.63 735.613C1044.84 736.227 1044.84 736.842 1044.63 737.456C1044.02 738.685 1042.58 738.89 1041.56 738.89C1027.43 736.637 1015.35 731.722 1007.16 727.422C1003.06 725.374 999.783 723.326 997.531 721.892C996.507 721.278 995.688 720.664 995.073 720.254C994.459 719.845 994.254 719.64 994.254 719.64C994.254 719.64 994.664 719.845 995.278 720.049C995.892 720.459 996.712 720.869 997.94 721.483C1000.19 722.712 1003.47 724.555 1007.57 726.603C1011.66 728.65 1016.78 730.903 1022.51 732.746C1028.25 734.589 1034.8 736.637 1041.76 737.661C1042.79 737.661 1043.81 737.456 1044.02 736.637C1044.43 735.818 1044.02 734.794 1043.4 734.999V734.18C1048.73 735.613 1054.26 735.408 1058.76 734.384L1058.56 734.999C1057.53 733.77 1056.1 732.746 1054.67 732.132L1054.87 731.313C1062.04 732.541 1068.18 730.698 1071.87 728.855C1075.14 727.422 1076.78 725.783 1076.99 725.783Z", fill: "#263238" }),
	      React.createElement("path", { d: "M998.147 679.911C997.737 680.116 997.328 680.116 997.123 680.116C996.713 680.116 996.509 680.116 996.099 680.116C995.689 680.116 995.485 679.911 995.28 679.706C995.075 679.502 994.666 679.297 994.461 679.092C994.256 678.887 994.256 678.273 994.666 677.863C995.075 677.454 995.894 677.249 996.713 677.249C997.533 677.454 998.147 678.068 998.352 678.478C998.761 679.297 998.556 679.706 998.147 679.911Z", fill: "#263238" }),
	      React.createElement("path", { d: "M976.644 684.826C976.644 684.826 959.647 683.802 956.984 699.161L959.442 697.727C960.67 696.908 962.104 696.499 963.742 696.499L981.558 694.451L985.245 691.379C984.016 690.355 976.644 684.826 976.644 684.826Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M976.029 686.26C976.029 686.465 975.005 686.875 973.777 687.079C972.548 687.284 971.524 687.284 971.524 687.079C971.524 686.875 972.343 686.465 973.777 686.26C975.005 686.055 976.029 686.055 976.029 686.26Z", fill: "#263238" }),
	      React.createElement("path", { d: "M983.401 693.017C983.401 693.222 981.968 693.426 979.305 693.631C976.848 694.041 973.367 694.245 969.476 694.655C967.633 694.86 965.79 695.065 964.151 695.269C962.513 695.474 961.08 695.884 960.056 696.498C957.803 697.522 957.189 699.16 956.984 698.955C956.779 698.955 957.393 697.317 959.646 695.884C960.67 695.269 962.308 694.655 963.947 694.45C965.585 694.245 967.428 694.041 969.271 693.836C973.162 693.426 976.438 693.222 979.101 693.017C981.968 693.017 983.401 693.017 983.401 693.017Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1079.85 723.938C1079.85 723.938 1078.83 722.914 1076.99 721.276C1075.14 719.638 1072.48 717.18 1069 714.313C1065.52 711.447 1061.42 707.965 1056.3 705.303C1053.64 703.869 1050.98 702.641 1047.91 701.822C1044.84 701.002 1041.56 700.593 1038.28 700.388C1024.77 699.979 1012.28 702.231 1004.08 705.917C999.989 707.76 996.917 709.603 994.869 711.242C992.821 712.675 991.797 713.699 991.797 713.699C991.797 713.699 992.002 713.494 992.412 712.88C992.821 712.47 993.641 711.651 994.46 710.832C996.303 709.194 999.374 707.146 1003.47 705.303C1011.66 701.412 1024.15 699.159 1037.87 699.364C1041.36 699.569 1044.63 699.979 1047.91 701.002C1050.98 701.822 1054.05 703.255 1056.51 704.689C1061.83 707.556 1065.93 711.242 1069.21 714.109C1072.69 716.976 1075.14 719.638 1076.99 721.481C1077.81 722.3 1078.42 723.119 1079.04 723.529C1079.65 723.734 1079.85 723.938 1079.85 723.938Z", fill: "#263238" }),
	      React.createElement("path", { d: "M224.264 613.966H225.084C223.241 587.344 209.93 558.878 200.305 533.895C190.27 508.297 181.055 481.879 158.324 466.316C182.898 514.031 204.81 563.998 224.264 613.966Z", fill: "#E06255" }),
	      React.createElement("path", { d: "M240.237 479.014C240.237 479.014 240.237 479.219 240.237 479.424C240.237 479.629 240.033 480.038 239.828 480.448C239.623 481.267 239.009 482.7 238.599 484.339C238.394 485.158 237.985 485.977 237.78 487.001C237.575 488.025 237.166 489.049 236.756 490.277C236.142 492.735 235.118 495.397 234.503 498.264C234.094 499.698 233.684 501.336 233.275 502.974C232.865 504.612 232.456 506.251 232.046 508.094C231.227 511.575 230.408 515.466 229.793 519.562C228.36 527.548 227.131 536.559 226.517 545.979C225.902 555.399 225.698 564.409 225.902 572.601C226.107 576.697 226.107 580.588 226.517 584.274C226.722 586.117 226.722 587.755 226.926 589.598C227.131 591.236 227.336 592.875 227.336 594.513C227.541 597.585 228.155 600.452 228.36 602.909C228.565 604.138 228.769 605.162 228.769 606.39C228.974 607.414 229.179 608.438 229.179 609.257C229.384 610.896 229.589 612.329 229.793 613.148C229.793 613.558 229.998 613.967 229.998 614.172C229.998 614.377 229.998 614.582 229.998 614.582C229.998 614.582 228.36 607.005 226.722 594.718C226.517 593.079 226.312 591.646 226.107 589.803C225.902 588.164 225.902 586.321 225.698 584.478C225.288 580.792 225.288 576.901 225.083 572.806C224.879 564.614 224.879 555.604 225.698 546.184C226.517 536.764 227.541 527.753 228.974 519.766C229.793 515.671 230.408 511.985 231.432 508.298C231.841 506.455 232.251 504.817 232.66 503.179C233.07 501.541 233.479 499.902 233.889 498.469C234.708 495.397 235.527 492.735 236.346 490.482C236.756 489.254 237.166 488.23 237.37 487.206C237.78 486.182 237.985 485.363 238.394 484.543C239.009 482.905 239.418 481.677 239.828 480.857C240.033 480.448 240.033 480.038 240.237 479.833C240.237 479.014 240.237 479.014 240.237 479.014Z", fill: "#E06255" }),
	      React.createElement("path", { d: "M232.661 504.41L231.227 504C227.951 503.181 226.108 499.7 227.132 496.423L236.347 464.272C237.166 460.995 240.647 459.152 243.924 460.176L245.357 460.586C248.634 461.405 250.477 464.886 249.453 468.163L240.238 500.314C239.214 503.386 235.937 505.229 232.661 504.41Z", fill: "#F5F5F5" }),
	      React.createElement("path", { d: "M232.661 504.406C232.661 504.406 233.07 504.406 233.685 504.611C234.299 504.611 235.528 504.611 236.756 503.997C237.985 503.383 239.214 502.359 239.828 500.516C240.442 498.672 240.852 496.42 241.671 494.167C242.9 489.457 244.538 483.928 246.381 477.58C247.2 474.508 248.224 471.231 249.043 467.75C249.453 466.112 249.248 464.269 248.224 462.835C247.815 462.221 246.996 461.606 246.381 461.197C245.562 460.787 244.743 460.583 243.719 460.378C242.081 459.968 240.033 460.173 238.804 461.197C238.19 461.811 237.575 462.426 237.166 463.04C236.756 463.859 236.552 464.678 236.347 465.497C235.323 468.979 234.504 472.05 233.48 475.327C231.637 481.471 229.998 487.205 228.77 491.915C228.36 493.143 228.155 494.167 227.746 495.191C227.336 496.215 227.131 497.239 227.131 498.263C227.131 500.106 228.155 501.744 228.975 502.563C229.998 503.587 231.022 503.792 231.637 503.997C232.046 503.997 232.251 504.202 232.456 504.202C232.661 504.202 232.661 504.406 232.661 504.406C232.661 504.406 232.661 504.406 232.456 504.406C232.251 504.406 232.046 504.202 231.637 504.202C231.022 503.997 229.794 503.792 228.77 502.768C227.746 501.949 226.722 500.311 226.722 498.263C226.722 497.239 226.927 496.215 227.336 495.191C227.541 494.167 227.951 492.939 228.36 491.915C229.589 487.205 231.227 481.675 233.07 475.327C233.889 472.255 234.913 468.979 235.732 465.497C235.937 464.678 236.142 463.859 236.552 462.835C236.961 462.016 237.575 461.197 238.395 460.787C239.828 459.559 242.081 459.354 243.924 459.763C244.743 459.968 245.767 460.173 246.586 460.787C247.405 461.197 248.224 461.811 248.634 462.63C249.658 464.269 250.067 466.112 249.658 467.955C248.634 471.436 247.815 474.508 246.791 477.784C244.948 483.928 243.309 489.662 242.081 494.372C241.466 496.625 240.852 498.877 240.238 500.72C239.623 502.563 238.19 503.792 236.961 504.406C235.732 505.021 234.504 505.021 233.889 504.816C233.07 504.611 232.661 504.406 232.661 504.406Z", fill: "#263238" }),
	      React.createElement("path", { d: "M230 613.971C229.181 593.493 229.181 570.761 240.853 553.764C247.406 544.139 257.441 537.177 268.09 532.467C278.739 527.757 290.206 524.89 301.47 522.023C288.773 539.634 260.308 539.839 248.226 557.86C244.539 563.184 242.901 569.533 241.263 575.881C237.986 588.783 234.915 601.07 231.638 613.971", fill: "#E06255" }),
	      React.createElement("path", { d: "M139.893 541.887C139.893 541.887 139.893 541.887 140.098 541.887C140.303 541.887 140.508 541.887 140.917 541.887C141.532 542.091 142.76 542.091 143.989 542.296C146.651 542.706 150.542 543.525 155.252 545.163C159.962 546.597 165.287 549.054 171.021 552.331C173.887 553.969 176.55 556.017 179.417 558.065C182.284 560.317 184.946 562.775 187.608 565.437C190.27 568.099 192.523 570.966 194.571 573.833C195.595 575.267 196.619 576.7 197.438 578.134C198.257 579.567 199.281 581.001 199.895 582.434C202.967 588.168 205.22 593.492 206.653 598.202C208.087 602.912 208.906 606.803 209.315 609.466C209.52 610.899 209.52 611.923 209.725 612.537C209.725 612.947 209.725 613.152 209.725 613.356C209.725 613.152 209.725 612.947 209.52 612.537C209.315 611.923 209.315 610.694 209.11 609.466C208.701 606.803 207.677 602.912 206.243 598.202C204.81 593.492 202.557 588.168 199.281 582.434C198.462 581.001 197.643 579.567 196.823 578.134C195.799 576.7 194.98 575.267 193.956 573.833C191.909 570.966 189.656 568.099 186.994 565.437C184.332 562.775 181.669 560.317 179.007 558.065C176.14 555.812 173.478 553.969 170.611 552.331C165.082 549.054 159.757 546.597 155.047 545.163C150.337 543.525 146.651 542.706 143.784 542.091C142.351 541.887 141.327 541.682 140.712 541.477C140.303 541.477 140.098 541.272 139.893 541.272C140.098 541.887 139.893 541.887 139.893 541.887Z", fill: "#E06255" }),
	      React.createElement("path", { d: "M160.782 548.442L160.167 549.671C158.734 552.743 155.048 553.971 151.976 552.538L121.873 537.998C118.801 536.565 117.572 532.878 119.006 529.807L119.62 528.578C121.053 525.506 124.74 524.277 127.811 525.711L157.915 540.251C160.986 541.684 162.215 545.37 160.782 548.442Z", fill: "#F5F5F5" }),
	      React.createElement("path", { d: "M160.782 548.444C160.782 548.444 160.987 548.035 161.192 547.42C161.397 546.806 161.601 545.577 161.192 544.349C160.782 543.12 159.963 541.482 158.325 540.663C156.687 539.843 154.639 538.82 152.386 537.796C147.881 535.748 142.761 533.086 136.822 530.423C133.955 528.99 130.884 527.556 127.607 526.123C126.174 525.509 124.126 525.304 122.692 526.123C121.873 526.532 121.259 527.147 120.644 527.761C120.03 528.375 119.825 529.195 119.416 530.219C118.597 531.857 118.597 533.7 119.416 535.338C119.825 536.157 120.44 536.772 121.054 537.386C121.668 538 122.488 538.205 123.307 538.615C126.378 540.048 129.45 541.686 132.522 543.12C138.256 545.987 143.58 548.444 147.881 550.697C148.905 551.311 149.929 551.721 150.953 552.131C151.977 552.54 152.796 553.154 153.82 553.154C155.663 553.564 157.301 552.745 158.325 551.926C159.349 551.107 159.963 550.083 160.168 549.468C160.373 549.264 160.373 548.854 160.577 548.649C160.782 548.444 160.782 548.444 160.782 548.444C160.782 548.444 160.782 548.444 160.782 548.649C160.782 548.854 160.577 549.059 160.373 549.468C160.168 550.083 159.554 551.107 158.53 551.926C157.506 552.745 155.663 553.564 153.82 553.154C152.796 552.95 151.772 552.54 150.953 552.131C149.929 551.721 148.905 551.107 147.881 550.697C143.376 548.649 138.256 545.987 132.317 543.325C129.45 541.891 126.378 540.458 123.102 539.024C122.283 538.615 121.464 538.41 120.644 537.796C119.825 537.181 119.211 536.567 118.801 535.543C117.982 533.905 117.982 531.652 118.801 530.014C119.211 529.195 119.621 528.375 120.235 527.556C120.849 526.737 121.668 526.123 122.488 525.713C124.126 524.894 126.174 524.894 127.812 525.713C130.884 527.147 133.955 528.785 137.027 530.219C142.761 533.086 148.086 535.543 152.386 537.796C154.639 538.82 156.482 539.843 158.325 540.663C160.168 541.686 160.987 543.325 161.397 544.554C161.806 545.987 161.601 547.011 161.397 547.625C160.987 548.035 160.782 548.444 160.782 548.444Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1265.19 559.497C1275.63 634.243 1286.28 708.99 1296.72 783.736L1304.91 783.941C1299.59 707.761 1294.06 630.148 1265.19 559.497Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M1352.63 549.058C1330.72 573.223 1321.71 606.193 1316.18 638.344C1308.19 684.011 1307.58 737.665 1309.83 783.946L1321.3 784.151C1316.79 704.49 1327.44 625.033 1352.63 549.058Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M1270.92 692.196C1268.46 681.137 1265.59 669.874 1259.25 660.249C1250.65 647.553 1236.72 639.361 1222.59 633.013C1208.46 626.665 1193.72 621.75 1181.02 612.944C1195.15 636.085 1227.3 642.433 1243.68 664.14C1251.87 674.994 1255.15 688.51 1258.43 701.616C1265.39 730.286 1269.69 755.065 1276.65 783.735H1285.87C1282.8 752.607 1277.88 722.709 1270.92 692.196Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M1329.69 783.944C1329.69 783.944 1337.68 694.863 1343.41 678.48C1349.35 662.097 1404.44 617.044 1404.03 619.092C1403.42 621.14 1362.66 670.698 1356.72 680.732C1350.79 690.767 1340.75 783.944 1340.75 783.944H1329.69Z", fill: "#ECC651" }),
	      React.createElement("path", { d: "M514.65 205.424C514.65 205.628 512.397 204.604 508.301 203.785C504.206 202.966 497.857 202.147 490.28 203.171C482.703 204.195 473.898 207.267 466.116 213.615C458.334 219.963 451.576 229.383 448.914 240.851C448.914 241.056 448.914 241.056 448.914 241.056L448.504 242.899L447.685 241.056C443.385 230.203 435.603 221.806 427.207 216.277C418.811 210.748 409.8 208.495 402.223 207.881C394.646 207.267 388.502 208.495 384.407 209.519C380.311 210.543 378.058 211.567 378.058 211.362C378.058 211.362 378.673 211.158 379.697 210.543C380.721 210.134 382.359 209.519 384.407 208.905C388.502 207.676 394.646 206.447 402.428 206.857C410.21 207.267 419.425 209.519 428.026 215.048C436.627 220.578 444.613 229.179 449.119 240.237H447.89C447.89 240.237 447.89 240.032 447.89 239.827C450.552 228.155 457.515 218.53 465.501 211.977C473.488 205.424 482.703 202.352 490.28 201.533C498.062 200.509 504.411 201.533 508.506 202.557C510.554 203.171 512.192 203.581 513.216 203.99C514.035 205.219 514.65 205.424 514.65 205.424Z", fill: "#263238" }),
	      React.createElement("path", { d: "M714.11 86.2418C714.11 86.4466 712.881 85.8322 710.629 85.4226C708.376 85.0131 704.895 84.6035 700.799 85.2179C696.703 85.8322 691.789 87.4705 687.693 90.9518C683.392 94.4332 679.911 99.5528 678.478 105.696V105.901L678.068 107.744L677.249 105.901C674.791 99.9624 670.696 95.4571 666.191 92.3853C661.685 89.3136 656.77 88.0848 652.47 87.6753C648.374 87.2657 644.893 87.8801 642.64 88.4944C640.388 89.1088 639.159 89.5183 639.159 89.5183C639.159 89.5183 639.364 89.3135 639.978 89.1088C640.592 88.904 641.412 88.4944 642.436 88.0848C644.688 87.4705 648.169 86.6513 652.47 86.8561C656.77 87.0609 661.89 88.2896 666.6 91.3614C671.31 94.4332 675.815 99.1432 678.273 105.287H677.044V105.082C678.478 98.5289 682.369 93.2045 686.874 89.7231C691.379 86.037 696.499 84.3987 700.799 83.9891C705.1 83.5796 708.581 83.9891 710.834 84.6035C712.062 85.0131 712.881 85.2179 713.496 85.4226C713.905 86.037 714.11 86.2418 714.11 86.2418Z", fill: "#263238" }),
	      React.createElement("path", { d: "M574.447 58.3901C574.447 58.3901 573.218 59.8236 570.965 62.281C568.713 64.7384 565.641 68.6293 562.569 73.7489C556.221 83.7834 549.873 99.7566 550.077 118.187C550.077 118.392 550.077 118.597 550.077 118.802L548.849 119.006C547.415 109.996 544.548 101.804 540.657 95.0465C536.971 88.0838 532.466 82.5547 528.37 78.459C524.274 74.1585 520.384 71.2915 517.721 69.4484C515.059 67.6054 513.421 66.5815 513.421 66.5815C513.421 66.5815 513.83 66.7862 514.65 67.1958C515.469 67.6054 516.493 68.2197 517.926 69.0389C520.793 70.8819 524.684 73.7489 528.984 77.8446C533.285 81.9403 537.79 87.6743 541.681 94.637C545.572 101.6 548.644 109.996 550.077 119.006L548.849 119.211C548.849 119.006 548.849 118.802 548.849 118.597C548.644 99.9614 555.197 83.7834 561.955 73.7489C565.231 68.6293 568.508 64.9432 570.761 62.4858C571.989 61.2571 572.808 60.4379 573.628 59.8236C574.037 58.5949 574.447 58.1853 574.447 58.3901Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1408.74 376.826C1408.74 377.031 1093.37 377.441 704.689 377.441C315.599 377.441 0.434921 377.236 0.434921 376.826C0.434921 376.417 315.599 376.212 704.485 376.212C1093.37 376.417 1408.74 376.622 1408.74 376.826Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1391.13 783.735C1391.13 783.94 1342.8 784.35 1283.21 784.35C1223.61 784.35 1175.29 784.145 1175.29 783.735C1175.29 783.53 1223.61 783.121 1283.21 783.121C1342.8 783.326 1391.13 783.53 1391.13 783.735Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1286.28 788.854C1286.28 789.059 1284.64 789.469 1282.39 789.469C1280.34 789.469 1278.5 789.264 1278.5 788.854C1278.5 788.445 1280.14 788.24 1282.39 788.24C1284.64 788.445 1286.28 788.649 1286.28 788.854Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1305.73 790.081C1305.73 790.286 1303.89 790.695 1301.64 790.695C1299.39 790.695 1297.54 790.491 1297.54 790.081C1297.54 789.671 1299.39 789.467 1301.64 789.467C1303.89 789.467 1305.73 789.671 1305.73 790.081Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1319.25 790.288C1319.25 790.493 1317.61 790.902 1315.77 790.902C1313.93 790.902 1312.29 790.698 1312.29 790.288C1312.29 790.083 1313.93 789.674 1315.77 789.674C1317.61 789.878 1319.25 790.083 1319.25 790.288Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1339.32 790.081C1339.32 790.286 1337.27 790.695 1334.81 790.695C1332.36 790.695 1330.31 790.491 1330.31 790.081C1330.31 789.671 1332.36 789.467 1334.81 789.467C1337.27 789.467 1339.32 789.671 1339.32 790.081Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1321.5 794.383C1321.5 794.588 1319.86 794.997 1317.82 794.997C1315.77 794.997 1314.13 794.792 1314.13 794.383C1314.13 794.178 1315.77 793.768 1317.82 793.768C1319.86 793.768 1321.5 794.178 1321.5 794.383Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1310.44 796.02C1310.44 796.225 1308.4 796.635 1305.94 796.635C1303.48 796.635 1301.43 796.43 1301.43 796.02C1301.43 795.611 1303.48 795.406 1305.94 795.406C1308.4 795.406 1310.44 795.611 1310.44 796.02Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1233.85 514.441C1233.85 514.646 1172.62 515.055 1096.85 515.055C1021.29 515.055 959.852 514.851 959.852 514.441C959.852 514.236 1021.08 513.827 1096.85 513.827C1172.62 513.827 1233.85 514.031 1233.85 514.441Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1314.33 539.428C1314.33 539.633 1253.1 540.042 1177.33 540.042C1101.77 540.042 1040.33 539.837 1040.33 539.428C1040.33 539.223 1101.56 538.813 1177.33 538.813C1253.1 538.813 1314.33 539.018 1314.33 539.428Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1495.57 392.393C1495.57 392.598 1366.14 393.007 1206.62 393.007C1047.09 393.007 917.666 392.802 917.666 392.393C917.666 392.188 1047.09 391.779 1206.62 391.779C1366.14 391.779 1495.57 392.188 1495.57 392.393Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1067.77 403.251C1067.77 403.456 1029.48 403.865 981.968 403.865C934.663 403.865 896.163 403.661 896.163 403.251C896.163 403.046 934.458 402.637 981.968 402.637C1029.48 402.637 1067.77 402.841 1067.77 403.251Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1515.43 402.225C1515.43 402.43 1484.51 402.839 1446.42 402.839C1408.33 402.839 1377.41 402.634 1377.41 402.225C1377.41 402.02 1408.33 401.61 1446.42 401.61C1484.51 401.61 1515.43 402.02 1515.43 402.225Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M424.545 614.587C424.545 614.791 362.905 615.201 286.93 615.201C210.955 615.201 149.314 614.996 149.314 614.587C149.314 614.382 210.955 613.972 286.93 613.972C362.905 613.972 424.545 614.382 424.545 614.587Z", fill: "#263238" }),
	      React.createElement("path", { d: "M446.252 583.256C446.252 583.46 422.906 583.87 393.827 583.87C364.952 583.87 341.402 583.665 341.402 583.256C341.402 583.051 364.747 582.641 393.827 582.641C422.701 582.846 446.252 583.051 446.252 583.256Z", fill: "#263238" }),
	      React.createElement("path", { d: "M245.153 623.597C245.153 623.801 235.733 624.211 224.265 624.211C212.593 624.211 203.377 624.006 203.377 623.597C203.377 623.187 212.797 622.982 224.265 622.982C235.733 623.187 245.153 623.392 245.153 623.597Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M220.579 633.223C220.579 633.428 216.893 633.633 212.183 633.428C207.678 633.223 203.992 632.814 203.992 632.404C203.992 632.199 207.678 631.995 212.388 632.199C216.893 632.404 220.579 632.814 220.579 633.223Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M211.364 644.077C211.364 644.282 209.726 644.487 207.678 644.487C205.63 644.282 203.992 644.077 203.992 643.668C203.992 643.463 205.63 643.258 207.678 643.258C209.726 643.463 211.364 643.668 211.364 644.077Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1505.4 251.096C1488.2 239.628 1447.85 238.604 1432.7 252.734C1426.76 241.266 1405.05 246.59 1405.05 259.492C1394.4 250.891 1375.15 263.383 1378.84 276.694C1370.85 266.455 1351.4 271.369 1348.94 283.861C1329.28 276.899 1309.62 269.936 1289.96 262.973C1266.82 248.433 1236.11 246.386 1211.12 257.854C1207.64 252.12 1199.45 249.662 1193.31 252.734C1187.16 255.601 1184.09 263.588 1186.34 269.936C1178.56 264.816 1166.48 268.707 1163.2 277.513C1156.85 268.912 1140.06 274.851 1140.47 285.5C1131.46 280.175 1117.74 287.752 1117.95 298.401C1112.83 289.186 1097.06 289.39 1092.14 298.606C1089.48 288.776 1078.42 282.018 1068.39 284.066C1052.41 269.526 1026.82 266.864 1008.18 277.718C1004.7 272.393 997.122 269.936 991.388 272.393C985.45 274.851 981.968 281.813 983.402 288.162C973.982 280.175 957.394 284.271 952.889 295.534C946.336 287.343 930.158 294.715 931.591 304.954C925.857 296.763 909.884 303.725 911.932 313.555C906.198 304.135 887.972 310.688 889.815 321.542C878.347 314.169 860.736 320.313 856.23 333.214C851.316 323.18 832.68 327.685 832.885 338.948C826.741 327.685 808.72 325.637 800.119 335.057C791.518 325.023 774.317 323.999 764.692 333.01C767.968 324.409 757.934 314.169 749.333 317.241C749.742 304.954 738.479 293.486 726.192 293.691C713.905 293.896 703.051 305.773 703.871 318.06C698.341 314.784 689.945 317.446 687.488 323.589C685.03 329.733 689.126 337.515 695.474 338.948C691.379 332.395 681.14 331.166 675.406 336.286C669.876 341.611 670.491 351.85 676.634 356.355C670.491 351.85 661.275 352.055 655.132 356.765C649.193 361.475 646.736 370.28 649.398 377.448H1505.19V251.096H1505.4Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M1111.6 298.398C1111.6 298.398 1110.98 297.784 1109.34 296.965C1107.91 296.146 1105.45 294.917 1102.38 294.712C1099.31 294.507 1095.21 295.122 1091.73 297.989C1088.46 300.856 1085.79 305.771 1086.41 311.095V311.709H1085.79C1080.67 311.505 1075.15 313.962 1071.25 318.467C1067.36 322.768 1064.91 329.116 1066.34 335.464L1066.54 336.488L1065.73 336.079C1064.91 335.874 1064.09 335.464 1063.27 335.464C1056.71 334.236 1049.75 336.693 1045.86 341.198C1041.97 345.908 1040.74 352.257 1041.97 357.376L1042.17 358.4L1041.36 357.991C1036.44 355.329 1030.91 354.919 1026.61 355.943C1022.11 356.762 1018.62 359.015 1015.96 361.063C1010.84 365.363 1010.02 369.459 1009.82 369.254C1009.82 369.254 1009.82 369.049 1010.02 368.64C1010.23 368.23 1010.43 367.616 1010.84 366.796C1011.66 365.158 1013.1 362.906 1015.76 360.653C1018.22 358.4 1021.9 356.148 1026.61 355.329C1031.12 354.305 1036.85 354.509 1041.97 357.172L1041.36 357.786C1039.92 352.462 1041.15 345.704 1045.45 340.789C1049.55 335.874 1056.92 333.212 1063.88 334.645C1064.91 334.85 1065.73 335.055 1066.54 335.464L1065.93 336.079C1064.5 329.321 1067.16 322.563 1071.25 318.058C1075.35 313.552 1081.08 310.89 1086.41 311.095L1086 311.505C1085.38 305.771 1088.25 300.651 1091.73 297.579C1095.42 294.507 1099.72 293.893 1103 294.303C1106.27 294.712 1108.73 295.941 1110.16 296.76C1110.98 297.17 1111.39 297.784 1111.8 297.989C1111.6 298.194 1111.6 298.398 1111.6 298.398Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1374.13 273.419C1374.13 273.624 1369.22 272.396 1361.23 274.853C1357.34 276.082 1352.63 278.334 1348.53 282.225C1344.23 285.911 1340.55 291.441 1338.91 298.198V298.608H1338.5C1333.58 298.198 1328.05 299.427 1323.34 302.294C1318.63 305.161 1314.54 309.666 1312.29 315.196C1311.47 317.039 1311.06 319.291 1310.85 321.134L1310.65 321.953L1310.03 321.544C1304.09 317.448 1295.9 317.653 1290.58 321.544C1285.25 325.435 1283 331.988 1283.82 337.517L1284.03 338.541L1283.21 337.927C1278.91 334.855 1273.79 334.65 1269.9 335.674C1265.8 336.903 1263.14 339.565 1261.5 342.022C1259.86 344.48 1259.25 346.937 1259.04 348.371C1258.84 350.009 1258.84 350.828 1258.84 350.828C1258.84 350.828 1258.84 350.623 1258.84 350.214C1258.84 349.804 1258.84 349.19 1258.84 348.371C1259.04 346.732 1259.66 344.275 1261.29 341.818C1262.93 339.155 1265.8 336.288 1269.9 335.06C1273.99 333.831 1279.52 334.036 1284.03 337.312L1283.41 337.722C1282.59 331.988 1284.84 325.025 1290.58 320.93C1296.11 316.834 1304.71 316.424 1311.06 320.93L1310.24 321.339C1310.44 319.291 1310.85 317.039 1311.67 314.991C1316.18 303.318 1328.46 296.56 1338.91 297.789L1338.29 298.198C1339.93 291.236 1343.82 285.707 1348.33 281.816C1352.63 277.925 1357.34 275.672 1361.43 274.443C1365.53 273.215 1368.81 273.01 1371.06 273.215C1372.29 273.215 1373.11 273.419 1373.72 273.419C1373.93 273.419 1374.13 273.419 1374.13 273.419Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1203.34 366.8C1203.34 366.8 1203.55 365.981 1204.36 364.752C1205.18 363.524 1206.62 361.885 1208.87 360.452C1211.12 359.018 1214.19 357.585 1217.88 357.585C1221.57 357.38 1225.46 358.404 1228.94 360.657L1228.12 360.861V360.657C1229.35 356.561 1232.62 353.489 1236.11 352.26C1239.59 351.032 1243.07 351.646 1245.53 353.079C1247.98 354.308 1249.42 356.151 1250.24 357.38C1251.06 358.609 1251.26 359.428 1251.06 359.428C1251.06 359.428 1250.65 358.609 1249.83 357.585C1249.01 356.356 1247.57 354.923 1245.12 353.694C1242.86 352.465 1239.59 352.056 1236.31 353.079C1233.24 354.308 1230.17 356.97 1229.14 360.657L1228.94 361.271L1228.32 360.861C1225.05 358.609 1221.16 357.79 1217.88 357.79C1214.4 357.79 1211.53 359.018 1209.28 360.452C1204.98 363.933 1203.55 367.005 1203.34 366.8Z", fill: "#263238" }),
	      React.createElement("path", { d: "M873.227 333.211C873.227 333.416 871.384 333.416 868.722 335.054C867.493 335.873 865.855 337.102 864.626 338.945C863.397 340.788 862.578 343.245 862.578 345.703V346.727L861.759 346.112C859.711 344.474 857.049 343.245 853.977 343.041C850.905 342.836 847.834 343.86 845.376 345.908C842.1 348.775 840.666 353.28 841.076 356.966L841.281 358.195L840.257 357.376C837.594 355.328 834.318 354.509 831.451 354.509C828.584 354.713 826.331 355.737 824.488 356.966C821.212 359.423 820.393 362.086 820.188 362.086C820.188 362.086 820.393 361.471 820.802 360.447C821.416 359.423 822.44 357.99 824.079 356.556C825.717 355.123 828.174 353.894 831.246 353.689C834.318 353.485 837.799 354.304 840.666 356.556L839.847 356.966C839.233 352.87 840.871 348.16 844.352 345.088C847.015 342.631 850.496 341.812 853.772 342.017C857.049 342.221 859.916 343.45 861.964 345.293L861.145 345.703C861.145 342.836 862.169 340.174 863.602 338.331C864.831 336.487 866.469 335.259 867.903 334.44C869.336 333.621 870.565 333.211 871.384 333.211C872.817 333.211 873.227 333.211 873.227 333.211Z", fill: "#263238" }),
	      React.createElement("path", { d: "M1470.79 280.589C1470.79 280.793 1467.31 279.565 1461.57 280.589C1458.71 281.203 1455.43 282.432 1452.15 284.684C1448.88 286.937 1446.01 290.213 1444.37 294.514L1444.17 295.128L1443.76 294.923C1441.71 293.9 1439.25 293.08 1436.8 292.876C1431.47 292.057 1425.94 293.285 1421.85 295.538C1417.75 297.79 1414.88 301.272 1413.04 304.344C1411.2 307.415 1410.38 310.282 1409.97 312.33C1409.56 314.378 1409.56 315.402 1409.35 315.402C1409.35 315.402 1409.35 315.197 1409.35 314.583C1409.35 313.968 1409.35 313.149 1409.56 312.125C1409.76 310.078 1410.58 307.211 1412.43 303.934C1414.27 300.657 1417.14 297.176 1421.44 294.719C1425.74 292.261 1431.27 291.033 1437 291.852C1439.66 292.261 1442.12 293.08 1444.37 294.104L1443.55 294.309C1445.4 289.804 1448.47 286.323 1451.95 284.07C1455.23 281.817 1458.71 280.589 1461.78 280.179C1464.65 279.769 1467.1 279.769 1468.74 280.179C1469.56 280.384 1470.18 280.589 1470.58 280.589H1470.79Z", fill: "#263238" }),
	      React.createElement("path", { d: "M786.807 619.893L788.855 667.812L814.658 667.198L812.815 619.278L786.807 619.893Z", fill: "#E06255" }),
	      React.createElement("path", { d: "M801.553 665.561C801.758 665.561 801.349 655.117 800.734 642.216C800.12 629.314 799.301 618.87 799.096 618.87C798.891 618.87 799.301 629.314 799.915 642.216C800.529 655.117 801.349 665.561 801.553 665.561Z", fill: "#263238" }),
	      React.createElement("path", { d: "M788.651 664.551L814.454 663.732L814.659 667.213L788.856 667.828L788.651 664.551Z", fill: "#263238" }),
	      React.createElement("path", { d: "M814.045 651.847C814.045 651.847 813.84 651.438 813.431 650.823C813.021 650.209 812.202 649.39 810.973 648.571C809.949 647.751 808.516 646.728 806.673 645.908C804.83 645.089 802.782 644.68 800.529 644.885C796.024 645.089 792.338 647.547 790.7 649.799C789.88 650.823 789.266 652.052 788.857 652.666C788.652 653.485 788.447 653.895 788.447 653.895C788.652 653.895 789.061 652.257 790.904 650.209C792.747 648.161 796.229 645.908 800.325 645.704C804.625 645.499 808.106 647.547 810.359 648.98C812.816 650.618 814.045 651.847 814.045 651.847Z", fill: "#263238" }),
	      React.createElement("path", { opacity: "0.3", d: "M787.422 639.153L788.037 645.706L813.635 643.454V639.153H787.422Z", fill: "black" }),
	      React.createElement("path", { d: "M687.693 625.439L688.717 654.109C688.717 654.109 660.047 664.348 659.637 669.672L715.339 670.082L715.544 625.234L687.693 625.439Z", fill: "#E06255" }),
	      React.createElement("path", { d: "M705.714 651.861C706.738 652.066 707.557 653.295 707.353 654.523C707.148 655.547 705.919 656.366 704.69 656.162C703.666 655.957 702.643 654.523 703.052 653.295C703.462 652.271 704.895 651.452 705.919 651.861", fill: "#E0E0E0" }),
	      React.createElement("path", { d: "M715.339 670.289V666.807L661.275 667.422C661.275 667.422 659.432 668.446 659.432 670.289H715.339Z", fill: "#263238" }),
	      React.createElement("path", { d: "M688.306 654.508C688.306 654.713 689.739 654.918 690.968 655.737C692.402 656.556 693.016 657.785 693.221 657.58C693.426 657.58 693.016 655.942 691.378 654.918C689.944 653.894 688.101 654.099 688.306 654.508Z", fill: "#263238" }),
	      React.createElement("path", { d: "M682.369 656.971C682.369 657.175 683.597 657.79 684.416 658.814C685.44 660.042 685.645 661.271 685.85 661.271C686.055 661.271 686.26 659.633 685.031 658.199C684.007 656.766 682.369 656.561 682.369 656.971Z", fill: "#263238" }),
	      React.createElement("path", { d: "M679.092 663.932C679.297 663.932 679.707 662.704 679.092 661.065C678.478 659.632 677.045 659.018 677.045 659.222C676.84 659.427 677.659 660.246 678.273 661.475C678.683 662.704 678.683 663.932 679.092 663.932Z", fill: "#263238" }),
	      React.createElement("path", { d: "M688.717 647.766C688.922 647.971 690.151 647.562 691.584 647.766C693.222 647.766 694.246 648.381 694.451 648.176C694.656 647.971 693.427 646.947 691.584 646.947C689.946 646.743 688.512 647.562 688.717 647.766Z", fill: "#263238" }),
	      React.createElement("path", { d: "M687.693 641.616C687.693 641.821 688.717 641.821 690.56 641.616C691.38 641.412 692.403 641.207 693.427 640.797C694.042 640.592 694.451 640.183 695.066 639.978C695.27 639.773 695.68 639.568 695.885 639.364C696.09 639.159 696.294 638.34 696.09 637.93C695.885 637.521 695.27 637.316 694.861 637.316C694.451 637.316 694.042 637.316 693.837 637.521C693.223 637.725 692.608 637.93 691.994 638.135C690.97 638.545 690.151 639.159 689.332 639.773C688.103 641.002 687.489 642.026 687.693 642.026C687.898 642.026 688.513 641.207 689.741 640.183C690.356 639.773 691.175 639.159 692.199 638.749C692.608 638.545 693.223 638.34 693.837 638.34C694.451 638.135 694.861 638.135 695.066 638.34C695.066 638.34 695.066 638.545 695.066 638.749C694.861 638.954 694.656 639.159 694.451 639.159C694.042 639.568 693.427 639.773 693.018 639.978C691.994 640.388 691.175 640.797 690.356 641.002C688.717 641.412 687.693 641.412 687.693 641.616Z", fill: "#263238" }),
	      React.createElement(
	        "g",
	        { opacity: "0.3" },
	        React.createElement("path", { d: "M715.545 642.636V648.985L688.513 648.78V643.046L715.545 642.636Z", fill: "black" })
	      ),
	      React.createElement("path", { d: "M815.273 384.196L810.154 403.241L795.204 385.63L803.191 368.223L815.273 376.824V384.196Z", fill: "#FFBE9D" }),
	      React.createElement("path", { d: "M818.14 224.874C818.14 224.874 825.717 233.066 826.536 241.871C827.355 250.677 840.461 329.929 840.461 329.929C840.461 329.929 820.392 380.306 815.273 383.992L799.914 377.644L812.611 323.58L803.395 286.924L818.14 224.874Z", fill: "#3B53A7" }),
	      React.createElement("path", { d: "M837.184 334.229C837.389 334.433 833.703 335.662 829.198 334.638C824.692 333.409 822.235 330.543 822.44 330.338C822.645 330.133 825.307 332.386 829.402 333.409C833.498 334.638 836.98 333.819 837.184 334.229Z", fill: "#263238" }),
	      React.createElement("path", { d: "M835.137 291.835C835.137 291.835 833.703 292.859 831.246 294.293C828.788 295.726 825.512 297.774 821.826 300.027C818.139 302.279 815.068 304.532 812.815 306.17C810.562 307.809 809.129 308.833 809.129 308.833C809.129 308.833 809.334 308.423 809.948 308.013C810.562 307.399 811.382 306.785 812.61 305.966C814.863 304.327 817.935 301.87 821.621 299.617C825.307 297.365 828.583 295.317 831.041 293.883C832.27 293.269 833.294 292.655 834.113 292.45C834.727 292.04 835.137 291.835 835.137 291.835Z", fill: "white" }),
	      React.createElement("path", { d: "M828.788 264.601C828.788 264.601 827.355 265.215 825.102 266.239C822.849 267.263 819.778 268.901 816.706 270.949C813.634 272.997 810.972 275.25 809.129 276.888C807.286 278.526 806.262 279.55 806.057 279.55C806.057 279.55 806.262 279.14 806.671 278.731C807.081 278.116 807.9 277.502 808.719 276.683C810.562 275.045 813.02 272.792 816.296 270.539C819.368 268.492 822.645 266.853 824.897 266.034C826.126 265.625 826.945 265.215 827.559 265.01C828.379 264.601 828.788 264.601 828.788 264.601Z", fill: "white" }),
	      React.createElement("path", { d: "M825.512 241.256C825.512 241.461 821.825 241.666 817.73 243.918C813.634 245.966 811.177 248.833 811.177 248.833C811.177 248.833 811.586 248.014 812.815 246.99C813.839 245.966 815.477 244.533 817.525 243.509C819.573 242.485 821.621 241.87 823.054 241.666C824.692 241.256 825.512 241.256 825.512 241.256Z", fill: "white" }),
	      React.createElement("path", { d: "M837.389 328.902C837.389 328.902 836.16 328.288 833.907 327.469C831.86 326.649 828.788 325.83 825.306 325.421C821.825 325.011 818.753 325.421 816.501 325.83C814.248 326.24 812.815 326.649 812.815 326.649C812.815 326.649 813.224 326.445 813.634 326.24C814.248 326.035 815.067 325.626 816.296 325.421C818.549 324.806 821.825 324.397 825.306 324.806C828.788 325.216 831.86 326.035 834.112 327.059C835.136 327.469 835.955 327.878 836.57 328.288C836.979 328.697 837.389 328.902 837.389 328.902Z", fill: "white" }),
	      React.createElement("path", { d: "M824.283 358.596C824.283 358.596 823.669 357.367 822.645 355.524C821.621 353.681 819.778 351.428 817.525 349.176C815.068 346.923 812.61 345.49 810.767 344.466C808.924 343.442 807.695 343.032 807.695 343.032C807.695 343.032 808.105 343.032 808.515 343.237C809.129 343.442 809.948 343.647 810.972 344.056C813.02 344.875 815.477 346.514 817.935 348.766C820.392 351.019 822.03 353.476 823.054 355.319C823.464 356.343 823.873 357.162 824.078 357.572C824.078 358.186 824.283 358.596 824.283 358.596Z", fill: "white" }),
	      React.createElement("path", { d: "M691.788 378.257C691.993 379.076 699.365 398.326 699.365 398.326L711.652 393.001L712.676 376.823L707.761 368.222L691.788 378.257Z", fill: "#FFBE9D" }),
	      React.createElement("path", { d: "M734.383 198.661C732.54 198.661 703.461 211.972 698.341 215.249C693.222 218.525 664.552 322.965 664.552 328.494C664.552 334.024 691.788 381.329 691.788 381.329C691.788 381.329 706.328 374.776 708.171 373.342C710.014 371.909 695.27 325.013 695.27 325.013L707.352 280.37L734.383 198.661Z", fill: "#3B53A7" }),
	      React.createElement("path", { d: "M690.764 328.906C690.764 328.906 690.149 330.135 688.511 331.364C686.873 332.593 684.415 334.026 681.344 334.845C678.272 335.459 675.405 335.255 673.357 334.64C671.309 334.026 670.285 333.412 670.285 333.207C670.285 333.002 671.514 333.412 673.562 333.821C675.405 334.231 678.272 334.231 681.139 333.616C684.006 333.002 686.463 331.773 688.101 330.749C689.74 329.521 690.764 328.702 690.764 328.906Z", fill: "#263238" }),
	      React.createElement("path", { d: "M702.846 353.271C702.846 353.476 701.617 353.681 699.569 354.5C697.521 355.319 694.859 356.753 692.197 358.801C689.535 360.849 687.692 363.306 686.463 365.149C685.234 366.992 684.62 368.221 684.62 368.221C684.62 368.221 684.62 367.811 685.03 367.197C685.234 366.582 685.644 365.763 686.258 364.739C687.487 362.896 689.33 360.234 691.992 358.186C694.654 355.934 697.521 354.705 699.569 353.886C700.593 353.476 701.412 353.271 702.027 353.271C702.436 353.271 702.846 353.271 702.846 353.271Z", fill: "white" }),
	      React.createElement("path", { d: "M693.631 336.482C693.631 336.482 692.812 337.506 690.969 338.735C689.331 339.963 686.668 341.397 683.597 342.216C680.525 343.24 677.658 343.445 675.405 343.445C673.357 343.445 671.924 343.24 671.924 343.24C671.924 343.035 673.153 343.24 675.2 343.035C677.248 342.83 680.115 342.626 683.187 341.602C686.259 340.578 688.716 339.349 690.559 338.325C692.607 337.301 693.631 336.482 693.631 336.482Z", fill: "white" }),
	      React.createElement("path", { d: "M695.884 314.569C695.884 314.569 694.45 314.16 692.197 313.341C689.945 312.522 686.873 311.702 683.392 310.883C679.91 310.269 676.634 309.859 674.381 309.655C672.128 309.45 670.49 309.45 670.49 309.245C670.49 309.245 671.924 309.04 674.381 309.04C676.839 309.04 679.91 309.45 683.596 310.064C687.078 310.883 690.354 311.702 692.402 312.726C694.655 313.75 695.884 314.569 695.884 314.569Z", fill: "white" }),
	      React.createElement("path", { d: "M701.617 293.067C701.617 293.067 700.594 291.838 698.955 290.2C697.317 288.357 694.655 286.309 691.378 284.671C688.102 283.032 684.825 282.213 682.368 281.804C679.91 281.394 678.477 281.394 678.477 281.394C678.477 281.394 678.886 281.394 679.501 281.189C680.115 281.189 681.139 281.189 682.368 281.189C684.825 281.394 688.306 282.213 691.583 283.851C695.064 285.49 697.522 287.947 699.16 289.79C699.979 290.814 700.594 291.428 701.003 292.043C701.617 292.657 701.617 293.067 701.617 293.067Z", fill: "white" }),
	      React.createElement("path", { d: "M699.979 256.405C699.774 256.609 697.522 253.947 693.426 252.718C689.33 251.49 685.849 252.309 685.849 252.104C685.849 251.899 689.33 250.875 693.631 252.104C697.931 253.538 700.184 256.405 699.979 256.405Z", fill: "white" }),
	      React.createElement(
	        "g",
	        { opacity: "0.3" },
	        React.createElement("path", { d: "M705.714 287.738C703.666 280.161 701.618 272.584 700.389 265.007C699.365 257.225 699.365 249.239 701.208 241.662C704.485 256.406 704.69 271.765 705.099 286.919C705.099 286.509 705.099 286.1 704.894 285.69", fill: "black" })
	      ),
	      React.createElement("path", { d: "M699.57 234.293C699.365 234.293 698.956 232.45 697.727 230.607C696.293 228.764 694.655 227.74 694.655 227.535C694.655 227.33 696.703 228.15 698.137 230.197C699.57 232.04 699.57 234.293 699.57 234.293Z", fill: "white" }),
	      React.createElement("path", { d: "M699.57 372.727L690.764 499.489C690.764 499.489 684.006 550.48 684.006 566.658C684.006 582.631 686.259 644.272 686.259 644.272H717.591L749.537 425.152C749.537 425.152 752.814 422.49 753.224 425.152C753.633 427.814 771.859 506.247 773.702 518.943C775.136 528.978 786.808 641.609 786.808 641.609L813.84 640.381C813.84 640.381 816.297 538.808 814.454 506.247L809.744 394.025L803.191 362.283L714.724 359.007L699.57 372.727Z", fill: "#263238" }),
	      React.createElement("path", { d: "M783.737 417.168C783.737 417.372 772.064 419.42 757.524 421.673C742.984 423.925 731.107 425.359 731.107 425.154C731.107 424.949 742.78 422.901 757.319 420.649C771.859 418.396 783.737 416.758 783.737 417.168Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M720.253 511.165C720.457 511.37 715.133 514.442 708.785 518.538C702.436 522.633 697.726 526.524 697.522 526.319C697.317 526.115 701.822 521.814 708.17 517.718C714.519 513.418 720.048 510.96 720.253 511.165Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M808.105 510.342C808.105 510.751 802.781 509.522 796.228 510.342C789.675 511.161 784.965 513.823 784.76 513.618C784.555 513.413 789.265 510.137 796.023 509.318C802.986 508.294 808.31 509.932 808.105 510.342Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M767.763 200.706C767.763 200.706 766.944 200.706 765.51 200.706C764.077 200.706 761.824 200.502 759.162 200.092C756.5 199.682 753.223 198.863 749.946 197.43C746.67 195.792 743.393 193.334 741.141 189.648C738.888 185.962 738.069 182.071 737.455 178.59C736.84 175.108 736.635 171.832 736.021 169.17C735.202 163.845 733.768 160.773 733.973 160.773C733.973 160.773 734.383 161.388 734.997 162.821C735.612 164.255 736.226 166.303 736.84 168.965C737.455 171.627 737.864 174.699 738.479 178.18C739.093 181.661 739.912 185.552 741.96 188.829C744.008 192.31 747.079 194.563 750.151 196.201C753.223 197.839 756.295 198.659 758.957 199.068C764.486 200.297 767.763 200.502 767.763 200.706Z", fill: "#263238" }),
	      React.createElement("path", { d: "M753.632 109.985L754.451 109.78C756.704 105.48 761.414 103.022 766.328 102.613C771.038 102.408 775.953 104.251 779.435 107.527C781.892 109.78 783.94 112.442 786.397 114.695C788.855 116.948 792.336 118.586 795.613 117.767C796.022 118.995 793.77 119.61 793.974 121.043C793.974 121.658 794.589 122.067 795.203 122.067C796.022 122.272 797.046 122.067 797.865 122.067C798.684 122.067 799.708 122.477 799.913 123.296C800.118 123.705 799.913 124.115 799.708 124.525C798.684 128.416 797.046 132.102 794.384 134.969C791.722 137.836 787.626 139.474 783.735 138.86C780.663 138.245 778.001 136.197 775.544 134.354C770.834 130.668 766.328 126.982 761.618 123.091C759.571 121.453 757.318 119.61 755.68 117.357C754.246 115.514 753.017 112.647 753.632 109.985Z", fill: "#263238" }),
	      React.createElement("path", { d: "M756.499 110.807C754.656 109.374 752.403 108.145 749.946 107.53C747.488 107.121 745.031 107.53 742.983 108.964C741.14 110.193 740.116 112.445 738.682 114.288C737.454 116.131 735.611 117.974 733.358 118.384C732.948 118.384 732.539 118.384 732.334 118.794C731.925 119.203 732.129 120.227 732.744 120.432C733.358 120.637 734.177 120.637 734.792 120.432C733.768 121.661 732.129 122.685 730.491 122.889C730.901 124.528 732.744 125.756 734.382 125.142C733.768 127.804 733.153 130.466 733.153 133.129C733.153 135.791 733.972 138.658 735.815 140.706C737.863 142.958 741.14 144.187 741.959 147.054", fill: "#263238" }),
	      React.createElement("path", { d: "M775.953 206.653L739.706 206.243L743.801 175.321C743.801 175.321 741.344 174.707 741.139 161.396C740.934 147.88 740.32 125.149 740.32 125.149C755.884 118.391 773.905 120.643 787.216 131.087L789.264 132.521L775.953 206.653Z", fill: "#FFBE9D" }),
	      React.createElement("path", { d: "M785.168 148.911C785.373 148.911 794.384 146.248 794.179 155.464C793.974 164.679 784.759 162.426 784.759 162.222C784.554 161.812 785.168 148.911 785.168 148.911Z", fill: "#FFBE9D" }),
	      React.createElement("path", { d: "M741.961 146.847C741.756 146.847 733.564 144.594 733.769 153.81C733.974 163.025 743.189 160.772 743.189 160.568C743.189 160.363 741.961 146.847 741.961 146.847Z", fill: "#FFBE9D" }),
	      React.createElement("path", { d: "M788.035 147.874C786.602 155.655 787.011 159.546 785.578 164.871C783.53 173.062 779.434 179.206 772.267 183.301C764.895 187.397 755.065 187.397 748.717 181.663C744.416 177.772 741.14 173.472 740.525 167.738C739.911 162.004 738.273 151.15 738.068 145.211C738.068 134.767 738.273 125.347 738.273 125.347L768.376 119.818L785.373 130.057L788.035 147.874Z", fill: "#263238" }),
	      React.createElement("path", { d: "M757.114 187.799C757.114 188.004 759.367 188.619 762.439 188.209C765.306 187.799 767.558 186.775 767.558 186.571C767.558 186.366 765.306 186.98 762.439 187.39C759.572 187.799 757.114 187.595 757.114 187.799Z", fill: "#263238" }),
	      React.createElement("path", { d: "M786.602 160.975C787.421 152.988 788.035 143.978 789.264 135.786C789.673 132.715 790.902 128.209 790.492 124.933C790.288 121.861 789.264 122.68 788.035 119.813C786.192 116.332 779.639 113.874 775.748 113.055C771.857 112.236 771.448 108.96 768.376 111.622C766.123 108.345 761.823 106.707 758.137 107.526C754.246 108.345 751.174 111.827 750.764 115.717C748.716 113.67 745.03 113.26 742.573 114.898C740.115 116.332 738.682 119.813 739.501 122.475C737.248 122.885 735.405 124.318 734.586 126.366C733.767 128.414 733.972 130.872 734.996 132.715C736.429 134.762 738.887 135.991 740.525 138.039C742.368 140.292 742.573 143.773 740.935 146.435", fill: "#263238" }),
	      React.createElement("path", { d: "M747.898 159.335C747.693 159.335 747.284 163.022 748.922 167.322C750.56 171.622 753.427 174.285 753.427 174.08C753.632 173.875 751.175 171.213 749.741 167.117C748.308 163.022 748.308 159.335 747.898 159.335Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M744.007 152.571C743.802 152.571 742.573 155.848 743.392 159.943C744.212 164.039 746.464 166.701 746.464 166.496C746.669 166.292 744.826 163.629 744.212 159.739C743.392 155.848 744.212 152.571 744.007 152.571Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M790.903 141.93C790.903 141.93 795.817 141.93 797.251 144.183C798.684 146.436 796.841 163.637 794.998 165.071C793.155 166.504 785.578 164.252 785.578 164.252C785.578 164.252 788.65 147.05 787.421 142.545L790.903 141.93Z", fill: "#3B53A7" }),
	      React.createElement("path", { d: "M733.768 140.709C733.768 140.709 730.287 141.937 728.853 144.19C727.42 146.443 729.058 162.416 730.901 163.849C732.744 165.283 740.321 163.03 740.321 163.03C740.321 163.03 737.249 145.009 738.478 140.709H733.768Z", fill: "#3B53A7" }),
	      React.createElement("path", { d: "M733.768 140.702C733.768 140.702 735.406 111.008 763.667 110.598C791.722 110.189 792.337 142.135 792.337 142.135L788.036 142.545C788.036 142.545 789.06 113.465 764.895 112.441C740.526 111.417 736.635 139.678 738.478 140.702H733.768Z", fill: "#3B53A7" }),
	      React.createElement("path", { d: "M781.687 120.835C779.435 117.149 776.363 114.078 772.267 112.439C768.376 110.801 763.461 111.211 760.185 113.873", fill: "#263238" }),
	      React.createElement("path", { d: "M781.074 141.116C780.869 141.116 781.074 140.092 781.278 138.454C781.483 136.816 781.893 134.563 781.893 132.106C781.893 129.648 781.278 127.395 780.459 125.962C779.64 124.528 779.026 123.709 779.231 123.709C779.231 123.709 780.254 124.119 781.278 125.757C782.302 127.191 783.122 129.648 783.122 132.31C783.122 134.973 782.507 137.225 782.098 138.863C781.483 140.297 781.074 141.116 781.074 141.116Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M774.724 144.183C774.519 143.978 775.134 142.135 775.953 139.882C776.772 137.63 777.181 135.787 777.386 135.787C777.591 135.787 777.591 137.835 776.977 140.292C776.158 142.545 774.929 144.388 774.724 144.183Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M746.055 141.726C746.055 141.726 744.826 140.702 744.007 138.45C742.983 136.197 742.369 132.716 743.188 129.03C744.007 125.344 745.85 122.477 747.693 120.838C749.331 119.2 750.765 118.586 750.765 118.586C750.765 118.79 749.741 119.61 748.103 121.248C746.669 122.886 744.826 125.753 744.212 129.234C743.597 132.716 744.007 135.992 744.826 138.04C745.236 140.498 746.055 141.726 746.055 141.726Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M778.82 107.522C778.82 107.727 777.591 107.113 775.953 106.294C774.11 105.474 771.653 104.451 768.786 104.451C765.919 104.451 763.461 105.884 762.232 107.318C761.004 108.751 760.799 109.98 760.594 109.98C760.389 109.98 760.389 108.546 761.618 106.908C762.232 106.089 763.256 105.27 764.485 104.655C765.714 104.041 767.147 103.631 768.786 103.631C772.062 103.631 774.724 104.86 776.363 105.884C777.796 106.703 778.82 107.522 778.82 107.522Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M737.659 116.134C737.455 116.134 737.659 115.11 738.683 113.676C739.707 112.243 741.55 110.604 744.008 109.99C746.465 109.171 748.923 109.58 750.356 110.4C751.994 111.014 752.609 111.833 752.609 111.833C752.609 112.038 751.585 111.424 750.151 111.014C748.718 110.604 746.465 110.4 744.213 111.014C741.96 111.628 740.322 113.062 739.298 114.086C738.274 115.314 737.864 116.134 737.659 116.134Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M747.693 149.925C747.693 149.72 749.126 149.311 751.583 148.287C754.041 147.263 757.317 145.42 760.389 142.348L762.027 140.71L761.004 142.962C760.389 144.396 759.98 145.829 759.775 147.263C759.57 148.082 759.57 148.901 759.775 149.106C759.98 149.311 760.799 148.901 761.413 148.492C763.871 146.853 765.918 145.01 767.557 142.962L769.195 141.119L768.376 143.577C767.557 146.034 766.942 148.082 766.328 150.13L765.714 149.72C770.014 145.829 771.448 142.143 771.652 142.348C771.652 142.348 771.448 143.372 770.628 144.805C769.809 146.239 768.376 148.287 766.328 150.335L765.304 151.359L765.714 149.72C766.328 147.672 766.942 145.42 767.557 143.167L768.376 143.577C766.738 145.625 764.485 147.672 762.027 149.311C761.618 149.516 761.413 149.72 760.799 149.925C760.389 150.13 759.57 150.335 759.161 149.925C758.546 149.516 758.546 148.696 758.546 148.287C758.546 147.877 758.751 147.468 758.751 147.058C758.956 145.42 759.57 143.782 760.184 142.553L761.004 143.167C757.727 146.239 754.246 148.082 751.583 149.106C749.126 149.72 747.693 149.925 747.693 149.925Z", fill: "#455A64" }),
	      React.createElement("path", { d: "M765.1 114.495C764.486 113.471 763.462 112.652 762.233 112.242C761.004 111.832 759.776 111.832 758.547 112.242C755.475 112.856 752.608 114.495 750.765 116.747C750.356 117.362 749.946 118.181 750.356 118.59C750.56 118.795 750.97 119 751.38 119C755.885 119.41 760.39 119.205 764.895 118.59", fill: "#263238" }),
	      React.createElement("path", { d: "M736.431 164.249C736.226 164.249 734.588 159.13 733.768 152.781C732.949 146.228 733.359 140.904 733.564 140.904C733.973 140.904 733.973 146.228 734.792 152.577C735.612 158.925 736.84 164.249 736.431 164.249Z", fill: "#263238" }),
	      React.createElement("path", { d: "M788.445 164.868C788.24 164.868 789.06 163.64 789.879 161.797C790.698 159.954 791.517 157.087 791.927 153.81C792.336 150.534 792.336 147.667 792.336 145.619C792.336 143.571 792.336 142.137 792.541 142.137C792.746 142.137 792.95 143.366 793.155 145.619C793.36 147.667 793.36 150.738 792.95 154.015C792.541 157.291 791.517 160.158 790.493 162.206C789.469 164.049 788.65 165.073 788.445 164.868Z", fill: "#263238" }),
	      React.createElement("path", { d: "M785.783 197.838C785.578 197.838 785.783 195.995 785.988 193.128C786.193 190.261 786.602 186.165 787.012 181.66C787.421 177.155 787.626 173.059 787.831 170.192C788.036 167.325 788.241 165.482 788.241 165.482C788.445 165.482 788.445 167.325 788.445 170.192C788.445 173.264 788.241 177.359 788.036 181.865C787.626 186.37 787.217 190.466 786.602 193.333C786.397 195.995 785.783 197.838 785.783 197.838Z", fill: "#263238" }),
	      React.createElement("path", { d: "M787.627 143.157C787.422 142.953 789.674 141.724 792.337 141.929C795.204 142.134 797.047 143.362 797.047 143.567C796.842 143.772 794.999 143.157 792.337 142.953C789.674 142.748 787.627 143.362 787.627 143.157Z", fill: "#263238" }),
	      React.createElement("path", { d: "M728.443 145.01C728.238 145.01 728.443 144.191 729.057 143.371C729.672 142.348 730.9 141.324 732.539 140.504C734.177 139.89 735.815 139.685 736.839 139.89C737.863 140.095 738.682 140.3 738.478 140.504C738.478 140.914 735.815 140.095 732.744 141.528C730.081 142.757 728.648 145.214 728.443 145.01Z", fill: "#263238" }),
	      React.createElement("path", { d: "M814.044 252.318C812.61 253.751 802.576 305.971 801.552 316.211C800.528 326.45 813.429 368.635 805.852 378.875L801.552 380.103H698.955L707.76 308.838L703.665 249.246L704.484 212.385L734.792 198.869H779.23C779.23 198.869 818.549 222.01 818.549 225.286C818.549 228.563 814.044 252.318 814.044 252.318Z", fill: "#3B53A7" }),
	      React.createElement("path", { d: "M699.57 374.778C699.57 374.778 699.57 374.368 699.57 373.344C699.57 372.525 699.775 371.092 699.775 369.453C699.98 366.177 700.594 361.262 701.208 355.323C702.642 343.446 704.69 326.858 707.147 308.428V308.632C707.147 307.813 706.942 306.789 706.942 305.97C705.099 286.925 704.075 269.518 703.051 257.027C702.642 250.883 702.232 245.763 701.823 242.282C701.618 240.644 701.618 239.21 701.618 238.186C701.618 237.162 701.618 236.753 701.618 236.753C701.618 236.753 701.823 237.162 701.823 238.186C702.027 239.21 702.027 240.644 702.232 242.282C702.642 245.763 703.051 250.883 703.666 257.027C704.894 269.518 706.123 286.925 707.966 305.97C707.966 306.994 708.171 307.813 708.171 308.632C705.714 326.858 703.461 343.446 702.027 355.323C701.208 361.262 700.594 365.972 700.184 369.453C699.98 371.092 699.775 372.32 699.775 373.344C699.57 374.368 699.57 374.778 699.57 374.778Z", fill: "#263238" }),
	      React.createElement("path", { d: "M803.805 381.334C803.805 381.334 804.009 380.924 804.624 380.31C805.238 379.695 805.852 378.671 806.672 377.238C807.491 375.804 808.31 373.961 808.515 371.709C808.719 369.456 808.105 366.794 807.695 363.927C805.852 352.254 803.19 336.076 800.118 317.646C800.733 314.779 801.347 311.707 801.757 308.43C805.238 287.952 807.695 269.316 809.743 255.801C810.767 249.247 811.382 243.718 811.996 239.827C812.201 237.984 812.406 236.551 812.61 235.527C812.815 234.503 812.815 234.093 812.815 234.093C812.815 234.093 812.815 234.708 812.815 235.527C812.61 236.551 812.61 237.984 812.405 239.827C811.996 243.718 811.177 249.247 810.358 255.801C808.515 269.316 806.262 287.952 802.781 308.43C802.166 311.502 801.757 314.779 801.142 317.646V317.441C804.214 335.667 806.876 352.049 808.515 363.722C808.924 366.589 809.334 369.251 809.129 371.709C808.924 374.166 807.9 376.009 807.081 377.443C806.262 378.876 805.443 379.9 804.828 380.514C804.214 381.129 803.805 381.334 803.805 381.334Z", fill: "#263238" }),
	      React.createElement("path", { d: "M787.013 196.209C786.194 194.775 784.351 193.751 782.712 194.366C783.531 192.522 781.074 190.475 779.026 190.679C776.978 190.884 775.135 192.318 773.497 193.342C765.92 198.461 755.271 198.666 747.285 194.161C743.803 192.113 740.527 189.041 736.431 189.246C731.926 189.451 728.649 193.342 725.987 197.028C724.553 198.871 723.12 201.328 724.144 203.581L725.782 203.376C729.059 212.182 732.335 221.602 739.708 227.745C748.513 235.118 762.234 235.937 772.268 230.203C782.303 224.469 788.446 212.796 788.242 201.123C788.037 199.485 787.832 197.642 787.013 196.209Z", fill: "#3B53A7" }),
	      React.createElement("path", { d: "M788.241 204.398C788.241 204.398 788.241 204.808 788.036 205.422C787.831 206.037 787.627 207.061 787.422 208.289C786.807 210.747 785.579 214.228 783.736 218.324C781.688 222.42 778.821 226.925 774.111 230.816C771.858 232.659 768.991 234.297 765.919 235.526C762.848 236.55 759.366 237.164 755.885 236.754C752.404 236.345 749.127 235.321 746.26 233.887C743.393 232.454 740.526 230.816 738.273 228.973C735.816 227.13 733.973 225.082 732.54 222.829C731.106 220.576 730.082 218.324 729.263 216.276C727.625 211.976 726.806 208.494 725.986 206.242C725.167 203.784 724.553 202.555 724.758 202.555C724.758 202.555 724.962 202.76 725.167 203.375C725.372 203.989 725.782 204.808 726.396 206.037C727.42 208.289 728.444 211.771 730.082 215.866C730.901 217.914 731.925 220.167 733.359 222.215C734.792 224.263 736.84 226.31 739.093 228.154C741.345 229.997 744.007 231.43 746.874 232.864C749.741 234.297 752.813 235.321 756.09 235.731C759.366 236.14 762.643 235.731 765.715 234.707C768.582 233.683 771.244 232.044 773.701 230.406C778.206 226.72 781.278 222.215 783.326 218.324C785.374 214.433 786.603 210.952 787.217 208.699C787.831 205.832 788.241 204.398 788.241 204.398Z", fill: "#263238" }),
	      React.createElement(
	        "g",
	        { opacity: "0.3" },
	        React.createElement("path", { d: "M778.003 191.908C776.569 191.089 775.34 192.318 773.907 193.342C769.607 197.028 762.849 197.847 757.319 197.232C751.995 196.618 747.285 195.185 742.78 191.499C741.346 190.475 739.708 189.655 738.07 189.451C736.636 189.246 734.998 189.86 734.179 191.089C736.636 191.703 738.274 194.161 739.298 196.209C741.346 199.895 742.575 203.99 744.418 207.881C746.261 211.772 748.514 215.458 751.79 218.121C755.067 220.783 759.777 222.011 763.872 220.373C767.149 219.144 769.606 216.073 771.45 213.001C774.726 207.881 777.184 202.352 778.822 196.618C779.231 194.98 779.436 192.727 778.003 191.908Z", fill: "black" })
	      ),
	      React.createElement("path", { d: "M780.254 193.957C780.254 193.957 779.845 194.981 779.026 196.824C778.206 198.668 777.387 201.33 776.363 204.606C775.339 207.883 774.111 211.978 771.244 215.869C769.81 217.712 767.967 219.556 765.51 220.579C763.257 221.808 760.185 222.013 757.523 221.194C754.861 220.375 752.608 218.941 750.765 217.098C748.922 215.255 747.489 213.207 746.465 211.159C744.212 207.064 742.983 202.968 741.345 199.896C739.912 196.824 738.273 194.367 736.84 192.934C735.611 191.5 734.587 190.886 734.792 190.886C734.792 190.886 734.997 191.09 735.406 191.295C735.816 191.5 736.43 192.114 737.249 192.729C738.683 194.162 740.526 196.415 742.164 199.487C743.803 202.558 745.236 206.654 747.489 210.545C748.513 212.593 749.946 214.641 751.584 216.279C753.223 217.917 755.475 219.556 757.933 220.17C760.39 220.784 763.052 220.579 765.1 219.556C767.353 218.532 768.991 216.893 770.425 215.05C773.292 211.569 774.52 207.473 775.749 204.197C776.773 200.92 777.797 198.258 778.821 196.415C779.23 195.596 779.64 194.777 779.845 194.367C780.049 193.957 780.254 193.753 780.254 193.957Z", fill: "#263238" }),
	      React.createElement("path", { d: "M781.074 209.314C781.074 209.314 781.074 210.133 780.664 211.361C780.255 212.59 779.436 214.433 778.002 216.276C775.34 220.167 770.015 224.672 762.643 225.901C755.271 227.13 748.718 224.468 745.032 221.601C743.189 220.167 741.755 218.734 740.936 217.71C740.117 216.686 739.707 216.071 739.912 216.071C740.117 215.867 741.755 218.324 745.441 220.986C749.127 223.444 755.476 225.901 762.438 224.877C769.401 223.649 774.521 219.348 777.183 215.662C780.05 212.181 780.869 209.314 781.074 209.314Z", fill: "#263238" }),
	      React.createElement("path", { d: "M798.275 340.79C798.275 340.79 798.07 340.79 797.456 340.994C796.842 340.994 796.023 341.199 794.999 341.199C792.951 341.199 789.879 340.994 786.193 340.38C782.507 339.766 778.206 338.537 773.496 336.489C768.991 334.646 764.076 331.984 759.161 329.117C749.332 323.178 740.731 317.649 734.382 313.553C731.311 311.505 728.853 309.867 727.01 308.638C725.372 307.41 724.348 306.795 724.348 306.795C724.348 306.795 725.372 307.205 727.215 308.434C729.263 309.662 731.72 311.096 734.792 312.939C741.14 316.83 749.946 322.359 759.571 328.298C764.486 331.165 769.196 333.827 773.701 335.67C778.206 337.513 782.507 338.947 785.988 339.766C789.674 340.585 792.541 340.79 794.589 340.994C797.046 340.79 798.275 340.79 798.275 340.79Z", fill: "#263238" }),
	      React.createElement(
	        "g",
	        { opacity: "0.3" },
	        React.createElement("path", { d: "M728.854 309.251L728.035 309.455C738.069 315.599 748.104 321.538 758.138 327.681C765.715 332.186 773.497 336.897 782.098 338.535C767.149 324.609 748.718 314.37 728.854 309.251Z", fill: "black" })
	      ),
	      React.createElement(
	        "g",
	        { opacity: "0.3" },
	        React.createElement("path", { d: "M725.782 203.58C725.782 217.3 733.359 230.816 745.031 238.188C749.127 240.851 754.042 242.694 758.957 242.284C763.872 241.875 768.377 239.417 771.858 236.141C775.34 232.659 777.797 228.564 779.845 224.058C775.34 230.202 767.967 234.297 760.39 235.117C752.813 235.936 744.827 233.683 739.093 228.768C731.516 222.42 727.829 212.795 725.372 203.17", fill: "black" })
	      ),
	      React.createElement(
	        "g",
	        { opacity: "0.3" },
	        React.createElement("path", { d: "M743.803 220.989C748.718 225.699 755.271 228.566 762.029 228.157C768.787 227.747 775.135 223.446 777.387 217.098C773.292 221.808 767.353 224.88 761.209 225.494C755.066 226.109 748.513 224.266 743.803 220.375", fill: "black" })
	      ),
	      React.createElement("path", { d: "M727.215 215.051C727.215 215.051 725.577 215.46 722.915 215.87C720.253 216.279 716.567 216.894 712.676 217.508C708.58 218.327 705.099 218.942 702.436 219.556C699.774 220.17 698.136 220.375 698.136 220.375C698.136 220.375 698.546 220.17 699.16 219.966C699.774 219.761 701.003 219.351 702.232 219.146C704.894 218.532 708.375 217.713 712.471 216.894C716.567 216.075 720.253 215.665 722.915 215.46C724.144 215.255 725.372 215.256 725.987 215.256C726.806 215.051 727.215 215.051 727.215 215.051Z", fill: "white" }),
	      React.createElement("path", { d: "M739.298 198.26C739.298 198.465 735.612 199.079 732.335 202.151C729.059 205.223 728.035 208.909 727.83 208.704C727.83 208.704 727.83 207.68 728.444 206.451C729.059 205.018 730.083 203.175 731.721 201.741C733.359 200.103 735.202 199.079 736.636 198.67C738.274 198.26 739.298 198.26 739.298 198.26Z", fill: "white" }),
	      React.createElement("path", { d: "M742.984 219.35C742.984 219.555 741.346 220.374 739.707 222.217C738.069 223.855 737.25 225.698 737.045 225.698C736.84 225.698 737.455 223.65 739.093 221.807C741.141 219.76 742.984 219.145 742.984 219.35Z", fill: "white" }),
	      React.createElement("path", { d: "M748.514 214.228C748.514 214.432 747.08 214.842 745.442 215.866C743.804 216.89 742.78 218.119 742.575 217.914C742.37 217.914 743.394 216.48 745.032 215.252C746.875 214.228 748.514 214.228 748.514 214.228Z", fill: "white" }),
	      React.createElement("path", { d: "M756.295 235.121C756.295 235.326 754.656 233.483 754.452 230.82C754.247 228.158 755.476 226.315 755.68 226.315C755.885 226.315 754.861 228.363 755.066 230.82C755.271 233.278 756.499 234.916 756.295 235.121Z", fill: "white" }),
	      React.createElement("path", { d: "M764.691 224.675C764.691 224.879 763.872 224.47 763.667 223.446C763.462 222.422 763.872 221.808 764.076 221.808C764.281 221.808 764.076 222.627 764.281 223.241C764.281 224.06 764.691 224.47 764.691 224.675Z", fill: "white" }),
	      React.createElement("path", { d: "M774.725 227.542C774.521 227.542 775.34 226.108 774.93 224.47C774.521 222.832 773.292 222.012 773.497 221.808C773.497 221.808 773.906 221.808 774.316 222.217C774.725 222.627 775.34 223.446 775.545 224.265C775.749 225.289 775.545 226.108 775.34 226.723C774.93 227.337 774.725 227.746 774.725 227.542Z", fill: "white" }),
	      React.createElement("path", { d: "M779.026 214.236C778.821 214.236 778.617 212.802 776.978 211.983C775.545 211.164 774.111 211.983 774.111 211.778C774.111 211.778 774.316 211.369 774.931 211.164C775.545 210.959 776.569 210.959 777.388 211.369C778.207 211.778 778.821 212.597 779.026 213.212C779.231 213.826 779.231 214.236 779.026 214.236Z", fill: "white" }),
	      React.createElement("path", { d: "M785.579 208.496C785.374 208.496 785.374 207.882 785.169 206.858C784.76 205.834 784.145 204.605 782.917 203.582C781.688 202.558 780.459 202.148 779.435 201.943C778.411 201.739 777.797 201.943 777.797 201.739C777.797 201.739 778.411 201.329 779.435 201.534C780.459 201.534 782.097 202.148 783.326 203.172C784.555 204.196 785.374 205.629 785.579 206.653C785.784 207.882 785.784 208.496 785.579 208.496Z", fill: "white" }),
	      React.createElement("path", { d: "M809.743 242.078C809.743 242.078 809.334 242.078 808.719 242.078C807.9 242.078 806.876 242.078 805.647 242.078C802.78 242.078 798.89 241.873 794.18 241.873C784.555 241.668 771.244 241.463 756.499 241.668C741.755 241.668 728.444 242.078 718.819 242.283C714.109 242.487 710.218 242.487 707.351 242.692C706.122 242.692 705.098 242.692 704.279 242.692C703.665 242.692 703.255 242.692 703.255 242.692C703.255 242.692 703.665 242.692 704.279 242.487C705.098 242.487 706.122 242.283 707.351 242.283C710.218 242.078 714.109 242.078 718.819 241.668C728.444 241.259 741.755 241.054 756.499 240.849C771.244 240.849 784.555 241.054 794.18 241.259C798.89 241.463 802.78 241.668 805.647 241.668C806.876 241.668 807.9 241.873 808.719 241.873C809.334 241.873 809.743 241.873 809.743 242.078Z", fill: "white" }),
	      React.createElement("path", { d: "M807.696 218.936C807.696 218.936 806.467 218.731 804.624 218.526C802.781 218.117 799.914 217.707 797.047 217.298C793.975 216.888 791.313 216.683 789.47 216.479C787.422 216.274 786.398 216.069 786.398 216.069C786.398 216.069 787.627 215.864 789.675 216.069C791.723 216.069 794.385 216.274 797.457 216.683C800.528 217.093 803.19 217.707 805.034 218.117C806.672 218.322 807.696 218.731 807.696 218.936Z", fill: "white" }),
	      React.createElement("path", { d: "M806.057 271.565C806.057 271.565 805.648 271.565 805.033 271.77C804.214 271.77 803.19 271.975 802.166 271.975C799.709 272.18 796.023 272.384 791.517 272.589C782.507 272.999 770.015 273.408 756.09 273.408C742.369 273.408 729.877 273.204 720.662 272.794C716.157 272.589 712.471 272.384 710.013 272.384C708.784 272.384 707.965 272.18 707.146 272.18C706.532 272.18 706.122 272.18 706.122 271.975C706.122 271.975 706.532 271.975 707.146 271.975C707.965 271.975 708.989 271.975 710.013 271.975C712.675 271.975 716.362 272.18 720.662 272.18C729.673 272.384 742.164 272.589 756.09 272.589C769.81 272.589 782.302 272.18 791.313 271.975C795.613 271.77 799.299 271.77 801.961 271.565C803.19 271.565 804.009 271.565 804.828 271.565C805.648 271.565 806.057 271.565 806.057 271.565Z", fill: "white" }),
	      React.createElement("path", { d: "M802.781 303.509C802.781 303.509 802.371 303.509 801.757 303.509C800.938 303.509 800.119 303.509 799.095 303.714C796.637 303.918 793.361 303.918 789.06 304.123C780.664 304.328 768.786 304.533 755.885 304.328C742.984 304.123 731.311 303.714 722.71 303.304C718.41 303.099 715.133 302.895 712.675 302.69C711.652 302.69 710.628 302.485 710.013 302.485C709.399 302.485 708.989 302.485 708.989 302.28C708.989 302.28 709.399 302.28 710.013 302.28C710.832 302.28 711.652 302.28 712.675 302.28C715.133 302.28 718.614 302.485 722.71 302.69C731.106 303.099 742.984 303.304 755.885 303.509C768.786 303.714 780.459 303.714 789.06 303.509C793.156 303.509 796.637 303.509 799.095 303.304C800.119 303.304 801.142 303.304 801.757 303.304C802.371 303.509 802.781 303.509 802.781 303.509Z", fill: "white" }),
	      React.createElement("path", { d: "M752.609 326.653C752.609 326.653 751.994 326.858 750.766 326.858C749.537 327.062 747.899 327.062 745.646 327.267C741.346 327.472 735.407 327.677 728.854 327.472C722.301 327.267 716.362 326.858 712.061 326.448C709.809 326.243 708.17 326.038 706.942 325.834C705.713 325.629 705.099 325.629 705.099 325.424C705.099 325.424 705.713 325.424 706.942 325.424C708.375 325.629 710.014 325.629 712.061 325.834C716.362 326.243 722.301 326.448 728.854 326.653C735.407 326.858 741.346 326.653 745.646 326.653C747.694 326.653 749.332 326.653 750.766 326.448C751.994 326.448 752.609 326.653 752.609 326.653Z", fill: "white" }),
	      React.createElement("path", { d: "M803.191 329.319C803.191 329.319 802.577 329.524 801.757 329.729C800.734 329.934 799.505 330.139 797.662 330.343C794.18 330.753 789.47 331.367 784.146 331.777C778.822 332.186 774.112 332.186 770.63 331.982C768.992 331.982 767.558 331.982 766.535 331.777C765.511 331.777 765.101 331.572 765.101 331.572C765.101 331.572 765.715 331.572 766.535 331.572C767.763 331.572 769.197 331.572 770.63 331.572C774.112 331.572 778.822 331.367 784.146 331.162C789.47 330.753 794.18 330.343 797.662 329.934C799.095 329.729 800.529 329.524 801.757 329.524C802.577 329.319 803.191 329.115 803.191 329.319Z", fill: "white" }),
	      React.createElement("path", { d: "M805.647 360.24C805.647 360.24 805.238 360.24 804.623 360.444C803.804 360.444 802.78 360.649 801.756 360.854C799.094 361.059 795.408 361.468 790.903 361.673C781.688 362.287 768.786 362.697 754.656 362.287C740.526 361.878 727.829 360.649 718.614 359.42C714.109 358.806 710.218 358.192 707.76 357.782C706.532 357.577 705.712 357.373 704.893 357.373C704.279 357.168 703.869 357.168 703.869 357.168C703.869 357.168 704.279 357.168 704.893 357.168C705.712 357.373 706.736 357.373 707.76 357.577C710.422 357.987 714.109 358.397 718.614 359.011C727.829 360.035 740.526 361.264 754.656 361.673C768.786 362.083 781.483 361.878 790.903 361.264C795.613 361.059 799.299 360.854 801.756 360.649C802.985 360.649 804.009 360.444 804.828 360.444C805.238 360.24 805.647 360.24 805.647 360.24Z", fill: "white" })
	    ),
	    React.createElement(
	      "defs",
	      null,
	      React.createElement(
	        "clipPath",
	        { id: "clip0_4242_34229" },
	        React.createElement("rect", { width: "1515", height: "915.592", fill: "white", transform: "translate(0.435547 0.433594)" })
	      )
	    )
	  );
	}
	
	var _default = Thinking;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Thinking, "Thinking", "D:/a/1/s/src/web/employee/src/images/Thinking.js");
	
	  __REACT_HOT_LOADER__.register(_default, "default", "D:/a/1/s/src/web/employee/src/images/Thinking.js");
	}();

	;

/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactHotLoader = __webpack_require__(1657);
	
	__webpack_require__(458);
	
	__webpack_require__(1050);
	
	__webpack_require__(1306);
	
	__webpack_require__(814);
	
	var _Root = __webpack_require__(921);
	
	var _Root2 = _interopRequireDefault(_Root);
	
	var _configureStore = __webpack_require__(1022);
	
	var _configureStore2 = _interopRequireDefault(_configureStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Routes from './routes';
	__webpack_require__(1834);
	
	/* Polyfill for fetch */
	
	/* Date polyfill */
	/* eslint global-require: 0 */
	
	__webpack_require__(1033);
	
	var store = (0, _configureStore2.default)();
	
	var runApp = function runApp() {
	  (0, _reactDom.render)(_react2.default.createElement(
	    _reactHotLoader.AppContainer,
	    null,
	    _react2.default.createElement(_Root2.default, {
	      store: store
	    })
	  ), document.getElementById('app'));
	
	  if (false) {
	    module.hot.accept('./containers/Root', function () {
	      var RootContainer = require('./containers/Root').default;
	
	      (0, _reactDom.render)(_react2.default.createElement(
	        _reactHotLoader.AppContainer,
	        null,
	        _react2.default.createElement(RootContainer, {
	          store: store
	        })
	      ), document.getElementById('app'));
	    });
	  }
	};
	
	if (!global.Intl) {
	  __webpack_require__.e/* nsure */(1, function (require) {
	    __webpack_require__(525);
	    __webpack_require__(526);
	    __webpack_require__(527);
	    runApp();
	  });
	} else {
	  runApp();
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(store, 'store', 'D:/a/1/s/src/web/employee/src/index.js');
	
	  __REACT_HOT_LOADER__.register(runApp, 'runApp', 'D:/a/1/s/src/web/employee/src/index.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.trackingIsActive = exports.withTracking = exports.appInsights = exports.reactPlugin = undefined;
	
	var _applicationinsightsWeb = __webpack_require__(823);
	
	var _applicationinsightsReactJs = __webpack_require__(822);
	
	var _config = __webpack_require__(54);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Boolean value that denotes whether or no tracking should take place.
	 */
	var trackingIsActive = Boolean(_config.applicationInsightsInstrumentationKey && ("production") === 'production');
	
	var reactPlugin = new _applicationinsightsReactJs.ReactPlugin();
	
	var appInsights = function appInsights() {
	  return new _applicationinsightsWeb.ApplicationInsights({
	    config: {
	      instrumentationKey: _config.applicationInsightsInstrumentationKey,
	      distributedTracingMode: _applicationinsightsWeb.DistributedTracingModes.W3C,
	      enableCorsCorrelation: true,
	      extensions: [reactPlugin],
	      extensionConfig: _defineProperty({}, reactPlugin.identifier, {})
	    }
	  });
	};
	
	/**
	 * Helper function to ensure all components are wrapped the same.
	 * @param {Component} component the component being wrapped
	 * @param {String} componentName the name of the component, required if the component is pure
	 */
	var withTracking = function withTracking(component, componentName) {
	  if (trackingIsActive) {
	    return (0, _applicationinsightsReactJs.withAITracking)(reactPlugin, component, componentName);
	  }
	  return component;
	};
	
	exports.reactPlugin = reactPlugin;
	exports.appInsights = appInsights;
	exports.withTracking = withTracking;
	exports.trackingIsActive = trackingIsActive;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(trackingIsActive, 'trackingIsActive', 'D:/a/1/s/src/web/employee/src/insights/index.js');
	
	  __REACT_HOT_LOADER__.register(reactPlugin, 'reactPlugin', 'D:/a/1/s/src/web/employee/src/insights/index.js');
	
	  __REACT_HOT_LOADER__.register(appInsights, 'appInsights', 'D:/a/1/s/src/web/employee/src/insights/index.js');
	
	  __REACT_HOT_LOADER__.register(withTracking, 'withTracking', 'D:/a/1/s/src/web/employee/src/insights/index.js');
	}();

	;

/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = AgreementsReducer;
	
	var _ActionTypes = __webpack_require__(18);
	
	var initState = {
	  agreementsByID: {},
	  hasError: false,
	  agreementsLoading: false,
	  agreementsError: null
	};
	
	function AgreementsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.UPDATE_AGREEMENT_ANSWERS:
	      {
	        var newAgreementsByID = state.agreementsByID;
	        var newAnswer = action.newAnswer;
	        newAgreementsByID[newAnswer.EmployeeDetailID].answers[newAnswer.AgreementID] = newAnswer;
	        return _extends({}, state, {
	          agreementsByID: newAgreementsByID
	        });
	      }
	    case _ActionTypes.REQUEST_AGREEMENTS:
	      return _extends({}, state, {
	        hasError: false,
	        agreementsError: null,
	        agreementsLoading: true,
	        agreementsByID: {}
	      });
	    case _ActionTypes.REQUEST_AGREEMENTS_SUCCESS:
	      return _extends({}, state, {
	        agreementsByID: _extends({}, state.agreementsByID, action.newAgreements),
	        agreementsLoading: false
	      });
	    case _ActionTypes.REQUEST_AGREEMENTS_FAILURE:
	      return _extends({}, state, {
	        hasError: true,
	        agreementsError: action.error,
	        agreementsLoading: false
	      });
	    case _ActionTypes.REQUEST_AGREEMENT_YES:
	      return _extends({}, state);
	    case _ActionTypes.REQUEST_AGREEMENT_NO:
	      return _extends({}, state);
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initState, 'initState', 'D:/a/1/s/src/web/employee/src/reducers/AgreementsReducer.js');
	
	  __REACT_HOT_LOADER__.register(AgreementsReducer, 'AgreementsReducer', 'D:/a/1/s/src/web/employee/src/reducers/AgreementsReducer.js');
	}();

	;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = Appraisal;
	
	var _range = __webpack_require__(207);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _dateTools = __webpack_require__(35);
	
	var _DataTypes = __webpack_require__(85);
	
	var _ActionTypes = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var year = new Date().getFullYear();
	function Appraisal() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    appraisals: [],
	    openAppraisals: [],
	    appraisalsById: {},
	    appraisalAnswers: {},
	    loading: true,
	    loadingById: {},
	    isSaving: false,
	    error: null,
	    tab: _DataTypes.EMPLOYEE_TAB,
	    year: year,
	    yearOptions: (0, _range2.default)(year - 2, year + 2)
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.SET_APPRAISAL_TAB:
	      return _extends({}, state, {
	        tab: action.tab
	      });
	    case _ActionTypes.SET_EMPLOYEE_YEAR:
	      return _extends({}, state, {
	        year: action.year
	      });
	    case _ActionTypes.RESET_APPRAISAL_LOADING:
	      return _extends({}, state, {
	        loadingById: {}
	      });
	    case _ActionTypes.REQUEST_APPRAISAL:
	      return _extends({}, state, {
	        error: null,
	        loading: true,
	        appraisals: []
	      });
	    case _ActionTypes.REQUEST_APPRAISAL_SUCCESS:
	      return _extends({}, state, {
	        error: null,
	        loading: false,
	        appraisals: action.appraisals.sort(function (a, b) {
	          return (0, _dateTools.compare)(a.EmployeeDueDate, b.EmployeeDueDate);
	        }),
	        openAppraisals: action.openAppraisals,
	        yearOptions: [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray((0, _map2.default)(action.appraisals, function (a) {
	          return new Date(a.FinalAppraisalDate).getFullYear();
	        }).sort()), [year]))))
	      });
	    case _ActionTypes.REQUEST_APPRAISAL_FAILURE:
	      return _extends({}, state, {
	        error: action.error,
	        loading: false,
	        appraisals: []
	      });
	    case _ActionTypes.REQUEST_APPRAISAL_BY_ID:
	      return _extends({}, state, {
	        error: null,
	        loadingById: _extends({}, state.loadingById, _defineProperty({}, action.appraisalId, true))
	      });
	    case _ActionTypes.REQUEST_APPRAISAL_BY_ID_SUCCESS:
	      return _extends({}, state, {
	        error: null,
	        loadingById: _extends({}, state.loadingById, _defineProperty({}, action.appraisal.PMAppraisalID, false)),
	        appraisalsById: _extends({}, state.appraisalsById, _defineProperty({}, action.appraisal.PMAppraisalID, action.appraisal)),
	        expiredById: _defineProperty({}, action.appraisal.PMAppraisalID, false)
	        /* appraisalAnswers: {
	          ...state.appraisalAnswers,
	          [action.appraisal.PMAppraisalID]: action.answers,
	        }, */
	      });
	    case _ActionTypes.SET_FINAL_ANSWERS:
	      return _extends({}, state, {
	        appraisalAnswers: _extends({}, state.appraisalAnswers, _defineProperty({}, action.appraisalId, _extends({}, state.appraisalAnswers[action.appraisalId], {
	          finalAnswers: action.answers
	        })))
	      });
	    case _ActionTypes.SET_MANAGER_ANSWERS:
	      return _extends({}, state, {
	        appraisalAnswers: _extends({}, state.appraisalAnswers, _defineProperty({}, action.appraisalId, _extends({}, state.appraisalAnswers[action.appraisalId], {
	          managerAnswers: action.answers
	        })))
	      });
	    case _ActionTypes.SET_EMPLOYEE_ANSWERS:
	      return _extends({}, state, {
	        appraisalAnswers: _extends({}, state.appraisalAnswers, _defineProperty({}, action.appraisalId, _extends({}, state.appraisalAnswers[action.appraisalId], {
	          employeeAnswers: action.answers
	        })))
	      });
	    case _ActionTypes.REQUEST_APPRAISAL_BY_ID_FAILURE:
	      return _extends({}, state, {
	        error: action.error,
	        loadingById: _extends({}, state.loadingById, _defineProperty({}, action.appraisalId, false)),
	        appraisalsById: {}
	      });
	    case _ActionTypes.SAVING_APPRAISAL:
	      return _extends({}, state, {
	        isSaving: true,
	        error: null
	      });
	    case _ActionTypes.SAVING_APPRAISAL_FAILURE:
	      return _extends({}, state, {
	        isSaving: false,
	        error: action.error
	      });
	    case _ActionTypes.SAVING_APPRAISAL_SUCCESS:
	      return _extends({}, state, {
	        isSaving: false,
	        error: null,
	        expiredById: _defineProperty({}, action.id, true)
	      });
	    case _ActionTypes.SUBMIT_APPRAISAL:
	      return _extends({}, state, {
	        isSubmitting: true,
	        error: null
	      });
	    case _ActionTypes.SUBMIT_APPRAISAL_FAILURE:
	      return _extends({}, state, {
	        isSubmitting: false,
	        error: action.error
	      });
	    case _ActionTypes.SUBMIT_APPRAISAL_SUCCESS:
	      return _extends({}, state, {
	        isSubmitting: false,
	        error: null,
	        expiredById: _defineProperty({}, action.id, true)
	      });
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(year, 'year', 'D:/a/1/s/src/web/employee/src/reducers/Appraisal.js');
	
	  __REACT_HOT_LOADER__.register(Appraisal, 'Appraisal', 'D:/a/1/s/src/web/employee/src/reducers/Appraisal.js');
	}();

	;

/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = BenefitsReducer;
	
	var _ActionTypes = __webpack_require__(18);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function BenefitsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    benefitLoadingById: {},
	    benefitRegisterError: null
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.REQUEST_BENEFITS:
	      return _extends({}, state, {
	        isFetching: true,
	        benefits: [],
	        loaded: false
	      });
	
	    case _ActionTypes.REQUEST_BENEFITS_FAILURE:
	      return _extends({}, state, {
	        isFetching: false,
	        error: action.error,
	        loaded: true
	      });
	
	    case _ActionTypes.REQUEST_BENEFITS_SUCCESS:
	      return _extends({}, state, {
	        isFetching: false,
	        benefits: action.benefits,
	        lastUpdated: action.receivedAt,
	        loaded: true
	      });
	    case _ActionTypes.FITNESS_GRANT_REGISTER_REQUEST:
	      return _extends({}, state, {
	        benefitLoadingById: _extends({}, state.benefitLoadingById, _defineProperty({}, action.benefitId, true))
	      });
	    case _ActionTypes.FITNESS_GRANT_REGISTER_SUCCESS:
	      return _extends({}, state, {
	        benefitLoadingById: _extends({}, state.benefitLoadingById, _defineProperty({}, action.benefitId, false))
	      });
	    case _ActionTypes.FITNESS_GRANT_REGISTER_FAILURE:
	      return _extends({}, state, {
	        benefitRegisterError: action.error,
	        benefitLoadingById: _extends({}, state.benefitLoadingById, _defineProperty({}, action.benefitId, false))
	      });
	    case _ActionTypes.GRANT_REGISTER_REQUEST:
	      return _extends({}, state);
	    case _ActionTypes.GRANT_REGISTER_SUCCESS:
	      return _extends({}, state);
	    case _ActionTypes.GRANT_REGISTER_FAILURE:
	      return _extends({}, state, {
	        benefitRegisterError: action.error
	      });
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BenefitsReducer, 'BenefitsReducer', 'D:/a/1/s/src/web/employee/src/reducers/BenefitsReducer.js');
	}();

	;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(66);
	
	var _ActionTypes = __webpack_require__(18);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initalState = {
	  birthdays: [],
	  loaded: false,
	  error: null,
	  hasError: false
	};
	
	var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes.REQUEST_BIRTHDAYS, function (state) {
	  return _extends({}, state, {
	    loaded: false
	  });
	}), _defineProperty(_handleActions, _ActionTypes.REQUEST_BIRTHDAYS_SUCCESS, function (state, _ref) {
	  var birthdays = _ref.birthdays;
	  return _extends({}, state, {
	    birthdays: birthdays,
	    loaded: true
	  });
	}), _defineProperty(_handleActions, _ActionTypes.REQUEST_BIRTHDAYS_FAILURE, function (state, _ref2) {
	  var error = _ref2.error;
	  return _extends({}, state, {
	    error: error,
	    hasError: true
	  });
	}), _handleActions), initalState);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initalState, 'initalState', 'D:/a/1/s/src/web/employee/src/reducers/BirthdaysReducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/reducers/BirthdaysReducer.js');
	}();

	;

/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = CourseEvaluationReducer;
	
	var _ActionTypes = __webpack_require__(18);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  evaluationsLoaded: false,
	  evaluationsError: null,
	  hasError: false,
	  evaluations: [],
	  evaluationError: null,
	  hasEvaluationError: false,
	  evaluationById: {},
	  evaluationLoadedById: {},
	  evaluationSaving: false,
	  evaluationSubmitting: false
	};
	function CourseEvaluationReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.COURSE_EVAL_LIST_REQUEST:
	      {
	        return _extends({}, state, {
	          evaluationsLoaded: false,
	          evaluationsError: null,
	          hasError: false
	        });
	      }
	    case _ActionTypes.COURSE_EVAL_LIST_SUCCESS:
	      return _extends({}, state, {
	        evaluationsLoaded: true,
	        evaluations: action.evaluations
	      });
	    case _ActionTypes.COURSE_EVAL_LIST_FAILURE:
	      return _extends({}, state, {
	        evaluationsLoaded: true,
	        evaluationsError: action.evaluationsError,
	        hasError: true
	      });
	    case _ActionTypes.COURSE_EVAL_REQUEST:
	      return _extends({}, state, {
	        evaluationLoadedById: _extends({}, state.evaluationLoadedById, _defineProperty({}, action.CourseAttendeeID, false)),
	        evaluationById: _extends({}, state.evaluationById, _defineProperty({}, action.CourseAttendeeID, null)),
	        evaluationError: null,
	        hasEvaluationError: false
	      });
	    case _ActionTypes.COURSE_EVAL_SUCCESS:
	      return _extends({}, state, {
	        evaluationLoadedById: _extends({}, state.evaluationLoadedById, _defineProperty({}, action.CourseAttendee.CourseAttendeeID, true)),
	        evaluationById: _extends({}, state.evaluationById, _defineProperty({}, action.CourseAttendee.CourseAttendeeID, {
	          CourseAttendee: action.CourseAttendee,
	          CourseEvaluation: action.CourseEvaluation,
	          CourseEvaluationAnswers: action.CourseEvaluationAnswers
	        }))
	      });
	    case _ActionTypes.COURSE_EVAL_FAILURE:
	      return _extends({}, state, {
	        evaluationLoadedById: _extends({}, state.evaluationLoadedById, _defineProperty({}, action.CourseAttendeeID, true)),
	        evaluationError: action.evaluationError,
	        hasEvaluationError: true
	      });
	    case _ActionTypes.COURSE_EVAL_SAVE_REQUEST:
	      return _extends({}, state, {
	        evaluationSaving: true,
	        evaluationError: null,
	        hasEvaluationError: false
	      });
	    case _ActionTypes.COURSE_EVAL_SAVE_SUCCESS:
	      return _extends({}, state, {
	        evaluationSaving: false
	      });
	    case _ActionTypes.COURSE_EVAL_SAVE_FAILURE:
	      return _extends({}, state, {
	        evaluationSaving: false,
	        evaluationError: action.evaluationError,
	        hasEvaluationError: true
	      });
	    case _ActionTypes.COURSE_EVAL_SUBMIT_REQUEST:
	      return _extends({}, state, {
	        evaluationSubmitting: true,
	        hasEvaluationError: false
	      });
	    case _ActionTypes.COURSE_EVAL_SUBMIT_SUCCESS:
	      return _extends({}, state, {
	        evaluationSubmitting: false
	      });
	    case _ActionTypes.COURSE_EVAL_SUBMIT_FAILURE:
	      return _extends({}, state, {
	        evaluationSubmitting: false,
	        evaluationError: action.evaluationError,
	        hasEvaluationError: true
	      });
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/reducers/CourseEvaluationReducer.js');
	
	  __REACT_HOT_LOADER__.register(CourseEvaluationReducer, 'CourseEvaluationReducer', 'D:/a/1/s/src/web/employee/src/reducers/CourseEvaluationReducer.js');
	}();

	;

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(66);
	
	var _ActionTypes = __webpack_require__(18);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  questionnaireError: null,
	  questionnaireLoaded: false
	};
	
	var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes.COURSE_QUEST_REQUEST, function (state, _ref) {
	  var RootQAElementID = _ref.RootQAElementID;
	  return _extends({}, state, {
	    RootQAElementID: RootQAElementID,
	    questionnaireError: null,
	    questionnaireLoaded: false
	  });
	}), _defineProperty(_handleActions, _ActionTypes.COURSE_QUEST_FAILURE, function (state, _ref2) {
	  var questionnaireError = _ref2.questionnaireError;
	  return _extends({}, state, {
	    questionnaireError: questionnaireError
	  });
	}), _defineProperty(_handleActions, _ActionTypes.COURSE_QUEST_SUCCESS, function (state, _ref3) {
	  var questionnaire = _ref3.questionnaire;
	  return _extends({}, state, {
	    questionnaire: questionnaire,
	    questionnaireLoaded: true
	  });
	}), _defineProperty(_handleActions, _ActionTypes.COURSE_QUEST_SUBMIT_REQUEST, function (state) {
	  return _extends({}, state);
	}), _defineProperty(_handleActions, _ActionTypes.COURSE_QUEST_SUBMIT_FAILURE, function (state, _ref4) {
	  var questionnaireError = _ref4.questionnaireError;
	  return _extends({}, state, {
	    questionnaireError: questionnaireError
	  });
	}), _defineProperty(_handleActions, _ActionTypes.COURSE_QUEST_SUBMIT_SUCCESS, function (state) {
	  return _extends({}, state);
	}), _handleActions), initialState);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/reducers/CourseQuestionnaireReducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/reducers/CourseQuestionnaireReducer.js');
	}();

	;

/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = EmployeeBankReducer;
	
	var _keyBy = __webpack_require__(370);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _ActionTypes = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  loaded: true,
	  branchesLoaded: false,
	  error: null,
	  hasError: false,
	  accounts: {},
	  payYear: 0,
	  bankBranches: [],
	  bankLedgers: {
	    '05': '05',
	    '04': '04',
	    13: '13',
	    14: '14',
	    15: '15',
	    18: '18',
	    24: '24',
	    26: '26',
	    29: '29',
	    38: '38'
	  }
	};
	function EmployeeBankReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.REQUEST_BANK:
	      {
	        return _extends({}, state, {
	          loaded: false,
	          hasError: false,
	          error: null
	        });
	      }
	    case _ActionTypes.REQUEST_BANK_SUCCESS:
	      {
	        var accounts = (0, _keyBy2.default)(action.accounts, 'EmployeeMasterBankID');
	        return _extends({}, state, {
	          loaded: true,
	          accounts: accounts
	        });
	      }
	    case _ActionTypes.REQUEST_BANK_FAILURE:
	      return _extends({}, state, {
	        loaded: true,
	        error: action.error,
	        hasError: true
	      });
	    case _ActionTypes.SET_ACCOUNT_STATUS:
	      return _extends({}, state, _defineProperty({}, 'status-' + action.status.id, action.status.value));
	    case _ActionTypes.REQUEST_BANK_BRANCHES:
	      return _extends({}, state, {
	        branchesLoaded: false
	      });
	    case _ActionTypes.SET_BANK_BRANCHES:
	      return _extends({}, state, {
	        branchesLoaded: true,
	        bankBranches: (0, _keyBy2.default)(action.branches, 'SysBankBranchID')
	      });
	    case _ActionTypes.REQUEST_BANK_UPDATE:
	      {
	        return _extends({}, state, {
	          hasError: false,
	          error: null
	        });
	      }
	    case _ActionTypes.REQUEST_BANK_UPDATE_SUCCESS:
	      {
	        var _extends4;
	
	        return _extends({}, state, (_extends4 = {
	          hasError: false,
	          error: null
	        }, _defineProperty(_extends4, 'status-' + action.account.EmployeeMasterBankID, 'ACCOUNT_FIXED'), _defineProperty(_extends4, 'accounts', _extends({}, state.accounts, _defineProperty({}, action.account.EmployeeMasterBankID, action.account))), _extends4));
	      }
	    case _ActionTypes.REQUEST_BANK_UPDATE_FAILURE:
	      {
	        return _extends({}, state, {
	          error: action.error,
	          hasError: true
	        });
	      }
	    case _ActionTypes.CREATE_NEW_ACCOUNT:
	      return _extends({}, state, {
	        'status-NEW_ACCOUNT': 'ACCOUNT_EDIT',
	        accounts: _extends({}, state.accounts, {
	          NEW_ACCOUNT: { EmployeeMasterBankID: 'NEW_ACCOUNT' }
	        })
	      });
	    case _ActionTypes.CLEAR_NEW_ACCOUNT:
	      {
	        var _accounts = state.accounts;
	        delete _accounts.NEW_ACCOUNT;
	        return _extends({}, state, {
	          'status-NEW_ACCOUNT': null,
	          accounts: _accounts
	        });
	      }
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/reducers/EmployeeBankReducer.js');
	
	  __REACT_HOT_LOADER__.register(EmployeeBankReducer, 'EmployeeBankReducer', 'D:/a/1/s/src/web/employee/src/reducers/EmployeeBankReducer.js');
	}();

	;

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = EmployeeHolidayReducer;
	
	var _ActionTypes = __webpack_require__(18);
	
	var initialState = {
	  loaded: true,
	  error: null,
	  hasError: false,
	  holidays: [],
	  payYear: 0,
	  holidayOverview: {},
	  overviewError: null,
	  overviewLoaded: false,
	  holidayInfo: null,
	  initialized: false,
	  loading: false,
	  fetchingByYear: false,
	  holidayPayYear: 0
	};
	function EmployeeHolidayReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.REQUEST_HOLIDAY:
	      {
	        return _extends({}, state, {
	          loaded: false,
	          loading: true,
	          hasError: false,
	          error: null
	        });
	      }
	    case _ActionTypes.REQUEST_HOLIDAY_SUCCESS:
	      return _extends({}, state, {
	        initialized: true,
	        loading: false,
	        loaded: true,
	        holidays: action.holidays,
	        holidayPayYear: action.holidayPayYear,
	        earnedHolidayInfo: action.earnedHolidayInfo
	      });
	    case _ActionTypes.REQUEST_HOLIDAY_FAILURE:
	      return _extends({}, state, {
	        initialized: true,
	        loading: false,
	        loaded: true,
	        error: action.error,
	        hasError: true
	      });
	    case _ActionTypes.REQUEST_HOLIDAY_OVERVIEW:
	      {
	        return _extends({}, state, {
	          overviewLoaded: false
	        });
	      }
	    case _ActionTypes.REQUEST_HOLIDAY_OVERVIEW_SUCCESS:
	      return _extends({}, state, {
	        holidayOverview: action.holidayOverview,
	        overviewLoaded: true
	      });
	    case _ActionTypes.REQUEST_HOLIDAY_OVERVIEW_FAILURE:
	      return _extends({}, state, {
	        overviewError: action.error
	      });
	    case _ActionTypes.SET_HOLIDAY_INFO:
	      return _extends({}, state, {
	        holidayInfo: action.holidayInfo
	      });
	    case _ActionTypes.FETCH_HOLIDAY_BY_YEAR:
	      return _extends({}, state, {
	        fetchedByYear: false,
	        fetchingByYear: true,
	        hasError: false,
	        error: null,
	        payYear: action.year
	      });
	    case _ActionTypes.FETCH_HOLIDAY_BY_YEAR_SUCCESS:
	      return _extends({}, state, {
	        fetchingByYear: false,
	        fetchedByYear: true,
	        holidays: action.holidays,
	        holidayOverview: action.holidaysOverview
	      });
	    case _ActionTypes.FETCH_HOLIDAY_BY_YEAR_FAILURE:
	      return _extends({}, state, {
	        fetchingByYear: false,
	        fetchedByYear: true,
	        error: action.error,
	        hasError: true
	      });
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/reducers/EmployeeHolidayReducer.js');
	
	  __REACT_HOT_LOADER__.register(EmployeeHolidayReducer, 'EmployeeHolidayReducer', 'D:/a/1/s/src/web/employee/src/reducers/EmployeeHolidayReducer.js');
	}();

	;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = EmployeeOrgChart;
	
	var _ActionTypes = __webpack_require__(18);
	
	var initialState = {
	  isFetching: false,
	  error: false
	};
	
	function EmployeeOrgChart() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.ORGCHART_REQUEST_DATA:
	      return _extends({}, state, {
	        isFetching: true,
	        error: false
	      });
	    case _ActionTypes.ORGCHART_REQUEST_DATA_SUCCESS:
	      return _extends({}, state, {
	        isFetching: false,
	        error: false,
	        data: action.data
	      });
	    case _ActionTypes.ORGCHART_REQUEST_DATA_FAILURE:
	      return _extends({}, state, {
	        isFetching: false,
	        error: action.error
	      });
	    case _ActionTypes.ORGCHART_SET_ACTIVE_NODE:
	      {
	        return _extends({}, state, {
	          cursorItem: action.nodeId
	        });
	      }
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/reducers/EmployeeOrgChart.js');
	
	  __REACT_HOT_LOADER__.register(EmployeeOrgChart, 'EmployeeOrgChart', 'D:/a/1/s/src/web/employee/src/reducers/EmployeeOrgChart.js');
	}();

	;

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = EmployeePensionAndUnionReducer;
	
	var _ActionTypes = __webpack_require__(18);
	
	var initialState = {
	  unions: [],
	  unionLoading: false,
	  unionError: null,
	  employeeUnions: [],
	  employeeUnionLoading: false,
	  employeeUnionError: null,
	  pensions: [],
	  privatePensions: [],
	  pensionLoading: false,
	  pensionError: null,
	  bonuses: [],
	  bonusesLoading: false,
	  bonusesError: null
	};
	
	function EmployeePensionAndUnionReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.REQUEST_UNION:
	      return _extends({}, state, {
	        unionLoading: true,
	        unionError: null
	      });
	    case _ActionTypes.REQUEST_UNION_SUCCESS:
	      return _extends({}, state, {
	        unionLoading: false,
	        unions: action.unions
	      });
	    case _ActionTypes.REQUEST_UNION_FAILURE:
	      return _extends({}, state, {
	        unionLoading: false,
	        unionError: action.error
	      });
	    case _ActionTypes.REQUEST_EMPLOYEE_UNION:
	      return _extends({}, state, {
	        employeeUnionLoading: true,
	        employeeUnionError: null
	      });
	    case _ActionTypes.REQUEST_EMPLOYEE_UNION_SUCCESS:
	      return _extends({}, state, {
	        employeeUnionLoading: false,
	        employeeUnions: action.employeeUnions
	      });
	    case _ActionTypes.REQUEST_EMPLOYEE_UNION_FAILURE:
	      return _extends({}, state, {
	        employeeUnionLoading: false,
	        employeeUnionError: action.error
	      });
	    case _ActionTypes.REQUEST_PENSION:
	      return _extends({}, state, {
	        pensionLoading: true,
	        pensionError: null
	      });
	    case _ActionTypes.REQUEST_PENSION_SUCCESS:
	      return _extends({}, state, {
	        pensionLoading: false,
	        pensions: action.data.General,
	        privatePensions: action.data.Private
	      });
	    case _ActionTypes.REQUEST_PENSION_FAILURE:
	      return _extends({}, state, {
	        pensionLoading: false,
	        pensionError: action.error
	      });
	    case _ActionTypes.REQUEST_BONUSES:
	      return _extends({}, state, {
	        bonusesLoading: true,
	        bonusesError: null
	      });
	    case _ActionTypes.REQUEST_BONUSES_SUCCESS:
	      return _extends({}, state, {
	        bonusesLoading: false,
	        bonuses: action.bonuses
	      });
	    case _ActionTypes.REQUEST_BONUSES_FAILURE:
	      return _extends({}, state, {
	        bonusesLoading: false,
	        bonusesError: action.error
	      });
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/reducers/EmployeePensionAndUnionReducer.js');
	
	  __REACT_HOT_LOADER__.register(EmployeePensionAndUnionReducer, 'EmployeePensionAndUnionReducer', 'D:/a/1/s/src/web/employee/src/reducers/EmployeePensionAndUnionReducer.js');
	}();

	;

/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = EmployeeSearch;
	
	var _ActionTypes = __webpack_require__(18);
	
	var initialState = { loaded: true, loadedAll: false, resultData: [] };
	function EmployeeSearch() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.SEARCH_REQUEST:
	      return _extends({}, state, {
	        loaded: false,
	        loadedAll: false,
	        error: null,
	        query: action.query
	      });
	    case _ActionTypes.SEARCH_REQUEST_SUCCESS:
	      return _extends({}, state, {
	        loaded: true,
	        error: null,
	        resultData: action.resultData
	      });
	    case _ActionTypes.SEARCH_REQUEST_SUCCESS_ALL:
	      return _extends({}, state, {
	        loadedAll: true,
	        loaded: true,
	        error: null,
	        resultData: action.resultData
	      });
	    case _ActionTypes.SEARCH_REQUEST_FAILURE:
	      return _extends({}, state, {
	        loaded: true,
	        error: action.error,
	        resultData: []
	      });
	    case _ActionTypes.SEARCH_REQUEST_CLEAR:
	      return _extends({}, state, {
	        resultData: []
	      });
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/reducers/EmployeeSearch.js');
	
	  __REACT_HOT_LOADER__.register(EmployeeSearch, 'EmployeeSearch', 'D:/a/1/s/src/web/employee/src/reducers/EmployeeSearch.js');
	}();

	;

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = EmployeeTaxCardsReducer;
	
	var _find = __webpack_require__(263);
	
	var _find2 = _interopRequireDefault(_find);
	
	var _range = __webpack_require__(207);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ActionTypes = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initState = {
	  taxCardsLoading: false,
	  employeeTaxCard: null,
	  spouseTaxCard: null,
	  hasError: false,
	  taxCardsError: null,
	  taxDiscount: 0,
	  lastUsedOptions: (0, _map2.default)((0, _range2.default)(0, 12), function (x) {
	    return {
	      key: x,
	      value: (0, _moment2.default)({ M: x }).subtract(1, 'day').toISOString(),
	      primaryText: (0, _moment2.default)().month(x).format('MMMM')
	    };
	  })
	};
	
	function EmployeeTaxCardsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.SET_TAX_DISCOUNT:
	      return _extends({}, state, {
	        taxDiscount: action.taxDiscount
	      });
	    case _ActionTypes.SET_TAX_CARD_STATUS:
	      return _extends({}, state, _defineProperty({}, 'status-' + action.status.id, action.status.value));
	    case _ActionTypes.SET_TAX_CARD_INFO:
	      return _extends({}, state, {
	        taxCardInfo: action.taxCardInfo
	      });
	    case _ActionTypes.REQUEST_TAX_CARDS:
	      return _extends({}, state, {
	        taxCardsLoading: true,
	        taxCardsError: null,
	        hasError: false
	      });
	    case _ActionTypes.REQUEST_TAX_CARDS_SUCCESS:
	      return _extends({}, state, {
	        taxCardsLoading: false,
	        employeeTaxCard: (0, _find2.default)(action.taxCards, ['TaxCardType', 1]),
	        spouseTaxCard: (0, _find2.default)(action.taxCards, ['TaxCardType', 2])
	      });
	    case _ActionTypes.REQUEST_TAX_CARDS_FAILURE:
	      return _extends({}, state, {
	        taxCardsLoading: false,
	        taxCardsError: action.error,
	        hasError: true
	      });
	    case _ActionTypes.REQUEST_CREATE_TAX_CARDS:
	      return _extends({}, state, {
	        taxCardsLoading: true,
	        taxCardsError: null,
	        hasError: false
	      });
	    case _ActionTypes.REQUEST_CREATE_TAX_CARDS_FAILURE:
	      return _extends({}, state, {
	        taxCardsLoading: false,
	        taxCardsError: action.error,
	        hasError: true
	      });
	    case _ActionTypes.REQUEST_UPDATE_TAX_CARD:
	      return _extends({}, state, {
	        hasError: false,
	        error: null
	      });
	    case _ActionTypes.REQUEST_CREATE_TAX_CARDS_SUCCESS:
	    case _ActionTypes.REQUEST_UPDATE_TAX_CARD_SUCCESS:
	      {
	        if (action.data.TaxCardType === 1) {
	          return _extends({}, state, {
	            taxCardsLoading: false,
	            employeeTaxCard: action.data,
	            'status-1': 'TAX_CARD_FIXED'
	          });
	        }
	        return _extends({}, state, {
	          taxCardsLoading: false,
	          spouseTaxCard: action.data,
	          'status-2': 'TAX_CARD_FIXED'
	        });
	      }
	    case _ActionTypes.REQUEST_UPDATE_TAX_CARD_FAILURE:
	      return _extends({}, state, {
	        hasError: true,
	        taxCardsError: action.error
	      });
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initState, 'initState', 'D:/a/1/s/src/web/employee/src/reducers/EmployeeTaxCardsReducer.js');
	
	  __REACT_HOT_LOADER__.register(EmployeeTaxCardsReducer, 'EmployeeTaxCardsReducer', 'D:/a/1/s/src/web/employee/src/reducers/EmployeeTaxCardsReducer.js');
	}();

	;

/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = EntityCRUD;
	
	var _ActionTypes = __webpack_require__(18);
	
	function EntityCRUD() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.CREATE_ENTITY_REQUEST:
	      return _extends({}, state, {
	        CRUDLoading: true
	      });
	    case _ActionTypes.CREATE_ENTITY_REQUEST_SUCCESS:
	      return _extends({}, state, {
	        CRUDLoading: false
	      });
	    case _ActionTypes.CREATE_ENTITY_REQUEST_FAILURE:
	      return _extends({}, state, {
	        CRUDLoading: false
	      });
	    case _ActionTypes.SAVE_ENTITY_REQUEST:
	      return _extends({}, state, {
	        CRUDLoading: true
	      });
	    case _ActionTypes.SAVE_ENTITY_REQUEST_SUCCESS:
	      return _extends({}, state, {
	        CRUDLoading: false
	      });
	    case _ActionTypes.SAVE_ENTITY_REQUEST_FAILURE:
	      return _extends({}, state, {
	        CRUDLoading: false
	      });
	    case _ActionTypes.DELETE_ENTITY_REQUEST:
	      return _extends({}, state, {
	        CRUDLoading: true
	      });
	    case _ActionTypes.DELETE_ENTITY_REQUEST_SUCCESS:
	      return _extends({}, state, {
	        CRUDLoading: false
	      });
	    case _ActionTypes.DELETE_ENTITY_REQUEST_FAILURE:
	      return _extends({}, state, {
	        CRUDLoading: false
	      });
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(EntityCRUD, 'EntityCRUD', 'D:/a/1/s/src/web/employee/src/reducers/EntityCRUD.js');
	}();

	;

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(66);
	
	var _keyBy = __webpack_require__(370);
	
	var _keyBy2 = _interopRequireDefault(_keyBy);
	
	var _range = __webpack_require__(207);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _ActionTypes = __webpack_require__(18);
	
	var TYPES = _interopRequireWildcard(_ActionTypes);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var yearNow = new Date().getFullYear();
	var initialState = {
	  documentTypes: [],
	  documentTypesById: {},
	  documentTypesByValue: {},
	  error: null,
	  files: [],
	  fileById: {},
	  groupedFiles: {},
	  groupFilter: null,
	  hasError: false,
	  loaded: false,
	  ownerTypes: [],
	  payslips: [],
	  payslipsLoaded: false,
	  payYear: yearNow,
	  payYearOptions: (0, _range2.default)(2010, yearNow + 1),
	  uploadHasError: false,
	  uploading: false
	};
	
	// handleActions is a helper function to instead of using a switch case statement,
	// we just use the regular map with function state attach to it.
	
	var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, TYPES.REQUEST_FILES, function (state) {
	  return _extends({}, state, {
	    loaded: false,
	    hasError: false
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILES_SUCCESS, function (state, _ref) {
	  var files = _ref.files,
	      groupedFiles = _ref.groupedFiles;
	  return _extends({}, state, {
	    groupedFiles: groupedFiles,
	    files: files,
	    loaded: true
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILES_FAILURE, function (state, _ref2) {
	  var error = _ref2.error;
	  return _extends({}, state, {
	    error: error,
	    loaded: true,
	    hasError: true
	  });
	}), _defineProperty(_handleActions, TYPES.SET_PAY_YEAR, function (state, _ref3) {
	  var payYear = _ref3.payYear,
	      payYearOptions = _ref3.payYearOptions;
	  return _extends({}, state, {
	    payYear: payYear,
	    payYearOptions: payYearOptions || state.payYearOptions
	  });
	}), _defineProperty(_handleActions, TYPES.SET_GROUP_FILTER, function (state, _ref4) {
	  var groupFilter = _ref4.groupFilter;
	  return _extends({}, state, {
	    groupFilter: groupFilter
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_PAYSLIPS, function (state) {
	  return _extends({}, state, {
	    payslipsLoaded: false,
	    hasError: false
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_PAYSLIPS_SUCCESS, function (state, _ref5) {
	  var payslips = _ref5.payslips;
	  return _extends({}, state, {
	    payslips: payslips.map(function (s) {
	      var PayMonth = new Date(s.PayPeriodBegda).getMonth();
	      return _extends({}, s, {
	        PayMonth: PayMonth
	      });
	    }),
	    payslipsLoaded: true
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_PAYSLIPS_FAILURE, function (state, _ref6) {
	  var error = _ref6.error;
	  return _extends({}, state, {
	    error: error,
	    payslipsLoaded: true,
	    hasError: true
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILE_DOWNLOAD, function (state) {
	  return _extends({}, state, {
	    hasError: false
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILE_DOWNLOAD_SUCCESS, function (state) {
	  return _extends({}, state);
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILE_DOWNLOAD_FAILURE, function (state, _ref7) {
	  var error = _ref7.error;
	  return _extends({}, state, {
	    hasError: true,
	    error: error
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILE_DELETE, function (state) {
	  return _extends({}, state, {
	    uploadHasError: false
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILE_DELETE_SUCCESS, function (state) {
	  return _extends({}, state);
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILE_DELETE_FAILURE, function (state, _ref8) {
	  var error = _ref8.error;
	  return _extends({}, state, {
	    uploadHasError: true,
	    error: error
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILE_UPLOAD, function (state) {
	  return _extends({}, state, {
	    uploadHasError: false,
	    uploading: true
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILE_UPLOAD_SUCCESS, function (state) {
	  return _extends({}, state, {
	    uploading: false
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILE_UPLOAD_FAILURE, function (state, _ref9) {
	  var error = _ref9.error;
	  return _extends({}, state, {
	    uploadHasError: true,
	    uploading: false,
	    error: error
	  });
	}), _defineProperty(_handleActions, TYPES.INIT_FILE_UPLOAD, function (state) {
	  return _extends({}, state, {
	    uploadHasError: false
	  });
	}), _defineProperty(_handleActions, TYPES.INIT_FILE_UPLOAD_SUCCESS, function (state, _ref10) {
	  var ownerTypes = _ref10.ownerTypes,
	      documentTypes = _ref10.documentTypes;
	  return _extends({}, state, {
	    ownerTypes: ownerTypes,
	    documentTypes: documentTypes,
	    documentTypesById: _extends({}, (0, _keyBy2.default)(documentTypes, 'FileRepositoryObjectDocumentTypeID'), {
	      0: { Name: 'Ekkert', Value: 'None' }
	    }),
	    documentTypesByValue: (0, _keyBy2.default)(documentTypes, 'Value')
	  });
	}), _defineProperty(_handleActions, TYPES.INIT_FILE_UPLOAD_FAILURE, function (state, _ref11) {
	  var error = _ref11.error;
	  return _extends({}, state, {
	    uploadHasError: true,
	    error: error
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILE_BY_ID, function (state) {
	  return _extends({}, state, {
	    loaded: false,
	    error: false
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILE_BY_ID_SUCCESS, function (state, _ref12) {
	  var fileById = _ref12.fileById;
	  return _extends({}, state, {
	    fileById: fileById,
	    loaded: true
	
	  });
	}), _defineProperty(_handleActions, TYPES.REQUEST_FILE_BY_ID_FAILURE, function (state, _ref13) {
	  var error = _ref13.error;
	  return _extends({}, state, {
	    loaded: true,
	    error: error
	  });
	}), _handleActions), initialState);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(yearNow, 'yearNow', 'D:/a/1/s/src/web/employee/src/reducers/FileReducer.js');
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/reducers/FileReducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/reducers/FileReducer.js');
	}();

	;

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = ManagerAppraisal;
	
	var _range = __webpack_require__(207);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _dateTools = __webpack_require__(35);
	
	var _ActionTypes = __webpack_require__(18);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var year = new Date().getFullYear();
	function ManagerAppraisal() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    appraisals: [],
	    loading: false,
	    error: null,
	    year: year,
	    yearOptions: (0, _range2.default)(year - 2, year + 2),
	    employee: 0
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.SET_MANAGER_YEAR:
	      return _extends({}, state, {
	        year: action.year
	      });
	    case _ActionTypes.SET_EMPLOYEE:
	      return _extends({}, state, {
	        employee: action.employee
	      });
	    case _ActionTypes.REQUEST_MANAGER_APPRAISAL:
	      return _extends({}, state, {
	        error: null,
	        loading: true,
	        appraisals: []
	      });
	    case _ActionTypes.REQUEST_MANAGER_APPRAISAL_SUCCESS:
	      return _extends({}, state, {
	        error: null,
	        loading: false,
	        appraisals: action.appraisals.sort(function (a, b) {
	          return (0, _dateTools.compare)(a.ManagerDueDate, b.ManagerDueDate);
	        }),
	        yearOptions: [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray((0, _map2.default)(action.appraisals, function (a) {
	          return new Date(a.FinalAppraisalDate).getFullYear();
	        }).sort()), [year]))))
	      });
	    case _ActionTypes.REQUEST_MANAGER_APPRAISAL_FAILURE:
	      return _extends({}, state, {
	        error: action.error,
	        loading: false,
	        appraisals: []
	      });
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(year, 'year', 'D:/a/1/s/src/web/employee/src/reducers/ManagerAppraisal.js');
	
	  __REACT_HOT_LOADER__.register(ManagerAppraisal, 'ManagerAppraisal', 'D:/a/1/s/src/web/employee/src/reducers/ManagerAppraisal.js');
	}();

	;

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ActionTypes = __webpack_require__(18);
	
	var initState = {
	  showAlert: false,
	  alertMessage: '',
	  alertAction: function alertAction() {
	    return null;
	  }
	};
	
	var _default = function _default() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.SHOW_ALERT:
	      return _extends({}, state, {
	        showAlert: true,
	        alertMessage: action.message,
	        alertAction: action.action,
	        alertActionLabel: action.alertActionLabel,
	        alertCancelLabel: action.alertCancelLabel
	      });
	    case _ActionTypes.HIDE_ALERT:
	      return _extends({}, initState);
	    default:
	      return state;
	  }
	};
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initState, 'initState', 'D:/a/1/s/src/web/employee/src/reducers/Notification.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/reducers/Notification.js');
	}();

	;

/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ActionTypes = __webpack_require__(18);
	
	var TYPES = _interopRequireWildcard(_ActionTypes);
	
	var _lodash = __webpack_require__(8);
	
	var _reduxActions = __webpack_require__(66);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  register: {
	    error: null,
	    hasError: false,
	    initFetching: false,
	    initFetched: false,
	    perDiemList: [],
	    perDiemLocationList: [],
	    perDiemTypeList: [],
	    perDiemListKeyed: [],
	    perDiemLocationListKeyed: [],
	    perDiemTypeListKeyed: [],
	    approvalLoading: false,
	    calculating: false,
	    calculatedRecord: null,
	    calcError: null,
	    calcHasError: false
	  }
	};
	
	var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, TYPES.PERDIEM_INIT_APPROVAL_REQUEST, function (state) {
	  return _extends({}, state, {
	    initFetching: true
	  });
	}), _defineProperty(_handleActions, TYPES.PERDIEM_INIT_APPROVAL_SUCCESS, function (state, action) {
	  var perDiemList = (0, _lodash.get)(action, 'data.perDiemList', []);
	  var perDiemLocationList = (0, _lodash.get)(action, 'data.perDiemLocationList', []);
	  var perDiemTypeList = (0, _lodash.get)(action, 'data.perDiemTypeList', []);
	  var perDiemAmountTypeFixed = (0, _lodash.get)(action, 'data.perDiemAmountTypeFixed');
	  return _extends({}, state, {
	    initFetched: true,
	    initFetching: false,
	    perDiemList: perDiemList,
	    perDiemLocationList: perDiemLocationList,
	    perDiemTypeList: perDiemTypeList,
	    perDiemListKeyed: (0, _lodash.keyBy)(perDiemList, 'PerDiemID'),
	    perDiemLocationListKeyed: (0, _lodash.keyBy)(perDiemLocationList, 'PerDiemLocationID'),
	    perDiemTypeListKeyed: (0, _lodash.keyBy)(perDiemTypeList, 'PerDiemTypeID'),
	    perDiemAmountTypeFixed: perDiemAmountTypeFixed
	  });
	}), _defineProperty(_handleActions, TYPES.PERDIEM_INIT_APPROVAL_FAILURE, function (state, action) {
	  return _extends({}, state, {
	    hasError: true,
	    error: action.error,
	    fetching: false,
	    initFetching: false
	  });
	}), _defineProperty(_handleActions, TYPES.PERDIEM_APPROVAL_REQUEST, function (state) {
	  return _extends({}, state, {
	    approvalError: null,
	    hasApprovalError: false,
	    approvalLoading: true
	  });
	}), _defineProperty(_handleActions, TYPES.PERDIEM_APPROVAL_SUCCESS, function (state) {
	  return _extends({}, state, {
	    approvalLoading: false
	  });
	}), _defineProperty(_handleActions, TYPES.PERDIEM_APPROVAL_FAILURE, function (state, action) {
	  return _extends({}, state, {
	    approvalError: action.error,
	    hasApprovalError: true,
	    approvalLoading: false
	  });
	}), _defineProperty(_handleActions, TYPES.CALCULATE_REQUEST, function (state) {
	  return _extends({}, state, {
	    calculating: true,
	    calcError: null,
	    calcHasError: false
	  });
	}), _defineProperty(_handleActions, TYPES.CALCULATE_SUCCESS, function (state, action) {
	  return _extends({}, state, {
	    calculating: false,
	    calculatedRecord: action.calculatedRecord
	  });
	}), _defineProperty(_handleActions, TYPES.CALCULATE_FAILURE, function (state, action) {
	  return _extends({}, state, {
	    calculatedRecord: null,
	    calculating: false,
	    calcHasError: true,
	    calcError: action.error
	  });
	}), _defineProperty(_handleActions, TYPES.CALCULATE_RESET, function (state) {
	  return _extends({}, state, {
	    calculatedRecord: null
	  });
	}), _handleActions), initialState);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/reducers/PerDiem.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/reducers/PerDiem.js');
	}();

	;

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = SettingsReducer;
	
	var _ActionTypes = __webpack_require__(18);
	
	var iState = {
	  hasError: false,
	  newPasswordError: null,
	  newPasswordLoading: false
	};
	function SettingsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : iState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.NEW_PASSWORD_REQUEST:
	      return _extends({}, state, {
	        error: null,
	        hasError: false,
	        newPasswordLoading: true
	      });
	    case _ActionTypes.NEW_PASSWORD_SUCCESS:
	      return _extends({}, state, {
	        newPasswordLoading: false
	      });
	    case _ActionTypes.NEW_PASSWORD_FAILURE:
	      return _extends({}, state, {
	        newPasswordError: action.error,
	        hasError: true,
	        newPasswordLoading: false
	      });
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(iState, 'iState', 'D:/a/1/s/src/web/employee/src/reducers/SettingsReducer.js');
	
	  __REACT_HOT_LOADER__.register(SettingsReducer, 'SettingsReducer', 'D:/a/1/s/src/web/employee/src/reducers/SettingsReducer.js');
	}();

	;

/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(66);
	
	var _ActionTypes = __webpack_require__(18);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  timeStamp: null,
	  loaded: false,
	  isFetching: false,
	  values: [],
	  valuesByKey: undefined,
	  links: [],
	  error: null,
	  hasError: false
	};
	
	var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes.REQUEST_WEB_VALUES, function (state) {
	  return _extends({}, state, {
	    loaded: false,
	    isFetching: true,
	    hasError: false,
	    timeStamp: null
	  });
	}), _defineProperty(_handleActions, _ActionTypes.REQUEST_WEB_VALUES_SUCCESS, function (state, _ref) {
	  var values = _ref.values,
	      valuesByKey = _ref.valuesByKey,
	      links = _ref.links;
	  return _extends({}, state, {
	    values: values,
	    valuesByKey: valuesByKey, // : keyBy(filter(values, x => startsWith(x.Code, 'Employee.Web')), x => replace(x.Code, 'Employee.Web.', '')),
	    links: links,
	    loaded: true,
	    isFetching: false,
	    timeStamp: Date.now()
	  });
	}), _defineProperty(_handleActions, _ActionTypes.REQUEST_WEB_VALUES_FAILURE, function (state, _ref2) {
	  var error = _ref2.error;
	  return _extends({}, state, {
	    error: error,
	    loaded: true,
	    isFetching: false,
	    hasError: true,
	    timeStamp: null
	  });
	}), _handleActions), initialState);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/reducers/WebValuesReducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/reducers/WebValuesReducer.js');
	}();

	;

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(178);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _reduxForm = __webpack_require__(67);
	
	var _reapop = __webpack_require__(44);
	
	var _ActionTypes = __webpack_require__(18);
	
	var _Appraisal = __webpack_require__(964);
	
	var _Appraisal2 = _interopRequireDefault(_Appraisal);
	
	var _AgreementsReducer = __webpack_require__(963);
	
	var _AgreementsReducer2 = _interopRequireDefault(_AgreementsReducer);
	
	var _BirthdaysReducer = __webpack_require__(966);
	
	var _BirthdaysReducer2 = _interopRequireDefault(_BirthdaysReducer);
	
	var _careerReducer = __webpack_require__(437);
	
	var _careerReducer2 = _interopRequireDefault(_careerReducer);
	
	var _certificateReducer = __webpack_require__(438);
	
	var _certificateReducer2 = _interopRequireDefault(_certificateReducer);
	
	var _CourseEvaluationReducer = __webpack_require__(967);
	
	var _CourseEvaluationReducer2 = _interopRequireDefault(_CourseEvaluationReducer);
	
	var _CourseQuestionnaireReducer = __webpack_require__(968);
	
	var _CourseQuestionnaireReducer2 = _interopRequireDefault(_CourseQuestionnaireReducer);
	
	var _coursesReducer = __webpack_require__(439);
	
	var _coursesReducer2 = _interopRequireDefault(_coursesReducer);
	
	var _educationReducer = __webpack_require__(440);
	
	var _educationReducer2 = _interopRequireDefault(_educationReducer);
	
	var _EmployeeHolidayReducer = __webpack_require__(970);
	
	var _EmployeeHolidayReducer2 = _interopRequireDefault(_EmployeeHolidayReducer);
	
	var _EmployeeBankReducer = __webpack_require__(969);
	
	var _EmployeeBankReducer2 = _interopRequireDefault(_EmployeeBankReducer);
	
	var _EmployeeSearch = __webpack_require__(973);
	
	var _EmployeeSearch2 = _interopRequireDefault(_EmployeeSearch);
	
	var _EmployeeTaxCardsReducer = __webpack_require__(974);
	
	var _EmployeeTaxCardsReducer2 = _interopRequireDefault(_EmployeeTaxCardsReducer);
	
	var _EmployeePensionAndUnionReducer = __webpack_require__(972);
	
	var _EmployeePensionAndUnionReducer2 = _interopRequireDefault(_EmployeePensionAndUnionReducer);
	
	var _EntityCRUD = __webpack_require__(975);
	
	var _EntityCRUD2 = _interopRequireDefault(_EntityCRUD);
	
	var _FileReducer = __webpack_require__(976);
	
	var _FileReducer2 = _interopRequireDefault(_FileReducer);
	
	var _languageReducer = __webpack_require__(983);
	
	var _languageReducer2 = _interopRequireDefault(_languageReducer);
	
	var _loginReducer = __webpack_require__(984);
	
	var _loginReducer2 = _interopRequireDefault(_loginReducer);
	
	var _ManagerAppraisal = __webpack_require__(977);
	
	var _ManagerAppraisal2 = _interopRequireDefault(_ManagerAppraisal);
	
	var _Notification = __webpack_require__(978);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	var _profileReducer = __webpack_require__(985);
	
	var _profileReducer2 = _interopRequireDefault(_profileReducer);
	
	var _qualificationReducer = __webpack_require__(442);
	
	var _qualificationReducer2 = _interopRequireDefault(_qualificationReducer);
	
	var _SettingsReducer = __webpack_require__(980);
	
	var _SettingsReducer2 = _interopRequireDefault(_SettingsReducer);
	
	var _WebValuesReducer = __webpack_require__(981);
	
	var _WebValuesReducer2 = _interopRequireDefault(_WebValuesReducer);
	
	var _EmployeeOrgChart = __webpack_require__(971);
	
	var _EmployeeOrgChart2 = _interopRequireDefault(_EmployeeOrgChart);
	
	var _BenefitsReducer = __webpack_require__(965);
	
	var _BenefitsReducer2 = _interopRequireDefault(_BenefitsReducer);
	
	var _loansReducer = __webpack_require__(441);
	
	var _loansReducer2 = _interopRequireDefault(_loansReducer);
	
	var _PerDiem = __webpack_require__(979);
	
	var _PerDiem2 = _interopRequireDefault(_PerDiem);
	
	var _transportationGrants = __webpack_require__(292);
	
	var _transportationGrants2 = _interopRequireDefault(_transportationGrants);
	
	var _time = __webpack_require__(449);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _teria = __webpack_require__(1003);
	
	var _teria2 = _interopRequireDefault(_teria);
	
	var _inOut = __webpack_require__(994);
	
	var _inOut2 = _interopRequireDefault(_inOut);
	
	var _vacationApprovals = __webpack_require__(1020);
	
	var _vacationApprovals2 = _interopRequireDefault(_vacationApprovals);
	
	var _payTickets = __webpack_require__(997);
	
	var _payTickets2 = _interopRequireDefault(_payTickets);
	
	var _approvalRequests = __webpack_require__(988);
	
	var _approvalRequests2 = _interopRequireDefault(_approvalRequests);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var appReducer = (0, _redux.combineReducers)({
	  Appraisal: _Appraisal2.default,
	  AgreementsReducer: _AgreementsReducer2.default,
	  BirthdaysReducer: _BirthdaysReducer2.default,
	  BenefitsReducer: _BenefitsReducer2.default,
	  careerReducer: _careerReducer2.default,
	  certificateReducer: _certificateReducer2.default,
	  CourseEvaluationReducer: _CourseEvaluationReducer2.default,
	  CourseQuestionnaireReducer: _CourseQuestionnaireReducer2.default,
	  coursesReducer: _coursesReducer2.default,
	  educationReducer: _educationReducer2.default,
	  EmployeeBankReducer: _EmployeeBankReducer2.default,
	  EmployeeHolidayReducer: _EmployeeHolidayReducer2.default,
	  EmployeeOrgChart: _EmployeeOrgChart2.default,
	  EmployeeSearch: _EmployeeSearch2.default,
	  EmployeeTaxCardsReducer: _EmployeeTaxCardsReducer2.default,
	  EmployeePensionAndUnionReducer: _EmployeePensionAndUnionReducer2.default,
	  EntityCRUD: _EntityCRUD2.default,
	  FileReducer: _FileReducer2.default,
	  form: _reduxForm.reducer,
	  languageReducer: _languageReducer2.default,
	  loginReducer: _loginReducer2.default,
	  ManagerAppraisal: _ManagerAppraisal2.default,
	  Notification: _Notification2.default,
	  notifications: (0, _reapop.reducer)(),
	  profileReducer: _profileReducer2.default,
	  qualificationReducer: _qualificationReducer2.default,
	  routing: _reactRouterRedux.routerReducer,
	  WebValuesReducer: _WebValuesReducer2.default,
	  SettingsReducer: _SettingsReducer2.default,
	  TransportationGrantReducer: _transportationGrants2.default.reducer,
	  loansReducer: _loansReducer2.default,
	  timeReducer: _time2.default.reducer,
	  teriaReducer: _teria2.default.reducer,
	  inOutReducer: _inOut2.default.reducer,
	  vacationApprovalsReducer: _vacationApprovals2.default.reducer,
	  perDiemReducer: _PerDiem2.default,
	  payticketReducer: _payTickets2.default.reducer,
	  approvalRequestsReducer: _approvalRequests2.default.reducer
	});
	// New way
	
	
	var rootReducer = function rootReducer(state, action) {
	  if (action.type === _ActionTypes.LOGOUT_FAILURE || action.type === _ActionTypes.LOGOUT_SUCCESS) {
	    var routing = state.routing;
	    return appReducer({ routing: routing }, action);
	  }
	  return appReducer(state, action);
	};
	
	var _default = rootReducer;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(appReducer, 'appReducer', 'D:/a/1/s/src/web/employee/src/reducers/index.js');
	
	  __REACT_HOT_LOADER__.register(rootReducer, 'rootReducer', 'D:/a/1/s/src/web/employee/src/reducers/index.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/reducers/index.js');
	}();

	;

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(66);
	
	var _ActionTypes = __webpack_require__(18);
	
	var _en = __webpack_require__(1378);
	
	var _en2 = _interopRequireDefault(_en);
	
	var _is = __webpack_require__(1379);
	
	var _is2 = _interopRequireDefault(_is);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  language: localStorage.language || 'is',
	  messages: _is2.default
	};
	
	// handleActions is a helper function to instead of using a switch case statement,
	// we just use the regular map with function state attach to it.
	
	var _default = (0, _reduxActions.handleActions)(_defineProperty({}, _ActionTypes.SET_LANGUAGE, function (state, _ref) {
	  var language = _ref.language;
	  return _extends({}, state, {
	    language: language,
	    messages: language === 'en' ? _en2.default : _is2.default
	  });
	}), initialState);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/reducers/languageReducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/reducers/languageReducer.js');
	}();

	;

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = loginReducer;
	
	var _config = __webpack_require__(54);
	
	var _ActionTypes = __webpack_require__(18);
	
	function loginReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    isAuthenticated: false, ssoLoading: false, user: {}, securityCode: null
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.SSO_CHECK_START:
	      return _extends({}, state, {
	        ssoLoading: true
	      });
	    case _ActionTypes.SSO_CHECK_END:
	      return _extends({}, state, {
	        ssoLoading: false
	      });
	    case _ActionTypes.LOGIN_REQUEST:
	      return _extends({}, state, {
	        loading: true,
	        isAuthenticated: false,
	        credentials: action.credentials,
	        validationErrors: null,
	        error: null
	      });
	    case _ActionTypes.LOGIN_SUCCESS:
	      return _extends({}, state, {
	        loading: false,
	        isAuthenticated: true,
	        user: action.user,
	        securityCode: null
	      });
	    case _ActionTypes.LOGIN_FAILURE:
	      return _extends({}, state, {
	        loading: false,
	        isAuthenticated: false,
	        error: action.error,
	        validationError: {},
	        ssoLoading: false,
	        securityCode: null
	      });
	    case _ActionTypes.LOGOUT_REQUEST:
	      return _extends({}, state, {
	        loading: true,
	        error: {},
	        validationError: {}
	      });
	    case _ActionTypes.LOGOUT_SUCCESS:
	      return _extends({}, state, {
	        loading: false,
	        isAuthenticated: false,
	        user: {},
	        step: _config.useSSO ? 'sso' : 'initial'
	      });
	    case _ActionTypes.LOGOUT_FAILURE:
	      return _extends({}, state, {
	        loading: false,
	        isAuthenticated: false,
	        user: {},
	        error: action.error,
	        step: _config.useSSO ? 'sso' : 'initial'
	      });
	    case _ActionTypes.LOGIN_STEP:
	      return _extends({}, state, {
	        step: action.step,
	        validationErrors: [],
	        error: null
	      });
	    case _ActionTypes.LOGIN_VALIDATION_ERRORS:
	      return _extends({}, state, {
	        validationError: action.validationError
	      });
	    case _ActionTypes.INITIALIZE_LOGIN:
	      return _extends({}, state, {
	        validationErrors: []
	      });
	    case _ActionTypes.NOT_AUTHENTICATED:
	      return _extends({}, state, {
	        isAuthenticated: false,
	        user: {}
	      });
	    case _ActionTypes.AUTHENTICATED:
	      return _extends({}, state, {
	        isAuthenticated: true,
	        user: action.user
	      });
	    case _ActionTypes.SET_DETAIL_IDS:
	      return _extends({}, state, {
	        user: _extends({}, state.user, {
	          detailIDs: action.detailIDs.map(function (x) {
	            return x.EmployeeDetailID;
	          })
	        })
	      });
	    case _ActionTypes.SET_SECURITY_CODE:
	      return _extends({}, state, {
	        securityCode: action.securityCode
	      });
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(loginReducer, 'loginReducer', 'D:/a/1/s/src/web/employee/src/reducers/loginReducer.js');
	}();

	;

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = profileReducer;
	
	var _ActionTypes = __webpack_require__(18);
	
	function profileReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case _ActionTypes.REQUEST_EMPLOYEE_MASTER:
	      return _extends({}, state, action);
	    case _ActionTypes.REQUEST_EMPLOYEE_MASTER_FAILURE:
	      return _extends({}, state, action);
	    case _ActionTypes.REQUEST_EMPLOYEE_MASTER_SUCCESS:
	      return _extends({}, state, action);
	    case _ActionTypes.REQUEST_EMPLOYEE_DETAIL_ORG:
	      return _extends({}, state, action);
	    case _ActionTypes.REQUEST_EMPLOYEE_DETAIL_ORG_FAILURE:
	      return _extends({}, state, action);
	    case _ActionTypes.REQUEST_EMPLOYEE_DETAIL_ORG_SUCCESS:
	      return _extends({}, state, action);
	    case _ActionTypes.PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_REQUEST:
	      return _extends({}, state, action);
	    case _ActionTypes.PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_SUCCESS:
	      return _extends({}, state, action);
	    case _ActionTypes.PATCH_EMPLOYEE_DETAIL_IDENTIFICATION_FAILURE:
	      return _extends({}, state, action);
	    default:
	      return state;
	  }
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(profileReducer, 'profileReducer', 'D:/a/1/s/src/web/employee/src/reducers/profileReducer.js');
	}();

	;

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(401);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _Api = __webpack_require__(21);
	
	var _config = __webpack_require__(54);
	
	var _login = __webpack_require__(144);
	
	var _language = __webpack_require__(282);
	
	var _Account = __webpack_require__(904);
	
	var _Account2 = _interopRequireDefault(_Account);
	
	var _App = __webpack_require__(433);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _SSOApp = __webpack_require__(923);
	
	var _SSOApp2 = _interopRequireDefault(_SSOApp);
	
	var _CourseEvaluation = __webpack_require__(909);
	
	var _CourseEvaluation2 = _interopRequireDefault(_CourseEvaluation);
	
	var _PageNotFound = __webpack_require__(869);
	
	var _PageNotFound2 = _interopRequireDefault(_PageNotFound);
	
	var _Profile = __webpack_require__(919);
	
	var _Profile2 = _interopRequireDefault(_Profile);
	
	var _EmployeeHoliday = __webpack_require__(912);
	
	var _EmployeeHoliday2 = _interopRequireDefault(_EmployeeHoliday);
	
	var _Payslip = __webpack_require__(918);
	
	var _Payslip2 = _interopRequireDefault(_Payslip);
	
	var _Courses = __webpack_require__(910);
	
	var _Courses2 = _interopRequireDefault(_Courses);
	
	var _Benefits = __webpack_require__(908);
	
	var _Benefits2 = _interopRequireDefault(_Benefits);
	
	var _EmployeeSearch = __webpack_require__(914);
	
	var _EmployeeSearch2 = _interopRequireDefault(_EmployeeSearch);
	
	var _Agreements = __webpack_require__(905);
	
	var _Agreements2 = _interopRequireDefault(_Agreements);
	
	var _Appraisals = __webpack_require__(907);
	
	var _Appraisals2 = _interopRequireDefault(_Appraisals);
	
	var _Appraisal = __webpack_require__(906);
	
	var _Appraisal2 = _interopRequireDefault(_Appraisal);
	
	var _PMAppraisals = __webpack_require__(935);
	
	var _PMAppraisals2 = _interopRequireDefault(_PMAppraisals);
	
	var _PMAppraisal = __webpack_require__(934);
	
	var _PMAppraisal2 = _interopRequireDefault(_PMAppraisal);
	
	var _Settings = __webpack_require__(924);
	
	var _Settings2 = _interopRequireDefault(_Settings);
	
	var _Dashboard = __webpack_require__(911);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Files = __webpack_require__(916);
	
	var _Files2 = _interopRequireDefault(_Files);
	
	var _EmployeeOrgChart = __webpack_require__(913);
	
	var _EmployeeOrgChart2 = _interopRequireDefault(_EmployeeOrgChart);
	
	var _time = __webpack_require__(449);
	
	var _time2 = _interopRequireDefault(_time);
	
	var _Teria = __webpack_require__(447);
	
	var _Teria2 = _interopRequireDefault(_Teria);
	
	var _ResetPassword = __webpack_require__(875);
	
	var _ResetPassword2 = _interopRequireDefault(_ResetPassword);
	
	var _transportationGrants = __webpack_require__(292);
	
	var _transportationGrants2 = _interopRequireDefault(_transportationGrants);
	
	var _grants = __webpack_require__(990);
	
	var _grants2 = _interopRequireDefault(_grants);
	
	var _InOut = __webpack_require__(445);
	
	var _InOut2 = _interopRequireDefault(_InOut);
	
	var _VacationApprovals = __webpack_require__(453);
	
	var _VacationApprovals2 = _interopRequireDefault(_VacationApprovals);
	
	var _Paytickets = __webpack_require__(446);
	
	var _Paytickets2 = _interopRequireDefault(_Paytickets);
	
	var _ApprovalRequests = __webpack_require__(444);
	
	var _ApprovalRequests2 = _interopRequireDefault(_ApprovalRequests);
	
	var _Pay = __webpack_require__(999);
	
	var _Pay2 = _interopRequireDefault(_Pay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// New way of doing things
	
	var authInterval = null;
	
	var Routes = function (_Component) {
	  _inherits(Routes, _Component);
	
	  function Routes(props) {
	    _classCallCheck(this, Routes);
	
	    var _this = _possibleConstructorReturn(this, (Routes.__proto__ || Object.getPrototypeOf(Routes)).call(this, props));
	
	    _this.checkLanguage = function () {
	      return _this.__checkLanguage__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.checkSSO = function () {
	      return _this.__checkSSO__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.authenticate = function () {
	      return _this.__authenticate__REACT_HOT_LOADER__.apply(_this, arguments);
	    };
	
	    _this.routes = {
	      path: '/',
	      component: _config.useSSO ? _SSOApp2.default : _App2.default,
	      onEnter: _this.checkLanguage,
	      // indexRoute: { component: Profile, name: 'Mínar Upplýsingar', onEnter: this.authenticate },
	      indexRoute: { component: _Dashboard2.default, name: 'Heim', onEnter: _this.authenticate },
	      childRoutes: [{
	        path: 'me', component: _Profile2.default, name: 'Mínar Upplýsingar', onEnter: _this.authenticate
	      }, {
	        path: 'account', component: _Account2.default, name: 'Innskráning'
	      }, {
	        path: 'search', ID: 'Search', component: _EmployeeSearch2.default, name: 'Leit', onEnter: _this.authenticate
	      }, {
	        path: 'evaluation/:CourseAttendeeID', ID: 'Learning', component: _CourseEvaluation2.default, name: 'Námskeiðsmat', onEnter: _this.authenticate
	      }, {
	        path: 'pay', ID: 'Payroll', component: _Pay2.default, name: 'Launaupplýsingar', onEnter: _this.authenticate
	      }, {
	        path: 'holiday', ID: 'Holiday', component: _EmployeeHoliday2.default, name: 'Orlof', onEnter: _this.authenticate
	      }, {
	        path: 'payslip', ID: 'PaySlip', component: _Payslip2.default, name: 'Launaseðlar', onEnter: _this.authenticate
	      }, {
	        path: 'paytickets', ID: 'PayTicket', component: _Paytickets2.default, name: 'Launaseðlar', onEnter: _this.authenticate, autoHide: true
	      }, {
	        path: 'courses', ID: 'Learning', component: _Courses2.default, name: 'Námskeið', onEnter: _this.authenticate
	      }, {
	        path: 'courses/:courseId', ID: 'Learning', component: _Courses2.default, name: 'Námskeið', onEnter: _this.authenticate
	      }, {
	        path: 'benefits', ID: 'Benefits', component: _Benefits2.default, name: 'Benefits', onEnter: _this.authenticate
	      }, {
	        path: 'grants', ID: 'Grants', component: _Benefits2.default, name: 'Grants', onEnter: _this.authenticate
	      }, {
	        path: 'grants/fitness', ID: 'FitnessGrants', component: _grants2.default.Fitness, name: 'Grants', onEnter: _this.authenticate
	      }, {
	        path: 'events', ID: 'Learning', component: _Courses2.default, name: 'Events', onEnter: _this.authenticate
	      }, {
	        path: 'events/:courseId', ID: 'Learning', component: _Courses2.default, name: 'Events', onEnter: _this.authenticate
	      }, {
	        path: 'agreements', ID: 'Agreements', component: _Agreements2.default, name: 'Agreements', onEnter: _this.authenticate
	      }, {
	        path: 'appraisals', ID: 'PM', component: _Appraisals2.default, name: 'Frammistöðumat', onEnter: _this.authenticate
	      }, {
	        path: 'appraisals/:appraisalId', ID: 'PM', component: _Appraisal2.default, name: 'Frammistöðumat', onEnter: _this.authenticate
	      }, {
	        path: 'pmappraisals', ID: 'PM', component: _PMAppraisals2.default, name: 'Frammistöðumat', onEnter: _this.authenticate
	      }, {
	        path: 'pmappraisals/:appraisalId', ID: 'PM', component: _PMAppraisal2.default, name: 'Frammistöðumat', onEnter: _this.authenticate
	      }, {
	        path: 'files', ID: 'Repository', component: _Files2.default, name: 'Rafræn skjöl', onEnter: _this.authenticate
	      }, {
	        path: 'transportation', ID: 'TransportationGrants', component: _transportationGrants2.default.TransportationGrants, name: 'Samgöngustyrkir', onEnter: _this.authenticate
	      }, {
	        path: 'teria', ID: 'Teria', component: _Teria2.default, name: 'Mötuneyti og verslanir', onEnter: _this.authenticate, autoHide: true
	      }, {
	        path: 'time', ID: 'Time', component: _time2.default.TimeOverview, name: 'Viðvera', onEnter: _this.authenticate, autoHide: true
	      }, {
	        path: 'inOut', ID: 'InOut', component: _InOut2.default, name: 'Inni/úti', onEnter: _this.authenticate, autoHide: true
	      }, {
	        path: 'vacations', ID: 'VacationApprovals', component: _VacationApprovals2.default, name: 'Orlofsbeiðnayfirlit', onEnter: _this.authenticate, autoHide: true
	      }, {
	        path: 'approvals', ID: 'ApprovalRequests', component: _ApprovalRequests2.default, name: 'Beiðnir', onEnter: _this.authenticate, autoHide: true
	      }, {
	        path: 'settings', component: _Settings2.default, name: 'Stillingar', onEnter: _this.authenticate
	      }, { path: 'resetPassword/:code', component: _ResetPassword2.default, name: 'ResetPassword' }, { path: '404', component: _PageNotFound2.default, name: '404' }, {
	        path: 'orgchart', ID: 'OrgChart', component: _EmployeeOrgChart2.default, name: 'Skipurit', onEnter: _this.authenticate
	      }, { path: '*', component: _PageNotFound2.default, name: '404' }]
	    };
	    _this.history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, _this.props.store);
	    return _this;
	  }
	
	  _createClass(Routes, [{
	    key: '__authenticate__REACT_HOT_LOADER__',
	    value: function __authenticate__REACT_HOT_LOADER__() {
	      return this.__authenticate__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__checkSSO__REACT_HOT_LOADER__',
	    value: function __checkSSO__REACT_HOT_LOADER__() {
	      return this.__checkSSO__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__checkLanguage__REACT_HOT_LOADER__',
	    value: function __checkLanguage__REACT_HOT_LOADER__() {
	      return this.__checkLanguage__REACT_HOT_LOADER__.apply(this, arguments);
	    }
	  }, {
	    key: '__checkLanguage__REACT_HOT_LOADER__',
	    value: function __checkLanguage__REACT_HOT_LOADER__() {
	      var dispatch = this.props.store.dispatch;
	
	      if (localStorage.language && (localStorage.language === 'is' || localStorage.language === 'en')) {
	        dispatch((0, _language.setLanguage)(localStorage.language));
	      } else {
	        dispatch((0, _language.setLanguage)('is'));
	      }
	    }
	  }, {
	    key: '__checkSSO__REACT_HOT_LOADER__',
	    value: function __checkSSO__REACT_HOT_LOADER__() {
	      var _props$store = this.props.store,
	          dispatch = _props$store.dispatch,
	          getState = _props$store.getState;
	      var user = getState().loginReducer.user;
	      var locationBeforeTransitions = getState().routing.locationBeforeTransitions;
	
	      if (user.sso || locationBeforeTransitions.query && locationBeforeTransitions.query.logout === 'true') {
	        return;
	      }
	      dispatch((0, _login.sso)());
	    }
	  }, {
	    key: '__authenticate__REACT_HOT_LOADER__',
	    value: function __authenticate__REACT_HOT_LOADER__(nextState, replace) {
	      if (_config.useSSO) {
	        return;
	      }
	      var _props$store2 = this.props.store,
	          dispatch = _props$store2.dispatch,
	          getState = _props$store2.getState;
	      var user = getState().loginReducer.user;
	
	      if (!(localStorage.EmployeeMasterID && localStorage.token) && !user.sso) {
	        dispatch((0, _login.notAuthenticated)());
	        var nextPathname = '' + nextState.location.pathname + nextState.location.search;
	        if (localStorage.nextPath && localStorage.nextPath !== '') {
	          nextPathname = localStorage.nextPath;
	          localStorage.nextPath = '';
	        }
	        replace({ pathname: '/account', state: { nextPathname: nextPathname } });
	        localStorage.nextPath = '' + nextState.location.pathname + nextState.location.search;
	      } else {
	        localStorage.nextPath = '';
	        if (!authInterval) {
	          authInterval = setInterval(function () {
	            var cfg = {
	              headers: {},
	              url: '/api/qdata/version'
	            };
	            if (!user.sso) {
	              cfg.headers.Authorization = 'Bearer ' + localStorage.token;
	            }
	            (0, _Api.custom)(cfg).catch(function () {
	              clearInterval(authInterval);
	              authInterval = null;
	              dispatch((0, _reactRouterRedux.push)('/account?logout=true'));
	            });
	            // s    ms
	          }, 60 * 1000);
	        }
	        dispatch((0, _login.authenticated)(_extends({}, user, {
	          userName: localStorage.userName,
	          token: !user.sso && localStorage.token,
	          EmployeeMasterID: Number(localStorage.EmployeeMasterID),
	          Gender: localStorage.Gender,
	          DefaultEmployeeDetailID: Number(localStorage.DefaultEmployeeDetailID)
	        })));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_reactRouter.Router, { history: this.history, routes: this.routes });
	    }
	  }]);
	
	  return Routes;
	}(_react.Component);
	
	Routes.propTypes = {
	  store: _propTypes2.default.object.isRequired
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref) {
	  var WebValuesReducer = _ref.WebValuesReducer;
	  return _extends({}, WebValuesReducer);
	})(Routes);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(authInterval, 'authInterval', 'D:/a/1/s/src/web/employee/src/routes.js');
	
	  __REACT_HOT_LOADER__.register(Routes, 'Routes', 'D:/a/1/s/src/web/employee/src/routes.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/routes.js');
	}();

	;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchApprovalRequests = exports.requestDetailApprovalRequestsFailure = exports.requestDetailApprovalRequestsSuccess = exports.requestDetailApprovalRequests = undefined;
	
	var _lodash = __webpack_require__(8);
	
	var _Api = __webpack_require__(21);
	
	var _constants = __webpack_require__(287);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var requestDetailApprovalRequests = exports.requestDetailApprovalRequests = function requestDetailApprovalRequests() {
	  return {
	    type: _constants.FETCH_DETAIL_APPROVAL_REQUESTS
	  };
	};
	
	var requestDetailApprovalRequestsSuccess = exports.requestDetailApprovalRequestsSuccess = function requestDetailApprovalRequestsSuccess(approvalRequests) {
	  return {
	    type: _constants.FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS,
	    approvalRequests: approvalRequests
	  };
	};
	
	var requestDetailApprovalRequestsFailure = exports.requestDetailApprovalRequestsFailure = function requestDetailApprovalRequestsFailure(error) {
	  return {
	    type: _constants.FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE,
	    error: error
	  };
	};
	
	var fetchApprovalRequests = exports.fetchApprovalRequests = function fetchApprovalRequests() {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, DefaultEmployeeDetailID, config, approvals, ordered;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              dispatch(requestDetailApprovalRequests());
	              _getState = getState(), DefaultEmployeeDetailID = _getState.loginReducer.user.DefaultEmployeeDetailID;
	              _context.prev = 2;
	              config = {
	                url: '/kjarni/api/v2/EmployeeDetailApprovalRequests',
	                method: 'GET',
	                params: {
	                  $filter: 'EmployeeDetailID eq ' + DefaultEmployeeDetailID
	                }
	              };
	              _context.t0 = _lodash.get;
	              _context.next = 7;
	              return (0, _Api.custom)(config);
	
	            case 7:
	              _context.t1 = _context.sent;
	              _context.t2 = [];
	              approvals = (0, _context.t0)(_context.t1, 'data.value', _context.t2);
	              ordered = (0, _lodash.orderBy)(approvals, ['EmployeeDetailApprovalRequestID'], ['desc']);
	
	              dispatch(requestDetailApprovalRequestsSuccess(ordered));
	              _context.next = 17;
	              break;
	
	            case 14:
	              _context.prev = 14;
	              _context.t3 = _context['catch'](2);
	
	              dispatch(requestDetailApprovalRequestsFailure(_context.t3));
	
	            case 17:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 14]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestDetailApprovalRequests, 'requestDetailApprovalRequests', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestDetailApprovalRequestsSuccess, 'requestDetailApprovalRequestsSuccess', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestDetailApprovalRequestsFailure, 'requestDetailApprovalRequestsFailure', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchApprovalRequests, 'fetchApprovalRequests', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/actions.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(287);
	
	var _reducer = __webpack_require__(989);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _ApprovalRequests = __webpack_require__(444);
	
	var _ApprovalRequests2 = _interopRequireDefault(_ApprovalRequests);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  name: _constants.name,
	  ApprovalRequests: _ApprovalRequests2.default,
	  reducer: _reducer2.default
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/index.js');
	}();

	;

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(66);
	
	var _constants = __webpack_require__(287);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  loading: false,
	  hasError: false,
	  error: null,
	  approvalRequests: []
	};
	
	var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.FETCH_DETAIL_APPROVAL_REQUESTS, function (state) {
	  return _extends({}, state, {
	    error: '',
	    hasError: false,
	    loading: true
	  });
	}), _defineProperty(_handleActions, _constants.FETCH_DETAIL_APPROVAL_REQUESTS_SUCCESS, function (state, _ref) {
	  var approvalRequests = _ref.approvalRequests;
	  return _extends({}, state, {
	    approvalRequests: approvalRequests,
	    loading: false
	  });
	}), _defineProperty(_handleActions, _constants.FETCH_DETAIL_APPROVAL_REQUESTS_FAILURE, function (state, action) {
	  return _extends({}, state, {
	    loading: false,
	    error: action.error,
	    hasError: true
	  });
	}), _handleActions), initialState);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/approvalRequests/reducer.js');
	}();

	;

/***/ }),
/* 990 */
/***/ (function(module, exports) {

	"use strict";

	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _materialUi = __webpack_require__(17);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _Pagination = __webpack_require__(443);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _localSettings = __webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ITEMS_PER_PAGE_LOCAL_KEY = 'inOutItemsPerPage';
	
	var columnStyle = {
	  whiteSpace: 'normal',
	  paddingRight: 0,
	  paddingLeft: 0,
	  border: '1px groove'
	};
	
	var InOutTable = function InOutTable(_ref) {
	  var entries = _ref.entries,
	      table = _ref.table;
	
	  var HALF_DAY_HOURS = 6;
	
	  var _useState = (0, _react.useState)({
	    top: '-9999px',
	    left: '-9999px',
	    padding: 12,
	    background: 'white',
	    position: 'absolute',
	    textAlign: 'center',
	    boxShadow: '5px 10px 18px #888888'
	  }),
	      _useState2 = _slicedToArray(_useState, 2),
	      placedDiv = _useState2[0],
	      setPlacedDiv = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      inOutHoverTexts = _useState4[0],
	      setInOutHoverTexts = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(1),
	      _useState6 = _slicedToArray(_useState5, 2),
	      currentPage = _useState6[0],
	      setCurrentPage = _useState6[1];
	
	  var _useState7 = (0, _react.useState)((0, _localSettings.getSettingByKey)(ITEMS_PER_PAGE_LOCAL_KEY) || 10),
	      _useState8 = _slicedToArray(_useState7, 2),
	      itemsPerPage = _useState8[0],
	      _setItemsPerPage = _useState8[1];
	
	  var _useState9 = (0, _react.useState)([]),
	      _useState10 = _slicedToArray(_useState9, 2),
	      dataSource = _useState10[0],
	      setDataSource = _useState10[1];
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.inOutReducer;
	  }),
	      loading = _useSelector.loading,
	      clockTypesById = _useSelector.clockTypesById;
	
	  (0, _react.useEffect)(function () {
	    var data = (0, _lodash.map)(entries, function (rec) {
	      return _extends({}, rec, { ClockCardEntries: (0, _lodash.groupBy)(rec.ClockCardEntries, function (t) {
	          return (0, _moment2.default)(t.ClockIn).format('DD/MM/YY');
	        }) });
	    });
	    setDataSource(data);
	    data.length > 0 ? setCurrentPage(1) : setCurrentPage(0);
	  }, [entries]);
	
	  var getTypeColor = function getTypeColor(clock) {
	    if (clock.Active && clock.ClockCardEntryTypeName) {
	      return (0, _lodash.get)(clockTypesById, [clock.ClockCardEntryTypeName, 'color']);
	    }
	    return _colors2.default.errorColor;
	  };
	  var getCell = function getCell(clockarr) {
	    var moreThanOneEntry = clockarr.length > 1;
	    var clock = clockarr[0];
	    var start = (0, _moment2.default)(clock.ClockIn);
	    var end = (0, _moment2.default)(clock.ClockOut);
	    var duration = _moment2.default.duration(end.diff(start));
	    var hours = duration.asHours();
	    var styleBase = {
	      color: 'white',
	      border: 'none',
	      borderRadius: 0,
	      width: '100%',
	      height: '100%',
	      display: 'flex',
	      boxShadow: 'none',
	      justifyContent: 'center'
	    };
	    if (moreThanOneEntry) {
	      return _react2.default.createElement(
	        'span',
	        {
	          key: (0, _lodash.get)(clock, 'ClockCardEntryID'),
	          style: _extends({}, styleBase, { background: _colors2.default.warningColor, alignItems: 'center' })
	        },
	        '*'
	      );
	    }
	    return _react2.default.createElement(
	      'span',
	      {
	        key: (0, _lodash.get)(clock, 'ClockCardEntryID'),
	        style: _extends({}, styleBase, hours <= HALF_DAY_HOURS && { backgroundImage: 'linear-gradient(45deg, ' + getTypeColor(clock) + ' 50%, rgba(255, 255, 255, 0) 50%)' }, hours > HALF_DAY_HOURS && { background: getTypeColor(clock) }, {
	          alignItems: hours > HALF_DAY_HOURS ? 'center' : 'end'
	        })
	      },
	      (0, _lodash.get)(clockTypesById, [clock.ClockCardEntryTypeName, 'value_short']) || 'FV'
	    );
	  };
	  var onCellHover = function onCellHover(rowNumber, colNumber, event) {
	    var row = itemsPerPage * (currentPage - 1) + rowNumber;
	    var ClockCardEntries = dataSource[row].ClockCardEntries;
	
	    var cells = (0, _lodash.get)(ClockCardEntries, (0, _lodash.get)(table.columns[colNumber - 1], 'dataIndex'));
	    if (cells) {
	      setPlacedDiv(_extends({}, placedDiv, {
	        top: event.pageY,
	        left: event.pageX + 10
	      }));
	      var hoverTexts = (0, _lodash.map)(cells, function (cell) {
	        return {
	          inOutType: (0, _lodash.get)(clockTypesById, [cell.ClockCardEntryTypeName, 'value']) || _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'inOut.type.absence' }),
	          inOutClock: (0, _moment2.default)(cell.ClockIn).format('HH:mm') + ' - ' + (0, _moment2.default)(cell.ClockOut).format('HH:mm'),
	          comment: cell.ClockCardEntryComment
	        };
	      });
	      setInOutHoverTexts(hoverTexts);
	    } else {
	      setPlacedDiv(_extends({}, placedDiv, {
	        top: -9999,
	        left: -9999
	      }));
	      setInOutHoverTexts([]);
	    }
	  };
	  return _react2.default.createElement(
	    _materialUi.Paper,
	    { style: { maxWidth: 1400, margin: 'auto' } },
	    loading && _react2.default.createElement(_materialUi.LinearProgress, { mode: 'indeterminate' }),
	    _react2.default.createElement(
	      _Pagination2.default,
	      {
	        data: dataSource,
	        itemsPerPage: itemsPerPage,
	        setItemsPerPage: function setItemsPerPage(val) {
	          (0, _localSettings.setSettingByKey)(ITEMS_PER_PAGE_LOCAL_KEY, val);
	          _setItemsPerPage(val);
	        },
	        currentPage: currentPage,
	        setCurrentPage: setCurrentPage,
	        settingsKey: ITEMS_PER_PAGE_LOCAL_KEY
	      },
	      function (currentData) {
	        return _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _materialUi.Table
	            // bodyStyle={{ overflowX: 'none', overflowY: 'none', height: 520 }}
	            ,
	            { bodyStyle: { overflowX: 'none', overflowY: 'none', minHeight: 520 },
	              fixedHeader: true,
	              onCellHover: onCellHover,
	              onRowHover: function onRowHover() {
	                return null;
	              }
	            },
	            _react2.default.createElement(
	              _materialUi.TableHeader,
	              {
	                displaySelectAll: false,
	                adjustForCheckbox: false,
	                enableSelectAll: false
	              },
	              _react2.default.createElement(
	                _materialUi.TableRow,
	                { key: 'table-key', hoverable: true },
	                (0, _lodash.map)(table.columns, function (c, i) {
	                  return _react2.default.createElement(
	                    _materialUi.TableHeaderColumn,
	                    { key: i, style: _extends({}, columnStyle, { width: c.width || 100 }, i === 0 && { paddingLeft: 8 }), className: c.isRedDay || c.isWeekend ? 'weekend-column' : '' },
	                    c.title
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _materialUi.TableBody,
	              {
	                displayRowCheckbox: false,
	                deselectOnClickaway: false,
	                showRowHover: true,
	                stripedRows: false
	              },
	              !loading ? (0, _lodash.map)(currentData, function (row, index) {
	                return _react2.default.createElement(
	                  _materialUi.TableRow,
	                  { key: index, displayBorder: true },
	                  '(',
	                  (0, _lodash.map)(table.columns, function (c, i) {
	                    return _react2.default.createElement(
	                      _materialUi.TableRowColumn,
	                      { key: i, style: _extends({}, columnStyle, { width: c.width || 100 }, i === 0 && { paddingLeft: 8 }), className: c.isRedDay || c.isWeekend ? 'weekend-column' : '' },
	                      c.render ? c.render(row[c.dataIndex]) : row[c.dataIndex],
	                      row.ClockCardEntries[c.dataIndex] ? getCell(row.ClockCardEntries[c.dataIndex]) : null
	                    );
	                  }),
	                  ')'
	                );
	              }) : null
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: placedDiv },
	            (0, _lodash.map)(inOutHoverTexts, function (t, i) {
	              return _react2.default.createElement(
	                'div',
	                { key: i },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  t.inOutType,
	                  ': ',
	                  t.inOutClock
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  t.comment
	                ),
	                i !== inOutHoverTexts.length - 1 && _react2.default.createElement(_materialUi.Divider, { style: { marginTop: 12, marginBottom: 12 } })
	              );
	            })
	          )
	        );
	      }
	    )
	  );
	};
	
	InOutTable.propTypes = {
	  table: _propTypes2.default.shape({
	    columns: _propTypes2.default.array.isRequired,
	    key: _propTypes2.default.string.isRequired
	  }).isRequired,
	  entries: _propTypes2.default.array.isRequired
	};
	
	var _default = (0, _reactRedux.connect)()(InOutTable);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(ITEMS_PER_PAGE_LOCAL_KEY, 'ITEMS_PER_PAGE_LOCAL_KEY', 'D:/a/1/s/src/web/employee/src/sites/inOut/InOutTable.js');
	
	  __REACT_HOT_LOADER__.register(columnStyle, 'columnStyle', 'D:/a/1/s/src/web/employee/src/sites/inOut/InOutTable.js');
	
	  __REACT_HOT_LOADER__.register(InOutTable, 'InOutTable', 'D:/a/1/s/src/web/employee/src/sites/inOut/InOutTable.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/inOut/InOutTable.js');
	}();

	;

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useInOutState = exports.initialize = exports.initializeFailure = exports.initializeSuccess = exports.initializeRequest = exports.changePeriod = exports.requestEntries = exports.fetchEntriesFailure = exports.fetchEntriesSuccess = exports.fetchEntriesRequest = exports.setPeriod = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(179);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(12);
	
	var _constants = __webpack_require__(226);
	
	var _api = __webpack_require__(993);
	
	var _Api = __webpack_require__(21);
	
	var _api2 = __webpack_require__(185);
	
	var _localSettings = __webpack_require__(187);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	// import { fetchEmployeeDetailOrg, fetchEmployeeMaster } from '../../actions/profile';
	
	
	var getDates = function getDates(startDate, endDate, lang) {
	  var dateArray = [];
	  var currentDate = new Date(startDate);
	  _moment2.default.locale(lang);
	  while (currentDate <= endDate) {
	    dateArray.push({
	      dateString: (0, _moment2.default)(currentDate).format('DD/MM/YY'),
	      date: (0, _moment2.default)(currentDate),
	      isWeekend: currentDate.getDay() === 6 || currentDate.getDay() === 0,
	      dayOfWeek: (0, _moment2.default)(currentDate).format('ddd')
	    });
	    currentDate.setDate(currentDate.getDate() + 1);
	  }
	  return dateArray;
	};
	
	var setCancelToken = function setCancelToken(cancelToken) {
	  return {
	    type: _constants.SET_CANCEL_TOKEN,
	    cancelToken: cancelToken
	  };
	};
	
	var setPeriod = exports.setPeriod = function setPeriod(start, end, lang) {
	  return {
	    type: _constants.SET_PERIOD,
	    start: start,
	    end: end,
	    datesBetween: getDates(start, end, lang)
	  };
	};
	
	var fetchEntriesRequest = exports.fetchEntriesRequest = function fetchEntriesRequest() {
	  return {
	    type: _constants.FETCH_RECORDS_REQUEST
	  };
	};
	
	var fetchEntriesSuccess = exports.fetchEntriesSuccess = function fetchEntriesSuccess(employees, clockTypes) {
	  return {
	    type: _constants.FETCH_RECORDS_SUCCESS,
	    employees: employees,
	    clockTypes: clockTypes
	  };
	};
	
	var fetchEntriesFailure = exports.fetchEntriesFailure = function fetchEntriesFailure(error) {
	  return {
	    type: _constants.FETCH_RECORDS_FAILURE,
	    error: error
	  };
	};
	
	var requestEntries = exports.requestEntries = function requestEntries(start, end, unitId) {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, cancelToken, language, CancelToken, source, employeesRes, employees, clockCardTypes, clockTypes;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _getState = getState(), cancelToken = _getState.inOutReducer.cancelToken, language = _getState.languageReducer.language;
	
	              if (cancelToken) {
	                cancelToken.cancel();
	              }
	              _context.prev = 2;
	              CancelToken = _axios2.default.CancelToken;
	              source = CancelToken.source();
	
	              dispatch(setCancelToken(source));
	              dispatch(fetchEntriesRequest());
	              _context.next = 9;
	              return (0, _Api.custom)((0, _api.getInOutEntries)(start, end, unitId, source.token));
	
	            case 9:
	              employeesRes = _context.sent;
	              employees = (0, _lodash.get)(employeesRes, 'data.value', []);
	              clockCardTypes = [];
	
	              (0, _lodash.map)(employees, function (emp) {
	                return (0, _lodash.map)(emp.ClockCardEntries, function (clock) {
	                  if (clock.Active && clock.ClockCardEntryTypeName) {
	                    clockCardTypes.push({
	                      id: clock.ClockCardEntryTypeName,
	                      value: language === 'is' ? clock.ClockCardEntryTypeName : clock.ClockCardEntryTypeName
	                    });
	                  }
	                });
	              });
	              clockTypes = (0, _lodash.unionBy)(clockCardTypes, 'id');
	
	              dispatch(setCancelToken(null));
	              dispatch(fetchEntriesSuccess(employees, clockTypes));
	              _context.next = 21;
	              break;
	
	            case 18:
	              _context.prev = 18;
	              _context.t0 = _context['catch'](2);
	
	              if (!_axios2.default.isCancel(_context.t0)) {
	                dispatch(fetchEntriesFailure(_context.t0));
	              }
	
	            case 21:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 18]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var changePeriod = exports.changePeriod = function changePeriod(start, end, unitIds) {
	  return function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	      var _getState2, language, ids;
	
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _getState2 = getState(), language = _getState2.languageReducer.language;
	              ids = void 0;
	              // if unitIds is [null], then we want to get all units by setting ids to null
	
	              if (unitIds.length === 1 && unitIds[0] === null) {
	                ids = null;
	              } else {
	                ids = unitIds;
	              }
	              dispatch(setPeriod(start.startOf('day'), end.endOf('day'), language));
	              dispatch(requestEntries(start.startOf('day'), end.endOf('day'), ids));
	
	            case 5:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x3, _x4) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	
	var initializeRequest = exports.initializeRequest = function initializeRequest() {
	  return {
	    type: _constants.INITIALIZE_REQUEST
	  };
	};
	
	var initializeSuccess = exports.initializeSuccess = function initializeSuccess(periodFrom, orgCompanyUnits, defaultCompanyUnitID, clockTypesById, inOutFilters) {
	  return {
	    type: _constants.INITIALIZE_SUCCESS,
	    periodFrom: periodFrom,
	    orgCompanyUnits: orgCompanyUnits,
	    defaultCompanyUnitID: defaultCompanyUnitID,
	    clockTypesById: clockTypesById,
	    inOutFilters: inOutFilters
	  };
	};
	
	var initializeFailure = exports.initializeFailure = function initializeFailure(error) {
	  return {
	    type: _constants.INITIALIZE_FAILURE,
	    error: error
	  };
	};
	
	var initialize = exports.initialize = function initialize() {
	  return function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	      var _getState3, language, valuesByKey, _getState3$loginReduc, EmployeeMasterID, DefaultEmployeeDetailID, employeeDetailOrgList, requests, _ref4, _ref5, xapRes, periodFrom, startDate, endDate, defaultCompanyUnitID, employeeDetailOrgs, orgCompanyUnits, customOrgCompanyUnitsWebValue, allOrgCompanyUnits, customOrgCompanyUnitsIds, clockTypes, i, j, allColors, clockTypesById, inOutFilters, units;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _getState3 = getState(), language = _getState3.languageReducer.language, valuesByKey = _getState3.WebValuesReducer.valuesByKey, _getState3$loginReduc = _getState3.loginReducer.user, EmployeeMasterID = _getState3$loginReduc.EmployeeMasterID, DefaultEmployeeDetailID = _getState3$loginReduc.DefaultEmployeeDetailID, employeeDetailOrgList = _getState3.profileReducer.employeeDetailOrgList;
	              _context3.prev = 1;
	
	              dispatch(initializeRequest());
	              requests = [(0, _Api.custom)((0, _api.getXapValue)('Pay.PeriodFrom'))];
	              _context3.next = 6;
	              return Promise.all(requests);
	
	            case 6:
	              _ref4 = _context3.sent;
	              _ref5 = _slicedToArray(_ref4, 1);
	              xapRes = _ref5[0];
	              periodFrom = (0, _lodash.get)(xapRes, 'data.value[0].Value') || '1';
	              startDate = (0, _moment2.default)().date(periodFrom).add(-1, 'months').startOf('day');
	              endDate = (0, _moment2.default)().date(periodFrom - 1).endOf('day');
	
	              if (endDate.isSameOrBefore((0, _moment2.default)())) {
	                startDate = startDate.add(1, 'months');
	                endDate = startDate.clone().add(1, 'months').add(-1, 'days').endOf('day');
	              }
	
	              defaultCompanyUnitID = void 0;
	
	              if (!(!employeeDetailOrgList || !employeeDetailOrgList.length)) {
	                _context3.next = 25;
	                break;
	              }
	
	              _context3.t0 = _lodash.get;
	              _context3.next = 18;
	              return (0, _Api.custom)((0, _api.getEmployeeDetailOrg)(EmployeeMasterID));
	
	            case 18:
	              _context3.t1 = _context3.sent;
	              _context3.next = 21;
	              return (0, _context3.t0)(_context3.t1, 'data');
	
	            case 21:
	              employeeDetailOrgs = _context3.sent;
	
	              defaultCompanyUnitID = (0, _lodash.get)((0, _lodash.find)(employeeDetailOrgs, function (unit) {
	                return unit.Entity.EmployeeDetailID === DefaultEmployeeDetailID;
	              }), 'Entity.OrgCompanyUnitID');
	              _context3.next = 26;
	              break;
	
	            case 25:
	              defaultCompanyUnitID = (0, _lodash.get)((0, _lodash.find)(employeeDetailOrgList, function (unit) {
	                return unit.EmployeeDetailID === DefaultEmployeeDetailID;
	              }), 'OrgCompanyUnitID');
	
	            case 26:
	              orgCompanyUnits = [];
	              customOrgCompanyUnitsWebValue = (0, _lodash.get)(valuesByKey, ['InOut.OrgCompanyUnitsIDs', 'Value']);
	              _context3.t2 = _lodash.get;
	              _context3.next = 31;
	              return (0, _Api.custom)((0, _api.getOrgCompanyUnits)());
	
	            case 31:
	              _context3.t3 = _context3.sent;
	              _context3.t4 = [];
	              allOrgCompanyUnits = (0, _context3.t2)(_context3.t3, 'data.value', _context3.t4);
	
	
	              if (customOrgCompanyUnitsWebValue) {
	                customOrgCompanyUnitsIds = (0, _lodash.map)((0, _lodash.split)((0, _lodash.get)(valuesByKey, ['InOut.OrgCompanyUnitsIDs', 'Value']), ','), function (id) {
	                  return parseInt((0, _lodash.trim)(id), 10);
	                });
	                // we need to add defaultCompanyUnitID to the list if it is not there
	
	                customOrgCompanyUnitsIds.push(defaultCompanyUnitID);
	                orgCompanyUnits = (0, _lodash.filter)(allOrgCompanyUnits, function (unit) {
	                  return (0, _lodash.includes)((0, _lodash.uniq)(customOrgCompanyUnitsIds), unit.OrgCompanyUnitID);
	                });
	              } else {
	                orgCompanyUnits = allOrgCompanyUnits;
	              }
	
	              _context3.t5 = _lodash.get;
	              _context3.next = 38;
	              return (0, _Api.custom)(_api2.getClockCardEntryTypes);
	
	            case 38:
	              _context3.t6 = _context3.sent;
	              _context3.t7 = [];
	              clockTypes = (0, _context3.t5)(_context3.t6, 'data.value', _context3.t7);
	              i = 1;
	              j = 0;
	              allColors = ['#3B53A7', '#77BB97', '#A07CEF', '#F7A548', '#6D85C6', '#8F36AA', '#419488', '#52BAD1', '#97C05C', '#667C89', '#9E9E9E', '#5E36B3', '#93382C', '#FBAEA7'];
	              clockTypesById = clockTypes.reduce(function (acc, elem) {
	                if (elem.ClockCardEntryTypeRule === 'Daytime') {
	                  var shortKey = (0, _lodash.upperCase)(elem.ClockCardEntryTypeName.slice(0, 2)).replace(/ /g, '');
	                  (0, _lodash.mapValues)(acc, function (item) {
	                    var shortKeyExists = Object.values(item).includes(shortKey);
	                    if (shortKeyExists) {
	                      shortKey = '' + elem.ClockCardEntryTypeName.slice(0, 1) + i;
	                      i += 1;
	                    }
	                  });
	                  acc[elem.ClockCardEntryTypeName] = {
	                    id: elem.ClockCardEntryTypeName,
	                    color: allColors[j % (allColors.length - 1)],
	                    value: language === 'is' ? elem.ClockCardEntryTypeName : elem.ClockCardEntryTypeName,
	                    value_en: elem.ClockCardEntryTypeName,
	                    value_short: shortKey
	                  };
	                  j += 1;
	                }
	                return acc;
	              }, {});
	              inOutFilters = (0, _localSettings.getSettingByKey)(_constants.IN_OUT_FILTERS) || {
	                orgCompanyUnitId: [defaultCompanyUnitID],
	                employeeId: [],
	                typeId: []
	              };
	              units = (0, _lodash.get)(inOutFilters, 'orgCompanyUnitId', [defaultCompanyUnitID]);
	
	
	              units = units.includes(null) ? (0, _lodash.map)(orgCompanyUnits, 'OrgCompanyUnitID') : units;
	              dispatch(initializeSuccess(periodFrom, orgCompanyUnits, defaultCompanyUnitID, clockTypesById, inOutFilters));
	              dispatch(changePeriod(startDate, endDate, units));
	              _context3.next = 55;
	              break;
	
	            case 52:
	              _context3.prev = 52;
	              _context3.t8 = _context3['catch'](1);
	
	              dispatch(initializeFailure((0, _lodash.get)(_context3.t8, 'message')));
	
	            case 55:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[1, 52]]);
	    }));
	
	    return function (_x5, _x6) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	};
	
	var useInOutState = exports.useInOutState = function useInOutState() {
	  return (0, _reactRedux.useSelector)(function (state) {
	    return state.inOutReducer;
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getDates, 'getDates', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	
	  __REACT_HOT_LOADER__.register(setCancelToken, 'setCancelToken', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	
	  __REACT_HOT_LOADER__.register(setPeriod, 'setPeriod', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchEntriesRequest, 'fetchEntriesRequest', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchEntriesSuccess, 'fetchEntriesSuccess', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchEntriesFailure, 'fetchEntriesFailure', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestEntries, 'requestEntries', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	
	  __REACT_HOT_LOADER__.register(changePeriod, 'changePeriod', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeRequest, 'initializeRequest', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeSuccess, 'initializeSuccess', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeFailure, 'initializeFailure', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	
	  __REACT_HOT_LOADER__.register(initialize, 'initialize', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	
	  __REACT_HOT_LOADER__.register(useInOutState, 'useInOutState', 'D:/a/1/s/src/web/employee/src/sites/inOut/actions.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getXapValue = exports.getXapValue = function getXapValue(val) {
	  return {
	    url: '/kjarni/api/v2/XapValues',
	    method: 'GET',
	    params: {
	      $filter: 'XapValueName eq \'' + val + '\''
	    }
	  };
	};
	
	var getWorkingHours = exports.getWorkingHours = function getWorkingHours(detailId) {
	  return {
	    url: '/kjarni/api/v2/EmployeeDetailWorkingHours',
	    method: 'GET',
	    params: {
	      $filter: 'EmployeeDetailID eq ' + detailId
	    }
	  };
	};
	
	var getEmployeeDetailOrg = exports.getEmployeeDetailOrg = function getEmployeeDetailOrg(masterId) {
	  return {
	    url: '/api/QDataWebModel/EmployeeDetailOrg',
	    method: 'GET',
	    params: {
	      $filter: 'Entity/EmployeeDetailID ge ' + masterId + '1 and Entity/EmployeeDetailID le ' + masterId + '9 and (Entity/EmployeeStatus eq \'0\' or (Entity/EmployeeStatus ge \'4\'  and Entity/EmployeeStatus le \'7\')) and Entity/Begda le datetime\'' + new Date().toISOString() + '\' and Entity/Endda ge datetime\'' + new Date().toISOString() + '\''
	    }
	  };
	};
	
	var getInOutEntries = exports.getInOutEntries = function getInOutEntries(dateFrom, dateTo, unitId, cancelToken) {
	  return {
	    url: '/kjarni/api/v2/ClockCardEntries/ByPeriodAndUnitId',
	    method: 'POST',
	    data: {
	      unitIds: unitId,
	      dateFrom: dateFrom,
	      dateTo: dateTo
	    },
	    cancelToken: cancelToken
	  };
	};
	
	var getOrgCompanyUnits = exports.getOrgCompanyUnits = function getOrgCompanyUnits() {
	  return {
	    url: '/kjarni/api/v2/OrgCompanyUnits',
	    method: 'GET'
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getXapValue, 'getXapValue', 'D:/a/1/s/src/web/employee/src/sites/inOut/api.js');
	
	  __REACT_HOT_LOADER__.register(getWorkingHours, 'getWorkingHours', 'D:/a/1/s/src/web/employee/src/sites/inOut/api.js');
	
	  __REACT_HOT_LOADER__.register(getEmployeeDetailOrg, 'getEmployeeDetailOrg', 'D:/a/1/s/src/web/employee/src/sites/inOut/api.js');
	
	  __REACT_HOT_LOADER__.register(getInOutEntries, 'getInOutEntries', 'D:/a/1/s/src/web/employee/src/sites/inOut/api.js');
	
	  __REACT_HOT_LOADER__.register(getOrgCompanyUnits, 'getOrgCompanyUnits', 'D:/a/1/s/src/web/employee/src/sites/inOut/api.js');
	}();

	;

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(226);
	
	var _reducer = __webpack_require__(995);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _InOut = __webpack_require__(445);
	
	var _InOut2 = _interopRequireDefault(_InOut);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  name: _constants.name,
	  InOut: _InOut2.default,
	  reducer: _reducer2.default
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/inOut/index.js');
	}();

	;

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(66);
	
	__webpack_require__(8);
	
	var _constants = __webpack_require__(226);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  inOut: {
	    employees: [],
	    clockTypes: [],
	    clockTypesById: {},
	    datesBetween: [],
	    loading: false,
	    error: '',
	    hasError: false,
	    start: {},
	    end: {},
	    initialized: false,
	    initializing: false,
	    initializeFailed: false,
	    periodFrom: '1',
	    cancelToken: null
	  }
	};
	
	var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.FETCH_RECORDS_REQUEST, function (state) {
	  return _extends({}, state, {
	    fetchingEntries: true,
	    employees: [],
	    error: '',
	    hasError: false,
	    loading: true
	  });
	}), _defineProperty(_handleActions, _constants.FETCH_RECORDS_SUCCESS, function (state, _ref) {
	  var employees = _ref.employees,
	      clockTypes = _ref.clockTypes;
	  return _extends({}, state, {
	    clockTypes: clockTypes,
	    employees: employees,
	    loading: false
	  });
	}), _defineProperty(_handleActions, _constants.FETCH_RECORDS_FAILURE, function (state, action) {
	  return _extends({}, state, {
	    loading: false,
	    error: action.error,
	    hasError: true
	  });
	}), _defineProperty(_handleActions, _constants.INITIALIZE_REQUEST, function (state) {
	  return _extends({}, state, {
	    initialized: false,
	    initializing: true,
	    error: '',
	    hasError: false,
	    initializeFailed: false,
	    loading: true
	  });
	}), _defineProperty(_handleActions, _constants.INITIALIZE_SUCCESS, function (state, _ref2) {
	  var periodFrom = _ref2.periodFrom,
	      orgCompanyUnits = _ref2.orgCompanyUnits,
	      defaultCompanyUnitID = _ref2.defaultCompanyUnitID,
	      clockTypesById = _ref2.clockTypesById,
	      inOutFilters = _ref2.inOutFilters;
	  return _extends({}, state, {
	    initialized: true,
	    initializing: false,
	    periodFrom: periodFrom,
	    orgCompanyUnits: orgCompanyUnits,
	    clockTypesById: clockTypesById,
	    defaultCompanyUnitID: defaultCompanyUnitID,
	    inOutFilters: inOutFilters,
	    initializeFailed: false,
	    loading: false
	  });
	}), _defineProperty(_handleActions, _constants.INITIALIZE_FAILURE, function (state, _ref3) {
	  var error = _ref3.error;
	  return _extends({}, state, {
	    error: error,
	    hasError: true,
	    initialized: false,
	    initializing: false,
	    initializeFailed: true,
	    loading: false
	  });
	}), _defineProperty(_handleActions, _constants.SET_PERIOD, function (state, _ref4) {
	  var start = _ref4.start,
	      end = _ref4.end,
	      datesBetween = _ref4.datesBetween;
	  return _extends({}, state, {
	    start: start,
	    end: end,
	    datesBetween: datesBetween
	  });
	}), _defineProperty(_handleActions, _constants.SET_CANCEL_TOKEN, function (state, action) {
	  return _extends({}, state, {
	    cancelToken: action.cancelToken
	  });
	}), _handleActions), initialState.inOut);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/sites/inOut/reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/inOut/reducer.js');
	}();

	;

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fetchUserPaytickets = exports.requestPayticketFailure = exports.requestPayticketSuccess = exports.requestPayticket = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _lodash = __webpack_require__(8);
	
	var _Api = __webpack_require__(21);
	
	var _constants = __webpack_require__(288);
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var requestPayticket = exports.requestPayticket = function requestPayticket() {
	  return {
	    type: _constants.FETCH_TICKETS_REQUEST
	  };
	};
	
	var requestPayticketSuccess = exports.requestPayticketSuccess = function requestPayticketSuccess(paytickets, orgCompanyIds) {
	  return {
	    type: _constants.FETCH_TICKETS_SUCCESS,
	    paytickets: paytickets,
	    orgCompanyIds: orgCompanyIds
	  };
	};
	
	var requestPayticketFailure = exports.requestPayticketFailure = function requestPayticketFailure(error) {
	  return {
	    type: _constants.FETCH_TICKETS_FAILURE,
	    error: error
	  };
	};
	
	var fetchUserPaytickets = exports.fetchUserPaytickets = function fetchUserPaytickets(year) {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, EmployeeMasterID, employeeDetailOrgList, orgCompanyIds, orgCompIds, now, fetchConfig, orgs, requests, res, tickets, paytickets;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              dispatch(requestPayticket());
	              _getState = getState(), EmployeeMasterID = _getState.loginReducer.user.EmployeeMasterID, employeeDetailOrgList = _getState.profileReducer.employeeDetailOrgList, orgCompanyIds = _getState.payticketReducer.orgCompanyIds;
	              _context.prev = 2;
	              orgCompIds = [];
	
	              if (!orgCompanyIds) {
	                _context.next = 8;
	                break;
	              }
	
	              orgCompIds = orgCompanyIds;
	              _context.next = 20;
	              break;
	
	            case 8:
	              if (!employeeDetailOrgList) {
	                _context.next = 12;
	                break;
	              }
	
	              orgCompIds = (0, _lodash.map)(employeeDetailOrgList, function (o) {
	                return (0, _lodash.get)(o, 'Entity.OrgCompanyID');
	              });
	              _context.next = 20;
	              break;
	
	            case 12:
	              now = new Date().toISOString();
	              fetchConfig = {
	                url: '/api/QDataWebModel/EmployeeDetailOrg',
	                method: 'GET',
	                params: {
	                  $filter: 'Entity/EmployeeDetailID ge ' + EmployeeMasterID + '1 and Entity/EmployeeDetailID le ' + EmployeeMasterID + '9 and (Entity/EmployeeStatus eq \'0\' or (Entity/EmployeeStatus ge \'4\'  and Entity/EmployeeStatus le \'7\')) and Entity/Begda le datetime\'' + now + '\' and Entity/Endda ge datetime\'' + now + '\''
	                }
	              };
	              _context.t0 = _lodash.get;
	              _context.next = 17;
	              return (0, _Api.custom)(fetchConfig);
	
	            case 17:
	              _context.t1 = _context.sent;
	              orgs = (0, _context.t0)(_context.t1, 'data');
	
	              orgCompIds = (0, _lodash.map)(orgs, function (o) {
	                return (0, _lodash.get)(o, 'Entity.OrgCompanyID');
	              });
	
	            case 20:
	              requests = (0, _lodash.map)(orgCompIds, function (orgCompId) {
	                return (0, _Api.custom)({
	                  url: '/api/PaySalary/Fetch',
	                  method: 'POST',
	                  data: {
	                    EmployeeMasterID: EmployeeMasterID,
	                    PayYear: year,
	                    OrgCompanyID: orgCompId
	                  }
	                });
	              });
	              _context.next = 23;
	              return Promise.all(requests);
	
	            case 23:
	              res = _context.sent;
	              tickets = (0, _lodash.map)(res, function (r) {
	                return (0, _lodash.get)(r, 'data');
	              });
	              paytickets = [];
	
	              (0, _lodash.map)(tickets, function (_ref2) {
	                var Employees = _ref2.Employees,
	                    Header = _ref2.Header;
	
	                if (!Employees.length) return;
	                var employee = Employees[0];
	                var firstRow = [];
	                var restRows = [];
	                (0, _lodash.map)(employee.Columns, function (col) {
	                  if (col.SkNr === -1) {
	                    firstRow.push({
	                      PaySalaryID: col.PaySalaryID,
	                      PaySalaryName: col.PaySalaryName,
	                      Samtals: col.Samtals,
	                      SkNr: '',
	                      TotalPayField: ''
	                    });
	                  }
	                });
	                if (firstRow.length) {
	                  restRows.push({
	                    PaySalaryID: '',
	                    PaySalaryName: '',
	                    Samtals: '',
	                    SkNr: -1,
	                    TotalPayField: (0, _lodash.sumBy)(firstRow, 'Samtals')
	                  });
	                }
	                (0, _lodash.map)(employee.Columns, function (col) {
	                  if (col.SkNr !== -1) {
	                    restRows.push({
	                      PaySalaryID: col.PaySalaryID,
	                      PaySalaryName: col.PaySalaryName,
	                      Samtals: col.Samtals,
	                      SkNr: '',
	                      TotalPayField: ''
	                    });
	                    restRows.push({
	                      PaySalaryID: '',
	                      PaySalaryName: '',
	                      Samtals: '',
	                      SkNr: col.SkNr,
	                      TotalPayField: (0, _lodash.get)(col, 'Samtals')
	                    });
	                  }
	                });
	                paytickets.push(_extends({}, employee, {
	                  Header: Header,
	                  firstRow: firstRow,
	                  restRows: restRows
	                }));
	              });
	              dispatch(requestPayticketSuccess(paytickets, orgCompIds));
	              _context.next = 33;
	              break;
	
	            case 30:
	              _context.prev = 30;
	              _context.t2 = _context['catch'](2);
	
	              dispatch(requestPayticketFailure(_context.t2));
	
	            case 33:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 30]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(requestPayticket, 'requestPayticket', 'D:/a/1/s/src/web/employee/src/sites/payTickets/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestPayticketSuccess, 'requestPayticketSuccess', 'D:/a/1/s/src/web/employee/src/sites/payTickets/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestPayticketFailure, 'requestPayticketFailure', 'D:/a/1/s/src/web/employee/src/sites/payTickets/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchUserPaytickets, 'fetchUserPaytickets', 'D:/a/1/s/src/web/employee/src/sites/payTickets/actions.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(288);
	
	var _reducer = __webpack_require__(998);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _Paytickets = __webpack_require__(446);
	
	var _Paytickets2 = _interopRequireDefault(_Paytickets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  name: _constants.name,
	  Paytickets: _Paytickets2.default,
	  reducer: _reducer2.default
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/payTickets/index.js');
	}();

	;

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(66);
	
	var _range = __webpack_require__(207);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _constants = __webpack_require__(288);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var yearNow = new Date().getFullYear();
	var initialState = {
	  payTickets: {
	    initialized: false,
	    initializing: false,
	    initializeFailed: false,
	    error: null,
	    hasError: false,
	    loaded: false,
	    loading: false,
	    paytickets: [],
	    payticketsLoaded: false,
	    payYear: yearNow,
	    payYearOptions: (0, _range2.default)(2010, yearNow + 1)
	  }
	};
	
	var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.FETCH_TICKETS_REQUEST, function (state) {
	  return _extends({}, state, {
	    fetchingEntries: true,
	    error: '',
	    hasError: false,
	    loading: true
	  });
	}), _defineProperty(_handleActions, _constants.FETCH_TICKETS_SUCCESS, function (state, _ref) {
	  var paytickets = _ref.paytickets,
	      orgCompanyIds = _ref.orgCompanyIds;
	  return _extends({}, state, {
	    paytickets: paytickets,
	    orgCompanyIds: orgCompanyIds,
	    loading: false
	  });
	}), _defineProperty(_handleActions, _constants.FETCH_TICKETS_FAILURE, function (state, action) {
	  return _extends({}, state, {
	    loading: false,
	    error: action.error,
	    hasError: true
	  });
	}), _handleActions), initialState.payTickets);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(yearNow, 'yearNow', 'D:/a/1/s/src/web/employee/src/sites/payTickets/reducer.js');
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/sites/payTickets/reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/payTickets/reducer.js');
	}();

	;

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _lodash = __webpack_require__(8);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reactRedux = __webpack_require__(12);
	
	var _valuesByKey = __webpack_require__(92);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _profile = __webpack_require__(118);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _EmployeeBank = __webpack_require__(926);
	
	var _EmployeeBank2 = _interopRequireDefault(_EmployeeBank);
	
	var _EmployeeTaxCards = __webpack_require__(931);
	
	var _EmployeeTaxCards2 = _interopRequireDefault(_EmployeeTaxCards);
	
	var _KTabs = __webpack_require__(223);
	
	var _KTabs2 = _interopRequireDefault(_KTabs);
	
	var _KTab = __webpack_require__(222);
	
	var _KTab2 = _interopRequireDefault(_KTab);
	
	var _Bonuses = __webpack_require__(925);
	
	var _Bonuses2 = _interopRequireDefault(_Bonuses);
	
	var _EmployeePension = __webpack_require__(929);
	
	var _EmployeePension2 = _interopRequireDefault(_EmployeePension);
	
	var _EmployeeUnion = __webpack_require__(932);
	
	var _EmployeeUnion2 = _interopRequireDefault(_EmployeeUnion);
	
	var _EmployeePayUnion = __webpack_require__(928);
	
	var _EmployeePayUnion2 = _interopRequireDefault(_EmployeePayUnion);
	
	__webpack_require__(1833);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Pay = function Pay() {
	  var dispatch = (0, _reactRedux.useDispatch)();
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state;
	  }),
	      profileReducer = _useSelector.profileReducer,
	      WebValuesReducer = _useSelector.WebValuesReducer;
	
	  var employeeDetailOrgListLoaded = profileReducer.employeeDetailOrgListLoaded,
	      employeeDetailOrgList = profileReducer.employeeDetailOrgList,
	      masterError = profileReducer.masterError;
	  var valuesByKey = WebValuesReducer.valuesByKey;
	
	  var show = function show(key) {
	    return (0, _valuesByKey.shouldNotHide)(valuesByKey, key);
	  };
	
	  (0, _react.useEffect)(function () {
	    dispatch((0, _profile.fetchProfileIfNeeded)());
	  }, []);
	
	  if (!employeeDetailOrgListLoaded) return _react2.default.createElement(_Loading2.default, null);
	
	  if (masterError) {
	    return _react2.default.createElement(_PanelMessage2.default, {
	      message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.initialize.error' }),
	      iconName: 'error',
	      type: 'error'
	    });
	  }
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_KTitle2.default, { containerStyle: { maxWidth: 1400, margin: 'auto', marginTop: 12 }, key: 'hb', title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'toolbar.payroll' }) })
	    ),
	    _react2.default.createElement(
	      _reactFlexboxGrid.Grid,
	      null,
	      _react2.default.createElement(
	        _reactFlexboxGrid.Row,
	        null,
	        _react2.default.createElement(
	          _reactFlexboxGrid.Col,
	          { xs: 12, lg: 6, style: { padding: 16 } },
	          show('EmployeeMasterBank') && _react2.default.createElement(_EmployeeBank2.default, null),
	          show('EmployeeMasterTaxCards') && _react2.default.createElement(_EmployeeTaxCards2.default, null)
	        ),
	        _react2.default.createElement(
	          _reactFlexboxGrid.Col,
	          { xs: 12, lg: 6, style: { padding: 16 }, className: 'pay-info-desktop' },
	          _react2.default.createElement(
	            _KTabs2.default,
	            { style: { marginTop: 12 } },
	            (0, _lodash.map)(employeeDetailOrgList, function (obj, i) {
	              return _react2.default.createElement(
	                _KTab2.default,
	                { style: { padding: 12 }, key: i, name: obj.OrgCompanyPositionName },
	                show('EmployeeDetailBasicPay.Bonuses') && _react2.default.createElement(_Bonuses2.default, { detailId: obj.EmployeeDetailID }),
	                show('EmployeeDetailPension') && _react2.default.createElement(_EmployeePension2.default, { detailId: obj.EmployeeDetailID }),
	                show('EmployeeDetailUnion') && _react2.default.createElement(_EmployeePayUnion2.default, { detailId: obj.EmployeeDetailID }),
	                show('EmployeeDetailUnion') && _react2.default.createElement(_EmployeeUnion2.default, { detailId: obj.EmployeeDetailID })
	              );
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	// import cardStyles from '../../containers/pay/styles/Cards';
	
	
	// import { Subheader } from 'material-ui';
	var _default = Pay;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Pay, 'Pay', 'D:/a/1/s/src/web/employee/src/sites/pay/Pay.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/pay/Pay.js');
	}();

	;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _lodash = __webpack_require__(8);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactIntl = __webpack_require__(5);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var columnStyle = {
	  whiteSpace: 'normal',
	  paddingRight: 12
	};
	
	var PurchasesTable = function PurchasesTable(_ref) {
	  var entries = _ref.entries,
	      table = _ref.table,
	      showTitle = _ref.showTitle;
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.teriaReducer;
	  }),
	      loading = _useSelector.loading;
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    showTitle ? _react2.default.createElement(_KTitle2.default, {
	      containerStyle: { marginBottom: 0, marginTop: 12 },
	      style: {
	        fontSize: 18,
	        fontWeight: 'normal',
	        marginBottom: 0,
	        marginLeft: 12
	      },
	      subtitleStyle: { marginLeft: 0 },
	      title: table.title
	    }) : '',
	    _react2.default.createElement(
	      _materialUi.Paper,
	      { style: { margin: 12 } },
	      _react2.default.createElement(
	        _materialUi.Table,
	        {
	          bodyStyle: { overflowX: 'none', overflowY: 'none' },
	          fixedHeader: true
	        },
	        _react2.default.createElement(
	          _materialUi.TableHeader,
	          {
	            displaySelectAll: false,
	            adjustForCheckbox: false,
	            enableSelectAll: false
	          },
	          _react2.default.createElement(
	            _materialUi.TableRow,
	            { key: 'table-key' },
	            (0, _lodash.map)(table.columns, function (c, i) {
	              return _react2.default.createElement(
	                _materialUi.TableHeaderColumn,
	                { key: i, style: _extends({}, columnStyle, { width: c.width || 100 }) },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: c.title })
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _materialUi.TableBody,
	          {
	            displayRowCheckbox: false,
	            deselectOnClickaway: false,
	            showRowHover: false,
	            stripedRows: false
	          },
	          !loading ? (0, _lodash.map)(entries, function (data, index) {
	            return _react2.default.createElement(
	              _materialUi.TableRow,
	              { key: index },
	              '(',
	              (0, _lodash.map)(table.columns, function (c, i) {
	                return _react2.default.createElement(
	                  _materialUi.TableRowColumn,
	                  { key: i, style: _extends({}, columnStyle, { width: c.width || 100 }) },
	                  c.render ? c.render(data[c.dataIndex]) : data[c.dataIndex]
	                );
	              }),
	              ')'
	            );
	          }) : null
	        )
	      )
	    )
	  );
	};
	
	PurchasesTable.propTypes = {
	  table: _propTypes2.default.shape({
	    title: _propTypes2.default.object.isRequired,
	    columns: _propTypes2.default.array.isRequired,
	    key: _propTypes2.default.string.isRequired
	  }).isRequired,
	  entries: _propTypes2.default.array.isRequired,
	  showTitle: _propTypes2.default.bool.isRequired
	};
	
	var _default = (0, _reactRedux.connect)()(PurchasesTable);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(columnStyle, 'columnStyle', 'D:/a/1/s/src/web/employee/src/sites/teria/PurchasesTable.js');
	
	  __REACT_HOT_LOADER__.register(PurchasesTable, 'PurchasesTable', 'D:/a/1/s/src/web/employee/src/sites/teria/PurchasesTable.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/teria/PurchasesTable.js');
	}();

	;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useTeriaState = exports.initialize = exports.initializeFailure = exports.initializeSuccess = exports.initializeRequest = exports.changePeriod = exports.requestEntries = exports.fetchPurchasesFailure = exports.fetchPurchasesSuccess = exports.fetchPurchasesRequest = exports.setPeriod = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(12);
	
	var _constants = __webpack_require__(289);
	
	var _api = __webpack_require__(1002);
	
	var _Api = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	var getDates = function getDates(startDate, endDate) {
	  var dateArray = [];
	  var currentDate = new Date(startDate);
	  while (currentDate <= endDate) {
	    dateArray.push({
	      dateString: (0, _moment2.default)(currentDate).format('DD/MM/YY'),
	      date: (0, _moment2.default)(currentDate),
	      isWeekend: currentDate.getDay() === 6 || currentDate.getDay() === 0,
	      dayOfWeek: (0, _moment2.default)(currentDate).format('ddd')
	    });
	    currentDate.setDate(currentDate.getDate() + 1);
	  }
	  return dateArray;
	};
	
	var setPeriod = exports.setPeriod = function setPeriod(start, end) {
	  return {
	    type: _constants.SET_PERIOD,
	    start: start,
	    end: end,
	    datesBetween: getDates(start, end)
	  };
	};
	
	var fetchPurchasesRequest = exports.fetchPurchasesRequest = function fetchPurchasesRequest() {
	  return {
	    type: _constants.FETCH_PURCHASES_REQUEST
	  };
	};
	
	var fetchPurchasesSuccess = exports.fetchPurchasesSuccess = function fetchPurchasesSuccess(employeePurchases, guestPurchases) {
	  return {
	    type: _constants.FETCH_PURCHASES_SUCCESS,
	    employeePurchases: employeePurchases,
	    guestPurchases: guestPurchases
	  };
	};
	
	var fetchPurchasesFailure = exports.fetchPurchasesFailure = function fetchPurchasesFailure(error) {
	  return {
	    type: _constants.FETCH_PURCHASES_FAILURE,
	    error: error
	  };
	};
	
	var requestEntries = exports.requestEntries = function requestEntries(start, end, type) {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, DefaultEmployeeDetailID, _getState$teriaReduce, showCafes, showStores, employeePurchases, guestPurchases;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              dispatch(fetchPurchasesRequest());
	              _getState = getState(), DefaultEmployeeDetailID = _getState.loginReducer.user.DefaultEmployeeDetailID, _getState$teriaReduce = _getState.teriaReducer, showCafes = _getState$teriaReduce.showCafes, showStores = _getState$teriaReduce.showStores;
	              employeePurchases = [];
	              guestPurchases = [];
	
	              if (!(type === 'CAFE' && showCafes)) {
	                _context.next = 20;
	                break;
	              }
	
	              _context.t0 = _lodash.get;
	              _context.next = 9;
	              return (0, _Api.custom)((0, _api.getCafePurchases)(start, end, DefaultEmployeeDetailID));
	
	            case 9:
	              _context.t1 = _context.sent;
	              _context.t2 = [];
	              employeePurchases = (0, _context.t0)(_context.t1, 'data.value', _context.t2);
	              _context.t3 = _lodash.get;
	              _context.next = 15;
	              return (0, _Api.custom)((0, _api.getCafeGuestPurchases)(start, end, DefaultEmployeeDetailID));
	
	            case 15:
	              _context.t4 = _context.sent;
	              _context.t5 = [];
	              guestPurchases = (0, _context.t3)(_context.t4, 'data.value', _context.t5);
	              _context.next = 28;
	              break;
	
	            case 20:
	              if (!(type === 'STORE' && showStores)) {
	                _context.next = 28;
	                break;
	              }
	
	              _context.t6 = _lodash.get;
	              _context.next = 24;
	              return (0, _Api.custom)((0, _api.getStorePurchases)(start, end, DefaultEmployeeDetailID));
	
	            case 24:
	              _context.t7 = _context.sent;
	              _context.t8 = [];
	              employeePurchases = (0, _context.t6)(_context.t7, 'data.value', _context.t8);
	
	              guestPurchases = []; // no guest purchases available for stores at the moment
	
	            case 28:
	              dispatch(fetchPurchasesSuccess(employeePurchases, guestPurchases));
	              _context.next = 34;
	              break;
	
	            case 31:
	              _context.prev = 31;
	              _context.t9 = _context['catch'](0);
	
	              dispatch(fetchPurchasesFailure(_context.t9));
	
	            case 34:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 31]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var changePeriod = exports.changePeriod = function changePeriod(start, end, type) {
	  return function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              dispatch(setPeriod(start.startOf('day'), end.endOf('day')));
	              dispatch(requestEntries(start.startOf('day'), end.endOf('day'), type));
	
	            case 2:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x3) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	
	var initializeRequest = exports.initializeRequest = function initializeRequest() {
	  return {
	    type: _constants.INITIALIZE_REQUEST
	  };
	};
	
	var initializeSuccess = exports.initializeSuccess = function initializeSuccess(periodFrom, showStores, showCafes) {
	  return {
	    type: _constants.INITIALIZE_SUCCESS,
	    periodFrom: periodFrom,
	    showStores: showStores,
	    showCafes: showCafes
	  };
	};
	
	var initializeFailure = exports.initializeFailure = function initializeFailure(error) {
	  return {
	    type: _constants.INITIALIZE_FAILURE,
	    error: error
	  };
	};
	
	var initialize = exports.initialize = function initialize() {
	  return function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch, getState) {
	      var requests, _ref4, _ref5, xapRes, periodFrom, startDate, endDate, _getState2, valuesByKey, showStores, showCafes, initialType;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	
	              dispatch(initializeRequest());
	              requests = [(0, _Api.custom)((0, _api.getXapValue)('Pay.PeriodFrom'))];
	              _context3.next = 5;
	              return Promise.all(requests);
	
	            case 5:
	              _ref4 = _context3.sent;
	              _ref5 = _slicedToArray(_ref4, 1);
	              xapRes = _ref5[0];
	              periodFrom = (0, _lodash.get)(xapRes, 'data.value[0].Value') || 1;
	              startDate = (0, _moment2.default)().date(periodFrom).add(-1, 'months').startOf('day');
	              endDate = (0, _moment2.default)().date(periodFrom - 1).endOf('day');
	
	              if (endDate.isSameOrBefore((0, _moment2.default)())) {
	                startDate = startDate.add(1, 'months');
	                endDate = startDate.clone().add(1, 'months').add(-1, 'days').endOf('day');
	              }
	              _getState2 = getState(), valuesByKey = _getState2.WebValuesReducer.valuesByKey;
	              showStores = (0, _lodash.get)(valuesByKey, ['Hide.Teria.Store', 'Value']) !== 'true';
	              showCafes = (0, _lodash.get)(valuesByKey, ['Hide.Teria.Cafeteria', 'Value']) !== 'true';
	              initialType = void 0;
	
	              if (showCafes) {
	                initialType = 'CAFE';
	              } else if (showStores) {
	                initialType = 'STORE';
	              }
	              dispatch(initializeSuccess(periodFrom, showStores, showCafes));
	              dispatch(changePeriod(startDate, endDate, initialType));
	              _context3.next = 24;
	              break;
	
	            case 21:
	              _context3.prev = 21;
	              _context3.t0 = _context3['catch'](0);
	
	              dispatch(initializeFailure((0, _lodash.get)(_context3.t0, 'message')));
	
	            case 24:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[0, 21]]);
	    }));
	
	    return function (_x4, _x5) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	};
	
	var useTeriaState = exports.useTeriaState = function useTeriaState() {
	  return (0, _reactRedux.useSelector)(function (state) {
	    return state.TeriaReducer;
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getDates, 'getDates', 'D:/a/1/s/src/web/employee/src/sites/teria/actions.js');
	
	  __REACT_HOT_LOADER__.register(setPeriod, 'setPeriod', 'D:/a/1/s/src/web/employee/src/sites/teria/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasesRequest, 'fetchPurchasesRequest', 'D:/a/1/s/src/web/employee/src/sites/teria/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasesSuccess, 'fetchPurchasesSuccess', 'D:/a/1/s/src/web/employee/src/sites/teria/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchPurchasesFailure, 'fetchPurchasesFailure', 'D:/a/1/s/src/web/employee/src/sites/teria/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestEntries, 'requestEntries', 'D:/a/1/s/src/web/employee/src/sites/teria/actions.js');
	
	  __REACT_HOT_LOADER__.register(changePeriod, 'changePeriod', 'D:/a/1/s/src/web/employee/src/sites/teria/actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeRequest, 'initializeRequest', 'D:/a/1/s/src/web/employee/src/sites/teria/actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeSuccess, 'initializeSuccess', 'D:/a/1/s/src/web/employee/src/sites/teria/actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeFailure, 'initializeFailure', 'D:/a/1/s/src/web/employee/src/sites/teria/actions.js');
	
	  __REACT_HOT_LOADER__.register(initialize, 'initialize', 'D:/a/1/s/src/web/employee/src/sites/teria/actions.js');
	
	  __REACT_HOT_LOADER__.register(useTeriaState, 'useTeriaState', 'D:/a/1/s/src/web/employee/src/sites/teria/actions.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getXapValue = exports.getXapValue = function getXapValue(val) {
	  return {
	    url: '/kjarni/api/v2/XapValues',
	    method: 'GET',
	    params: {
	      $filter: 'XapValueName eq \'' + val + '\''
	    }
	  };
	};
	
	var getWorkingHours = exports.getWorkingHours = function getWorkingHours(detailId) {
	  return {
	    url: '/kjarni/api/v2/EmployeeDetailWorkingHours',
	    method: 'GET',
	    params: {
	      $filter: 'EmployeeDetailID eq ' + detailId
	    }
	  };
	};
	
	var getCafePurchases = exports.getCafePurchases = function getCafePurchases(start, end, detailId) {
	  return {
	    url: '/kjarni/api/v2/TeriaEmployeeCafeteriaPurchases/GetPurchasesInPeriod(dateFrom=' + start.format('YYYY-MM-DD') + ',dateTo=' + end.format('YYYY-MM-DD') + ')?$filter=EmployeeDetailID eq ' + detailId,
	    method: 'GET'
	  };
	};
	
	var getCafeGuestPurchases = exports.getCafeGuestPurchases = function getCafeGuestPurchases(start, end, detailId) {
	  return {
	    url: '/kjarni/api/v2/TeriaEmployeeCafeteriaCompanyGuestPurchases/GetPurchasesInPeriod(dateFrom=' + start.format('YYYY-MM-DD') + ',dateTo=' + end.format('YYYY-MM-DD') + ')?$filter=EmployeeDetailID eq ' + detailId,
	    method: 'GET'
	  };
	};
	
	var getStorePurchases = exports.getStorePurchases = function getStorePurchases(start, end, detailId) {
	  return {
	    url: '/kjarni/api/v2/TeriaEmployeeStorePurchases/GetPurchasesInPeriod(dateFrom=' + start.format('YYYY-MM-DD') + ',dateTo=' + end.format('YYYY-MM-DD') + ')?$filter=EmployeeDetailID eq ' + detailId,
	    method: 'GET'
	  };
	};
	
	var getStores = exports.getStores = function getStores() {
	  return {
	    url: '/kjarni/api/v2/TeriaStores',
	    method: 'GET'
	  };
	};
	
	var getCafeterias = exports.getCafeterias = function getCafeterias() {
	  return {
	    url: '/kjarni/api/v2/TeriaCafeterias',
	    method: 'GET'
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getXapValue, 'getXapValue', 'D:/a/1/s/src/web/employee/src/sites/teria/api.js');
	
	  __REACT_HOT_LOADER__.register(getWorkingHours, 'getWorkingHours', 'D:/a/1/s/src/web/employee/src/sites/teria/api.js');
	
	  __REACT_HOT_LOADER__.register(getCafePurchases, 'getCafePurchases', 'D:/a/1/s/src/web/employee/src/sites/teria/api.js');
	
	  __REACT_HOT_LOADER__.register(getCafeGuestPurchases, 'getCafeGuestPurchases', 'D:/a/1/s/src/web/employee/src/sites/teria/api.js');
	
	  __REACT_HOT_LOADER__.register(getStorePurchases, 'getStorePurchases', 'D:/a/1/s/src/web/employee/src/sites/teria/api.js');
	
	  __REACT_HOT_LOADER__.register(getStores, 'getStores', 'D:/a/1/s/src/web/employee/src/sites/teria/api.js');
	
	  __REACT_HOT_LOADER__.register(getCafeterias, 'getCafeterias', 'D:/a/1/s/src/web/employee/src/sites/teria/api.js');
	}();

	;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(289);
	
	var _reducer = __webpack_require__(1004);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _Teria = __webpack_require__(447);
	
	var _Teria2 = _interopRequireDefault(_Teria);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  name: _constants.name,
	  Teria: _Teria2.default,
	  reducer: _reducer2.default
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/teria/index.js');
	}();

	;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(66);
	
	__webpack_require__(8);
	
	var _constants = __webpack_require__(289);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  teria: {
	    employeePurchases: [],
	    guestPurchases: [],
	    loading: false,
	    error: '',
	    hasError: false,
	    start: {},
	    end: {},
	    initialized: false,
	    initializing: false,
	    initializeFailed: false,
	    periodFrom: '1',
	    showStores: false,
	    showCafes: false
	  }
	};
	
	var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.FETCH_PURCHASES_REQUEST, function (state) {
	  return _extends({}, state, {
	    fetchingEntries: true,
	    employeePurchases: [],
	    guestPurchases: [],
	    error: '',
	    hasError: false,
	    loading: true
	  });
	}), _defineProperty(_handleActions, _constants.FETCH_PURCHASES_SUCCESS, function (state, _ref) {
	  var employeePurchases = _ref.employeePurchases,
	      guestPurchases = _ref.guestPurchases;
	  return _extends({}, state, {
	    employeePurchases: employeePurchases,
	    guestPurchases: guestPurchases,
	    loading: false
	  });
	}), _defineProperty(_handleActions, _constants.FETCH_PURCHASES_FAILURE, function (state, action) {
	  return _extends({}, state, {
	    loading: false,
	    error: action.error,
	    hasError: true
	  });
	}), _defineProperty(_handleActions, _constants.INITIALIZE_REQUEST, function (state) {
	  return _extends({}, state, {
	    initialized: false,
	    initializing: true,
	    error: '',
	    hasError: false,
	    initializeFailed: false,
	    loading: true
	  });
	}), _defineProperty(_handleActions, _constants.INITIALIZE_SUCCESS, function (state, _ref2) {
	  var periodFrom = _ref2.periodFrom,
	      showStores = _ref2.showStores,
	      showCafes = _ref2.showCafes;
	  return _extends({}, state, {
	    initialized: true,
	    initializing: false,
	    periodFrom: periodFrom,
	    showStores: showStores,
	    showCafes: showCafes,
	    initializeFailed: false,
	    loading: false
	  });
	}), _defineProperty(_handleActions, _constants.INITIALIZE_FAILURE, function (state, _ref3) {
	  var error = _ref3.error;
	  return _extends({}, state, {
	    error: error,
	    hasError: true,
	    initialized: false,
	    initializing: false,
	    initializeFailed: true,
	    loading: false
	  });
	}), _defineProperty(_handleActions, _constants.SET_PERIOD, function (state, _ref4) {
	  var start = _ref4.start,
	      end = _ref4.end;
	  return _extends({}, state, {
	    start: start,
	    end: end
	  });
	}), _handleActions), initialState.teria);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/sites/teria/reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/teria/reducer.js');
	}();

	;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _lodash = __webpack_require__(8);
	
	var _materialUi = __webpack_require__(17);
	
	var _colors = __webpack_require__(175);
	
	var _filterList = __webpack_require__(1610);
	
	var _filterList2 = _interopRequireDefault(_filterList);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactIntl = __webpack_require__(5);
	
	var _exportHelpers = __webpack_require__(1032);
	
	var _normalize = __webpack_require__(103);
	
	var _EntryModal = __webpack_require__(448);
	
	var _EntryModal2 = _interopRequireDefault(_EntryModal);
	
	var _colors2 = __webpack_require__(20);
	
	var _colors3 = _interopRequireDefault(_colors2);
	
	var _Alert = __webpack_require__(145);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _actions = __webpack_require__(149);
	
	var _ExpectedHours = __webpack_require__(290);
	
	var _ExpectedHours2 = _interopRequireDefault(_ExpectedHours);
	
	var _MultiEntryModal = __webpack_require__(1009);
	
	var _MultiEntryModal2 = _interopRequireDefault(_MultiEntryModal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var columnStyle = {
	  whiteSpace: 'normal',
	  width: 100
	};
	
	var EntriesTable = function EntriesTable(_ref) {
	  var entries = _ref.entries,
	      entryTypes = _ref.entryTypes,
	      hideActions = _ref.hideActions,
	      deleteClockCardEntry = _ref.deleteClockCardEntry,
	      datesBetween = _ref.datesBetween;
	
	  var _useState = (0, _react.useState)([]),
	      _useState2 = _slicedToArray(_useState, 2),
	      dataSource = _useState2[0],
	      setDataSource = _useState2[1];
	
	  var _useState3 = (0, _react.useState)([]),
	      _useState4 = _slicedToArray(_useState3, 2),
	      filteredData = _useState4[0],
	      setFilteredData = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({}),
	      _useState6 = _slicedToArray(_useState5, 2),
	      entriesByDate = _useState6[0],
	      setEntriesByDate = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      modalOpen = _useState8[0],
	      setModalOpen = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      multiModalOpen = _useState10[0],
	      setMultiModalOpen = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      alertOpen = _useState12[0],
	      setAlertOpen = _useState12[1];
	
	  var _useState13 = (0, _react.useState)([]),
	      _useState14 = _slicedToArray(_useState13, 2),
	      selectedEntries = _useState14[0],
	      setSelectedEntries = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(null),
	      _useState16 = _slicedToArray(_useState15, 2),
	      selectedValue = _useState16[0],
	      setSelectedValue = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      isEdit = _useState18[0],
	      setIsEdit = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      initialDate = _useState20[0],
	      setInitialDate = _useState20[1];
	
	  var selectedLanguage = localStorage.language === 'is' ? 'is' : 'en';
	
	  var visibleColumns = [{ key: 'Date', title: selectedLanguage === 'is' ? 'Dagsetning' : 'Date' }, { key: 'ClockIn', title: selectedLanguage === 'is' ? 'Inn' : 'Clock In' }, { key: 'ClockOut', title: selectedLanguage === 'is' ? 'Út' : 'Clock Out' }, { key: 'ActualClockTime', title: selectedLanguage === 'is' ? 'Tímar' : 'Hours' }, { key: 'ClockCardEntryTypeName', title: selectedLanguage === 'is' ? 'Tegund' : 'Type' }, { key: 'ClockCardEntryComment', title: selectedLanguage === 'is' ? 'Athugasemd' : 'Comment' }];
	
	  (0, _react.useEffect)(function () {
	    setDataSource((0, _lodash.orderBy)(entries, ['ClockIn'], ['asc']));
	    setFilteredData((0, _lodash.orderBy)(entries, ['ClockIn'], ['asc']));
	    setEntriesByDate((0, _lodash.groupBy)((0, _lodash.map)(entries, function (entry) {
	      return _extends({}, entry, { date: (0, _moment2.default)(entry.ClockIn).format('DD/MM/YY') });
	    }), 'date'));
	    setSelectedValue(null);
	  }, [entries]);
	
	  var closeAlert = function closeAlert() {
	    setSelectedEntries([]);
	    setAlertOpen(false);
	  };
	  var openAlert = function openAlert() {
	    setAlertOpen(true);
	  };
	
	  var closeModal = function closeModal() {
	    setInitialDate('');
	    setSelectedEntries([]);
	    setIsEdit(false);
	    setModalOpen(false);
	  };
	  var openModal = function openModal() {
	    if (Array.isArray(selectedEntries[0])) {
	      setMultiModalOpen(true);
	    } else {
	      setModalOpen(true);
	    }
	  };
	
	  var onOpenModal = function onOpenModal(entry, isEditing) {
	    isEditing && setIsEdit(true);
	    setSelectedEntries(entry);
	    if ((0, _lodash.size)(entry) > 1) {
	      setMultiModalOpen(true);
	    } else {
	      isEditing ? openModal() : openAlert();
	    }
	  };
	
	  var createEntry = function createEntry() {
	    setInitialDate((0, _moment2.default)());
	    setModalOpen(true);
	  };
	
	  var excelExport = function excelExport() {
	    var documentName = 'T\xEDmaskr\xE1ningar-' + (0, _moment2.default)().format('DD.MM.YYYY');
	    var exportData = (0, _lodash.map)(filteredData, function (item) {
	      return {
	        Date: (0, _moment2.default)(item.ClockIn).format('DD.MM.YYYY'),
	        ClockIn: (0, _moment2.default)(item.ClockIn).format('HH:mm'),
	        ClockOut: item.ClockOut ? (0, _moment2.default)(item.ClockOut).format('HH:mm') : '',
	        ActualClockTime: (0, _normalize.unitRender)(item.ActualClockTime),
	        ClockCardEntryTypeName: (0, _lodash.get)(entryTypes, [item.ClockCardEntryTypeID, selectedLanguage === 'is' ? 'ClockCardEntryTypeName' : 'ClockCardEntryTypeName_EN']),
	        ClockCardEntryComment: item.ClockCardEntryComment
	      };
	    });
	    (0, _exportHelpers.exportToExcel)(documentName, exportData, visibleColumns);
	  };
	
	  var closeAndDelete = function closeAndDelete() {
	    (0, _lodash.forEach)(selectedEntries, function (entry) {
	      deleteClockCardEntry((0, _lodash.get)(entry, 'ClockCardEntryID'));
	    });
	    setAlertOpen(false);
	    setSelectedEntries([]);
	  };
	
	  var isExportDisabled = function isExportDisabled() {
	    return filteredData.length === 0;
	  };
	
	  var onFilterChange = function onFilterChange(value) {
	    if (value) {
	      var filtered = (0, _lodash.filter)(dataSource, ['ClockCardEntryTypeID', value]);
	      setEntriesByDate((0, _lodash.groupBy)((0, _lodash.map)(filtered, function (entry) {
	        return _extends({}, entry, { date: (0, _moment2.default)(entry.ClockIn).format('DD/MM/YY') });
	      }), 'date'));
	      setFilteredData(filtered);
	      setSelectedValue(value);
	    } else {
	      setFilteredData(dataSource);
	      setEntriesByDate((0, _lodash.groupBy)((0, _lodash.map)(dataSource, function (entry) {
	        return _extends({}, entry, { date: (0, _moment2.default)(entry.ClockIn).format('DD/MM/YY') });
	      }), 'date'));
	      setSelectedValue(null);
	    }
	  };
	
	  var onMultipleEntrySelect = function onMultipleEntrySelect(entry) {
	    setMultiModalOpen(false);
	    setSelectedEntries([entry]);
	    openModal();
	  };
	  var onMultipleEntryDelete = function onMultipleEntryDelete(entry) {
	    setMultiModalOpen(false);
	    setSelectedEntries([entry]);
	    openAlert();
	  };
	  var closeMultiModal = function closeMultiModal() {
	    setIsEdit(false);
	    setMultiModalOpen(false);
	    setSelectedEntries([]);
	  };
	  var createFromDate = function createFromDate(date) {
	    var _date$split = date.split('/'),
	        _date$split2 = _slicedToArray(_date$split, 3),
	        day = _date$split2[0],
	        month = _date$split2[1],
	        year = _date$split2[2];
	
	    var customDate = new Date('20' + year, month - 1, day, 0, 0, 0);
	    setInitialDate((0, _moment2.default)(customDate));
	    openModal();
	  };
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_Alert2.default, {
	      open: alertOpen,
	      onOk: closeAndDelete,
	      onCancel: closeAlert,
	      text: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.alert.delete', values: { count: (0, _lodash.size)(selectedEntries.flat()) } })
	    }),
	    _react2.default.createElement(_EntryModal2.default, {
	      modalState: modalOpen,
	      closeModal: closeModal,
	      selectedEntries: selectedEntries,
	      entriesByDate: entriesByDate,
	      initialDate: initialDate,
	      isEdit: isEdit
	    }),
	    multiModalOpen && _react2.default.createElement(_MultiEntryModal2.default, {
	      modalState: multiModalOpen,
	      isEdit: isEdit,
	      closeModal: closeMultiModal,
	      selectedEntries: selectedEntries,
	      onMultipleEntrySelect: onMultipleEntrySelect,
	      onMultipleEntryDelete: onMultipleEntryDelete,
	      selectedLanguage: selectedLanguage
	    }),
	    _react2.default.createElement(
	      _materialUi.Paper,
	      { style: { padding: 24, maxWidth: 1420, margin: 'auto' } },
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between'
	          }
	        },
	        !hideActions && _react2.default.createElement(_materialUi.RaisedButton, {
	          primary: true,
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.CreateEntry' }),
	          onClick: createEntry,
	          disabled: (0, _lodash.size)(selectedEntries) > 0,
	          icon: _react2.default.createElement(
	            _materialUi.FontIcon,
	            { className: 'material-icons' },
	            'add'
	          )
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: 'hide-mobile' },
	          _react2.default.createElement(_ExpectedHours2.default, null)
	        ),
	        !hideActions && _react2.default.createElement(_materialUi.RaisedButton, {
	          primary: true,
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.exportExcel' }),
	          onClick: excelExport,
	          icon: _react2.default.createElement(
	            _materialUi.FontIcon,
	            { className: 'material-icons' },
	            'file_download'
	          ),
	          disabled: isExportDisabled()
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'show-mobile' },
	        _react2.default.createElement(_ExpectedHours2.default, null)
	      ),
	      _react2.default.createElement(
	        _materialUi.Table,
	        {
	          bodyStyle: { overflowX: 'none', overflowY: 'none' },
	          height: 'calc(100vh - 320px)'
	          // fixedHeader
	          , multiSelectable: false,
	          selectable: false
	        },
	        _react2.default.createElement(
	          _materialUi.TableHeader,
	          { displaySelectAll: false, adjustForCheckbox: false },
	          _react2.default.createElement(
	            _materialUi.TableRow,
	            null,
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: { width: 110 } },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Date' })
	            ),
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: columnStyle },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.ClockIn' })
	            ),
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: columnStyle },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.ClockOut' })
	            ),
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: columnStyle },
	              _react2.default.createElement(
	                'div',
	                { style: { display: 'flex', alignItems: 'center' } },
	                _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Type' }),
	                _react2.default.createElement(
	                  _materialUi.IconMenu,
	                  {
	                    iconButtonElement: _react2.default.createElement(
	                      _materialUi.IconButton,
	                      null,
	                      _react2.default.createElement(_filterList2.default, { color: selectedValue === null ? _colors.grey500 : _colors3.default.primary1Color })
	                    ),
	                    value: selectedValue || null
	                  },
	                  _react2.default.createElement(_materialUi.MenuItem, {
	                    key: 'all',
	                    value: null,
	                    primaryText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'repository.all' }),
	                    onClick: function onClick() {
	                      return onFilterChange(null);
	                    }
	                  }),
	                  (0, _lodash.map)(entryTypes, function (_ref2) {
	                    var ClockCardEntryTypeID = _ref2.ClockCardEntryTypeID,
	                        ClockCardEntryTypeName = _ref2.ClockCardEntryTypeName;
	                    return _react2.default.createElement(_materialUi.MenuItem, {
	                      key: ClockCardEntryTypeID,
	                      value: ClockCardEntryTypeID,
	                      primaryText: ClockCardEntryTypeName,
	                      onClick: function onClick() {
	                        return onFilterChange(ClockCardEntryTypeID);
	                      }
	                    });
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: columnStyle },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.ActualClockTime' })
	            ),
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: columnStyle },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Comment' })
	            ),
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: { width: 48 } },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.HasError' })
	            ),
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: columnStyle },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'panel.actions' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _materialUi.TableBody,
	          {
	            displayRowCheckbox: false,
	            deselectOnClickaway: false
	          },
	          (0, _lodash.map)(datesBetween, function (_ref3) {
	            var dateString = _ref3.dateString,
	                isWeekend = _ref3.isWeekend,
	                isRedDay = _ref3.isRedDay,
	                dayOfWeek = _ref3.dayOfWeek,
	                date = _ref3.date;
	            return _react2.default.createElement(
	              _materialUi.TableRow,
	              {
	                key: dateString,
	                style: { backgroundColor: isWeekend || isRedDay ? '#3b53a70d' : 'white' }
	              },
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: { width: 110 } },
	                _react2.default.createElement(
	                  'div',
	                  { style: { display: 'flex', justifyContent: 'space-between' } },
	                  _react2.default.createElement(
	                    'span',
	                    { style: { textAlign: 'center', width: 20 } },
	                    dayOfWeek
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    date.format('DD.MM.YY')
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: columnStyle },
	                (0, _lodash.map)((0, _lodash.get)(entriesByDate, dateString), function (entry) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: entry.ClockCardEntryID },
	                    (0, _moment2.default)(entry.ClockIn).format('HH:mm')
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: columnStyle },
	                (0, _lodash.map)((0, _lodash.get)(entriesByDate, dateString), function (entry) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: entry.ClockCardEntryID },
	                    entry.ClockOut ? (0, _moment2.default)(entry.ClockOut).format('HH:mm') : ''
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: columnStyle },
	                (0, _lodash.map)((0, _lodash.get)(entriesByDate, dateString), function (entry) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: entry.ClockCardEntryID },
	                    (0, _lodash.get)(entryTypes, [entry.ClockCardEntryTypeID, selectedLanguage === 'is' ? 'ClockCardEntryTypeName' : 'ClockCardEntryTypeName_EN']) || (0, _lodash.get)(entryTypes, [entry.ClockCardEntryTypeID, 'ClockCardEntryTypeName'])
	                  );
	                })
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: columnStyle },
	                (0, _normalize.unitRender)((0, _lodash.sumBy)((0, _lodash.get)(entriesByDate, dateString), 'ActualClockTime')) || ''
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: { width: 100, overflow: 'visible' } },
	                (0, _lodash.map)((0, _lodash.get)(entriesByDate, dateString), function (entry) {
	                  return (0, _lodash.get)(entry, 'ClockCardEntryComment') ? _react2.default.createElement(
	                    'div',
	                    { className: 'tooltip' },
	                    _react2.default.createElement(
	                      'div',
	                      { key: entry.ClockCardEntryID, style: { textOverflow: 'ellipsis', overflow: 'hidden' } },
	                      (0, _lodash.get)(entry, 'ClockCardEntryComment') || _react2.default.createElement('br', null)
	                    ),
	                    _react2.default.createElement(
	                      'span',
	                      { className: 'tooltiptext' },
	                      (0, _lodash.get)(entry, 'ClockCardEntryComment') || _react2.default.createElement('br', null)
	                    )
	                  ) : _react2.default.createElement('br', null);
	                })
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: { width: 48, overflow: 'visible' } },
	                (0, _lodash.map)((0, _lodash.get)(entriesByDate, dateString), function (entry) {
	                  return (0, _lodash.get)(entry, 'ClockTimeHasError') ? _react2.default.createElement(
	                    'div',
	                    null,
	                    _react2.default.createElement(
	                      _materialUi.IconButton,
	                      {
	                        disabled: true,
	                        style: { padding: 0, height: 12 },
	                        tooltip: _react2.default.createElement(
	                          'div',
	                          null,
	                          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.HasError.Tooltip' })
	                        ),
	                        iconStyle: { color: _colors3.default.warningColor, padding: 0, height: 12 },
	                        iconClassName: 'material-icons',
	                        color: _colors3.default.warningColor
	                      },
	                      'report_problem'
	                    )
	                  ) : '';
	                })
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: columnStyle },
	                (0, _lodash.get)(entriesByDate, dateString) ? _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    _materialUi.IconButton,
	                    {
	                      iconStyle: { color: _colors3.default.primary1Color },
	                      onClick: function onClick() {
	                        return onOpenModal((0, _lodash.get)(entriesByDate, dateString), true);
	                      }
	                    },
	                    _react2.default.createElement(
	                      _materialUi.FontIcon,
	                      { className: 'material-icons' },
	                      'mode'
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _materialUi.IconButton,
	                    {
	                      iconStyle: { color: _colors3.default.errorColor },
	                      onClick: function onClick() {
	                        return onOpenModal((0, _lodash.get)(entriesByDate, dateString), false);
	                      }
	                    },
	                    _react2.default.createElement(
	                      _materialUi.FontIcon,
	                      { className: 'material-icons' },
	                      'delete_outlined'
	                    )
	                  )
	                ) : _react2.default.createElement(_materialUi.FlatButton, {
	                  primary: true,
	                  label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.CreateEntry' }),
	                  onClick: function onClick() {
	                    return createFromDate(dateString);
	                  }
	                })
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	EntriesTable.propTypes = {
	  deleteClockCardEntry: _propTypes2.default.func.isRequired,
	  entries: _propTypes2.default.shape({}),
	  entryTypes: _propTypes2.default.shape({}).isRequired,
	  start: _propTypes2.default.shape({}).isRequired,
	  hideActions: _propTypes2.default.bool.isRequired,
	  datesBetween: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref4) {
	  var timeReducer = _ref4.timeReducer;
	  return _extends({}, timeReducer);
	}, function (dispatch) {
	  return {
	    deleteClockCardEntry: function deleteClockCardEntry(id) {
	      return dispatch((0, _actions.deleteEntry)(id));
	    }
	  };
	})(EntriesTable);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(columnStyle, 'columnStyle', 'D:/a/1/s/src/web/employee/src/sites/time/EntriesTable.js');
	
	  __REACT_HOT_LOADER__.register(EntriesTable, 'EntriesTable', 'D:/a/1/s/src/web/employee/src/sites/time/EntriesTable.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/time/EntriesTable.js');
	}();

	;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(12);
	
	var _reactFlexboxGrid = __webpack_require__(38);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactDatepicker = __webpack_require__(211);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	var _actions = __webpack_require__(149);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _EntriesTable = __webpack_require__(1005);
	
	var _EntriesTable2 = _interopRequireDefault(_EntriesTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeOverview = function TimeOverview(_ref) {
	  var setTimePeriod = _ref.setTimePeriod,
	      initializing = _ref.initializing,
	      start = _ref.start,
	      end = _ref.end,
	      error = _ref.error,
	      hasError = _ref.hasError,
	      initializeFailed = _ref.initializeFailed,
	      timeInitialize = _ref.timeInitialize;
	
	  (0, _react.useEffect)(function () {
	    timeInitialize();
	  }, []);
	
	  if (initializing) return _react2.default.createElement(_Loading2.default, null);
	
	  if (initializeFailed || hasError) {
	    return _react2.default.createElement(_PanelMessage2.default, {
	      message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.initialize.error', values: { error: error } }),
	      iconName: 'error',
	      type: 'error'
	    });
	  }
	
	  var isPeriod = (0, _moment2.default)(end).format('DD/MM/YYYY') === (0, _moment2.default)(start).add(1, 'month').add(-1, 'day').format('DD/MM/YYYY');
	
	  var isMonth = (0, _moment2.default)(start).format('DD/MM/YYYY') === (0, _moment2.default)(start).startOf('month').format('DD/MM/YYYY') && (0, _moment2.default)(end).format('DD/MM/YYYY') === (0, _moment2.default)(end).endOf('month').format('DD/MM/YYYY');
	
	  var setLastPeriod = function setLastPeriod() {
	    if (isMonth) {
	      setTimePeriod((0, _moment2.default)(start).add(-1, 'month'), (0, _moment2.default)(end).add(-1, 'month').endOf('month'));
	    } else if (isPeriod) {
	      setTimePeriod((0, _moment2.default)(start).add(-1, 'month'), (0, _moment2.default)(start).add(-1, 'day'));
	    } else {
	      var numberOfDays = (0, _moment2.default)(end).diff(start, 'days') + 1;
	      setTimePeriod((0, _moment2.default)(start).add(-numberOfDays, 'days'), (0, _moment2.default)(end).add(-numberOfDays, 'days'));
	    }
	  };
	
	  var setNextPeriod = function setNextPeriod() {
	    if (isMonth) {
	      setTimePeriod((0, _moment2.default)(start).add(1, 'month'), (0, _moment2.default)(end).add(1, 'month').endOf('month'));
	    } else if (isPeriod) {
	      setTimePeriod((0, _moment2.default)(start).add(1, 'month'), (0, _moment2.default)(start).add(2, 'month').add(-1, 'day'));
	    } else {
	      var numberOfDays = (0, _moment2.default)(end).diff(start, 'days') + 1;
	      setTimePeriod((0, _moment2.default)(start).add(numberOfDays, 'days'), (0, _moment2.default)(end).add(numberOfDays, 'days'));
	    }
	  };
	
	  var setStartDate = function setStartDate(date) {
	    setTimePeriod(date, end);
	  };
	
	  var setEndDate = function setEndDate(date) {
	    setTimePeriod(start, date);
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactFlexboxGrid.Row,
	      { middle: 'xs', center: 'xs' },
	      _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', alignItems: 'center', paddingTop: 16 } },
	        _react2.default.createElement(
	          _materialUi.IconButton,
	          { onClick: setLastPeriod, style: { marginRight: 12 } },
	          _react2.default.createElement(
	            _materialUi.FontIcon,
	            { className: 'material-icons' },
	            'arrow_back'
	          )
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: { fontSize: 18, fontWeight: 400 } },
	          _react2.default.createElement(_reactDatepicker2.default, {
	            selected: (0, _moment2.default)(start),
	            onChange: setStartDate,
	            dateFormat: 'DD.MMM YYYY',
	            selectsStart: true,
	            startDate: (0, _moment2.default)(start),
	            endDate: (0, _moment2.default)(end)
	          }),
	          ' - ',
	          _react2.default.createElement(_reactDatepicker2.default, {
	            selected: (0, _moment2.default)(end),
	            onChange: setEndDate,
	            dateFormat: 'DD.MMM YYYY',
	            selectsEnd: true,
	            startDate: (0, _moment2.default)(start),
	            endDate: (0, _moment2.default)(end),
	            minDate: (0, _moment2.default)(start)
	          })
	        ),
	        _react2.default.createElement(
	          _materialUi.IconButton,
	          { onClick: setNextPeriod, style: { marginLeft: 12 } },
	          _react2.default.createElement(
	            _materialUi.FontIcon,
	            { className: 'material-icons' },
	            'arrow_forward'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_EntriesTable2.default, null)
	  );
	};
	
	TimeOverview.propTypes = {
	  timeInitialize: _propTypes2.default.func.isRequired,
	  setTimePeriod: _propTypes2.default.func.isRequired,
	  initializing: _propTypes2.default.bool.isRequired,
	  start: _propTypes2.default.shape({}).isRequired,
	  end: _propTypes2.default.shape({}).isRequired,
	  hasError: _propTypes2.default.bool.isRequired,
	  initializeFailed: _propTypes2.default.bool.isRequired,
	  error: _propTypes2.default.string
	};
	
	TimeOverview.defaultProps = {
	  error: null
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref2) {
	  var timeReducer = _ref2.timeReducer;
	  return _extends({}, timeReducer);
	}, function (dispatch) {
	  return {
	    timeInitialize: function timeInitialize() {
	      return dispatch((0, _actions.initialize)());
	    },
	    setTimePeriod: function setTimePeriod(from, to) {
	      return dispatch((0, _actions.changePeriod)(from, to));
	    }
	  };
	})(TimeOverview);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(TimeOverview, 'TimeOverview', 'D:/a/1/s/src/web/employee/src/sites/time/TimeOverview.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/time/TimeOverview.js');
	}();

	;

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Clock = function Clock() {
	  var _useState = (0, _react.useState)((0, _moment2.default)()),
	      _useState2 = _slicedToArray(_useState, 2),
	      time = _useState2[0],
	      setTime = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    var tick = function tick() {
	      setTime((0, _moment2.default)());
	    };
	    var timeInterval = setInterval(tick, 1000);
	    return function () {
	      clearInterval(timeInterval);
	    };
	  }, []);
	  return _react2.default.createElement(
	    'h1',
	    { style: { paddingTop: 12 } },
	    time.format('HH:mm:ss')
	  );
	};
	var _default = Clock;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(Clock, 'Clock', 'D:/a/1/s/src/web/employee/src/sites/time/components/Clock.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/time/components/Clock.js');
	}();

	;

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint-disable no-restricted-globals */
	
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reapop = __webpack_require__(44);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactDatepicker = __webpack_require__(211);
	
	var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);
	
	__webpack_require__(811);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _holidayResponseStatuses = __webpack_require__(285);
	
	var _holidayResponseStatuses2 = _interopRequireDefault(_holidayResponseStatuses);
	
	var _actions = __webpack_require__(149);
	
	var _useClockCardEntries2 = __webpack_require__(450);
	
	var _useClockCardEntries3 = _interopRequireDefault(_useClockCardEntries2);
	
	var _Api = __webpack_require__(21);
	
	var _api = __webpack_require__(185);
	
	var _EmployeeHoliday = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var OK = _holidayResponseStatuses2.default.OK,
	    WARNING = _holidayResponseStatuses2.default.WARNING,
	    ERROR = _holidayResponseStatuses2.default.ERROR;
	
	
	var errorStyle = {
	  color: 'red',
	  fontSize: '12px',
	  margintop: 20
	};
	
	var inputStyle = { width: 310, textAlign: 'left', marginTop: 10 };
	var timeInputRowStyle = {
	  display: 'flex', alignItems: 'center', gap: 8, marginTop: 4
	};
	var floatingStyle = { textAlign: 'left', width: 340 };
	
	var dateInputStyle = {
	  border: '1px solid #ccc',
	  padding: '4px 8px',
	  textAlign: 'center',
	  cursor: 'pointer',
	  width: 90,
	  height: 20,
	  color: '#00000099'
	};
	
	var tsWrapStyle = { position: 'relative', display: 'inline-block' };
	var tsTriggerStyle = {
	  cursor: 'pointer',
	  border: '1px solid #ccc',
	  padding: '4px 8px',
	  width: 44,
	  textAlign: 'center',
	  fontSize: 14,
	  height: 30,
	  color: '#00000099',
	  boxSizing: 'border-box'
	};
	var tsListStyle = {
	  position: 'absolute',
	  zIndex: 1000,
	  background: 'white',
	  border: '1px solid #ccc',
	  maxHeight: 200,
	  overflowY: 'auto',
	  minWidth: 54,
	  boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
	};
	var tsOptionStyle = function tsOptionStyle(selected) {
	  return {
	    padding: '4px 8px',
	    cursor: 'pointer',
	    textAlign: 'center',
	    background: selected ? '#1976d2' : 'white',
	    color: selected ? 'white' : 'inherit'
	  };
	};
	
	var TimeSelect = function TimeSelect(_ref) {
	  var value = _ref.value,
	      count = _ref.count,
	      onChange = _ref.onChange;
	
	  var _useState = (0, _react.useState)(false),
	      _useState2 = _slicedToArray(_useState, 2),
	      open = _useState2[0],
	      setOpen = _useState2[1];
	
	  var ref = (0, _react.useRef)(null);
	
	  (0, _react.useEffect)(function () {
	    var handleClickOutside = function handleClickOutside(e) {
	      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
	    };
	    if (open) document.addEventListener('mousedown', handleClickOutside);
	    return function () {
	      return document.removeEventListener('mousedown', handleClickOutside);
	    };
	  }, [open]);
	
	  var toggle = function toggle() {
	    return setOpen(function (o) {
	      return !o;
	    });
	  };
	
	  var handleInput = function handleInput(e) {
	    var parsed = parseInt(e.target.value, 10);
	    if (!isNaN(parsed) && parsed >= 0 && parsed < count) onChange(parsed);
	  };
	
	  return _react2.default.createElement(
	    'div',
	    { ref: ref, style: tsWrapStyle },
	    _react2.default.createElement('input', {
	      type: 'text',
	      value: String(value).padStart(2, '0'),
	      onChange: handleInput,
	      onClick: toggle,
	      onKeyDown: function onKeyDown(e) {
	        if (e.key === 'Tab') setOpen(false);
	      },
	      style: tsTriggerStyle
	    }),
	    open && _react2.default.createElement(
	      'div',
	      { style: tsListStyle },
	      Array.from({ length: count }, function (_, i) {
	        return _react2.default.createElement(
	          'div',
	          {
	            key: i,
	            role: 'option',
	            'aria-selected': i === value,
	            tabIndex: -1,
	            onClick: function onClick() {
	              onChange(i);setOpen(false);
	            },
	            onKeyDown: function onKeyDown(e) {
	              if (e.key === 'Enter') {
	                onChange(i);setOpen(false);
	              }
	            },
	            style: tsOptionStyle(i === value)
	          },
	          String(i).padStart(2, '0')
	        );
	      })
	    )
	  );
	};
	
	TimeSelect.propTypes = {
	  value: _propTypes2.default.number.isRequired,
	  count: _propTypes2.default.number.isRequired,
	  onChange: _propTypes2.default.func.isRequired
	};
	
	var DayEntryForm = function DayEntryForm(_ref2) {
	  var defaultValues = _ref2.defaultValues,
	      selectedEntries = _ref2.selectedEntries,
	      clearAndClose = _ref2.clearAndClose,
	      hrsPerDay = _ref2.hrsPerDay,
	      entryTypes = _ref2.entryTypes,
	      primaryButton = _ref2.primaryButton,
	      setPrimaryButton = _ref2.setPrimaryButton,
	      whichButton = _ref2.whichButton,
	      valuesByKey = _ref2.valuesByKey,
	      getRemainingHours = _ref2.getRemainingHours,
	      entriesByDate = _ref2.entriesByDate,
	      isEdit = _ref2.isEdit,
	      dispatch = _ref2.dispatch,
	      start = _ref2.start,
	      end = _ref2.end,
	      timeEmailTypes = _ref2.timeEmailTypes;
	
	  var _useState3 = (0, _react.useState)({}),
	      _useState4 = _slicedToArray(_useState3, 2),
	      form = _useState4[0],
	      setForm = _useState4[1];
	
	  var _useState5 = (0, _react.useState)({}),
	      _useState6 = _slicedToArray(_useState5, 2),
	      errors = _useState6[0],
	      setErrors = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      loading = _useState8[0],
	      setLoading = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      inOutTimeError = _useState10[0],
	      setInOutTimeError = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(false),
	      _useState12 = _slicedToArray(_useState11, 2),
	      sameTimeError = _useState12[0],
	      setSameTimeError = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(false),
	      _useState14 = _slicedToArray(_useState13, 2),
	      moreThan24HoursError = _useState14[0],
	      setMoreThan24HoursError = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      moreThanZeroError = _useState16[0],
	      setMoreThanZeroError = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(''),
	      _useState18 = _slicedToArray(_useState17, 2),
	      warningText = _useState18[0],
	      setWarningText = _useState18[1];
	
	  var _useState19 = (0, _react.useState)(''),
	      _useState20 = _slicedToArray(_useState19, 2),
	      warningType = _useState20[0],
	      setWarningType = _useState20[1];
	
	  var _useState21 = (0, _react.useState)(false),
	      _useState22 = _slicedToArray(_useState21, 2),
	      isConfirming = _useState22[0],
	      setIsConfirming = _useState22[1];
	
	  var DefaultEmployeeDetailID = localStorage.getItem('DefaultEmployeeDetailID');
	
	  var _useClockCardEntries = (0, _useClockCardEntries3.default)(),
	      createClockCardEntries = _useClockCardEntries.createClockCardEntries,
	      updateClockCardEntries = _useClockCardEntries.updateClockCardEntries;
	
	  var locale = localStorage.language === 'is' ? 'is' : 'en';
	  var showInOutInput = (0, _lodash.get)(valuesByKey, ['Time.Use.RegisterClock', 'Value']);
	
	  (0, _react.useEffect)(function () {
	    setForm(defaultValues);
	  }, [defaultValues]);
	
	  var closeModal = function closeModal() {
	    setIsConfirming(false);
	    clearAndClose();
	  };
	
	  var validateAndSetErrors = function validateAndSetErrors() {
	    var hours = parseFloat((0, _lodash.get)(form, 'hours'));
	    if (hours <= 0 && showInOutInput === 'false') {
	      setMoreThanZeroError(true);
	      return true;
	    }
	    setErrors((0, _lodash.mapValues)(form, function (v) {
	      return !v;
	    }));
	    if (!(0, _lodash.size)((0, _lodash.get)(form, 'date')) || !(0, _lodash.size)((0, _lodash.get)(form, 'timeIn')) || (0, _lodash.get)(form, 'clockCardEntryTypeID') === null) return true;
	    if (inOutTimeError) {
	      return true;
	    }
	
	    var timeFrom = (0, _moment2.default)((0, _lodash.get)(form, 'timeIn'));
	    var timeTo = (0, _moment2.default)((0, _lodash.get)(form, 'timeOut'));
	    var duration = _moment2.default.duration(timeTo.diff(timeFrom));
	    if ((0, _lodash.get)(form, 'timeOut') && duration.asMinutes() === 0) {
	      setSameTimeError(true);
	      return true;
	    }
	    if (duration.asHours() > 24) {
	      setMoreThan24HoursError(true);
	      return true;
	    }
	
	    return false;
	  };
	
	  var reset = function reset() {
	    setWarningText('');
	    setWarningType('');
	    setInOutTimeError(false);
	    setSameTimeError(false);
	    setMoreThan24HoursError(false);
	    setMoreThanZeroError(false);
	    setIsConfirming(false);
	  };
	
	  var formChanged = function formChanged(key, value) {
	    reset();
	    var current = void 0;
	    if (key === 'date') {
	      var hoursRegistered = hrsPerDay - getRemainingHours(value);
	      var remaining = hrsPerDay - hoursRegistered;
	      var clockIn = (0, _moment2.default)(value).set({
	        hour: 8, minute: 0, second: 0, millisecond: 0
	      });
	      if (hoursRegistered > 0) {
	        var employeeEntries = (0, _lodash.get)(entriesByDate, (0, _moment2.default)(value).format('DD/MM/YY'));
	        var lastEntry = (0, _lodash.get)((0, _lodash.last)((0, _lodash.orderBy)(employeeEntries, 'ClockOut')), 'ClockOut');
	        clockIn = (0, _moment2.default)(lastEntry);
	      }
	      var clockOut = (0, _moment2.default)(clockIn).add(remaining, 'hours');
	      current = _extends({}, form, {
	        timeIn: clockIn,
	        timeOut: clockOut,
	        hours: remaining.toFixed(2),
	        date: value
	      });
	    } else if (key === 'hours') {
	      var _hoursRegistered = hrsPerDay - getRemainingHours((0, _lodash.get)(form, 'date'));
	
	      var _clockIn = (0, _moment2.default)((0, _lodash.get)(form, 'date')).set({
	        hour: 8, minute: 0, second: 0, millisecond: 0
	      });
	      if (_hoursRegistered > 0 && !isEdit) {
	        var _employeeEntries = (0, _lodash.get)(entriesByDate, (0, _moment2.default)((0, _lodash.get)(form, 'date')).format('DD/MM/YY'));
	        var _lastEntry = (0, _lodash.get)((0, _lodash.last)((0, _lodash.orderBy)(_employeeEntries, 'ClockOut')), 'ClockOut');
	        _clockIn = (0, _moment2.default)(_lastEntry);
	      }
	      var _clockOut = (0, _moment2.default)(_clockIn).add(value, 'hours');
	
	      current = _extends({}, form, { timeIn: _clockIn, timeOut: _clockOut, hours: value
	      });
	    } else {
	      current = _extends({}, form, _defineProperty({}, key, value));
	    }
	    setForm(current);
	    setErrors(_extends({}, errors, _defineProperty({}, key, !value)));
	  };
	
	  var onPressDay = function onPressDay(day) {
	    reset();
	    setPrimaryButton(day);
	    if (hrsPerDay > 0.00) {
	      var clockIn = (0, _moment2.default)((0, _lodash.get)(form, 'date')).set({
	        hour: 8, minute: 0, second: 0, millisecond: 0
	      });
	      var clockOut = (0, _moment2.default)(clockIn);
	      var hrs = hrsPerDay;
	      if (day === 'halfDay') {
	        clockOut.add((hrsPerDay / 2).toFixed(2), 'hours');
	        hrs = (hrsPerDay / 2).toFixed(2);
	      } else {
	        clockOut.add(hrsPerDay, 'hours');
	      }
	      var current = _extends({}, form, { timeIn: clockIn.format('YYYY-MM-DD HH:mm'), timeOut: clockOut.format('YYYY-MM-DD HH:mm'), hours: hrs
	      });
	      setForm(current);
	    }
	  };
	
	  var getDuration = function getDuration(timeIn, timeOut) {
	    if (timeIn !== null && timeOut !== null) {
	      var timeFrom = (0, _moment2.default)(timeIn);
	      var timeTo = (0, _moment2.default)(timeOut);
	      var duration = _moment2.default.duration(timeTo.diff(timeFrom));
	      var mins = duration.asMinutes();
	      var hours = (0, _lodash.floor)(mins / 60);
	      var minutes = (0, _lodash.floor)(mins % 60);
	      if (duration.seconds() >= 30) {
	        minutes += 1;
	      }
	      var hoursInDigits = duration.asHours().toFixed(2);
	      var isClockOutBeforeIn = timeTo.isBefore(timeFrom);
	
	      whichButton(hoursInDigits);
	
	      if (isClockOutBeforeIn) {
	        setInOutTimeError(true);
	        return '';
	      }
	      if (isNaN(hours)) {
	        hours = 0;
	      }
	      if (isNaN(minutes)) {
	        minutes = 0;
	      }
	
	      return hours + 'h ' + minutes + 'm';
	    }
	    return 0 + 'h ' + 0 + 'm';
	  };
	
	  var submit = function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var clockIn, clockOut, hours, duration, status, messages, Comment, ClockCardEntryTypeID, entryType, isVacation, isCreating, hasClockOut, msg, openEntryData, finalClockOut, data, res, _data, _res, entry;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _context.prev = 0;
	
	              if (validateAndSetErrors()) {
	                _context.next = 59;
	                break;
	              }
	
	              setLoading(true);
	              clockIn = (0, _moment2.default)((0, _lodash.get)(form, 'timeIn'));
	              clockOut = (0, _moment2.default)((0, _lodash.get)(form, 'timeOut'));
	              hours = parseFloat((0, _lodash.get)(form, 'hours'));
	
	              if (showInOutInput === 'true') {
	                duration = _moment2.default.duration(clockOut.diff(clockIn));
	
	                hours = parseFloat(duration.asHours());
	              }
	              status = void 0;
	              messages = [];
	              Comment = (0, _lodash.get)(form, 'clockCardEntryComment') || '';
	              ClockCardEntryTypeID = (0, _lodash.get)(form, 'clockCardEntryTypeID');
	              entryType = (0, _lodash.get)(entryTypes, ClockCardEntryTypeID);
	              isVacation = (0, _lodash.get)(entryType, 'ClockCardEntryTypeRule') === 'Vacation';
	              isCreating = (0, _lodash.isEmpty)(selectedEntries);
	
	              if (!isCreating) {
	                _context.next = 40;
	                break;
	              }
	
	              // Check if user provided a clockOut value
	              hasClockOut = (0, _lodash.get)(form, 'timeOut') && (0, _lodash.get)(form, 'timeOut') !== '';
	
	              if (hasClockOut) {
	                _context.next = 30;
	                break;
	              }
	
	              if (!isVacation) {
	                _context.next = 23;
	                break;
	              }
	
	              msg = locale === 'is' ? 'Ekki er hægt að skrá opna orlofs færslu. Vinsamlegast fylltu út bæði "Inn" og "Út" reitina.' : 'Vacation is being registered without an out time. Please fill in both "In" and "Out" fields.';
	
	              setWarningText(msg);
	              setWarningType('ERROR');
	              setLoading(false);
	              return _context.abrupt('return');
	
	            case 23:
	              openEntryData = {
	                ClockCardEntryComment: Comment,
	                ClockCardEntryTypeID: ClockCardEntryTypeID,
	                ClockIn: clockIn.toISOString(),
	                ClockOut: null,
	                EmployeeDetailID: parseInt(DefaultEmployeeDetailID, 10)
	              };
	              _context.next = 26;
	              return (0, _Api.custom)((0, _api.post)(openEntryData));
	
	            case 26:
	              status = OK;
	              messages = [];
	              _context.next = 38;
	              break;
	
	            case 30:
	              // User filled in ClockOut - check if it's on the next day
	              finalClockOut = clockOut.toISOString();
	
	              if (!clockIn.isSame(clockOut, 'day')) {
	                // ClockOut is on the next day, then we need to set PeriodEndda to null
	                finalClockOut = null;
	              }
	
	              data = {
	                ClockCardEntryTypeID: ClockCardEntryTypeID,
	                Comment: Comment,
	                EmployeeDetailID: parseInt(DefaultEmployeeDetailID, 10),
	                PeriodBegda: clockIn.toISOString(),
	                PeriodEndda: finalClockOut,
	                HoursPerDay: hours,
	                IncludesWeekends: false,
	                IncludesRedDays: false,
	                UseAccrualsIfNeeded: isConfirming
	              };
	              _context.next = 35;
	              return createClockCardEntries(data);
	
	            case 35:
	              res = _context.sent;
	
	              status = (0, _lodash.get)(res, 'status');
	              messages = (0, _lodash.get)(res, 'messages', []);
	
	            case 38:
	              _context.next = 46;
	              break;
	
	            case 40:
	              _data = {
	                ClockCardEntryTypeID: ClockCardEntryTypeID,
	                ClockCardEntryComment: Comment,
	                ClockCardEntryIDs: (0, _lodash.map)(selectedEntries, 'ClockCardEntryID'),
	                ClockIn: clockIn.toISOString(),
	                ClockOut: clockOut.toISOString(),
	                UseAccrualsIfNeeded: isConfirming
	              };
	              _context.next = 43;
	              return updateClockCardEntries(_data);
	
	            case 43:
	              _res = _context.sent;
	
	              status = (0, _lodash.get)(_res, 'status');
	              messages = (0, _lodash.get)(_res, 'messages', []);
	
	            case 46:
	              if (!(status === OK)) {
	                _context.next = 58;
	                break;
	              }
	
	              setLoading(false);
	              closeModal();
	              dispatch((0, _actions.changePeriod)(start, end));
	
	              // Refresh holiday data if vacation entry because user could be located on dashboard.
	              if (isVacation) {
	                dispatch((0, _EmployeeHoliday.fetch)());
	              }
	
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: isCreating ? 'time.notification.post.title' : 'time.notification.patch.title' }),
	                message: messages.join('. '),
	                status: 'success',
	                dismissible: true,
	                dismissAfter: 5000
	              }));
	              // Send notification email if creating new entry
	
	              if (!(isCreating && clockOut && (0, _lodash.size)(timeEmailTypes) > 0)) {
	                _context.next = 56;
	                break;
	              }
	
	              entry = {
	                ClockCardEntryTypeID: (0, _lodash.get)(form, 'clockCardEntryTypeID')
	              };
	              _context.next = 56;
	              return (0, _actions.sendNotifyEmail)(DefaultEmployeeDetailID, clockIn.toISOString(), clockOut.toISOString(), entryTypes, timeEmailTypes, entry);
	
	            case 56:
	              _context.next = 59;
	              break;
	
	            case 58:
	              if (status === WARNING || status === ERROR) {
	                setWarningText(messages.join('. '));
	                setWarningType(status);
	                setIsConfirming(status === WARNING);
	                setLoading(false);
	              }
	
	            case 59:
	              _context.next = 64;
	              break;
	
	            case 61:
	              _context.prev = 61;
	              _context.t0 = _context['catch'](0);
	
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error' }),
	                message: (0, _lodash.get)(_context.t0, 'message'),
	                status: 'error',
	                dismissible: true,
	                dismissAfter: 3000
	              }));
	
	            case 64:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[0, 61]]);
	    }));
	
	    return function submit() {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: { marginTop: 16, display: 'flex' } },
	      _react2.default.createElement(_materialUi.RaisedButton, {
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.wholeDay' }),
	        primary: primaryButton === 'wholeDay',
	        onClick: function onClick() {
	          return onPressDay('wholeDay');
	        }
	      }),
	      _react2.default.createElement(_materialUi.RaisedButton, {
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.halfDay' }),
	        primary: primaryButton === 'halfDay',
	        onClick: function onClick() {
	          return onPressDay('halfDay');
	        }
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: {
	          display: 'flex',
	          flexDirection: 'column'
	        }
	      },
	      showInOutInput === 'true' ? _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { fontSize: 12, color: 'rgba(0,0,0,0.3)', marginTop: 14 } },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.ClockIn' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: timeInputRowStyle },
	            _react2.default.createElement(_reactDatepicker2.default, {
	              selected: (0, _lodash.get)(form, 'timeIn', null) ? (0, _moment2.default)(form.timeIn) : null,
	              onChange: function onChange(date) {
	                var prev = (0, _lodash.get)(form, 'timeIn') ? (0, _moment2.default)(form.timeIn) : (0, _moment2.default)().set({ hour: 8, minute: 0 });
	                formChanged('timeIn', (0, _moment2.default)(date).set({ hour: prev.hours(), minute: prev.minutes() }));
	              },
	              dateFormat: 'DD.MM.YYYY',
	              placeholderText: 'DD.MM.YYYY',
	              customInput: _react2.default.createElement('input', { style: dateInputStyle })
	            }),
	            _react2.default.createElement(TimeSelect, {
	              value: (0, _lodash.get)(form, 'timeIn') ? (0, _moment2.default)(form.timeIn).hours() : 8,
	              count: 24,
	              onChange: function onChange(h) {
	                return formChanged('timeIn', (0, _moment2.default)((0, _lodash.get)(form, 'timeIn') || undefined).set({ hour: h }));
	              }
	            }),
	            _react2.default.createElement(
	              'span',
	              null,
	              ':'
	            ),
	            _react2.default.createElement(TimeSelect, {
	              value: (0, _lodash.get)(form, 'timeIn') ? (0, _moment2.default)(form.timeIn).minutes() : 0,
	              count: 60,
	              onChange: function onChange(m) {
	                return formChanged('timeIn', (0, _moment2.default)((0, _lodash.get)(form, 'timeIn') || undefined).set({ minute: m }));
	              }
	            })
	          ),
	          errors.timeIn && _react2.default.createElement(
	            'div',
	            { style: errorStyle },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { style: { fontSize: 12, color: 'rgba(0,0,0,0.3)', marginTop: 14 } },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.ClockOut' })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: timeInputRowStyle },
	            _react2.default.createElement(_reactDatepicker2.default, {
	              selected: (0, _lodash.get)(form, 'timeOut', null) ? (0, _moment2.default)(form.timeOut) : null,
	              onChange: function onChange(date) {
	                var prev = (0, _lodash.get)(form, 'timeOut') ? (0, _moment2.default)(form.timeOut) : (0, _moment2.default)().set({ hour: 17, minute: 0 });
	                formChanged('timeOut', (0, _moment2.default)(date).set({ hour: prev.hours(), minute: prev.minutes() }));
	              },
	              dateFormat: 'DD.MM.YYYY',
	              placeholderText: 'DD.MM.YYYY',
	              customInput: _react2.default.createElement('input', { style: dateInputStyle })
	            }),
	            _react2.default.createElement(TimeSelect, {
	              value: (0, _lodash.get)(form, 'timeOut') ? (0, _moment2.default)(form.timeOut).hours() : 17,
	              count: 24,
	              onChange: function onChange(h) {
	                return formChanged('timeOut', (0, _moment2.default)((0, _lodash.get)(form, 'timeOut') || undefined).set({ hour: h }));
	              }
	            }),
	            _react2.default.createElement(
	              'span',
	              null,
	              ':'
	            ),
	            _react2.default.createElement(TimeSelect, {
	              value: (0, _lodash.get)(form, 'timeOut') ? (0, _moment2.default)(form.timeOut).minutes() : 0,
	              count: 60,
	              onChange: function onChange(m) {
	                return formChanged('timeOut', (0, _moment2.default)((0, _lodash.get)(form, 'timeOut') || undefined).set({ minute: m }));
	              }
	            })
	          )
	        ),
	        inOutTimeError && _react2.default.createElement(
	          'div',
	          { style: errorStyle },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error.TimeOutBeforeTimeIn' })
	        ),
	        sameTimeError && _react2.default.createElement(
	          'div',
	          { style: errorStyle },
	          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error.inAndOutSame' })
	        )
	      ) : _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_materialUi.TextField, {
	          id: 'date',
	          type: 'date',
	          floatingLabelFixed: true,
	          floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Date' }),
	          errorText: errors.date ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : '',
	          value: (0, _lodash.get)(form, 'date'),
	          onChange: function onChange(event) {
	            formChanged('date', event.target.value);
	          }
	        }),
	        _react2.default.createElement(_materialUi.TextField, {
	          type: 'number',
	          value: (0, _lodash.get)(form, 'hours', 0),
	          onChange: function onChange(_, val) {
	            formChanged('hours', val);
	          },
	          hintStyle: inputStyle,
	          style: inputStyle,
	          inputStyle: inputStyle,
	          floatingLabelStyle: floatingStyle,
	          floatingLabelFixed: true,
	          errorText: errors.hours ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : '',
	          floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.NumberOfHours' })
	        })
	      ),
	      moreThan24HoursError ? _react2.default.createElement(
	        'div',
	        { style: errorStyle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error.MoreThan24HoursError' })
	      ) : '',
	      moreThanZeroError ? _react2.default.createElement(
	        'div',
	        { style: errorStyle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error.MoreThanZero' })
	      ) : '',
	      (0, _lodash.get)(form, 'timeOut') !== '' && (0, _lodash.get)(form, 'timeIn') !== '' && inOutTimeError !== true && sameTimeError !== true && _react2.default.createElement(
	        'div',
	        { style: { marginTop: 10 } },
	        getDuration((0, _lodash.get)(form, 'timeIn'), (0, _lodash.get)(form, 'timeOut'))
	      )
	    ),
	    _react2.default.createElement(
	      _materialUi.SelectField,
	      {
	        fullWidth: true,
	        floatingLabelFixed: true,
	        floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Type' }),
	        value: (0, _lodash.get)(form, 'clockCardEntryTypeID'),
	        onChange: function onChange(event, index, value) {
	          formChanged('clockCardEntryTypeID', value);
	        }
	      },
	      (0, _lodash.map)(entryTypes, function (_ref4) {
	        var ClockCardEntryTypeID = _ref4.ClockCardEntryTypeID,
	            ClockCardEntryTypeName = _ref4.ClockCardEntryTypeName,
	            NameEnglish = _ref4.ClockCardEntryTypeName_EN;
	        return _react2.default.createElement(_materialUi.MenuItem, { key: ClockCardEntryTypeID, value: ClockCardEntryTypeID, primaryText: locale === 'is' ? ClockCardEntryTypeName : NameEnglish || ClockCardEntryTypeName });
	      })
	    ),
	    errors.clockCardEntryTypeID && _react2.default.createElement(
	      'div',
	      { style: errorStyle },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' })
	    ),
	    _react2.default.createElement(
	      'span',
	      { style: { color: warningType === 'ERROR' ? 'red' : _colors2.default.warningColor } },
	      warningText && warningText
	    ),
	    _react2.default.createElement(_materialUi.TextField, {
	      fullWidth: true,
	      floatingLabelFixed: true,
	      floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Comment' }),
	      multiLine: true,
	      value: (0, _lodash.get)(form, 'clockCardEntryComment'),
	      onChange: function onChange(_, comment) {
	        return formChanged('clockCardEntryComment', comment);
	      }
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', justifyContent: 'flex-end', marginTop: 20 } },
	      _react2.default.createElement(_materialUi.FlatButton, {
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.cancel' }),
	        secondary: true,
	        onClick: function onClick() {
	          return closeModal();
	        },
	        disabled: loading
	      }),
	      !isConfirming ? _react2.default.createElement(_materialUi.RaisedButton, {
	        type: 'submit',
	        label: (0, _lodash.size)(selectedEntries) ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.update' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.create' }),
	        primary: true,
	        onClick: submit,
	        disabled: loading || inOutTimeError || sameTimeError || (0, _lodash.get)(errors, 'date', false) === true || (0, _lodash.get)(errors, 'timeIn', false) === true || (0, _lodash.size)((0, _lodash.get)(form, 'clockCardEntryTypeID')) > 0,
	        loading: '' + loading
	      }) : _react2.default.createElement(_materialUi.RaisedButton, {
	        type: 'submit',
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'alert.ok' }),
	        primary: true,
	        onClick: submit,
	        disabled: loading || inOutTimeError || sameTimeError || (0, _lodash.get)(errors, 'date', false) === true || (0, _lodash.get)(errors, 'timeIn', false) === true || (0, _lodash.size)((0, _lodash.get)(form, 'clockCardEntryTypeID')) > 0,
	        loading: '' + loading
	      })
	    )
	  );
	};
	
	DayEntryForm.propTypes = {
	  clearAndClose: _propTypes2.default.func.isRequired,
	  defaultValues: _propTypes2.default.shape({
	    clockCardEntryComment: _propTypes2.default.string,
	    clockCardEntryTypeID: _propTypes2.default.number,
	    timeIn: _propTypes2.default.string,
	    timeOut: _propTypes2.default.string
	  }).isRequired,
	  entryTypes: _propTypes2.default.shape({}).isRequired,
	  hrsPerDay: _propTypes2.default.string.isRequired,
	  primaryButton: _propTypes2.default.string.isRequired,
	  selectedEntries: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
	  setPrimaryButton: _propTypes2.default.func.isRequired,
	  whichButton: _propTypes2.default.func.isRequired,
	  valuesByKey: _propTypes2.default.object,
	  entriesByDate: _propTypes2.default.shape({}).isRequired,
	  getRemainingHours: _propTypes2.default.func.isRequired,
	  isEdit: _propTypes2.default.bool.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  start: _propTypes2.default.object.isRequired,
	  end: _propTypes2.default.object.isRequired,
	  timeEmailTypes: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
	};
	
	var _default = DayEntryForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(OK, 'OK', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(WARNING, 'WARNING', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(ERROR, 'ERROR', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(errorStyle, 'errorStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(inputStyle, 'inputStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(timeInputRowStyle, 'timeInputRowStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(floatingStyle, 'floatingStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(dateInputStyle, 'dateInputStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(tsWrapStyle, 'tsWrapStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(tsTriggerStyle, 'tsTriggerStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(tsListStyle, 'tsListStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(tsOptionStyle, 'tsOptionStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(TimeSelect, 'TimeSelect', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(DayEntryForm, 'DayEntryForm', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/time/components/DayEntryForm.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconButton = __webpack_require__(64);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _reactIntl = __webpack_require__(5);
	
	var _materialUi = __webpack_require__(17);
	
	var _reactRedux = __webpack_require__(12);
	
	var _lodash = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _normalize = __webpack_require__(103);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MultiEntryModal = function MultiEntryModal(_ref) {
	  var modalState = _ref.modalState,
	      closeModal = _ref.closeModal,
	      entryTypes = _ref.entryTypes,
	      selectedEntries = _ref.selectedEntries,
	      isEdit = _ref.isEdit,
	      selectedLanguage = _ref.selectedLanguage,
	      onMultipleEntrySelect = _ref.onMultipleEntrySelect,
	      onMultipleEntryDelete = _ref.onMultipleEntryDelete;
	
	  var columnStyle = {
	    whiteSpace: 'normal',
	    width: 50
	  };
	
	  var clearAndClose = function clearAndClose() {
	    closeModal();
	  };
	
	  return _react2.default.createElement(
	    _materialUi.Dialog,
	    {
	      contentStyle: {
	        overflow: 'hidden',
	        maxWidth: 960,
	        width: '100%'
	      },
	      bodyStyle: {
	        overflowY: 'auto'
	      },
	      modal: true,
	      open: modalState,
	      onRequestClose: clearAndClose
	    },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _materialUi.Table,
	        {
	          bodyStyle: { overflowX: 'none', overflowY: 'none' },
	          selectable: false,
	          multiSelectable: false
	        },
	        _react2.default.createElement(
	          _materialUi.TableHeader,
	          {
	            displaySelectAll: false,
	            adjustForCheckbox: false,
	            enableSelectAll: false
	          },
	          _react2.default.createElement(
	            _materialUi.TableRow,
	            null,
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: columnStyle },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.ClockIn' })
	            ),
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: columnStyle },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.ClockOut' })
	            ),
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: columnStyle },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.ActualClockTime' })
	            ),
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: columnStyle },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Type' })
	            ),
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: { width: 60 } },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Comment' })
	            ),
	            _react2.default.createElement(
	              _materialUi.TableHeaderColumn,
	              { style: { width: 48 } },
	              _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.HasError' })
	            ),
	            _react2.default.createElement(_materialUi.TableHeaderColumn, { style: columnStyle })
	          )
	        ),
	        _react2.default.createElement(
	          _materialUi.TableBody,
	          { displayRowCheckbox: false, deselectOnClickaway: false },
	          (0, _lodash.map)(selectedEntries, function (_ref2, i) {
	            var ClockCardEntryID = _ref2.ClockCardEntryID,
	                ClockIn = _ref2.ClockIn,
	                ClockOut = _ref2.ClockOut,
	                ActualClockTime = _ref2.ActualClockTime,
	                ClockCardEntryComment = _ref2.ClockCardEntryComment,
	                ClockTimeHasError = _ref2.ClockTimeHasError,
	                ClockCardEntryTypeID = _ref2.ClockCardEntryTypeID;
	            return _react2.default.createElement(
	              _materialUi.TableRow,
	              { key: ClockCardEntryID },
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: columnStyle },
	                (0, _moment2.default)(ClockIn).format('HH:mm (DD.MM.YY)')
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: columnStyle },
	                ClockOut ? (0, _moment2.default)(ClockOut).format('HH:mm (DD.MM.YY)') : ''
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: columnStyle },
	                (0, _normalize.unitRender)(ActualClockTime)
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: columnStyle },
	                (0, _lodash.get)(entryTypes, [ClockCardEntryTypeID, selectedLanguage === 'is' ? 'ClockCardEntryTypeName' : 'ClockCardEntryTypeName_EN'])
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: { width: 60, overflow: 'visible' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tooltip' },
	                  _react2.default.createElement(
	                    'div',
	                    { key: ClockCardEntryID, style: { textOverflow: 'ellipsis', overflow: 'hidden' } },
	                    ClockCardEntryComment
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'tooltiptext' },
	                    ClockCardEntryComment
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: { width: 48, overflow: 'visible' } },
	                ClockTimeHasError ? _react2.default.createElement(
	                  _IconButton2.default,
	                  {
	                    disabled: true,
	                    style: { padding: 0, height: 12 },
	                    tooltip: _react2.default.createElement(
	                      'div',
	                      null,
	                      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.HasError.Tooltip' })
	                    ),
	                    iconStyle: { color: _colors2.default.warningColor, padding: 0 },
	                    iconClassName: 'material-icons',
	                    color: _colors2.default.warningColor
	                  },
	                  'report_problem'
	                ) : null
	              ),
	              _react2.default.createElement(
	                _materialUi.TableRowColumn,
	                { style: columnStyle },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  isEdit && _react2.default.createElement(_materialUi.FlatButton, {
	                    primary: true,
	                    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.edit' }),
	                    onClick: function onClick() {
	                      return onMultipleEntrySelect(selectedEntries[i]);
	                    },
	                    style: { marginRight: '8px' }
	                  }),
	                  !isEdit && _react2.default.createElement(_materialUi.FlatButton, {
	                    secondary: true,
	                    label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.delete' }),
	                    onClick: function onClick() {
	                      return onMultipleEntryDelete(selectedEntries[i]);
	                    },
	                    style: { marginRight: '8px' }
	                  })
	                )
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: { display: 'flex', justifyContent: 'flex-end', marginTop: 20 } },
	        _react2.default.createElement(_materialUi.FlatButton, {
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.cancel' }),
	          secondary: true,
	          onClick: function onClick() {
	            return closeModal();
	          }
	        })
	      )
	    )
	  );
	};
	
	MultiEntryModal.propTypes = {
	  modalState: _propTypes2.default.bool.isRequired,
	  isEdit: _propTypes2.default.bool.isRequired,
	  closeModal: _propTypes2.default.func.isRequired,
	  onMultipleEntrySelect: _propTypes2.default.func.isRequired,
	  onMultipleEntryDelete: _propTypes2.default.func.isRequired,
	  entryTypes: _propTypes2.default.shape({}).isRequired,
	  selectedEntries: _propTypes2.default.array,
	  selectedLanguage: _propTypes2.default.string.isRequired
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref3) {
	  var timeReducer = _ref3.timeReducer;
	  return { entryTypes: timeReducer.entryTypes };
	})(MultiEntryModal);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(MultiEntryModal, 'MultiEntryModal', 'D:/a/1/s/src/web/employee/src/sites/time/components/MultiEntryModal.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/time/components/MultiEntryModal.js');
	}();

	;

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PunchInTime = function PunchInTime(_ref) {
	  var openEntry = _ref.openEntry;
	
	  var _useState = (0, _react.useState)(''),
	      _useState2 = _slicedToArray(_useState, 2),
	      time = _useState2[0],
	      setTime = _useState2[1];
	
	  (0, _react.useEffect)(function () {
	    var tick = function tick() {
	      var ms = (0, _moment2.default)().diff((0, _moment2.default)((0, _lodash.get)(openEntry, 'ClockIn')));
	      var d = _moment2.default.duration(ms);
	      setTime(Math.floor(d.asHours()) + _moment2.default.utc(ms).format(':mm:ss'));
	    };
	    var timeInterval = setInterval(tick, 1000);
	    return function () {
	      clearInterval(timeInterval);
	    };
	  }, []);
	  return _react2.default.createElement(
	    'h2',
	    null,
	    time
	  );
	};
	PunchInTime.propTypes = {
	  openEntry: _propTypes2.default.object
	};
	PunchInTime.defaultProps = {
	  openEntry: {
	    ClockIn: '',
	    ClockOut: '',
	    ActualClockTime: 0,
	    ClockTimeHasError: false,
	    ClockCardEntryTypeID: 0,
	    ClockCardEntryComment: ''
	  }
	};
	var _default = PunchInTime;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(PunchInTime, 'PunchInTime', 'D:/a/1/s/src/web/employee/src/sites/time/components/PunchInTime.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/time/components/PunchInTime.js');
	}();

	;

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _reapop = __webpack_require__(44);
	
	var _materialUi = __webpack_require__(17);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(8);
	
	var _holidays = __webpack_require__(227);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _useClockCardEntries2 = __webpack_require__(450);
	
	var _useClockCardEntries3 = _interopRequireDefault(_useClockCardEntries2);
	
	var _holidayResponseStatuses = __webpack_require__(285);
	
	var _holidayResponseStatuses2 = _interopRequireDefault(_holidayResponseStatuses);
	
	var _actions = __webpack_require__(149);
	
	var _EmployeeHoliday = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var OK = _holidayResponseStatuses2.default.OK,
	    WARNING = _holidayResponseStatuses2.default.WARNING,
	    ERROR = _holidayResponseStatuses2.default.ERROR;
	
	
	var errorStyle = {
	  color: 'red',
	  fontSize: '12px',
	  margintop: 20
	};
	var warningStyle = {
	  color: 'orange',
	  fontSize: '12px',
	  margintop: 20
	};
	var inputStyle = { width: 310, textAlign: 'left', marginTop: 10 };
	var floatingStyle = { textAlign: 'left', width: 340 };
	
	var TimeSpanEntryForm = function TimeSpanEntryForm(_ref) {
	  var defaultValues = _ref.defaultValues,
	      selectedEntries = _ref.selectedEntries,
	      entryTypes = _ref.entryTypes,
	      clearAndClose = _ref.clearAndClose,
	      start = _ref.start,
	      end = _ref.end,
	      timeEmailTypes = _ref.timeEmailTypes,
	      dispatch = _ref.dispatch;
	
	  var _useState = (0, _react.useState)(defaultValues),
	      _useState2 = _slicedToArray(_useState, 2),
	      form = _useState2[0],
	      setForm = _useState2[1];
	
	  var _useState3 = (0, _react.useState)({}),
	      _useState4 = _slicedToArray(_useState3, 2),
	      errors = _useState4[0],
	      setErrors = _useState4[1];
	
	  var _useState5 = (0, _react.useState)(false),
	      _useState6 = _slicedToArray(_useState5, 2),
	      dateError = _useState6[0],
	      setDateError = _useState6[1];
	
	  var _useState7 = (0, _react.useState)(false),
	      _useState8 = _slicedToArray(_useState7, 2),
	      moreThan24HoursError = _useState8[0],
	      setMoreThan24HoursError = _useState8[1];
	
	  var _useState9 = (0, _react.useState)(false),
	      _useState10 = _slicedToArray(_useState9, 2),
	      loading = _useState10[0],
	      setLoading = _useState10[1];
	
	  var _useState11 = (0, _react.useState)(''),
	      _useState12 = _slicedToArray(_useState11, 2),
	      warningText = _useState12[0],
	      setWarningText = _useState12[1];
	
	  var _useState13 = (0, _react.useState)(''),
	      _useState14 = _slicedToArray(_useState13, 2),
	      warningType = _useState14[0],
	      setWarningType = _useState14[1];
	
	  var _useState15 = (0, _react.useState)(false),
	      _useState16 = _slicedToArray(_useState15, 2),
	      isConfirming = _useState16[0],
	      setIsConfirming = _useState16[1];
	
	  var _useState17 = (0, _react.useState)(false),
	      _useState18 = _slicedToArray(_useState17, 2),
	      showHalfDayWarning = _useState18[0],
	      setShowHalfDayWarning = _useState18[1];
	
	  var _useClockCardEntries = (0, _useClockCardEntries3.default)(),
	      createClockCardEntries = _useClockCardEntries.createClockCardEntries;
	
	  var locale = localStorage.language === 'is' ? 'is' : 'en';
	
	  var closeModal = function closeModal() {
	    setIsConfirming(false);
	    clearAndClose();
	  };
	
	  var reset = function reset() {
	    setWarningText('');
	    setWarningType('');
	    setDateError(false);
	    setMoreThan24HoursError(false);
	    setIsConfirming(false);
	  };
	
	  var validateAndSetErrors = function validateAndSetErrors() {
	    setErrors((0, _lodash.mapValues)(form, function (v, key) {
	      return key === 'hours' && v <= 0 ? true : !v;
	    }));
	    if (!(0, _lodash.size)((0, _lodash.get)(form, 'dateFrom')) || !(0, _lodash.size)((0, _lodash.get)(form, 'dateTo')) || (0, _lodash.get)(form, 'clockCardEntryTypeID') === null || (0, _lodash.get)(form, 'hours') <= 0.0 || dateError) return true;
	
	    if (parseFloat((0, _lodash.get)(form, 'hours')) > 24) {
	      setMoreThan24HoursError(true);
	      return true;
	    }
	    return false;
	  };
	
	  var checkIfDateError = function checkIfDateError(dateFrom, dateTo) {
	    var from = (0, _moment2.default)((0, _moment2.default)(dateFrom).format('YYYY-MM-DD'));
	    var to = (0, _moment2.default)((0, _moment2.default)(dateTo).format('YYYY-MM-DD'));
	    var isDateFromBeforeDateTo = to.isBefore(from);
	    setDateError(isDateFromBeforeDateTo);
	  };
	  var isHalfDayInPeriod = function isHalfDayInPeriod(dayinout) {
	    if (dayinout == null) {
	      setShowHalfDayWarning(false);
	      return false;
	    }
	
	    var _dayinout = _slicedToArray(dayinout, 2),
	        DateFrom = _dayinout[0],
	        DateTo = _dayinout[1];
	
	    for (var current = DateFrom; current.isBefore(DateTo) || current.isSame(DateTo); current = current.add(1, 'day')) {
	      if ((0, _holidays.isHalfDay)(new Date(current))) {
	        setShowHalfDayWarning(true);
	        return true;
	      }
	    }
	    setShowHalfDayWarning(false);
	    return false;
	  };
	  var formChanged = function formChanged(key, value) {
	    reset();
	    var current = _extends({}, form, _defineProperty({}, key, value));
	    setForm(current);
	    if (key === 'dateTo' || key === 'dateFrom') {
	      if ((0, _lodash.get)(current, 'dateFrom') !== '' && key === 'dateTo') {
	        checkIfDateError((0, _lodash.get)(current, 'dateFrom'), value, key);
	      } else if ((0, _lodash.get)(current, 'dateTo') !== '' && key === 'dateFrom') {
	        checkIfDateError(value, (0, _lodash.get)(current, 'dateTo'), key);
	      }
	      if ((0, _lodash.get)(current, 'dateFrom') !== '' && (0, _lodash.get)(current, 'dateTo') !== '') {
	        isHalfDayInPeriod([(0, _moment2.default)((0, _lodash.get)(current, 'dateFrom')), (0, _moment2.default)((0, _lodash.get)(current, 'dateTo'))]);
	      }
	    }
	    setErrors(_extends({}, errors, _defineProperty({}, key, key === 'hours' && value <= 0 ? true : !value)));
	  };
	
	  var submitSpan = function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
	      var emailData, timeIn, timeOut, PeriodBegda, PeriodEndda, DefaultEmployeeDetailID, payload, res, status, messages, entryType, isVacation;
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              if (validateAndSetErrors()) {
	                _context.next = 29;
	                break;
	              }
	
	              setLoading(true);
	
	              emailData = {
	                ClockCardEntryTypeID: (0, _lodash.get)(form, 'clockCardEntryTypeID'),
	                ClockCardEntryComment: (0, _lodash.get)(form, 'clockCardEntryComment')
	              };
	              timeIn = (0, _moment2.default)((0, _lodash.get)(form, 'dateFrom')).set({
	                hour: 8, minute: 0, second: 0, millisecond: 0
	              });
	              timeOut = (0, _moment2.default)(timeIn);
	
	              timeOut.add((0, _lodash.get)(form, 'hours'), 'hours');
	              PeriodBegda = timeIn.toISOString();
	              PeriodEndda = (0, _moment2.default)((0, _lodash.get)(form, 'dateTo')).set({
	                hour: timeOut.hours(), minute: timeOut.minute(), second: 0, millisecond: 0
	              }).toISOString();
	              DefaultEmployeeDetailID = parseInt(localStorage.getItem('DefaultEmployeeDetailID'), 10);
	              payload = {
	                EmployeeDetailID: DefaultEmployeeDetailID,
	                ClockCardEntryTypeID: (0, _lodash.get)(form, 'clockCardEntryTypeID'),
	                Comment: (0, _lodash.get)(form, 'clockCardEntryComment'),
	                PeriodBegda: PeriodBegda,
	                PeriodEndda: PeriodEndda,
	                HoursPerDay: parseFloat((0, _lodash.get)(form, 'hours')),
	                IncludesWeekends: (0, _lodash.get)(form, 'registerWeekends'),
	                IncludesRedDays: (0, _lodash.get)(form, 'registerRedDays'),
	                UseAccrualsIfNeeded: isConfirming
	              };
	              _context.next = 12;
	              return createClockCardEntries(payload);
	
	            case 12:
	              res = _context.sent;
	              status = (0, _lodash.get)(res, 'status');
	              messages = (0, _lodash.get)(res, 'messages', []);
	
	              if (!(status === OK)) {
	                _context.next = 27;
	                break;
	              }
	
	              closeModal();
	              dispatch((0, _actions.changePeriod)(start, end));
	
	              // Refresh holiday data if vacation was created.
	              // User could be located on dashboard.
	              entryType = (0, _lodash.get)(entryTypes, (0, _lodash.get)(form, 'clockCardEntryTypeID'));
	              isVacation = (0, _lodash.get)(entryType, 'ClockCardEntryTypeRule') === 'Vacation';
	
	              if (isVacation) {
	                dispatch((0, _EmployeeHoliday.fetch)());
	              }
	
	              if (!((0, _lodash.size)(timeEmailTypes) > 0)) {
	                _context.next = 24;
	                break;
	              }
	
	              _context.next = 24;
	              return (0, _actions.sendNotifyEmail)(DefaultEmployeeDetailID, PeriodBegda, PeriodEndda, entryTypes, timeEmailTypes, emailData);
	
	            case 24:
	              dispatch((0, _reapop.addNotification)({
	                title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.notification.batch.created' }),
	                message: messages.join('. '),
	                status: 'success',
	                dismissible: true,
	                dismissAfter: 5000
	              }));
	              _context.next = 28;
	              break;
	
	            case 27:
	              if (status === WARNING || status === ERROR) {
	                setWarningText(messages.join('. '));
	                setWarningType(status);
	                setIsConfirming(status === WARNING);
	                setLoading(false);
	              }
	
	            case 28:
	              setLoading(false);
	
	            case 29:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined);
	    }));
	
	    return function submitSpan() {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: {
	          marginTop: 16,
	          display: 'flex',
	          marginBottom: 10
	        }
	      },
	      _react2.default.createElement(_materialUi.Checkbox, {
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.RegisterWeekends' }),
	        checked: (0, _lodash.get)(form, 'registerWeekends'),
	        onCheck: function onCheck() {
	          return formChanged('registerWeekends', !(0, _lodash.get)(form, 'registerWeekends'));
	        },
	        iconStyle: { marginRight: 4 }
	      }),
	      _react2.default.createElement(_materialUi.Checkbox, {
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.registerRedDays' }),
	        checked: (0, _lodash.get)(form, 'registerRedDays'),
	        onCheck: function onCheck() {
	          return formChanged('registerRedDays', !(0, _lodash.get)(form, 'registerRedDays'));
	        },
	        iconStyle: { marginRight: 4 }
	      })
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', flexDirection: 'column' } },
	      _react2.default.createElement(_materialUi.TextField, {
	        id: 'dateFrom',
	        type: 'date',
	        floatingLabelFixed: true,
	        floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.DateIn' }),
	        errorText: errors.dateFrom ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : '',
	        value: (0, _lodash.get)(form, 'dateFrom'),
	        onChange: function onChange(event) {
	          formChanged('dateFrom', event.target.value);
	        }
	      }),
	      _react2.default.createElement(_materialUi.TextField, {
	        id: 'dateTo',
	        type: 'date',
	        floatingLabelFixed: true,
	        floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.DateOut' }),
	        errorText: errors.dateTo ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' }) : '',
	        value: (0, _lodash.get)(form, 'dateTo'),
	        onChange: function onChange(event) {
	          formChanged('dateTo', event.target.value);
	        }
	      }),
	      dateError && _react2.default.createElement(
	        'div',
	        { style: errorStyle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error.DateOutBeforeDateIn' })
	      ),
	      _react2.default.createElement(_materialUi.TextField, {
	        id: 'hours',
	        type: 'number',
	        value: (0, _lodash.get)(form, 'hours'),
	        onChange: function onChange(_, val) {
	          formChanged('hours', val);
	        },
	        hintStyle: inputStyle,
	        style: inputStyle,
	        inputStyle: inputStyle,
	        floatingLabelStyle: floatingStyle,
	        floatingLabelFixed: true,
	        floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.totalHours.span' })
	      }),
	      errors.hours && _react2.default.createElement(
	        'div',
	        { style: errorStyle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' })
	      ),
	      moreThan24HoursError ? _react2.default.createElement(
	        'div',
	        { style: errorStyle },
	        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.error.MoreThan24HoursTimeSpanError' })
	      ) : ''
	    ),
	    _react2.default.createElement(
	      _materialUi.SelectField,
	      {
	        fullWidth: true,
	        floatingLabelFixed: true,
	        floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Type' }),
	        value: (0, _lodash.get)(form, 'clockCardEntryTypeID'),
	        onChange: function onChange(event, index, value) {
	          formChanged('clockCardEntryTypeID', value);
	        }
	      },
	      (0, _lodash.map)(entryTypes, function (_ref3) {
	        var ClockCardEntryTypeID = _ref3.ClockCardEntryTypeID,
	            ClockCardEntryTypeName = _ref3.ClockCardEntryTypeName,
	            NameEnglish = _ref3.ClockCardEntryTypeName_EN;
	        return _react2.default.createElement(_materialUi.MenuItem, { key: ClockCardEntryTypeID, value: ClockCardEntryTypeID, primaryText: locale === 'is' ? ClockCardEntryTypeName : NameEnglish || ClockCardEntryTypeName });
	      })
	    ),
	    errors.clockCardEntryTypeID && _react2.default.createElement(
	      'div',
	      { style: errorStyle },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'editPanel.required' })
	    ),
	    showHalfDayWarning && _react2.default.createElement(
	      'div',
	      { style: warningStyle },
	      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.HalfDayWarning.Description' })
	    ),
	    _react2.default.createElement(
	      'span',
	      { style: { color: warningType === ERROR ? 'red' : _colors2.default.warningColor } },
	      warningText && warningText
	    ),
	    _react2.default.createElement(_materialUi.TextField, {
	      fullWidth: true,
	      floatingLabelFixed: true,
	      floatingLabelText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.Comment' }),
	      multiLine: true,
	      value: (0, _lodash.get)(form, 'clockCardEntryComment'),
	      onChange: function onChange(_, comment) {
	        return formChanged('clockCardEntryComment', comment);
	      }
	    }),
	    _react2.default.createElement(
	      'div',
	      { style: { display: 'flex', justifyContent: 'flex-end', marginTop: 20 } },
	      _react2.default.createElement(_materialUi.FlatButton, {
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.cancel' }),
	        secondary: true,
	        onClick: function onClick() {
	          return closeModal();
	        },
	        disabled: loading
	      }),
	      loading && _react2.default.createElement(_materialUi.CircularProgress, null),
	      !loading && (!isConfirming ? _react2.default.createElement(_materialUi.RaisedButton, {
	        type: 'submit',
	        label: (0, _lodash.size)(selectedEntries) ? _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.update' }) : _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'time.create' }),
	        primary: true,
	        onClick: submitSpan,
	        disabled: loading || dateError,
	        loading: '' + loading
	      }) : _react2.default.createElement(_materialUi.RaisedButton, {
	        type: 'submit',
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'alert.ok' }),
	        primary: true,
	        onClick: submitSpan,
	        disabled: loading || dateError,
	        loading: '' + loading
	      }))
	    )
	  );
	};
	
	TimeSpanEntryForm.propTypes = {
	  clearAndClose: _propTypes2.default.func.isRequired,
	  defaultValues: _propTypes2.default.shape({
	    clockCardEntryComment: _propTypes2.default.string,
	    clockCardEntryTypeID: _propTypes2.default.number,
	    dateFrom: _propTypes2.default.string,
	    dateTo: _propTypes2.default.string,
	    hours: _propTypes2.default.number,
	    registerRedDays: _propTypes2.default.bool,
	    registerWeekends: _propTypes2.default.bool
	  }).isRequired,
	  entryTypes: _propTypes2.default.shape({}).isRequired,
	  selectedEntries: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  start: _propTypes2.default.string.isRequired,
	  end: _propTypes2.default.string.isRequired,
	  timeEmailTypes: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
	};
	
	var _default = TimeSpanEntryForm;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(OK, 'OK', 'D:/a/1/s/src/web/employee/src/sites/time/components/TimeSpanEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(WARNING, 'WARNING', 'D:/a/1/s/src/web/employee/src/sites/time/components/TimeSpanEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(ERROR, 'ERROR', 'D:/a/1/s/src/web/employee/src/sites/time/components/TimeSpanEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(errorStyle, 'errorStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/TimeSpanEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(warningStyle, 'warningStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/TimeSpanEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(inputStyle, 'inputStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/TimeSpanEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(floatingStyle, 'floatingStyle', 'D:/a/1/s/src/web/employee/src/sites/time/components/TimeSpanEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(TimeSpanEntryForm, 'TimeSpanEntryForm', 'D:/a/1/s/src/web/employee/src/sites/time/components/TimeSpanEntryForm.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/time/components/TimeSpanEntryForm.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(66);
	
	__webpack_require__(8);
	
	var _constants = __webpack_require__(291);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  teamOverview: {
	    openEntry: {},
	    openEntryFetched: false,
	    openEntryFetching: false,
	    openEntryError: false,
	    openEntryErrorMessage: '',
	    isPunching: false,
	    isPunchedIn: false,
	    punchError: false,
	    punchErrorMessage: '',
	    fetchingEntries: false,
	    fetchedEntries: false,
	    workingHours: [],
	    entries: {},
	    loading: {},
	    error: '',
	    hasError: false,
	    start: {},
	    end: {},
	    initialized: false,
	    initializing: false,
	    entryTypes: {},
	    patching: false,
	    patchError: null,
	    deleting: false,
	    posting: false,
	    initializeFailed: false,
	    periodFrom: '1',
	    hideActions: true,
	    workingDays: 0,
	    timeEmailTypes: []
	  }
	};
	
	var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.FETCH_ENTRIES_REQUEST, function (state) {
	  return _extends({}, state, {
	    fetchingEntries: true,
	    entries: {},
	    error: '',
	    hasError: false
	  });
	}), _defineProperty(_handleActions, _constants.FETCH_ENTRIES_SUCCESS, function (state, _ref) {
	  var entries = _ref.entries;
	  return _extends({}, state, {
	    entries: entries,
	    fetchedEntries: true,
	    fetchingEntries: false
	  });
	}), _defineProperty(_handleActions, _constants.FETCH_ENTRIES_FAILURE, function (state, action) {
	  return _extends({}, state, {
	    error: action.error,
	    hasError: true,
	    fetchingEntries: false,
	    fetchedEntries: false
	  });
	}), _defineProperty(_handleActions, _constants.INITIALIZE_REQUEST, function (state) {
	  return _extends({}, state, {
	    initialized: false,
	    initializing: true,
	    error: '',
	    hasError: false,
	    initializeFailed: false
	  });
	}), _defineProperty(_handleActions, _constants.INITIALIZE_SUCCESS, function (state, _ref2) {
	  var entryTypes = _ref2.entryTypes,
	      periodFrom = _ref2.periodFrom,
	      workingHours = _ref2.workingHours,
	      hideActions = _ref2.hideActions,
	      timeEmailTypes = _ref2.timeEmailTypes;
	  return _extends({}, state, {
	    initialized: true,
	    initializing: false,
	    entryTypes: entryTypes,
	    periodFrom: periodFrom,
	    workingHours: workingHours,
	    initializeFailed: false,
	    timeEmailTypes: timeEmailTypes,
	    hideActions: hideActions
	  });
	}), _defineProperty(_handleActions, _constants.INITIALIZE_FAILURE, function (state, _ref3) {
	  var error = _ref3.error;
	  return _extends({}, state, {
	    error: error,
	    hasError: true,
	    initialized: false,
	    initializing: false,
	    initializeFailed: true
	  });
	}), _defineProperty(_handleActions, _constants.PATCH_REQUEST, function (state) {
	  return _extends({}, state, {
	    patching: true
	  });
	}), _defineProperty(_handleActions, _constants.PATCH_SUCCESS, function (state, _ref4) {
	  var entry = _ref4.entry,
	      entryId = _ref4.entryId;
	  return _extends({}, state, {
	    patching: false,
	    entries: _extends({}, state.entries, _defineProperty({}, entryId, entry))
	  });
	}), _defineProperty(_handleActions, _constants.PATCH_FAILURE, function (state, _ref5) {
	  var error = _ref5.error;
	  return _extends({}, state, {
	    patchError: error,
	    patching: false
	  });
	}), _defineProperty(_handleActions, _constants.DELETE_REQUEST, function (state) {
	  return _extends({}, state, {
	    deleting: true
	  });
	}), _defineProperty(_handleActions, _constants.DELETE_SUCCESS, function (state, _ref6) {
	  var entries = _ref6.entries;
	  return _extends({}, state, {
	    entries: _extends({}, entries),
	    deleting: false
	  });
	}), _defineProperty(_handleActions, _constants.DELETE_FAILURE, function (state) {
	  return _extends({}, state, {
	    deleting: false
	  });
	}), _defineProperty(_handleActions, _constants.POST_REQUEST, function (state) {
	  return _extends({}, state, {
	    posting: true
	  });
	}), _defineProperty(_handleActions, _constants.POST_SUCCESS, function (state, _ref7) {
	  var entries = _ref7.entries;
	  return _extends({}, state, {
	    entries: _extends({}, state.entries, entries),
	    posting: false
	  });
	}), _defineProperty(_handleActions, _constants.POST_OUT_OF_RANGE_SUCCESS, function (state) {
	  return _extends({}, state, {
	    posting: false
	  });
	}), _defineProperty(_handleActions, _constants.POST_FAILURE, function (state) {
	  return _extends({}, state, {
	    posting: false
	  });
	}), _defineProperty(_handleActions, _constants.SET_PERIOD, function (state, _ref8) {
	  var start = _ref8.start,
	      end = _ref8.end,
	      datesBetween = _ref8.datesBetween,
	      workingDays = _ref8.workingDays;
	  return _extends({}, state, {
	    start: start,
	    end: end,
	    datesBetween: datesBetween,
	    workingDays: workingDays
	  });
	}), _defineProperty(_handleActions, _constants.PUNCH_REQUEST, function (state) {
	  return _extends({}, state, {
	    isPunching: true
	  });
	}), _defineProperty(_handleActions, _constants.PUNCH_SUCCESS, function (state, _ref9) {
	  var openEntry = _ref9.openEntry,
	      isPunchedIn = _ref9.isPunchedIn;
	  return _extends({}, state, {
	    openEntry: openEntry,
	    isPunchedIn: isPunchedIn,
	    isPunching: false,
	    punchError: false,
	    punchErrorMessage: ''
	  });
	}), _defineProperty(_handleActions, _constants.PUNCH_FAILURE, function (state, _ref10) {
	  var error = _ref10.error;
	  return _extends({}, state, {
	    isPunching: false,
	    punchError: true,
	    punchErrorMessage: error
	  });
	}), _defineProperty(_handleActions, _constants.OPEN_ENTRY_REQUEST, function (state) {
	  return _extends({}, state, {
	    openEntryFetched: false,
	    openEntryFetching: true
	  });
	}), _defineProperty(_handleActions, _constants.OPEN_ENTRY_SUCCESS, function (state, _ref11) {
	  var openEntry = _ref11.openEntry,
	      isPunchedIn = _ref11.isPunchedIn;
	  return _extends({}, state, {
	    openEntry: openEntry,
	    openEntryFetched: true,
	    openEntryFetching: false,
	    isPunchedIn: isPunchedIn,
	    openEntryError: false,
	    openEntryErrorMessage: ''
	  });
	}), _defineProperty(_handleActions, _constants.OPEN_ENTRY_FAILURE, function (state, _ref12) {
	  var error = _ref12.error;
	  return _extends({}, state, {
	    openEntryFetched: true,
	    openEntryFetching: false,
	    openEntryError: true,
	    openEntryErrorMessage: error
	  });
	}), _handleActions), initialState.teamOverview);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/sites/time/reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/time/reducer.js');
	}();

	;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _pick = __webpack_require__(1506);
	
	var _pick2 = _interopRequireDefault(_pick);
	
	var _values = __webpack_require__(583);
	
	var _values2 = _interopRequireDefault(_values);
	
	var _includes = __webpack_require__(204);
	
	var _includes2 = _interopRequireDefault(_includes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _get = __webpack_require__(96);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _Divider = __webpack_require__(172);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	var _materialUi = __webpack_require__(17);
	
	var _TransportationGrant = __webpack_require__(294);
	
	var _TransportationGrant2 = _interopRequireDefault(_TransportationGrant);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _KListItem = __webpack_require__(184);
	
	var _KListItem2 = _interopRequireDefault(_KListItem);
	
	var _constants = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var BackCard = function BackCard(_ref) {
	  var _useState3;
	
	  var embed = _ref.embed,
	      grant = _ref.grant,
	      loading = _ref.loading,
	      handleClick = _ref.handleClick,
	      onSubmit = _ref.onSubmit;
	
	  var _useState = (0, _react.useState)((_useState3 = {}, _defineProperty(_useState3, _constants.STATE_PROPS.PublicTransportation, false), _defineProperty(_useState3, _constants.STATE_PROPS.Cycling, false), _defineProperty(_useState3, _constants.STATE_PROPS.Walking, false), _defineProperty(_useState3, _constants.STATE_PROPS.TransportationCard, false), _useState3)),
	      _useState2 = _slicedToArray(_useState, 2),
	      transportations = _useState2[0],
	      setTransportations = _useState2[1];
	
	  var handleCheck = function handleCheck(stateProp) {
	    return function (_, value) {
	      return setTransportations(_extends({}, transportations, _defineProperty({}, stateProp, value)));
	    };
	  };
	
	  var handleSubmit = function handleSubmit() {
	    var HrTransportationGrantID = grant.HrTransportationGrantID;
	
	    handleClick(false)();
	    onSubmit(_extends({
	      HrTransportationGrantID: HrTransportationGrantID
	    }, (0, _pick2.default)(transportations, (0, _values2.default)(_constants.STATE_PROPS))));
	  };
	
	  var periodStart = (0, _moment2.default)().startOf('month').add(1, 'month');
	  var periodEnd = (0, _moment2.default)(periodStart).add(grant.Months - 1, 'month').endOf('month');
	  var selected = (0, _includes2.default)((0, _pick2.default)(transportations, (0, _values2.default)(_constants.STATE_PROPS)), true);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: embed ? _TransportationGrant2.default.embedCard : _TransportationGrant2.default.card },
	      _react2.default.createElement(_KTitle2.default, { style: { marginBottom: 12 }, title: grant.HrTransportationGrantName }),
	      _react2.default.createElement(_Divider2.default, { style: _TransportationGrant2.default.divider }),
	      (0, _map2.default)(_constants.STATE_PROPS, function (prop) {
	        return (0, _get2.default)(grant, prop) ? _react2.default.createElement(
	          _react2.default.Fragment,
	          { key: '' + grant.HrTransportationGrantID + prop },
	          prop === _constants.STATE_PROPS.TransportationCard ? _react2.default.createElement(_Divider2.default, { style: _TransportationGrant2.default.divider }) : null,
	          _react2.default.createElement(
	            'div',
	            { style: _TransportationGrant2.default.checkboxRow },
	            _react2.default.createElement(
	              _materialUi.FontIcon,
	              { style: _TransportationGrant2.default.icon, className: 'material-icons' },
	              (0, _get2.default)(_constants.ICONS, prop)
	            ),
	            _react2.default.createElement(_materialUi.Checkbox, {
	              'data-cy': grant.HrTransportationGrantName === 'Bus card 6 months' ? 'Bus card' : prop,
	              checked: transportations[prop],
	              onCheck: handleCheck(prop),
	              label: (0, _get2.default)(grant, prop)
	            })
	          )
	        ) : null;
	      }),
	      _react2.default.createElement(
	        'div',
	        { style: _TransportationGrant2.default.details },
	        _react2.default.createElement(
	          _KListItem2.default,
	          { disabled: true },
	          _react2.default.createElement(
	            'div',
	            { style: _TransportationGrant2.default.detailItem },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'transportationGrant.AmountPerMonth' }),
	            _react2.default.createElement(
	              'span',
	              { style: _TransportationGrant2.default.detailItemValue },
	              grant.AmountPerMonth
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _KListItem2.default,
	          { disabled: true },
	          _react2.default.createElement(
	            'div',
	            { style: _TransportationGrant2.default.detailItem },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'transportationGrant.Months' }),
	            _react2.default.createElement(
	              'span',
	              { style: _TransportationGrant2.default.detailItemValue },
	              grant.Months
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _KListItem2.default,
	          { disabled: true },
	          _react2.default.createElement(
	            'div',
	            { style: _TransportationGrant2.default.detailItem },
	            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'transportationGrant.period' }),
	            _react2.default.createElement(
	              'span',
	              { style: _TransportationGrant2.default.detailItemValue },
	              (0, _dateTools2.default)(periodStart) + ' - ' + (0, _dateTools2.default)(periodEnd)
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { style: _TransportationGrant2.default.button },
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          style: { marginRight: 12 },
	          disabled: loading,
	          onClick: handleClick(false),
	          icon: _react2.default.createElement(
	            _materialUi.FontIcon,
	            { className: 'material-icons' },
	            'arrow_back'
	          )
	        }),
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          primary: true,
	          'data-cy': 'send-' + grant.HrTransportationGrantName,
	          disabled: loading || !selected,
	          onClick: handleSubmit,
	          label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'transportationGrant.register.finish' })
	        })
	      )
	    )
	  );
	};
	
	BackCard.propTypes = {
	  loading: _propTypes2.default.bool,
	  handleClick: _propTypes2.default.func.isRequired,
	  onSubmit: _propTypes2.default.func.isRequired,
	  embed: _propTypes2.default.bool,
	  grant: _propTypes2.default.shape({
	    HrTransportationGrantID: _propTypes2.default.number.isRequired,
	    HrTransportationGrantName: _propTypes2.default.string.isRequired,
	    PublicTransportation: _propTypes2.default.string,
	    Cycling: _propTypes2.default.string,
	    Walking: _propTypes2.default.string,
	    TransportationCard: _propTypes2.default.string,
	    Months: _propTypes2.default.number,
	    AmountPerMonth: _propTypes2.default.string,
	    Previous: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      Begda: _propTypes2.default.string,
	      Endda: _propTypes2.default.string
	    }))
	  }).isRequired
	};
	
	BackCard.defaultProps = {
	  loading: false,
	  embed: false
	};
	
	var _default = BackCard;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(BackCard, 'BackCard', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/BackCard.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/BackCard.js');
	}();

	;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactIntl = __webpack_require__(5);
	
	var _lodash = __webpack_require__(8);
	
	var _materialUi = __webpack_require__(17);
	
	var _TransportationGrant = __webpack_require__(294);
	
	var _TransportationGrant2 = _interopRequireDefault(_TransportationGrant);
	
	var _dateTools = __webpack_require__(35);
	
	var _dateTools2 = _interopRequireDefault(_dateTools);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	var _TMessage = __webpack_require__(51);
	
	var _TMessage2 = _interopRequireDefault(_TMessage);
	
	var _constants = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FrontCard = function FrontCard(_ref) {
	  var embed = _ref.embed,
	      grant = _ref.grant,
	      loading = _ref.loading,
	      handleClick = _ref.handleClick;
	  var Previous = grant.Previous;
	
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { style: embed ? _TransportationGrant2.default.embedCard : _TransportationGrant2.default.card },
	      _react2.default.createElement(_KTitle2.default, {
	        style: {
	          margin: 0,
	          marginBottom: 12,
	          fontWeight: 600,
	          fontSize: 20
	        },
	        title: grant.HrTransportationGrantName
	      }),
	      _react2.default.createElement('div', { style: _TransportationGrant2.default.htmlContainer, dangerouslySetInnerHTML: { __html: (0, _lodash.get)(grant, 'EmailTemplate.TextBody') } }),
	      Previous && Previous.length && !loading ? _react2.default.createElement(
	        _TMessage2.default,
	        { style: _TransportationGrant2.default.message, type: 'success', message: 'transportationGrant.active' },
	        (0, _lodash.map)(Previous, function (prev) {
	          return _react2.default.createElement(
	            'div',
	            { key: prev.EmployeeMasterTransportationID, style: _TransportationGrant2.default.dateRange },
	            (0, _dateTools2.default)(prev.Begda) + ' - ' + (0, _dateTools2.default)(prev.Endda),
	            (0, _lodash.map)(_constants.STATE_PROPS, function (prop) {
	              return (0, _lodash.get)(prev, prop) ? _react2.default.createElement(
	                _materialUi.FontIcon,
	                { key: prop, style: _TransportationGrant2.default.iconActivity, className: 'material-icons' },
	                (0, _lodash.get)(_constants.ICONS, prop)
	              ) : null;
	            })
	          );
	        })
	      ) : null,
	      _react2.default.createElement(_materialUi.RaisedButton, {
	        'data-cy': 'register-' + grant.HrTransportationGrantName,
	        primary: true,
	        style: _TransportationGrant2.default.button,
	        label: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'transportationGrant.register' }),
	        onClick: handleClick(true)
	      })
	    )
	  );
	};
	
	FrontCard.propTypes = {
	  loading: _propTypes2.default.bool,
	  handleClick: _propTypes2.default.func.isRequired,
	  embed: _propTypes2.default.bool,
	  grant: _propTypes2.default.shape({
	    HrTransportationGrantID: _propTypes2.default.number.isRequired,
	    HrTransportationGrantName: _propTypes2.default.string.isRequired,
	    PublicTransportation: _propTypes2.default.string,
	    Cycling: _propTypes2.default.string,
	    Walking: _propTypes2.default.string,
	    TransportationCard: _propTypes2.default.string,
	    Months: _propTypes2.default.number,
	    AmountPerMonth: _propTypes2.default.string,
	    Previous: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      Begda: _propTypes2.default.string,
	      Endda: _propTypes2.default.string
	    }))
	  }).isRequired
	};
	
	FrontCard.defaultProps = {
	  loading: false,
	  embed: false
	};
	
	var _default = FrontCard;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(FrontCard, 'FrontCard', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/FrontCard.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/FrontCard.js');
	}();

	;

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _map = __webpack_require__(46);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _reactIntl = __webpack_require__(5);
	
	var _Loading = __webpack_require__(33);
	
	var _Loading2 = _interopRequireDefault(_Loading);
	
	var _PanelMessage = __webpack_require__(24);
	
	var _PanelMessage2 = _interopRequireDefault(_PanelMessage);
	
	var _TransportationGrant = __webpack_require__(451);
	
	var _TransportationGrant2 = _interopRequireDefault(_TransportationGrant);
	
	var _actions = __webpack_require__(452);
	
	var _KTitle = __webpack_require__(29);
	
	var _KTitle2 = _interopRequireDefault(_KTitle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var duplicateRegister = 'Employee has an active EmployeeMasterTransportation contract';
	
	var styles = {
	  container: {
	    paddingTop: 16,
	    paddingBottom: 16,
	    display: 'flex',
	    alignItems: 'center',
	    flexDirection: 'row',
	    flexWrap: 'wrap',
	    maxWidth: 1344,
	    margin: 'auto'
	  },
	  titleContainer: {
	    width: '100%'
	  },
	  list: {
	    paddingBottom: 16,
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    flexDirection: 'row',
	    flexWrap: 'wrap',
	    maxWidth: 1344,
	    margin: 'auto'
	  }
	};
	
	var TransportationGrants = function (_Component) {
	  _inherits(TransportationGrants, _Component);
	
	  function TransportationGrants() {
	    _classCallCheck(this, TransportationGrants);
	
	    return _possibleConstructorReturn(this, (TransportationGrants.__proto__ || Object.getPrototypeOf(TransportationGrants)).apply(this, arguments));
	  }
	
	  _createClass(TransportationGrants, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var fetchGrants = this.props.fetchGrants;
	
	      fetchGrants();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          grantsLoading = _props.grantsLoading,
	          grantsError = _props.grantsError,
	          grantRegister = _props.grantRegister,
	          transportationGrants = _props.transportationGrants,
	          registerError = _props.registerError,
	          registerLoadingById = _props.registerLoadingById;
	
	
	      if (grantsLoading) {
	        return _react2.default.createElement(_Loading2.default, null);
	      }
	
	      if (grantsError) {
	        return _react2.default.createElement(_PanelMessage2.default, {
	          message: _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'transportationGrants.error',
	            values: { error: grantsError }
	          }),
	          iconName: 'error',
	          type: 'error'
	        });
	      }
	
	      if (registerError && registerError !== duplicateRegister) {
	        return _react2.default.createElement(_PanelMessage2.default, {
	          message: _react2.default.createElement(_reactIntl.FormattedMessage, {
	            id: 'transportationGrants.error',
	            values: { error: registerError }
	          }),
	          iconName: 'error',
	          type: 'error'
	        });
	      }
	
	      if (!grantsError && transportationGrants && !transportationGrants.length) {
	        return _react2.default.createElement(_PanelMessage2.default, {
	          message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'transportationGrants.empty' }),
	          iconName: 'info',
	          type: 'info'
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.container },
	        registerError === duplicateRegister ? _react2.default.createElement(_PanelMessage2.default, {
	          message: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'transportationGrants.duplicate' }),
	          iconName: 'warning',
	          type: 'warning'
	        }) : null,
	        _react2.default.createElement(_KTitle2.default, { containerStyle: styles.titleContainer, title: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'tile.transportations.title' }) }),
	        (0, _map2.default)(transportationGrants, function (grant) {
	          return _react2.default.createElement(
	            'div',
	            { style: { margin: 12 } },
	            _react2.default.createElement(_TransportationGrant2.default, {
	              key: grant.HrTransportationGrantID,
	              loading: registerLoadingById[grant.HrTransportationGrantID],
	              onSubmit: grantRegister,
	              grant: grant
	            })
	          );
	        })
	      );
	    }
	  }]);
	
	  return TransportationGrants;
	}(_react.Component);
	
	TransportationGrants.propTypes = {
	  fetchGrants: _propTypes2.default.func.isRequired,
	  grantRegister: _propTypes2.default.func.isRequired,
	  registerError: _propTypes2.default.string,
	  registerLoadingById: _propTypes2.default.objectOf(_propTypes2.default.bool).isRequired,
	  grantsError: _propTypes2.default.string,
	  grantsLoading: _propTypes2.default.bool.isRequired,
	  transportationGrants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    HrTransportationGrantID: _propTypes2.default.number.isRequired,
	    HrTransportationGrantName: _propTypes2.default.string.isRequired,
	    PublicTransportation: _propTypes2.default.string,
	    Cycling: _propTypes2.default.string,
	    Walking: _propTypes2.default.string,
	    TransportationCard: _propTypes2.default.string,
	    Months: _propTypes2.default.number,
	    AmountPerMonth: _propTypes2.default.string
	  })).isRequired
	};
	
	TransportationGrants.defaultProps = {
	  grantsError: null,
	  registerError: null
	};
	
	var _default = (0, _reactRedux.connect)(function (_ref) {
	  var TransportationGrantReducer = _ref.TransportationGrantReducer;
	  return _extends({}, TransportationGrantReducer);
	}, function (dispatch) {
	  return {
	    fetchGrants: function fetchGrants() {
	      return dispatch((0, _actions.fetch)());
	    },
	    grantRegister: function grantRegister(transportGrant) {
	      return dispatch((0, _actions.register)(transportGrant));
	    }
	  };
	})(TransportationGrants);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(duplicateRegister, 'duplicateRegister', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/TransportationGrants.js');
	
	  __REACT_HOT_LOADER__.register(styles, 'styles', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/TransportationGrants.js');
	
	  __REACT_HOT_LOADER__.register(TransportationGrants, 'TransportationGrants', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/TransportationGrants.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/TransportationGrants.js');
	}();

	;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(66);
	
	var _findIndex = __webpack_require__(368);
	
	var _findIndex2 = _interopRequireDefault(_findIndex);
	
	var _set = __webpack_require__(1509);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _constants = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  grantsLoading: true,
	  grantsError: null,
	  transportationGrants: [],
	  registerError: null,
	  registerLoadingById: {}
	};
	
	var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.REQUEST_TRANSPORT_GRANTS, function (state) {
	  return _extends({}, state, {
	    loadingGrants: true,
	    transportationsLoadingById: {}
	  });
	}), _defineProperty(_handleActions, _constants.REQUEST_TRANSPORT_GRANTS_SUCCESS, function (state, _ref) {
	  var transportationGrants = _ref.transportationGrants;
	  return _extends({}, state, {
	    grantsLoading: false,
	    transportationGrants: transportationGrants
	  });
	}), _defineProperty(_handleActions, _constants.REQUEST_TRANSPORT_GRANTS_FAILURE, function (state, _ref2) {
	  var error = _ref2.error;
	  return _extends({}, state, {
	    grantsLoading: false,
	    grantsError: error.message || error.Message
	  });
	}), _defineProperty(_handleActions, _constants.EMPLOYEE_TRANSPORT_GRANT_REGISTER, function (state, _ref3) {
	  var transportationGrantId = _ref3.transportationGrantId;
	  return _extends({}, state, {
	    registerLoadingById: _extends({}, state.registerLoadingById, _defineProperty({}, transportationGrantId, true))
	  });
	}), _defineProperty(_handleActions, _constants.EMPLOYEE_TRANSPORT_GRANT_REGISTER_SUCCESS, function (state, _ref4) {
	  var transportationGrantId = _ref4.transportationGrantId,
	      employeeMasterTransportations = _ref4.employeeMasterTransportations;
	
	  var index = (0, _findIndex2.default)(state.transportationGrants, ['HrTransportationGrantID', transportationGrantId]);
	  if (index > -1) {
	    (0, _set2.default)(state, 'transportationGrants[' + index + '].Previous', employeeMasterTransportations);
	  }
	  return _extends({}, state, {
	    registerLoadingById: _extends({}, state.registerLoadingById, _defineProperty({}, transportationGrantId, false))
	  });
	}), _defineProperty(_handleActions, _constants.EMPLOYEE_TRANSPORT_GRANT_REGISTER_FAILURE, function (state, _ref5) {
	  var error = _ref5.error,
	      transportationGrantId = _ref5.transportationGrantId;
	  return _extends({}, state, {
	    registerError: error.message || error.Message,
	    registerLoadingById: _extends({}, state.registerLoadingById, _defineProperty({}, transportationGrantId, false))
	  });
	}), _handleActions), initialState);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/transportationGrants/reducer.js');
	}();

	;

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _lodash = __webpack_require__(8);
	
	var _materialUi = __webpack_require__(17);
	
	var _Pagination = __webpack_require__(443);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var columnStyle = {
	  whiteSpace: 'normal',
	  paddingRight: 0,
	  paddingLeft: 0,
	  border: '1px groove',
	  width: 40
	};
	var VacationTable = function VacationTable(_ref) {
	  var entries = _ref.entries,
	      table = _ref.table;
	
	  var _useState = (0, _react.useState)(1),
	      _useState2 = _slicedToArray(_useState, 2),
	      currentPage = _useState2[0],
	      setCurrentPage = _useState2[1];
	
	  var _useState3 = (0, _react.useState)(10),
	      _useState4 = _slicedToArray(_useState3, 2),
	      itemsPerPage = _useState4[0],
	      setItemsPerPage = _useState4[1];
	
	  var _useState5 = (0, _react.useState)([]),
	      _useState6 = _slicedToArray(_useState5, 2),
	      dataSource = _useState6[0],
	      setDataSource = _useState6[1];
	
	  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
	    return state.vacationApprovalsReducer;
	  }),
	      loading = _useSelector.loading;
	
	  (0, _react.useEffect)(function () {
	    setDataSource(entries);
	  }, [entries]);
	  var getCell = function getCell(request) {
	    var styleBase = {
	      color: 'white',
	      border: 'none',
	      borderRadius: 0,
	      width: '100%',
	      height: '100%',
	      display: 'flex',
	      boxShadow: 'none',
	      justifyContent: 'center',
	      background: 'white'
	    };
	    return _react2.default.createElement('span', { style: _extends({}, styleBase, { background: request.color }) });
	  };
	  return _react2.default.createElement(
	    _materialUi.Paper,
	    { style: { maxWidth: 1600, margin: 'auto' } },
	    loading && _react2.default.createElement(_materialUi.LinearProgress, { mode: 'indeterminate' }),
	    _react2.default.createElement(
	      _Pagination2.default,
	      {
	        data: dataSource,
	        itemsPerPage: itemsPerPage,
	        setItemsPerPage: setItemsPerPage,
	        currentPage: currentPage,
	        setCurrentPage: setCurrentPage
	      },
	      function (currentData) {
	        return _react2.default.createElement(
	          'div',
	          { style: {
	              overflowX: 'auto', maxWidth: '100%'
	            }
	          },
	          _react2.default.createElement(
	            _materialUi.Table,
	            {
	              className: 'vacation-table',
	              bodyStyle: { overflowX: 'none', overflowY: 'none', minHeight: 520 },
	              fixedHeader: true
	            },
	            _react2.default.createElement(
	              _materialUi.TableHeader,
	              {
	                displaySelectAll: false,
	                adjustForCheckbox: false,
	                enableSelectAll: false
	              },
	              _react2.default.createElement(
	                _materialUi.TableRow,
	                { key: 'table-key', hoverable: true },
	                (0, _lodash.map)(table.columns, function (c, i) {
	                  return (
	                    // eslint-disable-next-line no-nested-ternary
	                    _react2.default.createElement(
	                      _materialUi.TableHeaderColumn,
	                      { key: i, style: _extends({}, columnStyle), className: i === 0 ? 'sticky-column' : c.isRedDay || c.isWeekend ? 'weekend-column' : '' },
	                      c.title
	                    )
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _materialUi.TableBody,
	              {
	                displayRowCheckbox: false,
	                deselectOnClickaway: false,
	                showRowHover: true,
	                stripedRows: false
	              },
	              !loading ? (0, _lodash.map)(currentData, function (row, index) {
	                return _react2.default.createElement(
	                  _materialUi.TableRow,
	                  { key: index, displayBorder: true },
	                  '(',
	                  (0, _lodash.map)(table.columns, function (c, i) {
	                    return _react2.default.createElement(
	                      _materialUi.TableRowColumn,
	                      {
	                        key: i,
	                        style: _extends({}, columnStyle)
	                        // eslint-disable-next-line no-nested-ternary
	                        , className: i === 0 ? 'sticky-column' : c.isRedDay || c.isWeekend ? 'weekend-column' : ''
	                      },
	                      c.render ? c.render(row[c.dataIndex]) : row[c.dataIndex],
	                      row.approvalRequests[c.dataIndex] ? getCell(row.approvalRequests[c.dataIndex]) : null
	                    );
	                  }),
	                  ')'
	                );
	              }) : null
	            )
	          )
	        );
	      }
	    )
	  );
	};
	
	VacationTable.propTypes = {
	  table: _propTypes2.default.shape({
	    columns: _propTypes2.default.array.isRequired,
	    key: _propTypes2.default.string.isRequired
	  }).isRequired,
	  entries: _propTypes2.default.array.isRequired
	};
	
	var _default = (0, _reactRedux.connect)()(VacationTable);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(columnStyle, 'columnStyle', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/VacationTable.js');
	
	  __REACT_HOT_LOADER__.register(VacationTable, 'VacationTable', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/VacationTable.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/VacationTable.js');
	}();

	;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useVacationApprovalsState = exports.initialize = exports.initializeFailure = exports.initializeSuccess = exports.initializeRequest = exports.changePeriod = exports.requestEntries = exports.fetchEntriesFailure = exports.fetchEntriesSuccess = exports.fetchEntriesRequest = exports.setPeriod = undefined;
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _axios = __webpack_require__(179);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(12);
	
	var _constants = __webpack_require__(293);
	
	var _api = __webpack_require__(1019);
	
	var _Api = __webpack_require__(21);
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _holidays = __webpack_require__(227);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // /* eslint-disable */
	
	
	var getDates = function getDates(startDate, endDate, lang) {
	  var dateArray = [];
	  var currentDate = new Date(startDate);
	  _moment2.default.locale(lang);
	  while (currentDate <= endDate) {
	    dateArray.push({
	      dateString: (0, _moment2.default)(currentDate).format('DD/MM/YY'),
	      date: (0, _moment2.default)(currentDate),
	      isWeekend: currentDate.getDay() === 6 || currentDate.getDay() === 0,
	      dayOfWeek: (0, _moment2.default)(currentDate).format('ddd'),
	      isRedDay: (0, _holidays.isRedDay)(currentDate)
	    });
	    currentDate.setDate(currentDate.getDate() + 1);
	  }
	  return dateArray;
	};
	
	var setCancelToken = function setCancelToken(cancelToken) {
	  return {
	    type: _constants.SET_CANCEL_TOKEN,
	    cancelToken: cancelToken
	  };
	};
	
	var setPeriod = exports.setPeriod = function setPeriod(start, end, lang) {
	  return {
	    type: _constants.SET_PERIOD,
	    start: start,
	    end: end,
	    datesBetween: getDates(start, end, lang)
	  };
	};
	
	var fetchEntriesRequest = exports.fetchEntriesRequest = function fetchEntriesRequest() {
	  return {
	    type: _constants.FETCH_RECORDS_REQUEST
	  };
	};
	
	var fetchEntriesSuccess = exports.fetchEntriesSuccess = function fetchEntriesSuccess(employees) {
	  return {
	    type: _constants.FETCH_RECORDS_SUCCESS,
	    employees: employees
	  };
	};
	
	var fetchEntriesFailure = exports.fetchEntriesFailure = function fetchEntriesFailure(error) {
	  return {
	    type: _constants.FETCH_RECORDS_FAILURE,
	    error: error
	  };
	};
	
	var getColor = function getColor(status) {
	  switch (status) {
	    case 'Expired':
	      return '#808080';
	    case 'Accepted':
	      return '#77BB97';
	    case 'Pending':
	      return _colors2.default.warningColor;
	    default:
	      return _colors2.default.errorColor;
	  }
	};
	
	var requestEntries = exports.requestEntries = function requestEntries(start, end) {
	  return function () {
	    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch, getState) {
	      var _getState, cancelToken, EmployeeMasterID, CancelToken, source, employeesRes, employeesData, employees;
	
	      return regeneratorRuntime.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              _getState = getState(), cancelToken = _getState.vacationApprovalsReducer.cancelToken, EmployeeMasterID = _getState.loginReducer.user.EmployeeMasterID;
	
	              if (cancelToken) {
	                cancelToken.cancel();
	              }
	              _context.prev = 2;
	              CancelToken = _axios2.default.CancelToken;
	              source = CancelToken.source();
	
	              dispatch(setCancelToken(source));
	              dispatch(fetchEntriesRequest());
	
	              _context.next = 9;
	              return (0, _Api.custom)((0, _api.getEntries)(start, end, EmployeeMasterID, source.token));
	
	            case 9:
	              employeesRes = _context.sent;
	              employeesData = (0, _lodash.get)(employeesRes, 'data.value', []);
	              employees = [];
	
	              employeesData.forEach(function (item) {
	                var ApprovalRequests = item.ApprovalRequests;
	
	                var approvalRequests = {};
	                ApprovalRequests.forEach(function (request) {
	                  var PeriodBegda = request.PeriodBegda,
	                      PeriodEndda = request.PeriodEndda;
	
	                  var from = (0, _moment2.default)(PeriodBegda);
	                  var to = (0, _moment2.default)(PeriodEndda);
	                  while (from <= to) {
	                    var existing = approvalRequests[from.format('DD/MM/YY')];
	                    // we don't need to show overlapping requests if existing request is accepted
	                    if (!existing || existing.status !== 'Accepted') {
	                      approvalRequests[from.format('DD/MM/YY')] = {
	                        duration: request.Duration,
	                        status: request.ApprovalRequestStatus,
	                        color: getColor(request.ApprovalRequestStatus),
	                        id: request.EmployeeDetailApprovalRequestID
	                      };
	                    }
	                    from.add(1, 'days');
	                  }
	                });
	                employees.push(_extends({}, item, { approvalRequests: approvalRequests }));
	              });
	              dispatch(setCancelToken(null));
	              dispatch(fetchEntriesSuccess(employees));
	              _context.next = 20;
	              break;
	
	            case 17:
	              _context.prev = 17;
	              _context.t0 = _context['catch'](2);
	
	              if (!_axios2.default.isCancel(_context.t0)) {
	                dispatch(fetchEntriesFailure(_context.t0));
	              }
	
	            case 20:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, undefined, [[2, 17]]);
	    }));
	
	    return function (_x, _x2) {
	      return _ref.apply(this, arguments);
	    };
	  }();
	};
	
	var changePeriod = exports.changePeriod = function changePeriod(start, end) {
	  return function () {
	    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
	      var _getState2, language;
	
	      return regeneratorRuntime.wrap(function _callee2$(_context2) {
	        while (1) {
	          switch (_context2.prev = _context2.next) {
	            case 0:
	              _getState2 = getState(), language = _getState2.languageReducer.language;
	
	              dispatch(setPeriod(start.startOf('day'), end.endOf('day'), language));
	              dispatch(requestEntries(start.startOf('day'), end.endOf('day')));
	
	            case 3:
	            case 'end':
	              return _context2.stop();
	          }
	        }
	      }, _callee2, undefined);
	    }));
	
	    return function (_x3, _x4) {
	      return _ref2.apply(this, arguments);
	    };
	  }();
	};
	
	var initializeRequest = exports.initializeRequest = function initializeRequest() {
	  return {
	    type: _constants.INITIALIZE_REQUEST
	  };
	};
	
	var initializeSuccess = exports.initializeSuccess = function initializeSuccess(periodFrom, approvalStatusTypes) {
	  return {
	    type: _constants.INITIALIZE_SUCCESS,
	    periodFrom: periodFrom,
	    approvalStatusTypes: approvalStatusTypes
	  };
	};
	
	var initializeFailure = exports.initializeFailure = function initializeFailure(error) {
	  return {
	    type: _constants.INITIALIZE_FAILURE,
	    error: error
	  };
	};
	
	var initialize = exports.initialize = function initialize() {
	  return function () {
	    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
	      var requests, _ref4, _ref5, xapRes, periodFrom, startDate, endDate, approvalStatusTypes;
	
	      return regeneratorRuntime.wrap(function _callee3$(_context3) {
	        while (1) {
	          switch (_context3.prev = _context3.next) {
	            case 0:
	              _context3.prev = 0;
	
	              dispatch(initializeRequest());
	              requests = [(0, _Api.custom)((0, _api.getXapValue)('Pay.PeriodFrom'))];
	              _context3.next = 5;
	              return Promise.all(requests);
	
	            case 5:
	              _ref4 = _context3.sent;
	              _ref5 = _slicedToArray(_ref4, 1);
	              xapRes = _ref5[0];
	              periodFrom = (0, _lodash.get)(xapRes, 'data.value[0].Value');
	
	              if (!periodFrom) {
	                periodFrom = '1';
	              }
	              startDate = (0, _moment2.default)().date(periodFrom).add(-1, 'months').startOf('day');
	              endDate = (0, _moment2.default)().date(periodFrom - 1).endOf('day');
	
	              if (endDate.isSameOrBefore((0, _moment2.default)())) {
	                startDate = startDate.add(1, 'months');
	                endDate = endDate.add(1, 'months');
	              }
	
	              approvalStatusTypes = [{
	                id: 'Accepted',
	                value: 'Accepted',
	                color: getColor('Accepted')
	              }, {
	                id: 'Pending',
	                value: 'Pending',
	                color: getColor('Pending')
	              }, {
	                id: 'Rejected',
	                value: 'Rejected',
	                color: getColor('Rejected')
	              }];
	
	
	              dispatch(initializeSuccess(periodFrom, approvalStatusTypes));
	              dispatch(changePeriod(startDate, endDate));
	              _context3.next = 21;
	              break;
	
	            case 18:
	              _context3.prev = 18;
	              _context3.t0 = _context3['catch'](0);
	
	              dispatch(initializeFailure((0, _lodash.get)(_context3.t0, 'message')));
	
	            case 21:
	            case 'end':
	              return _context3.stop();
	          }
	        }
	      }, _callee3, undefined, [[0, 18]]);
	    }));
	
	    return function (_x5) {
	      return _ref3.apply(this, arguments);
	    };
	  }();
	};
	
	var useVacationApprovalsState = exports.useVacationApprovalsState = function useVacationApprovalsState() {
	  return (0, _reactRedux.useSelector)(function (state) {
	    return state.vacationApprovalsReducer;
	  });
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getDates, 'getDates', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(setCancelToken, 'setCancelToken', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(setPeriod, 'setPeriod', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchEntriesRequest, 'fetchEntriesRequest', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchEntriesSuccess, 'fetchEntriesSuccess', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(fetchEntriesFailure, 'fetchEntriesFailure', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(getColor, 'getColor', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(requestEntries, 'requestEntries', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(changePeriod, 'changePeriod', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeRequest, 'initializeRequest', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeSuccess, 'initializeSuccess', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(initializeFailure, 'initializeFailure', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(initialize, 'initialize', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	
	  __REACT_HOT_LOADER__.register(useVacationApprovalsState, 'useVacationApprovalsState', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/actions.js');
	}();

	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getXapValue = exports.getXapValue = function getXapValue(val) {
	  return {
	    url: '/kjarni/api/v2/XapValues',
	    method: 'GET',
	    params: {
	      $filter: 'XapValueName eq \'' + val + '\''
	    }
	  };
	};
	
	var getEntries = exports.getEntries = function getEntries(dateFrom, dateTo, masterId, cancelToken) {
	  return {
	    url: '/kjarni/api/v2/EmployeeDetailApprovalRequests/RequestsByPeriod',
	    method: 'POST',
	    data: {
	      dateFrom: dateFrom,
	      dateTo: dateTo
	    },
	    cancelToken: cancelToken
	  };
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getXapValue, 'getXapValue', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/api.js');
	
	  __REACT_HOT_LOADER__.register(getEntries, 'getEntries', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/api.js');
	}();

	;

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _constants = __webpack_require__(293);
	
	var _reducer = __webpack_require__(1021);
	
	var _reducer2 = _interopRequireDefault(_reducer);
	
	var _VacationApprovals = __webpack_require__(453);
	
	var _VacationApprovals2 = _interopRequireDefault(_VacationApprovals);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  name: _constants.name,
	  VacationApprovals: _VacationApprovals2.default,
	  reducer: _reducer2.default
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/index.js');
	}();

	;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _handleActions;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _reduxActions = __webpack_require__(66);
	
	__webpack_require__(8);
	
	var _constants = __webpack_require__(293);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var initialState = {
	  vacations: {
	    employees: [],
	    approvalStatusTypes: {},
	    datesBetween: [],
	    loading: false,
	    error: '',
	    hasError: false,
	    start: {},
	    end: {},
	    initialized: false,
	    initializing: false,
	    initializeFailed: false,
	    periodFrom: '1',
	    cancelToken: null
	  }
	};
	
	var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.FETCH_RECORDS_REQUEST, function (state) {
	  return _extends({}, state, {
	    fetchingEntries: true,
	    employees: [],
	    error: '',
	    hasError: false,
	    loading: true
	  });
	}), _defineProperty(_handleActions, _constants.FETCH_RECORDS_SUCCESS, function (state, _ref) {
	  var employees = _ref.employees;
	  return _extends({}, state, {
	    employees: employees,
	    loading: false
	  });
	}), _defineProperty(_handleActions, _constants.FETCH_RECORDS_FAILURE, function (state, action) {
	  return _extends({}, state, {
	    loading: false,
	    error: action.error,
	    hasError: true
	  });
	}), _defineProperty(_handleActions, _constants.INITIALIZE_REQUEST, function (state) {
	  return _extends({}, state, {
	    initialized: false,
	    initializing: true,
	    error: '',
	    hasError: false,
	    initializeFailed: false,
	    loading: true
	  });
	}), _defineProperty(_handleActions, _constants.INITIALIZE_SUCCESS, function (state, _ref2) {
	  var periodFrom = _ref2.periodFrom,
	      approvalStatusTypes = _ref2.approvalStatusTypes;
	  return _extends({}, state, {
	    initialized: true,
	    initializing: false,
	    periodFrom: periodFrom,
	    approvalStatusTypes: approvalStatusTypes,
	    initializeFailed: false,
	    loading: false
	  });
	}), _defineProperty(_handleActions, _constants.INITIALIZE_FAILURE, function (state, _ref3) {
	  var error = _ref3.error;
	  return _extends({}, state, {
	    error: error,
	    hasError: true,
	    initialized: false,
	    initializing: false,
	    initializeFailed: true,
	    loading: false
	  });
	}), _defineProperty(_handleActions, _constants.SET_PERIOD, function (state, _ref4) {
	  var start = _ref4.start,
	      end = _ref4.end,
	      datesBetween = _ref4.datesBetween;
	  return _extends({}, state, {
	    start: start,
	    end: end,
	    datesBetween: datesBetween
	  });
	}), _defineProperty(_handleActions, _constants.SET_CANCEL_TOKEN, function (state, action) {
	  return _extends({}, state, {
	    cancelToken: action.cancelToken
	  });
	}), _handleActions), initialState.vacations);
	
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(initialState, 'initialState', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/reducer.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/sites/vacationApprovals/reducer.js');
	}();

	;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.insights = undefined;
	exports.default = configureStore;
	
	var _redux = __webpack_require__(178);
	
	var _reduxThunk = __webpack_require__(1823);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _lodash = __webpack_require__(8);
	
	var _reactRouterRedux = __webpack_require__(57);
	
	var _reactRouter = __webpack_require__(401);
	
	var _reduxLogger = __webpack_require__(1822);
	
	var _reduxBatchedSubscribe = __webpack_require__(1748);
	
	var _reactDom = __webpack_require__(30);
	
	var _config = __webpack_require__(54);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _reducers = __webpack_require__(982);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _insights = __webpack_require__(962);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint camelcase: 0, global-require: 0 */
	
	
	var __PRODUCTION__ = __PRODUCTION__ || ("production") === 'production'; // eslint-disable-line
	
	var logger = (0, _reduxLogger.createLogger)({
	  collapsed: true,
	  predicate: function predicate() {
	    return ("production") === 'development';
	  }
	});
	
	var insights = exports.insights = (0, _insights.appInsights)();
	if (_insights.trackingIsActive) {
	  insights.loadAppInsights();
	  insights.addTelemetryInitializer(function (telemetry) {
	    (0, _lodash.set)(telemetry, ['tags', 'ai.cloud.role'], 'Employee Web');
	    (0, _lodash.set)(telemetry, ['tags', 'ai.cloud.roleInstance'], (0, _lodash.get)(_config2.default, 'siteName'));
	  });
	}
	
	var middlewares = [_reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(_reactRouter.browserHistory), !__PRODUCTION__ && logger].filter(Boolean);
	
	var createStoreWithMiddleware = _redux.applyMiddleware.apply(undefined, _toConsumableArray(middlewares))(_redux.createStore);
	
	function configureStore(initialState) {
	  var store = createStoreWithMiddleware(_reducers2.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(), // eslint-disable-line no-underscore-dangle
	  initialState, (0, _reduxBatchedSubscribe.batchedSubscribe)(_reactDom.unstable_batchedUpdates));
	
	  if (false) {
	    // Enable Webpack hot module replacement for reducers
	    module.hot.accept('../', function () {
	      var nextRootReducer = require('../index').default;
	
	      store.replaceReducer(nextRootReducer);
	    });
	  }
	
	  return store;
	}
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(__PRODUCTION__, '__PRODUCTION__', 'D:/a/1/s/src/web/employee/src/store/configureStore.js');
	
	  __REACT_HOT_LOADER__.register(logger, 'logger', 'D:/a/1/s/src/web/employee/src/store/configureStore.js');
	
	  __REACT_HOT_LOADER__.register(insights, 'insights', 'D:/a/1/s/src/web/employee/src/store/configureStore.js');
	
	  __REACT_HOT_LOADER__.register(middlewares, 'middlewares', 'D:/a/1/s/src/web/employee/src/store/configureStore.js');
	
	  __REACT_HOT_LOADER__.register(createStoreWithMiddleware, 'createStoreWithMiddleware', 'D:/a/1/s/src/web/employee/src/store/configureStore.js');
	
	  __REACT_HOT_LOADER__.register(configureStore, 'configureStore', 'D:/a/1/s/src/web/employee/src/store/configureStore.js');
	}();

	;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  subheader: {
	    paddingLeft: 0,
	    fontSize: 20,
	    fontWeight: 300,
	    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	    cursor: 'pointer'
	  },
	  header: {
	    flex: 1,
	    fontSize: 20,
	    fontWeight: 500
	  },
	  root: {
	    padding: 16
	  },
	  info: {
	    paddingTop: 16,
	    display: 'flex',
	    flex: 1,
	    flexDirection: 'row',
	    alignItems: 'center',
	    justifyContent: 'space-between',
	    flexWrap: 'wrap'
	  },
	  infoItem: {
	    flexDirection: 'column',
	    flexWrap: 'wrap',
	    display: 'flex',
	    padding: 6,
	    minWidth: 260,
	    overflow: 'hidden'
	  },
	  infoMessage: {
	    flex: 1,
	    flexBasis: 24
	  },
	  label: {
	    flex: 1,
	    flexBasis: 24,
	    color: 'rgb(176, 176, 176)'
	  },
	  actions: {
	    display: 'flex',
	    justifyContent: 'flex-end'
	  },
	  action: {
	    marginLeft: 16
	  },
	  errorText: {
	    color: _colors2.default.errorColor
	  }
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/styles/Appraisal.js');
	}();

	;

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _default = {
	  subheader: {
	    fontSize: 20,
	    fontWeight: 300,
	    fontFamily: '"Helvetica Neue",Helvetica,Arial,sans-serif',
	    paddingLeft: 8,
	    paddingRight: 8
	  },
	  content: {
	    maxWidth: 1200,
	    marginTop: 32,
	    marginLeft: 'auto',
	    marginRight: 'auto'
	  },
	  loading: {
	    padding: 16,
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center'
	  },
	  wrap: {
	    flexWrap: 'wrap',
	    marginTop: 16
	  },
	  header: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    alignItems: 'center'
	  },
	  checkbox: {
	    width: 140
	  },
	  select: {
	    marginLeft: 12, marginRight: 8, marginTop: 0, width: 100
	  }
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/styles/EmployeeHoliday.js');
	}();

	;

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(175);
	
	var _colors2 = __webpack_require__(20);
	
	var _colors3 = _interopRequireDefault(_colors2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  infoList: {
	    display: 'flex',
	    flexDirection: 'column'
	  },
	  infoButton: {
	    padding: 0,
	    width: 24,
	    height: 24
	  },
	  root: {
	    width: '100%'
	  },
	  result: {
	    marginTop: 16,
	    padding: 0
	  },
	  message: {
	    textAlign: 'center',
	    padding: 24,
	    textTransform: 'uppercase',
	    fontWeight: 500,
	    color: _colors.grey500
	  },
	  errorMessage: {
	    textAlign: 'center',
	    padding: 24,
	    textTransform: 'uppercase',
	    fontWeight: 500,
	    color: _colors3.default.errorColor
	  },
	  avatar: {
	    objectFit: 'cover',
	    objectPosition: '50% 30%'
	  },
	  secondaryText: {
	    verticalAlign: 'bottom',
	    margin: 0,
	    color: 'inherit',
	    display: 'inline-block',
	    overflow: 'hidden',
	    textOverflow: 'ellipsis',
	    whiteSpace: 'nowrap'
	  }
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/styles/EmployeeSearch.js');
	}();

	;

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  action: {
	    flex: '1 1 0',
	    justifyContent: 'center',
	    minHeight: 40,
	    maxHeight: 40
	  },
	  actionButton: {
	    maxWidth: 'none',
	    fontSize: 14
	  },
	  time: {
	    display: 'flex',
	    justifyContent: 'space-between'
	  },
	  container: {
	    display: 'flex',
	    flexDirection: 'row',
	    flexWrap: 'wrap'
	  },
	  containerItem: {
	    flex: 1,
	    margin: 12,
	    minWidth: 350
	  },
	  title: {
	    margin: 0,
	    textAlign: 'center'
	  },
	  subtitle: {
	    display: 'block',
	    textAlign: 'center',
	    marginLeft: 0
	  },
	  valueContainer: {
	    display: 'flex',
	    flexDirection: 'row',
	    paddingTop: 32,
	    paddingBottom: 16
	  },
	  paper: {
	    padding: 16
	  },
	  chart: {
	    width: '70%',
	    height: 24,
	    borderRadius: 4,
	    overflow: 'hidden',
	    marginTop: 12,
	
	    marginLeft: 'auto',
	    marginRight: 'auto',
	    backgroundColor: '#eeeeee'
	  },
	  chartBar: {
	    height: '100%',
	    backgroundColor: _colors2.default.primary3Color
	  },
	  mainValueContainer: {
	    padding: 24,
	    paddingTop: 12
	  },
	  mainValue: {
	    fontSize: 24,
	    textAlign: 'center'
	  },
	  subtitleValue: {
	    fontSize: 14,
	    color: 'rgba(0, 0, 0, 0.54)',
	    textAlign: 'center',
	    marginTop: 12
	  }
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/styles/HolidayEntry.js');
	}();

	;

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(20);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = {
	  container: {
	    maxWidth: 380,
	    width: '100%',
	    minWidth: 300,
	    borderRadius: 8,
	    height: 460,
	    display: 'flex',
	    flexDirection: 'column',
	    flex: 1,
	    padding: 24,
	    paddingBottom: 24
	  },
	  action: {
	    minHeight: 40,
	    maxHeight: 40,
	    justifyContent: 'center',
	    marginLeft: 0,
	    marginRight: 0,
	    marginTop: 10
	  },
	  actionButton: {
	    fontSize: 14,
	    maxWidth: 'none',
	    paddingLeft: 0,
	    whiteSpace: 'nowrap',
	    color: _colors2.default.titleColor,
	    float: 'right'
	  },
	  divider: {},
	  times: {
	    marginTop: 'auto',
	    marginBottom: 18,
	    display: 'flex',
	    justifyContent: 'space-between',
	    float: 'right'
	  },
	  title: {
	    margin: 0,
	    fontSize: 20,
	    fontWeight: 600,
	    marginBottom: 12
	  },
	  description: {
	    color: _colors2.default.subtitleColor,
	    overflowX: 'hidden',
	    overflowY: 'auto'
	  },
	  amount: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    marginTop: 6,
	    fontSize: 14,
	    fontWeight: 600
	  },
	  fileInput: {
	    marginTop: 6,
	    minHeight: 28
	  },
	  validDate: {
	    fontSize: 14,
	    fontWeight: 600
	  },
	  amountInput: {}
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/styles/KBenefit.js');
	}();

	;

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _default = {
	  container: {
	    width: 'calc(100% - 72px)',
	    height: 'calc(100% - 46px)',
	    paddingLeft: 36,
	    paddingRight: 36,
	    paddingTop: 36,
	    paddingBottom: 10,
	    display: 'flex',
	    flexDirection: 'column'
	  },
	  action: {
	    flex: '1 1 0',
	    justifyContent: 'center',
	    minHeight: 40,
	    maxHeight: 40
	  },
	  actionButton: {
	    maxWidth: 'none',
	    fontSize: 14
	  },
	  head: {
	    display: 'flex',
	    flex: '0 0 auto'
	  },
	  title: {
	    fontSize: 20
	  },
	  list: {
	    display: 'flex',
	    flexDirection: 'column',
	    flex: '1 0 auto',
	    overflow: 'auto',
	    justifyContent: 'space-around'
	  },
	  listContainer: {
	    display: 'flex',
	    flexDirection: 'column',
	    flex: '1 0 auto',
	    overflow: 'auto',
	    justifyContent: 'space-around'
	  },
	  listSection: {
	    display: 'flex',
	    justifyContent: 'space-around'
	  }
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/styles/TProfile.js');
	}();

	;

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _styles = __webpack_require__(1836);
	
	var _styles2 = _interopRequireDefault(_styles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// media breakpoint - small screen min width
	var smallScreenMin = 768;
	
	// default className for NotificationsSystem component
	var notificationsSystemClassName = _styles2.default['notifications-system'];
	
	// default className for NotificationsContainer component
	var notificationsContainerClassName = {
	  main: _styles2.default['notifications-container'],
	  position: function position(_position) {
	    return _styles2.default['notifications-container--' + _position];
	  }
	};
	
	// default transition for Notification component
	var notificationsContainerTransition = {
	  appearTimeout: 500,
	  enterTimeout: 500,
	  leaveTimeout: 500,
	  name: {
	    appear: _styles2.default['notification-appear'],
	    appearActive: _styles2.default['notification-appear-active'],
	    enter: _styles2.default['notification-enter'],
	    enterActive: _styles2.default['notification-enter-active'],
	    leave: _styles2.default['notification-leave'],
	    leaveActive: _styles2.default['notification-leave-active']
	  }
	};
	
	// default className for Notification component
	var notificationClassName = {
	  wrapper: _styles2.default['notification-wrapper'],
	  main: _styles2.default.notification,
	  meta: _styles2.default['notification-meta'],
	  title: _styles2.default['notification-title'],
	  message: _styles2.default['notification-message'],
	  icon: 'material-icons ' + _styles2.default['notification-icon'],
	  imageContainer: _styles2.default['notification-image-container'],
	  image: _styles2.default['notification-image'],
	  status: function status(_status) {
	    return _styles2.default['notification--' + _status];
	  },
	  dismissible: _styles2.default['notification--dismissible'],
	  buttons: function buttons(count) {
	    if (count === 0) {
	      return '';
	    } else if (count === 1) {
	      return _styles2.default['notification--buttons-1'];
	    } else if (count === 2) {
	      return _styles2.default['notification--buttons-2'];
	    }
	    return _styles2.default['notification-buttons'];
	  },
	  closeButtonContainer: _styles2.default['notification-close-button-container'],
	  closeButton: 'material-icons ' + _styles2.default['notification-close-button'],
	  button: _styles2.default['notification-button'],
	  buttonText: _styles2.default['notification-button-text']
	};
	
	module.exports = {
	  smallScreenMin: smallScreenMin,
	  notificationsSystem: {
	    className: notificationsSystemClassName
	  },
	  notificationsContainer: {
	    className: notificationsContainerClassName,
	    transition: notificationsContainerTransition
	  },
	  notification: {
	    className: notificationClassName
	  }
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(smallScreenMin, 'smallScreenMin', 'D:/a/1/s/src/web/employee/src/themes/notifications/index.js');
	
	  __REACT_HOT_LOADER__.register(notificationsSystemClassName, 'notificationsSystemClassName', 'D:/a/1/s/src/web/employee/src/themes/notifications/index.js');
	
	  __REACT_HOT_LOADER__.register(notificationsContainerClassName, 'notificationsContainerClassName', 'D:/a/1/s/src/web/employee/src/themes/notifications/index.js');
	
	  __REACT_HOT_LOADER__.register(notificationsContainerTransition, 'notificationsContainerTransition', 'D:/a/1/s/src/web/employee/src/themes/notifications/index.js');
	
	  __REACT_HOT_LOADER__.register(notificationClassName, 'notificationClassName', 'D:/a/1/s/src/web/employee/src/themes/notifications/index.js');
	}();

	;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colorManipulator = __webpack_require__(90);
	
	var _spacing = __webpack_require__(621);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _colors = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var steelblue = '#3B53A7';
	var indianred = '#cd5c5c';
	var forestgreen = '#228B22';
	
	var _default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Open Sans, sans-serif',
	  palette: {
	    primary1Color: steelblue,
	    primary2Color: (0, _colorManipulator.darken)(steelblue, 0.15),
	    primary3Color: (0, _colorManipulator.lighten)(steelblue, 0.6),
	    accent1Color: indianred,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    alternateTextColor: _colors.white, // darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54), // darken(white, 0.05),
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    appBarColor: _colors.white,
	    footerColor: _colors.white, // lighten(darkBlack, 0.9),
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: steelblue,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack,
	    errorText: indianred,
	    successText: (0, _colorManipulator.lighten)(forestgreen, 0.1)
	  }
	};
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(steelblue, 'steelblue', 'D:/a/1/s/src/web/employee/src/themes/white.js');
	
	  __REACT_HOT_LOADER__.register(indianred, 'indianred', 'D:/a/1/s/src/web/employee/src/themes/white.js');
	
	  __REACT_HOT_LOADER__.register(forestgreen, 'forestgreen', 'D:/a/1/s/src/web/employee/src/themes/white.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/themes/white.js');
	}();

	;

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _default = {
	  101: 'Reykjavík',
	  102: 'Reykjavík',
	  103: 'Reykjavík',
	  104: 'Reykjavík',
	  105: 'Reykjavík',
	  107: 'Reykjavík',
	  108: 'Reykjavík',
	  109: 'Reykjavík',
	  110: 'Reykjavík',
	  111: 'Reykjavík',
	  112: 'Reykjavík',
	  113: 'Reykjavík',
	  116: 'Reykjavík',
	  121: 'Reykjavík',
	  123: 'Reykjavík',
	  124: 'Reykjavík',
	  125: 'Reykjavík',
	  127: 'Reykjavík',
	  128: 'Reykjavík',
	  129: 'Reykjavík',
	  130: 'Reykjavík',
	  132: 'Reykjavík',
	  150: 'Reykjavík',
	  155: 'Reykjavík',
	  161: 'Reykjavík',
	  162: 'Reykjavík',
	  170: 'Seltjarnarnesi',
	  172: 'Seltjarnarnesi',
	  190: 'Vogum',
	  191: 'Vogum',
	  200: 'Kópavogi',
	  201: 'Kópavogi',
	  202: 'Kópavogi',
	  203: 'Kópavogi',
	  206: 'Kópavogi',
	  210: 'Garðabæ',
	  212: 'Garðabæ',
	  220: 'Hafnarfirði',
	  221: 'Hafnarfirði',
	  222: 'Hafnarfirði',
	  225: 'Álftanesi',
	  230: 'Reykjanesbæ',
	  232: 'Reykjanesbæ',
	  233: 'Reykjanesbæ',
	  235: 'Reykjanesbæ',
	  240: 'Grindavík',
	  241: 'Grindavík',
	  245: 'Sandgerði',
	  246: 'Sandgerði',
	  250: 'Garði',
	  251: 'Garði',
	  260: 'Reykjanesbæ',
	  262: 'Reykjanesbæ',
	  270: 'Mosfellsbæ',
	  271: 'Mosfellsbæ',
	  276: 'Mosfellsbæ',
	  300: 'Akranesi',
	  301: 'Akranesi',
	  302: 'Akranesi',
	  310: 'Borgarnesi',
	  311: 'Borgarnesi',
	  320: 'Reykholt í Borgarfirði',
	  340: 'Stykkishólmi',
	  341: 'Stykkishólmi',
	  345: 'Flatey á Breiðafirði',
	  350: 'Grundarfirði',
	  351: 'Grundafirði',
	  355: 'Ólafsvík',
	  356: 'Snæfellsbæ',
	  360: 'Hellissandi',
	  370: 'Búðardal',
	  371: 'Búðardal',
	  380: 'Reykhólahreppi',
	  381: 'Reykhólahreppi',
	  400: 'Ísafirði',
	  401: 'Ísafirði',
	  410: 'Hnífsdal',
	  415: 'Bolungarvík',
	  416: 'Bolungarvík',
	  420: 'Súðavík',
	  421: 'Súðavík',
	  425: 'Flateyri',
	  426: 'Flateyri',
	  430: 'Suðureyri',
	  431: 'Suðureyri',
	  450: 'Patreksfirði',
	  451: 'Patreksfirði',
	  460: 'Tálknafirði',
	  461: 'Tálknafirði',
	  465: 'Bíldudal',
	  466: 'Bíldudal',
	  470: 'Þingeyri',
	  471: 'Þingeyri',
	  500: 'Stað',
	  510: 'Hólmavík',
	  511: 'Hólmavík',
	  512: 'Hólmavík',
	  520: 'Drangsnesi',
	  524: 'Árneshreppi',
	  530: 'Hvammstanga',
	  531: 'Hvammstanga',
	  540: 'Blönduósi',
	  541: 'Blönduósi',
	  545: 'Skagaströnd',
	  546: 'Skagaströnd',
	  550: 'Sauðárkróki',
	  551: 'Sauðárkróki',
	  560: 'Varmahlíð',
	  561: 'Varmahlíð',
	  565: 'Hofsós',
	  566: 'Hofsós',
	  570: 'Fljótum',
	  580: 'Siglufirði',
	  581: 'Siglufirði',
	  600: 'Akureyri',
	  601: 'Akureyri',
	  602: 'Akureyri',
	  603: 'Akureyri',
	  604: 'Akureyri',
	  605: 'Akureyri',
	  606: 'Akureyri',
	  607: 'Akureyri',
	  610: 'Grenivík',
	  611: 'Grímsey',
	  616: 'Grenivík',
	  620: 'Dalvík',
	  621: 'Dalvík',
	  625: 'Ólafsfirði',
	  626: 'Ólafsfirði',
	  630: 'Hrísey',
	  640: 'Húsavík',
	  641: 'Húsavík',
	  645: 'Fosshólli',
	  650: 'Laugum',
	  660: 'Mývatni',
	  670: 'Kópaskeri',
	  671: 'Kópaskeri',
	  675: 'Raufarhöfn',
	  676: 'Raufarhöfn',
	  680: 'Þórshöfn',
	  681: 'Þórshöfn',
	  685: 'Bakkafirði',
	  686: 'Bakkafirði',
	  690: 'Vopnafirði',
	  691: 'Vopnafirði',
	  700: 'Egilsstöðum',
	  701: 'Egilsstöðum',
	  710: 'Seyðisfirði',
	  711: 'Seyðisfirði',
	  715: 'Mjóafirði',
	  720: 'Borgarfirði (eystri)',
	  721: 'Borgarfirði (Eystri)',
	  730: 'Reyðarfirði',
	  731: 'Reyðarfirði',
	  735: 'Eskifirði',
	  736: 'Eskifirði',
	  740: 'Neskaupstað',
	  741: 'Neskaupsstað',
	  750: 'Fáskrúðsfirði',
	  751: 'Fáskrúðsfirði',
	  755: 'Stöðvarfirði',
	  760: 'Breiðdalsvík',
	  761: 'Breiðdalsvík',
	  765: 'Djúpavogi',
	  766: 'Djúpavogi',
	  780: 'Höfn í Hornafirði',
	  781: 'Höfn í Hornafirði',
	  785: 'Öræfum',
	  800: 'Selfossi',
	  801: 'Selfossi',
	  802: 'Selfossi',
	  803: 'Selfossi',
	  804: 'Selfossi',
	  805: 'Selfossi',
	  806: 'Selfossi',
	  810: 'Hveragerði',
	  815: 'Þorlákshöfn',
	  816: 'Ölfusi',
	  820: 'Eyrarbakka',
	  825: 'Stokkseyri',
	  840: 'Laugarvatni',
	  845: 'Flúðum',
	  846: 'Flúðum',
	  850: 'Hellu',
	  851: 'Hellu',
	  860: 'Hvolsvelli',
	  861: 'Hvolsvelli',
	  870: 'Vík',
	  871: 'Vík',
	  880: 'Kirkjubæjarklaustri',
	  881: 'Kirkjubæjarklaustri',
	  900: 'Vestmannaeyjum',
	  902: 'Vestmannaeyjum',
	  999: 'Erlendis'
	};
	exports.default = _default;
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }

	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/utils/PostCodes.js');
	}();

	;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.exportToMultipleSheetsExcel = exports.exportToExcel = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _xlsx = __webpack_require__(1848);
	
	var _xlsx2 = _interopRequireDefault(_xlsx);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _fileSaver = __webpack_require__(516);
	
	var _lodash = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createSheet = function createSheet(data, columns) {
	  var dataToExport = [];
	  if (data && data.length !== 0) {
	    dataToExport = data.map(function (item) {
	      var excelItem = {};
	      columns.map(function (column) {
	        if (column.format && column.format === 'datetime') {
	          excelItem[column.title || column.key] = (0, _moment2.default)((0, _lodash.get)(item, column.key)).format('DD.MM.YYYY HH:mm');
	        } else if (column.format && column.format === 'date') {
	          excelItem[column.title || column.key] = (0, _moment2.default)((0, _lodash.get)(item, column.key)).format('DD.MM.YYYY');
	        } else {
	          excelItem[column.title || column.key] = (0, _lodash.get)(item, column.key);
	        }
	        return null;
	      });
	      return excelItem;
	    });
	  }
	  var headerNames = columns.map(function (column) {
	    return column.title || column.key;
	  });
	  return _xlsx2.default.utils.json_to_sheet(dataToExport, { header: headerNames });
	};
	
	function s2ab(s) {
	  var buf = new ArrayBuffer(s.length);
	  var view = new Uint8Array(buf);
	  for (var i = 0; i !== s.length; i += 1) {
	    // eslint-disable-next-line
	    view[i] = s.charCodeAt(i) & 0xff;
	  }
	  return buf;
	}
	
	var wopts = {
	  bookType: 'xlsx',
	  bookSST: false,
	  type: 'binary'
	};
	
	/*
	 * A method to export an array of objects to an excel spreadsheet
	 * documentName (Mandatory): The name of the exported document
	 * data (Optional): an array of objects, if data is empty only the headers will be exported
	 * columns: a sorted array of objects with the following properties:
	 *  - key (or dataIndex): Mandatory, says which key in the data should fit in each column
	 *  - title: Optional, this will be the title of the column,
	 *            if no title is declared the key will be the header value.
	 *  - format: Optional, defaults to number / string, formats a date string if format: 'date' is set.
	 * example:
	 *  input:
	 *    - documentName: 'test.xlsx'
	 *    - data: [
	 *        { foo: 'a', bar: 'b', baz: '31.12.2019' },
	 *        { foo: 'aa', bar: 'bb', baz: '31.11.2019' },
	 *      ]
	 *    - columns: [
	 *        { key: 'foo', title: 'column1' }
	 *        { key: 'bar', title: 'column2' }
	 *        { key: 'baz', title: 'column3', format: 'date' }
	 *      ]
	 *  output: an excel sheet with the name test.xlsx and the following rows / columns:
	 *    | column1 | column2 | column3         |
	 *    |---------|---------|-----------------|
	 *    | a       | b       | 31.12.2019 00:01|
	 *    |---------|---------|-----------------|
	 *    | aa      | bb      | 31.11.2019 00:01|
	 */
	var exportToExcel = exports.exportToExcel = function exportToExcel(documentName, data, columns) {
	  var wb = _xlsx2.default.utils.book_new();
	  var mapped = (0, _lodash.map)(columns, function (col) {
	    return _extends({}, col, { key: col.key || col.dataIndex });
	  }); // add key
	  var filtered = (0, _lodash.filter)(mapped, function (col) {
	    return col.dataIndex !== 'operations';
	  }); // remove operations
	  var ws = createSheet(data, filtered);
	  wb.SheetNames.push(documentName.slice(0, 31)); // sheet names cannot exceed 31 characters
	  wb.Sheets[documentName.slice(0, 31)] = ws;
	  var wbout = _xlsx2.default.write(wb, wopts);
	  return (0, _fileSaver.saveAs)(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), documentName + '.xlsx');
	};
	
	/*
	 * Export a document with multiple sheets to excel format.
	 * documentName (Mandatory): the name of the exported document
	 * sheets (Mandatory): an array of objects with the following properties:
	 *  - sheetName (Mandatory): the name of the sheet,
	 *  - data (Optional): an array of objects, if data is empty only the headers will be exported
	 *  - columns (Mandatory): a sorted array of objects with the following properties:
	 *    - key (Mandatory): says which key in the data should fit in each column
	 *    - title (Optional): the title of the column,
	 *        if no header is declared the key will be the header value.
	 *    - format (Optional): defaults to number / string,
	 *        formats a date string if format: 'date' is set
	 */
	
	var exportToMultipleSheetsExcel = exports.exportToMultipleSheetsExcel = function exportToMultipleSheetsExcel(documentName, sheets) {
	  var wb = _xlsx2.default.utils.book_new();
	  (0, _lodash.forEach)(sheets, function (sheet) {
	    wb.SheetNames.push(sheet.sheetName.slice(0, 31)); // sheet names cannot exceed 31 characters
	    wb.Sheets[sheet.sheetName.slice(0, 31)] = createSheet(sheet.data, sheet.columns);
	  });
	  var wbout = _xlsx2.default.write(wb, wopts);
	  return (0, _fileSaver.saveAs)(new Blob([s2ab(wbout)], { type: 'application/octet-stream' }), documentName + '.xlsx');
	};
	
	var _default = { exportToExcel: exportToExcel, exportToMultipleSheetsExcel: exportToMultipleSheetsExcel };
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(createSheet, 'createSheet', 'D:/a/1/s/src/web/employee/src/utils/exportHelpers.js');
	
	  __REACT_HOT_LOADER__.register(s2ab, 's2ab', 'D:/a/1/s/src/web/employee/src/utils/exportHelpers.js');
	
	  __REACT_HOT_LOADER__.register(wopts, 'wopts', 'D:/a/1/s/src/web/employee/src/utils/exportHelpers.js');
	
	  __REACT_HOT_LOADER__.register(exportToExcel, 'exportToExcel', 'D:/a/1/s/src/web/employee/src/utils/exportHelpers.js');
	
	  __REACT_HOT_LOADER__.register(exportToMultipleSheetsExcel, 'exportToMultipleSheetsExcel', 'D:/a/1/s/src/web/employee/src/utils/exportHelpers.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/utils/exportHelpers.js');
	}();

	;

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	    Polyfills and haks for IE.
	*/
	/*eslint-disable */
	if (typeof Object.assign != 'function') {
	  Object.assign = function (target) {
	    'use strict';
	
	    if (target == null) {
	      throw new TypeError('Cannot convert undefined or null to object');
	    }
	
	    target = Object(target);
	    for (var index = 1; index < arguments.length; index++) {
	      var source = arguments[index];
	      if (source != null) {
	        for (var key in source) {
	          if (Object.prototype.hasOwnProperty.call(source, key)) {
	            target[key] = source[key];
	          }
	        }
	      }
	    }
	    return target;
	  };
	}
	
	/*
	if (!window.Intl) {
	  require.ensure(['intl'], (require) => {
	    window.Intl = require('intl')
	  }, "IntlBundle");
	}
	*/
	
	Number.isInteger = Number.isInteger || function (value) {
	  return typeof value === "number" && isFinite(value) && Math.floor(value) === value;
	};
	/* eslint-enable */
	
	;

	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	}();

	;

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Api = __webpack_require__(21);
	
	var linkField = function linkField(_ref) {
	  var token = _ref.token,
	      entity = _ref.entity,
	      entityID = _ref.entityID,
	      value = _ref.value;
	  return (0, _Api.read)({
	    entity: entity,
	    entityID: entityID,
	    headers: { Authorization: 'Bearer ' + token }
	  }).then(function (e) {
	    return e.data[value];
	  });
	};
	
	var _default = linkField;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(linkField, 'linkField', 'D:/a/1/s/src/web/employee/src/utils/linkField.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/utils/linkField.js');
	}();

	;

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateCompanyCursorTemplate = exports.generateCompanyHighlightTemplate = exports.generateHighlightTemplate = exports.generateCompanyTemplate = exports.generateEmployeeTemplate = undefined;
	
	var _jquery = __webpack_require__(198);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	__webpack_require__(528);
	
	__webpack_require__(436);
	
	__webpack_require__(812);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// source: https://www.basicprimitives.com/index.php?option=com_content&view=article&id=11&Itemid=10&lang=en
	var generateEmployeeTemplate = exports.generateEmployeeTemplate = function generateEmployeeTemplate(template) {
	  var elementString = '<div class="bp-item bp-corner-all bt-item-frame ' + template.name + 'Container">\n      <div name="title" class=" bp-item bp-title ' + template.name + 'Title"  style="top: 10px; left: 10px; width: 190px; height: 18px; font-size: 16px" />\n      <div class="imageContainer bp-item bp-photo-frame">\n        <div class="material-icons bp-item" style="height: 70px; width: 56px; color: rgba(0, 0, 0, 0.541176); font-size: 64px;">person</div>\n      </div>\n      <div class="bp-item material-icons employeeIcon" style="top: 32px;">phone</div>\n      <div name="phone" class="bp-item employeeInfo" style="top: 32px; height: 18px;" />\n      <div class="bp-item material-icons employeeIcon" style="top: 52px;">mail</div>\n      <div name="email" class="bp-item employeeInfo" style="top: 52px; height: 18px;"/>\n      <div class="bp-item material-icons employeeIcon" style="top: 72px;">description</div>\n      <div name="description" class="bp-item employeeInfo" style="top: 72px; height: 30px; word-wrap: break-word;" />\n    </div>';
	  var itemTemplate = (0, _jquery2.default)(elementString).css({
	    width: template.itemSize.width + "px",
	    height: template.itemSize.height + "px"
	  }).addClass("bp-item bp-corner-all bt-item-frame");
	  return itemTemplate.wrap('<div>').parent().html();
	};
	
	var generateCompanyTemplate = exports.generateCompanyTemplate = function generateCompanyTemplate(template, iconName) {
	  var elementString = '<div class="bp-item bp-corner-all bt-item-frame ' + template.name + 'Container">\n      <div name="title" class="bp-item bp-title ' + template.name + 'Title"  style="top: 10px; left: 10px; width: 135px; height: 18px; font-size: 16px" />\n      <div class="imageContainer bp-item bp-photo-frame">\n        <div class="material-icons bp-item" style="height: 41px; width: 41px; color: rgba(0, 0, 0, 0.541176); font-size: 40px;">' + iconName + '</div>\n      </div>\n    </div>';
	  var itemTemplate = (0, _jquery2.default)(elementString).css({
	    width: template.itemSize.width + "px",
	    height: template.itemSize.height + "px"
	  }).addClass("bp-item bp-corner-all bt-item-frame-2");
	  return itemTemplate.wrap('<div>').parent().html();
	};
	
	var generateHighlightTemplate = exports.generateHighlightTemplate = function generateHighlightTemplate(template) {
	  return (0, _jquery2.default)('<div></div>').css({
	    position: 'absolute',
	    overflow: 'visible',
	    width: template.itemSize.width + template.highlightPadding.left + template.highlightPadding.right + "px",
	    height: template.itemSize.height + template.highlightPadding.top + template.highlightPadding.bottom + "px",
	    'box-shadow': 'rgba(0, 0, 0, 0.3) 0px 3px 10px',
	    "border-width": "0px",
	    'font-color': 'white'
	  }).addClass('bp-item2 bp-corner-all').wrap('<div>').parent().html();
	};
	
	var generateCompanyHighlightTemplate = exports.generateCompanyHighlightTemplate = function generateCompanyHighlightTemplate(template) {
	  return (0, _jquery2.default)('<div></div>').css({
	    position: 'absolute',
	    overflow: 'visible',
	    width: template.itemSize.width + template.highlightPadding.left + template.highlightPadding.right + "px",
	    height: template.itemSize.height + template.highlightPadding.top + template.highlightPadding.bottom + "px",
	    'box-shadow': 'rgba(0, 0, 0, 0.0) 0px 3px 10px',
	    "border-width": "0px"
	  }).addClass('bt-item-frame').wrap('<div>').parent().html();
	};
	var generateCompanyCursorTemplate = exports.generateCompanyCursorTemplate = function generateCompanyCursorTemplate(template) {
	  return (0, _jquery2.default)('<div></div>').css({
	    position: 'absolute',
	    overflow: 'visible',
	    width: template.itemSize.width + template.highlightPadding.left + template.highlightPadding.right + "px",
	    height: template.itemSize.height + template.highlightPadding.top + template.highlightPadding.bottom + "px",
	    'box-shadow': 'rgba(0, 0, 0, 0.0) 0px 3px 10px',
	    "border-width": "0px"
	  }).addClass('').wrap('<div>').parent().html();
	};
	var _default = generateEmployeeTemplate;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(generateEmployeeTemplate, 'generateEmployeeTemplate', 'D:/a/1/s/src/web/employee/src/utils/orgChart.js');
	
	  __REACT_HOT_LOADER__.register(generateCompanyTemplate, 'generateCompanyTemplate', 'D:/a/1/s/src/web/employee/src/utils/orgChart.js');
	
	  __REACT_HOT_LOADER__.register(generateHighlightTemplate, 'generateHighlightTemplate', 'D:/a/1/s/src/web/employee/src/utils/orgChart.js');
	
	  __REACT_HOT_LOADER__.register(generateCompanyHighlightTemplate, 'generateCompanyHighlightTemplate', 'D:/a/1/s/src/web/employee/src/utils/orgChart.js');
	
	  __REACT_HOT_LOADER__.register(generateCompanyCursorTemplate, 'generateCompanyCursorTemplate', 'D:/a/1/s/src/web/employee/src/utils/orgChart.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/utils/orgChart.js');
	}();

	;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _uniqBy = __webpack_require__(582);
	
	var _uniqBy2 = _interopRequireDefault(_uniqBy);
	
	var _xSelect = __webpack_require__(188);
	
	var _Api = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mapOptions(obj, _ref) {
	  var label = _ref.label,
	      value = _ref.value;
	
	  return {
	    label: obj[label] || '-',
	    value: obj[value]
	  };
	}
	
	/**
	  Function that fetches optins for a select field from QData.
	  Where prop `field` in the entity equals `fieldValue`,
	*/
	function selectOptions(_ref2) {
	  var entity = _ref2.entity,
	      label = _ref2.label,
	      value = _ref2.value,
	      token = _ref2.token,
	      field = _ref2.field,
	      fieldValue = _ref2.fieldValue,
	      orderByValue = _ref2.orderByValue;
	
	
	  var config = {
	    entity: entity,
	    headers: { Authorization: 'Bearer ' + token },
	    data: fieldValue !== undefined ? (0, _xSelect.xSelectSingle)([{ field: field, value: fieldValue, relation: 'eq' }]) : ''
	  };
	
	  return (0, _Api.list)(config).then(function (entityList) {
	    return (0, _uniqBy2.default)(entityList.data.map(function (e) {
	      return mapOptions(e, { label: label, value: value });
	    }).sort(function (a, b) {
	      if (orderByValue) {
	        return a.value > b.value;
	      }
	      return a.label.toString().localeCompare(b.label.toString());
	    }), 'value');
	  });
	}
	
	var _default = selectOptions;
	exports.default = _default;
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(mapOptions, 'mapOptions', 'D:/a/1/s/src/web/employee/src/utils/selectOptions.js');
	
	  __REACT_HOT_LOADER__.register(selectOptions, 'selectOptions', 'D:/a/1/s/src/web/employee/src/utils/selectOptions.js');
	
	  __REACT_HOT_LOADER__.register(_default, 'default', 'D:/a/1/s/src/web/employee/src/utils/selectOptions.js');
	}();

	;

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var getEmployeeStatus = exports.getEmployeeStatus = function getEmployeeStatus(status) {
	  switch (status) {
	    case 1:
	      return 'Retired';
	    case 2:
	      return 'Severance';
	    case 3:
	      return 'Withdrawn';
	    case 4:
	      return 'Parental Leave';
	    case 5:
	      return 'Leave';
	    case 6:
	      return 'Active';
	    case 7:
	      return 'Sick Leave';
	    case 8:
	      return 'Budget';
	    case 9:
	      return 'Study Leave';
	    default:
	      return 'None';
	  }
	};
	
	var getEmployeeGroup = exports.getEmployeeGroup = function getEmployeeGroup(group) {
	  switch (group) {
	    case 1:
	      return 'Permanent';
	    case 2:
	      return 'Student';
	    case 3:
	      return 'Probation';
	    case 4:
	      return 'Summer Job';
	    case 5:
	      return 'Fixed Term';
	    case 6:
	      return 'External';
	    case 7:
	      return 'Hourly';
	    case 8:
	      return 'Work Contract';
	    case 9:
	      return 'Board Member';
	    case 10:
	      return 'Replacement';
	    case 11:
	      return 'Committees';
	    default:
	      return 'None';
	  }
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(getEmployeeStatus, 'getEmployeeStatus', 'D:/a/1/s/src/web/employee/src/utils/translations.js');
	
	  __REACT_HOT_LOADER__.register(getEmployeeGroup, 'getEmployeeGroup', 'D:/a/1/s/src/web/employee/src/utils/translations.js');
	}();

	;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var codes = __webpack_require__(1373);
	var removeDiacritics = __webpack_require__(1309).remove;
	var registeredLocales = {};
	
	/*
	 * All codes map to ISO 3166-1 alpha-2
	 */
	var alpha2 = {},
	    alpha3 = {},
	    numeric = {},
	    invertedNumeric = {};
	
	codes.forEach(function (codeInformation) {
	  var s = codeInformation;
	  alpha2[s[0]] = s[1];
	  alpha3[s[1]] = s[0];
	  numeric[s[2]] = s[0];
	  invertedNumeric[s[0]] = s[2];
	});
	
	/**
	 * @private
	 * @param {number} code
	 */
	function formatNumericCode(code) {
	  return String("000" + (code ? code : "")).slice(-3);
	}
	
	/**
	 * @private
	 * Avoid using obj.hasOwnProperty directly as `hasOwnProperty` could be a
	 * property in itself ({ hasOwnProperty: 1 }) and cause weird bugs
	 * https://eslint.org/docs/rules/no-prototype-builtins
	 */
	function hasOwnProperty(object, property) {
	  return Object.prototype.hasOwnProperty.call(object, property);
	}
	
	/**
	 * @private
	 * Pass localeList through a filter and return a newLocaleList obj
	 * with the same structure of the old localeList.
	 *
	 * @param {LocalizedCountryNames} localeList  Local List in raw
	 * @param {Function} filter    callback to set filter rule
	 * @return {String | String[]} new filtered Local List
	 */
	function localeFilter(localeList, filter) {
	  return Object.keys(localeList).reduce(function (newLocaleList, alpha2) {
	    var nameList = localeList[alpha2];
	    newLocaleList[alpha2] = filter(nameList, alpha2);
	    return newLocaleList;
	  }, {});
	}
	
	/**
	 * @private
	 * Preserve for getName & getNames
	 *
	 * @param {GetNameOptions.select} type all | official | alias
	 * @param countryNameList  string array of country's
	 *                         official name and alias
	 * @return {String | String[]} of a country name
	 */
	function filterNameBy(type, countryNameList) {
	  switch (type) {
	    case "official":
	      return Array.isArray(countryNameList) ? countryNameList[0] : countryNameList;
	
	    case "all":
	      return typeof countryNameList === "string" ? [countryNameList] : countryNameList;
	
	    case "alias":
	      return Array.isArray(countryNameList) ? countryNameList[1] || countryNameList[0] : countryNameList;
	
	    default:
	      throw new TypeError("LocaleNameType must be one of these: all, official, alias!");
	  }
	}
	
	/**
	 * Register countries in browsers' environment:
	 * @param {object} localeData
	 * @example countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
	 * @return void
	 */
	exports.registerLocale = function (localeData) {
	  if (!localeData.locale) {
	    throw new TypeError("Missing localeData.locale");
	  }
	
	  if (!localeData.countries) {
	    throw new TypeError("Missing localeData.countries");
	  }
	
	  registeredLocales[localeData.locale] = localeData.countries;
	};
	
	/*
	 * @param code Alpha-3 code
	 * @return Alpha-2 code or undefined
	 */
	function alpha3ToAlpha2(code) {
	  return alpha3[code];
	}
	exports.alpha3ToAlpha2 = alpha3ToAlpha2;
	
	/*
	 * @param code Alpha-2 code
	 * @return Alpha-3 code or undefined
	 */
	function alpha2ToAlpha3(code) {
	  return alpha2[code];
	}
	exports.alpha2ToAlpha3 = alpha2ToAlpha3;
	
	/*
	 * @param code Alpha-3 code
	 * @return Numeric code or undefined
	 */
	function alpha3ToNumeric(code) {
	  return invertedNumeric[alpha3ToAlpha2(code)];
	}
	exports.alpha3ToNumeric = alpha3ToNumeric;
	
	/*
	 * @param code Alpha-2 code
	 * @return Numeric code or undefined
	 */
	function alpha2ToNumeric(code) {
	  return invertedNumeric[code];
	}
	exports.alpha2ToNumeric = alpha2ToNumeric;
	
	/*
	 * @param code Numeric code
	 * @return Alpha-3 code or undefined
	 */
	function numericToAlpha3(code) {
	  var padded = formatNumericCode(code);
	  return alpha2ToAlpha3(numeric[padded]);
	}
	exports.numericToAlpha3 = numericToAlpha3;
	
	/*
	 * @param code Numeric code
	 * @return Alpha-2 code or undefined
	 */
	function numericToAlpha2(code) {
	  var padded = formatNumericCode(code);
	  return numeric[padded];
	}
	exports.numericToAlpha2 = numericToAlpha2;
	
	/*
	 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
	 * @return ISO 3166-1 alpha-3
	 */
	function toAlpha3(code) {
	  if (typeof code === "string") {
	    if (/^[0-9]*$/.test(code)) {
	      return numericToAlpha3(code);
	    }
	    if (code.length === 2) {
	      return alpha2ToAlpha3(code.toUpperCase());
	    }
	    if (code.length === 3) {
	      return code.toUpperCase();
	    }
	  }
	  if (typeof code === "number") {
	    return numericToAlpha3(code);
	  }
	  return undefined;
	}
	exports.toAlpha3 = toAlpha3;
	
	/*
	 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
	 * @return ISO 3166-1 alpha-2
	 */
	function toAlpha2(code) {
	  if (typeof code === "string") {
	    if (/^[0-9]*$/.test(code)) {
	      return numericToAlpha2(code);
	    }
	    if (code.length === 2) {
	      return code.toUpperCase();
	    }
	    if (code.length === 3) {
	      return alpha3ToAlpha2(code.toUpperCase());
	    }
	  }
	  if (typeof code === "number") {
	    return numericToAlpha2(code);
	  }
	  return undefined;
	}
	exports.toAlpha2 = toAlpha2;
	
	/**
	 * @param {string | number | Alpha2Code | Alpha3Code} code
	 * @param {String} lang          language for country name
	 * @param {GetNameOptions} options
	 * @return {String | String[] | undefined}  name
	 */
	exports.getName = function (code, lang) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  if (!("select" in options)) {
	    options.select = "official";
	  }
	  try {
	    var codeMaps = registeredLocales[lang.toLowerCase()];
	    var nameList = codeMaps[toAlpha2(code)];
	    return filterNameBy(options.select, nameList);
	  } catch (err) {
	    return undefined;
	  }
	};
	
	/**
	 * @param {String} lang             language for country names
	 * @param {GetNameOptions} options   getNames Options
	 * @return {LocalizedCountryNames}  country code
	 *                                  mapped to county name
	 */
	exports.getNames = function (lang) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (!("select" in options)) {
	    options.select = "official";
	  }
	  var localeList = registeredLocales[lang.toLowerCase()];
	  if (localeList === undefined) return {};
	  return localeFilter(localeList, function (nameList) {
	    return filterNameBy(options.select, nameList);
	  });
	};
	
	/*
	 * @param name name
	 * @param lang language for country name
	 * @return ISO 3166-1 alpha-2 or undefined
	 */
	exports.getAlpha2Code = function (name, lang) {
	  var normalizeString = function normalizeString(string) {
	    return string.toLowerCase();
	  };
	  var areSimilar = function areSimilar(a, b) {
	    return normalizeString(a) === normalizeString(b);
	  };
	
	  try {
	    var codenames = registeredLocales[lang.toLowerCase()];
	    for (var p in codenames) {
	      if (!hasOwnProperty(codenames, p)) {
	        continue;
	      }
	      if (typeof codenames[p] === "string") {
	        if (areSimilar(codenames[p], name)) {
	          return p;
	        }
	      }
	      if (Array.isArray(codenames[p])) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = codenames[p][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var mappedName = _step.value;
	
	            if (areSimilar(mappedName, name)) {
	              return p;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	    }
	    return undefined;
	  } catch (err) {
	    return undefined;
	  }
	};
	
	/*
	 * @param name name
	 * @param lang language for country name
	 * @return ISO 3166-1 alpha-2 or undefined
	 */
	exports.getSimpleAlpha2Code = function (name, lang) {
	  var normalizeString = function normalizeString(string) {
	    return removeDiacritics(string.toLowerCase());
	  };
	  var areSimilar = function areSimilar(a, b) {
	    return normalizeString(a) === normalizeString(b);
	  };
	
	  try {
	    var codenames = registeredLocales[lang.toLowerCase()];
	    for (var p in codenames) {
	      if (!hasOwnProperty(codenames, p)) {
	        continue;
	      }
	      if (typeof codenames[p] === "string") {
	        if (areSimilar(codenames[p], name)) {
	          return p;
	        }
	      }
	      if (Array.isArray(codenames[p])) {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = codenames[p][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var mappedName = _step2.value;
	
	            if (areSimilar(mappedName, name)) {
	              return p;
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      }
	    }
	    return undefined;
	  } catch (err) {
	    return undefined;
	  }
	};
	
	/*
	 * @return Object of alpha-2 codes mapped to alpha-3 codes
	 */
	exports.getAlpha2Codes = function () {
	  return alpha2;
	};
	
	/*
	 * @param name name
	 * @param lang language for country name
	 * @return ISO 3166-1 alpha-3 or undefined
	 */
	exports.getAlpha3Code = function (name, lang) {
	  var alpha2 = this.getAlpha2Code(name, lang);
	  if (alpha2) {
	    return this.toAlpha3(alpha2);
	  } else {
	    return undefined;
	  }
	};
	
	/*
	 * @param name name
	 * @param lang language for country name
	 * @return ISO 3166-1 alpha-3 or undefined
	 */
	exports.getSimpleAlpha3Code = function (name, lang) {
	  var alpha2 = this.getSimpleAlpha2Code(name, lang);
	  if (alpha2) {
	    return this.toAlpha3(alpha2);
	  } else {
	    return undefined;
	  }
	};
	
	/*
	 * @return Object of alpha-3 codes mapped to alpha-2 codes
	 */
	exports.getAlpha3Codes = function () {
	  return alpha3;
	};
	
	/*
	 * @return Object of numeric codes mapped to alpha-2 codes
	 */
	exports.getNumericCodes = function () {
	  return numeric;
	};
	
	/*
	 * @return Array of supported languages
	 */
	exports.langs = function () {
	  return Object.keys(registeredLocales);
	};
	
	/*
	 * @param code ISO 3166-1 alpha-2, alpha-3 or numeric code
	 * @return Boolean
	 */
	exports.isValid = function (code) {
	  if (!code) {
	    return false;
	  }
	
	  var coerced = code.toString().toUpperCase();
	  return hasOwnProperty(alpha3, coerced) || hasOwnProperty(alpha2, coerced) || hasOwnProperty(numeric, coerced);
	};
	;
	
	var _temp = function () {
	  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
	    return;
	  }
	
	  __REACT_HOT_LOADER__.register(removeDiacritics, "removeDiacritics", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(registeredLocales, "registeredLocales", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(alpha2, "alpha2", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(alpha3, "alpha3", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(numeric, "numeric", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(invertedNumeric, "invertedNumeric", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(formatNumericCode, "formatNumericCode", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(hasOwnProperty, "hasOwnProperty", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(localeFilter, "localeFilter", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(filterNameBy, "filterNameBy", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(alpha3ToAlpha2, "alpha3ToAlpha2", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(alpha2ToAlpha3, "alpha2ToAlpha3", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(alpha3ToNumeric, "alpha3ToNumeric", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(alpha2ToNumeric, "alpha2ToNumeric", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(numericToAlpha3, "numericToAlpha3", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(numericToAlpha2, "numericToAlpha2", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(toAlpha3, "toAlpha3", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	
	  __REACT_HOT_LOADER__.register(toAlpha2, "toAlpha2", "D:/a/1/s/src/web/employee/node_modules/i18n-iso-countries/index.js");
	}();

	;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Promise) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(19)))

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1055), __esModule: true };

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1056), __esModule: true };

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1057), __esModule: true };

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1058), __esModule: true };

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1062), __esModule: true };

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1063), __esModule: true };

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1064), __esModule: true };

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(813)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)(o|0)s/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr\/|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/Whale/i.test(ua)) {
	      result = {
	        name: 'NAVER Whale browser'
	        , whale: t
	        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/MZBrowser/i.test(ua)) {
	      result = {
	        name: 'MZ Browser'
	        , mzbrowser: t
	        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/focus/i.test(ua)) {
	      result = {
	        name: 'Focus'
	        , focus: t
	        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , osname: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , osname: 'Chrome OS'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/edg([ea]|ios)/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , osname: 'Sailfish OS'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	        result.osname = 'Firefox OS'
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , osname: 'BlackBerry OS'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , osname: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , osname: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , osname: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && (android || result.silk)) {
	      result.android = t
	      result.osname = 'Android'
	    } else if (!result.windowsphone && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	      result.osname = 'iOS'
	    } else if (mac) {
	      result.mac = t
	      result.osname = 'macOS'
	    } else if (xbox) {
	      result.xbox = t
	      result.osname = 'Xbox'
	    } else if (windows) {
	      result.windows = t
	      result.osname = 'Windows'
	    } else if (linux) {
	      result.linux = t
	      result.osname = 'Linux'
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
	        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
	        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  /*
	   * Set our detect public method to the main bowser object
	   * This is needed to implement bowser in server side
	   */
	  bowser.detect = detect;
	  return bowser
	});


/***/ }),
/* 1049 */
/***/ (function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ }),
/* 1050 */
/***/ (function(module, exports) {

	/*
	 * classList.js: Cross-browser full element.classList implementation.
	 * 1.1.20170427
	 *
	 * By Eli Grey, http://eligrey.com
	 * License: Dedicated to the public domain.
	 *   See https://github.com/eligrey/classList.js/blob/master/LICENSE.md
	 */
	
	/*global self, document, DOMException */
	
	/*! @source http://purl.eligrey.com/github/classList.js/blob/master/classList.js */
	
	if ("document" in window.self) {
	
	// Full polyfill for browsers with no classList support
	// Including IE < Edge missing SVGElement.classList
	if (!("classList" in document.createElement("_")) 
		|| document.createElementNS && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))) {
	
	(function (view) {
	
	"use strict";
	
	if (!('Element' in view)) return;
	
	var
		  classListProp = "classList"
		, protoProp = "prototype"
		, elemCtrProto = view.Element[protoProp]
		, objCtr = Object
		, strTrim = String[protoProp].trim || function () {
			return this.replace(/^\s+|\s+$/g, "");
		}
		, arrIndexOf = Array[protoProp].indexOf || function (item) {
			var
				  i = 0
				, len = this.length
			;
			for (; i < len; i++) {
				if (i in this && this[i] === item) {
					return i;
				}
			}
			return -1;
		}
		// Vendors: please allow content code to instantiate DOMExceptions
		, DOMEx = function (type, message) {
			this.name = type;
			this.code = DOMException[type];
			this.message = message;
		}
		, checkTokenAndGetIndex = function (classList, token) {
			if (token === "") {
				throw new DOMEx(
					  "SYNTAX_ERR"
					, "An invalid or illegal string was specified"
				);
			}
			if (/\s/.test(token)) {
				throw new DOMEx(
					  "INVALID_CHARACTER_ERR"
					, "String contains an invalid character"
				);
			}
			return arrIndexOf.call(classList, token);
		}
		, ClassList = function (elem) {
			var
				  trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
				, classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
				, i = 0
				, len = classes.length
			;
			for (; i < len; i++) {
				this.push(classes[i]);
			}
			this._updateClassName = function () {
				elem.setAttribute("class", this.toString());
			};
		}
		, classListProto = ClassList[protoProp] = []
		, classListGetter = function () {
			return new ClassList(this);
		}
	;
	// Most DOMException implementations don't allow calling DOMException's toString()
	// on non-DOMExceptions. Error's toString() is sufficient here.
	DOMEx[protoProp] = Error[protoProp];
	classListProto.item = function (i) {
		return this[i] || null;
	};
	classListProto.contains = function (token) {
		token += "";
		return checkTokenAndGetIndex(this, token) !== -1;
	};
	classListProto.add = function () {
		var
			  tokens = arguments
			, i = 0
			, l = tokens.length
			, token
			, updated = false
		;
		do {
			token = tokens[i] + "";
			if (checkTokenAndGetIndex(this, token) === -1) {
				this.push(token);
				updated = true;
			}
		}
		while (++i < l);
	
		if (updated) {
			this._updateClassName();
		}
	};
	classListProto.remove = function () {
		var
			  tokens = arguments
			, i = 0
			, l = tokens.length
			, token
			, updated = false
			, index
		;
		do {
			token = tokens[i] + "";
			index = checkTokenAndGetIndex(this, token);
			while (index !== -1) {
				this.splice(index, 1);
				updated = true;
				index = checkTokenAndGetIndex(this, token);
			}
		}
		while (++i < l);
	
		if (updated) {
			this._updateClassName();
		}
	};
	classListProto.toggle = function (token, force) {
		token += "";
	
		var
			  result = this.contains(token)
			, method = result ?
				force !== true && "remove"
			:
				force !== false && "add"
		;
	
		if (method) {
			this[method](token);
		}
	
		if (force === true || force === false) {
			return force;
		} else {
			return !result;
		}
	};
	classListProto.toString = function () {
		return this.join(" ");
	};
	
	if (objCtr.defineProperty) {
		var classListPropDesc = {
			  get: classListGetter
			, enumerable: true
			, configurable: true
		};
		try {
			objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
		} catch (ex) { // IE 8 doesn't support enumerable:true
			// adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
			// modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
			if (ex.number === undefined || ex.number === -0x7FF5EC54) {
				classListPropDesc.enumerable = false;
				objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
			}
		}
	} else if (objCtr[protoProp].__defineGetter__) {
		elemCtrProto.__defineGetter__(classListProp, classListGetter);
	}
	
	}(window.self));
	
	}
	
	// There is full or partial native classList support, so just check if we need
	// to normalize the add/remove and toggle APIs.
	
	(function () {
		"use strict";
	
		var testElement = document.createElement("_");
	
		testElement.classList.add("c1", "c2");
	
		// Polyfill for IE 10/11 and Firefox <26, where classList.add and
		// classList.remove exist but support only one argument at a time.
		if (!testElement.classList.contains("c2")) {
			var createMethod = function(method) {
				var original = DOMTokenList.prototype[method];
	
				DOMTokenList.prototype[method] = function(token) {
					var i, len = arguments.length;
	
					for (i = 0; i < len; i++) {
						token = arguments[i];
						original.call(this, token);
					}
				};
			};
			createMethod('add');
			createMethod('remove');
		}
	
		testElement.classList.toggle("c3", false);
	
		// Polyfill for IE 10 and Firefox <24, where classList.toggle does not
		// support the second argument.
		if (testElement.classList.contains("c3")) {
			var _toggle = DOMTokenList.prototype.toggle;
	
			DOMTokenList.prototype.toggle = function(token, force) {
				if (1 in arguments && !this.contains(token) === !force) {
					return force;
				} else {
					return _toggle.call(this, token);
				}
			};
	
		}
	
		testElement = null;
	}());
	
	}


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(513);
	__webpack_require__(509);
	module.exports = __webpack_require__(68).Symbol;


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1104);
	module.exports = __webpack_require__(68).RegExp.escape;


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(231);
	__webpack_require__(1086);
	module.exports = __webpack_require__(55).Array.from;


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(311);
	__webpack_require__(231);
	module.exports = __webpack_require__(1084);


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(311);
	__webpack_require__(231);
	module.exports = __webpack_require__(1085);


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1088);
	module.exports = __webpack_require__(55).Object.assign;


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1089);
	var $Object = __webpack_require__(55).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1090);
	var $Object = __webpack_require__(55).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1091);
	module.exports = __webpack_require__(55).Object.getPrototypeOf;


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1092);
	module.exports = __webpack_require__(55).Object.keys;


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1093);
	module.exports = __webpack_require__(55).Object.setPrototypeOf;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(1095);
	__webpack_require__(1094);
	__webpack_require__(1096);
	__webpack_require__(1097);
	module.exports = __webpack_require__(55).Symbol;


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(231);
	__webpack_require__(311);
	module.exports = __webpack_require__(310).f('iterator');


/***/ }),
/* 1065 */
56,
/* 1066 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 1067 */
[1856, 154, 475, 1083],
/* 1068 */
[1858, 107, 192],
/* 1069 */
[1862, 191, 303, 229],
/* 1070 */
[1864, 106],
/* 1071 */
[1867, 153, 75],
/* 1072 */
[1868, 298],
/* 1073 */
[1869, 120],
/* 1074 */
[1870, 302, 192, 304, 151, 75],
/* 1075 */
[1872, 75],
/* 1076 */
490,
/* 1077 */
[1873, 230, 152, 121, 107, 150],
/* 1078 */
[1874, 104, 191, 303, 229, 155, 467, 150],
/* 1079 */
[1877, 107, 120, 191, 104],
/* 1080 */
[1879, 154, 470],
/* 1081 */
[1885, 152, 120, 299, 469],
/* 1082 */
[1889, 307, 300],
/* 1083 */
[1890, 307],
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(120);
	var get = __webpack_require__(476);
	module.exports = __webpack_require__(55).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(464);
	var ITERATOR = __webpack_require__(75)('iterator');
	var Iterators = __webpack_require__(153);
	module.exports = __webpack_require__(55).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ }),
/* 1086 */
[1899, 299, 105, 155, 1073, 1071, 475, 1068, 476, 1075],
/* 1087 */
[1900, 1066, 1076, 153, 154, 468],
/* 1088 */
[1901, 105, 1078],
/* 1089 */
[1902, 105, 302],
/* 1090 */
[1903, 105, 104, 107],
/* 1091 */
[1904, 155, 471, 473],
/* 1092 */
[1905, 155, 191, 473],
/* 1093 */
[1906, 105, 1081],
/* 1094 */
/***/ (function(module, exports) {



/***/ }),
/* 1095 */
[1908, 106, 121, 104, 105, 474, 1077, 150, 306, 304, 230, 75, 310, 309, 1069, 1072, 120, 152, 155, 154, 308, 192, 302, 1080, 469, 303, 107, 191, 470, 229, 228, 151],
/* 1096 */
[1909, 309],
/* 1097 */
[1910, 309],
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(28);
	var isArray = __webpack_require__(235);
	var SPECIES = __webpack_require__(31)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(27);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(22);
	var toPrimitive = __webpack_require__(89);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 1101 */
[1862, 126, 239, 195],
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(196)('native-function-to-string', Function.toString);


/***/ }),
/* 1103 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(4);
	var $re = __webpack_require__(1103)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(478) });
	
	__webpack_require__(108)('copyWithin');


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $every = __webpack_require__(86)(4);
	
	$export($export.P + $export.F * !__webpack_require__(78)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Array', { fill: __webpack_require__(313) });
	
	__webpack_require__(108)('fill');


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $filter = __webpack_require__(86)(2);
	
	$export($export.P + $export.F * !__webpack_require__(78)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(4);
	var $find = __webpack_require__(86)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(108)(KEY);


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(4);
	var $find = __webpack_require__(86)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(108)(KEY);


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $forEach = __webpack_require__(86)(0);
	var STRICT = __webpack_require__(78)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1112 */
[1899, 77, 4, 43, 489, 321, 34, 315, 337, 237],
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $indexOf = __webpack_require__(232)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(78)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(235) });


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(72);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(194) != Object || !__webpack_require__(78)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(72);
	var toInteger = __webpack_require__(79);
	var toLength = __webpack_require__(34);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(78)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $map = __webpack_require__(86)(1);
	
	$export($export.P + $export.F * !__webpack_require__(78)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var createProperty = __webpack_require__(315);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(27)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $reduce = __webpack_require__(480);
	
	$export($export.P + $export.F * !__webpack_require__(78)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $reduce = __webpack_require__(480);
	
	$export($export.P + $export.F * !__webpack_require__(78)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var html = __webpack_require__(319);
	var cof = __webpack_require__(76);
	var toAbsoluteIndex = __webpack_require__(130);
	var toLength = __webpack_require__(34);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(27)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $some = __webpack_require__(86)(3);
	
	$export($export.P + $export.F * !__webpack_require__(78)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(56);
	var toObject = __webpack_require__(43);
	var fails = __webpack_require__(27);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(78)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(129)('Array');


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(4);
	var toISOString = __webpack_require__(1099);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(43);
	var toPrimitive = __webpack_require__(89);
	
	$export($export.P + $export.F * __webpack_require__(27)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(31)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(60)(proto, TO_PRIMITIVE, __webpack_require__(1100));


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(61)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(4);
	
	$export($export.P, 'Function', { bind: __webpack_require__(481) });


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(28);
	var getPrototypeOf = __webpack_require__(71);
	var HAS_INSTANCE = __webpack_require__(31)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(42).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(42).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(36) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(4);
	var log1p = __webpack_require__(492);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(4);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(4);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(4);
	var sign = __webpack_require__(325);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(4);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(4);
	var $expm1 = __webpack_require__(324);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { fround: __webpack_require__(491) });


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(4);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(4);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(27)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(492) });


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { sign: __webpack_require__(325) });


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(4);
	var expm1 = __webpack_require__(324);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(27)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(4);
	var expm1 = __webpack_require__(324);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(25);
	var has = __webpack_require__(69);
	var cof = __webpack_require__(76);
	var inheritIfRequired = __webpack_require__(320);
	var toPrimitive = __webpack_require__(89);
	var fails = __webpack_require__(27);
	var gOPN = __webpack_require__(125).f;
	var gOPD = __webpack_require__(70).f;
	var dP = __webpack_require__(42).f;
	var $trim = __webpack_require__(159).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(124)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(36) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(61)(global, NUMBER, $Number);
	}


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(4);
	var _isFinite = __webpack_require__(25).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(488) });


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(4);
	var isInteger = __webpack_require__(488);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseFloat = __webpack_require__(500);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseInt = __webpack_require__(501);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toInteger = __webpack_require__(79);
	var aNumberValue = __webpack_require__(477);
	var repeat = __webpack_require__(332);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(27)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $fails = __webpack_require__(27);
	var aNumberValue = __webpack_require__(477);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 1162 */
[1901, 4, 494],
/* 1163 */
[1902, 4, 124],
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(36), 'Object', { defineProperties: __webpack_require__(495) });


/***/ }),
/* 1165 */
[1903, 4, 36, 42],
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(28);
	var meta = __webpack_require__(110).onFreeze;
	
	__webpack_require__(88)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(72);
	var $getOwnPropertyDescriptor = __webpack_require__(70).f;
	
	__webpack_require__(88)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(88)('getOwnPropertyNames', function () {
	  return __webpack_require__(496).f;
	});


/***/ }),
/* 1169 */
[1904, 43, 71, 88],
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(28);
	
	__webpack_require__(88)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(28);
	
	__webpack_require__(88)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(28);
	
	__webpack_require__(88)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(4);
	$export($export.S, 'Object', { is: __webpack_require__(504) });


/***/ }),
/* 1174 */
[1905, 43, 126, 88],
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(28);
	var meta = __webpack_require__(110).onFreeze;
	
	__webpack_require__(88)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(28);
	var meta = __webpack_require__(110).onFreeze;
	
	__webpack_require__(88)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 1177 */
[1906, 4, 329],
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseFloat = __webpack_require__(500);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $parseInt = __webpack_require__(501);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(109);
	var global = __webpack_require__(25);
	var ctx = __webpack_require__(77);
	var classof = __webpack_require__(156);
	var $export = __webpack_require__(4);
	var isObject = __webpack_require__(28);
	var aFunction = __webpack_require__(56);
	var anInstance = __webpack_require__(122);
	var forOf = __webpack_require__(123);
	var speciesConstructor = __webpack_require__(197);
	var task = __webpack_require__(334).set;
	var microtask = __webpack_require__(326)();
	var newPromiseCapabilityModule = __webpack_require__(327);
	var perform = __webpack_require__(502);
	var userAgent = __webpack_require__(245);
	var promiseResolve = __webpack_require__(503);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(31)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(128)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(158)($Promise, PROMISE);
	__webpack_require__(129)(PROMISE);
	Wrapper = __webpack_require__(68)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(237)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(4);
	var aFunction = __webpack_require__(56);
	var anObject = __webpack_require__(22);
	var rApply = (__webpack_require__(25).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(27)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(4);
	var create = __webpack_require__(124);
	var aFunction = __webpack_require__(56);
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(28);
	var fails = __webpack_require__(27);
	var bind = __webpack_require__(481);
	var rConstruct = (__webpack_require__(25).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(42);
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(22);
	var toPrimitive = __webpack_require__(89);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(27)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(4);
	var gOPD = __webpack_require__(70).f;
	var anObject = __webpack_require__(22);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(22);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(322)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(70);
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(22);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(4);
	var getProto = __webpack_require__(71);
	var anObject = __webpack_require__(22);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(70);
	var getPrototypeOf = __webpack_require__(71);
	var has = __webpack_require__(69);
	var $export = __webpack_require__(4);
	var isObject = __webpack_require__(28);
	var anObject = __webpack_require__(22);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(22);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(499) });


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(4);
	var anObject = __webpack_require__(22);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(4);
	var setProto = __webpack_require__(329);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(42);
	var gOPD = __webpack_require__(70);
	var getPrototypeOf = __webpack_require__(71);
	var has = __webpack_require__(69);
	var $export = __webpack_require__(4);
	var createDesc = __webpack_require__(127);
	var anObject = __webpack_require__(22);
	var isObject = __webpack_require__(28);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(25);
	var inheritIfRequired = __webpack_require__(320);
	var dP = __webpack_require__(42).f;
	var gOPN = __webpack_require__(125).f;
	var isRegExp = __webpack_require__(236);
	var $flags = __webpack_require__(193);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(36) && (!CORRECT_NEW || __webpack_require__(27)(function () {
	  re2[__webpack_require__(31)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(61)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(129)('RegExp');


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(22);
	var toLength = __webpack_require__(34);
	var advanceStringIndex = __webpack_require__(312);
	var regExpExec = __webpack_require__(240);
	
	// @@match logic
	__webpack_require__(234)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(22);
	var toObject = __webpack_require__(43);
	var toLength = __webpack_require__(34);
	var toInteger = __webpack_require__(79);
	var advanceStringIndex = __webpack_require__(312);
	var regExpExec = __webpack_require__(240);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(234)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(22);
	var sameValue = __webpack_require__(504);
	var regExpExec = __webpack_require__(240);
	
	// @@search logic
	__webpack_require__(234)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(236);
	var anObject = __webpack_require__(22);
	var speciesConstructor = __webpack_require__(197);
	var advanceStringIndex = __webpack_require__(312);
	var toLength = __webpack_require__(34);
	var callRegExpExec = __webpack_require__(240);
	var regexpExec = __webpack_require__(328);
	var fails = __webpack_require__(27);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(234)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(511);
	var anObject = __webpack_require__(22);
	var $flags = __webpack_require__(193);
	var DESCRIPTORS = __webpack_require__(36);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(61)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(27)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(62)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(62)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(62)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(62)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $at = __webpack_require__(243)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(4);
	var toLength = __webpack_require__(34);
	var context = __webpack_require__(331);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(318)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(62)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(62)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(62)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var toAbsoluteIndex = __webpack_require__(130);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(4);
	var context = __webpack_require__(331);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(318)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(62)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 1213 */
[1907, 243, 323],
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(62)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var toIObject = __webpack_require__(72);
	var toLength = __webpack_require__(34);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(332)
	});


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(62)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(4);
	var toLength = __webpack_require__(34);
	var context = __webpack_require__(331);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(318)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(62)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(62)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(62)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(159)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var $typed = __webpack_require__(244);
	var buffer = __webpack_require__(335);
	var anObject = __webpack_require__(22);
	var toAbsoluteIndex = __webpack_require__(130);
	var toLength = __webpack_require__(34);
	var isObject = __webpack_require__(28);
	var ArrayBuffer = __webpack_require__(25).ArrayBuffer;
	var speciesConstructor = __webpack_require__(197);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(27)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(129)(ARRAY_BUFFER);


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	$export($export.G + $export.W + $export.F * !__webpack_require__(244).ABV, {
	  DataView: __webpack_require__(335).DataView
	});


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(94)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(94)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(94)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(94)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(94)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(94)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(94)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(94)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(94)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(484);
	var validate = __webpack_require__(132);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(233)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(4);
	var flattenIntoArray = __webpack_require__(485);
	var toObject = __webpack_require__(43);
	var toLength = __webpack_require__(34);
	var aFunction = __webpack_require__(56);
	var arraySpeciesCreate = __webpack_require__(314);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(108)('flatMap');


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(4);
	var flattenIntoArray = __webpack_require__(485);
	var toObject = __webpack_require__(43);
	var toLength = __webpack_require__(34);
	var toInteger = __webpack_require__(79);
	var arraySpeciesCreate = __webpack_require__(314);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(108)('flatten');


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(4);
	var $includes = __webpack_require__(232)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(108)('includes');


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(4);
	var microtask = __webpack_require__(326)();
	var process = __webpack_require__(25).process;
	var isNode = __webpack_require__(76)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(4);
	var cof = __webpack_require__(76);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(4);
	
	$export($export.G, { global: __webpack_require__(25) });


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(241)('Map');


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(242)('Map');


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(4);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(483)('Map') });


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	var scale = __webpack_require__(493);
	var fround = __webpack_require__(491);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { scale: __webpack_require__(493) });


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(4);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(43);
	var aFunction = __webpack_require__(56);
	var $defineProperty = __webpack_require__(42);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(36) && $export($export.P + __webpack_require__(238), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(43);
	var aFunction = __webpack_require__(56);
	var $defineProperty = __webpack_require__(42);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(36) && $export($export.P + __webpack_require__(238), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(4);
	var $entries = __webpack_require__(498)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(4);
	var ownKeys = __webpack_require__(499);
	var toIObject = __webpack_require__(72);
	var gOPD = __webpack_require__(70);
	var createProperty = __webpack_require__(315);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(43);
	var toPrimitive = __webpack_require__(89);
	var getPrototypeOf = __webpack_require__(71);
	var getOwnPropertyDescriptor = __webpack_require__(70).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(36) && $export($export.P + __webpack_require__(238), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(4);
	var toObject = __webpack_require__(43);
	var toPrimitive = __webpack_require__(89);
	var getPrototypeOf = __webpack_require__(71);
	var getOwnPropertyDescriptor = __webpack_require__(70).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(36) && $export($export.P + __webpack_require__(238), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(4);
	var $values = __webpack_require__(498)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(4);
	var global = __webpack_require__(25);
	var core = __webpack_require__(68);
	var microtask = __webpack_require__(326)();
	var OBSERVABLE = __webpack_require__(31)('observable');
	var aFunction = __webpack_require__(56);
	var anObject = __webpack_require__(22);
	var anInstance = __webpack_require__(122);
	var redefineAll = __webpack_require__(128);
	var hide = __webpack_require__(60);
	var forOf = __webpack_require__(123);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(129)('Observable');


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(4);
	var core = __webpack_require__(68);
	var global = __webpack_require__(25);
	var speciesConstructor = __webpack_require__(197);
	var promiseResolve = __webpack_require__(503);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(4);
	var newPromiseCapability = __webpack_require__(327);
	var perform = __webpack_require__(502);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(93);
	var anObject = __webpack_require__(22);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(93);
	var anObject = __webpack_require__(22);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(512);
	var from = __webpack_require__(479);
	var metadata = __webpack_require__(93);
	var anObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(71);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(93);
	var anObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(71);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(93);
	var anObject = __webpack_require__(22);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(93);
	var anObject = __webpack_require__(22);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(93);
	var anObject = __webpack_require__(22);
	var getPrototypeOf = __webpack_require__(71);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(93);
	var anObject = __webpack_require__(22);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(93);
	var anObject = __webpack_require__(22);
	var aFunction = __webpack_require__(56);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(241)('Set');


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(242)('Set');


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(4);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(483)('Set') });


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(4);
	var $at = __webpack_require__(243)(true);
	
	$export($export.P, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(4);
	var defined = __webpack_require__(87);
	var toLength = __webpack_require__(34);
	var isRegExp = __webpack_require__(236);
	var getFlags = __webpack_require__(193);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(322)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(4);
	var $pad = __webpack_require__(505);
	var userAgent = __webpack_require__(245);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(4);
	var $pad = __webpack_require__(505);
	var userAgent = __webpack_require__(245);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(159)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(159)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 1284 */
[1909, 336],
/* 1285 */
[1910, 336],
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(4);
	
	$export($export.S, 'System', { global: __webpack_require__(25) });


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(241)('WeakMap');


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(242)('WeakMap');


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(241)('WeakSet');


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(242)('WeakSet');


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(338);
	var getKeys = __webpack_require__(126);
	var redefine = __webpack_require__(61);
	var global = __webpack_require__(25);
	var hide = __webpack_require__(60);
	var Iterators = __webpack_require__(157);
	var wks = __webpack_require__(31);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(4);
	var $task = __webpack_require__(334);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(25);
	var $export = __webpack_require__(4);
	var userAgent = __webpack_require__(245);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(513);
	__webpack_require__(1163);
	__webpack_require__(1165);
	__webpack_require__(1164);
	__webpack_require__(1167);
	__webpack_require__(1169);
	__webpack_require__(1174);
	__webpack_require__(1168);
	__webpack_require__(1166);
	__webpack_require__(1176);
	__webpack_require__(1175);
	__webpack_require__(1171);
	__webpack_require__(1172);
	__webpack_require__(1170);
	__webpack_require__(1162);
	__webpack_require__(1173);
	__webpack_require__(1177);
	__webpack_require__(509);
	__webpack_require__(1130);
	__webpack_require__(1132);
	__webpack_require__(1131);
	__webpack_require__(1179);
	__webpack_require__(1178);
	__webpack_require__(1150);
	__webpack_require__(1160);
	__webpack_require__(1161);
	__webpack_require__(1151);
	__webpack_require__(1152);
	__webpack_require__(1153);
	__webpack_require__(1154);
	__webpack_require__(1155);
	__webpack_require__(1156);
	__webpack_require__(1157);
	__webpack_require__(1158);
	__webpack_require__(1159);
	__webpack_require__(1133);
	__webpack_require__(1134);
	__webpack_require__(1135);
	__webpack_require__(1136);
	__webpack_require__(1137);
	__webpack_require__(1138);
	__webpack_require__(1139);
	__webpack_require__(1140);
	__webpack_require__(1141);
	__webpack_require__(1142);
	__webpack_require__(1143);
	__webpack_require__(1144);
	__webpack_require__(1145);
	__webpack_require__(1146);
	__webpack_require__(1147);
	__webpack_require__(1148);
	__webpack_require__(1149);
	__webpack_require__(1210);
	__webpack_require__(1215);
	__webpack_require__(1222);
	__webpack_require__(1213);
	__webpack_require__(1205);
	__webpack_require__(1206);
	__webpack_require__(1211);
	__webpack_require__(1216);
	__webpack_require__(1218);
	__webpack_require__(1201);
	__webpack_require__(1202);
	__webpack_require__(1203);
	__webpack_require__(1204);
	__webpack_require__(1207);
	__webpack_require__(1208);
	__webpack_require__(1209);
	__webpack_require__(1212);
	__webpack_require__(1214);
	__webpack_require__(1217);
	__webpack_require__(1219);
	__webpack_require__(1220);
	__webpack_require__(1221);
	__webpack_require__(1125);
	__webpack_require__(1127);
	__webpack_require__(1126);
	__webpack_require__(1129);
	__webpack_require__(1128);
	__webpack_require__(1114);
	__webpack_require__(1112);
	__webpack_require__(1118);
	__webpack_require__(1115);
	__webpack_require__(1121);
	__webpack_require__(1123);
	__webpack_require__(1111);
	__webpack_require__(1117);
	__webpack_require__(1108);
	__webpack_require__(1122);
	__webpack_require__(1106);
	__webpack_require__(1120);
	__webpack_require__(1119);
	__webpack_require__(1113);
	__webpack_require__(1116);
	__webpack_require__(1105);
	__webpack_require__(1107);
	__webpack_require__(1110);
	__webpack_require__(1109);
	__webpack_require__(1124);
	__webpack_require__(338);
	__webpack_require__(1195);
	__webpack_require__(510);
	__webpack_require__(1200);
	__webpack_require__(511);
	__webpack_require__(1196);
	__webpack_require__(1197);
	__webpack_require__(1198);
	__webpack_require__(1199);
	__webpack_require__(1180);
	__webpack_require__(508);
	__webpack_require__(512);
	__webpack_require__(514);
	__webpack_require__(1234);
	__webpack_require__(1223);
	__webpack_require__(1224);
	__webpack_require__(1229);
	__webpack_require__(1232);
	__webpack_require__(1233);
	__webpack_require__(1227);
	__webpack_require__(1230);
	__webpack_require__(1228);
	__webpack_require__(1231);
	__webpack_require__(1225);
	__webpack_require__(1226);
	__webpack_require__(1181);
	__webpack_require__(1182);
	__webpack_require__(1183);
	__webpack_require__(1184);
	__webpack_require__(1185);
	__webpack_require__(1188);
	__webpack_require__(1186);
	__webpack_require__(1187);
	__webpack_require__(1189);
	__webpack_require__(1190);
	__webpack_require__(1191);
	__webpack_require__(1192);
	__webpack_require__(1194);
	__webpack_require__(1193);
	__webpack_require__(1237);
	__webpack_require__(1235);
	__webpack_require__(1236);
	__webpack_require__(1278);
	__webpack_require__(1281);
	__webpack_require__(1280);
	__webpack_require__(1282);
	__webpack_require__(1283);
	__webpack_require__(1279);
	__webpack_require__(1284);
	__webpack_require__(1285);
	__webpack_require__(1259);
	__webpack_require__(1262);
	__webpack_require__(1258);
	__webpack_require__(1256);
	__webpack_require__(1257);
	__webpack_require__(1260);
	__webpack_require__(1261);
	__webpack_require__(1243);
	__webpack_require__(1277);
	__webpack_require__(1242);
	__webpack_require__(1276);
	__webpack_require__(1288);
	__webpack_require__(1290);
	__webpack_require__(1241);
	__webpack_require__(1275);
	__webpack_require__(1287);
	__webpack_require__(1289);
	__webpack_require__(1240);
	__webpack_require__(1286);
	__webpack_require__(1239);
	__webpack_require__(1244);
	__webpack_require__(1245);
	__webpack_require__(1246);
	__webpack_require__(1247);
	__webpack_require__(1248);
	__webpack_require__(1250);
	__webpack_require__(1249);
	__webpack_require__(1251);
	__webpack_require__(1252);
	__webpack_require__(1253);
	__webpack_require__(1255);
	__webpack_require__(1254);
	__webpack_require__(1264);
	__webpack_require__(1265);
	__webpack_require__(1266);
	__webpack_require__(1267);
	__webpack_require__(1269);
	__webpack_require__(1268);
	__webpack_require__(1271);
	__webpack_require__(1270);
	__webpack_require__(1272);
	__webpack_require__(1273);
	__webpack_require__(1274);
	__webpack_require__(1238);
	__webpack_require__(1263);
	__webpack_require__(1293);
	__webpack_require__(1292);
	__webpack_require__(1291);
	module.exports = __webpack_require__(68);


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(210);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(1320);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(1298);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(1296);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(133)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{margin-left:-8px;position:absolute}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{box-sizing:content-box;position:absolute;border:8px solid transparent;height:0;width:1px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{content:\"\";z-index:-1;border-width:8px;left:-8px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle{top:0;margin-top:-8px}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{border-top:none;border-bottom-color:#f0f0f0}.react-datepicker-popper[data-placement^=bottom] .react-datepicker__triangle:before{top:-1px;border-bottom-color:#aeaeae}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{bottom:0;margin-bottom:-8px}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle,.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow:before{border-bottom:none;border-top-color:#fff}.react-datepicker-popper[data-placement^=top] .react-datepicker__triangle:before,.react-datepicker__month-read-view--down-arrow:before,.react-datepicker__month-year-read-view--down-arrow:before,.react-datepicker__year-read-view--down-arrow:before{bottom:-1px;border-top-color:#aeaeae}.react-datepicker,.react-datepicker-wrapper{display:inline-block}.react-datepicker{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:.8rem;background-color:#fff;color:#000;border:1px solid #aeaeae;border-radius:.3rem;position:relative}.react-datepicker--time-only .react-datepicker__triangle{left:35px}.react-datepicker--time-only .react-datepicker__time-container{border-left:0}.react-datepicker--time-only .react-datepicker__time,.react-datepicker--time-only .react-datepicker__time-box{border-radius:.3rem}.react-datepicker__triangle{position:absolute;left:50px}.react-datepicker-popper{z-index:1}.react-datepicker-popper[data-placement^=bottom]{margin-top:10px}.react-datepicker-popper[data-placement^=top]{margin-bottom:10px}.react-datepicker-popper[data-placement^=right]{margin-left:8px}.react-datepicker-popper[data-placement^=right] .react-datepicker__triangle{left:auto;right:42px}.react-datepicker-popper[data-placement^=left]{margin-right:8px}.react-datepicker-popper[data-placement^=left] .react-datepicker__triangle{left:42px;right:auto}.react-datepicker__header{text-align:center;background-color:#f0f0f0;border-bottom:1px solid #aeaeae;border-top-left-radius:.3rem;border-top-right-radius:.3rem;padding-top:8px;position:relative}.react-datepicker__header--time{padding-bottom:8px;padding-left:5px;padding-right:5px}.react-datepicker__month-dropdown-container--scroll,.react-datepicker__month-dropdown-container--select,.react-datepicker__month-year-dropdown-container--scroll,.react-datepicker__month-year-dropdown-container--select,.react-datepicker__year-dropdown-container--scroll,.react-datepicker__year-dropdown-container--select{display:inline-block;margin:0 2px}.react-datepicker-time__header,.react-datepicker__current-month{margin-top:0;color:#000;font-weight:700;font-size:.944rem}.react-datepicker-time__header{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}.react-datepicker__navigation{background:none;line-height:1.7rem;text-align:center;cursor:pointer;position:absolute;top:10px;width:0;padding:0;border:.45rem solid transparent;z-index:1;height:10px;width:10px;text-indent:-999em;overflow:hidden}.react-datepicker__navigation--previous{left:10px;border-right-color:#ccc}.react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__navigation--previous--disabled,.react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__navigation--next{right:10px;border-left-color:#ccc}.react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button){right:80px}.react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__navigation--next--disabled,.react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}.react-datepicker__navigation--years{position:relative;top:0;display:block;margin-left:auto;margin-right:auto}.react-datepicker__navigation--years-previous{top:4px;border-top-color:#ccc}.react-datepicker__navigation--years-previous:hover{border-top-color:#b3b3b3}.react-datepicker__navigation--years-upcoming{top:-4px;border-bottom-color:#ccc}.react-datepicker__navigation--years-upcoming:hover{border-bottom-color:#b3b3b3}.react-datepicker__month-container{float:left}.react-datepicker__month{margin:.4rem;text-align:center}.react-datepicker__time-container{float:right;border-left:1px solid #aeaeae;width:70px}.react-datepicker__time-container--with-today-button{display:inline;border:1px solid #aeaeae;border-radius:.3rem;position:absolute;right:-72px;top:0}.react-datepicker__time-container .react-datepicker__time{position:relative;background:#fff}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box{width:70px;overflow-x:hidden;margin:0 auto;text-align:center}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list{list-style:none;margin:0;height:calc(195px + 0.85rem);overflow-y:scroll;padding-right:0;padding-left:0;width:100%;box-sizing:content-box}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item{height:30px;padding:5px 10px}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item:hover{cursor:pointer;background-color:#f0f0f0}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected{background-color:#216ba5;color:#fff;font-weight:700}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--selected:hover{background-color:#216ba5}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled{color:#ccc}.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item--disabled:hover{cursor:default;background-color:transparent}.react-datepicker__week-number{color:#ccc;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__week-number.react-datepicker__week-number--clickable{cursor:pointer}.react-datepicker__week-number.react-datepicker__week-number--clickable:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day-names,.react-datepicker__week{white-space:nowrap}.react-datepicker__day,.react-datepicker__day-name,.react-datepicker__time-name{color:#000;display:inline-block;width:1.7rem;line-height:1.7rem;text-align:center;margin:.166rem}.react-datepicker__day{cursor:pointer}.react-datepicker__day:hover{border-radius:.3rem;background-color:#f0f0f0}.react-datepicker__day--today{font-weight:700}.react-datepicker__day--highlighted{border-radius:.3rem;background-color:#3dcc4a;color:#fff}.react-datepicker__day--highlighted:hover{background-color:#32be3f}.react-datepicker__day--highlighted-custom-1{color:#f0f}.react-datepicker__day--highlighted-custom-2{color:green}.react-datepicker__day--in-range,.react-datepicker__day--in-selecting-range,.react-datepicker__day--selected{border-radius:.3rem;background-color:#216ba5;color:#fff}.react-datepicker__day--in-range:hover,.react-datepicker__day--in-selecting-range:hover,.react-datepicker__day--selected:hover{background-color:#1d5d90}.react-datepicker__day--keyboard-selected{border-radius:.3rem;background-color:#2a87d0;color:#fff}.react-datepicker__day--keyboard-selected:hover{background-color:#1d5d90}.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range){background-color:rgba(33,107,165,.5)}.react-datepicker__month--selecting-range .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range){background-color:#f0f0f0;color:#000}.react-datepicker__day--disabled{cursor:default;color:#ccc}.react-datepicker__day--disabled:hover{background-color:transparent}.react-datepicker__input-container{position:relative;display:inline-block}.react-datepicker__month-read-view,.react-datepicker__month-year-read-view,.react-datepicker__year-read-view{border:1px solid transparent;border-radius:.3rem}.react-datepicker__month-read-view:hover,.react-datepicker__month-year-read-view:hover,.react-datepicker__year-read-view:hover{cursor:pointer}.react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,.react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow{border-top-color:#b3b3b3}.react-datepicker__month-read-view--down-arrow,.react-datepicker__month-year-read-view--down-arrow,.react-datepicker__year-read-view--down-arrow{border-top-color:#ccc;float:right;margin-left:20px;top:8px;position:relative;border-width:.45rem}.react-datepicker__month-dropdown,.react-datepicker__month-year-dropdown,.react-datepicker__year-dropdown{background-color:#f0f0f0;position:absolute;width:50%;left:25%;top:30px;z-index:1;text-align:center;border-radius:.3rem;border:1px solid #aeaeae}.react-datepicker__month-dropdown:hover,.react-datepicker__month-year-dropdown:hover,.react-datepicker__year-dropdown:hover{cursor:pointer}.react-datepicker__month-dropdown--scrollable,.react-datepicker__month-year-dropdown--scrollable,.react-datepicker__year-dropdown--scrollable{height:150px;overflow-y:scroll}.react-datepicker__month-option,.react-datepicker__month-year-option,.react-datepicker__year-option{line-height:20px;width:100%;display:block;margin-left:auto;margin-right:auto}.react-datepicker__month-option:first-of-type,.react-datepicker__month-year-option:first-of-type,.react-datepicker__year-option:first-of-type{border-top-left-radius:.3rem;border-top-right-radius:.3rem}.react-datepicker__month-option:last-of-type,.react-datepicker__month-year-option:last-of-type,.react-datepicker__year-option:last-of-type{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem}.react-datepicker__month-option:hover,.react-datepicker__month-year-option:hover,.react-datepicker__year-option:hover{background-color:#ccc}.react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming,.react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming{border-bottom-color:#b3b3b3}.react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous,.react-datepicker__year-option:hover .react-datepicker__navigation--years-previous{border-top-color:#b3b3b3}.react-datepicker__month-option--selected,.react-datepicker__month-year-option--selected,.react-datepicker__year-option--selected{position:absolute;left:15px}.react-datepicker__close-icon{background-color:transparent;border:0;cursor:pointer;outline:0;padding:0;vertical-align:middle;position:absolute;height:16px;width:16px;top:25%;right:7px}.react-datepicker__close-icon:after{background-color:#216ba5;border-radius:50%;bottom:0;box-sizing:border-box;color:#fff;content:\"\\D7\";cursor:pointer;font-size:12px;height:16px;width:16px;line-height:1;margin:-8px auto 0;padding:2px;position:absolute;right:0;text-align:center}.react-datepicker__today-button{background:#f0f0f0;border-top:1px solid #aeaeae;cursor:pointer;text-align:center;font-weight:700;padding:5px 0;clear:left}.react-datepicker__portal{position:fixed;width:100vw;height:100vh;background-color:rgba(0,0,0,.8);left:0;top:0;justify-content:center;align-items:center;display:flex;z-index:2147483647}.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:3rem;line-height:3rem}@media (max-height:550px),(max-width:400px){.react-datepicker__portal .react-datepicker__day,.react-datepicker__portal .react-datepicker__day-name,.react-datepicker__portal .react-datepicker__time-name{width:2rem;line-height:2rem}}.react-datepicker__portal .react-datepicker-time__header,.react-datepicker__portal .react-datepicker__current-month{font-size:1.44rem}.react-datepicker__portal .react-datepicker__navigation{border:.81rem solid transparent}.react-datepicker__portal .react-datepicker__navigation--previous{border-right-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--previous:hover{border-right-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--previous--disabled,.react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover{border-right-color:#e6e6e6;cursor:default}.react-datepicker__portal .react-datepicker__navigation--next{border-left-color:#ccc}.react-datepicker__portal .react-datepicker__navigation--next:hover{border-left-color:#b3b3b3}.react-datepicker__portal .react-datepicker__navigation--next--disabled,.react-datepicker__portal .react-datepicker__navigation--next--disabled:hover{border-left-color:#e6e6e6;cursor:default}", ""]);
	
	// exports


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(133)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, "@media (min-width:992px){.pay-info-desktop{margin-top:54px}}", ""]);
	
	// exports


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(133)(undefined);
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);", ""]);
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:400,300,500,700|Open+Sans:400,600,700);", ""]);
	
	// module
	exports.push([module.id, "html{position:relative;min-height:100%;color:rgba(0,0,0,.670588);font-size:14px;background-color:#f3f3f3}button,h1,h2,h3,h4,h5,h6,html,p{font-family:Open Sans,sans-serif}h1,h2,h3,h4,h5,h6{margin:0 12px}body{margin:0}input:-webkit-autofill{-webkit-box-shadow:0 0 0 1000px #fff inset}input::-webkit-inner-spin-button,input::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}date-input-polyfill[data-open=true]{z-index:10000!important}.toolbarContainer{position:relative}.react-datepicker__input-container input{display:block;width:110px}.hide-mobile{display:none!important}@media (min-width:768px) and (max-width:1023px){.hide-mobile{display:inherit!important}}@media (min-width:1024px){.hide-mobile{display:inherit!important}}.show-mobile{display:inherit!important}@media (min-width:768px) and (max-width:1023px){.show-mobile{display:none!important}}@media (min-width:1024px){.show-mobile{display:none!important}}.date-root{font-size:16px;line-height:16px;min-height:36px;margin-top:18px;display:inline-block;transition:height .2s cubic-bezier(.23,1,.32,1) 0ms}.date-input,.date-root{width:100%;position:relative;background-color:transparent}.date-input{-webkit-tap-highlight-color:rgba(0,0,0,0);padding:0;padding-bottom:6px;border:none;outline:none;color:rgba(0,0,0,.870588);cursor:auto;font-style:inherit;font-variant:inherit;font-weight:inherit;font-stretch:inherit;font-size:inherit;line-height:inherit;font-family:inherit;height:100%;box-sizing:border-box}.date-label{font-size:12px;line-height:22px;top:16px;z-index:1;cursor:text;pointer-events:none;color:rgba(0,0,0,.298039);-webkit-user-select:none}.date-underline{border-top:none #e0e0e0;border-right:none #e0e0e0;border-bottom:1px solid #e0e0e0;border-left:none #e0e0e0;box-sizing:content-box;margin:0;position:absolute;width:100%}.date-underline-error{border-top:none #f44336;border-right:none #f44336;border-bottom:2px solid #f44336;border-left:none #f44336}.date-underline-active,.date-underline-error{box-sizing:content-box;margin:0;position:absolute;width:100%;transition:all .45s cubic-bezier(.23,1,.32,1) 0ms;transform:scaleX(0)}.date-underline-active{border-top:none #4682b4;border-right:none #4682b4;border-bottom:2px solid #4682b4;border-left:none #4682b4}.date-underline-active-scale{transform:scaleX(1)}.date-error-text{position:relative;margin-top:6px;font-size:12px;line-height:12px;color:#f44336;transition:all .45s cubic-bezier(.23,1,.32,1) 0ms}input[type=file]{font-family:Open Sans,sans-serif}::-webkit-file-upload-button{background:#4682b4;color:#fff;font-family:Open Sans,sans-serif;font-size:12px;font-weight:500;letter-spacing:0;margin:0;padding-left:12px;padding-right:12px;text-transform:uppercase;height:28px;border:10px;border-radius:2px;transition:all .45s cubic-bezier(.23,1,.32,1)}::-ms-browse{background:#4682b4;color:#fff;font-family:Open Sans,sans-serif;font-size:15px;font-weight:500;letter-spacing:0;margin:0;padding-left:16px;padding-right:16px;text-transform:uppercase;height:36px;border:10px;border-radius:2px;transition:all .45s cubic-bezier(.23,1,.32,1)}.ktile-width{max-width:400px}@media (min-width:768px) and (max-width:1023px){.ktile-width{max-width:336px}}@media (min-width:1024px){.ktile-width{max-width:400px}}.react-datepicker-popper{z-index:9}.react-datepicker__input-container input{font-size:14px;text-align:center}.pay-ticket-table-container{border:1px solid #ddd;background-color:#fff;overflow-x:auto}.pay-ticket-table{background-color:#fff;border-collapse:collapse;width:100%}.pay-ticket-table td,th{padding:8px;word-wrap:break-word}.pay-ticket-table tr:nth-child(odd){background-color:#f3f6ff}.pay-ticket-table-header{width:100%;padding:18px 0;color:#3b53a7;font-size:24px;font-style:normal;font-weight:700;line-height:normal;text-align:center}.pay-ticket-table-footer{display:flex;margin:56px 36px 16px;align-items:flex-end;justify-content:space-between;line-height:1.7em}@media print{.no-print,.no-print *{display:none!important}}.tooltip{position:relative}.tooltip .tooltiptext{visibility:hidden;white-space:\"nowrap\";max-width:\"320px\";background-color:rgba(0,0,0,.75);color:#fff;text-align:center;border-radius:6px;padding:5px;position:absolute;z-index:1;top:-5px;right:105%}.tooltip:hover .tooltiptext{visibility:visible}", ""]);
	
	// exports


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(133)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".orgdiagram{outline-width:0;overflow:scroll;transform:translateZ(0)}.employeeTemplateTitleBackground{background-color:rgba(25,118,210,.8);-moz-border-radius:2px;-webkit-border-radius:2px;-khtml-border-radius:2px;border-radius:5px 5px 5px 0;width:100%;height:20px;overflow:hidden;transform:translateZ(0)}.employeeTemplateTitle{text-overflow:ellipsis;-o-text-overflow:ellipsis;overflow:hidden;word-wrap:break-word}.imageContainer{width:56px;height:70px;top:30px;left:5px}.bp-highlight-frame{box-shadow:0 3px 10px rgba(0,0,0,.4)}.employeeInfo{width:113px;font-size:12px;left:82px;padding-top:3px;text-overflow:ellipsis;-o-text-overflow:ellipsis;overflow:hidden}.employeeIcon{left:65px;width:16px;height:16px;font-size:16px!important;color:rgba(0,0,0,.5411)}", ""]);
	
	// exports


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(133)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, ".bp-item{position:absolute;overflow:hidden;font-family:Trebuchet MS,Tahoma,Verdana,Arial,sans-serif;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-touch-callout:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;box-sizing:content-box;cursor:pointer}.bp-corner-all{-moz-border-radius:2px;-webkit-border-radius:2px;-khtml-border-radius:2px;border-radius:2px}.bt-item-frame{box-shadow:0 3px 10px rgba(0,0,0,.16);overflow:hidden;display:hidden!important;background:#fff url(" + __webpack_require__(1845) + ") 50% 50% repeat-x}.bp-title{text-overflow:ellipsis;-o-text-overflow:ellipsis;white-space:nowrap;font-size:12px;line-height:16px;color:rgba(0,0,0,.8);padding:0}.bp-title-frame{border-width:0;color:#fff;padding:0}.bp-photo-frame{border-radius:2px;color:#1c94c4}.bp-description{font-size:10px;line-height:12px}.bp-cursor-frame{box-shadow:0 3px 10px #4682b4}.bp-grouptitle-frame{background:#00f;border-width:0;color:#fff;padding:0}.bp-selectioncheckbox-frame{font-size:12px;line-height:14px}.bp-selectioncheckbox,.bp-selectiontext{font-size:12px;line-height:14px;vertical-align:middle}.bp-readmore{text-align:right;text-decoration:none}.bp-label,.bp-readmore{font-size:10px;line-height:12px}.bp-connector-label,.bp-label{vertical-align:middle}.bp-connector-label{font-size:12px;line-height:14px;text-align:center;text-decoration:none;color:#000;font-weight:700}.bp-label-annotation{font-size:16px;text-align:center}.bp-badge{-moz-border-radius:10px;-webkit-border-radius:10px;-khtml-border-radius:10px;border-radius:10px;font-size:12px;line-height:12px;text-align:center;text-decoration:none;vertical-align:middle;font-weight:700;font-family:Arial;padding:4px;float:left}.bp-printpreview{position:absolute;overflow:hidden;border-right:1px;border-bottom:1px;border-right-style:dotted;border-bottom-style:dotted;border-right-color:#ccc;border-bottom-color:#ccc}.sticky-column{background-color:#fff!important;width:220px!important;left:0!important;position:sticky!important;padding-left:8px!important;z-index:2!important}.weekend-column{background-color:rgba(59,83,167,.1)!important}", ""]);
	
	// exports


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(133)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, "@keyframes _348YnSTcatdA1fpxnx0Owf{0%{transform:rotate(0deg);-webkit-transform:rotate(0deg);-moz-transform:rotate(0deg)}to{transform:rotate(1turn);-webkit-transform:rotate(1turn);-moz-transform:rotate(1turn)}}._2VnA_ZRg15DjjLngM11d_w{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.428571429}._3AYmS9VJxRa9yMhLLd3O4s{position:fixed;z-index:99999}._1Lo6ZMoncbLUOqEADYoddD,._1PQWHG5u9H9K9gH7Dz2K2X,._3KuHL0f8C4QkYfQMyt1dd1,._6lRZjHrXoz0BfliV7QMJW,.HPl0liCLg5OXgQhBCbzR9,.HQI4351Z5TECxgMkDOQwJ{width:360px}._1Lo6ZMoncbLUOqEADYoddD ._1MiVYSQWyga4EUlmB2xntp ._2fZUTcek_3w9Le8aKmc0N1,._1PQWHG5u9H9K9gH7Dz2K2X ._1MiVYSQWyga4EUlmB2xntp ._2fZUTcek_3w9Le8aKmc0N1,._3KuHL0f8C4QkYfQMyt1dd1 ._1MiVYSQWyga4EUlmB2xntp ._2fZUTcek_3w9Le8aKmc0N1,._6lRZjHrXoz0BfliV7QMJW ._1MiVYSQWyga4EUlmB2xntp ._2fZUTcek_3w9Le8aKmc0N1,.HPl0liCLg5OXgQhBCbzR9 ._1MiVYSQWyga4EUlmB2xntp ._2fZUTcek_3w9Le8aKmc0N1,.HQI4351Z5TECxgMkDOQwJ ._1MiVYSQWyga4EUlmB2xntp ._2fZUTcek_3w9Le8aKmc0N1{height:100%}._1Lo6ZMoncbLUOqEADYoddD .iRtj2MrM0UxCpVO6Prqq9 ._2fZUTcek_3w9Le8aKmc0N1,._1PQWHG5u9H9K9gH7Dz2K2X .iRtj2MrM0UxCpVO6Prqq9 ._2fZUTcek_3w9Le8aKmc0N1,._3KuHL0f8C4QkYfQMyt1dd1 .iRtj2MrM0UxCpVO6Prqq9 ._2fZUTcek_3w9Le8aKmc0N1,._6lRZjHrXoz0BfliV7QMJW .iRtj2MrM0UxCpVO6Prqq9 ._2fZUTcek_3w9Le8aKmc0N1,.HPl0liCLg5OXgQhBCbzR9 .iRtj2MrM0UxCpVO6Prqq9 ._2fZUTcek_3w9Le8aKmc0N1,.HQI4351Z5TECxgMkDOQwJ .iRtj2MrM0UxCpVO6Prqq9 ._2fZUTcek_3w9Le8aKmc0N1{height:50%}._1Lo6ZMoncbLUOqEADYoddD ._1G2_d9whKwLujrLMs8DOLP,._1PQWHG5u9H9K9gH7Dz2K2X ._1G2_d9whKwLujrLMs8DOLP,._3KuHL0f8C4QkYfQMyt1dd1 ._1G2_d9whKwLujrLMs8DOLP,._6lRZjHrXoz0BfliV7QMJW ._1G2_d9whKwLujrLMs8DOLP,.HPl0liCLg5OXgQhBCbzR9 ._1G2_d9whKwLujrLMs8DOLP,.HQI4351Z5TECxgMkDOQwJ ._1G2_d9whKwLujrLMs8DOLP{width:90px}._1Lo6ZMoncbLUOqEADYoddD ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1,._1PQWHG5u9H9K9gH7Dz2K2X ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1,._3KuHL0f8C4QkYfQMyt1dd1 ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1,._6lRZjHrXoz0BfliV7QMJW ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1,.HPl0liCLg5OXgQhBCbzR9 ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1,.HQI4351Z5TECxgMkDOQwJ ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1{display:block;width:90px}._1Lo6ZMoncbLUOqEADYoddD ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1:nth-child(2),._1PQWHG5u9H9K9gH7Dz2K2X ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1:nth-child(2),._3KuHL0f8C4QkYfQMyt1dd1 ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1:nth-child(2),._6lRZjHrXoz0BfliV7QMJW ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1:nth-child(2),.HPl0liCLg5OXgQhBCbzR9 ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1:nth-child(2),.HQI4351Z5TECxgMkDOQwJ ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1:nth-child(2){border-top:1px solid rgba(0,0,0,.09)}._1R5kIIKqyosLyFZnXwyd2m ._1MiVYSQWyga4EUlmB2xntp ._1G2_d9whKwLujrLMs8DOLP,.p7tV28wd0U9KKNRJ27eVr ._1MiVYSQWyga4EUlmB2xntp ._1G2_d9whKwLujrLMs8DOLP{width:90px}._1R5kIIKqyosLyFZnXwyd2m .iRtj2MrM0UxCpVO6Prqq9 .qLMDOggIJa22Q0mfNdDOn,.p7tV28wd0U9KKNRJ27eVr .iRtj2MrM0UxCpVO6Prqq9 .qLMDOggIJa22Q0mfNdDOn{width:calc(100% - 90px * 2)}._1R5kIIKqyosLyFZnXwyd2m .iRtj2MrM0UxCpVO6Prqq9 ._1G2_d9whKwLujrLMs8DOLP,.p7tV28wd0U9KKNRJ27eVr .iRtj2MrM0UxCpVO6Prqq9 ._1G2_d9whKwLujrLMs8DOLP{width:180px}._1R5kIIKqyosLyFZnXwyd2m ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1,.p7tV28wd0U9KKNRJ27eVr ._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1{float:left;width:90px;height:100%}._1R5kIIKqyosLyFZnXwyd2m{width:calc(100% - 40px);top:20px;left:20px}._1R5kIIKqyosLyFZnXwyd2m ._1VUOfmVNwwV3r95dZ4W6h_{position:relative;transition:opacity .4s,top .4s}._1R5kIIKqyosLyFZnXwyd2m ._2d4djBdeAt31-nERikZfW9,._1R5kIIKqyosLyFZnXwyd2m ._322CZItDr9ZP0ZLzBKpsJC{opacity:.01;top:-360px}._1R5kIIKqyosLyFZnXwyd2m ._2d4djBdeAt31-nERikZfW9._1oOmOKV7rTfTNfIqIh_iwH,._1R5kIIKqyosLyFZnXwyd2m ._2d4djBdeAt31-nERikZfW9._2EIx67SjZScX0RLzZMIkio,._1R5kIIKqyosLyFZnXwyd2m ._3K6sbR79tqCHf8KAFY2oV3,._1R5kIIKqyosLyFZnXwyd2m ._322CZItDr9ZP0ZLzBKpsJC._1oOmOKV7rTfTNfIqIh_iwH,._1R5kIIKqyosLyFZnXwyd2m ._322CZItDr9ZP0ZLzBKpsJC._2EIx67SjZScX0RLzZMIkio{top:0;opacity:1}._1R5kIIKqyosLyFZnXwyd2m ._3K6sbR79tqCHf8KAFY2oV3._1g5HuF5gVh-YijXHbgh0st{opacity:.01;top:-360px}.HQI4351Z5TECxgMkDOQwJ{top:20px;left:50%;transform:translateX(-50%)}.HQI4351Z5TECxgMkDOQwJ ._1VUOfmVNwwV3r95dZ4W6h_{position:relative;transition:opacity .4s,top .4s}.HQI4351Z5TECxgMkDOQwJ ._2d4djBdeAt31-nERikZfW9,.HQI4351Z5TECxgMkDOQwJ ._322CZItDr9ZP0ZLzBKpsJC{opacity:.01;top:-360px}.HQI4351Z5TECxgMkDOQwJ ._2d4djBdeAt31-nERikZfW9._1oOmOKV7rTfTNfIqIh_iwH,.HQI4351Z5TECxgMkDOQwJ ._2d4djBdeAt31-nERikZfW9._2EIx67SjZScX0RLzZMIkio,.HQI4351Z5TECxgMkDOQwJ ._3K6sbR79tqCHf8KAFY2oV3,.HQI4351Z5TECxgMkDOQwJ ._322CZItDr9ZP0ZLzBKpsJC._1oOmOKV7rTfTNfIqIh_iwH,.HQI4351Z5TECxgMkDOQwJ ._322CZItDr9ZP0ZLzBKpsJC._2EIx67SjZScX0RLzZMIkio{top:0;opacity:1}.HQI4351Z5TECxgMkDOQwJ ._3K6sbR79tqCHf8KAFY2oV3._1g5HuF5gVh-YijXHbgh0st{opacity:.01;top:-360px}._3KuHL0f8C4QkYfQMyt1dd1{top:20px;right:20px}._3KuHL0f8C4QkYfQMyt1dd1 ._1VUOfmVNwwV3r95dZ4W6h_{position:relative;transition:opacity .4s,right .4s}._3KuHL0f8C4QkYfQMyt1dd1 ._2d4djBdeAt31-nERikZfW9,._3KuHL0f8C4QkYfQMyt1dd1 ._322CZItDr9ZP0ZLzBKpsJC{opacity:.01;right:-360px}._3KuHL0f8C4QkYfQMyt1dd1 ._2d4djBdeAt31-nERikZfW9._1oOmOKV7rTfTNfIqIh_iwH,._3KuHL0f8C4QkYfQMyt1dd1 ._2d4djBdeAt31-nERikZfW9._2EIx67SjZScX0RLzZMIkio,._3KuHL0f8C4QkYfQMyt1dd1 ._3K6sbR79tqCHf8KAFY2oV3,._3KuHL0f8C4QkYfQMyt1dd1 ._322CZItDr9ZP0ZLzBKpsJC._1oOmOKV7rTfTNfIqIh_iwH,._3KuHL0f8C4QkYfQMyt1dd1 ._322CZItDr9ZP0ZLzBKpsJC._2EIx67SjZScX0RLzZMIkio{right:0;opacity:1}._3KuHL0f8C4QkYfQMyt1dd1 ._3K6sbR79tqCHf8KAFY2oV3._1g5HuF5gVh-YijXHbgh0st{opacity:.01;right:-360px}._1PQWHG5u9H9K9gH7Dz2K2X{top:20px;left:20px}._1PQWHG5u9H9K9gH7Dz2K2X ._1VUOfmVNwwV3r95dZ4W6h_{position:relative;transition:opacity .4s,left .4s}._1PQWHG5u9H9K9gH7Dz2K2X ._2d4djBdeAt31-nERikZfW9,._1PQWHG5u9H9K9gH7Dz2K2X ._322CZItDr9ZP0ZLzBKpsJC{opacity:.01;left:-360px}._1PQWHG5u9H9K9gH7Dz2K2X ._2d4djBdeAt31-nERikZfW9._1oOmOKV7rTfTNfIqIh_iwH,._1PQWHG5u9H9K9gH7Dz2K2X ._2d4djBdeAt31-nERikZfW9._2EIx67SjZScX0RLzZMIkio,._1PQWHG5u9H9K9gH7Dz2K2X ._3K6sbR79tqCHf8KAFY2oV3,._1PQWHG5u9H9K9gH7Dz2K2X ._322CZItDr9ZP0ZLzBKpsJC._1oOmOKV7rTfTNfIqIh_iwH,._1PQWHG5u9H9K9gH7Dz2K2X ._322CZItDr9ZP0ZLzBKpsJC._2EIx67SjZScX0RLzZMIkio{left:0;opacity:1}._1PQWHG5u9H9K9gH7Dz2K2X ._3K6sbR79tqCHf8KAFY2oV3._1g5HuF5gVh-YijXHbgh0st{opacity:.01;left:-360px}.p7tV28wd0U9KKNRJ27eVr{width:calc(100% - 40px);bottom:0;left:20px}.p7tV28wd0U9KKNRJ27eVr ._1VUOfmVNwwV3r95dZ4W6h_{position:relative;transition:opacity .4s,bottom .4s}.p7tV28wd0U9KKNRJ27eVr ._2d4djBdeAt31-nERikZfW9,.p7tV28wd0U9KKNRJ27eVr ._322CZItDr9ZP0ZLzBKpsJC{opacity:.01;bottom:-360px}.p7tV28wd0U9KKNRJ27eVr ._2d4djBdeAt31-nERikZfW9._1oOmOKV7rTfTNfIqIh_iwH,.p7tV28wd0U9KKNRJ27eVr ._2d4djBdeAt31-nERikZfW9._2EIx67SjZScX0RLzZMIkio,.p7tV28wd0U9KKNRJ27eVr ._3K6sbR79tqCHf8KAFY2oV3,.p7tV28wd0U9KKNRJ27eVr ._322CZItDr9ZP0ZLzBKpsJC._1oOmOKV7rTfTNfIqIh_iwH,.p7tV28wd0U9KKNRJ27eVr ._322CZItDr9ZP0ZLzBKpsJC._2EIx67SjZScX0RLzZMIkio{bottom:0;opacity:1}.p7tV28wd0U9KKNRJ27eVr ._3K6sbR79tqCHf8KAFY2oV3._1g5HuF5gVh-YijXHbgh0st{opacity:.01;bottom:-360px}.HPl0liCLg5OXgQhBCbzR9{bottom:0;left:50%;transform:translateX(-50%)}.HPl0liCLg5OXgQhBCbzR9 ._1VUOfmVNwwV3r95dZ4W6h_{position:relative;transition:opacity .4s,bottom .4s}.HPl0liCLg5OXgQhBCbzR9 ._2d4djBdeAt31-nERikZfW9,.HPl0liCLg5OXgQhBCbzR9 ._322CZItDr9ZP0ZLzBKpsJC{opacity:.01;bottom:-360px}.HPl0liCLg5OXgQhBCbzR9 ._2d4djBdeAt31-nERikZfW9._1oOmOKV7rTfTNfIqIh_iwH,.HPl0liCLg5OXgQhBCbzR9 ._2d4djBdeAt31-nERikZfW9._2EIx67SjZScX0RLzZMIkio,.HPl0liCLg5OXgQhBCbzR9 ._3K6sbR79tqCHf8KAFY2oV3,.HPl0liCLg5OXgQhBCbzR9 ._322CZItDr9ZP0ZLzBKpsJC._1oOmOKV7rTfTNfIqIh_iwH,.HPl0liCLg5OXgQhBCbzR9 ._322CZItDr9ZP0ZLzBKpsJC._2EIx67SjZScX0RLzZMIkio{bottom:0;opacity:1}.HPl0liCLg5OXgQhBCbzR9 ._3K6sbR79tqCHf8KAFY2oV3._1g5HuF5gVh-YijXHbgh0st{opacity:.01;bottom:-360px}._1Lo6ZMoncbLUOqEADYoddD{bottom:0;right:20px}._1Lo6ZMoncbLUOqEADYoddD ._1VUOfmVNwwV3r95dZ4W6h_{position:relative;transition:opacity .4s,right .4s}._1Lo6ZMoncbLUOqEADYoddD ._2d4djBdeAt31-nERikZfW9,._1Lo6ZMoncbLUOqEADYoddD ._322CZItDr9ZP0ZLzBKpsJC{opacity:.01;right:-360px}._1Lo6ZMoncbLUOqEADYoddD ._2d4djBdeAt31-nERikZfW9._1oOmOKV7rTfTNfIqIh_iwH,._1Lo6ZMoncbLUOqEADYoddD ._2d4djBdeAt31-nERikZfW9._2EIx67SjZScX0RLzZMIkio,._1Lo6ZMoncbLUOqEADYoddD ._3K6sbR79tqCHf8KAFY2oV3,._1Lo6ZMoncbLUOqEADYoddD ._322CZItDr9ZP0ZLzBKpsJC._1oOmOKV7rTfTNfIqIh_iwH,._1Lo6ZMoncbLUOqEADYoddD ._322CZItDr9ZP0ZLzBKpsJC._2EIx67SjZScX0RLzZMIkio{right:0;opacity:1}._1Lo6ZMoncbLUOqEADYoddD ._3K6sbR79tqCHf8KAFY2oV3._1g5HuF5gVh-YijXHbgh0st{opacity:.01;right:-360px}._6lRZjHrXoz0BfliV7QMJW{bottom:0;left:20px}._6lRZjHrXoz0BfliV7QMJW ._1VUOfmVNwwV3r95dZ4W6h_{position:relative;transition:opacity .4s,left .4s}._6lRZjHrXoz0BfliV7QMJW ._2d4djBdeAt31-nERikZfW9,._6lRZjHrXoz0BfliV7QMJW ._322CZItDr9ZP0ZLzBKpsJC{opacity:.01;left:-360px}._6lRZjHrXoz0BfliV7QMJW ._2d4djBdeAt31-nERikZfW9._1oOmOKV7rTfTNfIqIh_iwH,._6lRZjHrXoz0BfliV7QMJW ._2d4djBdeAt31-nERikZfW9._2EIx67SjZScX0RLzZMIkio,._6lRZjHrXoz0BfliV7QMJW ._3K6sbR79tqCHf8KAFY2oV3,._6lRZjHrXoz0BfliV7QMJW ._322CZItDr9ZP0ZLzBKpsJC._1oOmOKV7rTfTNfIqIh_iwH,._6lRZjHrXoz0BfliV7QMJW ._322CZItDr9ZP0ZLzBKpsJC._2EIx67SjZScX0RLzZMIkio{left:0;opacity:1}._6lRZjHrXoz0BfliV7QMJW ._3K6sbR79tqCHf8KAFY2oV3._1g5HuF5gVh-YijXHbgh0st{opacity:.01;left:-360px}@media (max-width:767px){._1R5kIIKqyosLyFZnXwyd2m{width:100%;top:0;left:0}._1R5kIIKqyosLyFZnXwyd2m ._1VUOfmVNwwV3r95dZ4W6h_{position:relative;transition:opacity .4s,top .4s}._1R5kIIKqyosLyFZnXwyd2m ._2d4djBdeAt31-nERikZfW9,._1R5kIIKqyosLyFZnXwyd2m ._322CZItDr9ZP0ZLzBKpsJC{opacity:.01;top:-360px}._1R5kIIKqyosLyFZnXwyd2m ._2d4djBdeAt31-nERikZfW9._1oOmOKV7rTfTNfIqIh_iwH,._1R5kIIKqyosLyFZnXwyd2m ._2d4djBdeAt31-nERikZfW9._2EIx67SjZScX0RLzZMIkio,._1R5kIIKqyosLyFZnXwyd2m ._3K6sbR79tqCHf8KAFY2oV3,._1R5kIIKqyosLyFZnXwyd2m ._322CZItDr9ZP0ZLzBKpsJC._1oOmOKV7rTfTNfIqIh_iwH,._1R5kIIKqyosLyFZnXwyd2m ._322CZItDr9ZP0ZLzBKpsJC._2EIx67SjZScX0RLzZMIkio{top:0;opacity:1}._1R5kIIKqyosLyFZnXwyd2m ._3K6sbR79tqCHf8KAFY2oV3._1g5HuF5gVh-YijXHbgh0st{opacity:.01;top:-360px}._1R5kIIKqyosLyFZnXwyd2m ._1C4L_m4-AkH54GMi_fflE8{margin:0}}._1VUOfmVNwwV3r95dZ4W6h_{display:table;width:100%;height:100%;min-height:40px;position:relative;border:none;-webkit-box-shadow:0 1px 3px -1px rgba(0,0,0,.3);box-shadow:0 1px 3px -1px rgba(0,0,0,.3);z-index:999;margin-bottom:20px}._1C4L_m4-AkH54GMi_fflE8{display:block;width:100%;height:100%;margin-bottom:20px}._36MhPpGgC6q_HPwBJRCGgV{display:table-cell;box-sizing:border-box;padding:10px 0 10px 15px}._1mmL58jx1TlJrwWVnZh-9m{display:inline-block;vertical-align:top;border-radius:40px;width:40px;height:40px;background-size:cover}._1wqKIfsytk7bm_3ZuRwo67{display:inline-block;box-sizing:border-box;margin:10px 0 10px 15px;font-size:20px!important}.qLMDOggIJa22Q0mfNdDOn{display:table-cell;vertical-align:top;box-sizing:border-box;width:100%;padding:10px 20px}.vtlENIsG-7qClGUhemU8n{display:table-cell;padding:10px 15px;box-sizing:border-box}.heiGWA5K2fs3yfbAPsKZ4{font-size:14px!important;color:#524c4c;cursor:pointer}.heiGWA5K2fs3yfbAPsKZ4:before{content:\"\\E5CD\"}.heiGWA5K2fs3yfbAPsKZ4:hover{color:#6c6565}._1G2_d9whKwLujrLMs8DOLP{display:table-cell;box-sizing:border-box;height:100%;vertical-align:top}._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1{min-height:40px;box-sizing:border-box;padding:0;background:none;border:none;border-left:1px solid rgba(0,0,0,.09);outline:none;text-align:center;color:#524c4c;cursor:pointer}._1G2_d9whKwLujrLMs8DOLP ._30JM1ZFhiclMfts6BNEfB0{display:block;height:25px;width:70px;white-space:nowrap;overflow:hidden;margin:0 auto;text-overflow:ellipsis;text-align:center;font-size:14px;line-height:25px}._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1:hover{color:#349ef3}._1G2_d9whKwLujrLMs8DOLP ._2fZUTcek_3w9Le8aKmc0N1:active{color:#0e86e6}._2Uca1_cmPFKGZ6hBWtqG_{margin:0 0 10px;font-size:15px;font-weight:700;line-height:1.428571429}.Z3RdqGCEJTHddincDPW3L{margin:0}._2QQIdfPOySk56G5WR0th9P{cursor:pointer}._3qkiZjVKmw8W-eSHbmJUXs{background-color:#fff;border-left:2px solid #fff;color:#524c4c}._3qkiZjVKmw8W-eSHbmJUXs ._1wqKIfsytk7bm_3ZuRwo67{display:none}.BysS0NLUlX_q5Jg-YBNs2{background-color:#fff;border-left:2px solid #4dc657;color:#524c4c}.BysS0NLUlX_q5Jg-YBNs2 ._1wqKIfsytk7bm_3ZuRwo67:before{content:\"\\E86C\";color:#4dc657}._3YfKmTuni853OZMuywAhnj{background-color:#fff;border-left:2px solid #349ef3;color:#524c4c}._3YfKmTuni853OZMuywAhnj ._1wqKIfsytk7bm_3ZuRwo67:before{content:\"\\E88E\";color:#349ef3}._16D-SxRjgTASA-03mcdgMh{background-color:#fff;border-left:2px solid #f5aa0a;color:#524c4c}._16D-SxRjgTASA-03mcdgMh ._1wqKIfsytk7bm_3ZuRwo67:before{content:\"\\E002\";color:#f5aa0a}._36L8EvY0p1f25VCx_RCabM{background-color:#fff;border-left:2px solid #f5311d;color:#524c4c}._36L8EvY0p1f25VCx_RCabM ._1wqKIfsytk7bm_3ZuRwo67:before{content:\"\\E000\";color:#f5311d}.N7BwEZekvNEboyoR9N-KH{background-color:#fff;border-left:2px solid #349ef3;color:#524c4c}.N7BwEZekvNEboyoR9N-KH ._1wqKIfsytk7bm_3ZuRwo67{-webkit-animation:_348YnSTcatdA1fpxnx0Owf 2s infinite linear;animation:_348YnSTcatdA1fpxnx0Owf 2s infinite linear}.N7BwEZekvNEboyoR9N-KH ._1wqKIfsytk7bm_3ZuRwo67:before{content:\"\\E863\";color:#349ef3}", ""]);
	
	// exports
	exports.locals = {
		"notifications-system": "_2VnA_ZRg15DjjLngM11d_w",
		"notifications-container": "_3AYmS9VJxRa9yMhLLd3O4s",
		"notifications-container--tc": "HQI4351Z5TECxgMkDOQwJ",
		"notifications-container--tr": "_3KuHL0f8C4QkYfQMyt1dd1",
		"notifications-container--tl": "_1PQWHG5u9H9K9gH7Dz2K2X",
		"notifications-container--bc": "HPl0liCLg5OXgQhBCbzR9",
		"notifications-container--br": "_1Lo6ZMoncbLUOqEADYoddD",
		"notifications-container--bl": "_6lRZjHrXoz0BfliV7QMJW",
		"notification--buttons-1": "_1MiVYSQWyga4EUlmB2xntp",
		"notification-button": "_2fZUTcek_3w9Le8aKmc0N1",
		"notification--buttons-2": "iRtj2MrM0UxCpVO6Prqq9",
		"notification-buttons": "_1G2_d9whKwLujrLMs8DOLP",
		"notifications-container--b": "p7tV28wd0U9KKNRJ27eVr",
		"notifications-container--t": "_1R5kIIKqyosLyFZnXwyd2m",
		"notification-meta": "qLMDOggIJa22Q0mfNdDOn",
		"notification": "_1VUOfmVNwwV3r95dZ4W6h_",
		"notification-enter": "_2d4djBdeAt31-nERikZfW9",
		"notification-appear": "_322CZItDr9ZP0ZLzBKpsJC",
		"notification-enter-active": "_2EIx67SjZScX0RLzZMIkio",
		"notification-appear-active": "_1oOmOKV7rTfTNfIqIh_iwH",
		"notification-leave": "_3K6sbR79tqCHf8KAFY2oV3",
		"notification-leave-active": "_1g5HuF5gVh-YijXHbgh0st",
		"notification-wrapper": "_1C4L_m4-AkH54GMi_fflE8",
		"notification-image-container": "_36MhPpGgC6q_HPwBJRCGgV",
		"notification-image": "_1mmL58jx1TlJrwWVnZh-9m",
		"notification-icon": "_1wqKIfsytk7bm_3ZuRwo67",
		"notification-close-button-container": "vtlENIsG-7qClGUhemU8n",
		"notification-close-button": "heiGWA5K2fs3yfbAPsKZ4",
		"notification-button-text": "_30JM1ZFhiclMfts6BNEfB0",
		"notification-title": "_2Uca1_cmPFKGZ6hBWtqG_",
		"notification-message": "Z3RdqGCEJTHddincDPW3L",
		"notification--dismissible": "_2QQIdfPOySk56G5WR0th9P",
		"notification--default": "_3qkiZjVKmw8W-eSHbmJUXs",
		"notification--success": "BysS0NLUlX_q5Jg-YBNs2",
		"notification--info": "_3YfKmTuni853OZMuywAhnj",
		"notification--warning": "_16D-SxRjgTASA-03mcdgMh",
		"notification--error": "_36L8EvY0p1f25VCx_RCabM",
		"notification--loading": "N7BwEZekvNEboyoR9N-KH",
		"rotating": "_348YnSTcatdA1fpxnx0Owf"
	};

/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(133)(undefined);
	// imports
	
	
	// module
	exports.push([module.id, "._1XdwbIRSc2WC65kpIvpUDJ{box-sizing:border-box;margin-left:auto;margin-right:auto;padding-right:8px;padding-left:8px}._2CR4_4wd8n4P3i45K3t2bj{padding-right:16px;padding-left:16px}@media only screen and (min-width:576px){._1XdwbIRSc2WC65kpIvpUDJ{width:560px;max-width:100%}}@media only screen and (min-width:768px){._1XdwbIRSc2WC65kpIvpUDJ{width:752px;max-width:100%}}@media only screen and (min-width:992px){._1XdwbIRSc2WC65kpIvpUDJ{width:976px;max-width:100%}}@media only screen and (min-width:1200px){._1XdwbIRSc2WC65kpIvpUDJ{width:1184px;max-width:100%}}._3a-jZNt8INCoPL48YmE-dx{box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-right:-8px;margin-left:-8px}._3a-jZNt8INCoPL48YmE-dx._3SKrH8FbNAsj8R7ofUeE_D{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.kWMj4pqLtm8zcEgdK_NQh._3SKrH8FbNAsj8R7ofUeE_D{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.-Ta2ee-mJwm_KFgt-JPJA,.-yJ2vMMOpo3cXFnhef6hu,._1-1tejBNNQE3f8I7PrIF7G,._1ah0hPOZiVa6qoLA_8GMpW,._1AZJwNi0kfM6BMwSxVfsGJ,._1c0Og4hrdPZXjXRyg9yq6-,._1cOiqu6xdLBUUv530NiGwa,._1D7U0lzA7cCf5BvGAnrMl9,._1dkXCR3q8WmuzEKazpxUCt,._1FO-L4XMm2JhBOWpwvK0bG,._1Gkwoe9jwvTIbcTKJ_vZkK,._1i2ro7aYHhTYURWO3Anuqa,._1jNsyL6mzV68lmkhprjqBn,._1np3o9VtPyT8TbHyhTYuC9,._1oeo9uEY2OrDK_G0mXwyBj,._1ofrtluqJnBJjHb0OeYhXn,._1OTc3C9LqDquN3YLpc9fXW,._1PMtME1xRTHtnFRneQ88u4,._1sI6E1-yN5azOAktkFe1mY,._1SOsqeo9i-RHUi7__t4hzy,._1SzG-G6agUohpgsx9KAjck,._1TrqgJYZMB_dQToCceYact,._1uHCHjpGHvBOOt_u0weJev,._1WNCntQlSENh27YqrMFI4b,._1X3oHL0kdWq7zvL_76vhkv,._1zzOGcx-FjtemLcfUn4hrg,._2_59sin4sfJtahjRg_XTY-,._2aFDet8K8bZfxHW35yNYz4,._2AWtWi_CudNsdoRcty2ab0,._2Bs3uF7Zl3L02984A3kit4,._2e6xPUlLs0kF18Vpepqy2B,._2FwJ_uNgMp-803AxnOWlZg,._2g_SAA8uKo3Q3qqm4mDCW2,._2GdtJ1YqyedIEtO9RPLwiP,._2GmS6hcbyjN58qJHZgOU2U,._2Hm1RWYupRwE2RIKkAEWN5,._2iKHfRmVBh9GfWuPrq1Ozw,._2jvCCRfo4NHmbBAV9ADUpB,._2l7chbL1253lh4iyBwMe1I,._2LiFSoulhMqFqzXi8rCJD3,._2LlvVGUt1vGbBzKlfVPenu,._2mUjS6ZPReWf-wNTBtGlqz,._2NCib0FR4ONq_VM00yDDJy,._2NJu62cyju_Lg_msYhNZge,._2nT9KvwcDj6oZjD0apQ_-b,._2Oc5SWOWQFjLPPc_dKdGwR,._2Ra0jSBt5oY9Z57fkYMcnC,._2Tq95nlGPrOeJwothrxhj8,._2WzT-Sdvnp4HsbkWCLs-ar,._2xI0Cfm91PmPwF_CxsCV5V,._2YGYPIKiI0kts1nyctgSuk,._3__wipJ4ZzIOk_0_8SVup4,._3_ZRF5owaFPZE0XJ0U6wlN,._3amrDmrmuBy3F-KPGVDWpT,._3BXs0YNZqGr03B92Y8SnoG,._3BzOIJDp3lwgHfmlqWqj9e,._3cm_xHeS14XzUO-2SsBzbl,._3DeIC2mO0g9KMadSM_V2XK,._3eWuhG76dBkzbB09gX051G,._3EyyyqL2H_Y-uCMO14zllH,._3Hdl-H9e5dxBioYMG5hp50,._3kLH4IlAqGig_hYk6mjmG,._3MmwEQ1tjnSHm0g6AVF3He,._3mSlaTko9x_BrD7i7urFa9,._3NaCwYmUZs4eIdzOs8KLGD,._3nE_yleboO-gjpDgf1_NBp,._3o6QfVWN64K35rnUKaMpfM,._3otnNXSv69JyBMrEhABd-W,._3OYvHkSmU6NCvmaob5nXZG,._3pRQmPQuWxsoBlq9Izk041,._3sJYvf-89ryeVihDbBKBE-,._3TpoU1TE5au60nlkAW74Q0,._3WUSoaaPMCnt81kX4O5iRi,._3Xe0GC4IOJt9-0TtfoS2NK,._3yacn24cjUubhQIhHacwgk,._3Z7TyAAmsr3PIUkDU1GqHA,._9xPEhfHL3hfAdJKED_JXL,._10RxV3umxjuId0DzPA3e2I,._14fZl0Z7XW6LD0xORhIEDE,._15QqZk8CFtehtpo6r8euP8,._17lwzxl1qyn2VYFHdvKNAB,._18VsvSCTcwB3UgNgWfZ9up,._19QS7OQH1WKX4nSxCLpZC1,._19vLt7uqtRYqE02g8Klwxa,._20H2OFpsuLgOxxwNvkChru,._22rtoey2dJzou8G7jTszjL,._25_cdQgA3_kY5EC5bKWciN,._25aozodQsKhHtxiCsJ-H7p,._27DA7TdZQKrNK1VeXdRRh9,._27x-hFfYIKT_TnzRIpwVEf,._27XbsT7iKe7kzOo4DNbEhR,._30Ei78IccRyFl2ZmQTfHBM,._31x5eJt0CXWEfykbYgfrHW,._32eNbFAWa0d3xlLE6EgR98,._32ok2pRIvbGSxRh3_T7bQA,._37Rq94GNvToG8ZkiIgnqQ8,._37uyD-yDewzrc7eShx3lgV,._39WeWRU3ZolJVlgK2q8l6X,._315dBFpay2n4g76NJTJ-Q3,._358ShyEzY-SfH3c0GgB_d6,.A0K3BEqFxPFJncWNQQ8tx,.bCa03AstWiLav7gAvisrj,.BeiHuuVvr67dZJc-4FBh1,.CCQcUsqfG-ZD98qZ9GlkT,.CooMCzDJiw9BIYr2DLM5g,.DdwSJc_8NG0b_cifkVj9z,.ed1iAJ-YnCHKr93WNSCHu,.fC3BZzvAa8GhoWpajYYav,.fk9YyTRPWbq5E-CqSaxwP,.ftKDqW-8F-MtvfEZBII59,.gjS09F45_-Xu9JeW3LopK,.HD_mBhRUhjv1suiDCnXqG,.ieiVs5DyK6e0J42l-BTdg,.ifgJcUbmxPv1EwhueZaQM,.J2jqNzcUYXQgjfm_72aeV,.JUmbRkPgpK440xPMLiuAW,.Kl2MUZkxRtHRCDJr2MO0B,.KWP8o2rRmUQhiSSpqkO7J,.N_0Cj3Mry7bENuLTGibys,.Sb_he-OEEqqy1Rl737GrJ,.tp6-hCiIWI8W2U-hABtNk,.UqveYlOiKXVJ9AZ4-SSwE,.urwOoSl5bWDb-68I9mBD,.uzAaed5oswir300qWShMe,.Vu7KtPMC5KjBbsyieBgo2,.vZtYbzVqMIxAVzbhwkix2,.WvctTd7dzMObnmn8wISZw,.x6vB8X8LpawRQI0bMHrhM,.yalaDabhFcbiJ2-iuamzY,.z8akXgQ0Pkw-HSLL9SduH{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;-ms-flex-preferred-size:100%;flex-basis:100%;padding-right:8px;padding-left:8px;max-width:100%}._31x5eJt0CXWEfykbYgfrHW{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}._3Xe0GC4IOJt9-0TtfoS2NK{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}._3sJYvf-89ryeVihDbBKBE-{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}.z8akXgQ0Pkw-HSLL9SduH{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}._1-1tejBNNQE3f8I7PrIF7G{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}.N_0Cj3Mry7bENuLTGibys{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}._3BXs0YNZqGr03B92Y8SnoG{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}._1sI6E1-yN5azOAktkFe1mY{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}._37Rq94GNvToG8ZkiIgnqQ8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}._1dkXCR3q8WmuzEKazpxUCt{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.Vu7KtPMC5KjBbsyieBgo2{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}.ifgJcUbmxPv1EwhueZaQM{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}._2AWtWi_CudNsdoRcty2ab0{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.ieiVs5DyK6e0J42l-BTdg{margin-left:0}._1cOiqu6xdLBUUv530NiGwa{margin-left:8.33333333%}._3Hdl-H9e5dxBioYMG5hp50{margin-left:16.66666667%}._17lwzxl1qyn2VYFHdvKNAB{margin-left:25%}._2Bs3uF7Zl3L02984A3kit4{margin-left:33.33333333%}._2xI0Cfm91PmPwF_CxsCV5V{margin-left:41.66666667%}._1WNCntQlSENh27YqrMFI4b{margin-left:50%}._3OYvHkSmU6NCvmaob5nXZG{margin-left:58.33333333%}._2LiFSoulhMqFqzXi8rCJD3{margin-left:66.66666667%}._18VsvSCTcwB3UgNgWfZ9up{margin-left:75%}._3eWuhG76dBkzbB09gX051G{margin-left:83.33333333%}._2NCib0FR4ONq_VM00yDDJy{margin-left:91.66666667%}._1P1LX-8qQy00dlb1F809KC{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}._4Yy5n6OiGibWPHk93ASHO{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}.DRHe_zm2lGv7OU0HszO9j{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}._2mJqAyMzvTXoHJnnJehVXv{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}._2i1PAEbtdWJbOLKdyXRfoj{-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3OhQ9KalsomTyiLSzHAlkp{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.UX8b_58rNSNJinFJgjSCe{-ms-flex-pack:distribute;justify-content:space-around}._20qM2Ne70R7il6b39xd00U{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.h9nO2DpOU_12ycvGW89Dq{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.JsGZn35MeyJ20H963sCJs{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}._3qXzT0CVbvx_ydh1ZkgUHL{-webkit-box-ordinal-group:NaN;-ms-flex-order:initial;order:0}@media only screen and (min-width:576px){.ed1iAJ-YnCHKr93WNSCHu{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}._25aozodQsKhHtxiCsJ-H7p{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}._2jvCCRfo4NHmbBAV9ADUpB{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}._3otnNXSv69JyBMrEhABd-W{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}._32ok2pRIvbGSxRh3_T7bQA{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}._1OTc3C9LqDquN3YLpc9fXW{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}._3WUSoaaPMCnt81kX4O5iRi{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.vZtYbzVqMIxAVzbhwkix2{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}._15QqZk8CFtehtpo6r8euP8{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}._2NJu62cyju_Lg_msYhNZge{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}._3__wipJ4ZzIOk_0_8SVup4{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}._3cm_xHeS14XzUO-2SsBzbl{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}._2Oc5SWOWQFjLPPc_dKdGwR{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}.yalaDabhFcbiJ2-iuamzY{margin-left:0}._3NaCwYmUZs4eIdzOs8KLGD{margin-left:8.33333333%}.A0K3BEqFxPFJncWNQQ8tx{margin-left:16.66666667%}._1SzG-G6agUohpgsx9KAjck{margin-left:25%}.KWP8o2rRmUQhiSSpqkO7J{margin-left:33.33333333%}._30Ei78IccRyFl2ZmQTfHBM{margin-left:41.66666667%}._19QS7OQH1WKX4nSxCLpZC1{margin-left:50%}._20H2OFpsuLgOxxwNvkChru{margin-left:58.33333333%}._1i2ro7aYHhTYURWO3Anuqa{margin-left:66.66666667%}._2FwJ_uNgMp-803AxnOWlZg{margin-left:75%}.Sb_he-OEEqqy1Rl737GrJ{margin-left:83.33333333%}._1SOsqeo9i-RHUi7__t4hzy{margin-left:91.66666667%}._2t5CBp_YKMSqSKJuhMRHms{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}._2sVcN5IgDtZLagc1glT5h4{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}._1QXhH8LcfJrPhlPUwTKZZM{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}._16H96O7vl_Gjre2DuDwFw7{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}._26rUV4pee3yAgkWCNB20L6{-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2oUIGbcns3Cktscbgg0KjX{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}._3eb6ejBZs7jBhepIvEAjQY{-ms-flex-pack:distribute;justify-content:space-around}._1OwuB8252GBWnOL5T_Wj3E{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._1uYdoU_EF20dAqRfBnuwXi{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}._1DrCCDe1raNZVFVv_jd_ib{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}.XiX4zag1sHKA1PeO-iw6w{-webkit-box-ordinal-group:NaN;-ms-flex-order:initial;order:0}}@media only screen and (min-width:768px){._1Gkwoe9jwvTIbcTKJ_vZkK,._1np3o9VtPyT8TbHyhTYuC9,._1PMtME1xRTHtnFRneQ88u4,._1TrqgJYZMB_dQToCceYact,._1uHCHjpGHvBOOt_u0weJev,._1X3oHL0kdWq7zvL_76vhkv,._2GmS6hcbyjN58qJHZgOU2U,._2iKHfRmVBh9GfWuPrq1Ozw,._2nT9KvwcDj6oZjD0apQ_-b,._2Ra0jSBt5oY9Z57fkYMcnC,._3EyyyqL2H_Y-uCMO14zllH,._3kLH4IlAqGig_hYk6mjmG,._3mSlaTko9x_BrD7i7urFa9,._3nE_yleboO-gjpDgf1_NBp,._3TpoU1TE5au60nlkAW74Q0,._3yacn24cjUubhQIhHacwgk,._9xPEhfHL3hfAdJKED_JXL,._10RxV3umxjuId0DzPA3e2I,._25_cdQgA3_kY5EC5bKWciN,._27x-hFfYIKT_TnzRIpwVEf,._315dBFpay2n4g76NJTJ-Q3,.bCa03AstWiLav7gAvisrj,.CooMCzDJiw9BIYr2DLM5g,.DdwSJc_8NG0b_cifkVj9z,.tp6-hCiIWI8W2U-hABtNk,.WvctTd7dzMObnmn8wISZw{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:8px;padding-left:8px}._1TrqgJYZMB_dQToCceYact{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}._27x-hFfYIKT_TnzRIpwVEf{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}.DdwSJc_8NG0b_cifkVj9z{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}.CooMCzDJiw9BIYr2DLM5g{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}._3mSlaTko9x_BrD7i7urFa9{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}._3yacn24cjUubhQIhHacwgk{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}._2nT9KvwcDj6oZjD0apQ_-b{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}._3kLH4IlAqGig_hYk6mjmG{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}.bCa03AstWiLav7gAvisrj{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}.WvctTd7dzMObnmn8wISZw{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}._10RxV3umxjuId0DzPA3e2I{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}._2iKHfRmVBh9GfWuPrq1Ozw{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}._2Ra0jSBt5oY9Z57fkYMcnC{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}._1X3oHL0kdWq7zvL_76vhkv{margin-left:0}._25_cdQgA3_kY5EC5bKWciN{margin-left:8.33333333%}._1uHCHjpGHvBOOt_u0weJev{margin-left:16.66666667%}._315dBFpay2n4g76NJTJ-Q3{margin-left:25%}._1PMtME1xRTHtnFRneQ88u4{margin-left:33.33333333%}.tp6-hCiIWI8W2U-hABtNk{margin-left:41.66666667%}._3EyyyqL2H_Y-uCMO14zllH{margin-left:50%}._2GmS6hcbyjN58qJHZgOU2U{margin-left:58.33333333%}._3TpoU1TE5au60nlkAW74Q0{margin-left:66.66666667%}._1np3o9VtPyT8TbHyhTYuC9{margin-left:75%}._9xPEhfHL3hfAdJKED_JXL{margin-left:83.33333333%}._3nE_yleboO-gjpDgf1_NBp{margin-left:91.66666667%}.ogdFtRRbswteY7llKqQ0s{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}._1ETLtkFD2XASe4r54Hif9y{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}._395W4LTrRRRYoH4B6y2WJo{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}._2bZsNf2SZz6vaIHDbk2QTs{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}._1pB84R4v85xG5Vj4yFqHsr{-webkit-box-align:center;-ms-flex-align:center;align-items:center}._1gZlQ5_CAaJfXKMGFCb_0w{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}._2s3FqyLtMuakcoSmPGOIXd{-ms-flex-pack:distribute;justify-content:space-around}._15r3ne8l-HjGOJH0Vy86SU{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.QO-WtpCgZFP9UrbKj61XV{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}._3C11seSCC13gIvw1Kq5DxY{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}._26QcDRrPMjzOOAFLdW7Bbs{-webkit-box-ordinal-group:NaN;-ms-flex-order:initial;order:0}}@media only screen and (min-width:992px){.-Ta2ee-mJwm_KFgt-JPJA,.-yJ2vMMOpo3cXFnhef6hu,._1ah0hPOZiVa6qoLA_8GMpW,._1FO-L4XMm2JhBOWpwvK0bG,._1jNsyL6mzV68lmkhprjqBn,._1ofrtluqJnBJjHb0OeYhXn,._1zzOGcx-FjtemLcfUn4hrg,._2_59sin4sfJtahjRg_XTY-,._2Hm1RWYupRwE2RIKkAEWN5,._2l7chbL1253lh4iyBwMe1I,._2LlvVGUt1vGbBzKlfVPenu,._2Tq95nlGPrOeJwothrxhj8,._3_ZRF5owaFPZE0XJ0U6wlN,._3BzOIJDp3lwgHfmlqWqj9e,._3MmwEQ1tjnSHm0g6AVF3He,._3pRQmPQuWxsoBlq9Izk041,._3Z7TyAAmsr3PIUkDU1GqHA,._14fZl0Z7XW6LD0xORhIEDE,._19vLt7uqtRYqE02g8Klwxa,._22rtoey2dJzou8G7jTszjL,._27DA7TdZQKrNK1VeXdRRh9,._32eNbFAWa0d3xlLE6EgR98,._39WeWRU3ZolJVlgK2q8l6X,.HD_mBhRUhjv1suiDCnXqG,.Kl2MUZkxRtHRCDJr2MO0B,.x6vB8X8LpawRQI0bMHrhM{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:8px;padding-left:8px}._3MmwEQ1tjnSHm0g6AVF3He{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}._22rtoey2dJzou8G7jTszjL{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}._2l7chbL1253lh4iyBwMe1I{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}.x6vB8X8LpawRQI0bMHrhM{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}._1ofrtluqJnBJjHb0OeYhXn{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}._2Hm1RWYupRwE2RIKkAEWN5{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}._2LlvVGUt1vGbBzKlfVPenu{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}._1zzOGcx-FjtemLcfUn4hrg{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}._3_ZRF5owaFPZE0XJ0U6wlN{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}._3Z7TyAAmsr3PIUkDU1GqHA{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}._2_59sin4sfJtahjRg_XTY-{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}._27DA7TdZQKrNK1VeXdRRh9{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}.HD_mBhRUhjv1suiDCnXqG{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}._3pRQmPQuWxsoBlq9Izk041{margin-left:0}._39WeWRU3ZolJVlgK2q8l6X{margin-left:8.33333333%}._1ah0hPOZiVa6qoLA_8GMpW{margin-left:16.66666667%}._1jNsyL6mzV68lmkhprjqBn{margin-left:25%}.-Ta2ee-mJwm_KFgt-JPJA{margin-left:33.33333333%}._3BzOIJDp3lwgHfmlqWqj9e{margin-left:41.66666667%}._19vLt7uqtRYqE02g8Klwxa{margin-left:50%}.Kl2MUZkxRtHRCDJr2MO0B{margin-left:58.33333333%}._2Tq95nlGPrOeJwothrxhj8{margin-left:66.66666667%}.-yJ2vMMOpo3cXFnhef6hu{margin-left:75%}._1FO-L4XMm2JhBOWpwvK0bG{margin-left:83.33333333%}._14fZl0Z7XW6LD0xORhIEDE{margin-left:91.66666667%}._16-hUe5Nj5lcjRagz_xnCE{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}._1wg6sd-cxkfLCC5w-Ogxbz{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}._2yx-klLklkoPD_3YQE4igi{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}._1LD-cyHwIWPnrFAaKvC7VF{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}._2fi4jfKATQbWFCWjZkpI5j{-webkit-box-align:center;-ms-flex-align:center;align-items:center}._2UDYLANthWfshFBHbj1fl8{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}._1gRdCoJ5DfGKo74lmQNG3T{-ms-flex-pack:distribute;justify-content:space-around}.mhYrtYphyo8pFPX05GDuK{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.rmvzXmVPz9FqR1K9lw8yu{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}.P5jr2-Jm5DlkE8LuyNCKd{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}._3l1jIo12oXQ_CnToqqKZUM{-webkit-box-ordinal-group:NaN;-ms-flex-order:initial;order:0}}@media only screen and (min-width:1200px){._1AZJwNi0kfM6BMwSxVfsGJ,._1c0Og4hrdPZXjXRyg9yq6-,._1D7U0lzA7cCf5BvGAnrMl9,._2aFDet8K8bZfxHW35yNYz4,._2e6xPUlLs0kF18Vpepqy2B,._2g_SAA8uKo3Q3qqm4mDCW2,._2GdtJ1YqyedIEtO9RPLwiP,._2mUjS6ZPReWf-wNTBtGlqz,._2WzT-Sdvnp4HsbkWCLs-ar,._2YGYPIKiI0kts1nyctgSuk,._3amrDmrmuBy3F-KPGVDWpT,._3DeIC2mO0g9KMadSM_V2XK,._3o6QfVWN64K35rnUKaMpfM,._27XbsT7iKe7kzOo4DNbEhR,._37uyD-yDewzrc7eShx3lgV,._358ShyEzY-SfH3c0GgB_d6,.BeiHuuVvr67dZJc-4FBh1,.CCQcUsqfG-ZD98qZ9GlkT,.fC3BZzvAa8GhoWpajYYav,.ftKDqW-8F-MtvfEZBII59,.gjS09F45_-Xu9JeW3LopK,.J2jqNzcUYXQgjfm_72aeV,.JUmbRkPgpK440xPMLiuAW,.UqveYlOiKXVJ9AZ4-SSwE,.urwOoSl5bWDb-68I9mBD,.uzAaed5oswir300qWShMe{box-sizing:border-box;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;padding-right:8px;padding-left:8px}.CCQcUsqfG-ZD98qZ9GlkT{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0;max-width:100%}._27XbsT7iKe7kzOo4DNbEhR{-ms-flex-preferred-size:8.33333333%;flex-basis:8.33333333%;max-width:8.33333333%}._358ShyEzY-SfH3c0GgB_d6{-ms-flex-preferred-size:16.66666667%;flex-basis:16.66666667%;max-width:16.66666667%}.UqveYlOiKXVJ9AZ4-SSwE{-ms-flex-preferred-size:25%;flex-basis:25%;max-width:25%}._2aFDet8K8bZfxHW35yNYz4{-ms-flex-preferred-size:33.33333333%;flex-basis:33.33333333%;max-width:33.33333333%}._2GdtJ1YqyedIEtO9RPLwiP{-ms-flex-preferred-size:41.66666667%;flex-basis:41.66666667%;max-width:41.66666667%}._2g_SAA8uKo3Q3qqm4mDCW2{-ms-flex-preferred-size:50%;flex-basis:50%;max-width:50%}.urwOoSl5bWDb-68I9mBD{-ms-flex-preferred-size:58.33333333%;flex-basis:58.33333333%;max-width:58.33333333%}._2e6xPUlLs0kF18Vpepqy2B{-ms-flex-preferred-size:66.66666667%;flex-basis:66.66666667%;max-width:66.66666667%}._2WzT-Sdvnp4HsbkWCLs-ar{-ms-flex-preferred-size:75%;flex-basis:75%;max-width:75%}.ftKDqW-8F-MtvfEZBII59{-ms-flex-preferred-size:83.33333333%;flex-basis:83.33333333%;max-width:83.33333333%}._1AZJwNi0kfM6BMwSxVfsGJ{-ms-flex-preferred-size:91.66666667%;flex-basis:91.66666667%;max-width:91.66666667%}.fC3BZzvAa8GhoWpajYYav{-ms-flex-preferred-size:100%;flex-basis:100%;max-width:100%}._3amrDmrmuBy3F-KPGVDWpT{margin-left:0}._2YGYPIKiI0kts1nyctgSuk{margin-left:8.33333333%}.J2jqNzcUYXQgjfm_72aeV{margin-left:16.66666667%}._3DeIC2mO0g9KMadSM_V2XK{margin-left:25%}.gjS09F45_-Xu9JeW3LopK{margin-left:33.33333333%}._1c0Og4hrdPZXjXRyg9yq6-{margin-left:41.66666667%}.BeiHuuVvr67dZJc-4FBh1{margin-left:50%}.JUmbRkPgpK440xPMLiuAW{margin-left:58.33333333%}._1D7U0lzA7cCf5BvGAnrMl9{margin-left:66.66666667%}._37uyD-yDewzrc7eShx3lgV{margin-left:75%}._3o6QfVWN64K35rnUKaMpfM{margin-left:83.33333333%}.uzAaed5oswir300qWShMe{margin-left:91.66666667%}.hld1ie7a3YYbjDb-egJ2E{-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;text-align:start}.kYyHhW62Sg2UZFgLnu-jK{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center}._3p9CIPgOEXPsKIn98YFrEe{-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;text-align:end}.NTLPswV_L5UcVWv0a0M2p{-webkit-box-align:start;-ms-flex-align:start;align-items:flex-start}._1efSBoPeLKzCmlQRwHKYt7{-webkit-box-align:center;-ms-flex-align:center;align-items:center}._3qoVg8pOSK0tHAYEadRams{-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.kXJs7U3ahgy69-xorBzvg{-ms-flex-pack:distribute;justify-content:space-around}._2uPcF3MtGNxw6dpvnuziRJ{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}._3I5NdwxsCcId2k6BW6DV9Q{-webkit-box-ordinal-group:0;-ms-flex-order:-1;order:-1}._26U2QtsMJfKXhPYxi5Y0gw{-webkit-box-ordinal-group:2;-ms-flex-order:1;order:1}._3Jgfw3pzyg1mZVveQHlhaZ{-webkit-box-ordinal-group:NaN;-ms-flex-order:initial;order:0}}@media only screen and (max-width:575px){._3enEz-JE17VdQ-_5bxIn0c{display:none}}@media only screen and (min-width:576px) and (max-width:767px){.cA0GoYVrNnrtgk-FeM_h_{display:none}}@media only screen and (min-width:768px) and (max-width:991px){._29NOTpROMY9yLQLuYC4FEG{display:none}}@media only screen and (min-width:992px) and (max-width:1199px){._3nb8qlQTxGHx2ukvCmVcD8{display:none}}@media only screen and (min-width:1200px){._2ty7Oy3MxFcYXswhjqpJm-{display:none}}", ""]);
	
	// exports
	exports.locals = {
		"container": "_1XdwbIRSc2WC65kpIvpUDJ",
		"container-fluid": "_2CR4_4wd8n4P3i45K3t2bj",
		"row": "_3a-jZNt8INCoPL48YmE-dx",
		"reverse": "_3SKrH8FbNAsj8R7ofUeE_D",
		"col": "kWMj4pqLtm8zcEgdK_NQh",
		"col-xs": "_31x5eJt0CXWEfykbYgfrHW",
		"col-xs-1": "_3Xe0GC4IOJt9-0TtfoS2NK",
		"col-xs-2": "_3sJYvf-89ryeVihDbBKBE-",
		"col-xs-3": "z8akXgQ0Pkw-HSLL9SduH",
		"col-xs-4": "_1-1tejBNNQE3f8I7PrIF7G",
		"col-xs-5": "N_0Cj3Mry7bENuLTGibys",
		"col-xs-6": "_3BXs0YNZqGr03B92Y8SnoG",
		"col-xs-7": "_1sI6E1-yN5azOAktkFe1mY",
		"col-xs-8": "_37Rq94GNvToG8ZkiIgnqQ8",
		"col-xs-9": "_1dkXCR3q8WmuzEKazpxUCt",
		"col-xs-10": "Vu7KtPMC5KjBbsyieBgo2",
		"col-xs-11": "ifgJcUbmxPv1EwhueZaQM",
		"col-xs-12": "_2AWtWi_CudNsdoRcty2ab0",
		"col-xs-offset-0": "ieiVs5DyK6e0J42l-BTdg",
		"col-xs-offset-1": "_1cOiqu6xdLBUUv530NiGwa",
		"col-xs-offset-2": "_3Hdl-H9e5dxBioYMG5hp50",
		"col-xs-offset-3": "_17lwzxl1qyn2VYFHdvKNAB",
		"col-xs-offset-4": "_2Bs3uF7Zl3L02984A3kit4",
		"col-xs-offset-5": "_2xI0Cfm91PmPwF_CxsCV5V",
		"col-xs-offset-6": "_1WNCntQlSENh27YqrMFI4b",
		"col-xs-offset-7": "_3OYvHkSmU6NCvmaob5nXZG",
		"col-xs-offset-8": "_2LiFSoulhMqFqzXi8rCJD3",
		"col-xs-offset-9": "_18VsvSCTcwB3UgNgWfZ9up",
		"col-xs-offset-10": "_3eWuhG76dBkzbB09gX051G",
		"col-xs-offset-11": "_2NCib0FR4ONq_VM00yDDJy",
		"col-xs-offset-12": "_1oeo9uEY2OrDK_G0mXwyBj",
		"col-sm": "ed1iAJ-YnCHKr93WNSCHu",
		"col-sm-1": "_25aozodQsKhHtxiCsJ-H7p",
		"col-sm-2": "_2jvCCRfo4NHmbBAV9ADUpB",
		"col-sm-3": "_3otnNXSv69JyBMrEhABd-W",
		"col-sm-4": "_32ok2pRIvbGSxRh3_T7bQA",
		"col-sm-5": "_1OTc3C9LqDquN3YLpc9fXW",
		"col-sm-6": "_3WUSoaaPMCnt81kX4O5iRi",
		"col-sm-7": "vZtYbzVqMIxAVzbhwkix2",
		"col-sm-8": "_15QqZk8CFtehtpo6r8euP8",
		"col-sm-9": "_2NJu62cyju_Lg_msYhNZge",
		"col-sm-10": "_3__wipJ4ZzIOk_0_8SVup4",
		"col-sm-11": "_3cm_xHeS14XzUO-2SsBzbl",
		"col-sm-12": "_2Oc5SWOWQFjLPPc_dKdGwR",
		"col-sm-offset-0": "yalaDabhFcbiJ2-iuamzY",
		"col-sm-offset-1": "_3NaCwYmUZs4eIdzOs8KLGD",
		"col-sm-offset-2": "A0K3BEqFxPFJncWNQQ8tx",
		"col-sm-offset-3": "_1SzG-G6agUohpgsx9KAjck",
		"col-sm-offset-4": "KWP8o2rRmUQhiSSpqkO7J",
		"col-sm-offset-5": "_30Ei78IccRyFl2ZmQTfHBM",
		"col-sm-offset-6": "_19QS7OQH1WKX4nSxCLpZC1",
		"col-sm-offset-7": "_20H2OFpsuLgOxxwNvkChru",
		"col-sm-offset-8": "_1i2ro7aYHhTYURWO3Anuqa",
		"col-sm-offset-9": "_2FwJ_uNgMp-803AxnOWlZg",
		"col-sm-offset-10": "Sb_he-OEEqqy1Rl737GrJ",
		"col-sm-offset-11": "_1SOsqeo9i-RHUi7__t4hzy",
		"col-sm-offset-12": "fk9YyTRPWbq5E-CqSaxwP",
		"col-md": "_1TrqgJYZMB_dQToCceYact",
		"col-md-1": "_27x-hFfYIKT_TnzRIpwVEf",
		"col-md-2": "DdwSJc_8NG0b_cifkVj9z",
		"col-md-3": "CooMCzDJiw9BIYr2DLM5g",
		"col-md-4": "_3mSlaTko9x_BrD7i7urFa9",
		"col-md-5": "_3yacn24cjUubhQIhHacwgk",
		"col-md-6": "_2nT9KvwcDj6oZjD0apQ_-b",
		"col-md-7": "_3kLH4IlAqGig_hYk6mjmG",
		"col-md-8": "bCa03AstWiLav7gAvisrj",
		"col-md-9": "WvctTd7dzMObnmn8wISZw",
		"col-md-10": "_10RxV3umxjuId0DzPA3e2I",
		"col-md-11": "_2iKHfRmVBh9GfWuPrq1Ozw",
		"col-md-12": "_2Ra0jSBt5oY9Z57fkYMcnC",
		"col-md-offset-0": "_1X3oHL0kdWq7zvL_76vhkv",
		"col-md-offset-1": "_25_cdQgA3_kY5EC5bKWciN",
		"col-md-offset-2": "_1uHCHjpGHvBOOt_u0weJev",
		"col-md-offset-3": "_315dBFpay2n4g76NJTJ-Q3",
		"col-md-offset-4": "_1PMtME1xRTHtnFRneQ88u4",
		"col-md-offset-5": "tp6-hCiIWI8W2U-hABtNk",
		"col-md-offset-6": "_3EyyyqL2H_Y-uCMO14zllH",
		"col-md-offset-7": "_2GmS6hcbyjN58qJHZgOU2U",
		"col-md-offset-8": "_3TpoU1TE5au60nlkAW74Q0",
		"col-md-offset-9": "_1np3o9VtPyT8TbHyhTYuC9",
		"col-md-offset-10": "_9xPEhfHL3hfAdJKED_JXL",
		"col-md-offset-11": "_3nE_yleboO-gjpDgf1_NBp",
		"col-md-offset-12": "_1Gkwoe9jwvTIbcTKJ_vZkK",
		"col-lg": "_3MmwEQ1tjnSHm0g6AVF3He",
		"col-lg-1": "_22rtoey2dJzou8G7jTszjL",
		"col-lg-2": "_2l7chbL1253lh4iyBwMe1I",
		"col-lg-3": "x6vB8X8LpawRQI0bMHrhM",
		"col-lg-4": "_1ofrtluqJnBJjHb0OeYhXn",
		"col-lg-5": "_2Hm1RWYupRwE2RIKkAEWN5",
		"col-lg-6": "_2LlvVGUt1vGbBzKlfVPenu",
		"col-lg-7": "_1zzOGcx-FjtemLcfUn4hrg",
		"col-lg-8": "_3_ZRF5owaFPZE0XJ0U6wlN",
		"col-lg-9": "_3Z7TyAAmsr3PIUkDU1GqHA",
		"col-lg-10": "_2_59sin4sfJtahjRg_XTY-",
		"col-lg-11": "_27DA7TdZQKrNK1VeXdRRh9",
		"col-lg-12": "HD_mBhRUhjv1suiDCnXqG",
		"col-lg-offset-0": "_3pRQmPQuWxsoBlq9Izk041",
		"col-lg-offset-1": "_39WeWRU3ZolJVlgK2q8l6X",
		"col-lg-offset-2": "_1ah0hPOZiVa6qoLA_8GMpW",
		"col-lg-offset-3": "_1jNsyL6mzV68lmkhprjqBn",
		"col-lg-offset-4": "-Ta2ee-mJwm_KFgt-JPJA",
		"col-lg-offset-5": "_3BzOIJDp3lwgHfmlqWqj9e",
		"col-lg-offset-6": "_19vLt7uqtRYqE02g8Klwxa",
		"col-lg-offset-7": "Kl2MUZkxRtHRCDJr2MO0B",
		"col-lg-offset-8": "_2Tq95nlGPrOeJwothrxhj8",
		"col-lg-offset-9": "-yJ2vMMOpo3cXFnhef6hu",
		"col-lg-offset-10": "_1FO-L4XMm2JhBOWpwvK0bG",
		"col-lg-offset-11": "_14fZl0Z7XW6LD0xORhIEDE",
		"col-lg-offset-12": "_32eNbFAWa0d3xlLE6EgR98",
		"col-xl": "CCQcUsqfG-ZD98qZ9GlkT",
		"col-xl-1": "_27XbsT7iKe7kzOo4DNbEhR",
		"col-xl-2": "_358ShyEzY-SfH3c0GgB_d6",
		"col-xl-3": "UqveYlOiKXVJ9AZ4-SSwE",
		"col-xl-4": "_2aFDet8K8bZfxHW35yNYz4",
		"col-xl-5": "_2GdtJ1YqyedIEtO9RPLwiP",
		"col-xl-6": "_2g_SAA8uKo3Q3qqm4mDCW2",
		"col-xl-7": "urwOoSl5bWDb-68I9mBD",
		"col-xl-8": "_2e6xPUlLs0kF18Vpepqy2B",
		"col-xl-9": "_2WzT-Sdvnp4HsbkWCLs-ar",
		"col-xl-10": "ftKDqW-8F-MtvfEZBII59",
		"col-xl-11": "_1AZJwNi0kfM6BMwSxVfsGJ",
		"col-xl-12": "fC3BZzvAa8GhoWpajYYav",
		"col-xl-offset-0": "_3amrDmrmuBy3F-KPGVDWpT",
		"col-xl-offset-1": "_2YGYPIKiI0kts1nyctgSuk",
		"col-xl-offset-2": "J2jqNzcUYXQgjfm_72aeV",
		"col-xl-offset-3": "_3DeIC2mO0g9KMadSM_V2XK",
		"col-xl-offset-4": "gjS09F45_-Xu9JeW3LopK",
		"col-xl-offset-5": "_1c0Og4hrdPZXjXRyg9yq6-",
		"col-xl-offset-6": "BeiHuuVvr67dZJc-4FBh1",
		"col-xl-offset-7": "JUmbRkPgpK440xPMLiuAW",
		"col-xl-offset-8": "_1D7U0lzA7cCf5BvGAnrMl9",
		"col-xl-offset-9": "_37uyD-yDewzrc7eShx3lgV",
		"col-xl-offset-10": "_3o6QfVWN64K35rnUKaMpfM",
		"col-xl-offset-11": "uzAaed5oswir300qWShMe",
		"col-xl-offset-12": "_2mUjS6ZPReWf-wNTBtGlqz",
		"start-xs": "_1P1LX-8qQy00dlb1F809KC",
		"center-xs": "_4Yy5n6OiGibWPHk93ASHO",
		"end-xs": "DRHe_zm2lGv7OU0HszO9j",
		"top-xs": "_2mJqAyMzvTXoHJnnJehVXv",
		"middle-xs": "_2i1PAEbtdWJbOLKdyXRfoj",
		"bottom-xs": "_3OhQ9KalsomTyiLSzHAlkp",
		"around-xs": "UX8b_58rNSNJinFJgjSCe",
		"between-xs": "_20qM2Ne70R7il6b39xd00U",
		"first-xs": "h9nO2DpOU_12ycvGW89Dq",
		"last-xs": "JsGZn35MeyJ20H963sCJs",
		"initial-order-xs": "_3qXzT0CVbvx_ydh1ZkgUHL",
		"start-sm": "_2t5CBp_YKMSqSKJuhMRHms",
		"center-sm": "_2sVcN5IgDtZLagc1glT5h4",
		"end-sm": "_1QXhH8LcfJrPhlPUwTKZZM",
		"top-sm": "_16H96O7vl_Gjre2DuDwFw7",
		"middle-sm": "_26rUV4pee3yAgkWCNB20L6",
		"bottom-sm": "_2oUIGbcns3Cktscbgg0KjX",
		"around-sm": "_3eb6ejBZs7jBhepIvEAjQY",
		"between-sm": "_1OwuB8252GBWnOL5T_Wj3E",
		"first-sm": "_1uYdoU_EF20dAqRfBnuwXi",
		"last-sm": "_1DrCCDe1raNZVFVv_jd_ib",
		"initial-order-sm": "XiX4zag1sHKA1PeO-iw6w",
		"start-md": "ogdFtRRbswteY7llKqQ0s",
		"center-md": "_1ETLtkFD2XASe4r54Hif9y",
		"end-md": "_395W4LTrRRRYoH4B6y2WJo",
		"top-md": "_2bZsNf2SZz6vaIHDbk2QTs",
		"middle-md": "_1pB84R4v85xG5Vj4yFqHsr",
		"bottom-md": "_1gZlQ5_CAaJfXKMGFCb_0w",
		"around-md": "_2s3FqyLtMuakcoSmPGOIXd",
		"between-md": "_15r3ne8l-HjGOJH0Vy86SU",
		"first-md": "QO-WtpCgZFP9UrbKj61XV",
		"last-md": "_3C11seSCC13gIvw1Kq5DxY",
		"initial-order-md": "_26QcDRrPMjzOOAFLdW7Bbs",
		"start-lg": "_16-hUe5Nj5lcjRagz_xnCE",
		"center-lg": "_1wg6sd-cxkfLCC5w-Ogxbz",
		"end-lg": "_2yx-klLklkoPD_3YQE4igi",
		"top-lg": "_1LD-cyHwIWPnrFAaKvC7VF",
		"middle-lg": "_2fi4jfKATQbWFCWjZkpI5j",
		"bottom-lg": "_2UDYLANthWfshFBHbj1fl8",
		"around-lg": "_1gRdCoJ5DfGKo74lmQNG3T",
		"between-lg": "mhYrtYphyo8pFPX05GDuK",
		"first-lg": "rmvzXmVPz9FqR1K9lw8yu",
		"last-lg": "P5jr2-Jm5DlkE8LuyNCKd",
		"initial-order-lg": "_3l1jIo12oXQ_CnToqqKZUM",
		"start-xl": "hld1ie7a3YYbjDb-egJ2E",
		"center-xl": "kYyHhW62Sg2UZFgLnu-jK",
		"end-xl": "_3p9CIPgOEXPsKIn98YFrEe",
		"top-xl": "NTLPswV_L5UcVWv0a0M2p",
		"middle-xl": "_1efSBoPeLKzCmlQRwHKYt7",
		"bottom-xl": "_3qoVg8pOSK0tHAYEadRams",
		"around-xl": "kXJs7U3ahgy69-xorBzvg",
		"between-xl": "_2uPcF3MtGNxw6dpvnuziRJ",
		"first-xl": "_3I5NdwxsCcId2k6BW6DV9Q",
		"last-xl": "_26U2QtsMJfKXhPYxi5Y0gw",
		"initial-order-xl": "_3Jgfw3pzyg1mZVveQHlhaZ",
		"hidden-xs": "_3enEz-JE17VdQ-_5bxIn0c",
		"hidden-sm": "cA0GoYVrNnrtgk-FeM_h_",
		"hidden-md": "_29NOTpROMY9yLQLuYC4FEG",
		"hidden-lg": "_3nb8qlQTxGHx2ukvCmVcD8",
		"hidden-xl": "_2ty7Oy3MxFcYXswhjqpJm-"
	};

/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var n=e();for(var r in n)("object"==typeof exports?exports:t)[r]=n[r]}}(this,function(){return function(t){function e(r){if(n[r])return n[r].exports;var o=n[r]={exports:{},id:r,loaded:!1};return t[r].call(o.exports,o,o.exports,e),o.loaded=!0,o.exports}var n={};return e.m=t,e.c=n,e.p="",e(0)}([function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}n(84);var o=n(41),i=r(o),a=function(){i["default"].addPickerToOtherInputs(),i["default"].supportsDateInput()||i["default"].addPickerToDateInputs()};a(),document.addEventListener("DOMContentLoaded",function(){a()}),document.querySelector("body").addEventListener("mousedown",function(){a()})},function(t,e,n){t.exports=!n(11)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,e){var n=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(t,e){var n={}.hasOwnProperty;t.exports=function(t,e){return n.call(t,e)}},function(t,e,n){var r=n(9),o=n(32),i=n(25),a=Object.defineProperty;e.f=n(1)?Object.defineProperty:function(t,e,n){if(r(t),e=i(e,!0),r(n),o)try{return a(t,e,n)}catch(u){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(t[e]=n.value),t}},function(t,e,n){var r=n(59),o=n(16);t.exports=function(t){return r(o(t))}},function(t,e,n){var r=n(4),o=n(14);t.exports=n(1)?function(t,e,n){return r.f(t,e,o(1,n))}:function(t,e,n){return t[e]=n,t}},function(t,e,n){var r=n(23)("wks"),o=n(15),i=n(2).Symbol,a="function"==typeof i,u=t.exports=function(t){return r[t]||(r[t]=a&&i[t]||(a?i:o)("Symbol."+t))};u.store=r},function(t,e){var n=t.exports={version:"2.4.0"};"number"==typeof __e&&(__e=n)},function(t,e,n){var r=n(12);t.exports=function(t){if(!r(t))throw TypeError(t+" is not an object!");return t}},function(t,e,n){var r=n(2),o=n(8),i=n(56),a=n(6),u="prototype",s=function(t,e,n){var c,l,f,d=t&s.F,p=t&s.G,h=t&s.S,y=t&s.P,m=t&s.B,v=t&s.W,b=p?o:o[e]||(o[e]={}),g=b[u],x=p?r:h?r[e]:(r[e]||{})[u];p&&(n=e);for(c in n)l=!d&&x&&void 0!==x[c],l&&c in b||(f=l?x[c]:n[c],b[c]=p&&"function"!=typeof x[c]?n[c]:m&&l?i(f,r):v&&x[c]==f?function(t){var e=function(e,n,r){if(this instanceof t){switch(arguments.length){case 0:return new t;case 1:return new t(e);case 2:return new t(e,n)}return new t(e,n,r)}return t.apply(this,arguments)};return e[u]=t[u],e}(f):y&&"function"==typeof f?i(Function.call,f):f,y&&((b.virtual||(b.virtual={}))[c]=f,t&s.R&&g&&!g[c]&&a(g,c,f)))};s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,s.U=64,s.R=128,t.exports=s},function(t,e){t.exports=function(t){try{return!!t()}catch(e){return!0}}},function(t,e){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,e,n){var r=n(38),o=n(17);t.exports=Object.keys||function(t){return r(t,o)}},function(t,e){t.exports=function(t,e){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:e}}},function(t,e){var n=0,r=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++n+r).toString(36))}},function(t,e){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,e){t.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(t,e){t.exports={}},function(t,e){t.exports=!0},function(t,e){e.f={}.propertyIsEnumerable},function(t,e,n){var r=n(4).f,o=n(3),i=n(7)("toStringTag");t.exports=function(t,e,n){t&&!o(t=n?t:t.prototype,i)&&r(t,i,{configurable:!0,value:e})}},function(t,e,n){var r=n(23)("keys"),o=n(15);t.exports=function(t){return r[t]||(r[t]=o(t))}},function(t,e,n){var r=n(2),o="__core-js_shared__",i=r[o]||(r[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,e){var n=Math.ceil,r=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?r:n)(t)}},function(t,e,n){var r=n(12);t.exports=function(t,e){if(!r(t))return t;var n,o;if(e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;if("function"==typeof(n=t.valueOf)&&!r(o=n.call(t)))return o;if(!e&&"function"==typeof(n=t.toString)&&!r(o=n.call(t)))return o;throw TypeError("Can't convert object to primitive value")}},function(t,e,n){var r=n(2),o=n(8),i=n(19),a=n(27),u=n(4).f;t.exports=function(t){var e=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==t.charAt(0)||t in e||u(e,t,{value:a.f(t)})}},function(t,e,n){e.f=n(7)},function(t,e){"use strict";e.__esModule=!0,e["default"]=function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}e.__esModule=!0;var o=n(45),i=r(o);e["default"]=function(){function t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),(0,i["default"])(t,r.key,r)}}return function(e,n,r){return n&&t(e.prototype,n),r&&t(e,r),e}}()},function(t,e){var n={}.toString;t.exports=function(t){return n.call(t).slice(8,-1)}},function(t,e,n){var r=n(12),o=n(2).document,i=r(o)&&r(o.createElement);t.exports=function(t){return i?o.createElement(t):{}}},function(t,e,n){t.exports=!n(1)&&!n(11)(function(){return 7!=Object.defineProperty(n(31)("div"),"a",{get:function(){return 7}}).a})},function(t,e,n){"use strict";var r=n(19),o=n(10),i=n(39),a=n(6),u=n(3),s=n(18),c=n(61),l=n(21),f=n(67),d=n(7)("iterator"),p=!([].keys&&"next"in[].keys()),h="@@iterator",y="keys",m="values",v=function(){return this};t.exports=function(t,e,n,b,g,x,M){c(n,e,b);var w,S,O,D=function(t){if(!p&&t in k)return k[t];switch(t){case y:return function(){return new n(this,t)};case m:return function(){return new n(this,t)}}return function(){return new n(this,t)}},T=e+" Iterator",_=g==m,A=!1,k=t.prototype,E=k[d]||k[h]||g&&k[g],j=E||D(g),C=g?_?D("entries"):j:void 0,N="Array"==e?k.entries||E:E;if(N&&(O=f(N.call(new t)),O!==Object.prototype&&(l(O,T,!0),r||u(O,d)||a(O,d,v))),_&&E&&E.name!==m&&(A=!0,j=function(){return E.call(this)}),r&&!M||!p&&!A&&k[d]||a(k,d,j),s[e]=j,s[T]=v,g)if(w={values:_?j:D(m),keys:x?j:D(y),entries:C},M)for(S in w)S in k||i(k,S,w[S]);else o(o.P+o.F*(p||A),e,w);return w}},function(t,e,n){var r=n(9),o=n(35),i=n(17),a=n(22)("IE_PROTO"),u=function(){},s="prototype",c=function(){var t,e=n(31)("iframe"),r=i.length,o="<",a=">";for(e.style.display="none",n(58).appendChild(e),e.src="javascript:",t=e.contentWindow.document,t.open(),t.write(o+"script"+a+"document.F=Object"+o+"/script"+a),t.close(),c=t.F;r--;)delete c[s][i[r]];return c()};t.exports=Object.create||function(t,e){var n;return null!==t?(u[s]=r(t),n=new u,u[s]=null,n[a]=t):n=c(),void 0===e?n:o(n,e)}},function(t,e,n){var r=n(4),o=n(9),i=n(13);t.exports=n(1)?Object.defineProperties:function(t,e){o(t);for(var n,a=i(e),u=a.length,s=0;u>s;)r.f(t,n=a[s++],e[n]);return t}},function(t,e,n){var r=n(38),o=n(17).concat("length","prototype");e.f=Object.getOwnPropertyNames||function(t){return r(t,o)}},function(t,e){e.f=Object.getOwnPropertySymbols},function(t,e,n){var r=n(3),o=n(5),i=n(55)(!1),a=n(22)("IE_PROTO");t.exports=function(t,e){var n,u=o(t),s=0,c=[];for(n in u)n!=a&&r(u,n)&&c.push(n);for(;e.length>s;)r(u,n=e[s++])&&(~i(c,n)||c.push(n));return c}},function(t,e,n){t.exports=n(6)},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}function o(t,e){for(t=String(t),e=e||2;t.length<e;)t="0"+t;return t}function i(t){var e=new Date(t.getFullYear(),t.getMonth(),t.getDate());e.setDate(e.getDate()-(e.getDay()+6)%7+3);var n=new Date(e.getFullYear(),0,4);n.setDate(n.getDate()-(n.getDay()+6)%7+3);var r=e.getTimezoneOffset()-n.getTimezoneOffset();e.setHours(e.getHours()-r);var o=(e-n)/6048e5;return 1+Math.floor(o)}function a(t){var e=t.getDay();return 0===e&&(e=7),e}function u(t){return null===t?"null":void 0===t?"undefined":"object"!==("undefined"==typeof t?"undefined":(0,c["default"])(t))?"undefined"==typeof t?"undefined":(0,c["default"])(t):Array.isArray(t)?"array":{}.toString.call(t).slice(8,-1).toLowerCase()}Object.defineProperty(e,"__esModule",{value:!0});var s=n(48),c=r(s),l=function(){var t=/d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|'[^']*'|'[^']*'/g,e=/\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,n=/[^-+\dA-Z]/g;return function(r,s,c,f){if(1!==arguments.length||"string"!==u(r)||/\d/.test(r)||(s=r,r=void 0),r=r||new Date,r instanceof Date||(r=new Date(r)),isNaN(r))throw TypeError("Invalid date");s=String(l.masks[s]||s||l.masks["default"]);var d=s.slice(0,4);"UTC:"!==d&&"GMT:"!==d||(s=s.slice(4),c=!0,"GMT:"===d&&(f=!0));var p=c?"getUTC":"get",h=r[p+"Date"](),y=r[p+"Day"](),m=r[p+"Month"](),v=r[p+"FullYear"](),b=r[p+"Hours"](),g=r[p+"Minutes"](),x=r[p+"Seconds"](),M=r[p+"Milliseconds"](),w=c?0:r.getTimezoneOffset(),S=i(r),O=a(r),D={d:h,dd:o(h),ddd:l.i18n.dayNames[y],dddd:l.i18n.dayNames[y+7],m:m+1,mm:o(m+1),mmm:l.i18n.monthNames[m],mmmm:l.i18n.monthNames[m+12],yy:String(v).slice(2),yyyy:v,h:b%12||12,hh:o(b%12||12),H:b,HH:o(b),M:g,MM:o(g),s:x,ss:o(x),l:o(M,3),L:o(Math.round(M/10)),t:b<12?"a":"p",tt:b<12?"am":"pm",T:b<12?"A":"P",TT:b<12?"AM":"PM",Z:f?"GMT":c?"UTC":(String(r).match(e)||[""]).pop().replace(n,""),o:(w>0?"-":"+")+o(100*Math.floor(Math.abs(w)/60)+Math.abs(w)%60,4),S:["th","st","nd","rd"][h%10>3?0:(h%100-h%10!=10)*h%10],W:S,N:O};return s.replace(t,function(t){return t in D?D[t]:t.slice(1,t.length-1)})}}();l.masks={"default":"ddd mmm dd yyyy HH:MM:ss",shortDate:"m/d/yy",mediumDate:"mmm d, yyyy",longDate:"mmmm d, yyyy",fullDate:"dddd, mmmm d, yyyy",shortTime:"h:MM TT",mediumTime:"h:MM:ss TT",longTime:"h:MM:ss TT Z",isoDate:"yyyy-mm-dd",isoTime:"HH:MM:ss",isoDateTime:"yyyy-mm-dd'T'HH:MM:sso",isoUtcDateTime:"UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",expiresHeaderFormat:"ddd, dd mmm yyyy HH:MM:ss Z"},l.i18n={dayNames:["Sun","Mon","Tue","Wed","Thu","Fri","Sat","Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],monthNames:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec","January","February","March","April","May","June","July","August","September","October","November","December"]},e["default"]=l},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(44),i=r(o),a=n(28),u=r(a),s=n(29),c=r(s),l=n(43),f=r(l),d=n(42),p=r(d),h=n(40),y=r(h),m=function(){function t(e){var n=this;(0,u["default"])(this,t),this.element=e,this.element.setAttribute("data-has-picker",""),this.locale=this.element.getAttribute("lang")||document.body.getAttribute("lang")||"en",this.format=this.element.getAttribute("date-format")||document.body.getAttribute("date-format")||this.element.getAttribute("data-date-format")||document.body.getAttribute("data-date-format")||"yyyy-mm-dd",this.localeText=this.getLocaleText(),(0,i["default"])(this.element,{valueAsDate:{get:function(){if(!n.element.value)return null;var t=n.format||"yyyy-mm-dd",e=n.element.value.match(/(\d+)/g),r=0,o={};return t.replace(/(yyyy|dd|mm)/g,function(t){o[t]=r++}),new Date(e[o.yyyy],e[o.mm]-1,e[o.dd])},set:function(t){n.element.value=(0,y["default"])(t,n.format)}},valueAsNumber:{get:function(){return n.element.value?n.element.valueAsDate.valueOf():NaN},set:function(t){n.element.valueAsDate=new Date(t)}}});var r=function(t){var e=n.element;e.locale=n.localeText,f["default"].attachTo(e)};this.element.addEventListener("focus",r),this.element.addEventListener("mouseup",r),this.element.addEventListener("keydown",function(t){var e=new Date;switch(t.keyCode){case 9:case 27:f["default"].hide();break;case 38:n.element.valueAsDate&&(e.setDate(n.element.valueAsDate.getDate()+1),n.element.valueAsDate=e,f["default"].pingInput());break;case 40:n.element.valueAsDate&&(e.setDate(n.element.valueAsDate.getDate()-1),n.element.valueAsDate=e,f["default"].pingInput())}f["default"].sync()}),this.element.addEventListener("keyup",function(t){f["default"].sync()})}return(0,c["default"])(t,[{key:"getLocaleText",value:function(){var t=this.locale.toLowerCase();for(var e in p["default"]){var n=e.split("_");if(n.map(function(t){return t.toLowerCase()}),~n.indexOf(t)||~n.indexOf(t.substr(0,2)))return p["default"][e]}}}],[{key:"supportsDateInput",value:function(){var t=document.createElement("input");t.setAttribute("type","date");var e="not-a-date";return t.setAttribute("value",e),!(t.value===e)}},{key:"addPickerToDateInputs",value:function(){var e=document.querySelectorAll('input[type="date"]:not([data-has-picker])'),n=e.length;if(!n)return!1;for(var r=0;r<n;++r)new t(e[r])}},{key:"addPickerToOtherInputs",value:function(){var e=document.querySelectorAll('input[type="text"].date-polyfill:not([data-has-picker])'),n=e.length;if(!n)return!1;for(var r=0;r<n;++r)new t(e[r])}}]),t}();e["default"]=m},function(t,e){"use strict";Object.defineProperty(e,"__esModule",{value:!0});var n={"en_en-US_en-UK":{days:["Su","Mo","Tu","We","Th","Fr","Sa"],months:["January","February","March","April","May","June","July","August","September","October","November","December"]},"zh_zh-CN":{days:["星期天","星期一","星期二","星期三","星期四","星期五","星期六"],months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]},"zh-Hans_zh-Hans-CN":{days:["周日","周一","周二","周三","周四","周五","周六"],months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]},"zh-Hant_zh-Hant-TW":{days:["週日","週一","週二","週三","週四","週五","週六"],months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"]},"de_de-DE":{days:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],months:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"]},"nl_nl-NL_nl-BE":{days:["Zondag","Maandag","Dinsdag","Woensdag","Donderdag","Vrijdag","Zaterdag"],months:["Januari","Februari","Maart","April","Mei","Juni","Juli","Augustus","September","Oktober","November","December"],today:"Vandaag",format:"D/M/Y"},"pt_pt-BR":{days:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],months:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],today:"Hoje"},"fr_fr-FR_fr-BE":{days:["Di","Lu","Ma","Me","Je","Ve","Sa"],months:["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],today:"Aujourd'hui",format:"D/M/Y"},"es_es-VE":{days:["Do","Lu","Ma","Mi","Ju","Vi","Sa"],months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],today:"Hoy",format:"D/M/Y"},"da_da-dk":{days:["Søndag","Mandag","Tirsdag","Onsdag","Torsdag","Fredag","Lørdag"],months:["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],today:"I dag",format:"dd/MM-YYYY"},"ru_ru-RU_ru-UA_ru-KZ_ru-MD":{days:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],today:"Сегодня",format:"D.M.Y"},"uk_uk-UA":{days:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"],months:["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],today:"Cьогодні",format:"D.M.Y"},"sv_sv-SE":{days:["Söndag","Måndag","Tisdag","Onsdag","Torsdag","Fredag","Lördag"],months:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],today:"Idag",format:"YYYY-MM-dd"},"test_test-TEST":{days:["Foo","Mon","Tue","Wed","Thu","Fri","Sat"],months:["Foo","February","March","April","May","June","July","August","September","October","November","December"]},ja:{days:["日","月","火","水","木","金","土"],months:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],today:"今日",format:"YYYY-MM-dd"}};e["default"]=n},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}Object.defineProperty(e,"__esModule",{value:!0});var o=n(28),i=r(o),a=n(29),u=r(a),s=function(){function t(){var e=this;if((0,i["default"])(this,t),window.thePicker)return window.thePicker;this.date=new Date,this.input=null,this.isOpen=!1,this.container=document.createElement("date-input-polyfill"),this.year=document.createElement("select"),t.createRangeSelect(this.year,1890,this.date.getFullYear()+20),this.year.className="yearSelect",this.year.addEventListener("change",function(){e.date.setYear(e.year.value),e.refreshDaysMatrix()});var n=document.createElement("span");n.className="yearSelect-wrapper",n.appendChild(this.year),this.container.appendChild(n),this.month=document.createElement("select"),this.month.className="monthSelect",this.month.addEventListener("change",function(){e.date.setMonth(e.month.value),e.refreshDaysMatrix()});var r=document.createElement("span");r.className="monthSelect-wrapper",r.appendChild(this.month),this.container.appendChild(r),this.today=document.createElement("button"),this.today.textContent="Today",this.today.addEventListener("click",function(){var t=new Date;e.date=new Date(t.getFullYear()+"/"+("0"+(t.getMonth()+1)).slice(-2)+"/"+("0"+t.getDate()).slice(-2)),e.setInput()}),this.container.appendChild(this.today);var o=document.createElement("table");this.daysHead=document.createElement("thead"),this.days=document.createElement("tbody"),this.days.addEventListener("click",function(t){var n=t.target;if(!n.hasAttribute("data-day"))return!1;var r=e.days.querySelector("[data-selected]");r&&r.removeAttribute("data-selected"),n.setAttribute("data-selected",""),e.date.setDate(parseInt(n.textContent)),e.setInput()}),o.appendChild(this.daysHead),o.appendChild(this.days),this.container.appendChild(o),this.hide(),document.body.appendChild(this.container),this.removeClickOut=function(t){if(e.isOpen){for(var n=t.target,r=n===e.container||n===e.input;!r&&(n=n.parentNode);)r=n===e.container;("date"!==t.target.getAttribute("type")&&!r||!r)&&e.hide()}},this.removeBlur=function(t){e.isOpen&&e.hide()}}return(0,u["default"])(t,[{key:"hide",value:function(){this.container.setAttribute("data-open",this.isOpen=!1),this.input&&this.input.blur(),document.removeEventListener("mousedown",this.removeClickOut),document.removeEventListener("touchstart",this.removeClickOut)}},{key:"show",value:function(){var t=this;this.container.setAttribute("data-open",this.isOpen=!0),setTimeout(function(){document.addEventListener("mousedown",t.removeClickOut),document.addEventListener("touchstart",t.removeClickOut)},500),window.onpopstate=function(){t.hide()}}},{key:"goto",value:function(t){var e=this,n=t.getBoundingClientRect();this.container.style.top=n.top+n.height+(document.documentElement.scrollTop||document.body.scrollTop)+3+"px";var r=this.container.getBoundingClientRect(),o=r.width?r.width:280,i=function(){return e.container.className.replace("polyfill-left-aligned","").replace("polyfill-right-aligned","").replace(/\s+/g," ").trim()},a=n.right-o;n.right<o?(a=n.left,this.container.className=i()+" polyfill-left-aligned"):this.container.className=i()+" polyfill-right-aligned",this.container.style.left=a+(document.documentElement.scrollLeft||document.body.scrollLeft)+"px",this.show()}},{key:"attachTo",value:function(t){return!(t===this.input&&this.isOpen||(this.input=t,this.refreshLocale(),this.sync(),this["goto"](this.input),0))}},{key:"sync",value:function(){isNaN(Date.parse(this.input.valueAsDate))?this.date=new Date:this.date=t.absoluteDate(this.input.valueAsDate),this.year.value=this.date.getFullYear(),this.month.value=this.date.getMonth(),this.refreshDaysMatrix()}},{key:"setInput",value:function(){var t=this;this.input.valueAsDate=this.date,this.input.focus(),setTimeout(function(){t.hide()},100),this.pingInput()}},{key:"refreshLocale",value:function(){if(this.locale===this.input.locale)return!1;this.locale=this.input.locale,this.today.textContent=this.locale.today||"Today";for(var e=["<tr>"],n=0,r=this.locale.days.length;n<r;++n)e.push('<th scope="col">'+this.locale.days[n]+"</th>");this.daysHead.innerHTML=e.join(""),t.createRangeSelect(this.month,0,11,this.locale.months)}},{key:"refreshDaysMatrix",value:function(){this.refreshLocale();for(var e=this.date.getFullYear(),n=this.date.getMonth(),r=new Date(e,n,1).getDay(),o=new Date(this.date.getFullYear(),n+1,0).getDate(),i=t.absoluteDate(this.input.valueAsDate)||!1,a=i&&e===i.getFullYear()&&n===i.getMonth(),u=[],s=0;s<o+r;++s)if(s%7===0&&u.push("\n          "+(0!==s?"</tr>":"")+"\n          <tr>\n        "),s+1<=r)u.push("<td></td>");else{var c=s+1-r,l=a&&i.getDate()===c;u.push("<td data-day "+(l?"data-selected":"")+">\n          "+c+"\n        </td>")}this.days.innerHTML=u.join("")}},{key:"pingInput",value:function(){var t=void 0,e=void 0;try{t=new Event("input"),e=new Event("change")}catch(n){t=document.createEvent("KeyboardEvent"),t.initEvent("input",!0,!1),e=document.createEvent("KeyboardEvent"),e.initEvent("change",!0,!1)}this.input.dispatchEvent(t),this.input.dispatchEvent(e)}}],[{key:"createRangeSelect",value:function(t,e,n,r){t.innerHTML="";for(var o=e;o<=n;++o){var i=document.createElement("option");t.appendChild(i);var a=r?r[o-e]:o;i.text=a,i.value=o}return t}},{key:"absoluteDate",value:function(t){return t&&new Date(t.getTime()+60*t.getTimezoneOffset()*1e3)}}]),t}();window.thePicker=new s,e["default"]=window.thePicker},function(t,e,n){t.exports={"default":n(49),__esModule:!0}},function(t,e,n){t.exports={"default":n(50),__esModule:!0}},function(t,e,n){t.exports={"default":n(51),__esModule:!0}},function(t,e,n){t.exports={"default":n(52),__esModule:!0}},function(t,e,n){"use strict";function r(t){return t&&t.__esModule?t:{"default":t}}e.__esModule=!0;var o=n(47),i=r(o),a=n(46),u=r(a),s="function"==typeof u["default"]&&"symbol"==typeof i["default"]?function(t){return typeof t}:function(t){return t&&"function"==typeof u["default"]&&t.constructor===u["default"]?"symbol":typeof t};e["default"]="function"==typeof u["default"]&&"symbol"===s(i["default"])?function(t){return"undefined"==typeof t?"undefined":s(t)}:function(t){return t&&"function"==typeof u["default"]&&t.constructor===u["default"]?"symbol":"undefined"==typeof t?"undefined":s(t)}},function(t,e,n){n(73);var r=n(8).Object;t.exports=function(t,e){return r.defineProperties(t,e)}},function(t,e,n){n(74);var r=n(8).Object;t.exports=function(t,e,n){return r.defineProperty(t,e,n)}},function(t,e,n){n(77),n(75),n(78),n(79),t.exports=n(8).Symbol},function(t,e,n){n(76),n(80),t.exports=n(27).f("iterator")},function(t,e){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,e){t.exports=function(){}},function(t,e,n){var r=n(5),o=n(70),i=n(69);t.exports=function(t){return function(e,n,a){var u,s=r(e),c=o(s.length),l=i(a,c);if(t&&n!=n){for(;c>l;)if(u=s[l++],u!=u)return!0}else for(;c>l;l++)if((t||l in s)&&s[l]===n)return t||l||0;return!t&&-1}}},function(t,e,n){var r=n(53);t.exports=function(t,e,n){if(r(t),void 0===e)return t;switch(n){case 1:return function(n){return t.call(e,n)};case 2:return function(n,r){return t.call(e,n,r)};case 3:return function(n,r,o){return t.call(e,n,r,o)}}return function(){return t.apply(e,arguments)}}},function(t,e,n){var r=n(13),o=n(37),i=n(20);t.exports=function(t){var e=r(t),n=o.f;if(n)for(var a,u=n(t),s=i.f,c=0;u.length>c;)s.call(t,a=u[c++])&&e.push(a);return e}},function(t,e,n){t.exports=n(2).document&&document.documentElement},function(t,e,n){var r=n(30);t.exports=Object("z").propertyIsEnumerable(0)?Object:function(t){return"String"==r(t)?t.split(""):Object(t)}},function(t,e,n){var r=n(30);t.exports=Array.isArray||function(t){return"Array"==r(t)}},function(t,e,n){"use strict";var r=n(34),o=n(14),i=n(21),a={};n(6)(a,n(7)("iterator"),function(){return this}),t.exports=function(t,e,n){t.prototype=r(a,{next:o(1,n)}),i(t,e+" Iterator")}},function(t,e){t.exports=function(t,e){return{value:e,done:!!t}}},function(t,e,n){var r=n(13),o=n(5);t.exports=function(t,e){for(var n,i=o(t),a=r(i),u=a.length,s=0;u>s;)if(i[n=a[s++]]===e)return n}},function(t,e,n){var r=n(15)("meta"),o=n(12),i=n(3),a=n(4).f,u=0,s=Object.isExtensible||function(){return!0},c=!n(11)(function(){return s(Object.preventExtensions({}))}),l=function(t){a(t,r,{value:{i:"O"+ ++u,w:{}}})},f=function(t,e){if(!o(t))return"symbol"==typeof t?t:("string"==typeof t?"S":"P")+t;if(!i(t,r)){if(!s(t))return"F";if(!e)return"E";l(t)}return t[r].i},d=function(t,e){if(!i(t,r)){if(!s(t))return!0;if(!e)return!1;l(t)}return t[r].w},p=function(t){return c&&h.NEED&&s(t)&&!i(t,r)&&l(t),t},h=t.exports={KEY:r,NEED:!1,fastKey:f,getWeak:d,onFreeze:p}},function(t,e,n){var r=n(20),o=n(14),i=n(5),a=n(25),u=n(3),s=n(32),c=Object.getOwnPropertyDescriptor;e.f=n(1)?c:function(t,e){if(t=i(t),e=a(e,!0),s)try{return c(t,e)}catch(n){}if(u(t,e))return o(!r.f.call(t,e),t[e])}},function(t,e,n){var r=n(5),o=n(36).f,i={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],u=function(t){try{return o(t)}catch(e){return a.slice()}};t.exports.f=function(t){return a&&"[object Window]"==i.call(t)?u(t):o(r(t))}},function(t,e,n){var r=n(3),o=n(71),i=n(22)("IE_PROTO"),a=Object.prototype;t.exports=Object.getPrototypeOf||function(t){return t=o(t),r(t,i)?t[i]:"function"==typeof t.constructor&&t instanceof t.constructor?t.constructor.prototype:t instanceof Object?a:null}},function(t,e,n){var r=n(24),o=n(16);t.exports=function(t){return function(e,n){var i,a,u=String(o(e)),s=r(n),c=u.length;return s<0||s>=c?t?"":void 0:(i=u.charCodeAt(s),i<55296||i>56319||s+1===c||(a=u.charCodeAt(s+1))<56320||a>57343?t?u.charAt(s):i:t?u.slice(s,s+2):(i-55296<<10)+(a-56320)+65536)}}},function(t,e,n){var r=n(24),o=Math.max,i=Math.min;t.exports=function(t,e){return t=r(t),t<0?o(t+e,0):i(t,e)}},function(t,e,n){var r=n(24),o=Math.min;t.exports=function(t){return t>0?o(r(t),9007199254740991):0}},function(t,e,n){var r=n(16);t.exports=function(t){return Object(r(t))}},function(t,e,n){"use strict";var r=n(54),o=n(62),i=n(18),a=n(5);t.exports=n(33)(Array,"Array",function(t,e){this._t=a(t),this._i=0,this._k=e},function(){var t=this._t,e=this._k,n=this._i++;return!t||n>=t.length?(this._t=void 0,o(1)):"keys"==e?o(0,n):"values"==e?o(0,t[n]):o(0,[n,t[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(t,e,n){var r=n(10);r(r.S+r.F*!n(1),"Object",{defineProperties:n(35)})},function(t,e,n){var r=n(10);r(r.S+r.F*!n(1),"Object",{defineProperty:n(4).f})},function(t,e){},function(t,e,n){"use strict";var r=n(68)(!0);n(33)(String,"String",function(t){this._t=String(t),this._i=0},function(){var t,e=this._t,n=this._i;return n>=e.length?{value:void 0,done:!0}:(t=r(e,n),this._i+=t.length,{value:t,done:!1})})},function(t,e,n){"use strict";var r=n(2),o=n(3),i=n(1),a=n(10),u=n(39),s=n(64).KEY,c=n(11),l=n(23),f=n(21),d=n(15),p=n(7),h=n(27),y=n(26),m=n(63),v=n(57),b=n(60),g=n(9),x=n(5),M=n(25),w=n(14),S=n(34),O=n(66),D=n(65),T=n(4),_=n(13),A=D.f,k=T.f,E=O.f,j=r.Symbol,C=r.JSON,N=C&&C.stringify,L="prototype",P=p("_hidden"),F=p("toPrimitive"),J={}.propertyIsEnumerable,H=l("symbol-registry"),I=l("symbols"),Y=l("op-symbols"),R=Object[L],z="function"==typeof j,U=r.QObject,B=!U||!U[L]||!U[L].findChild,W=i&&c(function(){return 7!=S(k({},"a",{get:function(){return k(this,"a",{value:7}).a}})).a})?function(t,e,n){var r=A(R,e);r&&delete R[e],k(t,e,n),r&&t!==R&&k(R,e,r)}:k,Z=function(t){var e=I[t]=S(j[L]);return e._k=t,e},G=z&&"symbol"==typeof j.iterator?function(t){return"symbol"==typeof t}:function(t){return t instanceof j},K=function(t,e,n){return t===R&&K(Y,e,n),g(t),e=M(e,!0),g(n),o(I,e)?(n.enumerable?(o(t,P)&&t[P][e]&&(t[P][e]=!1),n=S(n,{enumerable:w(0,!1)})):(o(t,P)||k(t,P,w(1,{})),t[P][e]=!0),W(t,e,n)):k(t,e,n)},V=function(t,e){g(t);for(var n,r=v(e=x(e)),o=0,i=r.length;i>o;)K(t,n=r[o++],e[n]);return t},q=function(t,e){return void 0===e?S(t):V(S(t),e)},Q=function(t){var e=J.call(this,t=M(t,!0));return!(this===R&&o(I,t)&&!o(Y,t))&&(!(e||!o(this,t)||!o(I,t)||o(this,P)&&this[P][t])||e)},X=function(t,e){if(t=x(t),e=M(e,!0),t!==R||!o(I,e)||o(Y,e)){var n=A(t,e);return!n||!o(I,e)||o(t,P)&&t[P][e]||(n.enumerable=!0),n}},$=function(t){for(var e,n=E(x(t)),r=[],i=0;n.length>i;)o(I,e=n[i++])||e==P||e==s||r.push(e);return r},tt=function(t){for(var e,n=t===R,r=E(n?Y:x(t)),i=[],a=0;r.length>a;)!o(I,e=r[a++])||n&&!o(R,e)||i.push(I[e]);return i};z||(j=function(){if(this instanceof j)throw TypeError("Symbol is not a constructor!");var t=d(arguments.length>0?arguments[0]:void 0),e=function(n){this===R&&e.call(Y,n),o(this,P)&&o(this[P],t)&&(this[P][t]=!1),W(this,t,w(1,n))};return i&&B&&W(R,t,{configurable:!0,set:e}),Z(t)},u(j[L],"toString",function(){return this._k}),D.f=X,T.f=K,n(36).f=O.f=$,n(20).f=Q,n(37).f=tt,i&&!n(19)&&u(R,"propertyIsEnumerable",Q,!0),h.f=function(t){return Z(p(t))}),a(a.G+a.W+a.F*!z,{Symbol:j});for(var et="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),nt=0;et.length>nt;)p(et[nt++]);for(var et=_(p.store),nt=0;et.length>nt;)y(et[nt++]);a(a.S+a.F*!z,"Symbol",{"for":function(t){return o(H,t+="")?H[t]:H[t]=j(t)},keyFor:function(t){if(G(t))return m(H,t);throw TypeError(t+" is not a symbol!")},useSetter:function(){B=!0},useSimple:function(){B=!1}}),a(a.S+a.F*!z,"Object",{create:q,defineProperty:K,defineProperties:V,getOwnPropertyDescriptor:X,getOwnPropertyNames:$,getOwnPropertySymbols:tt}),C&&a(a.S+a.F*(!z||c(function(){var t=j();return"[null]"!=N([t])||"{}"!=N({a:t})||"{}"!=N(Object(t))})),"JSON",{stringify:function(t){if(void 0!==t&&!G(t)){for(var e,n,r=[t],o=1;arguments.length>o;)r.push(arguments[o++]);return e=r[1],"function"==typeof e&&(n=e),!n&&b(e)||(e=function(t,e){if(n&&(e=n.call(this,t,e)),!G(e))return e}),r[1]=e,N.apply(C,r)}}}),j[L][F]||n(6)(j[L],F,j[L].valueOf),f(j,"Symbol"),f(Math,"Math",!0),f(r.JSON,"JSON",!0)},function(t,e,n){n(26)("asyncIterator")},function(t,e,n){n(26)("observable")},function(t,e,n){n(72);for(var r=n(2),o=n(6),i=n(18),a=n(7)("toStringTag"),u=["NodeList","DOMTokenList","MediaList","StyleSheetList","CSSRuleList"],s=0;s<5;s++){var c=u[s],l=r[c],f=l&&l.prototype;f&&!f[a]&&o(f,a,c),i[c]=i.Array}},function(t,e,n){e=t.exports=n(82)(),e.push([t.id,"date-input-polyfill{background:#fff;color:#000;text-shadow:none;border:0;padding:0;height:auto;width:auto;line-height:normal;font-family:sans-serif;font-size:14px;position:absolute!important;text-align:center;box-shadow:0 3px 10px 1px rgba(0,0,0,.22);cursor:default;z-index:1;border-radius:5px;-moz-border-radius:5px;-webkit-border-radius:5px;overflow:hidden;display:block}date-input-polyfill[data-open=false]{visibility:hidden;z-index:-100!important;top:0}date-input-polyfill[data-open=true]{visibility:visible}date-input-polyfill select,date-input-polyfill table,date-input-polyfill td,date-input-polyfill th{background:#fff;color:#000;text-shadow:none;border:0;padding:0;height:auto;width:auto;line-height:normal;font-family:sans-serif;font-size:14px;box-shadow:none;font-family:Lato,Helvetica,Arial,sans-serif}date-input-polyfill button,date-input-polyfill select{border:0;border-radius:0;border-bottom:1px solid #dadfe1;height:24px;vertical-align:top;-webkit-appearance:none;-moz-appearance:none}date-input-polyfill .monthSelect-wrapper{width:55%;display:inline-block}date-input-polyfill .yearSelect-wrapper{width:25%;display:inline-block}date-input-polyfill select{width:100%}date-input-polyfill select:first-of-type{border-right:1px solid #dadfe1;border-radius:5px 0 0 0;-moz-border-radius:5px 0 0 0;-webkit-border-radius:5px 0 0 0}date-input-polyfill button{width:20%;background:#dadfe1;border-radius:0 5px 0 0;-moz-border-radius:0 5px 0 0;-webkit-border-radius:0 5px 0 0}date-input-polyfill button:hover{background:#eee}date-input-polyfill table{border-collapse:separate!important;border-radius:0 0 5px 5px;-moz-border-radius:0 0 5px 5px;-webkit-border-radius:0 0 5px 5px;overflow:hidden;max-width:280px;width:280px}date-input-polyfill td,date-input-polyfill th{width:32px;padding:4px;text-align:center;box-sizing:content-box}date-input-polyfill td[data-day]{cursor:pointer}date-input-polyfill td[data-day]:hover{background:#dadfe1}date-input-polyfill [data-selected]{font-weight:700;background:#d8eaf6}",""]);
	},function(t,e){t.exports=function(){var t=[];return t.toString=function(){for(var t=[],e=0;e<this.length;e++){var n=this[e];n[2]?t.push("@media "+n[2]+"{"+n[1]+"}"):t.push(n[1])}return t.join("")},t.i=function(e,n){"string"==typeof e&&(e=[[null,e,""]]);for(var r={},o=0;o<this.length;o++){var i=this[o][0];"number"==typeof i&&(r[i]=!0)}for(o=0;o<e.length;o++){var a=e[o];"number"==typeof a[0]&&r[a[0]]||(n&&!a[2]?a[2]=n:n&&(a[2]="("+a[2]+") and ("+n+")"),t.push(a))}},t}},function(t,e,n){function r(t,e){for(var n=0;n<t.length;n++){var r=t[n],o=p[r.id];if(o){o.refs++;for(var i=0;i<o.parts.length;i++)o.parts[i](r.parts[i]);for(;i<r.parts.length;i++)o.parts.push(c(r.parts[i],e))}else{for(var a=[],i=0;i<r.parts.length;i++)a.push(c(r.parts[i],e));p[r.id]={id:r.id,refs:1,parts:a}}}}function o(t){for(var e=[],n={},r=0;r<t.length;r++){var o=t[r],i=o[0],a=o[1],u=o[2],s=o[3],c={css:a,media:u,sourceMap:s};n[i]?n[i].parts.push(c):e.push(n[i]={id:i,parts:[c]})}return e}function i(t,e){var n=m(),r=g[g.length-1];if("top"===t.insertAt)r?r.nextSibling?n.insertBefore(e,r.nextSibling):n.appendChild(e):n.insertBefore(e,n.firstChild),g.push(e);else{if("bottom"!==t.insertAt)throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");n.appendChild(e)}}function a(t){t.parentNode.removeChild(t);var e=g.indexOf(t);e>=0&&g.splice(e,1)}function u(t){var e=document.createElement("style");return e.type="text/css",i(t,e),e}function s(t){var e=document.createElement("link");return e.rel="stylesheet",i(t,e),e}function c(t,e){var n,r,o;if(e.singleton){var i=b++;n=v||(v=u(e)),r=l.bind(null,n,i,!1),o=l.bind(null,n,i,!0)}else t.sourceMap&&"function"==typeof URL&&"function"==typeof URL.createObjectURL&&"function"==typeof URL.revokeObjectURL&&"function"==typeof Blob&&"function"==typeof btoa?(n=s(e),r=d.bind(null,n),o=function(){a(n),n.href&&URL.revokeObjectURL(n.href)}):(n=u(e),r=f.bind(null,n),o=function(){a(n)});return r(t),function(e){if(e){if(e.css===t.css&&e.media===t.media&&e.sourceMap===t.sourceMap)return;r(t=e)}else o()}}function l(t,e,n,r){var o=n?"":r.css;if(t.styleSheet)t.styleSheet.cssText=x(e,o);else{var i=document.createTextNode(o),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(i,a[e]):t.appendChild(i)}}function f(t,e){var n=e.css,r=e.media;if(r&&t.setAttribute("media",r),t.styleSheet)t.styleSheet.cssText=n;else{for(;t.firstChild;)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(n))}}function d(t,e){var n=e.css,r=e.sourceMap;r&&(n+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(r))))+" */");var o=new Blob([n],{type:"text/css"}),i=t.href;t.href=URL.createObjectURL(o),i&&URL.revokeObjectURL(i)}var p={},h=function(t){var e;return function(){return"undefined"==typeof e&&(e=t.apply(this,arguments)),e}},y=h(function(){return/msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase())}),m=h(function(){return document.head||document.getElementsByTagName("head")[0]}),v=null,b=0,g=[];t.exports=function(t,e){e=e||{},"undefined"==typeof e.singleton&&(e.singleton=y()),"undefined"==typeof e.insertAt&&(e.insertAt="bottom");var n=o(t);return r(n,e),function(t){for(var i=[],a=0;a<n.length;a++){var u=n[a],s=p[u.id];s.refs--,i.push(s)}if(t){var c=o(t);r(c,e)}for(var a=0;a<i.length;a++){var s=i[a];if(0===s.refs){for(var l=0;l<s.parts.length;l++)s.parts[l]();delete p[s.id]}}}};var x=function(){var t=[];return function(e,n){return t[e]=n,t.filter(Boolean).join("\n")}}()},function(t,e,n){var r=n(81);"string"==typeof r&&(r=[[t.id,r,""]]),n(83)(r,{}),r.locals&&(t.exports=r.locals)}])});

/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

	var objectKeys = __webpack_require__(751);
	var isArguments = __webpack_require__(1368);
	var is = __webpack_require__(1634);
	var isRegex = __webpack_require__(1370);
	var flags = __webpack_require__(1827);
	var isDate = __webpack_require__(1369);
	
	var getTime = Date.prototype.getTime;
	
	function deepEqual(actual, expected, options) {
	  var opts = options || {};
	
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (opts.strict ? is(actual, expected) : actual === expected) {
	    return true;
	  }
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
	  if (!actual || !expected || (typeof actual !== 'object' && typeof expected !== 'object')) {
	    return opts.strict ? is(actual, expected) : actual == expected;
	  }
	
	  /*
	   * 7.4. For all other Object pairs, including Array objects, equivalence is
	   * determined by having the same number of owned properties (as verified
	   * with Object.prototype.hasOwnProperty.call), the same set of keys
	   * (although not necessarily the same order), equivalent values for every
	   * corresponding key, and an identical 'prototype' property. Note: this
	   * accounts for both named and indexed properties on Arrays.
	   */
	  // eslint-disable-next-line no-use-before-define
	  return objEquiv(actual, expected, opts);
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer(x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') {
	    return false;
	  }
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') {
	    return false;
	  }
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  /* eslint max-statements: [2, 50] */
	  var i, key;
	  if (typeof a !== typeof b) { return false; }
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b)) { return false; }
	
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) { return false; }
	
	  if (isArguments(a) !== isArguments(b)) { return false; }
	
	  var aIsRegex = isRegex(a);
	  var bIsRegex = isRegex(b);
	  if (aIsRegex !== bIsRegex) { return false; }
	  if (aIsRegex || bIsRegex) {
	    return a.source === b.source && flags(a) === flags(b);
	  }
	
	  if (isDate(a) && isDate(b)) {
	    return getTime.call(a) === getTime.call(b);
	  }
	
	  var aIsBuffer = isBuffer(a);
	  var bIsBuffer = isBuffer(b);
	  if (aIsBuffer !== bIsBuffer) { return false; }
	  if (aIsBuffer || bIsBuffer) { // && would work too, because both are true or both false here
	    if (a.length !== b.length) { return false; }
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) { return false; }
	    }
	    return true;
	  }
	
	  if (typeof a !== typeof b) { return false; }
	
	  try {
	    var ka = objectKeys(a);
	    var kb = objectKeys(b);
	  } catch (e) { // happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates hasOwnProperty)
	  if (ka.length !== kb.length) { return false; }
	
	  // the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  // ~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i]) { return false; }
	  }
	  // equivalent values for every corresponding key, and ~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) { return false; }
	  }
	
	  return true;
	}
	
	module.exports = deepEqual;


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {function detect() {
	  var nodeVersion = getNodeVersion();
	  if (nodeVersion) {
	    return nodeVersion;
	  } else if (typeof navigator !== 'undefined') {
	    return parseUserAgent(navigator.userAgent);
	  }
	
	  return null;
	}
	
	function detectOS(userAgentString) {
	  var rules = getOperatingSystemRules();
	  var detected = rules.filter(function (os) {
	    return os.rule && os.rule.test(userAgentString);
	  })[0];
	
	  return detected ? detected.name : null;
	}
	
	function getNodeVersion() {
	  var isNode = typeof navigator === 'undefined' && typeof process !== 'undefined';
	  return isNode ? {
	    name: 'node',
	    version: process.version.slice(1),
	    os: __webpack_require__(1636).type().toLowerCase()
	  } : null;
	}
	
	function parseUserAgent(userAgentString) {
	  var browsers = getBrowserRules();
	  if (!userAgentString) {
	    return null;
	  }
	
	  var detected = browsers.map(function(browser) {
	    var match = browser.rule.exec(userAgentString);
	    var version = match && match[1].split(/[._]/).slice(0,3);
	
	    if (version && version.length < 3) {
	      version = version.concat(version.length == 1 ? [0, 0] : [0]);
	    }
	
	    return match && {
	      name: browser.name,
	      version: version.join('.')
	    };
	  }).filter(Boolean)[0] || null;
	
	  if (detected) {
	    detected.os = detectOS(userAgentString);
	  }
	
	  if (/alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/i.test(userAgentString)) {
	    detected = detected || {};
	    detected.bot = true;
	  }
	
	  return detected;
	}
	
	function getBrowserRules() {
	  return buildRules([
	    [ 'aol', /AOLShield\/([0-9\._]+)/ ],
	    [ 'edge', /Edge\/([0-9\._]+)/ ],
	    [ 'yandexbrowser', /YaBrowser\/([0-9\._]+)/ ],
	    [ 'vivaldi', /Vivaldi\/([0-9\.]+)/ ],
	    [ 'kakaotalk', /KAKAOTALK\s([0-9\.]+)/ ],
	    [ 'samsung', /SamsungBrowser\/([0-9\.]+)/ ],
	    [ 'chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'crios', /CriOS\/([0-9\.]+)(:?\s|$)/ ],
	    [ 'firefox', /Firefox\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'fxios', /FxiOS\/([0-9\.]+)/ ],
	    [ 'opera', /Opera\/([0-9\.]+)(?:\s|$)/ ],
	    [ 'opera', /OPR\/([0-9\.]+)(:?\s|$)$/ ],
	    [ 'ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/ ],
	    [ 'ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/ ],
	    [ 'ie', /MSIE\s(7\.0)/ ],
	    [ 'bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/ ],
	    [ 'android', /Android\s([0-9\.]+)/ ],
	    [ 'ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/ ],
	    [ 'safari', /Version\/([0-9\._]+).*Safari/ ],
	    [ 'facebook', /FBAV\/([0-9\.]+)/],
	    [ 'instagram', /Instagram\ ([0-9\.]+)/],
	    [ 'ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/]
	  ]);
	}
	
	function getOperatingSystemRules() {
	  return buildRules([
	    [ 'iOS', /iP(hone|od|ad)/ ],
	    [ 'Android OS', /Android/ ],
	    [ 'BlackBerry OS', /BlackBerry|BB10/ ],
	    [ 'Windows Mobile', /IEMobile/ ],
	    [ 'Amazon OS', /Kindle/ ],
	    [ 'Windows 3.11', /Win16/ ],
	    [ 'Windows 95', /(Windows 95)|(Win95)|(Windows_95)/ ],
	    [ 'Windows 98', /(Windows 98)|(Win98)/ ],
	    [ 'Windows 2000', /(Windows NT 5.0)|(Windows 2000)/ ],
	    [ 'Windows XP', /(Windows NT 5.1)|(Windows XP)/ ],
	    [ 'Windows Server 2003', /(Windows NT 5.2)/ ],
	    [ 'Windows Vista', /(Windows NT 6.0)/ ],
	    [ 'Windows 7', /(Windows NT 6.1)/ ],
	    [ 'Windows 8', /(Windows NT 6.2)/ ],
	    [ 'Windows 8.1', /(Windows NT 6.3)/ ],
	    [ 'Windows 10', /(Windows NT 10.0)/ ],
	    [ 'Windows ME', /Windows ME/ ],
	    [ 'Open BSD', /OpenBSD/ ],
	    [ 'Sun OS', /SunOS/ ],
	    [ 'Linux', /(Linux)|(X11)/ ],
	    [ 'Mac OS', /(Mac_PowerPC)|(Macintosh)/ ],
	    [ 'QNX', /QNX/ ],
	    [ 'BeOS', /BeOS/ ],
	    [ 'OS/2', /OS\/2/ ],
	    [ 'Search Bot', /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/ ]
	  ]);
	}
	
	function buildRules(ruleTuples) {
	  return ruleTuples.map(function(tuple) {
	    return {
	      name: tuple[0],
	      rule: tuple[1]
	    };
	  });
	}
	
	module.exports = {
	  detect: detect,
	  detectOS: detectOS,
	  getNodeVersion: getNodeVersion,
	  parseUserAgent: parseUserAgent
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)))

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

	exports.remove = removeDiacritics;
	
	var replacementList = [
	  {
	    base: ' ',
	    chars: "\u00A0",
	  }, {
	    base: '0',
	    chars: "\u07C0",
	  }, {
	    base: 'A',
	    chars: "\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F",
	  }, {
	    base: 'AA',
	    chars: "\uA732",
	  }, {
	    base: 'AE',
	    chars: "\u00C6\u01FC\u01E2",
	  }, {
	    base: 'AO',
	    chars: "\uA734",
	  }, {
	    base: 'AU',
	    chars: "\uA736",
	  }, {
	    base: 'AV',
	    chars: "\uA738\uA73A",
	  }, {
	    base: 'AY',
	    chars: "\uA73C",
	  }, {
	    base: 'B',
	    chars: "\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0181",
	  }, {
	    base: 'C',
	    chars: "\u24b8\uff23\uA73E\u1E08\u0106\u0043\u0108\u010A\u010C\u00C7\u0187\u023B",
	  }, {
	    base: 'D',
	    chars: "\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018A\u0189\u1D05\uA779",
	  }, {
	    base: 'Dh',
	    chars: "\u00D0",
	  }, {
	    base: 'DZ',
	    chars: "\u01F1\u01C4",
	  }, {
	    base: 'Dz',
	    chars: "\u01F2\u01C5",
	  }, {
	    base: 'E',
	    chars: "\u025B\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E\u1D07",
	  }, {
	    base: 'F',
	    chars: "\uA77C\u24BB\uFF26\u1E1E\u0191\uA77B",
	  }, {
	    base: 'G',
	    chars: "\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E\u0262",
	  }, {
	    base: 'H',
	    chars: "\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D",
	  }, {
	    base: 'I',
	    chars: "\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197",
	  }, {
	    base: 'J',
	    chars: "\u24BF\uFF2A\u0134\u0248\u0237",
	  }, {
	    base: 'K',
	    chars: "\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2",
	  }, {
	    base: 'L',
	    chars: "\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780",
	  }, {
	    base: 'LJ',
	    chars: "\u01C7",
	  }, {
	    base: 'Lj',
	    chars: "\u01C8",
	  }, {
	    base: 'M',
	    chars: "\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C\u03FB",
	  }, {
	    base: 'N',
	    chars: "\uA7A4\u0220\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u019D\uA790\u1D0E",
	  }, {
	    base: 'NJ',
	    chars: "\u01CA",
	  }, {
	    base: 'Nj',
	    chars: "\u01CB",
	  }, {
	    base: 'O',
	    chars: "\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C",
	  }, {
	    base: 'OE',
	    chars: "\u0152",
	  }, {
	    base: 'OI',
	    chars: "\u01A2",
	  }, {
	    base: 'OO',
	    chars: "\uA74E",
	  }, {
	    base: 'OU',
	    chars: "\u0222",
	  }, {
	    base: 'P',
	    chars: "\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754",
	  }, {
	    base: 'Q',
	    chars: "\u24C6\uFF31\uA756\uA758\u024A",
	  }, {
	    base: 'R',
	    chars: "\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782",
	  }, {
	    base: 'S',
	    chars: "\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784",
	  }, {
	    base: 'T',
	    chars: "\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786",
	  }, {
	    base: 'Th',
	    chars: "\u00DE",
	  }, {
	    base: 'TZ',
	    chars: "\uA728",
	  }, {
	    base: 'U',
	    chars: "\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244",
	  }, {
	    base: 'V',
	    chars: "\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245",
	  }, {
	    base: 'VY',
	    chars: "\uA760",
	  }, {
	    base: 'W',
	    chars: "\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72",
	  }, {
	    base: 'X',
	    chars: "\u24CD\uFF38\u1E8A\u1E8C",
	  }, {
	    base: 'Y',
	    chars: "\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE",
	  }, {
	    base: 'Z',
	    chars: "\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762",
	  }, {
	    base: 'a',
	    chars: "\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250\u0251",
	  }, {
	    base: 'aa',
	    chars: "\uA733",
	  }, {
	    base: 'ae',
	    chars: "\u00E6\u01FD\u01E3",
	  }, {
	    base: 'ao',
	    chars: "\uA735",
	  }, {
	    base: 'au',
	    chars: "\uA737",
	  }, {
	    base: 'av',
	    chars: "\uA739\uA73B",
	  }, {
	    base: 'ay',
	    chars: "\uA73D",
	  }, {
	    base: 'b',
	    chars: "\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253\u0182",
	  }, {
	    base: 'c',
	    chars: "\uFF43\u24D2\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184",
	  }, {
	    base: 'd',
	    chars: "\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\u018B\u13E7\u0501\uA7AA",
	  }, {
	    base: 'dh',
	    chars: "\u00F0",
	  }, {
	    base: 'dz',
	    chars: "\u01F3\u01C6",
	  }, {
	    base: 'e',
	    chars: "\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u01DD",
	  }, {
	    base: 'f',
	    chars: "\u24D5\uFF46\u1E1F\u0192",
	  }, {
	    base: 'ff',
	    chars: "\uFB00",
	  }, {
	    base: 'fi',
	    chars: "\uFB01",
	  }, {
	    base: 'fl',
	    chars: "\uFB02",
	  }, {
	    base: 'ffi',
	    chars: "\uFB03",
	  }, {
	    base: 'ffl',
	    chars: "\uFB04",
	  }, {
	    base: 'g',
	    chars: "\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\uA77F\u1D79",
	  }, {
	    base: 'h',
	    chars: "\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265",
	  }, {
	    base: 'hv',
	    chars: "\u0195",
	  }, {
	    base: 'i',
	    chars: "\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131",
	  }, {
	    base: 'j',
	    chars: "\u24D9\uFF4A\u0135\u01F0\u0249",
	  }, {
	    base: 'k',
	    chars: "\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3",
	  }, {
	    base: 'l',
	    chars: "\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747\u026D",
	  }, {
	    base: 'lj',
	    chars: "\u01C9",
	  }, {
	    base: 'm',
	    chars: "\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F",
	  }, {
	    base: 'n',
	    chars: "\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5\u043B\u0509",
	  }, {
	    base: 'nj',
	    chars: "\u01CC",
	  }, {
	    base: 'o',
	    chars: "\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\uA74B\uA74D\u0275\u0254\u1D11",
	  }, {
	    base: 'oe',
	    chars: "\u0153",
	  }, {
	    base: 'oi',
	    chars: "\u01A3",
	  }, {
	    base: 'oo',
	    chars: "\uA74F",
	  }, {
	    base: 'ou',
	    chars: "\u0223",
	  }, {
	    base: 'p',
	    chars: "\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755\u03C1",
	  }, {
	    base: 'q',
	    chars: "\u24E0\uFF51\u024B\uA757\uA759",
	  }, {
	    base: 'r',
	    chars: "\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783",
	  }, {
	    base: 's',
	    chars: "\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B\u0282",
	  }, {
	    base: 'ss',
	    chars: "\xDF",
	  }, {
	    base: 't',
	    chars: "\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787",
	  }, {
	    base: 'th',
	    chars: "\u00FE",
	  }, {
	    base: 'tz',
	    chars: "\uA729",
	  }, {
	    base: 'u',
	    chars: "\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289",
	  }, {
	    base: 'v',
	    chars: "\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C",
	  }, {
	    base: 'vy',
	    chars: "\uA761",
	  }, {
	    base: 'w',
	    chars: "\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73",
	  }, {
	    base: 'x',
	    chars: "\u24E7\uFF58\u1E8B\u1E8D",
	  }, {
	    base: 'y',
	    chars: "\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF",
	  }, {
	    base: 'z',
	    chars: "\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763",
	  }
	];
	
	var diacriticsMap = {};
	for (var i = 0; i < replacementList.length; i += 1) {
	  var chars = replacementList[i].chars;
	  for (var j = 0; j < chars.length; j += 1) {
	    diacriticsMap[chars[j]] = replacementList[i].base;
	  }
	}
	
	function removeDiacritics(str) {
	  return str.replace(/[^\u0000-\u007e]/g, function(c) {
	    return diacriticsMap[c] || c;
	  });
	}
	
	exports.replacementList = replacementList;
	exports.diacriticsMap = diacriticsMap;


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(1311));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

	'use strict';
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	module.exports = function removeClass(element, className) {
	  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	};

/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {'use strict';
	
	/* globals
		Atomics,
		SharedArrayBuffer,
	*/
	
	var undefined;
	
	var $TypeError = TypeError;
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () { throw new $TypeError(); };
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(1321)();
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var generator; // = function * () {};
	var generatorFunction = generator ? getProto(generator) : undefined;
	var asyncFn; // async function() {};
	var asyncFunction = asyncFn ? asyncFn.constructor : undefined;
	var asyncGen; // async function * () {};
	var asyncGenFunction = asyncGen ? getProto(asyncGen) : undefined;
	var asyncGenIterator = asyncGen ? asyncGen() : undefined;
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer.prototype,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'%ArrayPrototype%': Array.prototype,
		'%ArrayProto_entries%': Array.prototype.entries,
		'%ArrayProto_forEach%': Array.prototype.forEach,
		'%ArrayProto_keys%': Array.prototype.keys,
		'%ArrayProto_values%': Array.prototype.values,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': asyncFunction,
		'%AsyncFunctionPrototype%': asyncFunction ? asyncFunction.prototype : undefined,
		'%AsyncGenerator%': asyncGen ? getProto(asyncGenIterator) : undefined,
		'%AsyncGeneratorFunction%': asyncGenFunction,
		'%AsyncGeneratorPrototype%': asyncGenFunction ? asyncGenFunction.prototype : undefined,
		'%AsyncIteratorPrototype%': asyncGenIterator && hasSymbols && Symbol.asyncIterator ? asyncGenIterator[Symbol.asyncIterator]() : undefined,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%Boolean%': Boolean,
		'%BooleanPrototype%': Boolean.prototype,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%DataViewPrototype%': typeof DataView === 'undefined' ? undefined : DataView.prototype,
		'%Date%': Date,
		'%DatePrototype%': Date.prototype,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%ErrorPrototype%': Error.prototype,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%EvalErrorPrototype%': EvalError.prototype,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? undefined : Float32Array.prototype,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? undefined : Float64Array.prototype,
		'%Function%': Function,
		'%FunctionPrototype%': Function.prototype,
		'%Generator%': generator ? getProto(generator()) : undefined,
		'%GeneratorFunction%': generatorFunction,
		'%GeneratorPrototype%': generatorFunction ? generatorFunction.prototype : undefined,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? undefined : Int8Array.prototype,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? undefined : Int8Array.prototype,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? undefined : Int32Array.prototype,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%JSONParse%': typeof JSON === 'object' ? JSON.parse : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%MapPrototype%': typeof Map === 'undefined' ? undefined : Map.prototype,
		'%Math%': Math,
		'%Number%': Number,
		'%NumberPrototype%': Number.prototype,
		'%Object%': Object,
		'%ObjectPrototype%': Object.prototype,
		'%ObjProto_toString%': Object.prototype.toString,
		'%ObjProto_valueOf%': Object.prototype.valueOf,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%PromisePrototype%': typeof Promise === 'undefined' ? undefined : Promise.prototype,
		'%PromiseProto_then%': typeof Promise === 'undefined' ? undefined : Promise.prototype.then,
		'%Promise_all%': typeof Promise === 'undefined' ? undefined : Promise.all,
		'%Promise_reject%': typeof Promise === 'undefined' ? undefined : Promise.reject,
		'%Promise_resolve%': typeof Promise === 'undefined' ? undefined : Promise.resolve,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%RangeErrorPrototype%': RangeError.prototype,
		'%ReferenceError%': ReferenceError,
		'%ReferenceErrorPrototype%': ReferenceError.prototype,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%RegExpPrototype%': RegExp.prototype,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SetPrototype%': typeof Set === 'undefined' ? undefined : Set.prototype,
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer.prototype,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'%StringPrototype%': String.prototype,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SymbolPrototype%': hasSymbols ? Symbol.prototype : undefined,
		'%SyntaxError%': SyntaxError,
		'%SyntaxErrorPrototype%': SyntaxError.prototype,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypedArrayPrototype%': TypedArray ? TypedArray.prototype : undefined,
		'%TypeError%': $TypeError,
		'%TypeErrorPrototype%': $TypeError.prototype,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array.prototype,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray.prototype,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array.prototype,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array.prototype,
		'%URIError%': URIError,
		'%URIErrorPrototype%': URIError.prototype,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakMapPrototype%': typeof WeakMap === 'undefined' ? undefined : WeakMap.prototype,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
		'%WeakSetPrototype%': typeof WeakSet === 'undefined' ? undefined : WeakSet.prototype
	};
	
	var bind = __webpack_require__(341);
	var $replace = bind.call(Function.call, String.prototype.replace);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : (number || match);
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		if (!(name in INTRINSICS)) {
			throw new SyntaxError('intrinsic ' + name + ' does not exist!');
		}
	
		// istanbul ignore if // hopefully this is impossible to test :-)
		if (typeof INTRINSICS[name] === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}
	
		return INTRINSICS[name];
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new TypeError('"allowMissing" argument must be a boolean');
		}
	
		var parts = stringToPath(name);
	
		var value = getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
		for (var i = 1; i < parts.length; i += 1) {
			if (value != null) {
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, parts[i]);
					if (!allowMissing && !(parts[i] in value)) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					value = desc ? (desc.get || desc.value) : value[parts[i]];
				} else {
					value = value[parts[i]];
				}
			}
		}
		return value;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(341);
	
	var GetIntrinsic = __webpack_require__(1313);
	
	var $Function = GetIntrinsic('%Function%');
	var $apply = $Function.apply;
	var $call = $Function.call;
	
	module.exports = function callBind() {
		return bind.apply($call, arguments);
	};
	
	module.exports.apply = function applyBind() {
		return bind.apply($apply, arguments);
	};


/***/ }),
/* 1315 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _extendableBuiltin(cls) {
	  function ExtendableBuiltin() {
	    cls.apply(this, arguments);
	  }
	
	  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
	    constructor: {
	      value: cls,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (Object.setPrototypeOf) {
	    Object.setPrototypeOf(ExtendableBuiltin, cls);
	  } else {
	    ExtendableBuiltin.__proto__ = cls;
	  }
	
	  return ExtendableBuiltin;
	}
	
	var ExtendableError = function (_extendableBuiltin2) {
	  _inherits(ExtendableError, _extendableBuiltin2);
	
	  function ExtendableError() {
	    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    _classCallCheck(this, ExtendableError);
	
	    // extending Error is weird and does not propagate `message`
	    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));
	
	    Object.defineProperty(_this, 'message', {
	      configurable: true,
	      enumerable: false,
	      value: message,
	      writable: true
	    });
	
	    Object.defineProperty(_this, 'name', {
	      configurable: true,
	      enumerable: false,
	      value: _this.constructor.name,
	      writable: true
	    });
	
	    if (Error.hasOwnProperty('captureStackTrace')) {
	      Error.captureStackTrace(_this, _this.constructor);
	      return _possibleConstructorReturn(_this);
	    }
	
	    Object.defineProperty(_this, 'stack', {
	      configurable: true,
	      enumerable: false,
	      value: new Error(message).stack,
	      writable: true
	    });
	    return _this;
	  }
	
	  return ExtendableError;
	}(_extendableBuiltin(Error));
	
	exports.default = ExtendableError;
	module.exports = exports['default'];


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 1317 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),
/* 1319 */
/***/ (function(module, exports) {

	module.exports = function groperty( obj, propList ) {
	  if ( typeof obj !== 'object' ) return obj;
	
	  if( Object.prototype.toString.call( propList ) !== '[object Array]' ) {
	    propList = propList.replace(/^\./, '').replace(/\.$/, '').split('.');
	  }
	
	  propList.forEach(function walkThroughObj ( propName ) {
	    obj = obj[ propName ] ? obj[ propName ] : obj;
	  });
	  
	  return obj;
	};

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var origSymbol = global.Symbol;
	var hasSymbolSham = __webpack_require__(1322);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(341);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 1324 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(342);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(160);
	
	var _DOMUtils = __webpack_require__(247);
	
	var _DOMStateStorage = __webpack_require__(517);
	
	var _PathUtils = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(342);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(160);
	
	var _PathUtils = __webpack_require__(111);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(343);
	
	var _BrowserProtocol = __webpack_require__(342);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(1326);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(247);
	
	var _createHistory = __webpack_require__(344);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(343);
	
	var _DOMUtils = __webpack_require__(247);
	
	var _HashProtocol = __webpack_require__(1325);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(344);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(160);
	
	var _PathUtils = __webpack_require__(111);
	
	var _createHistory = __webpack_require__(344);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(246);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 1331 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 1332 */
/***/ (function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createPrefixer;
	
	var _getBrowserInformation = __webpack_require__(1349);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(1350);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(346);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _addNewValuesOnly = __webpack_require__(520);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(521);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _prefixValue = __webpack_require__(522);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
	    return style;
	  };
	
	  return function () {
	    /**
	    * Instantiante a new prefixer
	    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	    * @param {string} keepUnprefixed - keeps unprefixed properties and values
	    */
	    function Prefixer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      _classCallCheck(this, Prefixer);
	
	      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	      this._userAgent = options.userAgent || defaultUserAgent;
	      this._keepUnprefixed = options.keepUnprefixed || false;
	
	      if (this._userAgent) {
	        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	      }
	
	      // Checks if the userAgent was resolved correctly
	      if (this._browserInfo && this._browserInfo.cssPrefix) {
	        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
	      } else {
	        this._useFallback = true;
	        return false;
	      }
	
	      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
	      if (prefixData) {
	        this._requiresPrefix = {};
	
	        for (var property in prefixData) {
	          if (prefixData[property] >= this._browserInfo.browserVersion) {
	            this._requiresPrefix[property] = true;
	          }
	        }
	
	        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	      } else {
	        this._useFallback = true;
	      }
	
	      this._metaData = {
	        browserVersion: this._browserInfo.browserVersion,
	        browserName: this._browserInfo.browserName,
	        cssPrefix: this._browserInfo.cssPrefix,
	        jsPrefix: this._browserInfo.jsPrefix,
	        keepUnprefixed: this._keepUnprefixed,
	        requiresPrefix: this._requiresPrefix
	      };
	    }
	
	    _createClass(Prefixer, [{
	      key: 'prefix',
	      value: function prefix(style) {
	        // use static prefixer as fallback if userAgent can not be resolved
	        if (this._useFallback) {
	          return fallback(style);
	        }
	
	        // only add prefixes if needed
	        if (!this._hasPropsRequiringPrefix) {
	          return style;
	        }
	
	        return this._prefixStyle(style);
	      }
	    }, {
	      key: '_prefixStyle',
	      value: function _prefixStyle(style) {
	        for (var property in style) {
	          var value = style[property];
	
	          // handle nested objects
	          if ((0, _isObject2.default)(value)) {
	            style[property] = this.prefix(value);
	            // handle array values
	          } else if (Array.isArray(value)) {
	            var combinedValue = [];
	
	            for (var i = 0, len = value.length; i < len; ++i) {
	              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
	              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	            }
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (combinedValue.length > 0) {
	              style[property] = combinedValue;
	            }
	          } else {
	            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (_processedValue) {
	              style[property] = _processedValue;
	            }
	
	            // add prefixes to properties
	            if (this._requiresPrefix.hasOwnProperty(property)) {
	              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	              if (!this._keepUnprefixed) {
	                delete style[property];
	              }
	            }
	          }
	        }
	
	        return style;
	      }
	
	      /**
	      * Returns a prefixed version of the style object using all vendor prefixes
	      * @param {Object} styles - Style object that gets prefixed properties added
	      * @returns {Object} - Style object with prefixed properties and values
	      */
	
	    }], [{
	      key: 'prefixAll',
	      value: function prefixAll(styles) {
	        return fallback(styles);
	      }
	    }]);
	
	    return Prefixer;
	  }();
	}
	module.exports = exports['default'];

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(161);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
	    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(161);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  flex: true,
	  'inline-flex': true
	};
	function flex(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(161);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(161);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      if (value.indexOf('column') > -1) {
	        style.WebkitBoxOrient = 'vertical';
	      } else {
	        style.WebkitBoxOrient = 'horizontal';
	      }
	      if (value.indexOf('reverse') > -1) {
	        style.WebkitBoxDirection = 'reverse';
	      } else {
	        style.WebkitBoxDirection = 'normal';
	      }
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(161);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	function gradient(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(161);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	
	  // TODO: chrome & opera support it
	};function sizing(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(515);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var requiresPrefixDashCased = void 0;
	
	function transition(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    // memoize the prefix array for later use
	    if (!requiresPrefixDashCased) {
	      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateProperty2.default)(prop);
	      });
	    }
	
	    // only split multi values, not cubic beziers
	    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	    requiresPrefixDashCased.forEach(function (prop) {
	      multipleValues.forEach(function (val, index) {
	        if (val.indexOf(prop) > -1 && prop !== 'order') {
	          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
	        }
	      });
	    });
	
	    return multipleValues.join(',');
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(1351);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(522);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(520);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(521);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports['default'];

/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _isPrefixedValue = __webpack_require__(339);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style) {
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(339);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(515);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(339);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(346);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getBrowserInformation;
	
	var _bowser = __webpack_require__(1048);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixByBrowser = {
	  chrome: 'Webkit',
	  safari: 'Webkit',
	  ios: 'Webkit',
	  android: 'Webkit',
	  phantom: 'Webkit',
	  opera: 'Webkit',
	  webos: 'Webkit',
	  blackberry: 'Webkit',
	  bada: 'Webkit',
	  tizen: 'Webkit',
	  chromium: 'Webkit',
	  vivaldi: 'Webkit',
	  firefox: 'Moz',
	  seamoney: 'Moz',
	  sailfish: 'Moz',
	  msie: 'ms',
	  msedge: 'ms'
	};
	
	
	var browserByCanIuseAlias = {
	  chrome: 'chrome',
	  chromium: 'chrome',
	  safari: 'safari',
	  firfox: 'firefox',
	  msedge: 'edge',
	  opera: 'opera',
	  vivaldi: 'opera',
	  msie: 'ie'
	};
	
	function getBrowserName(browserInfo) {
	  if (browserInfo.firefox) {
	    return 'firefox';
	  }
	
	  if (browserInfo.mobile || browserInfo.tablet) {
	    if (browserInfo.ios) {
	      return 'ios_saf';
	    } else if (browserInfo.android) {
	      return 'android';
	    } else if (browserInfo.opera) {
	      return 'op_mini';
	    }
	  }
	
	  for (var browser in browserByCanIuseAlias) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      return browserByCanIuseAlias[browser];
	    }
	  }
	}
	
	/**
	 * Uses bowser to get default browser browserInformation such as version and name
	 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	function getBrowserInformation(userAgent) {
	  var browserInfo = _bowser2.default._detect(userAgent);
	
	  if (browserInfo.yandexbrowser) {
	    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
	  }
	
	  for (var browser in prefixByBrowser) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      var prefix = prefixByBrowser[browser];
	
	      browserInfo.jsPrefix = prefix;
	      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
	      break;
	    }
	  }
	
	  browserInfo.browserName = getBrowserName(browserInfo);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  if (browserInfo.version) {
	    browserInfo.browserVersion = parseFloat(browserInfo.version);
	  } else {
	    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
	  }
	
	  browserInfo.osVersion = parseFloat(browserInfo.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
	    browserInfo.browserName = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // Samsung browser are basically build on Chrome > 44
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
	  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
	    browserInfo.browserName = 'and_chr';
	    browserInfo.browserVersion = 44;
	  }
	
	  return browserInfo;
	}
	module.exports = exports['default'];

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedKeyframes;
	function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
	  var prefixedKeyframes = 'keyframes';
	
	  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
	    return cssPrefix + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	}
	module.exports = exports['default'];

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(346);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var requiredPrefixes = prefixProperties[property];
	    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
	      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
	    }
	  }
	}
	module.exports = exports['default'];

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var RelativeTimeFormat;
	// -- Utilities ----------------------------------------------------------------
	function getCacheId(inputs) {
	    return JSON.stringify(inputs.map(function (input) {
	        return input && typeof input === 'object' ? orderedProps(input) : input;
	    }));
	}
	function orderedProps(obj) {
	    return Object.keys(obj)
	        .sort()
	        .map(function (k) {
	        var _a;
	        return (_a = {}, _a[k] = obj[k], _a);
	    });
	}
	var memoizeFormatConstructor = function (FormatConstructor, cache) {
	    if (cache === void 0) { cache = {}; }
	    return function () {
	        var _a;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var cacheId = getCacheId(args);
	        var format = cacheId && cache[cacheId];
	        if (!format) {
	            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	        return format;
	    };
	};
	exports.default = memoizeFormatConstructor;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(1352)['default'];
	exports['default'] = exports;


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(1355)['default'];
	exports['default'] = exports;


/***/ }),
/* 1355 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  "use strict";
	
	  /*
	   * Generated by PEG.js 0.9.0.
	   *
	   * http://pegjs.org/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function peg$SyntaxError(message, expected, found, location) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.location = location;
	    this.name     = "SyntaxError";
	
	    if (typeof Error.captureStackTrace === "function") {
	      Error.captureStackTrace(this, peg$SyntaxError);
	    }
	  }
	
	  peg$subclass(peg$SyntaxError, Error);
	
	  function peg$parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	        parser  = this,
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements,
	                    location: location()
	                };
	            },
	        peg$c1 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c2 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText,
	                    location: location()
	                };
	            },
	        peg$c3 = /^[^ \t\n\r,.+={}#]/,
	        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c5 = "{",
	        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c7 = ",",
	        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c9 = "}",
	        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c11 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2],
	                    location: location()
	                };
	            },
	        peg$c12 = "number",
	        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c14 = "date",
	        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c16 = "time",
	        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c18 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2],
	                    location: location()
	                };
	            },
	        peg$c19 = "plural",
	        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c21 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                };
	            },
	        peg$c22 = "selectordinal",
	        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options,
	                    location: location()
	                }
	            },
	        peg$c25 = "select",
	        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c27 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c28 = "=",
	        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c30 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern,
	                    location: location()
	                };
	            },
	        peg$c31 = "offset:",
	        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c33 = function(number) {
	                return number;
	            },
	        peg$c34 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options,
	                    location: location()
	                };
	            },
	        peg$c35 = { type: "other", description: "whitespace" },
	        peg$c36 = /^[ \t\n\r]/,
	        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c38 = { type: "other", description: "optionalWhitespace" },
	        peg$c39 = /^[0-9]/,
	        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c41 = /^[0-9a-f]/i,
	        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c43 = "0",
	        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c45 = /^[1-9]/,
	        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c47 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
	        peg$c50 = "\\\\",
	        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c52 = function() { return '\\'; },
	        peg$c53 = "\\#",
	        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c55 = function() { return '\\#'; },
	        peg$c56 = "\\{",
	        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c58 = function() { return '\u007B'; },
	        peg$c59 = "\\}",
	        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c61 = function() { return '\u007D'; },
	        peg$c62 = "\\u",
	        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c64 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c65 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$savedPos         = 0,
	        peg$posDetailsCache  = [{ line: 1, column: 1, seenCR: false }],
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$savedPos, peg$currPos);
	    }
	
	    function location() {
	      return peg$computeLocation(peg$savedPos, peg$currPos);
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(
	        message,
	        null,
	        input.substring(peg$savedPos, peg$currPos),
	        peg$computeLocation(peg$savedPos, peg$currPos)
	      );
	    }
	
	    function peg$computePosDetails(pos) {
	      var details = peg$posDetailsCache[pos],
	          p, ch;
	
	      if (details) {
	        return details;
	      } else {
	        p = pos - 1;
	        while (!peg$posDetailsCache[p]) {
	          p--;
	        }
	
	        details = peg$posDetailsCache[p];
	        details = {
	          line:   details.line,
	          column: details.column,
	          seenCR: details.seenCR
	        };
	
	        while (p < pos) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	
	          p++;
	        }
	
	        peg$posDetailsCache[pos] = details;
	        return details;
	      }
	    }
	
	    function peg$computeLocation(startPos, endPos) {
	      var startPosDetails = peg$computePosDetails(startPos),
	          endPosDetails   = peg$computePosDetails(endPos);
	
	      return {
	        start: {
	          offset: startPos,
	          line:   startPosDetails.line,
	          column: startPosDetails.column
	        },
	        end: {
	          offset: endPos,
	          line:   endPosDetails.line,
	          column: endPosDetails.column
	        }
	      };
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, found, location) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0100-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1000-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new peg$SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        location
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c0(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$FAILED;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c2(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c3.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c4); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c3.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c4); }
	            }
	          }
	        } else {
	          s1 = peg$FAILED;
	        }
	        if (s1 !== peg$FAILED) {
	          s0 = input.substring(s0, peg$currPos);
	        } else {
	          s0 = s1;
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c5;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c6); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c7;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c8); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$FAILED;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = null;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c9;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c11(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c12) {
	        s1 = peg$c12;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c13); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c14) {
	          s1 = peg$c14;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c15); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c16) {
	            s1 = peg$c16;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c17); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c7;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$FAILED;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = null;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c18(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c19) {
	        s1 = peg$c19;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c20); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c21(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c7;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c8); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$FAILED;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c28;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c5;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c9;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$savedPos = s0;
	                      s1 = peg$c30(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$FAILED;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$FAILED;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c31) {
	        s1 = peg$c31;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c33(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = null;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$FAILED;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c34(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$FAILED;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$FAILED;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c36.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c37); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c36.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c37); }
	          }
	        }
	      } else {
	        s0 = peg$FAILED;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s0 = input.substring(s0, peg$currPos);
	      } else {
	        s0 = s1;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c41.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c42); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c43;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c44); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c45.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c46); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$FAILED;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$FAILED;
	        }
	        if (s2 !== peg$FAILED) {
	          s1 = input.substring(s1, peg$currPos);
	        } else {
	          s1 = s2;
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c47(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c48.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c49); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c50) {
	          s1 = peg$c50;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c51); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$savedPos = s0;
	          s1 = peg$c52();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c53) {
	            s1 = peg$c53;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c54); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$savedPos = s0;
	            s1 = peg$c55();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c56) {
	              s1 = peg$c56;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c57); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$savedPos = s0;
	              s1 = peg$c58();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c59) {
	                s1 = peg$c59;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c60); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$savedPos = s0;
	                s1 = peg$c61();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c62) {
	                  s1 = peg$c62;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c63); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$FAILED;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$FAILED;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$FAILED;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$FAILED;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s2 = input.substring(s2, peg$currPos);
	                  } else {
	                    s2 = s3;
	                  }
	                  if (s2 !== peg$FAILED) {
	                    peg$savedPos = s0;
	                    s1 = peg$c64(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$FAILED;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$FAILED;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$FAILED;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$savedPos = s0;
	        s1 = peg$c65(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(
	        null,
	        peg$maxFailExpected,
	        peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
	        peg$maxFailPos < input.length
	          ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
	          : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
	      );
	    }
	  }
	
	  return {
	    SyntaxError: peg$SyntaxError,
	    parse:       peg$parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value && typeof value !== 'number') {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(524), src$es5$$ = __webpack_require__(1359), src$compiler$$ = __webpack_require__(1356), intl$messageformat$parser$$ = __webpack_require__(1354);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	      try {
	        return messageFormat._format(pattern, values);
	      } catch (e) {
	        if (e.variableId) {
	          throw new Error(
	            'The intl string context variable \'' + e.variableId + '\'' +
	            ' was not provided to the string \'' + message + '\''
	          );
	        } else {
	          throw e;
	        }
	      }
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value, err;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	          err = new Error('A value must be provided for: ' + id);
	          err.variableId = id;
	          throw err;
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(524);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(1357), src$en$$ = __webpack_require__(1358);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(1366)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(1851);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/* jslint esnext: true */
	var intl_messageformat_1 = __webpack_require__(523);
	var diff_1 = __webpack_require__(1363);
	var es5_1 = __webpack_require__(1365);
	exports.default = RelativeFormat;
	// -----------------------------------------------------------------------------
	var FIELDS = [
	    'second', 'second-short',
	    'minute', 'minute-short',
	    'hour', 'hour-short',
	    'day', 'day-short',
	    'month', 'month-short',
	    'year', 'year-short'
	];
	var STYLES = ['best fit', 'numeric'];
	// -- RelativeFormat -----------------------------------------------------------
	function RelativeFormat(locales, options) {
	    options = options || {};
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (es5_1.isArray(locales)) {
	        locales = locales.concat();
	    }
	    es5_1.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
	    es5_1.defineProperty(this, '_options', { value: {
	            style: this._resolveStyle(options.style),
	            units: this._isValidUnits(options.units) && options.units
	        } });
	    es5_1.defineProperty(this, '_locales', { value: locales });
	    es5_1.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
	    es5_1.defineProperty(this, '_messages', { value: es5_1.objCreate(null) });
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	// Define internal private properties for dealing with locale data.
	es5_1.defineProperty(RelativeFormat, '__localeData__', { value: es5_1.objCreate(null) });
	es5_1.defineProperty(RelativeFormat, '__addLocaleData', { value: function () {
	        for (var i = 0; i < arguments.length; i++) {
	            var datum = arguments[i];
	            if (!(datum && datum.locale)) {
	                throw new Error('Locale data provided to IntlRelativeFormat is missing a ' +
	                    '`locale` property value');
	            }
	            RelativeFormat.__localeData__[datum.locale.toLowerCase()] = datum;
	            // Add data to IntlMessageFormat.
	            intl_messageformat_1.default.__addLocaleData(datum);
	        }
	    } });
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	es5_1.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable: true,
	    value: undefined
	});
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	es5_1.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	    value: {
	        second: 45, 'second-short': 45,
	        minute: 45, 'minute-short': 45,
	        hour: 22, 'hour-short': 22,
	        day: 26, 'day-short': 26,
	        month: 11, 'month-short': 11 // months to year
	    }
	});
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style: this._options.style,
	        units: this._options.units
	    };
	};
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales = this._locales;
	    var resolvedLocale = this._locale;
	    var field = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future = '';
	    var past = '';
	    var i;
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	        'past {{0, plural, ' + past + '}}}';
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl_messageformat_1.default(message, locales);
	};
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	    return messages[units];
	};
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data = localeData[locale.toLowerCase()];
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale);
	};
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : es5_1.dateNow();
	    if (date === undefined) {
	        date = now;
	    }
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.');
	    }
	    if (!isFinite(date)) {
	        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.');
	    }
	    var diffReport = diff_1.default(now, date);
	    var units = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	    return this._getMessage(units).format({
	        '0': Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || es5_1.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && es5_1.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion);
	        }
	    }
	    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"');
	};
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	            localeParts.pop();
	        }
	    }
	    var defaultLocale = locales.pop();
	    throw new Error('No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale);
	};
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	    if (es5_1.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"');
	};
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	    var fields = FIELDS.filter(function (field) {
	        return field.indexOf('-short') < 1;
	    });
	    for (i = 0, l = fields.length; i < l; i += 1) {
	        units = fields[i];
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	    return units;
	};
	//# sourceMappingURL=core.js.map

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/* jslint esnext: true */
	var round = Math.round;
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	// Thanks to date-fns
	// https://github.com/date-fns/date-fns
	// MIT © Sasha Koss
	var MILLISECONDS_IN_MINUTE = 60000;
	var MILLISECONDS_IN_DAY = 86400000;
	function startOfDay(dirtyDate) {
	    var date = new Date(dirtyDate);
	    date.setHours(0, 0, 0, 0);
	    return date;
	}
	function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
	    var startOfDayLeft = startOfDay(dirtyDateLeft);
	    var startOfDayRight = startOfDay(dirtyDateRight);
	    var timestampLeft = startOfDayLeft.getTime() -
	        startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	    var timestampRight = startOfDayRight.getTime() -
	        startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE;
	    // Round the number of days to the nearest integer
	    // because the number of milliseconds in a day is not constant
	    // (e.g. it's different in the day of the daylight saving time clock shift)
	    return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
	}
	function default_1(from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to = +to;
	    var millisecond = round(to - from), second = round(millisecond / 1000), minute = round(second / 60), hour = round(minute / 60);
	    // We expect a more precision in rounding when dealing with
	    // days as it feels wrong when something happended 13 hours ago and
	    // is regarded as "yesterday" even if the time was this morning.
	    var day = differenceInCalendarDays(to, from);
	    var week = round(day / 7);
	    var rawYears = daysToYears(day), month = round(rawYears * 12), year = round(rawYears);
	    return {
	        millisecond: millisecond,
	        second: second,
	        'second-short': second,
	        minute: minute,
	        'minute-short': minute,
	        hour: hour,
	        'hour-short': hour,
	        day: day,
	        'day-short': day,
	        week: week,
	        'week-short': week,
	        month: month,
	        'month-short': month,
	        year: year,
	        'year-short': year
	    };
	}
	exports.default = default_1;
	//# sourceMappingURL=diff.js.map

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/* @generated */
	exports.default = { "locale": "en", "pluralRuleFunction": function (n, ord) {
	        var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
	        if (ord)
	            return (n10 == 1 && n100 != 11) ? 'one'
	                : (n10 == 2 && n100 != 12) ? 'two'
	                    : (n10 == 3 && n100 != 13) ? 'few'
	                        : 'other';
	        return (n == 1 && v0) ? 'one' : 'other';
	    }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "week": { "displayName": "week", "relativePeriod": "the week of {0}", "relative": { "0": "this week", "1": "next week", "-1": "last week" }, "relativeTime": { "future": { "one": "in {0} week", "other": "in {0} weeks" }, "past": { "one": "{0} week ago", "other": "{0} weeks ago" } } }, "week-short": { "displayName": "wk.", "relativePeriod": "the week of {0}", "relative": { "0": "this wk.", "1": "next wk.", "-1": "last wk." }, "relativeTime": { "future": { "one": "in {0} wk.", "other": "in {0} wk." }, "past": { "one": "{0} wk. ago", "other": "{0} wk. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };
	//# sourceMappingURL=en.js.map

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	/* jslint esnext: true */
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	var realDefineProp = (function () {
	    try {
	        return !!Object.defineProperty({}, 'a', {});
	    }
	    catch (e) {
	        return false;
	    }
	})();
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	var defineProperty = realDefineProp ? Object.defineProperty :
	    function (obj, name, desc) {
	        if ('get' in desc && obj.__defineGetter__) {
	            obj.__defineGetter__(name, desc.get);
	        }
	        else if (!hop.call(obj, name) || 'value' in desc) {
	            obj[name] = desc.value;
	        }
	    };
	exports.defineProperty = defineProperty;
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	    function F() { }
	    F.prototype = proto;
	    obj = new F();
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	    return obj;
	};
	exports.objCreate = objCreate;
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	    return -1;
	};
	exports.arrIndexOf = arrIndexOf;
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	exports.isArray = isArray;
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.dateNow = dateNow;
	//# sourceMappingURL=es5.js.map

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	/* jslint esnext: true */
	Object.defineProperty(exports, "__esModule", { value: true });
	var core_1 = __webpack_require__(1362);
	var en_1 = __webpack_require__(1364);
	core_1.default.__addLocaleData(en_1.default);
	core_1.default.defaultLocale = 'en';
	exports.default = core_1.default;
	//# sourceMappingURL=main.js.map

/***/ }),
/* 1367 */,
/* 1368 */
/***/ (function(module, exports) {

	'use strict';
	
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	var toStr = Object.prototype.toString;
	
	var isStandardArguments = function isArguments(value) {
		if (hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) {
			return false;
		}
		return toStr.call(value) === '[object Arguments]';
	};
	
	var isLegacyArguments = function isArguments(value) {
		if (isStandardArguments(value)) {
			return true;
		}
		return value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value) !== '[object Array]' &&
			toStr.call(value.callee) === '[object Function]';
	};
	
	var supportsStandardArguments = (function () {
		return isStandardArguments(arguments);
	}());
	
	isStandardArguments.isLegacyArguments = isLegacyArguments; // for tests
	
	module.exports = supportsStandardArguments ? isStandardArguments : isLegacyArguments;


/***/ }),
/* 1369 */
/***/ (function(module, exports) {

	'use strict';
	
	var getDay = Date.prototype.getDay;
	var tryDateObject = function tryDateGetDayCall(value) {
		try {
			getDay.call(value);
			return true;
		} catch (e) {
			return false;
		}
	};
	
	var toStr = Object.prototype.toString;
	var dateClass = '[object Date]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isDateObject(value) {
		if (typeof value !== 'object' || value === null) {
			return false;
		}
		return hasToStringTag ? tryDateObject(value) : toStr.call(value) === dateClass;
	};


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = __webpack_require__(1323);
	var regexExec = RegExp.prototype.exec;
	var gOPD = Object.getOwnPropertyDescriptor;
	
	var tryRegexExecCall = function tryRegexExec(value) {
		try {
			var lastIndex = value.lastIndex;
			value.lastIndex = 0; // eslint-disable-line no-param-reassign
	
			regexExec.call(value);
			return true;
		} catch (e) {
			return false;
		} finally {
			value.lastIndex = lastIndex; // eslint-disable-line no-param-reassign
		}
	};
	var toStr = Object.prototype.toString;
	var regexClass = '[object RegExp]';
	var hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
	
	module.exports = function isRegex(value) {
		if (!value || typeof value !== 'object') {
			return false;
		}
		if (!hasToStringTag) {
			return toStr.call(value) === regexClass;
		}
	
		var descriptor = gOPD(value, 'lastIndex');
		var hasLastIndexDataProperty = descriptor && has(descriptor, 'value');
		if (!hasLastIndexDataProperty) {
			return false;
		}
	
		return tryRegexExecCall(value);
	};


/***/ }),
/* 1371 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;( function( factory ) {
		if ( true ) {
	
			// AMD. Register as an anonymous module.
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(198) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
	
			// Browser globals
			factory( jQuery );
		}
	} ( function( $ ) {
	
	$.ui = $.ui || {};
	
	return $.ui.version = "1.12.1";
	
	} ) );


/***/ }),
/* 1373 */
/***/ (function(module, exports) {

	module.exports = [["AF","AFG","004","ISO 3166-2:AF"],["AL","ALB","008","ISO 3166-2:AL"],["DZ","DZA","012","ISO 3166-2:DZ"],["AS","ASM","016","ISO 3166-2:AS"],["AD","AND","020","ISO 3166-2:AD"],["AO","AGO","024","ISO 3166-2:AO"],["AI","AIA","660","ISO 3166-2:AI"],["AQ","ATA","010","ISO 3166-2:AQ"],["AG","ATG","028","ISO 3166-2:AG"],["AR","ARG","032","ISO 3166-2:AR"],["AM","ARM","051","ISO 3166-2:AM"],["AW","ABW","533","ISO 3166-2:AW"],["AU","AUS","036","ISO 3166-2:AU"],["AT","AUT","040","ISO 3166-2:AT"],["AZ","AZE","031","ISO 3166-2:AZ"],["BS","BHS","044","ISO 3166-2:BS"],["BH","BHR","048","ISO 3166-2:BH"],["BD","BGD","050","ISO 3166-2:BD"],["BB","BRB","052","ISO 3166-2:BB"],["BY","BLR","112","ISO 3166-2:BY"],["BE","BEL","056","ISO 3166-2:BE"],["BZ","BLZ","084","ISO 3166-2:BZ"],["BJ","BEN","204","ISO 3166-2:BJ"],["BM","BMU","060","ISO 3166-2:BM"],["BT","BTN","064","ISO 3166-2:BT"],["BO","BOL","068","ISO 3166-2:BO"],["BA","BIH","070","ISO 3166-2:BA"],["BW","BWA","072","ISO 3166-2:BW"],["BV","BVT","074","ISO 3166-2:BV"],["BR","BRA","076","ISO 3166-2:BR"],["IO","IOT","086","ISO 3166-2:IO"],["BN","BRN","096","ISO 3166-2:BN"],["BG","BGR","100","ISO 3166-2:BG"],["BF","BFA","854","ISO 3166-2:BF"],["BI","BDI","108","ISO 3166-2:BI"],["KH","KHM","116","ISO 3166-2:KH"],["CM","CMR","120","ISO 3166-2:CM"],["CA","CAN","124","ISO 3166-2:CA"],["CV","CPV","132","ISO 3166-2:CV"],["KY","CYM","136","ISO 3166-2:KY"],["CF","CAF","140","ISO 3166-2:CF"],["TD","TCD","148","ISO 3166-2:TD"],["CL","CHL","152","ISO 3166-2:CL"],["CN","CHN","156","ISO 3166-2:CN"],["CX","CXR","162","ISO 3166-2:CX"],["CC","CCK","166","ISO 3166-2:CC"],["CO","COL","170","ISO 3166-2:CO"],["KM","COM","174","ISO 3166-2:KM"],["CG","COG","178","ISO 3166-2:CG"],["CD","COD","180","ISO 3166-2:CD"],["CK","COK","184","ISO 3166-2:CK"],["CR","CRI","188","ISO 3166-2:CR"],["CI","CIV","384","ISO 3166-2:CI"],["HR","HRV","191","ISO 3166-2:HR"],["CU","CUB","192","ISO 3166-2:CU"],["CY","CYP","196","ISO 3166-2:CY"],["CZ","CZE","203","ISO 3166-2:CZ"],["DK","DNK","208","ISO 3166-2:DK"],["DJ","DJI","262","ISO 3166-2:DJ"],["DM","DMA","212","ISO 3166-2:DM"],["DO","DOM","214","ISO 3166-2:DO"],["EC","ECU","218","ISO 3166-2:EC"],["EG","EGY","818","ISO 3166-2:EG"],["SV","SLV","222","ISO 3166-2:SV"],["GQ","GNQ","226","ISO 3166-2:GQ"],["ER","ERI","232","ISO 3166-2:ER"],["EE","EST","233","ISO 3166-2:EE"],["ET","ETH","231","ISO 3166-2:ET"],["FK","FLK","238","ISO 3166-2:FK"],["FO","FRO","234","ISO 3166-2:FO"],["FJ","FJI","242","ISO 3166-2:FJ"],["FI","FIN","246","ISO 3166-2:FI"],["FR","FRA","250","ISO 3166-2:FR"],["GF","GUF","254","ISO 3166-2:GF"],["PF","PYF","258","ISO 3166-2:PF"],["TF","ATF","260","ISO 3166-2:TF"],["GA","GAB","266","ISO 3166-2:GA"],["GM","GMB","270","ISO 3166-2:GM"],["GE","GEO","268","ISO 3166-2:GE"],["DE","DEU","276","ISO 3166-2:DE"],["GH","GHA","288","ISO 3166-2:GH"],["GI","GIB","292","ISO 3166-2:GI"],["GR","GRC","300","ISO 3166-2:GR"],["GL","GRL","304","ISO 3166-2:GL"],["GD","GRD","308","ISO 3166-2:GD"],["GP","GLP","312","ISO 3166-2:GP"],["GU","GUM","316","ISO 3166-2:GU"],["GT","GTM","320","ISO 3166-2:GT"],["GN","GIN","324","ISO 3166-2:GN"],["GW","GNB","624","ISO 3166-2:GW"],["GY","GUY","328","ISO 3166-2:GY"],["HT","HTI","332","ISO 3166-2:HT"],["HM","HMD","334","ISO 3166-2:HM"],["VA","VAT","336","ISO 3166-2:VA"],["HN","HND","340","ISO 3166-2:HN"],["HK","HKG","344","ISO 3166-2:HK"],["HU","HUN","348","ISO 3166-2:HU"],["IS","ISL","352","ISO 3166-2:IS"],["IN","IND","356","ISO 3166-2:IN"],["ID","IDN","360","ISO 3166-2:ID"],["IR","IRN","364","ISO 3166-2:IR"],["IQ","IRQ","368","ISO 3166-2:IQ"],["IE","IRL","372","ISO 3166-2:IE"],["IL","ISR","376","ISO 3166-2:IL"],["IT","ITA","380","ISO 3166-2:IT"],["JM","JAM","388","ISO 3166-2:JM"],["JP","JPN","392","ISO 3166-2:JP"],["JO","JOR","400","ISO 3166-2:JO"],["KZ","KAZ","398","ISO 3166-2:KZ"],["KE","KEN","404","ISO 3166-2:KE"],["KI","KIR","296","ISO 3166-2:KI"],["KP","PRK","408","ISO 3166-2:KP"],["KR","KOR","410","ISO 3166-2:KR"],["KW","KWT","414","ISO 3166-2:KW"],["KG","KGZ","417","ISO 3166-2:KG"],["LA","LAO","418","ISO 3166-2:LA"],["LV","LVA","428","ISO 3166-2:LV"],["LB","LBN","422","ISO 3166-2:LB"],["LS","LSO","426","ISO 3166-2:LS"],["LR","LBR","430","ISO 3166-2:LR"],["LY","LBY","434","ISO 3166-2:LY"],["LI","LIE","438","ISO 3166-2:LI"],["LT","LTU","440","ISO 3166-2:LT"],["LU","LUX","442","ISO 3166-2:LU"],["MO","MAC","446","ISO 3166-2:MO"],["MG","MDG","450","ISO 3166-2:MG"],["MW","MWI","454","ISO 3166-2:MW"],["MY","MYS","458","ISO 3166-2:MY"],["MV","MDV","462","ISO 3166-2:MV"],["ML","MLI","466","ISO 3166-2:ML"],["MT","MLT","470","ISO 3166-2:MT"],["MH","MHL","584","ISO 3166-2:MH"],["MQ","MTQ","474","ISO 3166-2:MQ"],["MR","MRT","478","ISO 3166-2:MR"],["MU","MUS","480","ISO 3166-2:MU"],["YT","MYT","175","ISO 3166-2:YT"],["MX","MEX","484","ISO 3166-2:MX"],["FM","FSM","583","ISO 3166-2:FM"],["MD","MDA","498","ISO 3166-2:MD"],["MC","MCO","492","ISO 3166-2:MC"],["MN","MNG","496","ISO 3166-2:MN"],["MS","MSR","500","ISO 3166-2:MS"],["MA","MAR","504","ISO 3166-2:MA"],["MZ","MOZ","508","ISO 3166-2:MZ"],["MM","MMR","104","ISO 3166-2:MM"],["NA","NAM","516","ISO 3166-2:NA"],["NR","NRU","520","ISO 3166-2:NR"],["NP","NPL","524","ISO 3166-2:NP"],["NL","NLD","528","ISO 3166-2:NL"],["NC","NCL","540","ISO 3166-2:NC"],["NZ","NZL","554","ISO 3166-2:NZ"],["NI","NIC","558","ISO 3166-2:NI"],["NE","NER","562","ISO 3166-2:NE"],["NG","NGA","566","ISO 3166-2:NG"],["NU","NIU","570","ISO 3166-2:NU"],["NF","NFK","574","ISO 3166-2:NF"],["MP","MNP","580","ISO 3166-2:MP"],["MK","MKD","807","ISO 3166-2:MK"],["NO","NOR","578","ISO 3166-2:NO"],["OM","OMN","512","ISO 3166-2:OM"],["PK","PAK","586","ISO 3166-2:PK"],["PW","PLW","585","ISO 3166-2:PW"],["PS","PSE","275","ISO 3166-2:PS"],["PA","PAN","591","ISO 3166-2:PA"],["PG","PNG","598","ISO 3166-2:PG"],["PY","PRY","600","ISO 3166-2:PY"],["PE","PER","604","ISO 3166-2:PE"],["PH","PHL","608","ISO 3166-2:PH"],["PN","PCN","612","ISO 3166-2:PN"],["PL","POL","616","ISO 3166-2:PL"],["PT","PRT","620","ISO 3166-2:PT"],["PR","PRI","630","ISO 3166-2:PR"],["QA","QAT","634","ISO 3166-2:QA"],["RE","REU","638","ISO 3166-2:RE"],["RO","ROU","642","ISO 3166-2:RO"],["RU","RUS","643","ISO 3166-2:RU"],["RW","RWA","646","ISO 3166-2:RW"],["SH","SHN","654","ISO 3166-2:SH"],["KN","KNA","659","ISO 3166-2:KN"],["LC","LCA","662","ISO 3166-2:LC"],["PM","SPM","666","ISO 3166-2:PM"],["VC","VCT","670","ISO 3166-2:VC"],["WS","WSM","882","ISO 3166-2:WS"],["SM","SMR","674","ISO 3166-2:SM"],["ST","STP","678","ISO 3166-2:ST"],["SA","SAU","682","ISO 3166-2:SA"],["SN","SEN","686","ISO 3166-2:SN"],["SC","SYC","690","ISO 3166-2:SC"],["SL","SLE","694","ISO 3166-2:SL"],["SG","SGP","702","ISO 3166-2:SG"],["SK","SVK","703","ISO 3166-2:SK"],["SI","SVN","705","ISO 3166-2:SI"],["SB","SLB","090","ISO 3166-2:SB"],["SO","SOM","706","ISO 3166-2:SO"],["ZA","ZAF","710","ISO 3166-2:ZA"],["GS","SGS","239","ISO 3166-2:GS"],["ES","ESP","724","ISO 3166-2:ES"],["LK","LKA","144","ISO 3166-2:LK"],["SD","SDN","729","ISO 3166-2:SD"],["SR","SUR","740","ISO 3166-2:SR"],["SJ","SJM","744","ISO 3166-2:SJ"],["SZ","SWZ","748","ISO 3166-2:SZ"],["SE","SWE","752","ISO 3166-2:SE"],["CH","CHE","756","ISO 3166-2:CH"],["SY","SYR","760","ISO 3166-2:SY"],["TW","TWN","158","ISO 3166-2:TW"],["TJ","TJK","762","ISO 3166-2:TJ"],["TZ","TZA","834","ISO 3166-2:TZ"],["TH","THA","764","ISO 3166-2:TH"],["TL","TLS","626","ISO 3166-2:TL"],["TG","TGO","768","ISO 3166-2:TG"],["TK","TKL","772","ISO 3166-2:TK"],["TO","TON","776","ISO 3166-2:TO"],["TT","TTO","780","ISO 3166-2:TT"],["TN","TUN","788","ISO 3166-2:TN"],["TR","TUR","792","ISO 3166-2:TR"],["TM","TKM","795","ISO 3166-2:TM"],["TC","TCA","796","ISO 3166-2:TC"],["TV","TUV","798","ISO 3166-2:TV"],["UG","UGA","800","ISO 3166-2:UG"],["UA","UKR","804","ISO 3166-2:UA"],["AE","ARE","784","ISO 3166-2:AE"],["GB","GBR","826","ISO 3166-2:GB"],["US","USA","840","ISO 3166-2:US"],["UM","UMI","581","ISO 3166-2:UM"],["UY","URY","858","ISO 3166-2:UY"],["UZ","UZB","860","ISO 3166-2:UZ"],["VU","VUT","548","ISO 3166-2:VU"],["VE","VEN","862","ISO 3166-2:VE"],["VN","VNM","704","ISO 3166-2:VN"],["VG","VGB","092","ISO 3166-2:VG"],["VI","VIR","850","ISO 3166-2:VI"],["WF","WLF","876","ISO 3166-2:WF"],["EH","ESH","732","ISO 3166-2:EH"],["YE","YEM","887","ISO 3166-2:YE"],["ZM","ZMB","894","ISO 3166-2:ZM"],["ZW","ZWE","716","ISO 3166-2:ZW"],["AX","ALA","248","ISO 3166-2:AX"],["BQ","BES","535","ISO 3166-2:BQ"],["CW","CUW","531","ISO 3166-2:CW"],["GG","GGY","831","ISO 3166-2:GG"],["IM","IMN","833","ISO 3166-2:IM"],["JE","JEY","832","ISO 3166-2:JE"],["ME","MNE","499","ISO 3166-2:ME"],["BL","BLM","652","ISO 3166-2:BL"],["MF","MAF","663","ISO 3166-2:MF"],["RS","SRB","688","ISO 3166-2:RS"],["SX","SXM","534","ISO 3166-2:SX"],["SS","SSD","728","ISO 3166-2:SS"],["XK","XKX","","ISO 3166-2:XK"]]

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

	module.exports = {"locale":"en","countries":{"AF":"Afghanistan","AL":"Albania","DZ":"Algeria","AS":"American Samoa","AD":"Andorra","AO":"Angola","AI":"Anguilla","AQ":"Antarctica","AG":"Antigua and Barbuda","AR":"Argentina","AM":"Armenia","AW":"Aruba","AU":"Australia","AT":"Austria","AZ":"Azerbaijan","BS":"Bahamas","BH":"Bahrain","BD":"Bangladesh","BB":"Barbados","BY":"Belarus","BE":"Belgium","BZ":"Belize","BJ":"Benin","BM":"Bermuda","BT":"Bhutan","BO":"Bolivia","BA":"Bosnia and Herzegovina","BW":"Botswana","BV":"Bouvet Island","BR":"Brazil","IO":"British Indian Ocean Territory","BN":"Brunei Darussalam","BG":"Bulgaria","BF":"Burkina Faso","BI":"Burundi","KH":"Cambodia","CM":"Cameroon","CA":"Canada","CV":"Cape Verde","KY":"Cayman Islands","CF":"Central African Republic","TD":"Chad","CL":"Chile","CN":"China","CX":"Christmas Island","CC":"Cocos (Keeling) Islands","CO":"Colombia","KM":"Comoros","CG":"Congo","CD":"Congo, the Democratic Republic of the","CK":"Cook Islands","CR":"Costa Rica","CI":"Cote D'Ivoire","HR":"Croatia","CU":"Cuba","CY":"Cyprus","CZ":"Czech Republic","DK":"Denmark","DJ":"Djibouti","DM":"Dominica","DO":"Dominican Republic","EC":"Ecuador","EG":"Egypt","SV":"El Salvador","GQ":"Equatorial Guinea","ER":"Eritrea","EE":"Estonia","ET":"Ethiopia","FK":"Falkland Islands (Malvinas)","FO":"Faroe Islands","FJ":"Fiji","FI":"Finland","FR":"France","GF":"French Guiana","PF":"French Polynesia","TF":"French Southern Territories","GA":"Gabon","GM":"Gambia","GE":"Georgia","DE":"Germany","GH":"Ghana","GI":"Gibraltar","GR":"Greece","GL":"Greenland","GD":"Grenada","GP":"Guadeloupe","GU":"Guam","GT":"Guatemala","GN":"Guinea","GW":"Guinea-Bissau","GY":"Guyana","HT":"Haiti","HM":"Heard Island and McDonald Islands","VA":"Holy See (Vatican City State)","HN":"Honduras","HK":"Hong Kong","HU":"Hungary","IS":"Iceland","IN":"India","ID":"Indonesia","IR":"Iran, Islamic Republic of","IQ":"Iraq","IE":"Ireland","IL":"Israel","IT":"Italy","JM":"Jamaica","JP":"Japan","JO":"Jordan","KZ":"Kazakhstan","KE":"Kenya","KI":"Kiribati","KP":"North Korea","KR":"South Korea","KW":"Kuwait","KG":"Kyrgyzstan","LA":"Lao People's Democratic Republic","LV":"Latvia","LB":"Lebanon","LS":"Lesotho","LR":"Liberia","LY":"Libya","LI":"Liechtenstein","LT":"Lithuania","LU":"Luxembourg","MO":"Macao","MG":"Madagascar","MW":"Malawi","MY":"Malaysia","MV":"Maldives","ML":"Mali","MT":"Malta","MH":"Marshall Islands","MQ":"Martinique","MR":"Mauritania","MU":"Mauritius","YT":"Mayotte","MX":"Mexico","FM":"Micronesia, Federated States of","MD":"Moldova, Republic of","MC":"Monaco","MN":"Mongolia","MS":"Montserrat","MA":"Morocco","MZ":"Mozambique","MM":"Myanmar","NA":"Namibia","NR":"Nauru","NP":"Nepal","NL":"Netherlands","NC":"New Caledonia","NZ":"New Zealand","NI":"Nicaragua","NE":"Niger","NG":"Nigeria","NU":"Niue","NF":"Norfolk Island","MK":"North Macedonia, Republic of","MP":"Northern Mariana Islands","NO":"Norway","OM":"Oman","PK":"Pakistan","PW":"Palau","PS":"Palestinian Territory, Occupied","PA":"Panama","PG":"Papua New Guinea","PY":"Paraguay","PE":"Peru","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PT":"Portugal","PR":"Puerto Rico","QA":"Qatar","RE":"Reunion","RO":"Romania","RU":["Russian Federation","Russia"],"RW":"Rwanda","SH":"Saint Helena","KN":"Saint Kitts and Nevis","LC":"Saint Lucia","PM":"Saint Pierre and Miquelon","VC":"Saint Vincent and the Grenadines","WS":"Samoa","SM":"San Marino","ST":"Sao Tome and Principe","SA":"Saudi Arabia","SN":"Senegal","SC":"Seychelles","SL":"Sierra Leone","SG":"Singapore","SK":"Slovakia","SI":"Slovenia","SB":"Solomon Islands","SO":"Somalia","ZA":"South Africa","GS":"South Georgia and the South Sandwich Islands","ES":"Spain","LK":"Sri Lanka","SD":"Sudan","SR":"Suriname","SJ":"Svalbard and Jan Mayen","SZ":"Eswatini","SE":"Sweden","CH":"Switzerland","SY":"Syrian Arab Republic","TW":"Taiwan","TJ":"Tajikistan","TZ":"Tanzania, United Republic of","TH":"Thailand","TL":"Timor-Leste","TG":"Togo","TK":"Tokelau","TO":"Tonga","TT":"Trinidad and Tobago","TN":"Tunisia","TR":"Turkey","TM":"Turkmenistan","TC":"Turks and Caicos Islands","TV":"Tuvalu","UG":"Uganda","UA":"Ukraine","AE":"United Arab Emirates","GB":["United Kingdom","UK","Great Britain"],"US":["United States of America","USA"],"UM":"United States Minor Outlying Islands","UY":"Uruguay","UZ":"Uzbekistan","VU":"Vanuatu","VE":"Venezuela","VN":"Vietnam","VG":"Virgin Islands, British","VI":"Virgin Islands, U.S.","WF":"Wallis and Futuna","EH":"Western Sahara","YE":"Yemen","ZM":"Zambia","ZW":"Zimbabwe","AX":"Åland Islands","BQ":"Bonaire, Sint Eustatius and Saba","CW":"Curaçao","GG":"Guernsey","IM":"Isle of Man","JE":"Jersey","ME":"Montenegro","BL":"Saint Barthélemy","MF":"Saint Martin (French part)","RS":"Serbia","SX":"Sint Maarten (Dutch part)","SS":"South Sudan","XK":"Kosovo"}}

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

	module.exports = {"locale":"is","countries":{"AD":"Andorra","AE":"Sameinuðu arabísku furstadæmin","AF":"Afganistan","AG":"Antígva og Barbúda","AI":"Angvilla","AL":"Albanía","AM":"Armenía","AO":"Angóla","AQ":"Suðurskautslandið","AR":"Argentína","AS":"Bandaríska Samóa","AT":"Austurríki","AU":"Ástralía","AW":"Arúba","AX":"Álandseyjar","AZ":"Aserbaísjan","BA":"Bosnía og Hersegóvína","BB":"Barbados","BD":"Bangladess","BE":"Belgía","BF":"Búrkína Fasó","BG":"Búlgaría","BH":"Barein","BI":"Búrúndí","BJ":"Benín","BL":"Saint-Barthélemy","BM":"Bermúda","BN":"Brúnei","BO":"Bólivía","BQ":"Bonaire","BR":"Brasilía","BS":"Bahamas","BT":"Bútan","BV":"Bouveteyja","BW":"Botsvana","BY":"Hvíta-Rússland","BZ":"Belís","CA":"Kanada","CC":"Kókoseyjar","CD":"Lýðstjórnarlýðveldið Kongó","CF":"Mið-Afríkulýðveldið","CG":"Kongó","CH":"Sviss","CI":"Fílabeinsströndin","CK":"Cooks-eyjar","CL":"Síle","CM":"Kamerún","CN":"Kína","CO":"Kólumbía","CR":"Kosta Ríka","CU":"Kúba","CV":"Grænhöfðaeyjar","CW":"Curaçao","CX":"Jólaeyja","CY":"Kípur","CZ":"Tékkland","DE":"Þýskaland","DJ":"Djibútí","DK":"Danmörk","DM":"Dóminíka","DO":"Dóminíska lýðveldið","DZ":"Alsír","EC":"Ekvador","EE":"Eistland","EG":"Egyptaland","EH":"Vestur-Sahara","ER":"Eritrea","ES":"Spánn","ET":"Eþíópía","FI":"Finnland","FJ":"Fídjíeyjar","FK":"Falklandseyjar","FM":"Míkrónesía","FO":"Færeyjar","FR":"Frakkland","GA":"Gabon","GB":"Bretland","GD":"Grenada","GE":"Georgía","GF":"Franska Gvæjana","GG":"Guernsey","GH":"Gana","GI":"Gíbraltar","GL":"Grænland","GM":"Gambía","GN":"Gínea","GP":"Gvadelúpeyjar","GQ":"Miðbaugs-Gínea","GR":"Grikkland","GS":"Suður-Georgía og Suður-Sandvíkureyjar","GT":"Gvatemala","GU":"Gvam","GW":"Gínea-Bissá","GY":"Gvæjana","HK":"Hong Kong","HM":"Heard og McDonaldseyjar","HN":"Hondúras","HR":"Króatía","HT":"Haítí","HU":"Ungverjaland","ID":"Indónesía","IE":"Írland","IL":"Ísrael","IM":"Mön","IN":"Indland","IO":"Bresku Indlandshafseyjar","IQ":"Írak","IR":"Íran","IS":"Ísland","IT":"Ítalía","JE":"Jersey","JM":"Jamaíka","JO":"Jórdanía","JP":"Japan","KE":"Kenía","KG":"Kirgistan","KH":"Kambódía","KI":"Kíribatí","KM":"Kómoreyjar","KN":"Sankti Kristófer og Nevis","KP":"Norður-Kórea","KR":"Suður-Kórea","KW":"Kúveit","KY":"Cayman-eyjar","KZ":"Kasakstan","LA":"Laos","LB":"Lebanon","LC":"Sankti Lúsía","LI":"Liechtenstein","LK":"Srí Lanka","LR":"Líbería","LS":"Lesótó","LT":"Litháen","LU":"Lúxemborg","LV":"Lettland","LY":"Líbía","MA":"Marokkó","MC":"Mónakó","MD":"Moldóva","ME":"Svartfjallaland","MF":"Saint-Martin","MG":"Madagaskar","MH":"Marshalleyjar","MK":"Norður-Makedónía","ML":"Malí","MM":"Mjanmar","MN":"Mongólía","MO":"Makaó","MP":"Norður-Maríanaeyjar","MQ":"Martinique","MR":"Máritanía","MS":"Montserrat","MT":"Malta","MU":"Máritíus","MV":"Maldívur","MW":"Malaví","MX":"Mexíkó","MY":"Malasía","MZ":"Mósambík","NA":"Namibía","NC":"Nýja-Kaledónía","NE":"Níger","NF":"Norfolkeyja","NG":"Nígería","NI":"Níkaragva","NL":"Holland","NO":"Noregur","NP":"Nepal","NR":"Naúrú","NU":"Niue","NZ":"Nýja-Sjáland","OM":"Óman","PA":"Panama","PE":"Perú","PF":"Franska Pólýnesía","PG":"Papúa Nýja-Gínea","PH":"Philippines","PK":"Pakistan","PL":"Pólland","PM":"Sankti Pierre og Miquelon","PN":"Pitcairn","PR":"Púertó Ríkó","PS":"Palestína","PT":"Portúgal","PW":"Palá","PY":"Paragvæ","QA":"Katar","RE":"Réunion","RO":"Rúmenía","RS":"Serbía","RU":"Rússland","RW":"Rúanda","SA":"Sádi-Arabía","SB":"Salómonseyjar","SC":"Seychelles-eyjar","SD":"Súdan","SE":"Svíþjóð","SG":"Singapúr","SH":"Sankti Helena","SI":"Slóvenía","SJ":"Svalbarði","SK":"Slóvakía","SL":"Síerra Leóne","SM":"San Marínó","SN":"Senegal","SO":"Sómalía","SR":"Súrínam","SS":"Suður-Súdan","ST":"Saó Tóme og Prinsípe","SV":"El Salvador","SX":"Sint Maarten","SY":"Sýrland","SZ":"Esvatíní","TC":"Turks- og Caicoseyjar","TD":"Tjad","TF":"Frönsku suðlægu landsvæðin","TG":"Tógó","TH":"Taíland","TJ":"Tadsíkistan","TK":"Tókelá","TL":"Austur-Tímor","TM":"Túrkmenistan","TN":"Túnis","TO":"Tonga","TR":"Tyrkland","TT":"Trínidad og Tóbagó","TV":"Túvalú","TW":"Taívan","TZ":"Tansanía","UA":"Úkraína","UG":"Úganda","UM":"Smáeyjar Bandaríkjanna","US":"Bandaríkin","UY":"Úrúgvæ","UZ":"Úsbekistan","VA":"Vatíkanið","VC":"Sankti Vinsent og Grenadínur","VE":"Venesúela","VG":"Bresku Jómfrúaeyjar","VI":"Bandarísku Jómfrúaeyjar","VN":"Víetnam","VU":"Vanúatú","WF":"Wallis- og Fútúnaeyjar","WS":"Samóa","XK":"Kósovó","YE":"Jemen","YT":"Mayotte","ZA":"Suður-Afríka","ZM":"Sambía","ZW":"Simbabve"}}

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

	module.exports = {"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true,"extensions":["atomdeleted"]},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true,"extensions":["dwd"]},"application/atsc-held+xml":{"source":"iana","compressible":true,"extensions":["held"]},"application/atsc-rdt+json":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true,"extensions":["rsat"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true,"extensions":["xcs"]},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/cbor":{"source":"iana"},"application/cbor-seq":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true,"extensions":["cdfx"]},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/clue+xml":{"source":"iana","compressible":true},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["ecma","es"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true,"extensions":["emotionml"]},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true,"extensions":["fdt"]},"application/fhir+json":{"source":"iana","compressible":true},"application/fhir+xml":{"source":"iana","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/flexfec":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true,"extensions":["its"]},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true,"extensions":["lgr"]},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mipc":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true,"extensions":["maei"]},"application/mmt-usd+xml":{"source":"iana","compressible":true,"extensions":["musd"]},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/mrb-publish+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/msc-ivr+xml":{"source":"iana","compressible":true},"application/msc-mixer+xml":{"source":"iana","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/multipart-core":{"source":"iana"},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana"},"application/news-groupinfo":{"source":"iana"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana"},"application/nss":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p2p-overlay+xml":{"source":"iana","compressible":true,"extensions":["relo"]},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana"},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","compressible":true},"application/pidf-diff+xml":{"source":"iana","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true,"extensions":["provx"]},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true,"extensions":["rapd"]},"application/route-s-tsid+xml":{"source":"iana","compressible":true,"extensions":["sls"]},"application/route-usd+xml":{"source":"iana","compressible":true,"extensions":["rusd"]},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true,"extensions":["senmlx"]},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true,"extensions":["sensmlx"]},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/sipc":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/swid+xml":{"source":"iana","compressible":true,"extensions":["swidtag"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/toml":{"compressible":true,"extensions":["toml"]},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana"},"application/ttml+xml":{"source":"iana","compressible":true,"extensions":["ttml"]},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true,"extensions":["rsheet"]},"application/urc-targetdesc+xml":{"source":"iana","compressible":true},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true,"extensions":["1km"]},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.afplinedata-pagedef":{"source":"iana"},"application/vnd.afpc.foca-charset":{"source":"iana"},"application/vnd.afpc.foca-codedfont":{"source":"iana"},"application/vnd.afpc.foca-codepage":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.afpc.modca-formdef":{"source":"iana"},"application/vnd.afpc.modca-mediummap":{"source":"iana"},"application/vnd.afpc.modca-objectcontainer":{"source":"iana"},"application/vnd.afpc.modca-overlay":{"source":"iana"},"application/vnd.afpc.modca-pagesegment":{"source":"iana"},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.ota":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.aplextor.warrp+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["keynote"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true,"extensions":["bmml"]},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.error":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.bpf":{"source":"iana"},"application/vnd.bpf3":{"source":"iana"},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.ciedi":{"source":"iana"},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.cryptii.pipe+json":{"source":"iana","compressible":true},"application/vnd.crypto-shade-file":{"source":"iana"},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.ficlab.flb+zip":{"source":"iana","compressible":false},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.gentics.grd+json":{"source":"iana","compressible":true},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.iso11783-10+zip":{"source":"iana","compressible":false},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las":{"source":"iana"},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.laszip":{"source":"iana"},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.logipipe.circuit+zip":{"source":"iana","compressible":false},"application/vnd.loom":{"source":"iana"},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana"},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true,"extensions":["ac"]},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true,"extensions":["obgx"]},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true,"extensions":["osm"]},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana"},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shade-save-file":{"source":"iana"},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.shopkick+json":{"source":"iana","compressible":true},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true,"extensions":["fo"]},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","compressible":true,"extensions":["ddf"]},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.ves.encrypted":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-keepass2":{"extensions":["kdbx"]},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"apache","extensions":["der","crt","pem"]},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true,"extensions":["xav"]},"application/xcap-caps+xml":{"source":"iana","compressible":true,"extensions":["xca"]},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true,"extensions":["xel"]},"application/xcap-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/xcap-ns+xml":{"source":"iana","compressible":true,"extensions":["xns"]},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true,"extensions":["xlf"]},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana"},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/flexfec":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana","extensions":["mxmf"]},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","compressible":true,"extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana"},"image/avcs":{"source":"iana"},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/hej2k":{"source":"iana","extensions":["hej2"]},"image/hsj2":{"source":"iana","extensions":["hsj2"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jph":{"source":"iana","extensions":["jph"]},"image/jphc":{"source":"iana","extensions":["jhc"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/jxra":{"source":"iana","extensions":["jxra"]},"image/jxrs":{"source":"iana","extensions":["jxrs"]},"image/jxs":{"source":"iana","extensions":["jxs"]},"image/jxsc":{"source":"iana","extensions":["jxsc"]},"image/jxsi":{"source":"iana","extensions":["jxsi"]},"image/jxss":{"source":"iana","extensions":["jxss"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-dds":{"extensions":["dds"]},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana"},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/flexfec":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shex":{"extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana"},"text/vnd.ficlab.flt":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sosi":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/flexfec":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana"},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vnd.youtube.yt":{"source":"iana"},"video/vp8":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

	module.exports = {"name":"employee","version":"26.1.1","description":"employee web","main":"index.js","scripts":{"build":"webpack","dist":"webpack -p --colors --env=dist --customer","deploy":"webpack -p --colors --env=deploy --customer","publish":"webpack -p --colors --env=deploy --customer","start":"node server.js --env=dev","test":"jest","test:watch":"npm test -- --watch --no-cache","coverage":"npm test -- --coverage","cypress:open":"cypress open","spec":"cypress open","analyze":"source-map-explorer dist/dist/ana/*"},"author":"","license":"ISC","dependencies":{"@azure/msal-browser":"2.12.1","@azure/msal-react":"1.0.0-beta.0","@babel/runtime-corejs3":"^7.12.5","@microsoft/applicationinsights-react-js":"^3.1.0","@microsoft/applicationinsights-web":"^2.6.1","axios":"^0.21.0","classlist-polyfill":"^1.0.3","classnames":"^2.2.5","date-input-polyfill":"^2.14.0","detect-browser":"^2.0.0","es6-promise":"^4.1.0","eslint-plugin-jsx-a11y":"^6.0.3","file-saver":"^1.3.8","flexboxgrid":"^6.3.1","focus-trap-react":"^3.0.2","fs":"0.0.1-security","history":"^3.2.1","i18n-iso-countries":"^6.3.0","intl":"^1.2.5","intl-locales-supported":"^1.0.0","jquery":"^3.5.1","jquery-ui":"^1.12.1","left-pad":"^1.1.3","lodash":"^4.17.20","material-ui":"^0.20.1","mdi":"^2.1.19","mime-types":"^2.1.15","moment":"^2.17.1","OrgChart.js":"git+https://github.com/dabeng/OrgChart.js.git","prop-types":"^15.6.0","react":"^16.2.0","react-card-flip":"^1.0.10","react-datepicker":"1.8.0","react-dom":"^16.2.0","react-flexbox-grid":"^2.0.0","react-google-recaptcha":"^2.1.0","react-helmet":"^5.2.0","react-hook-form":"^6.12.2","react-intl":"^2.2.3","react-list":"^0.8.4","react-modal":"^3.12.1","react-motion":"^0.5.2","react-redux":"^7.2.2","react-router":"^3.0.2","react-router-redux":"^4.0.8","react-tap-event-plugin":"^3.0.2","react-time":"^4.2.0","react-ui-tree":"^3.1.0","reapop":"^1.0.0","redux":"^3.6.0","redux-actions":"^2.0.1","redux-batched-subscribe":"^0.1.6","redux-form":"^8.3.7","redux-logger":"^3.0.6","redux-thunk":"^2.2.0","sort-international":"0.0.6","whatwg-fetch":"^2.0.3","xlsx":"^0.17.5"},"devDependencies":{"babel-cli":"^6.24.0","babel-eslint":"^7.1.1","babel-jest":"^19.0.0","babel-loader":"^6.4.1","babel-plugin-module-resolver":"^2.5.0","babel-plugin-transform-class-properties":"^6.23.0","babel-polyfill":"^6.23.0","babel-preset-es2015":"^6.24.0","babel-preset-react":"^6.23.0","babel-preset-stage-0":"^6.22.0","bower-webpack-plugin":"^0.1.9","clean-webpack-plugin":"^0.1.16","copy-webpack-plugin":"^4.0.1","core-js":"^2.4.1","css-loader":"^0.27.3","enzyme":"^2.7.1","eslint":"^4.9.0","eslint-config-airbnb":"^16.1.0","eslint-loader":"^1.6.3","eslint-plugin-babel":"^4.1.1","eslint-plugin-import":"^2.7.0","eslint-plugin-jsx-a11y":"^6.0.2","eslint-plugin-react":"^7.4.0","exports-loader":"^0.6.4","file-loader":"^0.10.1","imports-loader":"^0.7.1","jest":"^19.0.2","jest-webpack-alias":"^3.3.3","jsdom":"^9.12.0","json-loader":"^0.5.4","minimist":"^1.2.8","mocha":"^3.2.0","nock":"^9.0.9","node-sass":"^6.0.0","open":"0.0.5","postcss-loader":"^1.3.3","react-hot-loader":"^3.0.0-beta.6","redux-logger":"^3.0.6","redux-mock-store":"^1.2.2","replace-webpack-plugin":"^0.1.2","sass-loader":"^4.1.1","source-map-explorer":"^1.5.0","style-loader":"^0.19.1","url-loader":"^0.6.2","webpack":"^1.15.0","webpack-dev-server":"^1.16.3","webpack-fail-plugin":"^1.0.6"},"jest":{"moduleNameMapper":{"config":"<rootDir>/src/config/test/index.js","utils(.*)$":"<rootDir>/src/utils/$1","components(.*)$":"<rootDir>/src/components/$1","actions(.*)$":"<rootDir>/src/actions/$1","constants(.*)$":"<rootDir>/src/constants/$1","styles(.*)$":"<rootDir>/src/styles/$1","stores(.*)$":"<rootDir>/src/stores/$1","sources(.*)$":"<rootDir>/src/sources/$1"},"unmockedModulePathPatterns":["<rootDir>/node_modules"],"modulePathIgnorePatterns":["<rootDir>/cfg"],"coverageReporters":["json","lcov","text","html"],"coverageDirectory":"__coverage__"}}

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

	module.exports = {"account.confirmPassword":"Confirm password","account.forgotPassword.message":"Enter your username and press send, an email will be sent containing a link where you can reset your password","account.forgotPassword":"Forgot password","account.login":"Log in","account.loginWindows":"Windows log in","account.loginWithSSO":"Windows log in","account.loginWithXap":"Log in with Kjarni user","account.password":"Password","account.ssoTitle":"Log in with Windows User","account.login.error.default":"Authentication failed","account.title":"Account log in","account.mobileTitle":"Mobile verification","account.mobileAppTitle":"Auðkennisapp","account.phoneNumber":"phone number","account.ssn":"SSN","account.securityCode":"Security code","account.username":"Username","account.usernameemail":"Username / Email","account.wrongPassword":"The username or password is incorrect.","auth.error.user-cancel":"User cancelled","auth.error.ssn.length":"SSN must be 10 digits","auth.error.mobile.length":"Phone number must be 7 digits","auth.error.user-not-found":"User not found","addOption.action":"Create a new {label}","addOption.add":"Add","addOption.cancel":"Cancel","addOption.placeholder":"{label} to be added","agreement.dialog":"Are you sure you want to change the agreement?","agreement.moreInfo":"More information","agreement.no":"No","agreement.noFile":"Attachment needs to be included.","agreement.sign":"I agree","agreement.yes":"Yes","agreements.empty":"No agreements","agreements.error":"Error in agreements","agreements.title":"agreements","alert.cancel":"Cancel","alert.ok":"Agree","answer":"Answer","appLinks.message":"Kjarni offers an app. In the app, staff can search for colleagues, clock in and out, apply for grants, check their vacation leave status and submit a vacation request. You can also see an overview of available courses and register for courses as well as see an overview of your basic information, including payroll information, and maintain some information. If the Kjarni app is a part of your company's agreement, there are shortcuts to downloading the app below.","appLinks.title":"Kjarni Companion App","appraisal.alert.save":"Not all answers are saved! Are you sure you want to leave?","appraisal.alert.submit":"Are you sure you want to send? Answers cannot be changed after they have been sent.","appraisal.answer.fail":"Answer period expired","appraisal.answer":"Answered","appraisal.conversation":"Employee conversation","appraisal.conversation.archive":"Previous Employee conversation","appraisal.development":"Development conversation","appraisal.development.archive":"Previous Development conversation","appraisal.discussion":"Discussion","appraisal.discussion.archive":"Previous Discussion","appraisal.employee":"Employee","appraisal.error.closed":"This appraisal is closed and cannot be changed.","appraisal.error.form":"Theis appraisal does not contain a performance appraisal form.","appraisal.error.mine":"This appraisal is not yours to fill out.","appraisal.error.required":"Not all fields answered","appraisal.error":"Something went wrong.","appraisal.expired":"Expired","appraisal.finished":"Finished","appraisal.finalResult":"Result","appraisal.inProgress":"In progress","appraisal.manager":"Manager","appraisal.notStarted":"Not started","appraisal.noAppraisal":"No data.","appraisal.notification.saved.message":"Data has been saved","appraisal.notification.saved":"Saved","appraisal.notification.submitted.message":"Data has been saved","appraisal.notification.submitted":"Submitted","appraisal.save":"Save and send later","appraisal.select.employee":"Select an employee to filter by","appraisal.select.year":"Select a year to filter by","appraisal.submit.fail":"Submit period expired","appraisal.submit":"Finish","appraisal.timeToFinish":"Time to finish appraisal","appraisal.title.employee.tab":"Employee answers","appraisal.title.employee":"Employee answers","appraisal.title.me.tab":"My answers","appraisal.title.me":"Performance appraisal","appraisal.title":"Performance appraisal","approvals.error":"Error fetching approvals","approval.type":"Approval type","approval.date.from":"From","approval.date.to":"To","approval.status":"Approval status","approval.status.Pending":"Pending","approval.status.Accepted":"Approved","approval.status.Rejected":"Rejected","approval.status.Canceled":"Canceled","approval.status.Expired":"Unprocessed","approval.type.EmployeeDetailVacationsHandler":"Vacation request","approval.type.ClockCardEntriesHandler":"Vacation request","approval.type.PerDiemRecordsHandler":"Per diem request","approval.type.CourseAttendeesHandler":"Course registration","approval.type.EmployeeMasterCoursesHandler":"Educational request","approval.type.ClockCardEntriesController":"Vacation request","approval.type.PerDiemsHandler:":"Per diem request","approval.type.EmployeeDetailPerDiemsHandler":"Per diem request","approval.type.PerDiemRecordsController":"Per diem request","approval.type.CourseAttendeesController":"Course registration","approval.type.EmployeeMasterCoursesController":"Educational request","approvalRequest.create.error":"Failed to create request","approvalRequest.create.error.missingEmail":"No e-mail registered for approver","approvalRequest.create.success":"Request successfully created","approvalRequest.form.cost":"Cost","approvalRequest.form.description":"Description","approvalRequest.form.from":"Start date","approvalRequest.form.hoursPerDay":"Hours per day","approvalRequest.form.location":"Country","approvalRequest.form.organizer":"Organizer","approvalRequest.form.title":"Title","approvalRequest.form.to":"End date","approvalRequest.form.totalHours":"Total hours","April":"April","August":"August","back":"Back","bank.account":"Account","bank.add":"Add","bank.branch":"Bank","bank.edit":"Edit","bank.error":"Something went wrong.","bank.errorAccount":"Invalid account number.","bank.errorBranch":"Kjarni does not recognize the bank number.","bank.errorLedger":"Kjarni does not recognize the ledger.","bank.ledger":"Ledger","bank.none":"No wage account on file.","bank.save":"Save","bank.title":"Wage Account","benefit.amount":"Amount available: {val} kr","benefit.apply":"Apply","benefit.empty":"No grants/health benefits were found","benefit.grant.title":"Grants","benefit.health.title":"Health benefits","benefit.loading":"Loading..","benefit.notification.title":"File has been uploaded","benefit.notification.uploadMessageSuccess":"{Name} has been added to your file repository","benefit.payRecordSumRemaining":"Remaining balance: {val} kr","benefit.receipt.hint":"Please enter amount","benefit.receipt":"Requested amount","benefit.request":"Request grant","benefit.saveFile":"Save file","benefit.sendFile":"Send file","benefit.validUntil":"Agreement valid until: {val}","Bonuses":"Bonuses","career.city":"City","career.country":"Country","career.employer":"Employer","career.empty":"No previous employers on record","career.from":"From","career.job":"Job title","career.title":"Previous employers","career.to":"To","certificate.empty":"No certificate on record","certificate.from":"Valid from","certificate.name":"Certificate","certificate.title":"Certificates","certificate.to":"Valid to","certificate.type":"Type","comment":"Comment","course.attending.female":"Registered","course.attending.male":"Registered","course.attending":"Registered","course.comments":"Comments","course.description":"Description","course.empty":"No courses on record","course.end":"Finished","course.group":"Group","course.length":"Duration (hrs)","course.location":"Location","course.name":"Name","course.noDescription":"No description for this event","course.points":"Points","course.requiresApproval":"Requires approval","course.room":"Room","course.soon":"Soon","course.start":"Started","course.started":"Started","course.title":"Courses","course.today":"Today","course.tomorrow":"Tomorrow","course.type":"Type","courseApprovalRequest.button":"New request","courseApprovalRequest.description":"Here you can submit a request to attend a course or conference. The request will be sent to your supervisor for approval.","courseAttendeeType.0":"None","courseAttendeeType.1":"Registered","courseAttendeeType.2":"Waitinglist","courseAttendeeType.3":"Canceled","courseAttendeeType.4":"Didn't attend","courseAttendeeType.5":"Waiting for approval","courseAttendeeType.6":"Registration rejected","courseAttendeeType.7":"Waiting for approval, on waitinglist","courseEval.save":"Save","courseEval.submit":"Finish","courseEval.title":"Course evaluations","courses.alert":"Are you sure you want to leave the course?","courses.attend":"Register","courses.attending.female":"Registered courses","courses.attending.male":"Registered courses","courses.attending":"Registered courses","courses.available":"Available courses","courses.close":"Close","courses.CourseDeadlineEnd":"Cancellation deadline","courses.CourseDeadlineStart":"Registration deadline","courses.date":"Date","courses.description":"Description","courses.details":"Details","courses.empty":"Nothing available today","courses.end":"Ends","courses.group":"Course group","courses.instructor":"Instructor","courses.leave":"Leave","courses.length":"Length","courses.duration.value":"{hours,plural,=0 {} =1 {{hours} hour} other {{hours} hours}} {minutes,plural,=0 {} =1 { {minutes} minute} other { {minutes} minutes}}","courses.location":"Location","courses.name":"Name","courses.noAttending":"Not registered for any courses","courses.noOpen":"No courses available","courses.price":"Price","courses.pricePerAttendee":"Price {price} kr. per attendee based on {attendees} attendees","courses.registered":"Attending","courses.room":"Room","courses.start":"Starts","courses.status":"Status","courses.times":"Times","courses.title":"Courses","courses.type":"Course type","dash.title.agreements":"Agreements","dash.title.appraisals.archive":"Previous Appraisals","dash.title.appraisals":"Performance appraisal","dash.title.approvals":"My requests","dash.title.benefits":"Health benefits","dash.title.birthdays":"Birthdays","dash.title.courseApprovalRequest":"Learning request","dash.title.courses":"Courses","dash.title.evaluations":"Course evaluations","dash.title.events":"Events and courses","dash.title.files":"My files","dash.title.grants":"Grants","dash.title.holiday":"Vacation","dash.title.holidayApprovalRequest":"Holiday request","dash.title.links":"Links","dash.title.newEmployees":"New employees","dash.title.payslips":"Payslips","dash.title.paytickets":"Pay statement","dash.title.perDiem":"Per diem request","dash.title.profile":"My details","dash.title.punchClock":"Time entries - Punch clock","dash.title.timeEntries":"Time entries - Registrations","dash.title.timeEntries.Absence":"Time entries - Registrations","dash.title.transportations":"Transportation grants","dash.title.workAniversary":"Seniority","December":"December","editPanel.add":"Add entry","editPanel.alert":"Are you sure you want to delete the entry?","editPanel.close":"Close","editPanel.delete":"Delete","editPanel.detail":"Details","editPanel.edit":"Edit","editPanel.exportExcel":"Export to Excel","editPanel.matchesPreviousPassword":"Confirmed password is different","editPanel.pattern":"Password needs to be at least 12 characters long and include a capital letter, lowercase letter and a special character","editPanel.refresh":"Refresh","editPanel.required":"This field is required","editPanel.save":"Save","education.branch1":"Main branch of study","education.branch2":"Secondary branch Of study","education.country":"Country","education.degree":"Degree / Certificate","education.empty":"No education on record","education.end":"Finished degree","education.grade":"Grade","education.highest":"Highest education","education.info":"Additional information","education.no":"No","education.school":"Institution","education.start":"Started degree","education.title":"Education","education.type.apprentice":"Apprenticeship","education.type.highschool":"High school","education.type.internship":"Internship","education.type.primary":"Primary school","education.type.university":"University","education.type.unknown":"Unknown","education.type":"Education type","education.yes":"Yes","employee":"Employee","employeeSearch.button":"Search","employeeSearch.close":"Close","employeeSearch.company":"Company","employeeSearch.costCenter":"Cost center","employeeSearch.department":"Department","employeeSearch.division":"Division","employeeSearch.email":"Email","employeeSearch.location":"Location","employeeSearch.manager":"Manager","employeeSearch.mobile":"Mobile","employeeSearch.noresult":"No results","employeeSearch.phone":"Phone","employeeSearch.placeholder":"Search for employees","employeeSearch.qualificationToggle":"Find employee by qualification","employeeSearch.title":"Job title","EmployeeUnion.number":"Number","EmployeeUnion":"Employee union","events.title":"Events and courses","expires":"Expires","error":"Error fetching {name}","Error.AccessDenied":"Access denied","February":"February","forgotPassword.notification":"Request sent","forgotPassword.validationError":"Please fill out the username field and confirm that you are not a robot","Hide":"Hide","holiday":"Vacation","holiday.days":"{val} days","holiday.earned":"Earned vacation pay available after 1. May {year}","holiday.error":"Something went wrong.","holiday.firstOfMay":"Status 1. May {year}","holiday.hours":"{val} hours","holiday.settlement":"Settled vacation pay","holiday.showByHour":"Show hours","holiday.sum":"Remaining vacation pay","holiday.taken":"Used vacation pay from 1. May {year}","holiday.title.year":"Vacation {year}","holiday.label.year":"Vacation year","holiday.title":"Vacation pay overview","holiday.total":"Total vacation pay","holiday.unpaid":"Unpaid vacation","holiday.usedVacation":"Used vacation","holiday.workTime":"Your work commitment is {hours} hours","holiday.vacationApprovals":"Holiday overview","holiday.Accepted":"Accepted","holiday.Pending":"Pending","holiday.Rejected":"Rejected","holiday.Expired":"Expired","holidayApprovalRequest.button":"New request","holidayApprovalRequest.description":"Here you can submit a request to apply for vacation. The request will be sent to your supervisor for approval.","holidayApprovalRequest.timeError":"Start date must be before end date","holidayApprovalRequest.timeError.beforeCurrentDate":"Not possible to create a holiday request in the past.","holidayOverview.winterAddition.title":"Already corrected winter addition","hours":"{val, plural, one {hour} other {hours}}","inOut.title":"In/Out","inOut.type":"Type","inOut.employee.all":"All","inOut.selectAll":"Select all","inOut.type.all":"All","inOut.type.daytime":"Business hours","inOut.type.overtime":"Overtime","inOut.type.absence":"Absent","inOut.type.moreThanOne":"More than one register","ISK":"{amount} kr.","January":"January","July":"July","June":"June","loading.message":"Fetching data...","loan.amount":"Amount","loan.begda":"Valid from","loan.endda":"Valid to","loan.objectNumber":"Object id","loan.pieces":"Pieces","loan.title":"Objects on loan","loan.type":"Object type","loan.empty":"No objects on loan","March":"March","May":"May","name":"Name","newPassword.capital":"Needs to contain a capital letter","newPassword.currentPassword":"Current password","newPassword.error":"Current password incorrect.","newPassword.length":"Password too short, min 8","newPassword.letter":"Needs to contain a lowercase letter","newPassword.match":"Passwords do not match","newPassword.newPassword":"New password","newPassword.newPasswordConfirm":"Confirm password","newPassword.number":"Needs to contain a number","newPassword.required":"Required","newPassword.save":"Save","newPassword.special":"Needs to contain a special character","newPassword.title":"Change password","No.employee.union":"No employee union registered.","No.pay.union":"No pay union registered.","No.pension.fund":"No pension fund registered.","No.private.pension.fund":"No optional pension fund registered.","notification.create.contact.hr":"Registration has been sent to human resources for review.","notification.create.message":"The entry has been created","notification.create.title":"Created","notification.delete.message":"The entry has been deleted","notification.delete.title":"Deleted","notification.error.auth":"The user does not have authorization to add, change or delete the entry. Please contact HR","notification.error.title":"Operation failed","notification.register.full":"Registration did not succeed, not places available","notification.register.title":"Registration","notification.ResetPassword.Error":"Could not update password","notification.ResetPassword.Success":"Password has been updated","notification.save.message":"The entry has been saved","notification.save.title":"Saved","notification.transportRegister.message":"Request for transportation grant received","notification.transportRegister.title":"Success","November":"November","October":"October","Pagination.PerPage":"{items} / page","Pagination.TotalPages":"Page {page} of {pages}","panel.actions":"Actions","panel.empty":"No information to display","PayEducationBonus":"Education bonus","PayLifelongEducationBonus":"Continuous education bonus","PayLoyaltyBonus":"Loyalty bonus","PayManagementBonus":"Management bonus","payticket.download":"Download","payticket.empty":"There are no pay statement to view for this year.","payticket.error":"Error occurred when fetching Pay statement.","payticket.select":"Pay period","payticket.ticket":"Pay statement","payticket.title":"Pay statement","payticket.column":"Column","payticket.name":"Name","payticket.total":"Total","payticket.field":"Field","payticket.totalField":"Pay statement field total","payslip.download":"Download","payslip.empty":"There are no payslips to view.","payslip.error":"Error occurred when fetching payslips.","payslip.select":"Pay period","payslip.title":"Payslips","Pension.company.percentage":"Company %","Pension.employee.percentage":"Employee %","Pension.fund.number":"Number","Pension.fund":"Pension fund","PerDiem.Button":"New request","PerDiem.Create.Error":"Failed to create request","PerDiem.Create.Success":"Request successfully created","PerDiem.Days":"days","PerDiem.Description":"Here you can submit a request to apply for per diem. The request will be sent to your supervisor for approval.","PerDiem.PerDiemAmountType":"Type","PerDiem.PerDiemAmountTypeEnum.Accommodation":"Accommodation","PerDiem.PerDiemAmountTypeEnum.None":"None","PerDiem.PerDiemAmountTypeEnum.Other":"Other","PerDiem.PerDiemAmountTypeEnum.Total":"Total","PerDiem.PerDiemLocationID":"Location","PerDiem.PerDiemTypeID":"Category","PerDiem":"Per diem","PerDiemCalculated.Days":"Days","PerDiemCalculated.EstimatedTaxISK":"Estimated cash payment","PerDiemCalculated.ExchangeRate":"Exchange rate {currency}","PerDiemCalculated.TotalAmountCurrency":"Amount {currency}","PerDiemCalculated.TotalAmountISK":"Amount","PerDiemCalculated.TotalAmountPrepaidPaymentCurrency":"Prepaid (emp. currency) {currency}","PerDiemCalculated":"Calculation details","PerDiemComment.Custom":"Purpose of the trip","pickNewPassword":"Pick a new password","print":"Print","Private.pension.fund.number":"Number","Private.pension.fund":"Optional pension fund","profile.accessCard":"Access card","profile.add":"Add","profile.address":"Address","profile.addressPlace":"Address (place)","profile.addressStreet":"Address (street & number)","profile.age":"Age","profile.alert":"Are you sure you want to close before saving?","profile.bankInfo":"Pay","profile.basicInfo":"Profile","profile.child.birthYear":"Birth year","profile.child.gender":"Gender","profile.child.name":"Name","profile.close":"Close","profile.comInfo":"Communication","profile.countryCode.mobile":"Country code for mobile","profile.delete":"Delete","profile.editChildren":"Edit","profile.editProfile":"Edit","profile.email":"Email","profile.employeeMaster":"My information","profile.employeeMasterID":"Employee id","profile.family":"Children","profile.gender.female":"Female","profile.gender.male":"Male","profile.gender.unknown":"Undefined","profile.gender":"Gender","profile.lastHire":"Hire Date","profile.legalAddress":"Legal address","profile.mobile":"Mobile","profile.org.company":"Company","profile.org.costCenter":"Cost center","profile.org.division":"Division","profile.org.employeeDetailID":"Employee pay id","profile.org.group":"Type","profile.org.jobDescription":"Job description","profile.org.location":"Location","profile.org.manager":"Manager","profile.org.position":"Position","profile.org.positionAlt":"Position alt","profile.org.status":"Status","profile.org.unit":"Unit","profile.phone":"Phone","profile.recruitingDate":"Seniority","profile.recruitingDatePay":"Pay seniority","profile.relative.name":"Name","profile.relative.phone":"Phone","profile.relative.relation":"Relation","profile.relative":"Emergency contact","profile.relative2":"Emergency contact 2","profile.relativeAssociation.other":"Other","profile.relativeAssociation.parent":"Parent","profile.relativeAssociation.relative":"Relative","profile.relativeAssociation.sibling":"Sibling","profile.relativeAssociation.spouse":"Spouse","profile.relativeAssociation.unknown":"Undefined","profile.relativeEmail":"Contact email","profile.relativeAddress":"Contact address","profile.relativeName":"Contact full name","profile.relativePhone":"Contact phone","profile.relativePhoneMobile":"Contact mobile phone","profile.relativeRelation":"Contact relation","profile.relog":"An error ocured when trying to fetch the data. Please try loging back in.","profile.save":"Save","profile.saveclose":"Save & close","profile.ssn":"Social security number","profile.tab.children":"Children","profile.tab.communication":"Communication","profile.tab.relative":"Emergency contacts","profile.tetra":"Mobile 2","profile.username":"Username","profile.workEmail":"Work email","profile.workPhone":"Work phone","qaelement.answer.comment":"Reasoning for answer","qaelement.answer.employee":"Employees answer","qaelement.answer.final":"Conclusion","qaelement.answer.manager":"Managers answer","qaelement.input.select":"Click here to select an option","qaelement.input.text":"Please write your answer in the text box","qualification.empty":"No qualification on record","qualification.name":"Qualification","qualification.scale":"Skill","qualification.title":"Qualifications","qualification.type":"Type","questionnaire.submit":"Register","questionnaire.submitFailed":"Form is not properly filled out","questionnaire.title":"Additional questions","repository.alert":"Are you sure you want to delete ","repository.all":"All","repository.chooseFile":"Choose file","repository.delete":"Delete","repository.download":"Download","repository.error":"Error in file repository.","repository.errorSize":"The file is too large, (max 10 MB).","repository.errorType":"File type is required.","repository.fileType":"File type","repository.noFiles.CanAdd":"You do not own any files. Use the uploader above to add new files.","repository.noFiles":"You do not own any files.","repository.noFilesFilter":"No files match the search query.","repository.refresh":"Refresh","repository.save":"Save","repository.search":"Search","repository.title":"My files","repository.uploadTitle":"File upload","sending.message":"Sending data...","send":"Send","September":"September","submit":"Submit","taxCard.create":"Add","taxCard.edit":"Change","taxCard.errorUnused.invalid":"Invalid amount.","taxCard.errorUnused.max":"Amount is too high for current period.","taxCard.errorUnused.noLast":"Need to select valid from date as well.","taxCard.lastUsed":"Use from","taxCard.none.employee":"No tax card registered to employee.","taxCard.none.spouse":"No tax card registered to spouse.","taxCard.none.EmployeeMasterTaxCard":"No tax card registered to employee.","taxCard.none.EmployeeMasterTaxCardSpouse":"No tax card registered to spouse.","taxCard.percent":"Percentage","taxCard.save":"Save","taxCard.title.employee":"Tax card","taxCard.title.spouse":"Spouse tax card","taxCard.unused":"Unused tax discount","taxCards.title":"Tax card","teria.cafeteria":"Cafeteria","teria.cafeteria.description":"Description","teria.cafeteria.type":"Type","teria.cafeteria.employeeGuest":"Employee guest","teria.guests":"Guests","teria.noProducts":"No data for chosen period","teria.store":"Store","teria.price":"Price","teria.product":"Product","teria.title":"Cafeterias and stores","tile.appraisals.empty":"Nothing planned","tile.appraisals.error":"Error fetching appraisals","tile.appraisals.goto":"See older","tile.appraisals.handin":"Not handed in","tile.appraisals.managerDivider":"Employee appraisals","tile.appraisals.start":"Not started","tile.benefits.empty":"No health benefits were found","tile.birthdays.empty":"No birthdays today","tile.birthdays.error":"Error fetching birthday data","tile.courses.empty":"No courses available","tile.courses.error":"Error fetching courses","tile.courses.goto":"View all courses","tile.error":"An error occurred: {error}","tile.evaluation.empty":"No incomplete evaluations","tile.evaluation.error":"Error loading data","tile.evaluation.handin":"Not handed in","tile.evaluation.start":"Not started","tile.events.attending.female":"Registered","tile.events.attending.male":"Registered","tile.events.attending":"Registered","tile.events.empty":"No events available","tile.events.error":"Error fetching events","tile.events.goto":"View all events","tile.files.empty":"No files","tile.files.goto":"See all files","tile.grants.empty":"No grants were found","tile.grants.error":"Error fetching transportation grants","tile.holiday.allowance":"Vacation allowance","tile.holiday.earned":"Earned for {year}","tile.holiday.earned1":"Earned vacation","tile.holiday.empty":"No vacation available","tile.holiday.error":"Error fetching vacation","tile.holiday.firstOfMay":"Status May 1st {year}","tile.holiday.goto":"View details","tile.holiday.period":"1.5.{year} - 30.4.{nextYear}","tile.holiday.settlement":"Settled vacation pay","tile.holiday.sum":"Remaining vacation","tile.holiday.taken":"Used from May 1st {year}","tile.holiday.workTime":"Work commitment","tile.loading":"Loading","tile.payslips.empty":"No payslips","tile.payslips.goto":"See all payslips","tile.profile.division":"Division","tile.profile.emailWork":"Work Email","tile.profile.goto":"View all my details","tile.profile.manager":"Manager","tile.profile.position":"Position","tile.profile.ssn":"Social security number","tile.profile.unit":"Unit","tile.time.goto":"See more","tile.transportations.goto":"View all grants","tile.transportations.title":"Transportation grants","time.ActualClockTime":"Hours","time.alert.delete":"Are you sure you want to delete {count, number} {count, plural, one {record} other {records}}?","time.cancel":"Cancel","time.ClockIn":"In","time.ClockOut":"Out","time.NumberOfHours":"Number of hours","time.Comment":"Comment","time.create":"Create","time.CreateEntry":"Log time","time.Date":"Date","time.DateIn":"Date from","time.DateOut":"Date to","time.error.DateOutBeforeDateIn":"Date from has to be before date to","time.error.TimeOutBeforeTimeIn":"In time has to be before out time","time.error.inAndOutSame":"In time and out time cannot be the same","time.error.MoreThanZero":"Number of hours must be greater than 0","time.error.MoreThan24HoursError":"Time registrations spans more than 24 hours. Please review and select \"Period\" if registration covers more than 1 day.","time.error.MoreThan24HoursTimeSpanError":"Time registrations spans more than 24 hours.","time.error":"Error occurred","time.expectedHours":"Work obligation of the period","time.halfDay":"Half Day","time.HasError.Tooltip":"Clock times need to be reviewed","time.HasError":"Error","time.hours":"{hours} hrs","time.initialize.error":"Error has occurred","time.notification.batch.created":"Entries created","time.notification.delete.title":"Entry deleted","time.notification.patch.title":"Entry saved","time.notification.post.title":"Entry created","time.PunchIn":"Clock in","time.PunchOut":"Clock out","time.registerRedDays":"Register red days","time.RegisterWeekends":"Register weekends","time.selectTime":"Select time","time.span":"Period","time.TimeEntries":"Logging time","time.title":"Time entries","time.totalHours.span":"Hours per day","time.totalHours":"Total hours","time.Type":"Type","time.Approver":"Approver","time.update":"Save","time.wholeDay":"Whole day","time.TimeBehind":"Time behind","time.warningText.NotEnoughVacationHours":"Not possible to register holiday as there is not enough holiday accrual. Please check your holiday balance and try again later.","time.warningText.NotEnoughFirstOfMaiHours":"Not enough unused holiday. Holiday balance will be negative and the holiday hours will be subtracted from next years holiday.","time.error.NotEnoughSickHours":"Not posible to register sickness as there is not enough sick leave accural.","time.error.NotEnoughSickHours.Many":"Not posible to register sickness for all days in selected period as there is not enough sick leave accural.","time.workedHours":"Logged","time.HalfDayWarning.Description":"Registration covers the days of December 24th and/or 31st. Please note that time must be recorded separately on those days.","toolbar.agreements":"Agreements","toolbar.appraisal.archive":"Previous Appraisals","toolbar.appraisal":"Performance appraisal","toolbar.benefits":"Benefits","toolbar.courses":"Courses","toolbar.events":"Events and courses","toolbar.grants":"Grants","toolbar.holiday":"Vacation","toolbar.logout":"Log out","toolbar.menu":"Menu","toolbar.orgchart":"Organizational chart","toolbar.payroll":"Pay info","toolbar.payslip":"Payslips","toolbar.profile":"My profile","toolbar.repository":"My files","toolbar.search":"Employee search","toolbar.searchField":"Search","toolbar.settings":"Settings","toolbar.transportationGrants":"Transport grants","transportationGrant.active":"Transportation grant is active.","transportationGrant.AmountPerMonth":"Amount per month:","transportationGrant.error":"Data missing or incorrect","transportationGrant.Months":"Months:","transportationGrant.period":"period:","transportationGrant.register.finish":"Send","transportationGrant.register":"Register","transportationGrants.duplicate":"You have already registered for this grant in the period.","transportationGrants.empty":"No gratns are available at the moment.","transportationGrants.error":"Error fetching grants: {error}","transportationGrants.title":"Transportation grants","Truncate.Less":"See less","Truncate.More":"See more","Union.number":"Number","Union":"Union","unused":"Unused"}

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

	module.exports = {"account.confirmPassword":"Staðfesta lykilorð","account.forgotPassword.message":"Sláðu inn notandanafn og ýttu á Senda, tölvupóstur verður sendur með hlekk til að endursetja lykilorð","account.forgotPassword":"Gleymt lykilorð","account.login":"Innskrá","account.loginWindows":"Windows innskráning","account.loginWithSSO":"Windows innskráning","account.loginWithXap":"Innskrá með Kjarna notanda","account.password":"Lykilorð","account.ssoTitle":"Innskráning með Windows notanda","account.login.error.default":"Innskráning mistókst","account.title":"Innskráning","account.mobileTitle":"Rafræn innskráning","account.securityCode":"Öryggiskóði","account.mobileAppTitle":"Auðkennisapp","account.mobileAppButton":"Innskrá með Auðkennisappi","account.phoneNumber":"Símanúmer","account.ssn":"Kennitala","account.username":"Notandanafn","account.usernameemail":"Notandanafn / netfang","account.wrongPassword":"Notandanafn eða lykilorð var rangt. Vinsamlegast reyndu aftur.","auth.error.user-cancel":"Notandi hætti við","auth.error.ssn.length":"Kennitala þarf að vera 10 stafir","auth.error.mobile.length":"Símanúmer þarf að vera 7 stafir","auth.error.user-not-found":"Notandi fannst ekki","addOption.action":"Stofna nýja {label} í lista","addOption.add":"Bæta við","addOption.cancel":"Hætta við","addOption.placeholder":"{label} sem á að bæta við","agreement.dialog":"Ertu viss um að þú viljir breyta?","agreement.moreInfo":"Nánari upplýsingar","agreement.no":"Nei","agreement.noFile":"Viðhengi þarf að fylgja.","agreement.sign":"Ég samþykki","agreement.yes":"Já","agreements.empty":"Engin samþykki","agreements.error":"Upp kom villa","agreements.title":"Samþykki","alert.cancel":"Hætta við","alert.ok":"Samþykkja","answer":"Svara","appLinks.message":"Kjarni býður upp á app. Í app-inu getur starfsfólk m.a. leitað að samstarfsfólki, stimplað sig inn og út, sótt um styrki, skoðað orlofsstöðu sína og sent inn orlofsbeiðni. Einnig er hægt að sjá yfirlit yfir námskeið í boði og skrá sig á námskeið ásamt því að sjá yfirlit yfir grunnupplýsingar sínar, þ.m.t. launaupplýsingar, og viðhalda ákveðnum upplýsingum. Ef Kjarna app-ið er hluti af Kjarnasamningi þíns fyrirtækis þá eru hér að neðan flýtileiðir til að sækja app-ið.","appLinks.title":"Sækja Kjarna appið","appraisal.alert.save":"Ekki eru öll gögn vistuð! Vilt þú örugglega fara af síðunni?","appraisal.alert.submit":"Ertu viss um að þú viljir senda? Ekki er hægt að breyta svörum eftir að búið er að senda.","appraisal.answer.fail":"Svarfrestur liðinn","appraisal.answer":"Svarað","appraisal.conversation":"Starfsmannasamtal","appraisal.conversation.archive":"Eldri starfsmannasamtal","appraisal.development":"Starfsþróunarsamtal","appraisal.development.archive":"Eldri starfsþróunarsamtal","appraisal.discussion":"Samtal","appraisal.discussion.archive":"Eldri samtal","appraisal.employee":"Starfsmaður","appraisal.error.closed":"Þetta frammistöðumat er lokað og því ekki hægt að breyta því.","appraisal.error.form":"Frammistöðumatseyðublað er ekki skráð.","appraisal.error.mine":"Þetta frammistöðumat er ekki skráð á þig.","appraisal.error.required":"Ekki eru öll svæði rétt útfyllt","appraisal.error":"Eitthvað fór úrskeiðis.","appraisal.expired":"Útrunnin","appraisal.finished":"Lokið","appraisal.finalResult":"Niðurstaða","appraisal.inProgress":"Í vinnslu","appraisal.manager":"Yfirmaður","appraisal.notStarted":"Ekki hafið","appraisal.noAppraisal":"Engin gögn","appraisal.notification.saved.message":"Gögn hafa verið vistuð","appraisal.notification.saved":"Vistað","appraisal.notification.submitted.message":"Gögn hafa verið vistuð","appraisal.notification.submitted":"Skilað","appraisal.save":"Vista og senda seinna","appraisal.select.employee":"Veldu starfsmann til að flokka eftir","appraisal.select.year":"Veldu ár til að flokka eftir","appraisal.submit.fail":"Skilafrestur liðinn","appraisal.submit":"Ljúka","appraisal.timeToFinish":"Tími til að klára frammistöðumat","appraisal.title.employee.tab":"Svör starfsfólks","appraisal.title.employee":"Svör starfsfólks","appraisal.title.me.tab":"Mín svör","appraisal.title.me":"Frammistöðumat","appraisal.title":"Frammistöðumat","approvals.error":"Villa við að sækja beiðnir","approval.type":"Tegund beiðni","approval.date.from":"Frá","approval.date.to":"Til","approval.status":"Staða beiðni","approval.status.Pending":"Óafgreidd","approval.status.Accepted":"Samþykkt","approval.status.Rejected":"Hafnað","approval.status.Canceled":"Hætt við","approval.status.Expired":"Óafgreidd","approval.type.EmployeeDetailVacationsHandler":"Orlofsbeiðni","approval.type.ClockCardEntriesHandler":"Orlofsbeiðni","approval.type.ClockCardEntriesController":"Orlofsbeiðni","approval.type.PerDiemRecordsHandler":"Dagpeningabeiðni","approval.type.PerDiemsHandler:":"Dagpeningabeiðni","approval.type.EmployeeDetailPerDiemsHandler":"Dagpeningabeiðni","approval.type.PerDiemRecordsController":"Dagpeningabeiðni","approval.type.CourseAttendeesHandler":"Skráning á námskeið","approval.type.CourseAttendeesController":"Skráning á námskeið","approval.type.EmployeeMasterCoursesHandler":"Fræðslubeiðni","approval.type.EmployeeMasterCoursesController":"Fræðslubeiðni","approvalRequest.create.error":"Ekki tókst að stofna beiðni","approvalRequest.create.error.missingEmail":"Netfang er ekki skráð á samþykkjanda","approvalRequest.create.success":"Beiðni hefur verið stofnuð","approvalRequest.form.cost":"Kostnaður","approvalRequest.form.description":"Lýsing","approvalRequest.form.from":"Upphafsdagur","approvalRequest.form.hoursPerDay":"Klst. á dag","approvalRequest.form.location":"Land","approvalRequest.form.organizer":"Skipuleggjandi","approvalRequest.form.title":"Viðburður","approvalRequest.form.to":"Lokadagur","approvalRequest.form.totalHours":"Heildarfjöldi klst","April":"Apríl","August":"Ágúst","back":"Til baka","bank.account":"Reikningsnr.","bank.add":"Skrá","bank.branch":"Banki","bank.edit":"Breyta","bank.error":"Eitthvað fór úrskeiðis.","bank.errorAccount":"Ekki leyfilegt Reikningsnr.","bank.errorBranch":"Kjarni þekkir ekki þetta bankanúmer.","bank.errorLedger":"Kjarni þekkir ekki þessa höfuðbók.","bank.ledger":"Hb","bank.none":"Enginn launareikningur er skráður.","bank.save":"Vista","bank.title":"Launareikningur","benefit.amount":"Upphæð í boði: {val} kr","benefit.apply":"Sækja um","benefit.empty":"Engir styrkir/heilsueflingar fundust","benefit.grant.title":"Styrkir","benefit.health.title":"Heilsuefling","benefit.loading":"Hleð..","benefit.notification.title":"Skjali bætt við","benefit.notification.uploadMessageSuccess":"{Name} hefur verið bætt í skjalaskáp","benefit.payRecordSumRemaining":"Eftirstöðvar: {val} kr","benefit.receipt.hint":"Sláðu inn upphæð","benefit.receipt":"Upphæð styrks","benefit.request":"Sækja um","benefit.saveFile":"Vista skjal","benefit.sendFile":"Senda skjal","benefit.validUntil":"Samningur í gildi til: {val}","Bonuses":"Álag","career.city":"Staður","career.country":"Land","career.employer":"Vinnuveitandi","career.empty":"Enginn starfsferill skráður","career.from":"Hóf störf","career.job":"Starfsheiti","career.title":"Starfsferill","career.to":"Lauk störfum","certificate.empty":"Engin réttindi skráð","certificate.from":"Gildir frá","certificate.name":"Réttindi","certificate.title":"Réttindi","certificate.to":"Gildir til","certificate.type":"Tegund","comment":"Athugasemd","course.attending.female":"Skráð","course.attending.male":"Skráður","course.attending":"Skráð(ur)","course.comments":"Athugasemdir","course.description":"Lýsing","course.empty":"Engin námskeið skráð","course.end":"Lauk","course.group":"Námskeiðsflokkur","course.length":"Lengd (klst)","course.location":"Staðsetning","course.name":"Heiti námskeiðs","course.noDescription":"Ekki nein lýsing fyrir þennan viðburð","course.points":"Punktafjöldi","course.requiresApproval":"Krefst samþykkis","course.room":"Stofa","course.soon":"Fljótlega","course.start":"Hóf","course.started":"Hafið","course.title":"Námskeið","course.today":"í dag","course.tomorrow":"Á morgun","course.type":"Tegund námskeiðs","courseApprovalRequest.button":"Sækja um","courseApprovalRequest.description":"Hér getur þú óskað eftir því að fara á námskeið eða ráðstefnu. Beiðnin verður send á næsta yfirmann til samþykktar.","courseAttendeeType.0":"Óskilgreint","courseAttendeeType.1":"Skráð{Gender,plural,=1 {ur} other {}}","courseAttendeeType.2":"Á biðlista","courseAttendeeType.3":"Hætti við","courseAttendeeType.4":"Mætti ekki","courseAttendeeType.5":"Bíður samþykkis","courseAttendeeType.6":"Skráningu hafnað","courseAttendeeType.7":"Bíður samþykkis á biðlista","courseEval.save":"Vista","courseEval.submit":"Ljúka","courseEval.title":"Námskeiðsmat","courses.alert":"Ertu viss um að þú viljir afskrá þig úr námskeiðinu?","courses.attend":"Skrá mig","courses.attending.female":"Námskeið sem ég er skráð á","courses.attending.male":"Námskeið sem ég er skráður á","courses.attending":"Námskeið sem ég er skráð(ur) á","courses.available":"Námskeið í boði","courses.close":"Loka","courses.CourseDeadlineEnd":"Afskráningarfestur","courses.CourseDeadlineStart":"Skráningarfrestur","courses.date":"Dagsetning","courses.description":"Lýsing","courses.details":"Nánar","courses.empty":"Ekkert í boði í dag","courses.end":"Endar","courses.group":"Flokkur námskeiðs","courses.instructor":"Leiðbeinandi","courses.leave":"Afskrá mig","courses.length":"Lengd","courses.duration.value":"{hours,plural,=0 {} other {{hours} klst.}} {minutes,plural,=0 {} other { {minutes} mín.}}","courses.location":"Staðsetning","courses.name":"Heiti námskeiðs","courses.noAttending":"Engin námskeið skráð","courses.noOpen":"Engin opin námskeið","courses.price":"Verð","courses.pricePerAttendee":"Verð {price} kr. per þátttakanda m.v. {attendees} þátttakendur","courses.registered":"Skráðir","courses.room":"Stofa","courses.start":"Byrjar","courses.status":"Staða","courses.times":"Tímar","courses.title":"Námskeið","courses.type":"Tegund námskeiðs","dash.title.agreements":"Samþykki","dash.title.appraisals.archive":"Eldri frammistöðumat","dash.title.appraisals":"Frammistöðumat","dash.title.approvals":"Mínar beiðnir","dash.title.benefits":"Heilsuefling","dash.title.birthdays":"Afmælisbörn","dash.title.courseApprovalRequest":"Fræðslubeiðni","dash.title.courses":"Námskeið","dash.title.evaluations":"Námskeiðsmat","dash.title.events":"Viðburðir og námskeið","dash.title.files":"Skjalaskápur","dash.title.grants":"Styrkir","dash.title.holiday":"Orlof","dash.title.holidayApprovalRequest":"Orlofsbeiðni","dash.title.links":"Hlekkir","dash.title.newEmployees":"Nýjir starfsmenn","dash.title.payslips":"Launaseðlar","dash.title.paytickets":"Launamiðar","dash.title.perDiem":"Dagpeningabeiðni","dash.title.profile":"Mínar upplýsingar","dash.title.punchClock":"Viðvera - Stimpilklukka","dash.title.timeEntries":"Viðvera - Tímaskráningar","dash.title.timeEntries.Absence":"Fjarvera - Tímaskráningar","dash.title.transportations":"Samgöngustyrkir","dash.title.workAniversary":"Starfsafmæli","December":"Desember","editPanel.add":"Bæta við færslu","editPanel.alert":"Ertu viss um að þú viljir eyða þessari færslu?","editPanel.close":"Loka","editPanel.delete":"Eyða","editPanel.detail":"Nánar","editPanel.edit":"Breyta","editPanel.exportExcel":"Flytja í Excel","editPanel.matchesPreviousPassword":"Staðfest lykilorð passar ekki","editPanel.pattern":"Lykilorð þarf að vera amk 12 stafir að lengd og þarf að innihalda hástaf, lágstaf og tákn","editPanel.refresh":"Fríska","editPanel.required":"Þetta svæði er skilyrt","editPanel.save":"Vista","education.branch1":"Námsleið 1","education.branch2":"Námsleið 2","education.country":"Land","education.degree":"Gráða / Skírteini","education.empty":"Engin menntun skráð","education.end":"Lauk námi","education.grade":"Einkunn","education.highest":"Hæsta menntunarstig","education.info":"Frekari upplýsingar","education.no":"Nei","education.school":"Námsstofnun","education.start":"Hóf nám","education.title":"Menntun","education.type.apprentice":"Iðnnám","education.type.highschool":"Stúdentsnám","education.type.internship":"Starfsnám","education.type.primary":"Grunnskólanám","education.type.university":"Háskólanám","education.type.unknown":"Óskilgreint","education.type":"Tegund Náms","education.yes":"Já","employee":"Starfsmaður","employeeSearch.button":"Leita","employeeSearch.close":"Loka","employeeSearch.company":"Fyrirtæki","employeeSearch.costCenter":"Kostnaðarstöð","employeeSearch.department":"Skipulagseining","employeeSearch.division":"Svið","employeeSearch.email":"Vinnunetfang","employeeSearch.location":"Staðsetning","employeeSearch.manager":"Næsti yfirmaður","employeeSearch.mobile":"Farsími","employeeSearch.noresult":"Engar niðurstöður","employeeSearch.phone":"Vinnusími","employeeSearch.placeholder":"Leita að starfsfólki","employeeSearch.qualificationToggle":"Finna starfsmann út frá hæfni","employeeSearch.title":"Starfsheiti","EmployeeUnion.number":"Númer","EmployeeUnion":"Starfsmannafélag","error":"Villa við að sækja {name}","Error.AccessDenied":"Aðgangur ekki leyfður","events.title":"Viðburðir og námskeið","expires":"Rennur út","February":"Febrúar","forgotPassword.notification":"Beiðni send","forgotPassword.validationError":"Vinsamlegast fylltu út notandanafn og staðfestu að þú sért ekki vélmenni","Hide":"Fela","holiday":"Orlof","holiday.days":"{val} dagar","holiday.earned":"Áunnið orlof til úttektar eftir 1. maí {year}","holiday.error":"Eitthvað fór úrskeiðis.","holiday.firstOfMay":"Staða 1. maí {year}","holiday.hours":"{val} tímar","holiday.settlement":"Uppgert orlof","holiday.showByHour":"Sjá í tímum","holiday.sum":"Eftirstöðvar orlofs","holiday.taken":"Úttekið frá 1. maí {year}","holiday.title.year":"Orlofsárið {year}","holiday.label.year":"Orlofsár","holiday.title":"Orlofsstaða","holiday.total":"Heildarorlof","holiday.unpaid":"Launalaust leyfi","holiday.usedVacation":"Úttekið orlof","holiday.workTime":"Vinnuskylda þín er {hours} tímar","holiday.vacationApprovals":"Orlofsyfirlit","holiday.Accepted":"Samþykkt","holiday.Pending":"Í bið","holiday.Rejected":"Hafnað","holiday.Expired":"Útrunnið","holidayApprovalRequest.button":"Sækja um","holidayApprovalRequest.timeError":"Upphafsdagur þarf að vera á undan lokadegi","holidayApprovalRequest.timeError.beforeCurrentDate":"Ekki er hægt að stofna orlofsbeiðni aftur í tímann.","holidayApprovalRequest.description":"Hér getur þú sent inn orlofsbeiðni. Beiðnin verður send á næsta yfirmann til samþykktar.","holidayOverview.winterAddition.title":"Þegar leiðrétt vegna vetrarorlofs","hours":"{val, plural, one {klst.} other {klst.}}","inOut.title":"Inni/úti","inOut.employee.all":"Allir","inOut.selectAll":"Velja allar","inOut.type":"Tegund","inOut.type.all":"Allar","inOut.type.daytime":"Dagvinna","inOut.type.overtime":"Yfirvinna","inOut.type.absence":"Fjarvera","inOut.type.moreThanOne":"Fleiri en ein skráning","ISK":"{amount} kr.","January":"Janúar","July":"Júlí","June":"Júní","loading.message":"Sæki gögn...","loan.amount":"Upphæð","loan.begda":"Gildir frá","loan.endda":"Gildir til","loan.objectNumber":"Nr. hlutar","loan.pieces":"Fjöldi","loan.title":"Hlutir í láni","loan.type":"Tegund hlutar","loan.empty":"Enginn hlutur í láni skráður","March":"Mars","May":"Maí","name":"Nafn","newPassword.capital":"Þarf að innihalda hástaf","newPassword.currentPassword":"Núverandi lykilorð","newPassword.error":"Núverandi lykilorð ekki rétt.","newPassword.length":"Þarf að vera 12 stafir að lengd","newPassword.letter":"Þarf að innihalda lástaf","newPassword.match":"Lykilorð stemma ekki","newPassword.newPassword":"Nýtt lykilorð","newPassword.newPasswordConfirm":"Staðfesta lykilorð","newPassword.number":"þarf að innihalda tölustaf","newPassword.required":"Þarf að fylla út","newPassword.save":"Vista","newPassword.special":"Þarf að innihalda tákn","newPassword.title":"Breyta um lykilorð","No.employee.union":"Ekkert starfsmannafélag skráð.","No.pay.union":"Ekkert stéttarfélag skráð.","No.pension.fund":"Enginn lífeyrissjóður skráður.","No.private.pension.fund":"Enginn séreignarsjóður skráður.","notification.create.contact.hr":"Skráning hefur verið send starfsmannasviði til yfirferðar.","notification.create.message":"Færslan hefur verið stofnuð","notification.create.title":"Stofnað","notification.delete.message":"Færslan hefur verið fjarlægð","notification.delete.title":"Eytt","notification.error.auth":"Athugið - notandi hefur ekki heimild til að bæta við, breyta eða eyða færslu. Vinsamlegast hafið samband við mannauðssvið/starfsmannasvið.","notification.error.title":"Aðgerð tókst ekki","notification.register.full":"Ekki tókst að skrá þig á viðburðin, ekki nein laus sæti","notification.register.title":"Skráning","notification.ResetPassword.Error":"Ekki tókst að uppfæra lykilorð","notification.ResetPassword.Success":"Lykilorð hefur verið uppfært","notification.save.message":"Færslan hefur verið vistuð","notification.save.title":"Vistað","notification.transportRegister.message":"Umsókn um samgöngustyrk móttekin","notification.transportRegister.title":"Aðgerð tókst","November":"Nóvember","October":"Október","Pagination.PerPage":"{items} / síðu","Pagination.TotalPages":"Síða {page} af {pages}","panel.actions":"Aðgerðir","panel.empty":"Engar upplýsingar eru skráðar","PayEducationBonus":"Menntunarálag","PayLifelongEducationBonus":"Símenntunarálag","PayLoyaltyBonus":"Tryggðarálag","PayManagementBonus":"Stjórnunarálag","payticket.download":"Sækja","payticket.empty":"Ekki er til launamiði fyrir þetta ár.","payticket.error":"Villa við að sækja launamiða.","payticket.select":"Launatímabil","payticket.ticket":"Launamiði","payticket.title":"Launamiðar","payticket.column":"Dálkur","payticket.name":"Nafn","payticket.total":"Samtals","payticket.field":"Reitur","payticket.totalField":"Samtals á launamiðareit","payslip.download":"Sækja","payslip.empty":"Ekki eru til launaseðlar fyrir þig.","payslip.error":"Villa við að sækja launaseðla.","payslip.select":"Launatímabil","payslip.title":"Launaseðlar","Pension.company.percentage":"Mótframlag %","Pension.employee.percentage":"Iðgjald %","Pension.fund.number":"Númer","Pension.fund":"Lífeyrissjóður","PerDiem.Button":"Sækja um","PerDiem.Create.Error":"Ekki tókst að stofna beiðni","PerDiem.Create.Success":"Beiðni hefur verið stofnuð","PerDiem.Days":"dagar","PerDiem.Description":"Hér getur þú sent inn dagpeningabeiðni. Beiðnin verður send á næsta yfirmann til samþykktar.","PerDiem.PerDiemAmountType":"Tegund","PerDiem.PerDiemAmountTypeEnum.Accommodation":"Gisting","PerDiem.PerDiemAmountTypeEnum.None":"Óskilgreint","PerDiem.PerDiemAmountTypeEnum.Other":"Annað","PerDiem.PerDiemAmountTypeEnum.Total":"Samtals","PerDiem.PerDiemLocationID":"Staður","PerDiem.PerDiemTypeID":"Flokkur","PerDiem":"Dagpeningar","PerDiemCalculated.Days":"Dagar","PerDiemCalculated.EstimatedTaxISK":"Áætluð staðgreiðsla","PerDiemCalculated.ExchangeRate":"Gengi {currency}","PerDiemCalculated.TotalAmountCurrency":"Upphæð {currency}","PerDiemCalculated.TotalAmountISK":"Upphæð","PerDiemCalculated.TotalAmountPrepaidPaymentCurrency":"Ff. gr. (mynt starfsm.) {currency}","PerDiemCalculated":"Niðurbrot á útreikning","PerDiemComment.Custom":"Tilgangur ferðar","pickNewPassword":"Velja nýtt lykilorð","print":"Prenta","Private.pension.fund.number":"Númer","Private.pension.fund":"Séreignarsjóður","profile.accessCard":"Auðkenniskort","profile.add":"Bæta við","profile.address":"Aðsetur","profile.addressPlace":"Aðsetur (staður)","profile.addressStreet":"Aðsetur (gata og númer)","profile.age":"Aldur","profile.alert":"Ertu viss um að þú viljir loka án þess að vista?","profile.bankInfo":"Launa","profile.basicInfo":"Upplýsingar","profile.child.birthYear":"Fæðingarár","profile.child.gender":"Kyn","profile.child.name":"Nafn","profile.close":"Loka","profile.comInfo":"Samskipti","profile.countryCode.mobile":"Landsnúmer fyrir farsíma","profile.countryCode":"Landsnúmer","profile.delete":"Eyða","profile.editChildren":"Breyta","profile.editProfile":"Breyta","profile.email":"Netfang","profile.employeeMaster":"Mínar upplýsingar","profile.employeeMasterID":"Starfsmannanúmer","profile.family":"Börn","profile.gender.female":"Kona","profile.gender.male":"Karl","profile.gender.unknown":"Óskilgreint","profile.gender":"Kyn","profile.lastHire":"Ráðningardagsetning","profile.legalAddress":"Lögheimili","profile.mobile":"Farsími","profile.org.company":"Fyrirtæki","profile.org.costCenter":"Kostnaðarstöð","profile.org.division":"Svið","profile.org.employeeDetailID":"Launamannanúmer","profile.org.group":"Tegund","profile.org.jobDescription":"Starfslýsing","profile.org.location":"Staðsetning","profile.org.manager":"Næsti yfirmaður","profile.org.position":"Starfsheiti","profile.org.positionAlt":"Annað starfsheiti","profile.org.status":"Ráðningarmerking","profile.org.unit":"Deild","profile.phone":"Heimasími","profile.recruitingDate":"Starfsaldur í fyrirtæki","profile.recruitingDatePay":"Starfsaldur til launa","profile.relative.name":"Nafn","profile.relative.phone":"Sími","profile.relative.relation":"Tengsl","profile.relative":"Nánasti aðstandandi","profile.relative2":"Nánasti aðstandandi 2","profile.relativeAssociation.other":"Annað","profile.relativeAssociation.parent":"Foreldri","profile.relativeAssociation.relative":"Ættingi","profile.relativeAssociation.sibling":"Systkin","profile.relativeAssociation.spouse":"Maki","profile.relativeAssociation.unknown":"Óskilgreint","profile.relativeEmail":"Netfang nánasta aðstandanda","profile.relativeAddress":"Aðsetur nánasta aðstandanda","profile.relativeName":"Fullt nafn nánasta aðstandanda","profile.relativePhone":"Sími nánasta aðstandanda","profile.relativePhoneMobile":"Farsími nánasta aðstandanda","profile.relativeRelation":"Tengsl við nánasta aðstandanda","profile.relog":"Villa kom upp og ekki tókst að sækja gögnin, vinsamlegast reyndu að skrá þig aftur inn.","profile.save":"Vista","profile.saveclose":"Vista & loka","profile.ssn":"Kennitala","profile.tab.children":"Börn","profile.tab.communication":"Samskipti","profile.tab.relative":"Nánasti aðstandandi","profile.tetra":"Farsími 2","profile.username":"Notandanafn","profile.workEmail":"Vinnunetfang","profile.workPhone":"Vinnusími","qaelement.answer.comment":"Nánari útskýring á svari","qaelement.answer.employee":"Svar starfsmanns","qaelement.answer.final":"Loka niðurstaða","qaelement.answer.manager":"Svar yfirmanns","qaelement.input.select":"Smelltu hér til að velja svarmöguleika","qaelement.input.text":"Vinsamlegast skrifaðu svar hér í textasvæðið","qualification.empty":"Engin hæfni skráð","qualification.name":"Hæfni","qualification.scale":"Kunnátta","qualification.title":"Hæfni","qualification.type":"Tegund","questionnaire.submit":"Skrá mig","questionnaire.submitFailed":"Form ekki rétt fyllt út","questionnaire.title":"Viðbótarspurningar","repository.alert":"Ertu viss um að þú viljir eyða ","repository.all":"Allt","repository.chooseFile":"Sækja skjal","repository.delete":"Eyða","repository.download":"Hlaða niður","repository.error":"Upp kom villa í skjalaskáp.","repository.errorSize":"Þetta skjal er of stórt, (max 10 MB).","repository.errorType":"Verður að velja tegund skjals.","repository.fileType":"Tegund skjals","repository.noFiles.CanAdd":"Engin skjöl vistuð í skjalaskáp, þú getur bætt þeim við hér að ofan.","repository.noFiles":"Engin skjöl vistuð í skjalaskáp.","repository.noFilesFilter":"Engin skjöl passa við leit.","repository.refresh":"Fríska","repository.save":"Vista","repository.search":"Leit","repository.title":"Skjölin mín","repository.uploadTitle":"Bæta við skjali","send":"Senda","sending.message":"Sendi gögn...","September":"September","submit":"Senda","taxCard.create":"Bæta við","taxCard.edit":"Breyta","taxCard.errorUnused.invalid":"Upphæð ekki leyfileg.","taxCard.errorUnused.max":"Upphæð of há fyrir núverandi tímabil.","taxCard.errorUnused.noLast":"Ekki búið að velja hvenær kortið verður virkt.","taxCard.lastUsed":"Nýta frá og með","taxCard.none.employee":"Ekki er skráður persónuafsláttur á starfsmann.","taxCard.none.spouse":"Ekki er skráður persónuafsláttur maka.","taxCard.none.EmployeeMasterTaxCard":"Ekki er skráður persónuafsláttur á starfsmann.","taxCard.none.EmployeeMasterTaxCardSpouse":"Ekki er skráður persónuafsláttur maka.","taxCard.percent":"Nýtingarhlutfall","taxCard.save":"Vista","taxCard.title.employee":"Persónuafsláttur","taxCard.title.spouse":"Persónuafsláttur maka","taxCard.unused":"Ónotaður persónuafsláttur","taxCards.title":"Persónuafsláttur","teria.cafeteria":"Mötuneyti","teria.cafeteria.description":"Lýsing","teria.cafeteria.type":"Tegund færslu","teria.cafeteria.employeeGuest":"Gestur starfsmanns","teria.guests":"Gestir fyrirtækis","teria.noProducts":"Engar færslur fyrir valið tímabil","teria.store":"Verslun","teria.price":"Upphæð","teria.product":"Vara","teria.title":"Mötuneyti og verslanir","tile.appraisals.empty":"Ekkert framundan","tile.appraisals.error":"Villa við að sækja lista","tile.appraisals.goto":"Sjá eldri","tile.appraisals.handin":"Ekki búið að ljúka","tile.appraisals.managerDivider":"Svör starfsfólks","tile.appraisals.start":"Ekki byrjað að svara","tile.benefits.empty":"Engar heilsueflingar fundust","tile.birthdays.empty":"Enginn á afmæli í dag","tile.birthdays.error":"Villa við að sækja afmælisbörn","tile.courses.empty":"Engin námskeið framundan","tile.courses.error":"Villa við að sækja námskeið","tile.courses.goto":"Skoða öll námskeið","tile.error":"Villa kom upp: {error}","tile.evaluation.empty":"Engu námskeiðsmati ósvarað","tile.evaluation.error":"Villa við að sækja gögn","tile.evaluation.handin":"Ekki búið að ljúka","tile.evaluation.start":"Ekki byrjað að svara","tile.events.attending.female":"Skráð","tile.events.attending.male":"Skráður","tile.events.attending":"Skráð(ur)","tile.events.empty":"Engir viðburðir framundan","tile.events.error":"Villa við að sækja viðburði","tile.events.goto":"Skoða alla viðburði","tile.files.empty":"Engin skjöl","tile.files.goto":"Skoða öll skjöl","tile.grants.empty":"Engir styrkir fundust","tile.grants.error":"Villa við að sækja styrki","tile.holiday.allowance":"Orlofsréttur","tile.holiday.earned":"Áunnið fyrir {year}","tile.holiday.earned1":"Áunnið orlof","tile.holiday.empty":"Ekkert orlof skráð","tile.holiday.error":"Villa við að sækja orlof","tile.holiday.firstOfMay":"Staða 1. maí {year}","tile.holiday.goto":"Skoða nánar","tile.holiday.period":"(1.5.{year} - 30.4.{nextYear})","tile.holiday.settlement":"Uppgert orlof","tile.holiday.sum":"Eftirstöðvar orlofs","tile.holiday.taken":"Úttekið frá 1. maí {year}","tile.holiday.workTime":"Vinnuskylda","tile.loading":"Sæki gögn","tile.payslips.empty":"Engir launaseðlar","tile.payslips.goto":"Skoða alla launaseðla","tile.profile.division":"Svið","tile.profile.emailWork":"Vinnu netfang","tile.profile.goto":"Frekari upplýsingar","tile.profile.manager":"Næsti yfirmaður","tile.profile.position":"Starfsheiti","tile.profile.ssn":"Kennitala","tile.profile.unit":"Deild","tile.time.goto":"Skoða nánar","tile.transportations.goto":"Skoða nánar","tile.transportations.title":"Samgöngustyrkir","time.ActualClockTime":"Tímar","time.alert.delete":"Ertu viss um að þú viljir eyða {count, number} {count, plural, one {færslu} other {færslum}}?","time.cancel":"Hætta við","time.ClockIn":"Inn","time.ClockOut":"Út","time.NumberOfHours":"Fjöldi klst.","time.Comment":"Athugasemd","time.create":"Stofna","time.CreateEntry":"Skrá tíma","time.Date":"Dagsetning","time.DateIn":"Dagsetning frá","time.DateOut":"Dagsetning til","time.error.DateOutBeforeDateIn":"Dagsetning frá þarf að vera á undan dagsetning til","time.error.TimeOutBeforeTimeIn":"Inn tími þarf að vera á undan út tíma","time.error.inAndOutSame":"Inn og út tími getur ekki verið sá sami","time.error.MoreThanZero":"Fjöldi klst. verður að vera meira en 0","time.error.MoreThan24HoursError":"Tímaskráning spannar meira en 24 klst. Vinsamlegast yfirfarið og veljið \"Tímabil\" ef skráning nær yfir meira en 1 dag.","time.error.MoreThan24HoursTimeSpanError":"Tímaskráning spannar meira en 24 klst.","time.error":"Villa kom upp","time.expectedHours":"Vinnuskylda tímabils","time.halfDay":"Hálfur dagur","time.HasError.Tooltip":"Yfirfara þarf tíma á þessari færslu","time.HasError":"Villa","time.hours":"{hours} klst","time.initialize.error":"Villa við að sækja gögn","time.notification.batch.created":"Færslur stofnaðar","time.notification.delete.title":"Færslu eytt","time.notification.patch.title":"Færsla vistuð","time.notification.post.title":"Færsla stofnuð","time.PunchIn":"Stimpla inn","time.PunchOut":"Stimpla út","time.registerRedDays":"Skrá frídaga","time.RegisterWeekends":"Skrá helgar","time.selectTime":"Velja tíma","time.span":"Tímabil","time.title":"Viðvera","time.totalHours.span":"Klst. á dag","time.totalHours":"Heildarfjöldi klst","time.Type":"Tegund","time.Approver":"Samþykkjandi","time.update":"Vista","time.wholeDay":"Heill dagur","time.TimeBehind":"Eftirstöðvar","time.warningText.NotEnoughVacationHours":"Ekki hægt að skrá orlof þar sem ekki hefur verið safnað nægilega miklu orlofi. Vinsamlegast kannið orlofsstöðu og reynið aftur síðar.","time.warningText.NotEnoughFirstOfMaiHours":"Ekki er næg orlofsinneign. Orlofsstaða fer í mínus og umfram tímar dragast frá orlofi næsta orlofsárs.","time.error.NotEnoughSickHours":"Ekki er hægt að skrá veikindi þar sem veikindaréttur er fullnýttur.","time.error.NotEnoughSickHours.Many":"Ekki er hægt að skrá veikindi á alla daga á völdu tímabili þar sem veikindaréttur er fullnýttur.","time.workedHours":"Skráð","time.HalfDayWarning.Description":"Skráning nær yfir dagana 24. og/eða 31. desember. Vinsamlegast athugið að skrá þarf tíma sérstaklega á þá daga.","toolbar.agreements":"Samþykki","toolbar.appraisal.archive":"Eldri frammistöðumat","toolbar.appraisal":"Frammistöðumat","toolbar.benefits":"Heilsuefling","toolbar.courses":"Námskeið í boði","toolbar.events":"Viðburðir og námskeið","toolbar.grants":"Styrkir","toolbar.holiday":"Orlof","toolbar.logout":"Útskráning","toolbar.menu":"Valmynd","toolbar.orgchart":"Skipurit","toolbar.payroll":"Launaupplýsingar","toolbar.payslip":"Launaseðlar","toolbar.profile":"Mínar upplýsingar","toolbar.repository":"Skjalaskápur","toolbar.search":"Starfsmannaleit","toolbar.searchField":"Leita","toolbar.settings":"Stillingar","toolbar.transportationGrants":"Samgöngustyrkir","transportationGrant.active":"Samgöngustyrkur er í gildi.","transportationGrant.AmountPerMonth":"Upphæð á mánuði:","transportationGrant.error":"Gögn ekki til staðar eða röng","transportationGrant.Months":"Mánuðir:","transportationGrant.period":"Tímabil:","transportationGrant.register.finish":"Senda","transportationGrant.register":"Sækja um","transportationGrants.duplicate":"Þú hefur nú þegar sótt um þennan styrk á tímabilinu.","transportationGrants.empty":"Ekki eru neinir styrkir í boði.","transportationGrants.error":"Villa við að sækja samgöngustyrki: {error}","transportationGrants.title":"Samgöngustyrkir","Truncate.Less":"Sjá minna","Truncate.More":"Sjá meira","Union.number":"Númer","Union":"Stéttarfélag","unused":"Ónotað"}

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

	module.exports = curry;
	
	/*
	  function add(a, b, c) {
	    return a + b + c;
	  }
	  curry(add)(1)(2)(3); // 6
	  curry(add)(1)(2)(2); // 5
	  curry(add)(2)(4, 3); // 9
	
	  function add(...args) {
	    return args.reduce((sum, n) => sum + n, 0)
	  }
	  var curryAdd4 = curry(add, 4)
	  curryAdd4(1)(2, 3)(4); // 10
	
	  function converter(ratio, input) {
	    return (input*ratio).toFixed(1);
	  }
	  const curriedConverter = curry(converter)
	  const milesToKm = curriedConverter(1.62);
	  milesToKm(35); // 56.7
	  milesToKm(10); // 16.2
	*/
	
	function curry(fn, arity) {
	  return function curried() {
	    if (arity == null) {
	      arity = fn.length;
	    }
	    var args = [].slice.call(arguments);
	    if (args.length >= arity) {
	      return fn.apply(this, args);
	    } else {
	      return function() {
	        return curried.apply(this, args.concat([].slice.call(arguments)));
	      };
	    }
	  };
	}


/***/ }),
/* 1381 */
/***/ (function(module, exports) {

	/* This program is free software. It comes without any warranty, to
	     * the extent permitted by applicable law. You can redistribute it
	     * and/or modify it under the terms of the Do What The Fuck You Want
	     * To Public License, Version 2, as published by Sam Hocevar. See
	     * http://www.wtfpl.net/ for more details. */
	'use strict';
	module.exports = leftPad;
	
	var cache = [
	  '',
	  ' ',
	  '  ',
	  '   ',
	  '    ',
	  '     ',
	  '      ',
	  '       ',
	  '        ',
	  '         '
	];
	
	function leftPad (str, len, ch) {
	  // convert `str` to a `string`
	  str = str + '';
	  // `len` is the `pad`'s length now
	  len = len - str.length;
	  // doesn't need to pad
	  if (len <= 0) return str;
	  // `ch` defaults to `' '`
	  if (!ch && ch !== 0) ch = ' ';
	  // convert `ch` to a `string` cuz it could be a number
	  ch = ch + '';
	  // cache common use cases
	  if (ch === ' ' && len < 10) return cache[len] + str;
	  // `pad` starts with an empty string
	  var pad = '';
	  // loop
	  while (true) {
	    // add `ch` to `pad` if `len` is odd
	    if (len & 1) pad += ch;
	    // divide `len` by 2, ditch the remainder
	    len >>= 1;
	    // "double" the `ch` so this operation count grows logarithmically on `len`
	    // each time `ch` is "doubled", the `len` would need to be "doubled" too
	    // similar to finding a value in binary search tree, hence O(log(n))
	    if (len) ch += ch;
	    // `len` is 0, exit the loop
	    else break;
	  }
	  // pad `str`!
	  return pad + str;
	}


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeMax = Math.max,
	    nativeNow = Date.now;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(102)(module)))

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(135),
	    root = __webpack_require__(80);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(1451),
	    hashDelete = __webpack_require__(1452),
	    hashGet = __webpack_require__(1453),
	    hashHas = __webpack_require__(1454),
	    hashSet = __webpack_require__(1455);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(135),
	    root = __webpack_require__(80);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 1387 */
/***/ (function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ }),
/* 1388 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `baseAggregator` for arrays.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function arrayAggregator(array, setter, iteratee, accumulator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    setter(accumulator, value, iteratee(value), array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayAggregator;


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(253);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ }),
/* 1390 */
/***/ (function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ }),
/* 1391 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 1392 */
/***/ (function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(251);
	
	/**
	 * Aggregates elements of `collection` on `accumulator` with keys transformed
	 * by `iteratee` and values set by `setter`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform keys.
	 * @param {Object} accumulator The initial aggregated object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseAggregator(collection, setter, iteratee, accumulator) {
	  baseEach(collection, function(value, key, collection) {
	    setter(accumulator, value, iteratee(value), collection);
	  });
	  return accumulator;
	}
	
	module.exports = baseAggregator;


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(166),
	    keys = __webpack_require__(99);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(166),
	    keysIn = __webpack_require__(168);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 1396 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.clamp` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {number} number The number to clamp.
	 * @param {number} [lower] The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the clamped number.
	 */
	function baseClamp(number, lower, upper) {
	  if (number === number) {
	    if (upper !== undefined) {
	      number = number <= upper ? number : upper;
	    }
	    if (lower !== undefined) {
	      number = number >= lower ? number : lower;
	    }
	  }
	  return number;
	}
	
	module.exports = baseClamp;


/***/ }),
/* 1397 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(249),
	    arrayEach = __webpack_require__(533),
	    assignValue = __webpack_require__(353),
	    baseAssign = __webpack_require__(1394),
	    baseAssignIn = __webpack_require__(1395),
	    cloneBuffer = __webpack_require__(547),
	    copyArray = __webpack_require__(256),
	    copySymbols = __webpack_require__(1432),
	    copySymbolsIn = __webpack_require__(1433),
	    getAllKeys = __webpack_require__(553),
	    getAllKeysIn = __webpack_require__(554),
	    getTag = __webpack_require__(200),
	    initCloneArray = __webpack_require__(1456),
	    initCloneByTag = __webpack_require__(1457),
	    initCloneObject = __webpack_require__(558),
	    isArray = __webpack_require__(41),
	    isBuffer = __webpack_require__(206),
	    isMap = __webpack_require__(1499),
	    isObject = __webpack_require__(63),
	    isSet = __webpack_require__(1501),
	    keys = __webpack_require__(99),
	    keysIn = __webpack_require__(168);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (isSet(value)) {
	    value.forEach(function(subValue) {
	      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
	    });
	  } else if (isMap(value)) {
	    value.forEach(function(subValue, key) {
	      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
	    });
	  }
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 1398 */
/***/ (function(module, exports, __webpack_require__) {

	var baseEach = __webpack_require__(251);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	module.exports = baseFilter;


/***/ }),
/* 1399 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ }),
/* 1400 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(249),
	    equalArrays = __webpack_require__(551),
	    equalByTag = __webpack_require__(1444),
	    equalObjects = __webpack_require__(1445),
	    getTag = __webpack_require__(200),
	    isArray = __webpack_require__(41),
	    isBuffer = __webpack_require__(206),
	    isTypedArray = __webpack_require__(266);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(200),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]';
	
	/**
	 * The base implementation of `_.isMap` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 */
	function baseIsMap(value) {
	  return isObjectLike(value) && getTag(value) == mapTag;
	}
	
	module.exports = baseIsMap;


/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(249),
	    baseIsEqual = __webpack_require__(254);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 1404 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(264),
	    isMasked = __webpack_require__(1461),
	    isObject = __webpack_require__(63),
	    toSource = __webpack_require__(566);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

	var getTag = __webpack_require__(200),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var setTag = '[object Set]';
	
	/**
	 * The base implementation of `_.isSet` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 */
	function baseIsSet(value) {
	  return isObjectLike(value) && getTag(value) == setTag;
	}
	
	module.exports = baseIsSet;


/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isLength = __webpack_require__(369),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(63),
	    isPrototype = __webpack_require__(260),
	    nativeKeysIn = __webpack_require__(1476);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(1403),
	    getMatchData = __webpack_require__(1446),
	    matchesStrictComparable = __webpack_require__(560);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(254),
	    get = __webpack_require__(96),
	    hasIn = __webpack_require__(571),
	    isKey = __webpack_require__(365),
	    isStrictComparable = __webpack_require__(559),
	    matchesStrictComparable = __webpack_require__(560),
	    toKey = __webpack_require__(136);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(249),
	    assignMergeValue = __webpack_require__(536),
	    baseFor = __webpack_require__(355),
	    baseMergeDeep = __webpack_require__(1412),
	    isObject = __webpack_require__(63),
	    keysIn = __webpack_require__(168),
	    safeGet = __webpack_require__(563);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(536),
	    cloneBuffer = __webpack_require__(547),
	    cloneTypedArray = __webpack_require__(548),
	    copyArray = __webpack_require__(256),
	    initCloneObject = __webpack_require__(558),
	    isArguments = __webpack_require__(205),
	    isArray = __webpack_require__(41),
	    isArrayLikeObject = __webpack_require__(572),
	    isBuffer = __webpack_require__(206),
	    isFunction = __webpack_require__(264),
	    isObject = __webpack_require__(63),
	    isPlainObject = __webpack_require__(265),
	    isTypedArray = __webpack_require__(266),
	    safeGet = __webpack_require__(563),
	    toPlainObject = __webpack_require__(1514);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(1414),
	    hasIn = __webpack_require__(571);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(199),
	    baseSet = __webpack_require__(543),
	    castPath = __webpack_require__(165);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ }),
/* 1415 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(199);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 1417 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.propertyOf` without support for deep paths.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyOf(object) {
	  return function(key) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = basePropertyOf;


/***/ }),
/* 1418 */
/***/ (function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.range` and `_.rangeRight` which doesn't
	 * coerce arguments.
	 *
	 * @private
	 * @param {number} start The start of the range.
	 * @param {number} end The end of the range.
	 * @param {number} step The value to increment or decrement by.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Array} Returns the range of numbers.
	 */
	function baseRange(start, end, step, fromRight) {
	  var index = -1,
	      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	      result = Array(length);
	
	  while (length--) {
	    result[fromRight ? length : ++index] = start;
	    start += step;
	  }
	  return result;
	}
	
	module.exports = baseRange;


/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(1494),
	    defineProperty = __webpack_require__(550),
	    identity = __webpack_require__(203);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ }),
/* 1420 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	module.exports = baseSortBy;


/***/ }),
/* 1421 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 1422 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(165),
	    last = __webpack_require__(575),
	    parent = __webpack_require__(1478),
	    toKey = __webpack_require__(136);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ }),
/* 1423 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(163);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ }),
/* 1424 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(358);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ }),
/* 1425 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(253);
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the last unmatched string symbol.
	 */
	function charsEndIndex(strSymbols, chrSymbols) {
	  var index = strSymbols.length;
	
	  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsEndIndex;


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(253);
	
	/**
	 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	 * that is not found in the character symbols.
	 *
	 * @private
	 * @param {Array} strSymbols The string symbols to inspect.
	 * @param {Array} chrSymbols The character symbols to find.
	 * @returns {number} Returns the index of the first unmatched string symbol.
	 */
	function charsStartIndex(strSymbols, chrSymbols) {
	  var index = -1,
	      length = strSymbols.length;
	
	  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	  return index;
	}
	
	module.exports = charsStartIndex;


/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(361);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 1428 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(162);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(167);
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	module.exports = compareAscending;


/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

	var compareAscending = __webpack_require__(1430);
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	module.exports = compareMultiple;


/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(166),
	    getSymbols = __webpack_require__(364);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(166),
	    getSymbolsIn = __webpack_require__(557);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(80);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(357),
	    isIterateeCall = __webpack_require__(259);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(97);
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	module.exports = createBaseEach;


/***/ }),
/* 1437 */
/***/ (function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(112),
	    isArrayLike = __webpack_require__(97),
	    keys = __webpack_require__(99);
	
	/**
	 * Creates a `_.find` or `_.findLast` function.
	 *
	 * @private
	 * @param {Function} findIndexFunc The function to find the collection index.
	 * @returns {Function} Returns the new find function.
	 */
	function createFind(findIndexFunc) {
	  return function(collection, predicate, fromIndex) {
	    var iterable = Object(collection);
	    if (!isArrayLike(collection)) {
	      var iteratee = baseIteratee(predicate, 3);
	      collection = keys(collection);
	      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	    }
	    var index = findIndexFunc(collection, predicate, fromIndex);
	    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	  };
	}
	
	module.exports = createFind;


/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

	var LodashWrapper = __webpack_require__(349),
	    flatRest = __webpack_require__(362),
	    getData = __webpack_require__(555),
	    getFuncName = __webpack_require__(556),
	    isArray = __webpack_require__(41),
	    isLaziable = __webpack_require__(1460);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to compose bitmasks for function metadata. */
	var WRAP_CURRY_FLAG = 8,
	    WRAP_PARTIAL_FLAG = 32,
	    WRAP_ARY_FLAG = 128,
	    WRAP_REARG_FLAG = 256;
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return flatRest(function(funcs) {
	    var length = funcs.length,
	        index = length,
	        prereq = LodashWrapper.prototype.thru;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      var func = funcs[index];
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	        var wrapper = new LodashWrapper([], true);
	      }
	    }
	    index = wrapper ? index : length;
	    while (++index < length) {
	      func = funcs[index];
	
	      var funcName = getFuncName(func),
	          data = funcName == 'wrapper' ? getData(func) : undefined;
	
	      if (data && isLaziable(data[0]) &&
	            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	            !data[4].length && data[9] == 1
	          ) {
	        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	      } else {
	        wrapper = (func.length == 1 && isLaziable(func))
	          ? wrapper[funcName]()
	          : wrapper.thru(func);
	      }
	    }
	    return function() {
	      var args = arguments,
	          value = args[0];
	
	      if (wrapper && args.length == 1 && isArray(value)) {
	        return wrapper.plant(value).value();
	      }
	      var index = 0,
	          result = length ? funcs[index].apply(this, args) : value;
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	module.exports = createFlow;


/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

	var baseRange = __webpack_require__(1418),
	    isIterateeCall = __webpack_require__(259),
	    toFinite = __webpack_require__(580);
	
	/**
	 * Creates a `_.range` or `_.rangeRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new range function.
	 */
	function createRange(fromRight) {
	  return function(start, end, step) {
	    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	      end = step = undefined;
	    }
	    // Ensure the sign of `-0` is preserved.
	    start = toFinite(start);
	    if (end === undefined) {
	      end = start;
	      start = 0;
	    } else {
	      end = toFinite(end);
	    }
	    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	    return baseRange(start, end, step, fromRight);
	  };
	}
	
	module.exports = createRange;


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(529),
	    noop = __webpack_require__(577),
	    setToArray = __webpack_require__(367);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(265);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

	var basePropertyOf = __webpack_require__(1417);
	
	/** Used to map Latin Unicode letters to basic Latin letters. */
	var deburredLetters = {
	  // Latin-1 Supplement block.
	  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	  '\xc7': 'C',  '\xe7': 'c',
	  '\xd0': 'D',  '\xf0': 'd',
	  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	  '\xd1': 'N',  '\xf1': 'n',
	  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	  '\xc6': 'Ae', '\xe6': 'ae',
	  '\xde': 'Th', '\xfe': 'th',
	  '\xdf': 'ss',
	  // Latin Extended-A block.
	  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	  '\u0134': 'J',  '\u0135': 'j',
	  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	  '\u0174': 'W',  '\u0175': 'w',
	  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	  '\u0132': 'IJ', '\u0133': 'ij',
	  '\u0152': 'Oe', '\u0153': 'oe',
	  '\u0149': "'n", '\u017f': 's'
	};
	
	/**
	 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	 * letters to basic Latin letters.
	 *
	 * @private
	 * @param {string} letter The matched letter to deburr.
	 * @returns {string} Returns the deburred letter.
	 */
	var deburrLetter = basePropertyOf(deburredLetters);
	
	module.exports = deburrLetter;


/***/ }),
/* 1444 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(162),
	    Uint8Array = __webpack_require__(531),
	    eq = __webpack_require__(201),
	    equalArrays = __webpack_require__(551),
	    mapToArray = __webpack_require__(1472),
	    setToArray = __webpack_require__(367);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(553);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 1446 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(559),
	    keys = __webpack_require__(99);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(162);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 1448 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 1449 */
/***/ (function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(165),
	    isArguments = __webpack_require__(205),
	    isArray = __webpack_require__(41),
	    isIndex = __webpack_require__(258),
	    isLength = __webpack_require__(369),
	    toKey = __webpack_require__(136);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ }),
/* 1450 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ }),
/* 1451 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(261);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 1452 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 1453 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(261);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 1454 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(261);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 1455 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(261);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 1456 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 1457 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(361),
	    cloneDataView = __webpack_require__(1427),
	    cloneRegExp = __webpack_require__(1428),
	    cloneSymbol = __webpack_require__(1429),
	    cloneTypedArray = __webpack_require__(548);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return new Ctor;
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return new Ctor;
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 1458 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(162),
	    isArguments = __webpack_require__(205),
	    isArray = __webpack_require__(41);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ }),
/* 1459 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(348),
	    getData = __webpack_require__(555),
	    getFuncName = __webpack_require__(556),
	    lodash = __webpack_require__(1518);
	
	/**
	 * Checks if `func` has a lazy counterpart.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	 *  else `false`.
	 */
	function isLaziable(func) {
	  var funcName = getFuncName(func),
	      other = lodash[funcName];
	
	  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	    return false;
	  }
	  if (func === other) {
	    return true;
	  }
	  var data = getData(other);
	  return !!data && func === data[0];
	}
	
	module.exports = isLaziable;


/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(1434);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 1462 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 1463 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(250);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 1464 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(250);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(250);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(250);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(1385),
	    ListCache = __webpack_require__(248),
	    Map = __webpack_require__(350);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 1468 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(257);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 1469 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(257);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(257);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 1471 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(257);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 1472 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(1503);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

	var WeakMap = __webpack_require__(532);
	
	/** Used to store function metadata. */
	var metaMap = WeakMap && new WeakMap;
	
	module.exports = metaMap;


/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(561);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 1476 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 1477 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 1478 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(199),
	    baseSlice = __webpack_require__(358);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ }),
/* 1479 */
/***/ (function(module, exports) {

	/** Used to lookup unminified function names. */
	var realNames = {};
	
	module.exports = realNames;


/***/ }),
/* 1480 */
/***/ (function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ }),
/* 1481 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ }),
/* 1482 */
/***/ (function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ }),
/* 1483 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(248);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 1484 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 1485 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 1486 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(248),
	    Map = __webpack_require__(350),
	    MapCache = __webpack_require__(351);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 1488 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ }),
/* 1489 */
/***/ (function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(1392),
	    hasUnicode = __webpack_require__(1450),
	    unicodeToArray = __webpack_require__(1491);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ }),
/* 1490 */
/***/ (function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ }),
/* 1491 */
/***/ (function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ }),
/* 1492 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(348),
	    LodashWrapper = __webpack_require__(349),
	    copyArray = __webpack_require__(256);
	
	/**
	 * Creates a clone of `wrapper`.
	 *
	 * @private
	 * @param {Object} wrapper The wrapper to clone.
	 * @returns {Object} Returns the cloned wrapper.
	 */
	function wrapperClone(wrapper) {
	  if (wrapper instanceof LazyWrapper) {
	    return wrapper.clone();
	  }
	  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	  result.__actions__ = copyArray(wrapper.__actions__);
	  result.__index__  = wrapper.__index__;
	  result.__values__ = wrapper.__values__;
	  return result;
	}
	
	module.exports = wrapperClone;


/***/ }),
/* 1493 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(358),
	    isIterateeCall = __webpack_require__(259),
	    toInteger = __webpack_require__(267);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil,
	    nativeMax = Math.max;
	
	/**
	 * Creates an array of elements split into groups the length of `size`.
	 * If `array` can't be split evenly, the final chunk will be the remaining
	 * elements.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Array
	 * @param {Array} array The array to process.
	 * @param {number} [size=1] The length of each chunk
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Array} Returns the new array of chunks.
	 * @example
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 2);
	 * // => [['a', 'b'], ['c', 'd']]
	 *
	 * _.chunk(['a', 'b', 'c', 'd'], 3);
	 * // => [['a', 'b', 'c'], ['d']]
	 */
	function chunk(array, size, guard) {
	  if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	    size = 1;
	  } else {
	    size = nativeMax(toInteger(size), 0);
	  }
	  var length = array == null ? 0 : array.length;
	  if (!length || size < 1) {
	    return [];
	  }
	  var index = 0,
	      resIndex = 0,
	      result = Array(nativeCeil(length / size));
	
	  while (index < length) {
	    result[resIndex++] = baseSlice(array, index, (index += size));
	  }
	  return result;
	}
	
	module.exports = chunk;


/***/ }),
/* 1494 */
/***/ (function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ }),
/* 1495 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(63),
	    now = __webpack_require__(1504),
	    toNumber = __webpack_require__(581);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ }),
/* 1496 */
/***/ (function(module, exports, __webpack_require__) {

	var deburrLetter = __webpack_require__(1443),
	    toString = __webpack_require__(169);
	
	/** Used to match Latin Unicode letters (excluding mathematical operators). */
	var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	/** Used to compose unicode character classes. */
	var rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;
	
	/** Used to compose unicode capture groups. */
	var rsCombo = '[' + rsComboRange + ']';
	
	/**
	 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	 */
	var reComboMark = RegExp(rsCombo, 'g');
	
	/**
	 * Deburrs `string` by converting
	 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	 * letters to basic Latin letters and removing
	 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to deburr.
	 * @returns {string} Returns the deburred string.
	 * @example
	 *
	 * _.deburr('déjà vu');
	 * // => 'deja vu'
	 */
	function deburr(string) {
	  string = toString(string);
	  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	}
	
	module.exports = deburr;


/***/ }),
/* 1497 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(533),
	    baseEach = __webpack_require__(251),
	    castFunction = __webpack_require__(546),
	    isArray = __webpack_require__(41);
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _.forEach([1, 2], function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, castFunction(iteratee));
	}
	
	module.exports = forEach;


/***/ }),
/* 1498 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(164),
	    createAggregator = __webpack_require__(549);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an object composed of keys generated from the results of running
	 * each element of `collection` thru `iteratee`. The order of grouped values
	 * is determined by the order they occur in `collection`. The corresponding
	 * value of each key is an array of elements responsible for generating the
	 * key. The iteratee is invoked with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	 * @returns {Object} Returns the composed aggregate object.
	 * @example
	 *
	 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	 * // => { '4': [4.2], '6': [6.1, 6.3] }
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.groupBy(['one', 'two', 'three'], 'length');
	 * // => { '3': ['one', 'two'], '5': ['three'] }
	 */
	var groupBy = createAggregator(function(result, value, key) {
	  if (hasOwnProperty.call(result, key)) {
	    result[key].push(value);
	  } else {
	    baseAssignValue(result, key, [value]);
	  }
	});
	
	module.exports = groupBy;


/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMap = __webpack_require__(1402),
	    baseUnary = __webpack_require__(255),
	    nodeUtil = __webpack_require__(366);
	
	/* Node.js helper references. */
	var nodeIsMap = nodeUtil && nodeUtil.isMap;
	
	/**
	 * Checks if `value` is classified as a `Map` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	 * @example
	 *
	 * _.isMap(new Map);
	 * // => true
	 *
	 * _.isMap(new WeakMap);
	 * // => false
	 */
	var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	module.exports = isMap;


/***/ }),
/* 1500 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is `null` or `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	 * @example
	 *
	 * _.isNil(null);
	 * // => true
	 *
	 * _.isNil(void 0);
	 * // => true
	 *
	 * _.isNil(NaN);
	 * // => false
	 */
	function isNil(value) {
	  return value == null;
	}
	
	module.exports = isNil;


/***/ }),
/* 1501 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsSet = __webpack_require__(1406),
	    baseUnary = __webpack_require__(255),
	    nodeUtil = __webpack_require__(366);
	
	/* Node.js helper references. */
	var nodeIsSet = nodeUtil && nodeUtil.isSet;
	
	/**
	 * Checks if `value` is classified as a `Set` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	 * @example
	 *
	 * _.isSet(new Set);
	 * // => true
	 *
	 * _.isSet(new WeakSet);
	 * // => false
	 */
	var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	module.exports = isSet;


/***/ }),
/* 1502 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(134),
	    isArray = __webpack_require__(41),
	    isObjectLike = __webpack_require__(81);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 1503 */
/***/ (function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(351);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ }),
/* 1504 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(80);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ }),
/* 1505 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(163),
	    baseClone = __webpack_require__(1397),
	    baseUnset = __webpack_require__(1422),
	    castPath = __webpack_require__(165),
	    copyObject = __webpack_require__(166),
	    customOmitClone = __webpack_require__(1442),
	    flatRest = __webpack_require__(362),
	    getAllKeysIn = __webpack_require__(554);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ }),
/* 1506 */
/***/ (function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(1413),
	    flatRest = __webpack_require__(362);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ }),
/* 1507 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(1415),
	    basePropertyDeep = __webpack_require__(1416),
	    isKey = __webpack_require__(365),
	    toKey = __webpack_require__(136);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 1508 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeReverse = arrayProto.reverse;
	
	/**
	 * Reverses `array` so that the first element becomes the last, the second
	 * element becomes the second to last, and so on.
	 *
	 * **Note:** This method mutates `array` and is based on
	 * [`Array#reverse`](https://mdn.io/Array/reverse).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to modify.
	 * @returns {Array} Returns `array`.
	 * @example
	 *
	 * var array = [1, 2, 3];
	 *
	 * _.reverse(array);
	 * // => [3, 2, 1]
	 *
	 * console.log(array);
	 * // => [3, 2, 1]
	 */
	function reverse(array) {
	  return array == null ? array : nativeReverse.call(array);
	}
	
	module.exports = reverse;


/***/ }),
/* 1509 */
/***/ (function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(543);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ }),
/* 1510 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClamp = __webpack_require__(1396),
	    baseToString = __webpack_require__(359),
	    toInteger = __webpack_require__(267),
	    toString = __webpack_require__(169);
	
	/**
	 * Checks if `string` starts with the given target string.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to inspect.
	 * @param {string} [target] The string to search for.
	 * @param {number} [position=0] The position to search from.
	 * @returns {boolean} Returns `true` if `string` starts with `target`,
	 *  else `false`.
	 * @example
	 *
	 * _.startsWith('abc', 'a');
	 * // => true
	 *
	 * _.startsWith('abc', 'b');
	 * // => false
	 *
	 * _.startsWith('abc', 'b', 1);
	 * // => true
	 */
	function startsWith(string, target, position) {
	  string = toString(string);
	  position = position == null
	    ? 0
	    : baseClamp(toInteger(position), 0, string.length);
	
	  target = baseToString(target);
	  return string.slice(position, position + target.length) == target;
	}
	
	module.exports = startsWith;


/***/ }),
/* 1511 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 1512 */
/***/ (function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(1495),
	    isObject = __webpack_require__(63);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ }),
/* 1513 */
/***/ (function(module, exports, __webpack_require__) {

	var toString = __webpack_require__(169);
	
	/**
	 * Converts `string`, as a whole, to lower case just like
	 * [String#toLowerCase](https://mdn.io/toLowerCase).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to convert.
	 * @returns {string} Returns the lower cased string.
	 * @example
	 *
	 * _.toLower('--Foo-Bar--');
	 * // => '--foo-bar--'
	 *
	 * _.toLower('fooBar');
	 * // => 'foobar'
	 *
	 * _.toLower('__FOO_BAR__');
	 * // => '__foo_bar__'
	 */
	function toLower(value) {
	  return toString(value).toLowerCase();
	}
	
	module.exports = toLower;


/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(166),
	    keysIn = __webpack_require__(168);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 1515 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(359),
	    baseTrim = __webpack_require__(544),
	    castSlice = __webpack_require__(1424),
	    charsEndIndex = __webpack_require__(1425),
	    charsStartIndex = __webpack_require__(1426),
	    stringToArray = __webpack_require__(1489),
	    toString = __webpack_require__(169);
	
	/**
	 * Removes leading and trailing whitespace or specified characters from `string`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category String
	 * @param {string} [string=''] The string to trim.
	 * @param {string} [chars=whitespace] The characters to trim.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {string} Returns the trimmed string.
	 * @example
	 *
	 * _.trim('  abc  ');
	 * // => 'abc'
	 *
	 * _.trim('-_-abc-_-', '_-');
	 * // => 'abc'
	 *
	 * _.map(['  foo  ', '  bar  '], _.trim);
	 * // => ['foo', 'bar']
	 */
	function trim(string, chars, guard) {
	  string = toString(string);
	  if (string && (guard || chars === undefined)) {
	    return baseTrim(string);
	  }
	  if (!string || !(chars = baseToString(chars))) {
	    return string;
	  }
	  var strSymbols = stringToArray(string),
	      chrSymbols = stringToArray(chars),
	      start = charsStartIndex(strSymbols, chrSymbols),
	      end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	  return castSlice(strSymbols, start, end).join('');
	}
	
	module.exports = trim;


/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(252),
	    baseRest = __webpack_require__(357),
	    baseUniq = __webpack_require__(360),
	    isArrayLikeObject = __webpack_require__(572),
	    last = __webpack_require__(575);
	
	/**
	 * This method is like `_.union` except that it accepts `comparator` which
	 * is invoked to compare elements of `arrays`. Result values are chosen from
	 * the first array in which the value occurs. The comparator is invoked
	 * with two arguments: (arrVal, othVal).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	 *
	 * _.unionWith(objects, others, _.isEqual);
	 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	 */
	var unionWith = baseRest(function(arrays) {
	  var comparator = last(arrays);
	  comparator = typeof comparator == 'function' ? comparator : undefined;
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	});
	
	module.exports = unionWith;


/***/ }),
/* 1517 */
/***/ (function(module, exports, __webpack_require__) {

	var baseUniq = __webpack_require__(360);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurrence of each element
	 * is kept. The order of result values is determined by the order they occur
	 * in the array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 */
	function uniq(array) {
	  return (array && array.length) ? baseUniq(array) : [];
	}
	
	module.exports = uniq;


/***/ }),
/* 1518 */
/***/ (function(module, exports, __webpack_require__) {

	var LazyWrapper = __webpack_require__(348),
	    LodashWrapper = __webpack_require__(349),
	    baseLodash = __webpack_require__(356),
	    isArray = __webpack_require__(41),
	    isObjectLike = __webpack_require__(81),
	    wrapperClone = __webpack_require__(1492);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates a `lodash` object which wraps `value` to enable implicit method
	 * chain sequences. Methods that operate on and return arrays, collections,
	 * and functions can be chained together. Methods that retrieve a single value
	 * or may return a primitive value will automatically end the chain sequence
	 * and return the unwrapped value. Otherwise, the value must be unwrapped
	 * with `_#value`.
	 *
	 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	 * enabled using `_.chain`.
	 *
	 * The execution of chained methods is lazy, that is, it's deferred until
	 * `_#value` is implicitly or explicitly called.
	 *
	 * Lazy evaluation allows several methods to support shortcut fusion.
	 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	 * the creation of intermediate arrays and can greatly reduce the number of
	 * iteratee executions. Sections of a chain sequence qualify for shortcut
	 * fusion if the section is applied to an array and iteratees accept only
	 * one argument. The heuristic for whether a section qualifies for shortcut
	 * fusion is subject to change.
	 *
	 * Chaining is supported in custom builds as long as the `_#value` method is
	 * directly or indirectly included in the build.
	 *
	 * In addition to lodash methods, wrappers have `Array` and `String` methods.
	 *
	 * The wrapper `Array` methods are:
	 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	 *
	 * The wrapper `String` methods are:
	 * `replace` and `split`
	 *
	 * The wrapper methods that support shortcut fusion are:
	 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	 *
	 * The chainable wrapper methods are:
	 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	 * `zipObject`, `zipObjectDeep`, and `zipWith`
	 *
	 * The wrapper methods that are **not** chainable by default are:
	 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	 * `upperFirst`, `value`, and `words`
	 *
	 * @name _
	 * @constructor
	 * @category Seq
	 * @param {*} value The value to wrap in a `lodash` instance.
	 * @returns {Object} Returns the new `lodash` wrapper instance.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var wrapped = _([1, 2, 3]);
	 *
	 * // Returns an unwrapped value.
	 * wrapped.reduce(_.add);
	 * // => 6
	 *
	 * // Returns a wrapped value.
	 * var squares = wrapped.map(square);
	 *
	 * _.isArray(squares);
	 * // => false
	 *
	 * _.isArray(squares.value());
	 * // => true
	 */
	function lodash(value) {
	  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	    if (value instanceof LodashWrapper) {
	      return value;
	    }
	    if (hasOwnProperty.call(value, '__wrapped__')) {
	      return wrapperClone(value);
	    }
	  }
	  return new LodashWrapper(value);
	}
	
	// Ensure wrappers are instances of `baseLodash`.
	lodash.prototype = baseLodash.prototype;
	lodash.prototype.constructor = lodash;
	
	module.exports = lodash;


/***/ }),
/* 1519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(461);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.getStyles = getStyles;
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconButton = __webpack_require__(64);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _menu = __webpack_require__(1620);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      appBar = _context$muiTheme.appBar,
	      iconButtonSize = _context$muiTheme.button.iconButtonSize,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var flatButtonSize = 36;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      zIndex: zIndex.appBar,
	      width: '100%',
	      display: 'flex',
	      backgroundColor: appBar.color,
	      paddingLeft: appBar.padding,
	      paddingRight: appBar.padding
	    },
	    title: {
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      margin: 0,
	      paddingTop: 0,
	      letterSpacing: 0,
	      fontSize: 24,
	      fontWeight: appBar.titleFontWeight,
	      color: appBar.textColor,
	      height: appBar.height,
	      lineHeight: appBar.height + 'px'
	    },
	    mainElement: {
	      boxFlex: 1,
	      flex: '1'
	    },
	    iconButtonStyle: {
	      marginTop: (appBar.height - iconButtonSize) / 2,
	      marginRight: 8,
	      marginLeft: -16
	    },
	    iconButtonIconStyle: {
	      fill: appBar.textColor,
	      color: appBar.textColor
	    },
	    flatButton: {
	      color: appBar.textColor,
	      marginTop: (iconButtonSize - flatButtonSize) / 2 + 1
	    }
	  };
	
	  return styles;
	}
	
	var AppBar = function (_Component) {
	  (0, _inherits3.default)(AppBar, _Component);
	
	  function AppBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AppBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppBar.__proto__ || (0, _getPrototypeOf2.default)(AppBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickLeftIconButton = function (event) {
	      if (_this.props.onLeftIconButtonClick) {
	        _this.props.onLeftIconButtonClick(event);
	      }
	    }, _this.handleClickRightIconButton = function (event) {
	      if (_this.props.onRightIconButtonClick) {
	        _this.props.onRightIconButtonClick(event);
	      }
	    }, _this.handleTitleClick = function (event) {
	      if (_this.props.onTitleClick) {
	        _this.props.onTitleClick(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AppBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconElementLeft || !this.props.iconClassNameLeft, 'Material-UI: Properties iconElementLeft\n      and iconClassNameLeft cannot be simultaneously defined. Please use one or the other.') : void 0;
	
	       false ? (0, _warning2.default)(!this.props.iconElementRight || !this.props.iconClassNameRight, 'Material-UI: Properties iconElementRight\n      and iconClassNameRight cannot be simultaneously defined. Please use one or the other.') : void 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          titleStyle = _props.titleStyle,
	          iconStyleLeft = _props.iconStyleLeft,
	          iconStyleRight = _props.iconStyleRight,
	          onTitleClick = _props.onTitleClick,
	          showMenuIconButton = _props.showMenuIconButton,
	          iconElementLeft = _props.iconElementLeft,
	          iconElementRight = _props.iconElementRight,
	          iconClassNameLeft = _props.iconClassNameLeft,
	          iconClassNameRight = _props.iconClassNameRight,
	          onLeftIconButtonClick = _props.onLeftIconButtonClick,
	          onRightIconButtonClick = _props.onRightIconButtonClick,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'titleStyle', 'iconStyleLeft', 'iconStyleRight', 'onTitleClick', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'onLeftIconButtonClick', 'onRightIconButtonClick', 'className', 'style', 'zDepth', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var menuElementLeft = void 0;
	      var menuElementRight = void 0;
	
	      // If the title is a string, wrap in an h1 tag.
	      // If not, wrap in a div tag.
	      var titleComponent = typeof title === 'string' || title instanceof String ? 'h1' : 'div';
	
	      var titleElement = _react2.default.createElement(titleComponent, {
	        onClick: this.handleTitleClick,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.title, styles.mainElement, titleStyle))
	      }, title);
	
	      var iconLeftStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, iconStyleLeft);
	
	      if (showMenuIconButton) {
	        if (iconElementLeft) {
	          var iconElementLeftProps = {};
	
	          if (iconElementLeft.type.muiName === 'IconButton') {
	            var iconElemLeftChildren = iconElementLeft.props.children;
	            var iconButtonIconStyle = !(iconElemLeftChildren && iconElemLeftChildren.props && iconElemLeftChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementLeftProps.iconStyle = (0, _simpleAssign2.default)({}, iconButtonIconStyle, iconElementLeft.props.iconStyle);
	          }
	
	          if (!iconElementLeft.props.onClick && this.props.onLeftIconButtonClick) {
	            iconElementLeftProps.onClick = this.handleClickLeftIconButton;
	          }
	
	          menuElementLeft = _react2.default.createElement(
	            'div',
	            { style: prepareStyles(iconLeftStyle) },
	            (0, _keys2.default)(iconElementLeftProps).length > 0 ? (0, _react.cloneElement)(iconElementLeft, iconElementLeftProps) : iconElementLeft
	          );
	        } else {
	          menuElementLeft = _react2.default.createElement(
	            _IconButton2.default,
	            {
	              style: iconLeftStyle,
	              iconStyle: styles.iconButtonIconStyle,
	              iconClassName: iconClassNameLeft,
	              onClick: this.handleClickLeftIconButton
	            },
	            iconClassNameLeft ? '' : _react2.default.createElement(_menu2.default, { style: (0, _simpleAssign2.default)({}, styles.iconButtonIconStyle) })
	          );
	        }
	      }
	
	      var iconRightStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, {
	        marginRight: -16,
	        marginLeft: 'auto'
	      }, iconStyleRight);
	
	      if (iconElementRight) {
	        var iconElementRightProps = {};
	
	        switch (iconElementRight.type.muiName) {
	          case 'IconMenu':
	          case 'IconButton':
	            var iconElemRightChildren = iconElementRight.props.children;
	            var _iconButtonIconStyle = !(iconElemRightChildren && iconElemRightChildren.props && iconElemRightChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementRightProps.iconStyle = (0, _simpleAssign2.default)({}, _iconButtonIconStyle, iconElementRight.props.iconStyle);
	            break;
	
	          case 'FlatButton':
	            iconElementRightProps.style = (0, _simpleAssign2.default)({}, styles.flatButton, iconElementRight.props.style);
	            break;
	
	          default:
	        }
	
	        if (!iconElementRight.props.onClick && this.props.onRightIconButtonClick) {
	          iconElementRightProps.onClick = this.handleClickRightIconButton;
	        }
	
	        menuElementRight = _react2.default.createElement(
	          'div',
	          { style: prepareStyles(iconRightStyle) },
	          (0, _keys2.default)(iconElementRightProps).length > 0 ? (0, _react.cloneElement)(iconElementRight, iconElementRightProps) : iconElementRight
	        );
	      } else if (iconClassNameRight) {
	        menuElementRight = _react2.default.createElement(_IconButton2.default, {
	          style: iconRightStyle,
	          iconStyle: styles.iconButtonIconStyle,
	          iconClassName: iconClassNameRight,
	          onClick: this.handleClickRightIconButton
	        });
	      }
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, {
	          rounded: false,
	          className: className,
	          style: (0, _simpleAssign2.default)({}, styles.root, style),
	          zDepth: zDepth
	        }),
	        menuElementLeft,
	        titleElement,
	        menuElementRight,
	        children
	      );
	    }
	  }]);
	  return AppBar;
	}(_react.Component);
	
	AppBar.muiName = 'AppBar';
	AppBar.defaultProps = {
	  showMenuIconButton: true,
	  title: '',
	  zDepth: 1
	};
	AppBar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	AppBar.propTypes =  false ? {
	  /**
	   * Can be used to render a tab inside an app bar for instance.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Applied to the app bar's root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The classname of the icon on the left of the app bar.
	   * If you are using a stylesheet for your icons, enter the class name for the icon to be used here.
	   */
	  iconClassNameLeft: _propTypes2.default.string,
	  /**
	   * Similiar to the iconClassNameLeft prop except that
	   * it applies to the icon displayed on the right of the app bar.
	   */
	  iconClassNameRight: _propTypes2.default.string,
	  /**
	   * The custom element to be displayed on the left side of the
	   * app bar such as an SvgIcon.
	   */
	  iconElementLeft: _propTypes2.default.element,
	  /**
	   * Similiar to the iconElementLeft prop except that this element is displayed on the right of the app bar.
	   */
	  iconElementRight: _propTypes2.default.element,
	  /**
	   * Override the inline-styles of the element displayed on the left side of the app bar.
	   */
	  iconStyleLeft: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the element displayed on the right side of the app bar.
	   */
	  iconStyleRight: _propTypes2.default.object,
	  /**
	   * Callback function for when the left icon is selected via a click.
	   *
	   * @param {object} event Click event targeting the left `IconButton`.
	   */
	  onLeftIconButtonClick: _propTypes2.default.func,
	  /**
	   * Callback function for when the right icon is selected via a click.
	   *
	   * @param {object} event Click event targeting the right `IconButton`.
	   */
	  onRightIconButtonClick: _propTypes2.default.func,
	  /**
	   * Callback function for when the title text is selected via a click.
	   *
	   * @param {object} event Click event targeting the `title` node.
	   */
	  onTitleClick: _propTypes2.default.func,
	  /**
	   * Determines whether or not to display the Menu icon next to the title.
	   * Setting this prop to false will hide the icon.
	   */
	  showMenuIconButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The title to display on the app bar.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the app bar's title element.
	   */
	  titleStyle: _propTypes2.default.object,
	  /**
	   * The zDepth of the component.
	   * The shadow of the app bar is also dependent on this property.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = AppBar;

/***/ }),
/* 1520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(190);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keycode = __webpack_require__(73);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Menu = __webpack_require__(598);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(113);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Divider = __webpack_require__(172);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Popover = __webpack_require__(174);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var anchorEl = state.anchorEl;
	  var fullWidth = props.fullWidth;
	
	
	  var styles = {
	    root: {
	      display: 'inline-block',
	      position: 'relative',
	      width: fullWidth ? '100%' : 256
	    },
	    menu: {
	      width: '100%'
	    },
	    list: {
	      display: 'block',
	      width: fullWidth ? '100%' : 256
	    },
	    innerDiv: {
	      overflow: 'hidden'
	    }
	  };
	
	  if (anchorEl && fullWidth) {
	    styles.popover = {
	      width: anchorEl.clientWidth
	    };
	  }
	
	  return styles;
	}
	
	var AutoComplete = function (_Component) {
	  (0, _inherits3.default)(AutoComplete, _Component);
	
	  function AutoComplete() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoComplete);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoComplete.__proto__ || (0, _getPrototypeOf2.default)(AutoComplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      focusTextField: true,
	      open: false,
	      searchText: undefined
	    }, _this.handleRequestClose = function () {
	      // Only take into account the Popover clickAway when we are
	      // not focusing the TextField.
	      if (!_this.state.focusTextField) {
	        _this.close();
	      }
	    }, _this.handleMouseDown = function (event) {
	      // Keep the TextField focused
	      event.preventDefault();
	    }, _this.handleItemClick = function (event, child) {
	      var dataSource = _this.props.dataSource;
	      var index = parseInt(child.key, 10);
	      var chosenRequest = dataSource[index];
	      var searchText = _this.chosenRequestText(chosenRequest);
	
	      var updateInput = function updateInput() {
	        return _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	          source: 'click'
	        });
	      };
	      _this.timerClickCloseId = function () {
	        return setTimeout(function () {
	          _this.timerClickCloseId = null;
	          _this.close();
	          _this.props.onNewRequest(chosenRequest, index);
	        }, _this.props.menuCloseDelay);
	      };
	
	      if (typeof _this.props.searchText !== 'undefined') {
	        updateInput();
	        _this.timerClickCloseId();
	      } else {
	        _this.setState({
	          searchText: searchText
	        }, function () {
	          updateInput();
	          _this.timerClickCloseId();
	        });
	      }
	    }, _this.chosenRequestText = function (chosenRequest) {
	      if (typeof chosenRequest === 'string') {
	        return chosenRequest;
	      } else {
	        return chosenRequest[_this.props.dataSourceConfig.text];
	      }
	    }, _this.handleEscKeyDown = function () {
	      _this.close();
	    }, _this.handleKeyDown = function (event) {
	      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.close();
	          var searchText = _this.state.searchText;
	          if (searchText !== '') {
	            _this.props.onNewRequest(searchText, -1);
	          }
	          break;
	
	        case 'esc':
	          _this.close();
	          break;
	
	        case 'down':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            focusTextField: false,
	            anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	          });
	          break;
	
	        default:
	          break;
	      }
	    }, _this.handleChange = function (event) {
	      var searchText = event.target.value;
	
	      // Make sure that we have a new searchText.
	      // Fix an issue with a Cordova Webview
	      if (searchText === _this.state.searchText) {
	        return;
	      }
	
	      var state = {
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	      };
	
	      if (_this.props.searchText === undefined) {
	        state.searchText = searchText;
	      }
	
	      _this.setState(state);
	
	      _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	        source: 'change'
	      });
	    }, _this.handleBlur = function (event) {
	      if (_this.state.focusTextField && _this.timerClickCloseId === null) {
	        _this.timerBlurClose = setTimeout(function () {
	          _this.close();
	        }, 0);
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      if (!_this.state.open && _this.props.openOnFocus) {
	        _this.setState({
	          open: true,
	          anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	        });
	      }
	
	      _this.setState({
	        focusTextField: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoComplete, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.requestsList = [];
	      this.setState({
	        open: this.props.open,
	        searchText: this.props.searchText || ''
	      });
	      this.timerClickCloseId = null;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.searchText !== nextProps.searchText) {
	        this.setState({
	          searchText: nextProps.searchText
	        });
	      }
	      if (this.props.open !== nextProps.open) {
	        this.setState({
	          open: nextProps.open,
	          anchorEl: _reactDom2.default.findDOMNode(this.refs.searchTextField)
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerClickCloseId);
	      clearTimeout(this.timerBlurClose);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({
	        open: false,
	        anchorEl: null
	      });
	
	      if (this.props.onClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.refs.searchTextField.blur();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.refs.searchTextField.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          animated = _props.animated,
	          animation = _props.animation,
	          dataSource = _props.dataSource,
	          dataSourceConfig = _props.dataSourceConfig,
	          disableFocusRipple = _props.disableFocusRipple,
	          errorStyle = _props.errorStyle,
	          floatingLabelText = _props.floatingLabelText,
	          filter = _props.filter,
	          fullWidth = _props.fullWidth,
	          style = _props.style,
	          hintText = _props.hintText,
	          maxSearchResults = _props.maxSearchResults,
	          menuCloseDelay = _props.menuCloseDelay,
	          textFieldStyle = _props.textFieldStyle,
	          menuStyle = _props.menuStyle,
	          menuProps = _props.menuProps,
	          listStyle = _props.listStyle,
	          targetOrigin = _props.targetOrigin,
	          onBlur = _props.onBlur,
	          onClose = _props.onClose,
	          onFocus = _props.onFocus,
	          onKeyDown = _props.onKeyDown,
	          onNewRequest = _props.onNewRequest,
	          onUpdateInput = _props.onUpdateInput,
	          openOnFocus = _props.openOnFocus,
	          popoverProps = _props.popoverProps,
	          searchTextProp = _props.searchText,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'animated', 'animation', 'dataSource', 'dataSourceConfig', 'disableFocusRipple', 'errorStyle', 'floatingLabelText', 'filter', 'fullWidth', 'style', 'hintText', 'maxSearchResults', 'menuCloseDelay', 'textFieldStyle', 'menuStyle', 'menuProps', 'listStyle', 'targetOrigin', 'onBlur', 'onClose', 'onFocus', 'onKeyDown', 'onNewRequest', 'onUpdateInput', 'openOnFocus', 'popoverProps', 'searchText']);
	
	      var _ref2 = popoverProps || {},
	          popoverStyle = _ref2.style,
	          popoverOther = (0, _objectWithoutProperties3.default)(_ref2, ['style']);
	
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl,
	          searchText = _state.searchText,
	          focusTextField = _state.focusTextField;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var requestsList = [];
	
	      dataSource.every(function (item, index) {
	        switch (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) {
	          case 'string':
	            if (filter(searchText, item, item)) {
	              requestsList.push({
	                text: item,
	                value: _react2.default.createElement(_MenuItem2.default, {
	                  innerDivStyle: styles.innerDiv,
	                  value: item,
	                  primaryText: item,
	                  disableFocusRipple: disableFocusRipple,
	                  key: index
	                })
	              });
	            }
	            break;
	
	          case 'object':
	            if (item && typeof item[_this2.props.dataSourceConfig.text] === 'string') {
	              var itemText = item[_this2.props.dataSourceConfig.text];
	              if (!_this2.props.filter(searchText, itemText, item)) break;
	
	              var itemValue = item[_this2.props.dataSourceConfig.value];
	              if (itemValue && itemValue.type && (itemValue.type.muiName === _MenuItem2.default.muiName || itemValue.type.muiName === _Divider2.default.muiName)) {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.cloneElement(itemValue, {
	                    key: index,
	                    disableFocusRipple: disableFocusRipple
	                  })
	                });
	              } else {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.createElement(_MenuItem2.default, {
	                    innerDivStyle: styles.innerDiv,
	                    primaryText: itemText,
	                    disableFocusRipple: disableFocusRipple,
	                    key: index
	                  })
	                });
	              }
	            }
	            break;
	
	          default:
	          // Do nothing
	        }
	
	        return !(maxSearchResults && maxSearchResults > 0 && requestsList.length === maxSearchResults);
	      });
	
	      this.requestsList = requestsList;
	
	      var menu = open && requestsList.length > 0 && _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({
	          ref: 'menu',
	          autoWidth: false,
	          disableAutoFocus: focusTextField,
	          onEscKeyDown: this.handleEscKeyDown,
	          initiallyKeyboardFocused: true,
	          onItemClick: this.handleItemClick,
	          onMouseDown: this.handleMouseDown,
	          style: (0, _simpleAssign2.default)(styles.menu, menuStyle),
	          listStyle: (0, _simpleAssign2.default)(styles.list, listStyle)
	        }, menuProps),
	        requestsList.map(function (i) {
	          return i.value;
	        })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({
	          ref: 'searchTextField',
	          autoComplete: 'off',
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onKeyDown: this.handleKeyDown,
	          floatingLabelText: floatingLabelText,
	          hintText: hintText,
	          fullWidth: fullWidth,
	          multiLine: false,
	          errorStyle: errorStyle,
	          style: textFieldStyle
	        }, other, {
	          // value and onChange are idiomatic properties often leaked.
	          // We prevent their overrides in order to reduce potential bugs.
	          value: searchText,
	          onChange: this.handleChange
	        })),
	        _react2.default.createElement(
	          _Popover2.default,
	          (0, _extends3.default)({
	            style: (0, _simpleAssign2.default)({}, styles.popover, popoverStyle),
	            canAutoPosition: false,
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation
	          }, popoverOther),
	          menu
	        )
	      );
	    }
	  }]);
	  return AutoComplete;
	}(_react.Component);
	
	AutoComplete.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  dataSourceConfig: {
	    text: 'text',
	    value: 'value'
	  },
	  disableFocusRipple: true,
	  filter: function filter(searchText, key) {
	    return searchText !== '' && key.indexOf(searchText) !== -1;
	  },
	  fullWidth: false,
	  open: false,
	  openOnFocus: false,
	  onUpdateInput: function onUpdateInput() {},
	  onNewRequest: function onNewRequest() {},
	  menuCloseDelay: 300,
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	AutoComplete.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	AutoComplete.propTypes =  false ? {
	  /**
	   * Location of the anchor for the auto complete.
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the auto complete is animated as it is toggled.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * Array of strings or nodes used to populate the list.
	   */
	  dataSource: _propTypes2.default.array.isRequired,
	  /**
	   * Config for objects list dataSource.
	   *
	   * @typedef {Object} dataSourceConfig
	   *
	   * @property {string} text `dataSource` element key used to find a string to be matched for search
	   * and shown as a `TextField` input value after choosing the result.
	   * @property {string} value `dataSource` element key used to find a string to be shown in search results.
	   */
	  dataSourceConfig: _propTypes2.default.object,
	  /**
	   * Disables focus ripple when true.
	   */
	  disableFocusRipple: _propTypes2.default.bool,
	  /**
	   * Override style prop for error.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * Callback function used to filter the auto complete.
	   *
	   * @param {string} searchText The text to search for within `dataSource`.
	   * @param {string} key `dataSource` element, or `text` property on that element if it's not a string.
	   * @returns {boolean} `true` indicates the auto complete list will include `key` when the input is `searchText`.
	   */
	  filter: _propTypes2.default.func,
	  /**
	   * The content to use for adding floating label element.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the field receives the property `width: 100%`.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * Override style for list.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The max number of search results to be shown.
	   * By default it shows all the items which matches filter.
	   */
	  maxSearchResults: _propTypes2.default.number,
	  /**
	   * Delay for closing time of the menu.
	   */
	  menuCloseDelay: _propTypes2.default.number,
	  /**
	   * Props to be passed to menu.
	   */
	  menuProps: _propTypes2.default.object,
	  /**
	   * Override style for menu.
	   */
	  menuStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when a list item is selected, or enter is pressed in the `TextField`.
	   *
	   * @param {string} chosenRequest Either the `TextField` input value, if enter is pressed in the `TextField`,
	   * or the dataSource object corresponding to the list item that was selected.
	   * @param {number} index The index in `dataSource` of the list item selected, or `-1` if enter is pressed in the
	   * `TextField`.
	   */
	  onNewRequest: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the user updates the `TextField`.
	   *
	   * @param {string} searchText The auto-complete's `searchText` value.
	   * @param {array} dataSource The auto-complete's `dataSource` array.
	   * @param {object} params Additional information linked the update.
	   */
	  onUpdateInput: _propTypes2.default.func,
	  /**
	   * Auto complete menu is open if true.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * If true, the list item is showed when a focus event triggers.
	   */
	  openOnFocus: _propTypes2.default.bool,
	  /**
	   * Props to be passed to popover.
	   */
	  popoverProps: _propTypes2.default.object,
	  /**
	   * Text being input to auto complete.
	   */
	  searchText: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Origin for location of target.
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * Override the inline-styles of AutoComplete's TextField element.
	   */
	  textFieldStyle: _propTypes2.default.object
	} : {};
	
	
	AutoComplete.levenshteinDistance = function (searchText, key) {
	  var current = [];
	  var prev = void 0;
	  var value = void 0;
	
	  for (var i = 0; i <= key.length; i++) {
	    for (var j = 0; j <= searchText.length; j++) {
	      if (i && j) {
	        if (searchText.charAt(j - 1) === key.charAt(i - 1)) value = prev;else value = Math.min(current[j], current[j - 1], prev) + 1;
	      } else {
	        value = i + j;
	      }
	      prev = current[j];
	      current[j] = value;
	    }
	  }
	  return current.pop();
	};
	
	AutoComplete.noFilter = function () {
	  return true;
	};
	
	AutoComplete.defaultFilter = AutoComplete.caseSensitiveFilter = function (searchText, key) {
	  return searchText !== '' && key.indexOf(searchText) !== -1;
	};
	
	AutoComplete.caseInsensitiveFilter = function (searchText, key) {
	  return key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
	};
	
	AutoComplete.levenshteinDistanceFilter = function (distanceLessThan) {
	  if (distanceLessThan === undefined) {
	    return AutoComplete.levenshteinDistance;
	  } else if (typeof distanceLessThan !== 'number') {
	    throw 'Error: AutoComplete.levenshteinDistanceFilter is a filter generator, not a filter!';
	  }
	
	  return function (s, k) {
	    return AutoComplete.levenshteinDistance(s, k) < distanceLessThan;
	  };
	};
	
	AutoComplete.fuzzyFilter = function (searchText, key) {
	  var compareString = key.toLowerCase();
	  searchText = searchText.toLowerCase();
	
	  var searchTextIndex = 0;
	  for (var index = 0; index < key.length; index++) {
	    if (compareString[index] === searchText[searchTextIndex]) {
	      searchTextIndex += 1;
	    }
	  }
	
	  return searchTextIndex === searchText.length;
	};
	
	AutoComplete.Item = _MenuItem2.default;
	AutoComplete.Divider = _Divider2.default;
	
	exports.default = AutoComplete;

/***/ }),
/* 1521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AutoComplete = __webpack_require__(1520);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoComplete2.default;

/***/ }),
/* 1522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var backgroundColor = props.backgroundColor,
	      color = props.color,
	      size = props.size;
	  var avatar = context.muiTheme.avatar;
	
	
	  var styles = {
	    root: {
	      color: color || avatar.color,
	      backgroundColor: backgroundColor || avatar.backgroundColor,
	      userSelect: 'none',
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      fontSize: size / 2,
	      borderRadius: '50%',
	      height: size,
	      width: size
	    },
	    icon: {
	      color: color || avatar.color,
	      width: size * 0.6,
	      height: size * 0.6,
	      fontSize: size * 0.6,
	      margin: size * 0.2
	    }
	  };
	
	  return styles;
	}
	
	var Avatar = function (_Component) {
	  (0, _inherits3.default)(Avatar, _Component);
	
	  function Avatar() {
	    (0, _classCallCheck3.default)(this, Avatar);
	    return (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Avatar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          icon = _props.icon,
	          src = _props.src,
	          style = _props.style,
	          className = _props.className,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      if (src) {
	        return _react2.default.createElement('img', (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other, {
	          src: src,
	          className: className
	        }));
	      } else {
	        return _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, {
	            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
	            className: className
	          }),
	          icon && _react2.default.cloneElement(icon, {
	            color: styles.icon.color,
	            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	          }),
	          this.props.children
	        );
	      }
	    }
	  }]);
	  return Avatar;
	}(_react.Component);
	
	Avatar.muiName = 'Avatar';
	Avatar.defaultProps = {
	  size: 40
	};
	Avatar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Avatar.propTypes =  false ? {
	  /**
	   * The backgroundColor of the avatar. Does not apply to image avatars.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Can be used, for instance, to render a letter inside the avatar.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root `div` or `img` element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The icon or letter's color.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the SvgIcon or FontIcon to be used inside the avatar.
	   */
	  icon: _propTypes2.default.element,
	  /**
	   * This is the size of the avatar in pixels.
	   */
	  size: _propTypes2.default.number,
	  /**
	   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
	   */
	  src: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Avatar;

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var primary = props.primary,
	      secondary = props.secondary;
	  var badge = context.muiTheme.badge;
	
	
	  var badgeBackgroundColor = void 0;
	  var badgeTextColor = void 0;
	
	  if (primary) {
	    badgeBackgroundColor = badge.primaryColor;
	    badgeTextColor = badge.primaryTextColor;
	  } else if (secondary) {
	    badgeBackgroundColor = badge.secondaryColor;
	    badgeTextColor = badge.secondaryTextColor;
	  } else {
	    badgeBackgroundColor = badge.color;
	    badgeTextColor = badge.textColor;
	  }
	
	  var radius = 12;
	  var radius2x = Math.floor(2 * radius);
	
	  return {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      padding: radius2x + 'px ' + radius2x + 'px ' + radius + 'px ' + radius + 'px'
	    },
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      fontWeight: badge.fontWeight,
	      fontSize: radius,
	      width: radius2x,
	      height: radius2x,
	      borderRadius: '50%',
	      backgroundColor: badgeBackgroundColor,
	      color: badgeTextColor
	    }
	  };
	}
	
	var Badge = function (_Component) {
	  (0, _inherits3.default)(Badge, _Component);
	
	  function Badge() {
	    (0, _classCallCheck3.default)(this, Badge);
	    return (0, _possibleConstructorReturn3.default)(this, (Badge.__proto__ || (0, _getPrototypeOf2.default)(Badge)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Badge, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          badgeContent = _props.badgeContent,
	          badgeStyle = _props.badgeStyle,
	          children = _props.children,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['badgeContent', 'badgeStyle', 'children', 'primary', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, styles.badge, badgeStyle)) },
	          badgeContent
	        )
	      );
	    }
	  }]);
	  return Badge;
	}(_react.Component);
	
	Badge.defaultProps = {
	  primary: false,
	  secondary: false
	};
	Badge.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Badge.propTypes =  false ? {
	  /**
	   * This is the content rendered within the badge.
	   */
	  badgeContent: _propTypes2.default.node.isRequired,
	  /**
	   * Override the inline-styles of the badge element.
	   */
	  badgeStyle: _propTypes2.default.object,
	  /**
	   * The badge will be added relativelty to this node.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the badge will use the primary badge colors.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * If true, the badge will use the secondary badge colors.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Badge;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Badge = __webpack_require__(1523);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Badge2.default;

/***/ }),
/* 1525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      width: '100%',
	      display: 'flex',
	      justifyContent: 'center',
	      backgroundColor: bottomNavigation.backgroundColor,
	      height: bottomNavigation.height
	    },
	    item: {
	      flex: '1'
	    }
	  };
	
	  return styles;
	}
	
	var BottomNavigation = function BottomNavigation(props, context) {
	  var children = props.children,
	      style = props.style,
	      selectedIndex = props.selectedIndex,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'style', 'selectedIndex']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var preparedChildren = _react.Children.map(children, function (child, index) {
	    if (!child) {
	      return null;
	    }
	
	    return (0, _react.cloneElement)(child, {
	      style: (0, _simpleAssign2.default)({}, styles.item, child.props.style),
	      selected: index === selectedIndex
	    });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	    preparedChildren
	  );
	};
	
	BottomNavigation.propTypes =  false ? {
	  /**
	   * The `BottomNavigationItem`s to populate the element with.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The index of the currently selected navigation item.
	   */
	  selectedIndex: _propTypes2.default.number,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	BottomNavigation.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = BottomNavigation;

/***/ }),
/* 1526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BottomNavigationItem = exports.BottomNavigation = undefined;
	
	var _BottomNavigation2 = __webpack_require__(1525);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(586);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.default = _BottomNavigation3.default;

/***/ }),
/* 1527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _CardExpandable = __webpack_require__(588);
	
	var _CardExpandable2 = _interopRequireDefault(_CardExpandable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function (_Component) {
	  (0, _inherits3.default)(Card, _Component);
	
	  function Card() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Card);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      expanded: null
	    }, _this.handleExpanding = function (event) {
	      event.preventDefault();
	      var newExpandedState = !_this.state.expanded;
	      // no automatic state update when the component is controlled
	      if (_this.props.expanded === null) {
	        _this.setState({ expanded: newExpandedState });
	      }
	      if (_this.props.onExpandChange) {
	        _this.props.onExpandChange(newExpandedState);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Card, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          containerStyle = _props.containerStyle,
	          children = _props.children,
	          expandable = _props.expandable,
	          expandedProp = _props.expanded,
	          initiallyExpanded = _props.initiallyExpanded,
	          onExpandChange = _props.onExpandChange,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);
	
	
	      var lastElement = void 0;
	      var expanded = this.state.expanded;
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        var doClone = false;
	        var newChild = undefined;
	        var newProps = {};
	        var element = currentChild;
	        if (!currentChild || !currentChild.props) {
	          return null;
	        }
	        if (expanded === false && currentChild.props.expandable === true) return;
	        if (currentChild.props.actAsExpander === true) {
	          doClone = true;
	          newProps.onClick = _this2.handleExpanding;
	          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
	        }
	        if (currentChild.props.showExpandableButton === true) {
	          doClone = true;
	          newChild = _react2.default.createElement(_CardExpandable2.default, {
	            closeIcon: currentChild.props.closeIcon,
	            expanded: expanded,
	            onExpanding: _this2.handleExpanding,
	            openIcon: currentChild.props.openIcon,
	            iconStyle: currentChild.props.iconStyle
	          });
	        }
	        if (doClone) {
	          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
	        }
	        lastElement = element;
	        return element;
	      }, this);
	
	      // If the last element is text or a title we should add
	      // 8px padding to the bottom of the card
	      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        zIndex: 1
	      }, style);
	      var containerMergedStyles = (0, _simpleAssign2.default)({
	        paddingBottom: addBottomPadding ? 8 : 0
	      }, containerStyle);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, { style: mergedStyles }),
	        _react2.default.createElement(
	          'div',
	          { style: containerMergedStyles },
	          newChildren
	        )
	      );
	    }
	  }]);
	  return Card;
	}(_react.Component);
	
	Card.defaultProps = {
	  expandable: false,
	  expanded: null,
	  initiallyExpanded: false
	};
	Card.propTypes =  false ? {
	  /**
	   * Can be used to render elements inside the Card.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _propTypes2.default.object,
	  /**
	   * If true, this card component is expandable. Can be set on any child of the `Card` component.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Whether this card is expanded.
	   * If `true` or `false` the component is controlled.
	   * if `null` the component is uncontrolled.
	   */
	  expanded: _propTypes2.default.bool,
	  /**
	   * Whether this card is initially expanded.
	   */
	  initiallyExpanded: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the `expandable` state of the card has changed.
	   *
	   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
	   */
	  onExpandChange: _propTypes2.default.func,
	  /**
	   * If true, this card component will include a button to expand the card. `CardTitle`,
	   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
	   * of `Card` can implements `showExpandableButton` or forwards the property to a child
	   * component supporting it.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Card;

/***/ }),
/* 1528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;
	
	var _Card2 = __webpack_require__(1527);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardHeader2 = __webpack_require__(589);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardTitle2 = __webpack_require__(592);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardMedia2 = __webpack_require__(590);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardText2 = __webpack_require__(591);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _CardActions2 = __webpack_require__(587);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardExpandable2 = __webpack_require__(588);
	
	var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Card = _Card3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardText = _CardText3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardExpandable = _CardExpandable3.default;
	exports.default = _Card3.default;

/***/ }),
/* 1529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedSwitch = __webpack_require__(381);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _checkBoxOutlineBlank = __webpack_require__(1621);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(1622);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var checkbox = context.muiTheme.checkbox;
	
	  var checkboxSize = 24;
	
	  return {
	    icon: {
	      height: checkboxSize,
	      width: checkboxSize
	    },
	    check: {
	      position: 'absolute',
	      opacity: 0,
	      transform: 'scale(0)',
	      transitionOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
	      fill: checkbox.checkedColor
	    },
	    checkWhenSwitched: {
	      opacity: 1,
	      transform: 'scale(1)',
	      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
	    },
	    checkWhenDisabled: {
	      fill: checkbox.disabledColor
	    },
	    box: {
	      position: 'absolute',
	      opacity: 1,
	      fill: checkbox.boxColor,
	      transition: _transitions2.default.easeOut('1000ms', 'opacity', '200ms')
	    },
	    boxWhenSwitched: {
	      opacity: 0,
	      transition: _transitions2.default.easeOut('650ms', 'opacity', '150ms'),
	      fill: checkbox.checkedColor
	    },
	    boxWhenDisabled: {
	      fill: props.checked ? 'transparent' : checkbox.disabledColor
	    },
	    label: {
	      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
	    }
	  };
	}
	
	var Checkbox = function (_Component) {
	  (0, _inherits3.default)(Checkbox, _Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleCheck = function (event, isInputChecked) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Checkbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          checked = _props.checked,
	          defaultChecked = _props.defaultChecked,
	          valueLink = _props.valueLink;
	
	
	      if (checked || defaultChecked || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.checked !== nextProps.checked) {
	        this.setState({
	          switched: nextProps.checked
	        });
	      }
	    }
	  }, {
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          iconStyle = _props2.iconStyle,
	          onCheck = _props2.onCheck,
	          checkedIcon = _props2.checkedIcon,
	          uncheckedIcon = _props2.uncheckedIcon,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon']);
	
	      var styles = getStyles(this.props, this.context);
	      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
	      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);
	
	      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_checkBox2.default, {
	        style: checkStyles
	      });
	
	      var unCheckedElement = uncheckedIcon ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(boxStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
	        style: boxStyles
	      });
	
	      var checkboxElement = _react2.default.createElement(
	        'div',
	        null,
	        unCheckedElement,
	        checkedElement
	      );
	
	      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switched: this.state.switched,
	        switchElement: checkboxElement,
	        rippleColor: rippleColor,
	        iconStyle: mergedIconStyle,
	        onSwitch: this.handleCheck,
	        labelStyle: labelStyle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.defaultProps = {
	  labelPosition: 'right',
	  disabled: false
	};
	Checkbox.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Checkbox.propTypes =  false ? {
	  /**
	   * Checkbox is checked if true.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * The SvgIcon to use for the checked state.
	   * This is useful to create icon toggles.
	   */
	  checkedIcon: _propTypes2.default.element,
	  /**
	   * The default state of our checkbox component.
	   * **Warning:** This cannot be used in conjunction with `checked`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultChecked: _propTypes2.default.bool,
	  /**
	   * Disabled if true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * Where the label will be placed next to the checkbox.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Checkbox element label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function that is fired when the checkbox is checked.
	   *
	   * @param {object} event `change` event targeting the underlying checkbox `input`.
	   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
	   */
	  onCheck: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The SvgIcon to use for the unchecked state.
	   * This is useful to create icon toggles.
	   */
	  uncheckedIcon: _propTypes2.default.element,
	  /**
	   * ValueLink for when using controlled checkbox.
	   */
	  valueLink: _propTypes2.default.object
	} : {};
	exports.default = Checkbox;

/***/ }),
/* 1530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keycode = __webpack_require__(73);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _colorManipulator = __webpack_require__(90);
	
	var _EnhancedButton = __webpack_require__(84);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _cancel = __webpack_require__(1614);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var chip = context.muiTheme.chip;
	
	
	  var backgroundColor = props.backgroundColor || chip.backgroundColor;
	  var focusColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.08);
	  var pressedColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.12);
	
	  return {
	    avatar: {
	      marginRight: -4
	    },
	    deleteIcon: {
	      color: state.deleteHovered ? (0, _colorManipulator.fade)(chip.deleteIconColor, 0.4) : chip.deleteIconColor,
	      cursor: 'pointer',
	      margin: '4px 4px 0px -8px'
	    },
	    label: {
	      color: props.labelColor || chip.textColor,
	      fontSize: chip.fontSize,
	      fontWeight: chip.fontWeight,
	      lineHeight: '32px',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap'
	    },
	    root: {
	      backgroundColor: state.clicked ? pressedColor : state.focused || state.hovered ? focusColor : backgroundColor,
	      borderRadius: 16,
	      boxShadow: state.clicked ? chip.shadow : null,
	      cursor: props.onClick ? 'pointer' : 'default',
	      display: 'flex',
	      whiteSpace: 'nowrap',
	      width: 'fit-content'
	    }
	  };
	}
	
	var Chip = function (_Component) {
	  (0, _inherits3.default)(Chip, _Component);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Chip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chip.__proto__ || (0, _getPrototypeOf2.default)(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      clicked: false,
	      deleteHovered: false,
	      focused: false,
	      hovered: false
	    }, _this.handleBlur = function (event) {
	      _this.setState({ clicked: false, focused: false });
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (_this.props.onClick || _this.props.onRequestDelete) {
	        _this.setState({ focused: true });
	      }
	      _this.props.onFocus(event);
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused) {
	        _this.handleFocus();
	        _this.props.onFocus(event);
	      } else {
	        _this.handleBlur();
	      }
	
	      _this.props.onKeyboardFocus(event, keyboardFocused);
	    }, _this.handleKeyDown = function (event) {
	      if ((0, _keycode2.default)(event) === 'backspace') {
	        event.preventDefault();
	        if (_this.props.onRequestDelete) {
	          _this.props.onRequestDelete(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleMouseDown = function (event) {
	      // Only listen to left clicks
	      if (event.button === 0) {
	        event.stopPropagation();
	        if (_this.props.onClick) {
	          _this.setState({ clicked: true });
	        }
	      }
	      _this.props.onMouseDown(event);
	    }, _this.handleMouseEnter = function (event) {
	      if (_this.props.onClick) {
	        _this.setState({ hovered: true });
	      }
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseEnterDeleteIcon = function () {
	      _this.setState({ deleteHovered: true });
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({
	        clicked: false,
	        hovered: false
	      });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseLeaveDeleteIcon = function () {
	      _this.setState({ deleteHovered: false });
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onMouseUp(event);
	    }, _this.handleClickDeleteIcon = function (event) {
	      // Stop the event from bubbling up to the `Chip`
	      event.stopPropagation();
	      _this.props.onRequestDelete(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onTouchEnd(event);
	    }, _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      if (_this.props.onClick) {
	        _this.setState({ clicked: true });
	      }
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Chip, [{
	    key: 'render',
	    value: function render() {
	      var buttonEventHandlers = {
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleMouseDown,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseUp: this.handleMouseUp,
	        onTouchEnd: this.handleTouchEnd,
	        onTouchStart: this.handleTouchStart,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var _props = this.props,
	          childrenProp = _props.children,
	          containerElement = _props.containerElement,
	          style = _props.style,
	          className = _props.className,
	          deleteIconStyle = _props.deleteIconStyle,
	          labelStyle = _props.labelStyle,
	          labelColor = _props.labelColor,
	          backgroundColor = _props.backgroundColor,
	          onRequestDelete = _props.onRequestDelete,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'containerElement', 'style', 'className', 'deleteIconStyle', 'labelStyle', 'labelColor', 'backgroundColor', 'onRequestDelete']);
	
	
	      var deletable = this.props.onRequestDelete;
	      var avatar = null;
	
	      var deleteIcon = deletable ? _react2.default.createElement(_cancel2.default, {
	        color: styles.deleteIcon.color,
	        style: (0, _simpleAssign2.default)(styles.deleteIcon, deleteIconStyle),
	        onClick: this.handleClickDeleteIcon,
	        onMouseEnter: this.handleMouseEnterDeleteIcon,
	        onMouseLeave: this.handleMouseLeaveDeleteIcon
	      }) : null;
	
	      var children = childrenProp;
	      var childCount = _react2.default.Children.count(children);
	
	      // If the first child is an avatar, extract it and style it
	      if (childCount > 1) {
	        children = _react2.default.Children.toArray(children);
	
	        if (_react2.default.isValidElement(children[0]) && children[0].type.muiName === 'Avatar') {
	          avatar = children.shift();
	
	          avatar = _react2.default.cloneElement(avatar, {
	            style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style),
	            size: 32
	          });
	        }
	      }
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, buttonEventHandlers, {
	          className: className,
	          containerElement: containerElement,
	          disableTouchRipple: true,
	          disableFocusRipple: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }),
	        avatar,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	          children
	        ),
	        deleteIcon
	      );
	    }
	  }]);
	  return Chip;
	}(_react.Component);
	
	Chip.defaultProps = {
	  containerElement: 'div', // Firefox doesn't support nested buttons
	  onBlur: function onBlur() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseUp: function onMouseUp() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {}
	};
	Chip.contextTypes = { muiTheme: _propTypes2.default.object.isRequired };
	Chip.propTypes =  false ? {
	  /**
	   * Override the background color of the chip.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Used to render elements inside the Chip.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * CSS `className` of the root element.
	   */
	  className: _propTypes2.default.node,
	  /**
	   * The element to use as the container for the Chip. Either a string to
	   * use a DOM element or a ReactElement.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * Override the inline-styles of the delete icon.
	   */
	  deleteIconStyle: _propTypes2.default.object,
	  /**
	   * Override the label color.
	   */
	  labelColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `Chip` element is clicked.
	   *
	   * @param {object} event Click event targeting the element.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /** @ignore */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /**
	   * Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.
	   * @param {object} event `click` event targeting the element.
	   */
	  onRequestDelete: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Chip;

/***/ }),
/* 1531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Chip = __webpack_require__(1530);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chip2.default;

/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autoPrefix = __webpack_require__(137);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return clampedValue / (max - min);
	}
	
	function getArcLength(fraction, props) {
	  return fraction * Math.PI * (props.size - props.thickness);
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      size = props.size,
	      value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      width: size,
	      height: size
	    },
	    wrapper: {
	      width: size,
	      height: size,
	      display: 'inline-block',
	      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	      transitionTimingFunction: 'linear'
	    },
	    svg: {
	      width: size,
	      height: size,
	      position: 'relative'
	    },
	    path: {
	      stroke: props.color || palette.primary1Color,
	      strokeLinecap: 'round',
	      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	    }
	  };
	
	  if (props.mode === 'determinate') {
	    var relVal = getRelativeValue(value, min, max);
	    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
	    styles.path.strokeDasharray = getArcLength(relVal, props) + ', ' + getArcLength(1, props);
	  }
	
	  return styles;
	}
	
	var CircularProgress = function (_Component) {
	  (0, _inherits3.default)(CircularProgress, _Component);
	
	  function CircularProgress() {
	    (0, _classCallCheck3.default)(this, CircularProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (CircularProgress.__proto__ || (0, _getPrototypeOf2.default)(CircularProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircularProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path) {
	      var _this2 = this;
	
	      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step %= 3;
	
	      if (step === 0) {
	        path.style.strokeDasharray = getArcLength(0, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = 0;
	        path.style.transitionDuration = '0ms';
	      } else if (step === 1) {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-0.3, this.props);
	        path.style.transitionDuration = '750ms';
	      } else {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-1, this.props);
	        path.style.transitionDuration = '850ms';
	      }
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, step + 1);
	      }, step ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          innerStyle = _props.innerStyle,
	          size = _props.size,
	          thickness = _props.thickness,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'innerStyle', 'size', 'thickness']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
	          _react2.default.createElement(
	            'svg',
	            {
	              viewBox: '0 0 ' + size + ' ' + size,
	              style: prepareStyles(styles.svg)
	            },
	            _react2.default.createElement('circle', {
	              ref: 'path',
	              style: prepareStyles(styles.path),
	              cx: size / 2,
	              cy: size / 2,
	              r: (size - thickness) / 2,
	              fill: 'none',
	              strokeWidth: thickness,
	              strokeMiterlimit: '20'
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return CircularProgress;
	}(_react.Component);
	
	CircularProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100,
	  size: 40,
	  thickness: 3.5
	};
	CircularProgress.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CircularProgress.propTypes =  false ? {
	  /**
	   * Override the progress's color.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * Style for inner wrapper div.
	   */
	  innerStyle: _propTypes2.default.object,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _propTypes2.default.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _propTypes2.default.number,
	  /**
	   * The mode of show your progress, indeterminate
	   * for when there is no value for progress.
	   */
	  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
	  /**
	   * The diameter of the progress in pixels.
	   */
	  size: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Stroke width in pixels.
	   */
	  thickness: _propTypes2.default.number,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _propTypes2.default.number
	} : {};
	exports.default = CircularProgress;

/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toConsumableArray2 = __webpack_require__(189);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(100);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(73);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _CalendarActionButtons = __webpack_require__(1534);
	
	var _CalendarActionButtons2 = _interopRequireDefault(_CalendarActionButtons);
	
	var _CalendarMonth = __webpack_require__(1535);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _CalendarYear = __webpack_require__(1537);
	
	var _CalendarYear2 = _interopRequireDefault(_CalendarYear);
	
	var _CalendarToolbar = __webpack_require__(1536);
	
	var _CalendarToolbar2 = _interopRequireDefault(_CalendarToolbar);
	
	var _DateDisplay = __webpack_require__(1538);
	
	var _DateDisplay2 = _interopRequireDefault(_DateDisplay);
	
	var _SlideIn = __webpack_require__(383);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	var _dateUtils = __webpack_require__(208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var daysArray = [].concat((0, _toConsumableArray3.default)(Array(7)));
	
	var Calendar = function (_Component) {
	  (0, _inherits3.default)(Calendar, _Component);
	
	  function Calendar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Calendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      displayDate: undefined,
	      displayMonthDay: undefined,
	      selectedDate: undefined,
	      transitionDirection: 'left',
	      transitionEnter: true
	    }, _this.calendarRefs = {}, _this.handleClickDay = function (event, date) {
	      _this.setSelectedDate(date);
	      if (_this.props.onClickDay) _this.props.onClickDay(event, date);
	    }, _this.handleMonthChange = function (months) {
	      var nextDirection = _this.context.muiTheme.isRtl ? 'right' : 'left';
	      var prevDirection = _this.context.muiTheme.isRtl ? 'left' : 'right';
	      var direction = months >= 0 ? nextDirection : prevDirection;
	      _this.setState({
	        transitionDirection: direction,
	        displayDate: _this.props.utils.addMonths(_this.state.displayDate, months)
	      });
	    }, _this.handleClickYear = function (event, year) {
	      _this.setSelectedDate(_this.props.utils.setYear(_this.state.selectedDate, year), event);
	      _this.handleClickDateDisplayMonthDay();
	    }, _this.handleClickDateDisplayMonthDay = function () {
	      _this.setState({
	        displayMonthDay: true
	      });
	    }, _this.handleClickDateDisplayYear = function () {
	      _this.setState({
	        displayMonthDay: false
	      });
	    }, _this.handleWindowKeyDown = function (event) {
	      if (_this.props.open) {
	        var nextArrow = _this.context.muiTheme.isRtl ? 'left' : 'right';
	        var prevArrow = _this.context.muiTheme.isRtl ? 'right' : 'left';
	        switch ((0, _keycode2.default)(event)) {
	          case 'up':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-7);
	            }
	            break;
	
	          case 'down':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(7);
	            }
	            break;
	
	          case nextArrow:
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(1);
	            }
	            break;
	
	          case prevArrow:
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-1);
	            }
	            break;
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Calendar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        displayDate: this.props.utils.getFirstDayOfMonth(this.props.initialDate),
	        selectedDate: this.props.initialDate,
	        displayMonthDay: !this.props.openToYearSelection
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.initialDate !== this.props.initialDate) {
	        var date = nextProps.initialDate || new Date();
	        this.setState({
	          displayDate: this.props.utils.getFirstDayOfMonth(date),
	          selectedDate: date
	        });
	      }
	    }
	  }, {
	    key: 'getMinDate',
	    value: function getMinDate() {
	      return this.props.minDate || this.props.utils.addYears(new Date(), -100);
	    }
	  }, {
	    key: 'getMaxDate',
	    value: function getMaxDate() {
	      return this.props.maxDate || this.props.utils.addYears(new Date(), 100);
	    }
	  }, {
	    key: 'getSelectedDate',
	    value: function getSelectedDate() {
	      return this.state.selectedDate;
	    }
	  }, {
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      if (!this.state.displayMonthDay) {
	        return false;
	      }
	
	      if (this.calendarRefs.calendar) {
	        return this.calendarRefs.calendar.isSelectedDateDisabled();
	      } else {
	        return false;
	      }
	    }
	  }, {
	    key: 'addSelectedDays',
	    value: function addSelectedDays(days) {
	      this.setSelectedDate(this.props.utils.addDays(this.state.selectedDate, days));
	    }
	  }, {
	    key: 'addSelectedMonths',
	    value: function addSelectedMonths(months) {
	      this.setSelectedDate(this.props.utils.addMonths(this.state.selectedDate, months));
	    }
	  }, {
	    key: 'addSelectedYears',
	    value: function addSelectedYears(years) {
	      this.setSelectedDate(this.props.utils.addYears(this.state.selectedDate, years));
	    }
	  }, {
	    key: 'setDisplayDate',
	    value: function setDisplayDate(date, newSelectedDate) {
	      var newDisplayDate = this.props.utils.getFirstDayOfMonth(date);
	
	      if (newDisplayDate !== this.state.displayDate) {
	        var nextDirection = this.context.muiTheme.isRtl ? 'right' : 'left';
	        var prevDirection = this.context.muiTheme.isRtl ? 'left' : 'right';
	        var direction = newDisplayDate > this.state.displayDate ? nextDirection : prevDirection;
	        this.setState({
	          displayDate: newDisplayDate,
	          transitionDirection: direction,
	          selectedDate: newSelectedDate || this.state.selectedDate
	        });
	      }
	    }
	  }, {
	    key: 'setSelectedDate',
	    value: function setSelectedDate(date) {
	      var adjustedDate = date;
	      var minDate = this.getMinDate();
	      var maxDate = this.getMaxDate();
	      if ((0, _dateUtils.isBeforeDate)(date, minDate)) {
	        adjustedDate = minDate;
	      } else if ((0, _dateUtils.isAfterDate)(date, maxDate)) {
	        adjustedDate = maxDate;
	      }
	
	      var newDisplayDate = this.props.utils.getFirstDayOfMonth(adjustedDate);
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setDisplayDate(newDisplayDate, adjustedDate);
	      } else {
	        this.setState({
	          selectedDate: adjustedDate
	        });
	      }
	    }
	  }, {
	    key: 'getToolbarInteractions',
	    value: function getToolbarInteractions() {
	      return {
	        prevMonth: this.props.utils.monthDiff(this.state.displayDate, this.getMinDate()) > 0,
	        nextMonth: this.props.utils.monthDiff(this.state.displayDate, this.getMaxDate()) < 0
	      };
	    }
	  }, {
	    key: 'yearSelector',
	    value: function yearSelector() {
	      if (!this.props.disableYearSelection) {
	        return _react2.default.createElement(_CalendarYear2.default, {
	          key: 'years',
	          DateTimeFormat: this.props.DateTimeFormat,
	          locale: this.props.locale,
	          onClickYear: this.handleClickYear,
	          selectedDate: this.state.selectedDate,
	          minDate: this.getMinDate(),
	          maxDate: this.getMaxDate(),
	          utils: this.props.utils
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var hideCalendarDate = this.props.hideCalendarDate;
	
	      var toolbarInteractions = this.getToolbarInteractions();
	      var isLandscape = this.props.mode === 'landscape';
	      var calendarTextColor = this.context.muiTheme.datePicker.calendarTextColor;
	
	
	      var styles = {
	        root: {
	          color: calendarTextColor,
	          userSelect: 'none',
	          width: !hideCalendarDate && isLandscape ? 479 : 310
	        },
	        calendar: {
	          display: 'flex',
	          flexDirection: 'column'
	        },
	        calendarContainer: {
	          display: 'flex',
	          alignContent: 'space-between',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          fontSize: 12,
	          fontWeight: 400,
	          padding: '0px 8px',
	          transition: _transitions2.default.easeOut()
	        },
	        yearContainer: {
	          display: 'flex',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          height: 272,
	          marginTop: 10,
	          overflow: 'hidden',
	          width: 310
	        },
	        weekTitle: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'space-between',
	          fontWeight: '500',
	          height: 20,
	          lineHeight: '15px',
	          opacity: '0.5',
	          textAlign: 'center'
	        },
	        weekTitleDay: {
	          width: 42
	        },
	        transitionSlide: {
	          height: 214
	        }
	      };
	
	      var weekTitleDayStyle = prepareStyles(styles.weekTitleDay);
	
	      var _props = this.props,
	          cancelLabel = _props.cancelLabel,
	          DateTimeFormat = _props.DateTimeFormat,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          okLabel = _props.okLabel,
	          onClickCancel = _props.onClickCancel,
	          onClickOk = _props.onClickOk,
	          utils = _props.utils;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleWindowKeyDown
	        }),
	        !hideCalendarDate && _react2.default.createElement(_DateDisplay2.default, {
	          DateTimeFormat: DateTimeFormat,
	          disableYearSelection: this.props.disableYearSelection,
	          onClickMonthDay: this.handleClickDateDisplayMonthDay,
	          onClickYear: this.handleClickDateDisplayYear,
	          locale: locale,
	          monthDaySelected: this.state.displayMonthDay,
	          mode: this.props.mode,
	          selectedDate: this.state.selectedDate
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.calendar) },
	          this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.calendarContainer) },
	            _react2.default.createElement(_CalendarToolbar2.default, {
	              DateTimeFormat: DateTimeFormat,
	              locale: locale,
	              displayDate: this.state.displayDate,
	              onMonthChange: this.handleMonthChange,
	              prevMonth: toolbarInteractions.prevMonth,
	              nextMonth: toolbarInteractions.nextMonth
	            }),
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.weekTitle) },
	              daysArray.map(function (event, i) {
	                return _react2.default.createElement(
	                  'span',
	                  { key: i, style: weekTitleDayStyle },
	                  (0, _dateUtils.localizedWeekday)(DateTimeFormat, locale, i, firstDayOfWeek)
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _SlideIn2.default,
	              { direction: this.state.transitionDirection, style: styles.transitionSlide },
	              _react2.default.createElement(_CalendarMonth2.default, {
	                DateTimeFormat: DateTimeFormat,
	                locale: locale,
	                displayDate: this.state.displayDate,
	                firstDayOfWeek: this.props.firstDayOfWeek,
	                key: this.state.displayDate.toDateString(),
	                minDate: this.getMinDate(),
	                maxDate: this.getMaxDate(),
	                onClickDay: this.handleClickDay,
	                ref: function ref(_ref2) {
	                  return _this2.calendarRefs.calendar = _ref2;
	                },
	                selectedDate: this.state.selectedDate,
	                shouldDisableDate: this.props.shouldDisableDate,
	                utils: utils
	              })
	            )
	          ),
	          !this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.yearContainer) },
	            this.yearSelector()
	          ),
	          okLabel && _react2.default.createElement(_CalendarActionButtons2.default, {
	            autoOk: this.props.autoOk,
	            cancelLabel: cancelLabel,
	            okLabel: okLabel,
	            onClickCancel: onClickCancel,
	            onClickOk: onClickOk
	          })
	        )
	      );
	    }
	  }]);
	  return Calendar;
	}(_react.Component);
	
	Calendar.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  disableYearSelection: false,
	  initialDate: new Date(),
	  locale: 'en-US',
	  utils: _dateUtils.defaultUtils
	};
	Calendar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Calendar.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  autoOk: _propTypes2.default.bool,
	  cancelLabel: _propTypes2.default.node,
	  disableYearSelection: _propTypes2.default.bool,
	  firstDayOfWeek: _propTypes2.default.number,
	  hideCalendarDate: _propTypes2.default.bool,
	  initialDate: _propTypes2.default.object,
	  locale: _propTypes2.default.string.isRequired,
	  maxDate: _propTypes2.default.object,
	  minDate: _propTypes2.default.object,
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  okLabel: _propTypes2.default.node,
	  onClickCancel: _propTypes2.default.func,
	  onClickDay: _propTypes2.default.func,
	  onClickOk: _propTypes2.default.func,
	  open: _propTypes2.default.bool,
	  openToYearSelection: _propTypes2.default.bool,
	  shouldDisableDate: _propTypes2.default.func,
	  utils: _propTypes2.default.object
	} : {};
	exports.default = Calendar;

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FlatButton = __webpack_require__(82);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarActionButton = function (_Component) {
	  (0, _inherits3.default)(CalendarActionButton, _Component);
	
	  function CalendarActionButton() {
	    (0, _classCallCheck3.default)(this, CalendarActionButton);
	    return (0, _possibleConstructorReturn3.default)(this, (CalendarActionButton.__proto__ || (0, _getPrototypeOf2.default)(CalendarActionButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CalendarActionButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancelLabel = _props.cancelLabel,
	          okLabel = _props.okLabel;
	
	
	      var styles = {
	        root: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'flex-end',
	          margin: 0,
	          maxHeight: 48,
	          padding: 0
	        },
	        flatButtons: {
	          fontsize: 14,
	          margin: '4px 8px 8px 0px',
	          maxHeight: 36,
	          minWidth: 64,
	          padding: 0
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_FlatButton2.default, {
	          label: cancelLabel,
	          onClick: this.props.onClickCancel,
	          primary: true,
	          style: styles.flatButtons
	        }),
	        !this.props.autoOk && _react2.default.createElement(_FlatButton2.default, {
	          disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
	          label: okLabel,
	          onClick: this.props.onClickOk,
	          primary: true,
	          style: styles.flatButtons
	        })
	      );
	    }
	  }]);
	  return CalendarActionButton;
	}(_react.Component);
	
	CalendarActionButton.propTypes =  false ? {
	  autoOk: _propTypes2.default.bool,
	  cancelLabel: _propTypes2.default.node,
	  okLabel: _propTypes2.default.node,
	  onClickCancel: _propTypes2.default.func,
	  onClickOk: _propTypes2.default.func
	} : {};
	exports.default = CalendarActionButton;

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateUtils = __webpack_require__(208);
	
	var _DayButton = __webpack_require__(1541);
	
	var _DayButton2 = _interopRequireDefault(_DayButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'flex-start',
	    fontWeight: 400,
	    height: 228,
	    lineHeight: 2,
	    position: 'relative',
	    textAlign: 'center',
	    MozPaddingStart: 0
	  },
	  week: {
	    display: 'flex',
	    flexDirection: 'row',
	    justifyContent: 'space-around',
	    height: 34,
	    marginBottom: 2
	  }
	};
	
	var CalendarMonth = function (_Component) {
	  (0, _inherits3.default)(CalendarMonth, _Component);
	
	  function CalendarMonth() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarMonth);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarMonth.__proto__ || (0, _getPrototypeOf2.default)(CalendarMonth)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickDay = function (event, date) {
	      if (_this.props.onClickDay) {
	        _this.props.onClickDay(event, date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarMonth, [{
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      return this.selectedDateDisabled;
	    }
	  }, {
	    key: 'shouldDisableDate',
	    value: function shouldDisableDate(day) {
	      if (day === null) return false;
	      var disabled = !(0, _dateUtils.isBetweenDates)(day, this.props.minDate, this.props.maxDate);
	      if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);
	
	      return disabled;
	    }
	  }, {
	    key: 'getWeekElements',
	    value: function getWeekElements() {
	      var _this2 = this;
	
	      var weekArray = this.props.utils.getWeekArray(this.props.displayDate, this.props.firstDayOfWeek);
	
	      return weekArray.map(function (week, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: styles.week },
	          _this2.getDayElements(week, i)
	        );
	      }, this);
	    }
	  }, {
	    key: 'getDayElements',
	    value: function getDayElements(week, i) {
	      var _this3 = this;
	
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          selectedDate = _props.selectedDate;
	
	
	      return week.map(function (day, j) {
	        var isSameDate = (0, _dateUtils.isEqualDate)(selectedDate, day);
	        var disabled = _this3.shouldDisableDate(day);
	        var selected = !disabled && isSameDate;
	
	        if (isSameDate) {
	          _this3.selectedDateDisabled = disabled;
	        }
	
	        return _react2.default.createElement(_DayButton2.default, {
	          DateTimeFormat: DateTimeFormat,
	          locale: locale,
	          date: day,
	          disabled: disabled,
	          key: 'db' + (i + j),
	          onClick: _this3.handleClickDay,
	          selected: selected
	        });
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        this.getWeekElements()
	      );
	    }
	  }]);
	  return CalendarMonth;
	}(_react.Component);
	
	CalendarMonth.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  autoOk: _propTypes2.default.bool,
	  displayDate: _propTypes2.default.object.isRequired,
	  firstDayOfWeek: _propTypes2.default.number,
	  locale: _propTypes2.default.string.isRequired,
	  maxDate: _propTypes2.default.object,
	  minDate: _propTypes2.default.object,
	  onClickDay: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.object.isRequired,
	  shouldDisableDate: _propTypes2.default.func,
	  utils: _propTypes2.default.object.isRequired
	} : {};
	exports.default = CalendarMonth;

/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconButton = __webpack_require__(64);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _chevronLeft = __webpack_require__(1616);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(1617);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _SlideIn = __webpack_require__(383);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    backgroundColor: 'inherit',
	    height: 48
	  },
	  titleDiv: {
	    fontSize: 14,
	    fontWeight: '500',
	    textAlign: 'center',
	    width: '100%'
	  },
	  titleText: {
	    height: 'inherit',
	    paddingTop: 12
	  }
	};
	
	var CalendarToolbar = function (_Component) {
	  (0, _inherits3.default)(CalendarToolbar, _Component);
	
	  function CalendarToolbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarToolbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarToolbar.__proto__ || (0, _getPrototypeOf2.default)(CalendarToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _this.handleClickPrevMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(-1);
	      }
	    }, _this.handleClickNextMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(1);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarToolbar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.displayDate !== this.props.displayDate) {
	        var nextDirection = this.context.muiTheme.isRtl ? 'right' : 'left';
	        var prevDirection = this.context.muiTheme.isRtl ? 'left' : 'right';
	        var direction = nextProps.displayDate > this.props.displayDate ? nextDirection : prevDirection;
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          displayDate = _props.displayDate;
	
	
	      var dateTimeFormatted = new DateTimeFormat(locale, {
	        month: 'long',
	        year: 'numeric'
	      }).format(displayDate);
	
	      var nextButtonIcon = this.context.muiTheme.isRtl ? _react2.default.createElement(_chevronLeft2.default, null) : _react2.default.createElement(_chevronRight2.default, null);
	      var prevButtonIcon = this.context.muiTheme.isRtl ? _react2.default.createElement(_chevronRight2.default, null) : _react2.default.createElement(_chevronLeft2.default, null);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.prevMonth,
	            onClick: this.handleClickPrevMonth
	          },
	          prevButtonIcon
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          {
	            direction: this.state.transitionDirection,
	            style: styles.titleDiv
	          },
	          _react2.default.createElement(
	            'div',
	            { key: dateTimeFormatted, style: styles.titleText },
	            dateTimeFormatted
	          )
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.nextMonth,
	            onClick: this.handleClickNextMonth
	          },
	          nextButtonIcon
	        )
	      );
	    }
	  }]);
	  return CalendarToolbar;
	}(_react.Component);
	
	CalendarToolbar.defaultProps = {
	  nextMonth: true,
	  prevMonth: true
	};
	CalendarToolbar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CalendarToolbar.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  displayDate: _propTypes2.default.object.isRequired,
	  locale: _propTypes2.default.string.isRequired,
	  nextMonth: _propTypes2.default.bool,
	  onMonthChange: _propTypes2.default.func,
	  prevMonth: _propTypes2.default.bool
	} : {};
	exports.default = CalendarToolbar;

/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _YearButton = __webpack_require__(1542);
	
	var _YearButton2 = _interopRequireDefault(_YearButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarYear = function (_Component) {
	  (0, _inherits3.default)(CalendarYear, _Component);
	
	  function CalendarYear() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarYear);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarYear.__proto__ || (0, _getPrototypeOf2.default)(CalendarYear)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickYear = function (event, year) {
	      if (_this.props.onClickYear) {
	        _this.props.onClickYear(event, year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarYear, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'getYears',
	    value: function getYears() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          selectedDate = _props.selectedDate,
	          utils = _props.utils;
	
	
	      var minYear = utils.getYear(minDate);
	      var maxYear = utils.getYear(maxDate);
	      var years = [];
	
	      for (var year = minYear; year <= maxYear; year++) {
	        var selected = utils.getYear(selectedDate) === year;
	        var selectedProps = {};
	        if (selected) {
	          selectedProps.ref = 'selectedYearButton';
	        }
	
	        var yearFormated = new DateTimeFormat(locale, {
	          year: 'numeric'
	        }).format(utils.setYear(selectedDate, year));
	
	        var yearButton = _react2.default.createElement(
	          _YearButton2.default,
	          (0, _extends3.default)({
	            key: 'yb' + year,
	            onClick: this.handleClickYear,
	            selected: selected,
	            year: year,
	            utils: utils
	          }, selectedProps),
	          yearFormated
	        );
	
	        years.push(yearButton);
	      }
	
	      return years;
	    }
	  }, {
	    key: 'scrollToSelectedYear',
	    value: function scrollToSelectedYear() {
	      if (this.refs.selectedYearButton === undefined) {
	        return;
	      }
	
	      var container = _reactDom2.default.findDOMNode(this);
	      var yearButtonNode = _reactDom2.default.findDOMNode(this.refs.selectedYearButton);
	
	      var containerHeight = container.clientHeight;
	      var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;
	
	      var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
	      container.scrollTop = scrollYOffset;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          calendarYearBackgroundColor = _context$muiTheme.datePicker.calendarYearBackgroundColor;
	
	
	      var styles = {
	        root: {
	          backgroundColor: calendarYearBackgroundColor,
	          height: 'inherit',
	          lineHeight: '35px',
	          overflowX: 'hidden',
	          overflowY: 'scroll',
	          position: 'relative'
	        },
	        child: {
	          display: 'flex',
	          flexDirection: 'column',
	          justifyContent: 'center',
	          minHeight: '100%'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.child) },
	          this.getYears()
	        )
	      );
	    }
	  }]);
	  return CalendarYear;
	}(_react.Component);
	
	CalendarYear.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CalendarYear.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locale: _propTypes2.default.string.isRequired,
	  maxDate: _propTypes2.default.object.isRequired,
	  minDate: _propTypes2.default.object.isRequired,
	  onClickYear: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.object.isRequired,
	  utils: _propTypes2.default.object.isRequired,
	  wordings: _propTypes2.default.object
	} : {};
	exports.default = CalendarYear;

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _SlideIn = __webpack_require__(383);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var datePicker = context.muiTheme.datePicker;
	  var selectedYear = state.selectedYear;
	
	  var isLandscape = props.mode === 'landscape';
	
	  var styles = {
	    root: {
	      width: isLandscape ? 165 : '100%',
	      height: isLandscape ? 330 : 'auto',
	      float: isLandscape ? 'left' : 'none',
	      fontWeight: 700,
	      display: 'inline-block',
	      backgroundColor: datePicker.headerColor,
	      borderTopLeftRadius: 2,
	      borderTopRightRadius: isLandscape ? 0 : 2,
	      borderBottomLeftRadius: isLandscape ? 2 : 0,
	      color: datePicker.textColor,
	      padding: 20,
	      boxSizing: 'border-box'
	    },
	    monthDay: {
	      display: 'block',
	      fontSize: 36,
	      lineHeight: '36px',
	      height: props.mode === 'landscape' ? '100%' : 38,
	      opacity: selectedYear ? 0.7 : 1,
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      fontWeight: '500'
	    },
	    monthDayTitle: {
	      cursor: !selectedYear ? 'default' : 'pointer',
	      width: '100%',
	      display: 'block'
	    },
	    year: {
	      margin: 0,
	      fontSize: 16,
	      fontWeight: '500',
	      lineHeight: '16px',
	      height: 16,
	      opacity: selectedYear ? 1 : 0.7,
	      transition: _transitions2.default.easeOut(),
	      marginBottom: 10
	    },
	    yearTitle: {
	      cursor: props.disableYearSelection || selectedYear ? 'default' : 'pointer'
	    }
	  };
	
	  return styles;
	}
	
	var DateDisplay = function (_Component) {
	  (0, _inherits3.default)(DateDisplay, _Component);
	
	  function DateDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DateDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateDisplay.__proto__ || (0, _getPrototypeOf2.default)(DateDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedYear: false,
	      transitionDirection: 'up'
	    }, _this.handleClickMonthDay = function () {
	      if (_this.props.onClickMonthDay && _this.state.selectedYear) {
	        _this.props.onClickMonthDay();
	      }
	
	      _this.setState({ selectedYear: false });
	    }, _this.handleClickYear = function () {
	      if (_this.props.onClickYear && !_this.props.disableYearSelection && !_this.state.selectedYear) {
	        _this.props.onClickYear();
	      }
	
	      if (!_this.props.disableYearSelection) {
	        _this.setState({ selectedYear: true });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DateDisplay, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.monthDaySelected) {
	        this.setState({ selectedYear: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedDate !== this.props.selectedDate) {
	        var direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	
	      if (nextProps.monthDaySelected !== undefined) {
	        this.setState({
	          selectedYear: !nextProps.monthDaySelected
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          disableYearSelection = _props.disableYearSelection,
	          locale = _props.locale,
	          mode = _props.mode,
	          monthDaySelected = _props.monthDaySelected,
	          onClickMonthDay = _props.onClickMonthDay,
	          onClickYear = _props.onClickYear,
	          selectedDate = _props.selectedDate,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'disableYearSelection', 'locale', 'mode', 'monthDaySelected', 'onClickMonthDay', 'onClickYear', 'selectedDate', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var year = new DateTimeFormat(locale, {
	        year: 'numeric'
	      }).format(selectedDate);
	
	      var dateTime = new DateTimeFormat(locale, {
	        month: 'short',
	        weekday: 'short',
	        day: '2-digit'
	      }).format(selectedDate);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root, style) }),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.year, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            { key: year, style: styles.yearTitle, onClick: this.handleClickYear },
	            year
	          )
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.monthDay, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            {
	              key: dateTime,
	              onClick: this.handleClickMonthDay,
	              style: styles.monthDayTitle
	            },
	            dateTime
	          )
	        )
	      );
	    }
	  }]);
	  return DateDisplay;
	}(_react.Component);
	
	DateDisplay.defaultProps = {
	  disableYearSelection: false,
	  monthDaySelected: true
	};
	DateDisplay.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DateDisplay.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  disableYearSelection: _propTypes2.default.bool,
	  locale: _propTypes2.default.string.isRequired,
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  monthDaySelected: _propTypes2.default.bool,
	  onClickMonthDay: _propTypes2.default.func,
	  onClickYear: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.object.isRequired,
	  style: _propTypes2.default.object
	} : {};
	exports.default = DateDisplay;

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateUtils = __webpack_require__(208);
	
	var _DatePickerDialog = __webpack_require__(1540);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePicker = function (_Component) {
	  (0, _inherits3.default)(DatePicker, _Component);
	
	  function DatePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      date: undefined
	    }, _this.handleAccept = function (date) {
	      if (!_this.isControlled()) {
	        _this.setState({
	          date: date
	        });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(null, date);
	      }
	    }, _this.handleFocus = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	
	      if (!_this.props.disabled) {
	        setTimeout(function () {
	          _this.openDialog();
	        }, 0);
	      }
	    }, _this.formatDate = function (date) {
	      if (_this.props.locale) {
	        var DateTimeFormat = _this.props.DateTimeFormat || _dateUtils.dateTimeFormat;
	        return new DateTimeFormat(_this.props.locale, {
	          day: 'numeric',
	          month: 'numeric',
	          year: 'numeric'
	        }).format(date);
	      } else {
	        return (0, _dateUtils.formatIso)(date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        date: this.isControlled() ? this.getControlledDate() : this.props.defaultDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.isControlled()) {
	        var newDate = this.getControlledDate(nextProps);
	        if (!(0, _dateUtils.isEqualDate)(this.state.date, newDate)) {
	          this.setState({
	            date: newDate
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getDate',
	    value: function getDate() {
	      return this.state.date;
	    }
	
	    /**
	     * Open the date-picker dialog programmatically from a parent.
	     */
	
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      /**
	       * if the date is not selected then set it to new date
	       * (get the current system date while doing so)
	       * else set it to the currently selected date
	       */
	      if (this.state.date !== undefined) {
	        this.setState({
	          dialogDate: this.getDate()
	        }, this.refs.dialogWindow.show);
	      } else {
	        this.setState({
	          dialogDate: new Date()
	        }, this.refs.dialogWindow.show);
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'getControlledDate',
	    value: function getControlledDate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      if (props.value instanceof Date) {
	        return props.value;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          className = _props.className,
	          container = _props.container,
	          defaultDate = _props.defaultDate,
	          dialogContainerStyle = _props.dialogContainerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          formatDateProp = _props.formatDate,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onDismiss = _props.onDismiss,
	          onFocus = _props.onFocus,
	          onShow = _props.onShow,
	          onClick = _props.onClick,
	          openToYearSelection = _props.openToYearSelection,
	          shouldDisableDate = _props.shouldDisableDate,
	          hideCalendarDate = _props.hideCalendarDate,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          utils = _props.utils,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'className', 'container', 'defaultDate', 'dialogContainerStyle', 'disableYearSelection', 'firstDayOfWeek', 'formatDate', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onDismiss', 'onFocus', 'onShow', 'onClick', 'openToYearSelection', 'shouldDisableDate', 'hideCalendarDate', 'style', 'textFieldStyle', 'utils']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var formatDate = formatDateProp || this.formatDate;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          onFocus: this.handleFocus,
	          onClick: this.handleClick,
	          ref: 'input',
	          style: textFieldStyle,
	          value: this.state.date ? formatDate(this.state.date) : ''
	        })),
	        _react2.default.createElement(_DatePickerDialog2.default, {
	          DateTimeFormat: DateTimeFormat,
	          autoOk: autoOk,
	          cancelLabel: cancelLabel,
	          container: container,
	          containerStyle: dialogContainerStyle,
	          disableYearSelection: disableYearSelection,
	          firstDayOfWeek: firstDayOfWeek,
	          initialDate: this.state.dialogDate,
	          locale: locale,
	          maxDate: maxDate,
	          minDate: minDate,
	          mode: mode,
	          okLabel: okLabel,
	          onAccept: this.handleAccept,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          ref: 'dialogWindow',
	          shouldDisableDate: shouldDisableDate,
	          hideCalendarDate: hideCalendarDate,
	          openToYearSelection: openToYearSelection,
	          utils: utils
	        })
	      );
	    }
	  }]);
	  return DatePicker;
	}(_react.Component);
	
	DatePicker.defaultProps = {
	  autoOk: false,
	  container: 'dialog',
	  disabled: false,
	  disableYearSelection: false,
	  firstDayOfWeek: 1,
	  hideCalendarDate: false,
	  style: {},
	  openToYearSelection: false
	};
	DatePicker.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DatePicker.propTypes =  false ? {
	  /**
	   * Constructor for date formatting for the specified `locale`.
	   * The constructor must follow this specification: ECMAScript Internationalization API 1.0 (ECMA-402).
	   * `Intl.DateTimeFormat` is supported by most modern browsers, see http://caniuse.com/#search=intl,
	   * otherwise https://github.com/andyearnshaw/Intl.js is a good polyfill.
	   *
	   * By default, a built-in `DateTimeFormat` is used which supports the 'en-US' `locale`.
	   */
	  DateTimeFormat: _propTypes2.default.func,
	  /**
	   * If true, automatically accept and close the picker on select a date.
	   */
	  autoOk: _propTypes2.default.bool,
	  /**
	   * Override the default text of the 'Cancel' button.
	   */
	  cancelLabel: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Used to control how the Date Picker will be displayed when the input field is focused.
	   * `dialog` (default) displays the DatePicker as a dialog with a modal.
	   * `inline` displays the DatePicker below the input field (similar to auto complete).
	   */
	  container: _propTypes2.default.oneOf(['dialog', 'inline']),
	  /**
	   * This is the initial date value of the component.
	   * If either `value` or `valueLink` is provided they will override this
	   * prop with `value` taking precedence.
	   */
	  defaultDate: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of DatePickerDialog's Container element.
	   */
	  dialogContainerStyle: _propTypes2.default.object,
	  /**
	   * Disables the year selection in the date picker.
	   */
	  disableYearSelection: _propTypes2.default.bool,
	  /**
	   * Disables the DatePicker.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Used to change the first day of week. It varies from
	   * Saturday to Monday between different locales.
	   * The allowed range is 0 (Sunday) to 6 (Saturday).
	   * The default is `1`, Monday, as per ISO 8601.
	   */
	  firstDayOfWeek: _propTypes2.default.number,
	  /**
	   * This function is called to format the date displayed in the input field, and should return a string.
	   * By default if no `locale` and `DateTimeFormat` is provided date objects are formatted to ISO 8601 YYYY-MM-DD.
	   *
	   * @param {object} date Date object to be formatted.
	   * @returns {any} The formatted date.
	   */
	  formatDate: _propTypes2.default.func,
	  /**
	   * Hide date display
	   */
	  hideCalendarDate: _propTypes2.default.bool,
	  /**
	   * Locale used for formatting the `DatePicker` date strings. Other than for 'en-US', you
	   * must provide a `DateTimeFormat` that supports the chosen `locale`.
	   */
	  locale: _propTypes2.default.string,
	  /**
	   * The ending of a range of valid dates. The range includes the endDate.
	   * The default value is current date + 100 years.
	   */
	  maxDate: _propTypes2.default.object,
	  /**
	   * The beginning of a range of valid dates. The range includes the startDate.
	   * The default value is current date - 100 years.
	   */
	  minDate: _propTypes2.default.object,
	  /**
	   * Tells the component to display the picker in portrait or landscape mode.
	   */
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  /**
	   * Override the default text of the 'OK' button.
	   */
	  okLabel: _propTypes2.default.node,
	  /**
	   * Callback function that is fired when the date value changes.
	   *
	   * @param {null} null Since there is no particular event associated with the change,
	   * the first argument will always be null.
	   * @param {object} date The new date.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when a click event occurs on the Date Picker's `TextField`.
	   *
	   * @param {object} event Click event targeting the `TextField`.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is dismissed.
	   */
	  onDismiss: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the Date Picker's `TextField` gains focus.
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is shown.
	   */
	  onShow: _propTypes2.default.func,
	  /**
	   * If true sets the datepicker to open to year selection first.
	   */
	  openToYearSelection: _propTypes2.default.bool,
	  /**
	   * Callback function used to determine if a day's entry should be disabled on the calendar.
	   *
	   * @param {object} day Date object of a day.
	   * @returns {boolean} Indicates whether the day should be disabled.
	   */
	  shouldDisableDate: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of DatePicker's TextField element.
	   */
	  textFieldStyle: _propTypes2.default.object,
	  /**
	   * This object should contain methods needed to build the calendar system.
	   *
	   * Useful for building a custom calendar system. Refer to the
	   * [source code](https://github.com/mui-org/material-ui/blob/v0.x/src/DatePicker/dateUtils.js)
	   * and an [example implementation](https://github.com/alitaheri/material-ui-persian-date-picker-utils)
	   * for more information.
	   */
	  utils: _propTypes2.default.object,
	  /**
	   * Sets the date for the Date Picker programmatically.
	   */
	  value: _propTypes2.default.object
	} : {};
	exports.default = DatePicker;

/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(100);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(73);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Calendar = __webpack_require__(1533);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Dialog = __webpack_require__(171);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Popover = __webpack_require__(174);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(378);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _dateUtils = __webpack_require__(208);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerDialog = function (_Component) {
	  (0, _inherits3.default)(DatePickerDialog, _Component);
	
	  function DatePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(DatePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.show = function () {
	      if (_this.props.onShow && !_this.state.open) {
	        _this.props.onShow();
	      }
	
	      _this.setState({
	        open: true
	      });
	    }, _this.dismiss = function () {
	      if (_this.props.onDismiss && _this.state.open) {
	        _this.props.onDismiss();
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleClickDay = function () {
	      if (_this.props.autoOk) {
	        setTimeout(_this.handleClickOk, 300);
	      }
	    }, _this.handleClickCancel = function () {
	      _this.dismiss();
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleClickOk = function () {
	      if (_this.props.onAccept && !_this.refs.calendar.isSelectedDateDisabled()) {
	        _this.props.onAccept(_this.refs.calendar.getSelectedDate());
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleWindowKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleClickOk();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePickerDialog, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          container = _props.container,
	          containerStyle = _props.containerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          initialDate = _props.initialDate,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onAccept = _props.onAccept,
	          onDismiss = _props.onDismiss,
	          onShow = _props.onShow,
	          openToYearSelection = _props.openToYearSelection,
	          shouldDisableDate = _props.shouldDisableDate,
	          hideCalendarDate = _props.hideCalendarDate,
	          style = _props.style,
	          animation = _props.animation,
	          utils = _props.utils,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'container', 'containerStyle', 'disableYearSelection', 'initialDate', 'firstDayOfWeek', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onAccept', 'onDismiss', 'onShow', 'openToYearSelection', 'shouldDisableDate', 'hideCalendarDate', 'style', 'animation', 'utils']);
	      var open = this.state.open;
	
	
	      var styles = {
	        dialogContent: {
	          width: !hideCalendarDate && mode === 'landscape' ? 479 : 310
	        },
	        dialogBodyContent: {
	          padding: 0,
	          minHeight: hideCalendarDate || mode === 'landscape' ? 330 : 434,
	          minWidth: hideCalendarDate || mode !== 'landscape' ? 310 : 479
	        }
	      };
	
	      var Container = container === 'inline' ? _Popover2.default : _Dialog2.default;
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'root' }),
	        _react2.default.createElement(
	          Container,
	          {
	            anchorEl: this.refs.root // For Popover
	            , animation: animation || _PopoverAnimationVertical2.default // For Popover
	            , bodyStyle: styles.dialogBodyContent,
	            contentStyle: styles.dialogContent,
	            ref: 'dialog',
	            repositionOnUpdate: true,
	            open: open,
	            onRequestClose: this.handleRequestClose,
	            style: (0, _simpleAssign2.default)(styles.dialogBodyContent, containerStyle)
	          },
	          _react2.default.createElement(_reactEventListener2.default, {
	            target: 'window',
	            onKeyUp: this.handleWindowKeyUp
	          }),
	          _react2.default.createElement(_Calendar2.default, {
	            autoOk: autoOk,
	            DateTimeFormat: DateTimeFormat,
	            cancelLabel: cancelLabel,
	            disableYearSelection: disableYearSelection,
	            firstDayOfWeek: firstDayOfWeek,
	            initialDate: initialDate,
	            locale: locale,
	            onClickDay: this.handleClickDay,
	            maxDate: maxDate,
	            minDate: minDate,
	            mode: mode,
	            open: open,
	            ref: 'calendar',
	            onClickCancel: this.handleClickCancel,
	            onClickOk: this.handleClickOk,
	            okLabel: okLabel,
	            openToYearSelection: openToYearSelection,
	            shouldDisableDate: shouldDisableDate,
	            hideCalendarDate: hideCalendarDate,
	            utils: utils
	          })
	        )
	      );
	    }
	  }]);
	  return DatePickerDialog;
	}(_react.Component);
	
	DatePickerDialog.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  cancelLabel: 'Cancel',
	  container: 'dialog',
	  locale: 'en-US',
	  okLabel: 'OK',
	  openToYearSelection: false
	};
	DatePickerDialog.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DatePickerDialog.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func,
	  animation: _propTypes2.default.func,
	  autoOk: _propTypes2.default.bool,
	  cancelLabel: _propTypes2.default.node,
	  container: _propTypes2.default.oneOf(['dialog', 'inline']),
	  containerStyle: _propTypes2.default.object,
	  disableYearSelection: _propTypes2.default.bool,
	  firstDayOfWeek: _propTypes2.default.number,
	  hideCalendarDate: _propTypes2.default.bool,
	  initialDate: _propTypes2.default.object,
	  locale: _propTypes2.default.string,
	  maxDate: _propTypes2.default.object,
	  minDate: _propTypes2.default.object,
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  okLabel: _propTypes2.default.node,
	  onAccept: _propTypes2.default.func,
	  onDismiss: _propTypes2.default.func,
	  onShow: _propTypes2.default.func,
	  open: _propTypes2.default.bool,
	  openToYearSelection: _propTypes2.default.bool,
	  shouldDisableDate: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  utils: _propTypes2.default.object
	} : {};
	exports.default = DatePickerDialog;

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _dateUtils = __webpack_require__(208);
	
	var _EnhancedButton = __webpack_require__(84);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var date = props.date,
	      disabled = props.disabled,
	      selected = props.selected;
	  var hover = state.hover;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	
	
	  var labelColor = baseTheme.palette.textColor;
	  var buttonStateOpacity = 0;
	  var buttonStateTransform = 'scale(0)';
	
	  if (hover || selected) {
	    labelColor = datePicker.selectTextColor;
	    buttonStateOpacity = selected ? 1 : 0.6;
	    buttonStateTransform = 'scale(1)';
	  } else if ((0, _dateUtils.isEqualDate)(date, new Date())) {
	    labelColor = datePicker.color;
	  }
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      fontWeight: '400',
	      opacity: disabled && '0.4',
	      padding: '4px 0px',
	      position: 'relative',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      width: 42
	    },
	    label: {
	      color: labelColor,
	      fontWeight: '400',
	      position: 'relative'
	    },
	    buttonState: {
	      backgroundColor: datePicker.selectColor,
	      borderRadius: '50%',
	      height: 34,
	      left: 4,
	      opacity: buttonStateOpacity,
	      position: 'absolute',
	      top: 0,
	      transform: buttonStateTransform,
	      transition: _transitions2.default.easeOut(),
	      width: 34
	    }
	  };
	}
	
	var DayButton = function (_Component) {
	  (0, _inherits3.default)(DayButton, _Component);
	
	  function DayButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DayButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DayButton.__proto__ || (0, _getPrototypeOf2.default)(DayButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: true });
	      }
	    }, _this.handleMouseLeave = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: false });
	      }
	    }, _this.handleClick = function (event) {
	      if (!_this.props.disabled && _this.props.onClick) {
	        _this.props.onClick(event, _this.props.date);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (!_this.props.disabled && _this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event, keyboardFocused, _this.props.date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DayButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          date = _props.date,
	          disabled = _props.disabled,
	          locale = _props.locale,
	          onClick = _props.onClick,
	          selected = _props.selected,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'date', 'disabled', 'locale', 'onClick', 'selected']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return date ? _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onClick: this.handleClick,
	          style: styles.root
	        }),
	        _react2.default.createElement('div', { style: prepareStyles(styles.buttonState) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          new DateTimeFormat(locale, {
	            day: 'numeric'
	          }).format(date)
	        )
	      ) : _react2.default.createElement('span', { style: prepareStyles(styles.root) });
	    }
	  }]);
	  return DayButton;
	}(_react.Component);
	
	DayButton.defaultProps = {
	  selected: false,
	  disabled: false
	};
	DayButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DayButton.propTypes =  false ? {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  date: _propTypes2.default.object,
	  disabled: _propTypes2.default.bool,
	  locale: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func,
	  onKeyboardFocus: _propTypes2.default.func,
	  selected: _propTypes2.default.bool
	} : {};
	exports.default = DayButton;

/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(84);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var selected = props.selected,
	      year = props.year,
	      utils = props.utils;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	  var hover = state.hover;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      color: year === utils.getYear(new Date()) && datePicker.color,
	      display: 'block',
	      fontSize: 14,
	      margin: '0 auto',
	      position: 'relative',
	      textAlign: 'center',
	      lineHeight: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' // Remove mobile color flashing (deprecated)
	    },
	    label: {
	      alignSelf: 'center',
	      color: hover || selected ? datePicker.color : baseTheme.palette.textColor,
	      fontSize: selected ? 26 : 17,
	      fontWeight: hover ? 450 : selected ? 500 : 400,
	      position: 'relative',
	      top: -1
	    }
	  };
	}
	
	var YearButton = function (_Component) {
	  (0, _inherits3.default)(YearButton, _Component);
	
	  function YearButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, YearButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = YearButton.__proto__ || (0, _getPrototypeOf2.default)(YearButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      _this.setState({ hover: true });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({ hover: false });
	    }, _this.handleClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(YearButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onClick = _props.onClick,
	          selected = _props.selected,
	          year = _props.year,
	          utils = _props.utils,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onClick', 'selected', 'year', 'utils']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onClick: this.handleClick,
	          style: styles.root
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          children
	        )
	      );
	    }
	  }]);
	  return YearButton;
	}(_react.Component);
	
	YearButton.defaultProps = {
	  selected: false
	};
	YearButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	YearButton.propTypes =  false ? {
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  selected: _propTypes2.default.bool,
	  utils: _propTypes2.default.object.isRequired,
	  year: _propTypes2.default.number.isRequired
	} : {};
	exports.default = YearButton;

/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DatePicker = __webpack_require__(1539);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DatePicker2.default;

/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(100);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(73);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(615);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _RenderToLayer = __webpack_require__(616);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _TransitionGroup = __webpack_require__(214);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransitionItem = function (_Component) {
	  (0, _inherits3.default)(TransitionItem, _Component);
	
	  function TransitionItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TransitionItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransitionItem.__proto__ || (0, _getPrototypeOf2.default)(TransitionItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      style: {}
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TransitionItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimeout);
	      clearTimeout(this.leaveTimeout);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.componentWillAppear(callback);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      var spacing = this.context.muiTheme.baseTheme.spacing;
	
	      this.setState({
	        style: {
	          opacity: 1,
	          transform: 'translate(0, ' + spacing.desktopKeylineIncrement + 'px)'
	        }
	      });
	
	      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.setState({
	        style: {
	          opacity: 0,
	          transform: 'translate(0, 0)'
	        }
	      });
	
	      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
	        children
	      );
	    }
	  }]);
	  return TransitionItem;
	}(_react.Component);
	
	TransitionItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TransitionItem.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : {};
	
	
	function getStyles(props, context) {
	  var autoScrollBodyContent = props.autoScrollBodyContent,
	      open = props.open;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      spacing = _context$muiTheme$bas.spacing,
	      palette = _context$muiTheme$bas.palette,
	      dialog = _context$muiTheme.dialog,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var gutter = spacing.desktopGutter;
	  var borderScroll = '1px solid ' + palette.borderColor;
	
	  return {
	    root: {
	      position: 'fixed',
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      zIndex: zIndex.dialog,
	      top: 0,
	      left: open ? 0 : -10000,
	      width: '100%',
	      height: '100%',
	      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
	    },
	    content: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      transition: _transitions2.default.easeOut(),
	      position: 'relative',
	      width: '75%',
	      maxWidth: spacing.desktopKeylineIncrement * 12,
	      margin: '0 auto',
	      zIndex: zIndex.dialog
	    },
	    actionsContainer: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      padding: 8,
	      width: '100%',
	      textAlign: 'right',
	      marginTop: autoScrollBodyContent ? -1 : 0
	    },
	    overlay: {
	      zIndex: zIndex.dialogOverlay
	    },
	    title: {
	      margin: 0,
	      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
	      color: palette.textColor,
	      fontSize: dialog.titleFontSize,
	      lineHeight: '32px',
	      fontWeight: 400,
	      marginBottom: autoScrollBodyContent ? -1 : 0
	    },
	    body: {
	      fontSize: dialog.bodyFontSize,
	      color: dialog.bodyColor,
	      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
	      boxSizing: 'border-box',
	      overflowY: autoScrollBodyContent ? 'auto' : 'hidden',
	      borderTop: autoScrollBodyContent ? borderScroll : 'none',
	      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
	    }
	  };
	}
	
	var DialogInline = function (_Component2) {
	  (0, _inherits3.default)(DialogInline, _Component2);
	
	  function DialogInline() {
	    var _ref2;
	
	    var _temp2, _this2, _ret2;
	
	    (0, _classCallCheck3.default)(this, DialogInline);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DialogInline.__proto__ || (0, _getPrototypeOf2.default)(DialogInline)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleClickOverlay = function () {
	      _this2.requestClose(false);
	    }, _this2.handleKeyUp = function (event) {
	      if ((0, _keycode2.default)(event) === 'esc') {
	        _this2.requestClose(false);
	      }
	    }, _this2.handleResize = function () {
	      _this2.positionDialog();
	    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
	  }
	
	  (0, _createClass3.default)(DialogInline, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'positionDialog',
	    value: function positionDialog() {
	      var _props2 = this.props,
	          actions = _props2.actions,
	          autoDetectWindowHeight = _props2.autoDetectWindowHeight,
	          autoScrollBodyContent = _props2.autoScrollBodyContent,
	          bodyStyle = _props2.bodyStyle,
	          open = _props2.open,
	          repositionOnUpdate = _props2.repositionOnUpdate,
	          title = _props2.title;
	
	
	      if (!open) {
	        return;
	      }
	
	      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	      var container = _reactDom2.default.findDOMNode(this);
	      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
	      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
	      var minPaddingTop = 16;
	
	      // Reset the height in case the window was resized.
	      dialogWindow.style.height = '';
	      dialogContent.style.height = '';
	
	      var dialogWindowHeight = dialogWindow.offsetHeight;
	      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
	      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;
	
	      // Vertically center the dialog window, but make sure it doesn't
	      // transition to that position.
	      if (repositionOnUpdate || !container.style.paddingTop) {
	        container.style.paddingTop = paddingTop + 'px';
	      }
	
	      // Force a height if the dialog is taller than clientHeight
	      if (autoDetectWindowHeight || autoScrollBodyContent) {
	        var styles = getStyles(this.props, this.context);
	        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	        var maxDialogContentHeight = clientHeight - 2 * 64;
	
	        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
	
	        if (_react2.default.Children.count(actions)) {
	          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
	        }
	
	        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
	        if (maxDialogContentHeight > dialogWindowHeight) {
	          dialogContent.style.borderBottom = 'none';
	          dialogContent.style.borderTop = 'none';
	        }
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(buttonClicked) {
	      if (!buttonClicked && this.props.modal) {
	        return;
	      }
	
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(!!buttonClicked);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          actions = _props3.actions,
	          actionsContainerClassName = _props3.actionsContainerClassName,
	          actionsContainerStyle = _props3.actionsContainerStyle,
	          bodyClassName = _props3.bodyClassName,
	          bodyStyle = _props3.bodyStyle,
	          children = _props3.children,
	          className = _props3.className,
	          contentClassName = _props3.contentClassName,
	          contentStyle = _props3.contentStyle,
	          overlayClassName = _props3.overlayClassName,
	          overlayStyle = _props3.overlayStyle,
	          open = _props3.open,
	          paperClassName = _props3.paperClassName,
	          paperProps = _props3.paperProps,
	          style = _props3.style,
	          titleClassName = _props3.titleClassName,
	          titleStyle = _props3.titleStyle,
	          title = _props3.title;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      styles.root = (0, _simpleAssign2.default)(styles.root, style);
	      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
	      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
	      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);
	
	      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
	        'div',
	        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
	        _react2.default.Children.toArray(actions)
	      );
	
	      var titleElement = title;
	      if (_react2.default.isValidElement(title)) {
	        titleElement = _react2.default.cloneElement(title, {
	          className: title.props.className || titleClassName,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
	        });
	      } else if (typeof title === 'string') {
	        titleElement = _react2.default.createElement(
	          'h3',
	          { className: titleClassName, style: prepareStyles(styles.title) },
	          title
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles(styles.root) },
	        open && _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyUp: this.handleKeyUp,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(
	          _TransitionGroup2.default,
	          {
	            component: 'div',
	            ref: 'dialogWindow',
	            transitionAppear: true,
	            transitionAppearTimeout: 450,
	            transitionEnter: true,
	            transitionEnterTimeout: 450
	          },
	          open && _react2.default.createElement(
	            TransitionItem,
	            {
	              className: contentClassName,
	              style: styles.content
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              (0, _extends3.default)({ className: paperClassName, zDepth: 4 }, paperProps),
	              titleElement,
	              _react2.default.createElement(
	                'div',
	                {
	                  ref: 'dialogContent',
	                  className: bodyClassName,
	                  style: prepareStyles(styles.body)
	                },
	                children
	              ),
	              actionsContainer
	            )
	          )
	        ),
	        _react2.default.createElement(_Overlay2.default, {
	          show: open,
	          className: overlayClassName,
	          style: styles.overlay,
	          onClick: this.handleClickOverlay
	        })
	      );
	    }
	  }]);
	  return DialogInline;
	}(_react.Component);
	
	DialogInline.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DialogInline.propTypes =  false ? {
	  actions: _propTypes2.default.node,
	  actionsContainerClassName: _propTypes2.default.string,
	  actionsContainerStyle: _propTypes2.default.object,
	  autoDetectWindowHeight: _propTypes2.default.bool,
	  autoScrollBodyContent: _propTypes2.default.bool,
	  bodyClassName: _propTypes2.default.string,
	  bodyStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  contentClassName: _propTypes2.default.string,
	  contentStyle: _propTypes2.default.object,
	  modal: _propTypes2.default.bool,
	  onRequestClose: _propTypes2.default.func,
	  open: _propTypes2.default.bool.isRequired,
	  overlayClassName: _propTypes2.default.string,
	  overlayStyle: _propTypes2.default.object,
	  paperClassName: _propTypes2.default.string,
	  paperProps: _propTypes2.default.object,
	  repositionOnUpdate: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  title: _propTypes2.default.node,
	  titleClassName: _propTypes2.default.string,
	  titleStyle: _propTypes2.default.object
	} : {};
	
	var Dialog = function (_Component3) {
	  (0, _inherits3.default)(Dialog, _Component3);
	
	  function Dialog() {
	    var _ref3;
	
	    var _temp3, _this3, _ret3;
	
	    (0, _classCallCheck3.default)(this, Dialog);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Dialog.__proto__ || (0, _getPrototypeOf2.default)(Dialog)).call.apply(_ref3, [this].concat(args))), _this3), _this3.renderLayer = function () {
	      return _react2.default.createElement(DialogInline, _this3.props);
	    }, _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
	  }
	
	  (0, _createClass3.default)(Dialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
	    }
	  }]);
	  return Dialog;
	}(_react.Component);
	
	Dialog.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Dialog.defaultProps = {
	  autoDetectWindowHeight: true,
	  autoScrollBodyContent: false,
	  modal: false,
	  repositionOnUpdate: true
	};
	Dialog.propTypes =  false ? {
	  /**
	   * Action buttons to display below the Dialog content (`children`).
	   * This property accepts either a React element, or an array of React elements.
	   */
	  actions: _propTypes2.default.node,
	  /**
	   * The `className` to add to the actions container's root element.
	   */
	  actionsContainerClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the actions container's root element.
	   */
	  actionsContainerStyle: _propTypes2.default.object,
	  /**
	   * If set to true, the height of the `Dialog` will be auto detected. A max height
	   * will be enforced so that the content does not extend beyond the viewport.
	   */
	  autoDetectWindowHeight: _propTypes2.default.bool,
	  /**
	   * If set to true, the body content of the `Dialog` will be scrollable.
	   */
	  autoScrollBodyContent: _propTypes2.default.bool,
	  /**
	   * The `className` to add to the content's root element under the title.
	   */
	  bodyClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the content's root element under the title.
	   */
	  bodyStyle: _propTypes2.default.object,
	  /**
	   * The contents of the `Dialog`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The `className` to add to the content container.
	   */
	  contentClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the content container.
	   */
	  contentStyle: _propTypes2.default.object,
	  /**
	   * Force the user to use one of the actions in the `Dialog`.
	   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
	   */
	  modal: _propTypes2.default.bool,
	  /**
	   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
	   *
	   * @param {bool} buttonClicked Determines whether a button click triggered this request.
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * Controls whether the Dialog is opened or not.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * The CSS class name of the `Paper` element.
	   */
	  paperClassName: _propTypes2.default.string,
	  /**
	   * Properties applied to the `Paper` element.
	   */
	  paperProps: _propTypes2.default.object,
	  /**
	   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
	   */
	  repositionOnUpdate: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * The `className` to add to the title's root container element.
	   */
	  titleClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the title's root container element.
	   */
	  titleStyle: _propTypes2.default.object
	} : {};
	exports.default = Dialog;

/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(100);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(73);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _autoPrefix = __webpack_require__(137);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(615);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openNavEventHandler = null;
	
	var Drawer = function (_Component) {
	  (0, _inherits3.default)(Drawer, _Component);
	
	  function Drawer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Drawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickOverlay = function (event) {
	      event.preventDefault();
	      _this.close('clickaway');
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.open && !_this.props.docked && (0, _keycode2.default)(event) === 'esc') {
	        _this.close('escape');
	      }
	    }, _this.onBodyTouchStart = function (event) {
	      var swipeAreaWidth = _this.props.swipeAreaWidth;
	
	      var touchStartX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
	      var touchStartY = event.touches[0].pageY;
	
	      // Open only if swiping from far left (or right) while closed
	      if (swipeAreaWidth !== null && !_this.state.open) {
	        if (_this.props.openSecondary) {
	          // If openSecondary is true calculate from the far right
	          if (touchStartX < document.body.offsetWidth - swipeAreaWidth) return;
	        } else {
	          // If openSecondary is false calculate from the far left
	          if (touchStartX > swipeAreaWidth) return;
	        }
	      }
	
	      if (!_this.state.open && (openNavEventHandler !== _this.onBodyTouchStart || _this.props.disableSwipeToOpen)) {
	        return;
	      }
	
	      _this.maybeSwiping = true;
	      _this.touchStartX = touchStartX;
	      _this.touchStartY = touchStartY;
	
	      document.body.addEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.addEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.addEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _this.onBodyTouchMove = function (event) {
	      var currentX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.touches[0].pageX : event.touches[0].pageX;
	      var currentY = event.touches[0].pageY;
	
	      if (_this.state.swiping) {
	        event.preventDefault();
	        _this.setPosition(_this.getTranslateX(currentX));
	      } else if (_this.maybeSwiping) {
	        var dXAbs = Math.abs(currentX - _this.touchStartX);
	        var dYAbs = Math.abs(currentY - _this.touchStartY);
	        // If the user has moved his thumb ten pixels in either direction,
	        // we can safely make an assumption about whether he was intending
	        // to swipe or scroll.
	        var threshold = 10;
	
	        if (dXAbs > threshold && dYAbs <= threshold) {
	          _this.swipeStartX = currentX;
	          _this.setState({
	            swiping: _this.state.open ? 'closing' : 'opening'
	          });
	          _this.setPosition(_this.getTranslateX(currentX));
	        } else if (dXAbs <= threshold && dYAbs > threshold) {
	          _this.onBodyTouchEnd();
	        }
	      }
	    }, _this.onBodyTouchEnd = function (event) {
	      if (_this.state.swiping) {
	        var currentX = _this.context.muiTheme.isRtl ? document.body.offsetWidth - event.changedTouches[0].pageX : event.changedTouches[0].pageX;
	        var translateRatio = _this.getTranslateX(currentX) / _this.getMaxTranslateX();
	
	        _this.maybeSwiping = false;
	        var swiping = _this.state.swiping;
	        _this.setState({
	          swiping: null
	        });
	
	        // We have to open or close after setting swiping to null,
	        // because only then CSS transition is enabled.
	        if (translateRatio > 0.5) {
	          if (swiping === 'opening') {
	            _this.setPosition(_this.getMaxTranslateX());
	          } else {
	            _this.close('swipe');
	          }
	        } else {
	          if (swiping === 'opening') {
	            _this.open('swipe');
	          } else {
	            _this.setPosition(0);
	          }
	        }
	      } else {
	        _this.maybeSwiping = false;
	      }
	
	      _this.removeBodyTouchListeners();
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Drawer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.maybeSwiping = false;
	      this.touchStartX = null;
	      this.touchStartY = null;
	      this.swipeStartX = null;
	
	      this.setState({
	        open: this.props.open !== null ? this.props.open : this.props.docked,
	        swiping: null
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // If controlled then the open prop takes precedence.
	      if (nextProps.open !== null) {
	        this.setState({
	          open: nextProps.open
	        });
	        // Otherwise, if docked is changed, change the open state for when uncontrolled.
	      } else if (this.props.docked !== nextProps.docked) {
	        this.setState({
	          open: nextProps.docked
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.disableSwipeHandling();
	      this.removeBodyTouchListeners();
	    }
	  }, {
	    key: 'getStyles',
	    value: function getStyles() {
	      var muiTheme = this.context.muiTheme;
	      var theme = muiTheme.drawer;
	
	      var x = this.getTranslateMultiplier() * (this.state.open ? 0 : this.getMaxTranslateX());
	
	      var styles = {
	        root: {
	          height: '100%',
	          width: this.getTranslatedWidth() || theme.width,
	          position: 'fixed',
	          zIndex: muiTheme.zIndex.drawer,
	          left: 0,
	          top: 0,
	          transform: 'translate(' + x + 'px, 0)',
	          transition: !this.state.swiping && _transitions2.default.easeOut(null, 'transform', null),
	          backgroundColor: theme.color,
	          overflow: 'auto',
	          WebkitOverflowScrolling: 'touch' // iOS momentum scrolling
	        },
	        overlay: {
	          zIndex: muiTheme.zIndex.drawerOverlay,
	          pointerEvents: this.state.open ? 'auto' : 'none' // Bypass mouse events when left nav is closing.
	        },
	        rootWhenOpenRight: {
	          left: 'auto',
	          right: 0
	        }
	      };
	
	      return styles;
	    }
	  }, {
	    key: 'shouldShow',
	    value: function shouldShow() {
	      return this.state.open || !!this.state.swiping; // component is swiping
	    }
	  }, {
	    key: 'close',
	    value: function close(reason) {
	      if (this.props.open === null) this.setState({ open: false });
	      if (this.props.onRequestChange) this.props.onRequestChange(false, reason);
	      return this;
	    }
	  }, {
	    key: 'open',
	    value: function open(reason) {
	      if (this.props.open === null) this.setState({ open: true });
	      if (this.props.onRequestChange) this.props.onRequestChange(true, reason);
	      return this;
	    }
	  }, {
	    key: 'getTranslatedWidth',
	    value: function getTranslatedWidth() {
	      if (typeof this.props.width === 'string') {
	        if (!/^\d+(\.\d+)?%$/.test(this.props.width)) {
	          throw new Error('Not a valid percentage format.');
	        }
	        var width = parseFloat(this.props.width) / 100.0;
	        // We are doing our best on the Server to render a consistent UI, hence the
	        // default value of 10000
	        return typeof window !== 'undefined' ? width * window.innerWidth : 10000;
	      } else {
	        return this.props.width;
	      }
	    }
	  }, {
	    key: 'getMaxTranslateX',
	    value: function getMaxTranslateX() {
	      var width = this.getTranslatedWidth() || this.context.muiTheme.drawer.width;
	      return width + 10;
	    }
	  }, {
	    key: 'getTranslateMultiplier',
	    value: function getTranslateMultiplier() {
	      return this.props.openSecondary ? 1 : -1;
	    }
	  }, {
	    key: 'enableSwipeHandling',
	    value: function enableSwipeHandling() {
	      if (!this.props.docked) {
	        document.body.addEventListener('touchstart', this.onBodyTouchStart);
	        if (!openNavEventHandler) {
	          openNavEventHandler = this.onBodyTouchStart;
	        }
	      } else {
	        this.disableSwipeHandling();
	      }
	    }
	  }, {
	    key: 'disableSwipeHandling',
	    value: function disableSwipeHandling() {
	      document.body.removeEventListener('touchstart', this.onBodyTouchStart);
	      if (openNavEventHandler === this.onBodyTouchStart) {
	        openNavEventHandler = null;
	      }
	    }
	  }, {
	    key: 'removeBodyTouchListeners',
	    value: function removeBodyTouchListeners() {
	      document.body.removeEventListener('touchmove', this.onBodyTouchMove);
	      document.body.removeEventListener('touchend', this.onBodyTouchEnd);
	      document.body.removeEventListener('touchcancel', this.onBodyTouchEnd);
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(translateX) {
	      var rtlTranslateMultiplier = this.context.muiTheme.isRtl ? -1 : 1;
	      var drawer = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
	      var transformCSS = 'translate(' + this.getTranslateMultiplier() * rtlTranslateMultiplier * translateX + 'px, 0)';
	      this.refs.overlay.setOpacity(1 - translateX / this.getMaxTranslateX());
	      _autoPrefix2.default.set(drawer.style, 'transform', transformCSS);
	    }
	  }, {
	    key: 'getTranslateX',
	    value: function getTranslateX(currentX) {
	      return Math.min(Math.max(this.state.swiping === 'closing' ? this.getTranslateMultiplier() * (currentX - this.swipeStartX) : this.getMaxTranslateX() - this.getTranslateMultiplier() * (this.swipeStartX - currentX), 0), this.getMaxTranslateX());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          containerClassName = _props.containerClassName,
	          containerStyle = _props.containerStyle,
	          docked = _props.docked,
	          openSecondary = _props.openSecondary,
	          overlayClassName = _props.overlayClassName,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = this.getStyles();
	
	      var overlay = void 0;
	      if (!docked) {
	        overlay = _react2.default.createElement(_Overlay2.default, {
	          ref: 'overlay',
	          show: this.shouldShow(),
	          className: overlayClassName,
	          style: (0, _simpleAssign2.default)(styles.overlay, overlayStyle),
	          transitionEnabled: !this.state.swiping,
	          onClick: this.handleClickOverlay
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          style: style
	        },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        overlay,
	        _react2.default.createElement(
	          _Paper2.default,
	          {
	            ref: 'clickAwayableElement',
	            zDepth: zDepth,
	            rounded: false,
	            transitionEnabled: !this.state.swiping,
	            className: containerClassName,
	            style: (0, _simpleAssign2.default)(styles.root, openSecondary && styles.rootWhenOpenRight, containerStyle)
	          },
	          children
	        )
	      );
	    }
	  }]);
	  return Drawer;
	}(_react.Component);
	
	Drawer.defaultProps = {
	  disableSwipeToOpen: false,
	  docked: true,
	  open: null,
	  openSecondary: false,
	  swipeAreaWidth: 30,
	  width: null,
	  zDepth: 2
	};
	Drawer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Drawer.propTypes =  false ? {
	  /**
	   * The contents of the `Drawer`
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The CSS class name of the container element.
	   */
	  containerClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _propTypes2.default.object,
	  /**
	   * If true, swiping sideways when the `Drawer` is closed will not open it.
	   */
	  disableSwipeToOpen: _propTypes2.default.bool,
	  /**
	   * If true, the `Drawer` will be docked. In this state, the overlay won't show and
	   * clicking on a menu item will not close the `Drawer`.
	   */
	  docked: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the `open` state of the `Drawer` is requested to be changed.
	   *
	   * @param {boolean} open If true, the `Drawer` was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'swipe' for open requests; 'clickaway' (on overlay clicks),
	   * 'escape' (on escape key press), and 'swipe' for close requests.
	   */
	  onRequestChange: _propTypes2.default.func,
	  /**
	   * If true, the `Drawer` is opened.  Providing a value will turn the `Drawer`
	   * into a controlled component.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * If true, the `Drawer` is positioned to open from the opposite side.
	   */
	  openSecondary: _propTypes2.default.bool,
	  /**
	   * The CSS class name to add to the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The width of the left most (or right most) area in pixels where the `Drawer` can be
	   * swiped open from. Setting this to `null` spans that area to the entire page
	   * (**CAUTION!** Setting this property to `null` might cause issues with sliders and
	   * swipeable `Tabs`: use at your own risk).
	   */
	  swipeAreaWidth: _propTypes2.default.number,
	  /**
	   * The width of the `Drawer` in pixels or percentage in string format ex. `50%` to fill
	   * half of the window or `100%` and so on. Defaults to using the values from theme.
	   */
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * The zDepth of the `Drawer`.
	   */
	  zDepth: _propTypes4.default.zDepth
	
	} : {};
	exports.default = Drawer;

/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _arrowDropDown = __webpack_require__(1613);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _Menu = __webpack_require__(270);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ClearFix = __webpack_require__(1600);
	
	var _ClearFix2 = _interopRequireDefault(_ClearFix);
	
	var _Popover = __webpack_require__(174);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(378);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _keycode = __webpack_require__(73);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _events = __webpack_require__(274);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _IconButton = __webpack_require__(64);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var disabled = props.disabled;
	
	  var spacing = context.muiTheme.baseTheme.spacing;
	  var palette = context.muiTheme.baseTheme.palette;
	  var accentColor = context.muiTheme.dropDownMenu.accentColor;
	  return {
	    control: {
	      cursor: disabled ? 'not-allowed' : 'pointer',
	      height: '100%',
	      position: 'relative',
	      width: '100%'
	    },
	    icon: {
	      fill: accentColor,
	      position: 'absolute',
	      right: spacing.desktopGutterLess,
	      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
	    },
	    iconChildren: {
	      fill: 'inherit'
	    },
	    label: {
	      color: disabled ? palette.disabledColor : palette.textColor,
	      height: spacing.desktopToolbarHeight + 'px',
	      lineHeight: spacing.desktopToolbarHeight + 'px',
	      overflow: 'hidden',
	      opacity: 1,
	      position: 'relative',
	      paddingLeft: spacing.desktopGutter,
	      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
	      textOverflow: 'ellipsis',
	      top: 0,
	      whiteSpace: 'nowrap'
	    },
	    labelWhenOpen: {
	      opacity: 0,
	      top: spacing.desktopToolbarHeight / 8
	    },
	    root: {
	      display: 'inline-block',
	      fontSize: spacing.desktopDropDownMenuFontSize,
	      height: spacing.desktopSubheaderHeight,
	      fontFamily: context.muiTheme.baseTheme.fontFamily,
	      outline: 'none',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	    rootWhenOpen: {
	      opacity: 1
	    },
	    underline: {
	      borderTop: 'solid 1px ' + accentColor,
	      bottom: 1,
	      left: 0,
	      margin: '-1px ' + spacing.desktopGutter + 'px',
	      right: 0,
	      position: 'absolute'
	    }
	  };
	}
	
	var DropDownMenu = function (_Component) {
	  (0, _inherits3.default)(DropDownMenu, _Component);
	
	  function DropDownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleClickControl = function (event) {
	      event.preventDefault();
	      if (!_this.props.disabled) {
	        _this.setState({
	          open: !_this.state.open,
	          anchorEl: _this.rootNode
	        });
	      }
	    }, _this.handleRequestCloseMenu = function () {
	      _this.close(false);
	    }, _this.handleEscKeyDownMenu = function () {
	      _this.close(true);
	    }, _this.handleKeyDown = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'up':
	        case 'down':
	        case 'space':
	        case 'enter':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            anchorEl: _this.rootNode
	          });
	          break;
	      }
	    }, _this.handleItemClick = function (event, child, index) {
	      if (_this.props.multiple) {
	        if (!_this.state.open) {
	          _this.setState({ open: true });
	        }
	      } else {
	        event.persist();
	        _this.setState({
	          open: false
	        }, function () {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, index, child.props.value);
	          }
	
	          _this.close(_events2.default.isKeyboard(event));
	        });
	      }
	    }, _this.handleChange = function (event, value) {
	      if (_this.props.multiple && _this.props.onChange) {
	        _this.props.onChange(event, undefined, value);
	      }
	    }, _this.close = function (isKeyboard) {
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onClose) {
	          _this.props.onClose();
	        }
	
	        if (isKeyboard) {
	          var dropArrow = _this.arrowNode;
	          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
	          dropNode.focus();
	          dropArrow.setKeyboardFocus(true);
	        }
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	
	
	  (0, _createClass3.default)(DropDownMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (this.props.openImmediately) {
	        // TODO: Temporary fix to make openImmediately work with popover.
	        /* eslint-disable react/no-did-mount-set-state */
	        setTimeout(function () {
	          return _this2.setState({
	            open: true,
	            anchorEl: _this2.rootNode
	          });
	        }, 0);
	        /* eslint-enable react/no-did-mount-set-state */
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	    }
	  }, {
	    key: 'getInputNode',
	
	
	    /**
	     * This method is deprecated but still here because the TextField
	     * need it in order to work. TODO: That will be addressed later.
	     */
	    value: function getInputNode() {
	      var _this3 = this;
	
	      var rootNode = this.rootNode;
	
	      rootNode.focus = function () {
	        if (!_this3.props.disabled) {
	          _this3.setState({
	            open: !_this3.state.open,
	            anchorEl: _this3.rootNode
	          });
	        }
	      };
	
	      return rootNode;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = this.rootNode;
	      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	        el.style.width = 'auto';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          animated = _props.animated,
	          animation = _props.animation,
	          autoWidth = _props.autoWidth,
	          multiple = _props.multiple,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyleProp = _props.menuStyle,
	          selectionRenderer = _props.selectionRenderer,
	          onClose = _props.onClose,
	          openImmediately = _props.openImmediately,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          style = _props.style,
	          underlineStyle = _props.underlineStyle,
	          value = _props.value,
	          iconButton = _props.iconButton,
	          anchorOrigin = _props.anchorOrigin,
	          targetOrigin = _props.targetOrigin,
	          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'multiple', 'children', 'className', 'disabled', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'selectionRenderer', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value', 'iconButton', 'anchorOrigin', 'targetOrigin']);
	      var _state = this.state,
	          anchorEl = _state.anchorEl,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var displayValue = '';
	      if (!multiple) {
	        _react2.default.Children.forEach(children, function (child) {
	          if (child && value === child.props.value) {
	            if (selectionRenderer) {
	              displayValue = selectionRenderer(value, child);
	            } else {
	              // This will need to be improved (in case primaryText is a node)
	              displayValue = child.props.label || child.props.primaryText;
	            }
	          }
	        });
	      } else {
	        var values = [];
	        var selectionRendererChildren = [];
	        _react2.default.Children.forEach(children, function (child) {
	          if (child && value && value.indexOf(child.props.value) > -1) {
	            if (selectionRenderer) {
	              values.push(child.props.value);
	              selectionRendererChildren.push(child);
	            } else {
	              values.push(child.props.label || child.props.primaryText);
	            }
	          }
	        });
	
	        displayValue = [];
	        if (selectionRenderer) {
	          displayValue = selectionRenderer(values, selectionRendererChildren);
	        } else {
	          displayValue = values.join(', ');
	        }
	      }
	
	      var menuStyle = void 0;
	      if (anchorEl && !autoWidth) {
	        menuStyle = (0, _simpleAssign2.default)({
	          width: anchorEl.clientWidth
	        }, menuStyleProp);
	      } else {
	        menuStyle = menuStyleProp;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: function ref(node) {
	            _this4.rootNode = node;
	          },
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
	        }),
	        _react2.default.createElement(
	          _ClearFix2.default,
	          { style: styles.control, onClick: this.handleClickControl },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
	            displayValue
	          ),
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              disabled: disabled,
	              onKeyDown: this.handleKeyDown,
	              ref: function ref(node) {
	                _this4.arrowNode = node;
	              },
	              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
	              iconStyle: styles.iconChildren
	            },
	            iconButton
	          ),
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
	        ),
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            anchorEl: anchorEl,
	            animation: animation || _PopoverAnimationVertical2.default,
	            open: open,
	            animated: animated,
	            onRequestClose: this.handleRequestCloseMenu
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            {
	              multiple: multiple,
	              maxHeight: maxHeight,
	              desktop: true,
	              value: value,
	              onEscKeyDown: this.handleEscKeyDownMenu,
	              style: menuStyle,
	              listStyle: listStyle,
	              onItemClick: this.handleItemClick,
	              onChange: this.handleChange,
	              menuItemStyle: menuItemStyle,
	              selectedMenuItemStyle: selectedMenuItemStyle,
	              autoWidth: autoWidth,
	              width: !autoWidth && menuStyle ? menuStyle.width : null
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return DropDownMenu;
	}(_react.Component);
	
	DropDownMenu.muiName = 'DropDownMenu';
	DropDownMenu.defaultProps = {
	  animated: true,
	  autoWidth: true,
	  disabled: false,
	  iconButton: _react2.default.createElement(_arrowDropDown2.default, null),
	  openImmediately: false,
	  maxHeight: 500,
	  multiple: false,
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	DropDownMenu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	DropDownMenu.propTypes =  false ? {
	  /**
	   * This is the point on the anchor that the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * The width will automatically be set according to the items inside the menu.
	   * To control this width in css instead, set this prop to `false`.
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
	   * prop `label` that value will be used to render the representation of that
	   * item within the field.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the menu.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides default `SvgIcon` dropdown arrow component.
	   */
	  iconButton: _propTypes2.default.node,
	  /**
	   * Overrides the styles of icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the styles of label when the `DropDownMenu` is inactive.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override underlying list style.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The maximum height of the `Menu` when it is displayed.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {object} event Click event targeting the menu item that was clicked.
	   * @param {number} key The index of the clicked menu item in the `children` collection.
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Set to true to have the `DropDownMenu` automatically open on mount.
	   */
	  openImmediately: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   * @param {any} menuItem The selected `MenuItem`.
	   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
	   */
	  selectionRenderer: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * Overrides the inline-styles of the underline.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = DropDownMenu;

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(90);
	
	var _EnhancedButton = __webpack_require__(84);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FlatButtonLabel = __webpack_require__(1548);
	
	var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	var FlatButton = function (_Component) {
	  (0, _inherits3.default)(FlatButton, _Component);
	
	  function FlatButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FlatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FlatButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({
	          hovered: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          children = _props.children,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          hoverColor = _props.hoverColor,
	          icon = _props.icon,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          primary = _props.primary,
	          rippleColor = _props.rippleColor,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'children', 'disabled', 'fullWidth', 'hoverColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
	      var _context$muiTheme = this.context.muiTheme,
	          borderRadius = _context$muiTheme.borderRadius,
	          _context$muiTheme$but = _context$muiTheme.button,
	          buttonHeight = _context$muiTheme$but.height,
	          buttonMinWidth = _context$muiTheme$but.minWidth,
	          buttonTextTransform = _context$muiTheme$but.textTransform,
	          _context$muiTheme$fla = _context$muiTheme.flatButton,
	          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
	          buttonColor = _context$muiTheme$fla.color,
	          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
	          fontSize = _context$muiTheme$fla.fontSize,
	          fontWeight = _context$muiTheme$fla.fontWeight,
	          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
	          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
	          textColor = _context$muiTheme$fla.textColor,
	          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
	          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;
	
	      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
	      var defaultRippleColor = buttonFilterColor;
	      var buttonHoverColor = hoverColor || defaultHoverColor;
	      var buttonRippleColor = rippleColor || defaultRippleColor;
	      var buttonBackgroundColor = backgroundColor || buttonColor;
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        height: buttonHeight,
	        lineHeight: buttonHeight + 'px',
	        minWidth: fullWidth ? '100%' : buttonMinWidth,
	        color: defaultTextColor,
	        transition: _transitions2.default.easeOut(),
	        borderRadius: borderRadius,
	        userSelect: 'none',
	        overflow: 'hidden',
	        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	        padding: 0,
	        margin: 0,
	        textAlign: 'center'
	      }, style);
	
	      var iconCloned = void 0;
	      var labelStyleIcon = {};
	
	      if (icon) {
	        var iconStyles = (0, _simpleAssign2.default)({
	          verticalAlign: 'middle',
	          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	          marginRight: label && labelPosition === 'before' ? 12 : 0
	        }, icon.props.style);
	        iconCloned = _react2.default.cloneElement(icon, {
	          color: icon.props.color || mergedRootStyles.color,
	          style: iconStyles,
	          key: 'iconCloned'
	        });
	
	        if (labelPosition === 'before') {
	          labelStyleIcon.paddingRight = 8;
	        } else {
	          labelStyleIcon.paddingLeft = 8;
	        }
	      }
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({
	        letterSpacing: 0,
	        textTransform: textTransform,
	        fontWeight: fontWeight,
	        fontSize: fontSize
	      }, labelStyleIcon, labelStyle);
	
	      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { key: 'labelElement', label: label, style: mergedLabelStyles }) : undefined;
	
	      // Place label before or after children.
	      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          focusRippleColor: buttonRippleColor,
	          focusRippleOpacity: 0.3,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          touchRippleColor: buttonRippleColor,
	          touchRippleOpacity: 0.3
	        }),
	        enhancedButtonChildren
	      );
	    }
	  }]);
	  return FlatButton;
	}(_react.Component);
	
	FlatButton.muiName = 'FlatButton';
	FlatButton.defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  labelStyle: {},
	  labelPosition: 'after',
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onTouchStart: function onTouchStart() {},
	  primary: false,
	  secondary: false
	};
	FlatButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FlatButton.propTypes =  false ? {
	  /**
	   * Color of button when mouse is not hovering over it.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * This is what will be displayed inside the button.
	   * If a label is specified, the text within the label prop will
	   * be displayed. Otherwise, the component will expect children
	   * which will then be displayed. (In our example,
	   * we are nesting an `<input type="file" />` and a `span`
	   * that acts as our label to be displayed.) This only
	   * applies to flat and raised buttons.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The element to use as the container for the FlatButton. Either a string to
	   * use a DOM element or a ReactElement. This is useful for wrapping the
	   * FlatButton in a custom Link component. If a ReactElement is given, ensure
	   * that it passes all of its given props through to the underlying DOM
	   * element and renders its children prop for proper integration.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Color of button when mouse hovers over.
	   */
	  hoverColor: _propTypes2.default.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * Use this property to display an icon.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * Label for the button.
	   */
	  label: validateLabel,
	  /**
	   * Place label before or after the passed children.
	   */
	  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the button is clicked.
	   *
	   * @param {object} event Click event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * If true, colors button according to
	   * primaryTextColor from the Theme.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * Color for the ripple after button is clicked.
	   */
	  rippleColor: _propTypes2.default.string,
	  /**
	   * If true, colors button according to secondaryTextColor from the theme.
	   * The primary prop has precendent if set to true.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = FlatButton;

/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      paddingLeft: baseTheme.spacing.desktopGutterLess,
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      verticalAlign: 'middle'
	    }
	  };
	}
	
	var FlatButtonLabel = function (_Component) {
	  (0, _inherits3.default)(FlatButtonLabel, _Component);
	
	  function FlatButtonLabel() {
	    (0, _classCallCheck3.default)(this, FlatButtonLabel);
	    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FlatButtonLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        label
	      );
	    }
	  }]);
	  return FlatButtonLabel;
	}(_react.Component);
	
	FlatButtonLabel.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FlatButtonLabel.propTypes =  false ? {
	  label: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : {};
	exports.default = FlatButtonLabel;

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(90);
	
	var _EnhancedButton = __webpack_require__(84);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(83);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _childUtils = __webpack_require__(622);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var floatingActionButton = context.muiTheme.floatingActionButton;
	
	
	  var backgroundColor = props.backgroundColor || floatingActionButton.color;
	  var iconColor = floatingActionButton.iconColor;
	
	  if (props.disabled) {
	    backgroundColor = props.disabledColor || floatingActionButton.disabledColor;
	    iconColor = floatingActionButton.disabledTextColor;
	  } else if (props.secondary) {
	    backgroundColor = floatingActionButton.secondaryColor;
	    iconColor = floatingActionButton.secondaryIconColor;
	  }
	
	  return {
	    root: {
	      transition: _transitions2.default.easeOut(),
	      display: 'inline-block',
	      backgroundColor: 'transparent'
	    },
	    container: {
	      backgroundColor: backgroundColor,
	      transition: _transitions2.default.easeOut(),
	      height: floatingActionButton.buttonSize,
	      width: floatingActionButton.buttonSize,
	      padding: 0,
	      overflow: 'hidden',
	      borderRadius: '50%',
	      textAlign: 'center',
	      verticalAlign: 'bottom'
	    },
	    containerWhenMini: {
	      height: floatingActionButton.miniSize,
	      width: floatingActionButton.miniSize
	    },
	    overlay: {
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    overlayWhenHovered: {
	      backgroundColor: (0, _colorManipulator.fade)(iconColor, 0.4)
	    },
	    icon: {
	      height: floatingActionButton.buttonSize,
	      lineHeight: floatingActionButton.buttonSize + 'px',
	      fill: iconColor,
	      color: iconColor
	    },
	    iconWhenMini: {
	      height: floatingActionButton.miniSize,
	      lineHeight: floatingActionButton.miniSize + 'px'
	    }
	  };
	}
	
	var FloatingActionButton = function (_Component) {
	  (0, _inherits3.default)(FloatingActionButton, _Component);
	
	  function FloatingActionButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FloatingActionButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FloatingActionButton.__proto__ || (0, _getPrototypeOf2.default)(FloatingActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touch: false,
	      zDepth: undefined
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	      }
	      if (_this.props.onMouseDown) _this.props.onMouseDown(event);
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ zDepth: _this.props.zDepth });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.refs.container.isKeyboardFocused()) {
	        _this.setState({ zDepth: _this.props.zDepth, hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.refs.container.isKeyboardFocused() && !_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth + 1
	      });
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth
	      });
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused && !_this.props.disabled) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	        _this.refs.overlay.style.backgroundColor = (0, _colorManipulator.fade)(getStyles(_this.props, _this.context).icon.color, 0.4);
	      } else if (!_this.state.hovered) {
	        _this.setState({ zDepth: _this.props.zDepth });
	        _this.refs.overlay.style.backgroundColor = 'transparent';
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FloatingActionButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        zDepth: this.props.disabled ? 0 : this.props.zDepth
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconClassName || !this.props.children, 'Material-UI: You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.') : void 0;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextState = {};
	
	      if (nextProps.disabled !== this.props.disabled) {
	        nextState.zDepth = nextProps.disabled ? 0 : this.props.zDepth;
	      }
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          className = _props.className,
	          childrenProp = _props.children,
	          disabled = _props.disabled,
	          disabledColor = _props.disabledColor,
	          mini = _props.mini,
	          secondary = _props.secondary,
	          iconStyle = _props.iconStyle,
	          iconClassName = _props.iconClassName,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'className', 'children', 'disabled', 'disabledColor', 'mini', 'secondary', 'iconStyle', 'iconClassName', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (iconClassName) {
	        iconElement = _react2.default.createElement(_FontIcon2.default, {
	          className: iconClassName,
	          style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle)
	        });
	      }
	
	      var children = void 0;
	
	      if (childrenProp) {
	        children = (0, _childUtils.extendChildren)(childrenProp, function (child) {
	          return {
	            style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle, child.props.style)
	          };
	        });
	      }
	
	      var buttonEventHandlers = disabled ? null : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          zDepth: this.state.zDepth,
	          circle: true
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
	            focusRippleColor: styles.icon.color,
	            touchRippleColor: styles.icon.color
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered))
	            },
	            iconElement,
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return FloatingActionButton;
	}(_react.Component);
	
	FloatingActionButton.defaultProps = {
	  disabled: false,
	  mini: false,
	  secondary: false,
	  zDepth: 2
	};
	FloatingActionButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FloatingActionButton.propTypes =  false ? {
	  /**
	   * This value will override the default background color for the button.
	   * However it will not override the default disabled background color.
	   * This has to be set separately using the disabledColor attribute.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * This is what displayed inside the floating action button; for example, a SVG Icon.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * This value will override the default background color for the button when it is disabled.
	   */
	  disabledColor: _propTypes2.default.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * The icon within the FloatingActionButton is a FontIcon component.
	   * This property is the classname of the icon to be displayed inside the button.
	   * An alternative to adding an iconClassName would be to manually insert a
	   * FontIcon component or custom SvgIcon component or as a child of FloatingActionButton.
	   */
	  iconClassName: _propTypes2.default.string,
	  /**
	   * This is the equivalent to iconClassName except that it is used for
	   * overriding the inline-styles of the FontIcon component.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will be a small floating action button.
	   */
	  mini: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the button is clicked.
	   *
	   * @param {object} event Click event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * If true, the button will use the secondary button colors.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The zDepth of the underlying `Paper` component.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = FloatingActionButton;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FloatingActionButton = __webpack_require__(1549);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FloatingActionButton2.default;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var color = props.color,
	      hoverColor = props.hoverColor;
	  var baseTheme = context.muiTheme.baseTheme;
	
	  var offColor = color || baseTheme.palette.textColor;
	  var onColor = hoverColor || offColor;
	
	  return {
	    root: {
	      color: state.hovered ? onColor : offColor,
	      position: 'relative',
	      fontSize: baseTheme.spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }
	  };
	}
	
	var FontIcon = function (_Component) {
	  (0, _inherits3.default)(FontIcon, _Component);
	
	  function FontIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FontIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FontIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hoverColor = _props.hoverColor,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	      }));
	    }
	  }]);
	  return FontIcon;
	}(_react.Component);
	
	FontIcon.muiName = 'FontIcon';
	FontIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {}
	};
	FontIcon.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	FontIcon.propTypes =  false ? {
	  /**
	   * This is the font color of the font icon. If not specified,
	   * this component will default to muiTheme.palette.textColor.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _propTypes2.default.string,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = FontIcon;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    root: {
	      display: 'flex',
	      flexWrap: 'wrap',
	      margin: -props.padding / 2
	    },
	    item: {
	      boxSizing: 'border-box',
	      padding: props.padding / 2
	    }
	  };
	}
	
	var GridList = function (_Component) {
	  (0, _inherits3.default)(GridList, _Component);
	
	  function GridList() {
	    (0, _classCallCheck3.default)(this, GridList);
	    return (0, _possibleConstructorReturn3.default)(this, (GridList.__proto__ || (0, _getPrototypeOf2.default)(GridList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cols = _props.cols,
	          padding = _props.padding,
	          cellHeight = _props.cellHeight,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['cols', 'padding', 'cellHeight', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var wrappedChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (_react2.default.isValidElement(currentChild) && currentChild.type.muiName === 'Subheader') {
	          return currentChild;
	        }
	        var childCols = currentChild.props.cols || 1;
	        var childRows = currentChild.props.rows || 1;
	        var itemStyle = (0, _simpleAssign2.default)({}, styles.item, {
	          width: 100 / cols * childCols + '%',
	          height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + padding
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { style: prepareStyles(itemStyle) },
	          currentChild
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles(mergedRootStyles) }, other),
	        wrappedChildren
	      );
	    }
	  }]);
	  return GridList;
	}(_react.Component);
	
	GridList.defaultProps = {
	  cols: 2,
	  padding: 4,
	  cellHeight: 180
	};
	GridList.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	GridList.propTypes =  false ? {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]),
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Number of columns.
	   */
	  cols: _propTypes2.default.number,
	  /**
	   * Number of px for the padding/spacing between items.
	   */
	  padding: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = GridList;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.GridTile = exports.GridList = undefined;
	
	var _GridList2 = __webpack_require__(1552);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(595);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.default = _GridList3.default;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _EnhancedButton = __webpack_require__(84);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(83);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Tooltip = __webpack_require__(617);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _childUtils = __webpack_require__(622);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      overflow: 'visible',
	      transition: _transitions2.default.easeOut(),
	      padding: baseTheme.spacing.iconSize / 2,
	      width: baseTheme.spacing.iconSize * 2,
	      height: baseTheme.spacing.iconSize * 2,
	      fontSize: 0
	    },
	    tooltip: {
	      boxSizing: 'border-box'
	    },
	    disabled: {
	      color: baseTheme.palette.disabledColor,
	      fill: baseTheme.palette.disabledColor,
	      cursor: 'default'
	    }
	  };
	}
	
	var IconButton = function (_Component) {
	  (0, _inherits3.default)(IconButton, _Component);
	
	  function IconButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      // Not to be confonded with the touch property.
	      // This state is to determined if it's a mobile device.
	      touch: false,
	      tooltipShown: false
	    }, _this.handleBlur = function (event) {
	      _this.hideTooltip();
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      _this.showTooltip();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.button.isKeyboardFocused()) {
	        _this.hideTooltip();
	      }
	      _this.setState({ hovered: false });
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseOut = function (event) {
	      if (_this.props.disabled) _this.hideTooltip();
	      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.showTooltip();
	
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onFocus = _this$props.onFocus,
	          onBlur = _this$props.onBlur,
	          onKeyboardFocus = _this$props.onKeyboardFocus;
	
	      if (isKeyboardFocused && !disabled) {
	        _this.showTooltip();
	        if (onFocus) {
	          onFocus(event);
	        }
	      } else {
	        _this.hideTooltip();
	        if (onBlur) {
	          onBlur(event);
	        }
	      }
	
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      if (onKeyboardFocus) {
	        onKeyboardFocus(event, isKeyboardFocused);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({ hovered: false });
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus() {
	      this.button.setKeyboardFocus();
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      if (this.props.tooltip) {
	        this.setState({ tooltipShown: true });
	      }
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      if (this.props.tooltip) this.setState({ tooltipShown: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          disabled = _props.disabled,
	          hoveredStyle = _props.hoveredStyle,
	          disableTouchRipple = _props.disableTouchRipple,
	          children = _props.children,
	          iconClassName = _props.iconClassName,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipPositionProp = _props.tooltipPosition,
	          tooltipStyles = _props.tooltipStyles,
	          touch = _props.touch,
	          iconStyle = _props.iconStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);
	
	      var fonticon = void 0;
	
	      var styles = getStyles(this.props, this.context);
	      var tooltipPosition = tooltipPositionProp.split('-');
	
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});
	
	      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
	        label: tooltip,
	        show: this.state.tooltipShown,
	        touch: touch,
	        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
	        verticalPosition: tooltipPosition[0],
	        horizontalPosition: tooltipPosition[1]
	      }) : null;
	
	      if (iconClassName) {
	        var iconHoverColor = iconStyle.iconHoverColor,
	            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);
	
	
	        fonticon = _react2.default.createElement(
	          _FontIcon2.default,
	          {
	            className: iconClassName,
	            hoverColor: disabled ? null : iconHoverColor,
	            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
	            color: this.context.muiTheme.baseTheme.palette.textColor
	          },
	          children
	        );
	      }
	
	      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          ref: function ref(_ref2) {
	            return _this2.button = _ref2;
	          }
	        }, other, {
	          centerRipple: true,
	          disabled: disabled,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          disableTouchRipple: disableTouchRipple,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseOut: this.handleMouseOut,
	          onKeyboardFocus: this.handleKeyboardFocus
	        }),
	        tooltipElement,
	        fonticon,
	        (0, _childUtils.extendChildren)(children, {
	          style: childrenStyle
	        })
	      );
	    }
	  }]);
	  return IconButton;
	}(_react.Component);
	
	IconButton.muiName = 'IconButton';
	IconButton.defaultProps = {
	  disabled: false,
	  disableTouchRipple: false,
	  iconStyle: {},
	  tooltipPosition: 'bottom-center',
	  touch: false
	};
	IconButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	IconButton.propTypes =  false ? {
	  /**
	   * Can be used to pass a `FontIcon` element as the icon for the button.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * If true, the element will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element when the component is hovered.
	   */
	  hoveredStyle: _propTypes2.default.object,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
	   */
	  iconClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the icon element.
	   * Note: you can specify iconHoverColor as a String inside this object.
	   */
	  iconStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when the button is clicked.
	   *
	   * @param {object} event Click event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} keyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseOut: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The text to supply to the element's tooltip.
	   */
	  tooltip: _propTypes2.default.node,
	  /**
	   * The vertical and horizontal positions, respectively, of the element's tooltip.
	   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
	   * "bottom-left", and "top-left".
	   */
	  tooltipPosition: _propTypes4.default.cornersAndCenter,
	  /**
	   * Override the inline-styles of the tooltip element.
	   */
	  tooltipStyles: _propTypes2.default.object,
	  /**
	   * If true, increase the tooltip element's size. Useful for increasing tooltip
	   * readability on mobile devices.
	   */
	  touch: _propTypes2.default.bool
	} : {};
	exports.default = IconButton;

/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(274);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Menu = __webpack_require__(270);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Popover = __webpack_require__(174);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMenu = function (_Component) {
	  (0, _inherits3.default)(IconMenu, _Component);
	
	  function IconMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconMenu.__proto__ || (0, _getPrototypeOf2.default)(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      menuInitiallyKeyboardFocused: false,
	      open: false
	    }, _this.handleItemClick = function (event, child) {
	      if (_this.props.clickCloseDelay !== 0 && !child.props.hasOwnProperty('menuItems')) {
	        var isKeyboard = _events2.default.isKeyboard(event);
	        _this.timerCloseId = setTimeout(function () {
	          _this.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
	        }, _this.props.clickCloseDelay);
	      }
	
	      _this.props.onItemClick(event, child);
	    }, _this.handleRequestClose = function (reason) {
	      _this.close(reason);
	    }, _this.handleEscKeyDownMenu = function (event) {
	      _this.close('escape', event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open != null) {
	        this.setState({
	          open: nextProps.open,
	          anchorEl: this.refs.iconMenuContainer
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerCloseId);
	    }
	  }, {
	    key: 'isOpen',
	    value: function isOpen() {
	      return this.state.open;
	    }
	  }, {
	    key: 'close',
	    value: function close(reason, isKeyboard) {
	      var _this2 = this;
	
	      if (!this.state.open) {
	        return;
	      }
	
	      if (this.props.open !== null) {
	        this.props.onRequestChange(false, reason);
	      } else {
	        this.setState({ open: false }, function () {
	          // Set focus on the icon button when the menu close
	          if (isKeyboard) {
	            var iconButton = _this2.refs.iconButton;
	            _reactDom2.default.findDOMNode(iconButton).focus();
	            iconButton.setKeyboardFocus();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open(reason, event) {
	      if (this.props.open !== null) {
	        this.props.onRequestChange(true, reason);
	
	        return this.setState({
	          menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	          anchorEl: event.currentTarget
	        });
	      }
	
	      this.setState({
	        open: true,
	        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	        anchorEl: event.currentTarget
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          className = _props.className,
	          animated = _props.animated,
	          animation = _props.animation,
	          iconButtonElement = _props.iconButtonElement,
	          iconStyle = _props.iconStyle,
	          onItemClick = _props.onItemClick,
	          onKeyboardFocus = _props.onKeyboardFocus,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseUp = _props.onMouseUp,
	          onRequestChange = _props.onRequestChange,
	          onClick = _props.onClick,
	          listStyle = _props.listStyle,
	          menuStyle = _props.menuStyle,
	          style = _props.style,
	          targetOrigin = _props.targetOrigin,
	          clickCloseDelay = _props.clickCloseDelay,
	          useLayerForClickAway = _props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'className', 'animated', 'animation', 'iconButtonElement', 'iconStyle', 'onItemClick', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onRequestChange', 'onClick', 'listStyle', 'menuStyle', 'style', 'targetOrigin', 'clickCloseDelay', 'useLayerForClickAway']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl;
	
	
	      var styles = {
	        root: {
	          display: 'inline-block',
	          position: 'relative'
	        },
	        menu: {
	          position: 'relative'
	        }
	      };
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedMenuStyles = (0, _simpleAssign2.default)(styles.menu, menuStyle);
	
	       false ? (0, _warning2.default)(iconButtonElement.type.muiName !== 'SvgIcon', 'Material-UI: You shoud not provide an <SvgIcon /> to the \'iconButtonElement\' property of <IconMenu />.\nYou should wrapped it with an <IconButton />.') : void 0;
	
	      var iconButtonProps = {
	        onKeyboardFocus: onKeyboardFocus,
	        onClick: function onClick(event) {
	          _this3.open(_events2.default.isKeyboard(event) ? 'keyboard' : 'iconTap', event);
	          if (iconButtonElement.props.onClick) {
	            iconButtonElement.props.onClick(event);
	          }
	        },
	        ref: 'iconButton'
	      };
	      if (iconStyle || iconButtonElement.props.iconStyle) {
	        iconButtonProps.iconStyle = iconStyle ? (0, _simpleAssign2.default)({}, iconStyle, iconButtonElement.props.iconStyle) : iconButtonElement.props.iconStyle;
	      }
	      var iconButton = _react2.default.cloneElement(iconButtonElement, iconButtonProps);
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({}, other, {
	          initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
	          onEscKeyDown: this.handleEscKeyDownMenu,
	          onItemClick: this.handleItemClick,
	          style: mergedMenuStyles,
	          listStyle: listStyle
	        }),
	        this.props.children
	      );
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'iconMenuContainer',
	          className: className,
	          onMouseDown: onMouseDown,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          onMouseUp: onMouseUp,
	          onClick: onClick,
	          style: prepareStyles(mergedRootStyles)
	        },
	        iconButton,
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            childContextTypes: this.constructor.childContextTypes,
	            useLayerForClickAway: useLayerForClickAway,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation,
	            context: this.context
	          },
	          menu
	        )
	      );
	    }
	  }]);
	  return IconMenu;
	}(_react.Component);
	
	IconMenu.muiName = 'IconMenu';
	IconMenu.defaultProps = {
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  animated: true,
	  multiple: false,
	  open: null,
	  onItemClick: function onItemClick() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseUp: function onMouseUp() {},
	  onRequestChange: function onRequestChange() {},
	  onClick: function onClick() {},
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  clickCloseDelay: 200,
	  useLayerForClickAway: false
	};
	IconMenu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	IconMenu.propTypes =  false ? {
	  /**
	   * This is the point on the icon where the menu
	   * `targetOrigin` will attach.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * Should be used to pass `MenuItem` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Sets the delay in milliseconds before closing the
	   * menu when an item is clicked.
	   * If set to 0 then the auto close functionality
	   * will be disabled.
	   */
	  clickCloseDelay: _propTypes2.default.number,
	  /**
	   * This is the `IconButton` to render. This button will open the menu.
	   */
	  iconButtonElement: _propTypes2.default.element.isRequired,
	  /**
	   * Override the inline-styles of the underlying icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the menu element.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, the value can an be array and allow the menu to be a multi-select.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the `IconButton` element is clicked.
	   *
	   * @param {object} event Click event targeting the `IconButton` element.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is selected with a click.
	   *
	   * @param {object} event Click event targeting the selected menu item element.
	   * @param {object} child The selected element.
	   */
	  onItemClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `IconButton` element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `IconButton` element.
	   * @param {boolean} keyboardFocused If true, the `IconButton` element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `open` state of the menu is requested to be changed.
	   *
	   * @param {boolean} open If true, the menu was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'keyboard' and 'iconTap' for open requests; 'enter', 'escape', 'itemTap', and 'clickAway'
	   * for close requests.
	   */
	  onRequestChange: _propTypes2.default.func,
	  /**
	   * If true, the `IconMenu` is opened.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the menu which will stick to the menu
	   * origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying elements.
	   */
	  useLayerForClickAway: _propTypes2.default.bool
	} : {};
	exports.default = IconMenu;

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  var rangeValue = max - min;
	  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
	  return relValue * 100;
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      value = props.value;
	  var _context$muiTheme = context.muiTheme,
	      palette = _context$muiTheme.baseTheme.palette,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      height: 4,
	      display: 'block',
	      width: '100%',
	      backgroundColor: palette.primary3Color,
	      borderRadius: borderRadius,
	      margin: 0,
	      overflow: 'hidden'
	    },
	    bar: {
	      height: '100%'
	    },
	    barFragment1: {},
	    barFragment2: {}
	  };
	
	  if (props.mode === 'indeterminate') {
	    styles.barFragment1 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
	    };
	
	    styles.barFragment2 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
	    };
	  } else {
	    styles.bar.backgroundColor = props.color || palette.primary1Color;
	    styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
	    styles.bar.width = getRelativeValue(value, min, max) + '%';
	  }
	
	  return styles;
	}
	
	var LinearProgress = function (_Component) {
	  (0, _inherits3.default)(LinearProgress, _Component);
	
	  function LinearProgress() {
	    (0, _classCallCheck3.default)(this, LinearProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (LinearProgress.__proto__ || (0, _getPrototypeOf2.default)(LinearProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LinearProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.timers = {};
	
	      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]], 0);
	
	      this.timers.bar2 = setTimeout(function () {
	        _this2.barUpdate('bar2', 0, _this2.refs.bar2, [[-200, 100], [107, -8]], 0);
	      }, 850);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timers.bar1);
	      clearTimeout(this.timers.bar2);
	    }
	  }, {
	    key: 'barUpdate',
	    value: function barUpdate(id, step, barElement, stepValues, timeToNextStep) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      timeToNextStep = timeToNextStep || 420;
	      step = step || 0;
	      step %= 4;
	
	      var right = this.context.muiTheme.isRtl ? 'left' : 'right';
	      var left = this.context.muiTheme.isRtl ? 'right' : 'left';
	
	      if (step === 0) {
	        barElement.style[left] = stepValues[0][0] + '%';
	        barElement.style[right] = stepValues[0][1] + '%';
	      } else if (step === 1) {
	        barElement.style.transitionDuration = '840ms';
	      } else if (step === 2) {
	        barElement.style[left] = stepValues[1][0] + '%';
	        barElement.style[right] = stepValues[1][1] + '%';
	      } else if (step === 3) {
	        barElement.style.transitionDuration = '0ms';
	      }
	      this.timers[id] = setTimeout(function () {
	        return _this3.barUpdate(id, step + 1, barElement, stepValues);
	      }, timeToNextStep);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.bar) },
	          _react2.default.createElement('div', { ref: 'bar1', style: prepareStyles(styles.barFragment1) }),
	          _react2.default.createElement('div', { ref: 'bar2', style: prepareStyles(styles.barFragment2) })
	        )
	      );
	    }
	  }]);
	  return LinearProgress;
	}(_react.Component);
	
	LinearProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100
	};
	LinearProgress.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	LinearProgress.propTypes =  false ? {
	  /**
	   * The color of the progress bar, defaults to
	   * primary color of theme.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _propTypes2.default.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _propTypes2.default.number,
	  /**
	   * The mode of show your progress, indeterminate for when
	   * there is no value for progress.
	   */
	  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _propTypes2.default.number
	} : {};
	exports.default = LinearProgress;

/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(375);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NestedList = function NestedList(props) {
	  var children = props.children,
	      open = props.open,
	      nestedLevel = props.nestedLevel,
	      style = props.style;
	
	
	  if (!open) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _List2.default,
	    { style: style },
	    _react.Children.map(children, function (child) {
	      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
	        nestedLevel: nestedLevel + 1
	      }) : child;
	    })
	  );
	};
	
	NestedList.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  nestedLevel: _propTypes2.default.number.isRequired,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	exports.default = NestedList;

/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HotKeyHolder = undefined;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HotKeyHolder = exports.HotKeyHolder = function () {
	  function HotKeyHolder() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, HotKeyHolder);
	
	    this.clear = function () {
	      _this.timerId = null;
	      _this.lastKeys = null;
	    };
	  }
	
	  (0, _createClass3.default)(HotKeyHolder, [{
	    key: 'append',
	    value: function append(key) {
	      clearTimeout(this.timerId);
	      this.timerId = setTimeout(this.clear, 500);
	      return this.lastKeys = (this.lastKeys || '') + key;
	    }
	  }]);
	  return HotKeyHolder;
	}();

/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var rounded = props.rounded,
	      circle = props.circle,
	      transitionEnabled = props.transitionEnabled,
	      zDepth = props.zDepth;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      paper = _context$muiTheme.paper,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  return {
	    root: {
	      color: paper.color,
	      backgroundColor: paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: baseTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? borderRadius : '0px'
	    }
	  };
	}
	
	var Paper = function (_Component) {
	  (0, _inherits3.default)(Paper, _Component);
	
	  function Paper() {
	    (0, _classCallCheck3.default)(this, Paper);
	    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          circle = _props.circle,
	          rounded = _props.rounded,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Paper;
	}(_react.Component);
	
	Paper.defaultProps = {
	  circle: false,
	  rounded: true,
	  transitionEnabled: true,
	  zDepth: 1
	};
	Paper.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Paper.propTypes =  false ? {
	  /**
	   * Children passed into the paper element.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Set to true to generate a circular paper container.
	   */
	  circle: _propTypes2.default.bool,
	  /**
	   * By default, the paper container will have a border radius.
	   * Set this to false to generate a container with sharp corners.
	   */
	  rounded: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Set to false to disable CSS transitions for the paper element.
	   */
	  transitionEnabled: _propTypes2.default.bool,
	  /**
	   * This number represents the zDepth of the paper shadow.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = Paper;

/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(65);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    },
	    horizontal: {
	      maxHeight: '100%',
	      overflowY: 'auto',
	      transform: open ? 'scaleX(1)' : 'scaleX(0)',
	      opacity: open ? 1 : 0,
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
	    },
	    vertical: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
	    }
	  };
	}
	
	var PopoverAnimationDefault = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationDefault, _Component);
	
	  function PopoverAnimationDefault() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationDefault, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.horizontal) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.vertical) },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	  return PopoverAnimationDefault;
	}(_react.Component);
	
	PopoverAnimationDefault.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationDefault.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	PopoverAnimationDefault.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  targetOrigin: _propTypes4.default.origin.isRequired,
	  zDepth: _propTypes4.default.zDepth
	} : {};
	exports.default = PopoverAnimationDefault;

/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;
	
	var _Popover2 = __webpack_require__(174);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _PopoverAnimationVertical2 = __webpack_require__(378);
	
	var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Popover = _Popover3.default;
	exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
	exports.default = _Popover3.default;

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(90);
	
	var _EnhancedButton = __webpack_require__(84);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      raisedButton = _context$muiTheme.raisedButton,
	      borderRadius = _context$muiTheme.borderRadius;
	  var disabled = props.disabled,
	      disabledBackgroundColor = props.disabledBackgroundColor,
	      disabledLabelColor = props.disabledLabelColor,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      label = props.label,
	      labelPosition = props.labelPosition,
	      primary = props.primary,
	      secondary = props.secondary,
	      style = props.style;
	
	
	  var amount = primary || secondary ? 0.4 : 0.08;
	
	  var backgroundColor = raisedButton.color;
	  var labelColor = raisedButton.textColor;
	
	  if (disabled) {
	    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
	    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
	  } else if (primary) {
	    backgroundColor = raisedButton.primaryColor;
	    labelColor = raisedButton.primaryTextColor;
	  } else if (secondary) {
	    backgroundColor = raisedButton.secondaryColor;
	    labelColor = raisedButton.secondaryTextColor;
	  } else {
	    if (props.backgroundColor) {
	      backgroundColor = props.backgroundColor;
	    }
	    if (props.labelColor) {
	      labelColor = props.labelColor;
	    }
	  }
	
	  var buttonHeight = style && style.height || button.height;
	
	  return {
	    root: {
	      display: 'inline-block',
	      transition: _transitions2.default.easeOut(),
	      minWidth: fullWidth ? '100%' : button.minWidth
	    },
	    button: {
	      height: buttonHeight,
	      lineHeight: buttonHeight + 'px',
	      width: '100%',
	      padding: 0,
	      borderRadius: borderRadius,
	      transition: _transitions2.default.easeOut(),
	      backgroundColor: backgroundColor,
	      // That's the default value for a button but not a link
	      textAlign: 'center'
	    },
	    label: {
	      position: 'relative',
	      opacity: 1,
	      fontSize: raisedButton.fontSize,
	      letterSpacing: 0,
	      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
	      fontWeight: raisedButton.fontWeight,
	      margin: 0,
	      userSelect: 'none',
	      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      color: labelColor
	    },
	    icon: {
	      verticalAlign: 'middle',
	      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	      marginRight: label && labelPosition === 'before' ? 12 : 0
	    },
	    overlay: {
	      height: buttonHeight,
	      borderRadius: borderRadius,
	      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    ripple: {
	      color: labelColor,
	      opacity: !(primary || secondary) ? 0.1 : 0.16
	    }
	  };
	}
	
	var RaisedButton = function (_Component) {
	  (0, _inherits3.default)(RaisedButton, _Component);
	
	  function RaisedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RaisedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaisedButton.__proto__ || (0, _getPrototypeOf2.default)(RaisedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      keyboardFocused: false,
	      touched: false,
	      initialZDepth: 0,
	      zDepth: 0
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth + 1
	        });
	      }
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.state.keyboardFocused) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth,
	          hovered: false
	        });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.keyboardFocused && !_this.state.touched) {
	        _this.setState({
	          hovered: true
	        });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth + 1
	      });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth
	      });
	
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;
	
	      _this.setState({
	        zDepth: zDepth,
	        keyboardFocused: keyboardFocused
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RaisedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var zDepth = this.props.disabled ? 0 : 1;
	      this.setState({
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var zDepth = nextProps.disabled ? 0 : 1;
	      var nextState = {
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      };
	
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          buttonStyle = _props.buttonStyle,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          disabledBackgroundColor = _props.disabledBackgroundColor,
	          disabledLabelColor = _props.disabledLabelColor,
	          fullWidth = _props.fullWidth,
	          icon = _props.icon,
	          label = _props.label,
	          labelColor = _props.labelColor,
	          labelPosition = _props.labelPosition,
	          labelStyle = _props.labelStyle,
	          overlayStyle = _props.overlayStyle,
	          primary = _props.primary,
	          rippleStyle = _props.rippleStyle,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'buttonStyle', 'children', 'className', 'disabled', 'disabledBackgroundColor', 'disabledLabelColor', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'overlayStyle', 'primary', 'rippleStyle', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);
	
	      var buttonEventHandlers = disabled ? {} : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var labelElement = label && _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)), key: 'labelElement' },
	        label
	      );
	
	      var iconCloned = icon && (0, _react.cloneElement)(icon, {
	        color: icon.props.color || styles.label.color,
	        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style),
	        key: 'iconCloned'
	      });
	
	      var overlayBackgroundProxy = {
	        backgroundColor: overlayStyle && styles.overlay.backgroundColor && overlayStyle.backgroundColor || styles.overlay.backgroundColor
	      };
	
	      // Place label before or after children.
	      var enhancedButtonChildren = labelPosition === 'before' ? [labelElement, iconCloned, children] : [children, iconCloned, labelElement];
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: this.state.zDepth
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.button, buttonStyle),
	            focusRippleColor: mergedRippleStyles.color,
	            touchRippleColor: mergedRippleStyles.color,
	            focusRippleOpacity: mergedRippleStyles.opacity,
	            touchRippleOpacity: mergedRippleStyles.opacity
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, overlayStyle, overlayBackgroundProxy))
	            },
	            enhancedButtonChildren
	          )
	        )
	      );
	    }
	  }]);
	  return RaisedButton;
	}(_react.Component);
	
	RaisedButton.muiName = 'RaisedButton';
	RaisedButton.defaultProps = {
	  disabled: false,
	  labelPosition: 'after',
	  fullWidth: false,
	  primary: false,
	  secondary: false
	};
	RaisedButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RaisedButton.propTypes =  false ? {
	  /**
	   * Override the default background color for the button,
	   * but not the default disabled background color
	   * (use `disabledBackgroundColor` for this).
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _propTypes2.default.object,
	  /**
	   * The content of the button.
	   * If a label is provided via the `label` prop, the text within the label
	   * will be displayed in addition to the content provided here.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	    * The element to use as the container for the RaisedButton. Either a string to
	    * use a DOM element or a ReactElement. This is useful for wrapping the
	    * RaisedButton in a custom Link component. If a ReactElement is given, ensure
	    * that it passes all of its given props through to the underlying DOM
	    * element and renders its children prop for proper integration.
	    */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * If true, the button will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the default background color for the button
	   * when it is disabled.
	   */
	  disabledBackgroundColor: _propTypes2.default.string,
	  /**
	   * The color of the button's label when the button is disabled.
	   */
	  disabledLabelColor: _propTypes2.default.string,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * An icon to be displayed within the button.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * The label to be displayed within the button.
	   * If content is provided via the `children` prop, that content will be
	   * displayed in addition to the label provided here.
	   */
	  label: validateLabel,
	  /**
	   * The color of the button's label.
	   */
	  labelColor: _propTypes2.default.string,
	  /**
	   * The position of the button's label relative to the button's `children`.
	   */
	  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the button is clicked.
	   *
	   * @param {object} event Click event targeting the button.
	   */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline style of the button overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will use the theme's primary color.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * Override the inline style of the ripple element.
	   */
	  rippleStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will use the theme's secondary color.
	   * If both `secondary` and `primary` are true, the button will use
	   * the theme's primary color.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = RaisedButton;

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _slicedToArray2 = __webpack_require__(296);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autoPrefix = __webpack_require__(137);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VIEWBOX_SIZE = 32;
	
	function getStyles(props) {
	  var padding = props.size * 0.1; // same implementation of `this.getPaddingSize()`
	  return {
	    root: {
	      position: 'absolute',
	      zIndex: 2,
	      width: props.size,
	      height: props.size,
	      padding: padding,
	      top: -10000,
	      left: -10000,
	      transform: 'translate(' + (10000 + props.left) + 'px, ' + (10000 + props.top) + 'px)',
	      opacity: props.status === 'hide' ? 0 : 1,
	      transition: props.status === 'hide' ? _transitions2.default.create('all', '.3s', 'ease-out') : 'none'
	    }
	  };
	}
	
	var RefreshIndicator = function (_Component) {
	  (0, _inherits3.default)(RefreshIndicator, _Component);
	
	  function RefreshIndicator() {
	    (0, _classCallCheck3.default)(this, RefreshIndicator);
	    return (0, _possibleConstructorReturn3.default)(this, (RefreshIndicator.__proto__ || (0, _getPrototypeOf2.default)(RefreshIndicator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RefreshIndicator, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var paperSize = this.getPaperSize();
	
	      var childrenCmp = null;
	      if (this.props.status !== 'ready') {
	        var circleStyle = this.getCircleStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'div',
	          {
	            ref: 'wrapper',
	            style: prepareStyles({
	              transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	              width: '100%',
	              height: '100%'
	            })
	          },
	          _react2.default.createElement(
	            'svg',
	            {
	              style: {
	                width: paperSize,
	                height: paperSize
	              },
	              viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	            },
	            _react2.default.createElement('circle', (0, _extends3.default)({
	              ref: 'path',
	              style: prepareStyles((0, _simpleAssign2.default)(circleStyle.style, {
	                transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	              }))
	            }, circleStyle.attr))
	          )
	        );
	      } else {
	        var _circleStyle = this.getCircleStyle(paperSize);
	        var polygonStyle = this.getPolygonStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'svg',
	          {
	            style: {
	              width: paperSize,
	              height: paperSize
	            },
	            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	          },
	          _react2.default.createElement('circle', (0, _extends3.default)({
	            style: prepareStyles(_circleStyle.style)
	          }, _circleStyle.attr)),
	          _react2.default.createElement('polygon', (0, _extends3.default)({
	            style: prepareStyles(polygonStyle.style)
	          }, polygonStyle.attr))
	        );
	      }
	
	      return childrenCmp;
	    }
	  }, {
	    key: 'getTheme',
	    value: function getTheme() {
	      return this.context.muiTheme.refreshIndicator;
	    }
	  }, {
	    key: 'getPaddingSize',
	    value: function getPaddingSize() {
	      var padding = this.props.size * 0.1;
	      return padding;
	    }
	  }, {
	    key: 'getPaperSize',
	    value: function getPaperSize() {
	      return this.props.size - this.getPaddingSize() * 2;
	    }
	  }, {
	    key: 'getCircleAttr',
	    value: function getCircleAttr() {
	      return {
	        radiu: VIEWBOX_SIZE / 2 - 5,
	        originX: VIEWBOX_SIZE / 2,
	        originY: VIEWBOX_SIZE / 2,
	        strokeWidth: 3
	      };
	    }
	  }, {
	    key: 'getArcDeg',
	    value: function getArcDeg() {
	      var p = this.props.percentage / 100;
	
	      var beginDeg = p * 120;
	      var endDeg = p * 410;
	      return [beginDeg, endDeg];
	    }
	  }, {
	    key: 'getFactor',
	    value: function getFactor() {
	      var p = this.props.percentage / 100;
	      var p1 = Math.min(1, p / 0.4);
	
	      return p1;
	    }
	  }, {
	    key: 'getCircleStyle',
	    value: function getCircleStyle() {
	      var isLoading = this.props.status === 'loading';
	      var p1 = isLoading ? 1 : this.getFactor();
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	
	      var _getArcDeg = this.getArcDeg(),
	          _getArcDeg2 = (0, _slicedToArray3.default)(_getArcDeg, 2),
	          beginDeg = _getArcDeg2[0],
	          endDeg = _getArcDeg2[1];
	
	      var arcLen = (endDeg - beginDeg) * perimeter / 360;
	      var dashOffset = -beginDeg * perimeter / 360;
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
	          strokeDashoffset: dashOffset,
	          stroke: isLoading || this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          strokeLinecap: 'round',
	          opacity: p1,
	          strokeWidth: circle.strokeWidth * p1,
	          fill: 'none'
	        },
	        attr: {
	          cx: circle.originX,
	          cy: circle.originY,
	          r: circle.radiu
	        }
	      };
	    }
	  }, {
	    key: 'getPolygonStyle',
	    value: function getPolygonStyle() {
	      var p1 = this.getFactor();
	      var circle = this.getCircleAttr();
	
	      var triangleCx = circle.originX + circle.radiu;
	      var triangleCy = circle.originY;
	      var dx = circle.strokeWidth * 7 / 4 * p1;
	      var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);
	
	      var _getArcDeg3 = this.getArcDeg(),
	          _getArcDeg4 = (0, _slicedToArray3.default)(_getArcDeg3, 2),
	          endDeg = _getArcDeg4[1];
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          fill: this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          transform: 'rotate(' + endDeg + 'deg)',
	          transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
	          opacity: p1
	        },
	        attr: {
	          points: trianglePath
	        }
	      };
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path, step) {
	      var _this2 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      var currStep = (step || 0) % 3;
	
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	      var arcLen = perimeter * 0.64;
	
	      var strokeDasharray = void 0;
	      var strokeDashoffset = void 0;
	      var transitionDuration = void 0;
	
	      if (currStep === 0) {
	        strokeDasharray = '1, 200';
	        strokeDashoffset = 0;
	        transitionDuration = '0ms';
	      } else if (currStep === 1) {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -15;
	        transitionDuration = '750ms';
	      } else {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -(perimeter - 1);
	        transitionDuration = '850ms';
	      }
	
	      _autoPrefix2.default.set(path.style, 'strokeDasharray', strokeDasharray);
	      _autoPrefix2.default.set(path.style, 'strokeDashoffset', strokeDashoffset);
	      _autoPrefix2.default.set(path.style, 'transitionDuration', transitionDuration);
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, currStep + 1);
	      }, currStep ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', null);
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      this.rotateWrapperSecondTimer = setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          top = _props.top,
	          left = _props.left,
	          percentage = _props.percentage,
	          status = _props.status,
	          loadingColor = _props.loadingColor,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'top', 'left', 'percentage', 'status', 'loadingColor']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({
	          circle: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }, other),
	        this.renderChildren()
	      );
	    }
	  }]);
	  return RefreshIndicator;
	}(_react.Component);
	
	RefreshIndicator.defaultProps = {
	  percentage: 0,
	  size: 40,
	  status: 'hide'
	};
	RefreshIndicator.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	RefreshIndicator.propTypes =  false ? {
	  /**
	   * Override the theme's color of the indicator while it's status is
	   * "ready" and it's percentage is less than 100.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * The absolute left position of the indicator in pixels.
	   */
	  left: _propTypes2.default.number.isRequired,
	  /**
	   * Override the theme's color of the indicator while
	   * it's status is "loading" or when it's percentage is 100.
	   */
	  loadingColor: _propTypes2.default.string,
	  /**
	   * The confirmation progress to fetch data. Max value is 100.
	   */
	  percentage: _propTypes2.default.number,
	  /**
	   * Size in pixels.
	   */
	  size: _propTypes2.default.number,
	  /**
	   * The display status of the indicator. If the status is
	   * "ready", the indicator will display the ready state
	   * arrow. If the status is "loading", it will display
	   * the loading progress indicator. If the status is "hide",
	   * the indicator will be hidden.
	   */
	  status: _propTypes2.default.oneOf(['ready', 'loading', 'hide']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The absolute top position of the indicator in pixels.
	   */
	  top: _propTypes2.default.number.isRequired
	} : {};
	exports.default = RefreshIndicator;

/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RefreshIndicator = __webpack_require__(1563);
	
	var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RefreshIndicator2.default;

/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DropDownMenu = __webpack_require__(373);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    label: {
	      paddingLeft: 0,
	      top: props.floatingLabelText ? 6 : -4
	    },
	    icon: {
	      right: 0,
	      top: props.floatingLabelText ? 8 : 0
	    },
	    hideDropDownUnderline: {
	      borderTop: 'none'
	    },
	    dropDownMenu: {
	      display: 'block'
	    }
	  };
	}
	
	var SelectField = function (_Component) {
	  (0, _inherits3.default)(SelectField, _Component);
	
	  function SelectField() {
	    (0, _classCallCheck3.default)(this, SelectField);
	    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SelectField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          multiple = _props.multiple,
	          children = _props.children,
	          style = _props.style,
	          labelStyle = _props.labelStyle,
	          iconStyle = _props.iconStyle,
	          id = _props.id,
	          underlineDisabledStyle = _props.underlineDisabledStyle,
	          underlineFocusStyle = _props.underlineFocusStyle,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          underlineStyle = _props.underlineStyle,
	          dropDownMenuProps = _props.dropDownMenuProps,
	          errorStyle = _props.errorStyle,
	          disabled = _props.disabled,
	          floatingLabelFixed = _props.floatingLabelFixed,
	          floatingLabelText = _props.floatingLabelText,
	          floatingLabelStyle = _props.floatingLabelStyle,
	          hintStyle = _props.hintStyle,
	          hintText = _props.hintText,
	          fullWidth = _props.fullWidth,
	          errorText = _props.errorText,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyle = _props.menuStyle,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          onChange = _props.onChange,
	          selectionRenderer = _props.selectionRenderer,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'multiple', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'menuItemStyle', 'selectedMenuItemStyle', 'underlineStyle', 'dropDownMenuProps', 'errorStyle', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'listStyle', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'selectionRenderer', 'value']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _TextField2.default,
	        (0, _extends3.default)({}, other, {
	          style: style,
	          disabled: disabled,
	          floatingLabelFixed: floatingLabelFixed,
	          floatingLabelText: floatingLabelText,
	          floatingLabelStyle: floatingLabelStyle,
	          hintStyle: hintStyle,
	          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
	          fullWidth: fullWidth,
	          errorText: errorText,
	          underlineStyle: underlineStyle,
	          errorStyle: errorStyle,
	          onFocus: onFocus,
	          onBlur: onBlur,
	          id: id,
	          underlineDisabledStyle: underlineDisabledStyle,
	          underlineFocusStyle: underlineFocusStyle
	        }),
	        _react2.default.createElement(
	          _DropDownMenu2.default,
	          (0, _extends3.default)({
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.dropDownMenu, menuStyle),
	            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
	            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
	            menuItemStyle: menuItemStyle,
	            selectedMenuItemStyle: selectedMenuItemStyle,
	            underlineStyle: styles.hideDropDownUnderline,
	            listStyle: listStyle,
	            autoWidth: autoWidth,
	            value: value,
	            onChange: onChange,
	            maxHeight: maxHeight,
	            multiple: multiple,
	            selectionRenderer: selectionRenderer
	          }, dropDownMenuProps),
	          children
	        )
	      );
	    }
	  }]);
	  return SelectField;
	}(_react.Component);
	
	SelectField.defaultProps = {
	  autoWidth: false,
	  disabled: false,
	  fullWidth: false,
	  multiple: false
	};
	SelectField.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SelectField.propTypes =  false ? {
	  /**
	   * If true, the width will automatically be set according to the
	   * items inside the menu.
	   * To control the width in CSS instead, leave this prop set to `false`.
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The `MenuItem` elements to populate the select field with.
	   * If the menu items have a `label` prop, that value will
	   * represent the selected menu item in the rendered select field.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the select field will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Object that can handle and override any property of component DropDownMenu.
	   */
	  dropDownMenuProps: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the error element.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * If true, the floating label will float even when no value is selected.
	   */
	  floatingLabelFixed: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the floating label.
	   */
	  floatingLabelStyle: _propTypes2.default.object,
	  /**
	   * The content of the floating label.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the select field will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the hint element.
	   */
	  hintStyle: _propTypes2.default.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * The id prop for the text field.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Override the label style when the select field is inactive.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * Override the default max-height of the underlying `DropDownMenu` element.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `DropDownMenu` element.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event Click event targeting the menu item
	   * that was selected.
	   * @param {number} key The index of the selected menu item, or undefined
	   * if `multiple` is true.
	   * @param {any} payload If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Customize the rendering of the selected item.
	   *
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   * @param {any} menuItem The selected `MenuItem`.
	   * If `multiple` is true, this will be an array with the `MenuItem`s matching the `value`s parameter.
	   */
	  selectionRenderer: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element when the select
	   * field is disabled.
	   */
	  underlineDisabledStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element when the select field
	   * is focused.
	   */
	  underlineFocusStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = SelectField;

/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(462);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keycode = __webpack_require__(73);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(382);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Verifies min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if min >= max otherwise null.
	 */
	var minMaxPropType = function minMaxPropType(props, propName, componentName) {
	  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    rest[_key - 3] = arguments[_key];
	  }
	
	  var error = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  if (props.min >= props.max) {
	    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
	    return new Error(errorMsg);
	  }
	};
	
	/**
	 * Verifies value is within the min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
	 */
	var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
	  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	    rest[_key2 - 3] = arguments[_key2];
	  }
	
	  var error = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  var value = props[propName];
	  if (value < props.min || props.max < value) {
	    return new Error(propName + ' should be within the range specified by min and max');
	  }
	};
	
	var crossAxisProperty = {
	  x: 'height',
	  'x-reverse': 'height',
	  y: 'width',
	  'y-reverse': 'width'
	};
	
	var crossAxisOffsetProperty = {
	  x: 'top',
	  'x-reverse': 'top',
	  y: 'left',
	  'y-reverse': 'left'
	};
	
	var mainAxisProperty = {
	  x: 'width',
	  'x-reverse': 'width',
	  y: 'height',
	  'y-reverse': 'height'
	};
	
	var mainAxisMarginFromEnd = {
	  x: 'marginRight',
	  'x-reverse': 'marginLeft',
	  y: 'marginTop',
	  'y-reverse': 'marginBottom'
	};
	
	var mainAxisMarginFromStart = {
	  x: 'marginLeft',
	  'x-reverse': 'marginRight',
	  y: 'marginBottom',
	  'y-reverse': 'marginTop'
	};
	
	var mainAxisOffsetProperty = {
	  x: 'left',
	  'x-reverse': 'right',
	  y: 'bottom',
	  'y-reverse': 'top'
	};
	
	var mainAxisClientProperty = {
	  x: 'clientWidth',
	  'x-reverse': 'clientWidth',
	  y: 'clientHeight',
	  'y-reverse': 'clientHeight'
	};
	
	var mainAxisClientOffsetProperty = {
	  x: 'clientX',
	  'x-reverse': 'clientX',
	  y: 'clientY',
	  'y-reverse': 'clientY'
	};
	
	var reverseMainAxisOffsetProperty = {
	  x: 'right',
	  'x-reverse': 'left',
	  y: 'top',
	  'y-reverse': 'bottom'
	};
	
	var isMouseControlInverted = function isMouseControlInverted(axis) {
	  return axis === 'x-reverse' || axis === 'y';
	};
	
	var calculateAxis = function calculateAxis(axis, isRtl) {
	  if (isRtl) {
	    switch (axis) {
	      case 'x':
	        return 'x-reverse';
	      case 'x-reverse':
	        return 'x';
	    }
	  }
	  return axis;
	};
	
	function getPercent(value, min, max) {
	  var percent = (value - min) / (max - min);
	  if (isNaN(percent)) {
	    percent = 0;
	  }
	
	  return percent;
	}
	
	var getStyles = function getStyles(props, context, state) {
	  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;
	
	  var axis = props.axis,
	      disabled = props.disabled,
	      max = props.max,
	      min = props.min;
	  var _context$muiTheme = context.muiTheme,
	      isRtl = _context$muiTheme.isRtl,
	      _context$muiTheme$sli = _context$muiTheme.slider,
	      handleColorZero = _context$muiTheme$sli.handleColorZero,
	      handleFillColor = _context$muiTheme$sli.handleFillColor,
	      handleSize = _context$muiTheme$sli.handleSize,
	      handleSizeDisabled = _context$muiTheme$sli.handleSizeDisabled,
	      handleSizeActive = _context$muiTheme$sli.handleSizeActive,
	      trackSize = _context$muiTheme$sli.trackSize,
	      trackColor = _context$muiTheme$sli.trackColor,
	      trackColorSelected = _context$muiTheme$sli.trackColorSelected,
	      rippleColor = _context$muiTheme$sli.rippleColor,
	      selectionColor = _context$muiTheme$sli.selectionColor;
	
	
	  var fillGutter = handleSize / 2;
	  var disabledGutter = trackSize + handleSizeDisabled / 2;
	  var calcDisabledSpacing = disabled ? ' - ' + disabledGutter + 'px' : '';
	  var percent = getPercent(state.value, min, max);
	  var calculatedAxis = calculateAxis(axis, isRtl);
	
	  var styles = {
	    slider: (_slider = {
	      touchCallout: 'none',
	      userSelect: 'none',
	      cursor: 'default'
	    }, (0, _defineProperty3.default)(_slider, crossAxisProperty[calculatedAxis], handleSizeActive), (0, _defineProperty3.default)(_slider, mainAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_slider, 'position', 'relative'), (0, _defineProperty3.default)(_slider, 'marginTop', 24), (0, _defineProperty3.default)(_slider, 'marginBottom', 48), _slider),
	    track: (_track = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_track, crossAxisOffsetProperty[calculatedAxis], (handleSizeActive - trackSize) / 2), (0, _defineProperty3.default)(_track, mainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_track, mainAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_track, crossAxisProperty[calculatedAxis], trackSize), _track),
	    filledAndRemaining: (_filledAndRemaining = {
	      directionInvariant: true,
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_filledAndRemaining, crossAxisOffsetProperty, 0), (0, _defineProperty3.default)(_filledAndRemaining, crossAxisProperty[calculatedAxis], '100%'), (0, _defineProperty3.default)(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
	    handle: (_handle = {
	      directionInvariant: true,
	      boxSizing: 'border-box',
	      position: 'absolute',
	      cursor: 'pointer',
	      pointerEvents: 'inherit'
	    }, (0, _defineProperty3.default)(_handle, crossAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_handle, mainAxisOffsetProperty[calculatedAxis], percent === 0 ? '0%' : percent * 100 + '%'), (0, _defineProperty3.default)(_handle, 'zIndex', 1), (0, _defineProperty3.default)(_handle, 'margin', {
	      x: trackSize / 2 + 'px 0 0 0',
	      'x-reverse': trackSize / 2 + 'px 0 0 0',
	      y: '0 0 0 ' + trackSize / 2 + 'px',
	      'y-reverse': '0 0 0 ' + trackSize / 2 + 'px'
	    }[calculatedAxis]), (0, _defineProperty3.default)(_handle, 'width', handleSize), (0, _defineProperty3.default)(_handle, 'height', handleSize), (0, _defineProperty3.default)(_handle, 'backgroundColor', selectionColor), (0, _defineProperty3.default)(_handle, 'backgroundClip', 'padding-box'), (0, _defineProperty3.default)(_handle, 'border', '0px solid transparent'), (0, _defineProperty3.default)(_handle, 'borderRadius', '50%'), (0, _defineProperty3.default)(_handle, 'transform', {
	      x: 'translate(-50%, -50%)',
	      'x-reverse': 'translate(50%, -50%)',
	      y: 'translate(-50%, 50%)',
	      'y-reverse': 'translate(-50%, -50%)'
	    }[calculatedAxis]), (0, _defineProperty3.default)(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), (0, _defineProperty3.default)(_handle, 'overflow', 'visible'), (0, _defineProperty3.default)(_handle, 'outline', 'none'), _handle),
	    handleWhenDisabled: {
	      boxSizing: 'content-box',
	      cursor: 'not-allowed',
	      backgroundColor: trackColor,
	      width: handleSizeDisabled,
	      height: handleSizeDisabled,
	      border: 'none'
	    },
	    handleWhenPercentZero: {
	      border: trackSize + 'px solid ' + handleColorZero,
	      backgroundColor: handleFillColor,
	      boxShadow: 'none'
	    },
	    handleWhenPercentZeroAndDisabled: {
	      cursor: 'not-allowed',
	      width: handleSizeDisabled,
	      height: handleSizeDisabled
	    },
	    handleWhenPercentZeroAndFocused: {
	      border: trackSize + 'px solid ' + trackColorSelected
	    },
	    handleWhenActive: {
	      width: handleSizeActive,
	      height: handleSizeActive
	    },
	    ripple: {
	      height: handleSize,
	      width: handleSize,
	      overflow: 'visible'
	    },
	    rippleWhenPercentZero: {
	      top: -trackSize,
	      left: -trackSize
	    },
	    rippleInner: {
	      height: '300%',
	      width: '300%',
	      top: -handleSize,
	      left: -handleSize
	    },
	    rippleColor: {
	      fill: percent === 0 ? handleColorZero : rippleColor
	    }
	  };
	  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, (0, _defineProperty3.default)(_objectAssign2, mainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_objectAssign2, 'backgroundColor', disabled ? trackColor : selectionColor), (0, _defineProperty3.default)(_objectAssign2, mainAxisMarginFromEnd[calculatedAxis], fillGutter), (0, _defineProperty3.default)(_objectAssign2, mainAxisProperty[calculatedAxis], 'calc(' + percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
	  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, (0, _defineProperty3.default)(_objectAssign3, reverseMainAxisOffsetProperty[calculatedAxis], 0), (0, _defineProperty3.default)(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !disabled ? trackColorSelected : trackColor), (0, _defineProperty3.default)(_objectAssign3, mainAxisMarginFromStart[calculatedAxis], fillGutter), (0, _defineProperty3.default)(_objectAssign3, mainAxisProperty[calculatedAxis], 'calc(' + (1 - percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));
	
	  return styles;
	};
	
	var Slider = function (_Component) {
	  (0, _inherits3.default)(Slider, _Component);
	
	  function Slider() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Slider);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: false,
	      dragging: false,
	      focused: false,
	      hovered: false,
	      value: 0
	    }, _this.track = null, _this.handle = null, _this.resolveValue = function (value, min, max) {
	      if (value > max) {
	        return max;
	      }
	
	      if (value < min) {
	        return min;
	      }
	
	      return value;
	    }, _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          axis = _this$props.axis,
	          min = _this$props.min,
	          max = _this$props.max,
	          step = _this$props.step;
	      var isRtl = _this.context.muiTheme.isRtl;
	
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	
	      var action = void 0;
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'page down':
	        case 'down':
	          if (calculatedAxis === 'y-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'left':
	          if (calculatedAxis === 'x-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'page up':
	        case 'up':
	          if (calculatedAxis === 'y-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'right':
	          if (calculatedAxis === 'x-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'home':
	          action = 'min';
	          break;
	        case 'end':
	          action = 'max';
	          break;
	      }
	
	      if (action) {
	        var newValue = void 0;
	
	        // Cancel scroll
	        event.preventDefault();
	
	        switch (action) {
	          case 'decrease':
	            newValue = _this.state.value - step;
	            break;
	          case 'increase':
	            newValue = _this.state.value + step;
	            break;
	          case 'min':
	            newValue = min;
	            break;
	          case 'max':
	            newValue = max;
	            break;
	        }
	
	        // We need to use toFixed() because of float point errors.
	        // For example, 0.01 + 0.06 = 0.06999999999999999
	        newValue = _this.resolveValue(parseFloat(newValue.toFixed(5)), min, max);
	
	        if (_this.state.value !== newValue) {
	          _this.setState({
	            value: newValue
	          });
	
	          if (_this.props.onChange) {
	            _this.props.onChange(event, newValue);
	          }
	        }
	      }
	    }, _this.handleDragMouseMove = function (event) {
	      _this.onDragUpdate(event, 'mouse');
	    }, _this.handleTouchMove = function (event) {
	      _this.onDragUpdate(event, 'touch');
	    }, _this.handleMouseEnd = function (event) {
	      document.removeEventListener('mousemove', _this.handleDragMouseMove);
	      document.removeEventListener('mouseup', _this.handleMouseEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchEnd = function (event) {
	      document.removeEventListener('touchmove', _this.handleTouchMove);
	      document.removeEventListener('touchup', _this.handleTouchEnd);
	      document.removeEventListener('touchend', _this.handleTouchEnd);
	      document.removeEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchStart = function (event) {
	      var _this$props2 = _this.props,
	          axis = _this$props2.axis,
	          disabled = _this$props2.disabled;
	      var isRtl = _this.context.muiTheme.isRtl;
	
	
	      if (disabled) {
	        return;
	      }
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	
	      var position = void 0;
	      if (isMouseControlInverted(calculatedAxis)) {
	        position = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[calculatedAxis]];
	      } else {
	        position = event.touches[0][mainAxisClientOffsetProperty[calculatedAxis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('touchmove', _this.handleTouchMove);
	      document.addEventListener('touchup', _this.handleTouchEnd);
	      document.addEventListener('touchend', _this.handleTouchEnd);
	      document.addEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStart(event);
	
	      // Cancel scroll and context menu
	      event.preventDefault();
	    }, _this.handleFocus = function (event) {
	      _this.setState({
	        focused: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        focused: false,
	        active: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      var _this$props3 = _this.props,
	          axis = _this$props3.axis,
	          disabled = _this$props3.disabled;
	      var isRtl = _this.context.muiTheme.isRtl;
	
	
	      if (disabled) {
	        return;
	      }
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	
	      var position = void 0;
	      if (isMouseControlInverted(calculatedAxis)) {
	        position = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[calculatedAxis]];
	      } else {
	        position = event[mainAxisClientOffsetProperty[calculatedAxis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('mousemove', _this.handleDragMouseMove);
	      document.addEventListener('mouseup', _this.handleMouseEnd);
	
	      // Cancel text selection
	      event.preventDefault();
	
	      // Set focus manually since we called preventDefault()
	      _this.handle.focus();
	
	      _this.onDragStart(event);
	    }, _this.handleMouseUp = function () {
	      if (!_this.props.disabled) {
	        _this.setState({
	          active: false
	        });
	      }
	    }, _this.handleMouseEnter = function () {
	      _this.setState({
	        hovered: true
	      });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({
	        hovered: false
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Slider, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          defaultValue = _props.defaultValue,
	          min = _props.min,
	          max = _props.max;
	      var value = this.props.value;
	
	
	      if (value === undefined) {
	        value = defaultValue !== undefined ? defaultValue : min;
	      }
	
	      this.setState({
	        value: this.resolveValue(value, min, max)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && !this.state.dragging) {
	        var _nextProps$min = nextProps.min,
	            min = _nextProps$min === undefined ? this.props.min : _nextProps$min,
	            _nextProps$max = nextProps.max,
	            max = _nextProps$max === undefined ? this.props.max : _nextProps$max;
	
	
	        this.setState({
	          value: this.resolveValue(nextProps.value, min, max)
	        });
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: getValue() method is deprecated.\n      Use the onChange callbacks instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      return this.state.value;
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: clearValue() method is deprecated.\n      Use the value property to control the component instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      this.setState({
	        value: this.props.min
	      });
	    }
	  }, {
	    key: 'getTrackOffset',
	    value: function getTrackOffset() {
	      var axis = this.props.axis;
	      var isRtl = this.context.muiTheme.isRtl;
	
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	
	      if (!this.track) return 0;
	      return this.track.getBoundingClientRect()[mainAxisOffsetProperty[calculatedAxis]];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(event) {
	      this.setState({
	        dragging: true,
	        active: true
	      });
	
	      if (this.props.onDragStart) {
	        this.props.onDragStart(event);
	      }
	    }
	  }, {
	    key: 'onDragUpdate',
	    value: function onDragUpdate(event, type) {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          axis = _props2.axis,
	          disabled = _props2.disabled;
	      var isRtl = this.context.muiTheme.isRtl;
	
	
	      if (this.dragRunning) {
	        return;
	      }
	      this.dragRunning = true;
	
	      requestAnimationFrame(function () {
	        _this2.dragRunning = false;
	
	        var calculatedAxis = calculateAxis(axis, isRtl);
	        var source = type === 'touch' ? event.touches[0] : event;
	
	        var position = void 0;
	        if (isMouseControlInverted(calculatedAxis)) {
	          position = _this2.getTrackOffset() - source[mainAxisClientOffsetProperty[calculatedAxis]];
	        } else {
	          position = source[mainAxisClientOffsetProperty[calculatedAxis]] - _this2.getTrackOffset();
	        }
	
	        if (!disabled) {
	          _this2.setValueFromPosition(event, position);
	        }
	      });
	    }
	  }, {
	    key: 'onDragStop',
	    value: function onDragStop(event) {
	      this.setState({
	        dragging: false,
	        active: false
	      });
	
	      if (this.props.onDragStop) {
	        this.props.onDragStop(event);
	      }
	    }
	  }, {
	    key: 'setValueFromPosition',
	    value: function setValueFromPosition(event, position) {
	      var _props3 = this.props,
	          axis = _props3.axis,
	          step = _props3.step,
	          min = _props3.min,
	          max = _props3.max;
	      var isRtl = this.context.muiTheme.isRtl;
	
	
	      var calculatedAxis = calculateAxis(axis, isRtl);
	      var positionMax = this.track[mainAxisClientProperty[calculatedAxis]];
	
	      var value = void 0;
	
	      if (position <= 0) {
	        value = min;
	      } else if (position >= positionMax) {
	        value = max;
	      } else {
	        value = position / positionMax * (max - min);
	        value = Math.round(value / step) * step + min;
	        value = parseFloat(value.toFixed(5));
	      }
	
	      value = this.resolveValue(value, min, max);
	
	      if (this.state.value !== value) {
	        this.setState({
	          value: value
	        });
	
	        if (this.props.onChange) {
	          this.props.onChange(event, value);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props4 = this.props,
	          axis = _props4.axis,
	          disabled = _props4.disabled,
	          disableFocusRipple = _props4.disableFocusRipple,
	          max = _props4.max,
	          min = _props4.min,
	          name = _props4.name,
	          onBlur = _props4.onBlur,
	          onChange = _props4.onChange,
	          onDragStart = _props4.onDragStart,
	          onDragStop = _props4.onDragStop,
	          onFocus = _props4.onFocus,
	          required = _props4.required,
	          sliderStyle = _props4.sliderStyle,
	          step = _props4.step,
	          style = _props4.style,
	          propValue = _props4.value,
	          other = (0, _objectWithoutProperties3.default)(_props4, ['axis', 'disabled', 'disableFocusRipple', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style', 'value']);
	      var _state = this.state,
	          active = _state.active,
	          focused = _state.focused,
	          hovered = _state.hovered,
	          value = _state.value;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var percent = getPercent(value, min, max);
	
	      var handleStyles = {};
	      if (percent === 0) {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, active && styles.handleWhenActive, (hovered || focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
	      } else {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
	      }
	
	      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.slider, sliderStyle)),
	            onFocus: this.handleFocus,
	            onBlur: this.handleBlur,
	            onMouseDown: this.handleMouseDown,
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseUp: this.handleMouseUp,
	            onTouchStart: this.handleTouchStart,
	            onKeyDown: !disabled ? this.handleKeyDown : undefined
	          },
	          _react2.default.createElement(
	            'div',
	            { ref: function ref(node) {
	                return _this3.track = node;
	              }, style: prepareStyles(styles.track) },
	            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
	            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
	            _react2.default.createElement(
	              'div',
	              {
	                ref: function ref(node) {
	                  return _this3.handle = node;
	                },
	                style: prepareStyles(handleStyles),
	                tabIndex: 0
	              },
	              !disabled && !disableFocusRipple && _react2.default.createElement(_FocusRipple2.default, {
	                style: rippleStyle,
	                innerStyle: styles.rippleInner,
	                show: (hovered || focused) && !active,
	                color: styles.rippleColor.fill
	              })
	            )
	          )
	        ),
	        _react2.default.createElement('input', {
	          type: 'hidden',
	          name: name,
	          value: value,
	          required: required,
	          min: min,
	          max: max,
	          step: step
	        })
	      );
	    }
	  }]);
	  return Slider;
	}(_react.Component);
	
	Slider.defaultProps = {
	  axis: 'x',
	  disabled: false,
	  disableFocusRipple: false,
	  max: 1,
	  min: 0,
	  required: true,
	  step: 0.01,
	  style: {}
	};
	Slider.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Slider.propTypes =  false ? {
	  /**
	   * The axis on which the slider will slide.
	   */
	  axis: _propTypes2.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * The default value of the slider.
	   */
	  defaultValue: valueInRangePropType,
	  /**
	   * Disables focus ripple if set to true.
	   */
	  disableFocusRipple: _propTypes2.default.bool,
	  /**
	   * If true, the slider will not be interactable.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The maximum value the slider can slide to on
	   * a scale from 0 to 1 inclusive. Cannot be equal to min.
	   */
	  max: minMaxPropType,
	  /**
	   * The minimum value the slider can slide to on a scale
	   * from 0 to 1 inclusive. Cannot be equal to max.
	   */
	  min: minMaxPropType,
	  /**
	   * The name of the slider. Behaves like the name attribute
	   * of an input element.
	   */
	  name: _propTypes2.default.string,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event KeyDown event targeting the slider.
	   * @param {number} newValue The new value of the slider.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the slider has begun to move.
	   *
	   * @param {object} event MouseDown or TouchStart event targeting the slider.
	   */
	  onDragStart: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the slide has stopped moving.
	   *
	   * @param {object} event MouseEnd or TouchEnd event targeting the slider.
	   */
	  onDragStop: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Whether or not the slider is required in a form.
	   */
	  required: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the inner slider element.
	   */
	  sliderStyle: _propTypes2.default.object,
	  /**
	   * The granularity the slider can step through values.
	   */
	  step: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The value of the slider.
	   */
	  value: valueInRangePropType
	} : {};
	exports.default = Slider;

/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Slider = __webpack_require__(1566);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Slider2.default;

/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ClickAwayListener = __webpack_require__(380);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _SnackbarBody = __webpack_require__(1569);
	
	var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      desktopSubheaderHeight = _context$muiTheme.baseTheme.spacing.desktopSubheaderHeight,
	      zIndex = _context$muiTheme.zIndex;
	  var open = state.open;
	
	
	  var styles = {
	    root: {
	      position: 'fixed',
	      left: '50%',
	      display: 'flex',
	      bottom: 0,
	      zIndex: zIndex.snackbar,
	      visibility: open ? 'visible' : 'hidden',
	      transform: open ? 'translate(-50%, 0)' : 'translate(-50%, ' + desktopSubheaderHeight + 'px)',
	      transition: _transitions2.default.easeOut('400ms', 'transform') + ', ' + _transitions2.default.easeOut('400ms', 'visibility')
	    }
	  };
	
	  return styles;
	}
	
	var Snackbar = function (_Component) {
	  (0, _inherits3.default)(Snackbar, _Component);
	
	  function Snackbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Snackbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.componentClickAway = function () {
	      if (_this.timerTransitionId) {
	        // If transitioning, don't close the snackbar.
	        return;
	      }
	
	      if (_this.props.open !== null && _this.props.onRequestClose) {
	        _this.props.onRequestClose(Snackbar.reasons.CLICKAWAY);
	      } else {
	        _this.setState({ open: false });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Snackbar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open,
	        message: this.props.message,
	        action: this.props.action
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.open) {
	        this.setAutoHideTimer();
	        this.setTransitionTimer();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
	        this.setState({
	          open: false
	        });
	
	        clearTimeout(this.timerOneAtTheTimeId);
	        this.timerOneAtTheTimeId = setTimeout(function () {
	          _this2.setState({
	            message: nextProps.message,
	            action: nextProps.action,
	            open: true
	          });
	        }, 400);
	      } else {
	        var open = nextProps.open;
	
	        this.setState({
	          open: open !== null ? open : this.state.open,
	          message: nextProps.message,
	          action: nextProps.action
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.open !== this.state.open) {
	        if (this.state.open) {
	          this.setAutoHideTimer();
	          this.setTransitionTimer();
	        } else {
	          clearTimeout(this.timerAutoHideId);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerAutoHideId);
	      clearTimeout(this.timerTransitionId);
	      clearTimeout(this.timerOneAtTheTimeId);
	    }
	  }, {
	    key: 'setAutoHideTimer',
	
	
	    // Timer that controls delay before snackbar auto hides
	    value: function setAutoHideTimer() {
	      var _this3 = this;
	
	      var autoHideDuration = this.props.autoHideDuration;
	
	      if (autoHideDuration > 0) {
	        clearTimeout(this.timerAutoHideId);
	        this.timerAutoHideId = setTimeout(function () {
	          if (_this3.props.open !== null && _this3.props.onRequestClose) {
	            _this3.props.onRequestClose(Snackbar.reasons.TIMEOUT);
	          } else {
	            _this3.setState({ open: false });
	          }
	        }, autoHideDuration);
	      }
	    }
	
	    // Timer that controls delay before click-away events are captured (based on when animation completes)
	
	  }, {
	    key: 'setTransitionTimer',
	    value: function setTransitionTimer() {
	      var _this4 = this;
	
	      this.timerTransitionId = setTimeout(function () {
	        _this4.timerTransitionId = undefined;
	      }, 400);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoHideDuration = _props.autoHideDuration,
	          contentStyle = _props.contentStyle,
	          bodyStyle = _props.bodyStyle,
	          messageProp = _props.message,
	          onRequestClose = _props.onRequestClose,
	          onActionClick = _props.onActionClick,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoHideDuration', 'contentStyle', 'bodyStyle', 'message', 'onRequestClose', 'onActionClick', 'style']);
	      var _state = this.state,
	          action = _state.action,
	          message = _state.message,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: open ? this.componentClickAway : null },
	        _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	          _react2.default.createElement(_SnackbarBody2.default, {
	            action: action,
	            contentStyle: contentStyle,
	            message: message,
	            open: open,
	            onActionClick: onActionClick,
	            style: bodyStyle
	          })
	        )
	      );
	    }
	  }]);
	  return Snackbar;
	}(_react.Component);
	
	Snackbar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Snackbar.reasons = {
	  CLICKAWAY: 'clickaway',
	  TIMEOUT: 'timeout'
	};
	Snackbar.propTypes =  false ? {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _propTypes2.default.node,
	  /**
	   * The number of milliseconds to wait before automatically dismissing.
	   * If no value is specified the snackbar will dismiss normally.
	   * If a value is provided the snackbar can still be dismissed normally.
	   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
	   */
	  autoHideDuration: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the body element.
	   */
	  bodyStyle: _propTypes2.default.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _propTypes2.default.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _propTypes2.default.node.isRequired,
	  /**
	   * Fired when the action button is clicked.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionClick: _propTypes2.default.func,
	  /**
	   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
	   * `autoHideDuration` timer expires.
	   *
	   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
	   * `open` prop.
	   *
	   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Snackbar;

/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SnackbarBody = undefined;
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _withWidth = __webpack_require__(1630);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _FlatButton = __webpack_require__(82);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var open = props.open,
	      width = props.width;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      _context$muiTheme$bas2 = _context$muiTheme$bas.spacing,
	      desktopGutter = _context$muiTheme$bas2.desktopGutter,
	      desktopSubheaderHeight = _context$muiTheme$bas2.desktopSubheaderHeight,
	      fontFamily = _context$muiTheme$bas.fontFamily,
	      _context$muiTheme$sna = _context$muiTheme.snackbar,
	      backgroundColor = _context$muiTheme$sna.backgroundColor,
	      textColor = _context$muiTheme$sna.textColor,
	      actionColor = _context$muiTheme$sna.actionColor,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var isSmall = width === _withWidth.SMALL;
	
	  var styles = {
	    root: {
	      fontFamily: fontFamily,
	      backgroundColor: backgroundColor,
	      padding: '0 ' + desktopGutter + 'px',
	      height: desktopSubheaderHeight,
	      lineHeight: desktopSubheaderHeight + 'px',
	      borderRadius: isSmall ? 0 : borderRadius,
	      maxWidth: isSmall ? 'inherit' : 568,
	      minWidth: isSmall ? 'inherit' : 288,
	      width: isSmall ? 'calc(100vw - ' + desktopGutter * 2 + 'px)' : 'auto',
	      flexGrow: isSmall ? 1 : 0
	    },
	    content: {
	      fontSize: 14,
	      color: textColor,
	      opacity: open ? 1 : 0,
	      transition: open ? _transitions2.default.easeOut('500ms', 'opacity', '100ms') : _transitions2.default.easeOut('400ms', 'opacity')
	    },
	    action: {
	      color: actionColor,
	      float: 'right',
	      marginTop: 6,
	      marginRight: -16,
	      marginLeft: desktopGutter,
	      backgroundColor: 'transparent'
	    }
	  };
	
	  return styles;
	}
	
	var SnackbarBody = function SnackbarBody(props, context) {
	  var action = props.action,
	      contentStyle = props.contentStyle,
	      message = props.message,
	      open = props.open,
	      onActionClick = props.onActionClick,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['action', 'contentStyle', 'message', 'open', 'onActionClick', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var actionButton = action && _react2.default.createElement(_FlatButton2.default, {
	    style: styles.action,
	    label: action,
	    onClick: onActionClick
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.content, contentStyle)) },
	      _react2.default.createElement(
	        'span',
	        null,
	        message
	      ),
	      actionButton
	    )
	  );
	};
	
	exports.SnackbarBody = SnackbarBody;
	SnackbarBody.propTypes =  false ? {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _propTypes2.default.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _propTypes2.default.node.isRequired,
	  /**
	   * Fired when the action button is clicked.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * @ignore
	   * Width of the screen.
	   */
	  width: _propTypes2.default.number.isRequired
	} : {};
	
	SnackbarBody.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _withWidth2.default)()(SnackbarBody);

/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Snackbar = __webpack_require__(1568);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Snackbar2.default;

/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var index = _ref.index;
	  var stepper = _ref2.stepper;
	  var orientation = stepper.orientation;
	
	  var styles = {
	    root: {
	      flex: '0 0 auto'
	    }
	  };
	
	  if (index > 0) {
	    if (orientation === 'horizontal') {
	      styles.root.marginLeft = -6;
	    } else if (orientation === 'vertical') {
	      styles.root.marginTop = -14;
	    }
	  }
	
	  return styles;
	};
	
	var Step = function (_Component) {
	  (0, _inherits3.default)(Step, _Component);
	
	  function Step() {
	    var _ref3;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Step.__proto__ || (0, _getPrototypeOf2.default)(Step)).call.apply(_ref3, [this].concat(args))), _this), _this.renderChild = function (child) {
	      var _this$props = _this.props,
	          active = _this$props.active,
	          completed = _this$props.completed,
	          disabled = _this$props.disabled,
	          index = _this$props.index,
	          last = _this$props.last;
	
	
	      var icon = index + 1;
	
	      return _react2.default.cloneElement(child, (0, _simpleAssign2.default)({ active: active, completed: completed, disabled: disabled, icon: icon, last: last }, child.props));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          index = _props.index,
	          last = _props.last,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'completed', 'disabled', 'index', 'last', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.Children.map(children, this.renderChild)
	      );
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	Step.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	Step.propTypes =  false ? {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Should be `Step` sub-components such as `StepLabel`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _propTypes2.default.number,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Step;

/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(84);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _StepLabel = __webpack_require__(602);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isLabel = function isLabel(child) {
	  return child && child.type && child.type.muiName === 'StepLabel';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var hovered = state.hovered;
	  var _context$muiTheme$ste = context.muiTheme.stepper,
	      backgroundColor = _context$muiTheme$ste.backgroundColor,
	      hoverBackgroundColor = _context$muiTheme$ste.hoverBackgroundColor;
	
	
	  var styles = {
	    root: {
	      padding: 0,
	      backgroundColor: hovered ? hoverBackgroundColor : backgroundColor,
	      transition: _transitions2.default.easeOut()
	    }
	  };
	
	  if (context.stepper.orientation === 'vertical') {
	    styles.root.width = '100%';
	  }
	
	  return styles;
	};
	
	var StepButton = function (_Component) {
	  (0, _inherits3.default)(StepButton, _Component);
	
	  function StepButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, StepButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepButton.__proto__ || (0, _getPrototypeOf2.default)(StepButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touched: false
	    }, _this.handleMouseEnter = function (event) {
	      var onMouseEnter = _this.props.onMouseEnter;
	      // Cancel hover styles for touch devices
	
	      if (!_this.state.touched) {
	        _this.setState({ hovered: true });
	      }
	      if (typeof onMouseEnter === 'function') {
	        onMouseEnter(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      _this.setState({ hovered: false });
	      if (typeof onMouseLeave === 'function') {
	        onMouseLeave(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      var onTouchStart = _this.props.onTouchStart;
	
	      if (!_this.state.touched) {
	        _this.setState({ touched: true });
	      }
	      if (typeof onTouchStart === 'function') {
	        onTouchStart(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(StepButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          icon = _props.icon,
	          iconContainerStyle = _props.iconContainerStyle,
	          last = _props.last,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'disabled', 'icon', 'iconContainerStyle', 'last', 'onMouseEnter', 'onMouseLeave', 'onTouchStart', 'style']);
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var child = isLabel(children) ? children : _react2.default.createElement(
	        _StepLabel2.default,
	        null,
	        children
	      );
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart
	        }, other),
	        _react2.default.cloneElement(child, { active: active, completed: completed, disabled: disabled, icon: icon, iconContainerStyle: iconContainerStyle })
	      );
	    }
	  }]);
	  return StepButton;
	}(_react.Component);
	
	StepButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	StepButton.propTypes =  false ? {
	  /**
	   * Passed from `Step` Is passed to StepLabel.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _propTypes2.default.object,
	  /** @ignore */
	  last: _propTypes2.default.bool,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = StepButton;

/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlainStepConnector = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	};
	
	var contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	
	var StepConnector = function StepConnector(props, context) {
	  var muiTheme = context.muiTheme,
	      stepper = context.stepper;
	
	
	  var styles = {
	    wrapper: {
	      flex: '1 1 auto'
	    },
	    line: {
	      display: 'block',
	      borderColor: muiTheme.stepper.connectorLineColor
	    }
	  };
	
	  /**
	   * Clean up once we can use CSS pseudo elements
	   */
	  if (stepper.orientation === 'horizontal') {
	    styles.line.marginLeft = -6;
	    styles.line.borderTopStyle = 'solid';
	    styles.line.borderTopWidth = 1;
	  } else if (stepper.orientation === 'vertical') {
	    styles.wrapper.marginLeft = 14 + 11; // padding + 1/2 icon
	    styles.line.borderLeftStyle = 'solid';
	    styles.line.borderLeftWidth = 1;
	    styles.line.minHeight = 28;
	  }
	
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles(styles.wrapper) },
	    _react2.default.createElement('span', { style: prepareStyles(styles.line) })
	  );
	};
	
	StepConnector.propTypes =  false ? propTypes : {};
	StepConnector.contextTypes = contextTypes;
	
	exports.PlainStepConnector = StepConnector;
	exports.default = (0, _pure2.default)(StepConnector);

/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ExpandTransition = __webpack_require__(1601);
	
	var _ExpandTransition2 = _interopRequireDefault(_ExpandTransition);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExpandTransition(props) {
	  return _react2.default.createElement(_ExpandTransition2.default, props);
	}
	
	var getStyles = function getStyles(props, context) {
	  var styles = {
	    root: {
	      marginTop: -14,
	      marginLeft: 14 + 11, // padding + 1/2 icon
	      paddingLeft: 24 - 11 + 8,
	      paddingRight: 16,
	      overflow: 'hidden'
	    }
	  };
	
	  if (!props.last) {
	    styles.root.borderLeft = '1px solid ' + context.muiTheme.stepper.connectorLineColor;
	  }
	
	  return styles;
	};
	
	var StepContent = function (_Component) {
	  (0, _inherits3.default)(StepContent, _Component);
	
	  function StepContent() {
	    (0, _classCallCheck3.default)(this, StepContent);
	    return (0, _possibleConstructorReturn3.default)(this, (StepContent.__proto__ || (0, _getPrototypeOf2.default)(StepContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StepContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          last = _props.last,
	          style = _props.style,
	          transition = _props.transition,
	          transitionDuration = _props.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'last', 'style', 'transition', 'transitionDuration']);
	      var _context = this.context,
	          stepper = _context.stepper,
	          prepareStyles = _context.muiTheme.prepareStyles;
	
	
	      if (stepper.orientation !== 'vertical') {
	         false ? (0, _warning2.default)(false, 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
	        return null;
	      }
	
	      var styles = getStyles(this.props, this.context);
	      var transitionProps = {
	        enterDelay: transitionDuration,
	        transitionDuration: transitionDuration,
	        open: active
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.createElement(transition, transitionProps, _react2.default.createElement(
	          'div',
	          { style: { overflow: 'hidden' } },
	          children
	        ))
	      );
	    }
	  }]);
	  return StepContent;
	}(_react.Component);
	
	StepContent.defaultProps = {
	  transition: ExpandTransition,
	  transitionDuration: 450
	};
	StepContent.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	StepContent.propTypes =  false ? {
	  /**
	   * Expands the content
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Step content
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * ReactTransitionGroup component.
	   */
	  transition: _propTypes2.default.func,
	  /**
	   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
	   */
	  transitionDuration: _propTypes2.default.number
	} : {};
	exports.default = StepContent;

/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StepConnector = __webpack_require__(1573);
	
	var _StepConnector2 = _interopRequireDefault(_StepConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props) {
	  var orientation = props.orientation;
	
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
	      alignContent: 'center',
	      alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
	      justifyContent: 'space-between'
	    }
	  };
	};
	
	var Stepper = function (_Component) {
	  (0, _inherits3.default)(Stepper, _Component);
	
	  function Stepper() {
	    (0, _classCallCheck3.default)(this, Stepper);
	    return (0, _possibleConstructorReturn3.default)(this, (Stepper.__proto__ || (0, _getPrototypeOf2.default)(Stepper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Stepper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var orientation = this.props.orientation;
	
	      return { stepper: { orientation: orientation } };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeStep = _props.activeStep,
	          children = _props.children,
	          connector = _props.connector,
	          linear = _props.linear,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      /**
	       * One day, we may be able to use real CSS tools
	       * For now, we need to create our own "pseudo" elements
	       * and nth child selectors, etc
	       * That's what some of this garbage is for :)
	       */
	      var numChildren = _react.Children.count(children);
	      var steps = _react.Children.map(children, function (step, index) {
	        if (!_react2.default.isValidElement(step)) {
	          return null;
	        }
	        var controlProps = { index: index };
	
	        if (activeStep === index) {
	          controlProps.active = true;
	        } else if (linear && activeStep > index) {
	          controlProps.completed = true;
	        } else if (linear && activeStep < index) {
	          controlProps.disabled = true;
	        }
	
	        if (index + 1 === numChildren) {
	          controlProps.last = true;
	        }
	
	        return [index > 0 && connector, _react2.default.cloneElement(step, (0, _simpleAssign2.default)(controlProps, step.props))];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        steps
	      );
	    }
	  }]);
	  return Stepper;
	}(_react.Component);
	
	Stepper.defaultProps = {
	  connector: _react2.default.createElement(_StepConnector2.default, null),
	  orientation: 'horizontal',
	  linear: true
	};
	Stepper.contextTypes = { muiTheme: _propTypes2.default.object.isRequired };
	Stepper.childContextTypes = { stepper: _propTypes2.default.object };
	Stepper.propTypes =  false ? {
	  /**
	   * Set the active step (zero based index). This will enable `Step` control helpers.
	   */
	  activeStep: _propTypes2.default.number,
	  /**
	   * Should be two or more `<Step />` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * A component to be placed between each step.
	   */
	  connector: _propTypes2.default.node,
	  /**
	   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
	   */
	  linear: _propTypes2.default.bool,
	  /**
	   * The stepper orientation (layout flow direction)
	   */
	  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Stepper;

/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Subheader = function Subheader(props, context) {
	  var children = props.children,
	      inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      prepareStyles = _context$muiTheme.prepareStyles,
	      subheader = _context$muiTheme.subheader;
	
	
	  var styles = {
	    root: {
	      boxSizing: 'border-box',
	      color: subheader.color,
	      fontSize: 14,
	      fontWeight: subheader.fontWeight,
	      lineHeight: '48px',
	      paddingLeft: inset ? 72 : 16,
	      width: '100%'
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    children
	  );
	};
	
	Subheader.muiName = 'Subheader';
	
	Subheader.propTypes =  false ? {
	  /**
	   * Node that will be placed inside the `Subheader`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the `Subheader` will be indented.
	   */
	  inset: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	Subheader.defaultProps = {
	  inset: false
	};
	
	Subheader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Subheader;

/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgIcon = function (_Component) {
	  (0, _inherits3.default)(SvgIcon, _Component);
	
	  function SvgIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SvgIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SvgIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          color = _props.color,
	          hoverColor = _props.hoverColor,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          style = _props.style,
	          viewBox = _props.viewBox,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	      var _context$muiTheme = this.context.muiTheme,
	          svgIcon = _context$muiTheme.svgIcon,
	          prepareStyles = _context$muiTheme.prepareStyles;
	
	
	      var offColor = color ? color : 'currentColor';
	      var onColor = hoverColor ? hoverColor : offColor;
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        display: 'inline-block',
	        color: svgIcon.color,
	        fill: this.state.hovered ? onColor : offColor,
	        height: 24,
	        width: 24,
	        userSelect: 'none',
	        transition: _transitions2.default.easeOut()
	      }, style);
	
	      return _react2.default.createElement(
	        'svg',
	        (0, _extends3.default)({}, other, {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: prepareStyles(mergedStyles),
	          viewBox: viewBox
	        }),
	        children
	      );
	    }
	  }]);
	  return SvgIcon;
	}(_react.Component);
	
	SvgIcon.muiName = 'SvgIcon';
	SvgIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  viewBox: '0 0 24 24'
	};
	SvgIcon.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SvgIcon.propTypes =  false ? {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * This is the fill color of the svg icon.
	   * If not specified, this component will default
	   * to muiTheme.palette.textColor.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _propTypes2.default.string,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Allows you to redefine what the coordinates
	   * without units mean inside an svg element. For example,
	   * if the SVG element is 500 (width) by 200 (height), and you
	   * pass viewBox="0 0 50 20", this means that the coordinates inside
	   * the svg will go from the top left corner (0,0) to bottom right (50,20)
	   * and each unit will be worth 10px.
	   */
	  viewBox: _propTypes2.default.string
	} : {};
	exports.default = SvgIcon;

/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      table = _context$muiTheme.table;
	
	
	  return {
	    root: {
	      backgroundColor: table.backgroundColor,
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      tableLayout: 'fixed',
	      fontFamily: baseTheme.fontFamily
	    },
	    bodyTable: {
	      height: props.fixedHeader || props.fixedFooter ? props.height : 'auto',
	      overflowX: 'hidden',
	      overflowY: 'auto'
	    },
	    tableWrapper: {
	      height: props.fixedHeader || props.fixedFooter ? 'auto' : props.height,
	      overflow: 'auto'
	    }
	  };
	}
	
	var Table = function (_Component) {
	  (0, _inherits3.default)(Table, _Component);
	
	  function Table() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Table);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      allRowsSelected: false
	    }, _this.onCellClick = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellClick) _this.props.onCellClick(rowNumber, columnNumber, event);
	    }, _this.onCellHover = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHover) _this.props.onCellHover(rowNumber, columnNumber, event);
	    }, _this.onCellHoverExit = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(rowNumber, columnNumber, event);
	    }, _this.onRowHover = function (rowNumber) {
	      if (_this.props.onRowHover) _this.props.onRowHover(rowNumber);
	    }, _this.onRowHoverExit = function (rowNumber) {
	      if (_this.props.onRowHoverExit) _this.props.onRowHoverExit(rowNumber);
	    }, _this.onRowSelection = function (selectedRows) {
	      if (_this.state.allRowsSelected) {
	        _this.setState({ allRowsSelected: false });
	      }
	
	      if (_this.props.onRowSelection) {
	        _this.props.onRowSelection(selectedRows);
	      }
	    }, _this.onSelectAll = function () {
	      if (_this.props.onRowSelection) {
	        if (!_this.state.allRowsSelected) {
	          _this.props.onRowSelection('all');
	        } else {
	          _this.props.onRowSelection('none');
	        }
	      }
	
	      _this.setState({ allRowsSelected: !_this.state.allRowsSelected });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Table, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.allRowsSelected) {
	        this.setState({ allRowsSelected: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
	        this.setState({ allRowsSelected: nextProps.allRowsSelected });
	      }
	    }
	  }, {
	    key: 'isScrollbarVisible',
	    value: function isScrollbarVisible() {
	      var tableDivHeight = this.refs.tableDiv.clientHeight;
	      var tableBodyHeight = this.refs.tableBody.clientHeight;
	
	      return tableBodyHeight > tableDivHeight;
	    }
	  }, {
	    key: 'createTableHeader',
	    value: function createTableHeader(base) {
	      return _react2.default.cloneElement(base, {
	        enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
	        onSelectAll: this.onSelectAll,
	        selectAllSelected: this.state.allRowsSelected
	      });
	    }
	  }, {
	    key: 'createTableBody',
	    value: function createTableBody(base) {
	      return _react2.default.cloneElement(base, {
	        allRowsSelected: this.state.allRowsSelected,
	        multiSelectable: this.props.multiSelectable,
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowSelection: this.onRowSelection,
	        selectable: this.props.selectable
	      });
	    }
	  }, {
	    key: 'createTableFooter',
	    value: function createTableFooter(base) {
	      return base;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          fixedFooter = _props.fixedFooter,
	          fixedHeader = _props.fixedHeader,
	          style = _props.style,
	          wrapperStyle = _props.wrapperStyle,
	          headerStyle = _props.headerStyle,
	          bodyStyle = _props.bodyStyle,
	          footerStyle = _props.footerStyle;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var tHead = void 0;
	      var tFoot = void 0;
	      var tBody = void 0;
	
	      _react2.default.Children.forEach(children, function (child) {
	        if (!_react2.default.isValidElement(child)) return;
	
	        var muiName = child.type.muiName;
	
	        if (muiName === 'TableBody') {
	          tBody = _this2.createTableBody(child);
	        } else if (muiName === 'TableHeader') {
	          tHead = _this2.createTableHeader(child);
	        } else if (muiName === 'TableFooter') {
	          tFoot = _this2.createTableFooter(child);
	        } else {
	           false ? (0, _warning2.default)(false, 'Material-UI: Children of the Table component must be TableBody or TableHeader or TableFooter.\n           Nothing is rendered.') : void 0;
	        }
	      });
	
	      // If we could not find a table-header and a table-body, do not attempt to display anything.
	      if (!tBody && !tHead) return null;
	
	      var mergedTableStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var headerTable = void 0;
	      var footerTable = void 0;
	      var inlineHeader = void 0;
	      var inlineFooter = void 0;
	
	      if (fixedHeader) {
	        headerTable = _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, headerStyle)) },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle },
	            tHead
	          )
	        );
	      } else {
	        inlineHeader = tHead;
	      }
	
	      if (tFoot !== undefined) {
	        if (fixedFooter) {
	          footerTable = _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, footerStyle)) },
	            _react2.default.createElement(
	              'table',
	              { className: className, style: prepareStyles(mergedTableStyle) },
	              tFoot
	            )
	          );
	        } else {
	          inlineFooter = tFoot;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.tableWrapper, wrapperStyle)) },
	        headerTable,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.bodyTable, bodyStyle)), ref: 'tableDiv' },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle, ref: 'tableBody' },
	            inlineHeader,
	            inlineFooter,
	            tBody
	          )
	        ),
	        footerTable
	      );
	    }
	  }]);
	  return Table;
	}(_react.Component);
	
	Table.defaultProps = {
	  allRowsSelected: false,
	  fixedFooter: true,
	  fixedHeader: true,
	  height: 'inherit',
	  multiSelectable: false,
	  selectable: true
	};
	Table.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Table.propTypes =  false ? {
	  /**
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the body's table element.
	   */
	  bodyStyle: _propTypes2.default.object,
	  /**
	   * Children passed to table.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the footer will appear fixed below the table.
	   * The default value is true.
	   */
	  fixedFooter: _propTypes2.default.bool,
	  /**
	   * If true, the header will appear fixed above the table.
	   * The default value is true.
	   */
	  fixedHeader: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the footer's table element.
	   */
	  footerStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the header's table element.
	   */
	  headerStyle: _propTypes2.default.object,
	  /**
	   * The height of the table.
	   */
	  height: _propTypes2.default.string,
	  /**
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _propTypes2.default.bool,
	  /**
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _propTypes2.default.func,
	  /**
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _propTypes2.default.func,
	  /**
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _propTypes2.default.func,
	  /**
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _propTypes2.default.func,
	  /**
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _propTypes2.default.func,
	  /**
	   * Called when a row is selected.
	   * selectedRows is an array of all row selections.
	   * IF all rows have been selected, the string "all"
	   * will be returned instead to indicate that all rows have been selected.
	   */
	  onRowSelection: _propTypes2.default.func,
	  /**
	   * If true, table rows can be selected.
	   * If multiple row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the table's wrapper element.
	   */
	  wrapperStyle: _propTypes2.default.object
	} : {};
	exports.default = Table;

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      inkBar = _context$muiTheme.inkBar,
	      isRtl = _context$muiTheme.isRtl;
	
	
	  return {
	    root: {
	      left: props.left,
	      width: props.width,
	      bottom: 0,
	      display: 'block',
	      backgroundColor: props.color || inkBar.backgroundColor,
	      height: 2,
	      marginTop: -2,
	      position: 'relative',
	      transition: _transitions2.default.easeOut('1s', isRtl ? 'right' : 'left')
	    }
	  };
	}
	
	var InkBar = function (_Component) {
	  (0, _inherits3.default)(InkBar, _Component);
	
	  function InkBar() {
	    (0, _classCallCheck3.default)(this, InkBar);
	    return (0, _possibleConstructorReturn3.default)(this, (InkBar.__proto__ || (0, _getPrototypeOf2.default)(InkBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InkBar, [{
	    key: 'render',
	    value: function render() {
	      var style = this.props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
	    }
	  }]);
	  return InkBar;
	}(_react.Component);
	
	InkBar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	InkBar.propTypes =  false ? {
	  color: _propTypes2.default.string,
	  left: _propTypes2.default.string.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  width: _propTypes2.default.string.isRequired
	} : {};
	exports.default = InkBar;

/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  width: '100%',
	  position: 'relative',
	  textAlign: 'initial'
	};
	
	var TabTemplate = function TabTemplate(_ref) {
	  var children = _ref.children,
	      selected = _ref.selected,
	      style = _ref.style;
	
	  var templateStyle = (0, _simpleAssign2.default)({}, styles, style);
	  if (!selected) {
	    templateStyle.height = 0;
	    templateStyle.overflow = 'hidden';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: templateStyle },
	    children
	  );
	};
	
	TabTemplate.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  selected: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	} : {};
	
	exports.default = TabTemplate;

/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _TabTemplate = __webpack_require__(1580);
	
	var _TabTemplate2 = _interopRequireDefault(_TabTemplate);
	
	var _InkBar = __webpack_require__(1579);
	
	var _InkBar2 = _interopRequireDefault(_InkBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    tabItemContainer: {
	      width: '100%',
	      backgroundColor: tabs.backgroundColor,
	      whiteSpace: 'nowrap',
	      display: 'flex'
	    }
	  };
	}
	
	var Tabs = function (_Component) {
	  (0, _inherits3.default)(Tabs, _Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabClick = function (value, event, tab) {
	      var valueLink = _this.getValueLink(_this.props);
	      var index = tab.props.index;
	
	      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
	        valueLink.requestChange(value, event, tab);
	      }
	
	      _this.setState({ selectedIndex: index });
	
	      if (tab.props.onActive) {
	        tab.props.onActive(tab);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tabs, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var valueLink = this.getValueLink(this.props);
	      var initialIndex = this.props.initialSelectedIndex;
	
	      this.setState({
	        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps, nextContext) {
	      var valueLink = this.getValueLink(newProps);
	      var newState = {
	        muiTheme: nextContext.muiTheme || this.context.muiTheme
	      };
	
	      if (valueLink.value !== undefined) {
	        newState.selectedIndex = this.getSelectedIndex(newProps);
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'getTabs',
	    value: function getTabs() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var tabs = [];
	
	      _react.Children.forEach(props.children, function (tab) {
	        if ((0, _react.isValidElement)(tab)) {
	          tabs.push(tab);
	        }
	      });
	
	      return tabs;
	    }
	  }, {
	    key: 'getTabCount',
	    value: function getTabCount() {
	      return this.getTabs().length;
	    }
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	
	  }, {
	    key: 'getValueLink',
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props) {
	      var valueLink = this.getValueLink(props);
	      var selectedIndex = -1;
	
	      this.getTabs(props).forEach(function (tab, index) {
	        if (valueLink.value === tab.props.value) {
	          selectedIndex = index;
	        }
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected(tab, index) {
	      var valueLink = this.getValueLink(this.props);
	      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          contentContainerClassName = _props.contentContainerClassName,
	          contentContainerStyle = _props.contentContainerStyle,
	          initialSelectedIndex = _props.initialSelectedIndex,
	          inkBarStyle = _props.inkBarStyle,
	          inkBarContainerStyle = _props.inkBarContainerStyle,
	          onChange = _props.onChange,
	          style = _props.style,
	          tabItemContainerStyle = _props.tabItemContainerStyle,
	          tabTemplate = _props.tabTemplate,
	          tabTemplateStyle = _props.tabTemplateStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'inkBarContainerStyle', 'onChange', 'style', 'tabItemContainerStyle', 'tabTemplate', 'tabTemplateStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var valueLink = this.getValueLink(this.props);
	      var tabValue = valueLink.value;
	      var tabContent = [];
	      var width = 100 / this.getTabCount();
	
	      var tabs = this.getTabs().map(function (tab, index) {
	         false ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Material-UI: Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;
	
	         false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Material-UI: Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;
	
	        tabContent.push(tab.props.children ? (0, _react.createElement)(tabTemplate || _TabTemplate2.default, {
	          key: index,
	          selected: _this2.getSelected(tab, index),
	          style: tabTemplateStyle
	        }, tab.props.children) : undefined);
	
	        return (0, _react.cloneElement)(tab, {
	          key: index,
	          index: index,
	          selected: _this2.getSelected(tab, index),
	          width: width + '%',
	          onClick: _this2.handleTabClick
	        });
	      });
	
	      var realSelectedIndex = valueLink.value ? this.getSelectedIndex(this.props) : this.state.selectedIndex;
	
	      var inkBar = realSelectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
	        left: width * realSelectedIndex + '%',
	        width: width + '%',
	        style: inkBarStyle
	      }) : null;
	
	      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
	          tabs
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)({ width: inkBarContainerWidth }, inkBarContainerStyle)) },
	          inkBar
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
	            className: contentContainerClassName
	          },
	          tabContent
	        )
	      );
	    }
	  }]);
	  return Tabs;
	}(_react.Component);
	
	Tabs.defaultProps = {
	  initialSelectedIndex: 0,
	  onChange: function onChange() {}
	};
	Tabs.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Tabs.propTypes =  false ? {
	  /**
	   * Should be used to pass `Tab` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The css class name of the content's container.
	   */
	  contentContainerClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the content's container.
	   */
	  contentContainerStyle: _propTypes2.default.object,
	  /**
	   * Specify initial visible tab index.
	   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
	   * `initialSelectedIndex` will revert back to default.
	   * If `initialSelectedIndex` is set to any negative value, no tab will be selected intially.
	   */
	  initialSelectedIndex: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the InkBar.
	   */
	  inkBarStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the InkBar container.
	   */
	  inkBarContainerStyle: _propTypes2.default.object,
	  /**
	   * Called when the selected value change.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the tab-labels container.
	   */
	  tabItemContainerStyle: _propTypes2.default.object,
	  /**
	   * Override the default tab template used to wrap the content of each tab element.
	   */
	  tabTemplate: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the tab template.
	   */
	  tabTemplateStyle: _propTypes2.default.object,
	  /**
	   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = Tabs;

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Tabs = exports.Tab = undefined;
	
	var _Tab2 = __webpack_require__(607);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Tabs2 = __webpack_require__(1581);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tab = _Tab3.default;
	exports.Tabs = _Tabs3.default;
	exports.default = _Tabs3.default;

/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(100);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowsHeight = 24;
	
	function getStyles(props, context, state) {
	  return {
	    root: {
	      position: 'relative' // because the shadow has position: 'absolute'
	    },
	    textarea: {
	      height: state.height,
	      width: '100%',
	      resize: 'none',
	      font: 'inherit',
	      padding: 0,
	      cursor: 'inherit'
	    },
	    shadow: {
	      resize: 'none',
	      // Overflow also needed to here to remove the extra row
	      // added to textareas in Firefox.
	      overflow: 'hidden',
	      // Visibility needed to hide the extra text area on ipads
	      visibility: 'hidden',
	      position: 'absolute',
	      height: 'auto'
	    }
	  };
	}
	
	var EnhancedTextarea = function (_Component) {
	  (0, _inherits3.default)(EnhancedTextarea, _Component);
	
	  function EnhancedTextarea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedTextarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.handleResize = function (event) {
	      _this.syncHeightWithShadow(_this.props.value, event);
	    }, _this.handleChange = function (event) {
	      if (!_this.props.hasOwnProperty('value')) {
	        _this.syncHeightWithShadow(event.target.value);
	      }
	
	      if (_this.props.hasOwnProperty('valueLink')) {
	        _this.props.valueLink.requestChange(event.target.value);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        height: this.props.rows * rowsHeight
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow(this.props.value);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value || nextProps.rowsMax !== this.props.rowsMax) {
	        this.syncHeightWithShadow(nextProps.value, null, nextProps);
	      }
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.getInputNode().value = value;
	      this.syncHeightWithShadow(value);
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(newValue, event, props) {
	      var shadow = this.refs.shadow;
	      var displayText = this.props.hintText && (newValue === '' || newValue === undefined || newValue === null) ? this.props.hintText : newValue;
	
	      if (displayText !== undefined) {
	        shadow.value = displayText;
	      }
	
	      var newHeight = shadow.scrollHeight;
	
	      // Guarding for jsdom, where scrollHeight isn't present.
	      // See https://github.com/tmpvar/jsdom/issues/1013
	      if (newHeight === undefined) return;
	
	      props = props || this.props;
	
	      if (props.rowsMax >= props.rows) {
	        newHeight = Math.min(props.rowsMax * rowsHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, rowsHeight);
	
	      if (this.state.height !== newHeight) {
	        var input = this.refs.input;
	        var cursorPosition = input.selectionEnd;
	        this.setState({
	          height: newHeight
	        }, function () {
	          input.setSelectionRange(cursorPosition, cursorPosition);
	        });
	
	        if (props.onHeightChange) {
	          props.onHeightChange(event, newHeight);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          onHeightChange = _props.onHeightChange,
	          rows = _props.rows,
	          rowsMax = _props.rowsMax,
	          shadowStyle = _props.shadowStyle,
	          style = _props.style,
	          hintText = _props.hintText,
	          textareaStyle = _props.textareaStyle,
	          valueLink = _props.valueLink,
	          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'hintText', 'textareaStyle', 'valueLink']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
	      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
	      var props = {};
	
	      if (this.props.hasOwnProperty('valueLink')) {
	        other.value = valueLink.value;
	        props.valueLink = valueLink;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(rootStyles) },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', (0, _extends3.default)({
	          ref: 'shadow',
	          style: prepareStyles(shadowStyles),
	          tabIndex: '-1',
	          rows: this.props.rows,
	          defaultValue: this.props.defaultValue,
	          readOnly: true,
	          value: this.props.value
	        }, props)),
	        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
	          ref: 'input',
	          rows: this.props.rows,
	          style: prepareStyles(textareaStyles),
	          onChange: this.handleChange
	        }))
	      );
	    }
	  }]);
	  return EnhancedTextarea;
	}(_react.Component);
	
	EnhancedTextarea.defaultProps = {
	  rows: 1
	};
	EnhancedTextarea.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	EnhancedTextarea.propTypes =  false ? {
	  defaultValue: _propTypes2.default.any,
	  disabled: _propTypes2.default.bool,
	  hintText: _propTypes2.default.node,
	  onChange: _propTypes2.default.func,
	  onHeightChange: _propTypes2.default.func,
	  rows: _propTypes2.default.number,
	  rowsMax: _propTypes2.default.number,
	  shadowStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  textareaStyle: _propTypes2.default.object,
	  value: _propTypes2.default.string,
	  valueLink: _propTypes2.default.object
	} : {};
	exports.default = EnhancedTextarea;

/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(140);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedTextarea = __webpack_require__(1583);
	
	var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);
	
	var _TextFieldHint = __webpack_require__(1585);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(1586);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(1587);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      _context$muiTheme$tex = _context$muiTheme.textField,
	      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
	      focusColor = _context$muiTheme$tex.focusColor,
	      textColor = _context$muiTheme$tex.textColor,
	      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
	      backgroundColor = _context$muiTheme$tex.backgroundColor,
	      errorColor = _context$muiTheme$tex.errorColor;
	
	
	  var styles = {
	    root: {
	      fontSize: 16,
	      lineHeight: '24px',
	      width: props.fullWidth ? '100%' : 256,
	      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	      display: 'inline-block',
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      fontFamily: baseTheme.fontFamily,
	      transition: _transitions2.default.easeOut('200ms', 'height'),
	      cursor: props.disabled ? 'not-allowed' : 'auto'
	    },
	    error: {
	      position: 'relative',
	      bottom: 2,
	      fontSize: 12,
	      lineHeight: '12px',
	      color: errorColor,
	      transition: _transitions2.default.easeOut()
	    },
	    floatingLabel: {
	      color: props.disabled ? disabledTextColor : floatingLabelColor,
	      pointerEvents: 'none'
	    },
	    input: {
	      padding: 0,
	      position: 'relative',
	      width: '100%',
	      border: 'none',
	      outline: 'none',
	      backgroundColor: 'rgba(0,0,0,0)',
	      color: props.disabled ? disabledTextColor : textColor,
	      cursor: 'inherit',
	      font: 'inherit',
	      WebkitOpacity: 1,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' // Remove mobile color flashing (deprecated style).
	    },
	    inputNative: {
	      appearance: 'textfield' // Improve type search style.
	    }
	  };
	
	  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
	    marginTop: props.floatingLabelText ? 36 : 12,
	    marginBottom: props.floatingLabelText ? -36 : -12,
	    boxSizing: 'border-box',
	    font: 'inherit'
	  });
	
	  // Do not assign a height to the textarea as he handles it on his own.
	  styles.input.height = '100%';
	
	  if (state.isFocused) {
	    styles.floatingLabel.color = focusColor;
	  }
	
	  if (props.floatingLabelText) {
	    styles.input.boxSizing = 'border-box';
	
	    if (!props.multiLine) {
	      styles.input.marginTop = 14;
	    }
	
	    if (state.errorText) {
	      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	    }
	  }
	
	  if (state.errorText) {
	    if (state.isFocused) {
	      styles.floatingLabel.color = styles.error.color;
	    }
	  }
	
	  return styles;
	};
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
	}
	
	var TextField = function (_Component) {
	  (0, _inherits3.default)(TextField, _Component);
	
	  function TextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFocused: false,
	      errorText: undefined,
	      hasValue: false
	    }, _this.handleInputBlur = function (event) {
	      _this.setState({ isFocused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleInputChange = function (event) {
	      if (!_this.props.hasOwnProperty('value')) {
	        _this.setState({ hasValue: isValid(event.target.value) });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(event, event.target.value);
	      }
	    }, _this.handleInputFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	      _this.setState({ isFocused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleHeightChange = function (event, height) {
	      var newHeight = height + 24;
	      if (_this.props.floatingLabelText) {
	        newHeight += 24;
	      }
	      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          hintText = _props.hintText,
	          floatingLabelText = _props.floatingLabelText,
	          id = _props.id;
	
	
	      var propsLeaf = children ? children.props : this.props;
	
	      this.setState({
	        errorText: this.props.errorText,
	        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
	      });
	
	       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;
	
	      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
	      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled && !this.props.disabled) {
	        this.setState({
	          isFocused: false
	        });
	      }
	
	      if (nextProps.errorText !== this.props.errorText) {
	        this.setState({
	          errorText: nextProps.errorText
	        });
	      }
	
	      if (nextProps.children && nextProps.children.props) {
	        nextProps = nextProps.children.props;
	      }
	
	      if (nextProps.hasOwnProperty('value')) {
	        var hasValue = isValid(nextProps.value);
	
	        this.setState({
	          hasValue: hasValue
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      if (this.input) {
	        this.getInputNode().blur();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) {
	        this.getInputNode().focus();
	      }
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      if (this.input) {
	        this.getInputNode().select();
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input ? this.getInputNode().value : undefined;
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
	    }
	  }, {
	    key: '_isControlled',
	    value: function _isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          errorStyle = _props2.errorStyle,
	          errorText = _props2.errorText,
	          floatingLabelFixed = _props2.floatingLabelFixed,
	          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
	          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
	          floatingLabelStyle = _props2.floatingLabelStyle,
	          floatingLabelText = _props2.floatingLabelText,
	          fullWidth = _props2.fullWidth,
	          hintText = _props2.hintText,
	          hintStyle = _props2.hintStyle,
	          id = _props2.id,
	          inputStyle = _props2.inputStyle,
	          multiLine = _props2.multiLine,
	          onBlur = _props2.onBlur,
	          onChange = _props2.onChange,
	          onFocus = _props2.onFocus,
	          style = _props2.style,
	          type = _props2.type,
	          underlineDisabledStyle = _props2.underlineDisabledStyle,
	          underlineFocusStyle = _props2.underlineFocusStyle,
	          underlineShow = _props2.underlineShow,
	          underlineStyle = _props2.underlineStyle,
	          rows = _props2.rows,
	          rowsMax = _props2.rowsMax,
	          textareaStyle = _props2.textareaStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var inputId = id || this.uniqueId;
	
	      var errorTextElement = this.state.errorText && _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
	        this.state.errorText
	      );
	
	      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
	        _TextFieldLabel2.default,
	        {
	          muiTheme: this.context.muiTheme,
	          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
	          shrinkStyle: floatingLabelShrinkStyle,
	          htmlFor: inputId,
	          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
	          disabled: disabled
	        },
	        floatingLabelText
	      );
	
	      var inputProps = {
	        id: inputId,
	        ref: function ref(elem) {
	          return _this2.input = elem;
	        },
	        disabled: this.props.disabled,
	        onBlur: this.handleInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus
	      };
	
	      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);
	
	      var inputElement = void 0;
	      if (children) {
	        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
	          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
	        }));
	      } else {
	        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
	          style: childStyleMerged,
	          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
	          rows: rows,
	          rowsMax: rowsMax,
	          hintText: hintText
	        }, other, inputProps, {
	          onHeightChange: this.handleHeightChange
	        })) : _react2.default.createElement('input', (0, _extends3.default)({
	          type: type,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
	        }, other, inputProps));
	      }
	
	      var rootProps = {};
	
	      if (children) {
	        rootProps = other;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, rootProps, {
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }),
	        floatingLabelTextElement,
	        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	          muiTheme: this.context.muiTheme,
	          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
	          style: hintStyle,
	          text: hintText
	        }) : null,
	        inputElement,
	        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	          disabled: disabled,
	          disabledStyle: underlineDisabledStyle,
	          error: !!this.state.errorText,
	          errorStyle: errorStyle,
	          focus: this.state.isFocused,
	          focusStyle: underlineFocusStyle,
	          muiTheme: this.context.muiTheme,
	          style: underlineStyle
	        }) : null,
	        errorTextElement
	      );
	    }
	  }]);
	  return TextField;
	}(_react.Component);
	
	TextField.defaultProps = {
	  disabled: false,
	  floatingLabelFixed: false,
	  multiLine: false,
	  fullWidth: false,
	  type: 'text',
	  underlineShow: true,
	  rows: 1
	};
	TextField.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TextField.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The text string to use for the default value.
	   */
	  defaultValue: _propTypes2.default.any,
	  /**
	   * Disables the text field if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The style object to use to override error styles.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * If true, the floating label will float even when there is no value.
	   */
	  floatingLabelFixed: _propTypes2.default.bool,
	  /**
	   * The style object to use to override floating label styles when focused.
	   */
	  floatingLabelFocusStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override floating label styles when shrunk.
	   */
	  floatingLabelShrinkStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override floating label styles.
	   */
	  floatingLabelStyle: _propTypes2.default.object,
	  /**
	   * The content to use for the floating label element.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the field receives the property width 100%.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the TextField's hint text element.
	   */
	  hintStyle: _propTypes2.default.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * The id prop for the text field.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the TextField's input element.
	   * When multiLine is false: define the style of the input element.
	   * When multiLine is true: define the style of the container of the textarea.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * If true, a textarea element will be rendered.
	   * The textarea also grows and shrinks according to the number of lines.
	   */
	  multiLine: _propTypes2.default.bool,
	  /**
	   * Name applied to the input.
	   */
	  name: _propTypes2.default.string,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the textfield's value changes.
	   *
	   * @param {object} event Change event targeting the text field.
	   * @param {string} newValue The new value of the text field.
	   */
	  onChange: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Number of rows to display when multiLine option is set to true.
	   */
	  rows: _propTypes2.default.number,
	  /**
	   * Maximum number of rows to display when
	   * multiLine option is set to true.
	   */
	  rowsMax: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the TextField's textarea element.
	   * The TextField use either a textarea or an input,
	   * this property has effects only when multiLine is true.
	   */
	  textareaStyle: _propTypes2.default.object,
	  /**
	   * Specifies the type of input to display
	   * such as "password" or "text".
	   */
	  type: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the
	   * TextField's underline element when disabled.
	   */
	  underlineDisabledStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the TextField's
	   * underline element when focussed.
	   */
	  underlineFocusStyle: _propTypes2.default.object,
	  /**
	   * If true, shows the underline for the text field.
	   */
	  underlineShow: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the TextField's underline element.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * The value of the text field.
	   */
	  value: _propTypes2.default.any
	} : {};
	exports.default = TextField;

/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var hintColor = props.muiTheme.textField.hintColor,
	      show = props.show;
	
	
	  return {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	}
	
	var TextFieldHint = function TextFieldHint(props) {
	  var prepareStyles = props.muiTheme.prepareStyles,
	      style = props.style,
	      text = props.text;
	
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	    text
	  );
	};
	
	TextFieldHint.propTypes =  false ? {
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The hint text displayed.
	   */
	  text: _propTypes2.default.node
	} : {};
	
	TextFieldHint.defaultProps = {
	  show: true
	};
	
	exports.default = TextFieldHint;

/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var defaultStyles = {
	    position: 'absolute',
	    lineHeight: '22px',
	    top: 38,
	    transition: _transitions2.default.easeOut(),
	    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	    transform: 'scale(1) translate(0, 0)',
	    transformOrigin: 'left top',
	    pointerEvents: 'auto',
	    userSelect: 'none'
	  };
	
	  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
	    transform: 'scale(0.75) translate(0, -28px)',
	    pointerEvents: 'none'
	  }, props.shrinkStyle) : null;
	
	  return {
	    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
	  };
	}
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme,
	      className = props.className,
	      children = props.children,
	      htmlFor = props.htmlFor,
	      onClick = props.onClick;
	  var prepareStyles = muiTheme.prepareStyles;
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: prepareStyles(styles.root),
	      htmlFor: htmlFor,
	      onClick: onClick
	    },
	    children
	  );
	};
	
	TextFieldLabel.propTypes =  false ? {
	  /**
	   * The label contents.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _propTypes2.default.string,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * Callback function for when the label is selected via a click.
	   *
	   * @param {object} event Click event targeting the text field label.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element when shrunk.
	   */
	  shrinkStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	TextFieldLabel.defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	exports.default = TextFieldLabel;

/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _propTypes2.default.object,
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled,
	      disabledStyle = props.disabledStyle,
	      error = props.error,
	      errorStyle = props.errorStyle,
	      focus = props.focus,
	      focusStyle = props.focusStyle,
	      muiTheme = props.muiTheme,
	      style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var prepareStyles = muiTheme.prepareStyles,
	      _muiTheme$textField = muiTheme.textField,
	      borderColor = _muiTheme$textField.borderColor,
	      disabledTextColor = _muiTheme$textField.disabledTextColor,
	      errorColor = _muiTheme$textField.errorColor,
	      focusColor = _muiTheme$textField.focusColor;
	
	
	  var styles = {
	    root: {
	      borderTop: 'none',
	      borderLeft: 'none',
	      borderRight: 'none',
	      borderBottomStyle: 'solid',
	      borderBottomWidth: 1,
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottomStyle: 'dotted',
	      borderBottomWidth: 2,
	      borderColor: disabledTextColor
	    },
	    focus: {
	      borderBottomStyle: 'solid',
	      borderBottomWidth: 2,
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
	  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(underline) }),
	    _react2.default.createElement('hr', { 'aria-hidden': 'true', style: prepareStyles(focusedUnderline) })
	  );
	};
	
	TextFieldUnderline.propTypes =  false ? propTypes : {};
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;

/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimeDisplay = __webpack_require__(1591);
	
	var _TimeDisplay2 = _interopRequireDefault(_TimeDisplay);
	
	var _ClockHours = __webpack_require__(1589);
	
	var _ClockHours2 = _interopRequireDefault(_ClockHours);
	
	var _ClockMinutes = __webpack_require__(1590);
	
	var _ClockMinutes2 = _interopRequireDefault(_ClockMinutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Clock = function (_Component) {
	  (0, _inherits3.default)(Clock, _Component);
	
	  function Clock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Clock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Clock.__proto__ || (0, _getPrototypeOf2.default)(Clock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedTime: null,
	      mode: 'hour'
	    }, _this.setMode = function (mode) {
	      setTimeout(function () {
	        _this.setState({
	          mode: mode
	        });
	      }, 100);
	    }, _this.handleSelectAffix = function (affix) {
	      if (affix === _this.getAffix()) return;
	
	      var hours = _this.state.selectedTime.getHours();
	
	      if (affix === 'am') {
	        _this.handleChangeHours(hours - 12, affix);
	        return;
	      }
	
	      _this.handleChangeHours(hours + 12, affix);
	    }, _this.handleChangeHours = function (hours, finished) {
	      var time = new Date(_this.state.selectedTime);
	      var affix = void 0;
	
	      if (typeof finished === 'string') {
	        affix = finished;
	        finished = undefined;
	      }
	      if (!affix) {
	        affix = _this.getAffix();
	      }
	      if (affix === 'pm' && hours < 12) {
	        hours += 12;
	      }
	
	      time.setHours(hours);
	      _this.setState({
	        selectedTime: time
	      });
	
	      if (finished) {
	        setTimeout(function () {
	          _this.setState({
	            mode: 'minute'
	          });
	
	          var onChangeHours = _this.props.onChangeHours;
	
	          if (onChangeHours) {
	            onChangeHours(time);
	          }
	        }, 100);
	      }
	    }, _this.handleChangeMinutes = function (minutes, finished) {
	      var time = new Date(_this.state.selectedTime);
	      time.setMinutes(minutes);
	      _this.setState({
	        selectedTime: time
	      });
	
	      var onChangeMinutes = _this.props.onChangeMinutes;
	
	      if (onChangeMinutes && finished) {
	        setTimeout(function () {
	          onChangeMinutes(time);
	        }, 0);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Clock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var selectedTime = this.props.initialTime || new Date();
	      var minutes = selectedTime.getMinutes();
	      selectedTime.setMinutes(minutes - minutes % this.props.minutesStep);
	
	      this.setState({
	        selectedTime: selectedTime
	      });
	    }
	  }, {
	    key: 'getAffix',
	    value: function getAffix() {
	      if (this.props.format !== 'ampm') return '';
	
	      var hours = this.state.selectedTime.getHours();
	      if (hours < 12) {
	        return 'am';
	      }
	
	      return 'pm';
	    }
	  }, {
	    key: 'getSelectedTime',
	    value: function getSelectedTime() {
	      return this.state.selectedTime;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var clock = null;
	
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          userSelect: 'none'
	        },
	        container: {
	          height: 280,
	          padding: 10,
	          position: 'relative',
	          boxSizing: 'content-box'
	        },
	        circle: {
	          position: 'absolute',
	          top: 20,
	          width: 260,
	          height: 260,
	          borderRadius: '100%',
	          backgroundColor: timePicker.clockCircleColor
	        }
	      };
	
	      if (this.state.mode === 'hour') {
	        clock = _react2.default.createElement(_ClockHours2.default, {
	          key: 'hours',
	          format: this.props.format,
	          onChange: this.handleChangeHours,
	          initialHours: this.state.selectedTime.getHours()
	        });
	      } else {
	        clock = _react2.default.createElement(_ClockMinutes2.default, {
	          key: 'minutes',
	          onChange: this.handleChangeMinutes,
	          initialMinutes: this.state.selectedTime.getMinutes(),
	          step: this.props.minutesStep
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_TimeDisplay2.default, {
	          selectedTime: this.state.selectedTime,
	          mode: this.state.mode,
	          format: this.props.format,
	          affix: this.getAffix(),
	          onSelectAffix: this.handleSelectAffix,
	          onSelectHour: this.setMode.bind(this, 'hour'),
	          onSelectMin: this.setMode.bind(this, 'minute')
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.container) },
	          _react2.default.createElement('div', { style: prepareStyles(styles.circle) }),
	          clock
	        )
	      );
	    }
	  }]);
	  return Clock;
	}(_react.Component);
	
	Clock.defaultProps = {
	  initialTime: new Date()
	};
	Clock.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Clock.propTypes =  false ? {
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  initialTime: _propTypes2.default.object,
	  minutesStep: _propTypes2.default.number,
	  onChangeHours: _propTypes2.default.func,
	  onChangeMinutes: _propTypes2.default.func
	} : {};
	exports.default = Clock;

/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ClockNumber = __webpack_require__(608);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(609);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockHours = function (_Component) {
	  (0, _inherits3.default)(ClockHours, _Component);
	
	  function ClockHours() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockHours);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockHours.__proto__ || (0, _getPrototypeOf2.default)(ClockHours)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) return;
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouchMove = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], false);
	    }, _this.handleTouchEnd = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], true);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockHours, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = _reactDom2.default.findDOMNode(this.refs.mask);
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var hours = this.getHours(event.offsetX, event.offsetY);
	
	      this.props.onChange(hours, finish);
	    }
	  }, {
	    key: 'getHours',
	    value: function getHours(offsetX, offsetY) {
	      var step = 30;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      var delta = Math.pow(x, 2) + Math.pow(y, 2);
	      var distance = Math.sqrt(delta);
	
	      value = value || 12;
	      if (this.props.format === '24hr') {
	        if (distance < 90) {
	          value += 12;
	          value %= 24;
	        }
	      } else {
	        value %= 12;
	      }
	
	      return value;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected() {
	      var hour = this.props.initialHours;
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      return hour;
	    }
	  }, {
	    key: 'getHourNumbers',
	    value: function getHourNumbers() {
	      var _this2 = this;
	
	      var style = {
	        pointerEvents: 'none'
	      };
	      var hourSize = this.props.format === 'ampm' ? 12 : 24;
	
	      var hours = [];
	      for (var i = 1; i <= hourSize; i++) {
	        hours.push(i % 24);
	      }
	
	      return hours.map(function (hour) {
	        var isSelected = _this2.getSelected() === hour;
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: hour,
	          style: style,
	          isSelected: isSelected,
	          type: 'hour',
	          value: hour
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var hours = this.getSelected();
	      var numbers = this.getHourNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { hasSelected: true, value: hours, type: 'hour' }),
	        numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask', style: prepareStyles(styles.hitMask), onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleTouchEnd, onMouseUp: this.handleUp, onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockHours;
	}(_react.Component);
	
	ClockHours.defaultProps = {
	  initialHours: new Date().getHours(),
	  onChange: function onChange() {},
	  format: 'ampm'
	};
	ClockHours.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ClockHours.propTypes =  false ? {
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  initialHours: _propTypes2.default.number,
	  onChange: _propTypes2.default.func
	} : {};
	exports.default = ClockHours;

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClockNumber = __webpack_require__(608);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(609);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockMinutes = function (_Component) {
	  (0, _inherits3.default)(ClockMinutes, _Component);
	
	  function ClockMinutes() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockMinutes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockMinutes.__proto__ || (0, _getPrototypeOf2.default)(ClockMinutes)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) {
	        return;
	      }
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouch = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], event.type === 'touchend');
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockMinutes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = this.refs.mask;
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var minutes = this.getMinutes(event.offsetX, event.offsetY);
	
	      this.props.onChange(minutes, finish);
	    }
	  }, {
	    key: 'getMinutes',
	    value: function getMinutes(offsetX, offsetY) {
	      var step = 6 * this.props.step;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      return value * this.props.step;
	    }
	  }, {
	    key: 'getMinuteNumbers',
	    value: function getMinuteNumbers() {
	      var minutes = [];
	      for (var i = 0; i < 12; i++) {
	        minutes.push(i * 5);
	      }
	      var selectedMinutes = this.props.initialMinutes;
	      var hasSelected = false;
	
	      var numbers = minutes.map(function (minute) {
	        var isSelected = selectedMinutes === minute;
	        if (isSelected) {
	          hasSelected = true;
	        }
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: minute,
	          isSelected: isSelected,
	          type: 'minute',
	          value: minute
	        });
	      });
	
	      return {
	        numbers: numbers,
	        hasSelected: hasSelected,
	        selected: selectedMinutes
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var minutes = this.getMinuteNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { value: minutes.selected, type: 'minute', hasSelected: minutes.hasSelected }),
	        minutes.numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask',
	          style: prepareStyles(styles.hitMask),
	          onTouchMove: this.handleTouch,
	          onTouchEnd: this.handleTouch,
	          onMouseUp: this.handleUp,
	          onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockMinutes;
	}(_react.Component);
	
	ClockMinutes.defaultProps = {
	  initialMinutes: new Date().getMinutes(),
	  onChange: function onChange() {},
	  step: 1
	};
	ClockMinutes.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ClockMinutes.propTypes =  false ? {
	  initialMinutes: _propTypes2.default.number,
	  onChange: _propTypes2.default.func,
	  step: _propTypes2.default.number
	} : {};
	exports.default = ClockMinutes;

/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(296);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeDisplay = function (_Component) {
	  (0, _inherits3.default)(TimeDisplay, _Component);
	
	  function TimeDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimeDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimeDisplay.__proto__ || (0, _getPrototypeOf2.default)(TimeDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimeDisplay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedTime !== this.props.selectedTime) {
	        var direction = nextProps.selectedTime > this.props.selectedTime ? 'up' : 'down';
	
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'sanitizeTime',
	    value: function sanitizeTime() {
	      var hour = this.props.selectedTime.getHours();
	      var min = this.props.selectedTime.getMinutes().toString();
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      hour = hour.toString();
	      if (hour.length < 2) hour = '0' + hour;
	      if (min.length < 2) min = '0' + min;
	
	      return [hour, min];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          affix = _props.affix,
	          format = _props.format,
	          mode = _props.mode,
	          onSelectAffix = _props.onSelectAffix,
	          onSelectHour = _props.onSelectHour,
	          onSelectMin = _props.onSelectMin,
	          selectedTime = _props.selectedTime,
	          other = (0, _objectWithoutProperties3.default)(_props, ['affix', 'format', 'mode', 'onSelectAffix', 'onSelectHour', 'onSelectMin', 'selectedTime']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          padding: '14px 0',
	          borderTopLeftRadius: 2,
	          borderTopRightRadius: 2,
	          backgroundColor: timePicker.headerColor,
	          color: timePicker.textColor
	        },
	        text: {
	          margin: '6px 0',
	          lineHeight: '58px',
	          height: 58,
	          fontSize: 58,
	          display: 'flex',
	          justifyContent: 'center',
	          alignItems: 'baseline'
	        },
	        time: {
	          margin: '0 10px'
	        },
	        affix: {
	          flex: 1,
	          position: 'relative',
	          lineHeight: '17px',
	          height: 17,
	          fontSize: 17
	        },
	        affixTop: {
	          position: 'absolute',
	          top: -20,
	          left: 0
	        },
	        clickable: {
	          cursor: 'pointer'
	        },
	        inactive: {
	          opacity: 0.7
	        }
	      };
	
	      var _sanitizeTime = this.sanitizeTime(),
	          _sanitizeTime2 = (0, _slicedToArray3.default)(_sanitizeTime, 2),
	          hour = _sanitizeTime2[0],
	          min = _sanitizeTime2[1];
	
	      var buttons = [];
	      if (format === 'ampm') {
	        buttons = [_react2.default.createElement(
	          'div',
	          {
	            key: 'pm',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, affix === 'pm' ? {} : styles.inactive)),
	            onClick: function onClick() {
	              return onSelectAffix('pm');
	            }
	          },
	          'PM'
	        ), _react2.default.createElement(
	          'div',
	          {
	            key: 'am',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.affixTop, styles.clickable, affix === 'am' ? {} : styles.inactive)),
	            onClick: function onClick() {
	              return onSelectAffix('am');
	            }
	          },
	          'AM'
	        )];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.text) },
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.time) },
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'hour' ? {} : styles.inactive)),
	                onClick: onSelectHour
	              },
	              hour
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'minute' ? {} : styles.inactive)),
	                onClick: onSelectMin
	              },
	              min
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) },
	            buttons
	          )
	        )
	      );
	    }
	  }]);
	  return TimeDisplay;
	}(_react.Component);
	
	TimeDisplay.defaultProps = {
	  affix: '',
	  mode: 'hour'
	};
	TimeDisplay.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TimeDisplay.propTypes =  false ? {
	  affix: _propTypes2.default.oneOf(['', 'pm', 'am']),
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  mode: _propTypes2.default.oneOf(['hour', 'minute']),
	  onSelectAffix: _propTypes2.default.func,
	  onSelectHour: _propTypes2.default.func,
	  onSelectMin: _propTypes2.default.func,
	  selectedTime: _propTypes2.default.object.isRequired
	} : {};
	exports.default = TimeDisplay;

/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimePickerDialog = __webpack_require__(1593);
	
	var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);
	
	var _TextField = __webpack_require__(58);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _timeUtils = __webpack_require__(209);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyTime = new Date();
	emptyTime.setHours(0);
	emptyTime.setMinutes(0);
	emptyTime.setSeconds(0);
	emptyTime.setMilliseconds(0);
	
	var TimePicker = function (_Component) {
	  (0, _inherits3.default)(TimePicker, _Component);
	
	  function TimePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePicker.__proto__ || (0, _getPrototypeOf2.default)(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      time: null,
	      dialogTime: new Date()
	    }, _this.handleAcceptDialog = function (time) {
	      _this.setState({
	        time: time
	      });
	      if (_this.props.onChange) _this.props.onChange(null, time);
	    }, _this.handleFocusInput = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleClickInput = function (event) {
	      event.preventDefault();
	
	      if (!_this.props.disabled) {
	        _this.openDialog();
	      }
	
	      if (_this.props.onClick) {
	        _this.props.onClick(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        time: this.isControlled() ? this.getControlledTime() : this.props.defaultTime
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.setState({
	          time: this.getControlledTime(nextProps)
	        });
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      this.setState({
	        dialogTime: this.state.time
	      });
	      this.refs.dialogWindow.show();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.value !== null;
	    }
	  }, {
	    key: 'getControlledTime',
	    value: function getControlledTime() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var result = null;
	      if (props.value instanceof Date) {
	        result = props.value;
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          defaultTime = _props.defaultTime,
	          dialogBodyStyle = _props.dialogBodyStyle,
	          dialogStyle = _props.dialogStyle,
	          format = _props.format,
	          okLabel = _props.okLabel,
	          onFocus = _props.onFocus,
	          onClick = _props.onClick,
	          onShow = _props.onShow,
	          onDismiss = _props.onDismiss,
	          pedantic = _props.pedantic,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          minutesStep = _props.minutesStep,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoOk', 'cancelLabel', 'defaultTime', 'dialogBodyStyle', 'dialogStyle', 'format', 'okLabel', 'onFocus', 'onClick', 'onShow', 'onDismiss', 'pedantic', 'style', 'textFieldStyle', 'minutesStep']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var time = this.state.time;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          style: textFieldStyle,
	          ref: 'input',
	          value: time === emptyTime ? null : (0, _timeUtils.formatTime)(time, format, pedantic),
	          onFocus: this.handleFocusInput,
	          onClick: this.handleClickInput
	        })),
	        _react2.default.createElement(_TimePickerDialog2.default, {
	          ref: 'dialogWindow',
	          bodyStyle: dialogBodyStyle,
	          initialTime: this.state.dialogTime,
	          onAccept: this.handleAcceptDialog,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          format: format,
	          okLabel: okLabel,
	          cancelLabel: cancelLabel,
	          autoOk: autoOk,
	          style: dialogStyle,
	          minutesStep: minutesStep
	        })
	      );
	    }
	  }]);
	  return TimePicker;
	}(_react.Component);
	
	TimePicker.defaultProps = {
	  autoOk: false,
	  cancelLabel: 'Cancel',
	  defaultTime: null,
	  disabled: false,
	  format: 'ampm',
	  okLabel: 'OK',
	  pedantic: false,
	  style: {},
	  value: null,
	  minutesStep: 1
	};
	TimePicker.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TimePicker.propTypes =  false ? {
	  /**
	   * If true, automatically accept and close the picker on set minutes.
	   */
	  autoOk: _propTypes2.default.bool,
	  /**
	   * Override the label of the 'Cancel' button.
	   */
	  cancelLabel: _propTypes2.default.node,
	  /**
	   * The initial time value of the TimePicker.
	   */
	  defaultTime: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's body element.
	   */
	  dialogBodyStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's root element.
	   */
	  dialogStyle: _propTypes2.default.object,
	  /**
	   * If true, the TimePicker is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Tells the component to display the picker in `ampm` (12hr) format or `24hr` format.
	   */
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  /**
	   * How many minutes should be added/subtracted when moving the clock pointer.
	   */
	  minutesStep: _propTypes2.default.number,
	  /**
	   * Override the label of the 'OK' button.
	   */
	  okLabel: _propTypes2.default.node,
	  /**
	   * Callback function that is fired when the time value changes. The time value is passed in a Date Object.
	   * Since there is no particular event associated with the change the first argument will always be null
	   * and the second argument will be the new Date instance.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker is tapped or clicked.
	   */
	  onClick: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker dialog is dismissed.
	   */
	  onDismiss: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker `TextField` gains focus.
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker dialog is shown.
	   */
	  onShow: _propTypes2.default.func,
	  /**
	   * If true, uses ("noon" / "midnight") instead of ("12 a.m." / "12 p.m.").
	   *
	   * It's technically more correct to refer to "12 noon" and "12 midnight" rather than "12 a.m." and "12 p.m."
	   * and it avoids confusion between different locales. By default (for compatibility reasons) TimePicker uses
	   * ("12 a.m." / "12 p.m.").
	   */
	  pedantic: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of TimePicker's TextField element.
	   */
	  textFieldStyle: _propTypes2.default.object,
	  /**
	   * Sets the time for the Time Picker programmatically.
	   */
	  value: _propTypes2.default.object
	} : {};
	exports.default = TimePicker;

/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(100);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(73);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Clock = __webpack_require__(1588);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _Dialog = __webpack_require__(171);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(82);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimePickerDialog = function (_Component) {
	  (0, _inherits3.default)(TimePickerDialog, _Component);
	
	  function TimePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(TimePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleClickCancel = function () {
	      _this.dismiss();
	    }, _this.handleClickOK = function () {
	      if (_this.props.onAccept) {
	        _this.props.onAccept(_this.refs.clock.getSelectedTime());
	      }
	      _this.setState({
	        open: false
	      });
	    }, _this.handleKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleClickOK();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePickerDialog, [{
	    key: 'show',
	    value: function show() {
	      if (this.props.onShow && !this.state.open) this.props.onShow();
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      if (this.props.onDismiss && this.state.open) this.props.onDismiss();
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bodyStyle = _props.bodyStyle,
	          initialTime = _props.initialTime,
	          onAccept = _props.onAccept,
	          format = _props.format,
	          autoOk = _props.autoOk,
	          okLabel = _props.okLabel,
	          cancelLabel = _props.cancelLabel,
	          style = _props.style,
	          minutesStep = _props.minutesStep,
	          other = (0, _objectWithoutProperties3.default)(_props, ['bodyStyle', 'initialTime', 'onAccept', 'format', 'autoOk', 'okLabel', 'cancelLabel', 'style', 'minutesStep']);
	
	
	      var styles = {
	        root: {
	          fontSize: 14,
	          color: this.context.muiTheme.timePicker.clockColor
	        },
	        dialogContent: {
	          width: 280
	        },
	        body: {
	          padding: 0
	        }
	      };
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        key: 0,
	        label: cancelLabel,
	        primary: true,
	        onClick: this.handleClickCancel
	      }), _react2.default.createElement(_FlatButton2.default, {
	        key: 1,
	        label: okLabel,
	        primary: true,
	        onClick: this.handleClickOK
	      })];
	
	      var onClockChangeMinutes = autoOk === true ? this.handleClickOK : undefined;
	      var open = this.state.open;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          bodyStyle: (0, _simpleAssign2.default)(styles.body, bodyStyle),
	          actions: actions,
	          contentStyle: styles.dialogContent,
	          repositionOnUpdate: false,
	          open: open,
	          onRequestClose: this.handleRequestClose
	        }),
	        open && _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        open && _react2.default.createElement(_Clock2.default, {
	          ref: 'clock',
	          format: format,
	          initialTime: initialTime,
	          onChangeMinutes: onClockChangeMinutes,
	          minutesStep: minutesStep
	        })
	      );
	    }
	  }]);
	  return TimePickerDialog;
	}(_react.Component);
	
	TimePickerDialog.defaultProps = {
	  okLabel: 'OK',
	  cancelLabel: 'Cancel'
	};
	TimePickerDialog.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	TimePickerDialog.propTypes =  false ? {
	  autoOk: _propTypes2.default.bool,
	  bodyStyle: _propTypes2.default.object,
	  cancelLabel: _propTypes2.default.node,
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  initialTime: _propTypes2.default.object,
	  minutesStep: _propTypes2.default.number,
	  okLabel: _propTypes2.default.node,
	  onAccept: _propTypes2.default.func,
	  onDismiss: _propTypes2.default.func,
	  onShow: _propTypes2.default.func,
	  style: _propTypes2.default.object
	} : {};
	exports.default = TimePickerDialog;

/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TimePicker = __webpack_require__(1592);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TimePicker2.default;

/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(37);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _EnhancedSwitch = __webpack_require__(381);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var disabled = props.disabled,
	      elementStyle = props.elementStyle,
	      trackSwitchedStyle = props.trackSwitchedStyle,
	      thumbSwitchedStyle = props.thumbSwitchedStyle,
	      trackStyle = props.trackStyle,
	      thumbStyle = props.thumbStyle,
	      iconStyle = props.iconStyle,
	      rippleStyle = props.rippleStyle,
	      labelStyle = props.labelStyle;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toggle = _context$muiTheme.toggle;
	
	
	  var toggleSize = 20;
	  var toggleTrackWidth = 36;
	  var styles = {
	    icon: {
	      width: 36,
	      padding: '4px 0px 6px 2px'
	    },
	    ripple: {
	      top: -10,
	      left: -10,
	      color: state.switched ? toggle.thumbOnColor : baseTheme.palette.textColor
	    },
	    toggleElement: {
	      width: toggleTrackWidth
	    },
	    track: {
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      height: 14,
	      borderRadius: 30,
	      backgroundColor: toggle.trackOffColor
	    },
	    thumb: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      top: 1,
	      left: 0,
	      width: toggleSize,
	      height: toggleSize,
	      lineHeight: '24px',
	      borderRadius: '50%',
	      backgroundColor: toggle.thumbOffColor
	    },
	    trackWhenSwitched: {
	      backgroundColor: toggle.trackOnColor
	    },
	    thumbWhenSwitched: {
	      backgroundColor: toggle.thumbOnColor,
	      left: '100%'
	    },
	    trackWhenDisabled: {
	      backgroundColor: toggle.trackDisabledColor
	    },
	    thumbWhenDisabled: {
	      backgroundColor: toggle.thumbDisabledColor
	    },
	    label: {
	      color: disabled ? toggle.labelDisabledColor : toggle.labelColor,
	      width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)'
	    }
	  };
	
	  (0, _simpleAssign2.default)(styles.track, trackStyle, state.switched && styles.trackWhenSwitched, state.switched && trackSwitchedStyle, disabled && styles.trackWhenDisabled);
	
	  (0, _simpleAssign2.default)(styles.thumb, thumbStyle, state.switched && styles.thumbWhenSwitched, state.switched && thumbSwitchedStyle, disabled && styles.thumbWhenDisabled);
	
	  if (state.switched) {
	    styles.thumb.marginLeft = 0 - styles.thumb.width;
	  }
	
	  (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	  (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	  (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	  (0, _simpleAssign2.default)(styles.toggleElement, elementStyle);
	
	  return styles;
	}
	
	var Toggle = function (_Component) {
	  (0, _inherits3.default)(Toggle, _Component);
	
	  function Toggle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Toggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleToggle = function (event, isInputChecked) {
	      if (_this.props.onToggle) {
	        _this.props.onToggle(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Toggle, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          toggled = _props.toggled,
	          defaultToggled = _props.defaultToggled,
	          valueLink = _props.valueLink;
	
	
	      if (toggled || defaultToggled || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'isToggled',
	    value: function isToggled() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setToggled',
	    value: function setToggled(newToggledValue) {
	      this.refs.enhancedSwitch.setSwitched(newToggledValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          defaultToggled = _props2.defaultToggled,
	          elementStyle = _props2.elementStyle,
	          onToggle = _props2.onToggle,
	          trackSwitchedStyle = _props2.trackSwitchedStyle,
	          thumbSwitchedStyle = _props2.thumbSwitchedStyle,
	          toggled = _props2.toggled,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['defaultToggled', 'elementStyle', 'onToggle', 'trackSwitchedStyle', 'thumbSwitchedStyle', 'toggled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var toggleElement = _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, styles.toggleElement)) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.track)) }),
	        _react2.default.createElement(_Paper2.default, { style: styles.thumb, circle: true, zDepth: 1 })
	      );
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switchElement: toggleElement,
	        rippleStyle: styles.ripple,
	        rippleColor: styles.ripple.color,
	        iconStyle: styles.icon,
	        trackStyle: styles.track,
	        thumbStyle: styles.thumb,
	        labelStyle: styles.label,
	        switched: this.state.switched,
	        onSwitch: this.handleToggle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      if (this.props.hasOwnProperty('toggled')) {
	        enhancedSwitchProps.checked = toggled;
	      } else if (this.props.hasOwnProperty('defaultToggled')) {
	        enhancedSwitchProps.defaultChecked = defaultToggled;
	      }
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Toggle;
	}(_react.Component);
	
	Toggle.defaultProps = {
	  defaultToggled: false,
	  disabled: false,
	  labelPosition: 'left'
	};
	Toggle.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Toggle.propTypes =  false ? {
	  /**
	   * Determines whether the Toggle is initially turned on.
	   * **Warning:** This cannot be used in conjunction with `toggled`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultToggled: _propTypes2.default.bool,
	  /**
	   * Will disable the toggle if true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides the inline-styles of the Toggle element.
	   */
	  elementStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the Icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * Label for toggle.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * Where the label will be placed next to the toggle.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Toggle element label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function that is fired when the toggle switch is toggled.
	   *
	   * @param {object} event Change event targeting the toggle.
	   * @param {bool} isInputChecked The new value of the toggle.
	   */
	  onToggle: _propTypes2.default.func,
	  /**
	   * Override style of ripple.
	   */
	  rippleStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override style for thumb.
	   */
	  thumbStyle: _propTypes2.default.object,
	  /**
	  * Override the inline styles for thumb when the toggle switch is toggled on.
	  */
	  thumbSwitchedStyle: _propTypes2.default.object,
	  /**
	   * Toggled if set to true.
	   */
	  toggled: _propTypes2.default.bool,
	  /**
	   * Override style for track.
	   */
	  trackStyle: _propTypes2.default.object,
	  /**
	  * Override the inline styles for track when the toggle switch is toggled on.
	  */
	  trackSwitchedStyle: _propTypes2.default.object,
	  /**
	   * ValueLink prop for when using controlled toggle.
	   */
	  valueLink: _propTypes2.default.object
	} : {};
	exports.default = Toggle;

/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var noGutter = props.noGutter;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      backgroundColor: toolbar.backgroundColor,
	      height: toolbar.height,
	      padding: noGutter ? 0 : '0px ' + baseTheme.spacing.desktopGutter + 'px',
	      display: 'flex',
	      justifyContent: 'space-between'
	    }
	  };
	}
	
	var Toolbar = function (_Component) {
	  (0, _inherits3.default)(Toolbar, _Component);
	
	  function Toolbar() {
	    (0, _classCallCheck3.default)(this, Toolbar);
	    return (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          noGutter = _props.noGutter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'noGutter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Toolbar;
	}(_react.Component);
	
	Toolbar.defaultProps = {
	  noGutter: false
	};
	Toolbar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Toolbar.propTypes =  false ? {
	  /**
	   * Can be a `ToolbarGroup` to render a group of related items.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Do not apply `desktopGutter` to the `Toolbar`.
	   */
	  noGutter: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = Toolbar;

/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var originalBodyOverflow = null;
	var lockingCounter = 0;
	
	var AutoLockScrolling = function (_Component) {
	  (0, _inherits3.default)(AutoLockScrolling, _Component);
	
	  function AutoLockScrolling() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoLockScrolling);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoLockScrolling.__proto__ || (0, _getPrototypeOf2.default)(AutoLockScrolling)).call.apply(_ref, [this].concat(args))), _this), _this.locked = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoLockScrolling, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.lock === true) {
	        this.preventScrolling();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.lock !== nextProps.lock) {
	        if (nextProps.lock) {
	          this.preventScrolling();
	        } else {
	          this.allowScrolling();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.allowScrolling();
	    }
	
	    // force to only lock/unlock once
	
	  }, {
	    key: 'preventScrolling',
	    value: function preventScrolling() {
	      if (this.locked === true) {
	        return;
	      }
	
	      lockingCounter = lockingCounter + 1;
	      this.locked = true;
	
	      // only lock the first time the component is mounted.
	      if (lockingCounter === 1) {
	        var body = document.getElementsByTagName('body')[0];
	        originalBodyOverflow = body.style.overflow;
	        body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'allowScrolling',
	    value: function allowScrolling() {
	      if (this.locked === true) {
	        lockingCounter = lockingCounter - 1;
	        this.locked = false;
	      }
	
	      if (lockingCounter === 0 && originalBodyOverflow !== null) {
	        var body = document.getElementsByTagName('body')[0];
	        body.style.overflow = originalBodyOverflow || '';
	        originalBodyOverflow = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return AutoLockScrolling;
	}(_react.Component);
	
	AutoLockScrolling.propTypes =  false ? {
	  lock: _propTypes2.default.bool.isRequired
	} : {};
	exports.default = AutoLockScrolling;

/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  BeforeAfterWrapper
	 *    An alternative for the ::before and ::after css pseudo-elements for
	 *    components whose styles are defined in javascript instead of css.
	 *
	 *  Usage: For the element that we want to apply before and after elements to,
	 *    wrap its children with BeforeAfterWrapper. For example:
	 *
	 *                                            <Paper>
	 *  <Paper>                                     <div> // See notice
	 *    <BeforeAfterWrapper>        renders         <div/> // before element
	 *      [children of paper]       ------>         [children of paper]
	 *    </BeforeAfterWrapper>                       <div/> // after element
	 *  </Paper>                                    </div>
	 *                                            </Paper>
	 *
	 *  Notice: Notice that this div bundles together our elements. If the element
	 *    that we want to apply before and after elements is a HTML tag (i.e. a
	 *    div, p, or button tag), we can avoid this extra nesting by passing using
	 *    the BeforeAfterWrapper in place of said tag like so:
	 *
	 *  <p>
	 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
	 *      [children of p]          ------>         [children of p]
	 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
	 *  </p>
	 *
	 *  BeforeAfterWrapper features spread functionality. This means that we can
	 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
	 *
	 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
	 *  and afterElement have a defined style position.
	 */
	
	var styles = {
	  box: {
	    boxSizing: 'border-box'
	  }
	};
	
	var BeforeAfterWrapper = function (_Component) {
	  (0, _inherits3.default)(BeforeAfterWrapper, _Component);
	
	  function BeforeAfterWrapper() {
	    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BeforeAfterWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          beforeStyle = _props.beforeStyle,
	          afterStyle = _props.afterStyle,
	          beforeElementType = _props.beforeElementType,
	          afterElementType = _props.afterElementType,
	          elementType = _props.elementType,
	          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var beforeElement = void 0;
	      var afterElement = void 0;
	
	      if (beforeStyle) {
	        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
	          key: '::before'
	        });
	      }
	
	      if (afterStyle) {
	        afterElement = _react2.default.createElement(this.props.afterElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
	          key: '::after'
	        });
	      }
	
	      var children = [beforeElement, this.props.children, afterElement];
	
	      var props = other;
	      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));
	
	      return _react2.default.createElement(this.props.elementType, props, children);
	    }
	  }]);
	  return BeforeAfterWrapper;
	}(_react.Component);
	
	BeforeAfterWrapper.defaultProps = {
	  beforeElementType: 'div',
	  afterElementType: 'div',
	  elementType: 'div'
	};
	BeforeAfterWrapper.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	BeforeAfterWrapper.propTypes =  false ? {
	  afterElementType: _propTypes2.default.string,
	  afterStyle: _propTypes2.default.object,
	  beforeElementType: _propTypes2.default.string,
	  beforeStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  elementType: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = BeforeAfterWrapper;

/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(140);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(137);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleRipple = function (_Component) {
	  (0, _inherits3.default)(CircleRipple, _Component);
	
	  function CircleRipple() {
	    (0, _classCallCheck3.default)(this, CircleRipple);
	    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircleRipple, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = 0;
	      // If the animation is aborted, remove from the DOM immediately
	      var removeAfter = this.props.aborted ? 0 : 2000;
	      this.enterTimer = setTimeout(callback, removeAfter);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
	      _autoPrefix2.default.set(style, 'transition', transitionValue);
	      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = this.props.opacity;
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	      this.leaveTimer = setTimeout(callback, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          aborted = _props.aborted,
	          color = _props.color,
	          opacity = _props.opacity,
	          style = _props.style,
	          touchGenerated = _props.touchGenerated,
	          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        backgroundColor: color
	      }, style);
	
	      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
	    }
	  }]);
	  return CircleRipple;
	}(_react.Component);
	
	CircleRipple.defaultProps = {
	  opacity: 0.1,
	  aborted: false
	};
	CircleRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CircleRipple.propTypes =  false ? {
	  aborted: _propTypes2.default.bool,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  touchGenerated: _propTypes2.default.bool
	} : {};
	exports.default = CircleRipple;

/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BeforeAfterWrapper = __webpack_require__(1598);
	
	var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  before: {
	    content: "' '",
	    display: 'table'
	  },
	  after: {
	    content: "' '",
	    clear: 'both',
	    display: 'table'
	  }
	};
	
	var ClearFix = function ClearFix(_ref) {
	  var style = _ref.style,
	      children = _ref.children,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
	  return _react2.default.createElement(
	    _BeforeAfterWrapper2.default,
	    (0, _extends3.default)({}, other, {
	      beforeStyle: styles.before,
	      afterStyle: styles.after,
	      style: style
	    }),
	    children
	  );
	};
	
	ClearFix.muiName = 'ClearFix';
	
	ClearFix.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	
	exports.default = ClearFix;

/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(214);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _ExpandTransitionChild = __webpack_require__(1602);
	
	var _ExpandTransitionChild2 = _interopRequireDefault(_ExpandTransitionChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandTransition = function (_Component) {
	  (0, _inherits3.default)(ExpandTransition, _Component);
	
	  function ExpandTransition() {
	    (0, _classCallCheck3.default)(this, ExpandTransition);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransition.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransition)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransition, [{
	    key: 'renderChildren',
	    value: function renderChildren(children) {
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration,
	          expandTransitionChildStyle = _props.expandTransitionChildStyle;
	
	      return _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ExpandTransitionChild2.default,
	          {
	            enterDelay: enterDelay,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            key: child.key,
	            style: expandTransitionChildStyle
	          },
	          child
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          enterDelay = _props2.enterDelay,
	          loading = _props2.loading,
	          open = _props2.open,
	          style = _props2.style,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration,
	          expandTransitionChildStyle = _props2.expandTransitionChildStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'enterDelay', 'loading', 'open', 'style', 'transitionDelay', 'transitionDuration', 'expandTransitionChildStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: 'auto'
	      }, style);
	
	      var newChildren = loading ? [] : this.renderChildren(children);
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }, other),
	        open && newChildren
	      );
	    }
	  }]);
	  return ExpandTransition;
	}(_react.Component);
	
	ExpandTransition.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450,
	  loading: false,
	  open: false
	};
	ExpandTransition.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ExpandTransition.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  expandTransitionChildStyle: _propTypes2.default.object,
	  loading: _propTypes2.default.bool,
	  open: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  transitionDelay: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number
	} : {};
	exports.default = ExpandTransition;

/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reflow = function reflow(elem) {
	  return elem.offsetHeight;
	};
	
	var ExpandTransitionChild = function (_Component) {
	  (0, _inherits3.default)(ExpandTransitionChild, _Component);
	
	  function ExpandTransitionChild() {
	    (0, _classCallCheck3.default)(this, ExpandTransitionChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransitionChild.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransitionChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransitionChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.enteredTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.open();
	      callback();
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = 0;
	      this.enterTimer = setTimeout(function () {
	        return _this2.open();
	      }, enterDelay);
	      this.enteredTimer = setTimeout(function () {
	        return callback();
	      }, enterDelay + transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var _props2 = this.props,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      // Set fixed height first for animated property value
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	      reflow(element);
	      element.style.transitionDuration = transitionDuration + 'ms';
	      element.style.height = 0;
	      this.leaveTimer = setTimeout(function () {
	        return callback();
	      }, transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'setAutoHeight',
	    value: function setAutoHeight() {
	      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this),
	          style = _ReactDOM$findDOMNode.style;
	
	      style.transitionDuration = 0;
	      style.height = 'auto';
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          enterDelay = _props3.enterDelay,
	          style = _props3.style,
	          transitionDelay = _props3.transitionDelay,
	          transitionDuration = _props3.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['children', 'enterDelay', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        position: 'relative',
	        height: 0,
	        width: '100%',
	        top: 0,
	        left: 0,
	        overflow: 'hidden',
	        transition: _transitions2.default.easeOut(transitionDuration + 'ms', ['height'], transitionDelay + 'ms')
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper' },
	          children
	        )
	      );
	    }
	  }]);
	  return ExpandTransitionChild;
	}(_react.Component);
	
	ExpandTransitionChild.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450
	};
	ExpandTransitionChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ExpandTransitionChild.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  transitionDelay: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number
	} : {};
	exports.default = ExpandTransitionChild;

/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(214);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _ScaleInChild = __webpack_require__(1604);
	
	var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleIn = function (_Component) {
	  (0, _inherits3.default)(ScaleIn, _Component);
	
	  function ScaleIn() {
	    (0, _classCallCheck3.default)(this, ScaleIn);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleIn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ScaleInChild2.default,
	          {
	            key: child.key,
	            enterDelay: enterDelay,
	            maxScale: maxScale,
	            minScale: minScale,
	            style: childStyle
	          },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _TransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return ScaleIn;
	}(_react.Component);
	
	ScaleIn.defaultProps = {
	  enterDelay: 0
	};
	ScaleIn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ScaleIn.propTypes =  false ? {
	  childStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  maxScale: _propTypes2.default.number,
	  minScale: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : {};
	exports.default = ScaleIn;

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(137);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleInChild = function (_Component) {
	  (0, _inherits3.default)(ScaleInChild, _Component);
	
	  function ScaleInChild() {
	    (0, _classCallCheck3.default)(this, ScaleInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return ScaleInChild;
	}(_react.Component);
	
	ScaleInChild.defaultProps = {
	  enterDelay: 0,
	  maxScale: 1,
	  minScale: 0
	};
	ScaleInChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	ScaleInChild.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  maxScale: _propTypes2.default.number,
	  minScale: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : {};
	exports.default = ScaleInChild;

/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(15);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(13);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(137);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(23);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideInChild = function (_Component) {
	  (0, _inherits3.default)(SlideInChild, _Component);
	
	  function SlideInChild() {
	    (0, _classCallCheck3.default)(this, SlideInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (SlideInChild.__proto__ || (0, _getPrototypeOf2.default)(SlideInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SlideInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
	      var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'translate(0,0)');
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var direction = this.props.getLeaveDirection();
	      var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
	      var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          getLeaveDirection = _props.getLeaveDirection,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return SlideInChild;
	}(_react.Component);
	
	SlideInChild.defaultProps = {
	  enterDelay: 0
	};
	SlideInChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	SlideInChild.propTypes =  false ? {
	  children: _propTypes2.default.node,
	  direction: _propTypes2.default.string,
	  enterDelay: _propTypes2.default.number,
	  // This callback is needed bacause the direction could change when leaving the DOM
	  getLeaveDirection: _propTypes2.default.func.isRequired,
	  style: _propTypes2.default.object
	} : {};
	exports.default = SlideInChild;

/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(175);
	
	var _colorManipulator = __webpack_require__(90);
	
	var _spacing = __webpack_require__(621);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  borderRadius: 2,
	  palette: {
	    primary1Color: _colors.cyan500,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey400,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	  }
	}; /**
	    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
	    */

/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _colors = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Typography = function Typography() {
	  (0, _classCallCheck3.default)(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors.fullBlack;
	  this.textDarkBlack = _colors.darkBlack;
	  this.textLightBlack = _colors.lightBlack;
	  this.textMinBlack = _colors.minBlack;
	  this.textFullWhite = _colors.fullWhite;
	  this.textDarkWhite = _colors.darkWhite;
	  this.textLightWhite = _colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();

/***/ }),
/* 1608 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  drawerOverlay: 1200,
	  drawer: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};

/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCheckCircle = function ActionCheckCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
	ActionCheckCircle.displayName = 'ActionCheckCircle';
	ActionCheckCircle.muiName = 'SvgIcon';
	
	exports.default = ActionCheckCircle;

/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentFilterList = function ContentFilterList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z' })
	  );
	};
	ContentFilterList = (0, _pure2.default)(ContentFilterList);
	ContentFilterList.displayName = 'ContentFilterList';
	ContentFilterList.muiName = 'SvgIcon';
	
	exports.default = ContentFilterList;

/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
	  );
	};
	HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
	HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
	HardwareKeyboardArrowDown.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowDown;

/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
	  );
	};
	HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
	HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
	HardwareKeyboardArrowUp.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowUp;

/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
	  );
	};
	NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
	NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
	NavigationArrowDropDown.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDown;

/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCancel = function NavigationCancel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
	  );
	};
	NavigationCancel = (0, _pure2.default)(NavigationCancel);
	NavigationCancel.displayName = 'NavigationCancel';
	NavigationCancel.muiName = 'SvgIcon';
	
	exports.default = NavigationCancel;

/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = function NavigationCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	  );
	};
	NavigationCheck = (0, _pure2.default)(NavigationCheck);
	NavigationCheck.displayName = 'NavigationCheck';
	NavigationCheck.muiName = 'SvgIcon';
	
	exports.default = NavigationCheck;

/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronLeft = function NavigationChevronLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	  );
	};
	NavigationChevronLeft = (0, _pure2.default)(NavigationChevronLeft);
	NavigationChevronLeft.displayName = 'NavigationChevronLeft';
	NavigationChevronLeft.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronLeft;

/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronRight = function NavigationChevronRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	  );
	};
	NavigationChevronRight = (0, _pure2.default)(NavigationChevronRight);
	NavigationChevronRight.displayName = 'NavigationChevronRight';
	NavigationChevronRight.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronRight;

/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandLess = function NavigationExpandLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
	  );
	};
	NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
	NavigationExpandLess.displayName = 'NavigationExpandLess';
	NavigationExpandLess.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandLess;

/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandMore = function NavigationExpandMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
	  );
	};
	NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
	NavigationExpandMore.displayName = 'NavigationExpandMore';
	NavigationExpandMore.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandMore;

/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMenu = function NavigationMenu(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
	  );
	};
	NavigationMenu = (0, _pure2.default)(NavigationMenu);
	NavigationMenu.displayName = 'NavigationMenu';
	NavigationMenu.muiName = 'SvgIcon';
	
	exports.default = NavigationMenu;

/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
	ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
	ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBoxOutlineBlank;

/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBox = function ToggleCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
	ToggleCheckBox.displayName = 'ToggleCheckBox';
	ToggleCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBox;

/***/ }),
/* 1623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonChecked = function ToggleRadioButtonChecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonChecked = (0, _pure2.default)(ToggleRadioButtonChecked);
	ToggleRadioButtonChecked.displayName = 'ToggleRadioButtonChecked';
	ToggleRadioButtonChecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonChecked;

/***/ }),
/* 1624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(47);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(45);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonUnchecked = function ToggleRadioButtonUnchecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonUnchecked = (0, _pure2.default)(ToggleRadioButtonUnchecked);
	ToggleRadioButtonUnchecked.displayName = 'ToggleRadioButtonUnchecked';
	ToggleRadioButtonUnchecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonUnchecked;

/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (muiTheme) {
	  var isClient = typeof navigator !== 'undefined';
	  var userAgent = muiTheme.userAgent;
	
	  if (userAgent === undefined && isClient) {
	    userAgent = navigator.userAgent;
	  }
	
	  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;
	
	    hasWarnedAboutUserAgent = true;
	  }
	
	  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);
	
	  if (userAgent === false) {
	    // Disabled autoprefixer
	    return null;
	  } else if (userAgent === 'all' || userAgent === undefined) {
	    // Prefix for all user agent
	    return function (style) {
	      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
	      var stylePrefixed = prefixAll(style);
	
	      if (isFlex) {
	        var display = stylePrefixed.display;
	        if (isClient) {
	          // We can't apply this join with react-dom:
	          // #https://github.com/facebook/react/issues/6467
	          stylePrefixed.display = display[display.length - 1];
	        } else {
	          stylePrefixed.display = display.join('; display: ');
	        }
	      }
	
	      return stylePrefixed;
	    };
	  } else {
	    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
	    var prefixer = new Prefixer({
	      userAgent: userAgent
	    });
	
	    return function (style) {
	      return prefixer.prefix(style);
	    };
	  }
	};
	
	var _createPrefixer = __webpack_require__(1341);
	
	var _createPrefixer2 = _interopRequireDefault(_createPrefixer);
	
	var _createPrefixer3 = __webpack_require__(1333);
	
	var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);
	
	var _autoprefixerDynamic = __webpack_require__(1626);
	
	var _autoprefixerDynamic2 = _interopRequireDefault(_autoprefixerDynamic);
	
	var _autoprefixerStatic = __webpack_require__(1627);
	
	var _autoprefixerStatic2 = _interopRequireDefault(_autoprefixerStatic);
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasWarnedAboutUserAgent = false;

/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(1334);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _flex = __webpack_require__(1335);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(1336);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1337);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1338);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _sizing = __webpack_require__(1339);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1340);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
	  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
	}; /* eslint-disable */

/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(1342);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _flex = __webpack_require__(1343);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(1344);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(1345);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(1346);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _sizing = __webpack_require__(1347);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(1348);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
	  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
	}; /* eslint-disable */

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(39);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (false) {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(461);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = rtl;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      if (style.directionInvariant === true) {
	        return style;
	      }
	
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      (0, _keys2.default)(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            if (!value) break;
	            var matches = void 0;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (!value) break;
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LARGE = exports.MEDIUM = exports.SMALL = undefined;
	
	var _extends2 = __webpack_require__(14);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(9);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(7);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(11);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(10);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = withWidth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(100);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SMALL = exports.SMALL = 1;
	var MEDIUM = exports.MEDIUM = 2;
	var LARGE = exports.LARGE = 3;
	
	function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$largeWidth = options.largeWidth,
	      largeWidth = _options$largeWidth === undefined ? 992 : _options$largeWidth,
	      _options$mediumWidth = options.mediumWidth,
	      mediumWidth = _options$mediumWidth === undefined ? 768 : _options$mediumWidth,
	      _options$resizeInterv = options.resizeInterval,
	      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;
	
	
	  return function (MyComponent) {
	    return function (_Component) {
	      (0, _inherits3.default)(WithWidth, _Component);
	
	      function WithWidth() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, WithWidth);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          width: null
	        }, _this.handleResize = function () {
	          clearTimeout(_this.deferTimer);
	          _this.deferTimer = setTimeout(function () {
	            _this.updateWidth();
	          }, resizeInterval);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	      }
	
	      (0, _createClass3.default)(WithWidth, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.updateWidth();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          clearTimeout(this.deferTimer);
	        }
	      }, {
	        key: 'updateWidth',
	        value: function updateWidth() {
	          var innerWidth = window.innerWidth;
	          var width = void 0;
	
	          if (innerWidth >= largeWidth) {
	            width = LARGE;
	          } else if (innerWidth >= mediumWidth) {
	            width = MEDIUM;
	          } else {
	            // innerWidth < 768
	            width = SMALL;
	          }
	
	          if (width !== this.state.width) {
	            this.setState({
	              width: width
	            });
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var width = this.state.width;
	
	          /**
	           * When rendering the component on the server,
	           * we have no idea about the screen width.
	           * In order to prevent blinks and help the reconciliation
	           * we are not rendering the component.
	           *
	           * A better alternative would be to send client hints.
	           * But the browser support of this API is low:
	           * http://caniuse.com/#search=client%20hint
	           */
	          if (width === null) {
	            return null;
	          }
	
	          return _react2.default.createElement(
	            _reactEventListener2.default,
	            { target: 'window', onResize: this.handleResize },
	            _react2.default.createElement(MyComponent, (0, _extends3.default)({
	              width: width
	            }, this.props))
	          );
	        }
	      }]);
	      return WithWidth;
	    }(_react.Component);
	  };
	}

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * mime-db
	 * Copyright(c) 2014 Jonathan Ong
	 * MIT Licensed
	 */
	
	/**
	 * Module exports.
	 */
	
	module.exports = __webpack_require__(1376)


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * mime-types
	 * Copyright(c) 2014 Jonathan Ong
	 * Copyright(c) 2015 Douglas Christopher Wilson
	 * MIT Licensed
	 */
	
	'use strict'
	
	/**
	 * Module dependencies.
	 * @private
	 */
	
	var db = __webpack_require__(1631)
	var extname = __webpack_require__(1637).extname
	
	/**
	 * Module variables.
	 * @private
	 */
	
	var EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/
	var TEXT_TYPE_REGEXP = /^text\//i
	
	/**
	 * Module exports.
	 * @public
	 */
	
	exports.charset = charset
	exports.charsets = { lookup: charset }
	exports.contentType = contentType
	exports.extension = extension
	exports.extensions = Object.create(null)
	exports.lookup = lookup
	exports.types = Object.create(null)
	
	// Populate the extensions/types maps
	populateMaps(exports.extensions, exports.types)
	
	/**
	 * Get the default charset for a MIME type.
	 *
	 * @param {string} type
	 * @return {boolean|string}
	 */
	
	function charset (type) {
	  if (!type || typeof type !== 'string') {
	    return false
	  }
	
	  // TODO: use media-typer
	  var match = EXTRACT_TYPE_REGEXP.exec(type)
	  var mime = match && db[match[1].toLowerCase()]
	
	  if (mime && mime.charset) {
	    return mime.charset
	  }
	
	  // default text/* to utf-8
	  if (match && TEXT_TYPE_REGEXP.test(match[1])) {
	    return 'UTF-8'
	  }
	
	  return false
	}
	
	/**
	 * Create a full Content-Type header given a MIME type or extension.
	 *
	 * @param {string} str
	 * @return {boolean|string}
	 */
	
	function contentType (str) {
	  // TODO: should this even be in this module?
	  if (!str || typeof str !== 'string') {
	    return false
	  }
	
	  var mime = str.indexOf('/') === -1
	    ? exports.lookup(str)
	    : str
	
	  if (!mime) {
	    return false
	  }
	
	  // TODO: use content-type or other module
	  if (mime.indexOf('charset') === -1) {
	    var charset = exports.charset(mime)
	    if (charset) mime += '; charset=' + charset.toLowerCase()
	  }
	
	  return mime
	}
	
	/**
	 * Get the default extension for a MIME type.
	 *
	 * @param {string} type
	 * @return {boolean|string}
	 */
	
	function extension (type) {
	  if (!type || typeof type !== 'string') {
	    return false
	  }
	
	  // TODO: use media-typer
	  var match = EXTRACT_TYPE_REGEXP.exec(type)
	
	  // get extensions
	  var exts = match && exports.extensions[match[1].toLowerCase()]
	
	  if (!exts || !exts.length) {
	    return false
	  }
	
	  return exts[0]
	}
	
	/**
	 * Lookup the MIME type for a file path/extension.
	 *
	 * @param {string} path
	 * @return {boolean|string}
	 */
	
	function lookup (path) {
	  if (!path || typeof path !== 'string') {
	    return false
	  }
	
	  // get the extension ("ext" or ".ext" or full path)
	  var extension = extname('x.' + path)
	    .toLowerCase()
	    .substr(1)
	
	  if (!extension) {
	    return false
	  }
	
	  return exports.types[extension] || false
	}
	
	/**
	 * Populate the extensions and types maps.
	 * @private
	 */
	
	function populateMaps (extensions, types) {
	  // source preference (least -> most)
	  var preference = ['nginx', 'apache', undefined, 'iana']
	
	  Object.keys(db).forEach(function forEachMimeType (type) {
	    var mime = db[type]
	    var exts = mime.extensions
	
	    if (!exts || !exts.length) {
	      return
	    }
	
	    // mime -> extensions
	    extensions[type] = exts
	
	    // extension -> mime
	    for (var i = 0; i < exts.length; i++) {
	      var extension = exts[i]
	
	      if (types[extension]) {
	        var from = preference.indexOf(db[types[extension]].source)
	        var to = preference.indexOf(mime.source)
	
	        if (types[extension] !== 'application/octet-stream' &&
	          (from > to || (from === to && types[extension].substr(0, 12) === 'application/'))) {
	          // skip the remapping
	          continue
	        }
	      }
	
	      // set the extension -> mime
	      types[extension] = type
	    }
	  })
	}


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 624,
		"./af.js": 624,
		"./ar": 631,
		"./ar-dz": 625,
		"./ar-dz.js": 625,
		"./ar-kw": 626,
		"./ar-kw.js": 626,
		"./ar-ly": 627,
		"./ar-ly.js": 627,
		"./ar-ma": 628,
		"./ar-ma.js": 628,
		"./ar-sa": 629,
		"./ar-sa.js": 629,
		"./ar-tn": 630,
		"./ar-tn.js": 630,
		"./ar.js": 631,
		"./az": 632,
		"./az.js": 632,
		"./be": 633,
		"./be.js": 633,
		"./bg": 634,
		"./bg.js": 634,
		"./bm": 635,
		"./bm.js": 635,
		"./bn": 636,
		"./bn.js": 636,
		"./bo": 637,
		"./bo.js": 637,
		"./br": 638,
		"./br.js": 638,
		"./bs": 639,
		"./bs.js": 639,
		"./ca": 640,
		"./ca.js": 640,
		"./cs": 641,
		"./cs.js": 641,
		"./cv": 642,
		"./cv.js": 642,
		"./cy": 643,
		"./cy.js": 643,
		"./da": 644,
		"./da.js": 644,
		"./de": 647,
		"./de-at": 645,
		"./de-at.js": 645,
		"./de-ch": 646,
		"./de-ch.js": 646,
		"./de.js": 647,
		"./dv": 648,
		"./dv.js": 648,
		"./el": 649,
		"./el.js": 649,
		"./en-SG": 650,
		"./en-SG.js": 650,
		"./en-au": 651,
		"./en-au.js": 651,
		"./en-ca": 652,
		"./en-ca.js": 652,
		"./en-gb": 653,
		"./en-gb.js": 653,
		"./en-ie": 654,
		"./en-ie.js": 654,
		"./en-il": 655,
		"./en-il.js": 655,
		"./en-nz": 656,
		"./en-nz.js": 656,
		"./eo": 657,
		"./eo.js": 657,
		"./es": 660,
		"./es-do": 658,
		"./es-do.js": 658,
		"./es-us": 659,
		"./es-us.js": 659,
		"./es.js": 660,
		"./et": 661,
		"./et.js": 661,
		"./eu": 662,
		"./eu.js": 662,
		"./fa": 663,
		"./fa.js": 663,
		"./fi": 664,
		"./fi.js": 664,
		"./fo": 665,
		"./fo.js": 665,
		"./fr": 668,
		"./fr-ca": 666,
		"./fr-ca.js": 666,
		"./fr-ch": 667,
		"./fr-ch.js": 667,
		"./fr.js": 668,
		"./fy": 669,
		"./fy.js": 669,
		"./ga": 670,
		"./ga.js": 670,
		"./gd": 671,
		"./gd.js": 671,
		"./gl": 672,
		"./gl.js": 672,
		"./gom-latn": 673,
		"./gom-latn.js": 673,
		"./gu": 674,
		"./gu.js": 674,
		"./he": 675,
		"./he.js": 675,
		"./hi": 676,
		"./hi.js": 676,
		"./hr": 677,
		"./hr.js": 677,
		"./hu": 678,
		"./hu.js": 678,
		"./hy-am": 679,
		"./hy-am.js": 679,
		"./id": 680,
		"./id.js": 680,
		"./is": 681,
		"./is.js": 681,
		"./it": 683,
		"./it-ch": 682,
		"./it-ch.js": 682,
		"./it.js": 683,
		"./ja": 684,
		"./ja.js": 684,
		"./jv": 685,
		"./jv.js": 685,
		"./ka": 686,
		"./ka.js": 686,
		"./kk": 687,
		"./kk.js": 687,
		"./km": 688,
		"./km.js": 688,
		"./kn": 689,
		"./kn.js": 689,
		"./ko": 690,
		"./ko.js": 690,
		"./ku": 691,
		"./ku.js": 691,
		"./ky": 692,
		"./ky.js": 692,
		"./lb": 693,
		"./lb.js": 693,
		"./lo": 694,
		"./lo.js": 694,
		"./lt": 695,
		"./lt.js": 695,
		"./lv": 696,
		"./lv.js": 696,
		"./me": 697,
		"./me.js": 697,
		"./mi": 698,
		"./mi.js": 698,
		"./mk": 699,
		"./mk.js": 699,
		"./ml": 700,
		"./ml.js": 700,
		"./mn": 701,
		"./mn.js": 701,
		"./mr": 702,
		"./mr.js": 702,
		"./ms": 704,
		"./ms-my": 703,
		"./ms-my.js": 703,
		"./ms.js": 704,
		"./mt": 705,
		"./mt.js": 705,
		"./my": 706,
		"./my.js": 706,
		"./nb": 707,
		"./nb.js": 707,
		"./ne": 708,
		"./ne.js": 708,
		"./nl": 710,
		"./nl-be": 709,
		"./nl-be.js": 709,
		"./nl.js": 710,
		"./nn": 711,
		"./nn.js": 711,
		"./pa-in": 712,
		"./pa-in.js": 712,
		"./pl": 713,
		"./pl.js": 713,
		"./pt": 715,
		"./pt-br": 714,
		"./pt-br.js": 714,
		"./pt.js": 715,
		"./ro": 716,
		"./ro.js": 716,
		"./ru": 717,
		"./ru.js": 717,
		"./sd": 718,
		"./sd.js": 718,
		"./se": 719,
		"./se.js": 719,
		"./si": 720,
		"./si.js": 720,
		"./sk": 721,
		"./sk.js": 721,
		"./sl": 722,
		"./sl.js": 722,
		"./sq": 723,
		"./sq.js": 723,
		"./sr": 725,
		"./sr-cyrl": 724,
		"./sr-cyrl.js": 724,
		"./sr.js": 725,
		"./ss": 726,
		"./ss.js": 726,
		"./sv": 727,
		"./sv.js": 727,
		"./sw": 728,
		"./sw.js": 728,
		"./ta": 729,
		"./ta.js": 729,
		"./te": 730,
		"./te.js": 730,
		"./tet": 731,
		"./tet.js": 731,
		"./tg": 732,
		"./tg.js": 732,
		"./th": 733,
		"./th.js": 733,
		"./tl-ph": 734,
		"./tl-ph.js": 734,
		"./tlh": 735,
		"./tlh.js": 735,
		"./tr": 736,
		"./tr.js": 736,
		"./tzl": 737,
		"./tzl.js": 737,
		"./tzm": 739,
		"./tzm-latn": 738,
		"./tzm-latn.js": 738,
		"./tzm.js": 739,
		"./ug-cn": 740,
		"./ug-cn.js": 740,
		"./uk": 741,
		"./uk.js": 741,
		"./ur": 742,
		"./ur.js": 742,
		"./uz": 744,
		"./uz-latn": 743,
		"./uz-latn.js": 743,
		"./uz.js": 744,
		"./vi": 745,
		"./vi.js": 745,
		"./x-pseudo": 746,
		"./x-pseudo.js": 746,
		"./yo": 747,
		"./yo.js": 747,
		"./zh-cn": 748,
		"./zh-cn.js": 748,
		"./zh-hk": 749,
		"./zh-hk.js": 749,
		"./zh-tw": 750,
		"./zh-tw.js": 750
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1633;


/***/ }),
/* 1634 */
/***/ (function(module, exports) {

	'use strict';
	
	// http://www.ecma-international.org/ecma-262/6.0/#sec-object.is
	
	var numberIsNaN = function (value) {
		return value !== value;
	};
	
	module.exports = function is(a, b) {
		if (a === 0 && b === 0) {
			return 1 / a === 1 / b;
		}
		if (a === b) {
			return true;
		}
		if (numberIsNaN(a) && numberIsNaN(b)) {
			return true;
		}
		return false;
	};
	


/***/ }),
/* 1635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(752); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ }),
/* 1636 */
/***/ (function(module, exports) {

	exports.endianness = function () { return 'LE' };
	
	exports.hostname = function () {
	    if (typeof location !== 'undefined') {
	        return location.hostname
	    }
	    else return '';
	};
	
	exports.loadavg = function () { return [] };
	
	exports.uptime = function () { return 0 };
	
	exports.freemem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.totalmem = function () {
	    return Number.MAX_VALUE;
	};
	
	exports.cpus = function () { return [] };
	
	exports.type = function () { return 'Browser' };
	
	exports.release = function () {
	    if (typeof navigator !== 'undefined') {
	        return navigator.appVersion;
	    }
	    return '';
	};
	
	exports.networkInterfaces
	= exports.getNetworkInterfaces
	= function () { return {} };
	
	exports.arch = function () { return 'javascript' };
	
	exports.platform = function () { return 'browser' };
	
	exports.tmpdir = exports.tmpDir = function () {
	    return '/tmp';
	};
	
	exports.EOL = '\n';


/***/ }),
/* 1637 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)))

/***/ }),
/* 1638 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.0
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop, 10);
	    var marginLeft = parseFloat(styles.marginLeft, 10);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1639 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1640);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 1640 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 1641 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(1832);
	var objectAssign = __webpack_require__(210);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 1642 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(138)))

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = makeAsyncScript;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(1644));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function
	
	var idCount = 0;
	
	function makeAsyncScript(getScriptURL, options) {
	  options = options || {};
	  return function wrapWithAsyncScript(WrappedComponent) {
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
	
	    var AsyncScriptLoader =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(AsyncScriptLoader, _Component);
	
	      function AsyncScriptLoader(props, context) {
	        var _this;
	
	        _this = _Component.call(this, props, context) || this;
	        _this.state = {};
	        _this.__scriptURL = "";
	        return _this;
	      }
	
	      var _proto = AsyncScriptLoader.prototype;
	
	      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
	        if (!this.__scriptLoaderID) {
	          this.__scriptLoaderID = "async-script-loader-" + idCount++;
	        }
	
	        return this.__scriptLoaderID;
	      };
	
	      _proto.setupScriptURL = function setupScriptURL() {
	        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
	        return this.__scriptURL;
	      };
	
	      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
	        var _this2 = this;
	
	        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
	        this.setState(state, function () {
	          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
	        });
	      };
	
	      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
	        var mapEntry = SCRIPT_MAP[this.__scriptURL];
	
	        if (!mapEntry || !mapEntry.loaded) {
	          throw new Error("Script is not loaded.");
	        }
	
	        for (var obsKey in mapEntry.observers) {
	          mapEntry.observers[obsKey](mapEntry);
	        }
	
	        delete window[options.callbackName];
	      };
	
	      _proto.componentDidMount = function componentDidMount() {
	        var _this3 = this;
	
	        var scriptURL = this.setupScriptURL();
	        var key = this.asyncScriptLoaderGetScriptLoaderID();
	        var _options = options,
	            globalName = _options.globalName,
	            callbackName = _options.callbackName,
	            scriptId = _options.scriptId; // check if global object already attached to window
	
	        if (globalName && typeof window[globalName] !== "undefined") {
	          SCRIPT_MAP[scriptURL] = {
	            loaded: true,
	            observers: {}
	          };
	        } // check if script loading already
	
	
	        if (SCRIPT_MAP[scriptURL]) {
	          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"
	
	          if (entry && (entry.loaded || entry.errored)) {
	            this.asyncScriptLoaderHandleLoad(entry);
	            return;
	          } // if still loading then callback to observer queue
	
	
	          entry.observers[key] = function (entry) {
	            return _this3.asyncScriptLoaderHandleLoad(entry);
	          };
	
	          return;
	        }
	        /*
	         * hasn't started loading
	         * start the "magic"
	         * setup script to load and observers
	         */
	
	
	        var observers = {};
	
	        observers[key] = function (entry) {
	          return _this3.asyncScriptLoaderHandleLoad(entry);
	        };
	
	        SCRIPT_MAP[scriptURL] = {
	          loaded: false,
	          observers: observers
	        };
	        var script = document.createElement("script");
	        script.src = scriptURL;
	        script.async = true;
	
	        for (var attribute in options.attributes) {
	          script.setAttribute(attribute, options.attributes[attribute]);
	        }
	
	        if (scriptId) {
	          script.id = scriptId;
	        }
	
	        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
	          if (SCRIPT_MAP[scriptURL]) {
	            var mapEntry = SCRIPT_MAP[scriptURL];
	            var observersMap = mapEntry.observers;
	
	            for (var obsKey in observersMap) {
	              if (func(observersMap[obsKey])) {
	                delete observersMap[obsKey];
	              }
	            }
	          }
	        };
	
	        if (callbackName && typeof window !== "undefined") {
	          window[callbackName] = function () {
	            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
	          };
	        }
	
	        script.onload = function () {
	          var mapEntry = SCRIPT_MAP[scriptURL];
	
	          if (mapEntry) {
	            mapEntry.loaded = true;
	            callObserverFuncAndRemoveObserver(function (observer) {
	              if (callbackName) {
	                return false;
	              }
	
	              observer(mapEntry);
	              return true;
	            });
	          }
	        };
	
	        script.onerror = function () {
	          var mapEntry = SCRIPT_MAP[scriptURL];
	
	          if (mapEntry) {
	            mapEntry.errored = true;
	            callObserverFuncAndRemoveObserver(function (observer) {
	              observer(mapEntry);
	              return true;
	            });
	          }
	        };
	
	        document.body.appendChild(script);
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        // Remove tag script
	        var scriptURL = this.__scriptURL;
	
	        if (options.removeOnUnmount === true) {
	          var allScripts = document.getElementsByTagName("script");
	
	          for (var i = 0; i < allScripts.length; i += 1) {
	            if (allScripts[i].src.indexOf(scriptURL) > -1) {
	              if (allScripts[i].parentNode) {
	                allScripts[i].parentNode.removeChild(allScripts[i]);
	              }
	            }
	          }
	        } // Clean the observer entry
	
	
	        var mapEntry = SCRIPT_MAP[scriptURL];
	
	        if (mapEntry) {
	          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];
	
	          if (options.removeOnUnmount === true) {
	            delete SCRIPT_MAP[scriptURL];
	          }
	        }
	      };
	
	      _proto.render = function render() {
	        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps
	
	        var _this$props = this.props,
	            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
	            forwardedRef = _this$props.forwardedRef,
	            childProps = _objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars
	
	
	        if (globalName && typeof window !== "undefined") {
	          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
	        }
	
	        childProps.ref = forwardedRef;
	        return (0, _react.createElement)(WrappedComponent, childProps);
	      };
	
	      return AsyncScriptLoader;
	    }(_react.Component); // Note the second param "ref" provided by React.forwardRef.
	    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
	    // And it can then be attached to the Component.
	
	
	    var ForwardedComponent = (0, _react.forwardRef)(function (props, ref) {
	      return (0, _react.createElement)(AsyncScriptLoader, _extends({}, props, {
	        forwardedRef: ref
	      }));
	    });
	    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
	    ForwardedComponent.propTypes = {
	      asyncScriptOnLoad: _propTypes["default"].func
	    };
	    return (0, _hoistNonReactStatics["default"])(ForwardedComponent, WrappedComponent);
	  };
	}

/***/ }),
/* 1644 */
[1911, 212],
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	var __importStar = (this && this.__importStar) || function (mod) {
	    if (mod && mod.__esModule) return mod;
	    var result = {};
	    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	    result["default"] = mod;
	    return result;
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var React = __importStar(__webpack_require__(1));
	var react_1 = __webpack_require__(1);
	var ReactCardFlip = function (props) {
	    var flipDirection = props.flipDirection, infinite = props.infinite, flipSpeedFrontToBack = props.flipSpeedFrontToBack, flipSpeedBackToFront = props.flipSpeedBackToFront, _a = props.cardStyles, front = _a.front, back = _a.back, containerStyle = props.containerStyle, cardZIndex = props.cardZIndex;
	    var _b = react_1.useState(props.isFlipped), isFlipped = _b[0], setFlipped = _b[1];
	    var _c = react_1.useState(0), rotation = _c[0], setRotation = _c[1];
	    react_1.useEffect(function () {
	        if (props.isFlipped !== isFlipped) {
	            setFlipped(props.isFlipped);
	            setRotation(function (c) { return c + 180; });
	        }
	    }, [props.isFlipped]);
	    var getComponent = function (key) {
	        if (props.children.length !== 2) {
	            throw new Error('Component ReactCardFlip requires 2 children to function');
	        }
	        return props.children[key];
	    };
	    var frontRotateY = "rotateY(" + (infinite ? rotation : isFlipped ? 180 : 0) + "deg)";
	    var backRotateY = "rotateY(" + (infinite ? rotation + 180 : isFlipped ? 0 : -180) + "deg)";
	    var frontRotateX = "rotateX(" + (infinite ? rotation : isFlipped ? 180 : 0) + "deg)";
	    var backRotateX = "rotateX(" + (infinite ? rotation + 180 : isFlipped ? 0 : -180) + "deg)";
	    var styles = {
	        container: {
	            perspective: '1000px',
	            zIndex: "" + cardZIndex
	        },
	        flipper: {
	            position: 'relative',
	            width: '100%',
	            height: '100%'
	        },
	        front: __assign({ WebkitBackfaceVisibility: 'hidden', backfaceVisibility: 'hidden', left: '0', position: isFlipped ? 'absolute' : 'relative', top: '0', transform: flipDirection === 'horizontal' ? frontRotateY : frontRotateX, transformStyle: 'preserve-3d', width: '100%', height: '100%', zIndex: '2', transition: flipSpeedBackToFront + "s" }, front),
	        back: __assign({ WebkitBackfaceVisibility: 'hidden', backfaceVisibility: 'hidden', left: '0', position: isFlipped ? 'relative' : 'absolute', transform: flipDirection === 'horizontal' ? backRotateY : backRotateX, transformStyle: 'preserve-3d', top: '0', width: '100%', height: '100%', transition: flipSpeedFrontToBack + "s" }, back)
	    };
	    return (React.createElement("div", { className: "react-card-flip", style: __assign(__assign({}, styles.container), containerStyle) },
	        React.createElement("div", { className: "react-card-flipper", style: styles.flipper },
	            React.createElement("div", { className: "react-card-front", style: styles.front }, getComponent(0)),
	            React.createElement("div", { className: "react-card-back", style: styles.back }, getComponent(1)))));
	};
	ReactCardFlip.defaultProps = {
	    containerStyle: {},
	    cardStyles: {
	        front: {},
	        back: {}
	    },
	    cardZIndex: 'auto',
	    flipDirection: 'horizontal',
	    flipSpeedBackToFront: 0.6,
	    flipSpeedFrontToBack: 0.6,
	    infinite: false,
	    isFlipped: false
	};
	exports.default = ReactCardFlip;


/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.12.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1),n=__webpack_require__(210),q=__webpack_require__(1830);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
	function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
	function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
	function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
	var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
	function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
	return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
	var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
	60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
	function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
	function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
	"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
	var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
	function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
	["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
	tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
	D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
	function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
	function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
	function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
	function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
	Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
	function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
	function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
	c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
	function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
	function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
	function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
	function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
	function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
	function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
	function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
	function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
	n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
	function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
	var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
	a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
	b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
	elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
	0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
	0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
	2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
	"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
	var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
	Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
	function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
	var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
	function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
	function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
	function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
	function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
	var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
	function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
	function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
	function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
	function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
	function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
	function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
	function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
	function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
	function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
	var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
	function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
	function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
	var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
	b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
	var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
	function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
	var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
	dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
	e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
	a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
	h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
	var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
	function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
	var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
	case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
	function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
	function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
	function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
	var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
	function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
	function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
	function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
	function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
	function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
	function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
	function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
	function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
	k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
	function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
	var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
	c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
	function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
	function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
	function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
	function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
	function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
	Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
	r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
	if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
	p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
	k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
	typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
	function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
	function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
	var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
	function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
	function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
	function Ph(a,b){return"function"===typeof b?b(a):b}
	function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
	d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
	function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
	function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
	function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
	function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
	(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
	var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
	[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
	c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
	null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
	N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
	function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
	function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
	function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
	function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
	function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
	function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
	g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
	"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
	("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
	d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
	function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
	var xi={dehydrated:null,retryTime:0};
	function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
	b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
	null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
	function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
	function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
	null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
	function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
	Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
	Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
	h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
	c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
	function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
	function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
	var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
	function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
	function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
	function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
	function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
	e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
	f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
	function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
	d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
	if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
	a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
	function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
	function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
	var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
	function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
	function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
	function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
	function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
	function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
	b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
	function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
	c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
	d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
	pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
	function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
	function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
	function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
	function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
	H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
	"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
	(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
	function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
	function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
	lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
	{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
	(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
	k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
	c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
	Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
	typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
	null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
	e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
	d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
	64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
	e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
	V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
	function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
	d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
	m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
	null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
	Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
	l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
	"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
	fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
	Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
	(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
	function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
	function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
	function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
	gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
	1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
	typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
	e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
	null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
	b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
	e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
	c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
	case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
	function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
	function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
	function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
	function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
	firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
	function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
	10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
	function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
	function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
	function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
	function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
	function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
	d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
	function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
	function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
	function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
	Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
	fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
	var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
	if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
	xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
	(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
	rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 1647 */
1298,
/* 1648 */
/***/ (function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getColumnProps = getColumnProps;
	exports.default = Col;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createProps = __webpack_require__(387);
	
	var _createProps2 = _interopRequireDefault(_createProps);
	
	var _classNames = __webpack_require__(386);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	var _types = __webpack_require__(753);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  xs: _types.ColumnSizeType,
	  sm: _types.ColumnSizeType,
	  md: _types.ColumnSizeType,
	  lg: _types.ColumnSizeType,
	  xl: _types.ColumnSizeType,
	  xsOffset: _propTypes2.default.number,
	  smOffset: _propTypes2.default.number,
	  mdOffset: _propTypes2.default.number,
	  lgOffset: _propTypes2.default.number,
	  xlOffset: _propTypes2.default.number,
	  first: _types.ViewportSizeType,
	  last: _types.ViewportSizeType,
	  className: _propTypes2.default.string,
	  tagName: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	var classMap = {
	  xs: 'col-xs',
	  sm: 'col-sm',
	  md: 'col-md',
	  lg: 'col-lg',
	  xl: 'col-xl',
	  xsOffset: 'col-xs-offset',
	  smOffset: 'col-sm-offset',
	  mdOffset: 'col-md-offset',
	  lgOffset: 'col-lg-offset',
	  xlOffset: 'col-xl-offset'
	};
	
	function isInteger(value) {
	  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	}
	
	function getColClassNames(props) {
	  var extraClasses = [];
	
	  if (props.className) {
	    extraClasses.push(props.className);
	  }
	
	  if (props.first) {
	    extraClasses.push((0, _classNames2.default)('first-' + props.first));
	  }
	
	  if (props.last) {
	    extraClasses.push((0, _classNames2.default)('last-' + props.last));
	  }
	
	  return Object.keys(props).filter(function (key) {
	    return classMap[key];
	  }).map(function (key) {
	    return (0, _classNames2.default)(isInteger(props[key]) ? classMap[key] + '-' + props[key] : classMap[key]);
	  }).concat(extraClasses);
	}
	
	function getColumnProps(props) {
	  return (0, _createProps2.default)(propTypes, props, getColClassNames(props));
	}
	
	function Col(props) {
	  var tagName = props.tagName,
	      columnProps = _objectWithoutProperties(props, ['tagName']);
	
	  return _react2.default.createElement(tagName || 'div', getColumnProps(columnProps));
	}
	
	Col.propTypes = propTypes;

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Grid;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createProps = __webpack_require__(387);
	
	var _createProps2 = _interopRequireDefault(_createProps);
	
	var _classNames = __webpack_require__(386);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  fluid: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  tagName: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	function Grid(props) {
	  var containerClass = (0, _classNames2.default)(props.fluid ? 'container-fluid' : 'container');
	  var classNames = [props.className, containerClass];
	
	  return _react2.default.createElement(props.tagName || 'div', (0, _createProps2.default)(propTypes, props, classNames));
	}
	
	Grid.propTypes = propTypes;

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRowProps = getRowProps;
	exports.default = Row;
	
	var _classNames = __webpack_require__(386);
	
	var _classNames2 = _interopRequireDefault(_classNames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createProps = __webpack_require__(387);
	
	var _createProps2 = _interopRequireDefault(_createProps);
	
	var _types = __webpack_require__(753);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowKeys = ['start', 'center', 'end', 'top', 'middle', 'bottom', 'around', 'between'];
	
	var propTypes = {
	  reverse: _propTypes2.default.bool,
	  start: _types.ViewportSizeType,
	  center: _types.ViewportSizeType,
	  end: _types.ViewportSizeType,
	  top: _types.ViewportSizeType,
	  middle: _types.ViewportSizeType,
	  bottom: _types.ViewportSizeType,
	  around: _types.ViewportSizeType,
	  between: _types.ViewportSizeType,
	  className: _propTypes2.default.string,
	  tagName: _propTypes2.default.string,
	  children: _propTypes2.default.node
	};
	
	function getRowClassNames(props) {
	  var modificators = [props.className, (0, _classNames2.default)('row')];
	
	  for (var i = 0; i < rowKeys.length; ++i) {
	    var key = rowKeys[i];
	    var value = props[key];
	    if (value) {
	      modificators.push((0, _classNames2.default)(key + '-' + value));
	    }
	  }
	
	  if (props.reverse) {
	    modificators.push((0, _classNames2.default)('reverse'));
	  }
	
	  return modificators;
	}
	
	function getRowProps(props) {
	  return (0, _createProps2.default)(propTypes, props, getRowClassNames(props));
	}
	
	function Row(props) {
	  return _react2.default.createElement(props.tagName || 'div', getRowProps(props));
	}
	
	Row.propTypes = propTypes;

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _recaptchaWrapper = _interopRequireDefault(__webpack_require__(1653));
	
	var _recaptcha = _interopRequireDefault(__webpack_require__(754));
	
	exports.ReCAPTCHA = _recaptcha["default"];
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _recaptchaWrapper["default"];
	exports["default"] = _default;

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _recaptcha = _interopRequireDefault(__webpack_require__(754));
	
	var _reactAsyncScript = _interopRequireDefault(__webpack_require__(1643));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var callbackName = "onloadcallback";
	var globalName = "grecaptcha";
	
	function getOptions() {
	  return typeof window !== "undefined" && window.recaptchaOptions || {};
	}
	
	function getURL() {
	  var dynamicOptions = getOptions();
	  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
	  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
	}
	
	var _default = (0, _reactAsyncScript["default"])(getURL, {
	  callbackName: callbackName,
	  globalName: globalName
	})(_recaptcha["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(1717);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(1648);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(1655);
	
	var _HelmetConstants = __webpack_require__(755);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 1655 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(210);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(755);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1656 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var r=__webpack_require__(1),e=function(){return(e=Object.assign||function(r){for(var e,t=1,n=arguments.length;t<n;t++)for(var u in e=arguments[t])Object.prototype.hasOwnProperty.call(e,u)&&(r[u]=e[u]);return r}).apply(this,arguments)};function t(r,e){var t={};for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&e.indexOf(n)<0&&(t[n]=r[n]);if(null!=r&&"function"==typeof Object.getOwnPropertySymbols){var u=0;for(n=Object.getOwnPropertySymbols(r);u<n.length;u++)e.indexOf(n[u])<0&&Object.prototype.propertyIsEnumerable.call(r,n[u])&&(t[n[u]]=r[n[u]])}return t}function n(r,e,t,n){return new(t||(t=Promise))((function(u,i){function a(r){try{o(n.next(r))}catch(r){i(r)}}function c(r){try{o(n.throw(r))}catch(r){i(r)}}function o(r){var e;r.done?u(r.value):(e=r.value,e instanceof t?e:new t((function(r){r(e)}))).then(a,c)}o((n=n.apply(r,e||[])).next())}))}function u(r,e){var t,n,u,i,a={label:0,sent:function(){if(1&u[0])throw u[1];return u[1]},trys:[],ops:[]};return i={next:c(0),throw:c(1),return:c(2)},"function"==typeof Symbol&&(i[Symbol.iterator]=function(){return this}),i;function c(i){return function(c){return function(i){if(t)throw new TypeError("Generator is already executing.");for(;a;)try{if(t=1,n&&(u=2&i[0]?n.return:i[0]?n.throw||((u=n.return)&&u.call(n),0):n.next)&&!(u=u.call(n,i[1])).done)return u;switch(n=0,u&&(i=[2&i[0],u.value]),i[0]){case 0:case 1:u=i;break;case 4:return a.label++,{value:i[1],done:!1};case 5:a.label++,n=i[1],i=[0];continue;case 7:i=a.ops.pop(),a.trys.pop();continue;default:if(!(u=a.trys,(u=u.length>0&&u[u.length-1])||6!==i[0]&&2!==i[0])){a=0;continue}if(3===i[0]&&(!u||i[1]>u[0]&&i[1]<u[3])){a.label=i[1];break}if(6===i[0]&&a.label<u[1]){a.label=u[1],u=i;break}if(u&&a.label<u[2]){a.label=u[2],a.ops.push(i);break}u[2]&&a.ops.pop(),a.trys.pop();continue}i=e.call(r,a)}catch(r){i=[6,r],n=0}finally{t=u=0}if(5&i[0])throw i[1];return{value:i[0]?i[1]:void 0,done:!0}}([i,c])}}}function i(r){var e="function"==typeof Symbol&&Symbol.iterator,t=e&&r[e],n=0;if(t)return t.call(r);if(r&&"number"==typeof r.length)return{next:function(){return r&&n>=r.length&&(r=void 0),{value:r&&r[n++],done:!r}}};throw new TypeError(e?"Object is not iterable.":"Symbol.iterator is not defined.")}function a(r,e){var t="function"==typeof Symbol&&r[Symbol.iterator];if(!t)return r;var n,u,i=t.call(r),a=[];try{for(;(void 0===e||e-- >0)&&!(n=i.next()).done;)a.push(n.value)}catch(r){u={error:r}}finally{try{n&&!n.done&&(t=i.return)&&t.call(i)}finally{if(u)throw u.error}}return a}function c(){for(var r=[],e=0;e<arguments.length;e++)r=r.concat(a(arguments[e]));return r}var o=function(r){return r instanceof HTMLElement},s="blur",l="change",f="input",d="onBlur",v="onChange",y="onSubmit",h="onTouched",p="all",m="max",b="min",g="maxLength",A="minLength",x="pattern",R="required",V="validate";var w=function(r){return null==r},F=function(r){return"object"==typeof r},C=function(r){return!w(r)&&!Array.isArray(r)&&F(r)&&!(r instanceof Date)},S=function(r){return/^\w*$/.test(r)},k=function(r){return r.filter(Boolean)},O=function(r){return k(r.replace(/["|']/g,"").replace(/\[/g,".").replace(/\]/g,"").split("."))};function D(r,e,t){for(var n=-1,u=S(e)?[e]:O(e),i=u.length,a=i-1;++n<i;){var c=u[n],o=t;if(n!==a){var s=r[c];o=C(s)||Array.isArray(s)?s:isNaN(+u[n+1])?{}:[]}r[c]=o,r=r[c]}return r}var E=function(r,e){for(var t in void 0===e&&(e={}),r)S(t)?e[t]=r[t]:D(e,t,r[t]);return e},B=function(r){return void 0===r},j=function(r,e,t){void 0===r&&(r={});var n=k(e.split(/[,[\].]+?/)).reduce((function(r,e){return w(r)?r:r[e]}),r);return B(n)||n===r?B(r[e])?t:r[e]:n},N=function(r,e){o(r)&&r.removeEventListener&&(r.removeEventListener(f,e),r.removeEventListener(l,e),r.removeEventListener(s,e))},T={isValid:!1,value:""},L=function(r){return Array.isArray(r)?r.reduce((function(r,e){return e&&e.ref.checked?{isValid:!0,value:e.ref.value}:r}),T):T},W=function(r){return"radio"===r.type},M=function(r){return"file"===r.type},P=function(r){return"checkbox"===r.type},U=function(r){return"select-multiple"===r.type},q={value:!1,isValid:!1},H={value:!0,isValid:!0},I=function(r){if(Array.isArray(r)){if(r.length>1){var e=r.filter((function(r){return r&&r.ref.checked})).map((function(r){return r.ref.value}));return{value:e,isValid:!!e.length}}var t=r[0].ref,n=t.checked,u=t.value,i=t.attributes;return n?i&&!B(i.value)?B(u)||""===u?H:{value:u,isValid:!0}:H:q}return q};function _(r,e,t,n){var u=r.current[e];if(u){var i=u.ref,a=i.value,o=i.disabled,s=u.ref,l=u.valueAsNumber,f=u.valueAsDate,d=u.setValueAs;if(o&&n)return;return M(s)?s.files:W(s)?L(u.options).value:U(s)?c(s.options).filter((function(r){return r.selected})).map((function(r){return r.value})):P(s)?I(u.options).value:l?+a:f?s.valueAsDate:d?d(a):a}if(t)return j(t.current,e)}function z(r){return!r||r instanceof HTMLElement&&r.nodeType!==Node.DOCUMENT_NODE&&z(r.parentNode)}var G=function(r){return C(r)&&!Object.keys(r).length},$=function(r){return"boolean"==typeof r};function J(r,e){var t=S(e)?[e]:O(e),n=1==t.length?r:function(r,e){for(var t=e.slice(0,-1).length,n=0;n<t;)r=B(r)?n++:r[e[n++]];return r}(r,t),u=t[t.length-1],i=void 0;n&&delete n[u];for(var a=0;a<t.slice(0,-1).length;a++){var c=-1,o=void 0,s=t.slice(0,-(a+1)),l=s.length-1;for(a>0&&(i=r);++c<s.length;){var f=s[c];o=o?o[f]:r[f],l===c&&(C(o)&&G(o)||Array.isArray(o)&&!o.filter((function(r){return C(r)&&!G(r)||$(r)})).length)&&(i?delete i[f]:delete r[f]),i=o}}return r}var K=function(r,e){return r&&r.ref===e};var Q=function(r){return w(r)||!F(r)};function X(r,e){if(Q(r)||Q(e))return e;for(var t in e){var n=r[t],u=e[t];try{r[t]=C(n)&&C(u)||Array.isArray(n)&&Array.isArray(u)?X(n,u):u}catch(r){}}return r}function Y(r,t,n,u,i){for(var a,c=-1;++c<r.length;){for(var o in r[c])Array.isArray(r[c][o])?(!n[c]&&(n[c]={}),n[c][o]=[],Y(r[c][o],j(t[c]||{},o,[]),n[c][o],n[c],o)):j(t[c]||{},o)===r[c][o]?D(n[c]||{},o):n[c]=e(e({},n[c]),((a={})[o]=!0,a));u&&!n.length&&delete u[i]}return n}var Z=function(r,e,t){return X(Y(r,e,t),Y(e,r,t))},rr=function(r){return"string"==typeof r},er=function(r,e,t,n,u){var i={},a=function(e){(B(u)||(rr(u)?e.startsWith(u):Array.isArray(u)&&u.find((function(r){return e.startsWith(r)}))))&&(i[e]=_(r,e,void 0,n))};for(var c in r.current)a(c);return t?E(i):X(e,E(i))};function tr(e,t,n){var u,a;if(Q(e)||Q(t)||e instanceof Date||t instanceof Date)return e===t;if(!r.isValidElement(e)){var c=Object.keys(e),o=Object.keys(t);if(c.length!==o.length)return!1;try{for(var s=i(c),l=s.next();!l.done;l=s.next()){var f=l.value,d=e[f];if(!n||"ref"!==f){var v=t[f];if((C(d)||Array.isArray(d))&&(C(v)||Array.isArray(v))?!tr(d,v,n):d!==v)return!1}}}catch(r){u={error:r}}finally{try{l&&!l.done&&(a=s.return)&&a.call(s)}finally{if(u)throw u.error}}}return!0}var nr=function(r){return r instanceof RegExp},ur=function(r){return C(r)&&!nr(r)?r:{value:r,message:""}},ir=function(r){return"function"==typeof r},ar=function(e){return rr(e)||r.isValidElement(e)};function cr(r,e,t){if(void 0===t&&(t="validate"),ar(r)||$(r)&&!r)return{type:t,message:ar(r)?r:"",ref:e}}var or=function(r,t,n,u,i){var a;return t?e(e({},n[r]),{types:e(e({},n[r]&&n[r].types?n[r].types:{}),(a={},a[u]=i||!0,a))}):{}},sr=function(r,t,c,o){var s=c.ref,l=c.ref.value,f=c.options,d=c.required,v=c.maxLength,y=c.minLength,h=c.min,p=c.max,F=c.pattern,S=c.validate;return n(void 0,void 0,void 0,(function(){var n,c,k,O,D,E,B,j,N,T,M,U,q,H,z,J,K,Q,X,Y,Z,er,tr,sr,lr,fr,dr,vr,yr,hr,pr,mr,br,gr,Ar;return u(this,(function(u){switch(u.label){case 0:return n=s.name,c={},k=W(s),O=P(s),D=k||O,E=""===l,B=or.bind(null,n,t,c),j=function(r,t,u,i,a){void 0===i&&(i=g),void 0===a&&(a=A);var o=r?t:u;c[n]=e({type:r?i:a,message:o,ref:s},B(r?i:a,o))},d&&(!k&&!O&&(E||w(l))||$(l)&&!l||O&&!I(f).isValid||k&&!L(f).isValid)&&(N=ar(d)?{value:!!d,message:d}:ur(d),T=N.value,Z=N.message,T&&(c[n]=e({type:R,message:Z,ref:D?((r.current[n].options||[])[0]||{}).ref:s},B(R,Z)),!t))?[2,c]:(w(h)&&w(p)||""===l||(K=void 0,Q=void 0,M=ur(p),U=ur(h),isNaN(l)?(H=s.valueAsDate||new Date(l),rr(M.value)&&(K=H>new Date(M.value)),rr(U.value)&&(Q=H<new Date(U.value))):(q=s.valueAsNumber||parseFloat(l),w(M.value)||(K=q>M.value),w(U.value)||(Q=q<U.value)),!K&&!Q||(j(!!K,M.message,U.message,m,b),t)))&&(!rr(l)||E||!v&&!y||(z=ur(v),J=ur(y),K=!w(z.value)&&l.length>z.value,Q=!w(J.value)&&l.length<J.value,!K&&!Q||(j(K,z.message,J.message),t)))&&(!F||E||(X=ur(F),Y=X.value,Z=X.message,!nr(Y)||Y.test(l)||(c[n]=e({type:x,message:Z,ref:s},B(x,Z)),t)))?S?(er=_(r,n,o),tr=D&&f?f[0].ref:s,ir(S)?[4,S(er)]:[3,2]):[3,11]:[2,c];case 1:return sr=u.sent(),(mr=cr(sr,tr))&&(c[n]=e(e({},mr),B(V,mr.message)),!t)?[2,c]:[3,11];case 2:if(!C(S))return[3,11];lr={},u.label=3;case 3:u.trys.push([3,8,9,10]),fr=i(Object.entries(S)),dr=fr.next(),u.label=4;case 4:return dr.done?[3,7]:(vr=a(dr.value,2),yr=vr[0],hr=vr[1],G(lr)||t?[4,hr(er)]:[3,7]);case 5:pr=u.sent(),(mr=cr(pr,tr,yr))&&(lr=e(e({},mr),B(yr,mr.message)),t&&(c[n]=lr)),u.label=6;case 6:return dr=fr.next(),[3,4];case 7:return[3,10];case 8:return br=u.sent(),gr={error:br},[3,10];case 9:try{dr&&!dr.done&&(Ar=fr.return)&&Ar.call(fr)}finally{if(gr)throw gr.error}return[7];case 10:if(!G(lr)&&(c[n]=e({ref:tr},lr),!t))return[2,c];u.label=11;case 11:return[2,c]}}))}))},lr=function(r,e,t){for(var n in void 0===t&&(t=[]),e){var u=r+(C(e)?"."+n:"["+n+"]");Q(e[n])?t.push(u):lr(u,e[n],t)}return t},fr=function(r,e,t,n,u){var i=void 0;return t.add(e),G(r)||(i=j(r,e),(C(i)||Array.isArray(i))&&lr(e,i).forEach((function(r){return t.add(r)}))),B(i)?u?n:j(n,e):i},dr=function(r){var e=r.isOnBlur,t=r.isOnChange,n=r.isOnTouch,u=r.isTouched,i=r.isReValidateOnBlur,a=r.isReValidateOnChange,c=r.isBlurEvent,o=r.isSubmitted;return!r.isOnAll&&(!o&&n?!(u||c):(o?i:e)?!c:!(o?a:t)||c)},vr=function(r){return r.substring(0,r.indexOf("["))},yr=function(r,e){return RegExp(("^"+e+"([|.)\\d+").replace(/\[/g,"\\[").replace(/\]/g,"\\]")).test(r)},hr=function(r,e){return c(r).some((function(r){return yr(e,r)}))};var pr="undefined"!=typeof window&&"undefined"!=typeof document;function mr(r){var e,t,n,u,a;if(Q(r)||pr&&r instanceof File)return r;if(r instanceof Date)return a=new Date(r.getTime());if(r instanceof Set){a=new Set;try{for(var c=i(r),o=c.next();!o.done;o=c.next()){var s=o.value;a.add(s)}}catch(r){e={error:r}}finally{try{o&&!o.done&&(t=c.return)&&t.call(c)}finally{if(e)throw e.error}}return a}if(r instanceof Map){a=new Map;try{for(var l=i(r.keys()),f=l.next();!f.done;f=l.next()){var d=f.value;a.set(d,mr(r.get(d)))}}catch(r){n={error:r}}finally{try{f&&!f.done&&(u=l.return)&&u.call(l)}finally{if(n)throw n.error}}return a}for(var d in a=Array.isArray(r)?[]:{},r)a[d]=mr(r[d]);return a}var br=function(r){return{isOnSubmit:!r||r===y,isOnBlur:r===d,isOnChange:r===v,isOnAll:r===p,isOnTouch:r===h}},gr=function(r){return W(r)||P(r)},Ar="undefined"==typeof window,xr=pr?"Proxy"in window:"undefined"!=typeof Proxy;var Rr=r.createContext(null);Rr.displayName="RHFContext";var Vr=function(){return r.useContext(Rr)},wr=function(){var r="undefined"==typeof performance?Date.now():1e3*performance.now();return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(e){var t=(16*Math.random()+r)%16|0;return("x"==e?t:3&t|8).toString(16)}))};var Fr=function(r,e){return B(e)?[]:function(r,e){var t,n,u=0,a=c(r);try{for(var o=i(e),s=o.next();!s.done;s=o.next()){var l=s.value;a.splice(l-u,1),u++}}catch(r){t={error:r}}finally{try{s&&!s.done&&(n=o.return)&&n.call(o)}finally{if(t)throw t.error}}return k(a).length?a:[]}(r,(Array.isArray(e)?e:[e]).sort())},Cr=function(r,e,t){return Array.isArray(r)?(B(r[t])&&(r[t]=void 0),r.splice(t,0,r.splice(e,1)[0]),r):[]},Sr=function(r,e,t){var n=[r[t],r[e]];r[e]=n[0],r[t]=n[1]};function kr(r,e){return c(Array.isArray(e)?e:[e||void 0],r)}function Or(r,e,t){return c(r.slice(0,e),Array.isArray(t)?t:[t||void 0],r.slice(e))}var Dr=function(r){return Array.isArray(r)?Array(r.length).fill(void 0):void 0},Er=function(r){return(Array.isArray(r)?r:[r]).map((function(r){if(C(r)){var e={};for(var t in r)e[t]=!0;return e}return!0}))},Br=function(r,t){return void 0===r&&(r=[]),r.map((function(r){var n;return e(((n={})[t]=wr(),n),r)}))};function jr(t){var n=t.name,u=t.rules,i=t.defaultValue,c=t.control,o=t.onFocus,s=Vr(),l=c||s.control,f=l.defaultValuesRef,d=l.setValue,v=l.register,y=l.unregister,h=l.trigger,p=l.mode,m=l.reValidateMode,b=m.isReValidateOnBlur,g=m.isReValidateOnChange,A=l.formStateRef.current,x=A.isSubmitted,R=A.touched,V=A.errors,w=A.dirtyFields,F=l.updateFormState,S=l.readFormStateRef,k=l.fieldsRef,O=l.fieldArrayNamesRef,E=l.shallowFieldsStateRef,N=!hr(O.current,n),T=function(){return!B(j(E.current,n))&&N?j(E.current,n):B(i)?j(f.current,n):i},L=a(r.useState(T()),2),W=L[0],M=L[1],P=r.useRef(W),U=r.useRef({focus:function(){return null}}),q=r.useRef(o||function(){ir(U.current.focus)&&U.current.focus()}),H=r.useCallback((function(r){return!dr(e({isBlurEvent:r,isReValidateOnBlur:b,isReValidateOnChange:g,isSubmitted:x,isTouched:!!j(R,n)},p))}),[b,g,x,R,n,p]),I=r.useCallback((function(r){var e=function(r){return Q(r)||!C(r.target)||C(r.target)&&!r.type?r:B(r.target.value)?r.target.checked:r.target.value}(a(r,1)[0]);return M(e),P.current=e,e}),[]),_=r.useCallback((function(r){k.current[n]?k.current[n]=e({ref:k.current[n].ref},u):(v(Object.defineProperty({name:n,focus:q.current},"value",{set:function(r){M(r),P.current=r},get:function(){return P.current}}),u),r=B(j(f.current,n))),r&&N&&M(T())}),[u,n,v]);r.useEffect((function(){return function(){return y(n)}}),[n]),r.useEffect((function(){_()}),[_]),r.useEffect((function(){!k.current[n]&&_(!0)}));var z=r.useCallback((function(){S.current.touched&&!j(R,n)&&(D(R,n,!0),F({touched:R})),H(!0)&&h(n)}),[n,F,H,h,S]);return{field:{onChange:r.useCallback((function(){for(var r=[],e=0;e<arguments.length;e++)r[e]=arguments[e];return d(n,I(r),{shouldValidate:H(),shouldDirty:!0})}),[d,n,H]),onBlur:z,name:n,value:W,ref:U},state:{inValid:!j(V,n),isDirty:!!j(w,n),isTouched:!!j(R,n)}}}exports.Controller=function(n){n.rules;var u=n.as,i=n.render,a=(n.defaultValue,n.control,n.onFocus,t(n,["rules","as","render","defaultValue","control","onFocus"])),c=jr(n).field,o=e(e({},a),c);return u?r.isValidElement(u)?r.cloneElement(u,o):r.createElement(u,o):i?i(c):null},exports.FormProvider=function(n){var u=n.children,i=t(n,["children"]);return r.createElement(Rr.Provider,{value:e({},i)},u)},exports.appendErrors=or,exports.get=j,exports.transformToNestObject=E,exports.useFieldArray=function(n){var u=n.control,i=n.name,o=n.keyName,s=void 0===o?"id":o,l=Vr(),f=r.useRef(-1),d=u||l.control,v=d.isFormDirty,y=d.updateWatchedValue,h=d.resetFieldArrayFunctionRef,p=d.fieldArrayNamesRef,m=d.fieldsRef,b=d.defaultValuesRef,g=d.removeFieldEventListener,A=d.formStateRef,x=d.shallowFieldsStateRef,R=d.updateFormState,V=d.readFormStateRef,w=d.validFieldsRef,F=d.fieldsWithValidationRef,C=d.fieldArrayDefaultValuesRef,S=d.validateResolver,O=d.getValues,E=d.shouldUnregister,B=d.fieldArrayValuesRef,N=vr(i),T=r.useRef(c(j(C.current,N)?j(C.current,i,[]):j(E?b.current:x.current,i,[]))),L=a(r.useState(Br(T.current,s)),2),W=L[0],M=L[1];D(B.current,i,W);var P=function(r){return r.map((function(r){void 0===r&&(r={});var e=s;r[e];return t(r,["symbol"==typeof e?e:e+""])}))};p.current.add(i);var U=r.useCallback((function(){return j(B.current,i,[])}),[]),q=function(){return j(O(),i,U()).map((function(r,t){return e(e({},U()[t]),r)}))};p.current.add(i),N&&!j(C.current,N)&&D(C.current,N,mr(j(b.current,N)));var H=function(r){if(M(r),D(B.current,i,r),V.current.isValid&&S){var e=O();D(e,i,r),S(e)}},I=function(){for(var r in m.current)yr(r,i)&&g(m.current[r],!0)},_=function(r){return!k(j(r,i,[])).length&&J(r,i)},z=function(r){r&&D(A.current.dirtyFields,i,Z(P(r),j(b.current,i,[]),j(A.current.dirtyFields,i,[])))},G=function(r,e,t,n,u,a){if(void 0===n&&(n=[]),void 0===u&&(u=!0),void 0===a&&(a=!1),j(x.current,i)){var c=r(j(x.current,i),e.argA,e.argB);u&&D(x.current,i,c)}if(j(C.current,i)){c=r(j(C.current,i),e.argA,e.argB);u&&D(C.current,i,c),_(C.current)}if(Array.isArray(j(A.current.errors,i))){c=r(j(A.current.errors,i),e.argA,e.argB);u&&D(A.current.errors,i,c),_(A.current.errors)}if(V.current.touched&&j(A.current.touched,i)){c=r(j(A.current.touched,i),e.argA,e.argB);u&&D(A.current.touched,i,c),_(A.current.touched)}if(V.current.dirtyFields||V.current.isDirty){c=r(j(A.current.dirtyFields,i,[]),e.argC,e.argD);u&&D(A.current.dirtyFields,i,c),z(t),_(A.current.dirtyFields)}a&&V.current.isValid&&!S&&(D(w.current,i,r(j(w.current,i,[]),e.argA)),_(w.current),D(F.current,i,r(j(F.current,i,[]),e.argA)),_(F.current)),R({isDirty:v(i,P(n))})};return r.useEffect((function(){var r=j(C.current,i);if(r&&W.length<r.length&&(r.pop(),D(C.current,i,r)),y(i),f.current>-1)for(var e in m.current){var t=m.current[e];if(e.startsWith(i+"["+f.current+"]")&&t.ref.focus){t.ref.focus();break}}f.current=-1}),[W,i]),r.useEffect((function(){var r=h.current,e=p.current;return vr(i)||(r[i]=function(r){I(),!r&&J(C.current,i),J(x.current,i),T.current=j(r||b.current,i),M(Br(T.current,s))}),function(){I(),delete r[i],J(B,i),e.delete(i)}}),[]),{swap:r.useCallback((function(r,e){var t=q();Sr(t,r,e),I(),H(c(t)),G(Sr,{argA:r,argB:e,argC:r,argD:e},void 0,t,!1)}),[i]),move:r.useCallback((function(r,e){var t=q();Cr(t,r,e),I(),H(c(t)),G(Cr,{argA:r,argB:e,argC:r,argD:e},void 0,t,!1)}),[i]),prepend:r.useCallback((function(r,e){void 0===e&&(e=!0);var t=Dr(r),n=kr(q(),Br(Array.isArray(r)?r:[r],s));H(n),I(),G(kr,{argA:t,argC:Er(r)},n),f.current=e?0:-1}),[i]),append:r.useCallback((function(r,e){void 0===e&&(e=!0);var t=c(q(),Br(Array.isArray(r)?r:[r],s));H(t),(V.current.dirtyFields||V.current.isDirty)&&(z(t),R({isDirty:!0,dirtyFields:A.current.dirtyFields})),!E&&D(x.current,i,c(j(x.current,i)||[],[r])),f.current=e?W.length:-1}),[i,W]),remove:r.useCallback((function(r){var e=q(),t=Fr(e,r);H(t),I(),G(Fr,{argA:r,argC:r},t,Fr(e,r),!0,!0)}),[i]),insert:r.useCallback((function(r,e,t){void 0===t&&(t=!0);var n=Dr(e),u=q(),i=Or(u,r,Br(Array.isArray(e)?e:[e],s));H(i),I(),G(Or,{argA:r,argB:n,argC:r,argD:Er(e)},i,Or(u,r)),f.current=t?r:-1}),[i]),fields:W}},exports.useForm=function(t){var d=this,h=void 0===t?{}:t,m=h.mode,b=void 0===m?y:m,g=h.reValidateMode,A=void 0===g?v:g,x=h.resolver,R=h.context,V=h.defaultValues,F=void 0===V?{}:V,O=h.shouldFocusError,T=void 0===O||O,L=h.shouldUnregister,q=void 0===L||L,H=h.criteriaMode,I=r.useRef({}),$=r.useRef({}),X=r.useRef({}),Y=r.useRef(new Set),nr=r.useRef({}),ur=r.useRef({}),ar=r.useRef({}),cr=r.useRef({}),or=r.useRef(F),yr=r.useRef({}),Rr=r.useRef(!1),Vr=r.useRef(!1),wr=r.useRef(),Fr=r.useRef({}),Cr=r.useRef({}),Sr=r.useRef(R),kr=r.useRef(x),Or=r.useRef(new Set),Dr=r.useRef(br(b)),Er=Dr.current,Br=Er.isOnSubmit,jr=Er.isOnTouch,Nr=H===p,Tr=a(r.useState({isDirty:!1,dirtyFields:{},isSubmitted:!1,submitCount:0,touched:{},isSubmitting:!1,isSubmitSuccessful:!1,isValid:!Br,errors:{}}),2),Lr=Tr[0],Wr=Tr[1],Mr=r.useRef({isDirty:!xr,dirtyFields:!xr,touched:!xr||jr,isSubmitting:!xr,isValid:!xr}),Pr=r.useRef(Lr),Ur=r.useRef(),qr=r.useRef(br(A)).current,Hr=qr.isOnBlur,Ir=qr.isOnChange;Sr.current=R,kr.current=x,Pr.current=Lr,Fr.current=q?{}:G(Fr.current)?mr(F):Fr.current;var _r=r.useCallback((function(r){void 0===r&&(r={}),Rr.current||(Pr.current=e(e({},Pr.current),r),Wr(Pr.current))}),[]),zr=r.useCallback((function(r,t,n,u,i){void 0===n&&(n=!1),void 0===u&&(u={});var a=n||function(r){var e=r.errors,t=r.name,n=r.error,u=r.validFields,i=r.fieldsWithValidation,a=B(n),c=j(e,t);return a&&!!c||!a&&!tr(c,n,!0)||a&&j(i,t)&&!j(u,t)}({errors:Pr.current.errors,error:t,name:r,validFields:cr.current,fieldsWithValidation:ar.current}),c=j(Pr.current.errors,r);t?(J(cr.current,r),a=a||!c||!tr(c,t,!0),D(Pr.current.errors,r,t)):((j(ar.current,r)||kr.current)&&(D(cr.current,r,!0),a=a||c),J(Pr.current.errors,r)),(a&&!w(n)||!G(u))&&_r(e(e({},u),kr.current?{isValid:!!i}:{}))}),[]),Gr=r.useCallback((function(r,e){var t=I.current[r],n=t.ref,u=t.options,i=pr&&o(n)&&w(e)?"":e;W(n)?(u||[]).forEach((function(r){var e=r.ref;return e.checked=e.value===i})):M(n)&&!rr(i)?n.files=i:U(n)?c(n.options).forEach((function(r){return r.selected=i.includes(r.value)})):P(n)&&u?u.length>1?u.forEach((function(r){var e=r.ref;return e.checked=Array.isArray(i)?!!i.find((function(r){return r===e.value})):i===e.value})):u[0].ref.checked=!!i:n.value=i}),[]),$r=r.useCallback((function(r,e){if(Mr.current.isDirty){var t=ne();return r&&e&&D(t,r,e),!tr(t,G(or.current)?yr.current:or.current)}return!1}),[]),Jr=r.useCallback((function(r,e){if(void 0===e&&(e=!0),Mr.current.isDirty||Mr.current.dirtyFields){var t=!tr(j(yr.current,r),_(I,r,Fr)),n=j(Pr.current.dirtyFields,r),u=Pr.current.isDirty;t?D(Pr.current.dirtyFields,r,!0):J(Pr.current.dirtyFields,r);var i={isDirty:$r(),dirtyFields:Pr.current.dirtyFields},a=Mr.current.isDirty&&u!==i.isDirty||Mr.current.dirtyFields&&n!==j(Pr.current.dirtyFields,r);return a&&e&&_r(i),a?i:{}}return{}}),[]),Kr=r.useCallback((function(r,e){return n(d,void 0,void 0,(function(){var t;return u(this,(function(n){switch(n.label){case 0:return[4,sr(I,Nr,I.current[r],Fr)];case 1:return t=n.sent()[r],zr(r,t,e),[2,B(t)]}}))}))}),[zr,Nr]),Qr=r.useCallback((function(r){return n(d,void 0,void 0,(function(){var e,t,n,i;return u(this,(function(u){switch(u.label){case 0:return[4,kr.current(ne(),Sr.current,Nr)];case 1:return e=u.sent().errors,t=Pr.current.isValid,Array.isArray(r)?(n=r.map((function(r){var t=j(e,r);return t?D(Pr.current.errors,r,t):J(Pr.current.errors,r),!t})).every(Boolean),_r({isValid:G(e)}),[2,n]):(i=j(e,r),zr(r,i,t!==G(e),{},G(e)),[2,!i])}}))}))}),[zr,Nr]),Xr=r.useCallback((function(r){return n(d,void 0,void 0,(function(){var e,t,i=this;return u(this,(function(a){switch(a.label){case 0:return e=r||Object.keys(I.current),kr.current?[2,Qr(e)]:Array.isArray(e)?(!r&&(Pr.current.errors={}),[4,Promise.all(e.map((function(r){return n(i,void 0,void 0,(function(){return u(this,(function(e){switch(e.label){case 0:return[4,Kr(r,null)];case 1:return[2,e.sent()]}}))}))})))]):[3,2];case 1:return t=a.sent(),_r(),[2,t.every(Boolean)];case 2:return[4,Kr(e)];case 3:return[2,a.sent()]}}))}))}),[Qr,Kr]),Yr=r.useCallback((function(r,e,t){var n,u,a=t.shouldDirty,c=t.shouldValidate,o={};D(o,r,e);try{for(var s=i(lr(r,e)),l=s.next();!l.done;l=s.next()){var f=l.value;I.current[f]&&(Gr(f,j(o,f)),a&&Jr(f),c&&Xr(f))}}catch(r){n={error:r}}finally{try{l&&!l.done&&(u=s.return)&&u.call(s)}finally{if(n)throw n.error}}}),[Xr,Gr,Jr]),Zr=r.useCallback((function(r,t,n){var u,i;!Q(t)&&D(Fr.current,r,t),I.current[r]?(Gr(r,t),n.shouldDirty&&Jr(r),n.shouldValidate&&Xr(r)):Q(t)||(Yr(r,t,n),Or.current.has(r)&&($.current[r]=t,Cr.current[r](((u={})[r]=t,u)),(Mr.current.isDirty||Mr.current.dirtyFields)&&n.shouldDirty&&(D(Pr.current.dirtyFields,r,Z(t,j(or.current,r,[]),j(Pr.current.dirtyFields,r,[]))),_r({isDirty:!tr(e(e({},ne()),(i={},i[r]=t,i)),or.current)})))),!q&&D(Fr.current,r,t)}),[Jr,Gr,Yr]),re=function(r){return Vr.current||Y.current.has(r)||Y.current.has((r.match(/\w+/)||[])[0])},ee=function(r,e){if(void 0===e&&(e=!0),!G(nr.current))for(var t in nr.current)r&&nr.current[t].size&&!nr.current[t].has(r)&&!nr.current[t].has(vr(r))||(ur.current[t](),e=!1);return e};function te(r){var t,n,u;if(!q){var a=mr(r);try{for(var c=i(Or.current),o=c.next();!o.done;o=c.next()){var s=o.value;S(s)&&!a[s]&&(a=e(e({},a),((u={})[s]=[],u)))}}catch(r){t={error:r}}finally{try{o&&!o.done&&(n=c.return)&&n.call(c)}finally{if(t)throw t.error}}return a}return r}function ne(r){var e,t;if(rr(r))return _(I,r,Fr);if(Array.isArray(r)){var n={};try{for(var u=i(r),a=u.next();!a.done;a=u.next()){var c=a.value;D(n,c,_(I,c,Fr))}}catch(r){e={error:r}}finally{try{a&&!a.done&&(t=u.return)&&t.call(u)}finally{if(e)throw e.error}}return n}return te(er(I,mr(Fr.current),q))}wr.current=wr.current?wr.current:function(r){var t=r.type,i=r.target;return n(d,void 0,void 0,(function(){var r,n,a,c,o,l,f,d,v,y,h,p;return u(this,(function(u){switch(u.label){case 0:return r=i.name,(n=I.current[r])?(l=dr(e({isBlurEvent:o=t===s,isReValidateOnChange:Ir,isReValidateOnBlur:Hr,isTouched:!!j(Pr.current.touched,r),isSubmitted:Pr.current.isSubmitted},Dr.current)),f=Jr(r,!1),d=!G(f)||re(r),o&&!j(Pr.current.touched,r)&&Mr.current.touched&&(D(Pr.current.touched,r,!0),f=e(e({},f),{touched:Pr.current.touched})),!q&&P(i)&&D(Fr.current,r,_(I,r)),l?(ee(r),[2,(!G(f)||d&&G(f))&&_r(f)]):kr.current?[4,kr.current(ne(),Sr.current,Nr)]:[3,2]):[3,5];case 1:return v=u.sent().errors,y=Pr.current.isValid,a=j(v,r),P(i)&&!a&&kr.current&&(h=vr(r),(p=j(v,h,{})).type&&p.message&&(a=p),h&&(p||j(Pr.current.errors,h))&&(r=h)),c=G(v),y!==c&&(d=!0),[3,4];case 2:return[4,sr(I,Nr,n,Fr)];case 3:a=u.sent()[r],u.label=4;case 4:ee(r),zr(r,a,d,f,c),u.label=5;case 5:return[2]}}))}))};var ue=r.useCallback((function(r){return void 0===r&&(r={}),n(d,void 0,void 0,(function(){var t,n;return u(this,(function(u){switch(u.label){case 0:return[4,kr.current(e(e({},ne()),r),Sr.current,Nr)];case 1:return t=u.sent().errors,n=G(t),Pr.current.isValid!==n&&_r({isValid:n}),[2]}}))}))}),[Nr]),ie=r.useCallback((function(r,e){return function(r,e,t,n,u,i){var a=t.ref,c=t.ref.name,o=r.current[c];if(!u){var s=_(r,c,n);!B(s)&&D(n.current,c,s)}a.type&&o?W(a)||P(a)?Array.isArray(o.options)&&o.options.length?(k(o.options).forEach((function(r,t){void 0===r&&(r={}),(z(r.ref)&&K(r,r.ref)||i)&&(N(r.ref,e),J(o.options,"["+t+"]"))})),o.options&&!k(o.options).length&&delete r.current[c]):delete r.current[c]:(z(a)&&K(o,a)||i)&&(N(a,e),delete r.current[c]):delete r.current[c]}(I,wr.current,r,Fr,q,e)}),[q]),ae=r.useCallback((function(r){var e,t;if(Vr.current)_r();else{try{for(var n=i(Y.current),u=n.next();!u.done;u=n.next()){if(u.value.startsWith(r)){_r();break}}}catch(r){e={error:r}}finally{try{u&&!u.done&&(t=n.return)&&t.call(n)}finally{if(e)throw e.error}}ee(r)}}),[]),ce=r.useCallback((function(r,e){r&&(ie(r,e),q&&!k(r.options||[]).length&&(J(yr.current,r.ref.name),J(cr.current,r.ref.name),J(ar.current,r.ref.name),J(Pr.current.errors,r.ref.name),D(Pr.current.dirtyFields,r.ref.name,!0),_r({isDirty:$r()}),Mr.current.isValid&&kr.current&&ue(),ae(r.ref.name)))}),[ue,ie]),oe=r.useCallback((function(r,t,n){var u=n?nr.current[n]:Y.current,i=er(I,mr(Fr.current),q,!1,r);if(rr(r)){if(Or.current.has(r)){var a=j(X.current,r,[]);i=a.length&&a.length===k(j(i,r,[])).length?i:X.current}return fr(i,r,u,B(j(or.current,r))?t:j(or.current,r),!0)}var c=B(t)?or.current:t;return Array.isArray(r)?r.reduce((function(r,t){var n;return e(e({},r),((n={})[t]=fr(i,t,u,c),n))}),{}):(Vr.current=B(n),E(!G(i)&&i||c))}),[]);function se(r,t){void 0===t&&(t={});var n,u=r.name,i=r.type,a=r.value,d=e({ref:r},t),v=I.current,y=gr(r),h=hr(Or.current,u),p=function(e){return pr&&(!o(r)||e===r)},m=v[u],b=!0;if(m&&(y?Array.isArray(m.options)&&k(m.options).find((function(r){return a===r.ref.value&&p(r.ref)})):p(m.ref)))v[u]=e(e({},m),t);else{m=i?y?e({options:c(k(m&&m.options||[]),[{ref:r}]),ref:{type:i,name:u}},t):e({},d):d,v[u]=m;var g=B(j(Fr.current,u));if(G(or.current)&&g||(n=j(g?or.current:Fr.current,u),(b=B(n))||h||Gr(u,n)),G(t)||(D(ar.current,u,!0),!Br&&Mr.current.isValid&&sr(I,Nr,m,Fr).then((function(r){var e=Pr.current.isValid;G(r)?D(cr.current,u,!0):J(cr.current,u),e!==G(r)&&_r()}))),!(yr.current[u]||h&&b)){var A=_(I,u,Fr);D(yr.current,u,b?C(A)?e({},A):A:n),!h&&J(Pr.current.dirtyFields,u)}i&&function(r,e,t){var n=r.ref;o(n)&&t&&(n.addEventListener(e?l:f,t),n.addEventListener(s,t))}(y&&m.options?m.options[m.options.length-1]:m,y||"select-one"===r.type,wr.current)}}var le=r.useCallback((function(r,t){return function(a){return n(d,void 0,void 0,(function(){var n,c,o,s,l,f,d,v,y,h,p,m,b;return u(this,(function(u){switch(u.label){case 0:a&&a.preventDefault&&(a.preventDefault(),a.persist()),n={},c=te(er(I,mr(Fr.current),q,!0)),Mr.current.isSubmitting&&_r({isSubmitting:!0}),u.label=1;case 1:return u.trys.push([1,,16,17]),kr.current?[4,kr.current(c,Sr.current,Nr)]:[3,3];case 2:return o=u.sent(),s=o.errors,l=o.values,Pr.current.errors=n=s,c=l,[3,10];case 3:u.trys.push([3,8,9,10]),f=i(Object.values(I.current)),d=f.next(),u.label=4;case 4:return d.done?[3,7]:(v=d.value)?(y=v.ref.name,[4,sr(I,Nr,v,Fr)]):[3,6];case 5:(h=u.sent())[y]?(D(n,y,h[y]),J(cr.current,y)):j(ar.current,y)&&(J(Pr.current.errors,y),D(cr.current,y,!0)),u.label=6;case 6:return d=f.next(),[3,4];case 7:return[3,10];case 8:return p=u.sent(),m={error:p},[3,10];case 9:try{d&&!d.done&&(b=f.return)&&b.call(f)}finally{if(m)throw m.error}return[7];case 10:return G(n)&&Object.keys(Pr.current.errors).every((function(r){return r in I.current}))?(_r({errors:{},isSubmitting:!0}),[4,r(c,a)]):[3,12];case 11:return u.sent(),[3,15];case 12:return Pr.current.errors=e(e({},Pr.current.errors),n),t?[4,t(Pr.current.errors,a)]:[3,14];case 13:u.sent(),u.label=14;case 14:T&&function(r,e){for(var t in r)if(j(e,t)){var n=r[t];if(n){if(n.ref.focus&&B(n.ref.focus()))break;if(n.options){n.options[0].ref.focus();break}}}}(I.current,Pr.current.errors),u.label=15;case 15:return[3,17];case 16:return Pr.current.isSubmitting=!1,_r({isSubmitted:!0,isSubmitting:!1,isSubmitSuccessful:G(Pr.current.errors),submitCount:Pr.current.submitCount+1}),[7];case 17:return[2]}}))}))}}),[T,Nr]);r.useEffect((function(){x&&Mr.current.isValid&&ue(),Ur.current=Ur.current||!pr?Ur.current:function(r,e){var t=new MutationObserver((function(){var t,n,u,a;try{for(var c=i(Object.values(r.current)),o=c.next();!o.done;o=c.next()){var s=o.value;if(s&&s.options)try{for(var l=(u=void 0,i(s.options)),f=l.next();!f.done;f=l.next()){var d=f.value;d&&d.ref&&z(d.ref)&&e(s)}}catch(r){u={error:r}}finally{try{f&&!f.done&&(a=l.return)&&a.call(l)}finally{if(u)throw u.error}}else s&&z(s.ref)&&e(s)}}catch(r){t={error:r}}finally{try{o&&!o.done&&(n=c.return)&&n.call(c)}finally{if(t)throw t.error}}}));return t.observe(window.document,{childList:!0,subtree:!0}),t}(I,ce)}),[ce,or.current]),r.useEffect((function(){return function(){Ur.current&&Ur.current.disconnect(),Rr.current=!0,Object.values(I.current).forEach((function(r){return ce(r,!0)}))}}),[]),!x&&Mr.current.isValid&&(Lr.isValid=tr(cr.current,ar.current)&&G(Pr.current.errors));var fe={trigger:Xr,setValue:r.useCallback((function(r,e,t){Zr(r,e,t||{}),re(r)&&_r(),ee(r)}),[Zr,Xr]),getValues:r.useCallback(ne,[]),register:r.useCallback((function(r,e){if(!Ar)if(rr(r))se({name:r},e);else{if(!C(r)||!("name"in r))return function(e){return e&&se(e,r)};se(r,e)}}),[or.current]),unregister:r.useCallback((function(r){var e,t;try{for(var n=i(Array.isArray(r)?r:[r]),u=n.next();!u.done;u=n.next()){var a=u.value;ce(I.current[a],!0)}}catch(r){e={error:r}}finally{try{u&&!u.done&&(t=n.return)&&t.call(n)}finally{if(e)throw e.error}}}),[])},de=r.useMemo((function(){return e({isFormDirty:$r,updateWatchedValue:ae,shouldUnregister:q,updateFormState:_r,removeFieldEventListener:ie,watchInternal:oe,mode:Dr.current,reValidateMode:{isReValidateOnBlur:Hr,isReValidateOnChange:Ir},validateResolver:x?ue:void 0,fieldsRef:I,resetFieldArrayFunctionRef:Cr,useWatchFieldsRef:nr,useWatchRenderFunctionsRef:ur,fieldArrayDefaultValuesRef:$,validFieldsRef:cr,fieldsWithValidationRef:ar,fieldArrayNamesRef:Or,readFormStateRef:Mr,formStateRef:Pr,defaultValuesRef:or,shallowFieldsStateRef:Fr,fieldArrayValuesRef:X},fe)}),[or.current,ae,q,ie,oe]);return e({watch:function(r,e){return oe(r,e)},control:de,formState:xr?new Proxy(Lr,{get:function(r,e){if(e in r)return Mr.current[e]=!0,r[e]}}):Lr,handleSubmit:le,reset:r.useCallback((function(r,e){var t,n;if(void 0===e&&(e={}),pr)try{for(var u=i(Object.values(I.current)),a=u.next();!a.done;a=u.next()){var c=a.value;if(c){var s=c.ref,l=c.options,f=gr(s)&&Array.isArray(l)?l[0].ref:s;if(o(f))try{f.closest("form").reset();break}catch(r){}}}}catch(r){t={error:r}}finally{try{a&&!a.done&&(n=u.return)&&n.call(u)}finally{if(t)throw t.error}}I.current={},or.current=mr(r||or.current),r&&ee(""),Object.values(Cr.current).forEach((function(r){return ir(r)&&r()})),Fr.current=q?{}:mr(r)||{},function(r){var e=r.errors,t=r.isDirty,n=r.isSubmitted,u=r.touched,i=r.isValid,a=r.submitCount,c=r.dirtyFields;i||(cr.current={},ar.current={}),yr.current={},$.current={},Y.current=new Set,Vr.current=!1,_r({submitCount:a?Pr.current.submitCount:0,isDirty:!!t&&Pr.current.isDirty,isSubmitted:!!n&&Pr.current.isSubmitted,isValid:!!i&&Pr.current.isValid,dirtyFields:c?Pr.current.dirtyFields:{},touched:u?Pr.current.touched:{},errors:e?Pr.current.errors:{},isSubmitting:!1,isSubmitSuccessful:!1})}(e)}),[]),clearErrors:r.useCallback((function(r){r&&(Array.isArray(r)?r:[r]).forEach((function(r){return I.current[r]&&S(r)?delete Pr.current.errors[r]:J(Pr.current.errors,r)})),_r({errors:r?Pr.current.errors:{}})}),[]),setError:r.useCallback((function(r,t){var n=(I.current[r]||{}).ref;D(Pr.current.errors,r,e(e({},t),{ref:n})),_r({isValid:!1}),t.shouldFocus&&n&&n.focus&&n.focus()}),[]),errors:Lr.errors},fe)},exports.useFormContext=Vr,exports.useWatch=function(t){var n=t.control,u=t.name,i=t.defaultValue,a=Vr(),c=n||a.control,o=c.useWatchFieldsRef,s=c.useWatchRenderFunctionsRef,l=c.watchInternal,f=c.defaultValuesRef,d=r.useState()[1],v=r.useRef(),y=r.useRef(i);return r.useEffect((function(){var r=v.current=wr(),e=s.current,t=o.current;return t[r]=new Set,e[r]=function(){return d({})},l(u,y.current,r),function(){delete t[r],delete e[r]}}),[u,s,o,l,y]),v.current?l(u,y.current,v.current):B(i)?rr(u)?j(f.current,u):Array.isArray(u)?u.reduce((function(r,t){var n;return e(e({},r),((n={})[t]=j(f.current,t),n))}),{}):f.current:i};
	//# sourceMappingURL=index.ie11.production.min.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1660)


/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable global-require */
	
	if (true) {
	  module.exports = __webpack_require__(1659);
	} else {
	  module.exports = require('./AppContainer.dev');
	}

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* eslint-disable react/prop-types */
	
	var React = __webpack_require__(1);
	
	var Component = React.Component;
	
	var AppContainer = function (_Component) {
	  _inherits(AppContainer, _Component);
	
	  function AppContainer() {
	    _classCallCheck(this, AppContainer);
	
	    return _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).apply(this, arguments));
	  }
	
	  _createClass(AppContainer, [{
	    key: 'render',
	    value: function render() {
	      if (this.props.component) {
	        return React.createElement(this.props.component, this.props.props);
	      }
	
	      return React.Children.only(this.props.children);
	    }
	  }]);
	
	  return AppContainer;
	}(Component);
	
	module.exports = AppContainer;

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/* eslint-disable global-require */
	
	if (true) {
	  module.exports = __webpack_require__(1661);
	} else {
	  module.exports = require('./index.dev');
	}

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports.AppContainer = __webpack_require__(1658);

/***/ }),
/* 1662 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,a){ true?module.exports=a():"function"==typeof define&&define.amd?define(a):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.en=a())}(this,function(){"use strict";return[{locale:"en",pluralRuleFunction:function(e,a){var t=String(e).split("."),o=!t[1],n=Number(t[0])==e,r=n&&t[0].slice(-1),i=n&&t[0].slice(-2);return a?1==r&&11!=i?"one":2==r&&12!=i?"two":3==r&&13!=i?"few":"other":1==e&&o?"one":"other"},fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yr."},past:{one:"{0} yr. ago",other:"{0} yr. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hr."},past:{one:"{0} hr. ago",other:"{0} hr. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} min."},past:{one:"{0} min. ago",other:"{0} min. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} sec."},past:{one:"{0} sec. ago",other:"{0} sec. ago"}}}}},{locale:"en-001",parentLocale:"en",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo",other:"in {0} mo"},past:{one:"{0} mo ago",other:"{0} mo ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-150",parentLocale:"en-001"},{locale:"en-AG",parentLocale:"en-001"},{locale:"en-AI",parentLocale:"en-001"},{locale:"en-AS",parentLocale:"en"},{locale:"en-AT",parentLocale:"en-150"},{locale:"en-AU",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr",other:"in {0} yrs"},past:{one:"{0} yr ago",other:"{0} yrs ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mo."},past:{one:"{0} mo. ago",other:"{0} mo. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"h",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hrs"},past:{one:"{0} hr ago",other:"{0} hrs ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins"},past:{one:"{0} min. ago",other:"{0} mins ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs"},past:{one:"{0} sec. ago",other:"{0} secs ago"}}}}},{locale:"en-BB",parentLocale:"en-001"},{locale:"en-BE",parentLocale:"en-001"},{locale:"en-BI",parentLocale:"en"},{locale:"en-BM",parentLocale:"en-001"},{locale:"en-BS",parentLocale:"en-001"},{locale:"en-BW",parentLocale:"en-001"},{locale:"en-BZ",parentLocale:"en-001"},{locale:"en-CA",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr.",relative:{0:"this yr.",1:"next yr.","-1":"last yr."},relativeTime:{future:{one:"in {0} yr.",other:"in {0} yrs."},past:{one:"{0} yr. ago",other:"{0} yrs. ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mo.",relative:{0:"this mo.",1:"next mo.","-1":"last mo."},relativeTime:{future:{one:"in {0} mo.",other:"in {0} mos."},past:{one:"{0} mo. ago",other:"{0} mos. ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr.",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr.",other:"in {0} hrs."},past:{one:"{0} hr. ago",other:"{0} hrs. ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min.",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min.",other:"in {0} mins."},past:{one:"{0} min. ago",other:"{0} mins. ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec.",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec.",other:"in {0} secs."},past:{one:"{0} sec. ago",other:"{0} secs. ago"}}}}},{locale:"en-CC",parentLocale:"en-001"},{locale:"en-CH",parentLocale:"en-150"},{locale:"en-CK",parentLocale:"en-001"},{locale:"en-CM",parentLocale:"en-001"},{locale:"en-CX",parentLocale:"en-001"},{locale:"en-CY",parentLocale:"en-001"},{locale:"en-DE",parentLocale:"en-150"},{locale:"en-DG",parentLocale:"en-001"},{locale:"en-DK",parentLocale:"en-150"},{locale:"en-DM",parentLocale:"en-001"},{locale:"en-Dsrt",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-ER",parentLocale:"en-001"},{locale:"en-FI",parentLocale:"en-150"},{locale:"en-FJ",parentLocale:"en-001"},{locale:"en-FK",parentLocale:"en-001"},{locale:"en-FM",parentLocale:"en-001"},{locale:"en-GB",parentLocale:"en-001"},{locale:"en-GD",parentLocale:"en-001"},{locale:"en-GG",parentLocale:"en-001"},{locale:"en-GH",parentLocale:"en-001"},{locale:"en-GI",parentLocale:"en-001"},{locale:"en-GM",parentLocale:"en-001"},{locale:"en-GU",parentLocale:"en"},{locale:"en-GY",parentLocale:"en-001"},{locale:"en-HK",parentLocale:"en-001"},{locale:"en-IE",parentLocale:"en-001"},{locale:"en-IL",parentLocale:"en-001"},{locale:"en-IM",parentLocale:"en-001"},{locale:"en-IN",parentLocale:"en-001"},{locale:"en-IO",parentLocale:"en-001"},{locale:"en-JE",parentLocale:"en-001"},{locale:"en-JM",parentLocale:"en-001"},{locale:"en-KE",parentLocale:"en-001"},{locale:"en-KI",parentLocale:"en-001"},{locale:"en-KN",parentLocale:"en-001"},{locale:"en-KY",parentLocale:"en-001"},{locale:"en-LC",parentLocale:"en-001"},{locale:"en-LR",parentLocale:"en-001"},{locale:"en-LS",parentLocale:"en-001"},{locale:"en-MG",parentLocale:"en-001"},{locale:"en-MH",parentLocale:"en"},{locale:"en-MO",parentLocale:"en-001"},{locale:"en-MP",parentLocale:"en"},{locale:"en-MS",parentLocale:"en-001"},{locale:"en-MT",parentLocale:"en-001"},{locale:"en-MU",parentLocale:"en-001"},{locale:"en-MW",parentLocale:"en-001"},{locale:"en-MY",parentLocale:"en-001"},{locale:"en-NA",parentLocale:"en-001"},{locale:"en-NF",parentLocale:"en-001"},{locale:"en-NG",parentLocale:"en-001"},{locale:"en-NL",parentLocale:"en-150"},{locale:"en-NR",parentLocale:"en-001"},{locale:"en-NU",parentLocale:"en-001"},{locale:"en-NZ",parentLocale:"en-001"},{locale:"en-PG",parentLocale:"en-001"},{locale:"en-PH",parentLocale:"en-001"},{locale:"en-PK",parentLocale:"en-001"},{locale:"en-PN",parentLocale:"en-001"},{locale:"en-PR",parentLocale:"en"},{locale:"en-PW",parentLocale:"en-001"},{locale:"en-RW",parentLocale:"en-001"},{locale:"en-SB",parentLocale:"en-001"},{locale:"en-SC",parentLocale:"en-001"},{locale:"en-SD",parentLocale:"en-001"},{locale:"en-SE",parentLocale:"en-150"},{locale:"en-SG",parentLocale:"en-001",fields:{year:{displayName:"year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{one:"in {0} year",other:"in {0} years"},past:{one:"{0} year ago",other:"{0} years ago"}}},"year-short":{displayName:"yr",relative:{0:"this yr",1:"next yr","-1":"last yr"},relativeTime:{future:{one:"in {0} yr",other:"in {0} yr"},past:{one:"{0} yr ago",other:"{0} yr ago"}}},month:{displayName:"month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{one:"in {0} month",other:"in {0} months"},past:{one:"{0} month ago",other:"{0} months ago"}}},"month-short":{displayName:"mth",relative:{0:"this mth",1:"next mth","-1":"last mth"},relativeTime:{future:{one:"in {0} mth",other:"in {0} mth"},past:{one:"{0} mth ago",other:"{0} mth ago"}}},day:{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},"day-short":{displayName:"day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{one:"in {0} day",other:"in {0} days"},past:{one:"{0} day ago",other:"{0} days ago"}}},hour:{displayName:"hour",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hour",other:"in {0} hours"},past:{one:"{0} hour ago",other:"{0} hours ago"}}},"hour-short":{displayName:"hr",relative:{0:"this hour"},relativeTime:{future:{one:"in {0} hr",other:"in {0} hr"},past:{one:"{0} hr ago",other:"{0} hr ago"}}},minute:{displayName:"minute",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} minute",other:"in {0} minutes"},past:{one:"{0} minute ago",other:"{0} minutes ago"}}},"minute-short":{displayName:"min",relative:{0:"this minute"},relativeTime:{future:{one:"in {0} min",other:"in {0} min"},past:{one:"{0} min ago",other:"{0} min ago"}}},second:{displayName:"second",relative:{0:"now"},relativeTime:{future:{one:"in {0} second",other:"in {0} seconds"},past:{one:"{0} second ago",other:"{0} seconds ago"}}},"second-short":{displayName:"sec",relative:{0:"now"},relativeTime:{future:{one:"in {0} sec",other:"in {0} sec"},past:{one:"{0} sec ago",other:"{0} sec ago"}}}}},{locale:"en-SH",parentLocale:"en-001"},{locale:"en-SI",parentLocale:"en-150"},{locale:"en-SL",parentLocale:"en-001"},{locale:"en-SS",parentLocale:"en-001"},{locale:"en-SX",parentLocale:"en-001"},{locale:"en-SZ",parentLocale:"en-001"},{locale:"en-Shaw",pluralRuleFunction:function(e,a){return"other"},fields:{year:{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},"year-short":{displayName:"Year",relative:{0:"this year",1:"next year","-1":"last year"},relativeTime:{future:{other:"+{0} y"},past:{other:"-{0} y"}}},month:{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},"month-short":{displayName:"Month",relative:{0:"this month",1:"next month","-1":"last month"},relativeTime:{future:{other:"+{0} m"},past:{other:"-{0} m"}}},day:{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},"day-short":{displayName:"Day",relative:{0:"today",1:"tomorrow","-1":"yesterday"},relativeTime:{future:{other:"+{0} d"},past:{other:"-{0} d"}}},hour:{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},"hour-short":{displayName:"Hour",relative:{0:"this hour"},relativeTime:{future:{other:"+{0} h"},past:{other:"-{0} h"}}},minute:{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},"minute-short":{displayName:"Minute",relative:{0:"this minute"},relativeTime:{future:{other:"+{0} min"},past:{other:"-{0} min"}}},second:{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}},"second-short":{displayName:"Second",relative:{0:"now"},relativeTime:{future:{other:"+{0} s"},past:{other:"-{0} s"}}}}},{locale:"en-TC",parentLocale:"en-001"},{locale:"en-TK",parentLocale:"en-001"},{locale:"en-TO",parentLocale:"en-001"},{locale:"en-TT",parentLocale:"en-001"},{locale:"en-TV",parentLocale:"en-001"},{locale:"en-TZ",parentLocale:"en-001"},{locale:"en-UG",parentLocale:"en-001"},{locale:"en-UM",parentLocale:"en"},{locale:"en-US",parentLocale:"en"},{locale:"en-VC",parentLocale:"en-001"},{locale:"en-VG",parentLocale:"en-001"},{locale:"en-VI",parentLocale:"en"},{locale:"en-VU",parentLocale:"en-001"},{locale:"en-WS",parentLocale:"en-001"},{locale:"en-ZA",parentLocale:"en-001"},{locale:"en-ZM",parentLocale:"en-001"},{locale:"en-ZW",parentLocale:"en-001"}]});


/***/ }),
/* 1663 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,r){ true?module.exports=r():"function"==typeof define&&define.amd?define(r):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.is=r())}(this,function(){"use strict";return[{locale:"is",pluralRuleFunction:function(e,r){var t=String(e).split("."),i=t[0],a=Number(t[0])==e,n=i.slice(-1),s=i.slice(-2);return r?"other":a&&1==n&&11!=s||!a?"one":"other"},fields:{year:{displayName:"ár",relative:{0:"á þessu ári",1:"á næsta ári","-1":"á síðasta ári"},relativeTime:{future:{one:"eftir {0} ár",other:"eftir {0} ár"},past:{one:"fyrir {0} ári",other:"fyrir {0} árum"}}},"year-short":{displayName:"ár",relative:{0:"á þessu ári",1:"á næsta ári","-1":"á síðasta ári"},relativeTime:{future:{one:"eftir {0} ár",other:"eftir {0} ár"},past:{one:"fyrir {0} ári",other:"fyrir {0} árum"}}},month:{displayName:"mánuður",relative:{0:"í þessum mánuði",1:"í næsta mánuði","-1":"í síðasta mánuði"},relativeTime:{future:{one:"eftir {0} mánuð",other:"eftir {0} mánuði"},past:{one:"fyrir {0} mánuði",other:"fyrir {0} mánuðum"}}},"month-short":{displayName:"mán.",relative:{0:"í þessum mán.",1:"í næsta mán.","-1":"í síðasta mán."},relativeTime:{future:{one:"eftir {0} mán.",other:"eftir {0} mán."},past:{one:"fyrir {0} mán.",other:"fyrir {0} mán."}}},day:{displayName:"dagur",relative:{0:"í dag",1:"á morgun",2:"eftir tvo daga","-2":"í fyrradag","-1":"í gær"},relativeTime:{future:{one:"eftir {0} dag",other:"eftir {0} daga"},past:{one:"fyrir {0} degi",other:"fyrir {0} dögum"}}},"day-short":{displayName:"dagur",relative:{0:"í dag",1:"á morgun",2:"eftir tvo daga","-2":"í fyrradag","-1":"í gær"},relativeTime:{future:{one:"eftir {0} dag",other:"eftir {0} daga"},past:{one:"fyrir {0} degi",other:"fyrir {0} dögum"}}},hour:{displayName:"klukkustund",relative:{0:"þessa stundina"},relativeTime:{future:{one:"eftir {0} klukkustund",other:"eftir {0} klukkustundir"},past:{one:"fyrir {0} klukkustund",other:"fyrir {0} klukkustundum"}}},"hour-short":{displayName:"klst.",relative:{0:"þessa stundina"},relativeTime:{future:{one:"eftir {0} klst.",other:"eftir {0} klst."},past:{one:"fyrir {0} klst.",other:"fyrir {0} klst."}}},minute:{displayName:"mínúta",relative:{0:"á þessari mínútu"},relativeTime:{future:{one:"eftir {0} mínútu",other:"eftir {0} mínútur"},past:{one:"fyrir {0} mínútu",other:"fyrir {0} mínútum"}}},"minute-short":{displayName:"mín.",relative:{0:"á þessari mínútu"},relativeTime:{future:{one:"eftir {0} mín.",other:"eftir {0} mín."},past:{one:"fyrir {0} mín.",other:"fyrir {0} mín."}}},second:{displayName:"sekúnda",relative:{0:"núna"},relativeTime:{future:{one:"eftir {0} sekúndu",other:"eftir {0} sekúndur"},past:{one:"fyrir {0} sekúndu",other:"fyrir {0} sekúndum"}}},"second-short":{displayName:"sek.",relative:{0:"núna"},relativeTime:{future:{one:"eftir {0} sek.",other:"eftir {0} sek."},past:{one:"fyrir {0} sek.",other:"fyrir {0} sek."}}}}}]});


/***/ }),
/* 1664 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(212);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	function getStatics(component) {
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  }
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 1665 */
/***/ (function(module, exports) {

	/** @license React v16.12.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
	60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
	exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 1666 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports !== "undefined") {
	    factory(require("react"), require("prop-types"));
	  } else {
	    var mod = {
	      exports: {}
	    };
	    factory(global.React, global.PropTypes);
	    global.ReactList = mod.exports;
	  }
	})(this, function (_react, _propTypes) {
	  "use strict";
	
	  _react = _interopRequireWildcard(_react);
	  _propTypes = _interopRequireDefault(_propTypes);
	
	  var _class, _temp;
	
	  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	  function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	  function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	  function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	  function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	  function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	  function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	  function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	  var CLIENT_SIZE_KEYS = {
	    x: 'clientWidth',
	    y: 'clientHeight'
	  };
	  var CLIENT_START_KEYS = {
	    x: 'clientTop',
	    y: 'clientLeft'
	  };
	  var INNER_SIZE_KEYS = {
	    x: 'innerWidth',
	    y: 'innerHeight'
	  };
	  var OFFSET_SIZE_KEYS = {
	    x: 'offsetWidth',
	    y: 'offsetHeight'
	  };
	  var OFFSET_START_KEYS = {
	    x: 'offsetLeft',
	    y: 'offsetTop'
	  };
	  var OVERFLOW_KEYS = {
	    x: 'overflowX',
	    y: 'overflowY'
	  };
	  var SCROLL_SIZE_KEYS = {
	    x: 'scrollWidth',
	    y: 'scrollHeight'
	  };
	  var SCROLL_START_KEYS = {
	    x: 'scrollLeft',
	    y: 'scrollTop'
	  };
	  var SIZE_KEYS = {
	    x: 'width',
	    y: 'height'
	  };
	
	  var NOOP = function NOOP() {}; // If a browser doesn't support the `options` argument to
	  // add/removeEventListener, we need to check, otherwise we will
	  // accidentally set `capture` with a truthy value.
	
	
	  var PASSIVE = function () {
	    if (typeof window === 'undefined') return false;
	    var hasSupport = false;
	
	    try {
	      document.createElement('div').addEventListener('test', NOOP, {
	        get passive() {
	          hasSupport = true;
	          return false;
	        }
	
	      });
	    } catch (e) {// noop
	    }
	
	    return hasSupport;
	  }() ? {
	    passive: true
	  } : false;
	  var UNSTABLE_MESSAGE = 'ReactList failed to reach a stable state.';
	  var MAX_SYNC_UPDATES = 50;
	
	  var isEqualSubset = function isEqualSubset(a, b) {
	    for (var key in b) {
	      if (a[key] !== b[key]) return false;
	    }
	
	    return true;
	  };
	
	  var defaultScrollParentGetter = function defaultScrollParentGetter(component) {
	    var axis = component.props.axis;
	    var el = component.getEl();
	    var overflowKey = OVERFLOW_KEYS[axis];
	
	    while (el = el.parentElement) {
	      switch (window.getComputedStyle(el)[overflowKey]) {
	        case 'auto':
	        case 'scroll':
	        case 'overlay':
	          return el;
	      }
	    }
	
	    return window;
	  };
	
	  var defaultScrollParentViewportSizeGetter = function defaultScrollParentViewportSizeGetter(component) {
	    var axis = component.props.axis;
	    var scrollParent = component.scrollParent;
	    return scrollParent === window ? window[INNER_SIZE_KEYS[axis]] : scrollParent[CLIENT_SIZE_KEYS[axis]];
	  };
	
	  var constrain = function constrain(props, state) {
	    var length = props.length,
	        minSize = props.minSize,
	        type = props.type;
	    var from = state.from,
	        size = state.size,
	        itemsPerRow = state.itemsPerRow;
	    size = Math.max(size, minSize);
	    var mod = size % itemsPerRow;
	    if (mod) size += itemsPerRow - mod;
	    if (size > length) size = length;
	    from = type === 'simple' || !from ? 0 : Math.max(Math.min(from, length - size), 0);
	
	    if (mod = from % itemsPerRow) {
	      from -= mod;
	      size += mod;
	    }
	
	    if (from === state.from && size == state.size) return state;
	    return _objectSpread({}, state, {
	      from: from,
	      size: size
	    });
	  };
	
	  module.exports = (_temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inherits(ReactList, _Component);
	
	    _createClass(ReactList, null, [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(props, state) {
	        var newState = constrain(props, state);
	        return newState === state ? null : newState;
	      }
	    }]);
	
	    function ReactList(props) {
	      var _this;
	
	      _classCallCheck(this, ReactList);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactList).call(this, props));
	      _this.state = constrain(props, {
	        itemsPerRow: 1,
	        from: props.initialIndex,
	        size: 0
	      });
	      _this.cache = {};
	      _this.cachedScrollPosition = null;
	      _this.prevPrevState = {};
	      _this.unstable = false;
	      _this.updateCounter = 0;
	      return _this;
	    }
	
	    _createClass(ReactList, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.updateFrameAndClearCache = this.updateFrameAndClearCache.bind(this);
	        window.addEventListener('resize', this.updateFrameAndClearCache);
	        this.updateFrame(this.scrollTo.bind(this, this.props.initialIndex));
	      }
	    }, {
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(prevProps) {
	        var _this2 = this;
	
	        // Viewport scroll is no longer useful if axis changes
	        if (this.props.axis !== prevProps.axis) this.clearSizeCache(); // If the list has reached an unstable state, prevent an infinite loop.
	
	        if (this.unstable) return;
	
	        if (++this.updateCounter > MAX_SYNC_UPDATES) {
	          this.unstable = true;
	          return console.error(UNSTABLE_MESSAGE);
	        }
	
	        if (!this.updateCounterTimeoutId) {
	          this.updateCounterTimeoutId = setTimeout(function () {
	            _this2.updateCounter = 0;
	            delete _this2.updateCounterTimeoutId;
	          }, 0);
	        }
	
	        this.updateFrame();
	      }
	    }, {
	      key: "maybeSetState",
	      value: function maybeSetState(b, cb) {
	        if (isEqualSubset(this.state, b)) return cb();
	        this.setState(b, cb);
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        window.removeEventListener('resize', this.updateFrameAndClearCache);
	        this.scrollParent.removeEventListener('scroll', this.updateFrameAndClearCache, PASSIVE);
	        this.scrollParent.removeEventListener('mousewheel', NOOP, PASSIVE);
	      }
	    }, {
	      key: "getOffset",
	      value: function getOffset(el) {
	        var axis = this.props.axis;
	        var offset = el[CLIENT_START_KEYS[axis]] || 0;
	        var offsetKey = OFFSET_START_KEYS[axis];
	
	        do {
	          offset += el[offsetKey] || 0;
	        } while (el = el.offsetParent);
	
	        return offset;
	      }
	    }, {
	      key: "getEl",
	      value: function getEl() {
	        return this.el || this.items;
	      }
	    }, {
	      key: "getScrollPosition",
	      value: function getScrollPosition() {
	        // Cache scroll position as this causes a forced synchronous layout.
	        if (typeof this.cachedScrollPosition === 'number') {
	          return this.cachedScrollPosition;
	        }
	
	        var scrollParent = this.scrollParent;
	        var axis = this.props.axis;
	        var scrollKey = SCROLL_START_KEYS[axis];
	        var actual = scrollParent === window ? // Firefox always returns document.body[scrollKey] as 0 and Chrome/Safari
	        // always return document.documentElement[scrollKey] as 0, so take
	        // whichever has a value.
	        document.body[scrollKey] || document.documentElement[scrollKey] : scrollParent[scrollKey];
	        var max = this.getScrollSize() - this.props.scrollParentViewportSizeGetter(this);
	        var scroll = Math.max(0, Math.min(actual, max));
	        var el = this.getEl();
	        this.cachedScrollPosition = this.getOffset(scrollParent) + scroll - this.getOffset(el);
	        return this.cachedScrollPosition;
	      }
	    }, {
	      key: "setScroll",
	      value: function setScroll(offset) {
	        var scrollParent = this.scrollParent;
	        var axis = this.props.axis;
	        offset += this.getOffset(this.getEl());
	        if (scrollParent === window) return window.scrollTo(0, offset);
	        offset -= this.getOffset(this.scrollParent);
	        scrollParent[SCROLL_START_KEYS[axis]] = offset;
	      }
	    }, {
	      key: "getScrollSize",
	      value: function getScrollSize() {
	        var scrollParent = this.scrollParent;
	        var _document = document,
	            body = _document.body,
	            documentElement = _document.documentElement;
	        var key = SCROLL_SIZE_KEYS[this.props.axis];
	        return scrollParent === window ? Math.max(body[key], documentElement[key]) : scrollParent[key];
	      }
	    }, {
	      key: "hasDeterminateSize",
	      value: function hasDeterminateSize() {
	        var _this$props = this.props,
	            itemSizeGetter = _this$props.itemSizeGetter,
	            type = _this$props.type;
	        return type === 'uniform' || itemSizeGetter;
	      }
	    }, {
	      key: "getStartAndEnd",
	      value: function getStartAndEnd() {
	        var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.threshold;
	        var scroll = this.getScrollPosition();
	        var start = Math.max(0, scroll - threshold);
	        var end = scroll + this.props.scrollParentViewportSizeGetter(this) + threshold;
	
	        if (this.hasDeterminateSize()) {
	          end = Math.min(end, this.getSpaceBefore(this.props.length));
	        }
	
	        return {
	          start: start,
	          end: end
	        };
	      }
	    }, {
	      key: "getItemSizeAndItemsPerRow",
	      value: function getItemSizeAndItemsPerRow() {
	        var _this$props2 = this.props,
	            axis = _this$props2.axis,
	            useStaticSize = _this$props2.useStaticSize;
	        var _this$state = this.state,
	            itemSize = _this$state.itemSize,
	            itemsPerRow = _this$state.itemsPerRow;
	
	        if (useStaticSize && itemSize && itemsPerRow) {
	          return {
	            itemSize: itemSize,
	            itemsPerRow: itemsPerRow
	          };
	        }
	
	        var itemEls = this.items.children;
	        if (!itemEls.length) return {};
	        var firstEl = itemEls[0]; // Firefox has a problem where it will return a *slightly* (less than
	        // thousandths of a pixel) different size for the same element between
	        // renders. This can cause an infinite render loop, so only change the
	        // itemSize when it is significantly different.
	
	        var firstElSize = firstEl[OFFSET_SIZE_KEYS[axis]];
	        var delta = Math.abs(firstElSize - itemSize);
	        if (isNaN(delta) || delta >= 1) itemSize = firstElSize;
	        if (!itemSize) return {};
	        var startKey = OFFSET_START_KEYS[axis];
	        var firstStart = firstEl[startKey];
	        itemsPerRow = 1;
	
	        for (var item = itemEls[itemsPerRow]; item && item[startKey] === firstStart; item = itemEls[itemsPerRow]) {
	          ++itemsPerRow;
	        }
	
	        return {
	          itemSize: itemSize,
	          itemsPerRow: itemsPerRow
	        };
	      }
	    }, {
	      key: "clearSizeCache",
	      value: function clearSizeCache() {
	        this.cachedScrollPosition = null;
	      } // Called by 'scroll' and 'resize' events, clears scroll position cache.
	
	    }, {
	      key: "updateFrameAndClearCache",
	      value: function updateFrameAndClearCache(cb) {
	        this.clearSizeCache();
	        return this.updateFrame(cb);
	      }
	    }, {
	      key: "updateFrame",
	      value: function updateFrame(cb) {
	        this.updateScrollParent();
	        if (typeof cb != 'function') cb = NOOP;
	
	        switch (this.props.type) {
	          case 'simple':
	            return this.updateSimpleFrame(cb);
	
	          case 'variable':
	            return this.updateVariableFrame(cb);
	
	          case 'uniform':
	            return this.updateUniformFrame(cb);
	        }
	      }
	    }, {
	      key: "updateScrollParent",
	      value: function updateScrollParent() {
	        var prev = this.scrollParent;
	        this.scrollParent = this.props.scrollParentGetter(this);
	        if (prev === this.scrollParent) return;
	
	        if (prev) {
	          prev.removeEventListener('scroll', this.updateFrameAndClearCache);
	          prev.removeEventListener('mousewheel', NOOP);
	        } // If we have a new parent, cached parent dimensions are no longer useful.
	
	
	        this.clearSizeCache();
	        this.scrollParent.addEventListener('scroll', this.updateFrameAndClearCache, PASSIVE); // You have to attach mousewheel listener to the scrollable element.
	        // Just an empty listener. After that onscroll events will be fired synchronously.
	
	        this.scrollParent.addEventListener('mousewheel', NOOP, PASSIVE);
	      }
	    }, {
	      key: "updateSimpleFrame",
	      value: function updateSimpleFrame(cb) {
	        var _this$getStartAndEnd = this.getStartAndEnd(),
	            end = _this$getStartAndEnd.end;
	
	        var itemEls = this.items.children;
	        var elEnd = 0;
	
	        if (itemEls.length) {
	          var axis = this.props.axis;
	          var firstItemEl = itemEls[0];
	          var lastItemEl = itemEls[itemEls.length - 1];
	          elEnd = this.getOffset(lastItemEl) + lastItemEl[OFFSET_SIZE_KEYS[axis]] - this.getOffset(firstItemEl);
	        }
	
	        if (elEnd > end) return cb();
	        var _this$props3 = this.props,
	            pageSize = _this$props3.pageSize,
	            length = _this$props3.length;
	        var size = Math.min(this.state.size + pageSize, length);
	        this.maybeSetState({
	          size: size
	        }, cb);
	      }
	    }, {
	      key: "updateVariableFrame",
	      value: function updateVariableFrame(cb) {
	        if (!this.props.itemSizeGetter) this.cacheSizes();
	
	        var _this$getStartAndEnd2 = this.getStartAndEnd(),
	            start = _this$getStartAndEnd2.start,
	            end = _this$getStartAndEnd2.end;
	
	        var _this$props4 = this.props,
	            length = _this$props4.length,
	            pageSize = _this$props4.pageSize;
	        var space = 0;
	        var from = 0;
	        var size = 0;
	        var maxFrom = length - 1;
	
	        while (from < maxFrom) {
	          var itemSize = this.getSizeOfItem(from);
	          if (itemSize == null || space + itemSize > start) break;
	          space += itemSize;
	          ++from;
	        }
	
	        var maxSize = length - from;
	
	        while (size < maxSize && space < end) {
	          var _itemSize = this.getSizeOfItem(from + size);
	
	          if (_itemSize == null) {
	            size = Math.min(size + pageSize, maxSize);
	            break;
	          }
	
	          space += _itemSize;
	          ++size;
	        }
	
	        this.maybeSetState({
	          from: from,
	          size: size
	        }, cb);
	      }
	    }, {
	      key: "updateUniformFrame",
	      value: function updateUniformFrame(cb) {
	        var _this$getItemSizeAndI = this.getItemSizeAndItemsPerRow(),
	            itemSize = _this$getItemSizeAndI.itemSize,
	            itemsPerRow = _this$getItemSizeAndI.itemsPerRow;
	
	        if (!itemSize || !itemsPerRow) return cb();
	
	        var _this$getStartAndEnd3 = this.getStartAndEnd(),
	            start = _this$getStartAndEnd3.start,
	            end = _this$getStartAndEnd3.end;
	
	        var _constrain = constrain(this.props, {
	          from: Math.floor(start / itemSize) * itemsPerRow,
	          size: (Math.ceil((end - start) / itemSize) + 1) * itemsPerRow,
	          itemsPerRow: itemsPerRow
	        }),
	            from = _constrain.from,
	            size = _constrain.size;
	
	        return this.maybeSetState({
	          itemsPerRow: itemsPerRow,
	          from: from,
	          itemSize: itemSize,
	          size: size
	        }, cb);
	      }
	    }, {
	      key: "getSpaceBefore",
	      value: function getSpaceBefore(index) {
	        var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	        if (cache[index] != null) return cache[index]; // Try the static itemSize.
	
	        var _this$state2 = this.state,
	            itemSize = _this$state2.itemSize,
	            itemsPerRow = _this$state2.itemsPerRow;
	
	        if (itemSize) {
	          return cache[index] = Math.floor(index / itemsPerRow) * itemSize;
	        } // Find the closest space to index there is a cached value for.
	
	
	        var from = index;
	
	        while (from > 0 && cache[--from] == null) {
	          ;
	        } // Finally, accumulate sizes of items from - index.
	
	
	        var space = cache[from] || 0;
	
	        for (var i = from; i < index; ++i) {
	          cache[i] = space;
	
	          var _itemSize2 = this.getSizeOfItem(i);
	
	          if (_itemSize2 == null) break;
	          space += _itemSize2;
	        }
	
	        return cache[index] = space;
	      }
	    }, {
	      key: "cacheSizes",
	      value: function cacheSizes() {
	        var cache = this.cache;
	        var from = this.state.from;
	        var itemEls = this.items.children;
	        var sizeKey = OFFSET_SIZE_KEYS[this.props.axis];
	
	        for (var i = 0, l = itemEls.length; i < l; ++i) {
	          cache[from + i] = itemEls[i][sizeKey];
	        }
	      }
	    }, {
	      key: "getSizeOfItem",
	      value: function getSizeOfItem(index) {
	        var cache = this.cache,
	            items = this.items;
	        var _this$props5 = this.props,
	            axis = _this$props5.axis,
	            itemSizeGetter = _this$props5.itemSizeGetter,
	            itemSizeEstimator = _this$props5.itemSizeEstimator,
	            type = _this$props5.type;
	        var _this$state3 = this.state,
	            from = _this$state3.from,
	            itemSize = _this$state3.itemSize,
	            size = _this$state3.size; // Try the static itemSize.
	
	        if (itemSize) return itemSize; // Try the itemSizeGetter.
	
	        if (itemSizeGetter) return itemSizeGetter(index); // Try the cache.
	
	        if (index in cache) return cache[index]; // Try the DOM.
	
	        if (type === 'simple' && index >= from && index < from + size && items) {
	          var itemEl = items.children[index - from];
	          if (itemEl) return itemEl[OFFSET_SIZE_KEYS[axis]];
	        } // Try the itemSizeEstimator.
	
	
	        if (itemSizeEstimator) return itemSizeEstimator(index, cache);
	      }
	    }, {
	      key: "scrollTo",
	      value: function scrollTo(index) {
	        if (index != null) this.setScroll(this.getSpaceBefore(index));
	      }
	    }, {
	      key: "scrollAround",
	      value: function scrollAround(index) {
	        var current = this.getScrollPosition();
	        var bottom = this.getSpaceBefore(index);
	        var top = bottom - this.props.scrollParentViewportSizeGetter(this) + this.getSizeOfItem(index);
	        var min = Math.min(top, bottom);
	        var max = Math.max(top, bottom);
	        if (current <= min) return this.setScroll(min);
	        if (current > max) return this.setScroll(max);
	      }
	    }, {
	      key: "getVisibleRange",
	      value: function getVisibleRange() {
	        var _this$state4 = this.state,
	            from = _this$state4.from,
	            size = _this$state4.size;
	
	        var _this$getStartAndEnd4 = this.getStartAndEnd(0),
	            start = _this$getStartAndEnd4.start,
	            end = _this$getStartAndEnd4.end;
	
	        var cache = {};
	        var first, last;
	
	        for (var i = from; i < from + size; ++i) {
	          var itemStart = this.getSpaceBefore(i, cache);
	          var itemEnd = itemStart + this.getSizeOfItem(i);
	          if (first == null && itemEnd > start) first = i;
	          if (first != null && itemStart < end) last = i;
	        }
	
	        return [first, last];
	      }
	    }, {
	      key: "renderItems",
	      value: function renderItems() {
	        var _this3 = this;
	
	        var _this$props6 = this.props,
	            itemRenderer = _this$props6.itemRenderer,
	            itemsRenderer = _this$props6.itemsRenderer;
	        var _this$state5 = this.state,
	            from = _this$state5.from,
	            size = _this$state5.size;
	        var items = [];
	
	        for (var i = 0; i < size; ++i) {
	          items.push(itemRenderer(from + i, i));
	        }
	
	        return itemsRenderer(items, function (c) {
	          return _this3.items = c;
	        });
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _this4 = this;
	
	        var _this$props7 = this.props,
	            axis = _this$props7.axis,
	            length = _this$props7.length,
	            type = _this$props7.type,
	            useTranslate3d = _this$props7.useTranslate3d;
	        var _this$state6 = this.state,
	            from = _this$state6.from,
	            itemsPerRow = _this$state6.itemsPerRow;
	        var items = this.renderItems();
	        if (type === 'simple') return items;
	        var style = {
	          position: 'relative'
	        };
	        var cache = {};
	        var bottom = Math.ceil(length / itemsPerRow) * itemsPerRow;
	        var size = this.getSpaceBefore(bottom, cache);
	
	        if (size) {
	          style[SIZE_KEYS[axis]] = size;
	          if (axis === 'x') style.overflowX = 'hidden';
	        }
	
	        var offset = this.getSpaceBefore(from, cache);
	        var x = axis === 'x' ? offset : 0;
	        var y = axis === 'y' ? offset : 0;
	        var transform = useTranslate3d ? "translate3d(".concat(x, "px, ").concat(y, "px, 0)") : "translate(".concat(x, "px, ").concat(y, "px)");
	        var listStyle = {
	          msTransform: transform,
	          WebkitTransform: transform,
	          transform: transform
	        };
	        return _react["default"].createElement("div", {
	          style: style,
	          ref: function ref(c) {
	            return _this4.el = c;
	          }
	        }, _react["default"].createElement("div", {
	          style: listStyle
	        }, items));
	      }
	    }]);
	
	    return ReactList;
	  }(_react.Component), _defineProperty(_class, "displayName", 'ReactList'), _defineProperty(_class, "propTypes", {
	    axis: _propTypes["default"].oneOf(['x', 'y']),
	    initialIndex: _propTypes["default"].number,
	    itemRenderer: _propTypes["default"].func,
	    itemSizeEstimator: _propTypes["default"].func,
	    itemSizeGetter: _propTypes["default"].func,
	    itemsRenderer: _propTypes["default"].func,
	    length: _propTypes["default"].number,
	    minSize: _propTypes["default"].number,
	    pageSize: _propTypes["default"].number,
	    scrollParentGetter: _propTypes["default"].func,
	    scrollParentViewportSizeGetter: _propTypes["default"].func,
	    threshold: _propTypes["default"].number,
	    type: _propTypes["default"].oneOf(['simple', 'variable', 'uniform']),
	    useStaticSize: _propTypes["default"].bool,
	    useTranslate3d: _propTypes["default"].bool
	  }), _defineProperty(_class, "defaultProps", {
	    axis: 'y',
	    itemRenderer: function itemRenderer(index, key) {
	      return _react["default"].createElement("div", {
	        key: key
	      }, index);
	    },
	    itemsRenderer: function itemsRenderer(items, ref) {
	      return _react["default"].createElement("div", {
	        ref: ref
	      }, items);
	    },
	    length: 0,
	    minSize: 1,
	    pageSize: 10,
	    scrollParentGetter: defaultScrollParentGetter,
	    scrollParentViewportSizeGetter: defaultScrollParentViewportSizeGetter,
	    threshold: 100,
	    type: 'simple',
	    useStaticSize: false,
	    useTranslate3d: false
	  }), _temp);
	});


/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.bodyOpenClassName = exports.portalClassName = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(30);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ModalPortal = __webpack_require__(1668);
	
	var _ModalPortal2 = _interopRequireDefault(_ModalPortal);
	
	var _ariaAppHider = __webpack_require__(756);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _safeHTMLElement = __webpack_require__(390);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _reactLifecyclesCompat = __webpack_require__(389);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var portalClassName = exports.portalClassName = "ReactModalPortal";
	var bodyOpenClassName = exports.bodyOpenClassName = "ReactModal__Body--open";
	
	var isReact16 = _safeHTMLElement.canUseDOM && _reactDom2.default.createPortal !== undefined;
	
	var getCreatePortal = function getCreatePortal() {
	  return isReact16 ? _reactDom2.default.createPortal : _reactDom2.default.unstable_renderSubtreeIntoContainer;
	};
	
	function getParentElement(parentSelector) {
	  return parentSelector();
	}
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [this].concat(args))), _this), _this.removePortal = function () {
	      !isReact16 && _reactDom2.default.unmountComponentAtNode(_this.node);
	      var parent = getParentElement(_this.props.parentSelector);
	      if (parent && parent.contains(_this.node)) {
	        parent.removeChild(_this.node);
	      } else {
	        // eslint-disable-next-line no-console
	        console.warn('React-Modal: "parentSelector" prop did not returned any DOM ' + "element. Make sure that the parent element is unmounted to " + "avoid any memory leaks.");
	      }
	    }, _this.portalRef = function (ref) {
	      _this.portal = ref;
	    }, _this.renderPortal = function (props) {
	      var createPortal = getCreatePortal();
	      var portal = createPortal(_this, _react2.default.createElement(_ModalPortal2.default, _extends({ defaultStyles: Modal.defaultStyles }, props)), _this.node);
	      _this.portalRef(portal);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Modal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (!_safeHTMLElement.canUseDOM) return;
	
	      if (!isReact16) {
	        this.node = document.createElement("div");
	      }
	      this.node.className = this.props.portalClassName;
	
	      var parent = getParentElement(this.props.parentSelector);
	      parent.appendChild(this.node);
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      var prevParent = getParentElement(prevProps.parentSelector);
	      var nextParent = getParentElement(this.props.parentSelector);
	      return { prevParent: prevParent, nextParent: nextParent };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, _, snapshot) {
	      if (!_safeHTMLElement.canUseDOM) return;
	      var _props = this.props,
	          isOpen = _props.isOpen,
	          portalClassName = _props.portalClassName;
	
	
	      if (prevProps.portalClassName !== portalClassName) {
	        this.node.className = portalClassName;
	      }
	
	      var prevParent = snapshot.prevParent,
	          nextParent = snapshot.nextParent;
	
	      if (nextParent !== prevParent) {
	        prevParent.removeChild(this.node);
	        nextParent.appendChild(this.node);
	      }
	
	      // Stop unnecessary renders if modal is remaining closed
	      if (!prevProps.isOpen && !isOpen) return;
	
	      !isReact16 && this.renderPortal(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (!_safeHTMLElement.canUseDOM || !this.node || !this.portal) return;
	
	      var state = this.portal.state;
	      var now = Date.now();
	      var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
	
	      if (closesAt) {
	        if (!state.beforeClose) {
	          this.portal.closeWithTimeout();
	        }
	
	        setTimeout(this.removePortal, closesAt - now);
	      } else {
	        this.removePortal();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!_safeHTMLElement.canUseDOM || !isReact16) {
	        return null;
	      }
	
	      if (!this.node && isReact16) {
	        this.node = document.createElement("div");
	      }
	
	      var createPortal = getCreatePortal();
	      return createPortal(_react2.default.createElement(_ModalPortal2.default, _extends({
	        ref: this.portalRef,
	        defaultStyles: Modal.defaultStyles
	      }, this.props)), this.node);
	    }
	  }], [{
	    key: "setAppElement",
	    value: function setAppElement(element) {
	      ariaAppHider.setElement(element);
	    }
	
	    /* eslint-disable react/no-unused-prop-types */
	
	    /* eslint-enable react/no-unused-prop-types */
	
	  }]);
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  portalClassName: _propTypes2.default.string,
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
	    base: _propTypes2.default.string.isRequired,
	    afterOpen: _propTypes2.default.string.isRequired,
	    beforeClose: _propTypes2.default.string.isRequired
	  })]),
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  ariaHideApp: _propTypes2.default.bool,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  parentSelector: _propTypes2.default.func,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func
	};
	Modal.defaultProps = {
	  isOpen: false,
	  portalClassName: portalClassName,
	  bodyOpenClassName: bodyOpenClassName,
	  role: "dialog",
	  ariaHideApp: true,
	  closeTimeoutMS: 0,
	  shouldFocusAfterRender: true,
	  shouldCloseOnEsc: true,
	  shouldCloseOnOverlayClick: true,
	  shouldReturnFocusAfterClose: true,
	  preventScroll: false,
	  parentSelector: function parentSelector() {
	    return document.body;
	  },
	  overlayElement: function overlayElement(props, contentEl) {
	    return _react2.default.createElement(
	      "div",
	      props,
	      contentEl
	    );
	  },
	  contentElement: function contentElement(props, children) {
	    return _react2.default.createElement(
	      "div",
	      props,
	      children
	    );
	  }
	};
	Modal.defaultStyles = {
	  overlay: {
	    position: "fixed",
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    backgroundColor: "rgba(255, 255, 255, 0.75)"
	  },
	  content: {
	    position: "absolute",
	    top: "40px",
	    left: "40px",
	    right: "40px",
	    bottom: "40px",
	    border: "1px solid #ccc",
	    background: "#fff",
	    overflow: "auto",
	    WebkitOverflowScrolling: "touch",
	    borderRadius: "4px",
	    outline: "none",
	    padding: "20px"
	  }
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Modal);
	
	exports.default = Modal;

/***/ }),
/* 1668 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _focusManager = __webpack_require__(1671);
	
	var focusManager = _interopRequireWildcard(_focusManager);
	
	var _scopeTab = __webpack_require__(1672);
	
	var _scopeTab2 = _interopRequireDefault(_scopeTab);
	
	var _ariaAppHider = __webpack_require__(756);
	
	var ariaAppHider = _interopRequireWildcard(_ariaAppHider);
	
	var _classList = __webpack_require__(1670);
	
	var classList = _interopRequireWildcard(_classList);
	
	var _safeHTMLElement = __webpack_require__(390);
	
	var _safeHTMLElement2 = _interopRequireDefault(_safeHTMLElement);
	
	var _portalOpenInstances = __webpack_require__(757);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	__webpack_require__(1669);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: "ReactModal__Overlay",
	  content: "ReactModal__Content"
	};
	
	var TAB_KEY = 9;
	var ESC_KEY = 27;
	
	var ariaHiddenInstances = 0;
	
	var ModalPortal = function (_Component) {
	  _inherits(ModalPortal, _Component);
	
	  function ModalPortal(props) {
	    _classCallCheck(this, ModalPortal);
	
	    var _this = _possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
	
	    _this.setOverlayRef = function (overlay) {
	      _this.overlay = overlay;
	      _this.props.overlayRef && _this.props.overlayRef(overlay);
	    };
	
	    _this.setContentRef = function (content) {
	      _this.content = content;
	      _this.props.contentRef && _this.props.contentRef(content);
	    };
	
	    _this.afterClose = function () {
	      var _this$props = _this.props,
	          appElement = _this$props.appElement,
	          ariaHideApp = _this$props.ariaHideApp,
	          htmlOpenClassName = _this$props.htmlOpenClassName,
	          bodyOpenClassName = _this$props.bodyOpenClassName;
	
	      // Remove classes.
	
	      bodyOpenClassName && classList.remove(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      // Reset aria-hidden attribute if all modals have been removed
	      if (ariaHideApp && ariaHiddenInstances > 0) {
	        ariaHiddenInstances -= 1;
	
	        if (ariaHiddenInstances === 0) {
	          ariaAppHider.show(appElement);
	        }
	      }
	
	      if (_this.props.shouldFocusAfterRender) {
	        if (_this.props.shouldReturnFocusAfterClose) {
	          focusManager.returnFocus(_this.props.preventScroll);
	          focusManager.teardownScopedFocus();
	        } else {
	          focusManager.popWithoutFocus();
	        }
	      }
	
	      if (_this.props.onAfterClose) {
	        _this.props.onAfterClose();
	      }
	
	      _portalOpenInstances2.default.deregister(_this);
	    };
	
	    _this.open = function () {
	      _this.beforeOpen();
	      if (_this.state.afterOpen && _this.state.beforeClose) {
	        clearTimeout(_this.closeTimer);
	        _this.setState({ beforeClose: false });
	      } else {
	        if (_this.props.shouldFocusAfterRender) {
	          focusManager.setupScopedFocus(_this.node);
	          focusManager.markForFocusLater();
	        }
	
	        _this.setState({ isOpen: true }, function () {
	          _this.setState({ afterOpen: true });
	
	          if (_this.props.isOpen && _this.props.onAfterOpen) {
	            _this.props.onAfterOpen({
	              overlayEl: _this.overlay,
	              contentEl: _this.content
	            });
	          }
	        });
	      }
	    };
	
	    _this.close = function () {
	      if (_this.props.closeTimeoutMS > 0) {
	        _this.closeWithTimeout();
	      } else {
	        _this.closeWithoutTimeout();
	      }
	    };
	
	    _this.focusContent = function () {
	      return _this.content && !_this.contentHasFocus() && _this.content.focus({ preventScroll: true });
	    };
	
	    _this.closeWithTimeout = function () {
	      var closesAt = Date.now() + _this.props.closeTimeoutMS;
	      _this.setState({ beforeClose: true, closesAt: closesAt }, function () {
	        _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
	      });
	    };
	
	    _this.closeWithoutTimeout = function () {
	      _this.setState({
	        beforeClose: false,
	        isOpen: false,
	        afterOpen: false,
	        closesAt: null
	      }, _this.afterClose);
	    };
	
	    _this.handleKeyDown = function (event) {
	      if (event.keyCode === TAB_KEY) {
	        (0, _scopeTab2.default)(_this.content, event);
	      }
	
	      if (_this.props.shouldCloseOnEsc && event.keyCode === ESC_KEY) {
	        event.stopPropagation();
	        _this.requestClose(event);
	      }
	    };
	
	    _this.handleOverlayOnClick = function (event) {
	      if (_this.shouldClose === null) {
	        _this.shouldClose = true;
	      }
	
	      if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
	        if (_this.ownerHandlesClose()) {
	          _this.requestClose(event);
	        } else {
	          _this.focusContent();
	        }
	      }
	      _this.shouldClose = null;
	    };
	
	    _this.handleContentOnMouseUp = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleOverlayOnMouseDown = function (event) {
	      if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) {
	        event.preventDefault();
	      }
	    };
	
	    _this.handleContentOnClick = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.handleContentOnMouseDown = function () {
	      _this.shouldClose = false;
	    };
	
	    _this.requestClose = function (event) {
	      return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
	    };
	
	    _this.ownerHandlesClose = function () {
	      return _this.props.onRequestClose;
	    };
	
	    _this.shouldBeClosed = function () {
	      return !_this.state.isOpen && !_this.state.beforeClose;
	    };
	
	    _this.contentHasFocus = function () {
	      return document.activeElement === _this.content || _this.content.contains(document.activeElement);
	    };
	
	    _this.buildClassName = function (which, additional) {
	      var classNames = (typeof additional === "undefined" ? "undefined" : _typeof(additional)) === "object" ? additional : {
	        base: CLASS_NAMES[which],
	        afterOpen: CLASS_NAMES[which] + "--after-open",
	        beforeClose: CLASS_NAMES[which] + "--before-close"
	      };
	      var className = classNames.base;
	      if (_this.state.afterOpen) {
	        className = className + " " + classNames.afterOpen;
	      }
	      if (_this.state.beforeClose) {
	        className = className + " " + classNames.beforeClose;
	      }
	      return typeof additional === "string" && additional ? className + " " + additional : className;
	    };
	
	    _this.attributesFromObject = function (prefix, items) {
	      return Object.keys(items).reduce(function (acc, name) {
	        acc[prefix + "-" + name] = items[name];
	        return acc;
	      }, {});
	    };
	
	    _this.state = {
	      afterOpen: false,
	      beforeClose: false
	    };
	
	    _this.shouldClose = null;
	    _this.moveFromContentToOverlay = null;
	    return _this;
	  }
	
	  _createClass(ModalPortal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.isOpen) {
	        this.open();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (false) {
	        if (prevProps.bodyOpenClassName !== this.props.bodyOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "bodyOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	        if (prevProps.htmlOpenClassName !== this.props.htmlOpenClassName) {
	          // eslint-disable-next-line no-console
	          console.warn('React-Modal: "htmlOpenClassName" prop has been modified. ' + "This may cause unexpected behavior when multiple modals are open.");
	        }
	      }
	
	      if (this.props.isOpen && !prevProps.isOpen) {
	        this.open();
	      } else if (!this.props.isOpen && prevProps.isOpen) {
	        this.close();
	      }
	
	      // Focus only needs to be set once when the modal is being opened
	      if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) {
	        this.focusContent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.state.isOpen) {
	        this.afterClose();
	      }
	      clearTimeout(this.closeTimer);
	    }
	  }, {
	    key: "beforeOpen",
	    value: function beforeOpen() {
	      var _props = this.props,
	          appElement = _props.appElement,
	          ariaHideApp = _props.ariaHideApp,
	          htmlOpenClassName = _props.htmlOpenClassName,
	          bodyOpenClassName = _props.bodyOpenClassName;
	
	      // Add classes.
	
	      bodyOpenClassName && classList.add(document.body, bodyOpenClassName);
	
	      htmlOpenClassName && classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
	
	      if (ariaHideApp) {
	        ariaHiddenInstances += 1;
	        ariaAppHider.hide(appElement);
	      }
	
	      _portalOpenInstances2.default.register(this);
	    }
	
	    // Don't steal focus from inner elements
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _props2 = this.props,
	          id = _props2.id,
	          className = _props2.className,
	          overlayClassName = _props2.overlayClassName,
	          defaultStyles = _props2.defaultStyles,
	          children = _props2.children;
	
	      var contentStyles = className ? {} : defaultStyles.content;
	      var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
	
	      if (this.shouldBeClosed()) {
	        return null;
	      }
	
	      var overlayProps = {
	        ref: this.setOverlayRef,
	        className: this.buildClassName("overlay", overlayClassName),
	        style: _extends({}, overlayStyles, this.props.style.overlay),
	        onClick: this.handleOverlayOnClick,
	        onMouseDown: this.handleOverlayOnMouseDown
	      };
	
	      var contentProps = _extends({
	        id: id,
	        ref: this.setContentRef,
	        style: _extends({}, contentStyles, this.props.style.content),
	        className: this.buildClassName("content", className),
	        tabIndex: "-1",
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleContentOnMouseDown,
	        onMouseUp: this.handleContentOnMouseUp,
	        onClick: this.handleContentOnClick,
	        role: this.props.role,
	        "aria-label": this.props.contentLabel
	      }, this.attributesFromObject("aria", _extends({ modal: true }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
	        "data-testid": this.props.testId
	      });
	
	      var contentElement = this.props.contentElement(contentProps, children);
	      return this.props.overlayElement(overlayProps, contentElement);
	    }
	  }]);
	
	  return ModalPortal;
	}(_react.Component);
	
	ModalPortal.defaultProps = {
	  style: {
	    overlay: {},
	    content: {}
	  },
	  defaultStyles: {}
	};
	ModalPortal.propTypes = {
	  isOpen: _propTypes2.default.bool.isRequired,
	  defaultStyles: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  style: _propTypes2.default.shape({
	    content: _propTypes2.default.object,
	    overlay: _propTypes2.default.object
	  }),
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  overlayClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  bodyOpenClassName: _propTypes2.default.string,
	  htmlOpenClassName: _propTypes2.default.string,
	  ariaHideApp: _propTypes2.default.bool,
	  appElement: _propTypes2.default.instanceOf(_safeHTMLElement2.default),
	  onAfterOpen: _propTypes2.default.func,
	  onAfterClose: _propTypes2.default.func,
	  onRequestClose: _propTypes2.default.func,
	  closeTimeoutMS: _propTypes2.default.number,
	  shouldFocusAfterRender: _propTypes2.default.bool,
	  shouldCloseOnOverlayClick: _propTypes2.default.bool,
	  shouldReturnFocusAfterClose: _propTypes2.default.bool,
	  preventScroll: _propTypes2.default.bool,
	  role: _propTypes2.default.string,
	  contentLabel: _propTypes2.default.string,
	  aria: _propTypes2.default.object,
	  data: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  shouldCloseOnEsc: _propTypes2.default.bool,
	  overlayRef: _propTypes2.default.func,
	  contentRef: _propTypes2.default.func,
	  id: _propTypes2.default.string,
	  overlayElement: _propTypes2.default.func,
	  contentElement: _propTypes2.default.func,
	  testId: _propTypes2.default.string
	};
	exports.default = ModalPortal;
	module.exports = exports["default"];

/***/ }),
/* 1669 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _portalOpenInstances = __webpack_require__(757);
	
	var _portalOpenInstances2 = _interopRequireDefault(_portalOpenInstances);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Body focus trap see Issue #742
	
	var before = void 0,
	    after = void 0,
	    instances = [];
	
	function focusContent() {
	  if (instances.length === 0) {
	    if (false) {
	      // eslint-disable-next-line no-console
	      console.warn("React-Modal: Open instances > 0 expected");
	    }
	    return;
	  }
	  instances[instances.length - 1].focusContent();
	}
	
	function bodyTrap(eventType, openInstances) {
	  if (!before || !after) {
	    before = document.createElement("div");
	    before.setAttribute("data-react-modal-body-trap", "");
	    before.style.position = "absolute";
	    before.style.opacity = "0";
	    before.setAttribute("tabindex", "0");
	    before.addEventListener("focus", focusContent);
	    after = before.cloneNode();
	    after.addEventListener("focus", focusContent);
	  }
	
	  instances = openInstances;
	
	  if (instances.length > 0) {
	    // Add focus trap
	    if (document.body.firstChild !== before) {
	      document.body.insertBefore(before, document.body.firstChild);
	    }
	    if (document.body.lastChild !== after) {
	      document.body.appendChild(after);
	    }
	  } else {
	    // Remove focus trap
	    if (before.parentElement) {
	      before.parentElement.removeChild(before);
	    }
	    if (after.parentElement) {
	      after.parentElement.removeChild(after);
	    }
	  }
	}
	
	_portalOpenInstances2.default.subscribe(bodyTrap);

/***/ }),
/* 1670 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dumpClassLists = dumpClassLists;
	var htmlClassList = {};
	var docBodyClassList = {};
	
	function dumpClassLists() {
	  if (false) {
	    var classes = document.getElementsByTagName("html")[0].className;
	    var buffer = "Show tracked classes:\n\n";
	
	    buffer += "<html /> (" + classes + "):\n";
	    for (var x in htmlClassList) {
	      buffer += "  " + x + " " + htmlClassList[x] + "\n";
	    }
	
	    classes = document.body.className;
	
	    // eslint-disable-next-line max-len
	    buffer += "\n\ndoc.body (" + classes + "):\n";
	    for (var _x in docBodyClassList) {
	      buffer += "  " + _x + " " + docBodyClassList[_x] + "\n";
	    }
	
	    buffer += "\n";
	
	    // eslint-disable-next-line no-console
	    console.log(buffer);
	  }
	}
	
	/**
	 * Track the number of reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var incrementReference = function incrementReference(poll, className) {
	  if (!poll[className]) {
	    poll[className] = 0;
	  }
	  poll[className] += 1;
	  return className;
	};
	
	/**
	 * Drop the reference of a class.
	 * @param {object} poll The poll to receive the reference.
	 * @param {string} className The class name.
	 * @return {string}
	 */
	var decrementReference = function decrementReference(poll, className) {
	  if (poll[className]) {
	    poll[className] -= 1;
	  }
	  return className;
	};
	
	/**
	 * Track a class and add to the given class list.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be tracked.
	 */
	var trackClass = function trackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    incrementReference(poll, className);
	    classListRef.add(className);
	  });
	};
	
	/**
	 * Untrack a class and remove from the given class list if the reference
	 * reaches 0.
	 * @param {Object} classListRef A class list of an element.
	 * @param {Object} poll         The poll to be used.
	 * @param {Array}  classes      The list of classes to be untracked.
	 */
	var untrackClass = function untrackClass(classListRef, poll, classes) {
	  classes.forEach(function (className) {
	    decrementReference(poll, className);
	    poll[className] === 0 && classListRef.remove(className);
	  });
	};
	
	/**
	 * Public inferface to add classes to the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var add = exports.add = function add(element, classString) {
	  return trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};
	
	/**
	 * Public inferface to remove classes from the document.body.
	 * @param {string} bodyClass The class string to be added.
	 *                           It may contain more then one class
	 *                           with ' ' as separator.
	 */
	var remove = exports.remove = function remove(element, classString) {
	  return untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? htmlClassList : docBodyClassList, classString.split(" "));
	};

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBlur = handleBlur;
	exports.handleFocus = handleFocus;
	exports.markForFocusLater = markForFocusLater;
	exports.returnFocus = returnFocus;
	exports.popWithoutFocus = popWithoutFocus;
	exports.setupScopedFocus = setupScopedFocus;
	exports.teardownScopedFocus = teardownScopedFocus;
	
	var _tabbable = __webpack_require__(758);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var focusLaterElements = [];
	var modalElement = null;
	var needToFocus = false;
	
	function handleBlur() {
	  needToFocus = true;
	}
	
	function handleFocus() {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation
	    // is that the document.body gets focus, and then we focus our element right
	    // after, seems fine.
	    setTimeout(function () {
	      if (modalElement.contains(document.activeElement)) {
	        return;
	      }
	      var el = (0, _tabbable2.default)(modalElement)[0] || modalElement;
	      el.focus();
	    }, 0);
	  }
	}
	
	function markForFocusLater() {
	  focusLaterElements.push(document.activeElement);
	}
	
	/* eslint-disable no-console */
	function returnFocus() {
	  var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	  var toFocus = null;
	  try {
	    if (focusLaterElements.length !== 0) {
	      toFocus = focusLaterElements.pop();
	      toFocus.focus({ preventScroll: preventScroll });
	    }
	    return;
	  } catch (e) {
	    console.warn(["You tried to return focus to", toFocus, "but it is not in the DOM anymore"].join(" "));
	  }
	}
	/* eslint-enable no-console */
	
	function popWithoutFocus() {
	  focusLaterElements.length > 0 && focusLaterElements.pop();
	}
	
	function setupScopedFocus(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener("blur", handleBlur, false);
	    document.addEventListener("focus", handleFocus, true);
	  } else {
	    window.attachEvent("onBlur", handleBlur);
	    document.attachEvent("onFocus", handleFocus);
	  }
	}
	
	function teardownScopedFocus() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener("blur", handleBlur);
	    document.removeEventListener("focus", handleFocus);
	  } else {
	    window.detachEvent("onBlur", handleBlur);
	    document.detachEvent("onFocus", handleFocus);
	  }
	}

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scopeTab;
	
	var _tabbable = __webpack_require__(758);
	
	var _tabbable2 = _interopRequireDefault(_tabbable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scopeTab(node, event) {
	  var tabbable = (0, _tabbable2.default)(node);
	
	  if (!tabbable.length) {
	    // Do nothing, since there are no elements that can receive focus.
	    event.preventDefault();
	    return;
	  }
	
	  var target = void 0;
	
	  var shiftKey = event.shiftKey;
	  var head = tabbable[0];
	  var tail = tabbable[tabbable.length - 1];
	
	  // proceed with default browser behavior on tab.
	  // Focus on last element on shift + tab.
	  if (node === document.activeElement) {
	    if (!shiftKey) return;
	    target = tail;
	  }
	
	  if (tail === document.activeElement && !shiftKey) {
	    target = head;
	  }
	
	  if (head === document.activeElement && shiftKey) {
	    target = tail;
	  }
	
	  if (target) {
	    event.preventDefault();
	    target.focus();
	    return;
	  }
	
	  // Safari radio issue.
	  //
	  // Safari does not move the focus to the radio button,
	  // so we need to force it to really walk through all elements.
	  //
	  // This is very error prone, since we are trying to guess
	  // if it is a safari browser from the first occurence between
	  // chrome or safari.
	  //
	  // The chrome user agent contains the first ocurrence
	  // as the 'chrome/version' and later the 'safari/version'.
	  var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
	  var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
	
	  // If we are not in safari desktop, let the browser control
	  // the focus
	  if (!isSafariDesktop) return;
	
	  var x = tabbable.indexOf(document.activeElement);
	
	  if (x > -1) {
	    x += shiftKey ? -1 : 1;
	  }
	
	  target = tabbable[x];
	
	  // If the tabbable element does not exist,
	  // focus head/tail based on shiftKey
	  if (typeof target === "undefined") {
	    event.preventDefault();
	    target = shiftKey ? tail : head;
	    target.focus();
	    return;
	  }
	
	  event.preventDefault();
	
	  target.focus();
	}
	module.exports = exports["default"];

/***/ }),
/* 1673 */
1298,
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(392);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(275);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(394);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(384);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(385);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(393);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	var Motion = (function (_React$Component) {
	  _inherits(Motion, _React$Component);
	
	  _createClass(Motion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
	      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      onRest: _propTypes2['default'].func
	    },
	    enumerable: true
	  }]);
	
	  function Motion(props) {
	    var _this = this;
	
	    _classCallCheck(this, Motion);
	
	    _React$Component.call(this, props);
	    this.wasAnimating = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyle = null;
	
	    this.clearUnreadPropStyle = function (destStyle) {
	      var dirty = false;
	      var _state = _this.state;
	      var currentStyle = _state.currentStyle;
	      var currentVelocity = _state.currentVelocity;
	      var lastIdealStyle = _state.lastIdealStyle;
	      var lastIdealVelocity = _state.lastIdealVelocity;
	
	      for (var key in destStyle) {
	        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	          continue;
	        }
	
	        var styleValue = destStyle[key];
	        if (typeof styleValue === 'number') {
	          if (!dirty) {
	            dirty = true;
	            currentStyle = _extends({}, currentStyle);
	            currentVelocity = _extends({}, currentVelocity);
	            lastIdealStyle = _extends({}, lastIdealStyle);
	            lastIdealVelocity = _extends({}, lastIdealVelocity);
	          }
	
	          currentStyle[key] = styleValue;
	          currentVelocity[key] = 0;
	          lastIdealStyle[key] = styleValue;
	          lastIdealVelocity[key] = 0;
	        }
	      }
	
	      if (dirty) {
	        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // check if we need to animate in the first place
	        var propsStyle = _this.props.style;
	        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
	          if (_this.wasAnimating && _this.props.onRest) {
	            _this.props.onRest();
	          }
	
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.wasAnimating = false;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        _this.wasAnimating = true;
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyle = {};
	        var newLastIdealVelocity = {};
	        var newCurrentStyle = {};
	        var newCurrentVelocity = {};
	
	        for (var key in propsStyle) {
	          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
	            continue;
	          }
	
	          var styleValue = propsStyle[key];
	          if (typeof styleValue === 'number') {
	            newCurrentStyle[key] = styleValue;
	            newCurrentVelocity[key] = 0;
	            newLastIdealStyle[key] = styleValue;
	            newLastIdealVelocity[key] = 0;
	          } else {
	            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
	            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
	            for (var i = 0; i < framesToCatchUp; i++) {
	              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              newLastIdealStyleValue = _stepper[0];
	              newLastIdealVelocityValue = _stepper[1];
	            }
	
	            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	            var nextIdealX = _stepper2[0];
	            var nextIdealV = _stepper2[1];
	
	            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	            newLastIdealStyle[key] = newLastIdealStyleValue;
	            newLastIdealVelocity[key] = newLastIdealVelocityValue;
	          }
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyle: newCurrentStyle,
	          currentVelocity: newCurrentVelocity,
	          lastIdealStyle: newLastIdealStyle,
	          lastIdealVelocity: newLastIdealVelocity
	        });
	
	        _this.unreadPropStyle = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  Motion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyle = _props.defaultStyle;
	    var style = _props.style;
	
	    var currentStyle = defaultStyle || _stripStyle2['default'](style);
	    var currentVelocity = _mapToZero2['default'](currentStyle);
	    return {
	      currentStyle: currentStyle,
	      currentVelocity: currentVelocity,
	      lastIdealStyle: currentStyle,
	      lastIdealVelocity: currentVelocity
	    };
	  };
	
	  // it's possible that currentStyle's value is stale: if props is immediately
	  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
	  // at 0 (didn't have time to tick and interpolate even once). If we naively
	  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	  // In reality currentStyle should be 400
	
	  Motion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyle != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyle);
	    }
	
	    this.unreadPropStyle = props.style;
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  Motion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyle);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return Motion;
	})(_react2['default'].Component);
	
	exports['default'] = Motion;
	module.exports = exports['default'];
	
	// after checking for unreadPropStyle != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(392);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(275);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(394);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _performanceNow = __webpack_require__(384);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(385);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(393);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
	  for (var i = 0; i < currentStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	var StaggeredMotion = (function (_React$Component) {
	  _inherits(StaggeredMotion, _React$Component);
	
	  _createClass(StaggeredMotion, null, [{
	    key: 'propTypes',
	    value: {
	      // TOOD: warn against putting a config in here
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
	      styles: _propTypes2['default'].func.isRequired,
	      children: _propTypes2['default'].func.isRequired
	    },
	    enumerable: true
	  }]);
	
	  function StaggeredMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, StaggeredMotion);
	
	    _React$Component.call(this, props);
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _state = _this.state;
	      var currentStyles = _state.currentStyles;
	      var currentVelocities = _state.currentVelocities;
	      var lastIdealStyles = _state.lastIdealStyles;
	      var lastIdealVelocities = _state.lastIdealVelocities;
	
	      var someDirty = false;
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i];
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              someDirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	          }
	        }
	      }
	
	      if (someDirty) {
	        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
	      }
	    };
	
	    this.startAnimationIfNecessary = function () {
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        var destStyles = _this.props.styles(_this.state.lastIdealStyles);
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var newLastIdealStyles = [];
	        var newLastIdealVelocities = [];
	        var newCurrentStyles = [];
	        var newCurrentVelocities = [];
	
	        for (var i = 0; i < destStyles.length; i++) {
	          var destStyle = destStyles[i];
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in destStyle) {
	            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
	              continue;
	            }
	
	            var styleValue = destStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
	              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  StaggeredMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	
	    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
	    var currentVelocities = currentStyles.map(function (currentStyle) {
	      return _mapToZero2['default'](currentStyle);
	    });
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: currentStyles,
	      lastIdealVelocities: currentVelocities
	    };
	  };
	
	  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles != null) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  StaggeredMotion.prototype.render = function render() {
	    var renderedChildren = this.props.children(this.state.currentStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return StaggeredMotion;
	})(_react2['default'].Component);
	
	exports['default'] = StaggeredMotion;
	module.exports = exports['default'];
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400
	
	// after checking for unreadPropStyles != null, we manually go set the
	// non-interpolating values (those that are a number, without a spring
	// config)

/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _mapToZero = __webpack_require__(392);
	
	var _mapToZero2 = _interopRequireDefault(_mapToZero);
	
	var _stripStyle = __webpack_require__(275);
	
	var _stripStyle2 = _interopRequireDefault(_stripStyle);
	
	var _stepper3 = __webpack_require__(394);
	
	var _stepper4 = _interopRequireDefault(_stepper3);
	
	var _mergeDiff = __webpack_require__(1677);
	
	var _mergeDiff2 = _interopRequireDefault(_mergeDiff);
	
	var _performanceNow = __webpack_require__(384);
	
	var _performanceNow2 = _interopRequireDefault(_performanceNow);
	
	var _raf = __webpack_require__(385);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _shouldStopAnimation = __webpack_require__(393);
	
	var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var msPerFrame = 1000 / 60;
	
	// the children function & (potential) styles function asks as param an
	// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
	// {key: string, data?: any, style: PlainStyle}. However, the way we keep
	// internal states doesn't contain such a data structure (check the state and
	// TransitionMotionState). So when children function and others ask for such
	// data we need to generate them on the fly by combining mergedPropsStyles and
	// currentStyles/lastIdealStyles
	function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
	  // Copy the value to a `const` so that Flow understands that the const won't
	  // change and will be non-nullable in the callback below.
	  var cUnreadPropStyles = unreadPropStyles;
	  if (cUnreadPropStyles == null) {
	    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	      return {
	        key: mergedPropsStyle.key,
	        data: mergedPropsStyle.data,
	        style: plainStyles[i]
	      };
	    });
	  }
	  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
	    for (var j = 0; j < cUnreadPropStyles.length; j++) {
	      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
	        return {
	          key: cUnreadPropStyles[j].key,
	          data: cUnreadPropStyles[j].data,
	          style: plainStyles[i]
	        };
	      }
	    }
	    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
	  });
	}
	
	function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
	  if (mergedPropsStyles.length !== destStyles.length) {
	    return false;
	  }
	
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (mergedPropsStyles[i].key !== destStyles[i].key) {
	      return false;
	    }
	  }
	
	  // we have the invariant that mergedPropsStyles and
	  // currentStyles/currentVelocities/last* are synced in terms of cells, see
	  // mergeAndSync comment for more info
	  for (var i = 0; i < mergedPropsStyles.length; i++) {
	    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	// core key merging logic
	
	// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
	// c}, previous current (interpolating) style is {a, b}
	// **invariant**: current[i] corresponds to merged[i] in terms of key
	
	// steps:
	// turn merged style into {a?, b, c}
	//    add c, value of c is destStyles.c
	//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
	// turn current (interpolating) style from {a, b} into {a?, b, c}
	//    maybe remove a
	//    certainly add c, value of c is willEnter(c)
	// loop over merged and construct new current
	// dest doesn't change, that's owner's
	function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
	  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
	    var leavingStyle = willLeave(oldMergedPropsStyle);
	    if (leavingStyle == null) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
	      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
	      return null;
	    }
	    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
	  });
	
	  var newCurrentStyles = [];
	  var newCurrentVelocities = [];
	  var newLastIdealStyles = [];
	  var newLastIdealVelocities = [];
	  for (var i = 0; i < newMergedPropsStyles.length; i++) {
	    var newMergedPropsStyleCell = newMergedPropsStyles[i];
	    var foundOldIndex = null;
	    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
	      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
	        foundOldIndex = j;
	        break;
	      }
	    }
	    // TODO: key search code
	    if (foundOldIndex == null) {
	      var plainStyle = willEnter(newMergedPropsStyleCell);
	      newCurrentStyles[i] = plainStyle;
	      newLastIdealStyles[i] = plainStyle;
	
	      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
	      newCurrentVelocities[i] = velocity;
	      newLastIdealVelocities[i] = velocity;
	    } else {
	      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
	      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
	      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
	      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
	    }
	  }
	
	  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
	}
	
	var TransitionMotion = (function (_React$Component) {
	  _inherits(TransitionMotion, _React$Component);
	
	  _createClass(TransitionMotion, null, [{
	    key: 'propTypes',
	    value: {
	      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
	      })),
	      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
	        key: _propTypes2['default'].string.isRequired,
	        data: _propTypes2['default'].any,
	        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
	      }))]).isRequired,
	      children: _propTypes2['default'].func.isRequired,
	      willEnter: _propTypes2['default'].func,
	      willLeave: _propTypes2['default'].func,
	      didLeave: _propTypes2['default'].func
	    },
	    enumerable: true
	  }, {
	    key: 'defaultProps',
	    value: {
	      willEnter: function willEnter(styleThatEntered) {
	        return _stripStyle2['default'](styleThatEntered.style);
	      },
	      // recall: returning null makes the current unmounting TransitionStyle
	      // disappear immediately
	      willLeave: function willLeave() {
	        return null;
	      },
	      didLeave: function didLeave() {}
	    },
	    enumerable: true
	  }]);
	
	  function TransitionMotion(props) {
	    var _this = this;
	
	    _classCallCheck(this, TransitionMotion);
	
	    _React$Component.call(this, props);
	    this.unmounting = false;
	    this.animationID = null;
	    this.prevTime = 0;
	    this.accumulatedTime = 0;
	    this.unreadPropStyles = null;
	
	    this.clearUnreadPropStyle = function (unreadPropStyles) {
	      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	      var mergedPropsStyles = _mergeAndSync[0];
	      var currentStyles = _mergeAndSync[1];
	      var currentVelocities = _mergeAndSync[2];
	      var lastIdealStyles = _mergeAndSync[3];
	      var lastIdealVelocities = _mergeAndSync[4];
	
	      for (var i = 0; i < unreadPropStyles.length; i++) {
	        var unreadPropStyle = unreadPropStyles[i].style;
	        var dirty = false;
	
	        for (var key in unreadPropStyle) {
	          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
	            continue;
	          }
	
	          var styleValue = unreadPropStyle[key];
	          if (typeof styleValue === 'number') {
	            if (!dirty) {
	              dirty = true;
	              currentStyles[i] = _extends({}, currentStyles[i]);
	              currentVelocities[i] = _extends({}, currentVelocities[i]);
	              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
	              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
	              mergedPropsStyles[i] = {
	                key: mergedPropsStyles[i].key,
	                data: mergedPropsStyles[i].data,
	                style: _extends({}, mergedPropsStyles[i].style)
	              };
	            }
	            currentStyles[i][key] = styleValue;
	            currentVelocities[i][key] = 0;
	            lastIdealStyles[i][key] = styleValue;
	            lastIdealVelocities[i][key] = 0;
	            mergedPropsStyles[i].style[key] = styleValue;
	          }
	        }
	      }
	
	      // unlike the other 2 components, we can't detect staleness and optionally
	      // opt out of setState here. each style object's data might contain new
	      // stuff we're not/cannot compare
	      _this.setState({
	        currentStyles: currentStyles,
	        currentVelocities: currentVelocities,
	        mergedPropsStyles: mergedPropsStyles,
	        lastIdealStyles: lastIdealStyles,
	        lastIdealVelocities: lastIdealVelocities
	      });
	    };
	
	    this.startAnimationIfNecessary = function () {
	      if (_this.unmounting) {
	        return;
	      }
	
	      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
	      // call cb? No, otherwise accidental parent rerender causes cb trigger
	      _this.animationID = _raf2['default'](function (timestamp) {
	        // https://github.com/chenglou/react-motion/pull/420
	        // > if execution passes the conditional if (this.unmounting), then
	        // executes async defaultRaf and after that component unmounts and after
	        // that the callback of defaultRaf is called, then setState will be called
	        // on unmounted component.
	        if (_this.unmounting) {
	          return;
	        }
	
	        var propStyles = _this.props.styles;
	        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
	
	        // check if we need to animate in the first place
	        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.accumulatedTime = 0;
	          return;
	        }
	
	        var currentTime = timestamp || _performanceNow2['default']();
	        var timeDelta = currentTime - _this.prevTime;
	        _this.prevTime = currentTime;
	        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
	        // more than 10 frames? prolly switched browser tab. Restart
	        if (_this.accumulatedTime > msPerFrame * 10) {
	          _this.accumulatedTime = 0;
	        }
	
	        if (_this.accumulatedTime === 0) {
	          // no need to cancel animationID here; shouldn't have any in flight
	          _this.animationID = null;
	          _this.startAnimationIfNecessary();
	          return;
	        }
	
	        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
	        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);
	
	        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
	
	        var newMergedPropsStyles = _mergeAndSync2[0];
	        var newCurrentStyles = _mergeAndSync2[1];
	        var newCurrentVelocities = _mergeAndSync2[2];
	        var newLastIdealStyles = _mergeAndSync2[3];
	        var newLastIdealVelocities = _mergeAndSync2[4];
	
	        for (var i = 0; i < newMergedPropsStyles.length; i++) {
	          var newMergedPropsStyle = newMergedPropsStyles[i].style;
	          var newCurrentStyle = {};
	          var newCurrentVelocity = {};
	          var newLastIdealStyle = {};
	          var newLastIdealVelocity = {};
	
	          for (var key in newMergedPropsStyle) {
	            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
	              continue;
	            }
	
	            var styleValue = newMergedPropsStyle[key];
	            if (typeof styleValue === 'number') {
	              newCurrentStyle[key] = styleValue;
	              newCurrentVelocity[key] = 0;
	              newLastIdealStyle[key] = styleValue;
	              newLastIdealVelocity[key] = 0;
	            } else {
	              var newLastIdealStyleValue = newLastIdealStyles[i][key];
	              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
	              for (var j = 0; j < framesToCatchUp; j++) {
	                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	                newLastIdealStyleValue = _stepper[0];
	                newLastIdealVelocityValue = _stepper[1];
	              }
	
	              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
	
	              var nextIdealX = _stepper2[0];
	              var nextIdealV = _stepper2[1];
	
	              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
	              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
	              newLastIdealStyle[key] = newLastIdealStyleValue;
	              newLastIdealVelocity[key] = newLastIdealVelocityValue;
	            }
	          }
	
	          newLastIdealStyles[i] = newLastIdealStyle;
	          newLastIdealVelocities[i] = newLastIdealVelocity;
	          newCurrentStyles[i] = newCurrentStyle;
	          newCurrentVelocities[i] = newCurrentVelocity;
	        }
	
	        _this.animationID = null;
	        // the amount we're looped over above
	        _this.accumulatedTime -= framesToCatchUp * msPerFrame;
	
	        _this.setState({
	          currentStyles: newCurrentStyles,
	          currentVelocities: newCurrentVelocities,
	          lastIdealStyles: newLastIdealStyles,
	          lastIdealVelocities: newLastIdealVelocities,
	          mergedPropsStyles: newMergedPropsStyles
	        });
	
	        _this.unreadPropStyles = null;
	
	        _this.startAnimationIfNecessary();
	      });
	    };
	
	    this.state = this.defaultState();
	  }
	
	  TransitionMotion.prototype.defaultState = function defaultState() {
	    var _props = this.props;
	    var defaultStyles = _props.defaultStyles;
	    var styles = _props.styles;
	    var willEnter = _props.willEnter;
	    var willLeave = _props.willLeave;
	    var didLeave = _props.didLeave;
	
	    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
	
	    // this is special. for the first time around, we don't have a comparison
	    // between last (no last) and current merged props. we'll compute last so:
	    // say default is {a, b} and styles (dest style) is {b, c}, we'll
	    // fabricate last as {a, b}
	    var oldMergedPropsStyles = undefined;
	    if (defaultStyles == null) {
	      oldMergedPropsStyles = destStyles;
	    } else {
	      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
	        // TODO: key search code
	        for (var i = 0; i < destStyles.length; i++) {
	          if (destStyles[i].key === defaultStyleCell.key) {
	            return destStyles[i];
	          }
	        }
	        return defaultStyleCell;
	      });
	    }
	    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _stripStyle2['default'](s.style);
	    });
	    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    }) : defaultStyles.map(function (s) {
	      return _mapToZero2['default'](s.style);
	    });
	
	    var _mergeAndSync3 = mergeAndSync(
	    // Because this is an old-style createReactClass component, Flow doesn't
	    // understand that the willEnter and willLeave props have default values
	    // and will always be present.
	    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
	    oldCurrentVelocities);
	
	    var mergedPropsStyles = _mergeAndSync3[0];
	    var currentStyles = _mergeAndSync3[1];
	    var currentVelocities = _mergeAndSync3[2];
	    var lastIdealStyles = _mergeAndSync3[3];
	    var lastIdealVelocities = _mergeAndSync3[4];
	    // oldLastIdealVelocities really
	
	    return {
	      currentStyles: currentStyles,
	      currentVelocities: currentVelocities,
	      lastIdealStyles: lastIdealStyles,
	      lastIdealVelocities: lastIdealVelocities,
	      mergedPropsStyles: mergedPropsStyles
	    };
	  };
	
	  // after checking for unreadPropStyles != null, we manually go set the
	  // non-interpolating values (those that are a number, without a spring
	  // config)
	
	  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
	    this.prevTime = _performanceNow2['default']();
	    this.startAnimationIfNecessary();
	  };
	
	  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (this.unreadPropStyles) {
	      // previous props haven't had the chance to be set yet; set them here
	      this.clearUnreadPropStyle(this.unreadPropStyles);
	    }
	
	    var styles = props.styles;
	    if (typeof styles === 'function') {
	      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
	    } else {
	      this.unreadPropStyles = styles;
	    }
	
	    if (this.animationID == null) {
	      this.prevTime = _performanceNow2['default']();
	      this.startAnimationIfNecessary();
	    }
	  };
	
	  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unmounting = true;
	    if (this.animationID != null) {
	      _raf2['default'].cancel(this.animationID);
	      this.animationID = null;
	    }
	  };
	
	  TransitionMotion.prototype.render = function render() {
	    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
	    var renderedChildren = this.props.children(hydratedStyles);
	    return renderedChildren && _react2['default'].Children.only(renderedChildren);
	  };
	
	  return TransitionMotion;
	})(_react2['default'].Component);
	
	exports['default'] = TransitionMotion;
	module.exports = exports['default'];
	
	// list of styles, each containing interpolating values. Part of what's passed
	// to children function. Notice that this is
	// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
	// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
	// contains the key & data info (so that we only have a single source of truth
	// for these, and to save space). Check the comment for `rehydrateStyles` to
	// see how we regenerate the entirety of what's passed to children function
	
	// the array that keeps track of currently rendered stuff! Including stuff
	// that you've unmounted but that's still animating. This is where it lives
	
	// it's possible that currentStyle's value is stale: if props is immediately
	// changed from 0 to 400 to spring(0) again, the async currentStyle is still
	// at 0 (didn't have time to tick and interpolate even once). If we naively
	// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
	// In reality currentStyle should be 400

/***/ }),
/* 1677 */
/***/ (function(module, exports) {

	
	
	// core keys merging algorithm. If previous render's keys are [a, b], and the
	// next render's [c, b, d], what's the final merged keys and ordering?
	
	// - c and a must both be before b
	// - b before d
	// - ordering between a and c ambiguous
	
	// this reduces to merging two partially ordered lists (e.g. lists where not
	// every item has a definite ordering, like comparing a and c above). For the
	// ambiguous ordering we deterministically choose to place the next render's
	// item after the previous'; so c after a
	
	// this is called a topological sorting. Except the existing algorithms don't
	// work well with js bc of the amount of allocation, and isn't optimized for our
	// current use-case bc the runtime is linear in terms of edges (see wiki for
	// meaning), which is huge when two lists have many common elements
	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeDiff;
	
	function mergeDiff(prev, next, onRemove) {
	  // bookkeeping for easier access of a key's index below. This is 2 allocations +
	  // potentially triggering chrome hash map mode for objs (so it might be faster
	
	  var prevKeyIndex = {};
	  for (var i = 0; i < prev.length; i++) {
	    prevKeyIndex[prev[i].key] = i;
	  }
	  var nextKeyIndex = {};
	  for (var i = 0; i < next.length; i++) {
	    nextKeyIndex[next[i].key] = i;
	  }
	
	  // first, an overly elaborate way of merging prev and next, eliminating
	  // duplicates (in terms of keys). If there's dupe, keep the item in next).
	  // This way of writing it saves allocations
	  var ret = [];
	  for (var i = 0; i < next.length; i++) {
	    ret[i] = next[i];
	  }
	  for (var i = 0; i < prev.length; i++) {
	    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
	      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
	      // merge in keys that the user desires to kill
	      var fill = onRemove(i, prev[i]);
	      if (fill != null) {
	        ret.push(fill);
	      }
	    }
	  }
	
	  // now all the items all present. Core sorting logic to have the right order
	  return ret.sort(function (a, b) {
	    var nextOrderA = nextKeyIndex[a.key];
	    var nextOrderB = nextKeyIndex[b.key];
	    var prevOrderA = prevKeyIndex[a.key];
	    var prevOrderB = prevKeyIndex[b.key];
	
	    if (nextOrderA != null && nextOrderB != null) {
	      // both keys in next
	      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
	    } else if (prevOrderA != null && prevOrderB != null) {
	      // both keys in prev
	      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
	    } else if (nextOrderA != null) {
	      // key a in next, key b in prev
	
	      // how to determine the order between a and b? We find a "pivot" (term
	      // abuse), a key present in both prev and next, that is sandwiched between
	      // a and b. In the context of our above example, if we're comparing a and
	      // d, b's (the only) pivot
	      for (var i = 0; i < next.length; i++) {
	        var pivot = next[i].key;
	        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	          continue;
	        }
	
	        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
	          return -1;
	        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
	          return 1;
	        }
	      }
	      // pluggable. default to: next bigger than prev
	      return 1;
	    }
	    // prevOrderA, nextOrderB
	    for (var i = 0; i < next.length; i++) {
	      var pivot = next[i].key;
	      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
	        continue;
	      }
	      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
	        return 1;
	      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
	        return -1;
	      }
	    }
	    // pluggable. default to: next bigger than prev
	    return -1;
	  });
	}
	
	module.exports = exports['default'];
	// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 1678 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _Motion = __webpack_require__(1674);
	
	exports.Motion = _interopRequire(_Motion);
	
	var _StaggeredMotion = __webpack_require__(1675);
	
	exports.StaggeredMotion = _interopRequire(_StaggeredMotion);
	
	var _TransitionMotion = __webpack_require__(1676);
	
	exports.TransitionMotion = _interopRequire(_TransitionMotion);
	
	var _spring = __webpack_require__(1680);
	
	exports.spring = _interopRequire(_spring);
	
	var _presets = __webpack_require__(759);
	
	exports.presets = _interopRequire(_presets);
	
	var _stripStyle = __webpack_require__(275);
	
	exports.stripStyle = _interopRequire(_stripStyle);
	
	// deprecated, dummy warning function
	
	var _reorderKeys = __webpack_require__(1679);
	
	exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 1679 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = reorderKeys;
	
	var hasWarned = false;
	
	function reorderKeys() {
	  if (false) {
	    if (!hasWarned) {
	      hasWarned = true;
	      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
	    }
	  }
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1680 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = spring;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _presets = __webpack_require__(759);
	
	var _presets2 = _interopRequireDefault(_presets);
	
	var defaultConfig = _extends({}, _presets2['default'].noWobble, {
	  precision: 0.01
	});
	
	function spring(val, config) {
	  return _extends({}, defaultConfig, config, { val: val });
	}
	
	module.exports = exports['default'];

/***/ }),
/* 1681 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var react = __webpack_require__(1);
	var reactDom = __webpack_require__(30);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	/**
	 * Check whether some DOM node is our Component's node.
	 */
	function isNodeFound(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // SVG <use/> elements do not technically reside in the rendered DOM, so
	  // they do not have classList directly, but they offer a link to their
	  // corresponding element, which can have classList. This extra check is for
	  // that case.
	  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
	  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
	
	
	  if (current.correspondingElement) {
	    return current.correspondingElement.classList.contains(ignoreClass);
	  }
	
	  return current.classList.contains(ignoreClass);
	}
	/**
	 * Try to find our node in a hierarchy of nodes, returning the document
	 * node as highest node if our node is not found in the path up.
	 */
	
	function findHighest(current, componentNode, ignoreClass) {
	  if (current === componentNode) {
	    return true;
	  } // If source=local then this event came from 'somewhere'
	  // inside and should be ignored. We could handle this with
	  // a layered approach, too, but that requires going back to
	  // thinking in terms of Dom node nesting, running counter
	  // to React's 'you shouldn't care about the DOM' philosophy.
	
	
	  while (current.parentNode) {
	    if (isNodeFound(current, componentNode, ignoreClass)) {
	      return true;
	    }
	
	    current = current.parentNode;
	  }
	
	  return current;
	}
	/**
	 * Check if the browser scrollbar was clicked
	 */
	
	function clickedScrollbar(evt) {
	  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
	}
	
	// ideally will get replaced with external dep
	// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
	var testPassiveEventSupport = function testPassiveEventSupport() {
	  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
	    return;
	  }
	
	  var passive = false;
	  var options = Object.defineProperty({}, 'passive', {
	    get: function get() {
	      passive = true;
	    }
	  });
	
	  var noop = function noop() {};
	
	  window.addEventListener('testPassiveEventSupport', noop, options);
	  window.removeEventListener('testPassiveEventSupport', noop, options);
	  return passive;
	};
	
	function autoInc(seed) {
	  if (seed === void 0) {
	    seed = 0;
	  }
	
	  return function () {
	    return ++seed;
	  };
	}
	
	var uid = autoInc();
	
	var passiveEventSupport;
	var handlersMap = {};
	var enabledInstances = {};
	var touchEvents = ['touchstart', 'touchmove'];
	var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
	/**
	 * Options for addEventHandler and removeEventHandler
	 */
	
	function getEventHandlerOptions(instance, eventName) {
	  var handlerOptions = null;
	  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;
	
	  if (isTouchEvent && passiveEventSupport) {
	    handlerOptions = {
	      passive: !instance.props.preventDefault
	    };
	  }
	
	  return handlerOptions;
	}
	/**
	 * This function generates the HOC function that you'll use
	 * in order to impart onOutsideClick listening to an
	 * arbitrary component. It gets called at the end of the
	 * bootstrapping code to yield an instance of the
	 * onClickOutsideHOC function defined inside setupHOC().
	 */
	
	
	function onClickOutsideHOC(WrappedComponent, config) {
	  var _class, _temp;
	
	  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  return _temp = _class =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(onClickOutside, _Component);
	
	    function onClickOutside(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	
	      _this.__outsideClickHandler = function (event) {
	        if (typeof _this.__clickOutsideHandlerProp === 'function') {
	          _this.__clickOutsideHandlerProp(event);
	
	          return;
	        }
	
	        var instance = _this.getInstance();
	
	        if (typeof instance.props.handleClickOutside === 'function') {
	          instance.props.handleClickOutside(event);
	          return;
	        }
	
	        if (typeof instance.handleClickOutside === 'function') {
	          instance.handleClickOutside(event);
	          return;
	        }
	
	        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
	      };
	
	      _this.__getComponentNode = function () {
	        var instance = _this.getInstance();
	
	        if (config && typeof config.setClickOutsideRef === 'function') {
	          return config.setClickOutsideRef()(instance);
	        }
	
	        if (typeof instance.setClickOutsideRef === 'function') {
	          return instance.setClickOutsideRef();
	        }
	
	        return reactDom.findDOMNode(instance);
	      };
	
	      _this.enableOnClickOutside = function () {
	        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
	          return;
	        }
	
	        if (typeof passiveEventSupport === 'undefined') {
	          passiveEventSupport = testPassiveEventSupport();
	        }
	
	        enabledInstances[_this._uid] = true;
	        var events = _this.props.eventTypes;
	
	        if (!events.forEach) {
	          events = [events];
	        }
	
	        handlersMap[_this._uid] = function (event) {
	          if (_this.componentNode === null) return;
	
	          if (_this.props.preventDefault) {
	            event.preventDefault();
	          }
	
	          if (_this.props.stopPropagation) {
	            event.stopPropagation();
	          }
	
	          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
	          var current = event.target;
	
	          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
	            return;
	          }
	
	          _this.__outsideClickHandler(event);
	        };
	
	        events.forEach(function (eventName) {
	          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
	        });
	      };
	
	      _this.disableOnClickOutside = function () {
	        delete enabledInstances[_this._uid];
	        var fn = handlersMap[_this._uid];
	
	        if (fn && typeof document !== 'undefined') {
	          var events = _this.props.eventTypes;
	
	          if (!events.forEach) {
	            events = [events];
	          }
	
	          events.forEach(function (eventName) {
	            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
	          });
	          delete handlersMap[_this._uid];
	        }
	      };
	
	      _this.getRef = function (ref) {
	        return _this.instanceRef = ref;
	      };
	
	      _this._uid = uid();
	      return _this;
	    }
	    /**
	     * Access the WrappedComponent's instance.
	     */
	
	
	    var _proto = onClickOutside.prototype;
	
	    _proto.getInstance = function getInstance() {
	      if (!WrappedComponent.prototype.isReactComponent) {
	        return this;
	      }
	
	      var ref = this.instanceRef;
	      return ref.getInstance ? ref.getInstance() : ref;
	    };
	
	    /**
	     * Add click listeners to the current document,
	     * linked to this component's state.
	     */
	    _proto.componentDidMount = function componentDidMount() {
	      // If we are in an environment without a DOM such
	      // as shallow rendering or snapshots then we exit
	      // early to prevent any unhandled errors being thrown.
	      if (typeof document === 'undefined' || !document.createElement) {
	        return;
	      }
	
	      var instance = this.getInstance();
	
	      if (config && typeof config.handleClickOutside === 'function') {
	        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
	
	        if (typeof this.__clickOutsideHandlerProp !== 'function') {
	          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
	        }
	      }
	
	      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
	
	      if (this.props.disableOnClickOutside) return;
	      this.enableOnClickOutside();
	    };
	
	    _proto.componentDidUpdate = function componentDidUpdate() {
	      this.componentNode = this.__getComponentNode();
	    };
	    /**
	     * Remove all document's event listeners for this component
	     */
	
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.disableOnClickOutside();
	    };
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	
	
	    /**
	     * Pass-through render
	     */
	    _proto.render = function render() {
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          excludeScrollbar = _props.excludeScrollbar,
	          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);
	
	      if (WrappedComponent.prototype.isReactComponent) {
	        props.ref = this.getRef;
	      } else {
	        props.wrappedRef = this.getRef;
	      }
	
	      props.disableOnClickOutside = this.disableOnClickOutside;
	      props.enableOnClickOutside = this.enableOnClickOutside;
	      return react.createElement(WrappedComponent, props);
	    };
	
	    return onClickOutside;
	  }(react.Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
	    eventTypes: ['mousedown', 'touchstart'],
	    excludeScrollbar: config && config.excludeScrollbar || false,
	    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
	    preventDefault: false,
	    stopPropagation: false
	  }, _class.getClass = function () {
	    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
	  }, _temp;
	}
	
	exports.IGNORE_CLASS_NAME = IGNORE_CLASS_NAME;
	exports['default'] = onClickOutsideHOC;


/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Popper;
	exports.placements = exports.InnerPopper = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(219));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(278));
	
	var _deepEqual = _interopRequireDefault(__webpack_require__(1307));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _popper = _interopRequireDefault(__webpack_require__(1638));
	
	var _Manager = __webpack_require__(395);
	
	var _utils = __webpack_require__(760);
	
	var initialStyle = {
	  position: 'absolute',
	  top: 0,
	  left: 0,
	  opacity: 0,
	  pointerEvents: 'none'
	};
	var initialArrowStyle = {};
	
	var InnerPopper =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerPopper, _React$Component);
	
	  function InnerPopper() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
	      data: undefined,
	      placement: undefined
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperInstance", void 0);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "popperNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "arrowNode", null);
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setPopperNode", function (popperNode) {
	      if (!popperNode || _this.popperNode === popperNode) return;
	      (0, _utils.setRef)(_this.props.innerRef, popperNode);
	      _this.popperNode = popperNode;
	
	      _this.updatePopperInstance();
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setArrowNode", function (arrowNode) {
	      _this.arrowNode = arrowNode;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateStateModifier", {
	      enabled: true,
	      order: 900,
	      fn: function fn(data) {
	        var placement = data.placement;
	
	        _this.setState({
	          data: data,
	          placement: placement
	        });
	
	        return data;
	      }
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOptions", function () {
	      return {
	        placement: _this.props.placement,
	        eventsEnabled: _this.props.eventsEnabled,
	        positionFixed: _this.props.positionFixed,
	        modifiers: (0, _extends2.default)({}, _this.props.modifiers, {
	          arrow: (0, _extends2.default)({}, _this.props.modifiers && _this.props.modifiers.arrow, {
	            enabled: !!_this.arrowNode,
	            element: _this.arrowNode
	          }),
	          applyStyle: {
	            enabled: false
	          },
	          updateStateModifier: _this.updateStateModifier
	        })
	      };
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopperStyle", function () {
	      return !_this.popperNode || !_this.state.data ? initialStyle : (0, _extends2.default)({
	        position: _this.state.data.offsets.popper.position
	      }, _this.state.data.styles);
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getPopperPlacement", function () {
	      return !_this.state.data ? undefined : _this.state.placement;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getArrowStyle", function () {
	      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getOutOfBoundariesState", function () {
	      return _this.state.data ? _this.state.data.hide : undefined;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "destroyPopperInstance", function () {
	      if (!_this.popperInstance) return;
	
	      _this.popperInstance.destroy();
	
	      _this.popperInstance = null;
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePopperInstance", function () {
	      _this.destroyPopperInstance();
	
	      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
	          popperNode = _assertThisInitialize.popperNode;
	
	      var referenceElement = _this.props.referenceElement;
	      if (!referenceElement || !popperNode) return;
	      _this.popperInstance = new _popper.default(referenceElement, popperNode, _this.getOptions());
	    });
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "scheduleUpdate", function () {
	      if (_this.popperInstance) {
	        _this.popperInstance.scheduleUpdate();
	      }
	    });
	    return _this;
	  }
	
	  var _proto = InnerPopper.prototype;
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    // If the Popper.js options have changed, update the instance (destroy + create)
	    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !(0, _deepEqual.default)(this.props.modifiers, prevProps.modifiers, {
	      strict: true
	    })) {
	      // develop only check that modifiers isn't being updated needlessly
	      if (false) {
	        if (this.props.modifiers !== prevProps.modifiers && this.props.modifiers != null && prevProps.modifiers != null && (0, _utils.shallowEqual)(this.props.modifiers, prevProps.modifiers)) {
	          console.warn("'modifiers' prop reference updated even though all values appear the same.\nConsider memoizing the 'modifiers' object to avoid needless rendering.");
	        }
	      }
	
	      this.updatePopperInstance();
	    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
	      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
	    } // A placement difference in state means popper determined a new placement
	    // apart from the props value. By the time the popper element is rendered with
	    // the new position Popper has already measured it, if the place change triggers
	    // a size change it will result in a misaligned popper. So we schedule an update to be sure.
	
	
	    if (prevState.placement !== this.state.placement) {
	      this.scheduleUpdate();
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	    this.destroyPopperInstance();
	  };
	
	  _proto.render = function render() {
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.setPopperNode,
	      style: this.getPopperStyle(),
	      placement: this.getPopperPlacement(),
	      outOfBoundaries: this.getOutOfBoundariesState(),
	      scheduleUpdate: this.scheduleUpdate,
	      arrowProps: {
	        ref: this.setArrowNode,
	        style: this.getArrowStyle()
	      }
	    });
	  };
	
	  return InnerPopper;
	}(React.Component);
	
	exports.InnerPopper = InnerPopper;
	(0, _defineProperty2.default)(InnerPopper, "defaultProps", {
	  placement: 'bottom',
	  eventsEnabled: true,
	  referenceElement: undefined,
	  positionFixed: false
	});
	var placements = _popper.default.placements;
	exports.placements = placements;
	
	function Popper(_ref) {
	  var referenceElement = _ref.referenceElement,
	      props = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["referenceElement"]);
	  return React.createElement(_Manager.ManagerReferenceNodeContext.Consumer, null, function (referenceNode) {
	    return React.createElement(InnerPopper, (0, _extends2.default)({
	      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
	    }, props));
	  });
	}

/***/ }),
/* 1683 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = Reference;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(219));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(278));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(1685));
	
	var _Manager = __webpack_require__(395);
	
	var _utils = __webpack_require__(760);
	
	var InnerReference =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inheritsLoose2.default)(InnerReference, _React$Component);
	
	  function InnerReference() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refHandler", function (node) {
	      (0, _utils.setRef)(_this.props.innerRef, node);
	      (0, _utils.safeInvoke)(_this.props.setReferenceNode, node);
	    });
	    return _this;
	  }
	
	  var _proto = InnerReference.prototype;
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    (0, _utils.setRef)(this.props.innerRef, null);
	  };
	
	  _proto.render = function render() {
	    (0, _warning.default)(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
	    return (0, _utils.unwrapArray)(this.props.children)({
	      ref: this.refHandler
	    });
	  };
	
	  return InnerReference;
	}(React.Component);
	
	function Reference(props) {
	  return React.createElement(_Manager.ManagerReferenceNodeSetterContext.Consumer, null, function (setReferenceNode) {
	    return React.createElement(InnerReference, (0, _extends2.default)({
	      setReferenceNode: setReferenceNode
	    }, props));
	  });
	}

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "placements", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.placements;
	  }
	});
	Object.defineProperty(exports, "Manager", {
	  enumerable: true,
	  get: function get() {
	    return _Manager.default;
	  }
	});
	Object.defineProperty(exports, "Reference", {
	  enumerable: true,
	  get: function get() {
	    return _Reference.default;
	  }
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(1682));
	
	var _Manager = _interopRequireDefault(__webpack_require__(395));
	
	var _Reference = _interopRequireDefault(__webpack_require__(1683));

/***/ }),
/* 1685 */
1298,
/* 1686 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _Context = __webpack_require__(139);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(396));
	
	function Provider(_ref) {
	  var store = _ref.store,
	      context = _ref.context,
	      children = _ref.children;
	  var contextValue = (0, _react.useMemo)(function () {
	    var subscription = new _Subscription["default"](store);
	    subscription.onStateChange = subscription.notifyNestedSubs;
	    return {
	      store: store,
	      subscription: subscription
	    };
	  }, [store]);
	  var previousState = (0, _react.useMemo)(function () {
	    return store.getState();
	  }, [store]);
	  (0, _react.useEffect)(function () {
	    var subscription = contextValue.subscription;
	    subscription.trySubscribe();
	
	    if (previousState !== store.getState()) {
	      subscription.notifyNestedSubs();
	    }
	
	    return function () {
	      subscription.tryUnsubscribe();
	      subscription.onStateChange = null;
	    };
	  }, [contextValue, previousState]);
	  var Context = context || _Context.ReactReduxContext;
	  return /*#__PURE__*/_react["default"].createElement(Context.Provider, {
	    value: contextValue
	  }, children);
	}
	
	if (false) {
	  Provider.propTypes = {
	    store: _propTypes["default"].shape({
	      subscribe: _propTypes["default"].func.isRequired,
	      dispatch: _propTypes["default"].func.isRequired,
	      getState: _propTypes["default"].func.isRequired
	    }),
	    context: _propTypes["default"].object,
	    children: _propTypes["default"].any
	  };
	}
	
	var _default = Provider;
	exports["default"] = _default;

/***/ }),
/* 1687 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(761));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(766));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(1688));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(1689));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(1690));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(1691));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced["default"] : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps["default"] : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps["default"] : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps["default"] : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory["default"] : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual["default"] : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual["default"] : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual["default"] : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2["default"])({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = /*#__PURE__*/createConnect();
	
	exports["default"] = _default;

/***/ }),
/* 1688 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports["default"] = void 0;
	
	var _redux = __webpack_require__(178);
	
	var _wrapMapToProps = __webpack_require__(762);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports["default"] = _default;

/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports["default"] = void 0;
	
	var _wrapMapToProps = __webpack_require__(762);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports["default"] = _default;

/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(768));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2["default"])({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject["default"])(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports["default"] = _default;

/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports["default"] = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(1692));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors["default"])(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(769));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) {
	      (0, _warning["default"])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.createDispatchHook = createDispatchHook;
	exports.useDispatch = void 0;
	
	var _Context = __webpack_require__(139);
	
	var _useStore = __webpack_require__(764);
	
	/**
	 * Hook factory, which creates a `useDispatch` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useDispatch` hook bound to the specified context.
	 */
	function createDispatchHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useStore = context === _Context.ReactReduxContext ? _useStore.useStore : (0, _useStore.createStoreHook)(context);
	  return function useDispatch() {
	    var store = useStore();
	    return store.dispatch;
	  };
	}
	/**
	 * A hook to access the redux `dispatch` function.
	 *
	 * @returns {any|function} redux store's `dispatch` function
	 *
	 * @example
	 *
	 * import React, { useCallback } from 'react'
	 * import { useDispatch } from 'react-redux'
	 *
	 * export const CounterComponent = ({ value }) => {
	 *   const dispatch = useDispatch()
	 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
	 *   return (
	 *     <div>
	 *       <span>{value}</span>
	 *       <button onClick={increaseCounter}>Increase counter</button>
	 *     </div>
	 *   )
	 * }
	 */
	
	
	var useDispatch = /*#__PURE__*/createDispatchHook();
	exports.useDispatch = useDispatch;

/***/ }),
/* 1694 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports.createSelectorHook = createSelectorHook;
	exports.useSelector = void 0;
	
	var _react = __webpack_require__(1);
	
	var _useReduxContext2 = __webpack_require__(763);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(396));
	
	var _useIsomorphicLayoutEffect = __webpack_require__(767);
	
	var _Context = __webpack_require__(139);
	
	var refEquality = function refEquality(a, b) {
	  return a === b;
	};
	
	function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
	  var _useReducer = (0, _react.useReducer)(function (s) {
	    return s + 1;
	  }, 0),
	      forceRender = _useReducer[1];
	
	  var subscription = (0, _react.useMemo)(function () {
	    return new _Subscription["default"](store, contextSub);
	  }, [store, contextSub]);
	  var latestSubscriptionCallbackError = (0, _react.useRef)();
	  var latestSelector = (0, _react.useRef)();
	  var latestStoreState = (0, _react.useRef)();
	  var latestSelectedState = (0, _react.useRef)();
	  var storeState = store.getState();
	  var selectedState;
	
	  try {
	    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
	      selectedState = selector(storeState);
	    } else {
	      selectedState = latestSelectedState.current;
	    }
	  } catch (err) {
	    if (latestSubscriptionCallbackError.current) {
	      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
	    }
	
	    throw err;
	  }
	
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    latestSelector.current = selector;
	    latestStoreState.current = storeState;
	    latestSelectedState.current = selectedState;
	    latestSubscriptionCallbackError.current = undefined;
	  });
	  (0, _useIsomorphicLayoutEffect.useIsomorphicLayoutEffect)(function () {
	    function checkForUpdates() {
	      try {
	        var newSelectedState = latestSelector.current(store.getState());
	
	        if (equalityFn(newSelectedState, latestSelectedState.current)) {
	          return;
	        }
	
	        latestSelectedState.current = newSelectedState;
	      } catch (err) {
	        // we ignore all errors here, since when the component
	        // is re-rendered, the selectors are called again, and
	        // will throw again, if neither props nor store state
	        // changed
	        latestSubscriptionCallbackError.current = err;
	      }
	
	      forceRender();
	    }
	
	    subscription.onStateChange = checkForUpdates;
	    subscription.trySubscribe();
	    checkForUpdates();
	    return function () {
	      return subscription.tryUnsubscribe();
	    };
	  }, [store, subscription]);
	  return selectedState;
	}
	/**
	 * Hook factory, which creates a `useSelector` hook bound to a given context.
	 *
	 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
	 * @returns {Function} A `useSelector` hook bound to the specified context.
	 */
	
	
	function createSelectorHook(context) {
	  if (context === void 0) {
	    context = _Context.ReactReduxContext;
	  }
	
	  var useReduxContext = context === _Context.ReactReduxContext ? _useReduxContext2.useReduxContext : function () {
	    return (0, _react.useContext)(context);
	  };
	  return function useSelector(selector, equalityFn) {
	    if (equalityFn === void 0) {
	      equalityFn = refEquality;
	    }
	
	    if (false) {
	      throw new Error("You must pass a selector to useSelector");
	    }
	
	    var _useReduxContext = useReduxContext(),
	        store = _useReduxContext.store,
	        contextSub = _useReduxContext.subscription;
	
	    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
	    (0, _react.useDebugValue)(selectedState);
	    return selectedState;
	  };
	}
	/**
	 * A hook to access the redux store's state. This hook takes a selector function
	 * as an argument. The selector is called with the store state.
	 *
	 * This hook takes an optional equality comparison function as the second parameter
	 * that allows you to customize the way the selected state is compared to determine
	 * whether the component needs to be re-rendered.
	 *
	 * @param {Function} selector the selector function
	 * @param {Function=} equalityFn the function that will be used to determine equality
	 *
	 * @returns {any} the selected state
	 *
	 * @example
	 *
	 * import React from 'react'
	 * import { useSelector } from 'react-redux'
	 *
	 * export const CounterComponent = () => {
	 *   const counter = useSelector(state => state.counter)
	 *   return <div>{counter}</div>
	 * }
	 */
	
	
	var useSelector = /*#__PURE__*/createSelectorHook();
	exports.useSelector = useSelector;

/***/ }),
/* 1695 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ }),
/* 1696 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.unstable_batchedUpdates = void 0;
	
	var _reactDom = __webpack_require__(30);
	
	exports.unstable_batchedUpdates = _reactDom.unstable_batchedUpdates;

/***/ }),
/* 1697 */
[1911, 770],
/* 1698 */
/***/ (function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(771);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ }),
/* 1700 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(772);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ }),
/* 1701 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(95);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(773);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ }),
/* 1702 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(95);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(775);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ }),
/* 1703 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(95);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(116);
	
	var _InternalPropTypes = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ }),
/* 1704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(95);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(116);
	
	var _InternalPropTypes = __webpack_require__(213);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ }),
/* 1705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(95);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(2);
	
	var _createTransitionManager2 = __webpack_require__(779);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(213);
	
	var _RouterContext = __webpack_require__(400);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(116);
	
	var _RouterUtils = __webpack_require__(776);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ }),
/* 1706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(397);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ }),
/* 1707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(400);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(1327);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(778);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(176);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(397);
	
	var _PromiseUtils = __webpack_require__(774);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(176);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(1328);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(778);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(176);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(246);
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(777);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(779);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(116);
	
	var _RouterUtils = __webpack_require__(776);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ }),
/* 1715 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(397);
	
	var _PromiseUtils = __webpack_require__(774);
	
	var _PatternUtils = __webpack_require__(176);
	
	var _routerWarning = __webpack_require__(177);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ }),
/* 1716 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(32);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(95);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(1330);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(398);
	
	var _PropTypes = __webpack_require__(399);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ }),
/* 1717 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(1);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(1831));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _temp; /**
	                    * @copyright 2015, Andrey Popp <8mayday@gmail.com>
	                    */
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Time = (_temp = _class = function (_React$Component) {
	  _inherits(Time, _React$Component);
	
	  function Time() {
	    _classCallCheck(this, Time);
	
	    return _possibleConstructorReturn(this, (Time.__proto__ || Object.getPrototypeOf(Time)).apply(this, arguments));
	  }
	
	  _createClass(Time, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          value = _props.value,
	          locale = _props.locale,
	          relative = _props.relative,
	          utc = _props.utc,
	          format = _props.format,
	          valueFormat = _props.valueFormat,
	          titleFormat = _props.titleFormat,
	          Component = _props.Component,
	          props = _objectWithoutProperties(_props, ['value', 'locale', 'relative', 'utc', 'format', 'valueFormat', 'titleFormat', 'Component']);
	
	      if (!value) {
	        return _react2.default.createElement(
	          'span',
	          null,
	          'Invalid date'
	        );
	      }
	
	      if (!_moment2.default.isMoment(value)) {
	        value = (0, _moment2.default)(value, valueFormat, true);
	      }
	
	      if (locale) {
	        value = value.locale(locale);
	      }
	
	      if (utc) {
	        value = value.utc();
	      }
	
	      var machineReadable = value.format('YYYY-MM-DDTHH:mm:ssZ');
	
	      if (relative || format) {
	        var humanReadable = relative ? value.fromNow() : value.format(format);
	        return _react2.default.createElement(
	          Component,
	          _extends({
	            title: relative ? value.format(titleFormat) : null
	          }, props, {
	            dateTime: machineReadable }),
	          humanReadable
	        );
	      } else {
	        return _react2.default.createElement(
	          'time',
	          props,
	          machineReadable
	        );
	      }
	    }
	  }]);
	
	  return Time;
	}(_react2.default.Component), _class.propTypes = {
	
	  /**
	   * Value.
	   */
	  value: _propTypes2.default.oneOfType([_propTypes2.default.instanceOf(_moment2.default.fn.constructor), _propTypes2.default.instanceOf(Date), _propTypes2.default.number, _propTypes2.default.string]).isRequired,
	
	  /**
	   * If component should output the relative time difference between now and
	   * passed value.
	   */
	  relative: _propTypes2.default.bool,
	
	  /**
	   * If set to true will use the utc mode from moment and display all dates
	   * in utc disregarding the users locale
	   */
	  utc: _propTypes2.default.bool,
	
	  /**
	   * Datetime format which is used to output date to DOM.
	   */
	  format: _propTypes2.default.string,
	
	  /**
	   * Datetime format which is used to parse value if it's being a string.
	   */
	  valueFormat: _propTypes2.default.string,
	
	  /**
	   * Datetime format which is used to set title attribute on relative or
	   * formatted dates.
	   */
	  titleFormat: _propTypes2.default.string,
	
	  /**
	   * Locale.
	   */
	  locale: _propTypes2.default.string,
	
	  /**
	   * Component to use.
	   */
	  Component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	}, _class.defaultProps = {
	  titleFormat: 'YYYY-MM-DD HH:mm',
	  Component: 'time'
	}, _temp);
	exports.default = Time;


/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Time = __webpack_require__(1718);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Time).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

	/** @license React v16.12.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var h=__webpack_require__(210),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
	var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
	function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
	function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
	H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
	function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
	0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
	function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
	var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
	if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
	__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Notification = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(402);
	
	var _notifications = __webpack_require__(781);
	
	var _constants = __webpack_require__(215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Create a timer
	 * @param {Number} dismissAfter
	 * @param {Function} callback
	 * @returns {Function|null} a Timer
	 */
	function createTimer(dismissAfter, callback) {
	  if (dismissAfter > 0) {
	    return new _helpers.Timer(dismissAfter, callback);
	  }
	  return null;
	}
	
	var Notification = exports.Notification = function (_Component) {
	  _inherits(Notification, _Component);
	
	  /**
	   * Init timer
	   * @param {Object} props
	   * @returns {void}
	   */
	  function Notification(props) {
	    _classCallCheck(this, Notification);
	
	    var dismissAfter = props.notification.dismissAfter;
	
	    var _this = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this, props));
	
	    _this._remove = function () {
	      var _this$props = _this.props,
	          removeNotification = _this$props.removeNotification,
	          id = _this$props.notification.id;
	
	      removeNotification(id);
	    };
	
	    _this._pauseTimer = function () {
	      var timer = _this.state.timer;
	
	      timer.pause();
	    };
	
	    _this._resumeTimer = function () {
	      var timer = _this.state.timer;
	
	      timer.resume();
	    };
	
	    _this._setHTML = function (content) {
	      return {
	        __html: content
	      };
	    };
	
	    _this._renderButtons = function () {
	      var _this$props2 = _this.props,
	          className = _this$props2.className,
	          buttons = _this$props2.notification.buttons;
	
	
	      return buttons.map(function (_ref) {
	        var name = _ref.name,
	            onClick = _ref.onClick,
	            primary = _ref.primary;
	        return _react2.default.createElement(
	          'button',
	          { key: name, className: className.button, onClick: onClick },
	          _react2.default.createElement(
	            'span',
	            { className: className.buttonText },
	            primary ? _react2.default.createElement(
	              'b',
	              null,
	              name
	            ) : name
	          )
	        );
	      });
	    };
	
	    _this.state = {
	      timer: createTimer(dismissAfter, _this._remove)
	    };
	    return _this;
	  }
	
	  /**
	   * Run `onAdd` callback function when component is mounted
	   * @returns {void}
	   */
	
	
	  _createClass(Notification, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var onAdd = this.props.notification.onAdd;
	
	      if (typeof onAdd === 'function') {
	        onAdd();
	      }
	    }
	
	    /**
	     * Run `onRemove` callback function when component will unmount
	     * @returns {void}
	     */
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var onRemove = this.props.notification.onRemove;
	
	      if (typeof onRemove === 'function') {
	        onRemove();
	      }
	    }
	
	    /**
	     * Update timer
	     * @param {Object} nextProps
	     * @returns {void}
	     */
	
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var dismissAfter = nextProps.notification.dismissAfter;
	
	      this.setState({
	        timer: createTimer(dismissAfter, this._remove)
	      });
	    }
	
	    /**
	     * Remove the notification
	     * @private
	     * @returns {void}
	     */
	
	
	    /**
	     * Pauses the timer
	     * @returns {void}
	     * @private
	     */
	
	
	    /**
	     * Resumes the timer
	     * @returns {void}
	     * @private
	     */
	
	
	    /**
	     * Wrap content in an object ready for HTML
	     * @param {String} content a text
	     * @returns {Object}
	     * @private
	     */
	
	
	    /**
	     * Render button(s)
	     * @returns {*}
	     */
	
	  }, {
	    key: 'render',
	
	
	    /**
	     * Render
	     * @returns {XML}
	     */
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          _props$notification = _props.notification,
	          title = _props$notification.title,
	          message = _props$notification.message,
	          status = _props$notification.status,
	          dismissible = _props$notification.dismissible,
	          closeButton = _props$notification.closeButton,
	          buttons = _props$notification.buttons,
	          image = _props$notification.image,
	          allowHTML = _props$notification.allowHTML;
	      var timer = this.state.timer;
	
	      var isDismissible = dismissible && buttons.length === 0;
	      var notificationClass = [className.main, className.status(status), className.buttons(buttons.length), isDismissible && !closeButton ? className.dismissible : null].join(' ');
	
	      if (timer) {
	        this._resumeTimer();
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className.wrapper,
	          onClick: isDismissible && !closeButton ? this._remove : null,
	          onMouseEnter: timer ? this._pauseTimer : null,
	          onMouseLeave: timer ? this._resumeTimer : null
	        },
	        _react2.default.createElement(
	          'div',
	          { className: notificationClass },
	          image ? _react2.default.createElement(
	            'div',
	            { className: className.imageContainer },
	            _react2.default.createElement('span', { className: className.image, style: { backgroundImage: 'url(' + image + ')' } })
	          ) : _react2.default.createElement('span', { className: className.icon }),
	          _react2.default.createElement(
	            'div',
	            { className: className.meta },
	            title ? allowHTML ? _react2.default.createElement('h4', { className: className.title, dangerouslySetInnerHTML: this._setHTML(title) }) : _react2.default.createElement(
	              'h4',
	              { className: className.title },
	              title
	            ) : null,
	            message ? allowHTML ? _react2.default.createElement('p', { className: className.message, dangerouslySetInnerHTML: this._setHTML(message) }) : _react2.default.createElement(
	              'p',
	              { className: className.message },
	              message
	            ) : null
	          ),
	          isDismissible && closeButton ? _react2.default.createElement(
	            'div',
	            { className: className.closeButtonContainer },
	            _react2.default.createElement('span', { className: className.closeButton, onClick: this._remove })
	          ) : null,
	          buttons.length ? _react2.default.createElement(
	            'div',
	            { className: className.buttons(), onClick: this._remove },
	            this._renderButtons()
	          ) : null
	        )
	      );
	    }
	  }]);
	
	  return Notification;
	}(_react.Component);
	
	Notification.propTypes = {
	  className: _propTypes2.default.shape({
	    main: _propTypes2.default.string.isRequired,
	    wrapper: _propTypes2.default.string.isRequired,
	    meta: _propTypes2.default.string.isRequired,
	    title: _propTypes2.default.string.isRequired,
	    message: _propTypes2.default.string.isRequired,
	    imageContainer: _propTypes2.default.string.isRequired,
	    image: _propTypes2.default.string.isRequired,
	    icon: _propTypes2.default.string.isRequired,
	    status: _propTypes2.default.func.isRequired,
	    dismissible: _propTypes2.default.string.isRequired,
	    closeButtonContainer: _propTypes2.default.string.isRequired,
	    closeButton: _propTypes2.default.string.isRequired,
	    buttons: _propTypes2.default.func.isRequired,
	    button: _propTypes2.default.string.isRequired,
	    buttonText: _propTypes2.default.string.isRequired
	  }).isRequired,
	  notification: _propTypes2.default.shape({
	    id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
	    title: _propTypes2.default.string,
	    message: _propTypes2.default.string,
	    image: _propTypes2.default.string,
	    status: _propTypes2.default.string.isRequired,
	    position: _propTypes2.default.oneOf((0, _helpers.mapObjectValues)(_constants.POSITIONS)),
	    dismissAfter: _propTypes2.default.number.isRequired,
	    dismissible: _propTypes2.default.bool.isRequired,
	    onAdd: _propTypes2.default.func,
	    onRemove: _propTypes2.default.func,
	    closeButton: _propTypes2.default.bool.isRequired,
	    buttons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      name: _propTypes2.default.string.isRequired,
	      onClick: _propTypes2.default.func
	    })).isRequired,
	    allowHTML: _propTypes2.default.bool.isRequired
	  }).isRequired,
	  removeNotification: _propTypes2.default.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(null, { removeNotification: _notifications.removeNotification })(Notification);

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NotificationsContainer = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TransitionGroup = __webpack_require__(1727);
	
	var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);
	
	var _CSSTransition = __webpack_require__(1725);
	
	var _CSSTransition2 = _interopRequireDefault(_CSSTransition);
	
	var _Notification = __webpack_require__(1722);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotificationsContainer = exports.NotificationsContainer = function (_Component) {
	  _inherits(NotificationsContainer, _Component);
	
	  function NotificationsContainer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NotificationsContainer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationsContainer.__proto__ || Object.getPrototypeOf(NotificationsContainer)).call.apply(_ref, [this].concat(args))), _this), _this._renderNotifications = function () {
	      var position = _this.props.position;
	      var className = _this.props.theme.notification.className;
	      var _this$props$theme$not = _this.props.theme.notificationsContainer.transition,
	          name = _this$props$theme$not.name,
	          enterTimeout = _this$props$theme$not.enterTimeout,
	          leaveTimeout = _this$props$theme$not.leaveTimeout;
	      var notifications = _this.props.notifications;
	
	      // when notifications are displayed at the bottom,
	      // we display notifications from bottom to top
	
	      if (position.startsWith('b')) {
	        notifications = notifications.reverse();
	      }
	
	      return notifications.map(function (notification) {
	        return _react2.default.createElement(
	          _CSSTransition2.default,
	          {
	            key: notification.id,
	            classNames: {
	              enter: name.enter,
	              exit: name.leave
	            },
	            timeout: {
	              enter: enterTimeout,
	              exit: leaveTimeout
	            }
	          },
	          _react2.default.createElement(_Notification2.default, {
	            key: notification.id,
	            notification: notification,
	            className: className
	          })
	        );
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Render notifications
	   * @private
	   * @returns {XML}
	   */
	
	
	  _createClass(NotificationsContainer, [{
	    key: 'render',
	
	
	    /**
	     * Render
	     * @returns {XML}
	     */
	    value: function render() {
	      var className = this.props.theme.notificationsContainer.className;
	      var position = this.props.position;
	
	
	      return _react2.default.createElement(
	        'div',
	        { className: className.main + ' ' + className.position(position) },
	        _react2.default.createElement(
	          _TransitionGroup2.default,
	          null,
	          this._renderNotifications()
	        )
	      );
	    }
	  }]);
	
	  return NotificationsContainer;
	}(_react.Component);
	
	NotificationsContainer.propTypes = {
	  notifications: _propTypes2.default.array.isRequired,
	  position: _propTypes2.default.string.isRequired,
	  theme: _propTypes2.default.shape({
	    notificationsContainer: _propTypes2.default.shape({
	      className: _propTypes2.default.shape({
	        main: _propTypes2.default.string.isRequired,
	        position: _propTypes2.default.func.isRequired
	      }).isRequired,
	      transition: _propTypes2.default.shape({
	        name: _propTypes2.default.object.isRequired,
	        enterTimeout: _propTypes2.default.number.isRequired,
	        leaveTimeout: _propTypes2.default.number.isRequired
	      }).isRequired
	    }).isRequired,
	    notification: _propTypes2.default.shape({
	      className: _propTypes2.default.object.isRequired
	    }).isRequired
	  }).isRequired
	};
	NotificationsContainer.defaultProps = {
	  notifications: []
	};
	exports.default = NotificationsContainer;

/***/ }),
/* 1724 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NotificationsSystem = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactRedux = __webpack_require__(12);
	
	var _helpers = __webpack_require__(402);
	
	var _NotificationsContainer = __webpack_require__(1723);
	
	var _NotificationsContainer2 = _interopRequireDefault(_NotificationsContainer);
	
	var _constants = __webpack_require__(215);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NotificationsSystem = exports.NotificationsSystem = function (_Component) {
	  _inherits(NotificationsSystem, _Component);
	
	  function NotificationsSystem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NotificationsSystem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotificationsSystem.__proto__ || Object.getPrototypeOf(NotificationsSystem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      windowWidth: window.innerWidth
	    }, _this._updateWindowWidth = function () {
	      _this.setState({ windowWidth: window.innerWidth });
	    }, _this._renderNotificationsContainers = function () {
	      var _this$props = _this.props,
	          theme = _this$props.theme,
	          filter = _this$props.filter;
	      var windowWidth = _this.state.windowWidth;
	
	      var positions = (0, _helpers.mapObjectValues)(_constants.POSITIONS);
	      var containers = [];
	      var notifications = _this.props.notifications;
	
	      if (typeof filter === 'function') {
	        notifications = notifications.filter(filter);
	      }
	
	      // render all notifications in the same container at the top for small screens
	      if (windowWidth < theme.smallScreenMin) {
	        return _react2.default.createElement(_NotificationsContainer2.default, {
	          key: theme.smallScreenPosition || _constants.POSITIONS.top,
	          position: theme.smallScreenPosition || _constants.POSITIONS.top,
	          theme: theme,
	          notifications: notifications
	        });
	      }
	
	      containers.push(positions.map(function (position) {
	        var notifs = notifications.filter(function (notif) {
	          return position === notif.position;
	        });
	
	        return _react2.default.createElement(_NotificationsContainer2.default, {
	          key: position,
	          position: position,
	          theme: theme,
	          notifications: notifs
	        });
	      }));
	      return containers;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(NotificationsSystem, [{
	    key: 'componentDidMount',
	
	
	    /**
	     * Add resize listener to update window width when the window is resized
	     * @returns {void}
	     */
	    value: function componentDidMount() {
	      window.addEventListener('resize', this._updateWindowWidth);
	    }
	
	    /**
	     * Remove resize listener
	     * @returns {void}
	     */
	
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      window.removeEventListener('resize', this._updateWindowWidth);
	    }
	
	    /**
	     * Update window width
	     * @returns {void}
	     * @private
	     */
	
	
	    /**
	     * Render notifications containers
	     * @returns {XML}
	     * @private
	     */
	
	  }, {
	    key: 'render',
	
	
	    /**
	     * Render
	     * @returns {XML}
	     */
	    value: function render() {
	      var className = this.props.theme.notificationsSystem.className;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className },
	        this._renderNotificationsContainers()
	      );
	    }
	  }]);
	
	  return NotificationsSystem;
	}(_react.Component);
	
	/**
	 * Map state to props
	 * @param {Object} state
	 * @returns {{notifications: {Array}}}
	 */
	
	
	NotificationsSystem.propTypes = {
	  notifications: _propTypes2.default.array.isRequired,
	  filter: _propTypes2.default.func,
	  theme: _propTypes2.default.shape({
	    smallScreenMin: _propTypes2.default.number.isRequired,
	    smallScreenPosition: _propTypes2.default.oneOf([_constants.POSITIONS.top, _constants.POSITIONS.bottom]),
	    notificationsSystem: _propTypes2.default.shape({
	      className: _propTypes2.default.string
	    })
	  }).isRequired
	};
	NotificationsSystem.defaultProps = {
	  notifications: []
	};
	function mapStateToProps(state) {
	  return {
	    notifications: state.notifications
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(NotificationsSystem);

/***/ }),
/* 1725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _addClass = _interopRequireDefault(__webpack_require__(1310));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(1312));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _Transition = _interopRequireDefault(__webpack_require__(1726));
	
	var _PropTypes = __webpack_require__(782);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity: 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	
	    _this.onEnter = function (node, appearing) {
	      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          className = _this$getClassNames.className;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, className);
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
	          activeClassName = _this$getClassNames2.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var appearClassName = _this.getClassNames('appear').doneClassName;
	
	      var enterClassName = _this.getClassNames('enter').doneClassName;
	
	      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
	
	      _this.removeClasses(node, appearing ? 'appear' : 'enter');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      var _this$getClassNames3 = _this.getClassNames('exit'),
	          className = _this$getClassNames3.className;
	
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      addClass(node, className);
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      var _this$getClassNames4 = _this.getClassNames('exit'),
	          activeClassName = _this$getClassNames4.activeClassName;
	
	      _this.reflowAndAddClass(node, activeClassName);
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      var _this$getClassNames5 = _this.getClassNames('exit'),
	          doneClassName = _this$getClassNames5.doneClassName;
	
	      _this.removeClasses(node, 'exit');
	
	      addClass(node, doneClassName);
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
	      var className = isStringClassNames ? prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
	      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
	      return {
	        className: className,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$getClassNames6 = this.getClassNames(type),
	        className = _this$getClassNames6.className,
	        activeClassName = _this$getClassNames6.activeClassName,
	        doneClassName = _this$getClassNames6.doneClassName;
	
	    className && removeClass(node, className);
	    activeClassName && removeClass(node, activeClassName);
	    doneClassName && removeClass(node, doneClassName);
	  };
	
	  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
	    // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	    if (className) {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	      /* eslint-enable no-unused-expressions */
	
	      addClass(node, className);
	    }
	  };
	
	  _proto.render = function render() {
	    var props = _extends({}, this.props);
	
	    delete props.classNames;
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it enters, exits or
	   * has finished the transition. A single name can be provided and it will be
	   * suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
	   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
	   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: PropTypes.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 1726 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(30));
	
	var _reactLifecyclesCompat = __webpack_require__(389);
	
	var _PropTypes = __webpack_require__(782);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 0 },
	 *   entered:  { opacity: 1 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  var _proto = Transition.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: null // allows for nested Transitions
	
	    };
	  };
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      return children(status, childProps);
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return _react.default.cloneElement(child, childProps);
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextTypes = {
	  transitionGroup: PropTypes.object
	};
	Transition.childContextTypes = {
	  transitionGroup: function transitionGroup() {}
	};
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: PropTypes.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: PropTypes.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: PropTypes.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
	   * If you want to transition on the first mount set `appear` to `true`, and the
	   * component will transition in as soon as the `<Transition>` mounts.
	   *
	   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
	   */
	  appear: PropTypes.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: PropTypes.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: PropTypes.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: PropTypes.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: PropTypes.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: PropTypes.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: PropTypes.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: PropTypes.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: PropTypes.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: PropTypes.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);
	
	exports.default = _default;

/***/ }),
/* 1727 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(389);
	
	var _ChildMapping = __webpack_require__(1728);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.getChildContext = function getChildContext() {
	    return {
	      transitionGroup: {
	        isMounting: !this.appeared
	      }
	    };
	  };
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	    this.mounted = true;
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return children;
	    }
	
	    return _react.default.createElement(Component, props, children);
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.childContextTypes = {
	  transitionGroup: _propTypes.default.object.isRequired
	};
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ }),
/* 1728 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ }),
/* 1729 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ }),
/* 1732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(783);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(784);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _react.createFactory)(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      _inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        _classCallCheck(this, ShouldUpdate);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	exports.default = shouldUpdate;

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function () {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var initialState = typeof args[args.length - 1] !== 'function' && args.pop();
	  var reducers = args;
	
	  if (typeof initialState === 'undefined') {
	    throw new TypeError('The initial state may not be undefined. If you do not want to set a value for this reducer, you can use null instead of undefined.');
	  }
	
	  return function (prevState, value) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	      args[_key2 - 2] = arguments[_key2];
	    }
	
	    var prevStateIsUndefined = typeof prevState === 'undefined';
	    var valueIsUndefined = typeof value === 'undefined';
	
	    if (prevStateIsUndefined && valueIsUndefined && initialState) {
	      return initialState;
	    }
	
	    return reducers.reduce(function (newState, reducer) {
	      return reducer.apply(undefined, [newState, value].concat(args));
	    }, prevStateIsUndefined && !valueIsUndefined && initialState ? initialState : prevState);
	  };
	};
	
	module.exports = exports['default'];

/***/ }),
/* 1734 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = combineActions;
	
	var _invariant = _interopRequireDefault(__webpack_require__(32));
	
	var _isFunction = _interopRequireDefault(__webpack_require__(276));
	
	var _isSymbol = _interopRequireDefault(__webpack_require__(1745));
	
	var _isEmpty = _interopRequireDefault(__webpack_require__(789));
	
	var _toString = _interopRequireDefault(__webpack_require__(792));
	
	var _isString = _interopRequireDefault(__webpack_require__(791));
	
	var _constants = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidActionType(type) {
	  return (0, _isString.default)(type) || (0, _isFunction.default)(type) || (0, _isSymbol.default)(type);
	}
	
	function isValidActionTypes(types) {
	  if ((0, _isEmpty.default)(types)) {
	    return false;
	  }
	
	  return types.every(isValidActionType);
	}
	
	function combineActions() {
	  for (var _len = arguments.length, actionsTypes = new Array(_len), _key = 0; _key < _len; _key++) {
	    actionsTypes[_key] = arguments[_key];
	  }
	
	  (0, _invariant.default)(isValidActionTypes(actionsTypes), 'Expected action types to be strings, symbols, or action creators');
	  var combinedActionType = actionsTypes.map(_toString.default).join(_constants.ACTION_TYPE_DELIMITER);
	  return {
	    toString: function toString() {
	      return combinedActionType;
	    }
	  };
	}

/***/ }),
/* 1735 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = createActions;
	
	var _invariant = _interopRequireDefault(__webpack_require__(32));
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(217));
	
	var _isFunction = _interopRequireDefault(__webpack_require__(276));
	
	var _identity = _interopRequireDefault(__webpack_require__(404));
	
	var _isArray = _interopRequireDefault(__webpack_require__(1743));
	
	var _isString = _interopRequireDefault(__webpack_require__(791));
	
	var _isNil = _interopRequireDefault(__webpack_require__(790));
	
	var _getLastElement = _interopRequireDefault(__webpack_require__(1741));
	
	var _camelCase = _interopRequireDefault(__webpack_require__(786));
	
	var _arrayToObject = _interopRequireDefault(__webpack_require__(1738));
	
	var _flattenActionMap = _interopRequireDefault(__webpack_require__(1739));
	
	var _unflattenActionCreators = _interopRequireDefault(__webpack_require__(1747));
	
	var _createAction = _interopRequireDefault(__webpack_require__(403));
	
	var _constants = __webpack_require__(216);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function createActions(actionMap) {
	  for (var _len = arguments.length, identityActions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    identityActions[_key - 1] = arguments[_key];
	  }
	
	  var options = (0, _isPlainObject.default)((0, _getLastElement.default)(identityActions)) ? identityActions.pop() : {};
	  (0, _invariant.default)(identityActions.every(_isString.default) && ((0, _isString.default)(actionMap) || (0, _isPlainObject.default)(actionMap)), 'Expected optional object followed by string action types');
	
	  if ((0, _isString.default)(actionMap)) {
	    return actionCreatorsFromIdentityActions([actionMap].concat(identityActions), options);
	  }
	
	  return _objectSpread({}, actionCreatorsFromActionMap(actionMap, options), actionCreatorsFromIdentityActions(identityActions, options));
	}
	
	function actionCreatorsFromActionMap(actionMap, options) {
	  var flatActionMap = (0, _flattenActionMap.default)(actionMap, options);
	  var flatActionCreators = actionMapToActionCreators(flatActionMap);
	  return (0, _unflattenActionCreators.default)(flatActionCreators, options);
	}
	
	function actionMapToActionCreators(actionMap, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      prefix = _ref.prefix,
	      _ref$namespace = _ref.namespace,
	      namespace = _ref$namespace === void 0 ? _constants.DEFAULT_NAMESPACE : _ref$namespace;
	
	  function isValidActionMapValue(actionMapValue) {
	    if ((0, _isFunction.default)(actionMapValue) || (0, _isNil.default)(actionMapValue)) {
	      return true;
	    }
	
	    if ((0, _isArray.default)(actionMapValue)) {
	      var _actionMapValue$ = actionMapValue[0],
	          payload = _actionMapValue$ === void 0 ? _identity.default : _actionMapValue$,
	          meta = actionMapValue[1];
	      return (0, _isFunction.default)(payload) && (0, _isFunction.default)(meta);
	    }
	
	    return false;
	  }
	
	  return (0, _arrayToObject.default)(Object.keys(actionMap), function (partialActionCreators, type) {
	    var _objectSpread2;
	
	    var actionMapValue = actionMap[type];
	    (0, _invariant.default)(isValidActionMapValue(actionMapValue), 'Expected function, undefined, null, or array with payload and meta ' + ("functions for " + type));
	    var prefixedType = prefix ? "" + prefix + namespace + type : type;
	    var actionCreator = (0, _isArray.default)(actionMapValue) ? _createAction.default.apply(void 0, [prefixedType].concat(actionMapValue)) : (0, _createAction.default)(prefixedType, actionMapValue);
	    return _objectSpread({}, partialActionCreators, (_objectSpread2 = {}, _objectSpread2[type] = actionCreator, _objectSpread2));
	  });
	}
	
	function actionCreatorsFromIdentityActions(identityActions, options) {
	  var actionMap = (0, _arrayToObject.default)(identityActions, function (partialActionMap, type) {
	    var _objectSpread3;
	
	    return _objectSpread({}, partialActionMap, (_objectSpread3 = {}, _objectSpread3[type] = _identity.default, _objectSpread3));
	  });
	  var actionCreators = actionMapToActionCreators(actionMap, options);
	  return (0, _arrayToObject.default)(Object.keys(actionCreators), function (partialActionCreators, type) {
	    var _objectSpread4;
	
	    return _objectSpread({}, partialActionCreators, (_objectSpread4 = {}, _objectSpread4[(0, _camelCase.default)(type)] = actionCreators[type], _objectSpread4));
	  });
	}

/***/ }),
/* 1736 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _justCurryIt = _interopRequireDefault(__webpack_require__(1380));
	
	var _createAction = _interopRequireDefault(__webpack_require__(403));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = function _default(type, payloadCreator) {
	  return (0, _justCurryIt.default)((0, _createAction.default)(type, payloadCreator), payloadCreator.length);
	};
	
	exports.default = _default;

/***/ }),
/* 1737 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = handleActions;
	
	var _reduceReducers = _interopRequireDefault(__webpack_require__(1733));
	
	var _invariant = _interopRequireDefault(__webpack_require__(32));
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(217));
	
	var _isMap = _interopRequireDefault(__webpack_require__(277));
	
	var _ownKeys = _interopRequireDefault(__webpack_require__(405));
	
	var _flattenReducerMap = _interopRequireDefault(__webpack_require__(1740));
	
	var _handleAction = _interopRequireDefault(__webpack_require__(785));
	
	var _get = _interopRequireDefault(__webpack_require__(788));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleActions(handlers, defaultState, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  (0, _invariant.default)((0, _isPlainObject.default)(handlers) || (0, _isMap.default)(handlers), 'Expected handlers to be a plain object.');
	  var flattenedReducerMap = (0, _flattenReducerMap.default)(handlers, options);
	  var reducers = (0, _ownKeys.default)(flattenedReducerMap).map(function (type) {
	    return (0, _handleAction.default)(type, (0, _get.default)(type, flattenedReducerMap), defaultState);
	  });
	
	  var reducer = _reduceReducers.default.apply(void 0, reducers.concat([defaultState]));
	
	  return function (state, action) {
	    if (state === void 0) {
	      state = defaultState;
	    }
	
	    return reducer(state, action);
	  };
	}

/***/ }),
/* 1738 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(array, callback) {
	  return array.reduce(function (partialObject, element) {
	    return callback(partialObject, element);
	  }, {});
	};
	
	exports.default = _default;

/***/ }),
/* 1739 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(217));
	
	var _flattenWhenNode = _interopRequireDefault(__webpack_require__(787));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _flattenWhenNode.default)(_isPlainObject.default);
	
	exports.default = _default;

/***/ }),
/* 1740 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(217));
	
	var _isMap = _interopRequireDefault(__webpack_require__(277));
	
	var _hasGeneratorInterface = _interopRequireDefault(__webpack_require__(1742));
	
	var _flattenWhenNode = _interopRequireDefault(__webpack_require__(787));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = (0, _flattenWhenNode.default)(function (node) {
	  return ((0, _isPlainObject.default)(node) || (0, _isMap.default)(node)) && !(0, _hasGeneratorInterface.default)(node);
	});
	
	exports.default = _default;

/***/ }),
/* 1741 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(array) {
	  return array[array.length - 1];
	};
	
	exports.default = _default;

/***/ }),
/* 1742 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasGeneratorInterface;
	
	var _ownKeys = _interopRequireDefault(__webpack_require__(405));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasGeneratorInterface(handler) {
	  var keys = (0, _ownKeys.default)(handler);
	  var hasOnlyInterfaceNames = keys.every(function (ownKey) {
	    return ownKey === 'next' || ownKey === 'throw';
	  });
	  return keys.length && keys.length <= 2 && hasOnlyInterfaceNames;
	}

/***/ }),
/* 1743 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return Array.isArray(value);
	};
	
	exports.default = _default;

/***/ }),
/* 1744 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return value === null;
	};
	
	exports.default = _default;

/***/ }),
/* 1745 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return typeof value === 'symbol' || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Symbol]';
	};
	
	exports.default = _default;

/***/ }),
/* 1746 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _default = function _default(value) {
	  return value === undefined;
	};
	
	exports.default = _default;

/***/ }),
/* 1747 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = unflattenActionCreators;
	
	var _constants = __webpack_require__(216);
	
	var _isEmpty = _interopRequireDefault(__webpack_require__(789));
	
	var _camelCase = _interopRequireDefault(__webpack_require__(786));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function unflattenActionCreators(flatActionCreators, _temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$namespace = _ref.namespace,
	      namespace = _ref$namespace === void 0 ? _constants.DEFAULT_NAMESPACE : _ref$namespace,
	      prefix = _ref.prefix;
	
	  function unflatten(flatActionType, partialNestedActionCreators, partialFlatActionTypePath) {
	    var nextNamespace = (0, _camelCase.default)(partialFlatActionTypePath.shift());
	
	    if ((0, _isEmpty.default)(partialFlatActionTypePath)) {
	      partialNestedActionCreators[nextNamespace] = flatActionCreators[flatActionType];
	    } else {
	      if (!partialNestedActionCreators[nextNamespace]) {
	        partialNestedActionCreators[nextNamespace] = {};
	      }
	
	      unflatten(flatActionType, partialNestedActionCreators[nextNamespace], partialFlatActionTypePath);
	    }
	  }
	
	  var nestedActionCreators = {};
	  Object.getOwnPropertyNames(flatActionCreators).forEach(function (type) {
	    var unprefixedType = prefix ? type.replace("" + prefix + namespace, '') : type;
	    return unflatten(type, nestedActionCreators, unprefixedType.split(namespace));
	  });
	  return nestedActionCreators;
	}

/***/ }),
/* 1748 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.batchedSubscribe = batchedSubscribe;
	
	function batchedSubscribe(batch) {
	  if (typeof batch !== 'function') {
	    throw new Error('Expected batch to be a function.');
	  }
	
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  function notifyListeners() {
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	  }
	
	  function notifyListenersBatched() {
	    batch(notifyListeners);
	  }
	
	  return function (next) {
	    return function () {
	      var store = next.apply(undefined, arguments);
	      var subscribeImmediate = store.subscribe;
	
	      function dispatch() {
	        var res = store.dispatch.apply(store, arguments);
	        notifyListenersBatched();
	        return res;
	      }
	
	      return _extends({}, store, {
	        dispatch: dispatch,
	        subscribe: subscribe,
	        subscribeImmediate: subscribeImmediate
	      });
	    };
	  };
	}

/***/ }),
/* 1749 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactRedux = __webpack_require__(12);
	
	var _createFieldProps2 = _interopRequireDefault(__webpack_require__(795));
	
	var _onChangeValue = _interopRequireDefault(__webpack_require__(800));
	
	var _eventConsts = __webpack_require__(1817);
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _isReactNative = _interopRequireDefault(__webpack_require__(802));
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(141));
	
	var _isEvent = _interopRequireDefault(__webpack_require__(407));
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	var isObject = function isObject(entity) {
	  return entity && typeof entity === 'object';
	};
	
	var isFunction = function isFunction(entity) {
	  return entity && typeof entity === 'function';
	};
	
	var eventPreventDefault = function eventPreventDefault(event) {
	  if (isObject(event) && isFunction(event.preventDefault)) {
	    event.preventDefault();
	  }
	};
	
	var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
	    return event.dataTransfer.getData(key);
	  }
	};
	
	var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
	  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
	    event.dataTransfer.setData(key, value);
	  }
	};
	
	function createConnectedField(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    var error = _plain["default"].getIn(syncErrors, name); // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	
	
	    return error && error._error ? error._error : error;
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name); // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedField = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(ConnectedField, _Component);
	
	    function ConnectedField() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.ref = _react["default"].createRef();
	
	      _this.isPristine = function () {
	        return _this.props.pristine;
	      };
	
	      _this.getValue = function () {
	        return _this.props.value;
	      };
	
	      _this.handleChange = function (event) {
	        var _this$props = _this.props,
	            name = _this$props.name,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            normalize = _this$props.normalize,
	            onChange = _this$props.onChange,
	            _reduxForm = _this$props._reduxForm,
	            previousValue = _this$props.value;
	        var newValue = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse,
	          normalize: normalize
	        });
	        var defaultPrevented = false;
	
	        if (onChange) {
	          // Can't seem to find a way to extend Event in React Native,
	          // thus I simply avoid adding preventDefault() in a RN environment
	          // to prevent the following error:
	          // `One of the sources for assign has an enumerable key on the prototype chain`
	          // Reference: https://github.com/facebook/react-native/issues/5507
	          if (!_isReactNative["default"] && (0, _isEvent["default"])(event)) {
	            onChange((0, _extends2["default"])({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), newValue, previousValue, name);
	          } else {
	            var onChangeResult = onChange(event, newValue, previousValue, name); // Return value of change handler affecting preventDefault is RN
	            // specific behavior.
	
	            if (_isReactNative["default"]) {
	              defaultPrevented = onChangeResult;
	            }
	          }
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue)); // call post-change callback
	
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue, 'change');
	          }
	        }
	      };
	
	      _this.handleFocus = function (event) {
	        var _this$props2 = _this.props,
	            name = _this$props2.name,
	            dispatch = _this$props2.dispatch,
	            onFocus = _this$props2.onFocus,
	            _reduxForm = _this$props2._reduxForm;
	        var defaultPrevented = false;
	
	        if (onFocus) {
	          if (!_isReactNative["default"]) {
	            onFocus((0, _extends2["default"])({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), name);
	          } else {
	            defaultPrevented = onFocus(event, name);
	          }
	        }
	
	        if (!defaultPrevented) {
	          dispatch(_reduxForm.focus(name));
	        }
	      };
	
	      _this.handleBlur = function (event) {
	        var _this$props3 = _this.props,
	            name = _this$props3.name,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            normalize = _this$props3.normalize,
	            onBlur = _this$props3.onBlur,
	            _reduxForm = _this$props3._reduxForm,
	            _value = _this$props3._value,
	            previousValue = _this$props3.value;
	        var newValue = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse,
	          normalize: normalize
	        }); // for checkbox and radio, if the value property of checkbox or radio equals
	        // the value passed by blur event, then fire blur action with previousValue.
	
	        if (newValue === _value && _value !== undefined) {
	          newValue = previousValue;
	        }
	
	        var defaultPrevented = false;
	
	        if (onBlur) {
	          if (!_isReactNative["default"]) {
	            onBlur((0, _extends2["default"])({}, event, {
	              preventDefault: function preventDefault() {
	                defaultPrevented = true;
	                return eventPreventDefault(event);
	              }
	            }), newValue, previousValue, name);
	          } else {
	            defaultPrevented = onBlur(event, newValue, previousValue, name);
	          }
	        }
	
	        if (!defaultPrevented) {
	          // dispatch blur action
	          dispatch(_reduxForm.blur(name, newValue)); // call post-blur callback
	
	          if (_reduxForm.asyncValidate) {
	            _reduxForm.asyncValidate(name, newValue, 'blur');
	          }
	        }
	      };
	
	      _this.handleDragStart = function (event) {
	        var _this$props4 = _this.props,
	            name = _this$props4.name,
	            onDragStart = _this$props4.onDragStart,
	            value = _this$props4.value;
	        eventDataTransferSetData(event, _eventConsts.dataKey, value == null ? '' : value);
	
	        if (onDragStart) {
	          onDragStart(event, name);
	        }
	      };
	
	      _this.handleDrop = function (event) {
	        var _this$props5 = _this.props,
	            name = _this$props5.name,
	            dispatch = _this$props5.dispatch,
	            onDrop = _this$props5.onDrop,
	            _reduxForm = _this$props5._reduxForm,
	            previousValue = _this$props5.value;
	        var newValue = eventDataTransferGetData(event, _eventConsts.dataKey);
	        var defaultPrevented = false;
	
	        if (onDrop) {
	          onDrop((0, _extends2["default"])({}, event, {
	            preventDefault: function preventDefault() {
	              defaultPrevented = true;
	              return eventPreventDefault(event);
	            }
	          }), newValue, previousValue, name);
	        }
	
	        if (!defaultPrevented) {
	          // dispatch change action
	          dispatch(_reduxForm.change(name, newValue));
	          eventPreventDefault(event);
	        }
	      };
	
	      return _this;
	    }
	
	    var _proto = ConnectedField.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      var nextPropsKeys = Object.keys(nextProps);
	      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
	      // https://twitter.com/erikras/status/915866544558788608
	
	      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	        if (~(nextProps.immutableProps || []).indexOf(prop)) {
	          return _this2.props[prop] !== nextProps[prop];
	        }
	
	        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	      }));
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      return this.ref.current;
	    };
	
	    _proto.render = function render() {
	      var _this$props6 = this.props,
	          component = _this$props6.component,
	          forwardRef = _this$props6.forwardRef,
	          name = _this$props6.name,
	          _reduxForm = _this$props6._reduxForm,
	          normalize = _this$props6.normalize,
	          onBlur = _this$props6.onBlur,
	          onChange = _this$props6.onChange,
	          onFocus = _this$props6.onFocus,
	          onDragStart = _this$props6.onDragStart,
	          onDrop = _this$props6.onDrop,
	          immutableProps = _this$props6.immutableProps,
	          rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props6, ["component", "forwardRef", "name", "_reduxForm", "normalize", "onBlur", "onChange", "onFocus", "onDragStart", "onDrop", "immutableProps"]);
	
	      var _createFieldProps = (0, _createFieldProps2["default"])(structure, name, (0, _extends2["default"])({}, rest, {
	        form: _reduxForm.form,
	        onBlur: this.handleBlur,
	        onChange: this.handleChange,
	        onDrop: this.handleDrop,
	        onDragStart: this.handleDragStart,
	        onFocus: this.handleFocus
	      })),
	          custom = _createFieldProps.custom,
	          props = (0, _objectWithoutPropertiesLoose2["default"])(_createFieldProps, ["custom"]);
	
	      if (forwardRef) {
	        custom.ref = this.ref;
	      }
	
	      if (typeof component === 'string') {
	        var input = props.input,
	            meta = props.meta; // eslint-disable-line no-unused-vars
	        // flatten input into other props
	
	        return (0, _react.createElement)(component, (0, _extends2["default"])({}, input, {}, custom));
	      } else {
	        return (0, _react.createElement)(component, (0, _extends2["default"])({}, props, {}, custom));
	      }
	    };
	
	    return ConnectedField;
	  }(_react.Component);
	
	  ConnectedField.propTypes = {
	    component: _validateComponentProp["default"],
	    props: _propTypes["default"].object
	  };
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	    var formState = getFormState(state);
	    var initialState = getIn(formState, "initial." + name);
	    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	    var value = getIn(formState, "values." + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, "asyncErrors." + name),
	      asyncValidating: getIn(formState, 'asyncValidating') === name,
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, "fields." + name),
	      submitError: getIn(formState, "submitErrors." + name),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      initial: initial,
	      value: value,
	      _value: ownProps.value // save value passed in (for radios)
	
	    };
	  }, undefined, undefined, {
	    forwardRef: true
	  });
	  return connector(ConnectedField);
	}
	
	var _default = createConnectedField;
	exports["default"] = _default;

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createConnectedFieldArray;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(143));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(371));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactRedux = __webpack_require__(12);
	
	var _redux = __webpack_require__(178);
	
	var _createFieldArrayProps = _interopRequireDefault(__webpack_require__(1761));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(141));
	
	var propsToNotUpdateFor = ['_reduxForm', 'value'];
	
	function createConnectedFieldArray(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size,
	      equals = structure.equals,
	      orderChanged = structure.orderChanged;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // For an array, the error can _ONLY_ be under _error.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return _plain["default"].getIn(syncErrors, name + "._error");
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    // For an array, the warning can _ONLY_ be under _warning.
	    // This is why this getSyncError is not the same as the
	    // one in Field.
	    return getIn(syncWarnings, name + "._warning");
	  };
	
	  var ConnectedFieldArray = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(ConnectedFieldArray, _Component);
	
	    function ConnectedFieldArray() {
	      var _this;
	
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _this.ref = _react["default"].createRef();
	
	      _this.getValue = function (index) {
	        return _this.props.value && getIn(_this.props.value, String(index));
	      };
	
	      return _this;
	    }
	
	    var _proto = ConnectedFieldArray.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      var _this2 = this;
	
	      // Update if the elements of the value array was updated.
	      var thisValue = this.props.value;
	      var nextValue = nextProps.value;
	
	      if (thisValue && nextValue) {
	        var nextValueItemsSame = equals(nextValue, thisValue); //.every(val => ~thisValue.indexOf(val))
	
	        var nextValueItemsOrderChanged = orderChanged(thisValue, nextValue);
	        var thisValueLength = thisValue.length || thisValue.size;
	        var nextValueLength = nextValue.length || nextValue.size;
	
	        if (thisValueLength !== nextValueLength || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
	          return !deepEqual(val, nextValue[index]);
	        })) {
	          return true;
	        }
	      }
	
	      var nextPropsKeys = Object.keys(nextProps);
	      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
	      // https://twitter.com/erikras/status/915866544558788608
	
	      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	        // useful to debug rerenders
	        // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	        //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	        // }
	        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	      }));
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      return this.ref.current;
	    };
	
	    _proto.render = function render() {
	      var _this$props = this.props,
	          component = _this$props.component,
	          forwardRef = _this$props.forwardRef,
	          name = _this$props.name,
	          _reduxForm = _this$props._reduxForm,
	          validate = _this$props.validate,
	          warn = _this$props.warn,
	          rerenderOnEveryChange = _this$props.rerenderOnEveryChange,
	          rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["component", "forwardRef", "name", "_reduxForm", "validate", "warn", "rerenderOnEveryChange"]);
	      var props = (0, _createFieldArrayProps["default"])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
	
	      if (forwardRef) {
	        props.ref = this.ref;
	      }
	
	      return (0, _react.createElement)(component, props);
	    };
	
	    (0, _createClass2["default"])(ConnectedFieldArray, [{
	      key: "dirty",
	      get: function get() {
	        return this.props.dirty;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return this.props.pristine;
	      }
	    }, {
	      key: "value",
	      get: function get() {
	        return this.props.value;
	      }
	    }]);
	    return ConnectedFieldArray;
	  }(_react.Component);
	
	  ConnectedFieldArray.propTypes = {
	    component: _validateComponentProp["default"],
	    props: _propTypes["default"].object,
	    rerenderOnEveryChange: _propTypes["default"].bool
	  };
	  ConnectedFieldArray.defaultProps = {
	    rerenderOnEveryChange: false
	  };
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var name = ownProps.name,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	    var formState = getFormState(state);
	    var initial = getIn(formState, "initial." + name) || initialValues && getIn(initialValues, name);
	    var value = getIn(formState, "values." + name);
	    var submitting = getIn(formState, 'submitting');
	    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	    var pristine = deepEqual(value, initial);
	    return {
	      asyncError: getIn(formState, "asyncErrors." + name + "._error"),
	      dirty: !pristine,
	      pristine: pristine,
	      state: getIn(formState, "fields." + name),
	      submitError: getIn(formState, "submitErrors." + name + "._error"),
	      submitFailed: getIn(formState, 'submitFailed'),
	      submitting: submitting,
	      syncError: syncError,
	      syncWarning: syncWarning,
	      value: value,
	      length: size(value)
	    };
	  }, function (dispatch, ownProps) {
	    var name = ownProps.name,
	        _reduxForm = ownProps._reduxForm;
	    var arrayInsert = _reduxForm.arrayInsert,
	        arrayMove = _reduxForm.arrayMove,
	        arrayPop = _reduxForm.arrayPop,
	        arrayPush = _reduxForm.arrayPush,
	        arrayRemove = _reduxForm.arrayRemove,
	        arrayRemoveAll = _reduxForm.arrayRemoveAll,
	        arrayShift = _reduxForm.arrayShift,
	        arraySplice = _reduxForm.arraySplice,
	        arraySwap = _reduxForm.arraySwap,
	        arrayUnshift = _reduxForm.arrayUnshift;
	    return (0, _mapValues2["default"])({
	      arrayInsert: arrayInsert,
	      arrayMove: arrayMove,
	      arrayPop: arrayPop,
	      arrayPush: arrayPush,
	      arrayRemove: arrayRemove,
	      arrayRemoveAll: arrayRemoveAll,
	      arrayShift: arrayShift,
	      arraySplice: arraySplice,
	      arraySwap: arraySwap,
	      arrayUnshift: arrayUnshift
	    }, function (actionCreator) {
	      return (0, _redux.bindActionCreators)(actionCreator.bind(null, name), dispatch);
	    });
	  }, undefined, {
	    forwardRef: true
	  });
	  return connector(ConnectedFieldArray);
	}

/***/ }),
/* 1751 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createConnectedFields;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _reactRedux = __webpack_require__(12);
	
	var _createFieldProps2 = _interopRequireDefault(__webpack_require__(795));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _onChangeValue = _interopRequireDefault(__webpack_require__(800));
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(141));
	
	var propsToNotUpdateFor = ['_reduxForm'];
	
	function createConnectedFields(structure) {
	  var deepEqual = structure.deepEqual,
	      getIn = structure.getIn,
	      size = structure.size;
	
	  var getSyncError = function getSyncError(syncErrors, name) {
	    // Because the error for this field might not be at a level in the error structure where
	    // it can be set directly, it might need to be unwrapped from the _error property
	    return _plain["default"].getIn(syncErrors, name + "._error") || _plain["default"].getIn(syncErrors, name);
	  };
	
	  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
	    var warning = getIn(syncWarnings, name); // Because the warning for this field might not be at a level in the warning structure where
	    // it can be set directly, it might need to be unwrapped from the _warning property
	
	    return warning && warning._warning ? warning._warning : warning;
	  };
	
	  var ConnectedFields = /*#__PURE__*/function (_React$Component) {
	    (0, _inheritsLoose2["default"])(ConnectedFields, _React$Component);
	
	    function ConnectedFields(props) {
	      var _this;
	
	      _this = _React$Component.call(this, props) || this;
	      _this.onChangeFns = {};
	      _this.onFocusFns = {};
	      _this.onBlurFns = {};
	      _this.ref = _react["default"].createRef();
	
	      _this.prepareEventHandlers = function (_ref) {
	        var names = _ref.names;
	        return names.forEach(function (name) {
	          _this.onChangeFns[name] = function (event) {
	            return _this.handleChange(name, event);
	          };
	
	          _this.onFocusFns[name] = function () {
	            return _this.handleFocus(name);
	          };
	
	          _this.onBlurFns[name] = function (event) {
	            return _this.handleBlur(name, event);
	          };
	        });
	      };
	
	      _this.handleChange = function (name, event) {
	        var _this$props = _this.props,
	            dispatch = _this$props.dispatch,
	            parse = _this$props.parse,
	            _reduxForm = _this$props._reduxForm;
	        var value = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse
	        });
	        dispatch(_reduxForm.change(name, value)); // call post-change callback
	
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value, 'change');
	        }
	      };
	
	      _this.handleFocus = function (name) {
	        var _this$props2 = _this.props,
	            dispatch = _this$props2.dispatch,
	            _reduxForm = _this$props2._reduxForm;
	        dispatch(_reduxForm.focus(name));
	      };
	
	      _this.handleBlur = function (name, event) {
	        var _this$props3 = _this.props,
	            dispatch = _this$props3.dispatch,
	            parse = _this$props3.parse,
	            _reduxForm = _this$props3._reduxForm;
	        var value = (0, _onChangeValue["default"])(event, {
	          name: name,
	          parse: parse
	        }); // dispatch blur action
	
	        dispatch(_reduxForm.blur(name, value)); // call post-blur callback
	
	        if (_reduxForm.asyncValidate) {
	          _reduxForm.asyncValidate(name, value, 'blur');
	        }
	      };
	
	      _this.prepareEventHandlers(props);
	
	      return _this;
	    }
	
	    var _proto = ConnectedFields.prototype;
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
	        return !_this2.props._fields[nextName];
	      }))) {
	        // names has changed. The cached event handlers need to be updated
	        this.prepareEventHandlers(nextProps);
	      }
	    };
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      var _this3 = this;
	
	      var nextPropsKeys = Object.keys(nextProps);
	      var thisPropsKeys = Object.keys(this.props); // if we have children, we MUST update in React 16
	      // https://twitter.com/erikras/status/915866544558788608
	
	      return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
	        return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
	      }));
	    };
	
	    _proto.isDirty = function isDirty() {
	      var _fields = this.props._fields;
	      return Object.keys(_fields).some(function (name) {
	        return _fields[name].dirty;
	      });
	    };
	
	    _proto.getValues = function getValues() {
	      var _fields = this.props._fields;
	      return Object.keys(_fields).reduce(function (accumulator, name) {
	        return _plain["default"].setIn(accumulator, name, _fields[name].value);
	      }, {});
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      return this.ref.current;
	    };
	
	    _proto.render = function render() {
	      var _this4 = this;
	
	      var _this$props4 = this.props,
	          component = _this$props4.component,
	          forwardRef = _this$props4.forwardRef,
	          _fields = _this$props4._fields,
	          _reduxForm = _this$props4._reduxForm,
	          rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props4, ["component", "forwardRef", "_fields", "_reduxForm"]);
	      var sectionPrefix = _reduxForm.sectionPrefix,
	          form = _reduxForm.form;
	
	      var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
	        var connectedProps = _fields[name];
	
	        var _createFieldProps = (0, _createFieldProps2["default"])(structure, name, (0, _extends2["default"])({}, connectedProps, {}, rest, {
	          form: form,
	          onBlur: _this4.onBlurFns[name],
	          onChange: _this4.onChangeFns[name],
	          onFocus: _this4.onFocusFns[name]
	        })),
	            custom = _createFieldProps.custom,
	            fieldProps = (0, _objectWithoutPropertiesLoose2["default"])(_createFieldProps, ["custom"]);
	
	        accumulator.custom = custom;
	        var fieldName = sectionPrefix ? name.replace(sectionPrefix + ".", '') : name;
	        return _plain["default"].setIn(accumulator, fieldName, fieldProps);
	      }, {}),
	          custom = _Object$keys$reduce.custom,
	          props = (0, _objectWithoutPropertiesLoose2["default"])(_Object$keys$reduce, ["custom"]);
	
	      if (forwardRef) {
	        props.ref = this.ref;
	      }
	
	      return _react["default"].createElement(component, (0, _extends2["default"])({}, props, {}, custom));
	    };
	
	    return ConnectedFields;
	  }(_react["default"].Component);
	
	  ConnectedFields.propTypes = {
	    component: _validateComponentProp["default"],
	    _fields: _propTypes["default"].object.isRequired,
	    props: _propTypes["default"].object
	  };
	  var connector = (0, _reactRedux.connect)(function (state, ownProps) {
	    var names = ownProps.names,
	        _ownProps$_reduxForm = ownProps._reduxForm,
	        initialValues = _ownProps$_reduxForm.initialValues,
	        getFormState = _ownProps$_reduxForm.getFormState;
	    var formState = getFormState(state);
	    return {
	      _fields: names.reduce(function (accumulator, name) {
	        var initialState = getIn(formState, "initial." + name);
	        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
	        var value = getIn(formState, "values." + name);
	        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
	        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
	        var submitting = getIn(formState, 'submitting');
	        var pristine = value === initial;
	        accumulator[name] = {
	          asyncError: getIn(formState, "asyncErrors." + name),
	          asyncValidating: getIn(formState, 'asyncValidating') === name,
	          dirty: !pristine,
	          initial: initial,
	          pristine: pristine,
	          state: getIn(formState, "fields." + name),
	          submitError: getIn(formState, "submitErrors." + name),
	          submitFailed: getIn(formState, 'submitFailed'),
	          submitting: submitting,
	          syncError: syncError,
	          syncWarning: syncWarning,
	          value: value,
	          _value: ownProps.value // save value passed in (for radios)
	
	        };
	        return accumulator;
	      }, {})
	    };
	  }, undefined, undefined, {
	    forwardRef: true
	  });
	  return connector(ConnectedFields);
	}

/***/ }),
/* 1752 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createField = _interopRequireDefault(__webpack_require__(1759));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _createField["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFieldArray = _interopRequireDefault(__webpack_require__(1760));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _createFieldArray["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1754 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFields = _interopRequireDefault(__webpack_require__(1762));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _createFields["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1755 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _ReduxFormContext = __webpack_require__(101);
	
	var Form = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2["default"])(Form, _Component);
	
	  function Form(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	
	    if (!props._reduxForm) {
	      throw new Error('Form must be inside a component decorated with reduxForm()');
	    }
	
	    return _this;
	  }
	
	  var _proto = Form.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.props._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    if (this.props.onSubmit !== prevProps.onSubmit) {
	      this.props._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _reduxForm = _this$props._reduxForm,
	        rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["_reduxForm"]);
	    return /*#__PURE__*/_react["default"].createElement("form", rest);
	  };
	
	  return Form;
	}(_react.Component);
	
	Form.propTypes = {
	  onSubmit: _propTypes["default"].func.isRequired,
	  _reduxForm: _propTypes["default"].object
	};
	
	var _default = (0, _ReduxFormContext.withReduxForm)(Form);
	
	exports["default"] = _default;

/***/ }),
/* 1756 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _ReduxFormContext = __webpack_require__(101);
	
	var FormName = function FormName(_ref) {
	  var children = _ref.children,
	      _reduxForm = _ref._reduxForm;
	  return children({
	    form: _reduxForm && _reduxForm.form,
	    sectionPrefix: _reduxForm && _reduxForm.sectionPrefix
	  });
	};
	
	var _default = (0, _ReduxFormContext.withReduxForm)(FormName);
	
	exports["default"] = _default;

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(218));
	
	var _ReduxFormContext = __webpack_require__(101);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(141));
	
	var FormSection = /*#__PURE__*/function (_Component) {
	  (0, _inheritsLoose2["default"])(FormSection, _Component);
	
	  function FormSection(props) {
	    var _this;
	
	    _this = _Component.call(this, props) || this;
	
	    if (!props._reduxForm) {
	      throw new Error('FormSection must be inside a component decorated with reduxForm()');
	    }
	
	    return _this;
	  }
	
	  var _proto = FormSection.prototype;
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _reduxForm = _this$props._reduxForm,
	        children = _this$props.children,
	        name = _this$props.name,
	        component = _this$props.component,
	        rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["_reduxForm", "children", "name", "component"]);
	
	    if (_react["default"].isValidElement(children)) {
	      return (0, _react.createElement)(_ReduxFormContext.ReduxFormContext.Provider, {
	        value: (0, _extends2["default"])({}, this.props._reduxForm, {
	          sectionPrefix: (0, _prefixName["default"])(this.props, name)
	        }),
	        children: children
	      });
	    }
	
	    return (0, _react.createElement)(_ReduxFormContext.ReduxFormContext.Provider, {
	      value: (0, _extends2["default"])({}, this.props._reduxForm, {
	        sectionPrefix: (0, _prefixName["default"])(this.props, name)
	      }),
	      children: (0, _react.createElement)(component, (0, _extends2["default"])({}, rest, {
	        children: children
	      }))
	    });
	  };
	
	  return FormSection;
	}(_react.Component);
	
	FormSection.propTypes = {
	  name: _propTypes["default"].string.isRequired,
	  component: _validateComponentProp["default"]
	};
	FormSection.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _ReduxFormContext.withReduxForm)(FormSection);
	
	exports["default"] = _default;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isPromise = _interopRequireDefault(__webpack_require__(347));
	
	var asyncValidation = function asyncValidation(fn, start, stop, field) {
	  start(field);
	  var promise = fn();
	
	  if (!(0, _isPromise["default"])(promise)) {
	    throw new Error('asyncValidate function passed to reduxForm must return a promise');
	  }
	
	  var handleErrors = function handleErrors(rejected) {
	    return function (errors) {
	      if (rejected) {
	        if (errors && Object.keys(errors).length) {
	          stop(errors);
	          return errors;
	        } else {
	          stop();
	          throw new Error('Asynchronous validation promise was rejected without errors.');
	        }
	      }
	
	      stop();
	      return Promise.resolve();
	    };
	  };
	
	  return promise.then(handleErrors(false), handleErrors(true));
	};
	
	var _default = asyncValidation;
	exports["default"] = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(143));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _invariant = _interopRequireDefault(__webpack_require__(32));
	
	var _ConnectedField = _interopRequireDefault(__webpack_require__(1749));
	
	var _shallowCompare = _interopRequireDefault(__webpack_require__(804));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(218));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _ReduxFormContext = __webpack_require__(101);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(141));
	
	function createField(structure) {
	  var ConnectedField = (0, _ConnectedField["default"])(structure);
	  var setIn = structure.setIn;
	
	  var Field = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(Field, _Component);
	
	    function Field(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	      _this.ref = _react["default"].createRef();
	
	      _this.normalize = function (name, value) {
	        var normalize = _this.props.normalize;
	
	        if (!normalize) {
	          return value;
	        }
	
	        var previousValues = _this.props._reduxForm.getValues();
	
	        var previousValue = _this.value;
	        var nextValues = setIn(previousValues, name, value);
	        return normalize(value, previousValue, nextValues, previousValues, name);
	      };
	
	      if (!props._reduxForm) {
	        throw new Error('Field must be inside a component decorated with reduxForm()');
	      }
	
	      return _this;
	    }
	
	    var _proto = Field.prototype;
	
	    _proto.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.props._reduxForm.register(this.name, 'Field', function () {
	        return _this2.props.validate;
	      }, function () {
	        return _this2.props.warn;
	      });
	    };
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	      return (0, _shallowCompare["default"])(this, nextProps, nextState);
	    };
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      var oldName = (0, _prefixName["default"])(this.props, this.props.name);
	      var newName = (0, _prefixName["default"])(nextProps, nextProps.name);
	
	      if (oldName !== newName || // use deepEqual here because they could be a function or an array of functions
	      !_plain["default"].deepEqual(this.props.validate, nextProps.validate) || !_plain["default"].deepEqual(this.props.warn, nextProps.warn)) {
	        // unregister old name
	        this.props._reduxForm.unregister(oldName); // register new name
	
	
	        this.props._reduxForm.register(newName, 'Field', function () {
	          return nextProps.validate;
	        }, function () {
	          return nextProps.warn;
	        });
	      }
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.props._reduxForm.unregister(this.name);
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      (0, _invariant["default"])(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to Field');
	      return this.ref.current ? this.ref.current.getRenderedComponent() : undefined;
	    };
	
	    _proto.render = function render() {
	      return (0, _react.createElement)(ConnectedField, (0, _extends2["default"])({}, this.props, {
	        name: this.name,
	        normalize: this.normalize,
	        ref: this.ref
	      }));
	    };
	
	    (0, _createClass2["default"])(Field, [{
	      key: "name",
	      get: function get() {
	        return (0, _prefixName["default"])(this.props, this.props.name);
	      }
	    }, {
	      key: "dirty",
	      get: function get() {
	        return !this.pristine;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return !!(this.ref.current && this.ref.current.isPristine());
	      }
	    }, {
	      key: "value",
	      get: function get() {
	        return this.ref.current && this.ref.current.getValue();
	      }
	    }]);
	    return Field;
	  }(_react.Component);
	
	  Field.propTypes = {
	    name: _propTypes["default"].string.isRequired,
	    component: _validateComponentProp["default"],
	    format: _propTypes["default"].func,
	    normalize: _propTypes["default"].func,
	    onBlur: _propTypes["default"].func,
	    onChange: _propTypes["default"].func,
	    onFocus: _propTypes["default"].func,
	    onDragStart: _propTypes["default"].func,
	    onDrop: _propTypes["default"].func,
	    parse: _propTypes["default"].func,
	    props: _propTypes["default"].object,
	    validate: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    warn: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    forwardRef: _propTypes["default"].bool,
	    immutableProps: _propTypes["default"].arrayOf(_propTypes["default"].string),
	    _reduxForm: _propTypes["default"].object
	  };
	  return (0, _ReduxFormContext.withReduxForm)(Field);
	}
	
	var _default = createField;
	exports["default"] = _default;

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createFieldArray;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(143));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _invariant = _interopRequireDefault(__webpack_require__(32));
	
	var _ConnectedFieldArray = _interopRequireDefault(__webpack_require__(1750));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(218));
	
	var _ReduxFormContext = __webpack_require__(101);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(141));
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var wrapError = function wrapError(fn, key) {
	  return fn && function () {
	    var validators = toArray(fn);
	
	    for (var i = 0; i < validators.length; i++) {
	      var result = validators[i].apply(validators, arguments);
	
	      if (result) {
	        var _ref;
	
	        return _ref = {}, _ref[key] = result, _ref;
	      }
	    }
	  };
	};
	
	function createFieldArray(structure) {
	  var ConnectedFieldArray = (0, _ConnectedFieldArray["default"])(structure);
	
	  var FieldArray = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(FieldArray, _Component);
	
	    function FieldArray(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	      _this.ref = _react["default"].createRef();
	
	      if (!props._reduxForm) {
	        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
	      }
	
	      return _this;
	    }
	
	    var _proto = FieldArray.prototype;
	
	    _proto.componentDidMount = function componentDidMount() {
	      var _this2 = this;
	
	      this.props._reduxForm.register(this.name, 'FieldArray', function () {
	        return wrapError(_this2.props.validate, '_error');
	      }, function () {
	        return wrapError(_this2.props.warn, '_warning');
	      });
	    };
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      var oldName = (0, _prefixName["default"])(this.props, this.props.name);
	      var newName = (0, _prefixName["default"])(nextProps, nextProps.name);
	
	      if (oldName !== newName) {
	        // unregister old name
	        this.props._reduxForm.unregister(oldName); // register new name
	
	
	        this.props._reduxForm.register(newName, 'FieldArray');
	      }
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      this.props._reduxForm.unregister(this.name);
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      (0, _invariant["default"])(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to FieldArray');
	      return this.ref && this.ref.current.getRenderedComponent();
	    };
	
	    _proto.render = function render() {
	      return (0, _react.createElement)(ConnectedFieldArray, (0, _extends2["default"])({}, this.props, {
	        name: this.name,
	        ref: this.ref
	      }));
	    };
	
	    (0, _createClass2["default"])(FieldArray, [{
	      key: "name",
	      get: function get() {
	        return (0, _prefixName["default"])(this.props, this.props.name);
	      }
	    }, {
	      key: "dirty",
	      get: function get() {
	        return !this.ref || this.ref.current.dirty;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return !!(this.ref && this.ref.current.pristine);
	      }
	    }, {
	      key: "value",
	      get: function get() {
	        return this.ref ? this.ref.current.value : undefined;
	      }
	    }]);
	    return FieldArray;
	  }(_react.Component);
	
	  FieldArray.propTypes = {
	    name: _propTypes["default"].string.isRequired,
	    component: _validateComponentProp["default"],
	    props: _propTypes["default"].object,
	    validate: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    warn: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]),
	    forwardRef: _propTypes["default"].bool,
	    _reduxForm: _propTypes["default"].object
	  };
	  return (0, _ReduxFormContext.withReduxForm)(FieldArray);
	}

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createFieldArrayProps;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	function createFieldArrayProps(_ref, name, form, sectionPrefix, getValue, _ref2) {
	  var getIn = _ref.getIn;
	  var arrayInsert = _ref2.arrayInsert,
	      arrayMove = _ref2.arrayMove,
	      arrayPop = _ref2.arrayPop,
	      arrayPush = _ref2.arrayPush,
	      arrayRemove = _ref2.arrayRemove,
	      arrayRemoveAll = _ref2.arrayRemoveAll,
	      arrayShift = _ref2.arrayShift,
	      arraySplice = _ref2.arraySplice,
	      arraySwap = _ref2.arraySwap,
	      arrayUnshift = _ref2.arrayUnshift,
	      asyncError = _ref2.asyncError,
	      dirty = _ref2.dirty,
	      length = _ref2.length,
	      pristine = _ref2.pristine,
	      submitError = _ref2.submitError,
	      state = _ref2.state,
	      submitFailed = _ref2.submitFailed,
	      submitting = _ref2.submitting,
	      syncError = _ref2.syncError,
	      syncWarning = _ref2.syncWarning,
	      value = _ref2.value,
	      props = _ref2.props,
	      rest = (0, _objectWithoutPropertiesLoose2["default"])(_ref2, ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncError", "dirty", "length", "pristine", "submitError", "state", "submitFailed", "submitting", "syncError", "syncWarning", "value", "props"]);
	  var error = syncError || asyncError || submitError;
	  var warning = syncWarning;
	  var fieldName = sectionPrefix ? name.replace(sectionPrefix + ".", '') : name;
	  var finalProps = (0, _extends2["default"])({
	    fields: {
	      _isFieldArray: true,
	      forEach: function forEach(callback) {
	        return (value || []).forEach(function (item, index) {
	          return callback(fieldName + "[" + index + "]", index, finalProps.fields);
	        });
	      },
	      get: getValue,
	      getAll: function getAll() {
	        return value;
	      },
	      insert: arrayInsert,
	      length: length,
	      map: function map(callback) {
	        return (value || []).map(function (item, index) {
	          return callback(fieldName + "[" + index + "]", index, finalProps.fields);
	        });
	      },
	      move: arrayMove,
	      name: name,
	      pop: function pop() {
	        arrayPop();
	        return getIn(value, String(length - 1));
	      },
	      push: arrayPush,
	      reduce: function reduce(callback, initial) {
	        return (value || []).reduce(function (accumulator, item, index) {
	          return callback(accumulator, fieldName + "[" + index + "]", index, finalProps.fields);
	        }, initial);
	      },
	      remove: arrayRemove,
	      removeAll: arrayRemoveAll,
	      shift: function shift() {
	        arrayShift();
	        return getIn(value, '0');
	      },
	      splice: arraySplice,
	      swap: arraySwap,
	      unshift: arrayUnshift
	    },
	    meta: {
	      dirty: dirty,
	      error: error,
	      form: form,
	      warning: warning,
	      invalid: !!error,
	      pristine: pristine,
	      submitting: submitting,
	      submitFailed: submitFailed,
	      valid: !error
	    }
	  }, props, {}, rest);
	  return finalProps;
	}

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createFields;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(143));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _react = __webpack_require__(1);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _invariant = _interopRequireDefault(__webpack_require__(32));
	
	var _get = _interopRequireDefault(__webpack_require__(96));
	
	var _ConnectedFields = _interopRequireDefault(__webpack_require__(1751));
	
	var _shallowCompare = _interopRequireDefault(__webpack_require__(804));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _prefixName = _interopRequireDefault(__webpack_require__(218));
	
	var _ReduxFormContext = __webpack_require__(101);
	
	var _validateComponentProp = _interopRequireDefault(__webpack_require__(141));
	
	var validateNameProp = function validateNameProp(prop) {
	  if (!prop) {
	    return new Error('No "names" prop was specified <Fields/>');
	  }
	
	  if (!Array.isArray(prop) && !prop._isFieldArray) {
	    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
	  }
	};
	
	var warnAndValidatePropType = _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func), _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].arrayOf(_propTypes["default"].func)]))]);
	
	var fieldsPropTypes = {
	  component: _validateComponentProp["default"],
	  format: _propTypes["default"].func,
	  parse: _propTypes["default"].func,
	  props: _propTypes["default"].object,
	  forwardRef: _propTypes["default"].bool,
	  validate: warnAndValidatePropType,
	  warn: warnAndValidatePropType
	};
	
	var getFieldWarnAndValidate = function getFieldWarnAndValidate(prop, name) {
	  return Array.isArray(prop) || typeof prop === 'function' ? prop : (0, _get["default"])(prop, name, undefined);
	};
	
	function createFields(structure) {
	  var ConnectedFields = (0, _ConnectedFields["default"])(structure);
	
	  var Fields = /*#__PURE__*/function (_Component) {
	    (0, _inheritsLoose2["default"])(Fields, _Component);
	
	    function Fields(props) {
	      var _this;
	
	      _this = _Component.call(this, props) || this;
	      _this.connected = (0, _react.createRef)();
	
	      if (!props._reduxForm) {
	        throw new Error('Fields must be inside a component decorated with reduxForm()');
	      }
	
	      var error = validateNameProp(props.names);
	
	      if (error) {
	        throw error;
	      }
	
	      return _this;
	    }
	
	    var _proto = Fields.prototype;
	
	    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      return (0, _shallowCompare["default"])(this, nextProps);
	    };
	
	    _proto.componentDidMount = function componentDidMount() {
	      this.registerFields(this.props.names);
	    };
	
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	      if (!_plain["default"].deepEqual(this.props.names, nextProps.names)) {
	        var props = this.props;
	        var unregister = props._reduxForm.unregister; // unregister old name
	
	        this.props.names.forEach(function (name) {
	          return unregister((0, _prefixName["default"])(props, name));
	        }); // register new name
	
	        this.registerFields(nextProps.names);
	      }
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      var props = this.props;
	      var unregister = props._reduxForm.unregister;
	      this.props.names.forEach(function (name) {
	        return unregister((0, _prefixName["default"])(props, name));
	      });
	    };
	
	    _proto.registerFields = function registerFields(names) {
	      var _this2 = this;
	
	      var props = this.props;
	      var register = props._reduxForm.register;
	      names.forEach(function (name) {
	        return register((0, _prefixName["default"])(props, name), 'Field', function () {
	          return getFieldWarnAndValidate(_this2.props.validate, name);
	        }, function () {
	          return getFieldWarnAndValidate(_this2.props.warn, name);
	        });
	      });
	    };
	
	    _proto.getRenderedComponent = function getRenderedComponent() {
	      (0, _invariant["default"])(this.props.forwardRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a forwardRef prop to Fields');
	      return this.connected.current ? this.connected.current.getRenderedComponent() : null;
	    };
	
	    _proto.render = function render() {
	      var props = this.props;
	      return (0, _react.createElement)(ConnectedFields, (0, _extends2["default"])({}, this.props, {
	        names: this.props.names.map(function (name) {
	          return (0, _prefixName["default"])(props, name);
	        }),
	        ref: this.connected
	      }));
	    };
	
	    (0, _createClass2["default"])(Fields, [{
	      key: "names",
	      get: function get() {
	        var props = this.props;
	        return this.props.names.map(function (name) {
	          return (0, _prefixName["default"])(props, name);
	        });
	      }
	    }, {
	      key: "dirty",
	      get: function get() {
	        return this.connected.current ? this.connected.current.isDirty() : false;
	      }
	    }, {
	      key: "pristine",
	      get: function get() {
	        return !this.dirty;
	      }
	    }, {
	      key: "values",
	      get: function get() {
	        return this.connected.current ? this.connected.current.getValues() : {};
	      }
	    }]);
	    return Fields;
	  }(_react.Component);
	
	  Fields.propTypes = (0, _extends2["default"])({
	    names: function names(props, propName) {
	      return validateNameProp(props[propName]);
	    }
	  }, fieldsPropTypes);
	  return (0, _ReduxFormContext.withReduxForm)(Fields);
	}

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createFormValueSelector;
	
	var _invariant = _interopRequireDefault(__webpack_require__(32));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	function createFormValueSelector(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    (0, _invariant["default"])(form, 'Form value must be specified');
	
	    var nonNullGetFormState = getFormState || function (state) {
	      return getIn(state, 'form');
	    };
	
	    return function (state) {
	      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      (0, _invariant["default"])(fields.length, 'No fields specified');
	      return fields.length === 1 ? // only selecting one field, so return its value
	      getIn(nonNullGetFormState(state), form + ".values." + fields[0]) : // selecting many fields, so return an object of field values
	      fields.reduce(function (accumulator, field) {
	        var value = getIn(nonNullGetFormState(state), form + ".values." + field);
	        return value === undefined ? accumulator : _plain["default"].setIn(accumulator, field, value);
	      }, {});
	    };
	  };
	}

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createValues;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(371));
	
	var _isEqual2 = _interopRequireDefault(__webpack_require__(573));
	
	var _isEmpty2 = _interopRequireDefault(__webpack_require__(98));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactRedux = __webpack_require__(12);
	
	var _prefixName = _interopRequireDefault(__webpack_require__(218));
	
	var _ReduxFormContext = __webpack_require__(101);
	
	function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (firstArg) {
	    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      rest[_key - 1] = arguments[_key];
	    }
	
	    // create a class that reads current form name and creates a selector
	    // return
	    return function (Component) {
	      var FormValues = /*#__PURE__*/function (_React$Component) {
	        (0, _inheritsLoose2["default"])(FormValues, _React$Component);
	
	        function FormValues(props) {
	          var _this;
	
	          _this = _React$Component.call(this, props) || this;
	
	          if (!props._reduxForm) {
	            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
	          }
	
	          _this.updateComponent(props);
	
	          return _this;
	        }
	
	        var _proto = FormValues.prototype;
	
	        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(props) {
	          if (typeof firstArg === 'function') {
	            this.updateComponent(props);
	          }
	        };
	
	        _proto.render = function render() {
	          var Component = this.Component;
	          return /*#__PURE__*/_react["default"].createElement(Component // so that the connected component updates props when sectionPrefix has changed
	          , (0, _extends2["default"])({
	            sectionPrefix: this.props._reduxForm.sectionPrefix
	          }, this.props));
	        };
	
	        _proto.updateComponent = function updateComponent(props) {
	          var valuesMap;
	          var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
	
	          if (typeof resolvedFirstArg === 'string') {
	            var _rest$reduce;
	
	            valuesMap = rest.reduce(function (result, k) {
	              result[k] = k;
	              return result;
	            }, (_rest$reduce = {}, _rest$reduce[resolvedFirstArg] = resolvedFirstArg, _rest$reduce));
	          } else {
	            valuesMap = resolvedFirstArg;
	          }
	
	          if ((0, _isEmpty2["default"])(valuesMap)) {
	            // maybe that empty valuesMap is ok if firstArg is a function?
	            // if this is the case, we probably should set this.Component = Component
	            throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
	          }
	
	          if ((0, _isEqual2["default"])(valuesMap, this._valuesMap)) {
	            // no change in valuesMap
	            return;
	          }
	
	          this._valuesMap = valuesMap;
	          this.setComponent();
	        };
	
	        _proto.setComponent = function setComponent() {
	          var _this2 = this;
	
	          var formValuesSelector = function formValuesSelector(_, _ref2) {
	            var sectionPrefix = _ref2.sectionPrefix;
	            // Yes, we're only using connect() for listening to updates.
	            // The second argument needs to be there so that connect calls
	            // the selector when props change
	            var getValues = _this2.props._reduxForm.getValues;
	            var values = getValues();
	            return (0, _mapValues2["default"])(_this2._valuesMap, function (path) {
	              return getIn(values, (0, _prefixName["default"])(_this2.props, path));
	            });
	          };
	
	          this.Component = (0, _reactRedux.connect)(formValuesSelector, function () {
	            return {};
	          } // ignore dispatch
	          )(function (_ref3) {
	            var sectionPrefix = _ref3.sectionPrefix,
	                otherProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref3, ["sectionPrefix"]);
	            return /*#__PURE__*/_react["default"].createElement(Component, otherProps);
	          });
	        };
	
	        return FormValues;
	      }(_react["default"].Component);
	
	      return (0, _ReduxFormContext.withReduxForm)(FormValues);
	    };
	  };
	}

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _isFunction2 = _interopRequireDefault(__webpack_require__(264));
	
	var _actionTypes = __webpack_require__(406);
	
	var _deleteInWithCleanUp = _interopRequireDefault(__webpack_require__(1768));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var shouldDelete = function shouldDelete(_ref) {
	  var getIn = _ref.getIn;
	  return function (state, path) {
	    var initialValuesPath = null;
	
	    if (/^values/.test(path)) {
	      initialValuesPath = path.replace('values', 'initial');
	    }
	
	    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;
	    return getIn(state, path) !== undefined && initialValueComparison;
	  };
	};
	
	var isReduxFormAction = function isReduxFormAction(action) {
	  return action && action.type && action.type.length > _actionTypes.prefix.length && action.type.substring(0, _actionTypes.prefix.length) === _actionTypes.prefix;
	};
	
	function createReducer(structure) {
	  var _behaviors;
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      forEach = structure.forEach,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      deleteIn = structure.deleteIn,
	      fromJS = structure.fromJS,
	      keys = structure.keys,
	      size = structure.size,
	      some = structure.some,
	      splice = structure.splice;
	  var deleteInWithCleanUp = (0, _deleteInWithCleanUp["default"])(structure)(shouldDelete);
	  var plainDeleteInWithCleanUp = (0, _deleteInWithCleanUp["default"])(_plain["default"])(shouldDelete);
	
	  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
	    var existing = getIn(state, key + "." + field);
	    return existing || force ? setIn(state, key + "." + field, splice(existing, index, removeNum, value)) : state;
	  };
	
	  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
	    var slice = getIn(state, key);
	
	    var existing = _plain["default"].getIn(slice, field);
	
	    return existing || force ? setIn(state, key, _plain["default"].setIn(slice, field, _plain["default"].splice(existing, index, removeNum, value))) : state;
	  };
	
	  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
	
	  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
	    var result = state;
	    var nonValuesValue = value != null ? empty : undefined;
	    result = doSplice(result, 'values', field, index, removeNum, value, true);
	    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
	    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
	    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
	    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
	    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
	    return result;
	  };
	
	  var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ARRAY_INSERT] = function (state, _ref2) {
	    var _ref2$meta = _ref2.meta,
	        field = _ref2$meta.field,
	        index = _ref2$meta.index,
	        payload = _ref2.payload;
	    return arraySplice(state, field, index, 0, payload);
	  }, _behaviors[_actionTypes.ARRAY_MOVE] = function (state, _ref3) {
	    var _ref3$meta = _ref3.meta,
	        field = _ref3$meta.field,
	        from = _ref3$meta.from,
	        to = _ref3$meta.to;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    var result = state;
	
	    if (length) {
	      rootKeys.forEach(function (key) {
	        var path = key + "." + field;
	
	        if (getIn(result, path)) {
	          var value = getIn(result, path + "[" + from + "]");
	          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
	
	          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
	        }
	      });
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.ARRAY_POP] = function (state, _ref4) {
	    var field = _ref4.meta.field;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, length - 1, 1) : state;
	  }, _behaviors[_actionTypes.ARRAY_PUSH] = function (state, _ref5) {
	    var field = _ref5.meta.field,
	        payload = _ref5.payload;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    return arraySplice(state, field, length, 0, payload);
	  }, _behaviors[_actionTypes.ARRAY_REMOVE] = function (state, _ref6) {
	    var _ref6$meta = _ref6.meta,
	        field = _ref6$meta.field,
	        index = _ref6$meta.index;
	    return arraySplice(state, field, index, 1);
	  }, _behaviors[_actionTypes.ARRAY_REMOVE_ALL] = function (state, _ref7) {
	    var field = _ref7.meta.field;
	    var array = getIn(state, "values." + field);
	    var length = array ? size(array) : 0;
	    return length ? arraySplice(state, field, 0, length) : state;
	  }, _behaviors[_actionTypes.ARRAY_SHIFT] = function (state, _ref8) {
	    var field = _ref8.meta.field;
	    return arraySplice(state, field, 0, 1);
	  }, _behaviors[_actionTypes.ARRAY_SPLICE] = function (state, _ref9) {
	    var _ref9$meta = _ref9.meta,
	        field = _ref9$meta.field,
	        index = _ref9$meta.index,
	        removeNum = _ref9$meta.removeNum,
	        payload = _ref9.payload;
	    return arraySplice(state, field, index, removeNum, payload);
	  }, _behaviors[_actionTypes.ARRAY_SWAP] = function (state, _ref10) {
	    var _ref10$meta = _ref10.meta,
	        field = _ref10$meta.field,
	        indexA = _ref10$meta.indexA,
	        indexB = _ref10$meta.indexB;
	    var result = state;
	    rootKeys.forEach(function (key) {
	      var valueA = getIn(result, key + "." + field + "[" + indexA + "]");
	      var valueB = getIn(result, key + "." + field + "[" + indexB + "]");
	
	      if (valueA !== undefined || valueB !== undefined) {
	        result = setIn(result, key + "." + field + "[" + indexA + "]", valueB);
	        result = setIn(result, key + "." + field + "[" + indexB + "]", valueA);
	      }
	    });
	    return result;
	  }, _behaviors[_actionTypes.ARRAY_UNSHIFT] = function (state, _ref11) {
	    var field = _ref11.meta.field,
	        payload = _ref11.payload;
	    return arraySplice(state, field, 0, 0, payload);
	  }, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref12) {
	    var field = _ref12.meta.field,
	        payload = _ref12.payload;
	    var result = state;
	    result = deleteInWithCleanUp(result, "asyncErrors." + field);
	    result = deleteInWithCleanUp(result, "submitErrors." + field);
	    result = setIn(result, "fields." + field + ".autofilled", true);
	    result = setIn(result, "values." + field, payload);
	    return result;
	  }, _behaviors[_actionTypes.BLUR] = function (state, _ref13) {
	    var _ref13$meta = _ref13.meta,
	        field = _ref13$meta.field,
	        touch = _ref13$meta.touch,
	        payload = _ref13.payload;
	    var result = state;
	    var initial = getIn(result, "initial." + field);
	
	    if (initial === undefined && payload === '') {
	      result = deleteInWithCleanUp(result, "values." + field);
	    } else if (payload !== undefined) {
	      result = setIn(result, "values." + field, payload);
	    }
	
	    if (field === getIn(result, 'active')) {
	      result = deleteIn(result, 'active');
	    }
	
	    result = deleteIn(result, "fields." + field + ".active");
	
	    if (touch) {
	      result = setIn(result, "fields." + field + ".touched", true);
	      result = setIn(result, 'anyTouched', true);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.CHANGE] = function (state, _ref14) {
	    var _ref14$meta = _ref14.meta,
	        field = _ref14$meta.field,
	        touch = _ref14$meta.touch,
	        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
	        payload = _ref14.payload;
	    var result = state;
	    var initial = getIn(result, "initial." + field);
	
	    if (initial === undefined && payload === '' || payload === undefined) {
	      result = deleteInWithCleanUp(result, "values." + field);
	    } else if ((0, _isFunction2["default"])(payload)) {
	      var fieldCurrentValue = getIn(state, "values." + field);
	      result = setIn(result, "values." + field, payload(fieldCurrentValue, state.values));
	    } else {
	      result = setIn(result, "values." + field, payload);
	    }
	
	    result = deleteInWithCleanUp(result, "asyncErrors." + field);
	
	    if (!persistentSubmitErrors) {
	      result = deleteInWithCleanUp(result, "submitErrors." + field);
	    }
	
	    result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");
	
	    if (touch) {
	      result = setIn(result, "fields." + field + ".touched", true);
	      result = setIn(result, 'anyTouched', true);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.CLEAR_SUBMIT] = function (state) {
	    return deleteIn(state, 'triggerSubmit');
	  }, _behaviors[_actionTypes.CLEAR_SUBMIT_ERRORS] = function (state) {
	    var result = state;
	    result = deleteInWithCleanUp(result, 'submitErrors');
	    result = deleteIn(result, 'error');
	    return result;
	  }, _behaviors[_actionTypes.CLEAR_ASYNC_ERROR] = function (state, _ref15) {
	    var field = _ref15.meta.field;
	    return deleteIn(state, "asyncErrors." + field);
	  }, _behaviors[_actionTypes.CLEAR_FIELDS] = function (state, _ref16) {
	    var _ref16$meta = _ref16.meta,
	        keepTouched = _ref16$meta.keepTouched,
	        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
	        fields = _ref16$meta.fields;
	    var result = state;
	    fields.forEach(function (field) {
	      result = deleteInWithCleanUp(result, "asyncErrors." + field);
	
	      if (!persistentSubmitErrors) {
	        result = deleteInWithCleanUp(result, "submitErrors." + field);
	      }
	
	      result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");
	
	      if (!keepTouched) {
	        result = deleteIn(result, "fields." + field + ".touched");
	      }
	
	      var values = getIn(state, "initial." + field);
	      result = values ? setIn(result, "values." + field, values) : deleteInWithCleanUp(result, "values." + field);
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, "fields." + key + ".touched");
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }, _behaviors[_actionTypes.FOCUS] = function (state, _ref17) {
	    var field = _ref17.meta.field;
	    var result = state;
	    var previouslyActive = getIn(state, 'active');
	    result = deleteIn(result, "fields." + previouslyActive + ".active");
	    result = setIn(result, "fields." + field + ".visited", true);
	    result = setIn(result, "fields." + field + ".active", true);
	    result = setIn(result, 'active', field);
	    return result;
	  }, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref18) {
	    var payload = _ref18.payload,
	        _ref18$meta = _ref18.meta,
	        keepDirty = _ref18$meta.keepDirty,
	        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
	        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
	        keepValues = _ref18$meta.keepValues;
	    var mapData = fromJS(payload);
	    var result = empty; // clean all field state
	    // persist old warnings, they will get recalculated if the new form values are different from the old values
	
	    var warning = getIn(state, 'warning');
	
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    }
	
	    var syncWarnings = getIn(state, 'syncWarnings');
	
	    if (syncWarnings) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } // persist old errors, they will get recalculated if the new form values are different from the old values
	
	
	    var error = getIn(state, 'error');
	
	    if (error) {
	      result = setIn(result, 'error', error);
	    }
	
	    var syncErrors = getIn(state, 'syncErrors');
	
	    if (syncErrors) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    }
	
	    var registeredFields = getIn(state, 'registeredFields');
	
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	
	    var previousValues = getIn(state, 'values');
	    var previousInitialValues = getIn(state, 'initial');
	    var newInitialValues = mapData;
	    var newValues = previousValues;
	
	    if (keepDirty && registeredFields) {
	      if (!deepEqual(newInitialValues, previousInitialValues)) {
	        //
	        // Keep the value of dirty fields while updating the value of
	        // pristine fields. This way, apps can reinitialize forms while
	        // avoiding stomping on user edits.
	        //
	        // Note 1: The initialize action replaces all initial values
	        // regardless of keepDirty.
	        //
	        // Note 2: When a field is dirty, keepDirty is enabled, and the field
	        // value is the same as the new initial value for the field, the
	        // initialize action causes the field to become pristine. That effect
	        // is what we want.
	        //
	        var overwritePristineValue = function overwritePristineValue(name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	          var previousValue = getIn(previousValues, name);
	
	          if (deepEqual(previousValue, previousInitialValue)) {
	            // Overwrite the old pristine value with the new pristine value
	            var newInitialValue = getIn(newInitialValues, name); // This check prevents any 'setIn' call that would create useless
	            // nested objects, since the path to the new field value would
	            // evaluate to the same (especially for undefined values)
	
	            if (getIn(newValues, name) !== newInitialValue) {
	              newValues = setIn(newValues, name, newInitialValue);
	            }
	          }
	        };
	
	        if (!updateUnregisteredFields) {
	          forEach(keys(registeredFields), function (name) {
	            return overwritePristineValue(name);
	          });
	        }
	
	        forEach(keys(newInitialValues), function (name) {
	          var previousInitialValue = getIn(previousInitialValues, name);
	
	          if (typeof previousInitialValue === 'undefined') {
	            // Add new values at the root level.
	            var newInitialValue = getIn(newInitialValues, name);
	            newValues = setIn(newValues, name, newInitialValue);
	          }
	
	          if (updateUnregisteredFields) {
	            overwritePristineValue(name);
	          }
	        });
	      }
	    } else {
	      newValues = newInitialValues;
	    }
	
	    if (keepValues) {
	      forEach(keys(previousValues), function (name) {
	        var previousValue = getIn(previousValues, name);
	        newValues = setIn(newValues, name, previousValue);
	      });
	      forEach(keys(previousInitialValues), function (name) {
	        var previousInitialValue = getIn(previousInitialValues, name);
	        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
	      });
	    }
	
	    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
	      result = setIn(result, 'submitSucceeded', true);
	    }
	
	    result = setIn(result, 'values', newValues);
	    result = setIn(result, 'initial', newInitialValues);
	    return result;
	  }, _behaviors[_actionTypes.REGISTER_FIELD] = function (state, _ref19) {
	    var _ref19$payload = _ref19.payload,
	        name = _ref19$payload.name,
	        type = _ref19$payload.type;
	    var key = "registeredFields['" + name + "']";
	    var field = getIn(state, key);
	
	    if (field) {
	      var count = getIn(field, 'count') + 1;
	      field = setIn(field, 'count', count);
	    } else {
	      field = fromJS({
	        name: name,
	        type: type,
	        count: 1
	      });
	    }
	
	    return setIn(state, key, field);
	  }, _behaviors[_actionTypes.RESET] = function (state) {
	    var result = empty;
	    var registeredFields = getIn(state, 'registeredFields');
	
	    if (registeredFields) {
	      result = setIn(result, 'registeredFields', registeredFields);
	    }
	
	    var values = getIn(state, 'initial');
	
	    if (values) {
	      result = setIn(result, 'values', values);
	      result = setIn(result, 'initial', values);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.RESET_SECTION] = function (state, _ref20) {
	    var sections = _ref20.meta.sections;
	    var result = state;
	    sections.forEach(function (section) {
	      result = deleteInWithCleanUp(result, "asyncErrors." + section);
	      result = deleteInWithCleanUp(result, "submitErrors." + section);
	      result = deleteInWithCleanUp(result, "fields." + section);
	      var values = getIn(state, "initial." + section);
	      result = values ? setIn(result, "values." + section, values) : deleteInWithCleanUp(result, "values." + section);
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, "fields." + key + ".touched");
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }, _behaviors[_actionTypes.SUBMIT] = function (state) {
	    return setIn(state, 'triggerSubmit', true);
	  }, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref21) {
	    var field = _ref21.meta.field;
	    return setIn(state, 'asyncValidating', field || true);
	  }, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
	    return setIn(state, 'submitting', true);
	  }, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref22) {
	    var payload = _ref22.payload;
	    var result = state;
	    result = deleteIn(result, 'asyncValidating');
	
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = (0, _objectWithoutPropertiesLoose2["default"])(payload, ["_error"]);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      }
	
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
	      }
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'asyncErrors');
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref23) {
	    var payload = _ref23.payload;
	    var result = state;
	    result = deleteIn(result, 'submitting');
	    result = deleteIn(result, 'submitFailed');
	    result = deleteIn(result, 'submitSucceeded');
	
	    if (payload && Object.keys(payload).length) {
	      var _error = payload._error,
	          fieldErrors = (0, _objectWithoutPropertiesLoose2["default"])(payload, ["_error"]);
	
	      if (_error) {
	        result = setIn(result, 'error', _error);
	      } else {
	        result = deleteIn(result, 'error');
	      }
	
	      if (Object.keys(fieldErrors).length) {
	        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
	      } else {
	        result = deleteIn(result, 'submitErrors');
	      }
	
	      result = setIn(result, 'submitFailed', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'submitErrors');
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.SET_SUBMIT_FAILED] = function (state, _ref24) {
	    var fields = _ref24.meta.fields;
	    var result = state;
	    result = setIn(result, 'submitFailed', true);
	    result = deleteIn(result, 'submitSucceeded');
	    result = deleteIn(result, 'submitting');
	    fields.forEach(function (field) {
	      return result = setIn(result, "fields." + field + ".touched", true);
	    });
	
	    if (fields.length) {
	      result = setIn(result, 'anyTouched', true);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.SET_SUBMIT_SUCCEEDED] = function (state) {
	    var result = state;
	    result = deleteIn(result, 'submitFailed');
	    result = setIn(result, 'submitSucceeded', true);
	    return result;
	  }, _behaviors[_actionTypes.TOUCH] = function (state, _ref25) {
	    var fields = _ref25.meta.fields;
	    var result = state;
	    fields.forEach(function (field) {
	      return result = setIn(result, "fields." + field + ".touched", true);
	    });
	    result = setIn(result, 'anyTouched', true);
	    return result;
	  }, _behaviors[_actionTypes.UNREGISTER_FIELD] = function (state, _ref26) {
	    var _ref26$payload = _ref26.payload,
	        name = _ref26$payload.name,
	        destroyOnUnmount = _ref26$payload.destroyOnUnmount;
	    var result = state;
	    var key = "registeredFields['" + name + "']";
	    var field = getIn(result, key);
	
	    if (!field) {
	      return result;
	    }
	
	    var count = getIn(field, 'count') - 1;
	
	    if (count <= 0 && destroyOnUnmount) {
	      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
	      result = deleteIn(result, key);
	
	      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
	        result = deleteIn(result, 'registeredFields');
	      }
	
	      var syncErrors = getIn(result, 'syncErrors');
	
	      if (syncErrors) {
	        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
	
	        if (_plain["default"].deepEqual(syncErrors, _plain["default"].empty)) {
	          result = deleteIn(result, 'syncErrors');
	        } else {
	          result = setIn(result, 'syncErrors', syncErrors);
	        }
	      }
	
	      var syncWarnings = getIn(result, 'syncWarnings');
	
	      if (syncWarnings) {
	        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
	
	        if (_plain["default"].deepEqual(syncWarnings, _plain["default"].empty)) {
	          result = deleteIn(result, 'syncWarnings');
	        } else {
	          result = setIn(result, 'syncWarnings', syncWarnings);
	        }
	      }
	
	      result = deleteInWithCleanUp(result, "submitErrors." + name);
	      result = deleteInWithCleanUp(result, "asyncErrors." + name);
	    } else {
	      field = setIn(field, 'count', count);
	      result = setIn(result, key, field);
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref27) {
	    var fields = _ref27.meta.fields;
	    var result = state;
	    fields.forEach(function (field) {
	      return result = deleteIn(result, "fields." + field + ".touched");
	    });
	    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
	      return getIn(result, "fields." + key + ".touched");
	    });
	    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
	    return result;
	  }, _behaviors[_actionTypes.UPDATE_SYNC_ERRORS] = function (state, _ref28) {
	    var _ref28$payload = _ref28.payload,
	        syncErrors = _ref28$payload.syncErrors,
	        error = _ref28$payload.error;
	    var result = state;
	
	    if (error) {
	      result = setIn(result, 'error', error);
	      result = setIn(result, 'syncError', true);
	    } else {
	      result = deleteIn(result, 'error');
	      result = deleteIn(result, 'syncError');
	    }
	
	    if (Object.keys(syncErrors).length) {
	      result = setIn(result, 'syncErrors', syncErrors);
	    } else {
	      result = deleteIn(result, 'syncErrors');
	    }
	
	    return result;
	  }, _behaviors[_actionTypes.UPDATE_SYNC_WARNINGS] = function (state, _ref29) {
	    var _ref29$payload = _ref29.payload,
	        syncWarnings = _ref29$payload.syncWarnings,
	        warning = _ref29$payload.warning;
	    var result = state;
	
	    if (warning) {
	      result = setIn(result, 'warning', warning);
	    } else {
	      result = deleteIn(result, 'warning');
	    }
	
	    if (Object.keys(syncWarnings).length) {
	      result = setIn(result, 'syncWarnings', syncWarnings);
	    } else {
	      result = deleteIn(result, 'syncWarnings');
	    }
	
	    return result;
	  }, _behaviors);
	
	  var reducer = function reducer(state, action) {
	    if (state === void 0) {
	      state = empty;
	    }
	
	    var behavior = behaviors[action.type];
	    return behavior ? behavior(state, action) : state;
	  };
	
	  var byForm = function byForm(reducer) {
	    return function (state, action) {
	      if (state === void 0) {
	        state = empty;
	      }
	
	      if (action === void 0) {
	        action = {
	          type: 'NONE'
	        };
	      }
	
	      var form = action && action.meta && action.meta.form;
	
	      if (!form || !isReduxFormAction(action)) {
	        return state;
	      }
	
	      if (action.type === _actionTypes.DESTROY && action.meta && action.meta.form) {
	        return action.meta.form.reduce(function (result, form) {
	          return deleteInWithCleanUp(result, form);
	        }, state);
	      }
	
	      var formState = getIn(state, form);
	      var result = reducer(formState, action);
	      return result === formState ? state : setIn(state, form, result);
	    };
	  };
	  /**
	   * Adds additional functionality to the reducer
	   */
	
	
	  function decorate(target) {
	    target.plugin = function (reducers, config) {
	      var _this = this;
	
	      if (config === void 0) {
	        config = {};
	      }
	
	      // use 'function' keyword to enable 'this'
	      return decorate(function (state, action) {
	        if (state === void 0) {
	          state = empty;
	        }
	
	        if (action === void 0) {
	          action = {
	            type: 'NONE'
	          };
	        }
	
	        var callPlugin = function callPlugin(processed, key) {
	          var previousState = getIn(processed, key);
	          var nextState = reducers[key](previousState, action, getIn(state, key));
	          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
	        };
	
	        var processed = _this(state, action); // run through redux-form reducer
	
	
	        var form = action && action.meta && action.meta.form;
	
	        if (form && !config.receiveAllFormActions) {
	          // this is an action aimed at forms, so only give it to the specified form's plugin
	          return reducers[form] ? callPlugin(processed, form) : processed;
	        } else {
	          // this is not a form-specific action, so send it to all the plugins
	          return Object.keys(reducers).reduce(callPlugin, processed);
	        }
	      });
	    };
	
	    return target;
	  }
	
	  return decorate(byForm(reducer));
	}
	
	var _default = createReducer;
	exports["default"] = _default;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(48);
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createReduxForm;
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(143));
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(52));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(49));
	
	var _merge4 = _interopRequireDefault(__webpack_require__(576));
	
	var _mapValues2 = _interopRequireDefault(__webpack_require__(371));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(1821));
	
	var _invariant = _interopRequireDefault(__webpack_require__(32));
	
	var _isPromise = _interopRequireDefault(__webpack_require__(347));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactRedux = __webpack_require__(12);
	
	var _redux = __webpack_require__(178);
	
	var _actions = _interopRequireDefault(__webpack_require__(794));
	
	var _asyncValidation = _interopRequireDefault(__webpack_require__(1758));
	
	var _defaultShouldAsyncValidate = _interopRequireDefault(__webpack_require__(796));
	
	var _defaultShouldValidate = _interopRequireDefault(__webpack_require__(798));
	
	var _defaultShouldError = _interopRequireDefault(__webpack_require__(797));
	
	var _defaultShouldWarn = _interopRequireDefault(__webpack_require__(799));
	
	var _silenceEvent = _interopRequireDefault(__webpack_require__(801));
	
	var _silenceEvents = _interopRequireDefault(__webpack_require__(1770));
	
	var _generateValidator = _interopRequireDefault(__webpack_require__(1773));
	
	var _handleSubmit = _interopRequireDefault(__webpack_require__(1783));
	
	var _isValid = _interopRequireDefault(__webpack_require__(408));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(1818));
	
	var _isHotReloading = _interopRequireDefault(__webpack_require__(1819));
	
	var _ReduxFormContext = __webpack_require__(101);
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	}; // extract field-specific actions
	
	
	var arrayInsert = _actions["default"].arrayInsert,
	    arrayMove = _actions["default"].arrayMove,
	    arrayPop = _actions["default"].arrayPop,
	    arrayPush = _actions["default"].arrayPush,
	    arrayRemove = _actions["default"].arrayRemove,
	    arrayRemoveAll = _actions["default"].arrayRemoveAll,
	    arrayShift = _actions["default"].arrayShift,
	    arraySplice = _actions["default"].arraySplice,
	    arraySwap = _actions["default"].arraySwap,
	    arrayUnshift = _actions["default"].arrayUnshift,
	    blur = _actions["default"].blur,
	    change = _actions["default"].change,
	    focus = _actions["default"].focus,
	    formActions = (0, _objectWithoutPropertiesLoose2["default"])(_actions["default"], ["arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "blur", "change", "focus"]);
	var arrayActions = {
	  arrayInsert: arrayInsert,
	  arrayMove: arrayMove,
	  arrayPop: arrayPop,
	  arrayPush: arrayPush,
	  arrayRemove: arrayRemove,
	  arrayRemoveAll: arrayRemoveAll,
	  arrayShift: arrayShift,
	  arraySplice: arraySplice,
	  arraySwap: arraySwap,
	  arrayUnshift: arrayUnshift
	};
	var propsToNotUpdateFor = [].concat(Object.keys(_actions["default"]), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);
	
	var checkSubmit = function checkSubmit(submit) {
	  if (!submit || typeof submit !== 'function') {
	    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
	  }
	
	  return submit;
	};
	
	/**
	 * The decorator that is the main API to redux-form
	 */
	function createReduxForm(structure) {
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      setIn = structure.setIn,
	      keys = structure.keys,
	      fromJS = structure.fromJS,
	      toJS = structure.toJS;
	  var isValid = (0, _isValid["default"])(structure);
	  return function (initialConfig) {
	    var config = (0, _extends2["default"])({
	      touchOnBlur: true,
	      touchOnChange: false,
	      persistentSubmitErrors: false,
	      destroyOnUnmount: true,
	      shouldAsyncValidate: _defaultShouldAsyncValidate["default"],
	      shouldValidate: _defaultShouldValidate["default"],
	      shouldError: _defaultShouldError["default"],
	      shouldWarn: _defaultShouldWarn["default"],
	      enableReinitialize: false,
	      keepDirtyOnReinitialize: false,
	      updateUnregisteredFields: false,
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      },
	      pure: true,
	      forceUnregisterOnUnmount: false,
	      submitAsSideEffect: false
	    }, initialConfig);
	    return function (WrappedComponent) {
	      var Form = /*#__PURE__*/function (_React$Component) {
	        (0, _inheritsLoose2["default"])(Form, _React$Component);
	
	        function Form() {
	          var _this;
	
	          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	          _this.wrapped = _react["default"].createRef();
	          _this.destroyed = false;
	          _this.fieldCounts = {};
	          _this.fieldValidators = {};
	          _this.lastFieldValidatorKeys = [];
	          _this.fieldWarners = {};
	          _this.lastFieldWarnerKeys = [];
	          _this.innerOnSubmit = undefined;
	          _this.submitPromise = undefined;
	
	          _this.initIfNeeded = function (nextProps) {
	            var enableReinitialize = _this.props.enableReinitialize;
	
	            if (nextProps) {
	              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(_this.props.initialValues, nextProps.initialValues)) {
	                var _keepDirty = nextProps.initialized && _this.props.keepDirtyOnReinitialize;
	
	                _this.props.initialize(nextProps.initialValues, _keepDirty, {
	                  keepValues: nextProps.keepValues,
	                  lastInitialValues: _this.props.initialValues,
	                  updateUnregisteredFields: nextProps.updateUnregisteredFields
	                });
	              }
	            } else if (_this.props.initialValues && (!_this.props.initialized || enableReinitialize)) {
	              _this.props.initialize(_this.props.initialValues, _this.props.keepDirtyOnReinitialize, {
	                keepValues: _this.props.keepValues,
	                updateUnregisteredFields: _this.props.updateUnregisteredFields
	              });
	            }
	          };
	
	          _this.updateSyncErrorsIfNeeded = function (nextSyncErrors, nextError, lastSyncErrors) {
	            var _this$props = _this.props,
	                error = _this$props.error,
	                updateSyncErrors = _this$props.updateSyncErrors;
	            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
	            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
	
	            if (!(noErrors && nextNoErrors) && (!_plain["default"].deepEqual(lastSyncErrors, nextSyncErrors) || !_plain["default"].deepEqual(error, nextError))) {
	              updateSyncErrors(nextSyncErrors, nextError);
	            }
	          };
	
	          _this.clearSubmitPromiseIfNeeded = function (nextProps) {
	            var submitting = _this.props.submitting;
	
	            if (_this.submitPromise && submitting && !nextProps.submitting) {
	              delete _this.submitPromise;
	            }
	          };
	
	          _this.submitIfNeeded = function (nextProps) {
	            var _this$props2 = _this.props,
	                clearSubmit = _this$props2.clearSubmit,
	                triggerSubmit = _this$props2.triggerSubmit;
	
	            if (!triggerSubmit && nextProps.triggerSubmit) {
	              clearSubmit();
	
	              _this.submit();
	            }
	          };
	
	          _this.shouldErrorFunction = function () {
	            var _this$props3 = _this.props,
	                shouldValidate = _this$props3.shouldValidate,
	                shouldError = _this$props3.shouldError;
	            var shouldValidateOverridden = shouldValidate !== _defaultShouldValidate["default"];
	            var shouldErrorOverridden = shouldError !== _defaultShouldError["default"];
	            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
	          };
	
	          _this.validateIfNeeded = function (nextProps) {
	            var _this$props4 = _this.props,
	                validate = _this$props4.validate,
	                values = _this$props4.values;
	
	            var shouldError = _this.shouldErrorFunction();
	
	            var fieldLevelValidate = _this.generateValidator();
	
	            if (validate || fieldLevelValidate) {
	              var initialRender = nextProps === undefined;
	              var fieldValidatorKeys = Object.keys(_this.getValidators());
	              var validateParams = {
	                values: values,
	                nextProps: nextProps,
	                props: _this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: _this.lastFieldValidatorKeys,
	                fieldValidatorKeys: fieldValidatorKeys,
	                structure: structure
	              };
	
	              if (shouldError(validateParams)) {
	                var propsToValidate = initialRender || !nextProps ? _this.props : nextProps;
	
	                var _merge2 = (0, _merge4["default"])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
	                    _error = _merge2._error,
	                    nextSyncErrors = (0, _objectWithoutPropertiesLoose2["default"])(_merge2, ["_error"]);
	
	                _this.lastFieldValidatorKeys = fieldValidatorKeys;
	
	                _this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
	              }
	            } else {
	              _this.lastFieldValidatorKeys = [];
	            }
	          };
	
	          _this.updateSyncWarningsIfNeeded = function (nextSyncWarnings, nextWarning, lastSyncWarnings) {
	            var _this$props5 = _this.props,
	                warning = _this$props5.warning,
	                updateSyncWarnings = _this$props5.updateSyncWarnings;
	            var noWarnings = (!lastSyncWarnings || !Object.keys(lastSyncWarnings).length) && !warning;
	            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
	
	            if (!(noWarnings && nextNoWarnings) && (!_plain["default"].deepEqual(lastSyncWarnings, nextSyncWarnings) || !_plain["default"].deepEqual(warning, nextWarning))) {
	              updateSyncWarnings(nextSyncWarnings, nextWarning);
	            }
	          };
	
	          _this.shouldWarnFunction = function () {
	            var _this$props6 = _this.props,
	                shouldValidate = _this$props6.shouldValidate,
	                shouldWarn = _this$props6.shouldWarn;
	            var shouldValidateOverridden = shouldValidate !== _defaultShouldValidate["default"];
	            var shouldWarnOverridden = shouldWarn !== _defaultShouldWarn["default"];
	            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
	          };
	
	          _this.warnIfNeeded = function (nextProps) {
	            var _this$props7 = _this.props,
	                warn = _this$props7.warn,
	                values = _this$props7.values;
	
	            var shouldWarn = _this.shouldWarnFunction();
	
	            var fieldLevelWarn = _this.generateWarner();
	
	            if (warn || fieldLevelWarn) {
	              var initialRender = nextProps === undefined;
	              var fieldWarnerKeys = Object.keys(_this.getWarners());
	              var validateParams = {
	                values: values,
	                nextProps: nextProps,
	                props: _this.props,
	                initialRender: initialRender,
	                lastFieldValidatorKeys: _this.lastFieldWarnerKeys,
	                fieldValidatorKeys: fieldWarnerKeys,
	                structure: structure
	              };
	
	              if (shouldWarn(validateParams)) {
	                var propsToWarn = initialRender || !nextProps ? _this.props : nextProps;
	
	                var _merge3 = (0, _merge4["default"])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
	                    _warning = _merge3._warning,
	                    nextSyncWarnings = (0, _objectWithoutPropertiesLoose2["default"])(_merge3, ["_warning"]);
	
	                _this.lastFieldWarnerKeys = fieldWarnerKeys;
	
	                _this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
	              }
	            }
	          };
	
	          _this.getValues = function () {
	            return _this.props.values;
	          };
	
	          _this.isValid = function () {
	            return _this.props.valid;
	          };
	
	          _this.isPristine = function () {
	            return _this.props.pristine;
	          };
	
	          _this.register = function (name, type, getValidator, getWarner) {
	            var lastCount = _this.fieldCounts[name];
	            var nextCount = (lastCount || 0) + 1;
	            _this.fieldCounts[name] = nextCount;
	
	            _this.props.registerField(name, type);
	
	            if (getValidator) {
	              _this.fieldValidators[name] = getValidator;
	            }
	
	            if (getWarner) {
	              _this.fieldWarners[name] = getWarner;
	            }
	          };
	
	          _this.unregister = function (name) {
	            var lastCount = _this.fieldCounts[name];
	            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;
	
	            if (!_this.destroyed) {
	              var _this$props8 = _this.props,
	                  _destroyOnUnmount = _this$props8.destroyOnUnmount,
	                  forceUnregisterOnUnmount = _this$props8.forceUnregisterOnUnmount,
	                  unregisterField = _this$props8.unregisterField;
	
	              if (_destroyOnUnmount || forceUnregisterOnUnmount) {
	                unregisterField(name, _destroyOnUnmount);
	
	                if (!_this.fieldCounts[name]) {
	                  delete _this.fieldValidators[name];
	                  delete _this.fieldWarners[name];
	                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
	                    return key !== name;
	                  });
	                }
	              } else {
	                unregisterField(name, false);
	              }
	            }
	          };
	
	          _this.getFieldList = function (options) {
	            var registeredFields = _this.props.registeredFields;
	
	            if (!registeredFields) {
	              return [];
	            }
	
	            var keySeq = keys(registeredFields);
	
	            if (options) {
	              if (options.excludeFieldArray) {
	                keySeq = keySeq.filter(function (name) {
	                  return getIn(registeredFields, "['" + name + "'].type") !== 'FieldArray';
	                });
	              }
	
	              if (options.excludeUnregistered) {
	                keySeq = keySeq.filter(function (name) {
	                  return getIn(registeredFields, "['" + name + "'].count") !== 0;
	                });
	              }
	            }
	
	            return toJS(keySeq);
	          };
	
	          _this.getValidators = function () {
	            var validators = {};
	            Object.keys(_this.fieldValidators).forEach(function (name) {
	              var validator = _this.fieldValidators[name]();
	
	              if (validator) {
	                validators[name] = validator;
	              }
	            });
	            return validators;
	          };
	
	          _this.generateValidator = function () {
	            var validators = _this.getValidators();
	
	            return Object.keys(validators).length ? (0, _generateValidator["default"])(validators, structure) : undefined;
	          };
	
	          _this.getWarners = function () {
	            var warners = {};
	            Object.keys(_this.fieldWarners).forEach(function (name) {
	              var warner = _this.fieldWarners[name]();
	
	              if (warner) {
	                warners[name] = warner;
	              }
	            });
	            return warners;
	          };
	
	          _this.generateWarner = function () {
	            var warners = _this.getWarners();
	
	            return Object.keys(warners).length ? (0, _generateValidator["default"])(warners, structure) : undefined;
	          };
	
	          _this.asyncValidate = function (name, value, trigger) {
	            var _this$props9 = _this.props,
	                asyncBlurFields = _this$props9.asyncBlurFields,
	                asyncChangeFields = _this$props9.asyncChangeFields,
	                asyncErrors = _this$props9.asyncErrors,
	                asyncValidate = _this$props9.asyncValidate,
	                dispatch = _this$props9.dispatch,
	                initialized = _this$props9.initialized,
	                pristine = _this$props9.pristine,
	                shouldAsyncValidate = _this$props9.shouldAsyncValidate,
	                startAsyncValidation = _this$props9.startAsyncValidation,
	                stopAsyncValidation = _this$props9.stopAsyncValidation,
	                syncErrors = _this$props9.syncErrors,
	                values = _this$props9.values;
	            var submitting = !name;
	
	            var fieldNeedsValidation = function fieldNeedsValidation() {
	              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+]/g, '[]'));
	              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+]/g, '[]'));
	              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);
	              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
	            };
	
	            if (asyncValidate) {
	              var valuesToValidate = submitting ? values : setIn(values, name, value);
	              var syncValidationPasses = submitting || !getIn(syncErrors, name);
	
	              if (fieldNeedsValidation() && shouldAsyncValidate({
	                asyncErrors: asyncErrors,
	                initialized: initialized,
	                trigger: submitting ? 'submit' : trigger,
	                blurredField: name,
	                pristine: pristine,
	                syncValidationPasses: syncValidationPasses
	              })) {
	                return (0, _asyncValidation["default"])(function () {
	                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
	                }, startAsyncValidation, stopAsyncValidation, name);
	              }
	            }
	          };
	
	          _this.submitCompleted = function (result) {
	            delete _this.submitPromise;
	            return result;
	          };
	
	          _this.submitFailed = function (error) {
	            delete _this.submitPromise;
	            throw error;
	          };
	
	          _this.listenToSubmit = function (promise) {
	            if (!(0, _isPromise["default"])(promise)) {
	              return promise;
	            }
	
	            _this.submitPromise = promise;
	            return promise.then(_this.submitCompleted, _this.submitFailed);
	          };
	
	          _this.submit = function (submitOrEvent) {
	            var _this$props10 = _this.props,
	                onSubmit = _this$props10.onSubmit,
	                blur = _this$props10.blur,
	                change = _this$props10.change,
	                dispatch = _this$props10.dispatch;
	
	            if (!submitOrEvent || (0, _silenceEvent["default"])(submitOrEvent)) {
	              // submitOrEvent is an event: fire submit if not already submitting
	              if (!_this.submitPromise) {
	                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
	                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
	                  // will call "submitOrEvent is the submit function" block below
	                  return _this.innerOnSubmit();
	                } else {
	                  return _this.listenToSubmit((0, _handleSubmit["default"])(checkSubmit(onSubmit), (0, _extends2["default"])({}, _this.props, {}, (0, _redux.bindActionCreators)({
	                    blur: blur,
	                    change: change
	                  }, dispatch)), // TODO: fix type, should be `Props`
	                  _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({
	                    excludeFieldArray: true,
	                    excludeUnregistered: true
	                  })));
	                }
	              }
	            } else {
	              // submitOrEvent is the submit function: return deferred submit thunk
	              return (0, _silenceEvents["default"])(function () {
	                return !_this.submitPromise && _this.listenToSubmit((0, _handleSubmit["default"])(checkSubmit(submitOrEvent), (0, _extends2["default"])({}, _this.props, {}, (0, _redux.bindActionCreators)({
	                  blur: blur,
	                  change: change
	                }, dispatch)), // TODO: fix type, should be `Props`
	                _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({
	                  excludeFieldArray: true,
	                  excludeUnregistered: true
	                })));
	              });
	            }
	          };
	
	          _this.reset = function () {
	            return _this.props.reset();
	          };
	
	          return _this;
	        }
	
	        var _proto = Form.prototype;
	
	        _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
	          if (!(0, _isHotReloading["default"])()) {
	            this.initIfNeeded();
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	
	          (0, _invariant["default"])(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v9.0.0. Use shouldWarn() or shouldError() instead.');
	        };
	
	        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	          this.initIfNeeded(nextProps);
	          this.validateIfNeeded(nextProps);
	          this.warnIfNeeded(nextProps);
	          this.clearSubmitPromiseIfNeeded(nextProps);
	          this.submitIfNeeded(nextProps);
	          var onChange = nextProps.onChange,
	              values = nextProps.values,
	              dispatch = nextProps.dispatch;
	
	          if (onChange && !deepEqual(values, this.props.values)) {
	            onChange(values, dispatch, nextProps, this.props.values);
	          }
	        };
	
	        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	          var _this2 = this;
	
	          if (!this.props.pure) return true;
	          var _config$immutableProp = config.immutableProps,
	              immutableProps = _config$immutableProp === void 0 ? [] : _config$immutableProp; // if we have children, we MUST update in React 16
	          // https://twitter.com/erikras/status/915866544558788608
	
	          return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
	            // useful to debug rerenders
	            // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
	            //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
	            // }
	            if (~immutableProps.indexOf(prop)) {
	              return _this2.props[prop] !== nextProps[prop];
	            }
	
	            return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
	          }));
	        };
	
	        _proto.componentDidMount = function componentDidMount() {
	          if (!(0, _isHotReloading["default"])()) {
	            this.initIfNeeded(this.props);
	            this.validateIfNeeded();
	            this.warnIfNeeded();
	          }
	
	          (0, _invariant["default"])(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v9.0.0. Use shouldWarn() or shouldError() instead.');
	        };
	
	        _proto.componentWillUnmount = function componentWillUnmount() {
	          var _this$props11 = this.props,
	              destroyOnUnmount = _this$props11.destroyOnUnmount,
	              destroy = _this$props11.destroy;
	
	          if (destroyOnUnmount && !(0, _isHotReloading["default"])()) {
	            this.destroyed = true;
	            destroy();
	          }
	        };
	
	        _proto.render = function render() {
	          var _ref,
	              _this3 = this;
	
	          // remove some redux-form config-only props
	
	          /* eslint-disable no-unused-vars */
	          var _this$props12 = this.props,
	              anyTouched = _this$props12.anyTouched,
	              array = _this$props12.array,
	              arrayInsert = _this$props12.arrayInsert,
	              arrayMove = _this$props12.arrayMove,
	              arrayPop = _this$props12.arrayPop,
	              arrayPush = _this$props12.arrayPush,
	              arrayRemove = _this$props12.arrayRemove,
	              arrayRemoveAll = _this$props12.arrayRemoveAll,
	              arrayShift = _this$props12.arrayShift,
	              arraySplice = _this$props12.arraySplice,
	              arraySwap = _this$props12.arraySwap,
	              arrayUnshift = _this$props12.arrayUnshift,
	              asyncErrors = _this$props12.asyncErrors,
	              asyncValidate = _this$props12.asyncValidate,
	              asyncValidating = _this$props12.asyncValidating,
	              blur = _this$props12.blur,
	              change = _this$props12.change,
	              clearSubmit = _this$props12.clearSubmit,
	              destroy = _this$props12.destroy,
	              destroyOnUnmount = _this$props12.destroyOnUnmount,
	              forceUnregisterOnUnmount = _this$props12.forceUnregisterOnUnmount,
	              dirty = _this$props12.dirty,
	              dispatch = _this$props12.dispatch,
	              enableReinitialize = _this$props12.enableReinitialize,
	              error = _this$props12.error,
	              focus = _this$props12.focus,
	              form = _this$props12.form,
	              getFormState = _this$props12.getFormState,
	              immutableProps = _this$props12.immutableProps,
	              initialize = _this$props12.initialize,
	              initialized = _this$props12.initialized,
	              initialValues = _this$props12.initialValues,
	              invalid = _this$props12.invalid,
	              keepDirtyOnReinitialize = _this$props12.keepDirtyOnReinitialize,
	              keepValues = _this$props12.keepValues,
	              updateUnregisteredFields = _this$props12.updateUnregisteredFields,
	              pristine = _this$props12.pristine,
	              propNamespace = _this$props12.propNamespace,
	              registeredFields = _this$props12.registeredFields,
	              registerField = _this$props12.registerField,
	              reset = _this$props12.reset,
	              resetSection = _this$props12.resetSection,
	              setSubmitFailed = _this$props12.setSubmitFailed,
	              setSubmitSucceeded = _this$props12.setSubmitSucceeded,
	              shouldAsyncValidate = _this$props12.shouldAsyncValidate,
	              shouldValidate = _this$props12.shouldValidate,
	              shouldError = _this$props12.shouldError,
	              shouldWarn = _this$props12.shouldWarn,
	              startAsyncValidation = _this$props12.startAsyncValidation,
	              startSubmit = _this$props12.startSubmit,
	              stopAsyncValidation = _this$props12.stopAsyncValidation,
	              stopSubmit = _this$props12.stopSubmit,
	              submitAsSideEffect = _this$props12.submitAsSideEffect,
	              submitting = _this$props12.submitting,
	              submitFailed = _this$props12.submitFailed,
	              submitSucceeded = _this$props12.submitSucceeded,
	              touch = _this$props12.touch,
	              touchOnBlur = _this$props12.touchOnBlur,
	              touchOnChange = _this$props12.touchOnChange,
	              persistentSubmitErrors = _this$props12.persistentSubmitErrors,
	              syncErrors = _this$props12.syncErrors,
	              syncWarnings = _this$props12.syncWarnings,
	              unregisterField = _this$props12.unregisterField,
	              untouch = _this$props12.untouch,
	              updateSyncErrors = _this$props12.updateSyncErrors,
	              updateSyncWarnings = _this$props12.updateSyncWarnings,
	              valid = _this$props12.valid,
	              validExceptSubmit = _this$props12.validExceptSubmit,
	              values = _this$props12.values,
	              warning = _this$props12.warning,
	              rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props12, ["anyTouched", "array", "arrayInsert", "arrayMove", "arrayPop", "arrayPush", "arrayRemove", "arrayRemoveAll", "arrayShift", "arraySplice", "arraySwap", "arrayUnshift", "asyncErrors", "asyncValidate", "asyncValidating", "blur", "change", "clearSubmit", "destroy", "destroyOnUnmount", "forceUnregisterOnUnmount", "dirty", "dispatch", "enableReinitialize", "error", "focus", "form", "getFormState", "immutableProps", "initialize", "initialized", "initialValues", "invalid", "keepDirtyOnReinitialize", "keepValues", "updateUnregisteredFields", "pristine", "propNamespace", "registeredFields", "registerField", "reset", "resetSection", "setSubmitFailed", "setSubmitSucceeded", "shouldAsyncValidate", "shouldValidate", "shouldError", "shouldWarn", "startAsyncValidation", "startSubmit", "stopAsyncValidation", "stopSubmit", "submitAsSideEffect", "submitting", "submitFailed", "submitSucceeded", "touch", "touchOnBlur", "touchOnChange", "persistentSubmitErrors", "syncErrors", "syncWarnings", "unregisterField", "untouch", "updateSyncErrors", "updateSyncWarnings", "valid", "validExceptSubmit", "values", "warning"]);
	          /* eslint-enable no-unused-vars */
	
	          var reduxFormProps = (0, _extends2["default"])({
	            array: array,
	            anyTouched: anyTouched,
	            asyncValidate: this.asyncValidate,
	            asyncValidating: asyncValidating
	          }, (0, _redux.bindActionCreators)({
	            blur: blur,
	            change: change
	          }, dispatch), {
	            clearSubmit: clearSubmit,
	            destroy: destroy,
	            dirty: dirty,
	            dispatch: dispatch,
	            error: error,
	            form: form,
	            handleSubmit: this.submit,
	            initialize: initialize,
	            initialized: initialized,
	            initialValues: initialValues,
	            invalid: invalid,
	            pristine: pristine,
	            reset: reset,
	            resetSection: resetSection,
	            submitting: submitting,
	            submitAsSideEffect: submitAsSideEffect,
	            submitFailed: submitFailed,
	            submitSucceeded: submitSucceeded,
	            touch: touch,
	            untouch: untouch,
	            valid: valid,
	            warning: warning
	          });
	          var propsToPass = (0, _extends2["default"])({}, propNamespace ? (_ref = {}, _ref[propNamespace] = reduxFormProps, _ref) : reduxFormProps, {}, rest);
	
	          if (isClassComponent(WrappedComponent)) {
	            ;
	            propsToPass.ref = this.wrapped;
	          }
	
	          var _reduxForm = (0, _extends2["default"])({}, this.props, {
	            getFormState: function getFormState(state) {
	              return getIn(_this3.props.getFormState(state), _this3.props.form);
	            },
	            asyncValidate: this.asyncValidate,
	            getValues: this.getValues,
	            sectionPrefix: undefined,
	            register: this.register,
	            unregister: this.unregister,
	            registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
	              return _this3.innerOnSubmit = innerOnSubmit;
	            }
	          });
	
	          return (0, _react.createElement)(_ReduxFormContext.ReduxFormContext.Provider, {
	            value: _reduxForm,
	            children: (0, _react.createElement)(WrappedComponent, propsToPass)
	          });
	        };
	
	        return Form;
	      }(_react["default"].Component);
	
	      Form.displayName = "Form(" + (0, _getDisplayName["default"])(WrappedComponent) + ")";
	      Form.WrappedComponent = WrappedComponent;
	      Form.propTypes = {
	        destroyOnUnmount: _propTypes["default"].bool,
	        forceUnregisterOnUnmount: _propTypes["default"].bool,
	        form: _propTypes["default"].string.isRequired,
	        immutableProps: _propTypes["default"].arrayOf(_propTypes["default"].string),
	        initialValues: _propTypes["default"].oneOfType([_propTypes["default"].array, _propTypes["default"].object]),
	        getFormState: _propTypes["default"].func,
	        onSubmitFail: _propTypes["default"].func,
	        onSubmitSuccess: _propTypes["default"].func,
	        propNamespace: _propTypes["default"].string,
	        validate: _propTypes["default"].func,
	        warn: _propTypes["default"].func,
	        touchOnBlur: _propTypes["default"].bool,
	        touchOnChange: _propTypes["default"].bool,
	        triggerSubmit: _propTypes["default"].bool,
	        persistentSubmitErrors: _propTypes["default"].bool,
	        registeredFields: _propTypes["default"].any
	      };
	      var connector = (0, _reactRedux.connect)(function (state, props) {
	        var form = props.form,
	            getFormState = props.getFormState,
	            initialValues = props.initialValues,
	            enableReinitialize = props.enableReinitialize,
	            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;
	        var formState = getIn(getFormState(state) || empty, form) || empty;
	        var stateInitial = getIn(formState, 'initial');
	        var initialized = !!stateInitial;
	        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
	        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;
	        var initial = initialValues || stateInitial || empty;
	
	        if (!shouldUpdateInitialValues) {
	          initial = stateInitial || empty;
	        }
	
	        var values = getIn(formState, 'values') || initial;
	
	        if (shouldResetValues) {
	          values = initial;
	        }
	
	        var pristine = shouldResetValues || deepEqual(initial, values);
	        var asyncErrors = getIn(formState, 'asyncErrors');
	
	        var syncErrors = getIn(formState, 'syncErrors') || _plain["default"].empty;
	
	        var syncWarnings = getIn(formState, 'syncWarnings') || _plain["default"].empty;
	
	        var registeredFields = getIn(formState, 'registeredFields');
	        var valid = isValid(form, getFormState, false)(state);
	        var validExceptSubmit = isValid(form, getFormState, true)(state);
	        var anyTouched = !!getIn(formState, 'anyTouched');
	        var submitting = !!getIn(formState, 'submitting');
	        var submitFailed = !!getIn(formState, 'submitFailed');
	        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
	        var error = getIn(formState, 'error');
	        var warning = getIn(formState, 'warning');
	        var triggerSubmit = getIn(formState, 'triggerSubmit');
	        return {
	          anyTouched: anyTouched,
	          asyncErrors: asyncErrors,
	          asyncValidating: getIn(formState, 'asyncValidating') || false,
	          dirty: !pristine,
	          error: error,
	          initialized: initialized,
	          invalid: !valid,
	          pristine: pristine,
	          registeredFields: registeredFields,
	          submitting: submitting,
	          submitFailed: submitFailed,
	          submitSucceeded: submitSucceeded,
	          syncErrors: syncErrors,
	          syncWarnings: syncWarnings,
	          triggerSubmit: triggerSubmit,
	          values: values,
	          valid: valid,
	          validExceptSubmit: validExceptSubmit,
	          warning: warning
	        };
	      }, function (dispatch, initialProps) {
	        var bindForm = function bindForm(actionCreator) {
	          return actionCreator.bind(null, initialProps.form);
	        }; // Bind the first parameter on `props.form`
	
	
	        var boundFormACs = (0, _mapValues2["default"])(formActions, bindForm);
	        var boundArrayACs = (0, _mapValues2["default"])(arrayActions, bindForm);
	
	        var boundBlur = function boundBlur(field, value) {
	          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
	        };
	
	        var boundChange = function boundChange(field, value) {
	          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
	        };
	
	        var boundFocus = bindForm(focus); // Wrap action creators with `dispatch`
	
	        var connectedFormACs = (0, _redux.bindActionCreators)(boundFormACs, dispatch);
	        var connectedArrayACs = {
	          insert: (0, _redux.bindActionCreators)(boundArrayACs.arrayInsert, dispatch),
	          move: (0, _redux.bindActionCreators)(boundArrayACs.arrayMove, dispatch),
	          pop: (0, _redux.bindActionCreators)(boundArrayACs.arrayPop, dispatch),
	          push: (0, _redux.bindActionCreators)(boundArrayACs.arrayPush, dispatch),
	          remove: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemove, dispatch),
	          removeAll: (0, _redux.bindActionCreators)(boundArrayACs.arrayRemoveAll, dispatch),
	          shift: (0, _redux.bindActionCreators)(boundArrayACs.arrayShift, dispatch),
	          splice: (0, _redux.bindActionCreators)(boundArrayACs.arraySplice, dispatch),
	          swap: (0, _redux.bindActionCreators)(boundArrayACs.arraySwap, dispatch),
	          unshift: (0, _redux.bindActionCreators)(boundArrayACs.arrayUnshift, dispatch)
	        };
	        return (0, _extends2["default"])({}, connectedFormACs, {}, boundArrayACs, {
	          blur: boundBlur,
	          change: boundChange,
	          array: connectedArrayACs,
	          focus: boundFocus,
	          dispatch: dispatch
	        });
	      }, undefined, {
	        forwardRef: true
	      });
	      var ConnectedForm = (0, _hoistNonReactStatics["default"])(connector(Form), WrappedComponent);
	      ConnectedForm.defaultProps = config; // build outer component to expose instance api
	
	      var ReduxForm = /*#__PURE__*/function (_React$Component2) {
	        (0, _inheritsLoose2["default"])(ReduxForm, _React$Component2);
	
	        function ReduxForm() {
	          var _this4;
	
	          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }
	
	          _this4 = _React$Component2.call.apply(_React$Component2, [this].concat(args)) || this;
	          _this4.ref = _react["default"].createRef();
	          return _this4;
	        }
	
	        var _proto2 = ReduxForm.prototype;
	
	        _proto2.submit = function submit() {
	          return this.ref.current && this.ref.current.submit();
	        };
	
	        _proto2.reset = function reset() {
	          if (this.ref) {
	            this.ref.current.reset();
	          }
	        };
	
	        _proto2.render = function render() {
	          var _this$props13 = this.props,
	              initialValues = _this$props13.initialValues,
	              rest = (0, _objectWithoutPropertiesLoose2["default"])(_this$props13, ["initialValues"]);
	          return (0, _react.createElement)(ConnectedForm, (0, _extends2["default"])({}, rest, {
	            ref: this.ref,
	            // convert initialValues if need to
	            initialValues: fromJS(initialValues)
	          }));
	        };
	
	        (0, _createClass2["default"])(ReduxForm, [{
	          key: "valid",
	          get: function get() {
	            return !!(this.ref.current && this.ref.current.isValid());
	          }
	        }, {
	          key: "invalid",
	          get: function get() {
	            return !this.valid;
	          }
	        }, {
	          key: "pristine",
	          get: function get() {
	            return !!(this.ref.current && this.ref.current.isPristine());
	          }
	        }, {
	          key: "dirty",
	          get: function get() {
	            return !this.pristine;
	          }
	        }, {
	          key: "values",
	          get: function get() {
	            return this.ref.current ? this.ref.current.getValues() : empty;
	          }
	        }, {
	          key: "fieldList",
	          get: function get() {
	            // mainly provided for testing
	            return this.ref.current ? this.ref.current.getFieldList() : [];
	          }
	        }, {
	          key: "wrappedInstance",
	          get: function get() {
	            // for testing
	            return this.ref.current && this.ref.current.wrapped.current;
	          }
	        }]);
	        return ReduxForm;
	      }(_react["default"].Component);
	
	      var WithContext = (0, _hoistNonReactStatics["default"])((0, _ReduxFormContext.withReduxForm)(ReduxForm), WrappedComponent);
	      WithContext.defaultProps = config;
	      return WithContext;
	    };
	  };
	}

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createValues;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _reactRedux = __webpack_require__(12);
	
	function createValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (config) {
	    var _prop$getFormState$co = (0, _extends2["default"])({
	      prop: 'values',
	      getFormState: function getFormState(state) {
	        return getIn(state, 'form');
	      }
	    }, config),
	        form = _prop$getFormState$co.form,
	        prop = _prop$getFormState$co.prop,
	        getFormState = _prop$getFormState$co.getFormState;
	
	    return (0, _reactRedux.connect)(function (state) {
	      var _ref2;
	
	      return _ref2 = {}, _ref2[prop] = getIn(getFormState(state), form + ".values"), _ref2;
	    } // ignore dispatch
	    );
	  };
	}

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(268));
	
	function createDeleteInWithCleanUp(structure) {
	  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
	    return function (state, path) {
	      return structure.getIn(state, path) !== undefined;
	    };
	  };
	
	  var deepEqual = structure.deepEqual,
	      empty = structure.empty,
	      getIn = structure.getIn,
	      deleteIn = structure.deleteIn,
	      setIn = structure.setIn;
	  return function (shouldDelete) {
	    if (shouldDelete === void 0) {
	      shouldDelete = shouldDeleteDefault;
	    }
	
	    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
	      if (path[path.length - 1] === ']') {
	        // array path
	        var pathTokens = (0, _toPath2["default"])(path);
	        pathTokens.pop();
	        var parent = getIn(state, pathTokens.join('.'));
	        return parent ? setIn(state, path) : state;
	      }
	
	      var result = state;
	
	      if (shouldDelete(structure)(state, path)) {
	        result = deleteIn(state, path);
	      }
	
	      var dotIndex = path.lastIndexOf('.');
	
	      if (dotIndex > 0) {
	        var parentPath = path.substring(0, dotIndex);
	
	        if (parentPath[parentPath.length - 1] !== ']') {
	          var _parent = getIn(result, parentPath);
	
	          if (deepEqual(_parent, empty)) {
	            return deleteInWithCleanUp(result, parentPath);
	          }
	        }
	      }
	
	      return result;
	    };
	
	    return deleteInWithCleanUp;
	  };
	}
	
	var _default = createDeleteInWithCleanUp;
	exports["default"] = _default;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isEvent = _interopRequireDefault(__webpack_require__(407));
	
	var getSelectedValues = function getSelectedValues(options) {
	  var result = [];
	
	  if (options) {
	    for (var index = 0; index < options.length; index++) {
	      var option = options[index];
	
	      if (option.selected) {
	        result.push(option.value);
	      }
	    }
	  }
	
	  return result;
	};
	
	var getValue = function getValue(event, isReactNative) {
	  if ((0, _isEvent["default"])(event)) {
	    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
	      return event.nativeEvent.text;
	    }
	
	    if (isReactNative && event.nativeEvent !== undefined) {
	      return event.nativeEvent.text;
	    }
	
	    var detypedEvent = event;
	    var _detypedEvent$target = detypedEvent.target,
	        type = _detypedEvent$target.type,
	        value = _detypedEvent$target.value,
	        checked = _detypedEvent$target.checked,
	        files = _detypedEvent$target.files,
	        dataTransfer = detypedEvent.dataTransfer;
	
	    if (type === 'checkbox') {
	      return !!checked;
	    }
	
	    if (type === 'file') {
	      return files || dataTransfer && dataTransfer.files;
	    }
	
	    if (type === 'select-multiple') {
	      return getSelectedValues(event.target.options);
	    }
	
	    return value;
	  }
	
	  return event;
	};
	
	var _default = getValue;
	exports["default"] = _default;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _silenceEvent = _interopRequireDefault(__webpack_require__(801));
	
	var silenceEvents = function silenceEvents(fn) {
	  return function (event) {
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return (0, _silenceEvent["default"])(event) ? fn.apply(void 0, args) : fn.apply(void 0, [event].concat(args));
	  };
	};
	
	var _default = silenceEvents;
	exports["default"] = _default;

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFormValueSelector = _interopRequireDefault(__webpack_require__(1763));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _createFormValueSelector["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createFormValues = _interopRequireDefault(__webpack_require__(1764));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _createFormValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = generateValidator;
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var toArray = function toArray(value) {
	  return Array.isArray(value) ? value : [value];
	};
	
	var getError = function getError(value, values, props, validators, name) {
	  var array = toArray(validators);
	
	  for (var i = 0; i < array.length; i++) {
	    var error = array[i](value, values, props, name);
	
	    if (error) {
	      return error;
	    }
	  }
	};
	
	function generateValidator(validators, _ref) {
	  var getIn = _ref.getIn;
	  return function (values, props) {
	    var errors = {};
	    Object.keys(validators).forEach(function (name) {
	      var value = getIn(values, name);
	      var error = getError(value, values, props, validators[name], name);
	
	      if (error) {
	        errors = _plain["default"].setIn(errors, name, error);
	      }
	    });
	    return errors;
	  };
	}

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormAsyncErrors = _interopRequireDefault(__webpack_require__(1796));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _getFormAsyncErrors["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormError = _interopRequireDefault(__webpack_require__(1797));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _getFormError["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormInitialValues = _interopRequireDefault(__webpack_require__(1798));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _getFormInitialValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormMeta = _interopRequireDefault(__webpack_require__(1799));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _getFormMeta["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormNames = _interopRequireDefault(__webpack_require__(1800));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _getFormNames["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1779 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormSubmitErrors = _interopRequireDefault(__webpack_require__(1801));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _getFormSubmitErrors["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormSyncErrors = _interopRequireDefault(__webpack_require__(1802));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _getFormSyncErrors["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormSyncWarnings = _interopRequireDefault(__webpack_require__(1803));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _getFormSyncWarnings["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1782 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _getFormValues = _interopRequireDefault(__webpack_require__(1804));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _getFormValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Promise) {"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(40));
	
	var _isPromise = _interopRequireDefault(__webpack_require__(347));
	
	var _SubmissionError = __webpack_require__(793);
	
	var mergeErrors = function mergeErrors(_ref) {
	  var asyncErrors = _ref.asyncErrors,
	      syncErrors = _ref.syncErrors;
	  return asyncErrors && typeof asyncErrors.merge === 'function' ? asyncErrors.merge(syncErrors).toJS() : (0, _extends2["default"])({}, asyncErrors, {}, syncErrors);
	};
	
	var executeSubmit = function executeSubmit(submit, fields, props) {
	  var dispatch = props.dispatch,
	      submitAsSideEffect = props.submitAsSideEffect,
	      onSubmitFail = props.onSubmitFail,
	      onSubmitSuccess = props.onSubmitSuccess,
	      startSubmit = props.startSubmit,
	      stopSubmit = props.stopSubmit,
	      setSubmitFailed = props.setSubmitFailed,
	      setSubmitSucceeded = props.setSubmitSucceeded,
	      values = props.values;
	  var result;
	
	  try {
	    result = submit(values, dispatch, props);
	  } catch (submitError) {
	    var error = (0, _SubmissionError.isSubmissionError)(submitError) ? submitError.errors : undefined;
	    stopSubmit(error);
	    setSubmitFailed.apply(void 0, fields);
	
	    if (onSubmitFail) {
	      onSubmitFail(error, dispatch, submitError, props);
	    }
	
	    if (error || onSubmitFail) {
	      // if you've provided an onSubmitFail callback, don't re-throw the error
	      return error;
	    } else {
	      throw submitError;
	    }
	  }
	
	  if (submitAsSideEffect) {
	    if (result) {
	      dispatch(result);
	    }
	  } else {
	    if ((0, _isPromise["default"])(result)) {
	      startSubmit();
	      return result.then(function (submitResult) {
	        stopSubmit();
	        setSubmitSucceeded();
	
	        if (onSubmitSuccess) {
	          onSubmitSuccess(submitResult, dispatch, props);
	        }
	
	        return submitResult;
	      }, function (submitError) {
	        var error = (0, _SubmissionError.isSubmissionError)(submitError) ? submitError.errors : undefined;
	        stopSubmit(error);
	        setSubmitFailed.apply(void 0, fields);
	
	        if (onSubmitFail) {
	          onSubmitFail(error, dispatch, submitError, props);
	        }
	
	        if (error || onSubmitFail) {
	          // if you've provided an onSubmitFail callback, don't re-throw the error
	          return error;
	        } else {
	          throw submitError;
	        }
	      });
	    } else {
	      setSubmitSucceeded();
	
	      if (onSubmitSuccess) {
	        onSubmitSuccess(result, dispatch, props);
	      }
	    }
	  }
	
	  return result;
	};
	
	var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
	  var dispatch = props.dispatch,
	      onSubmitFail = props.onSubmitFail,
	      setSubmitFailed = props.setSubmitFailed,
	      syncErrors = props.syncErrors,
	      asyncErrors = props.asyncErrors,
	      touch = props.touch,
	      persistentSubmitErrors = props.persistentSubmitErrors;
	  touch.apply(void 0, fields);
	
	  if (valid || persistentSubmitErrors) {
	    var asyncValidateResult = asyncValidate && asyncValidate();
	
	    if (asyncValidateResult) {
	      return asyncValidateResult.then(function (asyncErrors) {
	        if (asyncErrors) {
	          throw asyncErrors;
	        }
	
	        return executeSubmit(submit, fields, props);
	      })["catch"](function (asyncErrors) {
	        setSubmitFailed.apply(void 0, fields);
	
	        if (onSubmitFail) {
	          onSubmitFail(asyncErrors, dispatch, null, props);
	        }
	
	        return Promise.reject(asyncErrors);
	      });
	    } else {
	      return executeSubmit(submit, fields, props);
	    }
	  } else {
	    setSubmitFailed.apply(void 0, fields);
	    var errors = mergeErrors({
	      asyncErrors: asyncErrors,
	      syncErrors: syncErrors
	    });
	
	    if (onSubmitFail) {
	      onSubmitFail(errors, dispatch, null, props);
	    }
	
	    return errors;
	  }
	};
	
	var _default = handleSubmit;
	exports["default"] = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createHasError;
	
	var getErrorKeys = function getErrorKeys(name, type) {
	  switch (type) {
	    case 'Field':
	      return [name, name + "._error"];
	
	    case 'FieldArray':
	      return [name + "._error"];
	
	    default:
	      throw new Error('Unknown field type');
	  }
	};
	
	function createHasError(_ref) {
	  var getIn = _ref.getIn;
	  return function (field, syncErrors, asyncErrors, submitErrors) {
	    if (!syncErrors && !asyncErrors && !submitErrors) {
	      return false;
	    }
	
	    var name = getIn(field, 'name');
	    var type = getIn(field, 'type');
	    return getErrorKeys(name, type).some(function (key) {
	      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
	    });
	  };
	}

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _hasSubmitFailed = _interopRequireDefault(__webpack_require__(1805));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _hasSubmitFailed["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _hasSubmitSucceeded = _interopRequireDefault(__webpack_require__(1806));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _hasSubmitSucceeded["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isAsyncValidating = _interopRequireDefault(__webpack_require__(1807));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _isAsyncValidating["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isDirty = _interopRequireDefault(__webpack_require__(1808));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _isDirty["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isInvalid = _interopRequireDefault(__webpack_require__(1809));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _isInvalid["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isPristine = _interopRequireDefault(__webpack_require__(803));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _isPristine["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isSubmitting = _interopRequireDefault(__webpack_require__(1810));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _isSubmitting["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isValid = _interopRequireDefault(__webpack_require__(408));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _isValid["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = exports.fieldArrayPropTypes = exports.fieldPropTypes = exports.fieldArrayFieldsPropTypes = exports.fieldArrayMetaPropTypes = exports.fieldMetaPropTypes = exports.fieldInputPropTypes = exports.formPropTypes = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var any = _propTypes["default"].any,
	    bool = _propTypes["default"].bool,
	    func = _propTypes["default"].func,
	    shape = _propTypes["default"].shape,
	    string = _propTypes["default"].string,
	    oneOfType = _propTypes["default"].oneOfType,
	    object = _propTypes["default"].object,
	    number = _propTypes["default"].number;
	var formPropTypes = {
	  // State:
	  anyTouched: bool.isRequired,
	  // true if any of the fields have been marked as touched
	  asyncValidating: oneOfType([bool, string]).isRequired,
	  // true if async validation is running, a string if a field triggered async validation
	  dirty: bool.isRequired,
	  // true if any values are different from initialValues
	  error: any,
	  // form-wide error from '_error' key in validation result
	  form: string.isRequired,
	  // the name of the form
	  invalid: bool.isRequired,
	  // true if there are any validation errors
	  initialized: bool.isRequired,
	  // true if the form has been initialized
	  initialValues: object,
	  // the initialValues object passed to reduxForm
	  pristine: bool.isRequired,
	  // true if the values are the same as initialValues
	  pure: bool.isRequired,
	  // if true, implements shouldComponentUpdate
	  submitting: bool.isRequired,
	  // true if the form is in the process of being submitted
	  submitAsSideEffect: bool.isRequired,
	  // true if onSubmit result will be dispatched
	  submitFailed: bool.isRequired,
	  // true if the form was submitted and failed for any reason
	  submitSucceeded: bool.isRequired,
	  // true if the form was successfully submitted
	  valid: bool.isRequired,
	  // true if there are no validation errors
	  warning: any,
	  // form-wide warning from '_warning' key in validation result
	  // Actions:
	  array: shape({
	    insert: func.isRequired,
	    // function to insert a value into an array field
	    move: func.isRequired,
	    // function to move a value within an array field
	    pop: func.isRequired,
	    // function to pop a value off of an array field
	    push: func.isRequired,
	    // function to push a value onto an array field
	    remove: func.isRequired,
	    // function to remove a value from an array field
	    removeAll: func.isRequired,
	    // function to remove all the values from an array field
	    shift: func.isRequired,
	    // function to shift a value out of an array field
	    splice: func.isRequired,
	    // function to splice a value into an array field
	    swap: func.isRequired,
	    // function to swap values in an array field
	    unshift: func.isRequired // function to unshift a value into an array field
	
	  }),
	  asyncValidate: func.isRequired,
	  // function to trigger async validation
	  autofill: func.isRequired,
	  // action to set a value of a field and mark it as autofilled
	  blur: func.isRequired,
	  // action to mark a field as blurred
	  change: func.isRequired,
	  // action to change the value of a field
	  clearAsyncError: func.isRequired,
	  // action to clear the async error of a field
	  clearFields: func.isRequired,
	  // action to clean fields values for all fields
	  clearSubmitErrors: func.isRequired,
	  // action to remove submitErrors and error
	  destroy: func.isRequired,
	  // action to destroy the form's data in Redux
	  dispatch: func.isRequired,
	  // the Redux dispatch action
	  handleSubmit: func.isRequired,
	  // function to submit the form
	  initialize: func.isRequired,
	  // action to initialize form data
	  reset: func.isRequired,
	  // action to reset the form data to previously initialized values
	  resetSection: func.isRequired,
	  // action to reset the form sections data to previously initialized values
	  touch: func.isRequired,
	  // action to mark fields as touched
	  submit: func.isRequired,
	  // action to trigger a submission of the specified form
	  untouch: func.isRequired,
	  // action to mark fields as untouched
	  // triggerSubmit
	  triggerSubmit: bool,
	  // if true, submits the form on componentWillReceiveProps
	  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
	
	};
	exports.formPropTypes = formPropTypes;
	var fieldInputPropTypes = {
	  checked: bool,
	  name: string.isRequired,
	  onBlur: func.isRequired,
	  onChange: func.isRequired,
	  onDragStart: func.isRequired,
	  onDrop: func.isRequired,
	  onFocus: func.isRequired,
	  value: any
	};
	exports.fieldInputPropTypes = fieldInputPropTypes;
	var fieldMetaPropTypes = {
	  active: bool.isRequired,
	  asyncValidating: bool.isRequired,
	  autofilled: bool.isRequired,
	  dirty: bool.isRequired,
	  dispatch: func.isRequired,
	  error: any,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitting: bool.isRequired,
	  submitFailed: bool.isRequired,
	  touched: bool.isRequired,
	  valid: bool.isRequired,
	  visited: bool.isRequired,
	  warning: string
	};
	exports.fieldMetaPropTypes = fieldMetaPropTypes;
	var fieldArrayMetaPropTypes = {
	  dirty: bool.isRequired,
	  error: any,
	  form: string.isRequired,
	  invalid: bool.isRequired,
	  pristine: bool.isRequired,
	  submitFailed: bool,
	  submitting: bool,
	  valid: bool.isRequired,
	  warning: string
	};
	exports.fieldArrayMetaPropTypes = fieldArrayMetaPropTypes;
	var fieldArrayFieldsPropTypes = {
	  name: string.isRequired,
	  forEach: func.isRequired,
	  get: func.isRequired,
	  getAll: func.isRequired,
	  insert: func.isRequired,
	  length: number.isRequired,
	  map: func.isRequired,
	  move: func.isRequired,
	  pop: func.isRequired,
	  push: func.isRequired,
	  reduce: func.isRequired,
	  remove: func.isRequired,
	  removeAll: func.isRequired,
	  shift: func.isRequired,
	  swap: func.isRequired,
	  unshift: func.isRequired
	};
	exports.fieldArrayFieldsPropTypes = fieldArrayFieldsPropTypes;
	var fieldPropTypes = {
	  input: shape(fieldInputPropTypes).isRequired,
	  meta: shape(fieldMetaPropTypes).isRequired
	};
	exports.fieldPropTypes = fieldPropTypes;
	var fieldArrayPropTypes = {
	  fields: shape(fieldArrayFieldsPropTypes).isRequired,
	  meta: shape(fieldArrayMetaPropTypes).isRequired
	};
	exports.fieldArrayPropTypes = fieldArrayPropTypes;
	var _default = formPropTypes;
	exports["default"] = _default;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createReducer = _interopRequireDefault(__webpack_require__(1765));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _createReducer["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createReduxForm = _interopRequireDefault(__webpack_require__(1766));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _createReduxForm["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1796 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormAsyncErrors;
	
	function createGetFormAsyncErrors(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".asyncErrors");
	    };
	  };
	}

/***/ }),
/* 1797 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormError;
	
	function createGetFormError(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".error");
	    };
	  };
	}

/***/ }),
/* 1798 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormInitialValues;
	
	function createGetFormInitialValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".initial");
	    };
	  };
	}

/***/ }),
/* 1799 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormMeta;
	
	function createGetFormMeta(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".fields") || empty;
	    };
	  };
	}

/***/ }),
/* 1800 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormNames;
	
	function createGetFormNames(_ref) {
	  var getIn = _ref.getIn,
	      keys = _ref.keys;
	  return function (getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return keys(nonNullGetFormState(state));
	    };
	  };
	}

/***/ }),
/* 1801 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormSubmitErrors;
	
	function createGetFormSubmitErrors(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".submitErrors") || empty;
	    };
	  };
	}

/***/ }),
/* 1802 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormSyncErrors;
	
	function createGetFormSyncErrors(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".syncErrors") || empty;
	    };
	  };
	}

/***/ }),
/* 1803 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormSyncWarnings;
	
	function createGetFormSyncWarnings(_ref) {
	  var getIn = _ref.getIn,
	      empty = _ref.empty;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".syncWarnings") || empty;
	    };
	  };
	}

/***/ }),
/* 1804 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createGetFormValues;
	
	function createGetFormValues(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return getIn(nonNullGetFormState(state), form + ".values");
	    };
	  };
	}

/***/ }),
/* 1805 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createHasSubmitFailed;
	
	function createHasSubmitFailed(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".submitFailed");
	    };
	  };
	}

/***/ }),
/* 1806 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createHasSubmitSucceeded;
	
	function createHasSubmitSucceeded(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".submitSucceeded");
	    };
	  };
	}

/***/ }),
/* 1807 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createIsAsyncValidating;
	
	function createIsAsyncValidating(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".asyncValidating");
	    };
	  };
	}

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createIsDirty;
	
	var _isPristine = _interopRequireDefault(__webpack_require__(803));
	
	function createIsDirty(structure) {
	  return function (form, getFormState) {
	    var isPristine = (0, _isPristine["default"])(structure)(form, getFormState);
	    return function (state) {
	      for (var _len = arguments.length, fields = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        fields[_key - 1] = arguments[_key];
	      }
	
	      return !isPristine.apply(void 0, [state].concat(fields));
	    };
	  };
	}

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = createIsInvalid;
	
	var _isValid = _interopRequireDefault(__webpack_require__(408));
	
	function createIsInvalid(structure) {
	  return function (form, getFormState) {
	    var isValid = (0, _isValid["default"])(structure)(form, getFormState);
	    return function (state) {
	      return !isValid(state);
	    };
	  };
	}

/***/ }),
/* 1810 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = createIsSubmitting;
	
	function createIsSubmitting(_ref) {
	  var getIn = _ref.getIn;
	  return function (form, getFormState) {
	    return function (state) {
	      var nonNullGetFormState = getFormState || function (state) {
	        return getIn(state, 'form');
	      };
	
	      return !!getIn(nonNullGetFormState(state), form + ".submitting");
	    };
	  };
	}

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _isNil2 = _interopRequireDefault(__webpack_require__(1500));
	
	var _isEqualWith2 = _interopRequireDefault(__webpack_require__(574));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var isEmpty = function isEmpty(obj) {
	  return (0, _isNil2["default"])(obj) || obj === '' || isNaN(obj);
	};
	
	var customizer = function customizer(obj, other) {
	  if (obj === other) return true;
	
	  if (!obj && !other) {
	    return isEmpty(obj) === isEmpty(other);
	  }
	
	  if (obj && other && obj._error !== other._error) return false;
	  if (obj && other && obj._warning !== other._warning) return false;
	  if (_react["default"].isValidElement(obj) || _react["default"].isValidElement(other)) return false;
	};
	
	var deepEqual = function deepEqual(a, b) {
	  return (0, _isEqualWith2["default"])(a, b, customizer);
	};
	
	var _default = deepEqual;
	exports["default"] = _default;

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(40));
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(268));
	
	function deleteInWithPath(state, first) {
	  if (state === undefined || state === null || first === undefined || first === null) {
	    return state;
	  }
	
	  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    rest[_key - 2] = arguments[_key];
	  }
	
	  if (rest.length) {
	    if (Array.isArray(state)) {
	      if (isNaN(first)) {
	        throw new Error("Must access array elements with a number, not \"" + String(first) + "\".");
	      }
	
	      var firstIndex = Number(first);
	
	      if (firstIndex < state.length) {
	        var result = deleteInWithPath.apply(void 0, [state && state[firstIndex]].concat(rest));
	
	        if (result !== state[firstIndex]) {
	          var copy = [].concat(state);
	          copy[firstIndex] = result;
	          return copy;
	        }
	      }
	
	      return state;
	    }
	
	    if (first in state) {
	      var _extends2;
	
	      var _result = deleteInWithPath.apply(void 0, [state && state[first]].concat(rest));
	
	      return state[first] === _result ? state : (0, _extends3["default"])({}, state, (_extends2 = {}, _extends2[first] = _result, _extends2));
	    }
	
	    return state;
	  }
	
	  if (Array.isArray(state)) {
	    if (isNaN(first)) {
	      throw new Error("Cannot delete non-numerical index from an array. Given: \"" + String(first));
	    }
	
	    var _firstIndex = Number(first);
	
	    if (_firstIndex < state.length) {
	      var _copy = [].concat(state);
	
	      _copy.splice(_firstIndex, 1);
	
	      return _copy;
	    }
	
	    return state;
	  }
	
	  if (first in state) {
	    var _copy2 = (0, _extends3["default"])({}, state);
	
	    delete _copy2[first];
	    return _copy2;
	  }
	
	  return state;
	}
	
	var deleteIn = function deleteIn(state, field) {
	  return deleteInWithPath.apply(void 0, [state].concat((0, _toPath2["default"])(field)));
	};
	
	var _default = deleteIn;
	exports["default"] = _default;

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(268));
	
	var getIn = function getIn(state, field) {
	  if (!state) {
	    return state;
	  }
	
	  var path = (0, _toPath2["default"])(field);
	  var length = path.length;
	
	  if (!length) {
	    return undefined;
	  }
	
	  var result = state;
	
	  for (var i = 0; i < length && result; ++i) {
	    result = result[path[i]];
	  }
	
	  return result;
	};
	
	var _default = getIn;
	exports["default"] = _default;

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	function keys(value) {
	  if (!value) {
	    return [];
	  }
	
	  if (Array.isArray(value)) {
	    return value.map(function (i) {
	      return i.name;
	    });
	  }
	
	  return Object.keys(value);
	}
	
	var _default = keys;
	exports["default"] = _default;

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _extends3 = _interopRequireDefault(__webpack_require__(40));
	
	var _toPath2 = _interopRequireDefault(__webpack_require__(268));
	
	var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
	  var _extends2;
	
	  if (pathIndex >= path.length) {
	    return value;
	  }
	
	  var first = path[pathIndex];
	  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
	  var next = setInWithPath(firstState, value, path, pathIndex + 1);
	
	  if (!state) {
	    if (isNaN(first)) {
	      var _ref;
	
	      return _ref = {}, _ref[first] = next, _ref;
	    }
	
	    var initialized = [];
	    initialized[parseInt(first, 10)] = next;
	    return initialized;
	  }
	
	  if (Array.isArray(state)) {
	    var copy = [].concat(state);
	    copy[parseInt(first, 10)] = next;
	    return copy;
	  }
	
	  return (0, _extends3["default"])({}, state, (_extends2 = {}, _extends2[first] = next, _extends2));
	};
	
	var setIn = function setIn(state, field, value) {
	  return setInWithPath(state, value, (0, _toPath2["default"])(field), 0);
	};
	
	var _default = setIn;
	exports["default"] = _default;

/***/ }),
/* 1816 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var splice = function splice(array, index, removeNum, value) {
	  array = array || [];
	
	  if (index < array.length) {
	    if (value === undefined && !removeNum) {
	      // inserting undefined
	      var _copy2 = [].concat(array);
	
	      _copy2.splice(index, 0, true); // temporary placeholder
	
	
	      _copy2[index] = undefined; // set to undefined
	
	      return _copy2;
	    }
	
	    if (value != null) {
	      var _copy3 = [].concat(array);
	
	      _copy3.splice(index, removeNum, value); // removing and adding
	
	
	      return _copy3;
	    }
	
	    var _copy = [].concat(array);
	
	    _copy.splice(index, removeNum); // removing
	
	
	    return _copy;
	  }
	
	  if (removeNum) {
	    // trying to remove non-existant item: return original array
	    return array;
	  } // trying to add outside of range: just set value
	
	
	  var copy = [].concat(array);
	  copy[index] = value;
	  return copy;
	};
	
	var _default = splice;
	exports["default"] = _default;

/***/ }),
/* 1817 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.dataKey = void 0;
	var dataKey = 'text';
	exports.dataKey = dataKey;

/***/ }),
/* 1818 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var getDisplayName = function getDisplayName(Comp) {
	  return Comp.displayName || Comp.name || 'Component';
	};
	
	var _default = getDisplayName;
	exports["default"] = _default;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var isHotReloading = function isHotReloading() {
	  var castModule = module;
	  return !!(typeof castModule !== 'undefined' && castModule.hot && typeof castModule.hot.status === 'function' && castModule.hot.status() === 'apply');
	};
	
	var _default = isHotReloading;
	exports["default"] = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(102)(module)))

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(16);
	
	exports.__esModule = true;
	exports["default"] = void 0;
	
	var _createValues = _interopRequireDefault(__webpack_require__(1767));
	
	var _plain = _interopRequireDefault(__webpack_require__(26));
	
	var _default = (0, _createValues["default"])(_plain["default"]);
	
	exports["default"] = _default;

/***/ }),
/* 1821 */
[1911, 212],
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1823 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function createThunkMiddleware(extraArgument) {
	  return function (_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        if (typeof action === 'function') {
	          return action(dispatch, getState, extraArgument);
	        }
	
	        return next(action);
	      };
	    };
	  };
	}
	
	var thunk = createThunkMiddleware();
	thunk.withExtraArgument = createThunkMiddleware;
	
	exports['default'] = thunk;

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(805);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 1825 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(806);
	
	var _isPlainObject = __webpack_require__(265);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(807);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(340);
	var callBind = __webpack_require__(1314);
	
	var implementation = __webpack_require__(808);
	var getPolyfill = __webpack_require__(809);
	var shim = __webpack_require__(1828);
	
	var flagsBound = callBind(implementation);
	
	define(flagsBound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = flagsBound;


/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var supportsDescriptors = __webpack_require__(340).supportsDescriptors;
	var getPolyfill = __webpack_require__(809);
	var gOPD = Object.getOwnPropertyDescriptor;
	var defineProperty = Object.defineProperty;
	var TypeErr = TypeError;
	var getProto = Object.getPrototypeOf;
	var regex = /a/;
	
	module.exports = function shimFlags() {
		if (!supportsDescriptors || !getProto) {
			throw new TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
		}
		var polyfill = getPolyfill();
		var proto = getProto(regex);
		var descriptor = gOPD(proto, 'flags');
		if (!descriptor || descriptor.get !== polyfill) {
			defineProperty(proto, 'flags', {
				configurable: true,
				enumerable: false,
				get: polyfill
			});
		}
		return polyfill;
	};


/***/ }),
/* 1829 */
/***/ (function(module, exports) {

	/** @license React v0.18.0
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
	exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(1829);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),
/* 1831 */
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),
/* 1832 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1300);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {"hmr":true}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(142)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js?outputStyle=expanded!./payStyles.css", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/postcss-loader/index.js!../../../node_modules/sass-loader/index.js?outputStyle=expanded!./payStyles.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1301);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {"hmr":true}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(142)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js?outputStyle=expanded!./main.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js?outputStyle=expanded!./main.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1302);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {"hmr":true}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(142)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js?outputStyle=expanded!./orgChartCustomStyles.css", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/postcss-loader/index.js!../../node_modules/sass-loader/index.js?outputStyle=expanded!./orgChartCustomStyles.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1304);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {"hmr":true}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(142)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?outputStyle=expanded!./styles.scss", function() {
				var newContent = require("!!../../../../node_modules/css-loader/index.js!../../../../node_modules/postcss-loader/index.js!../../../../node_modules/sass-loader/index.js?outputStyle=expanded!./styles.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(1305);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// Prepare cssTransformation
	var transform;
	
	var options = {"hmr":true}
	options.transform = transform
	// add the styles to the DOM
	var update = __webpack_require__(142)(content, options);
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../css-loader/index.js?modules!./flexboxgrid2.css", function() {
				var newContent = require("!!../css-loader/index.js?modules!./flexboxgrid2.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 1838 */
/***/ (function(module, exports) {

	
	/**
	 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
	 * embed the css on the page. This breaks all relative urls because now they are relative to a
	 * bundle instead of the current page.
	 *
	 * One solution is to only use full urls, but that may be impossible.
	 *
	 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
	 *
	 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
	 *
	 */
	
	module.exports = function (css) {
	  // get current location
	  var location = typeof window !== "undefined" && window.location;
	
	  if (!location) {
	    throw new Error("fixUrls requires window.location");
	  }
	
		// blank or null?
		if (!css || typeof css !== "string") {
		  return css;
	  }
	
	  var baseUrl = location.protocol + "//" + location.host;
	  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");
	
		// convert each url(...)
		/*
		This regular expression is just a way to recursively match brackets within
		a string.
	
		 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
		   (  = Start a capturing group
		     (?:  = Start a non-capturing group
		         [^)(]  = Match anything that isn't a parentheses
		         |  = OR
		         \(  = Match a start parentheses
		             (?:  = Start another non-capturing groups
		                 [^)(]+  = Match anything that isn't a parentheses
		                 |  = OR
		                 \(  = Match a start parentheses
		                     [^)(]*  = Match anything that isn't a parentheses
		                 \)  = Match a end parentheses
		             )  = End Group
	              *\) = Match anything and then a close parens
	          )  = Close non-capturing group
	          *  = Match anything
	       )  = Close capturing group
		 \)  = Match a close parens
	
		 /gi  = Get all matches, not the first.  Be case insensitive.
		 */
		var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
			// strip quotes (if they exist)
			var unquotedOrigUrl = origUrl
				.trim()
				.replace(/^"(.*)"$/, function(o, $1){ return $1; })
				.replace(/^'(.*)'$/, function(o, $1){ return $1; });
	
			// already a full url? no change
			if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
			  return fullMatch;
			}
	
			// convert the url to a full url
			var newUrl;
	
			if (unquotedOrigUrl.indexOf("//") === 0) {
			  	//TODO: should we add protocol?
				newUrl = unquotedOrigUrl;
			} else if (unquotedOrigUrl.indexOf("/") === 0) {
				// path should be relative to the base url
				newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
			} else {
				// path should be relative to current directory
				newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
			}
	
			// send back the fixed url(...)
			return "url(" + JSON.stringify(newUrl) + ")";
		});
	
		// send back the fixed css
		return fixedCss;
	};


/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(1840);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(102)(module)))

/***/ }),
/* 1840 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

	
	var space = __webpack_require__(1843)
	
	/**
	 * Export.
	 */
	
	module.exports = toCamelCase
	
	/**
	 * Convert a `string` to camel case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toCamelCase(string) {
	  return space(string).replace(/\s(\w)/g, function (matches, letter) {
	    return letter.toUpperCase()
	  })
	}


/***/ }),
/* 1842 */
/***/ (function(module, exports) {

	
	/**
	 * Export.
	 */
	
	module.exports = toNoCase
	
	/**
	 * Test whether a string is camel-case.
	 */
	
	var hasSpace = /\s/
	var hasSeparator = /(_|-|\.|:)/
	var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/
	
	/**
	 * Remove any starting case from a `string`, like camel or snake, but keep
	 * spaces and punctuation that may be important otherwise.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toNoCase(string) {
	  if (hasSpace.test(string)) return string.toLowerCase()
	  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase()
	  if (hasCamel.test(string)) return uncamelize(string).toLowerCase()
	  return string.toLowerCase()
	}
	
	/**
	 * Separator splitter.
	 */
	
	var separatorSplitter = /[\W_]+(.|$)/g
	
	/**
	 * Un-separate a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function unseparate(string) {
	  return string.replace(separatorSplitter, function (m, next) {
	    return next ? ' ' + next : ''
	  })
	}
	
	/**
	 * Camelcase splitter.
	 */
	
	var camelSplitter = /(.)([A-Z]+)/g
	
	/**
	 * Un-camelcase a `string`.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function uncamelize(string) {
	  return string.replace(camelSplitter, function (m, previous, uppers) {
	    return previous + ' ' + uppers.toLowerCase().split('').join(' ')
	  })
	}


/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

	
	var clean = __webpack_require__(1842)
	
	/**
	 * Export.
	 */
	
	module.exports = toSpaceCase
	
	/**
	 * Convert a `string` to space case.
	 *
	 * @param {String} string
	 * @return {String}
	 */
	
	function toSpaceCase(string) {
	  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
	    return match ? ' ' + match : ''
	  }).trim()
	}


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "7d7436265ee212b42a486015152d8aea.png";

/***/ }),
/* 1845 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAGQCAYAAABvWArbAAAAMElEQVQ4je3LIQ4AIBTD0O3f/8wrFgmKhMy8pKJKwkhSKeVbbGuAPU9f4PIopTxgAeS0DRtI4yK0AAAAAElFTkSuQmCC"

/***/ }),
/* 1846 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

	/*
	
	JSZip - A Javascript class for generating and reading zip files
	<http://stuartk.com/jszip>
	
	(c) 2009-2014 Stuart Knightley <stuart [at] stuartk.com>
	Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/master/LICENSE.markdown.
	
	JSZip uses the library pako released under the MIT license :
	https://github.com/nodeca/pako/blob/master/LICENSE
	
	Note: since JSZip 3 removed critical functionality, this version assigns to the
	`JSZipSync` variable.  Another JSZip version can be loaded in parallel.
	*/
	(function(e){
		if("object"==typeof exports&&"undefined"!=typeof module&&"undefined"==typeof DO_NOT_EXPORT_JSZIP)module.exports=e();
		else if("function"==typeof define&&define.amd&&"undefined"==typeof DO_NOT_EXPORT_JSZIP){JSZipSync=e();define('j',[],e);}
		else{
			var f;
			"undefined"!=typeof globalThis?f=globalThis:
			"undefined"!=typeof window?f=window:
			"undefined"!=typeof global?f=global:
			"undefined"!=typeof $ && $.global?f=$.global:
			"undefined"!=typeof self&&(f=self),f.JSZipSync=e()
		}
	}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);throw new Error("Cannot find module '"+o+"'")}var f=n[o]={exports:{}};t[o][0].call(f.exports,function(e){var n=t[o][1][e];return s(n?n:e)},f,f.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	'use strict';
	// private property
	var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
	
	
	// public method for encoding
	exports.encode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    while (i < input.length) {
	
	        chr1 = input.charCodeAt(i++);
	        chr2 = input.charCodeAt(i++);
	        chr3 = input.charCodeAt(i++);
	
	        enc1 = chr1 >> 2;
	        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
	        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
	        enc4 = chr3 & 63;
	
	        if (isNaN(chr2)) {
	            enc3 = enc4 = 64;
	        }
	        else if (isNaN(chr3)) {
	            enc4 = 64;
	        }
	
	        output = output + _keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4);
	
	    }
	
	    return output;
	};
	
	// public method for decoding
	exports.decode = function(input, utf8) {
	    var output = "";
	    var chr1, chr2, chr3;
	    var enc1, enc2, enc3, enc4;
	    var i = 0;
	
	    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
	
	    while (i < input.length) {
	
	        enc1 = _keyStr.indexOf(input.charAt(i++));
	        enc2 = _keyStr.indexOf(input.charAt(i++));
	        enc3 = _keyStr.indexOf(input.charAt(i++));
	        enc4 = _keyStr.indexOf(input.charAt(i++));
	
	        chr1 = (enc1 << 2) | (enc2 >> 4);
	        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
	        chr3 = ((enc3 & 3) << 6) | enc4;
	
	        output = output + String.fromCharCode(chr1);
	
	        if (enc3 != 64) {
	            output = output + String.fromCharCode(chr2);
	        }
	        if (enc4 != 64) {
	            output = output + String.fromCharCode(chr3);
	        }
	
	    }
	
	    return output;
	
	};
	
	},{}],2:[function(_dereq_,module,exports){
	'use strict';
	function CompressedObject() {
	    this.compressedSize = 0;
	    this.uncompressedSize = 0;
	    this.crc32 = 0;
	    this.compressionMethod = null;
	    this.compressedContent = null;
	}
	
	CompressedObject.prototype = {
	    /**
	     * Return the decompressed content in an unspecified format.
	     * The format will depend on the decompressor.
	     * @return {Object} the decompressed content.
	     */
	    getContent: function() {
	        return null; // see implementation
	    },
	    /**
	     * Return the compressed content in an unspecified format.
	     * The format will depend on the compressed conten source.
	     * @return {Object} the compressed content.
	     */
	    getCompressedContent: function() {
	        return null; // see implementation
	    }
	};
	module.exports = CompressedObject;
	
	},{}],3:[function(_dereq_,module,exports){
	'use strict';
	exports.STORE = {
	    magic: "\x00\x00",
	    compress: function(content) {
	        return content; // no compression
	    },
	    uncompress: function(content) {
	        return content; // no compression
	    },
	    compressInputType: null,
	    uncompressInputType: null
	};
	exports.DEFLATE = _dereq_('./flate');
	
	},{"./flate":8}],4:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	
	var table = [
	    0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA,
	    0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
	    0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988,
	    0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91,
	    0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE,
	    0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
	    0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC,
	    0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5,
	    0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172,
	    0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B,
	    0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940,
	    0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59,
	    0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116,
	    0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
	    0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924,
	    0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
	    0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A,
	    0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
	    0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818,
	    0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01,
	    0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E,
	    0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457,
	    0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C,
	    0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65,
	    0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2,
	    0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB,
	    0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0,
	    0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9,
	    0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086,
	    0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F,
	    0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4,
	    0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD,
	    0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A,
	    0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683,
	    0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8,
	    0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1,
	    0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE,
	    0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7,
	    0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC,
	    0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5,
	    0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252,
	    0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B,
	    0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60,
	    0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79,
	    0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236,
	    0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F,
	    0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04,
	    0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D,
	    0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A,
	    0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713,
	    0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38,
	    0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21,
	    0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E,
	    0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777,
	    0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C,
	    0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45,
	    0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2,
	    0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB,
	    0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0,
	    0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9,
	    0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6,
	    0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF,
	    0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94,
	    0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D
	];
	
	/**
	 *
	 *  Javascript crc32
	 *  http://www.webtoolkit.info/
	 *
	 */
	module.exports = function crc32(input, crc) {
	    if (typeof input === "undefined" || !input.length) {
	        return 0;
	    }
	
	    var isArray = utils.getTypeOf(input) !== "string";
	
	    if (typeof(crc) == "undefined") {
	        crc = 0;
	    }
	    var x = 0;
	    var y = 0;
	    var b = 0;
	
	    crc = crc ^ (-1);
	    for (var i = 0, iTop = input.length; i < iTop; i++) {
	        b = isArray ? input[i] : input.charCodeAt(i);
	        y = (crc ^ b) & 0xFF;
	        x = table[y];
	        crc = (crc >>> 8) ^ x;
	    }
	
	    return crc ^ (-1);
	};
	// vim: set shiftwidth=4 softtabstop=4:
	
	},{"./utils":21}],5:[function(_dereq_,module,exports){
	'use strict';
	var utils = _dereq_('./utils');
	
	function DataReader(data) {
	    this.data = null; // type : see implementation
	    this.length = 0;
	    this.index = 0;
	}
	DataReader.prototype = {
	    /**
	     * Check that the offset will not go too far.
	     * @param {string} offset the additional offset to check.
	     * @throws {Error} an Error if the offset is out of bounds.
	     */
	    checkOffset: function(offset) {
	        this.checkIndex(this.index + offset);
	    },
	    /**
	     * Check that the specifed index will not be too far.
	     * @param {string} newIndex the index to check.
	     * @throws {Error} an Error if the index is out of bounds.
	     */
	    checkIndex: function(newIndex) {
	        if (this.length < newIndex || newIndex < 0) {
	            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
	        }
	    },
	    /**
	     * Change the index.
	     * @param {number} newIndex The new index.
	     * @throws {Error} if the new index is out of the data.
	     */
	    setIndex: function(newIndex) {
	        this.checkIndex(newIndex);
	        this.index = newIndex;
	    },
	    /**
	     * Skip the next n bytes.
	     * @param {number} n the number of bytes to skip.
	     * @throws {Error} if the new index is out of the data.
	     */
	    skip: function(n) {
	        this.setIndex(this.index + n);
	    },
	    /**
	     * Get the byte at the specified index.
	     * @param {number} i the index to use.
	     * @return {number} a byte.
	     */
	    byteAt: function(i) {
	        // see implementations
	    },
	    /**
	     * Get the next number with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {number} the corresponding number.
	     */
	    readInt: function(size) {
	        var result = 0,
	            i;
	        this.checkOffset(size);
	        for (i = this.index + size - 1; i >= this.index; i--) {
	            result = (result << 8) + this.byteAt(i);
	        }
	        this.index += size;
	        return result;
	    },
	    /**
	     * Get the next string with a given byte size.
	     * @param {number} size the number of bytes to read.
	     * @return {string} the corresponding string.
	     */
	    readString: function(size) {
	        return utils.transformTo("string", this.readData(size));
	    },
	    /**
	     * Get raw data without conversion, <size> bytes.
	     * @param {number} size the number of bytes to read.
	     * @return {Object} the raw data, implementation specific.
	     */
	    readData: function(size) {
	        // see implementations
	    },
	    /**
	     * Find the last occurrence of a zip signature (4 bytes).
	     * @param {string} sig the signature to find.
	     * @return {number} the index of the last occurrence, -1 if not found.
	     */
	    lastIndexOfSignature: function(sig) {
	        // see implementations
	    },
	    /**
	     * Get the next date.
	     * @return {Date} the date.
	     */
	    readDate: function() {
	        var dostime = this.readInt(4);
	        return new Date(
	        ((dostime >> 25) & 0x7f) + 1980, // year
	        ((dostime >> 21) & 0x0f) - 1, // month
	        (dostime >> 16) & 0x1f, // day
	        (dostime >> 11) & 0x1f, // hour
	        (dostime >> 5) & 0x3f, // minute
	        (dostime & 0x1f) << 1); // second
	    }
	};
	module.exports = DataReader;
	
	},{"./utils":21}],6:[function(_dereq_,module,exports){
	'use strict';
	exports.base64 = false;
	exports.binary = false;
	exports.dir = false;
	exports.createFolders = false;
	exports.date = null;
	exports.compression = null;
	exports.comment = null;
	
	},{}],7:[function(_dereq_,module,exports){
	'use strict';
	var utils = _dereq_('./utils');
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2binary = function(str) {
	    return utils.string2binary(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Uint8Array = function(str) {
	    return utils.transformTo("uint8array", str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.uint8Array2String = function(array) {
	    return utils.transformTo("string", array);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.string2Blob = function(str) {
	    var buffer = utils.transformTo("arraybuffer", str);
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.arrayBuffer2Blob = function(buffer) {
	    return utils.arrayBuffer2Blob(buffer);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.transformTo = function(outputType, input) {
	    return utils.transformTo(outputType, input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.getTypeOf = function(input) {
	    return utils.getTypeOf(input);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.checkSupport = function(type) {
	    return utils.checkSupport(type);
	};
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_16BITS = utils.MAX_VALUE_16BITS;
	
	/**
	 * @deprecated
	 * This value will be removed in a future version without replacement.
	 */
	exports.MAX_VALUE_32BITS = utils.MAX_VALUE_32BITS;
	
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.pretty = function(str) {
	    return utils.pretty(str);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.findCompression = function(compressionMethod) {
	    return utils.findCompression(compressionMethod);
	};
	
	/**
	 * @deprecated
	 * This function will be removed in a future version without replacement.
	 */
	exports.isRegExp = function (object) {
	    return utils.isRegExp(object);
	};
	
	
	},{"./utils":21}],8:[function(_dereq_,module,exports){
	'use strict';
	var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');
	
	var pako = _dereq_("pako");
	exports.uncompressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	exports.compressInputType = USE_TYPEDARRAY ? "uint8array" : "array";
	
	exports.magic = "\x08\x00";
	exports.compress = function(input) {
	    return pako.deflateRaw(input);
	};
	exports.uncompress =  function(input) {
	    return pako.inflateRaw(input);
	};
	
	},{"pako":24}],9:[function(_dereq_,module,exports){
	'use strict';
	
	var base64 = _dereq_('./base64');
	
	/**
	Usage:
	   zip = new JSZip();
	   zip.file("hello.txt", "Hello, World!").file("tempfile", "nothing");
	   zip.folder("images").file("smile.gif", base64Data, {base64: true});
	   zip.file("Xmas.txt", "Ho ho ho !", {date : new Date("December 25, 2007 00:00:01")});
	   zip.remove("tempfile");
	
	   base64zip = zip.generate();
	
	**/
	
	/**
	 * Representation a of zip file in js
	 * @constructor
	 * @param {String=|ArrayBuffer=|Uint8Array=} data the data to load, if any (optional).
	 * @param {Object=} options the options for creating this objects (optional).
	 */
	function JSZipSync(data, options) {
	    // if this constructor is used without `new`, it adds `new` before itself:
	    if(!(this instanceof JSZipSync)) return new JSZipSync(data, options);
	
	    // object containing the files :
	    // {
	    //   "folder/" : {...},
	    //   "folder/data.txt" : {...}
	    // }
	    this.files = {};
	
	    this.comment = null;
	
	    // Where we are in the hierarchy
	    this.root = "";
	    if (data) {
	        this.load(data, options);
	    }
	    this.clone = function() {
	        var newObj = new JSZipSync();
	        for (var i in this) {
	            if (typeof this[i] !== "function") {
	                newObj[i] = this[i];
	            }
	        }
	        return newObj;
	    };
	}
	JSZipSync.prototype = _dereq_('./object');
	JSZipSync.prototype.load = _dereq_('./load');
	JSZipSync.support = _dereq_('./support');
	JSZipSync.defaults = _dereq_('./defaults');
	
	/**
	 * @deprecated
	 * This namespace will be removed in a future version without replacement.
	 */
	JSZipSync.utils = _dereq_('./deprecatedPublicUtils');
	
	JSZipSync.base64 = {
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    encode : function(input) {
	        return base64.encode(input);
	    },
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    decode : function(input) {
	        return base64.decode(input);
	    }
	};
	JSZipSync.compressions = _dereq_('./compressions');
	module.exports = JSZipSync;
	
	},{"./base64":1,"./compressions":3,"./defaults":6,"./deprecatedPublicUtils":7,"./load":10,"./object":13,"./support":17}],10:[function(_dereq_,module,exports){
	'use strict';
	var base64 = _dereq_('./base64');
	var ZipEntries = _dereq_('./zipEntries');
	module.exports = function(data, options) {
	    var files, zipEntries, i, input;
	    options = options || {};
	    if (options.base64) {
	        data = base64.decode(data);
	    }
	
	    zipEntries = new ZipEntries(data, options);
	    files = zipEntries.files;
	    for (i = 0; i < files.length; i++) {
	        input = files[i];
	        this.file(input.fileName, input.decompressed, {
	            binary: true,
	            optimizedBinaryString: true,
	            date: input.date,
	            dir: input.dir,
	            comment : input.fileComment.length ? input.fileComment : null,
	            createFolders: options.createFolders
	        });
	    }
	    if (zipEntries.zipComment.length) {
	        this.comment = zipEntries.zipComment;
	    }
	
	    return this;
	};
	
	},{"./base64":1,"./zipEntries":22}],11:[function(_dereq_,module,exports){
	(function (Buffer){
	'use strict';
	var Buffer_from = /*::(*/function(){}/*:: :any)*/;
	if(typeof Buffer !== 'undefined') {
		var nbfs = !Buffer.from;
		if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
		Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
		// $FlowIgnore
		if(!Buffer.alloc) Buffer.alloc = function(n) { return new Buffer(n); };
	}
	module.exports = function(data, encoding){
	    return typeof data == 'number' ? Buffer.alloc(data) : Buffer_from(data, encoding);
	};
	module.exports.test = function(b){
	    return Buffer.isBuffer(b);
	};
	}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
	},{}],12:[function(_dereq_,module,exports){
	'use strict';
	var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
	
	function NodeBufferReader(data) {
	    this.data = data;
	    this.length = this.data.length;
	    this.index = 0;
	}
	NodeBufferReader.prototype = new Uint8ArrayReader();
	
	/**
	 * @see DataReader.readData
	 */
	NodeBufferReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    var result = this.data.slice(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = NodeBufferReader;
	
	},{"./uint8ArrayReader":18}],13:[function(_dereq_,module,exports){
	'use strict';
	var support = _dereq_('./support');
	var utils = _dereq_('./utils');
	var crc32 = _dereq_('./crc32');
	var signature = _dereq_('./signature');
	var defaults = _dereq_('./defaults');
	var base64 = _dereq_('./base64');
	var compressions = _dereq_('./compressions');
	var CompressedObject = _dereq_('./compressedObject');
	var nodeBuffer = _dereq_('./nodeBuffer');
	var utf8 = _dereq_('./utf8');
	var StringWriter = _dereq_('./stringWriter');
	var Uint8ArrayWriter = _dereq_('./uint8ArrayWriter');
	
	/**
	 * Returns the raw data of a ZipObject, decompress the content if necessary.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getRawData = function(file) {
	    if (file._data instanceof CompressedObject) {
	        file._data = file._data.getContent();
	        file.options.binary = true;
	        file.options.base64 = false;
	
	        if (utils.getTypeOf(file._data) === "uint8array") {
	            var copy = file._data;
	            // when reading an arraybuffer, the CompressedObject mechanism will keep it and subarray() a Uint8Array.
	            // if we request a file in the same format, we might get the same Uint8Array or its ArrayBuffer (the original zip file).
	            file._data = new Uint8Array(copy.length);
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            if (copy.length !== 0) {
	                file._data.set(copy, 0);
	            }
	        }
	    }
	    return file._data;
	};
	
	/**
	 * Returns the data of a ZipObject in a binary form. If the content is an unicode string, encode it.
	 * @param {ZipObject} file the file to use.
	 * @return {String|ArrayBuffer|Uint8Array|Buffer} the data.
	 */
	var getBinaryData = function(file) {
	    var result = getRawData(file),
	        type = utils.getTypeOf(result);
	    if (type === "string") {
	        if (!file.options.binary) {
	            // unicode text !
	            // unicode string => binary string is a painful process, check if we can avoid it.
	            if (support.nodebuffer) {
	                return nodeBuffer(result, "utf-8");
	            }
	        }
	        return file.asBinary();
	    }
	    return result;
	};
	
	/**
	 * Transform this._data into a string.
	 * @param {function} filter a function String -> String, applied if not null on the result.
	 * @return {String} the string representing this._data.
	 */
	var dataToString = function(asUTF8) {
	    var result = getRawData(this);
	    if (result === null || typeof result === "undefined") {
	        return "";
	    }
	    // if the data is a base64 string, we decode it before checking the encoding !
	    if (this.options.base64) {
	        result = base64.decode(result);
	    }
	    if (asUTF8 && this.options.binary) {
	        // JSZip.prototype.utf8decode supports arrays as input
	        // skip to array => string step, utf8decode will do it.
	        result = out.utf8decode(result);
	    }
	    else {
	        // no utf8 transformation, do the array => string step.
	        result = utils.transformTo("string", result);
	    }
	
	    if (!asUTF8 && !this.options.binary) {
	        result = utils.transformTo("string", out.utf8encode(result));
	    }
	    return result;
	};
	/**
	 * A simple object representing a file in the zip file.
	 * @constructor
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
	 * @param {Object} options the options of the file
	 */
	var ZipObject = function(name, data, options) {
	    this.name = name;
	    this.dir = options.dir;
	    this.date = options.date;
	    this.comment = options.comment;
	
	    this._data = data;
	    this.options = options;
	
	    /*
	     * This object contains initial values for dir and date.
	     * With them, we can check if the user changed the deprecated metadata in
	     * `ZipObject#options` or not.
	     */
	    this._initialMetadata = {
	      dir : options.dir,
	      date : options.date
	    };
	};
	
	ZipObject.prototype = {
	    /**
	     * Return the content as UTF8 string.
	     * @return {string} the UTF8 string.
	     */
	    asText: function() {
	        return dataToString.call(this, true);
	    },
	    /**
	     * Returns the binary content.
	     * @return {string} the content as binary.
	     */
	    asBinary: function() {
	        return dataToString.call(this, false);
	    },
	    /**
	     * Returns the content as a nodejs Buffer.
	     * @return {Buffer} the content as a Buffer.
	     */
	    asNodeBuffer: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("nodebuffer", result);
	    },
	    /**
	     * Returns the content as an Uint8Array.
	     * @return {Uint8Array} the content as an Uint8Array.
	     */
	    asUint8Array: function() {
	        var result = getBinaryData(this);
	        return utils.transformTo("uint8array", result);
	    },
	    /**
	     * Returns the content as an ArrayBuffer.
	     * @return {ArrayBuffer} the content as an ArrayBufer.
	     */
	    asArrayBuffer: function() {
	        return this.asUint8Array().buffer;
	    }
	};
	
	/**
	 * Transform an integer into a string in hexadecimal.
	 * @private
	 * @param {number} dec the number to convert.
	 * @param {number} bytes the number of bytes to generate.
	 * @returns {string} the result.
	 */
	var decToHex = function(dec, bytes) {
	    var hex = "",
	        i;
	    for (i = 0; i < bytes; i++) {
	        hex += String.fromCharCode(dec & 0xff);
	        dec = dec >>> 8;
	    }
	    return hex;
	};
	
	/**
	 * Merge the objects passed as parameters into a new one.
	 * @private
	 * @param {...Object} var_args All objects to merge.
	 * @return {Object} a new object with the data of the others.
	 */
	var extend = function() {
	    var result = {}, i, attr;
	    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
	        for (attr in arguments[i]) {
	            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
	                result[attr] = arguments[i][attr];
	            }
	        }
	    }
	    return result;
	};
	
	/**
	 * Transforms the (incomplete) options from the user into the complete
	 * set of options to create a file.
	 * @private
	 * @param {Object} o the options from the user.
	 * @return {Object} the complete set of options.
	 */
	var prepareFileAttrs = function(o) {
	    o = o || {};
	    if (o.base64 === true && (o.binary === null || o.binary === undefined)) {
	        o.binary = true;
	    }
	    o = extend(o, defaults);
	    o.date = o.date || new Date();
	    if (o.compression !== null) o.compression = o.compression.toUpperCase();
	
	    return o;
	};
	
	/**
	 * Add a file in the current folder.
	 * @private
	 * @param {string} name the name of the file
	 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
	 * @param {Object} o the options of the file
	 * @return {Object} the new file.
	 */
	var fileAdd = function(name, data, o) {
	    // be sure sub folders exist
	    var dataType = utils.getTypeOf(data),
	        parent;
	
	    o = prepareFileAttrs(o);
	
	    if (o.createFolders && (parent = parentFolder(name))) {
	        folderAdd.call(this, parent, true);
	    }
	
	    if (o.dir || data === null || typeof data === "undefined") {
	        o.base64 = false;
	        o.binary = false;
	        data = null;
	    }
	    else if (dataType === "string") {
	        if (o.binary && !o.base64) {
	            // optimizedBinaryString == true means that the file has already been filtered with a 0xFF mask
	            if (o.optimizedBinaryString !== true) {
	                // this is a string, not in a base64 format.
	                // Be sure that this is a correct "binary string"
	                data = utils.string2binary(data);
	            }
	        }
	    }
	    else { // arraybuffer, uint8array, ...
	        o.base64 = false;
	        o.binary = true;
	
	        if (!dataType && !(data instanceof CompressedObject)) {
	            throw new Error("The data of '" + name + "' is in an unsupported format !");
	        }
	
	        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
	        if (dataType === "arraybuffer") {
	            data = utils.transformTo("uint8array", data);
	        }
	    }
	
	    var object = new ZipObject(name, data, o);
	    this.files[name] = object;
	    return object;
	};
	
	/**
	 * Find the parent folder of the path.
	 * @private
	 * @param {string} path the path to use
	 * @return {string} the parent folder, or ""
	 */
	var parentFolder = function (path) {
	    if (path.slice(-1) == '/') {
	        path = path.substring(0, path.length - 1);
	    }
	    var lastSlash = path.lastIndexOf('/');
	    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
	};
	
	/**
	 * Add a (sub) folder in the current folder.
	 * @private
	 * @param {string} name the folder's name
	 * @param {boolean=} [createFolders] If true, automatically create sub
	 *  folders. Defaults to false.
	 * @return {Object} the new folder.
	 */
	var folderAdd = function(name, createFolders) {
	    // Check the name ends with a /
	    if (name.slice(-1) != "/") {
	        name += "/"; // IE doesn't like substr(-1)
	    }
	
	    createFolders = (typeof createFolders !== 'undefined') ? createFolders : false;
	
	    // Does this folder already exist?
	    if (!this.files[name]) {
	        fileAdd.call(this, name, null, {
	            dir: true,
	            createFolders: createFolders
	        });
	    }
	    return this.files[name];
	};
	
	/**
	 * Generate a JSZip.CompressedObject for a given zipOject.
	 * @param {ZipObject} file the object to read.
	 * @param {JSZip.compression} compression the compression to use.
	 * @return {JSZip.CompressedObject} the compressed result.
	 */
	var generateCompressedObjectFrom = function(file, compression) {
	    var result = new CompressedObject(),
	        content;
	
	    // the data has not been decompressed, we might reuse things !
	    if (file._data instanceof CompressedObject) {
	        result.uncompressedSize = file._data.uncompressedSize;
	        result.crc32 = file._data.crc32;
	
	        if (result.uncompressedSize === 0 || file.dir) {
	            compression = compressions['STORE'];
	            result.compressedContent = "";
	            result.crc32 = 0;
	        }
	        else if (file._data.compressionMethod === compression.magic) {
	            result.compressedContent = file._data.getCompressedContent();
	        }
	        else {
	            content = file._data.getContent();
	            // need to decompress / recompress
	            result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
	        }
	    }
	    else {
	        // have uncompressed data
	        content = getBinaryData(file);
	        if (!content || content.length === 0 || file.dir) {
	            compression = compressions['STORE'];
	            content = "";
	        }
	        result.uncompressedSize = content.length;
	        result.crc32 = crc32(content);
	        result.compressedContent = compression.compress(utils.transformTo(compression.compressInputType, content));
	    }
	
	    result.compressedSize = result.compressedContent.length;
	    result.compressionMethod = compression.magic;
	
	    return result;
	};
	
	/**
	 * Generate the various parts used in the construction of the final zip file.
	 * @param {string} name the file name.
	 * @param {ZipObject} file the file content.
	 * @param {JSZip.CompressedObject} compressedObject the compressed object.
	 * @param {number} offset the current offset from the start of the zip file.
	 * @return {object} the zip parts.
	 */
	var generateZipParts = function(name, file, compressedObject, offset) {
	    var data = compressedObject.compressedContent,
	        utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
	        comment = file.comment || "",
	        utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
	        useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
	        useUTF8ForComment = utfEncodedComment.length !== comment.length,
	        o = file.options,
	        dosTime,
	        dosDate,
	        extraFields = "",
	        unicodePathExtraField = "",
	        unicodeCommentExtraField = "",
	        dir, date;
	
	
	    // handle the deprecated options.dir
	    if (file._initialMetadata.dir !== file.dir) {
	        dir = file.dir;
	    } else {
	        dir = o.dir;
	    }
	
	    // handle the deprecated options.date
	    if(file._initialMetadata.date !== file.date) {
	        date = file.date;
	    } else {
	        date = o.date;
	    }
	
	
	    dosTime = date.getHours();
	    dosTime = dosTime << 6;
	    dosTime = dosTime | date.getMinutes();
	    dosTime = dosTime << 5;
	    dosTime = dosTime | date.getSeconds() / 2;
	
	    dosDate = date.getFullYear() - 1980;
	    dosDate = dosDate << 4;
	    dosDate = dosDate | (date.getMonth() + 1);
	    dosDate = dosDate << 5;
	    dosDate = dosDate | date.getDate();
	
	    if (useUTF8ForFileName) {
	        // set the unicode path extra field. unzip needs at least one extra
	        // field to correctly handle unicode path, so using the path is as good
	        // as any other information. This could improve the situation with
	        // other archive managers too.
	        // This field is usually used without the utf8 flag, with a non
	        // unicode path in the header (winrar, winzip). This helps (a bit)
	        // with the messy Windows' default compressed folders feature but
	        // breaks on p7zip which doesn't seek the unicode path extra field.
	        // So for now, UTF-8 everywhere !
	        unicodePathExtraField =
	            // Version
	            decToHex(1, 1) +
	            // NameCRC32
	            decToHex(crc32(utfEncodedFileName), 4) +
	            // UnicodeName
	            utfEncodedFileName;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x70" +
	            // size
	            decToHex(unicodePathExtraField.length, 2) +
	            // content
	            unicodePathExtraField;
	    }
	
	    if(useUTF8ForComment) {
	
	        unicodeCommentExtraField =
	            // Version
	            decToHex(1, 1) +
	            // CommentCRC32
	            decToHex(this.crc32(utfEncodedComment), 4) +
	            // UnicodeName
	            utfEncodedComment;
	
	        extraFields +=
	            // Info-ZIP Unicode Path Extra Field
	            "\x75\x63" +
	            // size
	            decToHex(unicodeCommentExtraField.length, 2) +
	            // content
	            unicodeCommentExtraField;
	    }
	
	    var header = "";
	
	    // version needed to extract
	    header += "\x0A\x00";
	    // general purpose bit flag
	    // set bit 11 if utf8
	    header += (useUTF8ForFileName || useUTF8ForComment) ? "\x00\x08" : "\x00\x00";
	    // compression method
	    header += compressedObject.compressionMethod;
	    // last mod file time
	    header += decToHex(dosTime, 2);
	    // last mod file date
	    header += decToHex(dosDate, 2);
	    // crc-32
	    header += decToHex(compressedObject.crc32, 4);
	    // compressed size
	    header += decToHex(compressedObject.compressedSize, 4);
	    // uncompressed size
	    header += decToHex(compressedObject.uncompressedSize, 4);
	    // file name length
	    header += decToHex(utfEncodedFileName.length, 2);
	    // extra field length
	    header += decToHex(extraFields.length, 2);
	
	
	    var fileRecord = signature.LOCAL_FILE_HEADER + header + utfEncodedFileName + extraFields;
	
	    var dirRecord = signature.CENTRAL_FILE_HEADER +
	    // version made by (00: DOS)
	    "\x14\x00" +
	    // file header (common to file and central directory)
	    header +
	    // file comment length
	    decToHex(utfEncodedComment.length, 2) +
	    // disk number start
	    "\x00\x00" +
	    // internal file attributes TODO
	    "\x00\x00" +
	    // external file attributes
	    (dir === true ? "\x10\x00\x00\x00" : "\x00\x00\x00\x00") +
	    // relative offset of local header
	    decToHex(offset, 4) +
	    // file name
	    utfEncodedFileName +
	    // extra field
	    extraFields +
	    // file comment
	    utfEncodedComment;
	
	    return {
	        fileRecord: fileRecord,
	        dirRecord: dirRecord,
	        compressedObject: compressedObject
	    };
	};
	
	
	// return the actual prototype of JSZip
	var out = {
	    /**
	     * Read an existing zip and merge the data in the current JSZip object.
	     * The implementation is in jszip-load.js, don't forget to include it.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} stream  The stream to load
	     * @param {Object} options Options for loading the stream.
	     *  options.base64 : is the stream in base64 ? default : false
	     * @return {JSZip} the current JSZip object
	     */
	    load: function(stream, options) {
	        throw new Error("Load method is not defined. Is the file jszip-load.js included ?");
	    },
	
	    /**
	     * Filter nested files/folders with the specified function.
	     * @param {Function} search the predicate to use :
	     * function (relativePath, file) {...}
	     * It takes 2 arguments : the relative path and the file.
	     * @return {Array} An array of matching elements.
	     */
	    filter: function(search) {
	        var result = [],
	            filename, relativePath, file, fileClone;
	        for (filename in this.files) {
	            if (!this.files.hasOwnProperty(filename)) {
	                continue;
	            }
	            file = this.files[filename];
	            // return a new object, don't let the user mess with our internal objects :)
	            fileClone = new ZipObject(file.name, file._data, extend(file.options));
	            relativePath = filename.slice(this.root.length, filename.length);
	            if (filename.slice(0, this.root.length) === this.root && // the file is in the current root
	            search(relativePath, fileClone)) { // and the file matches the function
	                result.push(fileClone);
	            }
	        }
	        return result;
	    },
	
	    /**
	     * Add a file to the zip file, or search a file.
	     * @param   {string|RegExp} name The name of the file to add (if data is defined),
	     * the name of the file to find (if no data) or a regex to match files.
	     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
	     * @param   {Object} o     File options
	     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
	     * a file (when searching by string) or an array of files (when searching by regex).
	     */
	    file: function(name, data, o) {
	        if (arguments.length === 1) {
	            if (utils.isRegExp(name)) {
	                var regexp = name;
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && regexp.test(relativePath);
	                });
	            }
	            else { // text
	                return this.filter(function(relativePath, file) {
	                    return !file.dir && relativePath === name;
	                })[0] || null;
	            }
	        }
	        else { // more than one argument : we have data !
	            name = this.root + name;
	            fileAdd.call(this, name, data, o);
	        }
	        return this;
	    },
	
	    /**
	     * Add a directory to the zip file, or search.
	     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
	     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
	     */
	    folder: function(arg) {
	        if (!arg) {
	            return this;
	        }
	
	        if (utils.isRegExp(arg)) {
	            return this.filter(function(relativePath, file) {
	                return file.dir && arg.test(relativePath);
	            });
	        }
	
	        // else, name is a new folder
	        var name = this.root + arg;
	        var newFolder = folderAdd.call(this, name);
	
	        // Allow chaining by returning a new object with this folder as the root
	        var ret = this.clone();
	        ret.root = newFolder.name;
	        return ret;
	    },
	
	    /**
	     * Delete a file, or a directory and all sub-files, from the zip
	     * @param {string} name the name of the file to delete
	     * @return {JSZip} this JSZip object
	     */
	    remove: function(name) {
	        name = this.root + name;
	        var file = this.files[name];
	        if (!file) {
	            // Look for any folders
	            if (name.slice(-1) != "/") {
	                name += "/";
	            }
	            file = this.files[name];
	        }
	
	        if (file && !file.dir) {
	            // file
	            delete this.files[name];
	        } else {
	            // maybe a folder, delete recursively
	            var kids = this.filter(function(relativePath, file) {
	                return file.name.slice(0, name.length) === name;
	            });
	            for (var i = 0; i < kids.length; i++) {
	                delete this.files[kids[i].name];
	            }
	        }
	
	        return this;
	    },
	
	    /**
	     * Generate the complete zip file
	     * @param {Object} options the options to generate the zip file :
	     * - base64, (deprecated, use type instead) true to generate base64.
	     * - compression, "STORE" by default.
	     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
	     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
	     */
	    generate: function(options) {
	        options = extend(options || {}, {
	            base64: true,
	            compression: "STORE",
	            type: "base64",
	            comment: null
	        });
	
	        utils.checkSupport(options.type);
	
	        var zipData = [],
	            localDirLength = 0,
	            centralDirLength = 0,
	            writer, i,
	            utfEncodedComment = utils.transformTo("string", this.utf8encode(options.comment || this.comment || ""));
	
	        // first, generate all the zip parts.
	        for (var name in this.files) {
	            if (!this.files.hasOwnProperty(name)) {
	                continue;
	            }
	            var file = this.files[name];
	
	            var compressionName = file.options.compression || options.compression.toUpperCase();
	            var compression = compressions[compressionName];
	            if (!compression) {
	                throw new Error(compressionName + " is not a valid compression method !");
	            }
	
	            var compressedObject = generateCompressedObjectFrom.call(this, file, compression);
	
	            var zipPart = generateZipParts.call(this, name, file, compressedObject, localDirLength);
	            localDirLength += zipPart.fileRecord.length + compressedObject.compressedSize;
	            centralDirLength += zipPart.dirRecord.length;
	            zipData.push(zipPart);
	        }
	
	        var dirEnd = "";
	
	        // end of central dir signature
	        dirEnd = signature.CENTRAL_DIRECTORY_END +
	        // number of this disk
	        "\x00\x00" +
	        // number of the disk with the start of the central directory
	        "\x00\x00" +
	        // total number of entries in the central directory on this disk
	        decToHex(zipData.length, 2) +
	        // total number of entries in the central directory
	        decToHex(zipData.length, 2) +
	        // size of the central directory   4 bytes
	        decToHex(centralDirLength, 4) +
	        // offset of start of central directory with respect to the starting disk number
	        decToHex(localDirLength, 4) +
	        // .ZIP file comment length
	        decToHex(utfEncodedComment.length, 2) +
	        // .ZIP file comment
	        utfEncodedComment;
	
	
	        // we have all the parts (and the total length)
	        // time to create a writer !
	        var typeName = options.type.toLowerCase();
	        if(typeName==="uint8array"||typeName==="arraybuffer"||typeName==="blob"||typeName==="nodebuffer") {
	            writer = new Uint8ArrayWriter(localDirLength + centralDirLength + dirEnd.length);
	        }else{
	            writer = new StringWriter(localDirLength + centralDirLength + dirEnd.length);
	        }
	
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].fileRecord);
	            writer.append(zipData[i].compressedObject.compressedContent);
	        }
	        for (i = 0; i < zipData.length; i++) {
	            writer.append(zipData[i].dirRecord);
	        }
	
	        writer.append(dirEnd);
	
	        var zip = writer.finalize();
	
	
	
	        switch(options.type.toLowerCase()) {
	            // case "zip is an Uint8Array"
	            case "uint8array" :
	            case "arraybuffer" :
	            case "nodebuffer" :
	               return utils.transformTo(options.type.toLowerCase(), zip);
	            case "blob" :
	               return utils.arrayBuffer2Blob(utils.transformTo("arraybuffer", zip));
	            // case "zip is a string"
	            case "base64" :
	               return (options.base64) ? base64.encode(zip) : zip;
	            default : // case "string" :
	               return zip;
	         }
	
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    crc32: function (input, crc) {
	        return crc32(input, crc);
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8encode: function (string) {
	        return utils.transformTo("string", utf8.utf8encode(string));
	    },
	
	    /**
	     * @deprecated
	     * This method will be removed in a future version without replacement.
	     */
	    utf8decode: function (input) {
	        return utf8.utf8decode(input);
	    }
	};
	module.exports = out;
	
	},{"./base64":1,"./compressedObject":2,"./compressions":3,"./crc32":4,"./defaults":6,"./nodeBuffer":11,"./signature":14,"./stringWriter":16,"./support":17,"./uint8ArrayWriter":19,"./utf8":20,"./utils":21}],14:[function(_dereq_,module,exports){
	'use strict';
	exports.LOCAL_FILE_HEADER = "PK\x03\x04";
	exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
	exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
	exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
	exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
	exports.DATA_DESCRIPTOR = "PK\x07\x08";
	
	},{}],15:[function(_dereq_,module,exports){
	'use strict';
	var DataReader = _dereq_('./dataReader');
	var utils = _dereq_('./utils');
	
	function StringReader(data, optimizedBinaryString) {
	    this.data = data;
	    if (!optimizedBinaryString) {
	        this.data = utils.string2binary(this.data);
	    }
	    this.length = this.data.length;
	    this.index = 0;
	}
	StringReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	StringReader.prototype.byteAt = function(i) {
	    return this.data.charCodeAt(i);
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	StringReader.prototype.lastIndexOfSignature = function(sig) {
	    return this.data.lastIndexOf(sig);
	};
	/**
	 * @see DataReader.readData
	 */
	StringReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    // this will work because the constructor applied the "& 0xff" mask.
	    var result = this.data.slice(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = StringReader;
	
	},{"./dataReader":5,"./utils":21}],16:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	
	/**
	 * An object to write any content to a string.
	 * @constructor
	 */
	var StringWriter = function() {
	    this.data = [];
	};
	StringWriter.prototype = {
	    /**
	     * Append any content to the current string.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        input = utils.transformTo("string", input);
	        this.data.push(input);
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {string} the generated string.
	     */
	    finalize: function() {
	        return this.data.join("");
	    }
	};
	
	module.exports = StringWriter;
	
	},{"./utils":21}],17:[function(_dereq_,module,exports){
	(function (Buffer){
	'use strict';
	exports.base64 = true;
	exports.array = true;
	exports.string = true;
	exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
	// contains true if JSZip can read/generate nodejs Buffer, false otherwise.
	// Browserify will provide a Buffer implementation for browsers, which is
	// an augmented Uint8Array (i.e., can be used as either Buffer or U8).
	exports.nodebuffer = typeof Buffer !== "undefined";
	// contains true if JSZip can read/generate Uint8Array, false otherwise.
	exports.uint8array = typeof Uint8Array !== "undefined";
	
	if (typeof ArrayBuffer === "undefined") {
	    exports.blob = false;
	}
	else {
	    var buffer = new ArrayBuffer(0);
	    try {
	        exports.blob = new Blob([buffer], {
	            type: "application/zip"
	        }).size === 0;
	    }
	    catch (e) {
	        try {
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            exports.blob = builder.getBlob('application/zip').size === 0;
	        }
	        catch (e) {
	            exports.blob = false;
	        }
	    }
	}
	
	}).call(this,(typeof Buffer !== "undefined" ? Buffer : undefined))
	},{}],18:[function(_dereq_,module,exports){
	'use strict';
	var DataReader = _dereq_('./dataReader');
	
	function Uint8ArrayReader(data) {
	    if (data) {
	        this.data = data;
	        this.length = this.data.length;
	        this.index = 0;
	    }
	}
	Uint8ArrayReader.prototype = new DataReader();
	/**
	 * @see DataReader.byteAt
	 */
	Uint8ArrayReader.prototype.byteAt = function(i) {
	    return this.data[i];
	};
	/**
	 * @see DataReader.lastIndexOfSignature
	 */
	Uint8ArrayReader.prototype.lastIndexOfSignature = function(sig) {
	    var sig0 = sig.charCodeAt(0),
	        sig1 = sig.charCodeAt(1),
	        sig2 = sig.charCodeAt(2),
	        sig3 = sig.charCodeAt(3);
	    for (var i = this.length - 4; i >= 0; --i) {
	        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	/**
	 * @see DataReader.readData
	 */
	Uint8ArrayReader.prototype.readData = function(size) {
	    this.checkOffset(size);
	    if(size === 0) {
	        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
	        return new Uint8Array(0);
	    }
	    var result = this.data.subarray(this.index, this.index + size);
	    this.index += size;
	    return result;
	};
	module.exports = Uint8ArrayReader;
	
	},{"./dataReader":5}],19:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	
	/**
	 * An object to write any content to an Uint8Array.
	 * @constructor
	 * @param {number} length The length of the array.
	 */
	var Uint8ArrayWriter = function(length) {
	    this.data = new Uint8Array(length);
	    this.index = 0;
	};
	Uint8ArrayWriter.prototype = {
	    /**
	     * Append any content to the current array.
	     * @param {Object} input the content to add.
	     */
	    append: function(input) {
	        if (input.length !== 0) {
	            // with an empty Uint8Array, Opera fails with a "Offset larger than array size"
	            input = utils.transformTo("uint8array", input);
	            this.data.set(input, this.index);
	            this.index += input.length;
	        }
	    },
	    /**
	     * Finalize the construction an return the result.
	     * @return {Uint8Array} the generated array.
	     */
	    finalize: function() {
	        return this.data;
	    }
	};
	
	module.exports = Uint8ArrayWriter;
	
	},{"./utils":21}],20:[function(_dereq_,module,exports){
	'use strict';
	
	var utils = _dereq_('./utils');
	var support = _dereq_('./support');
	var nodeBuffer = _dereq_('./nodeBuffer');
	
	/**
	 * The following functions come from pako, from pako/lib/utils/strings
	 * released under the MIT license, see pako https://github.com/nodeca/pako/
	 */
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new Array(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	// convert string to array (typed, when possible)
	var string2buf = function (str) {
	    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	    // count binary size
	    for (m_pos = 0; m_pos < str_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if (((c & 0xfc00) === 0xd800) && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        buf_len += (c < 0x80) ? 1 : ((c < 0x800) ? 2 : ((c < 0x10000) ? 3 : 4));
	    }
	
	    // allocate buffer
	    if (support.uint8array) {
	        buf = new Uint8Array(buf_len);
	    } else {
	        buf = new Array(buf_len);
	    }
	
	    // convert
	    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	        c = str.charCodeAt(m_pos);
	        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	            c2 = str.charCodeAt(m_pos+1);
	            if ((c2 & 0xfc00) === 0xdc00) {
	                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	                m_pos++;
	            }
	        }
	        if (c < 0x80) {
	            /* one byte */
	            buf[i++] = c;
	        } else if (c < 0x800) {
	            /* two bytes */
	            buf[i++] = 0xC0 | (c >>> 6);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else if (c < 0x10000) {
	            /* three bytes */
	            buf[i++] = 0xE0 | (c >>> 12);
	            buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        } else {
	            /* four bytes */
	            buf[i++] = 0xf0 | (c >>> 18);
	            buf[i++] = 0x80 | ((c >>> 12) & 0x3f);
	            buf[i++] = 0x80 | ((c >>> 6) & 0x3f);
	            buf[i++] = 0x80 | (c & 0x3f);
	        }
	    }
	
	    return buf;
	};
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	var utf8border = function(buf, max) {
	    var pos;
	
	    max = max || buf.length;
	    if (max > buf.length) { max = buf.length; }
	
	    // go back from last position, until start of sequence found
	    pos = max-1;
	    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	    // Fuckup - very small and broken sequence,
	    // return max, because we should return something anyway.
	    if (pos < 0) { return max; }
	
	    // If we came to start of buffer - that means vuffer is too small,
	    // return max too.
	    if (pos === 0) { return max; }
	
	    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	// convert array to string
	var buf2string = function (buf) {
	    var str, i, out, c, c_len;
	    var len = buf.length;
	
	    // Reserve max possible length (2 words per char)
	    // NB: by unknown reasons, Array is significantly faster for
	    //     String.fromCharCode.apply than Uint16Array.
	    var utf16buf = new Array(len*2);
	
	    for (out=0, i=0; i<len;) {
	        c = buf[i++];
	        // quick process ascii
	        if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	        c_len = _utf8len[c];
	        // skip 5 & 6 byte codes
	        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	        // apply mask on first byte
	        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	        // join the rest
	        while (c_len > 1 && i < len) {
	            c = (c << 6) | (buf[i++] & 0x3f);
	            c_len--;
	        }
	
	        // terminated by end of string?
	        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	        if (c < 0x10000) {
	            utf16buf[out++] = c;
	        } else {
	            c -= 0x10000;
	            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	        }
	    }
	
	    // shrinkBuf(utf16buf, out)
	    if (utf16buf.length !== out) {
	        if(utf16buf.subarray) {
	            utf16buf = utf16buf.subarray(0, out);
	        } else {
	            utf16buf.length = out;
	        }
	    }
	
	    // return String.fromCharCode.apply(null, utf16buf);
	    return utils.applyFromCharCode(utf16buf);
	};
	
	
	// That's all for the pako functions.
	
	
	/**
	 * Transform a javascript string into an array (typed if possible) of bytes,
	 * UTF-8 encoded.
	 * @param {String} str the string to encode
	 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
	 */
	exports.utf8encode = function utf8encode(str) {
	    if (support.nodebuffer) {
	        return nodeBuffer(str, "utf-8");
	    }
	
	    return string2buf(str);
	};
	
	
	/**
	 * Transform a bytes array (or a representation) representing an UTF-8 encoded
	 * string into a javascript string.
	 * @param {Array|Uint8Array|Buffer} buf the data de decode
	 * @return {String} the decoded string.
	 */
	exports.utf8decode = function utf8decode(buf) {
	    if (support.nodebuffer) {
	        return utils.transformTo("nodebuffer", buf).toString("utf-8");
	    }
	
	    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
	
	    // return buf2string(buf);
	    // Chrome prefers to work with "small" chunks of data
	    // for the method buf2string.
	    // Firefox and Chrome has their own shortcut, IE doesn't seem to really care.
	    var result = [], k = 0, len = buf.length, chunk = 65536;
	    while (k < len) {
	        var nextBoundary = utf8border(buf, Math.min(k + chunk, len));
	        if (support.uint8array) {
	            result.push(buf2string(buf.subarray(k, nextBoundary)));
	        } else {
	            result.push(buf2string(buf.slice(k, nextBoundary)));
	        }
	        k = nextBoundary;
	    }
	    return result.join("");
	
	};
	// vim: set shiftwidth=4 softtabstop=4:
	
	},{"./nodeBuffer":11,"./support":17,"./utils":21}],21:[function(_dereq_,module,exports){
	'use strict';
	var support = _dereq_('./support');
	var compressions = _dereq_('./compressions');
	var nodeBuffer = _dereq_('./nodeBuffer');
	/**
	 * Convert a string to a "binary string" : a string containing only char codes between 0 and 255.
	 * @param {string} str the string to transform.
	 * @return {String} the binary string.
	 */
	exports.string2binary = function(str) {
	    var result = "";
	    for (var i = 0; i < str.length; i++) {
	        result += String.fromCharCode(str.charCodeAt(i) & 0xff);
	    }
	    return result;
	};
	exports.arrayBuffer2Blob = function(buffer) {
	    exports.checkSupport("blob");
	
	    try {
	        // Blob constructor
	        return new Blob([buffer], {
	            type: "application/zip"
	        });
	    }
	    catch (e) {
	
	        try {
	            // deprecated, browser only, old way
	            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
	            var builder = new Builder();
	            builder.append(buffer);
	            return builder.getBlob('application/zip');
	        }
	        catch (e) {
	
	            // well, fuck ?!
	            throw new Error("Bug : can't construct the Blob.");
	        }
	    }
	
	
	};
	/**
	 * The identity function.
	 * @param {Object} input the input.
	 * @return {Object} the same input.
	 */
	function identity(input) {
	    return input;
	}
	
	/**
	 * Fill in an array with a string.
	 * @param {String} str the string to use.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
	 */
	function stringToArrayLike(str, array) {
	    for (var i = 0; i < str.length; ++i) {
	        array[i] = str.charCodeAt(i) & 0xFF;
	    }
	    return array;
	}
	
	/**
	 * Transform an array-like object to a string.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
	 * @return {String} the result.
	 */
	function arrayLikeToString(array) {
	    // Performances notes :
	    // --------------------
	    // String.fromCharCode.apply(null, array) is the fastest, see
	    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
	    // but the stack is limited (and we can get huge arrays !).
	    //
	    // result += String.fromCharCode(array[i]); generate too many strings !
	    //
	    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
	    var chunk = 65536;
	    var result = [],
	        len = array.length,
	        type = exports.getTypeOf(array),
	        k = 0,
	        canUseApply = true;
	      try {
	         switch(type) {
	            case "uint8array":
	               String.fromCharCode.apply(null, new Uint8Array(0));
	               break;
	            case "nodebuffer":
	               String.fromCharCode.apply(null, nodeBuffer(0));
	               break;
	         }
	      } catch(e) {
	         canUseApply = false;
	      }
	
	      // no apply : slow and painful algorithm
	      // default browser on android 4.*
	      if (!canUseApply) {
	         var resultStr = "";
	         for(var i = 0; i < array.length;i++) {
	            resultStr += String.fromCharCode(array[i]);
	         }
	    return resultStr;
	    }
	    while (k < len && chunk > 1) {
	        try {
	            if (type === "array" || type === "nodebuffer") {
	                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
	            }
	            else {
	                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
	            }
	            k += chunk;
	        }
	        catch (e) {
	            chunk = Math.floor(chunk / 2);
	        }
	    }
	    return result.join("");
	}
	
	exports.applyFromCharCode = arrayLikeToString;
	
	
	/**
	 * Copy the data from an array-like to an other array-like.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
	 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
	 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
	 */
	function arrayLikeToArrayLike(arrayFrom, arrayTo) {
	    for (var i = 0; i < arrayFrom.length; i++) {
	        arrayTo[i] = arrayFrom[i];
	    }
	    return arrayTo;
	}
	
	// a matrix containing functions to transform everything into everything.
	var transform = {};
	
	// string to ?
	transform["string"] = {
	    "string": identity,
	    "array": function(input) {
	        return stringToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["string"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return stringToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": function(input) {
	        return stringToArrayLike(input, nodeBuffer(input.length));
	    }
	};
	
	// array to ?
	transform["array"] = {
	    "string": arrayLikeToString,
	    "array": identity,
	    "arraybuffer": function(input) {
	        return (new Uint8Array(input)).buffer;
	    },
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// arraybuffer to ?
	transform["arraybuffer"] = {
	    "string": function(input) {
	        return arrayLikeToString(new Uint8Array(input));
	    },
	    "array": function(input) {
	        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
	    },
	    "arraybuffer": identity,
	    "uint8array": function(input) {
	        return new Uint8Array(input);
	    },
	    "nodebuffer": function(input) {
	        return nodeBuffer(new Uint8Array(input));
	    }
	};
	
	// uint8array to ?
	transform["uint8array"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return input.buffer;
	    },
	    "uint8array": identity,
	    "nodebuffer": function(input) {
	        return nodeBuffer(input);
	    }
	};
	
	// nodebuffer to ?
	transform["nodebuffer"] = {
	    "string": arrayLikeToString,
	    "array": function(input) {
	        return arrayLikeToArrayLike(input, new Array(input.length));
	    },
	    "arraybuffer": function(input) {
	        return transform["nodebuffer"]["uint8array"](input).buffer;
	    },
	    "uint8array": function(input) {
	        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
	    },
	    "nodebuffer": identity
	};
	
	/**
	 * Transform an input into any type.
	 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
	 * If no output type is specified, the unmodified input will be returned.
	 * @param {String} outputType the output type.
	 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
	 * @throws {Error} an Error if the browser doesn't support the requested output type.
	 */
	exports.transformTo = function(outputType, input) {
	    if (!input) {
	        // undefined, null, etc
	        // an empty string won't harm.
	        input = "";
	    }
	    if (!outputType) {
	        return input;
	    }
	    exports.checkSupport(outputType);
	    var inputType = exports.getTypeOf(input);
	    var result = transform[inputType][outputType](input);
	    return result;
	};
	
	/**
	 * Return the type of the input.
	 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
	 * @param {Object} input the input to identify.
	 * @return {String} the (lowercase) type of the input.
	 */
	exports.getTypeOf = function(input) {
	    if (typeof input === "string") {
	        return "string";
	    }
	    if (Object.prototype.toString.call(input) === "[object Array]") {
	        return "array";
	    }
	    if (support.nodebuffer && nodeBuffer.test(input)) {
	        return "nodebuffer";
	    }
	    if (support.uint8array && input instanceof Uint8Array) {
	        return "uint8array";
	    }
	    if (support.arraybuffer && input instanceof ArrayBuffer) {
	        return "arraybuffer";
	    }
	};
	
	/**
	 * Throw an exception if the type is not supported.
	 * @param {String} type the type to check.
	 * @throws {Error} an Error if the browser doesn't support the requested type.
	 */
	exports.checkSupport = function(type) {
	    var supported = support[type.toLowerCase()];
	    if (!supported) {
	        throw new Error(type + " is not supported by this browser");
	    }
	};
	exports.MAX_VALUE_16BITS = 65535;
	exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1
	
	/**
	 * Prettify a string read as binary.
	 * @param {string} str the string to prettify.
	 * @return {string} a pretty string.
	 */
	exports.pretty = function(str) {
	    var res = '',
	        code, i;
	    for (i = 0; i < (str || "").length; i++) {
	        code = str.charCodeAt(i);
	        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
	    }
	    return res;
	};
	
	/**
	 * Find a compression registered in JSZip.
	 * @param {string} compressionMethod the method magic to find.
	 * @return {Object|null} the JSZip compression object, null if none found.
	 */
	exports.findCompression = function(compressionMethod) {
	    for (var method in compressions) {
	        if (!compressions.hasOwnProperty(method)) {
	            continue;
	        }
	        if (compressions[method].magic === compressionMethod) {
	            return compressions[method];
	        }
	    }
	    return null;
	};
	/**
	* Cross-window, cross-Node-context regular expression detection
	* @param  {Object}  object Anything
	* @return {Boolean}        true if the object is a regular expression,
	* false otherwise
	*/
	exports.isRegExp = function (object) {
	    return Object.prototype.toString.call(object) === "[object RegExp]";
	};
	
	
	},{"./compressions":3,"./nodeBuffer":11,"./support":17}],22:[function(_dereq_,module,exports){
	'use strict';
	var StringReader = _dereq_('./stringReader');
	var NodeBufferReader = _dereq_('./nodeBufferReader');
	var Uint8ArrayReader = _dereq_('./uint8ArrayReader');
	var utils = _dereq_('./utils');
	var sig = _dereq_('./signature');
	var ZipEntry = _dereq_('./zipEntry');
	var support = _dereq_('./support');
	var jszipProto = _dereq_('./object');
	//  class ZipEntries {{{
	/**
	 * All the entries in the zip file.
	 * @constructor
	 * @param {String|ArrayBuffer|Uint8Array} data the binary stream to load.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntries(data, loadOptions) {
	    this.files = [];
	    this.loadOptions = loadOptions;
	    if (data) {
	        this.load(data);
	    }
	}
	ZipEntries.prototype = {
	    /**
	     * Check that the reader is on the speficied signature.
	     * @param {string} expectedSignature the expected signature.
	     * @throws {Error} if it is an other signature.
	     */
	    checkSignature: function(expectedSignature) {
	        var signature = this.reader.readString(4);
	        if (signature !== expectedSignature) {
	            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
	        }
	    },
	    /**
	     * Read the end of the central directory.
	     */
	    readBlockEndOfCentral: function() {
	        this.diskNumber = this.reader.readInt(2);
	        this.diskWithCentralDirStart = this.reader.readInt(2);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
	        this.centralDirRecords = this.reader.readInt(2);
	        this.centralDirSize = this.reader.readInt(4);
	        this.centralDirOffset = this.reader.readInt(4);
	
	        this.zipCommentLength = this.reader.readInt(2);
	        // warning : the encoding depends of the system locale
	        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
	        // On a windows machine, this field is encoded with the localized windows code page.
	        this.zipComment = this.reader.readString(this.zipCommentLength);
	        // To get consistent behavior with the generation part, we will assume that
	        // this is utf8 encoded.
	        this.zipComment = jszipProto.utf8decode(this.zipComment);
	    },
	    /**
	     * Read the end of the Zip 64 central directory.
	     * Not merged with the method readEndOfCentral :
	     * The end of central can coexist with its Zip64 brother,
	     * I don't want to read the wrong number of bytes !
	     */
	    readBlockZip64EndOfCentral: function() {
	        this.zip64EndOfCentralSize = this.reader.readInt(8);
	        this.versionMadeBy = this.reader.readString(2);
	        this.versionNeeded = this.reader.readInt(2);
	        this.diskNumber = this.reader.readInt(4);
	        this.diskWithCentralDirStart = this.reader.readInt(4);
	        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
	        this.centralDirRecords = this.reader.readInt(8);
	        this.centralDirSize = this.reader.readInt(8);
	        this.centralDirOffset = this.reader.readInt(8);
	
	        this.zip64ExtensibleData = {};
	        var extraDataSize = this.zip64EndOfCentralSize - 44,
	            index = 0,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	        while (index < extraDataSize) {
	            extraFieldId = this.reader.readInt(2);
	            extraFieldLength = this.reader.readInt(4);
	            extraFieldValue = this.reader.readString(extraFieldLength);
	            this.zip64ExtensibleData[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Read the end of the Zip 64 central directory locator.
	     */
	    readBlockZip64EndOfCentralLocator: function() {
	        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
	        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
	        this.disksCount = this.reader.readInt(4);
	        if (this.disksCount > 1) {
	            throw new Error("Multi-volumes zip are not supported");
	        }
	    },
	    /**
	     * Read the local files, based on the offset read in the central part.
	     */
	    readLocalFiles: function() {
	        var i, file;
	        for (i = 0; i < this.files.length; i++) {
	            file = this.files[i];
	            this.reader.setIndex(file.localHeaderOffset);
	            this.checkSignature(sig.LOCAL_FILE_HEADER);
	            file.readLocalPart(this.reader);
	            file.handleUTF8();
	        }
	    },
	    /**
	     * Read the central directory.
	     */
	    readCentralDir: function() {
	        var file;
	
	        this.reader.setIndex(this.centralDirOffset);
	        while (this.reader.readString(4) === sig.CENTRAL_FILE_HEADER) {
	            file = new ZipEntry({
	                zip64: this.zip64
	            }, this.loadOptions);
	            file.readCentralPart(this.reader);
	            this.files.push(file);
	        }
	    },
	    /**
	     * Read the end of central directory.
	     */
	    readEndOfCentral: function() {
	        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
	        if (offset === -1) {
	            throw new Error("Corrupted zip : can't find end of central directory");
	        }
	        this.reader.setIndex(offset);
	        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
	        this.readBlockEndOfCentral();
	
	
	        /* extract from the zip spec :
	            4)  If one of the fields in the end of central directory
	                record is too small to hold required data, the field
	                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
	                ZIP64 format record should be created.
	            5)  The end of central directory record and the
	                Zip64 end of central directory locator record must
	                reside on the same disk when splitting or spanning
	                an archive.
	         */
	        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
	            this.zip64 = true;
	
	            /*
	            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
	            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
	            all numbers as 64-bit double precision IEEE 754 floating point numbers.
	            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
	            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
	            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
	            */
	
	            // should look for a zip64 EOCD locator
	            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            if (offset === -1) {
	                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
	            }
	            this.reader.setIndex(offset);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
	            this.readBlockZip64EndOfCentralLocator();
	
	            // now the zip64 EOCD record
	            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
	            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
	            this.readBlockZip64EndOfCentral();
	        }
	    },
	    prepareReader: function(data) {
	        var type = utils.getTypeOf(data);
	        if (type === "string" && !support.uint8array) {
	            this.reader = new StringReader(data, this.loadOptions.optimizedBinaryString);
	        }
	        else if (type === "nodebuffer") {
	            this.reader = new NodeBufferReader(data);
	        }
	        else {
	            this.reader = new Uint8ArrayReader(utils.transformTo("uint8array", data));
	        }
	    },
	    /**
	     * Read a zip file and create ZipEntries.
	     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
	     */
	    load: function(data) {
	        this.prepareReader(data);
	        this.readEndOfCentral();
	        this.readCentralDir();
	        this.readLocalFiles();
	    }
	};
	// }}} end of ZipEntries
	module.exports = ZipEntries;
	
	},{"./nodeBufferReader":12,"./object":13,"./signature":14,"./stringReader":15,"./support":17,"./uint8ArrayReader":18,"./utils":21,"./zipEntry":23}],23:[function(_dereq_,module,exports){
	'use strict';
	var StringReader = _dereq_('./stringReader');
	var utils = _dereq_('./utils');
	var CompressedObject = _dereq_('./compressedObject');
	var jszipProto = _dereq_('./object');
	// class ZipEntry {{{
	/**
	 * An entry in the zip file.
	 * @constructor
	 * @param {Object} options Options of the current file.
	 * @param {Object} loadOptions Options for loading the stream.
	 */
	function ZipEntry(options, loadOptions) {
	    this.options = options;
	    this.loadOptions = loadOptions;
	}
	ZipEntry.prototype = {
	    /**
	     * say if the file is encrypted.
	     * @return {boolean} true if the file is encrypted, false otherwise.
	     */
	    isEncrypted: function() {
	        // bit 1 is set
	        return (this.bitFlag & 0x0001) === 0x0001;
	    },
	    /**
	     * say if the file has utf-8 filename/comment.
	     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
	     */
	    useUTF8: function() {
	        // bit 11 is set
	        return (this.bitFlag & 0x0800) === 0x0800;
	    },
	    /**
	     * Prepare the function used to generate the compressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @return {Function} the callback to get the compressed content (the type depends of the DataReader class).
	     */
	    prepareCompressedContent: function(reader, from, length) {
	        return function() {
	            var previousIndex = reader.index;
	            reader.setIndex(from);
	            var compressedFileData = reader.readData(length);
	            reader.setIndex(previousIndex);
	
	            return compressedFileData;
	        };
	    },
	    /**
	     * Prepare the function used to generate the uncompressed content from this ZipFile.
	     * @param {DataReader} reader the reader to use.
	     * @param {number} from the offset from where we should read the data.
	     * @param {number} length the length of the data to read.
	     * @param {JSZip.compression} compression the compression used on this file.
	     * @param {number} uncompressedSize the uncompressed size to expect.
	     * @return {Function} the callback to get the uncompressed content (the type depends of the DataReader class).
	     */
	    prepareContent: function(reader, from, length, compression, uncompressedSize) {
	        return function() {
	
	            var compressedFileData = utils.transformTo(compression.uncompressInputType, this.getCompressedContent());
	            var uncompressedFileData = compression.uncompress(compressedFileData);
	
	            if (uncompressedFileData.length !== uncompressedSize) {
	                throw new Error("Bug : uncompressed data size mismatch");
	            }
	
	            return uncompressedFileData;
	        };
	    },
	    /**
	     * Read the local part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readLocalPart: function(reader) {
	        var compression, localExtraFieldsLength;
	
	        // we already know everything from the central dir !
	        // If the central dir data are false, we are doomed.
	        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
	        // The less data we get here, the more reliable this should be.
	        // Let's skip the whole header and dash to the data !
	        reader.skip(22);
	        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
	        // Strangely, the filename here is OK.
	        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
	        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
	        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
	        // the internet.
	        //
	        // I think I see the logic here : the central directory is used to display
	        // content and the local directory is used to extract the files. Mixing / and \
	        // may be used to display \ to windows users and use / when extracting the files.
	        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
	        this.fileNameLength = reader.readInt(2);
	        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
	        this.fileName = reader.readString(this.fileNameLength);
	        reader.skip(localExtraFieldsLength);
	
	        if (this.compressedSize == -1 || this.uncompressedSize == -1) {
	            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize == -1 || uncompressedSize == -1)");
	        }
	
	        compression = utils.findCompression(this.compressionMethod);
	        if (compression === null) { // no compression found
	            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + this.fileName + ")");
	        }
	        this.decompressed = new CompressedObject();
	        this.decompressed.compressedSize = this.compressedSize;
	        this.decompressed.uncompressedSize = this.uncompressedSize;
	        this.decompressed.crc32 = this.crc32;
	        this.decompressed.compressionMethod = this.compressionMethod;
	        this.decompressed.getCompressedContent = this.prepareCompressedContent(reader, reader.index, this.compressedSize, compression);
	        this.decompressed.getContent = this.prepareContent(reader, reader.index, this.compressedSize, compression, this.uncompressedSize);
	
	        // we need to compute the crc32...
	        if (this.loadOptions.checkCRC32) {
	            this.decompressed = utils.transformTo("string", this.decompressed.getContent());
	            if (jszipProto.crc32(this.decompressed) !== this.crc32) {
	                throw new Error("Corrupted zip : CRC32 mismatch");
	            }
	        }
	    },
	
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readCentralPart: function(reader) {
	        this.versionMadeBy = reader.readString(2);
	        this.versionNeeded = reader.readInt(2);
	        this.bitFlag = reader.readInt(2);
	        this.compressionMethod = reader.readString(2);
	        this.date = reader.readDate();
	        this.crc32 = reader.readInt(4);
	        this.compressedSize = reader.readInt(4);
	        this.uncompressedSize = reader.readInt(4);
	        this.fileNameLength = reader.readInt(2);
	        this.extraFieldsLength = reader.readInt(2);
	        this.fileCommentLength = reader.readInt(2);
	        this.diskNumberStart = reader.readInt(2);
	        this.internalFileAttributes = reader.readInt(2);
	        this.externalFileAttributes = reader.readInt(4);
	        this.localHeaderOffset = reader.readInt(4);
	
	        if (this.isEncrypted()) {
	            throw new Error("Encrypted zip are not supported");
	        }
	
	        this.fileName = reader.readString(this.fileNameLength);
	        this.readExtraFields(reader);
	        this.parseZIP64ExtraField(reader);
	        this.fileComment = reader.readString(this.fileCommentLength);
	
	        // warning, this is true only for zip with madeBy == DOS (plateform dependent feature)
	        this.dir = this.externalFileAttributes & 0x00000010 ? true : false;
	    },
	    /**
	     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
	     * @param {DataReader} reader the reader to use.
	     */
	    parseZIP64ExtraField: function(reader) {
	
	        if (!this.extraFields[0x0001]) {
	            return;
	        }
	
	        // should be something, preparing the extra reader
	        var extraReader = new StringReader(this.extraFields[0x0001].value);
	
	        // I really hope that these 64bits integer can fit in 32 bits integer, because js
	        // won't let us have more.
	        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
	            this.uncompressedSize = extraReader.readInt(8);
	        }
	        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
	            this.compressedSize = extraReader.readInt(8);
	        }
	        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
	            this.localHeaderOffset = extraReader.readInt(8);
	        }
	        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
	            this.diskNumberStart = extraReader.readInt(4);
	        }
	    },
	    /**
	     * Read the central part of a zip file and add the info in this object.
	     * @param {DataReader} reader the reader to use.
	     */
	    readExtraFields: function(reader) {
	        var start = reader.index,
	            extraFieldId,
	            extraFieldLength,
	            extraFieldValue;
	
	        this.extraFields = this.extraFields || {};
	
	        while (reader.index < start + this.extraFieldsLength) {
	            extraFieldId = reader.readInt(2);
	            extraFieldLength = reader.readInt(2);
	            extraFieldValue = reader.readString(extraFieldLength);
	
	            this.extraFields[extraFieldId] = {
	                id: extraFieldId,
	                length: extraFieldLength,
	                value: extraFieldValue
	            };
	        }
	    },
	    /**
	     * Apply an UTF8 transformation if needed.
	     */
	    handleUTF8: function() {
	        if (this.useUTF8()) {
	            this.fileName = jszipProto.utf8decode(this.fileName);
	            this.fileComment = jszipProto.utf8decode(this.fileComment);
	        } else {
	            var upath = this.findExtraFieldUnicodePath();
	            if (upath !== null) {
	                this.fileName = upath;
	            }
	            var ucomment = this.findExtraFieldUnicodeComment();
	            if (ucomment !== null) {
	                this.fileComment = ucomment;
	            }
	        }
	    },
	
	    /**
	     * Find the unicode path declared in the extra field, if any.
	     * @return {String} the unicode path, null otherwise.
	     */
	    findExtraFieldUnicodePath: function() {
	        var upathField = this.extraFields[0x7075];
	        if (upathField) {
	            var extraReader = new StringReader(upathField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the filename changed, this field is out of date.
	            if (jszipProto.crc32(this.fileName) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(upathField.length - 5));
	        }
	        return null;
	    },
	
	    /**
	     * Find the unicode comment declared in the extra field, if any.
	     * @return {String} the unicode comment, null otherwise.
	     */
	    findExtraFieldUnicodeComment: function() {
	        var ucommentField = this.extraFields[0x6375];
	        if (ucommentField) {
	            var extraReader = new StringReader(ucommentField.value);
	
	            // wrong version
	            if (extraReader.readInt(1) !== 1) {
	                return null;
	            }
	
	            // the crc of the comment changed, this field is out of date.
	            if (jszipProto.crc32(this.fileComment) !== extraReader.readInt(4)) {
	                return null;
	            }
	
	            return jszipProto.utf8decode(extraReader.readString(ucommentField.length - 5));
	        }
	        return null;
	    }
	};
	module.exports = ZipEntry;
	
	},{"./compressedObject":2,"./object":13,"./stringReader":15,"./utils":21}],24:[function(_dereq_,module,exports){
	// Top level file is just a mixin of submodules & constants
	'use strict';
	
	var assign    = _dereq_('./lib/utils/common').assign;
	
	var deflate   = _dereq_('./lib/deflate');
	var inflate   = _dereq_('./lib/inflate');
	var constants = _dereq_('./lib/zlib/constants');
	
	var pako = {};
	
	assign(pako, deflate, inflate, constants);
	
	module.exports = pako;
	},{"./lib/deflate":25,"./lib/inflate":26,"./lib/utils/common":27,"./lib/zlib/constants":30}],25:[function(_dereq_,module,exports){
	'use strict';
	
	
	var zlib_deflate = _dereq_('./zlib/deflate.js');
	var utils = _dereq_('./utils/common');
	var strings = _dereq_('./utils/strings');
	var msg = _dereq_('./zlib/messages');
	var zstream = _dereq_('./zlib/zstream');
	
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	var Z_NO_FLUSH      = 0;
	var Z_FINISH        = 4;
	
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	
	var Z_DEFAULT_COMPRESSION = -1;
	
	var Z_DEFAULT_STRATEGY    = 0;
	
	var Z_DEFLATED  = 8;
	
	/* ===========================================================================*/
	
	
	/**
	 * class Deflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[deflate]],
	 * [[deflateRaw]] and [[gzip]].
	 **/
	
	/* internal
	 * Deflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Deflate#onData]] not overriden.
	 **/
	
	/**
	 * Deflate.result -> Uint8Array|Array
	 *
	 * Compressed result, generated by default [[Deflate#onData]]
	 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
	 **/
	
	/**
	 * Deflate.err -> Number
	 *
	 * Error code after deflate finished. 0 (Z_OK) on success.
	 * You will not need it in real life, because deflate errors
	 * are possible only on wrong options or bad `onData` / `onEnd`
	 * custom handlers.
	 **/
	
	/**
	 * Deflate.msg -> String
	 *
	 * Error message, if [[Deflate.err]] != 0
	 **/
	
	
	/**
	 * new Deflate(options)
	 * - options (Object): zlib deflate options.
	 *
	 * Creates new deflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `level`
	 * - `windowBits`
	 * - `memLevel`
	 * - `strategy`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw deflate
	 * - `gzip` (Boolean) - create gzip wrapper
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 * - `header` (Object) - custom header for gzip
	 *   - `text` (Boolean) - true if compressed data believed to be text
	 *   - `time` (Number) - modification time, unix timestamp
	 *   - `os` (Number) - operation system code
	 *   - `extra` (Array) - array of bytes with extra data (max 65536)
	 *   - `name` (String) - file name (binary string)
	 *   - `comment` (String) - comment (binary string)
	 *   - `hcrc` (Boolean) - true if header crc should be added
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var deflate = new pako.Deflate({ level: 3});
	 *
	 * deflate.push(chunk1, false);
	 * deflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (deflate.err) { throw new Error(deflate.err); }
	 *
	 * console.log(deflate.result);
	 * ```
	 **/
	var Deflate = function(options) {
	
	  this.options = utils.assign({
	    level: Z_DEFAULT_COMPRESSION,
	    method: Z_DEFLATED,
	    chunkSize: 16384,
	    windowBits: 15,
	    memLevel: 8,
	    strategy: Z_DEFAULT_STRATEGY,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  if (opt.raw && (opt.windowBits > 0)) {
	    opt.windowBits = -opt.windowBits;
	  }
	
	  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
	    opt.windowBits += 16;
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm = new zstream();
	  this.strm.avail_out = 0;
	
	  var status = zlib_deflate.deflateInit2(
	    this.strm,
	    opt.level,
	    opt.method,
	    opt.windowBits,
	    opt.memLevel,
	    opt.strategy
	  );
	
	  if (status !== Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  if (opt.header) {
	    zlib_deflate.deflateSetHeader(this.strm, opt.header);
	  }
	};
	
	/**
	 * Deflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|String): input data. Strings will be converted to
	 *   utf8 byte sequence.
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
	 * new compressed chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
	 * [[Deflate#onEnd]].
	 *
	 * On fail call [[Deflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * array format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Deflate.prototype.push = function(data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	
	  if (this.ended) { return false; }
	
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // If we need to compress text, change encoding to utf8.
	    strm.input = strings.string2buf(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */
	
	    if (status !== Z_STREAM_END && status !== Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	    if (strm.avail_out === 0 || (strm.avail_in === 0 && _mode === Z_FINISH)) {
	      if (this.options.to === 'string') {
	        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
	      } else {
	        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	      }
	    }
	  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);
	
	  // Finalize on the last chunk.
	  if (_mode === Z_FINISH) {
	    status = zlib_deflate.deflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === Z_OK;
	  }
	
	  return true;
	};
	
	
	/**
	 * Deflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Deflate.prototype.onData = function(chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Deflate#onEnd(status) -> Void
	 * - status (Number): deflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell deflate that input stream complete
	 * or error happenned. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Deflate.prototype.onEnd = function(status) {
	  // On success - join
	  if (status === Z_OK) {
	    if (this.options.to === 'string') {
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * deflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * Compress `data` with deflate alrorythm and `options`.
	 *
	 * Supported options are:
	 *
	 * - level
	 * - windowBits
	 * - memLevel
	 * - strategy
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be "binary string"
	 *    (each char code [0..255])
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
	 *
	 * console.log(pako.deflate(data));
	 * ```
	 **/
	function deflate(input, options) {
	  var deflator = new Deflate(options);
	
	  deflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (deflator.err) { throw deflator.msg; }
	
	  return deflator.result;
	}
	
	
	/**
	 * deflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function deflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return deflate(input, options);
	}
	
	
	/**
	 * gzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to compress.
	 * - options (Object): zlib deflate options.
	 *
	 * The same as [[deflate]], but create gzip wrapper instead of
	 * deflate one.
	 **/
	function gzip(input, options) {
	  options = options || {};
	  options.gzip = true;
	  return deflate(input, options);
	}
	
	
	exports.Deflate = Deflate;
	exports.deflate = deflate;
	exports.deflateRaw = deflateRaw;
	exports.gzip = gzip;
	},{"./utils/common":27,"./utils/strings":28,"./zlib/deflate.js":32,"./zlib/messages":37,"./zlib/zstream":39}],26:[function(_dereq_,module,exports){
	'use strict';
	
	
	var zlib_inflate = _dereq_('./zlib/inflate.js');
	var utils = _dereq_('./utils/common');
	var strings = _dereq_('./utils/strings');
	var c = _dereq_('./zlib/constants');
	var msg = _dereq_('./zlib/messages');
	var zstream = _dereq_('./zlib/zstream');
	var gzheader = _dereq_('./zlib/gzheader');
	
	
	/**
	 * class Inflate
	 *
	 * Generic JS-style wrapper for zlib calls. If you don't need
	 * streaming behaviour - use more simple functions: [[inflate]]
	 * and [[inflateRaw]].
	 **/
	
	/* internal
	 * inflate.chunks -> Array
	 *
	 * Chunks of output data, if [[Inflate#onData]] not overriden.
	 **/
	
	/**
	 * Inflate.result -> Uint8Array|Array|String
	 *
	 * Uncompressed result, generated by default [[Inflate#onData]]
	 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
	 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
	 **/
	
	/**
	 * Inflate.err -> Number
	 *
	 * Error code after inflate finished. 0 (Z_OK) on success.
	 * Should be checked if broken data possible.
	 **/
	
	/**
	 * Inflate.msg -> String
	 *
	 * Error message, if [[Inflate.err]] != 0
	 **/
	
	
	/**
	 * new Inflate(options)
	 * - options (Object): zlib inflate options.
	 *
	 * Creates new inflator instance with specified params. Throws exception
	 * on bad params. Supported options:
	 *
	 * - `windowBits`
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information on these.
	 *
	 * Additional options, for internal needs:
	 *
	 * - `chunkSize` - size of generated data chunks (16K by default)
	 * - `raw` (Boolean) - do raw inflate
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 * By default, when no options set, autodetect deflate/gzip data format via
	 * wrapper header.
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
	 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
	 *
	 * var inflate = new pako.Inflate({ level: 3});
	 *
	 * inflate.push(chunk1, false);
	 * inflate.push(chunk2, true);  // true -> last chunk
	 *
	 * if (inflate.err) { throw new Error(inflate.err); }
	 *
	 * console.log(inflate.result);
	 * ```
	 **/
	var Inflate = function(options) {
	
	  this.options = utils.assign({
	    chunkSize: 16384,
	    windowBits: 0,
	    to: ''
	  }, options || {});
	
	  var opt = this.options;
	
	  // Force window size for `raw` data, if not set directly,
	  // because we have no header for autodetect.
	  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
	    opt.windowBits = -opt.windowBits;
	    if (opt.windowBits === 0) { opt.windowBits = -15; }
	  }
	
	  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
	  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
	      !(options && options.windowBits)) {
	    opt.windowBits += 32;
	  }
	
	  // Gzip header has no info about windows size, we can do autodetect only
	  // for deflate. So, if window size not set, force it to max when gzip possible
	  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
	    // bit 3 (16) -> gzipped data
	    // bit 4 (32) -> autodetect gzip/deflate
	    if ((opt.windowBits & 15) === 0) {
	      opt.windowBits |= 15;
	    }
	  }
	
	  this.err    = 0;      // error code, if happens (0 = Z_OK)
	  this.msg    = '';     // error message
	  this.ended  = false;  // used to avoid multiple onEnd() calls
	  this.chunks = [];     // chunks of compressed data
	
	  this.strm   = new zstream();
	  this.strm.avail_out = 0;
	
	  var status  = zlib_inflate.inflateInit2(
	    this.strm,
	    opt.windowBits
	  );
	
	  if (status !== c.Z_OK) {
	    throw new Error(msg[status]);
	  }
	
	  this.header = new gzheader();
	
	  zlib_inflate.inflateGetHeader(this.strm, this.header);
	};
	
	/**
	 * Inflate#push(data[, mode]) -> Boolean
	 * - data (Uint8Array|Array|String): input data
	 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
	 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
	 *
	 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
	 * new output chunks. Returns `true` on success. The last data block must have
	 * mode Z_FINISH (or `true`). That flush internal pending buffers and call
	 * [[Inflate#onEnd]].
	 *
	 * On fail call [[Inflate#onEnd]] with error code and return false.
	 *
	 * We strongly recommend to use `Uint8Array` on input for best speed (output
	 * format is detected automatically). Also, don't skip last param and always
	 * use the same type in your code (boolean or number). That will improve JS speed.
	 *
	 * For regular `Array`-s make sure all elements are [0..255].
	 *
	 * ##### Example
	 *
	 * ```javascript
	 * push(chunk, false); // push one of data chunks
	 * ...
	 * push(chunk, true);  // push last chunk
	 * ```
	 **/
	Inflate.prototype.push = function(data, mode) {
	  var strm = this.strm;
	  var chunkSize = this.options.chunkSize;
	  var status, _mode;
	  var next_out_utf8, tail, utf8str;
	
	  if (this.ended) { return false; }
	  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);
	
	  // Convert data if needed
	  if (typeof data === 'string') {
	    // Only binary strings can be decompressed on practice
	    strm.input = strings.binstring2buf(data);
	  } else {
	    strm.input = data;
	  }
	
	  strm.next_in = 0;
	  strm.avail_in = strm.input.length;
	
	  do {
	    if (strm.avail_out === 0) {
	      strm.output = new utils.Buf8(chunkSize);
	      strm.next_out = 0;
	      strm.avail_out = chunkSize;
	    }
	
	    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */
	
	    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
	      this.onEnd(status);
	      this.ended = true;
	      return false;
	    }
	
	    if (strm.next_out) {
	      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && _mode === c.Z_FINISH)) {
	
	        if (this.options.to === 'string') {
	
	          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
	
	          tail = strm.next_out - next_out_utf8;
	          utf8str = strings.buf2string(strm.output, next_out_utf8);
	
	          // move tail
	          strm.next_out = tail;
	          strm.avail_out = chunkSize - tail;
	          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }
	
	          this.onData(utf8str);
	
	        } else {
	          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
	        }
	      }
	    }
	  } while ((strm.avail_in > 0) && status !== c.Z_STREAM_END);
	
	  if (status === c.Z_STREAM_END) {
	    _mode = c.Z_FINISH;
	  }
	  // Finalize on the last chunk.
	  if (_mode === c.Z_FINISH) {
	    status = zlib_inflate.inflateEnd(this.strm);
	    this.onEnd(status);
	    this.ended = true;
	    return status === c.Z_OK;
	  }
	
	  return true;
	};
	
	
	/**
	 * Inflate#onData(chunk) -> Void
	 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
	 *   on js engine support. When string output requested, each chunk
	 *   will be string.
	 *
	 * By default, stores data blocks in `chunks[]` property and glue
	 * those in `onEnd`. Override this handler, if you need another behaviour.
	 **/
	Inflate.prototype.onData = function(chunk) {
	  this.chunks.push(chunk);
	};
	
	
	/**
	 * Inflate#onEnd(status) -> Void
	 * - status (Number): inflate status. 0 (Z_OK) on success,
	 *   other if not.
	 *
	 * Called once after you tell inflate that input stream complete
	 * or error happenned. By default - join collected chunks,
	 * free memory and fill `results` / `err` properties.
	 **/
	Inflate.prototype.onEnd = function(status) {
	  // On success - join
	  if (status === c.Z_OK) {
	    if (this.options.to === 'string') {
	      // Glue & convert here, until we teach pako to send
	      // utf8 alligned strings to onData
	      this.result = this.chunks.join('');
	    } else {
	      this.result = utils.flattenChunks(this.chunks);
	    }
	  }
	  this.chunks = [];
	  this.err = status;
	  this.msg = this.strm.msg;
	};
	
	
	/**
	 * inflate(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Decompress `data` with inflate/ungzip and `options`. Autodetect
	 * format via wrapper header by default. That's why we don't provide
	 * separate `ungzip` method.
	 *
	 * Supported options are:
	 *
	 * - windowBits
	 *
	 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
	 * for more information.
	 *
	 * Sugar (options):
	 *
	 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
	 *   negative windowBits implicitly.
	 * - `to` (String) - if equal to 'string', then result will be converted
	 *   from utf8 to utf16 (javascript) string. When string output requested,
	 *   chunk length can differ from `chunkSize`, depending on content.
	 *
	 *
	 * ##### Example:
	 *
	 * ```javascript
	 * var pako = require('pako')
	 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
	 *   , output;
	 *
	 * try {
	 *   output = pako.inflate(input);
	 * } catch (err)
	 *   console.log(err);
	 * }
	 * ```
	 **/
	function inflate(input, options) {
	  var inflator = new Inflate(options);
	
	  inflator.push(input, true);
	
	  // That will never happens, if you don't cheat with options :)
	  if (inflator.err) { throw inflator.msg; }
	
	  return inflator.result;
	}
	
	
	/**
	 * inflateRaw(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * The same as [[inflate]], but creates raw data, without wrapper
	 * (header and adler32 crc).
	 **/
	function inflateRaw(input, options) {
	  options = options || {};
	  options.raw = true;
	  return inflate(input, options);
	}
	
	
	/**
	 * ungzip(data[, options]) -> Uint8Array|Array|String
	 * - data (Uint8Array|Array|String): input data to decompress.
	 * - options (Object): zlib inflate options.
	 *
	 * Just shortcut to [[inflate]], because it autodetects format
	 * by header.content. Done for convenience.
	 **/
	
	
	exports.Inflate = Inflate;
	exports.inflate = inflate;
	exports.inflateRaw = inflateRaw;
	exports.ungzip  = inflate;
	
	},{"./utils/common":27,"./utils/strings":28,"./zlib/constants":30,"./zlib/gzheader":33,"./zlib/inflate.js":35,"./zlib/messages":37,"./zlib/zstream":39}],27:[function(_dereq_,module,exports){
	'use strict';
	
	
	var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
	                (typeof Uint16Array !== 'undefined') &&
	                (typeof Int32Array !== 'undefined');
	
	
	exports.assign = function (obj /*from1, from2, from3, ...*/) {
	  var sources = Array.prototype.slice.call(arguments, 1);
	  while (sources.length) {
	    var source = sources.shift();
	    if (!source) { continue; }
	
	    if (typeof(source) !== 'object') {
	      throw new TypeError(source + 'must be non-object');
	    }
	
	    for (var p in source) {
	      if (source.hasOwnProperty(p)) {
	        obj[p] = source[p];
	      }
	    }
	  }
	
	  return obj;
	};
	
	
	// reduce buffer size, avoiding mem copy
	exports.shrinkBuf = function (buf, size) {
	  if (buf.length === size) { return buf; }
	  if (buf.subarray) { return buf.subarray(0, size); }
	  buf.length = size;
	  return buf;
	};
	
	
	var fnTyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    if (src.subarray && dest.subarray) {
	      dest.set(src.subarray(src_offs, src_offs+len), dest_offs);
	      return;
	    }
	    // Fallback to ordinary array
	    for(var i=0; i<len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function(chunks) {
	    var i, l, len, pos, chunk, result;
	
	    // calculate data length
	    len = 0;
	    for (i=0, l=chunks.length; i<l; i++) {
	      len += chunks[i].length;
	    }
	
	    // join chunks
	    result = new Uint8Array(len);
	    pos = 0;
	    for (i=0, l=chunks.length; i<l; i++) {
	      chunk = chunks[i];
	      result.set(chunk, pos);
	      pos += chunk.length;
	    }
	
	    return result;
	  }
	};
	
	var fnUntyped = {
	  arraySet: function (dest, src, src_offs, len, dest_offs) {
	    for(var i=0; i<len; i++) {
	      dest[dest_offs + i] = src[src_offs + i];
	    }
	  },
	  // Join array of chunks to single array.
	  flattenChunks: function(chunks) {
	    return [].concat.apply([], chunks);
	  }
	};
	
	
	// Enable/Disable typed arrays use, for testing
	//
	exports.setTyped = function (on) {
	  if (on) {
	    exports.Buf8  = Uint8Array;
	    exports.Buf16 = Uint16Array;
	    exports.Buf32 = Int32Array;
	    exports.assign(exports, fnTyped);
	  } else {
	    exports.Buf8  = Array;
	    exports.Buf16 = Array;
	    exports.Buf32 = Array;
	    exports.assign(exports, fnUntyped);
	  }
	};
	
	exports.setTyped(TYPED_OK);
	},{}],28:[function(_dereq_,module,exports){
	// String encode/decode helpers
	'use strict';
	
	
	var utils = _dereq_('./common');
	
	
	// Quick check if we can use fast array to bin string conversion
	//
	// - apply(Array) can fail on Android 2.2
	// - apply(Uint8Array) can fail on iOS 5.1 Safary
	//
	var STR_APPLY_OK = true;
	var STR_APPLY_UIA_OK = true;
	
	try { String.fromCharCode.apply(null, [0]); } catch(__) { STR_APPLY_OK = false; }
	try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch(__) { STR_APPLY_UIA_OK = false; }
	
	
	// Table with utf8 lengths (calculated by first byte of sequence)
	// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
	// because max possible codepoint is 0x10ffff
	var _utf8len = new utils.Buf8(256);
	for (var i=0; i<256; i++) {
	  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
	}
	_utf8len[254]=_utf8len[254]=1; // Invalid sequence start
	
	
	// convert string to array (typed, when possible)
	exports.string2buf = function (str) {
	  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
	
	  // count binary size
	  for (m_pos = 0; m_pos < str_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	      c2 = str.charCodeAt(m_pos+1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
	  }
	
	  // allocate buffer
	  buf = new utils.Buf8(buf_len);
	
	  // convert
	  for (i=0, m_pos = 0; i < buf_len; m_pos++) {
	    c = str.charCodeAt(m_pos);
	    if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
	      c2 = str.charCodeAt(m_pos+1);
	      if ((c2 & 0xfc00) === 0xdc00) {
	        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
	        m_pos++;
	      }
	    }
	    if (c < 0x80) {
	      /* one byte */
	      buf[i++] = c;
	    } else if (c < 0x800) {
	      /* two bytes */
	      buf[i++] = 0xC0 | (c >>> 6);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else if (c < 0x10000) {
	      /* three bytes */
	      buf[i++] = 0xE0 | (c >>> 12);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    } else {
	      /* four bytes */
	      buf[i++] = 0xf0 | (c >>> 18);
	      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
	      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
	      buf[i++] = 0x80 | (c & 0x3f);
	    }
	  }
	
	  return buf;
	};
	
	// Helper (used in 2 places)
	function buf2binstring(buf, len) {
	  // use fallback for big arrays to avoid stack overflow
	  if (len < 65537) {
	    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
	      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
	    }
	  }
	
	  var result = '';
	  for(var i=0; i < len; i++) {
	    result += String.fromCharCode(buf[i]);
	  }
	  return result;
	}
	
	
	// Convert byte array to binary string
	exports.buf2binstring = function(buf) {
	  return buf2binstring(buf, buf.length);
	};
	
	
	// Convert binary string (typed, when possible)
	exports.binstring2buf = function(str) {
	  var buf = new utils.Buf8(str.length);
	  for(var i=0, len=buf.length; i < len; i++) {
	    buf[i] = str.charCodeAt(i);
	  }
	  return buf;
	};
	
	
	// convert array to string
	exports.buf2string = function (buf, max) {
	  var i, out, c, c_len;
	  var len = max || buf.length;
	
	  // Reserve max possible length (2 words per char)
	  // NB: by unknown reasons, Array is significantly faster for
	  //     String.fromCharCode.apply than Uint16Array.
	  var utf16buf = new Array(len*2);
	
	  for (out=0, i=0; i<len;) {
	    c = buf[i++];
	    // quick process ascii
	    if (c < 0x80) { utf16buf[out++] = c; continue; }
	
	    c_len = _utf8len[c];
	    // skip 5 & 6 byte codes
	    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }
	
	    // apply mask on first byte
	    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
	    // join the rest
	    while (c_len > 1 && i < len) {
	      c = (c << 6) | (buf[i++] & 0x3f);
	      c_len--;
	    }
	
	    // terminated by end of string?
	    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }
	
	    if (c < 0x10000) {
	      utf16buf[out++] = c;
	    } else {
	      c -= 0x10000;
	      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
	      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
	    }
	  }
	
	  return buf2binstring(utf16buf, out);
	};
	
	
	// Calculate max possible position in utf8 buffer,
	// that will not break sequence. If that's not possible
	// - (very small limits) return max size as is.
	//
	// buf[] - utf8 bytes array
	// max   - length limit (mandatory);
	exports.utf8border = function(buf, max) {
	  var pos;
	
	  max = max || buf.length;
	  if (max > buf.length) { max = buf.length; }
	
	  // go back from last position, until start of sequence found
	  pos = max-1;
	  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }
	
	  // Fuckup - very small and broken sequence,
	  // return max, because we should return something anyway.
	  if (pos < 0) { return max; }
	
	  // If we came to start of buffer - that means vuffer is too small,
	  // return max too.
	  if (pos === 0) { return max; }
	
	  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
	};
	
	},{"./common":27}],29:[function(_dereq_,module,exports){
	'use strict';
	
	// Note: adler32 takes 12% for level 0 and 2% for level 6.
	// It doesn't worth to make additional optimizationa as in original.
	// Small size is preferable.
	
	function adler32(adler, buf, len, pos) {
	  var s1 = (adler & 0xffff) |0
	    , s2 = ((adler >>> 16) & 0xffff) |0
	    , n = 0;
	
	  while (len !== 0) {
	    // Set limit ~ twice less than 5552, to keep
	    // s2 in 31-bits, because we force signed ints.
	    // in other case %= will fail.
	    n = len > 2000 ? 2000 : len;
	    len -= n;
	
	    do {
	      s1 = (s1 + buf[pos++]) |0;
	      s2 = (s2 + s1) |0;
	    } while (--n);
	
	    s1 %= 65521;
	    s2 %= 65521;
	  }
	
	  return (s1 | (s2 << 16)) |0;
	}
	
	
	module.exports = adler32;
	},{}],30:[function(_dereq_,module,exports){
	module.exports = {
	
	  /* Allowed flush values; see deflate() and inflate() below for details */
	  Z_NO_FLUSH:         0,
	  Z_PARTIAL_FLUSH:    1,
	  Z_SYNC_FLUSH:       2,
	  Z_FULL_FLUSH:       3,
	  Z_FINISH:           4,
	  Z_BLOCK:            5,
	  Z_TREES:            6,
	
	  /* Return codes for the compression/decompression functions. Negative values
	  * are errors, positive values are used for special but normal events.
	  */
	  Z_OK:               0,
	  Z_STREAM_END:       1,
	  Z_NEED_DICT:        2,
	  Z_ERRNO:           -1,
	  Z_STREAM_ERROR:    -2,
	  Z_DATA_ERROR:      -3,
	  //Z_MEM_ERROR:     -4,
	  Z_BUF_ERROR:       -5,
	  //Z_VERSION_ERROR: -6,
	
	  /* compression levels */
	  Z_NO_COMPRESSION:         0,
	  Z_BEST_SPEED:             1,
	  Z_BEST_COMPRESSION:       9,
	  Z_DEFAULT_COMPRESSION:   -1,
	
	
	  Z_FILTERED:               1,
	  Z_HUFFMAN_ONLY:           2,
	  Z_RLE:                    3,
	  Z_FIXED:                  4,
	  Z_DEFAULT_STRATEGY:       0,
	
	  /* Possible values of the data_type field (though see inflate()) */
	  Z_BINARY:                 0,
	  Z_TEXT:                   1,
	  //Z_ASCII:                1, // = Z_TEXT (deprecated)
	  Z_UNKNOWN:                2,
	
	  /* The deflate compression method */
	  Z_DEFLATED:               8
	  //Z_NULL:                 null // Use -1 or null inline, depending on var type
	};
	},{}],31:[function(_dereq_,module,exports){
	'use strict';
	
	// Note: we can't get significant speed boost here.
	// So write code to minimize size - no pregenerated tables
	// and array tools dependencies.
	
	
	// Use ordinary array, since untyped makes no boost here
	function makeTable() {
	  var c, table = [];
	
	  for(var n =0; n < 256; n++){
	    c = n;
	    for(var k =0; k < 8; k++){
	      c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
	    }
	    table[n] = c;
	  }
	
	  return table;
	}
	
	// Create table on load. Just 255 signed longs. Not a problem.
	var crcTable = makeTable();
	
	
	function crc32(crc, buf, len, pos) {
	  var t = crcTable
	    , end = pos + len;
	
	  crc = crc ^ (-1);
	
	  for (var i = pos; i < end; i++ ) {
	    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
	  }
	
	  return (crc ^ (-1)); // >>> 0;
	}
	
	
	module.exports = crc32;
	},{}],32:[function(_dereq_,module,exports){
	'use strict';
	
	var utils   = _dereq_('../utils/common');
	var trees   = _dereq_('./trees');
	var adler32 = _dereq_('./adler32');
	var crc32   = _dereq_('./crc32');
	var msg   = _dereq_('./messages');
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	var Z_NO_FLUSH      = 0;
	var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	//var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	//var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	//var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	
	/* compression levels */
	//var Z_NO_COMPRESSION      = 0;
	//var Z_BEST_SPEED          = 1;
	//var Z_BEST_COMPRESSION    = 9;
	var Z_DEFAULT_COMPRESSION = -1;
	
	
	var Z_FILTERED            = 1;
	var Z_HUFFMAN_ONLY        = 2;
	var Z_RLE                 = 3;
	var Z_FIXED               = 4;
	var Z_DEFAULT_STRATEGY    = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	//var Z_BINARY              = 0;
	//var Z_TEXT                = 1;
	//var Z_ASCII               = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	/*============================================================================*/
	
	
	var MAX_MEM_LEVEL = 9;
	/* Maximum value for memLevel in deflateInit2 */
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_MEM_LEVEL = 8;
	
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	var D_CODES       = 30;
	/* number of distance codes */
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	var HEAP_SIZE     = 2*L_CODES + 1;
	/* maximum heap size */
	var MAX_BITS  = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var MIN_MATCH = 3;
	var MAX_MATCH = 258;
	var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);
	
	var PRESET_DICT = 0x20;
	
	var INIT_STATE = 42;
	var EXTRA_STATE = 69;
	var NAME_STATE = 73;
	var COMMENT_STATE = 91;
	var HCRC_STATE = 103;
	var BUSY_STATE = 113;
	var FINISH_STATE = 666;
	
	var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
	var BS_BLOCK_DONE     = 2; /* block flush performed */
	var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
	var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */
	
	var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
	
	function err(strm, errorCode) {
	  strm.msg = msg[errorCode];
	  return errorCode;
	}
	
	function rank(f) {
	  return ((f) << 1) - ((f) > 4 ? 9 : 0);
	}
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	
	/* =========================================================================
	 * Flush as much pending output as possible. All deflate() output goes
	 * through this function so some applications may wish to modify it
	 * to avoid allocating a large strm->output buffer and copying into it.
	 * (See also read_buf()).
	 */
	function flush_pending(strm) {
	  var s = strm.state;
	
	  //_tr_flush_bits(s);
	  var len = s.pending;
	  if (len > strm.avail_out) {
	    len = strm.avail_out;
	  }
	  if (len === 0) { return; }
	
	  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
	  strm.next_out += len;
	  s.pending_out += len;
	  strm.total_out += len;
	  strm.avail_out -= len;
	  s.pending -= len;
	  if (s.pending === 0) {
	    s.pending_out = 0;
	  }
	}
	
	
	function flush_block_only (s, last) {
	  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
	  s.block_start = s.strstart;
	  flush_pending(s.strm);
	}
	
	
	function put_byte(s, b) {
	  s.pending_buf[s.pending++] = b;
	}
	
	
	/* =========================================================================
	 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
	 * IN assertion: the stream state is correct and there is enough room in
	 * pending_buf.
	 */
	function putShortMSB(s, b) {
	//  put_byte(s, (Byte)(b >> 8));
	//  put_byte(s, (Byte)(b & 0xff));
	  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
	  s.pending_buf[s.pending++] = b & 0xff;
	}
	
	
	/* ===========================================================================
	 * Read a new buffer from the current input stream, update the adler32
	 * and total number of bytes read.  All deflate() input goes through
	 * this function so some applications may wish to modify it to avoid
	 * allocating a large strm->input buffer and copying from it.
	 * (See also flush_pending()).
	 */
	function read_buf(strm, buf, start, size) {
	  var len = strm.avail_in;
	
	  if (len > size) { len = size; }
	  if (len === 0) { return 0; }
	
	  strm.avail_in -= len;
	
	  utils.arraySet(buf, strm.input, strm.next_in, len, start);
	  if (strm.state.wrap === 1) {
	    strm.adler = adler32(strm.adler, buf, len, start);
	  }
	
	  else if (strm.state.wrap === 2) {
	    strm.adler = crc32(strm.adler, buf, len, start);
	  }
	
	  strm.next_in += len;
	  strm.total_in += len;
	
	  return len;
	}
	
	
	/* ===========================================================================
	 * Set match_start to the longest match starting at the given string and
	 * return its length. Matches shorter or equal to prev_length are discarded,
	 * in which case the result is equal to prev_length and match_start is
	 * garbage.
	 * IN assertions: cur_match is the head of the hash chain for the current
	 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
	 * OUT assertion: the match length is not greater than s->lookahead.
	 */
	function longest_match(s, cur_match) {
	  var chain_length = s.max_chain_length;      /* max hash chain length */
	  var scan = s.strstart; /* current string */
	  var match;                       /* matched string */
	  var len;                           /* length of current match */
	  var best_len = s.prev_length;              /* best match length so far */
	  var nice_match = s.nice_match;             /* stop if match long enough */
	  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
	      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;
	
	  var _win = s.window; // shortcut
	
	  var wmask = s.w_mask;
	  var prev  = s.prev;
	
	  /* Stop when cur_match becomes <= limit. To simplify the code,
	   * we prevent matches with the string of window index 0.
	   */
	
	  var strend = s.strstart + MAX_MATCH;
	  var scan_end1  = _win[scan + best_len - 1];
	  var scan_end   = _win[scan + best_len];
	
	  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
	   * It is easy to get rid of this optimization if necessary.
	   */
	  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
	
	  /* Do not waste too much time if we already have a good match: */
	  if (s.prev_length >= s.good_match) {
	    chain_length >>= 2;
	  }
	  /* Do not look for matches beyond the end of the input. This is necessary
	   * to make deflate deterministic.
	   */
	  if (nice_match > s.lookahead) { nice_match = s.lookahead; }
	
	  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
	
	  do {
	    // Assert(cur_match < s->strstart, "no future");
	    match = cur_match;
	
	    /* Skip to next match if the match length cannot increase
	     * or if the match length is less than 2.  Note that the checks below
	     * for insufficient lookahead only occur occasionally for performance
	     * reasons.  Therefore uninitialized memory will be accessed, and
	     * conditional jumps will be made that depend on those values.
	     * However the length of the match is limited to the lookahead, so
	     * the output of deflate is not affected by the uninitialized values.
	     */
	
	    if (_win[match + best_len]     !== scan_end  ||
	        _win[match + best_len - 1] !== scan_end1 ||
	        _win[match]                !== _win[scan] ||
	        _win[++match]              !== _win[scan + 1]) {
	      continue;
	    }
	
	    /* The check at best_len-1 can be removed because it will be made
	     * again later. (This heuristic is not always a win.)
	     * It is not necessary to compare scan[2] and match[2] since they
	     * are always equal when the other bytes match, given that
	     * the hash keys are equal and that HASH_BITS >= 8.
	     */
	    scan += 2;
	    match++;
	    // Assert(*scan == *match, "match[2]?");
	
	    /* We check for insufficient lookahead only every 8th comparison;
	     * the 256th check will be made at strstart+258.
	     */
	    do {
	      /*jshint noempty:false*/
	    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
	             scan < strend);
	
	    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
	
	    len = MAX_MATCH - (strend - scan);
	    scan = strend - MAX_MATCH;
	
	    if (len > best_len) {
	      s.match_start = cur_match;
	      best_len = len;
	      if (len >= nice_match) {
	        break;
	      }
	      scan_end1  = _win[scan + best_len - 1];
	      scan_end   = _win[scan + best_len];
	    }
	  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
	
	  if (best_len <= s.lookahead) {
	    return best_len;
	  }
	  return s.lookahead;
	}
	
	
	/* ===========================================================================
	 * Fill the window when the lookahead becomes insufficient.
	 * Updates strstart and lookahead.
	 *
	 * IN assertion: lookahead < MIN_LOOKAHEAD
	 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
	 *    At least one byte has been read, or avail_in == 0; reads are
	 *    performed for at least two bytes (required for the zip translate_eol
	 *    option -- not supported here).
	 */
	function fill_window(s) {
	  var _w_size = s.w_size;
	  var p, n, m, more, str;
	
	  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
	
	  do {
	    more = s.window_size - s.lookahead - s.strstart;
	
	    // JS ints have 32 bit, block below not needed
	    /* Deal with !@#$% 64K limit: */
	    //if (sizeof(int) <= 2) {
	    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
	    //        more = wsize;
	    //
	    //  } else if (more == (unsigned)(-1)) {
	    //        /* Very unlikely, but possible on 16 bit machine if
	    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
	    //         */
	    //        more--;
	    //    }
	    //}
	
	
	    /* If the window is almost full and there is insufficient lookahead,
	     * move the upper half to the lower one to make room in the upper half.
	     */
	    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
	
	      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
	      s.match_start -= _w_size;
	      s.strstart -= _w_size;
	      /* we now have strstart >= MAX_DIST */
	      s.block_start -= _w_size;
	
	      /* Slide the hash table (could be avoided with 32 bit values
	       at the expense of memory usage). We slide even when level == 0
	       to keep the hash table consistent if we switch back to level > 0
	       later. (Using level 0 permanently is not an optimal usage of
	       zlib, so we don't care about this pathological case.)
	       */
	
	      n = s.hash_size;
	      p = n;
	      do {
	        m = s.head[--p];
	        s.head[p] = (m >= _w_size ? m - _w_size : 0);
	      } while (--n);
	
	      n = _w_size;
	      p = n;
	      do {
	        m = s.prev[--p];
	        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
	        /* If n is not on any hash chain, prev[n] is garbage but
	         * its value will never be used.
	         */
	      } while (--n);
	
	      more += _w_size;
	    }
	    if (s.strm.avail_in === 0) {
	      break;
	    }
	
	    /* If there was no sliding:
	     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
	     *    more == window_size - lookahead - strstart
	     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
	     * => more >= window_size - 2*WSIZE + 2
	     * In the BIG_MEM or MMAP case (not yet supported),
	     *   window_size == input_size + MIN_LOOKAHEAD  &&
	     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
	     * Otherwise, window_size == 2*WSIZE so more >= 2.
	     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
	     */
	    //Assert(more >= 2, "more < 2");
	    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
	    s.lookahead += n;
	
	    /* Initialize the hash value now that we have some input: */
	    if (s.lookahead + s.insert >= MIN_MATCH) {
	      str = s.strstart - s.insert;
	      s.ins_h = s.window[str];
	
	      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
	//#if MIN_MATCH != 3
	//        Call update_hash() MIN_MATCH-3 more times
	//#endif
	      while (s.insert) {
	        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH-1]) & s.hash_mask;
	
	        s.prev[str & s.w_mask] = s.head[s.ins_h];
	        s.head[s.ins_h] = str;
	        str++;
	        s.insert--;
	        if (s.lookahead + s.insert < MIN_MATCH) {
	          break;
	        }
	      }
	    }
	    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
	     * but this is not important since only literal bytes will be emitted.
	     */
	
	  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
	
	  /* If the WIN_INIT bytes after the end of the current data have never been
	   * written, then zero those bytes in order to avoid memory check reports of
	   * the use of uninitialized (or uninitialised as Julian writes) bytes by
	   * the longest match routines.  Update the high water mark for the next
	   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
	   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
	   */
	//  if (s.high_water < s.window_size) {
	//    var curr = s.strstart + s.lookahead;
	//    var init = 0;
	//
	//    if (s.high_water < curr) {
	//      /* Previous high water mark below current data -- zero WIN_INIT
	//       * bytes or up to end of window, whichever is less.
	//       */
	//      init = s.window_size - curr;
	//      if (init > WIN_INIT)
	//        init = WIN_INIT;
	//      zmemzero(s->window + curr, (unsigned)init);
	//      s->high_water = curr + init;
	//    }
	//    else if (s->high_water < (ulg)curr + WIN_INIT) {
	//      /* High water mark at or above current data, but below current data
	//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
	//       * to end of window, whichever is less.
	//       */
	//      init = (ulg)curr + WIN_INIT - s->high_water;
	//      if (init > s->window_size - s->high_water)
	//        init = s->window_size - s->high_water;
	//      zmemzero(s->window + s->high_water, (unsigned)init);
	//      s->high_water += init;
	//    }
	//  }
	//
	//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
	//    "not enough room for search");
	}
	
	/* ===========================================================================
	 * Copy without compression as much as possible from the input stream, return
	 * the current block state.
	 * This function does not insert new strings in the dictionary since
	 * uncompressible data is probably not useful. This function is used
	 * only for the level=0 compression option.
	 * NOTE: this function should be optimized to avoid extra copying from
	 * window to pending_buf.
	 */
	function deflate_stored(s, flush) {
	  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
	   * to pending_buf_size, and each stored block has a 5 byte header:
	   */
	  var max_block_size = 0xffff;
	
	  if (max_block_size > s.pending_buf_size - 5) {
	    max_block_size = s.pending_buf_size - 5;
	  }
	
	  /* Copy as much as possible from input to output: */
	  for (;;) {
	    /* Fill the window as much as possible: */
	    if (s.lookahead <= 1) {
	
	      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
	      //  s->block_start >= (long)s->w_size, "slide too late");
	//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
	//        s.block_start >= s.w_size)) {
	//        throw  new Error("slide too late");
	//      }
	
	      fill_window(s);
	      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	
	      if (s.lookahead === 0) {
	        break;
	      }
	      /* flush the current block */
	    }
	    //Assert(s->block_start >= 0L, "block gone");
	//    if (s.block_start < 0) throw new Error("block gone");
	
	    s.strstart += s.lookahead;
	    s.lookahead = 0;
	
	    /* Emit a stored block if pending_buf will be full: */
	    var max_start = s.block_start + max_block_size;
	
	    if (s.strstart === 0 || s.strstart >= max_start) {
	      /* strstart == 0 is possible when wraparound on 16-bit machine */
	      s.lookahead = s.strstart - max_start;
	      s.strstart = max_start;
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	
	
	    }
	    /* Flush if we may have to slide, otherwise block_start may become
	     * negative and the data will be gone:
	     */
	    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	
	  s.insert = 0;
	
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	
	  if (s.strstart > s.block_start) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_NEED_MORE;
	}
	
	/* ===========================================================================
	 * Compress as much as possible from the input stream, return the current
	 * block state.
	 * This function does not perform lazy evaluation of matches and inserts
	 * new strings in the dictionary only for unmatched strings or for short
	 * matches. It is used only for the fast compression options.
	 */
	function deflate_fast(s, flush) {
	  var hash_head;        /* head of the hash chain */
	  var bflush;           /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) {
	        break; /* flush the current block */
	      }
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     * At this point we have always match_length < MIN_MATCH
	     */
	    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	    }
	    if (s.match_length >= MIN_MATCH) {
	      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
	
	      /*** _tr_tally_dist(s, s.strstart - s.match_start,
	                     s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	
	      /* Insert new strings in the hash table only if the match length
	       * is not too large. This saves time but degrades compression.
	       */
	      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
	        s.match_length--; /* string at strstart already in table */
	        do {
	          s.strstart++;
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
	           * always MIN_MATCH bytes ahead.
	           */
	        } while (--s.match_length !== 0);
	        s.strstart++;
	      } else
	      {
	        s.strstart += s.match_length;
	        s.match_length = 0;
	        s.ins_h = s.window[s.strstart];
	        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
	        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;
	
	//#if MIN_MATCH != 3
	//                Call UPDATE_HASH() MIN_MATCH-3 more times
	//#endif
	        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
	         * matter since it will be recomputed at next deflate call.
	         */
	      }
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s.window[s.strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = ((s.strstart < (MIN_MATCH-1)) ? s.strstart : MIN_MATCH-1);
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * Same as above, but achieves better compression. We use a lazy
	 * evaluation for matches: a match is finally adopted only if there is
	 * no better match at the next window position.
	 */
	function deflate_slow(s, flush) {
	  var hash_head;          /* head of hash chain */
	  var bflush;              /* set if current block must be flushed */
	
	  var max_insert;
	
	  /* Process the input block. */
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the next match, plus MIN_MATCH bytes to insert the
	     * string following the next match.
	     */
	    if (s.lookahead < MIN_LOOKAHEAD) {
	      fill_window(s);
	      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* Insert the string window[strstart .. strstart+2] in the
	     * dictionary, and set hash_head to the head of the hash chain:
	     */
	    hash_head = 0/*NIL*/;
	    if (s.lookahead >= MIN_MATCH) {
	      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	      s.head[s.ins_h] = s.strstart;
	      /***/
	    }
	
	    /* Find the longest match, discarding those <= prev_length.
	     */
	    s.prev_length = s.match_length;
	    s.prev_match = s.match_start;
	    s.match_length = MIN_MATCH-1;
	
	    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
	        s.strstart - hash_head <= (s.w_size-MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
	      /* To simplify the code, we prevent matches with the string
	       * of window index 0 (in particular we have to avoid a match
	       * of the string with itself at the start of the input file).
	       */
	      s.match_length = longest_match(s, hash_head);
	      /* longest_match() sets match_start */
	
	      if (s.match_length <= 5 &&
	         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {
	
	        /* If prev_match is also MIN_MATCH, match_start is garbage
	         * but we will ignore the current match anyway.
	         */
	        s.match_length = MIN_MATCH-1;
	      }
	    }
	    /* If there was a match at the previous step and the current
	     * match is not better, output the previous match:
	     */
	    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
	      max_insert = s.strstart + s.lookahead - MIN_MATCH;
	      /* Do not insert strings in hash table beyond this. */
	
	      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
	
	      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
	                     s.prev_length - MIN_MATCH, bflush);***/
	      bflush = trees._tr_tally(s, s.strstart - 1- s.prev_match, s.prev_length - MIN_MATCH);
	      /* Insert in hash table all strings up to the end of the match.
	       * strstart-1 and strstart are already inserted. If there is not
	       * enough lookahead, the last two strings are not inserted in
	       * the hash table.
	       */
	      s.lookahead -= s.prev_length-1;
	      s.prev_length -= 2;
	      do {
	        if (++s.strstart <= max_insert) {
	          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
	          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
	          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
	          s.head[s.ins_h] = s.strstart;
	          /***/
	        }
	      } while (--s.prev_length !== 0);
	      s.match_available = 0;
	      s.match_length = MIN_MATCH-1;
	      s.strstart++;
	
	      if (bflush) {
	        /*** FLUSH_BLOCK(s, 0); ***/
	        flush_block_only(s, false);
	        if (s.strm.avail_out === 0) {
	          return BS_NEED_MORE;
	        }
	        /***/
	      }
	
	    } else if (s.match_available) {
	      /* If there was no match at the previous position, output a
	       * single literal. If there was a match but the current match
	       * is longer, truncate the previous match to a single literal.
	       */
	      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);
	
	      if (bflush) {
	        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
	        flush_block_only(s, false);
	        /***/
	      }
	      s.strstart++;
	      s.lookahead--;
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	    } else {
	      /* There is no previous match to compare with, wait for
	       * the next step to decide.
	       */
	      s.match_available = 1;
	      s.strstart++;
	      s.lookahead--;
	    }
	  }
	  //Assert (flush != Z_NO_FLUSH, "no flush?");
	  if (s.match_available) {
	    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
	    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart-1]);
	
	    s.match_available = 0;
	  }
	  s.insert = s.strstart < MIN_MATCH-1 ? s.strstart : MIN_MATCH-1;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	
	  return BS_BLOCK_DONE;
	}
	
	
	/* ===========================================================================
	 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
	 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
	 * deflate switches away from Z_RLE.)
	 */
	function deflate_rle(s, flush) {
	  var bflush;            /* set if current block must be flushed */
	  var prev;              /* byte at distance one to match */
	  var scan, strend;      /* scan goes up to strend for length of run */
	
	  var _win = s.window;
	
	  for (;;) {
	    /* Make sure that we always have enough lookahead, except
	     * at the end of the input file. We need MAX_MATCH bytes
	     * for the longest run, plus one for the unrolled loop.
	     */
	    if (s.lookahead <= MAX_MATCH) {
	      fill_window(s);
	      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
	        return BS_NEED_MORE;
	      }
	      if (s.lookahead === 0) { break; } /* flush the current block */
	    }
	
	    /* See how many times the previous byte repeats */
	    s.match_length = 0;
	    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
	      scan = s.strstart - 1;
	      prev = _win[scan];
	      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
	        strend = s.strstart + MAX_MATCH;
	        do {
	          /*jshint noempty:false*/
	        } while (prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 prev === _win[++scan] && prev === _win[++scan] &&
	                 scan < strend);
	        s.match_length = MAX_MATCH - (strend - scan);
	        if (s.match_length > s.lookahead) {
	          s.match_length = s.lookahead;
	        }
	      }
	      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
	    }
	
	    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
	    if (s.match_length >= MIN_MATCH) {
	      //check_match(s, s.strstart, s.strstart - 1, s.match_length);
	
	      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
	      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
	
	      s.lookahead -= s.match_length;
	      s.strstart += s.match_length;
	      s.match_length = 0;
	    } else {
	      /* No match, output a literal byte */
	      //Tracevv((stderr,"%c", s->window[s->strstart]));
	      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	
	      s.lookahead--;
	      s.strstart++;
	    }
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* ===========================================================================
	 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
	 * (It will be regenerated if this run of deflate switches away from Huffman.)
	 */
	function deflate_huff(s, flush) {
	  var bflush;             /* set if current block must be flushed */
	
	  for (;;) {
	    /* Make sure that we have a literal to write. */
	    if (s.lookahead === 0) {
	      fill_window(s);
	      if (s.lookahead === 0) {
	        if (flush === Z_NO_FLUSH) {
	          return BS_NEED_MORE;
	        }
	        break;      /* flush the current block */
	      }
	    }
	
	    /* Output a literal byte */
	    s.match_length = 0;
	    //Tracevv((stderr,"%c", s->window[s->strstart]));
	    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
	    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
	    s.lookahead--;
	    s.strstart++;
	    if (bflush) {
	      /*** FLUSH_BLOCK(s, 0); ***/
	      flush_block_only(s, false);
	      if (s.strm.avail_out === 0) {
	        return BS_NEED_MORE;
	      }
	      /***/
	    }
	  }
	  s.insert = 0;
	  if (flush === Z_FINISH) {
	    /*** FLUSH_BLOCK(s, 1); ***/
	    flush_block_only(s, true);
	    if (s.strm.avail_out === 0) {
	      return BS_FINISH_STARTED;
	    }
	    /***/
	    return BS_FINISH_DONE;
	  }
	  if (s.last_lit) {
	    /*** FLUSH_BLOCK(s, 0); ***/
	    flush_block_only(s, false);
	    if (s.strm.avail_out === 0) {
	      return BS_NEED_MORE;
	    }
	    /***/
	  }
	  return BS_BLOCK_DONE;
	}
	
	/* Values for max_lazy_match, good_match and max_chain_length, depending on
	 * the desired pack level (0..9). The values given below have been tuned to
	 * exclude worst case performance for pathological files. Better values may be
	 * found for specific files.
	 */
	var Config = function (good_length, max_lazy, nice_length, max_chain, func) {
	  this.good_length = good_length;
	  this.max_lazy = max_lazy;
	  this.nice_length = nice_length;
	  this.max_chain = max_chain;
	  this.func = func;
	};
	
	var configuration_table;
	
	configuration_table = [
	  /*      good lazy nice chain */
	  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
	  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
	  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
	  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */
	
	  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
	  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
	  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
	  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
	  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
	  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
	];
	
	
	/* ===========================================================================
	 * Initialize the "longest match" routines for a new zlib stream
	 */
	function lm_init(s) {
	  s.window_size = 2 * s.w_size;
	
	  /*** CLEAR_HASH(s); ***/
	  zero(s.head); // Fill with NIL (= 0);
	
	  /* Set the default configuration parameters:
	   */
	  s.max_lazy_match = configuration_table[s.level].max_lazy;
	  s.good_match = configuration_table[s.level].good_length;
	  s.nice_match = configuration_table[s.level].nice_length;
	  s.max_chain_length = configuration_table[s.level].max_chain;
	
	  s.strstart = 0;
	  s.block_start = 0;
	  s.lookahead = 0;
	  s.insert = 0;
	  s.match_length = s.prev_length = MIN_MATCH - 1;
	  s.match_available = 0;
	  s.ins_h = 0;
	}
	
	
	function DeflateState() {
	  this.strm = null;            /* pointer back to this zlib stream */
	  this.status = 0;            /* as the name implies */
	  this.pending_buf = null;      /* output still pending */
	  this.pending_buf_size = 0;  /* size of pending_buf */
	  this.pending_out = 0;       /* next pending byte to output to the stream */
	  this.pending = 0;           /* nb of bytes in the pending buffer */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.gzhead = null;         /* gzip header information to write */
	  this.gzindex = 0;           /* where in extra, name, or comment */
	  this.method = Z_DEFLATED; /* can only be DEFLATED */
	  this.last_flush = -1;   /* value of flush param for previous deflate call */
	
	  this.w_size = 0;  /* LZ77 window size (32K by default) */
	  this.w_bits = 0;  /* log2(w_size)  (8..16) */
	  this.w_mask = 0;  /* w_size - 1 */
	
	  this.window = null;
	  /* Sliding window. Input bytes are read into the second half of the window,
	   * and move to the first half later to keep a dictionary of at least wSize
	   * bytes. With this organization, matches are limited to a distance of
	   * wSize-MAX_MATCH bytes, but this ensures that IO is always
	   * performed with a length multiple of the block size.
	   */
	
	  this.window_size = 0;
	  /* Actual size of window: 2*wSize, except when the user input buffer
	   * is directly used as sliding window.
	   */
	
	  this.prev = null;
	  /* Link to older string with same hash index. To limit the size of this
	   * array to 64K, this link is maintained only for the last 32K strings.
	   * An index in this array is thus a window index modulo 32K.
	   */
	
	  this.head = null;   /* Heads of the hash chains or NIL. */
	
	  this.ins_h = 0;       /* hash index of string to be inserted */
	  this.hash_size = 0;   /* number of elements in hash table */
	  this.hash_bits = 0;   /* log2(hash_size) */
	  this.hash_mask = 0;   /* hash_size-1 */
	
	  this.hash_shift = 0;
	  /* Number of bits by which ins_h must be shifted at each input
	   * step. It must be such that after MIN_MATCH steps, the oldest
	   * byte no longer takes part in the hash key, that is:
	   *   hash_shift * MIN_MATCH >= hash_bits
	   */
	
	  this.block_start = 0;
	  /* Window position at the beginning of the current output block. Gets
	   * negative when the window is moved backwards.
	   */
	
	  this.match_length = 0;      /* length of best match */
	  this.prev_match = 0;        /* previous match */
	  this.match_available = 0;   /* set if previous match exists */
	  this.strstart = 0;          /* start of string to insert */
	  this.match_start = 0;       /* start of matching string */
	  this.lookahead = 0;         /* number of valid bytes ahead in window */
	
	  this.prev_length = 0;
	  /* Length of the best match at previous step. Matches not greater than this
	   * are discarded. This is used in the lazy match evaluation.
	   */
	
	  this.max_chain_length = 0;
	  /* To speed up deflation, hash chains are never searched beyond this
	   * length.  A higher limit improves compression ratio but degrades the
	   * speed.
	   */
	
	  this.max_lazy_match = 0;
	  /* Attempt to find a better match only when the current match is strictly
	   * smaller than this value. This mechanism is used only for compression
	   * levels >= 4.
	   */
	  // That's alias to max_lazy_match, don't use directly
	  //this.max_insert_length = 0;
	  /* Insert new strings in the hash table only if the match length is not
	   * greater than this length. This saves time but degrades compression.
	   * max_insert_length is used only for compression levels <= 3.
	   */
	
	  this.level = 0;     /* compression level (1..9) */
	  this.strategy = 0;  /* favor or force Huffman coding*/
	
	  this.good_match = 0;
	  /* Use a faster search when the previous match is longer than this */
	
	  this.nice_match = 0; /* Stop searching when current match exceeds this */
	
	              /* used by trees.c: */
	
	  /* Didn't use ct_data typedef below to suppress compiler warning */
	
	  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
	  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
	  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
	
	  // Use flat array of DOUBLE size, with interleaved fata,
	  // because JS does not support effective
	  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
	  this.dyn_dtree  = new utils.Buf16((2*D_CODES+1) * 2);
	  this.bl_tree    = new utils.Buf16((2*BL_CODES+1) * 2);
	  zero(this.dyn_ltree);
	  zero(this.dyn_dtree);
	  zero(this.bl_tree);
	
	  this.l_desc   = null;         /* desc. for literal tree */
	  this.d_desc   = null;         /* desc. for distance tree */
	  this.bl_desc  = null;         /* desc. for bit length tree */
	
	  //ush bl_count[MAX_BITS+1];
	  this.bl_count = new utils.Buf16(MAX_BITS+1);
	  /* number of codes at each bit length for an optimal tree */
	
	  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
	  this.heap = new utils.Buf16(2*L_CODES+1);  /* heap used to build the Huffman trees */
	  zero(this.heap);
	
	  this.heap_len = 0;               /* number of elements in the heap */
	  this.heap_max = 0;               /* element of largest frequency */
	  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
	   * The same heap array is used to build all trees.
	   */
	
	  this.depth = new utils.Buf16(2*L_CODES+1); //uch depth[2*L_CODES+1];
	  zero(this.depth);
	  /* Depth of each subtree used as tie breaker for trees of equal frequency
	   */
	
	  this.l_buf = 0;          /* buffer index for literals or lengths */
	
	  this.lit_bufsize = 0;
	  /* Size of match buffer for literals/lengths.  There are 4 reasons for
	   * limiting lit_bufsize to 64K:
	   *   - frequencies can be kept in 16 bit counters
	   *   - if compression is not successful for the first block, all input
	   *     data is still in the window so we can still emit a stored block even
	   *     when input comes from standard input.  (This can also be done for
	   *     all blocks if lit_bufsize is not greater than 32K.)
	   *   - if compression is not successful for a file smaller than 64K, we can
	   *     even emit a stored file instead of a stored block (saving 5 bytes).
	   *     This is applicable only for zip (not gzip or zlib).
	   *   - creating new Huffman trees less frequently may not provide fast
	   *     adaptation to changes in the input data statistics. (Take for
	   *     example a binary file with poorly compressible code followed by
	   *     a highly compressible string table.) Smaller buffer sizes give
	   *     fast adaptation but have of course the overhead of transmitting
	   *     trees more frequently.
	   *   - I can't count above 4
	   */
	
	  this.last_lit = 0;      /* running index in l_buf */
	
	  this.d_buf = 0;
	  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
	   * the same number of elements. To use different lengths, an extra flag
	   * array would be necessary.
	   */
	
	  this.opt_len = 0;       /* bit length of current block with optimal trees */
	  this.static_len = 0;    /* bit length of current block with static trees */
	  this.matches = 0;       /* number of string matches in current block */
	  this.insert = 0;        /* bytes at end of window left to insert */
	
	
	  this.bi_buf = 0;
	  /* Output buffer. bits are inserted starting at the bottom (least
	   * significant bits).
	   */
	  this.bi_valid = 0;
	  /* Number of valid bits in bi_buf.  All bits above the last valid bit
	   * are always zero.
	   */
	
	  // Used for window memory init. We safely ignore it for JS. That makes
	  // sense only for pointers and memory check tools.
	  //this.high_water = 0;
	  /* High water mark offset in window for initialized bytes -- bytes above
	   * this are set to zero in order to avoid memory check warnings when
	   * longest match routines access bytes past the input.  This is then
	   * updated to the new high water mark.
	   */
	}
	
	
	function deflateResetKeep(strm) {
	  var s;
	
	  if (!strm || !strm.state) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.total_in = strm.total_out = 0;
	  strm.data_type = Z_UNKNOWN;
	
	  s = strm.state;
	  s.pending = 0;
	  s.pending_out = 0;
	
	  if (s.wrap < 0) {
	    s.wrap = -s.wrap;
	    /* was made negative by deflate(..., Z_FINISH); */
	  }
	  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
	  strm.adler = (s.wrap === 2) ?
	    0  // crc32(0, Z_NULL, 0)
	  :
	    1; // adler32(0, Z_NULL, 0)
	  s.last_flush = Z_NO_FLUSH;
	  trees._tr_init(s);
	  return Z_OK;
	}
	
	
	function deflateReset(strm) {
	  var ret = deflateResetKeep(strm);
	  if (ret === Z_OK) {
	    lm_init(strm.state);
	  }
	  return ret;
	}
	
	
	function deflateSetHeader(strm, head) {
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
	  strm.state.gzhead = head;
	  return Z_OK;
	}
	
	
	function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
	  if (!strm) { // === Z_NULL
	    return Z_STREAM_ERROR;
	  }
	  var wrap = 1;
	
	  if (level === Z_DEFAULT_COMPRESSION) {
	    level = 6;
	  }
	
	  if (windowBits < 0) { /* suppress zlib wrapper */
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	
	  else if (windowBits > 15) {
	    wrap = 2;           /* write gzip wrapper instead */
	    windowBits -= 16;
	  }
	
	
	  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
	    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
	    strategy < 0 || strategy > Z_FIXED) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	
	  if (windowBits === 8) {
	    windowBits = 9;
	  }
	  /* until 256-byte window bug fixed */
	
	  var s = new DeflateState();
	
	  strm.state = s;
	  s.strm = strm;
	
	  s.wrap = wrap;
	  s.gzhead = null;
	  s.w_bits = windowBits;
	  s.w_size = 1 << s.w_bits;
	  s.w_mask = s.w_size - 1;
	
	  s.hash_bits = memLevel + 7;
	  s.hash_size = 1 << s.hash_bits;
	  s.hash_mask = s.hash_size - 1;
	  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
	
	  s.window = new utils.Buf8(s.w_size * 2);
	  s.head = new utils.Buf16(s.hash_size);
	  s.prev = new utils.Buf16(s.w_size);
	
	  // Don't need mem init magic for JS.
	  //s.high_water = 0;  /* nothing written to s->window yet */
	
	  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */
	
	  s.pending_buf_size = s.lit_bufsize * 4;
	  s.pending_buf = new utils.Buf8(s.pending_buf_size);
	
	  s.d_buf = s.lit_bufsize >> 1;
	  s.l_buf = (1 + 2) * s.lit_bufsize;
	
	  s.level = level;
	  s.strategy = strategy;
	  s.method = method;
	
	  return deflateReset(strm);
	}
	
	function deflateInit(strm, level) {
	  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
	}
	
	
	function deflate(strm, flush) {
	  var old_flush, s;
	  var beg, val; // for gzip header write only
	
	  if (!strm || !strm.state ||
	    flush > Z_BLOCK || flush < 0) {
	    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
	  }
	
	  s = strm.state;
	
	  if (!strm.output ||
	      (!strm.input && strm.avail_in !== 0) ||
	      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
	    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
	  }
	
	  s.strm = strm; /* just in case */
	  old_flush = s.last_flush;
	  s.last_flush = flush;
	
	  /* Write the header */
	  if (s.status === INIT_STATE) {
	
	    if (s.wrap === 2) { // GZIP header
	      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
	      put_byte(s, 31);
	      put_byte(s, 139);
	      put_byte(s, 8);
	      if (!s.gzhead) { // s->gzhead == Z_NULL
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, 0);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, OS_CODE);
	        s.status = BUSY_STATE;
	      }
	      else {
	        put_byte(s, (s.gzhead.text ? 1 : 0) +
	                    (s.gzhead.hcrc ? 2 : 0) +
	                    (!s.gzhead.extra ? 0 : 4) +
	                    (!s.gzhead.name ? 0 : 8) +
	                    (!s.gzhead.comment ? 0 : 16)
	                );
	        put_byte(s, s.gzhead.time & 0xff);
	        put_byte(s, (s.gzhead.time >> 8) & 0xff);
	        put_byte(s, (s.gzhead.time >> 16) & 0xff);
	        put_byte(s, (s.gzhead.time >> 24) & 0xff);
	        put_byte(s, s.level === 9 ? 2 :
	                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
	                     4 : 0));
	        put_byte(s, s.gzhead.os & 0xff);
	        if (s.gzhead.extra && s.gzhead.extra.length) {
	          put_byte(s, s.gzhead.extra.length & 0xff);
	          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
	        }
	        if (s.gzhead.hcrc) {
	          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
	        }
	        s.gzindex = 0;
	        s.status = EXTRA_STATE;
	      }
	    }
	    else // DEFLATE header
	    {
	      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
	      var level_flags = -1;
	
	      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
	        level_flags = 0;
	      } else if (s.level < 6) {
	        level_flags = 1;
	      } else if (s.level === 6) {
	        level_flags = 2;
	      } else {
	        level_flags = 3;
	      }
	      header |= (level_flags << 6);
	      if (s.strstart !== 0) { header |= PRESET_DICT; }
	      header += 31 - (header % 31);
	
	      s.status = BUSY_STATE;
	      putShortMSB(s, header);
	
	      /* Save the adler32 of the preset dictionary: */
	      if (s.strstart !== 0) {
	        putShortMSB(s, strm.adler >>> 16);
	        putShortMSB(s, strm.adler & 0xffff);
	      }
	      strm.adler = 1; // adler32(0L, Z_NULL, 0);
	    }
	  }
	
	//#ifdef GZIP
	  if (s.status === EXTRA_STATE) {
	    if (s.gzhead.extra/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	
	      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            break;
	          }
	        }
	        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
	        s.gzindex++;
	      }
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (s.gzindex === s.gzhead.extra.length) {
	        s.gzindex = 0;
	        s.status = NAME_STATE;
	      }
	    }
	    else {
	      s.status = NAME_STATE;
	    }
	  }
	  if (s.status === NAME_STATE) {
	    if (s.gzhead.name/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.name.length) {
	          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg){
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.gzindex = 0;
	        s.status = COMMENT_STATE;
	      }
	    }
	    else {
	      s.status = COMMENT_STATE;
	    }
	  }
	  if (s.status === COMMENT_STATE) {
	    if (s.gzhead.comment/* != Z_NULL*/) {
	      beg = s.pending;  /* start of bytes to update crc */
	      //int val;
	
	      do {
	        if (s.pending === s.pending_buf_size) {
	          if (s.gzhead.hcrc && s.pending > beg) {
	            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	          }
	          flush_pending(strm);
	          beg = s.pending;
	          if (s.pending === s.pending_buf_size) {
	            val = 1;
	            break;
	          }
	        }
	        // JS specific: little magic to add zero terminator to end of string
	        if (s.gzindex < s.gzhead.comment.length) {
	          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
	        } else {
	          val = 0;
	        }
	        put_byte(s, val);
	      } while (val !== 0);
	
	      if (s.gzhead.hcrc && s.pending > beg) {
	        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
	      }
	      if (val === 0) {
	        s.status = HCRC_STATE;
	      }
	    }
	    else {
	      s.status = HCRC_STATE;
	    }
	  }
	  if (s.status === HCRC_STATE) {
	    if (s.gzhead.hcrc) {
	      if (s.pending + 2 > s.pending_buf_size) {
	        flush_pending(strm);
	      }
	      if (s.pending + 2 <= s.pending_buf_size) {
	        put_byte(s, strm.adler & 0xff);
	        put_byte(s, (strm.adler >> 8) & 0xff);
	        strm.adler = 0; //crc32(0L, Z_NULL, 0);
	        s.status = BUSY_STATE;
	      }
	    }
	    else {
	      s.status = BUSY_STATE;
	    }
	  }
	//#endif
	
	  /* Flush as much pending output as possible */
	  if (s.pending !== 0) {
	    flush_pending(strm);
	    if (strm.avail_out === 0) {
	      /* Since avail_out is 0, deflate will be called again with
	       * more output space, but possibly with both pending and
	       * avail_in equal to zero. There won't be anything to do,
	       * but this is not an error situation so make sure we
	       * return OK instead of BUF_ERROR at next call of deflate:
	       */
	      s.last_flush = -1;
	      return Z_OK;
	    }
	
	    /* Make sure there is something to do and avoid duplicate consecutive
	     * flushes. For repeated and useless calls with Z_FINISH, we keep
	     * returning Z_STREAM_END instead of Z_BUF_ERROR.
	     */
	  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
	    flush !== Z_FINISH) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* User must not provide more input after the first FINISH: */
	  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
	    return err(strm, Z_BUF_ERROR);
	  }
	
	  /* Start a new block or continue the current one.
	   */
	  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
	    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
	    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
	      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
	        configuration_table[s.level].func(s, flush));
	
	    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
	      s.status = FINISH_STATE;
	    }
	    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
	      if (strm.avail_out === 0) {
	        s.last_flush = -1;
	        /* avoid BUF_ERROR next call, see above */
	      }
	      return Z_OK;
	      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
	       * of deflate should use the same flush parameter to make sure
	       * that the flush is complete. So we don't have to output an
	       * empty block here, this will be done at next call. This also
	       * ensures that for a very small output buffer, we emit at most
	       * one empty block.
	       */
	    }
	    if (bstate === BS_BLOCK_DONE) {
	      if (flush === Z_PARTIAL_FLUSH) {
	        trees._tr_align(s);
	      }
	      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */
	
	        trees._tr_stored_block(s, 0, 0, false);
	        /* For a full flush, this empty block will be recognized
	         * as a special marker by inflate_sync().
	         */
	        if (flush === Z_FULL_FLUSH) {
	          /*** CLEAR_HASH(s); ***/             /* forget history */
	          zero(s.head); // Fill with NIL (= 0);
	
	          if (s.lookahead === 0) {
	            s.strstart = 0;
	            s.block_start = 0;
	            s.insert = 0;
	          }
	        }
	      }
	      flush_pending(strm);
	      if (strm.avail_out === 0) {
	        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
	        return Z_OK;
	      }
	    }
	  }
	  //Assert(strm->avail_out > 0, "bug2");
	  //if (strm.avail_out <= 0) { throw new Error("bug2");}
	
	  if (flush !== Z_FINISH) { return Z_OK; }
	  if (s.wrap <= 0) { return Z_STREAM_END; }
	
	  /* Write the trailer */
	  if (s.wrap === 2) {
	    put_byte(s, strm.adler & 0xff);
	    put_byte(s, (strm.adler >> 8) & 0xff);
	    put_byte(s, (strm.adler >> 16) & 0xff);
	    put_byte(s, (strm.adler >> 24) & 0xff);
	    put_byte(s, strm.total_in & 0xff);
	    put_byte(s, (strm.total_in >> 8) & 0xff);
	    put_byte(s, (strm.total_in >> 16) & 0xff);
	    put_byte(s, (strm.total_in >> 24) & 0xff);
	  }
	  else
	  {
	    putShortMSB(s, strm.adler >>> 16);
	    putShortMSB(s, strm.adler & 0xffff);
	  }
	
	  flush_pending(strm);
	  /* If avail_out is zero, the application will call deflate again
	   * to flush the rest.
	   */
	  if (s.wrap > 0) { s.wrap = -s.wrap; }
	  /* write the trailer only once! */
	  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
	}
	
	function deflateEnd(strm) {
	  var status;
	
	  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  status = strm.state.status;
	  if (status !== INIT_STATE &&
	    status !== EXTRA_STATE &&
	    status !== NAME_STATE &&
	    status !== COMMENT_STATE &&
	    status !== HCRC_STATE &&
	    status !== BUSY_STATE &&
	    status !== FINISH_STATE
	  ) {
	    return err(strm, Z_STREAM_ERROR);
	  }
	
	  strm.state = null;
	
	  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
	}
	
	/* =========================================================================
	 * Copy the source state to the destination state
	 */
	//function deflateCopy(dest, source) {
	//
	//}
	
	exports.deflateInit = deflateInit;
	exports.deflateInit2 = deflateInit2;
	exports.deflateReset = deflateReset;
	exports.deflateResetKeep = deflateResetKeep;
	exports.deflateSetHeader = deflateSetHeader;
	exports.deflate = deflate;
	exports.deflateEnd = deflateEnd;
	exports.deflateInfo = 'pako deflate (from Nodeca project)';
	
	/* Not implemented
	exports.deflateBound = deflateBound;
	exports.deflateCopy = deflateCopy;
	exports.deflateSetDictionary = deflateSetDictionary;
	exports.deflateParams = deflateParams;
	exports.deflatePending = deflatePending;
	exports.deflatePrime = deflatePrime;
	exports.deflateTune = deflateTune;
	*/
	},{"../utils/common":27,"./adler32":29,"./crc32":31,"./messages":37,"./trees":38}],33:[function(_dereq_,module,exports){
	'use strict';
	
	
	function GZheader() {
	  /* true if compressed data believed to be text */
	  this.text       = 0;
	  /* modification time */
	  this.time       = 0;
	  /* extra flags (not used when writing a gzip file) */
	  this.xflags     = 0;
	  /* operating system */
	  this.os         = 0;
	  /* pointer to extra field or Z_NULL if none */
	  this.extra      = null;
	  /* extra field length (valid if extra != Z_NULL) */
	  this.extra_len  = 0; // Actually, we don't need it in JS,
	                       // but leave for few code modifications
	
	  //
	  // Setup limits is not necessary because in js we should not preallocate memory
	  // for inflate use constant limit in 65536 bytes
	  //
	
	  /* space at extra (only when reading header) */
	  // this.extra_max  = 0;
	  /* pointer to zero-terminated file name or Z_NULL */
	  this.name       = '';
	  /* space at name (only when reading header) */
	  // this.name_max   = 0;
	  /* pointer to zero-terminated comment or Z_NULL */
	  this.comment    = '';
	  /* space at comment (only when reading header) */
	  // this.comm_max   = 0;
	  /* true if there was or will be a header crc */
	  this.hcrc       = 0;
	  /* true when done reading gzip header (not used when writing a gzip file) */
	  this.done       = false;
	}
	
	module.exports = GZheader;
	},{}],34:[function(_dereq_,module,exports){
	'use strict';
	
	// See state defs from inflate.js
	var BAD = 30;       /* got a data error -- remain here until reset */
	var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	
	/*
	   Decode literal, length, and distance codes and write out the resulting
	   literal and match bytes until either not enough input or output is
	   available, an end-of-block is encountered, or a data error is encountered.
	   When large enough input and output buffers are supplied to inflate(), for
	   example, a 16K input buffer and a 64K output buffer, more than 95% of the
	   inflate execution time is spent in this routine.
	
	   Entry assumptions:
	
	        state.mode === LEN
	        strm.avail_in >= 6
	        strm.avail_out >= 258
	        start >= strm.avail_out
	        state.bits < 8
	
	   On return, state.mode is one of:
	
	        LEN -- ran out of enough output space or enough available input
	        TYPE -- reached end of block code, inflate() to interpret next block
	        BAD -- error in block data
	
	   Notes:
	
	    - The maximum input bits used by a length/distance pair is 15 bits for the
	      length code, 5 bits for the length extra, 15 bits for the distance code,
	      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
	      Therefore if strm.avail_in >= 6, then there is enough input to avoid
	      checking for available input while decoding.
	
	    - The maximum bytes that a single length/distance pair can output is 258
	      bytes, which is the maximum length that can be coded.  inflate_fast()
	      requires strm.avail_out >= 258 for each loop to avoid checking for
	      output space.
	 */
	module.exports = function inflate_fast(strm, start) {
	  var state;
	  var _in;                    /* local strm.input */
	  var last;                   /* have enough input while in < last */
	  var _out;                   /* local strm.output */
	  var beg;                    /* inflate()'s initial strm.output */
	  var end;                    /* while out < end, enough space available */
	//#ifdef INFLATE_STRICT
	  var dmax;                   /* maximum distance from zlib header */
	//#endif
	  var wsize;                  /* window size or zero if not using window */
	  var whave;                  /* valid bytes in the window */
	  var wnext;                  /* window write index */
	  var window;                 /* allocated sliding window, if wsize != 0 */
	  var hold;                   /* local strm.hold */
	  var bits;                   /* local strm.bits */
	  var lcode;                  /* local strm.lencode */
	  var dcode;                  /* local strm.distcode */
	  var lmask;                  /* mask for first level of length codes */
	  var dmask;                  /* mask for first level of distance codes */
	  var here;                   /* retrieved table entry */
	  var op;                     /* code bits, operation, extra bits, or */
	                              /*  window position, window bytes to copy */
	  var len;                    /* match length, unused bytes */
	  var dist;                   /* match distance */
	  var from;                   /* where to copy match from */
	  var from_source;
	
	
	  var input, output; // JS specific, because we have no pointers
	
	  /* copy state to local variables */
	  state = strm.state;
	  //here = state.here;
	  _in = strm.next_in;
	  input = strm.input;
	  last = _in + (strm.avail_in - 5);
	  _out = strm.next_out;
	  output = strm.output;
	  beg = _out - (start - strm.avail_out);
	  end = _out + (strm.avail_out - 257);
	//#ifdef INFLATE_STRICT
	  dmax = state.dmax;
	//#endif
	  wsize = state.wsize;
	  whave = state.whave;
	  wnext = state.wnext;
	  window = state.window;
	  hold = state.hold;
	  bits = state.bits;
	  lcode = state.lencode;
	  dcode = state.distcode;
	  lmask = (1 << state.lenbits) - 1;
	  dmask = (1 << state.distbits) - 1;
	
	
	  /* decode literals and length/distances until end-of-block or not enough
	     input data or output space */
	
	  top:
	  do {
	    if (bits < 15) {
	      hold += input[_in++] << bits;
	      bits += 8;
	      hold += input[_in++] << bits;
	      bits += 8;
	    }
	
	    here = lcode[hold & lmask];
	
	    dolen:
	    for (;;) { // Goto emulation
	      op = here >>> 24/*here.bits*/;
	      hold >>>= op;
	      bits -= op;
	      op = (here >>> 16) & 0xff/*here.op*/;
	      if (op === 0) {                          /* literal */
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        output[_out++] = here & 0xffff/*here.val*/;
	      }
	      else if (op & 16) {                     /* length base */
	        len = here & 0xffff/*here.val*/;
	        op &= 15;                           /* number of extra bits */
	        if (op) {
	          if (bits < op) {
	            hold += input[_in++] << bits;
	            bits += 8;
	          }
	          len += hold & ((1 << op) - 1);
	          hold >>>= op;
	          bits -= op;
	        }
	        //Tracevv((stderr, "inflate:         length %u\n", len));
	        if (bits < 15) {
	          hold += input[_in++] << bits;
	          bits += 8;
	          hold += input[_in++] << bits;
	          bits += 8;
	        }
	        here = dcode[hold & dmask];
	
	        dodist:
	        for (;;) { // goto emulation
	          op = here >>> 24/*here.bits*/;
	          hold >>>= op;
	          bits -= op;
	          op = (here >>> 16) & 0xff/*here.op*/;
	
	          if (op & 16) {                      /* distance base */
	            dist = here & 0xffff/*here.val*/;
	            op &= 15;                       /* number of extra bits */
	            if (bits < op) {
	              hold += input[_in++] << bits;
	              bits += 8;
	              if (bits < op) {
	                hold += input[_in++] << bits;
	                bits += 8;
	              }
	            }
	            dist += hold & ((1 << op) - 1);
	//#ifdef INFLATE_STRICT
	            if (dist > dmax) {
	              strm.msg = 'invalid distance too far back';
	              state.mode = BAD;
	              break top;
	            }
	//#endif
	            hold >>>= op;
	            bits -= op;
	            //Tracevv((stderr, "inflate:         distance %u\n", dist));
	            op = _out - beg;                /* max distance in output */
	            if (dist > op) {                /* see if copy from window */
	              op = dist - op;               /* distance back in window */
	              if (op > whave) {
	                if (state.sane) {
	                  strm.msg = 'invalid distance too far back';
	                  state.mode = BAD;
	                  break top;
	                }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//                if (len <= op - whave) {
	//                  do {
	//                    output[_out++] = 0;
	//                  } while (--len);
	//                  continue top;
	//                }
	//                len -= op - whave;
	//                do {
	//                  output[_out++] = 0;
	//                } while (--op > whave);
	//                if (op === 0) {
	//                  from = _out - dist;
	//                  do {
	//                    output[_out++] = output[from++];
	//                  } while (--len);
	//                  continue top;
	//                }
	//#endif
	              }
	              from = 0; // window index
	              from_source = window;
	              if (wnext === 0) {           /* very common case */
	                from += wsize - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              else if (wnext < op) {      /* wrap around window */
	                from += wsize + wnext - op;
	                op -= wnext;
	                if (op < len) {         /* some from end of window */
	                  len -= op;
	                  do {
	                    output[_out++] = window[from++];
	                  } while (--op);
	                  from = 0;
	                  if (wnext < len) {  /* some from start of window */
	                    op = wnext;
	                    len -= op;
	                    do {
	                      output[_out++] = window[from++];
	                    } while (--op);
	                    from = _out - dist;      /* rest from output */
	                    from_source = output;
	                  }
	                }
	              }
	              else {                      /* contiguous in window */
	                from += wnext - op;
	                if (op < len) {         /* some from window */
	                  len -= op;
	                  do {
	                    output[_out++] = window[from++];
	                  } while (--op);
	                  from = _out - dist;  /* rest from output */
	                  from_source = output;
	                }
	              }
	              while (len > 2) {
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                output[_out++] = from_source[from++];
	                len -= 3;
	              }
	              if (len) {
	                output[_out++] = from_source[from++];
	                if (len > 1) {
	                  output[_out++] = from_source[from++];
	                }
	              }
	            }
	            else {
	              from = _out - dist;          /* copy direct from output */
	              do {                        /* minimum length is three */
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                output[_out++] = output[from++];
	                len -= 3;
	              } while (len > 2);
	              if (len) {
	                output[_out++] = output[from++];
	                if (len > 1) {
	                  output[_out++] = output[from++];
	                }
	              }
	            }
	          }
	          else if ((op & 64) === 0) {          /* 2nd level distance code */
	            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	            continue dodist;
	          }
	          else {
	            strm.msg = 'invalid distance code';
	            state.mode = BAD;
	            break top;
	          }
	
	          break; // need to emulate goto via "continue"
	        }
	      }
	      else if ((op & 64) === 0) {              /* 2nd level length code */
	        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
	        continue dolen;
	      }
	      else if (op & 32) {                     /* end-of-block */
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.mode = TYPE;
	        break top;
	      }
	      else {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break top;
	      }
	
	      break; // need to emulate goto via "continue"
	    }
	  } while (_in < last && _out < end);
	
	  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
	  len = bits >> 3;
	  _in -= len;
	  bits -= len << 3;
	  hold &= (1 << bits) - 1;
	
	  /* update state and return */
	  strm.next_in = _in;
	  strm.next_out = _out;
	  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
	  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
	  state.hold = hold;
	  state.bits = bits;
	  return;
	};
	
	},{}],35:[function(_dereq_,module,exports){
	'use strict';
	
	
	var utils = _dereq_('../utils/common');
	var adler32 = _dereq_('./adler32');
	var crc32   = _dereq_('./crc32');
	var inflate_fast = _dereq_('./inffast');
	var inflate_table = _dereq_('./inftrees');
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	/* Allowed flush values; see deflate() and inflate() below for details */
	//var Z_NO_FLUSH      = 0;
	//var Z_PARTIAL_FLUSH = 1;
	//var Z_SYNC_FLUSH    = 2;
	//var Z_FULL_FLUSH    = 3;
	var Z_FINISH        = 4;
	var Z_BLOCK         = 5;
	var Z_TREES         = 6;
	
	
	/* Return codes for the compression/decompression functions. Negative values
	 * are errors, positive values are used for special but normal events.
	 */
	var Z_OK            = 0;
	var Z_STREAM_END    = 1;
	var Z_NEED_DICT     = 2;
	//var Z_ERRNO         = -1;
	var Z_STREAM_ERROR  = -2;
	var Z_DATA_ERROR    = -3;
	var Z_MEM_ERROR     = -4;
	var Z_BUF_ERROR     = -5;
	//var Z_VERSION_ERROR = -6;
	
	/* The deflate compression method */
	var Z_DEFLATED  = 8;
	
	
	/* STATES ====================================================================*/
	/* ===========================================================================*/
	
	
	var    HEAD = 1;       /* i: waiting for magic header */
	var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
	var    TIME = 3;       /* i: waiting for modification time (gzip) */
	var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
	var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
	var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
	var    NAME = 7;       /* i: waiting for end of file name (gzip) */
	var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
	var    HCRC = 9;       /* i: waiting for header crc (gzip) */
	var    DICTID = 10;    /* i: waiting for dictionary check value */
	var    DICT = 11;      /* waiting for inflateSetDictionary() call */
	var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
	var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
	var        STORED = 14;    /* i: waiting for stored size (length and complement) */
	var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
	var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
	var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
	var        LENLENS = 18;   /* i: waiting for code length code lengths */
	var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
	var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
	var            LEN = 21;       /* i: waiting for length/lit/eob code */
	var            LENEXT = 22;    /* i: waiting for length extra bits */
	var            DIST = 23;      /* i: waiting for distance code */
	var            DISTEXT = 24;   /* i: waiting for distance extra bits */
	var            MATCH = 25;     /* o: waiting for output space to copy string */
	var            LIT = 26;       /* o: waiting for output space to write literal */
	var    CHECK = 27;     /* i: waiting for 32-bit check value */
	var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
	var    DONE = 29;      /* finished check, done -- remain here until reset */
	var    BAD = 30;       /* got a data error -- remain here until reset */
	var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
	var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */
	
	/* ===========================================================================*/
	
	
	
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
	
	var MAX_WBITS = 15;
	/* 32K LZ77 window */
	var DEF_WBITS = MAX_WBITS;
	
	
	function ZSWAP32(q) {
	  return  (((q >>> 24) & 0xff) +
	          ((q >>> 8) & 0xff00) +
	          ((q & 0xff00) << 8) +
	          ((q & 0xff) << 24));
	}
	
	
	function InflateState() {
	  this.mode = 0;             /* current inflate mode */
	  this.last = false;          /* true if processing last block */
	  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
	  this.havedict = false;      /* true if dictionary provided */
	  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
	  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
	  this.check = 0;             /* protected copy of check value */
	  this.total = 0;             /* protected copy of output count */
	  // TODO: may be {}
	  this.head = null;           /* where to save gzip header information */
	
	  /* sliding window */
	  this.wbits = 0;             /* log base 2 of requested window size */
	  this.wsize = 0;             /* window size or zero if not using window */
	  this.whave = 0;             /* valid bytes in the window */
	  this.wnext = 0;             /* window write index */
	  this.window = null;         /* allocated sliding window, if needed */
	
	  /* bit accumulator */
	  this.hold = 0;              /* input bit accumulator */
	  this.bits = 0;              /* number of bits in "in" */
	
	  /* for string and stored block copying */
	  this.length = 0;            /* literal or length of data to copy */
	  this.offset = 0;            /* distance back to copy string from */
	
	  /* for table and code decoding */
	  this.extra = 0;             /* extra bits needed */
	
	  /* fixed and dynamic code tables */
	  this.lencode = null;          /* starting table for length/literal codes */
	  this.distcode = null;         /* starting table for distance codes */
	  this.lenbits = 0;           /* index bits for lencode */
	  this.distbits = 0;          /* index bits for distcode */
	
	  /* dynamic table building */
	  this.ncode = 0;             /* number of code length code lengths */
	  this.nlen = 0;              /* number of length code lengths */
	  this.ndist = 0;             /* number of distance code lengths */
	  this.have = 0;              /* number of code lengths in lens[] */
	  this.next = null;              /* next available space in codes[] */
	
	  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
	  this.work = new utils.Buf16(288); /* work area for code table building */
	
	  /*
	   because we don't have pointers in js, we use lencode and distcode directly
	   as buffers so we don't need codes
	  */
	  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
	  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
	  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
	  this.sane = 0;                   /* if false, allow invalid distance too far */
	  this.back = 0;                   /* bits back of last unprocessed length/lit */
	  this.was = 0;                    /* initial length of match */
	}
	
	function inflateResetKeep(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  strm.total_in = strm.total_out = state.total = 0;
	  strm.msg = ''; /*Z_NULL*/
	  if (state.wrap) {       /* to support ill-conceived Java test suite */
	    strm.adler = state.wrap & 1;
	  }
	  state.mode = HEAD;
	  state.last = 0;
	  state.havedict = 0;
	  state.dmax = 32768;
	  state.head = null/*Z_NULL*/;
	  state.hold = 0;
	  state.bits = 0;
	  //state.lencode = state.distcode = state.next = state.codes;
	  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
	  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
	
	  state.sane = 1;
	  state.back = -1;
	  //Tracev((stderr, "inflate: reset\n"));
	  return Z_OK;
	}
	
	function inflateReset(strm) {
	  var state;
	
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  state.wsize = 0;
	  state.whave = 0;
	  state.wnext = 0;
	  return inflateResetKeep(strm);
	
	}
	
	function inflateReset2(strm, windowBits) {
	  var wrap;
	  var state;
	
	  /* get the state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	
	  /* extract wrap request from windowBits parameter */
	  if (windowBits < 0) {
	    wrap = 0;
	    windowBits = -windowBits;
	  }
	  else {
	    wrap = (windowBits >> 4) + 1;
	    if (windowBits < 48) {
	      windowBits &= 15;
	    }
	  }
	
	  /* set number of window bits, free window if different */
	  if (windowBits && (windowBits < 8 || windowBits > 15)) {
	    return Z_STREAM_ERROR;
	  }
	  if (state.window !== null && state.wbits !== windowBits) {
	    state.window = null;
	  }
	
	  /* update state and reset the rest of it */
	  state.wrap = wrap;
	  state.wbits = windowBits;
	  return inflateReset(strm);
	}
	
	function inflateInit2(strm, windowBits) {
	  var ret;
	  var state;
	
	  if (!strm) { return Z_STREAM_ERROR; }
	  //strm.msg = Z_NULL;                 /* in case we return an error */
	
	  state = new InflateState();
	
	  //if (state === Z_NULL) return Z_MEM_ERROR;
	  //Tracev((stderr, "inflate: allocated\n"));
	  strm.state = state;
	  state.window = null/*Z_NULL*/;
	  ret = inflateReset2(strm, windowBits);
	  if (ret !== Z_OK) {
	    strm.state = null/*Z_NULL*/;
	  }
	  return ret;
	}
	
	function inflateInit(strm) {
	  return inflateInit2(strm, DEF_WBITS);
	}
	
	
	/*
	 Return state with length and distance decoding tables and index sizes set to
	 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
	 If BUILDFIXED is defined, then instead this routine builds the tables the
	 first time it's called, and returns those tables the first time and
	 thereafter.  This reduces the size of the code by about 2K bytes, in
	 exchange for a little execution time.  However, BUILDFIXED should not be
	 used for threaded applications, since the rewriting of the tables and virgin
	 may not be thread-safe.
	 */
	var virgin = true;
	
	var lenfix, distfix; // We have no pointers in JS, so keep tables separate
	
	function fixedtables(state) {
	  /* build fixed huffman tables if first call (may not be thread safe) */
	  if (virgin) {
	    var sym;
	
	    lenfix = new utils.Buf32(512);
	    distfix = new utils.Buf32(32);
	
	    /* literal/length table */
	    sym = 0;
	    while (sym < 144) { state.lens[sym++] = 8; }
	    while (sym < 256) { state.lens[sym++] = 9; }
	    while (sym < 280) { state.lens[sym++] = 7; }
	    while (sym < 288) { state.lens[sym++] = 8; }
	
	    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, {bits: 9});
	
	    /* distance table */
	    sym = 0;
	    while (sym < 32) { state.lens[sym++] = 5; }
	
	    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, {bits: 5});
	
	    /* do this just once */
	    virgin = false;
	  }
	
	  state.lencode = lenfix;
	  state.lenbits = 9;
	  state.distcode = distfix;
	  state.distbits = 5;
	}
	
	
	/*
	 Update the window with the last wsize (normally 32K) bytes written before
	 returning.  If window does not exist yet, create it.  This is only called
	 when a window is already in use, or when output has been written during this
	 inflate call, but the end of the deflate stream has not been reached yet.
	 It is also called to create a window for dictionary data when a dictionary
	 is loaded.
	
	 Providing output buffers larger than 32K to inflate() should provide a speed
	 advantage, since only the last 32K of output is copied to the sliding window
	 upon return from inflate(), and since all distances after the first 32K of
	 output will fall in the output data, making match copies simpler and faster.
	 The advantage may be dependent on the size of the processor's data caches.
	 */
	function updatewindow(strm, src, end, copy) {
	  var dist;
	  var state = strm.state;
	
	  /* if it hasn't been done already, allocate space for the window */
	  if (state.window === null) {
	    state.wsize = 1 << state.wbits;
	    state.wnext = 0;
	    state.whave = 0;
	
	    state.window = new utils.Buf8(state.wsize);
	  }
	
	  /* copy state->wsize or less output bytes into the circular window */
	  if (copy >= state.wsize) {
	    utils.arraySet(state.window,src, end - state.wsize, state.wsize, 0);
	    state.wnext = 0;
	    state.whave = state.wsize;
	  }
	  else {
	    dist = state.wsize - state.wnext;
	    if (dist > copy) {
	      dist = copy;
	    }
	    //zmemcpy(state->window + state->wnext, end - copy, dist);
	    utils.arraySet(state.window,src, end - copy, dist, state.wnext);
	    copy -= dist;
	    if (copy) {
	      //zmemcpy(state->window, end - copy, copy);
	      utils.arraySet(state.window,src, end - copy, copy, 0);
	      state.wnext = copy;
	      state.whave = state.wsize;
	    }
	    else {
	      state.wnext += dist;
	      if (state.wnext === state.wsize) { state.wnext = 0; }
	      if (state.whave < state.wsize) { state.whave += dist; }
	    }
	  }
	  return 0;
	}
	
	function inflate(strm, flush) {
	  var state;
	  var input, output;          // input/output buffers
	  var next;                   /* next input INDEX */
	  var put;                    /* next output INDEX */
	  var have, left;             /* available input and output */
	  var hold;                   /* bit buffer */
	  var bits;                   /* bits in bit buffer */
	  var _in, _out;              /* save starting available input and output */
	  var copy;                   /* number of stored or match bytes to copy */
	  var from;                   /* where to copy match bytes from */
	  var from_source;
	  var here = 0;               /* current decoding table entry */
	  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
	  //var last;                   /* parent table entry */
	  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
	  var len;                    /* length to copy for repeats, bits to drop */
	  var ret;                    /* return code */
	  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
	  var opts;
	
	  var n; // temporary var for NEED_BITS
	
	  var order = /* permutation of code lengths */
	    [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
	
	
	  if (!strm || !strm.state || !strm.output ||
	      (!strm.input && strm.avail_in !== 0)) {
	    return Z_STREAM_ERROR;
	  }
	
	  state = strm.state;
	  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */
	
	
	  //--- LOAD() ---
	  put = strm.next_out;
	  output = strm.output;
	  left = strm.avail_out;
	  next = strm.next_in;
	  input = strm.input;
	  have = strm.avail_in;
	  hold = state.hold;
	  bits = state.bits;
	  //---
	
	  _in = have;
	  _out = left;
	  ret = Z_OK;
	
	  inf_leave: // goto emulation
	  for (;;) {
	    switch (state.mode) {
	    case HEAD:
	      if (state.wrap === 0) {
	        state.mode = TYPEDO;
	        break;
	      }
	      //=== NEEDBITS(16);
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
	        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        state.mode = FLAGS;
	        break;
	      }
	      state.flags = 0;           /* expect zlib header */
	      if (state.head) {
	        state.head.done = false;
	      }
	      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
	        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
	        strm.msg = 'incorrect header check';
	        state.mode = BAD;
	        break;
	      }
	      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	      len = (hold & 0x0f)/*BITS(4)*/ + 8;
	      if (state.wbits === 0) {
	        state.wbits = len;
	      }
	      else if (len > state.wbits) {
	        strm.msg = 'invalid window size';
	        state.mode = BAD;
	        break;
	      }
	      state.dmax = 1 << len;
	      //Tracev((stderr, "inflate:   zlib header ok\n"));
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = hold & 0x200 ? DICTID : TYPE;
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      break;
	    case FLAGS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.flags = hold;
	      if ((state.flags & 0xff) !== Z_DEFLATED) {
	        strm.msg = 'unknown compression method';
	        state.mode = BAD;
	        break;
	      }
	      if (state.flags & 0xe000) {
	        strm.msg = 'unknown header flags set';
	        state.mode = BAD;
	        break;
	      }
	      if (state.head) {
	        state.head.text = ((hold >> 8) & 1);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = TIME;
	      /* falls through */
	    case TIME:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.time = hold;
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC4(state.check, hold)
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        hbuf[2] = (hold >>> 16) & 0xff;
	        hbuf[3] = (hold >>> 24) & 0xff;
	        state.check = crc32(state.check, hbuf, 4, 0);
	        //===
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = OS;
	      /* falls through */
	    case OS:
	      //=== NEEDBITS(16); */
	      while (bits < 16) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if (state.head) {
	        state.head.xflags = (hold & 0xff);
	        state.head.os = (hold >> 8);
	      }
	      if (state.flags & 0x0200) {
	        //=== CRC2(state.check, hold);
	        hbuf[0] = hold & 0xff;
	        hbuf[1] = (hold >>> 8) & 0xff;
	        state.check = crc32(state.check, hbuf, 2, 0);
	        //===//
	      }
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = EXLEN;
	      /* falls through */
	    case EXLEN:
	      if (state.flags & 0x0400) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length = hold;
	        if (state.head) {
	          state.head.extra_len = hold;
	        }
	        if (state.flags & 0x0200) {
	          //=== CRC2(state.check, hold);
	          hbuf[0] = hold & 0xff;
	          hbuf[1] = (hold >>> 8) & 0xff;
	          state.check = crc32(state.check, hbuf, 2, 0);
	          //===//
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      else if (state.head) {
	        state.head.extra = null/*Z_NULL*/;
	      }
	      state.mode = EXTRA;
	      /* falls through */
	    case EXTRA:
	      if (state.flags & 0x0400) {
	        copy = state.length;
	        if (copy > have) { copy = have; }
	        if (copy) {
	          if (state.head) {
	            len = state.head.extra_len - state.length;
	            if (!state.head.extra) {
	              // Use untyped array for more conveniend processing later
	              state.head.extra = new Array(state.head.extra_len);
	            }
	            utils.arraySet(
	              state.head.extra,
	              input,
	              next,
	              // extra field is limited to 65536 bytes
	              // - no need for additional size check
	              copy,
	              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
	              len
	            );
	            //zmemcpy(state.head.extra + len, next,
	            //        len + copy > state.head.extra_max ?
	            //        state.head.extra_max - len : copy);
	          }
	          if (state.flags & 0x0200) {
	            state.check = crc32(state.check, input, copy, next);
	          }
	          have -= copy;
	          next += copy;
	          state.length -= copy;
	        }
	        if (state.length) { break inf_leave; }
	      }
	      state.length = 0;
	      state.mode = NAME;
	      /* falls through */
	    case NAME:
	      if (state.flags & 0x0800) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          // TODO: 2 or 1 bytes?
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.name_max*/)) {
	            state.head.name += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.name = null;
	      }
	      state.length = 0;
	      state.mode = COMMENT;
	      /* falls through */
	    case COMMENT:
	      if (state.flags & 0x1000) {
	        if (have === 0) { break inf_leave; }
	        copy = 0;
	        do {
	          len = input[next + copy++];
	          /* use constant limit because in js we should not preallocate memory */
	          if (state.head && len &&
	              (state.length < 65536 /*state.head.comm_max*/)) {
	            state.head.comment += String.fromCharCode(len);
	          }
	        } while (len && copy < have);
	        if (state.flags & 0x0200) {
	          state.check = crc32(state.check, input, copy, next);
	        }
	        have -= copy;
	        next += copy;
	        if (len) { break inf_leave; }
	      }
	      else if (state.head) {
	        state.head.comment = null;
	      }
	      state.mode = HCRC;
	      /* falls through */
	    case HCRC:
	      if (state.flags & 0x0200) {
	        //=== NEEDBITS(16); */
	        while (bits < 16) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.check & 0xffff)) {
	          strm.msg = 'header crc mismatch';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	      }
	      if (state.head) {
	        state.head.hcrc = ((state.flags >> 9) & 1);
	        state.head.done = true;
	      }
	      strm.adler = state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      break;
	    case DICTID:
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      strm.adler = state.check = ZSWAP32(hold);
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = DICT;
	      /* falls through */
	    case DICT:
	      if (state.havedict === 0) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        return Z_NEED_DICT;
	      }
	      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
	      state.mode = TYPE;
	      /* falls through */
	    case TYPE:
	      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case TYPEDO:
	      if (state.last) {
	        //--- BYTEBITS() ---//
	        hold >>>= bits & 7;
	        bits -= bits & 7;
	        //---//
	        state.mode = CHECK;
	        break;
	      }
	      //=== NEEDBITS(3); */
	      while (bits < 3) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.last = (hold & 0x01)/*BITS(1)*/;
	      //--- DROPBITS(1) ---//
	      hold >>>= 1;
	      bits -= 1;
	      //---//
	
	      switch ((hold & 0x03)/*BITS(2)*/) {
	      case 0:                             /* stored block */
	        //Tracev((stderr, "inflate:     stored block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = STORED;
	        break;
	      case 1:                             /* fixed block */
	        fixedtables(state);
	        //Tracev((stderr, "inflate:     fixed codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = LEN_;             /* decode codes */
	        if (flush === Z_TREES) {
	          //--- DROPBITS(2) ---//
	          hold >>>= 2;
	          bits -= 2;
	          //---//
	          break inf_leave;
	        }
	        break;
	      case 2:                             /* dynamic block */
	        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
	        //        state.last ? " (last)" : ""));
	        state.mode = TABLE;
	        break;
	      case 3:
	        strm.msg = 'invalid block type';
	        state.mode = BAD;
	      }
	      //--- DROPBITS(2) ---//
	      hold >>>= 2;
	      bits -= 2;
	      //---//
	      break;
	    case STORED:
	      //--- BYTEBITS() ---// /* go to byte boundary */
	      hold >>>= bits & 7;
	      bits -= bits & 7;
	      //---//
	      //=== NEEDBITS(32); */
	      while (bits < 32) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
	        strm.msg = 'invalid stored block lengths';
	        state.mode = BAD;
	        break;
	      }
	      state.length = hold & 0xffff;
	      //Tracev((stderr, "inflate:       stored length %u\n",
	      //        state.length));
	      //=== INITBITS();
	      hold = 0;
	      bits = 0;
	      //===//
	      state.mode = COPY_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case COPY_:
	      state.mode = COPY;
	      /* falls through */
	    case COPY:
	      copy = state.length;
	      if (copy) {
	        if (copy > have) { copy = have; }
	        if (copy > left) { copy = left; }
	        if (copy === 0) { break inf_leave; }
	        //--- zmemcpy(put, next, copy); ---
	        utils.arraySet(output, input, next, copy, put);
	        //---//
	        have -= copy;
	        next += copy;
	        left -= copy;
	        put += copy;
	        state.length -= copy;
	        break;
	      }
	      //Tracev((stderr, "inflate:       stored end\n"));
	      state.mode = TYPE;
	      break;
	    case TABLE:
	      //=== NEEDBITS(14); */
	      while (bits < 14) {
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	      }
	      //===//
	      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
	      //--- DROPBITS(5) ---//
	      hold >>>= 5;
	      bits -= 5;
	      //---//
	      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
	      //--- DROPBITS(4) ---//
	      hold >>>= 4;
	      bits -= 4;
	      //---//
	//#ifndef PKZIP_BUG_WORKAROUND
	      if (state.nlen > 286 || state.ndist > 30) {
	        strm.msg = 'too many length or distance symbols';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracev((stderr, "inflate:       table sizes ok\n"));
	      state.have = 0;
	      state.mode = LENLENS;
	      /* falls through */
	    case LENLENS:
	      while (state.have < state.ncode) {
	        //=== NEEDBITS(3);
	        while (bits < 3) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
	        //--- DROPBITS(3) ---//
	        hold >>>= 3;
	        bits -= 3;
	        //---//
	      }
	      while (state.have < 19) {
	        state.lens[order[state.have++]] = 0;
	      }
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      //state.next = state.codes;
	      //state.lencode = state.next;
	      // Switch to use dynamic table
	      state.lencode = state.lendyn;
	      state.lenbits = 7;
	
	      opts = {bits: state.lenbits};
	      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
	      state.lenbits = opts.bits;
	
	      if (ret) {
	        strm.msg = 'invalid code lengths set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, "inflate:       code lengths ok\n"));
	      state.have = 0;
	      state.mode = CODELENS;
	      /* falls through */
	    case CODELENS:
	      while (state.have < state.nlen + state.ndist) {
	        for (;;) {
	          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        if (here_val < 16) {
	          //--- DROPBITS(here.bits) ---//
	          hold >>>= here_bits;
	          bits -= here_bits;
	          //---//
	          state.lens[state.have++] = here_val;
	        }
	        else {
	          if (here_val === 16) {
	            //=== NEEDBITS(here.bits + 2);
	            n = here_bits + 2;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            if (state.have === 0) {
	              strm.msg = 'invalid bit length repeat';
	              state.mode = BAD;
	              break;
	            }
	            len = state.lens[state.have - 1];
	            copy = 3 + (hold & 0x03);//BITS(2);
	            //--- DROPBITS(2) ---//
	            hold >>>= 2;
	            bits -= 2;
	            //---//
	          }
	          else if (here_val === 17) {
	            //=== NEEDBITS(here.bits + 3);
	            n = here_bits + 3;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 3 + (hold & 0x07);//BITS(3);
	            //--- DROPBITS(3) ---//
	            hold >>>= 3;
	            bits -= 3;
	            //---//
	          }
	          else {
	            //=== NEEDBITS(here.bits + 7);
	            n = here_bits + 7;
	            while (bits < n) {
	              if (have === 0) { break inf_leave; }
	              have--;
	              hold += input[next++] << bits;
	              bits += 8;
	            }
	            //===//
	            //--- DROPBITS(here.bits) ---//
	            hold >>>= here_bits;
	            bits -= here_bits;
	            //---//
	            len = 0;
	            copy = 11 + (hold & 0x7f);//BITS(7);
	            //--- DROPBITS(7) ---//
	            hold >>>= 7;
	            bits -= 7;
	            //---//
	          }
	          if (state.have + copy > state.nlen + state.ndist) {
	            strm.msg = 'invalid bit length repeat';
	            state.mode = BAD;
	            break;
	          }
	          while (copy--) {
	            state.lens[state.have++] = len;
	          }
	        }
	      }
	
	      /* handle error breaks in while */
	      if (state.mode === BAD) { break; }
	
	      /* check for end-of-block code (better have one) */
	      if (state.lens[256] === 0) {
	        strm.msg = 'invalid code -- missing end-of-block';
	        state.mode = BAD;
	        break;
	      }
	
	      /* build code tables -- note: do not change the lenbits or distbits
	         values here (9 and 6) without reading the comments in inftrees.h
	         concerning the ENOUGH constants, which depend on those values */
	      state.lenbits = 9;
	
	      opts = {bits: state.lenbits};
	      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.lenbits = opts.bits;
	      // state.lencode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid literal/lengths set';
	        state.mode = BAD;
	        break;
	      }
	
	      state.distbits = 6;
	      //state.distcode.copy(state.codes);
	      // Switch to use dynamic table
	      state.distcode = state.distdyn;
	      opts = {bits: state.distbits};
	      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
	      // We have separate tables & no pointers. 2 commented lines below not needed.
	      // state.next_index = opts.table_index;
	      state.distbits = opts.bits;
	      // state.distcode = state.next;
	
	      if (ret) {
	        strm.msg = 'invalid distances set';
	        state.mode = BAD;
	        break;
	      }
	      //Tracev((stderr, 'inflate:       codes ok\n'));
	      state.mode = LEN_;
	      if (flush === Z_TREES) { break inf_leave; }
	      /* falls through */
	    case LEN_:
	      state.mode = LEN;
	      /* falls through */
	    case LEN:
	      if (have >= 6 && left >= 258) {
	        //--- RESTORE() ---
	        strm.next_out = put;
	        strm.avail_out = left;
	        strm.next_in = next;
	        strm.avail_in = have;
	        state.hold = hold;
	        state.bits = bits;
	        //---
	        inflate_fast(strm, _out);
	        //--- LOAD() ---
	        put = strm.next_out;
	        output = strm.output;
	        left = strm.avail_out;
	        next = strm.next_in;
	        input = strm.input;
	        have = strm.avail_in;
	        hold = state.hold;
	        bits = state.bits;
	        //---
	
	        if (state.mode === TYPE) {
	          state.back = -1;
	        }
	        break;
	      }
	      state.back = 0;
	      for (;;) {
	        here = state.lencode[hold & ((1 << state.lenbits) -1)];  /*BITS(state.lenbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if (here_bits <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if (here_op && (here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.lencode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      state.length = here_val;
	      if (here_op === 0) {
	        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
	        //        "inflate:         literal '%c'\n" :
	        //        "inflate:         literal 0x%02x\n", here.val));
	        state.mode = LIT;
	        break;
	      }
	      if (here_op & 32) {
	        //Tracevv((stderr, "inflate:         end of block\n"));
	        state.back = -1;
	        state.mode = TYPE;
	        break;
	      }
	      if (here_op & 64) {
	        strm.msg = 'invalid literal/length code';
	        state.mode = BAD;
	        break;
	      }
	      state.extra = here_op & 15;
	      state.mode = LENEXT;
	      /* falls through */
	    case LENEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.length += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	      //Tracevv((stderr, "inflate:         length %u\n", state.length));
	      state.was = state.length;
	      state.mode = DIST;
	      /* falls through */
	    case DIST:
	      for (;;) {
	        here = state.distcode[hold & ((1 << state.distbits) -1)];/*BITS(state.distbits)*/
	        here_bits = here >>> 24;
	        here_op = (here >>> 16) & 0xff;
	        here_val = here & 0xffff;
	
	        if ((here_bits) <= bits) { break; }
	        //--- PULLBYTE() ---//
	        if (have === 0) { break inf_leave; }
	        have--;
	        hold += input[next++] << bits;
	        bits += 8;
	        //---//
	      }
	      if ((here_op & 0xf0) === 0) {
	        last_bits = here_bits;
	        last_op = here_op;
	        last_val = here_val;
	        for (;;) {
	          here = state.distcode[last_val +
	                  ((hold & ((1 << (last_bits + last_op)) -1))/*BITS(last.bits + last.op)*/ >> last_bits)];
	          here_bits = here >>> 24;
	          here_op = (here >>> 16) & 0xff;
	          here_val = here & 0xffff;
	
	          if ((last_bits + here_bits) <= bits) { break; }
	          //--- PULLBYTE() ---//
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	          //---//
	        }
	        //--- DROPBITS(last.bits) ---//
	        hold >>>= last_bits;
	        bits -= last_bits;
	        //---//
	        state.back += last_bits;
	      }
	      //--- DROPBITS(here.bits) ---//
	      hold >>>= here_bits;
	      bits -= here_bits;
	      //---//
	      state.back += here_bits;
	      if (here_op & 64) {
	        strm.msg = 'invalid distance code';
	        state.mode = BAD;
	        break;
	      }
	      state.offset = here_val;
	      state.extra = (here_op) & 15;
	      state.mode = DISTEXT;
	      /* falls through */
	    case DISTEXT:
	      if (state.extra) {
	        //=== NEEDBITS(state.extra);
	        n = state.extra;
	        while (bits < n) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        state.offset += hold & ((1 << state.extra) -1)/*BITS(state.extra)*/;
	        //--- DROPBITS(state.extra) ---//
	        hold >>>= state.extra;
	        bits -= state.extra;
	        //---//
	        state.back += state.extra;
	      }
	//#ifdef INFLATE_STRICT
	      if (state.offset > state.dmax) {
	        strm.msg = 'invalid distance too far back';
	        state.mode = BAD;
	        break;
	      }
	//#endif
	      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
	      state.mode = MATCH;
	      /* falls through */
	    case MATCH:
	      if (left === 0) { break inf_leave; }
	      copy = _out - left;
	      if (state.offset > copy) {         /* copy from window */
	        copy = state.offset - copy;
	        if (copy > state.whave) {
	          if (state.sane) {
	            strm.msg = 'invalid distance too far back';
	            state.mode = BAD;
	            break;
	          }
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
	//          Trace((stderr, "inflate.c too far\n"));
	//          copy -= state.whave;
	//          if (copy > state.length) { copy = state.length; }
	//          if (copy > left) { copy = left; }
	//          left -= copy;
	//          state.length -= copy;
	//          do {
	//            output[put++] = 0;
	//          } while (--copy);
	//          if (state.length === 0) { state.mode = LEN; }
	//          break;
	//#endif
	        }
	        if (copy > state.wnext) {
	          copy -= state.wnext;
	          from = state.wsize - copy;
	        }
	        else {
	          from = state.wnext - copy;
	        }
	        if (copy > state.length) { copy = state.length; }
	        from_source = state.window;
	      }
	      else {                              /* copy from output */
	        from_source = output;
	        from = put - state.offset;
	        copy = state.length;
	      }
	      if (copy > left) { copy = left; }
	      left -= copy;
	      state.length -= copy;
	      do {
	        output[put++] = from_source[from++];
	      } while (--copy);
	      if (state.length === 0) { state.mode = LEN; }
	      break;
	    case LIT:
	      if (left === 0) { break inf_leave; }
	      output[put++] = state.length;
	      left--;
	      state.mode = LEN;
	      break;
	    case CHECK:
	      if (state.wrap) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          // Use '|' insdead of '+' to make sure that result is signed
	          hold |= input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        _out -= left;
	        strm.total_out += _out;
	        state.total += _out;
	        if (_out) {
	          strm.adler = state.check =
	              /*UPDATE(state.check, put - _out, _out);*/
	              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));
	
	        }
	        _out = left;
	        // NB: crc32 stored as signed 32-bit int, ZSWAP32 returns signed too
	        if ((state.flags ? hold : ZSWAP32(hold)) !== state.check) {
	          strm.msg = 'incorrect data check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   check matches trailer\n"));
	      }
	      state.mode = LENGTH;
	      /* falls through */
	    case LENGTH:
	      if (state.wrap && state.flags) {
	        //=== NEEDBITS(32);
	        while (bits < 32) {
	          if (have === 0) { break inf_leave; }
	          have--;
	          hold += input[next++] << bits;
	          bits += 8;
	        }
	        //===//
	        if (hold !== (state.total & 0xffffffff)) {
	          strm.msg = 'incorrect length check';
	          state.mode = BAD;
	          break;
	        }
	        //=== INITBITS();
	        hold = 0;
	        bits = 0;
	        //===//
	        //Tracev((stderr, "inflate:   length matches trailer\n"));
	      }
	      state.mode = DONE;
	      /* falls through */
	    case DONE:
	      ret = Z_STREAM_END;
	      break inf_leave;
	    case BAD:
	      ret = Z_DATA_ERROR;
	      break inf_leave;
	    case MEM:
	      return Z_MEM_ERROR;
	    case SYNC:
	      /* falls through */
	    default:
	      return Z_STREAM_ERROR;
	    }
	  }
	
	  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
	
	  /*
	     Return from inflate(), updating the total counts and the check value.
	     If there was no progress during the inflate() call, return a buffer
	     error.  Call updatewindow() to create and/or update the window state.
	     Note: a memory error from inflate() is non-recoverable.
	   */
	
	  //--- RESTORE() ---
	  strm.next_out = put;
	  strm.avail_out = left;
	  strm.next_in = next;
	  strm.avail_in = have;
	  state.hold = hold;
	  state.bits = bits;
	  //---
	
	  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
	                      (state.mode < CHECK || flush !== Z_FINISH))) {
	    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
	      state.mode = MEM;
	      return Z_MEM_ERROR;
	    }
	  }
	  _in -= strm.avail_in;
	  _out -= strm.avail_out;
	  strm.total_in += _in;
	  strm.total_out += _out;
	  state.total += _out;
	  if (state.wrap && _out) {
	    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
	      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
	  }
	  strm.data_type = state.bits + (state.last ? 64 : 0) +
	                    (state.mode === TYPE ? 128 : 0) +
	                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
	  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
	    ret = Z_BUF_ERROR;
	  }
	  return ret;
	}
	
	function inflateEnd(strm) {
	
	  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
	    return Z_STREAM_ERROR;
	  }
	
	  var state = strm.state;
	  if (state.window) {
	    state.window = null;
	  }
	  strm.state = null;
	  return Z_OK;
	}
	
	function inflateGetHeader(strm, head) {
	  var state;
	
	  /* check state */
	  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
	  state = strm.state;
	  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }
	
	  /* save header structure */
	  state.head = head;
	  head.done = false;
	  return Z_OK;
	}
	
	
	exports.inflateReset = inflateReset;
	exports.inflateReset2 = inflateReset2;
	exports.inflateResetKeep = inflateResetKeep;
	exports.inflateInit = inflateInit;
	exports.inflateInit2 = inflateInit2;
	exports.inflate = inflate;
	exports.inflateEnd = inflateEnd;
	exports.inflateGetHeader = inflateGetHeader;
	exports.inflateInfo = 'pako inflate (from Nodeca project)';
	
	/* Not implemented
	exports.inflateCopy = inflateCopy;
	exports.inflateGetDictionary = inflateGetDictionary;
	exports.inflateMark = inflateMark;
	exports.inflatePrime = inflatePrime;
	exports.inflateSetDictionary = inflateSetDictionary;
	exports.inflateSync = inflateSync;
	exports.inflateSyncPoint = inflateSyncPoint;
	exports.inflateUndermine = inflateUndermine;
	*/
	},{"../utils/common":27,"./adler32":29,"./crc32":31,"./inffast":34,"./inftrees":36}],36:[function(_dereq_,module,exports){
	'use strict';
	
	
	var utils = _dereq_('../utils/common');
	
	var MAXBITS = 15;
	var ENOUGH_LENS = 852;
	var ENOUGH_DISTS = 592;
	//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
	
	var CODES = 0;
	var LENS = 1;
	var DISTS = 2;
	
	var lbase = [ /* Length codes 257..285 base */
	  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
	  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
	];
	
	var lext = [ /* Length codes 257..285 extra */
	  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
	  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
	];
	
	var dbase = [ /* Distance codes 0..29 base */
	  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
	  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
	  8193, 12289, 16385, 24577, 0, 0
	];
	
	var dext = [ /* Distance codes 0..29 extra */
	  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
	  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
	  28, 28, 29, 29, 64, 64
	];
	
	module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
	{
	  var bits = opts.bits;
	      //here = opts.here; /* table entry for duplication */
	
	  var len = 0;               /* a code's length in bits */
	  var sym = 0;               /* index of code symbols */
	  var min = 0, max = 0;          /* minimum and maximum code lengths */
	  var root = 0;              /* number of index bits for root table */
	  var curr = 0;              /* number of index bits for current table */
	  var drop = 0;              /* code bits to drop for sub-table */
	  var left = 0;                   /* number of prefix codes available */
	  var used = 0;              /* code entries in table used */
	  var huff = 0;              /* Huffman code */
	  var incr;              /* for incrementing code, index */
	  var fill;              /* index for replicating entries */
	  var low;               /* low bits for current root entry */
	  var mask;              /* mask for low root bits */
	  var next;             /* next available space in table */
	  var base = null;     /* base value table to use */
	  var base_index = 0;
	//  var shoextra;    /* extra bits table to use */
	  var end;                    /* use base and extra for symbol > end */
	  var count = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];    /* number of codes of each length */
	  var offs = new utils.Buf16(MAXBITS+1); //[MAXBITS+1];     /* offsets in table for each length */
	  var extra = null;
	  var extra_index = 0;
	
	  var here_bits, here_op, here_val;
	
	  /*
	   Process a set of code lengths to create a canonical Huffman code.  The
	   code lengths are lens[0..codes-1].  Each length corresponds to the
	   symbols 0..codes-1.  The Huffman code is generated by first sorting the
	   symbols by length from short to long, and retaining the symbol order
	   for codes with equal lengths.  Then the code starts with all zero bits
	   for the first code of the shortest length, and the codes are integer
	   increments for the same length, and zeros are appended as the length
	   increases.  For the deflate format, these bits are stored backwards
	   from their more natural integer increment ordering, and so when the
	   decoding tables are built in the large loop below, the integer codes
	   are incremented backwards.
	
	   This routine assumes, but does not check, that all of the entries in
	   lens[] are in the range 0..MAXBITS.  The caller must assure this.
	   1..MAXBITS is interpreted as that code length.  zero means that that
	   symbol does not occur in this code.
	
	   The codes are sorted by computing a count of codes for each length,
	   creating from that a table of starting indices for each length in the
	   sorted table, and then entering the symbols in order in the sorted
	   table.  The sorted table is work[], with that space being provided by
	   the caller.
	
	   The length counts are used for other purposes as well, i.e. finding
	   the minimum and maximum length codes, determining if there are any
	   codes at all, checking for a valid set of lengths, and looking ahead
	   at length counts to determine sub-table sizes when building the
	   decoding tables.
	   */
	
	  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
	  for (len = 0; len <= MAXBITS; len++) {
	    count[len] = 0;
	  }
	  for (sym = 0; sym < codes; sym++) {
	    count[lens[lens_index + sym]]++;
	  }
	
	  /* bound code lengths, force root to be within code lengths */
	  root = bits;
	  for (max = MAXBITS; max >= 1; max--) {
	    if (count[max] !== 0) { break; }
	  }
	  if (root > max) {
	    root = max;
	  }
	  if (max === 0) {                     /* no symbols to code at all */
	    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
	    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
	    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	
	    //table.op[opts.table_index] = 64;
	    //table.bits[opts.table_index] = 1;
	    //table.val[opts.table_index++] = 0;
	    table[table_index++] = (1 << 24) | (64 << 16) | 0;
	
	    opts.bits = 1;
	    return 0;     /* no symbols, but wait for decoding to report error */
	  }
	  for (min = 1; min < max; min++) {
	    if (count[min] !== 0) { break; }
	  }
	  if (root < min) {
	    root = min;
	  }
	
	  /* check for an over-subscribed or incomplete set of lengths */
	  left = 1;
	  for (len = 1; len <= MAXBITS; len++) {
	    left <<= 1;
	    left -= count[len];
	    if (left < 0) {
	      return -1;
	    }        /* over-subscribed */
	  }
	  if (left > 0 && (type === CODES || max !== 1)) {
	    return -1;                      /* incomplete set */
	  }
	
	  /* generate offsets into symbol table for each length for sorting */
	  offs[1] = 0;
	  for (len = 1; len < MAXBITS; len++) {
	    offs[len + 1] = offs[len] + count[len];
	  }
	
	  /* sort symbols by length, by symbol order within each length */
	  for (sym = 0; sym < codes; sym++) {
	    if (lens[lens_index + sym] !== 0) {
	      work[offs[lens[lens_index + sym]]++] = sym;
	    }
	  }
	
	  /*
	   Create and fill in decoding tables.  In this loop, the table being
	   filled is at next and has curr index bits.  The code being used is huff
	   with length len.  That code is converted to an index by dropping drop
	   bits off of the bottom.  For codes where len is less than drop + curr,
	   those top drop + curr - len bits are incremented through all values to
	   fill the table with replicated entries.
	
	   root is the number of index bits for the root table.  When len exceeds
	   root, sub-tables are created pointed to by the root entry with an index
	   of the low root bits of huff.  This is saved in low to check for when a
	   new sub-table should be started.  drop is zero when the root table is
	   being filled, and drop is root when sub-tables are being filled.
	
	   When a new sub-table is needed, it is necessary to look ahead in the
	   code lengths to determine what size sub-table is needed.  The length
	   counts are used for this, and so count[] is decremented as codes are
	   entered in the tables.
	
	   used keeps track of how many table entries have been allocated from the
	   provided *table space.  It is checked for LENS and DIST tables against
	   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
	   the initial root table size constants.  See the comments in inftrees.h
	   for more information.
	
	   sym increments through all symbols, and the loop terminates when
	   all codes of length max, i.e. all codes, have been processed.  This
	   routine permits incomplete codes, so another loop after this one fills
	   in the rest of the decoding tables with invalid code markers.
	   */
	
	  /* set up for code type */
	  // poor man optimization - use if-else instead of switch,
	  // to avoid deopts in old v8
	  if (type === CODES) {
	      base = extra = work;    /* dummy value--not used */
	      end = 19;
	  } else if (type === LENS) {
	      base = lbase;
	      base_index -= 257;
	      extra = lext;
	      extra_index -= 257;
	      end = 256;
	  } else {                    /* DISTS */
	      base = dbase;
	      extra = dext;
	      end = -1;
	  }
	
	  /* initialize opts for loop */
	  huff = 0;                   /* starting code */
	  sym = 0;                    /* starting code symbol */
	  len = min;                  /* starting code length */
	  next = table_index;              /* current table to fill in */
	  curr = root;                /* current table index bits */
	  drop = 0;                   /* current bits to drop from code for index */
	  low = -1;                   /* trigger new sub-table when len > root */
	  used = 1 << root;          /* use root table entries */
	  mask = used - 1;            /* mask for comparing low */
	
	  /* check available table space */
	  if ((type === LENS && used > ENOUGH_LENS) ||
	    (type === DISTS && used > ENOUGH_DISTS)) {
	    return 1;
	  }
	
	  var i=0;
	  /* process all codes and make table entries */
	  for (;;) {
	    i++;
	    /* create table entry */
	    here_bits = len - drop;
	    if (work[sym] < end) {
	      here_op = 0;
	      here_val = work[sym];
	    }
	    else if (work[sym] > end) {
	      here_op = extra[extra_index + work[sym]];
	      here_val = base[base_index + work[sym]];
	    }
	    else {
	      here_op = 32 + 64;         /* end of block */
	      here_val = 0;
	    }
	
	    /* replicate for those indices with low len bits equal to huff */
	    incr = 1 << (len - drop);
	    fill = 1 << curr;
	    min = fill;                 /* save offset to next table */
	    do {
	      fill -= incr;
	      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
	    } while (fill !== 0);
	
	    /* backwards increment the len-bit code huff */
	    incr = 1 << (len - 1);
	    while (huff & incr) {
	      incr >>= 1;
	    }
	    if (incr !== 0) {
	      huff &= incr - 1;
	      huff += incr;
	    } else {
	      huff = 0;
	    }
	
	    /* go to next symbol, update count, len */
	    sym++;
	    if (--count[len] === 0) {
	      if (len === max) { break; }
	      len = lens[lens_index + work[sym]];
	    }
	
	    /* create new sub-table if needed */
	    if (len > root && (huff & mask) !== low) {
	      /* if first time, transition to sub-tables */
	      if (drop === 0) {
	        drop = root;
	      }
	
	      /* increment past last table */
	      next += min;            /* here min is 1 << curr */
	
	      /* determine length of next table */
	      curr = len - drop;
	      left = 1 << curr;
	      while (curr + drop < max) {
	        left -= count[curr + drop];
	        if (left <= 0) { break; }
	        curr++;
	        left <<= 1;
	      }
	
	      /* check for enough space */
	      used += 1 << curr;
	      if ((type === LENS && used > ENOUGH_LENS) ||
	        (type === DISTS && used > ENOUGH_DISTS)) {
	        return 1;
	      }
	
	      /* point entry in root table to sub-table */
	      low = huff & mask;
	      /*table.op[low] = curr;
	      table.bits[low] = root;
	      table.val[low] = next - opts.table_index;*/
	      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
	    }
	  }
	
	  /* fill in remaining table entry if code is incomplete (guaranteed to have
	   at most one remaining entry, since if the code is incomplete, the
	   maximum code length that was allowed to get this far is one bit) */
	  if (huff !== 0) {
	    //table.op[next + huff] = 64;            /* invalid code marker */
	    //table.bits[next + huff] = len - drop;
	    //table.val[next + huff] = 0;
	    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
	  }
	
	  /* set return parameters */
	  //opts.table_index += used;
	  opts.bits = root;
	  return 0;
	};
	
	},{"../utils/common":27}],37:[function(_dereq_,module,exports){
	'use strict';
	
	module.exports = {
	  '2':    'need dictionary',     /* Z_NEED_DICT       2  */
	  '1':    'stream end',          /* Z_STREAM_END      1  */
	  '0':    '',                    /* Z_OK              0  */
	  '-1':   'file error',          /* Z_ERRNO         (-1) */
	  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
	  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
	  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
	  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
	  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
	};
	},{}],38:[function(_dereq_,module,exports){
	'use strict';
	
	
	var utils = _dereq_('../utils/common');
	
	/* Public constants ==========================================================*/
	/* ===========================================================================*/
	
	
	//var Z_FILTERED          = 1;
	//var Z_HUFFMAN_ONLY      = 2;
	//var Z_RLE               = 3;
	var Z_FIXED               = 4;
	//var Z_DEFAULT_STRATEGY  = 0;
	
	/* Possible values of the data_type field (though see inflate()) */
	var Z_BINARY              = 0;
	var Z_TEXT                = 1;
	//var Z_ASCII             = 1; // = Z_TEXT
	var Z_UNKNOWN             = 2;
	
	/*============================================================================*/
	
	
	function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }
	
	// From zutil.h
	
	var STORED_BLOCK = 0;
	var STATIC_TREES = 1;
	var DYN_TREES    = 2;
	/* The three kinds of block type */
	
	var MIN_MATCH    = 3;
	var MAX_MATCH    = 258;
	/* The minimum and maximum match lengths */
	
	// From deflate.h
	/* ===========================================================================
	 * Internal compression state.
	 */
	
	var LENGTH_CODES  = 29;
	/* number of length codes, not counting the special END_BLOCK code */
	
	var LITERALS      = 256;
	/* number of literal bytes 0..255 */
	
	var L_CODES       = LITERALS + 1 + LENGTH_CODES;
	/* number of Literal or Length codes, including the END_BLOCK code */
	
	var D_CODES       = 30;
	/* number of distance codes */
	
	var BL_CODES      = 19;
	/* number of codes used to transfer the bit lengths */
	
	var HEAP_SIZE     = 2*L_CODES + 1;
	/* maximum heap size */
	
	var MAX_BITS      = 15;
	/* All codes must not exceed MAX_BITS bits */
	
	var Buf_size      = 16;
	/* size of bit buffer in bi_buf */
	
	
	/* ===========================================================================
	 * Constants
	 */
	
	var MAX_BL_BITS = 7;
	/* Bit length codes must not exceed MAX_BL_BITS bits */
	
	var END_BLOCK   = 256;
	/* end of block literal code */
	
	var REP_3_6     = 16;
	/* repeat previous bit length 3-6 times (2 bits of repeat count) */
	
	var REPZ_3_10   = 17;
	/* repeat a zero length 3-10 times  (3 bits of repeat count) */
	
	var REPZ_11_138 = 18;
	/* repeat a zero length 11-138 times  (7 bits of repeat count) */
	
	var extra_lbits =   /* extra bits for each length code */
	  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];
	
	var extra_dbits =   /* extra bits for each distance code */
	  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];
	
	var extra_blbits =  /* extra bits for each bit length code */
	  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];
	
	var bl_order =
	  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
	/* The lengths of the bit length codes are sent in order of decreasing
	 * probability, to avoid transmitting the lengths for unused bit length codes.
	 */
	
	/* ===========================================================================
	 * Local data. These are initialized only once.
	 */
	
	// We pre-fill arrays with 0 to avoid uninitialized gaps
	
	var DIST_CODE_LEN = 512; /* see definition of array dist_code below */
	
	// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
	var static_ltree  = new Array((L_CODES+2) * 2);
	zero(static_ltree);
	/* The static literal tree. Since the bit lengths are imposed, there is no
	 * need for the L_CODES extra codes used during heap construction. However
	 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
	 * below).
	 */
	
	var static_dtree  = new Array(D_CODES * 2);
	zero(static_dtree);
	/* The static distance tree. (Actually a trivial tree since all codes use
	 * 5 bits.)
	 */
	
	var _dist_code    = new Array(DIST_CODE_LEN);
	zero(_dist_code);
	/* Distance codes. The first 256 values correspond to the distances
	 * 3 .. 258, the last 256 values correspond to the top 8 bits of
	 * the 15 bit distances.
	 */
	
	var _length_code  = new Array(MAX_MATCH-MIN_MATCH+1);
	zero(_length_code);
	/* length code for each normalized match length (0 == MIN_MATCH) */
	
	var base_length   = new Array(LENGTH_CODES);
	zero(base_length);
	/* First normalized length for each code (0 = MIN_MATCH) */
	
	var base_dist     = new Array(D_CODES);
	zero(base_dist);
	/* First normalized distance for each code (0 = distance of 1) */
	
	
	var StaticTreeDesc = function (static_tree, extra_bits, extra_base, elems, max_length) {
	
	  this.static_tree  = static_tree;  /* static tree or NULL */
	  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
	  this.extra_base   = extra_base;   /* base index for extra_bits */
	  this.elems        = elems;        /* max number of elements in the tree */
	  this.max_length   = max_length;   /* max bit length for the codes */
	
	  // show if `static_tree` has data or dummy - needed for monomorphic objects
	  this.has_stree    = static_tree && static_tree.length;
	};
	
	
	var static_l_desc;
	var static_d_desc;
	var static_bl_desc;
	
	
	var TreeDesc = function(dyn_tree, stat_desc) {
	  this.dyn_tree = dyn_tree;     /* the dynamic tree */
	  this.max_code = 0;            /* largest code with non zero frequency */
	  this.stat_desc = stat_desc;   /* the corresponding static tree */
	};
	
	
	
	function d_code(dist) {
	  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
	}
	
	
	/* ===========================================================================
	 * Output a short LSB first on the stream.
	 * IN assertion: there is enough room in pendingBuf.
	 */
	function put_short (s, w) {
	//    put_byte(s, (uch)((w) & 0xff));
	//    put_byte(s, (uch)((ush)(w) >> 8));
	  s.pending_buf[s.pending++] = (w) & 0xff;
	  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
	}
	
	
	/* ===========================================================================
	 * Send a value on a given number of bits.
	 * IN assertion: length <= 16 and value fits in length bits.
	 */
	function send_bits(s, value, length) {
	  if (s.bi_valid > (Buf_size - length)) {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    put_short(s, s.bi_buf);
	    s.bi_buf = value >> (Buf_size - s.bi_valid);
	    s.bi_valid += length - Buf_size;
	  } else {
	    s.bi_buf |= (value << s.bi_valid) & 0xffff;
	    s.bi_valid += length;
	  }
	}
	
	
	function send_code(s, c, tree) {
	  send_bits(s, tree[c*2]/*.Code*/, tree[c*2 + 1]/*.Len*/);
	}
	
	
	/* ===========================================================================
	 * Reverse the first len bits of a code, using straightforward code (a faster
	 * method would use a table)
	 * IN assertion: 1 <= len <= 15
	 */
	function bi_reverse(code, len) {
	  var res = 0;
	  do {
	    res |= code & 1;
	    code >>>= 1;
	    res <<= 1;
	  } while (--len > 0);
	  return res >>> 1;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer, keeping at most 7 bits in it.
	 */
	function bi_flush(s) {
	  if (s.bi_valid === 16) {
	    put_short(s, s.bi_buf);
	    s.bi_buf = 0;
	    s.bi_valid = 0;
	
	  } else if (s.bi_valid >= 8) {
	    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
	    s.bi_buf >>= 8;
	    s.bi_valid -= 8;
	  }
	}
	
	
	/* ===========================================================================
	 * Compute the optimal bit lengths for a tree and update the total bit length
	 * for the current block.
	 * IN assertion: the fields freq and dad are set, heap[heap_max] and
	 *    above are the tree nodes sorted by increasing frequency.
	 * OUT assertions: the field len is set to the optimal bit length, the
	 *     array bl_count contains the frequencies for each bit length.
	 *     The length opt_len is updated; static_len is also updated if stree is
	 *     not null.
	 */
	function gen_bitlen(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc;    /* the tree descriptor */
	{
	  var tree            = desc.dyn_tree;
	  var max_code        = desc.max_code;
	  var stree           = desc.stat_desc.static_tree;
	  var has_stree       = desc.stat_desc.has_stree;
	  var extra           = desc.stat_desc.extra_bits;
	  var base            = desc.stat_desc.extra_base;
	  var max_length      = desc.stat_desc.max_length;
	  var h;              /* heap index */
	  var n, m;           /* iterate over the tree elements */
	  var bits;           /* bit length */
	  var xbits;          /* extra bits */
	  var f;              /* frequency */
	  var overflow = 0;   /* number of elements with bit length too large */
	
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    s.bl_count[bits] = 0;
	  }
	
	  /* In a first pass, compute the optimal bit lengths (which may
	   * overflow in the case of the bit length tree).
	   */
	  tree[s.heap[s.heap_max]*2 + 1]/*.Len*/ = 0; /* root of the heap */
	
	  for (h = s.heap_max+1; h < HEAP_SIZE; h++) {
	    n = s.heap[h];
	    bits = tree[tree[n*2 +1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
	    if (bits > max_length) {
	      bits = max_length;
	      overflow++;
	    }
	    tree[n*2 + 1]/*.Len*/ = bits;
	    /* We overwrite tree[n].Dad which is no longer needed */
	
	    if (n > max_code) { continue; } /* not a leaf node */
	
	    s.bl_count[bits]++;
	    xbits = 0;
	    if (n >= base) {
	      xbits = extra[n-base];
	    }
	    f = tree[n * 2]/*.Freq*/;
	    s.opt_len += f * (bits + xbits);
	    if (has_stree) {
	      s.static_len += f * (stree[n*2 + 1]/*.Len*/ + xbits);
	    }
	  }
	  if (overflow === 0) { return; }
	
	  // Trace((stderr,"\nbit length overflow\n"));
	  /* This happens for example on obj2 and pic of the Calgary corpus */
	
	  /* Find the first bit length which could increase: */
	  do {
	    bits = max_length-1;
	    while (s.bl_count[bits] === 0) { bits--; }
	    s.bl_count[bits]--;      /* move one leaf down the tree */
	    s.bl_count[bits+1] += 2; /* move one overflow item as its brother */
	    s.bl_count[max_length]--;
	    /* The brother of the overflow item also moves one step up,
	     * but this does not affect bl_count[max_length]
	     */
	    overflow -= 2;
	  } while (overflow > 0);
	
	  /* Now recompute all bit lengths, scanning in increasing frequency.
	   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
	   * lengths instead of fixing only the wrong ones. This idea is taken
	   * from 'ar' written by Haruhiko Okumura.)
	   */
	  for (bits = max_length; bits !== 0; bits--) {
	    n = s.bl_count[bits];
	    while (n !== 0) {
	      m = s.heap[--h];
	      if (m > max_code) { continue; }
	      if (tree[m*2 + 1]/*.Len*/ !== bits) {
	        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
	        s.opt_len += (bits - tree[m*2 + 1]/*.Len*/)*tree[m*2]/*.Freq*/;
	        tree[m*2 + 1]/*.Len*/ = bits;
	      }
	      n--;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Generate the codes for a given tree and bit counts (which need not be
	 * optimal).
	 * IN assertion: the array bl_count contains the bit length statistics for
	 * the given tree and the field len is set for all tree elements.
	 * OUT assertion: the field code is set for all tree elements of non
	 *     zero code length.
	 */
	function gen_codes(tree, max_code, bl_count)
	//    ct_data *tree;             /* the tree to decorate */
	//    int max_code;              /* largest code with non zero frequency */
	//    ushf *bl_count;            /* number of codes at each bit length */
	{
	  var next_code = new Array(MAX_BITS+1); /* next code value for each bit length */
	  var code = 0;              /* running code value */
	  var bits;                  /* bit index */
	  var n;                     /* code index */
	
	  /* The distribution counts are first used to generate the code values
	   * without bit reversal.
	   */
	  for (bits = 1; bits <= MAX_BITS; bits++) {
	    next_code[bits] = code = (code + bl_count[bits-1]) << 1;
	  }
	  /* Check that the bit counts in bl_count are consistent. The last code
	   * must be all ones.
	   */
	  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
	  //        "inconsistent bit counts");
	  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
	
	  for (n = 0;  n <= max_code; n++) {
	    var len = tree[n*2 + 1]/*.Len*/;
	    if (len === 0) { continue; }
	    /* Now reverse the bits */
	    tree[n*2]/*.Code*/ = bi_reverse(next_code[len]++, len);
	
	    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
	    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
	  }
	}
	
	
	/* ===========================================================================
	 * Initialize the various 'constant' tables.
	 */
	function tr_static_init() {
	  var n;        /* iterates over tree elements */
	  var bits;     /* bit counter */
	  var length;   /* length value */
	  var code;     /* code value */
	  var dist;     /* distance index */
	  var bl_count = new Array(MAX_BITS+1);
	  /* number of codes at each bit length for an optimal tree */
	
	  // do check in _tr_init()
	  //if (static_init_done) return;
	
	  /* For some embedded targets, global variables are not initialized: */
	/*#ifdef NO_INIT_GLOBAL_POINTERS
	  static_l_desc.static_tree = static_ltree;
	  static_l_desc.extra_bits = extra_lbits;
	  static_d_desc.static_tree = static_dtree;
	  static_d_desc.extra_bits = extra_dbits;
	  static_bl_desc.extra_bits = extra_blbits;
	#endif*/
	
	  /* Initialize the mapping length (0..255) -> length code (0..28) */
	  length = 0;
	  for (code = 0; code < LENGTH_CODES-1; code++) {
	    base_length[code] = length;
	    for (n = 0; n < (1<<extra_lbits[code]); n++) {
	      _length_code[length++] = code;
	    }
	  }
	  //Assert (length == 256, "tr_static_init: length != 256");
	  /* Note that the length 255 (match length 258) can be represented
	   * in two different ways: code 284 + 5 bits or code 285, so we
	   * overwrite length_code[255] to use the best encoding:
	   */
	  _length_code[length-1] = code;
	
	  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
	  dist = 0;
	  for (code = 0 ; code < 16; code++) {
	    base_dist[code] = dist;
	    for (n = 0; n < (1<<extra_dbits[code]); n++) {
	      _dist_code[dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: dist != 256");
	  dist >>= 7; /* from now on, all distances are divided by 128 */
	  for ( ; code < D_CODES; code++) {
	    base_dist[code] = dist << 7;
	    for (n = 0; n < (1<<(extra_dbits[code]-7)); n++) {
	      _dist_code[256 + dist++] = code;
	    }
	  }
	  //Assert (dist == 256, "tr_static_init: 256+dist != 512");
	
	  /* Construct the codes of the static literal tree */
	  for (bits = 0; bits <= MAX_BITS; bits++) {
	    bl_count[bits] = 0;
	  }
	
	  n = 0;
	  while (n <= 143) {
	    static_ltree[n*2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  while (n <= 255) {
	    static_ltree[n*2 + 1]/*.Len*/ = 9;
	    n++;
	    bl_count[9]++;
	  }
	  while (n <= 279) {
	    static_ltree[n*2 + 1]/*.Len*/ = 7;
	    n++;
	    bl_count[7]++;
	  }
	  while (n <= 287) {
	    static_ltree[n*2 + 1]/*.Len*/ = 8;
	    n++;
	    bl_count[8]++;
	  }
	  /* Codes 286 and 287 do not exist, but we must include them in the
	   * tree construction to get a canonical Huffman tree (longest code
	   * all ones)
	   */
	  gen_codes(static_ltree, L_CODES+1, bl_count);
	
	  /* The static distance tree is trivial: */
	  for (n = 0; n < D_CODES; n++) {
	    static_dtree[n*2 + 1]/*.Len*/ = 5;
	    static_dtree[n*2]/*.Code*/ = bi_reverse(n, 5);
	  }
	
	  // Now data ready and we can init static trees
	  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS+1, L_CODES, MAX_BITS);
	  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
	  static_bl_desc =new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);
	
	  //static_init_done = true;
	}
	
	
	/* ===========================================================================
	 * Initialize a new block.
	 */
	function init_block(s) {
	  var n; /* iterates over tree elements */
	
	  /* Initialize the trees. */
	  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n*2]/*.Freq*/ = 0; }
	  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n*2]/*.Freq*/ = 0; }
	  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n*2]/*.Freq*/ = 0; }
	
	  s.dyn_ltree[END_BLOCK*2]/*.Freq*/ = 1;
	  s.opt_len = s.static_len = 0;
	  s.last_lit = s.matches = 0;
	}
	
	
	/* ===========================================================================
	 * Flush the bit buffer and align the output on a byte boundary
	 */
	function bi_windup(s)
	{
	  if (s.bi_valid > 8) {
	    put_short(s, s.bi_buf);
	  } else if (s.bi_valid > 0) {
	    //put_byte(s, (Byte)s->bi_buf);
	    s.pending_buf[s.pending++] = s.bi_buf;
	  }
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	}
	
	/* ===========================================================================
	 * Copy a stored block, storing first the length and its
	 * one's complement if requested.
	 */
	function copy_block(s, buf, len, header)
	//DeflateState *s;
	//charf    *buf;    /* the input data */
	//unsigned len;     /* its length */
	//int      header;  /* true if block header must be written */
	{
	  bi_windup(s);        /* align on byte boundary */
	
	  if (header) {
	    put_short(s, len);
	    put_short(s, ~len);
	  }
	//  while (len--) {
	//    put_byte(s, *buf++);
	//  }
	  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
	  s.pending += len;
	}
	
	/* ===========================================================================
	 * Compares to subtrees, using the tree depth as tie breaker when
	 * the subtrees have equal frequency. This minimizes the worst case length.
	 */
	function smaller(tree, n, m, depth) {
	  var _n2 = n*2;
	  var _m2 = m*2;
	  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
	         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
	}
	
	/* ===========================================================================
	 * Restore the heap property by moving down the tree starting at node k,
	 * exchanging a node with the smallest of its two sons if necessary, stopping
	 * when the heap property is re-established (each father smaller than its
	 * two sons).
	 */
	function pqdownheap(s, tree, k)
	//    deflate_state *s;
	//    ct_data *tree;  /* the tree to restore */
	//    int k;               /* node to move down */
	{
	  var v = s.heap[k];
	  var j = k << 1;  /* left son of k */
	  while (j <= s.heap_len) {
	    /* Set j to the smallest of the two sons: */
	    if (j < s.heap_len &&
	      smaller(tree, s.heap[j+1], s.heap[j], s.depth)) {
	      j++;
	    }
	    /* Exit if v is smaller than both sons */
	    if (smaller(tree, v, s.heap[j], s.depth)) { break; }
	
	    /* Exchange v with the smallest son */
	    s.heap[k] = s.heap[j];
	    k = j;
	
	    /* And continue down the tree, setting j to the left son of k */
	    j <<= 1;
	  }
	  s.heap[k] = v;
	}
	
	
	// inlined manually
	// var SMALLEST = 1;
	
	/* ===========================================================================
	 * Send the block data compressed using the given Huffman trees
	 */
	function compress_block(s, ltree, dtree)
	//    deflate_state *s;
	//    const ct_data *ltree; /* literal tree */
	//    const ct_data *dtree; /* distance tree */
	{
	  var dist;           /* distance of matched string */
	  var lc;             /* match length or unmatched char (if dist == 0) */
	  var lx = 0;         /* running index in l_buf */
	  var code;           /* the code to send */
	  var extra;          /* number of extra bits to send */
	
	  if (s.last_lit !== 0) {
	    do {
	      dist = (s.pending_buf[s.d_buf + lx*2] << 8) | (s.pending_buf[s.d_buf + lx*2 + 1]);
	      lc = s.pending_buf[s.l_buf + lx];
	      lx++;
	
	      if (dist === 0) {
	        send_code(s, lc, ltree); /* send a literal byte */
	        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
	      } else {
	        /* Here, lc is the match length - MIN_MATCH */
	        code = _length_code[lc];
	        send_code(s, code+LITERALS+1, ltree); /* send the length code */
	        extra = extra_lbits[code];
	        if (extra !== 0) {
	          lc -= base_length[code];
	          send_bits(s, lc, extra);       /* send the extra length bits */
	        }
	        dist--; /* dist is now the match distance - 1 */
	        code = d_code(dist);
	        //Assert (code < D_CODES, "bad d_code");
	
	        send_code(s, code, dtree);       /* send the distance code */
	        extra = extra_dbits[code];
	        if (extra !== 0) {
	          dist -= base_dist[code];
	          send_bits(s, dist, extra);   /* send the extra distance bits */
	        }
	      } /* literal or match pair ? */
	
	      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
	      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
	      //       "pendingBuf overflow");
	
	    } while (lx < s.last_lit);
	  }
	
	  send_code(s, END_BLOCK, ltree);
	}
	
	
	/* ===========================================================================
	 * Construct one Huffman tree and assigns the code bit strings and lengths.
	 * Update the total bit length for the current block.
	 * IN assertion: the field freq is set for all tree elements.
	 * OUT assertions: the fields len and code are set to the optimal bit length
	 *     and corresponding code. The length opt_len is updated; static_len is
	 *     also updated if stree is not null. The field max_code is set.
	 */
	function build_tree(s, desc)
	//    deflate_state *s;
	//    tree_desc *desc; /* the tree descriptor */
	{
	  var tree     = desc.dyn_tree;
	  var stree    = desc.stat_desc.static_tree;
	  var has_stree = desc.stat_desc.has_stree;
	  var elems    = desc.stat_desc.elems;
	  var n, m;          /* iterate over heap elements */
	  var max_code = -1; /* largest code with non zero frequency */
	  var node;          /* new node being created */
	
	  /* Construct the initial heap, with least frequent element in
	   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
	   * heap[0] is not used.
	   */
	  s.heap_len = 0;
	  s.heap_max = HEAP_SIZE;
	
	  for (n = 0; n < elems; n++) {
	    if (tree[n * 2]/*.Freq*/ !== 0) {
	      s.heap[++s.heap_len] = max_code = n;
	      s.depth[n] = 0;
	
	    } else {
	      tree[n*2 + 1]/*.Len*/ = 0;
	    }
	  }
	
	  /* The pkzip format requires that at least one distance code exists,
	   * and that at least one bit should be sent even if there is only one
	   * possible code. So to avoid special checks later on we force at least
	   * two codes of non zero frequency.
	   */
	  while (s.heap_len < 2) {
	    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
	    tree[node * 2]/*.Freq*/ = 1;
	    s.depth[node] = 0;
	    s.opt_len--;
	
	    if (has_stree) {
	      s.static_len -= stree[node*2 + 1]/*.Len*/;
	    }
	    /* node is 0 or 1 so it does not have extra bits */
	  }
	  desc.max_code = max_code;
	
	  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
	   * establish sub-heaps of increasing lengths:
	   */
	  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }
	
	  /* Construct the Huffman tree by repeatedly combining the least two
	   * frequent nodes.
	   */
	  node = elems;              /* next internal node of the tree */
	  do {
	    //pqremove(s, tree, n);  /* n = node of least frequency */
	    /*** pqremove ***/
	    n = s.heap[1/*SMALLEST*/];
	    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	    /***/
	
	    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */
	
	    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
	    s.heap[--s.heap_max] = m;
	
	    /* Create a new node father of n and m */
	    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
	    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
	    tree[n*2 + 1]/*.Dad*/ = tree[m*2 + 1]/*.Dad*/ = node;
	
	    /* and insert the new node in the heap */
	    s.heap[1/*SMALLEST*/] = node++;
	    pqdownheap(s, tree, 1/*SMALLEST*/);
	
	  } while (s.heap_len >= 2);
	
	  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];
	
	  /* At this point, the fields freq and dad are set. We can now
	   * generate the bit lengths.
	   */
	  gen_bitlen(s, desc);
	
	  /* The field len is now set, we can generate the bit codes */
	  gen_codes(tree, max_code, s.bl_count);
	}
	
	
	/* ===========================================================================
	 * Scan a literal or distance tree to determine the frequencies of the codes
	 * in the bit length tree.
	 */
	function scan_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree;   /* the tree to be scanned */
	//    int max_code;    /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	  tree[(max_code+1)*2 + 1]/*.Len*/ = 0xffff; /* guard */
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n+1)*2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      s.bl_tree[curlen * 2]/*.Freq*/ += count;
	
	    } else if (curlen !== 0) {
	
	      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
	      s.bl_tree[REP_3_6*2]/*.Freq*/++;
	
	    } else if (count <= 10) {
	      s.bl_tree[REPZ_3_10*2]/*.Freq*/++;
	
	    } else {
	      s.bl_tree[REPZ_11_138*2]/*.Freq*/++;
	    }
	
	    count = 0;
	    prevlen = curlen;
	
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Send a literal or distance tree in compressed form, using the codes in
	 * bl_tree.
	 */
	function send_tree(s, tree, max_code)
	//    deflate_state *s;
	//    ct_data *tree; /* the tree to be scanned */
	//    int max_code;       /* and its largest code of non zero frequency */
	{
	  var n;                     /* iterates over all tree elements */
	  var prevlen = -1;          /* last emitted length */
	  var curlen;                /* length of current code */
	
	  var nextlen = tree[0*2 + 1]/*.Len*/; /* length of next code */
	
	  var count = 0;             /* repeat count of the current code */
	  var max_count = 7;         /* max repeat count */
	  var min_count = 4;         /* min repeat count */
	
	  /* tree[max_code+1].Len = -1; */  /* guard already set */
	  if (nextlen === 0) {
	    max_count = 138;
	    min_count = 3;
	  }
	
	  for (n = 0; n <= max_code; n++) {
	    curlen = nextlen;
	    nextlen = tree[(n+1)*2 + 1]/*.Len*/;
	
	    if (++count < max_count && curlen === nextlen) {
	      continue;
	
	    } else if (count < min_count) {
	      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);
	
	    } else if (curlen !== 0) {
	      if (curlen !== prevlen) {
	        send_code(s, curlen, s.bl_tree);
	        count--;
	      }
	      //Assert(count >= 3 && count <= 6, " 3_6?");
	      send_code(s, REP_3_6, s.bl_tree);
	      send_bits(s, count-3, 2);
	
	    } else if (count <= 10) {
	      send_code(s, REPZ_3_10, s.bl_tree);
	      send_bits(s, count-3, 3);
	
	    } else {
	      send_code(s, REPZ_11_138, s.bl_tree);
	      send_bits(s, count-11, 7);
	    }
	
	    count = 0;
	    prevlen = curlen;
	    if (nextlen === 0) {
	      max_count = 138;
	      min_count = 3;
	
	    } else if (curlen === nextlen) {
	      max_count = 6;
	      min_count = 3;
	
	    } else {
	      max_count = 7;
	      min_count = 4;
	    }
	  }
	}
	
	
	/* ===========================================================================
	 * Construct the Huffman tree for the bit lengths and return the index in
	 * bl_order of the last bit length code to send.
	 */
	function build_bl_tree(s) {
	  var max_blindex;  /* index of last bit length code of non zero freq */
	
	  /* Determine the bit length frequencies for literal and distance trees */
	  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
	  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
	
	  /* Build the bit length tree: */
	  build_tree(s, s.bl_desc);
	  /* opt_len now includes the length of the tree representations, except
	   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
	   */
	
	  /* Determine the number of bit length codes to send. The pkzip format
	   * requires that at least 4 bit length codes be sent. (appnote.txt says
	   * 3 but the actual value used is 4.)
	   */
	  for (max_blindex = BL_CODES-1; max_blindex >= 3; max_blindex--) {
	    if (s.bl_tree[bl_order[max_blindex]*2 + 1]/*.Len*/ !== 0) {
	      break;
	    }
	  }
	  /* Update opt_len to include the bit length tree and counts */
	  s.opt_len += 3*(max_blindex+1) + 5+5+4;
	  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
	  //        s->opt_len, s->static_len));
	
	  return max_blindex;
	}
	
	
	/* ===========================================================================
	 * Send the header for a block using dynamic Huffman trees: the counts, the
	 * lengths of the bit length codes, the literal tree and the distance tree.
	 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
	 */
	function send_all_trees(s, lcodes, dcodes, blcodes)
	//    deflate_state *s;
	//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
	{
	  var rank;                    /* index in bl_order */
	
	  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
	  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
	  //        "too many codes");
	  //Tracev((stderr, "\nbl counts: "));
	  send_bits(s, lcodes-257, 5); /* not +255 as stated in appnote.txt */
	  send_bits(s, dcodes-1,   5);
	  send_bits(s, blcodes-4,  4); /* not -3 as stated in appnote.txt */
	  for (rank = 0; rank < blcodes; rank++) {
	    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
	    send_bits(s, s.bl_tree[bl_order[rank]*2 + 1]/*.Len*/, 3);
	  }
	  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_ltree, lcodes-1); /* literal tree */
	  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
	
	  send_tree(s, s.dyn_dtree, dcodes-1); /* distance tree */
	  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
	}
	
	
	/* ===========================================================================
	 * Check if the data type is TEXT or BINARY, using the following algorithm:
	 * - TEXT if the two conditions below are satisfied:
	 *    a) There are no non-portable control characters belonging to the
	 *       "black list" (0..6, 14..25, 28..31).
	 *    b) There is at least one printable character belonging to the
	 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
	 * - BINARY otherwise.
	 * - The following partially-portable control characters form a
	 *   "gray list" that is ignored in this detection algorithm:
	 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
	 * IN assertion: the fields Freq of dyn_ltree are set.
	 */
	function detect_data_type(s) {
	  /* black_mask is the bit mask of black-listed bytes
	   * set bits 0..6, 14..25, and 28..31
	   * 0xf3ffc07f = binary 11110011111111111100000001111111
	   */
	  var black_mask = 0xf3ffc07f;
	  var n;
	
	  /* Check for non-textual ("black-listed") bytes. */
	  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
	    if ((black_mask & 1) && (s.dyn_ltree[n*2]/*.Freq*/ !== 0)) {
	      return Z_BINARY;
	    }
	  }
	
	  /* Check for textual ("white-listed") bytes. */
	  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
	      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
	    return Z_TEXT;
	  }
	  for (n = 32; n < LITERALS; n++) {
	    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
	      return Z_TEXT;
	    }
	  }
	
	  /* There are no "black-listed" or "white-listed" bytes:
	   * this stream either is empty or has tolerated ("gray-listed") bytes only.
	   */
	  return Z_BINARY;
	}
	
	
	var static_init_done = false;
	
	/* ===========================================================================
	 * Initialize the tree data structures for a new zlib stream.
	 */
	function _tr_init(s)
	{
	
	  if (!static_init_done) {
	    tr_static_init();
	    static_init_done = true;
	  }
	
	  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
	  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
	  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
	
	  s.bi_buf = 0;
	  s.bi_valid = 0;
	
	  /* Initialize the first block of the first file: */
	  init_block(s);
	}
	
	
	/* ===========================================================================
	 * Send a stored block
	 */
	function _tr_stored_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  send_bits(s, (STORED_BLOCK<<1)+(last ? 1 : 0), 3);    /* send block type */
	  copy_block(s, buf, stored_len, true); /* with header */
	}
	
	
	/* ===========================================================================
	 * Send one empty static block to give enough lookahead for inflate.
	 * This takes 10 bits, of which 7 may remain in the bit buffer.
	 */
	function _tr_align(s) {
	  send_bits(s, STATIC_TREES<<1, 3);
	  send_code(s, END_BLOCK, static_ltree);
	  bi_flush(s);
	}
	
	
	/* ===========================================================================
	 * Determine the best encoding for the current block: dynamic trees, static
	 * trees or store, and output the encoded block to the zip file.
	 */
	function _tr_flush_block(s, buf, stored_len, last)
	//DeflateState *s;
	//charf *buf;       /* input block, or NULL if too old */
	//ulg stored_len;   /* length of input block */
	//int last;         /* one if this is the last block for a file */
	{
	  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
	  var max_blindex = 0;        /* index of last bit length code of non zero freq */
	
	  /* Build the Huffman trees unless a stored block is forced */
	  if (s.level > 0) {
	
	    /* Check if the file is binary or text */
	    if (s.strm.data_type === Z_UNKNOWN) {
	      s.strm.data_type = detect_data_type(s);
	    }
	
	    /* Construct the literal and distance trees */
	    build_tree(s, s.l_desc);
	    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	
	    build_tree(s, s.d_desc);
	    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
	    //        s->static_len));
	    /* At this point, opt_len and static_len are the total bit lengths of
	     * the compressed block data, excluding the tree representations.
	     */
	
	    /* Build the bit length tree for the above two trees, and get the index
	     * in bl_order of the last bit length code to send.
	     */
	    max_blindex = build_bl_tree(s);
	
	    /* Determine the best encoding. Compute the block lengths in bytes. */
	    opt_lenb = (s.opt_len+3+7) >>> 3;
	    static_lenb = (s.static_len+3+7) >>> 3;
	
	    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
	    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
	    //        s->last_lit));
	
	    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }
	
	  } else {
	    // Assert(buf != (char*)0, "lost buf");
	    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
	  }
	
	  if ((stored_len+4 <= opt_lenb) && (buf !== -1)) {
	    /* 4: two words for the lengths */
	
	    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
	     * Otherwise we can't have processed more than WSIZE input bytes since
	     * the last block flush, because compression would have been
	     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
	     * transform a block into a stored block.
	     */
	    _tr_stored_block(s, buf, stored_len, last);
	
	  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
	
	    send_bits(s, (STATIC_TREES<<1) + (last ? 1 : 0), 3);
	    compress_block(s, static_ltree, static_dtree);
	
	  } else {
	    send_bits(s, (DYN_TREES<<1) + (last ? 1 : 0), 3);
	    send_all_trees(s, s.l_desc.max_code+1, s.d_desc.max_code+1, max_blindex+1);
	    compress_block(s, s.dyn_ltree, s.dyn_dtree);
	  }
	  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
	  /* The above check is made mod 2^32, for files larger than 512 MB
	   * and uLong implemented on 32 bits.
	   */
	  init_block(s);
	
	  if (last) {
	    bi_windup(s);
	  }
	  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
	  //       s->compressed_len-7*last));
	}
	
	/* ===========================================================================
	 * Save the match info and tally the frequency counts. Return true if
	 * the current block must be flushed.
	 */
	function _tr_tally(s, dist, lc)
	//    deflate_state *s;
	//    unsigned dist;  /* distance of matched string */
	//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
	{
	  //var out_length, in_length, dcode;
	
	  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
	  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
	
	  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
	  s.last_lit++;
	
	  if (dist === 0) {
	    /* lc is the unmatched char */
	    s.dyn_ltree[lc*2]/*.Freq*/++;
	  } else {
	    s.matches++;
	    /* Here, lc is the match length - MIN_MATCH */
	    dist--;             /* dist = match distance - 1 */
	    //Assert((ush)dist < (ush)MAX_DIST(s) &&
	    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
	    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
	
	    s.dyn_ltree[(_length_code[lc]+LITERALS+1) * 2]/*.Freq*/++;
	    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
	  }
	
	// (!) This block is disabled in zlib defailts,
	// don't enable it for binary compatibility
	
	//#ifdef TRUNCATE_BLOCK
	//  /* Try to guess if it is profitable to stop the current block here */
	//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
	//    /* Compute an upper bound for the compressed length */
	//    out_length = s.last_lit*8;
	//    in_length = s.strstart - s.block_start;
	//
	//    for (dcode = 0; dcode < D_CODES; dcode++) {
	//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
	//    }
	//    out_length >>>= 3;
	//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
	//    //       s->last_lit, in_length, out_length,
	//    //       100L - out_length*100L/in_length));
	//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
	//      return true;
	//    }
	//  }
	//#endif
	
	  return (s.last_lit === s.lit_bufsize-1);
	  /* We avoid equality with lit_bufsize because of wraparound at 64K
	   * on 16 bit machines and because stored blocks are restricted to
	   * 64K-1 bytes.
	   */
	}
	
	exports._tr_init  = _tr_init;
	exports._tr_stored_block = _tr_stored_block;
	exports._tr_flush_block  = _tr_flush_block;
	exports._tr_tally = _tr_tally;
	exports._tr_align = _tr_align;
	},{"../utils/common":27}],39:[function(_dereq_,module,exports){
	'use strict';
	
	
	function ZStream() {
	  /* next input byte */
	  this.input = null; // JS specific, because we have no pointers
	  this.next_in = 0;
	  /* number of bytes available at input */
	  this.avail_in = 0;
	  /* total number of input bytes read so far */
	  this.total_in = 0;
	  /* next output byte should be put there */
	  this.output = null; // JS specific, because we have no pointers
	  this.next_out = 0;
	  /* remaining free space at output */
	  this.avail_out = 0;
	  /* total number of bytes output so far */
	  this.total_out = 0;
	  /* last error message, NULL if no error */
	  this.msg = ''/*Z_NULL*/;
	  /* not visible by applications */
	  this.state = null;
	  /* best guess about the data type: binary or text */
	  this.data_type = 2/*Z_UNKNOWN*/;
	  /* adler32 value of the uncompressed data */
	  this.adler = 0;
	}
	
	module.exports = ZStream;
	},{}]},{},[9])
	(9)
	}));


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, Buffer, process) {/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported XLSX */
	/*global global, exports, module, require:false, process:false, Buffer:false, ArrayBuffer:false */
	var XLSX = {};
	function make_xlsx_lib(XLSX){
	XLSX.version = '0.17.5';
	var current_codepage = 1200, current_ansi = 1252;
	/*global cptable:true, window */
	if(true) {
		if(typeof cptable === 'undefined') {
			if(typeof global !== 'undefined') global.cptable = __webpack_require__(815);
			else if(typeof window !== 'undefined') window.cptable = __webpack_require__(815);
		}
	}
	
	var VALID_ANSI = [ 874, 932, 936, 949, 950 ];
	for(var i = 0; i <= 8; ++i) VALID_ANSI.push(1250 + i);
	/* ECMA-376 Part I 18.4.1 charset to codepage mapping */
	var CS2CP = ({
	0:    1252, /* ANSI */
	1:   65001, /* DEFAULT */
	2:   65001, /* SYMBOL */
	77:  10000, /* MAC */
	128:   932, /* SHIFTJIS */
	129:   949, /* HANGUL */
	130:  1361, /* JOHAB */
	134:   936, /* GB2312 */
	136:   950, /* CHINESEBIG5 */
	161:  1253, /* GREEK */
	162:  1254, /* TURKISH */
	163:  1258, /* VIETNAMESE */
	177:  1255, /* HEBREW */
	178:  1256, /* ARABIC */
	186:  1257, /* BALTIC */
	204:  1251, /* RUSSIAN */
	222:   874, /* THAI */
	238:  1250, /* EASTEUROPE */
	255:  1252, /* OEM */
	69:   6969  /* MISC */
	});
	
	var set_ansi = function(cp) { if(VALID_ANSI.indexOf(cp) == -1) return; current_ansi = CS2CP[0] = cp; };
	function reset_ansi() { set_ansi(1252); }
	
	var set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
	function reset_cp() { set_cp(1200); reset_ansi(); }
	
	function char_codes(data) { var o = []; for(var i = 0, len = data.length; i < len; ++i) o[i] = data.charCodeAt(i); return o; }
	
	function utf16leread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i) + (data.charCodeAt(2*i+1)<<8));
		return o.join("");
	}
	function utf16beread(data) {
		var o = [];
		for(var i = 0; i < (data.length>>1); ++i) o[i] = String.fromCharCode(data.charCodeAt(2*i+1) + (data.charCodeAt(2*i)<<8));
		return o.join("");
	}
	
	var debom = function(data) {
		var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
		if(c1 == 0xFF && c2 == 0xFE) return utf16leread(data.slice(2));
		if(c1 == 0xFE && c2 == 0xFF) return utf16beread(data.slice(2));
		if(c1 == 0xFEFF) return data.slice(1);
		return data;
	};
	
	var _getchar = function _gc1(x) { return String.fromCharCode(x); };
	var _getansi = function _ga1(x) { return String.fromCharCode(x); };
	if(typeof cptable !== 'undefined') {
		set_cp = function(cp) { current_codepage = cp; set_ansi(cp); };
		debom = function(data) {
			if(data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) { return cptable.utils.decode(1200, char_codes(data.slice(2))); }
			return data;
		};
		_getchar = function _gc2(x) {
			if(current_codepage === 1200) return String.fromCharCode(x);
			return cptable.utils.decode(current_codepage, [x&255,x>>8])[0];
		};
		_getansi = function _ga2(x) {
			return cptable.utils.decode(current_ansi, [x])[0];
		};
	}
	var DENSE = null;
	var DIF_XL = true;
	var Base64 = (function make_b64(){
		var map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
		return {
			encode: function(input) {
				var o = "";
				var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
				for(var i = 0; i < input.length; ) {
					c1 = input.charCodeAt(i++);
					e1 = (c1 >> 2);
	
					c2 = input.charCodeAt(i++);
					e2 = ((c1 & 3) << 4) | (c2 >> 4);
	
					c3 = input.charCodeAt(i++);
					e3 = ((c2 & 15) << 2) | (c3 >> 6);
					e4 = (c3 & 63);
					if (isNaN(c2)) { e3 = e4 = 64; }
					else if (isNaN(c3)) { e4 = 64; }
					o += map.charAt(e1) + map.charAt(e2) + map.charAt(e3) + map.charAt(e4);
				}
				return o;
			},
			decode: function b64_decode(input) {
				var o = "";
				var c1=0, c2=0, c3=0, e1=0, e2=0, e3=0, e4=0;
				input = input.replace(/[^\w\+\/\=]/g, "");
				for(var i = 0; i < input.length;) {
					e1 = map.indexOf(input.charAt(i++));
					e2 = map.indexOf(input.charAt(i++));
					c1 = (e1 << 2) | (e2 >> 4);
					o += String.fromCharCode(c1);
	
					e3 = map.indexOf(input.charAt(i++));
					c2 = ((e2 & 15) << 4) | (e3 >> 2);
					if (e3 !== 64) { o += String.fromCharCode(c2); }
	
					e4 = map.indexOf(input.charAt(i++));
					c3 = ((e3 & 3) << 6) | e4;
					if (e4 !== 64) { o += String.fromCharCode(c3); }
				}
				return o;
			}
		};
	})();
	var has_buf = (typeof Buffer !== 'undefined' && typeof process !== 'undefined' && typeof process.versions !== 'undefined' && !!process.versions.node);
	
	var Buffer_from = function(){};
	
	if(typeof Buffer !== 'undefined') {
		var nbfs = !Buffer.from;
		if(!nbfs) try { Buffer.from("foo", "utf8"); } catch(e) { nbfs = true; }
		Buffer_from = nbfs ? function(buf, enc) { return (enc) ? new Buffer(buf, enc) : new Buffer(buf); } : Buffer.from.bind(Buffer);
		// $FlowIgnore
		if(!Buffer.alloc) Buffer.alloc = function(n) { return new Buffer(n); };
		// $FlowIgnore
		if(!Buffer.allocUnsafe) Buffer.allocUnsafe = function(n) { return new Buffer(n); };
	}
	
	function new_raw_buf(len) {
		/* jshint -W056 */
		return has_buf ? Buffer.alloc(len) : new Array(len);
		/* jshint +W056 */
	}
	
	function new_unsafe_buf(len) {
		/* jshint -W056 */
		return has_buf ? Buffer.allocUnsafe(len) : new Array(len);
		/* jshint +W056 */
	}
	
	var s2a = function s2a(s) {
		if(has_buf) return Buffer_from(s, "binary");
		return s.split("").map(function(x){ return x.charCodeAt(0) & 0xff; });
	};
	
	function s2ab(s) {
		if(typeof ArrayBuffer === 'undefined') return s2a(s);
		var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
		for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
		return buf;
	}
	
	function a2s(data) {
		if(Array.isArray(data)) return data.map(function(c) { return String.fromCharCode(c); }).join("");
		var o = []; for(var i = 0; i < data.length; ++i) o[i] = String.fromCharCode(data[i]); return o.join("");
	}
	
	function a2u(data) {
		if(typeof Uint8Array === 'undefined') throw new Error("Unsupported");
		return new Uint8Array(data);
	}
	
	function ab2a(data) {
		if(typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
		if(data instanceof ArrayBuffer) return ab2a(new Uint8Array(data));
	var o = new Array(data.length);
		for(var i = 0; i < data.length; ++i) o[i] = data[i];
		return o;
	}
	
	var bconcat = function(bufs) { return [].concat.apply([], bufs); };
	
	var chr0 = /\u0000/g, chr1 = /[\u0001-\u0006]/g;
	/* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/*jshint -W041 */
	var SSF = ({});
	var make_ssf = function make_ssf(SSF){
	SSF.version = '0.11.2';
	function _strrev(x) { var o = "", i = x.length-1; while(i>=0) o += x.charAt(i--); return o; }
	function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
	function pad0(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad_(v,d){var t=""+v;return t.length>=d?t:fill(' ',d-t.length)+t;}
	function rpad_(v,d){var t=""+v; return t.length>=d?t:t+fill(' ',d-t.length);}
	function pad0r1(v,d){var t=""+Math.round(v); return t.length>=d?t:fill('0',d-t.length)+t;}
	function pad0r2(v,d){var t=""+v; return t.length>=d?t:fill('0',d-t.length)+t;}
	var p2_32 = Math.pow(2,32);
	function pad0r(v,d){if(v>p2_32||v<-p2_32) return pad0r1(v,d); var i = Math.round(v); return pad0r2(i,d); }
	function isgeneral(s, i) { i = i || 0; return s.length >= 7 + i && (s.charCodeAt(i)|32) === 103 && (s.charCodeAt(i+1)|32) === 101 && (s.charCodeAt(i+2)|32) === 110 && (s.charCodeAt(i+3)|32) === 101 && (s.charCodeAt(i+4)|32) === 114 && (s.charCodeAt(i+5)|32) === 97 && (s.charCodeAt(i+6)|32) === 108; }
	var days = [
		['Sun', 'Sunday'],
		['Mon', 'Monday'],
		['Tue', 'Tuesday'],
		['Wed', 'Wednesday'],
		['Thu', 'Thursday'],
		['Fri', 'Friday'],
		['Sat', 'Saturday']
	];
	var months = [
		['J', 'Jan', 'January'],
		['F', 'Feb', 'February'],
		['M', 'Mar', 'March'],
		['A', 'Apr', 'April'],
		['M', 'May', 'May'],
		['J', 'Jun', 'June'],
		['J', 'Jul', 'July'],
		['A', 'Aug', 'August'],
		['S', 'Sep', 'September'],
		['O', 'Oct', 'October'],
		['N', 'Nov', 'November'],
		['D', 'Dec', 'December']
	];
	function init_table(t) {
		t[0]=  'General';
		t[1]=  '0';
		t[2]=  '0.00';
		t[3]=  '#,##0';
		t[4]=  '#,##0.00';
		t[9]=  '0%';
		t[10]= '0.00%';
		t[11]= '0.00E+00';
		t[12]= '# ?/?';
		t[13]= '# ??/??';
		t[14]= 'm/d/yy';
		t[15]= 'd-mmm-yy';
		t[16]= 'd-mmm';
		t[17]= 'mmm-yy';
		t[18]= 'h:mm AM/PM';
		t[19]= 'h:mm:ss AM/PM';
		t[20]= 'h:mm';
		t[21]= 'h:mm:ss';
		t[22]= 'm/d/yy h:mm';
		t[37]= '#,##0 ;(#,##0)';
		t[38]= '#,##0 ;[Red](#,##0)';
		t[39]= '#,##0.00;(#,##0.00)';
		t[40]= '#,##0.00;[Red](#,##0.00)';
		t[45]= 'mm:ss';
		t[46]= '[h]:mm:ss';
		t[47]= 'mmss.0';
		t[48]= '##0.0E+0';
		t[49]= '@';
		t[56]= '"上午/下午 "hh"時"mm"分"ss"秒 "';
	}
	
	var table_fmt = {};
	init_table(table_fmt);
	/* Defaults determined by systematically testing in Excel 2019 */
	
	/* These formats appear to default to other formats in the table */
	var default_map = [];
	var defi = 0;
	
	//  5 -> 37 ...  8 -> 40
	for(defi = 5; defi <= 8; ++defi) default_map[defi] = 32 + defi;
	
	// 23 ->  0 ... 26 ->  0
	for(defi = 23; defi <= 26; ++defi) default_map[defi] = 0;
	
	// 27 -> 14 ... 31 -> 14
	for(defi = 27; defi <= 31; ++defi) default_map[defi] = 14;
	// 50 -> 14 ... 58 -> 14
	for(defi = 50; defi <= 58; ++defi) default_map[defi] = 14;
	
	// 59 ->  1 ... 62 ->  4
	for(defi = 59; defi <= 62; ++defi) default_map[defi] = defi - 58;
	// 67 ->  9 ... 68 -> 10
	for(defi = 67; defi <= 68; ++defi) default_map[defi] = defi - 58;
	// 72 -> 14 ... 75 -> 17
	for(defi = 72; defi <= 75; ++defi) default_map[defi] = defi - 58;
	
	// 69 -> 12 ... 71 -> 14
	for(defi = 67; defi <= 68; ++defi) default_map[defi] = defi - 57;
	
	// 76 -> 20 ... 78 -> 22
	for(defi = 76; defi <= 78; ++defi) default_map[defi] = defi - 56;
	
	// 79 -> 45 ... 81 -> 47
	for(defi = 79; defi <= 81; ++defi) default_map[defi] = defi - 34;
	
	// 82 ->  0 ... 65536 -> 0 (omitted)
	
	/* These formats technically refer to Accounting formats with no equivalent */
	var default_str = [];
	
	//  5 -- Currency,   0 decimal, black negative
	default_str[5] = default_str[63] = '"$"#,##0_);\\("$"#,##0\\)';
	//  6 -- Currency,   0 decimal, red   negative
	default_str[6] = default_str[64] = '"$"#,##0_);[Red]\\("$"#,##0\\)';
	//  7 -- Currency,   2 decimal, black negative
	default_str[7] = default_str[65] = '"$"#,##0.00_);\\("$"#,##0.00\\)';
	//  8 -- Currency,   2 decimal, red   negative
	default_str[8] = default_str[66] = '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)';
	
	// 41 -- Accounting, 0 decimal, No Symbol
	default_str[41] = '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)';
	// 42 -- Accounting, 0 decimal, $  Symbol
	default_str[42] = '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)';
	// 43 -- Accounting, 2 decimal, No Symbol
	default_str[43] = '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)';
	// 44 -- Accounting, 2 decimal, $  Symbol
	default_str[44] = '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)';
	function frac(x, D, mixed) {
		var sgn = x < 0 ? -1 : 1;
		var B = x * sgn;
		var P_2 = 0, P_1 = 1, P = 0;
		var Q_2 = 1, Q_1 = 0, Q = 0;
		var A = Math.floor(B);
		while(Q_1 < D) {
			A = Math.floor(B);
			P = A * P_1 + P_2;
			Q = A * Q_1 + Q_2;
			if((B - A) < 0.00000005) break;
			B = 1 / (B - A);
			P_2 = P_1; P_1 = P;
			Q_2 = Q_1; Q_1 = Q;
		}
		if(Q > D) { if(Q_1 > D) { Q = Q_2; P = P_2; } else { Q = Q_1; P = P_1; } }
		if(!mixed) return [0, sgn * P, Q];
		var q = Math.floor(sgn * P/Q);
		return [q, sgn*P - q*Q, Q];
	}
	function parse_date_code(v,opts,b2) {
		if(v > 2958465 || v < 0) return null;
		var date = (v|0), time = Math.floor(86400 * (v - date)), dow=0;
		var dout=[];
		var out={D:date, T:time, u:86400*(v-date)-time,y:0,m:0,d:0,H:0,M:0,S:0,q:0};
		if(Math.abs(out.u) < 1e-6) out.u = 0;
		if(opts && opts.date1904) date += 1462;
		if(out.u > 0.9999) {
			out.u = 0;
			if(++time == 86400) { out.T = time = 0; ++date; ++out.D; }
		}
		if(date === 60) {dout = b2 ? [1317,10,29] : [1900,2,29]; dow=3;}
		else if(date === 0) {dout = b2 ? [1317,8,29] : [1900,1,0]; dow=6;}
		else {
			if(date > 60) --date;
			/* 1 = Jan 1 1900 in Gregorian */
			var d = new Date(1900, 0, 1);
			d.setDate(d.getDate() + date - 1);
			dout = [d.getFullYear(), d.getMonth()+1,d.getDate()];
			dow = d.getDay();
			if(date < 60) dow = (dow + 6) % 7;
			if(b2) dow = fix_hijri(d, dout);
		}
		out.y = dout[0]; out.m = dout[1]; out.d = dout[2];
		out.S = time % 60; time = Math.floor(time / 60);
		out.M = time % 60; time = Math.floor(time / 60);
		out.H = time;
		out.q = dow;
		return out;
	}
	SSF.parse_date_code = parse_date_code;
	var basedate = new Date(1899, 11, 31, 0, 0, 0);
	var dnthresh = basedate.getTime();
	var base1904 = new Date(1900, 2, 1, 0, 0, 0);
	function datenum_local(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1461*24*60*60*1000;
		else if(v >= base1904) epoch += 24*60*60*1000;
		return (epoch - (dnthresh + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000)) / (24 * 60 * 60 * 1000);
	}
	/* The longest 32-bit integer text is "-4294967296", exactly 11 chars */
	function general_fmt_int(v) { return v.toString(10); }
	SSF._general_int = general_fmt_int;
	
	/* ECMA-376 18.8.30 numFmt*/
	/* Note: `toPrecision` uses standard form when prec > E and E >= -6 */
	var general_fmt_num = (function make_general_fmt_num() {
		var trailing_zeroes_and_decimal = /(?:\.0*|(\.\d*[1-9])0+)$/;
		function strip_decimal(o) {
			return (o.indexOf(".") == -1) ? o : o.replace(trailing_zeroes_and_decimal, "$1");
		}
	
		/* General Exponential always shows 2 digits exp and trims the mantissa */
		var mantissa_zeroes_and_decimal = /(?:\.0*|(\.\d*[1-9])0+)[Ee]/;
		var exp_with_single_digit = /(E[+-])(\d)$/;
		function normalize_exp(o) {
			if(o.indexOf("E") == -1) return o;
			return o.replace(mantissa_zeroes_and_decimal,"$1E").replace(exp_with_single_digit,"$10$2");
		}
	
		/* exponent >= -9 and <= 9 */
		function small_exp(v) {
			var w = (v<0?12:11);
			var o = strip_decimal(v.toFixed(12)); if(o.length <= w) return o;
			o = v.toPrecision(10); if(o.length <= w) return o;
			return v.toExponential(5);
		}
	
		/* exponent >= 11 or <= -10 likely exponential */
		function large_exp(v) {
			var o = strip_decimal(v.toFixed(11));
			return (o.length > (v<0?12:11) || o === "0" || o === "-0") ? v.toPrecision(6) : o;
		}
	
		function general_fmt_num_base(v) {
			var V = Math.floor(Math.log(Math.abs(v))*Math.LOG10E), o;
	
			if(V >= -4 && V <= -1) o = v.toPrecision(10+V);
			else if(Math.abs(V) <= 9) o = small_exp(v);
			else if(V === 10) o = v.toFixed(10).substr(0,12);
			else o = large_exp(v);
	
			return strip_decimal(normalize_exp(o.toUpperCase()));
		}
	
		return general_fmt_num_base;
	})();
	SSF._general_num = general_fmt_num;
	
	/*
		"General" rules:
		- text is passed through ("@")
		- booleans are rendered as TRUE/FALSE
		- "up to 11 characters" displayed for numbers
		- Default date format (code 14) used for Dates
	
		TODO: technically the display depends on the width of the cell
	*/
	function general_fmt(v, opts) {
		switch(typeof v) {
			case 'string': return v;
			case 'boolean': return v ? "TRUE" : "FALSE";
			case 'number': return (v|0) === v ? v.toString(10) : general_fmt_num(v);
			case 'undefined': return "";
			case 'object':
				if(v == null) return "";
				if(v instanceof Date) return format(14, datenum_local(v, opts && opts.date1904), opts);
		}
		throw new Error("unsupported value in General format: " + v);
	}
	SSF._general = general_fmt;
	function fix_hijri(date, o) {
	  /* TODO: properly adjust y/m/d and  */
	  o[0] -= 581;
	  var dow = date.getDay();
	  if(date < 60) dow = (dow + 6) % 7;
	  return dow;
	}
	//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
	/*jshint -W086 */
	function write_date(type, fmt, val, ss0) {
		var o="", ss=0, tt=0, y = val.y, out, outl = 0;
		switch(type) {
			case 98: /* 'b' buddhist year */
				y = val.y + 543;
				/* falls through */
			case 121: /* 'y' year */
			switch(fmt.length) {
				case 1: case 2: out = y % 100; outl = 2; break;
				default: out = y % 10000; outl = 4; break;
			} break;
			case 109: /* 'm' month */
			switch(fmt.length) {
				case 1: case 2: out = val.m; outl = fmt.length; break;
				case 3: return months[val.m-1][1];
				case 5: return months[val.m-1][0];
				default: return months[val.m-1][2];
			} break;
			case 100: /* 'd' day */
			switch(fmt.length) {
				case 1: case 2: out = val.d; outl = fmt.length; break;
				case 3: return days[val.q][0];
				default: return days[val.q][1];
			} break;
			case 104: /* 'h' 12-hour */
			switch(fmt.length) {
				case 1: case 2: out = 1+(val.H+11)%12; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 72: /* 'H' 24-hour */
			switch(fmt.length) {
				case 1: case 2: out = val.H; outl = fmt.length; break;
				default: throw 'bad hour format: ' + fmt;
			} break;
			case 77: /* 'M' minutes */
			switch(fmt.length) {
				case 1: case 2: out = val.M; outl = fmt.length; break;
				default: throw 'bad minute format: ' + fmt;
			} break;
			case 115: /* 's' seconds */
				if(fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
				if(val.u === 0 && (fmt == "s" || fmt == "ss")) return pad0(val.S, fmt.length);
	if(ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
				else tt = ss0 === 1 ? 10 : 1;
				ss = Math.round((tt)*(val.S + val.u));
				if(ss >= 60*tt) ss = 0;
				if(fmt === 's') return ss === 0 ? "0" : ""+ss/tt;
				o = pad0(ss,2 + ss0);
				if(fmt === 'ss') return o.substr(0,2);
				return "." + o.substr(2,fmt.length-1);
			case 90: /* 'Z' absolute time */
			switch(fmt) {
				case '[h]': case '[hh]': out = val.D*24+val.H; break;
				case '[m]': case '[mm]': out = (val.D*24+val.H)*60+val.M; break;
				case '[s]': case '[ss]': out = ((val.D*24+val.H)*60+val.M)*60+Math.round(val.S+val.u); break;
				default: throw 'bad abstime format: ' + fmt;
			} outl = fmt.length === 3 ? 1 : 2; break;
			case 101: /* 'e' era */
				out = y; outl = 1; break;
		}
		var outstr = outl > 0 ? pad0(out, outl) : "";
		return outstr;
	}
	/*jshint +W086 */
	function commaify(s) {
		var w = 3;
		if(s.length <= w) return s;
		var j = (s.length % w), o = s.substr(0,j);
		for(; j!=s.length; j+=w) o+=(o.length > 0 ? "," : "") + s.substr(j,w);
		return o;
	}
	var write_num = (function make_write_num(){
	var pct1 = /%/g;
	function write_num_pct(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_cm(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_exp(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(o.indexOf("e") === -1) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				while(o.substr(0,2) === "0.") {
					o = o.charAt(0) + o.substr(2,period) + "." + o.substr(2+period);
					o = o.replace(/^0+([1-9])/,"$1").replace(/^0+\./,"0.");
				}
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	var frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
	function write_num_f1(r, aval, sign) {
		var den = parseInt(r[4],10), rr = Math.round(aval * den), base = Math.floor(rr/den);
		var myn = (rr - base*den), myd = den;
		return sign + (base === 0 ? "" : ""+base) + " " + (myn === 0 ? fill(" ", r[1].length + 1 + r[4].length) : pad_(myn,r[1].length) + r[2] + "/" + r[3] + pad0(myd,r[4].length));
	}
	function write_num_f2(r, aval, sign) {
		return sign + (aval === 0 ? "" : ""+aval) + fill(" ", r[1].length + 2 + r[4].length);
	}
	var dec1 = /^#*0*\.([0#]+)/;
	var closeparen = /\).*[0#]/;
	var phone = /\(###\) ###\\?-####/;
	function hashq(str) {
		var o = "", cc;
		for(var i = 0; i != str.length; ++i) switch((cc=str.charCodeAt(i))) {
			case 35: break;
			case 63: o+= " "; break;
			case 48: o+= "0"; break;
			default: o+= String.fromCharCode(cc);
		}
		return o;
	}
	function rnd(val, d) { var dd = Math.pow(10,d); return ""+(Math.round(val * dd)/dd); }
	function dec(val, d) {
		var _frac = val - Math.floor(val), dd = Math.pow(10,d);
		if (d < ('' + Math.round(_frac * dd)).length) return 0;
		return Math.round(_frac * dd);
	}
	function carry(val, d) {
		if (d < ('' + Math.round((val-Math.floor(val))*Math.pow(10,d))).length) {
			return 1;
		}
		return 0;
	}
	function flr(val) {
		if(val < 2147483647 && val > -2147483648) return ""+(val >= 0 ? (val|0) : (val-1|0));
		return ""+Math.floor(val);
	}
	function write_num_flt(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_flt('n', ffmt, val);
			return '(' + write_num_flt('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_flt(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0r(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = pad0r(val,0); if(o === "0") o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f1(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0r(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
			o = rnd(val, r[1].length).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1])).replace(/\.(\d*)$/,function($$, $1) { return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify(pad0r(aval,0));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(""+(Math.floor(val) + carry(val, r[1].length))) + "." + pad0(dec(val, r[1].length),r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_flt(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_flt(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_flt(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = pad0r(val, 0);
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0?]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			ri = dec(val, r[1].length);
			return val < 0 ? "-" + write_num_flt(type, fmt, -val) : commaify(flr(val)).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(ri,r[1].length);
		}
		switch(fmt) {
			case "###,##0.00": return write_num_flt(type, "#,##0.00", val);
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(pad0r(aval,0)); return x !== "0" ? sign + x : "";
			case "###,###.00": return write_num_flt(type, "###,##0.00",val).replace(/^0\./,".");
			case "#,###.00": return write_num_flt(type, "#,##0.00",val).replace(/^0\./,".");
			default:
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	function write_num_cm2(type, fmt, val){
		var idx = fmt.length - 1;
		while(fmt.charCodeAt(idx-1) === 44) --idx;
		return write_num(type, fmt.substr(0,idx), val / Math.pow(10,3*(fmt.length-idx)));
	}
	function write_num_pct2(type, fmt, val){
		var sfmt = fmt.replace(pct1,""), mul = fmt.length - sfmt.length;
		return write_num(type, sfmt, val * Math.pow(10,2*mul)) + fill("%",mul);
	}
	function write_num_exp2(fmt, val){
		var o;
		var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
		if(fmt.match(/^#+0.0E\+0$/)) {
			if(val == 0) return "0.0E+0";
			else if(val < 0) return "-" + write_num_exp2(fmt, -val);
			var period = fmt.indexOf("."); if(period === -1) period=fmt.indexOf('E');
			var ee = Math.floor(Math.log(val)*Math.LOG10E)%period;
			if(ee < 0) ee += period;
			o = (val/Math.pow(10,ee)).toPrecision(idx+1+(period+ee)%period);
			if(!o.match(/[Ee]/)) {
				var fakee = Math.floor(Math.log(val)*Math.LOG10E);
				if(o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length+ee);
				else o += "E+" + (fakee - ee);
				o = o.replace(/\+-/,"-");
			}
			o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/,function($$,$1,$2,$3) { return $1 + $2 + $3.substr(0,(period+ee)%period) + "." + $3.substr(ee) + "E"; });
		} else o = val.toExponential(idx);
		if(fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0,o.length-1) + "0" + o.charAt(o.length-1);
		if(fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/,"e");
		return o.replace("e","E");
	}
	function write_num_int(type, fmt, val) {
		if(type.charCodeAt(0) === 40 && !fmt.match(closeparen)) {
			var ffmt = fmt.replace(/\( */,"").replace(/ \)/,"").replace(/\)/,"");
			if(val >= 0) return write_num_int('n', ffmt, val);
			return '(' + write_num_int('n', ffmt, -val) + ')';
		}
		if(fmt.charCodeAt(fmt.length - 1) === 44) return write_num_cm2(type, fmt, val);
		if(fmt.indexOf('%') !== -1) return write_num_pct2(type, fmt, val);
		if(fmt.indexOf('E') !== -1) return write_num_exp2(fmt, val);
		if(fmt.charCodeAt(0) === 36) return "$"+write_num_int(type,fmt.substr(fmt.charAt(1)==' '?2:1),val);
		var o;
		var r, ri, ff, aval = Math.abs(val), sign = val < 0 ? "-" : "";
		if(fmt.match(/^00+$/)) return sign + pad0(aval,fmt.length);
		if(fmt.match(/^[#?]+$/)) {
			o = (""+val); if(val === 0) o = "";
			return o.length > fmt.length ? o : hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(frac1))) return write_num_f2(r, aval, sign);
		if(fmt.match(/^#+0+$/)) return sign + pad0(aval,fmt.length - fmt.indexOf("0"));
		if((r = fmt.match(dec1))) {
	o = (""+val).replace(/^([^\.]+)$/,"$1."+hashq(r[1])).replace(/\.$/,"."+hashq(r[1]));
			o = o.replace(/\.(\d*)$/,function($$, $1) {
	return "." + $1 + fill("0", hashq(r[1]).length-$1.length); });
			return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./,".");
		}
		fmt = fmt.replace(/^#+([0.])/, "$1");
		if((r = fmt.match(/^(0*)\.(#*)$/))) {
			return sign + (""+aval).replace(/\.(\d*[1-9])0*$/,".$1").replace(/^(-?\d*)$/,"$1.").replace(/^0\./,r[1].length?"0.":".");
		}
		if((r = fmt.match(/^#{1,3},##0(\.?)$/))) return sign + commaify((""+aval));
		if((r = fmt.match(/^#,##0\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify((""+val)) + "." + fill('0',r[1].length);
		}
		if((r = fmt.match(/^#,#*,#0/))) return write_num_int(type,fmt.replace(/^#,#*,/,""),val);
		if((r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/))) {
			o = _strrev(write_num_int(type, fmt.replace(/[\\-]/g,""), val));
			ri = 0;
			return _strrev(_strrev(fmt.replace(/\\/g,"")).replace(/[0#]/g,function(x){return ri<o.length?o.charAt(ri++):x==='0'?'0':"";}));
		}
		if(fmt.match(phone)) {
			o = write_num_int(type, "##########", val);
			return "(" + o.substr(0,3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
		}
		var oa = "";
		if((r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(r[4].length,7);
			ff = frac(aval, Math.pow(10,ri)-1, false);
			o = "" + sign;
			oa = write_num("n", r[1], ff[1]);
			if(oa.charAt(oa.length-1) == " ") oa = oa.substr(0,oa.length-1) + "0";
			o += oa + r[2] + "/" + r[3];
			oa = rpad_(ff[2],ri);
			if(oa.length < r[4].length) oa = hashq(r[4].substr(r[4].length-oa.length)) + oa;
			o += oa;
			return o;
		}
		if((r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/))) {
			ri = Math.min(Math.max(r[1].length, r[4].length),7);
			ff = frac(aval, Math.pow(10,ri)-1, true);
			return sign + (ff[0]||(ff[1] ? "" : "0")) + " " + (ff[1] ? pad_(ff[1],ri) + r[2] + "/" + r[3] + rpad_(ff[2],ri): fill(" ", 2*ri+1 + r[2].length + r[3].length));
		}
		if((r = fmt.match(/^[#0?]+$/))) {
			o = "" + val;
			if(fmt.length <= o.length) return o;
			return hashq(fmt.substr(0,fmt.length-o.length)) + o;
		}
		if((r = fmt.match(/^([#0]+)\.([#0]+)$/))) {
			o = "" + val.toFixed(Math.min(r[2].length,10)).replace(/([^0])0+$/,"$1");
			ri = o.indexOf(".");
			var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
			return hashq(fmt.substr(0,lres) + o + fmt.substr(fmt.length-rres));
		}
		if((r = fmt.match(/^00,000\.([#0]*0)$/))) {
			return val < 0 ? "-" + write_num_int(type, fmt, -val) : commaify(""+val).replace(/^\d,\d{3}$/,"0$&").replace(/^\d*$/,function($$) { return "00," + ($$.length < 3 ? pad0(0,3-$$.length) : "") + $$; }) + "." + pad0(0,r[1].length);
		}
		switch(fmt) {
			case "###,###":
			case "##,###":
			case "#,###": var x = commaify(""+aval); return x !== "0" ? sign + x : "";
			default:
				if(fmt.match(/\.[0#?]*$/)) return write_num_int(type, fmt.slice(0,fmt.lastIndexOf(".")), val) + hashq(fmt.slice(fmt.lastIndexOf(".")));
		}
		throw new Error("unsupported format |" + fmt + "|");
	}
	return function write_num(type, fmt, val) {
		return (val|0) === val ? write_num_int(type, fmt, val) : write_num_flt(type, fmt, val);
	};})();
	function split_fmt(fmt) {
		var out = [];
		var in_str = false/*, cc*/;
		for(var i = 0, j = 0; i < fmt.length; ++i) switch((/*cc=*/fmt.charCodeAt(i))) {
			case 34: /* '"' */
				in_str = !in_str; break;
			case 95: case 42: case 92: /* '_' '*' '\\' */
				++i; break;
			case 59: /* ';' */
				out[out.length] = fmt.substr(j,i-j);
				j = i+1;
		}
		out[out.length] = fmt.substr(j);
		if(in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
		return out;
	}
	SSF._split = split_fmt;
	var abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
	function fmt_is_date(fmt) {
		var i = 0, /*cc = 0,*/ c = "", o = "";
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': if(isgeneral(fmt, i)) i+= 6; i++; break;
				case '"': for(;(/*cc=*/fmt.charCodeAt(++i)) !== 34 && i < fmt.length;){/*empty*/} ++i; break;
				case '\\': i+=2; break;
				case '_': i+=2; break;
				case '@': ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") return true;
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g': return true;
				case 'A': case 'a': case '上':
					if(fmt.substr(i, 3).toUpperCase() === "A/P") return true;
					if(fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
					if(fmt.substr(i, 5).toUpperCase() === "上午/下午") return true;
					++i; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.match(abstime)) return true;
					break;
				case '.':
					/* falls through */
				case '0': case '#':
					while(i < fmt.length && ("0#?.,E+-%".indexOf(c=fmt.charAt(++i)) > -1 || (c=='\\' && fmt.charAt(i+1) == "-" && "0#".indexOf(fmt.charAt(i+2))>-1))){/* empty */}
					break;
				case '?': while(fmt.charAt(++i) === c){/* empty */} break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break;
				case '(': case ')': ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1){/* empty */} break;
				case ' ': ++i; break;
				default: ++i; break;
			}
		}
		return false;
	}
	SSF.is_date = fmt_is_date;
	function eval_fmt(fmt, v, opts, flen) {
		var out = [], o = "", i = 0, c = "", lst='t', dt, j, cc;
		var hr='H';
		/* Tokenize */
		while(i < fmt.length) {
			switch((c = fmt.charAt(i))) {
				case 'G': /* General */
					if(!isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' +fmt);
					out[out.length] = {t:'G', v:'General'}; i+=7; break;
				case '"': /* Literal text */
					for(o="";(cc=fmt.charCodeAt(++i)) !== 34 && i < fmt.length;) o += String.fromCharCode(cc);
					out[out.length] = {t:'t', v:o}; ++i; break;
				case '\\': var w = fmt.charAt(++i), t = (w === "(" || w === ")") ? w : 't';
					out[out.length] = {t:t, v:w}; ++i; break;
				case '_': out[out.length] = {t:'t', v:" "}; i+=2; break;
				case '@': /* Text Placeholder */
					out[out.length] = {t:'T', v:v}; ++i; break;
				case 'B': case 'b':
					if(fmt.charAt(i+1) === "1" || fmt.charAt(i+1) === "2") {
						if(dt==null) { dt=parse_date_code(v, opts, fmt.charAt(i+1) === "2"); if(dt==null) return ""; }
						out[out.length] = {t:'X', v:fmt.substr(i,2)}; lst = c; i+=2; break;
					}
					/* falls through */
				case 'M': case 'D': case 'Y': case 'H': case 'S': case 'E':
					c = c.toLowerCase();
					/* falls through */
				case 'm': case 'd': case 'y': case 'h': case 's': case 'e': case 'g':
					if(v < 0) return "";
					if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
					o = c; while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c) o+=c;
					if(c === 'm' && lst.toLowerCase() === 'h') c = 'M';
					if(c === 'h') c = hr;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case 'A': case 'a': case '上':
					var q={t:c, v:c};
					if(dt==null) dt=parse_date_code(v, opts);
					if(fmt.substr(i, 3).toUpperCase() === "A/P") { if(dt!=null) q.v = dt.H >= 12 ? "P" : "A"; q.t = 'T'; hr='h';i+=3;}
					else if(fmt.substr(i,5).toUpperCase() === "AM/PM") { if(dt!=null) q.v = dt.H >= 12 ? "PM" : "AM"; q.t = 'T'; i+=5; hr='h'; }
					else if(fmt.substr(i,5).toUpperCase() === "上午/下午") { if(dt!=null) q.v = dt.H >= 12 ? "下午" : "上午"; q.t = 'T'; i+=5; hr='h'; }
					else { q.t = "t"; ++i; }
					if(dt==null && q.t === 'T') return "";
					out[out.length] = q; lst = c; break;
				case '[':
					o = c;
					while(fmt.charAt(i++) !== ']' && i < fmt.length) o += fmt.charAt(i);
					if(o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
					if(o.match(abstime)) {
						if(dt==null) { dt=parse_date_code(v, opts); if(dt==null) return ""; }
						out[out.length] = {t:'Z', v:o.toLowerCase()};
						lst = o.charAt(1);
					} else if(o.indexOf("$") > -1) {
						o = (o.match(/\$([^-\[\]]*)/)||[])[1]||"$";
						if(!fmt_is_date(fmt)) out[out.length] = {t:'t',v:o};
					}
					break;
				/* Numbers */
				case '.':
					if(dt != null) {
						o = c; while(++i < fmt.length && (c=fmt.charAt(i)) === "0") o += c;
						out[out.length] = {t:'s', v:o}; break;
					}
					/* falls through */
				case '0': case '#':
					o = c; while(++i < fmt.length && "0#?.,E+-%".indexOf(c=fmt.charAt(i)) > -1) o += c;
					out[out.length] = {t:'n', v:o}; break;
				case '?':
					o = c; while(fmt.charAt(++i) === c) o+=c;
					out[out.length] = {t:c, v:o}; lst = c; break;
				case '*': ++i; if(fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i; break; // **
				case '(': case ')': out[out.length] = {t:(flen===1?'t':c), v:c}; ++i; break;
				case '1': case '2': case '3': case '4': case '5': case '6': case '7': case '8': case '9':
					o = c; while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1) o+=fmt.charAt(i);
					out[out.length] = {t:'D', v:o}; break;
				case ' ': out[out.length] = {t:c, v:c}; ++i; break;
				case '$': out[out.length] = {t:'t', v:'$'}; ++i; break;
				default:
					if(",$-+/():!^&'~{}<>=€acfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
					out[out.length] = {t:'t', v:c}; ++i; break;
			}
		}
	
		/* Scan for date/time parts */
		var bt = 0, ss0 = 0, ssm;
		for(i=out.length-1, lst='t'; i >= 0; --i) {
			switch(out[i].t) {
				case 'h': case 'H': out[i].t = hr; lst='h'; if(bt < 1) bt = 1; break;
				case 's':
					if((ssm=out[i].v.match(/\.0+$/))) ss0=Math.max(ss0,ssm[0].length-1);
					if(bt < 3) bt = 3;
				/* falls through */
				case 'd': case 'y': case 'M': case 'e': lst=out[i].t; break;
				case 'm': if(lst === 's') { out[i].t = 'M'; if(bt < 2) bt = 2; } break;
				case 'X': /*if(out[i].v === "B2");*/
					break;
				case 'Z':
					if(bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
					if(bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
					if(bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
			}
		}
		/* time rounding depends on presence of minute / second / usec fields */
		switch(bt) {
			case 0: break;
			case 1:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				if(dt.M >=  60) { dt.M = 0; ++dt.H; }
				break;
			case 2:
	if(dt.u >= 0.5) { dt.u = 0; ++dt.S; }
				if(dt.S >=  60) { dt.S = 0; ++dt.M; }
				break;
		}
	
		/* replace fields */
		var nstr = "", jj;
		for(i=0; i < out.length; ++i) {
			switch(out[i].t) {
				case 't': case 'T': case ' ': case 'D': break;
				case 'X': out[i].v = ""; out[i].t = ";"; break;
				case 'd': case 'm': case 'y': case 'h': case 'H': case 'M': case 's': case 'e': case 'b': case 'Z':
	out[i].v = write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
					out[i].t = 't'; break;
				case 'n': case '?':
					jj = i+1;
					while(out[jj] != null && (
						(c=out[jj].t) === "?" || c === "D" ||
						((c === " " || c === "t") && out[jj+1] != null && (out[jj+1].t === '?' || out[jj+1].t === "t" && out[jj+1].v === '/')) ||
						(out[i].t === '(' && (c === ' ' || c === 'n' || c === ')')) ||
						(c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj+1] != null && out[jj+1].t == '?'))
					)) {
						out[i].v += out[jj].v;
						out[jj] = {v:"", t:";"}; ++jj;
					}
					nstr += out[i].v;
					i = jj-1; break;
				case 'G': out[i].t = 't'; out[i].v = general_fmt(v,opts); break;
			}
		}
		var vv = "", myv, ostr;
		if(nstr.length > 0) {
			if(nstr.charCodeAt(0) == 40) /* '(' */ {
				myv = (v<0&&nstr.charCodeAt(0) === 45 ? -v : v);
				ostr = write_num('n', nstr, myv);
			} else {
				myv = (v<0 && flen > 1 ? -v : v);
				ostr = write_num('n', nstr, myv);
				if(myv < 0 && out[0] && out[0].t == 't') {
					ostr = ostr.substr(1);
					out[0].v = "-" + out[0].v;
				}
			}
			jj=ostr.length-1;
			var decpt = out.length;
			for(i=0; i < out.length; ++i) if(out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) { decpt = i; break; }
			var lasti=out.length;
			if(decpt === out.length && ostr.indexOf("E") === -1) {
				for(i=out.length-1; i>= 0;--i) {
					if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
					if(jj>=out[i].v.length-1) { jj -= out[i].v.length; out[i].v = ostr.substr(jj+1, out[i].v.length); }
					else if(jj < 0) out[i].v = "";
					else { out[i].v = ostr.substr(0, jj+1); jj = -1; }
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
			}
			else if(decpt !== out.length && ostr.indexOf("E") === -1) {
				jj = ostr.indexOf(".")-1;
				for(i=decpt; i>= 0; --i) {
					if(out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")-1:out[i].v.length-1;
					vv = out[i].v.substr(j+1);
					for(; j>=0; --j) {
						if(jj>=0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
				if(jj>=0 && lasti<out.length) out[lasti].v = ostr.substr(0,jj+1) + out[lasti].v;
				jj = ostr.indexOf(".")+1;
				for(i=decpt; i<out.length; ++i) {
					if(out[i] == null || ('n?('.indexOf(out[i].t) === -1 && i !== decpt)) continue;
					j=out[i].v.indexOf(".")>-1&&i===decpt?out[i].v.indexOf(".")+1:0;
					vv = out[i].v.substr(0,j);
					for(; j<out[i].v.length; ++j) {
						if(jj<ostr.length) vv += ostr.charAt(jj++);
					}
					out[i].v = vv;
					out[i].t = 't';
					lasti = i;
				}
			}
		}
		for(i=0; i<out.length; ++i) if(out[i] != null && 'n?'.indexOf(out[i].t)>-1) {
			myv = (flen >1 && v < 0 && i>0 && out[i-1].v === "-" ? -v:v);
			out[i].v = write_num(out[i].t, out[i].v, myv);
			out[i].t = 't';
		}
		var retval = "";
		for(i=0; i !== out.length; ++i) if(out[i] != null) retval += out[i].v;
		return retval;
	}
	SSF._eval = eval_fmt;
	var cfregex = /\[[=<>]/;
	var cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
	function chkcond(v, rr) {
		if(rr == null) return false;
		var thresh = parseFloat(rr[2]);
		switch(rr[1]) {
			case "=":  if(v == thresh) return true; break;
			case ">":  if(v >  thresh) return true; break;
			case "<":  if(v <  thresh) return true; break;
			case "<>": if(v != thresh) return true; break;
			case ">=": if(v >= thresh) return true; break;
			case "<=": if(v <= thresh) return true; break;
		}
		return false;
	}
	function choose_fmt(f, v) {
		var fmt = split_fmt(f);
		var l = fmt.length, lat = fmt[l-1].indexOf("@");
		if(l<4 && lat>-1) --l;
		if(fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
		if(typeof v !== "number") return [4, fmt.length === 4 || lat>-1?fmt[fmt.length-1]:"@"];
		switch(fmt.length) {
			case 1: fmt = lat>-1 ? ["General", "General", "General", fmt[0]] : [fmt[0], fmt[0], fmt[0], "@"]; break;
			case 2: fmt = lat>-1 ? [fmt[0], fmt[0], fmt[0], fmt[1]] : [fmt[0], fmt[1], fmt[0], "@"]; break;
			case 3: fmt = lat>-1 ? [fmt[0], fmt[1], fmt[0], fmt[2]] : [fmt[0], fmt[1], fmt[2], "@"]; break;
			case 4: break;
		}
		var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
		if(fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [l, ff];
		if(fmt[0].match(cfregex) != null || fmt[1].match(cfregex) != null) {
			var m1 = fmt[0].match(cfregex2);
			var m2 = fmt[1].match(cfregex2);
			return chkcond(v, m1) ? [l, fmt[0]] : chkcond(v, m2) ? [l, fmt[1]] : [l, fmt[m1 != null && m2 != null ? 2 : 1]];
		}
		return [l, ff];
	}
	function format(fmt,v,o) {
		if(o == null) o = {};
		var sfmt = "";
		switch(typeof fmt) {
			case "string":
				if(fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
				else sfmt = fmt;
				break;
			case "number":
				if(fmt == 14 && o.dateNF) sfmt = o.dateNF;
				else sfmt = (o.table != null ? (o.table) : table_fmt)[fmt];
				if(sfmt == null) sfmt = (o.table && o.table[default_map[fmt]]) || table_fmt[default_map[fmt]];
				if(sfmt == null) sfmt = default_str[fmt] || "General";
				break;
		}
		if(isgeneral(sfmt,0)) return general_fmt(v, o);
		if(v instanceof Date) v = datenum_local(v, o.date1904);
		var f = choose_fmt(sfmt, v);
		if(isgeneral(f[1])) return general_fmt(v, o);
		if(v === true) v = "TRUE"; else if(v === false) v = "FALSE";
		else if(v === "" || v == null) return "";
		return eval_fmt(f[1], v, o, f[0]);
	}
	function load_entry(fmt, idx) {
		if(typeof idx != 'number') {
			idx = +idx || -1;
	for(var i = 0; i < 0x0188; ++i) {
	if(table_fmt[i] == undefined) { if(idx < 0) idx = i; continue; }
				if(table_fmt[i] == fmt) { idx = i; break; }
			}
	if(idx < 0) idx = 0x187;
		}
	table_fmt[idx] = fmt;
		return idx;
	}
	SSF.load = load_entry;
	SSF._table = table_fmt;
	SSF.get_table = function get_table() { return table_fmt; };
	SSF.load_table = function load_table(tbl) {
		for(var i=0; i!=0x0188; ++i)
			if(tbl[i] !== undefined) load_entry(tbl[i], i);
	};
	SSF.init_table = init_table;
	SSF.format = format;
	};
	make_ssf(SSF);
	/* map from xlml named formats to SSF TODO: localize */
	var XLMLFormatMap/*{[string]:string}*/ = ({
		"General Number": "General",
		"General Date": SSF._table[22],
		"Long Date": "dddd, mmmm dd, yyyy",
		"Medium Date": SSF._table[15],
		"Short Date": SSF._table[14],
		"Long Time": SSF._table[19],
		"Medium Time": SSF._table[18],
		"Short Time": SSF._table[20],
		"Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"Fixed": SSF._table[2],
		"Standard": SSF._table[4],
		"Percent": SSF._table[10],
		"Scientific": SSF._table[11],
		"Yes/No": '"Yes";"Yes";"No";@',
		"True/False": '"True";"True";"False";@',
		"On/Off": '"Yes";"Yes";"No";@'
	});
	
	var SSFImplicit/*{[number]:string}*/ = ({
		"5": '"$"#,##0_);\\("$"#,##0\\)',
		"6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
		"7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
		"8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"23": 'General', "24": 'General', "25": 'General', "26": 'General',
		"27": 'm/d/yy', "28": 'm/d/yy', "29": 'm/d/yy', "30": 'm/d/yy', "31": 'm/d/yy',
		"32": 'h:mm:ss', "33": 'h:mm:ss', "34": 'h:mm:ss', "35": 'h:mm:ss',
		"36": 'm/d/yy',
		"41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
		"42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
		"43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
		"44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
		"50": 'm/d/yy', "51": 'm/d/yy', "52": 'm/d/yy', "53": 'm/d/yy', "54": 'm/d/yy',
		"55": 'm/d/yy', "56": 'm/d/yy', "57": 'm/d/yy', "58": 'm/d/yy',
		"59": '0',
		"60": '0.00',
		"61": '#,##0',
		"62": '#,##0.00',
		"63": '"$"#,##0_);\\("$"#,##0\\)',
		"64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
		"65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
		"66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
		"67": '0%',
		"68": '0.00%',
		"69": '# ?/?',
		"70": '# ??/??',
		"71": 'm/d/yy',
		"72": 'm/d/yy',
		"73": 'd-mmm-yy',
		"74": 'd-mmm',
		"75": 'mmm-yy',
		"76": 'h:mm',
		"77": 'h:mm:ss',
		"78": 'm/d/yy h:mm',
		"79": 'mm:ss',
		"80": '[h]:mm:ss',
		"81": 'mmss.0'
	});
	
	/* dateNF parse TODO: move to SSF */
	var dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
	function dateNF_regex(dateNF) {
		var fmt = typeof dateNF == "number" ? SSF._table[dateNF] : dateNF;
		fmt = fmt.replace(dateNFregex, "(\\d+)");
		return new RegExp("^" + fmt + "$");
	}
	function dateNF_fix(str, dateNF, match) {
		var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
		(dateNF.match(dateNFregex)||[]).forEach(function(n, i) {
			var v = parseInt(match[i+1], 10);
			switch(n.toLowerCase().charAt(0)) {
				case 'y': Y = v; break; case 'd': d = v; break;
				case 'h': H = v; break; case 's': S = v; break;
				case 'm': if(H >= 0) M = v; else m = v; break;
			}
		});
		if(S >= 0 && M == -1 && m >= 0) { M = m; m = -1; }
		var datestr = (("" + (Y>=0?Y: new Date().getFullYear())).slice(-4) + "-" + ("00" + (m>=1?m:1)).slice(-2) + "-" + ("00" + (d>=1?d:1)).slice(-2));
		if(datestr.length == 7) datestr = "0" + datestr;
		if(datestr.length == 8) datestr = "20" + datestr;
		var timestr = (("00" + (H>=0?H:0)).slice(-2) + ":" + ("00" + (M>=0?M:0)).slice(-2) + ":" + ("00" + (S>=0?S:0)).slice(-2));
		if(H == -1 && M == -1 && S == -1) return datestr;
		if(Y == -1 && m == -1 && d == -1) return timestr;
		return datestr + "T" + timestr;
	}
	
	var DO_NOT_EXPORT_CFB = true;
	/* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*jshint eqnull:true */
	/*exported CFB */
	/*global Uint8Array:false, Uint16Array:false */
	
	/* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */
	/* vim: set ts=2: */
	/*exported CRC32 */
	var CRC32;
	(function (factory) {
		/*jshint ignore:start */
		/*eslint-disable */
		factory(CRC32 = {});
		/*eslint-enable */
		/*jshint ignore:end */
	}(function(CRC32) {
	CRC32.version = '1.2.0';
	/* see perf/crc32table.js */
	/*global Int32Array */
	function signed_crc_table() {
		var c = 0, table = new Array(256);
	
		for(var n =0; n != 256; ++n){
			c = n;
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			c = ((c&1) ? (-306674912 ^ (c >>> 1)) : (c >>> 1));
			table[n] = c;
		}
	
		return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
	}
	
	var T = signed_crc_table();
	function crc32_bstr(bstr, seed) {
		var C = seed ^ -1, L = bstr.length - 1;
		for(var i = 0; i < L;) {
			C = (C>>>8) ^ T[(C^bstr.charCodeAt(i++))&0xFF];
			C = (C>>>8) ^ T[(C^bstr.charCodeAt(i++))&0xFF];
		}
		if(i === L) C = (C>>>8) ^ T[(C ^ bstr.charCodeAt(i))&0xFF];
		return C ^ -1;
	}
	
	function crc32_buf(buf, seed) {
		if(buf.length > 10000) return crc32_buf_8(buf, seed);
		var C = seed ^ -1, L = buf.length - 3;
		for(var i = 0; i < L;) {
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		}
		while(i < L+3) C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		return C ^ -1;
	}
	
	function crc32_buf_8(buf, seed) {
		var C = seed ^ -1, L = buf.length - 7;
		for(var i = 0; i < L;) {
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
			C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		}
		while(i < L+7) C = (C>>>8) ^ T[(C^buf[i++])&0xFF];
		return C ^ -1;
	}
	
	function crc32_str(str, seed) {
		var C = seed ^ -1;
		for(var i = 0, L=str.length, c, d; i < L;) {
			c = str.charCodeAt(i++);
			if(c < 0x80) {
				C = (C>>>8) ^ T[(C ^ c)&0xFF];
			} else if(c < 0x800) {
				C = (C>>>8) ^ T[(C ^ (192|((c>>6)&31)))&0xFF];
				C = (C>>>8) ^ T[(C ^ (128|(c&63)))&0xFF];
			} else if(c >= 0xD800 && c < 0xE000) {
				c = (c&1023)+64; d = str.charCodeAt(i++)&1023;
				C = (C>>>8) ^ T[(C ^ (240|((c>>8)&7)))&0xFF];
				C = (C>>>8) ^ T[(C ^ (128|((c>>2)&63)))&0xFF];
				C = (C>>>8) ^ T[(C ^ (128|((d>>6)&15)|((c&3)<<4)))&0xFF];
				C = (C>>>8) ^ T[(C ^ (128|(d&63)))&0xFF];
			} else {
				C = (C>>>8) ^ T[(C ^ (224|((c>>12)&15)))&0xFF];
				C = (C>>>8) ^ T[(C ^ (128|((c>>6)&63)))&0xFF];
				C = (C>>>8) ^ T[(C ^ (128|(c&63)))&0xFF];
			}
		}
		return C ^ -1;
	}
	CRC32.table = T;
	CRC32.bstr = crc32_bstr;
	CRC32.buf = crc32_buf;
	CRC32.str = crc32_str;
	}));
	/* [MS-CFB] v20171201 */
	var CFB = (function _CFB(){
	var exports = {};
	exports.version = '1.1.4';
	/* [MS-CFB] 2.6.4 */
	function namecmp(l, r) {
		var L = l.split("/"), R = r.split("/");
		for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i) {
			if((c = L[i].length - R[i].length)) return c;
			if(L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
		}
		return L.length - R.length;
	}
	function dirname(p) {
		if(p.charAt(p.length - 1) == "/") return (p.slice(0,-1).indexOf("/") === -1) ? p : dirname(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(0, c+1);
	}
	
	function filename(p) {
		if(p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
		var c = p.lastIndexOf("/");
		return (c === -1) ? p : p.slice(c+1);
	}
	/* -------------------------------------------------------------------------- */
	/* DOS Date format:
	   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
	   add 1980 to stored year
	   stored second should be doubled
	*/
	
	/* write JS date to buf as a DOS date */
	function write_dos_date(buf, date) {
		if(typeof date === "string") date = new Date(date);
		var hms = date.getHours();
		hms = hms << 6 | date.getMinutes();
		hms = hms << 5 | (date.getSeconds()>>>1);
		buf.write_shift(2, hms);
		var ymd = (date.getFullYear() - 1980);
		ymd = ymd << 4 | (date.getMonth()+1);
		ymd = ymd << 5 | date.getDate();
		buf.write_shift(2, ymd);
	}
	
	/* read four bytes from buf and interpret as a DOS date */
	function parse_dos_date(buf) {
		var hms = buf.read_shift(2) & 0xFFFF;
		var ymd = buf.read_shift(2) & 0xFFFF;
		var val = new Date();
		var d = ymd & 0x1F; ymd >>>= 5;
		var m = ymd & 0x0F; ymd >>>= 4;
		val.setMilliseconds(0);
		val.setFullYear(ymd + 1980);
		val.setMonth(m-1);
		val.setDate(d);
		var S = hms & 0x1F; hms >>>= 5;
		var M = hms & 0x3F; hms >>>= 6;
		val.setHours(hms);
		val.setMinutes(M);
		val.setSeconds(S<<1);
		return val;
	}
	function parse_extra_field(blob) {
		prep_blob(blob, 0);
		var o = {};
		var flags = 0;
		while(blob.l <= blob.length - 4) {
			var type = blob.read_shift(2);
			var sz = blob.read_shift(2), tgt = blob.l + sz;
			var p = {};
			switch(type) {
				/* UNIX-style Timestamps */
				case 0x5455: {
					flags = blob.read_shift(1);
					if(flags & 1) p.mtime = blob.read_shift(4);
					/* for some reason, CD flag corresponds to LFH */
					if(sz > 5) {
						if(flags & 2) p.atime = blob.read_shift(4);
						if(flags & 4) p.ctime = blob.read_shift(4);
					}
					if(p.mtime) p.mt = new Date(p.mtime*1000);
				}
				break;
			}
			blob.l = tgt;
			o[type] = p;
		}
		return o;
	}
	var fs;
	function get_fs() { return fs || (fs = __webpack_require__(816)); }
	function parse(file, options) {
	if(file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
	if(file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
	var mver = 3;
	var ssz = 512;
	var nmfs = 0; // number of mini FAT sectors
	var difat_sec_cnt = 0;
	var dir_start = 0;
	var minifat_start = 0;
	var difat_start = 0;
	
	var fat_addrs = []; // locations of FAT sectors
	
	/* [MS-CFB] 2.2 Compound File Header */
	var blob = file.slice(0,512);
	prep_blob(blob, 0);
	
	/* major version */
	var mv = check_get_mver(blob);
	mver = mv[0];
	switch(mver) {
		case 3: ssz = 512; break; case 4: ssz = 4096; break;
		case 0: if(mv[1] == 0) return parse_zip(file, options);
		/* falls through */
		default: throw new Error("Major Version: Expected 3 or 4 saw " + mver);
	}
	
	/* reprocess header */
	if(ssz !== 512) { blob = file.slice(0,ssz); prep_blob(blob, 28 /* blob.l */); }
	/* Save header for final object */
	var header = file.slice(0,ssz);
	
	check_shifts(blob, mver);
	
	// Number of Directory Sectors
	var dir_cnt = blob.read_shift(4, 'i');
	if(mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
	
	// Number of FAT Sectors
	blob.l += 4;
	
	// First Directory Sector Location
	dir_start = blob.read_shift(4, 'i');
	
	// Transaction Signature
	blob.l += 4;
	
	// Mini Stream Cutoff Size
	blob.chk('00100000', 'Mini Stream Cutoff Size: ');
	
	// First Mini FAT Sector Location
	minifat_start = blob.read_shift(4, 'i');
	
	// Number of Mini FAT Sectors
	nmfs = blob.read_shift(4, 'i');
	
	// First DIFAT sector location
	difat_start = blob.read_shift(4, 'i');
	
	// Number of DIFAT Sectors
	difat_sec_cnt = blob.read_shift(4, 'i');
	
	// Grab FAT Sector Locations
	for(var q = -1, j = 0; j < 109; ++j) { /* 109 = (512 - blob.l)>>>2; */
		q = blob.read_shift(4, 'i');
		if(q<0) break;
		fat_addrs[j] = q;
	}
	
	/** Break the file up into sectors */
	var sectors = sectorify(file, ssz);
	
	sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
	
	/** Chains */
	var sector_list = make_sector_list(sectors, dir_start, fat_addrs, ssz);
	
	sector_list[dir_start].name = "!Directory";
	if(nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
	sector_list[fat_addrs[0]].name = "!FAT";
	sector_list.fat_addrs = fat_addrs;
	sector_list.ssz = ssz;
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	var files = {}, Paths = [], FileIndex = [], FullPaths = [];
	read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
	
	build_full_paths(FileIndex, FullPaths, Paths);
	Paths.shift();
	
	var o = {
		FileIndex: FileIndex,
		FullPaths: FullPaths
	};
	
	// $FlowIgnore
	if(options && options.raw) o.raw = {header: header, sectors: sectors};
	return o;
	} // parse
	
	/* [MS-CFB] 2.2 Compound File Header -- read up to major version */
	function check_get_mver(blob) {
		if(blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [0, 0];
		// header signature 8
		blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
	
		// clsid 16
		//blob.chk(HEADER_CLSID, 'CLSID: ');
		blob.l += 16;
	
		// minor version 2
		var mver = blob.read_shift(2, 'u');
	
		return [blob.read_shift(2,'u'), mver];
	}
	function check_shifts(blob, mver) {
		var shift = 0x09;
	
		// Byte Order
		//blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
		blob.l += 2;
	
		// Sector Shift
		switch((shift = blob.read_shift(2))) {
			case 0x09: if(mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift); break;
			case 0x0c: if(mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift); break;
			default: throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
		}
	
		// Mini Sector Shift
		blob.chk('0600', 'Mini Sector Shift: ');
	
		// Reserved
		blob.chk('000000000000', 'Reserved: ');
	}
	
	/** Break the file up into sectors */
	function sectorify(file, ssz) {
		var nsectors = Math.ceil(file.length/ssz)-1;
		var sectors = [];
		for(var i=1; i < nsectors; ++i) sectors[i-1] = file.slice(i*ssz,(i+1)*ssz);
		sectors[nsectors-1] = file.slice(nsectors*ssz);
		return sectors;
	}
	
	/* [MS-CFB] 2.6.4 Red-Black Tree */
	function build_full_paths(FI, FP, Paths) {
		var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
		var dad = [], q = [];
	
		for(; i < pl; ++i) { dad[i]=q[i]=i; FP[i]=Paths[i]; }
	
		for(; j < q.length; ++j) {
			i = q[j];
			L = FI[i].L; R = FI[i].R; C = FI[i].C;
			if(dad[i] === i) {
				if(L !== -1 /*NOSTREAM*/ && dad[L] !== L) dad[i] = dad[L];
				if(R !== -1 && dad[R] !== R) dad[i] = dad[R];
			}
			if(C !== -1 /*NOSTREAM*/) dad[C] = i;
			if(L !== -1 && i != dad[i]) { dad[L] = dad[i]; if(q.lastIndexOf(L) < j) q.push(L); }
			if(R !== -1 && i != dad[i]) { dad[R] = dad[i]; if(q.lastIndexOf(R) < j) q.push(R); }
		}
		for(i=1; i < pl; ++i) if(dad[i] === i) {
			if(R !== -1 /*NOSTREAM*/ && dad[R] !== R) dad[i] = dad[R];
			else if(L !== -1 && dad[L] !== L) dad[i] = dad[L];
		}
	
		for(i=1; i < pl; ++i) {
			if(FI[i].type === 0 /* unknown */) continue;
			j = i;
			if(j != dad[j]) do {
				j = dad[j];
				FP[i] = FP[j] + "/" + FP[i];
			} while (j !== 0 && -1 !== dad[j] && j != dad[j]);
			dad[i] = -1;
		}
	
		FP[0] += "/";
		for(i=1; i < pl; ++i) {
			if(FI[i].type !== 2 /* stream */) FP[i] += "/";
		}
	}
	
	function get_mfat_entry(entry, payload, mini) {
		var start = entry.start, size = entry.size;
		//return (payload.slice(start*MSSZ, start*MSSZ + size));
		var o = [];
		var idx = start;
		while(mini && size > 0 && idx >= 0) {
			o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
			size -= MSSZ;
			idx = __readInt32LE(mini, idx * 4);
		}
		if(o.length === 0) return (new_buf(0));
		return (bconcat(o).slice(0, entry.size));
	}
	
	/** Chase down the rest of the DIFAT chain to build a comprehensive list
	    DIFAT chains by storing the next sector number as the last 32 bits */
	function sleuth_fat(idx, cnt, sectors, ssz, fat_addrs) {
		var q = ENDOFCHAIN;
		if(idx === ENDOFCHAIN) {
			if(cnt !== 0) throw new Error("DIFAT chain shorter than expected");
		} else if(idx !== -1 /*FREESECT*/) {
			var sector = sectors[idx], m = (ssz>>>2)-1;
			if(!sector) return;
			for(var i = 0; i < m; ++i) {
				if((q = __readInt32LE(sector,i*4)) === ENDOFCHAIN) break;
				fat_addrs.push(q);
			}
			if(cnt >= 1) sleuth_fat(__readInt32LE(sector,ssz-4),cnt - 1, sectors, ssz, fat_addrs);
		}
	}
	
	/** Follow the linked list of sectors for a given starting point */
	function get_sector_list(sectors, start, fat_addrs, ssz, chkd) {
		var buf = [], buf_chain = [];
		if(!chkd) chkd = [];
		var modulus = ssz - 1, j = 0, jj = 0;
		for(j=start; j>=0;) {
			chkd[j] = true;
			buf[buf.length] = j;
			buf_chain.push(sectors[j]);
			var addr = fat_addrs[Math.floor(j*4/ssz)];
			jj = ((j*4) & modulus);
			if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
			if(!sectors[addr]) break;
			j = __readInt32LE(sectors[addr], jj);
		}
		return {nodes: buf, data:__toBuffer([buf_chain])};
	}
	
	/** Chase down the sector linked lists */
	function make_sector_list(sectors, dir_start, fat_addrs, ssz) {
		var sl = sectors.length, sector_list = ([]);
		var chkd = [], buf = [], buf_chain = [];
		var modulus = ssz - 1, i=0, j=0, k=0, jj=0;
		for(i=0; i < sl; ++i) {
			buf = ([]);
			k = (i + dir_start); if(k >= sl) k-=sl;
			if(chkd[k]) continue;
			buf_chain = [];
			var seen = [];
			for(j=k; j>=0;) {
				seen[j] = true;
				chkd[j] = true;
				buf[buf.length] = j;
				buf_chain.push(sectors[j]);
				var addr = fat_addrs[Math.floor(j*4/ssz)];
				jj = ((j*4) & modulus);
				if(ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 "+ssz);
				if(!sectors[addr]) break;
				j = __readInt32LE(sectors[addr], jj);
				if(seen[j]) break;
			}
			sector_list[k] = ({nodes: buf, data:__toBuffer([buf_chain])});
		}
		return sector_list;
	}
	
	/* [MS-CFB] 2.6.1 Compound File Directory Entry */
	function read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, mini) {
		var minifat_store = 0, pl = (Paths.length?2:0);
		var sector = sector_list[dir_start].data;
		var i = 0, namelen = 0, name;
		for(; i < sector.length; i+= 128) {
			var blob = sector.slice(i, i+128);
			prep_blob(blob, 64);
			namelen = blob.read_shift(2);
			name = __utf16le(blob,0,namelen-pl);
			Paths.push(name);
			var o = ({
				name:  name,
				type:  blob.read_shift(1),
				color: blob.read_shift(1),
				L:     blob.read_shift(4, 'i'),
				R:     blob.read_shift(4, 'i'),
				C:     blob.read_shift(4, 'i'),
				clsid: blob.read_shift(16),
				state: blob.read_shift(4, 'i'),
				start: 0,
				size: 0
			});
			var ctime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(ctime !== 0) o.ct = read_date(blob, blob.l-8);
			var mtime = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
			if(mtime !== 0) o.mt = read_date(blob, blob.l-8);
			o.start = blob.read_shift(4, 'i');
			o.size = blob.read_shift(4, 'i');
			if(o.size < 0 && o.start < 0) { o.size = o.type = 0; o.start = ENDOFCHAIN; o.name = ""; }
			if(o.type === 5) { /* root */
				minifat_store = o.start;
				if(nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
				/*minifat_size = o.size;*/
			} else if(o.size >= 4096 /* MSCSZ */) {
				o.storage = 'fat';
				if(sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
				sector_list[o.start].name = o.name;
				o.content = (sector_list[o.start].data.slice(0,o.size));
			} else {
				o.storage = 'minifat';
				if(o.size < 0) o.size = 0;
				else if(minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) {
					o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini]||{}).data);
				}
			}
			if(o.content) prep_blob(o.content, 0);
			files[name] = o;
			FileIndex.push(o);
		}
	}
	
	function read_date(blob, offset) {
		return new Date(( ( (__readUInt32LE(blob,offset+4)/1e7)*Math.pow(2,32)+__readUInt32LE(blob,offset)/1e7 ) - 11644473600)*1000);
	}
	
	function read_file(filename, options) {
		get_fs();
		return parse(fs.readFileSync(filename), options);
	}
	
	function read(blob, options) {
		switch(options && options.type || "base64") {
			case "file": return read_file(blob, options);
			case "base64": return parse(s2a(Base64.decode(blob)), options);
			case "binary": return parse(s2a(blob), options);
		}
		return parse(blob, options);
	}
	
	function init_cfb(cfb, opts) {
		var o = opts || {}, root = o.root || "Root Entry";
		if(!cfb.FullPaths) cfb.FullPaths = [];
		if(!cfb.FileIndex) cfb.FileIndex = [];
		if(cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
		if(cfb.FullPaths.length === 0) {
			cfb.FullPaths[0] = root + "/";
			cfb.FileIndex[0] = ({ name: root, type: 5 });
		}
		if(o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
		seed_cfb(cfb);
	}
	function seed_cfb(cfb) {
		var nm = "\u0001Sh33tJ5";
		if(CFB.find(cfb, "/" + nm)) return;
		var p = new_buf(4); p[0] = 55; p[1] = p[3] = 50; p[2] = 54;
		cfb.FileIndex.push(({ name: nm, type: 2, content:p, size:4, L:69, R:69, C:69 }));
		cfb.FullPaths.push(cfb.FullPaths[0] + nm);
		rebuild_cfb(cfb);
	}
	function rebuild_cfb(cfb, f) {
		init_cfb(cfb);
		var gc = false, s = false;
		for(var i = cfb.FullPaths.length - 1; i >= 0; --i) {
			var _file = cfb.FileIndex[i];
			switch(_file.type) {
				case 0:
					if(s) gc = true;
					else { cfb.FileIndex.pop(); cfb.FullPaths.pop(); }
					break;
				case 1: case 2: case 5:
					s = true;
					if(isNaN(_file.R * _file.L * _file.C)) gc = true;
					if(_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
					break;
				default: gc = true; break;
			}
		}
		if(!gc && !f) return;
	
		var now = new Date(1987, 1, 19), j = 0;
		var data = [];
		for(i = 0; i < cfb.FullPaths.length; ++i) {
			if(cfb.FileIndex[i].type === 0) continue;
			data.push([cfb.FullPaths[i], cfb.FileIndex[i]]);
		}
		for(i = 0; i < data.length; ++i) {
			var dad = dirname(data[i][0]);
			s = false;
			for(j = 0; j < data.length; ++j) if(data[j][0] === dad) s = true;
			if(!s) data.push([dad, ({
				name: filename(dad).replace("/",""),
				type: 1,
				clsid: HEADER_CLSID,
				ct: now, mt: now,
				content: null
			})]);
		}
	
		data.sort(function(x,y) { return namecmp(x[0], y[0]); });
		cfb.FullPaths = []; cfb.FileIndex = [];
		for(i = 0; i < data.length; ++i) { cfb.FullPaths[i] = data[i][0]; cfb.FileIndex[i] = data[i][1]; }
		for(i = 0; i < data.length; ++i) {
			var elt = cfb.FileIndex[i];
			var nm = cfb.FullPaths[i];
	
			elt.name =  filename(nm).replace("/","");
			elt.L = elt.R = elt.C = -(elt.color = 1);
			elt.size = elt.content ? elt.content.length : 0;
			elt.start = 0;
			elt.clsid = (elt.clsid || HEADER_CLSID);
			if(i === 0) {
				elt.C = data.length > 1 ? 1 : -1;
				elt.size = 0;
				elt.type = 5;
			} else if(nm.slice(-1) == "/") {
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==nm) break;
				elt.C = j >= data.length ? -1 : j;
				for(j=i+1;j < data.length; ++j) if(dirname(cfb.FullPaths[j])==dirname(nm)) break;
				elt.R = j >= data.length ? -1 : j;
				elt.type = 1;
			} else {
				if(dirname(cfb.FullPaths[i+1]||"") == dirname(nm)) elt.R = i + 1;
				elt.type = 2;
			}
		}
	
	}
	
	function _write(cfb, options) {
		var _opts = options || {};
		rebuild_cfb(cfb);
		if(_opts.fileType == 'zip') return write_zip(cfb, _opts);
		var L = (function(cfb){
			var mini_size = 0, fat_size = 0;
			for(var i = 0; i < cfb.FileIndex.length; ++i) {
				var file = cfb.FileIndex[i];
				if(!file.content) continue;
	var flen = file.content.length;
				if(flen > 0){
					if(flen < 0x1000) mini_size += (flen + 0x3F) >> 6;
					else fat_size += (flen + 0x01FF) >> 9;
				}
			}
			var dir_cnt = (cfb.FullPaths.length +3) >> 2;
			var mini_cnt = (mini_size + 7) >> 3;
			var mfat_cnt = (mini_size + 0x7F) >> 7;
			var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
			var fat_cnt = (fat_base + 0x7F) >> 7;
			var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			while(((fat_base + fat_cnt + difat_cnt + 0x7F) >> 7) > fat_cnt) difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt-109)/0x7F);
			var L =  [1, difat_cnt, fat_cnt, mfat_cnt, dir_cnt, fat_size, mini_size, 0];
			cfb.FileIndex[0].size = mini_size << 6;
			L[7] = (cfb.FileIndex[0].start=L[0]+L[1]+L[2]+L[3]+L[4]+L[5])+((L[6]+7) >> 3);
			return L;
		})(cfb);
		var o = new_buf(L[7] << 9);
		var i = 0, T = 0;
		{
			for(i = 0; i < 8; ++i) o.write_shift(1, HEADER_SIG[i]);
			for(i = 0; i < 8; ++i) o.write_shift(2, 0);
			o.write_shift(2, 0x003E);
			o.write_shift(2, 0x0003);
			o.write_shift(2, 0xFFFE);
			o.write_shift(2, 0x0009);
			o.write_shift(2, 0x0006);
			for(i = 0; i < 3; ++i) o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, L[2]);
			o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
			o.write_shift(4, 0);
			o.write_shift(4, 1<<12);
			o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1: ENDOFCHAIN);
			o.write_shift(4, L[3]);
			o.write_shift(-4, L[1] ? L[0] - 1: ENDOFCHAIN);
			o.write_shift(4, L[1]);
			for(i = 0; i < 109; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
		}
		if(L[1]) {
			for(T = 0; T < L[1]; ++T) {
				for(; i < 236 + T * 127; ++i) o.write_shift(-4, i < L[2] ? L[1] + i : -1);
				o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
			}
		}
		var chainit = function(w) {
			for(T += w; i<T-1; ++i) o.write_shift(-4, i+1);
			if(w) { ++i; o.write_shift(-4, ENDOFCHAIN); }
		};
		T = i = 0;
		for(T+=L[1]; i<T; ++i) o.write_shift(-4, consts.DIFSECT);
		for(T+=L[2]; i<T; ++i) o.write_shift(-4, consts.FATSECT);
		chainit(L[3]);
		chainit(L[4]);
		var j = 0, flen = 0;
		var file = cfb.FileIndex[0];
		for(; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(flen < 0x1000) continue;
			file.start = T;
			chainit((flen + 0x01FF) >> 9);
		}
		chainit((L[6] + 7) >> 3);
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		T = i = 0;
		for(j = 0; j < cfb.FileIndex.length; ++j) {
			file = cfb.FileIndex[j];
			if(!file.content) continue;
	flen = file.content.length;
			if(!flen || flen >= 0x1000) continue;
			file.start = T;
			chainit((flen + 0x3F) >> 6);
		}
		while(o.l & 0x1FF) o.write_shift(-4, consts.ENDOFCHAIN);
		for(i = 0; i < L[4]<<2; ++i) {
			var nm = cfb.FullPaths[i];
			if(!nm || nm.length === 0) {
				for(j = 0; j < 17; ++j) o.write_shift(4, 0);
				for(j = 0; j < 3; ++j) o.write_shift(4, -1);
				for(j = 0; j < 12; ++j) o.write_shift(4, 0);
				continue;
			}
			file = cfb.FileIndex[i];
			if(i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
			var _nm = (i === 0 && _opts.root) || file.name;
			flen = 2*(_nm.length+1);
			o.write_shift(64, _nm, "utf16le");
			o.write_shift(2, flen);
			o.write_shift(1, file.type);
			o.write_shift(1, file.color);
			o.write_shift(-4, file.L);
			o.write_shift(-4, file.R);
			o.write_shift(-4, file.C);
			if(!file.clsid) for(j = 0; j < 4; ++j) o.write_shift(4, 0);
			else o.write_shift(16, file.clsid, "hex");
			o.write_shift(4, file.state || 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, 0); o.write_shift(4, 0);
			o.write_shift(4, file.start);
			o.write_shift(4, file.size); o.write_shift(4, 0);
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size >= 0x1000) {
				o.l = (file.start+1) << 9;
				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
				for(; j & 0x1FF; ++j) o.write_shift(1, 0);
			}
		}
		for(i = 1; i < cfb.FileIndex.length; ++i) {
			file = cfb.FileIndex[i];
	if(file.size > 0 && file.size < 0x1000) {
				for(j = 0; j < file.size; ++j) o.write_shift(1, file.content[j]);
				for(; j & 0x3F; ++j) o.write_shift(1, 0);
			}
		}
		while(o.l < o.length) o.write_shift(1, 0);
		return o;
	}
	/* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */
	function find(cfb, path) {
		var UCFullPaths = cfb.FullPaths.map(function(x) { return x.toUpperCase(); });
		var UCPaths = UCFullPaths.map(function(x) { var y = x.split("/"); return y[y.length - (x.slice(-1) == "/" ? 2 : 1)]; });
		var k = false;
		if(path.charCodeAt(0) === 47 /* "/" */) { k = true; path = UCFullPaths[0].slice(0, -1) + path; }
		else k = path.indexOf("/") !== -1;
		var UCPath = path.toUpperCase();
		var w = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
		if(w !== -1) return cfb.FileIndex[w];
	
		var m = !UCPath.match(chr1);
		UCPath = UCPath.replace(chr0,'');
		if(m) UCPath = UCPath.replace(chr1,'!');
		for(w = 0; w < UCFullPaths.length; ++w) {
			if((m ? UCFullPaths[w].replace(chr1,'!') : UCFullPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
			if((m ? UCPaths[w].replace(chr1,'!') : UCPaths[w]).replace(chr0,'') == UCPath) return cfb.FileIndex[w];
		}
		return null;
	}
	/** CFB Constants */
	var MSSZ = 64; /* Mini Sector Size = 1<<6 */
	//var MSCSZ = 4096; /* Mini Stream Cutoff Size */
	/* 2.1 Compound File Sector Numbers and Types */
	var ENDOFCHAIN = -2;
	/* 2.2 Compound File Header */
	var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
	var HEADER_SIG = [0xD0, 0xCF, 0x11, 0xE0, 0xA1, 0xB1, 0x1A, 0xE1];
	var HEADER_CLSID = '00000000000000000000000000000000';
	var consts = {
		/* 2.1 Compund File Sector Numbers and Types */
		MAXREGSECT: -6,
		DIFSECT: -4,
		FATSECT: -3,
		ENDOFCHAIN: ENDOFCHAIN,
		FREESECT: -1,
		/* 2.2 Compound File Header */
		HEADER_SIGNATURE: HEADER_SIGNATURE,
		HEADER_MINOR_VERSION: '3e00',
		MAXREGSID: -6,
		NOSTREAM: -1,
		HEADER_CLSID: HEADER_CLSID,
		/* 2.6.1 Compound File Directory Entry */
		EntryTypes: ['unknown','storage','stream','lockbytes','property','root']
	};
	
	function write_file(cfb, filename, options) {
		get_fs();
		var o = _write(cfb, options);
	fs.writeFileSync(filename, o);
	}
	
	function a2s(o) {
		var out = new Array(o.length);
		for(var i = 0; i < o.length; ++i) out[i] = String.fromCharCode(o[i]);
		return out.join("");
	}
	
	function write(cfb, options) {
		var o = _write(cfb, options);
		switch(options && options.type) {
			case "file": get_fs(); fs.writeFileSync(options.filename, (o)); return o;
			case "binary": return a2s(o);
			case "base64": return Base64.encode(a2s(o));
		}
		return o;
	}
	/* node < 8.1 zlib does not expose bytesRead, so default to pure JS */
	var _zlib;
	function use_zlib(zlib) { try {
		var InflateRaw = zlib.InflateRaw;
		var InflRaw = new InflateRaw();
		InflRaw._processChunk(new Uint8Array([3, 0]), InflRaw._finishFlushFlag);
		if(InflRaw.bytesRead) _zlib = zlib;
		else throw new Error("zlib does not expose bytesRead");
	} catch(e) {console.error("cannot use native zlib: " + (e.message || e)); } }
	
	function _inflateRawSync(payload, usz) {
		if(!_zlib) return _inflate(payload, usz);
		var InflateRaw = _zlib.InflateRaw;
		var InflRaw = new InflateRaw();
		var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
		payload.l += InflRaw.bytesRead;
		return out;
	}
	
	function _deflateRawSync(payload) {
		return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
	}
	var CLEN_ORDER = [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];
	
	/*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */
	var LEN_LN = [   3,   4,   5,   6,   7,   8,   9,  10,  11,  13 , 15,  17,  19,  23,  27,  31,  35,  43,  51,  59,  67,  83,  99, 115, 131, 163, 195, 227, 258 ];
	
	/*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */
	var DST_LN = [  1,  2,  3,  4,  5,  7,  9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577 ];
	
	function bit_swap_8(n) { var t = (((((n<<1)|(n<<11)) & 0x22110) | (((n<<5)|(n<<15)) & 0x88440))); return ((t>>16) | (t>>8) |t)&0xFF; }
	
	var use_typed_arrays = typeof Uint8Array !== 'undefined';
	
	var bitswap8 = use_typed_arrays ? new Uint8Array(1<<8) : [];
	for(var q = 0; q < (1<<8); ++q) bitswap8[q] = bit_swap_8(q);
	
	function bit_swap_n(n, b) {
		var rev = bitswap8[n & 0xFF];
		if(b <= 8) return rev >>> (8-b);
		rev = (rev << 8) | bitswap8[(n>>8)&0xFF];
		if(b <= 16) return rev >>> (16-b);
		rev = (rev << 8) | bitswap8[(n>>16)&0xFF];
		return rev >>> (24-b);
	}
	
	/* helpers for unaligned bit reads */
	function read_bits_2(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 6 ? 0 : buf[h+1]<<8))>>>w)& 0x03; }
	function read_bits_3(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 5 ? 0 : buf[h+1]<<8))>>>w)& 0x07; }
	function read_bits_4(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 4 ? 0 : buf[h+1]<<8))>>>w)& 0x0F; }
	function read_bits_5(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 3 ? 0 : buf[h+1]<<8))>>>w)& 0x1F; }
	function read_bits_7(buf, bl) { var w = (bl&7), h = (bl>>>3); return ((buf[h]|(w <= 1 ? 0 : buf[h+1]<<8))>>>w)& 0x7F; }
	
	/* works up to n = 3 * 8 + 1 = 25 */
	function read_bits_n(buf, bl, n) {
		var w = (bl&7), h = (bl>>>3), f = ((1<<n)-1);
		var v = buf[h] >>> w;
		if(n < 8 - w) return v & f;
		v |= buf[h+1]<<(8-w);
		if(n < 16 - w) return v & f;
		v |= buf[h+2]<<(16-w);
		if(n < 24 - w) return v & f;
		v |= buf[h+3]<<(24-w);
		return v & f;
	}
	
	/* until ArrayBuffer#realloc is a thing, fake a realloc */
	function realloc(b, sz) {
		var L = b.length, M = 2*L > sz ? 2*L : sz + 5, i = 0;
		if(L >= sz) return b;
		if(has_buf) {
			var o = new_unsafe_buf(M);
			// $FlowIgnore
			if(b.copy) b.copy(o);
			else for(; i < b.length; ++i) o[i] = b[i];
			return o;
		} else if(use_typed_arrays) {
			var a = new Uint8Array(M);
			if(a.set) a.set(b);
			else for(; i < b.length; ++i) a[i] = b[i];
			return a;
		}
		b.length = M;
		return b;
	}
	
	/* zero-filled arrays for older browsers */
	function zero_fill_array(n) {
		var o = new Array(n);
		for(var i = 0; i < n; ++i) o[i] = 0;
		return o;
	}var _deflate = (function() {
	var _deflateRaw = (function() {
		return function deflateRaw(data, out) {
			var boff = 0;
			while(boff < data.length) {
				var L = Math.min(0xFFFF, data.length - boff);
				var h = boff + L == data.length;
				/* TODO: this is only type 0 stored */
				out.write_shift(1, +h);
				out.write_shift(2, L);
				out.write_shift(2, (~L) & 0xFFFF);
				while(L-- > 0) out[out.l++] = data[boff++];
			}
			return out.l;
		};
	})();
	
	return function(data) {
		var buf = new_buf(50+Math.floor(data.length*1.1));
		var off = _deflateRaw(data, buf);
		return buf.slice(0, off);
	};
	})();
	/* modified inflate function also moves original read head */
	
	/* build tree (used for literals and lengths) */
	function build_tree(clens, cmap, MAX) {
		var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
	
		var bl_count  = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
		for(i = 0; i < 32; ++i) bl_count[i] = 0;
	
		for(i = L; i < MAX; ++i) clens[i] = 0;
		L = clens.length;
	
		var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
	
		/* build code tree */
		for(i = 0; i < L; ++i) {
			bl_count[(w = clens[i])]++;
			if(maxlen < w) maxlen = w;
			ctree[i] = 0;
		}
		bl_count[0] = 0;
		for(i = 1; i <= maxlen; ++i) bl_count[i+16] = (ccode = (ccode + bl_count[i-1])<<1);
		for(i = 0; i < L; ++i) {
			ccode = clens[i];
			if(ccode != 0) ctree[i] = bl_count[ccode+16]++;
		}
	
		/* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */
		var cleni = 0;
		for(i = 0; i < L; ++i) {
			cleni = clens[i];
			if(cleni != 0) {
				ccode = bit_swap_n(ctree[i], maxlen)>>(maxlen-cleni);
				for(j = (1<<(maxlen + 4 - cleni)) - 1; j>=0; --j)
					cmap[ccode|(j<<cleni)] = (cleni&15) | (i<<4);
			}
		}
		return maxlen;
	}
	
	var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
	var fix_dmap = use_typed_arrays ? new Uint16Array(32)  : zero_fill_array(32);
	if(!use_typed_arrays) {
		for(var i = 0; i < 512; ++i) fix_lmap[i] = 0;
		for(i = 0; i < 32; ++i) fix_dmap[i] = 0;
	}
	(function() {
		var dlens = [];
		var i = 0;
		for(;i<32; i++) dlens.push(5);
		build_tree(dlens, fix_dmap, 32);
	
		var clens = [];
		i = 0;
		for(; i<=143; i++) clens.push(8);
		for(; i<=255; i++) clens.push(9);
		for(; i<=279; i++) clens.push(7);
		for(; i<=287; i++) clens.push(8);
		build_tree(clens, fix_lmap, 288);
	})();
	
	var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
	var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
	var dyn_cmap = use_typed_arrays ? new Uint16Array(128)   : zero_fill_array(128);
	var dyn_len_1 = 1, dyn_len_2 = 1;
	
	/* 5.5.3 Expanding Huffman Codes */
	function dyn(data, boff) {
		/* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */
		var _HLIT = read_bits_5(data, boff) + 257; boff += 5;
		var _HDIST = read_bits_5(data, boff) + 1; boff += 5;
		var _HCLEN = read_bits_4(data, boff) + 4; boff += 4;
		var w = 0;
	
		/* grab and store code lengths */
		var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
		var ctree = [ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ];
		var maxlen = 1;
		var bl_count =  use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
		var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
		var L = clens.length; /* 19 */
		for(var i = 0; i < _HCLEN; ++i) {
			clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
			if(maxlen < w) maxlen = w;
			bl_count[w]++;
			boff += 3;
		}
	
		/* build code tree */
		var ccode = 0;
		bl_count[0] = 0;
		for(i = 1; i <= maxlen; ++i) next_code[i] = ccode = (ccode + bl_count[i-1])<<1;
		for(i = 0; i < L; ++i) if((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
		/* cmap[7 bits from stream] = (off&7) + (lit<<3) */
		var cleni = 0;
		for(i = 0; i < L; ++i) {
			cleni = clens[i];
			if(cleni != 0) {
				ccode = bitswap8[ctree[i]]>>(8-cleni);
				for(var j = (1<<(7-cleni))-1; j>=0; --j) dyn_cmap[ccode|(j<<cleni)] = (cleni&7) | (i<<3);
			}
		}
	
		/* read literal and dist codes at once */
		var hcodes = [];
		maxlen = 1;
		for(; hcodes.length < _HLIT + _HDIST;) {
			ccode = dyn_cmap[read_bits_7(data, boff)];
			boff += ccode & 7;
			switch((ccode >>>= 3)) {
				case 16:
					w = 3 + read_bits_2(data, boff); boff += 2;
					ccode = hcodes[hcodes.length - 1];
					while(w-- > 0) hcodes.push(ccode);
					break;
				case 17:
					w = 3 + read_bits_3(data, boff); boff += 3;
					while(w-- > 0) hcodes.push(0);
					break;
				case 18:
					w = 11 + read_bits_7(data, boff); boff += 7;
					while(w -- > 0) hcodes.push(0);
					break;
				default:
					hcodes.push(ccode);
					if(maxlen < ccode) maxlen = ccode;
					break;
			}
		}
	
		/* build literal / length trees */
		var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
		for(i = _HLIT; i < 286; ++i) h1[i] = 0;
		for(i = _HDIST; i < 30; ++i) h2[i] = 0;
		dyn_len_1 = build_tree(h1, dyn_lmap, 286);
		dyn_len_2 = build_tree(h2, dyn_dmap, 30);
		return boff;
	}
	
	/* return [ data, bytesRead ] */
	function inflate(data, usz) {
		/* shortcircuit for empty buffer [0x03, 0x00] */
		if(data[0] == 3 && !(data[1] & 0x3)) { return [new_raw_buf(usz), 2]; }
	
		/* bit offset */
		var boff = 0;
	
		/* header includes final bit and type bits */
		var header = 0;
	
		var outbuf = new_unsafe_buf(usz ? usz : (1<<18));
		var woff = 0;
		var OL = outbuf.length>>>0;
		var max_len_1 = 0, max_len_2 = 0;
	
		while((header&1) == 0) {
			header = read_bits_3(data, boff); boff += 3;
			if((header >>> 1) == 0) {
				/* Stored block */
				if(boff & 7) boff += 8 - (boff&7);
				/* 2 bytes sz, 2 bytes bit inverse */
				var sz = data[boff>>>3] | data[(boff>>>3)+1]<<8;
				boff += 32;
				/* push sz bytes */
				if(!usz && OL < woff + sz) { outbuf = realloc(outbuf, woff + sz); OL = outbuf.length; }
				if(typeof data.copy === 'function') {
					// $FlowIgnore
					data.copy(outbuf, woff, boff>>>3, (boff>>>3)+sz);
					woff += sz; boff += 8*sz;
				} else while(sz-- > 0) { outbuf[woff++] = data[boff>>>3]; boff += 8; }
				continue;
			} else if((header >>> 1) == 1) {
				/* Fixed Huffman */
				max_len_1 = 9; max_len_2 = 5;
			} else {
				/* Dynamic Huffman */
				boff = dyn(data, boff);
				max_len_1 = dyn_len_1; max_len_2 = dyn_len_2;
			}
			if(!usz && (OL < woff + 32767)) { outbuf = realloc(outbuf, woff + 32767); OL = outbuf.length; }
			for(;;) { // while(true) is apparently out of vogue in modern JS circles
				/* ingest code and move read head */
				var bits = read_bits_n(data, boff, max_len_1);
				var code = (header>>>1) == 1 ? fix_lmap[bits] : dyn_lmap[bits];
				boff += code & 15; code >>>= 4;
				/* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */
				if(((code>>>8)&0xFF) === 0) outbuf[woff++] = code;
				else if(code == 256) break;
				else {
					code -= 257;
					var len_eb = (code < 8) ? 0 : ((code-4)>>2); if(len_eb > 5) len_eb = 0;
					var tgt = woff + LEN_LN[code];
					/* length extra bits */
					if(len_eb > 0) {
						tgt += read_bits_n(data, boff, len_eb);
						boff += len_eb;
					}
	
					/* dist code */
					bits = read_bits_n(data, boff, max_len_2);
					code = (header>>>1) == 1 ? fix_dmap[bits] : dyn_dmap[bits];
					boff += code & 15; code >>>= 4;
					var dst_eb = (code < 4 ? 0 : (code-2)>>1);
					var dst = DST_LN[code];
					/* dist extra bits */
					if(dst_eb > 0) {
						dst += read_bits_n(data, boff, dst_eb);
						boff += dst_eb;
					}
	
					/* in the common case, manual byte copy is faster than TA set / Buffer copy */
					if(!usz && OL < tgt) { outbuf = realloc(outbuf, tgt); OL = outbuf.length; }
					while(woff < tgt) { outbuf[woff] = outbuf[woff - dst]; ++woff; }
				}
			}
		}
		return [usz ? outbuf : outbuf.slice(0, woff), (boff+7)>>>3];
	}
	
	function _inflate(payload, usz) {
		var data = payload.slice(payload.l||0);
		var out = inflate(data, usz);
		payload.l += out[1];
		return out[0];
	}
	
	function warn_or_throw(wrn, msg) {
		if(wrn) { if(typeof console !== 'undefined') console.error(msg); }
		else throw new Error(msg);
	}
	
	function parse_zip(file, options) {
		var blob = file;
		prep_blob(blob, 0);
	
		var FileIndex = [], FullPaths = [];
		var o = {
			FileIndex: FileIndex,
			FullPaths: FullPaths
		};
		init_cfb(o, { root: options.root });
	
		/* find end of central directory, start just after signature */
		var i = blob.length - 4;
		while((blob[i] != 0x50 || blob[i+1] != 0x4b || blob[i+2] != 0x05 || blob[i+3] != 0x06) && i >= 0) --i;
		blob.l = i + 4;
	
		/* parse end of central directory */
		blob.l += 4;
		var fcnt = blob.read_shift(2);
		blob.l += 6;
		var start_cd = blob.read_shift(4);
	
		/* parse central directory */
		blob.l = start_cd;
	
		for(i = 0; i < fcnt; ++i) {
			/* trust local file header instead of CD entry */
			blob.l += 20;
			var csz = blob.read_shift(4);
			var usz = blob.read_shift(4);
			var namelen = blob.read_shift(2);
			var efsz = blob.read_shift(2);
			var fcsz = blob.read_shift(2);
			blob.l += 8;
			var offset = blob.read_shift(4);
			var EF = parse_extra_field(blob.slice(blob.l+namelen, blob.l+namelen+efsz));
			blob.l += namelen + efsz + fcsz;
	
			var L = blob.l;
			blob.l = offset + 4;
			parse_local_file(blob, csz, usz, o, EF);
			blob.l = L;
		}
	
		return o;
	}
	
	
	/* head starts just after local file header signature */
	function parse_local_file(blob, csz, usz, o, EF) {
		/* [local file header] */
		blob.l += 2;
		var flags = blob.read_shift(2);
		var meth = blob.read_shift(2);
		var date = parse_dos_date(blob);
	
		if(flags & 0x2041) throw new Error("Unsupported ZIP encryption");
		var crc32 = blob.read_shift(4);
		var _csz = blob.read_shift(4);
		var _usz = blob.read_shift(4);
	
		var namelen = blob.read_shift(2);
		var efsz = blob.read_shift(2);
	
		// TODO: flags & (1<<11) // UTF8
		var name = ""; for(var i = 0; i < namelen; ++i) name += String.fromCharCode(blob[blob.l++]);
		if(efsz) {
			var ef = parse_extra_field(blob.slice(blob.l, blob.l + efsz));
			if((ef[0x5455]||{}).mt) date = ef[0x5455].mt;
			if(((EF||{})[0x5455]||{}).mt) date = EF[0x5455].mt;
		}
		blob.l += efsz;
	
		/* [encryption header] */
	
		/* [file data] */
		var data = blob.slice(blob.l, blob.l + _csz);
		switch(meth) {
			case 8: data = _inflateRawSync(blob, _usz); break;
			case 0: break;
			default: throw new Error("Unsupported ZIP Compression method " + meth);
		}
	
		/* [data descriptor] */
		var wrn = false;
		if(flags & 8) {
			crc32 = blob.read_shift(4);
			if(crc32 == 0x08074b50) { crc32 = blob.read_shift(4); wrn = true; }
			_csz = blob.read_shift(4);
			_usz = blob.read_shift(4);
		}
	
		if(_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
		if(_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
		var _crc32 = CRC32.buf(data, 0);
		if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
		cfb_add(o, name, data, {unsafe: true, mt: date});
	}
	function write_zip(cfb, options) {
		var _opts = options || {};
		var out = [], cdirs = [];
		var o = new_buf(1);
		var method = (_opts.compression ? 8 : 0), flags = 0;
		var desc = false;
		if(desc) flags |= 8;
		var i = 0, j = 0;
	
		var start_cd = 0, fcnt = 0;
		var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
		var crcs = [];
		var sz_cd = 0;
	
		for(i = 1; i < cfb.FullPaths.length; ++i) {
			fp = cfb.FullPaths[i].slice(root.length); fi = cfb.FileIndex[i];
			if(!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
			var start = start_cd;
	
			/* TODO: CP437 filename */
			var namebuf = new_buf(fp.length);
			for(j = 0; j < fp.length; ++j) namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
			namebuf = namebuf.slice(0, namebuf.l);
			crcs[fcnt] = CRC32.buf(fi.content, 0);
	
			var outbuf = fi.content;
			if(method == 8) outbuf = _deflateRawSync(outbuf);
	
			/* local file header */
			o = new_buf(30);
			o.write_shift(4, 0x04034b50);
			o.write_shift(2, 20);
			o.write_shift(2, flags);
			o.write_shift(2, method);
			/* TODO: last mod file time/date */
			if(fi.mt) write_dos_date(o, fi.mt);
			else o.write_shift(4, 0);
			o.write_shift(-4, (flags & 8) ? 0 : crcs[fcnt]);
			o.write_shift(4,  (flags & 8) ? 0 : outbuf.length);
			o.write_shift(4,  (flags & 8) ? 0 : fi.content.length);
			o.write_shift(2, namebuf.length);
			o.write_shift(2, 0);
	
			start_cd += o.length;
			out.push(o);
			start_cd += namebuf.length;
			out.push(namebuf);
	
			/* TODO: encryption header ? */
			start_cd += outbuf.length;
			out.push(outbuf);
	
			/* data descriptor */
			if(flags & 8) {
				o = new_buf(12);
				o.write_shift(-4, crcs[fcnt]);
				o.write_shift(4, outbuf.length);
				o.write_shift(4, fi.content.length);
				start_cd += o.l;
				out.push(o);
			}
	
			/* central directory */
			o = new_buf(46);
			o.write_shift(4, 0x02014b50);
			o.write_shift(2, 0);
			o.write_shift(2, 20);
			o.write_shift(2, flags);
			o.write_shift(2, method);
			o.write_shift(4, 0); /* TODO: last mod file time/date */
			o.write_shift(-4, crcs[fcnt]);
	
			o.write_shift(4, outbuf.length);
			o.write_shift(4, fi.content.length);
			o.write_shift(2, namebuf.length);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(4, 0);
			o.write_shift(4, start);
	
			sz_cd += o.l;
			cdirs.push(o);
			sz_cd += namebuf.length;
			cdirs.push(namebuf);
			++fcnt;
		}
	
		/* end of central directory */
		o = new_buf(22);
		o.write_shift(4, 0x06054b50);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, fcnt);
		o.write_shift(2, fcnt);
		o.write_shift(4, sz_cd);
		o.write_shift(4, start_cd);
		o.write_shift(2, 0);
	
		return bconcat(([bconcat((out)), bconcat(cdirs), o]));
	}
	function cfb_new(opts) {
		var o = ({});
		init_cfb(o, opts);
		return o;
	}
	
	function cfb_add(cfb, name, content, opts) {
		var unsafe = opts && opts.unsafe;
		if(!unsafe) init_cfb(cfb);
		var file = !unsafe && CFB.find(cfb, name);
		if(!file) {
			var fpath = cfb.FullPaths[0];
			if(name.slice(0, fpath.length) == fpath) fpath = name;
			else {
				if(fpath.slice(-1) != "/") fpath += "/";
				fpath = (fpath + name).replace("//","/");
			}
			file = ({name: filename(name), type: 2});
			cfb.FileIndex.push(file);
			cfb.FullPaths.push(fpath);
			if(!unsafe) CFB.utils.cfb_gc(cfb);
		}
	file.content = (content);
		file.size = content ? content.length : 0;
		if(opts) {
			if(opts.CLSID) file.clsid = opts.CLSID;
			if(opts.mt) file.mt = opts.mt;
			if(opts.ct) file.ct = opts.ct;
		}
		return file;
	}
	
	function cfb_del(cfb, name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex.splice(j, 1);
			cfb.FullPaths.splice(j, 1);
			return true;
		}
		return false;
	}
	
	function cfb_mov(cfb, old_name, new_name) {
		init_cfb(cfb);
		var file = CFB.find(cfb, old_name);
		if(file) for(var j = 0; j < cfb.FileIndex.length; ++j) if(cfb.FileIndex[j] == file) {
			cfb.FileIndex[j].name = filename(new_name);
			cfb.FullPaths[j] = new_name;
			return true;
		}
		return false;
	}
	
	function cfb_gc(cfb) { rebuild_cfb(cfb, true); }
	
	exports.find = find;
	exports.read = read;
	exports.parse = parse;
	exports.write = write;
	exports.writeFile = write_file;
	exports.utils = {
		cfb_new: cfb_new,
		cfb_add: cfb_add,
		cfb_del: cfb_del,
		cfb_mov: cfb_mov,
		cfb_gc: cfb_gc,
		ReadShift: ReadShift,
		CheckField: CheckField,
		prep_blob: prep_blob,
		bconcat: bconcat,
		use_zlib: use_zlib,
		_deflateRaw: _deflate,
		_inflateRaw: _inflate,
		consts: consts
	};
	
	return exports;
	})();
	
	if("function" !== 'undefined' && typeof module !== 'undefined' && typeof DO_NOT_EXPORT_CFB === 'undefined') { module.exports = CFB; }
	var _fs;
	if(true) try { _fs = __webpack_require__(816); } catch(e) {}
	
	/* normalize data for blob ctor */
	function blobify(data) {
		if(typeof data === "string") return s2ab(data);
		if(Array.isArray(data)) return a2u(data);
		return data;
	}
	/* write or download file */
	function write_dl(fname, payload, enc) {
		/*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */
		if(typeof _fs !== 'undefined' && _fs.writeFileSync) return enc ? _fs.writeFileSync(fname, payload, enc) : _fs.writeFileSync(fname, payload);
		var data = (enc == "utf8") ? utf8write(payload) : payload;
	if(typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
		if(typeof Blob !== 'undefined') {
			var blob = new Blob([blobify(data)], {type:"application/octet-stream"});
	if(typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
	if(typeof saveAs !== 'undefined') return saveAs(blob, fname);
			if(typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
				var url = URL.createObjectURL(blob);
	if(typeof chrome === 'object' && typeof (chrome.downloads||{}).download == "function") {
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return chrome.downloads.download({ url: url, filename: fname, saveAs: true});
				}
				var a = document.createElement("a");
				if(a.download != null) {
	a.download = fname; a.href = url; document.body.appendChild(a); a.click();
	document.body.removeChild(a);
					if(URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() { URL.revokeObjectURL(url); }, 60000);
					return url;
				}
			}
		}
		// $FlowIgnore
		if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
			// $FlowIgnore
			var out = File(fname); out.open("w"); out.encoding = "binary";
			if(Array.isArray(payload)) payload = a2s(payload);
			out.write(payload); out.close(); return payload;
		} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
		throw new Error("cannot save file " + fname);
	}
	
	/* read binary data from file */
	function read_binary(path) {
		if(typeof _fs !== 'undefined') return _fs.readFileSync(path);
		// $FlowIgnore
		if(typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try { // extendscript
			// $FlowIgnore
			var infile = File(path); infile.open("r"); infile.encoding = "binary";
			var data = infile.read(); infile.close();
			return data;
		} catch(e) { if(!e.message || !e.message.match(/onstruct/)) throw e; }
		throw new Error("Cannot access file " + path);
	}
	function keys(o) {
		var ks = Object.keys(o), o2 = [];
		for(var i = 0; i < ks.length; ++i) if(Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
		return o2;
	}
	
	function evert_key(obj, key) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) if(o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
		return o;
	}
	
	function evert(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = K[i];
		return o;
	}
	
	function evert_num(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) o[obj[K[i]]] = parseInt(K[i],10);
		return o;
	}
	
	function evert_arr(obj) {
		var o = ([]), K = keys(obj);
		for(var i = 0; i !== K.length; ++i) {
			if(o[obj[K[i]]] == null) o[obj[K[i]]] = [];
			o[obj[K[i]]].push(K[i]);
		}
		return o;
	}
	
	var basedate = new Date(1899, 11, 30, 0, 0, 0); // 2209161600000
	function datenum(v, date1904) {
		var epoch = v.getTime();
		if(date1904) epoch -= 1462*24*60*60*1000;
		var dnthresh = basedate.getTime() + (v.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
		return (epoch - dnthresh) / (24 * 60 * 60 * 1000);
	}
	var refdate = new Date();
	var dnthresh = basedate.getTime() + (refdate.getTimezoneOffset() - basedate.getTimezoneOffset()) * 60000;
	var refoffset = refdate.getTimezoneOffset();
	function numdate(v) {
		var out = new Date();
		out.setTime(v * 24 * 60 * 60 * 1000 + dnthresh);
		if (out.getTimezoneOffset() !== refoffset) {
			out.setTime(out.getTime() + (out.getTimezoneOffset() - refoffset) * 60000);
		}
		return out;
	}
	
	/* ISO 8601 Duration */
	function parse_isodur(s) {
		var sec = 0, mt = 0, time = false;
		var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
		if(!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
		for(var i = 1; i != m.length; ++i) {
			if(!m[i]) continue;
			mt = 1;
			if(i > 3) time = true;
			switch(m[i].slice(m[i].length-1)) {
				case 'Y':
					throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length-1));
				case 'D': mt *= 24;
					/* falls through */
				case 'H': mt *= 60;
					/* falls through */
				case 'M':
					if(!time) throw new Error("Unsupported ISO Duration Field: M");
					else mt *= 60;
					/* falls through */
				case 'S': break;
			}
			sec += mt * parseInt(m[i], 10);
		}
		return sec;
	}
	
	var good_pd_date = new Date('2017-02-19T19:06:09.000Z');
	if(isNaN(good_pd_date.getFullYear())) good_pd_date = new Date('2/19/17');
	var good_pd = good_pd_date.getFullYear() == 2017;
	/* parses a date as a local date */
	function parseDate(str, fixdate) {
		var d = new Date(str);
		if(good_pd) {
	if(fixdate > 0) d.setTime(d.getTime() + d.getTimezoneOffset() * 60 * 1000);
			else if(fixdate < 0) d.setTime(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
			return d;
		}
		if(str instanceof Date) return str;
		if(good_pd_date.getFullYear() == 1917 && !isNaN(d.getFullYear())) {
			var s = d.getFullYear();
			if(str.indexOf("" + s) > -1) return d;
			d.setFullYear(d.getFullYear() + 100); return d;
		}
		var n = str.match(/\d+/g)||["2017","2","19","0","0","0"];
		var out = new Date(+n[0], +n[1] - 1, +n[2], (+n[3]||0), (+n[4]||0), (+n[5]||0));
		if(str.indexOf("Z") > -1) out = new Date(out.getTime() - out.getTimezoneOffset() * 60 * 1000);
		return out;
	}
	
	function cc2str(arr) {
		var o = "";
		for(var i = 0; i != arr.length; ++i) o += String.fromCharCode(arr[i]);
		return o;
	}
	
	function dup(o) {
		if(typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
		if(typeof o != 'object' || o == null) return o;
		if(o instanceof Date) return new Date(o.getTime());
		var out = {};
		for(var k in o) if(Object.prototype.hasOwnProperty.call(o, k)) out[k] = dup(o[k]);
		return out;
	}
	
	function fill(c,l) { var o = ""; while(o.length < l) o+=c; return o; }
	
	/* TODO: stress test */
	function fuzzynum(s) {
		var v = Number(s);
		if(isFinite(v)) return v;
		if(!isNaN(v)) return NaN;
		if(!/\d/.test(s)) return v;
		var wt = 1;
		var ss = s.replace(/([\d]),([\d])/g,"$1$2").replace(/[$]/g,"").replace(/[%]/g, function() { wt *= 100; return "";});
		if(!isNaN(v = Number(ss))) return v / wt;
		ss = ss.replace(/[(](.*)[)]/,function($$, $1) { wt = -wt; return $1;});
		if(!isNaN(v = Number(ss))) return v / wt;
		return v;
	}
	function fuzzydate(s) {
		var o = new Date(s), n = new Date(NaN);
		var y = o.getYear(), m = o.getMonth(), d = o.getDate();
		if(isNaN(d)) return n;
		if(y < 0 || y > 8099) return n;
		if((m > 0 || d > 1) && y != 101) return o;
		if(s.toLowerCase().match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) return o;
		if(s.match(/[^-0-9:,\/\\]/)) return n;
		return o;
	}
	
	var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
	function split_regex(str, re, def) {
		if(safe_split_regex || typeof re == "string") return str.split(re);
		var p = str.split(re), o = [p[0]];
		for(var i = 1; i < p.length; ++i) { o.push(def); o.push(p[i]); }
		return o;
	}
	function getdatastr(data) {
		if(!data) return null;
		if(data.data) return debom(data.data);
		if(data.asNodeBuffer && has_buf) return debom(data.asNodeBuffer().toString('binary'));
		if(data.asBinary) return debom(data.asBinary());
		if(data._data && data._data.getContent) return debom(cc2str(Array.prototype.slice.call(data._data.getContent(),0)));
		if(data.content && data.type) return debom(cc2str(data.content));
		return null;
	}
	
	function getdatabin(data) {
		if(!data) return null;
		if(data.data) return char_codes(data.data);
		if(data.asNodeBuffer && has_buf) return data.asNodeBuffer();
		if(data._data && data._data.getContent) {
			var o = data._data.getContent();
			if(typeof o == "string") return char_codes(o);
			return Array.prototype.slice.call(o);
		}
		if(data.content && data.type) return data.content;
		return null;
	}
	
	function getdata(data) { return (data && data.name.slice(-4) === ".bin") ? getdatabin(data) : getdatastr(data); }
	
	/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */
	/* OASIS does not comment on filename case sensitivity */
	function safegetzipfile(zip, file) {
		var k = zip.FullPaths || keys(zip.files);
		var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g,'\/');
		for(var i=0; i<k.length; ++i) {
			var n = k[i].replace(/^Root Entry[\/]/,"").toLowerCase();
			if(f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
		}
		return null;
	}
	
	function getzipfile(zip, file) {
		var o = safegetzipfile(zip, file);
		if(o == null) throw new Error("Cannot find file " + file + " in zip");
		return o;
	}
	
	function getzipdata(zip, file, safe) {
		if(!safe) return getdata(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipdata(zip, file); } catch(e) { return null; }
	}
	
	function getzipstr(zip, file, safe) {
		if(!safe) return getdatastr(getzipfile(zip, file));
		if(!file) return null;
		try { return getzipstr(zip, file); } catch(e) { return null; }
	}
	
	function zipentries(zip) {
		var k = zip.FullPaths || keys(zip.files), o = [];
		for(var i = 0; i < k.length; ++i) if(k[i].slice(-1) != '/') o.push(k[i]);
		return o.sort();
	}
	
	function zip_add_file(zip, path, content) {
		if(zip.FullPaths) CFB.utils.cfb_add(zip, path, content);
		else zip.file(path, content);
	}
	
	var jszip;
	/*global JSZipSync:true */
	if(typeof JSZipSync !== 'undefined') jszip = JSZipSync;
	if(true) {
		if(typeof module !== 'undefined' && module.exports) {
			if(typeof jszip === 'undefined') jszip = __webpack_require__(1847);
		}
	}
	
	function zip_new() {
		if(!jszip) return CFB.utils.cfb_new();
		return new jszip();
	}
	
	function zip_read(d, o) {
		var zip;
		if(jszip) switch(o.type) {
			case "base64": zip = new jszip(d, { base64:true }); break;
			case "binary": case "array": zip = new jszip(d, { base64:false }); break;
			case "buffer": zip = new jszip(d); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		else switch(o.type) {
			case "base64": zip = CFB.read(d, { type: "base64" }); break;
			case "binary": zip = CFB.read(d, { type: "binary" }); break;
			case "buffer": case "array": zip = CFB.read(d, { type: "buffer" }); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		return zip;
	}
	
	function resolve_path(path, base) {
		if(path.charAt(0) == "/") return path.slice(1);
		var result = base.split('/');
		if(base.slice(-1) != "/") result.pop(); // folder path
		var target = path.split('/');
		while (target.length !== 0) {
			var step = target.shift();
			if (step === '..') result.pop();
			else if (step !== '.') result.push(step);
		}
		return result.join('/');
	}
	var XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
	var attregexg=/([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
	var tagregex=/<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'">\s=]+))*\s*[\/\?]?>/mg;
	
	if(!(XML_HEADER.match(tagregex))) tagregex = /<[^>]*>/g;
	var nsregex=/<\w*:/, nsregex2 = /<(\/?)\w+:/;
	function parsexmltag(tag, skip_root, skip_LC) {
		var z = ({});
		var eq = 0, c = 0;
		for(; eq !== tag.length; ++eq) if((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
		if(!skip_root) z[0] = tag.slice(0, eq);
		if(eq === tag.length) return z;
		var m = tag.match(attregexg), j=0, v="", i=0, q="", cc="", quot = 1;
		if(m) for(i = 0; i != m.length; ++i) {
			cc = m[i];
			for(c=0; c != cc.length; ++c) if(cc.charCodeAt(c) === 61) break;
			q = cc.slice(0,c).trim();
			while(cc.charCodeAt(c+1) == 32) ++c;
			quot = ((eq=cc.charCodeAt(c+1)) == 34 || eq == 39) ? 1 : 0;
			v = cc.slice(c+1+quot, cc.length-quot);
			for(j=0;j!=q.length;++j) if(q.charCodeAt(j) === 58) break;
			if(j===q.length) {
				if(q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
				z[q] = v;
				if(!skip_LC) z[q.toLowerCase()] = v;
			}
			else {
				var k = (j===5 && q.slice(0,5)==="xmlns"?"xmlns":"")+q.slice(j+1);
				if(z[k] && q.slice(j-3,j) == "ext") continue; // from ods
				z[k] = v;
				if(!skip_LC) z[k.toLowerCase()] = v;
			}
		}
		return z;
	}
	function strip_ns(x) { return x.replace(nsregex2, "<$1"); }
	
	var encodings = {
		'&quot;': '"',
		'&apos;': "'",
		'&gt;': '>',
		'&lt;': '<',
		'&amp;': '&'
	};
	var rencoding = evert(encodings);
	//var rencstr = "&<>'\"".split("");
	
	// TODO: CP remap (need to read file version to determine OS)
	var unescapexml = (function() {
		/* 22.4.2.4 bstr (Basic String) */
		var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
		return function unescapexml(text) {
			var s = text + '', i = s.indexOf("<![CDATA[");
			if(i == -1) return s.replace(encregex, function($$, $1) { return encodings[$$]||String.fromCharCode(parseInt($1,$$.indexOf("x")>-1?16:10))||$$; }).replace(coderegex,function(m,c) {return String.fromCharCode(parseInt(c,16));});
			var j = s.indexOf("]]>");
			return unescapexml(s.slice(0, i)) + s.slice(i+9,j) + unescapexml(s.slice(j+3));
		};
	})();
	
	var decregex=/[&<>'"]/g, charegex = /[\u0000-\u0008\u000b-\u001f]/g;
	function escapexml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(charegex,function(s) { return "_x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + "_";});
	}
	function escapexmltag(text){ return escapexml(text).replace(/ /g,"_x0020_"); }
	
	var htmlcharegex = /[\u0000-\u001f]/g;
	function escapehtml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(/\n/g, "<br/>").replace(htmlcharegex,function(s) { return "&#x" + ("000"+s.charCodeAt(0).toString(16)).slice(-4) + ";"; });
	}
	
	function escapexlml(text){
		var s = text + '';
		return s.replace(decregex, function(y) { return rencoding[y]; }).replace(htmlcharegex,function(s) { return "&#x" + (s.charCodeAt(0).toString(16)).toUpperCase() + ";"; });
	}
	
	/* TODO: handle codepages */
	var xlml_fixstr = (function() {
		var entregex = /&#(\d+);/g;
		function entrepl($$,$1) { return String.fromCharCode(parseInt($1,10)); }
		return function xlml_fixstr(str) { return str.replace(entregex,entrepl); };
	})();
	var xlml_unfixstr = (function() {
		return function xlml_unfixstr(str) { return str.replace(/(\r\n|[\r\n])/g,"\&#10;"); };
	})();
	
	function parsexmlbool(value) {
		switch(value) {
			case 1: case true: case '1': case 'true': case 'TRUE': return true;
			/* case '0': case 'false': case 'FALSE':*/
			default: return false;
		}
	}
	
	var utf8read = function utf8reada(orig) {
		var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
		while (i < orig.length) {
			c = orig.charCodeAt(i++);
			if (c < 128) { out += String.fromCharCode(c); continue; }
			d = orig.charCodeAt(i++);
			if (c>191 && c<224) { f = ((c & 31) << 6); f |= (d & 63); out += String.fromCharCode(f); continue; }
			e = orig.charCodeAt(i++);
			if (c < 240) { out += String.fromCharCode(((c & 15) << 12) | ((d & 63) << 6) | (e & 63)); continue; }
			f = orig.charCodeAt(i++);
			w = (((c & 7) << 18) | ((d & 63) << 12) | ((e & 63) << 6) | (f & 63))-65536;
			out += String.fromCharCode(0xD800 + ((w>>>10)&1023));
			out += String.fromCharCode(0xDC00 + (w&1023));
		}
		return out;
	};
	
	var utf8write = function(orig) {
		var out = [], i = 0, c = 0, d = 0;
		while(i < orig.length) {
			c = orig.charCodeAt(i++);
			switch(true) {
				case c < 128: out.push(String.fromCharCode(c)); break;
				case c < 2048:
					out.push(String.fromCharCode(192 + (c >> 6)));
					out.push(String.fromCharCode(128 + (c & 63)));
					break;
				case c >= 55296 && c < 57344:
					c -= 55296; d = orig.charCodeAt(i++) - 56320 + (c<<10);
					out.push(String.fromCharCode(240 + ((d >>18) & 7)));
					out.push(String.fromCharCode(144 + ((d >>12) & 63)));
					out.push(String.fromCharCode(128 + ((d >> 6) & 63)));
					out.push(String.fromCharCode(128 + (d & 63)));
					break;
				default:
					out.push(String.fromCharCode(224 + (c >> 12)));
					out.push(String.fromCharCode(128 + ((c >> 6) & 63)));
					out.push(String.fromCharCode(128 + (c & 63)));
			}
		}
		return out.join("");
	};
	
	if(has_buf) {
		var utf8readb = function utf8readb(data) {
			var out = Buffer.alloc(2*data.length), w, i, j = 1, k = 0, ww=0, c;
			for(i = 0; i < data.length; i+=j) {
				j = 1;
				if((c=data.charCodeAt(i)) < 128) w = c;
				else if(c < 224) { w = (c&31)*64+(data.charCodeAt(i+1)&63); j=2; }
				else if(c < 240) { w=(c&15)*4096+(data.charCodeAt(i+1)&63)*64+(data.charCodeAt(i+2)&63); j=3; }
				else { j = 4;
					w = (c & 7)*262144+(data.charCodeAt(i+1)&63)*4096+(data.charCodeAt(i+2)&63)*64+(data.charCodeAt(i+3)&63);
					w -= 65536; ww = 0xD800 + ((w>>>10)&1023); w = 0xDC00 + (w&1023);
				}
				if(ww !== 0) { out[k++] = ww&255; out[k++] = ww>>>8; ww = 0; }
				out[k++] = w%256; out[k++] = w>>>8;
			}
			return out.slice(0,k).toString('ucs2');
		};
		var corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
		if(utf8read(corpus) == utf8readb(corpus)) utf8read = utf8readb;
		var utf8readc = function utf8readc(data) { return Buffer_from(data, 'binary').toString('utf8'); };
		if(utf8read(corpus) == utf8readc(corpus)) utf8read = utf8readc;
	
		utf8write = function(data) { return Buffer_from(data, 'utf8').toString("binary"); };
	}
	
	// matches <foo>...</foo> extracts content
	var matchtag = (function() {
		var mtcache = ({});
		return function matchtag(f,g) {
			var t = f+"|"+(g||"");
			if(mtcache[t]) return mtcache[t];
			return (mtcache[t] = new RegExp('<(?:\\w+:)?'+f+'(?: xml:space="preserve")?(?:[^>]*)>([\\s\\S]*?)</(?:\\w+:)?'+f+'>',((g||""))));
		};
	})();
	
	var htmldecode = (function() {
		var entities = [
			['nbsp', ' '], ['middot', '·'],
			['quot', '"'], ['apos', "'"], ['gt',   '>'], ['lt',   '<'], ['amp',  '&']
		].map(function(x) { return [new RegExp('&' + x[0] + ';', "ig"), x[1]]; });
		return function htmldecode(str) {
			var o = str
					// Remove new lines and spaces from start of content
					.replace(/^[\t\n\r ]+/, "")
					// Remove new lines and spaces from end of content
					.replace(/[\t\n\r ]+$/,"")
					// Added line which removes any white space characters after and before html tags
					.replace(/>\s+/g,">").replace(/\s+</g,"<")
					// Replace remaining new lines and spaces with space
					.replace(/[\t\n\r ]+/g, " ")
					// Replace <br> tags with new lines
					.replace(/<\s*[bB][rR]\s*\/?>/g,"\n")
					// Strip HTML elements
					.replace(/<[^>]*>/g,"");
			for(var i = 0; i < entities.length; ++i) o = o.replace(entities[i][0], entities[i][1]);
			return o;
		};
	})();
	
	var vtregex = (function(){ var vt_cache = {};
		return function vt_regex(bt) {
			if(vt_cache[bt] !== undefined) return vt_cache[bt];
			return (vt_cache[bt] = new RegExp("<(?:vt:)?" + bt + ">([\\s\\S]*?)</(?:vt:)?" + bt + ">", 'g') );
	};})();
	var vtvregex = /<\/?(?:vt:)?variant>/g, vtmregex = /<(?:vt:)([^>]*)>([\s\S]*)</;
	function parseVector(data, opts) {
		var h = parsexmltag(data);
	
		var matches = data.match(vtregex(h.baseType))||[];
		var res = [];
		if(matches.length != h.size) {
			if(opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
			return res;
		}
		matches.forEach(function(x) {
			var v = x.replace(vtvregex,"").match(vtmregex);
			if(v) res.push({v:utf8read(v[2]), t:v[1]});
		});
		return res;
	}
	
	var wtregex = /(^\s|\s$|\n)/;
	function writetag(f,g) { return '<' + f + (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f + '>'; }
	
	function wxt_helper(h) { return keys(h).map(function(k) { return " " + k + '="' + h[k] + '"';}).join(""); }
	function writextag(f,g,h) { return '<' + f + ((h != null) ? wxt_helper(h) : "") + ((g != null) ? (g.match(wtregex)?' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';}
	
	function write_w3cdtf(d, t) { try { return d.toISOString().replace(/\.\d*/,""); } catch(e) { if(t) throw e; } return ""; }
	
	function write_vt(s, xlsx) {
		switch(typeof s) {
			case 'string':
				var o = writextag('vt:lpwstr', escapexml(s));
				if(xlsx) o = o.replace(/&quot;/g, "_x0022_");
				return o;
			case 'number': return writextag((s|0)==s?'vt:i4':'vt:r8', escapexml(String(s)));
			case 'boolean': return writextag('vt:bool',s?'true':'false');
		}
		if(s instanceof Date) return writextag('vt:filetime', write_w3cdtf(s));
		throw new Error("Unable to serialize " + s);
	}
	
	var XMLNS = ({
		'dc': 'http://purl.org/dc/elements/1.1/',
		'dcterms': 'http://purl.org/dc/terms/',
		'dcmitype': 'http://purl.org/dc/dcmitype/',
		'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
		'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
		'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
		'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
		'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
		'xsd': 'http://www.w3.org/2001/XMLSchema'
	});
	
	XMLNS.main = [
		'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
		'http://purl.oclc.org/ooxml/spreadsheetml/main',
		'http://schemas.microsoft.com/office/excel/2006/main',
		'http://schemas.microsoft.com/office/excel/2006/2'
	];
	
	var XLMLNS = ({
		'o':    'urn:schemas-microsoft-com:office:office',
		'x':    'urn:schemas-microsoft-com:office:excel',
		'ss':   'urn:schemas-microsoft-com:office:spreadsheet',
		'dt':   'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
		'mv':   'http://macVmlSchemaUri',
		'v':    'urn:schemas-microsoft-com:vml',
		'html': 'http://www.w3.org/TR/REC-html40'
	});
	function read_double_le(b, idx) {
		var s = 1 - 2 * (b[idx + 7] >>> 7);
		var e = ((b[idx + 7] & 0x7f) << 4) + ((b[idx + 6] >>> 4) & 0x0f);
		var m = (b[idx+6]&0x0f);
		for(var i = 5; i >= 0; --i) m = m * 256 + b[idx + i];
		if(e == 0x7ff) return m == 0 ? (s * Infinity) : NaN;
		if(e == 0) e = -1022;
		else { e -= 1023; m += Math.pow(2,52); }
		return s * Math.pow(2, e - 52) * m;
	}
	
	function write_double_le(b, v, idx) {
		var bs = ((((v < 0) || (1/v == -Infinity)) ? 1 : 0) << 7), e = 0, m = 0;
		var av = bs ? (-v) : v;
		if(!isFinite(av)) { e = 0x7ff; m = isNaN(v) ? 0x6969 : 0; }
		else if(av == 0) e = m = 0;
		else {
			e = Math.floor(Math.log(av) / Math.LN2);
			m = av * Math.pow(2, 52 - e);
			if((e <= -1023) && (!isFinite(m) || (m < Math.pow(2,52)))) { e = -1022; }
			else { m -= Math.pow(2,52); e+=1023; }
		}
		for(var i = 0; i <= 5; ++i, m/=256) b[idx + i] = m & 0xff;
		b[idx + 6] = ((e & 0x0f) << 4) | (m & 0xf);
		b[idx + 7] = (e >> 4) | bs;
	}
	
	var __toBuffer = function(bufs) { var x=[],w=10240; for(var i=0;i<bufs[0].length;++i) if(bufs[0][i]) for(var j=0,L=bufs[0][i].length;j<L;j+=w) x.push.apply(x, bufs[0][i].slice(j,j+w)); return x; };
	var ___toBuffer = __toBuffer;
	var __utf16le = function(b,s,e) { var ss=[]; for(var i=s; i<e; i+=2) ss.push(String.fromCharCode(__readUInt16LE(b,i))); return ss.join("").replace(chr0,''); };
	var ___utf16le = __utf16le;
	var __hexlify = function(b,s,l) { var ss=[]; for(var i=s; i<s+l; ++i) ss.push(("0" + b[i].toString(16)).slice(-2)); return ss.join(""); };
	var ___hexlify = __hexlify;
	var __utf8 = function(b,s,e) { var ss=[]; for(var i=s; i<e; i++) ss.push(String.fromCharCode(__readUInt8(b,i))); return ss.join(""); };
	var ___utf8 = __utf8;
	var __lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var ___lpstr = __lpstr;
	var __cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var ___cpstr = __cpstr;
	var __lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len-1) : "";};
	var ___lpwstr = __lpwstr;
	var __lpp4, ___lpp4;
	__lpp4 = ___lpp4 = function lpp4_(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf16le(b, i+4,i+4+len) : "";};
	var __8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? __utf8(b, i+4,i+4+len) : "";};
	var ___8lpp4 = __8lpp4;
	var __double, ___double;
	__double = ___double = function(b, idx) { return read_double_le(b, idx);};
	var is_buf = function is_buf_a(a) { return Array.isArray(a); };
	
	if(has_buf) {
		__utf16le = function(b,s,e) { if(!Buffer.isBuffer(b)) return ___utf16le(b,s,e); return b.toString('utf16le',s,e).replace(chr0,'')/*.replace(chr1,'!')*/; };
		__hexlify = function(b,s,l) { return Buffer.isBuffer(b) ? b.toString('hex',s,s+l) : ___hexlify(b,s,l); };
		__lpstr = function lpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__cpstr = function cpstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___cpstr(b, i); var len = b.readUInt32LE(i); return len > 0 ? b.toString('utf8',i+4,i+4+len-1) : "";};
		__lpwstr = function lpwstr_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpwstr(b, i); var len = 2*b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len-1);};
		__lpp4 = function lpp4_b(b, i) { if(!Buffer.isBuffer(b)) return ___lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf16le',i+4,i+4+len);};
		__8lpp4 = function lpp4_8b(b, i) { if(!Buffer.isBuffer(b)) return ___8lpp4(b, i); var len = b.readUInt32LE(i); return b.toString('utf8',i+4,i+4+len);};
		__utf8 = function utf8_b(b, s, e) { return (Buffer.isBuffer(b)) ? b.toString('utf8',s,e) : ___utf8(b,s,e); };
		__toBuffer = function(bufs) { return (bufs[0].length > 0 && Buffer.isBuffer(bufs[0][0])) ? Buffer.concat(bufs[0]) : ___toBuffer(bufs);};
		bconcat = function(bufs) { return Buffer.isBuffer(bufs[0]) ? Buffer.concat(bufs) : [].concat.apply([], bufs); };
		__double = function double_(b, i) { if(Buffer.isBuffer(b)) return b.readDoubleLE(i); return ___double(b,i); };
		is_buf = function is_buf_b(a) { return Buffer.isBuffer(a) || Array.isArray(a); };
	}
	
	/* from js-xls */
	if(typeof cptable !== 'undefined') {
		__utf16le = function(b,s,e) { return cptable.utils.decode(1200, b.slice(s,e)).replace(chr0, ''); };
		__utf8 = function(b,s,e) { return cptable.utils.decode(65001, b.slice(s,e)); };
		__lpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_ansi, b.slice(i+4, i+4+len-1)) : "";};
		__cpstr = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(current_codepage, b.slice(i+4, i+4+len-1)) : "";};
		__lpwstr = function(b,i) { var len = 2*__readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len-1)) : "";};
		__lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(1200, b.slice(i+4,i+4+len)) : "";};
		__8lpp4 = function(b,i) { var len = __readUInt32LE(b,i); return len > 0 ? cptable.utils.decode(65001, b.slice(i+4,i+4+len)) : "";};
	}
	
	var __readUInt8 = function(b, idx) { return b[idx]; };
	var __readUInt16LE = function(b, idx) { return (b[idx+1]*(1<<8))+b[idx]; };
	var __readInt16LE = function(b, idx) { var u = (b[idx+1]*(1<<8))+b[idx]; return (u < 0x8000) ? u : ((0xffff - u + 1) * -1); };
	var __readUInt32LE = function(b, idx) { return b[idx+3]*(1<<24)+(b[idx+2]<<16)+(b[idx+1]<<8)+b[idx]; };
	var __readInt32LE = function(b, idx) { return (b[idx+3]<<24)|(b[idx+2]<<16)|(b[idx+1]<<8)|b[idx]; };
	var __readInt32BE = function(b, idx) { return (b[idx]<<24)|(b[idx+1]<<16)|(b[idx+2]<<8)|b[idx+3]; };
	
	function ReadShift(size, t) {
		var o="", oI, oR, oo=[], w, vv, i, loc;
		switch(t) {
			case 'dbcs':
				loc = this.l;
				if(has_buf && Buffer.isBuffer(this)) o = this.slice(this.l, this.l+2*size).toString("utf16le");
				else for(i = 0; i < size; ++i) { o+=String.fromCharCode(__readUInt16LE(this, loc)); loc+=2; }
				size *= 2;
				break;
	
			case 'utf8': o = __utf8(this, this.l, this.l + size); break;
			case 'utf16le': size *= 2; o = __utf16le(this, this.l, this.l + size); break;
	
			case 'wstr':
				if(typeof cptable !== 'undefined') o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l+2*size));
				else return ReadShift.call(this, size, 'dbcs');
				size = 2 * size; break;
	
			/* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */
			case 'lpstr-ansi': o = __lpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			case 'lpstr-cp': o = __cpstr(this, this.l); size = 4 + __readUInt32LE(this, this.l); break;
			/* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */
			case 'lpwstr': o = __lpwstr(this, this.l); size = 4 + 2 * __readUInt32LE(this, this.l); break;
			/* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */
			case 'lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __lpp4(this, this.l); if(size & 0x02) size += 2; break;
			/* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */
			case '8lpp4': size = 4 +  __readUInt32LE(this, this.l); o = __8lpp4(this, this.l); if(size & 0x03) size += 4 - (size & 0x03); break;
	
			case 'cstr': size = 0; o = "";
				while((w=__readUInt8(this, this.l + size++))!==0) oo.push(_getchar(w));
				o = oo.join(""); break;
			case '_wstr': size = 0; o = "";
				while((w=__readUInt16LE(this,this.l +size))!==0){oo.push(_getchar(w));size+=2;}
				size+=2; o = oo.join(""); break;
	
			/* sbcs and dbcs support continue records in the SST way TODO codepages */
			case 'dbcs-cont': o = ""; loc = this.l;
				for(i = 0; i < size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt16LE(this, loc)));
					loc+=2;
				} o = oo.join(""); size *= 2; break;
	
			case 'cpstr':
				if(typeof cptable !== 'undefined') {
					o = cptable.utils.decode(current_codepage, this.slice(this.l, this.l + size));
					break;
				}
			/* falls through */
			case 'sbcs-cont': o = ""; loc = this.l;
				for(i = 0; i != size; ++i) {
					if(this.lens && this.lens.indexOf(loc) !== -1) {
						w = __readUInt8(this, loc);
						this.l = loc + 1;
						vv = ReadShift.call(this, size-i, w ? 'dbcs-cont' : 'sbcs-cont');
						return oo.join("") + vv;
					}
					oo.push(_getchar(__readUInt8(this, loc)));
					loc+=1;
				} o = oo.join(""); break;
	
			default:
		switch(size) {
			case 1: oI = __readUInt8(this, this.l); this.l++; return oI;
			case 2: oI = (t === 'i' ? __readInt16LE : __readUInt16LE)(this, this.l); this.l += 2; return oI;
			case 4: case -4:
				if(t === 'i' || ((this[this.l+3] & 0x80)===0)) { oI = ((size > 0) ? __readInt32LE : __readInt32BE)(this, this.l); this.l += 4; return oI; }
				else { oR = __readUInt32LE(this, this.l); this.l += 4; } return oR;
			case 8: case -8:
				if(t === 'f') {
					if(size == 8) oR = __double(this, this.l);
					else oR = __double([this[this.l+7],this[this.l+6],this[this.l+5],this[this.l+4],this[this.l+3],this[this.l+2],this[this.l+1],this[this.l+0]], 0);
					this.l += 8; return oR;
				} else size = 8;
			/* falls through */
			case 16: o = __hexlify(this, this.l, size); break;
		}}
		this.l+=size; return o;
	}
	
	var __writeUInt32LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); b[idx+2] = ((val >>> 16) & 0xFF); b[idx+3] = ((val >>> 24) & 0xFF); };
	var __writeInt32LE  = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >> 8) & 0xFF); b[idx+2] = ((val >> 16) & 0xFF); b[idx+3] = ((val >> 24) & 0xFF); };
	var __writeUInt16LE = function(b, val, idx) { b[idx] = (val & 0xFF); b[idx+1] = ((val >>> 8) & 0xFF); };
	
	function WriteShift(t, val, f) {
		var size = 0, i = 0;
		if(f === 'dbcs') {
	for(i = 0; i != val.length; ++i) __writeUInt16LE(this, val.charCodeAt(i), this.l + 2 * i);
			size = 2 * val.length;
		} else if(f === 'sbcs') {
			if(typeof cptable !== 'undefined' && current_ansi == 874) {
				/* TODO: use tables directly, don't encode */
	for(i = 0; i != val.length; ++i) {
					var cppayload = cptable.utils.encode(current_ansi, val.charAt(i));
					this[this.l + i] = cppayload[0];
				}
			} else {
	val = val.replace(/[^\x00-\x7F]/g, "_");
	for(i = 0; i != val.length; ++i) this[this.l + i] = (val.charCodeAt(i) & 0xFF);
			}
			size = val.length;
		} else if(f === 'hex') {
			for(; i < t; ++i) {
	this[this.l++] = (parseInt(val.slice(2*i, 2*i+2), 16)||0);
			} return this;
		} else if(f === 'utf16le') {
	var end = Math.min(this.l + t, this.length);
				for(i = 0; i < Math.min(val.length, t); ++i) {
					var cc = val.charCodeAt(i);
					this[this.l++] = (cc & 0xff);
					this[this.l++] = (cc >> 8);
				}
				while(this.l < end) this[this.l++] = 0;
				return this;
		} else  switch(t) {
			case  1: size = 1; this[this.l] = val&0xFF; break;
			case  2: size = 2; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; break;
			case  3: size = 3; this[this.l] = val&0xFF; val >>>= 8; this[this.l+1] = val&0xFF; val >>>= 8; this[this.l+2] = val&0xFF; break;
			case  4: size = 4; __writeUInt32LE(this, val, this.l); break;
			case  8: size = 8; if(f === 'f') { write_double_le(this, val, this.l); break; }
			/* falls through */
			case 16: break;
			case -4: size = 4; __writeInt32LE(this, val, this.l); break;
		}
		this.l += size; return this;
	}
	
	function CheckField(hexstr, fld) {
		var m = __hexlify(this,this.l,hexstr.length>>1);
		if(m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
		this.l += hexstr.length>>1;
	}
	
	function prep_blob(blob, pos) {
		blob.l = pos;
		blob.read_shift = ReadShift;
		blob.chk = CheckField;
		blob.write_shift = WriteShift;
	}
	
	function parsenoop(blob, length) { blob.l += length; }
	
	function new_buf(sz) {
		var o = new_raw_buf(sz);
		prep_blob(o, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.1.4 Record */
	function recordhopper(data, cb, opts) {
		if(!data) return;
		var tmpbyte, cntbyte, length;
		prep_blob(data, data.l || 0);
		var L = data.length, RT = 0, tgt = 0;
		while(data.l < L) {
			RT = data.read_shift(1);
			if(RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F)<<7);
			var R = XLSBRecordEnum[RT] || XLSBRecordEnum[0xFFFF];
			tmpbyte = data.read_shift(1);
			length = tmpbyte & 0x7F;
			for(cntbyte = 1; cntbyte <4 && (tmpbyte & 0x80); ++cntbyte) length += ((tmpbyte = data.read_shift(1)) & 0x7F)<<(7*cntbyte);
			tgt = data.l + length;
			var d = R.f && R.f(data, length, opts);
			data.l = tgt;
			if(cb(d, R.n, RT)) return;
		}
	}
	
	/* control buffer usage for fixed-length buffers */
	function buf_array() {
		var bufs = [], blksz = has_buf ? 256 : 2048;
		var newblk = function ba_newblk(sz) {
			var o = (new_buf(sz));
			prep_blob(o, 0);
			return o;
		};
	
		var curbuf = newblk(blksz);
	
		var endbuf = function ba_endbuf() {
			if(!curbuf) return;
			if(curbuf.length > curbuf.l) { curbuf = curbuf.slice(0, curbuf.l); curbuf.l = curbuf.length; }
			if(curbuf.length > 0) bufs.push(curbuf);
			curbuf = null;
		};
	
		var next = function ba_next(sz) {
			if(curbuf && (sz < (curbuf.length - curbuf.l))) return curbuf;
			endbuf();
			return (curbuf = newblk(Math.max(sz+1, blksz)));
		};
	
		var end = function ba_end() {
			endbuf();
			return __toBuffer([bufs]);
		};
	
		var push = function ba_push(buf) { endbuf(); curbuf = buf; if(curbuf.l == null) curbuf.l = curbuf.length; next(blksz); };
	
		return ({ next:next, push:push, end:end, _bufs:bufs });
	}
	
	function write_record(ba, type, payload, length) {
		var t = +XLSBRE[type], l;
		if(isNaN(t)) return; // TODO: throw something here?
		if(!length) length = XLSBRecordEnum[t].p || (payload||[]).length || 0;
		l = 1 + (t >= 0x80 ? 1 : 0) + 1/* + length*/;
		if(length >= 0x80) ++l; if(length >= 0x4000) ++l; if(length >= 0x200000) ++l;
		var o = ba.next(l);
		if(t <= 0x7F) o.write_shift(1, t);
		else {
			o.write_shift(1, (t & 0x7F) + 0x80);
			o.write_shift(1, (t >> 7));
		}
		for(var i = 0; i != 4; ++i) {
			if(length >= 0x80) { o.write_shift(1, (length & 0x7F)+0x80); length >>= 7; }
			else { o.write_shift(1, length); break; }
		}
		if(length > 0 && is_buf(payload)) ba.push(payload);
	}
	/* XLS ranges enforced */
	function shift_cell_xls(cell, tgt, opts) {
		var out = dup(cell);
		if(tgt.s) {
			if(out.cRel) out.c += tgt.s.c;
			if(out.rRel) out.r += tgt.s.r;
		} else {
			if(out.cRel) out.c += tgt.c;
			if(out.rRel) out.r += tgt.r;
		}
		if(!opts || opts.biff < 12) {
			while(out.c >= 0x100) out.c -= 0x100;
			while(out.r >= 0x10000) out.r -= 0x10000;
		}
		return out;
	}
	
	function shift_range_xls(cell, range, opts) {
		var out = dup(cell);
		out.s = shift_cell_xls(out.s, range.s, opts);
		out.e = shift_cell_xls(out.e, range.s, opts);
		return out;
	}
	
	function encode_cell_xls(c, biff) {
		if(c.cRel && c.c < 0) { c = dup(c); while(c.c < 0) c.c += (biff > 8) ? 0x4000 : 0x100; }
		if(c.rRel && c.r < 0) { c = dup(c); while(c.r < 0) c.r += (biff > 8) ? 0x100000 : ((biff > 5) ? 0x10000 : 0x4000); }
		var s = encode_cell(c);
		if(!c.cRel && c.cRel != null) s = fix_col(s);
		if(!c.rRel && c.rRel != null) s = fix_row(s);
		return s;
	}
	
	function encode_range_xls(r, opts) {
		if(r.s.r == 0 && !r.s.rRel) {
			if(r.e.r == (opts.biff >= 12 ? 0xFFFFF : (opts.biff >= 8 ? 0x10000 : 0x4000)) && !r.e.rRel) {
				return (r.s.cRel ? "" : "$") + encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + encode_col(r.e.c);
			}
		}
		if(r.s.c == 0 && !r.s.cRel) {
			if(r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) {
				return (r.s.rRel ? "" : "$") + encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + encode_row(r.e.r);
			}
		}
		return encode_cell_xls(r.s, opts.biff) + ":" + encode_cell_xls(r.e, opts.biff);
	}
	var OFFCRYPTO = {};
	
	var make_offcrypto = function(O, _crypto) {
		var crypto;
		if(typeof _crypto !== 'undefined') crypto = _crypto;
		else if(true) {
			try { crypto = __webpack_require__(1853); }
			catch(e) { crypto = null; }
		}
	
		O.rc4 = function(key, data) {
			var S = new Array(256);
			var c = 0, i = 0, j = 0, t = 0;
			for(i = 0; i != 256; ++i) S[i] = i;
			for(i = 0; i != 256; ++i) {
				j = (j + S[i] + (key[i%key.length]).charCodeAt(0))&255;
				t = S[i]; S[i] = S[j]; S[j] = t;
			}
			// $FlowIgnore
			i = j = 0; var out = new_raw_buf(data.length);
			for(c = 0; c != data.length; ++c) {
				i = (i + 1)&255;
				j = (j + S[i])%256;
				t = S[i]; S[i] = S[j]; S[j] = t;
				out[c] = (data[c] ^ S[(S[i]+S[j])&255]);
			}
			return out;
		};
	
		O.md5 = function(hex) {
			if(!crypto) throw new Error("Unsupported crypto");
			return crypto.createHash('md5').update(hex).digest('hex');
		};
	};
	/*global crypto:true */
	make_offcrypto(OFFCRYPTO, typeof crypto !== "undefined" ? crypto : undefined);
	
	function decode_row(rowstr) { return parseInt(unfix_row(rowstr),10) - 1; }
	function encode_row(row) { return "" + (row + 1); }
	function fix_row(cstr) { return cstr.replace(/([A-Z]|^)(\d+)$/,"$1$$$2"); }
	function unfix_row(cstr) { return cstr.replace(/\$(\d+)$/,"$1"); }
	
	function decode_col(colstr) { var c = unfix_col(colstr), d = 0, i = 0; for(; i !== c.length; ++i) d = 26*d + c.charCodeAt(i) - 64; return d - 1; }
	function encode_col(col) { if(col < 0) throw new Error("invalid column " + col); var s=""; for(++col; col; col=Math.floor((col-1)/26)) s = String.fromCharCode(((col-1)%26) + 65) + s; return s; }
	function fix_col(cstr) { return cstr.replace(/^([A-Z])/,"$$$1"); }
	function unfix_col(cstr) { return cstr.replace(/^\$([A-Z])/,"$1"); }
	
	function split_cell(cstr) { return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/,"$1,$2").split(","); }
	//function decode_cell(cstr) { var splt = split_cell(cstr); return { c:decode_col(splt[0]), r:decode_row(splt[1]) }; }
	function decode_cell(cstr) {
		var R = 0, C = 0;
		for(var i = 0; i < cstr.length; ++i) {
			var cc = cstr.charCodeAt(i);
			if(cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
			else if(cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
		}
		return { c: C - 1, r:R - 1 };
	}
	//function encode_cell(cell) { return encode_col(cell.c) + encode_row(cell.r); }
	function encode_cell(cell) {
		var col = cell.c + 1;
		var s="";
		for(; col; col=((col-1)/26)|0) s = String.fromCharCode(((col-1)%26) + 65) + s;
		return s + (cell.r + 1);
	}
	function decode_range(range) {
		var idx = range.indexOf(":");
		if(idx == -1) return { s: decode_cell(range), e: decode_cell(range) };
		return { s: decode_cell(range.slice(0, idx)), e: decode_cell(range.slice(idx + 1)) };
	}
	function encode_range(cs,ce) {
		if(typeof ce === 'undefined' || typeof ce === 'number') {
	return encode_range(cs.s, cs.e);
		}
	if(typeof cs !== 'string') cs = encode_cell((cs));
		if(typeof ce !== 'string') ce = encode_cell((ce));
	return cs == ce ? cs : cs + ":" + ce;
	}
	
	function safe_decode_range(range) {
		var o = {s:{c:0,r:0},e:{c:0,r:0}};
		var idx = 0, i = 0, cc = 0;
		var len = range.length;
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.s.c = --idx;
	
		for(idx = 0; i < len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.s.r = --idx;
	
		if(i === len || cc != 10) { o.e.c=o.s.c; o.e.r=o.s.r; return o; }
		++i;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-64) < 1 || cc > 26) break;
			idx = 26*idx + cc;
		}
		o.e.c = --idx;
	
		for(idx = 0; i != len; ++i) {
			if((cc=range.charCodeAt(i)-48) < 0 || cc > 9) break;
			idx = 10*idx + cc;
		}
		o.e.r = --idx;
		return o;
	}
	
	function safe_format_cell(cell, v) {
		var q = (cell.t == 'd' && v instanceof Date);
		if(cell.z != null) try { return (cell.w = SSF.format(cell.z, q ? datenum(v) : v)); } catch(e) { }
		try { return (cell.w = SSF.format((cell.XF||{}).numFmtId||(q ? 14 : 0),  q ? datenum(v) : v)); } catch(e) { return ''+v; }
	}
	
	function format_cell(cell, v, o) {
		if(cell == null || cell.t == null || cell.t == 'z') return "";
		if(cell.w !== undefined) return cell.w;
		if(cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
		if(cell.t == "e") return BErr[cell.v] || cell.v;
		if(v == undefined) return safe_format_cell(cell, cell.v);
		return safe_format_cell(cell, v);
	}
	
	function sheet_to_workbook(sheet, opts) {
		var n = opts && opts.sheet ? opts.sheet : "Sheet1";
		var sheets = {}; sheets[n] = sheet;
		return { SheetNames: [n], Sheets: sheets };
	}
	
	function sheet_add_aoa(_ws, data, opts) {
		var o = opts || {};
		var dense = _ws ? Array.isArray(_ws) : o.dense;
		if(DENSE != null && dense == null) dense = DENSE;
		var ws = _ws || (dense ? ([]) : ({}));
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
			if(!ws["!ref"]) ws["!ref"] = "A1:A1";
		}
		var range = ({s: {c:10000000, r:10000000}, e: {c:0, r:0}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.s.c = _range.s.c;
			range.s.r = _range.s.r;
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) range.e.r = _R = _range.e.r + 1;
		}
		for(var R = 0; R != data.length; ++R) {
			if(!data[R]) continue;
			if(!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
			for(var C = 0; C != data[R].length; ++C) {
				if(typeof data[R][C] === 'undefined') continue;
				var cell = ({v: data[R][C] });
				var __R = _R + R, __C = _C + C;
				if(range.s.r > __R) range.s.r = __R;
				if(range.s.c > __C) range.s.c = __C;
				if(range.e.r < __R) range.e.r = __R;
				if(range.e.c < __C) range.e.c = __C;
				if(data[R][C] && typeof data[R][C] === 'object' && !Array.isArray(data[R][C]) && !(data[R][C] instanceof Date)) cell = data[R][C];
				else {
					if(Array.isArray(cell.v)) { cell.f = data[R][C][1]; cell.v = cell.v[0]; }
					if(cell.v === null) {
						if(cell.f) cell.t = 'n';
						else if(o.nullError) { cell.t = 'e'; cell.v = 0; }
						else if(!o.sheetStubs) continue;
						else cell.t = 'z';
					}
					else if(typeof cell.v === 'number') cell.t = 'n';
					else if(typeof cell.v === 'boolean') cell.t = 'b';
					else if(cell.v instanceof Date) {
						cell.z = o.dateNF || SSF._table[14];
						if(o.cellDates) { cell.t = 'd'; cell.w = SSF.format(cell.z, datenum(cell.v)); }
						else { cell.t = 'n'; cell.v = datenum(cell.v); cell.w = SSF.format(cell.z, cell.v); }
					}
					else cell.t = 's';
				}
				if(dense) {
					if(!ws[__R]) ws[__R] = [];
					if(ws[__R][__C] && ws[__R][__C].z) cell.z = ws[__R][__C].z;
					ws[__R][__C] = cell;
				} else {
					var cell_ref = encode_cell(({c:__C,r:__R}));
					if(ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
					ws[cell_ref] = cell;
				}
			}
		}
		if(range.s.c < 10000000) ws['!ref'] = encode_range(range);
		return ws;
	}
	function aoa_to_sheet(data, opts) { return sheet_add_aoa(null, data, opts); }
	
	function write_UInt32LE(x, o) {
		if (!o) o = new_buf(4);
		o.write_shift(4, x);
		return o;
	}
	
	/* [MS-XLSB] 2.5.168 */
	function parse_XLWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLWideString(data, o) {
		var _null = false; if (o == null) { _null = true; o = new_buf(4 + 2 * data.length); }
		o.write_shift(4, data.length);
		if (data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.91 */
	//function parse_LPWideString(data) {
	//	var cchCharacters = data.read_shift(2);
	//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
	//}
	
	/* [MS-XLSB] 2.5.143 */
	function parse_StrRun(data) {
		return { ich: data.read_shift(2), ifnt: data.read_shift(2) };
	}
	function write_StrRun(run, o) {
		if (!o) o = new_buf(4);
		o.write_shift(2, run.ich || 0);
		o.write_shift(2, run.ifnt || 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.121 */
	function parse_RichStr(data, length) {
		var start = data.l;
		var flags = data.read_shift(1);
		var str = parse_XLWideString(data);
		var rgsStrRun = [];
		var z = ({ t: str, h: str });
		if ((flags & 1) !== 0) { /* fRichStr */
			/* TODO: formatted string */
			var dwSizeStrRun = data.read_shift(4);
			for (var i = 0; i != dwSizeStrRun; ++i) rgsStrRun.push(parse_StrRun(data));
			z.r = rgsStrRun;
		}
		else z.r = [{ ich: 0, ifnt: 0 }];
		//if((flags & 2) !== 0) { /* fExtStr */
		//	/* TODO: phonetic string */
		//}
		data.l = start + length;
		return z;
	}
	function write_RichStr(str, o) {
		/* TODO: formatted string */
		var _null = false; if (o == null) { _null = true; o = new_buf(15 + 4 * str.t.length); }
		o.write_shift(1, 0);
		write_XLWideString(str.t, o);
		return _null ? o.slice(0, o.l) : o;
	}
	/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */
	var parse_BrtCommentText = parse_RichStr;
	function write_BrtCommentText(str, o) {
		/* TODO: formatted string */
		var _null = false; if (o == null) { _null = true; o = new_buf(23 + 4 * str.t.length); }
		o.write_shift(1, 1);
		write_XLWideString(str.t, o);
		o.write_shift(4, 1);
		write_StrRun({ ich: 0, ifnt: 0 }, o);
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.9 */
	function parse_XLSBCell(data) {
		var col = data.read_shift(4);
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) << 16;
		data.l++; //var fPhShow = data.read_shift(1);
		return { c: col, iStyleRef: iStyleRef };
	}
	function write_XLSBCell(cell, o) {
		if (o == null) o = new_buf(8);
		o.write_shift(-4, cell.c);
		o.write_shift(3, cell.iStyleRef || cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	/* Short XLSB Cell does not include column */
	function parse_XLSBShortCell(data) {
		var iStyleRef = data.read_shift(2);
		iStyleRef += data.read_shift(1) <<16;
		data.l++; //var fPhShow = data.read_shift(1);
		return { c:-1, iStyleRef: iStyleRef };
	}
	function write_XLSBShortCell(cell, o) {
		if(o == null) o = new_buf(4);
		o.write_shift(3, cell.iStyleRef || cell.s);
		o.write_shift(1, 0); /* fPhShow */
		return o;
	}
	
	/* [MS-XLSB] 2.5.21 */
	var parse_XLSBCodeName = parse_XLWideString;
	var write_XLSBCodeName = write_XLWideString;
	
	/* [MS-XLSB] 2.5.166 */
	function parse_XLNullableWideString(data) {
		var cchCharacters = data.read_shift(4);
		return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
	}
	function write_XLNullableWideString(data, o) {
		var _null = false; if (o == null) { _null = true; o = new_buf(127); }
		o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
		if (data.length > 0) o.write_shift(0, data, 'dbcs');
		return _null ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.5.165 */
	var parse_XLNameWideString = parse_XLWideString;
	//var write_XLNameWideString = write_XLWideString;
	
	/* [MS-XLSB] 2.5.114 */
	var parse_RelID = parse_XLNullableWideString;
	var write_RelID = write_XLNullableWideString;
	
	
	/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */
	function parse_RkNumber(data) {
		var b = data.slice(data.l, data.l + 4);
		var fX100 = (b[0] & 1), fInt = (b[0] & 2);
		data.l += 4;
		b[0] &= 0xFC; // b[0] &= ~3;
		var RK = fInt === 0 ? __double([0, 0, 0, 0, b[0], b[1], b[2], b[3]], 0) : __readInt32LE(b, 0) >> 2;
		return fX100 ? (RK / 100) : RK;
	}
	function write_RkNumber(data, o) {
		if (o == null) o = new_buf(4);
		var fX100 = 0, fInt = 0, d100 = data * 100;
		if ((data == (data | 0)) && (data >= -(1 << 29)) && (data < (1 << 29))) { fInt = 1; }
		else if ((d100 == (d100 | 0)) && (d100 >= -(1 << 29)) && (d100 < (1 << 29))) { fInt = 1; fX100 = 1; }
		if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
		else throw new Error("unsupported RkNumber " + data); // TODO
	}
	
	
	/* [MS-XLSB] 2.5.117 RfX */
	function parse_RfX(data ) {
		var cell = ({ s: {}, e: {} });
		cell.s.r = data.read_shift(4);
		cell.e.r = data.read_shift(4);
		cell.s.c = data.read_shift(4);
		cell.e.c = data.read_shift(4);
		return cell;
	}
	function write_RfX(r, o) {
		if (!o) o = new_buf(16);
		o.write_shift(4, r.s.r);
		o.write_shift(4, r.e.r);
		o.write_shift(4, r.s.c);
		o.write_shift(4, r.e.c);
		return o;
	}
	
	/* [MS-XLSB] 2.5.153 UncheckedRfX */
	var parse_UncheckedRfX = parse_RfX;
	var write_UncheckedRfX = write_RfX;
	
	/* [MS-XLSB] 2.5.155 UncheckedSqRfX */
	//function parse_UncheckedSqRfX(data) {
	//	var cnt = data.read_shift(4);
	//	var out = [];
	//	for(var i = 0; i < cnt; ++i) {
	//		var rng = parse_UncheckedRfX(data);
	//		out.push(encode_range(rng));
	//	}
	//	return out.join(",");
	//}
	//function write_UncheckedSqRfX(sqrfx) {
	//	var parts = sqrfx.split(/\s*,\s*/);
	//	var o = new_buf(4); o.write_shift(4, parts.length);
	//	var out = [o];
	//	parts.forEach(function(rng) {
	//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
	//	});
	//	return bconcat(out);
	//}
	
	/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */
	/* TODO: error checking, NaN and Infinity values are not valid Xnum */
	function parse_Xnum(data) {
		if(data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
		return data.read_shift(8, 'f');
	}
	function write_Xnum(data, o) { return (o || new_buf(8)).write_shift(8, data, 'f'); }
	
	/* [MS-XLSB] 2.4.324 BrtColor */
	function parse_BrtColor(data) {
		var out = {};
		var d = data.read_shift(1);
	
		//var fValidRGB = d & 1;
		var xColorType = d >>> 1;
	
		var index = data.read_shift(1);
		var nTS = data.read_shift(2, 'i');
		var bR = data.read_shift(1);
		var bG = data.read_shift(1);
		var bB = data.read_shift(1);
		data.l++; //var bAlpha = data.read_shift(1);
	
		switch (xColorType) {
			case 0: out.auto = 1; break;
			case 1:
				out.index = index;
				var icv = XLSIcv[index];
				/* automatic pseudo index 81 */
				if (icv) out.rgb = rgb2Hex(icv);
				break;
			case 2:
				/* if(!fValidRGB) throw new Error("invalid"); */
				out.rgb = rgb2Hex([bR, bG, bB]);
				break;
			case 3: out.theme = index; break;
		}
		if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
	
		return out;
	}
	function write_BrtColor(color, o) {
		if (!o) o = new_buf(8);
		if (!color || color.auto) { o.write_shift(4, 0); o.write_shift(4, 0); return o; }
		if (color.index != null) {
			o.write_shift(1, 0x02);
			o.write_shift(1, color.index);
		} else if (color.theme != null) {
			o.write_shift(1, 0x06);
			o.write_shift(1, color.theme);
		} else {
			o.write_shift(1, 0x05);
			o.write_shift(1, 0);
		}
		var nTS = color.tint || 0;
		if (nTS > 0) nTS *= 32767;
		else if (nTS < 0) nTS *= 32768;
		o.write_shift(2, nTS);
		if (!color.rgb || color.theme != null) {
			o.write_shift(2, 0);
			o.write_shift(1, 0);
			o.write_shift(1, 0);
		} else {
			var rgb = (color.rgb || 'FFFFFF');
			if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
			o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
			o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
			o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
			o.write_shift(1, 0xFF);
		}
		return o;
	}
	
	/* [MS-XLSB] 2.5.52 */
	function parse_FontFlags(data) {
		var d = data.read_shift(1);
		data.l++;
		var out = {
			fBold: d & 0x01,
			fItalic: d & 0x02,
			fUnderline: d & 0x04,
			fStrikeout: d & 0x08,
			fOutline: d & 0x10,
			fShadow: d & 0x20,
			fCondense: d & 0x40,
			fExtend: d & 0x80
		};
		return out;
	}
	function write_FontFlags(font, o) {
		if (!o) o = new_buf(2);
		var grbit =
			(font.italic ? 0x02 : 0) |
			(font.strike ? 0x08 : 0) |
			(font.outline ? 0x10 : 0) |
			(font.shadow ? 0x20 : 0) |
			(font.condense ? 0x40 : 0) |
			(font.extend ? 0x80 : 0);
		o.write_shift(1, grbit);
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-OLEDS] 2.3.1 and 2.3.2 */
	function parse_ClipboardFormatOrString(o, w) {
		// $FlowIgnore
		var ClipFmt = { 2: "BITMAP", 3: "METAFILEPICT", 8: "DIB", 14: "ENHMETAFILE" };
		var m = o.read_shift(4);
		switch (m) {
			case 0x00000000: return "";
			case 0xffffffff: case 0xfffffffe: return ClipFmt[o.read_shift(4)] || "";
		}
		if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
		o.l -= 4;
		return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
	}
	function parse_ClipboardFormatOrAnsiString(o) { return parse_ClipboardFormatOrString(o, 1); }
	function parse_ClipboardFormatOrUnicodeString(o) { return parse_ClipboardFormatOrString(o, 2); }
	
	/* [MS-OLEPS] 2.2 PropertyType */
	//var VT_EMPTY    = 0x0000;
	//var VT_NULL     = 0x0001;
	var VT_I2       = 0x0002;
	var VT_I4       = 0x0003;
	//var VT_R4       = 0x0004;
	//var VT_R8       = 0x0005;
	//var VT_CY       = 0x0006;
	//var VT_DATE     = 0x0007;
	//var VT_BSTR     = 0x0008;
	//var VT_ERROR    = 0x000A;
	var VT_BOOL     = 0x000B;
	var VT_VARIANT  = 0x000C;
	//var VT_DECIMAL  = 0x000E;
	//var VT_I1       = 0x0010;
	//var VT_UI1      = 0x0011;
	//var VT_UI2      = 0x0012;
	var VT_UI4      = 0x0013;
	//var VT_I8       = 0x0014;
	//var VT_UI8      = 0x0015;
	//var VT_INT      = 0x0016;
	//var VT_UINT     = 0x0017;
	var VT_LPSTR    = 0x001E;
	//var VT_LPWSTR   = 0x001F;
	var VT_FILETIME = 0x0040;
	var VT_BLOB     = 0x0041;
	//var VT_STREAM   = 0x0042;
	//var VT_STORAGE  = 0x0043;
	//var VT_STREAMED_Object  = 0x0044;
	//var VT_STORED_Object    = 0x0045;
	//var VT_BLOB_Object      = 0x0046;
	var VT_CF       = 0x0047;
	//var VT_CLSID    = 0x0048;
	//var VT_VERSIONED_STREAM = 0x0049;
	var VT_VECTOR   = 0x1000;
	//var VT_ARRAY    = 0x2000;
	
	var VT_STRING   = 0x0050; // 2.3.3.1.11 VtString
	var VT_USTR     = 0x0051; // 2.3.3.1.12 VtUnalignedString
	var VT_CUSTOM   = [VT_STRING, VT_USTR];
	
	/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */
	var DocSummaryPIDDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Category', t: VT_STRING },
	0x03: { n: 'PresentationFormat', t: VT_STRING },
	0x04: { n: 'ByteCount', t: VT_I4 },
	0x05: { n: 'LineCount', t: VT_I4 },
	0x06: { n: 'ParagraphCount', t: VT_I4 },
	0x07: { n: 'SlideCount', t: VT_I4 },
	0x08: { n: 'NoteCount', t: VT_I4 },
	0x09: { n: 'HiddenCount', t: VT_I4 },
	0x0a: { n: 'MultimediaClipCount', t: VT_I4 },
	0x0b: { n: 'ScaleCrop', t: VT_BOOL },
	0x0c: { n: 'HeadingPairs', t: VT_VECTOR | VT_VARIANT },
	0x0d: { n: 'TitlesOfParts', t: VT_VECTOR | VT_LPSTR },
	0x0e: { n: 'Manager', t: VT_STRING },
	0x0f: { n: 'Company', t: VT_STRING },
	0x10: { n: 'LinksUpToDate', t: VT_BOOL },
	0x11: { n: 'CharacterCount', t: VT_I4 },
	0x13: { n: 'SharedDoc', t: VT_BOOL },
	0x16: { n: 'HyperlinksChanged', t: VT_BOOL },
	0x17: { n: 'AppVersion', t: VT_I4, p: 'version' },
	0x18: { n: 'DigSig', t: VT_BLOB },
	0x1A: { n: 'ContentType', t: VT_STRING },
	0x1B: { n: 'ContentStatus', t: VT_STRING },
	0x1C: { n: 'Language', t: VT_STRING },
	0x1D: { n: 'Version', t: VT_STRING },
	0xFF: {},
		/* [MS-OLEPS] 2.18 */
	0x80000000: { n: 'Locale', t: VT_UI4 },
	0x80000003: { n: 'Behavior', t: VT_UI4 },
	0x72627262: {}
	};
	
	/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */
	var SummaryPIDSI = {
	0x01: { n: 'CodePage', t: VT_I2 },
	0x02: { n: 'Title', t: VT_STRING },
	0x03: { n: 'Subject', t: VT_STRING },
	0x04: { n: 'Author', t: VT_STRING },
	0x05: { n: 'Keywords', t: VT_STRING },
	0x06: { n: 'Comments', t: VT_STRING },
	0x07: { n: 'Template', t: VT_STRING },
	0x08: { n: 'LastAuthor', t: VT_STRING },
	0x09: { n: 'RevNumber', t: VT_STRING },
	0x0A: { n: 'EditTime', t: VT_FILETIME },
	0x0B: { n: 'LastPrinted', t: VT_FILETIME },
	0x0C: { n: 'CreatedDate', t: VT_FILETIME },
	0x0D: { n: 'ModifiedDate', t: VT_FILETIME },
	0x0E: { n: 'PageCount', t: VT_I4 },
	0x0F: { n: 'WordCount', t: VT_I4 },
	0x10: { n: 'CharCount', t: VT_I4 },
	0x11: { n: 'Thumbnail', t: VT_CF },
	0x12: { n: 'Application', t: VT_STRING },
	0x13: { n: 'DocSecurity', t: VT_I4 },
	0xFF: {},
		/* [MS-OLEPS] 2.18 */
	0x80000000: { n: 'Locale', t: VT_UI4 },
	0x80000003: { n: 'Behavior', t: VT_UI4 },
	0x72627262: {}
	};
	
	var DocSummaryRE = evert_key(DocSummaryPIDDSI, "n");
	var SummaryRE = evert_key(SummaryPIDSI, "n");
	
	/* [MS-XLS] 2.4.63 Country/Region codes */
	var CountryEnum = {
	0x0001: "US", // United States
	0x0002: "CA", // Canada
	0x0003: "", // Latin America (except Brazil)
	0x0007: "RU", // Russia
	0x0014: "EG", // Egypt
	0x001E: "GR", // Greece
	0x001F: "NL", // Netherlands
	0x0020: "BE", // Belgium
	0x0021: "FR", // France
	0x0022: "ES", // Spain
	0x0024: "HU", // Hungary
	0x0027: "IT", // Italy
	0x0029: "CH", // Switzerland
	0x002B: "AT", // Austria
	0x002C: "GB", // United Kingdom
	0x002D: "DK", // Denmark
	0x002E: "SE", // Sweden
	0x002F: "NO", // Norway
	0x0030: "PL", // Poland
	0x0031: "DE", // Germany
	0x0034: "MX", // Mexico
	0x0037: "BR", // Brazil
	0x003d: "AU", // Australia
	0x0040: "NZ", // New Zealand
	0x0042: "TH", // Thailand
	0x0051: "JP", // Japan
	0x0052: "KR", // Korea
	0x0054: "VN", // Viet Nam
	0x0056: "CN", // China
	0x005A: "TR", // Turkey
	0x0069: "JS", // Ramastan
	0x00D5: "DZ", // Algeria
	0x00D8: "MA", // Morocco
	0x00DA: "LY", // Libya
	0x015F: "PT", // Portugal
	0x0162: "IS", // Iceland
	0x0166: "FI", // Finland
	0x01A4: "CZ", // Czech Republic
	0x0376: "TW", // Taiwan
	0x03C1: "LB", // Lebanon
	0x03C2: "JO", // Jordan
	0x03C3: "SY", // Syria
	0x03C4: "IQ", // Iraq
	0x03C5: "KW", // Kuwait
	0x03C6: "SA", // Saudi Arabia
	0x03CB: "AE", // United Arab Emirates
	0x03CC: "IL", // Israel
	0x03CE: "QA", // Qatar
	0x03D5: "IR", // Iran
	0xFFFF: "US"  // United States
	};
	
	/* [MS-XLS] 2.5.127 */
	var XLSFillPattern = [
		null,
		'solid',
		'mediumGray',
		'darkGray',
		'lightGray',
		'darkHorizontal',
		'darkVertical',
		'darkDown',
		'darkUp',
		'darkGrid',
		'darkTrellis',
		'lightHorizontal',
		'lightVertical',
		'lightDown',
		'lightUp',
		'lightGrid',
		'lightTrellis',
		'gray125',
		'gray0625'
	];
	
	function rgbify(arr) { return arr.map(function(x) { return [(x>>16)&255,(x>>8)&255,x&255]; }); }
	
	/* [MS-XLS] 2.5.161 */
	/* [MS-XLSB] 2.5.75 Icv */
	var _XLSIcv = rgbify([
		/* Color Constants */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		/* Overridable Defaults */
		0x000000,
		0xFFFFFF,
		0xFF0000,
		0x00FF00,
		0x0000FF,
		0xFFFF00,
		0xFF00FF,
		0x00FFFF,
	
		0x800000,
		0x008000,
		0x000080,
		0x808000,
		0x800080,
		0x008080,
		0xC0C0C0,
		0x808080,
		0x9999FF,
		0x993366,
		0xFFFFCC,
		0xCCFFFF,
		0x660066,
		0xFF8080,
		0x0066CC,
		0xCCCCFF,
	
		0x000080,
		0xFF00FF,
		0xFFFF00,
		0x00FFFF,
		0x800080,
		0x800000,
		0x008080,
		0x0000FF,
		0x00CCFF,
		0xCCFFFF,
		0xCCFFCC,
		0xFFFF99,
		0x99CCFF,
		0xFF99CC,
		0xCC99FF,
		0xFFCC99,
	
		0x3366FF,
		0x33CCCC,
		0x99CC00,
		0xFFCC00,
		0xFF9900,
		0xFF6600,
		0x666699,
		0x969696,
		0x003366,
		0x339966,
		0x003300,
		0x333300,
		0x993300,
		0x993366,
		0x333399,
		0x333333,
	
		/* Other entries to appease BIFF8/12 */
		0xFFFFFF, /* 0x40 icvForeground ?? */
		0x000000, /* 0x41 icvBackground ?? */
		0x000000, /* 0x42 icvFrame ?? */
		0x000000, /* 0x43 icv3D ?? */
		0x000000, /* 0x44 icv3DText ?? */
		0x000000, /* 0x45 icv3DHilite ?? */
		0x000000, /* 0x46 icv3DShadow ?? */
		0x000000, /* 0x47 icvHilite ?? */
		0x000000, /* 0x48 icvCtlText ?? */
		0x000000, /* 0x49 icvCtlScrl ?? */
		0x000000, /* 0x4A icvCtlInv ?? */
		0x000000, /* 0x4B icvCtlBody ?? */
		0x000000, /* 0x4C icvCtlFrame ?? */
		0x000000, /* 0x4D icvCtlFore ?? */
		0x000000, /* 0x4E icvCtlBack ?? */
		0x000000, /* 0x4F icvCtlNeutral */
		0x000000, /* 0x50 icvInfoBk ?? */
		0x000000 /* 0x51 icvInfoText ?? */
	]);
	var XLSIcv = dup(_XLSIcv);
	
	/* [MS-XLSB] 2.5.97.2 */
	var BErr = {
	0x00: "#NULL!",
	0x07: "#DIV/0!",
	0x0F: "#VALUE!",
	0x17: "#REF!",
	0x1D: "#NAME?",
	0x24: "#NUM!",
	0x2A: "#N/A",
	0x2B: "#GETTING_DATA",
	0xFF: "#WTF?"
	};
	var RBErr = evert_num(BErr);
	/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */
	/* 12.3 Part Summary <SpreadsheetML> */
	/* 14.2 Part Summary <DrawingML> */
	/* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */
	var ct2type/*{[string]:string}*/ = ({
		/* Workbook */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
	
		/* Worksheet */
		"application/vnd.ms-excel.binIndexWs": "TODO", /* Binary Index */
	
		/* Macrosheet */
		"application/vnd.ms-excel.intlmacrosheet": "TODO",
		"application/vnd.ms-excel.binIndexMs": "TODO", /* Binary Index */
	
		/* File Properties */
		"application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
		"application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
		"application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
	
		/* Custom Data Properties */
		"application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
	
		/* PivotTable */
		"application/vnd.ms-excel.pivotTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
	
		/* Chart Objects */
		"application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
	
		/* Chart Colors */
		"application/vnd.ms-office.chartcolorstyle+xml": "TODO",
	
		/* Chart Style */
		"application/vnd.ms-office.chartstyle+xml": "TODO",
	
		/* Chart Advanced */
		"application/vnd.ms-office.chartex+xml": "TODO",
	
		/* Calculation Chain */
		"application/vnd.ms-excel.calcChain": "calcchains",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
	
		/* Printer Settings */
		"application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
	
		/* ActiveX */
		"application/vnd.ms-office.activeX": "TODO",
		"application/vnd.ms-office.activeX+xml": "TODO",
	
		/* Custom Toolbars */
		"application/vnd.ms-excel.attachedToolbars": "TODO",
	
		/* External Data Connections */
		"application/vnd.ms-excel.connections": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
	
		/* External Links */
		"application/vnd.ms-excel.externalLink": "links",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
	
		/* Metadata */
		"application/vnd.ms-excel.sheetMetadata": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "TODO",
	
		/* PivotCache */
		"application/vnd.ms-excel.pivotCacheDefinition": "TODO",
		"application/vnd.ms-excel.pivotCacheRecords": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
	
		/* Query Table */
		"application/vnd.ms-excel.queryTable": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
	
		/* Shared Workbook */
		"application/vnd.ms-excel.userNames": "TODO",
		"application/vnd.ms-excel.revisionHeaders": "TODO",
		"application/vnd.ms-excel.revisionLog": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
	
		/* Single Cell Table */
		"application/vnd.ms-excel.tableSingleCells": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
	
		/* Slicer */
		"application/vnd.ms-excel.slicer": "TODO",
		"application/vnd.ms-excel.slicerCache": "TODO",
		"application/vnd.ms-excel.slicer+xml": "TODO",
		"application/vnd.ms-excel.slicerCache+xml": "TODO",
	
		/* Sort Map */
		"application/vnd.ms-excel.wsSortMap": "TODO",
	
		/* Table */
		"application/vnd.ms-excel.table": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
	
		/* Themes */
		"application/vnd.openxmlformats-officedocument.theme+xml": "themes",
	
		/* Theme Override */
		"application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
	
		/* Timeline */
		"application/vnd.ms-excel.Timeline+xml": "TODO", /* verify */
		"application/vnd.ms-excel.TimelineCache+xml": "TODO", /* verify */
	
		/* VBA */
		"application/vnd.ms-office.vbaProject": "vba",
		"application/vnd.ms-office.vbaProjectSignature": "vba",
	
		/* Volatile Dependencies */
		"application/vnd.ms-office.volatileDependencies": "TODO",
		"application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
	
		/* Control Properties */
		"application/vnd.ms-excel.controlproperties+xml": "TODO",
	
		/* Data Model */
		"application/vnd.openxmlformats-officedocument.model+data": "TODO",
	
		/* Survey */
		"application/vnd.ms-excel.Survey+xml": "TODO",
	
		/* Drawing */
		"application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
		"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
		"application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
	
		/* VML */
		"application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
	
		"application/vnd.openxmlformats-package.relationships+xml": "rels",
		"application/vnd.openxmlformats-officedocument.oleObject": "TODO",
	
		/* Image */
		"image/png": "TODO",
	
		"sheet": "js"
	});
	
	var CT_LIST = (function(){
		var o = {
			workbooks: {
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
				xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
				xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
				xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
				xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
			},
			strs: { /* Shared Strings */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
				xlsb: "application/vnd.ms-excel.sharedStrings"
			},
			comments: { /* Comments */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
				xlsb: "application/vnd.ms-excel.comments"
			},
			sheets: { /* Worksheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
				xlsb: "application/vnd.ms-excel.worksheet"
			},
			charts: { /* Chartsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
				xlsb: "application/vnd.ms-excel.chartsheet"
			},
			dialogs: { /* Dialogsheet */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
				xlsb: "application/vnd.ms-excel.dialogsheet"
			},
			macros: { /* Macrosheet (Excel 4.0 Macros) */
				xlsx: "application/vnd.ms-excel.macrosheet+xml",
				xlsb: "application/vnd.ms-excel.macrosheet"
			},
			styles: { /* Styles */
				xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
				xlsb: "application/vnd.ms-excel.styles"
			}
		};
		keys(o).forEach(function(k) { ["xlsm", "xlam"].forEach(function(v) { if(!o[k][v]) o[k][v] = o[k].xlsx; }); });
		keys(o).forEach(function(k){ keys(o[k]).forEach(function(v) { ct2type[o[k][v]] = k; }); });
		return o;
	})();
	
	var type2ct/*{[string]:Array<string>}*/ = evert_arr(ct2type);
	
	XMLNS.CT = 'http://schemas.openxmlformats.org/package/2006/content-types';
	
	function new_ct() {
		return ({
			workbooks:[], sheets:[], charts:[], dialogs:[], macros:[],
			rels:[], strs:[], comments:[], links:[],
			coreprops:[], extprops:[], custprops:[], themes:[], styles:[],
			calcchains:[], vba: [], drawings: [],
			TODO:[], xmlns: "" });
	}
	
	function parse_ct(data) {
		var ct = new_ct();
		if(!data || !data.match) return ct;
		var ctext = {};
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0].replace(nsregex,"<")) {
				case '<?xml': break;
				case '<Types': ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/)||["",""])[1] ]; break;
				case '<Default': ctext[y.Extension] = y.ContentType; break;
				case '<Override':
					if(ct[ct2type[y.ContentType]] !== undefined) ct[ct2type[y.ContentType]].push(y.PartName);
					break;
			}
		});
		if(ct.xmlns !== XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
		ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
		ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
		ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
		ct.defaults = ctext;
		delete ct.calcchains;
		return ct;
	}
	
	var CTYPE_XML_ROOT = writextag('Types', null, {
		'xmlns': XMLNS.CT,
		'xmlns:xsd': XMLNS.xsd,
		'xmlns:xsi': XMLNS.xsi
	});
	
	var CTYPE_DEFAULTS = [
		['xml', 'application/xml'],
		['bin', 'application/vnd.ms-excel.sheet.binary.macroEnabled.main'],
		['vml', 'application/vnd.openxmlformats-officedocument.vmlDrawing'],
		['data', 'application/vnd.openxmlformats-officedocument.model+data'],
		/* from test files */
		['bmp', 'image/bmp'],
		['png', 'image/png'],
		['gif', 'image/gif'],
		['emf', 'image/x-emf'],
		['wmf', 'image/x-wmf'],
		['jpg', 'image/jpeg'], ['jpeg', 'image/jpeg'],
		['tif', 'image/tiff'], ['tiff', 'image/tiff'],
		['pdf', 'application/pdf'],
		['rels', type2ct.rels[0]]
	].map(function(x) {
		return writextag('Default', null, {'Extension':x[0], 'ContentType': x[1]});
	});
	
	function write_ct(ct, opts) {
		var o = [], v;
		o[o.length] = (XML_HEADER);
		o[o.length] = (CTYPE_XML_ROOT);
		o = o.concat(CTYPE_DEFAULTS);
	
		/* only write first instance */
		var f1 = function(w) {
			if(ct[w] && ct[w].length > 0) {
				v = ct[w][0];
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
				}));
			}
		};
	
		/* book type-specific */
		var f2 = function(w) {
			(ct[w]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': CT_LIST[w][opts.bookType || 'xlsx']
				}));
			});
		};
	
		/* standard type */
		var f3 = function(t) {
			(ct[t]||[]).forEach(function(v) {
				o[o.length] = (writextag('Override', null, {
					'PartName': (v[0] == '/' ? "":"/") + v,
					'ContentType': type2ct[t][0]
				}));
			});
		};
	
		f1('workbooks');
		f2('sheets');
		f2('charts');
		f3('themes');
		['strs', 'styles'].forEach(f1);
		['coreprops', 'extprops', 'custprops'].forEach(f3);
		f3('vba');
		f3('comments');
		f3('drawings');
		if(o.length>2){ o[o.length] = ('</Types>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 9.3 Relationships */
	var RELS = ({
		WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
		HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
		VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
		XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
		XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
		XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
		CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
		CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
		VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
	});
	
	/* 9.3.3 Representing Relationships */
	function get_rels_path(file) {
		var n = file.lastIndexOf("/");
		return file.slice(0,n+1) + '_rels/' + file.slice(n+1) + ".rels";
	}
	
	function parse_rels(data, currentFilePath) {
		var rels = {"!id":{}};
		if (!data) return rels;
		if (currentFilePath.charAt(0) !== '/') {
			currentFilePath = '/'+currentFilePath;
		}
		var hash = {};
	
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			/* 9.3.2.2 OPC_Relationships */
			if (y[0] === '<Relationship') {
				var rel = {}; rel.Type = y.Type; rel.Target = y.Target; rel.Id = y.Id; if(y.TargetMode) rel.TargetMode = y.TargetMode;
				var canonictarget = y.TargetMode === 'External' ? y.Target : resolve_path(y.Target, currentFilePath);
				rels[canonictarget] = rel;
				hash[y.Id] = rel;
			}
		});
		rels["!id"] = hash;
		return rels;
	}
	
	XMLNS.RELS = 'http://schemas.openxmlformats.org/package/2006/relationships';
	
	var RELS_ROOT = writextag('Relationships', null, {
		//'xmlns:ns0': XMLNS.RELS,
		'xmlns': XMLNS.RELS
	});
	
	/* TODO */
	function write_rels(rels) {
		var o = [XML_HEADER, RELS_ROOT];
		keys(rels['!id']).forEach(function(rid) {
			o[o.length] = (writextag('Relationship', null, rels['!id'][rid]));
		});
		if(o.length>2){ o[o.length] = ('</Relationships>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	var RELS_EXTERN = [RELS.HLINK, RELS.XPATH, RELS.XMISS];
	function add_rels(rels, rId, f, type, relobj, targetmode) {
		if(!relobj) relobj = {};
		if(!rels['!id']) rels['!id'] = {};
		if(rId < 0) for(rId = 1; rels['!id']['rId' + rId]; ++rId){/* empty */}
		relobj.Id = 'rId' + rId;
		relobj.Type = type;
		relobj.Target = f;
		if(targetmode) relobj.TargetMode = targetmode;
		else if(RELS_EXTERN.indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
		if(rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
		rels['!id'][relobj.Id] = relobj;
		rels[('/' + relobj.Target).replace("//","/")] = relobj;
		return rId;
	}
	/* Open Document Format for Office Applications (OpenDocument) Version 1.2 */
	/* Part 3 Section 4 Manifest File */
	var CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
	function parse_manifest(d, opts) {
		var str = xlml_normalize(d);
		var Rn;
		var FEtag;
		while((Rn = xlmlregex.exec(str))) switch(Rn[3]) {
			case 'manifest': break; // 4.2 <manifest:manifest>
			case 'file-entry': // 4.3 <manifest:file-entry>
				FEtag = parsexmltag(Rn[0], false);
				if(FEtag.path == '/' && FEtag.type !== CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
				break;
			case 'encryption-data': // 4.4 <manifest:encryption-data>
			case 'algorithm': // 4.5 <manifest:algorithm>
			case 'start-key-generation': // 4.6 <manifest:start-key-generation>
			case 'key-derivation': // 4.7 <manifest:key-derivation>
				throw new Error("Unsupported ODS Encryption");
			default: if(opts && opts.WTF) throw Rn;
		}
	}
	
	function write_manifest(manifest) {
		var o = [XML_HEADER];
		o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
		o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
		for(var i = 0; i < manifest.length; ++i) o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
		o.push('</manifest:manifest>');
		return o.join("");
	}
	
	/* Part 3 Section 6 Metadata Manifest File */
	function write_rdf_type(file, res, tag) {
		return [
			'  <rdf:Description rdf:about="' + file + '">\n',
			'    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + '#' + res + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf_has(base, file) {
		return [
			'  <rdf:Description rdf:about="' + base + '">\n',
			'    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
			'  </rdf:Description>\n'
		].join("");
	}
	function write_rdf(rdf) {
		var o = [XML_HEADER];
		o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
		for(var i = 0; i != rdf.length; ++i) {
			o.push(write_rdf_type(rdf[i][0], rdf[i][1]));
			o.push(write_rdf_has("",rdf[i][0]));
		}
		o.push(write_rdf_type("","Document", "pkg"));
		o.push('</rdf:RDF>');
		return o.join("");
	}
	/* TODO: pull properties */
	var write_meta_ods = (function() {
		var payload = '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>Sheet' + 'JS ' + XLSX.version + '</meta:generator></office:meta></office:document-meta>';
		return function wmo() {
			return payload;
		};
	})();
	
	/* ECMA-376 Part II 11.1 Core Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var CORE_PROPS = [
		["cp:category", "Category"],
		["cp:contentStatus", "ContentStatus"],
		["cp:keywords", "Keywords"],
		["cp:lastModifiedBy", "LastAuthor"],
		["cp:lastPrinted", "LastPrinted"],
		["cp:revision", "RevNumber"],
		["cp:version", "Version"],
		["dc:creator", "Author"],
		["dc:description", "Comments"],
		["dc:identifier", "Identifier"],
		["dc:language", "Language"],
		["dc:subject", "Subject"],
		["dc:title", "Title"],
		["dcterms:created", "CreatedDate", 'date'],
		["dcterms:modified", "ModifiedDate", 'date']
	];
	
	XMLNS.CORE_PROPS = "http://schemas.openxmlformats.org/package/2006/metadata/core-properties";
	RELS.CORE_PROPS  = 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties';
	
	var CORE_PROPS_REGEX = (function() {
		var r = new Array(CORE_PROPS.length);
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var g = "(?:"+ f[0].slice(0,f[0].indexOf(":")) +":)"+ f[0].slice(f[0].indexOf(":")+1);
			r[i] = new RegExp("<" + g + "[^>]*>([\\s\\S]*?)<\/" + g + ">");
		}
		return r;
	})();
	
	function parse_core_props(data) {
		var p = {};
		data = utf8read(data);
	
		for(var i = 0; i < CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i], cur = data.match(CORE_PROPS_REGEX[i]);
			if(cur != null && cur.length > 0) p[f[1]] = unescapexml(cur[1]);
			if(f[2] === 'date' && p[f[1]]) p[f[1]] = parseDate(p[f[1]]);
		}
	
		return p;
	}
	
	var CORE_PROPS_XML_ROOT = writextag('cp:coreProperties', null, {
		//'xmlns': XMLNS.CORE_PROPS,
		'xmlns:cp': XMLNS.CORE_PROPS,
		'xmlns:dc': XMLNS.dc,
		'xmlns:dcterms': XMLNS.dcterms,
		'xmlns:dcmitype': XMLNS.dcmitype,
		'xmlns:xsi': XMLNS.xsi
	});
	
	function cp_doit(f, g, h, o, p) {
		if(p[f] != null || g == null || g === "") return;
		p[f] = g;
		g = escapexml(g);
		o[o.length] = (h ? writextag(f,g,h) : writetag(f,g));
	}
	
	function write_core_props(cp, _opts) {
		var opts = _opts || {};
		var o = [XML_HEADER, CORE_PROPS_XML_ROOT], p = {};
		if(!cp && !opts.Props) return o.join("");
	
		if(cp) {
			if(cp.CreatedDate != null) cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : write_w3cdtf(cp.CreatedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
			if(cp.ModifiedDate != null) cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : write_w3cdtf(cp.ModifiedDate, opts.WTF), {"xsi:type":"dcterms:W3CDTF"}, o, p);
		}
	
		for(var i = 0; i != CORE_PROPS.length; ++i) {
			var f = CORE_PROPS[i];
			var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
			if(v === true) v = "1";
			else if(v === false) v = "0";
			else if(typeof v == "number") v = String(v);
			if(v != null) cp_doit(f[0], v, null, o, p);
		}
		if(o.length>2){ o[o.length] = ('</cp:coreProperties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.3 Extended File Properties Part */
	/* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */
	var EXT_PROPS = [
		["Application", "Application", "string"],
		["AppVersion", "AppVersion", "string"],
		["Company", "Company", "string"],
		["DocSecurity", "DocSecurity", "string"],
		["Manager", "Manager", "string"],
		["HyperlinksChanged", "HyperlinksChanged", "bool"],
		["SharedDoc", "SharedDoc", "bool"],
		["LinksUpToDate", "LinksUpToDate", "bool"],
		["ScaleCrop", "ScaleCrop", "bool"],
		["HeadingPairs", "HeadingPairs", "raw"],
		["TitlesOfParts", "TitlesOfParts", "raw"]
	];
	
	XMLNS.EXT_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties";
	RELS.EXT_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties';
	
	var PseudoPropsPairs = [
		"Worksheets",  "SheetNames",
		"NamedRanges", "DefinedNames",
		"Chartsheets", "ChartNames"
	];
	function load_props_pairs(HP, TOP, props, opts) {
		var v = [];
		if(typeof HP == "string") v = parseVector(HP, opts);
		else for(var j = 0; j < HP.length; ++j) v = v.concat(HP[j].map(function(hp) { return {v:hp}; }));
		var parts = (typeof TOP == "string") ? parseVector(TOP, opts).map(function (x) { return x.v; }) : TOP;
		var idx = 0, len = 0;
		if(parts.length > 0) for(var i = 0; i !== v.length; i += 2) {
			len = +(v[i+1].v);
			switch(v[i].v) {
				case "Worksheets":
				case "工作表":
				case "Листы":
				case "أوراق العمل":
				case "ワークシート":
				case "גליונות עבודה":
				case "Arbeitsblätter":
				case "Çalışma Sayfaları":
				case "Feuilles de calcul":
				case "Fogli di lavoro":
				case "Folhas de cálculo":
				case "Planilhas":
				case "Regneark":
				case "Hojas de cálculo":
				case "Werkbladen":
					props.Worksheets = len;
					props.SheetNames = parts.slice(idx, idx + len);
					break;
	
				case "Named Ranges":
				case "Rangos con nombre":
				case "名前付き一覧":
				case "Benannte Bereiche":
				case "Navngivne områder":
					props.NamedRanges = len;
					props.DefinedNames = parts.slice(idx, idx + len);
					break;
	
				case "Charts":
				case "Diagramme":
					props.Chartsheets = len;
					props.ChartNames = parts.slice(idx, idx + len);
					break;
			}
			idx += len;
		}
	}
	
	function parse_ext_props(data, p, opts) {
		var q = {}; if(!p) p = {};
		data = utf8read(data);
	
		EXT_PROPS.forEach(function(f) {
			var xml = (data.match(matchtag(f[0]))||[])[1];
			switch(f[2]) {
				case "string": if(xml) p[f[1]] = unescapexml(xml); break;
				case "bool": p[f[1]] = xml === "true"; break;
				case "raw":
					var cur = data.match(new RegExp("<" + f[0] + "[^>]*>([\\s\\S]*?)<\/" + f[0] + ">"));
					if(cur && cur.length > 0) q[f[1]] = cur[1];
					break;
			}
		});
	
		if(q.HeadingPairs && q.TitlesOfParts) load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
	
		return p;
	}
	
	var EXT_PROPS_XML_ROOT = writextag('Properties', null, {
		'xmlns': XMLNS.EXT_PROPS,
		'xmlns:vt': XMLNS.vt
	});
	
	function write_ext_props(cp) {
		var o = [], W = writextag;
		if(!cp) cp = {};
		cp.Application = "SheetJS";
		o[o.length] = (XML_HEADER);
		o[o.length] = (EXT_PROPS_XML_ROOT);
	
		EXT_PROPS.forEach(function(f) {
			if(cp[f[1]] === undefined) return;
			var v;
			switch(f[2]) {
				case 'string': v = escapexml(String(cp[f[1]])); break;
				case 'bool': v = cp[f[1]] ? 'true' : 'false'; break;
			}
			if(v !== undefined) o[o.length] = (W(f[0], v));
		});
	
		/* TODO: HeadingPairs, TitlesOfParts */
		o[o.length] = (W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>')+W('vt:variant', W('vt:i4', String(cp.Worksheets))), {size:2, baseType:"variant"})));
		o[o.length] = (W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) { return "<vt:lpstr>" + escapexml(s) + "</vt:lpstr>"; }).join(""), {size: cp.Worksheets, baseType:"lpstr"})));
		if(o.length>2){ o[o.length] = ('</Properties>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* 15.2.12.2 Custom File Properties Part */
	XMLNS.CUST_PROPS = "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties";
	RELS.CUST_PROPS  = 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties';
	
	var custregex = /<[^>]+>[^<]*/g;
	function parse_cust_props(data, opts) {
		var p = {}, name = "";
		var m = data.match(custregex);
		if(m) for(var i = 0; i != m.length; ++i) {
			var x = m[i], y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				case '<Properties': break;
				case '<property': name = unescapexml(y.name); break;
				case '</property>': name = null; break;
				default: if (x.indexOf('<vt:') === 0) {
					var toks = x.split('>');
					var type = toks[0].slice(4), text = toks[1];
					/* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */
					switch(type) {
						case 'lpstr': case 'bstr': case 'lpwstr':
							p[name] = unescapexml(text);
							break;
						case 'bool':
							p[name] = parsexmlbool(text);
							break;
						case 'i1': case 'i2': case 'i4': case 'i8': case 'int': case 'uint':
							p[name] = parseInt(text, 10);
							break;
						case 'r4': case 'r8': case 'decimal':
							p[name] = parseFloat(text);
							break;
						case 'filetime': case 'date':
							p[name] = parseDate(text);
							break;
						case 'cy': case 'error':
							p[name] = unescapexml(text);
							break;
						default:
							if(type.slice(-1) == '/') break;
							if(opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
					}
				} else if(x.slice(0,2) === "</") {/* empty */
				} else if(opts.WTF) throw new Error(x);
			}
		}
		return p;
	}
	
	var CUST_PROPS_XML_ROOT = writextag('Properties', null, {
		'xmlns': XMLNS.CUST_PROPS,
		'xmlns:vt': XMLNS.vt
	});
	
	function write_cust_props(cp) {
		var o = [XML_HEADER, CUST_PROPS_XML_ROOT];
		if(!cp) return o.join("");
		var pid = 1;
		keys(cp).forEach(function custprop(k) { ++pid;
			o[o.length] = (writextag('property', write_vt(cp[k], true), {
				'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
				'pid': pid,
				'name': escapexml(k)
			}));
		});
		if(o.length>2){ o[o.length] = '</Properties>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* Common Name -> XLML Name */
	var XLMLDocPropsMap = {
		Title: 'Title',
		Subject: 'Subject',
		Author: 'Author',
		Keywords: 'Keywords',
		Comments: 'Description',
		LastAuthor: 'LastAuthor',
		RevNumber: 'Revision',
		Application: 'AppName',
		/* TotalTime: 'TotalTime', */
		LastPrinted: 'LastPrinted',
		CreatedDate: 'Created',
		ModifiedDate: 'LastSaved',
		/* Pages */
		/* Words */
		/* Characters */
		Category: 'Category',
		/* PresentationFormat */
		Manager: 'Manager',
		Company: 'Company',
		/* Guid */
		/* HyperlinkBase */
		/* Bytes */
		/* Lines */
		/* Paragraphs */
		/* CharactersWithSpaces */
		AppVersion: 'Version',
	
		ContentStatus: 'ContentStatus', /* NOTE: missing from schema */
		Identifier: 'Identifier', /* NOTE: missing from schema */
		Language: 'Language' /* NOTE: missing from schema */
	};
	var evert_XLMLDPM = evert(XLMLDocPropsMap);
	
	function xlml_set_prop(Props, tag, val) {
		tag = evert_XLMLDPM[tag] || tag;
		Props[tag] = val;
	}
	
	function xlml_write_docprops(Props, opts) {
		var o = [];
		keys(XLMLDocPropsMap).map(function(m) {
			for(var i = 0; i < CORE_PROPS.length; ++i) if(CORE_PROPS[i][1] == m) return CORE_PROPS[i];
			for(i = 0; i < EXT_PROPS.length; ++i) if(EXT_PROPS[i][1] == m) return EXT_PROPS[i];
			throw m;
		}).forEach(function(p) {
			if(Props[p[1]] == null) return;
			var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
			switch(p[2]) {
				case 'date': m = new Date(m).toISOString().replace(/\.\d*Z/,"Z"); break;
			}
			if(typeof m == 'number') m = String(m);
			else if(m === true || m === false) { m = m ? "1" : "0"; }
			else if(m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/,"");
			o.push(writetag(XLMLDocPropsMap[p[1]] || p[1], m));
		});
		return writextag('DocumentProperties', o.join(""), {xmlns:XLMLNS.o });
	}
	function xlml_write_custprops(Props, Custprops) {
		var BLACKLIST = ["Worksheets","SheetNames"];
		var T = 'CustomDocumentProperties';
		var o = [];
		if(Props) keys(Props).forEach(function(k) {
	if(!Object.prototype.hasOwnProperty.call(Props, k)) return;
			for(var i = 0; i < CORE_PROPS.length; ++i) if(k == CORE_PROPS[i][1]) return;
			for(i = 0; i < EXT_PROPS.length; ++i) if(k == EXT_PROPS[i][1]) return;
			for(i = 0; i < BLACKLIST.length; ++i) if(k == BLACKLIST[i]) return;
	
			var m = Props[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		if(Custprops) keys(Custprops).forEach(function(k) {
	if(!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
			if(Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
			var m = Custprops[k];
			var t = "string";
			if(typeof m == 'number') { t = "float"; m = String(m); }
			else if(m === true || m === false) { t = "boolean"; m = m ? "1" : "0"; }
			else if(m instanceof Date) { t = "dateTime.tz"; m = m.toISOString(); }
			else m = String(m);
			o.push(writextag(escapexmltag(k), m, {"dt:dt":t}));
		});
		return '<' + T + ' xmlns="' + XLMLNS.o + '">' + o.join("") + '</' + T + '>';
	}
	/* [MS-DTYP] 2.3.3 FILETIME */
	/* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */
	/* [MS-OLEPS] 2.8 FILETIME (Packet Version) */
	function parse_FILETIME(blob) {
		var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
		return new Date(((dwHighDateTime/1e7*Math.pow(2,32) + dwLowDateTime/1e7) - 11644473600)*1000).toISOString().replace(/\.000/,"");
	}
	function write_FILETIME(time) {
		var date = (typeof time == "string") ? new Date(Date.parse(time)) : time;
		var t = date.getTime() / 1000 + 11644473600;
		var l = t % Math.pow(2,32), h = (t - l) / Math.pow(2,32);
		l *= 1e7; h *= 1e7;
		var w = (l / Math.pow(2,32)) | 0;
		if(w > 0) { l = l % Math.pow(2,32); h += w; }
		var o = new_buf(8); o.write_shift(4, l); o.write_shift(4, h); return o;
	}
	
	/* [MS-OSHARED] 2.3.3.1.4 Lpstr */
	function parse_lpstr(blob, type, pad) {
		var start = blob.l;
		var str = blob.read_shift(0, 'lpstr-cp');
		if(pad) while((blob.l - start) & 3) ++blob.l;
		return str;
	}
	
	/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */
	function parse_lpwstr(blob, type, pad) {
		var str = blob.read_shift(0, 'lpwstr');
		if(pad) blob.l += (4 - ((str.length+1) & 3)) & 3;
		return str;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.11 VtString */
	/* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */
	function parse_VtStringBase(blob, stringType, pad) {
		if(stringType === 0x1F /*VT_LPWSTR*/) return parse_lpwstr(blob);
		return parse_lpstr(blob, stringType, pad);
	}
	
	function parse_VtString(blob, t, pad) { return parse_VtStringBase(blob, t, pad === false ? 0: 4); }
	function parse_VtUnalignedString(blob, t) { if(!t) throw new Error("VtUnalignedString must have positive length"); return parse_VtStringBase(blob, t, 0); }
	
	/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */
	function parse_VtVecLpwstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) {
			var start = blob.l;
			ret[i] = blob.read_shift(0, 'lpwstr').replace(chr0,'');
			if((blob.l - start) & 0x02) blob.l += 2;
		}
		return ret;
	}
	
	/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */
	function parse_VtVecUnalignedLpstrValue(blob) {
		var length = blob.read_shift(4);
		var ret = [];
		for(var i = 0; i != length; ++i) ret[i] = blob.read_shift(0, 'lpstr-cp').replace(chr0,'');
		return ret;
	}
	
	
	/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */
	function parse_VtHeadingPair(blob) {
		var start = blob.l;
		var headingString = parse_TypedPropertyValue(blob, VT_USTR);
		if(blob[blob.l] == 0x00 && blob[blob.l+1] == 0x00 && ((blob.l - start) & 0x02)) blob.l += 2;
		var headerParts = parse_TypedPropertyValue(blob, VT_I4);
		return [headingString, headerParts];
	}
	
	/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */
	function parse_VtVecHeadingPairValue(blob) {
		var cElements = blob.read_shift(4);
		var out = [];
		for(var i = 0; i < cElements / 2; ++i) out.push(parse_VtHeadingPair(blob));
		return out;
	}
	
	/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */
	function parse_dictionary(blob,CodePage) {
		var cnt = blob.read_shift(4);
		var dict = ({});
		for(var j = 0; j != cnt; ++j) {
			var pid = blob.read_shift(4);
			var len = blob.read_shift(4);
			dict[pid] = blob.read_shift(len, (CodePage === 0x4B0 ?'utf16le':'utf8')).replace(chr0,'').replace(chr1,'!');
			if(CodePage === 0x4B0 && (len % 2)) blob.l += 2;
		}
		if(blob.l & 3) blob.l = (blob.l>>2+1)<<2;
		return dict;
	}
	
	/* [MS-OLEPS] 2.9 BLOB */
	function parse_BLOB(blob) {
		var size = blob.read_shift(4);
		var bytes = blob.slice(blob.l,blob.l+size);
		blob.l += size;
		if((size & 3) > 0) blob.l += (4 - (size & 3)) & 3;
		return bytes;
	}
	
	/* [MS-OLEPS] 2.11 ClipboardData */
	function parse_ClipboardData(blob) {
		// TODO
		var o = {};
		o.Size = blob.read_shift(4);
		//o.Format = blob.read_shift(4);
		blob.l += o.Size + 3 - (o.Size - 1) % 4;
		return o;
	}
	
	/* [MS-OLEPS] 2.15 TypedPropertyValue */
	function parse_TypedPropertyValue(blob, type, _opts) {
		var t = blob.read_shift(2), ret, opts = _opts||{};
		blob.l += 2;
		if(type !== VT_VARIANT)
		if(t !== type && VT_CUSTOM.indexOf(type)===-1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
		switch(type === VT_VARIANT ? t : type) {
			case 0x02 /*VT_I2*/: ret = blob.read_shift(2, 'i'); if(!opts.raw) blob.l += 2; return ret;
			case 0x03 /*VT_I4*/: ret = blob.read_shift(4, 'i'); return ret;
			case 0x0B /*VT_BOOL*/: return blob.read_shift(4) !== 0x0;
			case 0x13 /*VT_UI4*/: ret = blob.read_shift(4); return ret;
			case 0x1E /*VT_LPSTR*/: return parse_lpstr(blob, t, 4).replace(chr0,'');
			case 0x1F /*VT_LPWSTR*/: return parse_lpwstr(blob);
			case 0x40 /*VT_FILETIME*/: return parse_FILETIME(blob);
			case 0x41 /*VT_BLOB*/: return parse_BLOB(blob);
			case 0x47 /*VT_CF*/: return parse_ClipboardData(blob);
			case 0x50 /*VT_STRING*/: return parse_VtString(blob, t, !opts.raw).replace(chr0,'');
			case 0x51 /*VT_USTR*/: return parse_VtUnalignedString(blob, t/*, 4*/).replace(chr0,'');
			case 0x100C /*VT_VECTOR|VT_VARIANT*/: return parse_VtVecHeadingPairValue(blob);
			case 0x101E /*VT_VECTOR|VT_LPSTR*/:
			case 0x101F /*VT_VECTOR|VT_LPWSTR*/:
				return t == 0x101F ? parse_VtVecLpwstrValue(blob) : parse_VtVecUnalignedLpstrValue(blob);
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
		}
	}
	function write_TypedPropertyValue(type, value) {
		var o = new_buf(4), p = new_buf(4);
		o.write_shift(4, type == 0x50 ? 0x1F : type);
		switch(type) {
			case 0x03 /*VT_I4*/: p.write_shift(-4, value); break;
			case 0x05 /*VT_I4*/: p = new_buf(8); p.write_shift(8, value, 'f'); break;
			case 0x0B /*VT_BOOL*/: p.write_shift(4, value ? 0x01 : 0x00); break;
			case 0x40 /*VT_FILETIME*/:  p = write_FILETIME(value); break;
			case 0x1F /*VT_LPWSTR*/:
			case 0x50 /*VT_STRING*/:
	p = new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
				p.write_shift(4, value.length + 1);
				p.write_shift(0, value, "dbcs");
				while(p.l != p.length) p.write_shift(1, 0);
				break;
			default: throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
		}
		return bconcat([o, p]);
	}
	
	/* [MS-OLEPS] 2.20 PropertySet */
	function parse_PropertySet(blob, PIDSI) {
		var start_addr = blob.l;
		var size = blob.read_shift(4);
		var NumProps = blob.read_shift(4);
		var Props = [], i = 0;
		var CodePage = 0;
		var Dictionary = -1, DictObj = ({});
		for(i = 0; i != NumProps; ++i) {
			var PropID = blob.read_shift(4);
			var Offset = blob.read_shift(4);
			Props[i] = [PropID, Offset + start_addr];
		}
		Props.sort(function(x,y) { return x[1] - y[1]; });
		var PropH = {};
		for(i = 0; i != NumProps; ++i) {
			if(blob.l !== Props[i][1]) {
				var fail = true;
				if(i>0 && PIDSI) switch(PIDSI[Props[i-1][0]].t) {
					case 0x02 /*VT_I2*/: if(blob.l+2 === Props[i][1]) { blob.l+=2; fail = false; } break;
					case 0x50 /*VT_STRING*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
					case 0x100C /*VT_VECTOR|VT_VARIANT*/: if(blob.l <= Props[i][1]) { blob.l=Props[i][1]; fail = false; } break;
				}
				if((!PIDSI||i==0) && blob.l <= Props[i][1]) { fail=false; blob.l = Props[i][1]; }
				if(fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
			}
			if(PIDSI) {
				var piddsi = PIDSI[Props[i][0]];
				PropH[piddsi.n] = parse_TypedPropertyValue(blob, piddsi.t, {raw:true});
				if(piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
				if(piddsi.n == "CodePage") switch(PropH[piddsi.n]) {
					case 0: PropH[piddsi.n] = 1252;
						/* falls through */
					case 874:
					case 932:
					case 936:
					case 949:
					case 950:
					case 1250:
					case 1251:
					case 1253:
					case 1254:
					case 1255:
					case 1256:
					case 1257:
					case 1258:
					case 10000:
					case 1200:
					case 1201:
					case 1252:
					case 65000: case -536:
					case 65001: case -535:
						set_cp(CodePage = (PropH[piddsi.n]>>>0) & 0xFFFF); break;
					default: throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
				}
			} else {
				if(Props[i][0] === 0x1) {
					CodePage = PropH.CodePage = (parse_TypedPropertyValue(blob, VT_I2));
					set_cp(CodePage);
					if(Dictionary !== -1) {
						var oldpos = blob.l;
						blob.l = Props[Dictionary][1];
						DictObj = parse_dictionary(blob,CodePage);
						blob.l = oldpos;
					}
				} else if(Props[i][0] === 0) {
					if(CodePage === 0) { Dictionary = i; blob.l = Props[i+1][1]; continue; }
					DictObj = parse_dictionary(blob,CodePage);
				} else {
					var name = DictObj[Props[i][0]];
					var val;
					/* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */
					switch(blob[blob.l]) {
						case 0x41 /*VT_BLOB*/: blob.l += 4; val = parse_BLOB(blob); break;
						case 0x1E /*VT_LPSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
						case 0x1F /*VT_LPWSTR*/: blob.l += 4; val = parse_VtString(blob, blob[blob.l-4]).replace(/\u0000+$/,""); break;
						case 0x03 /*VT_I4*/: blob.l += 4; val = blob.read_shift(4, 'i'); break;
						case 0x13 /*VT_UI4*/: blob.l += 4; val = blob.read_shift(4); break;
						case 0x05 /*VT_R8*/: blob.l += 4; val = blob.read_shift(8, 'f'); break;
						case 0x0B /*VT_BOOL*/: blob.l += 4; val = parsebool(blob, 4); break;
						case 0x40 /*VT_FILETIME*/: blob.l += 4; val = parseDate(parse_FILETIME(blob)); break;
						default: throw new Error("unparsed value: " + blob[blob.l]);
					}
					PropH[name] = val;
				}
			}
		}
		blob.l = start_addr + size; /* step ahead to skip padding */
		return PropH;
	}
	var XLSPSSkip = [ "CodePage", "Thumbnail", "_PID_LINKBASE", "_PID_HLINKS", "SystemIdentifier", "FMTID" ].concat(PseudoPropsPairs);
	function guess_property_type(val) {
		switch(typeof val) {
			case "boolean": return 0x0B;
			case "number": return ((val|0)==val) ? 0x03 : 0x05;
			case "string": return 0x1F;
			case "object": if(val instanceof Date) return 0x40; break;
		}
		return -1;
	}
	function write_PropertySet(entries, RE, PIDSI) {
		var hdr = new_buf(8), piao = [], prop = [];
		var sz = 8, i = 0;
	
		var pr = new_buf(8), pio = new_buf(8);
		pr.write_shift(4, 0x0002);
		pr.write_shift(4, 0x04B0);
		pio.write_shift(4, 0x0001);
		prop.push(pr); piao.push(pio);
		sz += 8 + pr.length;
	
		if(!RE) {
			pio = new_buf(8);
			pio.write_shift(4, 0);
			piao.unshift(pio);
	
			var bufs = [new_buf(4)];
			bufs[0].write_shift(4, entries.length);
			for(i = 0; i < entries.length; ++i) {
				var value = entries[i][0];
				pr = new_buf(4 + 4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
				pr.write_shift(4, i+2);
				pr.write_shift(4, value.length + 1);
				pr.write_shift(0, value, "dbcs");
				while(pr.l != pr.length) pr.write_shift(1, 0);
				bufs.push(pr);
			}
			pr = bconcat(bufs);
			prop.unshift(pr);
			sz += 8 + pr.length;
		}
	
		for(i = 0; i < entries.length; ++i) {
			if(RE && !RE[entries[i][0]]) continue;
			if(XLSPSSkip.indexOf(entries[i][0]) > -1) continue;
			if(entries[i][1] == null) continue;
	
			var val = entries[i][1], idx = 0;
			if(RE) {
				idx = +RE[entries[i][0]];
				var pinfo = (PIDSI)[idx];
				if(pinfo.p == "version" && typeof val == "string") {
	var arr = val.split(".");
					val = ((+arr[0])<<16) + ((+arr[1])||0);
				}
				pr = write_TypedPropertyValue(pinfo.t, val);
			} else {
				var T = guess_property_type(val);
				if(T == -1) { T = 0x1F; val = String(val); }
				pr = write_TypedPropertyValue(T, val);
			}
			prop.push(pr);
	
			pio = new_buf(8);
			pio.write_shift(4, !RE ? 2+i : idx);
			piao.push(pio);
	
			sz += 8 + pr.length;
		}
	
		var w = 8 * (prop.length + 1);
		for(i = 0; i < prop.length; ++i) { piao[i].write_shift(4, w); w += prop[i].length; }
		hdr.write_shift(4, sz);
		hdr.write_shift(4, prop.length);
		return bconcat([hdr].concat(piao).concat(prop));
	}
	
	/* [MS-OLEPS] 2.21 PropertySetStream */
	function parse_PropertySetStream(file, PIDSI, clsid) {
		var blob = file.content;
		if(!blob) return ({});
		prep_blob(blob, 0);
	
		var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
		blob.chk('feff', 'Byte Order: ');
	
		/*var vers = */blob.read_shift(2); // TODO: check version
		var SystemIdentifier = blob.read_shift(4);
		var CLSID = blob.read_shift(16);
		if(CLSID !== CFB.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
		NumSets = blob.read_shift(4);
		if(NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
		FMTID0 = blob.read_shift(16); Offset0 = blob.read_shift(4);
	
		if(NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
		else if(NumSets === 2) { FMTID1 = blob.read_shift(16); Offset1 = blob.read_shift(4); }
		var PSet0 = parse_PropertySet(blob, PIDSI);
	
		var rval = ({ SystemIdentifier: SystemIdentifier });
		for(var y in PSet0) rval[y] = PSet0[y];
		//rval.blob = blob;
		rval.FMTID = FMTID0;
		//rval.PSet0 = PSet0;
		if(NumSets === 1) return rval;
		if(Offset1 - blob.l == 2) blob.l += 2;
		if(blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
		var PSet1;
		try { PSet1 = parse_PropertySet(blob, null); } catch(e) {/* empty */}
		for(y in PSet1) rval[y] = PSet1[y];
		rval.FMTID = [FMTID0, FMTID1]; // TODO: verify FMTID0/1
		return rval;
	}
	function write_PropertySetStream(entries, clsid, RE, PIDSI, entries2, clsid2) {
		var hdr = new_buf(entries2 ? 68 : 48);
		var bufs = [hdr];
		hdr.write_shift(2, 0xFFFE);
		hdr.write_shift(2, 0x0000); /* TODO: type 1 props */
		hdr.write_shift(4, 0x32363237);
		hdr.write_shift(16, CFB.utils.consts.HEADER_CLSID, "hex");
		hdr.write_shift(4, (entries2 ? 2 : 1));
		hdr.write_shift(16, clsid, "hex");
		hdr.write_shift(4, (entries2 ? 68 : 48));
		var ps0 = write_PropertySet(entries, RE, PIDSI);
		bufs.push(ps0);
	
		if(entries2) {
			var ps1 = write_PropertySet(entries2, null, null);
			hdr.write_shift(16, clsid2, "hex");
			hdr.write_shift(4, 68 + ps0.length);
			bufs.push(ps1);
		}
		return bconcat(bufs);
	}
	
	function parsenoop2(blob, length) { blob.read_shift(length); return null; }
	function writezeroes(n, o) { if(!o) o=new_buf(n); for(var j=0; j<n; ++j) o.write_shift(1, 0); return o; }
	
	function parslurp(blob, length, cb) {
		var arr = [], target = blob.l + length;
		while(blob.l < target) arr.push(cb(blob, target - blob.l));
		if(target !== blob.l) throw new Error("Slurp error");
		return arr;
	}
	
	function parsebool(blob, length) { return blob.read_shift(length) === 0x1; }
	function writebool(v, o) { if(!o) o=new_buf(2); o.write_shift(2, +!!v); return o; }
	
	function parseuint16(blob) { return blob.read_shift(2, 'u'); }
	function writeuint16(v, o) { if(!o) o=new_buf(2); o.write_shift(2, v); return o; }
	function parseuint16a(blob, length) { return parslurp(blob,length,parseuint16);}
	
	/* --- 2.5 Structures --- */
	
	/* [MS-XLS] 2.5.10 Bes (boolean or error) */
	function parse_Bes(blob) {
		var v = blob.read_shift(1), t = blob.read_shift(1);
		return t === 0x01 ? v : v === 0x01;
	}
	function write_Bes(v, t, o) {
		if(!o) o = new_buf(2);
		o.write_shift(1, ((t == 'e') ? +v : +!!v));
		o.write_shift(1, ((t == 'e') ? 1 : 0));
		return o;
	}
	
	/* [MS-XLS] 2.5.240 ShortXLUnicodeString */
	function parse_ShortXLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
		var encoding = 'sbcs-cont';
		var cp = current_codepage;
		if(opts && opts.biff >= 8) current_codepage = 1200;
		if(!opts || opts.biff == 8 ) {
			var fHighByte = blob.read_shift(1);
			if(fHighByte) { encoding = 'dbcs-cont'; }
		} else if(opts.biff == 12) {
			encoding = 'wstr';
		}
		if(opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
		var o = cch ? blob.read_shift(cch, encoding) : "";
		current_codepage = cp;
		return o;
	}
	
	/* 2.5.293 XLUnicodeRichExtendedString */
	function parse_XLUnicodeRichExtendedString(blob) {
		var cp = current_codepage;
		current_codepage = 1200;
		var cch = blob.read_shift(2), flags = blob.read_shift(1);
		var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
		var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
		var cRun = 0, cbExtRst;
		var z = {};
		if(fRichSt) cRun = blob.read_shift(2);
		if(fExtSt) cbExtRst = blob.read_shift(4);
		var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
		var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
		if(fRichSt) blob.l += 4 * cRun; //TODO: parse this
		if(fExtSt) blob.l += cbExtRst; //TODO: parse this
		z.t = msg;
		if(!fRichSt) { z.raw = "<t>" + z.t + "</t>"; z.r = z.t; }
		current_codepage = cp;
		return z;
	}
	function write_XLUnicodeRichExtendedString(xlstr) {
		var str = (xlstr.t||""), nfmts = 1;
	
		var hdr = new_buf(3 + (nfmts > 1 ? 2 : 0));
		hdr.write_shift(2, str.length);
		hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
		if(nfmts > 1) hdr.write_shift(2, nfmts);
	
		var otext = new_buf(2 * str.length);
		otext.write_shift(2 * str.length, str, 'utf16le');
	
		var out = [hdr, otext];
	
		return bconcat(out);
	}
	
	/* 2.5.296 XLUnicodeStringNoCch */
	function parse_XLUnicodeStringNoCch(blob, cch, opts) {
		var retval;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
			if(opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
		}
		var fHighByte = blob.read_shift(1);
		if(fHighByte===0) { retval = blob.read_shift(cch, 'sbcs-cont'); }
		else { retval = blob.read_shift(cch, 'dbcs-cont'); }
		return retval;
	}
	
	/* 2.5.294 XLUnicodeString */
	function parse_XLUnicodeString(blob, length, opts) {
		var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		if(cch === 0) { blob.l++; return ""; }
		return parse_XLUnicodeStringNoCch(blob, cch, opts);
	}
	/* BIFF5 override */
	function parse_XLUnicodeString2(blob, length, opts) {
		if(opts.biff > 5) return parse_XLUnicodeString(blob, length, opts);
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, (opts.biff <= 4 || !blob.lens ) ? 'cpstr' : 'sbcs-cont');
	}
	/* TODO: BIFF5 and lower, codepage awareness */
	function write_XLUnicodeString(str, opts, o) {
		if(!o) o = new_buf(3 + 2 * str.length);
		o.write_shift(2, str.length);
		o.write_shift(1, 1);
		o.write_shift(31, str, 'utf16le');
		return o;
	}
	
	/* [MS-XLS] 2.5.61 ControlInfo */
	function parse_ControlInfo(blob) {
		var flags = blob.read_shift(1);
		blob.l++;
		var accel = blob.read_shift(2);
		blob.l += 2;
		return [flags, accel];
	}
	
	/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */
	function parse_URLMoniker(blob) {
		var len = blob.read_shift(4), start = blob.l;
		var extra = false;
		if(len > 24) {
			/* look ahead */
			blob.l += len - 24;
			if(blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
			blob.l = start;
		}
		var url = blob.read_shift((extra?len-24:len)>>1, 'utf16le').replace(chr0,"");
		if(extra) blob.l += 24;
		return url;
	}
	
	/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */
	function parse_FileMoniker(blob) {
		var cAnti = blob.read_shift(2);
		var preamble = ""; while(cAnti-- > 0) preamble += "../";
		var ansiPath = blob.read_shift(0, 'lpstr-ansi');
		blob.l += 2; //var endServer = blob.read_shift(2);
		if(blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
		var sz = blob.read_shift(4);
		if(sz === 0) return preamble + ansiPath.replace(/\\/g,"/");
		var bytes = blob.read_shift(4);
		if(blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
		var unicodePath = blob.read_shift(bytes>>1, 'utf16le').replace(chr0,"");
		return preamble + unicodePath;
	}
	
	/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */
	function parse_HyperlinkMoniker(blob, length) {
		var clsid = blob.read_shift(16); length -= 16;
		switch(clsid) {
			case "e0c9ea79f9bace118c8200aa004ba90b": return parse_URLMoniker(blob, length);
			case "0303000000000000c000000000000046": return parse_FileMoniker(blob, length);
			default: throw new Error("Unsupported Moniker " + clsid);
		}
	}
	
	/* [MS-OSHARED] 2.3.7.9 HyperlinkString */
	function parse_HyperlinkString(blob) {
		var len = blob.read_shift(4);
		var o = len > 0 ? blob.read_shift(len, 'utf16le').replace(chr0, "") : "";
		return o;
	}
	function write_HyperlinkString(str, o) {
		if(!o) o = new_buf(6 + str.length * 2);
		o.write_shift(4, 1 + str.length);
		for(var i = 0; i < str.length; ++i) o.write_shift(2, str.charCodeAt(i));
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */
	function parse_Hyperlink(blob, length) {
		var end = blob.l + length;
		var sVer = blob.read_shift(4);
		if(sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
		var flags = blob.read_shift(2);
		blob.l += 2;
		var displayName, targetFrameName, moniker, oleMoniker, Loc="", guid, fileTime;
		if(flags & 0x0010) displayName = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0080) targetFrameName = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0101) moniker = parse_HyperlinkString(blob, end - blob.l);
		if((flags & 0x0101) === 0x0001) oleMoniker = parse_HyperlinkMoniker(blob, end - blob.l);
		if(flags & 0x0008) Loc = parse_HyperlinkString(blob, end - blob.l);
		if(flags & 0x0020) guid = blob.read_shift(16);
		if(flags & 0x0040) fileTime = parse_FILETIME(blob/*, 8*/);
		blob.l = end;
		var target = targetFrameName||moniker||oleMoniker||"";
		if(target && Loc) target+="#"+Loc;
		if(!target) target = "#" + Loc;
		if((flags & 0x0002) && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
		var out = ({Target:target});
		if(guid) out.guid = guid;
		if(fileTime) out.time = fileTime;
		if(displayName) out.Tooltip = displayName;
		return out;
	}
	function write_Hyperlink(hl) {
		var out = new_buf(512), i = 0;
		var Target = hl.Target;
		if(Target.slice(0,7) == "file://") Target = Target.slice(7);
		var hashidx = Target.indexOf("#");
		var F = hashidx > -1 ? 0x1f : 0x17;
		switch(Target.charAt(0)) { case "#": F=0x1c; break; case ".": F&=~2; break; }
		out.write_shift(4,2); out.write_shift(4, F);
		var data = [8,6815827,6619237,4849780,83]; for(i = 0; i < data.length; ++i) out.write_shift(4, data[i]);
		if(F == 0x1C) {
			Target = Target.slice(1);
			write_HyperlinkString(Target, out);
		} else if(F & 0x02) {
			data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
			out.write_shift(4, 2*(Pretarget.length + 1));
			for(i = 0; i < Pretarget.length; ++i) out.write_shift(2, Pretarget.charCodeAt(i));
			out.write_shift(2, 0);
			if(F & 0x08) write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx+1): "", out);
		} else {
			data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
			for(i = 0; i < data.length; ++i) out.write_shift(1, parseInt(data[i], 16));
			var P = 0;
			while(Target.slice(P*3,P*3+3)=="../"||Target.slice(P*3,P*3+3)=="..\\") ++P;
			out.write_shift(2, P);
			out.write_shift(4, Target.length - 3 * P + 1);
			for(i = 0; i < Target.length - 3 * P; ++i) out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
			out.write_shift(1, 0);
			out.write_shift(2, 0xFFFF);
			out.write_shift(2, 0xDEAD);
			for(i = 0; i < 6; ++i) out.write_shift(4, 0);
		}
		return out.slice(0, out.l);
	}
	
	/* 2.5.178 LongRGBA */
	function parse_LongRGBA(blob) { var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1); return [r,g,b,a]; }
	
	/* 2.5.177 LongRGB */
	function parse_LongRGB(blob, length) { var x = parse_LongRGBA(blob, length); x[3] = 0; return x; }
	
	
	/* [MS-XLS] 2.5.19 */
	function parse_XLSCell(blob) {
		var rw = blob.read_shift(2); // 0-indexed
		var col = blob.read_shift(2);
		var ixfe = blob.read_shift(2);
		return ({r:rw, c:col, ixfe:ixfe});
	}
	function write_XLSCell(R, C, ixfe, o) {
		if(!o) o = new_buf(6);
		o.write_shift(2, R);
		o.write_shift(2, C);
		o.write_shift(2, ixfe||0);
		return o;
	}
	
	/* [MS-XLS] 2.5.134 */
	function parse_frtHeader(blob) {
		var rt = blob.read_shift(2);
		var flags = blob.read_shift(2); // TODO: parse these flags
		blob.l += 8;
		return {type: rt, flags: flags};
	}
	
	
	
	function parse_OptXLUnicodeString(blob, length, opts) { return length === 0 ? "" : parse_XLUnicodeString2(blob, length, opts); }
	
	/* [MS-XLS] 2.5.344 */
	function parse_XTI(blob, length, opts) {
		var w = opts.biff > 8 ? 4 : 2;
		var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w,'i'), itabLast = blob.read_shift(w,'i');
		return [iSupBook, itabFirst, itabLast];
	}
	
	/* [MS-XLS] 2.5.218 */
	function parse_RkRec(blob) {
		var ixfe = blob.read_shift(2);
		var RK = parse_RkNumber(blob);
		return [ixfe, RK];
	}
	
	/* [MS-XLS] 2.5.1 */
	function parse_AddinUdf(blob, length, opts) {
		blob.l += 4; length -= 4;
		var l = blob.l + length;
		var udfName = parse_ShortXLUnicodeString(blob, length, opts);
		var cb = blob.read_shift(2);
		l -= blob.l;
		if(cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
		blob.l += cb;
		return udfName;
	}
	
	/* [MS-XLS] 2.5.209 TODO: Check sizes */
	function parse_Ref8U(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(2);
		var colLast = blob.read_shift(2);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	function write_Ref8U(r, o) {
		if(!o) o = new_buf(8);
		o.write_shift(2, r.s.r);
		o.write_shift(2, r.e.r);
		o.write_shift(2, r.s.c);
		o.write_shift(2, r.e.c);
		return o;
	}
	
	/* [MS-XLS] 2.5.211 */
	function parse_RefU(blob) {
		var rwFirst = blob.read_shift(2);
		var rwLast = blob.read_shift(2);
		var colFirst = blob.read_shift(1);
		var colLast = blob.read_shift(1);
		return {s:{c:colFirst, r:rwFirst}, e:{c:colLast,r:rwLast}};
	}
	
	/* [MS-XLS] 2.5.207 */
	var parse_Ref = parse_RefU;
	
	/* [MS-XLS] 2.5.143 */
	function parse_FtCmo(blob) {
		blob.l += 4;
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var flags = blob.read_shift(2);
		blob.l+=12;
		return [id, ot, flags];
	}
	
	/* [MS-XLS] 2.5.149 */
	function parse_FtNts(blob) {
		var out = {};
		blob.l += 4;
		blob.l += 16; // GUID TODO
		out.fSharedNote = blob.read_shift(2);
		blob.l += 4;
		return out;
	}
	
	/* [MS-XLS] 2.5.142 */
	function parse_FtCf(blob) {
		var out = {};
		blob.l += 4;
		blob.cf = blob.read_shift(2);
		return out;
	}
	
	/* [MS-XLS] 2.5.140 - 2.5.154 and friends */
	function parse_FtSkip(blob) { blob.l += 2; blob.l += blob.read_shift(2); }
	var FtTab = {
	0x00: parse_FtSkip,      /* FtEnd */
	0x04: parse_FtSkip,      /* FtMacro */
	0x05: parse_FtSkip,      /* FtButton */
	0x06: parse_FtSkip,      /* FtGmo */
	0x07: parse_FtCf,        /* FtCf */
	0x08: parse_FtSkip,      /* FtPioGrbit */
	0x09: parse_FtSkip,      /* FtPictFmla */
	0x0A: parse_FtSkip,      /* FtCbls */
	0x0B: parse_FtSkip,      /* FtRbo */
	0x0C: parse_FtSkip,      /* FtSbs */
	0x0D: parse_FtNts,       /* FtNts */
	0x0E: parse_FtSkip,      /* FtSbsFmla */
	0x0F: parse_FtSkip,      /* FtGboData */
	0x10: parse_FtSkip,      /* FtEdoData */
	0x11: parse_FtSkip,      /* FtRboData */
	0x12: parse_FtSkip,      /* FtCblsData */
	0x13: parse_FtSkip,      /* FtLbsData */
	0x14: parse_FtSkip,      /* FtCblsFmla */
	0x15: parse_FtCmo
	};
	function parse_FtArray(blob, length) {
		var tgt = blob.l + length;
		var fts = [];
		while(blob.l < tgt) {
			var ft = blob.read_shift(2);
			blob.l-=2;
			try {
				fts.push(FtTab[ft](blob, tgt - blob.l));
			} catch(e) { blob.l = tgt; return fts; }
		}
		if(blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
		return fts;
	}
	
	/* --- 2.4 Records --- */
	
	/* [MS-XLS] 2.4.21 */
	function parse_BOF(blob, length) {
		var o = {BIFFVer:0, dt:0};
		o.BIFFVer = blob.read_shift(2); length -= 2;
		if(length >= 2) { o.dt = blob.read_shift(2); blob.l -= 2; }
		switch(o.BIFFVer) {
			case 0x0600: /* BIFF8 */
			case 0x0500: /* BIFF5 */
			case 0x0400: /* BIFF4 */
			case 0x0300: /* BIFF3 */
			case 0x0200: /* BIFF2 */
			case 0x0002: case 0x0007: /* BIFF2 */
				break;
			default: if(length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
		}
	
		blob.read_shift(length);
		return o;
	}
	function write_BOF(wb, t, o) {
		var h = 0x0600, w = 16;
		switch(o.bookType) {
			case 'biff8': break;
			case 'biff5': h = 0x0500; w = 8; break;
			case 'biff4': h = 0x0004; w = 6; break;
			case 'biff3': h = 0x0003; w = 6; break;
			case 'biff2': h = 0x0002; w = 4; break;
			case 'xla': break;
			default: throw new Error("unsupported BIFF version");
		}
		var out = new_buf(w);
		out.write_shift(2, h);
		out.write_shift(2, t);
		if(w > 4) out.write_shift(2, 0x7262);
		if(w > 6) out.write_shift(2, 0x07CD);
		if(w > 8) {
			out.write_shift(2, 0xC009);
			out.write_shift(2, 0x0001);
			out.write_shift(2, 0x0706);
			out.write_shift(2, 0x0000);
		}
		return out;
	}
	
	
	/* [MS-XLS] 2.4.146 */
	function parse_InterfaceHdr(blob, length) {
		if(length === 0) return 0x04b0;
		if((blob.read_shift(2))!==0x04b0){/* empty */}
		return 0x04b0;
	}
	
	
	/* [MS-XLS] 2.4.349 */
	function parse_WriteAccess(blob, length, opts) {
		if(opts.enc) { blob.l += length; return ""; }
		var l = blob.l;
		// TODO: make sure XLUnicodeString doesnt overrun
		var UserName = parse_XLUnicodeString2(blob, 0, opts);
		blob.read_shift(length + l - blob.l);
		return UserName;
	}
	function write_WriteAccess(s, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(b8 ? 112 : 54);
		o.write_shift(opts.biff == 8 ? 2 : 1, 7);
		if(b8) o.write_shift(1, 0);
		o.write_shift(4, 0x33336853);
		o.write_shift(4, (0x00534A74 | (b8 ? 0 : 0x20000000)));
		while(o.l < o.length) o.write_shift(1, (b8 ? 0 : 32));
		return o;
	}
	
	/* [MS-XLS] 2.4.351 */
	function parse_WsBool(blob, length, opts) {
		var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
		return { fDialog: flags & 0x10, fBelow: flags & 0x40, fRight: flags & 0x80 };
	}
	
	/* [MS-XLS] 2.4.28 */
	function parse_BoundSheet8(blob, length, opts) {
		var pos = blob.read_shift(4);
		var hidden = blob.read_shift(1) & 0x03;
		var dt = blob.read_shift(1);
		switch(dt) {
			case 0: dt = 'Worksheet'; break;
			case 1: dt = 'Macrosheet'; break;
			case 2: dt = 'Chartsheet'; break;
			case 6: dt = 'VBAModule'; break;
		}
		var name = parse_ShortXLUnicodeString(blob, 0, opts);
		if(name.length === 0) name = "Sheet1";
		return { pos:pos, hs:hidden, dt:dt, name:name };
	}
	function write_BoundSheet8(data, opts) {
		var w = (!opts || opts.biff >= 8 ? 2 : 1);
		var o = new_buf(8 + w * data.name.length);
		o.write_shift(4, data.pos);
		o.write_shift(1, data.hs || 0);
		o.write_shift(1, data.dt);
		o.write_shift(1, data.name.length);
		if(opts.biff >= 8) o.write_shift(1, 1);
		o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
		var out = o.slice(0, o.l);
		out.l = o.l; return out;
	}
	
	/* [MS-XLS] 2.4.265 TODO */
	function parse_SST(blob, length) {
		var end = blob.l + length;
		var cnt = blob.read_shift(4);
		var ucnt = blob.read_shift(4);
		var strs = ([]);
		for(var i = 0; i != ucnt && blob.l < end; ++i) {
			strs.push(parse_XLUnicodeRichExtendedString(blob));
		}
		strs.Count = cnt; strs.Unique = ucnt;
		return strs;
	}
	function write_SST(sst, opts) {
		var header = new_buf(8);
		header.write_shift(4, sst.Count);
		header.write_shift(4, sst.Unique);
		var strs = [];
		for(var j = 0; j < sst.length; ++j) strs[j] = write_XLUnicodeRichExtendedString(sst[j], opts);
		var o = bconcat([header].concat(strs));
	o.parts = [header.length].concat(strs.map(function(str) { return str.length; }));
		return o;
	}
	
	/* [MS-XLS] 2.4.107 */
	function parse_ExtSST(blob, length) {
		var extsst = {};
		extsst.dsst = blob.read_shift(2);
		blob.l += length-2;
		return extsst;
	}
	
	
	/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */
	function parse_Row(blob) {
		var z = ({});
		z.r = blob.read_shift(2);
		z.c = blob.read_shift(2);
		z.cnt = blob.read_shift(2) - z.c;
		var miyRw = blob.read_shift(2);
		blob.l += 4; // reserved(2), unused(2)
		var flags = blob.read_shift(1); // various flags
		blob.l += 3; // reserved(8), ixfe(12), flags(4)
		if(flags & 0x07) z.level = flags & 0x07;
		// collapsed: flags & 0x10
		if(flags & 0x20) z.hidden = true;
		if(flags & 0x40) z.hpt = miyRw / 20;
		return z;
	}
	
	
	/* [MS-XLS] 2.4.125 */
	function parse_ForceFullCalculation(blob) {
		var header = parse_frtHeader(blob);
		if(header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
		var fullcalc = blob.read_shift(4);
		return fullcalc !== 0x0;
	}
	
	
	
	
	
	/* [MS-XLS] 2.4.215 rt */
	function parse_RecalcId(blob) {
		blob.read_shift(2);
		return blob.read_shift(4);
	}
	
	/* [MS-XLS] 2.4.87 */
	function parse_DefaultRowHeight(blob, length, opts) {
		var f = 0;
		if(!(opts && opts.biff == 2)) {
			f = blob.read_shift(2);
		}
		var miyRw = blob.read_shift(2);
		if((opts && opts.biff == 2)) {
			f = 1 - (miyRw >> 15); miyRw &= 0x7fff;
		}
		var fl = {Unsynced:f&1,DyZero:(f&2)>>1,ExAsc:(f&4)>>2,ExDsc:(f&8)>>3};
		return [fl, miyRw];
	}
	
	/* [MS-XLS] 2.4.345 TODO */
	function parse_Window1(blob) {
		var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
		var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
		var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
		return { Pos: [xWn, yWn], Dim: [dxWn, dyWn], Flags: flags, CurTab: iTabCur,
			FirstTab: iTabFirst, Selected: ctabSel, TabRatio: wTabRatio };
	}
	function write_Window1() {
		var o = new_buf(18);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0x7260);
		o.write_shift(2, 0x44c0);
		o.write_shift(2, 0x38);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 1);
		o.write_shift(2, 0x01f4);
		return o;
	}
	/* [MS-XLS] 2.4.346 TODO */
	function parse_Window2(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff < 5) return {};
		var f = blob.read_shift(2);
		return { RTL: f & 0x40 };
	}
	function write_Window2(view) {
		var o = new_buf(18), f = 0x6b6;
		if(view && view.RTL) f |= 0x40;
		o.write_shift(2, f);
		o.write_shift(4, 0);
		o.write_shift(4, 64);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.189 TODO */
	function parse_Pane(/*blob, length, opts*/) {
	}
	
	/* [MS-XLS] 2.4.122 TODO */
	function parse_Font(blob, length, opts) {
		var o = {
			dyHeight: blob.read_shift(2),
			fl: blob.read_shift(2)
		};
		switch((opts && opts.biff) || 8) {
			case 2: break;
			case 3: case 4: blob.l += 2; break;
			default: blob.l += 10; break;
		}
		o.name = parse_ShortXLUnicodeString(blob, 0, opts);
		return o;
	}
	function write_Font(data, opts) {
		var name = data.name || "Arial";
		var b5 = (opts && (opts.biff == 5)), w = (b5 ? (15 + name.length) : (16 + 2 * name.length));
		var o = new_buf(w);
		o.write_shift(2, (data.sz || 12) * 20);
		o.write_shift(4, 0);
		o.write_shift(2, 400);
		o.write_shift(4, 0);
		o.write_shift(2, 0);
		o.write_shift(1, name.length);
		if(!b5) o.write_shift(1, 1);
		o.write_shift((b5 ? 1 : 2) * name.length, name, (b5 ? "sbcs" : "utf16le"));
		return o;
	}
	
	/* [MS-XLS] 2.4.149 */
	function parse_LabelSst(blob) {
		var cell = parse_XLSCell(blob);
		cell.isst = blob.read_shift(4);
		return cell;
	}
	function write_LabelSst(R, C, v, os ) {
		var o = new_buf(10);
		write_XLSCell(R, C, os, o);
		o.write_shift(4, v);
		return o;
	}
	
	/* [MS-XLS] 2.4.148 */
	function parse_Label(blob, length, opts) {
		if(opts.biffguess && opts.biff == 2) opts.biff = 5;
		var target = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) blob.l++;
		var str = parse_XLUnicodeString(blob, target - blob.l, opts);
		cell.val = str;
		return cell;
	}
	function write_Label(R, C, v, os, opts) {
		var b8 = !opts || opts.biff == 8;
		var o = new_buf(6 + 2 + (+b8) + (1 + b8) * v.length);
		write_XLSCell(R, C, os, o);
		o.write_shift(2, v.length);
		if(b8) o.write_shift(1, 1);
		o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
		return o;
	}
	
	
	/* [MS-XLS] 2.4.126 Number Formats */
	function parse_Format(blob, length, opts) {
		var numFmtId = blob.read_shift(2);
		var fmtstr = parse_XLUnicodeString2(blob, 0, opts);
		return [numFmtId, fmtstr];
	}
	function write_Format(i, f, opts, o) {
		var b5 = (opts && (opts.biff == 5));
		if(!o) o = new_buf(b5 ? (3 + f.length) : (5 + 2 * f.length));
		o.write_shift(2, i);
		o.write_shift((b5 ? 1 : 2), f.length);
		if(!b5) o.write_shift(1, 1);
		o.write_shift((b5 ? 1 : 2) * f.length, f, (b5 ? 'sbcs' : 'utf16le'));
		var out = (o.length > o.l) ? o.slice(0, o.l) : o;
		if(out.l == null) out.l = out.length;
		return out;
	}
	var parse_BIFF2Format = parse_XLUnicodeString2;
	
	/* [MS-XLS] 2.4.90 */
	function parse_Dimensions(blob, length, opts) {
		var end = blob.l + length;
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var r = blob.read_shift(w), R = blob.read_shift(w);
		var c = blob.read_shift(2), C = blob.read_shift(2);
		blob.l = end;
		return {s: {r:r, c:c}, e: {r:R, c:C}};
	}
	function write_Dimensions(range, opts) {
		var w = opts.biff == 8 || !opts.biff ? 4 : 2;
		var o = new_buf(2*w + 6);
		o.write_shift(w, range.s.r);
		o.write_shift(w, range.e.r + 1);
		o.write_shift(2, range.s.c);
		o.write_shift(2, range.e.c + 1);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.220 */
	function parse_RK(blob) {
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrec = parse_RkRec(blob);
		return {r:rw, c:col, ixfe:rkrec[0], rknum:rkrec[1]};
	}
	
	/* [MS-XLS] 2.4.175 */
	function parse_MulRk(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var rkrecs = [];
		while(blob.l < target) rkrecs.push(parse_RkRec(blob));
		if(blob.l !== target) throw new Error("MulRK read error");
		var lastcol = blob.read_shift(2);
		if(rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
		return {r:rw, c:col, C:lastcol, rkrec:rkrecs};
	}
	/* [MS-XLS] 2.4.174 */
	function parse_MulBlank(blob, length) {
		var target = blob.l + length - 2;
		var rw = blob.read_shift(2), col = blob.read_shift(2);
		var ixfes = [];
		while(blob.l < target) ixfes.push(blob.read_shift(2));
		if(blob.l !== target) throw new Error("MulBlank read error");
		var lastcol = blob.read_shift(2);
		if(ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
		return {r:rw, c:col, C:lastcol, ixfe:ixfes};
	}
	
	/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */
	function parse_CellStyleXF(blob, length, style, opts) {
		var o = {};
		var a = blob.read_shift(4), b = blob.read_shift(4);
		var c = blob.read_shift(4), d = blob.read_shift(2);
		o.patternType = XLSFillPattern[c >> 26];
	
		if(!opts.cellStyles) return o;
		o.alc = a & 0x07;
		o.fWrap = (a >> 3) & 0x01;
		o.alcV = (a >> 4) & 0x07;
		o.fJustLast = (a >> 7) & 0x01;
		o.trot = (a >> 8) & 0xFF;
		o.cIndent = (a >> 16) & 0x0F;
		o.fShrinkToFit = (a >> 20) & 0x01;
		o.iReadOrder = (a >> 22) & 0x02;
		o.fAtrNum = (a >> 26) & 0x01;
		o.fAtrFnt = (a >> 27) & 0x01;
		o.fAtrAlc = (a >> 28) & 0x01;
		o.fAtrBdr = (a >> 29) & 0x01;
		o.fAtrPat = (a >> 30) & 0x01;
		o.fAtrProt = (a >> 31) & 0x01;
	
		o.dgLeft = b & 0x0F;
		o.dgRight = (b >> 4) & 0x0F;
		o.dgTop = (b >> 8) & 0x0F;
		o.dgBottom = (b >> 12) & 0x0F;
		o.icvLeft = (b >> 16) & 0x7F;
		o.icvRight = (b >> 23) & 0x7F;
		o.grbitDiag = (b >> 30) & 0x03;
	
		o.icvTop = c & 0x7F;
		o.icvBottom = (c >> 7) & 0x7F;
		o.icvDiag = (c >> 14) & 0x7F;
		o.dgDiag = (c >> 21) & 0x0F;
	
		o.icvFore = d & 0x7F;
		o.icvBack = (d >> 7) & 0x7F;
		o.fsxButton = (d >> 14) & 0x01;
		return o;
	}
	//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
	//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
	
	/* [MS-XLS] 2.4.353 TODO: actually do this right */
	function parse_XF(blob, length, opts) {
		var o = {};
		o.ifnt = blob.read_shift(2); o.numFmtId = blob.read_shift(2); o.flags = blob.read_shift(2);
		o.fStyle = (o.flags >> 2) & 0x01;
		length -= 6;
		o.data = parse_CellStyleXF(blob, length, o.fStyle, opts);
		return o;
	}
	function write_XF(data, ixfeP, opts, o) {
		var b5 = (opts && (opts.biff == 5));
		if(!o) o = new_buf(b5 ? 16 : 20);
		o.write_shift(2, 0);
		if(data.style) {
			o.write_shift(2, (data.numFmtId||0));
			o.write_shift(2, 0xFFF4);
		} else {
			o.write_shift(2, (data.numFmtId||0));
			o.write_shift(2, (ixfeP<<4));
		}
		var f = 0;
		if(data.numFmtId > 0 && b5) f |= 0x0400;
		o.write_shift(4, f);
		o.write_shift(4, 0);
		if(!b5) o.write_shift(4, 0);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.134 */
	function parse_Guts(blob) {
		blob.l += 4;
		var out = [blob.read_shift(2), blob.read_shift(2)];
		if(out[0] !== 0) out[0]--;
		if(out[1] !== 0) out[1]--;
		if(out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
		return out;
	}
	function write_Guts(guts) {
		var o = new_buf(8);
		o.write_shift(4, 0);
		o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
		o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.24 */
	function parse_BoolErr(blob, length, opts) {
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2 || length == 9) ++blob.l;
		var val = parse_Bes(blob, 2);
		cell.val = val;
		cell.t = (val === true || val === false) ? 'b' : 'e';
		return cell;
	}
	function write_BoolErr(R, C, v, os, opts, t) {
		var o = new_buf(8);
		write_XLSCell(R, C, os, o);
		write_Bes(v, t, o);
		return o;
	}
	
	/* [MS-XLS] 2.4.180 Number */
	function parse_Number(blob, length, opts) {
		if(opts.biffguess && opts.biff == 2) opts.biff = 5;
		var cell = parse_XLSCell(blob, 6);
		var xnum = parse_Xnum(blob, 8);
		cell.val = xnum;
		return cell;
	}
	function write_Number(R, C, v, os) {
		var o = new_buf(14);
		write_XLSCell(R, C, os, o);
		write_Xnum(v, o);
		return o;
	}
	
	var parse_XLHeaderFooter = parse_OptXLUnicodeString; // TODO: parse 2.4.136
	
	/* [MS-XLS] 2.4.271 */
	function parse_SupBook(blob, length, opts) {
		var end = blob.l + length;
		var ctab = blob.read_shift(2);
		var cch = blob.read_shift(2);
		opts.sbcch = cch;
		if(cch == 0x0401 || cch == 0x3A01) return [cch, ctab];
		if(cch < 0x01 || cch >0xff) throw new Error("Unexpected SupBook type: "+cch);
		var virtPath = parse_XLUnicodeStringNoCch(blob, cch);
		/* TODO: 2.5.277 Virtual Path */
		var rgst = [];
		while(end > blob.l) rgst.push(parse_XLUnicodeString(blob));
		return [cch, ctab, virtPath, rgst];
	}
	
	/* [MS-XLS] 2.4.105 TODO */
	function parse_ExternName(blob, length, opts) {
		var flags = blob.read_shift(2);
		var body;
		var o = ({
			fBuiltIn: flags & 0x01,
			fWantAdvise: (flags >>> 1) & 0x01,
			fWantPict: (flags >>> 2) & 0x01,
			fOle: (flags >>> 3) & 0x01,
			fOleLink: (flags >>> 4) & 0x01,
			cf: (flags >>> 5) & 0x3FF,
			fIcon: flags >>> 15 & 0x01
		});
		if(opts.sbcch === 0x3A01) body = parse_AddinUdf(blob, length-2, opts);
		//else throw new Error("unsupported SupBook cch: " + opts.sbcch);
		o.body = body || blob.read_shift(length-2);
		if(typeof body === "string") o.Name = body;
		return o;
	}
	
	/* [MS-XLS] 2.4.150 TODO */
	var XLSLblBuiltIn = [
		"_xlnm.Consolidate_Area",
		"_xlnm.Auto_Open",
		"_xlnm.Auto_Close",
		"_xlnm.Extract",
		"_xlnm.Database",
		"_xlnm.Criteria",
		"_xlnm.Print_Area",
		"_xlnm.Print_Titles",
		"_xlnm.Recorder",
		"_xlnm.Data_Form",
		"_xlnm.Auto_Activate",
		"_xlnm.Auto_Deactivate",
		"_xlnm.Sheet_Title",
		"_xlnm._FilterDatabase"
	];
	function parse_Lbl(blob, length, opts) {
		var target = blob.l + length;
		var flags = blob.read_shift(2);
		var chKey = blob.read_shift(1);
		var cch = blob.read_shift(1);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var itab = 0;
		if(!opts || opts.biff >= 5) {
			if(opts.biff != 5) blob.l += 2;
			itab = blob.read_shift(2);
			if(opts.biff == 5) blob.l += 2;
			blob.l += 4;
		}
		var name = parse_XLUnicodeStringNoCch(blob, cch, opts);
		if(flags & 0x20) name = XLSLblBuiltIn[name.charCodeAt(0)];
		var npflen = target - blob.l; if(opts && opts.biff == 2) --npflen;
		/*jshint -W018 */
		var rgce = (target == blob.l || cce === 0 || !(npflen > 0)) ? [] : parse_NameParsedFormula(blob, npflen, opts, cce);
		/*jshint +W018 */
		return {
			chKey: chKey,
			Name: name,
			itab: itab,
			rgce: rgce
		};
	}
	
	/* [MS-XLS] 2.4.106 TODO: verify filename encoding */
	function parse_ExternSheet(blob, length, opts) {
		if(opts.biff < 8) return parse_BIFF5ExternSheet(blob, length, opts);
		var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
		while(len-- !== 0) o.push(parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
			// [iSupBook, itabFirst, itabLast];
		if(blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
		return o;
	}
	function parse_BIFF5ExternSheet(blob, length, opts) {
		if(blob[blob.l + 1] == 0x03) blob[blob.l]++;
		var o = parse_ShortXLUnicodeString(blob, length, opts);
		return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
	}
	
	/* [MS-XLS] 2.4.176 TODO: check older biff */
	function parse_NameCmt(blob, length, opts) {
		if(opts.biff < 8) { blob.l += length; return; }
		var cchName = blob.read_shift(2);
		var cchComment = blob.read_shift(2);
		var name = parse_XLUnicodeStringNoCch(blob, cchName, opts);
		var comment = parse_XLUnicodeStringNoCch(blob, cchComment, opts);
		return [name, comment];
	}
	
	/* [MS-XLS] 2.4.260 */
	function parse_ShrFmla(blob, length, opts) {
		var ref = parse_RefU(blob, 6);
		blob.l++;
		var cUse = blob.read_shift(1);
		length -= 8;
		return [parse_SharedParsedFormula(blob, length, opts), cUse, ref];
	}
	
	/* [MS-XLS] 2.4.4 TODO */
	function parse_Array(blob, length, opts) {
		var ref = parse_Ref(blob, 6);
		/* TODO: fAlwaysCalc */
		switch(opts.biff) {
			case 2: blob.l ++; length -= 7; break;
			case 3: case 4: blob.l += 2; length -= 8; break;
			default: blob.l += 6; length -= 12;
		}
		return [ref, parse_ArrayParsedFormula(blob, length, opts, ref)];
	}
	
	/* [MS-XLS] 2.4.173 */
	function parse_MTRSettings(blob) {
		var fMTREnabled = blob.read_shift(4) !== 0x00;
		var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
		var cUserThreadCount = blob.read_shift(4);
		return [fMTREnabled, fUserSetThreadCount, cUserThreadCount];
	}
	
	/* [MS-XLS] 2.5.186 TODO: BIFF5 */
	function parse_NoteSh(blob, length, opts) {
		if(opts.biff < 8) return;
		var row = blob.read_shift(2), col = blob.read_shift(2);
		var flags = blob.read_shift(2), idObj = blob.read_shift(2);
		var stAuthor = parse_XLUnicodeString2(blob, 0, opts);
		if(opts.biff < 8) blob.read_shift(1);
		return [{r:row,c:col}, stAuthor, idObj, flags];
	}
	
	/* [MS-XLS] 2.4.179 */
	function parse_Note(blob, length, opts) {
		/* TODO: Support revisions */
		return parse_NoteSh(blob, length, opts);
	}
	
	/* [MS-XLS] 2.4.168 */
	function parse_MergeCells(blob, length) {
		var merges = [];
		var cmcs = blob.read_shift(2);
		while (cmcs--) merges.push(parse_Ref8U(blob,length));
		return merges;
	}
	function write_MergeCells(merges) {
		var o = new_buf(2 + merges.length * 8);
		o.write_shift(2, merges.length);
		for(var i = 0; i < merges.length; ++i) write_Ref8U(merges[i], o);
		return o;
	}
	
	/* [MS-XLS] 2.4.181 TODO: parse all the things! */
	function parse_Obj(blob, length, opts) {
		if(opts && opts.biff < 8) return parse_BIFF5Obj(blob, length, opts);
		var cmo = parse_FtCmo(blob, 22); // id, ot, flags
		var fts = parse_FtArray(blob, length-22, cmo[1]);
		return { cmo: cmo, ft:fts };
	}
	/* from older spec */
	var parse_BIFF5OT = [];
	parse_BIFF5OT[0x08] = function(blob, length) {
		var tgt = blob.l + length;
		blob.l += 10; // todo
		var cf = blob.read_shift(2);
		blob.l += 4;
		blob.l += 2; //var cbPictFmla = blob.read_shift(2);
		blob.l += 2;
		blob.l += 2; //var grbit = blob.read_shift(2);
		blob.l += 4;
		var cchName = blob.read_shift(1);
		blob.l += cchName; // TODO: stName
		blob.l = tgt; // TODO: fmla
		return { fmt:cf };
	};
	
	function parse_BIFF5Obj(blob, length, opts) {
		blob.l += 4; //var cnt = blob.read_shift(4);
		var ot = blob.read_shift(2);
		var id = blob.read_shift(2);
		var grbit = blob.read_shift(2);
		blob.l += 2; //var colL = blob.read_shift(2);
		blob.l += 2; //var dxL = blob.read_shift(2);
		blob.l += 2; //var rwT = blob.read_shift(2);
		blob.l += 2; //var dyT = blob.read_shift(2);
		blob.l += 2; //var colR = blob.read_shift(2);
		blob.l += 2; //var dxR = blob.read_shift(2);
		blob.l += 2; //var rwB = blob.read_shift(2);
		blob.l += 2; //var dyB = blob.read_shift(2);
		blob.l += 2; //var cbMacro = blob.read_shift(2);
		blob.l += 6;
		length -= 36;
		var fts = [];
		fts.push((parse_BIFF5OT[ot]||parsenoop)(blob, length, opts));
		return { cmo: [id, ot, grbit], ft:fts };
	}
	
	/* [MS-XLS] 2.4.329 TODO: parse properly */
	function parse_TxO(blob, length, opts) {
		var s = blob.l;
		var texts = "";
	try {
		blob.l += 4;
		var ot = (opts.lastobj||{cmo:[0,0]}).cmo[1];
		var controlInfo; // eslint-disable-line no-unused-vars
		if([0,5,7,11,12,14].indexOf(ot) == -1) blob.l += 6;
		else controlInfo = parse_ControlInfo(blob, 6, opts);
		var cchText = blob.read_shift(2);
		/*var cbRuns = */blob.read_shift(2);
		/*var ifntEmpty = */parseuint16(blob, 2);
		var len = blob.read_shift(2);
		blob.l += len;
		//var fmla = parse_ObjFmla(blob, s + length - blob.l);
	
		for(var i = 1; i < blob.lens.length-1; ++i) {
			if(blob.l-s != blob.lens[i]) throw new Error("TxO: bad continue record");
			var hdr = blob[blob.l];
			var t = parse_XLUnicodeStringNoCch(blob, blob.lens[i+1]-blob.lens[i]-1);
			texts += t;
			if(texts.length >= (hdr ? cchText : 2*cchText)) break;
		}
		if(texts.length !== cchText && texts.length !== cchText*2) {
			throw new Error("cchText: " + cchText + " != " + texts.length);
		}
	
		blob.l = s + length;
		/* [MS-XLS] 2.5.272 TxORuns */
	//	var rgTxoRuns = [];
	//	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
	//	var cchText2 = blob.read_shift(2);
	//	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
	//	blob.l += 6;
	//	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
		return { t: texts };
	} catch(e) { blob.l = s + length; return { t: texts }; }
	}
	
	/* [MS-XLS] 2.4.140 */
	function parse_HLink(blob, length) {
		var ref = parse_Ref8U(blob, 8);
		blob.l += 16; /* CLSID */
		var hlink = parse_Hyperlink(blob, length-24);
		return [ref, hlink];
	}
	function write_HLink(hl) {
		var O = new_buf(24);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
		for(var i = 0; i < 16; ++i) O.write_shift(1, parseInt(clsid[i], 16));
		return bconcat([O, write_Hyperlink(hl[1])]);
	}
	
	
	/* [MS-XLS] 2.4.141 */
	function parse_HLinkTooltip(blob, length) {
		blob.read_shift(2);
		var ref = parse_Ref8U(blob, 8);
		var wzTooltip = blob.read_shift((length-10)/2, 'dbcs-cont');
		wzTooltip = wzTooltip.replace(chr0,"");
		return [ref, wzTooltip];
	}
	function write_HLinkTooltip(hl) {
		var TT = hl[1].Tooltip;
		var O = new_buf(10 + 2 * (TT.length + 1));
		O.write_shift(2, 0x0800);
		var ref = decode_cell(hl[0]);
		O.write_shift(2, ref.r); O.write_shift(2, ref.r);
		O.write_shift(2, ref.c); O.write_shift(2, ref.c);
		for(var i = 0; i < TT.length; ++i) O.write_shift(2, TT.charCodeAt(i));
		O.write_shift(2, 0);
		return O;
	}
	
	/* [MS-XLS] 2.4.63 */
	function parse_Country(blob) {
		var o = [0,0], d;
		d = blob.read_shift(2); o[0] = CountryEnum[d] || d;
		d = blob.read_shift(2); o[1] = CountryEnum[d] || d;
		return o;
	}
	function write_Country(o) {
		if(!o) o = new_buf(4);
		o.write_shift(2, 0x01);
		o.write_shift(2, 0x01);
		return o;
	}
	
	/* [MS-XLS] 2.4.50 ClrtClient */
	function parse_ClrtClient(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* [MS-XLS] 2.4.188 */
	function parse_Palette(blob) {
		var ccv = blob.read_shift(2);
		var o = [];
		while(ccv-->0) o.push(parse_LongRGB(blob, 8));
		return o;
	}
	
	/* [MS-XLS] 2.4.354 */
	function parse_XFCRC(blob) {
		blob.l += 2;
		var o = {cxfs:0, crc:0};
		o.cxfs = blob.read_shift(2);
		o.crc = blob.read_shift(4);
		return o;
	}
	
	/* [MS-XLS] 2.4.53 TODO: parse flags */
	/* [MS-XLSB] 2.4.323 TODO: parse flags */
	function parse_ColInfo(blob, length, opts) {
		if(!opts.cellStyles) return parsenoop(blob, length);
		var w = opts && opts.biff >= 12 ? 4 : 2;
		var colFirst = blob.read_shift(w);
		var colLast = blob.read_shift(w);
		var coldx = blob.read_shift(w);
		var ixfe = blob.read_shift(w);
		var flags = blob.read_shift(2);
		if(w == 2) blob.l += 2;
		var o = ({s:colFirst, e:colLast, w:coldx, ixfe:ixfe, flags:flags});
		if(opts.biff >= 5 || !opts.biff) o.level = (flags >> 8) & 0x7;
		return o;
	}
	function write_ColInfo(col, idx) {
		var o = new_buf(12);
		o.write_shift(2, idx);
		o.write_shift(2, idx);
		o.write_shift(2, col.width * 256);
		o.write_shift(2, 0);
		var f = 0;
		if(col.hidden) f |= 1;
		o.write_shift(1, f);
		f = col.level || 0;
		o.write_shift(1, f);
		o.write_shift(2, 0);
		return o;
	}
	
	/* [MS-XLS] 2.4.257 */
	function parse_Setup(blob, length) {
		var o = {};
		if(length < 32) return o;
		blob.l += 16;
		o.header = parse_Xnum(blob, 8);
		o.footer = parse_Xnum(blob, 8);
		blob.l += 2;
		return o;
	}
	
	/* [MS-XLS] 2.4.261 */
	function parse_ShtProps(blob, length, opts) {
		var def = {area:false};
		if(opts.biff != 5) { blob.l += length; return def; }
		var d = blob.read_shift(1); blob.l += 3;
		if((d & 0x10)) def.area = true;
		return def;
	}
	
	/* [MS-XLS] 2.4.241 */
	function write_RRTabId(n) {
		var out = new_buf(2 * n);
		for(var i = 0; i < n; ++i) out.write_shift(2, i+1);
		return out;
	}
	
	var parse_Blank = parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */
	var parse_Scl = parseuint16a; /* [MS-XLS] 2.4.247 num, den */
	var parse_String = parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */
	
	/* --- Specific to versions before BIFF8 --- */
	function parse_ImData(blob) {
		var cf = blob.read_shift(2);
		var env = blob.read_shift(2);
		var lcb = blob.read_shift(4);
		var o = {fmt:cf, env:env, len:lcb, data:blob.slice(blob.l,blob.l+lcb)};
		blob.l += lcb;
		return o;
	}
	
	/* BIFF2_??? where ??? is the name from [XLS] */
	function parse_BIFF2STR(blob, length, opts) {
		if(opts.biffguess && opts.biff == 5) opts.biff = 2;
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var str = parse_XLUnicodeString2(blob, length-7, opts);
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	
	function parse_BIFF2NUM(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = parse_Xnum(blob, 8);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2NUM(r, c, val) {
		var out = new_buf(15);
		write_BIFF2Cell(out, r, c);
		out.write_shift(8, val, 'f');
		return out;
	}
	
	function parse_BIFF2INT(blob) {
		var cell = parse_XLSCell(blob, 6);
		++blob.l;
		var num = blob.read_shift(2);
		cell.t = 'n';
		cell.val = num;
		return cell;
	}
	function write_BIFF2INT(r, c, val) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		out.write_shift(2, val);
		return out;
	}
	
	function parse_BIFF2STRING(blob) {
		var cch = blob.read_shift(1);
		if(cch === 0) { blob.l++; return ""; }
		return blob.read_shift(cch, 'sbcs-cont');
	}
	
	/* TODO: convert to BIFF8 font struct */
	function parse_BIFF2FONTXTRA(blob, length) {
		blob.l += 6; // unknown
		blob.l += 2; // font weight "bls"
		blob.l += 1; // charset
		blob.l += 3; // unknown
		blob.l += 1; // font family
		blob.l += length - 13;
	}
	
	/* TODO: parse rich text runs */
	function parse_RString(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		var cch = blob.read_shift(2);
		var str = parse_XLUnicodeStringNoCch(blob, cch, opts);
		blob.l = end;
		cell.t = 'str';
		cell.val = str;
		return cell;
	}
	/* from js-harb (C) 2014-present  SheetJS */
	var DBF = (function() {
	var dbf_codepage_map = {
		/* Code Pages Supported by Visual FoxPro */
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	
		/* shapefile DBF extension */
	0x00: 20127,           0x08:   865,
	0x09:   437,           0x0A:   850,
	0x0B:   437,           0x0D:   437,
	0x0E:   850,           0x0F:   437,
	0x10:   850,           0x11:   437,
	0x12:   850,           0x13:   932,
	0x14:   850,           0x15:   437,
	0x16:   850,           0x17:   865,
	0x18:   437,           0x19:   437,
	0x1A:   850,           0x1B:   437,
	0x1C:   863,           0x1D:   850,
	0x1F:   852,           0x22:   852,
	0x23:   852,           0x24:   860,
	0x25:   850,           0x26:   866,
	0x37:   850,           0x40:   852,
	0x4D:   936,           0x4E:   949,
	0x4F:   950,           0x50:   874,
	0x57:  1252,           0x58:  1252,
	0x59:  1252,           0x6C:   863,
	0x86:   737,           0x87:   852,
	0x88:   857,           0xCC:  1257,
	
	0xFF: 16969
	};
	var dbf_reverse_map = evert({
	0x01:   437,           0x02:   850,
	0x03:  1252,           0x04: 10000,
	0x64:   852,           0x65:   866,
	0x66:   865,           0x67:   861,
	0x68:   895,           0x69:   620,
	0x6A:   737,           0x6B:   857,
	0x78:   950,           0x79:   949,
	0x7A:   936,           0x7B:   932,
	0x7C:   874,           0x7D:  1255,
	0x7E:  1256,           0x96: 10007,
	0x97: 10029,           0x98: 10006,
	0xC8:  1250,           0xC9:  1251,
	0xCA:  1254,           0xCB:  1253,
	0x00: 20127
	});
	var DBF_SUPPORTED_VERSIONS = [0x02, 0x03, 0x30, 0x31, 0x83, 0x8B, 0x8C, 0xF5];
	/* TODO: find an actual specification */
	function dbf_to_aoa(buf, opts) {
		var out = [];
		var d = (new_raw_buf(1));
		switch(opts.type) {
			case 'base64': d = s2a(Base64.decode(buf)); break;
			case 'binary': d = s2a(buf); break;
			case 'buffer':
			case 'array': d = buf; break;
		}
		prep_blob(d, 0);
	
		/* header */
		var ft = d.read_shift(1);
		var memo = !!(ft & 0x88);
		var vfp = false, l7 = false;
		switch(ft) {
			case 0x02: break; // dBASE II
			case 0x03: break; // dBASE III
			case 0x30: vfp = true; memo = true; break; // VFP
			case 0x31: vfp = true; memo = true; break; // VFP with autoincrement
			// 0x43 dBASE IV SQL table files
			// 0x63 dBASE IV SQL system files
			case 0x83: break; // dBASE III with memo
			case 0x8B: break; // dBASE IV with memo
			case 0x8C: l7 = true; break; // dBASE Level 7 with memo
			// case 0xCB dBASE IV SQL table files with memo
			case 0xF5: break; // FoxPro 2.x with memo
			// case 0xFB FoxBASE
			default: throw new Error("DBF Unsupported Version: " + ft.toString(16));
		}
	
		var nrow = 0, fpos = 0x0209;
		if(ft == 0x02) nrow = d.read_shift(2);
		d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
		if(ft != 0x02) nrow = d.read_shift(4);
		if(nrow > 1048576) nrow = 1e6;
	
		if(ft != 0x02) fpos = d.read_shift(2); // header length
		var rlen = d.read_shift(2); // record length
	
		var /*flags = 0,*/ current_cp = opts.codepage || 1252;
		if(ft != 0x02) { // 20 reserved bytes
			d.l+=16;
			/*flags = */d.read_shift(1);
			//if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
	
			/* codepage present in FoxPro and dBASE Level 7 */
			if(d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
			d.l+=1;
	
			d.l+=2;
		}
		if(l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
	
	var fields = [], field = ({});
		var hend = Math.min(d.length, (ft == 0x02 ? 0x209 : (fpos - 10 - (vfp ? 264 : 0))));
		var ww = l7 ? 32 : 11;
		while(d.l < hend && d[d.l] != 0x0d) {
			field = ({});
			field.name = cptable.utils.decode(current_cp, d.slice(d.l, d.l+ww)).replace(/[\u0000\r\n].*$/g,"");
			d.l += ww;
			field.type = String.fromCharCode(d.read_shift(1));
			if(ft != 0x02 && !l7) field.offset = d.read_shift(4);
			field.len = d.read_shift(1);
			if(ft == 0x02) field.offset = d.read_shift(2);
			field.dec = d.read_shift(1);
			if(field.name.length) fields.push(field);
			if(ft != 0x02) d.l += l7 ? 13 : 14;
			switch(field.type) {
				case 'B': // Double (VFP) / Binary (dBASE L7)
					if((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case 'G': // General (FoxPro and dBASE L7)
				case 'P': // Picture (FoxPro and dBASE L7)
					if(opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
					break;
				case '+': // Autoincrement (dBASE L7 only)
				case '0': // _NullFlags (VFP only)
				case '@': // Timestamp (dBASE L7 only)
				case 'C': // Character (dBASE II)
				case 'D': // Date (dBASE III)
				case 'F': // Float (dBASE IV)
				case 'I': // Long (VFP and dBASE L7)
				case 'L': // Logical (dBASE II)
				case 'M': // Memo (dBASE III)
				case 'N': // Number (dBASE II)
				case 'O': // Double (dBASE L7 only)
				case 'T': // Datetime (VFP only)
				case 'Y': // Currency (VFP only)
					break;
				default: throw new Error('Unknown Field Type: ' + field.type);
			}
		}
	
		if(d[d.l] !== 0x0D) d.l = fpos-1;
		if(d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
		d.l = fpos;
	
		/* data */
		var R = 0, C = 0;
		out[0] = [];
		for(C = 0; C != fields.length; ++C) out[0][C] = fields[C].name;
		while(nrow-- > 0) {
			if(d[d.l] === 0x2A) {
				// TODO: record marked as deleted -- create a hidden row?
				d.l+=rlen;
				continue;
			}
			++d.l;
			out[++R] = []; C = 0;
			for(C = 0; C != fields.length; ++C) {
				var dd = d.slice(d.l, d.l+fields[C].len); d.l+=fields[C].len;
				prep_blob(dd, 0);
				var s = cptable.utils.decode(current_cp, dd);
				switch(fields[C].type) {
					case 'C':
						// NOTE: it is conventional to write '  /  /  ' for empty dates
						if(s.trim().length) out[R][C] = s.replace(/\s+$/,"");
						break;
					case 'D':
						if(s.length === 8) out[R][C] = new Date(+s.slice(0,4), +s.slice(4,6)-1, +s.slice(6,8));
						else out[R][C] = s;
						break;
					case 'F': out[R][C] = parseFloat(s.trim()); break;
					case '+': case 'I': out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i'); break;
					case 'L': switch(s.trim().toUpperCase()) {
						case 'Y': case 'T': out[R][C] = true; break;
						case 'N': case 'F': out[R][C] = false; break;
						case '': case '?': break;
						default: throw new Error("DBF Unrecognized L:|" + s + "|");
						} break;
					case 'M': /* TODO: handle memo files */
						if(!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
						out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10): dd.read_shift(4));
						break;
					case 'N':
						s = s.replace(/\u0000/g,"").trim();
						// NOTE: dBASE II interprets "  .  " as 0
						if(s && s != ".") out[R][C] = +s || 0; break;
					case '@':
						// NOTE: dBASE specs appear to be incorrect
						out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
						break;
					case 'T': out[R][C] = new Date((dd.read_shift(4) - 0x253D8C) * 0x5265C00 + dd.read_shift(4)); break;
					case 'Y': out[R][C] = dd.read_shift(4,'i')/1e4; break;
					case 'O': out[R][C] = -dd.read_shift(-8, 'f'); break;
					case 'B': if(vfp && fields[C].len == 8) { out[R][C] = dd.read_shift(8,'f'); break; }
						/* falls through */
					case 'G': case 'P': dd.l += fields[C].len; break;
					case '0':
						if(fields[C].name === '_NullFlags') break;
						/* falls through */
					default: throw new Error("DBF Unsupported data type " + fields[C].type);
				}
			}
		}
		if(ft != 0x02) if(d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l-1) + " of " + d.length + " " + d[d.l-1].toString(16));
		if(opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
		return out;
	}
	
	function dbf_to_sheet(buf, opts) {
		var o = opts || {};
		if(!o.dateNF) o.dateNF = "yyyymmdd";
		return aoa_to_sheet(dbf_to_aoa(buf, o), o);
	}
	
	function dbf_to_workbook(buf, opts) {
		try { return sheet_to_workbook(dbf_to_sheet(buf, opts), opts); }
		catch(e) { if(opts && opts.WTF) throw e; }
		return ({SheetNames:[],Sheets:{}});
	}
	
	var _RLEN = { 'B': 8, 'C': 250, 'L': 1, 'D': 8, '?': 0, '': 0 };
	function sheet_to_dbf(ws, opts) {
		var o = opts || {};
		if(+o.codepage >= 0) set_cp(+o.codepage);
		if(o.type == "string") throw new Error("Cannot write DBF to JS string");
		var ba = buf_array();
		var aoa = sheet_to_json(ws, {header:1, raw:true, cellDates:true});
		var headers = aoa[0], data = aoa.slice(1);
		var i = 0, j = 0, hcnt = 0, rlen = 1;
		for(i = 0; i < headers.length; ++i) {
			if(i == null) continue;
			++hcnt;
			if(typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
			if(typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + (typeof headers[i]) + "|");
			if(headers.indexOf(headers[i]) !== i) for(j=0; j<1024;++j)
				if(headers.indexOf(headers[i] + "_" + j) == -1) { headers[i] += "_" + j; break; }
		}
		var range = safe_decode_range(ws['!ref']);
		var coltypes = [];
		for(i = 0; i <= range.e.c - range.s.c; ++i) {
			var col = [];
			for(j=0; j < data.length; ++j) {
				if(data[j][i] != null) col.push(data[j][i]);
			}
			if(col.length == 0 || headers[i] == null) { coltypes[i] = '?'; continue; }
			var guess = '', _guess = '';
			for(j = 0; j < col.length; ++j) {
				switch(typeof col[j]) {
					/* TODO: check if L2 compat is desired */
					case 'number': _guess = 'B'; break;
					case 'string': _guess = 'C'; break;
					case 'boolean': _guess = 'L'; break;
					case 'object': _guess = col[j] instanceof Date ? 'D' : 'C'; break;
					default: _guess = 'C';
				}
				guess = guess && guess != _guess ? 'C' : _guess;
				if(guess == 'C') break;
			}
			rlen += _RLEN[guess] || 0;
			coltypes[i] = guess;
		}
	
		var h = ba.next(32);
		h.write_shift(4, 0x13021130);
		h.write_shift(4, data.length);
		h.write_shift(2, 296 + 32 * hcnt);
		h.write_shift(2, rlen);
		for(i=0; i < 4; ++i) h.write_shift(4, 0);
		h.write_shift(4, 0x00000000 | ((+dbf_reverse_map[current_ansi] || 0x03)<<8));
	
		for(i = 0, j = 0; i < headers.length; ++i) {
			if(headers[i] == null) continue;
			var hf = ba.next(32);
			var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
			hf.write_shift(1, _f, "sbcs");
			hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
			hf.write_shift(4, j);
			hf.write_shift(1, _RLEN[coltypes[i]] || 0);
			hf.write_shift(1, 0);
			hf.write_shift(1, 0x02);
			hf.write_shift(4, 0);
			hf.write_shift(1, 0);
			hf.write_shift(4, 0);
			hf.write_shift(4, 0);
			j += _RLEN[coltypes[i]] || 0;
		}
	
		var hb = ba.next(264);
		hb.write_shift(4, 0x0000000D);
		for(i=0; i < 65;++i) hb.write_shift(4, 0x00000000);
		for(i=0; i < data.length; ++i) {
			var rout = ba.next(rlen);
			rout.write_shift(1, 0);
			for(j=0; j<headers.length; ++j) {
				if(headers[j] == null) continue;
				switch(coltypes[j]) {
					case 'L': rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46); break;
					case 'B': rout.write_shift(8, data[i][j]||0, 'f'); break;
					case 'D':
						if(!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
						else {
							rout.write_shift(4, ("0000"+data[i][j].getFullYear()).slice(-4), "sbcs");
							rout.write_shift(2, ("00"+(data[i][j].getMonth()+1)).slice(-2), "sbcs");
							rout.write_shift(2, ("00"+data[i][j].getDate()).slice(-2), "sbcs");
						} break;
					case 'C':
						var _s = String(data[i][j]||"");
						rout.write_shift(1, _s, "sbcs");
						for(hcnt=0; hcnt < 250-_s.length; ++hcnt) rout.write_shift(1, 0x20); break;
				}
			}
			// data
		}
		ba.next(1).write_shift(1, 0x1A);
		return ba.end();
	}
		return {
			versions: DBF_SUPPORTED_VERSIONS,
			to_workbook: dbf_to_workbook,
			to_sheet: dbf_to_sheet,
			from_sheet: sheet_to_dbf
		};
	})();
	
	var SYLK = (function() {
		/* TODO: stress test sequences */
		var sylk_escapes = ({
			AA:'À', BA:'Á', CA:'Â', DA:195, HA:'Ä', JA:197,
			AE:'È', BE:'É', CE:'Ê',         HE:'Ë',
			AI:'Ì', BI:'Í', CI:'Î',         HI:'Ï',
			AO:'Ò', BO:'Ó', CO:'Ô', DO:213, HO:'Ö',
			AU:'Ù', BU:'Ú', CU:'Û',         HU:'Ü',
			Aa:'à', Ba:'á', Ca:'â', Da:227, Ha:'ä', Ja:229,
			Ae:'è', Be:'é', Ce:'ê',         He:'ë',
			Ai:'ì', Bi:'í', Ci:'î',         Hi:'ï',
			Ao:'ò', Bo:'ó', Co:'ô', Do:245, Ho:'ö',
			Au:'ù', Bu:'ú', Cu:'û',         Hu:'ü',
			KC:'Ç', Kc:'ç', q:'æ',  z:'œ',  a:'Æ',  j:'Œ',
			DN:209, Dn:241, Hy:255,
			S:169,  c:170,  R:174,  "B ":180,
	0:176,    1:177,  2:178,
	3:179,    5:181,  6:182,
	7:183,    Q:185,  k:186,  b:208,  i:216,  l:222,  s:240,  y:248,
			"!":161, '"':162, "#":163, "(":164, "%":165, "'":167, "H ":168,
			"+":171, ";":187, "<":188, "=":189, ">":190, "?":191, "{":223
		});
		var sylk_char_regex = new RegExp("\u001BN(" + keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g,"\\$1") + "|\\|)", "gm");
		var sylk_char_fn = function(_, $1){ var o = sylk_escapes[$1]; return typeof o == "number" ? _getansi(o) : o; };
		var decode_sylk_char = function($$, $1, $2) { var newcc = (($1.charCodeAt(0) - 0x20)<<4) | ($2.charCodeAt(0) - 0x30); return newcc == 59 ? $$ : _getansi(newcc); };
		sylk_escapes["|"] = 254;
		/* TODO: find an actual specification */
		function sylk_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return sylk_to_aoa_str(Base64.decode(d), opts);
				case 'binary': return sylk_to_aoa_str(d, opts);
				case 'buffer': return sylk_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array': return sylk_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function sylk_to_aoa_str(str, opts) {
			var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr = [];
			var formats = [];
			var next_cell_format = null;
			var sht = {}, rowinfo = [], colinfo = [], cw = [];
			var Mval = 0, j;
			if(+opts.codepage >= 0) set_cp(+opts.codepage);
			for (; ri !== records.length; ++ri) {
				Mval = 0;
				var rstr=records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
				var record=rstr.replace(/;;/g, "\u0000").split(";").map(function(x) { return x.replace(/\u0000/g, ";"); });
				var RT=record[0], val;
				if(rstr.length > 0) switch(RT) {
				case 'ID': break; /* header */
				case 'E': break; /* EOF */
				case 'B': break; /* dimensions */
				case 'O': break; /* options? */
				case 'W': break; /* window? */
				case 'P':
					if(record[1].charAt(0) == 'P')
						formats.push(rstr.slice(3).replace(/;;/g, ";"));
					break;
				case 'C':
				var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'A': break; // TODO: comment
					case 'X': C = parseInt(record[rj].slice(1))-1; C_seen_X = true; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; if(!C_seen_X) C = 0;
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'K':
						val = record[rj].slice(1);
						if(val.charAt(0) === '"') val = val.slice(1,val.length - 1);
						else if(val === 'TRUE') val = true;
						else if(val === 'FALSE') val = false;
						else if(!isNaN(fuzzynum(val))) {
							val = fuzzynum(val);
							if(next_cell_format !== null && SSF.is_date(next_cell_format)) val = numdate(val);
						} else if(!isNaN(fuzzydate(val).getDate())) {
							val = parseDate(val);
						}
						if(typeof cptable !== 'undefined' && typeof val == "string" && ((opts||{}).type != "string") && (opts||{}).codepage) val = cptable.utils.decode(opts.codepage, val);
						C_seen_K = true;
						break;
					case 'E':
						C_seen_E = true;
						var formula = rc_to_a1(record[rj].slice(1), {r:R,c:C});
						arr[R][C] = [arr[R][C], formula];
						break;
					case 'S':
						C_seen_S = true;
						arr[R][C] = [arr[R][C], "S5S"];
						break;
					case 'G': break; // unknown
					case 'R': _R = parseInt(record[rj].slice(1))-1; break;
					case 'C': _C = parseInt(record[rj].slice(1))-1; break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(C_seen_K) {
					if(arr[R][C] && arr[R][C].length == 2) arr[R][C][0] = val;
					else arr[R][C] = val;
					next_cell_format = null;
				}
				if(C_seen_S) {
					if(C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
					var shrbase = _R > -1 && arr[_R][_C];
					if(!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
					arr[R][C][1] = shift_formula_str(shrbase[1], {r: R - _R, c: C - _C});
				}
				break;
				case 'F':
				var F_seen = 0;
				for(rj=1; rj<record.length; ++rj) switch(record[rj].charAt(0)) {
					case 'X': C = parseInt(record[rj].slice(1))-1; ++F_seen; break;
					case 'Y':
						R = parseInt(record[rj].slice(1))-1; /*C = 0;*/
						for(j = arr.length; j <= R; ++j) arr[j] = [];
						break;
					case 'M': Mval = parseInt(record[rj].slice(1)) / 20; break;
					case 'F': break; /* ??? */
					case 'G': break; /* hide grid */
					case 'P':
						next_cell_format = formats[parseInt(record[rj].slice(1))];
						break;
					case 'S': break; /* cell style */
					case 'D': break; /* column */
					case 'N': break; /* font */
					case 'W':
						cw = record[rj].slice(1).split(" ");
						for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j) {
							Mval = parseInt(cw[2], 10);
							colinfo[j-1] = Mval === 0 ? {hidden:true}: {wch:Mval}; process_col(colinfo[j-1]);
						} break;
					case 'C': /* default column format */
						C = parseInt(record[rj].slice(1))-1;
						if(!colinfo[C]) colinfo[C] = {};
						break;
					case 'R': /* row properties */
						R = parseInt(record[rj].slice(1))-1;
						if(!rowinfo[R]) rowinfo[R] = {};
						if(Mval > 0) { rowinfo[R].hpt = Mval; rowinfo[R].hpx = pt2px(Mval); }
						else if(Mval === 0) rowinfo[R].hidden = true;
						break;
					default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
				if(F_seen < 1) next_cell_format = null; break;
				default: if(opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
				}
			}
			if(rowinfo.length > 0) sht['!rows'] = rowinfo;
			if(colinfo.length > 0) sht['!cols'] = colinfo;
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return [arr, sht];
		}
	
		function sylk_to_sheet(d, opts) {
			var aoasht = sylk_to_aoa(d, opts);
			var aoa = aoasht[0], ws = aoasht[1];
			var o = aoa_to_sheet(aoa, opts);
			keys(ws).forEach(function(k) { o[k] = ws[k]; });
			return o;
		}
	
		function sylk_to_workbook(d, opts) { return sheet_to_workbook(sylk_to_sheet(d, opts), opts); }
	
		function write_ws_cell_sylk(cell, ws, R, C) {
			var o = "C;Y" + (R+1) + ";X" + (C+1) + ";K";
			switch(cell.t) {
				case 'n':
					o += (cell.v||0);
					if(cell.f && !cell.F) o += ";E" + a1_to_rc(cell.f, {r:R, c:C}); break;
				case 'b': o += cell.v ? "TRUE" : "FALSE"; break;
				case 'e': o += cell.w || cell.v; break;
				case 'd': o += '"' + (cell.w || cell.v) + '"'; break;
				case 's': o += '"' + cell.v.replace(/"/g,"") + '"'; break;
			}
			return o;
		}
	
		function write_ws_cols_sylk(out, cols) {
			cols.forEach(function(col, i) {
				var rec = "F;W" + (i+1) + " " + (i+1) + " ";
				if(col.hidden) rec += "0";
				else {
					if(typeof col.width == 'number' && !col.wpx) col.wpx = width2px(col.width);
					if(typeof col.wpx == 'number' && !col.wch) col.wch = px2char(col.wpx);
					if(typeof col.wch == 'number') rec += Math.round(col.wch);
				}
				if(rec.charAt(rec.length - 1) != " ") out.push(rec);
			});
		}
	
		function write_ws_rows_sylk(out, rows) {
			rows.forEach(function(row, i) {
				var rec = "F;";
				if(row.hidden) rec += "M0;";
				else if(row.hpt) rec += "M" + 20 * row.hpt + ";";
				else if(row.hpx) rec += "M" + 20 * px2pt(row.hpx) + ";";
				if(rec.length > 2) out.push(rec + "R" + (i+1));
			});
		}
	
		function sheet_to_sylk(ws, opts) {
			var preamble = ["ID;PWXL;N;E"], o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			var RS = "\r\n";
	
			preamble.push("P;PGeneral");
			preamble.push("F;P0;DG0G8;M255");
			if(ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
			if(ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
	
			preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [r.s.c,r.s.r,r.e.c,r.e.r].join(" "));
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || (cell.v == null && (!cell.f || cell.F))) continue;
					o.push(write_ws_cell_sylk(cell, ws, R, C, opts));
				}
			}
			return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
		}
	
		return {
			to_workbook: sylk_to_workbook,
			to_sheet: sylk_to_sheet,
			from_sheet: sheet_to_sylk
		};
	})();
	
	var DIF = (function() {
		function dif_to_aoa(d, opts) {
			switch(opts.type) {
				case 'base64': return dif_to_aoa_str(Base64.decode(d), opts);
				case 'binary': return dif_to_aoa_str(d, opts);
				case 'buffer': return dif_to_aoa_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array': return dif_to_aoa_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
		function dif_to_aoa_str(str, opts) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				if (records[ri].trim() === 'BOT') { arr[++R] = []; C = 0; continue; }
				if (R < 0) continue;
				var metadata = records[ri].trim().split(",");
				var type = metadata[0], value = metadata[1];
				++ri;
				var data = records[ri] || "";
				while(((data.match(/["]/g)||[]).length & 1) && ri < records.length - 1) data += "\n" + records[++ri];
				data = data.trim();
				switch (+type) {
					case -1:
						if (data === 'BOT') { arr[++R] = []; C = 0; continue; }
						else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
						break;
					case 0:
						if(data === 'TRUE') arr[R][C] = true;
						else if(data === 'FALSE') arr[R][C] = false;
						else if(!isNaN(fuzzynum(value))) arr[R][C] = fuzzynum(value);
						else if(!isNaN(fuzzydate(value).getDate())) arr[R][C] = parseDate(value);
						else arr[R][C] = value;
						++C; break;
					case 1:
						data = data.slice(1,data.length-1);
						data = data.replace(/""/g, '"');
						if(DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
						arr[R][C++] = data !== '' ? data : null;
						break;
				}
				if (data === 'EOD') break;
			}
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return arr;
		}
	
		function dif_to_sheet(str, opts) { return aoa_to_sheet(dif_to_aoa(str, opts), opts); }
		function dif_to_workbook(str, opts) { return sheet_to_workbook(dif_to_sheet(str, opts), opts); }
	
		var sheet_to_dif = (function() {
			var push_field = function pf(o, topic, v, n, s) {
				o.push(topic);
				o.push(v + "," + n);
				o.push('"' + s.replace(/"/g,'""') + '"');
			};
			var push_value = function po(o, type, v, s) {
				o.push(type + "," + v);
				o.push(type == 1 ? '"' + s.replace(/"/g,'""') + '"' : s);
			};
			return function sheet_to_dif(ws) {
				var o = [];
				var r = safe_decode_range(ws['!ref']), cell;
				var dense = Array.isArray(ws);
				push_field(o, "TABLE", 0, 1, "sheetjs");
				push_field(o, "VECTORS", 0, r.e.r - r.s.r + 1,"");
				push_field(o, "TUPLES", 0, r.e.c - r.s.c + 1,"");
				push_field(o, "DATA", 0, 0,"");
				for(var R = r.s.r; R <= r.e.r; ++R) {
					push_value(o, -1, 0, "BOT");
					for(var C = r.s.c; C <= r.e.c; ++C) {
						var coord = encode_cell({r:R,c:C});
						cell = dense ? (ws[R]||[])[C] : ws[coord];
						if(!cell) { push_value(o, 1, 0, ""); continue;}
						switch(cell.t) {
							case 'n':
								var val = DIF_XL ? cell.w : cell.v;
								if(!val && cell.v != null) val = cell.v;
								if(val == null) {
									if(DIF_XL && cell.f && !cell.F) push_value(o, 1, 0, "=" + cell.f);
									else push_value(o, 1, 0, "");
								}
								else push_value(o, 0, val, "V");
								break;
							case 'b':
								push_value(o, 0, cell.v ? 1 : 0, cell.v ? "TRUE" : "FALSE");
								break;
							case 's':
								push_value(o, 1, 0, (!DIF_XL || isNaN(cell.v)) ? cell.v : '="' + cell.v + '"');
								break;
							case 'd':
								if(!cell.w) cell.w = SSF.format(cell.z || SSF._table[14], datenum(parseDate(cell.v)));
								if(DIF_XL) push_value(o, 0, cell.w, "V");
								else push_value(o, 1, 0, cell.w);
								break;
							default: push_value(o, 1, 0, "");
						}
					}
				}
				push_value(o, -1, 0, "EOD");
				var RS = "\r\n";
				var oo = o.join(RS);
				//while((oo.length & 0x7F) != 0) oo += "\0";
				return oo;
			};
		})();
		return {
			to_workbook: dif_to_workbook,
			to_sheet: dif_to_sheet,
			from_sheet: sheet_to_dif
		};
	})();
	
	var ETH = (function() {
		function decode(s) { return s.replace(/\\b/g,"\\").replace(/\\c/g,":").replace(/\\n/g,"\n"); }
		function encode(s) { return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g,"\\n"); }
	
		function eth_to_aoa(str, opts) {
			var records = str.split('\n'), R = -1, C = -1, ri = 0, arr = [];
			for (; ri !== records.length; ++ri) {
				var record = records[ri].trim().split(":");
				if(record[0] !== 'cell') continue;
				var addr = decode_cell(record[1]);
				if(arr.length <= addr.r) for(R = arr.length; R <= addr.r; ++R) if(!arr[R]) arr[R] = [];
				R = addr.r; C = addr.c;
				switch(record[2]) {
					case 't': arr[R][C] = decode(record[3]); break;
					case 'v': arr[R][C] = +record[3]; break;
					case 'vtf': var _f = record[record.length - 1];
						/* falls through */
					case 'vtc':
						switch(record[3]) {
							case 'nl': arr[R][C] = +record[4] ? true : false; break;
							default: arr[R][C] = +record[4]; break;
						}
						if(record[2] == 'vtf') arr[R][C] = [arr[R][C], _f];
				}
			}
			if(opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
			return arr;
		}
	
		function eth_to_sheet(d, opts) { return aoa_to_sheet(eth_to_aoa(d, opts), opts); }
		function eth_to_workbook(d, opts) { return sheet_to_workbook(eth_to_sheet(d, opts), opts); }
	
		var header = [
			"socialcalc:version:1.5",
			"MIME-Version: 1.0",
			"Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
		].join("\n");
	
		var sep = [
			"--SocialCalcSpreadsheetControlSave",
			"Content-type: text/plain; charset=UTF-8"
		].join("\n") + "\n";
	
		/* TODO: the other parts */
		var meta = [
			"# SocialCalc Spreadsheet Control Save",
			"part:sheet"
		].join("\n");
	
		var end = "--SocialCalcSpreadsheetControlSave--";
	
		function sheet_to_eth_data(ws) {
			if(!ws || !ws['!ref']) return "";
			var o = [], oo = [], cell, coord = "";
			var r = decode_range(ws['!ref']);
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				for(var C = r.s.c; C <= r.e.c; ++C) {
					coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null || cell.t === 'z') continue;
					oo = ["cell", coord, 't'];
					switch(cell.t) {
						case 's': case 'str': oo.push(encode(cell.v)); break;
						case 'n':
							if(!cell.f) { oo[2]='v'; oo[3]=cell.v; }
							else { oo[2]='vtf'; oo[3]='n'; oo[4]=cell.v; oo[5]=encode(cell.f); }
							break;
						case 'b':
							oo[2] = 'vt'+(cell.f?'f':'c'); oo[3]='nl'; oo[4]=cell.v?"1":"0";
							oo[5] = encode(cell.f||(cell.v?'TRUE':'FALSE'));
							break;
						case 'd':
							var t = datenum(parseDate(cell.v));
							oo[2] = 'vtc'; oo[3] = 'nd'; oo[4] = ""+t;
							oo[5] = cell.w || SSF.format(cell.z || SSF._table[14], t);
							break;
						case 'e': continue;
					}
					o.push(oo.join(":"));
				}
			}
			o.push("sheet:c:" + (r.e.c-r.s.c+1) + ":r:" + (r.e.r-r.s.r+1) + ":tvf:1");
			o.push("valueformat:1:text-wiki");
			//o.push("copiedfrom:" + ws['!ref']); // clipboard only
			return o.join("\n");
		}
	
		function sheet_to_eth(ws) {
			return [header, sep, meta, sep, sheet_to_eth_data(ws), end].join("\n");
			// return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
		}
	
		return {
			to_workbook: eth_to_workbook,
			to_sheet: eth_to_sheet,
			from_sheet: sheet_to_eth
		};
	})();
	
	var PRN = (function() {
		function set_text_arr(data, arr, R, C, o) {
			if(o.raw) arr[R][C] = data;
			else if(data === ""){/* empty */}
			else if(data === 'TRUE') arr[R][C] = true;
			else if(data === 'FALSE') arr[R][C] = false;
			else if(!isNaN(fuzzynum(data))) arr[R][C] = fuzzynum(data);
			else if(!isNaN(fuzzydate(data).getDate())) arr[R][C] = parseDate(data);
			else arr[R][C] = data;
		}
	
		function prn_to_aoa_str(f, opts) {
			var o = opts || {};
			var arr = ([]);
			if(!f || f.length === 0) return arr;
			var lines = f.split(/[\r\n]/);
			var L = lines.length - 1;
			while(L >= 0 && lines[L].length === 0) --L;
			var start = 10, idx = 0;
			var R = 0;
			for(; R <= L; ++R) {
				idx = lines[R].indexOf(" ");
				if(idx == -1) idx = lines[R].length; else idx++;
				start = Math.max(start, idx);
			}
			for(R = 0; R <= L; ++R) {
				arr[R] = [];
				/* TODO: confirm that widths are always 10 */
				var C = 0;
				set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
				for(C = 1; C <= (lines[R].length - start)/10 + 1; ++C)
					set_text_arr(lines[R].slice(start+(C-1)*10,start+C*10).trim(),arr,R,C,o);
			}
			if(o.sheetRows) arr = arr.slice(0, o.sheetRows);
			return arr;
		}
	
		// List of accepted CSV separators
		var guess_seps = {
	0x2C: ',',
	0x09: "\t",
	0x3B: ';',
	0x7C: '|'
		};
	
		// CSV separator weights to be used in case of equal numbers
		var guess_sep_weights = {
	0x2C: 3,
	0x09: 2,
	0x3B: 1,
	0x7C: 0
		};
	
		function guess_sep(str) {
			var cnt = {}, instr = false, end = 0, cc = 0;
			for(;end < str.length;++end) {
				if((cc=str.charCodeAt(end)) == 0x22) instr = !instr;
				else if(!instr && cc in guess_seps) cnt[cc] = (cnt[cc]||0)+1;
			}
	
			cc = [];
			for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
				cc.push([ cnt[end], end ]);
			}
	
			if ( !cc.length ) {
				cnt = guess_sep_weights;
				for(end in cnt) if ( Object.prototype.hasOwnProperty.call(cnt, end) ) {
					cc.push([ cnt[end], end ]);
				}
			}
	
			cc.sort(function(a, b) { return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]]; });
	
			return guess_seps[cc.pop()[1]] || 0x2C;
		}
	
		function dsv_to_sheet_str(str, opts) {
			var o = opts || {};
			var sep = "";
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var ws = o.dense ? ([]) : ({});
			var range = ({s: {c:0, r:0}, e: {c:0, r:0}});
	
			if(str.slice(0,4) == "sep=") {
				// If the line ends in \r\n
				if(str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10 ) {
					sep = str.charAt(4); str = str.slice(7);
				}
				// If line ends in \r OR \n
				else if(str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10 ) {
					sep = str.charAt(4); str = str.slice(6);
				}
				else sep = guess_sep(str.slice(0,1024));
			}
			else if(o && o.FS) sep = o.FS;
			else sep = guess_sep(str.slice(0,1024));
			var R = 0, C = 0, v = 0;
			var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc=0, startcc=str.charCodeAt(0);
			str = str.replace(/\r\n/mg, "\n");
			var _re = o.dateNF != null ? dateNF_regex(o.dateNF) : null;
			function finish_cell() {
				var s = str.slice(start, end);
				var cell = ({});
				if(s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1,-1).replace(/""/g,'"');
				if(s.length === 0) cell.t = 'z';
				else if(o.raw) { cell.t = 's'; cell.v = s; }
				else if(s.trim().length === 0) { cell.t = 's'; cell.v = s; }
				else if(s.charCodeAt(0) == 0x3D) {
					if(s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) { cell.t = 's'; cell.v = s.slice(2,-1).replace(/""/g,'"'); }
					else if(fuzzyfmla(s)) { cell.t = 'n'; cell.f = s.slice(1); }
					else { cell.t = 's'; cell.v = s; } }
				else if(s == "TRUE") { cell.t = 'b'; cell.v = true; }
				else if(s == "FALSE") { cell.t = 'b'; cell.v = false; }
				else if(!isNaN(v = fuzzynum(s))) { cell.t = 'n'; if(o.cellText !== false) cell.w = s; cell.v = v; }
				else if(!isNaN(fuzzydate(s).getDate()) || _re && s.match(_re)) {
					cell.z = o.dateNF || SSF._table[14];
					var k = 0;
					if(_re && s.match(_re)){ s=dateNF_fix(s, o.dateNF, (s.match(_re)||[])); k=1; }
					if(o.cellDates) { cell.t = 'd'; cell.v = parseDate(s, k); }
					else { cell.t = 'n'; cell.v = datenum(parseDate(s, k)); }
					if(o.cellText !== false) cell.w = SSF.format(cell.z, cell.v instanceof Date ? datenum(cell.v):cell.v);
					if(!o.cellNF) delete cell.z;
				} else {
					cell.t = 's';
					cell.v = s;
				}
				if(cell.t == 'z'){}
				else if(o.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = cell; }
				else ws[encode_cell({c:C,r:R})] = cell;
				start = end+1; startcc = str.charCodeAt(start);
				if(range.e.c < C) range.e.c = C;
				if(range.e.r < R) range.e.r = R;
				if(cc == sepcc) ++C; else { C = 0; ++R; if(o.sheetRows && o.sheetRows <= R) return true; }
			}
			outer: for(;end < str.length;++end) switch((cc=str.charCodeAt(end))) {
				case 0x22: if(startcc === 0x22) instr = !instr; break;
				case sepcc: case 0x0a: case 0x0d: if(!instr && finish_cell()) break outer; break;
				default: break;
			}
			if(end - start > 0) finish_cell();
	
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function prn_to_sheet_str(str, opts) {
			if(!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
			if(opts.FS) return dsv_to_sheet_str(str, opts);
			if(str.slice(0,4) == "sep=") return dsv_to_sheet_str(str, opts);
			if(str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
			return aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
		}
	
		function prn_to_sheet(d, opts) {
			var str = "", bytes = opts.type == 'string' ? [0,0,0,0] : firstbyte(d, opts);
			switch(opts.type) {
				case 'base64': str = Base64.decode(d); break;
				case 'binary': str = d; break;
				case 'buffer':
					if(opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
					else if(opts.codepage && typeof cptable !== 'undefined') str = cptable.utils.decode(opts.codepage, d);
					else str = has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d);
					break;
				case 'array': str = cc2str(d); break;
				case 'string': str = d; break;
				default: throw new Error("Unrecognized type " + opts.type);
			}
			if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str.slice(3));
			else if(opts.type != 'string' && opts.codepage == 65001) str = utf8read(str);
			else if((opts.type == 'binary') && typeof cptable !== 'undefined' && opts.codepage)  str = cptable.utils.decode(opts.codepage, cptable.utils.encode(28591,str));
			if(str.slice(0,19) == "socialcalc:version:") return ETH.to_sheet(opts.type == 'string' ? str : utf8read(str), opts);
			return prn_to_sheet_str(str, opts);
		}
	
		function prn_to_workbook(d, opts) { return sheet_to_workbook(prn_to_sheet(d, opts), opts); }
	
		function sheet_to_prn(ws) {
			var o = [];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				var oo = [];
				for(var C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C] : ws[coord];
					if(!cell || cell.v == null) { oo.push("          "); continue; }
					var w = (cell.w || (format_cell(cell), cell.w) || "").slice(0,10);
					while(w.length < 10) w += " ";
					oo.push(w + (C === 0 ? " " : ""));
				}
				o.push(oo.join(""));
			}
			return o.join("\n");
		}
	
		return {
			to_workbook: prn_to_workbook,
			to_sheet: prn_to_sheet,
			from_sheet: sheet_to_prn
		};
	})();
	
	/* Excel defaults to SYLK but warns if data is not valid */
	function read_wb_ID(d, opts) {
		var o = opts || {}, OLD_WTF = !!o.WTF; o.WTF = true;
		try {
			var out = SYLK.to_workbook(d, o);
			o.WTF = OLD_WTF;
			return out;
		} catch(e) {
			o.WTF = OLD_WTF;
			if(!e.message.match(/SYLK bad record ID/) && OLD_WTF) throw e;
			return PRN.to_workbook(d, opts);
		}
	}
	
	var WK_ =  (function() {
		function lotushopper(data, cb, opts) {
			if(!data) return;
			prep_blob(data, data.l || 0);
			var Enum = opts.Enum || WK1Enum;
			while(data.l < data.length) {
				var RT = data.read_shift(2);
				var R = Enum[RT] || Enum[0xFFFF];
				var length = data.read_shift(2);
				var tgt = data.l + length;
				var d = R.f && R.f(data, length, opts);
				data.l = tgt;
				if(cb(d, R, RT)) return;
			}
		}
	
		function lotus_to_workbook(d, opts) {
			switch(opts.type) {
				case 'base64': return lotus_to_workbook_buf(s2a(Base64.decode(d)), opts);
				case 'binary': return lotus_to_workbook_buf(s2a(d), opts);
				case 'buffer':
				case 'array': return lotus_to_workbook_buf(d, opts);
			}
			throw "Unsupported type " + opts.type;
		}
	
		function lotus_to_workbook_buf(d, opts) {
			if(!d) return d;
			var o = opts || {};
			if(DENSE != null && o.dense == null) o.dense = DENSE;
			var s = ((o.dense ? [] : {})), n = "Sheet1", next_n = "", sidx = 0;
			var sheets = {}, snames = [], realnames = [];
	
			var refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
			var sheetRows = o.sheetRows || 0;
	
			if(d[2] == 0x00) {
				if(d[3] == 0x08 || d[3] == 0x09) {
					if(d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
				}
			}
	
			if(d[2] == 0x02) {
				o.Enum = WK1Enum;
				lotushopper(d, function(val, R, RT) { switch(RT) {
					case 0x00: /* BOF */
						o.vers = val;
						if(val >= 0x1000) o.qpro = true;
						break;
					case 0x06: refguess = val; break; /* RANGE */
					case 0xCC: if(val) next_n = val; break; /* SHEETNAMECS */
					case 0xDE: next_n = val; break; /* SHEETNAMELP */
					case 0x0F: /* LABEL */
					case 0x33: /* STRING */
						if(!o.qpro) val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x0D: /* INTEGER */
					case 0x0E: /* NUMBER */
					case 0x10: /* FORMULA */
						/* TODO: actual translation of the format code */
						if(RT == 0x0E && (val[2] & 0x70) == 0x70 && (val[2] & 0x0F) > 1 && (val[2] & 0x0F) < 15) {
							val[1].z = o.dateNF || SSF._table[14];
							if(o.cellDates) { val[1].t = 'd'; val[1].v = numdate(val[1].v); }
						}
	
						if(o.qpro) {
							if(val[3] > sidx) {
								s["!ref"] = encode_range(refguess);
								sheets[n] = s;
								snames.push(n);
								s = (o.dense ? [] : {});
								refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
								sidx = val[3]; n = next_n || "Sheet" + (sidx + 1); next_n = "";
							}
						}
	
						var tmpcell = o.dense ? (s[val[0].r]||[])[val[0].c] : s[encode_cell(val[0])];
						if(tmpcell) {
							tmpcell.t = val[1].t; tmpcell.v = val[1].v;
							if(val[1].z != null) tmpcell.z = val[1].z;
							if(val[1].f != null) tmpcell.f = val[1].f;
							break;
						}
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						break;
					default:
				}}, o);
			} else if(d[2] == 0x1A || d[2] == 0x0E) {
				o.Enum = WK3Enum;
				if(d[2] == 0x0E) { o.qpro = true; d.l = 0; }
				lotushopper(d, function(val, R, RT) { switch(RT) {
					case 0xCC: n = val; break; /* SHEETNAMECS */
					case 0x16: /* LABEL16 */
						val[1].v = val[1].v.slice(1);
						/* falls through */
					case 0x17: /* NUMBER17 */
					case 0x18: /* NUMBER18 */
					case 0x19: /* FORMULA19 */
					case 0x25: /* NUMBER25 */
					case 0x27: /* NUMBER27 */
					case 0x28: /* FORMULA28 */
						if(val[3] > sidx) {
							s["!ref"] = encode_range(refguess);
							sheets[n] = s;
							snames.push(n);
							s = (o.dense ? [] : {});
							refguess = {s: {r:0, c:0}, e: {r:0, c:0} };
							sidx = val[3]; n = "Sheet" + (sidx + 1);
						}
						if(sheetRows > 0 && val[0].r >= sheetRows) break;
						if(o.dense) {
							if(!s[val[0].r]) s[val[0].r] = [];
							s[val[0].r][val[0].c] = val[1];
						} else s[encode_cell(val[0])] = val[1];
						if(refguess.e.c < val[0].c) refguess.e.c = val[0].c;
						if(refguess.e.r < val[0].r) refguess.e.r = val[0].r;
						break;
					case 0x1B: /* XFORMAT */
						if(val[0x36b0]) realnames[val[0x36b0][0]] = val[0x36b0][1];
						break;
					case 0x0601: /* SHEETINFOQP */
						realnames[val[0]] = val[1]; if(val[0] == sidx) n = val[1]; break;
					default: break;
				}}, o);
			} else throw new Error("Unrecognized LOTUS BOF " + d[2]);
			s["!ref"] = encode_range(refguess);
			sheets[next_n || n] = s;
			snames.push(next_n || n);
			if(!realnames.length) return { SheetNames: snames, Sheets: sheets };
			var osheets = {}, rnames = [];
			/* TODO: verify no collisions */
			for(var i = 0; i < realnames.length; ++i) if(sheets[snames[i]]) {
				rnames.push(realnames[i] || snames[i]);
				osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
			} else {
				rnames.push(realnames[i]);
				osheets[realnames[i]] = ({ "!ref": "A1" });
			}
			return { SheetNames: rnames, Sheets: osheets };
		}
	
		function sheet_to_wk1(ws, opts) {
			var o = opts || {};
			if(+o.codepage >= 0) set_cp(+o.codepage);
			if(o.type == "string") throw new Error("Cannot write WK1 to JS string");
			var ba = buf_array();
			var range = safe_decode_range(ws["!ref"]);
			var dense = Array.isArray(ws);
			var cols = [];
	
			write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
			write_biff_rec(ba, 0x06, write_RANGE(range));
			var max_R = Math.min(range.e.r, 8191);
			for(var R = range.s.r; R <= max_R; ++R) {
				var rr = encode_row(R);
				for(var C = range.s.c; C <= range.e.c; ++C) {
					if(R === range.s.r) cols[C] = encode_col(C);
					var ref = cols[C] + rr;
					var cell = dense ? (ws[R]||[])[C] : ws[ref];
					if(!cell || cell.t == "z") continue;
					/* TODO: formula records */
					if(cell.t == "n") {
						if((cell.v|0)==cell.v && cell.v >= -32768 && cell.v <= 32767) write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell.v));
						else write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell.v));
					} else {
						var str = format_cell(cell);
						write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
					}
				}
			}
	
			write_biff_rec(ba, 0x01);
			return ba.end();
		}
	
		function book_to_wk3(wb, opts) {
			var o = opts || {};
			if(+o.codepage >= 0) set_cp(+o.codepage);
			if(o.type == "string") throw new Error("Cannot write WK3 to JS string");
			var ba = buf_array();
	
			write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
	
			for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i) if((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
	
			var wsidx = 0;
			for(i = 0; i < wb.SheetNames.length; ++i) {
				var ws = wb.Sheets[wb.SheetNames[i]];
				if(!ws || !ws["!ref"]) continue;
				var range = safe_decode_range(ws["!ref"]);
				var dense = Array.isArray(ws);
				var cols = [];
				var max_R = Math.min(range.e.r, 8191);
				for(var R = range.s.r; R <= max_R; ++R) {
					var rr = encode_row(R);
					for(var C = range.s.c; C <= range.e.c; ++C) {
						if(R === range.s.r) cols[C] = encode_col(C);
						var ref = cols[C] + rr;
						var cell = dense ? (ws[R]||[])[C] : ws[ref];
						if(!cell || cell.t == "z") continue;
						/* TODO: FORMULA19 NUMBER18 records */
						if(cell.t == "n") {
							write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
						} else {
							var str = format_cell(cell);
							/* TODO: max len? */
							write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
						}
					}
				}
				++wsidx;
			}
	
			write_biff_rec(ba, 0x01);
			return ba.end();
		}
	
	
		function write_BOF_WK1(v) {
			var out = new_buf(2);
			out.write_shift(2, v);
			return out;
		}
	
		function write_BOF_WK3(wb) {
			var out = new_buf(26);
			out.write_shift(2, 0x1000);
			out.write_shift(2, 0x0004);
			out.write_shift(4, 0x0000);
			var rows = 0, cols = 0, wscnt = 0;
			for(var i = 0; i < wb.SheetNames.length; ++i) {
				var name = wb.SheetNames[i];
				var ws = wb.Sheets[name];
				if(!ws || !ws["!ref"]) continue;
				++wscnt;
				var range = decode_range(ws["!ref"]);
				if(rows < range.e.r) rows = range.e.r;
				if(cols < range.e.c) cols = range.e.c;
			}
			if(rows > 8191) rows = 8191;
			out.write_shift(2, rows);
			out.write_shift(1, wscnt);
			out.write_shift(1, cols);
			out.write_shift(2, 0x00);
			out.write_shift(2, 0x00);
			out.write_shift(1, 0x01);
			out.write_shift(1, 0x02);
			out.write_shift(4, 0);
			out.write_shift(4, 0);
			return out;
		}
	
		function parse_RANGE(blob, length, opts) {
			var o = {s:{c:0,r:0},e:{c:0,r:0}};
			if(length == 8 && opts.qpro) {
				o.s.c = blob.read_shift(1);
				blob.l++;
				o.s.r = blob.read_shift(2);
				o.e.c = blob.read_shift(1);
				blob.l++;
				o.e.r = blob.read_shift(2);
				return o;
			}
			o.s.c = blob.read_shift(2);
			o.s.r = blob.read_shift(2);
			if(length == 12 && opts.qpro) blob.l += 2;
			o.e.c = blob.read_shift(2);
			o.e.r = blob.read_shift(2);
			if(length == 12 && opts.qpro) blob.l += 2;
			if(o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
			return o;
		}
		function write_RANGE(range) {
			var out = new_buf(8);
			out.write_shift(2, range.s.c);
			out.write_shift(2, range.s.r);
			out.write_shift(2, range.e.c);
			out.write_shift(2, range.e.r);
			return out;
		}
	
		function parse_cell(blob, length, opts) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0, 0];
			if(opts.qpro && opts.vers != 0x5120) {
				o[0].c = blob.read_shift(1);
				o[3] = blob.read_shift(1);
				o[0].r = blob.read_shift(2);
				blob.l+=2;
			} else {
				o[2] = blob.read_shift(1);
				o[0].c = blob.read_shift(2); o[0].r = blob.read_shift(2);
			}
			return o;
		}
	
		function parse_LABEL(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			o[1].t = 's';
			if(opts.vers == 0x5120) {
				blob.l++;
				var len = blob.read_shift(1);
				o[1].v = blob.read_shift(len, 'utf8');
				return o;
			}
			if(opts.qpro) blob.l++;
			o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
			return o;
		}
		function write_LABEL(R, C, s) {
			/* TODO: encoding */
			var o = new_buf(7 + s.length);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(1, 0x27); // ??
			for(var i = 0; i < o.length; ++i) {
				var cc = s.charCodeAt(i);
				o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
			}
			o.write_shift(1, 0);
			return o;
		}
	
		function parse_INTEGER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(2, 'i');
			return o;
		}
		function write_INTEGER(R, C, v) {
			var o = new_buf(7);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(2, v, 'i');
			return o;
		}
	
		function parse_NUMBER(blob, length, opts) {
			var o = parse_cell(blob, length, opts);
			o[1].v = blob.read_shift(8, 'f');
			return o;
		}
		function write_NUMBER(R, C, v) {
			var o = new_buf(13);
			o.write_shift(1, 0xFF);
			o.write_shift(2, C);
			o.write_shift(2, R);
			o.write_shift(8, v, 'f');
			return o;
		}
	
		function parse_FORMULA(blob, length, opts) {
			var tgt = blob.l + length;
			var o = parse_cell(blob, length, opts);
			/* TODO: formula */
			o[1].v = blob.read_shift(8, 'f');
			if(opts.qpro) blob.l = tgt;
			else {
				var flen = blob.read_shift(2);
				wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
				blob.l += flen;
			}
			return o;
		}
	
		function wk1_parse_rc(B, V, col) {
			var rel = V & 0x8000;
			V &= ~0x8000;
			V = (rel ? B : 0) + ((V >= 0x2000) ? V - 0x4000 : V);
			return (rel ? "" : "$") + (col ? encode_col(V) : encode_row(V));
		}
		var oprec = [
			8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
			3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
		];
		/* TODO: flesh out */
		var FuncTab = {
			0x33: ["FALSE", 0],
			0x34: ["TRUE", 0],
			0x46: ["LEN", 1],
			0x50: ["SUM", 69],
			0x51: ["AVERAGEA", 69],
			0x52: ["COUNTA", 69],
			0x53: ["MINA", 69],
			0x54: ["MAXA", 69],
			0x6F: ["T", 1]
		};
		var BinOpTab = [
			  "",   "",   "",   "",   "",   "",   "",   "",
			  "",  "+",  "-",  "*",  "/",  "^",  "=", "<>",
			"<=", ">=",  "<",  ">",   "",   "",   "",   "",
			 "&",   "",   "",   "",   "",   "",   "",   ""
		];
	
		function wk1_fmla_to_csf(blob, o) {
			prep_blob(blob, 0);
			var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
			while(blob.l < blob.length) {
				var cc = blob[blob.l++];
				switch(cc) {
					case 0x00: out.push(blob.read_shift(8, 'f')); break;
					case 0x01: {
						C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						out.push(C + R);
					} break;
					case 0x02: {
						var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
						R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
						out.push(c + r + ":" + C + R);
					} break;
					case 0x03:
						if(blob.l < blob.length) { console.error("WK1 premature formula end"); return; }
						break;
					case 0x04: out.push("(" + out.pop() + ")"); break;
					case 0x05: out.push(blob.read_shift(2)); break;
					case 0x06: {
						/* TODO: text encoding */
						var Z = ""; while((cc = blob[blob.l++])) Z += String.fromCharCode(cc);
						out.push('"' + Z.replace(/"/g, '""') + '"'); break;
					} break;
	
					case 0x08: out.push("-" + out.pop()); break;
					case 0x17: out.push("+" + out.pop()); break;
					case 0x16: out.push("NOT(" + out.pop() + ")"); break;
	
					case 0x14: case 0x15: {
						argR = out.pop(); argL = out.pop();
						out.push(["AND", "OR"][cc - 0x14] + "(" + argL + "," + argR + ")");
					} break;
	
					default:
						if(cc < 0x20 && BinOpTab[cc]) {
							argR = out.pop(); argL = out.pop();
							out.push(argL + BinOpTab[cc] + argR);
						} else if(FuncTab[cc]) {
							argc = FuncTab[cc][1];
							if(argc == 69) argc = blob[blob.l++];
							if(argc > out.length) { console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|"); return; }
							var args = out.slice(-argc);
							out.length -= argc;
							out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
						}
						else if(cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
						else if(cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
						else if(cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
						else if(cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
						// possible future functions ??
						else return console.error("WK1 unrecognized opcode " + cc.toString(16));
				}
			}
			if(out.length == 1) o[1].f = "" + out[0];
			else console.error("WK1 bad formula parse |" + out.join("|") + "|");
		}
	
	
		function parse_cell_3(blob) {
			var o = [{c:0,r:0}, {t:'n',v:0}, 0];
			o[0].r = blob.read_shift(2); o[3] = blob[blob.l++]; o[0].c = blob[blob.l++];
			return o;
		}
	
		function parse_LABEL_16(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].t = 's';
			o[1].v = blob.read_shift(length - 4, 'cstr');
			return o;
		}
		function write_LABEL_16(R, C, wsidx, s) {
			/* TODO: encoding */
			var o = new_buf(6 + s.length);
			o.write_shift(2, R);
			o.write_shift(1, wsidx);
			o.write_shift(1, C);
			o.write_shift(1, 0x27);
			for(var i = 0; i < s.length; ++i) {
				var cc = s.charCodeAt(i);
				o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
			}
			o.write_shift(1, 0);
			return o;
		}
	
		function parse_NUMBER_18(blob, length) {
			var o = parse_cell_3(blob, length);
			o[1].v = blob.read_shift(2);
			var v = o[1].v >> 1;
			if(o[1].v & 0x1) {
				switch(v & 0x07) {
					case 0: v = (v >> 3) * 5000; break;
					case 1: v = (v >> 3) * 500; break;
					case 2: v = (v >> 3) / 20; break;
					case 3: v = (v >> 3) / 200; break;
					case 4: v = (v >> 3) / 2000; break;
					case 5: v = (v >> 3) / 20000; break;
					case 6: v = (v >> 3) / 16; break;
					case 7: v = (v >> 3) / 64; break;
				}
			}
			o[1].v = v;
			return o;
		}
	
		function parse_NUMBER_17(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			var v2 = blob.read_shift(4);
			var e = blob.read_shift(2);
			if(e == 0xFFFF) {
				if(v1 === 0 && v2 === 0xC0000000) { o[1].t = "e"; o[1].v = 0x0F; } // ERR -> #VALUE!
				else if(v1 === 0 && v2 === 0xD0000000) { o[1].t = "e"; o[1].v = 0x2A; } // NA -> #N/A
				else o[1].v = 0;
				return o;
			}
			var s = e & 0x8000; e = (e&0x7FFF) - 16446;
			o[1].v = (1 - s*2) * (v2 * Math.pow(2, e+32) + v1 * Math.pow(2, e));
			return o;
		}
		function write_NUMBER_17(R, C, wsidx, v) {
			var o = new_buf(14);
			o.write_shift(2, R);
			o.write_shift(1, wsidx);
			o.write_shift(1, C);
			if(v == 0) {
				o.write_shift(4, 0);
				o.write_shift(4, 0);
				o.write_shift(2, 0xFFFF);
				return o;
			}
			var s = 0, e = 0, v1 = 0, v2 = 0;
			if(v < 0) { s = 1; v = -v; }
			e = Math.log2(v) | 0;
			v /= Math.pow(2, e-31);
			v2 = (v)>>>0;
			if((v2&0x80000000) == 0) { v/=2; ++e; v2 = v >>> 0; }
			v -= v2;
			v2 |= 0x80000000;
			v2 >>>= 0;
			v *= Math.pow(2, 32);
			v1 = v>>>0;
			o.write_shift(4, v1);
			o.write_shift(4, v2);
			e += 0x3FFF + (s ? 0x8000 : 0);
			o.write_shift(2, e);
			return o;
		}
	
		function parse_FORMULA_19(blob, length) {
			var o = parse_NUMBER_17(blob, 14);
			blob.l += length - 14; /* TODO: WK3 formula */
			return o;
		}
	
		function parse_NUMBER_25(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(4);
			o[1].v = v1 >> 6;
			return o;
		}
	
		function parse_NUMBER_27(blob, length) {
			var o = parse_cell_3(blob, length);
			var v1 = blob.read_shift(8,'f');
			o[1].v = v1;
			return o;
		}
	
		function parse_FORMULA_28(blob, length) {
			var o = parse_NUMBER_27(blob, 14);
			blob.l += length - 10; /* TODO: formula */
			return o;
		}
	
		function parse_SHEETNAMECS(blob, length) {
			return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
		}
	
		function parse_SHEETNAMELP(blob, length) {
			var len = blob[blob.l++];
			if(len > length - 1) len = length - 1;
			var o = ""; while(o.length < len) o += String.fromCharCode(blob[blob.l++]);
			return o;
		}
	
		function parse_SHEETINFOQP(blob, length, opts) {
			if(!opts.qpro || length < 21) return;
			var id = blob.read_shift(1);
			blob.l += 17;
			var len = blob.read_shift(1);
			blob.l += 2;
			var nm = blob.read_shift(length - 21, 'cstr');
			return [id, nm];
		}
	
		function parse_XFORMAT(blob, length) {
			var o = {}, tgt = blob.l + length;
			while(blob.l < tgt) {
				var dt = blob.read_shift(2);
				if(dt == 0x36b0) {
					o[dt] = [0, ""];
					o[dt][0] = blob.read_shift(2);
					while(blob[blob.l]) { o[dt][1] += String.fromCharCode(blob[blob.l]); blob.l++; } blob.l++;
				}
				// TODO: 0x3a99 ??
			}
			return o;
		}
		function write_XFORMAT_SHEETNAME(name, wsidx) {
			var out = new_buf(5 + name.length);
			out.write_shift(2, 0x36b0);
			out.write_shift(2, wsidx);
			for(var i = 0; i < name.length; ++i) {
				var cc = name.charCodeAt(i);
				out[out.l++] = cc > 0x7F ? 0x5F : cc;
			}
			out[out.l++] = 0;
			return out;
		}
	
		var WK1Enum = {
	0x0000: { n:"BOF", f:parseuint16 },
	0x0001: { n:"EOF" },
	0x0002: { n:"CALCMODE" },
	0x0003: { n:"CALCORDER" },
	0x0004: { n:"SPLIT" },
	0x0005: { n:"SYNC" },
	0x0006: { n:"RANGE", f:parse_RANGE },
	0x0007: { n:"WINDOW1" },
	0x0008: { n:"COLW1" },
	0x0009: { n:"WINTWO" },
	0x000A: { n:"COLW2" },
	0x000B: { n:"NAME" },
	0x000C: { n:"BLANK" },
	0x000D: { n:"INTEGER", f:parse_INTEGER },
	0x000E: { n:"NUMBER", f:parse_NUMBER },
	0x000F: { n:"LABEL", f:parse_LABEL },
	0x0010: { n:"FORMULA", f:parse_FORMULA },
	0x0018: { n:"TABLE" },
	0x0019: { n:"ORANGE" },
	0x001A: { n:"PRANGE" },
	0x001B: { n:"SRANGE" },
	0x001C: { n:"FRANGE" },
	0x001D: { n:"KRANGE1" },
	0x0020: { n:"HRANGE" },
	0x0023: { n:"KRANGE2" },
	0x0024: { n:"PROTEC" },
	0x0025: { n:"FOOTER" },
	0x0026: { n:"HEADER" },
	0x0027: { n:"SETUP" },
	0x0028: { n:"MARGINS" },
	0x0029: { n:"LABELFMT" },
	0x002A: { n:"TITLES" },
	0x002B: { n:"SHEETJS" },
	0x002D: { n:"GRAPH" },
	0x002E: { n:"NGRAPH" },
	0x002F: { n:"CALCCOUNT" },
	0x0030: { n:"UNFORMATTED" },
	0x0031: { n:"CURSORW12" },
	0x0032: { n:"WINDOW" },
	0x0033: { n:"STRING", f:parse_LABEL },
	0x0037: { n:"PASSWORD" },
	0x0038: { n:"LOCKED" },
	0x003C: { n:"QUERY" },
	0x003D: { n:"QUERYNAME" },
	0x003E: { n:"PRINT" },
	0x003F: { n:"PRINTNAME" },
	0x0040: { n:"GRAPH2" },
	0x0041: { n:"GRAPHNAME" },
	0x0042: { n:"ZOOM" },
	0x0043: { n:"SYMSPLIT" },
	0x0044: { n:"NSROWS" },
	0x0045: { n:"NSCOLS" },
	0x0046: { n:"RULER" },
	0x0047: { n:"NNAME" },
	0x0048: { n:"ACOMM" },
	0x0049: { n:"AMACRO" },
	0x004A: { n:"PARSE" },
	0x0066: { n:"PRANGES??" },
	0x0067: { n:"RRANGES??" },
	0x0068: { n:"FNAME??" },
	0x0069: { n:"MRANGES??" },
	0x00CC: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
	0x00DE: { n:"SHEETNAMELP", f:parse_SHEETNAMELP },
	0xFFFF: { n:"" }
		};
	
		var WK3Enum = {
	0x0000: { n:"BOF" },
	0x0001: { n:"EOF" },
	0x0002: { n:"PASSWORD" },
	0x0003: { n:"CALCSET" },
	0x0004: { n:"WINDOWSET" },
	0x0005: { n:"SHEETCELLPTR" },
	0x0006: { n:"SHEETLAYOUT" },
	0x0007: { n:"COLUMNWIDTH" },
	0x0008: { n:"HIDDENCOLUMN" },
	0x0009: { n:"USERRANGE" },
	0x000A: { n:"SYSTEMRANGE" },
	0x000B: { n:"ZEROFORCE" },
	0x000C: { n:"SORTKEYDIR" },
	0x000D: { n:"FILESEAL" },
	0x000E: { n:"DATAFILLNUMS" },
	0x000F: { n:"PRINTMAIN" },
	0x0010: { n:"PRINTSTRING" },
	0x0011: { n:"GRAPHMAIN" },
	0x0012: { n:"GRAPHSTRING" },
	0x0013: { n:"??" },
	0x0014: { n:"ERRCELL" },
	0x0015: { n:"NACELL" },
	0x0016: { n:"LABEL16", f:parse_LABEL_16},
	0x0017: { n:"NUMBER17", f:parse_NUMBER_17 },
	0x0018: { n:"NUMBER18", f:parse_NUMBER_18 },
	0x0019: { n:"FORMULA19", f:parse_FORMULA_19},
	0x001A: { n:"FORMULA1A" },
	0x001B: { n:"XFORMAT", f:parse_XFORMAT },
	0x001C: { n:"DTLABELMISC" },
	0x001D: { n:"DTLABELCELL" },
	0x001E: { n:"GRAPHWINDOW" },
	0x001F: { n:"CPA" },
	0x0020: { n:"LPLAUTO" },
	0x0021: { n:"QUERY" },
	0x0022: { n:"HIDDENSHEET" },
	0x0023: { n:"??" },
	0x0025: { n:"NUMBER25", f:parse_NUMBER_25 },
	0x0026: { n:"??" },
	0x0027: { n:"NUMBER27", f:parse_NUMBER_27 },
	0x0028: { n:"FORMULA28", f:parse_FORMULA_28 },
	0x008E: { n:"??" },
	0x0093: { n:"??" },
	0x0096: { n:"??" },
	0x0097: { n:"??" },
	0x0098: { n:"??" },
	0x0099: { n:"??" },
	0x009A: { n:"??" },
	0x009B: { n:"??" },
	0x009C: { n:"??" },
	0x00A3: { n:"??" },
	0x00AE: { n:"??" },
	0x00AF: { n:"??" },
	0x00B0: { n:"??" },
	0x00B1: { n:"??" },
	0x00B8: { n:"??" },
	0x00B9: { n:"??" },
	0x00BA: { n:"??" },
	0x00BB: { n:"??" },
	0x00BC: { n:"??" },
	0x00C3: { n:"??" },
	0x00C9: { n:"??" },
	0x00CC: { n:"SHEETNAMECS", f:parse_SHEETNAMECS },
	0x00CD: { n:"??" },
	0x00CE: { n:"??" },
	0x00CF: { n:"??" },
	0x00D0: { n:"??" },
	0x0100: { n:"??" },
	0x0103: { n:"??" },
	0x0104: { n:"??" },
	0x0105: { n:"??" },
	0x0106: { n:"??" },
	0x0107: { n:"??" },
	0x0109: { n:"??" },
	0x010A: { n:"??" },
	0x010B: { n:"??" },
	0x010C: { n:"??" },
	0x010E: { n:"??" },
	0x010F: { n:"??" },
	0x0180: { n:"??" },
	0x0185: { n:"??" },
	0x0186: { n:"??" },
	0x0189: { n:"??" },
	0x018C: { n:"??" },
	0x0200: { n:"??" },
	0x0202: { n:"??" },
	0x0201: { n:"??" },
	0x0204: { n:"??" },
	0x0205: { n:"??" },
	0x0280: { n:"??" },
	0x0281: { n:"??" },
	0x0282: { n:"??" },
	0x0283: { n:"??" },
	0x0284: { n:"??" },
	0x0285: { n:"??" },
	0x0286: { n:"??" },
	0x0287: { n:"??" },
	0x0288: { n:"??" },
	0x0292: { n:"??" },
	0x0293: { n:"??" },
	0x0294: { n:"??" },
	0x0295: { n:"??" },
	0x0296: { n:"??" },
	0x0299: { n:"??" },
	0x029A: { n:"??" },
	0x0300: { n:"??" },
	0x0304: { n:"??" },
	0x0601: { n:"SHEETINFOQP", f:parse_SHEETINFOQP },
	0x0640: { n:"??" },
	0x0642: { n:"??" },
	0x0701: { n:"??" },
	0x0702: { n:"??" },
	0x0703: { n:"??" },
	0x0704: { n:"??" },
	0x0780: { n:"??" },
	0x0800: { n:"??" },
	0x0801: { n:"??" },
	0x0804: { n:"??" },
	0x0A80: { n:"??" },
	0x2AF6: { n:"??" },
	0x3231: { n:"??" },
	0x6E49: { n:"??" },
	0x6F44: { n:"??" },
	0xFFFF: { n:"" }
		};
		return {
			sheet_to_wk1: sheet_to_wk1,
			book_to_wk3: book_to_wk3,
			to_workbook: lotus_to_workbook
		};
	})();
	/* 18.4.7 rPr CT_RPrElt */
	function parse_rpr(rpr) {
		var font = {}, m = rpr.match(tagregex), i = 0;
		var pass = false;
		if(m) for(;i!=m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(y[0].replace(/\w*:/g,"")) {
				/* 18.8.12 condense CT_BooleanProperty */
				/* ** not required . */
				case '<condense': break;
				/* 18.8.17 extend CT_BooleanProperty */
				/* ** not required . */
				case '<extend': break;
				/* 18.8.36 shadow CT_BooleanProperty */
				/* ** not required . */
				case '<shadow':
					if(!y.val) break;
					/* falls through */
				case '<shadow>':
				case '<shadow/>': font.shadow = 1; break;
				case '</shadow>': break;
	
				/* 18.4.1 charset CT_IntProperty TODO */
				case '<charset':
					if(y.val == '1') break;
					font.cp = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.4.2 outline CT_BooleanProperty TODO */
				case '<outline':
					if(!y.val) break;
					/* falls through */
				case '<outline>':
				case '<outline/>': font.outline = 1; break;
				case '</outline>': break;
	
				/* 18.4.5 rFont CT_FontName */
				case '<rFont': font.name = y.val; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': font.sz = y.val; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike':
					if(!y.val) break;
					/* falls through */
				case '<strike>':
				case '<strike/>': font.strike = 1; break;
				case '</strike>': break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					if(!y.val) break;
					switch(y.val) {
						case 'double': font.uval = "double"; break;
						case 'singleAccounting': font.uval = "single-accounting"; break;
						case 'doubleAccounting': font.uval = "double-accounting"; break;
					}
					/* falls through */
				case '<u>':
				case '<u/>': font.u = 1; break;
				case '</u>': break;
	
				/* 18.8.2 b */
				case '<b':
					if(y.val == '0') break;
					/* falls through */
				case '<b>':
				case '<b/>': font.b = 1; break;
				case '</b>': break;
	
				/* 18.8.26 i */
				case '<i':
					if(y.val == '0') break;
					/* falls through */
				case '<i>':
				case '<i/>': font.i = 1; break;
				case '</i>': break;
	
				/* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */
				case '<color':
					if(y.rgb) font.color = y.rgb.slice(2,8);
					break;
	
				/* 18.8.18 family ST_FontFamily */
				case '<family': font.family = y.val; break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */
				case '<vertAlign': font.valign = y.val; break;
	
				/* 18.8.35 scheme CT_FontScheme TODO */
				case '<scheme': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default:
					if(y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
			}
		}
		return font;
	}
	
	var parse_rs = (function() {
		var tregex = matchtag("t"), rpregex = matchtag("rPr");
		/* 18.4.4 r CT_RElt */
		function parse_r(r) {
			/* 18.4.12 t ST_Xstring */
			var t = r.match(tregex)/*, cp = 65001*/;
			if(!t) return {t:"s", v:""};
	
			var o = ({t:'s', v:unescapexml(t[1])});
			var rpr = r.match(rpregex);
			if(rpr) o.s = parse_rpr(rpr[1]);
			return o;
		}
		var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
		return function parse_rs(rs) {
			return rs.replace(rregex,"").split(rend).map(parse_r).filter(function(r) { return r.v; });
		};
	})();
	
	
	/* Parse a list of <r> tags */
	var rs_to_html = (function parse_rs_factory() {
		var nlregex = /(\r\n|\n)/g;
		function parse_rpr2(font, intro, outro) {
			var style = [];
	
			if(font.u) style.push("text-decoration: underline;");
			if(font.uval) style.push("text-underline-style:" + font.uval + ";");
			if(font.sz) style.push("font-size:" + font.sz + "pt;");
			if(font.outline) style.push("text-effect: outline;");
			if(font.shadow) style.push("text-shadow: auto;");
			intro.push('<span style="' + style.join("") + '">');
	
			if(font.b) { intro.push("<b>"); outro.push("</b>"); }
			if(font.i) { intro.push("<i>"); outro.push("</i>"); }
			if(font.strike) { intro.push("<s>"); outro.push("</s>"); }
	
			var align = font.valign || "";
			if(align == "superscript" || align == "super") align = "sup";
			else if(align == "subscript") align = "sub";
			if(align != "") { intro.push("<" + align + ">"); outro.push("</" + align + ">"); }
	
			outro.push("</span>");
			return font;
		}
	
		/* 18.4.4 r CT_RElt */
		function r_to_html(r) {
			var terms = [[],r.v,[]];
			if(!r.v) return "";
	
			if(r.s) parse_rpr2(r.s, terms[0], terms[2]);
	
			return terms[0].join("") + terms[1].replace(nlregex,'<br/>') + terms[2].join("");
		}
	
		return function parse_rs(rs) {
			return rs.map(r_to_html).join("");
		};
	})();
	
	/* 18.4.8 si CT_Rst */
	var sitregex = /<(?:\w+:)?t[^>]*>([^<]*)<\/(?:\w+:)?t>/g, sirregex = /<(?:\w+:)?r>/;
	var sirphregex = /<(?:\w+:)?rPh.*?>([\s\S]*?)<\/(?:\w+:)?rPh>/g;
	function parse_si(x, opts) {
		var html = opts ? opts.cellHTML : true;
		var z = {};
		if(!x) return { t: "" };
		//var y;
		/* 18.4.12 t ST_Xstring (Plaintext String) */
		// TODO: is whitespace actually valid here?
		if(x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
			z.t = unescapexml(utf8read(x.slice(x.indexOf(">")+1).split(/<\/(?:\w+:)?t>/)[0]||""));
			z.r = utf8read(x);
			if(html) z.h = escapehtml(z.t);
		}
		/* 18.4.4 r CT_RElt (Rich Text Run) */
		else if((/*y = */x.match(sirregex))) {
			z.r = utf8read(x);
			z.t = unescapexml(utf8read((x.replace(sirphregex, '').match(sitregex)||[]).join("").replace(tagregex,"")));
			if(html) z.h = rs_to_html(parse_rs(z.r));
		}
		/* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */
		/* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */
		return z;
	}
	
	/* 18.4 Shared String Table */
	var sstr0 = /<(?:\w+:)?sst([^>]*)>([\s\S]*)<\/(?:\w+:)?sst>/;
	var sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
	var sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
	function parse_sst_xml(data, opts) {
		var s = ([]), ss = "";
		if(!data) return s;
		/* 18.4.9 sst CT_Sst */
		var sst = data.match(sstr0);
		if(sst) {
			ss = sst[2].replace(sstr1,"").split(sstr2);
			for(var i = 0; i != ss.length; ++i) {
				var o = parse_si(ss[i].trim(), opts);
				if(o != null) s[s.length] = o;
			}
			sst = parsexmltag(sst[1]); s.Count = sst.count; s.Unique = sst.uniqueCount;
		}
		return s;
	}
	
	RELS.SST = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings";
	var straywsregex = /^\s|\s$|[\t\n\r]/;
	function write_sst_xml(sst, opts) {
		if(!opts.bookSST) return "";
		var o = [XML_HEADER];
		o[o.length] = (writextag('sst', null, {
			xmlns: XMLNS.main[0],
			count: sst.Count,
			uniqueCount: sst.Unique
		}));
		for(var i = 0; i != sst.length; ++i) { if(sst[i] == null) continue;
			var s = sst[i];
			var sitag = "<si>";
			if(s.r) sitag += s.r;
			else {
				sitag += "<t";
				if(!s.t) s.t = "";
				if(s.t.match(straywsregex)) sitag += ' xml:space="preserve"';
				sitag += ">" + escapexml(s.t) + "</t>";
			}
			sitag += "</si>";
			o[o.length] = (sitag);
		}
		if(o.length>2){ o[o.length] = ('</sst>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.221 BrtBeginSst */
	function parse_BrtBeginSst(data) {
		return [data.read_shift(4), data.read_shift(4)];
	}
	
	/* [MS-XLSB] 2.1.7.45 Shared Strings */
	function parse_sst_bin(data, opts) {
		var s = ([]);
		var pass = false;
		recordhopper(data, function hopper_sst(val, R_n, RT) {
			switch(RT) {
				case 0x009F: /* 'BrtBeginSst' */
					s.Count = val[0]; s.Unique = val[1]; break;
				case 0x0013: /* 'BrtSSTItem' */
					s.push(val); break;
				case 0x00A0: /* 'BrtEndSst' */
					return true;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
	
				default:
					if(R_n.indexOf("Begin") > 0){/* empty */}
					else if(R_n.indexOf("End") > 0){/* empty */}
					if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		});
		return s;
	}
	
	function write_BrtBeginSst(sst, o) {
		if(!o) o = new_buf(8);
		o.write_shift(4, sst.Count);
		o.write_shift(4, sst.Unique);
		return o;
	}
	
	var write_BrtSSTItem = write_RichStr;
	
	function write_sst_bin(sst) {
		var ba = buf_array();
		write_record(ba, "BrtBeginSst", write_BrtBeginSst(sst));
		for(var i = 0; i < sst.length; ++i) write_record(ba, "BrtSSTItem", write_BrtSSTItem(sst[i]));
		/* FRTSST */
		write_record(ba, "BrtEndSst");
		return ba.end();
	}
	function _JS2ANSI(str) {
		if(typeof cptable !== 'undefined') return cptable.utils.encode(current_ansi, str);
		var o = [], oo = str.split("");
		for(var i = 0; i < oo.length; ++i) o[i] = oo[i].charCodeAt(0);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.4 Version */
	function parse_CRYPTOVersion(blob, length) {
		var o = {};
		o.Major = blob.read_shift(2);
		o.Minor = blob.read_shift(2);
	if(length >= 4) blob.l += length - 4;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */
	function parse_DataSpaceVersionInfo(blob) {
		var o = {};
		o.id = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */
	function parse_DataSpaceMapEntry(blob) {
		var len = blob.read_shift(4);
		var end = blob.l + len - 4;
		var o = {};
		var cnt = blob.read_shift(4);
		var comps = [];
		/* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */
		while(cnt-- > 0) comps.push({ t: blob.read_shift(4), v: blob.read_shift(0, 'lpp4') });
		o.name = blob.read_shift(0, 'lpp4');
		o.comps = comps;
		if(blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */
	function parse_DataSpaceMap(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(parse_DataSpaceMapEntry(blob));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */
	function parse_DataSpaceDefinition(blob) {
		var o = [];
		blob.l += 4; // must be 0x8
		var cnt = blob.read_shift(4);
		while(cnt-- > 0) o.push(blob.read_shift(0, 'lpp4'));
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */
	function parse_TransformInfoHeader(blob) {
		var o = {};
		/*var len = */blob.read_shift(4);
		blob.l += 4; // must be 0x1
		o.id = blob.read_shift(0, 'lpp4');
		o.name = blob.read_shift(0, 'lpp4');
		o.R = parse_CRYPTOVersion(blob, 4);
		o.U = parse_CRYPTOVersion(blob, 4);
		o.W = parse_CRYPTOVersion(blob, 4);
		return o;
	}
	
	function parse_Primary(blob) {
		/* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */
		var hdr = parse_TransformInfoHeader(blob);
		/* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */
		hdr.ename = blob.read_shift(0, '8lpp4');
		hdr.blksz = blob.read_shift(4);
		hdr.cmode = blob.read_shift(4);
		if(blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
		return hdr;
	}
	
	/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */
	function parse_EncryptionHeader(blob, length) {
		var tgt = blob.l + length;
		var o = {};
		o.Flags = (blob.read_shift(4) & 0x3F);
		blob.l += 4;
		o.AlgID = blob.read_shift(4);
		var valid = false;
		switch(o.AlgID) {
			case 0x660E: case 0x660F: case 0x6610: valid = (o.Flags == 0x24); break;
			case 0x6801: valid = (o.Flags == 0x04); break;
			case 0: valid = (o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24); break;
			default: throw 'Unrecognized encryption algorithm: ' + o.AlgID;
		}
		if(!valid) throw new Error("Encryption Flags/AlgID mismatch");
		o.AlgIDHash = blob.read_shift(4);
		o.KeySize = blob.read_shift(4);
		o.ProviderType = blob.read_shift(4);
		blob.l += 8;
		o.CSPName = blob.read_shift((tgt-blob.l)>>1, 'utf16le');
		blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */
	function parse_EncryptionVerifier(blob, length) {
		var o = {}, tgt = blob.l + length;
		blob.l += 4; // SaltSize must be 0x10
		o.Salt = blob.slice(blob.l, blob.l+16); blob.l += 16;
		o.Verifier = blob.slice(blob.l, blob.l+16); blob.l += 16;
		/*var sz = */blob.read_shift(4);
		o.VerifierHash = blob.slice(blob.l, tgt); blob.l = tgt;
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */
	function parse_EncryptionInfo(blob) {
		var vers = parse_CRYPTOVersion(blob);
		switch(vers.Minor) {
			case 0x02: return [vers.Minor, parse_EncInfoStd(blob, vers)];
			case 0x03: return [vers.Minor, parse_EncInfoExt(blob, vers)];
			case 0x04: return [vers.Minor, parse_EncInfoAgl(blob, vers)];
		}
		throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
	}
	
	/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */
	function parse_EncInfoStd(blob) {
		var flags = blob.read_shift(4);
		if((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
		var sz = blob.read_shift(4);
		//var tgt = blob.l + sz;
		var hdr = parse_EncryptionHeader(blob, sz);
		var verifier = parse_EncryptionVerifier(blob, blob.length - blob.l);
		return { t:"Std", h:hdr, v:verifier };
	}
	/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */
	function parse_EncInfoExt() { throw new Error("File is password-protected: ECMA-376 Extensible"); }
	/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */
	function parse_EncInfoAgl(blob) {
		var KeyData = ["saltSize","blockSize","keyBits","hashSize","cipherAlgorithm","cipherChaining","hashAlgorithm","saltValue"];
		blob.l+=4;
		var xml = blob.read_shift(blob.length - blob.l, 'utf8');
		var o = {};
		xml.replace(tagregex, function xml_agile(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
				case '<encryption': case '</encryption>': break;
				case '<keyData': KeyData.forEach(function(k) { o[k] = y[k]; }); break;
				case '<dataIntegrity': o.encryptedHmacKey = y.encryptedHmacKey; o.encryptedHmacValue = y.encryptedHmacValue; break;
				case '<keyEncryptors>': case '<keyEncryptors': o.encs = []; break;
				case '</keyEncryptors>': break;
	
				case '<keyEncryptor': o.uri = y.uri; break;
				case '</keyEncryptor>': break;
				case '<encryptedKey': o.encs.push(y); break;
				default: throw y[0];
			}
		});
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */
	function parse_RC4CryptoHeader(blob, length) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4); length -= 4;
		if(vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
		if(vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
		o.Flags = blob.read_shift(4); length -= 4;
		var sz = blob.read_shift(4); length -= 4;
		o.EncryptionHeader = parse_EncryptionHeader(blob, sz); length -= sz;
		o.EncryptionVerifier = parse_EncryptionVerifier(blob, length);
		return o;
	}
	/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */
	function parse_RC4Header(blob) {
		var o = {};
		var vers = o.EncryptionVersionInfo = parse_CRYPTOVersion(blob, 4);
		if(vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
		o.Salt = blob.read_shift(16);
		o.EncryptedVerifier = blob.read_shift(16);
		o.EncryptedVerifierHash = blob.read_shift(16);
		return o;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */
	function crypto_CreatePasswordVerifier_Method1(Password) {
		var Verifier = 0x0000, PasswordArray;
		var PasswordDecoded = _JS2ANSI(Password);
		var len = PasswordDecoded.length + 1, i, PasswordByte;
		var Intermediate1, Intermediate2, Intermediate3;
		PasswordArray = new_raw_buf(len);
		PasswordArray[0] = PasswordDecoded.length;
		for(i = 1; i != len; ++i) PasswordArray[i] = PasswordDecoded[i-1];
		for(i = len-1; i >= 0; --i) {
			PasswordByte = PasswordArray[i];
			Intermediate1 = ((Verifier & 0x4000) === 0x0000) ? 0 : 1;
			Intermediate2 = (Verifier << 1) & 0x7FFF;
			Intermediate3 = Intermediate1 | Intermediate2;
			Verifier = Intermediate3 ^ PasswordByte;
		}
		return Verifier ^ 0xCE4B;
	}
	
	/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */
	var crypto_CreateXorArray_Method1 = (function() {
		var PadArray = [0xBB, 0xFF, 0xFF, 0xBA, 0xFF, 0xFF, 0xB9, 0x80, 0x00, 0xBE, 0x0F, 0x00, 0xBF, 0x0F, 0x00];
		var InitialCode = [0xE1F0, 0x1D0F, 0xCC9C, 0x84C0, 0x110C, 0x0E10, 0xF1CE, 0x313E, 0x1872, 0xE139, 0xD40F, 0x84F9, 0x280C, 0xA96A, 0x4EC3];
		var XorMatrix = [0xAEFC, 0x4DD9, 0x9BB2, 0x2745, 0x4E8A, 0x9D14, 0x2A09, 0x7B61, 0xF6C2, 0xFDA5, 0xEB6B, 0xC6F7, 0x9DCF, 0x2BBF, 0x4563, 0x8AC6, 0x05AD, 0x0B5A, 0x16B4, 0x2D68, 0x5AD0, 0x0375, 0x06EA, 0x0DD4, 0x1BA8, 0x3750, 0x6EA0, 0xDD40, 0xD849, 0xA0B3, 0x5147, 0xA28E, 0x553D, 0xAA7A, 0x44D5, 0x6F45, 0xDE8A, 0xAD35, 0x4A4B, 0x9496, 0x390D, 0x721A, 0xEB23, 0xC667, 0x9CEF, 0x29FF, 0x53FE, 0xA7FC, 0x5FD9, 0x47D3, 0x8FA6, 0x0F6D, 0x1EDA, 0x3DB4, 0x7B68, 0xF6D0, 0xB861, 0x60E3, 0xC1C6, 0x93AD, 0x377B, 0x6EF6, 0xDDEC, 0x45A0, 0x8B40, 0x06A1, 0x0D42, 0x1A84, 0x3508, 0x6A10, 0xAA51, 0x4483, 0x8906, 0x022D, 0x045A, 0x08B4, 0x1168, 0x76B4, 0xED68, 0xCAF1, 0x85C3, 0x1BA7, 0x374E, 0x6E9C, 0x3730, 0x6E60, 0xDCC0, 0xA9A1, 0x4363, 0x86C6, 0x1DAD, 0x3331, 0x6662, 0xCCC4, 0x89A9, 0x0373, 0x06E6, 0x0DCC, 0x1021, 0x2042, 0x4084, 0x8108, 0x1231, 0x2462, 0x48C4];
		var Ror = function(Byte) { return ((Byte/2) | (Byte*128)) & 0xFF; };
		var XorRor = function(byte1, byte2) { return Ror(byte1 ^ byte2); };
		var CreateXorKey_Method1 = function(Password) {
			var XorKey = InitialCode[Password.length - 1];
			var CurrentElement = 0x68;
			for(var i = Password.length-1; i >= 0; --i) {
				var Char = Password[i];
				for(var j = 0; j != 7; ++j) {
					if(Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
					Char *= 2; --CurrentElement;
				}
			}
			return XorKey;
		};
		return function(password) {
			var Password = _JS2ANSI(password);
			var XorKey = CreateXorKey_Method1(Password);
			var Index = Password.length;
			var ObfuscationArray = new_raw_buf(16);
			for(var i = 0; i != 16; ++i) ObfuscationArray[i] = 0x00;
			var Temp, PasswordLastChar, PadIndex;
			if((Index & 1) === 1) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				PasswordLastChar = Password[Password.length - 1];
				ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
			}
			while(Index > 0) {
				--Index;
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
			}
			Index = 15;
			PadIndex = 15 - Password.length;
			while(PadIndex > 0) {
				Temp = XorKey >> 8;
				ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
				--Index;
				--PadIndex;
				Temp = XorKey & 0xFF;
				ObfuscationArray[Index] = XorRor(Password[Index], Temp);
				--Index;
				--PadIndex;
			}
			return ObfuscationArray;
		};
	})();
	
	/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */
	var crypto_DecryptData_Method1 = function(password, Data, XorArrayIndex, XorArray, O) {
		/* If XorArray is set, use it; if O is not set, make changes in-place */
		if(!O) O = Data;
		if(!XorArray) XorArray = crypto_CreateXorArray_Method1(password);
		var Index, Value;
		for(Index = 0; Index != Data.length; ++Index) {
			Value = Data[Index];
			Value ^= XorArray[XorArrayIndex];
			Value = ((Value>>5) | (Value<<3)) & 0xFF;
			O[Index] = Value;
			++XorArrayIndex;
		}
		return [O, XorArrayIndex, XorArray];
	};
	
	var crypto_MakeXorDecryptor = function(password) {
		var XorArrayIndex = 0, XorArray = crypto_CreateXorArray_Method1(password);
		return function(Data) {
			var O = crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
			XorArrayIndex = O[1];
			return O[0];
		};
	};
	
	/* 2.5.343 */
	function parse_XORObfuscation(blob, length, opts, out) {
		var o = ({ key: parseuint16(blob), verificationBytes: parseuint16(blob) });
		if(opts.password) o.verifier = crypto_CreatePasswordVerifier_Method1(opts.password);
		out.valid = o.verificationBytes === o.verifier;
		if(out.valid) out.insitu = crypto_MakeXorDecryptor(opts.password);
		return o;
	}
	
	/* 2.4.117 */
	function parse_FilePassHeader(blob, length, oo) {
		var o = oo || {}; o.Info = blob.read_shift(2); blob.l -= 2;
		if(o.Info === 1) o.Data = parse_RC4Header(blob, length);
		else o.Data = parse_RC4CryptoHeader(blob, length);
		return o;
	}
	function parse_FilePass(blob, length, opts) {
		var o = ({ Type: opts.biff >= 8 ? blob.read_shift(2) : 0 }); /* wEncryptionType */
		if(o.Type) parse_FilePassHeader(blob, length-2, o);
		else parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
		return o;
	}
	
	
	var RTF = (function() {
		function rtf_to_sheet(d, opts) {
			switch(opts.type) {
				case 'base64': return rtf_to_sheet_str(Base64.decode(d), opts);
				case 'binary': return rtf_to_sheet_str(d, opts);
				case 'buffer': return rtf_to_sheet_str(has_buf && Buffer.isBuffer(d) ? d.toString('binary') : a2s(d), opts);
				case 'array':  return rtf_to_sheet_str(cc2str(d), opts);
			}
			throw new Error("Unrecognized type " + opts.type);
		}
	
		/* TODO: this is a stub */
		function rtf_to_sheet_str(str, opts) {
			var o = opts || {};
			var ws = o.dense ? ([]) : ({});
	
			var rows = str.match(/\\trowd.*?\\row\b/g);
			if(!rows.length) throw new Error("RTF missing table");
			var range = ({s: {c:0, r:0}, e: {c:0, r:rows.length - 1}});
			rows.forEach(function(rowtf, R) {
				if(Array.isArray(ws)) ws[R] = [];
				var rtfre = /\\\w+\b/g;
				var last_index = 0;
				var res;
				var C = -1;
				while((res = rtfre.exec(rowtf))) {
					switch(res[0]) {
						case "\\cell":
							var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
							if(data[0] == " ") data = data.slice(1);
							++C;
							if(data.length) {
								// TODO: value parsing, including codepage adjustments
								var cell = {v: data, t:"s"};
								if(Array.isArray(ws)) ws[R][C] = cell;
								else ws[encode_cell({r:R, c:C})] = cell;
							}
							break;
					}
					last_index = rtfre.lastIndex;
				}
				if(C > range.e.c) range.e.c = C;
			});
			ws['!ref'] = encode_range(range);
			return ws;
		}
	
		function rtf_to_workbook(d, opts) { return sheet_to_workbook(rtf_to_sheet(d, opts), opts); }
	
		/* TODO: this is a stub */
		function sheet_to_rtf(ws) {
			var o = ["{\\rtf1\\ansi"];
			var r = safe_decode_range(ws['!ref']), cell;
			var dense = Array.isArray(ws);
			for(var R = r.s.r; R <= r.e.r; ++R) {
				o.push("\\trowd\\trautofit1");
				for(var C = r.s.c; C <= r.e.c; ++C) o.push("\\cellx" + (C+1));
				o.push("\\pard\\intbl");
				for(C = r.s.c; C <= r.e.c; ++C) {
					var coord = encode_cell({r:R,c:C});
					cell = dense ? (ws[R]||[])[C]: ws[coord];
					if(!cell || cell.v == null && (!cell.f || cell.F)) continue;
					o.push(" " + (cell.w || (format_cell(cell), cell.w)));
					o.push("\\cell");
				}
				o.push("\\pard\\intbl\\row");
			}
			return o.join("") + "}";
		}
	
		return {
			to_workbook: rtf_to_workbook,
			to_sheet: rtf_to_sheet,
			from_sheet: sheet_to_rtf
		};
	})();
	function hex2RGB(h) {
		var o = h.slice(h[0]==="#"?1:0).slice(0,6);
		return [parseInt(o.slice(0,2),16),parseInt(o.slice(2,4),16),parseInt(o.slice(4,6),16)];
	}
	function rgb2Hex(rgb) {
		for(var i=0,o=1; i!=3; ++i) o = o*256 + (rgb[i]>255?255:rgb[i]<0?0:rgb[i]);
		return o.toString(16).toUpperCase().slice(1);
	}
	
	function rgb2HSL(rgb) {
		var R = rgb[0]/255, G = rgb[1]/255, B=rgb[2]/255;
		var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
		if(C === 0) return [0, 0, R];
	
		var H6 = 0, S = 0, L2 = (M + m);
		S = C / (L2 > 1 ? 2 - L2 : L2);
		switch(M){
			case R: H6 = ((G - B) / C + 6)%6; break;
			case G: H6 = ((B - R) / C + 2); break;
			case B: H6 = ((R - G) / C + 4); break;
		}
		return [H6 / 6, S, L2 / 2];
	}
	
	function hsl2RGB(hsl){
		var H = hsl[0], S = hsl[1], L = hsl[2];
		var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C/2;
		var rgb = [m,m,m], h6 = 6*H;
	
		var X;
		if(S !== 0) switch(h6|0) {
			case 0: case 6: X = C * h6; rgb[0] += C; rgb[1] += X; break;
			case 1: X = C * (2 - h6);   rgb[0] += X; rgb[1] += C; break;
			case 2: X = C * (h6 - 2);   rgb[1] += C; rgb[2] += X; break;
			case 3: X = C * (4 - h6);   rgb[1] += X; rgb[2] += C; break;
			case 4: X = C * (h6 - 4);   rgb[2] += C; rgb[0] += X; break;
			case 5: X = C * (6 - h6);   rgb[2] += X; rgb[0] += C; break;
		}
		for(var i = 0; i != 3; ++i) rgb[i] = Math.round(rgb[i]*255);
		return rgb;
	}
	
	/* 18.8.3 bgColor tint algorithm */
	function rgb_tint(hex, tint) {
		if(tint === 0) return hex;
		var hsl = rgb2HSL(hex2RGB(hex));
		if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
		else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
		return rgb2Hex(hsl2RGB(hsl));
	}
	
	/* 18.3.1.13 width calculations */
	/* [MS-OI29500] 2.1.595 Column Width & Formatting */
	var DEF_MDW = 6, MAX_MDW = 15, MIN_MDW = 1, MDW = DEF_MDW;
	function width2px(width) { return Math.floor(( width + (Math.round(128/MDW))/256 )* MDW ); }
	function px2char(px) { return (Math.floor((px - 5)/MDW * 100 + 0.5))/100; }
	function char2width(chr) { return (Math.round((chr * MDW + 5)/MDW*256))/256; }
	//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
	//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
	function cycle_width(collw) { return char2width(px2char(width2px(collw))); }
	/* XLSX/XLSB/XLS specify width in units of MDW */
	function find_mdw_colw(collw) {
		var delta = Math.abs(collw - cycle_width(collw)), _MDW = MDW;
		if(delta > 0.005) for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) if(Math.abs(collw - cycle_width(collw)) <= delta) { delta = Math.abs(collw - cycle_width(collw)); _MDW = MDW; }
		MDW = _MDW;
	}
	/* XLML specifies width in terms of pixels */
	/*function find_mdw_wpx(wpx) {
		var delta = Infinity, guess = 0, _MDW = MIN_MDW;
		for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
			guess = char2width_(px2char_(wpx))*256;
			guess = (guess) % 1;
			if(guess > 0.5) guess--;
			if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
		}
		MDW = _MDW;
	}*/
	
	function process_col(coll) {
		if(coll.width) {
			coll.wpx = width2px(coll.width);
			coll.wch = px2char(coll.wpx);
			coll.MDW = MDW;
		} else if(coll.wpx) {
			coll.wch = px2char(coll.wpx);
			coll.width = char2width(coll.wch);
			coll.MDW = MDW;
		} else if(typeof coll.wch == 'number') {
			coll.width = char2width(coll.wch);
			coll.wpx = width2px(coll.width);
			coll.MDW = MDW;
		}
		if(coll.customWidth) delete coll.customWidth;
	}
	
	var DEF_PPI = 96, PPI = DEF_PPI;
	function px2pt(px) { return px * 96 / PPI; }
	function pt2px(pt) { return pt * PPI / 96; }
	
	/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */
	var XLMLPatternTypeMap = {
		"None": "none",
		"Solid": "solid",
		"Gray50": "mediumGray",
		"Gray75": "darkGray",
		"Gray25": "lightGray",
		"HorzStripe": "darkHorizontal",
		"VertStripe": "darkVertical",
		"ReverseDiagStripe": "darkDown",
		"DiagStripe": "darkUp",
		"DiagCross": "darkGrid",
		"ThickDiagCross": "darkTrellis",
		"ThinHorzStripe": "lightHorizontal",
		"ThinVertStripe": "lightVertical",
		"ThinReverseDiagStripe": "lightDown",
		"ThinHorzCross": "lightGrid"
	};
	
	/* 18.8.5 borders CT_Borders */
	function parse_borders(t, styles, themes, opts) {
		styles.Borders = [];
		var border = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<borders': case '<borders>': case '</borders>': break;
	
				/* 18.8.4 border CT_Border */
				case '<border': case '<border>': case '<border/>':
					border = {};
					if(y.diagonalUp) border.diagonalUp = parsexmlbool(y.diagonalUp);
					if(y.diagonalDown) border.diagonalDown = parsexmlbool(y.diagonalDown);
					styles.Borders.push(border);
					break;
				case '</border>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<left/>': break;
				case '<left': case '<left>': break;
				case '</left>': break;
	
				/* note: not in spec, appears to be CT_BorderPr */
				case '<right/>': break;
				case '<right': case '<right>': break;
				case '</right>': break;
	
				/* 18.8.43 top CT_BorderPr */
				case '<top/>': break;
				case '<top': case '<top>': break;
				case '</top>': break;
	
				/* 18.8.6 bottom CT_BorderPr */
				case '<bottom/>': break;
				case '<bottom': case '<bottom>': break;
				case '</bottom>': break;
	
				/* 18.8.13 diagonal CT_BorderPr */
				case '<diagonal': case '<diagonal>': case '<diagonal/>': break;
				case '</diagonal>': break;
	
				/* 18.8.25 horizontal CT_BorderPr */
				case '<horizontal': case '<horizontal>': case '<horizontal/>': break;
				case '</horizontal>': break;
	
				/* 18.8.44 vertical CT_BorderPr */
				case '<vertical': case '<vertical>': case '<vertical/>': break;
				case '</vertical>': break;
	
				/* 18.8.37 start CT_BorderPr */
				case '<start': case '<start>': case '<start/>': break;
				case '</start>': break;
	
				/* 18.8.16 end CT_BorderPr */
				case '<end': case '<end>': case '<end/>': break;
				case '</end>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color>':
					break;
				case '<color/>': case '</color>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
				}
			}
		});
	}
	
	/* 18.8.21 fills CT_Fills */
	function parse_fills(t, styles, themes, opts) {
		styles.Fills = [];
		var fill = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<fills': case '<fills>': case '</fills>': break;
	
				/* 18.8.20 fill CT_Fill */
				case '<fill>': case '<fill': case '<fill/>':
					fill = {}; styles.Fills.push(fill); break;
				case '</fill>': break;
	
				/* 18.8.24 gradientFill CT_GradientFill */
				case '<gradientFill>': break;
				case '<gradientFill':
				case '</gradientFill>': styles.Fills.push(fill); fill = {}; break;
	
				/* 18.8.32 patternFill CT_PatternFill */
				case '<patternFill': case '<patternFill>':
					if(y.patternType) fill.patternType = y.patternType;
					break;
				case '<patternFill/>': case '</patternFill>': break;
	
				/* 18.8.3 bgColor CT_Color */
				case '<bgColor':
					if(!fill.bgColor) fill.bgColor = {};
					if(y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
					if(y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.bgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
					break;
				case '<bgColor/>': case '</bgColor>': break;
	
				/* 18.8.19 fgColor CT_Color */
				case '<fgColor':
					if(!fill.fgColor) fill.fgColor = {};
					if(y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
					if(y.tint) fill.fgColor.tint = parseFloat(y.tint);
					/* Excel uses ARGB strings */
					if(y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
					break;
				case '<fgColor/>': case '</fgColor>': break;
	
				/* 18.8.38 stop CT_GradientStop */
				case '<stop': case '<stop/>': break;
				case '</stop>': break;
	
				/* 18.8.? color CT_Color */
				case '<color': case '<color/>': break;
				case '</color>': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
				}
			}
		});
	}
	
	/* 18.8.23 fonts CT_Fonts */
	function parse_fonts(t, styles, themes, opts) {
		styles.Fonts = [];
		var font = {};
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<fonts': case '<fonts>': case '</fonts>': break;
	
				/* 18.8.22 font CT_Font */
				case '<font': case '<font>': break;
				case '</font>': case '<font/>':
					styles.Fonts.push(font);
					font = {};
					break;
	
				/* 18.8.29 name CT_FontName */
				case '<name': if(y.val) font.name = utf8read(y.val); break;
				case '<name/>': case '</name>': break;
	
				/* 18.8.2  b CT_BooleanProperty */
				case '<b': font.bold = y.val ? parsexmlbool(y.val) : 1; break;
				case '<b/>': font.bold = 1; break;
	
				/* 18.8.26 i CT_BooleanProperty */
				case '<i': font.italic = y.val ? parsexmlbool(y.val) : 1; break;
				case '<i/>': font.italic = 1; break;
	
				/* 18.4.13 u CT_UnderlineProperty */
				case '<u':
					switch(y.val) {
						case "none": font.underline = 0x00; break;
						case "single": font.underline = 0x01; break;
						case "double": font.underline = 0x02; break;
						case "singleAccounting": font.underline = 0x21; break;
						case "doubleAccounting": font.underline = 0x22; break;
					} break;
				case '<u/>': font.underline = 1; break;
	
				/* 18.4.10 strike CT_BooleanProperty */
				case '<strike': font.strike = y.val ? parsexmlbool(y.val) : 1; break;
				case '<strike/>': font.strike = 1; break;
	
				/* 18.4.2  outline CT_BooleanProperty */
				case '<outline': font.outline = y.val ? parsexmlbool(y.val) : 1; break;
				case '<outline/>': font.outline = 1; break;
	
				/* 18.8.36 shadow CT_BooleanProperty */
				case '<shadow': font.shadow = y.val ? parsexmlbool(y.val) : 1; break;
				case '<shadow/>': font.shadow = 1; break;
	
				/* 18.8.12 condense CT_BooleanProperty */
				case '<condense': font.condense = y.val ? parsexmlbool(y.val) : 1; break;
				case '<condense/>': font.condense = 1; break;
	
				/* 18.8.17 extend CT_BooleanProperty */
				case '<extend': font.extend = y.val ? parsexmlbool(y.val) : 1; break;
				case '<extend/>': font.extend = 1; break;
	
				/* 18.4.11 sz CT_FontSize */
				case '<sz': if(y.val) font.sz = +y.val; break;
				case '<sz/>': case '</sz>': break;
	
				/* 18.4.14 vertAlign CT_VerticalAlignFontProperty */
				case '<vertAlign': if(y.val) font.vertAlign = y.val; break;
				case '<vertAlign/>': case '</vertAlign>': break;
	
				/* 18.8.18 family CT_FontFamily */
				case '<family': if(y.val) font.family = parseInt(y.val,10); break;
				case '<family/>': case '</family>': break;
	
				/* 18.8.35 scheme CT_FontScheme */
				case '<scheme': if(y.val) font.scheme = y.val; break;
				case '<scheme/>': case '</scheme>': break;
	
				/* 18.4.1 charset CT_IntProperty */
				case '<charset':
					if(y.val == '1') break;
					y.codepage = CS2CP[parseInt(y.val, 10)];
					break;
	
				/* 18.?.? color CT_Color */
				case '<color':
					if(!font.color) font.color = {};
					if(y.auto) font.color.auto = parsexmlbool(y.auto);
	
					if(y.rgb) font.color.rgb = y.rgb.slice(-6);
					else if(y.indexed) {
						font.color.index = parseInt(y.indexed, 10);
						var icv = XLSIcv[font.color.index];
						if(font.color.index == 81) icv = XLSIcv[1];
						if(!icv) icv = XLSIcv[1]; //throw new Error(x); // note: 206 is valid
						font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
					} else if(y.theme) {
						font.color.theme = parseInt(y.theme, 10);
						if(y.tint) font.color.tint = parseFloat(y.tint);
						if(y.theme && themes.themeElements && themes.themeElements.clrScheme) {
							font.color.rgb = rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
						}
					}
	
					break;
				case '<color/>': case '</color>': break;
	
				/* note: sometimes mc:AlternateContent appears bare */
				case '<AlternateContent': pass = true; break;
				case '</AlternateContent>': pass = false; break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
				}
			}
		});
	}
	
	/* 18.8.31 numFmts CT_NumFmts */
	function parse_numFmts(t, styles, opts) {
		styles.NumberFmt = [];
		var k/*Array<number>*/ = (keys(SSF._table));
		for(var i=0; i < k.length; ++i) styles.NumberFmt[k[i]] = SSF._table[k[i]];
		var m = t[0].match(tagregex);
		if(!m) return;
		for(i=0; i < m.length; ++i) {
			var y = parsexmltag(m[i]);
			switch(strip_ns(y[0])) {
				case '<numFmts': case '</numFmts>': case '<numFmts/>': case '<numFmts>': break;
				case '<numFmt': {
					var f=unescapexml(utf8read(y.formatCode)), j=parseInt(y.numFmtId,10);
					styles.NumberFmt[j] = f;
					if(j>0) {
						if(j > 0x188) {
							for(j = 0x188; j > 0x3c; --j) if(styles.NumberFmt[j] == null) break;
							styles.NumberFmt[j] = f;
						}
						SSF.load(f,j);
					}
				} break;
				case '</numFmt>': break;
				default: if(opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
			}
		}
	}
	
	function write_numFmts(NF) {
		var o = ["<numFmts>"];
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
			for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) o[o.length] = (writextag('numFmt',null,{numFmtId:i,formatCode:escapexml(NF[i])}));
		});
		if(o.length === 1) return "";
		o[o.length] = ("</numFmts>");
		o[0] = writextag('numFmts', null, { count:o.length-2 }).replace("/>", ">");
		return o.join("");
	}
	
	/* 18.8.10 cellXfs CT_CellXfs */
	var cellXF_uint = [ "numFmtId", "fillId", "fontId", "borderId", "xfId" ];
	var cellXF_bool = [ "applyAlignment", "applyBorder", "applyFill", "applyFont", "applyNumberFormat", "applyProtection", "pivotButton", "quotePrefix" ];
	function parse_cellXfs(t, styles, opts) {
		styles.CellXf = [];
		var xf;
		var pass = false;
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x), i = 0;
			switch(strip_ns(y[0])) {
				case '<cellXfs': case '<cellXfs>': case '<cellXfs/>': case '</cellXfs>': break;
	
				/* 18.8.45 xf CT_Xf */
				case '<xf': case '<xf/>':
					xf = y;
					delete xf[0];
					for(i = 0; i < cellXF_uint.length; ++i) if(xf[cellXF_uint[i]])
						xf[cellXF_uint[i]] = parseInt(xf[cellXF_uint[i]], 10);
					for(i = 0; i < cellXF_bool.length; ++i) if(xf[cellXF_bool[i]])
						xf[cellXF_bool[i]] = parsexmlbool(xf[cellXF_bool[i]]);
					if(styles.NumberFmt && xf.numFmtId > 0x188) {
						for(i = 0x188; i > 0x3c; --i) if(styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) { xf.numFmtId = i; break; }
					}
					styles.CellXf.push(xf); break;
				case '</xf>': break;
	
				/* 18.8.1 alignment CT_CellAlignment */
				case '<alignment': case '<alignment/>':
					var alignment = {};
					if(y.vertical) alignment.vertical = y.vertical;
					if(y.horizontal) alignment.horizontal = y.horizontal;
					if(y.textRotation != null) alignment.textRotation = y.textRotation;
					if(y.indent) alignment.indent = y.indent;
					if(y.wrapText) alignment.wrapText = parsexmlbool(y.wrapText);
					xf.alignment = alignment;
					break;
				case '</alignment>': break;
	
				/* 18.8.33 protection CT_CellProtection */
				case '<protection':
					break;
				case '</protection>': case '<protection/>': break;
	
				/* note: sometimes mc:AlternateContent appears bare */
				case '<AlternateContent': pass = true; break;
				case '</AlternateContent>': pass = false; break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': break;
				case '<ext': pass = true; break;
				case '</ext>': pass = false; break;
				default: if(opts && opts.WTF) {
					if(!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
				}
			}
		});
	}
	
	function write_cellXfs(cellXfs) {
		var o = [];
		o[o.length] = (writextag('cellXfs',null));
		cellXfs.forEach(function(c) {
			o[o.length] = (writextag('xf', null, c));
		});
		o[o.length] = ("</cellXfs>");
		if(o.length === 2) return "";
		o[0] = writextag('cellXfs',null, {count:o.length-2}).replace("/>",">");
		return o.join("");
	}
	
	/* 18.8 Styles CT_Stylesheet*/
	var parse_sty_xml= (function make_pstyx() {
	var numFmtRegex = /<(?:\w+:)?numFmts([^>]*)>[\S\s]*?<\/(?:\w+:)?numFmts>/;
	var cellXfRegex = /<(?:\w+:)?cellXfs([^>]*)>[\S\s]*?<\/(?:\w+:)?cellXfs>/;
	var fillsRegex = /<(?:\w+:)?fills([^>]*)>[\S\s]*?<\/(?:\w+:)?fills>/;
	var fontsRegex = /<(?:\w+:)?fonts([^>]*)>[\S\s]*?<\/(?:\w+:)?fonts>/;
	var bordersRegex = /<(?:\w+:)?borders([^>]*)>[\S\s]*?<\/(?:\w+:)?borders>/;
	
	return function parse_sty_xml(data, themes, opts) {
		var styles = {};
		if(!data) return styles;
		data = data.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
		/* 18.8.39 styleSheet CT_Stylesheet */
		var t;
	
		/* 18.8.31 numFmts CT_NumFmts ? */
		if((t=data.match(numFmtRegex))) parse_numFmts(t, styles, opts);
	
		/* 18.8.23 fonts CT_Fonts ? */
		if((t=data.match(fontsRegex))) parse_fonts(t, styles, themes, opts);
	
		/* 18.8.21 fills CT_Fills ? */
		if((t=data.match(fillsRegex))) parse_fills(t, styles, themes, opts);
	
		/* 18.8.5  borders CT_Borders ? */
		if((t=data.match(bordersRegex))) parse_borders(t, styles, themes, opts);
	
		/* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */
		/* 18.8.8  cellStyles CT_CellStyles ? */
	
		/* 18.8.10 cellXfs CT_CellXfs ? */
		if((t=data.match(cellXfRegex))) parse_cellXfs(t, styles, opts);
	
		/* 18.8.15 dxfs CT_Dxfs ? */
		/* 18.8.42 tableStyles CT_TableStyles ? */
		/* 18.8.11 colors CT_Colors ? */
		/* 18.2.10 extLst CT_ExtensionList ? */
	
		return styles;
	};
	})();
	
	var STYLES_XML_ROOT = writextag('styleSheet', null, {
		'xmlns': XMLNS.main[0],
		'xmlns:vt': XMLNS.vt
	});
	
	RELS.STY = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles";
	
	function write_sty_xml(wb, opts) {
		var o = [XML_HEADER, STYLES_XML_ROOT], w;
		if(wb.SSF && (w = write_numFmts(wb.SSF)) != null) o[o.length] = w;
		o[o.length] = ('<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>');
		o[o.length] = ('<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>');
		o[o.length] = ('<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>');
		o[o.length] = ('<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>');
		if((w = write_cellXfs(opts.cellXfs))) o[o.length] = (w);
		o[o.length] = ('<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>');
		o[o.length] = ('<dxfs count="0"/>');
		o[o.length] = ('<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>');
	
		if(o.length>2){ o[o.length] = ('</styleSheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.657 BrtFmt */
	function parse_BrtFmt(data, length) {
		var numFmtId = data.read_shift(2);
		var stFmtCode = parse_XLWideString(data,length-2);
		return [numFmtId, stFmtCode];
	}
	function write_BrtFmt(i, f, o) {
		if(!o) o = new_buf(6 + 4 * f.length);
		o.write_shift(2, i);
		write_XLWideString(f, o);
		var out = (o.length > o.l) ? o.slice(0, o.l) : o;
		if(o.l == null) o.l = o.length;
		return out;
	}
	
	/* [MS-XLSB] 2.4.659 BrtFont TODO */
	function parse_BrtFont(data, length, opts) {
		var out = ({});
	
		out.sz = data.read_shift(2) / 20;
	
		var grbit = parse_FontFlags(data, 2, opts);
		if(grbit.fItalic) out.italic = 1;
		if(grbit.fCondense) out.condense = 1;
		if(grbit.fExtend) out.extend = 1;
		if(grbit.fShadow) out.shadow = 1;
		if(grbit.fOutline) out.outline = 1;
		if(grbit.fStrikeout) out.strike = 1;
	
		var bls = data.read_shift(2);
		if(bls === 0x02BC) out.bold = 1;
	
		switch(data.read_shift(2)) {
			/* case 0: out.vertAlign = "baseline"; break; */
			case 1: out.vertAlign = "superscript"; break;
			case 2: out.vertAlign = "subscript"; break;
		}
	
		var underline = data.read_shift(1);
		if(underline != 0) out.underline = underline;
	
		var family = data.read_shift(1);
		if(family > 0) out.family = family;
	
		var bCharSet = data.read_shift(1);
		if(bCharSet > 0) out.charset = bCharSet;
	
		data.l++;
		out.color = parse_BrtColor(data, 8);
	
		switch(data.read_shift(1)) {
			/* case 0: out.scheme = "none": break; */
			case 1: out.scheme = "major"; break;
			case 2: out.scheme = "minor"; break;
		}
	
		out.name = parse_XLWideString(data, length - 21);
	
		return out;
	}
	function write_BrtFont(font, o) {
		if(!o) o = new_buf(25+4*32);
		o.write_shift(2, font.sz * 20);
		write_FontFlags(font, o);
		o.write_shift(2, font.bold ? 0x02BC : 0x0190);
		var sss = 0;
		if(font.vertAlign == "superscript") sss = 1;
		else if(font.vertAlign == "subscript") sss = 2;
		o.write_shift(2, sss);
		o.write_shift(1, font.underline || 0);
		o.write_shift(1, font.family || 0);
		o.write_shift(1, font.charset || 0);
		o.write_shift(1, 0);
		write_BrtColor(font.color, o);
		var scheme = 0;
		if(font.scheme == "major") scheme = 1;
		if(font.scheme == "minor") scheme = 2;
		o.write_shift(1, scheme);
		write_XLWideString(font.name, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.650 BrtFill */
	var XLSBFillPTNames = [
		"none",
		"solid",
		"mediumGray",
		"darkGray",
		"lightGray",
		"darkHorizontal",
		"darkVertical",
		"darkDown",
		"darkUp",
		"darkGrid",
		"darkTrellis",
		"lightHorizontal",
		"lightVertical",
		"lightDown",
		"lightUp",
		"lightGrid",
		"lightTrellis",
		"gray125",
		"gray0625"
	];
	var rev_XLSBFillPTNames = (evert(XLSBFillPTNames));
	/* TODO: gradient fill representation */
	var parse_BrtFill = parsenoop;
	function write_BrtFill(fill, o) {
		if(!o) o = new_buf(4*3 + 8*7 + 16*1);
		var fls = rev_XLSBFillPTNames[fill.patternType];
		if(fls == null) fls = 0x28;
		o.write_shift(4, fls);
		var j = 0;
		if(fls != 0x28) {
			/* TODO: custom FG Color */
			write_BrtColor({auto:1}, o);
			/* TODO: custom BG Color */
			write_BrtColor({auto:1}, o);
	
			for(; j < 12; ++j) o.write_shift(4, 0);
		} else {
			for(; j < 4; ++j) o.write_shift(4, 0);
	
			for(; j < 12; ++j) o.write_shift(4, 0); /* TODO */
			/* iGradientType */
			/* xnumDegree */
			/* xnumFillToLeft */
			/* xnumFillToRight */
			/* xnumFillToTop */
			/* xnumFillToBottom */
			/* cNumStop */
			/* xfillGradientStop */
		}
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.824 BrtXF */
	function parse_BrtXF(data, length) {
		var tgt = data.l + length;
		var ixfeParent = data.read_shift(2);
		var ifmt = data.read_shift(2);
		data.l = tgt;
		return {ixfe:ixfeParent, numFmtId:ifmt };
	}
	function write_BrtXF(data, ixfeP, o) {
		if(!o) o = new_buf(16);
		o.write_shift(2, ixfeP||0);
		o.write_shift(2, data.numFmtId||0);
		o.write_shift(2, 0); /* iFont */
		o.write_shift(2, 0); /* iFill */
		o.write_shift(2, 0); /* ixBorder */
		o.write_shift(1, 0); /* trot */
		o.write_shift(1, 0); /* indent */
		var flow = 0;
		o.write_shift(1, flow); /* flags */
		o.write_shift(1, 0); /* flags */
		o.write_shift(1, 0); /* xfGrbitAtr */
		o.write_shift(1, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.5.4 Blxf TODO */
	function write_Blxf(data, o) {
		if(!o) o = new_buf(10);
		o.write_shift(1, 0); /* dg */
		o.write_shift(1, 0);
		o.write_shift(4, 0); /* color */
		o.write_shift(4, 0); /* color */
		return o;
	}
	/* [MS-XLSB] 2.4.302 BrtBorder TODO */
	var parse_BrtBorder = parsenoop;
	function write_BrtBorder(border, o) {
		if(!o) o = new_buf(51);
		o.write_shift(1, 0); /* diagonal */
		write_Blxf(null, o); /* top */
		write_Blxf(null, o); /* bottom */
		write_Blxf(null, o); /* left */
		write_Blxf(null, o); /* right */
		write_Blxf(null, o); /* diag */
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.763 BrtStyle TODO */
	function write_BrtStyle(style, o) {
		if(!o) o = new_buf(12+4*10);
		o.write_shift(4, style.xfId);
		o.write_shift(2, 1);
		o.write_shift(1, +style.builtinId);
		o.write_shift(1, 0); /* iLevel */
		write_XLNullableWideString(style.name || "", o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */
	function write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
		var o = new_buf(4+256*2*4);
		o.write_shift(4, cnt);
		write_XLNullableWideString(defTableStyle, o);
		write_XLNullableWideString(defPivotStyle, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function parse_sty_bin(data, themes, opts) {
		var styles = {};
		styles.NumberFmt = ([]);
		for(var y in SSF._table) styles.NumberFmt[y] = SSF._table[y];
	
		styles.CellXf = [];
		styles.Fonts = [];
		var state = [];
		var pass = false;
		recordhopper(data, function hopper_sty(val, R_n, RT) {
			switch(RT) {
				case 0x002C: /* 'BrtFmt' */
					styles.NumberFmt[val[0]] = val[1]; SSF.load(val[1], val[0]);
					break;
				case 0x002B: /* 'BrtFont' */
					styles.Fonts.push(val);
					if(val.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) {
						val.color.rgb = rgb_tint(themes.themeElements.clrScheme[val.color.theme].rgb, val.color.tint || 0);
					}
					break;
				case 0x0401: /* 'BrtKnownFonts' */ break;
				case 0x002D: /* 'BrtFill' */
					break;
				case 0x002E: /* 'BrtBorder' */
					break;
				case 0x002F: /* 'BrtXF' */
					if(state[state.length - 1] == "BrtBeginCellXFs") {
						styles.CellXf.push(val);
					}
					break;
				case 0x0030: /* 'BrtStyle' */
				case 0x01FB: /* 'BrtDXF' */
				case 0x023C: /* 'BrtMRUColor' */
				case 0x01DB: /* 'BrtIndexedColor': */
					break;
	
				case 0x0493: /* 'BrtDXF14' */
				case 0x0836: /* 'BrtDXF15' */
				case 0x046A: /* 'BrtSlicerStyleElement' */
				case 0x0200: /* 'BrtTableStyleElement' */
				case 0x082F: /* 'BrtTimelineStyleElement' */
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(R_n); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
					else if((R_n||"").indexOf("End") > 0) state.pop();
					else if(!pass || (opts.WTF && state[state.length-1] != "BrtACBegin")) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		});
		return styles;
	}
	
	function write_FMTS_bin(ba, NF) {
		if(!NF) return;
		var cnt = 0;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) ++cnt;
		});
	
		if(cnt == 0) return;
		write_record(ba, "BrtBeginFmts", write_UInt32LE(cnt));
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_record(ba, "BrtFmt", write_BrtFmt(i, NF[i]));
		});
		write_record(ba, "BrtEndFmts");
	}
	
	function write_FONTS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, "BrtBeginFonts", write_UInt32LE(cnt));
		write_record(ba, "BrtFont", write_BrtFont({
			sz:12,
			color: {theme:1},
			name: "Calibri",
			family: 2,
			scheme: "minor"
		}));
		/* 1*65491BrtFont [ACFONTS] */
		write_record(ba, "BrtEndFonts");
	}
	
	function write_FILLS_bin(ba) {
		var cnt = 2;
	
		if(cnt == 0) return;
		write_record(ba, "BrtBeginFills", write_UInt32LE(cnt));
		write_record(ba, "BrtFill", write_BrtFill({patternType:"none"}));
		write_record(ba, "BrtFill", write_BrtFill({patternType:"gray125"}));
		/* 1*65431BrtFill */
		write_record(ba, "BrtEndFills");
	}
	
	function write_BORDERS_bin(ba) {
		var cnt = 1;
	
		if(cnt == 0) return;
		write_record(ba, "BrtBeginBorders", write_UInt32LE(cnt));
		write_record(ba, "BrtBorder", write_BrtBorder({}));
		/* 1*65430BrtBorder */
		write_record(ba, "BrtEndBorders");
	}
	
	function write_CELLSTYLEXFS_bin(ba) {
		var cnt = 1;
		write_record(ba, "BrtBeginCellStyleXFs", write_UInt32LE(cnt));
		write_record(ba, "BrtXF", write_BrtXF({
			numFmtId: 0,
			fontId:   0,
			fillId:   0,
			borderId: 0
		}, 0xFFFF));
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, "BrtEndCellStyleXFs");
	}
	
	function write_CELLXFS_bin(ba, data) {
		write_record(ba, "BrtBeginCellXFs", write_UInt32LE(data.length));
		data.forEach(function(c) { write_record(ba, "BrtXF", write_BrtXF(c,0)); });
		/* 1*65430(BrtXF *FRT) */
		write_record(ba, "BrtEndCellXFs");
	}
	
	function write_STYLES_bin(ba) {
		var cnt = 1;
	
		write_record(ba, "BrtBeginStyles", write_UInt32LE(cnt));
		write_record(ba, "BrtStyle", write_BrtStyle({
			xfId:0,
			builtinId:0,
			name:"Normal"
		}));
		/* 1*65430(BrtStyle *FRT) */
		write_record(ba, "BrtEndStyles");
	}
	
	function write_DXFS_bin(ba) {
		var cnt = 0;
	
		write_record(ba, "BrtBeginDXFs", write_UInt32LE(cnt));
		/* *2147483647(BrtDXF *FRT) */
		write_record(ba, "BrtEndDXFs");
	}
	
	function write_TABLESTYLES_bin(ba) {
		var cnt = 0;
	
		write_record(ba, "BrtBeginTableStyles", write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
		/* *TABLESTYLE */
		write_record(ba, "BrtEndTableStyles");
	}
	
	function write_COLORPALETTE_bin() {
		return;
		/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */
	}
	
	/* [MS-XLSB] 2.1.7.50 Styles */
	function write_sty_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, "BrtBeginStyleSheet");
		write_FMTS_bin(ba, wb.SSF);
		write_FONTS_bin(ba, wb);
		write_FILLS_bin(ba, wb);
		write_BORDERS_bin(ba, wb);
		write_CELLSTYLEXFS_bin(ba, wb);
		write_CELLXFS_bin(ba, opts.cellXfs);
		write_STYLES_bin(ba, wb);
		write_DXFS_bin(ba, wb);
		write_TABLESTYLES_bin(ba, wb);
		write_COLORPALETTE_bin(ba, wb);
		/* FRTSTYLESHEET*/
		write_record(ba, "BrtEndStyleSheet");
		return ba.end();
	}
	RELS.THEME = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme";
	
	/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */
	var XLSXThemeClrScheme = [
		'</a:lt1>', '</a:dk1>', '</a:lt2>', '</a:dk2>',
		'</a:accent1>', '</a:accent2>', '</a:accent3>',
		'</a:accent4>', '</a:accent5>', '</a:accent6>',
		'</a:hlink>', '</a:folHlink>'
	];
	/* 20.1.6.2 clrScheme CT_ColorScheme */
	function parse_clrScheme(t, themes, opts) {
		themes.themeElements.clrScheme = [];
		var color = {};
		(t[0].match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				/* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */
				case '<a:clrScheme': case '</a:clrScheme>': break;
	
				/* 20.1.2.3.32 srgbClr CT_SRgbColor */
				case '<a:srgbClr':
					color.rgb = y.val; break;
	
				/* 20.1.2.3.33 sysClr CT_SystemColor */
				case '<a:sysClr':
					color.rgb = y.lastClr; break;
	
				/* 20.1.4.1.1 accent1 (Accent 1) */
				/* 20.1.4.1.2 accent2 (Accent 2) */
				/* 20.1.4.1.3 accent3 (Accent 3) */
				/* 20.1.4.1.4 accent4 (Accent 4) */
				/* 20.1.4.1.5 accent5 (Accent 5) */
				/* 20.1.4.1.6 accent6 (Accent 6) */
				/* 20.1.4.1.9 dk1 (Dark 1) */
				/* 20.1.4.1.10 dk2 (Dark 2) */
				/* 20.1.4.1.15 folHlink (Followed Hyperlink) */
				/* 20.1.4.1.19 hlink (Hyperlink) */
				/* 20.1.4.1.22 lt1 (Light 1) */
				/* 20.1.4.1.23 lt2 (Light 2) */
				case '<a:dk1>': case '</a:dk1>':
				case '<a:lt1>': case '</a:lt1>':
				case '<a:dk2>': case '</a:dk2>':
				case '<a:lt2>': case '</a:lt2>':
				case '<a:accent1>': case '</a:accent1>':
				case '<a:accent2>': case '</a:accent2>':
				case '<a:accent3>': case '</a:accent3>':
				case '<a:accent4>': case '</a:accent4>':
				case '<a:accent5>': case '</a:accent5>':
				case '<a:accent6>': case '</a:accent6>':
				case '<a:hlink>': case '</a:hlink>':
				case '<a:folHlink>': case '</a:folHlink>':
					if (y[0].charAt(1) === '/') {
						themes.themeElements.clrScheme[XLSXThemeClrScheme.indexOf(y[0])] = color;
						color = {};
					} else {
						color.name = y[0].slice(3, y[0].length - 1);
					}
					break;
	
				default: if(opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
			}
		});
	}
	
	/* 20.1.4.1.18 fontScheme CT_FontScheme */
	function parse_fontScheme() { }
	
	/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */
	function parse_fmtScheme() { }
	
	var clrsregex = /<a:clrScheme([^>]*)>[\s\S]*<\/a:clrScheme>/;
	var fntsregex = /<a:fontScheme([^>]*)>[\s\S]*<\/a:fontScheme>/;
	var fmtsregex = /<a:fmtScheme([^>]*)>[\s\S]*<\/a:fmtScheme>/;
	
	/* 20.1.6.10 themeElements CT_BaseStyles */
	function parse_themeElements(data, themes, opts) {
		themes.themeElements = {};
	
		var t;
	
		[
			/* clrScheme CT_ColorScheme */
			['clrScheme', clrsregex, parse_clrScheme],
			/* fontScheme CT_FontScheme */
			['fontScheme', fntsregex, parse_fontScheme],
			/* fmtScheme CT_StyleMatrix */
			['fmtScheme', fmtsregex, parse_fmtScheme]
		].forEach(function(m) {
			if(!(t=data.match(m[1]))) throw new Error(m[0] + ' not found in themeElements');
			m[2](t, themes, opts);
		});
	}
	
	var themeltregex = /<a:themeElements([^>]*)>[\s\S]*<\/a:themeElements>/;
	
	/* 14.2.7 Theme Part */
	function parse_theme_xml(data, opts) {
		/* 20.1.6.9 theme CT_OfficeStyleSheet */
		if(!data || data.length === 0) return parse_theme_xml(write_theme());
	
		var t;
		var themes = {};
	
		/* themeElements CT_BaseStyles */
		if(!(t=data.match(themeltregex))) throw new Error('themeElements not found in theme');
		parse_themeElements(t[0], themes, opts);
		themes.raw = data;
		return themes;
	}
	
	function write_theme(Themes, opts) {
		if(opts && opts.themeXLSX) return opts.themeXLSX;
		if(Themes && typeof Themes.raw == "string") return Themes.raw;
		var o = [XML_HEADER];
		o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
		o[o.length] =  '<a:themeElements>';
	
		o[o.length] =   '<a:clrScheme name="Office">';
		o[o.length] =    '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
		o[o.length] =    '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
		o[o.length] =    '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
		o[o.length] =    '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
		o[o.length] =    '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
		o[o.length] =    '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
		o[o.length] =    '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
		o[o.length] =    '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
		o[o.length] =    '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
		o[o.length] =    '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
		o[o.length] =    '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
		o[o.length] =    '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
		o[o.length] =   '</a:clrScheme>';
	
		o[o.length] =   '<a:fontScheme name="Office">';
		o[o.length] =    '<a:majorFont>';
		o[o.length] =     '<a:latin typeface="Cambria"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="MoolBoran"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Times New Roman"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:majorFont>';
		o[o.length] =    '<a:minorFont>';
		o[o.length] =     '<a:latin typeface="Calibri"/>';
		o[o.length] =     '<a:ea typeface=""/>';
		o[o.length] =     '<a:cs typeface=""/>';
		o[o.length] =     '<a:font script="Jpan" typeface="ＭＳ Ｐゴシック"/>';
		o[o.length] =     '<a:font script="Hang" typeface="맑은 고딕"/>';
		o[o.length] =     '<a:font script="Hans" typeface="宋体"/>';
		o[o.length] =     '<a:font script="Hant" typeface="新細明體"/>';
		o[o.length] =     '<a:font script="Arab" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Hebr" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Thai" typeface="Tahoma"/>';
		o[o.length] =     '<a:font script="Ethi" typeface="Nyala"/>';
		o[o.length] =     '<a:font script="Beng" typeface="Vrinda"/>';
		o[o.length] =     '<a:font script="Gujr" typeface="Shruti"/>';
		o[o.length] =     '<a:font script="Khmr" typeface="DaunPenh"/>';
		o[o.length] =     '<a:font script="Knda" typeface="Tunga"/>';
		o[o.length] =     '<a:font script="Guru" typeface="Raavi"/>';
		o[o.length] =     '<a:font script="Cans" typeface="Euphemia"/>';
		o[o.length] =     '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
		o[o.length] =     '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
		o[o.length] =     '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
		o[o.length] =     '<a:font script="Thaa" typeface="MV Boli"/>';
		o[o.length] =     '<a:font script="Deva" typeface="Mangal"/>';
		o[o.length] =     '<a:font script="Telu" typeface="Gautami"/>';
		o[o.length] =     '<a:font script="Taml" typeface="Latha"/>';
		o[o.length] =     '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
		o[o.length] =     '<a:font script="Orya" typeface="Kalinga"/>';
		o[o.length] =     '<a:font script="Mlym" typeface="Kartika"/>';
		o[o.length] =     '<a:font script="Laoo" typeface="DokChampa"/>';
		o[o.length] =     '<a:font script="Sinh" typeface="Iskoola Pota"/>';
		o[o.length] =     '<a:font script="Mong" typeface="Mongolian Baiti"/>';
		o[o.length] =     '<a:font script="Viet" typeface="Arial"/>';
		o[o.length] =     '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
		o[o.length] =     '<a:font script="Geor" typeface="Sylfaen"/>';
		o[o.length] =    '</a:minorFont>';
		o[o.length] =   '</a:fontScheme>';
	
		o[o.length] =   '<a:fmtScheme name="Office">';
		o[o.length] =    '<a:fillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="1"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:lin ang="16200000" scaled="0"/>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:fillStyleLst>';
		o[o.length] =    '<a:lnStyleLst>';
		o[o.length] =     '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =     '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
		o[o.length] =    '</a:lnStyleLst>';
		o[o.length] =    '<a:effectStyleLst>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =     '<a:effectStyle>';
		o[o.length] =      '<a:effectLst>';
		o[o.length] =       '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
		o[o.length] =      '</a:effectLst>';
		o[o.length] =      '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
		o[o.length] =      '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
		o[o.length] =     '</a:effectStyle>';
		o[o.length] =    '</a:effectStyleLst>';
		o[o.length] =    '<a:bgFillStyleLst>';
		o[o.length] =     '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =     '<a:gradFill rotWithShape="1">';
		o[o.length] =      '<a:gsLst>';
		o[o.length] =       '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
		o[o.length] =       '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
		o[o.length] =      '</a:gsLst>';
		o[o.length] =      '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
		o[o.length] =     '</a:gradFill>';
		o[o.length] =    '</a:bgFillStyleLst>';
		o[o.length] =   '</a:fmtScheme>';
		o[o.length] =  '</a:themeElements>';
	
		o[o.length] =  '<a:objectDefaults>';
		o[o.length] =   '<a:spDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:spDef>';
		o[o.length] =   '<a:lnDef>';
		o[o.length] =    '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
		o[o.length] =   '</a:lnDef>';
		o[o.length] =  '</a:objectDefaults>';
		o[o.length] =  '<a:extraClrSchemeLst/>';
		o[o.length] = '</a:theme>';
		return o.join("");
	}
	/* [MS-XLS] 2.4.326 TODO: payload is a zip file */
	function parse_Theme(blob, length, opts) {
		var end = blob.l + length;
		var dwThemeVersion = blob.read_shift(4);
		if(dwThemeVersion === 124226) return;
		if(!opts.cellStyles) { blob.l = end; return; }
		var data = blob.slice(blob.l);
		blob.l = end;
		var zip; try { zip = zip_read(data, {type: "array"}); } catch(e) { return; }
		var themeXML = getzipstr(zip, "theme/theme/theme1.xml", true);
		if(!themeXML) return;
		return parse_theme_xml(themeXML, opts);
	}
	
	/* 2.5.49 */
	function parse_ColorTheme(blob) { return blob.read_shift(4); }
	
	/* 2.5.155 */
	function parse_FullColorExt(blob) {
		var o = {};
		o.xclrType = blob.read_shift(2);
		o.nTintShade = blob.read_shift(2);
		switch(o.xclrType) {
			case 0: blob.l += 4; break;
			case 1: o.xclrValue = parse_IcvXF(blob, 4); break;
			case 2: o.xclrValue = parse_LongRGBA(blob, 4); break;
			case 3: o.xclrValue = parse_ColorTheme(blob, 4); break;
			case 4: blob.l += 4; break;
		}
		blob.l += 8;
		return o;
	}
	
	/* 2.5.164 TODO: read 7 bits*/
	function parse_IcvXF(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* 2.5.280 */
	function parse_XFExtGradient(blob, length) {
		return parsenoop(blob, length);
	}
	
	/* [MS-XLS] 2.5.108 */
	function parse_ExtProp(blob) {
		var extType = blob.read_shift(2);
		var cb = blob.read_shift(2) - 4;
		var o = [extType];
		switch(extType) {
			case 0x04: case 0x05: case 0x07: case 0x08:
			case 0x09: case 0x0A: case 0x0B: case 0x0D:
				o[1] = parse_FullColorExt(blob, cb); break;
			case 0x06: o[1] = parse_XFExtGradient(blob, cb); break;
			case 0x0E: case 0x0F: o[1] = blob.read_shift(cb === 1 ? 1 : 2); break;
			default: throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
		}
		return o;
	}
	
	/* 2.4.355 */
	function parse_XFExt(blob, length) {
		var end = blob.l + length;
		blob.l += 2;
		var ixfe = blob.read_shift(2);
		blob.l += 2;
		var cexts = blob.read_shift(2);
		var ext = [];
		while(cexts-- > 0) ext.push(parse_ExtProp(blob, end-blob.l));
		return {ixfe:ixfe, ext:ext};
	}
	
	/* xf is an XF, see parse_XFExt for xfext */
	function update_xfext(xf, xfext) {
		xfext.forEach(function(xfe) {
			switch(xfe[0]) { /* 2.5.108 extPropData */
				case 0x04: break; /* foreground color */
				case 0x05: break; /* background color */
				case 0x06: break; /* gradient fill */
				case 0x07: break; /* top cell border color */
				case 0x08: break; /* bottom cell border color */
				case 0x09: break; /* left cell border color */
				case 0x0a: break; /* right cell border color */
				case 0x0b: break; /* diagonal cell border color */
				case 0x0d: /* text color */
					break;
				case 0x0e: break; /* font scheme */
				case 0x0f: break; /* indentation level */
			}
		});
	}
	
	/* 18.6 Calculation Chain */
	function parse_cc_xml(data) {
		var d = [];
		if(!data) return d;
		var i = 1;
		(data.match(tagregex)||[]).forEach(function(x) {
			var y = parsexmltag(x);
			switch(y[0]) {
				case '<?xml': break;
				/* 18.6.2  calcChain CT_CalcChain 1 */
				case '<calcChain': case '<calcChain>': case '</calcChain>': break;
				/* 18.6.1  c CT_CalcCell 1 */
				case '<c': delete y[0]; if(y.i) i = y.i; else y.i = i; d.push(y); break;
			}
		});
		return d;
	}
	
	//function write_cc_xml(data, opts) { }
	
	/* [MS-XLSB] 2.6.4.1 */
	function parse_BrtCalcChainItem$(data) {
		var out = {};
		out.i = data.read_shift(4);
		var cell = {};
		cell.r = data.read_shift(4);
		cell.c = data.read_shift(4);
		out.r = encode_cell(cell);
		var flags = data.read_shift(1);
		if(flags & 0x2) out.l = '1';
		if(flags & 0x8) out.a = '1';
		return out;
	}
	
	/* 18.6 Calculation Chain */
	function parse_cc_bin(data, name, opts) {
		var out = [];
		var pass = false;
		recordhopper(data, function hopper_cc(val, R_n, RT) {
			switch(RT) {
				case 0x003F: /* 'BrtCalcChainItem$' */
					out.push(val); break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		});
		return out;
	}
	
	//function write_cc_bin(data, opts) { }
	/* 18.14 Supplementary Workbook Data */
	function parse_xlink_xml() {
		//var opts = _opts || {};
		//if(opts.WTF) throw "XLSX External Link";
	}
	
	/* [MS-XLSB] 2.1.7.25 External Link */
	function parse_xlink_bin(data, rel, name, _opts) {
		if(!data) return data;
		var opts = _opts || {};
	
		var pass = false, end = false;
	
		recordhopper(data, function xlink_parse(val, R_n, RT) {
			if(end) return;
			switch(RT) {
				case 0x0167: /* 'BrtSupTabs' */
				case 0x016B: /* 'BrtExternTableStart' */
				case 0x016C: /* 'BrtExternTableEnd' */
				case 0x016E: /* 'BrtExternRowHdr' */
				case 0x016F: /* 'BrtExternCellBlank' */
				case 0x0170: /* 'BrtExternCellReal' */
				case 0x0171: /* 'BrtExternCellBool' */
				case 0x0172: /* 'BrtExternCellError' */
				case 0x0173: /* 'BrtExternCellString' */
				case 0x01D8: /* 'BrtExternValueMeta' */
				case 0x0241: /* 'BrtSupNameStart' */
				case 0x0242: /* 'BrtSupNameValueStart' */
				case 0x0243: /* 'BrtSupNameValueEnd' */
				case 0x0244: /* 'BrtSupNameNum' */
				case 0x0245: /* 'BrtSupNameErr' */
				case 0x0246: /* 'BrtSupNameSt' */
				case 0x0247: /* 'BrtSupNameNil' */
				case 0x0248: /* 'BrtSupNameBool' */
				case 0x0249: /* 'BrtSupNameFmla' */
				case 0x024A: /* 'BrtSupNameBits' */
				case 0x024B: /* 'BrtSupNameEnd' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT.toString(16) + " " + R_n);
			}
		}, opts);
	}
	/* 20.5 DrawingML - SpreadsheetML Drawing */
	RELS.IMG = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image";
	RELS.DRAW = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing";
	
	/* 20.5.2.35 wsDr CT_Drawing */
	function parse_drawing(data, rels) {
		if(!data) return "??";
		/*
		  Chartsheet Drawing:
		   - 20.5.2.35 wsDr CT_Drawing
		    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
		     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
		      - 20.1.2.2.16 graphic CT_GraphicalObject
		       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
	          - chart reference
		   the actual type is based on the URI of the graphicData
			TODO: handle embedded charts and other types of graphics
		*/
		var id = (data.match(/<c:chart [^>]*r:id="([^"]*)"/)||["",""])[1];
	
		return rels['!id'][id].Target;
	}
	
	/* L.5.5.2 SpreadsheetML Comments + VML Schema */
	var _shapeid = 1024;
	function write_comments_vml(rId, comments) {
		var csize = [21600, 21600];
		/* L.5.2.1.2 Path Attribute */
		var bbox = ["m0,0l0",csize[1],csize[0],csize[1],csize[0],"0xe"].join(",");
		var o = [
			writextag("xml", null, { 'xmlns:v': XLMLNS.v, 'xmlns:o': XLMLNS.o, 'xmlns:x': XLMLNS.x, 'xmlns:mv': XLMLNS.mv }).replace(/\/>/,">"),
			writextag("o:shapelayout", writextag("o:idmap", null, {'v:ext':"edit", 'data':rId}), {'v:ext':"edit"}),
			writextag("v:shapetype", [
				writextag("v:stroke", null, {joinstyle:"miter"}),
				writextag("v:path", null, {gradientshapeok:"t", 'o:connecttype':"rect"})
			].join(""), {id:"_x0000_t202", 'o:spt':202, coordsize:csize.join(","),path:bbox})
		];
		while(_shapeid < rId * 1000) _shapeid += 1000;
	
		comments.forEach(function(x) {
		var c = decode_cell(x[0]);
		var fillopts = {'color2':"#BEFF82", 'type':"gradient"};
		if(fillopts.type == "gradient") fillopts.angle = "-180";
		var fillparm = fillopts.type == "gradient" ? writextag("o:fill", null, {type:"gradientUnscaled", 'v:ext':"view"}) : null;
		var fillxml = writextag('v:fill', fillparm, fillopts);
	
		var shadata = ({on:"t", 'obscured':"t"});
		++_shapeid;
	
		o = o.concat([
		'<v:shape' + wxt_helper({
			id:'_x0000_s' + _shapeid,
			type:"#_x0000_t202",
			style:"position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : "") ,
			fillcolor:"#ECFAD4",
			strokecolor:"#edeaa1"
		}) + '>',
			fillxml,
			writextag("v:shadow", null, shadata),
			writextag("v:path", null, {'o:connecttype':"none"}),
			'<v:textbox><div style="text-align:left"></div></v:textbox>',
			'<x:ClientData ObjectType="Note">',
				'<x:MoveWithCells/>',
				'<x:SizeWithCells/>',
				/* Part 4 19.4.2.3 Anchor (Anchor) */
				writetag('x:Anchor', [c.c+1, 0, c.r+1, 0, c.c+3, 20, c.r+5, 20].join(",")),
				writetag('x:AutoFill', "False"),
				writetag('x:Row', String(c.r)),
				writetag('x:Column', String(c.c)),
				x[1].hidden ? '' : '<x:Visible/>',
			'</x:ClientData>',
		'</v:shape>'
		]); });
		o.push('</xml>');
		return o.join("");
	}
	RELS.CMNT = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments";
	
	function sheet_insert_comments(sheet, comments) {
		var dense = Array.isArray(sheet);
		var cell;
		comments.forEach(function(comment) {
			var r = decode_cell(comment.ref);
			if(dense) {
				if(!sheet[r.r]) sheet[r.r] = [];
				cell = sheet[r.r][r.c];
			} else cell = sheet[comment.ref];
			if (!cell) {
				cell = ({t:"z"});
				if(dense) sheet[r.r][r.c] = cell;
				else sheet[comment.ref] = cell;
				var range = safe_decode_range(sheet["!ref"]||"BDWGO1000001:A1");
				if(range.s.r > r.r) range.s.r = r.r;
				if(range.e.r < r.r) range.e.r = r.r;
				if(range.s.c > r.c) range.s.c = r.c;
				if(range.e.c < r.c) range.e.c = r.c;
				var encoded = encode_range(range);
				if (encoded !== sheet["!ref"]) sheet["!ref"] = encoded;
			}
	
			if (!cell.c) cell.c = [];
			var o = ({a: comment.author, t: comment.t, r: comment.r});
			if(comment.h) o.h = comment.h;
			cell.c.push(o);
		});
	}
	
	/* 18.7 Comments */
	function parse_comments_xml(data, opts) {
		/* 18.7.6 CT_Comments */
		if(data.match(/<(?:\w+:)?comments *\/>/)) return [];
		var authors = [];
		var commentList = [];
		var authtag = data.match(/<(?:\w+:)?authors>([\s\S]*)<\/(?:\w+:)?authors>/);
		if(authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var a = x.match(/<(?:\w+:)?author[^>]*>(.*)/);
			if(a) authors.push(a[1]);
		});
		var cmnttag = data.match(/<(?:\w+:)?commentList>([\s\S]*)<\/(?:\w+:)?commentList>/);
		if(cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
			if(x === "" || x.trim() === "") return;
			var cm = x.match(/<(?:\w+:)?comment[^>]*>/);
			if(!cm) return;
			var y = parsexmltag(cm[0]);
			var comment = ({ author: y.authorId && authors[y.authorId] || "sheetjsghost", ref: y.ref, guid: y.guid });
			var cell = decode_cell(y.ref);
			if(opts.sheetRows && opts.sheetRows <= cell.r) return;
			var textMatch = x.match(/<(?:\w+:)?text>([\s\S]*)<\/(?:\w+:)?text>/);
			var rt = !!textMatch && !!textMatch[1] && parse_si(textMatch[1]) || {r:"",t:"",h:""};
			comment.r = rt.r;
			if(rt.r == "<t></t>") rt.t = rt.h = "";
			comment.t = (rt.t||"").replace(/\r\n/g,"\n").replace(/\r/g,"\n");
			if(opts.cellHTML) comment.h = rt.h;
			commentList.push(comment);
		});
		return commentList;
	}
	
	var CMNT_XML_ROOT = writextag('comments', null, { 'xmlns': XMLNS.main[0] });
	function write_comments_xml(data) {
		var o = [XML_HEADER, CMNT_XML_ROOT];
	
		var iauthor = [];
		o.push("<authors>");
		data.forEach(function(x) { x[1].forEach(function(w) { var a = escapexml(w.a);
			if(iauthor.indexOf(a) > -1) return;
			iauthor.push(a);
			o.push("<author>" + a + "</author>");
		}); });
		o.push("</authors>");
		o.push("<commentList>");
		data.forEach(function(d) {
			d[1].forEach(function(c) {
				/* 18.7.3 CT_Comment */
				o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf(escapexml(c.a)) + '"><text>');
				o.push(writetag("t", c.t == null ? "" : escapexml(c.t)));
				o.push('</text></comment>');
			});
		});
		o.push("</commentList>");
		if(o.length>2) { o[o.length] = ('</comments>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.28 BrtBeginComment */
	function parse_BrtBeginComment(data) {
		var out = {};
		out.iauthor = data.read_shift(4);
		var rfx = parse_UncheckedRfX(data, 16);
		out.rfx = rfx.s;
		out.ref = encode_cell(rfx.s);
		data.l += 16; /*var guid = parse_GUID(data); */
		return out;
	}
	function write_BrtBeginComment(data, o) {
		if(o == null) o = new_buf(36);
		o.write_shift(4, data[1].iauthor);
		write_UncheckedRfX((data[0]), o);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		o.write_shift(4, 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.327 BrtCommentAuthor */
	var parse_BrtCommentAuthor = parse_XLWideString;
	function write_BrtCommentAuthor(data) { return write_XLWideString(data.slice(0, 54)); }
	
	/* [MS-XLSB] 2.1.7.8 Comments */
	function parse_comments_bin(data, opts) {
		var out = [];
		var authors = [];
		var c = {};
		var pass = false;
		recordhopper(data, function hopper_cmnt(val, R_n, RT) {
			switch(RT) {
				case 0x0278: /* 'BrtCommentAuthor' */
					authors.push(val); break;
				case 0x027B: /* 'BrtBeginComment' */
					c = val; break;
				case 0x027D: /* 'BrtCommentText' */
					c.t = val.t; c.h = val.h; c.r = val.r; break;
				case 0x027C: /* 'BrtEndComment' */
					c.author = authors[c.iauthor];
					delete (c).iauthor;
					if(opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
					if(!c.t) c.t = "";
					delete c.rfx; out.push(c); break;
	
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */ break;
				case 0x0026: /* 'BrtACEnd' */ break;
	
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		});
		return out;
	}
	
	function write_comments_bin(data) {
		var ba = buf_array();
		var iauthor = [];
		write_record(ba, "BrtBeginComments");
	
		write_record(ba, "BrtBeginCommentAuthors");
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				if(iauthor.indexOf(c.a) > -1) return;
				iauthor.push(c.a.slice(0,54));
				write_record(ba, "BrtCommentAuthor", write_BrtCommentAuthor(c.a));
			});
		});
		write_record(ba, "BrtEndCommentAuthors");
	
		write_record(ba, "BrtBeginCommentList");
		data.forEach(function(comment) {
			comment[1].forEach(function(c) {
				c.iauthor = iauthor.indexOf(c.a);
				var range = {s:decode_cell(comment[0]),e:decode_cell(comment[0])};
				write_record(ba, "BrtBeginComment", write_BrtBeginComment([range, c]));
				if(c.t && c.t.length > 0) write_record(ba, "BrtCommentText", write_BrtCommentText(c));
				write_record(ba, "BrtEndComment");
				delete c.iauthor;
			});
		});
		write_record(ba, "BrtEndCommentList");
	
		write_record(ba, "BrtEndComments");
		return ba.end();
	}
	var CT_VBA = "application/vnd.ms-office.vbaProject";
	function make_vba_xls(cfb) {
		var newcfb = CFB.utils.cfb_new({root:"R"});
		cfb.FullPaths.forEach(function(p, i) {
			if(p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
			var newpath = p.replace(/^[^\/]*/,"R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
			CFB.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
		});
		return CFB.write(newcfb);
	}
	
	function fill_vba_xls(cfb, vba) {
		vba.FullPaths.forEach(function(p, i) {
			if(i == 0) return;
			var newpath = p.replace(/[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
			if(newpath.slice(-1) !== "/") CFB.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
		});
	}
	
	var VBAFMTS = [ "xlsb", "xlsm", "xlam", "biff8", "xla" ];
	
	RELS.DS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet";
	RELS.MS = "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet";
	
	/* macro and dialog sheet stubs */
	function parse_ds_bin() { return {'!type':'dialog'}; }
	function parse_ds_xml() { return {'!type':'dialog'}; }
	function parse_ms_bin() { return {'!type':'macro'}; }
	function parse_ms_xml() { return {'!type':'macro'}; }
	/* TODO: it will be useful to parse the function str */
	var rc_to_a1 = (function(){
		var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
		var rcbase = ({r:0,c:0});
		function rcfunc($$,$1,$2,$3) {
			var cRel = false, rRel = false;
	
			if($2.length == 0) rRel = true;
			else if($2.charAt(0) == "[") { rRel = true; $2 = $2.slice(1, -1); }
	
			if($3.length == 0) cRel = true;
			else if($3.charAt(0) == "[") { cRel = true; $3 = $3.slice(1, -1); }
	
			var R = $2.length>0?parseInt($2,10)|0:0, C = $3.length>0?parseInt($3,10)|0:0;
	
			if(cRel) C += rcbase.c; else --C;
			if(rRel) R += rcbase.r; else --R;
			return $1 + (cRel ? "" : "$") + encode_col(C) + (rRel ? "" : "$") + encode_row(R);
		}
		return function rc_to_a1(fstr, base) {
			rcbase = base;
			return fstr.replace(rcregex, rcfunc);
		};
	})();
	
	var crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
	var a1_to_rc =(function(){
		return function a1_to_rc(fstr, base) {
			return fstr.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
				var c = decode_col($3) - ($2 ? 0 : base.c);
				var r = decode_row($5) - ($4 ? 0 : base.r);
				var R = (r == 0 ? "" : !$4 ? "[" + r + "]" : (r+1));
				var C = (c == 0 ? "" : !$2 ? "[" + c + "]" : (c+1));
				return $1 + "R" + R + "C" + C;
			});
		};
	})();
	
	/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */
	function shift_formula_str(f, delta) {
		return f.replace(crefregex, function($0, $1, $2, $3, $4, $5) {
			return $1+($2=="$" ? $2+$3 : encode_col(decode_col($3)+delta.c))+($4=="$" ? $4+$5 : encode_row(decode_row($5) + delta.r));
		});
	}
	
	function shift_formula_xlsx(f, range, cell) {
		var r = decode_range(range), s = r.s, c = decode_cell(cell);
		var delta = {r:c.r - s.r, c:c.c - s.c};
		return shift_formula_str(f, delta);
	}
	
	/* TODO: parse formula */
	function fuzzyfmla(f) {
		if(f.length == 1) return false;
		return true;
	}
	
	function _xlfn(f) {
		return f.replace(/_xlfn\./g,"");
	}
	function parseread1(blob) { blob.l+=1; return; }
	
	/* [MS-XLS] 2.5.51 */
	function parse_ColRelU(blob, length) {
		var c = blob.read_shift(length == 1 ? 1 : 2);
		return [c & 0x3FFF, (c >> 14) & 1, (c >> 15) & 1];
	}
	
	/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */
	function parse_RgceArea(blob, length, opts) {
		var w = 2;
		if(opts) {
			if(opts.biff >= 2 && opts.biff <= 5) return parse_RgceArea_BIFF2(blob, length, opts);
			else if(opts.biff == 12) w = 4;
		}
		var r=blob.read_shift(w), R=blob.read_shift(w);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	/* BIFF 2-5 encodes flags in the row field */
	function parse_RgceArea_BIFF2(blob) {
		var r=parse_ColRelU(blob, 2), R=parse_ColRelU(blob, 2);
		var c=blob.read_shift(1);
		var C=blob.read_shift(1);
		return { s:{r:r[0], c:c, cRel:r[1], rRel:r[2]}, e:{r:R[0], c:C, cRel:R[1], rRel:R[2]} };
	}
	
	/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */
	function parse_RgceAreaRel(blob, length, opts) {
		if(opts.biff < 8) return parse_RgceArea_BIFF2(blob, length, opts);
		var r=blob.read_shift(opts.biff == 12 ? 4 : 2), R=blob.read_shift(opts.biff == 12 ? 4 : 2);
		var c=parse_ColRelU(blob, 2);
		var C=parse_ColRelU(blob, 2);
		return { s:{r:r, c:c[0], cRel:c[1], rRel:c[2]}, e:{r:R, c:C[0], cRel:C[1], rRel:C[2]} };
	}
	
	/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */
	function parse_RgceLoc(blob, length, opts) {
		if(opts && opts.biff >= 2 && opts.biff <= 5) return parse_RgceLoc_BIFF2(blob, length, opts);
		var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
		var c = parse_ColRelU(blob, 2);
		return {r:r, c:c[0], cRel:c[1], rRel:c[2]};
	}
	function parse_RgceLoc_BIFF2(blob) {
		var r = parse_ColRelU(blob, 2);
		var c = blob.read_shift(1);
		return {r:r[0], c:c, cRel:r[1], rRel:r[2]};
	}
	
	/* [MS-XLS] 2.5.198.107, 2.5.47 */
	function parse_RgceElfLoc(blob) {
		var r = blob.read_shift(2);
		var c = blob.read_shift(2);
		return {r:r, c:c & 0xFF, fQuoted:!!(c & 0x4000), cRel:c>>15, rRel:c>>15 };
	}
	
	/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */
	function parse_RgceLocRel(blob, length, opts) {
		var biff = opts && opts.biff ? opts.biff : 8;
		if(biff >= 2 && biff <= 5) return parse_RgceLocRel_BIFF2(blob, length, opts);
		var r = blob.read_shift(biff >= 12 ? 4 : 2);
		var cl = blob.read_shift(2);
		var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
		cl &= 0x3FFF;
		if(rRel == 1) while(r > 0x7FFFF) r -= 0x100000;
		if(cRel == 1) while(cl > 0x1FFF) cl = cl - 0x4000;
		return {r:r,c:cl,cRel:cRel,rRel:rRel};
	}
	function parse_RgceLocRel_BIFF2(blob) {
		var rl = blob.read_shift(2);
		var c = blob.read_shift(1);
		var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
		rl &= 0x3FFF;
		if(rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
		if(cRel == 1 && c >= 0x80) c = c - 0x100;
		return {r:rl,c:c,cRel:cRel,rRel:rRel};
	}
	
	/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */
	function parse_PtgArea(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */
	function parse_PtgArea3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2, 'i');
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		var area = parse_RgceArea(blob, w, opts);
		return [type, ixti, area];
	}
	
	/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */
	function parse_PtgAreaErr(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts && (opts.biff > 8) ? 12 : (opts.biff < 8 ? 6 : 8);
		return [type];
	}
	/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */
	function parse_PtgAreaErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 8;
		if(opts) switch(opts.biff) {
			case 5: blob.l += 12; w = 6; break;
			case 12: w = 12; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */
	function parse_PtgAreaN(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var area = parse_RgceAreaRel(blob, length - 1, opts);
		return [type, area];
	}
	
	/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */
	function parse_PtgArray(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
		return [type];
	}
	
	/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */
	function parse_PtgAttrBaxcel(blob) {
		var bitSemi = blob[blob.l+1] & 0x01; /* 1 = volatile */
		var bitBaxcel = 1;
		blob.l += 4;
		return [bitSemi, bitBaxcel];
	}
	
	/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */
	function parse_PtgAttrChoose(blob, length, opts) {
		blob.l +=2;
		var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		var o = [];
		/* offset is 1 less than the number of elements */
		for(var i = 0; i <= offset; ++i) o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
		return o;
	}
	
	/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */
	function parse_PtgAttrGoto(blob, length, opts) {
		var bitGoto = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitGoto, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */
	function parse_PtgAttrIf(blob, length, opts) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(opts && opts.biff == 2 ? 1 : 2)];
	}
	
	/* [MS-XLSB] 2.5.97.28 */
	function parse_PtgAttrIfError(blob) {
		var bitIf = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += 2;
		return [bitIf, blob.read_shift(2)];
	}
	
	/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */
	function parse_PtgAttrSemi(blob, length, opts) {
		var bitSemi = (blob[blob.l+1] & 0xFF) ? 1 : 0;
		blob.l += opts && opts.biff == 2 ? 3 : 4;
		return [bitSemi];
	}
	
	/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */
	function parse_PtgAttrSpaceType(blob) {
		var type = blob.read_shift(1), cch = blob.read_shift(1);
		return [type, cch];
	}
	
	/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */
	function parse_PtgAttrSpace(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */
	function parse_PtgAttrSpaceSemi(blob) {
		blob.read_shift(2);
		return parse_PtgAttrSpaceType(blob, 2);
	}
	
	/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */
	function parse_PtgRef(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLoc(blob, 0, opts);
		return [type, loc];
	}
	
	/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */
	function parse_PtgRefN(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var loc = parse_RgceLocRel(blob, 0, opts);
		return [type, loc];
	}
	
	/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */
	function parse_PtgRef3d(blob, length, opts) {
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var ixti = blob.read_shift(2); // XtiIndex
		if(opts && opts.biff == 5) blob.l += 12;
		var loc = parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
		return [type, ixti, loc];
	}
	
	
	/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */
	function parse_PtgFunc(blob, length, opts) {
		//var ptg = blob[blob.l] & 0x1F;
		var type = (blob[blob.l] & 0x60)>>5;
		blob.l += 1;
		var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
		return [FtabArgc[iftab], Ftab[iftab], type];
	}
	/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */
	function parse_PtgFuncVar(blob, length, opts) {
		var type = blob[blob.l++];
		var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [(type == 0x58 ? -1 : 0), blob.read_shift(1)]: parsetab(blob);
		return [cparams, (tab[0] === 0 ? Ftab : Cetab)[tab[1]]];
	}
	
	function parsetab(blob) {
		return [blob[blob.l+1]>>7, blob.read_shift(2) & 0x7FFF];
	}
	
	/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */
	function parse_PtgAttrSum(blob, length, opts) {
		blob.l += opts && opts.biff == 2 ? 3 : 4; return;
	}
	
	/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */
	function parse_PtgExp(blob, length, opts) {
		blob.l++;
		if(opts && opts.biff == 12) return [blob.read_shift(4, 'i'), 0];
		var row = blob.read_shift(2);
		var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [row, col];
	}
	
	/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */
	function parse_PtgErr(blob) { blob.l++; return BErr[blob.read_shift(1)]; }
	
	/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */
	function parse_PtgInt(blob) { blob.l++; return blob.read_shift(2); }
	
	/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */
	function parse_PtgBool(blob) { blob.l++; return blob.read_shift(1)!==0;}
	
	/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */
	function parse_PtgNum(blob) { blob.l++; return parse_Xnum(blob, 8); }
	
	/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */
	function parse_PtgStr(blob, length, opts) { blob.l++; return parse_ShortXLUnicodeString(blob, length-1, opts); }
	
	/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */
	/* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */
	function parse_SerAr(blob, biff) {
		var val = [blob.read_shift(1)];
		if(biff == 12) switch(val[0]) {
			case 0x02: val[0] = 0x04; break; /* SerBool */
			case 0x04: val[0] = 0x10; break; /* SerErr */
			case 0x00: val[0] = 0x01; break; /* SerNum */
			case 0x01: val[0] = 0x02; break; /* SerStr */
		}
		switch(val[0]) {
			case 0x04: /* SerBool -- boolean */
				val[1] = parsebool(blob, 1) ? 'TRUE' : 'FALSE';
				if(biff != 12) blob.l += 7; break;
			case 0x25: /* appears to be an alias */
			case 0x10: /* SerErr -- error */
				val[1] = BErr[blob[blob.l]];
				blob.l += ((biff == 12) ? 4 : 8); break;
			case 0x00: /* SerNil -- honestly, I'm not sure how to reproduce this */
				blob.l += 8; break;
			case 0x01: /* SerNum -- Xnum */
				val[1] = parse_Xnum(blob, 8); break;
			case 0x02: /* SerStr -- XLUnicodeString (<256 chars) */
				val[1] = parse_XLUnicodeString2(blob, 0, {biff:biff > 0 && biff < 8 ? 2 : biff}); break;
			default: throw new Error("Bad SerAr: " + val[0]); /* Unreachable */
		}
		return val;
	}
	
	/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */
	function parse_PtgExtraMem(blob, cce, opts) {
		var count = blob.read_shift((opts.biff == 12) ? 4 : 2);
		var out = [];
		for(var i = 0; i != count; ++i) out.push(((opts.biff == 12) ? parse_UncheckedRfX : parse_Ref8U)(blob, 8));
		return out;
	}
	
	/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */
	function parse_PtgExtraArray(blob, length, opts) {
		var rows = 0, cols = 0;
		if(opts.biff == 12) {
			rows = blob.read_shift(4); // DRw
			cols = blob.read_shift(4); // DCol
		} else {
			cols = 1 + blob.read_shift(1); //DColByteU
			rows = 1 + blob.read_shift(2); //DRw
		}
		if(opts.biff >= 2 && opts.biff < 8) { --rows; if(--cols == 0) cols = 0x100; }
		// $FlowIgnore
		for(var i = 0, o = []; i != rows && (o[i] = []); ++i)
			for(var j = 0; j != cols; ++j) o[i][j] = parse_SerAr(blob, opts.biff);
		return o;
	}
	
	/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */
	function parse_PtgName(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var w = (!opts || (opts.biff >= 8)) ? 4 : 2;
		var nameindex = blob.read_shift(w);
		switch(opts.biff) {
			case 2: blob.l += 5; break;
			case 3: case 4: blob.l += 8; break;
			case 5: blob.l += 12; break;
		}
		return [type, 0, nameindex];
	}
	
	/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */
	function parse_PtgNameX(blob, length, opts) {
		if(opts.biff == 5) return parse_PtgNameX_BIFF5(blob, length, opts);
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2); // XtiIndex
		var nameindex = blob.read_shift(4);
		return [type, ixti, nameindex];
	}
	function parse_PtgNameX_BIFF5(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var ixti = blob.read_shift(2, 'i'); // XtiIndex
		blob.l += 8;
		var nameindex = blob.read_shift(2);
		blob.l += 12;
		return [type, ixti, nameindex];
	}
	
	/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */
	function parse_PtgMemArea(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += (opts && opts.biff == 2 ? 3 : 4);
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */
	function parse_PtgMemFunc(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
		return [type, cce];
	}
	
	
	/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */
	function parse_PtgRefErr(blob, length, opts) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		blob.l += 4;
		if(opts.biff < 8) blob.l--;
		if(opts.biff == 12) blob.l += 2;
		return [type];
	}
	
	/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */
	function parse_PtgRefErr3d(blob, length, opts) {
		var type = (blob[blob.l++] & 0x60) >> 5;
		var ixti = blob.read_shift(2);
		var w = 4;
		if(opts) switch(opts.biff) {
			case 5: w = 15; break;
			case 12: w = 6; break;
		}
		blob.l += w;
		return [type, ixti];
	}
	
	/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */
	var parse_PtgMemErr = parsenoop;
	/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */
	var parse_PtgMemNoMem = parsenoop;
	/* [MS-XLS] 2.5.198.92 */
	var parse_PtgTbl = parsenoop;
	
	function parse_PtgElfLoc(blob, length, opts) {
		blob.l += 2;
		return [parse_RgceElfLoc(blob, 4, opts)];
	}
	function parse_PtgElfNoop(blob) {
		blob.l += 6;
		return [];
	}
	/* [MS-XLS] 2.5.198.46 */
	var parse_PtgElfCol = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.47 */
	var parse_PtgElfColS = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.48 */
	var parse_PtgElfColSV = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.49 */
	var parse_PtgElfColV = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.50 */
	function parse_PtgElfLel(blob) {
		blob.l += 2;
		return [parseuint16(blob), blob.read_shift(2) & 0x01];
	}
	/* [MS-XLS] 2.5.198.51 */
	var parse_PtgElfRadical = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.52 */
	var parse_PtgElfRadicalLel = parse_PtgElfLel;
	/* [MS-XLS] 2.5.198.53 */
	var parse_PtgElfRadicalS = parse_PtgElfNoop;
	/* [MS-XLS] 2.5.198.54 */
	var parse_PtgElfRw = parse_PtgElfLoc;
	/* [MS-XLS] 2.5.198.55 */
	var parse_PtgElfRwV = parse_PtgElfLoc;
	
	/* [MS-XLSB] 2.5.97.52 TODO */
	var PtgListRT = [
		"Data",
		"All",
		"Headers",
		"??",
		"?Data2",
		"??",
		"?DataHeaders",
		"??",
		"Totals",
		"??",
		"??",
		"??",
		"?DataTotals",
		"??",
		"??",
		"??",
		"?Current"
	];
	function parse_PtgList(blob) {
		blob.l += 2;
		var ixti = blob.read_shift(2);
		var flags = blob.read_shift(2);
		var idx = blob.read_shift(4);
		var c = blob.read_shift(2);
		var C = blob.read_shift(2);
		var rt = PtgListRT[(flags >> 2) & 0x1F];
		return {ixti: ixti, coltype:(flags&0x3), rt:rt, idx:idx, c:c, C:C};
	}
	/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */
	function parse_PtgSxName(blob) {
		blob.l += 2;
		return [blob.read_shift(4)];
	}
	
	/* [XLS] old spec */
	function parse_PtgSheet(blob, length, opts) {
		blob.l += 5;
		blob.l += 2;
		blob.l += (opts.biff == 2 ? 1 : 4);
		return ["PTGSHEET"];
	}
	function parse_PtgEndSheet(blob, length, opts) {
		blob.l += (opts.biff == 2 ? 4 : 5);
		return ["PTGENDSHEET"];
	}
	function parse_PtgMemAreaN(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	function parse_PtgMemNoMemN(blob) {
		var type = (blob.read_shift(1) >>> 5) & 0x03;
		var cce = blob.read_shift(2);
		return [type, cce];
	}
	function parse_PtgAttrNoop(blob) {
		blob.l += 4;
		return [0, 0];
	}
	
	/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */
	var PtgTypes = {
	0x01: { n:'PtgExp', f:parse_PtgExp },
	0x02: { n:'PtgTbl', f:parse_PtgTbl },
	0x03: { n:'PtgAdd', f:parseread1 },
	0x04: { n:'PtgSub', f:parseread1 },
	0x05: { n:'PtgMul', f:parseread1 },
	0x06: { n:'PtgDiv', f:parseread1 },
	0x07: { n:'PtgPower', f:parseread1 },
	0x08: { n:'PtgConcat', f:parseread1 },
	0x09: { n:'PtgLt', f:parseread1 },
	0x0A: { n:'PtgLe', f:parseread1 },
	0x0B: { n:'PtgEq', f:parseread1 },
	0x0C: { n:'PtgGe', f:parseread1 },
	0x0D: { n:'PtgGt', f:parseread1 },
	0x0E: { n:'PtgNe', f:parseread1 },
	0x0F: { n:'PtgIsect', f:parseread1 },
	0x10: { n:'PtgUnion', f:parseread1 },
	0x11: { n:'PtgRange', f:parseread1 },
	0x12: { n:'PtgUplus', f:parseread1 },
	0x13: { n:'PtgUminus', f:parseread1 },
	0x14: { n:'PtgPercent', f:parseread1 },
	0x15: { n:'PtgParen', f:parseread1 },
	0x16: { n:'PtgMissArg', f:parseread1 },
	0x17: { n:'PtgStr', f:parse_PtgStr },
	0x1A: { n:'PtgSheet', f:parse_PtgSheet },
	0x1B: { n:'PtgEndSheet', f:parse_PtgEndSheet },
	0x1C: { n:'PtgErr', f:parse_PtgErr },
	0x1D: { n:'PtgBool', f:parse_PtgBool },
	0x1E: { n:'PtgInt', f:parse_PtgInt },
	0x1F: { n:'PtgNum', f:parse_PtgNum },
	0x20: { n:'PtgArray', f:parse_PtgArray },
	0x21: { n:'PtgFunc', f:parse_PtgFunc },
	0x22: { n:'PtgFuncVar', f:parse_PtgFuncVar },
	0x23: { n:'PtgName', f:parse_PtgName },
	0x24: { n:'PtgRef', f:parse_PtgRef },
	0x25: { n:'PtgArea', f:parse_PtgArea },
	0x26: { n:'PtgMemArea', f:parse_PtgMemArea },
	0x27: { n:'PtgMemErr', f:parse_PtgMemErr },
	0x28: { n:'PtgMemNoMem', f:parse_PtgMemNoMem },
	0x29: { n:'PtgMemFunc', f:parse_PtgMemFunc },
	0x2A: { n:'PtgRefErr', f:parse_PtgRefErr },
	0x2B: { n:'PtgAreaErr', f:parse_PtgAreaErr },
	0x2C: { n:'PtgRefN', f:parse_PtgRefN },
	0x2D: { n:'PtgAreaN', f:parse_PtgAreaN },
	0x2E: { n:'PtgMemAreaN', f:parse_PtgMemAreaN },
	0x2F: { n:'PtgMemNoMemN', f:parse_PtgMemNoMemN },
	0x39: { n:'PtgNameX', f:parse_PtgNameX },
	0x3A: { n:'PtgRef3d', f:parse_PtgRef3d },
	0x3B: { n:'PtgArea3d', f:parse_PtgArea3d },
	0x3C: { n:'PtgRefErr3d', f:parse_PtgRefErr3d },
	0x3D: { n:'PtgAreaErr3d', f:parse_PtgAreaErr3d },
	0xFF: {}
	};
	/* These are duplicated in the PtgTypes table */
	var PtgDupes = {
	0x40: 0x20, 0x60: 0x20,
	0x41: 0x21, 0x61: 0x21,
	0x42: 0x22, 0x62: 0x22,
	0x43: 0x23, 0x63: 0x23,
	0x44: 0x24, 0x64: 0x24,
	0x45: 0x25, 0x65: 0x25,
	0x46: 0x26, 0x66: 0x26,
	0x47: 0x27, 0x67: 0x27,
	0x48: 0x28, 0x68: 0x28,
	0x49: 0x29, 0x69: 0x29,
	0x4A: 0x2A, 0x6A: 0x2A,
	0x4B: 0x2B, 0x6B: 0x2B,
	0x4C: 0x2C, 0x6C: 0x2C,
	0x4D: 0x2D, 0x6D: 0x2D,
	0x4E: 0x2E, 0x6E: 0x2E,
	0x4F: 0x2F, 0x6F: 0x2F,
	0x58: 0x22, 0x78: 0x22,
	0x59: 0x39, 0x79: 0x39,
	0x5A: 0x3A, 0x7A: 0x3A,
	0x5B: 0x3B, 0x7B: 0x3B,
	0x5C: 0x3C, 0x7C: 0x3C,
	0x5D: 0x3D, 0x7D: 0x3D
	};
	(function(){for(var y in PtgDupes) PtgTypes[y] = PtgTypes[PtgDupes[y]];})();
	
	var Ptg18 = {
	0x01: { n:'PtgElfLel', f:parse_PtgElfLel },
	0x02: { n:'PtgElfRw', f:parse_PtgElfRw },
	0x03: { n:'PtgElfCol', f:parse_PtgElfCol },
	0x06: { n:'PtgElfRwV', f:parse_PtgElfRwV },
	0x07: { n:'PtgElfColV', f:parse_PtgElfColV },
	0x0A: { n:'PtgElfRadical', f:parse_PtgElfRadical },
	0x0B: { n:'PtgElfRadicalS', f:parse_PtgElfRadicalS },
	0x0D: { n:'PtgElfColS', f:parse_PtgElfColS },
	0x0F: { n:'PtgElfColSV', f:parse_PtgElfColSV },
	0x10: { n:'PtgElfRadicalLel', f:parse_PtgElfRadicalLel },
	0x19: { n:'PtgList', f:parse_PtgList },
	0x1D: { n:'PtgSxName', f:parse_PtgSxName },
	0xFF: {}
	};
	var Ptg19 = {
	0x00: { n:'PtgAttrNoop', f:parse_PtgAttrNoop },
	0x01: { n:'PtgAttrSemi', f:parse_PtgAttrSemi },
	0x02: { n:'PtgAttrIf', f:parse_PtgAttrIf },
	0x04: { n:'PtgAttrChoose', f:parse_PtgAttrChoose },
	0x08: { n:'PtgAttrGoto', f:parse_PtgAttrGoto },
	0x10: { n:'PtgAttrSum', f:parse_PtgAttrSum },
	0x20: { n:'PtgAttrBaxcel', f:parse_PtgAttrBaxcel },
	0x40: { n:'PtgAttrSpace', f:parse_PtgAttrSpace },
	0x41: { n:'PtgAttrSpaceSemi', f:parse_PtgAttrSpaceSemi },
	0x80: { n:'PtgAttrIfError', f:parse_PtgAttrIfError },
	0xFF: {}
	};
	Ptg19[0x21] = Ptg19[0x20];
	
	/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */
	function parse_RgbExtra(blob, length, rgce, opts) {
		if(opts.biff < 8) return parsenoop(blob, length);
		var target = blob.l + length;
		var o = [];
		for(var i = 0; i !== rgce.length; ++i) {
			switch(rgce[i][0]) {
				case 'PtgArray': /* PtgArray -> PtgExtraArray */
					rgce[i][1] = parse_PtgExtraArray(blob, 0, opts);
					o.push(rgce[i][1]);
					break;
				case 'PtgMemArea': /* PtgMemArea -> PtgExtraMem */
					rgce[i][2] = parse_PtgExtraMem(blob, rgce[i][1], opts);
					o.push(rgce[i][2]);
					break;
				case 'PtgExp': /* PtgExp -> PtgExtraCol */
					if(opts && opts.biff == 12) {
						rgce[i][1][1] = blob.read_shift(4);
						o.push(rgce[i][1]);
					} break;
				case 'PtgList': /* TODO: PtgList -> PtgExtraList */
				case 'PtgElfRadicalS': /* TODO: PtgElfRadicalS -> PtgExtraElf */
				case 'PtgElfColS': /* TODO: PtgElfColS -> PtgExtraElf */
				case 'PtgElfColSV': /* TODO: PtgElfColSV -> PtgExtraElf */
					throw "Unsupported " + rgce[i][0];
				default: break;
			}
		}
		length = target - blob.l;
		/* note: this is technically an error but Excel disregards */
		//if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
		if(length !== 0) o.push(parsenoop(blob, length));
		return o;
	}
	
	/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */
	function parse_Rgce(blob, length, opts) {
		var target = blob.l + length;
		var R, id, ptgs = [];
		while(target != blob.l) {
			length = target - blob.l;
			id = blob[blob.l];
			R = PtgTypes[id];
			if(id === 0x18 || id === 0x19) R = (id === 0x18 ? Ptg18 : Ptg19)[blob[blob.l + 1]];
			if(!R || !R.f) { /*ptgs.push*/(parsenoop(blob, length)); }
			else { ptgs.push([R.n, R.f(blob, length, opts)]); }
		}
		return ptgs;
	}
	
	function stringify_array(f) {
		var o = [];
		for(var i = 0; i < f.length; ++i) {
			var x = f[i], r = [];
			for(var j = 0; j < x.length; ++j) {
				var y = x[j];
				if(y) switch(y[0]) {
					// TODO: handle embedded quotes
					case 0x02:
	r.push('"' + y[1].replace(/"/g,'""') + '"'); break;
					default: r.push(y[1]);
				} else r.push("");
			}
			o.push(r.join(","));
		}
		return o.join(";");
	}
	
	/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */
	var PtgBinOp = {
		PtgAdd: "+",
		PtgConcat: "&",
		PtgDiv: "/",
		PtgEq: "=",
		PtgGe: ">=",
		PtgGt: ">",
		PtgLe: "<=",
		PtgLt: "<",
		PtgMul: "*",
		PtgNe: "<>",
		PtgPower: "^",
		PtgSub: "-"
	};
	
	// List of invalid characters needs to be tested further
	var quoteCharacters  = new RegExp(/[^\w\u4E00-\u9FFF\u3040-\u30FF]/);
	function formula_quote_sheet_name(sname, opts) {
		if(!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
		if (quoteCharacters.test(sname)) return "'" + sname + "'";
		return sname;
	}
	function get_ixti_raw(supbooks, ixti, opts) {
		if(!supbooks) return "SH33TJSERR0";
		if(opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
		if(!supbooks.XTI) return "SH33TJSERR6";
		var XTI = supbooks.XTI[ixti];
		if(opts.biff < 8) {
			if(ixti > 10000) ixti-= 65536;
			if(ixti < 0) ixti = -ixti;
			return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
		}
		if(!XTI) return "SH33TJSERR1";
		var o = "";
		if(opts.biff > 8) switch(supbooks[XTI[0]][0]) {
			case 0x0165: /* 'BrtSupSelf' */
				o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x0166: /* 'BrtSupSame' */
				if(opts.SID != null) return supbooks.SheetNames[opts.SID];
				return "SH33TJSSAME" + supbooks[XTI[0]][0];
			case 0x0163: /* 'BrtSupBookSrc' */
				/* falls through */
			default: return "SH33TJSSRC" + supbooks[XTI[0]][0];
		}
		switch(supbooks[XTI[0]][0][0]) {
			case 0x0401:
				o = XTI[1] == -1 ? "#REF" : (supbooks.SheetNames[XTI[1]] || "SH33TJSERR3");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
			case 0x3A01: return supbooks[XTI[0]].slice(1).map(function(name) { return name.Name; }).join(";;"); //return "SH33TJSERR8";
			default:
				if(!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
				o = XTI[1] == -1 ? "#REF" : (supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4");
				return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
		}
	}
	function get_ixti(supbooks, ixti, opts) {
		var ixtiraw = get_ixti_raw(supbooks, ixti, opts);
		return ixtiraw == "#REF" ? ixtiraw : formula_quote_sheet_name(ixtiraw, opts);
	}
	function stringify_formula(formula/*Array<any>*/, range, cell, supbooks, opts) {
		var biff = (opts && opts.biff) || 8;
		var _range = /*range != null ? range :*/ {s:{c:0, r:0},e:{c:0, r:0}};
		var stack = [], e1, e2,  c, ixti=0, nameidx=0, r, sname="";
		if(!formula[0] || !formula[0][0]) return "";
		var last_sp = -1, sp = "";
		for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff) {
			var f = formula[0][ff];
			switch(f[0]) {
				case 'PtgUminus': /* [MS-XLS] 2.5.198.93 */
					stack.push("-" + stack.pop()); break;
				case 'PtgUplus': /* [MS-XLS] 2.5.198.95 */
					stack.push("+" + stack.pop()); break;
				case 'PtgPercent': /* [MS-XLS] 2.5.198.81 */
					stack.push(stack.pop() + "%"); break;
	
				case 'PtgAdd':    /* [MS-XLS] 2.5.198.26 */
				case 'PtgConcat': /* [MS-XLS] 2.5.198.43 */
				case 'PtgDiv':    /* [MS-XLS] 2.5.198.45 */
				case 'PtgEq':     /* [MS-XLS] 2.5.198.56 */
				case 'PtgGe':     /* [MS-XLS] 2.5.198.64 */
				case 'PtgGt':     /* [MS-XLS] 2.5.198.65 */
				case 'PtgLe':     /* [MS-XLS] 2.5.198.68 */
				case 'PtgLt':     /* [MS-XLS] 2.5.198.69 */
				case 'PtgMul':    /* [MS-XLS] 2.5.198.75 */
				case 'PtgNe':     /* [MS-XLS] 2.5.198.78 */
				case 'PtgPower':  /* [MS-XLS] 2.5.198.82 */
				case 'PtgSub':    /* [MS-XLS] 2.5.198.90 */
					e1 = stack.pop(); e2 = stack.pop();
					if(last_sp >= 0) {
						switch(formula[0][last_sp][1][0]) {
							case 0:
								// $FlowIgnore
								sp = fill(" ", formula[0][last_sp][1][1]); break;
							case 1:
								// $FlowIgnore
								sp = fill("\r", formula[0][last_sp][1][1]); break;
							default:
								sp = "";
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						e2 = e2 + sp;
						last_sp = -1;
					}
					stack.push(e2+PtgBinOp[f[0]]+e1);
					break;
	
				case 'PtgIsect': /* [MS-XLS] 2.5.198.67 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+" "+e1);
					break;
				case 'PtgUnion': /* [MS-XLS] 2.5.198.94 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+","+e1);
					break;
				case 'PtgRange': /* [MS-XLS] 2.5.198.83 */
					e1 = stack.pop(); e2 = stack.pop();
					stack.push(e2+":"+e1);
					break;
	
				case 'PtgAttrChoose': /* [MS-XLS] 2.5.198.34 */
					break;
				case 'PtgAttrGoto': /* [MS-XLS] 2.5.198.35 */
					break;
				case 'PtgAttrIf': /* [MS-XLS] 2.5.198.36 */
					break;
				case 'PtgAttrIfError': /* [MS-XLSB] 2.5.97.28 */
					break;
	
	
				case 'PtgRef': /* [MS-XLS] 2.5.198.84 */
	c = shift_cell_xls((f[1][1]), _range, opts);
					stack.push(encode_cell_xls(c, biff));
					break;
				case 'PtgRefN': /* [MS-XLS] 2.5.198.88 */
	c = cell ? shift_cell_xls((f[1][1]), cell, opts) : (f[1][1]);
					stack.push(encode_cell_xls(c, biff));
					break;
				case 'PtgRef3d': /* [MS-XLS] 2.5.198.85 */
	ixti = f[1][1]; c = shift_cell_xls((f[1][2]), _range, opts);
					sname = get_ixti(supbooks, ixti, opts);
					var w = sname; /* IE9 fails on defined names */ // eslint-disable-line no-unused-vars
					stack.push(sname + "!" + encode_cell_xls(c, biff));
					break;
	
				case 'PtgFunc': /* [MS-XLS] 2.5.198.62 */
				case 'PtgFuncVar': /* [MS-XLS] 2.5.198.63 */
					/* f[1] = [argc, func, type] */
					var argc = (f[1][0]), func = (f[1][1]);
					if(!argc) argc = 0;
					argc &= 0x7F;
					var args = argc == 0 ? [] : stack.slice(-argc);
					stack.length -= argc;
					if(func === 'User') func = args.shift();
					stack.push(func + "(" + args.join(",") + ")");
					break;
	
				case 'PtgBool': /* [MS-XLS] 2.5.198.42 */
					stack.push(f[1] ? "TRUE" : "FALSE"); break;
				case 'PtgInt': /* [MS-XLS] 2.5.198.66 */
					stack.push(f[1]); break;
				case 'PtgNum': /* [MS-XLS] 2.5.198.79 TODO: precision? */
					stack.push(String(f[1])); break;
				case 'PtgStr': /* [MS-XLS] 2.5.198.89 */
					// $FlowIgnore
					stack.push('"' + f[1].replace(/"/g, '""') + '"'); break;
				case 'PtgErr': /* [MS-XLS] 2.5.198.57 */
					stack.push(f[1]); break;
				case 'PtgAreaN': /* [MS-XLS] 2.5.198.31 TODO */
	r = shift_range_xls(f[1][1], cell ? {s:cell} : _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea': /* [MS-XLS] 2.5.198.27 TODO: fixed points */
	r = shift_range_xls(f[1][1], _range, opts);
					stack.push(encode_range_xls((r), opts));
					break;
				case 'PtgArea3d': /* [MS-XLS] 2.5.198.28 TODO */
	ixti = f[1][1]; r = f[1][2];
					sname = get_ixti(supbooks, ixti, opts);
					stack.push(sname + "!" + encode_range_xls((r), opts));
					break;
				case 'PtgAttrSum': /* [MS-XLS] 2.5.198.41 */
					stack.push("SUM(" + stack.pop() + ")");
					break;
	
				case 'PtgAttrBaxcel': /* [MS-XLS] 2.5.198.33 */
				case 'PtgAttrSemi': /* [MS-XLS] 2.5.198.37 */
					break;
	
				case 'PtgName': /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */
					/* f[1] = type, 0, nameindex */
					nameidx = (f[1][2]);
					var lbl = (supbooks.names||[])[nameidx-1] || (supbooks[0]||[])[nameidx];
					var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
					if(name in XLSXFutureFunctions) name = XLSXFutureFunctions[name];
					stack.push(name);
					break;
	
				case 'PtgNameX': /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */
					/* f[1] = type, ixti, nameindex */
					var bookidx = (f[1][1]); nameidx = (f[1][2]); var externbook;
					/* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */
					if(opts.biff <= 5) {
						if(bookidx < 0) bookidx = -bookidx;
						if(supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
					} else {
						var o = "";
						if(((supbooks[bookidx]||[])[0]||[])[0] == 0x3A01){/* empty */}
						else if(((supbooks[bookidx]||[])[0]||[])[0] == 0x0401){
							if(supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) {
								o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab-1] + "!";
							}
						}
						else o = supbooks.SheetNames[nameidx-1]+ "!";
						if(supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
						else if(supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
						else {
							var ixtidata = (get_ixti_raw(supbooks, bookidx, opts)||"").split(";;");
							if(ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
							else o += "SH33TJSERRX";
						}
						stack.push(o);
						break;
					}
					if(!externbook) externbook = {Name: "SH33TJSERRY"};
					stack.push(externbook.Name);
					break;
	
				case 'PtgParen': /* [MS-XLS] 2.5.198.80 */
					var lp = '(', rp = ')';
					if(last_sp >= 0) {
						sp = "";
						switch(formula[0][last_sp][1][0]) {
							// $FlowIgnore
							case 2: lp = fill(" ", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 3: lp = fill("\r", formula[0][last_sp][1][1]) + lp; break;
							// $FlowIgnore
							case 4: rp = fill(" ", formula[0][last_sp][1][1]) + rp; break;
							// $FlowIgnore
							case 5: rp = fill("\r", formula[0][last_sp][1][1]) + rp; break;
							default:
								// $FlowIgnore
								if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
						}
						last_sp = -1;
					}
					stack.push(lp + stack.pop() + rp); break;
	
				case 'PtgRefErr': /* [MS-XLS] 2.5.198.86 */
					stack.push('#REF!'); break;
	
				case 'PtgRefErr3d': /* [MS-XLS] 2.5.198.87 */
					stack.push('#REF!'); break;
	
				case 'PtgExp': /* [MS-XLS] 2.5.198.58 TODO */
					c = {c:(f[1][1]),r:(f[1][0])};
					var q = ({c: cell.c, r:cell.r});
					if(supbooks.sharedf[encode_cell(c)]) {
						var parsedf = (supbooks.sharedf[encode_cell(c)]);
						stack.push(stringify_formula(parsedf, _range, q, supbooks, opts));
					} else {
						var fnd = false;
						for(e1=0;e1!=supbooks.arrayf.length; ++e1) {
							/* TODO: should be something like range_has */
							e2 = supbooks.arrayf[e1];
							if(c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
							if(c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
							stack.push(stringify_formula(e2[1], _range, q, supbooks, opts));
							fnd = true;
							break;
						}
						if(!fnd) stack.push(f[1]);
					}
					break;
	
				case 'PtgArray': /* [MS-XLS] 2.5.198.32 TODO */
					stack.push("{" + stringify_array(f[1]) + "}");
					break;
	
				case 'PtgMemArea': /* [MS-XLS] 2.5.198.70 TODO: confirm this is a non-display */
					//stack.push("(" + f[2].map(encode_range).join(",") + ")");
					break;
	
				case 'PtgAttrSpace': /* [MS-XLS] 2.5.198.38 */
				case 'PtgAttrSpaceSemi': /* [MS-XLS] 2.5.198.39 */
					last_sp = ff;
					break;
	
				case 'PtgTbl': /* [MS-XLS] 2.5.198.92 TODO */
					break;
	
				case 'PtgMemErr': /* [MS-XLS] 2.5.198.71 */
					break;
	
				case 'PtgMissArg': /* [MS-XLS] 2.5.198.74 */
					stack.push("");
					break;
	
				case 'PtgAreaErr': /* [MS-XLS] 2.5.198.29 */
					stack.push("#REF!"); break;
	
				case 'PtgAreaErr3d': /* [MS-XLS] 2.5.198.30 */
					stack.push("#REF!"); break;
	
				case 'PtgList': /* [MS-XLSB] 2.5.97.52 */
					// $FlowIgnore
					stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
					break;
	
				case 'PtgMemAreaN':
				case 'PtgMemNoMemN':
				case 'PtgAttrNoop':
				case 'PtgSheet':
				case 'PtgEndSheet':
					break;
	
				case 'PtgMemFunc': /* [MS-XLS] 2.5.198.72 TODO */
					break;
				case 'PtgMemNoMem': /* [MS-XLS] 2.5.198.73 TODO */
					break;
	
				case 'PtgElfCol': /* [MS-XLS] 2.5.198.46 */
				case 'PtgElfColS': /* [MS-XLS] 2.5.198.47 */
				case 'PtgElfColSV': /* [MS-XLS] 2.5.198.48 */
				case 'PtgElfColV': /* [MS-XLS] 2.5.198.49 */
				case 'PtgElfLel': /* [MS-XLS] 2.5.198.50 */
				case 'PtgElfRadical': /* [MS-XLS] 2.5.198.51 */
				case 'PtgElfRadicalLel': /* [MS-XLS] 2.5.198.52 */
				case 'PtgElfRadicalS': /* [MS-XLS] 2.5.198.53 */
				case 'PtgElfRw': /* [MS-XLS] 2.5.198.54 */
				case 'PtgElfRwV': /* [MS-XLS] 2.5.198.55 */
					throw new Error("Unsupported ELFs");
	
				case 'PtgSxName': /* [MS-XLS] 2.5.198.91 TODO -- find a test case */
					throw new Error('Unrecognized Formula Token: ' + String(f));
				default: throw new Error('Unrecognized Formula Token: ' + String(f));
			}
			var PtgNonDisp = ['PtgAttrSpace', 'PtgAttrSpaceSemi', 'PtgAttrGoto'];
			if(opts.biff != 3) if(last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
				f = formula[0][last_sp];
				var _left = true;
				switch(f[1][0]) {
					/* note: some bad XLSB files omit the PtgParen */
					case 4: _left = false;
					/* falls through */
					case 0:
						// $FlowIgnore
						sp = fill(" ", f[1][1]); break;
					case 5: _left = false;
					/* falls through */
					case 1:
						// $FlowIgnore
						sp = fill("\r", f[1][1]); break;
					default:
						sp = "";
						// $FlowIgnore
						if(opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
				}
				stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
				last_sp = -1;
			}
		}
		if(stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
		return stack[0];
	}
	
	/* [MS-XLS] 2.5.198.1 TODO */
	function parse_ArrayParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.3 TODO */
	function parse_XLSCellParsedFormula(blob, length, opts) {
		var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
		var rgcb, cce = blob.read_shift(len); // length of rgce
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		var rgce = parse_Rgce(blob, cce, opts);
		if(length !== cce + len) rgcb = parse_RgbExtra(blob, length - cce - len, rgce, opts);
		blob.l = target;
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.21 */
	function parse_NameParsedFormula(blob, length, opts, cce) {
		var target = blob.l + length;
		var rgce = parse_Rgce(blob, cce, opts);
		var rgcb;
		if(target !== blob.l) rgcb = parse_RgbExtra(blob, target - blob.l, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.198.118 TODO */
	function parse_SharedParsedFormula(blob, length, opts) {
		var target = blob.l + length;
		var rgcb, cce = blob.read_shift(2); // length of rgce
		var rgce = parse_Rgce(blob, cce, opts);
		if(cce == 0xFFFF) return [[],parsenoop(blob, length-2)];
		if(length !== cce + 2) rgcb = parse_RgbExtra(blob, target - cce - 2, rgce, opts);
		return [rgce, rgcb];
	}
	
	/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */
	function parse_FormulaValue(blob) {
		var b;
		if(__readUInt16LE(blob,blob.l + 6) !== 0xFFFF) return [parse_Xnum(blob),'n'];
		switch(blob[blob.l]) {
			case 0x00: blob.l += 8; return ["String", 's'];
			case 0x01: b = blob[blob.l+2] === 0x1; blob.l += 8; return [b,'b'];
			case 0x02: b = blob[blob.l+2]; blob.l += 8; return [b,'e'];
			case 0x03: blob.l += 8; return ["",'s'];
		}
		return [];
	}
	function write_FormulaValue(value) {
		if(value == null) {
			// Blank String Value
			var o = new_buf(8);
			o.write_shift(1, 0x03);
			o.write_shift(1, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0);
			o.write_shift(2, 0xFFFF);
			return o;
		} else if(typeof value == "number") return write_Xnum(value);
		return write_Xnum(0);
	}
	
	/* [MS-XLS] 2.4.127 TODO */
	function parse_Formula(blob, length, opts) {
		var end = blob.l + length;
		var cell = parse_XLSCell(blob, 6);
		if(opts.biff == 2) ++blob.l;
		var val = parse_FormulaValue(blob,8);
		var flags = blob.read_shift(1);
		if(opts.biff != 2) {
			blob.read_shift(1);
			if(opts.biff >= 5) {
				/*var chn = */blob.read_shift(4);
			}
		}
		var cbf = parse_XLSCellParsedFormula(blob, end - blob.l, opts);
		return {cell:cell, val:val[0], formula:cbf, shared: (flags >> 3) & 1, tt:val[1]};
	}
	function write_Formula(cell, R, C, opts, os) {
		// Cell
		var o1 = write_XLSCell(R, C, os);
	
		// FormulaValue
		var o2 = write_FormulaValue(cell.v);
	
		// flags + cache
		var o3 = new_buf(6);
		var flags = 0x01 | 0x20;
		o3.write_shift(2, flags);
		o3.write_shift(4, 0);
	
		// CellParsedFormula
		var bf = new_buf(cell.bf.length);
		for(var i = 0; i < cell.bf.length; ++i) bf[i] = cell.bf[i];
	
		var out = bconcat([o1, o2, o3, bf]);
		return out;
	}
	
	
	/* XLSB Parsed Formula records have the same shape */
	function parse_XLSBParsedFormula(data, length, opts) {
		var cce = data.read_shift(4);
		var rgce = parse_Rgce(data, cce, opts);
		var cb = data.read_shift(4);
		var rgcb = cb > 0 ? parse_RgbExtra(data, cb, rgce, opts) : null;
		return [rgce, rgcb];
	}
	
	/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */
	var parse_XLSBArrayParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.4 CellParsedFormula */
	var parse_XLSBCellParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.8 DVParsedFormula */
	//var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */
	//var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
	/* [MS-XLSB] 2.5.97.12 NameParsedFormula */
	var parse_XLSBNameParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */
	var parse_XLSBSharedParsedFormula = parse_XLSBParsedFormula;
	/* [MS-XLS] 2.5.198.4 */
	var Cetab = {
	0x0000: 'BEEP',
	0x0001: 'OPEN',
	0x0002: 'OPEN.LINKS',
	0x0003: 'CLOSE.ALL',
	0x0004: 'SAVE',
	0x0005: 'SAVE.AS',
	0x0006: 'FILE.DELETE',
	0x0007: 'PAGE.SETUP',
	0x0008: 'PRINT',
	0x0009: 'PRINTER.SETUP',
	0x000A: 'QUIT',
	0x000B: 'NEW.WINDOW',
	0x000C: 'ARRANGE.ALL',
	0x000D: 'WINDOW.SIZE',
	0x000E: 'WINDOW.MOVE',
	0x000F: 'FULL',
	0x0010: 'CLOSE',
	0x0011: 'RUN',
	0x0016: 'SET.PRINT.AREA',
	0x0017: 'SET.PRINT.TITLES',
	0x0018: 'SET.PAGE.BREAK',
	0x0019: 'REMOVE.PAGE.BREAK',
	0x001A: 'FONT',
	0x001B: 'DISPLAY',
	0x001C: 'PROTECT.DOCUMENT',
	0x001D: 'PRECISION',
	0x001E: 'A1.R1C1',
	0x001F: 'CALCULATE.NOW',
	0x0020: 'CALCULATION',
	0x0022: 'DATA.FIND',
	0x0023: 'EXTRACT',
	0x0024: 'DATA.DELETE',
	0x0025: 'SET.DATABASE',
	0x0026: 'SET.CRITERIA',
	0x0027: 'SORT',
	0x0028: 'DATA.SERIES',
	0x0029: 'TABLE',
	0x002A: 'FORMAT.NUMBER',
	0x002B: 'ALIGNMENT',
	0x002C: 'STYLE',
	0x002D: 'BORDER',
	0x002E: 'CELL.PROTECTION',
	0x002F: 'COLUMN.WIDTH',
	0x0030: 'UNDO',
	0x0031: 'CUT',
	0x0032: 'COPY',
	0x0033: 'PASTE',
	0x0034: 'CLEAR',
	0x0035: 'PASTE.SPECIAL',
	0x0036: 'EDIT.DELETE',
	0x0037: 'INSERT',
	0x0038: 'FILL.RIGHT',
	0x0039: 'FILL.DOWN',
	0x003D: 'DEFINE.NAME',
	0x003E: 'CREATE.NAMES',
	0x003F: 'FORMULA.GOTO',
	0x0040: 'FORMULA.FIND',
	0x0041: 'SELECT.LAST.CELL',
	0x0042: 'SHOW.ACTIVE.CELL',
	0x0043: 'GALLERY.AREA',
	0x0044: 'GALLERY.BAR',
	0x0045: 'GALLERY.COLUMN',
	0x0046: 'GALLERY.LINE',
	0x0047: 'GALLERY.PIE',
	0x0048: 'GALLERY.SCATTER',
	0x0049: 'COMBINATION',
	0x004A: 'PREFERRED',
	0x004B: 'ADD.OVERLAY',
	0x004C: 'GRIDLINES',
	0x004D: 'SET.PREFERRED',
	0x004E: 'AXES',
	0x004F: 'LEGEND',
	0x0050: 'ATTACH.TEXT',
	0x0051: 'ADD.ARROW',
	0x0052: 'SELECT.CHART',
	0x0053: 'SELECT.PLOT.AREA',
	0x0054: 'PATTERNS',
	0x0055: 'MAIN.CHART',
	0x0056: 'OVERLAY',
	0x0057: 'SCALE',
	0x0058: 'FORMAT.LEGEND',
	0x0059: 'FORMAT.TEXT',
	0x005A: 'EDIT.REPEAT',
	0x005B: 'PARSE',
	0x005C: 'JUSTIFY',
	0x005D: 'HIDE',
	0x005E: 'UNHIDE',
	0x005F: 'WORKSPACE',
	0x0060: 'FORMULA',
	0x0061: 'FORMULA.FILL',
	0x0062: 'FORMULA.ARRAY',
	0x0063: 'DATA.FIND.NEXT',
	0x0064: 'DATA.FIND.PREV',
	0x0065: 'FORMULA.FIND.NEXT',
	0x0066: 'FORMULA.FIND.PREV',
	0x0067: 'ACTIVATE',
	0x0068: 'ACTIVATE.NEXT',
	0x0069: 'ACTIVATE.PREV',
	0x006A: 'UNLOCKED.NEXT',
	0x006B: 'UNLOCKED.PREV',
	0x006C: 'COPY.PICTURE',
	0x006D: 'SELECT',
	0x006E: 'DELETE.NAME',
	0x006F: 'DELETE.FORMAT',
	0x0070: 'VLINE',
	0x0071: 'HLINE',
	0x0072: 'VPAGE',
	0x0073: 'HPAGE',
	0x0074: 'VSCROLL',
	0x0075: 'HSCROLL',
	0x0076: 'ALERT',
	0x0077: 'NEW',
	0x0078: 'CANCEL.COPY',
	0x0079: 'SHOW.CLIPBOARD',
	0x007A: 'MESSAGE',
	0x007C: 'PASTE.LINK',
	0x007D: 'APP.ACTIVATE',
	0x007E: 'DELETE.ARROW',
	0x007F: 'ROW.HEIGHT',
	0x0080: 'FORMAT.MOVE',
	0x0081: 'FORMAT.SIZE',
	0x0082: 'FORMULA.REPLACE',
	0x0083: 'SEND.KEYS',
	0x0084: 'SELECT.SPECIAL',
	0x0085: 'APPLY.NAMES',
	0x0086: 'REPLACE.FONT',
	0x0087: 'FREEZE.PANES',
	0x0088: 'SHOW.INFO',
	0x0089: 'SPLIT',
	0x008A: 'ON.WINDOW',
	0x008B: 'ON.DATA',
	0x008C: 'DISABLE.INPUT',
	0x008E: 'OUTLINE',
	0x008F: 'LIST.NAMES',
	0x0090: 'FILE.CLOSE',
	0x0091: 'SAVE.WORKBOOK',
	0x0092: 'DATA.FORM',
	0x0093: 'COPY.CHART',
	0x0094: 'ON.TIME',
	0x0095: 'WAIT',
	0x0096: 'FORMAT.FONT',
	0x0097: 'FILL.UP',
	0x0098: 'FILL.LEFT',
	0x0099: 'DELETE.OVERLAY',
	0x009B: 'SHORT.MENUS',
	0x009F: 'SET.UPDATE.STATUS',
	0x00A1: 'COLOR.PALETTE',
	0x00A2: 'DELETE.STYLE',
	0x00A3: 'WINDOW.RESTORE',
	0x00A4: 'WINDOW.MAXIMIZE',
	0x00A6: 'CHANGE.LINK',
	0x00A7: 'CALCULATE.DOCUMENT',
	0x00A8: 'ON.KEY',
	0x00A9: 'APP.RESTORE',
	0x00AA: 'APP.MOVE',
	0x00AB: 'APP.SIZE',
	0x00AC: 'APP.MINIMIZE',
	0x00AD: 'APP.MAXIMIZE',
	0x00AE: 'BRING.TO.FRONT',
	0x00AF: 'SEND.TO.BACK',
	0x00B9: 'MAIN.CHART.TYPE',
	0x00BA: 'OVERLAY.CHART.TYPE',
	0x00BB: 'SELECT.END',
	0x00BC: 'OPEN.MAIL',
	0x00BD: 'SEND.MAIL',
	0x00BE: 'STANDARD.FONT',
	0x00BF: 'CONSOLIDATE',
	0x00C0: 'SORT.SPECIAL',
	0x00C1: 'GALLERY.3D.AREA',
	0x00C2: 'GALLERY.3D.COLUMN',
	0x00C3: 'GALLERY.3D.LINE',
	0x00C4: 'GALLERY.3D.PIE',
	0x00C5: 'VIEW.3D',
	0x00C6: 'GOAL.SEEK',
	0x00C7: 'WORKGROUP',
	0x00C8: 'FILL.GROUP',
	0x00C9: 'UPDATE.LINK',
	0x00CA: 'PROMOTE',
	0x00CB: 'DEMOTE',
	0x00CC: 'SHOW.DETAIL',
	0x00CE: 'UNGROUP',
	0x00CF: 'OBJECT.PROPERTIES',
	0x00D0: 'SAVE.NEW.OBJECT',
	0x00D1: 'SHARE',
	0x00D2: 'SHARE.NAME',
	0x00D3: 'DUPLICATE',
	0x00D4: 'APPLY.STYLE',
	0x00D5: 'ASSIGN.TO.OBJECT',
	0x00D6: 'OBJECT.PROTECTION',
	0x00D7: 'HIDE.OBJECT',
	0x00D8: 'SET.EXTRACT',
	0x00D9: 'CREATE.PUBLISHER',
	0x00DA: 'SUBSCRIBE.TO',
	0x00DB: 'ATTRIBUTES',
	0x00DC: 'SHOW.TOOLBAR',
	0x00DE: 'PRINT.PREVIEW',
	0x00DF: 'EDIT.COLOR',
	0x00E0: 'SHOW.LEVELS',
	0x00E1: 'FORMAT.MAIN',
	0x00E2: 'FORMAT.OVERLAY',
	0x00E3: 'ON.RECALC',
	0x00E4: 'EDIT.SERIES',
	0x00E5: 'DEFINE.STYLE',
	0x00F0: 'LINE.PRINT',
	0x00F3: 'ENTER.DATA',
	0x00F9: 'GALLERY.RADAR',
	0x00FA: 'MERGE.STYLES',
	0x00FB: 'EDITION.OPTIONS',
	0x00FC: 'PASTE.PICTURE',
	0x00FD: 'PASTE.PICTURE.LINK',
	0x00FE: 'SPELLING',
	0x0100: 'ZOOM',
	0x0103: 'INSERT.OBJECT',
	0x0104: 'WINDOW.MINIMIZE',
	0x0109: 'SOUND.NOTE',
	0x010A: 'SOUND.PLAY',
	0x010B: 'FORMAT.SHAPE',
	0x010C: 'EXTEND.POLYGON',
	0x010D: 'FORMAT.AUTO',
	0x0110: 'GALLERY.3D.BAR',
	0x0111: 'GALLERY.3D.SURFACE',
	0x0112: 'FILL.AUTO',
	0x0114: 'CUSTOMIZE.TOOLBAR',
	0x0115: 'ADD.TOOL',
	0x0116: 'EDIT.OBJECT',
	0x0117: 'ON.DOUBLECLICK',
	0x0118: 'ON.ENTRY',
	0x0119: 'WORKBOOK.ADD',
	0x011A: 'WORKBOOK.MOVE',
	0x011B: 'WORKBOOK.COPY',
	0x011C: 'WORKBOOK.OPTIONS',
	0x011D: 'SAVE.WORKSPACE',
	0x0120: 'CHART.WIZARD',
	0x0121: 'DELETE.TOOL',
	0x0122: 'MOVE.TOOL',
	0x0123: 'WORKBOOK.SELECT',
	0x0124: 'WORKBOOK.ACTIVATE',
	0x0125: 'ASSIGN.TO.TOOL',
	0x0127: 'COPY.TOOL',
	0x0128: 'RESET.TOOL',
	0x0129: 'CONSTRAIN.NUMERIC',
	0x012A: 'PASTE.TOOL',
	0x012E: 'WORKBOOK.NEW',
	0x0131: 'SCENARIO.CELLS',
	0x0132: 'SCENARIO.DELETE',
	0x0133: 'SCENARIO.ADD',
	0x0134: 'SCENARIO.EDIT',
	0x0135: 'SCENARIO.SHOW',
	0x0136: 'SCENARIO.SHOW.NEXT',
	0x0137: 'SCENARIO.SUMMARY',
	0x0138: 'PIVOT.TABLE.WIZARD',
	0x0139: 'PIVOT.FIELD.PROPERTIES',
	0x013A: 'PIVOT.FIELD',
	0x013B: 'PIVOT.ITEM',
	0x013C: 'PIVOT.ADD.FIELDS',
	0x013E: 'OPTIONS.CALCULATION',
	0x013F: 'OPTIONS.EDIT',
	0x0140: 'OPTIONS.VIEW',
	0x0141: 'ADDIN.MANAGER',
	0x0142: 'MENU.EDITOR',
	0x0143: 'ATTACH.TOOLBARS',
	0x0144: 'VBAActivate',
	0x0145: 'OPTIONS.CHART',
	0x0148: 'VBA.INSERT.FILE',
	0x014A: 'VBA.PROCEDURE.DEFINITION',
	0x0150: 'ROUTING.SLIP',
	0x0152: 'ROUTE.DOCUMENT',
	0x0153: 'MAIL.LOGON',
	0x0156: 'INSERT.PICTURE',
	0x0157: 'EDIT.TOOL',
	0x0158: 'GALLERY.DOUGHNUT',
	0x015E: 'CHART.TREND',
	0x0160: 'PIVOT.ITEM.PROPERTIES',
	0x0162: 'WORKBOOK.INSERT',
	0x0163: 'OPTIONS.TRANSITION',
	0x0164: 'OPTIONS.GENERAL',
	0x0172: 'FILTER.ADVANCED',
	0x0175: 'MAIL.ADD.MAILER',
	0x0176: 'MAIL.DELETE.MAILER',
	0x0177: 'MAIL.REPLY',
	0x0178: 'MAIL.REPLY.ALL',
	0x0179: 'MAIL.FORWARD',
	0x017A: 'MAIL.NEXT.LETTER',
	0x017B: 'DATA.LABEL',
	0x017C: 'INSERT.TITLE',
	0x017D: 'FONT.PROPERTIES',
	0x017E: 'MACRO.OPTIONS',
	0x017F: 'WORKBOOK.HIDE',
	0x0180: 'WORKBOOK.UNHIDE',
	0x0181: 'WORKBOOK.DELETE',
	0x0182: 'WORKBOOK.NAME',
	0x0184: 'GALLERY.CUSTOM',
	0x0186: 'ADD.CHART.AUTOFORMAT',
	0x0187: 'DELETE.CHART.AUTOFORMAT',
	0x0188: 'CHART.ADD.DATA',
	0x0189: 'AUTO.OUTLINE',
	0x018A: 'TAB.ORDER',
	0x018B: 'SHOW.DIALOG',
	0x018C: 'SELECT.ALL',
	0x018D: 'UNGROUP.SHEETS',
	0x018E: 'SUBTOTAL.CREATE',
	0x018F: 'SUBTOTAL.REMOVE',
	0x0190: 'RENAME.OBJECT',
	0x019C: 'WORKBOOK.SCROLL',
	0x019D: 'WORKBOOK.NEXT',
	0x019E: 'WORKBOOK.PREV',
	0x019F: 'WORKBOOK.TAB.SPLIT',
	0x01A0: 'FULL.SCREEN',
	0x01A1: 'WORKBOOK.PROTECT',
	0x01A4: 'SCROLLBAR.PROPERTIES',
	0x01A5: 'PIVOT.SHOW.PAGES',
	0x01A6: 'TEXT.TO.COLUMNS',
	0x01A7: 'FORMAT.CHARTTYPE',
	0x01A8: 'LINK.FORMAT',
	0x01A9: 'TRACER.DISPLAY',
	0x01AE: 'TRACER.NAVIGATE',
	0x01AF: 'TRACER.CLEAR',
	0x01B0: 'TRACER.ERROR',
	0x01B1: 'PIVOT.FIELD.GROUP',
	0x01B2: 'PIVOT.FIELD.UNGROUP',
	0x01B3: 'CHECKBOX.PROPERTIES',
	0x01B4: 'LABEL.PROPERTIES',
	0x01B5: 'LISTBOX.PROPERTIES',
	0x01B6: 'EDITBOX.PROPERTIES',
	0x01B7: 'PIVOT.REFRESH',
	0x01B8: 'LINK.COMBO',
	0x01B9: 'OPEN.TEXT',
	0x01BA: 'HIDE.DIALOG',
	0x01BB: 'SET.DIALOG.FOCUS',
	0x01BC: 'ENABLE.OBJECT',
	0x01BD: 'PUSHBUTTON.PROPERTIES',
	0x01BE: 'SET.DIALOG.DEFAULT',
	0x01BF: 'FILTER',
	0x01C0: 'FILTER.SHOW.ALL',
	0x01C1: 'CLEAR.OUTLINE',
	0x01C2: 'FUNCTION.WIZARD',
	0x01C3: 'ADD.LIST.ITEM',
	0x01C4: 'SET.LIST.ITEM',
	0x01C5: 'REMOVE.LIST.ITEM',
	0x01C6: 'SELECT.LIST.ITEM',
	0x01C7: 'SET.CONTROL.VALUE',
	0x01C8: 'SAVE.COPY.AS',
	0x01CA: 'OPTIONS.LISTS.ADD',
	0x01CB: 'OPTIONS.LISTS.DELETE',
	0x01CC: 'SERIES.AXES',
	0x01CD: 'SERIES.X',
	0x01CE: 'SERIES.Y',
	0x01CF: 'ERRORBAR.X',
	0x01D0: 'ERRORBAR.Y',
	0x01D1: 'FORMAT.CHART',
	0x01D2: 'SERIES.ORDER',
	0x01D3: 'MAIL.LOGOFF',
	0x01D4: 'CLEAR.ROUTING.SLIP',
	0x01D5: 'APP.ACTIVATE.MICROSOFT',
	0x01D6: 'MAIL.EDIT.MAILER',
	0x01D7: 'ON.SHEET',
	0x01D8: 'STANDARD.WIDTH',
	0x01D9: 'SCENARIO.MERGE',
	0x01DA: 'SUMMARY.INFO',
	0x01DB: 'FIND.FILE',
	0x01DC: 'ACTIVE.CELL.FONT',
	0x01DD: 'ENABLE.TIPWIZARD',
	0x01DE: 'VBA.MAKE.ADDIN',
	0x01E0: 'INSERTDATATABLE',
	0x01E1: 'WORKGROUP.OPTIONS',
	0x01E2: 'MAIL.SEND.MAILER',
	0x01E5: 'AUTOCORRECT',
	0x01E9: 'POST.DOCUMENT',
	0x01EB: 'PICKLIST',
	0x01ED: 'VIEW.SHOW',
	0x01EE: 'VIEW.DEFINE',
	0x01EF: 'VIEW.DELETE',
	0x01FD: 'SHEET.BACKGROUND',
	0x01FE: 'INSERT.MAP.OBJECT',
	0x01FF: 'OPTIONS.MENONO',
	0x0205: 'MSOCHECKS',
	0x0206: 'NORMAL',
	0x0207: 'LAYOUT',
	0x0208: 'RM.PRINT.AREA',
	0x0209: 'CLEAR.PRINT.AREA',
	0x020A: 'ADD.PRINT.AREA',
	0x020B: 'MOVE.BRK',
	0x0221: 'HIDECURR.NOTE',
	0x0222: 'HIDEALL.NOTES',
	0x0223: 'DELETE.NOTE',
	0x0224: 'TRAVERSE.NOTES',
	0x0225: 'ACTIVATE.NOTES',
	0x026C: 'PROTECT.REVISIONS',
	0x026D: 'UNPROTECT.REVISIONS',
	0x0287: 'OPTIONS.ME',
	0x028D: 'WEB.PUBLISH',
	0x029B: 'NEWWEBQUERY',
	0x02A1: 'PIVOT.TABLE.CHART',
	0x02F1: 'OPTIONS.SAVE',
	0x02F3: 'OPTIONS.SPELL',
	0x0328: 'HIDEALL.INKANNOTS'
	};
	
	/* [MS-XLS] 2.5.198.17 */
	/* [MS-XLSB] 2.5.97.10 */
	var Ftab = {
	0x0000: 'COUNT',
	0x0001: 'IF',
	0x0002: 'ISNA',
	0x0003: 'ISERROR',
	0x0004: 'SUM',
	0x0005: 'AVERAGE',
	0x0006: 'MIN',
	0x0007: 'MAX',
	0x0008: 'ROW',
	0x0009: 'COLUMN',
	0x000A: 'NA',
	0x000B: 'NPV',
	0x000C: 'STDEV',
	0x000D: 'DOLLAR',
	0x000E: 'FIXED',
	0x000F: 'SIN',
	0x0010: 'COS',
	0x0011: 'TAN',
	0x0012: 'ATAN',
	0x0013: 'PI',
	0x0014: 'SQRT',
	0x0015: 'EXP',
	0x0016: 'LN',
	0x0017: 'LOG10',
	0x0018: 'ABS',
	0x0019: 'INT',
	0x001A: 'SIGN',
	0x001B: 'ROUND',
	0x001C: 'LOOKUP',
	0x001D: 'INDEX',
	0x001E: 'REPT',
	0x001F: 'MID',
	0x0020: 'LEN',
	0x0021: 'VALUE',
	0x0022: 'TRUE',
	0x0023: 'FALSE',
	0x0024: 'AND',
	0x0025: 'OR',
	0x0026: 'NOT',
	0x0027: 'MOD',
	0x0028: 'DCOUNT',
	0x0029: 'DSUM',
	0x002A: 'DAVERAGE',
	0x002B: 'DMIN',
	0x002C: 'DMAX',
	0x002D: 'DSTDEV',
	0x002E: 'VAR',
	0x002F: 'DVAR',
	0x0030: 'TEXT',
	0x0031: 'LINEST',
	0x0032: 'TREND',
	0x0033: 'LOGEST',
	0x0034: 'GROWTH',
	0x0035: 'GOTO',
	0x0036: 'HALT',
	0x0037: 'RETURN',
	0x0038: 'PV',
	0x0039: 'FV',
	0x003A: 'NPER',
	0x003B: 'PMT',
	0x003C: 'RATE',
	0x003D: 'MIRR',
	0x003E: 'IRR',
	0x003F: 'RAND',
	0x0040: 'MATCH',
	0x0041: 'DATE',
	0x0042: 'TIME',
	0x0043: 'DAY',
	0x0044: 'MONTH',
	0x0045: 'YEAR',
	0x0046: 'WEEKDAY',
	0x0047: 'HOUR',
	0x0048: 'MINUTE',
	0x0049: 'SECOND',
	0x004A: 'NOW',
	0x004B: 'AREAS',
	0x004C: 'ROWS',
	0x004D: 'COLUMNS',
	0x004E: 'OFFSET',
	0x004F: 'ABSREF',
	0x0050: 'RELREF',
	0x0051: 'ARGUMENT',
	0x0052: 'SEARCH',
	0x0053: 'TRANSPOSE',
	0x0054: 'ERROR',
	0x0055: 'STEP',
	0x0056: 'TYPE',
	0x0057: 'ECHO',
	0x0058: 'SET.NAME',
	0x0059: 'CALLER',
	0x005A: 'DEREF',
	0x005B: 'WINDOWS',
	0x005C: 'SERIES',
	0x005D: 'DOCUMENTS',
	0x005E: 'ACTIVE.CELL',
	0x005F: 'SELECTION',
	0x0060: 'RESULT',
	0x0061: 'ATAN2',
	0x0062: 'ASIN',
	0x0063: 'ACOS',
	0x0064: 'CHOOSE',
	0x0065: 'HLOOKUP',
	0x0066: 'VLOOKUP',
	0x0067: 'LINKS',
	0x0068: 'INPUT',
	0x0069: 'ISREF',
	0x006A: 'GET.FORMULA',
	0x006B: 'GET.NAME',
	0x006C: 'SET.VALUE',
	0x006D: 'LOG',
	0x006E: 'EXEC',
	0x006F: 'CHAR',
	0x0070: 'LOWER',
	0x0071: 'UPPER',
	0x0072: 'PROPER',
	0x0073: 'LEFT',
	0x0074: 'RIGHT',
	0x0075: 'EXACT',
	0x0076: 'TRIM',
	0x0077: 'REPLACE',
	0x0078: 'SUBSTITUTE',
	0x0079: 'CODE',
	0x007A: 'NAMES',
	0x007B: 'DIRECTORY',
	0x007C: 'FIND',
	0x007D: 'CELL',
	0x007E: 'ISERR',
	0x007F: 'ISTEXT',
	0x0080: 'ISNUMBER',
	0x0081: 'ISBLANK',
	0x0082: 'T',
	0x0083: 'N',
	0x0084: 'FOPEN',
	0x0085: 'FCLOSE',
	0x0086: 'FSIZE',
	0x0087: 'FREADLN',
	0x0088: 'FREAD',
	0x0089: 'FWRITELN',
	0x008A: 'FWRITE',
	0x008B: 'FPOS',
	0x008C: 'DATEVALUE',
	0x008D: 'TIMEVALUE',
	0x008E: 'SLN',
	0x008F: 'SYD',
	0x0090: 'DDB',
	0x0091: 'GET.DEF',
	0x0092: 'REFTEXT',
	0x0093: 'TEXTREF',
	0x0094: 'INDIRECT',
	0x0095: 'REGISTER',
	0x0096: 'CALL',
	0x0097: 'ADD.BAR',
	0x0098: 'ADD.MENU',
	0x0099: 'ADD.COMMAND',
	0x009A: 'ENABLE.COMMAND',
	0x009B: 'CHECK.COMMAND',
	0x009C: 'RENAME.COMMAND',
	0x009D: 'SHOW.BAR',
	0x009E: 'DELETE.MENU',
	0x009F: 'DELETE.COMMAND',
	0x00A0: 'GET.CHART.ITEM',
	0x00A1: 'DIALOG.BOX',
	0x00A2: 'CLEAN',
	0x00A3: 'MDETERM',
	0x00A4: 'MINVERSE',
	0x00A5: 'MMULT',
	0x00A6: 'FILES',
	0x00A7: 'IPMT',
	0x00A8: 'PPMT',
	0x00A9: 'COUNTA',
	0x00AA: 'CANCEL.KEY',
	0x00AB: 'FOR',
	0x00AC: 'WHILE',
	0x00AD: 'BREAK',
	0x00AE: 'NEXT',
	0x00AF: 'INITIATE',
	0x00B0: 'REQUEST',
	0x00B1: 'POKE',
	0x00B2: 'EXECUTE',
	0x00B3: 'TERMINATE',
	0x00B4: 'RESTART',
	0x00B5: 'HELP',
	0x00B6: 'GET.BAR',
	0x00B7: 'PRODUCT',
	0x00B8: 'FACT',
	0x00B9: 'GET.CELL',
	0x00BA: 'GET.WORKSPACE',
	0x00BB: 'GET.WINDOW',
	0x00BC: 'GET.DOCUMENT',
	0x00BD: 'DPRODUCT',
	0x00BE: 'ISNONTEXT',
	0x00BF: 'GET.NOTE',
	0x00C0: 'NOTE',
	0x00C1: 'STDEVP',
	0x00C2: 'VARP',
	0x00C3: 'DSTDEVP',
	0x00C4: 'DVARP',
	0x00C5: 'TRUNC',
	0x00C6: 'ISLOGICAL',
	0x00C7: 'DCOUNTA',
	0x00C8: 'DELETE.BAR',
	0x00C9: 'UNREGISTER',
	0x00CC: 'USDOLLAR',
	0x00CD: 'FINDB',
	0x00CE: 'SEARCHB',
	0x00CF: 'REPLACEB',
	0x00D0: 'LEFTB',
	0x00D1: 'RIGHTB',
	0x00D2: 'MIDB',
	0x00D3: 'LENB',
	0x00D4: 'ROUNDUP',
	0x00D5: 'ROUNDDOWN',
	0x00D6: 'ASC',
	0x00D7: 'DBCS',
	0x00D8: 'RANK',
	0x00DB: 'ADDRESS',
	0x00DC: 'DAYS360',
	0x00DD: 'TODAY',
	0x00DE: 'VDB',
	0x00DF: 'ELSE',
	0x00E0: 'ELSE.IF',
	0x00E1: 'END.IF',
	0x00E2: 'FOR.CELL',
	0x00E3: 'MEDIAN',
	0x00E4: 'SUMPRODUCT',
	0x00E5: 'SINH',
	0x00E6: 'COSH',
	0x00E7: 'TANH',
	0x00E8: 'ASINH',
	0x00E9: 'ACOSH',
	0x00EA: 'ATANH',
	0x00EB: 'DGET',
	0x00EC: 'CREATE.OBJECT',
	0x00ED: 'VOLATILE',
	0x00EE: 'LAST.ERROR',
	0x00EF: 'CUSTOM.UNDO',
	0x00F0: 'CUSTOM.REPEAT',
	0x00F1: 'FORMULA.CONVERT',
	0x00F2: 'GET.LINK.INFO',
	0x00F3: 'TEXT.BOX',
	0x00F4: 'INFO',
	0x00F5: 'GROUP',
	0x00F6: 'GET.OBJECT',
	0x00F7: 'DB',
	0x00F8: 'PAUSE',
	0x00FB: 'RESUME',
	0x00FC: 'FREQUENCY',
	0x00FD: 'ADD.TOOLBAR',
	0x00FE: 'DELETE.TOOLBAR',
	0x00FF: 'User',
	0x0100: 'RESET.TOOLBAR',
	0x0101: 'EVALUATE',
	0x0102: 'GET.TOOLBAR',
	0x0103: 'GET.TOOL',
	0x0104: 'SPELLING.CHECK',
	0x0105: 'ERROR.TYPE',
	0x0106: 'APP.TITLE',
	0x0107: 'WINDOW.TITLE',
	0x0108: 'SAVE.TOOLBAR',
	0x0109: 'ENABLE.TOOL',
	0x010A: 'PRESS.TOOL',
	0x010B: 'REGISTER.ID',
	0x010C: 'GET.WORKBOOK',
	0x010D: 'AVEDEV',
	0x010E: 'BETADIST',
	0x010F: 'GAMMALN',
	0x0110: 'BETAINV',
	0x0111: 'BINOMDIST',
	0x0112: 'CHIDIST',
	0x0113: 'CHIINV',
	0x0114: 'COMBIN',
	0x0115: 'CONFIDENCE',
	0x0116: 'CRITBINOM',
	0x0117: 'EVEN',
	0x0118: 'EXPONDIST',
	0x0119: 'FDIST',
	0x011A: 'FINV',
	0x011B: 'FISHER',
	0x011C: 'FISHERINV',
	0x011D: 'FLOOR',
	0x011E: 'GAMMADIST',
	0x011F: 'GAMMAINV',
	0x0120: 'CEILING',
	0x0121: 'HYPGEOMDIST',
	0x0122: 'LOGNORMDIST',
	0x0123: 'LOGINV',
	0x0124: 'NEGBINOMDIST',
	0x0125: 'NORMDIST',
	0x0126: 'NORMSDIST',
	0x0127: 'NORMINV',
	0x0128: 'NORMSINV',
	0x0129: 'STANDARDIZE',
	0x012A: 'ODD',
	0x012B: 'PERMUT',
	0x012C: 'POISSON',
	0x012D: 'TDIST',
	0x012E: 'WEIBULL',
	0x012F: 'SUMXMY2',
	0x0130: 'SUMX2MY2',
	0x0131: 'SUMX2PY2',
	0x0132: 'CHITEST',
	0x0133: 'CORREL',
	0x0134: 'COVAR',
	0x0135: 'FORECAST',
	0x0136: 'FTEST',
	0x0137: 'INTERCEPT',
	0x0138: 'PEARSON',
	0x0139: 'RSQ',
	0x013A: 'STEYX',
	0x013B: 'SLOPE',
	0x013C: 'TTEST',
	0x013D: 'PROB',
	0x013E: 'DEVSQ',
	0x013F: 'GEOMEAN',
	0x0140: 'HARMEAN',
	0x0141: 'SUMSQ',
	0x0142: 'KURT',
	0x0143: 'SKEW',
	0x0144: 'ZTEST',
	0x0145: 'LARGE',
	0x0146: 'SMALL',
	0x0147: 'QUARTILE',
	0x0148: 'PERCENTILE',
	0x0149: 'PERCENTRANK',
	0x014A: 'MODE',
	0x014B: 'TRIMMEAN',
	0x014C: 'TINV',
	0x014E: 'MOVIE.COMMAND',
	0x014F: 'GET.MOVIE',
	0x0150: 'CONCATENATE',
	0x0151: 'POWER',
	0x0152: 'PIVOT.ADD.DATA',
	0x0153: 'GET.PIVOT.TABLE',
	0x0154: 'GET.PIVOT.FIELD',
	0x0155: 'GET.PIVOT.ITEM',
	0x0156: 'RADIANS',
	0x0157: 'DEGREES',
	0x0158: 'SUBTOTAL',
	0x0159: 'SUMIF',
	0x015A: 'COUNTIF',
	0x015B: 'COUNTBLANK',
	0x015C: 'SCENARIO.GET',
	0x015D: 'OPTIONS.LISTS.GET',
	0x015E: 'ISPMT',
	0x015F: 'DATEDIF',
	0x0160: 'DATESTRING',
	0x0161: 'NUMBERSTRING',
	0x0162: 'ROMAN',
	0x0163: 'OPEN.DIALOG',
	0x0164: 'SAVE.DIALOG',
	0x0165: 'VIEW.GET',
	0x0166: 'GETPIVOTDATA',
	0x0167: 'HYPERLINK',
	0x0168: 'PHONETIC',
	0x0169: 'AVERAGEA',
	0x016A: 'MAXA',
	0x016B: 'MINA',
	0x016C: 'STDEVPA',
	0x016D: 'VARPA',
	0x016E: 'STDEVA',
	0x016F: 'VARA',
	0x0170: 'BAHTTEXT',
	0x0171: 'THAIDAYOFWEEK',
	0x0172: 'THAIDIGIT',
	0x0173: 'THAIMONTHOFYEAR',
	0x0174: 'THAINUMSOUND',
	0x0175: 'THAINUMSTRING',
	0x0176: 'THAISTRINGLENGTH',
	0x0177: 'ISTHAIDIGIT',
	0x0178: 'ROUNDBAHTDOWN',
	0x0179: 'ROUNDBAHTUP',
	0x017A: 'THAIYEAR',
	0x017B: 'RTD',
	
	0x017C: 'CUBEVALUE',
	0x017D: 'CUBEMEMBER',
	0x017E: 'CUBEMEMBERPROPERTY',
	0x017F: 'CUBERANKEDMEMBER',
	0x0180: 'HEX2BIN',
	0x0181: 'HEX2DEC',
	0x0182: 'HEX2OCT',
	0x0183: 'DEC2BIN',
	0x0184: 'DEC2HEX',
	0x0185: 'DEC2OCT',
	0x0186: 'OCT2BIN',
	0x0187: 'OCT2HEX',
	0x0188: 'OCT2DEC',
	0x0189: 'BIN2DEC',
	0x018A: 'BIN2OCT',
	0x018B: 'BIN2HEX',
	0x018C: 'IMSUB',
	0x018D: 'IMDIV',
	0x018E: 'IMPOWER',
	0x018F: 'IMABS',
	0x0190: 'IMSQRT',
	0x0191: 'IMLN',
	0x0192: 'IMLOG2',
	0x0193: 'IMLOG10',
	0x0194: 'IMSIN',
	0x0195: 'IMCOS',
	0x0196: 'IMEXP',
	0x0197: 'IMARGUMENT',
	0x0198: 'IMCONJUGATE',
	0x0199: 'IMAGINARY',
	0x019A: 'IMREAL',
	0x019B: 'COMPLEX',
	0x019C: 'IMSUM',
	0x019D: 'IMPRODUCT',
	0x019E: 'SERIESSUM',
	0x019F: 'FACTDOUBLE',
	0x01A0: 'SQRTPI',
	0x01A1: 'QUOTIENT',
	0x01A2: 'DELTA',
	0x01A3: 'GESTEP',
	0x01A4: 'ISEVEN',
	0x01A5: 'ISODD',
	0x01A6: 'MROUND',
	0x01A7: 'ERF',
	0x01A8: 'ERFC',
	0x01A9: 'BESSELJ',
	0x01AA: 'BESSELK',
	0x01AB: 'BESSELY',
	0x01AC: 'BESSELI',
	0x01AD: 'XIRR',
	0x01AE: 'XNPV',
	0x01AF: 'PRICEMAT',
	0x01B0: 'YIELDMAT',
	0x01B1: 'INTRATE',
	0x01B2: 'RECEIVED',
	0x01B3: 'DISC',
	0x01B4: 'PRICEDISC',
	0x01B5: 'YIELDDISC',
	0x01B6: 'TBILLEQ',
	0x01B7: 'TBILLPRICE',
	0x01B8: 'TBILLYIELD',
	0x01B9: 'PRICE',
	0x01BA: 'YIELD',
	0x01BB: 'DOLLARDE',
	0x01BC: 'DOLLARFR',
	0x01BD: 'NOMINAL',
	0x01BE: 'EFFECT',
	0x01BF: 'CUMPRINC',
	0x01C0: 'CUMIPMT',
	0x01C1: 'EDATE',
	0x01C2: 'EOMONTH',
	0x01C3: 'YEARFRAC',
	0x01C4: 'COUPDAYBS',
	0x01C5: 'COUPDAYS',
	0x01C6: 'COUPDAYSNC',
	0x01C7: 'COUPNCD',
	0x01C8: 'COUPNUM',
	0x01C9: 'COUPPCD',
	0x01CA: 'DURATION',
	0x01CB: 'MDURATION',
	0x01CC: 'ODDLPRICE',
	0x01CD: 'ODDLYIELD',
	0x01CE: 'ODDFPRICE',
	0x01CF: 'ODDFYIELD',
	0x01D0: 'RANDBETWEEN',
	0x01D1: 'WEEKNUM',
	0x01D2: 'AMORDEGRC',
	0x01D3: 'AMORLINC',
	0x01D4: 'CONVERT',
	0x02D4: 'SHEETJS',
	0x01D5: 'ACCRINT',
	0x01D6: 'ACCRINTM',
	0x01D7: 'WORKDAY',
	0x01D8: 'NETWORKDAYS',
	0x01D9: 'GCD',
	0x01DA: 'MULTINOMIAL',
	0x01DB: 'LCM',
	0x01DC: 'FVSCHEDULE',
	0x01DD: 'CUBEKPIMEMBER',
	0x01DE: 'CUBESET',
	0x01DF: 'CUBESETCOUNT',
	0x01E0: 'IFERROR',
	0x01E1: 'COUNTIFS',
	0x01E2: 'SUMIFS',
	0x01E3: 'AVERAGEIF',
	0x01E4: 'AVERAGEIFS'
	};
	var FtabArgc = {
	0x0002: 1, /* ISNA */
	0x0003: 1, /* ISERROR */
	0x000A: 0, /* NA */
	0x000F: 1, /* SIN */
	0x0010: 1, /* COS */
	0x0011: 1, /* TAN */
	0x0012: 1, /* ATAN */
	0x0013: 0, /* PI */
	0x0014: 1, /* SQRT */
	0x0015: 1, /* EXP */
	0x0016: 1, /* LN */
	0x0017: 1, /* LOG10 */
	0x0018: 1, /* ABS */
	0x0019: 1, /* INT */
	0x001A: 1, /* SIGN */
	0x001B: 2, /* ROUND */
	0x001E: 2, /* REPT */
	0x001F: 3, /* MID */
	0x0020: 1, /* LEN */
	0x0021: 1, /* VALUE */
	0x0022: 0, /* TRUE */
	0x0023: 0, /* FALSE */
	0x0026: 1, /* NOT */
	0x0027: 2, /* MOD */
	0x0028: 3, /* DCOUNT */
	0x0029: 3, /* DSUM */
	0x002A: 3, /* DAVERAGE */
	0x002B: 3, /* DMIN */
	0x002C: 3, /* DMAX */
	0x002D: 3, /* DSTDEV */
	0x002F: 3, /* DVAR */
	0x0030: 2, /* TEXT */
	0x0035: 1, /* GOTO */
	0x003D: 3, /* MIRR */
	0x003F: 0, /* RAND */
	0x0041: 3, /* DATE */
	0x0042: 3, /* TIME */
	0x0043: 1, /* DAY */
	0x0044: 1, /* MONTH */
	0x0045: 1, /* YEAR */
	0x0046: 1, /* WEEKDAY */
	0x0047: 1, /* HOUR */
	0x0048: 1, /* MINUTE */
	0x0049: 1, /* SECOND */
	0x004A: 0, /* NOW */
	0x004B: 1, /* AREAS */
	0x004C: 1, /* ROWS */
	0x004D: 1, /* COLUMNS */
	0x004F: 2, /* ABSREF */
	0x0050: 2, /* RELREF */
	0x0053: 1, /* TRANSPOSE */
	0x0055: 0, /* STEP */
	0x0056: 1, /* TYPE */
	0x0059: 0, /* CALLER */
	0x005A: 1, /* DEREF */
	0x005E: 0, /* ACTIVE.CELL */
	0x005F: 0, /* SELECTION */
	0x0061: 2, /* ATAN2 */
	0x0062: 1, /* ASIN */
	0x0063: 1, /* ACOS */
	0x0065: 3, /* HLOOKUP */
	0x0066: 3, /* VLOOKUP */
	0x0069: 1, /* ISREF */
	0x006A: 1, /* GET.FORMULA */
	0x006C: 2, /* SET.VALUE */
	0x006F: 1, /* CHAR */
	0x0070: 1, /* LOWER */
	0x0071: 1, /* UPPER */
	0x0072: 1, /* PROPER */
	0x0075: 2, /* EXACT */
	0x0076: 1, /* TRIM */
	0x0077: 4, /* REPLACE */
	0x0079: 1, /* CODE */
	0x007E: 1, /* ISERR */
	0x007F: 1, /* ISTEXT */
	0x0080: 1, /* ISNUMBER */
	0x0081: 1, /* ISBLANK */
	0x0082: 1, /* T */
	0x0083: 1, /* N */
	0x0085: 1, /* FCLOSE */
	0x0086: 1, /* FSIZE */
	0x0087: 1, /* FREADLN */
	0x0088: 2, /* FREAD */
	0x0089: 2, /* FWRITELN */
	0x008A: 2, /* FWRITE */
	0x008C: 1, /* DATEVALUE */
	0x008D: 1, /* TIMEVALUE */
	0x008E: 3, /* SLN */
	0x008F: 4, /* SYD */
	0x0090: 4, /* DDB */
	0x00A1: 1, /* DIALOG.BOX */
	0x00A2: 1, /* CLEAN */
	0x00A3: 1, /* MDETERM */
	0x00A4: 1, /* MINVERSE */
	0x00A5: 2, /* MMULT */
	0x00AC: 1, /* WHILE */
	0x00AF: 2, /* INITIATE */
	0x00B0: 2, /* REQUEST */
	0x00B1: 3, /* POKE */
	0x00B2: 2, /* EXECUTE */
	0x00B3: 1, /* TERMINATE */
	0x00B8: 1, /* FACT */
	0x00BA: 1, /* GET.WORKSPACE */
	0x00BD: 3, /* DPRODUCT */
	0x00BE: 1, /* ISNONTEXT */
	0x00C3: 3, /* DSTDEVP */
	0x00C4: 3, /* DVARP */
	0x00C5: 1, /* TRUNC */
	0x00C6: 1, /* ISLOGICAL */
	0x00C7: 3, /* DCOUNTA */
	0x00C9: 1, /* UNREGISTER */
	0x00CF: 4, /* REPLACEB */
	0x00D2: 3, /* MIDB */
	0x00D3: 1, /* LENB */
	0x00D4: 2, /* ROUNDUP */
	0x00D5: 2, /* ROUNDDOWN */
	0x00D6: 1, /* ASC */
	0x00D7: 1, /* DBCS */
	0x00E1: 0, /* END.IF */
	0x00E5: 1, /* SINH */
	0x00E6: 1, /* COSH */
	0x00E7: 1, /* TANH */
	0x00E8: 1, /* ASINH */
	0x00E9: 1, /* ACOSH */
	0x00EA: 1, /* ATANH */
	0x00EB: 3, /* DGET */
	0x00F4: 1, /* INFO */
	0x00F7: 4, /* DB */
	0x00FC: 2, /* FREQUENCY */
	0x0101: 1, /* EVALUATE */
	0x0105: 1, /* ERROR.TYPE */
	0x010F: 1, /* GAMMALN */
	0x0111: 4, /* BINOMDIST */
	0x0112: 2, /* CHIDIST */
	0x0113: 2, /* CHIINV */
	0x0114: 2, /* COMBIN */
	0x0115: 3, /* CONFIDENCE */
	0x0116: 3, /* CRITBINOM */
	0x0117: 1, /* EVEN */
	0x0118: 3, /* EXPONDIST */
	0x0119: 3, /* FDIST */
	0x011A: 3, /* FINV */
	0x011B: 1, /* FISHER */
	0x011C: 1, /* FISHERINV */
	0x011D: 2, /* FLOOR */
	0x011E: 4, /* GAMMADIST */
	0x011F: 3, /* GAMMAINV */
	0x0120: 2, /* CEILING */
	0x0121: 4, /* HYPGEOMDIST */
	0x0122: 3, /* LOGNORMDIST */
	0x0123: 3, /* LOGINV */
	0x0124: 3, /* NEGBINOMDIST */
	0x0125: 4, /* NORMDIST */
	0x0126: 1, /* NORMSDIST */
	0x0127: 3, /* NORMINV */
	0x0128: 1, /* NORMSINV */
	0x0129: 3, /* STANDARDIZE */
	0x012A: 1, /* ODD */
	0x012B: 2, /* PERMUT */
	0x012C: 3, /* POISSON */
	0x012D: 3, /* TDIST */
	0x012E: 4, /* WEIBULL */
	0x012F: 2, /* SUMXMY2 */
	0x0130: 2, /* SUMX2MY2 */
	0x0131: 2, /* SUMX2PY2 */
	0x0132: 2, /* CHITEST */
	0x0133: 2, /* CORREL */
	0x0134: 2, /* COVAR */
	0x0135: 3, /* FORECAST */
	0x0136: 2, /* FTEST */
	0x0137: 2, /* INTERCEPT */
	0x0138: 2, /* PEARSON */
	0x0139: 2, /* RSQ */
	0x013A: 2, /* STEYX */
	0x013B: 2, /* SLOPE */
	0x013C: 4, /* TTEST */
	0x0145: 2, /* LARGE */
	0x0146: 2, /* SMALL */
	0x0147: 2, /* QUARTILE */
	0x0148: 2, /* PERCENTILE */
	0x014B: 2, /* TRIMMEAN */
	0x014C: 2, /* TINV */
	0x0151: 2, /* POWER */
	0x0156: 1, /* RADIANS */
	0x0157: 1, /* DEGREES */
	0x015A: 2, /* COUNTIF */
	0x015B: 1, /* COUNTBLANK */
	0x015E: 4, /* ISPMT */
	0x015F: 3, /* DATEDIF */
	0x0160: 1, /* DATESTRING */
	0x0161: 2, /* NUMBERSTRING */
	0x0168: 1, /* PHONETIC */
	0x0170: 1, /* BAHTTEXT */
	0x0171: 1, /* THAIDAYOFWEEK */
	0x0172: 1, /* THAIDIGIT */
	0x0173: 1, /* THAIMONTHOFYEAR */
	0x0174: 1, /* THAINUMSOUND */
	0x0175: 1, /* THAINUMSTRING */
	0x0176: 1, /* THAISTRINGLENGTH */
	0x0177: 1, /* ISTHAIDIGIT */
	0x0178: 1, /* ROUNDBAHTDOWN */
	0x0179: 1, /* ROUNDBAHTUP */
	0x017A: 1, /* THAIYEAR */
	0x017E: 3, /* CUBEMEMBERPROPERTY */
	0x0181: 1, /* HEX2DEC */
	0x0188: 1, /* OCT2DEC */
	0x0189: 1, /* BIN2DEC */
	0x018C: 2, /* IMSUB */
	0x018D: 2, /* IMDIV */
	0x018E: 2, /* IMPOWER */
	0x018F: 1, /* IMABS */
	0x0190: 1, /* IMSQRT */
	0x0191: 1, /* IMLN */
	0x0192: 1, /* IMLOG2 */
	0x0193: 1, /* IMLOG10 */
	0x0194: 1, /* IMSIN */
	0x0195: 1, /* IMCOS */
	0x0196: 1, /* IMEXP */
	0x0197: 1, /* IMARGUMENT */
	0x0198: 1, /* IMCONJUGATE */
	0x0199: 1, /* IMAGINARY */
	0x019A: 1, /* IMREAL */
	0x019E: 4, /* SERIESSUM */
	0x019F: 1, /* FACTDOUBLE */
	0x01A0: 1, /* SQRTPI */
	0x01A1: 2, /* QUOTIENT */
	0x01A4: 1, /* ISEVEN */
	0x01A5: 1, /* ISODD */
	0x01A6: 2, /* MROUND */
	0x01A8: 1, /* ERFC */
	0x01A9: 2, /* BESSELJ */
	0x01AA: 2, /* BESSELK */
	0x01AB: 2, /* BESSELY */
	0x01AC: 2, /* BESSELI */
	0x01AE: 3, /* XNPV */
	0x01B6: 3, /* TBILLEQ */
	0x01B7: 3, /* TBILLPRICE */
	0x01B8: 3, /* TBILLYIELD */
	0x01BB: 2, /* DOLLARDE */
	0x01BC: 2, /* DOLLARFR */
	0x01BD: 2, /* NOMINAL */
	0x01BE: 2, /* EFFECT */
	0x01BF: 6, /* CUMPRINC */
	0x01C0: 6, /* CUMIPMT */
	0x01C1: 2, /* EDATE */
	0x01C2: 2, /* EOMONTH */
	0x01D0: 2, /* RANDBETWEEN */
	0x01D4: 3, /* CONVERT */
	0x01DC: 2, /* FVSCHEDULE */
	0x01DF: 1, /* CUBESETCOUNT */
	0x01E0: 2, /* IFERROR */
	0xFFFF: 0
	};
	/* [MS-XLSX] 2.2.3 Functions */
	/* [MS-XLSB] 2.5.97.10 Ftab */
	var XLSXFutureFunctions = {
		"_xlfn.ACOT": "ACOT",
		"_xlfn.ACOTH": "ACOTH",
		"_xlfn.AGGREGATE": "AGGREGATE",
		"_xlfn.ARABIC": "ARABIC",
		"_xlfn.AVERAGEIF": "AVERAGEIF",
		"_xlfn.AVERAGEIFS": "AVERAGEIFS",
		"_xlfn.BASE": "BASE",
		"_xlfn.BETA.DIST": "BETA.DIST",
		"_xlfn.BETA.INV": "BETA.INV",
		"_xlfn.BINOM.DIST": "BINOM.DIST",
		"_xlfn.BINOM.DIST.RANGE": "BINOM.DIST.RANGE",
		"_xlfn.BINOM.INV": "BINOM.INV",
		"_xlfn.BITAND": "BITAND",
		"_xlfn.BITLSHIFT": "BITLSHIFT",
		"_xlfn.BITOR": "BITOR",
		"_xlfn.BITRSHIFT": "BITRSHIFT",
		"_xlfn.BITXOR": "BITXOR",
		"_xlfn.CEILING.MATH": "CEILING.MATH",
		"_xlfn.CEILING.PRECISE": "CEILING.PRECISE",
		"_xlfn.CHISQ.DIST": "CHISQ.DIST",
		"_xlfn.CHISQ.DIST.RT": "CHISQ.DIST.RT",
		"_xlfn.CHISQ.INV": "CHISQ.INV",
		"_xlfn.CHISQ.INV.RT": "CHISQ.INV.RT",
		"_xlfn.CHISQ.TEST": "CHISQ.TEST",
		"_xlfn.COMBINA": "COMBINA",
		"_xlfn.CONCAT": "CONCAT",
		"_xlfn.CONFIDENCE.NORM": "CONFIDENCE.NORM",
		"_xlfn.CONFIDENCE.T": "CONFIDENCE.T",
		"_xlfn.COT": "COT",
		"_xlfn.COTH": "COTH",
		"_xlfn.COUNTIFS": "COUNTIFS",
		"_xlfn.COVARIANCE.P": "COVARIANCE.P",
		"_xlfn.COVARIANCE.S": "COVARIANCE.S",
		"_xlfn.CSC": "CSC",
		"_xlfn.CSCH": "CSCH",
		"_xlfn.DAYS": "DAYS",
		"_xlfn.DECIMAL": "DECIMAL",
		"_xlfn.ECMA.CEILING": "ECMA.CEILING",
		"_xlfn.ERF.PRECISE": "ERF.PRECISE",
		"_xlfn.ERFC.PRECISE": "ERFC.PRECISE",
		"_xlfn.EXPON.DIST": "EXPON.DIST",
		"_xlfn.F.DIST": "F.DIST",
		"_xlfn.F.DIST.RT": "F.DIST.RT",
		"_xlfn.F.INV": "F.INV",
		"_xlfn.F.INV.RT": "F.INV.RT",
		"_xlfn.F.TEST": "F.TEST",
		"_xlfn.FILTERXML": "FILTERXML",
		"_xlfn.FLOOR.MATH": "FLOOR.MATH",
		"_xlfn.FLOOR.PRECISE": "FLOOR.PRECISE",
		"_xlfn.FORECAST.ETS": "FORECAST.ETS",
		"_xlfn.FORECAST.ETS.CONFINT": "FORECAST.ETS.CONFINT",
		"_xlfn.FORECAST.ETS.SEASONALITY": "FORECAST.ETS.SEASONALITY",
		"_xlfn.FORECAST.ETS.STAT": "FORECAST.ETS.STAT",
		"_xlfn.FORECAST.LINEAR": "FORECAST.LINEAR",
		"_xlfn.FORMULATEXT": "FORMULATEXT",
		"_xlfn.GAMMA": "GAMMA",
		"_xlfn.GAMMA.DIST": "GAMMA.DIST",
		"_xlfn.GAMMA.INV": "GAMMA.INV",
		"_xlfn.GAMMALN.PRECISE": "GAMMALN.PRECISE",
		"_xlfn.GAUSS": "GAUSS",
		"_xlfn.HYPGEOM.DIST": "HYPGEOM.DIST",
		"_xlfn.IFERROR": "IFERROR",
		"_xlfn.IFNA": "IFNA",
		"_xlfn.IFS": "IFS",
		"_xlfn.IMCOSH": "IMCOSH",
		"_xlfn.IMCOT": "IMCOT",
		"_xlfn.IMCSC": "IMCSC",
		"_xlfn.IMCSCH": "IMCSCH",
		"_xlfn.IMSEC": "IMSEC",
		"_xlfn.IMSECH": "IMSECH",
		"_xlfn.IMSINH": "IMSINH",
		"_xlfn.IMTAN": "IMTAN",
		"_xlfn.ISFORMULA": "ISFORMULA",
		"_xlfn.ISO.CEILING": "ISO.CEILING",
		"_xlfn.ISOWEEKNUM": "ISOWEEKNUM",
		"_xlfn.LOGNORM.DIST": "LOGNORM.DIST",
		"_xlfn.LOGNORM.INV": "LOGNORM.INV",
		"_xlfn.MAXIFS": "MAXIFS",
		"_xlfn.MINIFS": "MINIFS",
		"_xlfn.MODE.MULT": "MODE.MULT",
		"_xlfn.MODE.SNGL": "MODE.SNGL",
		"_xlfn.MUNIT": "MUNIT",
		"_xlfn.NEGBINOM.DIST": "NEGBINOM.DIST",
		"_xlfn.NETWORKDAYS.INTL": "NETWORKDAYS.INTL",
		"_xlfn.NIGBINOM": "NIGBINOM",
		"_xlfn.NORM.DIST": "NORM.DIST",
		"_xlfn.NORM.INV": "NORM.INV",
		"_xlfn.NORM.S.DIST": "NORM.S.DIST",
		"_xlfn.NORM.S.INV": "NORM.S.INV",
		"_xlfn.NUMBERVALUE": "NUMBERVALUE",
		"_xlfn.PDURATION": "PDURATION",
		"_xlfn.PERCENTILE.EXC": "PERCENTILE.EXC",
		"_xlfn.PERCENTILE.INC": "PERCENTILE.INC",
		"_xlfn.PERCENTRANK.EXC": "PERCENTRANK.EXC",
		"_xlfn.PERCENTRANK.INC": "PERCENTRANK.INC",
		"_xlfn.PERMUTATIONA": "PERMUTATIONA",
		"_xlfn.PHI": "PHI",
		"_xlfn.POISSON.DIST": "POISSON.DIST",
		"_xlfn.QUARTILE.EXC": "QUARTILE.EXC",
		"_xlfn.QUARTILE.INC": "QUARTILE.INC",
		"_xlfn.QUERYSTRING": "QUERYSTRING",
		"_xlfn.RANK.AVG": "RANK.AVG",
		"_xlfn.RANK.EQ": "RANK.EQ",
		"_xlfn.RRI": "RRI",
		"_xlfn.SEC": "SEC",
		"_xlfn.SECH": "SECH",
		"_xlfn.SHEET": "SHEET",
		"_xlfn.SHEETS": "SHEETS",
		"_xlfn.SKEW.P": "SKEW.P",
		"_xlfn.STDEV.P": "STDEV.P",
		"_xlfn.STDEV.S": "STDEV.S",
		"_xlfn.SUMIFS": "SUMIFS",
		"_xlfn.SWITCH": "SWITCH",
		"_xlfn.T.DIST": "T.DIST",
		"_xlfn.T.DIST.2T": "T.DIST.2T",
		"_xlfn.T.DIST.RT": "T.DIST.RT",
		"_xlfn.T.INV": "T.INV",
		"_xlfn.T.INV.2T": "T.INV.2T",
		"_xlfn.T.TEST": "T.TEST",
		"_xlfn.TEXTJOIN": "TEXTJOIN",
		"_xlfn.UNICHAR": "UNICHAR",
		"_xlfn.UNICODE": "UNICODE",
		"_xlfn.VAR.P": "VAR.P",
		"_xlfn.VAR.S": "VAR.S",
		"_xlfn.WEBSERVICE": "WEBSERVICE",
		"_xlfn.WEIBULL.DIST": "WEIBULL.DIST",
		"_xlfn.WORKDAY.INTL": "WORKDAY.INTL",
		"_xlfn.XOR": "XOR",
		"_xlfn.Z.TEST": "Z.TEST"
	};
	
	/* Part 3 TODO: actually parse formulae */
	function ods_to_csf_formula(f) {
		if(f.slice(0,3) == "of:") f = f.slice(3);
		/* 5.2 Basic Expressions */
		if(f.charCodeAt(0) == 61) {
			f = f.slice(1);
			if(f.charCodeAt(0) == 61) f = f.slice(1);
		}
		f = f.replace(/COM\.MICROSOFT\./g, "");
		/* Part 3 Section 5.8 References */
		f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) { return $1.replace(/\./g,""); });
		/* TODO: something other than this */
		f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
		return f.replace(/[;~]/g,",").replace(/\|/g,";");
	}
	
	function csf_to_ods_formula(f) {
		var o = "of:=" + f.replace(crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g,":");
		/* TODO: something other than this */
		return o.replace(/;/g, "|").replace(/,/g,";");
	}
	
	function ods_to_csf_3D(r) {
		var a = r.split(":");
		var s = a[0].split(".")[0];
		return [s, a[0].split(".")[1] + (a.length > 1 ? (":" + (a[1].split(".")[1] || a[1].split(".")[0])) : "")];
	}
	
	function csf_to_ods_3D(r) {
		return r.replace(/\./,"!");
	}
	
	var strs = {}; // shared strings
	var _ssfopts = {}; // spreadsheet formatting options
	
	RELS.WS = [
		"http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
		"http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
	];
	
	/*global Map */
	var browser_has_Map = typeof Map !== 'undefined';
	
	function get_sst_id(sst, str, rev) {
		var i = 0, len = sst.length;
		if(rev) {
			if(browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
				var revarr = browser_has_Map ? rev.get(str) : rev[str];
				for(; i < revarr.length; ++i) {
					if(sst[revarr[i]].t === str) { sst.Count ++; return revarr[i]; }
				}
			}
		} else for(; i < len; ++i) {
			if(sst[i].t === str) { sst.Count ++; return i; }
		}
		sst[len] = ({t:str}); sst.Count ++; sst.Unique ++;
		if(rev) {
			if(browser_has_Map) {
				if(!rev.has(str)) rev.set(str, []);
				rev.get(str).push(len);
			} else {
				if(!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
				rev[str].push(len);
			}
		}
		return len;
	}
	
	function col_obj_w(C, col) {
		var p = ({min:C+1,max:C+1});
		/* wch (chars), wpx (pixels) */
		var wch = -1;
		if(col.MDW) MDW = col.MDW;
		if(col.width != null) p.customWidth = 1;
		else if(col.wpx != null) wch = px2char(col.wpx);
		else if(col.wch != null) wch = col.wch;
		if(wch > -1) { p.width = char2width(wch); p.customWidth = 1; }
		else if(col.width != null) p.width = col.width;
		if(col.hidden) p.hidden = true;
		if(col.level != null) { p.outlineLevel = p.level = col.level; }
		return p;
	}
	
	function default_margins(margins, mode) {
		if(!margins) return;
		var defs = [0.7, 0.7, 0.75, 0.75, 0.3, 0.3];
		if(mode == 'xlml') defs = [1, 1, 1, 1, 0.5, 0.5];
		if(margins.left   == null) margins.left   = defs[0];
		if(margins.right  == null) margins.right  = defs[1];
		if(margins.top    == null) margins.top    = defs[2];
		if(margins.bottom == null) margins.bottom = defs[3];
		if(margins.header == null) margins.header = defs[4];
		if(margins.footer == null) margins.footer = defs[5];
	}
	
	function get_cell_style(styles, cell, opts) {
		var z = opts.revssf[cell.z != null ? cell.z : "General"];
		var i = 0x3c, len = styles.length;
		if(z == null && opts.ssf) {
			for(; i < 0x188; ++i) if(opts.ssf[i] == null) {
				SSF.load(cell.z, i);
				// $FlowIgnore
				opts.ssf[i] = cell.z;
				opts.revssf[cell.z] = z = i;
				break;
			}
		}
		for(i = 0; i != len; ++i) if(styles[i].numFmtId === z) return i;
		styles[len] = {
			numFmtId:z,
			fontId:0,
			fillId:0,
			borderId:0,
			xfId:0,
			applyNumberFormat:1
		};
		return len;
	}
	
	function safe_format(p, fmtid, fillid, opts, themes, styles) {
		try {
			if(opts.cellNF) p.z = SSF._table[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(p.t === 'z' && !opts.cellStyles) return;
		if(p.t === 'd' && typeof p.v === 'string') p.v = parseDate(p.v);
		if((!opts || opts.cellText !== false) && p.t !== 'z') try {
			if(SSF._table[fmtid] == null) SSF.load(SSFImplicit[fmtid] || "General", fmtid);
			if(p.t === 'e') p.w = p.w || BErr[p.v];
			else if(fmtid === 0) {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
					else p.w = SSF._general_num(p.v);
				}
				else if(p.t === 'd') {
					var dd = datenum(p.v);
					if((dd|0) === dd) p.w = SSF._general_int(dd);
					else p.w = SSF._general_num(dd);
				}
				else if(p.v === undefined) return "";
				else p.w = SSF._general(p.v,_ssfopts);
			}
			else if(p.t === 'd') p.w = SSF.format(fmtid,datenum(p.v),_ssfopts);
			else p.w = SSF.format(fmtid,p.v,_ssfopts);
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts.cellStyles) return;
		if(fillid != null) try {
			p.s = styles.Fills[fillid];
			if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
				p.s.fgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
				if(opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
			}
			if (p.s.bgColor && p.s.bgColor.theme) {
				p.s.bgColor.rgb = rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
				if(opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
			}
		} catch(e) { if(opts.WTF && styles.Fills) throw e; }
	}
	
	function check_ws(ws, sname, i) {
		if(ws && ws['!ref']) {
			var range = safe_decode_range(ws['!ref']);
			if(range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
		}
	}
	function parse_ws_xml_dim(ws, s) {
		var d = safe_decode_range(s);
		if(d.s.r<=d.e.r && d.s.c<=d.e.c && d.s.r>=0 && d.s.c>=0) ws["!ref"] = encode_range(d);
	}
	var mergecregex = /<(?:\w:)?mergeCell ref="[A-Z0-9:]+"\s*[\/]?>/g;
	var sheetdataregex = /<(?:\w+:)?sheetData[^>]*>([\s\S]*)<\/(?:\w+:)?sheetData>/;
	var hlinkregex = /<(?:\w:)?hyperlink [^>]*>/mg;
	var dimregex = /"(\w*:\w*)"/;
	var colregex = /<(?:\w:)?col\b[^>]*[\/]?>/g;
	var afregex = /<(?:\w:)?autoFilter[^>]*([\/]|>([\s\S]*)<\/(?:\w:)?autoFilter)>/g;
	var marginregex= /<(?:\w:)?pageMargins[^>]*\/>/g;
	var sheetprregex = /<(?:\w:)?sheetPr\b(?:[^>a-z][^>]*)?\/>/;
	var sheetprregex2= /<(?:\w:)?sheetPr[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetPr)>/;
	var svsregex = /<(?:\w:)?sheetViews[^>]*(?:[\/]|>([\s\S]*)<\/(?:\w:)?sheetViews)>/;
	
	/* 18.3 Worksheets */
	function parse_ws_xml(data, opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
	
		/* 18.3.1.99 worksheet CT_Worksheet */
		var s = opts.dense ? ([]) : ({});
		var refguess = ({s: {r:2000000, c:2000000}, e: {r:0, c:0} });
	
		var data1 = "", data2 = "";
		var mtch = data.match(sheetdataregex);
		if(mtch) {
			data1 = data.slice(0, mtch.index);
			data2 = data.slice(mtch.index + mtch[0].length);
		} else data1 = data2 = data;
	
		/* 18.3.1.82 sheetPr CT_SheetPr */
		var sheetPr = data1.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
		else if((sheetPr = data1.match(sheetprregex2))) parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1]||"", s, wb, idx, styles, themes);
	
		/* 18.3.1.35 dimension CT_SheetDimension */
		var ridx = (data1.match(/<(?:\w*:)?dimension/)||{index:-1}).index;
		if(ridx > 0) {
			var ref = data1.slice(ridx,ridx+50).match(dimregex);
			if(ref) parse_ws_xml_dim(s, ref[1]);
		}
	
		/* 18.3.1.88 sheetViews CT_SheetViews */
		var svs = data1.match(svsregex);
		if(svs && svs[1]) parse_ws_xml_sheetviews(svs[1], wb);
	
		/* 18.3.1.17 cols CT_Cols */
		var columns = [];
		if(opts.cellStyles) {
			/* 18.3.1.13 col CT_Col */
			var cols = data1.match(colregex);
			if(cols) parse_ws_xml_cols(columns, cols);
		}
	
		/* 18.3.1.80 sheetData CT_SheetData ? */
		if(mtch) parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles);
	
		/* 18.3.1.2  autoFilter CT_AutoFilter */
		var afilter = data2.match(afregex);
		if(afilter) s['!autofilter'] = parse_ws_xml_autofilter(afilter[0]);
	
		/* 18.3.1.55 mergeCells CT_MergeCells */
		var merges = [];
		var _merge = data2.match(mergecregex);
		if(_merge) for(ridx = 0; ridx != _merge.length; ++ridx)
			merges[ridx] = safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("\"")+1));
	
		/* 18.3.1.48 hyperlinks CT_Hyperlinks */
		var hlink = data2.match(hlinkregex);
		if(hlink) parse_ws_xml_hlinks(s, hlink, rels);
	
		/* 18.3.1.62 pageMargins CT_PageMargins */
		var margins = data2.match(marginregex);
		if(margins) s['!margins'] = parse_ws_xml_margins(parsexmltag(margins[0]));
	
		if(!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = encode_range(refguess);
		if(opts.sheetRows > 0 && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows <= +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(columns.length > 0) s["!cols"] = columns;
		if(merges.length > 0) s["!merges"] = merges;
		return s;
	}
	
	function write_ws_xml_merges(merges) {
		if(merges.length === 0) return "";
		var o = '<mergeCells count="' + merges.length + '">';
		for(var i = 0; i != merges.length; ++i) o += '<mergeCell ref="' + encode_range(merges[i]) + '"/>';
		return o + '</mergeCells>';
	}
	
	/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */
	function parse_ws_xml_sheetpr(sheetPr, s, wb, idx) {
		var data = parsexmltag(sheetPr);
		if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
		if(data.codeName) wb.Sheets[idx].CodeName = unescapexml(utf8read(data.codeName));
	}
	function parse_ws_xml_sheetpr2(sheetPr, body, s, wb, idx, styles, themes) {
		parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
	}
	function write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
		var needed = false;
		var props = {}, payload = null;
		if(opts.bookType !== 'xlsx' && wb.vbaraw) {
			var cname = wb.SheetNames[idx];
			try { if(wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname; } catch(e) {}
			needed = true;
			props.codeName = utf8write(escapexml(cname));
		}
	
		if(ws && ws["!outline"]) {
			var outlineprops = {summaryBelow:1, summaryRight:1};
			if(ws["!outline"].above) outlineprops.summaryBelow = 0;
			if(ws["!outline"].left) outlineprops.summaryRight = 0;
			payload = (payload||"") + writextag('outlinePr', null, outlineprops);
		}
	
		if(!needed && !payload) return;
		o[o.length] = (writextag('sheetPr', payload, props));
	}
	
	/* 18.3.1.85 sheetProtection CT_SheetProtection */
	var sheetprot_deffalse = ["objects", "scenarios", "selectLockedCells", "selectUnlockedCells"];
	var sheetprot_deftrue = [
		"formatColumns", "formatRows", "formatCells",
		"insertColumns", "insertRows", "insertHyperlinks",
		"deleteColumns", "deleteRows",
		"sort", "autoFilter", "pivotTables"
	];
	function write_ws_xml_protection(sp) {
		// algorithmName, hashValue, saltValue, spinCount
		var o = ({sheet:1});
		sheetprot_deffalse.forEach(function(n) { if(sp[n] != null && sp[n]) o[n] = "1"; });
		sheetprot_deftrue.forEach(function(n) { if(sp[n] != null && !sp[n]) o[n] = "0"; });
		/* TODO: algorithm */
		if(sp.password) o.password = crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
		return writextag('sheetProtection', null, o);
	}
	
	function parse_ws_xml_hlinks(s, data, rels) {
		var dense = Array.isArray(s);
		for(var i = 0; i != data.length; ++i) {
			var val = parsexmltag(utf8read(data[i]), true);
			if(!val.ref) return;
			var rel = ((rels || {})['!id']||[])[val.id];
			if(rel) {
				val.Target = rel.Target;
				if(val.location) val.Target += "#"+unescapexml(val.location);
			} else {
				val.Target = "#" + unescapexml(val.location);
				rel = {Target: val.Target, TargetMode: 'Internal'};
			}
			val.Rel = rel;
			if(val.tooltip) { val.Tooltip = val.tooltip; delete val.tooltip; }
			var rng = safe_decode_range(val.ref);
			for(var R=rng.s.r;R<=rng.e.r;++R) for(var C=rng.s.c;C<=rng.e.c;++C) {
				var addr = encode_cell({c:C,r:R});
				if(dense) {
					if(!s[R]) s[R] = [];
					if(!s[R][C]) s[R][C] = {t:"z",v:undefined};
					s[R][C].l = val;
				} else {
					if(!s[addr]) s[addr] = {t:"z",v:undefined};
					s[addr].l = val;
				}
			}
		}
	}
	
	function parse_ws_xml_margins(margin) {
		var o = {};
		["left", "right", "top", "bottom", "header", "footer"].forEach(function(k) {
			if(margin[k]) o[k] = parseFloat(margin[k]);
		});
		return o;
	}
	function write_ws_xml_margins(margin) {
		default_margins(margin);
		return writextag('pageMargins', null, margin);
	}
	
	function parse_ws_xml_cols(columns, cols) {
		var seencol = false;
		for(var coli = 0; coli != cols.length; ++coli) {
			var coll = parsexmltag(cols[coli], true);
			if(coll.hidden) coll.hidden = parsexmlbool(coll.hidden);
			var colm=parseInt(coll.min, 10)-1, colM=parseInt(coll.max,10)-1;
			if(coll.outlineLevel) coll.level = (+coll.outlineLevel || 0);
			delete coll.min; delete coll.max; coll.width = +coll.width;
			if(!seencol && coll.width) { seencol = true; find_mdw_colw(coll.width); }
			process_col(coll);
			while(colm <= colM) columns[colm++] = dup(coll);
		}
	}
	function write_ws_xml_cols(ws, cols) {
		var o = ["<cols>"], col;
		for(var i = 0; i != cols.length; ++i) {
			if(!(col = cols[i])) continue;
			o[o.length] = (writextag('col', null, col_obj_w(i, col)));
		}
		o[o.length] = "</cols>";
		return o.join("");
	}
	
	function parse_ws_xml_autofilter(data) {
		var o = { ref: (data.match(/ref="([^"]*)"/)||[])[1]};
		return o;
	}
	function write_ws_xml_autofilter(data, ws, wb, idx) {
		var ref = typeof data.ref == "string" ? data.ref : encode_range(data.ref);
		if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		var names = wb.Workbook.Names;
		var range = decode_range(ref);
		if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
		for(var i = 0; i < names.length; ++i) {
			var name = names[i];
			if(name.Name != '_xlnm._FilterDatabase') continue;
			if(name.Sheet != idx) continue;
			name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
		}
		if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
		return writextag("autoFilter", null, {ref:ref});
	}
	
	/* 18.3.1.88 sheetViews CT_SheetViews */
	/* 18.3.1.87 sheetView CT_SheetView */
	var sviewregex = /<(?:\w:)?sheetView(?:[^>a-z][^>]*)?\/?>/;
	function parse_ws_xml_sheetviews(data, wb) {
		if(!wb.Views) wb.Views = [{}];
		(data.match(sviewregex)||[]).forEach(function(r, i) {
			var tag = parsexmltag(r);
			// $FlowIgnore
			if(!wb.Views[i]) wb.Views[i] = {};
			// $FlowIgnore
			if(+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
			// $FlowIgnore
			if(parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
		});
	}
	function write_ws_xml_sheetviews(ws, opts, idx, wb) {
		var sview = ({workbookViewId:"0"});
		// $FlowIgnore
		if((((wb||{}).Workbook||{}).Views||[])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
		return writextag("sheetViews", writextag("sheetView", null, sview), {});
	}
	
	function write_ws_xml_cell(cell, ref, ws, opts) {
		if(cell.v === undefined && typeof cell.f !== "string" || cell.t === 'z') return "";
		var vv = "";
		var oldt = cell.t, oldv = cell.v;
		if(cell.t !== "z") switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'n': vv = ''+cell.v; break;
			case 'e': vv = BErr[cell.v]; break;
			case 'd':
				if(opts && opts.cellDates) vv = parseDate(cell.v, -1).toISOString();
				else {
					cell = dup(cell);
					cell.t = 'n';
					vv = ''+(cell.v = datenum(parseDate(cell.v)));
				}
				if(typeof cell.z === 'undefined') cell.z = SSF._table[14];
				break;
			default: vv = cell.v; break;
		}
		var v = writetag('v', escapexml(vv)), o = ({r:ref});
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		if(os !== 0) o.s = os;
		switch(cell.t) {
			case 'n': break;
			case 'd': o.t = "d"; break;
			case 'b': o.t = "b"; break;
			case 'e': o.t = "e"; break;
			case 'z': break;
			default: if(cell.v == null) { delete cell.t; break; }
				if(cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
				if(opts && opts.bookSST) {
					v = writetag('v', ''+get_sst_id(opts.Strings, cell.v, opts.revStrings));
					o.t = "s"; break;
				}
				o.t = "str"; break;
		}
		if(cell.t != oldt) { cell.t = oldt; cell.v = oldv; }
		if(typeof cell.f == "string" && cell.f) {
			var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {t:"array", ref:cell.F} : null;
			v = writextag('f', escapexml(cell.f), ff) + (cell.v != null ? v : "");
		}
		if(cell.l) ws['!links'].push([ref, cell.l]);
		if(cell.c) ws['!comments'].push([ref, cell.c]);
		return writextag('c', v, o);
	}
	
	var parse_ws_xml_data = (function() {
		var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
		var rregex = /r=["']([^"']*)["']/, isregex = /<(?:\w+:)?is>([\S\s]*?)<\/(?:\w+:)?is>/;
		var refregex = /ref=["']([^"']*)["']/;
		var match_v = matchtag("v"), match_f = matchtag("f");
	
	return function parse_ws_xml_data(sdata, s, opts, guess, themes, styles) {
		var ri = 0, x = "", cells = [], cref = [], idx=0, i=0, cc=0, d="", p;
		var tag, tagr = 0, tagc = 0;
		var sstr, ftag;
		var fmtid = 0, fillid = 0;
		var do_format = Array.isArray(styles.CellXf), cf;
		var arrayf = [];
		var sharedf = [];
		var dense = Array.isArray(s);
		var rows = [], rowobj = {}, rowrite = false;
		var sheetStubs = !!opts.sheetStubs;
		for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt) {
			x = marr[mt].trim();
			var xlen = x.length;
			if(xlen === 0) continue;
	
			/* 18.3.1.73 row CT_Row */
			var rstarti = 0;
			outa: for(ri = 0; ri < xlen; ++ri) switch(/*x.charCodeAt(ri)*/x[ri]) {
				case ">" /*62*/:
					if(/*x.charCodeAt(ri-1) != 47*/x[ri-1] != "/") { ++ri; break outa; }
					if(opts && opts.cellStyles) {
						// TODO: avoid duplication
						tag = parsexmltag(x.slice(rstarti,ri), true);
						tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
						if(opts.sheetRows && opts.sheetRows < tagr) continue;
						rowobj = {}; rowrite = false;
						if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
						if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
						if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
						if(rowrite) rows[tagr-1] = rowobj;
					}
					break;
				case "<" /*60*/: rstarti = ri; break;
			}
			if(rstarti >= ri) break;
			tag = parsexmltag(x.slice(rstarti,ri), true);
			tagr = tag.r != null ? parseInt(tag.r, 10) : tagr+1; tagc = -1;
			if(opts.sheetRows && opts.sheetRows < tagr) continue;
			if(guess.s.r > tagr - 1) guess.s.r = tagr - 1;
			if(guess.e.r < tagr - 1) guess.e.r = tagr - 1;
	
			if(opts && opts.cellStyles) {
				rowobj = {}; rowrite = false;
				if(tag.ht) { rowrite = true; rowobj.hpt = parseFloat(tag.ht); rowobj.hpx = pt2px(rowobj.hpt); }
				if(tag.hidden == "1") { rowrite = true; rowobj.hidden = true; }
				if(tag.outlineLevel != null) { rowrite = true; rowobj.level = +tag.outlineLevel; }
				if(rowrite) rows[tagr-1] = rowobj;
			}
	
			/* 18.3.1.4 c CT_Cell */
			cells = x.slice(ri).split(cellregex);
			for(var rslice = 0; rslice != cells.length; ++rslice) if(cells[rslice].trim().charAt(0) != "<") break;
			cells = cells.slice(rslice);
			for(ri = 0; ri != cells.length; ++ri) {
				x = cells[ri].trim();
				if(x.length === 0) continue;
				cref = x.match(rregex); idx = ri; i=0; cc=0;
				x = "<c " + (x.slice(0,1)=="<"?">":"") + x;
				if(cref != null && cref.length === 2) {
					idx = 0; d=cref[1];
					for(i=0; i != d.length; ++i) {
						if((cc=d.charCodeAt(i)-64) < 1 || cc > 26) break;
						idx = 26*idx + cc;
					}
					--idx;
					tagc = idx;
				} else ++tagc;
				for(i = 0; i != x.length; ++i) if(x.charCodeAt(i) === 62) break; ++i;
				tag = parsexmltag(x.slice(0,i), true);
				if(!tag.r) tag.r = encode_cell({r:tagr-1, c:tagc});
				d = x.slice(i);
				p = ({t:""});
	
				if((cref=d.match(match_v))!= null && cref[1] !== '') p.v=unescapexml(cref[1]);
				if(opts.cellFormula) {
					if((cref=d.match(match_f))!= null && cref[1] !== '') {
						/* TODO: match against XLSXFutureFunctions */
						p.f=unescapexml(utf8read(cref[1])).replace(/\r\n/g, "\n");
						if(!opts.xlfn) p.f = _xlfn(p.f);
						if(cref[0].indexOf('t="array"') > -1) {
							p.F = (d.match(refregex)||[])[1];
							if(p.F.indexOf(":") > -1) arrayf.push([safe_decode_range(p.F), p.F]);
						} else if(cref[0].indexOf('t="shared"') > -1) {
							// TODO: parse formula
							ftag = parsexmltag(cref[0]);
							var ___f = unescapexml(utf8read(cref[1]));
							if(!opts.xlfn) ___f = _xlfn(___f);
							sharedf[parseInt(ftag.si, 10)] = [ftag, ___f, tag.r];
						}
					} else if((cref=d.match(/<f[^>]*\/>/))) {
						ftag = parsexmltag(cref[0]);
						if(sharedf[ftag.si]) p.f = shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2]/*[0].ref*/, tag.r);
					}
					/* TODO: factor out contains logic */
					var _tag = decode_cell(tag.r);
					for(i = 0; i < arrayf.length; ++i)
						if(_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r)
							if(_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c)
								p.F = arrayf[i][1];
				}
	
				if(tag.t == null && p.v === undefined) {
					if(p.f || p.F) {
						p.v = 0; p.t = "n";
					} else if(!sheetStubs) continue;
					else p.t = "z";
				}
				else p.t = tag.t || "n";
				if(guess.s.c > tagc) guess.s.c = tagc;
				if(guess.e.c < tagc) guess.e.c = tagc;
				/* 18.18.11 t ST_CellType */
				switch(p.t) {
					case 'n':
						if(p.v == "" || p.v == null) {
							if(!sheetStubs) continue;
							p.t = 'z';
						} else p.v = parseFloat(p.v);
						break;
					case 's':
						if(typeof p.v == 'undefined') {
							if(!sheetStubs) continue;
							p.t = 'z';
						} else {
							sstr = strs[parseInt(p.v, 10)];
							p.v = sstr.t;
							p.r = sstr.r;
							if(opts.cellHTML) p.h = sstr.h;
						}
						break;
					case 'str':
						p.t = "s";
						p.v = (p.v!=null) ? utf8read(p.v) : '';
						if(opts.cellHTML) p.h = escapehtml(p.v);
						break;
					case 'inlineStr':
						cref = d.match(isregex);
						p.t = 's';
						if(cref != null && (sstr = parse_si(cref[1]))) {
							p.v = sstr.t;
							if(opts.cellHTML) p.h = sstr.h;
						} else p.v = "";
						break;
					case 'b': p.v = parsexmlbool(p.v); break;
					case 'd':
						if(opts.cellDates) p.v = parseDate(p.v, 1);
						else { p.v = datenum(parseDate(p.v, 1)); p.t = 'n'; }
						break;
					/* error string in .w, number in .v */
					case 'e':
						if(!opts || opts.cellText !== false) p.w = p.v;
						p.v = RBErr[p.v]; break;
				}
				/* formatting */
				fmtid = fillid = 0;
				cf = null;
				if(do_format && tag.s !== undefined) {
					cf = styles.CellXf[tag.s];
					if(cf != null) {
						if(cf.numFmtId != null) fmtid = cf.numFmtId;
						if(opts.cellStyles) {
							if(cf.fillId != null) fillid = cf.fillId;
						}
					}
				}
				safe_format(p, fmtid, fillid, opts, themes, styles);
				if(opts.cellDates && do_format && p.t == 'n' && SSF.is_date(SSF._table[fmtid])) { p.t = 'd'; p.v = numdate(p.v); }
				if(dense) {
					var _r = decode_cell(tag.r);
					if(!s[_r.r]) s[_r.r] = [];
					s[_r.r][_r.c] = p;
				} else s[tag.r] = p;
			}
		}
		if(rows.length > 0) s['!rows'] = rows;
	}; })();
	
	function write_ws_xml_data(ws, opts, idx, wb) {
		var o = [], r = [], range = safe_decode_range(ws['!ref']), cell="", ref, rr = "", cols = [], R=0, C=0, rows = ws['!rows'];
		var dense = Array.isArray(ws);
		var params = ({r:rr}), row, height = -1;
		for(C = range.s.c; C <= range.e.c; ++C) cols[C] = encode_col(C);
		for(R = range.s.r; R <= range.e.r; ++R) {
			r = [];
			rr = encode_row(R);
			for(C = range.s.c; C <= range.e.c; ++C) {
				ref = cols[C] + rr;
				var _cell = dense ? (ws[R]||[])[C]: ws[ref];
				if(_cell === undefined) continue;
				if((cell = write_ws_xml_cell(_cell, ref, ws, opts, idx, wb)) != null) r.push(cell);
			}
			if(r.length > 0 || (rows && rows[R])) {
				params = ({r:rr});
				if(rows && rows[R]) {
					row = rows[R];
					if(row.hidden) params.hidden = 1;
					height = -1;
					if(row.hpx) height = px2pt(row.hpx);
					else if(row.hpt) height = row.hpt;
					if(height > -1) { params.ht = height; params.customHeight = 1; }
					if(row.level) { params.outlineLevel = row.level; }
				}
				o[o.length] = (writextag('row', r.join(""), params));
			}
		}
		if(rows) for(; R < rows.length; ++R) {
			if(rows && rows[R]) {
				params = ({r:R+1});
				row = rows[R];
				if(row.hidden) params.hidden = 1;
				height = -1;
				if (row.hpx) height = px2pt(row.hpx);
				else if (row.hpt) height = row.hpt;
				if (height > -1) { params.ht = height; params.customHeight = 1; }
				if (row.level) { params.outlineLevel = row.level; }
				o[o.length] = (writextag('row', "", params));
			}
		}
		return o.join("");
	}
	
	var WS_XML_ROOT = writextag('worksheet', null, {
		'xmlns': XMLNS.main[0],
		'xmlns:r': XMLNS.r
	});
	
	function write_ws_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, WS_XML_ROOT];
		var s = wb.SheetNames[idx], sidx = 0, rdata = "";
		var ws = wb.Sheets[s];
		if(ws == null) ws = {};
		var ref = ws['!ref'] || 'A1';
		var range = safe_decode_range(ref);
		if(range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
			if(opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
			range.e.c = Math.min(range.e.c, 0x3FFF);
			range.e.r = Math.min(range.e.c, 0xFFFFF);
			ref = encode_range(range);
		}
		if(!rels) rels = {};
		ws['!comments'] = [];
		var _drawing = [];
	
		write_ws_xml_sheetpr(ws, wb, idx, opts, o);
	
		o[o.length] = (writextag('dimension', null, {'ref': ref}));
	
		o[o.length] = write_ws_xml_sheetviews(ws, opts, idx, wb);
	
		/* TODO: store in WB, process styles */
		if(opts.sheetFormat) o[o.length] = (writextag('sheetFormatPr', null, {
			defaultRowHeight:opts.sheetFormat.defaultRowHeight||'16',
			baseColWidth:opts.sheetFormat.baseColWidth||'10',
			outlineLevelRow:opts.sheetFormat.outlineLevelRow||'7'
		}));
	
		if(ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = (write_ws_xml_cols(ws, ws['!cols']));
	
		o[sidx = o.length] = '<sheetData/>';
		ws['!links'] = [];
		if(ws['!ref'] != null) {
			rdata = write_ws_xml_data(ws, opts, idx, wb, rels);
			if(rdata.length > 0) o[o.length] = (rdata);
		}
		if(o.length>sidx+1) { o[o.length] = ('</sheetData>'); o[sidx]=o[sidx].replace("/>",">"); }
	
		/* sheetCalcPr */
	
		if(ws['!protect']) o[o.length] = write_ws_xml_protection(ws['!protect']);
	
		/* protectedRanges */
		/* scenarios */
	
		if(ws['!autofilter'] != null) o[o.length] = write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
	
		/* sortState */
		/* dataConsolidate */
		/* customSheetViews */
	
		if(ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = (write_ws_xml_merges(ws['!merges']));
	
		/* phoneticPr */
		/* conditionalFormatting */
		/* dataValidations */
	
		var relc = -1, rel, rId = -1;
		if(ws['!links'].length > 0) {
			o[o.length] = "<hyperlinks>";
	ws['!links'].forEach(function(l) {
				if(!l[1].Target) return;
				rel = ({"ref":l[0]});
				if(l[1].Target.charAt(0) != "#") {
					rId = add_rels(rels, -1, escapexml(l[1].Target).replace(/#.*$/, ""), RELS.HLINK);
					rel["r:id"] = "rId"+rId;
				}
				if((relc = l[1].Target.indexOf("#")) > -1) rel.location = escapexml(l[1].Target.slice(relc+1));
				if(l[1].Tooltip) rel.tooltip = escapexml(l[1].Tooltip);
				o[o.length] = writextag("hyperlink",null,rel);
			});
			o[o.length] = "</hyperlinks>";
		}
		delete ws['!links'];
	
		/* printOptions */
	
		if(ws['!margins'] != null) o[o.length] =  write_ws_xml_margins(ws['!margins']);
	
		/* pageSetup */
		/* headerFooter */
		/* rowBreaks */
		/* colBreaks */
		/* customProperties */
		/* cellWatches */
	
		if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) o[o.length] = writetag("ignoredErrors", writextag("ignoredError", null, {numberStoredAsText:1, sqref:ref}));
	
		/* smartTags */
	
		if(_drawing.length > 0) {
			rId = add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
			o[o.length] = writextag("drawing", null, {"r:id":"rId" + rId});
			ws['!drawing'] = _drawing;
		}
	
		if(ws['!comments'].length > 0) {
			rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			o[o.length] = writextag("legacyDrawing", null, {"r:id":"rId" + rId});
			ws['!legacy'] = rId;
		}
	
		/* legacyDrawingHF */
		/* picture */
		/* oleObjects */
		/* controls */
		/* webPublishItems */
		/* tableParts */
		/* extLst */
	
		if(o.length>1) { o[o.length] = ('</worksheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.726 BrtRowHdr */
	function parse_BrtRowHdr(data, length) {
		var z = ({});
		var tgt = data.l + length;
		z.r = data.read_shift(4);
		data.l += 4; // TODO: ixfe
		var miyRw = data.read_shift(2);
		data.l += 1; // TODO: top/bot padding
		var flags = data.read_shift(1);
		data.l = tgt;
		if(flags & 0x07) z.level = flags & 0x07;
		if(flags & 0x10) z.hidden = true;
		if(flags & 0x20) z.hpt = miyRw / 20;
		return z;
	}
	function write_BrtRowHdr(R, range, ws) {
		var o = new_buf(17+8*16);
		var row = (ws['!rows']||[])[R]||{};
		o.write_shift(4, R);
	
		o.write_shift(4, 0); /* TODO: ixfe */
	
		var miyRw = 0x0140;
		if(row.hpx) miyRw = px2pt(row.hpx) * 20;
		else if(row.hpt) miyRw = row.hpt * 20;
		o.write_shift(2, miyRw);
	
		o.write_shift(1, 0); /* top/bot padding */
	
		var flags = 0x0;
		if(row.level) flags |= row.level;
		if(row.hidden) flags |= 0x10;
		if(row.hpx || row.hpt) flags |= 0x20;
		o.write_shift(1, flags);
	
		o.write_shift(1, 0); /* phonetic guide */
	
		/* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */
		var ncolspan = 0, lcs = o.l;
		o.l += 4;
	
		var caddr = {r:R, c:0};
		for(var i = 0; i < 16; ++i) {
			if((range.s.c > ((i+1) << 10)) || (range.e.c < (i << 10))) continue;
			var first = -1, last = -1;
			for(var j = (i<<10); j < ((i+1)<<10); ++j) {
				caddr.c = j;
				var cell = Array.isArray(ws) ? (ws[caddr.r]||[])[caddr.c] : ws[encode_cell(caddr)];
				if(cell) { if(first < 0) first = j; last = j; }
			}
			if(first < 0) continue;
			++ncolspan;
			o.write_shift(4, first);
			o.write_shift(4, last);
		}
	
		var l = o.l;
		o.l = lcs;
		o.write_shift(4, ncolspan);
		o.l = l;
	
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	function write_row_header(ba, ws, range, R) {
		var o = write_BrtRowHdr(R, range, ws);
		if((o.length > 17) || (ws['!rows']||[])[R]) write_record(ba, 'BrtRowHdr', o);
	}
	
	/* [MS-XLSB] 2.4.820 BrtWsDim */
	var parse_BrtWsDim = parse_UncheckedRfX;
	var write_BrtWsDim = write_UncheckedRfX;
	
	/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */
	function parse_BrtWsFmtInfo() {
	}
	//function write_BrtWsFmtInfo(ws, o) { }
	
	/* [MS-XLSB] 2.4.823 BrtWsProp */
	function parse_BrtWsProp(data, length) {
		var z = {};
		var f = data[data.l]; ++data.l;
		z.above = !(f & 0x40);
		z.left  = !(f & 0x80);
		/* TODO: pull flags */
		data.l += 18;
		z.name = parse_XLSBCodeName(data, length - 19);
		return z;
	}
	function write_BrtWsProp(str, outl, o) {
		if(o == null) o = new_buf(84+4*str.length);
		var f = 0xC0;
		if(outl) {
			if(outl.above) f &= ~0x40;
			if(outl.left)  f &= ~0x80;
		}
		o.write_shift(1, f);
		for(var i = 1; i < 3; ++i) o.write_shift(1,0);
		write_BrtColor({auto:1}, o);
		o.write_shift(-4,-1);
		o.write_shift(-4,-1);
		write_XLSBCodeName(str, o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.306 BrtCellBlank */
	function parse_BrtCellBlank(data) {
		var cell = parse_XLSBCell(data);
		return [cell];
	}
	function write_BrtCellBlank(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		return write_XLSBCell(ncell, o);
	}
	function parse_BrtShortBlank(data) {
		var cell = parse_XLSBShortCell(data);
		return [cell];
	}
	function write_BrtShortBlank(cell, ncell, o) {
		if(o == null) o = new_buf(4);
		return write_XLSBShortCell(ncell, o);
	}
	
	/* [MS-XLSB] 2.4.307 BrtCellBool */
	function parse_BrtCellBool(data) {
		var cell = parse_XLSBCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	function write_BrtCellBool(cell, ncell, o) {
		if(o == null) o = new_buf(9);
		write_XLSBCell(ncell, o);
		o.write_shift(1, cell.v ? 1 : 0);
		return o;
	}
	function parse_BrtShortBool(data) {
		var cell = parse_XLSBShortCell(data);
		var fBool = data.read_shift(1);
		return [cell, fBool, 'b'];
	}
	function write_BrtShortBool(cell, ncell, o) {
		if(o == null) o = new_buf(5);
		write_XLSBShortCell(ncell, o);
		o.write_shift(1, cell.v ? 1 : 0);
		return o;
	}
	
	/* [MS-XLSB] 2.4.308 BrtCellError */
	function parse_BrtCellError(data) {
		var cell = parse_XLSBCell(data);
		var bError = data.read_shift(1);
		return [cell, bError, 'e'];
	}
	function write_BrtCellError(cell, ncell, o) {
		if(o == null) o = new_buf(9);
		write_XLSBCell(ncell, o);
		o.write_shift(1, cell.v);
		return o;
	}
	function parse_BrtShortError(data) {
		var cell = parse_XLSBShortCell(data);
		var bError = data.read_shift(1);
		return [cell, bError, 'e'];
	}
	function write_BrtShortError(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		o.write_shift(1, cell.v);
		o.write_shift(2, 0);
		o.write_shift(1, 0);
		return o;
	}
	
	
	/* [MS-XLSB] 2.4.311 BrtCellIsst */
	function parse_BrtCellIsst(data) {
		var cell = parse_XLSBCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	function write_BrtCellIsst(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		o.write_shift(4, ncell.v);
		return o;
	}
	function parse_BrtShortIsst(data) {
		var cell = parse_XLSBShortCell(data);
		var isst = data.read_shift(4);
		return [cell, isst, 's'];
	}
	function write_BrtShortIsst(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		o.write_shift(4, ncell.v);
		return o;
	}
	
	/* [MS-XLSB] 2.4.313 BrtCellReal */
	function parse_BrtCellReal(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellReal(cell, ncell, o) {
		if(o == null) o = new_buf(16);
		write_XLSBCell(ncell, o);
		write_Xnum(cell.v, o);
		return o;
	}
	function parse_BrtShortReal(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_Xnum(data);
		return [cell, value, 'n'];
	}
	function write_BrtShortReal(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBShortCell(ncell, o);
		write_Xnum(cell.v, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.314 BrtCellRk */
	function parse_BrtCellRk(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	function write_BrtCellRk(cell, ncell, o) {
		if(o == null) o = new_buf(12);
		write_XLSBCell(ncell, o);
		write_RkNumber(cell.v, o);
		return o;
	}
	function parse_BrtShortRk(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_RkNumber(data);
		return [cell, value, 'n'];
	}
	function write_BrtShortRk(cell, ncell, o) {
		if(o == null) o = new_buf(8);
		write_XLSBShortCell(ncell, o);
		write_RkNumber(cell.v, o);
		return o;
	}
	
	
	/* [MS-XLSB] 2.4.317 BrtCellSt */
	function parse_BrtCellSt(data) {
		var cell = parse_XLSBCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	function write_BrtCellSt(cell, ncell, o) {
		if(o == null) o = new_buf(12 + 4 * cell.v.length);
		write_XLSBCell(ncell, o);
		write_XLWideString(cell.v, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	function parse_BrtShortSt(data) {
		var cell = parse_XLSBShortCell(data);
		var value = parse_XLWideString(data);
		return [cell, value, 'str'];
	}
	function write_BrtShortSt(cell, ncell, o) {
		if(o == null) o = new_buf(8 + 4 * cell.v.length);
		write_XLSBShortCell(ncell, o);
		write_XLWideString(cell.v, o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.653 BrtFmlaBool */
	function parse_BrtFmlaBool(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'b'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.654 BrtFmlaError */
	function parse_BrtFmlaError(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = data.read_shift(1);
		var o = [cell, value, 'e'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.655 BrtFmlaNum */
	function parse_BrtFmlaNum(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_Xnum(data);
		var o = [cell, value, 'n'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.656 BrtFmlaString */
	function parse_BrtFmlaString(data, length, opts) {
		var end = data.l + length;
		var cell = parse_XLSBCell(data);
		cell.r = opts['!row'];
		var value = parse_XLWideString(data);
		var o = [cell, value, 'str'];
		if(opts.cellFormula) {
			data.l += 2;
			var formula = parse_XLSBCellParsedFormula(data, end - data.l, opts);
			o[3] = stringify_formula(formula, null/*range*/, cell, opts.supbooks, opts);/* TODO */
		}
		else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.682 BrtMergeCell */
	var parse_BrtMergeCell = parse_UncheckedRfX;
	var write_BrtMergeCell = write_UncheckedRfX;
	/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */
	function write_BrtBeginMergeCells(cnt, o) {
		if(o == null) o = new_buf(4);
		o.write_shift(4, cnt);
		return o;
	}
	
	/* [MS-XLSB] 2.4.662 BrtHLink */
	function parse_BrtHLink(data, length) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var relId = parse_XLNullableWideString(data);
		var loc = parse_XLWideString(data);
		var tooltip = parse_XLWideString(data);
		var display = parse_XLWideString(data);
		data.l = end;
		var o = ({rfx:rfx, relId:relId, loc:loc, display:display});
		if(tooltip) o.Tooltip = tooltip;
		return o;
	}
	function write_BrtHLink(l, rId) {
		var o = new_buf(50+4*(l[1].Target.length + (l[1].Tooltip || "").length));
		write_UncheckedRfX({s:decode_cell(l[0]), e:decode_cell(l[0])}, o);
		write_RelID("rId" + rId, o);
		var locidx = l[1].Target.indexOf("#");
		var loc = locidx == -1 ? "" : l[1].Target.slice(locidx+1);
		write_XLWideString(loc || "", o);
		write_XLWideString(l[1].Tooltip || "", o);
		write_XLWideString("", o);
		return o.slice(0, o.l);
	}
	
	/* [MS-XLSB] 2.4.692 BrtPane */
	function parse_BrtPane(/*data, length, opts*/) {
	}
	
	/* [MS-XLSB] 2.4.6 BrtArrFmla */
	function parse_BrtArrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_RfX(data, 16);
		var fAlwaysCalc = data.read_shift(1);
		var o = [rfx]; o[2] = fAlwaysCalc;
		if(opts.cellFormula) {
			var formula = parse_XLSBArrayParsedFormula(data, end - data.l, opts);
			o[1] = formula;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.750 BrtShrFmla */
	function parse_BrtShrFmla(data, length, opts) {
		var end = data.l + length;
		var rfx = parse_UncheckedRfX(data, 16);
		var o = [rfx];
		if(opts.cellFormula) {
			var formula = parse_XLSBSharedParsedFormula(data, end - data.l, opts);
			o[1] = formula;
			data.l = end;
		} else data.l = end;
		return o;
	}
	
	/* [MS-XLSB] 2.4.323 BrtColInfo */
	/* TODO: once XLS ColInfo is set, combine the functions */
	function write_BrtColInfo(C, col, o) {
		if(o == null) o = new_buf(18);
		var p = col_obj_w(C, col);
		o.write_shift(-4, C);
		o.write_shift(-4, C);
		o.write_shift(4, (p.width || 10) * 256);
		o.write_shift(4, 0/*ixfe*/); // style
		var flags = 0;
		if(col.hidden) flags |= 0x01;
		if(typeof p.width == 'number') flags |= 0x02;
		if(col.level) flags |= (col.level << 8);
		o.write_shift(2, flags); // bit flag
		return o;
	}
	
	/* [MS-XLSB] 2.4.678 BrtMargins */
	var BrtMarginKeys = ["left","right","top","bottom","header","footer"];
	function parse_BrtMargins(data) {
		var margins = ({});
		BrtMarginKeys.forEach(function(k) { margins[k] = parse_Xnum(data, 8); });
		return margins;
	}
	function write_BrtMargins(margins, o) {
		if(o == null) o = new_buf(6*8);
		default_margins(margins);
		BrtMarginKeys.forEach(function(k) { write_Xnum((margins)[k], o); });
		return o;
	}
	
	/* [MS-XLSB] 2.4.299 BrtBeginWsView */
	function parse_BrtBeginWsView(data) {
		var f = data.read_shift(2);
		data.l += 28;
		return { RTL: f & 0x20 };
	}
	function write_BrtBeginWsView(ws, Workbook, o) {
		if(o == null) o = new_buf(30);
		var f = 0x39c;
		if((((Workbook||{}).Views||[])[0]||{}).RTL) f |= 0x20;
		o.write_shift(2, f); // bit flag
		o.write_shift(4, 0);
		o.write_shift(4, 0); // view first row
		o.write_shift(4, 0); // view first col
		o.write_shift(1, 0); // gridline color ICV
		o.write_shift(1, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 100); // zoom scale
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(2, 0);
		o.write_shift(4, 0); // workbook view id
		return o;
	}
	
	/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */
	function write_BrtCellIgnoreEC(ref) {
		var o = new_buf(24);
		o.write_shift(4, 4);
		o.write_shift(4, 1);
		write_UncheckedRfX(ref, o);
		return o;
	}
	
	/* [MS-XLSB] 2.4.748 BrtSheetProtection */
	function write_BrtSheetProtection(sp, o) {
		if(o == null) o = new_buf(16*4+2);
		o.write_shift(2, sp.password ? crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
		o.write_shift(4, 1); // this record should not be written if no protection
		[
			["objects",             false], // fObjects
			["scenarios",           false], // fScenarios
			["formatCells",          true], // fFormatCells
			["formatColumns",        true], // fFormatColumns
			["formatRows",           true], // fFormatRows
			["insertColumns",        true], // fInsertColumns
			["insertRows",           true], // fInsertRows
			["insertHyperlinks",     true], // fInsertHyperlinks
			["deleteColumns",        true], // fDeleteColumns
			["deleteRows",           true], // fDeleteRows
			["selectLockedCells",   false], // fSelLockedCells
			["sort",                 true], // fSort
			["autoFilter",           true], // fAutoFilter
			["pivotTables",          true], // fPivotTables
			["selectUnlockedCells", false]  // fSelUnlockedCells
		].forEach(function(n) {
	if(n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
			else      o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
		});
		return o;
	}
	
	function parse_BrtDVal(/*data, length, opts*/) {
	}
	function parse_BrtDVal14(/*data, length, opts*/) {
	}
	/* [MS-XLSB] 2.1.7.61 Worksheet */
	function parse_ws_bin(data, _opts, idx, rels, wb, themes, styles) {
		if(!data) return data;
		var opts = _opts || {};
		if(!rels) rels = {'!id':{}};
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var s = (opts.dense ? [] : {});
	
		var ref;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		var state = [];
		var pass = false, end = false;
		var row, p, cf, R, C, addr, sstr, rr, cell;
		var merges = [];
		opts.biff = 12;
		opts['!row'] = 0;
	
		var ai = 0, af = false;
	
		var arrayf = [];
		var sharedf = {};
		var supbooks = opts.supbooks || wb.supbooks || ([[]]);
		supbooks.sharedf = sharedf;
		supbooks.arrayf = arrayf;
		supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) { return x.name; });
		if(!opts.supbooks) {
			opts.supbooks = supbooks;
			if(wb.Names) for(var i = 0; i < wb.Names.length; ++i) supbooks[0][i+1] = wb.Names[i];
		}
	
		var colinfo = [], rowinfo = [];
		var seencol = false;
	
		XLSBRecordEnum[0x0010] = { n:"BrtShortReal", f:parse_BrtShortReal };
	
		recordhopper(data, function ws_parse(val, R_n, RT) {
			if(end) return;
			switch(RT) {
				case 0x0094: /* 'BrtWsDim' */
					ref = val; break;
				case 0x0000: /* 'BrtRowHdr' */
					row = val;
					if(opts.sheetRows && opts.sheetRows <= row.r) end=true;
					rr = encode_row(R = row.r);
					opts['!row'] = row.r;
					if(val.hidden || val.hpt || val.level != null) {
						if(val.hpt) val.hpx = pt2px(val.hpt);
						rowinfo[val.r] = val;
					}
					break;
	
				case 0x0002: /* 'BrtCellRk' */
				case 0x0003: /* 'BrtCellError' */
				case 0x0004: /* 'BrtCellBool' */
				case 0x0005: /* 'BrtCellReal' */
				case 0x0006: /* 'BrtCellSt' */
				case 0x0007: /* 'BrtCellIsst' */
				case 0x0008: /* 'BrtFmlaString' */
				case 0x0009: /* 'BrtFmlaNum' */
				case 0x000A: /* 'BrtFmlaBool' */
				case 0x000B: /* 'BrtFmlaError' */
				case 0x000D: /* 'BrtShortRk' */
				case 0x000E: /* 'BrtShortError' */
				case 0x000F: /* 'BrtShortBool' */
				case 0x0010: /* 'BrtShortReal' */
				case 0x0011: /* 'BrtShortSt' */
				case 0x0012: /* 'BrtShortIsst' */
					p = ({t:val[2]});
					switch(val[2]) {
						case 'n': p.v = val[1]; break;
						case 's': sstr = strs[val[1]]; p.v = sstr.t; p.r = sstr.r; break;
						case 'b': p.v = val[1] ? true : false; break;
						case 'e': p.v = val[1]; if(opts.cellText !== false) p.w = BErr[p.v]; break;
						case 'str': p.t = 's'; p.v = val[1]; break;
					}
					if((cf = styles.CellXf[val[0].iStyleRef])) safe_format(p,cf.numFmtId,null,opts, themes, styles);
					C = val[0].c == -1 ? C + 1 : val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(opts.cellFormula) {
						af = false;
						for(ai = 0; ai < arrayf.length; ++ai) {
							var aii = arrayf[ai];
							if(row.r >= aii[0].s.r && row.r <= aii[0].e.r)
								if(C >= aii[0].s.c && C <= aii[0].e.c) {
									p.F = encode_range(aii[0]); af = true;
								}
						}
						if(!af && val.length > 3) p.f = val[3];
					}
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					if(opts.cellDates && cf && p.t == 'n' && SSF.is_date(SSF._table[cf.numFmtId])) {
						var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
					}
					break;
	
				case 0x0001: /* 'BrtCellBlank' */
				case 0x000C: /* 'BrtShortBlank' */
					if(!opts.sheetStubs || pass) break;
					p = ({t:'z',v:undefined});
					C = val[0].c == -1 ? C + 1 : val[0].c;
					if(opts.dense) { if(!s[R]) s[R] = []; s[R][C] = p; }
					else s[encode_col(C) + rr] = p;
					if(refguess.s.r > row.r) refguess.s.r = row.r;
					if(refguess.s.c > C) refguess.s.c = C;
					if(refguess.e.r < row.r) refguess.e.r = row.r;
					if(refguess.e.c < C) refguess.e.c = C;
					break;
	
				case 0x00B0: /* 'BrtMergeCell' */
					merges.push(val); break;
	
				case 0x01EE: /* 'BrtHLink' */
					var rel = rels['!id'][val.relId];
					if(rel) {
						val.Target = rel.Target;
						if(val.loc) val.Target += "#"+val.loc;
						val.Rel = rel;
					} else if(val.relId == '') {
						val.Target = "#" + val.loc;
					}
					for(R=val.rfx.s.r;R<=val.rfx.e.r;++R) for(C=val.rfx.s.c;C<=val.rfx.e.c;++C) {
						if(opts.dense) {
							if(!s[R]) s[R] = [];
							if(!s[R][C]) s[R][C] = {t:'z',v:undefined};
							s[R][C].l = val;
						} else {
							addr = encode_cell({c:C,r:R});
							if(!s[addr]) s[addr] = {t:'z',v:undefined};
							s[addr].l = val;
						}
					}
					break;
	
				case 0x01AA: /* 'BrtArrFmla' */
					if(!opts.cellFormula) break;
					arrayf.push(val);
					cell = ((opts.dense ? s[R][C] : s[encode_col(C) + rr]));
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					cell.F = encode_range(val[0]);
					break;
				case 0x01AB: /* 'BrtShrFmla' */
					if(!opts.cellFormula) break;
					sharedf[encode_cell(val[0].s)] = val[1];
					cell = (opts.dense ? s[R][C] : s[encode_col(C) + rr]);
					cell.f = stringify_formula(val[1], refguess, {r:row.r, c:C}, supbooks, opts);
					break;
	
				/* identical to 'ColInfo' in XLS */
				case 0x003C: /* 'BrtColInfo' */
					if(!opts.cellStyles) break;
					while(val.e >= val.s) {
						colinfo[val.e--] = { width: val.w/256, hidden: !!(val.flags & 0x01), level: val.level };
						if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
						process_col(colinfo[val.e+1]);
					}
					break;
	
				case 0x00A1: /* 'BrtBeginAFilter' */
					s['!autofilter'] = { ref:encode_range(val) };
					break;
	
				case 0x01DC: /* 'BrtMargins' */
					s['!margins'] = val;
					break;
	
				case 0x0093: /* 'BrtWsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					if(val.above || val.left) s['!outline'] = { above: val.above, left: val.left };
					break;
	
				case 0x0089: /* 'BrtBeginWsView' */
					if(!wb.Views) wb.Views = [{}];
					if(!wb.Views[0]) wb.Views[0] = {};
					if(val.RTL) wb.Views[0].RTL = true;
					break;
	
				case 0x01E5: /* 'BrtWsFmtInfo' */
					break;
	
				case 0x0040: /* 'BrtDVal' */
				case 0x041D: /* 'BrtDVal14' */
					break;
	
				case 0x0097: /* 'BrtPane' */
					break;
				case 0x0098: /* 'BrtSel' */
				case 0x00AF: /* 'BrtAFilterDateGroupItem' */
				case 0x0284: /* 'BrtActiveX' */
				case 0x0271: /* 'BrtBigName' */
				case 0x0232: /* 'BrtBkHim' */
				case 0x018C: /* 'BrtBrk' */
				case 0x0458: /* 'BrtCFIcon' */
				case 0x047A: /* 'BrtCFRuleExt' */
				case 0x01D7: /* 'BrtCFVO' */
				case 0x041A: /* 'BrtCFVO14' */
				case 0x0289: /* 'BrtCellIgnoreEC' */
				case 0x0451: /* 'BrtCellIgnoreEC14' */
				case 0x0031: /* 'BrtCellMeta' */
				case 0x024D: /* 'BrtCellSmartTagProperty' */
				case 0x025F: /* 'BrtCellWatch' */
				case 0x0234: /* 'BrtColor' */
				case 0x041F: /* 'BrtColor14' */
				case 0x00A8: /* 'BrtColorFilter' */
				case 0x00AE: /* 'BrtCustomFilter' */
				case 0x049C: /* 'BrtCustomFilter14' */
				case 0x01F3: /* 'BrtDRef' */
				case 0x01FB: /* 'BrtDXF' */
				case 0x0226: /* 'BrtDrawing' */
				case 0x00AB: /* 'BrtDynamicFilter' */
				case 0x00A7: /* 'BrtFilter' */
				case 0x0499: /* 'BrtFilter14' */
				case 0x00A9: /* 'BrtIconFilter' */
				case 0x049D: /* 'BrtIconFilter14' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x0295: /* 'BrtListPart' */
				case 0x027F: /* 'BrtOleObject' */
				case 0x01DE: /* 'BrtPageSetup' */
				case 0x0219: /* 'BrtPhoneticInfo' */
				case 0x01DD: /* 'BrtPrintOptions' */
				case 0x0218: /* 'BrtRangeProtection' */
				case 0x044F: /* 'BrtRangeProtection14' */
				case 0x02A8: /* 'BrtRangeProtectionIso' */
				case 0x0450: /* 'BrtRangeProtectionIso14' */
				case 0x0400: /* 'BrtRwDescent' */
				case 0x0297: /* 'BrtSheetCalcProp' */
				case 0x0217: /* 'BrtSheetProtection' */
				case 0x02A6: /* 'BrtSheetProtectionIso' */
				case 0x01F8: /* 'BrtSlc' */
				case 0x0413: /* 'BrtSparkline' */
				case 0x01AC: /* 'BrtTable' */
				case 0x00AA: /* 'BrtTop10Filter' */
				case 0x0C00: /* 'BrtUid' */
				case 0x0032: /* 'BrtValueMeta' */
				case 0x0816: /* 'BrtWebExtension' */
				case 0x0415: /* 'BrtWsFmtInfoEx14' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(R_n); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		}, opts);
	
		delete opts.supbooks;
		delete opts['!row'];
	
		if(!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = encode_range(ref || refguess);
		if(opts.sheetRows && s["!ref"]) {
			var tmpref = safe_decode_range(s["!ref"]);
			if(opts.sheetRows <= +tmpref.e.r) {
				tmpref.e.r = opts.sheetRows - 1;
				if(tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
				if(tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
				if(tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
				if(tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
				s["!fullref"] = s["!ref"];
				s["!ref"] = encode_range(tmpref);
			}
		}
		if(merges.length > 0) s["!merges"] = merges;
		if(colinfo.length > 0) s["!cols"] = colinfo;
		if(rowinfo.length > 0) s["!rows"] = rowinfo;
		return s;
	}
	
	/* TODO: something useful -- this is a stub */
	function write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen) {
		if(cell.v === undefined) return false;
		var vv = "";
		switch(cell.t) {
			case 'b': vv = cell.v ? "1" : "0"; break;
			case 'd': // no BrtCellDate :(
				cell = dup(cell);
				cell.z = cell.z || SSF._table[14];
				cell.v = datenum(parseDate(cell.v)); cell.t = 'n';
				break;
			/* falls through */
			case 'n': case 'e': vv = ''+cell.v; break;
			default: vv = cell.v; break;
		}
		var o = ({r:R, c:C});
		/* TODO: cell style */
		o.s = get_cell_style(opts.cellXfs, cell, opts);
		if(cell.l) ws['!links'].push([encode_cell(o), cell.l]);
		if(cell.c) ws['!comments'].push([encode_cell(o), cell.c]);
		switch(cell.t) {
			case 's': case 'str':
				if(opts.bookSST) {
					vv = get_sst_id(opts.Strings, (cell.v), opts.revStrings);
					o.t = "s"; o.v = vv;
					if(last_seen) write_record(ba, "BrtShortIsst", write_BrtShortIsst(cell, o));
					else write_record(ba, "BrtCellIsst", write_BrtCellIsst(cell, o));
				} else {
					o.t = "str";
					if(last_seen) write_record(ba, "BrtShortSt", write_BrtShortSt(cell, o));
					else write_record(ba, "BrtCellSt", write_BrtCellSt(cell, o));
				}
				return true;
			case 'n':
				/* TODO: determine threshold for Real vs RK */
				if(cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
					if(last_seen) write_record(ba, "BrtShortRk", write_BrtShortRk(cell, o));
					else write_record(ba, "BrtCellRk", write_BrtCellRk(cell, o));
				} else {
					if(last_seen) write_record(ba, "BrtShortReal", write_BrtShortReal(cell, o));
					else write_record(ba, "BrtCellReal", write_BrtCellReal(cell, o));
				} return true;
			case 'b':
				o.t = "b";
				if(last_seen) write_record(ba, "BrtShortBool", write_BrtShortBool(cell, o));
				else write_record(ba, "BrtCellBool", write_BrtCellBool(cell, o));
				return true;
			case 'e':
				o.t = "e";
				if(last_seen) write_record(ba, "BrtShortError", write_BrtShortError(cell, o));
				else write_record(ba, "BrtCellError", write_BrtCellError(cell, o));
				return true;
		}
		if(last_seen) write_record(ba, "BrtShortBlank", write_BrtShortBlank(cell, o));
		else write_record(ba, "BrtCellBlank", write_BrtCellBlank(cell, o));
		return true;
	}
	
	function write_CELLTABLE(ba, ws, idx, opts) {
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		write_record(ba, 'BrtBeginSheetData');
		var dense = Array.isArray(ws);
		var cap = range.e.r;
		if(ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
		for(var R = range.s.r; R <= cap; ++R) {
			rr = encode_row(R);
			/* [ACCELLTABLE] */
			/* BrtRowHdr */
			write_row_header(ba, ws, range, R);
			var last_seen = false;
			if(R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C) {
				/* *16384CELL */
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) { last_seen = false; continue; }
				/* write cell */
				last_seen = write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen);
			}
		}
		write_record(ba, 'BrtEndSheetData');
	}
	
	function write_MERGECELLS(ba, ws) {
		if(!ws || !ws['!merges']) return;
		write_record(ba, 'BrtBeginMergeCells', write_BrtBeginMergeCells(ws['!merges'].length));
		ws['!merges'].forEach(function(m) { write_record(ba, 'BrtMergeCell', write_BrtMergeCell(m)); });
		write_record(ba, 'BrtEndMergeCells');
	}
	
	function write_COLINFOS(ba, ws) {
		if(!ws || !ws['!cols']) return;
		write_record(ba, 'BrtBeginColInfos');
		ws['!cols'].forEach(function(m, i) { if(m) write_record(ba, 'BrtColInfo', write_BrtColInfo(i, m)); });
		write_record(ba, 'BrtEndColInfos');
	}
	
	function write_IGNOREECS(ba, ws) {
		if(!ws || !ws['!ref']) return;
		write_record(ba, 'BrtBeginCellIgnoreECs');
		write_record(ba, 'BrtCellIgnoreEC', write_BrtCellIgnoreEC(safe_decode_range(ws['!ref'])));
		write_record(ba, 'BrtEndCellIgnoreECs');
	}
	
	function write_HLINKS(ba, ws, rels) {
		/* *BrtHLink */
		ws['!links'].forEach(function(l) {
			if(!l[1].Target) return;
			var rId = add_rels(rels, -1, l[1].Target.replace(/#.*$/, ""), RELS.HLINK);
			write_record(ba, "BrtHLink", write_BrtHLink(l, rId));
		});
		delete ws['!links'];
	}
	function write_LEGACYDRAWING(ba, ws, idx, rels) {
		/* [BrtLegacyDrawing] */
		if(ws['!comments'].length > 0) {
			var rId = add_rels(rels, -1, "../drawings/vmlDrawing" + (idx+1) + ".vml", RELS.VML);
			write_record(ba, "BrtLegacyDrawing", write_RelID("rId" + rId));
			ws['!legacy'] = rId;
		}
	}
	
	function write_AUTOFILTER(ba, ws, wb, idx) {
		if(!ws['!autofilter']) return;
		var data = ws['!autofilter'];
		var ref = typeof data.ref === "string" ? data.ref : encode_range(data.ref);
	
		/* Update FilterDatabase defined name for the worksheet */
		if(!wb.Workbook) wb.Workbook = ({Sheets:[]});
		if(!wb.Workbook.Names) wb.Workbook.Names = [];
		var names = wb.Workbook.Names;
		var range = decode_range(ref);
		if(range.s.r == range.e.r) { range.e.r = decode_range(ws["!ref"]).e.r; ref = encode_range(range); }
		for(var i = 0; i < names.length; ++i) {
			var name = names[i];
			if(name.Name != '_xlnm._FilterDatabase') continue;
			if(name.Sheet != idx) continue;
			name.Ref = "'" + wb.SheetNames[idx] + "'!" + ref; break;
		}
		if(i == names.length) names.push({ Name: '_xlnm._FilterDatabase', Sheet: idx, Ref: "'" + wb.SheetNames[idx] + "'!" + ref  });
	
		write_record(ba, "BrtBeginAFilter", write_UncheckedRfX(safe_decode_range(ref)));
		/* *FILTERCOLUMN */
		/* [SORTSTATE] */
		/* BrtEndAFilter */
		write_record(ba, "BrtEndAFilter");
	}
	
	function write_WSVIEWS2(ba, ws, Workbook) {
		write_record(ba, "BrtBeginWsViews");
		{ /* 1*WSVIEW2 */
			/* [ACUID] */
			write_record(ba, "BrtBeginWsView", write_BrtBeginWsView(ws, Workbook));
			/* [BrtPane] */
			/* *4BrtSel */
			/* *4SXSELECT */
			/* *FRT */
			write_record(ba, "BrtEndWsView");
		}
		/* *FRT */
		write_record(ba, "BrtEndWsViews");
	}
	
	function write_WSFMTINFO() {
		/* [ACWSFMTINFO] */
		//write_record(ba, "BrtWsFmtInfo", write_BrtWsFmtInfo(ws));
	}
	
	function write_SHEETPROTECT(ba, ws) {
		if(!ws['!protect']) return;
		/* [BrtSheetProtectionIso] */
		write_record(ba, "BrtSheetProtection", write_BrtSheetProtection(ws['!protect']));
	}
	
	function write_ws_bin(idx, opts, wb, rels) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var c = s; try { if(wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c; } catch(e) {}
		var r = safe_decode_range(ws['!ref'] || "A1");
		if(r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
			r.e.c = Math.min(r.e.c, 0x3FFF);
			r.e.r = Math.min(r.e.c, 0xFFFFF);
		}
		ws['!links'] = [];
		/* passed back to write_zip and removed there */
		ws['!comments'] = [];
		write_record(ba, "BrtBeginSheet");
		if(wb.vbaraw || ws['!outline']) write_record(ba, "BrtWsProp", write_BrtWsProp(c, ws['!outline']));
		write_record(ba, "BrtWsDim", write_BrtWsDim(r));
		write_WSVIEWS2(ba, ws, wb.Workbook);
		write_WSFMTINFO(ba, ws);
		write_COLINFOS(ba, ws, idx, opts, wb);
		write_CELLTABLE(ba, ws, idx, opts, wb);
		/* [BrtSheetCalcProp] */
		write_SHEETPROTECT(ba, ws);
		/* *([BrtRangeProtectionIso] BrtRangeProtection) */
		/* [SCENMAN] */
		write_AUTOFILTER(ba, ws, wb, idx);
		/* [SORTSTATE] */
		/* [DCON] */
		/* [USERSHVIEWS] */
		write_MERGECELLS(ba, ws);
		/* [BrtPhoneticInfo] */
		/* *CONDITIONALFORMATTING */
		/* [DVALS] */
		write_HLINKS(ba, ws, rels);
		/* [BrtPrintOptions] */
		if(ws['!margins']) write_record(ba, "BrtMargins", write_BrtMargins(ws['!margins']));
		/* [BrtPageSetup] */
		/* [HEADERFOOTER] */
		/* [RWBRK] */
		/* [COLBRK] */
		/* *BrtBigName */
		/* [CELLWATCHES] */
		if(!opts || opts.ignoreEC || (opts.ignoreEC == (void 0))) write_IGNOREECS(ba, ws);
		/* [SMARTTAGS] */
		/* [BrtDrawing] */
		write_LEGACYDRAWING(ba, ws, idx, rels);
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [OLEOBJECTS] */
		/* [ACTIVEXCONTROLS] */
		/* [WEBPUBITEMS] */
		/* [LISTPARTS] */
		/* FRTWORKSHEET */
		write_record(ba, "BrtEndSheet");
		return ba.end();
	}
	RELS.CHART = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart";
	RELS.CHARTEX = "http://schemas.microsoft.com/office/2014/relationships/chartEx";
	
	function parse_Cache(data) {
		var col = [];
		var num = data.match(/^<c:numCache>/);
		var f;
	
		/* 21.2.2.150 pt CT_NumVal */
		(data.match(/<c:pt idx="(\d*)">(.*?)<\/c:pt>/mg)||[]).forEach(function(pt) {
			var q = pt.match(/<c:pt idx="(\d*?)"><c:v>(.*)<\/c:v><\/c:pt>/);
			if(!q) return;
			col[+q[1]] = num ? +q[2] : q[2];
		});
	
		/* 21.2.2.71 formatCode CT_Xstring */
		var nf = unescapexml((data.match(/<c:formatCode>([\s\S]*?)<\/c:formatCode>/) || ["","General"])[1]);
	
		(data.match(/<c:f>(.*?)<\/c:f>/mg)||[]).forEach(function(F) { f = F.replace(/<.*?>/g,""); });
	
		return [col, nf, f];
	}
	
	/* 21.2 DrawingML - Charts */
	function parse_chart(data, name, opts, rels, wb, csheet) {
		var cs = ((csheet || {"!type":"chart"}));
		if(!data) return csheet;
		/* 21.2.2.27 chart CT_Chart */
	
		var C = 0, R = 0, col = "A";
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
	
		/* 21.2.2.120 numCache CT_NumData */
		(data.match(/<c:numCache>[\s\S]*?<\/c:numCache>/gm)||[]).forEach(function(nc) {
			var cache = parse_Cache(nc);
			refguess.s.r = refguess.s.c = 0;
			refguess.e.c = C;
			col = encode_col(C);
			cache[0].forEach(function(n,i) {
				cs[col + encode_row(i)] = {t:'n', v:n, z:cache[1] };
				R = i;
			});
			if(refguess.e.r < R) refguess.e.r = R;
			++C;
		});
		if(C > 0) cs["!ref"] = encode_range(refguess);
		return cs;
	}
	RELS.CS = "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet";
	
	var CS_XML_ROOT = writextag('chartsheet', null, {
		'xmlns': XMLNS.main[0],
		'xmlns:r': XMLNS.r
	});
	
	/* 18.3 Worksheets also covers Chartsheets */
	function parse_cs_xml(data, opts, idx, rels, wb) {
		if(!data) return data;
		/* 18.3.1.12 chartsheet CT_ChartSheet */
		if(!rels) rels = {'!id':{}};
		var s = ({'!type':"chart", '!drawel':null, '!rel':""});
		var m;
	
		/* 18.3.1.83 sheetPr CT_ChartsheetPr */
		var sheetPr = data.match(sheetprregex);
		if(sheetPr) parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
	
		/* 18.3.1.36 drawing CT_Drawing */
		if((m = data.match(/drawing r:id="(.*?)"/))) s['!rel'] = m[1];
	
		if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_xml(idx, opts, wb, rels) {
		var o = [XML_HEADER, CS_XML_ROOT];
		o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
		add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
		if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	
	/* [MS-XLSB] 2.4.331 BrtCsProp */
	function parse_BrtCsProp(data, length) {
		data.l += 10;
		var name = parse_XLWideString(data, length - 10);
		return { name: name };
	}
	
	/* [MS-XLSB] 2.1.7.7 Chart Sheet */
	function parse_cs_bin(data, opts, idx, rels, wb) {
		if(!data) return data;
		if(!rels) rels = {'!id':{}};
		var s = {'!type':"chart", '!drawel':null, '!rel':""};
		var state = [];
		var pass = false;
		recordhopper(data, function cs_parse(val, R_n, RT) {
			switch(RT) {
	
				case 0x0226: /* 'BrtDrawing' */
					s['!rel'] = val; break;
	
				case 0x028B: /* 'BrtCsProp' */
					if(!wb.Sheets[idx]) wb.Sheets[idx] = {};
					if(val.name) wb.Sheets[idx].CodeName = val.name;
					break;
	
				case 0x0232: /* 'BrtBkHim' */
				case 0x028C: /* 'BrtCsPageSetup' */
				case 0x029D: /* 'BrtCsProtection' */
				case 0x02A7: /* 'BrtCsProtectionIso' */
				case 0x0227: /* 'BrtLegacyDrawing' */
				case 0x0228: /* 'BrtLegacyDrawingHF' */
				case 0x01DC: /* 'BrtMargins' */
				case 0x0C00: /* 'BrtUid' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(R_n); break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0) state.push(R_n);
					else if((R_n||"").indexOf("End") > 0) state.pop();
					else if(!pass || opts.WTF) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		}, opts);
	
		if(rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
		return s;
	}
	function write_cs_bin() {
		var ba = buf_array();
		write_record(ba, "BrtBeginSheet");
		/* [BrtCsProp] */
		/* CSVIEWS */
		/* [[BrtCsProtectionIso] BrtCsProtection] */
		/* [USERCSVIEWS] */
		/* [BrtMargins] */
		/* [BrtCsPageSetup] */
		/* [HEADERFOOTER] */
		/* BrtDrawing */
		/* [BrtLegacyDrawing] */
		/* [BrtLegacyDrawingHF] */
		/* [BrtBkHim] */
		/* [WEBPUBITEMS] */
		/* FRTCHARTSHEET */
		write_record(ba, "BrtEndSheet");
		return ba.end();
	}
	/* 18.2.28 (CT_WorkbookProtection) Defaults */
	var WBPropsDef = [
		['allowRefreshQuery',           false, "bool"],
		['autoCompressPictures',        true,  "bool"],
		['backupFile',                  false, "bool"],
		['checkCompatibility',          false, "bool"],
		['CodeName',                    ''],
		['date1904',                    false, "bool"],
		['defaultThemeVersion',         0,      "int"],
		['filterPrivacy',               false, "bool"],
		['hidePivotFieldList',          false, "bool"],
		['promptedSolutions',           false, "bool"],
		['publishItems',                false, "bool"],
		['refreshAllConnections',       false, "bool"],
		['saveExternalLinkValues',      true,  "bool"],
		['showBorderUnselectedTables',  true,  "bool"],
		['showInkAnnotation',           true,  "bool"],
		['showObjects',                 'all'],
		['showPivotChartFilter',        false, "bool"],
		['updateLinks', 'userSet']
	];
	
	/* 18.2.30 (CT_BookView) Defaults */
	var WBViewDef = [
		['activeTab',                   0,      "int"],
		['autoFilterDateGrouping',      true,  "bool"],
		['firstSheet',                  0,      "int"],
		['minimized',                   false, "bool"],
		['showHorizontalScroll',        true,  "bool"],
		['showSheetTabs',               true,  "bool"],
		['showVerticalScroll',          true,  "bool"],
		['tabRatio',                    600,    "int"],
		['visibility',                  'visible']
		//window{Height,Width}, {x,y}Window
	];
	
	/* 18.2.19 (CT_Sheet) Defaults */
	var SheetDef = [
		//['state', 'visible']
	];
	
	/* 18.2.2  (CT_CalcPr) Defaults */
	var CalcPrDef = [
		['calcCompleted', 'true'],
		['calcMode', 'auto'],
		['calcOnSave', 'true'],
		['concurrentCalc', 'true'],
		['fullCalcOnLoad', 'false'],
		['fullPrecision', 'true'],
		['iterate', 'false'],
		['iterateCount', '100'],
		['iterateDelta', '0.001'],
		['refMode', 'A1']
	];
	
	/* 18.2.3 (CT_CustomWorkbookView) Defaults */
	/*var CustomWBViewDef = [
		['autoUpdate', 'false'],
		['changesSavedWin', 'false'],
		['includeHiddenRowCol', 'true'],
		['includePrintSettings', 'true'],
		['maximized', 'false'],
		['minimized', 'false'],
		['onlySync', 'false'],
		['personalView', 'false'],
		['showComments', 'commIndicator'],
		['showFormulaBar', 'true'],
		['showHorizontalScroll', 'true'],
		['showObjects', 'all'],
		['showSheetTabs', 'true'],
		['showStatusbar', 'true'],
		['showVerticalScroll', 'true'],
		['tabRatio', '600'],
		['xWindow', '0'],
		['yWindow', '0']
	];*/
	
	function push_defaults_array(target, defaults) {
		for(var j = 0; j != target.length; ++j) { var w = target[j];
			for(var i=0; i != defaults.length; ++i) { var z = defaults[i];
				if(w[z[0]] == null) w[z[0]] = z[1];
				else switch(z[2]) {
				case "bool": if(typeof w[z[0]] == "string") w[z[0]] = parsexmlbool(w[z[0]]); break;
				case "int": if(typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10); break;
				}
			}
		}
	}
	function push_defaults(target, defaults) {
		for(var i = 0; i != defaults.length; ++i) { var z = defaults[i];
			if(target[z[0]] == null) target[z[0]] = z[1];
			else switch(z[2]) {
				case "bool": if(typeof target[z[0]] == "string") target[z[0]] = parsexmlbool(target[z[0]]); break;
				case "int": if(typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10); break;
			}
		}
	}
	
	function parse_wb_defaults(wb) {
		push_defaults(wb.WBProps, WBPropsDef);
		push_defaults(wb.CalcPr, CalcPrDef);
	
		push_defaults_array(wb.WBView, WBViewDef);
		push_defaults_array(wb.Sheets, SheetDef);
	
		_ssfopts.date1904 = parsexmlbool(wb.WBProps.date1904);
	}
	
	function safe1904(wb) {
		/* TODO: store date1904 somewhere else */
		if(!wb.Workbook) return "false";
		if(!wb.Workbook.WBProps) return "false";
		return parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
	}
	
	var badchars = "][*?\/\\".split("");
	function check_ws_name(n, safe) {
		if(n.length > 31) { if(safe) return false; throw new Error("Sheet names cannot exceed 31 chars"); }
		var _good = true;
		badchars.forEach(function(c) {
			if(n.indexOf(c) == -1) return;
			if(!safe) throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
			_good = false;
		});
		return _good;
	}
	function check_wb_names(N, S, codes) {
		N.forEach(function(n,i) {
			check_ws_name(n);
			for(var j = 0; j < i; ++j) if(n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
			if(codes) {
				var cn = (S && S[i] && S[i].CodeName) || n;
				if(cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
			}
		});
	}
	function check_wb(wb) {
		if(!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
		if(!wb.SheetNames.length) throw new Error("Workbook is empty");
		var Sheets = (wb.Workbook && wb.Workbook.Sheets) || [];
		check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
		for(var i = 0; i < wb.SheetNames.length; ++i) check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
		/* TODO: validate workbook */
	}
	/* 18.2 Workbook */
	var wbnsregex = /<\w+:workbook/;
	function parse_wb_xml(data, opts) {
		if(!data) throw new Error("Could not find file");
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, Names:[], xmlns: "" };
		var pass = false, xmlns = "xmlns";
		var dname = {}, dnstart = 0;
		data.replace(tagregex, function xml_wb(x, idx) {
			var y = parsexmltag(x);
			switch(strip_ns(y[0])) {
				case '<?xml': break;
	
				/* 18.2.27 workbook CT_Workbook 1 */
				case '<workbook':
					if(x.match(wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
					wb.xmlns = y[xmlns];
					break;
				case '</workbook>': break;
	
				/* 18.2.13 fileVersion CT_FileVersion ? */
				case '<fileVersion': delete y[0]; wb.AppVersion = y; break;
				case '<fileVersion/>': case '</fileVersion>': break;
	
				/* 18.2.12 fileSharing CT_FileSharing ? */
				case '<fileSharing':
					break;
				case '<fileSharing/>': break;
	
				/* 18.2.28 workbookPr CT_WorkbookPr ? */
				case '<workbookPr':
				case '<workbookPr/>':
					WBPropsDef.forEach(function(w) {
						if(y[w[0]] == null) return;
						switch(w[2]) {
							case "bool": wb.WBProps[w[0]] = parsexmlbool(y[w[0]]); break;
							case "int": wb.WBProps[w[0]] = parseInt(y[w[0]], 10); break;
							default: wb.WBProps[w[0]] = y[w[0]];
						}
					});
					if(y.codeName) wb.WBProps.CodeName = utf8read(y.codeName);
					break;
				case '</workbookPr>': break;
	
				/* 18.2.29 workbookProtection CT_WorkbookProtection ? */
				case '<workbookProtection':
					break;
				case '<workbookProtection/>': break;
	
				/* 18.2.1  bookViews CT_BookViews ? */
				case '<bookViews': case '<bookViews>': case '</bookViews>': break;
				/* 18.2.30   workbookView CT_BookView + */
				case '<workbookView': case '<workbookView/>': delete y[0]; wb.WBView.push(y); break;
				case '</workbookView>': break;
	
				/* 18.2.20 sheets CT_Sheets 1 */
				case '<sheets': case '<sheets>': case '</sheets>': break; // aggregate sheet
				/* 18.2.19   sheet CT_Sheet + */
				case '<sheet':
					switch(y.state) {
						case "hidden": y.Hidden = 1; break;
						case "veryHidden": y.Hidden = 2; break;
						default: y.Hidden = 0;
					}
					delete y.state;
					y.name = unescapexml(utf8read(y.name));
					delete y[0]; wb.Sheets.push(y); break;
				case '</sheet>': break;
	
				/* 18.2.15 functionGroups CT_FunctionGroups ? */
				case '<functionGroups': case '<functionGroups/>': break;
				/* 18.2.14   functionGroup CT_FunctionGroup + */
				case '<functionGroup': break;
	
				/* 18.2.9  externalReferences CT_ExternalReferences ? */
				case '<externalReferences': case '</externalReferences>': case '<externalReferences>': break;
				/* 18.2.8    externalReference CT_ExternalReference + */
				case '<externalReference': break;
	
				/* 18.2.6  definedNames CT_DefinedNames ? */
				case '<definedNames/>': break;
				case '<definedNames>': case '<definedNames': pass=true; break;
				case '</definedNames>': pass=false; break;
				/* 18.2.5    definedName CT_DefinedName + */
				case '<definedName': {
					dname = {};
					dname.Name = utf8read(y.name);
					if(y.comment) dname.Comment = y.comment;
					if(y.localSheetId) dname.Sheet = +y.localSheetId;
					if(parsexmlbool(y.hidden||"0")) dname.Hidden = true;
					dnstart = idx + x.length;
				}	break;
				case '</definedName>': {
					dname.Ref = unescapexml(utf8read(data.slice(dnstart, idx)));
					wb.Names.push(dname);
				} break;
				case '<definedName/>': break;
	
				/* 18.2.2  calcPr CT_CalcPr ? */
				case '<calcPr': delete y[0]; wb.CalcPr = y; break;
				case '<calcPr/>': delete y[0]; wb.CalcPr = y; break;
				case '</calcPr>': break;
	
				/* 18.2.16 oleSize CT_OleSize ? (ref required) */
				case '<oleSize': break;
	
				/* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */
				case '<customWorkbookViews>': case '</customWorkbookViews>': case '<customWorkbookViews': break;
				/* 18.2.3  customWorkbookView CT_CustomWorkbookView + */
				case '<customWorkbookView': case '</customWorkbookView>': break;
	
				/* 18.2.18 pivotCaches CT_PivotCaches ? */
				case '<pivotCaches>': case '</pivotCaches>': case '<pivotCaches': break;
				/* 18.2.17 pivotCache CT_PivotCache ? */
				case '<pivotCache': break;
	
				/* 18.2.21 smartTagPr CT_SmartTagPr ? */
				case '<smartTagPr': case '<smartTagPr/>': break;
	
				/* 18.2.23 smartTagTypes CT_SmartTagTypes ? */
				case '<smartTagTypes': case '<smartTagTypes>': case '</smartTagTypes>': break;
				/* 18.2.22 smartTagType CT_SmartTagType ? */
				case '<smartTagType': break;
	
				/* 18.2.24 webPublishing CT_WebPublishing ? */
				case '<webPublishing': case '<webPublishing/>': break;
	
				/* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */
				case '<fileRecoveryPr': case '<fileRecoveryPr/>': break;
	
				/* 18.2.26 webPublishObjects CT_WebPublishObjects ? */
				case '<webPublishObjects>': case '<webPublishObjects': case '</webPublishObjects>': break;
				/* 18.2.25 webPublishObject CT_WebPublishObject ? */
				case '<webPublishObject': break;
	
				/* 18.2.10 extLst CT_ExtensionList ? */
				case '<extLst': case '<extLst>': case '</extLst>': case '<extLst/>': break;
				/* 18.2.7  ext CT_Extension + */
				case '<ext': pass=true; break; //TODO: check with versions of excel
				case '</ext>': pass=false; break;
	
				/* Others */
				case '<ArchID': break;
				case '<AlternateContent':
				case '<AlternateContent>': pass=true; break;
				case '</AlternateContent>': pass=false; break;
	
				/* TODO */
				case '<revisionPtr': break;
	
				default: if(!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
			}
			return x;
		});
		if(XMLNS.main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
	
		parse_wb_defaults(wb);
	
		return wb;
	}
	
	var WB_XML_ROOT = writextag('workbook', null, {
		'xmlns': XMLNS.main[0],
		//'xmlns:mx': XMLNS.mx,
		//'xmlns:s': XMLNS.main[0],
		'xmlns:r': XMLNS.r
	});
	
	function write_wb_xml(wb) {
		var o = [XML_HEADER];
		o[o.length] = WB_XML_ROOT;
	
		var write_names = (wb.Workbook && (wb.Workbook.Names||[]).length > 0);
	
		/* fileVersion */
		/* fileSharing */
	
		var workbookPr = ({codeName:"ThisWorkbook"});
		if(wb.Workbook && wb.Workbook.WBProps) {
			WBPropsDef.forEach(function(x) {
	if((wb.Workbook.WBProps[x[0]]) == null) return;
				if((wb.Workbook.WBProps[x[0]]) == x[1]) return;
				workbookPr[x[0]] = (wb.Workbook.WBProps[x[0]]);
			});
	if(wb.Workbook.WBProps.CodeName) { workbookPr.codeName = wb.Workbook.WBProps.CodeName; delete workbookPr.CodeName; }
		}
		o[o.length] = (writextag('workbookPr', null, workbookPr));
	
		/* workbookProtection */
	
		var sheets = wb.Workbook && wb.Workbook.Sheets || [];
		var i = 0;
	
		/* bookViews only written if first worksheet is hidden */
		if(sheets && sheets[0] && !!sheets[0].Hidden) {
			o[o.length] = "<bookViews>";
			for(i = 0; i != wb.SheetNames.length; ++i) {
				if(!sheets[i]) break;
				if(!sheets[i].Hidden) break;
			}
			if(i == wb.SheetNames.length) i = 0;
			o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
			o[o.length] = "</bookViews>";
		}
	
		o[o.length] = "<sheets>";
		for(i = 0; i != wb.SheetNames.length; ++i) {
			var sht = ({name:escapexml(wb.SheetNames[i].slice(0,31))});
			sht.sheetId = ""+(i+1);
			sht["r:id"] = "rId"+(i+1);
			if(sheets[i]) switch(sheets[i].Hidden) {
				case 1: sht.state = "hidden"; break;
				case 2: sht.state = "veryHidden"; break;
			}
			o[o.length] = (writextag('sheet',null,sht));
		}
		o[o.length] = "</sheets>";
	
		/* functionGroups */
		/* externalReferences */
	
		if(write_names) {
			o[o.length] = "<definedNames>";
			if(wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
				var d = {name:n.Name};
				if(n.Comment) d.comment = n.Comment;
				if(n.Sheet != null) d.localSheetId = ""+n.Sheet;
				if(n.Hidden) d.hidden = "1";
				if(!n.Ref) return;
				o[o.length] = writextag('definedName', escapexml(n.Ref), d);
			});
			o[o.length] = "</definedNames>";
		}
	
		/* calcPr */
		/* oleSize */
		/* customWorkbookViews */
		/* pivotCaches */
		/* smartTagPr */
		/* smartTagTypes */
		/* webPublishing */
		/* fileRecoveryPr */
		/* webPublishObjects */
		/* extLst */
	
		if(o.length>2){ o[o.length] = '</workbook>'; o[1]=o[1].replace("/>",">"); }
		return o.join("");
	}
	/* [MS-XLSB] 2.4.304 BrtBundleSh */
	function parse_BrtBundleSh(data, length) {
		var z = {};
		z.Hidden = data.read_shift(4); //hsState ST_SheetState
		z.iTabID = data.read_shift(4);
		z.strRelID = parse_RelID(data,length-8);
		z.name = parse_XLWideString(data);
		return z;
	}
	function write_BrtBundleSh(data, o) {
		if(!o) o = new_buf(127);
		o.write_shift(4, data.Hidden);
		o.write_shift(4, data.iTabID);
		write_RelID(data.strRelID, o);
		write_XLWideString(data.name.slice(0,31), o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.815 BrtWbProp */
	function parse_BrtWbProp(data, length) {
		var o = ({});
		var flags = data.read_shift(4);
		o.defaultThemeVersion = data.read_shift(4);
		var strName = (length > 8) ? parse_XLWideString(data) : "";
		if(strName.length > 0) o.CodeName = strName;
		o.autoCompressPictures = !!(flags & 0x10000);
		o.backupFile = !!(flags & 0x40);
		o.checkCompatibility = !!(flags & 0x1000);
		o.date1904 = !!(flags & 0x01);
		o.filterPrivacy = !!(flags & 0x08);
		o.hidePivotFieldList = !!(flags & 0x400);
		o.promptedSolutions = !!(flags & 0x10);
		o.publishItems = !!(flags & 0x800);
		o.refreshAllConnections = !!(flags & 0x40000);
		o.saveExternalLinkValues = !!(flags & 0x80);
		o.showBorderUnselectedTables = !!(flags & 0x04);
		o.showInkAnnotation = !!(flags & 0x20);
		o.showObjects = ["all", "placeholders", "none"][(flags >> 13) & 0x03];
		o.showPivotChartFilter = !!(flags & 0x8000);
		o.updateLinks = ["userSet", "never", "always"][(flags >> 8) & 0x03];
		return o;
	}
	function write_BrtWbProp(data, o) {
		if(!o) o = new_buf(72);
		var flags = 0;
		if(data) {
			/* TODO: mirror parse_BrtWbProp fields */
			if(data.filterPrivacy) flags |= 0x08;
		}
		o.write_shift(4, flags);
		o.write_shift(4, 0);
		write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
		return o.slice(0, o.l);
	}
	
	function parse_BrtFRTArchID$(data, length) {
		var o = {};
		data.read_shift(4);
		o.ArchID = data.read_shift(4);
		data.l += length - 8;
		return o;
	}
	
	/* [MS-XLSB] 2.4.687 BrtName */
	function parse_BrtName(data, length, opts) {
		var end = data.l + length;
		data.l += 4; //var flags = data.read_shift(4);
		data.l += 1; //var chKey = data.read_shift(1);
		var itab = data.read_shift(4);
		var name = parse_XLNameWideString(data);
		var formula = parse_XLSBNameParsedFormula(data, 0, opts);
		var comment = parse_XLNullableWideString(data);
		//if(0 /* fProc */) {
			// unusedstring1: XLNullableWideString
			// description: XLNullableWideString
			// helpTopic: XLNullableWideString
			// unusedstring2: XLNullableWideString
		//}
		data.l = end;
		var out = ({Name:name, Ptg:formula});
		if(itab < 0xFFFFFFF) out.Sheet = itab;
		if(comment) out.Comment = comment;
		return out;
	}
	
	/* [MS-XLSB] 2.1.7.61 Workbook */
	function parse_wb_bin(data, opts) {
		var wb = { AppVersion:{}, WBProps:{}, WBView:[], Sheets:[], CalcPr:{}, xmlns: "" };
		var state = [];
		var pass = false;
	
		if(!opts) opts = {};
		opts.biff = 12;
	
		var Names = [];
		var supbooks = ([[]]);
		supbooks.SheetNames = [];
		supbooks.XTI = [];
	
		XLSBRecordEnum[0x0010] = { n:"BrtFRTArchID$", f:parse_BrtFRTArchID$ };
	
		recordhopper(data, function hopper_wb(val, R_n, RT) {
			switch(RT) {
				case 0x009C: /* 'BrtBundleSh' */
					supbooks.SheetNames.push(val.name);
					wb.Sheets.push(val); break;
	
				case 0x0099: /* 'BrtWbProp' */
					wb.WBProps = val; break;
	
				case 0x0027: /* 'BrtName' */
					if(val.Sheet != null) opts.SID = val.Sheet;
					val.Ref = stringify_formula(val.Ptg, null, null, supbooks, opts);
					delete opts.SID;
					delete val.Ptg;
					Names.push(val);
					break;
				case 0x040C: /* 'BrtNameExt' */ break;
	
				case 0x0165: /* 'BrtSupSelf' */
				case 0x0166: /* 'BrtSupSame' */
				case 0x0163: /* 'BrtSupBookSrc' */
				case 0x029B: /* 'BrtSupAddin' */
					if(!supbooks[0].length) supbooks[0] = [RT, val];
					else supbooks.push([RT, val]);
					supbooks[supbooks.length - 1].XTI = [];
					break;
				case 0x016A: /* 'BrtExternSheet' */
					if(supbooks.length === 0) { supbooks[0] = []; supbooks[0].XTI = []; }
					supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val);
					supbooks.XTI = supbooks.XTI.concat(val);
					break;
				case 0x0169: /* 'BrtPlaceholderName' */
					break;
	
				case 0x0817: /* 'BrtAbsPath15' */
				case 0x009E: /* 'BrtBookView' */
				case 0x008F: /* 'BrtBeginBundleShs' */
				case 0x0298: /* 'BrtBeginFnGroup' */
				case 0x0161: /* 'BrtBeginExternals' */
					break;
	
				/* case 'BrtModelTimeGroupingCalcCol' */
				case 0x0C00: /* 'BrtUid' */
				case 0x0C01: /* 'BrtRevisionPtr' */
				case 0x0216: /* 'BrtBookProtection' */
				case 0x02A5: /* 'BrtBookProtectionIso' */
				case 0x009D: /* 'BrtCalcProp' */
				case 0x0262: /* 'BrtCrashRecErr' */
				case 0x0802: /* 'BrtDecoupledPivotCacheID' */
				case 0x009B: /* 'BrtFileRecover' */
				case 0x0224: /* 'BrtFileSharing' */
				case 0x02A4: /* 'BrtFileSharingIso' */
				case 0x0080: /* 'BrtFileVersion' */
				case 0x0299: /* 'BrtFnGroup' */
				case 0x0850: /* 'BrtModelRelationship' */
				case 0x084D: /* 'BrtModelTable' */
				case 0x0225: /* 'BrtOleSize' */
				case 0x0805: /* 'BrtPivotTableRef' */
				case 0x0254: /* 'BrtSmartTagType' */
				case 0x081C: /* 'BrtTableSlicerCacheID' */
				case 0x081B: /* 'BrtTableSlicerCacheIDs' */
				case 0x0822: /* 'BrtTimelineCachePivotCacheID' */
				case 0x018D: /* 'BrtUserBookView' */
				case 0x009A: /* 'BrtWbFactoid' */
				case 0x045D: /* 'BrtWbProp14' */
				case 0x0229: /* 'BrtWebOpt' */
				case 0x082B: /* 'BrtWorkBookPr15' */
					break;
	
				case 0x0023: /* 'BrtFRTBegin' */
					state.push(R_n); pass = true; break;
				case 0x0024: /* 'BrtFRTEnd' */
					state.pop(); pass = false; break;
				case 0x0025: /* 'BrtACBegin' */
					state.push(R_n); pass = true; break;
				case 0x0026: /* 'BrtACEnd' */
					state.pop(); pass = false; break;
	
				case 0x0010: /* 'BrtFRTArchID$' */ break;
	
				default:
					if((R_n||"").indexOf("Begin") > 0){/* empty */}
					else if((R_n||"").indexOf("End") > 0){/* empty */}
					else if(!pass || (opts.WTF && state[state.length-1] != "BrtACBegin" && state[state.length-1] != "BrtFRTBegin")) throw new Error("Unexpected record " + RT + " " + R_n);
			}
		}, opts);
	
		parse_wb_defaults(wb);
	
		// $FlowIgnore
		wb.Names = Names;
	
		(wb).supbooks = supbooks;
		return wb;
	}
	
	function write_BUNDLESHS(ba, wb) {
		write_record(ba, "BrtBeginBundleShs");
		for(var idx = 0; idx != wb.SheetNames.length; ++idx) {
			var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
			var d = { Hidden: viz, iTabID: idx+1, strRelID: 'rId' + (idx+1), name: wb.SheetNames[idx] };
			write_record(ba, "BrtBundleSh", write_BrtBundleSh(d));
		}
		write_record(ba, "BrtEndBundleShs");
	}
	
	/* [MS-XLSB] 2.4.649 BrtFileVersion */
	function write_BrtFileVersion(data, o) {
		if(!o) o = new_buf(127);
		for(var i = 0; i != 4; ++i) o.write_shift(4, 0);
		write_XLWideString("SheetJS", o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString(XLSX.version, o);
		write_XLWideString("7262", o);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	/* [MS-XLSB] 2.4.301 BrtBookView */
	function write_BrtBookView(idx, o) {
		if(!o) o = new_buf(29);
		o.write_shift(-4, 0);
		o.write_shift(-4, 460);
		o.write_shift(4,  28800);
		o.write_shift(4,  17600);
		o.write_shift(4,  500);
		o.write_shift(4,  idx);
		o.write_shift(4,  idx);
		var flags = 0x78;
		o.write_shift(1,  flags);
		return o.length > o.l ? o.slice(0, o.l) : o;
	}
	
	function write_BOOKVIEWS(ba, wb) {
		/* required if hidden tab appears before visible tab */
		if(!wb.Workbook || !wb.Workbook.Sheets) return;
		var sheets = wb.Workbook.Sheets;
		var i = 0, vistab = -1, hidden = -1;
		for(; i < sheets.length; ++i) {
			if(!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
			else if(sheets[i].Hidden == 1 && hidden == -1) hidden = i;
		}
		if(hidden > vistab) return;
		write_record(ba, "BrtBeginBookViews");
		write_record(ba, "BrtBookView", write_BrtBookView(vistab));
		/* 1*(BrtBookView *FRT) */
		write_record(ba, "BrtEndBookViews");
	}
	
	/* [MS-XLSB] 2.4.305 BrtCalcProp */
	/*function write_BrtCalcProp(data, o) {
		if(!o) o = new_buf(26);
		o.write_shift(4,0); // force recalc
		o.write_shift(4,1);
		o.write_shift(4,0);
		write_Xnum(0, o);
		o.write_shift(-4, 1023);
		o.write_shift(1, 0x33);
		o.write_shift(1, 0x00);
		return o;
	}*/
	
	/* [MS-XLSB] 2.4.646 BrtFileRecover */
	/*function write_BrtFileRecover(data, o) {
		if(!o) o = new_buf(1);
		o.write_shift(1,0);
		return o;
	}*/
	
	/* [MS-XLSB] 2.1.7.61 Workbook */
	function write_wb_bin(wb, opts) {
		var ba = buf_array();
		write_record(ba, "BrtBeginBook");
		write_record(ba, "BrtFileVersion", write_BrtFileVersion());
		/* [[BrtFileSharingIso] BrtFileSharing] */
		write_record(ba, "BrtWbProp", write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
		/* [ACABSPATH] */
		/* [[BrtBookProtectionIso] BrtBookProtection] */
		write_BOOKVIEWS(ba, wb, opts);
		write_BUNDLESHS(ba, wb, opts);
		/* [FNGROUP] */
		/* [EXTERNALS] */
		/* *BrtName */
		/* write_record(ba, "BrtCalcProp", write_BrtCalcProp()); */
		/* [BrtOleSize] */
		/* *(BrtUserBookView *FRT) */
		/* [PIVOTCACHEIDS] */
		/* [BrtWbFactoid] */
		/* [SMARTTAGTYPES] */
		/* [BrtWebOpt] */
		/* write_record(ba, "BrtFileRecover", write_BrtFileRecover()); */
		/* [WEBPUBITEMS] */
		/* [CRERRS] */
		/* FRTWORKBOOK */
		write_record(ba, "BrtEndBook");
	
		return ba.end();
	}
	function parse_wb(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_wb_bin((data), opts);
		return parse_wb_xml((data), opts);
	}
	
	function parse_ws(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ws_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ws_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_cs(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_cs_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_cs_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ms(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ms_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ms_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_ds(data, name, idx, opts, rels, wb, themes, styles) {
		if(name.slice(-4)===".bin") return parse_ds_bin((data), opts, idx, rels, wb, themes, styles);
		return parse_ds_xml((data), opts, idx, rels, wb, themes, styles);
	}
	
	function parse_sty(data, name, themes, opts) {
		if(name.slice(-4)===".bin") return parse_sty_bin((data), themes, opts);
		return parse_sty_xml((data), themes, opts);
	}
	
	function parse_theme(data, name, opts) {
		return parse_theme_xml(data, opts);
	}
	
	function parse_sst(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_sst_bin((data), opts);
		return parse_sst_xml((data), opts);
	}
	
	function parse_cmnt(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_comments_bin((data), opts);
		return parse_comments_xml((data), opts);
	}
	
	function parse_cc(data, name, opts) {
		if(name.slice(-4)===".bin") return parse_cc_bin((data), name, opts);
		return parse_cc_xml((data), name, opts);
	}
	
	function parse_xlink(data, rel, name, opts) {
		if(name.slice(-4)===".bin") return parse_xlink_bin((data), rel, name, opts);
		return parse_xlink_xml((data), rel, name, opts);
	}
	
	function write_wb(wb, name, opts) {
		return (name.slice(-4)===".bin" ? write_wb_bin : write_wb_xml)(wb, opts);
	}
	
	function write_ws(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_ws_bin : write_ws_xml)(data, opts, wb, rels);
	}
	
	// eslint-disable-next-line no-unused-vars
	function write_cs(data, name, opts, wb, rels) {
		return (name.slice(-4)===".bin" ? write_cs_bin : write_cs_xml)(data, opts, wb, rels);
	}
	
	function write_sty(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sty_bin : write_sty_xml)(data, opts);
	}
	
	function write_sst(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_sst_bin : write_sst_xml)(data, opts);
	}
	
	function write_cmnt(data, name, opts) {
		return (name.slice(-4)===".bin" ? write_comments_bin : write_comments_xml)(data, opts);
	}
	/*
	function write_cc(data, name:string, opts) {
		return (name.slice(-4)===".bin" ? write_cc_bin : write_cc_xml)(data, opts);
	}
	*/
	var attregexg2=/([\w:]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
	var attregex2=/([\w:]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
	function xlml_parsexmltag(tag, skip_root) {
		var words = tag.split(/\s+/);
		var z = ([]); if(!skip_root) z[0] = words[0];
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	function xlml_parsexmltagobj(tag) {
		var words = tag.split(/\s+/);
		var z = {};
		if(words.length === 1) return z;
		var m = tag.match(attregexg2), y, j, w, i;
		if(m) for(i = 0; i != m.length; ++i) {
			y = m[i].match(attregex2);
	if((j=y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1,y[2].length-1);
			else {
				if(y[1].slice(0,6) === "xmlns:") w = "xmlns"+y[1].slice(6);
				else w = y[1].slice(j+1);
				z[w] = y[2].slice(1,y[2].length-1);
			}
		}
		return z;
	}
	
	// ----
	
	function xlml_format(format, value) {
		var fmt = XLMLFormatMap[format] || unescapexml(format);
		if(fmt === "General") return SSF._general(value);
		return SSF.format(fmt, value);
	}
	
	function xlml_set_custprop(Custprops, key, cp, val) {
		var oval = val;
		switch((cp[0].match(/dt:dt="([\w.]+)"/)||["",""])[1]) {
			case "boolean": oval = parsexmlbool(val); break;
			case "i2": case "int": oval = parseInt(val, 10); break;
			case "r4": case "float": oval = parseFloat(val); break;
			case "date": case "dateTime.tz": oval = parseDate(val); break;
			case "i8": case "string": case "fixed": case "uuid": case "bin.base64": break;
			default: throw new Error("bad custprop:" + cp[0]);
		}
		Custprops[unescapexml(key)] = oval;
	}
	
	function safe_format_xlml(cell, nf, o) {
		if(cell.t === 'z') return;
		if(!o || o.cellText !== false) try {
			if(cell.t === 'e') { cell.w = cell.w || BErr[cell.v]; }
			else if(nf === "General") {
				if(cell.t === 'n') {
					if((cell.v|0) === cell.v) cell.w = SSF._general_int(cell.v);
					else cell.w = SSF._general_num(cell.v);
				}
				else cell.w = SSF._general(cell.v);
			}
			else cell.w = xlml_format(nf||"General", cell.v);
		} catch(e) { if(o.WTF) throw e; }
		try {
			var z = XLMLFormatMap[nf]||nf||"General";
			if(o.cellNF) cell.z = z;
			if(o.cellDates && cell.t == 'n' && SSF.is_date(z)) {
				var _d = SSF.parse_date_code(cell.v); if(_d) { cell.t = 'd'; cell.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
			}
		} catch(e) { if(o.WTF) throw e; }
	}
	
	function process_style_xlml(styles, stag, opts) {
		if(opts.cellStyles) {
			if(stag.Interior) {
				var I = stag.Interior;
				if(I.Pattern) I.patternType = XLMLPatternTypeMap[I.Pattern] || I.Pattern;
			}
		}
		styles[stag.ID] = stag;
	}
	
	/* TODO: there must exist some form of OSP-blessed spec */
	function parse_xlml_data(xml, ss, data, cell, base, styles, csty, row, arrayf, o) {
		var nf = "General", sid = cell.StyleID, S = {}; o = o || {};
		var interiors = [];
		var i = 0;
		if(sid === undefined && row) sid = row.StyleID;
		if(sid === undefined && csty) sid = csty.StyleID;
		while(styles[sid] !== undefined) {
			if(styles[sid].nf) nf = styles[sid].nf;
			if(styles[sid].Interior) interiors.push(styles[sid].Interior);
			if(!styles[sid].Parent) break;
			sid = styles[sid].Parent;
		}
		switch(data.Type) {
			case 'Boolean':
				cell.t = 'b';
				cell.v = parsexmlbool(xml);
				break;
			case 'String':
				cell.t = 's'; cell.r = xlml_fixstr(unescapexml(xml));
				cell.v = (xml.indexOf("<") > -1 ? unescapexml(ss||xml).replace(/<.*?>/g, "") : cell.r); // todo: BR etc
				break;
			case 'DateTime':
				if(xml.slice(-1) != "Z") xml += "Z";
				cell.v = (parseDate(xml) - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
				if(cell.v !== cell.v) cell.v = unescapexml(xml);
				else if(cell.v<60) cell.v = cell.v -1;
				if(!nf || nf == "General") nf = "yyyy-mm-dd";
				/* falls through */
			case 'Number':
				if(cell.v === undefined) cell.v=+xml;
				if(!cell.t) cell.t = 'n';
				break;
			case 'Error': cell.t = 'e'; cell.v = RBErr[xml]; if(o.cellText !== false) cell.w = xml; break;
			default:
				if(xml == "" && ss == "") { cell.t = 'z'; }
				else { cell.t = 's'; cell.v = xlml_fixstr(ss||xml); }
				break;
		}
		safe_format_xlml(cell, nf, o);
		if(o.cellFormula !== false) {
			if(cell.Formula) {
				var fstr = unescapexml(cell.Formula);
				/* strictly speaking, the leading = is required but some writers omit */
				if(fstr.charCodeAt(0) == 61 /* = */) fstr = fstr.slice(1);
				cell.f = rc_to_a1(fstr, base);
				delete cell.Formula;
				if(cell.ArrayRange == "RC") cell.F = rc_to_a1("RC:RC", base);
				else if(cell.ArrayRange) {
					cell.F = rc_to_a1(cell.ArrayRange, base);
					arrayf.push([safe_decode_range(cell.F), cell.F]);
				}
			} else {
				for(i = 0; i < arrayf.length; ++i)
					if(base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r)
						if(base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c)
							cell.F = arrayf[i][1];
			}
		}
		if(o.cellStyles) {
			interiors.forEach(function(x) {
				if(!S.patternType && x.patternType) S.patternType = x.patternType;
			});
			cell.s = S;
		}
		if(cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
	}
	
	function xlml_clean_comment(comment) {
		comment.t = comment.v || "";
		comment.t = comment.t.replace(/\r\n/g,"\n").replace(/\r/g,"\n");
		comment.v = comment.w = comment.ixfe = undefined;
	}
	
	function xlml_normalize(d) {
		if(has_buf && Buffer.isBuffer(d)) return d.toString('utf8');
		if(typeof d === 'string') return d;
		/* duktape */
		if(typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return utf8read(a2s(ab2a(d)));
		throw new Error("Bad input format: expected Buffer or string");
	}
	
	/* TODO: Everything */
	/* UOS uses CJK in tags */
	var xlmlregex = /<(\/?)([^\s?><!\/:]*:|)([^\s?<>:\/]+)(?:[\s?:\/][^>]*)?>/mg;
	//var xlmlregex = /<(\/?)([a-z0-9]*:|)(\w+)[^>]*>/mg;
	function parse_xlml_xml(d, _opts) {
		var opts = _opts || {};
		make_ssf(SSF);
		var str = debom(xlml_normalize(d));
		if(opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
			if(typeof cptable !== 'undefined') str = cptable.utils.decode(65001, char_codes(str));
			else str = utf8read(str);
		}
		var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
		opening = opening.replace(/".*?"/g, "");
		if((opening.indexOf(">") & 1023) > Math.min((opening.indexOf(",") & 1023), (opening.indexOf(";")&1023))) { var _o = dup(opts); _o.type = "string"; return PRN.to_workbook(str, _o); }
		if(opening.indexOf("<?xml") == -1) ["html", "table", "head", "meta", "script", "style", "div"].forEach(function(tag) { if(opening.indexOf("<" + tag) >= 0) ishtml = true; });
		if(ishtml) return HTML_.to_workbook(str, opts);
		var Rn;
		var state = [], tmp;
		if(DENSE != null && opts.dense == null) opts.dense = DENSE;
		var sheets = {}, sheetnames = [], cursheet = (opts.dense ? [] : {}), sheetname = "";
		var table = {}, cell = ({}), row = {};// eslint-disable-line no-unused-vars
		var dtag = xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
		var c = 0, r = 0;
		var refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
		var styles = {}, stag = {};
		var ss = "", fidx = 0;
		var merges = [];
		var Props = {}, Custprops = {}, pidx = 0, cp = [];
		var comments = [], comment = ({});
		var cstys = [], csty, seencol = false;
		var arrayf = [];
		var rowinfo = [], rowobj = {}, cc = 0, rr = 0;
		var Workbook = ({ Sheets:[], WBProps:{date1904:false} }), wsprops = {};
		xlmlregex.lastIndex = 0;
		str = str.replace(/<!--([\s\S]*?)-->/mg,"");
		var raw_Rn3 = "";
		while((Rn = xlmlregex.exec(str))) switch((Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase())) {
			case 'data' /*case 'Data'*/:
				if(raw_Rn3 == "data") {
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
				}
				if(state[state.length-1][1]) break;
				if(Rn[1]==='/') parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length-1][0]==/*"Comment"*/"comment"?comment:cell, {c:c,r:r}, styles, cstys[c], row, arrayf, opts);
				else { ss = ""; dtag = xlml_parsexmltag(Rn[0]); didx = Rn.index + Rn[0].length; }
				break;
			case 'cell' /*case 'Cell'*/:
				if(Rn[1]==='/'){
					if(comments.length > 0) cell.c = comments;
					if((!opts.sheetRows || opts.sheetRows > r) && cell.v !== undefined) {
						if(opts.dense) {
							if(!cursheet[r]) cursheet[r] = [];
							cursheet[r][c] = cell;
						} else cursheet[encode_col(c) + encode_row(r)] = cell;
					}
					if(cell.HRef) {
						cell.l = ({Target:unescapexml(cell.HRef)});
						if(cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
						delete cell.HRef; delete cell.HRefScreenTip;
					}
					if(cell.MergeAcross || cell.MergeDown) {
						cc = c + (parseInt(cell.MergeAcross,10)|0);
						rr = r + (parseInt(cell.MergeDown,10)|0);
						merges.push({s:{c:c,r:r},e:{c:cc,r:rr}});
					}
					if(!opts.sheetStubs) { if(cell.MergeAcross) c = cc + 1; else ++c; }
					else if(cell.MergeAcross || cell.MergeDown) {
	for(var cma = c; cma <= cc; ++cma) {
							for(var cmd = r; cmd <= rr; ++cmd) {
								if(cma > c || cmd > r) {
									if(opts.dense) {
										if(!cursheet[cmd]) cursheet[cmd] = [];
										cursheet[cmd][cma] = {t:'z'};
									} else cursheet[encode_col(cma) + encode_row(cmd)] = {t:'z'};
								}
							}
						}
						c = cc + 1;
					}
					else ++c;
				} else {
					cell = xlml_parsexmltagobj(Rn[0]);
					if(cell.Index) c = +cell.Index - 1;
					if(c < refguess.s.c) refguess.s.c = c;
					if(c > refguess.e.c) refguess.e.c = c;
					if(Rn[0].slice(-2) === "/>") ++c;
					comments = [];
				}
				break;
			case 'row' /*case 'Row'*/:
				if(Rn[1]==='/' || Rn[0].slice(-2) === "/>") {
					if(r < refguess.s.r) refguess.s.r = r;
					if(r > refguess.e.r) refguess.e.r = r;
					if(Rn[0].slice(-2) === "/>") {
						row = xlml_parsexmltag(Rn[0]);
						if(row.Index) r = +row.Index - 1;
					}
					c = 0; ++r;
				} else {
					row = xlml_parsexmltag(Rn[0]);
					if(row.Index) r = +row.Index - 1;
					rowobj = {};
					if(row.AutoFitHeight == "0" || row.Height) {
						rowobj.hpx = parseInt(row.Height, 10); rowobj.hpt = px2pt(rowobj.hpx);
						rowinfo[r] = rowobj;
					}
					if(row.Hidden == "1") { rowobj.hidden = true; rowinfo[r] = rowobj; }
				}
				break;
			case 'worksheet' /*case 'Worksheet'*/: /* TODO: read range from FullRows/FullColumns */
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					sheetnames.push(sheetname);
					if(refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
						cursheet["!ref"] = encode_range(refguess);
						if(opts.sheetRows && opts.sheetRows <= refguess.e.r) {
							cursheet["!fullref"] = cursheet["!ref"];
							refguess.e.r = opts.sheetRows - 1;
							cursheet["!ref"] = encode_range(refguess);
						}
					}
					if(merges.length) cursheet["!merges"] = merges;
					if(cstys.length > 0) cursheet["!cols"] = cstys;
					if(rowinfo.length > 0) cursheet["!rows"] = rowinfo;
					sheets[sheetname] = cursheet;
				} else {
					refguess = {s: {r:2000000, c:2000000}, e: {r:0, c:0} };
					r = c = 0;
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					sheetname = unescapexml(tmp.Name);
					cursheet = (opts.dense ? [] : {});
					merges = [];
					arrayf = [];
					rowinfo = [];
					wsprops = {name:sheetname, Hidden:0};
					Workbook.Sheets.push(wsprops);
				}
				break;
			case 'table' /*case 'Table'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].slice(-2) == "/>") break;
				else {
					table = xlml_parsexmltag(Rn[0]);
					state.push([Rn[3], false]);
					cstys = []; seencol = false;
				}
				break;
	
			case 'style' /*case 'Style'*/:
				if(Rn[1]==='/') process_style_xlml(styles, stag, opts);
				else stag = xlml_parsexmltag(Rn[0]);
				break;
	
			case 'numberformat' /*case 'NumberFormat'*/:
				stag.nf = unescapexml(xlml_parsexmltag(Rn[0]).Format || "General");
				if(XLMLFormatMap[stag.nf]) stag.nf = XLMLFormatMap[stag.nf];
				for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == stag.nf) break;
				if(ssfidx == 0x188) for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx) if(SSF._table[ssfidx] == null) { SSF.load(stag.nf, ssfidx); break; }
				break;
	
			case 'column' /*case 'Column'*/:
				if(state[state.length-1][0] !== /*'Table'*/'table') break;
				csty = xlml_parsexmltag(Rn[0]);
				if(csty.Hidden) { csty.hidden = true; delete csty.Hidden; }
				if(csty.Width) csty.wpx = parseInt(csty.Width, 10);
				if(!seencol && csty.wpx > 10) {
					seencol = true; MDW = DEF_MDW; //find_mdw_wpx(csty.wpx);
					for(var _col = 0; _col < cstys.length; ++_col) if(cstys[_col]) process_col(cstys[_col]);
				}
				if(seencol) process_col(csty);
				cstys[(csty.Index-1||cstys.length)] = csty;
				for(var i = 0; i < +csty.Span; ++i) cstys[cstys.length] = dup(csty);
				break;
	
			case 'namedrange' /*case 'NamedRange'*/:
				if(Rn[1]==='/') break;
				if(!Workbook.Names) Workbook.Names = [];
				var _NamedRange = parsexmltag(Rn[0]);
				var _DefinedName = ({
					Name: _NamedRange.Name,
					Ref: rc_to_a1(_NamedRange.RefersTo.slice(1), {r:0, c:0})
				});
				if(Workbook.Sheets.length>0) _DefinedName.Sheet=Workbook.Sheets.length-1;
	Workbook.Names.push(_DefinedName);
				break;
	
			case 'namedcell' /*case 'NamedCell'*/: break;
			case 'b' /*case 'B'*/: break;
			case 'i' /*case 'I'*/: break;
			case 'u' /*case 'U'*/: break;
			case 's' /*case 'S'*/: break;
			case 'em' /*case 'EM'*/: break;
			case 'h2' /*case 'H2'*/: break;
			case 'h3' /*case 'H3'*/: break;
			case 'sub' /*case 'Sub'*/: break;
			case 'sup' /*case 'Sup'*/: break;
			case 'span' /*case 'Span'*/: break;
			case 'alignment' /*case 'Alignment'*/:
				break;
			case 'borders' /*case 'Borders'*/: break;
			case 'border' /*case 'Border'*/: break;
			case 'font' /*case 'Font'*/:
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") ss += str.slice(fidx, Rn.index);
				else fidx = Rn.index + Rn[0].length;
				break;
			case 'interior' /*case 'Interior'*/:
				if(!opts.cellStyles) break;
				stag.Interior = xlml_parsexmltag(Rn[0]);
				break;
			case 'protection' /*case 'Protection'*/: break;
	
			case 'author' /*case 'Author'*/:
			case 'title' /*case 'Title'*/:
			case 'description' /*case 'Description'*/:
			case 'created' /*case 'Created'*/:
			case 'keywords' /*case 'Keywords'*/:
			case 'subject' /*case 'Subject'*/:
			case 'category' /*case 'Category'*/:
			case 'company' /*case 'Company'*/:
			case 'lastauthor' /*case 'LastAuthor'*/:
			case 'lastsaved' /*case 'LastSaved'*/:
			case 'lastprinted' /*case 'LastPrinted'*/:
			case 'version' /*case 'Version'*/:
			case 'revision' /*case 'Revision'*/:
			case 'totaltime' /*case 'TotalTime'*/:
			case 'hyperlinkbase' /*case 'HyperlinkBase'*/:
			case 'manager' /*case 'Manager'*/:
			case 'contentstatus' /*case 'ContentStatus'*/:
			case 'identifier' /*case 'Identifier'*/:
			case 'language' /*case 'Language'*/:
			case 'appname' /*case 'AppName'*/:
				if(Rn[0].slice(-2) === "/>") break;
				else if(Rn[1]==="/") xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
				else pidx = Rn.index + Rn[0].length;
				break;
			case 'paragraphs' /*case 'Paragraphs'*/: break;
	
			case 'styles' /*case 'Styles'*/:
			case 'workbook' /*case 'Workbook'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else state.push([Rn[3], false]);
				break;
	
			case 'comment' /*case 'Comment'*/:
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
					xlml_clean_comment(comment);
					comments.push(comment);
				} else {
					state.push([Rn[3], false]);
					tmp = xlml_parsexmltag(Rn[0]);
					comment = ({a:tmp.Author});
				}
				break;
	
			case 'autofilter' /*case 'AutoFilter'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
					var AutoFilter = xlml_parsexmltag(Rn[0]);
					cursheet['!autofilter'] = { ref:rc_to_a1(AutoFilter.Range).replace(/\$/g,"") };
					state.push([Rn[3], true]);
				}
				break;
	
			case 'name' /*case 'Name'*/: break;
	
			case 'datavalidation' /*case 'DataValidation'*/:
				if(Rn[1]==='/'){
					if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));
				} else {
					if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				}
				break;
	
			case 'pixelsperinch' /*case 'PixelsPerInch'*/:
				break;
			case 'componentoptions' /*case 'ComponentOptions'*/:
			case 'documentproperties' /*case 'DocumentProperties'*/:
			case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/:
			case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/:
			case 'pivottable' /*case 'PivotTable'*/:
			case 'pivotcache' /*case 'PivotCache'*/:
			case 'names' /*case 'Names'*/:
			case 'mapinfo' /*case 'MapInfo'*/:
			case 'pagebreaks' /*case 'PageBreaks'*/:
			case 'querytable' /*case 'QueryTable'*/:
			case 'sorting' /*case 'Sorting'*/:
			case 'schema' /*case 'Schema'*/: //case 'data' /*case 'data'*/:
			case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
			case 'smarttagtype' /*case 'SmartTagType'*/:
			case 'smarttags' /*case 'SmartTags'*/:
			case 'excelworkbook' /*case 'ExcelWorkbook'*/:
			case 'workbookoptions' /*case 'WorkbookOptions'*/:
			case 'worksheetoptions' /*case 'WorksheetOptions'*/:
				if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw new Error("Bad state: "+tmp.join("|"));}
				else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
				break;
	
			case 'null' /*case 'Null'*/: break;
	
			default:
				/* FODS file root is <office:document> */
				if(state.length == 0 && Rn[3] == "document") return parse_fods(str, opts);
				/* UOS file root is <uof:UOF> */
				if(state.length == 0 && Rn[3] == "uof"/*"UOF"*/) return parse_fods(str, opts);
	
				var seen = true;
				switch(state[state.length-1][0]) {
					/* OfficeDocumentSettings */
					case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/: switch(Rn[3]) {
						case 'allowpng' /*case 'AllowPNG'*/: break;
						case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/: break;
						case 'downloadcomponents' /*case 'DownloadComponents'*/: break;
						case 'locationofcomponents' /*case 'LocationOfComponents'*/: break;
						case 'colors' /*case 'Colors'*/: break;
						case 'color' /*case 'Color'*/: break;
						case 'index' /*case 'Index'*/: break;
						case 'rgb' /*case 'RGB'*/: break;
						case 'targetscreensize' /*case 'TargetScreenSize'*/: break;
						case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/: break;
						default: seen = false;
					} break;
	
					/* ComponentOptions */
					case 'componentoptions' /*case 'ComponentOptions'*/: switch(Rn[3]) {
						case 'toolbar' /*case 'Toolbar'*/: break;
						case 'hideofficelogo' /*case 'HideOfficeLogo'*/: break;
						case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/: break;
						case 'label' /*case 'Label'*/: break;
						case 'caption' /*case 'Caption'*/: break;
						case 'maxheight' /*case 'MaxHeight'*/: break;
						case 'maxwidth' /*case 'MaxWidth'*/: break;
						case 'nextsheetnumber' /*case 'NextSheetNumber'*/: break;
						default: seen = false;
					} break;
	
					/* ExcelWorkbook */
					case 'excelworkbook' /*case 'ExcelWorkbook'*/: switch(Rn[3]) {
						case 'date1904' /*case 'Date1904'*/:
	Workbook.WBProps.date1904 = true;
							break;
						case 'windowheight' /*case 'WindowHeight'*/: break;
						case 'windowwidth' /*case 'WindowWidth'*/: break;
						case 'windowtopx' /*case 'WindowTopX'*/: break;
						case 'windowtopy' /*case 'WindowTopY'*/: break;
						case 'tabratio' /*case 'TabRatio'*/: break;
						case 'protectstructure' /*case 'ProtectStructure'*/: break;
						case 'protectwindow' /*case 'ProtectWindow'*/: break;
						case 'protectwindows' /*case 'ProtectWindows'*/: break;
						case 'activesheet' /*case 'ActiveSheet'*/: break;
						case 'displayinknotes' /*case 'DisplayInkNotes'*/: break;
						case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/: break;
						case 'supbook' /*case 'SupBook'*/: break;
						case 'sheetname' /*case 'SheetName'*/: break;
						case 'sheetindex' /*case 'SheetIndex'*/: break;
						case 'sheetindexfirst' /*case 'SheetIndexFirst'*/: break;
						case 'sheetindexlast' /*case 'SheetIndexLast'*/: break;
						case 'dll' /*case 'Dll'*/: break;
						case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/: break;
						case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/: break;
						case 'iteration' /*case 'Iteration'*/: break;
						case 'maxiterations' /*case 'MaxIterations'*/: break;
						case 'maxchange' /*case 'MaxChange'*/: break;
						case 'path' /*case 'Path'*/: break;
						case 'xct' /*case 'Xct'*/: break;
						case 'count' /*case 'Count'*/: break;
						case 'selectedsheets' /*case 'SelectedSheets'*/: break;
						case 'calculation' /*case 'Calculation'*/: break;
						case 'uncalced' /*case 'Uncalced'*/: break;
						case 'startupprompt' /*case 'StartupPrompt'*/: break;
						case 'crn' /*case 'Crn'*/: break;
						case 'externname' /*case 'ExternName'*/: break;
						case 'formula' /*case 'Formula'*/: break;
						case 'colfirst' /*case 'ColFirst'*/: break;
						case 'collast' /*case 'ColLast'*/: break;
						case 'wantadvise' /*case 'WantAdvise'*/: break;
						case 'boolean' /*case 'Boolean'*/: break;
						case 'error' /*case 'Error'*/: break;
						case 'text' /*case 'Text'*/: break;
						case 'ole' /*case 'OLE'*/: break;
						case 'noautorecover' /*case 'NoAutoRecover'*/: break;
						case 'publishobjects' /*case 'PublishObjects'*/: break;
						case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'refmoder1c1' /*case 'RefModeR1C1'*/: break;
						case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/: break;
						default: seen = false;
					} break;
	
					/* WorkbookOptions */
					case 'workbookoptions' /*case 'WorkbookOptions'*/: switch(Rn[3]) {
						case 'owcversion' /*case 'OWCVersion'*/: break;
						case 'height' /*case 'Height'*/: break;
						case 'width' /*case 'Width'*/: break;
						default: seen = false;
					} break;
	
					/* WorksheetOptions */
					case 'worksheetoptions' /*case 'WorksheetOptions'*/: switch(Rn[3]) {
						case 'visible' /*case 'Visible'*/:
							if(Rn[0].slice(-2) === "/>"){/* empty */}
							else if(Rn[1]==="/") switch(str.slice(pidx, Rn.index)) {
								case "SheetHidden": wsprops.Hidden = 1; break;
								case "SheetVeryHidden": wsprops.Hidden = 2; break;
							}
							else pidx = Rn.index + Rn[0].length;
							break;
						case 'header' /*case 'Header'*/:
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							cursheet['!margins'].header = parsexmltag(Rn[0]).Margin;
							break;
						case 'footer' /*case 'Footer'*/:
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={}, 'xlml');
							cursheet['!margins'].footer = parsexmltag(Rn[0]).Margin;
							break;
						case 'pagemargins' /*case 'PageMargins'*/:
							var pagemargins = parsexmltag(Rn[0]);
							if(!cursheet['!margins']) default_margins(cursheet['!margins']={},'xlml');
							if(pagemargins.Top) cursheet['!margins'].top = pagemargins.Top;
							if(pagemargins.Left) cursheet['!margins'].left = pagemargins.Left;
							if(pagemargins.Right) cursheet['!margins'].right = pagemargins.Right;
							if(pagemargins.Bottom) cursheet['!margins'].bottom = pagemargins.Bottom;
							break;
						case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/:
							if(!Workbook.Views) Workbook.Views = [];
							if(!Workbook.Views[0]) Workbook.Views[0] = {};
							Workbook.Views[0].RTL = true;
							break;
	
						case 'freezepanes' /*case 'FreezePanes'*/: break;
						case 'frozennosplit' /*case 'FrozenNoSplit'*/: break;
	
						case 'splithorizontal' /*case 'SplitHorizontal'*/:
						case 'splitvertical' /*case 'SplitVertical'*/:
							break;
	
						case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/:
							break;
	
						case 'activerow' /*case 'ActiveRow'*/: break;
						case 'activecol' /*case 'ActiveCol'*/: break;
						case 'toprowbottompane' /*case 'TopRowBottomPane'*/: break;
						case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/: break;
	
						case 'unsynced' /*case 'Unsynced'*/: break;
						case 'print' /*case 'Print'*/: break;
						case 'printerrors' /*case 'PrintErrors'*/: break;
						case 'panes' /*case 'Panes'*/: break;
						case 'scale' /*case 'Scale'*/: break;
						case 'pane' /*case 'Pane'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'layout' /*case 'Layout'*/: break;
						case 'pagesetup' /*case 'PageSetup'*/: break;
						case 'selected' /*case 'Selected'*/: break;
						case 'protectobjects' /*case 'ProtectObjects'*/: break;
						case 'enableselection' /*case 'EnableSelection'*/: break;
						case 'protectscenarios' /*case 'ProtectScenarios'*/: break;
						case 'validprinterinfo' /*case 'ValidPrinterInfo'*/: break;
						case 'horizontalresolution' /*case 'HorizontalResolution'*/: break;
						case 'verticalresolution' /*case 'VerticalResolution'*/: break;
						case 'numberofcopies' /*case 'NumberofCopies'*/: break;
						case 'activepane' /*case 'ActivePane'*/: break;
						case 'toprowvisible' /*case 'TopRowVisible'*/: break;
						case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/: break;
						case 'fittopage' /*case 'FitToPage'*/: break;
						case 'rangeselection' /*case 'RangeSelection'*/: break;
						case 'papersizeindex' /*case 'PaperSizeIndex'*/: break;
						case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/: break;
						case 'pagebreakzoom' /*case 'PageBreakZoom'*/: break;
						case 'filteron' /*case 'FilterOn'*/: break;
						case 'fitwidth' /*case 'FitWidth'*/: break;
						case 'fitheight' /*case 'FitHeight'*/: break;
						case 'commentslayout' /*case 'CommentsLayout'*/: break;
						case 'zoom' /*case 'Zoom'*/: break;
						case 'lefttoright' /*case 'LeftToRight'*/: break;
						case 'gridlines' /*case 'Gridlines'*/: break;
						case 'allowsort' /*case 'AllowSort'*/: break;
						case 'allowfilter' /*case 'AllowFilter'*/: break;
						case 'allowinsertrows' /*case 'AllowInsertRows'*/: break;
						case 'allowdeleterows' /*case 'AllowDeleteRows'*/: break;
						case 'allowinsertcols' /*case 'AllowInsertCols'*/: break;
						case 'allowdeletecols' /*case 'AllowDeleteCols'*/: break;
						case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/: break;
						case 'allowformatcells' /*case 'AllowFormatCells'*/: break;
						case 'allowsizecols' /*case 'AllowSizeCols'*/: break;
						case 'allowsizerows' /*case 'AllowSizeRows'*/: break;
						case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/:
							if(!cursheet["!outline"]) cursheet["!outline"] = {};
							cursheet["!outline"].above = true;
							break;
						case 'tabcolorindex' /*case 'TabColorIndex'*/: break;
						case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/: break;
						case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/: break;
						case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/:
							if(!cursheet["!outline"]) cursheet["!outline"] = {};
							cursheet["!outline"].left = true;
							break;
						case 'blackandwhite' /*case 'BlackAndWhite'*/: break;
						case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/: break;
						case 'displaypagebreak' /*case 'DisplayPageBreak'*/: break;
						case 'rowcolheadings' /*case 'RowColHeadings'*/: break;
						case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/: break;
						case 'noorientation' /*case 'NoOrientation'*/: break;
						case 'allowusepivottables' /*case 'AllowUsePivotTables'*/: break;
						case 'zeroheight' /*case 'ZeroHeight'*/: break;
						case 'viewablerange' /*case 'ViewableRange'*/: break;
						case 'selection' /*case 'Selection'*/: break;
						case 'protectcontents' /*case 'ProtectContents'*/: break;
						default: seen = false;
					} break;
	
					/* PivotTable */
					case 'pivottable' /*case 'PivotTable'*/: case 'pivotcache' /*case 'PivotCache'*/: switch(Rn[3]) {
						case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/: break;
						case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/: break;
						case 'compactrowindent' /*case 'CompactRowIndent'*/: break;
						case 'location' /*case 'Location'*/: break;
						case 'pivotfield' /*case 'PivotField'*/: break;
						case 'orientation' /*case 'Orientation'*/: break;
						case 'layoutform' /*case 'LayoutForm'*/: break;
						case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/: break;
						case 'layoutcompactrow' /*case 'LayoutCompactRow'*/: break;
						case 'position' /*case 'Position'*/: break;
						case 'pivotitem' /*case 'PivotItem'*/: break;
						case 'datatype' /*case 'DataType'*/: break;
						case 'datafield' /*case 'DataField'*/: break;
						case 'sourcename' /*case 'SourceName'*/: break;
						case 'parentfield' /*case 'ParentField'*/: break;
						case 'ptlineitems' /*case 'PTLineItems'*/: break;
						case 'ptlineitem' /*case 'PTLineItem'*/: break;
						case 'countofsameitems' /*case 'CountOfSameItems'*/: break;
						case 'item' /*case 'Item'*/: break;
						case 'itemtype' /*case 'ItemType'*/: break;
						case 'ptsource' /*case 'PTSource'*/: break;
						case 'cacheindex' /*case 'CacheIndex'*/: break;
						case 'consolidationreference' /*case 'ConsolidationReference'*/: break;
						case 'filename' /*case 'FileName'*/: break;
						case 'reference' /*case 'Reference'*/: break;
						case 'nocolumngrand' /*case 'NoColumnGrand'*/: break;
						case 'norowgrand' /*case 'NoRowGrand'*/: break;
						case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/: break;
						case 'hidden' /*case 'Hidden'*/: break;
						case 'subtotal' /*case 'Subtotal'*/: break;
						case 'basefield' /*case 'BaseField'*/: break;
						case 'mapchilditems' /*case 'MapChildItems'*/: break;
						case 'function' /*case 'Function'*/: break;
						case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/: break;
						case 'printsettitles' /*case 'PrintSetTitles'*/: break;
						case 'mergelabels' /*case 'MergeLabels'*/: break;
						case 'defaultversion' /*case 'DefaultVersion'*/: break;
						case 'refreshname' /*case 'RefreshName'*/: break;
						case 'refreshdate' /*case 'RefreshDate'*/: break;
						case 'refreshdatecopy' /*case 'RefreshDateCopy'*/: break;
						case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
						case 'versionlastupdate' /*case 'VersionLastUpdate'*/: break;
						case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/: break;
						case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/: break;
						case 'calculation' /*case 'Calculation'*/: break;
						default: seen = false;
					} break;
	
					/* PageBreaks */
					case 'pagebreaks' /*case 'PageBreaks'*/: switch(Rn[3]) {
						case 'colbreaks' /*case 'ColBreaks'*/: break;
						case 'colbreak' /*case 'ColBreak'*/: break;
						case 'rowbreaks' /*case 'RowBreaks'*/: break;
						case 'rowbreak' /*case 'RowBreak'*/: break;
						case 'colstart' /*case 'ColStart'*/: break;
						case 'colend' /*case 'ColEnd'*/: break;
						case 'rowend' /*case 'RowEnd'*/: break;
						default: seen = false;
					} break;
	
					/* AutoFilter */
					case 'autofilter' /*case 'AutoFilter'*/: switch(Rn[3]) {
						case 'autofiltercolumn' /*case 'AutoFilterColumn'*/: break;
						case 'autofiltercondition' /*case 'AutoFilterCondition'*/: break;
						case 'autofilterand' /*case 'AutoFilterAnd'*/: break;
						case 'autofilteror' /*case 'AutoFilterOr'*/: break;
						default: seen = false;
					} break;
	
					/* QueryTable */
					case 'querytable' /*case 'QueryTable'*/: switch(Rn[3]) {
						case 'id' /*case 'Id'*/: break;
						case 'autoformatfont' /*case 'AutoFormatFont'*/: break;
						case 'autoformatpattern' /*case 'AutoFormatPattern'*/: break;
						case 'querysource' /*case 'QuerySource'*/: break;
						case 'querytype' /*case 'QueryType'*/: break;
						case 'enableredirections' /*case 'EnableRedirections'*/: break;
						case 'refreshedinxl9' /*case 'RefreshedInXl9'*/: break;
						case 'urlstring' /*case 'URLString'*/: break;
						case 'htmltables' /*case 'HTMLTables'*/: break;
						case 'connection' /*case 'Connection'*/: break;
						case 'commandtext' /*case 'CommandText'*/: break;
						case 'refreshinfo' /*case 'RefreshInfo'*/: break;
						case 'notitles' /*case 'NoTitles'*/: break;
						case 'nextid' /*case 'NextId'*/: break;
						case 'columninfo' /*case 'ColumnInfo'*/: break;
						case 'overwritecells' /*case 'OverwriteCells'*/: break;
						case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/: break;
						case 'textwizardsettings' /*case 'TextWizardSettings'*/: break;
						case 'source' /*case 'Source'*/: break;
						case 'number' /*case 'Number'*/: break;
						case 'decimal' /*case 'Decimal'*/: break;
						case 'thousandseparator' /*case 'ThousandSeparator'*/: break;
						case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/: break;
						case 'formatsettings' /*case 'FormatSettings'*/: break;
						case 'fieldtype' /*case 'FieldType'*/: break;
						case 'delimiters' /*case 'Delimiters'*/: break;
						case 'tab' /*case 'Tab'*/: break;
						case 'comma' /*case 'Comma'*/: break;
						case 'autoformatname' /*case 'AutoFormatName'*/: break;
						case 'versionlastedit' /*case 'VersionLastEdit'*/: break;
						case 'versionlastrefresh' /*case 'VersionLastRefresh'*/: break;
						default: seen = false;
					} break;
	
					case 'datavalidation' /*case 'DataValidation'*/:
					switch(Rn[3]) {
						case 'range' /*case 'Range'*/: break;
	
						case 'type' /*case 'Type'*/: break;
						case 'min' /*case 'Min'*/: break;
						case 'max' /*case 'Max'*/: break;
						case 'sort' /*case 'Sort'*/: break;
						case 'descending' /*case 'Descending'*/: break;
						case 'order' /*case 'Order'*/: break;
						case 'casesensitive' /*case 'CaseSensitive'*/: break;
						case 'value' /*case 'Value'*/: break;
						case 'errorstyle' /*case 'ErrorStyle'*/: break;
						case 'errormessage' /*case 'ErrorMessage'*/: break;
						case 'errortitle' /*case 'ErrorTitle'*/: break;
						case 'inputmessage' /*case 'InputMessage'*/: break;
						case 'inputtitle' /*case 'InputTitle'*/: break;
						case 'combohide' /*case 'ComboHide'*/: break;
						case 'inputhide' /*case 'InputHide'*/: break;
						case 'condition' /*case 'Condition'*/: break;
						case 'qualifier' /*case 'Qualifier'*/: break;
						case 'useblank' /*case 'UseBlank'*/: break;
						case 'value1' /*case 'Value1'*/: break;
						case 'value2' /*case 'Value2'*/: break;
						case 'format' /*case 'Format'*/: break;
	
						case 'cellrangelist' /*case 'CellRangeList'*/: break;
						default: seen = false;
					} break;
	
					case 'sorting' /*case 'Sorting'*/:
					case 'conditionalformatting' /*case 'ConditionalFormatting'*/:
					switch(Rn[3]) {
						case 'range' /*case 'Range'*/: break;
						case 'type' /*case 'Type'*/: break;
						case 'min' /*case 'Min'*/: break;
						case 'max' /*case 'Max'*/: break;
						case 'sort' /*case 'Sort'*/: break;
						case 'descending' /*case 'Descending'*/: break;
						case 'order' /*case 'Order'*/: break;
						case 'casesensitive' /*case 'CaseSensitive'*/: break;
						case 'value' /*case 'Value'*/: break;
						case 'errorstyle' /*case 'ErrorStyle'*/: break;
						case 'errormessage' /*case 'ErrorMessage'*/: break;
						case 'errortitle' /*case 'ErrorTitle'*/: break;
						case 'cellrangelist' /*case 'CellRangeList'*/: break;
						case 'inputmessage' /*case 'InputMessage'*/: break;
						case 'inputtitle' /*case 'InputTitle'*/: break;
						case 'combohide' /*case 'ComboHide'*/: break;
						case 'inputhide' /*case 'InputHide'*/: break;
						case 'condition' /*case 'Condition'*/: break;
						case 'qualifier' /*case 'Qualifier'*/: break;
						case 'useblank' /*case 'UseBlank'*/: break;
						case 'value1' /*case 'Value1'*/: break;
						case 'value2' /*case 'Value2'*/: break;
						case 'format' /*case 'Format'*/: break;
						default: seen = false;
					} break;
	
					/* MapInfo (schema) */
					case 'mapinfo' /*case 'MapInfo'*/: case 'schema' /*case 'Schema'*/: case 'data' /*case 'data'*/: switch(Rn[3]) {
						case 'map' /*case 'Map'*/: break;
						case 'entry' /*case 'Entry'*/: break;
						case 'range' /*case 'Range'*/: break;
						case 'xpath' /*case 'XPath'*/: break;
						case 'field' /*case 'Field'*/: break;
						case 'xsdtype' /*case 'XSDType'*/: break;
						case 'filteron' /*case 'FilterOn'*/: break;
						case 'aggregate' /*case 'Aggregate'*/: break;
						case 'elementtype' /*case 'ElementType'*/: break;
						case 'attributetype' /*case 'AttributeType'*/: break;
					/* These are from xsd (XML Schema Definition) */
						case 'schema' /*case 'schema'*/:
						case 'element' /*case 'element'*/:
						case 'complextype' /*case 'complexType'*/:
						case 'datatype' /*case 'datatype'*/:
						case 'all' /*case 'all'*/:
						case 'attribute' /*case 'attribute'*/:
						case 'extends' /*case 'extends'*/: break;
	
						case 'row' /*case 'row'*/: break;
						default: seen = false;
					} break;
	
					/* SmartTags (can be anything) */
					case 'smarttags' /*case 'SmartTags'*/: break;
	
					default: seen = false; break;
				}
				if(seen) break;
				/* CustomDocumentProperties */
				if(Rn[3].match(/!\[CDATA/)) break;
				if(!state[state.length-1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
				if(state[state.length-1][0]===/*'CustomDocumentProperties'*/'customdocumentproperties') {
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
					else { cp = Rn; pidx = Rn.index + Rn[0].length; }
					break;
				}
				if(opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
		}
		var out = ({});
		if(!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
		out.SheetNames = sheetnames;
		out.Workbook = Workbook;
		out.SSF = SSF.get_table();
		out.Props = Props;
		out.Custprops = Custprops;
		return out;
	}
	
	function parse_xlml(data, opts) {
		fix_read_opts(opts=opts||{});
		switch(opts.type||"base64") {
			case "base64": return parse_xlml_xml(Base64.decode(data), opts);
			case "binary": case "buffer": case "file": return parse_xlml_xml(data, opts);
			case "array": return parse_xlml_xml(a2s(data), opts);
		}
	}
	
	/* TODO */
	function write_props_xlml(wb, opts) {
		var o = [];
		/* DocumentProperties */
		if(wb.Props) o.push(xlml_write_docprops(wb.Props, opts));
		/* CustomDocumentProperties */
		if(wb.Custprops) o.push(xlml_write_custprops(wb.Props, wb.Custprops, opts));
		return o.join("");
	}
	/* TODO */
	function write_wb_xlml() {
		/* OfficeDocumentSettings */
		/* ExcelWorkbook */
		return "";
	}
	/* TODO */
	function write_sty_xlml(wb, opts) {
		/* Styles */
		var styles = ['<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'];
		opts.cellXfs.forEach(function(xf, id) {
			var payload = [];
			payload.push(writextag('NumberFormat', null, {"ss:Format": escapexml(SSF._table[xf.numFmtId])}));
	
			var o = {"ss:ID": "s" + (21+id)};
			styles.push(writextag('Style', payload.join(""), o));
		});
		return writextag("Styles", styles.join(""));
	}
	function write_name_xlml(n) { return writextag("NamedRange", null, {"ss:Name": n.Name, "ss:RefersTo":"=" + a1_to_rc(n.Ref, {r:0,c:0})}); }
	function write_names_xlml(wb) {
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != null) continue;
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return writextag("Names", out.join(""));
	}
	function write_ws_xlml_names(ws, opts, idx, wb) {
		if(!ws) return "";
		if(!((wb||{}).Workbook||{}).Names) return "";
	var names = wb.Workbook.Names;
		var out = [];
		for(var i = 0; i < names.length; ++i) {
			var n = names[i];
			if(n.Sheet != idx) continue;
			/*switch(n.Name) {
				case "_": continue;
			}*/
			if(n.Name.match(/^_xlfn\./)) continue;
			out.push(write_name_xlml(n));
		}
		return out.join("");
	}
	/* WorksheetOptions */
	function write_ws_xlml_wsopts(ws, opts, idx, wb) {
		if(!ws) return "";
		var o = [];
		/* NOTE: spec technically allows any order, but stick with implied order */
	
		/* FitToPage */
		/* DoNotDisplayColHeaders */
		/* DoNotDisplayRowHeaders */
		/* ViewableRange */
		/* Selection */
		/* GridlineColor */
		/* Name */
		/* ExcelWorksheetType */
		/* IntlMacro */
		/* Unsynced */
		/* Selected */
		/* CodeName */
	
		if(ws['!margins']) {
			o.push("<PageSetup>");
			if(ws['!margins'].header) o.push(writextag("Header", null, {'x:Margin':ws['!margins'].header}));
			if(ws['!margins'].footer) o.push(writextag("Footer", null, {'x:Margin':ws['!margins'].footer}));
			o.push(writextag("PageMargins", null, {
				'x:Bottom': ws['!margins'].bottom || "0.75",
				'x:Left': ws['!margins'].left || "0.7",
				'x:Right': ws['!margins'].right || "0.7",
				'x:Top': ws['!margins'].top || "0.75"
			}));
			o.push("</PageSetup>");
		}
	
		/* PageSetup */
		/* DisplayPageBreak */
		/* TransitionExpressionEvaluation */
		/* TransitionFormulaEntry */
		/* Print */
		/* Zoom */
		/* PageLayoutZoom */
		/* PageBreakZoom */
		/* ShowPageBreakZoom */
		/* DefaultRowHeight */
		/* DefaultColumnWidth */
		/* StandardWidth */
	
		if(wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
			/* Visible */
			if(wb.Workbook.Sheets[idx].Hidden) o.push(writextag("Visible", (wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden"), {}));
			else {
				/* Selected */
				for(var i = 0; i < idx; ++i) if(wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
				if(i == idx) o.push("<Selected/>");
			}
		}
	
		/* LeftColumnVisible */
	
		if(((((wb||{}).Workbook||{}).Views||[])[0]||{}).RTL) o.push("<DisplayRightToLeft/>");
	
		/* GridlineColorIndex */
		/* DisplayFormulas */
		/* DoNotDisplayGridlines */
		/* DoNotDisplayHeadings */
		/* DoNotDisplayOutline */
		/* ApplyAutomaticOutlineStyles */
		/* NoSummaryRowsBelowDetail */
		/* NoSummaryColumnsRightDetail */
		/* DoNotDisplayZeros */
		/* ActiveRow */
		/* ActiveColumn */
		/* FilterOn */
		/* RangeSelection */
		/* TopRowVisible */
		/* TopRowBottomPane */
		/* LeftColumnRightPane */
		/* ActivePane */
		/* SplitHorizontal */
		/* SplitVertical */
		/* FreezePanes */
		/* FrozenNoSplit */
		/* TabColorIndex */
		/* Panes */
	
		/* NOTE: Password not supported in XLML Format */
		if(ws['!protect']) {
			o.push(writetag("ProtectContents", "True"));
			if(ws['!protect'].objects) o.push(writetag("ProtectObjects", "True"));
			if(ws['!protect'].scenarios) o.push(writetag("ProtectScenarios", "True"));
			if(ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push(writetag("EnableSelection", "NoSelection"));
			else if(ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push(writetag("EnableSelection", "UnlockedCells"));
		[
			[ "formatCells", "AllowFormatCells" ],
			[ "formatColumns", "AllowSizeCols" ],
			[ "formatRows", "AllowSizeRows" ],
			[ "insertColumns", "AllowInsertCols" ],
			[ "insertRows", "AllowInsertRows" ],
			[ "insertHyperlinks", "AllowInsertHyperlinks" ],
			[ "deleteColumns", "AllowDeleteCols" ],
			[ "deleteRows", "AllowDeleteRows" ],
			[ "sort", "AllowSort" ],
			[ "autoFilter", "AllowFilter" ],
			[ "pivotTables", "AllowUsePivotTables" ]
		].forEach(function(x) { if(ws['!protect'][x[0]]) o.push("<"+x[1]+"/>"); });
		}
	
		if(o.length == 0) return "";
		return writextag("WorksheetOptions", o.join(""), {xmlns:XLMLNS.x});
	}
	function write_ws_xlml_comment(comments) {
		return comments.map(function(c) {
			// TODO: formatted text
			var t = xlml_unfixstr(c.t||"");
			var d =writextag("ss:Data", t, {"xmlns":"http://www.w3.org/TR/REC-html40"});
			return writextag("Comment", d, {"ss:Author":c.a});
		}).join("");
	}
	function write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr){
		if(!cell || (cell.v == undefined && cell.f == undefined)) return "";
	
		var attr = {};
		if(cell.f) attr["ss:Formula"] = "=" + escapexml(a1_to_rc(cell.f, addr));
		if(cell.F && cell.F.slice(0, ref.length) == ref) {
			var end = decode_cell(cell.F.slice(ref.length + 1));
			attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
		}
	
		if(cell.l && cell.l.Target) {
			attr["ss:HRef"] = escapexml(cell.l.Target);
			if(cell.l.Tooltip) attr["x:HRefScreenTip"] = escapexml(cell.l.Tooltip);
		}
	
		if(ws['!merges']) {
			var marr = ws['!merges'];
			for(var mi = 0; mi != marr.length; ++mi) {
				if(marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
				if(marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
				if(marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
			}
		}
	
		var t = "", p = "";
		switch(cell.t) {
			case 'z': if(!opts.sheetStubs) return ""; break;
			case 'n': t = 'Number'; p = String(cell.v); break;
			case 'b': t = 'Boolean'; p = (cell.v ? "1" : "0"); break;
			case 'e': t = 'Error'; p = BErr[cell.v]; break;
			case 'd': t = 'DateTime'; p = new Date(cell.v).toISOString(); if(cell.z == null) cell.z = cell.z || SSF._table[14]; break;
			case 's': t = 'String'; p = escapexlml(cell.v||""); break;
		}
		/* TODO: cell style */
		var os = get_cell_style(opts.cellXfs, cell, opts);
		attr["ss:StyleID"] = "s" + (21+os);
		attr["ss:Index"] = addr.c + 1;
		var _v = (cell.v != null ? p : "");
		var m = cell.t == 'z' ? "" : ('<Data ss:Type="' + t + '">' + _v + '</Data>');
	
		if((cell.c||[]).length > 0) m += write_ws_xlml_comment(cell.c);
	
		return writextag("Cell", m, attr);
	}
	function write_ws_xlml_row(R, row) {
		var o = '<Row ss:Index="' + (R+1) + '"';
		if(row) {
			if(row.hpt && !row.hpx) row.hpx = pt2px(row.hpt);
			if(row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
			if(row.hidden) o += ' ss:Hidden="1"';
		}
		return o + '>';
	}
	/* TODO */
	function write_ws_xlml_table(ws, opts, idx, wb) {
		if(!ws['!ref']) return "";
		var range = safe_decode_range(ws['!ref']);
		var marr = ws['!merges'] || [], mi = 0;
		var o = [];
		if(ws['!cols']) ws['!cols'].forEach(function(n, i) {
			process_col(n);
			var w = !!n.width;
			var p = col_obj_w(i, n);
			var k = {"ss:Index":i+1};
			if(w) k['ss:Width'] = width2px(p.width);
			if(n.hidden) k['ss:Hidden']="1";
			o.push(writextag("Column",null,k));
		});
		var dense = Array.isArray(ws);
		for(var R = range.s.r; R <= range.e.r; ++R) {
			var row = [write_ws_xlml_row(R, (ws['!rows']||[])[R])];
			for(var C = range.s.c; C <= range.e.c; ++C) {
				var skip = false;
				for(mi = 0; mi != marr.length; ++mi) {
					if(marr[mi].s.c > C) continue;
					if(marr[mi].s.r > R) continue;
					if(marr[mi].e.c < C) continue;
					if(marr[mi].e.r < R) continue;
					if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
					break;
				}
				if(skip) continue;
				var addr = {r:R,c:C};
				var ref = encode_cell(addr), cell = dense ? (ws[R]||[])[C] : ws[ref];
				row.push(write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
			}
			row.push("</Row>");
			if(row.length > 2) o.push(row.join(""));
		}
		return o.join("");
	}
	function write_ws_xlml(idx, opts, wb) {
		var o = [];
		var s = wb.SheetNames[idx];
		var ws = wb.Sheets[s];
	
		var t = ws ? write_ws_xlml_names(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Names>" + t + "</Names>");
	
		/* Table */
		t = ws ? write_ws_xlml_table(ws, opts, idx, wb) : "";
		if(t.length > 0) o.push("<Table>" + t + "</Table>");
	
		/* WorksheetOptions */
		o.push(write_ws_xlml_wsopts(ws, opts, idx, wb));
	
		return o.join("");
	}
	function write_xlml(wb, opts) {
		if(!opts) opts = {};
		if(!wb.SSF) wb.SSF = SSF.get_table();
		if(wb.SSF) {
			make_ssf(SSF); SSF.load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
			opts.cellXfs = [];
			get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
		}
		var d = [];
		d.push(write_props_xlml(wb, opts));
		d.push(write_wb_xlml(wb, opts));
		d.push("");
		d.push("");
		for(var i = 0; i < wb.SheetNames.length; ++i)
			d.push(writextag("Worksheet", write_ws_xlml(i, opts, wb), {"ss:Name":escapexml(wb.SheetNames[i])}));
		d[2] = write_sty_xlml(wb, opts);
		d[3] = write_names_xlml(wb, opts);
		return XML_HEADER + writextag("Workbook", d.join(""), {
			'xmlns':      XLMLNS.ss,
			'xmlns:o':    XLMLNS.o,
			'xmlns:x':    XLMLNS.x,
			'xmlns:ss':   XLMLNS.ss,
			'xmlns:dt':   XLMLNS.dt,
			'xmlns:html': XLMLNS.html
		});
	}
	/* [MS-OLEDS] 2.3.8 CompObjStream */
	function parse_compobj(obj) {
		var v = {};
		var o = obj.content;
	/* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */
		o.l = 28;
	
		v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
		v.AnsiClipboardFormat = parse_ClipboardFormatOrAnsiString(o);
	
		if(o.length - o.l <= 4) return v;
	
		var m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved1 = o.read_shift(0, "lpstr-ansi");
	
		if(o.length - o.l <= 4) return v;
		m = o.read_shift(4);
		if(m !== 0x71b239f4) return v;
		v.UnicodeClipboardFormat = parse_ClipboardFormatOrUnicodeString(o);
	
		m = o.read_shift(4);
		if(m == 0 || m > 40) return v;
		o.l-=4; v.Reserved2 = o.read_shift(0, "lpwstr");
	}
	
	/*
		Continue logic for:
		- 2.4.58 Continue
		- 2.4.59 ContinueBigName
		- 2.4.60 ContinueFrt
		- 2.4.61 ContinueFrt11
		- 2.4.62 ContinueFrt12
	*/
	function slurp(R, blob, length, opts) {
		var l = length;
		var bufs = [];
		var d = blob.slice(blob.l,blob.l+l);
		if(opts && opts.enc && opts.enc.insitu && d.length > 0) switch(R.n) {
		case 'BOF': case 'FilePass': case 'FileLock': case 'InterfaceHdr': case 'RRDInfo': case 'RRDHead': case 'UsrExcl': case 'EOF':
			break;
		case 'BoundSheet8':
			break;
		default:
			opts.enc.insitu(d);
		}
		bufs.push(d);
		blob.l += l;
		var next = (XLSRecordEnum[__readUInt16LE(blob,blob.l)]);
		var start = 0;
		while(next != null && next.n.slice(0,8) === 'Continue') {
			l = __readUInt16LE(blob,blob.l+2);
			start = blob.l + 4;
			if(next.n == 'ContinueFrt') start += 4;
			else if(next.n.slice(0,11) == 'ContinueFrt') {
				start += 12;
			}
			d = blob.slice(start,blob.l+4+l);
			bufs.push(d);
			blob.l += 4+l;
			next = (XLSRecordEnum[__readUInt16LE(blob, blob.l)]);
		}
		var b = (bconcat(bufs));
		prep_blob(b, 0);
		var ll = 0; b.lens = [];
		for(var j = 0; j < bufs.length; ++j) { b.lens.push(ll); ll += bufs[j].length; }
		if(b.length < length) throw "XLS Record " + (R && R.n || "??") + " Truncated: " + b.length + " < " + length;
		return R.f(b, b.length, opts);
	}
	
	function safe_format_xf(p, opts, date1904) {
		if(p.t === 'z') return;
		if(!p.XF) return;
		var fmtid = 0;
		try {
			fmtid = p.z || p.XF.numFmtId || 0;
			if(opts.cellNF) p.z = SSF._table[fmtid];
		} catch(e) { if(opts.WTF) throw e; }
		if(!opts || opts.cellText !== false) try {
			if(p.t === 'e') { p.w = p.w || BErr[p.v]; }
			else if(fmtid === 0 || fmtid == "General") {
				if(p.t === 'n') {
					if((p.v|0) === p.v) p.w = SSF._general_int(p.v);
					else p.w = SSF._general_num(p.v);
				}
				else p.w = SSF._general(p.v);
			}
			else p.w = SSF.format(fmtid,p.v, {date1904:!!date1904, dateNF: opts && opts.dateNF});
		} catch(e) { if(opts.WTF) throw e; }
		if(opts.cellDates && fmtid && p.t == 'n' && SSF.is_date(SSF._table[fmtid] || String(fmtid))) {
			var _d = SSF.parse_date_code(p.v); if(_d) { p.t = 'd'; p.v = new Date(_d.y, _d.m-1,_d.d,_d.H,_d.M,_d.S,_d.u); }
		}
	}
	
	function make_cell(val, ixfe, t) {
		return ({v:val, ixfe:ixfe, t:t});
	}
	
	// 2.3.2
	function parse_workbook(blob, options) {
		var wb = ({opts:{}});
		var Sheets = {};
		if(DENSE != null && options.dense == null) options.dense = DENSE;
		var out = ((options.dense ? [] : {}));
		var Directory = {};
		var range = ({});
		var last_formula = null;
		var sst = ([]);
		var cur_sheet = "";
		var Preamble = {};
		var lastcell, last_cell = "", cc, cmnt, rngC, rngR;
		var sharedf = {};
		var arrayf = [];
		var temp_val;
		var country;
		var XFs = []; /* XF records */
		var palette = [];
		var Workbook = ({ Sheets:[], WBProps:{date1904:false}, Views:[{}] }), wsprops = {};
		var get_rgb = function getrgb(icv) {
			if(icv < 8) return XLSIcv[icv];
			if(icv < 64) return palette[icv-8] || XLSIcv[icv];
			return XLSIcv[icv];
		};
		var process_cell_style = function pcs(cell, line, options) {
			var xfd = line.XF.data;
			if(!xfd || !xfd.patternType || !options || !options.cellStyles) return;
			line.s = ({});
			line.s.patternType = xfd.patternType;
			var t;
			if((t = rgb2Hex(get_rgb(xfd.icvFore)))) { line.s.fgColor = {rgb:t}; }
			if((t = rgb2Hex(get_rgb(xfd.icvBack)))) { line.s.bgColor = {rgb:t}; }
		};
		var addcell = function addcell(cell, line, options) {
			if(file_depth > 1) return;
			if(options.sheetRows && cell.r >= options.sheetRows) return;
			if(options.cellStyles && line.XF && line.XF.data) process_cell_style(cell, line, options);
			delete line.ixfe; delete line.XF;
			lastcell = cell;
			last_cell = encode_cell(cell);
			if(!range || !range.s || !range.e) range = {s:{r:0,c:0},e:{r:0,c:0}};
			if(cell.r < range.s.r) range.s.r = cell.r;
			if(cell.c < range.s.c) range.s.c = cell.c;
			if(cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
			if(cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
			if(options.cellFormula && line.f) {
				for(var afi = 0; afi < arrayf.length; ++afi) {
					if(arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
					if(arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
					line.F = encode_range(arrayf[afi][0]);
					if(arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
					if(line.f) line.f = "" + stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
					break;
				}
			}
			{
				if(options.dense) {
					if(!out[cell.r]) out[cell.r] = [];
					out[cell.r][cell.c] = line;
				} else out[last_cell] = line;
			}
		};
		var opts = ({
			enc: false, // encrypted
			sbcch: 0, // cch in the preceding SupBook
			snames: [], // sheetnames
			sharedf: sharedf, // shared formulae by address
			arrayf: arrayf, // array formulae array
			rrtabid: [], // RRTabId
			lastuser: "", // Last User from WriteAccess
			biff: 8, // BIFF version
			codepage: 0, // CP from CodePage record
			winlocked: 0, // fLockWn from WinProtect
			cellStyles: !!options && !!options.cellStyles,
			WTF: !!options && !!options.wtf
		});
		if(options.password) opts.password = options.password;
		var themes;
		var merges = [];
		var objects = [];
		var colinfo = [], rowinfo = [];
		// eslint-disable-next-line no-unused-vars
		var defwidth = 0, defheight = 0; // twips / MDW respectively
		var seencol = false;
		var supbooks = ([]); // 1-indexed, will hold extern names
		supbooks.SheetNames = opts.snames;
		supbooks.sharedf = opts.sharedf;
		supbooks.arrayf = opts.arrayf;
		supbooks.names = [];
		supbooks.XTI = [];
		var last_Rn = '';
		var file_depth = 0; /* TODO: make a real stack */
		var BIFF2Fmt = 0, BIFF2FmtTable = [];
		var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */
		var last_lbl;
	
		/* explicit override for some broken writers */
		opts.codepage = 1200;
		set_cp(1200);
		var seen_codepage = false;
		while(blob.l < blob.length - 1) {
			var s = blob.l;
			var RecordType = blob.read_shift(2);
			if(RecordType === 0 && last_Rn === 'EOF') break;
			var length = (blob.l === blob.length ? 0 : blob.read_shift(2));
			var R = XLSRecordEnum[RecordType];
			//console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
			//if(!R) console.log(blob.slice(blob.l, blob.l + length));
			if(R && R.f) {
				if(options.bookSheets) {
					if(last_Rn === 'BoundSheet8' && R.n !== 'BoundSheet8') break;
				}
				last_Rn = R.n;
				if(R.r === 2 || R.r == 12) {
					var rt = blob.read_shift(2); length -= 2;
					if(!opts.enc && rt !== RecordType && (((rt&0xFF)<<8)|(rt>>8)) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
					if(R.r == 12){
						blob.l += 10; length -= 10;
					} // skip FRT
				}
				//console.error(R,blob.l,length,blob.length);
				var val = ({});
				if(R.n === 'EOF') val = R.f(blob, length, opts);
				else val = slurp(R, blob, length, opts);
				var Rn = R.n;
	if(file_depth == 0 && Rn != 'BOF') continue;
				/* nested switch statements to workaround V8 128 limit */
				switch(Rn) {
					/* Workbook Options */
					case 'Date1904':
	wb.opts.Date1904 = Workbook.WBProps.date1904 = val; break;
					case 'WriteProtect': wb.opts.WriteProtect = true; break;
					case 'FilePass':
						if(!opts.enc) blob.l = 0;
						opts.enc = val;
						if(!options.password) throw new Error("File is password-protected");
						if(val.valid == null) throw new Error("Encryption scheme unsupported");
						if(!val.valid) throw new Error("Password is incorrect");
						break;
					case 'WriteAccess': opts.lastuser = val; break;
					case 'FileSharing': break; //TODO
					case 'CodePage':
						var cpval = Number(val);
						/* overrides based on test cases */
						switch(cpval) {
							case 0x5212: cpval =  1200; break;
							case 0x8000: cpval = 10000; break;
							case 0x8001: cpval =  1252; break;
						}
						set_cp(opts.codepage = cpval);
						seen_codepage = true;
						break;
					case 'RRTabId': opts.rrtabid = val; break;
					case 'WinProtect': opts.winlocked = val; break;
					case 'Template': break; // TODO
					case 'BookBool': break; // TODO
					case 'UsesELFs': break;
					case 'MTRSettings': break;
					case 'RefreshAll':
					case 'CalcCount':
					case 'CalcDelta':
					case 'CalcIter':
					case 'CalcMode':
					case 'CalcPrecision':
					case 'CalcSaveRecalc':
						wb.opts[Rn] = val; break;
					case 'CalcRefMode': opts.CalcRefMode = val; break; // TODO: implement R1C1
					case 'Uncalced': break;
					case 'ForceFullCalculation': wb.opts.FullCalc = val; break;
					case 'WsBool':
						if(val.fDialog) out["!type"] = "dialog";
						if(!val.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
						if(!val.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
						break; // TODO
					case 'XF':
						XFs.push(val); break;
					case 'ExtSST': break; // TODO
					case 'BookExt': break; // TODO
					case 'RichTextStream': break;
					case 'BkHim': break;
	
					case 'SupBook':
						supbooks.push([val]);
						supbooks[supbooks.length-1].XTI = [];
						break;
					case 'ExternName':
						supbooks[supbooks.length-1].push(val);
						break;
					case 'Index': break; // TODO
					case 'Lbl':
						last_lbl = ({
							Name: val.Name,
							Ref: stringify_formula(val.rgce,range,null,supbooks,opts)
						});
						if(val.itab > 0) last_lbl.Sheet = val.itab - 1;
						supbooks.names.push(last_lbl);
						if(!supbooks[0]) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length-1].push(val);
						if(val.Name == "_xlnm._FilterDatabase" && val.itab > 0)
							if(val.rgce && val.rgce[0] && val.rgce[0][0] && val.rgce[0][0][0] == 'PtgArea3d')
								FilterDatabases[val.itab - 1] = { ref: encode_range(val.rgce[0][0][1][2]) };
						break;
					case 'ExternCount': opts.ExternCount = val; break;
					case 'ExternSheet':
						if(supbooks.length == 0) { supbooks[0] = []; supbooks[0].XTI = []; }
						supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val); supbooks.XTI = supbooks.XTI.concat(val); break;
					case 'NameCmt':
						/* TODO: search for correct name */
						if(opts.biff < 8) break;
						if(last_lbl != null) last_lbl.Comment = val[1];
						break;
	
					case 'Protect': out["!protect"] = val; break; /* for sheet or book */
					case 'Password': if(val !== 0 && opts.WTF) console.error("Password verifier: " + val); break;
					case 'Prot4Rev': case 'Prot4RevPass': break; /*TODO: Revision Control*/
	
					case 'BoundSheet8': {
						Directory[val.pos] = val;
						opts.snames.push(val.name);
					} break;
					case 'EOF': {
						if(--file_depth) break;
						if(range.e) {
							if(range.e.r > 0 && range.e.c > 0) {
								range.e.r--; range.e.c--;
								out["!ref"] = encode_range(range);
								if(options.sheetRows && options.sheetRows <= range.e.r) {
									var tmpri = range.e.r;
									range.e.r = options.sheetRows - 1;
									out["!fullref"] = out["!ref"];
									out["!ref"] = encode_range(range);
									range.e.r = tmpri;
								}
								range.e.r++; range.e.c++;
							}
							if(merges.length > 0) out["!merges"] = merges;
							if(objects.length > 0) out["!objects"] = objects;
							if(colinfo.length > 0) out["!cols"] = colinfo;
							if(rowinfo.length > 0) out["!rows"] = rowinfo;
							Workbook.Sheets.push(wsprops);
						}
						if(cur_sheet === "") Preamble = out; else Sheets[cur_sheet] = out;
						out = ((options.dense ? [] : {}));
					} break;
					case 'BOF': {
						if(opts.biff === 8) opts.biff = {
	0x0009:2,
	0x0209:3,
	0x0409:4
						}[RecordType] || {
	0x0200:2,
	0x0300:3,
	0x0400:4,
	0x0500:5,
	0x0600:8,
	0x0002:2,
	0x0007:2
						}[val.BIFFVer] || 8;
						opts.biffguess = val.BIFFVer == 0;
						if(val.BIFFVer == 0 && val.dt == 0x1000) { opts.biff = 5; seen_codepage = true; set_cp(opts.codepage = 28591); }
						if(opts.biff == 8 && val.BIFFVer == 0 && val.dt == 16) opts.biff = 2;
						if(file_depth++) break;
						out = ((options.dense ? [] : {}));
	
						if(opts.biff < 8 && !seen_codepage) { seen_codepage = true; set_cp(opts.codepage = options.codepage || 1252); }
	
						if(opts.biff < 5 || val.BIFFVer == 0 && val.dt == 0x1000) {
							if(cur_sheet === "") cur_sheet = "Sheet1";
							range = {s:{r:0,c:0},e:{r:0,c:0}};
							/* fake BoundSheet8 */
							var fakebs8 = {pos: blob.l - length, name:cur_sheet};
							Directory[fakebs8.pos] = fakebs8;
							opts.snames.push(cur_sheet);
						}
						else cur_sheet = (Directory[s] || {name:""}).name;
						if(val.dt == 0x20) out["!type"] = "chart";
						if(val.dt == 0x40) out["!type"] = "macro";
						merges = [];
						objects = [];
						opts.arrayf = arrayf = [];
						colinfo = []; rowinfo = [];
						defwidth = defheight = 0;
						seencol = false;
						wsprops = {Hidden:(Directory[s]||{hs:0}).hs, name:cur_sheet };
					} break;
	
					case 'Number': case 'BIFF2NUM': case 'BIFF2INT': {
						if(out["!type"] == "chart") if(options.dense ? (out[val.r]||[])[val.c]: out[encode_cell({c:val.c, r:val.r})]) ++val.c;
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe]||{}, v:val.val, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'BoolErr': {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.val, t:val.t});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'RK': {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], v:val.rknum, t:'n'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'MulRk': {
						for(var j = val.c; j <= val.C; ++j) {
							var ixfe = val.rkrec[j-val.c][0];
							temp_val= ({ixfe:ixfe, XF:XFs[ixfe], v:val.rkrec[j-val.c][1], t:'n'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:j, r:val.r}, temp_val, options);
						}
					} break;
					case 'Formula': {
						if(val.val == 'String') { last_formula = val; break; }
						temp_val = make_cell(val.val, val.cell.ixfe, val.tt);
						temp_val.XF = XFs[temp_val.ixfe];
						if(options.cellFormula) {
							var _f = val.formula;
							if(_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
								var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
								var _fe = encode_cell({r:_fr, c:_fc});
								if(sharedf[_fe]) temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
								else temp_val.F = ((options.dense ? (out[_fr]||[])[_fc]: out[_fe]) || {}).F;
							} else temp_val.f = ""+stringify_formula(val.formula,range,val.cell,supbooks, opts);
						}
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell(val.cell, temp_val, options);
						last_formula = val;
					} break;
					case 'String': {
						if(last_formula) { /* technically always true */
							last_formula.val = val;
							temp_val = make_cell(val, last_formula.cell.ixfe, 's');
							temp_val.XF = XFs[temp_val.ixfe];
							if(options.cellFormula) {
								temp_val.f = ""+stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
							}
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell(last_formula.cell, temp_val, options);
							last_formula = null;
						} else throw new Error("String record expects Formula");
					} break;
					case 'Array': {
						arrayf.push(val);
						var _arraystart = encode_cell(val[0].s);
						cc = options.dense ? (out[val[0].s.r]||[])[val[0].s.c] : out[_arraystart];
						if(options.cellFormula && cc) {
							if(!last_formula) break; /* technically unreachable */
							if(!_arraystart || !cc) break;
							cc.f = ""+stringify_formula(val[1], range, val[0], supbooks, opts);
							cc.F = encode_range(val[0]);
						}
					} break;
					case 'ShrFmla': {
						if(!options.cellFormula) break;
						if(last_cell) {
							/* TODO: capture range */
							if(!last_formula) break; /* technically unreachable */
							sharedf[encode_cell(last_formula.cell)]= val[0];
							cc = options.dense ? (out[last_formula.cell.r]||[])[last_formula.cell.c] : out[encode_cell(last_formula.cell)];
							(cc||{}).f = ""+stringify_formula(val[0], range, lastcell, supbooks, opts);
						}
					} break;
					case 'LabelSst':
						temp_val=make_cell(sst[val.isst].t, val.ixfe, 's');
						if(sst[val.isst].h) temp_val.h = sst[val.isst].h;
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
					case 'Blank': if(options.sheetStubs) {
						temp_val = ({ixfe: val.ixfe, XF: XFs[val.ixfe], t:'z'});
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
					} break;
					case 'MulBlank': if(options.sheetStubs) {
						for(var _j = val.c; _j <= val.C; ++_j) {
							var _ixfe = val.ixfe[_j-val.c];
							temp_val= ({ixfe:_ixfe, XF:XFs[_ixfe], t:'z'});
							if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
							safe_format_xf(temp_val, options, wb.opts.Date1904);
							addcell({c:_j, r:val.r}, temp_val, options);
						}
					} break;
					case 'RString':
					case 'Label': case 'BIFF2STR':
						temp_val=make_cell(val.val, val.ixfe, 's');
						temp_val.XF = XFs[temp_val.ixfe];
						if(BIFF2Fmt > 0) temp_val.z = BIFF2FmtTable[(temp_val.ixfe>>8) & 0x3F];
						safe_format_xf(temp_val, options, wb.opts.Date1904);
						addcell({c:val.c, r:val.r}, temp_val, options);
						break;
	
					case 'Dimensions': {
						if(file_depth === 1) range = val; /* TODO: stack */
					} break;
					case 'SST': {
						sst = val;
					} break;
					case 'Format': { /* val = [id, fmt] */
						if(opts.biff == 4) {
							BIFF2FmtTable[BIFF2Fmt++] = val[1];
							for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx) if(SSF._table[b4idx] == val[1]) break;
							if(b4idx >= 163) SSF.load(val[1], BIFF2Fmt + 163);
						}
						else SSF.load(val[1], val[0]);
					} break;
					case 'BIFF2FORMAT': {
						BIFF2FmtTable[BIFF2Fmt++] = val;
						for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx) if(SSF._table[b2idx] == val) break;
						if(b2idx >= 163) SSF.load(val, BIFF2Fmt + 163);
					} break;
	
					case 'MergeCells': merges = merges.concat(val); break;
	
					case 'Obj': objects[val.cmo[0]] = opts.lastobj = val; break;
					case 'TxO': opts.lastobj.TxO = val; break;
					case 'ImData': opts.lastobj.ImData = val; break;
	
					case 'HLink': {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc) cc.l = val[1];
							}
					} break;
					case 'HLinkTooltip': {
						for(rngR = val[0].s.r; rngR <= val[0].e.r; ++rngR)
							for(rngC = val[0].s.c; rngC <= val[0].e.c; ++rngC) {
								cc = options.dense ? (out[rngR]||[])[rngC] : out[encode_cell({c:rngC,r:rngR})];
								if(cc && cc.l) cc.l.Tooltip = val[1];
								}
					} break;
	
					/* Comments */
					case 'Note': {
						if(opts.biff <= 5 && opts.biff >= 2) break; /* TODO: BIFF5 */
						cc = options.dense ? (out[val[0].r]||[])[val[0].c] : out[encode_cell(val[0])];
						var noteobj = objects[val[2]];
						if(!cc) {
							if(options.dense) {
								if(!out[val[0].r]) out[val[0].r] = [];
								cc = out[val[0].r][val[0].c] = ({t:"z"});
							} else {
								cc = out[encode_cell(val[0])] = ({t:"z"});
							}
							range.e.r = Math.max(range.e.r, val[0].r);
							range.s.r = Math.min(range.s.r, val[0].r);
							range.e.c = Math.max(range.e.c, val[0].c);
							range.s.c = Math.min(range.s.c, val[0].c);
						}
						if(!cc.c) cc.c = [];
						cmnt = {a:val[1],t:noteobj.TxO.t};
						cc.c.push(cmnt);
					} break;
	
					default: switch(R.n) { /* nested */
					case 'ClrtClient': break;
					case 'XFExt': update_xfext(XFs[val.ixfe], val.ext); break;
	
					case 'DefColWidth': defwidth = val; break;
					case 'DefaultRowHeight': defheight = val[1]; break; // TODO: flags
	
					case 'ColInfo': {
						if(!opts.cellStyles) break;
						while(val.e >= val.s) {
							colinfo[val.e--] = { width: val.w/256, level: (val.level || 0), hidden: !!(val.flags & 1) };
							if(!seencol) { seencol = true; find_mdw_colw(val.w/256); }
							process_col(colinfo[val.e+1]);
						}
					} break;
					case 'Row': {
						var rowobj = {};
						if(val.level != null) { rowinfo[val.r] = rowobj; rowobj.level = val.level; }
						if(val.hidden) { rowinfo[val.r] = rowobj; rowobj.hidden = true; }
						if(val.hpt) {
							rowinfo[val.r] = rowobj;
							rowobj.hpt = val.hpt; rowobj.hpx = pt2px(val.hpt);
						}
					} break;
	
					case 'LeftMargin':
					case 'RightMargin':
					case 'TopMargin':
					case 'BottomMargin':
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'][Rn.slice(0,-6).toLowerCase()] = val;
						break;
	
					case 'Selection': break;
	
					case 'Setup': // TODO
						if(!out['!margins']) default_margins(out['!margins'] = {});
						out['!margins'].header = val.header;
						out['!margins'].footer = val.footer;
						break;
	
					case 'Window2': // TODO
						// $FlowIgnore
						if(val.RTL) Workbook.Views[0].RTL = true;
						break;
	
					case 'Header': break; // TODO
					case 'Footer': break; // TODO
					case 'HCenter': break; // TODO
					case 'VCenter': break; // TODO
					case 'Pls': break; // TODO
					case 'GCW': break;
					case 'LHRecord': break;
					case 'DBCell': break; // TODO
					case 'EntExU2': break; // TODO
					case 'SxView': break; // TODO
					case 'Sxvd': break; // TODO
					case 'SXVI': break; // TODO
					case 'SXVDEx': break; // TODO
					case 'SxIvd': break; // TODO
					case 'SXString': break; // TODO
					case 'Sync': break;
					case 'Addin': break;
					case 'SXDI': break; // TODO
					case 'SXLI': break; // TODO
					case 'SXEx': break; // TODO
					case 'QsiSXTag': break; // TODO
					case 'Feat': break;
					case 'FeatHdr': case 'FeatHdr11': break;
					case 'Feature11': case 'Feature12': case 'List12': break;
					case 'Country': country = val; break;
					case 'RecalcId': break;
					case 'DxGCol': break; // TODO: htmlify
					case 'Fbi': case 'Fbi2': case 'GelFrame': break;
					case 'Font': break; // TODO
					case 'XFCRC': break; // TODO
					case 'Style': break; // TODO
					case 'StyleExt': break; // TODO
					case 'Palette': palette = val; break;
					case 'Theme': themes = val; break;
					/* Protection */
					case 'ScenarioProtect': break;
					case 'ObjProtect': break;
	
					/* Conditional Formatting */
					case 'CondFmt12': break;
	
					/* Table */
					case 'Table': break; // TODO
					case 'TableStyles': break; // TODO
					case 'TableStyle': break; // TODO
					case 'TableStyleElement': break; // TODO
	
					/* PivotTable */
					case 'SXStreamID': break; // TODO
					case 'SXVS': break; // TODO
					case 'DConRef': break; // TODO
					case 'SXAddl': break; // TODO
					case 'DConBin': break; // TODO
					case 'DConName': break; // TODO
					case 'SXPI': break; // TODO
					case 'SxFormat': break; // TODO
					case 'SxSelect': break; // TODO
					case 'SxRule': break; // TODO
					case 'SxFilt': break; // TODO
					case 'SxItm': break; // TODO
					case 'SxDXF': break; // TODO
	
					/* Scenario Manager */
					case 'ScenMan': break;
	
					/* Data Consolidation */
					case 'DCon': break;
	
					/* Watched Cell */
					case 'CellWatch': break;
	
					/* Print Settings */
					case 'PrintRowCol': break;
					case 'PrintGrid': break;
					case 'PrintSize': break;
	
					case 'XCT': break;
					case 'CRN': break;
	
					case 'Scl': {
						//console.log("Zoom Level:", val[0]/val[1],val);
					} break;
					case 'SheetExt': {
						/* empty */
					} break;
					case 'SheetExtOptional': {
						/* empty */
					} break;
	
					/* VBA */
					case 'ObNoMacros': {
						/* empty */
					} break;
					case 'ObProj': {
						/* empty */
					} break;
					case 'CodeName': {
	if(!cur_sheet) Workbook.WBProps.CodeName = val || "ThisWorkbook";
						else wsprops.CodeName = val || wsprops.name;
					} break;
					case 'GUIDTypeLib': {
						/* empty */
					} break;
	
					case 'WOpt': break; // TODO: WTF?
					case 'PhoneticInfo': break;
	
					case 'OleObjectSize': break;
	
					/* Differential Formatting */
					case 'DXF': case 'DXFN': case 'DXFN12': case 'DXFN12List': case 'DXFN12NoCB': break;
	
					/* Data Validation */
					case 'Dv': case 'DVal': break;
	
					/* Data Series */
					case 'BRAI': case 'Series': case 'SeriesText': break;
	
					/* Data Connection */
					case 'DConn': break;
					case 'DbOrParamQry': break;
					case 'DBQueryExt': break;
	
					case 'OleDbConn': break;
					case 'ExtString': break;
	
					/* Formatting */
					case 'IFmtRecord': break;
					case 'CondFmt': case 'CF': case 'CF12': case 'CFEx': break;
	
					/* Explicitly Ignored */
					case 'Excel9File': break;
					case 'Units': break;
					case 'InterfaceHdr': case 'Mms': case 'InterfaceEnd': case 'DSF': break;
					case 'BuiltInFnGroupCount': /* 2.4.30 0x0E or 0x10 but excel 2011 generates 0x11? */ break;
					/* View Stuff */
					case 'Window1': case 'HideObj': case 'GridSet': case 'Guts':
					case 'UserBView': case 'UserSViewBegin': case 'UserSViewEnd': break;
					case 'Pane': break;
					default: switch(R.n) { /* nested */
					/* Chart */
					case 'Dat':
					case 'Begin': case 'End':
					case 'StartBlock': case 'EndBlock':
					case 'Frame': case 'Area':
					case 'Axis': case 'AxisLine': case 'Tick': break;
					case 'AxesUsed':
					case 'CrtLayout12': case 'CrtLayout12A': case 'CrtLink': case 'CrtLine': case 'CrtMlFrt': case 'CrtMlFrtContinue': break;
					case 'LineFormat': case 'AreaFormat':
					case 'Chart': case 'Chart3d': case 'Chart3DBarShape': case 'ChartFormat': case 'ChartFrtInfo': break;
					case 'PlotArea': case 'PlotGrowth': break;
					case 'SeriesList': case 'SerParent': case 'SerAuxTrend': break;
					case 'DataFormat': case 'SerToCrt': case 'FontX': break;
					case 'CatSerRange': case 'AxcExt': case 'SerFmt': break;
					case 'ShtProps': break;
					case 'DefaultText': case 'Text': case 'CatLab': break;
					case 'DataLabExtContents': break;
					case 'Legend': case 'LegendException': break;
					case 'Pie': case 'Scatter': break;
					case 'PieFormat': case 'MarkerFormat': break;
					case 'StartObject': case 'EndObject': break;
					case 'AlRuns': case 'ObjectLink': break;
					case 'SIIndex': break;
					case 'AttachedLabel': case 'YMult': break;
	
					/* Chart Group */
					case 'Line': case 'Bar': break;
					case 'Surf': break;
	
					/* Axis Group */
					case 'AxisParent': break;
					case 'Pos': break;
					case 'ValueRange': break;
	
					/* Pivot Chart */
					case 'SXViewEx9': break; // TODO
					case 'SXViewLink': break;
					case 'PivotChartBits': break;
					case 'SBaseRef': break;
					case 'TextPropsStream': break;
	
					/* Chart Misc */
					case 'LnExt': break;
					case 'MkrExt': break;
					case 'CrtCoopt': break;
	
					/* Query Table */
					case 'Qsi': case 'Qsif': case 'Qsir': case 'QsiSXTag': break;
					case 'TxtQry': break;
	
					/* Filter */
					case 'FilterMode': break;
					case 'AutoFilter': case 'AutoFilterInfo': break;
					case 'AutoFilter12': break;
					case 'DropDownObjIds': break;
					case 'Sort': break;
					case 'SortData': break;
	
					/* Drawing */
					case 'ShapePropsStream': break;
					case 'MsoDrawing': case 'MsoDrawingGroup': case 'MsoDrawingSelection': break;
					/* Pub Stuff */
					case 'WebPub': case 'AutoWebPub': break;
	
					/* Print Stuff */
					case 'HeaderFooter': case 'HFPicture': case 'PLV':
					case 'HorizontalPageBreaks': case 'VerticalPageBreaks': break;
					/* Behavioral */
					case 'Backup': case 'CompressPictures': case 'Compat12': break;
	
					/* Should not Happen */
					case 'Continue': case 'ContinueFrt12': break;
	
					/* Future Records */
					case 'FrtFontList': case 'FrtWrapper': break;
	
					default: switch(R.n) { /* nested */
					/* BIFF5 records */
					case 'TabIdConf': case 'Radar': case 'RadarArea': case 'DropBar': case 'Intl': case 'CoordList': case 'SerAuxErrBar': break;
	
					/* BIFF2-4 records */
					case 'BIFF2FONTCLR': case 'BIFF2FMTCNT': case 'BIFF2FONTXTRA': break;
					case 'BIFF2XF': case 'BIFF3XF': case 'BIFF4XF': break;
					case 'BIFF2XFINDEX': break;
					case 'BIFF4FMTCNT': case 'BIFF2ROW': case 'BIFF2WINDOW2': break;
	
					/* Miscellaneous */
					case 'SCENARIO': case 'DConBin': case 'PicF': case 'DataLabExt':
					case 'Lel': case 'BopPop': case 'BopPopCustom': case 'RealTimeData':
					case 'Name': break;
					case 'LHNGraph': case 'FnGroupName': case 'AddMenu': case 'LPr': break;
					case 'ListObj': case 'ListField': break;
					case 'RRSort': break;
					case 'BigName': break;
					case 'ToolbarHdr': case 'ToolbarEnd': break;
					case 'DDEObjName': break;
					case 'FRTArchId$': break;
					default: if(options.WTF) throw 'Unrecognized Record ' + R.n;
				}}}}
			} else blob.l += length;
		}
		wb.SheetNames=keys(Directory).sort(function(a,b) { return Number(a) - Number(b); }).map(function(x){return Directory[x].name;});
		if(!options.bookSheets) wb.Sheets=Sheets;
		if(!wb.SheetNames.length && Preamble["!ref"]) {
			wb.SheetNames.push("Sheet1");
			/*jshint -W069 */
			if(wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
			/*jshint +W069 */
		} else wb.Preamble=Preamble;
		if(wb.Sheets) FilterDatabases.forEach(function(r,i) { wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r; });
		wb.Strings = sst;
		wb.SSF = SSF.get_table();
		if(opts.enc) wb.Encryption = opts.enc;
		if(themes) wb.Themes = themes;
		wb.Metadata = {};
		if(country !== undefined) wb.Metadata.Country = country;
		if(supbooks.names.length > 0) Workbook.Names = supbooks.names;
		wb.Workbook = Workbook;
		return wb;
	}
	
	/* TODO: split props*/
	var PSCLSID = {
		SI: "e0859ff2f94f6810ab9108002b27b3d9",
		DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
		UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
	};
	function parse_xls_props(cfb, props, o) {
		/* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */
		var DSI = CFB.find(cfb, '!DocumentSummaryInformation');
		if(DSI && DSI.size > 0) try {
			var DocSummary = parse_PropertySetStream(DSI, DocSummaryPIDDSI, PSCLSID.DSI);
			for(var d in DocSummary) props[d] = DocSummary[d];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		/* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/
		var SI = CFB.find(cfb, '!SummaryInformation');
		if(SI && SI.size > 0) try {
			var Summary = parse_PropertySetStream(SI, SummaryPIDSI, PSCLSID.SI);
			for(var s in Summary) if(props[s] == null) props[s] = Summary[s];
		} catch(e) {if(o.WTF) throw e;/* empty */}
	
		if(props.HeadingPairs && props.TitlesOfParts) {
			load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
			delete props.HeadingPairs; delete props.TitlesOfParts;
		}
	}
	function write_xls_props(wb, cfb) {
		var DSEntries = [], SEntries = [], CEntries = [];
		var i = 0, Keys;
		if(wb.Props) {
			Keys = keys(wb.Props);
			// $FlowIgnore
			for(i = 0; i < Keys.length; ++i) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Props[Keys[i]]]);
		}
		if(wb.Custprops) {
			Keys = keys(wb.Custprops);
			// $FlowIgnore
			for(i = 0; i < Keys.length; ++i) if(!Object.prototype.hasOwnProperty.call((wb.Props||{}), Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([Keys[i], wb.Custprops[Keys[i]]]);
		}
		var CEntries2 = [];
		for(i = 0; i < CEntries.length; ++i) {
			if(XLSPSSkip.indexOf(CEntries[i][0]) > -1) continue;
			if(CEntries[i][1] == null) continue;
			CEntries2.push(CEntries[i]);
		}
		if(SEntries.length) CFB.utils.cfb_add(cfb, "/\u0005SummaryInformation", write_PropertySetStream(SEntries, PSCLSID.SI, SummaryRE, SummaryPIDSI));
		if(DSEntries.length || CEntries2.length) CFB.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", write_PropertySetStream(DSEntries, PSCLSID.DSI, DocSummaryRE, DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, PSCLSID.UDI));
	}
	
	function parse_xlscfb(cfb, options) {
	if(!options) options = {};
	fix_read_opts(options);
	reset_cp();
	if(options.codepage) set_ansi(options.codepage);
	var CompObj, WB;
	if(cfb.FullPaths) {
		if(CFB.find(cfb, '/encryption')) throw new Error("File is password-protected");
		CompObj = CFB.find(cfb, '!CompObj');
		WB = CFB.find(cfb, '/Workbook') || CFB.find(cfb, '/Book');
	} else {
		switch(options.type) {
			case 'base64': cfb = s2a(Base64.decode(cfb)); break;
			case 'binary': cfb = s2a(cfb); break;
			case 'buffer': break;
			case 'array': if(!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb); break;
		}
		prep_blob(cfb, 0);
		WB = ({content: cfb});
	}
	var WorkbookP;
	
	var _data;
	if(CompObj) parse_compobj(CompObj);
	if(options.bookProps && !options.bookSheets) WorkbookP = ({});
	else {
		var T = has_buf ? 'buffer' : 'array';
		if(WB && WB.content) WorkbookP = parse_workbook(WB.content, options);
		/* Quattro Pro 7-8 */
		else if((_data=CFB.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		/* Quattro Pro 9 */
		else if((_data=CFB.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = WK_.to_workbook(_data.content, (options.type = T, options));
		/* Works 4 for Mac */
		else if((_data=CFB.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
		else throw new Error("Cannot find Workbook stream");
		if(options.bookVBA && cfb.FullPaths && CFB.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = make_vba_xls(cfb);
	}
	
	var props = {};
	if(cfb.FullPaths) parse_xls_props(cfb, props, options);
	
	WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */
	if(options.bookFiles) WorkbookP.cfb = cfb;
	/*WorkbookP.CompObjP = CompObjP; // TODO: storage? */
	return WorkbookP;
	}
	
	
	function write_xlscfb(wb, opts) {
		var o = opts || {};
		var cfb = CFB.utils.cfb_new({root:"R"});
		var wbpath = "/Workbook";
		switch(o.bookType || "xls") {
			case "xls": o.bookType = "biff8";
			/* falls through */
			case "xla": if(!o.bookType) o.bookType = "xla";
			/* falls through */
			case "biff8": wbpath = "/Workbook"; o.biff = 8; break;
			case "biff5": wbpath = "/Book"; o.biff = 5; break;
			default: throw new Error("invalid type " + o.bookType + " for XLS CFB");
		}
		CFB.utils.cfb_add(cfb, wbpath, write_biff_buf(wb, o));
		if(o.biff == 8 && (wb.Props || wb.Custprops)) write_xls_props(wb, cfb);
		// TODO: SI, DSI, CO
		if(o.biff == 8 && wb.vbaraw) fill_vba_xls(cfb, CFB.read(wb.vbaraw, {type: typeof wb.vbaraw == "string" ? "binary" : "buffer"}));
		return cfb;
	}
	/* [MS-XLSB] 2.3 Record Enumeration */
	var XLSBRecordEnum = {
	0x0000: { n:"BrtRowHdr", f:parse_BrtRowHdr },
	0x0001: { n:"BrtCellBlank", f:parse_BrtCellBlank },
	0x0002: { n:"BrtCellRk", f:parse_BrtCellRk },
	0x0003: { n:"BrtCellError", f:parse_BrtCellError },
	0x0004: { n:"BrtCellBool", f:parse_BrtCellBool },
	0x0005: { n:"BrtCellReal", f:parse_BrtCellReal },
	0x0006: { n:"BrtCellSt", f:parse_BrtCellSt },
	0x0007: { n:"BrtCellIsst", f:parse_BrtCellIsst },
	0x0008: { n:"BrtFmlaString", f:parse_BrtFmlaString },
	0x0009: { n:"BrtFmlaNum", f:parse_BrtFmlaNum },
	0x000A: { n:"BrtFmlaBool", f:parse_BrtFmlaBool },
	0x000B: { n:"BrtFmlaError", f:parse_BrtFmlaError },
	0x000C: { n:"BrtShortBlank", f:parse_BrtShortBlank },
	0x000D: { n:"BrtShortRk", f:parse_BrtShortRk },
	0x000E: { n:"BrtShortError", f:parse_BrtShortError },
	0x000F: { n:"BrtShortBool", f:parse_BrtShortBool },
	0x0010: { n:"BrtShortReal", f:parse_BrtShortReal },
	0x0011: { n:"BrtShortSt", f:parse_BrtShortSt },
	0x0012: { n:"BrtShortIsst", f:parse_BrtShortIsst },
	0x0013: { n:"BrtSSTItem", f:parse_RichStr },
	0x0014: { n:"BrtPCDIMissing" },
	0x0015: { n:"BrtPCDINumber" },
	0x0016: { n:"BrtPCDIBoolean" },
	0x0017: { n:"BrtPCDIError" },
	0x0018: { n:"BrtPCDIString" },
	0x0019: { n:"BrtPCDIDatetime" },
	0x001A: { n:"BrtPCDIIndex" },
	0x001B: { n:"BrtPCDIAMissing" },
	0x001C: { n:"BrtPCDIANumber" },
	0x001D: { n:"BrtPCDIABoolean" },
	0x001E: { n:"BrtPCDIAError" },
	0x001F: { n:"BrtPCDIAString" },
	0x0020: { n:"BrtPCDIADatetime" },
	0x0021: { n:"BrtPCRRecord" },
	0x0022: { n:"BrtPCRRecordDt" },
	0x0023: { n:"BrtFRTBegin" },
	0x0024: { n:"BrtFRTEnd" },
	0x0025: { n:"BrtACBegin" },
	0x0026: { n:"BrtACEnd" },
	0x0027: { n:"BrtName", f:parse_BrtName },
	0x0028: { n:"BrtIndexRowBlock" },
	0x002A: { n:"BrtIndexBlock" },
	0x002B: { n:"BrtFont", f:parse_BrtFont },
	0x002C: { n:"BrtFmt", f:parse_BrtFmt },
	0x002D: { n:"BrtFill", f:parse_BrtFill },
	0x002E: { n:"BrtBorder", f:parse_BrtBorder },
	0x002F: { n:"BrtXF", f:parse_BrtXF },
	0x0030: { n:"BrtStyle" },
	0x0031: { n:"BrtCellMeta" },
	0x0032: { n:"BrtValueMeta" },
	0x0033: { n:"BrtMdb" },
	0x0034: { n:"BrtBeginFmd" },
	0x0035: { n:"BrtEndFmd" },
	0x0036: { n:"BrtBeginMdx" },
	0x0037: { n:"BrtEndMdx" },
	0x0038: { n:"BrtBeginMdxTuple" },
	0x0039: { n:"BrtEndMdxTuple" },
	0x003A: { n:"BrtMdxMbrIstr" },
	0x003B: { n:"BrtStr" },
	0x003C: { n:"BrtColInfo", f:parse_ColInfo },
	0x003E: { n:"BrtCellRString" },
	0x003F: { n:"BrtCalcChainItem$", f:parse_BrtCalcChainItem$ },
	0x0040: { n:"BrtDVal", f:parse_BrtDVal },
	0x0041: { n:"BrtSxvcellNum" },
	0x0042: { n:"BrtSxvcellStr" },
	0x0043: { n:"BrtSxvcellBool" },
	0x0044: { n:"BrtSxvcellErr" },
	0x0045: { n:"BrtSxvcellDate" },
	0x0046: { n:"BrtSxvcellNil" },
	0x0080: { n:"BrtFileVersion" },
	0x0081: { n:"BrtBeginSheet" },
	0x0082: { n:"BrtEndSheet" },
	0x0083: { n:"BrtBeginBook", f:parsenoop, p:0 },
	0x0084: { n:"BrtEndBook" },
	0x0085: { n:"BrtBeginWsViews" },
	0x0086: { n:"BrtEndWsViews" },
	0x0087: { n:"BrtBeginBookViews" },
	0x0088: { n:"BrtEndBookViews" },
	0x0089: { n:"BrtBeginWsView", f:parse_BrtBeginWsView },
	0x008A: { n:"BrtEndWsView" },
	0x008B: { n:"BrtBeginCsViews" },
	0x008C: { n:"BrtEndCsViews" },
	0x008D: { n:"BrtBeginCsView" },
	0x008E: { n:"BrtEndCsView" },
	0x008F: { n:"BrtBeginBundleShs" },
	0x0090: { n:"BrtEndBundleShs" },
	0x0091: { n:"BrtBeginSheetData" },
	0x0092: { n:"BrtEndSheetData" },
	0x0093: { n:"BrtWsProp", f:parse_BrtWsProp },
	0x0094: { n:"BrtWsDim", f:parse_BrtWsDim, p:16 },
	0x0097: { n:"BrtPane", f:parse_BrtPane },
	0x0098: { n:"BrtSel" },
	0x0099: { n:"BrtWbProp", f:parse_BrtWbProp },
	0x009A: { n:"BrtWbFactoid" },
	0x009B: { n:"BrtFileRecover" },
	0x009C: { n:"BrtBundleSh", f:parse_BrtBundleSh },
	0x009D: { n:"BrtCalcProp" },
	0x009E: { n:"BrtBookView" },
	0x009F: { n:"BrtBeginSst", f:parse_BrtBeginSst },
	0x00A0: { n:"BrtEndSst" },
	0x00A1: { n:"BrtBeginAFilter", f:parse_UncheckedRfX },
	0x00A2: { n:"BrtEndAFilter" },
	0x00A3: { n:"BrtBeginFilterColumn" },
	0x00A4: { n:"BrtEndFilterColumn" },
	0x00A5: { n:"BrtBeginFilters" },
	0x00A6: { n:"BrtEndFilters" },
	0x00A7: { n:"BrtFilter" },
	0x00A8: { n:"BrtColorFilter" },
	0x00A9: { n:"BrtIconFilter" },
	0x00AA: { n:"BrtTop10Filter" },
	0x00AB: { n:"BrtDynamicFilter" },
	0x00AC: { n:"BrtBeginCustomFilters" },
	0x00AD: { n:"BrtEndCustomFilters" },
	0x00AE: { n:"BrtCustomFilter" },
	0x00AF: { n:"BrtAFilterDateGroupItem" },
	0x00B0: { n:"BrtMergeCell", f:parse_BrtMergeCell },
	0x00B1: { n:"BrtBeginMergeCells" },
	0x00B2: { n:"BrtEndMergeCells" },
	0x00B3: { n:"BrtBeginPivotCacheDef" },
	0x00B4: { n:"BrtEndPivotCacheDef" },
	0x00B5: { n:"BrtBeginPCDFields" },
	0x00B6: { n:"BrtEndPCDFields" },
	0x00B7: { n:"BrtBeginPCDField" },
	0x00B8: { n:"BrtEndPCDField" },
	0x00B9: { n:"BrtBeginPCDSource" },
	0x00BA: { n:"BrtEndPCDSource" },
	0x00BB: { n:"BrtBeginPCDSRange" },
	0x00BC: { n:"BrtEndPCDSRange" },
	0x00BD: { n:"BrtBeginPCDFAtbl" },
	0x00BE: { n:"BrtEndPCDFAtbl" },
	0x00BF: { n:"BrtBeginPCDIRun" },
	0x00C0: { n:"BrtEndPCDIRun" },
	0x00C1: { n:"BrtBeginPivotCacheRecords" },
	0x00C2: { n:"BrtEndPivotCacheRecords" },
	0x00C3: { n:"BrtBeginPCDHierarchies" },
	0x00C4: { n:"BrtEndPCDHierarchies" },
	0x00C5: { n:"BrtBeginPCDHierarchy" },
	0x00C6: { n:"BrtEndPCDHierarchy" },
	0x00C7: { n:"BrtBeginPCDHFieldsUsage" },
	0x00C8: { n:"BrtEndPCDHFieldsUsage" },
	0x00C9: { n:"BrtBeginExtConnection" },
	0x00CA: { n:"BrtEndExtConnection" },
	0x00CB: { n:"BrtBeginECDbProps" },
	0x00CC: { n:"BrtEndECDbProps" },
	0x00CD: { n:"BrtBeginECOlapProps" },
	0x00CE: { n:"BrtEndECOlapProps" },
	0x00CF: { n:"BrtBeginPCDSConsol" },
	0x00D0: { n:"BrtEndPCDSConsol" },
	0x00D1: { n:"BrtBeginPCDSCPages" },
	0x00D2: { n:"BrtEndPCDSCPages" },
	0x00D3: { n:"BrtBeginPCDSCPage" },
	0x00D4: { n:"BrtEndPCDSCPage" },
	0x00D5: { n:"BrtBeginPCDSCPItem" },
	0x00D6: { n:"BrtEndPCDSCPItem" },
	0x00D7: { n:"BrtBeginPCDSCSets" },
	0x00D8: { n:"BrtEndPCDSCSets" },
	0x00D9: { n:"BrtBeginPCDSCSet" },
	0x00DA: { n:"BrtEndPCDSCSet" },
	0x00DB: { n:"BrtBeginPCDFGroup" },
	0x00DC: { n:"BrtEndPCDFGroup" },
	0x00DD: { n:"BrtBeginPCDFGItems" },
	0x00DE: { n:"BrtEndPCDFGItems" },
	0x00DF: { n:"BrtBeginPCDFGRange" },
	0x00E0: { n:"BrtEndPCDFGRange" },
	0x00E1: { n:"BrtBeginPCDFGDiscrete" },
	0x00E2: { n:"BrtEndPCDFGDiscrete" },
	0x00E3: { n:"BrtBeginPCDSDTupleCache" },
	0x00E4: { n:"BrtEndPCDSDTupleCache" },
	0x00E5: { n:"BrtBeginPCDSDTCEntries" },
	0x00E6: { n:"BrtEndPCDSDTCEntries" },
	0x00E7: { n:"BrtBeginPCDSDTCEMembers" },
	0x00E8: { n:"BrtEndPCDSDTCEMembers" },
	0x00E9: { n:"BrtBeginPCDSDTCEMember" },
	0x00EA: { n:"BrtEndPCDSDTCEMember" },
	0x00EB: { n:"BrtBeginPCDSDTCQueries" },
	0x00EC: { n:"BrtEndPCDSDTCQueries" },
	0x00ED: { n:"BrtBeginPCDSDTCQuery" },
	0x00EE: { n:"BrtEndPCDSDTCQuery" },
	0x00EF: { n:"BrtBeginPCDSDTCSets" },
	0x00F0: { n:"BrtEndPCDSDTCSets" },
	0x00F1: { n:"BrtBeginPCDSDTCSet" },
	0x00F2: { n:"BrtEndPCDSDTCSet" },
	0x00F3: { n:"BrtBeginPCDCalcItems" },
	0x00F4: { n:"BrtEndPCDCalcItems" },
	0x00F5: { n:"BrtBeginPCDCalcItem" },
	0x00F6: { n:"BrtEndPCDCalcItem" },
	0x00F7: { n:"BrtBeginPRule" },
	0x00F8: { n:"BrtEndPRule" },
	0x00F9: { n:"BrtBeginPRFilters" },
	0x00FA: { n:"BrtEndPRFilters" },
	0x00FB: { n:"BrtBeginPRFilter" },
	0x00FC: { n:"BrtEndPRFilter" },
	0x00FD: { n:"BrtBeginPNames" },
	0x00FE: { n:"BrtEndPNames" },
	0x00FF: { n:"BrtBeginPName" },
	0x0100: { n:"BrtEndPName" },
	0x0101: { n:"BrtBeginPNPairs" },
	0x0102: { n:"BrtEndPNPairs" },
	0x0103: { n:"BrtBeginPNPair" },
	0x0104: { n:"BrtEndPNPair" },
	0x0105: { n:"BrtBeginECWebProps" },
	0x0106: { n:"BrtEndECWebProps" },
	0x0107: { n:"BrtBeginEcWpTables" },
	0x0108: { n:"BrtEndECWPTables" },
	0x0109: { n:"BrtBeginECParams" },
	0x010A: { n:"BrtEndECParams" },
	0x010B: { n:"BrtBeginECParam" },
	0x010C: { n:"BrtEndECParam" },
	0x010D: { n:"BrtBeginPCDKPIs" },
	0x010E: { n:"BrtEndPCDKPIs" },
	0x010F: { n:"BrtBeginPCDKPI" },
	0x0110: { n:"BrtEndPCDKPI" },
	0x0111: { n:"BrtBeginDims" },
	0x0112: { n:"BrtEndDims" },
	0x0113: { n:"BrtBeginDim" },
	0x0114: { n:"BrtEndDim" },
	0x0115: { n:"BrtIndexPartEnd" },
	0x0116: { n:"BrtBeginStyleSheet" },
	0x0117: { n:"BrtEndStyleSheet" },
	0x0118: { n:"BrtBeginSXView" },
	0x0119: { n:"BrtEndSXVI" },
	0x011A: { n:"BrtBeginSXVI" },
	0x011B: { n:"BrtBeginSXVIs" },
	0x011C: { n:"BrtEndSXVIs" },
	0x011D: { n:"BrtBeginSXVD" },
	0x011E: { n:"BrtEndSXVD" },
	0x011F: { n:"BrtBeginSXVDs" },
	0x0120: { n:"BrtEndSXVDs" },
	0x0121: { n:"BrtBeginSXPI" },
	0x0122: { n:"BrtEndSXPI" },
	0x0123: { n:"BrtBeginSXPIs" },
	0x0124: { n:"BrtEndSXPIs" },
	0x0125: { n:"BrtBeginSXDI" },
	0x0126: { n:"BrtEndSXDI" },
	0x0127: { n:"BrtBeginSXDIs" },
	0x0128: { n:"BrtEndSXDIs" },
	0x0129: { n:"BrtBeginSXLI" },
	0x012A: { n:"BrtEndSXLI" },
	0x012B: { n:"BrtBeginSXLIRws" },
	0x012C: { n:"BrtEndSXLIRws" },
	0x012D: { n:"BrtBeginSXLICols" },
	0x012E: { n:"BrtEndSXLICols" },
	0x012F: { n:"BrtBeginSXFormat" },
	0x0130: { n:"BrtEndSXFormat" },
	0x0131: { n:"BrtBeginSXFormats" },
	0x0132: { n:"BrtEndSxFormats" },
	0x0133: { n:"BrtBeginSxSelect" },
	0x0134: { n:"BrtEndSxSelect" },
	0x0135: { n:"BrtBeginISXVDRws" },
	0x0136: { n:"BrtEndISXVDRws" },
	0x0137: { n:"BrtBeginISXVDCols" },
	0x0138: { n:"BrtEndISXVDCols" },
	0x0139: { n:"BrtEndSXLocation" },
	0x013A: { n:"BrtBeginSXLocation" },
	0x013B: { n:"BrtEndSXView" },
	0x013C: { n:"BrtBeginSXTHs" },
	0x013D: { n:"BrtEndSXTHs" },
	0x013E: { n:"BrtBeginSXTH" },
	0x013F: { n:"BrtEndSXTH" },
	0x0140: { n:"BrtBeginISXTHRws" },
	0x0141: { n:"BrtEndISXTHRws" },
	0x0142: { n:"BrtBeginISXTHCols" },
	0x0143: { n:"BrtEndISXTHCols" },
	0x0144: { n:"BrtBeginSXTDMPS" },
	0x0145: { n:"BrtEndSXTDMPs" },
	0x0146: { n:"BrtBeginSXTDMP" },
	0x0147: { n:"BrtEndSXTDMP" },
	0x0148: { n:"BrtBeginSXTHItems" },
	0x0149: { n:"BrtEndSXTHItems" },
	0x014A: { n:"BrtBeginSXTHItem" },
	0x014B: { n:"BrtEndSXTHItem" },
	0x014C: { n:"BrtBeginMetadata" },
	0x014D: { n:"BrtEndMetadata" },
	0x014E: { n:"BrtBeginEsmdtinfo" },
	0x014F: { n:"BrtMdtinfo" },
	0x0150: { n:"BrtEndEsmdtinfo" },
	0x0151: { n:"BrtBeginEsmdb" },
	0x0152: { n:"BrtEndEsmdb" },
	0x0153: { n:"BrtBeginEsfmd" },
	0x0154: { n:"BrtEndEsfmd" },
	0x0155: { n:"BrtBeginSingleCells" },
	0x0156: { n:"BrtEndSingleCells" },
	0x0157: { n:"BrtBeginList" },
	0x0158: { n:"BrtEndList" },
	0x0159: { n:"BrtBeginListCols" },
	0x015A: { n:"BrtEndListCols" },
	0x015B: { n:"BrtBeginListCol" },
	0x015C: { n:"BrtEndListCol" },
	0x015D: { n:"BrtBeginListXmlCPr" },
	0x015E: { n:"BrtEndListXmlCPr" },
	0x015F: { n:"BrtListCCFmla" },
	0x0160: { n:"BrtListTrFmla" },
	0x0161: { n:"BrtBeginExternals" },
	0x0162: { n:"BrtEndExternals" },
	0x0163: { n:"BrtSupBookSrc", f:parse_RelID},
	0x0165: { n:"BrtSupSelf" },
	0x0166: { n:"BrtSupSame" },
	0x0167: { n:"BrtSupTabs" },
	0x0168: { n:"BrtBeginSupBook" },
	0x0169: { n:"BrtPlaceholderName" },
	0x016A: { n:"BrtExternSheet", f:parse_ExternSheet },
	0x016B: { n:"BrtExternTableStart" },
	0x016C: { n:"BrtExternTableEnd" },
	0x016E: { n:"BrtExternRowHdr" },
	0x016F: { n:"BrtExternCellBlank" },
	0x0170: { n:"BrtExternCellReal" },
	0x0171: { n:"BrtExternCellBool" },
	0x0172: { n:"BrtExternCellError" },
	0x0173: { n:"BrtExternCellString" },
	0x0174: { n:"BrtBeginEsmdx" },
	0x0175: { n:"BrtEndEsmdx" },
	0x0176: { n:"BrtBeginMdxSet" },
	0x0177: { n:"BrtEndMdxSet" },
	0x0178: { n:"BrtBeginMdxMbrProp" },
	0x0179: { n:"BrtEndMdxMbrProp" },
	0x017A: { n:"BrtBeginMdxKPI" },
	0x017B: { n:"BrtEndMdxKPI" },
	0x017C: { n:"BrtBeginEsstr" },
	0x017D: { n:"BrtEndEsstr" },
	0x017E: { n:"BrtBeginPRFItem" },
	0x017F: { n:"BrtEndPRFItem" },
	0x0180: { n:"BrtBeginPivotCacheIDs" },
	0x0181: { n:"BrtEndPivotCacheIDs" },
	0x0182: { n:"BrtBeginPivotCacheID" },
	0x0183: { n:"BrtEndPivotCacheID" },
	0x0184: { n:"BrtBeginISXVIs" },
	0x0185: { n:"BrtEndISXVIs" },
	0x0186: { n:"BrtBeginColInfos" },
	0x0187: { n:"BrtEndColInfos" },
	0x0188: { n:"BrtBeginRwBrk" },
	0x0189: { n:"BrtEndRwBrk" },
	0x018A: { n:"BrtBeginColBrk" },
	0x018B: { n:"BrtEndColBrk" },
	0x018C: { n:"BrtBrk" },
	0x018D: { n:"BrtUserBookView" },
	0x018E: { n:"BrtInfo" },
	0x018F: { n:"BrtCUsr" },
	0x0190: { n:"BrtUsr" },
	0x0191: { n:"BrtBeginUsers" },
	0x0193: { n:"BrtEOF" },
	0x0194: { n:"BrtUCR" },
	0x0195: { n:"BrtRRInsDel" },
	0x0196: { n:"BrtRREndInsDel" },
	0x0197: { n:"BrtRRMove" },
	0x0198: { n:"BrtRREndMove" },
	0x0199: { n:"BrtRRChgCell" },
	0x019A: { n:"BrtRREndChgCell" },
	0x019B: { n:"BrtRRHeader" },
	0x019C: { n:"BrtRRUserView" },
	0x019D: { n:"BrtRRRenSheet" },
	0x019E: { n:"BrtRRInsertSh" },
	0x019F: { n:"BrtRRDefName" },
	0x01A0: { n:"BrtRRNote" },
	0x01A1: { n:"BrtRRConflict" },
	0x01A2: { n:"BrtRRTQSIF" },
	0x01A3: { n:"BrtRRFormat" },
	0x01A4: { n:"BrtRREndFormat" },
	0x01A5: { n:"BrtRRAutoFmt" },
	0x01A6: { n:"BrtBeginUserShViews" },
	0x01A7: { n:"BrtBeginUserShView" },
	0x01A8: { n:"BrtEndUserShView" },
	0x01A9: { n:"BrtEndUserShViews" },
	0x01AA: { n:"BrtArrFmla", f:parse_BrtArrFmla },
	0x01AB: { n:"BrtShrFmla", f:parse_BrtShrFmla },
	0x01AC: { n:"BrtTable" },
	0x01AD: { n:"BrtBeginExtConnections" },
	0x01AE: { n:"BrtEndExtConnections" },
	0x01AF: { n:"BrtBeginPCDCalcMems" },
	0x01B0: { n:"BrtEndPCDCalcMems" },
	0x01B1: { n:"BrtBeginPCDCalcMem" },
	0x01B2: { n:"BrtEndPCDCalcMem" },
	0x01B3: { n:"BrtBeginPCDHGLevels" },
	0x01B4: { n:"BrtEndPCDHGLevels" },
	0x01B5: { n:"BrtBeginPCDHGLevel" },
	0x01B6: { n:"BrtEndPCDHGLevel" },
	0x01B7: { n:"BrtBeginPCDHGLGroups" },
	0x01B8: { n:"BrtEndPCDHGLGroups" },
	0x01B9: { n:"BrtBeginPCDHGLGroup" },
	0x01BA: { n:"BrtEndPCDHGLGroup" },
	0x01BB: { n:"BrtBeginPCDHGLGMembers" },
	0x01BC: { n:"BrtEndPCDHGLGMembers" },
	0x01BD: { n:"BrtBeginPCDHGLGMember" },
	0x01BE: { n:"BrtEndPCDHGLGMember" },
	0x01BF: { n:"BrtBeginQSI" },
	0x01C0: { n:"BrtEndQSI" },
	0x01C1: { n:"BrtBeginQSIR" },
	0x01C2: { n:"BrtEndQSIR" },
	0x01C3: { n:"BrtBeginDeletedNames" },
	0x01C4: { n:"BrtEndDeletedNames" },
	0x01C5: { n:"BrtBeginDeletedName" },
	0x01C6: { n:"BrtEndDeletedName" },
	0x01C7: { n:"BrtBeginQSIFs" },
	0x01C8: { n:"BrtEndQSIFs" },
	0x01C9: { n:"BrtBeginQSIF" },
	0x01CA: { n:"BrtEndQSIF" },
	0x01CB: { n:"BrtBeginAutoSortScope" },
	0x01CC: { n:"BrtEndAutoSortScope" },
	0x01CD: { n:"BrtBeginConditionalFormatting" },
	0x01CE: { n:"BrtEndConditionalFormatting" },
	0x01CF: { n:"BrtBeginCFRule" },
	0x01D0: { n:"BrtEndCFRule" },
	0x01D1: { n:"BrtBeginIconSet" },
	0x01D2: { n:"BrtEndIconSet" },
	0x01D3: { n:"BrtBeginDatabar" },
	0x01D4: { n:"BrtEndDatabar" },
	0x01D5: { n:"BrtBeginColorScale" },
	0x01D6: { n:"BrtEndColorScale" },
	0x01D7: { n:"BrtCFVO" },
	0x01D8: { n:"BrtExternValueMeta" },
	0x01D9: { n:"BrtBeginColorPalette" },
	0x01DA: { n:"BrtEndColorPalette" },
	0x01DB: { n:"BrtIndexedColor" },
	0x01DC: { n:"BrtMargins", f:parse_BrtMargins },
	0x01DD: { n:"BrtPrintOptions" },
	0x01DE: { n:"BrtPageSetup" },
	0x01DF: { n:"BrtBeginHeaderFooter" },
	0x01E0: { n:"BrtEndHeaderFooter" },
	0x01E1: { n:"BrtBeginSXCrtFormat" },
	0x01E2: { n:"BrtEndSXCrtFormat" },
	0x01E3: { n:"BrtBeginSXCrtFormats" },
	0x01E4: { n:"BrtEndSXCrtFormats" },
	0x01E5: { n:"BrtWsFmtInfo", f:parse_BrtWsFmtInfo },
	0x01E6: { n:"BrtBeginMgs" },
	0x01E7: { n:"BrtEndMGs" },
	0x01E8: { n:"BrtBeginMGMaps" },
	0x01E9: { n:"BrtEndMGMaps" },
	0x01EA: { n:"BrtBeginMG" },
	0x01EB: { n:"BrtEndMG" },
	0x01EC: { n:"BrtBeginMap" },
	0x01ED: { n:"BrtEndMap" },
	0x01EE: { n:"BrtHLink", f:parse_BrtHLink },
	0x01EF: { n:"BrtBeginDCon" },
	0x01F0: { n:"BrtEndDCon" },
	0x01F1: { n:"BrtBeginDRefs" },
	0x01F2: { n:"BrtEndDRefs" },
	0x01F3: { n:"BrtDRef" },
	0x01F4: { n:"BrtBeginScenMan" },
	0x01F5: { n:"BrtEndScenMan" },
	0x01F6: { n:"BrtBeginSct" },
	0x01F7: { n:"BrtEndSct" },
	0x01F8: { n:"BrtSlc" },
	0x01F9: { n:"BrtBeginDXFs" },
	0x01FA: { n:"BrtEndDXFs" },
	0x01FB: { n:"BrtDXF" },
	0x01FC: { n:"BrtBeginTableStyles" },
	0x01FD: { n:"BrtEndTableStyles" },
	0x01FE: { n:"BrtBeginTableStyle" },
	0x01FF: { n:"BrtEndTableStyle" },
	0x0200: { n:"BrtTableStyleElement" },
	0x0201: { n:"BrtTableStyleClient" },
	0x0202: { n:"BrtBeginVolDeps" },
	0x0203: { n:"BrtEndVolDeps" },
	0x0204: { n:"BrtBeginVolType" },
	0x0205: { n:"BrtEndVolType" },
	0x0206: { n:"BrtBeginVolMain" },
	0x0207: { n:"BrtEndVolMain" },
	0x0208: { n:"BrtBeginVolTopic" },
	0x0209: { n:"BrtEndVolTopic" },
	0x020A: { n:"BrtVolSubtopic" },
	0x020B: { n:"BrtVolRef" },
	0x020C: { n:"BrtVolNum" },
	0x020D: { n:"BrtVolErr" },
	0x020E: { n:"BrtVolStr" },
	0x020F: { n:"BrtVolBool" },
	0x0210: { n:"BrtBeginCalcChain$" },
	0x0211: { n:"BrtEndCalcChain$" },
	0x0212: { n:"BrtBeginSortState" },
	0x0213: { n:"BrtEndSortState" },
	0x0214: { n:"BrtBeginSortCond" },
	0x0215: { n:"BrtEndSortCond" },
	0x0216: { n:"BrtBookProtection" },
	0x0217: { n:"BrtSheetProtection" },
	0x0218: { n:"BrtRangeProtection" },
	0x0219: { n:"BrtPhoneticInfo" },
	0x021A: { n:"BrtBeginECTxtWiz" },
	0x021B: { n:"BrtEndECTxtWiz" },
	0x021C: { n:"BrtBeginECTWFldInfoLst" },
	0x021D: { n:"BrtEndECTWFldInfoLst" },
	0x021E: { n:"BrtBeginECTwFldInfo" },
	0x0224: { n:"BrtFileSharing" },
	0x0225: { n:"BrtOleSize" },
	0x0226: { n:"BrtDrawing", f:parse_RelID },
	0x0227: { n:"BrtLegacyDrawing" },
	0x0228: { n:"BrtLegacyDrawingHF" },
	0x0229: { n:"BrtWebOpt" },
	0x022A: { n:"BrtBeginWebPubItems" },
	0x022B: { n:"BrtEndWebPubItems" },
	0x022C: { n:"BrtBeginWebPubItem" },
	0x022D: { n:"BrtEndWebPubItem" },
	0x022E: { n:"BrtBeginSXCondFmt" },
	0x022F: { n:"BrtEndSXCondFmt" },
	0x0230: { n:"BrtBeginSXCondFmts" },
	0x0231: { n:"BrtEndSXCondFmts" },
	0x0232: { n:"BrtBkHim" },
	0x0234: { n:"BrtColor" },
	0x0235: { n:"BrtBeginIndexedColors" },
	0x0236: { n:"BrtEndIndexedColors" },
	0x0239: { n:"BrtBeginMRUColors" },
	0x023A: { n:"BrtEndMRUColors" },
	0x023C: { n:"BrtMRUColor" },
	0x023D: { n:"BrtBeginDVals" },
	0x023E: { n:"BrtEndDVals" },
	0x0241: { n:"BrtSupNameStart" },
	0x0242: { n:"BrtSupNameValueStart" },
	0x0243: { n:"BrtSupNameValueEnd" },
	0x0244: { n:"BrtSupNameNum" },
	0x0245: { n:"BrtSupNameErr" },
	0x0246: { n:"BrtSupNameSt" },
	0x0247: { n:"BrtSupNameNil" },
	0x0248: { n:"BrtSupNameBool" },
	0x0249: { n:"BrtSupNameFmla" },
	0x024A: { n:"BrtSupNameBits" },
	0x024B: { n:"BrtSupNameEnd" },
	0x024C: { n:"BrtEndSupBook" },
	0x024D: { n:"BrtCellSmartTagProperty" },
	0x024E: { n:"BrtBeginCellSmartTag" },
	0x024F: { n:"BrtEndCellSmartTag" },
	0x0250: { n:"BrtBeginCellSmartTags" },
	0x0251: { n:"BrtEndCellSmartTags" },
	0x0252: { n:"BrtBeginSmartTags" },
	0x0253: { n:"BrtEndSmartTags" },
	0x0254: { n:"BrtSmartTagType" },
	0x0255: { n:"BrtBeginSmartTagTypes" },
	0x0256: { n:"BrtEndSmartTagTypes" },
	0x0257: { n:"BrtBeginSXFilters" },
	0x0258: { n:"BrtEndSXFilters" },
	0x0259: { n:"BrtBeginSXFILTER" },
	0x025A: { n:"BrtEndSXFilter" },
	0x025B: { n:"BrtBeginFills" },
	0x025C: { n:"BrtEndFills" },
	0x025D: { n:"BrtBeginCellWatches" },
	0x025E: { n:"BrtEndCellWatches" },
	0x025F: { n:"BrtCellWatch" },
	0x0260: { n:"BrtBeginCRErrs" },
	0x0261: { n:"BrtEndCRErrs" },
	0x0262: { n:"BrtCrashRecErr" },
	0x0263: { n:"BrtBeginFonts" },
	0x0264: { n:"BrtEndFonts" },
	0x0265: { n:"BrtBeginBorders" },
	0x0266: { n:"BrtEndBorders" },
	0x0267: { n:"BrtBeginFmts" },
	0x0268: { n:"BrtEndFmts" },
	0x0269: { n:"BrtBeginCellXFs" },
	0x026A: { n:"BrtEndCellXFs" },
	0x026B: { n:"BrtBeginStyles" },
	0x026C: { n:"BrtEndStyles" },
	0x0271: { n:"BrtBigName" },
	0x0272: { n:"BrtBeginCellStyleXFs" },
	0x0273: { n:"BrtEndCellStyleXFs" },
	0x0274: { n:"BrtBeginComments" },
	0x0275: { n:"BrtEndComments" },
	0x0276: { n:"BrtBeginCommentAuthors" },
	0x0277: { n:"BrtEndCommentAuthors" },
	0x0278: { n:"BrtCommentAuthor", f:parse_BrtCommentAuthor },
	0x0279: { n:"BrtBeginCommentList" },
	0x027A: { n:"BrtEndCommentList" },
	0x027B: { n:"BrtBeginComment", f:parse_BrtBeginComment},
	0x027C: { n:"BrtEndComment" },
	0x027D: { n:"BrtCommentText", f:parse_BrtCommentText },
	0x027E: { n:"BrtBeginOleObjects" },
	0x027F: { n:"BrtOleObject" },
	0x0280: { n:"BrtEndOleObjects" },
	0x0281: { n:"BrtBeginSxrules" },
	0x0282: { n:"BrtEndSxRules" },
	0x0283: { n:"BrtBeginActiveXControls" },
	0x0284: { n:"BrtActiveX" },
	0x0285: { n:"BrtEndActiveXControls" },
	0x0286: { n:"BrtBeginPCDSDTCEMembersSortBy" },
	0x0288: { n:"BrtBeginCellIgnoreECs" },
	0x0289: { n:"BrtCellIgnoreEC" },
	0x028A: { n:"BrtEndCellIgnoreECs" },
	0x028B: { n:"BrtCsProp", f:parse_BrtCsProp },
	0x028C: { n:"BrtCsPageSetup" },
	0x028D: { n:"BrtBeginUserCsViews" },
	0x028E: { n:"BrtEndUserCsViews" },
	0x028F: { n:"BrtBeginUserCsView" },
	0x0290: { n:"BrtEndUserCsView" },
	0x0291: { n:"BrtBeginPcdSFCIEntries" },
	0x0292: { n:"BrtEndPCDSFCIEntries" },
	0x0293: { n:"BrtPCDSFCIEntry" },
	0x0294: { n:"BrtBeginListParts" },
	0x0295: { n:"BrtListPart" },
	0x0296: { n:"BrtEndListParts" },
	0x0297: { n:"BrtSheetCalcProp" },
	0x0298: { n:"BrtBeginFnGroup" },
	0x0299: { n:"BrtFnGroup" },
	0x029A: { n:"BrtEndFnGroup" },
	0x029B: { n:"BrtSupAddin" },
	0x029C: { n:"BrtSXTDMPOrder" },
	0x029D: { n:"BrtCsProtection" },
	0x029F: { n:"BrtBeginWsSortMap" },
	0x02A0: { n:"BrtEndWsSortMap" },
	0x02A1: { n:"BrtBeginRRSort" },
	0x02A2: { n:"BrtEndRRSort" },
	0x02A3: { n:"BrtRRSortItem" },
	0x02A4: { n:"BrtFileSharingIso" },
	0x02A5: { n:"BrtBookProtectionIso" },
	0x02A6: { n:"BrtSheetProtectionIso" },
	0x02A7: { n:"BrtCsProtectionIso" },
	0x02A8: { n:"BrtRangeProtectionIso" },
	0x02A9: { n:"BrtDValList" },
	0x0400: { n:"BrtRwDescent" },
	0x0401: { n:"BrtKnownFonts" },
	0x0402: { n:"BrtBeginSXTupleSet" },
	0x0403: { n:"BrtEndSXTupleSet" },
	0x0404: { n:"BrtBeginSXTupleSetHeader" },
	0x0405: { n:"BrtEndSXTupleSetHeader" },
	0x0406: { n:"BrtSXTupleSetHeaderItem" },
	0x0407: { n:"BrtBeginSXTupleSetData" },
	0x0408: { n:"BrtEndSXTupleSetData" },
	0x0409: { n:"BrtBeginSXTupleSetRow" },
	0x040A: { n:"BrtEndSXTupleSetRow" },
	0x040B: { n:"BrtSXTupleSetRowItem" },
	0x040C: { n:"BrtNameExt" },
	0x040D: { n:"BrtPCDH14" },
	0x040E: { n:"BrtBeginPCDCalcMem14" },
	0x040F: { n:"BrtEndPCDCalcMem14" },
	0x0410: { n:"BrtSXTH14" },
	0x0411: { n:"BrtBeginSparklineGroup" },
	0x0412: { n:"BrtEndSparklineGroup" },
	0x0413: { n:"BrtSparkline" },
	0x0414: { n:"BrtSXDI14" },
	0x0415: { n:"BrtWsFmtInfoEx14" },
	0x0416: { n:"BrtBeginConditionalFormatting14" },
	0x0417: { n:"BrtEndConditionalFormatting14" },
	0x0418: { n:"BrtBeginCFRule14" },
	0x0419: { n:"BrtEndCFRule14" },
	0x041A: { n:"BrtCFVO14" },
	0x041B: { n:"BrtBeginDatabar14" },
	0x041C: { n:"BrtBeginIconSet14" },
	0x041D: { n:"BrtDVal14", f: parse_BrtDVal14 },
	0x041E: { n:"BrtBeginDVals14" },
	0x041F: { n:"BrtColor14" },
	0x0420: { n:"BrtBeginSparklines" },
	0x0421: { n:"BrtEndSparklines" },
	0x0422: { n:"BrtBeginSparklineGroups" },
	0x0423: { n:"BrtEndSparklineGroups" },
	0x0425: { n:"BrtSXVD14" },
	0x0426: { n:"BrtBeginSXView14" },
	0x0427: { n:"BrtEndSXView14" },
	0x0428: { n:"BrtBeginSXView16" },
	0x0429: { n:"BrtEndSXView16" },
	0x042A: { n:"BrtBeginPCD14" },
	0x042B: { n:"BrtEndPCD14" },
	0x042C: { n:"BrtBeginExtConn14" },
	0x042D: { n:"BrtEndExtConn14" },
	0x042E: { n:"BrtBeginSlicerCacheIDs" },
	0x042F: { n:"BrtEndSlicerCacheIDs" },
	0x0430: { n:"BrtBeginSlicerCacheID" },
	0x0431: { n:"BrtEndSlicerCacheID" },
	0x0433: { n:"BrtBeginSlicerCache" },
	0x0434: { n:"BrtEndSlicerCache" },
	0x0435: { n:"BrtBeginSlicerCacheDef" },
	0x0436: { n:"BrtEndSlicerCacheDef" },
	0x0437: { n:"BrtBeginSlicersEx" },
	0x0438: { n:"BrtEndSlicersEx" },
	0x0439: { n:"BrtBeginSlicerEx" },
	0x043A: { n:"BrtEndSlicerEx" },
	0x043B: { n:"BrtBeginSlicer" },
	0x043C: { n:"BrtEndSlicer" },
	0x043D: { n:"BrtSlicerCachePivotTables" },
	0x043E: { n:"BrtBeginSlicerCacheOlapImpl" },
	0x043F: { n:"BrtEndSlicerCacheOlapImpl" },
	0x0440: { n:"BrtBeginSlicerCacheLevelsData" },
	0x0441: { n:"BrtEndSlicerCacheLevelsData" },
	0x0442: { n:"BrtBeginSlicerCacheLevelData" },
	0x0443: { n:"BrtEndSlicerCacheLevelData" },
	0x0444: { n:"BrtBeginSlicerCacheSiRanges" },
	0x0445: { n:"BrtEndSlicerCacheSiRanges" },
	0x0446: { n:"BrtBeginSlicerCacheSiRange" },
	0x0447: { n:"BrtEndSlicerCacheSiRange" },
	0x0448: { n:"BrtSlicerCacheOlapItem" },
	0x0449: { n:"BrtBeginSlicerCacheSelections" },
	0x044A: { n:"BrtSlicerCacheSelection" },
	0x044B: { n:"BrtEndSlicerCacheSelections" },
	0x044C: { n:"BrtBeginSlicerCacheNative" },
	0x044D: { n:"BrtEndSlicerCacheNative" },
	0x044E: { n:"BrtSlicerCacheNativeItem" },
	0x044F: { n:"BrtRangeProtection14" },
	0x0450: { n:"BrtRangeProtectionIso14" },
	0x0451: { n:"BrtCellIgnoreEC14" },
	0x0457: { n:"BrtList14" },
	0x0458: { n:"BrtCFIcon" },
	0x0459: { n:"BrtBeginSlicerCachesPivotCacheIDs" },
	0x045A: { n:"BrtEndSlicerCachesPivotCacheIDs" },
	0x045B: { n:"BrtBeginSlicers" },
	0x045C: { n:"BrtEndSlicers" },
	0x045D: { n:"BrtWbProp14" },
	0x045E: { n:"BrtBeginSXEdit" },
	0x045F: { n:"BrtEndSXEdit" },
	0x0460: { n:"BrtBeginSXEdits" },
	0x0461: { n:"BrtEndSXEdits" },
	0x0462: { n:"BrtBeginSXChange" },
	0x0463: { n:"BrtEndSXChange" },
	0x0464: { n:"BrtBeginSXChanges" },
	0x0465: { n:"BrtEndSXChanges" },
	0x0466: { n:"BrtSXTupleItems" },
	0x0468: { n:"BrtBeginSlicerStyle" },
	0x0469: { n:"BrtEndSlicerStyle" },
	0x046A: { n:"BrtSlicerStyleElement" },
	0x046B: { n:"BrtBeginStyleSheetExt14" },
	0x046C: { n:"BrtEndStyleSheetExt14" },
	0x046D: { n:"BrtBeginSlicerCachesPivotCacheID" },
	0x046E: { n:"BrtEndSlicerCachesPivotCacheID" },
	0x046F: { n:"BrtBeginConditionalFormattings" },
	0x0470: { n:"BrtEndConditionalFormattings" },
	0x0471: { n:"BrtBeginPCDCalcMemExt" },
	0x0472: { n:"BrtEndPCDCalcMemExt" },
	0x0473: { n:"BrtBeginPCDCalcMemsExt" },
	0x0474: { n:"BrtEndPCDCalcMemsExt" },
	0x0475: { n:"BrtPCDField14" },
	0x0476: { n:"BrtBeginSlicerStyles" },
	0x0477: { n:"BrtEndSlicerStyles" },
	0x0478: { n:"BrtBeginSlicerStyleElements" },
	0x0479: { n:"BrtEndSlicerStyleElements" },
	0x047A: { n:"BrtCFRuleExt" },
	0x047B: { n:"BrtBeginSXCondFmt14" },
	0x047C: { n:"BrtEndSXCondFmt14" },
	0x047D: { n:"BrtBeginSXCondFmts14" },
	0x047E: { n:"BrtEndSXCondFmts14" },
	0x0480: { n:"BrtBeginSortCond14" },
	0x0481: { n:"BrtEndSortCond14" },
	0x0482: { n:"BrtEndDVals14" },
	0x0483: { n:"BrtEndIconSet14" },
	0x0484: { n:"BrtEndDatabar14" },
	0x0485: { n:"BrtBeginColorScale14" },
	0x0486: { n:"BrtEndColorScale14" },
	0x0487: { n:"BrtBeginSxrules14" },
	0x0488: { n:"BrtEndSxrules14" },
	0x0489: { n:"BrtBeginPRule14" },
	0x048A: { n:"BrtEndPRule14" },
	0x048B: { n:"BrtBeginPRFilters14" },
	0x048C: { n:"BrtEndPRFilters14" },
	0x048D: { n:"BrtBeginPRFilter14" },
	0x048E: { n:"BrtEndPRFilter14" },
	0x048F: { n:"BrtBeginPRFItem14" },
	0x0490: { n:"BrtEndPRFItem14" },
	0x0491: { n:"BrtBeginCellIgnoreECs14" },
	0x0492: { n:"BrtEndCellIgnoreECs14" },
	0x0493: { n:"BrtDxf14" },
	0x0494: { n:"BrtBeginDxF14s" },
	0x0495: { n:"BrtEndDxf14s" },
	0x0499: { n:"BrtFilter14" },
	0x049A: { n:"BrtBeginCustomFilters14" },
	0x049C: { n:"BrtCustomFilter14" },
	0x049D: { n:"BrtIconFilter14" },
	0x049E: { n:"BrtPivotCacheConnectionName" },
	0x0800: { n:"BrtBeginDecoupledPivotCacheIDs" },
	0x0801: { n:"BrtEndDecoupledPivotCacheIDs" },
	0x0802: { n:"BrtDecoupledPivotCacheID" },
	0x0803: { n:"BrtBeginPivotTableRefs" },
	0x0804: { n:"BrtEndPivotTableRefs" },
	0x0805: { n:"BrtPivotTableRef" },
	0x0806: { n:"BrtSlicerCacheBookPivotTables" },
	0x0807: { n:"BrtBeginSxvcells" },
	0x0808: { n:"BrtEndSxvcells" },
	0x0809: { n:"BrtBeginSxRow" },
	0x080A: { n:"BrtEndSxRow" },
	0x080C: { n:"BrtPcdCalcMem15" },
	0x0813: { n:"BrtQsi15" },
	0x0814: { n:"BrtBeginWebExtensions" },
	0x0815: { n:"BrtEndWebExtensions" },
	0x0816: { n:"BrtWebExtension" },
	0x0817: { n:"BrtAbsPath15" },
	0x0818: { n:"BrtBeginPivotTableUISettings" },
	0x0819: { n:"BrtEndPivotTableUISettings" },
	0x081B: { n:"BrtTableSlicerCacheIDs" },
	0x081C: { n:"BrtTableSlicerCacheID" },
	0x081D: { n:"BrtBeginTableSlicerCache" },
	0x081E: { n:"BrtEndTableSlicerCache" },
	0x081F: { n:"BrtSxFilter15" },
	0x0820: { n:"BrtBeginTimelineCachePivotCacheIDs" },
	0x0821: { n:"BrtEndTimelineCachePivotCacheIDs" },
	0x0822: { n:"BrtTimelineCachePivotCacheID" },
	0x0823: { n:"BrtBeginTimelineCacheIDs" },
	0x0824: { n:"BrtEndTimelineCacheIDs" },
	0x0825: { n:"BrtBeginTimelineCacheID" },
	0x0826: { n:"BrtEndTimelineCacheID" },
	0x0827: { n:"BrtBeginTimelinesEx" },
	0x0828: { n:"BrtEndTimelinesEx" },
	0x0829: { n:"BrtBeginTimelineEx" },
	0x082A: { n:"BrtEndTimelineEx" },
	0x082B: { n:"BrtWorkBookPr15" },
	0x082C: { n:"BrtPCDH15" },
	0x082D: { n:"BrtBeginTimelineStyle" },
	0x082E: { n:"BrtEndTimelineStyle" },
	0x082F: { n:"BrtTimelineStyleElement" },
	0x0830: { n:"BrtBeginTimelineStylesheetExt15" },
	0x0831: { n:"BrtEndTimelineStylesheetExt15" },
	0x0832: { n:"BrtBeginTimelineStyles" },
	0x0833: { n:"BrtEndTimelineStyles" },
	0x0834: { n:"BrtBeginTimelineStyleElements" },
	0x0835: { n:"BrtEndTimelineStyleElements" },
	0x0836: { n:"BrtDxf15" },
	0x0837: { n:"BrtBeginDxfs15" },
	0x0838: { n:"brtEndDxfs15" },
	0x0839: { n:"BrtSlicerCacheHideItemsWithNoData" },
	0x083A: { n:"BrtBeginItemUniqueNames" },
	0x083B: { n:"BrtEndItemUniqueNames" },
	0x083C: { n:"BrtItemUniqueName" },
	0x083D: { n:"BrtBeginExtConn15" },
	0x083E: { n:"BrtEndExtConn15" },
	0x083F: { n:"BrtBeginOledbPr15" },
	0x0840: { n:"BrtEndOledbPr15" },
	0x0841: { n:"BrtBeginDataFeedPr15" },
	0x0842: { n:"BrtEndDataFeedPr15" },
	0x0843: { n:"BrtTextPr15" },
	0x0844: { n:"BrtRangePr15" },
	0x0845: { n:"BrtDbCommand15" },
	0x0846: { n:"BrtBeginDbTables15" },
	0x0847: { n:"BrtEndDbTables15" },
	0x0848: { n:"BrtDbTable15" },
	0x0849: { n:"BrtBeginDataModel" },
	0x084A: { n:"BrtEndDataModel" },
	0x084B: { n:"BrtBeginModelTables" },
	0x084C: { n:"BrtEndModelTables" },
	0x084D: { n:"BrtModelTable" },
	0x084E: { n:"BrtBeginModelRelationships" },
	0x084F: { n:"BrtEndModelRelationships" },
	0x0850: { n:"BrtModelRelationship" },
	0x0851: { n:"BrtBeginECTxtWiz15" },
	0x0852: { n:"BrtEndECTxtWiz15" },
	0x0853: { n:"BrtBeginECTWFldInfoLst15" },
	0x0854: { n:"BrtEndECTWFldInfoLst15" },
	0x0855: { n:"BrtBeginECTWFldInfo15" },
	0x0856: { n:"BrtFieldListActiveItem" },
	0x0857: { n:"BrtPivotCacheIdVersion" },
	0x0858: { n:"BrtSXDI15" },
	0x0859: { n:"BrtBeginModelTimeGroupings" },
	0x085A: { n:"BrtEndModelTimeGroupings" },
	0x085B: { n:"BrtBeginModelTimeGrouping" },
	0x085C: { n:"BrtEndModelTimeGrouping" },
	0x085D: { n:"BrtModelTimeGroupingCalcCol" },
	0x0C00: { n:"BrtUid" },
	0x0C01: { n:"BrtRevisionPtr" },
	0x13e7: { n:"BrtBeginCalcFeatures" },
	0x13e8: { n:"BrtEndCalcFeatures" },
	0x13e9: { n:"BrtCalcFeature" },
	0xFFFF: { n:"" }
	};
	
	var XLSBRE = evert_key(XLSBRecordEnum, 'n');
	/*jshint -W069 */
	XLSBRE["BrtFRTArchID$"] = 0x0010;
	/*jshint +W069 */
	
	/* [MS-XLS] 2.3 Record Enumeration (and other sources) */
	var XLSRecordEnum = {
		/* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */
	0x0006: { n:"Formula", f:parse_Formula },
	0x000a: { n:'EOF', f:parsenoop2 },
	0x000c: { n:"CalcCount", f:parseuint16 },
	0x000d: { n:"CalcMode", f:parseuint16 },
	0x000e: { n:"CalcPrecision", f:parsebool },
	0x000f: { n:"CalcRefMode", f:parsebool },
	0x0010: { n:"CalcDelta", f:parse_Xnum },
	0x0011: { n:"CalcIter", f:parsebool },
	0x0012: { n:"Protect", f:parsebool },
	0x0013: { n:"Password", f:parseuint16 },
	0x0014: { n:"Header", f:parse_XLHeaderFooter },
	0x0015: { n:"Footer", f:parse_XLHeaderFooter },
	0x0017: { n:"ExternSheet", f:parse_ExternSheet },
	0x0018: { n:"Lbl", f:parse_Lbl },
	0x0019: { n:"WinProtect", f:parsebool },
	0x001a: { n:"VerticalPageBreaks" },
	0x001b: { n:"HorizontalPageBreaks" },
	0x001c: { n:"Note", f:parse_Note },
	0x001d: { n:"Selection" },
	0x0022: { n:"Date1904", f:parsebool },
	0x0023: { n:"ExternName", f:parse_ExternName },
	0x0026: { n:"LeftMargin", f:parse_Xnum },
	0x0027: { n:"RightMargin", f:parse_Xnum },
	0x0028: { n:"TopMargin", f:parse_Xnum },
	0x0029: { n:"BottomMargin", f:parse_Xnum },
	0x002a: { n:"PrintRowCol", f:parsebool },
	0x002b: { n:"PrintGrid", f:parsebool },
	0x002f: { n:"FilePass", f:parse_FilePass },
	0x0031: { n:"Font", f:parse_Font },
	0x0033: { n:"PrintSize", f:parseuint16 },
	0x003c: { n:"Continue" },
	0x003d: { n:"Window1", f:parse_Window1 },
	0x0040: { n:"Backup", f:parsebool },
	0x0041: { n:"Pane", f:parse_Pane },
	0x0042: { n:'CodePage', f:parseuint16 },
	0x004d: { n:"Pls" },
	0x0050: { n:"DCon" },
	0x0051: { n:"DConRef" },
	0x0052: { n:"DConName" },
	0x0055: { n:"DefColWidth", f:parseuint16 },
	0x0059: { n:"XCT" },
	0x005a: { n:"CRN" },
	0x005b: { n:"FileSharing" },
	0x005c: { n:'WriteAccess', f:parse_WriteAccess },
	0x005d: { n:"Obj", f:parse_Obj },
	0x005e: { n:"Uncalced" },
	0x005f: { n:"CalcSaveRecalc", f:parsebool },
	0x0060: { n:"Template" },
	0x0061: { n:"Intl" },
	0x0063: { n:"ObjProtect", f:parsebool },
	0x007d: { n:"ColInfo", f:parse_ColInfo },
	0x0080: { n:"Guts", f:parse_Guts },
	0x0081: { n:"WsBool", f:parse_WsBool },
	0x0082: { n:"GridSet", f:parseuint16 },
	0x0083: { n:"HCenter", f:parsebool },
	0x0084: { n:"VCenter", f:parsebool },
	0x0085: { n:'BoundSheet8', f:parse_BoundSheet8 },
	0x0086: { n:"WriteProtect" },
	0x008c: { n:"Country", f:parse_Country },
	0x008d: { n:"HideObj", f:parseuint16 },
	0x0090: { n:"Sort" },
	0x0092: { n:"Palette", f:parse_Palette },
	0x0097: { n:"Sync" },
	0x0098: { n:"LPr" },
	0x0099: { n:"DxGCol" },
	0x009a: { n:"FnGroupName" },
	0x009b: { n:"FilterMode" },
	0x009c: { n:"BuiltInFnGroupCount", f:parseuint16 },
	0x009d: { n:"AutoFilterInfo" },
	0x009e: { n:"AutoFilter" },
	0x00a0: { n:"Scl", f:parse_Scl },
	0x00a1: { n:"Setup", f:parse_Setup },
	0x00ae: { n:"ScenMan" },
	0x00af: { n:"SCENARIO" },
	0x00b0: { n:"SxView" },
	0x00b1: { n:"Sxvd" },
	0x00b2: { n:"SXVI" },
	0x00b4: { n:"SxIvd" },
	0x00b5: { n:"SXLI" },
	0x00b6: { n:"SXPI" },
	0x00b8: { n:"DocRoute" },
	0x00b9: { n:"RecipName" },
	0x00bd: { n:"MulRk", f:parse_MulRk },
	0x00be: { n:"MulBlank", f:parse_MulBlank },
	0x00c1: { n:'Mms', f:parsenoop2 },
	0x00c5: { n:"SXDI" },
	0x00c6: { n:"SXDB" },
	0x00c7: { n:"SXFDB" },
	0x00c8: { n:"SXDBB" },
	0x00c9: { n:"SXNum" },
	0x00ca: { n:"SxBool", f:parsebool },
	0x00cb: { n:"SxErr" },
	0x00cc: { n:"SXInt" },
	0x00cd: { n:"SXString" },
	0x00ce: { n:"SXDtr" },
	0x00cf: { n:"SxNil" },
	0x00d0: { n:"SXTbl" },
	0x00d1: { n:"SXTBRGIITM" },
	0x00d2: { n:"SxTbpg" },
	0x00d3: { n:"ObProj" },
	0x00d5: { n:"SXStreamID" },
	0x00d7: { n:"DBCell" },
	0x00d8: { n:"SXRng" },
	0x00d9: { n:"SxIsxoper" },
	0x00da: { n:"BookBool", f:parseuint16 },
	0x00dc: { n:"DbOrParamQry" },
	0x00dd: { n:"ScenarioProtect", f:parsebool },
	0x00de: { n:"OleObjectSize" },
	0x00e0: { n:"XF", f:parse_XF },
	0x00e1: { n:'InterfaceHdr', f:parse_InterfaceHdr },
	0x00e2: { n:'InterfaceEnd', f:parsenoop2 },
	0x00e3: { n:"SXVS" },
	0x00e5: { n:"MergeCells", f:parse_MergeCells },
	0x00e9: { n:"BkHim" },
	0x00eb: { n:"MsoDrawingGroup" },
	0x00ec: { n:"MsoDrawing" },
	0x00ed: { n:"MsoDrawingSelection" },
	0x00ef: { n:"PhoneticInfo" },
	0x00f0: { n:"SxRule" },
	0x00f1: { n:"SXEx" },
	0x00f2: { n:"SxFilt" },
	0x00f4: { n:"SxDXF" },
	0x00f5: { n:"SxItm" },
	0x00f6: { n:"SxName" },
	0x00f7: { n:"SxSelect" },
	0x00f8: { n:"SXPair" },
	0x00f9: { n:"SxFmla" },
	0x00fb: { n:"SxFormat" },
	0x00fc: { n:"SST", f:parse_SST },
	0x00fd: { n:"LabelSst", f:parse_LabelSst },
	0x00ff: { n:"ExtSST", f:parse_ExtSST },
	0x0100: { n:"SXVDEx" },
	0x0103: { n:"SXFormula" },
	0x0122: { n:"SXDBEx" },
	0x0137: { n:"RRDInsDel" },
	0x0138: { n:"RRDHead" },
	0x013b: { n:"RRDChgCell" },
	0x013d: { n:"RRTabId", f:parseuint16a },
	0x013e: { n:"RRDRenSheet" },
	0x013f: { n:"RRSort" },
	0x0140: { n:"RRDMove" },
	0x014a: { n:"RRFormat" },
	0x014b: { n:"RRAutoFmt" },
	0x014d: { n:"RRInsertSh" },
	0x014e: { n:"RRDMoveBegin" },
	0x014f: { n:"RRDMoveEnd" },
	0x0150: { n:"RRDInsDelBegin" },
	0x0151: { n:"RRDInsDelEnd" },
	0x0152: { n:"RRDConflict" },
	0x0153: { n:"RRDDefName" },
	0x0154: { n:"RRDRstEtxp" },
	0x015f: { n:"LRng" },
	0x0160: { n:"UsesELFs", f:parsebool },
	0x0161: { n:"DSF", f:parsenoop2 },
	0x0191: { n:"CUsr" },
	0x0192: { n:"CbUsr" },
	0x0193: { n:"UsrInfo" },
	0x0194: { n:"UsrExcl" },
	0x0195: { n:"FileLock" },
	0x0196: { n:"RRDInfo" },
	0x0197: { n:"BCUsrs" },
	0x0198: { n:"UsrChk" },
	0x01a9: { n:"UserBView" },
	0x01aa: { n:"UserSViewBegin" },
	0x01ab: { n:"UserSViewEnd" },
	0x01ac: { n:"RRDUserView" },
	0x01ad: { n:"Qsi" },
	0x01ae: { n:"SupBook", f:parse_SupBook },
	0x01af: { n:"Prot4Rev", f:parsebool },
	0x01b0: { n:"CondFmt" },
	0x01b1: { n:"CF" },
	0x01b2: { n:"DVal" },
	0x01b5: { n:"DConBin" },
	0x01b6: { n:"TxO", f:parse_TxO },
	0x01b7: { n:"RefreshAll", f:parsebool },
	0x01b8: { n:"HLink", f:parse_HLink },
	0x01b9: { n:"Lel" },
	0x01ba: { n:"CodeName", f:parse_XLUnicodeString },
	0x01bb: { n:"SXFDBType" },
	0x01bc: { n:"Prot4RevPass", f:parseuint16 },
	0x01bd: { n:"ObNoMacros" },
	0x01be: { n:"Dv" },
	0x01c0: { n:"Excel9File", f:parsenoop2 },
	0x01c1: { n:"RecalcId", f:parse_RecalcId, r:2},
	0x01c2: { n:"EntExU2", f:parsenoop2 },
	0x0200: { n:"Dimensions", f:parse_Dimensions },
	0x0201: { n:"Blank", f:parse_Blank },
	0x0203: { n:"Number", f:parse_Number },
	0x0204: { n:"Label", f:parse_Label },
	0x0205: { n:"BoolErr", f:parse_BoolErr },
	0x0207: { n:"String", f:parse_String },
	0x0208: { n:'Row', f:parse_Row },
	0x020b: { n:"Index" },
	0x0221: { n:"Array", f:parse_Array },
	0x0225: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
	0x0236: { n:"Table" },
	0x023e: { n:"Window2", f:parse_Window2 },
	0x027e: { n:"RK", f:parse_RK },
	0x0293: { n:"Style" },
	0x0418: { n:"BigName" },
	0x041e: { n:"Format", f:parse_Format },
	0x043c: { n:"ContinueBigName" },
	0x04bc: { n:"ShrFmla", f:parse_ShrFmla },
	0x0800: { n:"HLinkTooltip", f:parse_HLinkTooltip },
	0x0801: { n:"WebPub" },
	0x0802: { n:"QsiSXTag" },
	0x0803: { n:"DBQueryExt" },
	0x0804: { n:"ExtString" },
	0x0805: { n:"TxtQry" },
	0x0806: { n:"Qsir" },
	0x0807: { n:"Qsif" },
	0x0808: { n:"RRDTQSIF" },
	0x0809: { n:'BOF', f:parse_BOF },
	0x080a: { n:"OleDbConn" },
	0x080b: { n:"WOpt" },
	0x080c: { n:"SXViewEx" },
	0x080d: { n:"SXTH" },
	0x080e: { n:"SXPIEx" },
	0x080f: { n:"SXVDTEx" },
	0x0810: { n:"SXViewEx9" },
	0x0812: { n:"ContinueFrt" },
	0x0813: { n:"RealTimeData" },
	0x0850: { n:"ChartFrtInfo" },
	0x0851: { n:"FrtWrapper" },
	0x0852: { n:"StartBlock" },
	0x0853: { n:"EndBlock" },
	0x0854: { n:"StartObject" },
	0x0855: { n:"EndObject" },
	0x0856: { n:"CatLab" },
	0x0857: { n:"YMult" },
	0x0858: { n:"SXViewLink" },
	0x0859: { n:"PivotChartBits" },
	0x085a: { n:"FrtFontList" },
	0x0862: { n:"SheetExt" },
	0x0863: { n:"BookExt", r:12},
	0x0864: { n:"SXAddl" },
	0x0865: { n:"CrErr" },
	0x0866: { n:"HFPicture" },
	0x0867: { n:'FeatHdr', f:parsenoop2 },
	0x0868: { n:"Feat" },
	0x086a: { n:"DataLabExt" },
	0x086b: { n:"DataLabExtContents" },
	0x086c: { n:"CellWatch" },
	0x0871: { n:"FeatHdr11" },
	0x0872: { n:"Feature11" },
	0x0874: { n:"DropDownObjIds" },
	0x0875: { n:"ContinueFrt11" },
	0x0876: { n:"DConn" },
	0x0877: { n:"List12" },
	0x0878: { n:"Feature12" },
	0x0879: { n:"CondFmt12" },
	0x087a: { n:"CF12" },
	0x087b: { n:"CFEx" },
	0x087c: { n:"XFCRC", f:parse_XFCRC, r:12 },
	0x087d: { n:"XFExt", f:parse_XFExt, r:12 },
	0x087e: { n:"AutoFilter12" },
	0x087f: { n:"ContinueFrt12" },
	0x0884: { n:"MDTInfo" },
	0x0885: { n:"MDXStr" },
	0x0886: { n:"MDXTuple" },
	0x0887: { n:"MDXSet" },
	0x0888: { n:"MDXProp" },
	0x0889: { n:"MDXKPI" },
	0x088a: { n:"MDB" },
	0x088b: { n:"PLV" },
	0x088c: { n:"Compat12", f:parsebool, r:12 },
	0x088d: { n:"DXF" },
	0x088e: { n:"TableStyles", r:12 },
	0x088f: { n:"TableStyle" },
	0x0890: { n:"TableStyleElement" },
	0x0892: { n:"StyleExt" },
	0x0893: { n:"NamePublish" },
	0x0894: { n:"NameCmt", f:parse_NameCmt, r:12 },
	0x0895: { n:"SortData" },
	0x0896: { n:"Theme", f:parse_Theme, r:12 },
	0x0897: { n:"GUIDTypeLib" },
	0x0898: { n:"FnGrp12" },
	0x0899: { n:"NameFnGrp12" },
	0x089a: { n:"MTRSettings", f:parse_MTRSettings, r:12 },
	0x089b: { n:"CompressPictures", f:parsenoop2 },
	0x089c: { n:"HeaderFooter" },
	0x089d: { n:"CrtLayout12" },
	0x089e: { n:"CrtMlFrt" },
	0x089f: { n:"CrtMlFrtContinue" },
	0x08a3: { n:"ForceFullCalculation", f:parse_ForceFullCalculation },
	0x08a4: { n:"ShapePropsStream" },
	0x08a5: { n:"TextPropsStream" },
	0x08a6: { n:"RichTextStream" },
	0x08a7: { n:"CrtLayout12A" },
	0x1001: { n:"Units" },
	0x1002: { n:"Chart" },
	0x1003: { n:"Series" },
	0x1006: { n:"DataFormat" },
	0x1007: { n:"LineFormat" },
	0x1009: { n:"MarkerFormat" },
	0x100a: { n:"AreaFormat" },
	0x100b: { n:"PieFormat" },
	0x100c: { n:"AttachedLabel" },
	0x100d: { n:"SeriesText" },
	0x1014: { n:"ChartFormat" },
	0x1015: { n:"Legend" },
	0x1016: { n:"SeriesList" },
	0x1017: { n:"Bar" },
	0x1018: { n:"Line" },
	0x1019: { n:"Pie" },
	0x101a: { n:"Area" },
	0x101b: { n:"Scatter" },
	0x101c: { n:"CrtLine" },
	0x101d: { n:"Axis" },
	0x101e: { n:"Tick" },
	0x101f: { n:"ValueRange" },
	0x1020: { n:"CatSerRange" },
	0x1021: { n:"AxisLine" },
	0x1022: { n:"CrtLink" },
	0x1024: { n:"DefaultText" },
	0x1025: { n:"Text" },
	0x1026: { n:"FontX", f:parseuint16 },
	0x1027: { n:"ObjectLink" },
	0x1032: { n:"Frame" },
	0x1033: { n:"Begin" },
	0x1034: { n:"End" },
	0x1035: { n:"PlotArea" },
	0x103a: { n:"Chart3d" },
	0x103c: { n:"PicF" },
	0x103d: { n:"DropBar" },
	0x103e: { n:"Radar" },
	0x103f: { n:"Surf" },
	0x1040: { n:"RadarArea" },
	0x1041: { n:"AxisParent" },
	0x1043: { n:"LegendException" },
	0x1044: { n:"ShtProps", f:parse_ShtProps },
	0x1045: { n:"SerToCrt" },
	0x1046: { n:"AxesUsed" },
	0x1048: { n:"SBaseRef" },
	0x104a: { n:"SerParent" },
	0x104b: { n:"SerAuxTrend" },
	0x104e: { n:"IFmtRecord" },
	0x104f: { n:"Pos" },
	0x1050: { n:"AlRuns" },
	0x1051: { n:"BRAI" },
	0x105b: { n:"SerAuxErrBar" },
	0x105c: { n:"ClrtClient", f:parse_ClrtClient },
	0x105d: { n:"SerFmt" },
	0x105f: { n:"Chart3DBarShape" },
	0x1060: { n:"Fbi" },
	0x1061: { n:"BopPop" },
	0x1062: { n:"AxcExt" },
	0x1063: { n:"Dat" },
	0x1064: { n:"PlotGrowth" },
	0x1065: { n:"SIIndex" },
	0x1066: { n:"GelFrame" },
	0x1067: { n:"BopPopCustom" },
	0x1068: { n:"Fbi2" },
	
	0x0000: { n:"Dimensions", f:parse_Dimensions },
	0x0001: { n:"BIFF2BLANK" },
	0x0002: { n:"BIFF2INT", f:parse_BIFF2INT },
	0x0003: { n:"BIFF2NUM", f:parse_BIFF2NUM },
	0x0004: { n:"BIFF2STR", f:parse_BIFF2STR },
	0x0005: { n:"BoolErr", f:parse_BoolErr },
	0x0007: { n:"String", f:parse_BIFF2STRING },
	0x0008: { n:"BIFF2ROW" },
	0x0009: { n:'BOF', f:parse_BOF },
	0x000b: { n:"Index" },
	0x0016: { n:"ExternCount", f:parseuint16 },
	0x001e: { n:"BIFF2FORMAT", f:parse_BIFF2Format },
	0x001f: { n:"BIFF2FMTCNT" }, /* 16-bit cnt of BIFF2FORMAT records */
	0x0020: { n:"BIFF2COLINFO" },
	0x0021: { n:"Array", f:parse_Array },
	0x0024: { n:"COLWIDTH" },
	0x0025: { n:"DefaultRowHeight", f:parse_DefaultRowHeight },
		// 0x2c ??
		// 0x2d ??
		// 0x2e ??
		// 0x30 FONTCOUNT: number of fonts
	0x0032: { n:"BIFF2FONTXTRA", f:parse_BIFF2FONTXTRA },
		// 0x35: INFOOPTS
		// 0x36: TABLE (BIFF2 only)
		// 0x37: TABLE2 (BIFF2 only)
		// 0x38: WNDESK
		// 0x39 ??
		// 0x3a: BEGINPREF
		// 0x3b: ENDPREF
	0x003e: { n:"BIFF2WINDOW2" },
		// 0x3f ??
		// 0x46: SHOWSCROLL
		// 0x47: SHOWFORMULA
		// 0x48: STATUSBAR
		// 0x49: SHORTMENUS
		// 0x4A:
		// 0x4B:
		// 0x4C:
		// 0x4E:
		// 0x4F:
		// 0x58: TOOLBAR (BIFF3)
	
		/* - - - */
	0x0034: { n:"DDEObjName" },
	0x0043: { n:"BIFF2XF" },
	0x0044: { n:"BIFF2XFINDEX", f:parseuint16 },
	0x0045: { n:"BIFF2FONTCLR" },
	0x0056: { n:"BIFF4FMTCNT" }, /* 16-bit cnt, similar to BIFF2 */
	0x007e: { n:"RK" }, /* Not necessarily same as 0x027e */
	0x007f: { n:"ImData", f:parse_ImData },
	0x0087: { n:"Addin" },
	0x0088: { n:"Edg" },
	0x0089: { n:"Pub" },
		// 0x8A
		// 0x8B LH: alternate menu key flag (BIFF3/4)
		// 0x8E
		// 0x8F
	0x0091: { n:"Sub" },
		// 0x93 STYLE
	0x0094: { n:"LHRecord" },
	0x0095: { n:"LHNGraph" },
	0x0096: { n:"Sound" },
		// 0xA2 FNPROTO: function prototypes (BIFF4)
		// 0xA3
		// 0xA8
	0x00a9: { n:"CoordList" },
	0x00ab: { n:"GCW" },
	0x00bc: { n:"ShrFmla" }, /* Not necessarily same as 0x04bc */
	0x00bf: { n:"ToolbarHdr" },
	0x00c0: { n:"ToolbarEnd" },
	0x00c2: { n:"AddMenu" },
	0x00c3: { n:"DelMenu" },
	0x00d6: { n:"RString", f:parse_RString },
	0x00df: { n:"UDDesc" },
	0x00ea: { n:"TabIdConf" },
	0x0162: { n:"XL5Modify" },
	0x01a5: { n:"FileSharing2" },
	0x0206: { n:"Formula", f:parse_Formula },
	0x0209: { n:'BOF', f:parse_BOF },
	0x0218: { n:"Lbl", f:parse_Lbl },
	0x0223: { n:"ExternName", f:parse_ExternName },
	0x0231: { n:"Font" },
	0x0243: { n:"BIFF3XF" },
	0x0406: { n:"Formula", f:parse_Formula },
	0x0409: { n:'BOF', f:parse_BOF },
	0x0443: { n:"BIFF4XF" },
	0x086d: { n:"FeatInfo" },
	0x0873: { n:"FeatInfo11" },
	0x0881: { n:"SXAddl12" },
	0x08c0: { n:"AutoWebPub" },
	0x08c1: { n:"ListObj" },
	0x08c2: { n:"ListField" },
	0x08c3: { n:"ListDV" },
	0x08c4: { n:"ListCondFmt" },
	0x08c5: { n:"ListCF" },
	0x08c6: { n:"FMQry" },
	0x08c7: { n:"FMSQry" },
	0x08c8: { n:"PLV" },
	0x08c9: { n:"LnExt" },
	0x08ca: { n:"MkrExt" },
	0x08cb: { n:"CrtCoopt" },
	0x08d6: { n:"FRTArchId$", r:12 },
	
	0x7262: {}
	};
	
	var XLSRE = evert_key(XLSRecordEnum, 'n');
	function write_biff_rec(ba, type, payload, length) {
		var t = typeof type == "number" ? type : (+type || +XLSRE[type]);
		if(isNaN(t)) return;
		var len = length || (payload||[]).length || 0;
		var o = ba.next(4);
		o.write_shift(2, t);
		o.write_shift(2, len);
		if(len > 0 && is_buf(payload)) ba.push(payload);
	}
	
	function write_biff_continue(ba, type, payload, length) {
		var len = length || (payload||[]).length || 0;
		if(len <= 8224) return write_biff_rec(ba, type, payload, len);
		var t = +type || +XLSRE[type];
		if(isNaN(t)) return;
		var parts = payload.parts || [], sidx = 0;
		var i = 0, w = 0;
		while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
		var o = ba.next(4);
		o.write_shift(2, t);
		o.write_shift(2, w);
		ba.push(payload.slice(i, i + w));
		i += w;
		while(i < len) {
			o = ba.next(4);
			o.write_shift(2, 0x3c); // TODO: figure out correct continue type
			w = 0;
			while(w + (parts[sidx] || 8224) <= 8224) { w+= (parts[sidx] || 8224); sidx++; }
			o.write_shift(2, w);
			ba.push(payload.slice(i, i+w)); i+= w;
		}
	}
	
	function write_BIFF2Cell(out, r, c) {
		if(!out) out = new_buf(7);
		out.write_shift(2, r);
		out.write_shift(2, c);
		out.write_shift(2, 0);
		out.write_shift(1, 0);
		return out;
	}
	
	function write_BIFF2BERR(r, c, val, t) {
		var out = new_buf(9);
		write_BIFF2Cell(out, r, c);
		write_Bes(val, t || 'b', out);
		return out;
	}
	
	/* TODO: codepage, large strings */
	function write_BIFF2LABEL(r, c, val) {
		var out = new_buf(8 + 2*val.length);
		write_BIFF2Cell(out, r, c);
		out.write_shift(1, val.length);
		out.write_shift(val.length, val, 'sbcs');
		return out.l < out.length ? out.slice(0, out.l) : out;
	}
	
	function write_ws_biff2_cell(ba, cell, R, C) {
		if(cell.v != null) switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				if((v == (v|0)) && (v >= 0) && (v < 65536))
					write_biff_rec(ba, 0x0002, write_BIFF2INT(R, C, v));
				else
					write_biff_rec(ba, 0x0003, write_BIFF2NUM(R,C, v));
				return;
			case 'b': case 'e': write_biff_rec(ba, 0x0005, write_BIFF2BERR(R, C, cell.v, cell.t)); return;
			/* TODO: codepage, sst */
			case 's': case 'str':
				write_biff_rec(ba, 0x0004, write_BIFF2LABEL(R, C, (cell.v||"").slice(0,255)));
				return;
		}
		write_biff_rec(ba, 0x0001, write_BIFF2Cell(null, R, C));
	}
	
	function write_ws_biff2(ba, ws, idx, opts) {
		var dense = Array.isArray(ws);
		var range = safe_decode_range(ws['!ref'] || "A1"), ref, rr = "", cols = [];
		if(range.e.c > 0xFF || range.e.r > 0x3FFF) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
			range.e.c = Math.min(range.e.c, 0xFF);
			range.e.r = Math.min(range.e.c, 0x3FFF);
			ref = encode_range(range);
		}
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff2_cell(ba, cell, R, C, opts);
			}
		}
	}
	
	/* Based on test files */
	function write_biff2_buf(wb, opts) {
		var o = opts || {};
		if(DENSE != null && o.dense == null) o.dense = DENSE;
		var ba = buf_array();
		var idx = 0;
		for(var i=0;i<wb.SheetNames.length;++i) if(wb.SheetNames[i] == o.sheet) idx=i;
		if(idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
		write_biff_rec(ba, (o.biff == 4 ? 0x0409 : (o.biff == 3 ? 0x0209 : 0x0009)), write_BOF(wb, 0x10, o));
		/* ... */
		write_ws_biff2(ba, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
		/* ... */
		write_biff_rec(ba, 0x000A);
		return ba.end();
	}
	
	function write_FONTS_biff8(ba, data, opts) {
		write_biff_rec(ba, "Font", write_Font({
			sz:12,
			color: {theme:1},
			name: "Arial",
			family: 2,
			scheme: "minor"
		}, opts));
	}
	
	
	function write_FMTS_biff8(ba, NF, opts) {
		if(!NF) return;
		[[5,8],[23,26],[41,44],[/*63*/50,/*66],[164,*/392]].forEach(function(r) {
	for(var i = r[0]; i <= r[1]; ++i) if(NF[i] != null) write_biff_rec(ba, "Format", write_Format(i, NF[i], opts));
		});
	}
	
	function write_FEAT(ba, ws) {
		/* [MS-XLS] 2.4.112 */
		var o = new_buf(19);
		o.write_shift(4, 0x867); o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(2, 3); o.write_shift(1, 1); o.write_shift(4, 0);
		write_biff_rec(ba, "FeatHdr", o);
		/* [MS-XLS] 2.4.111 */
		o = new_buf(39);
		o.write_shift(4, 0x868); o.write_shift(4, 0); o.write_shift(4, 0);
		o.write_shift(2, 3); o.write_shift(1, 0); o.write_shift(4, 0);
		o.write_shift(2, 1); o.write_shift(4, 4); o.write_shift(2, 0);
		write_Ref8U(safe_decode_range(ws['!ref']||"A1"), o);
		o.write_shift(4, 4);
		write_biff_rec(ba, "Feat", o);
	}
	
	function write_CELLXFS_biff8(ba, opts) {
		for(var i = 0; i < 16; ++i) write_biff_rec(ba, "XF", write_XF({numFmtId:0, style:true}, 0, opts));
		opts.cellXfs.forEach(function(c) {
			write_biff_rec(ba, "XF", write_XF(c, 0, opts));
		});
	}
	
	function write_ws_biff8_hlinks(ba, ws) {
		for(var R=0; R<ws['!links'].length; ++R) {
			var HL = ws['!links'][R];
			write_biff_rec(ba, "HLink", write_HLink(HL));
			if(HL[1].Tooltip) write_biff_rec(ba, "HLinkTooltip", write_HLinkTooltip(HL));
		}
		delete ws['!links'];
	}
	
	function write_ws_cols_biff8(ba, cols, ws) {
		if(!cols) return;
		var cnt = 0;
		cols.forEach(function(col, idx) {
			if(++cnt <= 256 && col) {
				write_biff_rec(ba, "ColInfo", write_ColInfo(col_obj_w(idx, col), idx));
			}
		});
	}
	
	function write_ws_biff8_cell(ba, cell, R, C, opts) {
		var os = 16 + get_cell_style(opts.cellXfs, cell, opts);
		if(cell.v == null && !cell.bf) {
			write_biff_rec(ba, "Blank", write_XLSCell(R, C, os));
			return;
		}
		if(cell.bf) write_biff_rec(ba, "Formula", write_Formula(cell, R, C, opts, os));
		else switch(cell.t) {
			case 'd': case 'n':
				var v = cell.t == 'd' ? datenum(parseDate(cell.v)) : cell.v;
				/* TODO: emit RK as appropriate */
				write_biff_rec(ba, "Number", write_Number(R, C, v, os, opts));
				break;
			case 'b': case 'e':
				write_biff_rec(ba, 0x0205, write_BoolErr(R, C, cell.v, os, opts, cell.t));
				break;
			/* TODO: codepage, sst */
			case 's': case 'str':
				if(opts.bookSST) {
					var isst = get_sst_id(opts.Strings, cell.v, opts.revStrings);
					write_biff_rec(ba, "LabelSst", write_LabelSst(R, C, isst, os, opts));
				} else write_biff_rec(ba, "Label", write_Label(R, C, (cell.v||"").slice(0,255), os, opts));
				break;
			default:
				write_biff_rec(ba, "Blank", write_XLSCell(R, C, os));
		}
	}
	
	/* [MS-XLS] 2.1.7.20.5 */
	function write_ws_biff8(idx, opts, wb) {
		var ba = buf_array();
		var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
		var _WB = ((wb||{}).Workbook||{});
		var _sheet = ((_WB.Sheets||[])[idx]||{});
		var dense = Array.isArray(ws);
		var b8 = opts.biff == 8;
		var ref, rr = "", cols = [];
		var range = safe_decode_range(ws['!ref'] || "A1");
		var MAX_ROWS = b8 ? 65536 : 16384;
		if(range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
			if(opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
			range.e.c = Math.min(range.e.c, 0xFF);
			range.e.r = Math.min(range.e.c, MAX_ROWS-1);
		}
	
		write_biff_rec(ba, 0x0809, write_BOF(wb, 0x10, opts));
		/* [Uncalced] Index */
		write_biff_rec(ba, "CalcMode", writeuint16(1));
		write_biff_rec(ba, "CalcCount", writeuint16(100));
		write_biff_rec(ba, "CalcRefMode", writebool(true));
		write_biff_rec(ba, "CalcIter", writebool(false));
		write_biff_rec(ba, "CalcDelta", write_Xnum(0.001));
		write_biff_rec(ba, "CalcSaveRecalc", writebool(true));
		write_biff_rec(ba, "PrintRowCol", writebool(false));
		write_biff_rec(ba, "PrintGrid", writebool(false));
		write_biff_rec(ba, "GridSet", writeuint16(1));
		write_biff_rec(ba, "Guts", write_Guts([0,0]));
		/* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */
		/* Header (string) */
		/* Footer (string) */
		write_biff_rec(ba, "HCenter", writebool(false));
		write_biff_rec(ba, "VCenter", writebool(false));
		/* ... */
		if(b8) write_ws_cols_biff8(ba, ws["!cols"], ws);
		/* ... */
		write_biff_rec(ba, 0x200, write_Dimensions(range, opts));
		/* ... */
	
		if(b8) ws['!links'] = [];
		for(var R = range.s.r; R <= range.e.r; ++R) {
			rr = encode_row(R);
			for(var C = range.s.c; C <= range.e.c; ++C) {
				if(R === range.s.r) cols[C] = encode_col(C);
				ref = cols[C] + rr;
				var cell = dense ? (ws[R]||[])[C] : ws[ref];
				if(!cell) continue;
				/* write cell */
				write_ws_biff8_cell(ba, cell, R, C, opts);
				if(b8 && cell.l) ws['!links'].push([ref, cell.l]);
			}
		}
		var cname = _sheet.CodeName || _sheet.name || s;
		/* ... */
		if(b8) write_biff_rec(ba, "Window2", write_Window2((_WB.Views||[])[0]));
		/* ... */
		if(b8 && (ws['!merges']||[]).length) write_biff_rec(ba, "MergeCells", write_MergeCells(ws['!merges']));
		/* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */
		if(b8) write_ws_biff8_hlinks(ba, ws);
		/* [DVAL] */
		write_biff_rec(ba, "CodeName", write_XLUnicodeString(cname, opts));
		/* *WebPub *CellWatch [SheetExt] */
		if(b8) write_FEAT(ba, ws);
		/* *FEAT11 *RECORD12 */
		write_biff_rec(ba, "EOF");
		return ba.end();
	}
	
	/* [MS-XLS] 2.1.7.20.3 */
	function write_biff8_global(wb, bufs, opts) {
		var A = buf_array();
		var _WB = ((wb||{}).Workbook||{});
		var _sheets = (_WB.Sheets||[]);
		var _wb = _WB.WBProps||{};
		var b8 = opts.biff == 8, b5 = opts.biff == 5;
		write_biff_rec(A, 0x0809, write_BOF(wb, 0x05, opts));
		if(opts.bookType == "xla") write_biff_rec(A, "Addin");
		write_biff_rec(A, "InterfaceHdr", b8 ? writeuint16(0x04b0) : null);
		write_biff_rec(A, "Mms", writezeroes(2));
		if(b5) write_biff_rec(A, "ToolbarHdr");
		if(b5) write_biff_rec(A, "ToolbarEnd");
		write_biff_rec(A, "InterfaceEnd");
		write_biff_rec(A, "WriteAccess", write_WriteAccess("SheetJS", opts));
		/* [FileSharing] */
		write_biff_rec(A, "CodePage", writeuint16(b8 ? 0x04b0 : 0x04E4));
		/* *2047 Lel */
		if(b8) write_biff_rec(A, "DSF", writeuint16(0));
		if(b8) write_biff_rec(A, "Excel9File");
		write_biff_rec(A, "RRTabId", write_RRTabId(wb.SheetNames.length));
		if(b8 && wb.vbaraw) write_biff_rec(A, "ObProj");
		/* [ObNoMacros] */
		if(b8 && wb.vbaraw) {
			var cname = _wb.CodeName || "ThisWorkbook";
			write_biff_rec(A, "CodeName", write_XLUnicodeString(cname, opts));
		}
		write_biff_rec(A, "BuiltInFnGroupCount", writeuint16(0x11));
		/* *FnGroupName *FnGrp12 */
		/* *Lbl */
		/* [OleObjectSize] */
		write_biff_rec(A, "WinProtect", writebool(false));
		write_biff_rec(A, "Protect", writebool(false));
		write_biff_rec(A, "Password", writeuint16(0));
		if(b8) write_biff_rec(A, "Prot4Rev", writebool(false));
		if(b8) write_biff_rec(A, "Prot4RevPass", writeuint16(0));
		write_biff_rec(A, "Window1", write_Window1(opts));
		write_biff_rec(A, "Backup", writebool(false));
		write_biff_rec(A, "HideObj", writeuint16(0));
		write_biff_rec(A, "Date1904", writebool(safe1904(wb)=="true"));
		write_biff_rec(A, "CalcPrecision", writebool(true));
		if(b8) write_biff_rec(A, "RefreshAll", writebool(false));
		write_biff_rec(A, "BookBool", writeuint16(0));
		/* ... */
		write_FONTS_biff8(A, wb, opts);
		write_FMTS_biff8(A, wb.SSF, opts);
		write_CELLXFS_biff8(A, opts);
		/* ... */
		if(b8) write_biff_rec(A, "UsesELFs", writebool(false));
		var a = A.end();
	
		var C = buf_array();
		/* METADATA [MTRSettings] [ForceFullCalculation] */
		if(b8) write_biff_rec(C, "Country", write_Country());
		/* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture *MSODRAWINGGROUP */
	
		/* BIFF8: [SST *Continue] ExtSST */
		if(b8 && opts.Strings) write_biff_continue(C, "SST", write_SST(opts.Strings, opts));
	
		/* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */
		write_biff_rec(C, "EOF");
		var c = C.end();
	
		var B = buf_array();
		var blen = 0, j = 0;
		for(j = 0; j < wb.SheetNames.length; ++j) blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
		var start = a.length + blen + c.length;
		for(j = 0; j < wb.SheetNames.length; ++j) {
			var _sheet = _sheets[j] || ({});
			write_biff_rec(B, "BoundSheet8", write_BoundSheet8({pos:start, hs:_sheet.Hidden||0, dt:0, name:wb.SheetNames[j]}, opts));
			start += bufs[j].length;
		}
		/* 1*BoundSheet8 */
		var b = B.end();
		if(blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
	
		var out = [];
		if(a.length) out.push(a);
		if(b.length) out.push(b);
		if(c.length) out.push(c);
		return __toBuffer([out]);
	}
	
	/* [MS-XLS] 2.1.7.20 Workbook Stream */
	function write_biff8_buf(wb, opts) {
		var o = opts || {};
		var bufs = [];
	
		if(wb && !wb.SSF) {
			wb.SSF = SSF.get_table();
		}
		if(wb && wb.SSF) {
			make_ssf(SSF); SSF.load_table(wb.SSF);
			// $FlowIgnore
			o.revssf = evert_num(wb.SSF); o.revssf[wb.SSF[65535]] = 0;
			o.ssf = wb.SSF;
		}
	
		o.Strings = []; o.Strings.Count = 0; o.Strings.Unique = 0;
		fix_write_opts(o);
	
		o.cellXfs = [];
		get_cell_style(o.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		for(var i = 0; i < wb.SheetNames.length; ++i) bufs[bufs.length] = write_ws_biff8(i, o, wb);
		bufs.unshift(write_biff8_global(wb, bufs, o));
		return __toBuffer([bufs]);
	}
	
	function write_biff_buf(wb, opts) {
		for(var i = 0; i <= wb.SheetNames.length; ++i) {
			var ws = wb.Sheets[wb.SheetNames[i]];
			if(!ws || !ws["!ref"]) continue;
			var range = decode_range(ws["!ref"]);
			if(range.e.c > 255) { // note: 255 is IV
			  console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
			}
		}
	
		var o = opts || {};
		switch(o.biff || 2) {
			case 8: case 5: return write_biff8_buf(wb, opts);
			case 4: case 3: case 2: return write_biff2_buf(wb, opts);
		}
		throw new Error("invalid type " + o.bookType + " for BIFF");
	}
	/* note: browser DOM element cannot see mso- style attrs, must parse */
	var HTML_ = (function() {
		function html_to_sheet(str, _opts) {
			var opts = _opts || {};
			if(DENSE != null && opts.dense == null) opts.dense = DENSE;
			var ws = opts.dense ? ([]) : ({});
			str = str.replace(/<!--.*?-->/g, "");
			var mtch = str.match(/<table/i);
			if(!mtch) throw new Error("Invalid HTML: could not find <table>");
			var mtch2 = str.match(/<\/table/i);
			var i = mtch.index, j = mtch2 && mtch2.index || str.length;
			var rows = split_regex(str.slice(i, j), /(:?<tr[^>]*>)/i, "<tr>");
			var R = -1, C = 0, RS = 0, CS = 0;
			var range = {s:{r:10000000, c:10000000},e:{r:0,c:0}};
			var merges = [];
			for(i = 0; i < rows.length; ++i) {
				var row = rows[i].trim();
				var hd = row.slice(0,3).toLowerCase();
				if(hd == "<tr") { ++R; if(opts.sheetRows && opts.sheetRows <= R) { --R; break; } C = 0; continue; }
				if(hd != "<td" && hd != "<th") continue;
				var cells = row.split(/<\/t[dh]>/i);
				for(j = 0; j < cells.length; ++j) {
					var cell = cells[j].trim();
					if(!cell.match(/<t[dh]/i)) continue;
					var m = cell, cc = 0;
					/* TODO: parse styles etc */
					while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1) m = m.slice(cc+1);
					for(var midx = 0; midx < merges.length; ++midx) {
						var _merge = merges[midx];
						if(_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) { C = _merge.e.c + 1; midx = -1; }
					}
					var tag = parsexmltag(cell.slice(0, cell.indexOf(">")));
					CS = tag.colspan ? +tag.colspan : 1;
					if((RS = +tag.rowspan)>1 || CS>1) merges.push({s:{r:R,c:C},e:{r:R + (RS||1) - 1, c:C + CS - 1}});
					var _t = tag.t || tag["data-t"] || "";
					/* TODO: generate stub cells */
					if(!m.length) { C += CS; continue; }
					m = htmldecode(m);
					if(range.s.r > R) range.s.r = R; if(range.e.r < R) range.e.r = R;
					if(range.s.c > C) range.s.c = C; if(range.e.c < C) range.e.c = C;
					if(!m.length) continue;
					var o = {t:'s', v:m};
					if(opts.raw || !m.trim().length || _t == 's'){}
					else if(m === 'TRUE') o = {t:'b', v:true};
					else if(m === 'FALSE') o = {t:'b', v:false};
					else if(!isNaN(fuzzynum(m))) o = {t:'n', v:fuzzynum(m)};
					else if(!isNaN(fuzzydate(m).getDate())) {
						o = ({t:'d', v:parseDate(m)});
						if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
						o.z = opts.dateNF || SSF._table[14];
					}
					if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = o; }
					else ws[encode_cell({r:R, c:C})] = o;
					C += CS;
				}
			}
			ws['!ref'] = encode_range(range);
			if(merges.length) ws["!merges"] = merges;
			return ws;
		}
		function html_to_book(str, opts) {
			var mtch = str.match(/<table.*?>[\s\S]*?<\/table>/gi);
			if(!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
			if(mtch.length == 1) return sheet_to_workbook(html_to_sheet(mtch[0], opts), opts);
			var wb = utils.book_new();
			mtch.forEach(function(s, idx) { utils.book_append_sheet(wb, html_to_sheet(s, opts), "Sheet" + (idx+1)); });
			return wb;
		}
		function make_html_row(ws, r, R, o) {
			var M = (ws['!merges'] ||[]);
			var oo = [];
			for(var C = r.s.c; C <= r.e.c; ++C) {
				var RS = 0, CS = 0;
				for(var j = 0; j < M.length; ++j) {
					if(M[j].s.r > R || M[j].s.c > C) continue;
					if(M[j].e.r < R || M[j].e.c < C) continue;
					if(M[j].s.r < R || M[j].s.c < C) { RS = -1; break; }
					RS = M[j].e.r - M[j].s.r + 1; CS = M[j].e.c - M[j].s.c + 1; break;
				}
				if(RS < 0) continue;
				var coord = encode_cell({r:R,c:C});
				var cell = o.dense ? (ws[R]||[])[C] : ws[coord];
				/* TODO: html entities */
				var w = (cell && cell.v != null) && (cell.h || escapehtml(cell.w || (format_cell(cell), cell.w) || "")) || "";
				var sp = ({});
				if(RS > 1) sp.rowspan = RS;
				if(CS > 1) sp.colspan = CS;
				if(o.editable) w = '<span contenteditable="true">' + w + '</span>';
				else if(cell) {
					sp["data-t"] = cell && cell.t || 'z';
					if(cell.v != null) sp["data-v"] = cell.v;
					if(cell.z != null) sp["data-z"] = cell.z;
					if(cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + cell.l.Target +'">' + w + '</a>';
				}
				sp.id = (o.id || "sjs") + "-" + coord;
				oo.push(writextag('td', w, sp));
			}
			var preamble = "<tr>";
			return preamble + oo.join("") + "</tr>";
		}
		function make_html_preamble(ws, R, o) {
			var out = [];
			return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
		}
		var _BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
		var _END = '</body></html>';
		function sheet_to_html(ws, opts/*, wb:?Workbook*/) {
			var o = opts || {};
			var header = o.header != null ? o.header : _BEGIN;
			var footer = o.footer != null ? o.footer : _END;
			var out = [header];
			var r = decode_range(ws['!ref']);
			o.dense = Array.isArray(ws);
			out.push(make_html_preamble(ws, r, o));
			for(var R = r.s.r; R <= r.e.r; ++R) out.push(make_html_row(ws, r, R, o));
			out.push("</table>" + footer);
			return out.join("");
	
		}
		return {
			to_workbook: html_to_book,
			to_sheet: html_to_sheet,
			_row: make_html_row,
			BEGIN: _BEGIN,
			END: _END,
			_preamble: make_html_preamble,
			from_sheet: sheet_to_html
		};
	})();
	
	function sheet_add_dom(ws, table, _opts) {
		var opts = _opts || {};
		if(DENSE != null) opts.dense = DENSE;
		var or_R = 0, or_C = 0;
		if(opts.origin != null) {
			if(typeof opts.origin == 'number') or_R = opts.origin;
			else {
				var _origin = typeof opts.origin == "string" ? decode_cell(opts.origin) : opts.origin;
				or_R = _origin.r; or_C = _origin.c;
			}
		}
		var rows = table.getElementsByTagName('tr');
		var sheetRows = Math.min(opts.sheetRows||10000000, rows.length);
		var range = {s:{r:0,c:0},e:{r:or_R,c:or_C}};
		if(ws["!ref"]) {
			var _range = decode_range(ws["!ref"]);
			range.s.r = Math.min(range.s.r, _range.s.r);
			range.s.c = Math.min(range.s.c, _range.s.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			range.e.c = Math.max(range.e.c, _range.e.c);
			if(or_R == -1) range.e.r = or_R = _range.e.r + 1;
		}
		var merges = [], midx = 0;
		var rowinfo = ws["!rows"] || (ws["!rows"] = []);
		var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
		if(!ws["!cols"]) ws['!cols'] = [];
		for(; _R < rows.length && R < sheetRows; ++_R) {
			var row = rows[_R];
			if (is_dom_element_hidden(row)) {
				if (opts.display) continue;
				rowinfo[R] = {hidden: true};
			}
			var elts = (row.children);
			for(_C = C = 0; _C < elts.length; ++_C) {
				var elt = elts[_C];
				if (opts.display && is_dom_element_hidden(elt)) continue;
				var v = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : htmldecode(elt.innerHTML);
				var z = elt.getAttribute('data-z') || elt.getAttribute('z');
				for(midx = 0; midx < merges.length; ++midx) {
					var m = merges[midx];
					if(m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) { C = m.e.c+1 - or_C; midx = -1; }
				}
				/* TODO: figure out how to extract nonstandard mso- style */
				CS = +elt.getAttribute("colspan") || 1;
				if( ((RS = (+elt.getAttribute("rowspan") || 1)))>1 || CS>1) merges.push({s:{r:R + or_R,c:C + or_C},e:{r:R + or_R + (RS||1) - 1, c:C + or_C + (CS||1) - 1}});
				var o = {t:'s', v:v};
				var _t = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
				if(v != null) {
					if(v.length == 0) o.t = _t || 'z';
					else if(opts.raw || v.trim().length == 0 || _t == "s"){}
					else if(v === 'TRUE') o = {t:'b', v:true};
					else if(v === 'FALSE') o = {t:'b', v:false};
					else if(!isNaN(fuzzynum(v))) o = {t:'n', v:fuzzynum(v)};
					else if(!isNaN(fuzzydate(v).getDate())) {
						o = ({t:'d', v:parseDate(v)});
						if(!opts.cellDates) o = ({t:'n', v:datenum(o.v)});
						o.z = opts.dateNF || SSF._table[14];
					}
				}
				if(o.z === undefined && z != null) o.z = z;
				/* The first link is used.  Links are assumed to be fully specified.
				 * TODO: The right way to process relative links is to make a new <a> */
				var l = "", Aelts = elt.getElementsByTagName("A");
				if(Aelts && Aelts.length) for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)	if(Aelts[Aelti].hasAttribute("href")) {
					l = Aelts[Aelti].getAttribute("href"); if(l.charAt(0) != "#") break;
				}
				if(l && l.charAt(0) != "#") o.l = ({ Target: l });
				if(opts.dense) { if(!ws[R + or_R]) ws[R + or_R] = []; ws[R + or_R][C + or_C] = o; }
				else ws[encode_cell({c:C + or_C, r:R + or_R})] = o;
				if(range.e.c < C + or_C) range.e.c = C + or_C;
				C += CS;
			}
			++R;
		}
		if(merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
		range.e.r = Math.max(range.e.r, R - 1 + or_R);
		ws['!ref'] = encode_range(range);
		if(R >= sheetRows) ws['!fullref'] = encode_range((range.e.r = rows.length-_R+R-1 + or_R,range)); // We can count the real number of rows to parse but we don't to improve the performance
		return ws;
	}
	
	function parse_dom_table(table, _opts) {
		var opts = _opts || {};
		var ws = opts.dense ? ([]) : ({});
		return sheet_add_dom(ws, table, _opts);
	}
	
	function table_to_book(table, opts) {
		return sheet_to_workbook(parse_dom_table(table, opts), opts);
	}
	
	function is_dom_element_hidden(element) {
		var display = '';
		var get_computed_style = get_get_computed_style_function(element);
		if(get_computed_style) display = get_computed_style(element).getPropertyValue('display');
		if(!display) display = element.style.display; // Fallback for cases when getComputedStyle is not available (e.g. an old browser or some Node.js environments) or doesn't work (e.g. if the element is not inserted to a document)
		return display === 'none';
	}
	
	/* global getComputedStyle */
	function get_get_computed_style_function(element) {
		// The proper getComputedStyle implementation is the one defined in the element window
		if(element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
		// If it is not available, try to get one from the global namespace
		if(typeof getComputedStyle === 'function') return getComputedStyle;
		return null;
	}
	/* OpenDocument */
	var parse_content_xml = (function() {
	
		var parse_text_p = function(text) {
			/* 6.1.2 White Space Characters */
			var fixed = text
				.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ")
				.replace(/<text:s\/>/g," ")
				.replace(/<text:s text:c="(\d+)"\/>/g, function($$,$1) { return Array(parseInt($1,10)+1).join(" "); })
				.replace(/<text:tab[^>]*\/>/g,"\t")
				.replace(/<text:line-break\/>/g,"\n");
			var v = unescapexml(fixed.replace(/<[^>]*>/g,""));
	
			return [v];
		};
	
		var number_formats = {
			/* ods name: [short ssf fmt, long ssf fmt] */
			day:           ["d",   "dd"],
			month:         ["m",   "mm"],
			year:          ["y",   "yy"],
			hours:         ["h",   "hh"],
			minutes:       ["m",   "mm"],
			seconds:       ["s",   "ss"],
			"am-pm":       ["A/P", "AM/PM"],
			"day-of-week": ["ddd", "dddd"],
			era:           ["e",   "ee"],
			/* there is no native representation of LO "Q" format */
			quarter:       ["\\Qm", "m\\\"th quarter\""]
		};
	
		return function pcx(d, _opts) {
			var opts = _opts || {};
			if(DENSE != null && opts.dense == null) opts.dense = DENSE;
			var str = xlml_normalize(d);
			var state = [], tmp;
			var tag;
			var NFtag = {name:""}, NF = "", pidx = 0;
			var sheetag;
			var rowtag;
			var Sheets = {}, SheetNames = [];
			var ws = opts.dense ? ([]) : ({});
			var Rn, q;
			var ctag = ({value:""});
			var textp = "", textpidx = 0, textptag;
			var textR = [];
			var R = -1, C = -1, range = {s: {r:1000000,c:10000000}, e: {r:0, c:0}};
			var row_ol = 0;
			var number_format_map = {};
			var merges = [], mrange = {}, mR = 0, mC = 0;
			var rowinfo = [], rowpeat = 1, colpeat = 1;
			var arrayf = [];
			var WB = {Names:[]};
			var atag = ({});
			var _Ref = ["", ""];
			var comments = [], comment = ({});
			var creator = "", creatoridx = 0;
			var isstub = false, intable = false;
			var i = 0;
			xlmlregex.lastIndex = 0;
			str = str.replace(/<!--([\s\S]*?)-->/mg,"").replace(/<!DOCTYPE[^\[]*\[[^\]]*\]>/gm,"");
			while((Rn = xlmlregex.exec(str))) switch((Rn[3]=Rn[3].replace(/_.*$/,""))) {
	
				case 'table': case '工作表': // 9.1.2 <table:table>
					if(Rn[1]==='/') {
						if(range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = encode_range(range);
						else ws['!ref'] = "A1:A1";
						if(opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
							ws['!fullref'] = ws['!ref'];
							range.e.r = opts.sheetRows - 1;
							ws['!ref'] = encode_range(range);
						}
						if(merges.length) ws['!merges'] = merges;
						if(rowinfo.length) ws["!rows"] = rowinfo;
						sheetag.name = sheetag['名称'] || sheetag.name;
						if(typeof JSON !== 'undefined') JSON.stringify(sheetag);
						SheetNames.push(sheetag.name);
						Sheets[sheetag.name] = ws;
						intable = false;
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						sheetag = parsexmltag(Rn[0], false);
						R = C = -1;
						range.s.r = range.s.c = 10000000; range.e.r = range.e.c = 0;
						ws = opts.dense ? ([]) : ({}); merges = [];
						rowinfo = [];
						intable = true;
					}
					break;
	
				case 'table-row-group': // 9.1.9 <table:table-row-group>
					if(Rn[1] === "/") --row_ol; else ++row_ol;
					break;
				case 'table-row': case '行': // 9.1.3 <table:table-row>
					if(Rn[1] === '/') { R+=rowpeat; rowpeat = 1; break; }
					rowtag = parsexmltag(Rn[0], false);
					if(rowtag['行号']) R = rowtag['行号'] - 1; else if(R == -1) R = 0;
					rowpeat = +rowtag['number-rows-repeated'] || 1;
					/* TODO: remove magic */
					if(rowpeat < 10) for(i = 0; i < rowpeat; ++i) if(row_ol > 0) rowinfo[R + i] = {level: row_ol};
					C = -1; break;
				case 'covered-table-cell': // 9.1.5 <table:covered-table-cell>
					if(Rn[1] !== '/') ++C;
					if(opts.sheetStubs) {
						if(opts.dense) { if(!ws[R]) ws[R] = []; ws[R][C] = {t:'z'}; }
						else ws[encode_cell({r:R,c:C})] = {t:'z'};
					}
					textp = ""; textR = [];
					break; /* stub */
				case 'table-cell': case '数据':
					if(Rn[0].charAt(Rn[0].length-2) === '/') {
						++C;
						ctag = parsexmltag(Rn[0], false);
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						q = ({t:'z', v:null});
						if(ctag.formula && opts.cellFormula != false) q.f = ods_to_csf_formula(unescapexml(ctag.formula));
						if((ctag['数据类型'] || ctag['value-type']) == "string") {
							q.t = "s"; q.v = unescapexml(ctag['string-value'] || "");
							if(opts.dense) {
								if(!ws[R]) ws[R] = [];
								ws[R][C] = q;
							} else {
								ws[encode_cell({r:R,c:C})] = q;
							}
						}
						C+= colpeat-1;
					} else if(Rn[1]!=='/') {
						++C;
						textp = ""; textpidx = 0; textR = [];
						colpeat = 1;
						var rptR = rowpeat ? R + rowpeat - 1 : R;
						if(C > range.e.c) range.e.c = C;
						if(C < range.s.c) range.s.c = C;
						if(R < range.s.r) range.s.r = R;
						if(rptR > range.e.r) range.e.r = rptR;
						ctag = parsexmltag(Rn[0], false);
						comments = []; comment = ({});
						q = ({t:ctag['数据类型'] || ctag['value-type'], v:null});
						if(opts.cellFormula) {
							if(ctag.formula) ctag.formula = unescapexml(ctag.formula);
							if(ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
								mR = parseInt(ctag['number-matrix-rows-spanned'],10) || 0;
								mC = parseInt(ctag['number-matrix-columns-spanned'],10) || 0;
								mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
								q.F = encode_range(mrange);
								arrayf.push([mrange, q.F]);
							}
							if(ctag.formula) q.f = ods_to_csf_formula(ctag.formula);
							else for(i = 0; i < arrayf.length; ++i)
								if(R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r)
									if(C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c)
										q.F = arrayf[i][1];
						}
						if(ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
							mR = parseInt(ctag['number-rows-spanned'],10) || 0;
							mC = parseInt(ctag['number-columns-spanned'],10) || 0;
							mrange = {s: {r:R,c:C}, e:{r:R + mR-1,c:C + mC-1}};
							merges.push(mrange);
						}
	
						/* 19.675.2 table:number-columns-repeated */
						if(ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
	
						/* 19.385 office:value-type */
						switch(q.t) {
							case 'boolean': q.t = 'b'; q.v = parsexmlbool(ctag['boolean-value']); break;
							case 'float': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'percentage': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'currency': q.t = 'n'; q.v = parseFloat(ctag.value); break;
							case 'date': q.t = 'd'; q.v = parseDate(ctag['date-value']);
								if(!opts.cellDates) { q.t = 'n'; q.v = datenum(q.v); }
								q.z = 'm/d/yy'; break;
							case 'time': q.t = 'n'; q.v = parse_isodur(ctag['time-value'])/86400;
								if(opts.cellDates) { q.t = 'd'; q.v = numdate(q.v); }
								q.z = 'HH:MM:SS'; break;
							case 'number': q.t = 'n'; q.v = parseFloat(ctag['数据数值']); break;
							default:
								if(q.t === 'string' || q.t === 'text' || !q.t) {
									q.t = 's';
									if(ctag['string-value'] != null) { textp = unescapexml(ctag['string-value']); textR = []; }
								} else throw new Error('Unsupported value type ' + q.t);
						}
					} else {
						isstub = false;
						if(q.t === 's') {
							q.v = textp || '';
							if(textR.length) q.R = textR;
							isstub = textpidx == 0;
						}
						if(atag.Target) q.l = atag;
						if(comments.length > 0) { q.c = comments; comments = []; }
						if(textp && opts.cellText !== false) q.w = textp;
						if(isstub) { q.t = "z"; delete q.v; }
						if(!isstub || opts.sheetStubs) {
							if(!(opts.sheetRows && opts.sheetRows <= R)) {
								for(var rpt = 0; rpt < rowpeat; ++rpt) {
									colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
									if(opts.dense) {
										if(!ws[R + rpt]) ws[R + rpt] = [];
										ws[R + rpt][C] = rpt == 0 ? q : dup(q);
										while(--colpeat > 0) ws[R + rpt][C + colpeat] = dup(q);
									} else {
										ws[encode_cell({r:R + rpt,c:C})] = q;
										while(--colpeat > 0) ws[encode_cell({r:R + rpt,c:C + colpeat})] = dup(q);
									}
									if(range.e.c <= C) range.e.c = C;
								}
							}
						}
						colpeat = parseInt(ctag['number-columns-repeated']||"1", 10);
						C += colpeat-1; colpeat = 0;
						q = {};
						textp = ""; textR = [];
					}
					atag = ({});
					break; // 9.1.4 <table:table-cell>
	
				/* pure state */
				case 'document': // TODO: <office:document> is the root for FODS
				case 'document-content': case '电子表格文档': // 3.1.3.2 <office:document-content>
				case 'spreadsheet': case '主体': // 3.7 <office:spreadsheet>
				case 'scripts': // 3.12 <office:scripts>
				case 'styles': // TODO <office:styles>
				case 'font-face-decls': // 3.14 <office:font-face-decls>
				case 'master-styles': // 3.15.4 <office:master-styles> -- relevant for FODS
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], true]);
					break;
	
				case 'annotation': // 14.1 <office:annotation>
					if(Rn[1]==='/'){
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
						comment.t = textp;
						if(textR.length) comment.R = textR;
						comment.a = creator;
						comments.push(comment);
					}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') {state.push([Rn[3], false]);}
					creator = ""; creatoridx = 0;
					textp = ""; textpidx = 0; textR = [];
					break;
	
				case 'creator': // 4.3.2.7 <dc:creator>
					if(Rn[1]==='/') { creator = str.slice(creatoridx,Rn.index); }
					else creatoridx = Rn.index + Rn[0].length;
					break;
	
				/* ignore state */
				case 'meta': case '元数据': // TODO: <office:meta> <uof:元数据> FODS/UOF
				case 'settings': // TODO: <office:settings>
				case 'config-item-set': // TODO: <office:config-item-set>
				case 'config-item-map-indexed': // TODO: <office:config-item-map-indexed>
				case 'config-item-map-entry': // TODO: <office:config-item-map-entry>
				case 'config-item-map-named': // TODO: <office:config-item-map-entry>
				case 'shapes': // 9.2.8 <table:shapes>
				case 'frame': // 10.4.2 <draw:frame>
				case 'text-box': // 10.4.3 <draw:text-box>
				case 'image': // 10.4.4 <draw:image>
				case 'data-pilot-tables': // 9.6.2 <table:data-pilot-tables>
				case 'list-style': // 16.30 <text:list-style>
				case 'form': // 13.13 <form:form>
				case 'dde-links': // 9.8 <table:dde-links>
				case 'event-listeners': // TODO
				case 'chart': // TODO
					if(Rn[1]==='/'){if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;}
					else if(Rn[0].charAt(Rn[0].length-2) !== '/') state.push([Rn[3], false]);
					textp = ""; textpidx = 0; textR = [];
					break;
	
				case 'scientific-number': // TODO: <number:scientific-number>
					break;
				case 'currency-symbol': // TODO: <number:currency-symbol>
					break;
				case 'currency-style': // TODO: <number:currency-style>
					break;
				case 'number-style': // 16.27.2 <number:number-style>
				case 'percentage-style': // 16.27.9 <number:percentage-style>
				case 'date-style': // 16.27.10 <number:date-style>
				case 'time-style': // 16.27.18 <number:time-style>
					if(Rn[1]==='/'){
						number_format_map[NFtag.name] = NF;
						if((tmp=state.pop())[0]!==Rn[3]) throw "Bad state: "+tmp;
					} else if(Rn[0].charAt(Rn[0].length-2) !== '/') {
						NF = "";
						NFtag = parsexmltag(Rn[0], false);
						state.push([Rn[3], true]);
					} break;
	
				case 'script': break; // 3.13 <office:script>
				case 'libraries': break; // TODO: <ooo:libraries>
				case 'automatic-styles': break; // 3.15.3 <office:automatic-styles>
	
				case 'default-style': // TODO: <style:default-style>
				case 'page-layout': break; // TODO: <style:page-layout>
				case 'style': // 16.2 <style:style>
					break;
				case 'map': break; // 16.3 <style:map>
				case 'font-face': break; // 16.21 <style:font-face>
	
				case 'paragraph-properties': break; // 17.6 <style:paragraph-properties>
				case 'table-properties': break; // 17.15 <style:table-properties>
				case 'table-column-properties': break; // 17.16 <style:table-column-properties>
				case 'table-row-properties': break; // 17.17 <style:table-row-properties>
				case 'table-cell-properties': break; // 17.18 <style:table-cell-properties>
	
				case 'number': // 16.27.3 <number:number>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'fraction': break; // TODO 16.27.6 <number:fraction>
	
				case 'day': // 16.27.11 <number:day>
				case 'month': // 16.27.12 <number:month>
				case 'year': // 16.27.13 <number:year>
				case 'era': // 16.27.14 <number:era>
				case 'day-of-week': // 16.27.15 <number:day-of-week>
				case 'week-of-year': // 16.27.16 <number:week-of-year>
				case 'quarter': // 16.27.17 <number:quarter>
				case 'hours': // 16.27.19 <number:hours>
				case 'minutes': // 16.27.20 <number:minutes>
				case 'seconds': // 16.27.21 <number:seconds>
				case 'am-pm': // 16.27.22 <number:am-pm>
					switch(state[state.length-1][0]) {
						case 'time-style':
						case 'date-style':
							tag = parsexmltag(Rn[0], false);
							NF += number_formats[Rn[3]][tag.style==='long'?1:0]; break;
					} break;
	
				case 'boolean-style': break; // 16.27.23 <number:boolean-style>
				case 'boolean': break; // 16.27.24 <number:boolean>
				case 'text-style': break; // 16.27.25 <number:text-style>
				case 'text': // 16.27.26 <number:text>
					if(Rn[0].slice(-2) === "/>") break;
					else if(Rn[1]==="/") switch(state[state.length-1][0]) {
						case 'number-style':
						case 'date-style':
						case 'time-style':
							NF += str.slice(pidx, Rn.index);
							break;
					}
					else pidx = Rn.index + Rn[0].length;
					break;
	
				case 'named-range': // 9.4.12 <table:named-range>
					tag = parsexmltag(Rn[0], false);
					_Ref = ods_to_csf_3D(tag['cell-range-address']);
					var nrange = ({Name:tag.name, Ref:_Ref[0] + '!' + _Ref[1]});
					if(intable) nrange.Sheet = SheetNames.length;
					WB.Names.push(nrange);
					break;
	
				case 'text-content': break; // 16.27.27 <number:text-content>
				case 'text-properties': break; // 16.27.27 <style:text-properties>
				case 'embedded-text': break; // 16.27.4 <number:embedded-text>
	
				case 'body': case '电子表格': break; // 3.3 16.9.6 19.726.3
	
				case 'forms': break; // 12.25.2 13.2
				case 'table-column': break; // 9.1.6 <table:table-column>
				case 'table-header-rows': break; // 9.1.7 <table:table-header-rows>
				case 'table-rows': break; // 9.1.12 <table:table-rows>
				/* TODO: outline levels */
				case 'table-column-group': break; // 9.1.10 <table:table-column-group>
				case 'table-header-columns': break; // 9.1.11 <table:table-header-columns>
				case 'table-columns': break; // 9.1.12 <table:table-columns>
	
				case 'null-date': break; // 9.4.2 <table:null-date> TODO: date1904
	
				case 'graphic-properties': break; // 17.21 <style:graphic-properties>
				case 'calculation-settings': break; // 9.4.1 <table:calculation-settings>
				case 'named-expressions': break; // 9.4.11 <table:named-expressions>
				case 'label-range': break; // 9.4.9 <table:label-range>
				case 'label-ranges': break; // 9.4.10 <table:label-ranges>
				case 'named-expression': break; // 9.4.13 <table:named-expression>
				case 'sort': break; // 9.4.19 <table:sort>
				case 'sort-by': break; // 9.4.20 <table:sort-by>
				case 'sort-groups': break; // 9.4.22 <table:sort-groups>
	
				case 'tab': break; // 6.1.4 <text:tab>
				case 'line-break': break; // 6.1.5 <text:line-break>
				case 'span': break; // 6.1.7 <text:span>
				case 'p': case '文本串': // 5.1.3 <text:p>
					if(['master-styles'].indexOf(state[state.length-1][0]) > -1) break;
					if(Rn[1]==='/' && (!ctag || !ctag['string-value'])) {
						var ptp = parse_text_p(str.slice(textpidx,Rn.index), textptag);
						textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
					} else { textptag = parsexmltag(Rn[0], false); textpidx = Rn.index + Rn[0].length; }
					break; // <text:p>
				case 's': break; // <text:s>
	
				case 'database-range': // 9.4.15 <table:database-range>
					if(Rn[1]==='/') break;
					try {
						_Ref = ods_to_csf_3D(parsexmltag(Rn[0])['target-range-address']);
						Sheets[_Ref[0]]['!autofilter'] = { ref:_Ref[1] };
					} catch(e) {/* empty */}
					break;
	
				case 'date': break; // <*:date>
	
				case 'object': break; // 10.4.6.2 <draw:object>
				case 'title': case '标题': break; // <*:title> OR <uof:标题>
				case 'desc': break; // <*:desc>
				case 'binary-data': break; // 10.4.5 TODO: b64 blob
	
				/* 9.2 Advanced Tables */
				case 'table-source': break; // 9.2.6
				case 'scenario': break; // 9.2.6
	
				case 'iteration': break; // 9.4.3 <table:iteration>
				case 'content-validations': break; // 9.4.4 <table:
				case 'content-validation': break; // 9.4.5 <table:
				case 'help-message': break; // 9.4.6 <table:
				case 'error-message': break; // 9.4.7 <table:
				case 'database-ranges': break; // 9.4.14 <table:database-ranges>
				case 'filter': break; // 9.5.2 <table:filter>
				case 'filter-and': break; // 9.5.3 <table:filter-and>
				case 'filter-or': break; // 9.5.4 <table:filter-or>
				case 'filter-condition': break; // 9.5.5 <table:filter-condition>
	
				case 'list-level-style-bullet': break; // 16.31 <text:
				case 'list-level-style-number': break; // 16.32 <text:
				case 'list-level-properties': break; // 17.19 <style:
	
				/* 7.3 Document Fields */
				case 'sender-firstname': // 7.3.6.2
				case 'sender-lastname': // 7.3.6.3
				case 'sender-initials': // 7.3.6.4
				case 'sender-title': // 7.3.6.5
				case 'sender-position': // 7.3.6.6
				case 'sender-email': // 7.3.6.7
				case 'sender-phone-private': // 7.3.6.8
				case 'sender-fax': // 7.3.6.9
				case 'sender-company': // 7.3.6.10
				case 'sender-phone-work': // 7.3.6.11
				case 'sender-street': // 7.3.6.12
				case 'sender-city': // 7.3.6.13
				case 'sender-postal-code': // 7.3.6.14
				case 'sender-country': // 7.3.6.15
				case 'sender-state-or-province': // 7.3.6.16
				case 'author-name': // 7.3.7.1
				case 'author-initials': // 7.3.7.2
				case 'chapter': // 7.3.8
				case 'file-name': // 7.3.9
				case 'template-name': // 7.3.9
				case 'sheet-name': // 7.3.9
					break;
	
				case 'event-listener':
					break;
				/* TODO: FODS Properties */
				case 'initial-creator':
				case 'creation-date':
				case 'print-date':
				case 'generator':
				case 'document-statistic':
				case 'user-defined':
				case 'editing-duration':
				case 'editing-cycles':
					break;
	
				/* TODO: FODS Config */
				case 'config-item':
					break;
	
				/* TODO: style tokens */
				case 'page-number': break; // TODO <text:page-number>
				case 'page-count': break; // TODO <text:page-count>
				case 'time': break; // TODO <text:time>
	
				/* 9.3 Advanced Table Cells */
				case 'cell-range-source': break; // 9.3.1 <table:
				case 'detective': break; // 9.3.2 <table:
				case 'operation': break; // 9.3.3 <table:
				case 'highlighted-range': break; // 9.3.4 <table:
	
				/* 9.6 Data Pilot Tables <table: */
				case 'data-pilot-table': // 9.6.3
				case 'source-cell-range': // 9.6.5
				case 'source-service': // 9.6.6
				case 'data-pilot-field': // 9.6.7
				case 'data-pilot-level': // 9.6.8
				case 'data-pilot-subtotals': // 9.6.9
				case 'data-pilot-subtotal': // 9.6.10
				case 'data-pilot-members': // 9.6.11
				case 'data-pilot-member': // 9.6.12
				case 'data-pilot-display-info': // 9.6.13
				case 'data-pilot-sort-info': // 9.6.14
				case 'data-pilot-layout-info': // 9.6.15
				case 'data-pilot-field-reference': // 9.6.16
				case 'data-pilot-groups': // 9.6.17
				case 'data-pilot-group': // 9.6.18
				case 'data-pilot-group-member': // 9.6.19
					break;
	
				/* 10.3 Drawing Shapes */
				case 'rect': // 10.3.2
					break;
	
				/* 14.6 DDE Connections */
				case 'dde-connection-decls': // 14.6.2 <text:
				case 'dde-connection-decl': // 14.6.3 <text:
				case 'dde-link': // 14.6.4 <table:
				case 'dde-source': // 14.6.5 <office:
					break;
	
				case 'properties': break; // 13.7 <form:properties>
				case 'property': break; // 13.8 <form:property>
	
				case 'a': // 6.1.8 hyperlink
					if(Rn[1]!== '/') {
						atag = parsexmltag(Rn[0], false);
						if(!atag.href) break;
						atag.Target = unescapexml(atag.href); delete atag.href;
						if(atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
							_Ref = ods_to_csf_3D(atag.Target.slice(1));
							atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
						} else if(atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
					}
					break;
	
				/* non-standard */
				case 'table-protection': break;
				case 'data-pilot-grand-total': break; // <table:
				case 'office-document-common-attrs': break; // bare
				default: switch(Rn[2]) {
					case 'dc:':       // TODO: properties
					case 'calcext:':  // ignore undocumented extensions
					case 'loext:':    // ignore undocumented extensions
					case 'ooo:':      // ignore undocumented extensions
					case 'chartooo:': // ignore undocumented extensions
					case 'draw:':     // TODO: drawing
					case 'style:':    // TODO: styles
					case 'chart:':    // TODO: charts
					case 'form:':     // TODO: forms
					case 'uof:':      // TODO: uof
					case '表:':       // TODO: uof
					case '字:':       // TODO: uof
						break;
					default: if(opts.WTF) throw new Error(Rn);
				}
			}
			var out = ({
				Sheets: Sheets,
				SheetNames: SheetNames,
				Workbook: WB
			});
			if(opts.bookSheets) delete out.Sheets;
			return out;
		};
	})();
	
	function parse_ods(zip, opts) {
		opts = opts || ({});
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) parse_manifest(getzipdata(zip, 'META-INF/manifest.xml'), opts);
		var content = getzipstr(zip, 'content.xml');
		if(!content) throw new Error("Missing content.xml in ODS / UOF file");
		var wb = parse_content_xml(utf8read(content), opts);
		if(safegetzipfile(zip, 'meta.xml')) wb.Props = parse_core_props(getzipdata(zip, 'meta.xml'));
		return wb;
	}
	function parse_fods(data, opts) {
		return parse_content_xml(data, opts);
	}
	
	/* OpenDocument */
	var write_styles_ods = (function() {
		var master_styles = [
			'<office:master-styles>',
				'<style:master-page style:name="mp1" style:page-layout-name="mp1">',
					'<style:header/>',
					'<style:header-left style:display="false"/>',
					'<style:footer/>',
					'<style:footer-left style:display="false"/>',
				'</style:master-page>',
			'</office:master-styles>'
		].join("");
	
		var payload = '<office:document-styles ' + wxt_helper({
			'xmlns:office':   "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
			'xmlns:table':    "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
			'xmlns:style':    "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
			'xmlns:text':     "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
			'xmlns:draw':     "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
			'xmlns:fo':       "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
			'xmlns:xlink':    "http://www.w3.org/1999/xlink",
			'xmlns:dc':       "http://purl.org/dc/elements/1.1/",
			'xmlns:number':   "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
			'xmlns:svg':      "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
			'xmlns:of':       "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
			'office:version': "1.2"
		}) + '>' + master_styles + '</office:document-styles>';
	
		return function wso() {
			return XML_HEADER + payload;
		};
	})();
	var write_content_ods = (function() {
		/* 6.1.2 White Space Characters */
		var write_text_p = function(text) {
			return escapexml(text)
				.replace(/  +/g, function($$){return '<text:s text:c="'+$$.length+'"/>';})
				.replace(/\t/g, "<text:tab/>")
				.replace(/\n/g, "</text:p><text:p>")
				.replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
		};
	
		var null_cell_xml = '          <table:table-cell />\n';
		var covered_cell_xml = '          <table:covered-table-cell/>\n';
		var write_ws = function(ws, wb, i) {
			/* Section 9 Tables */
			var o = [];
			o.push('      <table:table table:name="' + escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
			var R=0,C=0, range = decode_range(ws['!ref']||"A1");
			var marr = ws['!merges'] || [], mi = 0;
			var dense = Array.isArray(ws);
			if(ws["!cols"]) {
				for(C = 0; C <= range.e.c; ++C) o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
			}
			var H = "", ROWS = ws["!rows"]||[];
			for(R = 0; R < range.s.r; ++R) {
				H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
				o.push('        <table:table-row' + H + '></table:table-row>\n');
			}
			for(; R <= range.e.r; ++R) {
				H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
				o.push('        <table:table-row' + H + '>\n');
				for(C=0; C < range.s.c; ++C) o.push(null_cell_xml);
				for(; C <= range.e.c; ++C) {
					var skip = false, ct = {}, textp = "";
					for(mi = 0; mi != marr.length; ++mi) {
						if(marr[mi].s.c > C) continue;
						if(marr[mi].s.r > R) continue;
						if(marr[mi].e.c < C) continue;
						if(marr[mi].e.r < R) continue;
						if(marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
						ct['table:number-columns-spanned'] = (marr[mi].e.c - marr[mi].s.c + 1);
						ct['table:number-rows-spanned'] =    (marr[mi].e.r - marr[mi].s.r + 1);
						break;
					}
					if(skip) { o.push(covered_cell_xml); continue; }
					var ref = encode_cell({r:R, c:C}), cell = dense ? (ws[R]||[])[C]: ws[ref];
					if(cell && cell.f) {
						ct['table:formula'] = escapexml(csf_to_ods_formula(cell.f));
						if(cell.F) {
							if(cell.F.slice(0, ref.length) == ref) {
								var _Fref = decode_range(cell.F);
								ct['table:number-matrix-columns-spanned'] = (_Fref.e.c - _Fref.s.c + 1);
								ct['table:number-matrix-rows-spanned'] =    (_Fref.e.r - _Fref.s.r + 1);
							}
						}
					}
					if(!cell) { o.push(null_cell_xml); continue; }
					switch(cell.t) {
						case 'b':
							textp = (cell.v ? 'TRUE' : 'FALSE');
							ct['office:value-type'] = "boolean";
							ct['office:boolean-value'] = (cell.v ? 'true' : 'false');
							break;
						case 'n':
							textp = (cell.w||String(cell.v||0));
							ct['office:value-type'] = "float";
							ct['office:value'] = (cell.v||0);
							break;
						case 's': case 'str':
							textp = cell.v == null ? "" : cell.v;
							ct['office:value-type'] = "string";
							break;
						case 'd':
							textp = (cell.w||(parseDate(cell.v).toISOString()));
							ct['office:value-type'] = "date";
							ct['office:date-value'] = (parseDate(cell.v).toISOString());
							ct['table:style-name'] = "ce1";
							break;
						//case 'e':
						default: o.push(null_cell_xml); continue;
					}
					var text_p = write_text_p(textp);
					if(cell.l && cell.l.Target) {
						var _tgt = cell.l.Target;
						_tgt = _tgt.charAt(0) == "#" ? "#" + csf_to_ods_3D(_tgt.slice(1)) : _tgt;
						// TODO: choose correct parent path format based on link delimiters
						if(_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
						text_p = writextag('text:a', text_p, {'xlink:href': _tgt.replace(/&/g, "&amp;")});
					}
					o.push('          ' + writextag('table:table-cell', writextag('text:p', text_p, {}), ct) + '\n');
				}
				o.push('        </table:table-row>\n');
			}
			o.push('      </table:table>\n');
			return o.join("");
		};
	
		var write_automatic_styles_ods = function(o, wb) {
			o.push(' <office:automatic-styles>\n');
	
			o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
			o.push('   <number:month number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:day number:style="long"/>\n');
			o.push('   <number:text>/</number:text>\n');
			o.push('   <number:year/>\n');
			o.push('  </number:date-style>\n');
	
			/* column styles */
			var cidx = 0;
			wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
				if(!ws) return;
				if(ws["!cols"]) {
					for(var C = 0; C < ws["!cols"].length; ++C) if(ws["!cols"][C]) {
						var colobj = ws["!cols"][C];
						if(colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
						process_col(colobj);
						colobj.ods = cidx;
						var w = ws["!cols"][C].wpx + "px";
						o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
						o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
						o.push('  </style:style>\n');
						++cidx;
					}
				}
			});
	
			/* row styles */
			var ridx = 0;
			wb.SheetNames.map(function(n) { return wb.Sheets[n]; }).forEach(function(ws) {
				if(!ws) return;
				if(ws["!rows"]) {
					for(var R = 0; R < ws["!rows"].length; ++R) if(ws["!rows"][R]) {
						ws["!rows"][R].ods = ridx;
						var h = ws["!rows"][R].hpx + "px";
						o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
						o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
						o.push('  </style:style>\n');
						++ridx;
					}
				}
			});
	
			/* table */
			o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
			o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
			o.push('  </style:style>\n');
	
			/* table cells, text */
			o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
	
			/* page-layout */
	
			o.push(' </office:automatic-styles>\n');
		};
	
		return function wcx(wb, opts) {
			var o = [XML_HEADER];
			/* 3.1.3.2 */
			var attr = wxt_helper({
				'xmlns:office':       "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
				'xmlns:table':        "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
				'xmlns:style':        "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
				'xmlns:text':         "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
				'xmlns:draw':         "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
				'xmlns:fo':           "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
				'xmlns:xlink':        "http://www.w3.org/1999/xlink",
				'xmlns:dc':           "http://purl.org/dc/elements/1.1/",
				'xmlns:meta':         "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
				'xmlns:number':       "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
				'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
				'xmlns:svg':          "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
				'xmlns:chart':        "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
				'xmlns:dr3d':         "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
				'xmlns:math':         "http://www.w3.org/1998/Math/MathML",
				'xmlns:form':         "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
				'xmlns:script':       "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
				'xmlns:ooo':          "http://openoffice.org/2004/office",
				'xmlns:ooow':         "http://openoffice.org/2004/writer",
				'xmlns:oooc':         "http://openoffice.org/2004/calc",
				'xmlns:dom':          "http://www.w3.org/2001/xml-events",
				'xmlns:xforms':       "http://www.w3.org/2002/xforms",
				'xmlns:xsd':          "http://www.w3.org/2001/XMLSchema",
				'xmlns:xsi':          "http://www.w3.org/2001/XMLSchema-instance",
				'xmlns:sheet':        "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
				'xmlns:rpt':          "http://openoffice.org/2005/report",
				'xmlns:of':           "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
				'xmlns:xhtml':        "http://www.w3.org/1999/xhtml",
				'xmlns:grddl':        "http://www.w3.org/2003/g/data-view#",
				'xmlns:tableooo':     "http://openoffice.org/2009/table",
				'xmlns:drawooo':      "http://openoffice.org/2010/draw",
				'xmlns:calcext':      "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
				'xmlns:loext':        "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
				'xmlns:field':        "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
				'xmlns:formx':        "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
				'xmlns:css3t':        "http://www.w3.org/TR/css3-text/",
				'office:version':     "1.2"
			});
	
			var fods = wxt_helper({
				'xmlns:config':    "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
				'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
			});
	
			if(opts.bookType == "fods") {
				o.push('<office:document' + attr + fods + '>\n');
				o.push(write_meta_ods().replace(/office:document-meta/g, "office:meta"));
				// TODO: settings (equiv of settings.xml for ODS)
			} else o.push('<office:document-content' + attr  + '>\n');
			// o.push('  <office:scripts/>\n');
			write_automatic_styles_ods(o, wb);
			o.push('  <office:body>\n');
			o.push('    <office:spreadsheet>\n');
			for(var i = 0; i != wb.SheetNames.length; ++i) o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts));
			o.push('    </office:spreadsheet>\n');
			o.push('  </office:body>\n');
			if(opts.bookType == "fods") o.push('</office:document>');
			else o.push('</office:document-content>');
			return o.join("");
		};
	})();
	
	function write_ods(wb, opts) {
		if(opts.bookType == "fods") return write_content_ods(wb, opts);
	
		var zip = zip_new();
		var f = "";
	
		var manifest = [];
		var rdf = [];
	
		/* Part 3 Section 3.3 MIME Media Type */
		f = "mimetype";
		zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
	
		/* Part 1 Section 2.2 Documents */
		f = "content.xml";
		zip_add_file(zip, f, write_content_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "ContentFile"]);
	
		/* TODO: these are hard-coded styles to satiate excel */
		f = "styles.xml";
		zip_add_file(zip, f, write_styles_ods(wb, opts));
		manifest.push([f, "text/xml"]);
		rdf.push([f, "StylesFile"]);
	
		/* TODO: this is hard-coded to satiate excel */
		f = "meta.xml";
		zip_add_file(zip, f, XML_HEADER + write_meta_ods());
		manifest.push([f, "text/xml"]);
		rdf.push([f, "MetadataFile"]);
	
		/* Part 3 Section 6 Metadata Manifest File */
		f = "manifest.rdf";
		zip_add_file(zip, f, write_rdf(rdf/*, opts*/));
		manifest.push([f, "application/rdf+xml"]);
	
		/* Part 3 Section 4 Manifest File */
		f = "META-INF/manifest.xml";
		zip_add_file(zip, f, write_manifest(manifest/*, opts*/));
	
		return zip;
	}
	
	function write_sheet_index(wb, sheet) {
		if(!sheet) return 0;
		var idx = wb.SheetNames.indexOf(sheet);
		if(idx == -1) throw new Error("Sheet not found: " + sheet);
		return idx;
	}
	
	function write_obj_str(factory) {
		return function write_str(wb, o) {
			var idx = write_sheet_index(wb, o.sheet);
			return factory.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb);
		};
	}
	
	var write_htm_str = write_obj_str(HTML_);
	var write_csv_str = write_obj_str({from_sheet:sheet_to_csv});
	var write_slk_str = write_obj_str(typeof SYLK !== "undefined" ? SYLK : {});
	var write_dif_str = write_obj_str(typeof DIF !== "undefined" ? DIF : {});
	var write_prn_str = write_obj_str(typeof PRN !== "undefined" ? PRN : {});
	var write_rtf_str = write_obj_str(typeof RTF !== "undefined" ? RTF : {});
	var write_txt_str = write_obj_str({from_sheet:sheet_to_txt});
	var write_dbf_buf = write_obj_str(typeof DBF !== "undefined" ? DBF : {});
	var write_eth_str = write_obj_str(typeof ETH !== "undefined" ? ETH : {});
	var write_wk1_buf = write_obj_str(typeof WK_ !== "undefined" ? {from_sheet:WK_.sheet_to_wk1} : {});
	
	function fix_opts_func(defaults) {
		return function fix_opts(opts) {
			for(var i = 0; i != defaults.length; ++i) {
				var d = defaults[i];
				if(opts[d[0]] === undefined) opts[d[0]] = d[1];
				if(d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
			}
		};
	}
	
	var fix_read_opts = function(opts) {
	fix_opts_func([
		['cellNF', false], /* emit cell number format string as .z */
		['cellHTML', true], /* emit html string as .h */
		['cellFormula', true], /* emit formulae as .f */
		['cellStyles', false], /* emits style/theme as .s */
		['cellText', true], /* emit formatted text as .w */
		['cellDates', false], /* emit date cells with type `d` */
	
		['sheetStubs', false], /* emit empty cells */
		['sheetRows', 0, 'n'], /* read n rows (0 = read all rows) */
	
		['bookDeps', false], /* parse calculation chains */
		['bookSheets', false], /* only try to get sheet names (no Sheets) */
		['bookProps', false], /* only try to get properties (no Sheets) */
		['bookFiles', false], /* include raw file structure (keys, files, cfb) */
		['bookVBA', false], /* include vba raw data (vbaraw) */
	
		['password',''], /* password */
		['WTF', false] /* WTF mode (throws errors) */
	])(opts);
	};
	
	var fix_write_opts = fix_opts_func([
		['cellDates', false], /* write date cells with type `d` */
	
		['bookSST', false], /* Generate Shared String Table */
	
		['bookType', 'xlsx'], /* Type of workbook (xlsx/m/b) */
	
		['compression', false], /* Use file compression */
	
		['WTF', false] /* WTF mode (throws errors) */
	]);
	function get_sheet_type(n) {
		if(RELS.WS.indexOf(n) > -1) return "sheet";
		if(RELS.CS && n == RELS.CS) return "chart";
		if(RELS.DS && n == RELS.DS) return "dialog";
		if(RELS.MS && n == RELS.MS) return "macro";
		return (n && n.length) ? n : "sheet";
	}
	function safe_parse_wbrels(wbrels, sheets) {
		if(!wbrels) return 0;
		try {
			wbrels = sheets.map(function pwbr(w) { if(!w.id) w.id = w.strRelID; return [w.name, wbrels['!id'][w.id].Target, get_sheet_type(wbrels['!id'][w.id].Type)]; });
		} catch(e) { return null; }
		return !wbrels || wbrels.length === 0 ? null : wbrels;
	}
	
	function safe_parse_sheet(zip, path, relsPath, sheet, idx, sheetRels, sheets, stype, opts, wb, themes, styles) {
		try {
			sheetRels[sheet]=parse_rels(getzipstr(zip, relsPath, true), path);
			var data = getzipdata(zip, path);
			var _ws;
			switch(stype) {
				case 'sheet':  _ws = parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'chart':  _ws = parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
					if(!_ws || !_ws['!drawel']) break;
					var dfile = resolve_path(_ws['!drawel'].Target, path);
					var drelsp = get_rels_path(dfile);
					var draw = parse_drawing(getzipstr(zip, dfile, true), parse_rels(getzipstr(zip, drelsp, true), dfile));
					var chartp = resolve_path(draw, dfile);
					var crelsp = get_rels_path(chartp);
					_ws = parse_chart(getzipstr(zip, chartp, true), chartp, opts, parse_rels(getzipstr(zip, crelsp, true), chartp), wb, _ws);
					break;
				case 'macro':  _ws = parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				case 'dialog': _ws = parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles); break;
				default: throw new Error("Unrecognized sheet type " + stype);
			}
			sheets[sheet] = _ws;
	
			/* scan rels for comments */
			var comments = [];
			if(sheetRels && sheetRels[sheet]) keys(sheetRels[sheet]).forEach(function(n) {
				if(sheetRels[sheet][n].Type == RELS.CMNT) {
					var dfile = resolve_path(sheetRels[sheet][n].Target, path);
					comments = parse_cmnt(getzipdata(zip, dfile, true), dfile, opts);
					if(!comments || !comments.length) return;
					sheet_insert_comments(_ws, comments);
				}
			});
		} catch(e) { if(opts.WTF) throw e; }
	}
	
	function strip_front_slash(x) { return x.charAt(0) == '/' ? x.slice(1) : x; }
	
	function parse_zip(zip, opts) {
		make_ssf(SSF);
		opts = opts || {};
		fix_read_opts(opts);
	
		/* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */
		if(safegetzipfile(zip, 'META-INF/manifest.xml')) return parse_ods(zip, opts);
		/* UOC */
		if(safegetzipfile(zip, 'objectdata.xml')) return parse_ods(zip, opts);
		/* Numbers */
		if(safegetzipfile(zip, 'Index/Document.iwa')) throw new Error('Unsupported NUMBERS file');
		if(!safegetzipfile(zip, '[Content_Types].xml')) {
			if(safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
			if(safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
			throw new Error('Unsupported ZIP file');
		}
	
		var entries = zipentries(zip);
		var dir = parse_ct((getzipstr(zip, '[Content_Types].xml')));
		var xlsb = false;
		var sheets, binname;
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.xml";
			if(getzipdata(zip,binname, true)) dir.workbooks.push(binname);
		}
		if(dir.workbooks.length === 0) {
			binname = "xl/workbook.bin";
			if(!getzipdata(zip,binname,true)) throw new Error("Could not find workbook");
			dir.workbooks.push(binname);
			xlsb = true;
		}
		if(dir.workbooks[0].slice(-3) == "bin") xlsb = true;
	
		var themes = ({});
		var styles = ({});
		if(!opts.bookSheets && !opts.bookProps) {
			strs = [];
			if(dir.sst) try { strs=parse_sst(getzipdata(zip, strip_front_slash(dir.sst)), dir.sst, opts); } catch(e) { if(opts.WTF) throw e; }
	
			if(opts.cellStyles && dir.themes.length) themes = parse_theme(getzipstr(zip, dir.themes[0].replace(/^\//,''), true)||"",dir.themes[0], opts);
	
			if(dir.style) styles = parse_sty(getzipdata(zip, strip_front_slash(dir.style)), dir.style, themes, opts);
		}
	
		/*var externbooks = */dir.links.map(function(link) {
			try {
				var rels = parse_rels(getzipstr(zip, get_rels_path(strip_front_slash(link))), link);
				return parse_xlink(getzipdata(zip, strip_front_slash(link)), rels, link, opts);
			} catch(e) {}
		});
	
		var wb = parse_wb(getzipdata(zip, strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
	
		var props = {}, propdata = "";
	
		if(dir.coreprops.length) {
			propdata = getzipdata(zip, strip_front_slash(dir.coreprops[0]), true);
			if(propdata) props = parse_core_props(propdata);
			if(dir.extprops.length !== 0) {
				propdata = getzipdata(zip, strip_front_slash(dir.extprops[0]), true);
				if(propdata) parse_ext_props(propdata, props, opts);
			}
		}
	
		var custprops = {};
		if(!opts.bookSheets || opts.bookProps) {
			if (dir.custprops.length !== 0) {
				propdata = getzipstr(zip, strip_front_slash(dir.custprops[0]), true);
				if(propdata) custprops = parse_cust_props(propdata, opts);
			}
		}
	
		var out = ({});
		if(opts.bookSheets || opts.bookProps) {
			if(wb.Sheets) sheets = wb.Sheets.map(function pluck(x){ return x.name; });
			else if(props.Worksheets && props.SheetNames.length > 0) sheets=props.SheetNames;
			if(opts.bookProps) { out.Props = props; out.Custprops = custprops; }
			if(opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
			if(opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
		}
		sheets = {};
	
		var deps = {};
		if(opts.bookDeps && dir.calcchain) deps=parse_cc(getzipdata(zip, strip_front_slash(dir.calcchain)),dir.calcchain,opts);
	
		var i=0;
		var sheetRels = ({});
		var path, relsPath;
	
		{
			var wbsheets = wb.Sheets;
			props.Worksheets = wbsheets.length;
			props.SheetNames = [];
			for(var j = 0; j != wbsheets.length; ++j) {
				props.SheetNames[j] = wbsheets[j].name;
			}
		}
	
		var wbext = xlsb ? "bin" : "xml";
		var wbrelsi = dir.workbooks[0].lastIndexOf("/");
		var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi+1) + "_rels/" + dir.workbooks[0].slice(wbrelsi+1) + ".rels").replace(/^\//,"");
		if(!safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
		var wbrels = parse_rels(getzipstr(zip, wbrelsfile, true), wbrelsfile);
		if(wbrels) wbrels = safe_parse_wbrels(wbrels, wb.Sheets);
	
		/* Numbers iOS hack */
		var nmode = (getzipdata(zip,"xl/worksheets/sheet.xml",true))?1:0;
		wsloop: for(i = 0; i != props.Worksheets; ++i) {
			var stype = "sheet";
			if(wbrels && wbrels[i]) {
				path = 'xl/' + (wbrels[i][1]).replace(/[\/]?xl\//, "");
				if(!safegetzipfile(zip, path)) path = wbrels[i][1];
				if(!safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/.*$/,"") + wbrels[i][1];
				stype = wbrels[i][2];
			} else {
				path = 'xl/worksheets/sheet'+(i+1-nmode)+"." + wbext;
				path = path.replace(/sheet0\./,"sheet.");
			}
			relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
			if(opts && opts.sheets != null) switch(typeof opts.sheets) {
				case "number": if(i != opts.sheets) continue wsloop; break;
				case "string": if(props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop; break;
				default: if(Array.isArray && Array.isArray(opts.sheets)) {
					var snjseen = false;
					for(var snj = 0; snj != opts.sheets.length; ++snj) {
						if(typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen=1;
						if(typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
					}
					if(!snjseen) continue wsloop;
				}
			}
			safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
		}
	
		out = ({
			Directory: dir,
			Workbook: wb,
			Props: props,
			Custprops: custprops,
			Deps: deps,
			Sheets: sheets,
			SheetNames: props.SheetNames,
			Strings: strs,
			Styles: styles,
			Themes: themes,
			SSF: SSF.get_table()
		});
		if(opts && opts.bookFiles) {
			if(zip.files) {
				out.keys = entries;
				out.files = zip.files;
			} else {
				out.keys = [];
				out.files = {};
				zip.FullPaths.forEach(function(p, idx) {
					p = p.replace(/^Root Entry[\/]/, "");
					out.keys.push(p);
					out.files[p] = zip.FileIndex[idx];
				});
			}
		}
		if(opts && opts.bookVBA) {
			if(dir.vba.length > 0) out.vbaraw = getzipdata(zip,strip_front_slash(dir.vba[0]),true);
			else if(dir.defaults && dir.defaults.bin === CT_VBA) out.vbaraw = getzipdata(zip, 'xl/vbaProject.bin',true);
		}
		return out;
	}
	
	/* [MS-OFFCRYPTO] 2.1.1 */
	function parse_xlsxcfb(cfb, _opts) {
		var opts = _opts || {};
		var f = 'Workbook', data = CFB.find(cfb, f);
		try {
		f = '/!DataSpaces/Version';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var version = */parse_DataSpaceVersionInfo(data.content);
	
		/* 2.3.4.1 */
		f = '/!DataSpaces/DataSpaceMap';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var dsm = parse_DataSpaceMap(data.content);
		if(dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.2 */
		f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var seds = parse_DataSpaceDefinition(data.content);
		if(seds.length != 1 || seds[0] != "StrongEncryptionTransform")
			throw new Error("ECMA-376 Encrypted file bad " + f);
	
		/* 2.3.4.3 */
		f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		/*var hdr = */parse_Primary(data.content);
		} catch(e) {}
	
		f = '/EncryptionInfo';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
		var einfo = parse_EncryptionInfo(data.content);
	
		/* 2.3.4.4 */
		f = '/EncryptedPackage';
		data = CFB.find(cfb, f); if(!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
	
	/*global decrypt_agile */
	if(einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
	/*global decrypt_std76 */
	if(einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
		throw new Error("File is password-protected");
	}
	
	function write_zip(wb, opts) {
		_shapeid = 1024;
		if(opts.bookType == "ods") return write_ods(wb, opts);
		if(wb && !wb.SSF) {
			wb.SSF = SSF.get_table();
		}
		if(wb && wb.SSF) {
			make_ssf(SSF); SSF.load_table(wb.SSF);
			// $FlowIgnore
			opts.revssf = evert_num(wb.SSF); opts.revssf[wb.SSF[65535]] = 0;
			opts.ssf = wb.SSF;
		}
		opts.rels = {}; opts.wbrels = {};
		opts.Strings = []; opts.Strings.Count = 0; opts.Strings.Unique = 0;
		if(browser_has_Map) opts.revStrings = new Map();
		else { opts.revStrings = {}; opts.revStrings.foo = []; delete opts.revStrings.foo; }
		var wbext = opts.bookType == "xlsb" ? "bin" : "xml";
		var vbafmt = VBAFMTS.indexOf(opts.bookType) > -1;
		var ct = new_ct();
		fix_write_opts(opts = opts || {});
		var zip = zip_new();
		var f = "", rId = 0;
	
		opts.cellXfs = [];
		get_cell_style(opts.cellXfs, {}, {revssf:{"General":0}});
	
		if(!wb.Props) wb.Props = {};
	
		f = "docProps/core.xml";
		zip_add_file(zip, f, write_core_props(wb.Props, opts));
		ct.coreprops.push(f);
		add_rels(opts.rels, 2, f, RELS.CORE_PROPS);
	
	f = "docProps/app.xml";
		if(wb.Props && wb.Props.SheetNames){/* empty */}
		else if(!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
		else {
			var _sn = [];
			for(var _i = 0; _i < wb.SheetNames.length; ++_i)
				if((wb.Workbook.Sheets[_i]||{}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
			wb.Props.SheetNames = _sn;
		}
		wb.Props.Worksheets = wb.Props.SheetNames.length;
		zip_add_file(zip, f, write_ext_props(wb.Props, opts));
		ct.extprops.push(f);
		add_rels(opts.rels, 3, f, RELS.EXT_PROPS);
	
		if(wb.Custprops !== wb.Props && keys(wb.Custprops||{}).length > 0) {
			f = "docProps/custom.xml";
			zip_add_file(zip, f, write_cust_props(wb.Custprops, opts));
			ct.custprops.push(f);
			add_rels(opts.rels, 4, f, RELS.CUST_PROPS);
		}
	
		for(rId=1;rId <= wb.SheetNames.length; ++rId) {
			var wsrels = {'!id':{}};
			var ws = wb.Sheets[wb.SheetNames[rId-1]];
			var _type = (ws || {})["!type"] || "sheet";
			switch(_type) {
			case "chart":
				/* falls through */
			default:
				f = "xl/worksheets/sheet" + rId + "." + wbext;
				zip_add_file(zip, f, write_ws(rId-1, f, opts, wb, wsrels));
				ct.sheets.push(f);
				add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, RELS.WS[0]);
			}
	
			if(ws) {
				var comments = ws['!comments'];
				var need_vml = false;
				if(comments && comments.length > 0) {
					var cf = "xl/comments" + rId + "." + wbext;
					zip_add_file(zip, cf, write_cmnt(comments, cf, opts));
					ct.comments.push(cf);
					add_rels(wsrels, -1, "../comments" + rId + "." + wbext, RELS.CMNT);
					need_vml = true;
				}
				if(ws['!legacy']) {
					if(need_vml) zip_add_file(zip, "xl/drawings/vmlDrawing" + (rId) + ".vml", write_comments_vml(rId, ws['!comments']));
				}
				delete ws['!comments'];
				delete ws['!legacy'];
			}
	
			if(wsrels['!id'].rId1) zip_add_file(zip, get_rels_path(f), write_rels(wsrels));
		}
	
		if(opts.Strings != null && opts.Strings.length > 0) {
			f = "xl/sharedStrings." + wbext;
			zip_add_file(zip, f, write_sst(opts.Strings, f, opts));
			ct.strs.push(f);
			add_rels(opts.wbrels, -1, "sharedStrings." + wbext, RELS.SST);
		}
	
		f = "xl/workbook." + wbext;
		zip_add_file(zip, f, write_wb(wb, f, opts));
		ct.workbooks.push(f);
		add_rels(opts.rels, 1, f, RELS.WB);
	
		/* TODO: something more intelligent with themes */
	
		f = "xl/theme/theme1.xml";
		zip_add_file(zip, f, write_theme(wb.Themes, opts));
		ct.themes.push(f);
		add_rels(opts.wbrels, -1, "theme/theme1.xml", RELS.THEME);
	
		/* TODO: something more intelligent with styles */
	
		f = "xl/styles." + wbext;
		zip_add_file(zip, f, write_sty(wb, f, opts));
		ct.styles.push(f);
		add_rels(opts.wbrels, -1, "styles." + wbext, RELS.STY);
	
		if(wb.vbaraw && vbafmt) {
			f = "xl/vbaProject.bin";
			zip_add_file(zip, f, wb.vbaraw);
			ct.vba.push(f);
			add_rels(opts.wbrels, -1, "vbaProject.bin", RELS.VBA);
		}
	
		zip_add_file(zip, "[Content_Types].xml", write_ct(ct, opts));
		zip_add_file(zip, '_rels/.rels', write_rels(opts.rels));
		zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', write_rels(opts.wbrels));
	
		delete opts.revssf; delete opts.ssf;
		return zip;
	}
	function firstbyte(f,o) {
		var x = "";
		switch((o||{}).type || "base64") {
			case 'buffer': return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
			case 'base64': x = Base64.decode(f.slice(0,12)); break;
			case 'binary': x = f; break;
			case 'array':  return [f[0], f[1], f[2], f[3], f[4], f[5], f[6], f[7]];
			default: throw new Error("Unrecognized type " + (o && o.type || "undefined"));
		}
		return [x.charCodeAt(0), x.charCodeAt(1), x.charCodeAt(2), x.charCodeAt(3), x.charCodeAt(4), x.charCodeAt(5), x.charCodeAt(6), x.charCodeAt(7)];
	}
	
	function read_cfb(cfb, opts) {
		if(CFB.find(cfb, "EncryptedPackage")) return parse_xlsxcfb(cfb, opts);
		return parse_xlscfb(cfb, opts);
	}
	
	function read_zip(data, opts) {
		var zip, d = data;
		var o = opts||{};
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		zip = zip_read(d, o);
		return parse_zip(zip, o);
	}
	
	function read_plaintext(data, o) {
		var i = 0;
		main: while(i < data.length) switch(data.charCodeAt(i)) {
			case 0x0A: case 0x0D: case 0x20: ++i; break;
			case 0x3C: return parse_xlml(data.slice(i),o);
			default: break main;
		}
		return PRN.to_workbook(data, o);
	}
	
	function read_plaintext_raw(data, o) {
		var str = "", bytes = firstbyte(data, o);
		switch(o.type) {
			case 'base64': str = Base64.decode(data); break;
			case 'binary': str = data; break;
			case 'buffer': str = data.toString('binary'); break;
			case 'array': str = cc2str(data); break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		if(bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = utf8read(str);
		return read_plaintext(str, o);
	}
	
	function read_utf16(data, o) {
		var d = data;
		if(o.type == 'base64') d = Base64.decode(d);
		d = cptable.utils.decode(1200, d.slice(2), 'str');
		o.type = "binary";
		return read_plaintext(d, o);
	}
	
	function bstrify(data) {
		return !data.match(/[^\x00-\x7F]/) ? data : utf8write(data);
	}
	
	function read_prn(data, d, o, str) {
		if(str) { o.type = "string"; return PRN.to_workbook(data, o); }
		return PRN.to_workbook(d, o);
	}
	
	function readSync(data, opts) {
		reset_cp();
		var o = opts||{};
		if(typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return readSync(new Uint8Array(data), (o = dup(o), o.type = "array", o));
		var d = data, n = [0,0,0,0], str = false;
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		_ssfopts = {};
		if(o.dateNF) _ssfopts.dateNF = o.dateNF;
		if(!o.type) o.type = (has_buf && Buffer.isBuffer(data)) ? "buffer" : "base64";
		if(o.type == "file") { o.type = has_buf ? "buffer" : "binary"; d = read_binary(data); }
		if(o.type == "string") { str = true; o.type = "binary"; o.codepage = 65001; d = bstrify(data); }
		if(o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
			// $FlowIgnore
			var ab=new ArrayBuffer(3), vu=new Uint8Array(ab); vu.foo="bar";
			// $FlowIgnore
			if(!vu.foo) {o=dup(o); o.type='array'; return readSync(ab2a(d), o);}
		}
		switch((n = firstbyte(d, o))[0]) {
			case 0xD0: if(n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return read_cfb(CFB.read(d, o), o); break;
			case 0x09: if(n[1] <= 0x08) return parse_xlscfb(d, o); break;
			case 0x3C: return parse_xlml(d, o);
			case 0x49:
				if(n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
				if(n[1] === 0x44) return read_wb_ID(d, o);
				break;
			case 0x54: if(n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return DIF.to_workbook(d, o); break;
			case 0x50: return (n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09) ? read_zip(d, o) : read_prn(data, d, o, str);
			case 0xEF: return n[3] === 0x3C ? parse_xlml(d, o) : read_prn(data, d, o, str);
			case 0xFF:
				if(n[1] === 0xFE) { return read_utf16(d, o); }
				else if(n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
				break;
			case 0x00:
				if(n[1] === 0x00) {
					if(n[2] >= 0x02 && n[3] === 0x00) return WK_.to_workbook(d, o);
					if(n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return WK_.to_workbook(d, o);
				}
				break;
			case 0x03: case 0x83: case 0x8B: case 0x8C: return DBF.to_workbook(d, o);
			case 0x7B: if(n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return RTF.to_workbook(d, o); break;
			case 0x0A: case 0x0D: case 0x20: return read_plaintext_raw(d, o);
			case 0x89: if(n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet"); break;
		}
		if(DBF.versions.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return DBF.to_workbook(d, o);
		return read_prn(data, d, o, str);
	}
	
	function readFileSync(filename, opts) {
		var o = opts||{}; o.type = 'file';
		return readSync(filename, o);
	}
	function write_cfb_ctr(cfb, o) {
		switch(o.type) {
			case "base64": case "binary": break;
			case "buffer": case "array": o.type = ""; break;
			case "file": return write_dl(o.file, CFB.write(cfb, {type:has_buf ? 'buffer' : ""}));
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			default: throw new Error("Unrecognized type " + o.type);
		}
		return CFB.write(cfb, o);
	}
	
	function write_zip_type(wb, opts) {
		var o = dup(opts||{});
		var z = write_zip(wb, o);
		var oopts = {};
		if(o.compression) oopts.compression = 'DEFLATE';
		if(o.password) oopts.type = has_buf ? "nodebuffer" : "string";
		else switch(o.type) {
			case "base64": oopts.type = "base64"; break;
			case "binary": oopts.type = "string"; break;
			case "string": throw new Error("'string' output type invalid for '" + o.bookType + "' files");
			case "buffer":
			case "file": oopts.type = has_buf ? "nodebuffer" : "string"; break;
			default: throw new Error("Unrecognized type " + o.type);
		}
		var out = z.FullPaths ? CFB.write(z, {fileType:"zip", type: {"nodebuffer": "buffer", "string": "binary"}[oopts.type] || oopts.type}) : z.generate(oopts);
	/*jshint -W083 */
		if(o.password && typeof encrypt_agile !== 'undefined') return write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
	/*jshint +W083 */
		if(o.type === "file") return write_dl(o.file, out);
		return o.type == "string" ? utf8read(out) : out;
	}
	
	function write_cfb_type(wb, opts) {
		var o = opts||{};
		var cfb = write_xlscfb(wb, o);
		return write_cfb_ctr(cfb, o);
	}
	
	function write_string_type(out, opts, bom) {
		if(!bom) bom = "";
		var o = bom + out;
		switch(opts.type) {
			case "base64": return Base64.encode(utf8write(o));
			case "binary": return utf8write(o);
			case "string": return out;
			case "file": return write_dl(opts.file, o, 'utf8');
			case "buffer": {
				if(has_buf) return Buffer_from(o, 'utf8');
				else return write_string_type(o, {type:'binary'}).split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	function write_stxt_type(out, opts) {
		switch(opts.type) {
			case "base64": return Base64.encode(out);
			case "binary": return out;
			case "string": return out; /* override in sheet_to_txt */
			case "file": return write_dl(opts.file, out, 'binary');
			case "buffer": {
				if(has_buf) return Buffer_from(out, 'binary');
				else return out.split("").map(function(c) { return c.charCodeAt(0); });
			}
		}
		throw new Error("Unrecognized type " + opts.type);
	}
	
	/* TODO: test consistency */
	function write_binary_type(out, opts) {
		switch(opts.type) {
			case "string":
			case "base64":
			case "binary":
				var bstr = "";
				// $FlowIgnore
				for(var i = 0; i < out.length; ++i) bstr += String.fromCharCode(out[i]);
				return opts.type == 'base64' ? Base64.encode(bstr) : opts.type == 'string' ? utf8read(bstr) : bstr;
			case "file": return write_dl(opts.file, out);
			case "buffer": return out;
			default: throw new Error("Unrecognized type " + opts.type);
		}
	}
	
	function writeSync(wb, opts) {
		reset_cp();
		check_wb(wb);
		var o = dup(opts||{});
		if(o.cellStyles) { o.cellNF = true; o.sheetStubs = true; }
		if(o.type == "array") { o.type = "binary"; var out = (writeSync(wb, o)); o.type = "array"; return s2ab(out); }
		switch(o.bookType || 'xlsb') {
			case 'xml':
			case 'xlml': return write_string_type(write_xlml(wb, o), o);
			case 'slk':
			case 'sylk': return write_string_type(write_slk_str(wb, o), o);
			case 'htm':
			case 'html': return write_string_type(write_htm_str(wb, o), o);
			case 'txt': return write_stxt_type(write_txt_str(wb, o), o);
			case 'csv': return write_string_type(write_csv_str(wb, o), o, "\ufeff");
			case 'dif': return write_string_type(write_dif_str(wb, o), o);
			case 'dbf': return write_binary_type(write_dbf_buf(wb, o), o);
			case 'prn': return write_string_type(write_prn_str(wb, o), o);
			case 'rtf': return write_string_type(write_rtf_str(wb, o), o);
			case 'eth': return write_string_type(write_eth_str(wb, o), o);
			case 'fods': return write_string_type(write_ods(wb, o), o);
			case 'wk1': return write_binary_type(write_wk1_buf(wb, o), o);
			case 'wk3': return write_binary_type(WK_.book_to_wk3(wb, o), o);
			case 'biff2': if(!o.biff) o.biff = 2; /* falls through */
			case 'biff3': if(!o.biff) o.biff = 3; /* falls through */
			case 'biff4': if(!o.biff) o.biff = 4; return write_binary_type(write_biff_buf(wb, o), o);
			case 'biff5': if(!o.biff) o.biff = 5; /* falls through */
			case 'biff8':
			case 'xla':
			case 'xls': if(!o.biff) o.biff = 8; return write_cfb_type(wb, o);
			case 'xlsx':
			case 'xlsm':
			case 'xlam':
			case 'xlsb':
			case 'ods': return write_zip_type(wb, o);
			default: throw new Error ("Unrecognized bookType |" + o.bookType + "|");
		}
	}
	
	function resolve_book_type(o) {
		if(o.bookType) return;
		var _BT = {
			"xls": "biff8",
			"htm": "html",
			"slk": "sylk",
			"socialcalc": "eth",
			"Sh33tJS": "WTF"
		};
		var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
		if(ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
		o.bookType = _BT[o.bookType] || o.bookType;
	}
	
	function writeFileSync(wb, filename, opts) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		return writeSync(wb, o);
	}
	
	function writeFileAsync(filename, wb, opts, cb) {
		var o = opts||{}; o.type = 'file';
		o.file = filename;
		resolve_book_type(o);
		o.type = 'buffer';
		var _cb = cb; if(!(_cb instanceof Function)) _cb = (opts);
		return _fs.writeFile(filename, writeSync(wb, o), _cb);
	}
	function make_json_row(sheet, r, R, cols, header, hdr, dense, o) {
		var rr = encode_row(R);
		var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
		var isempty = true;
		var row = (header === 1) ? [] : {};
		if(header !== 1) {
			if(Object.defineProperty) try { Object.defineProperty(row, '__rowNum__', {value:R, enumerable:false}); } catch(e) { row.__rowNum__ = R; }
			else row.__rowNum__ = R;
		}
		if(!dense || sheet[R]) for (var C = r.s.c; C <= r.e.c; ++C) {
			var val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			if(val === undefined || val.t === undefined) {
				if(defval === undefined) continue;
				if(hdr[C] != null) { row[hdr[C]] = defval; }
				continue;
			}
			var v = val.v;
			switch(val.t){
				case 'z': if(v == null) break; continue;
				case 'e': v = (v == 0 ? null : void 0); break;
				case 's': case 'd': case 'b': case 'n': break;
				default: throw new Error('unrecognized type ' + val.t);
			}
			if(hdr[C] != null) {
				if(v == null) {
					if(val.t == "e" && v === null) row[hdr[C]] = null;
					else if(defval !== undefined) row[hdr[C]] = defval;
					else if(raw && v === null) row[hdr[C]] = null;
					else continue;
				} else {
					row[hdr[C]] = raw || (o.rawNumbers && val.t == "n") ? v : format_cell(val,v,o);
				}
				if(v != null) isempty = false;
			}
		}
		return { row: row, isempty: isempty };
	}
	
	
	function sheet_to_json(sheet, opts) {
		if(sheet == null || sheet["!ref"] == null) return [];
		var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
		var r = {s:{r:0,c:0},e:{r:0,c:0}};
		var o = opts || {};
		var range = o.range != null ? o.range : sheet["!ref"];
		if(o.header === 1) header = 1;
		else if(o.header === "A") header = 2;
		else if(Array.isArray(o.header)) header = 3;
		else if(o.header == null) header = 0;
		switch(typeof range) {
			case 'string': r = safe_decode_range(range); break;
			case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
			default: r = range;
		}
		if(header > 0) offset = 0;
		var rr = encode_row(r.s.r);
		var cols = [];
		var out = [];
		var outi = 0, counter = 0;
		var dense = Array.isArray(sheet);
		var R = r.s.r, C = 0, CC = 0;
		if(dense && !sheet[R]) sheet[R] = [];
		for(C = r.s.c; C <= r.e.c; ++C) {
			cols[C] = encode_col(C);
			val = dense ? sheet[R][C] : sheet[cols[C] + rr];
			switch(header) {
				case 1: hdr[C] = C - r.s.c; break;
				case 2: hdr[C] = cols[C]; break;
				case 3: hdr[C] = o.header[C - r.s.c]; break;
				default:
					if(val == null) val = {w: "__EMPTY", t: "s"};
					vv = v = format_cell(val, null, o);
					counter = 0;
					for(CC = 0; CC < hdr.length; ++CC) if(hdr[CC] == vv) vv = v + "_" + (++counter);
					hdr[C] = vv;
			}
		}
		for (R = r.s.r + offset; R <= r.e.r; ++R) {
			var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
			if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
		}
		out.length = outi;
		return out;
	}
	
	var qreg = /"/g;
	function make_csv_row(sheet, r, R, cols, fs, rs, FS, o) {
		var isempty = true;
		var row = [], txt = "", rr = encode_row(R);
		for(var C = r.s.c; C <= r.e.c; ++C) {
			if (!cols[C]) continue;
			var val = o.dense ? (sheet[R]||[])[C]: sheet[cols[C] + rr];
			if(val == null) txt = "";
			else if(val.v != null) {
				isempty = false;
				txt = ''+(o.rawNumbers && val.t == "n" ? val.v : format_cell(val, null, o));
				for(var i = 0, cc = 0; i !== txt.length; ++i) if((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {txt = "\"" + txt.replace(qreg, '""') + "\""; break; }
				if(txt == "ID") txt = '"ID"';
			} else if(val.f != null && !val.F) {
				isempty = false;
				txt = '=' + val.f; if(txt.indexOf(",") >= 0) txt = '"' + txt.replace(qreg, '""') + '"';
			} else txt = "";
			/* NOTE: Excel CSV does not support array formulae */
			row.push(txt);
		}
		if(o.blankrows === false && isempty) return null;
		return row.join(FS);
	}
	
	function sheet_to_csv(sheet, opts) {
		var out = [];
		var o = opts == null ? {} : opts;
		if(sheet == null || sheet["!ref"] == null) return "";
		var r = safe_decode_range(sheet["!ref"]);
		var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
		var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
		var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
		var row = "", cols = [];
		o.dense = Array.isArray(sheet);
		var colinfo = o.skipHidden && sheet["!cols"] || [];
		var rowinfo = o.skipHidden && sheet["!rows"] || [];
		for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			if ((rowinfo[R]||{}).hidden) continue;
			row = make_csv_row(sheet, r, R, cols, fs, rs, FS, o);
			if(row == null) { continue; }
			if(o.strip) row = row.replace(endregex,"");
			out.push(row + RS);
		}
		delete o.dense;
		return out.join("");
	}
	
	function sheet_to_txt(sheet, opts) {
		if(!opts) opts = {}; opts.FS = "\t"; opts.RS = "\n";
		var s = sheet_to_csv(sheet, opts);
		if(typeof cptable == 'undefined' || opts.type == 'string') return s;
		var o = cptable.utils.encode(1200, s, 'str');
		return String.fromCharCode(255) + String.fromCharCode(254) + o;
	}
	
	function sheet_to_formulae(sheet) {
		var y = "", x, val="";
		if(sheet == null || sheet["!ref"] == null) return [];
		var r = safe_decode_range(sheet['!ref']), rr = "", cols = [], C;
		var cmds = [];
		var dense = Array.isArray(sheet);
		for(C = r.s.c; C <= r.e.c; ++C) cols[C] = encode_col(C);
		for(var R = r.s.r; R <= r.e.r; ++R) {
			rr = encode_row(R);
			for(C = r.s.c; C <= r.e.c; ++C) {
				y = cols[C] + rr;
				x = dense ? (sheet[R]||[])[C] : sheet[y];
				val = "";
				if(x === undefined) continue;
				else if(x.F != null) {
					y = x.F;
					if(!x.f) continue;
					val = x.f;
					if(y.indexOf(":") == -1) y = y + ":" + y;
				}
				if(x.f != null) val = x.f;
				else if(x.t == 'z') continue;
				else if(x.t == 'n' && x.v != null) val = "" + x.v;
				else if(x.t == 'b') val = x.v ? "TRUE" : "FALSE";
				else if(x.w !== undefined) val = "'" + x.w;
				else if(x.v === undefined) continue;
				else if(x.t == 's') val = "'" + x.v;
				else val = ""+x.v;
				cmds[cmds.length] = y + "=" + val;
			}
		}
		return cmds;
	}
	
	function sheet_add_json(_ws, js, opts) {
		var o = opts || {};
		var offset = +!o.skipHeader;
		var ws = _ws || ({});
		var _R = 0, _C = 0;
		if(ws && o.origin != null) {
			if(typeof o.origin == 'number') _R = o.origin;
			else {
				var _origin = typeof o.origin == "string" ? decode_cell(o.origin) : o.origin;
				_R = _origin.r; _C = _origin.c;
			}
		}
		var cell;
		var range = ({s: {c:0, r:0}, e: {c:_C, r:_R + js.length - 1 + offset}});
		if(ws['!ref']) {
			var _range = safe_decode_range(ws['!ref']);
			range.e.c = Math.max(range.e.c, _range.e.c);
			range.e.r = Math.max(range.e.r, _range.e.r);
			if(_R == -1) { _R = _range.e.r + 1; range.e.r = _R + js.length - 1 + offset; }
		} else {
			if(_R == -1) { _R = 0; range.e.r = js.length - 1 + offset; }
		}
		var hdr = o.header || [], C = 0;
	
		js.forEach(function (JS, R) {
			keys(JS).forEach(function(k) {
				if((C=hdr.indexOf(k)) == -1) hdr[C=hdr.length] = k;
				var v = JS[k];
				var t = 'z';
				var z = "";
				var ref = encode_cell({c:_C + C,r:_R + R + offset});
				cell = utils.sheet_get_cell(ws, ref);
				if(v && typeof v === 'object' && !(v instanceof Date)){
					ws[ref] = v;
				} else {
					if(typeof v == 'number') t = 'n';
					else if(typeof v == 'boolean') t = 'b';
					else if(typeof v == 'string') t = 's';
					else if(v instanceof Date) {
						t = 'd';
						if(!o.cellDates) { t = 'n'; v = datenum(v); }
						z = (o.dateNF || SSF._table[14]);
					}
					else if(v === null && o.nullError) { t = 'e'; v = 0; }
					if(!cell) ws[ref] = cell = ({t:t, v:v});
					else {
						cell.t = t; cell.v = v;
						delete cell.w; delete cell.R;
						if(z) cell.z = z;
					}
					if(z) cell.z = z;
				}
			});
		});
		range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
		var __R = encode_row(_R);
		if(offset) for(C = 0; C < hdr.length; ++C) ws[encode_col(C + _C) + __R] = {t:'s', v:hdr[C]};
		ws['!ref'] = encode_range(range);
		return ws;
	}
	function json_to_sheet(js, opts) { return sheet_add_json(null, js, opts); }
	
	var utils = {
		encode_col: encode_col,
		encode_row: encode_row,
		encode_cell: encode_cell,
		encode_range: encode_range,
		decode_col: decode_col,
		decode_row: decode_row,
		split_cell: split_cell,
		decode_cell: decode_cell,
		decode_range: decode_range,
		format_cell: format_cell,
		get_formulae: sheet_to_formulae,
		make_csv: sheet_to_csv,
		make_json: sheet_to_json,
		make_formulae: sheet_to_formulae,
		sheet_add_aoa: sheet_add_aoa,
		sheet_add_json: sheet_add_json,
		sheet_add_dom: sheet_add_dom,
		aoa_to_sheet: aoa_to_sheet,
		json_to_sheet: json_to_sheet,
		table_to_sheet: parse_dom_table,
		table_to_book: table_to_book,
		sheet_to_csv: sheet_to_csv,
		sheet_to_txt: sheet_to_txt,
		sheet_to_json: sheet_to_json,
		sheet_to_html: HTML_.from_sheet,
		sheet_to_formulae: sheet_to_formulae,
		sheet_to_row_object_array: sheet_to_json
	};
	
	(function(utils) {
	utils.consts = utils.consts || {};
	function add_consts(R/*Array<any>*/) { R.forEach(function(a){ utils.consts[a[0]] = a[1]; }); }
	
	function get_default(x, y, z) { return x[y] != null ? x[y] : (x[y] = z); }
	
	/* get cell, creating a stub if necessary */
	function ws_get_cell_stub(ws, R, C) {
		/* A1 cell address */
		if(typeof R == "string") {
			/* dense */
			if(Array.isArray(ws)) {
				var RC = decode_cell(R);
				if(!ws[RC.r]) ws[RC.r] = [];
				return ws[RC.r][RC.c] || (ws[RC.r][RC.c] = {t:'z'});
			}
			return ws[R] || (ws[R] = {t:'z'});
		}
		/* cell address object */
		if(typeof R != "number") return ws_get_cell_stub(ws, encode_cell(R));
		/* R and C are 0-based indices */
		return ws_get_cell_stub(ws, encode_cell({r:R,c:C||0}));
	}
	utils.sheet_get_cell = ws_get_cell_stub;
	
	/* find sheet index for given name / validate index */
	function wb_sheet_idx(wb, sh) {
		if(typeof sh == "number") {
			if(sh >= 0 && wb.SheetNames.length > sh) return sh;
			throw new Error("Cannot find sheet # " + sh);
		} else if(typeof sh == "string") {
			var idx = wb.SheetNames.indexOf(sh);
			if(idx > -1) return idx;
			throw new Error("Cannot find sheet name |" + sh + "|");
		} else throw new Error("Cannot find sheet |" + sh + "|");
	}
	
	/* simple blank workbook object */
	utils.book_new = function() {
		return { SheetNames: [], Sheets: {} };
	};
	
	/* add a worksheet to the end of a given workbook */
	utils.book_append_sheet = function(wb, ws, name) {
		if(!name) for(var i = 1; i <= 0xFFFF; ++i, name = undefined) if(wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
		if(!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
		check_ws_name(name);
		if(wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
	
		wb.SheetNames.push(name);
		wb.Sheets[name] = ws;
	};
	
	/* set sheet visibility (visible/hidden/very hidden) */
	utils.book_set_sheet_visibility = function(wb, sh, vis) {
		get_default(wb,"Workbook",{});
		get_default(wb.Workbook,"Sheets",[]);
	
		var idx = wb_sheet_idx(wb, sh);
		// $FlowIgnore
		get_default(wb.Workbook.Sheets,idx, {});
	
		switch(vis) {
			case 0: case 1: case 2: break;
			default: throw new Error("Bad sheet visibility setting " + vis);
		}
		// $FlowIgnore
		wb.Workbook.Sheets[idx].Hidden = vis;
	};
	add_consts([
		["SHEET_VISIBLE", 0],
		["SHEET_HIDDEN", 1],
		["SHEET_VERY_HIDDEN", 2]
	]);
	
	/* set number format */
	utils.cell_set_number_format = function(cell, fmt) {
		cell.z = fmt;
		return cell;
	};
	
	/* set cell hyperlink */
	utils.cell_set_hyperlink = function(cell, target, tooltip) {
		if(!target) {
			delete cell.l;
		} else {
			cell.l = ({ Target: target });
			if(tooltip) cell.l.Tooltip = tooltip;
		}
		return cell;
	};
	utils.cell_set_internal_link = function(cell, range, tooltip) { return utils.cell_set_hyperlink(cell, "#" + range, tooltip); };
	
	/* add to cell comments */
	utils.cell_add_comment = function(cell, text, author) {
		if(!cell.c) cell.c = [];
		cell.c.push({t:text, a:author||"SheetJS"});
	};
	
	/* set array formula and flush related cells */
	utils.sheet_set_array_formula = function(ws, range, formula) {
		var rng = typeof range != "string" ? range : safe_decode_range(range);
		var rngstr = typeof range == "string" ? range : encode_range(range);
		for(var R = rng.s.r; R <= rng.e.r; ++R) for(var C = rng.s.c; C <= rng.e.c; ++C) {
			var cell = ws_get_cell_stub(ws, R, C);
			cell.t = 'n';
			cell.F = rngstr;
			delete cell.v;
			if(R == rng.s.r && C == rng.s.c) cell.f = formula;
		}
		return ws;
	};
	
	return utils;
	})(utils);
	
	if(has_buf && "function" != 'undefined') (function() {
		var strmod = __webpack_require__(1854);
		if(!strmod) return;
		var Readable = strmod.Readable;
		if(!Readable) return;
	
		var write_csv_stream = function(sheet, opts) {
			var stream = Readable();
			var o = opts == null ? {} : opts;
			if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
			var r = safe_decode_range(sheet["!ref"]);
			var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
			var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
			var endregex = new RegExp((FS=="|" ? "\\|" : FS)+"+$");
			var row = "", cols = [];
			o.dense = Array.isArray(sheet);
			var colinfo = o.skipHidden && sheet["!cols"] || [];
			var rowinfo = o.skipHidden && sheet["!rows"] || [];
			for(var C = r.s.c; C <= r.e.c; ++C) if (!((colinfo[C]||{}).hidden)) cols[C] = encode_col(C);
			var R = r.s.r;
			var BOM = false;
			stream._read = function() {
				if(!BOM) { BOM = true; return stream.push("\uFEFF"); }
				while(R <= r.e.r) {
					++R;
					if ((rowinfo[R-1]||{}).hidden) continue;
					row = make_csv_row(sheet, r, R-1, cols, fs, rs, FS, o);
					if(row != null) {
						if(o.strip) row = row.replace(endregex,"");
						stream.push(row + RS);
						break;
					}
				}
				if(R > r.e.r) return stream.push(null);
			};
			return stream;
		};
	
		var write_html_stream = function(ws, opts) {
			var stream = Readable();
	
			var o = opts || {};
			var header = o.header != null ? o.header : HTML_.BEGIN;
			var footer = o.footer != null ? o.footer : HTML_.END;
			stream.push(header);
			var r = decode_range(ws['!ref']);
			o.dense = Array.isArray(ws);
			stream.push(HTML_._preamble(ws, r, o));
			var R = r.s.r;
			var end = false;
			stream._read = function() {
				if(R > r.e.r) {
					if(!end) { end = true; stream.push("</table>" + footer); }
					return stream.push(null);
				}
				while(R <= r.e.r) {
					stream.push(HTML_._row(ws, r, R, o));
					++R;
					break;
				}
			};
			return stream;
		};
	
		var write_json_stream = function(sheet, opts) {
			var stream = Readable({objectMode:true});
	
			if(sheet == null || sheet["!ref"] == null) { stream.push(null); return stream; }
			var val = {t:'n',v:0}, header = 0, offset = 1, hdr = [], v=0, vv="";
			var r = {s:{r:0,c:0},e:{r:0,c:0}};
			var o = opts || {};
			var range = o.range != null ? o.range : sheet["!ref"];
			if(o.header === 1) header = 1;
			else if(o.header === "A") header = 2;
			else if(Array.isArray(o.header)) header = 3;
			switch(typeof range) {
				case 'string': r = safe_decode_range(range); break;
				case 'number': r = safe_decode_range(sheet["!ref"]); r.s.r = range; break;
				default: r = range;
			}
			if(header > 0) offset = 0;
			var rr = encode_row(r.s.r);
			var cols = [];
			var counter = 0;
			var dense = Array.isArray(sheet);
			var R = r.s.r, C = 0, CC = 0;
			if(dense && !sheet[R]) sheet[R] = [];
			for(C = r.s.c; C <= r.e.c; ++C) {
				cols[C] = encode_col(C);
				val = dense ? sheet[R][C] : sheet[cols[C] + rr];
				switch(header) {
					case 1: hdr[C] = C - r.s.c; break;
					case 2: hdr[C] = cols[C]; break;
					case 3: hdr[C] = o.header[C - r.s.c]; break;
					default:
						if(val == null) val = {w: "__EMPTY", t: "s"};
						vv = v = format_cell(val, null, o);
						counter = 0;
						for(CC = 0; CC < hdr.length; ++CC) if(hdr[CC] == vv) vv = v + "_" + (++counter);
						hdr[C] = vv;
				}
			}
			R = r.s.r + offset;
			stream._read = function() {
				if(R > r.e.r) return stream.push(null);
				while(R <= r.e.r) {
					//if ((rowinfo[R-1]||{}).hidden) continue;
					var row = make_json_row(sheet, r, R, cols, header, hdr, dense, o);
					++R;
					if((row.isempty === false) || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
						stream.push(row.row);
						break;
					}
				}
			};
			return stream;
		};
	
		XLSX.stream = {
			to_json: write_json_stream,
			to_html: write_html_stream,
			to_csv: write_csv_stream
		};
	})();
	
	if(typeof parse_xlscfb !== "undefined") XLSX.parse_xlscfb = parse_xlscfb;
	XLSX.parse_zip = parse_zip;
	XLSX.read = readSync; //xlsread
	XLSX.readFile = readFileSync; //readFile
	XLSX.readFileSync = readFileSync;
	XLSX.write = writeSync;
	XLSX.writeFile = writeFileSync;
	XLSX.writeFileSync = writeFileSync;
	XLSX.writeFileAsync = writeFileAsync;
	XLSX.utils = utils;
	XLSX.SSF = SSF;
	if(typeof CFB !== "undefined") XLSX.CFB = CFB;
	}
	/*global define */
	if(true) make_xlsx_lib(exports);
	else if(typeof module !== 'undefined' && module.exports) make_xlsx_lib(module.exports);
	else if(typeof define === 'function' && define.amd) define('xlsx', function() { if(!XLSX.version) make_xlsx_lib(XLSX); return XLSX; });
	else make_xlsx_lib(XLSX);
	/* NOTE: the following extra line is needed for "Lightning Locker Service" */
	if(typeof window !== 'undefined' && !window.XLSX) try { window.XLSX = XLSX; } catch(e) {}
	/*exported XLS, ODS */
	var XLS = XLSX, ODS = XLSX;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(297).Buffer, __webpack_require__(138)))

/***/ }),
/* 1849 */,
/* 1850 */
816,
/* 1851 */
816,
/* 1852 */
816,
/* 1853 */
816,
/* 1854 */
816,
/* 1855 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_4__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_5__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_6__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_7__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_8__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_2__);
	var pIE = __webpack_require__(__webpack_module_template_argument_3__);
	var toObject = __webpack_require__(__webpack_module_template_argument_4__);
	var IObject = __webpack_require__(__webpack_module_template_argument_5__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_6__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 1879 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPN = __webpack_require__(__webpack_module_template_argument_1__).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 1880 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 1881 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 1882 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 1883 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 1884 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var fails = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 1885 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 1886 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 1887 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 1888 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var core = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(__webpack_module_template_argument_2__) ? 'pure' : 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 1889 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 1890 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 1891 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 1892 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 1893 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 1894 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 1895 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_2__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_3__);
	var defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 1896 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);


/***/ }),
/* 1897 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 1898 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 1899 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 1900 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 1901 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ }),
/* 1902 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ }),
/* 1903 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_1__), 'Object', { defineProperty: __webpack_require__(__webpack_module_template_argument_2__).f });


/***/ }),
/* 1904 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getPrototypeOf = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 1905 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 1906 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(__webpack_module_template_argument_1__).set });


/***/ }),
/* 1907 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 1908 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__, __webpack_module_template_argument_29__, __webpack_module_template_argument_30__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_2__);
	var $export = __webpack_require__(__webpack_module_template_argument_3__);
	var redefine = __webpack_require__(__webpack_module_template_argument_4__);
	var META = __webpack_require__(__webpack_module_template_argument_5__).KEY;
	var $fails = __webpack_require__(__webpack_module_template_argument_6__);
	var shared = __webpack_require__(__webpack_module_template_argument_7__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_8__);
	var uid = __webpack_require__(__webpack_module_template_argument_9__);
	var wks = __webpack_require__(__webpack_module_template_argument_10__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_11__);
	var wksDefine = __webpack_require__(__webpack_module_template_argument_12__);
	var enumKeys = __webpack_require__(__webpack_module_template_argument_13__);
	var isArray = __webpack_require__(__webpack_module_template_argument_14__);
	var anObject = __webpack_require__(__webpack_module_template_argument_15__);
	var isObject = __webpack_require__(__webpack_module_template_argument_16__);
	var toObject = __webpack_require__(__webpack_module_template_argument_17__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_18__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_19__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_20__);
	var _create = __webpack_require__(__webpack_module_template_argument_21__);
	var gOPNExt = __webpack_require__(__webpack_module_template_argument_22__);
	var $GOPD = __webpack_require__(__webpack_module_template_argument_23__);
	var $GOPS = __webpack_require__(__webpack_module_template_argument_24__);
	var $DP = __webpack_require__(__webpack_module_template_argument_25__);
	var $keys = __webpack_require__(__webpack_module_template_argument_26__);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_27__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_28__).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_29__)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_30__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1909 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');


/***/ }),
/* 1910 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('observable');


/***/ }),
/* 1911 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	var reactIs = __webpack_require__(__webpack_module_template_argument_0__);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ }),
/* 1912 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(__webpack_module_template_argument_0__);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ })
/******/ ])));


// WEBPACK FOOTER //
// 32f7c46dc19de595abe9.js